export default [
  {
    "Retail Branding": "",
    "Marketing Name": "",
    "Device": "AD681H",
    "Model": "Smartfren Andromax AD681H"
  },
  {
    "Retail Branding": "",
    "Marketing Name": "",
    "Device": "FJL21",
    "Model": "FJL21"
  },
  {
    "Retail Branding": "",
    "Marketing Name": "",
    "Device": "hws7721g",
    "Model": "MediaPad 7 Youth 2"
  },
  {
    "Retail Branding": "1&1",
    "Marketing Name": "1&1 Puck",
    "Device": "diw362_1u1",
    "Model": "DIW362P 1U1"
  },
  {
    "Retail Branding": "1&1",
    "Marketing Name": "1&1 TV BOX",
    "Device": "DIW377-1u1",
    "Model": "DIW377 1u1"
  },
  {
    "Retail Branding": "1&1",
    "Marketing Name": "1&1 TV Box",
    "Device": "diw387_1u1",
    "Model": "DIW387 1U1"
  },
  {
    "Retail Branding": "1&1",
    "Marketing Name": "AEOP525",
    "Device": "AEOP525",
    "Model": "AEOP525"
  },
  {
    "Retail Branding": "1&1",
    "Marketing Name": "DIW387-1&1",
    "Device": "diw387_1u1",
    "Model": "DIW387 1U1"
  },
  {
    "Retail Branding": "10.or",
    "Marketing Name": "10or_G2",
    "Device": "G2",
    "Model": "10or G2"
  },
  {
    "Retail Branding": "10.or",
    "Marketing Name": "D",
    "Device": "10or_D",
    "Model": "D"
  },
  {
    "Retail Branding": "10.or",
    "Marketing Name": "E",
    "Device": "E",
    "Model": "E"
  },
  {
    "Retail Branding": "10.or",
    "Marketing Name": "G",
    "Device": "G",
    "Model": "G"
  },
  {
    "Retail Branding": "10.or",
    "Marketing Name": "G2",
    "Device": "G2",
    "Model": "G2"
  },
  {
    "Retail Branding": "10.or",
    "Marketing Name": "TCL 60 XE NXTPAPER 5G",
    "Device": "Sunrise_CAN",
    "Model": "T705J"
  },
  {
    "Retail Branding": "1XBET",
    "Marketing Name": "1XPHONE",
    "Device": "1XBET_1XPHONE",
    "Model": "1XPHONE"
  },
  {
    "Retail Branding": "2E (ERC)",
    "Marketing Name": "2E 2K Google TV",
    "Device": "capitolhill",
    "Model": "2E 2K Google TV"
  },
  {
    "Retail Branding": "2E (ERC)",
    "Marketing Name": "2E 4K Google TV",
    "Device": "keoneae",
    "Model": "2E 4K Google TV"
  },
  {
    "Retail Branding": "3222222 Satelital",
    "Marketing Name": "G706",
    "Device": "G706",
    "Model": "G706"
  },
  {
    "Retail Branding": "3ATech",
    "Marketing Name": "T10-8128",
    "Device": "T10-8128",
    "Model": "T10-8128"
  },
  {
    "Retail Branding": "3BBTV",
    "Marketing Name": "3BBTV",
    "Device": "S3000",
    "Model": "S3000-T0C08"
  },
  {
    "Retail Branding": "3BBTV",
    "Marketing Name": "TBBTV01",
    "Device": "TBBTV01",
    "Model": "TBBTV01"
  },
  {
    "Retail Branding": "3Go",
    "Marketing Name": "GT10K3IPS",
    "Device": "GT10K3IPS",
    "Model": "GT10K3IPS"
  },
  {
    "Retail Branding": "3Go",
    "Marketing Name": "GT70053G",
    "Device": "GT70053G",
    "Model": "GT70053G"
  },
  {
    "Retail Branding": "3Go",
    "Marketing Name": "GT7007EQC",
    "Device": "GT7007EQC",
    "Model": "GT7007EQC"
  },
  {
    "Retail Branding": "3Q",
    "Marketing Name": "OC1020A",
    "Device": "OC1020A",
    "Model": "OC1020A"
  },
  {
    "Retail Branding": "3Rtablet",
    "Marketing Name": "VT-7A Pro",
    "Device": "VT-7A_Pro",
    "Model": "Rugged Tablet"
  },
  {
    "Retail Branding": "3Rtablet",
    "Marketing Name": "VT-7GA",
    "Device": "VT-7GA",
    "Model": "VT-7GA"
  },
  {
    "Retail Branding": "3Rtablet",
    "Marketing Name": "VT-7GE",
    "Device": "VT-7GE",
    "Model": "VT-7GE"
  },
  {
    "Retail Branding": "3nStar",
    "Marketing Name": "Nustar65",
    "Device": "Nustar65",
    "Model": "Nustar65"
  },
  {
    "Retail Branding": "4good",
    "Marketing Name": "4GOOD Light B100",
    "Device": "4GOOD_Light_B100",
    "Model": "Light B100"
  },
  {
    "Retail Branding": "4good",
    "Marketing Name": "A103",
    "Device": "4GOOD_Light_A103",
    "Model": "Light A103"
  },
  {
    "Retail Branding": "4iG TV",
    "Marketing Name": "4iG M391",
    "Device": "m3918_4iG",
    "Model": "4iG M391"
  },
  {
    "Retail Branding": "4iG TV",
    "Marketing Name": "Mini Box",
    "Device": "m252_4iG",
    "Model": "4iG DIW252V"
  },
  {
    "Retail Branding": "5STAR",
    "Marketing Name": "5Star_Note_5",
    "Device": "5Star_Note_5",
    "Model": "5Star_Note_5"
  },
  {
    "Retail Branding": "5STAR",
    "Marketing Name": "Note_1_Pro",
    "Device": "Note_1_Pro",
    "Model": "Note_1_Pro"
  },
  {
    "Retail Branding": "7Eleven",
    "Marketing Name": "IN265",
    "Device": "IN265",
    "Model": "IN265"
  },
  {
    "Retail Branding": "7mobile",
    "Marketing Name": "DRENA",
    "Device": "DRENA",
    "Model": "DRENA"
  },
  {
    "Retail Branding": "7mobile",
    "Marketing Name": "KAMBA",
    "Device": "KAMBA",
    "Model": "KAMBA"
  },
  {
    "Retail Branding": "7mobile",
    "Marketing Name": "Kamba 2",
    "Device": "7mobile_Kamba_2",
    "Model": "Kamba_2"
  },
  {
    "Retail Branding": "7mobile",
    "Marketing Name": "SWEGUE",
    "Device": "SWEGUE",
    "Model": "SWEGUE"
  },
  {
    "Retail Branding": "7mobile",
    "Marketing Name": "Swegue 2",
    "Device": "Swegue_2",
    "Model": "Swegue 2"
  },
  {
    "Retail Branding": 8849,
    "Marketing Name": "OB-A98",
    "Device": "OB-A98",
    "Model": "OB-A98"
  },
  {
    "Retail Branding": 8849,
    "Marketing Name": "OB-A99",
    "Device": "OB-A99",
    "Model": "OB-A99"
  },
  {
    "Retail Branding": 8849,
    "Marketing Name": "OB-P08",
    "Device": "OB-P08",
    "Model": "OB-P08"
  },
  {
    "Retail Branding": 8849,
    "Marketing Name": "OB-P10",
    "Device": "OB-P10",
    "Model": "OB-P10"
  },
  {
    "Retail Branding": 8849,
    "Marketing Name": "OB-P12",
    "Device": "OB-P10",
    "Model": "OB-P12"
  },
  {
    "Retail Branding": 8849,
    "Marketing Name": "TANK MINI 1",
    "Device": "TANK_MINI_1",
    "Model": "TANK MINI 1"
  },
  {
    "Retail Branding": 8849,
    "Marketing Name": "TANK X",
    "Device": "TANK3",
    "Model": "TANK X"
  },
  {
    "Retail Branding": 8849,
    "Marketing Name": "TANK2",
    "Device": "TANK2",
    "Model": "TANK2"
  },
  {
    "Retail Branding": 8849,
    "Marketing Name": "TANK2pro",
    "Device": "TANK2PRO",
    "Model": "TANK 2 PRO"
  },
  {
    "Retail Branding": 8849,
    "Marketing Name": "TANK3",
    "Device": "TANK3",
    "Model": "TANK 3"
  },
  {
    "Retail Branding": "9mobile",
    "Marketing Name": "DM_T901",
    "Device": "DM_T901",
    "Model": "DM_T901"
  },
  {
    "Retail Branding": "A.O.I. ELECTRONICS FACTORY",
    "Marketing Name": "A.O.I.",
    "Device": "TR10CS1_11",
    "Model": "TR10CS1"
  },
  {
    "Retail Branding": "A1",
    "Marketing Name": "A1 Alpha 20+",
    "Device": "P671F60",
    "Model": "A1 Alpha 20+"
  },
  {
    "Retail Branding": "A1",
    "Marketing Name": "A1 Bulgaria B866V2F02",
    "Device": "A1_B866V2F02",
    "Model": "B866V2F02"
  },
  {
    "Retail Branding": "A1",
    "Marketing Name": "A1 Hrvatska B866V2F02",
    "Device": "A1_B866V2F02",
    "Model": "B866V2F02"
  },
  {
    "Retail Branding": "A1",
    "Marketing Name": "A1 Smart N9",
    "Device": "VFD720",
    "Model": "VFD 720"
  },
  {
    "Retail Branding": "A1",
    "Marketing Name": "A1-Smart-Box-DV9161",
    "Device": "DV9161-KBA",
    "Model": "A1-Smart-Box-DV9161"
  },
  {
    "Retail Branding": "A1",
    "Marketing Name": "ADT-3",
    "Device": "adt3",
    "Model": "ADT-3"
  },
  {
    "Retail Branding": "A1",
    "Marketing Name": "Ai-ES1059",
    "Device": "Ai-ES1059",
    "Model": "Ai-ES1059"
  },
  {
    "Retail Branding": "AAAmaze",
    "Marketing Name": "Smart TV",
    "Device": "alimos",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "AAAmaze",
    "Marketing Name": "Smart TV",
    "Device": "osaka",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "AAUW",
    "Marketing Name": "M50",
    "Device": "M50",
    "Model": "M50"
  },
  {
    "Retail Branding": "AAUW",
    "Marketing Name": "M50_NEW",
    "Device": "M50_NEW",
    "Model": "M50_NEW"
  },
  {
    "Retail Branding": "AAUW",
    "Marketing Name": "M60_NEW",
    "Device": "M60_NEW",
    "Model": "M60_NEW"
  },
  {
    "Retail Branding": "AAUW",
    "Marketing Name": "T10",
    "Device": "T10",
    "Model": "T10"
  },
  {
    "Retail Branding": "AAUW",
    "Marketing Name": "T50_2023",
    "Device": "T50_2023",
    "Model": "T50_2023"
  },
  {
    "Retail Branding": "AAUW",
    "Marketing Name": "T60PRO",
    "Device": "T60PRO_ROW",
    "Model": "T60PRO_ROW"
  },
  {
    "Retail Branding": "AAUW",
    "Marketing Name": "T60Pro",
    "Device": "T60Pro",
    "Model": "T60Pro"
  },
  {
    "Retail Branding": "AAUW",
    "Marketing Name": "T60Pro_2023",
    "Device": "T60Pro_2023",
    "Model": "T60Pro_2023"
  },
  {
    "Retail Branding": "AAUW",
    "Marketing Name": "T90",
    "Device": "T90",
    "Model": "T90"
  },
  {
    "Retail Branding": "AAUW",
    "Marketing Name": "T_50",
    "Device": "T_50",
    "Model": "T_50"
  },
  {
    "Retail Branding": "ABCTECH",
    "Marketing Name": "PG11",
    "Device": "PG11",
    "Model": "PG11"
  },
  {
    "Retail Branding": "ABCTECH",
    "Marketing Name": "X20",
    "Device": "X20",
    "Model": "X20"
  },
  {
    "Retail Branding": "ABCTECH",
    "Marketing Name": "X20_Pro",
    "Device": "X20_Pro",
    "Model": "X20_Pro"
  },
  {
    "Retail Branding": "ABCTECH",
    "Marketing Name": "X5",
    "Device": "X5",
    "Model": "X5"
  },
  {
    "Retail Branding": "ABIL",
    "Marketing Name": "A8",
    "Device": "A8",
    "Model": "A8"
  },
  {
    "Retail Branding": "ABILIA",
    "Marketing Name": "MPM5",
    "Device": "MPM5",
    "Model": "MPMedium5"
  },
  {
    "Retail Branding": "ABILIA",
    "Marketing Name": "MPMedium5",
    "Device": "MPMedium5",
    "Model": "MPMedium5"
  },
  {
    "Retail Branding": "ACD Computers",
    "Marketing Name": "ACD-Tab-10S",
    "Device": "ACD-Tab-10S",
    "Model": "ACD-Tab-10S"
  },
  {
    "Retail Branding": "ACE (Global)",
    "Marketing Name": "AS0124",
    "Device": "BUZZ_5_Lite",
    "Model": "BUZZ 5 Lite"
  },
  {
    "Retail Branding": "ACE (Global)",
    "Marketing Name": "AS0224",
    "Device": "BUZZ_5_Prime",
    "Model": "BUZZ 5 Prime"
  },
  {
    "Retail Branding": "ACE (Global)",
    "Marketing Name": "AS0324",
    "Device": "BUZZ_5_Note",
    "Model": "BUZZ 5 Note"
  },
  {
    "Retail Branding": "ACE (Global)",
    "Marketing Name": "AS0623",
    "Device": "BUZZ_4_Note",
    "Model": "BUZZ 4 Note"
  },
  {
    "Retail Branding": "ACE (Global)",
    "Marketing Name": "BUZZ 3",
    "Device": "BUZZ_3",
    "Model": "BUZZ 3"
  },
  {
    "Retail Branding": "ACE (Global)",
    "Marketing Name": "BUZZ 3 Plus",
    "Device": "BUZZ_3_Plus",
    "Model": "BUZZ 3 Plus"
  },
  {
    "Retail Branding": "ACE (Global)",
    "Marketing Name": "BUZZ 4",
    "Device": "BUZZ_4",
    "Model": "BUZZ 4"
  },
  {
    "Retail Branding": "ACE (Global)",
    "Marketing Name": "BUZZ 4 Prime",
    "Device": "BUZZ_4_Prime",
    "Model": "BUZZ 4 Prime"
  },
  {
    "Retail Branding": "ACE (Global)",
    "Marketing Name": "BUZZ 4 Ultra",
    "Device": "BUZZ_4_Ultra",
    "Model": "BUZZ 4 Ultra"
  },
  {
    "Retail Branding": "ACE (Global)",
    "Marketing Name": "BUZZ 5 Ultra",
    "Device": "BUZZ_5_Ultra",
    "Model": "BUZZ 5 Ultra"
  },
  {
    "Retail Branding": "ACE (Global)",
    "Marketing Name": "BUZZ 6 Flip",
    "Device": "BUZZ_6_Flip",
    "Model": "BUZZ 6 Flip"
  },
  {
    "Retail Branding": "ACE (Global)",
    "Marketing Name": "BUZZ 6 Prime",
    "Device": "BUZZ_6_Prime",
    "Model": "BUZZ 6 Prime"
  },
  {
    "Retail Branding": "ACE (Global)",
    "Marketing Name": "BUZZ 6 Prime PLUS",
    "Device": "BUZZ_6_Prime_PLUS",
    "Model": "BUZZ 6 Prime PLUS"
  },
  {
    "Retail Branding": "ACE (Global)",
    "Marketing Name": "BUZZ 6 Pro PLUS",
    "Device": "BUZZ_6_Pro_PLUS",
    "Model": "BUZZ 6 Pro PLUS"
  },
  {
    "Retail Branding": "ACE (Global)",
    "Marketing Name": "BUZZ 6 Ultra",
    "Device": "BUZZ_6_Ultra",
    "Model": "BUZZ 6 Ultra"
  },
  {
    "Retail Branding": "ACE (Global)",
    "Marketing Name": "BUZZ 7 Lite",
    "Device": "BUZZ_7_Lite",
    "Model": "BUZZ 7 Lite"
  },
  {
    "Retail Branding": "ACE (Global)",
    "Marketing Name": "BUZZ 7 Pro",
    "Device": "BUZZ_7_Pro",
    "Model": "BUZZ 7 Pro"
  },
  {
    "Retail Branding": "ACE (Global)",
    "Marketing Name": "BUZZ 7 Ultra",
    "Device": "BUZZ_7_Ultra",
    "Model": "BUZZ 7 Ultra"
  },
  {
    "Retail Branding": "ACE (Global)",
    "Marketing Name": "CLEVER 3",
    "Device": "CLEVER_3",
    "Model": "CLEVER 3"
  },
  {
    "Retail Branding": "ACE (Global)",
    "Marketing Name": "URBAN 3",
    "Device": "URBAN_3",
    "Model": "URBAN 3"
  },
  {
    "Retail Branding": "ACE (Global)",
    "Marketing Name": "URBAN 3 Plus",
    "Device": "URBAN_3_PlusE",
    "Model": "URBAN 3 Plus"
  },
  {
    "Retail Branding": "ACE (Global)",
    "Marketing Name": "buzz 8 Note",
    "Device": "buzz_8_Note",
    "Model": "buzz 8 Note"
  },
  {
    "Retail Branding": "ACE (Global)",
    "Marketing Name": "buzz 8 Prime Plus",
    "Device": "buzz_8_Prime_Plus",
    "Model": "buzz 8 Prime Plus"
  },
  {
    "Retail Branding": "ACE France",
    "Marketing Name": "AS0218",
    "Device": "AS0218",
    "Model": "BUZZ 1"
  },
  {
    "Retail Branding": "ACE France",
    "Marketing Name": "AS0518",
    "Device": "AS0518",
    "Model": "URBAN 1 Pro"
  },
  {
    "Retail Branding": "ACE France",
    "Marketing Name": "AS0618",
    "Device": "AS0618",
    "Model": "CLEVER 1"
  },
  {
    "Retail Branding": "ACE France",
    "Marketing Name": "BUZZ 2",
    "Device": "BUZZ_2",
    "Model": "BUZZ 2"
  },
  {
    "Retail Branding": "ACE France",
    "Marketing Name": "BUZZ 2",
    "Device": "BUZZ_2_Plus",
    "Model": "BUZZ 2 Plus"
  },
  {
    "Retail Branding": "ACE France",
    "Marketing Name": "BUZZ 3 Lite",
    "Device": "BUZZ_3_Lite",
    "Model": "BUZZ 3 Lite"
  },
  {
    "Retail Branding": "ACE France",
    "Marketing Name": "BUZZ 4Lite",
    "Device": "BUZZ_4Lite",
    "Model": "BUZZ 4Lite"
  },
  {
    "Retail Branding": "ACE France",
    "Marketing Name": "BUZZ 4Pro",
    "Device": "BUZZ_4Pro",
    "Model": "BUZZ 4Pro"
  },
  {
    "Retail Branding": "ACE France",
    "Marketing Name": "BUZZ 4S",
    "Device": "BUZZ_4S",
    "Model": "BUZZ 4S"
  },
  {
    "Retail Branding": "ACE France",
    "Marketing Name": "BUZZ 5 Pro",
    "Device": "BUZZ_5_Pro",
    "Model": "BUZZ 5 Pro"
  },
  {
    "Retail Branding": "ACE France",
    "Marketing Name": "BUZZ 5 Pro PLUS",
    "Device": "BUZZ_5_Pro_PLUS",
    "Model": "BUZZ 5 Pro PLUS"
  },
  {
    "Retail Branding": "ACE France",
    "Marketing Name": "BUZZ 6 Pro",
    "Device": "BUZZ_6_Pro",
    "Model": "BUZZ 6 Pro"
  },
  {
    "Retail Branding": "ACE France",
    "Marketing Name": "BUZZ 7 GT",
    "Device": "BUZZ_7_GT",
    "Model": "BUZZ 7 GT"
  },
  {
    "Retail Branding": "ACE France",
    "Marketing Name": "BUZZ 7 Note",
    "Device": "BUZZ_7_Note",
    "Model": "BUZZ 7 Note"
  },
  {
    "Retail Branding": "ACE France",
    "Marketing Name": "BUZZ 7 Prime",
    "Device": "BUZZ_7_Prime",
    "Model": "BUZZ 7 Prime"
  },
  {
    "Retail Branding": "ACE France",
    "Marketing Name": "BUZZ 7 Prime PLUS",
    "Device": "BUZZ_7_Prime_PLUS",
    "Model": "BUZZ 7 Prime PLUS"
  },
  {
    "Retail Branding": "ACE France",
    "Marketing Name": "BUZZ_1_Lite",
    "Device": "BUZZ_1_Lite",
    "Model": "BUZZ 1 Lite"
  },
  {
    "Retail Branding": "ACE France",
    "Marketing Name": "BUZZ_1_Plus",
    "Device": "BUZZ_1_Plus",
    "Model": "BUZZ 1 Plus"
  },
  {
    "Retail Branding": "ACE France",
    "Marketing Name": "BUZZ_3E",
    "Device": "BUZZ_3E",
    "Model": "BUZZ 3"
  },
  {
    "Retail Branding": "ACE France",
    "Marketing Name": "URBAN 1",
    "Device": "URBAN_1",
    "Model": "URBAN 1"
  },
  {
    "Retail Branding": "ACE France",
    "Marketing Name": "URBAN 2",
    "Device": "URBAN_2",
    "Model": "URBAN 2"
  },
  {
    "Retail Branding": "ACE France",
    "Marketing Name": "URBAN 3",
    "Device": "URBAN_3E",
    "Model": "URBAN 3"
  },
  {
    "Retail Branding": "ACE France",
    "Marketing Name": "buzz 8 Lite",
    "Device": "buzz_8_Lite",
    "Model": "buzz 8 Lite"
  },
  {
    "Retail Branding": "ACE France",
    "Marketing Name": "buzz 8 Prime",
    "Device": "buzz_8_Prime",
    "Model": "buzz 8 Prime"
  },
  {
    "Retail Branding": "ACE France",
    "Marketing Name": "buzz 8 Pro",
    "Device": "buzz_8_Pro",
    "Model": "buzz 8 Pro"
  },
  {
    "Retail Branding": "ACE France",
    "Marketing Name": "buzz 8 Pro Plus",
    "Device": "buzz_8_Pro_Plus",
    "Model": "buzz 8 Pro Plus"
  },
  {
    "Retail Branding": "ACE France",
    "Marketing Name": "buzz Neo 5G",
    "Device": "buzz_Neo_5G",
    "Model": "buzz Neo 5G"
  },
  {
    "Retail Branding": "ACER_ALTOS",
    "Marketing Name": "ALTOS_EZA",
    "Device": "ALTOS_EZA",
    "Model": "ALTOS_EZA"
  },
  {
    "Retail Branding": "ACKEES",
    "Marketing Name": "V10401",
    "Device": "V10401",
    "Model": "V10401"
  },
  {
    "Retail Branding": "ACT",
    "Marketing Name": "ACT4K1007",
    "Device": "IPBox",
    "Model": "ACT4K1007"
  },
  {
    "Retail Branding": "ACT",
    "Marketing Name": "ACT4K2020",
    "Device": "HP40A",
    "Model": "ACT4K2020"
  },
  {
    "Retail Branding": "ACTECK",
    "Marketing Name": "AC_934312",
    "Device": "AC_934312",
    "Model": "AC_934312"
  },
  {
    "Retail Branding": "ADOC",
    "Marketing Name": "ADOC  D18",
    "Device": "ADOC_D18",
    "Model": "ADOC D18"
  },
  {
    "Retail Branding": "ADOC",
    "Marketing Name": "ADOC EX650",
    "Device": "rk3588_t",
    "Model": "ADOCEX650"
  },
  {
    "Retail Branding": "ADOC",
    "Marketing Name": "ADOC TCAT10",
    "Device": "ADOC_TCAT10",
    "Model": "ADOC TCAT10"
  },
  {
    "Retail Branding": "ADOC",
    "Marketing Name": "D30",
    "Device": "D30",
    "Model": "D30"
  },
  {
    "Retail Branding": "ADOC",
    "Marketing Name": "D40",
    "Device": "D40",
    "Model": "D40"
  },
  {
    "Retail Branding": "ADOC",
    "Marketing Name": "M3",
    "Device": "M3",
    "Model": "M3"
  },
  {
    "Retail Branding": "ADTH",
    "Marketing Name": "A-X25A3L1",
    "Device": "A-X25A3L1",
    "Model": "A-X25A3L1"
  },
  {
    "Retail Branding": "ADVAN",
    "Marketing Name": "ADVANNASAPro",
    "Device": "ADVANNASAPro",
    "Model": "ADVANNASAPro"
  },
  {
    "Retail Branding": "ADVAN",
    "Marketing Name": "ADVAN_SKETSA5",
    "Device": "ADVAN_SKETSA5",
    "Model": 1202
  },
  {
    "Retail Branding": "ADVAN",
    "Marketing Name": "ADVAN_TAB_A10",
    "Device": "ADVAN_TAB_A10",
    "Model": 1013
  },
  {
    "Retail Branding": "ADVAN",
    "Marketing Name": "ADVAN_TAB_A10",
    "Device": "ADVAN_TAB_A10",
    "Model": "A10"
  },
  {
    "Retail Branding": "ADVAN",
    "Marketing Name": "ADVAN_TAB_A10S",
    "Device": "ADVAN_TAB_A10S",
    "Model": 1013
  },
  {
    "Retail Branding": "ADVAN",
    "Marketing Name": "ADVAN_X1",
    "Device": "ADVAN_X1",
    "Model": 6781
  },
  {
    "Retail Branding": "ADVAN",
    "Marketing Name": "S50",
    "Device": "ADVAN_MACHA",
    "Model": "S50"
  },
  {
    "Retail Branding": "ADVAN",
    "Marketing Name": "Sketsa3",
    "Device": "ADVAN_SKETSA3",
    "Model": 1013
  },
  {
    "Retail Branding": "ADVAN",
    "Marketing Name": "TAB A8",
    "Device": "ADVAN_TAB_A8",
    "Model": 8004
  },
  {
    "Retail Branding": "ADVAN",
    "Marketing Name": "VX NEO",
    "Device": "ADVAN_VX_NEO",
    "Model": 1013
  },
  {
    "Retail Branding": "ADVAN",
    "Marketing Name": "VX_LITE",
    "Device": "ADVAN_TAB_VX_LITE",
    "Model": 1013
  },
  {
    "Retail Branding": "ADVANTOUCH",
    "Marketing Name": "Android_EDLA_OPS",
    "Device": "rk3588_t",
    "Model": "EO1_RK3588_08128"
  },
  {
    "Retail Branding": "AEEZO",
    "Marketing Name": "TK701",
    "Device": "TK701",
    "Model": "TK701"
  },
  {
    "Retail Branding": "AEEZO",
    "Marketing Name": "TK701_EEA",
    "Device": "TK701_EEA",
    "Model": "TK701_EEA"
  },
  {
    "Retail Branding": "AEEZO",
    "Marketing Name": "TK801",
    "Device": "TK801",
    "Model": "TK801"
  },
  {
    "Retail Branding": "AEEZO",
    "Marketing Name": "TK806",
    "Device": "TK806",
    "Model": "TK806"
  },
  {
    "Retail Branding": "AEEZO",
    "Marketing Name": "TK806_EEA",
    "Device": "TK806_EEA",
    "Model": "TK806_EEA"
  },
  {
    "Retail Branding": "AEEZO",
    "Marketing Name": "TK809",
    "Device": "TK809",
    "Model": "TK809"
  },
  {
    "Retail Branding": "AEEZO",
    "Marketing Name": "TK809_EEA",
    "Device": "TK809_EEA",
    "Model": "TK809_EEA"
  },
  {
    "Retail Branding": "AEEZO",
    "Marketing Name": "TP1001",
    "Device": "TP1001",
    "Model": "TP1001"
  },
  {
    "Retail Branding": "AEEZO",
    "Marketing Name": "TP901",
    "Device": "TP901",
    "Model": "TP901"
  },
  {
    "Retail Branding": "AFRICELL",
    "Marketing Name": "S10",
    "Device": "S10",
    "Model": "afriphone S10"
  },
  {
    "Retail Branding": "AG Mobile",
    "Marketing Name": "AG BOOST 2",
    "Device": "BOOST2",
    "Model": "E4010"
  },
  {
    "Retail Branding": "AG Mobile",
    "Marketing Name": "AG Flair",
    "Device": "AG_Flair",
    "Model": "Flair"
  },
  {
    "Retail Branding": "AG Mobile",
    "Marketing Name": "AG Go Tab Access 2",
    "Device": "AG_Go_Tab_Access_2",
    "Model": "AG_Go_Tab_Access_2"
  },
  {
    "Retail Branding": "AG Mobile",
    "Marketing Name": "AG Ultra2",
    "Device": "AG_Ultra2",
    "Model": "Ultra 2"
  },
  {
    "Retail Branding": "AG Mobile",
    "Marketing Name": "AGM  H1",
    "Device": "HSSDM450QC",
    "Model": "AGM H1"
  },
  {
    "Retail Branding": "AG Mobile",
    "Marketing Name": "AGM A10",
    "Device": "SHARKL5",
    "Model": "AGM A10"
  },
  {
    "Retail Branding": "AG Mobile",
    "Marketing Name": "AGM A10",
    "Device": "SHARKL5",
    "Model": "Android"
  },
  {
    "Retail Branding": "AG Mobile",
    "Marketing Name": "AGM A9",
    "Device": "HSSDM450QC",
    "Model": "AGM A9"
  },
  {
    "Retail Branding": "AG Mobile",
    "Marketing Name": "AGM A9",
    "Device": "HSSDM450QC",
    "Model": "Android"
  },
  {
    "Retail Branding": "AG Mobile",
    "Marketing Name": "AGM X3",
    "Device": "T91EUE1",
    "Model": "AGM X3"
  },
  {
    "Retail Branding": "AG Mobile",
    "Marketing Name": "AGM_G3",
    "Device": "AGM_G3",
    "Model": "AGM_G3"
  },
  {
    "Retail Branding": "AG Mobile",
    "Marketing Name": "AG_Go-Tab_Access",
    "Device": "md789hwag",
    "Model": "AG Go-Tab Access"
  },
  {
    "Retail Branding": "AG Mobile",
    "Marketing Name": "AG_Tab_7_0",
    "Device": "AG_Tab_7_0",
    "Model": "AG_Tab_7_0"
  },
  {
    "Retail Branding": "AG Mobile",
    "Marketing Name": "Boost",
    "Device": "Boost",
    "Model": "Boost"
  },
  {
    "Retail Branding": "AG Mobile",
    "Marketing Name": "Chacer",
    "Device": "Chacer",
    "Model": "Chacer"
  },
  {
    "Retail Branding": "AG Mobile",
    "Marketing Name": "Freedom Access",
    "Device": "Freedom_Access",
    "Model": "Freedom Access"
  },
  {
    "Retail Branding": "AG Mobile",
    "Marketing Name": "Freedom E",
    "Device": "Freedom_E",
    "Model": "Freedom E"
  },
  {
    "Retail Branding": "AG Mobile",
    "Marketing Name": "Freedom Plus LTE",
    "Device": "Freedom_Plus_LTE",
    "Model": "Freedom Plus LTE"
  },
  {
    "Retail Branding": "AG Mobile",
    "Marketing Name": "Ghost",
    "Device": "Ghost",
    "Model": "Ghost"
  },
  {
    "Retail Branding": "AG Mobile",
    "Marketing Name": "Glow",
    "Device": "Glow",
    "Model": "Glow"
  },
  {
    "Retail Branding": "AG Mobile",
    "Marketing Name": "HASHTAG",
    "Device": "Hashtag",
    "Model": "Hashtag"
  },
  {
    "Retail Branding": "AG Mobile",
    "Marketing Name": "Hype",
    "Device": "Hype",
    "Model": "Hype"
  },
  {
    "Retail Branding": "AG Mobile",
    "Marketing Name": "Neon",
    "Device": "Neon",
    "Model": "Neon"
  },
  {
    "Retail Branding": "AG Mobile",
    "Marketing Name": "Quest",
    "Device": "Quest",
    "Model": "Quest"
  },
  {
    "Retail Branding": "AG Mobile",
    "Marketing Name": "Rage",
    "Device": "Rage",
    "Model": "Rage"
  },
  {
    "Retail Branding": "AG Mobile",
    "Marketing Name": "STYLE PLUS",
    "Device": "STYLE_PLUS",
    "Model": "STYLE_PLUS"
  },
  {
    "Retail Branding": "AG Mobile",
    "Marketing Name": "Shine",
    "Device": "Shine",
    "Model": "Shine"
  },
  {
    "Retail Branding": "AG Mobile",
    "Marketing Name": "Status",
    "Device": "Status",
    "Model": "Status"
  },
  {
    "Retail Branding": "AG Mobile",
    "Marketing Name": "Style",
    "Device": "Style",
    "Model": "Style"
  },
  {
    "Retail Branding": "AG Mobile",
    "Marketing Name": "Style_2",
    "Device": "Style_2",
    "Model": "Style 2"
  },
  {
    "Retail Branding": "AG Mobile",
    "Marketing Name": "Swift",
    "Device": "Swift",
    "Model": "Swift"
  },
  {
    "Retail Branding": "AG Mobile",
    "Marketing Name": "Swift_Plus",
    "Device": "Swift_Plus",
    "Model": "Swift_Plus"
  },
  {
    "Retail Branding": "AG Mobile",
    "Marketing Name": "ULTRA",
    "Device": "Ultra",
    "Model": "Ultra"
  },
  {
    "Retail Branding": "AG Mobile",
    "Marketing Name": "Zenith",
    "Device": "Zenith",
    "Model": "Zenith"
  },
  {
    "Retail Branding": "AG Mobile",
    "Marketing Name": "Zone",
    "Device": "Zone",
    "Model": "Zone"
  },
  {
    "Retail Branding": "AG Mobile",
    "Marketing Name": "Zoom",
    "Device": "Zoom",
    "Model": "Zoom"
  },
  {
    "Retail Branding": "AGE (in)",
    "Marketing Name": "AGE",
    "Device": "elliniko",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "AGE (in)",
    "Marketing Name": "AGE",
    "Device": "zhongshan",
    "Model": "43F"
  },
  {
    "Retail Branding": "AGE (in)",
    "Marketing Name": "Age",
    "Device": "stanford",
    "Model": "40D"
  },
  {
    "Retail Branding": "AGE (in)",
    "Marketing Name": "India",
    "Device": "tamachi",
    "Model": "AGE FHD Android TV"
  },
  {
    "Retail Branding": "AGE (in)",
    "Marketing Name": "India",
    "Device": "yeongdeungpo",
    "Model": "AGE UHD Android TV"
  },
  {
    "Retail Branding": "AGM Mobile",
    "Marketing Name": "AGM Glory G1",
    "Device": "AGM_Glory_G1",
    "Model": "AGM Glory G1"
  },
  {
    "Retail Branding": "AGM Mobile",
    "Marketing Name": "AGM Glory_G1S",
    "Device": "AGM_Glory_G1S_EU",
    "Model": "AGM Glory_G1S"
  },
  {
    "Retail Branding": "AGM Mobile",
    "Marketing Name": "AGM Glory_G1S",
    "Device": "AGM_Glory_G1S_RU",
    "Model": "AGM Glory_G1S"
  },
  {
    "Retail Branding": "AGM Mobile",
    "Marketing Name": "AGM Glory_G1S",
    "Device": "AGM_Glory_G1S_US",
    "Model": "AGM Glory_G1S"
  },
  {
    "Retail Branding": "AGM Mobile",
    "Marketing Name": "AGM H3",
    "Device": "AGM_H3",
    "Model": "AGM_H3"
  },
  {
    "Retail Branding": "AGM Mobile",
    "Marketing Name": "AGM H5",
    "Device": "AGM_H5",
    "Model": "AGM_H5"
  },
  {
    "Retail Branding": "AGM Mobile",
    "Marketing Name": "AGM_G3",
    "Device": "AGM_G3",
    "Model": "AGM_G3"
  },
  {
    "Retail Branding": "AGM Mobile",
    "Marketing Name": "AGM_H5_PRO",
    "Device": "AGM_H5_PRO",
    "Model": "AGM_H5_PRO"
  },
  {
    "Retail Branding": "AGM Mobile",
    "Marketing Name": "AGM_H6",
    "Device": "AGM_H6",
    "Model": "AGM_H6"
  },
  {
    "Retail Branding": "AGM Mobile",
    "Marketing Name": "AGM_H_MAX",
    "Device": "AGM_H_MAX",
    "Model": "AGM_H_MAX"
  },
  {
    "Retail Branding": "AGM Mobile",
    "Marketing Name": "AGM_Note_N1",
    "Device": "AGM_Note_N1",
    "Model": "AGM_Note_N1"
  },
  {
    "Retail Branding": "AGM Mobile",
    "Marketing Name": "AGM_PAD_P1",
    "Device": "AGM_PAD_P1",
    "Model": "AGM_PAD_P1"
  },
  {
    "Retail Branding": "AGM Mobile",
    "Marketing Name": "AGM_PAD_P2",
    "Device": "AGM_PAD_P2",
    "Model": "AGM_PAD_P2"
  },
  {
    "Retail Branding": "AGM Mobile",
    "Marketing Name": "AGM_PAD_P2W_EEA",
    "Device": "AGM_PAD_P2_ACTIVE",
    "Model": "AGM_PAD_P2W"
  },
  {
    "Retail Branding": "AGM Mobile",
    "Marketing Name": "AGM_PAD_T1",
    "Device": "AGM_PAD_T1",
    "Model": "AGM_PAD_T1"
  },
  {
    "Retail Branding": "AGM Mobile",
    "Marketing Name": "AGM_PAD_T1_WIFI",
    "Device": "AGM_PAD_T1_WIFI",
    "Model": "AGM_PAD_T1"
  },
  {
    "Retail Branding": "AGM Mobile",
    "Marketing Name": "AGM_PAD_T2",
    "Device": "AGM_PAD_T2",
    "Model": "AGM_PAD_T2"
  },
  {
    "Retail Branding": "AGM Mobile",
    "Marketing Name": "AGM_PAD_T3",
    "Device": "AGM_PAD_T3",
    "Model": "AGM PAD T3"
  },
  {
    "Retail Branding": "AGM Mobile",
    "Marketing Name": "AGM_X6",
    "Device": "AGM_X6_EEA",
    "Model": "AGM_X6"
  },
  {
    "Retail Branding": "AGM Mobile",
    "Marketing Name": "AGM_X6",
    "Device": "AGM_X6_ROW",
    "Model": "AGM_X6"
  },
  {
    "Retail Branding": "AGM Mobile",
    "Marketing Name": "AGM_X6",
    "Device": "AGM_X6_RU",
    "Model": "AGM_X6"
  },
  {
    "Retail Branding": "AGM Mobile",
    "Marketing Name": "Android_Rugged",
    "Device": "Android_Rugged",
    "Model": "Android_Rugged"
  },
  {
    "Retail Branding": "AGM Mobile",
    "Marketing Name": "Android_Tablet",
    "Device": "Android_Tablet",
    "Model": "Android_Tablet"
  },
  {
    "Retail Branding": "AGM Mobile",
    "Marketing Name": "Android_Tough",
    "Device": "Android_Tough",
    "Model": "Android_Tough"
  },
  {
    "Retail Branding": "AGNO",
    "Marketing Name": "TAIG717A",
    "Device": "TAIG717A",
    "Model": "TA_G717"
  },
  {
    "Retail Branding": "AGNeovo",
    "Marketing Name": "AGNeovo",
    "Device": "Meetboard4Prime",
    "Model": "Meetboard4Prime"
  },
  {
    "Retail Branding": "AG_Neovo",
    "Marketing Name": "MeetBoard_4",
    "Device": "MeetBoard_4",
    "Model": "MeetBoard_4"
  },
  {
    "Retail Branding": "AHA(A)",
    "Marketing Name": "AHA_IFPD",
    "Device": "AHA_ULTRA_RK3576",
    "Model": "Hybrid_8700"
  },
  {
    "Retail Branding": "AHA(A)",
    "Marketing Name": "IFPD",
    "Device": "AHA_ULTRA_RK3588",
    "Model": "Hybrid_8600"
  },
  {
    "Retail Branding": "AIDATA",
    "Marketing Name": "ADT-R10TME",
    "Device": "ADT-R10TME",
    "Model": "ADT-R10TME"
  },
  {
    "Retail Branding": "AIDATA",
    "Marketing Name": "ADT1012L",
    "Device": "ADT1012L",
    "Model": "ADT1012L"
  },
  {
    "Retail Branding": "AIDATA",
    "Marketing Name": "ADT1061",
    "Device": "ADT1061",
    "Model": "ADT1061"
  },
  {
    "Retail Branding": "AIDATA",
    "Marketing Name": "ADT1061_1",
    "Device": "ADT1061_1",
    "Model": "ADT1061_1"
  },
  {
    "Retail Branding": "AIDATA",
    "Marketing Name": "ADT_1061",
    "Device": "ADT_1061",
    "Model": "ADT_1061"
  },
  {
    "Retail Branding": "AIPLUS",
    "Marketing Name": "AI+ Nova 1 5G",
    "Device": "Nova_1_5G",
    "Model": "AI+ Nova 1 5G"
  },
  {
    "Retail Branding": "AIPLUS",
    "Marketing Name": "AI+ Nova 2 5G",
    "Device": "Nova_2_5G",
    "Model": "AI+ Nova 2 5G"
  },
  {
    "Retail Branding": "AIPLUS",
    "Marketing Name": "AI+ NxtFlip 5G",
    "Device": "NxtFlip_5G",
    "Model": "AI+ NxtFlip 5G"
  },
  {
    "Retail Branding": "AIPLUS",
    "Marketing Name": "AI+ Pulse 1",
    "Device": "Pulse_1",
    "Model": "AI+ Pulse 1"
  },
  {
    "Retail Branding": "AIPLUS",
    "Marketing Name": "AI+ Pulse 2 4G",
    "Device": "Pulse_2_4G",
    "Model": "AI+ Pulse 2 4G"
  },
  {
    "Retail Branding": "AIS (Thailand)",
    "Marketing Name": "AISPLAYBOX",
    "Device": "AISPLAYBOX",
    "Model": "AISPLAYBOX"
  },
  {
    "Retail Branding": "AIS (Thailand)",
    "Marketing Name": "AISPLAYBOX",
    "Device": "B866V2-HA",
    "Model": "AISPLAYBOX"
  },
  {
    "Retail Branding": "AIS (Thailand)",
    "Marketing Name": "TBBTV01",
    "Device": "TBBTV01",
    "Model": "TBBTV01"
  },
  {
    "Retail Branding": "AKOR",
    "Marketing Name": "AKOR",
    "Device": "TG1016",
    "Model": "TG1016"
  },
  {
    "Retail Branding": "AKOR",
    "Marketing Name": "TG797",
    "Device": "TG797",
    "Model": "TG797"
  },
  {
    "Retail Branding": "AKOR",
    "Marketing Name": "TG996",
    "Device": "TG996",
    "Model": "TG996"
  },
  {
    "Retail Branding": "AKUVOX",
    "Marketing Name": "S567",
    "Device": "S567",
    "Model": "S567"
  },
  {
    "Retail Branding": "AKUVOX",
    "Marketing Name": "X937",
    "Device": "X937",
    "Model": "X937"
  },
  {
    "Retail Branding": "ALBADEEL",
    "Marketing Name": "AIP_X92",
    "Device": "AIP_X92",
    "Model": "AIP_X92"
  },
  {
    "Retail Branding": "ALBADEEL",
    "Marketing Name": "B725050U",
    "Device": "samseong",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "ALBADEEL",
    "Marketing Name": "B725U",
    "Device": "ikebukuro",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "ALBADEEL",
    "Marketing Name": "Smart TV",
    "Device": "alimos",
    "Model": "Albadeel Google TV"
  },
  {
    "Retail Branding": "ALBADEEL",
    "Marketing Name": "Smart TV",
    "Device": "longshan",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "ALBADEEL",
    "Marketing Name": "Smart TV",
    "Device": "redwood",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "ALLNET",
    "Marketing Name": "PrimeTwo",
    "Device": "PrimeTwo",
    "Model": "PrimeTwo"
  },
  {
    "Retail Branding": "ALMATEEN",
    "Marketing Name": "LXL43G7H-AT",
    "Device": "samseong",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "ALPHAWOLF",
    "Marketing Name": "A1",
    "Device": "A1",
    "Model": "A1"
  },
  {
    "Retail Branding": "ALPHAWOLF",
    "Marketing Name": "A2",
    "Device": "A2",
    "Model": "A2"
  },
  {
    "Retail Branding": "ALPHAWOLF",
    "Marketing Name": "L2",
    "Device": "L2",
    "Model": "L2"
  },
  {
    "Retail Branding": "ALPHAWOLF",
    "Marketing Name": "L2S",
    "Device": "L2S",
    "Model": "L2S"
  },
  {
    "Retail Branding": "ALPHAWOLF",
    "Marketing Name": "L3",
    "Device": "L3",
    "Model": "AR1"
  },
  {
    "Retail Branding": "ALPHAWOLF",
    "Marketing Name": "L3",
    "Device": "L3",
    "Model": "L3"
  },
  {
    "Retail Branding": "ALPHAWOLF",
    "Marketing Name": "L3A",
    "Device": "L3A",
    "Model": "L3A"
  },
  {
    "Retail Branding": "ALPHAWOLF",
    "Marketing Name": "P2",
    "Device": "P2",
    "Model": "P2"
  },
  {
    "Retail Branding": "ALPHA_LING",
    "Marketing Name": "A97GT",
    "Device": "A97GT",
    "Model": "A97GT"
  },
  {
    "Retail Branding": "ALPHA_LING",
    "Marketing Name": "A97GT_Pro",
    "Device": "A97GT_Pro",
    "Model": "A97GT_Pro"
  },
  {
    "Retail Branding": "ALPHA_LING",
    "Marketing Name": "P10SU_PLUS",
    "Device": "P10SU_PLUS",
    "Model": "P10SU_PLUS"
  },
  {
    "Retail Branding": "ALPINE",
    "Marketing Name": "INE-AX809",
    "Device": "INE-AX809",
    "Model": "INE-AX809"
  },
  {
    "Retail Branding": "ALPINE",
    "Marketing Name": "Intelligent vehicle network system",
    "Device": "INE-AW409S",
    "Model": "INE-AW409S"
  },
  {
    "Retail Branding": "ALT(IN)",
    "Marketing Name": "L1",
    "Device": "L1",
    "Model": "L1"
  },
  {
    "Retail Branding": "ALT(IN)",
    "Marketing Name": "Smart TV",
    "Device": "osaka",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "ALT.mive",
    "Marketing Name": "Kids Phone",
    "Device": "odin",
    "Model": "AT-M130"
  },
  {
    "Retail Branding": "ALT.mive",
    "Marketing Name": "Kids Phone 2",
    "Device": "odin2",
    "Model": "AT-M150"
  },
  {
    "Retail Branding": "ALT.mive",
    "Marketing Name": "Style Folder",
    "Device": "thor",
    "Model": "AT-M120"
  },
  {
    "Retail Branding": "ALT.mive",
    "Marketing Name": "Style Folder 2",
    "Device": "thor2",
    "Model": "AT-M140"
  },
  {
    "Retail Branding": "ALTOP",
    "Marketing Name": "ALTOP E board",
    "Device": "AIEDLA",
    "Model": "A SENSE"
  },
  {
    "Retail Branding": "AMCON",
    "Marketing Name": "Smart TV",
    "Device": "alimos",
    "Model": "AMCON Google TV"
  },
  {
    "Retail Branding": "AMCON",
    "Marketing Name": "Smart TV",
    "Device": "dangni",
    "Model": "AMCON Google TV"
  },
  {
    "Retail Branding": "AMG-Smartphone",
    "Marketing Name": "AMG_WR24",
    "Device": "ASPWR24",
    "Model": "ASPWR24"
  },
  {
    "Retail Branding": "AMGx13e",
    "Marketing Name": "ASPE2201",
    "Device": "ASPE2201",
    "Model": "ASPE2201"
  },
  {
    "Retail Branding": "AMTC",
    "Marketing Name": "MD1001 Tablet",
    "Device": "MD1001",
    "Model": "MD1001"
  },
  {
    "Retail Branding": "AMTC",
    "Marketing Name": "MD7008",
    "Device": "MD7008A",
    "Model": "MD7008"
  },
  {
    "Retail Branding": "AMTC",
    "Marketing Name": "MD7081",
    "Device": "MD7081A",
    "Model": "MD7081"
  },
  {
    "Retail Branding": "AMobile",
    "Marketing Name": "PD470",
    "Device": "PD470",
    "Model": "PD470"
  },
  {
    "Retail Branding": "AMobile",
    "Marketing Name": "PD602",
    "Device": "PD602",
    "Model": "PD602"
  },
  {
    "Retail Branding": "AMobile",
    "Marketing Name": "RT101",
    "Device": "RT101",
    "Model": "RT101"
  },
  {
    "Retail Branding": "ANAM",
    "Marketing Name": "ANAM",
    "Device": "seocho",
    "Model": "ANAM 4K Android TV"
  },
  {
    "Retail Branding": "ANDDORO",
    "Marketing Name": "B7V1-STK",
    "Device": "B7V1-STK",
    "Model": "B7V1-STK"
  },
  {
    "Retail Branding": "ANDRINO",
    "Marketing Name": "Andrino",
    "Device": "bangbae",
    "Model": "andrino 4K Android TV"
  },
  {
    "Retail Branding": "ANDRINO",
    "Marketing Name": "Andrino",
    "Device": "komagome",
    "Model": "andrino 2K Android TV"
  },
  {
    "Retail Branding": "ANEE",
    "Marketing Name": "A1 Neo",
    "Device": "A1_Neo",
    "Model": "A1_Neo"
  },
  {
    "Retail Branding": "ANEXA",
    "Marketing Name": "EUROPE",
    "Device": "osaka",
    "Model": "ANEXA Android TV"
  },
  {
    "Retail Branding": "ANEXA",
    "Marketing Name": "Smart TV",
    "Device": "alimos",
    "Model": "ANEXA Android TV"
  },
  {
    "Retail Branding": "ANEXA",
    "Marketing Name": "Smart TV",
    "Device": "dangni",
    "Model": "ANEXA Android TV"
  },
  {
    "Retail Branding": "ANEXA",
    "Marketing Name": "Smart TV",
    "Device": "redwood",
    "Model": "ANEXA Android TV"
  },
  {
    "Retail Branding": "ANFU",
    "Marketing Name": "AF930",
    "Device": "AF930",
    "Model": "AF930"
  },
  {
    "Retail Branding": "ANFU",
    "Marketing Name": "AF980",
    "Device": "AF980",
    "Model": "AF980"
  },
  {
    "Retail Branding": "ANS",
    "Marketing Name": "L50",
    "Device": "L50",
    "Model": "L50"
  },
  {
    "Retail Branding": "ANS",
    "Marketing Name": "L51",
    "Device": "L51",
    "Model": "L51"
  },
  {
    "Retail Branding": "ANS",
    "Marketing Name": "SP5670",
    "Device": "SP5670",
    "Model": "SP5670"
  },
  {
    "Retail Branding": "ANS",
    "Marketing Name": "Trailblazer",
    "Device": "rugged-smartphone",
    "Model": "H450R"
  },
  {
    "Retail Branding": "ANS",
    "Marketing Name": "UL40",
    "Device": "UL40",
    "Model": "UL40"
  },
  {
    "Retail Branding": "ANTEMPE",
    "Marketing Name": "D115_EEA",
    "Device": "D115_EEA",
    "Model": "D115_EEA"
  },
  {
    "Retail Branding": "ANTEMPER",
    "Marketing Name": "D106_EEA",
    "Device": "D106_EEA",
    "Model": "D106_EEA"
  },
  {
    "Retail Branding": "ANTEMPER",
    "Marketing Name": "D136_EEA",
    "Device": "D136_EEA",
    "Model": "D136_EEA"
  },
  {
    "Retail Branding": "ANXONIT",
    "Marketing Name": "AnPad_U2",
    "Device": "AnPad_U2",
    "Model": "AnPad_U2"
  },
  {
    "Retail Branding": "AOC",
    "Marketing Name": "A110_E",
    "Device": "A110_E",
    "Model": "A110_E"
  },
  {
    "Retail Branding": "AOC",
    "Marketing Name": "A731",
    "Device": "A731-N1",
    "Model": "A731-N1"
  },
  {
    "Retail Branding": "AOC",
    "Marketing Name": "A731-N2",
    "Device": "A731-N2",
    "Model": "A731-N2"
  },
  {
    "Retail Branding": "AOC",
    "Marketing Name": "A741",
    "Device": "A741",
    "Model": "A741"
  },
  {
    "Retail Branding": "AOC",
    "Marketing Name": "A941",
    "Device": "A941",
    "Model": "A941"
  },
  {
    "Retail Branding": "AOC",
    "Marketing Name": "AOC",
    "Device": "A731",
    "Model": "A731"
  },
  {
    "Retail Branding": "AOC",
    "Marketing Name": "AOC",
    "Device": "A731-H1",
    "Model": "A731-H1"
  },
  {
    "Retail Branding": "AOC",
    "Marketing Name": "AOC",
    "Device": "A732G",
    "Model": "A732G"
  },
  {
    "Retail Branding": "AOC",
    "Marketing Name": "AOC",
    "Device": "AOC_A831L-D",
    "Model": "A831L-D"
  },
  {
    "Retail Branding": "AOC",
    "Marketing Name": "AOC",
    "Device": "elliniko",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "AOC",
    "Marketing Name": "AOC",
    "Device": "hongkong",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "AOC",
    "Marketing Name": "AOC",
    "Device": "khardi",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "AOC",
    "Marketing Name": "AOC",
    "Device": "mountbaker",
    "Model": "2K SMART TV"
  },
  {
    "Retail Branding": "AOC",
    "Marketing Name": "AOC Android TV",
    "Device": "PH0M_EA_T32",
    "Model": "AOC Android TV"
  },
  {
    "Retail Branding": "AOC",
    "Marketing Name": "AOC Google TV TA7",
    "Device": "PH3M_AL_T32",
    "Model": "AOC Google TV TA7"
  },
  {
    "Retail Branding": "AOC",
    "Marketing Name": "AOC Smart Gaming Monitor",
    "Device": "wulong",
    "Model": "AOC Smart Gaming Monitor"
  },
  {
    "Retail Branding": "AOC",
    "Marketing Name": "M10c",
    "Device": "M10c",
    "Model": "M10"
  },
  {
    "Retail Branding": "AOC",
    "Marketing Name": "Q10107L-ME",
    "Device": "Q10107L-ME",
    "Model": "Q10107L-ME"
  },
  {
    "Retail Branding": "AOC",
    "Marketing Name": "Q10107LW-ME",
    "Device": "Q10107LW-ME",
    "Model": "Q10107LW-ME"
  },
  {
    "Retail Branding": "AOC",
    "Marketing Name": "Q8108L-ME",
    "Device": "Q8108L-ME",
    "Model": "Q8108L-ME"
  },
  {
    "Retail Branding": "AORLYM",
    "Marketing Name": "P10",
    "Device": "RK5S-A",
    "Model": "P10"
  },
  {
    "Retail Branding": "AORLYM",
    "Marketing Name": "P10 Kid",
    "Device": "RK5Kid-A",
    "Model": "P10 Kid"
  },
  {
    "Retail Branding": "AORLYM",
    "Marketing Name": "P10 Pro",
    "Device": "T5-A",
    "Model": "P10 Pro"
  },
  {
    "Retail Branding": "AORLYM",
    "Marketing Name": "P11",
    "Device": "T2-A",
    "Model": "P11"
  },
  {
    "Retail Branding": "AORLYM",
    "Marketing Name": "P11 Pro",
    "Device": "T4-A",
    "Model": "P11 Pro"
  },
  {
    "Retail Branding": "AORLYM",
    "Marketing Name": "P12",
    "Device": "P7C-A",
    "Model": "P12"
  },
  {
    "Retail Branding": "AORLYM",
    "Marketing Name": "P12 Power",
    "Device": "P9T-A",
    "Model": "P12 Plus"
  },
  {
    "Retail Branding": "AORLYM",
    "Marketing Name": "P12 Pro",
    "Device": "P7S-A",
    "Model": "P12 Pro"
  },
  {
    "Retail Branding": "AORLYM",
    "Marketing Name": "P13",
    "Device": "P8C-A",
    "Model": "P13"
  },
  {
    "Retail Branding": "AORLYM",
    "Marketing Name": "P13 Pro",
    "Device": "P8-A",
    "Model": "P13 Pro"
  },
  {
    "Retail Branding": "AORO",
    "Marketing Name": "AORO-M7",
    "Device": "AORO-M7",
    "Model": "AORO-M7"
  },
  {
    "Retail Branding": "AORO",
    "Marketing Name": "AORO_A25",
    "Device": "AORO_A25",
    "Model": "AORO_A25"
  },
  {
    "Retail Branding": "AORO",
    "Marketing Name": "M8",
    "Device": "M8",
    "Model": "M8"
  },
  {
    "Retail Branding": "AOSKEY",
    "Marketing Name": "F11",
    "Device": "F11",
    "Model": "F11"
  },
  {
    "Retail Branding": "AOSKEY",
    "Marketing Name": "P21",
    "Device": "P21",
    "Model": "P21"
  },
  {
    "Retail Branding": "AOYODKG",
    "Marketing Name": "A21S",
    "Device": "A21S",
    "Model": "A21S"
  },
  {
    "Retail Branding": "AOYODKG",
    "Marketing Name": "A21S_US",
    "Device": "A21S",
    "Model": "A21S"
  },
  {
    "Retail Branding": "AOYODKG",
    "Marketing Name": "A7",
    "Device": "A7",
    "Model": "A7"
  },
  {
    "Retail Branding": "AOYODKG",
    "Marketing Name": "M50",
    "Device": "M50",
    "Model": "M50"
  },
  {
    "Retail Branding": "AOYODKG",
    "Marketing Name": "M50_EEA",
    "Device": "M50_EEA",
    "Model": "M50_EEA"
  },
  {
    "Retail Branding": "AOYODKG",
    "Marketing Name": "TAB-A8",
    "Device": "TAB-A8",
    "Model": "TAB-A8"
  },
  {
    "Retail Branding": "AOZ (SZ)",
    "Marketing Name": "Mobile_Smart_Screen",
    "Device": "Mobile_Smart_Screen",
    "Model": "Mobile_Smart_Screen"
  },
  {
    "Retail Branding": "AOZORA",
    "Marketing Name": "A57",
    "Device": "A57",
    "Model": "A57"
  },
  {
    "Retail Branding": "AOZORA",
    "Marketing Name": "A61",
    "Device": "A61",
    "Model": "A61"
  },
  {
    "Retail Branding": "AOZORA",
    "Marketing Name": "K8",
    "Device": "K8",
    "Model": "K8 Active"
  },
  {
    "Retail Branding": "AOZORA",
    "Marketing Name": "k101",
    "Device": "K101",
    "Model": "K101"
  },
  {
    "Retail Branding": "AOpen",
    "Marketing Name": "Fire Legend FT12",
    "Device": "AOPEN_X12M2",
    "Model": "FT12X-M2"
  },
  {
    "Retail Branding": "AOpen",
    "Marketing Name": "Fire Legend FT12",
    "Device": "AOPEN_X12M2",
    "Model": "FT12X-M2_EEA"
  },
  {
    "Retail Branding": "AOpen",
    "Marketing Name": "RK3288 10\" Chromebase",
    "Device": "",
    "Model": ""
  },
  {
    "Retail Branding": "AOpen",
    "Marketing Name": "RK3288 10\" Chromebase",
    "Device": "tiger_cheets",
    "Model": "AOpen Chromebase Mini"
  },
  {
    "Retail Branding": "AOpen",
    "Marketing Name": "RK3288 Mini Chromebox",
    "Device": "",
    "Model": ""
  },
  {
    "Retail Branding": "AOpen",
    "Marketing Name": "RK3288 Mini Chromebox",
    "Device": "fievel_cheets",
    "Model": "AOpen Chromebox Mini"
  },
  {
    "Retail Branding": "APD_Spain",
    "Marketing Name": "APD_REGGIO",
    "Device": "REGGIO",
    "Model": "APD REGGIO"
  },
  {
    "Retail Branding": "AQHH",
    "Marketing Name": "A75",
    "Device": "A75",
    "Model": "A75"
  },
  {
    "Retail Branding": "ARATEK",
    "Marketing Name": "BM5500",
    "Device": "BM5500",
    "Model": "BM5500"
  },
  {
    "Retail Branding": "ARATEK",
    "Marketing Name": "BM5500S",
    "Device": "BM5500S",
    "Model": "BM5500S"
  },
  {
    "Retail Branding": "ARATEK",
    "Marketing Name": "Marshall-5",
    "Device": "Marshall-5",
    "Model": "Marshall-5"
  },
  {
    "Retail Branding": "ARATEK",
    "Marketing Name": "Marshall-5S",
    "Device": "Marshall-5A",
    "Model": "Marshall-5S"
  },
  {
    "Retail Branding": "ARATEK",
    "Marketing Name": "Marshall-5S",
    "Device": "Marshall-5S",
    "Model": "Marshall-5S"
  },
  {
    "Retail Branding": "ARATEK",
    "Marketing Name": "Marshall-8",
    "Device": "Marshall-8",
    "Model": "Marshall-8"
  },
  {
    "Retail Branding": "ARATEK",
    "Marketing Name": "Marshall-8",
    "Device": "Marshall-8-Plus",
    "Model": "Marshall-8"
  },
  {
    "Retail Branding": "ARATEK",
    "Marketing Name": "TruFace",
    "Device": "TruFace",
    "Model": "TruFace"
  },
  {
    "Retail Branding": "ARBOR",
    "Marketing Name": "G47",
    "Device": "G47",
    "Model": "G47"
  },
  {
    "Retail Branding": "ARBOR",
    "Marketing Name": "GT78-VN",
    "Device": "GT78-VN",
    "Model": "GT78-VN"
  },
  {
    "Retail Branding": "ARBOR",
    "Marketing Name": "HT10",
    "Device": "HT10",
    "Model": "HT10"
  },
  {
    "Retail Branding": "ARGUEST",
    "Marketing Name": "Arguest Android TV",
    "Device": "millbrae",
    "Model": "Arguest Android TV"
  },
  {
    "Retail Branding": "ARGUEST",
    "Marketing Name": "Arguest Android UHD TV",
    "Device": "kunyang",
    "Model": "Arguest Android UHD TV"
  },
  {
    "Retail Branding": "ARISTOGEA",
    "Marketing Name": "M258",
    "Device": "M258",
    "Model": "M258"
  },
  {
    "Retail Branding": "ARISTOGEA",
    "Marketing Name": "M832",
    "Device": "M832",
    "Model": "M832"
  },
  {
    "Retail Branding": "ARMADILOS",
    "Marketing Name": "Listo22",
    "Device": "Listo22",
    "Model": "Listo22"
  },
  {
    "Retail Branding": "ARRQW",
    "Marketing Name": "RO-55LCS",
    "Device": "samseong",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "ARRQW",
    "Marketing Name": "Saudi Arabia",
    "Device": "tamachi",
    "Model": "ARRQW FHD Android TV"
  },
  {
    "Retail Branding": "ARRQW",
    "Marketing Name": "Saudi Arabia",
    "Device": "yeongdeungpo",
    "Model": "ARRQW UHD Android TV"
  },
  {
    "Retail Branding": "ARRQW",
    "Marketing Name": "Smart TV",
    "Device": "longshan",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "ARTEQLED",
    "Marketing Name": "Smart TV",
    "Device": "osaka",
    "Model": "ARTEQLED Android TV"
  },
  {
    "Retail Branding": "ARTEQLED",
    "Marketing Name": "Smart TV",
    "Device": "redwood",
    "Model": "ARTEQLED Android TV"
  },
  {
    "Retail Branding": "ARTRAN",
    "Marketing Name": "ARTRAN _EI101F",
    "Device": "ARTRAN_EI101F",
    "Model": "EI101F"
  },
  {
    "Retail Branding": "ARTRAN",
    "Marketing Name": "AZ101F",
    "Device": "AZ101F",
    "Model": "AZ101F"
  },
  {
    "Retail Branding": "ARTRAN",
    "Marketing Name": "IB101F_Pro",
    "Device": "IB101F_Pro",
    "Model": "IB101F Pro"
  },
  {
    "Retail Branding": "ARTRAN",
    "Marketing Name": "IB119Q",
    "Device": "IB119Q",
    "Model": "IB119Q"
  },
  {
    "Retail Branding": "ARTRAN",
    "Marketing Name": "IB868H",
    "Device": "IB868H",
    "Model": "IB868H"
  },
  {
    "Retail Branding": "ARTRAN",
    "Marketing Name": "LI109Q",
    "Device": "ARTRAN_Tablet_1095",
    "Model": "LI109Q"
  },
  {
    "Retail Branding": "ARZOPA",
    "Marketing Name": "P1",
    "Device": "ARZOPA_P1",
    "Model": "ARZOPA P1"
  },
  {
    "Retail Branding": "ARZOPA",
    "Marketing Name": "P1",
    "Device": "P1",
    "Model": "P1"
  },
  {
    "Retail Branding": "ARZOPA",
    "Marketing Name": "P1-EEA",
    "Device": "P1",
    "Model": "P1-EEA"
  },
  {
    "Retail Branding": "ARZOPA",
    "Marketing Name": "P1-Pro_EEA",
    "Device": "P1-Pro",
    "Model": "ARZOPA P1 Pro"
  },
  {
    "Retail Branding": "ARZOPA",
    "Marketing Name": "P1-S",
    "Device": "P1-S",
    "Model": "ARZOPA P1S"
  },
  {
    "Retail Branding": "ARZOPA",
    "Marketing Name": "P1S",
    "Device": "P1S",
    "Model": "P1S"
  },
  {
    "Retail Branding": "ARZOPA",
    "Marketing Name": "P1_EEA",
    "Device": "ARZOPA_P1",
    "Model": "ARZOPA P1"
  },
  {
    "Retail Branding": "ASHER",
    "Marketing Name": "Smart TV",
    "Device": "longshan",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "ASHER",
    "Marketing Name": "Smart TV",
    "Device": "redwood",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "ASHIMA",
    "Marketing Name": "OEM50ANDROID22/OEM55ANDROID22",
    "Device": "songshan",
    "Model": "SmartTV 4K"
  },
  {
    "Retail Branding": "ASTCA",
    "Marketing Name": "AA 787 S",
    "Device": "SURGE_AA_787_S",
    "Model": "AA 787 S"
  },
  {
    "Retail Branding": "ASTECH",
    "Marketing Name": "Astech NEO",
    "Device": "Astech_NEO",
    "Model": "Astech NEO"
  },
  {
    "Retail Branding": "ASTECH",
    "Marketing Name": "Astech S7",
    "Device": "Astech_S7",
    "Model": "Astech S7"
  },
  {
    "Retail Branding": "ASTECH",
    "Marketing Name": "Astech S7 pro",
    "Device": "Astech_S7_pro",
    "Model": "Astech S7 pro"
  },
  {
    "Retail Branding": "ASTECH",
    "Marketing Name": "Astech_IRIS",
    "Device": "Astech_IRIS",
    "Model": "Astech IRIS"
  },
  {
    "Retail Branding": "ASTECH",
    "Marketing Name": "Astech_S8",
    "Device": "Astech_S8",
    "Model": "Astech S8"
  },
  {
    "Retail Branding": "ASTECH",
    "Marketing Name": "Astech_S9",
    "Device": "Astech_S9",
    "Model": "Astech S9"
  },
  {
    "Retail Branding": "ASTECH",
    "Marketing Name": "R10G",
    "Device": "R10G",
    "Model": "R10G"
  },
  {
    "Retail Branding": "ASTECH",
    "Marketing Name": "R3",
    "Device": "R3",
    "Model": "R3"
  },
  {
    "Retail Branding": "ASTECH",
    "Marketing Name": "R3_GTV",
    "Device": "R3_GTV",
    "Model": "R3G"
  },
  {
    "Retail Branding": "ASTECH",
    "Marketing Name": "R4",
    "Device": "R4",
    "Model": "R4"
  },
  {
    "Retail Branding": "ASTECH",
    "Marketing Name": "Senegal",
    "Device": "tamachi",
    "Model": "ASTECH FHD Android TV"
  },
  {
    "Retail Branding": "ASTECH",
    "Marketing Name": "Senegal",
    "Device": "yeongdeungpo",
    "Model": "ASTECH UHD Android TV"
  },
  {
    "Retail Branding": "ASTECH",
    "Marketing Name": "Smart TV",
    "Device": "alimos",
    "Model": "ASTECH Google TV"
  },
  {
    "Retail Branding": "ASTECH",
    "Marketing Name": "Smart TV",
    "Device": "dangni",
    "Model": "ASTECH Google TV"
  },
  {
    "Retail Branding": "ASTEX",
    "Marketing Name": "ASTEX 2K Android",
    "Device": "lasalle",
    "Model": "ASTEX 2K Android"
  },
  {
    "Retail Branding": "ASTEX",
    "Marketing Name": "ASTEX 2K Google TV",
    "Device": "capitolhill",
    "Model": "ASTEX 2K Google TV"
  },
  {
    "Retail Branding": "ASTEX",
    "Marketing Name": "ASTEX 4K Android",
    "Device": "kenton",
    "Model": "ASTEX 4K Android"
  },
  {
    "Retail Branding": "ASTEX",
    "Marketing Name": "ASTEX 4K Google TV",
    "Device": "keoneae",
    "Model": "ASTEX 4K Google TV"
  },
  {
    "Retail Branding": "ASTEX",
    "Marketing Name": "ASTEX Google TV",
    "Device": "bandra",
    "Model": "ASTEX Google TV"
  },
  {
    "Retail Branding": "ASTEX",
    "Marketing Name": "KKRTK2851FJTGTV_ASTEX",
    "Device": "ksr",
    "Model": "ASTEX JT Google TV"
  },
  {
    "Retail Branding": "ASTON",
    "Marketing Name": "Hyper_Max_Power",
    "Device": "Hyper_Max_Power",
    "Model": "Hyper_Max_Power"
  },
  {
    "Retail Branding": "ASTON",
    "Marketing Name": "IDEA",
    "Device": "IDEA",
    "Model": "IDEA"
  },
  {
    "Retail Branding": "ASTON",
    "Marketing Name": "NEO",
    "Device": "NEO",
    "Model": "NEO"
  },
  {
    "Retail Branding": "ASTREX",
    "Marketing Name": "VegaPro",
    "Device": "VegaPro",
    "Model": "VegaPro"
  },
  {
    "Retail Branding": "ASTREX",
    "Marketing Name": "Victory",
    "Device": "Victory",
    "Model": "Victory"
  },
  {
    "Retail Branding": "ASTREX",
    "Marketing Name": "VictoryPro",
    "Device": "VictoryPro",
    "Model": "VictoryPro"
  },
  {
    "Retail Branding": "AS_ELECTRONICS",
    "Marketing Name": "AS1",
    "Device": "AS1",
    "Model": "AS1"
  },
  {
    "Retail Branding": "AT&T",
    "Marketing Name": "9020A",
    "Device": "tint8_att",
    "Model": "9020A"
  },
  {
    "Retail Branding": "AT&T",
    "Marketing Name": "AT&T Calypso® 4",
    "Device": "U380AA",
    "Model": "U380AA"
  },
  {
    "Retail Branding": "AT&T",
    "Marketing Name": "AT&T Maestro™ Plus",
    "Device": "v350u",
    "Model": "V350U"
  },
  {
    "Retail Branding": "AT&T",
    "Marketing Name": "AT&T Motivate® Pro 2 5G",
    "Device": "SN512A",
    "Model": "SN512A"
  },
  {
    "Retail Branding": "AT&T",
    "Marketing Name": "AT&T Motivate® Pro 5G",
    "Device": "SN509A",
    "Model": "SN509A"
  },
  {
    "Retail Branding": "AT&T",
    "Marketing Name": "AT&T Motivate™ 2",
    "Device": "EA211002",
    "Model": "EA211002"
  },
  {
    "Retail Branding": "AT&T",
    "Marketing Name": "AT&T Propel™ 5G",
    "Device": "U6080AA",
    "Model": "U6080AA"
  },
  {
    "Retail Branding": "AT&T",
    "Marketing Name": "AT&T RADIANT™ Max 5G",
    "Device": "EA211001",
    "Model": "EA211001"
  },
  {
    "Retail Branding": "AT&T",
    "Marketing Name": "AT&T Trek™",
    "Device": "SN515AR",
    "Model": "SN515AR"
  },
  {
    "Retail Branding": "AT&T",
    "Marketing Name": "AT&T Verge™",
    "Device": "SL219A",
    "Model": "SL219A"
  },
  {
    "Retail Branding": "AT&T",
    "Marketing Name": "AT&T Verge™ 2 5G",
    "Device": "SN333A",
    "Model": "SN333A"
  },
  {
    "Retail Branding": "AT&T",
    "Marketing Name": "AT&T Vista™",
    "Device": "WTATTRW2",
    "Model": "WTATTRW2"
  },
  {
    "Retail Branding": "AT&T",
    "Marketing Name": "Pelican",
    "Device": "EA211005",
    "Model": "EA211005"
  },
  {
    "Retail Branding": "AT&T",
    "Marketing Name": "QS5509A",
    "Device": "QS5509QL",
    "Model": "QS5509A"
  },
  {
    "Retail Branding": "AT&T",
    "Marketing Name": "U202AA",
    "Device": "U202AA",
    "Model": "U202AA"
  },
  {
    "Retail Branding": "AT&T",
    "Marketing Name": "U304AA",
    "Device": "U304AA",
    "Model": "U304AA"
  },
  {
    "Retail Branding": "AT&T",
    "Marketing Name": "U318AA",
    "Device": "U318AA",
    "Model": "U318AA"
  },
  {
    "Retail Branding": "AT&T",
    "Marketing Name": "U319AA",
    "Device": "U319AA",
    "Model": "U319AA"
  },
  {
    "Retail Branding": "AT&T",
    "Marketing Name": "U626AA",
    "Device": "U626AA",
    "Model": "U626AA"
  },
  {
    "Retail Branding": "AT&T",
    "Marketing Name": "U705AA",
    "Device": "U705AA",
    "Model": "U705AA"
  },
  {
    "Retail Branding": "ATEAM",
    "Marketing Name": "A1010",
    "Device": "A1010",
    "Model": "A1010"
  },
  {
    "Retail Branding": "ATEAM",
    "Marketing Name": "A801",
    "Device": "A801",
    "Model": "A801"
  },
  {
    "Retail Branding": "ATEC",
    "Marketing Name": "APD3",
    "Device": "APD3",
    "Model": "APD3"
  },
  {
    "Retail Branding": "ATEC",
    "Marketing Name": "ATEC GRANDE",
    "Device": "ATEC_IWB",
    "Model": "A8GC"
  },
  {
    "Retail Branding": "ATEC",
    "Marketing Name": "ATEC_GRANDE",
    "Device": "ATEC_IWB",
    "Model": "ABGC"
  },
  {
    "Retail Branding": "ATEL",
    "Marketing Name": "A68EL",
    "Device": "A68EL",
    "Model": "A68EL"
  },
  {
    "Retail Branding": "ATID",
    "Marketing Name": "AT908",
    "Device": "AT908",
    "Model": "AT908"
  },
  {
    "Retail Branding": "ATID",
    "Marketing Name": "AT908_EEA",
    "Device": "AT908",
    "Model": "AT908_EEA"
  },
  {
    "Retail Branding": "ATILIM UNIVERSITY",
    "Marketing Name": "ATILIM_mPAD07",
    "Device": "ATILIM_mPAD07",
    "Model": "ATILIM_mPAD07"
  },
  {
    "Retail Branding": "ATM (Brazil)",
    "Marketing Name": "IT-1001A",
    "Device": "IT-1001A",
    "Model": "IT-1001A"
  },
  {
    "Retail Branding": "ATM (Brazil)",
    "Marketing Name": "R5",
    "Device": "R5",
    "Model": "R5"
  },
  {
    "Retail Branding": "ATM (Brazil)",
    "Marketing Name": "R5Plus",
    "Device": "R5Plus",
    "Model": "R5Plus"
  },
  {
    "Retail Branding": "ATM (Brazil)",
    "Marketing Name": "R5_Pro",
    "Device": "R5_Pro",
    "Model": "R5 Pro"
  },
  {
    "Retail Branding": "ATM (Brazil)",
    "Marketing Name": "X50u",
    "Device": "X50u",
    "Model": "X50u"
  },
  {
    "Retail Branding": "ATMPC",
    "Marketing Name": "A9_EEA",
    "Device": "A9",
    "Model": "A9"
  },
  {
    "Retail Branding": "ATMPC",
    "Marketing Name": "IT-701A",
    "Device": "IT-701A",
    "Model": "IT-701A"
  },
  {
    "Retail Branding": "ATMPC",
    "Marketing Name": "IT-701A3",
    "Device": "IT-701A3",
    "Model": "IT-701A"
  },
  {
    "Retail Branding": "ATMPC",
    "Marketing Name": "IT-701A3_EEA",
    "Device": "IT-701A3_EEA",
    "Model": "IT-701A"
  },
  {
    "Retail Branding": "ATMPC",
    "Marketing Name": "IT-701A4",
    "Device": "IT-701A4",
    "Model": "IT-701A"
  },
  {
    "Retail Branding": "ATMPC",
    "Marketing Name": "IT-701A4_EEA",
    "Device": "IT-701A4_EEA",
    "Model": "IT-701A"
  },
  {
    "Retail Branding": "ATMPC",
    "Marketing Name": "IT-801A",
    "Device": "IT-801A",
    "Model": "IT-801A"
  },
  {
    "Retail Branding": "ATMPC",
    "Marketing Name": "IT-801B",
    "Device": "IT-801B",
    "Model": "IT-801B"
  },
  {
    "Retail Branding": "ATMPC",
    "Marketing Name": "IT-801BA1",
    "Device": "IT-801BA1",
    "Model": "IT-801B"
  },
  {
    "Retail Branding": "ATMPC",
    "Marketing Name": "IT-801BA1_EEA",
    "Device": "IT-801BA1_EEA",
    "Model": "IT-801B"
  },
  {
    "Retail Branding": "ATMPC",
    "Marketing Name": "IT-801BA3",
    "Device": "IT-801BA3",
    "Model": "IT-801BA3"
  },
  {
    "Retail Branding": "ATMPC",
    "Marketing Name": "IT-801BA3_EEA",
    "Device": "IT-801BA3",
    "Model": "IT-801BA3"
  },
  {
    "Retail Branding": "ATMPC",
    "Marketing Name": "IT-801BA5",
    "Device": "IT-801BA5",
    "Model": "IT-801B"
  },
  {
    "Retail Branding": "ATMPC",
    "Marketing Name": "IT-801BA5_EEA",
    "Device": "IT-801BA5_EEA",
    "Model": "IT-801B"
  },
  {
    "Retail Branding": "ATMPC",
    "Marketing Name": "IT-801BA6",
    "Device": "IT-801BA6",
    "Model": "IT-801B"
  },
  {
    "Retail Branding": "ATMPC",
    "Marketing Name": "IT-801BA6_EEA",
    "Device": "IT-801BA6_EEA",
    "Model": "IT-801B"
  },
  {
    "Retail Branding": "ATMPC",
    "Marketing Name": "IT-801BA7_EEA",
    "Device": "IT-801BA7_EEA",
    "Model": "IT-801B"
  },
  {
    "Retail Branding": "ATMPC",
    "Marketing Name": "IT-801BA9_EEA",
    "Device": "IT-801BA9_EEA",
    "Model": "IT-801B"
  },
  {
    "Retail Branding": "ATMPC",
    "Marketing Name": "IT-801C",
    "Device": "IT-801C",
    "Model": "IT-801C"
  },
  {
    "Retail Branding": "ATMPC",
    "Marketing Name": "IT_1001A2",
    "Device": "IT_1001A2",
    "Model": "IT_1001A2"
  },
  {
    "Retail Branding": "ATMPC",
    "Marketing Name": "IT_1001A2_EEA",
    "Device": "IT_1001A2_EEA",
    "Model": "IT_1001A2_EEA"
  },
  {
    "Retail Branding": "ATMPC",
    "Marketing Name": "IT_1001A2_EEA",
    "Device": "IT_1001A2_EEA",
    "Model": "IT_801B"
  },
  {
    "Retail Branding": "ATMPC",
    "Marketing Name": "IT_701A",
    "Device": "IT_701A",
    "Model": "IT_701A"
  },
  {
    "Retail Branding": "ATMPC",
    "Marketing Name": "IT_701A1",
    "Device": "IT_701A1",
    "Model": "IT_701A"
  },
  {
    "Retail Branding": "ATMPC",
    "Marketing Name": "IT_701A2",
    "Device": "IT_701A2",
    "Model": "IT_701A"
  },
  {
    "Retail Branding": "ATMPC",
    "Marketing Name": "IT_701A2_EEA",
    "Device": "IT_701A2_EEA",
    "Model": "IT_701A"
  },
  {
    "Retail Branding": "ATMPC",
    "Marketing Name": "IT_701A_EEA",
    "Device": "IT_701A_EEA",
    "Model": "IT_701A"
  },
  {
    "Retail Branding": "ATMPC",
    "Marketing Name": "IT_801B",
    "Device": "IT_801B",
    "Model": "IT_801B"
  },
  {
    "Retail Branding": "ATMPC",
    "Marketing Name": "IT_801BA4",
    "Device": "IT_801BA4",
    "Model": "IT_801B"
  },
  {
    "Retail Branding": "ATMPC",
    "Marketing Name": "IT_801BA4_EEA",
    "Device": "IT_801BA4_EEA",
    "Model": "IT_801B"
  },
  {
    "Retail Branding": "ATMPC",
    "Marketing Name": "IT_801CA2_EEA",
    "Device": "IT_801CA2_EEA",
    "Model": "IT_801C"
  },
  {
    "Retail Branding": "ATMPC",
    "Marketing Name": "IT_801CA2_EEA",
    "Device": "IT_801CA2_EEA",
    "Model": "IT_801CA2_EEA"
  },
  {
    "Retail Branding": "ATOL",
    "Marketing Name": "Smart.Slim Plus",
    "Device": "t50p",
    "Model": "Smart_Slim_Plus"
  },
  {
    "Retail Branding": "ATOL",
    "Marketing Name": "Smart_Prime",
    "Device": "t150",
    "Model": "Smart_Prime"
  },
  {
    "Retail Branding": "ATOTO",
    "Marketing Name": "X10",
    "Device": "Multifunctional_Tablet",
    "Model": "X10"
  },
  {
    "Retail Branding": "ATVIO",
    "Marketing Name": "100011886BK",
    "Device": "100011886BK",
    "Model": "100011886BK"
  },
  {
    "Retail Branding": "ATVIO",
    "Marketing Name": "ATVIO",
    "Device": "mid7015_mk_32",
    "Model": "MID7015"
  },
  {
    "Retail Branding": "ATVIO",
    "Marketing Name": "MID1032",
    "Device": "mid1032_mr_32",
    "Model": "MID1032"
  },
  {
    "Retail Branding": "AUPO",
    "Marketing Name": "AUPO_Cute_75_EEA",
    "Device": "AUPO_Cute_75",
    "Model": "AUPO Cute 75"
  },
  {
    "Retail Branding": "AUPO",
    "Marketing Name": "AUPO_Zeus_10_Pro",
    "Device": "AUPO_Zeus_10_Pro",
    "Model": "AUPO_Zeus_10_Pro"
  },
  {
    "Retail Branding": "AUPO",
    "Marketing Name": "AUPO_Zeus_10_Pro_ROW",
    "Device": "AUPO_Zeus_10_Pro_ROW",
    "Model": "AUPO_Zeus_10_Pro"
  },
  {
    "Retail Branding": "AURII",
    "Marketing Name": "AURII ULTRA",
    "Device": "AURII_ULTRA",
    "Model": "AURII ULTRA"
  },
  {
    "Retail Branding": "AURII",
    "Marketing Name": "AURII_AMUSE_4G",
    "Device": "AURII_AMUSE_4G",
    "Model": "AURII_AMUSE_4G"
  },
  {
    "Retail Branding": "AURII",
    "Marketing Name": "AURII_FAME",
    "Device": "AURII_FAME",
    "Model": "AURII_FAME"
  },
  {
    "Retail Branding": "AURZEN",
    "Marketing Name": "BOOM MINI",
    "Device": "yandangshan",
    "Model": "AURZEN BOOM MINI"
  },
  {
    "Retail Branding": "AURZEN",
    "Marketing Name": "BOOMAIR",
    "Device": "himalaya",
    "Model": "BOOMAIR"
  },
  {
    "Retail Branding": "AURZEN",
    "Marketing Name": "D1G",
    "Device": "yandangshan",
    "Model": "AURZEN D1G"
  },
  {
    "Retail Branding": "AURZEN",
    "Marketing Name": "D1MAX",
    "Device": "coorg",
    "Model": "D1MAX"
  },
  {
    "Retail Branding": "AURZEN",
    "Marketing Name": "TB-AS100A",
    "Device": "TB-AS100A",
    "Model": "TB-AS100A"
  },
  {
    "Retail Branding": "AURZEN",
    "Marketing Name": "TB-AS110A",
    "Device": "TB-AS110A",
    "Model": "TB-AS110A"
  },
  {
    "Retail Branding": "AUZMAI",
    "Marketing Name": "Mete8",
    "Device": "Mete8",
    "Model": "Mete8"
  },
  {
    "Retail Branding": "AUZMAI",
    "Marketing Name": "Mete8_EEA",
    "Device": "Mete8_EEA",
    "Model": "Mete8_EEA"
  },
  {
    "Retail Branding": "AUZMAI",
    "Marketing Name": "V60",
    "Device": "Azumi_V60F",
    "Model": "V60"
  },
  {
    "Retail Branding": "AV",
    "Marketing Name": "AV10",
    "Device": "RCT6203W46",
    "Model": "AV10"
  },
  {
    "Retail Branding": "AV",
    "Marketing Name": "AV7",
    "Device": "RCT6773W22",
    "Model": "AV7"
  },
  {
    "Retail Branding": "AVA(USA)",
    "Marketing Name": "AVA-RM-RX1-EU",
    "Device": "AVA-RM-RX1",
    "Model": "RX1"
  },
  {
    "Retail Branding": "AVA(USA)",
    "Marketing Name": "AVA-RM-RX2-US",
    "Device": "AVA-RM-RX2-US",
    "Model": "RX2"
  },
  {
    "Retail Branding": "AVACOM",
    "Marketing Name": "AVT015",
    "Device": "AVT015",
    "Model": "AVT015"
  },
  {
    "Retail Branding": "AVACOM",
    "Marketing Name": "AVT016",
    "Device": "AVT016",
    "Model": "AVT016"
  },
  {
    "Retail Branding": "AVACOM",
    "Marketing Name": "AVT016",
    "Device": "AVT016",
    "Model": "Tablet_HQ_T616S"
  },
  {
    "Retail Branding": "AVANGARD",
    "Marketing Name": "R3",
    "Device": "R3",
    "Model": "R3"
  },
  {
    "Retail Branding": "AVANGARD",
    "Marketing Name": "R4",
    "Device": "R4",
    "Model": "R4"
  },
  {
    "Retail Branding": "AVATEL",
    "Marketing Name": "DV8547_Avatel",
    "Device": "DV8547-KSA",
    "Model": "DV8547_Avatel"
  },
  {
    "Retail Branding": "AVH San Luis S.A.",
    "Marketing Name": "ActionKids3.0",
    "Device": "ActionKids3_0",
    "Model": "ActionKids3.0"
  },
  {
    "Retail Branding": "AVH San Luis S.A.",
    "Marketing Name": "Actionkids 3.0",
    "Device": "Action_Kids_3",
    "Model": "Action_Kids_3.0"
  },
  {
    "Retail Branding": "AVH San Luis S.A.",
    "Marketing Name": "Excer 10PRO",
    "Device": "Excer_10_PRO",
    "Model": "Excer_10_PRO"
  },
  {
    "Retail Branding": "AVH San Luis S.A.",
    "Marketing Name": "Excer G10",
    "Device": "Excer_G10",
    "Model": "Excer_G10"
  },
  {
    "Retail Branding": "AVH San Luis S.A.",
    "Marketing Name": "Excer G5.6",
    "Device": "Excer_G5_6",
    "Model": "Excer G5.6"
  },
  {
    "Retail Branding": "AVH San Luis S.A.",
    "Marketing Name": "ExcerG5.6",
    "Device": "ExcerG5_6",
    "Model": "ExcerG5.6"
  },
  {
    "Retail Branding": "AVH San Luis S.A.",
    "Marketing Name": "Excer_P1",
    "Device": "Excer_P1",
    "Model": "Excer_P1"
  },
  {
    "Retail Branding": "AVH San Luis S.A.",
    "Marketing Name": "Excer_T8",
    "Device": "Excer_T8",
    "Model": "Excer_T8"
  },
  {
    "Retail Branding": "AVH San Luis S.A.",
    "Marketing Name": "Vortech3.0",
    "Device": "Vortech3_0",
    "Model": "Vortech3.0"
  },
  {
    "Retail Branding": "AVH San Luis S.A.",
    "Marketing Name": "Vortech_3_0",
    "Device": "Vortech_3_0",
    "Model": "Vortech 3.0"
  },
  {
    "Retail Branding": "AVITA",
    "Marketing Name": "T101",
    "Device": "T101",
    "Model": "T101"
  },
  {
    "Retail Branding": "AVITA",
    "Marketing Name": "TS11A1",
    "Device": "TS11A1",
    "Model": "TS11A1"
  },
  {
    "Retail Branding": "AVOCOR",
    "Marketing Name": "AVT-U_Series",
    "Device": "AVT-U_Series",
    "Model": "AVT-U_Series"
  },
  {
    "Retail Branding": "AVOCOR",
    "Marketing Name": "AVT-V_Series",
    "Device": "AVT-V_Series",
    "Model": "AVT-V_Series"
  },
  {
    "Retail Branding": "AVOCOR",
    "Marketing Name": "A_Series",
    "Device": "A_Series",
    "Model": "A_Series"
  },
  {
    "Retail Branding": "AVOCOR",
    "Marketing Name": "Commercial_Display",
    "Device": "S_Series",
    "Model": "S_Series"
  },
  {
    "Retail Branding": "AVOCOR",
    "Marketing Name": "S_Series",
    "Device": "S_Series",
    "Model": "S_Series"
  },
  {
    "Retail Branding": "AWOW",
    "Marketing Name": "AWOW_CreaPad_1001",
    "Device": "AWOW_CreaPad_1001",
    "Model": "AWOW_CreaPad_1001"
  },
  {
    "Retail Branding": "AWOW",
    "Marketing Name": "AWOW_CreaPad_1003",
    "Device": "AWOW_CreaPad_1003_EEA",
    "Model": "AWOW_CreaPad_1003_EEA"
  },
  {
    "Retail Branding": "AWOW",
    "Marketing Name": "CQA1019_EEA",
    "Device": "CQA1019_EEA",
    "Model": "CQA1019_EEA"
  },
  {
    "Retail Branding": "AWOW",
    "Marketing Name": "CUBTAB_1001",
    "Device": "CUBTAB_1001",
    "Model": "CUBTAB_1001"
  },
  {
    "Retail Branding": "AWOW",
    "Marketing Name": "CreaPad_1002A",
    "Device": "CreaPad_1002A",
    "Model": "CreaPad_1002A"
  },
  {
    "Retail Branding": "AWOW",
    "Marketing Name": "CreaPad_1002A_EEA",
    "Device": "CreaPad_1002A_EEA",
    "Model": "CreaPad_1002A_EEA"
  },
  {
    "Retail Branding": "AWOW",
    "Marketing Name": "CreaPad_1005",
    "Device": "CreaPad_1005",
    "Model": "CreaPad_1005"
  },
  {
    "Retail Branding": "AWOW",
    "Marketing Name": "CreaPad_1005_EEA",
    "Device": "CreaPad_1005_EEA",
    "Model": "CreaPad_1005_EEA"
  },
  {
    "Retail Branding": "AWOW",
    "Marketing Name": "CreaPad_1009",
    "Device": "CreaPad_1009",
    "Model": "CreaPad_1009"
  },
  {
    "Retail Branding": "AWOW",
    "Marketing Name": "CreaPad_1009A",
    "Device": "CreaPad_1009A",
    "Model": "CreaPad_1009A"
  },
  {
    "Retail Branding": "AWOW",
    "Marketing Name": "CreaPad_1009A_EEA",
    "Device": "CreaPad_1009A_EEA",
    "Model": "CreaPad_1009A_EEA"
  },
  {
    "Retail Branding": "AWOW",
    "Marketing Name": "CreaPad_1009S",
    "Device": "CreaPad_1009S",
    "Model": "CreaPad_1009S"
  },
  {
    "Retail Branding": "AWOW",
    "Marketing Name": "CreaPad_1009S_EEA",
    "Device": "CreaPad_1009S_EEA",
    "Model": "CreaPad_1009S_EEA"
  },
  {
    "Retail Branding": "AWOW",
    "Marketing Name": "CreaPad_1009_EEA",
    "Device": "CreaPad_1009_EEA",
    "Model": "CreaPad_1009_EEA"
  },
  {
    "Retail Branding": "AWOW",
    "Marketing Name": "Funtab_1001",
    "Device": "Funtab_1001",
    "Model": "Funtab_1001"
  },
  {
    "Retail Branding": "AWOW",
    "Marketing Name": "Funtab_1001_EEA",
    "Device": "Funtab_1001_EEA",
    "Model": "Funtab_1001_EEA"
  },
  {
    "Retail Branding": "AWOW",
    "Marketing Name": "Funtab_1002_EEA",
    "Device": "Funtab_1002_EEA",
    "Model": "Funtab_1002_EEA"
  },
  {
    "Retail Branding": "AWOW",
    "Marketing Name": "Funtab_1003_EEA",
    "Device": "Funtab_1003_EEA",
    "Model": "Funtab_1003_EEA"
  },
  {
    "Retail Branding": "AWOW",
    "Marketing Name": "Funtab_1003_US",
    "Device": "Funtab_1003_US",
    "Model": "Funtab_1003_US"
  },
  {
    "Retail Branding": "AWOW",
    "Marketing Name": "Funtab_1005_EEA",
    "Device": "Funtab_1005_EEA",
    "Model": "Funtab_1005_EEA"
  },
  {
    "Retail Branding": "AWOW",
    "Marketing Name": "Funtab_1005_US",
    "Device": "Funtab_1005_US",
    "Model": "Funtab_1005_US"
  },
  {
    "Retail Branding": "AWOW",
    "Marketing Name": "Funtab_801_I",
    "Device": "Funtab_801_I",
    "Model": "Funtab_801_I"
  },
  {
    "Retail Branding": "AWOW",
    "Marketing Name": "Funtab_801_K",
    "Device": "Funtab_801_K",
    "Model": "Funtab_801_K"
  },
  {
    "Retail Branding": "AWOW",
    "Marketing Name": "Funtab_801_K",
    "Device": "Funtab_801_K_EEA",
    "Model": "Funtab_801_K_EEA"
  },
  {
    "Retail Branding": "AWOW",
    "Marketing Name": "Futab_801_I",
    "Device": "Funtab_801_I_EEA",
    "Model": "Funtab_801_I_EEA"
  },
  {
    "Retail Branding": "AWOW",
    "Marketing Name": "MID-789A100-EEA",
    "Device": "MID_789A100_EEA",
    "Model": "MID-789A100-EEA"
  },
  {
    "Retail Branding": "AWOW",
    "Marketing Name": "MID_1085_EEA",
    "Device": "MID_1085_EEA",
    "Model": "MID_1085_EEA"
  },
  {
    "Retail Branding": "AWOW",
    "Marketing Name": "MID_1089IPS_EEA",
    "Device": "MID_1089IPS_EEA",
    "Model": "MID_1089IPS_EEA"
  },
  {
    "Retail Branding": "AWOW",
    "Marketing Name": "P11_EEA",
    "Device": "P11_EEA",
    "Model": "P11_EEA"
  },
  {
    "Retail Branding": "AWOW",
    "Marketing Name": "P12_EEA",
    "Device": "P12_EEA",
    "Model": "P12_EEA"
  },
  {
    "Retail Branding": "AWOW",
    "Marketing Name": "P12_US",
    "Device": "P12_US",
    "Model": "P12_US"
  },
  {
    "Retail Branding": "AWOW",
    "Marketing Name": "UTBook",
    "Device": "UTBook",
    "Model": "UTBook"
  },
  {
    "Retail Branding": "AWOW",
    "Marketing Name": "UTBook_14",
    "Device": "UTBook_14",
    "Model": "UTBook_14"
  },
  {
    "Retail Branding": "AWOW",
    "Marketing Name": "UTBook_15",
    "Device": "UTBook_15",
    "Model": "UTBook_15"
  },
  {
    "Retail Branding": "AWOW",
    "Marketing Name": "UTBook_15_EEA",
    "Device": "UTBook_15_EEA",
    "Model": "UTBook_15_EEA"
  },
  {
    "Retail Branding": "AWOW",
    "Marketing Name": "UTBook_16_EEA",
    "Device": "UTBook_16",
    "Model": "UTBook_16"
  },
  {
    "Retail Branding": "AWOW",
    "Marketing Name": "UTBook_16_US",
    "Device": "UTBook_16",
    "Model": "UTBook_16"
  },
  {
    "Retail Branding": "AWOW",
    "Marketing Name": "UTBook_EEA",
    "Device": "UTBook_EEA",
    "Model": "UTBook_EEA"
  },
  {
    "Retail Branding": "AX-META",
    "Marketing Name": "AX_META_Tab_7",
    "Device": "AX_META_Tab_7",
    "Model": "AX_META_Tab_7"
  },
  {
    "Retail Branding": "AXEL",
    "Marketing Name": "AX_PRO",
    "Device": "AX_PRO",
    "Model": "AX_PRO"
  },
  {
    "Retail Branding": "AXION",
    "Marketing Name": "Axion_6507M",
    "Device": "Axion_6507M",
    "Model": "Axion_6507M"
  },
  {
    "Retail Branding": "AXION",
    "Marketing Name": "SBAA1011",
    "Device": "SBAA1011",
    "Model": "SBAA1011"
  },
  {
    "Retail Branding": "AXON",
    "Marketing Name": "Axon Radiance 1",
    "Device": "Axon_Radiance_1",
    "Model": "Axon Radiance 1"
  },
  {
    "Retail Branding": "AXON",
    "Marketing Name": "Evolution",
    "Device": "Evolution",
    "Model": "Evolution"
  },
  {
    "Retail Branding": "AXPRO",
    "Marketing Name": "AX09",
    "Device": "AX09",
    "Model": "AX09"
  },
  {
    "Retail Branding": "AXSTV",
    "Marketing Name": "AXSTV130",
    "Device": "SEI130PTS",
    "Model": "AXSTV130"
  },
  {
    "Retail Branding": "AXSTV",
    "Marketing Name": "AXSTV530",
    "Device": "SEI530PTS",
    "Model": "AXSTV530"
  },
  {
    "Retail Branding": "AXXA",
    "Marketing Name": "AXXA S45",
    "Device": "AXXA_S45",
    "Model": "AXXA_S45"
  },
  {
    "Retail Branding": "AXXA",
    "Marketing Name": "AXXA S71",
    "Device": "AXXA_S71",
    "Model": "AXXA S71"
  },
  {
    "Retail Branding": "AXXA",
    "Marketing Name": "AXXA_S45_PLUS",
    "Device": "AXXA_S45_PLUS",
    "Model": "AXXA_S45_PLUS"
  },
  {
    "Retail Branding": "AXXA",
    "Marketing Name": "PRO",
    "Device": "PRO",
    "Model": "PRO"
  },
  {
    "Retail Branding": "AYYA",
    "Marketing Name": "Ayat101",
    "Device": "Ayat101",
    "Model": "Ayat101"
  },
  {
    "Retail Branding": "AYYA",
    "Marketing Name": "T1",
    "Device": "T1",
    "Model": "AYYA T1"
  },
  {
    "Retail Branding": "AZBox",
    "Marketing Name": "AZDroid",
    "Device": "AZDroid",
    "Model": "AZDroid"
  },
  {
    "Retail Branding": "AZOM TECH",
    "Marketing Name": "Desert2",
    "Device": "Desert2",
    "Model": "Desert2"
  },
  {
    "Retail Branding": "AZOM TECH",
    "Marketing Name": "River1",
    "Device": "River1",
    "Model": "AZOM River 1"
  },
  {
    "Retail Branding": "AZPEN",
    "Marketing Name": "A1046G",
    "Device": "A1046G",
    "Model": "A1046G"
  },
  {
    "Retail Branding": "AZPEN",
    "Marketing Name": "A1052",
    "Device": "A1052",
    "Model": "A1052"
  },
  {
    "Retail Branding": "AZPEN",
    "Marketing Name": "A1080",
    "Device": "mid1032_mk_32",
    "Model": "A1080"
  },
  {
    "Retail Branding": "AZPEN",
    "Marketing Name": "A1080G",
    "Device": "A1080G",
    "Model": "A1080G"
  },
  {
    "Retail Branding": "AZPEN",
    "Marketing Name": "A1083",
    "Device": "A1083",
    "Model": "A1083"
  },
  {
    "Retail Branding": "AZPEN",
    "Marketing Name": "A720",
    "Device": "wing-inet",
    "Model": "A720"
  },
  {
    "Retail Branding": "AZPEN",
    "Marketing Name": "A780",
    "Device": "A780",
    "Model": "A780"
  },
  {
    "Retail Branding": "AZPEN",
    "Marketing Name": "A780B",
    "Device": "A780B",
    "Model": "A780B"
  },
  {
    "Retail Branding": "AZPEN",
    "Marketing Name": "A780G",
    "Device": "A780G",
    "Model": "A780G"
  },
  {
    "Retail Branding": "AZPEN",
    "Marketing Name": "A780G1",
    "Device": "A780G1",
    "Model": "A780G"
  },
  {
    "Retail Branding": "AZPEN",
    "Marketing Name": "A780G1",
    "Device": "A780G1",
    "Model": "A780G1"
  },
  {
    "Retail Branding": "AZPEN",
    "Marketing Name": "A920",
    "Device": "wing-ibt",
    "Model": "A920"
  },
  {
    "Retail Branding": "AZPEN",
    "Marketing Name": "C-603",
    "Device": "C-603",
    "Model": "C-603"
  },
  {
    "Retail Branding": "AZPEN",
    "Marketing Name": "G680",
    "Device": "Blaze_8",
    "Model": "G680"
  },
  {
    "Retail Branding": "AZPEN",
    "Marketing Name": "G800",
    "Device": "G800",
    "Model": "G800"
  },
  {
    "Retail Branding": "AZPEN",
    "Marketing Name": "K749",
    "Device": "K749",
    "Model": "K749"
  },
  {
    "Retail Branding": "AZPEN",
    "Marketing Name": "K749B",
    "Device": "K749B",
    "Model": "K749B"
  },
  {
    "Retail Branding": "AZPEN",
    "Marketing Name": "K750",
    "Device": "K750",
    "Model": "K750"
  },
  {
    "Retail Branding": "AZZA",
    "Marketing Name": "XXW82B",
    "Device": "XXW82B",
    "Model": "XXW82B"
  },
  {
    "Retail Branding": "Aamra WE",
    "Marketing Name": "A10",
    "Device": "A10",
    "Model": "WE A10"
  },
  {
    "Retail Branding": "Aamra WE",
    "Marketing Name": "A50",
    "Device": "A50",
    "Model": "WE A50"
  },
  {
    "Retail Branding": "Aamra WE",
    "Marketing Name": "E2",
    "Device": "E2",
    "Model": "WE E2"
  },
  {
    "Retail Branding": "Aaztec",
    "Marketing Name": "THAZ-65/75/86/98/110 PD",
    "Device": "mensa_an64",
    "Model": "Aaztec-IFP-Series"
  },
  {
    "Retail Branding": "Abans",
    "Marketing Name": "65E-L3576C-E7",
    "Device": "65E-L3576C-E7",
    "Model": "Abans"
  },
  {
    "Retail Branding": "Abocom",
    "Marketing Name": "A08SM",
    "Device": "A08",
    "Model": "A08S"
  },
  {
    "Retail Branding": "Aborder",
    "Marketing Name": "Tanzania",
    "Device": "guandu",
    "Model": "Aborder 4K Android TV"
  },
  {
    "Retail Branding": "Aborder",
    "Marketing Name": "Tanzania",
    "Device": "martin",
    "Model": "Aborder 2K Android TV"
  },
  {
    "Retail Branding": "Accent",
    "Marketing Name": "Accent Camelon C5",
    "Device": "CAMELEON_C5",
    "Model": "CAMELEON_C5"
  },
  {
    "Retail Branding": "Accent",
    "Marketing Name": "Accent Camelon C6",
    "Device": "CAMELEON_C6",
    "Model": "CAMELEON_C6"
  },
  {
    "Retail Branding": "Accent",
    "Marketing Name": "Accent Camelon C6 Plus",
    "Device": "CAMELEON_C6_PLUS",
    "Model": "CAMELEON_C6_PLUS"
  },
  {
    "Retail Branding": "Accent",
    "Marketing Name": "C5",
    "Device": "C5",
    "Model": "C5"
  },
  {
    "Retail Branding": "Accent",
    "Marketing Name": "C5L PLUS",
    "Device": "C5_PLUS",
    "Model": "C5 PLUS"
  },
  {
    "Retail Branding": "Accent",
    "Marketing Name": "CAMELEON C5",
    "Device": "CAMELEON_C5",
    "Model": "CAMELEON C5"
  },
  {
    "Retail Branding": "Accent",
    "Marketing Name": "FAST10",
    "Device": "FAST10",
    "Model": "FAST10"
  },
  {
    "Retail Branding": "Accent",
    "Marketing Name": "FAST7",
    "Device": "FAST7",
    "Model": "FAST7"
  },
  {
    "Retail Branding": "Accent",
    "Marketing Name": "FAST7 3G",
    "Device": "FAST7_3G",
    "Model": "FAST7 3G"
  },
  {
    "Retail Branding": "Accent",
    "Marketing Name": "FAST73G",
    "Device": "FAST73G",
    "Model": "FAST73G"
  },
  {
    "Retail Branding": "Accent",
    "Marketing Name": "FAST_10",
    "Device": "FAST_10",
    "Model": "FAST_10"
  },
  {
    "Retail Branding": "Accent",
    "Marketing Name": "Fast10",
    "Device": "Fast10",
    "Model": "Fast10"
  },
  {
    "Retail Branding": "Accent",
    "Marketing Name": "Fast17",
    "Device": "Fast17",
    "Model": "Fast17"
  },
  {
    "Retail Branding": "Accent",
    "Marketing Name": "Fasts7",
    "Device": "Fasts7",
    "Model": "Fasts7"
  },
  {
    "Retail Branding": "Accent",
    "Marketing Name": "KIDZY70",
    "Device": "KIDZY70",
    "Model": "KIDZY70"
  },
  {
    "Retail Branding": "Accent",
    "Marketing Name": "PEARL A4 Lite",
    "Device": "PEARL_A4_Lite",
    "Model": "PEARL A4 Lite"
  },
  {
    "Retail Branding": "Accent",
    "Marketing Name": "PEARL A6",
    "Device": "PEARL_A6",
    "Model": "PEARL A6"
  },
  {
    "Retail Branding": "Accent",
    "Marketing Name": "Pearl A4 PLUS",
    "Device": "PEARL_A4_PLUS",
    "Model": "PEARL A4 PLUS"
  },
  {
    "Retail Branding": "Accent",
    "Marketing Name": "Pearl A6",
    "Device": "Pearl_A6",
    "Model": "Pearl A6"
  },
  {
    "Retail Branding": "Accent",
    "Marketing Name": "Pearl_A4",
    "Device": "Pearl_A4",
    "Model": "Pearl A4"
  },
  {
    "Retail Branding": "Accent",
    "Marketing Name": "SPEED S8",
    "Device": "SPEED_S8",
    "Model": "SPEED_S8"
  },
  {
    "Retail Branding": "Accent",
    "Marketing Name": "TANK_P55",
    "Device": "TANK_P55",
    "Model": "TANK_P55"
  },
  {
    "Retail Branding": "Accent",
    "Marketing Name": "fast-10",
    "Device": "fast-10",
    "Model": "Fast10"
  },
  {
    "Retail Branding": "Accent",
    "Marketing Name": "fast-10",
    "Device": "fast-10",
    "Model": "fast-10"
  },
  {
    "Retail Branding": "Access",
    "Marketing Name": "fm502",
    "Device": "fm502",
    "Model": "fm502"
  },
  {
    "Retail Branding": "Acegame S.A.",
    "Marketing Name": "NEONHD/NEONGo",
    "Device": "NEON",
    "Model": "NEONHD/NEONGo"
  },
  {
    "Retail Branding": "Acegame S.A.",
    "Marketing Name": "One_Mundial",
    "Device": "One_Mundial",
    "Model": "One_Mundial"
  },
  {
    "Retail Branding": "Acegame S.A.",
    "Marketing Name": "PROTON_JADE_2_PRO",
    "Device": "PROTON_JADE_2_PRO",
    "Model": "PROTON_JADE_2_PRO"
  },
  {
    "Retail Branding": "Acegame S.A.",
    "Marketing Name": "SAPPHIRE_HDLT",
    "Device": "SAPPHIRE_HDLT",
    "Model": "SAPPHIRE_HDLT"
  },
  {
    "Retail Branding": "Acegame S.A.",
    "Marketing Name": "TitaniumColors",
    "Device": "TitaniumColors",
    "Model": "TitaniumColors"
  },
  {
    "Retail Branding": "Acegame S.A.",
    "Marketing Name": "TitaniumHD",
    "Device": "TitaniumHD",
    "Model": "TitaniumHD"
  },
  {
    "Retail Branding": "Acepad",
    "Marketing Name": "A121",
    "Device": "A121",
    "Model": "A121"
  },
  {
    "Retail Branding": "Acepad",
    "Marketing Name": "A130",
    "Device": "A130",
    "Model": "A130"
  },
  {
    "Retail Branding": "Acepad",
    "Marketing Name": "A130-2023",
    "Device": "A130-2023",
    "Model": "A130-2023"
  },
  {
    "Retail Branding": "Acepad",
    "Marketing Name": "A131",
    "Device": "A131",
    "Model": "A131"
  },
  {
    "Retail Branding": "Acepad",
    "Marketing Name": "A131_14",
    "Device": "A131_14",
    "Model": "A131_14"
  },
  {
    "Retail Branding": "Acepad",
    "Marketing Name": "A140",
    "Device": "A140",
    "Model": "A140"
  },
  {
    "Retail Branding": "Acepad",
    "Marketing Name": "A145",
    "Device": "A145",
    "Model": "A145"
  },
  {
    "Retail Branding": "Acepad",
    "Marketing Name": "A150",
    "Device": "A150",
    "Model": "A150"
  },
  {
    "Retail Branding": "Acepad",
    "Marketing Name": "A150_14",
    "Device": "A150_14",
    "Model": "A150_14"
  },
  {
    "Retail Branding": "Acepad",
    "Marketing Name": "A151",
    "Device": "A151",
    "Model": "A151"
  },
  {
    "Retail Branding": "Acepad",
    "Marketing Name": "A170",
    "Device": "A170",
    "Model": "A170"
  },
  {
    "Retail Branding": "Acepad",
    "Marketing Name": "A171_14",
    "Device": "A171_14",
    "Model": "A171"
  },
  {
    "Retail Branding": "Acepad",
    "Marketing Name": "A171_14",
    "Device": "A171_14",
    "Model": "A171_14"
  },
  {
    "Retail Branding": "Acepad",
    "Marketing Name": "AX1",
    "Device": "AX1",
    "Model": "AX1"
  },
  {
    "Retail Branding": "Acepad",
    "Marketing Name": "Acepad ABLE",
    "Device": "Acepad_ABLE_EEA",
    "Model": "Acepad ABLE"
  },
  {
    "Retail Branding": "Acepad",
    "Marketing Name": "Acepad_HIGH_EEA",
    "Device": "Acepad_HIGH_EEA",
    "Model": "Acepad HIGH"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "",
    "Device": "C6",
    "Model": "Acer E320"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "",
    "Device": "C6",
    "Model": "Acer E320-orange"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "",
    "Device": "C7",
    "Model": "E330"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "",
    "Device": "C8n",
    "Model": "E350"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "",
    "Device": "K3",
    "Model": "E130"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "",
    "Device": "T2",
    "Model": "AT390"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "",
    "Device": "T603T",
    "Model": "TD600"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "",
    "Device": "a3",
    "Model": "Stream"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "",
    "Device": "a5",
    "Model": "S300"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "",
    "Device": "c4",
    "Model": "E310"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "",
    "Device": "k4",
    "Model": "E140"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "",
    "Device": "k5",
    "Model": "E210"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "A1-713",
    "Device": "acer_aprilia",
    "Model": "A1-713"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "A1-734",
    "Device": "acer_barricade",
    "Model": "A1-734"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "A1-810",
    "Device": "mango",
    "Model": "A1-810"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "A1-811",
    "Device": "mango",
    "Model": "A1-811"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "A1-830",
    "Device": "ducati",
    "Model": "A1-830"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "A100",
    "Device": "vangogh",
    "Model": "A100"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "A101",
    "Device": "vangogh",
    "Model": "A101"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "A10M1",
    "Device": "acer_A10M1",
    "Model": "A10-21"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "A10M1",
    "Device": "acer_A10M1",
    "Model": "A10-21_CUS1"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "A10M1",
    "Device": "acer_A10M1",
    "Model": "A10-21_EEA"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "A10M2",
    "Device": "acer_A10M2",
    "Model": "A10-31M"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "A10M2",
    "Device": "generic_arm64",
    "Model": "GSI on ARM64"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "A10M2N",
    "Device": "acer_A10M2N",
    "Model": "A10-31MN"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "A10P2",
    "Device": "A10P2",
    "Model": "A10-31P"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "A10P2",
    "Device": "acer_A10P2",
    "Model": "A10-31P_EEA"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "A110",
    "Device": "a110",
    "Model": "A110"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "A11M1",
    "Device": "acer_A11M1",
    "Model": "A11-11"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "A11M1",
    "Device": "acer_A11M1",
    "Model": "A11-11_EEA"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "A11M2",
    "Device": "acer_A11M2",
    "Model": "A11-21M"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "A11M2",
    "Device": "acer_A11M2",
    "Model": "A11-21M_EEA"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "A11M2N",
    "Device": "acer_A11-21MN",
    "Model": "A11-21MN"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "A11P2",
    "Device": "acer_A11P2",
    "Model": "A11-21P"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "A11P2",
    "Device": "acer_A11P2",
    "Model": "A11-21P_EEA"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "A12M1N",
    "Device": "acer_A12M1N",
    "Model": "A12-11MN"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "A12P2",
    "Device": "acer_A12P2",
    "Model": "A12-21P"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "A12P2",
    "Device": "acer_A12P2",
    "Model": "A12-21P_EEA"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "A13P2",
    "Device": "acer_A13P2",
    "Model": "A13-21P"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "A13P2",
    "Device": "acer_A13P2",
    "Model": "A13-21P_EEA"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "A14M1N",
    "Device": "acer_A14M1N",
    "Model": "A14-11MN_EEA"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "A14M1N​",
    "Device": "acer_A14M1N",
    "Model": "A14-11MN"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "A16M1N",
    "Device": "acer_A16M1N",
    "Model": "A16-11MN_EEA"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "A16M1N​",
    "Device": "acer_A16M1N",
    "Model": "A16-11MN"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "A3-A10",
    "Device": "zara",
    "Model": "A3-A10"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "A3-A11",
    "Device": "zara",
    "Model": "A3-A11"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "A3-A20",
    "Device": "acer_harley",
    "Model": "A3-A20"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "A3-A20FHD",
    "Device": "acer_harleyfhd",
    "Model": "A3-A20FHD"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "A3-A30",
    "Device": "omega",
    "Model": "A3-A30"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "A3-A40",
    "Device": "acer_jetfirefhd",
    "Model": "A3-A40"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "A5PLUS",
    "Device": "A5PLUS",
    "Model": "A5 PLUS"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "A8M1",
    "Device": "acer_A8M1",
    "Model": "A8-11"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "A8M1",
    "Device": "acer_A8M1",
    "Model": "A8-11_EEA"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "A8M2",
    "Device": "acer_A8M2",
    "Model": "A8-21M"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "A8M2",
    "Device": "acer_A8M2",
    "Model": "A8-21M_EEA"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "A8P2",
    "Device": "acer_A8P2",
    "Model": "A8-21P"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "A8P2",
    "Device": "acer_A8P2",
    "Model": "A8-21P_EEA"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "AC50_VZ",
    "Device": "AC50",
    "Model": "AC50"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "ACER ALTOS EZBA",
    "Device": "AKMEI14",
    "Model": "ACER_ALTOS_EZBA"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "ACER TAB V9-22",
    "Device": "ATV9-22",
    "Model": "ACER TAB V9-22"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "ACER_A6",
    "Device": "ACER_A6",
    "Model": "A6"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "ACER_A62_ULTRA_V25",
    "Device": "ACER_A62_ULTRA_V25",
    "Model": "A62 ULTRA V25"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "ACER_AC50_V25",
    "Device": "ACER_AC50_V25",
    "Model": "AC50 V25"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "ACER_ALTOS_EZB",
    "Device": "AKMEI14",
    "Model": "ACER_ALTOS_EZB"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "ACER_AQ6",
    "Device": "ACER_AQ6",
    "Model": "AQ6"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "ACER_AQ6_EU",
    "Device": "ACER_AQ6_EU",
    "Model": "AQ6"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "ACER_AQ9PRO",
    "Device": "ACER_AQ9PRO",
    "Model": "AQ9PRO"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "ACER_C1_EEA",
    "Device": "ACER_C1",
    "Model": "C1"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "ACTAB1021_A",
    "Device": "ACTAB1021_A",
    "Model": "ACTAB1021_A"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "ACTAB1022",
    "Device": "ACTAB1022",
    "Model": "ACTAB1022"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "ACTAB1024",
    "Device": "ACTAB1024",
    "Model": "ACTAB1024"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "ACTAB1025",
    "Device": "ACTAB1025",
    "Model": "ACTAB1025"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "ACTAB10KB23",
    "Device": "ACTAB10KB23",
    "Model": "ACTAB10KB23"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "ACTAB10KB24",
    "Device": "ACTAB10KB24",
    "Model": "ACTAB10KB24"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "ACTAB1123",
    "Device": "ACTAB1123",
    "Model": "ACTAB1123"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "ACTAB1422",
    "Device": "ACTAB1422",
    "Model": "ACTAB1422"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "ACTAB721",
    "Device": "ACTAB721",
    "Model": "ACTAB721"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "ACTAB723",
    "Device": "ACTAB723",
    "Model": "ACTAB723"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "ACTAB821_A",
    "Device": "ACTAB821_A",
    "Model": "ACTAB821_A"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "ACTABKID",
    "Device": "ACTABKID",
    "Model": "ACTABKID"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "ACTABKID2",
    "Device": "ACTABKID2",
    "Model": "ACTABKID2"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "AK330s",
    "Device": "C8n",
    "Model": "AK330S"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "ARSP25MTA14A1",
    "Device": "ARSP25MTA14A1",
    "Model": "ARSP25MTA14A1"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "AS10L",
    "Device": "AS10L",
    "Model": "AS10L"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "AS10W",
    "Device": "AS10W",
    "Model": "AS10W"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "AS10WF",
    "Device": "AS10WF",
    "Model": "AS10WF"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "AS8W",
    "Device": "AS8W",
    "Model": "AS8W"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "ATAB1021E",
    "Device": "ATAB1021E",
    "Model": "ATAB1021E"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "ATAB1024E",
    "Device": "ATAB1024E",
    "Model": "ATAB1024E"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "ATAB10KB24E",
    "Device": "ATAB10KB24E",
    "Model": "ATAB10KB24E"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "ATAB1123E",
    "Device": "ATAB1123E",
    "Model": "ATAB1123E"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "ATAB1422E",
    "Device": "ATAB1422E",
    "Model": "ATAB1422E"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "ATAB721E",
    "Device": "ATAB721E",
    "Model": "ATAB721E"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "ATAB723E",
    "Device": "ATAB723E",
    "Model": "ATAB723E"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "ATAB821E",
    "Device": "ATAB821E",
    "Model": "ATAB821E"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "ATABKD1024K",
    "Device": "ATABKD1024K",
    "Model": "ATABKD1024K"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "ATL1021EA",
    "Device": "ATL1021EA",
    "Model": "ATL1021EA"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "ATLTE1022",
    "Device": "ATLTE1022",
    "Model": "ATLTE1022"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "ATLTE1022E",
    "Device": "ATLTE1022E",
    "Model": "ATLTE1022E"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "Acer",
    "Device": "anglelake",
    "Model": "DIX41RKF"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "Acer",
    "Device": "chester",
    "Model": "ACR4KR75P"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "Acer",
    "Device": "waiawa",
    "Model": "DIX51R4KU"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "Acer Acerpure",
    "Device": "Acerone_Liquid",
    "Model": "Acerone Liquid S272E4"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "Acer Chromebook 11 (C740)",
    "Device": "paine_cheets",
    "Model": "Acer Chromebook 11 (C740)"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "Acer Chromebook R13",
    "Device": "elm_cheets",
    "Model": "Acer Chromebook R13 (CB5-312T)"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "Acer Holo360",
    "Device": "acer_c01",
    "Model": "C01"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "Acer Iconia T10-21M",
    "Device": "Acer_Iconia_T10-21M",
    "Model": "Acer_Iconia_T10-21M"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "Acer Iconia Tab iM10-22",
    "Device": "AITiM10-22",
    "Model": "Acer Iconia Tab iM10-22"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "Acer Iconia Tab iM11-12M",
    "Device": "iM11-12M",
    "Model": "Acer Iconia Tab iM11-12M"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "Acer Iconia Tab iM9-12M",
    "Device": "AITiM9-12M",
    "Model": "Acer lconia Tab iM9-12M"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "Acer Iconia iM11-22M5G",
    "Device": "iM11-22M5G",
    "Model": "Acer Iconia iM11-22M5G"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "Acer One 10 T4-129L",
    "Device": "AcerO10T4129L",
    "Model": "Acer One 10 T4-129L"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "Acer One 10 T4-129L",
    "Device": "AcerOne10T4129LIx",
    "Model": "Acer One 10 T4-129LIx"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "Acer One 10 T4-129LI",
    "Device": "AcerO10T412LI",
    "Model": "Acer One 10 T4-129LI"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "Acer One 10 T8-129L",
    "Device": "Acer_One_10_T8-129L",
    "Model": "Acer_One_10_T8-129L"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "Acer One 7",
    "Device": "Acer_One_7_4G",
    "Model": "Acer One 7 4G"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "Acer One 7 4G",
    "Device": "Acer_One_7_4G",
    "Model": "Acer One 7 4G"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "Acer One 8 T4-82L",
    "Device": "AcerOne8T4-82L",
    "Model": "Acer One 8 T4-82L"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "Acer One 8 T4-82L",
    "Device": "AcerOne8T4-82Lxi",
    "Model": "Acer One 8 T4-82L"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "Acer One 8 T4-82L",
    "Device": "AcerOne8T482L",
    "Model": "Acer One 8 T4-82L"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "Acer One 8 T4-82L-G2",
    "Device": "AcerOne8T4-82L-G2",
    "Model": "AcerOne8T4-82L-G2"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "Acer One 8 T9-422L",
    "Device": "AcerOne8T9-422L",
    "Model": "Acer One 8 T9-422L"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "Acer One T10-22L",
    "Device": "AOT10-22L",
    "Model": "Acer One T10-22L"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "Acer One T11-22L",
    "Device": "AOT11-22L",
    "Model": "Acer One T11-22L"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "Acer One T11-22L-5G",
    "Device": "T11-22L-5G",
    "Model": "Acer One T11-22L-5G"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "Acer education whiteboard",
    "Device": "DT3K_F",
    "Model": "DT3K_F"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "Acer_A6",
    "Device": "Acer_A6",
    "Model": "A6"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "Acer_A60",
    "Device": "Acer_A60",
    "Model": "A60"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "Acer_A60L",
    "Device": "Acer_A60L",
    "Model": "A60L"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "Acer_A61L",
    "Device": "Acer_A61L",
    "Model": "A61L"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "Acer_A61LX",
    "Device": "Acer_A61LX",
    "Model": "A61LX"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "Acer_A62_LITE",
    "Device": "Acer_A62LX",
    "Model": "A62 LITE"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "Acer_A62_LITE_GT",
    "Device": "Acer_A62LX",
    "Model": "A62 LITE"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "Acer_A62_LX_GT",
    "Device": "Acer_A62LX",
    "Model": "A62LX"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "Acer_A62_ULTRA",
    "Device": "Acer_A62LX",
    "Model": "A62 ULTRA"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "Acer_A62_ULTRA_RD",
    "Device": "Acer_A62LX",
    "Model": "A62 ULTRA"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "Acer_AC50",
    "Device": "Acer_AC50",
    "Model": "AC50"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "Acer_AC50_GT",
    "Device": "Acer_AC50",
    "Model": "AC50"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "Acer_AC50_RD",
    "Device": "Acer_AC50",
    "Model": "AC50"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "Acer_AC81",
    "Device": "Acer_AC81",
    "Model": "AC81"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "Acer_AC92",
    "Device": "Acer_AC92",
    "Model": "AC92"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "Acer_AC92_RD",
    "Device": "Acer_AC92",
    "Model": "AC92"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "Acer_AQ9_EU",
    "Device": "Acer_AQ9_EU",
    "Model": "AQ9"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "Acer_AX61",
    "Device": "Acer_AX61",
    "Model": "AX61"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "Acer_AX64",
    "Device": "Acer_AX64",
    "Model": "AX64"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "Acer_AX85",
    "Device": "Acer_AX85",
    "Model": "AX85"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "Acer_C2_EUR",
    "Device": "Acer_C2_EUR",
    "Model": "C2"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "Acer_C3_EUR",
    "Device": "Acer_C3_EUR",
    "Model": "C3"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "Acer_One_10_T9-1212L",
    "Device": "Acer_One_10_T9-1212L",
    "Model": "Acer_One_10_T9-1212L"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "Acer_education_whiteboard",
    "Device": "DT3K_F",
    "Model": "DT3K_F"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "Acer_one_8_T2",
    "Device": "Acer_one_8_T2",
    "Model": "Acer_one_8_T2"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "Acerpure",
    "Device": "anglelake",
    "Model": "DAC41F"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "Android TV",
    "Device": "R1",
    "Model": "ATV R1"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "Android TV",
    "Device": "R2",
    "Model": "ATV R2"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "Aspire A3",
    "Device": "aa3-600",
    "Model": "AA3-600"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "B1-710",
    "Device": "B1-710",
    "Model": "B1-710"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "B1-711",
    "Device": "B1-711",
    "Model": "B1-711"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "B1-720",
    "Device": "b1-720",
    "Model": "b1-720"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "B1-721",
    "Device": "b1-721",
    "Model": "b1-721"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "B1-723",
    "Device": "oban",
    "Model": "B1-723"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "B1-730",
    "Device": "vespatn",
    "Model": "B1-730"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "B1-730HD",
    "Device": "vespa",
    "Model": "B1-730HD"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "B1-733",
    "Device": "acer_barricade_3G",
    "Model": "B1-733"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "B1-780",
    "Device": "acer_barricadewifi",
    "Model": "B1-780"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "B1-790",
    "Device": "acer_barricadewifi",
    "Model": "B1-790"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "B1-820",
    "Device": "citizen",
    "Model": "B1-820"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "B1-850",
    "Device": "Frenzy",
    "Model": "B1-850"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "B1-A71",
    "Device": "B1-A71",
    "Model": "B1-A71"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "B3-A30",
    "Device": "acer_jetfirehd",
    "Model": "B3-A30"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "B3-A32",
    "Device": "acer_jetfirelte",
    "Model": "B3-A32"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "B3-A40",
    "Device": "acer_asgard",
    "Model": "B3-A40"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "B3-A40FHD",
    "Device": "acer_asgardfhd",
    "Model": "B3-A40FHD"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "Battlezone",
    "Device": "Battlezone",
    "Model": "M10-11"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "Battlezone LTE",
    "Device": "Battlezone_LTE",
    "Model": "M10-12"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "Battlezone LTE",
    "Device": "Battlezone_LTE",
    "Model": "M10-12_EEA"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "Baymax",
    "Device": "Baymax",
    "Model": "EUT110-11A"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "C01",
    "Device": "acer_c01",
    "Model": "C01"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "C01 (PA)",
    "Device": "acer_c01",
    "Model": "C01"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "C1_EEA",
    "Device": "ACER_C1",
    "Model": "C1"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "CW01",
    "Device": "acer_cw01",
    "Model": "CW01"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "Chromebook 14 for work",
    "Device": "lars_cheets",
    "Model": "Acer Chromebook 14 for Work (CP5-471)"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "Chromebook 14 for work",
    "Device": "lars_cheets",
    "Model": "Chromebook 14 for work (CP5-471)"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "Chromebook 15 (CB3-532)",
    "Device": "banon_cheets",
    "Model": "Acer Chromebook 15 (CB3-532)"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "Chromebook 15 (CB5-571)",
    "Device": "yuna_cheets",
    "Model": "Acer Chromebook 15 (C910 / CB5-571)"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "Chromebook 15 (CB5-571)",
    "Device": "yuna_cheets",
    "Model": "Acer Chromebook 15 (CB5-571)"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "Chromebook 15 (CB5-571)",
    "Device": "yuna_cheets",
    "Model": "Acer Chromebook 15 (CB5-571, C910)"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "Chromebook 15 CB515-1HT/1H",
    "Device": "sand_cheets",
    "Model": "Acer Chromebook 15 (CB515-1H, CB515-1HT)"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "Chromebook 15 CB515-1HT/1H",
    "Device": "sand_cheets",
    "Model": "Chromebook 15 (CB515 - 1HT / 1H)"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "Chromebook 15 CB515-1HT/1H",
    "Device": "sand_cheets",
    "Model": "Chromebook 15 CB515-1HT/1H"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "Chromebook 15 CB515-1HT/1H",
    "Device": "sand_cheets",
    "Model": "sand"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "Chromebook R11 (C738T)",
    "Device": "",
    "Model": ""
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "Chromebook R11 (C738T)",
    "Device": "cyan_cheets",
    "Model": "Acer Chromebook R11"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "Chromebook R11 (C738T)",
    "Device": "cyan_cheets",
    "Model": "Acer Chromebook R11 (CB5-132T / C738T / CB3-132)"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "Chromebook R11 (C738T)",
    "Device": "cyan_cheets",
    "Model": "Acer Chromebook R11 (CB5-132T / C738T)"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "Chromebook R11 (C738T)",
    "Device": "cyan_cheets",
    "Model": "Acer Chromebook R11 (CB5-132T, C738T)"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "Chromebook Tab 10",
    "Device": "scarlet_cheets",
    "Model": "scarlet"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "CloudMobile S500",
    "Device": "a9",
    "Model": "S500"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "DA220HQL",
    "Device": "DA220HQL",
    "Model": "DA220HQL"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "DA221HQL",
    "Device": "da1",
    "Model": "DA221HQL"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "DA222HQL",
    "Device": "da2",
    "Model": "DA222HQL"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "DA222HQLA",
    "Device": "da2",
    "Model": "DA222HQLA"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "DA222HQLA",
    "Device": "da222hqla",
    "Model": "DA222HQLA"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "DA223HQL",
    "Device": "da3",
    "Model": "DA223HQL"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "DA226HQ",
    "Device": "da6",
    "Model": "DA226HQ"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "DA241HL",
    "Device": "DA241HL",
    "Model": "DA241HL"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "DA245HQL",
    "Device": "da245hql",
    "Model": "DA245HQL"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "DA251Q",
    "Device": "Aquarius",
    "Model": "DA251Q"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "E380",
    "Device": "acer_e3n",
    "Model": "E380"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "Frontier",
    "Device": "Frontier",
    "Model": "P10-11"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "G1-715",
    "Device": "G1-715",
    "Model": "G1-715"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "G100W",
    "Device": "maya",
    "Model": "G100W"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "GT-810",
    "Device": "rolex",
    "Model": "GT-810"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "I110",
    "Device": "I1",
    "Model": "I110"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "Icona One 7",
    "Device": "vespa",
    "Model": "B1-730HD"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "Iconia One 10",
    "Device": "acer_Colnago",
    "Model": "B3-A50"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "Iconia One 10",
    "Device": "acer_ColnagoFHD",
    "Model": "B3-A50FHD"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "Iconia One 10",
    "Device": "acer_jetfirelte",
    "Model": "B3-A32"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "Iconia One 10",
    "Device": "corona",
    "Model": "B3-A20"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "Iconia One 10",
    "Device": "corona",
    "Model": "B3-A20B"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "Iconia One 7",
    "Device": "G1-725",
    "Model": "G1-725"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "Iconia One 7",
    "Device": "acer_Vulcan",
    "Model": "B1-7A0"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "Iconia One 7",
    "Device": "acer_barricadewifi",
    "Model": "B1-790"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "Iconia One 7",
    "Device": "vespa",
    "Model": "B1-730HD"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "Iconia One 7",
    "Device": "vespa2",
    "Model": "B1-750"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "Iconia One 7",
    "Device": "vespatn",
    "Model": "B1-730"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "Iconia One 8",
    "Device": "acer_FrenzyRefresh",
    "Model": "B1-860A"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "Iconia One 8",
    "Device": "acer_Zipp",
    "Model": "B1-870"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "Iconia One 8",
    "Device": "vespa8",
    "Model": "A1-850"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "Iconia One 8",
    "Device": "vespa8",
    "Model": "B1-810"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "Iconia Tab 10",
    "Device": "acer_Titan",
    "Model": "A3-A50"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "Iconia Tab 10",
    "Device": "acer_asgard",
    "Model": "B3-A40"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "Iconia Tab 10",
    "Device": "acer_asgardfhd",
    "Model": "B3-A40FHD"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "Iconia Tab 10",
    "Device": "acer_harley",
    "Model": "A3-A20"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "Iconia Tab 10",
    "Device": "acer_harleyfhd",
    "Model": "A3-A20FHD"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "Iconia Tab 10 (AsgardLTE)",
    "Device": "acer_asgardlte",
    "Model": "B3-A42"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "Iconia Tab 7",
    "Device": "acer_aprilia",
    "Model": "A1-713"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "Iconia Tab 7",
    "Device": "acer_apriliahd",
    "Model": "A1-713HD"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "Iconia Tab 8",
    "Device": "ducati2fhd",
    "Model": "A1-840FHD"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "Iconia Tab 8",
    "Device": "ducati2hd",
    "Model": "A1-840"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "Iconia Tab 8",
    "Device": "ducati2hd3g",
    "Model": "A1-841"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "Iconia Tab A100 (VanGogh)",
    "Device": "vangogh",
    "Model": "A100"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "Iconia Tab A100 (VanGogh)",
    "Device": "vangogh",
    "Model": "A101"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "Iconia Tab A200",
    "Device": "picasso_e",
    "Model": "A200"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "Iconia Tab A210",
    "Device": "picasso_e2",
    "Model": "A210"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "Iconia Tab A211",
    "Device": "picasso_e2",
    "Model": "A211"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "Iconia Tab A500",
    "Device": "picasso",
    "Model": "A500"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "Iconia Tab A501",
    "Device": "picasso",
    "Model": "A501"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "Iconia Tab A510",
    "Device": "picasso_m",
    "Model": "A510"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "Iconia Tab A511",
    "Device": "picasso_m",
    "Model": "A511"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "Iconia Tab A700",
    "Device": "picasso_mf",
    "Model": "A700"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "Iconia Tab A701",
    "Device": "picasso_mf",
    "Model": "A701"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "Iconia TalkTab 7",
    "Device": "acer_a1_724",
    "Model": "A1-724"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "J73G",
    "Device": "J73G",
    "Model": "J73G"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "Liquid",
    "Device": "a1",
    "Model": "Acer Liquid"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "Liquid",
    "Device": "a1",
    "Model": "Acer S100"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "Liquid",
    "Device": "a1",
    "Model": "Liquid"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "Liquid 200",
    "Device": "acer_z200",
    "Model": "Z200"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "Liquid C1",
    "Device": "I1",
    "Model": "I110"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "Liquid E1",
    "Device": "C10",
    "Model": "V360"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "Liquid E2",
    "Device": "C11",
    "Model": "V370"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "Liquid E3",
    "Device": "acer_e3",
    "Model": "E380"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "Liquid E3",
    "Device": "acer_e3n",
    "Model": "E380"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "Liquid E3S",
    "Device": "acer_ZXR",
    "Model": "Z130"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "Liquid E600",
    "Device": "e600",
    "Model": "E600"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "Liquid E700",
    "Device": "acer_e39",
    "Model": "E39"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "Liquid Gallant E350",
    "Device": "C8",
    "Model": "AK330"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "Liquid Gallant E350",
    "Device": "C8",
    "Model": "E350"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "Liquid Jade",
    "Device": "acer_S55",
    "Model": "S55"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "Liquid Jade 2",
    "Device": "acer_s58a",
    "Model": "S58A"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "Liquid Jade S",
    "Device": "acer_S56",
    "Model": "S56"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "Liquid Jade Z",
    "Device": "acer_S57",
    "Model": "S57"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "Liquid Mini",
    "Device": "C4R",
    "Model": "E310"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "Liquid S1",
    "Device": "a10",
    "Model": "S510"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "Liquid S2",
    "Device": "a12",
    "Model": "S520"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "Liquid S3",
    "Device": "s3",
    "Model": "S53"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "Liquid T2",
    "Device": "acer_T02",
    "Model": "T02"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "Liquid X1",
    "Device": "s3",
    "Model": "S53"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "Liquid X2",
    "Device": "acer_S59",
    "Model": "S59"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "Liquid Z200",
    "Device": "acer_z200",
    "Model": "Z200"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "Liquid Z205",
    "Device": "acer_z205",
    "Model": "Z205"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "Liquid Z205",
    "Device": "acer_z205p",
    "Model": "Z205"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "Liquid Z205",
    "Device": "acer_z205p",
    "Model": "Z205P"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "Liquid Z220",
    "Device": "z220",
    "Model": "Z220"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "Liquid Z3",
    "Device": "ZX",
    "Model": "Z130"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "Liquid Z3",
    "Device": "acer_ZXR",
    "Model": "Z130"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "Liquid Z320",
    "Device": "T012",
    "Model": "T012"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "Liquid Z330",
    "Device": "T01",
    "Model": "T01"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "Liquid Z4",
    "Device": "acer_Z6",
    "Model": "Z160"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "Liquid Z410",
    "Device": "acer_z410",
    "Model": "Z410"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "Liquid Z5",
    "Device": "acer_ZXL",
    "Model": "Z150"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "Liquid Z500",
    "Device": "acer_Z500",
    "Model": "Z500"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "Liquid Z520",
    "Device": "acer_z520",
    "Model": "Z520"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "Liquid Z530",
    "Device": "acer_T02",
    "Model": "T02"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "Liquid Z530S",
    "Device": "acer_t05",
    "Model": "T05"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "Liquid Z6",
    "Device": "acer_t09",
    "Model": "T09"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "Liquid Z6 Plus",
    "Device": "acer_t11",
    "Model": "T11"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "Liquid Z630",
    "Device": "acer_t03",
    "Model": "T03"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "Liquid Z630S",
    "Device": "acer_t04",
    "Model": "T04"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "Liquid Z6E",
    "Device": "acer_t10",
    "Model": "T10"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "Liquid Zest",
    "Device": "acer_t06",
    "Model": "T06"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "Liquid Zest 4G",
    "Device": "acer_t07",
    "Model": "T07"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "Liquid Zest Plus",
    "Device": "acer_t08",
    "Model": "T08"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "LiquidMT",
    "Device": "a4",
    "Model": "Acer Liquid Metal"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "LiquidMT",
    "Device": "a4",
    "Model": "Liquid MT"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "LiquidMT",
    "Device": "a4",
    "Model": "Liquid Metal"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "M3-2200",
    "Device": "da2",
    "Model": "M3-2200"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "MWND1",
    "Device": "MW1",
    "Model": "MWND1"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "N3-2200",
    "Device": "da2",
    "Model": "N3-2200"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "P10M2",
    "Device": "acer_P10M2",
    "Model": "P10-21"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "P11",
    "Device": "P11",
    "Model": "P11-11"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "P11",
    "Device": "P11",
    "Model": "P11-11_EEA"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "P11",
    "Device": "P11",
    "Model": "P11-11_EEA_CUS1"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "P11",
    "Device": "P11",
    "Model": "P11-11_PAPAP_CUS1"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "Picasso",
    "Device": "picasso",
    "Model": "A501"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "Picasso",
    "Device": "ventana",
    "Model": "A500"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "Picasso",
    "Device": "ventana",
    "Model": "G100W"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "Picasso",
    "Device": "ventana",
    "Model": "TPA60W"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "R10G",
    "Device": "R10G",
    "Model": "R10G"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "R3",
    "Device": "R3",
    "Model": "R3"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "R3_GTV",
    "Device": "R3_GTV",
    "Model": "R3G"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "R4",
    "Device": "R4",
    "Model": "R4"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "R4_GTV",
    "Device": "R4_GTV",
    "Model": "R4G"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "Sospiro AS20WF",
    "Device": "AS20WF",
    "Model": "AS20WF"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "TA2",
    "Device": "ta2",
    "Model": "TA272HUL"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "TA272HUL",
    "Device": "ta2",
    "Model": "TA272HUL"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "TPA60W",
    "Device": "maya",
    "Model": "TPA60W"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "Tab 7",
    "Device": "td070va1",
    "Model": "TD070VA1"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "Tattoo",
    "Device": "Tattoo",
    "Model": "A10-11"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "Ultimo",
    "Device": "Ultimo",
    "Model": "EUT310A-11A"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "V10M2",
    "Device": "acer_V10M2",
    "Model": "V10-21"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "V11M1",
    "Device": "acer_V11M1",
    "Model": "V11-11"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "V11M1",
    "Device": "acer_V11M1",
    "Model": "V11-11_EEA"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "V11M2",
    "Device": "acer_V11M2",
    "Model": "V11-21M"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "V11M2",
    "Device": "acer_V11M2",
    "Model": "V11-21M_EEA"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "V11M2-LTE",
    "Device": "acer_V11M2-LTE",
    "Model": "V11-22M"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "V11M2-LTE",
    "Device": "acer_V11M2-LTE",
    "Model": "V11-22M_EEA"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "V12M1",
    "Device": "acer_V12M1",
    "Model": "V12-11M"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "V12M1",
    "Device": "acer_V12M1",
    "Model": "V12-11M_EEA"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "V13M1",
    "Device": "acer_V13M1",
    "Model": "V13-11M"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "V13M1",
    "Device": "acer_V13M1",
    "Model": "V13-11M_EEA"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "Walle",
    "Device": "Walle",
    "Model": "ET-108-11A"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "Walle",
    "Device": "Walle",
    "Model": "ET-108-11AR"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "X11M1",
    "Device": "acer_X11M1",
    "Model": "X11-11M"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "X11M1",
    "Device": "acer_X11M1",
    "Model": "X11-11M_EEA"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "X12M1",
    "Device": "acer_X12M1",
    "Model": "X12-11"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "X12M2",
    "Device": "acer_X12M2",
    "Model": "X12-21M"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "X12M2",
    "Device": "acer_X12M2",
    "Model": "X12-21M_EEA"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "X14M1N",
    "Device": "acer_X14M1N",
    "Model": "X14-11MN"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "X14M1N",
    "Device": "acer_X14M1N",
    "Model": "X14-11MN_EEA"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "Z110",
    "Device": "Z1",
    "Model": "Z110"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "Z120",
    "Device": "Z2",
    "Model": "Z120"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "acerpure",
    "Device": "waiawa",
    "Model": "DAC51U"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "dahu",
    "Device": "dahu",
    "Model": "M1G"
  },
  {
    "Retail Branding": "Acer",
    "Marketing Name": "vileparle",
    "Device": "vileparle",
    "Model": "R6G"
  },
  {
    "Retail Branding": "AcerPure",
    "Marketing Name": "Acer Acerpure",
    "Device": "Acerone_Liquid_2",
    "Model": "Acerone Liquid S162E4"
  },
  {
    "Retail Branding": "Aceson",
    "Marketing Name": "R726",
    "Device": "R726",
    "Model": "R726"
  },
  {
    "Retail Branding": "Acet",
    "Marketing Name": "X63L",
    "Device": "X63L",
    "Model": "X63L"
  },
  {
    "Retail Branding": "Achate",
    "Marketing Name": "Kids Tab 1",
    "Device": "KidsTab1_EEA",
    "Model": "Kids Tab 1"
  },
  {
    "Retail Branding": "Achate",
    "Marketing Name": "KidsTab3_EEA",
    "Device": "KidsTab3_EEA",
    "Model": "KidsTab3_EEA"
  },
  {
    "Retail Branding": "Achate",
    "Marketing Name": "Kids_Tab_2",
    "Device": "Kids_Tab_2",
    "Model": "Kids_Tab_2"
  },
  {
    "Retail Branding": "Aclas",
    "Marketing Name": "AO4",
    "Device": "AO4",
    "Model": "AO4"
  },
  {
    "Retail Branding": "Aclas",
    "Marketing Name": "AOx_A_B_C",
    "Device": "AOx_A_B_C",
    "Model": "AOx_A_B_C"
  },
  {
    "Retail Branding": "Aconatic",
    "Marketing Name": "55US800AN",
    "Device": "barking",
    "Model": "ACONATIC AndroidTV"
  },
  {
    "Retail Branding": "Aconatic",
    "Marketing Name": "ACONATIC",
    "Device": "bangbae",
    "Model": "Aconatic 4K Android TV"
  },
  {
    "Retail Branding": "Aconatic",
    "Marketing Name": "ACONATIC",
    "Device": "bruno",
    "Model": "ACONATIC 2K Android TV"
  },
  {
    "Retail Branding": "Aconatic",
    "Marketing Name": "ACONATIC",
    "Device": "shilin",
    "Model": "ACONATIC 4K Android TV"
  },
  {
    "Retail Branding": "Aconatic",
    "Marketing Name": "ACONATIC",
    "Device": "stanford",
    "Model": "2K SMART TV"
  },
  {
    "Retail Branding": "Aconatic",
    "Marketing Name": "ACONATIC",
    "Device": "zhongshan",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "Aconatic",
    "Marketing Name": "ACONATIC FHD TV",
    "Device": "takao",
    "Model": "ACONATIC FHD TV"
  },
  {
    "Retail Branding": "Aconatic",
    "Marketing Name": "ACONATIC UHD TV",
    "Device": "OD0M_EA_T32",
    "Model": "ACONATIC UHD TV"
  },
  {
    "Retail Branding": "Aconatic",
    "Marketing Name": "Aconatic",
    "Device": "komagome",
    "Model": "Aconatic 2K Android TV"
  },
  {
    "Retail Branding": "Aconatic",
    "Marketing Name": "Aconatic 2K Smart TV",
    "Device": "beomil",
    "Model": "Aconatic 2K Smart TV"
  },
  {
    "Retail Branding": "Aconatic",
    "Marketing Name": "Aconatic 2K Smart TV",
    "Device": "umeda",
    "Model": "Aconatic 2K Smart TV"
  },
  {
    "Retail Branding": "Aconatic",
    "Marketing Name": "Aconatic 4K Smart TV",
    "Device": "eleonas",
    "Model": "Aconatic 4K Smart TV"
  },
  {
    "Retail Branding": "Aconatic",
    "Marketing Name": "Android TV",
    "Device": "R1",
    "Model": "ATV R1"
  },
  {
    "Retail Branding": "Aconatic",
    "Marketing Name": "Android TV",
    "Device": "R2",
    "Model": "ATV R2"
  },
  {
    "Retail Branding": "Aconatic",
    "Marketing Name": "DV6068Y",
    "Device": "DV6068Y",
    "Model": "DV6068Y"
  },
  {
    "Retail Branding": "Aconatic",
    "Marketing Name": "DV8547",
    "Device": "DV8547",
    "Model": "DV8547"
  },
  {
    "Retail Branding": "Aconatic",
    "Marketing Name": "R10G",
    "Device": "R10G",
    "Model": "R10G"
  },
  {
    "Retail Branding": "Aconatic",
    "Marketing Name": "R3_GTV",
    "Device": "R3_GTV",
    "Model": "R3G"
  },
  {
    "Retail Branding": "Aconatic",
    "Marketing Name": "R4_GTV",
    "Device": "R4_GTV",
    "Model": "R4G"
  },
  {
    "Retail Branding": "Adart",
    "Marketing Name": "ALIGATOR RX510",
    "Device": "RX510",
    "Model": "ALIGATOR RX510"
  },
  {
    "Retail Branding": "Adart",
    "Marketing Name": "ALIGATOR S4080 Duo",
    "Device": "ALIGATOR_S4080",
    "Model": "ALIGATOR S4080"
  },
  {
    "Retail Branding": "Adart",
    "Marketing Name": "ALIGATOR S4082 Duo",
    "Device": "S4082Duo",
    "Model": "S4082 Duo"
  },
  {
    "Retail Branding": "Adart",
    "Marketing Name": "ALIGATOR S5062 Duo",
    "Device": "S5062Duo",
    "Model": "S5062 Duo"
  },
  {
    "Retail Branding": "Adart",
    "Marketing Name": "ALIGATOR S5510 Duo",
    "Device": "Aligator_S5510",
    "Model": "Aligator S5510"
  },
  {
    "Retail Branding": "Adart",
    "Marketing Name": "RX550",
    "Device": "ALIGATOR_RX550",
    "Model": "RX550"
  },
  {
    "Retail Branding": "Adart",
    "Marketing Name": "S4090",
    "Device": "S4090",
    "Model": "S4090"
  },
  {
    "Retail Branding": "Adart",
    "Marketing Name": "S5060 Duo",
    "Device": "ALIGATOR_S5060",
    "Model": "ALIGATOR S5060"
  },
  {
    "Retail Branding": "Adesa",
    "Marketing Name": "AD33",
    "Device": "rk3588_t",
    "Model": "Adesa_AD33"
  },
  {
    "Retail Branding": "Adget",
    "Marketing Name": "ADGT_AL02",
    "Device": "Alternative",
    "Model": "Adget Alternative"
  },
  {
    "Retail Branding": "Admiral Overseas Corporation",
    "Marketing Name": "A2272PW4T",
    "Device": "AOC_WW",
    "Model": "G3SMNTA22"
  },
  {
    "Retail Branding": "Admiral Overseas Corporation",
    "Marketing Name": "A2272PW4T",
    "Device": "AOC_WW",
    "Model": "G3SMNTA24"
  },
  {
    "Retail Branding": "Admiral Overseas Corporation",
    "Marketing Name": "A2272PWHT",
    "Device": "AOC_WW",
    "Model": "G2SMNT"
  },
  {
    "Retail Branding": "Admiral Overseas Corporation",
    "Marketing Name": "A2472PW4T",
    "Device": "G3SMNTA24",
    "Model": "G3SMNTA24"
  },
  {
    "Retail Branding": "Admiral Overseas Corporation",
    "Marketing Name": "A7",
    "Device": "A7",
    "Model": "A7"
  },
  {
    "Retail Branding": "Admiral Overseas Corporation",
    "Marketing Name": "ADMIRAL",
    "Device": "stanford",
    "Model": "2K SMART TV"
  },
  {
    "Retail Branding": "Admiral Overseas Corporation",
    "Marketing Name": "ADMIRAL",
    "Device": "zhongshan",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "Admiral Overseas Corporation",
    "Marketing Name": "ADMIRAL 4K TV",
    "Device": "SW4H",
    "Model": "ADMIRAL 4K TV"
  },
  {
    "Retail Branding": "Admiral Overseas Corporation",
    "Marketing Name": "ADMIRAL TV",
    "Device": "sunnyvale",
    "Model": "ADMIRAL TV"
  },
  {
    "Retail Branding": "Admiral Overseas Corporation",
    "Marketing Name": "Admiral",
    "Device": "anglelake",
    "Model": "ADS41F"
  },
  {
    "Retail Branding": "Admiral Overseas Corporation",
    "Marketing Name": "Admiral",
    "Device": "waiawa",
    "Model": "ADS51U"
  },
  {
    "Retail Branding": "Admiral Overseas Corporation",
    "Marketing Name": "C7",
    "Device": "C7",
    "Model": "C7"
  },
  {
    "Retail Branding": "Admiral Overseas Corporation",
    "Marketing Name": "Fire",
    "Device": "Fire",
    "Model": "Fire"
  },
  {
    "Retail Branding": "Admiral Overseas Corporation",
    "Marketing Name": "O7",
    "Device": "O7",
    "Model": "O7"
  },
  {
    "Retail Branding": "Admiral Overseas Corporation",
    "Marketing Name": "One",
    "Device": "One",
    "Model": "One"
  },
  {
    "Retail Branding": "Adonis",
    "Marketing Name": "Adonis",
    "Device": "seocho",
    "Model": "Adonis 4K Android TV"
  },
  {
    "Retail Branding": "Adreamer (Shenzhen)",
    "Marketing Name": "KidsPad10X",
    "Device": "KidsPad10X",
    "Model": "KidsPad10X"
  },
  {
    "Retail Branding": "Adreamer (Shenzhen)",
    "Marketing Name": "KidsPad_7",
    "Device": "KidsPad_7",
    "Model": "KidsPad_7"
  },
  {
    "Retail Branding": "Adreamer (Shenzhen)",
    "Marketing Name": "LeoPad 10X",
    "Device": "LeoPad_10X",
    "Model": "LeoPad 10X"
  },
  {
    "Retail Branding": "Adreamer (Shenzhen)",
    "Marketing Name": "LeoPad20",
    "Device": "LeoPad20",
    "Model": "LeoPad20"
  },
  {
    "Retail Branding": "Adreamer (Shenzhen)",
    "Marketing Name": "Libra PAD",
    "Device": "Libra_PAD",
    "Model": "Libra PAD"
  },
  {
    "Retail Branding": "Adreamer (Shenzhen)",
    "Marketing Name": "TH10",
    "Device": "TH10",
    "Model": "TH10"
  },
  {
    "Retail Branding": "Adreamer (Shenzhen)",
    "Marketing Name": "TH10_Tab",
    "Device": "TH10_Tab",
    "Model": "TH10_Tab"
  },
  {
    "Retail Branding": "Advan digital",
    "Marketing Name": 5041,
    "Device": "ADVAN_5041",
    "Model": 5041
  },
  {
    "Retail Branding": "Advan digital",
    "Marketing Name": 5059,
    "Device": "ADVAN_5059",
    "Model": 5059
  },
  {
    "Retail Branding": "Advan digital",
    "Marketing Name": 5060,
    "Device": "ADVAN_5060",
    "Model": 5060
  },
  {
    "Retail Branding": "Advan digital",
    "Marketing Name": 5061,
    "Device": "ADVAN_5061",
    "Model": 5061
  },
  {
    "Retail Branding": "Advan digital",
    "Marketing Name": "A8",
    "Device": "ADVAN_A8",
    "Model": "A8"
  },
  {
    "Retail Branding": "Advan digital",
    "Marketing Name": "ADVAN G2 plus",
    "Device": "ADVAN_5701",
    "Model": 5701
  },
  {
    "Retail Branding": "Advan digital",
    "Marketing Name": "ADVAN S50 4G",
    "Device": "ADVAN_i5G",
    "Model": "i5G"
  },
  {
    "Retail Branding": "Advan digital",
    "Marketing Name": "ADVAN_SKETSA_2",
    "Device": "ADVAN_SKETSA_2",
    "Model": "ADVAN 1011"
  },
  {
    "Retail Branding": "Advan digital",
    "Marketing Name": "E1C",
    "Device": "ADVAN_E1C_3G",
    "Model": "E1C_3G"
  },
  {
    "Retail Branding": "Advan digital",
    "Marketing Name": "E1C  4G",
    "Device": "ADVAN_E1C4G",
    "Model": 7037
  },
  {
    "Retail Branding": "Advan digital",
    "Marketing Name": "E1C 4G",
    "Device": "ADVAN_E1C_4G",
    "Model": 7035
  },
  {
    "Retail Branding": "Advan digital",
    "Marketing Name": "E1C NXT",
    "Device": "ADVAN_E1C_NXT",
    "Model": "S7D"
  },
  {
    "Retail Branding": "Advan digital",
    "Marketing Name": "G-Tab",
    "Device": "ADVAN_G_Tab",
    "Model": 8001
  },
  {
    "Retail Branding": "Advan digital",
    "Marketing Name": "G1",
    "Device": "G1",
    "Model": "G1"
  },
  {
    "Retail Branding": "Advan digital",
    "Marketing Name": "G1 PRO",
    "Device": "ADVAN_G1_Pro",
    "Model": "i5K"
  },
  {
    "Retail Branding": "Advan digital",
    "Marketing Name": "G2",
    "Device": "ADVAN_G2",
    "Model": "i55C"
  },
  {
    "Retail Branding": "Advan digital",
    "Marketing Name": "G2 Pro",
    "Device": "ADVAN_G2_Pro",
    "Model": 6004
  },
  {
    "Retail Branding": "Advan digital",
    "Marketing Name": "G3",
    "Device": "ADVAN_G3",
    "Model": 6001
  },
  {
    "Retail Branding": "Advan digital",
    "Marketing Name": "G3 Pro",
    "Device": "ADVAN_G3_Pro",
    "Model": 6002
  },
  {
    "Retail Branding": "Advan digital",
    "Marketing Name": "G5",
    "Device": "ADVAN_G5",
    "Model": 6201
  },
  {
    "Retail Branding": "Advan digital",
    "Marketing Name": "G5 Elite",
    "Device": "ADVAN_G5_Elite",
    "Model": 6003
  },
  {
    "Retail Branding": "Advan digital",
    "Marketing Name": "G5 Plus",
    "Device": "ADVAN_G5_Plus",
    "Model": 6501
  },
  {
    "Retail Branding": "Advan digital",
    "Marketing Name": "G9",
    "Device": "ADVAN_G9",
    "Model": 6501
  },
  {
    "Retail Branding": "Advan digital",
    "Marketing Name": "GX",
    "Device": "ADVAN_GX",
    "Model": 6801
  },
  {
    "Retail Branding": "Advan digital",
    "Marketing Name": "I Tab",
    "Device": "ADVAN_i_Tab",
    "Model": "i7_Plus"
  },
  {
    "Retail Branding": "Advan digital",
    "Marketing Name": "I55A",
    "Device": "I55A",
    "Model": "I55A"
  },
  {
    "Retail Branding": "Advan digital",
    "Marketing Name": "I5E",
    "Device": "ADVAN_I5E",
    "Model": "I5E"
  },
  {
    "Retail Branding": "Advan digital",
    "Marketing Name": "I5E",
    "Device": "ADVAN_I5Es",
    "Model": "i5E"
  },
  {
    "Retail Branding": "Advan digital",
    "Marketing Name": "I7D",
    "Device": "ADVAN_I7D",
    "Model": "I7D"
  },
  {
    "Retail Branding": "Advan digital",
    "Marketing Name": "M4",
    "Device": "ADVAN_M4",
    "Model": "ADVAN M4"
  },
  {
    "Retail Branding": "Advan digital",
    "Marketing Name": "NASA",
    "Device": "ADVAN_NASA",
    "Model": 5202
  },
  {
    "Retail Branding": "Advan digital",
    "Marketing Name": "NASA_Plus",
    "Device": "ADVAN_NASA_Plus",
    "Model": 5505
  },
  {
    "Retail Branding": "Advan digital",
    "Marketing Name": "S40",
    "Device": "ADVAN_S40",
    "Model": "ADVAN S40"
  },
  {
    "Retail Branding": "Advan digital",
    "Marketing Name": "S40 LTE",
    "Device": "ADVAN_i4U",
    "Model": "i4U"
  },
  {
    "Retail Branding": "Advan digital",
    "Marketing Name": "S45E",
    "Device": "ADVAN_S45E",
    "Model": "S45E"
  },
  {
    "Retail Branding": "Advan digital",
    "Marketing Name": "S4T",
    "Device": "S4T",
    "Model": "S4T"
  },
  {
    "Retail Branding": "Advan digital",
    "Marketing Name": "S4Z",
    "Device": "ADVAN_S4Z",
    "Model": "S4Z"
  },
  {
    "Retail Branding": "Advan digital",
    "Marketing Name": "S50 Prime",
    "Device": "ADVAN_S50_Prime",
    "Model": 5063
  },
  {
    "Retail Branding": "Advan digital",
    "Marketing Name": "S5E FULL VIEW",
    "Device": "ADVAN_S5E_FULL_VIEW",
    "Model": 5062
  },
  {
    "Retail Branding": "Advan digital",
    "Marketing Name": "S5E_NXT",
    "Device": "ADVAN_S5E_NXT",
    "Model": "S5E_NXT"
  },
  {
    "Retail Branding": "Advan digital",
    "Marketing Name": "S6 Plus",
    "Device": "ADVAN_S6_Plus",
    "Model": 5502
  },
  {
    "Retail Branding": "Advan digital",
    "Marketing Name": "S6 Pro",
    "Device": "ADVAN_S6_Pro",
    "Model": 5504
  },
  {
    "Retail Branding": "Advan digital",
    "Marketing Name": "S7A",
    "Device": "S7A",
    "Model": "S7A"
  },
  {
    "Retail Branding": "Advan digital",
    "Marketing Name": "S7C",
    "Device": "ADVAN_S7C",
    "Model": "S7C"
  },
  {
    "Retail Branding": "Advan digital",
    "Marketing Name": "T2J",
    "Device": "T2J",
    "Model": "T2J"
  },
  {
    "Retail Branding": "Advan digital",
    "Marketing Name": "T2K",
    "Device": "T2K",
    "Model": "T2K"
  },
  {
    "Retail Branding": "Advan digital",
    "Marketing Name": "TAB 10",
    "Device": "ADVAN_TAB_10",
    "Model": 1010
  },
  {
    "Retail Branding": "Advan digital",
    "Marketing Name": "TAB 7",
    "Device": "ADVAN_TAB_7",
    "Model": 7039
  },
  {
    "Retail Branding": "Advan digital",
    "Marketing Name": "TAB 8",
    "Device": "ADVAN_TAB_8",
    "Model": 8002
  },
  {
    "Retail Branding": "Advan digital",
    "Marketing Name": "TAB Gallilea",
    "Device": "ADVAN_TAB_Gallilea",
    "Model": 8003
  },
  {
    "Retail Branding": "Advan digital",
    "Marketing Name": "TAB VX",
    "Device": "ADVAN_TAB_VX",
    "Model": 1013
  },
  {
    "Retail Branding": "Advan digital",
    "Marketing Name": "TAB_10",
    "Device": "ADVAN_TAB_10",
    "Model": 1010
  },
  {
    "Retail Branding": "Advan digital",
    "Marketing Name": "TAB_A8_PLUS",
    "Device": "ADVAN_TAB_A8_PLUS",
    "Model": 8004
  },
  {
    "Retail Branding": "Advan digital",
    "Marketing Name": "X7 Max",
    "Device": "X7_Max",
    "Model": 7301
  },
  {
    "Retail Branding": "Advan digital",
    "Marketing Name": "X7 Pro",
    "Device": "ADVAN_7008",
    "Model": 7008
  },
  {
    "Retail Branding": "Advan digital",
    "Marketing Name": "X7 Pro",
    "Device": "ADVAN_X7_Pro",
    "Model": "X7 Pro"
  },
  {
    "Retail Branding": "Advan digital",
    "Marketing Name": "XTAB",
    "Device": "ADVAN_XTAB",
    "Model": 8004
  },
  {
    "Retail Branding": "Advan digital",
    "Marketing Name": "i10",
    "Device": "i10",
    "Model": "i10"
  },
  {
    "Retail Branding": "Advan digital",
    "Marketing Name": "i55D",
    "Device": "ADVAN_i55D",
    "Model": "i55D"
  },
  {
    "Retail Branding": "Advan digital",
    "Marketing Name": "i55K",
    "Device": "ADVAN_i55K",
    "Model": "i55K"
  },
  {
    "Retail Branding": "Advan digital",
    "Marketing Name": "i5C",
    "Device": "i5C",
    "Model": "i5C"
  },
  {
    "Retail Branding": "Advan digital",
    "Marketing Name": "i5C plus",
    "Device": "ADVAN_i5C_Plus",
    "Model": 5058
  },
  {
    "Retail Branding": "Advan digital",
    "Marketing Name": "i5D",
    "Device": "ADVAN_i5D",
    "Model": "i5D"
  },
  {
    "Retail Branding": "Advan digital",
    "Marketing Name": "i6A",
    "Device": "ADVAN_5501",
    "Model": 5501
  },
  {
    "Retail Branding": "Advan digital",
    "Marketing Name": "i6c",
    "Device": "ADVAN_i6C",
    "Model": 5503
  },
  {
    "Retail Branding": "Advan digital",
    "Marketing Name": "i7",
    "Device": "ADVAN_i7",
    "Model": "i7"
  },
  {
    "Retail Branding": "Advan digital",
    "Marketing Name": "i7A",
    "Device": "ADVAN_i7A",
    "Model": "i7A"
  },
  {
    "Retail Branding": "Advan digital",
    "Marketing Name": "i7U",
    "Device": "ADVAN_i_Lite",
    "Model": "i7U"
  },
  {
    "Retail Branding": "Advance",
    "Marketing Name": "ADVANCE",
    "Device": "SP4871",
    "Model": "SP4871"
  },
  {
    "Retail Branding": "Advance",
    "Marketing Name": "ADVANCE",
    "Device": "elliniko",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "Advance",
    "Marketing Name": "ADVANCE",
    "Device": "templeton",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "Advance",
    "Marketing Name": "Advance",
    "Device": "Tr4995",
    "Model": "Tr4995"
  },
  {
    "Retail Branding": "Advance",
    "Marketing Name": "HL4736",
    "Device": "HL4736",
    "Model": "HL4736"
  },
  {
    "Retail Branding": "Advance",
    "Marketing Name": "HL4936",
    "Device": "HL4936",
    "Model": "HL4936"
  },
  {
    "Retail Branding": "Advance",
    "Marketing Name": "HL5576",
    "Device": "HL5576",
    "Model": "HL5576"
  },
  {
    "Retail Branding": "Advance",
    "Marketing Name": "HL5585",
    "Device": "HL5585",
    "Model": "HL5585"
  },
  {
    "Retail Branding": "Advance",
    "Marketing Name": "HL5677",
    "Device": "HL5677",
    "Model": "HL5677"
  },
  {
    "Retail Branding": "Advance",
    "Marketing Name": "HL6077",
    "Device": "HL6077",
    "Model": "HL6077"
  },
  {
    "Retail Branding": "Advance",
    "Marketing Name": "HL6248",
    "Device": "HL6248",
    "Model": "HL6248"
  },
  {
    "Retail Branding": "Advance",
    "Marketing Name": "HL6256",
    "Device": "HL6256",
    "Model": "HL6256"
  },
  {
    "Retail Branding": "Advance",
    "Marketing Name": "HL6577",
    "Device": "HL6577",
    "Model": "HL6577"
  },
  {
    "Retail Branding": "Advance",
    "Marketing Name": "HL7257",
    "Device": "HL7257",
    "Model": "HL7257"
  },
  {
    "Retail Branding": "Advance",
    "Marketing Name": "HL9000",
    "Device": "HL9000",
    "Model": "HL9000"
  },
  {
    "Retail Branding": "Advance",
    "Marketing Name": "NP6050",
    "Device": "NP6050",
    "Model": "NP6050"
  },
  {
    "Retail Branding": "Advance",
    "Marketing Name": "NP6070",
    "Device": "NP6070",
    "Model": "NP6070"
  },
  {
    "Retail Branding": "Advance",
    "Marketing Name": "NP6070",
    "Device": "NP6070_ADV",
    "Model": "NP6070_ADV"
  },
  {
    "Retail Branding": "Advance",
    "Marketing Name": "PR5860",
    "Device": "PR5860",
    "Model": "PR5860"
  },
  {
    "Retail Branding": "Advance",
    "Marketing Name": "PR6149",
    "Device": "PR6149",
    "Model": "PR6149"
  },
  {
    "Retail Branding": "Advance",
    "Marketing Name": "PR6152",
    "Device": "PR6152",
    "Model": "PR6152"
  },
  {
    "Retail Branding": "Advance",
    "Marketing Name": "PR6152-ADV",
    "Device": "PR6152-ADV",
    "Model": "PR6152-ADV"
  },
  {
    "Retail Branding": "Advance",
    "Marketing Name": "PR6167",
    "Device": "PR6171",
    "Model": "PR6171"
  },
  {
    "Retail Branding": "Advance",
    "Marketing Name": "PR6850",
    "Device": "PR6850",
    "Model": "PR6850"
  },
  {
    "Retail Branding": "Advance",
    "Marketing Name": "PR7145",
    "Device": "PR7145",
    "Model": "PR7145"
  },
  {
    "Retail Branding": "Advance",
    "Marketing Name": "Pr5650",
    "Device": "Pr5650",
    "Model": "Pr5650"
  },
  {
    "Retail Branding": "Advance",
    "Marketing Name": "Pr5747",
    "Device": "Pr5747",
    "Model": "Pr5747"
  },
  {
    "Retail Branding": "Advance",
    "Marketing Name": "Pr5950",
    "Device": "Pr5950",
    "Model": "Pr5950"
  },
  {
    "Retail Branding": "Advance",
    "Marketing Name": "Pr6146",
    "Device": "Pr6146",
    "Model": "Pr6146"
  },
  {
    "Retail Branding": "Advance",
    "Marketing Name": "Pr6150",
    "Device": "Pr6150",
    "Model": "Pr6150"
  },
  {
    "Retail Branding": "Advance",
    "Marketing Name": "Pr7547",
    "Device": "Pr7547",
    "Model": "Pr7547"
  },
  {
    "Retail Branding": "Advance",
    "Marketing Name": "SP3703",
    "Device": "SP3703",
    "Model": "SP3703"
  },
  {
    "Retail Branding": "Advance",
    "Marketing Name": "SP4702",
    "Device": "SP4702",
    "Model": "SP4702"
  },
  {
    "Retail Branding": "Advance",
    "Marketing Name": "SP4703",
    "Device": "SP4703",
    "Model": "SP4703"
  },
  {
    "Retail Branding": "Advance",
    "Marketing Name": "SP4872",
    "Device": "SP4872",
    "Model": "SP4872"
  },
  {
    "Retail Branding": "Advance",
    "Marketing Name": "SP5702",
    "Device": "SP5702",
    "Model": "SP5702"
  },
  {
    "Retail Branding": "Advance",
    "Marketing Name": "SP5705",
    "Device": "SP5705",
    "Model": "SP5705"
  },
  {
    "Retail Branding": "Advance",
    "Marketing Name": "SP5712",
    "Device": "SP5712",
    "Model": "SP5712"
  },
  {
    "Retail Branding": "Advance",
    "Marketing Name": "SP5713",
    "Device": "SP5713",
    "Model": "SP5713"
  },
  {
    "Retail Branding": "Advance",
    "Marketing Name": "SP5732",
    "Device": "SP5732",
    "Model": "SP5732"
  },
  {
    "Retail Branding": "Advance",
    "Marketing Name": "SP5733",
    "Device": "SP5733",
    "Model": "SP5733"
  },
  {
    "Retail Branding": "Advance",
    "Marketing Name": "SP5733",
    "Device": "SP5733A",
    "Model": "SP5733"
  },
  {
    "Retail Branding": "Advance",
    "Marketing Name": "SP5735",
    "Device": "SP5735",
    "Model": "SP5735"
  },
  {
    "Retail Branding": "Advance",
    "Marketing Name": "SP5736",
    "Device": "SP5736",
    "Model": "SP5736"
  },
  {
    "Retail Branding": "Advance",
    "Marketing Name": "SP5738",
    "Device": "SP5738",
    "Model": "SP5738"
  },
  {
    "Retail Branding": "Advance",
    "Marketing Name": "SP5739",
    "Device": "SP5739",
    "Model": "SP5739"
  },
  {
    "Retail Branding": "Advance",
    "Marketing Name": "SP5760",
    "Device": "SP5760",
    "Model": "SP5760"
  },
  {
    "Retail Branding": "Advance",
    "Marketing Name": "SP5775",
    "Device": "SP5775",
    "Model": "SP5775"
  },
  {
    "Retail Branding": "Advance",
    "Marketing Name": "SP5776",
    "Device": "SP5776",
    "Model": "SP5776"
  },
  {
    "Retail Branding": "Advance",
    "Marketing Name": "SP5782",
    "Device": "SP5782",
    "Model": "SP5782"
  },
  {
    "Retail Branding": "Advance",
    "Marketing Name": "SP7248",
    "Device": "SP7248",
    "Model": "SP7248"
  },
  {
    "Retail Branding": "Advance",
    "Marketing Name": "SP7348",
    "Device": "SP7348",
    "Model": "SP7348"
  },
  {
    "Retail Branding": "Advance",
    "Marketing Name": "Sp5730",
    "Device": "Sp5730",
    "Model": "Sp5730"
  },
  {
    "Retail Branding": "Advance",
    "Marketing Name": "TR3947",
    "Device": "TR3947",
    "Model": "TR3947"
  },
  {
    "Retail Branding": "Advance",
    "Marketing Name": "TR4986",
    "Device": "Tablet_adv_v1",
    "Model": "ADVANCE"
  },
  {
    "Retail Branding": "Advance",
    "Marketing Name": "TR5994",
    "Device": "TR5994",
    "Model": "TR5994"
  },
  {
    "Retail Branding": "Advance",
    "Marketing Name": "TR5996",
    "Device": "TR5996",
    "Model": "TR5996"
  },
  {
    "Retail Branding": "Advance",
    "Marketing Name": "TR6948",
    "Device": "TR6948",
    "Model": "TR6948"
  },
  {
    "Retail Branding": "Advance",
    "Marketing Name": "TR6949",
    "Device": "TR6949",
    "Model": "TR6949"
  },
  {
    "Retail Branding": "Advance",
    "Marketing Name": "TR6985",
    "Device": "TR6985",
    "Model": "TR6985"
  },
  {
    "Retail Branding": "Advance",
    "Marketing Name": "TR7988",
    "Device": "TR7988",
    "Model": "TR7988"
  },
  {
    "Retail Branding": "Advance",
    "Marketing Name": "TR7989",
    "Device": "TR7989",
    "Model": "TR7989"
  },
  {
    "Retail Branding": "Advance",
    "Marketing Name": "TR7990",
    "Device": "TR7990",
    "Model": "TR7990"
  },
  {
    "Retail Branding": "Advance",
    "Marketing Name": "TR7998",
    "Device": "TR7998",
    "Model": "TR7998"
  },
  {
    "Retail Branding": "Advance",
    "Marketing Name": "TR8050",
    "Device": "TR8050",
    "Model": "TR8050"
  },
  {
    "Retail Branding": "Advance",
    "Marketing Name": "TR8990",
    "Device": "TR8990",
    "Model": "TR8990"
  },
  {
    "Retail Branding": "Advance",
    "Marketing Name": "Tablet_Advance",
    "Device": "Tablet_adv_v1",
    "Model": "ADVANCE"
  },
  {
    "Retail Branding": "Advance",
    "Marketing Name": "Tr3946",
    "Device": "Tr3946",
    "Model": "Tr3946"
  },
  {
    "Retail Branding": "Advance",
    "Marketing Name": "Tr4986",
    "Device": "Tablet_adv_v1",
    "Model": "ADVANCE"
  },
  {
    "Retail Branding": "Advance",
    "Marketing Name": "Tr4986",
    "Device": "Tr4986",
    "Model": "Tr4986"
  },
  {
    "Retail Branding": "Advanced_Rugged",
    "Marketing Name": "Advanced_Rugged",
    "Device": "Z_Voyage",
    "Model": "Z_Voyage"
  },
  {
    "Retail Branding": "Advanced_Rugged",
    "Marketing Name": "Z_Voyage",
    "Device": "Z_Voyage",
    "Model": "Z_Voyage"
  },
  {
    "Retail Branding": "Advantage",
    "Marketing Name": "I101MTK",
    "Device": "I101MTK",
    "Model": "I101MTK"
  },
  {
    "Retail Branding": "Advantage Air",
    "Marketing Name": "PIC10GS10",
    "Device": "PIC10GS10",
    "Model": "PIC10GS10"
  },
  {
    "Retail Branding": "Advantage Air",
    "Marketing Name": "PIC10GS13",
    "Device": "PIC10GS13",
    "Model": "PIC10GS13"
  },
  {
    "Retail Branding": "Advantage Air",
    "Marketing Name": "PIC10GS8",
    "Device": "PIC10GS8",
    "Model": "PIC10GS8"
  },
  {
    "Retail Branding": "Advantage Air",
    "Marketing Name": "PIC7GS10-A",
    "Device": "PIC7GS10-A",
    "Model": "PIC7GS10-A"
  },
  {
    "Retail Branding": "Advantage Air",
    "Marketing Name": "PIC7GS13",
    "Device": "PIC7GS13",
    "Model": "PIC7GS13"
  },
  {
    "Retail Branding": "Advantage Air",
    "Marketing Name": "PIC7GS8",
    "Device": "PIC7GS8",
    "Model": "PIC7GS8"
  },
  {
    "Retail Branding": "Advantage Air",
    "Marketing Name": "PIC8GS10",
    "Device": "PIC8GS10",
    "Model": "PIC8GS10"
  },
  {
    "Retail Branding": "Advantage Air",
    "Marketing Name": "PIC8GS12",
    "Device": "PIC8GS12",
    "Model": "PIC8GS12"
  },
  {
    "Retail Branding": "Advantage Air",
    "Marketing Name": "PIC8GS8",
    "Device": "PIC8GS8",
    "Model": "PIC8GS8"
  },
  {
    "Retail Branding": "Advantech",
    "Marketing Name": "AIM-75",
    "Device": "AIM75-LTE",
    "Model": "AIM-75"
  },
  {
    "Retail Branding": "Advantech",
    "Marketing Name": "AIM-76S",
    "Device": "aim76s",
    "Model": "AIM-76S"
  },
  {
    "Retail Branding": "Advantech",
    "Marketing Name": "AIM75-LTE",
    "Device": "AIM75-LTE",
    "Model": "AIM75-LTE"
  },
  {
    "Retail Branding": "Advantech",
    "Marketing Name": "AIM75-WIFI",
    "Device": "AIM75-WIFI",
    "Model": "AIM75-WIFI"
  },
  {
    "Retail Branding": "Advantech",
    "Marketing Name": "DLT-V7310AP",
    "Device": "dlt_v7310",
    "Model": "DLT-V7310AP"
  },
  {
    "Retail Branding": "Advantech",
    "Marketing Name": "DLT-V7310AP FL",
    "Device": "dltv7310_fl",
    "Model": "DLT-V7310AP FL"
  },
  {
    "Retail Branding": "Advantech",
    "Marketing Name": "DLT-V7312AP",
    "Device": "dlt_v7312",
    "Model": "DLT-V7312AP"
  },
  {
    "Retail Branding": "Advantech",
    "Marketing Name": "DLT-V7312AP FL",
    "Device": "dltv7312_fl",
    "Model": "DLT-V7312AP FL"
  },
  {
    "Retail Branding": "Advantech",
    "Marketing Name": "DLT-V7312AP+",
    "Device": "dlt_v7312plus",
    "Model": "DLT-V7312AP+"
  },
  {
    "Retail Branding": "Advantech",
    "Marketing Name": "DLT-V7312AP+ FL",
    "Device": "dltv7312plus_fl",
    "Model": "DLT-V7312AP+ FL"
  },
  {
    "Retail Branding": "Advantech",
    "Marketing Name": "UBX-010RC",
    "Device": "ubx010rc",
    "Model": "UBX-010RC"
  },
  {
    "Retail Branding": "Advent",
    "Marketing Name": "SB11MD1",
    "Device": "SB11MD1",
    "Model": "SB11MD1"
  },
  {
    "Retail Branding": "Aelion",
    "Marketing Name": "i8",
    "Device": "Aelion_i8",
    "Model": "i8"
  },
  {
    "Retail Branding": "Aeon Communication (IN)",
    "Marketing Name": "AE1020",
    "Device": "AE1020",
    "Model": "AE1020"
  },
  {
    "Retail Branding": "Aermoo",
    "Marketing Name": "CM08",
    "Device": "PT3_2",
    "Model": "CM08"
  },
  {
    "Retail Branding": "Aermoo",
    "Marketing Name": "CM10",
    "Device": "PT1E_2",
    "Model": "CM10"
  },
  {
    "Retail Branding": "Aermoo",
    "Marketing Name": "CM20",
    "Device": "PT2_1",
    "Model": "CM20"
  },
  {
    "Retail Branding": "Aermoo",
    "Marketing Name": "DF10",
    "Device": "M22PE",
    "Model": "DF10"
  },
  {
    "Retail Branding": "Aermoo",
    "Marketing Name": "DF10 Pro",
    "Device": "M22G_2",
    "Model": "DF10 Pro"
  },
  {
    "Retail Branding": "Aermoo",
    "Marketing Name": "PF10",
    "Device": "M23HE_2",
    "Model": "PF10"
  },
  {
    "Retail Branding": "Aermoo",
    "Marketing Name": "PF10 Pro",
    "Device": "M23HT_2",
    "Model": "PF10 Pro"
  },
  {
    "Retail Branding": "Aermoo",
    "Marketing Name": "PF20",
    "Device": "ZN133SE",
    "Model": "PF 20"
  },
  {
    "Retail Branding": "Aermoo",
    "Marketing Name": "PF20 Pro",
    "Device": "ZN133TE",
    "Model": "PF20 Pro"
  },
  {
    "Retail Branding": "Aermoo",
    "Marketing Name": "RG Mini",
    "Device": "ZN137E",
    "Model": "RG Mini"
  },
  {
    "Retail Branding": "Aermoo",
    "Marketing Name": "RG10",
    "Device": "F1_2",
    "Model": "RG10"
  },
  {
    "Retail Branding": "Aermoo",
    "Marketing Name": "RG10S",
    "Device": "F1C_2",
    "Model": "RG10S"
  },
  {
    "Retail Branding": "Affix",
    "Marketing Name": "T737",
    "Device": "AFFIX_T737",
    "Model": "AFFIX T737"
  },
  {
    "Retail Branding": "AfriOne",
    "Marketing Name": "CYGNUS",
    "Device": "CYGNUS",
    "Model": "CYGNUS"
  },
  {
    "Retail Branding": "AfriOne",
    "Marketing Name": "CYGNUSX",
    "Device": "CYGNUSX",
    "Model": "CYGNUSX"
  },
  {
    "Retail Branding": "AfriOne",
    "Marketing Name": "ChampionPro",
    "Device": "ChampionPro",
    "Model": "ChampionPro"
  },
  {
    "Retail Branding": "AfriOne",
    "Marketing Name": "Gravity Z2",
    "Device": "Gravity_Z2",
    "Model": "Gravity Z2"
  },
  {
    "Retail Branding": "AfriOne",
    "Marketing Name": "moxie",
    "Device": "moxie",
    "Model": "moxie"
  },
  {
    "Retail Branding": "Afrrikia",
    "Marketing Name": "AFK-0001-1001",
    "Device": "AFK-0001-1001",
    "Model": "AFK-0001-1001"
  },
  {
    "Retail Branding": "Afrrikia",
    "Marketing Name": "AFK-0001-1002",
    "Device": "AFK-0001-1002",
    "Model": "AFK-0001-1002"
  },
  {
    "Retail Branding": "AgileTV",
    "Marketing Name": "DV9157-T2",
    "Device": "DV9157-T2-KIA",
    "Model": "DV9157-T2"
  },
  {
    "Retail Branding": "Aikun",
    "Marketing Name": "EDSTAR LC-TS08A",
    "Device": "LC-TS08A",
    "Model": "LC-TS08A"
  },
  {
    "Retail Branding": "Aikun",
    "Marketing Name": "EDSTAR LC-TS08S",
    "Device": "LC-TS08S",
    "Model": "LC-TS08S"
  },
  {
    "Retail Branding": "Aikun",
    "Marketing Name": "RX300",
    "Device": "X300",
    "Model": "X300"
  },
  {
    "Retail Branding": "Aikun",
    "Marketing Name": "Solely Tab S7",
    "Device": "HV1A",
    "Model": "S7"
  },
  {
    "Retail Branding": "Aikun",
    "Marketing Name": "Solely Tab S8",
    "Device": "HV1A",
    "Model": "S8"
  },
  {
    "Retail Branding": "Aimson",
    "Marketing Name": "7C08S",
    "Device": "7C08S",
    "Model": "7C08S"
  },
  {
    "Retail Branding": "Aimson",
    "Marketing Name": "AINOL_Q88X",
    "Device": "AINOL_Q88X",
    "Model": "Q88X"
  },
  {
    "Retail Branding": "Aimson",
    "Marketing Name": "Q88",
    "Device": "Q88",
    "Model": "Q88"
  },
  {
    "Retail Branding": "Ainmel",
    "Marketing Name": "A10S_EEA",
    "Device": "A10S",
    "Model": "A10S"
  },
  {
    "Retail Branding": "Ainmel",
    "Marketing Name": "KB07",
    "Device": "KB07",
    "Model": "KB07"
  },
  {
    "Retail Branding": "Ainmel",
    "Marketing Name": "KB07_EEA",
    "Device": "KB07",
    "Model": "KB07"
  },
  {
    "Retail Branding": "Ainmel",
    "Marketing Name": "KB08_EEA",
    "Device": "KB08",
    "Model": "KB08"
  },
  {
    "Retail Branding": "Ainmel",
    "Marketing Name": "KB1001",
    "Device": "KB1001",
    "Model": "KB1001"
  },
  {
    "Retail Branding": "Ainmel",
    "Marketing Name": "KB1001A",
    "Device": "KB1001",
    "Model": "KB1001"
  },
  {
    "Retail Branding": "Ainmel",
    "Marketing Name": "KB1001A_EEA",
    "Device": "KB1001",
    "Model": "KB1001"
  },
  {
    "Retail Branding": "Ainmel",
    "Marketing Name": "KB1001_EEA",
    "Device": "KB1001",
    "Model": "KB1001"
  },
  {
    "Retail Branding": "Ainmel",
    "Marketing Name": "KB1003_EEA",
    "Device": "KB1003",
    "Model": "KB1003"
  },
  {
    "Retail Branding": "Ainmel",
    "Marketing Name": "KB1004",
    "Device": "KB1004",
    "Model": "KB1004"
  },
  {
    "Retail Branding": "Ainmel",
    "Marketing Name": "KB1004A",
    "Device": "KB1004",
    "Model": "KB1004"
  },
  {
    "Retail Branding": "Ainmel",
    "Marketing Name": "KB1004A_EEA",
    "Device": "KB1004",
    "Model": "KB1004"
  },
  {
    "Retail Branding": "Ainmel",
    "Marketing Name": "KB1004S",
    "Device": "KB1004S",
    "Model": "KB1004S"
  },
  {
    "Retail Branding": "Ainmel",
    "Marketing Name": "KB1004S_EEA",
    "Device": "KB1004S",
    "Model": "KB1004S"
  },
  {
    "Retail Branding": "Ainmel",
    "Marketing Name": "KB1005",
    "Device": "KB1005",
    "Model": "KB1005"
  },
  {
    "Retail Branding": "Ainmel",
    "Marketing Name": "KB1005_EEA",
    "Device": "KB1005",
    "Model": "KB1005"
  },
  {
    "Retail Branding": "Ainol",
    "Marketing Name": "7C08X",
    "Device": "7C08X",
    "Model": "7C08X"
  },
  {
    "Retail Branding": "Ainol",
    "Marketing Name": "Q88A_EEA",
    "Device": "Q88A_EEA",
    "Model": "Q88A"
  },
  {
    "Retail Branding": "Ainuevo",
    "Marketing Name": "Ainuevo Neo S25 Pro",
    "Device": "Ainuevo_Neo_S25_Pro",
    "Model": "Ainuevo Neo S25 Pro"
  },
  {
    "Retail Branding": "AirTV",
    "Marketing Name": "AirTV Mini",
    "Device": "kunlun",
    "Model": "AirTV Mini"
  },
  {
    "Retail Branding": "AirTV",
    "Marketing Name": "DV8535",
    "Device": "DV8535",
    "Model": "DV8535"
  },
  {
    "Retail Branding": "AirTouch",
    "Marketing Name": "AirTouch5",
    "Device": "AirTouch5",
    "Model": "AirTouch5"
  },
  {
    "Retail Branding": "AirTouch",
    "Marketing Name": "AirTouch5n",
    "Device": "AirTouch5n",
    "Model": "AirTouch5n"
  },
  {
    "Retail Branding": "Airpha",
    "Marketing Name": "Halo3_Pro",
    "Device": "Halo3",
    "Model": "Halo3"
  },
  {
    "Retail Branding": "Airpha",
    "Marketing Name": "Halo3_Pro",
    "Device": "Halo3_Pro",
    "Model": "Halo3_Pro"
  },
  {
    "Retail Branding": "Airpha",
    "Marketing Name": "Halo4",
    "Device": "Halo4",
    "Model": "Halo4"
  },
  {
    "Retail Branding": "Airpha",
    "Marketing Name": "Halo4 Pro",
    "Device": "Halo4_Pro",
    "Model": "Halo4 Pro"
  },
  {
    "Retail Branding": "Airpha",
    "Marketing Name": "Mega3_Pro",
    "Device": "Mega3_Pro",
    "Model": "Mega3_Pro"
  },
  {
    "Retail Branding": "Airpha",
    "Marketing Name": "Sense2",
    "Device": "Sense2",
    "Model": "Sense2"
  },
  {
    "Retail Branding": "Airpha",
    "Marketing Name": "Sense2_Pro",
    "Device": "Sense2_Pro",
    "Model": "Sense2_Pro"
  },
  {
    "Retail Branding": "Airtab",
    "Marketing Name": "AT8-N",
    "Device": "AT8-N",
    "Model": "AT8-N"
  },
  {
    "Retail Branding": "Airtel",
    "Marketing Name": "AIRTEL SMART ROUTER",
    "Device": "SEI700ATLN",
    "Model": "AIRTEL SMART ROUTER"
  },
  {
    "Retail Branding": "Airtel",
    "Marketing Name": "AIRTEL SMART ROUTER",
    "Device": "SEI740DEM",
    "Model": "AIRTEL SMART ROUTER"
  },
  {
    "Retail Branding": "Airtel",
    "Marketing Name": "Airtel Smart Box",
    "Device": "DV9108-KNA",
    "Model": "Airtel Smart Box"
  },
  {
    "Retail Branding": "Airtel",
    "Marketing Name": "H6682_Airtel_DRC",
    "Device": "H6682",
    "Model": "H6682_Airtel_DRC"
  },
  {
    "Retail Branding": "Airtel",
    "Marketing Name": "HP2707",
    "Device": "AirtelOTTBox",
    "Model": "HP2707"
  },
  {
    "Retail Branding": "Airtel",
    "Marketing Name": "SH960S-AT",
    "Device": "ganesa",
    "Model": "SH960S-AT"
  },
  {
    "Retail Branding": "Airtel",
    "Marketing Name": "XStream Smart Box",
    "Device": "hsw4026atl",
    "Model": "XStream_Smart_Box_001"
  },
  {
    "Retail Branding": "Airtel",
    "Marketing Name": "XStream Smart Box",
    "Device": "hsw4026atl",
    "Model": "hsw4026atl"
  },
  {
    "Retail Branding": "Airtel",
    "Marketing Name": "Xstream4_AR",
    "Device": "VIP7220SIAI",
    "Model": "Xstream4_AR"
  },
  {
    "Retail Branding": "Airtel",
    "Marketing Name": "XstreamIPTV1",
    "Device": "UIW4078ATL",
    "Model": "XstreamIPTV1-VT"
  },
  {
    "Retail Branding": "Airtel-Xstream",
    "Marketing Name": "XstreamIPTV2-SM",
    "Device": "ASD6101SR",
    "Model": "XstreamIPTV2-SM"
  },
  {
    "Retail Branding": "Aisino",
    "Marketing Name": "A99",
    "Device": "A99",
    "Model": "A99"
  },
  {
    "Retail Branding": "Aiuto",
    "Marketing Name": "AT1001",
    "Device": "AT1001",
    "Model": "AT1001"
  },
  {
    "Retail Branding": "Aiuto",
    "Marketing Name": "AT1002",
    "Device": "AT1002",
    "Model": "AT1002"
  },
  {
    "Retail Branding": "Aiuto",
    "Marketing Name": "AT701",
    "Device": "AT701",
    "Model": "AT701"
  },
  {
    "Retail Branding": "Aiuto",
    "Marketing Name": "AT702",
    "Device": "AT702",
    "Model": "AT702"
  },
  {
    "Retail Branding": "Aiwa",
    "Marketing Name": "A81",
    "Device": "AIWA_A81",
    "Model": "A81"
  },
  {
    "Retail Branding": "Aiwa",
    "Marketing Name": "A8_LTE",
    "Device": "A8_LTE",
    "Model": "A8_LTE"
  },
  {
    "Retail Branding": "Aiwa",
    "Marketing Name": "AIWA",
    "Device": "elliniko",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "Aiwa",
    "Marketing Name": "AIWA",
    "Device": "elliniko",
    "Model": "AIWA 4K SMART TV"
  },
  {
    "Retail Branding": "Aiwa",
    "Marketing Name": "AIWA",
    "Device": "hongkong",
    "Model": "AIWA 4K GOOGLE TV"
  },
  {
    "Retail Branding": "Aiwa",
    "Marketing Name": "AIWA",
    "Device": "lavender",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "Aiwa",
    "Marketing Name": "AIWA",
    "Device": "stanford",
    "Model": "SMART TV"
  },
  {
    "Retail Branding": "Aiwa",
    "Marketing Name": "AIWA",
    "Device": "zhongshan",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "Aiwa",
    "Marketing Name": "AIWA 2K TV",
    "Device": "shinagawa",
    "Model": "AIWA 2K TV"
  },
  {
    "Retail Branding": "Aiwa",
    "Marketing Name": "AIWA FHD SMART TV",
    "Device": "umeda",
    "Model": "AIWA FHD SMART TV"
  },
  {
    "Retail Branding": "Aiwa",
    "Marketing Name": "AIWA TV",
    "Device": "SW6H",
    "Model": "AIWA TV"
  },
  {
    "Retail Branding": "Aiwa",
    "Marketing Name": "AIWA TV",
    "Device": "SW6H",
    "Model": "AIWA UHD SMART TV"
  },
  {
    "Retail Branding": "Aiwa",
    "Marketing Name": "AIWA UHD SMART TV",
    "Device": "SW6H",
    "Model": "AIWA UHD SMART TV"
  },
  {
    "Retail Branding": "Aiwa",
    "Marketing Name": "AIWA UHD SMART TV FF",
    "Device": "SW6H",
    "Model": "AIWA UHD SMART TV FF"
  },
  {
    "Retail Branding": "Aiwa",
    "Marketing Name": "AW-P",
    "Device": "AW-P",
    "Model": "AW-P"
  },
  {
    "Retail Branding": "Aiwa",
    "Marketing Name": "AW790",
    "Device": "AW790",
    "Model": "AW790"
  },
  {
    "Retail Branding": "Aiwa",
    "Marketing Name": "AWM501",
    "Device": "AWM501",
    "Model": "AWM501"
  },
  {
    "Retail Branding": "Aiwa",
    "Marketing Name": "AWM509",
    "Device": "AWM509",
    "Model": "AWM509"
  },
  {
    "Retail Branding": "Aiwa",
    "Marketing Name": "AWM539",
    "Device": "AWM539",
    "Model": "AWM539"
  },
  {
    "Retail Branding": "Aiwa",
    "Marketing Name": "AWM561",
    "Device": "AWM561",
    "Model": "AWM561"
  },
  {
    "Retail Branding": "Aiwa",
    "Marketing Name": "AWM580",
    "Device": "AWM580",
    "Model": "AWM580"
  },
  {
    "Retail Branding": "Aiwa",
    "Marketing Name": "AWM599",
    "Device": "AWM599",
    "Model": "AWM599"
  },
  {
    "Retail Branding": "Aiwa",
    "Marketing Name": "AWM999",
    "Device": "AWM999",
    "Model": "AWM999"
  },
  {
    "Retail Branding": "Aiwa",
    "Marketing Name": "AWPM106A",
    "Device": "AWPM106A",
    "Model": "AWPM106A"
  },
  {
    "Retail Branding": "Aiwa",
    "Marketing Name": "AWPM108T",
    "Device": "AWPM108T",
    "Model": "AWPM108T"
  },
  {
    "Retail Branding": "Aiwa",
    "Marketing Name": "AWPP101AW",
    "Device": "AWPP101AW",
    "Model": "AWPP101AK"
  },
  {
    "Retail Branding": "Aiwa",
    "Marketing Name": "AWPP101AW",
    "Device": "AWPP101AW",
    "Model": "AWPP101AW"
  },
  {
    "Retail Branding": "Aiwa",
    "Marketing Name": "AWPP86AW",
    "Device": "AWPP86AW",
    "Model": "AWPP86AW"
  },
  {
    "Retail Branding": "Aiwa",
    "Marketing Name": "AWT10H",
    "Device": "AWT10H",
    "Model": "AWT10H"
  },
  {
    "Retail Branding": "Aiwa",
    "Marketing Name": "AW_TAB10_14",
    "Device": "AW_TAB10_14",
    "Model": "AW_TAB10_14"
  },
  {
    "Retail Branding": "Aiwa",
    "Marketing Name": "Aiwa",
    "Device": "KSTB6043",
    "Model": "KSTB6043"
  },
  {
    "Retail Branding": "Aiwa",
    "Marketing Name": "Aiwa",
    "Device": "hongkong",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "Aiwa",
    "Marketing Name": "Aiwa",
    "Device": "mountbaker",
    "Model": "2K SMART TV"
  },
  {
    "Retail Branding": "Aiwa",
    "Marketing Name": "Aiwa",
    "Device": "mountbaker",
    "Model": "AIWA 2K SMART TV"
  },
  {
    "Retail Branding": "Aiwa",
    "Marketing Name": "Android TV",
    "Device": "ikebukuro",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "Aiwa",
    "Marketing Name": "Android TV",
    "Device": "samseong",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "Aiwa",
    "Marketing Name": "Android TV",
    "Device": "sindorim",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "Aiwa",
    "Marketing Name": "JA2-SMP0601",
    "Device": "JA2-SMP0601",
    "Model": "JA2-SMP0601"
  },
  {
    "Retail Branding": "Aiwa",
    "Marketing Name": "JA2-TBA0801",
    "Device": "JA2-TBA0801",
    "Model": "JA2-TBA0801"
  },
  {
    "Retail Branding": "Aiwa",
    "Marketing Name": "JA2-TBA1001",
    "Device": "JA2-TBA1001",
    "Model": "JA2-TBA1001"
  },
  {
    "Retail Branding": "Aiwa",
    "Marketing Name": "JA2-TBA1002",
    "Device": "JA2-TBA1002",
    "Model": "JA2-TBA1002"
  },
  {
    "Retail Branding": "Aiwa",
    "Marketing Name": "JA3-SMP0602",
    "Device": "JA3-SMP0602",
    "Model": "JA3-SMP0602"
  },
  {
    "Retail Branding": "Aiwa",
    "Marketing Name": "JA3-TBA0802",
    "Device": "JA3-TBA0802",
    "Model": "JA3-TBA0802"
  },
  {
    "Retail Branding": "Aiwa",
    "Marketing Name": "JA3-TBA1005",
    "Device": "JA3-TBA1005",
    "Model": "JA3-TBA1005"
  },
  {
    "Retail Branding": "Aiwa",
    "Marketing Name": "JA3-TBA1006-4",
    "Device": "JA3-TBA1006-4",
    "Model": "JA3-TBA1006-4"
  },
  {
    "Retail Branding": "Aiwa",
    "Marketing Name": "JA3-TBA1006-6",
    "Device": "JA3-TBA1006-6",
    "Model": "JA3-TBA1006-6"
  },
  {
    "Retail Branding": "Aiwa",
    "Marketing Name": "JA3-TBA1007",
    "Device": "JA3-TBA1007",
    "Model": "JA3-TBA1007"
  },
  {
    "Retail Branding": "Aiwa",
    "Marketing Name": "JA4-TBA0803",
    "Device": "JA4-TBA0803",
    "Model": "JA4-TBA0803"
  },
  {
    "Retail Branding": "Aiwa",
    "Marketing Name": "JA4-TBA1008",
    "Device": "JA4-TBA1008",
    "Model": "JA4-TBA1008"
  },
  {
    "Retail Branding": "Aiwa",
    "Marketing Name": "JA4-TBA1009",
    "Device": "JA4-TBA1009",
    "Model": "JA4-TBA1009"
  },
  {
    "Retail Branding": "Aiwa",
    "Marketing Name": "JA4-TBA1101",
    "Device": "JA4-TBA1101",
    "Model": "JA4-TBA1101"
  },
  {
    "Retail Branding": "Aiwa",
    "Marketing Name": "JA5-TBA1011",
    "Device": "JA5-TBA1011",
    "Model": "JA5-TBA1011"
  },
  {
    "Retail Branding": "Aiwa",
    "Marketing Name": "JA5-TBA1012",
    "Device": "JA5-TBA1012",
    "Model": "JA5-TBA1012"
  },
  {
    "Retail Branding": "Aiwa",
    "Marketing Name": "JA5-TBA1102",
    "Device": "JA5-TBA1102",
    "Model": "JA5-TBA1102"
  },
  {
    "Retail Branding": "Aiwa",
    "Marketing Name": "JA5-TBA1201",
    "Device": "JA5-TBA1201",
    "Model": "JA5-TBA1201"
  },
  {
    "Retail Branding": "Aiwa",
    "Marketing Name": "R3",
    "Device": "R3",
    "Model": "R3"
  },
  {
    "Retail Branding": "Aiwa",
    "Marketing Name": "R4",
    "Device": "R4",
    "Model": "R4"
  },
  {
    "Retail Branding": "Aiwa",
    "Marketing Name": "Smart TV",
    "Device": "alimos",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "Aiwa",
    "Marketing Name": "Smart TV",
    "Device": "dangni",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "Aiwa",
    "Marketing Name": "Smart TV",
    "Device": "longshan",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "Aiwa",
    "Marketing Name": "Smart TV",
    "Device": "osaka",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "Aiwa",
    "Marketing Name": "Smart TV",
    "Device": "osaka",
    "Model": "AI PONT CO"
  },
  {
    "Retail Branding": "Aiwa",
    "Marketing Name": "Smart TV",
    "Device": "osaka",
    "Model": "AI PONT NA"
  },
  {
    "Retail Branding": "Aiwa",
    "Marketing Name": "Smart TV",
    "Device": "osaka",
    "Model": "AI PONT SA"
  },
  {
    "Retail Branding": "Aiwa",
    "Marketing Name": "Smart TV",
    "Device": "redwood",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "Aiwa",
    "Marketing Name": "TA-07-232",
    "Device": "TA-07-232",
    "Model": "TA-07-232"
  },
  {
    "Retail Branding": "Aiwa",
    "Marketing Name": "TA-10-232",
    "Device": "TA-10-232",
    "Model": "TA-10-232"
  },
  {
    "Retail Branding": "Aiwa",
    "Marketing Name": "TA07-2GB",
    "Device": "TA07-2GB",
    "Model": "TA07-2GB"
  },
  {
    "Retail Branding": "Aiwa",
    "Marketing Name": "TA10-SO10",
    "Device": "TA10-SO10",
    "Model": "TA10-SO10"
  },
  {
    "Retail Branding": "Aiwa",
    "Marketing Name": "TAB-1100",
    "Device": "TAB-1100",
    "Model": "TAB-1100"
  },
  {
    "Retail Branding": "Aiwa",
    "Marketing Name": "TAB-1102",
    "Device": "TAB-1102",
    "Model": "TAB-1102"
  },
  {
    "Retail Branding": "Aiwa",
    "Marketing Name": "TAB-1103",
    "Device": "TAB-1103",
    "Model": "TAB-1103"
  },
  {
    "Retail Branding": "Aiwa",
    "Marketing Name": "TABLETAWTH801",
    "Device": "TABLETAWTH801",
    "Model": "AWTH801"
  },
  {
    "Retail Branding": "Aiwa",
    "Marketing Name": "TAB_1003G",
    "Device": "TAB_1003G",
    "Model": "TAB_1003G"
  },
  {
    "Retail Branding": "Aiwa",
    "Marketing Name": "Z9",
    "Device": "AIWA_Z9",
    "Model": "Z9"
  },
  {
    "Retail Branding": "Aiwa",
    "Marketing Name": "Z9 PLUS",
    "Device": "AIWA_Z9_PLUS",
    "Model": "Z9 PLUS"
  },
  {
    "Retail Branding": "Akai",
    "Marketing Name": "AKAI",
    "Device": "bangbae",
    "Model": "AKAI 4K Android TV"
  },
  {
    "Retail Branding": "Akai",
    "Marketing Name": "AKAI",
    "Device": "stanford",
    "Model": "2K SMART TV"
  },
  {
    "Retail Branding": "Akai",
    "Marketing Name": "AKAI 4K SMART TV",
    "Device": "SW6H",
    "Model": "AKAI 4K SMART TV"
  },
  {
    "Retail Branding": "Akai",
    "Marketing Name": "AKAI 4K SMART TV",
    "Device": "anaheim",
    "Model": "AKAI 4K SMART TV"
  },
  {
    "Retail Branding": "Akai",
    "Marketing Name": "AKAI SMART TV",
    "Device": "umeda",
    "Model": "AKAI  SMART TV"
  },
  {
    "Retail Branding": "Akai",
    "Marketing Name": "FZ101",
    "Device": "FZ101",
    "Model": "FZ101"
  },
  {
    "Retail Branding": "Akai",
    "Marketing Name": "FZ701",
    "Device": "FZ701",
    "Model": "FZ701"
  },
  {
    "Retail Branding": "Akai",
    "Marketing Name": "FZ702",
    "Device": "FZ702",
    "Model": "FZ702"
  },
  {
    "Retail Branding": "Akai",
    "Marketing Name": "FZ703",
    "Device": "FZ703",
    "Model": "FZ703"
  },
  {
    "Retail Branding": "Akai",
    "Marketing Name": "MD1063",
    "Device": "MD1063",
    "Model": "MD1063"
  },
  {
    "Retail Branding": "Akai",
    "Marketing Name": "R3",
    "Device": "R3",
    "Model": "R3"
  },
  {
    "Retail Branding": "Akai",
    "Marketing Name": "SP5504G",
    "Device": "SP5504G",
    "Model": "SP5504G"
  },
  {
    "Retail Branding": "Akari",
    "Marketing Name": "AX-115ATV",
    "Device": "DV8035",
    "Model": "AX-115ATV"
  },
  {
    "Retail Branding": "Akari",
    "Marketing Name": "AX-117ATV",
    "Device": "DV8219",
    "Model": "AX-117ATV"
  },
  {
    "Retail Branding": "Akino",
    "Marketing Name": "IN-32SE9",
    "Device": "shibuya",
    "Model": "AkinoTV"
  },
  {
    "Retail Branding": "Akino",
    "Marketing Name": "fushan_akino",
    "Device": "hamamatsucho",
    "Model": "Smart TV"
  },
  {
    "Retail Branding": "Akino",
    "Marketing Name": "laoshan-Akino",
    "Device": "laoshan",
    "Model": "HAT4KDTV"
  },
  {
    "Retail Branding": "Alba",
    "Marketing Name": "ALBA 7 TABLET",
    "Device": "ac70plv6",
    "Model": "ALBA 7 TABLET"
  },
  {
    "Retail Branding": "Alba",
    "Marketing Name": "Alba 4G Plus",
    "Device": "ac57crs",
    "Model": "Alba 4G Plus"
  },
  {
    "Retail Branding": "Alba",
    "Marketing Name": "Alba 6",
    "Device": "ac60crs",
    "Model": "Alba 6"
  },
  {
    "Retail Branding": "Alba",
    "Marketing Name": "Alba10Nou",
    "Device": "Alba10Nou",
    "Model": "Alba10Nou"
  },
  {
    "Retail Branding": "Alba",
    "Marketing Name": "Alba10Pie",
    "Device": "Alba10Pie",
    "Model": "Alba10Pie"
  },
  {
    "Retail Branding": "Alba",
    "Marketing Name": "Alba10Q",
    "Device": "Alba10Q",
    "Model": "Alba10Q"
  },
  {
    "Retail Branding": "Alba",
    "Marketing Name": "Alba7Nou",
    "Device": "Alba7Nou",
    "Model": "Alba7Nou"
  },
  {
    "Retail Branding": "Alba",
    "Marketing Name": "Alba7Pie",
    "Device": "Alba7Pie",
    "Model": "Alba7Pie"
  },
  {
    "Retail Branding": "Alba",
    "Marketing Name": "Alba7Q",
    "Device": "Alba7Q",
    "Model": "Alba7Q"
  },
  {
    "Retail Branding": "Alba",
    "Marketing Name": "Alba8Nou",
    "Device": "Alba8Nou",
    "Model": "Alba8Nou"
  },
  {
    "Retail Branding": "Alba",
    "Marketing Name": "Alba8Pie",
    "Device": "Alba8Pie",
    "Model": "Alba8Pie"
  },
  {
    "Retail Branding": "Alba",
    "Marketing Name": "Alba_8in",
    "Device": "Alba_8in",
    "Model": "Alba_8in"
  },
  {
    "Retail Branding": "Alco",
    "Marketing Name": "Alco S9",
    "Device": "Alco_S9",
    "Model": "Alco_S9"
  },
  {
    "Retail Branding": "Alco",
    "Marketing Name": "CT302T",
    "Device": "CT302T",
    "Model": "CT302T"
  },
  {
    "Retail Branding": "Alco",
    "Marketing Name": "RCT6613W23PG",
    "Device": "RCT6613W23PG",
    "Model": "RCT6613W23PG"
  },
  {
    "Retail Branding": "Alco",
    "Marketing Name": "VCT9B06Q23EU_eea",
    "Device": "VCT9B06Q23EU",
    "Model": "VCT9B06Q23EU"
  },
  {
    "Retail Branding": "Alco",
    "Marketing Name": "VCT9T48Q34",
    "Device": "VCT9T48Q34",
    "Model": "VCT9T48Q34"
  },
  {
    "Retail Branding": "Alco",
    "Marketing Name": "Voyager Pro",
    "Device": "RCT6873W42BMF8KC",
    "Model": "RCT6873W42BMF8KC"
  },
  {
    "Retail Branding": "Alcor",
    "Marketing Name": "Alcor",
    "Device": "Access_Q784C",
    "Model": "Access_Q784C"
  },
  {
    "Retail Branding": "Alcor",
    "Marketing Name": "Alcor",
    "Device": "Zest_Q108I",
    "Model": "Zest_Q108I"
  },
  {
    "Retail Branding": "Alcor",
    "Marketing Name": "Alcor",
    "Device": "Zest_Q708I",
    "Model": "Zest_Q708I"
  },
  {
    "Retail Branding": "Alcor",
    "Marketing Name": "Comet_O118LR",
    "Device": "Comet_O118LR",
    "Model": "Comet_O118LR"
  },
  {
    "Retail Branding": "Aldo Mobile",
    "Marketing Name": "S12",
    "Device": "S12",
    "Model": "S12"
  },
  {
    "Retail Branding": "Aldo Mobile",
    "Marketing Name": "T10S",
    "Device": "T10S",
    "Model": "T10S"
  },
  {
    "Retail Branding": "Aldo Mobile",
    "Marketing Name": "T7Q-4G",
    "Device": "T7Q-4G",
    "Model": "T7Q-4G"
  },
  {
    "Retail Branding": "Aldo Mobile",
    "Marketing Name": "T8S",
    "Device": "T8S",
    "Model": "T8S"
  },
  {
    "Retail Branding": "Algar",
    "Marketing Name": "GIU6770",
    "Device": "GIU6770",
    "Model": "GIU6770"
  },
  {
    "Retail Branding": "Algerie Telecom",
    "Marketing Name": "TwinBox 4k",
    "Device": "SEI700DA",
    "Model": "TwinBox 4k"
  },
  {
    "Retail Branding": "Alhafidh",
    "Marketing Name": "Android TV",
    "Device": "R1",
    "Model": "ATV R1"
  },
  {
    "Retail Branding": "Alhafidh",
    "Marketing Name": "Android TV",
    "Device": "R2",
    "Model": "ATV R2"
  },
  {
    "Retail Branding": "Alhafidh",
    "Marketing Name": "R10G",
    "Device": "R10G",
    "Model": "R10G"
  },
  {
    "Retail Branding": "Alhafidh",
    "Marketing Name": "R3",
    "Device": "R3",
    "Model": "R3"
  },
  {
    "Retail Branding": "Alhafidh",
    "Marketing Name": "R3_GTV",
    "Device": "R3_GTV",
    "Model": "R3G"
  },
  {
    "Retail Branding": "Alhafidh",
    "Marketing Name": "R4",
    "Device": "R4",
    "Model": "R4"
  },
  {
    "Retail Branding": "Alhafidh",
    "Marketing Name": "R4_GTV",
    "Device": "R4_GTV",
    "Model": "R4G"
  },
  {
    "Retail Branding": "Alhafidh",
    "Marketing Name": "vileparle",
    "Device": "vileparle",
    "Model": "R6G"
  },
  {
    "Retail Branding": "Aligator",
    "Marketing Name": "\\'Aligator_S5550",
    "Device": "Aligator_S5550",
    "Model": "Aligator_S5550"
  },
  {
    "Retail Branding": "Aligator",
    "Marketing Name": "ALIGATOR RX800",
    "Device": "ALIGATOR_RX800",
    "Model": "ALIGATOR RX800"
  },
  {
    "Retail Branding": "Aligator",
    "Marketing Name": "ALIGATOR S5070",
    "Device": "ALIGATOR_S5070",
    "Model": "ALIGATOR S5070"
  },
  {
    "Retail Branding": "Aligator",
    "Marketing Name": "ALIGATOR S5520",
    "Device": "ALIGATOR_S5520",
    "Model": "ALIGATOR_S5520"
  },
  {
    "Retail Branding": "Aligator",
    "Marketing Name": "ALIGATOR S5540",
    "Device": "ALIGATOR_S5540",
    "Model": "ALIGATOR S5540"
  },
  {
    "Retail Branding": "Aligator",
    "Marketing Name": "ALIGATOR S6000",
    "Device": "ALIGATOR_S6000",
    "Model": "ALIGATOR S6000"
  },
  {
    "Retail Branding": "Aligator",
    "Marketing Name": "ALIGATOR S6500",
    "Device": "ALIGATOR_S6500",
    "Model": "ALIGATOR S6500"
  },
  {
    "Retail Branding": "Aligator",
    "Marketing Name": "ALIGATOR_RX710_EEA",
    "Device": "ALIGATOR_RX710",
    "Model": "ALIGATOR RX710"
  },
  {
    "Retail Branding": "Aligator",
    "Marketing Name": "Aligator S5066",
    "Device": "Aligator_S5066",
    "Model": "Aligator_S5066"
  },
  {
    "Retail Branding": "Aligator",
    "Marketing Name": "Aligator_S6100",
    "Device": "Aligator_S6100",
    "Model": "Aligator_S6100"
  },
  {
    "Retail Branding": "Aligator",
    "Marketing Name": "Aligator_S6550",
    "Device": "Aligator_S6550",
    "Model": "Aligator_S6550"
  },
  {
    "Retail Branding": "Aligator",
    "Marketing Name": "Aligator_S6600",
    "Device": "Aligator_S6600",
    "Model": "Aligator_S6600"
  },
  {
    "Retail Branding": "Aligator",
    "Marketing Name": "Aligator_S6700",
    "Device": "Aligator_S6700",
    "Model": "Aligator_S6700"
  },
  {
    "Retail Branding": "Aligator",
    "Marketing Name": "Aligator_S8000",
    "Device": "Aligator_S8000",
    "Model": "Aligator S8000"
  },
  {
    "Retail Branding": "Aligator",
    "Marketing Name": "RX460",
    "Device": "RX460",
    "Model": "RX460"
  },
  {
    "Retail Branding": "Aligator",
    "Marketing Name": "RX600",
    "Device": "RX600",
    "Model": "RX600"
  },
  {
    "Retail Branding": "Aligator",
    "Marketing Name": "RX700",
    "Device": "RX700",
    "Model": "RX700"
  },
  {
    "Retail Branding": "Aligator",
    "Marketing Name": "RX850",
    "Device": "RX850",
    "Model": "ALIGATOR RX850"
  },
  {
    "Retail Branding": "Aligator",
    "Marketing Name": "S4090",
    "Device": "S4090",
    "Model": "S4090"
  },
  {
    "Retail Branding": "Aligator",
    "Marketing Name": "S5065",
    "Device": "ALIGATORS5065",
    "Model": "ALIGATOR S5065"
  },
  {
    "Retail Branding": "Aligator",
    "Marketing Name": "S5068",
    "Device": "S5068",
    "Model": "S5068"
  },
  {
    "Retail Branding": "Aligator",
    "Marketing Name": "S5710",
    "Device": "S5710",
    "Model": "S5710"
  },
  {
    "Retail Branding": "Alited",
    "Marketing Name": "PA650",
    "Device": "PA650",
    "Model": "PA650"
  },
  {
    "Retail Branding": "AllCall",
    "Marketing Name": "AllCall_Madrid",
    "Device": "AllCall_Madrid",
    "Model": "AllCall_Madrid"
  },
  {
    "Retail Branding": "AllCall",
    "Marketing Name": "AllCall_S1",
    "Device": "AllCall_S1",
    "Model": "AllCall_S1"
  },
  {
    "Retail Branding": "AllCall",
    "Marketing Name": "AllCall_S1_X",
    "Device": "AllCall_S1_X",
    "Model": "AllCall_S1_X"
  },
  {
    "Retail Branding": "AllCall",
    "Marketing Name": "HERO_20",
    "Device": "HERO_20",
    "Model": "HERO 20"
  },
  {
    "Retail Branding": "AllCall",
    "Marketing Name": "HERO_20_PRO",
    "Device": "HERO_20_PRO",
    "Model": "HERO_20_PRO"
  },
  {
    "Retail Branding": "AllCall",
    "Marketing Name": "MIX2",
    "Device": "MIX2",
    "Model": "MIX2"
  },
  {
    "Retail Branding": "AllCall",
    "Marketing Name": "Rio_X",
    "Device": "Rio_X",
    "Model": "Rio_X"
  },
  {
    "Retail Branding": "AllCall",
    "Marketing Name": "S10",
    "Device": "S10",
    "Model": "S10"
  },
  {
    "Retail Branding": "AllCall",
    "Marketing Name": "S5500",
    "Device": "S5500",
    "Model": "S5500"
  },
  {
    "Retail Branding": "AllCall",
    "Marketing Name": "Tab_1_3G",
    "Device": "Tab_1_3G",
    "Model": "Tab_1_3G"
  },
  {
    "Retail Branding": "AllCall",
    "Marketing Name": "Tab_2_3G",
    "Device": "Tab_2_3G",
    "Model": "Tab_2_3G"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "A10 Lite",
    "Device": "A10_Lite",
    "Model": "A10_Lite"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "A10 Lite 2019",
    "Device": "A10_Lite_2019",
    "Model": "A10_Lite_2019"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "A10 Lite 2GB",
    "Device": "A10_Lite_2GB",
    "Model": "A10_Lite_2GB"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "A10 Max",
    "Device": "A10_Max",
    "Model": "A10_Max"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "A10 Plus",
    "Device": "A10_Plus",
    "Model": "A10_Plus"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "A20 Lite",
    "Device": "A20_Lite",
    "Model": "A20_Lite"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "A20 Max",
    "Device": "A20_Max",
    "Model": "A20_Max"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "A30 MAX",
    "Device": "A30_Max",
    "Model": "A30_Max"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "A30_Plus",
    "Device": "A30_Plus",
    "Model": "A30_Plus"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "A5 Easy",
    "Device": "A5_Easy",
    "Model": "A5_Easy"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "A5 Easy",
    "Device": "A5_Easy",
    "Model": "A5_Easy_TM"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "A5 Lite",
    "Device": "A5_Lite",
    "Model": "A5_Lite"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "A5 Quad Plus",
    "Device": "A5_Quad_Plus",
    "Model": "A5_Quad_Plus"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "A5 Quad Plus",
    "Device": "A5_Quad_Plus",
    "Model": "A5_Quad_Plus_TM"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "A5 Ready",
    "Device": "A5_Ready",
    "Model": "A5_Ready"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "A5 Ready",
    "Device": "A5_Ready",
    "Model": "A5_Ready_TM"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "A6 Duo",
    "Device": "A6_Duo",
    "Model": "A6_Duo"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "A6 Lite",
    "Device": "A6_Lite",
    "Model": "A6_Lite"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "A7 Lite",
    "Device": "A7_Lite",
    "Model": "A7_Lite"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "A8 Lite",
    "Device": "A8_Lite",
    "Model": "A8_Lite"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "A8 Lite TM",
    "Device": "A8_Lite",
    "Model": "A8_Lite_TM"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "A9  Plus",
    "Device": "A9_Plus",
    "Model": "A9_Plus"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "A9 Lite",
    "Device": "A9_Lite",
    "Model": "A9_Lite"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "ALLVIEW",
    "Device": "bangbae",
    "Model": "ALLVIEW 4K Android TV"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "ALLVIEW 4K TV",
    "Device": "SW4H_FF",
    "Model": "ALLVIEW 4K TV"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "ALLVIEW eplay  2KTV",
    "Device": "umeda",
    "Model": "ALLVIEW eplay  2KTV"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "ALLVIEW eplay  4KTV",
    "Device": "SW6H",
    "Model": "ALLVIEW eplay 4KTV"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "ALLVIEW eplay  4KTV FF",
    "Device": "SW6H",
    "Model": "ALLVIEW eplay 4KTV FF"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "AX4 Nano Plus",
    "Device": "AX4Nano_plus",
    "Model": "AX4Nano_plus"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "AX501Q",
    "Device": "AX501Q",
    "Model": "AX501Q"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "AX502",
    "Device": "AX502",
    "Model": "AX502"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "AX503",
    "Device": "AX503",
    "Model": "AX503"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "AX503",
    "Device": "AX503_Q",
    "Model": "AX503"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "Allview",
    "Device": "komagome",
    "Model": "ALLVIEW 2K Android TV"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "Allview 2K TV",
    "Device": "shinagawa",
    "Model": "Allview 2K TV"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "C6 Duo",
    "Device": "C6_Duo",
    "Model": "C6_Duo"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "C6 Quad 4G",
    "Device": "C6_Quad_4G",
    "Model": "C6Quad_4G"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "E2 Jump",
    "Device": "ALLVIEW_E2_Jump",
    "Model": "E2_Jump"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "E3 Jump",
    "Device": "E3_Jump",
    "Model": "E3_Jump"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "E3 Living",
    "Device": "E3_Living",
    "Model": "E3_Living"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "E3 Sign",
    "Device": "E3_Sign",
    "Model": "E3_Sign"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "E4",
    "Device": "E4",
    "Model": "E4"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "E4 Lite",
    "Device": "E4_Lite",
    "Model": "E4_Lite"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "P10 Life",
    "Device": "P10_Life",
    "Model": "P10_Life"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "P10 Max",
    "Device": "P10_Max",
    "Model": "P10_Max"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "P10 Mini",
    "Device": "P10_Mini",
    "Model": "P10_Mini"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "P10 Pro",
    "Device": "P10_Pro",
    "Model": "P10_Pro"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "P10_Style",
    "Device": "P10_Style",
    "Model": "P10_Style"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "P4 Pro",
    "Device": "P4_Pro",
    "Model": "P4_Pro"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "P4 Quad",
    "Device": "P4_Quad",
    "Model": "P4_Quad"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "P4 eMagic",
    "Device": "P4_eMagic",
    "Model": "P4_eMagic"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "P4 eMagic",
    "Device": "P4_eMagic",
    "Model": "P4_eMagic_TM"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "P41 eMagic",
    "Device": "P41_eMagic",
    "Model": "P41_eMagic"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "P41 eMagic",
    "Device": "P41_eMagic",
    "Model": "P41_eMagic_TM"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "P42",
    "Device": "P42",
    "Model": "P42"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "P43 Easy",
    "Device": "P43_Easy",
    "Model": "P43_Easy"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "P5 Energy",
    "Device": "P5_Energy",
    "Model": "P5_Energy"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "P5 Life",
    "Device": "P5Life",
    "Model": "P5Life_TM"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "P5 Lite",
    "Device": "P5_Lite",
    "Model": "P5_Lite"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "P5 Pro",
    "Device": "P5_Pro",
    "Model": "P5_Pro"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "P5 eMagic",
    "Device": "P5_eMagic",
    "Model": "P5_eMagic"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "P5 eMagic",
    "Device": "P5_eMagic",
    "Model": "P5_eMagic_TM"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "P5Life",
    "Device": "P5Life",
    "Model": "P5Life"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "P5_Pro",
    "Device": "P5_Pro",
    "Model": "P5_Pro_TM"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "P6  Plus",
    "Device": "P6_plus",
    "Model": "P6_plus"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "P6 Energy",
    "Device": "P6_Energy",
    "Model": "P6_Energy_TM"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "P6 Energy Lite",
    "Device": "P6_Energy_Lite",
    "Model": "P6_Energy_Lite"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "P6 Energy Lite",
    "Device": "P6_Energy_Lite",
    "Model": "P6_Energy_Lite_TM"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "P6 Energy mini",
    "Device": "P6_Energy_mini",
    "Model": "P6_Energy_mini"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "P6 Life",
    "Device": "P6_Life",
    "Model": "P6_Life"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "P6 Lite",
    "Device": "P6_lite",
    "Model": "P6_lite"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "P6 Lite",
    "Device": "P6_lite",
    "Model": "P6_lite_TM"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "P6 Lite",
    "Device": "P6_lite",
    "Model": "P6_lite_mTEL"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "P6 Pro",
    "Device": "P6_Pro",
    "Model": "P6_Pro"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "P6 Qmax",
    "Device": "P6_Qmax",
    "Model": "P6_Qmax"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "P6 eMagic",
    "Device": "P6_eMagic",
    "Model": "P6_eMagic"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "P6_Energy",
    "Device": "P6_Energy",
    "Model": "P6_Energy"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "P7 Lite",
    "Device": "P7_Lite",
    "Model": "P7_Lite"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "P7 Lite",
    "Device": "P7_Lite",
    "Model": "P7_Lite_TM"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "P7 PRO",
    "Device": "P7_PRO",
    "Model": "P7_PRO"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "P7 PRO_TM",
    "Device": "P7_PRO",
    "Model": "P7_PRO_TM"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "P8 Energy",
    "Device": "P8_Energy",
    "Model": "P8_Energy"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "P8 Energy Pro",
    "Device": "P8_Energy_PRO",
    "Model": "P8_Energy_PRO"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "P8 Energy mini",
    "Device": "P8_Energy_mini",
    "Model": "P8_Energy_mini"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "P8 Energy mini",
    "Device": "P8_Energy_mini",
    "Model": "P8_Energy_mini_TM"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "P8 Life",
    "Device": "P8_Life",
    "Model": "P8_Life"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "P8 Pro",
    "Device": "P8_PRO",
    "Model": "P8_PRO"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "P8 eMagic",
    "Device": "P8_eMagic",
    "Model": "P8_eMagic"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "P8 eMagic",
    "Device": "P8_eMagic",
    "Model": "P8_eMagic_TM"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "P9 Energy",
    "Device": "P9_Energy",
    "Model": "P9_Energy"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "P9 Energy Lite",
    "Device": "P9_Energy_Lite",
    "Model": "P9_Energy_Lite"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "P9 Energy Lite 2017",
    "Device": "P9_Energy_Lite_2017",
    "Model": "P9_Energy_Lite_2017"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "P9 Energy Mini",
    "Device": "P9_Energy_mini",
    "Model": "P9_Energy_mini_TM"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "P9 Energy S",
    "Device": "P9_Energy_S",
    "Model": "P9_Energy_S"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "P9 Energy mini",
    "Device": "P9_Energy_mini",
    "Model": "P9_Energy_mini"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "P9 Life",
    "Device": "P9_Life",
    "Model": "P9_Life"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "P9_Life_TM",
    "Device": "P9_Life",
    "Model": "P9_Life_TM"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "Prime_H201_LTE_EEA",
    "Device": "Prime_H201_LTE",
    "Model": "Prime_H201_LTE"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "V1 Viper E",
    "Device": "V1_Viper_E",
    "Model": "V1_Viper_E"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "V1 Viper I4G",
    "Device": "V1_Viper_I4G",
    "Model": "V1_Viper_I4G"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "V1 Viper I4G",
    "Device": "V1_Viper_I4G",
    "Model": "V1_Viper_I4G_PL"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "V1 Viper I4G",
    "Device": "V1_Viper_I4G",
    "Model": "V1_Viper_I4G_TM"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "V1 Viper I4G",
    "Device": "V1_Viper_I4G_PL",
    "Model": "V1_Viper_I4G_PL"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "V1 Viper L",
    "Device": "V1_Viper_L",
    "Model": "V1_Viper_L"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "V1 Viper S4G",
    "Device": "V1_Viper_S4G",
    "Model": "V1_Viper_S4G"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "V10 Viper",
    "Device": "V10_Viper",
    "Model": "V10_Viper"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "V10 Viper Lite",
    "Device": "V10_Viper_Lite",
    "Model": "V10_Viper_Lite"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "V2 Viper",
    "Device": "V2_Viper",
    "Model": "V2_Viper"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "V2 Viper E",
    "Device": "V2_Viper_E",
    "Model": "V2_Viper_E"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "V2 Viper I",
    "Device": "V2_Viper_I",
    "Model": "V2_Viper_I"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "V2 Viper I",
    "Device": "V2_Viper_I",
    "Model": "V2_Viper_I_TM"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "V2 Viper I4G",
    "Device": "V2_Viper_I4G",
    "Model": "V2_Viper_I4G"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "V2 Viper S",
    "Device": "V2_Viper_S",
    "Model": "V2_Viper_S"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "V2 Viper X",
    "Device": "V2_Viper_X",
    "Model": "V2_Viper_X"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "V2 Viper X plus",
    "Device": "V2_Viper_X_plus",
    "Model": "V2_Viper_X_plus"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "V2 Viper Xe",
    "Device": "V2_Viper_Xe",
    "Model": "V2_Viper_Xe"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "V3 Viper",
    "Device": "V3_Viper",
    "Model": "V3_Viper"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "V4 Viper",
    "Device": "V4_Viper",
    "Model": "V4_Viper"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "V4 Viper PRO",
    "Device": "V4_Viper_PRO",
    "Model": "V4_Viper_PRO"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "V5 Viper",
    "Device": "V5_Viper",
    "Model": "V5_Viper"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "Viva  H1003 LTE",
    "Device": "Viva_H1003_LTE",
    "Model": "Viva_H1003_LTE"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "Viva 1001G",
    "Device": "Viva_1001G",
    "Model": "Viva_1001G"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "Viva 1003G",
    "Device": "Viva_1003G",
    "Model": "Viva_1003G"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "Viva 1003G Lite",
    "Device": "Viva_1003G_Lite",
    "Model": "Viva_1003G_Lite"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "Viva 1003G Lite",
    "Device": "Viva_1003G_Lite_Q",
    "Model": "Viva_1003G_Lite"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "Viva 803G",
    "Device": "Viva_803G",
    "Model": "Viva_803G"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "Viva C1004",
    "Device": "C1004",
    "Model": "C1004"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "Viva C701",
    "Device": "Viva_C701",
    "Model": "Viva_C701"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "Viva C702",
    "Device": "Viva_C702",
    "Model": "Viva_C702"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "Viva C703",
    "Device": "Viva_C703",
    "Model": "Viva_C703"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "Viva C703",
    "Device": "Viva_C703_Q",
    "Model": "Viva_C703"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "Viva H10 LTE",
    "Device": "Allview_VivaH10LTE_KK",
    "Model": "VivaH10LTE"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "Viva H1001 LTE",
    "Device": "Viva_H1001_LTE",
    "Model": "Viva_H1001_LTE"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "Viva H1002 LTE",
    "Device": "Viva_H1002_LTE",
    "Model": "Viva_H1002_LTE"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "Viva H1003 LTE PRO",
    "Device": "H1003_LTE_PRO",
    "Model": "H1003_LTE_PRO"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "Viva H1003 LTE PRO/1",
    "Device": "H1003_LTE_PRO1",
    "Model": "H1003_LTE_PRO1"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "Viva H1003 LTE PRO/1",
    "Device": "H1003_LTE_PRO1_32",
    "Model": "H1003_LTE_PRO1"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "Viva H1003 LTE PRO/1-64GB",
    "Device": "H1003_LTE_PRO1_64",
    "Model": "H1003_LTE_PRO1"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "Viva H1003 LTE PRO/B6",
    "Device": "H1003_LTE_PRO",
    "Model": "H1003_LTE_PRO"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "Viva H1003 LTE PRO3",
    "Device": "H1003_LTE_PRO3",
    "Model": "H1003_LTE_PRO3"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "Viva H1004 LTE",
    "Device": "H1004_LTE",
    "Model": "H1004_LTE"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "Viva H7 LTE",
    "Device": "Allview_VivaH7LTE_KK",
    "Model": "VivaH7LTE"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "Viva H8 LTE",
    "Device": "Allview_VivaH8LTE_KK",
    "Model": "VivaH8LTE"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "Viva H8 Life",
    "Device": "H8_Life",
    "Model": "H8_Life"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "Viva H801",
    "Device": "Viva_H801",
    "Model": "Viva_H801"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "Viva H801 LTE",
    "Device": "Viva_H801_LTE",
    "Model": "Viva_H801_LTE"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "Viva H802 LTE",
    "Device": "Viva_H802_LTE",
    "Model": "Viva_H802_LTE"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "Viva H802 LTE",
    "Device": "Viva_H802_LTE",
    "Model": "Viva_H802_LTE_TM"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "Viva Home",
    "Device": "Viva_Home",
    "Model": "Viva_Home"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "Viva i10HD",
    "Device": "Viva_i10HD",
    "Model": "Viva_i10HD"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "Viva i701G",
    "Device": "Viva_H701_LTE",
    "Model": "Viva_H701_LTE_CZ"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "Viva i701G",
    "Device": "Viva_i701G",
    "Model": "Viva_i701G"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "Viva i701G",
    "Device": "Viva_i701G",
    "Model": "Viva_i701G_TM"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "Viva i7G",
    "Device": "Viva_i7G",
    "Model": "Viva_i7G"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "Viva_H701_LTE",
    "Device": "Viva_H701_LTE",
    "Model": "Viva_H701_LTE"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "Viva_Play_804_EEA",
    "Device": "Viva_Play_804",
    "Model": "Viva_Play_804"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "X10_Soul_EEA",
    "Device": "X10_Soul",
    "Model": "X10_Soul"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "X10_Soul_Lite",
    "Device": "X10_Soul_Lite",
    "Model": "X10_Soul_Lite"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "X2 Soul Lite",
    "Device": "X2_Soul_Lite",
    "Model": "X2_Soul_Lite"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "X2 Soul Lite",
    "Device": "X2_Soul_Lite",
    "Model": "X2_Soul_Lite_TM"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "X2 Soul Mini",
    "Device": "X2_Soul_Mini",
    "Model": "X2_Soul_Mini"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "X2 Soul PRO",
    "Device": "X2_Soul_PRO",
    "Model": "X2_Soul_PRO"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "X2 Soul Style",
    "Device": "X2_Soul_Style",
    "Model": "X2_Soul_Style"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "X2 Soul Style",
    "Device": "X2_Soul_Style",
    "Model": "X2_Soul_Style_TM"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "X2 Soul Style+",
    "Device": "X2_Soul_Style_Plus",
    "Model": "X2_Soul_Style_Plus"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "X2 Soul Xtreme",
    "Device": "X2_Soul_Xtreme",
    "Model": "X2_Soul_Xtreme"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "X20_Soul_EEA",
    "Device": "X20_Soul",
    "Model": "X20_Soul"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "X3 Soul Lite",
    "Device": "X3_Soul_Lite",
    "Model": "X3_Soul_Lite"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "X3 Soul Lite",
    "Device": "X3_Soul_Lite",
    "Model": "X3_Soul_Lite_TM"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "X3 Soul Plus",
    "Device": "X3_Soul_PLUS",
    "Model": "X3_Soul_PLUS"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "X3 Soul Pro",
    "Device": "X3_Soul_PRO",
    "Model": "X3_Soul_PRO"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "X3 Soul Style",
    "Device": "X3_Soul_Style",
    "Model": "X3_Soul_Style"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "X3 Soul mini",
    "Device": "X3_Soul_mini",
    "Model": "X3_Soul_mini"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "X3Soul",
    "Device": "X3_Soul",
    "Model": "X3_Soul"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "X4 Soul",
    "Device": "X4_Soul",
    "Model": "X4_Soul"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "X4 Soul Infinity L",
    "Device": "X4_Soul_Infinity_L",
    "Model": "X4_Soul_Infinity_L"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "X4 Soul Infinity L",
    "Device": "X4_Soul_Infinity_LV",
    "Model": "X4_Soul_Infinity_L"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "X4 Soul Infinity N",
    "Device": "X4_Soul_Infinity_N",
    "Model": "X4_Soul_Infinity_N"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "X4 Soul Infinity N",
    "Device": "X4_Soul_Infinity_NV",
    "Model": "X4_Soul_Infinity_N"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "X4 Soul Infinity Plus",
    "Device": "X4_Soul_Plus",
    "Model": "X4_Soul_Infinity_Plus"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "X4 Soul Infinity S",
    "Device": "X4_Soul_Infinity_S",
    "Model": "X4_Soul_Infinity_S"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "X4 Soul Infinity SV",
    "Device": "X4_Soul_Infinity_SV",
    "Model": "X4_Soul_Infinity_S"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "X4 Soul Infinity Z",
    "Device": "X4_Soul_Infinity_Z",
    "Model": "X4_Soul_Infinity_Z"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "X4 Soul Infinity Z",
    "Device": "X4_Soul_Infinity_ZV",
    "Model": "X4_Soul_Infinity_Z"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "X4 Soul Lite",
    "Device": "X4_Soul_Lite",
    "Model": "X4_Soul_Lite"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "X4 Soul Mini",
    "Device": "X4_Soul_Mini",
    "Model": "X4_Soul_Mini"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "X4 Soul Mini S",
    "Device": "X4_Soul_Mini_S",
    "Model": "X4_Soul_Mini_S"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "X4 Soul Mini S",
    "Device": "X4_Soul_Mini_S",
    "Model": "X4_Soul_Mini_S_TM"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "X4 Soul Style",
    "Device": "X4_Soul_Style",
    "Model": "X4_Soul_Style"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "X4 Soul Vision",
    "Device": "X4_Soul_Vision",
    "Model": "X4_Soul_Vision"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "X4 Soul Xtreme",
    "Device": "X4_Soul_Xtreme",
    "Model": "X4_Soul_Xtreme"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "X5 Soul Mini",
    "Device": "X5_Soul_Mini",
    "Model": "X5_Soul_Mini"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "X5 Soul Pro",
    "Device": "X5_Soul_Pro",
    "Model": "X5_Soul_Pro"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "X5_Soul",
    "Device": "X5_Soul",
    "Model": "X5_Soul"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "X5_Soul_Style",
    "Device": "X5_Soul_Style",
    "Model": "X5_Soul_Style"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "X6 Soul Xtreme",
    "Device": "X6_Soul_Xtreme",
    "Model": "X6_Soul_Xtreme"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "X6 Soul mini",
    "Device": "X6_Soul_mini",
    "Model": "X6_Soul_mini"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "X7 Soul Style",
    "Device": "X7_Soul_Style",
    "Model": "X7_Soul_Style"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "X7_Soul_Pro_EEA",
    "Device": "X7_Soul_Pro",
    "Model": "X7_Soul_Pro"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "X8 PRO",
    "Device": "X8_Soul_Pro",
    "Model": "X8_Soul_Pro"
  },
  {
    "Retail Branding": "AllView",
    "Marketing Name": "X8 Soul Style",
    "Device": "X8_Soul_Style",
    "Model": "X8_Soul_Style"
  },
  {
    "Retail Branding": "Alldocube",
    "Marketing Name": "Kido",
    "Device": "kido",
    "Model": "T818"
  },
  {
    "Retail Branding": "Alldocube",
    "Marketing Name": "KidzPad Pro",
    "Device": "KidzPad_Pro",
    "Model": "T811"
  },
  {
    "Retail Branding": "Alldocube",
    "Marketing Name": "Smile_1",
    "Device": "Smile_1",
    "Model": "T803"
  },
  {
    "Retail Branding": "Alldocube",
    "Marketing Name": "Smile_X",
    "Device": "T1028",
    "Model": "Smile_X"
  },
  {
    "Retail Branding": "Alldocube",
    "Marketing Name": "T1001",
    "Device": "T1001",
    "Model": "T1001"
  },
  {
    "Retail Branding": "Alldocube",
    "Marketing Name": "T1021P",
    "Device": "T1021PM",
    "Model": "T1021P"
  },
  {
    "Retail Branding": "Alldocube",
    "Marketing Name": "T1021T",
    "Device": "T1021T",
    "Model": "T1021T"
  },
  {
    "Retail Branding": "Alldocube",
    "Marketing Name": "T701",
    "Device": "T701",
    "Model": "T701"
  },
  {
    "Retail Branding": "Alldocube",
    "Marketing Name": "T701_X",
    "Device": "T701_X",
    "Model": "T701_X"
  },
  {
    "Retail Branding": "Alldocube",
    "Marketing Name": "T806",
    "Device": "T806",
    "Model": "T806"
  },
  {
    "Retail Branding": "Alldocube",
    "Marketing Name": "T806ME",
    "Device": "T806ME",
    "Model": "T806ME"
  },
  {
    "Retail Branding": "Alldocube",
    "Marketing Name": "U1005",
    "Device": "U1005",
    "Model": "U1005"
  },
  {
    "Retail Branding": "Alldocube",
    "Marketing Name": "U1005E",
    "Device": "U1005E",
    "Model": "U1005E"
  },
  {
    "Retail Branding": "Alldocube",
    "Marketing Name": "U1006",
    "Device": "U1006",
    "Model": "U1006"
  },
  {
    "Retail Branding": "Alldocube",
    "Marketing Name": "U1006E",
    "Device": "U1006E",
    "Model": "U1006E"
  },
  {
    "Retail Branding": "Alldocube",
    "Marketing Name": "U1006H",
    "Device": "U1006H",
    "Model": "U1006H"
  },
  {
    "Retail Branding": "Alldocube",
    "Marketing Name": "U1006HE",
    "Device": "U1006HE",
    "Model": "U1006HE"
  },
  {
    "Retail Branding": "Alldocube",
    "Marketing Name": "U63PLUS",
    "Device": "U63PLUS",
    "Model": "U63PLUS"
  },
  {
    "Retail Branding": "Alldocube",
    "Marketing Name": "X game",
    "Device": "T1023",
    "Model": "X_Game"
  },
  {
    "Retail Branding": "Alldocube",
    "Marketing Name": "iPlay 20P",
    "Device": "T1021P",
    "Model": "iPlay_20P"
  },
  {
    "Retail Branding": "Alldocube",
    "Marketing Name": "iPlay 20S",
    "Device": "T1021",
    "Model": "iPlay20S"
  },
  {
    "Retail Branding": "Alldocube",
    "Marketing Name": "iPlay 40H",
    "Device": "T1020H",
    "Model": "iPlay_40H"
  },
  {
    "Retail Branding": "Alldocube",
    "Marketing Name": "iPlay 50",
    "Device": "T1030",
    "Model": "iPlay_50"
  },
  {
    "Retail Branding": "Alldocube",
    "Marketing Name": "iPlay 50 mini",
    "Device": "iPlay_50_mini",
    "Model": "iPlay 50 mini"
  },
  {
    "Retail Branding": "Alldocube",
    "Marketing Name": "iPlay 50S",
    "Device": "T1029T",
    "Model": "iPlay_50S"
  },
  {
    "Retail Branding": "Alldocube",
    "Marketing Name": "iPlay 60 Pad Pro",
    "Device": "T1201",
    "Model": "T1201"
  },
  {
    "Retail Branding": "Alldocube",
    "Marketing Name": "iPlay 70 Max Pro",
    "Device": "T1308",
    "Model": "iPlay70MaxPro"
  },
  {
    "Retail Branding": "Alldocube",
    "Marketing Name": "iPlay 70 Max Pro 5G",
    "Device": "T1302G",
    "Model": "iPlay70MaxPro5G"
  },
  {
    "Retail Branding": "Alldocube",
    "Marketing Name": "iPlay 70 SE",
    "Device": "T1038",
    "Model": "iPlay70SE"
  },
  {
    "Retail Branding": "Alldocube",
    "Marketing Name": "iPlay 70E",
    "Device": "iPlay70E",
    "Model": "T1160"
  },
  {
    "Retail Branding": "Alldocube",
    "Marketing Name": "iPlay 70E",
    "Device": "iPlay70E",
    "Model": "T1161"
  },
  {
    "Retail Branding": "Alldocube",
    "Marketing Name": "iPlay 8 Pro",
    "Device": "T806MH",
    "Model": "T806MH"
  },
  {
    "Retail Branding": "Alldocube",
    "Marketing Name": "iPlay 8 Pro",
    "Device": "T806MHE",
    "Model": "T806MHE"
  },
  {
    "Retail Branding": "Alldocube",
    "Marketing Name": "iPlay 80 miniUltra",
    "Device": "T880",
    "Model": "iPlay80miniUltra"
  },
  {
    "Retail Branding": "Alldocube",
    "Marketing Name": "iPlay 8T",
    "Device": "T802",
    "Model": "iPlay_8T"
  },
  {
    "Retail Branding": "Alldocube",
    "Marketing Name": "iPlay50",
    "Device": "T1030X",
    "Model": "iPlay50"
  },
  {
    "Retail Branding": "Alldocube",
    "Marketing Name": "iPlay50 Pro",
    "Device": "T1030M",
    "Model": "iPlay50 Pro"
  },
  {
    "Retail Branding": "Alldocube",
    "Marketing Name": "iPlay50 Pro",
    "Device": "T1030M",
    "Model": "iPlay50_Pro"
  },
  {
    "Retail Branding": "Alldocube",
    "Marketing Name": "iPlay50 Upgraded",
    "Device": "T1030T",
    "Model": "iPlay50_Upgraded"
  },
  {
    "Retail Branding": "Alldocube",
    "Marketing Name": "iPlay50S",
    "Device": "T1029TA",
    "Model": "iPlay50S"
  },
  {
    "Retail Branding": "Alldocube",
    "Marketing Name": "iPlay50_Lite",
    "Device": "U1030",
    "Model": "iPlay50_Lite"
  },
  {
    "Retail Branding": "Alldocube",
    "Marketing Name": "iPlay50_Mini_Lite",
    "Device": "U807",
    "Model": "iPlay50_Mini_Lite"
  },
  {
    "Retail Branding": "Alldocube",
    "Marketing Name": "iPlay50_SE",
    "Device": "iPlay50_SE",
    "Model": "iPlay50_SE"
  },
  {
    "Retail Branding": "Alldocube",
    "Marketing Name": "iPlay50_mini_Pro",
    "Device": "iPlay50_mini_Pro",
    "Model": "iPlay50_mini_Pro"
  },
  {
    "Retail Branding": "Alldocube",
    "Marketing Name": "iPlay60_Pro",
    "Device": "iPlay60_Pro",
    "Model": "iPlay60_Pro"
  },
  {
    "Retail Branding": "Alldocube",
    "Marketing Name": "iPlay60_S",
    "Device": "U1033",
    "Model": "iPlay60_S"
  },
  {
    "Retail Branding": "Alldocube",
    "Marketing Name": "iPlay60_S_4G",
    "Device": "iPlay60_S_4G",
    "Model": "iPlay60_S_4G"
  },
  {
    "Retail Branding": "Alldocube",
    "Marketing Name": "iPlay60_mini",
    "Device": "iPlay60_mini",
    "Model": "iPlay60_mini"
  },
  {
    "Retail Branding": "Alldocube",
    "Marketing Name": "iPlay60_mini_Pro",
    "Device": "iPlay60_mini_Pro",
    "Model": "iPlay60_mini_Pro"
  },
  {
    "Retail Branding": "Alldocube",
    "Marketing Name": "iPlay60_mini_Turbo",
    "Device": "U812",
    "Model": "iPlay60 mini Turbo"
  },
  {
    "Retail Branding": "Alldocube",
    "Marketing Name": "iPlay70",
    "Device": "iPlay70",
    "Model": "iPlay70"
  },
  {
    "Retail Branding": "Alldocube",
    "Marketing Name": "iPlay70_S",
    "Device": "iPlay70_S",
    "Model": "iPlay70_S"
  },
  {
    "Retail Branding": "Alldocube",
    "Marketing Name": "iPlay70_mini_Turbo",
    "Device": "U812",
    "Model": "iPlay70 mini Turbo"
  },
  {
    "Retail Branding": "Alldocube",
    "Marketing Name": "iPlay9T",
    "Device": "U1008",
    "Model": "iPlay9T"
  },
  {
    "Retail Branding": "Alldocube",
    "Marketing Name": "iPlay_20",
    "Device": "iPlay_20",
    "Model": "iPlay_20"
  },
  {
    "Retail Branding": "Alldocube",
    "Marketing Name": "iPlay_30",
    "Device": "T1012",
    "Model": "iPlay_30"
  },
  {
    "Retail Branding": "Alldocube",
    "Marketing Name": "iPlay_40",
    "Device": "T1020S",
    "Model": "iPlay_40"
  },
  {
    "Retail Branding": "Alldocube",
    "Marketing Name": "iPlay_40_5G",
    "Device": "T1016",
    "Model": "iPlay40_5G"
  },
  {
    "Retail Branding": "Alldocube",
    "Marketing Name": "iPlay_50_Pro",
    "Device": "T1030MAN",
    "Model": "iPlay_50_Pro"
  },
  {
    "Retail Branding": "Alldocube",
    "Marketing Name": "iPlay_60",
    "Device": "T1102T",
    "Model": "iPlay_60"
  },
  {
    "Retail Branding": "Alldocube",
    "Marketing Name": "iPlay_60_Lite",
    "Device": "T1103T",
    "Model": "iPlay_60_Lite"
  },
  {
    "Retail Branding": "Alldocube",
    "Marketing Name": "iPlay_60_SE",
    "Device": "iPlay_60_SE",
    "Model": "iPlay_60_SE"
  },
  {
    "Retail Branding": "Alldocube",
    "Marketing Name": "iPlay_70_Max",
    "Device": "iPlay_70_Max",
    "Model": "iPlay_70_Max"
  },
  {
    "Retail Branding": "Alldocube",
    "Marketing Name": "iPlay_70_Pad_Pro",
    "Device": "iPlay_70_Pad_Pro",
    "Model": "iPlay 70 Pad Pro"
  },
  {
    "Retail Branding": "Alldocube",
    "Marketing Name": "iPlay_70_Pro",
    "Device": "iPlay_70_Pro",
    "Model": "iPlay_70_Pro"
  },
  {
    "Retail Branding": "Alldocube",
    "Marketing Name": "iPlay_70_S",
    "Device": "iPlay_70_S",
    "Model": "iPlay_70_S"
  },
  {
    "Retail Branding": "Alldocube",
    "Marketing Name": "iPlay_70_Ultra",
    "Device": "iPlay_70_Ultra",
    "Model": "iPlay 70 Ultra"
  },
  {
    "Retail Branding": "Alldocube",
    "Marketing Name": "iPlay_70_mini_Ultra",
    "Device": "iPlay_70_mini_Ultra",
    "Model": "iPlay 70 mini Ultra"
  },
  {
    "Retail Branding": "Alldocube",
    "Marketing Name": "kPad",
    "Device": "T1026",
    "Model": "kPad"
  },
  {
    "Retail Branding": "Allducube",
    "Marketing Name": "T1001",
    "Device": "T1001",
    "Model": "T1001"
  },
  {
    "Retail Branding": "Allente",
    "Marketing Name": "Allente 1",
    "Device": "OnePlace2",
    "Model": "Allente 1"
  },
  {
    "Retail Branding": "Allente",
    "Marketing Name": "Allente Streaming Hub",
    "Device": "SEI700ALLG",
    "Model": "Allente Streaming Hub"
  },
  {
    "Retail Branding": "Allfine",
    "Marketing Name": "M721",
    "Device": "86S",
    "Model": "M721"
  },
  {
    "Retail Branding": "Allfine",
    "Marketing Name": "PC1038Q",
    "Device": "fine10_Joy",
    "Model": "PC1038Q"
  },
  {
    "Retail Branding": "Alliance",
    "Marketing Name": "DTP9731",
    "Device": "DTP9731",
    "Model": "DTP9731"
  },
  {
    "Retail Branding": "Allnet",
    "Marketing Name": "PrimeOne",
    "Device": "PrimeOne",
    "Model": "PrimeOne"
  },
  {
    "Retail Branding": "Allouette",
    "Marketing Name": "PSY7020SKD",
    "Device": "PSY7020SKD",
    "Model": "PSY7020SKD"
  },
  {
    "Retail Branding": "Alpha",
    "Marketing Name": "ALPHA 2K",
    "Device": "hayward",
    "Model": "ALPHA 2K"
  },
  {
    "Retail Branding": "Alpha",
    "Marketing Name": "ALPHA 4K",
    "Device": "lushan",
    "Model": "ALPHA 4K"
  },
  {
    "Retail Branding": "Alpha",
    "Marketing Name": "Alpha 43G7NUA",
    "Device": "samseong",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "Alpha",
    "Marketing Name": "Alpha S6",
    "Device": "Alpha_S6",
    "Model": "Alpha S6"
  },
  {
    "Retail Branding": "Alpha",
    "Marketing Name": "M8T",
    "Device": "ikebukuro",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "Alpha",
    "Marketing Name": "T1_Pro",
    "Device": "T1_pro",
    "Model": "T1_pro"
  },
  {
    "Retail Branding": "Alphascan",
    "Marketing Name": "SAT2242 WorkTab",
    "Device": "ADP_WW",
    "Model": "G2SMNT"
  },
  {
    "Retail Branding": "Altibox",
    "Marketing Name": "Altibox TV",
    "Device": "uiw4054aib",
    "Model": "Altibox TV"
  },
  {
    "Retail Branding": "Altice",
    "Marketing Name": "ADOBox 4K (DIW377)",
    "Device": "DIW377_ALT_DO",
    "Model": "ADOBox 4K (DIW377)"
  },
  {
    "Retail Branding": "Altice",
    "Marketing Name": "ALTICE S43",
    "Device": "S43",
    "Model": "ALTICE_S43"
  },
  {
    "Retail Branding": "Altice",
    "Marketing Name": "ALTICE S43",
    "Device": "S43",
    "Model": "S43"
  },
  {
    "Retail Branding": "Altice",
    "Marketing Name": "ALTICE S60",
    "Device": "S60",
    "Model": "S60"
  },
  {
    "Retail Branding": "Altice",
    "Marketing Name": "ALTICE S70",
    "Device": "S70",
    "Model": "S70"
  },
  {
    "Retail Branding": "Altice",
    "Marketing Name": "AlTICE S11",
    "Device": "S11",
    "Model": "S11"
  },
  {
    "Retail Branding": "Altice",
    "Marketing Name": "AlTICE S12",
    "Device": "S12",
    "Model": "S12"
  },
  {
    "Retail Branding": "Altice",
    "Marketing Name": "Altice S21",
    "Device": "STARNAUTE4",
    "Model": "STARNAUTE4"
  },
  {
    "Retail Branding": "Altice",
    "Marketing Name": "E25",
    "Device": "E25",
    "Model": "E25"
  },
  {
    "Retail Branding": "Altice",
    "Marketing Name": "E54",
    "Device": "E54",
    "Model": "E54"
  },
  {
    "Retail Branding": "Altice",
    "Marketing Name": "Eva",
    "Device": "SEI740ATC",
    "Model": "Eva"
  },
  {
    "Retail Branding": "Altice",
    "Marketing Name": "S13",
    "Device": "S13",
    "Model": "S13"
  },
  {
    "Retail Branding": "Altice",
    "Marketing Name": "S14",
    "Device": "S14",
    "Model": "S14"
  },
  {
    "Retail Branding": "Altice",
    "Marketing Name": "S22",
    "Device": "S22",
    "Model": "S22"
  },
  {
    "Retail Branding": "Altice",
    "Marketing Name": "S23",
    "Device": "S23",
    "Model": "S23"
  },
  {
    "Retail Branding": "Altice",
    "Marketing Name": "S24",
    "Device": "S24",
    "Model": "S24"
  },
  {
    "Retail Branding": "Altice",
    "Marketing Name": "S25",
    "Device": "S25",
    "Model": "S25"
  },
  {
    "Retail Branding": "Altice",
    "Marketing Name": "S31",
    "Device": "S31",
    "Model": "Altice_S31"
  },
  {
    "Retail Branding": "Altice",
    "Marketing Name": "S31",
    "Device": "S31",
    "Model": "S31"
  },
  {
    "Retail Branding": "Altice",
    "Marketing Name": "S32",
    "Device": "S32",
    "Model": "S32"
  },
  {
    "Retail Branding": "Altice",
    "Marketing Name": "S32_NFC",
    "Device": "S32_NFC",
    "Model": "S32_NFC"
  },
  {
    "Retail Branding": "Altice",
    "Marketing Name": "S32_Plus",
    "Device": "S32_Plus",
    "Model": "S32_Plus"
  },
  {
    "Retail Branding": "Altice",
    "Marketing Name": "S33",
    "Device": "S33",
    "Model": "S33"
  },
  {
    "Retail Branding": "Altice",
    "Marketing Name": "S34",
    "Device": "S34",
    "Model": "S34"
  },
  {
    "Retail Branding": "Altice",
    "Marketing Name": "S41",
    "Device": "HS6737MT",
    "Model": "S41"
  },
  {
    "Retail Branding": "Altice",
    "Marketing Name": "S42",
    "Device": "S42",
    "Model": "S42"
  },
  {
    "Retail Branding": "Altice",
    "Marketing Name": "S51",
    "Device": "HS6737MT",
    "Model": "S51"
  },
  {
    "Retail Branding": "Altice",
    "Marketing Name": "S61",
    "Device": "S61",
    "Model": "S61"
  },
  {
    "Retail Branding": "Altice",
    "Marketing Name": "S64",
    "Device": "S64",
    "Model": "S64"
  },
  {
    "Retail Branding": "Altice",
    "Marketing Name": "STARACTIVE",
    "Device": "STARACTIVE",
    "Model": "STARACTIVE"
  },
  {
    "Retail Branding": "Altice",
    "Marketing Name": "STARNAUTE 4",
    "Device": "STARNAUTE4",
    "Model": "STARNAUTE4"
  },
  {
    "Retail Branding": "Altice",
    "Marketing Name": "STARNAUTE3",
    "Device": "STARNAUTE3",
    "Model": "STARNAUTE 3"
  },
  {
    "Retail Branding": "Altice",
    "Marketing Name": "STARTRAIL 7",
    "Device": "STARTRAIL7",
    "Model": "STARTRAIL7"
  },
  {
    "Retail Branding": "Altice",
    "Marketing Name": "STARXTREM5",
    "Device": "STARXTREM5",
    "Model": "STARXTREM5"
  },
  {
    "Retail Branding": "Altice",
    "Marketing Name": "SX41",
    "Device": "HS6737MT",
    "Model": "SX41"
  },
  {
    "Retail Branding": "Altice",
    "Marketing Name": "Staractive",
    "Device": "STARACTIVE",
    "Model": "STARACTIVE"
  },
  {
    "Retail Branding": "Altice",
    "Marketing Name": "Stream V2",
    "Device": "DIW377AUSA",
    "Model": "Stream"
  },
  {
    "Retail Branding": "Altice",
    "Marketing Name": "T10",
    "Device": "T10",
    "Model": "T10"
  },
  {
    "Retail Branding": "Altron",
    "Marketing Name": "BE-730",
    "Device": "BE-730",
    "Model": "BE-730"
  },
  {
    "Retail Branding": "Altron",
    "Marketing Name": "GHIA",
    "Device": "GH1",
    "Model": "GH1"
  },
  {
    "Retail Branding": "Altron",
    "Marketing Name": "GI-420",
    "Device": "GI-420",
    "Model": "GI-420"
  },
  {
    "Retail Branding": "Altron",
    "Marketing Name": "GI-530",
    "Device": "GI-530",
    "Model": "GI-530"
  },
  {
    "Retail Branding": "Altron",
    "Marketing Name": "OB-1021",
    "Device": "OB-1021",
    "Model": "OB-1021"
  },
  {
    "Retail Branding": "Altron",
    "Marketing Name": "OB-627",
    "Device": "OB-627",
    "Model": "OB-627"
  },
  {
    "Retail Branding": "Altron",
    "Marketing Name": "OB-728",
    "Device": "OB-728",
    "Model": "OB-728"
  },
  {
    "Retail Branding": "Altron",
    "Marketing Name": "OB_421",
    "Device": "OB_421",
    "Model": "OB_421"
  },
  {
    "Retail Branding": "Altron",
    "Marketing Name": "OB_421_Plus",
    "Device": "OB_421_Plus",
    "Model": "OB_421"
  },
  {
    "Retail Branding": "Altron",
    "Marketing Name": "OB_588",
    "Device": "OB_588",
    "Model": "OB_588"
  },
  {
    "Retail Branding": "Altron",
    "Marketing Name": "OB_627",
    "Device": "OB_627",
    "Model": "OB_627"
  },
  {
    "Retail Branding": "Altron",
    "Marketing Name": "OB_628",
    "Device": "OB_628",
    "Model": "OB_628"
  },
  {
    "Retail Branding": "Altus",
    "Marketing Name": "2K Pro TV",
    "Device": "awaza",
    "Model": "2K Pro TV"
  },
  {
    "Retail Branding": "Altus",
    "Marketing Name": "2K Pro TV",
    "Device": "millbrae",
    "Model": "2K Pro TV"
  },
  {
    "Retail Branding": "Altus",
    "Marketing Name": "Altus Android TV",
    "Device": "kunyang",
    "Model": "4K Pro TV"
  },
  {
    "Retail Branding": "Altus",
    "Marketing Name": "Altus Android TV",
    "Device": "shinagawa",
    "Model": "Altus Android TV"
  },
  {
    "Retail Branding": "Altus",
    "Marketing Name": "Altus Android TV",
    "Device": "sinchon",
    "Model": "4K Pro TV"
  },
  {
    "Retail Branding": "Altus",
    "Marketing Name": "Altus UHD Android TV",
    "Device": "kunyang",
    "Model": "UHD Pro TV"
  },
  {
    "Retail Branding": "Altus",
    "Marketing Name": "Altus UHD Pro TV",
    "Device": "marina",
    "Model": "Altus UHD Pro TV"
  },
  {
    "Retail Branding": "Altus",
    "Marketing Name": "Turkey",
    "Device": "martin",
    "Model": "Altus Android TV"
  },
  {
    "Retail Branding": "Amdox",
    "Marketing Name": "EP-01",
    "Device": "EP-01",
    "Model": "EP-01"
  },
  {
    "Retail Branding": "Amdox",
    "Marketing Name": "X086AF",
    "Device": "rk3588_t",
    "Model": "X086AF"
  },
  {
    "Retail Branding": "Americamovil",
    "Marketing Name": "KIREI A5Q PLUS",
    "Device": "Azumi_KIREI_A5Q_PLUS_AC06",
    "Model": "KIREI A5Q PLUS"
  },
  {
    "Retail Branding": "Amgoo",
    "Marketing Name": "AM350",
    "Device": "AM350",
    "Model": "AM350"
  },
  {
    "Retail Branding": "Amgoo",
    "Marketing Name": "AM402",
    "Device": "AM402",
    "Model": "AM402"
  },
  {
    "Retail Branding": "Amgoo",
    "Marketing Name": "AM410",
    "Device": "AM410",
    "Model": "AM410"
  },
  {
    "Retail Branding": "Amgoo",
    "Marketing Name": "AM412",
    "Device": "AM412",
    "Model": "AM412"
  },
  {
    "Retail Branding": "Amgoo",
    "Marketing Name": "AM415",
    "Device": "AM415",
    "Model": "AM415"
  },
  {
    "Retail Branding": "Amgoo",
    "Marketing Name": "AM506",
    "Device": "AM506",
    "Model": "AM506"
  },
  {
    "Retail Branding": "Amgoo",
    "Marketing Name": "AM508",
    "Device": "AM508",
    "Model": "AM508"
  },
  {
    "Retail Branding": "Amgoo",
    "Marketing Name": "AM509",
    "Device": "AM509",
    "Model": "AM509"
  },
  {
    "Retail Branding": "Amgoo",
    "Marketing Name": "AM509",
    "Device": "AM509-A",
    "Model": "AM509"
  },
  {
    "Retail Branding": "Amgoo",
    "Marketing Name": "AM515",
    "Device": "AM515",
    "Model": "AM515"
  },
  {
    "Retail Branding": "Amgoo",
    "Marketing Name": "AM520",
    "Device": "AM520",
    "Model": "AM520"
  },
  {
    "Retail Branding": "Amgoo",
    "Marketing Name": "AM530",
    "Device": "AM530",
    "Model": "AM530"
  },
  {
    "Retail Branding": "Amgoo",
    "Marketing Name": "AM535",
    "Device": "AM535",
    "Model": "AM535"
  },
  {
    "Retail Branding": "Amgoo",
    "Marketing Name": "AMGOO",
    "Device": "AM518",
    "Model": "AM518"
  },
  {
    "Retail Branding": "Amgoo",
    "Marketing Name": "Amgoo",
    "Device": "AM518",
    "Model": "AM518"
  },
  {
    "Retail Branding": "Amino",
    "Marketing Name": "Amigo 7Y EspialTV",
    "Device": "Amigo7Y",
    "Model": "Amigo 7Y EspialTV"
  },
  {
    "Retail Branding": "Amino",
    "Marketing Name": "Amigo7Y",
    "Device": "Amigo7Y",
    "Model": "Amigo 7Y"
  },
  {
    "Retail Branding": "Amino",
    "Marketing Name": "DFN-Amigo7x",
    "Device": "Amigo7x3",
    "Model": "DFN-Amigo7x"
  },
  {
    "Retail Branding": "Aminocom",
    "Marketing Name": "Amigo",
    "Device": "Amigo",
    "Model": "Amigo7"
  },
  {
    "Retail Branding": "Aminocom",
    "Marketing Name": "Amigo7x",
    "Device": "Amigo7x",
    "Model": "Amigo7x"
  },
  {
    "Retail Branding": "Aminocom",
    "Marketing Name": "Amigo7x3SBC",
    "Device": "Amigo7x3SBC",
    "Model": "Amino SBCTV"
  },
  {
    "Retail Branding": "Aminocom",
    "Marketing Name": "Amigo7xESP",
    "Device": "Amigo7xESP",
    "Model": "Amigo7xESP"
  },
  {
    "Retail Branding": "Aminocom",
    "Marketing Name": "Amigo7xGM",
    "Device": "Amigo7xGM",
    "Model": "GO Android TV Box"
  },
  {
    "Retail Branding": "Aminocom",
    "Marketing Name": "Amigo7xSCB",
    "Device": "Amigo7xSCB",
    "Model": "Amigo7xSCB"
  },
  {
    "Retail Branding": "Aminocom",
    "Marketing Name": "Amigo7xcCN",
    "Device": "Amigo7xcCN",
    "Model": "Amigo7xcCN"
  },
  {
    "Retail Branding": "Aminocom",
    "Marketing Name": "Amino SBCTV",
    "Device": "Amigo7x3SBC",
    "Model": "Amino SBCTV"
  },
  {
    "Retail Branding": "Aminocom",
    "Marketing Name": "Kamai 7B",
    "Device": "Kamai7B",
    "Model": "Kamai7B"
  },
  {
    "Retail Branding": "Aminocom",
    "Marketing Name": "Kamai7",
    "Device": "Kamai7",
    "Model": "Kamai7"
  },
  {
    "Retail Branding": "Aminocom",
    "Marketing Name": "Kamai7B",
    "Device": "Kamai7B",
    "Model": "Kamai7B"
  },
  {
    "Retail Branding": "Aminocom",
    "Marketing Name": "eSTREAM4K",
    "Device": "eSTREAM4K_4x4",
    "Model": "IPA-1104HDH-01"
  },
  {
    "Retail Branding": "Ammigo",
    "Marketing Name": "Ammp8",
    "Device": "Ammp8",
    "Model": "Ammp8"
  },
  {
    "Retail Branding": "Ammigo",
    "Marketing Name": "Ni4",
    "Device": "Ni4",
    "Model": "Ni4"
  },
  {
    "Retail Branding": "Ammp",
    "Marketing Name": "Ammp10pro",
    "Device": "Ammp10pro",
    "Model": "Ammp10pro"
  },
  {
    "Retail Branding": "Ampila",
    "Marketing Name": "sti6160d327",
    "Device": "sti6160d327",
    "Model": "ampliaTV"
  },
  {
    "Retail Branding": "Amplify",
    "Marketing Name": "TL10RA3",
    "Device": "TL10RA3_1",
    "Model": "TL10RA3"
  },
  {
    "Retail Branding": "Amplify",
    "Marketing Name": "TR10CD3",
    "Device": "TR10CD3_1",
    "Model": "TR10CD3"
  },
  {
    "Retail Branding": "Amplify",
    "Marketing Name": "TR10CD3",
    "Device": "TR10CD3_2",
    "Model": "TR10CD3"
  },
  {
    "Retail Branding": "Amstrad",
    "Marketing Name": "Android TV",
    "Device": "R2",
    "Model": "ATV R2"
  },
  {
    "Retail Branding": "Amstrad",
    "Marketing Name": "R3",
    "Device": "R3",
    "Model": "R3"
  },
  {
    "Retail Branding": "Amstrad",
    "Marketing Name": "R4",
    "Device": "R4",
    "Model": "R4"
  },
  {
    "Retail Branding": "Amstrad",
    "Marketing Name": "R4_GTV",
    "Device": "R4_GTV",
    "Model": "R4G"
  },
  {
    "Retail Branding": "Andersson",
    "Marketing Name": "TBQ-7321",
    "Device": "TBQ-7321",
    "Model": "TBQ-7321"
  },
  {
    "Retail Branding": "Andersson",
    "Marketing Name": "TBQ10322",
    "Device": "TBQ10322",
    "Model": "TBQ10322"
  },
  {
    "Retail Branding": "Andersson",
    "Marketing Name": "TBQ8322",
    "Device": "TBQ8322",
    "Model": "TBQ8322"
  },
  {
    "Retail Branding": "Andersson",
    "Marketing Name": "TBQ_10321",
    "Device": "TBQ_10321",
    "Model": "TBQ_10321"
  },
  {
    "Retail Branding": "Andersson",
    "Marketing Name": "TBX10",
    "Device": "TBX10",
    "Model": "TBX10"
  },
  {
    "Retail Branding": "Andersson",
    "Marketing Name": "TBX11",
    "Device": "TBX11",
    "Model": "TBX11"
  },
  {
    "Retail Branding": "Andersson",
    "Marketing Name": "tablet",
    "Device": "TBX211",
    "Model": "TBX211"
  },
  {
    "Retail Branding": "AngelLira",
    "Marketing Name": "ALFP200",
    "Device": "ALFP200",
    "Model": "ALFP200"
  },
  {
    "Retail Branding": "AngelTech",
    "Marketing Name": "ATKSLIM",
    "Device": "ATKSLIM",
    "Model": "ATKSLIM"
  },
  {
    "Retail Branding": "AngelTech",
    "Marketing Name": "E109GCM",
    "Device": "E109GCM",
    "Model": "E109GCM"
  },
  {
    "Retail Branding": "AngelTech",
    "Marketing Name": "E80M",
    "Device": "E80M",
    "Model": "E80M"
  },
  {
    "Retail Branding": "AngelTech",
    "Marketing Name": "P80",
    "Device": "P80",
    "Model": "P80"
  },
  {
    "Retail Branding": "AngelTech",
    "Marketing Name": "PRO_II_16",
    "Device": "PRO_II_16",
    "Model": "PRO_II_16"
  },
  {
    "Retail Branding": "AngelTech",
    "Marketing Name": "SWAYTOSH_16",
    "Device": "SWAYTOSH_16",
    "Model": "SWAYTOSH_16"
  },
  {
    "Retail Branding": "Antel",
    "Marketing Name": "Antel Box2.0",
    "Device": "Antel_B866V2FAS",
    "Model": "Antel Box2.0"
  },
  {
    "Retail Branding": "Antel",
    "Marketing Name": "DV8547",
    "Device": "DV8547",
    "Model": "DV8547"
  },
  {
    "Retail Branding": "Anya",
    "Marketing Name": "Anya_S558",
    "Device": "S558",
    "Model": "S558"
  },
  {
    "Retail Branding": "Anydata",
    "Marketing Name": "",
    "Device": "ASP320Q_GSM",
    "Model": "ASP320Q_ANDi"
  },
  {
    "Retail Branding": "Anydata",
    "Marketing Name": "Aquaris I8",
    "Device": "bq_Aquaris",
    "Model": "bq Aquaris"
  },
  {
    "Retail Branding": "Anydata",
    "Marketing Name": "Auchan MID7317CP Tablet",
    "Device": "MID7317CP",
    "Model": "MID7317CP"
  },
  {
    "Retail Branding": "Anydata",
    "Marketing Name": "COBY MID7055",
    "Device": "MID7055",
    "Model": "MID7055"
  },
  {
    "Retail Branding": "Anydata",
    "Marketing Name": "Carrefour CT710",
    "Device": "M755ND",
    "Model": "CT710"
  },
  {
    "Retail Branding": "Anydata",
    "Marketing Name": "Carrefour CT720 / Emdoor EM63 Tablet",
    "Device": "EM63",
    "Model": "EM63"
  },
  {
    "Retail Branding": "Anydata",
    "Marketing Name": "Coby MID1065",
    "Device": "MID1065",
    "Model": "MID1065"
  },
  {
    "Retail Branding": "Anydata",
    "Marketing Name": "Coby MID7065",
    "Device": "MID7065",
    "Model": "MID7065"
  },
  {
    "Retail Branding": "Anydata",
    "Marketing Name": "Coby MID8065",
    "Device": "MID8065",
    "Model": "MID8065"
  },
  {
    "Retail Branding": "Anydata",
    "Marketing Name": "D2-721G",
    "Device": "D2-721G",
    "Model": "D2-721G"
  },
  {
    "Retail Branding": "Anydata",
    "Marketing Name": "D2-727G",
    "Device": "D2-727",
    "Model": "D2-727"
  },
  {
    "Retail Branding": "Anydata",
    "Marketing Name": "DOPO GMS-718 Tablet / Discovery",
    "Device": "DT088",
    "Model": "GS-718"
  },
  {
    "Retail Branding": "Anydata",
    "Marketing Name": "DOTPAD DP3D8 / Gadmei",
    "Device": "E8-3D",
    "Model": "DP3D8"
  },
  {
    "Retail Branding": "Anydata",
    "Marketing Name": "Digix TAB-840_G",
    "Device": "TAB-840_G",
    "Model": "TAB-840_G"
  },
  {
    "Retail Branding": "Anydata",
    "Marketing Name": "Eviant MT8000",
    "Device": "PDM829MD",
    "Model": "MT8000"
  },
  {
    "Retail Branding": "Anydata",
    "Marketing Name": "Garmin nuvi3590",
    "Device": "scorpio",
    "Model": "nuvi 3590"
  },
  {
    "Retail Branding": "Anydata",
    "Marketing Name": "Garmin nuvi3595",
    "Device": "scorpio",
    "Model": "nuvi 3595"
  },
  {
    "Retail Branding": "Anydata",
    "Marketing Name": "Grundig GR-TB10S Tablet",
    "Device": "GR-TB10S",
    "Model": "GR-TB10S"
  },
  {
    "Retail Branding": "Anydata",
    "Marketing Name": "HCL ME TABLET PC U2",
    "Device": "M712MC",
    "Model": "U2"
  },
  {
    "Retail Branding": "Anydata",
    "Marketing Name": "HKC P771A",
    "Device": "P771A_WIFI",
    "Model": "P771A"
  },
  {
    "Retail Branding": "Anydata",
    "Marketing Name": "HKC P774A",
    "Device": "P774A",
    "Model": "P774A"
  },
  {
    "Retail Branding": "Anydata",
    "Marketing Name": "HKC P776A",
    "Device": "P776A",
    "Model": "P776A"
  },
  {
    "Retail Branding": "Anydata",
    "Marketing Name": "HKC P778A",
    "Device": "HKCP778A",
    "Model": "P778A"
  },
  {
    "Retail Branding": "Anydata",
    "Marketing Name": "HKC P886A",
    "Device": "P886A",
    "Model": "P886A"
  },
  {
    "Retail Branding": "Anydata",
    "Marketing Name": "HS_7DTB14",
    "Device": "HS_7DTB14",
    "Model": "HS_7DTB14"
  },
  {
    "Retail Branding": "Anydata",
    "Marketing Name": "Insignia NS-13T001 Tablet",
    "Device": "oracle",
    "Model": "NS-13T001"
  },
  {
    "Retail Branding": "Anydata",
    "Marketing Name": "Jiateng JT1241",
    "Device": "JT1241",
    "Model": "JT1241"
  },
  {
    "Retail Branding": "Anydata",
    "Marketing Name": "Lazer MD7305 Tablet / AMTC",
    "Device": "MD7305",
    "Model": "MD7305"
  },
  {
    "Retail Branding": "Anydata",
    "Marketing Name": "Le Pan S",
    "Device": "oracle",
    "Model": "Le Pan S"
  },
  {
    "Retail Branding": "Anydata",
    "Marketing Name": "LePanII",
    "Device": "LePanII_wifi",
    "Model": "LePanII"
  },
  {
    "Retail Branding": "Anydata",
    "Marketing Name": "Leader I10A-LE",
    "Device": "I10A-LE",
    "Model": "I10A-LE"
  },
  {
    "Retail Branding": "Anydata",
    "Marketing Name": "Mach_Speed Trio G2 Tablet",
    "Device": "Trio_Stealth_G2",
    "Model": "G2"
  },
  {
    "Retail Branding": "Anydata",
    "Marketing Name": "Marquis Tablet",
    "Device": "marquis_tablet",
    "Model": "Marquis_MP977"
  },
  {
    "Retail Branding": "Anydata",
    "Marketing Name": "Matsunichi M97",
    "Device": "oracle",
    "Model": "M97"
  },
  {
    "Retail Branding": "Anydata",
    "Marketing Name": "Monster M7 Tablet",
    "Device": "MONSTERM7",
    "Model": "M7"
  },
  {
    "Retail Branding": "Anydata",
    "Marketing Name": "Nextbook NX007HD Tablet",
    "Device": "M7000ND",
    "Model": "NX007HD"
  },
  {
    "Retail Branding": "Anydata",
    "Marketing Name": "Nextbook NX008HD8G Tablet",
    "Device": "M8000ND",
    "Model": "NX008HD8G"
  },
  {
    "Retail Branding": "Anydata",
    "Marketing Name": "Nextbook NX008HI Tablet / Carrefour CT810",
    "Device": "M909NP",
    "Model": "NX008HI"
  },
  {
    "Retail Branding": "Anydata",
    "Marketing Name": "Nextbook Next7D12 Tablet",
    "Device": "M757ND",
    "Model": "Next7D12"
  },
  {
    "Retail Branding": "Anydata",
    "Marketing Name": "Nextbook Next7P12",
    "Device": "M727MC",
    "Model": "Next7P12"
  },
  {
    "Retail Branding": "Anydata",
    "Marketing Name": "Pendo PNDPP48GP",
    "Device": "PNDPP48GP",
    "Model": "PNDPP48GP"
  },
  {
    "Retail Branding": "Anydata",
    "Marketing Name": "Philips W336",
    "Device": "Crane",
    "Model": "Philips W336"
  },
  {
    "Retail Branding": "Anydata",
    "Marketing Name": "Philips W536",
    "Device": "Philips_WG-MANTO-RU_B",
    "Model": "Philips W536"
  },
  {
    "Retail Branding": "Anydata",
    "Marketing Name": "Philips W626",
    "Device": "sangfei73_gb",
    "Model": "W626"
  },
  {
    "Retail Branding": "Anydata",
    "Marketing Name": "Philips W632",
    "Device": "robot",
    "Model": "Philips W632"
  },
  {
    "Retail Branding": "Anydata",
    "Marketing Name": "Philips W832",
    "Device": "Philips_WG-ROVER-RU_A",
    "Model": "Philips W832"
  },
  {
    "Retail Branding": "Anydata",
    "Marketing Name": "Proscan PLT7223G",
    "Device": "PLT7223G",
    "Model": "PLT7223G"
  },
  {
    "Retail Branding": "Anydata",
    "Marketing Name": "Proscan PLT7777",
    "Device": "AMLMID710K",
    "Model": "PLT7777"
  },
  {
    "Retail Branding": "Anydata",
    "Marketing Name": "Proscan PLT8223G",
    "Device": "PLT8223G",
    "Model": "PLT8223G"
  },
  {
    "Retail Branding": "Anydata",
    "Marketing Name": "RCA RCT6078W2",
    "Device": "AMLEM62",
    "Model": "RCT6078W2"
  },
  {
    "Retail Branding": "Anydata",
    "Marketing Name": "RCA RCT6078W2",
    "Device": "EM62",
    "Model": "RCT6078W2"
  },
  {
    "Retail Branding": "Anydata",
    "Marketing Name": "TecToy TT-2500",
    "Device": "AML757ND",
    "Model": "TECTOYTT2500"
  },
  {
    "Retail Branding": "Anydata",
    "Marketing Name": "Visual Land Prestige 7D",
    "Device": "PRO7D",
    "Model": "PRO7D"
  },
  {
    "Retail Branding": "Anydata",
    "Marketing Name": "Vivitar Camelio Tablet",
    "Device": "PI070H04CA",
    "Model": "Camelio Family tablet"
  },
  {
    "Retail Branding": "Anydata",
    "Marketing Name": "Vivitar XO Tablet",
    "Device": "PI070H08XO",
    "Model": "XO Learning tablet"
  },
  {
    "Retail Branding": "Anydata",
    "Marketing Name": "Zeki TBDG773",
    "Device": "TBDG773",
    "Model": "TBDG773"
  },
  {
    "Retail Branding": "Anydata",
    "Marketing Name": "ematic EGP008",
    "Device": "EGP008",
    "Model": "EGP008"
  },
  {
    "Retail Branding": "Anydata",
    "Marketing Name": "ematic EGP010",
    "Device": "EGP010",
    "Model": "EGP010"
  },
  {
    "Retail Branding": "Anydata",
    "Marketing Name": "ematic EGS004",
    "Device": "EGS004",
    "Model": "EGS004"
  },
  {
    "Retail Branding": "Anydata",
    "Marketing Name": "ematic EGS102",
    "Device": "EGS102",
    "Model": "EGS102"
  },
  {
    "Retail Branding": "Anydata",
    "Marketing Name": "essentielb ST8003/FT8001 Tablet",
    "Device": "M805ND",
    "Model": "Smart\\'TAB 8003"
  },
  {
    "Retail Branding": "Anydata",
    "Marketing Name": "iCraig CMP748",
    "Device": "CMP748",
    "Model": "CMP748"
  },
  {
    "Retail Branding": "Anydata",
    "Marketing Name": "iCraig CMP749",
    "Device": "CMP749",
    "Model": "CMP749"
  },
  {
    "Retail Branding": "AoGo",
    "Marketing Name": "AoGo1",
    "Device": "AoGo1",
    "Model": "AoGo1"
  },
  {
    "Retail Branding": "Aocwei",
    "Marketing Name": "X300",
    "Device": "X300",
    "Model": "X300"
  },
  {
    "Retail Branding": "Aocwei",
    "Marketing Name": "X300_EEA",
    "Device": "X300_EEA",
    "Model": "X300_EEA"
  },
  {
    "Retail Branding": "Aocwei",
    "Marketing Name": "X300_EEA_T",
    "Device": "X300_EEA_T",
    "Model": "X300_EEA"
  },
  {
    "Retail Branding": "Aocwei",
    "Marketing Name": "X300_T",
    "Device": "X300_T",
    "Model": "X300_US"
  },
  {
    "Retail Branding": "Aocwei",
    "Marketing Name": "X500_EEA",
    "Device": "X500_EEA",
    "Model": "X500_EEA"
  },
  {
    "Retail Branding": "Aocwei",
    "Marketing Name": "X500_T_EEA",
    "Device": "X500_T_EEA",
    "Model": "X500_T_EEA"
  },
  {
    "Retail Branding": "Aocwei",
    "Marketing Name": "X500_US",
    "Device": "X500_US",
    "Model": "X500_US"
  },
  {
    "Retail Branding": "Aocwei",
    "Marketing Name": "X700_EEA",
    "Device": "X700_EEA",
    "Model": "X700_EEA"
  },
  {
    "Retail Branding": "Aocwei",
    "Marketing Name": "X800_EEA",
    "Device": "X800_EEA",
    "Model": "X800_EEA"
  },
  {
    "Retail Branding": "Aocwei",
    "Marketing Name": "X800_US",
    "Device": "X800_US",
    "Model": "X800_US"
  },
  {
    "Retail Branding": "Aocwei",
    "Marketing Name": "X900-US",
    "Device": "X900-US",
    "Model": "X900-US"
  },
  {
    "Retail Branding": "Aocwei",
    "Marketing Name": "X900_EEA",
    "Device": "X900_EEA",
    "Model": "X900_EEA"
  },
  {
    "Retail Branding": "Aocwei",
    "Marketing Name": "X900_US",
    "Device": "X900_US",
    "Model": "X900_US"
  },
  {
    "Retail Branding": "Apex",
    "Marketing Name": "A11D",
    "Device": "A11D",
    "Model": "A11D"
  },
  {
    "Retail Branding": "Apex",
    "Marketing Name": "APEX_A10",
    "Device": "NEOTab_A10",
    "Model": "NEOTab_A10"
  },
  {
    "Retail Branding": "Apex",
    "Marketing Name": "M10D",
    "Device": "M10D",
    "Model": "M10D"
  },
  {
    "Retail Branding": "Apex",
    "Marketing Name": "MT-734G",
    "Device": "MT-734G",
    "Model": "MT-734G"
  },
  {
    "Retail Branding": "Apex",
    "Marketing Name": "P10HD_Lite",
    "Device": "P10HD_Lite",
    "Model": "P10HD_Lite"
  },
  {
    "Retail Branding": "Apex",
    "Marketing Name": "R10D",
    "Device": "R10D",
    "Model": "R10D"
  },
  {
    "Retail Branding": "Apex",
    "Marketing Name": "T40PRO_L1",
    "Device": "T40PRO_L1",
    "Model": "T40PRO_L1"
  },
  {
    "Retail Branding": "Apex",
    "Marketing Name": "TM772",
    "Device": "TM772",
    "Model": "TM772"
  },
  {
    "Retail Branding": "Apex",
    "Marketing Name": "TM785CH",
    "Device": "tm785ch",
    "Model": "TM785CH"
  },
  {
    "Retail Branding": "Apex",
    "Marketing Name": "U10",
    "Device": "U10",
    "Model": "U10"
  },
  {
    "Retail Branding": "Apex",
    "Marketing Name": "U10PRO",
    "Device": "U10PRO",
    "Model": "U10PRO"
  },
  {
    "Retail Branding": "Apex",
    "Marketing Name": "Z12_PRO",
    "Device": "Z12_PRO",
    "Model": "Z12_PRO"
  },
  {
    "Retail Branding": "Apex",
    "Marketing Name": "Z4PRO",
    "Device": "Z4PRO",
    "Model": "Z4PRO"
  },
  {
    "Retail Branding": "Apolosign",
    "Marketing Name": "AndroidTablet",
    "Device": "WA1389T",
    "Model": "WA1389T"
  },
  {
    "Retail Branding": "Apolosign",
    "Marketing Name": "DigitalCalendar",
    "Device": "FA158AT",
    "Model": "FA158AT"
  },
  {
    "Retail Branding": "Apolosign",
    "Marketing Name": "DigitalSignage",
    "Device": "FA1569T",
    "Model": "Apolosign Calendar"
  },
  {
    "Retail Branding": "Apolosign",
    "Marketing Name": "DigitalSignage",
    "Device": "FA1569T",
    "Model": "FA1569T"
  },
  {
    "Retail Branding": "Apolosign",
    "Marketing Name": "DigitalSignageFA2169T",
    "Device": "FA2169T",
    "Model": "Apolosign Calendar"
  },
  {
    "Retail Branding": "Apolosign",
    "Marketing Name": "DigitalSignageFA2769T",
    "Device": "FA2769T",
    "Model": "Apolosign Calendar"
  },
  {
    "Retail Branding": "Apolosign",
    "Marketing Name": "DigitalSignageFA2769T4K",
    "Device": "FA2769T4K",
    "Model": "Apolosign Calendar"
  },
  {
    "Retail Branding": "Apolosign",
    "Marketing Name": "EM101A",
    "Device": "EM101A",
    "Model": "EM101A"
  },
  {
    "Retail Branding": "Apolosign",
    "Marketing Name": "EM101B",
    "Device": "EM101B",
    "Model": "EM101B"
  },
  {
    "Retail Branding": "Apolosign",
    "Marketing Name": "EM101B_EEA",
    "Device": "EM101B_EEA",
    "Model": "EM101B_EEA"
  },
  {
    "Retail Branding": "Apolosign",
    "Marketing Name": "EM101C",
    "Device": "EM101C",
    "Model": "EM101C"
  },
  {
    "Retail Branding": "Apolosign",
    "Marketing Name": "EM101C_EEA",
    "Device": "EM101C_EEA",
    "Model": "EM101C_EEA"
  },
  {
    "Retail Branding": "Apolosign",
    "Marketing Name": "EM103A",
    "Device": "EM103A",
    "Model": "EM103A"
  },
  {
    "Retail Branding": "Apolosign",
    "Marketing Name": "EM103B_EEA",
    "Device": "EP103B_EEA",
    "Model": "EP103B_EEA"
  },
  {
    "Retail Branding": "Apolosign",
    "Marketing Name": "EP103B",
    "Device": "EP103B",
    "Model": "EP103B"
  },
  {
    "Retail Branding": "Apolosign",
    "Marketing Name": "EP1095T",
    "Device": "EP1095T",
    "Model": "EP1095T"
  },
  {
    "Retail Branding": "Apolosign",
    "Marketing Name": "EP1095T_EEA",
    "Device": "EP1095T",
    "Model": "A30"
  },
  {
    "Retail Branding": "Apolosign",
    "Marketing Name": "EP1095T_EEA",
    "Device": "EP1095T",
    "Model": "EP1095T"
  },
  {
    "Retail Branding": "Apolosign",
    "Marketing Name": "EP1095T_EEA",
    "Device": "EP1095T",
    "Model": "EP1095T_EEA"
  },
  {
    "Retail Branding": "Apolosign",
    "Marketing Name": "EP1095_T",
    "Device": "EP1095_T",
    "Model": "EP1095_T"
  },
  {
    "Retail Branding": "Apolosign",
    "Marketing Name": "EP1095_T_EEA",
    "Device": "EP1095_T_EEA",
    "Model": "EP1095_T_EEA"
  },
  {
    "Retail Branding": "Apolosign",
    "Marketing Name": "EP1495T",
    "Device": "EP1495T",
    "Model": "EP1495T"
  },
  {
    "Retail Branding": "Apolosign",
    "Marketing Name": "K103_A",
    "Device": "K103_A",
    "Model": "K103A"
  },
  {
    "Retail Branding": "Apolosign",
    "Marketing Name": "K103_A",
    "Device": "K103_A",
    "Model": "K103_A"
  },
  {
    "Retail Branding": "Apolosign",
    "Marketing Name": "K103_B",
    "Device": "K103_B",
    "Model": "K103_B"
  },
  {
    "Retail Branding": "Apolosign",
    "Marketing Name": "K106A",
    "Device": "K106A",
    "Model": "K106A"
  },
  {
    "Retail Branding": "Apolosign",
    "Marketing Name": "K106_A",
    "Device": "K106_A",
    "Model": "K106_A"
  },
  {
    "Retail Branding": "Apolosign",
    "Marketing Name": "K109A",
    "Device": "K109A",
    "Model": "K109A"
  },
  {
    "Retail Branding": "Apolosign",
    "Marketing Name": "K109_Pro",
    "Device": "K109_Pro",
    "Model": "K109_Pro"
  },
  {
    "Retail Branding": "Apolosign",
    "Marketing Name": "K709A",
    "Device": "K709A",
    "Model": "K709A"
  },
  {
    "Retail Branding": "Apolosign",
    "Marketing Name": "NW1495T_ROW",
    "Device": "NW1495T",
    "Model": "NW1495T"
  },
  {
    "Retail Branding": "Apolosign",
    "Marketing Name": "Packgo",
    "Device": "AP2718T",
    "Model": "AP2718T"
  },
  {
    "Retail Branding": "Apolosign",
    "Marketing Name": "PortableTV",
    "Device": "SW3299T",
    "Model": "SW3299T"
  },
  {
    "Retail Branding": "Apolosign",
    "Marketing Name": "PortableTV",
    "Device": "SW3299T",
    "Model": "SW3299T-4K"
  },
  {
    "Retail Branding": "Apolosign",
    "Marketing Name": "PortableTVSW3299TFHD",
    "Device": "SW3299TFHD",
    "Model": "StandMe"
  },
  {
    "Retail Branding": "Apolosign",
    "Marketing Name": "WF1589T",
    "Device": "WF1589T",
    "Model": "WF1589T"
  },
  {
    "Retail Branding": "Apolosign",
    "Marketing Name": "WF2189T",
    "Device": "WF2189T",
    "Model": "Apolosign Calendar"
  },
  {
    "Retail Branding": "Apolosign",
    "Marketing Name": "WF2189T",
    "Device": "WF2189T",
    "Model": "WF2189T"
  },
  {
    "Retail Branding": "Apolosign",
    "Marketing Name": "WF2489T",
    "Device": "WF2489T",
    "Model": "WF2489T"
  },
  {
    "Retail Branding": "Apolosign",
    "Marketing Name": "WF3289T",
    "Device": "WF3289T",
    "Model": "WF3289T"
  },
  {
    "Retail Branding": "Apolosign",
    "Marketing Name": "elcnw tablet",
    "Device": "NW1495T",
    "Model": "NW1495T_EEA"
  },
  {
    "Retail Branding": "Aprix",
    "Marketing Name": "Aprix_Tab64_T2",
    "Device": "Tab64_T2",
    "Model": "Tab64_T"
  },
  {
    "Retail Branding": "Aprix",
    "Marketing Name": "Phat6",
    "Device": "Aprix_Phat6",
    "Model": "Aprix_Phat6"
  },
  {
    "Retail Branding": "Aprix",
    "Marketing Name": "Phat6",
    "Device": "Phat6",
    "Model": "Phat6"
  },
  {
    "Retail Branding": "Aprix",
    "Marketing Name": "Tab1066",
    "Device": "Tab1066",
    "Model": "Tab1066"
  },
  {
    "Retail Branding": "Aprix",
    "Marketing Name": "Tab64",
    "Device": "AprixTab64",
    "Model": "Aprix Tab64"
  },
  {
    "Retail Branding": "Aprix",
    "Marketing Name": "Tab64_T",
    "Device": "Tab64_T",
    "Model": "Tab64_T"
  },
  {
    "Retail Branding": "Aprix",
    "Marketing Name": "Tab8ii",
    "Device": "Tab8ii",
    "Model": "Tab8ii"
  },
  {
    "Retail Branding": "Aprix",
    "Marketing Name": "TabX4",
    "Device": "TabX4",
    "Model": "TabX4"
  },
  {
    "Retail Branding": "Aprix",
    "Marketing Name": "Tab_X1",
    "Device": "Tab_X1",
    "Model": "Tab_X1"
  },
  {
    "Retail Branding": "Aprix",
    "Marketing Name": "Tab_X2",
    "Device": "Tab_X2",
    "Model": "Tab_X2"
  },
  {
    "Retail Branding": "Aprix",
    "Marketing Name": "X4",
    "Device": "Aprix_X4",
    "Model": "Aprix_X4"
  },
  {
    "Retail Branding": "Aqua",
    "Marketing Name": "APAC",
    "Device": "nippori",
    "Model": "AQUA Android TV 2K"
  },
  {
    "Retail Branding": "Aqua",
    "Marketing Name": "AQUA Android TV DVB",
    "Device": "dupont",
    "Model": "AQUA Android TV DVB"
  },
  {
    "Retail Branding": "Aqua",
    "Marketing Name": "AQUA Android TV DVB2K",
    "Device": "broadway",
    "Model": "AQUA Android TV DVB2K"
  },
  {
    "Retail Branding": "Aqua",
    "Marketing Name": "AQUA Android TV FF Pro",
    "Device": "daan",
    "Model": "AQUA Android TV FF Pro"
  },
  {
    "Retail Branding": "Aqua",
    "Marketing Name": "AQUA MatrixTV AE",
    "Device": "irvine",
    "Model": "AQUA MatrixTV AE"
  },
  {
    "Retail Branding": "Aqua",
    "Marketing Name": "AQUA MatrixTV BE",
    "Device": "jordan",
    "Model": "AQUA MatrixTV BE"
  },
  {
    "Retail Branding": "Aqua",
    "Marketing Name": "AQUA MatrixTV CE",
    "Device": "deto",
    "Model": "AQUA MatrixTV CE"
  },
  {
    "Retail Branding": "Aqua",
    "Marketing Name": "AQUA MatrixTV DE",
    "Device": "omonia",
    "Model": "AQUA MatrixTV DE"
  },
  {
    "Retail Branding": "Aqua",
    "Marketing Name": "AQUA MatrixTV EE",
    "Device": "omonia",
    "Model": "AQUA MatrixTV EE"
  },
  {
    "Retail Branding": "Aqua",
    "Marketing Name": "AQUA MatrixTV FE",
    "Device": "burrard",
    "Model": "AQUA MatrixTV FE"
  },
  {
    "Retail Branding": "Aqua",
    "Marketing Name": "AQUA MatrixTV GE",
    "Device": "haeundae",
    "Model": "AQUA MatrixTV GE"
  },
  {
    "Retail Branding": "Aqua",
    "Marketing Name": "AQUA android TV",
    "Device": "hanyang",
    "Model": "AQUA Android TV"
  },
  {
    "Retail Branding": "Aqua",
    "Marketing Name": "S1 Jazz",
    "Device": "S1_Jazz",
    "Model": "S1 Jazz"
  },
  {
    "Retail Branding": "Arcelik",
    "Marketing Name": "Arcelik 2K Google TV",
    "Device": "awaza",
    "Model": "Arcelik 2K Google TV"
  },
  {
    "Retail Branding": "Arcelik",
    "Marketing Name": "Arcelik Google TV",
    "Device": "wanchai",
    "Model": "Arcelik Google TV"
  },
  {
    "Retail Branding": "Arcelik",
    "Marketing Name": "Arcelik Google TV OLED",
    "Device": "wanchai",
    "Model": "Arcelik Google TV OLED"
  },
  {
    "Retail Branding": "Arcelik",
    "Marketing Name": "Arcelik Google TV QLED",
    "Device": "wanchai",
    "Model": "Arcelik Google TV QLED"
  },
  {
    "Retail Branding": "Arcelik",
    "Marketing Name": "Arcelik Google TV UHD+",
    "Device": "wanchai",
    "Model": "Arcelik Google TV UHD+"
  },
  {
    "Retail Branding": "Arcelik",
    "Marketing Name": "Arcelik Google UHD TV",
    "Device": "akropoli",
    "Model": "Arcelik Google UHD TV"
  },
  {
    "Retail Branding": "Arcelik",
    "Marketing Name": "Arcelik Nano QLED",
    "Device": "aberdeen",
    "Model": "Arcelik Nano QLED"
  },
  {
    "Retail Branding": "Arcelik",
    "Marketing Name": "Arcelik OLED Google TV",
    "Device": "aberdeen",
    "Model": "Arcelik OLED Google TV"
  },
  {
    "Retail Branding": "Arcelik",
    "Marketing Name": "Arcelik QLED Google TV",
    "Device": "akropoli",
    "Model": "Arcelik QLED Google TV"
  },
  {
    "Retail Branding": "Arcelik",
    "Marketing Name": "B55L 9682 5AS",
    "Device": "arcelik_eu",
    "Model": "arcelik_uhd_powermax_at"
  },
  {
    "Retail Branding": "Arcelik",
    "Marketing Name": "R4",
    "Device": "R4",
    "Model": "R4"
  },
  {
    "Retail Branding": "Arcelik",
    "Marketing Name": "Turkey",
    "Device": "martin",
    "Model": "Arcelik Android TV"
  },
  {
    "Retail Branding": "Archer",
    "Marketing Name": "AT8600",
    "Device": "oversea_v",
    "Model": "SmarTouch"
  },
  {
    "Retail Branding": "Archer",
    "Marketing Name": "GB8600G3",
    "Device": "oversea_v",
    "Model": "SmarTouch"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "",
    "Device": "A101S",
    "Model": "ARCHOS 101G9"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "",
    "Device": "A101S",
    "Model": "Archos 101 Internet Tablet"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "",
    "Device": "A80S",
    "Model": "ARCHOS 80G9"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "",
    "Device": "A80S",
    "Model": "Archos 80 Internet Tablet"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "101 Childpad",
    "Device": "A101CHP",
    "Model": "ARCHOS 101 CHILDPAD"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "101 Cobalt",
    "Device": "AC101CO",
    "Model": "Archos 101 Cobalt"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "101 Copper",
    "Device": "ac101cv",
    "Model": "Archos 101 Copper"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "101 G9",
    "Device": "A101",
    "Model": "ARCHOS 101G9"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "101 Helium",
    "Device": "ac101he",
    "Model": "Archos 101 Helium"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "101 Helium Lite",
    "Device": "ac101hel",
    "Model": "Archos 101 Helium Lite"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "101 Magnus",
    "Device": "ac101ma",
    "Model": "ARCHOS 101 Magnus"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "101 Neon",
    "Device": "A101NE",
    "Model": "Archos 101 Neon"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "101 Oxygen",
    "Device": "ac101ox",
    "Model": "Archos 101 Oxygen"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "101 Platinum",
    "Device": "A101PL",
    "Model": "ARCHOS 101 PLATINUM"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "101 Titanium",
    "Device": "A101TI",
    "Model": "ARCHOS 101 Titanium"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "101 XS",
    "Device": "A101XS",
    "Model": "ARCHOS 101G10"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "101 Xenon",
    "Device": "a101xe",
    "Model": "Archos 101 Xenon"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "101 Xenon",
    "Device": "ac101cxe",
    "Model": "Archos 101c Xenon"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "101 Xenon",
    "Device": "ac101xev2",
    "Model": "Archos 101 Xenon v2"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "101 Xenon Lite",
    "Device": "ac101xel",
    "Model": "Archos 101 Xenon Lite"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "101D Neon",
    "Device": "ac101dne",
    "Model": "Archos 101d Neon"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "101XS2",
    "Device": "AC101XS2",
    "Model": "ARCHOS 101 XS 2"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "101XS3",
    "Device": "ac101xs3",
    "Model": "Archos 101XS3"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "101b Copper",
    "Device": "ac101bcv",
    "Model": "Archos 101b Copper"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "101b Helium",
    "Device": "ac101bhe",
    "Model": "Archos 101b Helium"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "101b Neon",
    "Device": "ac101bne",
    "Model": "Archos 101b Neon"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "101b Oxygen",
    "Device": "ac101box",
    "Model": "Archos 101b Oxygen"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "101b Platinum",
    "Device": "ac101bpl",
    "Model": "Archos 101b Platinium"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "101b XS2",
    "Device": "ac101bxs2",
    "Model": "ARCHOS 101b XS2"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "101b Xenon",
    "Device": "ac101bxev2",
    "Model": "Archos 101b Xenon v2"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "101c Copper",
    "Device": "ac101ccv",
    "Model": "Archos 101c Copper"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "101c Neon",
    "Device": "ac101cne",
    "Model": "Archos 101c Neon"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "101c Platinum",
    "Device": "ac101cpl",
    "Model": "Archos 101c Platinum"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "101d Platinum v2",
    "Device": "ac101cplv2",
    "Model": "Archos 101d Platinum v2"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "101d Platinum v3",
    "Device": "ac101dplv3",
    "Model": "Archos 101d Platinum v3"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "101e Neon",
    "Device": "ac101enev2",
    "Model": "Archos 101e Neon"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "101e neon",
    "Device": "ac101ene",
    "Model": "Archos 101e Neon"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "121 Neon",
    "Device": "ac121ne",
    "Model": "Archos 121 Neon"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "133 Oxygen",
    "Device": "ac133ox",
    "Model": "Archos 133 Oxygen"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "35b Titanium",
    "Device": "ac35bti",
    "Model": "Archos 35b Titanium"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "40 Helium",
    "Device": "ac40he",
    "Model": "Archos 40 Helium"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "40 Neon",
    "Device": "ac40ne",
    "Model": "Archos 40 Neon"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "40 Power",
    "Device": "ac40po",
    "Model": "Archos 40 Power"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "40 Power",
    "Device": "ac40pov2",
    "Model": "Archos 40 Power"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "40 Titanium",
    "Device": "a40ti",
    "Model": "Archos 40 Titanium"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "40b Titanium",
    "Device": "a40btisr",
    "Model": "Archos 40b Titanium Surround"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "40c Titanium",
    "Device": "ac40cti",
    "Model": "Archos 40c Titanium"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "40c Titanium",
    "Device": "ac40ctiv2",
    "Model": "ARCHOS 40C TIv2"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "40d Titanium",
    "Device": "ac40dti",
    "Model": "ARCHOS 40d Titanium"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "45 Helium 4G",
    "Device": "a45he",
    "Model": "Archos 45 Helium 4G"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "45 Neon",
    "Device": "ac45ne",
    "Model": "Archos 45 Neon"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "45 Platinum",
    "Device": "msm8625",
    "Model": "Archos 45 Platinum"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "45 Titanium",
    "Device": "a45ti",
    "Model": "Archos 45 Titanium"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "45b Helium",
    "Device": "ac45bhe",
    "Model": "AC45BHE"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "45b Helium",
    "Device": "ac45bhe",
    "Model": "ARCHOS 45b Helium"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "45b Neon",
    "Device": "ac45dpl",
    "Model": "Archos 45b Neon"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "45b Platinum",
    "Device": "ac45bpl",
    "Model": "Archos 45b Platinum"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "45c Helium",
    "Device": "ac45che",
    "Model": "Archos 45c Helium"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "45c Platinum",
    "Device": "ac45cpl",
    "Model": "Archos 45c Platinum"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "45c Titanium",
    "Device": "ac45cti",
    "Model": "Archos 45c Titanium"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "45d Platinum",
    "Device": "ac45dpl",
    "Model": "Archos 45d Platinum"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "50 Cobalt",
    "Device": "ac50co",
    "Model": "Archos 50 Cobalt"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "50 Diamond",
    "Device": "ac50da",
    "Model": "Archos 50 Diamond"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "50 Helium 4G",
    "Device": "a50he",
    "Model": "Archos 50 Helium 4G"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "50 Helium Plus",
    "Device": "ac50heplus",
    "Model": "Archos 50 Helium Plus"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "50 Neon",
    "Device": "a50ne",
    "Model": "Archos 50 Neon"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "50 Oxygen",
    "Device": "a50ox",
    "Model": "Archos 50 Oxygen"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "50 Oxygen plus",
    "Device": "ac50oxplus",
    "Model": "Archos 50 Oxygen Plus"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "50 Platinum",
    "Device": "msm8625",
    "Model": "Archos 50 Platinum"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "50 Platinum 4G",
    "Device": "AC50PL4G",
    "Model": "Archos 50 Platinum 4G"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "50 Power",
    "Device": "ac50po",
    "Model": "Archos 50 Power"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "50 Saphir",
    "Device": "ac50sa",
    "Model": "Archos 50 Saphir"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "50 Titanium",
    "Device": "a50ti",
    "Model": "Archos 50 Titanium"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "50 Titanium 4G",
    "Device": "ac50ti",
    "Model": "A50TI"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "50 d Helium",
    "Device": "ac50dhe",
    "Model": "AC50DHE"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "50B Cobalt",
    "Device": "ac50bco",
    "Model": "Archos 50B Cobalt"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "50F Neon",
    "Device": "ac50fnev2",
    "Model": "Archos 50f Neon"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "50b Helium",
    "Device": "ac50bhe",
    "Model": "AC50BHE"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "50b Helium",
    "Device": "ac50bhe",
    "Model": "Archos 50b Helium 4G"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "50b Neon",
    "Device": "ac50bne",
    "Model": "Archos 50b Neon"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "50b Oxygen",
    "Device": "a50box",
    "Model": "Archos 50b Oxygen"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "50b Platinum",
    "Device": "ac50bpl",
    "Model": "Archos 50b Platinum"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "50c Helium",
    "Device": "ac50che",
    "Model": "Archos 50c Helium"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "50c Neon",
    "Device": "ac50cne",
    "Model": "ARCHOS 50c Neon"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "50c Neon",
    "Device": "ac50cne",
    "Model": "Archos 50c Neon"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "50c Oxygen",
    "Device": "a50cox",
    "Model": "Archos 50c Oxygen"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "50c Platinum",
    "Device": "ac50cpl",
    "Model": "Archos 50c Platinum"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "50d Neon",
    "Device": "ac50dne",
    "Model": "Archos 50d Neon"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "50d Oxygen",
    "Device": "ac50dox",
    "Model": "Archos 50d Oxygen"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "50e Helium",
    "Device": "ac50ehe",
    "Model": "Archos 50e Helium"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "50e Neon",
    "Device": "ac50ene",
    "Model": "Archos 50e Neon"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "50f Helium",
    "Device": "ac50fhe",
    "Model": "Archos 50f Helium"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "50f Neon",
    "Device": "ac50fne",
    "Model": "Archos 50F Neon"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "52 Platinum",
    "Device": "ac52pl",
    "Model": "Archos 52 Platinum"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "53 Platinum",
    "Device": "msm8625",
    "Model": "Archos 53 Platinum"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "53 Titanium",
    "Device": "a53ti",
    "Model": "Archos 53 Titanium"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "55 Cobalt Plus",
    "Device": "ac55cop",
    "Model": "Archos 55 Cobalt Plus"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "55 Cobalt Plus",
    "Device": "ac55cop",
    "Model": "Archos 55 Cobalt plus"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "55 Diamond Selfie",
    "Device": "ac55diselfie",
    "Model": "Archos 55 diamond Selfie"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "55 Helium",
    "Device": "ac55he",
    "Model": "Archos 55 Helium"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "55 Helium Plus",
    "Device": "ac55heplus",
    "Model": "Archos 55 Helium Plus"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "55 platinum",
    "Device": "ac55pl",
    "Model": "Archos 55 Platinum"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "55B Cobalt",
    "Device": "ac55bco",
    "Model": "Archos 55B Cobalt"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "55b Platinum",
    "Device": "ac55bpl",
    "Model": "Archos 55B Platinum"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "59 Titanium",
    "Device": "ac59ti",
    "Model": "Archos 59 Titanium"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "59 Xenon",
    "Device": "ac59xe",
    "Model": "Archos 59 Xenon"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "60 Platinum",
    "Device": "ac60pl",
    "Model": "Archos 60 Platinum"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "62 Xenon",
    "Device": "ac62xe",
    "Model": "Archos 62 Xenon"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "64 Xenon",
    "Device": "ac64xe",
    "Model": "Archos 64 Xenon"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "70 Cobalt",
    "Device": "AC70CO",
    "Model": "ARCHOS 70 Cobalt"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "70 Copper",
    "Device": "ac70cv",
    "Model": "Archos 70 Copper"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "70 Helium",
    "Device": "ac70he",
    "Model": "Archos 70 Helium"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "70 Neon",
    "Device": "ac70ne",
    "Model": "Archos 70 Neon"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "70 Neon Plus",
    "Device": "ac70nep",
    "Model": "Archos 70 Neon Plus"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "70 Oxygen",
    "Device": "ac70ox",
    "Model": "Archos 70 Oxygen"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "70 Platinum",
    "Device": "ac70pl",
    "Model": "Archos 70 Platinum"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "70 Platinum 3G",
    "Device": "ac70pl3g",
    "Model": "Archos 70 Platinum 3G"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "70 Platinum v2",
    "Device": "ac70plv4",
    "Model": "Archos 70 Platinum v2"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "70 Titanium",
    "Device": "A70TI",
    "Model": "ARCHOS 70 Titanium"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "70 Xenon",
    "Device": "a70xe",
    "Model": "Archos 70 Xenon"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "70 Xenon Color",
    "Device": "ac70xec",
    "Model": "Archos 70 Xenon Color"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "70 platinum",
    "Device": "ac70plv3",
    "Model": "Archos 70 Platinum v3"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "70b Cobalt",
    "Device": "a70bco",
    "Model": "Archos 70b Cobalt"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "70b Copper",
    "Device": "ac70bcv",
    "Model": "Archos 70b Copper"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "70b Helium",
    "Device": "ac70bhe",
    "Model": "Archos 70b Helium"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "70b Neon",
    "Device": "ac70bne",
    "Model": "Archos 70b Neon"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "70b Titanium",
    "Device": "A70BTI",
    "Model": "ARCHOS 70b TITANIUM"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "70b Xenon",
    "Device": "ac70bxe",
    "Model": "Archos 70b Xenon"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "70c Cobalt",
    "Device": "ac70cco",
    "Model": "Archos 70c Cobalt"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "70c Neon",
    "Device": "ac70cne",
    "Model": "Archos 70c Neon"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "70c Titanium",
    "Device": "ac70cti",
    "Model": "Archos 70c Titanium"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "70c Xenon",
    "Device": "ac70cxe",
    "Model": "Archos 70c Xenon"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "70it 2",
    "Device": "A70it2",
    "Model": "ARCHOS 70it2"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "70it 2",
    "Device": "A70it2",
    "Model": "ARCHOS 70it2G8"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "79 Cobalt",
    "Device": "ac79co",
    "Model": "Archos 79 Cobalt"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "79 Neon",
    "Device": "a79ne",
    "Model": "Archos 79 Neon"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "79 Platinium",
    "Device": "AC79PL",
    "Model": "ARCHOS 79 Platinum"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "79 Xenon",
    "Device": "a79xe",
    "Model": "Archos 79 Xenon"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "80 Carbon",
    "Device": "AC80CA",
    "Model": "ARCHOS 80 Carbon"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "80 Childpad",
    "Device": "A80CHP",
    "Model": "ARCHOS 80 CHILDPAD"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "80 Cobalt",
    "Device": "A80CO",
    "Model": "ARCHOS 80 COBALT"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "80 G9",
    "Device": "A80",
    "Model": "ARCHOS 80G9"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "80 Helium",
    "Device": "ac80he",
    "Model": "Archos 80 Helium 4G"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "80 Oxygen",
    "Device": "ac80ox",
    "Model": "Archos 80 Oxygen"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "80 Platinum",
    "Device": "A80PL",
    "Model": "ARCHOS 80 Platinum"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "80 Platinum",
    "Device": "ac80cplv2_16G",
    "Model": "Archos 80 Platinum"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "80 Platinum v2",
    "Device": "ac80dplv2",
    "Model": "Archos 80 Platinum v2"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "80 Titanium",
    "Device": "A80TI",
    "Model": "ARCHOS 80 TITANIUM"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "80 XS",
    "Device": "A80XSK",
    "Model": "ARCHOS 80XSK"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "80 Xenon",
    "Device": "A80XE",
    "Model": "Archos 80 Xenon"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "80b Helium",
    "Device": "ac80bhe",
    "Model": "Archos 80b Helium"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "80b Helium",
    "Device": "ac80bhev2",
    "Model": "Archos 80b Helium v2"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "80b Platinum",
    "Device": "A80BPL",
    "Model": "ARCHOS 80b PLATINUM"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "80b xenon",
    "Device": "ac80bxe",
    "Model": "Archos 80b Xenon"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "80c Xenon",
    "Device": "ac80cxe",
    "Model": "Archos 80c Xenon"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "80d Xenon",
    "Device": "ac80dxe",
    "Model": "Archos 80d Xenon"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "9.4\\'\\' FFF",
    "Device": "ac94fff",
    "Model": "9.4\\'\\' FFF"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "90 Copper",
    "Device": "ac90cv",
    "Model": "Archos 90 Copper"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "90 Neon",
    "Device": "a90ne",
    "Model": "Archos 90 Neon"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "90b Copper",
    "Device": "ac90bcv",
    "Model": "Archos 90b Copper"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "90b Neon",
    "Device": "ac90bne",
    "Model": "Archos 90b Neon"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "96 Xenon",
    "Device": "ac96xe",
    "Model": "Archos 96 Xenon"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "97 Carbon",
    "Device": "A97C",
    "Model": "ARCHOS 97 CARBON"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "97 Cobalt",
    "Device": "AC97CO",
    "Model": "Archos 97 Cobalt"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "97 Platinum",
    "Device": "A97PL",
    "Model": "ARCHOS 97 Platinum"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "97 Titanium HD",
    "Device": "A97TIHD",
    "Model": "ARCHOS 97 TITANIUMHD"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "97 Xenon",
    "Device": "A97XE",
    "Model": "ARCHOS 97 XENON"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "97b Platinum",
    "Device": "AC97BPL",
    "Model": "ARCHOS 97b PLATINUM"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "97b Titanium",
    "Device": "A97BTI",
    "Model": "ARCHOS 97B TITANIUM"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "97c Platinum",
    "Device": "ac97cpl",
    "Model": "Archos 97c Platinum"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "AC101XPro4G",
    "Device": "AC101XPro4G",
    "Model": "AC101XPro4G"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "ACT101WF",
    "Device": "ACT101WF",
    "Model": "ACT101WF"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "ALBA 5",
    "Device": "ac50cr4gv2",
    "Model": "ALBA 5"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "ALBA4",
    "Device": "ac40as3g",
    "Model": "ALBA 4"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "ARCHOS",
    "Device": "ARCHOS",
    "Model": "ARCHOS T96 WIFI_EEA_V2"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "ARCHOS T101 4G",
    "Device": "act1014g",
    "Model": "Archos T 101 4G"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "ARCHOS T101HD 4G",
    "Device": "act101hd4g2",
    "Model": "ARCHOS T101 HD 4G"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "ARCHOS T96 3G_EEA",
    "Device": "ARCHOST963G",
    "Model": "ARCHOS T96 3G_EEA"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "ARCHOS T96 WIFI_EEA",
    "Device": "ARCHOST96",
    "Model": "ARCHOS T96 WIFI_EEA"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "ARCHOST963G",
    "Device": "ARCHOST963G",
    "Model": "ARCHOS T96 3G"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "AT101FHD2WF_EEA",
    "Device": "act101fhd2wf",
    "Model": "ARCHOS T101 FHD2 WIFI"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "AWACT80HDWF_EEA",
    "Device": "act80hdwf",
    "Model": "ARCHOS T80 HD WIFI"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "Alba 10",
    "Device": "ac101cplv3",
    "Model": "ALBA 10 TABLET"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "Alba 10",
    "Device": "ac101cpl",
    "Model": "Alba 10"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "Alba 4",
    "Device": "ac40he",
    "Model": "Alba 4.0\" Smartphone"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "Alba 4",
    "Device": "ac40ne",
    "Model": "ALBA 4"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "Alba 4\" Android",
    "Device": "ac40dti",
    "Model": "Alba 4\" Android"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "Alba 5",
    "Device": "ac50dne",
    "Model": "ALBA 5"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "Alba 5",
    "Device": "ac50fne",
    "Model": "ALBA 5"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "Alba 7",
    "Device": "ac70plv5",
    "Model": "ALBA 7 TABLET"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "Alba 7\\'\\'",
    "Device": "ac70plv4",
    "Model": "Alba 7"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "Alba 7\\'\\'",
    "Device": "ac70plv4",
    "Model": "Alba 7"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "Alba 8",
    "Device": "ac80cplv2",
    "Model": "Alba 8"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "Alba 8\\'\\'",
    "Device": "ac80cplv2_16G",
    "Model": "Alba 8"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "ArcBook",
    "Device": "a101db",
    "Model": "Archos 101 DB"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "Archos",
    "Device": "ac101aswf",
    "Model": "Archos Access 101 Wifi"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "Archos",
    "Device": "ac101cr3gv5",
    "Model": "Archos Core 101 3G v5"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "Archos",
    "Device": "ac101hello",
    "Model": "Archos Hello 10"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "Archos",
    "Device": "ac57as3g",
    "Model": "Archos Access 57 3G"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "Archos",
    "Device": "ac68oxxl",
    "Model": "Archos Oxygen 68XL"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "Archos 101 Oxygen 4G",
    "Device": "ac101ox4g",
    "Model": "Archos 101 Oxygen 4G"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "Archos 101 Platinum 3G",
    "Device": "ac101pl3g",
    "Model": "Archos 101 Platinium 3G"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "Archos 101 Platinum 3G",
    "Device": "ac101pl3gv2",
    "Model": "Archos 101 Platinum 3G"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "Archos 101b Oxygen",
    "Device": "ac101boxv2",
    "Model": "Archos 101b Oxygen"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "Archos 101b Oxygen",
    "Device": "ac101boxv3",
    "Model": "Archos 101b Oxygen"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "Archos 101b Xenon",
    "Device": "ac101bxev3",
    "Model": "Archos 101b Xenon"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "Archos 101b Xenon",
    "Device": "ac101bxev3",
    "Model": "Archos 101b Xenon v3"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "Archos 101c Helium",
    "Device": "ac101che",
    "Model": "Archos 101c Helium"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "Archos 101c Platinum",
    "Device": "ac101cplv3",
    "Model": "Archos 101c Platinum"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "Archos 101c Xenon",
    "Device": "ac101cxev2",
    "Model": "Archos 101c Xenon"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "Archos 116 Neon",
    "Device": "ac116ne",
    "Model": "Archos 116 Neon"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "Archos 156 Oxygen",
    "Device": "ac156ox",
    "Model": "Archos 156 Oxygen"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "Archos 50c Platinum",
    "Device": "ac80cplv3",
    "Model": "ALBA 8 TABLET"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "Archos 70 Oxygen",
    "Device": "ac70oxv2",
    "Model": "Archos 70 Oxygen"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "Archos 70 platinum",
    "Device": "ac70plv5",
    "Model": "Archos 70 Platinum"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "Archos 70d Titanium",
    "Device": "ac70dti",
    "Model": "Archos 70d Titanium"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "Archos 79b Neon",
    "Device": "ac79bnev2",
    "Model": "Archos 79b Neon"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "Archos 80 Oxygen",
    "Device": "ac80oxv2",
    "Model": "Archos 80 Oxygen"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "Archos 80c Platinum",
    "Device": "ac80cplv3",
    "Model": "Archos 80c Platinum"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "Archos 97c Platinum",
    "Device": "ac97cplv2",
    "Model": "Archos 97c Platinum"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "Archos Acces 101 3G",
    "Device": "ac101as3gv2",
    "Model": "Archos Access 101 3G V2"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "Archos Access 101 3G",
    "Device": "ac101as3g",
    "Model": "Archos Access 101 3G"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "Archos Access 101 3G V3",
    "Device": "ac101as3gv3",
    "Model": "Archos Access 101 3G v3"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "Archos Access 101 Wifi v2",
    "Device": "ac101aswfv2",
    "Model": "Archos Access 101 Wifi v2"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "Archos Access 40 3G",
    "Device": "ac40as3g",
    "Model": "Archos Access 40 3G"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "Archos Access 40 4G",
    "Device": "ac40as4g",
    "Model": "Archos Access 40 4G"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "Archos Access 45 4G",
    "Device": "ac45as4g",
    "Model": "Archos Access 45 4G"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "Archos Access 50 3G",
    "Device": "ac50as3g",
    "Model": "Archos Access 50 3G"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "Archos Access 50 4G",
    "Device": "ac50as4g",
    "Model": "Archos Access 50 4G"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "Archos Access 50 Color 3G",
    "Device": "ac50asclr3g",
    "Model": "Archos Access 50 Color 3G"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "Archos Access 50 Color 4G",
    "Device": "ac50asclr4g",
    "Model": "Archos Access 50 Color 4G"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "Archos Access 50S 4G",
    "Device": "ac50ass4g",
    "Model": "Archos Access 50S 4G"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "Archos Access 55 3G",
    "Device": "ac55as3g",
    "Model": "Archos Access 55 3G"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "Archos Access 57 4G",
    "Device": "ac57as4g",
    "Model": "Archos Access 57 4G"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "Archos Access 70 3G",
    "Device": "ac70as3g",
    "Model": "Archos Access 70 3G"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "Archos Access 70 Wifi",
    "Device": "ac70aswf",
    "Model": "Archos Access 70 Wifi"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "Archos Core 101 3G",
    "Device": "ac101cr3g",
    "Model": "Archos Core 101 3G"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "Archos Core 101 3G",
    "Device": "ac101cr3gv2",
    "Model": "Archos Core 101 3G"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "Archos Core 101 3G",
    "Device": "ac101cr3gv3",
    "Model": "Archos Core 101 3G"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "Archos Core 101 3G V4",
    "Device": "ac101cr3gv4",
    "Model": "Archos Core 3g v4"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "Archos Core 101 4G",
    "Device": "ac101cr4g",
    "Model": "Archos Core 101 4G"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "Archos Core 101 4G",
    "Device": "ac101cr4gv3",
    "Model": "Archos Core 101 4G"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "Archos Core 50 4G",
    "Device": "ac50cr4g",
    "Model": "Archos Core 50 4G"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "Archos Core 50 4G",
    "Device": "ac50cr4gv2",
    "Model": "Archos Phone"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "Archos Core 50P",
    "Device": "ac50crp",
    "Model": "Archos Core 50P"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "Archos Core 55 4G",
    "Device": "ac55cr4g",
    "Model": "Archos Core 55 4G"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "Archos Core 55P",
    "Device": "ac55crp",
    "Model": "Archos Core 55P"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "Archos Core 55S",
    "Device": "ac55crs",
    "Model": "Archos Core 55S"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "Archos Core 55S Ultra",
    "Device": "ac55crsultra",
    "Model": "Archos Core 55S Ultra"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "Archos Core 57S",
    "Device": "ac57crs",
    "Model": "Archos Core 57S"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "Archos Core 57S Ultra",
    "Device": "ac57crsultra",
    "Model": "Archos Core 57S Ultra"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "Archos Core 60S",
    "Device": "ac60crs",
    "Model": "Archos Core 60S"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "Archos Core 62S",
    "Device": "ac62crs",
    "Model": "Archos Core 62S"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "Archos Core 70 3G",
    "Device": "ac70cr3g",
    "Model": "Archos Core 70 3G"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "Archos Core 70 3G",
    "Device": "ac70cr3gv2",
    "Model": "Archos Core 70 3G"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "Archos Core 80 Wifi",
    "Device": "ac80crwf",
    "Model": "Archos Core 80 Wifi"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "Archos Hello 5",
    "Device": "ac50hello",
    "Model": "Archos Hello 5"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "Archos Hello 7",
    "Device": "ac70hello",
    "Model": "Archos Hello 7"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "Archos Oxygen 101S",
    "Device": "ac101sox",
    "Model": "Archos Oxygen 101S"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "Archos Oxygen 101S Ardoiz",
    "Device": "ac101soxaz",
    "Model": "Archos Oxygen 101S ARDOIZ"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "Archos Oxygen 57",
    "Device": "ac57ox",
    "Model": "Archos Oxygen 57"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "Archos Oxygen 63",
    "Device": "ac63ox",
    "Model": "Archos Oxygen 63"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "Archos Saphir 50X",
    "Device": "ac50sax",
    "Model": "Archos Saphir 50X"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "Archos Sense 101X",
    "Device": "ac101xse",
    "Model": "Archos Sense 101 X"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "Archos Sense 47 X",
    "Device": "ac47xse",
    "Model": "Archos Sense 47 X"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "Archos Sense 50 DC",
    "Device": "ac50sedc",
    "Model": "Archos Sense 50 DC"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "Archos Sense 50X",
    "Device": "ac50xse",
    "Model": "Archos Sense 50X"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "Archos Sense 55 DC",
    "Device": "ac55sedc",
    "Model": "Archos Sense 55 DC"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "Archos Sense 55 DC",
    "Device": "ac55sedcv2",
    "Model": "Archos Phone"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "Archos Sense 55 S",
    "Device": "ac55ses",
    "Model": "Archos Sense 55 S"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "Archos T 80 W",
    "Device": "act80w",
    "Model": "Archos T 80 W"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "Archos T101X 4G",
    "Device": "act101x4g",
    "Model": "Archos T 101X 4G"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "Archos80cpl_loreal",
    "Device": "ac80cpl",
    "Model": "Archos 80c Platinum"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "Auchan QiLive 45",
    "Device": "ql45",
    "Model": "Qilive 45"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "Auchan QiLive 50",
    "Device": "ql50",
    "Model": "Qilive 50"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "Auchan Qilive 40",
    "Device": "ql40",
    "Model": "Qilive 40"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "Auchan Qilive8",
    "Device": "QiLive8",
    "Model": "QiLive 8"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "Auchan Qilive8QC",
    "Device": "QiLive8QC",
    "Model": "QiLive 8QC"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "Auchan Qilive97",
    "Device": "QiLive97",
    "Model": "QiLive 97"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "Auchan Qilive97R",
    "Device": "QiLive97R",
    "Model": "QiLive 97R"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "Auchan Selecline 10",
    "Device": "SELECLINE10",
    "Model": "Selecline 10"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "BUSH SPIRA B3 5.5",
    "Device": "ac55cop",
    "Model": "BUSH SPIRA B3 5.5"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "BUSH SPIRA B5 POWER",
    "Device": "ac50crp",
    "Model": "BUSH SPIRA B5 POWER"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "BUSH SPIRA D3 5",
    "Device": "ac50dox",
    "Model": "BUSH SPIRA D3 5"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "BUSH SPIRA D5 Dual Camera",
    "Device": "ac50sedc",
    "Model": "BUSH SPIRA D5 Dual Camera"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "BUSH SPIRA D5.5 Dual Camera",
    "Device": "ac55sedcv2",
    "Model": "BUSH SPIRA D5.5 Dual Camera"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "Bush 10\\'\\'",
    "Device": "ac101dplv2",
    "Model": "Bush 10\" Android"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "Bush 10.0 MyTablet",
    "Device": "ac101dpl",
    "Model": "Bush 10.0 MyTablet"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "Bush 4\" Android Phone",
    "Device": "ac40cti",
    "Model": "Bush 4 Android"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "Bush 5 4G",
    "Device": "ac50heplus",
    "Model": "Bush 5\" 4G"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "Bush 5 4G",
    "Device": "ac50heplus",
    "Model": "Bush Spira C2 5\" Smartphone"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "Bush 5 4G",
    "Device": "ac55heplus",
    "Model": "Bush 5.5\" 4G"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "Bush 5 4G",
    "Device": "ac55heplus",
    "Model": "Bush Spira D2 5.5\" Smartphone"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "Bush 5\" Android",
    "Device": "ac50cne",
    "Model": "Bush 5\" Android"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "Bush 5\" Android Phone",
    "Device": "ac50bne",
    "Model": "BUSH 5 Android"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "Bush 7.0 MyTablet",
    "Device": "ac70pl",
    "Model": "Bush 7.0 MyTablet"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "Bush 7.85 My Tablet",
    "Device": "ac79bu",
    "Model": "Archos 79c Neon"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "Bush 8",
    "Device": "ac80bhe",
    "Model": "Bush 8\" LTE Android"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "Bush 8\\'\\'",
    "Device": "ac80dpl",
    "Model": "Bush 8 Android"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "Bush 8.0 MyTablet",
    "Device": "ac80cpl",
    "Model": "Bush 8.0 MyTablet"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "Bush MyTablet 7",
    "Device": "ac70bu",
    "Model": "Archos 70 Carbon"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "Bush MyTablet 7",
    "Device": "ac70bu",
    "Model": "BUSH 7.0 TABLET"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "Bush Mytablet 2",
    "Device": "a80bu",
    "Model": "Bush Mytablet 2"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "Bush Spira B1 10.1",
    "Device": "ac101dplv3a6",
    "Model": "Bush Spira B1 10.1"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "Bush Spira B1 10.1\\'\\'",
    "Device": "ac101dplv3",
    "Model": "Bush Spira B1 10.1"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "Bush Spira B1 8\\'\\'",
    "Device": "ac80dplv2",
    "Model": "Bush Spira B1 8"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "Bush Spira B2 8 tablet",
    "Device": "ac80ox",
    "Model": "Bush Spira B2 8 tablet"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "ChefPad",
    "Device": "A97CFP",
    "Model": "Archos Chefpad"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "Diamond 2 plus",
    "Device": "ac55di2plus",
    "Model": "Archos 55 Diamond 2 Plus"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "Diamond Plus",
    "Device": "ac55diplus",
    "Model": "Archos 55 Diamond Plus"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "Diamond Plus",
    "Device": "ac55diplus",
    "Model": "Archos Diamond Plus"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "Diamond S",
    "Device": "ac50dis",
    "Model": "Archos Diamond S"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "FamilyPad 2",
    "Device": "A133FP2",
    "Model": "ARCHOS FAMILYPAD 2"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "Fieldbook G1",
    "Device": "LIFBG1",
    "Model": "Logic Fieldbook G1"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "GamePad",
    "Device": "A70GP",
    "Model": "ARCHOS GAMEPAD"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "GamePad 2",
    "Device": "A70GP2",
    "Model": "ARCHOS GAMEPAD2"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "KUNO 4+",
    "Device": "kuno4p",
    "Model": "KUNO 4+"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "Kodak Tab 10",
    "Device": "ac101tr",
    "Model": "KODAK Tablet 10"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "Kodak Tab 7",
    "Device": "ac70tr",
    "Model": "KODAK Tablet 7"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "Kuno",
    "Device": "KUNO4",
    "Model": "KUNO4"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "Logic Instrument Fieldbook F1B",
    "Device": "lifbf1b",
    "Model": "Logic Instrument Fieldbook F1B"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "My Tablet 101",
    "Device": "ac101bu",
    "Model": "BUSH 10.1 TABLET"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "QiLive 101",
    "Device": "aqilive101",
    "Model": "QILIVE 101"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "Qilive 45 - 4G",
    "Device": "ql45lte",
    "Model": "Qilive 45 - 4G"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "Qilive 50 QC",
    "Device": "ql50qc",
    "Model": "Qilive 50 QC"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "Qilive 53",
    "Device": "msm8625",
    "Model": "Qilive 53"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "Qilive 7",
    "Device": "qilive7",
    "Model": "Qilive 7"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "Qilive 97R2",
    "Device": "qilive97r2",
    "Model": "Qilive 97R-2"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "Qilive79",
    "Device": "Qilive79",
    "Model": "Qilive 79"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "Qilive7V2",
    "Device": "ql70v2",
    "Model": "Qilive 70v2"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "Quechua Phone 5",
    "Device": "A50RG11",
    "Model": "Quechua Phone 5"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "Quechua Tablet 8",
    "Device": "A80RG11",
    "Model": "A80RG11"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "SPAC101SOXUL_EEA",
    "Device": "ac101soxul",
    "Model": "ARCHOS 101S Oxygen Ultra"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "SPACT101FHD4G",
    "Device": "ACT101FHD4G",
    "Model": "ARCHOS T101 FHD 4G ULTRA"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "SPACT101HD24G_EEA",
    "Device": "act101hd24g",
    "Model": "ARCHOS T101 HD2 4G"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "SPACT105FHD4G_EEA",
    "Device": "act105fhd4g",
    "Model": "ARCHOS T105 FHD 4G"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "SPACT105FHDWFUL_EEA",
    "Device": "act105fhdwful",
    "Model": "ARCHOS T105FHD WIFI ULTRA"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "SPACT110FHD4GULTRA_EEA",
    "Device": "ACT110FHD4GULTRA",
    "Model": "ARCHOS T110 FHD 4G ULTRA"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "SPAT101FHDW_EEA",
    "Device": "at101fhdw",
    "Model": "ARCHOS T101 FHD WiFi"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "SPAZA101SOXUL_EEA",
    "Device": "aza101soxul",
    "Model": "Tikeasy 10d"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "Smart Home Tablet",
    "Device": "hometablet",
    "Model": "Archos Smart Home Tablet"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "Smarthome La Poste",
    "Device": "hometablet",
    "Model": "Archos Smart Home Tablet"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "TV Connect",
    "Device": "LUDO",
    "Model": "ARCHOS LUDOG10"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "X18_Ultra",
    "Device": "X18_Ultra",
    "Model": "X18_Ultra"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "X67 5G",
    "Device": "ac67x5g",
    "Model": "X67 5G"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "act101hd",
    "Device": "act101hd",
    "Model": "Archos T101 HD"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "act101hd3",
    "Device": "act101hd3",
    "Model": "ARCHOS T101HD3 WiFi"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "act101hdp",
    "Device": "act101hdp",
    "Model": "Archos T101 HD PLUS"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "act101hdwf",
    "Device": "act101hdwf",
    "Model": "Archos T101 HD WIFI"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "alba 10",
    "Device": "ac101cplv2",
    "Model": "ALBA 10 TABLET"
  },
  {
    "Retail Branding": "Archos",
    "Marketing Name": "alba 10",
    "Device": "ac101cplv2",
    "Model": "Alba 10"
  },
  {
    "Retail Branding": "Arielli",
    "Marketing Name": "Smart TV",
    "Device": "alimos",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "Arielli",
    "Marketing Name": "Smart TV",
    "Device": "dangni",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "Arima",
    "Marketing Name": "A100",
    "Device": "A100",
    "Model": "A100"
  },
  {
    "Retail Branding": "Arirang",
    "Marketing Name": "ATPA801_1",
    "Device": "ATPA801_1",
    "Model": "ATPA801_1"
  },
  {
    "Retail Branding": "Arival",
    "Marketing Name": "BioniQP116",
    "Device": "BioniQP116",
    "Model": "BioniQP116"
  },
  {
    "Retail Branding": "Ark",
    "Marketing Name": "Bebefit M551",
    "Device": "Benefit_M551",
    "Model": "Benefit_M551"
  },
  {
    "Retail Branding": "Ark",
    "Marketing Name": "Benefit M503",
    "Device": "Benefit_M503",
    "Model": "Benefit_M503"
  },
  {
    "Retail Branding": "Ark",
    "Marketing Name": "Benefit M505",
    "Device": "Benefit_M505",
    "Model": "Benefit_M505"
  },
  {
    "Retail Branding": "Ark",
    "Marketing Name": "Benefit M8",
    "Device": "Benefit_M8",
    "Model": "Benefit_M8"
  },
  {
    "Retail Branding": "Ark",
    "Marketing Name": "Benefit S505",
    "Device": "Benefit_S505",
    "Model": "Benefit_S505"
  },
  {
    "Retail Branding": "Ark",
    "Marketing Name": "Benefit_M9",
    "Device": "Benefit_M9",
    "Model": "Benefit_M9"
  },
  {
    "Retail Branding": "Ark",
    "Marketing Name": "Benefit_Note 1",
    "Device": "Benefit_Note_1",
    "Model": "Benefit_Note_1"
  },
  {
    "Retail Branding": "Ark",
    "Marketing Name": "Impulse P2",
    "Device": "Impulse_P2",
    "Model": "Impulse_P2"
  },
  {
    "Retail Branding": "Ark",
    "Marketing Name": "MemoPad_T1",
    "Device": "MemoPad_T1",
    "Model": "MemoPad_T1"
  },
  {
    "Retail Branding": "Ark",
    "Marketing Name": "S504",
    "Device": "S504",
    "Model": "S504"
  },
  {
    "Retail Branding": "Ark",
    "Marketing Name": "Wizard 1",
    "Device": "Wizard_1",
    "Model": "Wizard_1"
  },
  {
    "Retail Branding": "Arknikko",
    "Marketing Name": "MemoPad_T3",
    "Device": "MemoPad_T3_EEA",
    "Model": "MemoPad_T3"
  },
  {
    "Retail Branding": "Arknikko",
    "Marketing Name": "Memopad_T4",
    "Device": "Memopad_T4",
    "Model": "Memopad_T4"
  },
  {
    "Retail Branding": "Arknikko",
    "Marketing Name": "SophPad_X11",
    "Device": "SophPad_X11",
    "Model": "SophPad_X11"
  },
  {
    "Retail Branding": "Arknikko",
    "Marketing Name": "SophPad_X22",
    "Device": "SophPad_X22_EEA",
    "Model": "SophPad_X22"
  },
  {
    "Retail Branding": "Arknikko",
    "Marketing Name": "SophPad_Z11",
    "Device": "SophPad_Z11",
    "Model": "SophPad_Z11"
  },
  {
    "Retail Branding": "Arknikko",
    "Marketing Name": "Sophpad_X21",
    "Device": "Sophpad_X21",
    "Model": "Sophpad_X21"
  },
  {
    "Retail Branding": "Arknikko",
    "Marketing Name": "Sophpad_Z21",
    "Device": "Sophpad_Z21",
    "Model": "Sophpad_Z21"
  },
  {
    "Retail Branding": "Aroot",
    "Marketing Name": "AM-F2000N",
    "Device": "AM-F2000N",
    "Model": "AM-F2000N"
  },
  {
    "Retail Branding": "Arris",
    "Marketing Name": "VIP6102W Genesis",
    "Device": "vip6102w",
    "Model": "VIP6102W"
  },
  {
    "Retail Branding": "Arris",
    "Marketing Name": "VIP7100 A",
    "Device": "SFO",
    "Model": "VIP7100 A"
  },
  {
    "Retail Branding": "Arris",
    "Marketing Name": "VIP7300",
    "Device": "f503",
    "Model": "VIP7300"
  },
  {
    "Retail Branding": "Arrow",
    "Marketing Name": "M916H",
    "Device": "M916H",
    "Model": "M916H"
  },
  {
    "Retail Branding": "Arrow",
    "Marketing Name": "RO-43LCS",
    "Device": "ikebukuro",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "Artek",
    "Marketing Name": "Beat",
    "Device": "Beat",
    "Model": "Beat"
  },
  {
    "Retail Branding": "Artel",
    "Marketing Name": "ALO",
    "Device": "ALO",
    "Model": "ALO"
  },
  {
    "Retail Branding": "Artel",
    "Marketing Name": "Android TV",
    "Device": "R1",
    "Model": "ATV R1"
  },
  {
    "Retail Branding": "Artel",
    "Marketing Name": "Android TV",
    "Device": "R2",
    "Model": "ATV R2"
  },
  {
    "Retail Branding": "Artel",
    "Marketing Name": "Artel 2K TV",
    "Device": "shinagawa",
    "Model": "Artel 2K TV"
  },
  {
    "Retail Branding": "Artel",
    "Marketing Name": "Artel Air",
    "Device": "Artel_Air",
    "Model": "Artel Air"
  },
  {
    "Retail Branding": "Artel",
    "Marketing Name": "Artel Android TV",
    "Device": "SW4H",
    "Model": "Artel Android TV"
  },
  {
    "Retail Branding": "Artel",
    "Marketing Name": "Artel Quadro",
    "Device": "Artel_Quadro",
    "Model": "Artel Quadro"
  },
  {
    "Retail Branding": "Artel",
    "Marketing Name": "Artel Quadro Pro",
    "Device": "Artel_Quadro_Pro",
    "Model": "Artel Quadro Pro"
  },
  {
    "Retail Branding": "Artel",
    "Marketing Name": "Artel Tesla",
    "Device": "Artel_Tesla",
    "Model": "Artel Tesla"
  },
  {
    "Retail Branding": "Artel",
    "Marketing Name": "Artel Tomchi",
    "Device": "Artel_Tomchi",
    "Model": "Artel Tomchi"
  },
  {
    "Retail Branding": "Artel",
    "Marketing Name": "Artel U5",
    "Device": "U5",
    "Model": "U5"
  },
  {
    "Retail Branding": "Artel",
    "Marketing Name": "Artel_Premium",
    "Device": "Artel_Premium",
    "Model": "Artel Premium"
  },
  {
    "Retail Branding": "Artel",
    "Marketing Name": "Artel_T10",
    "Device": "Artel_T10",
    "Model": "Artel T10"
  },
  {
    "Retail Branding": "Artel",
    "Marketing Name": "GAP YOQ",
    "Device": "GAP_YOQ",
    "Model": "GAP YOQ"
  },
  {
    "Retail Branding": "Artel",
    "Marketing Name": "GAPYOQ",
    "Device": "GAPYOQ",
    "Model": "GAP"
  },
  {
    "Retail Branding": "Artel",
    "Marketing Name": "R3",
    "Device": "R3",
    "Model": "R3"
  },
  {
    "Retail Branding": "Artel",
    "Marketing Name": "R3_GTV",
    "Device": "R3_GTV",
    "Model": "R3G"
  },
  {
    "Retail Branding": "Artel",
    "Marketing Name": "R4",
    "Device": "R4",
    "Model": "R4"
  },
  {
    "Retail Branding": "Artel",
    "Marketing Name": "R4_GTV",
    "Device": "R4_GTV",
    "Model": "R4G"
  },
  {
    "Retail Branding": "Artel",
    "Marketing Name": "Starpad_T-181",
    "Device": "Starpad",
    "Model": "Starpad_T-181"
  },
  {
    "Retail Branding": "Artel",
    "Marketing Name": "U1",
    "Device": "U1",
    "Model": "U1"
  },
  {
    "Retail Branding": "Artel",
    "Marketing Name": "U1_MINI",
    "Device": "U1_MINI",
    "Model": "U1 MINI"
  },
  {
    "Retail Branding": "Artel",
    "Marketing Name": "U2",
    "Device": "U2",
    "Model": "U2"
  },
  {
    "Retail Branding": "Artel",
    "Marketing Name": "U3",
    "Device": "U3",
    "Model": "U3"
  },
  {
    "Retail Branding": "Artel",
    "Marketing Name": "U3 4G",
    "Device": "U3_4G",
    "Model": "U3_4G"
  },
  {
    "Retail Branding": "Artel",
    "Marketing Name": "U4",
    "Device": "U4",
    "Model": "U4"
  },
  {
    "Retail Branding": "Artia",
    "Marketing Name": "Artia SP545C",
    "Device": "SP545C",
    "Model": "SP545C"
  },
  {
    "Retail Branding": "Artia",
    "Marketing Name": "SP545CV",
    "Device": "SP545C",
    "Model": "SP545C"
  },
  {
    "Retail Branding": "Artia",
    "Marketing Name": "SP545C_1",
    "Device": "SP545C",
    "Model": "SP545C"
  },
  {
    "Retail Branding": "Artizlee",
    "Marketing Name": "Artizlee S9",
    "Device": "Artizlee_S9",
    "Model": "Artizlee_S9"
  },
  {
    "Retail Branding": "Arçelik",
    "Marketing Name": "Arcelik Android TV",
    "Device": "shinagawa",
    "Model": "Arcelik Android TV"
  },
  {
    "Retail Branding": "Arçelik",
    "Marketing Name": "Arçelik Android TV",
    "Device": "kunyang",
    "Model": "Arcelik Android TV"
  },
  {
    "Retail Branding": "Arçelik",
    "Marketing Name": "Arçelik Android TV",
    "Device": "millbrae",
    "Model": "Arcelik Android TV"
  },
  {
    "Retail Branding": "Arçelik",
    "Marketing Name": "Arçelik Android TV",
    "Device": "sinchon",
    "Model": "Arcelik Android TV"
  },
  {
    "Retail Branding": "Arçelik",
    "Marketing Name": "Arçelik UHD Android TV",
    "Device": "kunyang",
    "Model": "Arcelik Android UHD TV"
  },
  {
    "Retail Branding": "Asanzo",
    "Marketing Name": "A1",
    "Device": "A1",
    "Model": "A1"
  },
  {
    "Retail Branding": "Asanzo",
    "Marketing Name": "ASANZO 2K TV",
    "Device": "shibuya",
    "Model": "ASANZO 2K TV"
  },
  {
    "Retail Branding": "Asanzo",
    "Marketing Name": "ASANZO A2",
    "Device": "ASANZO_A2",
    "Model": "ASANZO A2"
  },
  {
    "Retail Branding": "Asanzo",
    "Marketing Name": "Asanzo",
    "Device": "SW4H",
    "Model": "ASG 4K TV"
  },
  {
    "Retail Branding": "Asanzo",
    "Marketing Name": "E Series",
    "Device": "umeda",
    "Model": "E Series"
  },
  {
    "Retail Branding": "Asanzo",
    "Marketing Name": "EX FF Series",
    "Device": "SW6H",
    "Model": "EX FF Series"
  },
  {
    "Retail Branding": "Asanzo",
    "Marketing Name": "EX Series",
    "Device": "SW6H",
    "Model": "EX Series"
  },
  {
    "Retail Branding": "Asanzo",
    "Marketing Name": "S3 Plus",
    "Device": "ASANZO_S3_PLUS",
    "Model": "ASANZO_S3_PLUS"
  },
  {
    "Retail Branding": "Asanzo",
    "Marketing Name": "S6",
    "Device": "S6",
    "Model": "S6"
  },
  {
    "Retail Branding": "Ascom",
    "Marketing Name": "Ascom Myco 3",
    "Device": "ABAA",
    "Model": "Ascom Myco 3 Wi-Fi"
  },
  {
    "Retail Branding": "Ascom",
    "Marketing Name": "Ascom Myco 3",
    "Device": "ABBA",
    "Model": "Ascom Myco 3 Wi-Fi EU"
  },
  {
    "Retail Branding": "Ascom",
    "Marketing Name": "Ascom Myco 3",
    "Device": "ACAA",
    "Model": "Ascom Myco 3 Cellular Wi-Fi"
  },
  {
    "Retail Branding": "Ascom",
    "Marketing Name": "Ascom Myco 3",
    "Device": "ACBA",
    "Model": "Ascom Myco 3 Cellular Wi-Fi EU"
  },
  {
    "Retail Branding": "Ascom",
    "Marketing Name": "Ascom Myco 3",
    "Device": "ADAA",
    "Model": "Ascom Myco 3 DECT Wi-Fi"
  },
  {
    "Retail Branding": "Ascom",
    "Marketing Name": "Ascom Myco 3",
    "Device": "ADAA",
    "Model": "Ascom Myco 3 DECT Wi-Fi EU"
  },
  {
    "Retail Branding": "Ascom",
    "Marketing Name": "Ascom Myco 4",
    "Device": "SH4-1",
    "Model": "Myco 4 Cellular Wi-Fi"
  },
  {
    "Retail Branding": "Ascom",
    "Marketing Name": "Ascom Myco 4",
    "Device": "SH4-1",
    "Model": "Myco 4 Cellular Wi-Fi EEA"
  },
  {
    "Retail Branding": "Ascom",
    "Marketing Name": "Ascom Myco 4",
    "Device": "SH4-1",
    "Model": "Myco 4 Slim Cellular Wi-Fi"
  },
  {
    "Retail Branding": "Ascom",
    "Marketing Name": "Ascom Myco 4",
    "Device": "SH4-1",
    "Model": "Myco 4 Slim Cellular Wi-Fi EEA"
  },
  {
    "Retail Branding": "Ascom",
    "Marketing Name": "Ascom Myco 4",
    "Device": "SH4-2",
    "Model": "Myco 4 DECT Wi-Fi"
  },
  {
    "Retail Branding": "Ascom",
    "Marketing Name": "Ascom Myco 4",
    "Device": "SH4-2",
    "Model": "Myco 4 DECT Wi-Fi EEA"
  },
  {
    "Retail Branding": "Ascom",
    "Marketing Name": "Ascom Myco 4",
    "Device": "SH4-2",
    "Model": "Myco 4 Slim"
  },
  {
    "Retail Branding": "Ascom",
    "Marketing Name": "Ascom Myco 4",
    "Device": "SH4-2",
    "Model": "Myco 4 Slim EEA"
  },
  {
    "Retail Branding": "Ascom",
    "Marketing Name": "Ascom Myco 4",
    "Device": "SH4-2",
    "Model": "Myco 4 Wi-Fi"
  },
  {
    "Retail Branding": "Ascom",
    "Marketing Name": "Ascom Myco 4",
    "Device": "SH4-2",
    "Model": "Myco 4 Wi-Fi EEA"
  },
  {
    "Retail Branding": "Ascom Wireless Solutions",
    "Marketing Name": "Ascom Myco 2 Cellular",
    "Device": "ACBB",
    "Model": "SH1"
  },
  {
    "Retail Branding": "Ascom Wireless Solutions",
    "Marketing Name": "Ascom Myco 2 WiFi",
    "Device": "ABBB",
    "Model": "SH1"
  },
  {
    "Retail Branding": "Ascom Wireless Solutions",
    "Marketing Name": "Ascom Myco 2 WiFi",
    "Device": "ACBA",
    "Model": "SH1"
  },
  {
    "Retail Branding": "Ascom Wireless Solutions",
    "Marketing Name": "Ascom Myco Cellular",
    "Device": "ACBA",
    "Model": "SH1"
  },
  {
    "Retail Branding": "Ascom Wireless Solutions",
    "Marketing Name": "Ascom Myco Cellular",
    "Device": "myco_gms",
    "Model": "SH1"
  },
  {
    "Retail Branding": "Ascom Wireless Solutions",
    "Marketing Name": "Ascom Myco Wi-Fi",
    "Device": "ABBA",
    "Model": "SH1"
  },
  {
    "Retail Branding": "Ashna",
    "Marketing Name": "X55",
    "Device": "X55",
    "Model": "X55"
  },
  {
    "Retail Branding": "Ashna",
    "Marketing Name": "X66",
    "Device": "X66",
    "Model": "X66"
  },
  {
    "Retail Branding": "Ashna",
    "Marketing Name": "Z600",
    "Device": "Z600",
    "Model": "Z600"
  },
  {
    "Retail Branding": "Ashtel",
    "Marketing Name": "RAVOZ Z5 Lite",
    "Device": "RAVOZ_Z5_Lite",
    "Model": "RAVOZ Z5 Lite"
  },
  {
    "Retail Branding": "Ashtel",
    "Marketing Name": "RAVOZ Z7",
    "Device": "RAVOZ_R7",
    "Model": "RAVOZ R7"
  },
  {
    "Retail Branding": "Ashtel",
    "Marketing Name": "RAVOZ_Z5",
    "Device": "RAVOZ_Z5",
    "Model": "RAVOZ Z5"
  },
  {
    "Retail Branding": "Asianet",
    "Marketing Name": "D8109N",
    "Device": "D8109N",
    "Model": "D8109N"
  },
  {
    "Retail Branding": "Askey",
    "Marketing Name": "RC40",
    "Device": "RC40",
    "Model": "RC40"
  },
  {
    "Retail Branding": "Aspera",
    "Marketing Name": "A45",
    "Device": "A45",
    "Model": "A45"
  },
  {
    "Retail Branding": "Aspera",
    "Marketing Name": "A45",
    "Device": "A45_1",
    "Model": "A45"
  },
  {
    "Retail Branding": "Aspera",
    "Marketing Name": "A4G",
    "Device": "A4G",
    "Model": "A4G"
  },
  {
    "Retail Branding": "Aspera",
    "Marketing Name": "AS-10",
    "Device": "AS-10",
    "Model": "AS-10"
  },
  {
    "Retail Branding": "Aspera",
    "Marketing Name": "AS5",
    "Device": "AS5",
    "Model": "AS5"
  },
  {
    "Retail Branding": "Aspera",
    "Marketing Name": "AS57",
    "Device": "AS57",
    "Model": "AS57"
  },
  {
    "Retail Branding": "Aspera",
    "Marketing Name": "AS6",
    "Device": "AS6",
    "Model": "AS6"
  },
  {
    "Retail Branding": "Aspera",
    "Marketing Name": "AS7",
    "Device": "AS7",
    "Model": "AS7"
  },
  {
    "Retail Branding": "Aspera",
    "Marketing Name": "AS8",
    "Device": "AS8",
    "Model": "AS8"
  },
  {
    "Retail Branding": "Aspera",
    "Marketing Name": "AS9",
    "Device": "AS9",
    "Model": "AS9"
  },
  {
    "Retail Branding": "Aspera",
    "Marketing Name": "ASPERA R9",
    "Device": "R9",
    "Model": "ASPERA_R9"
  },
  {
    "Retail Branding": "Aspera",
    "Marketing Name": "ASPERA_R10",
    "Device": "ASPERA_R10",
    "Model": "ASPERA_R10"
  },
  {
    "Retail Branding": "Aspera",
    "Marketing Name": "Aspera Swift",
    "Device": "Aspera_Swift",
    "Model": "Swift"
  },
  {
    "Retail Branding": "Aspera",
    "Marketing Name": "Aspera_Nitro",
    "Device": "Aspera_Nitro",
    "Model": "Nitro"
  },
  {
    "Retail Branding": "Aspera",
    "Marketing Name": "Breeze",
    "Device": "Breeze",
    "Model": "Breeze"
  },
  {
    "Retail Branding": "Aspera",
    "Marketing Name": "Buzz",
    "Device": "Buzz",
    "Model": "Buzz"
  },
  {
    "Retail Branding": "Aspera",
    "Marketing Name": "GEM",
    "Device": "GEM",
    "Model": "GEM"
  },
  {
    "Retail Branding": "Aspera",
    "Marketing Name": "Halo",
    "Device": "Halo",
    "Model": "Halo"
  },
  {
    "Retail Branding": "Aspera",
    "Marketing Name": "JAZZ",
    "Device": "Jazz",
    "Model": "Jazz"
  },
  {
    "Retail Branding": "Aspera",
    "Marketing Name": "Jazz_2",
    "Device": "Jazz_2",
    "Model": "Jazz 2"
  },
  {
    "Retail Branding": "Aspera",
    "Marketing Name": "Nitro2",
    "Device": "Nitro2",
    "Model": "Nitro2"
  },
  {
    "Retail Branding": "Aspera",
    "Marketing Name": "Wren",
    "Device": "Wren",
    "Model": "Wren"
  },
  {
    "Retail Branding": "Aspera",
    "Marketing Name": "e-Chat",
    "Device": "e-Chat",
    "Model": "e-Chat"
  },
  {
    "Retail Branding": "Astak",
    "Marketing Name": "NEOS",
    "Device": "Wenu",
    "Model": "NEOS"
  },
  {
    "Retail Branding": "Astro",
    "Marketing Name": "Genesis_S8",
    "Device": "Astro_Genesis_S8",
    "Model": "Genesis_S8"
  },
  {
    "Retail Branding": "Astro",
    "Marketing Name": "Nova_Phab_M9",
    "Device": "Nova_Phab_M9",
    "Model": "Nova_Phab_M9"
  },
  {
    "Retail Branding": "Astro",
    "Marketing Name": "sooka-TV-v1",
    "Device": "sooka-TV_v1",
    "Model": "sooka-TV-v1"
  },
  {
    "Retail Branding": "Astro Queo",
    "Marketing Name": "A712",
    "Device": "A712",
    "Model": "A712"
  },
  {
    "Retail Branding": "Astro mobile",
    "Marketing Name": "Smart _A1_Plus",
    "Device": "Smart_A1_Plus",
    "Model": "Smart A1 Plus"
  },
  {
    "Retail Branding": "AstroQueo",
    "Marketing Name": "polaris_wifionly",
    "Device": "polaris-wifionly",
    "Model": "A912"
  },
  {
    "Retail Branding": "Astro_Tab",
    "Marketing Name": "A750",
    "Device": "A750",
    "Model": "A750"
  },
  {
    "Retail Branding": "Astro_Tab",
    "Marketing Name": "DCG-P10",
    "Device": "DCG-P10",
    "Model": "DCG-P10"
  },
  {
    "Retail Branding": "Astro_Tab",
    "Marketing Name": "G10",
    "Device": "G10",
    "Model": "G10"
  },
  {
    "Retail Branding": "Astro_Tab",
    "Marketing Name": "K10",
    "Device": "K10",
    "Model": "K10"
  },
  {
    "Retail Branding": "Astrom",
    "Marketing Name": "AST707G",
    "Device": "AST707G",
    "Model": "AST707G"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "",
    "Device": "EP71",
    "Model": "ME171"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "",
    "Device": "TF300T",
    "Model": "ASUS Transformer Pad TF300T"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "",
    "Device": "a10",
    "Model": "Asus A10"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "",
    "Device": "a10",
    "Model": "Garmin-Asus A10"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "",
    "Device": "ventana",
    "Model": "Transformer TF101"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ASUS Chromebook Flip C302",
    "Device": "cave_cheets",
    "Model": "ASUS Chromebook Flip C302"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ASUS Live (G500TG)",
    "Device": "ASUS_Z00YD",
    "Model": "ASUS_Z00YD"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ASUSPRO Tablet (M1000C)",
    "Device": "P023_M",
    "Model": "P023"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ASUSPRO Tablet (M1000CL)",
    "Device": "P01T_M",
    "Model": "P01T"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ASUSPRO Tablet (M700C)",
    "Device": "P01W_M",
    "Model": "P01W"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ASUSPRO Tablet (M700KL)",
    "Device": "P002_M",
    "Model": "P002"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ASUS_WW_2885",
    "Device": "pangyo",
    "Model": "XG34WCDMTG"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "Chromebook C202SA/C300SA/C301SA",
    "Device": "terra_cheets",
    "Model": "ASUS Chromebook C202SA"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "Chromebook Flip C100PA",
    "Device": "",
    "Model": ""
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "Chromebook Flip C100PA",
    "Device": "minnie_cheets",
    "Model": "ASUS Chromebook Flip C100PA"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "Chromebook Flip C101PA",
    "Device": "bob_cheets",
    "Model": "ASUS Chromebook Flip C101PA"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "Chromebook Flip C101PA",
    "Device": "bob_cheets",
    "Model": "bob"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "Commercial tablet 10\" (M1000M)",
    "Device": "P00C_M",
    "Model": "P00C"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "Commercial tablet 10\" (R1000M)",
    "Device": "P00C_M",
    "Model": "P00C"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "Commercial tablet 8\" (M800M)",
    "Device": "P00A_M",
    "Model": "P00A"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "Commercial tablet 8\" (R800M)",
    "Device": "P00A_M",
    "Model": "P00A"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "Cube",
    "Device": "asus_google_cube",
    "Model": "asus_google_cube"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ETBW11AA",
    "Device": "ETBW11AA",
    "Model": "ETBW11AA"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ETBW11AA",
    "Device": "TF101G",
    "Model": "ETBW11AA"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "Eee Pad",
    "Device": "EeePad",
    "Model": "Transformer TF101"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "Eee Pad",
    "Device": "EeePad",
    "Model": "Transformer TF101G"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "Eee Pad Slider",
    "Device": "SL101",
    "Model": "Slider SL101"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "Eee Pad TF101",
    "Device": "TF101",
    "Model": "TF101"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "Eee Pad TF101",
    "Device": "TF101",
    "Model": "Transformer TF101"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "Eee Pad TF101-WiMAX",
    "Device": "TF101-WiMAX",
    "Model": "TF101-WiMAX"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "Eee Pad Transformer",
    "Device": "TF101",
    "Model": "Transformer TF101"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "Eee Pad Transformer Prime",
    "Device": "TF201",
    "Model": "TF201"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "Eee Pad Transformer Prime",
    "Device": "TF201",
    "Model": "Transformer Prime TF201"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "Eee Pad Transformer Prime",
    "Device": "TF201",
    "Model": "Transformer TF201"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "EeePad Slider SL101",
    "Device": "SL101",
    "Model": "Slider SL101"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "Fonepad 7 (FE170CG)",
    "Device": "K012",
    "Model": "K012"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "Fonepad 7 (FE171CG)",
    "Device": "K01N_1",
    "Model": "K01N"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "Fonepad 7 (FE171CG)",
    "Device": "K01N_2",
    "Model": "K01N"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "Fonepad 7 (FE171MG)",
    "Device": "K01F",
    "Model": "K01F"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "Fonepad 7 (FE375CG)",
    "Device": "K019_1",
    "Model": "K019"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "Fonepad 7 (FE375CXG)",
    "Device": "K019_2",
    "Model": "K019"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "Fonepad 7 (FE375CXG)",
    "Device": "K019_3",
    "Model": "K019"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "Fonepad 7 (FE375CXG)",
    "Device": "K019_4",
    "Model": "K019"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "Fonepad 7 (ME175CG)",
    "Device": "K00Z",
    "Model": "K00Z"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "Fonepad 7 (ME372CG)",
    "Device": "K00E",
    "Model": "K00E"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "Fonepad 7 LTE (FE375CL)",
    "Device": "K01Q",
    "Model": "K01Q"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "Fonepad 7 LTE (ME372CL)",
    "Device": "K00Y",
    "Model": "K00Y"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "Fonepad 8 (FE380CG)",
    "Device": "K016_1",
    "Model": "K016"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "Fonepad 8 (FE380CG)",
    "Device": "K016_4",
    "Model": "K016"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "Fonepad 8 (FE380CXG)",
    "Device": "K016_2",
    "Model": "K016"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "Fonepad 8 (FE380CXG)",
    "Device": "K016_3",
    "Model": "K016"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "Fonepad ME371MG",
    "Device": "ME371MG",
    "Model": "ME371MG"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "Fonepad Note 6 (ME560CG)",
    "Device": "K00G",
    "Model": "K00G"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "MeMO PAD",
    "Device": "me172v",
    "Model": "ME172V"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "MeMO Pad (ME103K)",
    "Device": "K01E_1",
    "Model": "K01E"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "MeMO Pad (ME103K)",
    "Device": "K01E_2",
    "Model": "K01E"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "MeMO Pad 10 (ME102A)",
    "Device": "K00F",
    "Model": "K00F"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "MeMO Pad 7 (FE7010CG)",
    "Device": "K012_2",
    "Model": "K012_2"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "MeMO Pad 7 (ME170C)",
    "Device": "K017",
    "Model": "K017"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "MeMO Pad 7 (ME171C)",
    "Device": "K01U_1",
    "Model": "K01U"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "MeMO Pad 7 (ME171C)",
    "Device": "K01U_2",
    "Model": "K01U"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "MeMO Pad 7 (ME176C)",
    "Device": "K013",
    "Model": "K013"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "MeMO Pad 7 (ME176CE)",
    "Device": "K013C",
    "Model": "K013C"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "MeMO Pad 7 (ME176CX)",
    "Device": "K013_1",
    "Model": "K013"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "MeMO Pad 7 (ME572C)",
    "Device": "K007",
    "Model": "K007"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "MeMO Pad 7 (ME70C)",
    "Device": "K01A",
    "Model": "K01A"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "MeMO Pad 7 LTE (ME375CL)",
    "Device": "K00X",
    "Model": "ASUS MeMO Pad 7"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "MeMO Pad 7 LTE (ME572CL)",
    "Device": "K00R",
    "Model": "K00R"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "MeMO Pad 7 LTE (ME7530CL)",
    "Device": "K00X_1",
    "Model": "K00X"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "MeMO Pad 8 (AST21)",
    "Device": "K015",
    "Model": "AST21"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "MeMO Pad 8 (ME181C)",
    "Device": "K011",
    "Model": "K011"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "MeMO Pad 8 (ME181CX)",
    "Device": "K011_1",
    "Model": "K011"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "MeMO Pad 8 (ME581C)",
    "Device": "K01H",
    "Model": "K01H"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "MeMO Pad 8 (ME581CL)",
    "Device": "K015",
    "Model": "K015"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "MeMO Pad FHD 10 (ME302KL)",
    "Device": "ME302KL",
    "Model": "ME302KL"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "MeMO Pad HD 7 (ME173X)",
    "Device": "ME173X",
    "Model": "ME173X"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "MeMO Pad HD 7 (ME173XX)",
    "Device": "K00U",
    "Model": "K00U"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "MeMO Pad HD 8 (ME180A)",
    "Device": "K00L",
    "Model": "K00L"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "MeMO Pad HD7 Dual SIM (ME175KG)",
    "Device": "ASUS-K00S",
    "Model": "ASUS K00S"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "MeMO Pad Smart 10",
    "Device": "ME301T",
    "Model": "ME301T"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "MeMo Pad 10 (ME302C)",
    "Device": "ME302C",
    "Model": "ME302C"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "MeMo Pad HD 7 (ME173XX)",
    "Device": "K00U",
    "Model": "K00U"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "Nexus 7 (2012)",
    "Device": "grouper",
    "Model": "Nexus 7"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "Nexus 7 (2012)",
    "Device": "tilapia",
    "Model": "Nexus 7"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "Nexus 7 (2013)",
    "Device": "deb",
    "Model": "Nexus 7"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "Nexus 7 (2013)",
    "Device": "flo",
    "Model": "Nexus 7"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "Nexus Player",
    "Device": "fugu",
    "Model": "Nexus Player"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "Nuvifone",
    "Device": "a50",
    "Model": "Garmin-Asus A50"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "PadFone",
    "Device": "PadFone",
    "Model": "PadFone"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "PadFone 2",
    "Device": "A68",
    "Model": "PadFone 2"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "PadFone E (A68M)",
    "Device": "ASUS-T008",
    "Model": "PadFone T008"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "PadFone Infinity",
    "Device": "A80",
    "Model": "PadFone Infinity"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "PadFone Infinity",
    "Device": "ASUS-A80",
    "Model": "PadFone Infinity"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "PadFone Mini",
    "Device": "ASUS-T00C",
    "Model": "PadFone T00C"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "PadFone S (PF500KL)",
    "Device": "ASUS_T00N",
    "Model": "ASUS_T00N"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "PadFone X (A91)",
    "Device": "ASUS-T00D",
    "Model": "ASUS PadFone X"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "PadFone X mini (PF450CL)",
    "Device": "ASUS-T00S",
    "Model": "ASUS PadFone X mini"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "PadFone X mini (PF450CL)",
    "Device": "ASUS-T00S",
    "Model": "ASUS_T00T"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "PadFone mini",
    "Device": "ASUS-T00C",
    "Model": "PadFone T00C"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "PadFone mini",
    "Device": "ASUS_T00E",
    "Model": "ASUS_T00E"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "R Series Tablet (R1001MFL)",
    "Device": "ASUS_P00L_M2",
    "Model": "P00L"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "R Series Tablet (R1001ML)",
    "Device": "ASUS_P00L_M1",
    "Model": "P00L"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ROG Phone",
    "Device": "ASUS_Z01QD_1",
    "Model": "ASUS_Z01QD"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ROG Phone",
    "Device": "ASUS_Z01QD_1",
    "Model": "ZS600KL"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ROG Phone 3",
    "Device": "ASUS_I003_1",
    "Model": "ASUS_I003D"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ROG Phone 3",
    "Device": "ASUS_I003_1",
    "Model": "ASUS_I003DD"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ROG Phone 3",
    "Device": "ASUS_I003_1",
    "Model": "ZS661KS"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ROG Phone 5 series",
    "Device": "ASUS_I005_1",
    "Model": "ASUS_I005D"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ROG Phone 5 series",
    "Device": "ASUS_I005_1",
    "Model": "ASUS_I005DA"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ROG Phone 5 series",
    "Device": "ASUS_I005_1",
    "Model": "ASUS_I005DB"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ROG Phone 5 series",
    "Device": "ASUS_I005_1",
    "Model": "ZS673KS"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ROG Phone 5 series",
    "Device": "ASUS_I005_1",
    "Model": "ZS676KS"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ROG Phone 6 series",
    "Device": "ASUS_AI2201",
    "Model": "ASUS_AI2201_A"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ROG Phone 6 series",
    "Device": "ASUS_AI2201",
    "Model": "ASUS_AI2201_B"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ROG Phone 6 series",
    "Device": "ASUS_AI2201",
    "Model": "ASUS_AI2201_C"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ROG Phone 6 series",
    "Device": "ASUS_AI2201",
    "Model": "ASUS_AI2201_D"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ROG Phone 6D Ultimate",
    "Device": "ASUS_AI2203",
    "Model": "ASUS_AI2203_C"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ROG Phone 6D Ultimate",
    "Device": "ASUS_AI2203",
    "Model": "ASUS_AI2203_D"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ROG Phone 6D series",
    "Device": "ASUS_AI2203",
    "Model": "ASUS_AI2203_B"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ROG Phone 7 series",
    "Device": "ASUS_AI2205",
    "Model": "ASUS_AI2205_A"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ROG Phone 7 series",
    "Device": "ASUS_AI2205",
    "Model": "ASUS_AI2205_C"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ROG Phone 8 series",
    "Device": "ASUS_AI2401",
    "Model": "ASUS_AI2401_A"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ROG Phone 8 series",
    "Device": "ASUS_AI2401",
    "Model": "ASUS_AI2401_C"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ROG Phone 8 series",
    "Device": "ASUS_AI2401",
    "Model": "ASUS_AI2401_D"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ROG Phone 9",
    "Device": "ASUSAI2501",
    "Model": "ASUSAI2501A"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ROG Phone 9",
    "Device": "ASUSAI2501",
    "Model": "ASUSAI2501B"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ROG Phone 9 FE",
    "Device": "ASUS_AI2401",
    "Model": "ASUS_AI2401_N"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ROG Phone 9 Pro",
    "Device": "ASUSAI2501",
    "Model": "ASUSAI2501A"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ROG Phone 9 Pro",
    "Device": "ASUSAI2501",
    "Model": "ASUSAI2501C"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ROG Phone II",
    "Device": "ASUS_I001_1",
    "Model": "ASUS_I001D"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ROG Phone II",
    "Device": "ASUS_I001_1",
    "Model": "ASUS_I001DC"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ROG Phone II",
    "Device": "ASUS_I001_1",
    "Model": "ASUS_I001DE"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ROG Phone II",
    "Device": "ASUS_I001_1",
    "Model": "ZS660KL"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "RTC-700A",
    "Device": "RTC-tablet",
    "Model": "RTC-tablet"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "Smartphone for Snapdragon Insiders",
    "Device": "ASUS_I007_1",
    "Model": "ASUS_I007D"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "T101TA",
    "Device": "T10xTA",
    "Model": "T10xTA"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "TF700T",
    "Device": "TF700T",
    "Model": "ASUS Pad TF700T"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "TF700T",
    "Device": "TF700T",
    "Model": "ASUS Transformer Pad TF700T"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "TX201LAF",
    "Device": "TX201LAF",
    "Model": "TX201LAF"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "The new PadFone Infinity (A86)",
    "Device": "ASUS-A86",
    "Model": "PadFone T004"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "Trans AiO P1801",
    "Device": "P1801-T",
    "Model": "ASUS Tablet P1801-T"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "TransBook Trio",
    "Device": "TX201LA",
    "Model": "TX201LA"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "Transformer AiO P1801",
    "Device": "P1801-T",
    "Model": "ASUS Tablet P1801-T"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "Transformer AiO P1802",
    "Device": "P1802-T",
    "Model": "ASUS Tablet P1802-T"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "Transformer Book Trio",
    "Device": "TX201LA",
    "Model": "TX201LA"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "Transformer Pad",
    "Device": "K010_1",
    "Model": "K010"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "Transformer Pad",
    "Device": "TF300T",
    "Model": "ASUS Pad TF300T"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "Transformer Pad",
    "Device": "TF300T",
    "Model": "ASUS Transformer 300"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "Transformer Pad",
    "Device": "TF300T",
    "Model": "ASUS Transformer Pad TF300T"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "Transformer Pad (TF103C)",
    "Device": "K010",
    "Model": "K010"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "Transformer Pad (TF103C)",
    "Device": "K010_3",
    "Model": "K010"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "Transformer Pad (TF103CE)",
    "Device": "K010E",
    "Model": "K010E"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "Transformer Pad (TF103CE)",
    "Device": "K010E_1",
    "Model": "K010E"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "Transformer Pad (TF103CG)",
    "Device": "K018",
    "Model": "K018"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "Transformer Pad (TF303CL)",
    "Device": "K014",
    "Model": "K014"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "Transformer Pad (TF303K)",
    "Device": "K01B",
    "Model": "K01B"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "Transformer Pad Infinity",
    "Device": "TF700KL",
    "Model": "ASUS Transformer Pad TF700KL"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "Transformer Pad Infinity (TF701T)",
    "Device": "K00C",
    "Model": "K00C"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "Transformer Pad TF300TG",
    "Device": "TF300TG",
    "Model": "ASUS Transformer Pad TF300TG"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "Transformer Pad TF300TL",
    "Device": "TF300TL",
    "Model": "ASUS Transformer Pad TF300TL"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "Transformer Pad TF502T",
    "Device": "TF502T",
    "Model": "ASUS Transformer Pad TF502T"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "Transformer Pad TF600T",
    "Device": "TF600T",
    "Model": "ASUS Transformer Pad TF600T"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "Transformer TF101G",
    "Device": "TF101G",
    "Model": "Transformer TF101G"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenFone 2 (ZE500CL)",
    "Device": "ASUS_Z00D",
    "Model": "ASUS ZenFone 2"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenFone 2 (ZE500CL)",
    "Device": "ASUS_Z00D",
    "Model": "ASUS ZenFone 2E"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenFone 2 (ZE500CL)",
    "Device": "ASUS_Z00D",
    "Model": "Z00D"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenFone 2 (ZE550ML)",
    "Device": "Z008_1",
    "Model": "ASUS_Z008D"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenFone 2 (ZE551ML)",
    "Device": "Z00A",
    "Model": "ASUS_Z00AD"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenFone 2 (ZE551ML)",
    "Device": "Z00A",
    "Model": "ASUS_Z00ADA"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenFone 2 (ZE551ML)",
    "Device": "Z00A_1",
    "Model": "ASUS_Z00AD"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenFone 2 (ZE551ML)",
    "Device": "Z00A_1",
    "Model": "ASUS_Z00ADB"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenFone 2 (ZE551ML)",
    "Device": "Z00A_3",
    "Model": "ASUS_Z00AD"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenFone 2 Laser (ZE500KG)",
    "Device": "ASUS_Z00RD_5",
    "Model": "ASUS_Z00RD"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenFone 2 Laser (ZE500KG)",
    "Device": "ASUS_Z00RD_7",
    "Model": "ASUS_Z00RD"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenFone 2 Laser (ZE500KL)",
    "Device": "ASUS_Z00E_1",
    "Model": "ASUS_Z00ED"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenFone 2 Laser (ZE500KL)",
    "Device": "ASUS_Z00E_2",
    "Model": "ASUS_Z00ED"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenFone 2 Laser (ZE500KL)",
    "Device": "ASUS_Z00E_2",
    "Model": "ASUS_Z00EDB"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenFone 2 Laser (ZE500KL)",
    "Device": "ASUS_Z00E_3",
    "Model": "ASUS_Z00ED"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenFone 2 Laser (ZE500KL)",
    "Device": "ASUS_Z00E_4",
    "Model": "ASUS_Z00ED"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenFone 2 Laser (ZE550KG)",
    "Device": "ASUS_Z00W_63",
    "Model": "ASUS_Z00WD"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenFone 2 Laser (ZE550KL)",
    "Device": "ASUS_Z00L_63",
    "Model": "ASUS_Z00LD"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenFone 2 Laser (ZE550KL)",
    "Device": "ASUS_Z00L_63",
    "Model": "ASUS_Z00LDC"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenFone 2 Laser (ZE550KL)",
    "Device": "ASUS_Z00L_63A",
    "Model": "ASUS_Z00LD"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenFone 2 Laser (ZE550KL)",
    "Device": "ASUS_Z00L_63C",
    "Model": "ASUS_Z00LD"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenFone 2 Laser (ZE550KL)",
    "Device": "ASUS_Z00L_93",
    "Model": "ASUS_Z00LD"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenFone 2 Laser (ZE551KL)",
    "Device": "ASUS_Z00T",
    "Model": "ASUS_Z00TD"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenFone 2 Laser (ZE600KL)",
    "Device": "ASUS_Z00M",
    "Model": "ASUS_Z00MD"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenFone 2 Laser (ZE601KL)",
    "Device": "ASUS_Z011",
    "Model": "ASUS_Z011D"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenFone 3 (ZE520KL)",
    "Device": "ASUS_Z017D_1",
    "Model": "ASUS_Z017D"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenFone 3 (ZE520KL)",
    "Device": "ASUS_Z017D_1",
    "Model": "ASUS_Z017DA"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenFone 3 (ZE552KL)",
    "Device": "ASUS_Z012D",
    "Model": "ASUS_Z012D"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenFone 3 (ZE552KL)",
    "Device": "ASUS_Z012D",
    "Model": "ASUS_Z012DA"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenFone 3 (ZE552KL)",
    "Device": "ASUS_Z012D",
    "Model": "ASUS_Z012DE"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenFone 3 (ZE552KL)",
    "Device": "ASUS_Z012D",
    "Model": "ASUS_Z012S"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenFone 3 Deluxe (ZS550KL)",
    "Device": "ASUS_Z01F_1",
    "Model": "ASUS_Z01FD"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenFone 3 Deluxe (ZS570KL)",
    "Device": "Z016",
    "Model": "ASUS_Z016D"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenFone 3 Deluxe (ZS570KL)",
    "Device": "Z016",
    "Model": "ASUS_Z016DA"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenFone 3 Deluxe (ZS570KL)",
    "Device": "Z016",
    "Model": "ASUS_Z016S"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenFone 3 Deluxe (ZS570KL)",
    "Device": "Z016_1",
    "Model": "ASUS_Z016D"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenFone 3 Laser (ZC551KL)",
    "Device": "Z01B_1",
    "Model": "ASUS_Z01BD"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenFone 3 Laser (ZC551KL)",
    "Device": "Z01B_1",
    "Model": "ASUS_Z01BDA"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenFone 3 Laser (ZC551KL)",
    "Device": "Z01B_1",
    "Model": "ASUS_Z01BDC"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenFone 3 Laser (ZC551KL)",
    "Device": "Z01B_1",
    "Model": "ASUS_Z01BS"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenFone 3 Max (ZC520TL)",
    "Device": "ASUS_X008",
    "Model": "ASUS_X008D"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenFone 3 Max (ZC520TL)",
    "Device": "ASUS_X008",
    "Model": "ASUS_X008DA"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenFone 3 Max (ZC520TL)",
    "Device": "ASUS_X008",
    "Model": "ASUS_X008DB"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenFone 3 Max (ZC520TL)",
    "Device": "ASUS_X008_1",
    "Model": "ASUS_X008D"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenFone 3 Max (ZC520TL)",
    "Device": "ASUS_X008_1",
    "Model": "ASUS_X008DA"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenFone 3 Max (ZC520TL)",
    "Device": "ASUS_X008_1",
    "Model": "ASUS_X008DB"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenFone 3 Max (ZC520TL)",
    "Device": "ASUS_X008_1",
    "Model": "ASUS_X008DC"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenFone 3 Max (ZC553KL)",
    "Device": "ASUS_X00DD",
    "Model": "ASUS_X00DD"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenFone 3 Max (ZC553KL)",
    "Device": "ASUS_X00DD",
    "Model": "ASUS_X00DDA"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenFone 3 Ultra (ZU680KL)",
    "Device": "ASUS_A001",
    "Model": "ASUS_A001"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenFone 3 Zoom (ZE553KL)",
    "Device": "ASUS_Z01H_1",
    "Model": "ASUS_Z01HD"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenFone 3 Zoom (ZE553KL)",
    "Device": "ASUS_Z01H_1",
    "Model": "ASUS_Z01HDA"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenFone 3s Max (ZC521TL)",
    "Device": "ASUS_X00G_1",
    "Model": "ASUS_X00GD"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenFone 4 (A400CG)",
    "Device": "ASUS_T00I",
    "Model": "ASUS_T00I"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenFone 4 (A400CG)",
    "Device": "ASUS_T00I",
    "Model": "ASUS_T00I-D"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenFone 4 (A450CG)",
    "Device": "ASUS_T00Q",
    "Model": "ASUS_T00Q"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenFone 4 (ZE554KL)",
    "Device": "ASUS_Z01KDA",
    "Model": "ASUS_Z01KD"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenFone 4 (ZE554KL)",
    "Device": "ASUS_Z01KDA",
    "Model": "ASUS_Z01KS"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenFone 4 (ZE554KL)",
    "Device": "ASUS_Z01KD_1",
    "Model": "ASUS_Z01KDA"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenFone 4 (ZE554KL)",
    "Device": "ASUS_Z01KD_2",
    "Model": "ASUS_Z01KD"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenFone 4 (ZE554KL)",
    "Device": "ASUS_Z01KD_3",
    "Model": "ASUS_Z01KD"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenFone 4 Max (ZC520KL)",
    "Device": "ASUS_X00HD_1",
    "Model": "ASUS_X00HD"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenFone 4 Max (ZC520KL)",
    "Device": "ASUS_X00HD_2",
    "Model": "ASUS_X00HD"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenFone 4 Max (ZC520KL)",
    "Device": "ASUS_X00HD_4",
    "Model": "ASUS_X00HD"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenFone 4 Max (ZC520KL)",
    "Device": "ASUS_X00HD_5",
    "Model": "ASUS_X00HD"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenFone 4 Max (ZC554KL)",
    "Device": "ASUS_X00ID",
    "Model": "ASUS_X00ID"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenFone 4 Max (ZC554KL)",
    "Device": "ASUS_X00IDB",
    "Model": "ASUS_X00ID"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenFone 4 Max (ZC554KL)",
    "Device": "ASUS_X00IDC",
    "Model": "ASUS_X00ID"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenFone 4 Pro (ZS551KL)",
    "Device": "ASUS_Z01GD_1",
    "Model": "ASUS_Z01GD"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenFone 4 Selfie (ZD553KL)",
    "Device": "ASUS_X00LD_1",
    "Model": "ASUS_X00LD"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenFone 4 Selfie Lite (ZB520KL)",
    "Device": "ASUS_X00HD_3",
    "Model": "ASUS_X00HD"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenFone 4 Selfie Lite (ZB520KL)",
    "Device": "ASUS_X00HD_3",
    "Model": "ASUS_X00HDA"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenFone 4 Selfie Pro (ZD552KL)",
    "Device": "ASUS_Z01M_1",
    "Model": "ASUS_Z01MD"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenFone 4 Selfie Pro (ZD552KL)",
    "Device": "ASUS_Z01M_1",
    "Model": "ASUS_Z01MDA"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenFone 5",
    "Device": "ASUS_T00F",
    "Model": "ASUS_T00F"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenFone 5",
    "Device": "ASUS_T00J",
    "Model": "ASUS_T00J"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenFone 5 (A500CG)",
    "Device": "ASUS_T00F",
    "Model": "ASUS_T00F"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenFone 5 (A500CG)",
    "Device": "ASUS_T00F1",
    "Model": "ASUS_T00F"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenFone 5 (A501CG)",
    "Device": "ASUS_T00J1",
    "Model": "ASUS_T00J"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenFone 5 (A502CG)",
    "Device": "ASUS_T00K",
    "Model": "ASUS_T00K"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenFone 5 (ZE620KL)",
    "Device": "ASUS_X00QD",
    "Model": "ASUS_X00QD"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenFone 5 (ZE620KL)",
    "Device": "ASUS_X00QD",
    "Model": "ASUS_X00QSA"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenFone 5 (ZE620KL)",
    "Device": "ASUS_X00QD",
    "Model": "ZE620KL"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenFone 5 LTE (A500KL)",
    "Device": "ASUS_T00P",
    "Model": "ASUS_T00P"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenFone 5 Lite (ZC600KL)",
    "Device": "ASUS_X017D_1",
    "Model": "ASUS_X017D"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenFone 5 Lite (ZC600KL)",
    "Device": "ASUS_X017D_2",
    "Model": "ASUS_X017DA"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenFone 5 Lite (ZC600KL)",
    "Device": "ASUS_X017D_2",
    "Model": "ZC600KL"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenFone 5Z (ZS620KL) (WW) / 5Z (ZS621KL) (IN)",
    "Device": "ASUS_Z01R_1",
    "Model": "ASUS_Z01RD"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenFone 5Z (ZS620KL) (WW) / 5Z (ZS621KL) (IN)",
    "Device": "ASUS_Z01R_1",
    "Model": "ZS620KL"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenFone 6",
    "Device": "ASUS_T00G",
    "Model": "ASUS_T00G"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenFone 6 (A600CG)",
    "Device": "ASUS_T00G",
    "Model": "ASUS_T00G"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenFone 6 (A601CG)",
    "Device": "ASUS_Z002",
    "Model": "ASUS_Z002"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenFone 6 (ZS630KL) (WW) / 6Z (ZS630KL) (IN)",
    "Device": "ASUS_I01WD",
    "Model": "ASUS_I01WD"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenFone 6 (ZS630KL) (WW) / 6Z (ZS630KL) (IN)",
    "Device": "ASUS_I01WD",
    "Model": "ZS630KL"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenFone 7 / 7 Pro (ZS670KS/ZS671KS)",
    "Device": "ASUS_I002D",
    "Model": "ASUS_I002D"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenFone 7 / 7 Pro (ZS670KS/ZS671KS)",
    "Device": "ASUS_I002D",
    "Model": "ZS670KS"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenFone 7 / 7 Pro (ZS670KS/ZS671KS)",
    "Device": "ASUS_I002D",
    "Model": "ZS671KS"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenFone AR",
    "Device": "ASUS_A002_1",
    "Model": "ASUS_A002A"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenFone AR (ZS571KL)",
    "Device": "ASUS_A002",
    "Model": "ASUS_A002"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenFone Ares (ZS572KL)",
    "Device": "ASUS_A002_2",
    "Model": "ASUS_A002"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenFone C (ZC451CG)",
    "Device": "ASUS_Z007",
    "Model": "ASUS_Z007"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenFone Go (T500)",
    "Device": "ASUS_X003",
    "Model": "ASUS_X003"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenFone Go (ZB450KL)",
    "Device": "ASUS_X009D_2",
    "Model": "ASUS_X009DB"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenFone Go (ZB452KG)",
    "Device": "ASUS_X014D_1",
    "Model": "ASUS_X014D"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenFone Go (ZB452KG)",
    "Device": "ASUS_X014D_2",
    "Model": "ASUS_X014D"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenFone Go (ZB500KG)",
    "Device": "ASUS_X00BD_1",
    "Model": "ASUS_X00BD"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenFone Go (ZB500KL)",
    "Device": "ASUS_X00AD_2",
    "Model": "ASUS_X00AD"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenFone Go (ZB551KL)",
    "Device": "ASUS_X013D_1",
    "Model": "ASUS_X013DA"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenFone Go (ZB551KL)",
    "Device": "ASUS_X013D_1",
    "Model": "ASUS_X013DB"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenFone Go (ZB551KL)",
    "Device": "ASUS_X013D_2",
    "Model": "ASUS_X013DA"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenFone Go (ZB551KL)",
    "Device": "ASUS_X013D_2",
    "Model": "ASUS_X013DB"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenFone Go (ZB552KL)",
    "Device": "ASUS_X007D",
    "Model": "ASUS_X007D"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenFone Go (ZB690KG)",
    "Device": "ASUS_L001_1",
    "Model": "ASUS_L001"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenFone Go (ZB690KG)",
    "Device": "ASUS_L001_2",
    "Model": "ASUS_L001"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenFone Go (ZC451TG)",
    "Device": "ASUS_Z00SD",
    "Model": "ASUS_Z00SD"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenFone Go (ZC500TG)",
    "Device": "ASUS_Z00VD",
    "Model": "ASUS_Z00VD"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenFone Lite L1 (G553KL)",
    "Device": "ASUS_X00R_7",
    "Model": "G553KL"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenFone Lite L1 (ZA551KL) / ZenFone Live L1/L2 (ZA550KL)",
    "Device": "ASUS_X00R_1",
    "Model": "ASUS_X00RD"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenFone Lite L1 (ZA551KL) / ZenFone Live L1/L2 (ZA550KL)",
    "Device": "ASUS_X00R_2",
    "Model": "ASUS_X00RD"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenFone Lite L1 (ZA551KL) / ZenFone Live L1/L2 (ZA550KL)",
    "Device": "ASUS_X00R_3",
    "Model": "ASUS_X00RD"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenFone Lite L1 (ZA551KL) / ZenFone Live L1/L2 (ZA550KL)",
    "Device": "ASUS_X00R_5",
    "Model": "ASUS_X00RD"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenFone Lite L1 (ZA551KL) / ZenFone Live L1/L2 (ZA550KL)",
    "Device": "ASUS_X00R_6",
    "Model": "ASUS_X00RD"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenFone Lite L1 (ZA551KL) / ZenFone Live L1/L2 (ZA550KL)",
    "Device": "ASUS_X00R_7",
    "Model": "ASUS_X00RD"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenFone Live (ZB501KL)",
    "Device": "ASUS_A007",
    "Model": "ASUS_A007"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenFone Live L1 (G552KL)",
    "Device": "ASUS_X00R_3",
    "Model": "G552KL"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenFone Live L1 (G552KL)",
    "Device": "ASUS_X00R_3",
    "Model": "ZA550KL"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenFone Live L1 (ZA550KL)",
    "Device": "ASUS_X00R_2",
    "Model": "ZA550KL"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenFone Live Plus (ZB553KL)",
    "Device": "ASUS_X00LD_2",
    "Model": "ASUS_X00LDB"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenFone Live Plus (ZB553KL)",
    "Device": "ASUS_X00LD_3",
    "Model": "ASUS_X00LDA"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenFone Live Plus (ZB553KL)",
    "Device": "ASUS_X00LD_3",
    "Model": "ZB553KL"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenFone Max (ZC550KL)",
    "Device": "ASUS_Z010",
    "Model": "ASUS_Z010D"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenFone Max (ZC550KL)",
    "Device": "ASUS_Z010",
    "Model": "ASUS_Z010DA"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenFone Max (ZC550KL)",
    "Device": "ASUS_Z010",
    "Model": "ASUS_Z010DB"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenFone Max (ZC550KL)",
    "Device": "ASUS_Z010_2",
    "Model": "ASUS_Z010DD"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenFone Max (ZC550KL)",
    "Device": "ASUS_Z010_CD",
    "Model": "ASUS_Z010D"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenFone Max (ZC550KL)",
    "Device": "ASUS_Z010_CD",
    "Model": "ASUS_Z010DA"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenFone Max M1 (ZB556KL) / ZenFone Max M1/M2/M3 (ZB555KL)",
    "Device": "ASUS_X00P_1",
    "Model": "ASUS_X00PD"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenFone Max M1 (ZB556KL) / ZenFone Max M1/M2/M3 (ZB555KL)",
    "Device": "ASUS_X00P_1",
    "Model": "ZB555KL"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenFone Max M1 (ZB556KL) / ZenFone Max M1/M2/M3 (ZB555KL)",
    "Device": "ASUS_X00P_2",
    "Model": "ASUS_X00PD"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenFone Max M1 (ZB556KL) / ZenFone Max M1/M2/M3 (ZB555KL)",
    "Device": "ASUS_X00P_3",
    "Model": "ASUS_X00PD"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenFone Max M1 (ZB556KL) / ZenFone Max M1/M2/M3 (ZB555KL)",
    "Device": "ASUS_X00P_3",
    "Model": "ZB555KL"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenFone Max M1 (ZB556KL) / ZenFone Max M1/M2/M3 (ZB555KL)",
    "Device": "ASUS_X00P_4",
    "Model": "ASUS_X00PD"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenFone Max M1 (ZB556KL) / ZenFone Max M1/M2/M3 (ZB555KL)",
    "Device": "ASUS_X00P_6",
    "Model": "ASUS_X00PD"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenFone Max M1 (ZB556KL) / ZenFone Max M1/M2/M3 (ZB555KL)",
    "Device": "ASUS_X00P_8",
    "Model": "ASUS_X00PD"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenFone Max M1 (ZB556KL) / ZenFone Max M1/M2/M3 (ZB555KL)",
    "Device": "ASUS_X00P_8",
    "Model": "ZB555KL"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenFone Max M2 (ZB633KL) (WW) / Max M2 (ZB632KL) (IN)",
    "Device": "ASUS_X01A_1",
    "Model": "ASUS_X01AD"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenFone Max M2 (ZB633KL) (WW) / Max M2 (ZB632KL) (IN)",
    "Device": "ASUS_X01A_1",
    "Model": "ZB633KL"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenFone Max Plus M1 (ZB570TL)",
    "Device": "ASUS_X018_1",
    "Model": "ASUS_X018D"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenFone Max Plus M1 (ZB570TL)",
    "Device": "ASUS_X018_2",
    "Model": "ASUS_X018D"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenFone Max Plus M1 (ZB570TL)",
    "Device": "ASUS_X018_4",
    "Model": "ASUS_X018D"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenFone Max Plus M2 (ZB634KL)",
    "Device": "ASUS_A001D_1",
    "Model": "ASUS_A001D"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenFone Max Pro M1 (ZB602KL) (WW) / Max Pro M1 (ZB601KL) (IN)",
    "Device": "ASUS_X00T_2",
    "Model": "ASUS_X00TD"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenFone Max Pro M1 (ZB602KL) (WW) / Max Pro M1 (ZB601KL) (IN)",
    "Device": "ASUS_X00T_2",
    "Model": "ASUS_X00TDB"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenFone Max Pro M1 (ZB602KL) (WW) / Max Pro M1 (ZB601KL) (IN)",
    "Device": "ASUS_X00T_3",
    "Model": "ASUS_X00TD"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenFone Max Pro M1 (ZB602KL) (WW) / Max Pro M1 (ZB601KL) (IN)",
    "Device": "ASUS_X00T_4",
    "Model": "ASUS_X00TD"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenFone Max Pro M1 (ZB602KL) (WW) / Max Pro M1 (ZB601KL) (IN)",
    "Device": "ASUS_X00T_6",
    "Model": "ASUS_X00TD"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenFone Max Pro M1 (ZB602KL) (WW) / Max Pro M1 (ZB601KL) (IN)",
    "Device": "ASUS_X00T_6",
    "Model": "ASUS_X00TDB"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenFone Max Pro M1 (ZB602KL) (WW) / Max Pro M1 (ZB601KL) (IN)",
    "Device": "ASUS_X00T_6",
    "Model": "ZB602KL"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenFone Max Pro M1 (ZB602KL) (WW) / Max Pro M1 (ZB601KL) (IN)",
    "Device": "ASUS_X00T_8",
    "Model": "ASUS_X00TD"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenFone Max Pro M1 (ZB602KL) (WW) / Max Pro M1 (ZB601KL) (IN)",
    "Device": "ASUS_X00T_8",
    "Model": "ASUS_X00TDB"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenFone Max Pro M2 (ZB631KL) (WW) / Max Pro M2 (ZB630KL) (IN)",
    "Device": "ASUS_X01BD_1",
    "Model": "ASUS_X01BDA"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenFone Max Pro M2 (ZB631KL) (WW) / Max Pro M2 (ZB630KL) (IN)",
    "Device": "ASUS_X01BD_1",
    "Model": "ZB631KL"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenFone Max Pro M2 (ZB631KL) (WW) / Max Pro M2 (ZB630KL) (IN)",
    "Device": "ASUS_X01BD_2",
    "Model": "ASUS_X01BDA"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenFone Max Shot (ZB634KL)",
    "Device": "ASUS_A001D_2",
    "Model": "ASUS_A001D"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenFone Selfie (ZD551KL)",
    "Device": "ASUS_Z00U_1",
    "Model": "ASUS_Z00UD"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenFone Selfie (ZD551KL)",
    "Device": "ASUS_Z00U_1",
    "Model": "ASUS_Z00UDA"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenFone Selfie (ZD551KL)",
    "Device": "ASUS_Z00U_2",
    "Model": "ASUS_Z00UD"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenFone V",
    "Device": "ASUS_A006",
    "Model": "ASUS_A006"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenFone V Live",
    "Device": "ASUS_A009",
    "Model": "ASUS_A009"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenFone Zoom (ZX551ML)",
    "Device": "Z00X",
    "Model": "ASUS_Z00XS"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenFone Zoom (ZX551ML)",
    "Device": "Z00X",
    "Model": "ASUS_Z00XSA"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenFone Zoom (ZX551ML)",
    "Device": "Z00X",
    "Model": "ASUS_Z00XSB"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenFone Zoom (ZX551ML)",
    "Device": "Z00X_1",
    "Model": "ASUS_Z00XS"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenFone Zoom (ZX551ML)",
    "Device": "Z00X_1",
    "Model": "ASUS_Z00XSA"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenFone Zoom (ZX551ML)",
    "Device": "Z00X_2",
    "Model": "ASUS_Z00XS"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenPad 10 (Z300C)",
    "Device": "P023_1",
    "Model": "P023"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenPad 10 (Z300C)",
    "Device": "P023_2",
    "Model": "P023"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenPad 10 (Z300CG)",
    "Device": "P021",
    "Model": "P021"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenPad 10 (Z300CG)",
    "Device": "P021_1",
    "Model": "P021"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenPad 10 (Z300CL)",
    "Device": "P01T_1",
    "Model": "P01T_1"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenPad 10 (Z300M)",
    "Device": "P00C_1",
    "Model": "P00C"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenPad 10 (Z300M)",
    "Device": "P00C_2",
    "Model": "P00C"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenPad 10 (Z301M)",
    "Device": "ASUS_P028_1",
    "Model": "P028"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenPad 10 (Z301MF)",
    "Device": "ASUS_P028_2",
    "Model": "P028"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenPad 10 (Z301MFL)",
    "Device": "ASUS_P00L_2",
    "Model": "P00L"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenPad 10 (Z301ML)",
    "Device": "ASUS_P00L_1",
    "Model": "P00L"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenPad 3 8.0",
    "Device": "P008_2",
    "Model": "P008"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenPad 3 8.0 (Z581KL)",
    "Device": "P008_1",
    "Model": "P008"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenPad 3S 10 (Z500M)",
    "Device": "P027",
    "Model": "P027"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenPad 3S 10 LTE (Z500KL)",
    "Device": "ASUS_P00I",
    "Model": "ASUS_P00I"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenPad 7.0 (Z370C)",
    "Device": "P01W",
    "Model": "P01W"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenPad 7.0 (Z370CG)",
    "Device": "P01V_1",
    "Model": "P01V"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenPad 7.0 (Z370CG)",
    "Device": "P01V_2",
    "Model": "P01V"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenPad 7.0 (Z370KL)",
    "Device": "P002_1",
    "Model": "P002"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenPad 7.0 (Z370KL)",
    "Device": "P002_2",
    "Model": "P002"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenPad 8.0 (Z380KL)",
    "Device": "P024_1",
    "Model": "P024"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenPad 8.0 (Z380KL)",
    "Device": "P024_2",
    "Model": "P024"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenPad 8.0 (Z380KL)",
    "Device": "P024_3",
    "Model": "P024"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenPad 8.0 (Z380KL)",
    "Device": "P024_4",
    "Model": "P024"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenPad 8.0 (Z380M)",
    "Device": "P00A_1",
    "Model": "P00A"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenPad 8.0 (Z380M)",
    "Device": "P00A_2",
    "Model": "P00A"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenPad C 7.0",
    "Device": "P01Y_S",
    "Model": "P01Y"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenPad C 7.0",
    "Device": "P01Y_S",
    "Model": "P01Y_S"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenPad C 7.0 (Z170C)",
    "Device": "P01Z",
    "Model": "P01Z"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenPad C 7.0 (Z170C)",
    "Device": "P01Z_2",
    "Model": "P01Z"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenPad C 7.0 (Z170CG)",
    "Device": "P01Y",
    "Model": "P01Y"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenPad C 7.0 (Z170CG)",
    "Device": "P01Y_2",
    "Model": "P01Y"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenPad C 7.0 (Z170MG)",
    "Device": "P001",
    "Model": "P001"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenPad C 7.0 (Z170MG)",
    "Device": "P001_2",
    "Model": "P001"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenPad S 8.0 (Z580C)",
    "Device": "P01M_2",
    "Model": "P01M"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenPad S 8.0 (Z580C)",
    "Device": "P01M_4",
    "Model": "P01M"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenPad S 8.0 (Z580CA)",
    "Device": "P01M_1",
    "Model": "P01MA"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenPad S 8.0 (Z580CA)",
    "Device": "P01M_3",
    "Model": "P01MA"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenPad S 8.0 (Z580CA)",
    "Device": "P01M_5",
    "Model": "P01MA"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenPad Z10",
    "Device": "P00I",
    "Model": "P00I"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenPad Z8",
    "Device": "P008",
    "Model": "P008"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenPad Z8s",
    "Device": "ASUS_P00J",
    "Model": "ASUS_P00J"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenPadC 7.0 (Z170MG)",
    "Device": "P001_2",
    "Model": "P001_2"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenWatch",
    "Device": "anthias",
    "Model": "ASUS ZenWatch"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenWatch 2",
    "Device": "sparrow",
    "Model": "ASUS ZenWatch 2"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenWatch 2",
    "Device": "wren",
    "Model": "ASUS ZenWatch 2"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "ZenWatch 3",
    "Device": "swift",
    "Model": "ASUS ZenWatch 3"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "Zenbo",
    "Device": "ASUS_ZENBO",
    "Model": "Zenbo"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "Zenbo Qrobot",
    "Device": "ASUS_ZENBO",
    "Model": "Zenbo"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "Zenfone 10",
    "Device": "ASUS_AI2302",
    "Model": "ASUS_AI2302"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "Zenfone 11 Ultra",
    "Device": "ASUS_AI2401",
    "Model": "ASUS_AI2401_H"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "Zenfone 12 Ultra",
    "Device": "ASUSAI2501",
    "Model": "ASUSAI2501H"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "Zenfone 8",
    "Device": "ASUS_I006D",
    "Model": "ASUS_I006D"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "Zenfone 8",
    "Device": "ASUS_I006D",
    "Model": "ZS590KS"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "Zenfone 8 / ASUS 8z",
    "Device": "ASUS_I006D",
    "Model": "ASUS_I006D"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "Zenfone 8 Flip",
    "Device": "ASUS_I004D",
    "Model": "ASUS_I004D"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "Zenfone 8 Flip",
    "Device": "ASUS_I004D",
    "Model": "ZS672KS"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "Zenfone 9",
    "Device": "ASUS_AI2202",
    "Model": "ASUS_AI2202"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "Zenfone Go (ASUS_X00BD)",
    "Device": "ASUS_X00BD_1",
    "Model": "ASUS_X00BD"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "Zenpad 8.0 (Z380C)",
    "Device": "P022_1",
    "Model": "P022"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "Zenpad 8.0 (Z380C)",
    "Device": "P022_2",
    "Model": "P022"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "dahu",
    "Device": "dahu",
    "Model": "M1G"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "飛馬 (T500KLC)",
    "Device": "ASUS_X003",
    "Model": "ASUS_X003"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "飛馬 (T500TLT)",
    "Device": "ASUS_X002",
    "Model": "ASUS_X002"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "飛馬 5000 (T551TLC)",
    "Device": "ASUS_X005",
    "Model": "ASUS_X005"
  },
  {
    "Retail Branding": "Asus",
    "Marketing Name": "飛馬2 Plus (T550KLC)",
    "Device": "ASUS_X550",
    "Model": "ASUS_X550"
  },
  {
    "Retail Branding": "AtGames-zooti",
    "Marketing Name": "ZOOTI PAD ZT-701",
    "Device": "ZT-701",
    "Model": "ZT-701"
  },
  {
    "Retail Branding": "AthenaStellar",
    "Marketing Name": "MAT80211",
    "Device": "MAT80211",
    "Model": "MID"
  },
  {
    "Retail Branding": "Athesi",
    "Marketing Name": "AP5501",
    "Device": "AP5501",
    "Model": "AP5501"
  },
  {
    "Retail Branding": "Athesi",
    "Marketing Name": "AP5701",
    "Device": "AP5701",
    "Model": "AP5701"
  },
  {
    "Retail Branding": "Athesi",
    "Marketing Name": "AP5801",
    "Device": "AP5801",
    "Model": "AP5801"
  },
  {
    "Retail Branding": "Athesi",
    "Marketing Name": "AP6001_EEA",
    "Device": "AP6001",
    "Model": "AP6001"
  },
  {
    "Retail Branding": "Athesi",
    "Marketing Name": "AP6301",
    "Device": "AP6301",
    "Model": "AP6301"
  },
  {
    "Retail Branding": "Athesi",
    "Marketing Name": "AP8003TL",
    "Device": "AP8003TL",
    "Model": "AP8003TL"
  },
  {
    "Retail Branding": "Athesi",
    "Marketing Name": "AT-E8T",
    "Device": "AT-E8T",
    "Model": "AT-E8T"
  },
  {
    "Retail Branding": "Athesi",
    "Marketing Name": "Athesi AP5702",
    "Device": "AP5702",
    "Model": "AP5702"
  },
  {
    "Retail Branding": "Athesi",
    "Marketing Name": "Athesi AP5706",
    "Device": "AP5706",
    "Model": "Athesi_AP5706"
  },
  {
    "Retail Branding": "Athesi",
    "Marketing Name": "Athesi professional AP5705S",
    "Device": "AP5705S",
    "Model": "AP5705S"
  },
  {
    "Retail Branding": "Athesi",
    "Marketing Name": "E55",
    "Device": "E55",
    "Model": "E55"
  },
  {
    "Retail Branding": "Athesi",
    "Marketing Name": "E65",
    "Device": "E65",
    "Model": "E65"
  },
  {
    "Retail Branding": "Athesi",
    "Marketing Name": "E6A",
    "Device": "E6A",
    "Model": "E6A"
  },
  {
    "Retail Branding": "Athesi",
    "Marketing Name": "RT101A",
    "Device": "RT101A",
    "Model": "RT101A9"
  },
  {
    "Retail Branding": "Athesi",
    "Marketing Name": "RT4300_EEA",
    "Device": "RT4300",
    "Model": "RT4300"
  },
  {
    "Retail Branding": "Athesi",
    "Marketing Name": "RT4500_EEA",
    "Device": "RT4500",
    "Model": "RT4500"
  },
  {
    "Retail Branding": "Athesi",
    "Marketing Name": "RT55_EEA",
    "Device": "RT55",
    "Model": "RT55"
  },
  {
    "Retail Branding": "Athesi",
    "Marketing Name": "RT80A",
    "Device": "RT80A",
    "Model": "RT80A9"
  },
  {
    "Retail Branding": "Atozee",
    "Marketing Name": "A30MAX",
    "Device": "A30MAX",
    "Model": "A30"
  },
  {
    "Retail Branding": "Atozee",
    "Marketing Name": "A30MAX_EEA",
    "Device": "A30MAX_EEA",
    "Model": "A30"
  },
  {
    "Retail Branding": "Atozee",
    "Marketing Name": "AT10",
    "Device": "AT10",
    "Model": "AT10"
  },
  {
    "Retail Branding": "Atozee",
    "Marketing Name": "AT10K",
    "Device": "AT10K",
    "Model": "AT10K"
  },
  {
    "Retail Branding": "Atozee",
    "Marketing Name": "AT11K",
    "Device": "AT11K",
    "Model": "AT11K"
  },
  {
    "Retail Branding": "Atozee",
    "Marketing Name": "AT12K",
    "Device": "AT12K",
    "Model": "AT12K"
  },
  {
    "Retail Branding": "Atozee",
    "Marketing Name": "AT70K",
    "Device": "AT70K",
    "Model": "AT70K"
  },
  {
    "Retail Branding": "Atozee",
    "Marketing Name": "AT70KS",
    "Device": "AT70KS",
    "Model": "AT70KS"
  },
  {
    "Retail Branding": "Atozee",
    "Marketing Name": "AT70K_EEA",
    "Device": "AT70K_EEA",
    "Model": "AT70K_EEA"
  },
  {
    "Retail Branding": "Atozee",
    "Marketing Name": "AT71K",
    "Device": "AT71K",
    "Model": "AT71K"
  },
  {
    "Retail Branding": "Atozee",
    "Marketing Name": "AT71K",
    "Device": "AT71K",
    "Model": "Q8"
  },
  {
    "Retail Branding": "Atozee",
    "Marketing Name": "AT71K",
    "Device": "AT71K",
    "Model": "Q8K"
  },
  {
    "Retail Branding": "Atozee",
    "Marketing Name": "AT81K",
    "Device": "AT81K",
    "Model": "AT81K"
  },
  {
    "Retail Branding": "Atozee",
    "Marketing Name": "CP10S",
    "Device": "CP10S",
    "Model": "CP10S"
  },
  {
    "Retail Branding": "Atozee",
    "Marketing Name": "CP10_Pro",
    "Device": "CP10_Pro",
    "Model": "CP10K_Pro"
  },
  {
    "Retail Branding": "Atozee",
    "Marketing Name": "CP10_Pro",
    "Device": "CP10_Pro",
    "Model": "CP10_Pro"
  },
  {
    "Retail Branding": "Atozee",
    "Marketing Name": "CP20S",
    "Device": "CP20S",
    "Model": "CP20S"
  },
  {
    "Retail Branding": "Atozee",
    "Marketing Name": "CP20_GOLD",
    "Device": "CP20_GOLD",
    "Model": "CP20_GOLD"
  },
  {
    "Retail Branding": "Atozee",
    "Marketing Name": "CP20_MAX",
    "Device": "CP20_MAX",
    "Model": "CP20_MAX"
  },
  {
    "Retail Branding": "Atozee",
    "Marketing Name": "CP20_PRO",
    "Device": "CP20_PRO",
    "Model": "CP20_PRO"
  },
  {
    "Retail Branding": "Atozee",
    "Marketing Name": "CP30",
    "Device": "CP30",
    "Model": "CP30"
  },
  {
    "Retail Branding": "Atozee",
    "Marketing Name": "CP31",
    "Device": "CP31",
    "Model": "CP31"
  },
  {
    "Retail Branding": "Atozee",
    "Marketing Name": "CP31",
    "Device": "CP31",
    "Model": "SXPro"
  },
  {
    "Retail Branding": "Atozee",
    "Marketing Name": "CP80",
    "Device": "CP80",
    "Model": "CP80"
  },
  {
    "Retail Branding": "Atozee",
    "Marketing Name": "CP80KS",
    "Device": "CP80KS",
    "Model": "CP80KS"
  },
  {
    "Retail Branding": "Atozee",
    "Marketing Name": "CP81",
    "Device": "CP81",
    "Model": "CP81"
  },
  {
    "Retail Branding": "Atozee",
    "Marketing Name": "NV10S",
    "Device": "NV10S",
    "Model": "NV10S"
  },
  {
    "Retail Branding": "Atozee",
    "Marketing Name": "P10",
    "Device": "P10",
    "Model": "P10"
  },
  {
    "Retail Branding": "Atozee",
    "Marketing Name": "P12",
    "Device": "P12",
    "Model": "P12"
  },
  {
    "Retail Branding": "Atozee",
    "Marketing Name": "P70W",
    "Device": "P70W",
    "Model": "P70W"
  },
  {
    "Retail Branding": "Atozee",
    "Marketing Name": "P80W",
    "Device": "P80W",
    "Model": "P80W"
  },
  {
    "Retail Branding": "Atozee",
    "Marketing Name": "P81M",
    "Device": "P81M",
    "Model": "P81M"
  },
  {
    "Retail Branding": "Atozee",
    "Marketing Name": "P81W",
    "Device": "P81W",
    "Model": "P81W"
  },
  {
    "Retail Branding": "Atozee",
    "Marketing Name": "Q2S",
    "Device": "Q2S",
    "Model": "Q2S"
  },
  {
    "Retail Branding": "Atozee",
    "Marketing Name": "Q2SK",
    "Device": "Q2SK",
    "Model": "Q2S"
  },
  {
    "Retail Branding": "Atozee",
    "Marketing Name": "Q2SK",
    "Device": "Q2SK",
    "Model": "Q2SK"
  },
  {
    "Retail Branding": "Atozee",
    "Marketing Name": "Q2S_Pro",
    "Device": "Q2S_Pro",
    "Model": "Q2S_Pro"
  },
  {
    "Retail Branding": "Atozee",
    "Marketing Name": "T30MAX",
    "Device": "T30MAX",
    "Model": "T30MAX"
  },
  {
    "Retail Branding": "Atozee",
    "Marketing Name": "T30MAX",
    "Device": "T30MAX",
    "Model": "redbeat M3"
  },
  {
    "Retail Branding": "Atozee",
    "Marketing Name": "T30MAX_EEA",
    "Device": "T30MAX_EEA",
    "Model": "T30MAX"
  },
  {
    "Retail Branding": "Atozee",
    "Marketing Name": "T30MAX_EEA",
    "Device": "T30MAX_EEA",
    "Model": "TAB9"
  },
  {
    "Retail Branding": "Atozee",
    "Marketing Name": "YQ10M",
    "Device": "YQ10M",
    "Model": "YQ10M"
  },
  {
    "Retail Branding": "Atozee",
    "Marketing Name": "YQ10SK",
    "Device": "YQ10SK",
    "Model": "YQ10S"
  },
  {
    "Retail Branding": "Atozee",
    "Marketing Name": "YQ10SK",
    "Device": "YQ10SK",
    "Model": "YQ10SK"
  },
  {
    "Retail Branding": "Atozee",
    "Marketing Name": "YQ10S_Gold",
    "Device": "YQ10S_Gold",
    "Model": "YQ10S_Gold"
  },
  {
    "Retail Branding": "Atozee",
    "Marketing Name": "YQ10S_MAX",
    "Device": "YQ10S_MAX",
    "Model": "YQ10S_MAX"
  },
  {
    "Retail Branding": "Atozee",
    "Marketing Name": "YQ10S_PRO",
    "Device": "YQ10S_PRO",
    "Model": "YQ10S_PRO"
  },
  {
    "Retail Branding": "Atozee",
    "Marketing Name": "ZB10S",
    "Device": "ZB10S",
    "Model": "ZB10S"
  },
  {
    "Retail Branding": "Atozee",
    "Marketing Name": "ZB11S",
    "Device": "ZB11S",
    "Model": "ZB11S"
  },
  {
    "Retail Branding": "Atria Convergence Technologies",
    "Marketing Name": "ACT",
    "Device": "B860H_V1",
    "Model": "B860H"
  },
  {
    "Retail Branding": "Attila",
    "Marketing Name": "Magic_1",
    "Device": "Magic_1",
    "Model": "Magic_1"
  },
  {
    "Retail Branding": "Attila",
    "Marketing Name": "S25",
    "Device": "S25",
    "Model": "S25"
  },
  {
    "Retail Branding": "Attila",
    "Marketing Name": "WTATTRW2",
    "Device": "WTATTRW2",
    "Model": "WTATTRW2"
  },
  {
    "Retail Branding": "Auchan",
    "Marketing Name": "AUCHAN",
    "Device": "Q7T9INK",
    "Model": "Q7T9INK"
  },
  {
    "Retail Branding": "Auchan",
    "Marketing Name": "LI12210IN",
    "Device": "LI12210IN",
    "Model": "LI12210IN"
  },
  {
    "Retail Branding": "Auchan",
    "Marketing Name": "LI902T9IN",
    "Device": "LI902T9IN",
    "Model": "LI902T9IN"
  },
  {
    "Retail Branding": "Auchan",
    "Marketing Name": "LZ_890",
    "Device": "LZ_890",
    "Model": "LZ_890"
  },
  {
    "Retail Branding": "Auchan",
    "Marketing Name": "Q.4514",
    "Device": "Q4514",
    "Model": "Q4514"
  },
  {
    "Retail Branding": "Auchan",
    "Marketing Name": "Q10S53IN4G",
    "Device": "Q10S53IN4G",
    "Model": "Q10S53IN4G"
  },
  {
    "Retail Branding": "Auchan",
    "Marketing Name": "Q4S6IN4G",
    "Device": "Q4S6IN4G",
    "Model": "Q4S6IN4G"
  },
  {
    "Retail Branding": "Auchan",
    "Marketing Name": "Q4T10IN",
    "Device": "Q4T10IN",
    "Model": "Q4T10IN"
  },
  {
    "Retail Branding": "Auchan",
    "Marketing Name": "Q4T7IN",
    "Device": "Q4T7IN",
    "Model": "Q4T7IN"
  },
  {
    "Retail Branding": "Auchan",
    "Marketing Name": "Q4T7IN3G",
    "Device": "Q4T7IN3G",
    "Model": "Q4T7IN3G"
  },
  {
    "Retail Branding": "Auchan",
    "Marketing Name": "Q4T8IN",
    "Device": "Q4T8IN",
    "Model": "Q4T8IN"
  },
  {
    "Retail Branding": "Auchan",
    "Marketing Name": "Q5S55IN4G",
    "Device": "Q5S55IN4G",
    "Model": "Q5S55IN4G"
  },
  {
    "Retail Branding": "Auchan",
    "Marketing Name": "Q5S5IN4G",
    "Device": "Q5S5IN4G",
    "Model": "Q5S5IN4G"
  },
  {
    "Retail Branding": "Auchan",
    "Marketing Name": "Q6T10IN",
    "Device": "Q6T10IN",
    "Model": "Q6T10IN"
  },
  {
    "Retail Branding": "Auchan",
    "Marketing Name": "Q6T10IN4G",
    "Device": "Q6T10IN4G",
    "Model": "Q6T10IN4G"
  },
  {
    "Retail Branding": "Auchan",
    "Marketing Name": "Q6T7IN",
    "Device": "Q6T7IN",
    "Model": "Q6T7IN"
  },
  {
    "Retail Branding": "Auchan",
    "Marketing Name": "Q6T7IN4G",
    "Device": "Q6T7IN4G",
    "Model": "Q6T7IN4G"
  },
  {
    "Retail Branding": "Auchan",
    "Marketing Name": "Q6T7INK",
    "Device": "Q6T7INK",
    "Model": "Q6T7INK"
  },
  {
    "Retail Branding": "Auchan",
    "Marketing Name": "Q7S55IN4G",
    "Device": "Q7S55IN4G",
    "Model": "Q7S55IN4G"
  },
  {
    "Retail Branding": "Auchan",
    "Marketing Name": "Q7S5IN4G",
    "Device": "Q7S5IN4G",
    "Model": "Q7S5IN4G"
  },
  {
    "Retail Branding": "Auchan",
    "Marketing Name": "Q7S5IN4GP",
    "Device": "Q7S5IN4GP",
    "Model": "Q7S5IN4GP"
  },
  {
    "Retail Branding": "Auchan",
    "Marketing Name": "Q7T10INP",
    "Device": "Q7T10INP",
    "Model": "Q7T10INP"
  },
  {
    "Retail Branding": "Auchan",
    "Marketing Name": "Q7T7INK",
    "Device": "Q7T7INK",
    "Model": "Q7T7INK"
  },
  {
    "Retail Branding": "Auchan",
    "Marketing Name": "Q7T9INK",
    "Device": "Q7T9INK",
    "Model": "Q7T9INK"
  },
  {
    "Retail Branding": "Auchan",
    "Marketing Name": "Q8S55IN4G",
    "Device": "Q8S55IN4G",
    "Model": "Q8S55IN4G"
  },
  {
    "Retail Branding": "Auchan",
    "Marketing Name": "Q8S55IN4G2",
    "Device": "Q8S55IN4G2",
    "Model": "Q8S55IN4G2"
  },
  {
    "Retail Branding": "Auchan",
    "Marketing Name": "Q8S5IN4GP",
    "Device": "Q8S5IN4GP",
    "Model": "Q8S5IN4GP"
  },
  {
    "Retail Branding": "Auchan",
    "Marketing Name": "Q8S6IN4G",
    "Device": "Q8S6IN4G",
    "Model": "Q8S6IN4G"
  },
  {
    "Retail Branding": "Auchan",
    "Marketing Name": "Q8T10IN",
    "Device": "Q8T10IN",
    "Model": "Q8T10IN"
  },
  {
    "Retail Branding": "Auchan",
    "Marketing Name": "Q8T7IN",
    "Device": "Q8T7IN",
    "Model": "Q8T7IN"
  },
  {
    "Retail Branding": "Auchan",
    "Marketing Name": "Q8T7IN4G",
    "Device": "Q8T7IN4G",
    "Model": "Q8T7IN4G"
  },
  {
    "Retail Branding": "Auchan",
    "Marketing Name": "Q9S5IN4G",
    "Device": "Q9S5IN4G",
    "Model": "Q9S5IN4G"
  },
  {
    "Retail Branding": "Auchan",
    "Marketing Name": "Q9S5IN4G2",
    "Device": "Q9S5IN4G2",
    "Model": "Q9S5IN4G2"
  },
  {
    "Retail Branding": "Auchan",
    "Marketing Name": "QILIVE",
    "Device": "Q4T10INK",
    "Model": "Q4T10INK"
  },
  {
    "Retail Branding": "Auchan",
    "Marketing Name": "S3T10IN",
    "Device": "S3T10IN",
    "Model": "S3T10IN"
  },
  {
    "Retail Branding": "Auchan",
    "Marketing Name": "S3T10IN3G",
    "Device": "S3T10IN3G",
    "Model": "S3T10IN3G"
  },
  {
    "Retail Branding": "Auchan",
    "Marketing Name": "S3T7IN",
    "Device": "S3T7IN",
    "Model": "S3T7IN"
  },
  {
    "Retail Branding": "Auchan",
    "Marketing Name": "S3T7IN",
    "Device": "astar-d86",
    "Model": "S3T7IN"
  },
  {
    "Retail Branding": "Auchan",
    "Marketing Name": "S3T7IN3G",
    "Device": "S3T7IN3G",
    "Model": "S3T7IN3G"
  },
  {
    "Retail Branding": "Auchan",
    "Marketing Name": "S4S5IN3G",
    "Device": "S4S5IN3G",
    "Model": "S4S5IN3G"
  },
  {
    "Retail Branding": "Auchan",
    "Marketing Name": "S4S5IN4G",
    "Device": "S4S5IN4G",
    "Model": "S4S5IN4G"
  },
  {
    "Retail Branding": "Auchan",
    "Marketing Name": "S4S6IN3G",
    "Device": "S4S6IN3G",
    "Model": "S4S6IN3G"
  },
  {
    "Retail Branding": "Auchan",
    "Marketing Name": "S4T10IN3G",
    "Device": "S4T10IN3G",
    "Model": "S4T10IN3G"
  },
  {
    "Retail Branding": "Auchan",
    "Marketing Name": "S4T7IN",
    "Device": "S4T7IN",
    "Model": "S4T7IN"
  },
  {
    "Retail Branding": "Auchan",
    "Marketing Name": "S4T7IN3G",
    "Device": "S4T7IN3G",
    "Model": "S4T7IN3G"
  },
  {
    "Retail Branding": "Auchan",
    "Marketing Name": "S4T9IN",
    "Device": "S4T9IN",
    "Model": "S4T9IN"
  },
  {
    "Retail Branding": "Auchan",
    "Marketing Name": "S5S4IN3G",
    "Device": "S5S4IN3G",
    "Model": "S5S4IN3G"
  },
  {
    "Retail Branding": "Auchan",
    "Marketing Name": "S5S5IN4G",
    "Device": "S5S5IN4G",
    "Model": "S5S5IN4G"
  },
  {
    "Retail Branding": "Auchan",
    "Marketing Name": "S5T10IN",
    "Device": "S5T10IN",
    "Model": "S5T10IN"
  },
  {
    "Retail Branding": "Auchan",
    "Marketing Name": "S5T10IN3G",
    "Device": "S5T10IN3G",
    "Model": "S5T10IN3G"
  },
  {
    "Retail Branding": "Auchan",
    "Marketing Name": "S5T10INBT",
    "Device": "S5T10INBT",
    "Model": "S5T10INBT"
  },
  {
    "Retail Branding": "Auchan",
    "Marketing Name": "S5T7IN3G",
    "Device": "S5T7IN3G",
    "Model": "S5T7IN3G"
  },
  {
    "Retail Branding": "Auchan",
    "Marketing Name": "S5T9INDVD",
    "Device": "S5T9INDVD",
    "Model": "S5T9INDVD"
  },
  {
    "Retail Branding": "Auchan",
    "Marketing Name": "S6S4IN3G",
    "Device": "S6S4IN3G",
    "Model": "S6S4IN3G"
  },
  {
    "Retail Branding": "Auchan",
    "Marketing Name": "S6S55IN3G",
    "Device": "S6S55IN3G",
    "Model": "S6S55IN3G"
  },
  {
    "Retail Branding": "Auchan",
    "Marketing Name": "S6S5IN3G",
    "Device": "S6S5IN3G",
    "Model": "S6S5IN3G"
  },
  {
    "Retail Branding": "Auchan",
    "Marketing Name": "S6S6IN3G",
    "Device": "S6S6IN3G",
    "Model": "S6S6IN3G"
  },
  {
    "Retail Branding": "Auchan",
    "Marketing Name": "S6T7IN3G",
    "Device": "S6T7IN3G",
    "Model": "S6T7IN3G"
  },
  {
    "Retail Branding": "Auchan",
    "Marketing Name": "SP19403",
    "Device": "SP19403",
    "Model": "SP19403"
  },
  {
    "Retail Branding": "Auchan",
    "Marketing Name": "SP19504",
    "Device": "SP19504",
    "Model": "SP19504"
  },
  {
    "Retail Branding": "Auchan",
    "Marketing Name": "ST19071",
    "Device": "ST19071_EEA",
    "Model": "ST19071"
  },
  {
    "Retail Branding": "Auchan",
    "Marketing Name": "ST19101",
    "Device": "ST19101",
    "Model": "ST19101"
  },
  {
    "Retail Branding": "Auchan",
    "Marketing Name": "Selecline X35T",
    "Device": "X35T",
    "Model": "X35T"
  },
  {
    "Retail Branding": "Auchan",
    "Marketing Name": "Selecline-854599",
    "Device": 854599,
    "Model": "Selecline-854599"
  },
  {
    "Retail Branding": "Auchan",
    "Marketing Name": "Smartphone 5\" Q.4094",
    "Device": "ac50bhe",
    "Model": "Q.4094"
  },
  {
    "Retail Branding": "Audi AG",
    "Marketing Name": "Audi Tab CN",
    "Device": "sdis1",
    "Model": "Audi tablet"
  },
  {
    "Retail Branding": "Audi AG",
    "Marketing Name": "Audi tablet",
    "Device": "sdis1",
    "Model": "Audi tablet"
  },
  {
    "Retail Branding": "Audi AG",
    "Marketing Name": "RSE-III",
    "Device": "RSEIII",
    "Model": "RSEIII"
  },
  {
    "Retail Branding": "Audi AG",
    "Marketing Name": "SDIS1",
    "Device": "sdis1",
    "Model": "Audi tablet"
  },
  {
    "Retail Branding": "Audiovox",
    "Marketing Name": "T752 Tablet",
    "Device": "AD7L",
    "Model": "T752"
  },
  {
    "Retail Branding": "Audiovox",
    "Marketing Name": "T852 Tablet",
    "Device": "MID30801",
    "Model": "T852"
  },
  {
    "Retail Branding": "Aura",
    "Marketing Name": "DemoPad",
    "Device": "DemoPad",
    "Model": "DemoPad"
  },
  {
    "Retail Branding": "Aura",
    "Marketing Name": "Lite8",
    "Device": "Lite8",
    "Model": "Lite8"
  },
  {
    "Retail Branding": "Aura",
    "Marketing Name": "Smart_Landline_AC7",
    "Device": "SMART_LL_AC7",
    "Model": "Smart Landline AC7 Tablet"
  },
  {
    "Retail Branding": "Auris",
    "Marketing Name": "TB-701",
    "Device": "TB-701",
    "Model": "TB-701"
  },
  {
    "Retail Branding": "Austrostream",
    "Marketing Name": "TV Box",
    "Device": "SEID00ORS",
    "Model": "TV Box"
  },
  {
    "Retail Branding": "Avaya",
    "Marketing Name": "Vantage",
    "Device": "K175",
    "Model": "Avaya Vantage"
  },
  {
    "Retail Branding": "Avaya",
    "Marketing Name": "Vantage",
    "Device": "K175",
    "Model": "K175"
  },
  {
    "Retail Branding": "Avaya",
    "Marketing Name": "Vantage",
    "Device": "Vantage",
    "Model": "Avaya Vantage"
  },
  {
    "Retail Branding": "Avaya",
    "Marketing Name": "Vantage",
    "Device": "Vantage",
    "Model": "K165"
  },
  {
    "Retail Branding": "AvidPad",
    "Marketing Name": "A30",
    "Device": "A30",
    "Model": "A30"
  },
  {
    "Retail Branding": "AvidPad",
    "Marketing Name": "A30PRO",
    "Device": "A30PRO",
    "Model": "A30PRO"
  },
  {
    "Retail Branding": "AvidPad",
    "Marketing Name": "A60",
    "Device": "A60",
    "Model": "A60"
  },
  {
    "Retail Branding": "AvidPad",
    "Marketing Name": "A60",
    "Device": "A60",
    "Model": "S28 ultra"
  },
  {
    "Retail Branding": "AvidPad",
    "Marketing Name": "A90PRO",
    "Device": "A90PRO",
    "Model": "A90PRO"
  },
  {
    "Retail Branding": "AvidPad",
    "Marketing Name": "A90S-1",
    "Device": "A90S-1",
    "Model": "A90S-1"
  },
  {
    "Retail Branding": "AvidPad",
    "Marketing Name": "S30",
    "Device": "S30",
    "Model": "S30"
  },
  {
    "Retail Branding": "AvidPad",
    "Marketing Name": "S60",
    "Device": "S60",
    "Model": "S60"
  },
  {
    "Retail Branding": "AvidPad",
    "Marketing Name": "S80",
    "Device": "S80",
    "Model": "S80"
  },
  {
    "Retail Branding": "AvidPad",
    "Marketing Name": "S90",
    "Device": "S90",
    "Model": "S90"
  },
  {
    "Retail Branding": "Avion",
    "Marketing Name": "Avion A10",
    "Device": "Avion_A10",
    "Model": "Avion A10"
  },
  {
    "Retail Branding": "Avion",
    "Marketing Name": "Avion A10 Pro",
    "Device": "Avion_A10_Pro",
    "Model": "Avion A10 Pro"
  },
  {
    "Retail Branding": "Avion",
    "Marketing Name": "m2",
    "Device": "Avion_M2",
    "Model": "M2"
  },
  {
    "Retail Branding": "Aviron",
    "Marketing Name": "ATS",
    "Device": "ATS",
    "Model": "ATS"
  },
  {
    "Retail Branding": "Aviron",
    "Marketing Name": "ATS6",
    "Device": "ATS6",
    "Model": "ATS6"
  },
  {
    "Retail Branding": "Avoca",
    "Marketing Name": "STB7012",
    "Device": "STB7012",
    "Model": "STB7012"
  },
  {
    "Retail Branding": "Avoca",
    "Marketing Name": "STB7013",
    "Device": "AVOCA",
    "Model": "STB7013"
  },
  {
    "Retail Branding": "Avoca",
    "Marketing Name": "STB8098",
    "Device": "STB8098",
    "Model": "STB8098"
  },
  {
    "Retail Branding": "Avoca",
    "Marketing Name": "STB9097",
    "Device": "STB9097",
    "Model": "STB9097"
  },
  {
    "Retail Branding": "Avtek",
    "Marketing Name": "TS 8 Lite G",
    "Device": "rk3576_u",
    "Model": "TS_8_Lite_G"
  },
  {
    "Retail Branding": "Avtek",
    "Marketing Name": "TS_8_1_Mate_G",
    "Device": "MTK9679",
    "Model": "TS_8_1_Mate_G"
  },
  {
    "Retail Branding": "Avvio",
    "Marketing Name": "A680",
    "Device": "A680",
    "Model": "aiworks"
  },
  {
    "Retail Branding": "Avvio",
    "Marketing Name": "Avvio 4GO",
    "Device": "Avvio_4GO",
    "Model": "Avvio_4GO"
  },
  {
    "Retail Branding": "Avvio",
    "Marketing Name": "Avvio A400",
    "Device": "Avvio_A400",
    "Model": "Avvio_A400"
  },
  {
    "Retail Branding": "Avvio",
    "Marketing Name": "Avvio BSC451",
    "Device": "Avvio_BSC451",
    "Model": "BSC451"
  },
  {
    "Retail Branding": "Avvio",
    "Marketing Name": "Avvio Copa 18",
    "Device": "Colombia_2018",
    "Model": "Colombia_2018"
  },
  {
    "Retail Branding": "Avvio",
    "Marketing Name": "Avvio PRO450",
    "Device": "Avvio_PRO450",
    "Model": "Avvio_Pro450"
  },
  {
    "Retail Branding": "Avvio",
    "Marketing Name": "Avvio PRO450",
    "Device": "Avvio_Pro450",
    "Model": "Avvio_Pro450"
  },
  {
    "Retail Branding": "Avvio",
    "Marketing Name": "Avvio PRO550",
    "Device": "Avvio_Pro550",
    "Model": "Avvio_Pro550"
  },
  {
    "Retail Branding": "Avvio",
    "Marketing Name": "Avvio Platinum A50",
    "Device": "Avvio_A50",
    "Model": "Avvio_A50"
  },
  {
    "Retail Branding": "Avvio",
    "Marketing Name": "Avvio_A600",
    "Device": "Avvio_A600",
    "Model": "Avvio_A600"
  },
  {
    "Retail Branding": "Avvio",
    "Marketing Name": "CHIVAS 50",
    "Device": "CHIVAS_50",
    "Model": "CHIVAS_50"
  },
  {
    "Retail Branding": "Avvio",
    "Marketing Name": "CHIVAS 55",
    "Device": "CHIVAS_55",
    "Model": "CHIVAS_55"
  },
  {
    "Retail Branding": "Avvio",
    "Marketing Name": "Mint_M353",
    "Device": "Mint_M353",
    "Model": "Mint_M353"
  },
  {
    "Retail Branding": "Avvio",
    "Marketing Name": "Q503",
    "Device": "Avvio_Q503",
    "Model": "Avvio_Q503"
  },
  {
    "Retail Branding": "Axen",
    "Marketing Name": "AXEN 2K Google TV",
    "Device": "capitolhill",
    "Model": "AXEN 2K Google TV"
  },
  {
    "Retail Branding": "Axen",
    "Marketing Name": "AXEN 4K Google TV",
    "Device": "keoneae",
    "Model": "AXEN 4K Google TV"
  },
  {
    "Retail Branding": "Axioo",
    "Marketing Name": "Axioo AX4",
    "Device": "Axioo_AX4",
    "Model": "Axioo_AX4"
  },
  {
    "Retail Branding": "Axioo",
    "Marketing Name": "MH",
    "Device": "MH",
    "Model": "MH"
  },
  {
    "Retail Branding": "Axioo",
    "Marketing Name": "PICOpad-7H",
    "Device": "PICOpad-7H",
    "Model": "PICOpad-7H"
  },
  {
    "Retail Branding": "Axioo",
    "Marketing Name": "PICOpad_7H_JE",
    "Device": "PICOpad_7H_JE",
    "Model": "PICOpad_7H_JE"
  },
  {
    "Retail Branding": "Axioo",
    "Marketing Name": "PICOpad_7H_JL",
    "Device": "PICOpad_7H_JL",
    "Model": "PICOpad_7H_JL"
  },
  {
    "Retail Branding": "Axioo",
    "Marketing Name": "PICOpad_7H_R8",
    "Device": "PICOpad_7H_R8",
    "Model": "PICOpad_7H_R8"
  },
  {
    "Retail Branding": "Axxa Mobile",
    "Marketing Name": "GEM",
    "Device": "GEM",
    "Model": "GEM"
  },
  {
    "Retail Branding": "Axzy",
    "Marketing Name": "Axzy_Pad",
    "Device": "Axzy_Pad",
    "Model": "Axzy_Pad"
  },
  {
    "Retail Branding": "Axzy",
    "Marketing Name": "Axzy_Pad",
    "Device": "Axzy_Pad",
    "Model": "E140B"
  },
  {
    "Retail Branding": "Axzy",
    "Marketing Name": "Axzy_Pad_Pro",
    "Device": "Axzy_Pad_Pro",
    "Model": "Axzy_Pad_Pro"
  },
  {
    "Retail Branding": "Ayat",
    "Marketing Name": "Ayat_101",
    "Device": "Ayat_101",
    "Model": "Ayat_101"
  },
  {
    "Retail Branding": "Ayonz EKO",
    "Marketing Name": "SV11",
    "Device": "ICN",
    "Model": "KATV10"
  },
  {
    "Retail Branding": "Azatech",
    "Marketing Name": "AZATECH",
    "Device": "elliniko",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "Azatech",
    "Marketing Name": "AZATECH",
    "Device": "jagalchi",
    "Model": "2K SMART TV"
  },
  {
    "Retail Branding": "Azatech",
    "Marketing Name": "AZATECH",
    "Device": "stanford",
    "Model": "SMART TV"
  },
  {
    "Retail Branding": "Azatech",
    "Marketing Name": "AZATECH",
    "Device": "zhongshan",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "Azeyou",
    "Marketing Name": "AT1002J",
    "Device": "AT1002J",
    "Model": "AT1002J"
  },
  {
    "Retail Branding": "Azeyou",
    "Marketing Name": "AT1011E",
    "Device": "AT1011E",
    "Model": "AT1011E"
  },
  {
    "Retail Branding": "Azeyou",
    "Marketing Name": "AT1011U",
    "Device": "AT1011U",
    "Model": "AT1011U"
  },
  {
    "Retail Branding": "Azeyou",
    "Marketing Name": "AT1012E",
    "Device": "AT1012E",
    "Model": "AT1012E"
  },
  {
    "Retail Branding": "Azeyou",
    "Marketing Name": "AT1012U",
    "Device": "AT1012U",
    "Model": "AT1012U"
  },
  {
    "Retail Branding": "Azeyou",
    "Marketing Name": "AT1014",
    "Device": "AT1014",
    "Model": "AT1014"
  },
  {
    "Retail Branding": "Azeyou",
    "Marketing Name": "AT1014U",
    "Device": "AT1014U",
    "Model": "AT1014U"
  },
  {
    "Retail Branding": "Azeyou",
    "Marketing Name": "AT1016BBK",
    "Device": "AT1016BBK",
    "Model": "T50"
  },
  {
    "Retail Branding": "Azeyou",
    "Marketing Name": "AT1016E",
    "Device": "AT1016E",
    "Model": "T50"
  },
  {
    "Retail Branding": "Azeyou",
    "Marketing Name": "AT1016U",
    "Device": "AT1016U",
    "Model": "Tab6"
  },
  {
    "Retail Branding": "Azeyou",
    "Marketing Name": "AT1031E",
    "Device": "AT1031E",
    "Model": "AT1031E"
  },
  {
    "Retail Branding": "Azeyou",
    "Marketing Name": "AT1031U",
    "Device": "AT1031U",
    "Model": "AT1031U"
  },
  {
    "Retail Branding": "Azeyou",
    "Marketing Name": "AT1101",
    "Device": "AT1101",
    "Model": "AT1101"
  },
  {
    "Retail Branding": "Azeyou",
    "Marketing Name": "AT1202J",
    "Device": "AT1202J",
    "Model": "AT1202J"
  },
  {
    "Retail Branding": "Azeyou",
    "Marketing Name": "AT701E",
    "Device": "AT701E",
    "Model": "AT701E"
  },
  {
    "Retail Branding": "Azeyou",
    "Marketing Name": "AT701U",
    "Device": "AT701U",
    "Model": "AT701U"
  },
  {
    "Retail Branding": "Azeyou",
    "Marketing Name": "AT801",
    "Device": "AT801",
    "Model": "AT801"
  },
  {
    "Retail Branding": "Azeyou",
    "Marketing Name": "AT801U",
    "Device": "AT801U",
    "Model": "AT801U"
  },
  {
    "Retail Branding": "Azeyou",
    "Marketing Name": "AT_701B",
    "Device": "AT_701B",
    "Model": "AT_701B"
  },
  {
    "Retail Branding": "Azeyou",
    "Marketing Name": "F8E",
    "Device": "F8",
    "Model": "F8"
  },
  {
    "Retail Branding": "Azeyou",
    "Marketing Name": "F8U",
    "Device": "F8",
    "Model": "F8"
  },
  {
    "Retail Branding": "Azeyou",
    "Marketing Name": "K10E",
    "Device": "K10",
    "Model": "K10"
  },
  {
    "Retail Branding": "Azeyou",
    "Marketing Name": "K10U",
    "Device": "K10",
    "Model": "K10"
  },
  {
    "Retail Branding": "Azeyou",
    "Marketing Name": "M17QF27A",
    "Device": "M17QF27A",
    "Model": "M17QF27A"
  },
  {
    "Retail Branding": "Azeyou",
    "Marketing Name": "M17T11",
    "Device": "M17T11",
    "Model": "M17T11"
  },
  {
    "Retail Branding": "Azeyou",
    "Marketing Name": "M87QF6-4G",
    "Device": "M87QF6-4G",
    "Model": "M87QF6-4G"
  },
  {
    "Retail Branding": "Azeyou",
    "Marketing Name": "T11",
    "Device": "T11",
    "Model": "T11"
  },
  {
    "Retail Branding": "Azumi",
    "Marketing Name": "A4",
    "Device": "A4",
    "Model": "Azumi A4"
  },
  {
    "Retail Branding": "Azumi",
    "Marketing Name": "A4",
    "Device": "A4_AC25",
    "Model": "Azumi A4"
  },
  {
    "Retail Branding": "Azumi",
    "Marketing Name": "A4",
    "Device": "Azumi_A4_AC12OM",
    "Model": "A4"
  },
  {
    "Retail Branding": "Azumi",
    "Marketing Name": "A4 Go",
    "Device": "Azumi_A4_AC25B",
    "Model": "A4"
  },
  {
    "Retail Branding": "Azumi",
    "Marketing Name": "A4 Go",
    "Device": "Azumi_A4_AC27B",
    "Model": "A4"
  },
  {
    "Retail Branding": "Azumi",
    "Marketing Name": "A40 Style Plus",
    "Device": "A40_Style_Plus",
    "Model": "A40_Style_Plus"
  },
  {
    "Retail Branding": "Azumi",
    "Marketing Name": "A40C",
    "Device": "A40C",
    "Model": "A40C"
  },
  {
    "Retail Branding": "Azumi",
    "Marketing Name": "A4PLUS_AC11",
    "Device": "Azumi_A4PLUS_AC11",
    "Model": "Azumi A4+"
  },
  {
    "Retail Branding": "Azumi",
    "Marketing Name": "A4V",
    "Device": "Azumi_A4v",
    "Model": "Azumi A4v"
  },
  {
    "Retail Branding": "Azumi",
    "Marketing Name": "A4_AC19",
    "Device": "Azumi_A4_AC19",
    "Model": "A4"
  },
  {
    "Retail Branding": "Azumi",
    "Marketing Name": "A4_AC24B",
    "Device": "Azumi_A4_AC24B",
    "Model": "A4"
  },
  {
    "Retail Branding": "Azumi",
    "Marketing Name": "A4_AC27",
    "Device": "Azumi_A4_AC27",
    "Model": "A4"
  },
  {
    "Retail Branding": "Azumi",
    "Marketing Name": "A4_B",
    "Device": "Azumi_A4_B",
    "Model": "A4"
  },
  {
    "Retail Branding": "Azumi",
    "Marketing Name": "A5+",
    "Device": "Azumi_A5_P",
    "Model": "A5+"
  },
  {
    "Retail Branding": "Azumi",
    "Marketing Name": "A50 Style Plus",
    "Device": "A50_Style_Plus",
    "Model": "A50_Style_Plus"
  },
  {
    "Retail Branding": "Azumi",
    "Marketing Name": "A50LT",
    "Device": "A50LT",
    "Model": "A50LT"
  },
  {
    "Retail Branding": "Azumi",
    "Marketing Name": "A53",
    "Device": "Azumi_A53",
    "Model": "A53"
  },
  {
    "Retail Branding": "Azumi",
    "Marketing Name": "A57B",
    "Device": "Azumi_A57B",
    "Model": "A57B"
  },
  {
    "Retail Branding": "Azumi",
    "Marketing Name": "A57h",
    "Device": "Azumi_A57h",
    "Model": "A57"
  },
  {
    "Retail Branding": "Azumi",
    "Marketing Name": "A5B",
    "Device": "Azumi_A5B_BD",
    "Model": "A5B"
  },
  {
    "Retail Branding": "Azumi",
    "Marketing Name": "A5_AC11",
    "Device": "A5_AC11",
    "Model": "A5"
  },
  {
    "Retail Branding": "Azumi",
    "Marketing Name": "A5_P1",
    "Device": "Azumi_A5_P1",
    "Model": "A5+"
  },
  {
    "Retail Branding": "Azumi",
    "Marketing Name": "AT7",
    "Device": "AT7",
    "Model": "AT7"
  },
  {
    "Retail Branding": "Azumi",
    "Marketing Name": "AX5",
    "Device": "AX5",
    "Model": "Azumi AX5"
  },
  {
    "Retail Branding": "Azumi",
    "Marketing Name": "AZUMI KIREI A5D",
    "Device": "KIREI_A5_D",
    "Model": "Azumi KIREI A5 D"
  },
  {
    "Retail Branding": "Azumi",
    "Marketing Name": "AZUMI V5",
    "Device": "AZUMI_V5",
    "Model": "V5"
  },
  {
    "Retail Branding": "Azumi",
    "Marketing Name": "AZUMI_Daburu_A55O",
    "Device": "Daburu_A55O",
    "Model": "Azumi_Daburu_A55O"
  },
  {
    "Retail Branding": "Azumi",
    "Marketing Name": "AZUMI_M5_AC01",
    "Device": "AZUMI_M5_AC01",
    "Model": "M5"
  },
  {
    "Retail Branding": "Azumi",
    "Marketing Name": "AZUMI_M5_AC02",
    "Device": "AZUMI_M5_AC02",
    "Model": "M5"
  },
  {
    "Retail Branding": "Azumi",
    "Marketing Name": "AZUMI_V5_AC01",
    "Device": "AZUMI_V5_AC01",
    "Model": "Azumi V51"
  },
  {
    "Retail Branding": "Azumi",
    "Marketing Name": "AZUMI_V5_AC01",
    "Device": "AZUMI_V5_AC01",
    "Model": "V5"
  },
  {
    "Retail Branding": "Azumi",
    "Marketing Name": "Azumi A4",
    "Device": "Azumi_A4_MB",
    "Model": "A4"
  },
  {
    "Retail Branding": "Azumi",
    "Marketing Name": "Azumi A4 +",
    "Device": "Azumi_A4_Plus",
    "Model": "A4+"
  },
  {
    "Retail Branding": "Azumi",
    "Marketing Name": "Azumi A45",
    "Device": "Azumi_A45",
    "Model": "A45"
  },
  {
    "Retail Branding": "Azumi",
    "Marketing Name": "Azumi A45",
    "Device": "Azumi_A45_AC26",
    "Model": "A45"
  },
  {
    "Retail Branding": "Azumi",
    "Marketing Name": "Azumi A5",
    "Device": "A5",
    "Model": "Azumi A5"
  },
  {
    "Retail Branding": "Azumi",
    "Marketing Name": "Azumi A5C",
    "Device": "AZUMI_A5C",
    "Model": "A5C"
  },
  {
    "Retail Branding": "Azumi",
    "Marketing Name": "Azumi K55QL",
    "Device": "Azumi_K55QLB",
    "Model": "Azumi K55QL"
  },
  {
    "Retail Branding": "Azumi",
    "Marketing Name": "Azumi K55QL",
    "Device": "Azumi_K55QL_AC15",
    "Model": "K55QL"
  },
  {
    "Retail Branding": "Azumi",
    "Marketing Name": "Azumi V4",
    "Device": "Azumi_V4_AC04",
    "Model": "Azumi V4"
  },
  {
    "Retail Branding": "Azumi",
    "Marketing Name": "Azumi V5",
    "Device": "Azumi_V5_AC04",
    "Model": "Azumi_V5"
  },
  {
    "Retail Branding": "Azumi",
    "Marketing Name": "Azumi V54",
    "Device": "Azumi_V54_AC01",
    "Model": "V54"
  },
  {
    "Retail Branding": "Azumi",
    "Marketing Name": "Azumi V54",
    "Device": "Azumi_V54_AC23",
    "Model": "V54"
  },
  {
    "Retail Branding": "Azumi",
    "Marketing Name": "Azumi V65",
    "Device": "AZUMI_V65_AC04",
    "Model": "Azumi_V65"
  },
  {
    "Retail Branding": "Azumi",
    "Marketing Name": "Azumi V65+",
    "Device": "AZUMI_V65_PLUS_AC04",
    "Model": "Azumi_V65_PLUS"
  },
  {
    "Retail Branding": "Azumi",
    "Marketing Name": "Azumi_ V5_ AC05",
    "Device": "Azumi_V5_AC05",
    "Model": "V5"
  },
  {
    "Retail Branding": "Azumi",
    "Marketing Name": "Azumi_A4PLUS_AC11",
    "Device": "Azumi_A4PLUS_AC11",
    "Model": "Azumi A4+"
  },
  {
    "Retail Branding": "Azumi",
    "Marketing Name": "Azumi_A5_AC15",
    "Device": "Azumi_A5_AC15",
    "Model": "A5"
  },
  {
    "Retail Branding": "Azumi",
    "Marketing Name": "Azumi_AKANE",
    "Device": "Azumi_AKANE",
    "Model": "Azumi AKANE"
  },
  {
    "Retail Branding": "Azumi",
    "Marketing Name": "Azumi_Extend_Akaru_55_QL",
    "Device": "Extend_Akaru_55_QL",
    "Model": "Azumi Extend Akaru 55 QL"
  },
  {
    "Retail Branding": "Azumi",
    "Marketing Name": "Azumi_IKU_54",
    "Device": "Azumi_IKU_54",
    "Model": "Azumi IKU 54"
  },
  {
    "Retail Branding": "Azumi",
    "Marketing Name": "Azumi_IKU_A55_MB",
    "Device": "Azumi_IKU_A55_MB",
    "Model": "IKU A55"
  },
  {
    "Retail Branding": "Azumi",
    "Marketing Name": "Azumi_K55QL_AC04",
    "Device": "Azumi_K55QL_AC04",
    "Model": "Azumi K55QL"
  },
  {
    "Retail Branding": "Azumi",
    "Marketing Name": "Azumi_KIREI_A45_D",
    "Device": "KIREI_A45_D",
    "Model": "Azumi_KIREI_A45_D"
  },
  {
    "Retail Branding": "Azumi",
    "Marketing Name": "Azumi_KIREI_A4_D",
    "Device": "KIREI_A4_D",
    "Model": "Azumi_KIREI_A4_D"
  },
  {
    "Retail Branding": "Azumi",
    "Marketing Name": "Azumi_KIREI_A5_D",
    "Device": "KIREI_A5_D",
    "Model": "Azumi_KIREI_A5_D"
  },
  {
    "Retail Branding": "Azumi",
    "Marketing Name": "Azumi_M5_P",
    "Device": "Azumi_M5_P",
    "Model": "Azumi_M5+"
  },
  {
    "Retail Branding": "Azumi",
    "Marketing Name": "Azumi_Speed_Pro_55",
    "Device": "Speed_Pro_55",
    "Model": "Azumi_Speed_Pro_55"
  },
  {
    "Retail Branding": "Azumi",
    "Marketing Name": "Azumi_V54_AC04",
    "Device": "Azumi_V54_AC04",
    "Model": "Azumi_V54"
  },
  {
    "Retail Branding": "Azumi",
    "Marketing Name": "Azumi_V54_MB",
    "Device": "Azumi_V54_MB",
    "Model": "V54"
  },
  {
    "Retail Branding": "Azumi",
    "Marketing Name": "Azumi_V5PLUS_AC24",
    "Device": "Azumi_V5PLUS_AC24",
    "Model": "V5+"
  },
  {
    "Retail Branding": "Azumi",
    "Marketing Name": "Azumi_V5c",
    "Device": "Azumi_V5C",
    "Model": "V5C"
  },
  {
    "Retail Branding": "Azumi",
    "Marketing Name": "DOSHI A55 QL",
    "Device": "Azumi_DOSHI_A55_QL",
    "Model": "Azumi_DOSHI_A55_QL"
  },
  {
    "Retail Branding": "Azumi",
    "Marketing Name": "EXTEND 55 QL",
    "Device": "EXTEND_55_QL",
    "Model": "EXTEND 55 QL"
  },
  {
    "Retail Branding": "Azumi",
    "Marketing Name": "IKU A55",
    "Device": "Azumi_IKU_A55",
    "Model": "Azumi IKU A55"
  },
  {
    "Retail Branding": "Azumi",
    "Marketing Name": "IRO A4Q",
    "Device": "IRO_A4_Q",
    "Model": "Azumi_IRO_A4_Q"
  },
  {
    "Retail Branding": "Azumi",
    "Marketing Name": "IRO A4Q",
    "Device": "IRO_A4_Q_AF",
    "Model": "Azumi_IRO_A4_Q"
  },
  {
    "Retail Branding": "Azumi",
    "Marketing Name": "IRO A5 QL",
    "Device": "IRO_A5_QL",
    "Model": "Azumi_IRO_A5_QL"
  },
  {
    "Retail Branding": "Azumi",
    "Marketing Name": "IRO A5 QL",
    "Device": "IRO_A5_QL_OM",
    "Model": "Azumi_IRO_A5_QL"
  },
  {
    "Retail Branding": "Azumi",
    "Marketing Name": "IRO A5 QLT",
    "Device": "IRO_A5_QLT",
    "Model": "Azumi_IRO_A5_QLT"
  },
  {
    "Retail Branding": "Azumi",
    "Marketing Name": "IRO A55 Q",
    "Device": "IRO_A55_Q",
    "Model": "IRO A55 Q"
  },
  {
    "Retail Branding": "Azumi",
    "Marketing Name": "IRO A55 QL",
    "Device": "IRO_A55_QL",
    "Model": "Azumi_IRO_A55_QL"
  },
  {
    "Retail Branding": "Azumi",
    "Marketing Name": "IRO A5Q",
    "Device": "IRO_A5_Q",
    "Model": "Azumi_IRO_A5_Q"
  },
  {
    "Retail Branding": "Azumi",
    "Marketing Name": "IRO A5Q",
    "Device": "IRO_A5_Q_AF",
    "Model": "Azumi_IRO_A5_Q"
  },
  {
    "Retail Branding": "Azumi",
    "Marketing Name": "IRO A5QL",
    "Device": "IRO_A5QL_V2",
    "Model": "Azumi IRO A5QL V2"
  },
  {
    "Retail Branding": "Azumi",
    "Marketing Name": "IRO A5QL",
    "Device": "IRO_A5_QL_HD",
    "Model": "Azumi_IRO_A5_QL"
  },
  {
    "Retail Branding": "Azumi",
    "Marketing Name": "IRO_A4_Q_Pro",
    "Device": "IRO_A4_Q_PRO",
    "Model": "Azumi_IRO_A4_Q_PRO"
  },
  {
    "Retail Branding": "Azumi",
    "Marketing Name": "IRO_A55_Q_Pro",
    "Device": "IRO_A55_Q_Pro",
    "Model": "Azumi IRO A55 Q Pro"
  },
  {
    "Retail Branding": "Azumi",
    "Marketing Name": "IRO_A6_Q",
    "Device": "IRO_A6_Q",
    "Model": "IRO A6 Q"
  },
  {
    "Retail Branding": "Azumi",
    "Marketing Name": "K55QL_AC04",
    "Device": "Azumi_K55QL_AC04",
    "Model": "Azumi K55QL"
  },
  {
    "Retail Branding": "Azumi",
    "Marketing Name": "K55QL_AC12",
    "Device": "Azumi_K55QL_AC12",
    "Model": "K55QL"
  },
  {
    "Retail Branding": "Azumi",
    "Marketing Name": "K5QL",
    "Device": "Azumi_K5QL",
    "Model": "Azumi K5QL"
  },
  {
    "Retail Branding": "Azumi",
    "Marketing Name": "KINZO A55 OLi",
    "Device": "KINZO_A55_OLi",
    "Model": "Azumi_KINZO_A55_OLi"
  },
  {
    "Retail Branding": "Azumi",
    "Marketing Name": "KINZO A55QL",
    "Device": "KINZO_A55_OLi_CL",
    "Model": "Azumi_KINZO_A55_OLi"
  },
  {
    "Retail Branding": "Azumi",
    "Marketing Name": "KINZO ICHI A5 QL",
    "Device": "KINZO_ichi_A5_QL_NA",
    "Model": "KINZO_ichi_A5_QL"
  },
  {
    "Retail Branding": "Azumi",
    "Marketing Name": "KIREI A5Q PLUS",
    "Device": "Azumi_KIREI_A5Q_PLUS_AC06",
    "Model": "KIREI A5Q PLUS"
  },
  {
    "Retail Branding": "Azumi",
    "Marketing Name": "KIREI A5Q PLUS",
    "Device": "Azumi_KIREI_A5Q_PLUS_AC11",
    "Model": "KIREI A5Q PLUS"
  },
  {
    "Retail Branding": "Azumi",
    "Marketing Name": "M5",
    "Device": "Azumi_M5",
    "Model": "Azumi M5"
  },
  {
    "Retail Branding": "Azumi",
    "Marketing Name": "M5PLUS",
    "Device": "Azumi_M5PLUS",
    "Model": "M5+"
  },
  {
    "Retail Branding": "Azumi",
    "Marketing Name": "M5PLUS_AC24",
    "Device": "Azumi_M5PLUS_AC24",
    "Model": "M5+"
  },
  {
    "Retail Branding": "Azumi",
    "Marketing Name": "M5s",
    "Device": "Azumi_M5s",
    "Model": "M5s"
  },
  {
    "Retail Branding": "Azumi",
    "Marketing Name": "NA60_PRO",
    "Device": "Azumi_NA60_PRO",
    "Model": "Azumi_NA60_PRO"
  },
  {
    "Retail Branding": "Azumi",
    "Marketing Name": "NOBU A55",
    "Device": "NOBU_A55_AC01",
    "Model": "Azumi NOBU A55"
  },
  {
    "Retail Branding": "Azumi",
    "Marketing Name": "NOBU_A55_PRO",
    "Device": "NOBU_A55_PRO",
    "Model": "NOBU_A55_PRO"
  },
  {
    "Retail Branding": "Azumi",
    "Marketing Name": "Nobu A55",
    "Device": "NOBU_A55",
    "Model": "Azumi NOBU A55"
  },
  {
    "Retail Branding": "Azumi",
    "Marketing Name": "Speed 4",
    "Device": "Azumi_Speed_4",
    "Model": "Azumi Speed 4"
  },
  {
    "Retail Branding": "Azumi",
    "Marketing Name": "Speed 5",
    "Device": "Azumi_Speed_5B",
    "Model": "Azumi Speed 5"
  },
  {
    "Retail Branding": "Azumi",
    "Marketing Name": "Speed 55",
    "Device": "Speed_55",
    "Model": "Speed_55"
  },
  {
    "Retail Branding": "Azumi",
    "Marketing Name": "T7 3G",
    "Device": "T7_3G",
    "Model": "Azumi_T7_3G"
  },
  {
    "Retail Branding": "Azumi",
    "Marketing Name": "V4_AC04",
    "Device": "Azumi_V4_AC04",
    "Model": "Azumi V4"
  },
  {
    "Retail Branding": "Azumi",
    "Marketing Name": "V4_AC23",
    "Device": "Azumi_V4_AC23",
    "Model": "V4"
  },
  {
    "Retail Branding": "Azumi",
    "Marketing Name": "V4_AC25",
    "Device": "Azumi_V4_AC25",
    "Model": "V4"
  },
  {
    "Retail Branding": "Azumi",
    "Marketing Name": "V5",
    "Device": "Azumi_V5_AC04",
    "Model": "Azumi_V5"
  },
  {
    "Retail Branding": "Azumi",
    "Marketing Name": "V5",
    "Device": "Azumi_V5_AC15",
    "Model": "V5"
  },
  {
    "Retail Branding": "Azumi",
    "Marketing Name": "V5",
    "Device": "Azumi_V5_AC20",
    "Model": "Azumi_V5"
  },
  {
    "Retail Branding": "Azumi",
    "Marketing Name": "V5",
    "Device": "Azumi_V5_AC23B",
    "Model": "V5"
  },
  {
    "Retail Branding": "Azumi",
    "Marketing Name": "V5",
    "Device": "Azumi_V5_AC25S",
    "Model": "V5"
  },
  {
    "Retail Branding": "Azumi",
    "Marketing Name": "V5+",
    "Device": "AZUMI_V5PLUS_AC27",
    "Model": "V5+"
  },
  {
    "Retail Branding": "Azumi",
    "Marketing Name": "V51",
    "Device": "Azumi_V5_AC01",
    "Model": "Azumi_V51"
  },
  {
    "Retail Branding": "Azumi",
    "Marketing Name": "V52",
    "Device": "AZUMI_V52",
    "Model": "Azumi_V52"
  },
  {
    "Retail Branding": "Azumi",
    "Marketing Name": "V52B",
    "Device": "Azumi_V52B",
    "Model": "V52"
  },
  {
    "Retail Branding": "Azumi",
    "Marketing Name": "V54_AC24",
    "Device": "Azumi_V54_AC24",
    "Model": "V54"
  },
  {
    "Retail Branding": "Azumi",
    "Marketing Name": "V55",
    "Device": "Azumi_V55",
    "Model": "V55"
  },
  {
    "Retail Branding": "Azumi",
    "Marketing Name": "V55_AC04",
    "Device": "Azumi_V55_AC04",
    "Model": "V55"
  },
  {
    "Retail Branding": "Azumi",
    "Marketing Name": "V56",
    "Device": "AZUMI_V56",
    "Model": "Azumi_V56"
  },
  {
    "Retail Branding": "Azumi",
    "Marketing Name": "V56B",
    "Device": "Azumi_V56B",
    "Model": "V56"
  },
  {
    "Retail Branding": "Azumi",
    "Marketing Name": "V5PLUS_AC25",
    "Device": "Azumi_V5PLUS_AC25",
    "Model": "V5+"
  },
  {
    "Retail Branding": "Azumi",
    "Marketing Name": "V5_AC25",
    "Device": "Azumi_V5_AC25",
    "Model": "V5"
  },
  {
    "Retail Branding": "Azumi",
    "Marketing Name": "V5_AC25B",
    "Device": "Azumi_V5_AC25B",
    "Model": "V5"
  },
  {
    "Retail Branding": "Azumi",
    "Marketing Name": "V6",
    "Device": "Azumi_V6",
    "Model": "Azumi V6"
  },
  {
    "Retail Branding": "Azumi",
    "Marketing Name": "V60",
    "Device": "AZUMI_V60_AC04",
    "Model": "Azumi_V60"
  },
  {
    "Retail Branding": "Azumi",
    "Marketing Name": "V60",
    "Device": "Azumi_V60",
    "Model": "V60"
  },
  {
    "Retail Branding": "Azumi",
    "Marketing Name": "V61",
    "Device": "Azumi_V61",
    "Model": "Azumi_V61"
  },
  {
    "Retail Branding": "Azumi",
    "Marketing Name": "V66",
    "Device": "AZUMI_V66",
    "Model": "Azumi_V66"
  },
  {
    "Retail Branding": "BAIWOYER",
    "Marketing Name": "E10",
    "Device": "E10",
    "Model": "E10"
  },
  {
    "Retail Branding": "BAIWOYER",
    "Marketing Name": "F11Pro",
    "Device": "F11Pro",
    "Model": "F11Pro"
  },
  {
    "Retail Branding": "BAIWOYER",
    "Marketing Name": "F11plus",
    "Device": "F11plus",
    "Model": "F11"
  },
  {
    "Retail Branding": "BAKEN",
    "Marketing Name": "L10",
    "Device": "M10_A03_EEA",
    "Model": "L10"
  },
  {
    "Retail Branding": "BAKEN",
    "Marketing Name": "M10",
    "Device": "M10_A03",
    "Model": "M10"
  },
  {
    "Retail Branding": "BALMUDA",
    "Marketing Name": "BALMUDA Phone",
    "Device": "A101BM",
    "Model": "A101BM"
  },
  {
    "Retail Branding": "BALMUDA",
    "Marketing Name": "BALMUDA Phone",
    "Device": "X01A",
    "Model": "X01A"
  },
  {
    "Retail Branding": "BAMtelecoms",
    "Marketing Name": "N3",
    "Device": "N3",
    "Model": "N3"
  },
  {
    "Retail Branding": "BAMtelecoms",
    "Marketing Name": "T3",
    "Device": "T3",
    "Model": "T3"
  },
  {
    "Retail Branding": "BAROCOMPUTER",
    "Marketing Name": "EMC86HB_V",
    "Device": "EMC86HB_V",
    "Model": "EMC86HB_V"
  },
  {
    "Retail Branding": "BARTEC",
    "Marketing Name": "BARTEC SC9EX1 Smartscanner",
    "Device": "SC9EX1",
    "Model": "SC9EX1"
  },
  {
    "Retail Branding": "BARTEC",
    "Marketing Name": "BARTEC SP9EX1 Smartphone",
    "Device": "SP9EX1",
    "Model": "SP9EX1"
  },
  {
    "Retail Branding": "BARTEC",
    "Marketing Name": "Pixavi Phone",
    "Device": "PixaviPhone",
    "Model": "Pixavi Phone"
  },
  {
    "Retail Branding": "BARTEC",
    "Marketing Name": "Pixavi Thermal",
    "Device": "PixaviThermal",
    "Model": "Pixavi Thermal"
  },
  {
    "Retail Branding": "BASICS",
    "Marketing Name": "BT1025SS",
    "Device": "BT1025SS",
    "Model": "BT1025SS"
  },
  {
    "Retail Branding": "BASICS",
    "Marketing Name": "BT1124FW",
    "Device": "BT1124FW",
    "Model": "BT1124FW"
  },
  {
    "Retail Branding": "BASICS",
    "Marketing Name": "BT1226SS",
    "Device": "BT1226SS",
    "Model": "BT1226SS"
  },
  {
    "Retail Branding": "BATMAN",
    "Marketing Name": "TM-MID1065BT",
    "Device": "TM-MID1065BT",
    "Model": "TM-MID1065BT"
  },
  {
    "Retail Branding": "BAYKUS",
    "Marketing Name": "BKM10",
    "Device": "BKM10",
    "Model": "BKM10"
  },
  {
    "Retail Branding": "BDIC",
    "Marketing Name": "lgyuev-T11",
    "Device": "lgyuev-T11",
    "Model": "lgyuev-T11"
  },
  {
    "Retail Branding": "BDIC",
    "Marketing Name": "lgyuev-T11Pro",
    "Device": "lgyuev-T11Pro",
    "Model": "lgyuev-T11Pro"
  },
  {
    "Retail Branding": "BDQ",
    "Marketing Name": "Destiny",
    "Device": "Destiny",
    "Model": "Destiny"
  },
  {
    "Retail Branding": "BDQ",
    "Marketing Name": "Destiny-4G",
    "Device": "Destiny-4G",
    "Model": "Destiny-4G"
  },
  {
    "Retail Branding": "BDQ",
    "Marketing Name": "SMART_B19",
    "Device": "SMART_B19",
    "Model": "SMART_B19"
  },
  {
    "Retail Branding": "BDQ",
    "Marketing Name": "Smart_Camon",
    "Device": "Smart_Camon",
    "Model": "Smart_Camon"
  },
  {
    "Retail Branding": "BEC-KW",
    "Marketing Name": "Smart TV",
    "Device": "longshan",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "BEC-KW",
    "Marketing Name": "Smart TV",
    "Device": "redwood",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "BEISTA",
    "Marketing Name": "K105",
    "Device": "K105",
    "Model": "K105"
  },
  {
    "Retail Branding": "BEISTA",
    "Marketing Name": "K109",
    "Device": "K109",
    "Model": "K109"
  },
  {
    "Retail Branding": "BEISTA",
    "Marketing Name": "M80_EEA",
    "Device": "M80_EEA",
    "Model": "M80_EEA"
  },
  {
    "Retail Branding": "BEISTA",
    "Marketing Name": "T30",
    "Device": "T30-EEA",
    "Model": "T30-EEA"
  },
  {
    "Retail Branding": "BEISTA",
    "Marketing Name": "X101",
    "Device": "X101",
    "Model": "X101"
  },
  {
    "Retail Branding": "BEISTA",
    "Marketing Name": "X104",
    "Device": "X104",
    "Model": "X104"
  },
  {
    "Retail Branding": "BEISTA",
    "Marketing Name": "X104-EEA",
    "Device": "X104-EEA",
    "Model": "X104-EEA"
  },
  {
    "Retail Branding": "BEISTA",
    "Marketing Name": "X108",
    "Device": "X108",
    "Model": "X108"
  },
  {
    "Retail Branding": "BEISTA",
    "Marketing Name": "X80-EEA",
    "Device": "X80-EEA",
    "Model": "X80-EEA"
  },
  {
    "Retail Branding": "BENEWORLD",
    "Marketing Name": "BW768_EEA",
    "Device": "BW768",
    "Model": "BW768"
  },
  {
    "Retail Branding": "BERGSTROM",
    "Marketing Name": 666770,
    "Device": 666770,
    "Model": 666770
  },
  {
    "Retail Branding": "BERGSTROM",
    "Marketing Name": "H634_BLK",
    "Device": "H634_BLK",
    "Model": "H634 BLK"
  },
  {
    "Retail Branding": "BERGSTROM",
    "Marketing Name": "P187",
    "Device": "P187",
    "Model": "P187"
  },
  {
    "Retail Branding": "BESTTAB",
    "Marketing Name": "A10_EEA",
    "Device": "A10",
    "Model": "A10"
  },
  {
    "Retail Branding": "BESTTAB",
    "Marketing Name": "A10_NEU",
    "Device": "A10",
    "Model": "A10"
  },
  {
    "Retail Branding": "BESTTAB",
    "Marketing Name": "A20_EEA",
    "Device": "A20",
    "Model": "A20"
  },
  {
    "Retail Branding": "BESTTAB",
    "Marketing Name": "A20_NEU",
    "Device": "A20",
    "Model": "A20"
  },
  {
    "Retail Branding": "BEYODFU",
    "Marketing Name": "M103",
    "Device": "M103",
    "Model": "M103"
  },
  {
    "Retail Branding": "BEYODFU",
    "Marketing Name": "M148",
    "Device": "M148",
    "Model": "M148"
  },
  {
    "Retail Branding": "BEYODFU",
    "Marketing Name": "M193",
    "Device": "M193",
    "Model": "M193"
  },
  {
    "Retail Branding": "BEYODFU",
    "Marketing Name": "M326-EEA",
    "Device": "M326-EEA",
    "Model": "M326-EEA"
  },
  {
    "Retail Branding": "BEYODFU",
    "Marketing Name": "M518",
    "Device": "M518",
    "Model": "M518"
  },
  {
    "Retail Branding": "BEYODFU",
    "Marketing Name": "M901",
    "Device": "M901",
    "Model": "M901"
  },
  {
    "Retail Branding": "BGH S.A.",
    "Marketing Name": "BGH 2K Android TV",
    "Device": "lasalle",
    "Model": "BGH 2K Android TV"
  },
  {
    "Retail Branding": "BGH S.A.",
    "Marketing Name": "BGH 4K Android TV",
    "Device": "kenton",
    "Model": "BGH 4K Android TV"
  },
  {
    "Retail Branding": "BGH S.A.",
    "Marketing Name": "BGH 4K SMART TV",
    "Device": "eleonas",
    "Model": "BGH 4K SMART TV"
  },
  {
    "Retail Branding": "BGH S.A.",
    "Marketing Name": "BGH Joy 303",
    "Device": "BGH_Joy_303",
    "Model": "BGH Joy 303"
  },
  {
    "Retail Branding": "BGH S.A.",
    "Marketing Name": "BGH Smart TV",
    "Device": "sunnyvale",
    "Model": "BGH Smart TV"
  },
  {
    "Retail Branding": "BGH S.A.",
    "Marketing Name": "fushan_BGH",
    "Device": "hamamatsucho",
    "Model": "Smart TV"
  },
  {
    "Retail Branding": "BGH S.A.",
    "Marketing Name": "xiaoyushan-bgh",
    "Device": "xiaoyushan",
    "Model": "HiSmartTV A4"
  },
  {
    "Retail Branding": "BILIMLI",
    "Marketing Name": "BILIMLI2025",
    "Device": "BILIMLI2025",
    "Model": "BILIMLI2025"
  },
  {
    "Retail Branding": "BIOSfone",
    "Marketing Name": "T11",
    "Device": "T11",
    "Model": "T11"
  },
  {
    "Retail Branding": "BIT Mobile",
    "Marketing Name": "Phenix XT",
    "Device": "Phenix_XT",
    "Model": "Phenix XT"
  },
  {
    "Retail Branding": "BKAV",
    "Marketing Name": "B2017",
    "Device": "B2017",
    "Model": "B2017"
  },
  {
    "Retail Branding": "BKAV",
    "Marketing Name": "B2017",
    "Device": "B2017",
    "Model": "Bphone B2017"
  },
  {
    "Retail Branding": "BKAV",
    "Marketing Name": "Bphone",
    "Device": "Bphone",
    "Model": "Bphone B1111"
  },
  {
    "Retail Branding": "BKAV",
    "Marketing Name": "Bphone",
    "Device": "Bphone",
    "Model": "Bphone B1112"
  },
  {
    "Retail Branding": "BKAV",
    "Marketing Name": "Bphone",
    "Device": "Bphone",
    "Model": "Bphone B1114"
  },
  {
    "Retail Branding": "BKAV",
    "Marketing Name": "Bphone",
    "Device": "Bphone",
    "Model": "Bphone B1115"
  },
  {
    "Retail Branding": "BKAV",
    "Marketing Name": "Bphone",
    "Device": "Bphone",
    "Model": "Bphone B1116"
  },
  {
    "Retail Branding": "BKAV",
    "Marketing Name": "Bphone B86",
    "Device": "Bphone_B86",
    "Model": "Bphone B86"
  },
  {
    "Retail Branding": "BLACK+DECKER",
    "Marketing Name": "R10G",
    "Device": "R10G",
    "Model": "R10G"
  },
  {
    "Retail Branding": "BLACKLINE",
    "Marketing Name": "R10G",
    "Device": "R10G",
    "Model": "R10G"
  },
  {
    "Retail Branding": "BLACKLINE",
    "Marketing Name": "R3",
    "Device": "R3",
    "Model": "R3"
  },
  {
    "Retail Branding": "BLACKLINE",
    "Marketing Name": "R3_GTV",
    "Device": "R3_GTV",
    "Model": "R3G"
  },
  {
    "Retail Branding": "BLACKLINE",
    "Marketing Name": "R4",
    "Device": "R4",
    "Model": "R4"
  },
  {
    "Retail Branding": "BLACKLINE",
    "Marketing Name": "R4_GTV",
    "Device": "R4_GTV",
    "Model": "R4G"
  },
  {
    "Retail Branding": "BLECK",
    "Marketing Name": "BE dg",
    "Device": "BE_dg",
    "Model": "BE_dg"
  },
  {
    "Retail Branding": "BLECK",
    "Marketing Name": "BE fr",
    "Device": "BE_fr",
    "Model": "BE_fr"
  },
  {
    "Retail Branding": "BLECK",
    "Marketing Name": "BE_et",
    "Device": "BE_et",
    "Model": "BE_et"
  },
  {
    "Retail Branding": "BLECK",
    "Marketing Name": "BE_se",
    "Device": "BE_se",
    "Model": "BE_se"
  },
  {
    "Retail Branding": "BLECK",
    "Marketing Name": "ELEMENT",
    "Device": "ELEMENT",
    "Model": "ELEMENT"
  },
  {
    "Retail Branding": "BLECK",
    "Marketing Name": "O2",
    "Device": "BE_o2",
    "Model": "BE_o2"
  },
  {
    "Retail Branding": "BLESSX",
    "Marketing Name": "T4SMODELX",
    "Device": "T4SMODELX",
    "Model": "T4SMODELX"
  },
  {
    "Retail Branding": "BLOVEDREAM",
    "Marketing Name": "PDA",
    "Device": "PDA",
    "Model": "PDA"
  },
  {
    "Retail Branding": "BLOW",
    "Marketing Name": "BlackTAB7",
    "Device": "BlackTAB7",
    "Model": "BlackTAB7"
  },
  {
    "Retail Branding": "BLOW",
    "Marketing Name": "BlackTAB8_4G",
    "Device": "BlackTAB8_4G",
    "Model": "BlackTAB8_4G"
  },
  {
    "Retail Branding": "BLOW",
    "Marketing Name": "BlackTab7_3G_V2",
    "Device": "BlackTab7_3G_V2",
    "Model": "BlackTab7_3G_V2"
  },
  {
    "Retail Branding": "BLOW",
    "Marketing Name": "GPSTAB7_4G",
    "Device": "GPSTAB7_4G",
    "Model": "GPSTAB7 4G"
  },
  {
    "Retail Branding": "BLOW",
    "Marketing Name": "KidsTAB10_4G_EEA",
    "Device": "KidsTAB10_4G_EEA",
    "Model": "KidsTAB10_4G_EEA"
  },
  {
    "Retail Branding": "BLOW",
    "Marketing Name": "KidsTAB7",
    "Device": "KidsTAB7",
    "Model": "KidsTAB7"
  },
  {
    "Retail Branding": "BLOW",
    "Marketing Name": "KidsTAB7_EEA",
    "Device": "KidsTAB7",
    "Model": "KidsTAB7"
  },
  {
    "Retail Branding": "BLOW",
    "Marketing Name": "KidsTAB7_EEA",
    "Device": "KidsTAB7_EEA",
    "Model": "KidsTAB7_EEA"
  },
  {
    "Retail Branding": "BLOW",
    "Marketing Name": "KidsTAB7_V2_EEA",
    "Device": "KidsTAB7_V2_EEA",
    "Model": "KidsTAB7_V2"
  },
  {
    "Retail Branding": "BLOW",
    "Marketing Name": "KidsTAB7_V2_EEA",
    "Device": "KidsTAB7_V2_EEA",
    "Model": "KidsTAB7_V2_EEA"
  },
  {
    "Retail Branding": "BLOW",
    "Marketing Name": "LaserTAB10",
    "Device": "LaserTAB10",
    "Model": "LaserTAB10"
  },
  {
    "Retail Branding": "BLOW",
    "Marketing Name": "PlatinumTAB10",
    "Device": "PlatinumTAB10",
    "Model": "PlatinumTAB10"
  },
  {
    "Retail Branding": "BLOW",
    "Marketing Name": "PlatinumTAB10V11",
    "Device": "PlatinumTAB10V11",
    "Model": "PlatinumTAB10V11"
  },
  {
    "Retail Branding": "BLOW",
    "Marketing Name": "PlatinumTAB10V22",
    "Device": "PlatinumTAB10V22",
    "Model": "PlatinumTAB10V22"
  },
  {
    "Retail Branding": "BLOW",
    "Marketing Name": "PlatinumTAB10_4G_V1",
    "Device": "PlatinumTAB10_4G_V1",
    "Model": "PlatinumTAB10_4G_V1"
  },
  {
    "Retail Branding": "BLOW",
    "Marketing Name": "PlatinumTAB10_4G_V2",
    "Device": "PlatinumTAB10_4G_V2",
    "Model": "PlatinumTAB10_4G_V2"
  },
  {
    "Retail Branding": "BLOW",
    "Marketing Name": "PlatinumTAB10_4G_V3",
    "Device": "PlatinumTAB10_4G_V3",
    "Model": "PlatinumTAB10_4G_V3"
  },
  {
    "Retail Branding": "BLOW",
    "Marketing Name": "PlatinumTAB11_4G",
    "Device": "PlatinumTAB11_4G",
    "Model": "PlatinumTAB11_4G"
  },
  {
    "Retail Branding": "BLOW",
    "Marketing Name": "PlatinumTAB8_4G",
    "Device": "PlatinumTAB8_4G",
    "Model": "PlatinumTAB8_4G"
  },
  {
    "Retail Branding": "BLUE",
    "Marketing Name": "G6SG",
    "Device": "ikebukuro",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "BLUECRANE",
    "Marketing Name": "PP86M",
    "Device": "PP86M",
    "Model": "NOTE S8 4G"
  },
  {
    "Retail Branding": "BLUECRANE",
    "Marketing Name": "PP86M",
    "Device": "PP86M",
    "Model": "PP86M"
  },
  {
    "Retail Branding": "BLUEFOX",
    "Marketing Name": "BF001",
    "Device": "BLUEFOX",
    "Model": "NX1"
  },
  {
    "Retail Branding": "BLUEFOX",
    "Marketing Name": "BF001_EEA",
    "Device": "BLUEFOX",
    "Model": "NX1"
  },
  {
    "Retail Branding": "BLUEING",
    "Marketing Name": "M1867G",
    "Device": "M1867G",
    "Model": "M1867G"
  },
  {
    "Retail Branding": "BLUESTAR",
    "Marketing Name": "B850J",
    "Device": "B850J",
    "Model": "B850J"
  },
  {
    "Retail Branding": "BLUEWORLD",
    "Marketing Name": "TM12",
    "Device": "TM12",
    "Model": "TM12"
  },
  {
    "Retail Branding": "BMAX",
    "Marketing Name": "BMAX_I9",
    "Device": "BMAX_I9",
    "Model": "BMAX_I9"
  },
  {
    "Retail Branding": "BMAX",
    "Marketing Name": "I10",
    "Device": "I10",
    "Model": "I10"
  },
  {
    "Retail Branding": "BMAX",
    "Marketing Name": "I10Pro_LTE",
    "Device": "I10Pro_LTE",
    "Model": "I10Pro"
  },
  {
    "Retail Branding": "BMAX",
    "Marketing Name": "I10Pro_LTE_EEA",
    "Device": "I10Pro_LTE_EEA",
    "Model": "I10Pro"
  },
  {
    "Retail Branding": "BMAX",
    "Marketing Name": "I10_EEA",
    "Device": "I10_EEA",
    "Model": "I10_EEA"
  },
  {
    "Retail Branding": "BMAX",
    "Marketing Name": "I10_LTE",
    "Device": "I10_LTE",
    "Model": "I10_LTE"
  },
  {
    "Retail Branding": "BMAX",
    "Marketing Name": "I10_Plus",
    "Device": "I10_Plus",
    "Model": "I10_Plus"
  },
  {
    "Retail Branding": "BMAX",
    "Marketing Name": "I10_Plus",
    "Device": "I10_Plus_EEA",
    "Model": "I10_Plus_EEA"
  },
  {
    "Retail Branding": "BMAX",
    "Marketing Name": "I10_Plus_LTE",
    "Device": "I10_Plus_LTE",
    "Model": "I10_Plus"
  },
  {
    "Retail Branding": "BMAX",
    "Marketing Name": "I10_Plus_LTE_EEA",
    "Device": "I10_Plus_LTE_EEA",
    "Model": "I10_Plus"
  },
  {
    "Retail Branding": "BMAX",
    "Marketing Name": "I10_Plus_WLAN",
    "Device": "I10_Plus_WLAN",
    "Model": "I10_Plus"
  },
  {
    "Retail Branding": "BMAX",
    "Marketing Name": "I10_Plus_WLAN_EEA",
    "Device": "I10_Plus_WLAN_EEA",
    "Model": "I10_Plus"
  },
  {
    "Retail Branding": "BMAX",
    "Marketing Name": "I10_Pro_4G",
    "Device": "I10_Pro_4G",
    "Model": "I10_Pro_4G"
  },
  {
    "Retail Branding": "BMAX",
    "Marketing Name": "I10_Pro_EEA",
    "Device": "I10_Pro_EEA",
    "Model": "I10_Pro"
  },
  {
    "Retail Branding": "BMAX",
    "Marketing Name": "I10_Pro_LTE",
    "Device": "I10_Pro_LTE",
    "Model": "I10_Pro_LTE"
  },
  {
    "Retail Branding": "BMAX",
    "Marketing Name": "I10_Pro_LTE_EEA",
    "Device": "I10_Pro_LTE_EEA",
    "Model": "I10_Pro_LTE_EEA"
  },
  {
    "Retail Branding": "BMAX",
    "Marketing Name": "I10_Pro_ROW",
    "Device": "I10_Pro_ROW",
    "Model": "I10_Pro"
  },
  {
    "Retail Branding": "BMAX",
    "Marketing Name": "I10_S",
    "Device": "I10_S",
    "Model": "I10_S"
  },
  {
    "Retail Branding": "BMAX",
    "Marketing Name": "I10_S_Pro",
    "Device": "I10_S_Pro",
    "Model": "I10_S_Pro"
  },
  {
    "Retail Branding": "BMAX",
    "Marketing Name": "I11",
    "Device": "I11",
    "Model": "I11"
  },
  {
    "Retail Branding": "BMAX",
    "Marketing Name": "I11_EEA",
    "Device": "I11_EEA",
    "Model": "I11_EEA"
  },
  {
    "Retail Branding": "BMAX",
    "Marketing Name": "I11_LTE",
    "Device": "I11_LTE",
    "Model": "I11_LTE"
  },
  {
    "Retail Branding": "BMAX",
    "Marketing Name": "I11_LTE_EEA",
    "Device": "I11_LTE_EEA",
    "Model": "I11_LTE"
  },
  {
    "Retail Branding": "BMAX",
    "Marketing Name": "I11_Plus",
    "Device": "I11_Plus",
    "Model": "I11_Plus"
  },
  {
    "Retail Branding": "BMAX",
    "Marketing Name": "I11_Plus_EEA",
    "Device": "I11_Plus_EEA",
    "Model": "I11_Plus_EEA"
  },
  {
    "Retail Branding": "BMAX",
    "Marketing Name": "I11_Plus_LTE",
    "Device": "I11_Plus_LTE",
    "Model": "I11_Plus"
  },
  {
    "Retail Branding": "BMAX",
    "Marketing Name": "I11_Plus_LTE_EEA",
    "Device": "I11_Plus_LTE_EEA",
    "Model": "I11_Plus"
  },
  {
    "Retail Branding": "BMAX",
    "Marketing Name": "I11_Power",
    "Device": "I11_Power",
    "Model": "I11_Power"
  },
  {
    "Retail Branding": "BMAX",
    "Marketing Name": "I11_Power_LTE",
    "Device": "I11_Power_LTE",
    "Model": "I11_Power_LTE"
  },
  {
    "Retail Branding": "BMAX",
    "Marketing Name": "I11_Pro",
    "Device": "I11_Pro",
    "Model": "I11_Pro"
  },
  {
    "Retail Branding": "BMAX",
    "Marketing Name": "I11_S",
    "Device": "I11_S",
    "Model": "I11_S"
  },
  {
    "Retail Branding": "BMAX",
    "Marketing Name": "I11_S_EEA",
    "Device": "I11_S_EEA",
    "Model": "I11_S"
  },
  {
    "Retail Branding": "BMAX",
    "Marketing Name": "I12_A_Power",
    "Device": "I12_A_Power",
    "Model": "I12_A_Power"
  },
  {
    "Retail Branding": "BMAX",
    "Marketing Name": "I14",
    "Device": "I14",
    "Model": "I14"
  },
  {
    "Retail Branding": "BMAX",
    "Marketing Name": "I8",
    "Device": "I8",
    "Model": "I8"
  },
  {
    "Retail Branding": "BMAX",
    "Marketing Name": "I8_Plus",
    "Device": "I8_Plus",
    "Model": "I8_Plus"
  },
  {
    "Retail Branding": "BMAX",
    "Marketing Name": "I8_Plus",
    "Device": "I8_Plus_EEA",
    "Model": "I8_Plus"
  },
  {
    "Retail Branding": "BMAX",
    "Marketing Name": "I8_Plus_WLAN",
    "Device": "I8_Plus_WLAN",
    "Model": "I8_Plus"
  },
  {
    "Retail Branding": "BMAX",
    "Marketing Name": "I9_Plus",
    "Device": "I9_Plus_WIFI_EEA",
    "Model": "I9_Plus"
  },
  {
    "Retail Branding": "BMAX",
    "Marketing Name": "I9_Plus",
    "Device": "I9_Plus_WIFI_ROW",
    "Model": "I9_Plus"
  },
  {
    "Retail Branding": "BMAX",
    "Marketing Name": "I9_Plus_EEA",
    "Device": "I9_Plus_EEA",
    "Model": "I9_Plus_EEA"
  },
  {
    "Retail Branding": "BMAX",
    "Marketing Name": "I9_Plus_ROW",
    "Device": "I9_Plus_ROW",
    "Model": "I9_Plus_ROW"
  },
  {
    "Retail Branding": "BMAX",
    "Marketing Name": "I9_Plus_WIFIOnly",
    "Device": "I9_Plus_WIFIOnly",
    "Model": "I9_Plus"
  },
  {
    "Retail Branding": "BMAX",
    "Marketing Name": "I9_Plus_WLAN",
    "Device": "I9_Plus_WLAN",
    "Model": "I9_Plus"
  },
  {
    "Retail Branding": "BMAX",
    "Marketing Name": "I9_Plus_WLAN_EEA",
    "Device": "I9_Plus_WLAN_EEA",
    "Model": "I9_Plus"
  },
  {
    "Retail Branding": "BMAX",
    "Marketing Name": "I9_Plus_WireFree",
    "Device": "I9_Plus_WireFree",
    "Model": "I9_Plus_WireFree"
  },
  {
    "Retail Branding": "BMAX",
    "Marketing Name": "I9_Plus_Wlanonly",
    "Device": "I9_Plus_Wlanonly",
    "Model": "I9_Plus"
  },
  {
    "Retail Branding": "BMAX",
    "Marketing Name": "I9_Plus_Wlanonly_EEA",
    "Device": "I9_Plus_Wlanonly_EEA",
    "Model": "I9_Plus"
  },
  {
    "Retail Branding": "BMPRO",
    "Marketing Name": "BMPRO7DI",
    "Device": "BMPRO7DI",
    "Model": "BMPRO7DI"
  },
  {
    "Retail Branding": "BMSE",
    "Marketing Name": "A10_WIFI",
    "Device": "A10_WIFI",
    "Model": "A10"
  },
  {
    "Retail Branding": "BMSE",
    "Marketing Name": "A80_WIFI",
    "Device": "A80_WIFI",
    "Model": "A80"
  },
  {
    "Retail Branding": "BMXC",
    "Marketing Name": "BM108",
    "Device": "BM108",
    "Model": "BM108"
  },
  {
    "Retail Branding": "BMXC",
    "Marketing Name": "JR-M802",
    "Device": "JR-M802",
    "Model": "JR-M802"
  },
  {
    "Retail Branding": "BMXC",
    "Marketing Name": "K107",
    "Device": "K107",
    "Model": "K107"
  },
  {
    "Retail Branding": "BMXC",
    "Marketing Name": "K107_EEA",
    "Device": "K107-EEA",
    "Model": "K107-EEA"
  },
  {
    "Retail Branding": "BMXC",
    "Marketing Name": "M107",
    "Device": "M107",
    "Model": "M107"
  },
  {
    "Retail Branding": "BMXC",
    "Marketing Name": "M107",
    "Device": "M107-EEA",
    "Model": "M107-EEA"
  },
  {
    "Retail Branding": "BMXC",
    "Marketing Name": "M863",
    "Device": "M863",
    "Model": "M863"
  },
  {
    "Retail Branding": "BMXC",
    "Marketing Name": "M863-EEA",
    "Device": "M863-EEA",
    "Model": "M863-EEA"
  },
  {
    "Retail Branding": "BMXC",
    "Marketing Name": "N107",
    "Device": "N107",
    "Model": "N107"
  },
  {
    "Retail Branding": "BMXC",
    "Marketing Name": "N107_EEA",
    "Device": "N107-EEA",
    "Model": "N107-EEA"
  },
  {
    "Retail Branding": "BMXC",
    "Marketing Name": "ST-920",
    "Device": "ST-920",
    "Model": "ST-920"
  },
  {
    "Retail Branding": "BMXC",
    "Marketing Name": "XQ107",
    "Device": "XQ107",
    "Model": "XQ107"
  },
  {
    "Retail Branding": "BMXC",
    "Marketing Name": "XQ107-EEA",
    "Device": "XQ107-EEA",
    "Model": "XQ107-EEA"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "AX1010",
    "Device": "Bmobile_AX1010",
    "Model": "AX1010"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "AX1010",
    "Device": "Bmobile_AX1010",
    "Model": "Bmobile AX1010"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "AX1015",
    "Device": "Bmobile_AX1015",
    "Model": "AX1015"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "AX1015",
    "Device": "Bmobile_AX1015A",
    "Model": "AX1015"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "AX1016",
    "Device": "Bmobile_AX1016",
    "Model": "AX1016"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "AX1017",
    "Device": "Bmobile_AX1017_MV12",
    "Model": "AX1017"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "AX1017",
    "Device": "Bmobile_AX1017_TG05",
    "Model": "AX1017"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "AX1020",
    "Device": "Bmobile",
    "Model": "AX1020"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "AX1020",
    "Device": "Bmobile_AX1020",
    "Model": "AX1020"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "AX1030",
    "Device": "Bmobile_AX1030",
    "Model": "AX1030"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "AX1035",
    "Device": "Bmobile_AX1035",
    "Model": "AX1035"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "AX1040",
    "Device": "Bmobile_AX1040",
    "Model": "AX1040"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "AX1045E",
    "Device": "Bmobile_AX1045",
    "Model": "AX1045"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "AX1055",
    "Device": "Bmobile",
    "Model": "AX1055"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "AX1055",
    "Device": "Bmobile_AX1055",
    "Model": "AX1055"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "AX1060",
    "Device": "AX1060",
    "Model": "AX1060"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "AX1065",
    "Device": "Bmobile_AX1065",
    "Model": "AX1065"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "AX1065E",
    "Device": "Bmobile_AX1065E",
    "Model": "AX1065E"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "AX1070E",
    "Device": "BMOBILE_AX1070",
    "Model": "AX1070"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "AX1070E",
    "Device": "Bmobile_AX1070",
    "Model": "AX1070"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "AX1071",
    "Device": "Bmobile_AX1071",
    "Model": "AX1071"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "AX1072",
    "Device": "Bmobile_AX1072",
    "Model": "AX1072"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "AX1073",
    "Device": "Bmobile_AX1073",
    "Model": "AX1073"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "AX1073+",
    "Device": "AX1073PLUSMV18",
    "Model": "AX1073+"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "AX1073+",
    "Device": "Bmobile_AX1073PLUSW",
    "Model": "AX1073+"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "AX1073+",
    "Device": "Bmobile_AX1073P_MV11",
    "Model": "AX1073+"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "AX1073+",
    "Device": "Bmobile_AX1073Plus",
    "Model": "AX1073+"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "AX1073PLUSMV18",
    "Device": "Bmobile_AX1073PLUSMV18",
    "Model": "AX1073PLUSMV18"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "AX1074",
    "Device": "Bmobile_AX1074",
    "Model": "AX1074"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "AX1075",
    "Device": "Bmobile_AX1075",
    "Model": "AX1075"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "AX1076+",
    "Device": "Bmobile_AX1076P_MV03",
    "Model": "AX1076+"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "AX1076+",
    "Device": "Bmobile_AX1076P_MV05",
    "Model": "AX1076+"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "AX1076+",
    "Device": "Bmobile_AX1076P_MV12",
    "Model": "AX1076+"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "AX1077",
    "Device": "Bmobile_AX1077",
    "Model": "AX1077"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "AX1077+",
    "Device": "Bmobile_AX1077PLUS",
    "Model": "AX1077+"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "AX1077+",
    "Device": "Bmobile_AX1077_MAS",
    "Model": "AX1077+"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "AX1077+",
    "Device": "Bmobile_AX1077_MTG05",
    "Model": "AX1077+"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "AX1077+",
    "Device": "Bmobile_AX1077_MTG06",
    "Model": "AX1077+"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "AX1077+",
    "Device": "Bmobile_AX1077_MTG07",
    "Model": "AX1077+"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "AX1078",
    "Device": "Bmobile_AX1078_TG05",
    "Model": "AX1078"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "AX1078",
    "Device": "Bmobile_AX1078_TG07",
    "Model": "AX1078"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "AX1078",
    "Device": "Bmobile_AX1078_TG07B",
    "Model": "AX1078"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "AX1078_OM",
    "Device": "Bmobile_AX1078_OM",
    "Model": "AX1078"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "AX1078_TG06",
    "Device": "Bmobile_AX1078_TG06",
    "Model": "AX1078"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "AX1080",
    "Device": "Bmobile_AX1080",
    "Model": "AX1080"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "AX1082",
    "Device": "Bmobile_AX1082_MV07",
    "Model": "AX1082"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "AX1082",
    "Device": "Bmobile_AX1082_MV15",
    "Model": "AX1082"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "AX1082",
    "Device": "Bmobile_AX1082_TG",
    "Model": "AX1082"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "AX1082",
    "Device": "Bmobile_AX1082_TG07",
    "Model": "AX1082"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "AX1083",
    "Device": "Bmobile_AX1083",
    "Model": "AX1083"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "AX1085",
    "Device": "Bmobile_AX1085",
    "Model": "AX1085"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "AX1091",
    "Device": "Bmobile_AX1091",
    "Model": "AX1091"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "AX1091",
    "Device": "Bmobile_AX1091",
    "Model": "Bmobile_AX1091"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "AX1091",
    "Device": "Bmobile_AX1091A",
    "Model": "AX1091"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "AX1092",
    "Device": "Bmobile_AX1092W",
    "Model": "AX1092"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "AX1092",
    "Device": "Bmobile_AX1092_MV03",
    "Model": "AX1092"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "AX1093",
    "Device": "Bmobile_AX1093",
    "Model": "AX1093"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "AX1100",
    "Device": "Bmobile_AX1100",
    "Model": "AX1100"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "AX660",
    "Device": "Bmobile",
    "Model": "AX660"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "AX680+",
    "Device": "Bmobile_AX680_",
    "Model": "AX680+"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "AX681",
    "Device": "Bmobile_AX681",
    "Model": "AX681"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "AX681",
    "Device": "Bmobile_AX681A",
    "Model": "AX681"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "AX683",
    "Device": "Bmobile_AX683",
    "Model": "AX683"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "AX684",
    "Device": "Bmobile_AX684",
    "Model": "AX684"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "AX684A",
    "Device": "Bmobile_AX684A",
    "Model": "AX684"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "AX685",
    "Device": "Bmobile_AX685",
    "Model": "AX685"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "AX685",
    "Device": "Bmobile_AX685",
    "Model": "Bmobile_AX685"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "AX686",
    "Device": "Bmobile_AX686",
    "Model": "AX686"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "AX686A",
    "Device": "Bmobile_AX686A",
    "Model": "AX686A"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "AX687",
    "Device": "Bmobile_AX687",
    "Model": "AX687"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "AX687",
    "Device": "Bmobile_AX687_MV03",
    "Model": "AX687"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "AX688",
    "Device": "Bmobile_AX688",
    "Model": "AX688"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "AX688P",
    "Device": "Bmobile_AX688P",
    "Model": "Bmobile AX688+"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "AX700",
    "Device": "Bmobile",
    "Model": "AX7OO"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "AX715",
    "Device": "Bmobile_AX715",
    "Model": "AX715"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "AX751",
    "Device": "Bmobile_AX751",
    "Model": "AX751"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "AX754",
    "Device": "Bmobile_AX754",
    "Model": "AX754"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "AX754PLUS",
    "Device": "Bmobile_AX754PLUS",
    "Model": "AX754+"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "AX810",
    "Device": "Bmobile",
    "Model": "Bmobile_AX810"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "AX810",
    "Device": "Bmobile_AX810",
    "Model": "Bmobile_AX810"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "AX820",
    "Device": "Bmobile_AX820",
    "Model": "AX820"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "AX821",
    "Device": "Bmobile_AX821",
    "Model": "AX821"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "AX822",
    "Device": "Bmobile_AX822",
    "Model": "AX822"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "AX822",
    "Device": "Bmobile_AX822A",
    "Model": "AX822"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "AX823",
    "Device": "Bmobile_AX823",
    "Model": "AX823"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "AX823",
    "Device": "Bmobile_AX823a",
    "Model": "AX823"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "AX824",
    "Device": "Bmobile_AX824_MV03",
    "Model": "AX824"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "AX824+",
    "Device": "Bmobile_AX824PLUS_MV03",
    "Model": "AX824+"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "AX824A",
    "Device": "Bmobile_AX824A",
    "Model": "AX824A"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "AX824Plus",
    "Device": "Bmobile_AX824Plus_MV15",
    "Model": "AX824+"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "AX825",
    "Device": "Bmobile_AX825",
    "Model": "AX825"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "AX826",
    "Device": "Bmobile_AX826",
    "Model": "AX826"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "AX829",
    "Device": "Bmobile_AX829",
    "Model": "AX829"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "AX830",
    "Device": "Bmobile_AX830",
    "Model": "AX830"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "AX830",
    "Device": "Bmobile_AX830MV15",
    "Model": "AX830"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "AX905",
    "Device": "Bmobile_AX905",
    "Model": "AX905"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "AX920",
    "Device": "Bmobile_AX920",
    "Model": "AX920"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "AX921",
    "Device": "Bmobile_AX921",
    "Model": "AX921"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "AX921",
    "Device": "Bmobile_AX921",
    "Model": "Bmobile_AX921"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "AX922",
    "Device": "Bmobile_AX922",
    "Model": "AX922"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "AX925",
    "Device": "Bmobile_AX925",
    "Model": "AX925"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "AX926",
    "Device": "Bmobile_AX926",
    "Model": "AX926"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "AX927",
    "Device": "Bmobile_AX927",
    "Model": "Bmobile AX927"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "AX950",
    "Device": "Bmobile_AX950",
    "Model": "AX950"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "AX951",
    "Device": "Bmobile_AX951",
    "Model": "AX951"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "AX959",
    "Device": "Bmobile_AX959",
    "Model": "AX959"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "AX960",
    "Device": "Bmobile_AX960_MV15",
    "Model": "AX960"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "AX965",
    "Device": "Bmobile_AX965",
    "Model": "AX965"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "B50",
    "Device": "Bmobile_B50",
    "Model": "B50"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "B50 PRO",
    "Device": "Bmobile_B50Pro",
    "Model": "B50Pro"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "B50 PRO",
    "Device": "Bmobile_B50Pro_MV03",
    "Model": "B50Pro"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "B50ProSS",
    "Device": "Bmobile_B50ProSS",
    "Model": "B50Pro"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "B50ProSS_MV03",
    "Device": "Bmobile_B50ProSS",
    "Model": "B50Pro"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "B50_1",
    "Device": "Bmobile_B50_1",
    "Model": "B50"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "B55",
    "Device": "B55",
    "Model": "B55"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "B60Pro",
    "Device": "Bmobile_B60Pro_MV03SP",
    "Model": "B60Pro"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "B60Pro_DG",
    "Device": "Bmobile_B60Pro_DG",
    "Model": "B60Pro_DG"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "B60Pro_MV03",
    "Device": "B60Pro_MV03",
    "Model": "B60Pro_MV03"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "B61Pro_OM",
    "Device": "Bmobile_B61Pro",
    "Model": "Bmobile B61Pro"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "B63Pro",
    "Device": "Bmobile_B63Pro_MV03",
    "Model": "B63Pro"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "B70Pro",
    "Device": "Bmobile_B70Pro",
    "Model": "B70Pro"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "B70pro",
    "Device": "Bmobile_B70Pro_MV03",
    "Model": "B70Pro"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "BL40",
    "Device": "Bmobile_BL40_MV12",
    "Model": "BL40_MV12"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "BL50",
    "Device": "Bmobile_BL50",
    "Model": "BL50"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "BL50",
    "Device": "Bmobile_BL50",
    "Model": "BL52"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "BL50",
    "Device": "Bmobile_BL50_CL",
    "Model": "BL50_CL"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "BL50",
    "Device": "Bmobile_BL50_DG",
    "Model": "BL50_DG"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "BL50",
    "Device": "Bmobile_BL50_TG05",
    "Model": "BL50"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "BL50",
    "Device": "Bmobile_BL50_TG06",
    "Model": "BL50"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "BL50",
    "Device": "Bmobile_BL50_TG06",
    "Model": "BL52"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "BL50",
    "Device": "Bmobile_BL50_TG07",
    "Model": "BL50"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "BL50",
    "Device": "Bmobile_BL50_TG07",
    "Model": "BL51"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "BL50",
    "Device": "Bmobile_BL50_TG09",
    "Model": "BL50"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "BL50 PRO",
    "Device": "Bmobile_BL50P_TG06",
    "Model": "BL50P_TG06"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "BL50 Pro",
    "Device": "Bmobile_BL50PRO_TG06HS",
    "Model": "BL50PRO_TG06HS"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "BL50 Pro",
    "Device": "Bmobile_BL50PRO_TG07NP",
    "Model": "BL50PRO_TG07NP"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "BL50 Pro",
    "Device": "Bmobile_BL50P_TG05",
    "Model": "BL50P_TG05"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "BL50 Pro",
    "Device": "Bmobile_BL50P_TG07",
    "Model": "BL50P_TG07"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "BL50 Pro",
    "Device": "Bmobile_BL50P_TG09",
    "Model": "BL50P_TG09"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "BL51",
    "Device": "Bmobile_BL51_MV05",
    "Model": "BL51_MV05"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "BL51",
    "Device": "Bmobile_BL51_MV12",
    "Model": "BL51"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "BL51",
    "Device": "Bmobile_BL51_MV12",
    "Model": "BL51_MV12"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "BL52",
    "Device": "Bmobile_BL52",
    "Model": "BL52"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "BL52Pro",
    "Device": "Bmobile_BL52Pro",
    "Model": "BL52Pro"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "BL52_TG06",
    "Device": "Bmobile_BL52_TG06",
    "Model": "BL52"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "BL53",
    "Device": "Bmobile_BL53_TG05",
    "Model": "BL53_TG05"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "BL53",
    "Device": "Bmobile_BL53_TG06",
    "Model": "BL53_TG06"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "BL53",
    "Device": "Bmobile_BL53_TG07",
    "Model": "BL53_TG07"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "BL54Pro",
    "Device": "Bmobile_BL54Pro",
    "Model": "BL54Pro"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "BL54Pro_MV12",
    "Device": "Bmobile_BL54Pro",
    "Model": "BL54Pro"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "BL54_PRO_TG05",
    "Device": "Bmobile_BL54_PRO_TG05",
    "Model": "BL54_PRO"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "BL55",
    "Device": "Bmobile_BL55",
    "Model": "BMOBILE_BL55"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "BL55",
    "Device": "Bmobile_BL55_TG",
    "Model": "BL55_TG"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "BL55_PRO_MV12",
    "Device": "Bmobile_BL55_PRO_MV12",
    "Model": "BL55_PRO"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "BL55_TG06",
    "Device": "Bmobile_BL55_TG06",
    "Model": "BL55_TG06"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "BL60",
    "Device": "Bmobile_BL60",
    "Model": "BL60"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "BL60",
    "Device": "Bmobile_BL60_TG05B",
    "Model": "BL60_TG05B"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "BL60M_MV05",
    "Device": "Bmobile_BL60M_MV05",
    "Model": "BL60M_MV05"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "BL60_TG05",
    "Device": "Bmobile_BL60_TG05",
    "Model": "BL60_TG05"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "BL60_TG17",
    "Device": "Bmobile_BL60_TG17",
    "Model": "BL60_TG17"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "BL61",
    "Device": "Bmobile_BL61_MV05",
    "Model": "BL61"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "BL62",
    "Device": "Bmobile_BL62",
    "Model": "BL62"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "BL62",
    "Device": "Bmobile_BL62H",
    "Model": "BL62"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "BL62",
    "Device": "Bmobile_BL62_TG",
    "Model": "BL62_TG"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "BL62",
    "Device": "Bmobile_BL62i",
    "Model": "BL62"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "BL63",
    "Device": "Bmobile_BL63",
    "Model": "BL63"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "BL63",
    "Device": "Bmobile_BL63",
    "Model": "BL63_TG07"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "BL63Pro",
    "Device": "Bmobile_BL63Pro",
    "Model": "BL63Pro"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "BL65",
    "Device": "Bmobile_BL65_OM",
    "Model": "BL65_OM"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "BL65",
    "Device": "Bmobile_BL65_TG",
    "Model": "BL65_TG"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "BL65Plus_TG07",
    "Device": "Bmobile_BL65Plus_TG07",
    "Model": "BL65Plus"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "BL65Plus_TG07",
    "Device": "Bmobile_BL65Plus_TG07",
    "Model": "BL65Plus_TG07"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "BL70",
    "Device": "Bmobile_BL70",
    "Model": "BL70"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "BM65 Pro",
    "Device": "Bmobile_BM65Pro_TG05",
    "Model": "BM65Pro_TG05"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "BM65_PRO",
    "Device": "Bmobile_BM65_PRO",
    "Model": "BM65_PRO"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "Bella",
    "Device": "Bella",
    "Model": "Bella"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "Bmbile AX687",
    "Device": "Bmobile_AX687",
    "Model": "AX687"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "Bmobile AX1076",
    "Device": "Bmobile_AX1076",
    "Model": "AX1076"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "Bmobile AX1082",
    "Device": "Bmobile_AX1082",
    "Model": "AX1082"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "Bmobile AX683",
    "Device": "Bmobile_AX683",
    "Model": "AX683"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "Bmobile AX751",
    "Device": "Bmobile_AX751",
    "Model": "AX751"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "Bmobile AX753",
    "Device": "Bmobile_AX753",
    "Model": "Bmobile AX753"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "Bmobile AX960",
    "Device": "Bmobile_AX960",
    "Model": "AX960"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "Bmobile AX960",
    "Device": "Bmobile_AX960_MV03",
    "Model": "AX960"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "Bmobile_AX1077",
    "Device": "Bmobile_AX1077A",
    "Model": "AX1077"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "Bmobile_AX688",
    "Device": "Bmobile_AX688",
    "Model": "AX688"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "Bmobile_AX688",
    "Device": "Bmobile_AX688",
    "Model": "AX688+"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "Bmobile_AX751_PLUS",
    "Device": "Bmobile_AX751_PLUS",
    "Model": "AX751+"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "Bmobile_AX752",
    "Device": "Bmobile_AX752",
    "Model": "AX752"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "Bmobile_B60Pro",
    "Device": "Bmobile_B60Pro",
    "Model": "Bmobile_B60Pro"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "Bmobile_BM65Plus",
    "Device": "Bmobile_BM65Plus",
    "Model": "BM65Plus"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "Bmoblie AX683",
    "Device": "Bmobile_AX683_MV04",
    "Model": "AX683"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "COMET_TG06",
    "Device": "Bmobile_COMET_TG06",
    "Model": "COMET_TG06"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "Cosmo B6",
    "Device": "Bmobile_COSMO_B6",
    "Model": "COSMO_B6"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "Cosmo B6",
    "Device": "Bmobile_COSMO_B6_TG",
    "Model": "COSMO_B6_TG"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "FUN 4",
    "Device": "Bmobile_FUN_4_2018",
    "Model": "FUN 4 2018"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "NOVUS65",
    "Device": "Bmobile_NOVUS65_TG06",
    "Model": "NOVUS65_TG06"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "NOVUS65",
    "Device": "Bmobile_NOVUS65_TG07",
    "Model": "NOVUS65_TG07"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "NOVUS65",
    "Device": "Bmobile_Novus_65",
    "Model": "Novus_65"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "NOVUS65",
    "Device": "Bmobile_Novus_65_MV03",
    "Model": "Novus_65"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "Nobu A55 Pro",
    "Device": "Azumi_NA55_Pro",
    "Model": "NOBU A55 PRO"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "ORBIT_67",
    "Device": "Bmobile_ORBIT_67_TG06",
    "Model": "ORBIT_67_TG06"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "ORBIT_MAX",
    "Device": "Bmobile_ORBIT_MAX",
    "Model": "ORBIT_MAX"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "ORION_TG05",
    "Device": "Bmobile_ORION_TG05",
    "Model": "ORION_TG05"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "Speed 5",
    "Device": "Bmobile_SPEED5",
    "Model": "Speed 5"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "T70",
    "Device": "Bmobile_T70",
    "Model": "Bmobile_T70"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "ULTRA S",
    "Device": "Bmobile_ULTRA_S_MV03",
    "Model": "ULTRA_S"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "ULTRA S",
    "Device": "ULTRA_S",
    "Model": "ULTRA S"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "Ultra",
    "Device": "Bmobile_ULTRA",
    "Model": "ULTRA"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "Ultra",
    "Device": "Bmobile_ULTRA_TG07",
    "Model": "ULTRA"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "VENUS",
    "Device": "Bmobile_VENUS",
    "Model": "VENUS"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "VENUS_TG05",
    "Device": "Bmobile_VENUS_TG05",
    "Model": "VENUS_TG05"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "X10",
    "Device": "Bmobile_X10_MV03",
    "Model": "X10"
  },
  {
    "Retail Branding": "BMobile",
    "Marketing Name": "X11",
    "Device": "Bmobile_X11",
    "Model": "Bmobile X11"
  },
  {
    "Retail Branding": "BNCF",
    "Marketing Name": "BPad",
    "Device": "BPad",
    "Model": "BPad"
  },
  {
    "Retail Branding": "BNCF",
    "Marketing Name": "BPad_",
    "Device": "BPad_",
    "Model": "BPad_"
  },
  {
    "Retail Branding": "BNCF",
    "Marketing Name": "BPad_10_4G",
    "Device": "BPad_10_4G",
    "Model": "BPad_10_4G"
  },
  {
    "Retail Branding": "BNCF",
    "Marketing Name": "BPad_10_SE",
    "Device": "BPad_10_SE",
    "Model": "BPad_10_SE"
  },
  {
    "Retail Branding": "BNCF",
    "Marketing Name": "BPad_13",
    "Device": "BPad_13",
    "Model": "BPad 13"
  },
  {
    "Retail Branding": "BNCF",
    "Marketing Name": "BPad_GT",
    "Device": "BPad_GT",
    "Model": "BPad_GT"
  },
  {
    "Retail Branding": "BNCF",
    "Marketing Name": "BPad_Mini_Ultra",
    "Device": "BPad_Mini_Ultra",
    "Model": "BPad_Mini_Ultra"
  },
  {
    "Retail Branding": "BNCF",
    "Marketing Name": "BPad_T1",
    "Device": "BPad_T1",
    "Model": "BPad T1"
  },
  {
    "Retail Branding": "BNE(TW)",
    "Marketing Name": "4KS1",
    "Device": "GCU5AC0D",
    "Model": "4KS1"
  },
  {
    "Retail Branding": "BOBESPONJA",
    "Marketing Name": "BOBTAB",
    "Device": "BOBTAB",
    "Model": "BOBTAB"
  },
  {
    "Retail Branding": "BODYCRAFT",
    "Marketing Name": "M1_IC0_N702_BC",
    "Device": "CONNECT_22",
    "Model": "CONNECT_22"
  },
  {
    "Retail Branding": "BOLVA",
    "Marketing Name": "B_TAB1021",
    "Device": "B_TAB1021",
    "Model": "B_TAB1021"
  },
  {
    "Retail Branding": "BOREAL",
    "Marketing Name": "Android TV",
    "Device": "R1",
    "Model": "ATV R1"
  },
  {
    "Retail Branding": "BOREAL",
    "Marketing Name": "Android TV",
    "Device": "R2",
    "Model": "ATV R2"
  },
  {
    "Retail Branding": "BOTECH",
    "Marketing Name": "Android TV",
    "Device": "R1",
    "Model": "ATV R1"
  },
  {
    "Retail Branding": "BOTECH",
    "Marketing Name": "Android TV",
    "Device": "R2",
    "Model": "ATV R2"
  },
  {
    "Retail Branding": "BOTECH",
    "Marketing Name": "BOTECH",
    "Device": "elliniko",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "BOTECH",
    "Marketing Name": "BOTECH",
    "Device": "stanford",
    "Model": "2K SMART TV"
  },
  {
    "Retail Branding": "BOTECH",
    "Marketing Name": "BOTECH",
    "Device": "zhongshan",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "BOTECH",
    "Marketing Name": "WZONE",
    "Device": "HND",
    "Model": "WZONE"
  },
  {
    "Retail Branding": "BOTHO_University",
    "Marketing Name": "GLTAB101",
    "Device": "GLTAB101",
    "Model": "GLTAB101"
  },
  {
    "Retail Branding": "BOXLIGHT",
    "Marketing Name": "ProColor_P5",
    "Device": "rk3576_u",
    "Model": "Interactive_Intelligent_Panel"
  },
  {
    "Retail Branding": "BOXLIGHT",
    "Marketing Name": "ProColor_PcMod_i5_14_1",
    "Device": "oversea_v",
    "Model": "PC_MODULE"
  },
  {
    "Retail Branding": "BOXY",
    "Marketing Name": "BOXY",
    "Device": "YYC",
    "Model": "4K Android TV Box"
  },
  {
    "Retail Branding": "BOYO",
    "Marketing Name": "BYMP",
    "Device": "BYMP",
    "Model": "BOYO-MP"
  },
  {
    "Retail Branding": "BPL",
    "Marketing Name": "Android TV",
    "Device": "ikebukuro",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "BPL",
    "Marketing Name": "Android TV",
    "Device": "longshan",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "BPL",
    "Marketing Name": "Android TV",
    "Device": "samseong",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "BPL",
    "Marketing Name": "BPL FHD TV",
    "Device": "takao",
    "Model": "BPL FHD TV"
  },
  {
    "Retail Branding": "BPL",
    "Marketing Name": "BPL UHD TV",
    "Device": "OD0M_EA_T32",
    "Model": "BPL UHD TV"
  },
  {
    "Retail Branding": "BPL",
    "Marketing Name": "R4_GTV",
    "Device": "R4_GTV",
    "Model": "R4G"
  },
  {
    "Retail Branding": "BPL",
    "Marketing Name": "Smart TV",
    "Device": "alimos",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "BPL",
    "Marketing Name": "Smart TV",
    "Device": "dangni",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "BPL",
    "Marketing Name": "Smart TV",
    "Device": "osaka",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "BPL",
    "Marketing Name": "Smart TV",
    "Device": "redwood",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "BQru",
    "Marketing Name": 5060,
    "Device": "BQru-5060",
    "Model": "BQru-5060"
  },
  {
    "Retail Branding": "BQru",
    "Marketing Name": "5701L Slim",
    "Device": "BQru-5701L",
    "Model": "BQ-5701L"
  },
  {
    "Retail Branding": "BQru",
    "Marketing Name": "BQ 5503 NICE 2",
    "Device": "BQru_5503",
    "Model": "BQru-5503"
  },
  {
    "Retail Branding": "BQru",
    "Marketing Name": "BQ 6353L",
    "Device": "BQru-6353L",
    "Model": "BQ-6353L"
  },
  {
    "Retail Branding": "BQru",
    "Marketing Name": "BQ-1020L",
    "Device": "BQru-1020L",
    "Model": "BQ-1020L"
  },
  {
    "Retail Branding": "BQru",
    "Marketing Name": "BQ-1024L",
    "Device": "BQru-1024L",
    "Model": "BQ-1024L"
  },
  {
    "Retail Branding": "BQru",
    "Marketing Name": "BQ-1025L",
    "Device": "BQ-1025L",
    "Model": "BQ-1025L"
  },
  {
    "Retail Branding": "BQru",
    "Marketing Name": "BQ-1025L",
    "Device": "BQru-1025L",
    "Model": "BQ-1025L"
  },
  {
    "Retail Branding": "BQru",
    "Marketing Name": "BQ-1036L",
    "Device": "BQ_1036L",
    "Model": "BQ-1036L"
  },
  {
    "Retail Branding": "BQru",
    "Marketing Name": "BQ-1045G",
    "Device": "BQru-1045",
    "Model": "BQ-1045"
  },
  {
    "Retail Branding": "BQru",
    "Marketing Name": "BQ-1045G",
    "Device": "BQru-1045G_2019",
    "Model": "BQ-1045G"
  },
  {
    "Retail Branding": "BQru",
    "Marketing Name": "BQ-1056L",
    "Device": "BQru_1056L",
    "Model": "BQru-1056L"
  },
  {
    "Retail Branding": "BQru",
    "Marketing Name": "BQ-1057L",
    "Device": "BQru_1057L",
    "Model": "BQru-1057L"
  },
  {
    "Retail Branding": "BQru",
    "Marketing Name": "BQ-1081G",
    "Device": "BQru-1081G_2019",
    "Model": "BQ-1081G"
  },
  {
    "Retail Branding": "BQru",
    "Marketing Name": "BQ-1082G",
    "Device": "BQru-1082G_2019",
    "Model": "BQ-1082G"
  },
  {
    "Retail Branding": "BQru",
    "Marketing Name": "BQ-1084L",
    "Device": "BQru-1084L",
    "Model": "BQ-1084L"
  },
  {
    "Retail Branding": "BQru",
    "Marketing Name": "BQ-1085L",
    "Device": "BQru-1085L",
    "Model": "BQ-1085L"
  },
  {
    "Retail Branding": "BQru",
    "Marketing Name": "BQ-1085L",
    "Device": "BQru-1085L_2020",
    "Model": "BQ-1085L"
  },
  {
    "Retail Branding": "BQru",
    "Marketing Name": "BQ-4001G",
    "Device": "BQru-4001G",
    "Model": "BQ-4001G"
  },
  {
    "Retail Branding": "BQru",
    "Marketing Name": "BQ-4028UP!",
    "Device": "BQru-4028",
    "Model": "BQru-4028"
  },
  {
    "Retail Branding": "BQru",
    "Marketing Name": "BQ-4030G Nice Mini",
    "Device": "BQru-4030G",
    "Model": "BQ-4030G"
  },
  {
    "Retail Branding": "BQru",
    "Marketing Name": "BQ-4072 Strike Mini",
    "Device": "BQru_4072",
    "Model": "BQru-4072"
  },
  {
    "Retail Branding": "BQru",
    "Marketing Name": "BQ-4077",
    "Device": "BQru-4077",
    "Model": "BQ-4077"
  },
  {
    "Retail Branding": "BQru",
    "Marketing Name": "BQ-4500L",
    "Device": "BQru-4500",
    "Model": "BQru-4500"
  },
  {
    "Retail Branding": "BQru",
    "Marketing Name": "BQ-4501G",
    "Device": "BQru-4501G",
    "Model": "BQ-4501G"
  },
  {
    "Retail Branding": "BQru",
    "Marketing Name": "BQ-4585 Fox View",
    "Device": "BQru-4585",
    "Model": "BQ-4585"
  },
  {
    "Retail Branding": "BQru",
    "Marketing Name": "BQ-5000G",
    "Device": "BQru-5000G",
    "Model": "BQ-5000G"
  },
  {
    "Retail Branding": "BQru",
    "Marketing Name": "BQ-5000L",
    "Device": "BQru-5000",
    "Model": "BQru-5000"
  },
  {
    "Retail Branding": "BQru",
    "Marketing Name": "BQ-5001L Contact",
    "Device": "BQru-5001L",
    "Model": "BQ-5001L"
  },
  {
    "Retail Branding": "BQru",
    "Marketing Name": "BQ-5002G",
    "Device": "BQru-5002G",
    "Model": "BQ-5002G"
  },
  {
    "Retail Branding": "BQru",
    "Marketing Name": "BQ-5003L Shark Pro",
    "Device": "BQru_5003L",
    "Model": "BQ-5003L"
  },
  {
    "Retail Branding": "BQru",
    "Marketing Name": "BQ-5004G",
    "Device": "BQru-5004G",
    "Model": "BQ-5004G"
  },
  {
    "Retail Branding": "BQru",
    "Marketing Name": "BQ-5005L INTENSE",
    "Device": "BQru_5005L",
    "Model": "BQ-5005L"
  },
  {
    "Retail Branding": "BQru",
    "Marketing Name": "BQ-5007L IRON",
    "Device": "BQru-5007L",
    "Model": "BQ-5007L"
  },
  {
    "Retail Branding": "BQru",
    "Marketing Name": "BQ-5008L Brave",
    "Device": "BQru-5008L",
    "Model": "BQ-5008L"
  },
  {
    "Retail Branding": "BQru",
    "Marketing Name": "BQ-5009L",
    "Device": "BQru_5009L",
    "Model": "BQ-5009L"
  },
  {
    "Retail Branding": "BQru",
    "Marketing Name": "BQ-5010G SPOT",
    "Device": "BQru-5010G",
    "Model": "BQ-5010G"
  },
  {
    "Retail Branding": "BQru",
    "Marketing Name": "BQ-5011G FOX VIEW",
    "Device": "BQru-5011G",
    "Model": "BQ-5011G"
  },
  {
    "Retail Branding": "BQru",
    "Marketing Name": "BQ-5012L",
    "Device": "BQru_5012L",
    "Model": "BQ-5012L"
  },
  {
    "Retail Branding": "BQru",
    "Marketing Name": "BQ-5015L FIRST",
    "Device": "BQru-5015L",
    "Model": "BQ-5015L"
  },
  {
    "Retail Branding": "BQru",
    "Marketing Name": "BQ-5016G",
    "Device": "BQru-5016G",
    "Model": "BQ-5016G"
  },
  {
    "Retail Branding": "BQru",
    "Marketing Name": "BQ-5031G",
    "Device": "BQru-5031G",
    "Model": "BQ-5031G"
  },
  {
    "Retail Branding": "BQru",
    "Marketing Name": "BQ-5033 Shark",
    "Device": "BQru_5033",
    "Model": "BQru-5033"
  },
  {
    "Retail Branding": "BQru",
    "Marketing Name": "BQ-5035 Velvet",
    "Device": "BQru-5035",
    "Model": "BQru-5035"
  },
  {
    "Retail Branding": "BQru",
    "Marketing Name": "BQ-5044 Strike LTE",
    "Device": "BQru-5044",
    "Model": "BQru-5044"
  },
  {
    "Retail Branding": "BQru",
    "Marketing Name": "BQ-5045L",
    "Device": "BQru-5045L",
    "Model": "BQ-5045L"
  },
  {
    "Retail Branding": "BQru",
    "Marketing Name": "BQ-5046L",
    "Device": "BQ-5046L",
    "Model": "BQ-5046L"
  },
  {
    "Retail Branding": "BQru",
    "Marketing Name": "BQ-5047L",
    "Device": "BQru-5047L",
    "Model": "BQ-5047L"
  },
  {
    "Retail Branding": "BQru",
    "Marketing Name": "BQ-5056 Fresh",
    "Device": "BQru-5056",
    "Model": "BQ-5056"
  },
  {
    "Retail Branding": "BQru",
    "Marketing Name": "BQ-5057 Strike 2",
    "Device": "BQru_5057",
    "Model": "BQru-5057"
  },
  {
    "Retail Branding": "BQru",
    "Marketing Name": "BQ-5058 Strike Power Easy",
    "Device": "BQru-5058",
    "Model": "BQru_BQru-5058"
  },
  {
    "Retail Branding": "BQru",
    "Marketing Name": "BQ-5059 Strike Power",
    "Device": "BQru_5059",
    "Model": "BQru-5059"
  },
  {
    "Retail Branding": "BQru",
    "Marketing Name": "BQ-5060L",
    "Device": "BQru-5060L",
    "Model": "BQ-5060L"
  },
  {
    "Retail Branding": "BQru",
    "Marketing Name": "BQ-5060L",
    "Device": "BQru-5060L_9832E",
    "Model": "BQ-5060L"
  },
  {
    "Retail Branding": "BQru",
    "Marketing Name": "BQ-5201",
    "Device": "BQru-5201",
    "Model": "BQ-5201"
  },
  {
    "Retail Branding": "BQru",
    "Marketing Name": "BQ-5201",
    "Device": "BQru-5201",
    "Model": "BQru-5201"
  },
  {
    "Retail Branding": "BQru",
    "Marketing Name": "BQ-5202",
    "Device": "BQru-5202",
    "Model": "BQru-5202"
  },
  {
    "Retail Branding": "BQru",
    "Marketing Name": "BQ-5203 Shark",
    "Device": "BQru-5203",
    "Model": "BQru-5203"
  },
  {
    "Retail Branding": "BQru",
    "Marketing Name": "BQ-5204 Strike Selfie",
    "Device": "BQru-5204",
    "Model": "BQru-5204"
  },
  {
    "Retail Branding": "BQru",
    "Marketing Name": "BQ-5206L Balance",
    "Device": "BQru-5206L",
    "Model": "BQ-5206L"
  },
  {
    "Retail Branding": "BQru",
    "Marketing Name": "BQ-5209L",
    "Device": "BQru-5209L",
    "Model": "BQ-5209L"
  },
  {
    "Retail Branding": "BQru",
    "Marketing Name": "BQ-5211",
    "Device": "BQru-5211",
    "Model": "BQ-5211"
  },
  {
    "Retail Branding": "BQru",
    "Marketing Name": "BQ-5300G",
    "Device": "BQru-5300G",
    "Model": "BQ-5300G"
  },
  {
    "Retail Branding": "BQru",
    "Marketing Name": "BQ-5301",
    "Device": "BQru-5301",
    "Model": "BQ-5301"
  },
  {
    "Retail Branding": "BQru",
    "Marketing Name": "BQ-5302G",
    "Device": "BQru-5302G",
    "Model": "BQ-5302G"
  },
  {
    "Retail Branding": "BQru",
    "Marketing Name": "BQ-5340 Choice",
    "Device": "BQru-5340",
    "Model": "BQ-5340"
  },
  {
    "Retail Branding": "BQru",
    "Marketing Name": "BQ-5500L Advance",
    "Device": "BQru-5500L",
    "Model": "BQ-5500L"
  },
  {
    "Retail Branding": "BQru",
    "Marketing Name": "BQ-5504 Strike Selfie Max",
    "Device": "BQru_5504",
    "Model": "BQru-5504"
  },
  {
    "Retail Branding": "BQru",
    "Marketing Name": "BQ-5507L IRON MAX",
    "Device": "BQru-5507L",
    "Model": "BQ-5507L"
  },
  {
    "Retail Branding": "BQru",
    "Marketing Name": "BQ-5508L",
    "Device": "BQru-5508L",
    "Model": "BQ-5508L"
  },
  {
    "Retail Branding": "BQru",
    "Marketing Name": "BQ-5510 Strike Power Max 4G",
    "Device": "BQru_5510",
    "Model": "BQru-5510"
  },
  {
    "Retail Branding": "BQru",
    "Marketing Name": "BQ-5511L",
    "Device": "BQru_5511L",
    "Model": "BQ-5511L"
  },
  {
    "Retail Branding": "BQru",
    "Marketing Name": "BQ-5512L STRIKE FORWARD",
    "Device": "BQru-5512L",
    "Model": "BQ-5512L"
  },
  {
    "Retail Branding": "BQru",
    "Marketing Name": "BQ-5517L TWIN PRO",
    "Device": "BQru-5517L",
    "Model": "BQ-5517L"
  },
  {
    "Retail Branding": "BQru",
    "Marketing Name": "BQ-5518G",
    "Device": "BQru-5518G",
    "Model": "BQ-5518G"
  },
  {
    "Retail Branding": "BQru",
    "Marketing Name": "BQ-5519G",
    "Device": "BQru-5519G",
    "Model": "BQ-5519G"
  },
  {
    "Retail Branding": "BQru",
    "Marketing Name": "BQ-5519L Tele2",
    "Device": "BQru-5519L",
    "Model": "BQ-5519L"
  },
  {
    "Retail Branding": "BQru",
    "Marketing Name": "BQ-5520L Silk",
    "Device": "BQru-5520L",
    "Model": "BQ-5520L"
  },
  {
    "Retail Branding": "BQru",
    "Marketing Name": "BQ-5521 STRIKE POWER MAX",
    "Device": "BQru-5521",
    "Model": "BQru-5521"
  },
  {
    "Retail Branding": "BQru",
    "Marketing Name": "BQ-5522 Next",
    "Device": "BQru-5522",
    "Model": "BQ-5522"
  },
  {
    "Retail Branding": "BQru",
    "Marketing Name": "BQ-5528L",
    "Device": "BQru-5528L",
    "Model": "BQ-5528L"
  },
  {
    "Retail Branding": "BQru",
    "Marketing Name": "BQ-5530L",
    "Device": "BQru-5530L",
    "Model": "BQ-5530L"
  },
  {
    "Retail Branding": "BQru",
    "Marketing Name": "BQ-5533G",
    "Device": "BQru-5533G",
    "Model": "BQ-5533G"
  },
  {
    "Retail Branding": "BQru",
    "Marketing Name": "BQ-5535L",
    "Device": "BQru-5535L",
    "Model": "BQ-5535L"
  },
  {
    "Retail Branding": "BQru",
    "Marketing Name": "BQ-5540L",
    "Device": "BQru-5540L",
    "Model": "BQ-5540L"
  },
  {
    "Retail Branding": "BQru",
    "Marketing Name": "BQ-5541L",
    "Device": "BQru-5541L",
    "Model": "BQ-5541L"
  },
  {
    "Retail Branding": "BQru",
    "Marketing Name": "BQ-5560L",
    "Device": "BQru-5560L",
    "Model": "BQ-5560L"
  },
  {
    "Retail Branding": "BQru",
    "Marketing Name": "BQ-5590 Spring",
    "Device": "BQru_5590",
    "Model": "BQru_5590"
  },
  {
    "Retail Branding": "BQru",
    "Marketing Name": "BQ-5591 Jeans",
    "Device": "BQru-5591",
    "Model": "BQ-5591"
  },
  {
    "Retail Branding": "BQru",
    "Marketing Name": "BQ-5594 Strike Power Max",
    "Device": "BQru_5594",
    "Model": "BQ-5594"
  },
  {
    "Retail Branding": "BQru",
    "Marketing Name": "BQ-5700L Space X",
    "Device": "BQru-5700L",
    "Model": "BQ-5700L"
  },
  {
    "Retail Branding": "BQru",
    "Marketing Name": "BQ-5702",
    "Device": "BQru_5702",
    "Model": "BQ-5702"
  },
  {
    "Retail Branding": "BQru",
    "Marketing Name": "BQ-5707G Next Music",
    "Device": "BQru-5707G",
    "Model": "BQ-5707G"
  },
  {
    "Retail Branding": "BQru",
    "Marketing Name": "BQ-5730L",
    "Device": "BQru-5730L",
    "Model": "BQ-5730L"
  },
  {
    "Retail Branding": "BQru",
    "Marketing Name": "BQ-5731L Magic S",
    "Device": "BQru-5731L",
    "Model": "BQ-5731L"
  },
  {
    "Retail Branding": "BQru",
    "Marketing Name": "BQ-5732L",
    "Device": "BQru-5732L",
    "Model": "BQ-5732L"
  },
  {
    "Retail Branding": "BQru",
    "Marketing Name": "BQ-5740G",
    "Device": "BQru-5740G",
    "Model": "BQ-5740G"
  },
  {
    "Retail Branding": "BQru",
    "Marketing Name": "BQ-5740G_7731",
    "Device": "BQru-5740G_7731",
    "Model": "BQ-5740G"
  },
  {
    "Retail Branding": "BQru",
    "Marketing Name": "BQ-5745L Clever",
    "Device": "BQru-5745L",
    "Model": "BQ-5745L"
  },
  {
    "Retail Branding": "BQru",
    "Marketing Name": "BQ-5765L",
    "Device": "BQru-5765L",
    "Model": "BQ-5765L"
  },
  {
    "Retail Branding": "BQru",
    "Marketing Name": "BQ-6000L Aurora",
    "Device": "BQru-6000L",
    "Model": "BQ-6000L"
  },
  {
    "Retail Branding": "BQru",
    "Marketing Name": "BQ-6001 L",
    "Device": "BQru-6001L",
    "Model": "BQ-6001L"
  },
  {
    "Retail Branding": "BQru",
    "Marketing Name": "BQ-6010G",
    "Device": "BQru_6010G",
    "Model": "BQ-6010G"
  },
  {
    "Retail Branding": "BQru",
    "Marketing Name": "BQ-6015L Universe",
    "Device": "BQru-6015L",
    "Model": "BQ-6015L"
  },
  {
    "Retail Branding": "BQru",
    "Marketing Name": "BQ-6030G",
    "Device": "BQru-6030G",
    "Model": "BQ-6030G"
  },
  {
    "Retail Branding": "BQru",
    "Marketing Name": "BQ-6030G_7731",
    "Device": "BQru-6030G_7731",
    "Model": "BQ-6030G"
  },
  {
    "Retail Branding": "BQru",
    "Marketing Name": "BQ-6035L",
    "Device": "BQru-6035L",
    "Model": "BQ-6035L"
  },
  {
    "Retail Branding": "BQru",
    "Marketing Name": "BQ-6040L",
    "Device": "BQru-6040L",
    "Model": "BQ-6040L"
  },
  {
    "Retail Branding": "BQru",
    "Marketing Name": "BQ-6042",
    "Device": "BQru-6042L",
    "Model": "BQ-6042L"
  },
  {
    "Retail Branding": "BQru",
    "Marketing Name": "BQ-6045L Nice",
    "Device": "BQru-6045L",
    "Model": "BQ-6045L"
  },
  {
    "Retail Branding": "BQru",
    "Marketing Name": "BQ-6051G",
    "Device": "BQ-6051G",
    "Model": "BQ-6051G"
  },
  {
    "Retail Branding": "BQru",
    "Marketing Name": "BQ-6065L",
    "Device": "BQru-6065L",
    "Model": "BQ-6065L"
  },
  {
    "Retail Branding": "BQru",
    "Marketing Name": "BQ-6200L Aurora",
    "Device": "BQru-6200L",
    "Model": "BQ-6200L"
  },
  {
    "Retail Branding": "BQru",
    "Marketing Name": "BQ-6424L",
    "Device": "BQru-6424L",
    "Model": "BQ-6424L"
  },
  {
    "Retail Branding": "BQru",
    "Marketing Name": "BQ-6630L",
    "Device": "BQru-6630L",
    "Model": "BQ-6630L"
  },
  {
    "Retail Branding": "BQru",
    "Marketing Name": "BQ-6645L Element",
    "Device": "BQru-6645L",
    "Model": "BQ-6645L"
  },
  {
    "Retail Branding": "BQru",
    "Marketing Name": "BQ-6761",
    "Device": "BQ6761",
    "Model": "BQ-6761"
  },
  {
    "Retail Branding": "BQru",
    "Marketing Name": "BQ-6861L",
    "Device": "BQ6861L",
    "Model": "BQ-6861L"
  },
  {
    "Retail Branding": "BQru",
    "Marketing Name": "BQ-6868L",
    "Device": "BQru-6868L",
    "Model": "BQru-6868L"
  },
  {
    "Retail Branding": "BQru",
    "Marketing Name": "BQ-7000G",
    "Device": "BQru-7000G",
    "Model": "BQ-7000G"
  },
  {
    "Retail Branding": "BQru",
    "Marketing Name": "BQ-7000G",
    "Device": "BQru-7000G_2020",
    "Model": "BQ-7000G"
  },
  {
    "Retail Branding": "BQru",
    "Marketing Name": "BQ-7022G",
    "Device": "BQru-7022",
    "Model": "BQ-7022"
  },
  {
    "Retail Branding": "BQru",
    "Marketing Name": "BQ-7036L",
    "Device": "BQru-7036L",
    "Model": "BQ-7036L"
  },
  {
    "Retail Branding": "BQru",
    "Marketing Name": "BQ-7038G",
    "Device": "BQru-7038G",
    "Model": "BQ-7038G"
  },
  {
    "Retail Branding": "BQru",
    "Marketing Name": "BQ-7040G",
    "Device": "BQru-7040G",
    "Model": "BQ-7040G"
  },
  {
    "Retail Branding": "BQru",
    "Marketing Name": "BQ-7040G",
    "Device": "BQru-7040G_2020",
    "Model": "BQ-7040G"
  },
  {
    "Retail Branding": "BQru",
    "Marketing Name": "BQ-7055L",
    "Device": "BQ-7055L",
    "Model": "BQ-7055L"
  },
  {
    "Retail Branding": "BQru",
    "Marketing Name": "BQ-7081G",
    "Device": "BQru-7081",
    "Model": "BQru-7081"
  },
  {
    "Retail Branding": "BQru",
    "Marketing Name": "BQ-7082G",
    "Device": "BQru-7082G_2019",
    "Model": "BQ-7082G"
  },
  {
    "Retail Branding": "BQru",
    "Marketing Name": "BQ-7082G",
    "Device": "BQru-7082G_2020",
    "Model": "BQ-7082G"
  },
  {
    "Retail Branding": "BQru",
    "Marketing Name": "BQ-7083G_Plus",
    "Device": "BQru-7083G_Plus",
    "Model": "BQ-7083G"
  },
  {
    "Retail Branding": "BQru",
    "Marketing Name": "BQ-7084G",
    "Device": "BQru-7084G",
    "Model": "BQ-7084G"
  },
  {
    "Retail Branding": "BQru",
    "Marketing Name": "BQ-7098G",
    "Device": "BQru-7098G",
    "Model": "BQ-7098G"
  },
  {
    "Retail Branding": "BQru",
    "Marketing Name": "BQ-7098G",
    "Device": "BQru-7098G_2020",
    "Model": "BQ-7098G"
  },
  {
    "Retail Branding": "BQru",
    "Marketing Name": "BQ-8041L",
    "Device": "BQru-8041L",
    "Model": "BQ-8041L"
  },
  {
    "Retail Branding": "BQru",
    "Marketing Name": "BQ-8067L",
    "Device": "BQru-8067L",
    "Model": "BQ-8067L"
  },
  {
    "Retail Branding": "BQru",
    "Marketing Name": "BQ-8068L",
    "Device": "BQru-8068L",
    "Model": "BQ-8068L"
  },
  {
    "Retail Branding": "BQru",
    "Marketing Name": "BQ-8077L",
    "Device": "BQru-8077L",
    "Model": "BQ-8077L"
  },
  {
    "Retail Branding": "BQru",
    "Marketing Name": "BQ-8088L",
    "Device": "BQ_8088L",
    "Model": "BQ-8088L"
  },
  {
    "Retail Branding": "BQru",
    "Marketing Name": "BQ-9055L",
    "Device": "BQru-9055L",
    "Model": "BQ-9055L"
  },
  {
    "Retail Branding": "BQru",
    "Marketing Name": "BQru-1022L",
    "Device": "BQru-1022L",
    "Model": "BQ-1022L"
  },
  {
    "Retail Branding": "BQru",
    "Marketing Name": "BQru-1045G_A11",
    "Device": "BQru-1045G_A11",
    "Model": "BQ-1045G"
  },
  {
    "Retail Branding": "BQru",
    "Marketing Name": "BQru-1077L",
    "Device": "BQru-1077L",
    "Model": "BQ-1077L"
  },
  {
    "Retail Branding": "BQru",
    "Marketing Name": "BQru-1077L_2019",
    "Device": "BQru-1077L_2019",
    "Model": "BQ-1077L"
  },
  {
    "Retail Branding": "BQru",
    "Marketing Name": "BQru-1081G",
    "Device": "BQru-1081G",
    "Model": "BQru-1081G"
  },
  {
    "Retail Branding": "BQru",
    "Marketing Name": "BQru-1082G",
    "Device": "BQru-1082G",
    "Model": "BQ-1082G"
  },
  {
    "Retail Branding": "BQru",
    "Marketing Name": "BQru-1082G_2020",
    "Device": "BQru-1082G_2020",
    "Model": "BQ-1082G"
  },
  {
    "Retail Branding": "BQru",
    "Marketing Name": "BQru-1083G",
    "Device": "BQru-1083G",
    "Model": "BQ-1083G"
  },
  {
    "Retail Branding": "BQru",
    "Marketing Name": "BQru-1083G_2019",
    "Device": "BQru-1083G_2019",
    "Model": "BQ-1083G"
  },
  {
    "Retail Branding": "BQru",
    "Marketing Name": "BQru-1083G_2020",
    "Device": "BQru-1083G_2020",
    "Model": "BQ-1083G"
  },
  {
    "Retail Branding": "BQru",
    "Marketing Name": "BQru-4526",
    "Device": "BQru-4526",
    "Model": "BQru-4526"
  },
  {
    "Retail Branding": "BQru",
    "Marketing Name": "BQru-5022",
    "Device": "BQru",
    "Model": "BQru-5022"
  },
  {
    "Retail Branding": "BQru",
    "Marketing Name": "BQru-5031G",
    "Device": "BQru-5031G",
    "Model": "BQ-5031G"
  },
  {
    "Retail Branding": "BQru",
    "Marketing Name": "BQru-5514G",
    "Device": "BQru-5514G",
    "Model": "BQ-5514G"
  },
  {
    "Retail Branding": "BQru",
    "Marketing Name": "BQru-5514L",
    "Device": "BQru-5514L",
    "Model": "BQ-5514L"
  },
  {
    "Retail Branding": "BQru",
    "Marketing Name": "BQru-5521L",
    "Device": "BQru_5521L",
    "Model": "BQ-5521L"
  },
  {
    "Retail Branding": "BQru",
    "Marketing Name": "BQru-5533G",
    "Device": "BQru-5533G",
    "Model": "BQ-5533G"
  },
  {
    "Retail Branding": "BQru",
    "Marketing Name": "BQru-5565L",
    "Device": "BQru-5565L",
    "Model": "BQ-5565L"
  },
  {
    "Retail Branding": "BQru",
    "Marketing Name": "BQru-6022GA",
    "Device": "BQru-6022G",
    "Model": "BQ-6022G"
  },
  {
    "Retail Branding": "BQru",
    "Marketing Name": "BQru-6061L",
    "Device": "BQru-6061L",
    "Model": "BQ-6061L"
  },
  {
    "Retail Branding": "BQru",
    "Marketing Name": "BQru-6631G",
    "Device": "BQru-6631G",
    "Model": "BQ-6631G"
  },
  {
    "Retail Branding": "BQru",
    "Marketing Name": "BQru-6631G_A11",
    "Device": "BQru-6631G_A11",
    "Model": "BQru-6631G_A11"
  },
  {
    "Retail Branding": "BQru",
    "Marketing Name": "BQru-7082",
    "Device": "BQru-7082",
    "Model": "BQru-7082"
  },
  {
    "Retail Branding": "BQru",
    "Marketing Name": "BQru-7083",
    "Device": "BQru-7083",
    "Model": "BQru-7083"
  },
  {
    "Retail Branding": "BQru",
    "Marketing Name": "BQru-8068L_A11",
    "Device": "BQru-8068L_A11",
    "Model": "BQ-8068L"
  },
  {
    "Retail Branding": "BQru",
    "Marketing Name": "BQru_6022G",
    "Device": "BQru_6022G",
    "Model": "BQ-6022G"
  },
  {
    "Retail Branding": "BQru",
    "Marketing Name": "BQru_6430L",
    "Device": "BQru_6430L",
    "Model": "BQ-6430L"
  },
  {
    "Retail Branding": "BQru",
    "Marketing Name": "Bqru-5037",
    "Device": "BQru-5037",
    "Model": "BQru-5037"
  },
  {
    "Retail Branding": "BQru",
    "Marketing Name": "CRYSTAL",
    "Device": "BQru-5054",
    "Model": "BQru-5054"
  },
  {
    "Retail Branding": "BQru",
    "Marketing Name": "FOX  POWER",
    "Device": "BQru-4583",
    "Model": "BQru-4583"
  },
  {
    "Retail Branding": "BQru",
    "Marketing Name": "FOX POWER",
    "Device": "BQru-4583",
    "Model": "BQru-4583"
  },
  {
    "Retail Branding": "BRANDO",
    "Marketing Name": "Smart TV",
    "Device": "redwood",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "BRAVA",
    "Marketing Name": "DU 400",
    "Device": "DU_400",
    "Model": "DU_400"
  },
  {
    "Retail Branding": "BRAVA",
    "Marketing Name": "DU-500",
    "Device": "DU-500",
    "Model": "DU-500"
  },
  {
    "Retail Branding": "BRAVA",
    "Marketing Name": "DU-600",
    "Device": "DU_600",
    "Model": "DU-600"
  },
  {
    "Retail Branding": "BRAVE",
    "Marketing Name": "BT7X1",
    "Device": "BT7X1",
    "Model": "BT7X1"
  },
  {
    "Retail Branding": "BRAVE",
    "Marketing Name": "BT8X1",
    "Device": "BT8X1",
    "Model": "BT8X1"
  },
  {
    "Retail Branding": "BRAVE",
    "Marketing Name": "BTSL1",
    "Device": "BTSL1",
    "Model": "BTSL1"
  },
  {
    "Retail Branding": "BRAVE",
    "Marketing Name": "BTXS1",
    "Device": "BTXS1",
    "Model": "BTXS1"
  },
  {
    "Retail Branding": "BRAVE",
    "Marketing Name": "BTXS1_1",
    "Device": "BTXS1_1",
    "Model": "BTXS1_1"
  },
  {
    "Retail Branding": "BRAVE",
    "Marketing Name": "BraveArk",
    "Device": "BraveArk",
    "Model": "Brave Ark"
  },
  {
    "Retail Branding": "BRAVE",
    "Marketing Name": "EX10SL4",
    "Device": "EXCEED",
    "Model": "EX10SL4"
  },
  {
    "Retail Branding": "BRAVE",
    "Marketing Name": "T2Max",
    "Device": "T2Max",
    "Model": "T2Max"
  },
  {
    "Retail Branding": "BRAVE",
    "Marketing Name": "T2Pro",
    "Device": "T2Pro",
    "Model": "T2Pro"
  },
  {
    "Retail Branding": "BRAVE",
    "Marketing Name": "T2lite",
    "Device": "T2lite",
    "Model": "T2lite"
  },
  {
    "Retail Branding": "BRIGMTON",
    "Marketing Name": "BTPC-1023OC4G_EEA",
    "Device": "BTPC-1023OC4G",
    "Model": "BTPC-1023OC4G"
  },
  {
    "Retail Branding": "BRIGMTON",
    "Marketing Name": "BTPC-1024QC",
    "Device": "BTPC-1024QC",
    "Model": "BTPC-1024QC"
  },
  {
    "Retail Branding": "BRIGMTON",
    "Marketing Name": "BTPC-1025OC",
    "Device": "BTPC-1025OC",
    "Model": "BTPC-1025OC"
  },
  {
    "Retail Branding": "BRIGMTON",
    "Marketing Name": "BTPC-1027QC3G",
    "Device": "BTPC-1027QC3G",
    "Model": "BTPC-1027QC3G"
  },
  {
    "Retail Branding": "BRIGMTON",
    "Marketing Name": "Spain",
    "Device": "BTPC-801QC",
    "Model": "BTPC-801QC"
  },
  {
    "Retail Branding": "BROJ",
    "Marketing Name": "AZ101FB",
    "Device": "AZ101FB",
    "Model": "AZ101FB"
  },
  {
    "Retail Branding": "BRUHM",
    "Marketing Name": "BTF-43SG",
    "Device": "ikebukuro",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "BRUHM",
    "Marketing Name": "BTF-75TG",
    "Device": "samseong",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "BTC Mobile",
    "Marketing Name": "S5548",
    "Device": "S5548",
    "Model": "S5548"
  },
  {
    "Retail Branding": "BTC Mobile",
    "Marketing Name": "S8",
    "Device": "S8",
    "Model": "S8"
  },
  {
    "Retail Branding": "BTC Mobile",
    "Marketing Name": "Touch",
    "Device": "Touch",
    "Model": "Touch"
  },
  {
    "Retail Branding": "BTG(RU)",
    "Marketing Name": "BTG-PH-001",
    "Device": "BTG_X1",
    "Model": "BTG Phone X1"
  },
  {
    "Retail Branding": "BTOUCH",
    "Marketing Name": "HUB 2",
    "Device": "LKT_HUB",
    "Model": "LKT_HUB"
  },
  {
    "Retail Branding": "BUFF",
    "Marketing Name": "X9 pro",
    "Device": "X-9_LTEVII_PRO",
    "Model": "X9 pro"
  },
  {
    "Retail Branding": "BULSATCOM",
    "Marketing Name": "UPD-BJ00R",
    "Device": "UPD-BJ00R",
    "Model": "UPD-BJ00R"
  },
  {
    "Retail Branding": "BULSATCOM",
    "Marketing Name": "b-box",
    "Device": "HP44H",
    "Model": "b-box"
  },
  {
    "Retail Branding": "BVS (AR)",
    "Marketing Name": "BVS  4K 0TT 01",
    "Device": "SFO",
    "Model": "BVS 4K OTT 01"
  },
  {
    "Retail Branding": "BWJBSW",
    "Marketing Name": "KT802_EEA",
    "Device": "KT802_EEA",
    "Model": "KT802_EEA"
  },
  {
    "Retail Branding": "BWJBSW",
    "Marketing Name": "KT802_US",
    "Device": "KT802_US",
    "Model": "KT802_US"
  },
  {
    "Retail Branding": "BWJBSW",
    "Marketing Name": "QZ1095W",
    "Device": "QZ1095W",
    "Model": "QZ1095W"
  },
  {
    "Retail Branding": "BWJBSW",
    "Marketing Name": "QZ1095W_EEA",
    "Device": "QZ1095W_EEA",
    "Model": "QZ1095W_EEA"
  },
  {
    "Retail Branding": "BXLIYER",
    "Marketing Name": "BX_D04",
    "Device": "Tablet_player",
    "Model": "BX_D04"
  },
  {
    "Retail Branding": "BYD",
    "Marketing Name": "BYD",
    "Device": "BYD100F",
    "Model": "BYD100F"
  },
  {
    "Retail Branding": "BYD",
    "Marketing Name": "DynaVox T10",
    "Device": "T10",
    "Model": "T10"
  },
  {
    "Retail Branding": "BYD",
    "Marketing Name": "FarEastone Smart 502",
    "Device": "Smart502",
    "Model": "Smart 502"
  },
  {
    "Retail Branding": "BYD",
    "Marketing Name": "INHON G3",
    "Device": "G3",
    "Model": "G3"
  },
  {
    "Retail Branding": "BYD",
    "Marketing Name": "K-Touch E815",
    "Device": "E815",
    "Model": "E815"
  },
  {
    "Retail Branding": "BYD",
    "Marketing Name": "M601",
    "Device": "M601",
    "Model": "M601"
  },
  {
    "Retail Branding": "BYD",
    "Marketing Name": "Moii E996+",
    "Device": "E996plus",
    "Model": "moii E996+"
  },
  {
    "Retail Branding": "BYD",
    "Marketing Name": "PT452E",
    "Device": "PT452E",
    "Model": "Digma Linx 4.5 PT452E"
  },
  {
    "Retail Branding": "BYD",
    "Marketing Name": "Prestigio PAP5430",
    "Device": "PAP5430",
    "Model": "PAP5430"
  },
  {
    "Retail Branding": "BYD",
    "Marketing Name": "SI4301",
    "Device": "SI4301",
    "Model": "SI4301"
  },
  {
    "Retail Branding": "BYD",
    "Marketing Name": "SOLO S450",
    "Device": "S450",
    "Model": "S450"
  },
  {
    "Retail Branding": "BYD",
    "Marketing Name": "SP355AWG",
    "Device": "msm7627a_sku3",
    "Model": "SP355AWG"
  },
  {
    "Retail Branding": "BYD",
    "Marketing Name": "Smart 401",
    "Device": "tianyu72_wet_jb3",
    "Model": "Smart 401"
  },
  {
    "Retail Branding": "BYD",
    "Marketing Name": "Smart 402",
    "Device": "hawaii_garnet_c_w68tk",
    "Model": "Smart402"
  },
  {
    "Retail Branding": "BYD",
    "Marketing Name": "Solo S350",
    "Device": "S350",
    "Model": "S350"
  },
  {
    "Retail Branding": "BYD",
    "Marketing Name": "WISKY W032I",
    "Device": "W032I",
    "Model": "W032I"
  },
  {
    "Retail Branding": "BYD",
    "Marketing Name": "X910",
    "Device": "X910",
    "Model": "XOLO X910"
  },
  {
    "Retail Branding": "BYD",
    "Marketing Name": "Zippers",
    "Device": "Zippers",
    "Model": "Vexia Zippers"
  },
  {
    "Retail Branding": "BYJUS",
    "Marketing Name": "ITM03081",
    "Device": "BYJUS",
    "Model": "ITM03081"
  },
  {
    "Retail Branding": "BYJUS",
    "Marketing Name": "LRN10",
    "Device": "LRN10",
    "Model": "LRN10"
  },
  {
    "Retail Branding": "BYJUS",
    "Marketing Name": "LRNS10GEW0",
    "Device": "LRNS10WIFI",
    "Model": "LRNS10GEW0"
  },
  {
    "Retail Branding": "BYJUS",
    "Marketing Name": "LRNS10GIL0",
    "Device": "LRNS10GIL0",
    "Model": "LRNS10GIL0"
  },
  {
    "Retail Branding": "BYJUS",
    "Marketing Name": "LRNS10GNW0",
    "Device": "LRNS10WIFI",
    "Model": "LRNS10GNW0"
  },
  {
    "Retail Branding": "BYJUS",
    "Marketing Name": "LRNS10REW0",
    "Device": "LRNS10WIFI",
    "Model": "LRNS10REW0"
  },
  {
    "Retail Branding": "BYJUS",
    "Marketing Name": "LRNS10RIL0",
    "Device": "LRNS10RIL0",
    "Model": "LRNS10RIL0"
  },
  {
    "Retail Branding": "BYJUS",
    "Marketing Name": "LRNS10RNW0",
    "Device": "LRNS10WIFI",
    "Model": "LRNS10RNW0"
  },
  {
    "Retail Branding": "BYJUS",
    "Marketing Name": "LRNS10WEW0",
    "Device": "LRNS10WIFI",
    "Model": "LRNS10WEW0"
  },
  {
    "Retail Branding": "BYJUS",
    "Marketing Name": "LRNS10WIL0",
    "Device": "LRNS10WIL0",
    "Model": "LRNS10WIL0"
  },
  {
    "Retail Branding": "BYJUS",
    "Marketing Name": "LRNS10WNW0",
    "Device": "LRNS10WIFI",
    "Model": "LRNS10WNW0"
  },
  {
    "Retail Branding": "BYYBUO",
    "Marketing Name": "104S",
    "Device": "104S",
    "Model": "104S"
  },
  {
    "Retail Branding": "BYYBUO",
    "Marketing Name": "A10_EU",
    "Device": "A10_EU",
    "Model": "A10_EU"
  },
  {
    "Retail Branding": "BYYBUO",
    "Marketing Name": "A10_L",
    "Device": "A10_L",
    "Model": "A10_L"
  },
  {
    "Retail Branding": "BYYBUO",
    "Marketing Name": "A10_M_UK",
    "Device": "A10_M_UK",
    "Model": "A10_M_UK"
  },
  {
    "Retail Branding": "BYYBUO",
    "Marketing Name": "A10_M_US",
    "Device": "A10_M_US",
    "Model": "A10_M_US"
  },
  {
    "Retail Branding": "BYYBUO",
    "Marketing Name": "BYYBUO_SmartPad_A10",
    "Device": "BYYBUO_SmartPad_A10",
    "Model": "BYYBUO_SmartPad_A10"
  },
  {
    "Retail Branding": "BYYBUO",
    "Marketing Name": "BYYBUO_SmartPad_T10",
    "Device": "BYYBUO_SmartPad_T10",
    "Model": "BYYBUO_SmartPad_T10"
  },
  {
    "Retail Branding": "BYYBUO",
    "Marketing Name": "E220_M_US",
    "Device": "E220_M_US",
    "Model": "E220_M_US"
  },
  {
    "Retail Branding": "BYYBUO",
    "Marketing Name": "SmartPad_A10_EU",
    "Device": "SmartPad_A10_EU",
    "Model": "SmartPad_A10_EU"
  },
  {
    "Retail Branding": "BYYBUO",
    "Marketing Name": "SmartPad_A10_L",
    "Device": "SmartPad_A10_L",
    "Model": "SmartPad_A10_L"
  },
  {
    "Retail Branding": "BYYBUO",
    "Marketing Name": "SmartPad_A70W",
    "Device": "SmartPad_A70W",
    "Model": "SmartPad_A70W"
  },
  {
    "Retail Branding": "BYYBUO",
    "Marketing Name": "SmartPad_A70W_EU",
    "Device": "SmartPad_A70W_EU",
    "Model": "SmartPad_A70W_EU"
  },
  {
    "Retail Branding": "BYYBUO",
    "Marketing Name": "SmartPad_K7",
    "Device": "SmartPad_K7",
    "Model": "SmartPad_K7"
  },
  {
    "Retail Branding": "BYYBUO",
    "Marketing Name": "SmartPad_K7_EU",
    "Device": "SmartPad_K7_EU",
    "Model": "SmartPad_K7_EU"
  },
  {
    "Retail Branding": "BYYBUO",
    "Marketing Name": "SmartPad_T10_EU",
    "Device": "SmartPad_T10_EU",
    "Model": "SmartPad_T10_EU"
  },
  {
    "Retail Branding": "BYYBUO",
    "Marketing Name": "SmartPad_T20",
    "Device": "SmartPad_T20",
    "Model": "SmartPad_T20"
  },
  {
    "Retail Branding": "BYYBUO",
    "Marketing Name": "SmartPad_T20_EEA",
    "Device": "SmartPad_T20_EEA",
    "Model": "SmartPad_T20"
  },
  {
    "Retail Branding": "BYYBUO",
    "Marketing Name": "TAG-TAB-Executive",
    "Device": "TAG-TAB-Executive",
    "Model": "TAB-Executive"
  },
  {
    "Retail Branding": "BYYBUO",
    "Marketing Name": "TAG-TAB-Executive",
    "Device": "TAG-TAB-Executive",
    "Model": "TAG-Executive"
  },
  {
    "Retail Branding": "BYYBUO",
    "Marketing Name": "TAG-TAB-LU",
    "Device": "TAG-TAB-LU",
    "Model": "TAG-TAB-LU"
  },
  {
    "Retail Branding": "Babal",
    "Marketing Name": 1008,
    "Device": "Babal_1008",
    "Model": 1008
  },
  {
    "Retail Branding": "Bang & Olufsen",
    "Marketing Name": "BeoVision",
    "Device": "bno_MT5593Uplus_EU",
    "Model": "QM153E"
  },
  {
    "Retail Branding": "Bangho",
    "Marketing Name": "Bangho_AERO7",
    "Device": "Bangho_AERO7",
    "Model": "Bangho_AERO7"
  },
  {
    "Retail Branding": "Barel",
    "Marketing Name": "Base_7_2_Quad",
    "Device": "Base_7_2_Quad",
    "Model": "Cavion Base 7.2 Quad"
  },
  {
    "Retail Branding": "Barel",
    "Marketing Name": "Cavion Solid 4.5",
    "Device": "Cavion_Solid_4_5",
    "Model": "Cavion_Solid_4_5"
  },
  {
    "Retail Branding": "Barel",
    "Marketing Name": "WP-N1",
    "Device": "WP1-N",
    "Model": "WP1-N"
  },
  {
    "Retail Branding": "Barnes and Noble",
    "Marketing Name": "BNTV460",
    "Device": "st18c7bnn",
    "Model": "BNTV460"
  },
  {
    "Retail Branding": "Barnes and Noble",
    "Marketing Name": "BNTV650",
    "Device": "st18c10bnn",
    "Model": "BNTV650"
  },
  {
    "Retail Branding": "Barnes and Noble",
    "Marketing Name": "HD",
    "Device": "hummingbird",
    "Model": "BNTV400"
  },
  {
    "Retail Branding": "Barnes and Noble",
    "Marketing Name": "HD+",
    "Device": "ovation",
    "Model": "BNTV600"
  },
  {
    "Retail Branding": "Barnes and Noble",
    "Marketing Name": "NOOK® HD",
    "Device": "hummingbird",
    "Model": "BNTV400"
  },
  {
    "Retail Branding": "Barnes and Noble",
    "Marketing Name": "NOOK® HD+",
    "Device": "ovation",
    "Model": "BNTV600"
  },
  {
    "Retail Branding": "Barnes and Noble",
    "Marketing Name": "Nook Tablet 7”",
    "Device": "st16c7bnn",
    "Model": "BNTV450"
  },
  {
    "Retail Branding": "Battcell",
    "Marketing Name": "M7042F",
    "Device": "M7042F",
    "Model": "M7042F"
  },
  {
    "Retail Branding": "Bauf",
    "Marketing Name": "BAUF",
    "Device": "stanford",
    "Model": "SMART TV"
  },
  {
    "Retail Branding": "Bauf",
    "Marketing Name": "BAUF",
    "Device": "zhongshan",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "Bauhn",
    "Marketing Name": "4K Smart TV",
    "Device": "gangbyeon",
    "Model": "4K AI Smart TV"
  },
  {
    "Retail Branding": "Bauhn",
    "Marketing Name": "ATAB10-1224",
    "Device": "ATAB10-1224",
    "Model": "ATAB10-1224"
  },
  {
    "Retail Branding": "Bauhn",
    "Marketing Name": "ATAB7-0125",
    "Device": "ATAB7-0125",
    "Model": "AIBTAB7-1125"
  },
  {
    "Retail Branding": "Bauhn",
    "Marketing Name": "ATAB7-0125",
    "Device": "ATAB7-0125",
    "Model": "ATAB7-0125"
  },
  {
    "Retail Branding": "Bauhn",
    "Marketing Name": "Australia",
    "Device": "nippori",
    "Model": "Bauhn Android TV 2K"
  },
  {
    "Retail Branding": "Bauhn",
    "Marketing Name": "BAUHN",
    "Device": "bangbae",
    "Model": "BAUHN 4K Android TV"
  },
  {
    "Retail Branding": "Bauhn",
    "Marketing Name": "BAUHN",
    "Device": "shilin",
    "Model": "BAUHN4KAndroidTV"
  },
  {
    "Retail Branding": "Bauhn",
    "Marketing Name": "Bauhn",
    "Device": "komagome",
    "Model": "BAUHN 2K Android TV"
  },
  {
    "Retail Branding": "Bauhn",
    "Marketing Name": "Bauhn android TV",
    "Device": "hanyang",
    "Model": "Tempo Android TV"
  },
  {
    "Retail Branding": "Bauhn",
    "Marketing Name": "Smart TV",
    "Device": "longshan",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "Bauhn",
    "Marketing Name": "Smart TV",
    "Device": "redwood",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "BeLeno",
    "Marketing Name": "BeLeno_Neod_8",
    "Device": "BeLeno_Neod_8",
    "Model": "BeLeno_Neod_8"
  },
  {
    "Retail Branding": "BeLeno",
    "Marketing Name": "BeLeno_Turbo_101",
    "Device": "BeLeno_Turbo_101",
    "Model": "BeLeno_Turbo_101"
  },
  {
    "Retail Branding": "Becrypt",
    "Marketing Name": "Convex 430",
    "Device": "granite",
    "Model": "Becrypt Convex 430"
  },
  {
    "Retail Branding": "Becrypt",
    "Marketing Name": "Convex 430",
    "Device": "granite",
    "Model": "Becrypt Indigo 430"
  },
  {
    "Retail Branding": "Beeline",
    "Marketing Name": "Beebox",
    "Device": "SWG2001A",
    "Model": "SWG2001A-A"
  },
  {
    "Retail Branding": "Beeline",
    "Marketing Name": "Beeline Pro 4",
    "Device": "Beeline_Pro_4",
    "Model": "Beeline Pro 4"
  },
  {
    "Retail Branding": "Beeline",
    "Marketing Name": "Beeline Tab Fast 2",
    "Device": "z701",
    "Model": "Beeline Tab Fast 2"
  },
  {
    "Retail Branding": "Beeline",
    "Marketing Name": "Beeline Tab Pro",
    "Device": "BeelineTabPro",
    "Model": "Beeline Tab Pro"
  },
  {
    "Retail Branding": "Beeline",
    "Marketing Name": "Fast",
    "Device": "Fast",
    "Model": "Beeline Fast"
  },
  {
    "Retail Branding": "Beeline",
    "Marketing Name": "Fast HD",
    "Device": "Beeline_Fast_HD",
    "Model": "Beeline Fast HD"
  },
  {
    "Retail Branding": "Beeline",
    "Marketing Name": "Fast-Plus",
    "Device": "Fast_Plus",
    "Model": "Beeline Fast +"
  },
  {
    "Retail Branding": "Beeline",
    "Marketing Name": "Pro 2",
    "Device": "Beeline_Pro_2",
    "Model": "Beeline Pro 2"
  },
  {
    "Retail Branding": "Beeline",
    "Marketing Name": "Pro 3",
    "Device": "Pro_3",
    "Model": "Beeline_Pro_3"
  },
  {
    "Retail Branding": "Beeline",
    "Marketing Name": "Pro 6",
    "Device": "Beeline_Pro_6",
    "Model": "Beeline_Pro_6"
  },
  {
    "Retail Branding": "Beeline",
    "Marketing Name": "Pro5",
    "Device": "Beeline_Pro_5",
    "Model": "A451"
  },
  {
    "Retail Branding": "Beeline",
    "Marketing Name": "Smart 6",
    "Device": "Beeline_Smart_6",
    "Model": "Beeline Smart 6"
  },
  {
    "Retail Branding": "Beeline",
    "Marketing Name": "Smart Dual",
    "Device": "Beeline",
    "Model": "Beeline Smart Dual"
  },
  {
    "Retail Branding": "Beeline",
    "Marketing Name": "Smart_8",
    "Device": "Beeline_Smart_8",
    "Model": "A221"
  },
  {
    "Retail Branding": "Beeline",
    "Marketing Name": "Smart_8",
    "Device": "Beeline_Smart_8",
    "Model": "A239"
  },
  {
    "Retail Branding": "Beeline",
    "Marketing Name": "Tab",
    "Device": "Beeline_Tab",
    "Model": "Beeline Tab"
  },
  {
    "Retail Branding": "Beeline",
    "Marketing Name": "Tab 2",
    "Device": "Tab_2",
    "Model": "Tab_2"
  },
  {
    "Retail Branding": "Beeline",
    "Marketing Name": "Tab IS",
    "Device": "Beeline_Tab_IS",
    "Model": "Beeline_Tab_IS"
  },
  {
    "Retail Branding": "Beeline",
    "Marketing Name": "Tab_Fast",
    "Device": "Beeline_Tab_Fast",
    "Model": "Beeline_Tab_Fast"
  },
  {
    "Retail Branding": "Beghelli",
    "Marketing Name": "SLV SMARTPHONE 55",
    "Device": "SLV_SMARTPHONE_55",
    "Model": "SLV_SMARTPHONE_55"
  },
  {
    "Retail Branding": "Beko",
    "Marketing Name": "Beko 2K Google TV",
    "Device": "awaza",
    "Model": "Beko 2K Google TV"
  },
  {
    "Retail Branding": "Beko",
    "Marketing Name": "Beko Android TV",
    "Device": "kunyang",
    "Model": "Beko Android TV"
  },
  {
    "Retail Branding": "Beko",
    "Marketing Name": "Beko Android TV",
    "Device": "millbrae",
    "Model": "Beko Android TV"
  },
  {
    "Retail Branding": "Beko",
    "Marketing Name": "Beko Android TV",
    "Device": "shinagawa",
    "Model": "Beko Android TV"
  },
  {
    "Retail Branding": "Beko",
    "Marketing Name": "Beko Android TV",
    "Device": "sinchon",
    "Model": "Beko Android TV"
  },
  {
    "Retail Branding": "Beko",
    "Marketing Name": "Beko Google TV",
    "Device": "wanchai",
    "Model": "Beko Google TV"
  },
  {
    "Retail Branding": "Beko",
    "Marketing Name": "Beko Google TV OLED",
    "Device": "wanchai",
    "Model": "Beko Google TV OLED"
  },
  {
    "Retail Branding": "Beko",
    "Marketing Name": "Beko Google TV QLED",
    "Device": "wanchai",
    "Model": "Beko Google TV QLED"
  },
  {
    "Retail Branding": "Beko",
    "Marketing Name": "Beko Google TV UHD+",
    "Device": "wanchai",
    "Model": "Beko Google TV UHD+"
  },
  {
    "Retail Branding": "Beko",
    "Marketing Name": "Beko Google UHD TV",
    "Device": "akropoli",
    "Model": "Beko Google UHD TV"
  },
  {
    "Retail Branding": "Beko",
    "Marketing Name": "Beko Nano QLED",
    "Device": "aberdeen",
    "Model": "Beko Nano QLED"
  },
  {
    "Retail Branding": "Beko",
    "Marketing Name": "Beko OLED Google TV",
    "Device": "aberdeen",
    "Model": "Beko OLED Google TV"
  },
  {
    "Retail Branding": "Beko",
    "Marketing Name": "Beko QLED Google TV",
    "Device": "akropoli",
    "Model": "Beko QLED Google TV"
  },
  {
    "Retail Branding": "Beko",
    "Marketing Name": "Beko UHD Android TV",
    "Device": "kunyang",
    "Model": "Beko Android UHD TV"
  },
  {
    "Retail Branding": "Beko",
    "Marketing Name": "Beko UHD pro TV",
    "Device": "cottongreen",
    "Model": "Beko UHD pro TV"
  },
  {
    "Retail Branding": "Beko",
    "Marketing Name": "R4",
    "Device": "R4",
    "Model": "R4"
  },
  {
    "Retail Branding": "Beko",
    "Marketing Name": "Turkey",
    "Device": "martin",
    "Model": "Beko Android TV"
  },
  {
    "Retail Branding": "Bell Canada",
    "Marketing Name": "Bell Streamer",
    "Device": "sti6130d324",
    "Model": "Bell Streamer"
  },
  {
    "Retail Branding": "Bell Canada",
    "Marketing Name": "FibeTV",
    "Device": "vip7802_bell",
    "Model": "FibeTV"
  },
  {
    "Retail Branding": "BenQ",
    "Marketing Name": "A3",
    "Device": "A3",
    "Model": "A3"
  },
  {
    "Retail Branding": "BenQ",
    "Marketing Name": "A3c",
    "Device": "BenQ_A3c",
    "Model": "BenQ A3c"
  },
  {
    "Retail Branding": "BenQ",
    "Marketing Name": "Agora 4G",
    "Device": "Agora_4G",
    "Model": "Agora 4G"
  },
  {
    "Retail Branding": "BenQ",
    "Marketing Name": "Agora_4G_Pro",
    "Device": "Agora_4G_Pro",
    "Model": "Agora 4G Pro"
  },
  {
    "Retail Branding": "BenQ",
    "Marketing Name": "Agora_Lite",
    "Device": "Agora_Lite",
    "Model": "Agora Lite"
  },
  {
    "Retail Branding": "BenQ",
    "Marketing Name": "B50",
    "Device": "B50",
    "Model": "B50"
  },
  {
    "Retail Branding": "BenQ",
    "Marketing Name": "B502",
    "Device": "B502",
    "Model": "B502"
  },
  {
    "Retail Branding": "BenQ",
    "Marketing Name": "B502",
    "Device": "B502",
    "Model": "B502_SA"
  },
  {
    "Retail Branding": "BenQ",
    "Marketing Name": "B505",
    "Device": "B505",
    "Model": "B505"
  },
  {
    "Retail Branding": "BenQ",
    "Marketing Name": "B506",
    "Device": "B506_TW",
    "Model": "B506_TW"
  },
  {
    "Retail Branding": "BenQ",
    "Marketing Name": "B50_CHT",
    "Device": "B50",
    "Model": "B50_CHT"
  },
  {
    "Retail Branding": "BenQ",
    "Marketing Name": "BenQTK001",
    "Device": "coonoor",
    "Model": "BenQTK001"
  },
  {
    "Retail Branding": "BenQ",
    "Marketing Name": "BenQ_Digital_Signage_04",
    "Device": "BenQ_Digital_Signage_04",
    "Model": "BenQ_Digital_Signage_04"
  },
  {
    "Retail Branding": "BenQ",
    "Marketing Name": "CP05_CM05_series",
    "Device": "CP05_CM05_series",
    "Model": "CP05_CM05_series"
  },
  {
    "Retail Branding": "BenQ",
    "Marketing Name": "E40-520",
    "Device": "ikebukuro",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "BenQ",
    "Marketing Name": "E55-720",
    "Device": "samseong",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "BenQ",
    "Marketing Name": "F3",
    "Device": "F3",
    "Model": "F3"
  },
  {
    "Retail Branding": "BenQ",
    "Marketing Name": "F4",
    "Device": "benq_a3s",
    "Model": "BenQ A3s"
  },
  {
    "Retail Branding": "BenQ",
    "Marketing Name": "F5",
    "Device": "BENQ_F5",
    "Model": "BenQ F5"
  },
  {
    "Retail Branding": "BenQ",
    "Marketing Name": "F5",
    "Device": "F5",
    "Model": "BenQ F5"
  },
  {
    "Retail Branding": "BenQ",
    "Marketing Name": "F52",
    "Device": "F52",
    "Model": "F52_05"
  },
  {
    "Retail Branding": "BenQ",
    "Marketing Name": "F52_09",
    "Device": "F52",
    "Model": "F52_09"
  },
  {
    "Retail Branding": "BenQ",
    "Marketing Name": "F55",
    "Device": "F55",
    "Model": "BenQ F55"
  },
  {
    "Retail Branding": "BenQ",
    "Marketing Name": "F55J",
    "Device": "F55J",
    "Model": "BenQ F55J"
  },
  {
    "Retail Branding": "BenQ",
    "Marketing Name": "F5_06",
    "Device": "F5",
    "Model": "F5_06"
  },
  {
    "Retail Branding": "BenQ",
    "Marketing Name": "F5_13",
    "Device": "F5",
    "Model": "F5_13"
  },
  {
    "Retail Branding": "BenQ",
    "Marketing Name": "F5_15",
    "Device": "F5",
    "Model": "F5_15"
  },
  {
    "Retail Branding": "BenQ",
    "Marketing Name": "F5_16",
    "Device": "F5",
    "Model": "F5_16"
  },
  {
    "Retail Branding": "BenQ",
    "Marketing Name": "F5_18",
    "Device": "F5",
    "Model": "F5_18"
  },
  {
    "Retail Branding": "BenQ",
    "Marketing Name": "F5_19",
    "Device": "F5",
    "Model": "F5_19"
  },
  {
    "Retail Branding": "BenQ",
    "Marketing Name": "GP520",
    "Device": "khandala",
    "Model": "BenQGP01"
  },
  {
    "Retail Branding": "BenQ",
    "Marketing Name": "GV01",
    "Device": "himalaya",
    "Model": "BenQGV01"
  },
  {
    "Retail Branding": "BenQ",
    "Marketing Name": "Harrier",
    "Device": "Harrier",
    "Model": "Harrier from EE"
  },
  {
    "Retail Branding": "BenQ",
    "Marketing Name": "Harrier Mini",
    "Device": "harrier_mini",
    "Model": "Harrier Mini from EE"
  },
  {
    "Retail Branding": "BenQ",
    "Marketing Name": "Harrier Tab",
    "Device": "harrier_tab",
    "Model": "Harrier Tab from EE"
  },
  {
    "Retail Branding": "BenQ",
    "Marketing Name": "JD-150",
    "Device": "JD-150_P1",
    "Model": "JD-150"
  },
  {
    "Retail Branding": "BenQ",
    "Marketing Name": "JM-250",
    "Device": "JM-250",
    "Model": "JM-250"
  },
  {
    "Retail Branding": "BenQ",
    "Marketing Name": "JM-250",
    "Device": "JM-250_P1",
    "Model": "JM-250"
  },
  {
    "Retail Branding": "BenQ",
    "Marketing Name": "Kogan 4G+",
    "Device": "Agora_4G_PLUS",
    "Model": "Agora 4G+"
  },
  {
    "Retail Branding": "BenQ",
    "Marketing Name": "Kogan Agora 4G Lite",
    "Device": "B506",
    "Model": "Kogan Agora 4G Lite"
  },
  {
    "Retail Branding": "BenQ",
    "Marketing Name": "NE001_series",
    "Device": "NE001_series",
    "Model": "NE001_series"
  },
  {
    "Retail Branding": "BenQ",
    "Marketing Name": "PT2200",
    "Device": "PT2200",
    "Model": "PT2200"
  },
  {
    "Retail Branding": "BenQ",
    "Marketing Name": "Q Stick",
    "Device": "S905Y2",
    "Model": "QS01"
  },
  {
    "Retail Branding": "BenQ",
    "Marketing Name": "QS01",
    "Device": "S905Y2",
    "Model": "QS01"
  },
  {
    "Retail Branding": "BenQ",
    "Marketing Name": "QS02",
    "Device": "YUL",
    "Model": "QS02"
  },
  {
    "Retail Branding": "BenQ",
    "Marketing Name": "RE04A",
    "Device": "RE04A_series",
    "Model": "RE04A_series"
  },
  {
    "Retail Branding": "BenQ",
    "Marketing Name": "RE04N1_series",
    "Device": "RE04N1_series",
    "Model": "RE04N1_series"
  },
  {
    "Retail Branding": "BenQ",
    "Marketing Name": "RE04N_series",
    "Device": "RE04N_series",
    "Model": "RE04N_series"
  },
  {
    "Retail Branding": "BenQ",
    "Marketing Name": "RE04_series",
    "Device": "RE04_series",
    "Model": "RE04_series"
  },
  {
    "Retail Branding": "BenQ",
    "Marketing Name": "RE05A_series",
    "Device": "RE05A_series",
    "Model": "RE05A_series"
  },
  {
    "Retail Branding": "BenQ",
    "Marketing Name": "RM05_series",
    "Device": "RM05_series",
    "Model": "RM05_series"
  },
  {
    "Retail Branding": "BenQ",
    "Marketing Name": "RM6504",
    "Device": "RM6504",
    "Model": "RM6504"
  },
  {
    "Retail Branding": "BenQ",
    "Marketing Name": "RM7504",
    "Device": "RM7504",
    "Model": "RM7504"
  },
  {
    "Retail Branding": "BenQ",
    "Marketing Name": "RM8604",
    "Device": "RM8604",
    "Model": "RM8604"
  },
  {
    "Retail Branding": "BenQ",
    "Marketing Name": "RP05V_series",
    "Device": "RP05V_series",
    "Model": "RP05V_series"
  },
  {
    "Retail Branding": "BenQ",
    "Marketing Name": "RP05_series",
    "Device": "RP05_series",
    "Model": "RP05_series"
  },
  {
    "Retail Branding": "BenQ",
    "Marketing Name": "RP6504",
    "Device": "RP6504",
    "Model": "RP6504"
  },
  {
    "Retail Branding": "BenQ",
    "Marketing Name": "RP7504",
    "Device": "RP7504",
    "Model": "RP7504"
  },
  {
    "Retail Branding": "BenQ",
    "Marketing Name": "RP8604",
    "Device": "RP8604",
    "Model": "RP8604"
  },
  {
    "Retail Branding": "BenQ",
    "Marketing Name": "Smart TV",
    "Device": "alimos",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "BenQ",
    "Marketing Name": "Smart TV",
    "Device": "bridgeport",
    "Model": "AI PONT PLUS FF"
  },
  {
    "Retail Branding": "BenQ",
    "Marketing Name": "Smart TV",
    "Device": "longshan",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "BenQ",
    "Marketing Name": "Smart TV",
    "Device": "osaka",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "BenQ",
    "Marketing Name": "Smart TV",
    "Device": "redwood",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "BenQ",
    "Marketing Name": "T3",
    "Device": "T3",
    "Model": "BenQ T3"
  },
  {
    "Retail Branding": "BenQ",
    "Marketing Name": "T3",
    "Device": "T3_17A",
    "Model": "BenQ T3"
  },
  {
    "Retail Branding": "BenQ",
    "Marketing Name": "T3_08",
    "Device": "T3_17A",
    "Model": "BenQ T3"
  },
  {
    "Retail Branding": "BenQ",
    "Marketing Name": "T3_17A",
    "Device": "T3_17A",
    "Model": "BenQ T3"
  },
  {
    "Retail Branding": "BenQ",
    "Marketing Name": "T47",
    "Device": "T47",
    "Model": "T47_05"
  },
  {
    "Retail Branding": "BenQ",
    "Marketing Name": "T47_09",
    "Device": "",
    "Model": ""
  },
  {
    "Retail Branding": "BenQ",
    "Marketing Name": "T47_09",
    "Device": "T47",
    "Model": "T47_09"
  },
  {
    "Retail Branding": "BenQ",
    "Marketing Name": "T55",
    "Device": "T55",
    "Model": "T55"
  },
  {
    "Retail Branding": "BenQ",
    "Marketing Name": "TEY1A",
    "Device": "TEY1A",
    "Model": "TEY1A"
  },
  {
    "Retail Branding": "BenQ",
    "Marketing Name": "TEY2A",
    "Device": "TEY2A",
    "Model": "TEY2A"
  },
  {
    "Retail Branding": "BenQ",
    "Marketing Name": "laoshan_BenQ",
    "Device": "laoshan",
    "Model": "BENQANDROIDTV"
  },
  {
    "Retail Branding": "Benesse",
    "Marketing Name": "50S904",
    "Device": "50S904",
    "Model": "50S904"
  },
  {
    "Retail Branding": "Benesse",
    "Marketing Name": "TAB-A03-BR",
    "Device": "TAB-A03-BR",
    "Model": "TAB-A03-BR"
  },
  {
    "Retail Branding": "Benesse",
    "Marketing Name": "TAB-A03-BS",
    "Device": "TAB-A03-BS",
    "Model": "TAB-A03-BS"
  },
  {
    "Retail Branding": "Benesse",
    "Marketing Name": "TAB-A05-BD",
    "Device": "TAB-A05-BD",
    "Model": "TAB-A05-BD"
  },
  {
    "Retail Branding": "Benesse",
    "Marketing Name": "TAB-BEG-01",
    "Device": "beg01",
    "Model": "TAB-BEG-01"
  },
  {
    "Retail Branding": "Beneve",
    "Marketing Name": "M1036",
    "Device": "M1036",
    "Model": "M1036"
  },
  {
    "Retail Branding": "Beneve",
    "Marketing Name": "M1038_EEA",
    "Device": "M1038_EEA",
    "Model": "M1037"
  },
  {
    "Retail Branding": "Beneve",
    "Marketing Name": "M51",
    "Device": "M51",
    "Model": "M51"
  },
  {
    "Retail Branding": "Beneve",
    "Marketing Name": "M51S",
    "Device": "M51S",
    "Model": "M51S"
  },
  {
    "Retail Branding": "Beneve",
    "Marketing Name": "M51S_EEA",
    "Device": "M51S_EEA",
    "Model": "M51S_EEA"
  },
  {
    "Retail Branding": "Beneve",
    "Marketing Name": "M51_EEA",
    "Device": "M51_EEA",
    "Model": "M51_EEA"
  },
  {
    "Retail Branding": "Beneve",
    "Marketing Name": "M53",
    "Device": "M53",
    "Model": "M53"
  },
  {
    "Retail Branding": "Beneve",
    "Marketing Name": "M53_EEA",
    "Device": "M53_EEA",
    "Model": "M53_EEA"
  },
  {
    "Retail Branding": "Beneve",
    "Marketing Name": "M55",
    "Device": "M55",
    "Model": "M55"
  },
  {
    "Retail Branding": "Beneve",
    "Marketing Name": "M55_EEA",
    "Device": "M55_EEA",
    "Model": "M55_EEA"
  },
  {
    "Retail Branding": "Beneve",
    "Marketing Name": "M7133",
    "Device": "M7133",
    "Model": "M7133"
  },
  {
    "Retail Branding": "Beneve",
    "Marketing Name": "M7133E",
    "Device": "M7133E",
    "Model": "M7133E"
  },
  {
    "Retail Branding": "Beneve",
    "Marketing Name": "M7133E3",
    "Device": "M7133E3",
    "Model": "M7133E3"
  },
  {
    "Retail Branding": "Beneve",
    "Marketing Name": "M7152",
    "Device": "M7152",
    "Model": "M7152"
  },
  {
    "Retail Branding": "Beneve",
    "Marketing Name": "M7152D1",
    "Device": "M7152D1",
    "Model": "M7152D1"
  },
  {
    "Retail Branding": "Beneve",
    "Marketing Name": "M7152D1_EEA",
    "Device": "M7152D1_EEA",
    "Model": "M7152D1_EEA"
  },
  {
    "Retail Branding": "Beneve",
    "Marketing Name": "M7152P",
    "Device": "M7152P",
    "Model": "M7152P"
  },
  {
    "Retail Branding": "Beneve",
    "Marketing Name": "M7152P_EEA",
    "Device": "M7152P_EEA",
    "Model": "M7152P_EEA"
  },
  {
    "Retail Branding": "Beneve",
    "Marketing Name": "M755",
    "Device": "M755",
    "Model": "M755"
  },
  {
    "Retail Branding": "Benten",
    "Marketing Name": "Benten_S9_4G",
    "Device": "Benten_S9",
    "Model": "S9_4G"
  },
  {
    "Retail Branding": "Benten",
    "Marketing Name": "Benten_T20",
    "Device": "Benten_T20",
    "Model": "Benten_T20"
  },
  {
    "Retail Branding": "Benten",
    "Marketing Name": "Benten_T30",
    "Device": "Benten_T30",
    "Model": "T30"
  },
  {
    "Retail Branding": "Benten",
    "Marketing Name": "T10",
    "Device": "Benten_T10",
    "Model": "T10"
  },
  {
    "Retail Branding": "Benten",
    "Marketing Name": "T30",
    "Device": "T30",
    "Model": "T30"
  },
  {
    "Retail Branding": "Benten",
    "Marketing Name": "T8",
    "Device": "T8",
    "Model": "T8"
  },
  {
    "Retail Branding": "Bentley",
    "Marketing Name": "SDIS1",
    "Device": "sdis1",
    "Model": "BENTLEY ENTERTAINMENT TABLET"
  },
  {
    "Retail Branding": "Bentley",
    "Marketing Name": "Tab",
    "Device": "sdis1",
    "Model": "BENTLEY ENTERTAINMENT TABLET"
  },
  {
    "Retail Branding": "Bertoli",
    "Marketing Name": "B20X",
    "Device": "B20X",
    "Model": "B20X"
  },
  {
    "Retail Branding": "BesDW",
    "Marketing Name": "Note 15",
    "Device": "BesDW_Note_15",
    "Model": "Note 15"
  },
  {
    "Retail Branding": "BesDW",
    "Marketing Name": "X10_ROW",
    "Device": "X10_ROW",
    "Model": "X10"
  },
  {
    "Retail Branding": "Best Buy",
    "Marketing Name": "Transformer Pad (TF103C)",
    "Device": "K010",
    "Model": "K010"
  },
  {
    "Retail Branding": "Bestreha",
    "Marketing Name": "BRN01",
    "Device": "BRN01",
    "Model": "BRN01"
  },
  {
    "Retail Branding": "Beyond",
    "Marketing Name": "MAX4",
    "Device": "MAX4",
    "Model": "MAX4"
  },
  {
    "Retail Branding": "Beyond",
    "Marketing Name": "SURVE",
    "Device": "SURVE",
    "Model": "SURVE"
  },
  {
    "Retail Branding": "Beyond",
    "Marketing Name": "WIN",
    "Device": "WIN",
    "Model": "WIN"
  },
  {
    "Retail Branding": "Bfelix",
    "Marketing Name": "BF1001_Kids",
    "Device": "BF1001_Kids",
    "Model": "BF1001_Kids"
  },
  {
    "Retail Branding": "Bible-Pad",
    "Marketing Name": "Bible-Pad",
    "Device": "BTAB-7Q2",
    "Model": "BTAB-7Q2"
  },
  {
    "Retail Branding": "Biegedy",
    "Marketing Name": "B21_EEA",
    "Device": "B21_EEA",
    "Model": "B21_EEA"
  },
  {
    "Retail Branding": "Biegedy",
    "Marketing Name": "B21_US",
    "Device": "B21_US",
    "Model": "B21_US"
  },
  {
    "Retail Branding": "Biegedy",
    "Marketing Name": "B22-U-EEA",
    "Device": "B22-U-EEA",
    "Model": "B22-EEA"
  },
  {
    "Retail Branding": "Biegedy",
    "Marketing Name": "B22-U-EEA",
    "Device": "B22-U-EEA",
    "Model": "B22-U-EEA"
  },
  {
    "Retail Branding": "Biegedy",
    "Marketing Name": "B22-U-US",
    "Device": "B22-U-US",
    "Model": "B22-US"
  },
  {
    "Retail Branding": "Biegedy",
    "Marketing Name": "B22_EEA",
    "Device": "B22_EEA",
    "Model": "B22_EEA"
  },
  {
    "Retail Branding": "Biegedy",
    "Marketing Name": "B22_US",
    "Device": "B22_US",
    "Model": "B22_US"
  },
  {
    "Retail Branding": "Biegedy",
    "Marketing Name": "B23_US",
    "Device": "B23_US",
    "Model": "B23_US"
  },
  {
    "Retail Branding": "Biegedy",
    "Marketing Name": "B23_U_EEA",
    "Device": "B23_U_EEA",
    "Model": "B23_EEA"
  },
  {
    "Retail Branding": "Biegedy",
    "Marketing Name": "B23_U_EEA",
    "Device": "B23_U_EEA",
    "Model": "B23_U_EEA"
  },
  {
    "Retail Branding": "Biegedy",
    "Marketing Name": "B23_U_US",
    "Device": "B23_U_US",
    "Model": "B23_US"
  },
  {
    "Retail Branding": "Biegedy",
    "Marketing Name": "B23_U_US",
    "Device": "B23_U_US",
    "Model": "B23_U_US"
  },
  {
    "Retail Branding": "Biegedy",
    "Marketing Name": "B25_EEA",
    "Device": "B25_EEA",
    "Model": "B25_EEA"
  },
  {
    "Retail Branding": "Biegedy",
    "Marketing Name": "B25_US",
    "Device": "B25_US",
    "Model": "B25_US"
  },
  {
    "Retail Branding": "Biegedy",
    "Marketing Name": "B29_EEA",
    "Device": "B29_EEA",
    "Model": "B29_EEA"
  },
  {
    "Retail Branding": "Biegedy",
    "Marketing Name": "B29_US",
    "Device": "B29_US",
    "Model": "B29_US"
  },
  {
    "Retail Branding": "Bigben",
    "Marketing Name": "BB8252",
    "Device": "Bigben-TAB",
    "Model": "BB8252"
  },
  {
    "Retail Branding": "Bigben",
    "Marketing Name": "Bigtech_B_RU",
    "Device": "Bigtech_B_RU",
    "Model": "Bigtech_B_RU"
  },
  {
    "Retail Branding": "Bigben",
    "Marketing Name": "GAMETAB-ONE",
    "Device": "GAMETAB-ONE",
    "Model": "GAMETAB-ONE"
  },
  {
    "Retail Branding": "Bigme",
    "Marketing Name": "HiBreak",
    "Device": "Smartphone",
    "Model": "HiBreak"
  },
  {
    "Retail Branding": "Bigme",
    "Marketing Name": "HiBreak_EEA",
    "Device": "Smartphone",
    "Model": "HiBreak"
  },
  {
    "Retail Branding": "Bigme",
    "Marketing Name": "HiBreak_RU",
    "Device": "Smartphone",
    "Model": "HiBreak"
  },
  {
    "Retail Branding": "Bigtech",
    "Marketing Name": "BigTech_D2",
    "Device": "BigTech_D2",
    "Model": "BigTech D2"
  },
  {
    "Retail Branding": "Bigtech",
    "Marketing Name": "Bigtech_A_RU",
    "Device": "Bigtech_A_RU",
    "Model": "Bigtech_A_RU"
  },
  {
    "Retail Branding": "BilimBook",
    "Marketing Name": "BilimBook_mini",
    "Device": "BilimBook_mini",
    "Model": "BilimBook mini"
  },
  {
    "Retail Branding": "Billion",
    "Marketing Name": "Billion Capture+",
    "Device": "rimoB",
    "Model": "Capture+"
  },
  {
    "Retail Branding": "Billow",
    "Marketing Name": "X101PRO+",
    "Device": "X101PRO",
    "Model": "X101PRO+"
  },
  {
    "Retail Branding": "Billow",
    "Marketing Name": "X103PRO",
    "Device": "X103PRO",
    "Model": "X103PRO"
  },
  {
    "Retail Branding": "Billow",
    "Marketing Name": "X703",
    "Device": "X703",
    "Model": "X703"
  },
  {
    "Retail Branding": "Binatone",
    "Marketing Name": "SMART64",
    "Device": "SMART64",
    "Model": "SMART64"
  },
  {
    "Retail Branding": "Binatone",
    "Marketing Name": "Smart 63",
    "Device": "SMART63",
    "Model": "SMART63"
  },
  {
    "Retail Branding": "Binatone",
    "Marketing Name": "Smart 66",
    "Device": "SMART66",
    "Model": "SMART66"
  },
  {
    "Retail Branding": "BioRugged",
    "Marketing Name": "BIOWOLF8F30",
    "Device": "BIOWOLF8F30",
    "Model": "BIOWOLF8F30"
  },
  {
    "Retail Branding": "BioRugged",
    "Marketing Name": "BW10RS_EEA",
    "Device": "BW10RS_EEA",
    "Model": "BW10RS"
  },
  {
    "Retail Branding": "BioRugged",
    "Marketing Name": "BioWolf_C",
    "Device": "BioWolf_C",
    "Model": "BioWolf_C"
  },
  {
    "Retail Branding": "BioRugged",
    "Marketing Name": "RuggboLite",
    "Device": "RuggboLite",
    "Model": "RuggboLite"
  },
  {
    "Retail Branding": "BioRugged",
    "Marketing Name": "Ruggbo_AA",
    "Device": "Ruggbo_AA",
    "Model": "Ruggbo AA"
  },
  {
    "Retail Branding": "BioRugged",
    "Marketing Name": "T4000",
    "Device": "T4000",
    "Model": "T4000"
  },
  {
    "Retail Branding": "BioWolf",
    "Marketing Name": "DEZ",
    "Device": "DEZ",
    "Model": "DEZ"
  },
  {
    "Retail Branding": "Bird",
    "Marketing Name": "A7",
    "Device": "A7",
    "Model": "A7"
  },
  {
    "Retail Branding": "Bird",
    "Marketing Name": "E5018",
    "Device": "E5018",
    "Model": "E5018"
  },
  {
    "Retail Branding": "Bird",
    "Marketing Name": "Energy",
    "Device": "Energy",
    "Model": "Energy"
  },
  {
    "Retail Branding": "Bird",
    "Marketing Name": "F07",
    "Device": "Bird_F07",
    "Model": "F07"
  },
  {
    "Retail Branding": "Bird",
    "Marketing Name": "F15",
    "Device": "Bird_F15",
    "Model": "F15"
  },
  {
    "Retail Branding": "Bird",
    "Marketing Name": "S1",
    "Device": "Bird_S1",
    "Model": "S1"
  },
  {
    "Retail Branding": "Bird",
    "Marketing Name": "X6",
    "Device": "Bird_X6",
    "Model": "X6"
  },
  {
    "Retail Branding": "Bita-International",
    "Marketing Name": "MC66",
    "Device": "MC66",
    "Model": "MC66"
  },
  {
    "Retail Branding": "Bitel",
    "Marketing Name": "B8416",
    "Device": "B8416",
    "Model": "B8416"
  },
  {
    "Retail Branding": "Bitel",
    "Marketing Name": "B8506",
    "Device": "B8506",
    "Model": "B8506"
  },
  {
    "Retail Branding": "Bitel",
    "Marketing Name": "B9401",
    "Device": "B9401",
    "Model": "B9401"
  },
  {
    "Retail Branding": "Bitel",
    "Marketing Name": "B9502",
    "Device": "B9502",
    "Model": "B9502"
  },
  {
    "Retail Branding": "Bitel",
    "Marketing Name": "B9504",
    "Device": "B9504",
    "Model": "B9504"
  },
  {
    "Retail Branding": "Bitel",
    "Marketing Name": "B9505",
    "Device": "4G_Smart_Phone_B9505",
    "Model": "B9505"
  },
  {
    "Retail Branding": "Bitel",
    "Marketing Name": "BPRO",
    "Device": "BPRO",
    "Model": "BPRO"
  },
  {
    "Retail Branding": "Bitel",
    "Marketing Name": "Bitel B866V2FAS",
    "Device": "B866V2FAS_Bitel",
    "Model": "Bitel B866V2FAS"
  },
  {
    "Retail Branding": "Bitel",
    "Marketing Name": "M50",
    "Device": "M50",
    "Model": "M50"
  },
  {
    "Retail Branding": "Bitel",
    "Marketing Name": "Pro 9",
    "Device": "PRO9",
    "Model": "PRO9"
  },
  {
    "Retail Branding": "Bitmore",
    "Marketing Name": "Bitmore_Mobitab_8_4G",
    "Device": "Mobitab_8_4G",
    "Model": "Bitmore_Mobitab_8_4G"
  },
  {
    "Retail Branding": "Bitmore",
    "Marketing Name": "GTAB700",
    "Device": "GTAB700",
    "Model": "NID_7010"
  },
  {
    "Retail Branding": "Bitmore",
    "Marketing Name": "GTAB900",
    "Device": "GTAB900",
    "Model": "S952"
  },
  {
    "Retail Branding": "Bitmore",
    "Marketing Name": "LUXYA MID704DC Tablet / Bitmore Tab770",
    "Device": "MY7317P",
    "Model": "Tab770"
  },
  {
    "Retail Branding": "Bitmore",
    "Marketing Name": "Mobitab10_S3_32GB",
    "Device": "Mobitab10_S3_32GB",
    "Model": "Mobitab10_S3_32GB"
  },
  {
    "Retail Branding": "Bitmore",
    "Marketing Name": "Tab10_Plus_32GB",
    "Device": "Tab10_Plus_32GB",
    "Model": "Tab10_Plus_32GB"
  },
  {
    "Retail Branding": "Bitmore",
    "Marketing Name": "Tab870",
    "Device": "Tab870",
    "Model": "Tab870"
  },
  {
    "Retail Branding": "Bittium",
    "Marketing Name": "Air-Lynx ALS14000",
    "Device": "granite",
    "Model": "Bittium Tough Mobile"
  },
  {
    "Retail Branding": "Bittium",
    "Marketing Name": "Bittium Tough Mobile 2",
    "Device": "craton",
    "Model": "Bittium Tough Mobile 2"
  },
  {
    "Retail Branding": "Bittium",
    "Marketing Name": "Mx Smart",
    "Device": "adakite_sm",
    "Model": "Mx Smart"
  },
  {
    "Retail Branding": "Bittium",
    "Marketing Name": "Tough Mobile",
    "Device": "granite",
    "Model": "Bittium Tough Mobile"
  },
  {
    "Retail Branding": "Bittium",
    "Marketing Name": "granite",
    "Device": "granite",
    "Model": "Bittium Tough Mobile"
  },
  {
    "Retail Branding": "Bizringer",
    "Marketing Name": "8BIZ18",
    "Device": "8BIZ18",
    "Model": "8BIZ18"
  },
  {
    "Retail Branding": "Blabloo",
    "Marketing Name": "Space1Blue",
    "Device": "Space1Blue",
    "Model": "Space1Blue"
  },
  {
    "Retail Branding": "Black Bear",
    "Marketing Name": "B6 Master",
    "Device": "B6_Master",
    "Model": "B6 Master"
  },
  {
    "Retail Branding": "Black Bear",
    "Marketing Name": "B6_Note_X",
    "Device": "B6_Note_X",
    "Model": "B6 Note X"
  },
  {
    "Retail Branding": "BlackBerry",
    "Marketing Name": "Aurora",
    "Device": "bbc100",
    "Model": "BBC100-1"
  },
  {
    "Retail Branding": "BlackBerry",
    "Marketing Name": "BlackBerry Evolve",
    "Device": "bbg100",
    "Model": "BBG100-1"
  },
  {
    "Retail Branding": "BlackBerry",
    "Marketing Name": "BlackBerry KEY2",
    "Device": "bbf100",
    "Model": "BBF100-1"
  },
  {
    "Retail Branding": "BlackBerry",
    "Marketing Name": "BlackBerry KEY2",
    "Device": "bbf100",
    "Model": "BBF100-2"
  },
  {
    "Retail Branding": "BlackBerry",
    "Marketing Name": "BlackBerry KEY2",
    "Device": "bbf100",
    "Model": "BBF100-4"
  },
  {
    "Retail Branding": "BlackBerry",
    "Marketing Name": "BlackBerry KEY2",
    "Device": "bbf100",
    "Model": "BBF100-6"
  },
  {
    "Retail Branding": "BlackBerry",
    "Marketing Name": "BlackBerry KEY2",
    "Device": "bbf100",
    "Model": "BBF100-8"
  },
  {
    "Retail Branding": "BlackBerry",
    "Marketing Name": "BlackBerry KEY2",
    "Device": "bbf100",
    "Model": "BBF100-9"
  },
  {
    "Retail Branding": "BlackBerry",
    "Marketing Name": "BlackBerry KEY2 LE",
    "Device": "bbe100",
    "Model": "BBE100-1"
  },
  {
    "Retail Branding": "BlackBerry",
    "Marketing Name": "BlackBerry KEY2 LE",
    "Device": "bbe100",
    "Model": "BBE100-2"
  },
  {
    "Retail Branding": "BlackBerry",
    "Marketing Name": "BlackBerry KEY2 LE",
    "Device": "bbe100",
    "Model": "BBE100-4"
  },
  {
    "Retail Branding": "BlackBerry",
    "Marketing Name": "BlackBerry KEY2 LE",
    "Device": "bbe100",
    "Model": "BBE100-5"
  },
  {
    "Retail Branding": "BlackBerry",
    "Marketing Name": "BlackBerry KEYone",
    "Device": "bbb100",
    "Model": "BBB100-7"
  },
  {
    "Retail Branding": "BlackBerry",
    "Marketing Name": "BlackBerry MOTION",
    "Device": "bbd100",
    "Model": "BBD100-1"
  },
  {
    "Retail Branding": "BlackBerry",
    "Marketing Name": "BlackBerry MOTION",
    "Device": "bbd100",
    "Model": "BBD100-2"
  },
  {
    "Retail Branding": "BlackBerry",
    "Marketing Name": "BlackBerry MOTION",
    "Device": "bbd100",
    "Model": "BBD100-6"
  },
  {
    "Retail Branding": "BlackBerry",
    "Marketing Name": "Blackberry Evolve X",
    "Device": "bbh100",
    "Model": "BBH100-1"
  },
  {
    "Retail Branding": "BlackBerry",
    "Marketing Name": "Blackberry Keyone",
    "Device": "bbb100",
    "Model": "BBB100-7"
  },
  {
    "Retail Branding": "BlackBerry",
    "Marketing Name": "DTEK50",
    "Device": "hamburg",
    "Model": "STH100-1"
  },
  {
    "Retail Branding": "BlackBerry",
    "Marketing Name": "DTEK50",
    "Device": "hamburg",
    "Model": "STH100-2"
  },
  {
    "Retail Branding": "BlackBerry",
    "Marketing Name": "DTEK50 by BlackBerry",
    "Device": "hamburg",
    "Model": "STH100-1"
  },
  {
    "Retail Branding": "BlackBerry",
    "Marketing Name": "DTEK50 by BlackBerry",
    "Device": "hamburg",
    "Model": "STH100-2"
  },
  {
    "Retail Branding": "BlackBerry",
    "Marketing Name": "DTEK60",
    "Device": "argon",
    "Model": "BBA100-1"
  },
  {
    "Retail Branding": "BlackBerry",
    "Marketing Name": "DTEK60",
    "Device": "argon",
    "Model": "BBA100-2"
  },
  {
    "Retail Branding": "BlackBerry",
    "Marketing Name": "DTEK60 by BlackBerry",
    "Device": "argon",
    "Model": "BBA100-1"
  },
  {
    "Retail Branding": "BlackBerry",
    "Marketing Name": "DTEK60 by BlackBerry",
    "Device": "argon",
    "Model": "BBA100-2"
  },
  {
    "Retail Branding": "BlackBerry",
    "Marketing Name": "KEYone",
    "Device": "bbb100",
    "Model": "BBB100-1"
  },
  {
    "Retail Branding": "BlackBerry",
    "Marketing Name": "KEYone",
    "Device": "bbb100",
    "Model": "BBB100-2"
  },
  {
    "Retail Branding": "BlackBerry",
    "Marketing Name": "KEYone",
    "Device": "bbb100",
    "Model": "BBB100-3"
  },
  {
    "Retail Branding": "BlackBerry",
    "Marketing Name": "KEYone",
    "Device": "bbb100",
    "Model": "BBB100-4"
  },
  {
    "Retail Branding": "BlackBerry",
    "Marketing Name": "KEYone",
    "Device": "bbb100",
    "Model": "BBB100-5"
  },
  {
    "Retail Branding": "BlackBerry",
    "Marketing Name": "KEYone",
    "Device": "bbb100",
    "Model": "BBB100-6"
  },
  {
    "Retail Branding": "BlackBerry",
    "Marketing Name": "PRIV by BlackBerry",
    "Device": "venice",
    "Model": "STV100-1"
  },
  {
    "Retail Branding": "BlackBerry",
    "Marketing Name": "PRIV by BlackBerry",
    "Device": "venice",
    "Model": "STV100-2"
  },
  {
    "Retail Branding": "BlackBerry",
    "Marketing Name": "PRIV by BlackBerry",
    "Device": "venice",
    "Model": "STV100-3"
  },
  {
    "Retail Branding": "BlackBerry",
    "Marketing Name": "PRIV by BlackBerry",
    "Device": "venice",
    "Model": "STV100-4"
  },
  {
    "Retail Branding": "BlackZone",
    "Marketing Name": "BlackZone Apex 5G",
    "Device": "Apex_5G",
    "Model": "BlackZone Apex 5G"
  },
  {
    "Retail Branding": "Blackfox",
    "Marketing Name": "BMM431B",
    "Device": "BMM431B",
    "Model": "BMM431B"
  },
  {
    "Retail Branding": "Blackfox",
    "Marketing Name": "BMM431S",
    "Device": "BMM431S",
    "Model": "BMM431S"
  },
  {
    "Retail Branding": "Blackfox",
    "Marketing Name": "BMM441A",
    "Device": "BMM441A",
    "Model": "BMM441A"
  },
  {
    "Retail Branding": "Blackfox",
    "Marketing Name": "BMM441B",
    "Device": "BMM441B",
    "Model": "BMM441B"
  },
  {
    "Retail Branding": "Blackfox",
    "Marketing Name": "BMM441D",
    "Device": "BMM441D",
    "Model": "BMM441D"
  },
  {
    "Retail Branding": "Blackfox",
    "Marketing Name": "BMM441S",
    "Device": "BMM441S",
    "Model": "BMM441S"
  },
  {
    "Retail Branding": "Blackfox",
    "Marketing Name": "BMM441W",
    "Device": "BMM441W",
    "Model": "BMM441W"
  },
  {
    "Retail Branding": "Blackfox",
    "Marketing Name": "BMM442D",
    "Device": "BMM442D",
    "Model": "BMM442D"
  },
  {
    "Retail Branding": "Blackfox",
    "Marketing Name": "BMM442S",
    "Device": "BMM442S",
    "Model": "BMM442S"
  },
  {
    "Retail Branding": "Blackfox",
    "Marketing Name": "BMM443D",
    "Device": "BMM443D",
    "Model": "BMM443D"
  },
  {
    "Retail Branding": "Blackfox",
    "Marketing Name": "BMM531A",
    "Device": "BMM531A",
    "Model": "BMM531A"
  },
  {
    "Retail Branding": "Blackfox",
    "Marketing Name": "BMM531B",
    "Device": "BMM531B",
    "Model": "BMM531B"
  },
  {
    "Retail Branding": "Blackfox",
    "Marketing Name": "BMM531D",
    "Device": "BMM531D",
    "Model": "BMM531D"
  },
  {
    "Retail Branding": "Blackfox",
    "Marketing Name": "BMM531S",
    "Device": "BMM531S",
    "Model": "BMM531S"
  },
  {
    "Retail Branding": "Blackfox",
    "Marketing Name": "BMM532D",
    "Device": "BMM532D",
    "Model": "BMM532D"
  },
  {
    "Retail Branding": "Blackfox",
    "Marketing Name": "BMM541A",
    "Device": "BMM541A",
    "Model": "BMM541A"
  },
  {
    "Retail Branding": "Blackfox",
    "Marketing Name": "BMM541B",
    "Device": "BMM541B",
    "Model": "BMM541B"
  },
  {
    "Retail Branding": "Blackfox",
    "Marketing Name": "BMM541D",
    "Device": "BMM541D",
    "Model": "BMM541D"
  },
  {
    "Retail Branding": "Blackfox",
    "Marketing Name": "BMM541W",
    "Device": "BMM541W",
    "Model": "BMM541W"
  },
  {
    "Retail Branding": "Blackfox",
    "Marketing Name": "BMM542D",
    "Device": "BMM542D",
    "Model": "BMM542D"
  },
  {
    "Retail Branding": "Blackfox",
    "Marketing Name": "BMM543D",
    "Device": "BMM543D",
    "Model": "BMM543D"
  },
  {
    "Retail Branding": "Blackfox",
    "Marketing Name": "BMM543S",
    "Device": "BMM543S",
    "Model": "BMM543S"
  },
  {
    "Retail Branding": "Blackfox",
    "Marketing Name": "BMM_533D",
    "Device": "BMM_533D",
    "Model": "BMM_533D"
  },
  {
    "Retail Branding": "Blackshark",
    "Marketing Name": "BSM2",
    "Device": "PadSE",
    "Model": "BSM2"
  },
  {
    "Retail Branding": "Blackshark",
    "Marketing Name": "Black Shark 2",
    "Device": "skywalker",
    "Model": "SKW-A0"
  },
  {
    "Retail Branding": "Blackshark",
    "Marketing Name": "Black Shark 2",
    "Device": "skywalker",
    "Model": "SKW-H0"
  },
  {
    "Retail Branding": "Blackshark",
    "Marketing Name": "Black Shark 2 Pro",
    "Device": "darklighter",
    "Model": "DLT-H0"
  },
  {
    "Retail Branding": "Blackshark",
    "Marketing Name": "Black shark 4 pro",
    "Device": "kaiser-os",
    "Model": "SHARK KSR-H0"
  },
  {
    "Retail Branding": "Blackshark",
    "Marketing Name": "Black_Shark_Gaming_Tablet",
    "Device": "Black_Shark_Gaming_Tablet",
    "Model": "BSG1"
  },
  {
    "Retail Branding": "Blackshark",
    "Marketing Name": "KLE-A0",
    "Device": "klein",
    "Model": "SHARK KLE-A0"
  },
  {
    "Retail Branding": "Blackshark",
    "Marketing Name": "KLE-H0",
    "Device": "klein",
    "Model": "SHARK KLE-H0"
  },
  {
    "Retail Branding": "Blackshark",
    "Marketing Name": "MBU-A0",
    "Device": "mobius",
    "Model": "SHARK MBU-A0"
  },
  {
    "Retail Branding": "Blackshark",
    "Marketing Name": "MBU-H0",
    "Device": "mobius",
    "Model": "SHARK MBU-H0"
  },
  {
    "Retail Branding": "Blackshark",
    "Marketing Name": "Pad6",
    "Device": "Pad6",
    "Model": "ML1107H"
  },
  {
    "Retail Branding": "Blackshark",
    "Marketing Name": "Pad6",
    "Device": "Pad6",
    "Model": "Pad6"
  },
  {
    "Retail Branding": "Blackshark",
    "Marketing Name": "Pad7",
    "Device": "Pad7",
    "Model": "BSM1"
  },
  {
    "Retail Branding": "Blackshark",
    "Marketing Name": "Pad7_Pro",
    "Device": "Pad7_Pro",
    "Model": "BSM3"
  },
  {
    "Retail Branding": "Blackshark",
    "Marketing Name": "Pad7_WiFi",
    "Device": "Pad7_WiFi",
    "Model": "BSM4"
  },
  {
    "Retail Branding": "Blackshark",
    "Marketing Name": "Pad_7_Pro_UE",
    "Device": "Pad_7_Pro_UE",
    "Model": "Pad_7_Pro_UE"
  },
  {
    "Retail Branding": "Blackshark",
    "Marketing Name": "SHARK KSR-A0",
    "Device": "kaiser",
    "Model": "SHARK KSR-A0"
  },
  {
    "Retail Branding": "Blackshark",
    "Marketing Name": "SHARK PRS-A0",
    "Device": "penrose",
    "Model": "SHARK PRS-A0"
  },
  {
    "Retail Branding": "Blackshark",
    "Marketing Name": "SHARK PRS-H0",
    "Device": "penrose",
    "Model": "SHARK PRS-H0"
  },
  {
    "Retail Branding": "Blackshark",
    "Marketing Name": "Shark",
    "Device": "shark",
    "Model": "SKR-H0"
  },
  {
    "Retail Branding": "Blackshark",
    "Marketing Name": "Shark 1S",
    "Device": "bullhead",
    "Model": "AWM-A0"
  },
  {
    "Retail Branding": "Blackshark",
    "Marketing Name": "黑鲨游戏手机",
    "Device": "shark",
    "Model": "SKR-A0"
  },
  {
    "Retail Branding": "Blackshark",
    "Marketing Name": "黑鲨游戏手机 2 Pro",
    "Device": "darklighter",
    "Model": "DLT-A0"
  },
  {
    "Retail Branding": "Blacksonic",
    "Marketing Name": "BS7",
    "Device": "BS7",
    "Model": "BS7"
  },
  {
    "Retail Branding": "Blacksonic",
    "Marketing Name": "BS7-3G",
    "Device": "BS7-3G",
    "Model": "BS7-3G"
  },
  {
    "Retail Branding": "Blacksonic",
    "Marketing Name": "BS7-BUTTERFLY",
    "Device": "BS7-BUTTERFLY",
    "Model": "BS7-BUTTERFLY"
  },
  {
    "Retail Branding": "Blacksonic",
    "Marketing Name": "BS7-KIDS",
    "Device": "BS7-KIDS",
    "Model": "BS7-KIDS"
  },
  {
    "Retail Branding": "Blacksonic",
    "Marketing Name": "BS9",
    "Device": "BS9",
    "Model": "BS9"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "A100",
    "Device": "A100",
    "Model": "A100"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "A20",
    "Device": "A20",
    "Model": "A20"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "A200 Pro",
    "Device": "A200Pro",
    "Model": "A200 Pro"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "A30-RU",
    "Device": "A30-RU",
    "Model": "A30-RU"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "A5",
    "Device": "A5",
    "Model": "A5"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "A50",
    "Device": "A50",
    "Model": "A50"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "A52",
    "Device": "A52",
    "Model": "A52"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "A52 Pro",
    "Device": "A52Pro",
    "Model": "A52 Pro"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "A52 Pro",
    "Device": "A52Pro",
    "Model": "A52 Pro(6+128GB)"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "A53",
    "Device": "A53",
    "Model": "A53"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "A53 Pro",
    "Device": "A53_Pro",
    "Model": "A53 Pro"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "A55",
    "Device": "A55",
    "Model": "A55"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "A55 Pro",
    "Device": "A55_Pro",
    "Model": "A55 Pro"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "A60",
    "Device": "A60",
    "Model": "A60"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "A60",
    "Device": "A60_2G",
    "Model": "A60"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "A60 Plus",
    "Device": "A60Plus",
    "Model": "A60Plus"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "A60 Pro",
    "Device": "A60Pro",
    "Model": "A60Pro"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "A60Pro",
    "Device": "A60Pro",
    "Model": "A60Pro"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "A7",
    "Device": "A7",
    "Model": "A7"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "A70",
    "Device": "A70",
    "Model": "A70"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "A70 Pro",
    "Device": "A70_Pro",
    "Model": "A70 Pro"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "A7PRO",
    "Device": "A7Pro",
    "Model": "A7Pro"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "A8 MAX",
    "Device": "A8_MAX",
    "Model": "A8 MAX"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "A80",
    "Device": "A80",
    "Model": "A80"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "A80Plus",
    "Device": "A80Plus",
    "Model": "A80Plus"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "A80Pro",
    "Device": "A80Pro",
    "Model": "A80Pro"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "A80S",
    "Device": "A80S",
    "Model": "A80S"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "A85",
    "Device": "A85",
    "Model": "A85"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "A9 Pro",
    "Device": "A9_Pro",
    "Model": "A9_Pro"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "A90",
    "Device": "A90",
    "Model": "A90"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "A95",
    "Device": "A95",
    "Model": "A95"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "A96",
    "Device": "A96",
    "Model": "A96"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "Active 10 Pro",
    "Device": "Active_10_Pro",
    "Model": "Active 10 Pro"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "Active 12 Pro",
    "Device": "Active_12_Pro",
    "Model": "Active 12 Pro"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "Active 5",
    "Device": "Active_5",
    "Model": "Active 5"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "Active 6",
    "Device": "Active6",
    "Model": "Active 6"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "Active 6",
    "Device": "Active6_EEA",
    "Model": "Active 6"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "Active 6",
    "Device": "Active6_RU",
    "Model": "Active 6"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "Active 7",
    "Device": "Active_7",
    "Model": "Active 7"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "Active 8 Pro",
    "Device": "Active8Pro",
    "Model": "Active 8 Pro"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "Active 8 Pro",
    "Device": "Active8Pro_A15",
    "Model": "Active 8 Pro"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "Active8_EEA",
    "Device": "Active8",
    "Model": "Active 8"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "Active8_NEU",
    "Device": "Active8",
    "Model": "Active 8"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "Active8_RU",
    "Device": "Active8",
    "Model": "Active 8"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "BL5000",
    "Device": "BL5000",
    "Model": "BL5000"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "BL6000Pro",
    "Device": "BL6000Pro",
    "Model": "BL6000Pro"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "BL7000",
    "Device": "BL7000",
    "Model": "BL7000"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "BL8000",
    "Device": "BL8000",
    "Model": "BL8000"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "BL8800",
    "Device": "BL8800",
    "Model": "BL8800"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "BL8800Pro",
    "Device": "BL8800Pro",
    "Model": "BL8800Pro"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "BL9000",
    "Device": "BL9000",
    "Model": "BL9000"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "BL9000 Pro",
    "Device": "BL9000_Pro",
    "Model": "BL9000 Pro"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "BV4000",
    "Device": "BV4000",
    "Model": "BV4000"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "BV4000Pro_RU",
    "Device": "BV4000Pro",
    "Model": "BV4000Pro-RU"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "BV4800",
    "Device": "BV4800",
    "Model": "BV4800"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "BV4800 Pro",
    "Device": "BV4800Pro",
    "Model": "BV4800 Pro"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "BV4800 SE",
    "Device": "BV4800_SE",
    "Model": "BV4800 SE"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "BV4900",
    "Device": "BV4900",
    "Model": "BV4900"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "BV4900Pro",
    "Device": "BV4900Pro",
    "Model": "BV4900Pro"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "BV4900s",
    "Device": "BV4900s",
    "Model": "BV4900s"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "BV5100",
    "Device": "BV5100",
    "Model": "BV5100"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "BV5100Pro",
    "Device": "BV5100Pro",
    "Model": "BV5100Pro"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "BV5200",
    "Device": "BV5200",
    "Model": "BV5200"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "BV5200 Pro",
    "Device": "BV5200_Pro",
    "Model": "BV5200 Pro"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "BV5300",
    "Device": "BV5300",
    "Model": "BV5300"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "BV5300 Plus",
    "Device": "BV5300_Plus",
    "Model": "BV5300 Plus"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "BV5300 Pro",
    "Device": "BV5300_Pro",
    "Model": "BV5300 Pro"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "BV5500",
    "Device": "BV5500",
    "Model": "BV5500"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "BV5500",
    "Device": "BV5500S",
    "Model": "BV5500"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "BV5500PLUS",
    "Device": "BV5500Plus",
    "Model": "BV5500Plus"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "BV5500Plus",
    "Device": "BV5500Plus",
    "Model": "BV5500Plus"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "BV5500Pro",
    "Device": "BV5500Pro",
    "Model": "BV5500Pro"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "BV5500S",
    "Device": "BV5500S",
    "Model": "BV5500"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "BV5800",
    "Device": "BV5800",
    "Model": "BV5800"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "BV5800PRO",
    "Device": "BV5800_PRO",
    "Model": "BV5800 PRO"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "BV5800PRO_RU",
    "Device": "BV5800Pro_RU",
    "Model": "BV5800Pro_RU"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "BV5800_RU",
    "Device": "BV5800_RU",
    "Model": "BV5800_RU"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "BV5900",
    "Device": "BV5900",
    "Model": "BV5900"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "BV6000",
    "Device": "Blackview",
    "Model": "BV6000"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "BV6000",
    "Device": "SOLID_4G1",
    "Model": "SOLID_4G1"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "BV6000S_RU",
    "Device": "BV6000S_RU",
    "Model": "BV6000S_RU"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "BV6000_RU",
    "Device": "BV6000_RU",
    "Model": "BV6000_RU"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "BV6000s",
    "Device": "BV6000S",
    "Model": "BV6000S"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "BV6100",
    "Device": "BV6100",
    "Model": "BV6100"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "BV6200",
    "Device": "BV6200",
    "Model": "BV6200"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "BV6200 Plus",
    "Device": "BV6200_Plus",
    "Model": "BV6200 Plus"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "BV6200 Pro",
    "Device": "BV6200Pro",
    "Model": "BV6200 Pro"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "BV6200 Pro",
    "Device": "BV6200_Pro_14",
    "Model": "BV6200 Pro"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "BV6300",
    "Device": "BV6300",
    "Model": "BV6300"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "BV6300Pro",
    "Device": "BV6300Pro",
    "Model": "BV6300Pro"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "BV6600",
    "Device": "BV6600",
    "Model": "BV6600"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "BV6600E",
    "Device": "BV6600E",
    "Model": "BV6600E"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "BV6600Pro",
    "Device": "BV6600Pro",
    "Model": "BV6600Pro"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "BV6800Pro",
    "Device": "BV6800Pro",
    "Model": "BV6800Pro"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "BV6800Pro-RU",
    "Device": "BV6800Pro_RU",
    "Model": "BV6800Pro_RU"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "BV6800Pro_RU",
    "Device": "BV6800Pro_RU",
    "Model": "BV6800Pro_RU"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "BV6900",
    "Device": "BV6900",
    "Model": "BV6900"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "BV7000",
    "Device": "BV7000",
    "Model": "BV7000"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "BV7000 Pro",
    "Device": "BV7000_Pro",
    "Model": "BV7000 Pro"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "BV7000Pro_RU",
    "Device": "BV7000_Pro",
    "Model": "BV7000 Pro"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "BV7000_RU",
    "Device": "BV7000",
    "Model": "BV7000"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "BV7100",
    "Device": "BV7100",
    "Model": "BV7100"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "BV7200",
    "Device": "BV7200",
    "Model": "BV7200"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "BV7300",
    "Device": "BV7300",
    "Model": "BV7300"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "BV8000 Pro",
    "Device": "BV8000Pro",
    "Model": "BV8000Pro"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "BV8000Pro_RU",
    "Device": "BV8000Pro_RU",
    "Model": "BV8000Pro_RU"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "BV8100",
    "Device": "BV8100",
    "Model": "BV8100"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "BV8200",
    "Device": "BV8200",
    "Model": "BV8200"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "BV8800",
    "Device": "BV8800",
    "Model": "BV8800"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "BV8900",
    "Device": "BV8900",
    "Model": "BV8900"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "BV8900 Pro",
    "Device": "BV8900_Pro",
    "Model": "BV8900 Pro"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "BV9000",
    "Device": "BV9000",
    "Model": "BV9000"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "BV9000 Pro",
    "Device": "BV9000Pro",
    "Model": "BV9000Pro"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "BV9000 Pro-F",
    "Device": "BV9000Pro-F",
    "Model": "BV9000Pro-F"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "BV9000-F",
    "Device": "BV9000-F",
    "Model": "BV9000-F"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "BV9000-RU",
    "Device": "BV9000-RU",
    "Model": "BV9000-RU"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "BV9000-RU",
    "Device": "BV9000Pro-RU",
    "Model": "BV9000Pro-RU"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "BV9100",
    "Device": "BV9100",
    "Model": "BV9100"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "BV9200",
    "Device": "BV9200",
    "Model": "BV9200"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "BV9300",
    "Device": "BV9300",
    "Model": "BV9300"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "BV9300 Pro",
    "Device": "BV9300_Pro",
    "Model": "BV9300 Pro"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "BV9300 Pro",
    "Device": "BV9300_Pro_A15",
    "Model": "BV9300 Pro"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "BV9600",
    "Device": "BV9600",
    "Model": "BV9600"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "BV9600E",
    "Device": "BV9600E",
    "Model": "BV9600E"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "BV9600Pro",
    "Device": "Blackview",
    "Model": "BV9600Pro"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "BV9800",
    "Device": "BV9800",
    "Model": "BV9800"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "BV9800Pro",
    "Device": "BV9800Pro",
    "Model": "BV9800Pro"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "BV9900E",
    "Device": "BV9900E",
    "Model": "BV9900E"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "Blackview A10",
    "Device": "A10",
    "Model": "A10"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "Blackview A20 Pro",
    "Device": "A20Pro",
    "Model": "A20Pro"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "Blackview A30",
    "Device": "A30",
    "Model": "A30"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "Blackview BV4000",
    "Device": "BV4000",
    "Model": "BV4000"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "Blackview BV4000Pro",
    "Device": "BV4000Pro",
    "Model": "BV4000Pro"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "Blackview BV9500",
    "Device": "BV9500",
    "Model": "BV9500"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "Blackview BV9500-RU",
    "Device": "BV9500-RU",
    "Model": "BV9500-RU"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "Blackview BV9500Plus",
    "Device": "BV9500Plus",
    "Model": "BV9500Plus"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "Blackview BV9500Pro",
    "Device": "BV9500Pro",
    "Model": "BV9500Pro"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "Blackview BV9700Pro",
    "Device": "BV9700Pro",
    "Model": "BV9700Pro"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "Blackview BV9700Pro_EEA",
    "Device": "BV9700Pro",
    "Model": "BV9700Pro"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "Blackview BV9900",
    "Device": "BV9900",
    "Model": "BV9900"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "Blackview BV9900E",
    "Device": "BV9900E",
    "Model": "BV9900E"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "Blackview BV9900Pro",
    "Device": "BV9900Pro",
    "Model": "BV9900Pro"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "Blackview P2",
    "Device": "P2",
    "Model": "P2"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "Business_4_G1",
    "Device": "Business_4_G1",
    "Model": "Business_4_G1"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "COLOR 6",
    "Device": "COLOR_6",
    "Model": "COLOR 6"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "COLOR 8",
    "Device": "COLOR_8",
    "Model": "COLOR 8"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "E7S",
    "Device": "E7s",
    "Model": "E7s"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "FORT 1",
    "Device": "FORT_1",
    "Model": "FORT 1"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "FORT 100",
    "Device": "FORT_100",
    "Model": "FORT 100"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "FORT 2",
    "Device": "FORT_2",
    "Model": "FORT 2"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "FORT 5",
    "Device": "FORT_5",
    "Model": "FORT 5"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "HERO 10",
    "Device": "HERO10",
    "Model": "HERO 10"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "LINK 1 Kids",
    "Device": "LINK_1_Kids",
    "Model": "LINK 1 Kids"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "LINK 2",
    "Device": "LINK_2",
    "Model": "LINK 2"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "LINK 8",
    "Device": "LINK_8",
    "Model": "LINK 8"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "MAX1",
    "Device": "MAX1",
    "Model": "MAX1"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "MEGA 1",
    "Device": "MEGA_1",
    "Model": "MEGA 1"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "MEGA 12",
    "Device": "MEGA_12",
    "Model": "MEGA 12"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "MEGA 2",
    "Device": "MEGA_2",
    "Model": "MEGA 2"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "MEGA 2 WIFI",
    "Device": "MEGA_2_WIFI",
    "Model": "MEGA 2 WIFI"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "MEGA 3",
    "Device": "MEGA_3",
    "Model": "MEGA 3"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "MEGA 8",
    "Device": "MEGA_8",
    "Model": "MEGA 8"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "N6000",
    "Device": "N6000",
    "Model": "N6000"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "N6000 SE",
    "Device": "N6000_SE",
    "Model": "N6000 SE"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "P10000 Pro",
    "Device": "P10000_Pro",
    "Model": "P10000 Pro"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "P10000 Pro",
    "Device": "P10000_Pro",
    "Model": "P10000_Pro"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "P2 Lite",
    "Device": "P2Lite",
    "Model": "P2Lite"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "P6000",
    "Device": "P6000",
    "Model": "P6000"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "P6000Plus",
    "Device": "P6000Plus",
    "Model": "P6000Plus"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "PILOT 2",
    "Device": "PILOT_2",
    "Model": "PILOT 2"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "Pad8_EEA",
    "Device": "Pad8_EEA",
    "Model": "Pad8"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "Pad8_ROW",
    "Device": "Pad8_ROW",
    "Model": "Pad8"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "Pad8_RU",
    "Device": "Pad8_RU",
    "Model": "Pad8"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "ROCK 1",
    "Device": "ROCK_1",
    "Model": "ROCK 1"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "ROCK 1 Pro",
    "Device": "ROCK_1_Pro",
    "Model": "ROCK 1 Pro"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "ROCK 2",
    "Device": "ROCK_2",
    "Model": "ROCK 2"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "ROCK 2 Pro",
    "Device": "ROCK_2_Pro",
    "Model": "ROCK 2 Pro"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "ROCK 3",
    "Device": "ROCK_3",
    "Model": "ROCK 3"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "S6",
    "Device": "S6",
    "Model": "S6"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "S8",
    "Device": "S8",
    "Model": "S8"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "S8_RU",
    "Device": "S8",
    "Model": "S8"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "SHARK 6",
    "Device": "SHARK_6",
    "Model": "SHARK 6"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "SHARK 8",
    "Device": "Shark8",
    "Model": "SHARK 8"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "SHARK 9",
    "Device": "SHARK_9",
    "Model": "SHARK 9"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "SOLID-4G3",
    "Device": "SOLID_4G3",
    "Model": "SOLID_4G3"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "SOLID_4_G2",
    "Device": "SOLID_4_G2",
    "Model": "SOLID 4 G2"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "Shark 8",
    "Device": "Shark8",
    "Model": "SHARK 8"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "Tab 10",
    "Device": "Tab_10",
    "Model": "Tab 10"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "Tab 10 Pro",
    "Device": "Tab_10_Pro",
    "Model": "Tab 10 Pro"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "Tab 10 WiFi",
    "Device": "Tab10WiFi",
    "Model": "Tab 10 WiFi"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "Tab 13",
    "Device": "Tab_13",
    "Model": "Tab 13"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "Tab 13 Pro",
    "Device": "Tab13_Pro",
    "Model": "Tab 13 Pro"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "Tab 16 Pro",
    "Device": "Tab16_Pro",
    "Model": "Tab 16 Pro"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "Tab 16_Pro",
    "Device": "Tab16_Pro",
    "Model": "Tab 16 Pro"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "Tab 18",
    "Device": "Tab18",
    "Model": "Tab 18"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "Tab 20 Kids",
    "Device": "Tab_20_Kids",
    "Model": "Tab 20 Kids"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "Tab 20 WiFi",
    "Device": "Tab_20_WiFi",
    "Model": "Tab 20 WiFi"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "Tab 3 Kids",
    "Device": "Tab3Kids",
    "Model": "Tab 3 Kids"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "Tab 50 Kids",
    "Device": "Tab50Kids",
    "Model": "Tab 50 Kids"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "Tab 50 Kids",
    "Device": "Tab50Kids_TUR",
    "Model": "Tab 50 Kids"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "Tab 50 WiFi",
    "Device": "Tab50WiFi",
    "Model": "Tab 50 WiFi"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "Tab 60",
    "Device": "Tab60",
    "Model": "Tab 60"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "Tab 60 Kids",
    "Device": "Tab60Kids",
    "Model": "Tab 60 Kids"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "Tab 60 Kids",
    "Device": "Tab60Kids_EEA",
    "Model": "Tab 60 Kids"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "Tab 60 Kids",
    "Device": "Tab60Kids_RU",
    "Model": "Tab 60 Kids"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "Tab 60 Pro",
    "Device": "Tab_60_Pro",
    "Model": "Tab 60 Pro"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "Tab 60 Pro Kids",
    "Device": "Tab_60_Pro_K",
    "Model": "Tab 60 Pro Kids"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "Tab 60 WiFi",
    "Device": "Tab_60_WiFi",
    "Model": "Tab 60 WiFi"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "Tab 70 WiFi",
    "Device": "Tab70WiFi",
    "Model": "Tab 70 WiFi"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "Tab 70 WiFi",
    "Device": "Tab_70_WiFi_14",
    "Model": "Tab 70 WiFi"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "Tab 8 WiFi",
    "Device": "Tab8_WiFi_EEA",
    "Model": "Tab 8 WiFi"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "Tab 8 WiFi",
    "Device": "Tab8_WiFi_ROW",
    "Model": "Tab 8 WiFi"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "Tab 80",
    "Device": "Tab80",
    "Model": "Tab 80"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "Tab 80",
    "Device": "Tab80_EEA",
    "Model": "Tab 80"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "Tab 80",
    "Device": "Tab80_RU",
    "Model": "Tab 80"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "Tab 80 Kids",
    "Device": "Tab_80_Kids",
    "Model": "Tab 80 Kids"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "Tab 9 WiFi",
    "Device": "Tab_9_WiFi",
    "Model": "Tab 9 WiFi"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "Tab 90",
    "Device": "Tab_90",
    "Model": "Tab 90"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "Tab 90 WiFi",
    "Device": "Tab_90_WiFi",
    "Model": "Tab 90 WiFi"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "Tab A5 Kids",
    "Device": "Tab_A5_Kids",
    "Model": "Tab A5 Kids"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "Tab A6 Kids",
    "Device": "Tab_A6_Kids",
    "Model": "Tab A6 Kids"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "Tab10",
    "Device": "Tab_10",
    "Model": "Tab 10"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "Tab11SE_EEA",
    "Device": "Tab11SE_EEA",
    "Model": "Tab 11 SE"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "Tab11SE_NEU",
    "Device": "Tab11SE_NEU",
    "Model": "Tab 11 SE"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "Tab11SE_RU",
    "Device": "Tab11SE_RU",
    "Model": "Tab 11 RU"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "Tab11SE_RU",
    "Device": "Tab11SE_RU",
    "Model": "Tab 11 SE"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "Tab11WiFi_EEA",
    "Device": "Tab11WiFi_EEA",
    "Model": "Tab11WiFi_EEA"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "Tab11WiFi_NEU",
    "Device": "Tab11WiFi_NEU",
    "Model": "Tab11WiFi_NEU"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "Tab11WiFi_RU",
    "Device": "Tab11WiFi_NEU",
    "Model": "Tab11WiFi_RU"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "Tab11_EA",
    "Device": "Tab11_EA",
    "Model": "Tab 11"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "Tab11_EEA",
    "Device": "Tab11_EEA",
    "Model": "Tab11"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "Tab11_NEU",
    "Device": "Tab11_NEU",
    "Model": "Tab 11"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "Tab11_ROW",
    "Device": "Tab11_ROW",
    "Model": "Tab11"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "Tab11_RU",
    "Device": "Tab11_RU",
    "Model": "Tab 11"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "Tab11_RU",
    "Device": "Tab11_RU",
    "Model": "Tab11"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "Tab12Pro_EEA",
    "Device": "Tab12Pro_EEA",
    "Model": "Tab 12 Pro"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "Tab12Pro_NEU",
    "Device": "Tab12Pro_NEU",
    "Model": "Tab 12 Pro"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "Tab12Pro_RU",
    "Device": "Tab12Pro_NEU",
    "Model": "Tab 12 Pro"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "Tab12_EEA",
    "Device": "Tab12_EEA",
    "Model": "Tab 12"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "Tab12_NEU",
    "Device": "Tab12_NEU",
    "Model": "Tab 12"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "Tab12_RUU",
    "Device": "Tab12_NEU",
    "Model": "Tab 12"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "Tab13Pro_EEA",
    "Device": "Tab13Pro_EEA",
    "Model": "Tab 13 Pro"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "Tab13Pro_NEU",
    "Device": "Tab13Pro_NEU",
    "Model": "Tab 13 Pro"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "Tab15Pro_EEA",
    "Device": "Tab15Pro_EEA",
    "Model": "Tab 15 Pro"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "Tab15Pro_NEU",
    "Device": "Tab15Pro_NEU",
    "Model": "Tab 15 Pro"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "Tab15Pro_RU",
    "Device": "Tab15Pro_NEU",
    "Model": "Tab 15 Pro"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "Tab16_EEA",
    "Device": "Tab16_EEA",
    "Model": "Tab 16"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "Tab16_NEU",
    "Device": "Tab16_NEU",
    "Model": "Tab 16"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "Tab16_RU",
    "Device": "Tab16_RU",
    "Model": "Tab 16"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "Tab50WiFi_EEA",
    "Device": "Tab50WiFi",
    "Model": "Tab 50 WiFi"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "Tab5EEA",
    "Device": "Tab5EEA",
    "Model": "Tab 5"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "Tab5NEU",
    "Device": "Tab5NEU",
    "Model": "Tab 5"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "Tab6Kids_EEA",
    "Device": "Tab6Kids_EEA",
    "Model": "Tab 6 Kids"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "Tab6Kids_RU",
    "Device": "Tab6Kids_RU",
    "Model": "Tab 6 Kids"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "Tab6_EEA",
    "Device": "Tab6_EEA",
    "Model": "Tab 6"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "Tab6_NEU",
    "Device": "Tab6_NEU",
    "Model": "Tab 6"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "Tab6s_EEA",
    "Device": "Tab6s_EEA",
    "Model": "Tab 6s"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "Tab6s_NEU",
    "Device": "Tab6s_NEU",
    "Model": "Tab 6s"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "Tab70WiFi_EEA",
    "Device": "Tab70WiFi",
    "Model": "Tab 70 WiFi"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "Tab7Pro_EEA",
    "Device": "Tab7Pro_EEA",
    "Model": "Tab 7 Pro"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "Tab7Pro_NEU",
    "Device": "Tab7Pro_NEU",
    "Model": "Tab 7 Pro"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "Tab8",
    "Device": "Tab8",
    "Model": "Tab8"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "Tab8_EEA",
    "Device": "Tab8_EEA",
    "Model": "Tab 8"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "Tab8_NEU",
    "Device": "Tab8_NEU",
    "Model": "Tab8"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "Tab8_ROW",
    "Device": "Tab8_ROW",
    "Model": "Tab 8"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "Tab8_RU",
    "Device": "Tab8_RU",
    "Model": "Tab8_RU"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "Tab8_RUS",
    "Device": "Tab8_RUS",
    "Model": "Tab 8"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "Tab9_EEA",
    "Device": "Tab9_EEA",
    "Model": "Tab9"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "Tab9_NEU",
    "Device": "Tab9_NEU",
    "Model": "Tab 9"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "Tab9_RU",
    "Device": "Tab9_RU",
    "Model": "Tab 9"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "Tab_15_EEA",
    "Device": "Tab_15_EEA",
    "Model": "Tab 15"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "Tab_15_EU",
    "Device": "Tab_15_EU",
    "Model": "Tab 15"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "Tab_15_NEU",
    "Device": "Tab_15_NEU",
    "Model": "Tab 15"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "Tab_15_RU",
    "Device": "Tab_15_RU",
    "Model": "Tab 15"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "Tab_30_Kids_EEA",
    "Device": "Tab_30_Kids",
    "Model": "Tab 30 Kids"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "Tab_30_Kids_NEU",
    "Device": "Tab_30_Kids",
    "Model": "Tab 30 Kids"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "Tab_30_WiFi_EEA",
    "Device": "Tab_30_WIFI",
    "Model": "Tab 30 WiFi"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "Tab_30_WiFi_NEU",
    "Device": "Tab_30_WIFI",
    "Model": "Tab 30 WiFi"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "Tab_30_WiFi_RU",
    "Device": "Tab_30_WIFI",
    "Model": "Tab 30 WiFi"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "Tab_60_WiFi_EEA",
    "Device": "Tab_60_WiFi",
    "Model": "Tab 60 WiFi"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "Tab_7_EEA",
    "Device": "Tab_7_EEA",
    "Model": "Tab 7"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "Tab_7_NEU",
    "Device": "Tab_7_NEU",
    "Model": "Tab 7"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "Tab_7_WiFi_EEA",
    "Device": "Tab_7_WiFi_EEA",
    "Model": "Tab 7 WiFi"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "Tab_7_WiFi_NEU",
    "Device": "Tab_7_WiFi_NEU",
    "Model": "Tab 7 WiFi"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "Tab_90_WiFi_EEA",
    "Device": "Tab_90_WiFi",
    "Model": "Tab 90 WiFi"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "Tab_90_WiFi_NEU",
    "Device": "Tab_90_WiFi",
    "Model": "Tab 90 WiFi"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "WAVE 10",
    "Device": "WAVE_10",
    "Model": "WAVE 10"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "WAVE 6C",
    "Device": "WAVE6C",
    "Model": "WAVE 6C"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "WAVE 7C",
    "Device": "WAVE_7C",
    "Model": "WAVE 7C"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "WAVE 8",
    "Device": "WAVE_8",
    "Model": "WAVE 8"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "WAVE 8C",
    "Device": "WAVE_8C",
    "Model": "WAVE 8C"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "WAVE 9C",
    "Device": "WAVE_9C",
    "Model": "WAVE 9C"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "XPLORE 1",
    "Device": "XPLORE_1",
    "Model": "XPLORE 1"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "XPLORE 1 Pro",
    "Device": "XPLORE_1_Pro",
    "Model": "XPLORE 1 Pro"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "XPLORE 1 Walkie Talkie",
    "Device": "XPLORE_1_WT",
    "Model": "XPLORE 1 Walkie Talkie"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "XPLORE 2",
    "Device": "XPLORE2",
    "Model": "XPLORE 2"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "XPLORE 2 Projector",
    "Device": "XPLORE2_Pro",
    "Model": "XPLORE 2 Projector"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "XPLORE 2 Satellite",
    "Device": "XPLORE2_S",
    "Model": "XPLORE 2 Satellite"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "XPLORE X1",
    "Device": "XPLORE_X1",
    "Model": "XPLORE X1"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "ZENO 1",
    "Device": "ZENO_1",
    "Model": "ZENO 1"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "ZENO 10",
    "Device": "ZENO_10",
    "Model": "ZENO 10"
  },
  {
    "Retail Branding": "Blackview",
    "Marketing Name": "ZENO 100",
    "Device": "ZENO_100",
    "Model": "ZENO 100"
  },
  {
    "Retail Branding": "Blaupunkt",
    "Marketing Name": "A-STREAM",
    "Device": "GMP",
    "Model": "A-STREAM"
  },
  {
    "Retail Branding": "Blaupunkt",
    "Marketing Name": "AUSTRALIA, EU, JAPAN, MIDDLE EAST",
    "Device": "martin",
    "Model": "BLAUPUNKT Android Monitor"
  },
  {
    "Retail Branding": "Blaupunkt",
    "Marketing Name": "AUSTRALIA, MIDDLE EAST, JAPAN",
    "Device": "guandu",
    "Model": "BLAUPUNKT 4K Android TV"
  },
  {
    "Retail Branding": "Blaupunkt",
    "Marketing Name": "Android TV",
    "Device": "redwood",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "Blaupunkt",
    "Marketing Name": "Atlantis_A10_G403",
    "Device": "Atlantis_A10_G403",
    "Model": "Atlantis_A10_G403"
  },
  {
    "Retail Branding": "Blaupunkt",
    "Marketing Name": "Australia",
    "Device": "nippori",
    "Model": "BP Android TV 2K"
  },
  {
    "Retail Branding": "Blaupunkt",
    "Marketing Name": "Australia",
    "Device": "tamachi",
    "Model": "BLAUPUNKT Android TV"
  },
  {
    "Retail Branding": "Blaupunkt",
    "Marketing Name": "Australia",
    "Device": "yeongdeungpo",
    "Model": "BLAUPUNKT Android TV"
  },
  {
    "Retail Branding": "Blaupunkt",
    "Marketing Name": "B-STREAM",
    "Device": "JFK",
    "Model": "B-STREAM"
  },
  {
    "Retail Branding": "Blaupunkt",
    "Marketing Name": "B5000",
    "Device": "ikebukuro",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "Blaupunkt",
    "Marketing Name": "BATV10",
    "Device": "ICN",
    "Model": "BATV10"
  },
  {
    "Retail Branding": "Blaupunkt",
    "Marketing Name": "BLAUPUNKT",
    "Device": "bruno",
    "Model": "BLAUPUNKT 2K Android TV"
  },
  {
    "Retail Branding": "Blaupunkt",
    "Marketing Name": "BLAUPUNKT",
    "Device": "elliniko",
    "Model": "BLAUPUNKT GOOGLE TV 4K"
  },
  {
    "Retail Branding": "Blaupunkt",
    "Marketing Name": "BLAUPUNKT",
    "Device": "elliniko",
    "Model": "BLAUPUNKT SMART TV"
  },
  {
    "Retail Branding": "Blaupunkt",
    "Marketing Name": "BLAUPUNKT",
    "Device": "hongkong",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "Blaupunkt",
    "Marketing Name": "BLAUPUNKT",
    "Device": "hongkong",
    "Model": "BLAUPUNKT 4K TV"
  },
  {
    "Retail Branding": "Blaupunkt",
    "Marketing Name": "BLAUPUNKT",
    "Device": "hongkong",
    "Model": "BLAUPUNKT GOOGLE TV 4K"
  },
  {
    "Retail Branding": "Blaupunkt",
    "Marketing Name": "BLAUPUNKT",
    "Device": "jagalchi",
    "Model": "2K SMART TV"
  },
  {
    "Retail Branding": "Blaupunkt",
    "Marketing Name": "BLAUPUNKT",
    "Device": "jagalchi",
    "Model": "BLAUPUNKT GOOGLE TV"
  },
  {
    "Retail Branding": "Blaupunkt",
    "Marketing Name": "BLAUPUNKT",
    "Device": "khardi",
    "Model": "BLAUPUNKT GOOGLE TV 4K"
  },
  {
    "Retail Branding": "Blaupunkt",
    "Marketing Name": "BLAUPUNKT",
    "Device": "lavender",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "Blaupunkt",
    "Marketing Name": "BLAUPUNKT",
    "Device": "lavender",
    "Model": "BLAUPUNKT 4K TV"
  },
  {
    "Retail Branding": "Blaupunkt",
    "Marketing Name": "BLAUPUNKT",
    "Device": "mountbaker",
    "Model": "BLAUPUNKT 2K TV"
  },
  {
    "Retail Branding": "Blaupunkt",
    "Marketing Name": "BLAUPUNKT",
    "Device": "stanford",
    "Model": "CSV2K"
  },
  {
    "Retail Branding": "Blaupunkt",
    "Marketing Name": "BLAUPUNKT",
    "Device": "zhongshan",
    "Model": "CSV4K"
  },
  {
    "Retail Branding": "Blaupunkt",
    "Marketing Name": "BLAUPUNKT2K",
    "Device": "nippori",
    "Model": "BP 2K Android TV"
  },
  {
    "Retail Branding": "Blaupunkt",
    "Marketing Name": "BPTV30",
    "Device": "KHH",
    "Model": "UHD Google TV Stick"
  },
  {
    "Retail Branding": "Blaupunkt",
    "Marketing Name": "BP_6008",
    "Device": "BP_6008",
    "Model": "BP_6008"
  },
  {
    "Retail Branding": "Blaupunkt",
    "Marketing Name": "BP_6010",
    "Device": "BP_6010",
    "Model": "BP_6010"
  },
  {
    "Retail Branding": "Blaupunkt",
    "Marketing Name": "BP_6108",
    "Device": "BP_6108",
    "Model": "BP_6108"
  },
  {
    "Retail Branding": "Blaupunkt",
    "Marketing Name": "BP_6110",
    "Device": "BP_6110",
    "Model": "BP_6110"
  },
  {
    "Retail Branding": "Blaupunkt",
    "Marketing Name": "BP_T6108X",
    "Device": "BP_T6108X",
    "Model": "BP_T6108X"
  },
  {
    "Retail Branding": "Blaupunkt",
    "Marketing Name": "BP_T6110X",
    "Device": "BP_T6110X",
    "Model": "BP_T6110X"
  },
  {
    "Retail Branding": "Blaupunkt",
    "Marketing Name": "Blaupunk",
    "Device": "stanford",
    "Model": "Blaupunkt 2K Android TV"
  },
  {
    "Retail Branding": "Blaupunkt",
    "Marketing Name": "Blaupunkt",
    "Device": "bangbae",
    "Model": "BLAUPUNKT 4K Android TV"
  },
  {
    "Retail Branding": "Blaupunkt",
    "Marketing Name": "Blaupunkt",
    "Device": "dongmae",
    "Model": "Blaupunkt 2KTV"
  },
  {
    "Retail Branding": "Blaupunkt",
    "Marketing Name": "Blaupunkt",
    "Device": "ewha",
    "Model": "AQUOS-TVE19I"
  },
  {
    "Retail Branding": "Blaupunkt",
    "Marketing Name": "Blaupunkt",
    "Device": "ewha",
    "Model": "BLAU-TVE19I"
  },
  {
    "Retail Branding": "Blaupunkt",
    "Marketing Name": "Blaupunkt",
    "Device": "expo",
    "Model": "4K Blaupunkt Google TV"
  },
  {
    "Retail Branding": "Blaupunkt",
    "Marketing Name": "Blaupunkt",
    "Device": "kaitak",
    "Model": "Blaupunkt Google TV"
  },
  {
    "Retail Branding": "Blaupunkt",
    "Marketing Name": "Blaupunkt",
    "Device": "komagome",
    "Model": "BLAUPUNKT 2K Android TV"
  },
  {
    "Retail Branding": "Blaupunkt",
    "Marketing Name": "Blaupunkt",
    "Device": "lavender",
    "Model": "BLAUPUNKT GOOGLE TV 4K"
  },
  {
    "Retail Branding": "Blaupunkt",
    "Marketing Name": "Blaupunkt",
    "Device": "maniatika",
    "Model": "Blaupunkt 4K UHDTV"
  },
  {
    "Retail Branding": "Blaupunkt",
    "Marketing Name": "Blaupunkt",
    "Device": "mountbaker",
    "Model": "2K SMART TV"
  },
  {
    "Retail Branding": "Blaupunkt",
    "Marketing Name": "Blaupunkt",
    "Device": "mountbaker",
    "Model": "BLAUPUNKT GOOGLE TV"
  },
  {
    "Retail Branding": "Blaupunkt",
    "Marketing Name": "Blaupunkt",
    "Device": "shilin",
    "Model": "BLAUPUNKT 4K Android TV"
  },
  {
    "Retail Branding": "Blaupunkt",
    "Marketing Name": "Blaupunkt",
    "Device": "sindang",
    "Model": "BLAU-TVE19H"
  },
  {
    "Retail Branding": "Blaupunkt",
    "Marketing Name": "Blaupunkt",
    "Device": "tennoji",
    "Model": "2K Blaupunkt Google TV"
  },
  {
    "Retail Branding": "Blaupunkt",
    "Marketing Name": "Blaupunkt",
    "Device": "zhongshan",
    "Model": "Blaupunkt 4K Android TV"
  },
  {
    "Retail Branding": "Blaupunkt",
    "Marketing Name": "Blaupunkt 2K Google TV",
    "Device": "capitolhill",
    "Model": "Blaupunkt 2K Google TV"
  },
  {
    "Retail Branding": "Blaupunkt",
    "Marketing Name": "Blaupunkt 4K Google TV",
    "Device": "keoneae",
    "Model": "Blaupunkt 4K Google TV"
  },
  {
    "Retail Branding": "Blaupunkt",
    "Marketing Name": "Blaupunkt Google TV",
    "Device": "bandra",
    "Model": "Blaupunkt Google TV"
  },
  {
    "Retail Branding": "Blaupunkt",
    "Marketing Name": "Blaupunkt SL 01",
    "Device": "Blaupunkt_SL_01",
    "Model": "Blaupunkt SL 01"
  },
  {
    "Retail Branding": "Blaupunkt",
    "Marketing Name": "Blaupunkt SL 02",
    "Device": "Blaupunkt_SL_02",
    "Model": "Blaupunkt SL 02"
  },
  {
    "Retail Branding": "Blaupunkt",
    "Marketing Name": "Blaupunkt SL 04",
    "Device": "Blaupunkt_SL_04",
    "Model": "Blaupunkt SL 04"
  },
  {
    "Retail Branding": "Blaupunkt",
    "Marketing Name": "Blaupunkt SM 01",
    "Device": "Blaupunkt_SM_01",
    "Model": "Blaupunkt SM 01"
  },
  {
    "Retail Branding": "Blaupunkt",
    "Marketing Name": "Blaupunkt android TV",
    "Device": "hanyang",
    "Model": "BLAUPUNKT Android TV"
  },
  {
    "Retail Branding": "Blaupunkt",
    "Marketing Name": "Blaupunkt android TV",
    "Device": "hanyang",
    "Model": "BP 4K Android TV"
  },
  {
    "Retail Branding": "Blaupunkt",
    "Marketing Name": "Blaupunkt android TV",
    "Device": "hanyang",
    "Model": "BP Android TV"
  },
  {
    "Retail Branding": "Blaupunkt",
    "Marketing Name": "Blaupunkt_SM_02",
    "Device": "Blaupunkt_SM_02",
    "Model": "Blaupunkt_SM_02"
  },
  {
    "Retail Branding": "Blaupunkt",
    "Marketing Name": "Czech/Ukraine/Russia",
    "Device": "nippori",
    "Model": "BLAUPUNKT Android TV 2K"
  },
  {
    "Retail Branding": "Blaupunkt",
    "Marketing Name": "Discovery_A10_302",
    "Device": "Discovery_A10_302",
    "Model": "Discovery_A10_302"
  },
  {
    "Retail Branding": "Blaupunkt",
    "Marketing Name": "EU",
    "Device": "tamachi",
    "Model": "BLAUPUNKT FHD Android TV"
  },
  {
    "Retail Branding": "Blaupunkt",
    "Marketing Name": "EU、UK、AP",
    "Device": "martin",
    "Model": "BLAUPUNKT 2K Android TV"
  },
  {
    "Retail Branding": "Blaupunkt",
    "Marketing Name": "EU、UK、AP",
    "Device": "martin",
    "Model": "BLAUPUNKT 2K Android TV"
  },
  {
    "Retail Branding": "Blaupunkt",
    "Marketing Name": "Endeavour101",
    "Device": "Blaupunkt",
    "Model": "Endeavour101"
  },
  {
    "Retail Branding": "Blaupunkt",
    "Marketing Name": "Europe",
    "Device": "guandu",
    "Model": "BLAUPUNKT EU 4K Android TV"
  },
  {
    "Retail Branding": "Blaupunkt",
    "Marketing Name": "Europe",
    "Device": "marina",
    "Model": "Blaupunkt Smart TV"
  },
  {
    "Retail Branding": "Blaupunkt",
    "Marketing Name": "Europe",
    "Device": "martin",
    "Model": "BLAUPUNKT EU 2K Android TV"
  },
  {
    "Retail Branding": "Blaupunkt",
    "Marketing Name": "Europe",
    "Device": "martin",
    "Model": "BLAUPUNKT EU 2K Android TV"
  },
  {
    "Retail Branding": "Blaupunkt",
    "Marketing Name": "Europe",
    "Device": "nagata",
    "Model": "Blaupunkt Smart TV"
  },
  {
    "Retail Branding": "Blaupunkt",
    "Marketing Name": "Guardian",
    "Device": "Guardian",
    "Model": "Guardian"
  },
  {
    "Retail Branding": "Blaupunkt",
    "Marketing Name": "Japan,Australia, Italy,German",
    "Device": "patrick",
    "Model": "BLAUPUNKT Android Monitor"
  },
  {
    "Retail Branding": "Blaupunkt",
    "Marketing Name": "Kansas_City_150",
    "Device": "Tablet_player",
    "Model": "Kansas_City_150"
  },
  {
    "Retail Branding": "Blaupunkt",
    "Marketing Name": "MP3-A 4K TV",
    "Device": "SW4H",
    "Model": "MP3-A 4K TV"
  },
  {
    "Retail Branding": "Blaupunkt",
    "Marketing Name": "MP3TV",
    "Device": "shinjuku",
    "Model": "MP3-A 2K TV"
  },
  {
    "Retail Branding": "Blaupunkt",
    "Marketing Name": "North America, Central America",
    "Device": "hongik",
    "Model": "BP Smart TV"
  },
  {
    "Retail Branding": "Blaupunkt",
    "Marketing Name": "OT16",
    "Device": "OT16",
    "Model": "OT16"
  },
  {
    "Retail Branding": "Blaupunkt",
    "Marketing Name": "OT19",
    "Device": "OT19",
    "Model": "OT19"
  },
  {
    "Retail Branding": "Blaupunkt",
    "Marketing Name": "SF02_eea",
    "Device": "Blaupunkt_SF02",
    "Model": "Blaupunkt SF02"
  },
  {
    "Retail Branding": "Blaupunkt",
    "Marketing Name": "SF04 4G",
    "Device": "SF04_4G_EEA",
    "Model": "SF04 4G"
  },
  {
    "Retail Branding": "Blaupunkt",
    "Marketing Name": "SL05",
    "Device": "SL05",
    "Model": "SL05"
  },
  {
    "Retail Branding": "Blaupunkt",
    "Marketing Name": "SLplus02",
    "Device": "SLplus02",
    "Model": "SLplus02"
  },
  {
    "Retail Branding": "Blaupunkt",
    "Marketing Name": "SM 05",
    "Device": "Blaupunkt_SM_05",
    "Model": "Blaupunkt SM 05"
  },
  {
    "Retail Branding": "Blaupunkt",
    "Marketing Name": "SM_02_2019",
    "Device": "SM_02_2019",
    "Model": "SM 02 2019"
  },
  {
    "Retail Branding": "Blaupunkt",
    "Marketing Name": "Smart TV",
    "Device": "longshan",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "Blaupunkt",
    "Marketing Name": "Smart TV",
    "Device": "osaka",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "Blaupunkt",
    "Marketing Name": "Smart TV",
    "Device": "samseong",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "Blaupunkt",
    "Marketing Name": "Soundphone_S1",
    "Device": "Soundphone_S1",
    "Model": "Soundphone_S1"
  },
  {
    "Retail Branding": "Blaupunkt",
    "Marketing Name": "TX01",
    "Device": "TX01",
    "Model": "TX01"
  },
  {
    "Retail Branding": "Blaupunkt",
    "Marketing Name": "TX60",
    "Device": "Blaupunkt_TX60",
    "Model": "Blaupunkt_TX60"
  },
  {
    "Retail Branding": "Blaupunkt",
    "Marketing Name": "Turkey",
    "Device": "martin",
    "Model": "Blaupunkt 2K Android TV"
  },
  {
    "Retail Branding": "Blaupunkt",
    "Marketing Name": "Turkey",
    "Device": "tamachi",
    "Model": "Blaupunkt 2K Android TV"
  },
  {
    "Retail Branding": "Blaupunkt",
    "Marketing Name": "Turkey",
    "Device": "yeongdeungpo",
    "Model": "Blaupunkt 4K Android TV"
  },
  {
    "Retail Branding": "Blincast",
    "Marketing Name": "BLC-1600TF",
    "Device": "TRNE8_1319D_Hybrid",
    "Model": "1319D"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "A-200",
    "Device": "A200",
    "Model": "A200"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "A200",
    "Device": "A200",
    "Model": "A200"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "A250",
    "Device": "A250",
    "Model": "A250"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "A30",
    "Device": "A30",
    "Model": "A30"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "A5L",
    "Device": "A0050LL",
    "Model": "A5L"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "ADVANCE 4.0 L2",
    "Device": "BLU_ADVANCE_4_0_L2",
    "Model": "BLU ADVANCE 4.0 L2"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "ADVANCE 4.0 L3",
    "Device": "Advance_4_0_L3",
    "Model": "Advance 4.0 L3"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "ADVANCE 5.0 HD",
    "Device": "Advance_5_0_HD",
    "Model": "Advance 5.0 HD"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "ADVANCE L5",
    "Device": "A380",
    "Model": "Advance L5"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "ADVANCE L5",
    "Device": "A390",
    "Model": "Advance L5"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "Advance 4.0M",
    "Device": "Advance_4_0M",
    "Model": "Advance 4.0M"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "Advance 4.0M",
    "Device": "Advance_4_0M",
    "Model": "Studio M4"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "Advance 5.2",
    "Device": "A230Q",
    "Model": "Advance 5.2"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "Advance 5.2",
    "Device": "A290Q",
    "Model": "Advance 5.2"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "Advance A5 LTE",
    "Device": "A0010WW",
    "Model": "Advance A5 LTE"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "Advance A6",
    "Device": "A190",
    "Model": "Advance A6"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "Advance L4",
    "Device": "A350",
    "Model": "Advance L4"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "Advance L4",
    "Device": "A350A",
    "Model": "Advance L4"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "Advance L5",
    "Device": "A390T",
    "Model": "Advance L5"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "Advance_A7",
    "Device": "A210",
    "Model": "Advance A7"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "Advance A5 Plus LTE",
    "Device": "A0031WW",
    "Model": "Advance A5 Plus LTE"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "B110DL",
    "Device": "B110DL",
    "Model": "B110DL"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "B130DL",
    "Device": "B130DL",
    "Model": "B130DL"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "B131DL",
    "Device": "B130DL",
    "Model": "B131DL"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "B140DL",
    "Device": "B140DL",
    "Model": "B140DL"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "B160V",
    "Device": "B160V",
    "Model": "B160V"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "B3",
    "Device": "B301",
    "Model": "B3"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "BLU",
    "Device": "G0430WW",
    "Model": "G71"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "BLU Dash XL",
    "Device": "Dash_XL",
    "Model": "Dash XL"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "BLU Grand M3",
    "Device": "G0070WW",
    "Model": "Grand M3"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "BLU S1",
    "Device": "S0320WW",
    "Model": "BLU_S1"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "BLU STUDIO J8 LTE",
    "Device": "Studio_J8_LTE",
    "Model": "Studio J8 LTE"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "BLU VIEW 1",
    "Device": "B100DL",
    "Model": "VIEW 1"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "BLU Vivo ONE",
    "Device": "V0270WW",
    "Model": "Vivo ONE"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "BLU_STUDIO_G2",
    "Device": "BLU_STUDIO_G2",
    "Model": "BLU STUDIO G2"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "BLU_Studio_G_Max",
    "Device": "Studio_G_Max",
    "Model": "Studio G Max"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "BLU_Vivo_XL2",
    "Device": "BLU_Vivo_XL2",
    "Model": "Vivo XL2"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "BOLD K10",
    "Device": "K0110",
    "Model": "BOLD K10"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "BOLD K22",
    "Device": "K0250",
    "Model": "BOLD K22"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "BOLD K50",
    "Device": "K0130",
    "Model": "BOLD K50"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "BOLD M7",
    "Device": "M0100WW",
    "Model": "BOLD M7"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "BOLD M7",
    "Device": "M0110WW",
    "Model": "BOLD M7"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "BOLD M8",
    "Device": "M0120WW",
    "Model": "BOLD M8"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "BOLD M8",
    "Device": "M0130WW",
    "Model": "BOLD M8"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "BOLD M9",
    "Device": "M0140WW",
    "Model": "BOLD M9"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "BOLD M9",
    "Device": "M0150WW",
    "Model": "BOLD M9"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "BOLD N1",
    "Device": "N0030WW",
    "Model": "BOLD N1"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "BOLD N2",
    "Device": "N0050UU",
    "Model": "BOLD N2"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "BOLD N3",
    "Device": "N0070",
    "Model": "BOLD N3"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "C1",
    "Device": "C190",
    "Model": "C1"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "C2",
    "Device": "C210",
    "Model": "C2"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "C4",
    "Device": "C050",
    "Model": "C4"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "C4 2019",
    "Device": "C070",
    "Model": "C4 2019"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "C5",
    "Device": "C004",
    "Model": "C5"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "C5",
    "Device": "C010Q",
    "Model": "C5"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "C5",
    "Device": "C014",
    "Model": "C5"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "C5 2019",
    "Device": "C110",
    "Model": "C5 2019"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "C5 2019",
    "Device": "C111",
    "Model": "C5 2019"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "C5 LTE",
    "Device": "C0010UU",
    "Model": "C5 LTE"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "C5 MAX",
    "Device": "C270EQ",
    "Model": "C5 MAX"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "C5 PLUS",
    "Device": "C130EQ",
    "Model": "C5 Plus"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "C5L",
    "Device": "C0010TT",
    "Model": "C5L"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "C5L",
    "Device": "C0040",
    "Model": "C5L"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "C5L",
    "Device": "C0040LL",
    "Model": "C5L"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "C5L",
    "Device": "C0050",
    "Model": "C5L"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "C5L",
    "Device": "C0051LL",
    "Model": "C5L"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "C5L",
    "Device": "C017U",
    "Model": "C5L"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "C5L 2020",
    "Device": "C0070WW",
    "Model": "C5L 2020"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "C5L 2021",
    "Device": "C0100TT",
    "Model": "C5L 2021"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "C5L 2021",
    "Device": "C0101TT",
    "Model": "C5L 2021"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "C5L 2021",
    "Device": "C0101WW",
    "Model": "C5L 2021"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "C5L 2021",
    "Device": "C0110WW",
    "Model": "C5L 2021"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "C5L IW",
    "Device": "C017U",
    "Model": "C5L"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "C5L MAX",
    "Device": "C0160WW",
    "Model": "C5L Max"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "C5L Max",
    "Device": "C0161WW",
    "Model": "C5L MAX"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "C5L Max",
    "Device": "C0162WW",
    "Model": "C5L MAX"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "C5L Max",
    "Device": "C0170WW",
    "Model": "C5L MAX"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "C5L Max",
    "Device": "C0170WW",
    "Model": "C5L Max"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "C5L Max",
    "Device": "C0173WW",
    "Model": "C5L Max"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "C5L Max",
    "Device": "C0175",
    "Model": "C5L Max"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "C5L Max",
    "Device": "C0175_IW",
    "Model": "C5L Max"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "C5L Max",
    "Device": "C0176",
    "Model": "C5L Max"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "C5L PLUS",
    "Device": "C0130UU",
    "Model": "C5L PLUS"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "C5L+ 2021",
    "Device": "C0130WW",
    "Model": "C5L+ 2021"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "C5L_2020",
    "Device": "C0070WW",
    "Model": "C5L 2020"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "C5L_Mini",
    "Device": "C0250",
    "Model": "C5L Mini"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "C5L_Plus",
    "Device": "C0040TT",
    "Model": "C5L Plus"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "C5X",
    "Device": "C0000UU",
    "Model": "C5X"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "C5X",
    "Device": "C0010LL",
    "Model": "C5X"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "C6",
    "Device": "C031P",
    "Model": "C6"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "C6  2020",
    "Device": "C230EQ",
    "Model": "C6 2020"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "C6 2019",
    "Device": "C090EQ",
    "Model": "C6 2019"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "C6L",
    "Device": "C0030",
    "Model": "C6L"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "C6L",
    "Device": "C0190",
    "Model": "C6L"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "C6L 2020",
    "Device": "C0090WW",
    "Model": "C6L 2020"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "C6L 2021",
    "Device": "C0140TT",
    "Model": "C6L 2021"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "C6L 2021",
    "Device": "C0141TT",
    "Model": "C6L 2021"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "C6L 2021",
    "Device": "C0142TT",
    "Model": "C6L 2021"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "C6L 2021",
    "Device": "C0150WW",
    "Model": "C6L 2021"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "C6L 2021",
    "Device": "C0151WW",
    "Model": "C6L 2021"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "C6L 2021",
    "Device": "C0152TT",
    "Model": "C6L 2021"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "C6L 2021",
    "Device": "C0152WW",
    "Model": "C6L 2021"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "C6L MAX",
    "Device": "C0200",
    "Model": "C6L Max"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "C6L MAX",
    "Device": "C0210",
    "Model": "C6L Max"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "C6L Mini",
    "Device": "C0270",
    "Model": "C6L Mini"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "C6x",
    "Device": "C090P",
    "Model": "C6x"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "C7",
    "Device": "C250EQ",
    "Model": "C7"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "C7 MAX",
    "Device": "C0220",
    "Model": "C7 MAX"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "C7x",
    "Device": "C290EQ",
    "Model": "C7x"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "C9",
    "Device": "C0230",
    "Model": "C9"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "D10",
    "Device": "D10",
    "Model": "D10"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "D500",
    "Device": "D500",
    "Model": "D500"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "D510",
    "Device": "D510",
    "Model": "D510"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "D600",
    "Device": "D600",
    "Model": "D600"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "D701",
    "Device": "D701",
    "Model": "D701"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "DASH L2",
    "Device": "BLU_DASH_L2",
    "Model": "BLU DASH L2"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "DASH M2",
    "Device": "BLU_DASH_M2",
    "Model": "BLU DASH M2"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "DASH X LTE",
    "Device": "DASH_X_LTE",
    "Model": "BLU DASH X LTE"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "DASH X PLUS LTE",
    "Device": "BLU_DASH_X_PLUS_LTE",
    "Model": "DASH X PLUS LTE"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "DASH X2",
    "Device": "BLU_DASH_X2",
    "Model": "BLU DASH X2"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "DIAMOND M",
    "Device": "BLU_DIAMOND_M",
    "Model": "DIAMOND M"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "Dash 4.5",
    "Device": "D730",
    "Model": "Dash 4.5"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "Dash G",
    "Device": "Dash_G",
    "Model": "Dash G"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "Dash L3",
    "Device": "D931",
    "Model": "Dash L3"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "Dash L4",
    "Device": "D131",
    "Model": "Dash L4"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "Dash L4 LTE",
    "Device": "D0050",
    "Model": "Dash L4 LTE"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "Dash L4X",
    "Device": "D0040UU",
    "Model": "Dash L4X"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "Dash L5 LTE",
    "Device": "D0090WW",
    "Model": "Dash L5 LTE"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "Dash L5X",
    "Device": "D0070WW",
    "Model": "Dash L5X"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "Dash X",
    "Device": "BLU_DASH_X",
    "Model": "BLU DASH X"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "Dash X2",
    "Device": "Dash_X2",
    "Model": "Dash X2"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "Dash XL",
    "Device": "Dash_XL",
    "Model": "Dash XL"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "Dash XL",
    "Device": "Dash_XL",
    "Model": "Studio M5 Plus"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "Dash_L3",
    "Device": "Dash_L3",
    "Model": "Dash L3"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "E100",
    "Device": "E_100",
    "Model": "E100"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "E15",
    "Device": "E0010",
    "Model": "E15"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "E20",
    "Device": "E20",
    "Model": "E20"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "ENERGY  XL",
    "Device": "BLU_ENERGY_XL",
    "Model": "ENERGY XL"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "ENERGY DIAMOND",
    "Device": "BLU_ENERGY_DIAMOND",
    "Model": "BLU ENERGY DIAMOND"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "ENERGY DIAMOND MINI",
    "Device": "ENERGY_DIAMOND_MINI",
    "Model": "ENERGY_DIAMOND_MINI"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "ENERGY M",
    "Device": "BLU_ENERGY_M",
    "Model": "BLU ENERGY M"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "ENERGY X PLUS 2",
    "Device": "BLU_ENERGY_X_PLUS_2",
    "Model": "BLU ENERGY X PLUS 2"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "ENERGY_DIAMOND_MINI",
    "Device": "ENERGY_DIAMOND_MINI",
    "Model": "ENERGY_DIAMOND_MINI"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "Energy X 2",
    "Device": "BLU_Energy_X_2",
    "Model": "Energy X 2"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "Energy X LTE",
    "Device": "BLU_Energy_X_LTE",
    "Model": "Energy X LTE"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "F5",
    "Device": "F0090",
    "Model": "F5"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "F91 5G",
    "Device": "F0030UU",
    "Model": "F91 5G"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "G0290WW",
    "Device": "G0290WW",
    "Model": "G80"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "G33",
    "Device": "G0890",
    "Model": "G33"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "G33",
    "Device": "G0892",
    "Model": "G33"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "G33",
    "Device": "G0892_GMOB",
    "Model": "G33"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "G33",
    "Device": "G0892_MXT",
    "Model": "G33"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "G33",
    "Device": "G0892_SP",
    "Model": "G33"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "G33",
    "Device": "G0892_SYN",
    "Model": "G33"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "G33",
    "Device": "G0894",
    "Model": "G33"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "G34",
    "Device": "G1070",
    "Model": "G34"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "G35",
    "Device": "G1110",
    "Model": "G35"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "G35",
    "Device": "G1111",
    "Model": "G35"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "G40",
    "Device": "G0730WW",
    "Model": "G40"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "G40",
    "Device": "G0790UU",
    "Model": "G40"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "G43",
    "Device": "G0950",
    "Model": "G43"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "G44",
    "Device": "G0970",
    "Model": "G44"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "G44+",
    "Device": "G0971",
    "Model": "G44+"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "G45",
    "Device": "G1190",
    "Model": "G45"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "G5",
    "Device": "G0090",
    "Model": "G5"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "G5 Plus",
    "Device": "G0180LL",
    "Model": "G5 Plus"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "G5 Plus",
    "Device": "G0190",
    "Model": "G5 Plus"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "G50",
    "Device": "G0330WW",
    "Model": "G50"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "G50 MEGA",
    "Device": "G0390WW",
    "Model": "G50 Mega"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "G50 MEGA 2022",
    "Device": "G0660WW",
    "Model": "G50 Mega 2022"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "G50 MEGA 2022",
    "Device": "G0670WW",
    "Model": "G50 Mega 2022"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "G50 Plus",
    "Device": "G0350WW",
    "Model": "G50 Plus"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "G51",
    "Device": "G0480WW",
    "Model": "G51"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "G51",
    "Device": "G0490WW",
    "Model": "G51"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "G51 Plus",
    "Device": "G0510WW",
    "Model": "G51 Plus"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "G51 Plus",
    "Device": "G0512WW",
    "Model": "G51 Plus"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "G51S",
    "Device": "G0580WW",
    "Model": "G51S"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "G51S",
    "Device": "G0581WW",
    "Model": "G51S"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "G51S",
    "Device": "G0590WW",
    "Model": "G51S"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "G51S",
    "Device": "G0591WW",
    "Model": "G51S"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "G52L",
    "Device": "G0820",
    "Model": "G52L"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "G52L",
    "Device": "G0820WW",
    "Model": "G52L"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "G52L",
    "Device": "G0830WW",
    "Model": "G52L"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "G53",
    "Device": "G0850",
    "Model": "G53"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "G53",
    "Device": "G0850_IW",
    "Model": "G53"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "G53",
    "Device": "G0850_TIGO",
    "Model": "G53"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "G53",
    "Device": "G0851",
    "Model": "G53"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "G54",
    "Device": "E0010",
    "Model": "G54"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "G54",
    "Device": "G0840",
    "Model": "G54"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "G6",
    "Device": "G0210",
    "Model": "G6"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "G60",
    "Device": "G0270WW",
    "Model": "G60"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "G61",
    "Device": "G0450WW",
    "Model": "G61"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "G61S",
    "Device": "G0520WW",
    "Model": "G61S"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "G61S",
    "Device": "G0530WW",
    "Model": "G61S"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "G61S",
    "Device": "G0630WW",
    "Model": "G61S"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "G63",
    "Device": "G0860",
    "Model": "G63"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "G63",
    "Device": "G0870",
    "Model": "G63"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "G64",
    "Device": "G1010",
    "Model": "G64"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "G64L",
    "Device": "G0990",
    "Model": "G64L"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "G65L",
    "Device": "G1130",
    "Model": "G65L"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "G70",
    "Device": "G0151WW",
    "Model": "G70"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "G70",
    "Device": "G0250WW",
    "Model": "G70"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "G70",
    "Device": "G0251WW",
    "Model": "G70"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "G71",
    "Device": "G0570WW",
    "Model": "G71 PLUS"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "G71L",
    "Device": "G0710WW",
    "Model": "G71L"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "G71_PLUS_TIGO",
    "Device": "G0560WW",
    "Model": "G71 PLUS"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "G72 MAX",
    "Device": "G0770",
    "Model": "G72 MAX"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "G73",
    "Device": "G0771",
    "Model": "G73"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "G73L",
    "Device": "G0930",
    "Model": "G73L"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "G74",
    "Device": "G1030",
    "Model": "G74"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "G75",
    "Device": "G1170",
    "Model": "G75"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "G8",
    "Device": "G0160LL",
    "Model": "G8"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "G8",
    "Device": "G0170",
    "Model": "G8"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "G84",
    "Device": "G1050",
    "Model": "G84"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "G9",
    "Device": "G0130WW",
    "Model": "G9"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "G9",
    "Device": "G0130WW_SR",
    "Model": "G9"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "G9 PRO",
    "Device": "G0230WW",
    "Model": "G9 PRO"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "G9 PRO",
    "Device": "G0231WW",
    "Model": "G9 PRO"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "G90",
    "Device": "G0310WW",
    "Model": "G90"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "G90 PRO",
    "Device": "G0370WW",
    "Model": "G90 PRO"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "G91",
    "Device": "G0410WW",
    "Model": "G91"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "G91 Pro",
    "Device": "G0530WW",
    "Model": "G91 Pro"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "G91S",
    "Device": "G0550WW",
    "Model": "G91S"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "G91_Max",
    "Device": "G0690WW",
    "Model": "G91 Max"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "G93",
    "Device": "G0910",
    "Model": "G93"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "G95",
    "Device": "G1150",
    "Model": "G95"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "GRAND 5.5 HD",
    "Device": "BLU_GRAND_5_5_HD",
    "Model": "BLU GRAND 5.5 HD"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "Grand 5.5 HD II",
    "Device": "G210Q",
    "Model": "Grand 5.5 HD II"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "Grand Energy",
    "Device": "Grand_Energy",
    "Model": "Grand Energy"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "Grand M",
    "Device": "Grand_M",
    "Model": "Grand M"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "Grand M2",
    "Device": "G190",
    "Model": "Grand M2"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "Grand M2 LTE",
    "Device": "G0040LL",
    "Model": "Grand M2 LTE"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "Grand M2X",
    "Device": "G0040UU",
    "Model": "Grand M2X"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "Grand MAX",
    "Device": "Grand_Max",
    "Model": "Grand Max"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "Grand Mini",
    "Device": "G170Q",
    "Model": "Grand Mini"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "Grand X",
    "Device": "Grand_X",
    "Model": "Grand X"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "Grand X LTE",
    "Device": "BLU_Grand_X_LTE",
    "Model": "BLU Grand X LTE"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "Grand X LTE",
    "Device": "Grand_X_LTE",
    "Model": "Grand X LTE"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "Grand XL",
    "Device": "Grand_XL",
    "Model": "Grand XL"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "Grand XL LTE",
    "Device": "G0030",
    "Model": "Grand XL LTE"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "Grand_M2",
    "Device": "G190",
    "Model": "Grand M2"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "Grand_M2_LTE",
    "Device": "G0050",
    "Model": "Grand M2 LTE"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "Grand_X",
    "Device": "Grand_X",
    "Model": "Grand X"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "J10L",
    "Device": "J0140",
    "Model": "J10L"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "J10L",
    "Device": "J0150",
    "Model": "J10L"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "J12",
    "Device": "J0100",
    "Model": "J12"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "J12",
    "Device": "J0230",
    "Model": "J12"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "J13",
    "Device": "J0120",
    "Model": "J13"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "J5",
    "Device": "J0210",
    "Model": "J5"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "J6L",
    "Device": "J0110",
    "Model": "J6L"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "J6S",
    "Device": "J210EQ",
    "Model": "J6S"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "J7",
    "Device": "J0000LL_ATT_MX",
    "Model": "J7"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "J8L",
    "Device": "J0170",
    "Model": "J8L"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "J9L",
    "Device": "J0080WW",
    "Model": "J9L"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "J9L",
    "Device": "J0082WW",
    "Model": "J9L"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "J9L",
    "Device": "J0090WW",
    "Model": "J9L"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "J9L",
    "Device": "J0092WW",
    "Model": "J9L"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "K0010",
    "Device": "K0010",
    "Model": "BOLD K5"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "K0150",
    "Device": "K0150",
    "Model": "BOLD K30"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "K0170",
    "Device": "K0170",
    "Model": "BOLD K20"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "K10",
    "Device": "K0110",
    "Model": "K10"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "K2",
    "Device": "K0210",
    "Model": "K2"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "LIFE ONE X",
    "Device": "BLU_LIFE_ONE_X",
    "Model": "BLU LIFE ONE X"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "LIFE ONE X",
    "Device": "Life_One_X",
    "Model": "Life One X"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "LIFE ONE X2",
    "Device": "Life_One_X2",
    "Model": "Life One X2"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "LIFE ONE X2 MINI",
    "Device": "Life_One_X2_Mini",
    "Model": "Life One X2 Mini"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "LIFE XL",
    "Device": "BLU_LIFE_XL",
    "Model": "BLU LIFE XL"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "Life Mark",
    "Device": "BLU_LIFE_MARK",
    "Model": "BLU LIFE MARK"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "Life Max",
    "Device": "Life_Max",
    "Model": "Life Max"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "Life One X3",
    "Device": "L0150WW",
    "Model": "Life One X3"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "M10L",
    "Device": "M0178_ND",
    "Model": "M10L"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "M10L",
    "Device": "M0190WW",
    "Model": "M10L"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "M10L PLUS",
    "Device": "M0223",
    "Model": "M10L PLUS"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "M10L PLUS",
    "Device": "M0223_EX",
    "Model": "M10L PLUS"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "M10L PLUS",
    "Device": "M0223_ND",
    "Model": "M10L PLUS"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "M10L PLUS",
    "Device": "M0224",
    "Model": "M10L PLUS"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "M10L PLUS",
    "Device": "M0224_ND",
    "Model": "M10L PLUS"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "M10L Pro",
    "Device": "M0214_ND",
    "Model": "M10L Pro"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "M10L Pro",
    "Device": "M0215",
    "Model": "M10L Pro"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "M10L Pro",
    "Device": "M0215_MXT",
    "Model": "M10L Pro"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "M10L Pro",
    "Device": "M0215_ND",
    "Model": "M10L Pro"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "M10L Pro",
    "Device": "M0215_NDSK",
    "Model": "M10L Pro"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "M10L Pro",
    "Device": "M0215_SYN",
    "Model": "M10L Pro"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "M6",
    "Device": "M0030TT",
    "Model": "M6"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "M6",
    "Device": "M030P",
    "Model": "M6"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "M6 2021",
    "Device": "M0080WW",
    "Model": "M6 2021"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "M6 2021",
    "Device": "M0090WW",
    "Model": "M6 2021"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "M7",
    "Device": "M110EQ",
    "Model": "M7"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "M7L",
    "Device": "M0050LL",
    "Model": "M7L"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "M7i",
    "Device": "M0160WW",
    "Model": "M7i"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "M8L",
    "Device": "M0170WW",
    "Model": "M8L"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "M8L",
    "Device": "M0171WW",
    "Model": "M8L"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "M8L",
    "Device": "M0171WW_ND",
    "Model": "M8L"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "M8L",
    "Device": "M0172WW",
    "Model": "M8L"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "M8L",
    "Device": "M0173WW",
    "Model": "M8L"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "M8L",
    "Device": "M0174WW",
    "Model": "M8L"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "M8L",
    "Device": "M0174WW_ND",
    "Model": "M8L"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "M8L",
    "Device": "M0175WW_ND",
    "Model": "M8L"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "M8L",
    "Device": "M0176",
    "Model": "M8L"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "M8L",
    "Device": "M0176_EX",
    "Model": "M8L"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "M8L",
    "Device": "M0176_ND",
    "Model": "M8L"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "M8L 2022",
    "Device": "M0220WW",
    "Model": "M8L 2022"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "M8L 2022",
    "Device": "M0220WW_ND",
    "Model": "M8L 2022"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "M8L 2022",
    "Device": "M0222",
    "Model": "M8L 2022"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "M8L 2022",
    "Device": "M0222_EX",
    "Model": "M8L 2022"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "M8L 2022",
    "Device": "M0222_IMT",
    "Model": "M8L 2022"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "M8L PLUS",
    "Device": "M0209WW",
    "Model": "M8L PLUS"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "M8L PLUS",
    "Device": "M0210WW",
    "Model": "M8L PLUS"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "M8L PLUS",
    "Device": "M0213WW",
    "Model": "M8L Plus"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "M8L Plus",
    "Device": "M0209WW_ND",
    "Model": "M8L Plus"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "M8L Plus",
    "Device": "M0210WW_ND",
    "Model": "M8L PLUS"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "M8L Plus",
    "Device": "M0212WW_ND",
    "Model": "M8L Plus"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "M8L_PLUS",
    "Device": "M0208WW",
    "Model": "M8L PLUS"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "M8L_Plus",
    "Device": "M0213_ND",
    "Model": "M8L Plus"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "M8L_Plus",
    "Device": "M0213_SM",
    "Model": "M8L Plus"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "NEO ENERGY MINI",
    "Device": "BLU_NEO_ENERGY_MINI",
    "Model": "BLU NEO ENERGY MINI"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "NEO X",
    "Device": "BLU_NEO_X",
    "Model": "BLU NEO X"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "NEO X LTE",
    "Device": "BLU_NEO_X_LTE",
    "Model": "BLU NEO X LTE"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "NEO X MINI",
    "Device": "BLU_NEO_X_MINI",
    "Model": "BLU NEO X MINI"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "NEO X PLUS",
    "Device": "BLU_NEO_X_PLUS",
    "Model": "BLU NEO X PLUS"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "NEO XL",
    "Device": "BLU_NEO_XL",
    "Model": "BLU NEO XL"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "Neo X2",
    "Device": "Neo_X2",
    "Model": "Neo X2"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "PURE XL",
    "Device": "BLU_PURE_XL",
    "Model": "PURE XL"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "PURE XR",
    "Device": "BLU_Pure_XR",
    "Model": "Pure XR"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "Pure View",
    "Device": "P0050WW",
    "Model": "Pure View"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "R1 HD",
    "Device": "BLU_R1_HD",
    "Model": "BLU R1 HD"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "R1 HD",
    "Device": "R1_HD",
    "Model": "R1 HD"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "R1 PLUS",
    "Device": "R1_PLUS",
    "Model": "R1 PLUS"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "R1 Plus",
    "Device": "R1_PLUS",
    "Model": "R1 PLUS"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "R2 LTE",
    "Device": "R0150EE",
    "Model": "R2 LTE"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "R2 LTE",
    "Device": "R0170WW",
    "Model": "R2 LTE"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "R2 Plus",
    "Device": "R0190WW",
    "Model": "R2 Plus"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "R2_3G",
    "Device": "R010P",
    "Model": "R2 3G"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "S5",
    "Device": "S0480LL",
    "Model": "S5"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "S5",
    "Device": "S0480LL_ALTAN",
    "Model": "S5"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "S91",
    "Device": "S0690WW",
    "Model": "S91"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "S91 Pro",
    "Device": "S0730WW",
    "Model": "S91 Pro"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "S950P",
    "Device": "S950P",
    "Model": "Studio X9 HD"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "STUDIO 7.0 LTE",
    "Device": "blu_s0010tw",
    "Model": "BLU STUDIO 7.0 LTE"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "STUDIO 7.0 LTE",
    "Device": "blu_s0010uu",
    "Model": "BLU STUDIO 7.0 LTE"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "STUDIO C 8+8 LTE",
    "Device": "BLU_STUDIO_C_8_8_LTE",
    "Model": "BLU STUDIO C 8+8 LTE"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "STUDIO G",
    "Device": "BLU_STUDIO_G",
    "Model": "BLU STUDIO G"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "STUDIO G HD",
    "Device": "Studio_G_HD",
    "Model": "BLU Studio G HD"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "STUDIO G HD LTE",
    "Device": "Studio_G_HD_LTE",
    "Model": "Studio G HD LTE"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "STUDIO G PLUS",
    "Device": "Studio_G_Plus",
    "Model": "BLU STUDIO G PLUS"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "STUDIO G PLUS HD",
    "Device": "Studio_G_Plus_HD",
    "Model": "Studio G Plus HD"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "STUDIO M HD",
    "Device": "BLU_STUDIO_M_HD",
    "Model": "STUDIO M HD"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "STUDIO M LTE",
    "Device": "BLU_STUDIO_M_LTE",
    "Model": "STUDIO M LTE"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "STUDIO M4 PLUS",
    "Device": "S850U",
    "Model": "Studio M4 Plus"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "STUDIO MAX",
    "Device": "Studio_Max",
    "Model": "Studio Max"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "STUDIO ONE PLUS",
    "Device": "BLU_STUDIO_ONE_PLUS",
    "Model": "BLU STUDIO ONE PLUS"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "STUDIO SELFIE 2",
    "Device": "BLU_STUDIO_SELFIE_2",
    "Model": "BLU STUDIO SELFIE 2"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "STUDIO TOUCH",
    "Device": "BLU_Studio_Touch",
    "Model": "BLU Studio Touch"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "STUDIO XL LTE",
    "Device": "BLU_STUDIO_XL_LTE",
    "Model": "BLU STUDIO XL LTE"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "STUIDIO C 8+8",
    "Device": "BLU_STUDIO_C_8_8",
    "Model": "BLU STUDIO C 8+8"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "STUIDIO SELFIE 2",
    "Device": "BLU_STUDIO_SELFIE_2",
    "Model": "BLU STUDIO SELFIE 2"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "SUTDIO ENERGY 2",
    "Device": "BLU_STUDIO_ENERGY_2",
    "Model": "STUDIO ENERGY 2"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "Studio 5.5 HD",
    "Device": "S150",
    "Model": "STUDIO 5.5 HD"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "Studio C HD",
    "Device": "BLU_STUDIO_C_HD",
    "Model": "BLU STUDIO C HD"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "Studio C HD",
    "Device": "Studio_C_HD",
    "Model": "Studio C HD"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "Studio G HD",
    "Device": "STUDIO_G_HD",
    "Model": "STUDIO_G_HD"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "Studio G Mini",
    "Device": "S210",
    "Model": "Studio G Mini"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "Studio G2 HD",
    "Device": "Studio_G2_HD",
    "Model": "Studio G2 HD"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "Studio G3",
    "Device": "S770P",
    "Model": "Studio G3"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "Studio G4",
    "Device": "S870Q",
    "Model": "Studio G4"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "Studio J1",
    "Device": "Studio_J1",
    "Model": "Advance A4"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "Studio J1",
    "Device": "Studio_J1",
    "Model": "Studio J1"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "Studio J2",
    "Device": "Studio_J2",
    "Model": "Advance A5"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "Studio J2",
    "Device": "Studio_J2",
    "Model": "Studio J2"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "Studio J2",
    "Device": "Studio_J2",
    "Model": "Studio M5"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "Studio J5",
    "Device": "Studio_J5",
    "Model": "Studio J5"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "Studio J8",
    "Device": "Studio_J8",
    "Model": "Studio J8"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "Studio M5 Plus LTE",
    "Device": "S0390WW",
    "Model": "Studio M5 Plus LTE"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "Studio M6",
    "Device": "S730",
    "Model": "Studio M6"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "Studio Mega",
    "Device": "S910Q",
    "Model": "Studio Mega"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "Studio Mega",
    "Device": "Studio_Mega",
    "Model": "Studio Mega"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "Studio Mega LTE",
    "Device": "S0460WW",
    "Model": "Studio Mega LTE"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "Studio Mega LTE",
    "Device": "S0470WW",
    "Model": "Studio Mega LTE"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "Studio One",
    "Device": "BLU_STUDIO_ONE",
    "Model": "BLU STUDIO ONE"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "Studio Pro",
    "Device": "S750",
    "Model": "Studio Pro"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "Studio Selfie LTE",
    "Device": "BLU_STUDIO_SELFIE_LTE",
    "Model": "BLU STUDIO SELFIE LTE"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "Studio View",
    "Device": "S810",
    "Model": "Studio View"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "Studio View",
    "Device": "S810P",
    "Model": "Studio View"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "Studio View",
    "Device": "S812P",
    "Model": "Studio View"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "Studio View XL",
    "Device": "S790Q",
    "Model": "Studio View XL"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "Studio X Mini",
    "Device": "BLU_STUDIO_X_MINI",
    "Model": "BLU STUDIO X MINI"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "Studio X10",
    "Device": "S970EQ",
    "Model": "Studio X10"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "Studio X10 2022",
    "Device": "S011EQ",
    "Model": "Studio X10 2022"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "Studio X10+",
    "Device": "S990EQ",
    "Model": "Studio X10+"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "Studio X10L",
    "Device": "S0570WW",
    "Model": "Studio X10L"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "Studio X10L 2022",
    "Device": "S0590LL",
    "Model": "Studio X10L 2022"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "Studio X12",
    "Device": "S050EQ",
    "Model": "Studio X12"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "Studio X5",
    "Device": "S0610WW",
    "Model": "Studio X5"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "Studio X5 Max",
    "Device": "S0630WW",
    "Model": "Studio X5 Max"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "Studio X8 HD",
    "Device": "S532",
    "Model": "Studio X8 HD"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "Studio_J8M",
    "Device": "S0450WW",
    "Model": "Studio J8M"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "Studio_View",
    "Device": "S810P",
    "Model": "Studio View"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "Studio_XL_2",
    "Device": "Studio_XL_2",
    "Model": "Studio M6 LTE"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "Studio_XL_2",
    "Device": "Studio_XL_2",
    "Model": "Studio XL 2"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "T5",
    "Device": "T0040TT",
    "Model": "T5"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "T5",
    "Device": "T0050TT",
    "Model": "T5"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "T5 Plus",
    "Device": "T0060TT",
    "Model": "T5 Plus"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "T5 Plus",
    "Device": "T0070TT_TIGO",
    "Model": "T5 Plus"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "T6",
    "Device": "T0080TT",
    "Model": "T6"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "T6",
    "Device": "T0090TT",
    "Model": "T6"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "T6L",
    "Device": "T0120TT",
    "Model": "T6L"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "T6L",
    "Device": "T0130TT",
    "Model": "T6L"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "TOUCHBOOK M7",
    "Device": "BLU_TOUCHBOOK_M7",
    "Model": "BLU TOUCHBOOK M7"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "Tank Xtreme 4.0",
    "Device": "Tank_Xtreme_4_0",
    "Model": "Tank Xtreme 4.0"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "Tank Xtreme 5.0",
    "Device": "Tank_Xtreme_5_0",
    "Model": "Tank Xtreme 5.0"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "Tank Xtreme Pro",
    "Device": "T0010UU",
    "Model": "Tank Xtreme Pro"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "Tank_Xtreme",
    "Device": "T0030WW",
    "Model": "Tank Xtreme"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "Touchbook M7 Pro",
    "Device": "P290",
    "Model": "Touchbook M7 Pro"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "VIVO 5",
    "Device": "BLU_VIVO_5",
    "Model": "VIVO 5"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "VIVO 5R",
    "Device": "BLU_Vivo_5R",
    "Model": "Vivo 5R"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "VIVO 6",
    "Device": "BLU_Vivo_6",
    "Model": "Vivo 6"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "VIVO GO",
    "Device": "V0390WW",
    "Model": "VIVO GO"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "VIVO VI+",
    "Device": "V0310WW",
    "Model": "Vivo XI PLUS"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "VIVO VI+",
    "Device": "V0310WW",
    "Model": "Vivo XI+"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "VIVO XI",
    "Device": "V0330WW",
    "Model": "Vivo XI"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "VIVO XL",
    "Device": "BLU_VIVO_XL",
    "Model": "VIVO XL"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "View 5 Pro",
    "Device": "B170D",
    "Model": "B170D"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "Vivo 12 Pro",
    "Device": "V0670LL",
    "Model": "Vivo 12 Pro"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "Vivo 5 Mini",
    "Device": "Vivo_5_Mini",
    "Model": "Vivo 5 Mini"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "Vivo 8",
    "Device": "V0150UU",
    "Model": "Vivo 8"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "Vivo One Plus 2019",
    "Device": "V0370WW",
    "Model": "Vivo One Plus 2019"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "Vivo S",
    "Device": "V0160WW",
    "Model": "Vivo S"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "Vivo X",
    "Device": "V0230WW",
    "Model": "Vivo X"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "Vivo X WW",
    "Device": "V0230WW",
    "Model": "Vivo X"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "Vivo XI",
    "Device": "V0330WW",
    "Model": "Vivo XI"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "Vivo XI+",
    "Device": "V0310WW",
    "Model": "Vivo XI PLUS"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "Vivo XI+",
    "Device": "V0310WW",
    "Model": "Vivo XI+"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "Vivo XL3",
    "Device": "V0250WW",
    "Model": "Vivo XL3"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "Vivo XL3 Plus",
    "Device": "V0210WW",
    "Model": "Vivo XL3 Plus"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "Vivo XL4",
    "Device": "V0350WW",
    "Model": "Vivo XL4"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "Vivo_8L_UU",
    "Device": "V0190UU",
    "Model": "Vivo 8L"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "Vivo_8_LL",
    "Device": "V0150LL",
    "Model": "Vivo 8"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "Vivo_One_Plus",
    "Device": "V0290WW",
    "Model": "Vivo One Plus"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "X22",
    "Device": "X0010WW",
    "Model": "X22"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "X5",
    "Device": "X0020",
    "Model": "X5"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "X5 PLUS",
    "Device": "X0050",
    "Model": "X5 PLUS"
  },
  {
    "Retail Branding": "Blu",
    "Marketing Name": "X6",
    "Device": "X0060",
    "Model": "X6"
  },
  {
    "Retail Branding": "Bluboo",
    "Marketing Name": "D1",
    "Device": "BLUBOO_D1",
    "Model": "D1"
  },
  {
    "Retail Branding": "Bluboo",
    "Marketing Name": "D1_Pro",
    "Device": "D1_Pro",
    "Model": "D1_Pro"
  },
  {
    "Retail Branding": "Bluboo",
    "Marketing Name": "D2 Pro",
    "Device": "D2_Pro",
    "Model": "D2_Pro"
  },
  {
    "Retail Branding": "Bluboo",
    "Marketing Name": "D5",
    "Device": "D5",
    "Model": "D5"
  },
  {
    "Retail Branding": "Bluboo",
    "Marketing Name": "D5 Pro",
    "Device": "D5_Pro",
    "Model": "D5 Pro"
  },
  {
    "Retail Branding": "Bluboo",
    "Marketing Name": "D6",
    "Device": "D6",
    "Model": "D6"
  },
  {
    "Retail Branding": "Bluboo",
    "Marketing Name": "D6 Lite",
    "Device": "D6Lite",
    "Model": "D6 Lite"
  },
  {
    "Retail Branding": "Bluboo",
    "Marketing Name": "D6 Pro",
    "Device": "D6Pro",
    "Model": "D6 Pro"
  },
  {
    "Retail Branding": "Bluboo",
    "Marketing Name": "D6 SE",
    "Device": "D6_SE",
    "Model": "D6 SE"
  },
  {
    "Retail Branding": "Bluboo",
    "Marketing Name": "R2 Pro",
    "Device": "BLUBOO_R2_Pro",
    "Model": "R2 Pro"
  },
  {
    "Retail Branding": "Bluboo",
    "Marketing Name": "S1a",
    "Device": "S1a",
    "Model": "S1a"
  },
  {
    "Retail Branding": "Bluboo",
    "Marketing Name": "S2",
    "Device": "S2",
    "Model": "S2"
  },
  {
    "Retail Branding": "Bluboo",
    "Marketing Name": "S3",
    "Device": "S3",
    "Model": "S3"
  },
  {
    "Retail Branding": "Bluboo",
    "Marketing Name": "S8 Plus a",
    "Device": "S8_plus_a",
    "Model": "S8_plus_a"
  },
  {
    "Retail Branding": "Bluboo",
    "Marketing Name": "S8a",
    "Device": "BLUBOO_S8a",
    "Model": "S8a"
  },
  {
    "Retail Branding": "Bluboo",
    "Marketing Name": "X Pro",
    "Device": "X_Pro",
    "Model": "X Pro"
  },
  {
    "Retail Branding": "BlueTech",
    "Marketing Name": "MID1016BT001",
    "Device": "MID1016BT001",
    "Model": "MID1016BT001"
  },
  {
    "Retail Branding": "Bluebird",
    "Marketing Name": "BM180",
    "Device": "BM180",
    "Model": "BM180"
  },
  {
    "Retail Branding": "Bluebird",
    "Marketing Name": "CF550",
    "Device": "CF550",
    "Model": "CF550"
  },
  {
    "Retail Branding": "Bluebird",
    "Marketing Name": "EF400",
    "Device": "EF400",
    "Model": "EF400"
  },
  {
    "Retail Branding": "Bluebird",
    "Marketing Name": "EF401",
    "Device": "EF401",
    "Model": "EF401"
  },
  {
    "Retail Branding": "Bluebird",
    "Marketing Name": "EF401",
    "Device": "EF401",
    "Model": "EF401_RU"
  },
  {
    "Retail Branding": "Bluebird",
    "Marketing Name": "EF500",
    "Device": "EF500",
    "Model": "EF500"
  },
  {
    "Retail Branding": "Bluebird",
    "Marketing Name": "EF501",
    "Device": "EF501",
    "Model": "EF501"
  },
  {
    "Retail Branding": "Bluebird",
    "Marketing Name": "EF501R",
    "Device": "EF501",
    "Model": "EF501"
  },
  {
    "Retail Branding": "Bluebird",
    "Marketing Name": "EF501R",
    "Device": "EF501",
    "Model": "EF501R"
  },
  {
    "Retail Branding": "Bluebird",
    "Marketing Name": "EF501R",
    "Device": "EF501",
    "Model": "EF501R_RU"
  },
  {
    "Retail Branding": "Bluebird",
    "Marketing Name": "EF550",
    "Device": "EF550",
    "Model": "EF550"
  },
  {
    "Retail Branding": "Bluebird",
    "Marketing Name": "EF550R",
    "Device": "EF550R",
    "Model": "EF550R"
  },
  {
    "Retail Branding": "Bluebird",
    "Marketing Name": "EF551",
    "Device": "EF551",
    "Model": "EF551"
  },
  {
    "Retail Branding": "Bluebird",
    "Marketing Name": "EK430",
    "Device": "EK430",
    "Model": "EK430"
  },
  {
    "Retail Branding": "Bluebird",
    "Marketing Name": "HF450",
    "Device": "HF450",
    "Model": "HF450"
  },
  {
    "Retail Branding": "Bluebird",
    "Marketing Name": "HF550",
    "Device": "HF550",
    "Model": "HF550"
  },
  {
    "Retail Branding": "Bluebird",
    "Marketing Name": "HF550",
    "Device": "HF550",
    "Model": "HF550_RU"
  },
  {
    "Retail Branding": "Bluebird",
    "Marketing Name": "HF550X",
    "Device": "EF550",
    "Model": "HF550x"
  },
  {
    "Retail Branding": "Bluebird",
    "Marketing Name": "RP350",
    "Device": "RP350",
    "Model": "RP350"
  },
  {
    "Retail Branding": "Bluebird",
    "Marketing Name": "RT080",
    "Device": "RT080",
    "Model": "RT080"
  },
  {
    "Retail Branding": "Bluebird",
    "Marketing Name": "RT103",
    "Device": "RT103",
    "Model": "RT103"
  },
  {
    "Retail Branding": "Bluebird",
    "Marketing Name": "S10",
    "Device": "S10",
    "Model": "S10"
  },
  {
    "Retail Branding": "Bluebird",
    "Marketing Name": "S20",
    "Device": "S20",
    "Model": "S20"
  },
  {
    "Retail Branding": "Bluebird",
    "Marketing Name": "S50",
    "Device": "S50",
    "Model": "S50"
  },
  {
    "Retail Branding": "Bluebird",
    "Marketing Name": "S70",
    "Device": "S70",
    "Model": "S70"
  },
  {
    "Retail Branding": "Bluebird",
    "Marketing Name": "SF550",
    "Device": "SF550",
    "Model": "SF550"
  },
  {
    "Retail Branding": "Bluebird",
    "Marketing Name": "SF650",
    "Device": "SF650",
    "Model": "SF650"
  },
  {
    "Retail Branding": "Bluebird",
    "Marketing Name": "ST080",
    "Device": "ST080",
    "Model": "ST080"
  },
  {
    "Retail Branding": "Bluebird",
    "Marketing Name": "ST103",
    "Device": "ST103",
    "Model": "ST103"
  },
  {
    "Retail Branding": "Bluebird",
    "Marketing Name": "T10",
    "Device": "T10",
    "Model": "T10"
  },
  {
    "Retail Branding": "Bluebird",
    "Marketing Name": "T30",
    "Device": "T30",
    "Model": "T30"
  },
  {
    "Retail Branding": "Bluebird",
    "Marketing Name": "VF550",
    "Device": "VF550",
    "Model": "VF550"
  },
  {
    "Retail Branding": "Bluebird",
    "Marketing Name": "VF550",
    "Device": "VF550",
    "Model": "VF550_RU"
  },
  {
    "Retail Branding": "Bluebird",
    "Marketing Name": "VX500",
    "Device": "VX500",
    "Model": "VX500"
  },
  {
    "Retail Branding": "Bluebird",
    "Marketing Name": "X40",
    "Device": "X40",
    "Model": "X40"
  },
  {
    "Retail Branding": "Bluedigit",
    "Marketing Name": "RAVOZ R4",
    "Device": "RAVOZ_R4",
    "Model": "RAVOZ R4"
  },
  {
    "Retail Branding": "Bluedigit",
    "Marketing Name": "RAVOZ R7",
    "Device": "RAVOZ_R7",
    "Model": "RAVOZ R7"
  },
  {
    "Retail Branding": "Bluedigit",
    "Marketing Name": "RAVOZ R8",
    "Device": "RAVOZ_R8",
    "Model": "RAVOZ R8"
  },
  {
    "Retail Branding": "Bluedigit",
    "Marketing Name": "RAVOZ_R4",
    "Device": "RAVOZ_R4",
    "Model": "RAVOZ R4"
  },
  {
    "Retail Branding": "Bluedigit",
    "Marketing Name": "RAVOZ_R9",
    "Device": "RAVOZ_R9",
    "Model": "RAVOZ R9"
  },
  {
    "Retail Branding": "Bluedot",
    "Marketing Name": "BNT-1013",
    "Device": "BNT-1013",
    "Model": "BNT-1013"
  },
  {
    "Retail Branding": "Bluedot",
    "Marketing Name": "BNT-700K",
    "Device": "BNT-700K",
    "Model": "BNT-700K"
  },
  {
    "Retail Branding": "Bluedot",
    "Marketing Name": "BNT-801W",
    "Device": "BNT_801W",
    "Model": "BNT-801W"
  },
  {
    "Retail Branding": "Bluedot",
    "Marketing Name": "BNT-802",
    "Device": "BNT-802",
    "Model": "BNT-802"
  },
  {
    "Retail Branding": "Bluedot",
    "Marketing Name": "BNT_1012W",
    "Device": "BNT_1012W",
    "Model": "BNT-1012"
  },
  {
    "Retail Branding": "Bluemake",
    "Marketing Name": "BM-12WTN",
    "Device": "BM-12WTN",
    "Model": "BM-12WTN"
  },
  {
    "Retail Branding": "Bluesky",
    "Marketing Name": "BSS45",
    "Device": "BSS45",
    "Model": "BSS45"
  },
  {
    "Retail Branding": "Bluesky",
    "Marketing Name": "BSS50",
    "Device": "BSS50",
    "Model": "BSS50"
  },
  {
    "Retail Branding": "Bluewater",
    "Marketing Name": "L1108_EU_FW19",
    "Device": "L1108_EU_FW19",
    "Model": "L1108_EU_FW19"
  },
  {
    "Retail Branding": "Bluewater",
    "Marketing Name": "L1108_NEU_FW19",
    "Device": "L1108_EU_FW19",
    "Model": "L1108_EU_FW19"
  },
  {
    "Retail Branding": "Bluslate",
    "Marketing Name": "Bluslate8",
    "Device": "Bluslate8",
    "Model": "Bluslate8"
  },
  {
    "Retail Branding": "Bluslate",
    "Marketing Name": "Bluslate9",
    "Device": "Bluslate9",
    "Model": "Bluslate9"
  },
  {
    "Retail Branding": "Bmobility",
    "Marketing Name": "Belle",
    "Device": "Belle",
    "Model": "Belle"
  },
  {
    "Retail Branding": "Bmobility",
    "Marketing Name": "Benji",
    "Device": "Benji",
    "Model": "Benji"
  },
  {
    "Retail Branding": "Bmobility",
    "Marketing Name": "ORION TG07",
    "Device": "Bmobile_ORION_TG07",
    "Model": "ORION_TG07"
  },
  {
    "Retail Branding": "Booken",
    "Marketing Name": "Cybook Tablet",
    "Device": "cybtt10_bk",
    "Model": "Cybook-Tablet"
  },
  {
    "Retail Branding": "Boost",
    "Marketing Name": "Cabana",
    "Device": "Cabana",
    "Model": "Cabana"
  },
  {
    "Retail Branding": "Boost",
    "Marketing Name": "Cabana",
    "Device": "Cabana_D001",
    "Model": "Cabana"
  },
  {
    "Retail Branding": "Boost",
    "Marketing Name": "Moova Shuffle",
    "Device": "MoovaShuffle",
    "Model": "MoovaShuffle"
  },
  {
    "Retail Branding": "Boost",
    "Marketing Name": "Moova Soul",
    "Device": "Moova-Soul",
    "Model": "Moova-Soul"
  },
  {
    "Retail Branding": "Boost",
    "Marketing Name": "Pulse Glide",
    "Device": "PulseGlide",
    "Model": "Pulse Glide"
  },
  {
    "Retail Branding": "Boost",
    "Marketing Name": "Pulse Jive",
    "Device": "Jive",
    "Model": "Jive"
  },
  {
    "Retail Branding": "Boost",
    "Marketing Name": "Pulse Power",
    "Device": "Power",
    "Model": "Power"
  },
  {
    "Retail Branding": "Boost",
    "Marketing Name": "Pulse Retro",
    "Device": "M450B",
    "Model": "Pulse Retro"
  },
  {
    "Retail Branding": "Boost",
    "Marketing Name": "Pulse Sky",
    "Device": "Y551B",
    "Model": "Pulse Sky"
  },
  {
    "Retail Branding": "Boost",
    "Marketing Name": "Shaker-Slim",
    "Device": "Shaker-Slim",
    "Model": "Shaker-Slim"
  },
  {
    "Retail Branding": "Boost",
    "Marketing Name": "ShakerBeat",
    "Device": "ShakerBeat",
    "Model": "ShakerBeat"
  },
  {
    "Retail Branding": "Boost",
    "Marketing Name": "StrikaPlay",
    "Device": "StrikaPlay",
    "Model": "StrikaPlay"
  },
  {
    "Retail Branding": "Boost",
    "Marketing Name": "X4503",
    "Device": "X4503",
    "Model": "X4503"
  },
  {
    "Retail Branding": "Borqs",
    "Marketing Name": "Falcon",
    "Device": "falcon",
    "Model": "falcon"
  },
  {
    "Retail Branding": "Bosii",
    "Marketing Name": "Touch-Screen-Monitor",
    "Device": "G2",
    "Model": "G2"
  },
  {
    "Retail Branding": "Bouygues Telecom",
    "Marketing Name": "Bbox Brooklyn 4K",
    "Device": "HMB9213NW",
    "Model": "Bouygtel4K"
  },
  {
    "Retail Branding": "Bouygues Telecom",
    "Marketing Name": "Bbox Miami",
    "Device": "HMB4213H",
    "Model": "BouygtelTV"
  },
  {
    "Retail Branding": "Bouygues Telecom",
    "Marketing Name": "BboxTV",
    "Device": "UZW4020BYT",
    "Model": "BboxTV"
  },
  {
    "Retail Branding": "Bouygues Telecom",
    "Marketing Name": "BboxTV-4A",
    "Device": "HMB2013CW22",
    "Model": "BboxTV-4A"
  },
  {
    "Retail Branding": "Bouygues Telecom",
    "Marketing Name": "Bs 451",
    "Device": "Bs_451",
    "Model": "Bs 451"
  },
  {
    "Retail Branding": "Bphone",
    "Marketing Name": "Bphone_A40",
    "Device": "Bphone_A40",
    "Model": "Bphone A40"
  },
  {
    "Retail Branding": "Bphone",
    "Marketing Name": "Bphone_A85_5G",
    "Device": "Bphone_A85_5G",
    "Model": "Bphone A85 5G"
  },
  {
    "Retail Branding": "Bphone",
    "Marketing Name": "Bphone_A_Series",
    "Device": "Bphone_A_Series",
    "Model": "Bphone A Series"
  },
  {
    "Retail Branding": "BrailleNote",
    "Marketing Name": "gryphon",
    "Device": "gryphon",
    "Model": "BrailleNote Touch +"
  },
  {
    "Retail Branding": "Brain",
    "Marketing Name": "Natural AI Phone",
    "Device": "NaturalAIPhone",
    "Model": "BGX5"
  },
  {
    "Retail Branding": "Brandcode",
    "Marketing Name": "L1Fa",
    "Device": "L1Fa",
    "Model": "L1Fa"
  },
  {
    "Retail Branding": "Brandcode",
    "Marketing Name": "L1f-pluss",
    "Device": "L1f_pluss",
    "Model": "L1f-pluss"
  },
  {
    "Retail Branding": "Brandcode",
    "Marketing Name": "L5F_pro",
    "Device": "L5F_pro",
    "Model": "L5F_pro"
  },
  {
    "Retail Branding": "Brandt",
    "Marketing Name": "B-ONE",
    "Device": "B-ONE",
    "Model": "B-ONE"
  },
  {
    "Retail Branding": "Brandt",
    "Marketing Name": "BPRIME",
    "Device": "BPRIME",
    "Model": "BPRIME"
  },
  {
    "Retail Branding": "Brandt",
    "Marketing Name": "BPRIMES",
    "Device": "BPRIMES",
    "Model": "BPRIMES"
  },
  {
    "Retail Branding": "Brandt",
    "Marketing Name": "BRANDT FHD TV",
    "Device": "takao",
    "Model": "BRANDT FHD TV"
  },
  {
    "Retail Branding": "Brandt",
    "Marketing Name": "BRANDT UHD TV",
    "Device": "OD0M_EA_T32",
    "Model": "BRANDT UHD TV"
  },
  {
    "Retail Branding": "Brandt",
    "Marketing Name": "BSTAR",
    "Device": "BSTAR",
    "Model": "BSTAR"
  },
  {
    "Retail Branding": "Brandt",
    "Marketing Name": "BSTAR+",
    "Device": "BSTAR_PLUS",
    "Model": "BSTAR+"
  },
  {
    "Retail Branding": "Brandt",
    "Marketing Name": "R3",
    "Device": "R3",
    "Model": "R3"
  },
  {
    "Retail Branding": "Brandt",
    "Marketing Name": "R3_GTV",
    "Device": "R3_GTV",
    "Model": "R3G"
  },
  {
    "Retail Branding": "Brandt",
    "Marketing Name": "R4",
    "Device": "R4",
    "Model": "R4"
  },
  {
    "Retail Branding": "Brandt",
    "Marketing Name": "R4_GTV",
    "Device": "R4_GTV",
    "Model": "R4G"
  },
  {
    "Retail Branding": "Brandt",
    "Marketing Name": "vileparle",
    "Device": "vileparle",
    "Model": "R6G"
  },
  {
    "Retail Branding": "Brantel",
    "Marketing Name": "E-tel_i10",
    "Device": "E-tel_i10",
    "Model": "E-tel i10"
  },
  {
    "Retail Branding": "Brantel",
    "Marketing Name": "Q30",
    "Device": "Q30",
    "Model": "Q30"
  },
  {
    "Retail Branding": "Brasiltec",
    "Marketing Name": "B1",
    "Device": "B1",
    "Model": "B1"
  },
  {
    "Retail Branding": "Brasiltec",
    "Marketing Name": "B1_Max",
    "Device": "B1_Max",
    "Model": "B1_Max"
  },
  {
    "Retail Branding": "BraveTechs",
    "Marketing Name": "BraveT3Max",
    "Device": "T3Max",
    "Model": "T3 Max"
  },
  {
    "Retail Branding": "BraveTechs",
    "Marketing Name": "BraveT3Ultra",
    "Device": "T3Ultra",
    "Model": "T3 Ultra"
  },
  {
    "Retail Branding": "BraveTechs",
    "Marketing Name": "BraveT4Lite",
    "Device": "BraveT4Lite",
    "Model": "T4 Lite"
  },
  {
    "Retail Branding": "BraveTechs",
    "Marketing Name": "BraveT4Pro",
    "Device": "T4_Pro",
    "Model": "T4 Pro"
  },
  {
    "Retail Branding": "BraveTechs",
    "Marketing Name": "Brave_T3Pro",
    "Device": "T3_Pro",
    "Model": "T3 Pro"
  },
  {
    "Retail Branding": "Bravis",
    "Marketing Name": "A509_Jeans",
    "Device": "A509_Jeans",
    "Model": "A509_Jeans"
  },
  {
    "Retail Branding": "Bravis",
    "Marketing Name": "A510_Jeans_4G",
    "Device": "A510_Jeans_4G",
    "Model": "A510_Jeans_4G"
  },
  {
    "Retail Branding": "Bravis",
    "Marketing Name": "A511 Harmony",
    "Device": "A511_Harmony",
    "Model": "A511 Harmony"
  },
  {
    "Retail Branding": "Bravis",
    "Marketing Name": "A512 Harmony Pro",
    "Device": "A512_Harmony_Pro",
    "Model": "A512 Harmony Pro"
  },
  {
    "Retail Branding": "Bravis",
    "Marketing Name": "G7H",
    "Device": "ikebukuro",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "Bravis",
    "Marketing Name": "H7000",
    "Device": "samseong",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "Bravis",
    "Marketing Name": "M9",
    "Device": "M9",
    "Model": "M9"
  },
  {
    "Retail Branding": "Bravis",
    "Marketing Name": "N1-570 Space",
    "Device": "N1-570-Space",
    "Model": "N1-570 Space"
  },
  {
    "Retail Branding": "Bravis",
    "Marketing Name": "N1_550_Cruiser",
    "Device": "N1_550_Cruiser",
    "Model": "N1_550_Cruiser"
  },
  {
    "Retail Branding": "Bravis",
    "Marketing Name": "N1_552_Skyline",
    "Device": "N1_552_Skyline",
    "Model": "N1-552 Skyline"
  },
  {
    "Retail Branding": "Bravis",
    "Marketing Name": "NB108",
    "Device": "NB108",
    "Model": "NB108"
  },
  {
    "Retail Branding": "Bravis",
    "Marketing Name": "NB753",
    "Device": "NB753",
    "Model": "NB753"
  },
  {
    "Retail Branding": "Bravis",
    "Marketing Name": "NB76",
    "Device": "NB76",
    "Model": "NB76"
  },
  {
    "Retail Branding": "Bravis",
    "Marketing Name": "NB851",
    "Device": "NB851",
    "Model": "NB851"
  },
  {
    "Retail Branding": "Bravis",
    "Marketing Name": "NB871",
    "Device": "NB871",
    "Model": "NB871"
  },
  {
    "Retail Branding": "Bravis",
    "Marketing Name": "X500",
    "Device": "BRAVIS_X500",
    "Model": "BRAVIS X500"
  },
  {
    "Retail Branding": "Bravis",
    "Marketing Name": "bravis_A506",
    "Device": "bravis_A506",
    "Model": "bravis_A506"
  },
  {
    "Retail Branding": "Bravva",
    "Marketing Name": "DM-901",
    "Device": "DM-901",
    "Model": "DM-901"
  },
  {
    "Retail Branding": "Bravva",
    "Marketing Name": "Impress_Aero",
    "Device": "Impress_Aero",
    "Model": "Impress_Aero"
  },
  {
    "Retail Branding": "Bridgestone_Mobility_Solutions",
    "Marketing Name": "PRO X",
    "Device": "poseidon",
    "Model": "PRO X"
  },
  {
    "Retail Branding": "Brighton",
    "Marketing Name": "MAL-FWTVTB",
    "Device": "MAL-FWTVTB",
    "Model": "MAL-FWTVTB"
  },
  {
    "Retail Branding": "Brightside",
    "Marketing Name": "BS101",
    "Device": "BS101",
    "Model": "BS101"
  },
  {
    "Retail Branding": "Brightside",
    "Marketing Name": "BS701",
    "Device": "BS701",
    "Model": "BS701"
  },
  {
    "Retail Branding": "Brightside",
    "Marketing Name": "KS_T01",
    "Device": "KS_T01",
    "Model": "KS_T01"
  },
  {
    "Retail Branding": "Brightstar",
    "Marketing Name": "C8",
    "Device": "C8",
    "Model": "C8"
  },
  {
    "Retail Branding": "Brightstar",
    "Marketing Name": "M8046IU",
    "Device": "M8047IU",
    "Model": "M8047IU"
  },
  {
    "Retail Branding": "Briotouch",
    "Marketing Name": "IFP_ADPM",
    "Device": "t7_an400",
    "Model": "BrioTouch"
  },
  {
    "Retail Branding": "Briotouch",
    "Marketing Name": "ULTRA-PLUS-BR",
    "Device": "ULTRA-PLUS-BR",
    "Model": "ULTRA-PLUS-BR"
  },
  {
    "Retail Branding": "Brisanet",
    "Marketing Name": "brisaboxTV",
    "Device": "IMTM4000RA",
    "Model": "IMTM4000RA"
  },
  {
    "Retail Branding": "Britania",
    "Marketing Name": "Britania Smart TV",
    "Device": "sunnyvale",
    "Model": "Britania Smart TV"
  },
  {
    "Retail Branding": "Britania",
    "Marketing Name": "Britania Smart plus TV",
    "Device": "SW6H",
    "Model": "Britania Smart plus TV"
  },
  {
    "Retail Branding": "British Telecom",
    "Marketing Name": "BT Home SmartPhone III",
    "Device": "BT_Home_SmartPhone_III",
    "Model": "E81"
  },
  {
    "Retail Branding": "British Telecom",
    "Marketing Name": "HomeSmartphone d800",
    "Device": "d800",
    "Model": "BT Home SmartPhone S II"
  },
  {
    "Retail Branding": "Brondi",
    "Marketing Name": "620SZ",
    "Device": "G223_JH",
    "Model": "Brondi 620 SZ"
  },
  {
    "Retail Branding": "Brondi",
    "Marketing Name": "730 4G HD",
    "Device": "Brondi_730_4G_HD",
    "Model": "Brondi_730_4G_HD"
  },
  {
    "Retail Branding": "Brondi",
    "Marketing Name": "850_4G",
    "Device": "850_4G",
    "Model": "850_4G"
  },
  {
    "Retail Branding": "Brondi",
    "Marketing Name": "AMICO SMARTPHONE POCKET",
    "Device": "AMICO_SMARTPHONE_POCKET",
    "Model": "AMICO SMARTPHONE POCKET"
  },
  {
    "Retail Branding": "Brondi",
    "Marketing Name": "AMICO SMARTPHONE XL",
    "Device": "AMICO_SMARTPHONE_XL",
    "Model": "AMICO SMARTPHONE XL"
  },
  {
    "Retail Branding": "Brondi",
    "Marketing Name": "AMICO_SMARTPHONE_XS_EEA",
    "Device": "AMICO_SMARTPHONE_XS",
    "Model": "AMICO SMARTPHONE XS"
  },
  {
    "Retail Branding": "Brondi",
    "Marketing Name": "AMICO_VERO_4G_EEA",
    "Device": "AMICO_VERO_4G",
    "Model": "AMICO_VERO_4G"
  },
  {
    "Retail Branding": "Brondi",
    "Marketing Name": "MIDNIGHT_SKY_EEA",
    "Device": "MIDNIGHT_SKY_EEA",
    "Model": "MIDNIGHT_SKY"
  },
  {
    "Retail Branding": "Brookstone",
    "Marketing Name": "Android TV",
    "Device": "R1",
    "Model": "ATV R1"
  },
  {
    "Retail Branding": "Brown",
    "Marketing Name": "Brown2",
    "Device": "I9080_PH1",
    "Model": "brown 2"
  },
  {
    "Retail Branding": "Brown",
    "Marketing Name": "brown tab1",
    "Device": "brown_tab1",
    "Model": "brown tab1"
  },
  {
    "Retail Branding": "Bubblegum",
    "Marketing Name": "B1Teen",
    "Device": "B1Teen",
    "Model": "B1Teen"
  },
  {
    "Retail Branding": "Bubblegum",
    "Marketing Name": "BUB6R-3T",
    "Device": "BUB6R-3T",
    "Model": "BUB6R-3T"
  },
  {
    "Retail Branding": "Bubblegum",
    "Marketing Name": "Bubblegum",
    "Device": "Bubblegum",
    "Model": "Bubblegum"
  },
  {
    "Retail Branding": "Bubblegum",
    "Marketing Name": "Junior_7",
    "Device": "Junior_7",
    "Model": "Junior_7"
  },
  {
    "Retail Branding": "Buddy Phone",
    "Marketing Name": "P1",
    "Device": "BP",
    "Model": "P1"
  },
  {
    "Retail Branding": "Buddy Phone",
    "Marketing Name": "P2",
    "Device": "P2",
    "Model": "P2"
  },
  {
    "Retail Branding": "Buddy Phone",
    "Marketing Name": "P3",
    "Device": "P3",
    "Model": "P3"
  },
  {
    "Retail Branding": "Bullitt Group",
    "Marketing Name": "Cat S60",
    "Device": "CatS60",
    "Model": "S60"
  },
  {
    "Retail Branding": "Bullitt Group",
    "Marketing Name": "CatS31",
    "Device": "CatS31",
    "Model": "S31"
  },
  {
    "Retail Branding": "Bullitt Group",
    "Marketing Name": "S30",
    "Device": "CatS30",
    "Model": "S30"
  },
  {
    "Retail Branding": "Bunbungame",
    "Marketing Name": "KALOS",
    "Device": "FG6Q_N",
    "Model": "KALOS"
  },
  {
    "Retail Branding": "Bunbungame",
    "Marketing Name": "MiSS",
    "Device": "MiSS",
    "Model": "MiSS"
  },
  {
    "Retail Branding": "Bundy Mobile",
    "Marketing Name": "BT7_Pro",
    "Device": "BT7_Pro",
    "Model": "BT7 Pro"
  },
  {
    "Retail Branding": "Bundy Mobile",
    "Marketing Name": "BTOUCH7_PLUS",
    "Device": "BTOUCH7_PLUS",
    "Model": "BTOUCH7_PLUS"
  },
  {
    "Retail Branding": "Bush",
    "Marketing Name": "5 android",
    "Device": "ac50cpl",
    "Model": "Bush 5 Android"
  },
  {
    "Retail Branding": "Bush",
    "Marketing Name": "BUSH",
    "Device": "ewha",
    "Model": "AQUOS-TVE19L"
  },
  {
    "Retail Branding": "Bush",
    "Marketing Name": "BUSH",
    "Device": "ewha",
    "Model": "BUSH-TVE19L"
  },
  {
    "Retail Branding": "Bush",
    "Marketing Name": "BUSH SPIRA B3 10 TABLET",
    "Device": "ac101boxv2",
    "Model": "BUSH SPIRA B3 10 TABLET"
  },
  {
    "Retail Branding": "Bush",
    "Marketing Name": "BUSH SPIRA B3 10 TABLET",
    "Device": "ac101boxv3",
    "Model": "BUSH SPIRA B3 10 TABLET"
  },
  {
    "Retail Branding": "Bush",
    "Marketing Name": "BUSH SPIRA B3 8 TABLET",
    "Device": "ac80oxv2",
    "Model": "BUSH SPIRA B3 8 TABLET"
  },
  {
    "Retail Branding": "Bush",
    "Marketing Name": "BUSH SPIRA B5.5 POWER",
    "Device": "ac55crp",
    "Model": "BUSH SPIRA B5.5 POWER"
  },
  {
    "Retail Branding": "Bush",
    "Marketing Name": "Bush",
    "Device": "sindang",
    "Model": "BUSH-TVE19N"
  },
  {
    "Retail Branding": "Bush",
    "Marketing Name": "Bush10Nou",
    "Device": "Bush10Nou",
    "Model": "Bush10Nou"
  },
  {
    "Retail Branding": "Bush",
    "Marketing Name": "MyTablet 79",
    "Device": "ac79bu",
    "Model": "BUSH 7.85 TABLET"
  },
  {
    "Retail Branding": "Bush",
    "Marketing Name": "SPIRA B3 5",
    "Device": "ac50co",
    "Model": "BUSH SPIRA B3 5"
  },
  {
    "Retail Branding": "Bush",
    "Marketing Name": "SPIRA B4 5",
    "Device": "ac50fhe",
    "Model": "BUSH SPIRA B4 5"
  },
  {
    "Retail Branding": "Bush",
    "Marketing Name": "SPIRA B4 5.5",
    "Device": "ac55bhe",
    "Model": "BUSH SPIRA B4 5.5"
  },
  {
    "Retail Branding": "Bush",
    "Marketing Name": "SPIRA D3 5.5",
    "Device": "ac55diplus",
    "Model": "BUSH SPIRA D3 5.5"
  },
  {
    "Retail Branding": "Bush",
    "Marketing Name": "SPIRA D4 5",
    "Device": "ac50bco",
    "Model": "BUSH SPIRA D4 5"
  },
  {
    "Retail Branding": "Bush",
    "Marketing Name": "SPIRA E3X 5.5",
    "Device": "ac55di2plus",
    "Model": "BUSH SPIRA E3X 5.5"
  },
  {
    "Retail Branding": "Bush",
    "Marketing Name": "SPIRA E4X",
    "Device": "ac55diselfie",
    "Model": "BUSH SPIRA E4X"
  },
  {
    "Retail Branding": "Bush",
    "Marketing Name": "Spira B2 10 tablet",
    "Device": "ac101box",
    "Model": "Bush Spira B2 10 tablet"
  },
  {
    "Retail Branding": "Bush",
    "Marketing Name": "Spira B2 7 tablet",
    "Device": "ac70ox",
    "Model": "Bush Spira B2 7 tablet"
  },
  {
    "Retail Branding": "Bush",
    "Marketing Name": "Spira D4 5.5",
    "Device": "ac55bco",
    "Model": "BUSH SPIRA D4 5.5"
  },
  {
    "Retail Branding": "Bush",
    "Marketing Name": "Spira E2X 5\\'\\'",
    "Device": "ac50dis",
    "Model": "Bush Spira E2X 5\" Smartphone"
  },
  {
    "Retail Branding": "Bytello",
    "Marketing Name": "general_broad_3588",
    "Device": "oversea_v",
    "Model": "bytello_edla"
  },
  {
    "Retail Branding": "Byxsb",
    "Marketing Name": "X134",
    "Device": "X134",
    "Model": "X134"
  },
  {
    "Retail Branding": "Byxsb",
    "Marketing Name": "X134L",
    "Device": "X134L",
    "Model": "X134L"
  },
  {
    "Retail Branding": "Byxsb",
    "Marketing Name": "X134L_EEA",
    "Device": "X134L",
    "Model": "X134L"
  },
  {
    "Retail Branding": "C&M",
    "Marketing Name": "SH950C-CM",
    "Device": "stb_catv_cnmuhd",
    "Model": "SH950C-CM"
  },
  {
    "Retail Branding": "C&M",
    "Marketing Name": "Smart TV II",
    "Device": "stb_catv_cnm",
    "Model": "SX930C-CC"
  },
  {
    "Retail Branding": "C5 Mobile",
    "Marketing Name": "NOATAB",
    "Device": "NOATAB",
    "Model": "NOATAB"
  },
  {
    "Retail Branding": "C5 Mobile",
    "Marketing Name": "Noa X Power",
    "Device": "noaXPower",
    "Model": "noaXPower"
  },
  {
    "Retail Branding": "C5 Mobile",
    "Marketing Name": "noa X Plus",
    "Device": "noa_X_plus",
    "Model": "noa X plus"
  },
  {
    "Retail Branding": "C5 Mobile",
    "Marketing Name": "noa X2 Plus",
    "Device": "noa_x2_Plus",
    "Model": "noa X2 Plus"
  },
  {
    "Retail Branding": "C5 Mobile",
    "Marketing Name": "noa_G1",
    "Device": "noa_G1",
    "Model": "noa_G1"
  },
  {
    "Retail Branding": "CAIXUN",
    "Marketing Name": "APAC",
    "Device": "tamachi",
    "Model": "AiPlus2K"
  },
  {
    "Retail Branding": "CAIXUN",
    "Marketing Name": "Amstrong",
    "Device": "cottongreen",
    "Model": "Amstrong"
  },
  {
    "Retail Branding": "CAIXUN",
    "Marketing Name": "Apollo Premium TV",
    "Device": "nagata",
    "Model": "Apollo Premium TV"
  },
  {
    "Retail Branding": "CAIXUN",
    "Marketing Name": "Australian/EU",
    "Device": "yeongdeungpo",
    "Model": "AiPlus4K"
  },
  {
    "Retail Branding": "CAIXUN",
    "Marketing Name": "CAIXUN SMART TV",
    "Device": "marina",
    "Model": "CAIXUN SMART TV"
  },
  {
    "Retail Branding": "CAIXUN",
    "Marketing Name": "Caixun TV",
    "Device": "marina",
    "Model": "Caixun TV"
  },
  {
    "Retail Branding": "CAIXUN",
    "Marketing Name": "Caixun TV",
    "Device": "nagata",
    "Model": "Caixun TV"
  },
  {
    "Retail Branding": "CAIXUN",
    "Marketing Name": "Canada",
    "Device": "yeongdeungpo",
    "Model": "AiPlus4K"
  },
  {
    "Retail Branding": "CAIXUN",
    "Marketing Name": "Columbia",
    "Device": "marina",
    "Model": "Apollo Premium4K TV"
  },
  {
    "Retail Branding": "CAIXUN",
    "Marketing Name": "Columbia",
    "Device": "patrick",
    "Model": "Aiplus4K"
  },
  {
    "Retail Branding": "CAIXUN",
    "Marketing Name": "Columbia",
    "Device": "sepolia",
    "Model": "AOW4KMCTV"
  },
  {
    "Retail Branding": "CAIXUN",
    "Marketing Name": "Europe",
    "Device": "martin",
    "Model": "Caixun Android TV"
  },
  {
    "Retail Branding": "CAIXUN",
    "Marketing Name": "Europe",
    "Device": "martin",
    "Model": "Smarttech Android Monitor"
  },
  {
    "Retail Branding": "CAIXUN",
    "Marketing Name": "Europe",
    "Device": "sepolia",
    "Model": "Smart TV 4K"
  },
  {
    "Retail Branding": "CAIXUN",
    "Marketing Name": "Korea",
    "Device": "marina",
    "Model": "DWsummus 4K SMART TV"
  },
  {
    "Retail Branding": "CAIXUN",
    "Marketing Name": "MAXWELL SMART TV",
    "Device": "marina",
    "Model": "MAXWELL SMART TV"
  },
  {
    "Retail Branding": "CAIXUN",
    "Marketing Name": "MAXWELL SMART TV",
    "Device": "nagata",
    "Model": "MAXWELL SMART TV"
  },
  {
    "Retail Branding": "CAIXUN",
    "Marketing Name": "Malaysia",
    "Device": "yeongdeungpo",
    "Model": "AiPlus4KMY"
  },
  {
    "Retail Branding": "CAIXUN",
    "Marketing Name": "Mexico",
    "Device": "yeongdeungpo",
    "Model": "AiPlus4K"
  },
  {
    "Retail Branding": "CAIXUN",
    "Marketing Name": "Pakistan",
    "Device": "sepolia",
    "Model": "KONVO 4K SMART TV"
  },
  {
    "Retail Branding": "CAIXUN",
    "Marketing Name": "Sgamer",
    "Device": "cottongreen",
    "Model": "Sgamer"
  },
  {
    "Retail Branding": "CAIXUN",
    "Marketing Name": "South America",
    "Device": "sepolia",
    "Model": "AiPro4K TV"
  },
  {
    "Retail Branding": "CAIXUN",
    "Marketing Name": "South of America",
    "Device": "marina",
    "Model": "Apollo Pro4K TV"
  },
  {
    "Retail Branding": "CAIXUN",
    "Marketing Name": "South of America",
    "Device": "martin",
    "Model": "AiPlus2K"
  },
  {
    "Retail Branding": "CAIXUN",
    "Marketing Name": "South of America",
    "Device": "patrick",
    "Model": "Aipro4K"
  },
  {
    "Retail Branding": "CAIXUN",
    "Marketing Name": "USA",
    "Device": "yeongdeungpo",
    "Model": "AiPlus4K"
  },
  {
    "Retail Branding": "CALME",
    "Marketing Name": "LT5",
    "Device": "LT5",
    "Model": "LT5"
  },
  {
    "Retail Branding": "CALUS",
    "Marketing Name": "Note 16 Pro",
    "Device": "Note_16_Pro",
    "Model": "Note_16_Pro"
  },
  {
    "Retail Branding": "CANAL-PLUS",
    "Marketing Name": "B866V5-W10",
    "Device": "B866V5W_CP",
    "Model": "B866V5-W10"
  },
  {
    "Retail Branding": "CANAL-PLUS",
    "Marketing Name": "CANAL+ BOX",
    "Device": "HY40A2",
    "Model": "CANAL PLUS BOX"
  },
  {
    "Retail Branding": "CANAL-PLUS",
    "Marketing Name": "CANALATV1",
    "Device": "HY40A2",
    "Model": "CANAL PLUS BOX"
  },
  {
    "Retail Branding": "CANAL-PLUS",
    "Marketing Name": "CANALATV1",
    "Device": "HY40A2",
    "Model": "CANALATV1"
  },
  {
    "Retail Branding": "CARLINKIT",
    "Marketing Name": "TBOX",
    "Device": "TBOX",
    "Model": "TBOX"
  },
  {
    "Retail Branding": "CAST",
    "Marketing Name": "CAST",
    "Device": "CAST",
    "Model": "CAST"
  },
  {
    "Retail Branding": "CAST",
    "Marketing Name": "CAST2_CAST-BLACKBOX",
    "Device": "CAST2_CAST-BLACKBOX",
    "Model": "CT-V200"
  },
  {
    "Retail Branding": "CATCHTABLE",
    "Marketing Name": "AZ101FC",
    "Device": "AZ101FC",
    "Model": "AZ101FC"
  },
  {
    "Retail Branding": "CATCHTABLE",
    "Marketing Name": "AZ101FCN",
    "Device": "AZ101FCN",
    "Model": "AZ101FCN"
  },
  {
    "Retail Branding": "CBN Media",
    "Marketing Name": "connect",
    "Device": "connect",
    "Model": "connect"
  },
  {
    "Retail Branding": "CBN Media",
    "Marketing Name": "g-mee1",
    "Device": "g-mee1",
    "Model": "g-mee1"
  },
  {
    "Retail Branding": "CCC",
    "Marketing Name": "AirStick",
    "Device": "ts201",
    "Model": "AIrStick"
  },
  {
    "Retail Branding": "CCC",
    "Marketing Name": "AirStick",
    "Device": "ts201",
    "Model": "AirStick"
  },
  {
    "Retail Branding": "CCC",
    "Marketing Name": "AirStick 4K",
    "Device": "ts302",
    "Model": "AirStick 4K"
  },
  {
    "Retail Branding": "CCC",
    "Marketing Name": "LifeStick",
    "Device": "ts201",
    "Model": "LifeStick"
  },
  {
    "Retail Branding": "CCC",
    "Marketing Name": "LifeStick 4k",
    "Device": "ts302",
    "Model": "LifeStick 4K"
  },
  {
    "Retail Branding": "CCC",
    "Marketing Name": "TSUTAYA Stick",
    "Device": "ts201",
    "Model": "TStick"
  },
  {
    "Retail Branding": "CCC",
    "Marketing Name": "TV Stick",
    "Device": "ts401",
    "Model": "TV Stick"
  },
  {
    "Retail Branding": "CCC",
    "Marketing Name": "TV Stick",
    "Device": "ts401",
    "Model": "TV StickL"
  },
  {
    "Retail Branding": "CCIT",
    "Marketing Name": "Xedition",
    "Device": "Xedition",
    "Model": "Xedition"
  },
  {
    "Retail Branding": "CEM Global",
    "Marketing Name": "Continental",
    "Device": "CE10412-26",
    "Model": "CE10412-26"
  },
  {
    "Retail Branding": "CEM Global",
    "Marketing Name": "Continential",
    "Device": "CE10402-16",
    "Model": "CE10402-16"
  },
  {
    "Retail Branding": "CEM Global",
    "Marketing Name": "HS29779-18",
    "Device": "HS29779-18",
    "Model": "HS29779-18"
  },
  {
    "Retail Branding": "CENAVA",
    "Marketing Name": "A10ST-5G",
    "Device": "A10ST-5G",
    "Model": "A10ST-5G"
  },
  {
    "Retail Branding": "CENAVA",
    "Marketing Name": "A80ST",
    "Device": "A80ST",
    "Model": "A80ST"
  },
  {
    "Retail Branding": "CEPTER",
    "Marketing Name": "CEPTER-TAB-10L",
    "Device": "CEPTER-TAB-10L",
    "Model": "CEPTERTAB10L"
  },
  {
    "Retail Branding": "CEPTER",
    "Marketing Name": "CEPTER-TAB-10S",
    "Device": "CEPTER-TAB-10S",
    "Model": "CEPTERTAB10S"
  },
  {
    "Retail Branding": "CEPTER",
    "Marketing Name": "CEPTERTAB101",
    "Device": "CEPTERTAB101",
    "Model": "CEPTERTAB101"
  },
  {
    "Retail Branding": "CEPTER",
    "Marketing Name": "CEPTERTAB1095",
    "Device": "CEPTERTAB1095",
    "Model": "CEPTERTAB1095"
  },
  {
    "Retail Branding": "CEPTER",
    "Marketing Name": "CEPTERTAB10E",
    "Device": "CEPTERTAB10E",
    "Model": "CEPTERTAB10E"
  },
  {
    "Retail Branding": "CEPTER",
    "Marketing Name": "CEPTERTABP12",
    "Device": "CEPTERTABP12",
    "Model": "CEPTERTABP12"
  },
  {
    "Retail Branding": "CEPTER",
    "Marketing Name": "CGWT16207P",
    "Device": "CGWT16207P",
    "Model": "CTITANULTRAX"
  },
  {
    "Retail Branding": "CEPTER",
    "Marketing Name": "CTABERA101",
    "Device": "CTABERA101",
    "Model": "CTABERA101"
  },
  {
    "Retail Branding": "CEPTER",
    "Marketing Name": "CTABERAV2",
    "Device": "CTABERAV2",
    "Model": "CTABERAV2"
  },
  {
    "Retail Branding": "CEPTER",
    "Marketing Name": "CTABEVOP12",
    "Device": "CTABEVOP12",
    "Model": "CTABEVOP12"
  },
  {
    "Retail Branding": "CEPTER",
    "Marketing Name": "CTABLOTUSV2",
    "Device": "CTABLOTUSV2",
    "Model": "CTABLOTUSV2"
  },
  {
    "Retail Branding": "CEPTER",
    "Marketing Name": "CTABNEXUS",
    "Device": "CTABNEXUS",
    "Model": "CTABNEXUS"
  },
  {
    "Retail Branding": "CEPTER",
    "Marketing Name": "CTABNEXUS8128",
    "Device": "CTABNEXUS8128",
    "Model": "CTABNEXUS8128"
  },
  {
    "Retail Branding": "CEPTER",
    "Marketing Name": "CTABNEXUSG",
    "Device": "CTABNEXUSG",
    "Model": "CTABNEXUSG"
  },
  {
    "Retail Branding": "CEPTER",
    "Marketing Name": "CTABNEXUSW",
    "Device": "CTABNEXUSW",
    "Model": "CTABNEXUSW"
  },
  {
    "Retail Branding": "CEPTER",
    "Marketing Name": "CTABTERRA128",
    "Device": "CTABTERRA128",
    "Model": "CTABTERRA128"
  },
  {
    "Retail Branding": "CEPTER",
    "Marketing Name": "CTABTERRA256",
    "Device": "CTABTERRA256",
    "Model": "CTABTERRA256"
  },
  {
    "Retail Branding": "CEPTER",
    "Marketing Name": "CTABTITAN12",
    "Device": "CTABTITAN12",
    "Model": "CTABTITAN12"
  },
  {
    "Retail Branding": "CERAGEM",
    "Marketing Name": "CGM-ESAT-2501",
    "Device": "CGM-ESAT-2501",
    "Model": "CGM-ESAT-2501"
  },
  {
    "Retail Branding": "CG Inspiring Life",
    "Marketing Name": "Android TV",
    "Device": "R1",
    "Model": "ATV R1"
  },
  {
    "Retail Branding": "CG Inspiring Life",
    "Marketing Name": "Android TV",
    "Device": "R2",
    "Model": "ATV R2"
  },
  {
    "Retail Branding": "CG Inspiring Life",
    "Marketing Name": "R3",
    "Device": "R3",
    "Model": "R3"
  },
  {
    "Retail Branding": "CG Inspiring Life",
    "Marketing Name": "R3_GTV",
    "Device": "R3_GTV",
    "Model": "R3G"
  },
  {
    "Retail Branding": "CG Inspiring Life",
    "Marketing Name": "R4",
    "Device": "R4",
    "Model": "R4"
  },
  {
    "Retail Branding": "CG Mobile",
    "Marketing Name": "Blaze  G",
    "Device": "Blaze_G",
    "Model": "Blaze G"
  },
  {
    "Retail Branding": "CG Mobile",
    "Marketing Name": "Blaze N",
    "Device": "Blaze_N",
    "Model": "Blaze N"
  },
  {
    "Retail Branding": "CG Mobile",
    "Marketing Name": "EON Blaze Pro",
    "Device": "CG_EON_Blaze_Pro",
    "Model": "CG_EON_Blaze_Pro"
  },
  {
    "Retail Branding": "CG Mobile",
    "Marketing Name": "OMEGA 3",
    "Device": "OMEGA_3",
    "Model": "OMEGA 3"
  },
  {
    "Retail Branding": "CG Mobile",
    "Marketing Name": "OMEGA 8",
    "Device": "CG_Omega_8",
    "Model": "Omega 8"
  },
  {
    "Retail Branding": "CG Mobile",
    "Marketing Name": "Omega6",
    "Device": "OMEGA6",
    "Model": "CG_OMEGA6"
  },
  {
    "Retail Branding": "CGV (France)",
    "Marketing Name": "Ultimate T8",
    "Device": "Ultimate_T8",
    "Model": "CGV_Ultimate T8"
  },
  {
    "Retail Branding": "CHAINWAY",
    "Marketing Name": "C5_EEA",
    "Device": "C5",
    "Model": "C5"
  },
  {
    "Retail Branding": "CHAINWAY",
    "Marketing Name": "C5_GL",
    "Device": "C5",
    "Model": "C5"
  },
  {
    "Retail Branding": "CHAINWAY",
    "Marketing Name": "C60",
    "Device": "C60",
    "Model": "C60"
  },
  {
    "Retail Branding": "CHAINWAY",
    "Marketing Name": "C6000",
    "Device": "C6000",
    "Model": "C6000"
  },
  {
    "Retail Branding": "CHAINWAY",
    "Marketing Name": "C61",
    "Device": "C61",
    "Model": "C61"
  },
  {
    "Retail Branding": "CHAINWAY",
    "Marketing Name": "C61",
    "Device": "C61P",
    "Model": "C61"
  },
  {
    "Retail Branding": "CHAINWAY",
    "Marketing Name": "C61",
    "Device": "C61P",
    "Model": "C61P"
  },
  {
    "Retail Branding": "CHAINWAY",
    "Marketing Name": "C66",
    "Device": "C66",
    "Model": "C66"
  },
  {
    "Retail Branding": "CHAINWAY",
    "Marketing Name": "C66_EEA",
    "Device": "C66",
    "Model": "C66"
  },
  {
    "Retail Branding": "CHAINWAY",
    "Marketing Name": "C71",
    "Device": "C71",
    "Model": "C71"
  },
  {
    "Retail Branding": "CHAINWAY",
    "Marketing Name": "C71_EEA",
    "Device": "C71",
    "Model": "C71"
  },
  {
    "Retail Branding": "CHAINWAY",
    "Marketing Name": "C71_GL",
    "Device": "C71",
    "Model": "C71"
  },
  {
    "Retail Branding": "CHAINWAY",
    "Marketing Name": "C72_EEA",
    "Device": "C72",
    "Model": "C72"
  },
  {
    "Retail Branding": "CHAINWAY",
    "Marketing Name": "C72_GL",
    "Device": "C72",
    "Model": "C72"
  },
  {
    "Retail Branding": "CHAINWAY",
    "Marketing Name": "C75_GL",
    "Device": "C75",
    "Model": "C75"
  },
  {
    "Retail Branding": "CHAINWAY",
    "Marketing Name": "C90",
    "Device": "C90",
    "Model": "C90"
  },
  {
    "Retail Branding": "CHAINWAY",
    "Marketing Name": "C90A",
    "Device": "C90A",
    "Model": "C90A"
  },
  {
    "Retail Branding": "CHAINWAY",
    "Marketing Name": "MC21",
    "Device": "MC21",
    "Model": "MC21"
  },
  {
    "Retail Branding": "CHAINWAY",
    "Marketing Name": "MC50",
    "Device": "MC50",
    "Model": "MC50"
  },
  {
    "Retail Branding": "CHAINWAY",
    "Marketing Name": "MC51",
    "Device": "MC51",
    "Model": "MC51"
  },
  {
    "Retail Branding": "CHAINWAY",
    "Marketing Name": "MC62",
    "Device": "MC62",
    "Model": "MC62"
  },
  {
    "Retail Branding": "CHAINWAY",
    "Marketing Name": "MC95",
    "Device": "MC95",
    "Model": "MC95"
  },
  {
    "Retail Branding": "CHAINWAY",
    "Marketing Name": "P100",
    "Device": "P100",
    "Model": "P100"
  },
  {
    "Retail Branding": "CHAINWAY",
    "Marketing Name": "P100S",
    "Device": "P100S",
    "Model": "P100S"
  },
  {
    "Retail Branding": "CHAINWAY",
    "Marketing Name": "P80",
    "Device": "P80",
    "Model": "P80"
  },
  {
    "Retail Branding": "CHAINWAY",
    "Marketing Name": "P80_B",
    "Device": "P80_PRO",
    "Model": "P80"
  },
  {
    "Retail Branding": "CHAINWAY",
    "Marketing Name": "P80_EEA",
    "Device": "P80",
    "Model": "P80"
  },
  {
    "Retail Branding": "CHCNAV",
    "Marketing Name": "HCE600",
    "Device": "HCE600",
    "Model": "HCE600"
  },
  {
    "Retail Branding": "CHCNAV",
    "Marketing Name": "LT60",
    "Device": "LT60",
    "Model": "LT60"
  },
  {
    "Retail Branding": "CHCNAV",
    "Marketing Name": "LT60H",
    "Device": "LT60",
    "Model": "LT60"
  },
  {
    "Retail Branding": "CHCNAV",
    "Marketing Name": "LT700",
    "Device": "LT700",
    "Model": "LT700"
  },
  {
    "Retail Branding": "CHCNAV",
    "Marketing Name": "LT800",
    "Device": "LT800",
    "Model": "LT800"
  },
  {
    "Retail Branding": "CHCNAV",
    "Marketing Name": "LT800H",
    "Device": "LT800",
    "Model": "LT800"
  },
  {
    "Retail Branding": "CHEETAH",
    "Marketing Name": "Diplomat",
    "Device": "Diplomat",
    "Model": "Diplomat"
  },
  {
    "Retail Branding": "CHN TELECOM",
    "Marketing Name": "CHN-UCAN MJ",
    "Device": "lefhd",
    "Model": "CHN-UCAN MJ"
  },
  {
    "Retail Branding": "CHOFSLIA",
    "Marketing Name": "A6",
    "Device": "A6",
    "Model": "A6"
  },
  {
    "Retail Branding": "CHOFSLIA",
    "Marketing Name": "A6_EEA",
    "Device": "A6",
    "Model": "A6"
  },
  {
    "Retail Branding": "CHUBU TELECOMMUNICATIONS CO.,INC",
    "Marketing Name": "STI6130C",
    "Device": "sti6130d353",
    "Model": "STI6130C"
  },
  {
    "Retail Branding": "CHUBU TELECOMMUNICATIONS CO.,INC",
    "Marketing Name": "STI6130d353",
    "Device": "sti6130d353",
    "Model": "STI6130C"
  },
  {
    "Retail Branding": "CHiQ",
    "Marketing Name": "H7",
    "Device": "redwood",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "CHiQ",
    "Marketing Name": "H7",
    "Device": "sindorim",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "CHiQ",
    "Marketing Name": "H7A",
    "Device": "samseong",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "CHiQ",
    "Marketing Name": "M7A",
    "Device": "samseong",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "CHiQ",
    "Marketing Name": "Smart TV",
    "Device": "alimos",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "CHiQ",
    "Marketing Name": "Smart TV",
    "Device": "alimos",
    "Model": "AI PONT FF"
  },
  {
    "Retail Branding": "CHiQ",
    "Marketing Name": "Smart TV",
    "Device": "bridgeport",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "CHiQ",
    "Marketing Name": "Smart TV",
    "Device": "dangni",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "CHiQ",
    "Marketing Name": "Smart TV",
    "Device": "dundas",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "CHiQ",
    "Marketing Name": "Smart TV",
    "Device": "longshan",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "CHiQ",
    "Marketing Name": "Smart TV",
    "Device": "osaka",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "CHiQ",
    "Marketing Name": "Smart TV",
    "Device": "osaka",
    "Model": "AI PONT CO"
  },
  {
    "Retail Branding": "CHiQ",
    "Marketing Name": "Smart TV",
    "Device": "osaka",
    "Model": "AI PONT NA"
  },
  {
    "Retail Branding": "CHiQ",
    "Marketing Name": "Smart TV",
    "Device": "osaka",
    "Model": "AI PONT SA"
  },
  {
    "Retail Branding": "CIBER",
    "Marketing Name": "B610A103A",
    "Device": "B610A103A",
    "Model": "B610A103A"
  },
  {
    "Retail Branding": "CIBER",
    "Marketing Name": "B610A115",
    "Device": "B610A115",
    "Model": "B610A115"
  },
  {
    "Retail Branding": "CIBER",
    "Marketing Name": "B610A215",
    "Device": "B610A215",
    "Model": "B610A215"
  },
  {
    "Retail Branding": "CILICO",
    "Marketing Name": "C6",
    "Device": "C6_R",
    "Model": "C6"
  },
  {
    "Retail Branding": "CILICO",
    "Marketing Name": "C6_P",
    "Device": "C6",
    "Model": "C6"
  },
  {
    "Retail Branding": "CILICO",
    "Marketing Name": "C7X",
    "Device": "C7X",
    "Model": "C7X"
  },
  {
    "Retail Branding": "CILICO",
    "Marketing Name": "C7X",
    "Device": "C7X_R",
    "Model": "C7X"
  },
  {
    "Retail Branding": "CILICO",
    "Marketing Name": "C80",
    "Device": "C80",
    "Model": "C80"
  },
  {
    "Retail Branding": "CILICO",
    "Marketing Name": "F750",
    "Device": "F750",
    "Model": "F750"
  },
  {
    "Retail Branding": "CILICO",
    "Marketing Name": "F880",
    "Device": "F880",
    "Model": "F880"
  },
  {
    "Retail Branding": "CILICO",
    "Marketing Name": "M95",
    "Device": "M95",
    "Model": "M95"
  },
  {
    "Retail Branding": "CILICO",
    "Marketing Name": "V5",
    "Device": "V5",
    "Model": "V5"
  },
  {
    "Retail Branding": "CIMI",
    "Marketing Name": "A8",
    "Device": "A8",
    "Model": "A8"
  },
  {
    "Retail Branding": "CIMRL",
    "Marketing Name": "tab10",
    "Device": "tab10",
    "Model": "tab10"
  },
  {
    "Retail Branding": "CIRCLE_POWER",
    "Marketing Name": "CP1",
    "Device": "CP1",
    "Model": "CP1"
  },
  {
    "Retail Branding": "CIRKUIT PLANET (ESPANA)",
    "Marketing Name": "SMARTLIFE",
    "Device": "SL-TAB07116",
    "Model": "SL-TAB07116"
  },
  {
    "Retail Branding": "CIRKUIT PLANET (ESPANA)",
    "Marketing Name": "SMARTLIFE",
    "Device": "SL-TAB10232",
    "Model": "SL-TAB10232"
  },
  {
    "Retail Branding": "CJHelloVision",
    "Marketing Name": "CJ680CL",
    "Device": "cj680cl",
    "Model": "GX-CJ680CL"
  },
  {
    "Retail Branding": "CJHelloVision",
    "Marketing Name": "Hello TV Smart",
    "Device": "SX930C_CJ",
    "Model": "SX930C_CJ"
  },
  {
    "Retail Branding": "CJHelloVision",
    "Marketing Name": "viewing",
    "Device": "kr101",
    "Model": "kr101"
  },
  {
    "Retail Branding": "CLEVER",
    "Marketing Name": "C45",
    "Device": "C45",
    "Model": "C45"
  },
  {
    "Retail Branding": "CLEVER",
    "Marketing Name": "T45",
    "Device": "T45",
    "Model": "T45"
  },
  {
    "Retail Branding": "CLIO",
    "Marketing Name": "Neo 4",
    "Device": "Neo_4",
    "Model": "Neo 4"
  },
  {
    "Retail Branding": "CLIO",
    "Marketing Name": "Neo_4_Plus",
    "Device": "Neo_4_Plus",
    "Model": "Neo 4 Plus"
  },
  {
    "Retail Branding": "CLIO",
    "Marketing Name": "Zion_5",
    "Device": "Zion_5",
    "Model": "Zion_5"
  },
  {
    "Retail Branding": "CLOUD_AiR-WiFi",
    "Marketing Name": "ATab-1",
    "Device": "ATab-1",
    "Model": "CAW21T101"
  },
  {
    "Retail Branding": "CLOVERTEK",
    "Marketing Name": "G65",
    "Device": "G65",
    "Model": "G65"
  },
  {
    "Retail Branding": "CLOVERTEK",
    "Marketing Name": "P101",
    "Device": "P101",
    "Model": "P101"
  },
  {
    "Retail Branding": "CMCC",
    "Marketing Name": "M811",
    "Device": "m811",
    "Model": "M811"
  },
  {
    "Retail Branding": "CMCC",
    "Marketing Name": "M811",
    "Device": "m811hk",
    "Model": "M811"
  },
  {
    "Retail Branding": "CMF by Nothing",
    "Marketing Name": "CMF Phone 2 Pro",
    "Device": "Galaga",
    "Model": "A001"
  },
  {
    "Retail Branding": "CMF by Nothing",
    "Marketing Name": "CMF by Nothing Phone 1",
    "Device": "Tetris",
    "Model": "A015"
  },
  {
    "Retail Branding": "COCOMM",
    "Marketing Name": "COCOMM F900B",
    "Device": "F900BN0101",
    "Model": "F900B"
  },
  {
    "Retail Branding": "COCOMM",
    "Marketing Name": "ENOS",
    "Device": "ENOS",
    "Model": "ENOS"
  },
  {
    "Retail Branding": "COCOMM",
    "Marketing Name": "F780",
    "Device": "F780",
    "Model": "F780"
  },
  {
    "Retail Branding": "COCOMM",
    "Marketing Name": "F900",
    "Device": "F900N0101",
    "Model": "F900"
  },
  {
    "Retail Branding": "COCOMM",
    "Marketing Name": "F910B0101",
    "Device": "F910B0101",
    "Model": "F910"
  },
  {
    "Retail Branding": "COEX",
    "Marketing Name": "COEX 2K Smart TV",
    "Device": "sunnyvale",
    "Model": "COEX 2K Smart TV"
  },
  {
    "Retail Branding": "COEX",
    "Marketing Name": "COEX 4K Smart TV",
    "Device": "SW6H",
    "Model": "COEX 4K Smart TV"
  },
  {
    "Retail Branding": "COEX",
    "Marketing Name": "COEX 4K Smart TV FF",
    "Device": "SW6H",
    "Model": "COEX 4K Smart TV FF"
  },
  {
    "Retail Branding": "COLORROOM",
    "Marketing Name": "A30_Plus",
    "Device": "A30_Plus",
    "Model": "A30"
  },
  {
    "Retail Branding": "COLORROOM",
    "Marketing Name": "A30_Plus",
    "Device": "A30_Plus",
    "Model": "A30_Plus"
  },
  {
    "Retail Branding": "COLORROOM",
    "Marketing Name": "A5",
    "Device": "A5",
    "Model": "A5"
  },
  {
    "Retail Branding": "COLORROOM",
    "Marketing Name": "C1",
    "Device": "C1",
    "Model": "C1"
  },
  {
    "Retail Branding": "COLORROOM",
    "Marketing Name": "C10_EEA",
    "Device": "C10_EEA",
    "Model": "C10"
  },
  {
    "Retail Branding": "COLORROOM",
    "Marketing Name": "C10_ROW",
    "Device": "C10_ROW",
    "Model": "C10"
  },
  {
    "Retail Branding": "COLORROOM",
    "Marketing Name": "C2",
    "Device": "C2",
    "Model": "C2"
  },
  {
    "Retail Branding": "COLORROOM",
    "Marketing Name": "C20",
    "Device": "C20",
    "Model": "C20_ROW"
  },
  {
    "Retail Branding": "COLORROOM",
    "Marketing Name": "C20_EEA",
    "Device": "C20",
    "Model": "C20"
  },
  {
    "Retail Branding": "COLORROOM",
    "Marketing Name": "C30D",
    "Device": "C30D",
    "Model": "C30D"
  },
  {
    "Retail Branding": "COLORROOM",
    "Marketing Name": "C30_Pro",
    "Device": "C30_Pro",
    "Model": "C30"
  },
  {
    "Retail Branding": "COLORROOM",
    "Marketing Name": "C30_Pro",
    "Device": "C30_Pro",
    "Model": "C30_Pro"
  },
  {
    "Retail Branding": "COLORROOM",
    "Marketing Name": "C3_EEA",
    "Device": "C3_EEA",
    "Model": "C3"
  },
  {
    "Retail Branding": "COLORROOM",
    "Marketing Name": "C3_Pro_EEA",
    "Device": "C3_Pro_EEA",
    "Model": "C3_Pro"
  },
  {
    "Retail Branding": "COLORROOM",
    "Marketing Name": "C3_Pro_ROW",
    "Device": "C3_Pro_ROW",
    "Model": "C3_Pro"
  },
  {
    "Retail Branding": "COLORROOM",
    "Marketing Name": "C3_ROW",
    "Device": "C3_ROW",
    "Model": "C3"
  },
  {
    "Retail Branding": "COLORROOM",
    "Marketing Name": "C5",
    "Device": "C5",
    "Model": "C5"
  },
  {
    "Retail Branding": "COLORROOM",
    "Marketing Name": "C5_EEA",
    "Device": "C5_EEA",
    "Model": "C5"
  },
  {
    "Retail Branding": "COLORROOM",
    "Marketing Name": "C5_EEA",
    "Device": "C5_EEA",
    "Model": "C5_EEA"
  },
  {
    "Retail Branding": "COLORROOM",
    "Marketing Name": "C5_Pro",
    "Device": "C5_Pro",
    "Model": "C5"
  },
  {
    "Retail Branding": "COLORROOM",
    "Marketing Name": "C5_Pro",
    "Device": "C5_Pro",
    "Model": "C5_Pro"
  },
  {
    "Retail Branding": "COLORROOM",
    "Marketing Name": "E07",
    "Device": "E07",
    "Model": "E07"
  },
  {
    "Retail Branding": "COLORROOM",
    "Marketing Name": "E20_EEA",
    "Device": "E20",
    "Model": "E20"
  },
  {
    "Retail Branding": "COLORROOM",
    "Marketing Name": "E20_ROW",
    "Device": "E20_ROW",
    "Model": "E20"
  },
  {
    "Retail Branding": "COLORROOM",
    "Marketing Name": "E30_EEA",
    "Device": "E30_EEA",
    "Model": "E30_EEA"
  },
  {
    "Retail Branding": "COLORROOM",
    "Marketing Name": "E30_Pro",
    "Device": "E30_Pro",
    "Model": "E30"
  },
  {
    "Retail Branding": "COLORROOM",
    "Marketing Name": "E30_Pro",
    "Device": "E30_Pro",
    "Model": "E30_Pro"
  },
  {
    "Retail Branding": "COLORROOM",
    "Marketing Name": "E30_ROW",
    "Device": "E30",
    "Model": "E30"
  },
  {
    "Retail Branding": "COLORROOM",
    "Marketing Name": "E5",
    "Device": "E5",
    "Model": "E5"
  },
  {
    "Retail Branding": "COLORROOM",
    "Marketing Name": "E5_EEA",
    "Device": "E5_EEA",
    "Model": "E5_EEA"
  },
  {
    "Retail Branding": "COLORROOM",
    "Marketing Name": "E5_EEA",
    "Device": "E5_EEA",
    "Model": "T5"
  },
  {
    "Retail Branding": "COLORROOM",
    "Marketing Name": "K07-pro",
    "Device": "K07-pro_EEA",
    "Model": "K07-pro"
  },
  {
    "Retail Branding": "COLORROOM",
    "Marketing Name": "K07-pro_EEA",
    "Device": "K07-pro_EEA",
    "Model": "K07-pro"
  },
  {
    "Retail Branding": "COLORROOM",
    "Marketing Name": "K08",
    "Device": "K08",
    "Model": "K08"
  },
  {
    "Retail Branding": "COLORROOM",
    "Marketing Name": "K10",
    "Device": "K10",
    "Model": "K10"
  },
  {
    "Retail Branding": "COLORROOM",
    "Marketing Name": "K10C",
    "Device": "K10C",
    "Model": "K10C"
  },
  {
    "Retail Branding": "COLORROOM",
    "Marketing Name": "K10C_EEA",
    "Device": "K10C",
    "Model": "K10C"
  },
  {
    "Retail Branding": "COLORROOM",
    "Marketing Name": "K12",
    "Device": "K12",
    "Model": "K12"
  },
  {
    "Retail Branding": "COLORROOM",
    "Marketing Name": "K12-EEA",
    "Device": "K12-EEA",
    "Model": "K12"
  },
  {
    "Retail Branding": "COLORROOM",
    "Marketing Name": "K12-EEA",
    "Device": "K12-EEA",
    "Model": "K12-ROW"
  },
  {
    "Retail Branding": "COLORROOM",
    "Marketing Name": "K12E",
    "Device": "K12E",
    "Model": "K12E"
  },
  {
    "Retail Branding": "COLORROOM",
    "Marketing Name": "K12E_EEA",
    "Device": "K12E_EEA",
    "Model": "K12E_EEA"
  },
  {
    "Retail Branding": "COLORROOM",
    "Marketing Name": "K12E_ROW",
    "Device": "K12E_ROW",
    "Model": "K12E_ROW"
  },
  {
    "Retail Branding": "COLORROOM",
    "Marketing Name": "T30E",
    "Device": "T30E",
    "Model": "T30"
  },
  {
    "Retail Branding": "COLORROOM",
    "Marketing Name": "T30E",
    "Device": "T30E",
    "Model": "T30E"
  },
  {
    "Retail Branding": "COLORROOM",
    "Marketing Name": "W70",
    "Device": "W70",
    "Model": "W70"
  },
  {
    "Retail Branding": "COMBUSTECH",
    "Marketing Name": "COMBUSTECH-IFPD",
    "Device": "oversea_v",
    "Model": "COMBUS_IB2"
  },
  {
    "Retail Branding": "COMBUSTECH",
    "Marketing Name": "COMBUSTECH-IFPD",
    "Device": "rk3588_t",
    "Model": "COMBUS_IB"
  },
  {
    "Retail Branding": "COMBUSTECH",
    "Marketing Name": "COMBUS_IB3",
    "Device": "COMBUS_IB3",
    "Model": "COMBUS_IB3"
  },
  {
    "Retail Branding": "COMMTEC",
    "Marketing Name": "C80",
    "Device": "C80",
    "Model": "C80"
  },
  {
    "Retail Branding": "COMPAX",
    "Marketing Name": "ACE 1s Pro",
    "Device": "ACE_1s_Pro",
    "Model": "A3-1510P"
  },
  {
    "Retail Branding": "COMPUMAX",
    "Marketing Name": "BLUEPAD10",
    "Device": "BLUEPAD10",
    "Model": "BLUEPAD10"
  },
  {
    "Retail Branding": "COMPUMAX",
    "Marketing Name": "BlueS10",
    "Device": "COMPUMAX",
    "Model": "BlueS10"
  },
  {
    "Retail Branding": "COMTECO",
    "Marketing Name": "DV8535",
    "Device": "DV8535-KBC",
    "Model": "DV8535"
  },
  {
    "Retail Branding": "COMTEL",
    "Marketing Name": "Tivo Core",
    "Device": "Tivo_Core",
    "Model": "Tivo Core"
  },
  {
    "Retail Branding": "COMTEL",
    "Marketing Name": "Tivo Lite",
    "Device": "Tivo_Lite",
    "Model": "Tivo Lite"
  },
  {
    "Retail Branding": "CONKER",
    "Marketing Name": "ST60",
    "Device": "ST_60",
    "Model": "ST 60"
  },
  {
    "Retail Branding": "CONKER",
    "Marketing Name": "SX50",
    "Device": "SX50",
    "Model": "SX50"
  },
  {
    "Retail Branding": "CONNECT-ME",
    "Marketing Name": "C-710_PRO",
    "Device": "C-710_PRO",
    "Model": "C-710_PRO"
  },
  {
    "Retail Branding": "CONNECT-ME",
    "Marketing Name": "C-710_PRO_EEA",
    "Device": "C-710_PRO",
    "Model": "C-710_PRO"
  },
  {
    "Retail Branding": "CONNECT-ME",
    "Marketing Name": "C-710_PRO_MAX",
    "Device": "C-710_PRO_MAX",
    "Model": "C-710_PRO_MAX"
  },
  {
    "Retail Branding": "CONNECT-ME",
    "Marketing Name": "C-710_R",
    "Device": "C-710_R",
    "Model": "C-710_R"
  },
  {
    "Retail Branding": "CONNECT-ME",
    "Marketing Name": "C-710_R_EEA",
    "Device": "C-710_R",
    "Model": "C-710_R"
  },
  {
    "Retail Branding": "CONSUNG",
    "Marketing Name": "C80",
    "Device": "C80",
    "Model": "C80"
  },
  {
    "Retail Branding": "CONSUNG",
    "Marketing Name": "CS10L_PRO",
    "Device": "CS10L_PRO",
    "Model": "CS10L_PRO"
  },
  {
    "Retail Branding": "CONSUNG",
    "Marketing Name": "N101B",
    "Device": "N101B",
    "Model": "N101B"
  },
  {
    "Retail Branding": "CONVERGE",
    "Marketing Name": "T7045PS",
    "Device": "T7045PS",
    "Model": "T7045PS"
  },
  {
    "Retail Branding": "CONVERGE",
    "Marketing Name": "T8045PS",
    "Device": "T8045PS",
    "Model": "T8045PS"
  },
  {
    "Retail Branding": "COOCAA",
    "Marketing Name": "ATBOX001 THE ULTRA",
    "Device": "YDA",
    "Model": "4K Google TV Box"
  },
  {
    "Retail Branding": "COOKIE",
    "Marketing Name": "YS-CK0001",
    "Device": "YS-CK0001",
    "Model": "YS-CK0001"
  },
  {
    "Retail Branding": "COOL",
    "Marketing Name": "N685",
    "Device": "N685",
    "Model": "N685"
  },
  {
    "Retail Branding": "COOLFAN",
    "Marketing Name": "C107",
    "Device": "C107",
    "Model": "C107"
  },
  {
    "Retail Branding": "COOLFAN",
    "Marketing Name": "C107_EEA",
    "Device": "C107",
    "Model": "C107"
  },
  {
    "Retail Branding": "COOLFAN",
    "Marketing Name": "OC106",
    "Device": "OC106",
    "Model": "OC106"
  },
  {
    "Retail Branding": "COOLFAN",
    "Marketing Name": "OC106",
    "Device": "OC106_EEA",
    "Model": "OC106"
  },
  {
    "Retail Branding": "COOP",
    "Marketing Name": "MARTE",
    "Device": "MARTE",
    "Model": "MARTE"
  },
  {
    "Retail Branding": "COOP",
    "Marketing Name": "SATURNO2",
    "Device": "SATURNO2",
    "Model": "SATURNO2"
  },
  {
    "Retail Branding": "COOPERS",
    "Marketing Name": "CP10",
    "Device": "CP10",
    "Model": "CP10"
  },
  {
    "Retail Branding": "COOPERS",
    "Marketing Name": "CP20",
    "Device": "CP20",
    "Model": "CP20"
  },
  {
    "Retail Branding": "COOPERS",
    "Marketing Name": "CP20_EEA",
    "Device": "CP20_EEA",
    "Model": "CP20_EEA"
  },
  {
    "Retail Branding": "COOPERS",
    "Marketing Name": "CP70K",
    "Device": "CP70K",
    "Model": "CP70K"
  },
  {
    "Retail Branding": "COOPERS",
    "Marketing Name": "CP70KS",
    "Device": "CP70KS",
    "Model": "CP70KS"
  },
  {
    "Retail Branding": "COOPERS",
    "Marketing Name": "CP70K_EEA",
    "Device": "CP70K_EEA",
    "Model": "CP70K_EEA"
  },
  {
    "Retail Branding": "COOPERS",
    "Marketing Name": "CP80",
    "Device": "CP80",
    "Model": "CP80"
  },
  {
    "Retail Branding": "COOPERS",
    "Marketing Name": "CP81",
    "Device": "CP81",
    "Model": "CP81"
  },
  {
    "Retail Branding": "COPAN",
    "Marketing Name": "Aplus",
    "Device": "Aplus",
    "Model": "Aplus"
  },
  {
    "Retail Branding": "CORN",
    "Marketing Name": "C5",
    "Device": "C5",
    "Model": "C5"
  },
  {
    "Retail Branding": "CORN",
    "Marketing Name": "C55",
    "Device": "C55",
    "Model": "C55"
  },
  {
    "Retail Branding": "CORN",
    "Marketing Name": "C55 Pro",
    "Device": "S55310",
    "Model": "C55 Pro"
  },
  {
    "Retail Branding": "CORN",
    "Marketing Name": "C55_Pro",
    "Device": "C55_Pro",
    "Model": "C55 Pro"
  },
  {
    "Retail Branding": "CORN",
    "Marketing Name": "C60",
    "Device": "C60",
    "Model": "C60"
  },
  {
    "Retail Branding": "CORN",
    "Marketing Name": "C60 Ultra",
    "Device": "C60_Ultra",
    "Model": "C60 Ultra"
  },
  {
    "Retail Branding": "CORN",
    "Marketing Name": "CORN C10",
    "Device": "CORN_C10",
    "Model": "C10"
  },
  {
    "Retail Branding": "CORN",
    "Marketing Name": "CORN Note1",
    "Device": "Note1",
    "Model": "CORN Note1"
  },
  {
    "Retail Branding": "CORN",
    "Marketing Name": "CORN_R10",
    "Device": "CORN_R10",
    "Model": "CORN R10"
  },
  {
    "Retail Branding": "CORN",
    "Marketing Name": "CORN_X5",
    "Device": "CORN_X5",
    "Model": "CORN X5"
  },
  {
    "Retail Branding": "CORN",
    "Marketing Name": "CORN_X55",
    "Device": "CORN_X55",
    "Model": "CORN X55"
  },
  {
    "Retail Branding": "CORN",
    "Marketing Name": "Coco10_Ultra_4G",
    "Device": "Coco10_Ultra_4G",
    "Model": "Coco10_Ultra_4G"
  },
  {
    "Retail Branding": "CORN",
    "Marketing Name": "Coco20_Ultra_4G",
    "Device": "Coco20_Ultra_4G",
    "Model": "Coco20_Ultra_4G"
  },
  {
    "Retail Branding": "CORN",
    "Marketing Name": "G60",
    "Device": "G60",
    "Model": "G60"
  },
  {
    "Retail Branding": "CORN",
    "Marketing Name": "G60_Pro_4G",
    "Device": "G60_Pro_4G",
    "Model": "G60_Pro_4G"
  },
  {
    "Retail Branding": "CORN",
    "Marketing Name": "Note13",
    "Device": "Note13",
    "Model": "Note13"
  },
  {
    "Retail Branding": "CORN",
    "Marketing Name": "Play25_Pro_4G",
    "Device": "Play25_Pro_4G",
    "Model": "Play25_Pro_4G"
  },
  {
    "Retail Branding": "CORN",
    "Marketing Name": "R10",
    "Device": "R10S",
    "Model": "R10"
  },
  {
    "Retail Branding": "CORN",
    "Marketing Name": "R10E",
    "Device": "R10E",
    "Model": "R10"
  },
  {
    "Retail Branding": "CORN",
    "Marketing Name": "R20",
    "Device": "R20",
    "Model": "CORN R20"
  },
  {
    "Retail Branding": "CORN",
    "Marketing Name": "R40",
    "Device": "R40",
    "Model": "R40"
  },
  {
    "Retail Branding": "CORN",
    "Marketing Name": "R60",
    "Device": "R60",
    "Model": "CORN R60"
  },
  {
    "Retail Branding": "CORN",
    "Marketing Name": "Star10_3G",
    "Device": "Star10_3G",
    "Model": "Star10_3G"
  },
  {
    "Retail Branding": "CORN",
    "Marketing Name": "Star10_Pro",
    "Device": "Star10_Pro",
    "Model": "Star10_Pro"
  },
  {
    "Retail Branding": "CORN",
    "Marketing Name": "Star7_3G",
    "Device": "Star7_3G",
    "Model": "Star7 3G"
  },
  {
    "Retail Branding": "CORN",
    "Marketing Name": "Star8",
    "Device": "Corn_Star8",
    "Model": "CORN Star8"
  },
  {
    "Retail Branding": "CORN",
    "Marketing Name": "Star8",
    "Device": "Star8",
    "Model": "Star8"
  },
  {
    "Retail Branding": "CORN",
    "Marketing Name": "Star8_3G",
    "Device": "Star8_3G",
    "Model": "Star8_3G"
  },
  {
    "Retail Branding": "CORN",
    "Marketing Name": "Star9_Max",
    "Device": "Star9_Max",
    "Model": "Star9_Max"
  },
  {
    "Retail Branding": "CORN",
    "Marketing Name": "Star9_Pro",
    "Device": "Star9_Pro",
    "Model": "Star9_Pro"
  },
  {
    "Retail Branding": "CORN",
    "Marketing Name": "T12Pro",
    "Device": "T12Pro",
    "Model": "T12Pro"
  },
  {
    "Retail Branding": "CORN",
    "Marketing Name": "Tronik 13S",
    "Device": "Tronik_13S",
    "Model": "Tronik 13S"
  },
  {
    "Retail Branding": "CORN",
    "Marketing Name": "Tronik_12",
    "Device": "Tronik_12",
    "Model": "Tronik_12"
  },
  {
    "Retail Branding": "CORN",
    "Marketing Name": "Tronik_12S",
    "Device": "Tronik_12S",
    "Model": "Tronik_12S"
  },
  {
    "Retail Branding": "CORN",
    "Marketing Name": "X5",
    "Device": "X5S",
    "Model": "X5"
  },
  {
    "Retail Branding": "CORN",
    "Marketing Name": "X60",
    "Device": "X60",
    "Model": "X60"
  },
  {
    "Retail Branding": "CORN",
    "Marketing Name": "X60",
    "Device": "X60S",
    "Model": "X60"
  },
  {
    "Retail Branding": "CORN",
    "Marketing Name": "Y60",
    "Device": "Y60",
    "Model": "Y60"
  },
  {
    "Retail Branding": "CORNEA",
    "Marketing Name": "IS_IFPSeries_65",
    "Device": "IS_Panel",
    "Model": "IS_IFPSeries"
  },
  {
    "Retail Branding": "COSMIQ",
    "Marketing Name": "COSMIQ IFP Series",
    "Device": "COSMIQ_IFP_Series",
    "Model": "COSMIQ_IFP_Series"
  },
  {
    "Retail Branding": "COSMIQ",
    "Marketing Name": "GLIDE_SERIES",
    "Device": "COSMIQ_GLIDE_SERIES",
    "Model": "COSMIQ_GLIDE_SERIES"
  },
  {
    "Retail Branding": "COSMOTE TV",
    "Marketing Name": "TV Box",
    "Device": "HY44G",
    "Model": "TV Box"
  },
  {
    "Retail Branding": "COSTEL",
    "Marketing Name": "M16",
    "Device": "M16",
    "Model": "M16"
  },
  {
    "Retail Branding": "CP Plus",
    "Marketing Name": "CP-MUD-M721",
    "Device": "CP-MUD-M721",
    "Model": "CP-MUD-M721"
  },
  {
    "Retail Branding": "CRAIG",
    "Marketing Name": "CMP846",
    "Device": "CMP846",
    "Model": "CMP846"
  },
  {
    "Retail Branding": "CRONIC",
    "Marketing Name": "CT-M11",
    "Device": "CT-M11",
    "Model": "CT-M11"
  },
  {
    "Retail Branding": "CRONIC",
    "Marketing Name": "CT-T15G",
    "Device": "CT-T15G",
    "Model": "CT-T15G"
  },
  {
    "Retail Branding": "CRONY",
    "Marketing Name": "Smart TV",
    "Device": "longshan",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "CROWN MUSTANG",
    "Marketing Name": "ARGENTINA",
    "Device": "sepolia",
    "Model": "Crown Mustang 4K TV"
  },
  {
    "Retail Branding": "CROWN MUSTANG",
    "Marketing Name": "Argentina",
    "Device": "martin",
    "Model": "Crown Mustang 2K Android TV"
  },
  {
    "Retail Branding": "CROWN MUSTANG",
    "Marketing Name": "Argentina",
    "Device": "patrick",
    "Model": "Crown Mustang 4K Android TV"
  },
  {
    "Retail Branding": "CROWN MUSTANG",
    "Marketing Name": "Crown Mustang 2K TV",
    "Device": "dongnae",
    "Model": "Crown Mustang 2K TV"
  },
  {
    "Retail Branding": "CTOUCH",
    "Marketing Name": "CTOUCH Droid OPS Module",
    "Device": "Droid_OPS_Module",
    "Model": "UGE013AM"
  },
  {
    "Retail Branding": "CVTE",
    "Marketing Name": "CVTE SA12",
    "Device": "rk3588_t",
    "Model": "SA12 series"
  },
  {
    "Retail Branding": "CVTE",
    "Marketing Name": "Guangzhou Shirui Electronics Co., Ltd",
    "Device": "rk3576_u",
    "Model": "edu_v2"
  },
  {
    "Retail Branding": "CVTE",
    "Marketing Name": "Guangzhou Shirui Electronics Co., Ltd",
    "Device": "rk3588_t",
    "Model": "edu_v2"
  },
  {
    "Retail Branding": "CVTE",
    "Marketing Name": "general_3576",
    "Device": "oversea_b",
    "Model": "bytello_edla"
  },
  {
    "Retail Branding": "CVTE",
    "Marketing Name": "general_camera_broad",
    "Device": "rk3576_u",
    "Model": "general_edu_v2"
  },
  {
    "Retail Branding": "CVTE",
    "Marketing Name": "mensa_an64",
    "Device": "mensa",
    "Model": "mensa"
  },
  {
    "Retail Branding": "CViauto",
    "Marketing Name": "ARK01",
    "Device": "ARK01",
    "Model": "BRK7600SPL"
  },
  {
    "Retail Branding": "CWELL",
    "Marketing Name": "M10",
    "Device": "M10",
    "Model": "CWELL M10"
  },
  {
    "Retail Branding": "CWOWDEFU",
    "Marketing Name": "C10G",
    "Device": "C10G",
    "Model": "C10G"
  },
  {
    "Retail Branding": "CWOWDEFU",
    "Marketing Name": "C10W_EEA",
    "Device": "C10W_EEA",
    "Model": "C10W_EEA"
  },
  {
    "Retail Branding": "CWOWDEFU",
    "Marketing Name": "C18W",
    "Device": "C18W",
    "Model": "C18W"
  },
  {
    "Retail Branding": "CWOWDEFU",
    "Marketing Name": "C18W_EEA",
    "Device": "C18W_EEA",
    "Model": "C18W_EEA"
  },
  {
    "Retail Branding": "CWOWDEFU",
    "Marketing Name": "C28",
    "Device": "C28",
    "Model": "C28"
  },
  {
    "Retail Branding": "CWOWDEFU",
    "Marketing Name": "C29",
    "Device": "C29",
    "Model": "C29"
  },
  {
    "Retail Branding": "CWOWDEFU",
    "Marketing Name": "C29_C_EEA",
    "Device": "C29",
    "Model": "C29_C_EEA"
  },
  {
    "Retail Branding": "CWOWDEFU",
    "Marketing Name": "C6",
    "Device": "C6",
    "Model": "C6"
  },
  {
    "Retail Branding": "CWOWDEFU",
    "Marketing Name": "C6 Pro",
    "Device": "C6_Pro",
    "Model": "C6 Pro"
  },
  {
    "Retail Branding": "CWOWDEFU",
    "Marketing Name": "C6 Pro ROW",
    "Device": "C6_Pro",
    "Model": "C6 Pro"
  },
  {
    "Retail Branding": "CWOWDEFU",
    "Marketing Name": "C73W",
    "Device": "C73W",
    "Model": "C73W"
  },
  {
    "Retail Branding": "CWOWDEFU",
    "Marketing Name": "C73W_EEA",
    "Device": "C73W",
    "Model": "C73W"
  },
  {
    "Retail Branding": "CWOWDEFU",
    "Marketing Name": "C75W_EEA",
    "Device": "C75W_EEA",
    "Model": "C75W_EEA"
  },
  {
    "Retail Branding": "CWOWDEFU",
    "Marketing Name": "C77W",
    "Device": "C77W",
    "Model": "C77W"
  },
  {
    "Retail Branding": "CWOWDEFU",
    "Marketing Name": "C77W_EEA",
    "Device": "C77W_EEA",
    "Model": "C77W_EEA"
  },
  {
    "Retail Branding": "CWOWDEFU",
    "Marketing Name": "C80W",
    "Device": "C80W",
    "Model": "C80W"
  },
  {
    "Retail Branding": "CWOWDEFU",
    "Marketing Name": "C80W_EEA",
    "Device": "C80W_EEA",
    "Model": "C80W_EEA"
  },
  {
    "Retail Branding": "CWOWDEFU",
    "Marketing Name": "C82W",
    "Device": "C82W",
    "Model": "C82W"
  },
  {
    "Retail Branding": "CWOWDEFU",
    "Marketing Name": "C82W_EEA",
    "Device": "C82W_EEA",
    "Model": "C82W_EEA"
  },
  {
    "Retail Branding": "CWOWDEFU",
    "Marketing Name": "C84W",
    "Device": "C84W",
    "Model": "C84W"
  },
  {
    "Retail Branding": "CWOWDEFU",
    "Marketing Name": "C86W",
    "Device": "C86W",
    "Model": "C86W"
  },
  {
    "Retail Branding": "CWOWDEFU",
    "Marketing Name": "C86W_EEA",
    "Device": "C86W_EEA",
    "Model": "C86W_EEA"
  },
  {
    "Retail Branding": "CWOWDEFU",
    "Marketing Name": "F10L ROW",
    "Device": "F10L",
    "Model": "F10L"
  },
  {
    "Retail Branding": "CWOWDEFU",
    "Marketing Name": "F12W",
    "Device": "F12W",
    "Model": "F12W"
  },
  {
    "Retail Branding": "CWOWDEFU",
    "Marketing Name": "F12W_EEA",
    "Device": "F12W",
    "Model": "F12W_EEA"
  },
  {
    "Retail Branding": "CWOWDEFU",
    "Marketing Name": "F13W",
    "Device": "F13W",
    "Model": "F13W"
  },
  {
    "Retail Branding": "CWOWDEFU",
    "Marketing Name": "F13W_EEA",
    "Device": "F13W_EEA",
    "Model": "F13W_EEA"
  },
  {
    "Retail Branding": "CWOWDEFU",
    "Marketing Name": "F35W",
    "Device": "F35W",
    "Model": "F35W"
  },
  {
    "Retail Branding": "CWOWDEFU",
    "Marketing Name": "F36W",
    "Device": "F36W",
    "Model": "F36W"
  },
  {
    "Retail Branding": "CWOWDEFU",
    "Marketing Name": "F36W_EEA",
    "Device": "F36W_EEA",
    "Model": "F36W_EEA"
  },
  {
    "Retail Branding": "CWOWDEFU",
    "Marketing Name": "F80L",
    "Device": "F80L",
    "Model": "F80L"
  },
  {
    "Retail Branding": "CWOWDEFU",
    "Marketing Name": "F80W",
    "Device": "F80W",
    "Model": "F80W"
  },
  {
    "Retail Branding": "CWOWDEFU",
    "Marketing Name": "F80W_EEA",
    "Device": "F80W_EEA",
    "Model": "F80W_EEA"
  },
  {
    "Retail Branding": "CWOWDEFU",
    "Marketing Name": "F81L_EEA",
    "Device": "F81L",
    "Model": "F81L"
  },
  {
    "Retail Branding": "CWOWDEFU",
    "Marketing Name": "P12W",
    "Device": "P12W",
    "Model": "P12W"
  },
  {
    "Retail Branding": "CWOWDEFU",
    "Marketing Name": "P12W_EEA",
    "Device": "P12W_EEA",
    "Model": "P12W_EEA"
  },
  {
    "Retail Branding": "CWOWDEFU",
    "Marketing Name": "P15W",
    "Device": "P15W",
    "Model": "P15W"
  },
  {
    "Retail Branding": "CWOWDEFU",
    "Marketing Name": "P15W_EEA",
    "Device": "P15W_EEA",
    "Model": "P15W_EEA"
  },
  {
    "Retail Branding": "CWOWDEFU",
    "Marketing Name": "P16-C",
    "Device": "P16-C",
    "Model": "P16"
  },
  {
    "Retail Branding": "CWOWDEFU",
    "Marketing Name": "P16-C",
    "Device": "P16-C",
    "Model": "P16-C"
  },
  {
    "Retail Branding": "CWOWDEFU",
    "Marketing Name": "P20L",
    "Device": "P20L",
    "Model": "P20L"
  },
  {
    "Retail Branding": "CWOWDEFU",
    "Marketing Name": "P20L ROW",
    "Device": "P20L",
    "Model": "P20L"
  },
  {
    "Retail Branding": "CWOWDEFU",
    "Marketing Name": "P25L",
    "Device": "P25L",
    "Model": "P25L"
  },
  {
    "Retail Branding": "CWOWDEFU",
    "Marketing Name": "P25W",
    "Device": "P25W",
    "Model": "P25W"
  },
  {
    "Retail Branding": "CWOWDEFU",
    "Marketing Name": "P25W_EEA",
    "Device": "P25W_EEA",
    "Model": "P25W_EEA"
  },
  {
    "Retail Branding": "CWOWDEFU",
    "Marketing Name": "P35W",
    "Device": "P35W",
    "Model": "P35W"
  },
  {
    "Retail Branding": "CWOWDEFU",
    "Marketing Name": "P35W_EEA",
    "Device": "P35W_EEA",
    "Model": "P35W_EEA"
  },
  {
    "Retail Branding": "CWOWDEFU",
    "Marketing Name": "P38W",
    "Device": "P38W",
    "Model": "P38W"
  },
  {
    "Retail Branding": "CWOWDEFU",
    "Marketing Name": "P38W_EEA",
    "Device": "P38W_EEA",
    "Model": "P38W_EEA"
  },
  {
    "Retail Branding": "CWOWDEFU",
    "Marketing Name": "P50L",
    "Device": "P50L",
    "Model": "P50L"
  },
  {
    "Retail Branding": "CWOWDEFU",
    "Marketing Name": "P50L_EEA",
    "Device": "P50L_EEA",
    "Model": "P50L_EEA"
  },
  {
    "Retail Branding": "CWOWDEFU",
    "Marketing Name": "P80L",
    "Device": "P80L",
    "Model": "P80L"
  },
  {
    "Retail Branding": "CWOWDEFU",
    "Marketing Name": "P81L",
    "Device": "P81L",
    "Model": "P81L"
  },
  {
    "Retail Branding": "CWOWDEFU",
    "Marketing Name": "P83L",
    "Device": "P83L",
    "Model": "P83L"
  },
  {
    "Retail Branding": "CWOWDEFU",
    "Marketing Name": "S18",
    "Device": "S18",
    "Model": "S18"
  },
  {
    "Retail Branding": "CWOWDEFU",
    "Marketing Name": "S18 EEA",
    "Device": "S18",
    "Model": "S18"
  },
  {
    "Retail Branding": "CWOWDEFU",
    "Marketing Name": "S28",
    "Device": "S28",
    "Model": "S28"
  },
  {
    "Retail Branding": "CX Argentina",
    "Marketing Name": "CX9011",
    "Device": "CX9011",
    "Model": "CX9011"
  },
  {
    "Retail Branding": "CX Argentina",
    "Marketing Name": "EDU-AI",
    "Device": "SMART-BLACKBOARD",
    "Model": "EDU-AI251"
  },
  {
    "Retail Branding": "CYX Group",
    "Marketing Name": "A7008",
    "Device": "A7008",
    "Model": "A7008"
  },
  {
    "Retail Branding": "CYX Group",
    "Marketing Name": "Retailer Stores",
    "Device": "A7009",
    "Model": "A7009"
  },
  {
    "Retail Branding": "CZ Electronics",
    "Marketing Name": "M3CR",
    "Device": "Mint_Fox",
    "Model": "M3CR"
  },
  {
    "Retail Branding": "CZ Electronics",
    "Marketing Name": "M3CRD",
    "Device": "Mint_Fox",
    "Model": "M3CRD"
  },
  {
    "Retail Branding": "CZ Electronics",
    "Marketing Name": "M3s",
    "Device": "M3s",
    "Model": "M3s"
  },
  {
    "Retail Branding": "CZ Electronics",
    "Marketing Name": "M5CR",
    "Device": "M5CR",
    "Model": "M5CR"
  },
  {
    "Retail Branding": "CZ Electronics",
    "Marketing Name": "M5CRD",
    "Device": "M5CR",
    "Model": "M5CRD"
  },
  {
    "Retail Branding": "CZ Electronics",
    "Marketing Name": "M7 Sapphire",
    "Device": "M7",
    "Model": "M7"
  },
  {
    "Retail Branding": "CZ Electronics",
    "Marketing Name": "MX16",
    "Device": "Mint_Diamond",
    "Model": "MX16"
  },
  {
    "Retail Branding": "CZ Electronics",
    "Marketing Name": "Mint_Iris",
    "Device": "Mint_Iris",
    "Model": "M7L_Sapphire"
  },
  {
    "Retail Branding": "CZ Electronics",
    "Marketing Name": "Mint_Jane",
    "Device": "Mint_Jane",
    "Model": "M5E01"
  },
  {
    "Retail Branding": "CZUR",
    "Marketing Name": "StarryHub Core 50",
    "Device": "StarryHub",
    "Model": "StarryHub_Core_50"
  },
  {
    "Retail Branding": "Cablecolor",
    "Marketing Name": "CAB_TAB",
    "Device": "CAB_TAB",
    "Model": "CAB_TAB"
  },
  {
    "Retail Branding": "Cablecolor",
    "Marketing Name": "GIU3A00",
    "Device": "GIU3A00",
    "Model": "GIU3A00"
  },
  {
    "Retail Branding": "Callsky",
    "Marketing Name": "Cpad10",
    "Device": "Cpad10",
    "Model": "Cpad10"
  },
  {
    "Retail Branding": "Callsky",
    "Marketing Name": "Ctab_12",
    "Device": "Ctab_12",
    "Model": "Ctab 12"
  },
  {
    "Retail Branding": "Callsky",
    "Marketing Name": "Ctab_12",
    "Device": "Ctab_12",
    "Model": "SMART PRO 12"
  },
  {
    "Retail Branding": "Caltta",
    "Marketing Name": "e720",
    "Device": "e720",
    "Model": "e720"
  },
  {
    "Retail Branding": "Camelus",
    "Marketing Name": "L10",
    "Device": "TR-10HBT",
    "Model": "L10"
  },
  {
    "Retail Branding": "Camelus",
    "Marketing Name": "L7",
    "Device": "TR-7U",
    "Model": "L7"
  },
  {
    "Retail Branding": "Camfone",
    "Marketing Name": "ACTION",
    "Device": "ACTION",
    "Model": "ACTION"
  },
  {
    "Retail Branding": "Camfone",
    "Marketing Name": "CamPad P7",
    "Device": "CamPad_P7",
    "Model": "CamPad_P7"
  },
  {
    "Retail Branding": "Camfone",
    "Marketing Name": "Hero 11",
    "Device": "Hero_11",
    "Model": "Hero 11"
  },
  {
    "Retail Branding": "Camfone",
    "Marketing Name": "Hero 12",
    "Device": "Hero_12",
    "Model": "Hero 12"
  },
  {
    "Retail Branding": "Camfone",
    "Marketing Name": "Hero H7 Plus",
    "Device": "Hero_H7_Plus",
    "Model": "Hero_H7_Plus"
  },
  {
    "Retail Branding": "Camfone",
    "Marketing Name": "Hero H9",
    "Device": "Hero_H9",
    "Model": "Hero_H9"
  },
  {
    "Retail Branding": "Camfone",
    "Marketing Name": "Hero SE2",
    "Device": "Hero_SE2",
    "Model": "Hero_SE2"
  },
  {
    "Retail Branding": "Camfone",
    "Marketing Name": "Hero SE3 Max",
    "Device": "Hero_SE3_Max",
    "Model": "Hero SE3 Max"
  },
  {
    "Retail Branding": "Camfone",
    "Marketing Name": "Hero X",
    "Device": "Hero_X",
    "Model": "Hero X"
  },
  {
    "Retail Branding": "Camfone",
    "Marketing Name": "Hero_13",
    "Device": "Hero_13",
    "Model": "Hero_13"
  },
  {
    "Retail Branding": "Camfone",
    "Marketing Name": "Hero_H5+",
    "Device": "Hero_H5_Plus",
    "Model": "Hero_H5+"
  },
  {
    "Retail Branding": "Camfone",
    "Marketing Name": "Hero_SE3",
    "Device": "Hero_SE3",
    "Model": "Hero_SE3"
  },
  {
    "Retail Branding": "Camfone",
    "Marketing Name": "Hero_SX",
    "Device": "Hero_SX",
    "Model": "Hero SX"
  },
  {
    "Retail Branding": "Camfone",
    "Marketing Name": "Hero_XR_Plus",
    "Device": "Hero_XR_Plus",
    "Model": "Hero_XR_Plus"
  },
  {
    "Retail Branding": "Camfone",
    "Marketing Name": "Honey Y1",
    "Device": "Honey_Y1",
    "Model": "Honey Y1"
  },
  {
    "Retail Branding": "Camfone",
    "Marketing Name": "Honey_Y2s",
    "Device": "Honey_Y2s",
    "Model": "Honey Y2s"
  },
  {
    "Retail Branding": "Camfone",
    "Marketing Name": "Mega 10",
    "Device": "Mega_10",
    "Model": "Mega 10"
  },
  {
    "Retail Branding": "Canal Digital",
    "Marketing Name": "Allente 1",
    "Device": "OnePlace2",
    "Model": "Allente 1"
  },
  {
    "Retail Branding": "Canal Digital",
    "Marketing Name": "OnePlace",
    "Device": "canal_sat_bcm",
    "Model": "S70CDS"
  },
  {
    "Retail Branding": "Candi",
    "Marketing Name": "Blaze",
    "Device": "Blaze",
    "Model": "Blaze"
  },
  {
    "Retail Branding": "Candi",
    "Marketing Name": "Cola S",
    "Device": "Candi_M671M3",
    "Model": "M671M3"
  },
  {
    "Retail Branding": "Candi",
    "Marketing Name": "Cola S 4G",
    "Device": "Candi_M671M4",
    "Model": "M671M4"
  },
  {
    "Retail Branding": "Candor",
    "Marketing Name": "PHS-601",
    "Device": "phs601",
    "Model": "PHS-601"
  },
  {
    "Retail Branding": "Canguro",
    "Marketing Name": "M75TG",
    "Device": "M75TG",
    "Model": "M75TG"
  },
  {
    "Retail Branding": "Canguro",
    "Marketing Name": "M77XG",
    "Device": "M77XG",
    "Model": "M77XG"
  },
  {
    "Retail Branding": "Capstone",
    "Marketing Name": "CAP-001M",
    "Device": "CAP-001M",
    "Model": "CAP-001M"
  },
  {
    "Retail Branding": "Captiva",
    "Marketing Name": "CAPTIVA Pad 10 3G Plus",
    "Device": "Pad_10_3G_Plus",
    "Model": "Captiva Pad 10 3G Plus"
  },
  {
    "Retail Branding": "Captiva",
    "Marketing Name": "Pad 10 2-in-1",
    "Device": "Pad_10_2_in_1",
    "Model": "Pad_10_2_in_1"
  },
  {
    "Retail Branding": "Captiva",
    "Marketing Name": "Pad 10 3G pLUS",
    "Device": "Pad_10_3G_Plus",
    "Model": "Captiva Pad 10 3G Plus"
  },
  {
    "Retail Branding": "Caravan",
    "Marketing Name": "RSE_Caravan",
    "Device": "RSE_Caravan",
    "Model": "RSE"
  },
  {
    "Retail Branding": "Carbon Mobile",
    "Marketing Name": "Carbon 1 Mark II",
    "Device": "C1M2BD_R2",
    "Model": "Carbon 1 Mark II"
  },
  {
    "Retail Branding": "Carbon Mobile",
    "Marketing Name": "Carbon Mobile",
    "Device": "C1M2BD_R1",
    "Model": "C1M2BD_R1"
  },
  {
    "Retail Branding": "Carchi",
    "Marketing Name": "R10_PLUS",
    "Device": "R10_PLUS",
    "Model": "R10"
  },
  {
    "Retail Branding": "CarePad",
    "Marketing Name": "C101",
    "Device": "C101",
    "Model": "C101"
  },
  {
    "Retail Branding": "Carpe_Iter",
    "Marketing Name": "Adventure Pad",
    "Device": "CIAP1",
    "Model": "CIAP-01EU"
  },
  {
    "Retail Branding": "Carrefour",
    "Marketing Name": "CT1000",
    "Device": "Carrefour",
    "Model": "CT1000"
  },
  {
    "Retail Branding": "Carrefour",
    "Marketing Name": "CT1020W",
    "Device": "M1010FP",
    "Model": "CT1020W"
  },
  {
    "Retail Branding": "Carrefour",
    "Marketing Name": "CT1050",
    "Device": "TVE9603",
    "Model": "TVE9603I"
  },
  {
    "Retail Branding": "Carrefour",
    "Marketing Name": "CT1056_32GB",
    "Device": "CT1056_32GB",
    "Model": "CT1056_32GB"
  },
  {
    "Retail Branding": "Carrefour",
    "Marketing Name": "CT1085_ 32GB",
    "Device": "CT1085_32GB",
    "Model": "CT1085_32GB"
  },
  {
    "Retail Branding": "Carrefour",
    "Marketing Name": "CT726",
    "Device": "CT726",
    "Model": "CT726"
  },
  {
    "Retail Branding": "Carrefour",
    "Marketing Name": "CT735_16GB",
    "Device": "CT735_16GB",
    "Model": "CT735_16GB"
  },
  {
    "Retail Branding": "Carrefour",
    "Marketing Name": "CT756_16GB",
    "Device": "CT756_16GB",
    "Model": "CT756_16GB"
  },
  {
    "Retail Branding": "Carrefour",
    "Marketing Name": "CT820",
    "Device": "M878LP",
    "Model": "CT820"
  },
  {
    "Retail Branding": "Carrefour",
    "Marketing Name": "CT826",
    "Device": "CT826",
    "Model": "CT826"
  },
  {
    "Retail Branding": "Casio",
    "Marketing Name": "DT-X400",
    "Device": "dtx400",
    "Model": "DT-X400"
  },
  {
    "Retail Branding": "Casio",
    "Marketing Name": "DT-X400R",
    "Device": "dtx400r",
    "Model": "DT-X400R"
  },
  {
    "Retail Branding": "Casio",
    "Marketing Name": "ET-L10",
    "Device": "ET-L10",
    "Model": "ET-L10"
  },
  {
    "Retail Branding": "Casio",
    "Marketing Name": "GSW-H1000",
    "Device": "tai",
    "Model": "GSW-H1000"
  },
  {
    "Retail Branding": "Casio",
    "Marketing Name": "IT-G400",
    "Device": "itg400",
    "Model": "IT-G400"
  },
  {
    "Retail Branding": "Casio",
    "Marketing Name": "IT-G650",
    "Device": "itg650",
    "Model": "IT-G650"
  },
  {
    "Retail Branding": "Casio",
    "Marketing Name": "Smart Outdoor Watch WSD-F10",
    "Device": "koi",
    "Model": "CASIO WSD-F10"
  },
  {
    "Retail Branding": "Casio",
    "Marketing Name": "WSD-F20",
    "Device": "ayu",
    "Model": "CASIO WSD-F20"
  },
  {
    "Retail Branding": "Casio",
    "Marketing Name": "WSD-F20",
    "Device": "ayu",
    "Model": "CASIO WSD-F20S"
  },
  {
    "Retail Branding": "Casio",
    "Marketing Name": "WSD-F21HR",
    "Device": "medaka",
    "Model": "WSD-F21HR"
  },
  {
    "Retail Branding": "Casio",
    "Marketing Name": "WSD-F30",
    "Device": "kingyo",
    "Model": "WSD-F30"
  },
  {
    "Retail Branding": "Casio",
    "Marketing Name": "dtx450",
    "Device": "dtx450",
    "Model": "DT-X400/X450"
  },
  {
    "Retail Branding": "Casio",
    "Marketing Name": "itg600",
    "Device": "itg600",
    "Model": "IT-G600"
  },
  {
    "Retail Branding": "Casper",
    "Marketing Name": "43FGA610",
    "Device": "beaudry",
    "Model": "Casper AndroidTV"
  },
  {
    "Retail Branding": "Casper",
    "Marketing Name": "55UGA610",
    "Device": "barking",
    "Model": "Casper AndroidTV"
  },
  {
    "Retail Branding": "Casper",
    "Marketing Name": "Android TV",
    "Device": "R1",
    "Model": "ATV R1"
  },
  {
    "Retail Branding": "Casper",
    "Marketing Name": "Android TV",
    "Device": "R2",
    "Model": "ATV R2"
  },
  {
    "Retail Branding": "Casper",
    "Marketing Name": "CASPER",
    "Device": "elliniko",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "Casper",
    "Marketing Name": "CASPER",
    "Device": "lavender",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "Casper",
    "Marketing Name": "CASPER_L10_4_5G",
    "Device": "CASPER_L10_4_5G",
    "Model": "CASPER_L10_4.5G"
  },
  {
    "Retail Branding": "Casper",
    "Marketing Name": "CTP300",
    "Device": "PAD_M10",
    "Model": "CTP300"
  },
  {
    "Retail Branding": "Casper",
    "Marketing Name": "Casper 2K Smart TV",
    "Device": "sunnyvale",
    "Model": "Casper 2K Smart TV"
  },
  {
    "Retail Branding": "Casper",
    "Marketing Name": "Casper 4K TV",
    "Device": "SW6H",
    "Model": "Casper 4K TV"
  },
  {
    "Retail Branding": "Casper",
    "Marketing Name": "Casper Smart TV",
    "Device": "SW6H",
    "Model": "Casper Smart TV"
  },
  {
    "Retail Branding": "Casper",
    "Marketing Name": "Casper VIA S48",
    "Device": "VIA_S48",
    "Model": "VIA_S48"
  },
  {
    "Retail Branding": "Casper",
    "Marketing Name": "Casper VIA X20",
    "Device": "VIA_X20",
    "Model": "VIA X20"
  },
  {
    "Retail Branding": "Casper",
    "Marketing Name": "L20",
    "Device": "L20",
    "Model": "L20"
  },
  {
    "Retail Branding": "Casper",
    "Marketing Name": "Pad_H10_PEN",
    "Device": "Pad_H10_PEN",
    "Model": "Pad H10 PEN"
  },
  {
    "Retail Branding": "Casper",
    "Marketing Name": "Pad_H10_PRO",
    "Device": "Pad_H10_PRO",
    "Model": "Pad H10 PRO"
  },
  {
    "Retail Branding": "Casper",
    "Marketing Name": "R3",
    "Device": "R3",
    "Model": "R3"
  },
  {
    "Retail Branding": "Casper",
    "Marketing Name": "R3_GTV",
    "Device": "R3_GTV",
    "Model": "R3G"
  },
  {
    "Retail Branding": "Casper",
    "Marketing Name": "R4",
    "Device": "R4",
    "Model": "R4"
  },
  {
    "Retail Branding": "Casper",
    "Marketing Name": "S20",
    "Device": "S20",
    "Model": "S20"
  },
  {
    "Retail Branding": "Casper",
    "Marketing Name": "S38",
    "Device": "Casper_S38",
    "Model": "Casper_S38"
  },
  {
    "Retail Branding": "Casper",
    "Marketing Name": "TA80CA2",
    "Device": "TA80CA2_1",
    "Model": "TA80CA2"
  },
  {
    "Retail Branding": "Casper",
    "Marketing Name": "VIA A2",
    "Device": "CASPER_VIA_A2",
    "Model": "CASPER_VIA_A2"
  },
  {
    "Retail Branding": "Casper",
    "Marketing Name": "VIA A3 Plus",
    "Device": "VIA_A3_Plus",
    "Model": "VIA_A3_Plus"
  },
  {
    "Retail Branding": "Casper",
    "Marketing Name": "VIA A4",
    "Device": "VIA_A4",
    "Model": "VIA A4"
  },
  {
    "Retail Branding": "Casper",
    "Marketing Name": "VIA A40",
    "Device": "VIA_A40",
    "Model": "VIA A40"
  },
  {
    "Retail Branding": "Casper",
    "Marketing Name": "VIA A40",
    "Device": "VIA_M40",
    "Model": "VIA M40"
  },
  {
    "Retail Branding": "Casper",
    "Marketing Name": "VIA F30",
    "Device": "VIA_F30",
    "Model": "VIA F30"
  },
  {
    "Retail Branding": "Casper",
    "Marketing Name": "VIA F30 Plus",
    "Device": "VIA_F30_Plus",
    "Model": "VIA F30 Plus"
  },
  {
    "Retail Branding": "Casper",
    "Marketing Name": "VIA G1",
    "Device": "CASPER_VIA_G1",
    "Model": "CASPER_VIA_G1"
  },
  {
    "Retail Branding": "Casper",
    "Marketing Name": "VIA G1 Plus",
    "Device": "CASPER_VIA_G1_Plus",
    "Model": "CASPER_VIA_G1_Plus"
  },
  {
    "Retail Branding": "Casper",
    "Marketing Name": "VIA G5",
    "Device": "VIA_G5",
    "Model": "VIA G5"
  },
  {
    "Retail Branding": "Casper",
    "Marketing Name": "VIA L50",
    "Device": "VIA_L50",
    "Model": "VIA L50"
  },
  {
    "Retail Branding": "Casper",
    "Marketing Name": "VIA M3",
    "Device": "CASPER_VIA_M3",
    "Model": "CASPER_VIA_M3"
  },
  {
    "Retail Branding": "Casper",
    "Marketing Name": "VIA M30",
    "Device": "VIA_M30",
    "Model": "VIA M30"
  },
  {
    "Retail Branding": "Casper",
    "Marketing Name": "VIA M30 Plus",
    "Device": "VIA_M30_Plus",
    "Model": "VIA M30 Plus"
  },
  {
    "Retail Branding": "Casper",
    "Marketing Name": "VIA M35",
    "Device": "VIA_M35",
    "Model": "VIA M35"
  },
  {
    "Retail Branding": "Casper",
    "Marketing Name": "VIA M45",
    "Device": "VIA_M45",
    "Model": "VIA M45"
  },
  {
    "Retail Branding": "Casper",
    "Marketing Name": "VIA P3",
    "Device": "VIA_P3",
    "Model": "VIA_P3"
  },
  {
    "Retail Branding": "Casper",
    "Marketing Name": "VIA S50",
    "Device": "VIA_S50",
    "Model": "VIA S50"
  },
  {
    "Retail Branding": "Casper",
    "Marketing Name": "VIA T7D",
    "Device": "VIA-T7D",
    "Model": "VIA-T7D"
  },
  {
    "Retail Branding": "Casper",
    "Marketing Name": "VIA T7D 3G",
    "Device": "VIA-T7D-3G",
    "Model": "VIA-T7D-3G"
  },
  {
    "Retail Branding": "Casper",
    "Marketing Name": "VIA X20",
    "Device": "VIA_X20",
    "Model": "VIA X20"
  },
  {
    "Retail Branding": "Casper",
    "Marketing Name": "VIA X30",
    "Device": "VIA_X30",
    "Model": "VIA X30"
  },
  {
    "Retail Branding": "Casper",
    "Marketing Name": "VIA X30 Plus",
    "Device": "VIA_X30_Plus",
    "Model": "VIA X30 Plus"
  },
  {
    "Retail Branding": "Casper",
    "Marketing Name": "VIA X45",
    "Device": "VIA_X45",
    "Model": "VIA X45"
  },
  {
    "Retail Branding": "Casper",
    "Marketing Name": "VIA_ G3",
    "Device": "VIA_G3",
    "Model": "VIA_G3"
  },
  {
    "Retail Branding": "Casper",
    "Marketing Name": "VIA_A1",
    "Device": "VIA_A1",
    "Model": "VIA_A1"
  },
  {
    "Retail Branding": "Casper",
    "Marketing Name": "VIA_A1_1",
    "Device": "VIA_A1_1",
    "Model": "VIA_A1_1"
  },
  {
    "Retail Branding": "Casper",
    "Marketing Name": "VIA_A1_1",
    "Device": "VIA_F1",
    "Model": "VIA_F1"
  },
  {
    "Retail Branding": "Casper",
    "Marketing Name": "VIA_A1_Plus",
    "Device": "BBL7551TC",
    "Model": "VIA_A1_Plus"
  },
  {
    "Retail Branding": "Casper",
    "Marketing Name": "VIA_A3",
    "Device": "VIA_A3",
    "Model": "VIA_A3"
  },
  {
    "Retail Branding": "Casper",
    "Marketing Name": "VIA_E3",
    "Device": "VIA_E3",
    "Model": "VIA_E3"
  },
  {
    "Retail Branding": "Casper",
    "Marketing Name": "VIA_E3_0",
    "Device": "VIA_E30",
    "Model": "VIA_E30"
  },
  {
    "Retail Branding": "Casper",
    "Marketing Name": "VIA_E4",
    "Device": "VIA_E4",
    "Model": "VIA_E4"
  },
  {
    "Retail Branding": "Casper",
    "Marketing Name": "VIA_F20",
    "Device": "VIA_F20",
    "Model": "VIA_F20"
  },
  {
    "Retail Branding": "Casper",
    "Marketing Name": "VIA_F3",
    "Device": "VIA_F3",
    "Model": "VIA_F3"
  },
  {
    "Retail Branding": "Casper",
    "Marketing Name": "VIA_G5",
    "Device": "VIA_G5",
    "Model": "VIA G5"
  },
  {
    "Retail Branding": "Casper",
    "Marketing Name": "VIA_L30",
    "Device": "VIA_L30",
    "Model": "VIA_L30"
  },
  {
    "Retail Branding": "Casper",
    "Marketing Name": "VIA_L30_0",
    "Device": "VIA_L30_0",
    "Model": "VIA_L30_0"
  },
  {
    "Retail Branding": "Casper",
    "Marketing Name": "VIA_L40",
    "Device": "VIA_L40",
    "Model": "VIA L40"
  },
  {
    "Retail Branding": "Casper",
    "Marketing Name": "VIA_M4",
    "Device": "VIA_M4",
    "Model": "VIA_M4"
  },
  {
    "Retail Branding": "Casper",
    "Marketing Name": "VIA_P2",
    "Device": "VIA_P2",
    "Model": "VIA_P2"
  },
  {
    "Retail Branding": "Casper",
    "Marketing Name": "VIA_S",
    "Device": "VIA_S",
    "Model": "VIA_S"
  },
  {
    "Retail Branding": "Casper",
    "Marketing Name": "VIA_S10",
    "Device": "VIA_S10",
    "Model": "VIA_S10"
  },
  {
    "Retail Branding": "Casper",
    "Marketing Name": "VIA_S17",
    "Device": "VIA_S17",
    "Model": "VIA_S17"
  },
  {
    "Retail Branding": "Casper",
    "Marketing Name": "VIA_S18",
    "Device": "VIA_S18",
    "Model": "VIA_S18"
  },
  {
    "Retail Branding": "Casper",
    "Marketing Name": "VIA_S30",
    "Device": "VIA_S30",
    "Model": "VIA_S30"
  },
  {
    "Retail Branding": "Casper",
    "Marketing Name": "VIA_S30_0",
    "Device": "VIA_S30_0",
    "Model": "VIA_S30_0"
  },
  {
    "Retail Branding": "Casper",
    "Marketing Name": "VIA_S40",
    "Device": "VIA_S40",
    "Model": "VIA S40"
  },
  {
    "Retail Branding": "Casper",
    "Marketing Name": "VIA_S48_0",
    "Device": "VIA_S48_0",
    "Model": "VIA_S48_0"
  },
  {
    "Retail Branding": "Casper",
    "Marketing Name": "VIA_T41",
    "Device": "VIA_T41",
    "Model": "VIA_T41"
  },
  {
    "Retail Branding": "Casper",
    "Marketing Name": "VIA_X40",
    "Device": "VIA_X40",
    "Model": "VIA_X40"
  },
  {
    "Retail Branding": "Cat",
    "Marketing Name": "B15",
    "Device": "TOUGH",
    "Model": "B15"
  },
  {
    "Retail Branding": "Cat",
    "Marketing Name": "B15Q",
    "Device": "B15Q",
    "Model": "B15Q"
  },
  {
    "Retail Branding": "Cat",
    "Marketing Name": "B15Q",
    "Device": "CatB15Q",
    "Model": "B15Q"
  },
  {
    "Retail Branding": "Cat",
    "Marketing Name": "Cat S22 FLIP",
    "Device": "S22FLIP",
    "Model": "S22 FLIP"
  },
  {
    "Retail Branding": "Cat",
    "Marketing Name": "Cat S31",
    "Device": "CatS31",
    "Model": "S31"
  },
  {
    "Retail Branding": "Cat",
    "Marketing Name": "Cat S41",
    "Device": "CatS41",
    "Model": "S41"
  },
  {
    "Retail Branding": "Cat",
    "Marketing Name": "Cat S42",
    "Device": "S42",
    "Model": "S42"
  },
  {
    "Retail Branding": "Cat",
    "Marketing Name": "Cat S42",
    "Device": "S42G",
    "Model": "S42"
  },
  {
    "Retail Branding": "Cat",
    "Marketing Name": "Cat S48c",
    "Device": "CatS48c",
    "Model": "S48c"
  },
  {
    "Retail Branding": "Cat",
    "Marketing Name": "Cat S52",
    "Device": "CatS52",
    "Model": "S52"
  },
  {
    "Retail Branding": "Cat",
    "Marketing Name": "Cat S61",
    "Device": "CatS61",
    "Model": "S61"
  },
  {
    "Retail Branding": "Cat",
    "Marketing Name": "Cat S61B",
    "Device": "CatS61",
    "Model": "S61B"
  },
  {
    "Retail Branding": "Cat",
    "Marketing Name": "Cat S62",
    "Device": "S62",
    "Model": "S62"
  },
  {
    "Retail Branding": "Cat",
    "Marketing Name": "Cat S62 Pro",
    "Device": "S62Pro",
    "Model": "S62 Pro"
  },
  {
    "Retail Branding": "Cat",
    "Marketing Name": "Cat S75",
    "Device": "BM1S1B",
    "Model": "Cat S75"
  },
  {
    "Retail Branding": "Cat",
    "Marketing Name": "Cat S75",
    "Device": "BM1S1B",
    "Model": "S75"
  },
  {
    "Retail Branding": "Cat",
    "Marketing Name": "CatS50c",
    "Device": "CatS50c",
    "Model": "S50c"
  },
  {
    "Retail Branding": "Cat",
    "Marketing Name": "S30",
    "Device": "CatS30",
    "Model": "S30"
  },
  {
    "Retail Branding": "Cat",
    "Marketing Name": "S40",
    "Device": "CatS40",
    "Model": "S40"
  },
  {
    "Retail Branding": "Cat",
    "Marketing Name": "S50",
    "Device": "CatS50",
    "Model": "S50"
  },
  {
    "Retail Branding": "Cat",
    "Marketing Name": "S62Pro",
    "Device": "S62Pro",
    "Model": "S62 Pro"
  },
  {
    "Retail Branding": "Cathay",
    "Marketing Name": "AS01M",
    "Device": "AS01M",
    "Model": "AS01M"
  },
  {
    "Retail Branding": "Cavion",
    "Marketing Name": "Base_5.0",
    "Device": "Cavion_Base_5_0",
    "Model": "Cavion_Base_5_0"
  },
  {
    "Retail Branding": "Cavion",
    "Marketing Name": "Base_72_GO",
    "Device": "Base_72_GO",
    "Model": "Base_72_GO"
  },
  {
    "Retail Branding": "Cavion",
    "Marketing Name": "M1092Q",
    "Device": "M1092Q",
    "Model": "M1092Q"
  },
  {
    "Retail Branding": "Cavion",
    "Marketing Name": "base10.3g silver",
    "Device": "base10_3g_silver",
    "Model": "base10_3g_silver"
  },
  {
    "Retail Branding": "Caxilysh",
    "Marketing Name": "A10",
    "Device": "A10",
    "Model": "A10"
  },
  {
    "Retail Branding": "Caxilysh",
    "Marketing Name": "A10_EEA",
    "Device": "A10",
    "Model": "A10"
  },
  {
    "Retail Branding": "Cecotec",
    "Marketing Name": "R3",
    "Device": "R3",
    "Model": "R3"
  },
  {
    "Retail Branding": "Cecotec",
    "Marketing Name": "R3_GTV",
    "Device": "R3_GTV",
    "Model": "R3G"
  },
  {
    "Retail Branding": "Cecotec",
    "Marketing Name": "R4",
    "Device": "R4",
    "Model": "R4"
  },
  {
    "Retail Branding": "Cecotec",
    "Marketing Name": "R4_GTV",
    "Device": "R4_GTV",
    "Model": "R4G"
  },
  {
    "Retail Branding": "Cedar",
    "Marketing Name": "Cedar CT8X2",
    "Device": "CT8X2",
    "Model": "CT8X2"
  },
  {
    "Retail Branding": "Cedar",
    "Marketing Name": "Cedar CT8X2",
    "Device": "CT8XEU",
    "Model": "CT8XEU"
  },
  {
    "Retail Branding": "Ceibal",
    "Marketing Name": "A102",
    "Device": "A102",
    "Model": "A102"
  },
  {
    "Retail Branding": "Ceibal",
    "Marketing Name": "A81G_Ibi",
    "Device": "A81G_Ibi",
    "Model": "A81G_Ibi"
  },
  {
    "Retail Branding": "Ceibal",
    "Marketing Name": "ACRUX",
    "Device": "ACRUX",
    "Model": "ACRUX"
  },
  {
    "Retail Branding": "Ceibal",
    "Marketing Name": "Alfard",
    "Device": "Alfard",
    "Model": "Alfard"
  },
  {
    "Retail Branding": "Ceibal",
    "Marketing Name": "Alnilam",
    "Device": "H9190L",
    "Model": "Alnilam"
  },
  {
    "Retail Branding": "Ceibal",
    "Marketing Name": "BETELGEUSE",
    "Device": "BETELGEUSE",
    "Model": "BETELGEUSE"
  },
  {
    "Retail Branding": "Ceibal",
    "Marketing Name": "CEIBAL_HFP_LT",
    "Device": "CEIBAL_HFP_LT",
    "Model": "CEIBAL_HFP_LT"
  },
  {
    "Retail Branding": "Ceibal",
    "Marketing Name": "CEIBAL_HFP_LTH",
    "Device": "CEIBAL_HFP_LTH",
    "Model": "CEIBAL_HFP_LTH"
  },
  {
    "Retail Branding": "Ceibal",
    "Marketing Name": "GACRUX",
    "Device": "GACRUX",
    "Model": "GACRUX"
  },
  {
    "Retail Branding": "Ceibal",
    "Marketing Name": "Ibirapita",
    "Device": "A81F",
    "Model": "A81F"
  },
  {
    "Retail Branding": "Ceibal",
    "Marketing Name": "KIL-TAB82WIFI",
    "Device": "KIL-TAB82WIFI",
    "Model": "KIL-TAB82WIFI"
  },
  {
    "Retail Branding": "Ceibal",
    "Marketing Name": "Kil-82WFDC",
    "Device": "Kil-82WFDC",
    "Model": "Kil-82WFDC"
  },
  {
    "Retail Branding": "Ceibal",
    "Marketing Name": "RIGEL",
    "Device": "RIGEL",
    "Model": "RIGEL"
  },
  {
    "Retail Branding": "Ceibal",
    "Marketing Name": "TC80RA1",
    "Device": "TC80RA1_3",
    "Model": "TC80RA1"
  },
  {
    "Retail Branding": "Ceibal",
    "Marketing Name": "TC80RA6",
    "Device": "TC80RA6_1",
    "Model": "TC80RA6"
  },
  {
    "Retail Branding": "Ceibal",
    "Marketing Name": "U800B",
    "Device": "U800B",
    "Model": "U800B"
  },
  {
    "Retail Branding": "Celkon",
    "Marketing Name": "C10STAR",
    "Device": "C10STAR",
    "Model": "Celkon C10STAR"
  },
  {
    "Retail Branding": "Celkon",
    "Marketing Name": "CliQ 2",
    "Device": "c707_ym_n_37m35",
    "Model": "CliQ2"
  },
  {
    "Retail Branding": "Celkon",
    "Marketing Name": "Smart 4G",
    "Device": "Smart_4G",
    "Model": "Smart 4G"
  },
  {
    "Retail Branding": "Celkon",
    "Marketing Name": "Swift 4G",
    "Device": "Swift_4G",
    "Model": "Swift 4G"
  },
  {
    "Retail Branding": "Celkon",
    "Marketing Name": "uniQ",
    "Device": "UniQ",
    "Model": "UniQ"
  },
  {
    "Retail Branding": "CellAllure",
    "Marketing Name": "BIENESTAR_SMART",
    "Device": "BIENESTAR_SMART",
    "Model": "BIENESTAR_SMART"
  },
  {
    "Retail Branding": "CellAllure",
    "Marketing Name": "Cool Duo",
    "Device": "Cool_Duo",
    "Model": "Cool Duo"
  },
  {
    "Retail Branding": "CellAllure",
    "Marketing Name": "Cool_Extreme_2",
    "Device": "Cool_Extreme_2",
    "Model": "Cool_Extreme_2"
  },
  {
    "Retail Branding": "CellAllure",
    "Marketing Name": "Earn",
    "Device": "Earn",
    "Model": "Earn"
  },
  {
    "Retail Branding": "CellAllure",
    "Marketing Name": "Earn2_CL",
    "Device": "Earn2_CL",
    "Model": "Earn2 CL"
  },
  {
    "Retail Branding": "CellAllure",
    "Marketing Name": "Fashion2Plus",
    "Device": "Fashion2Plus",
    "Model": "Fashion2Plus"
  },
  {
    "Retail Branding": "CellAllure",
    "Marketing Name": "Fashion_C",
    "Device": "Fashion_C",
    "Model": "Fashion C"
  },
  {
    "Retail Branding": "CellAllure",
    "Marketing Name": "Miracle_Y",
    "Device": "Miracle_Y",
    "Model": "Miracle_Y"
  },
  {
    "Retail Branding": "Cell_C",
    "Marketing Name": "Cell C Evolve",
    "Device": "CELLC_Evolve",
    "Model": "CELLC_Evolve"
  },
  {
    "Retail Branding": "Cell_C",
    "Marketing Name": "Cell C Nitro",
    "Device": "CELLC_Nitro",
    "Model": "CELLC_Nitro"
  },
  {
    "Retail Branding": "Cell_C",
    "Marketing Name": "CellC_Extreme",
    "Device": "CELLC_Extreme",
    "Model": "CELLC_Extreme"
  },
  {
    "Retail Branding": "Cell_C",
    "Marketing Name": "Eclipse",
    "Device": "Eclipse",
    "Model": "Eclipse"
  },
  {
    "Retail Branding": "Cell_C",
    "Marketing Name": "FAME",
    "Device": "Cell_C_Fame",
    "Model": "Cell_C_Fame"
  },
  {
    "Retail Branding": "Cell_C",
    "Marketing Name": "Fantasy",
    "Device": "Cell_C",
    "Model": "Fantasy"
  },
  {
    "Retail Branding": "Cell_C",
    "Marketing Name": "JAZZ",
    "Device": "Jazz",
    "Model": "Jazz"
  },
  {
    "Retail Branding": "Cell_C",
    "Marketing Name": "Jewel",
    "Device": "Jewel",
    "Model": "Jewel"
  },
  {
    "Retail Branding": "Cell_C",
    "Marketing Name": "Luna",
    "Device": "Luna",
    "Model": "Luna"
  },
  {
    "Retail Branding": "Cell_C",
    "Marketing Name": "Summit",
    "Device": "Cell_C",
    "Model": "Summit"
  },
  {
    "Retail Branding": "Cell_C",
    "Marketing Name": "Summit Plus",
    "Device": "Summit_Plus",
    "Model": "Cell_C_Summit_Plus"
  },
  {
    "Retail Branding": "Cell_C",
    "Marketing Name": "Titan",
    "Device": "Titan",
    "Model": "Titan"
  },
  {
    "Retail Branding": "Cell_C",
    "Marketing Name": "WIZ",
    "Device": "Wiz",
    "Model": "Wiz"
  },
  {
    "Retail Branding": "Cell_C",
    "Marketing Name": "deluxe",
    "Device": "Cell_C",
    "Model": "Deluxe"
  },
  {
    "Retail Branding": "Cellacom",
    "Marketing Name": "Cellacom_S62",
    "Device": "Cellacom_S62",
    "Model": "Cellacom_S62"
  },
  {
    "Retail Branding": "Cellacom",
    "Marketing Name": "M432",
    "Device": "M432",
    "Model": "M432"
  },
  {
    "Retail Branding": "Cellacom",
    "Marketing Name": "M531",
    "Device": "M531",
    "Model": "M531"
  },
  {
    "Retail Branding": "Cellacom",
    "Marketing Name": "S51_lite",
    "Device": "S51_lite",
    "Model": "S51_lite"
  },
  {
    "Retail Branding": "Cellcom TV",
    "Marketing Name": "SEI-S905X2",
    "Device": "tai",
    "Model": "SEI-S905X2"
  },
  {
    "Retail Branding": "Cellcom TV",
    "Marketing Name": "SEI-S905X4",
    "Device": "SEI800CC",
    "Model": "SEI-S905X4"
  },
  {
    "Retail Branding": "Cellecor",
    "Marketing Name": "S2",
    "Device": "S2",
    "Model": "S2"
  },
  {
    "Retail Branding": "Cellecor",
    "Marketing Name": "S3",
    "Device": "S3",
    "Model": "S3"
  },
  {
    "Retail Branding": "Cellecor",
    "Marketing Name": "S3pro",
    "Device": "S3pro",
    "Model": "S3pro"
  },
  {
    "Retail Branding": "Cellecor",
    "Marketing Name": "S4",
    "Device": "S4",
    "Model": "S4"
  },
  {
    "Retail Branding": "Cello",
    "Marketing Name": "Cello",
    "Device": "sadang",
    "Model": "cello 4K Android TV"
  },
  {
    "Retail Branding": "Cello",
    "Marketing Name": "Cello",
    "Device": "sadang",
    "Model": "cello UK 4K Android TV"
  },
  {
    "Retail Branding": "Cello",
    "Marketing Name": "Cello",
    "Device": "tabata",
    "Model": "cello 2K Android TV"
  },
  {
    "Retail Branding": "Cello",
    "Marketing Name": "Smart TV",
    "Device": "ueno",
    "Model": "2K Android TV"
  },
  {
    "Retail Branding": "Cello",
    "Marketing Name": "T1045PC",
    "Device": "T1045PC",
    "Model": "T1045PC"
  },
  {
    "Retail Branding": "Cello",
    "Marketing Name": "T1045PN",
    "Device": "T1045PN",
    "Model": "T1045PN"
  },
  {
    "Retail Branding": "Cellon",
    "Marketing Name": "A27",
    "Device": "C8680",
    "Model": "A27"
  },
  {
    "Retail Branding": "Cellon",
    "Marketing Name": "A5801",
    "Device": "C8680",
    "Model": "A5801"
  },
  {
    "Retail Branding": "Cellon",
    "Marketing Name": "Alpha Ice",
    "Device": "M8047",
    "Model": "Alpha Ice"
  },
  {
    "Retail Branding": "Cellon",
    "Marketing Name": "C3668",
    "Device": "C3668",
    "Model": "C3668"
  },
  {
    "Retail Branding": "Cellon",
    "Marketing Name": "CI",
    "Device": "Dream-C1",
    "Model": "CI"
  },
  {
    "Retail Branding": "Cellon",
    "Marketing Name": "CJ-1984",
    "Device": "C8690",
    "Model": "C8690"
  },
  {
    "Retail Branding": "Cellon",
    "Marketing Name": "CJ-1984",
    "Device": "C8690",
    "Model": "CJ-1984"
  },
  {
    "Retail Branding": "Cellon",
    "Marketing Name": "CJ-1984",
    "Device": "C8690",
    "Model": "ELITE 4.7 HD"
  },
  {
    "Retail Branding": "Cellon",
    "Marketing Name": "EI",
    "Device": "Dream-E1",
    "Model": "EI"
  },
  {
    "Retail Branding": "Cellon",
    "Marketing Name": "EIII",
    "Device": "Dream-E3",
    "Model": "EIII"
  },
  {
    "Retail Branding": "Cellon",
    "Marketing Name": "EK-8680",
    "Device": "C8680",
    "Model": "EK-8680"
  },
  {
    "Retail Branding": "Cellon",
    "Marketing Name": "Explosion",
    "Device": "C8690",
    "Model": "Explosion"
  },
  {
    "Retail Branding": "Cellon",
    "Marketing Name": "HW-W900",
    "Device": "C8690",
    "Model": "HW-W900"
  },
  {
    "Retail Branding": "Cellon",
    "Marketing Name": "HWW820",
    "Device": "C8680",
    "Model": "HW-W820"
  },
  {
    "Retail Branding": "Cellon",
    "Marketing Name": "Houston",
    "Device": "C8680",
    "Model": "Houston"
  },
  {
    "Retail Branding": "Cellon",
    "Marketing Name": "ICON",
    "Device": "ICON",
    "Model": "ICON"
  },
  {
    "Retail Branding": "Cellon",
    "Marketing Name": "IQ 1.1",
    "Device": "IQ1-1",
    "Model": "i-mobile IQ1-1"
  },
  {
    "Retail Branding": "Cellon",
    "Marketing Name": "Linx PS474S",
    "Device": "C8690",
    "Model": "Linx PS474S"
  },
  {
    "Retail Branding": "Cellon",
    "Marketing Name": "MTC SMART Run",
    "Device": "SMART_Run",
    "Model": "MTC SMART Run"
  },
  {
    "Retail Branding": "Cellon",
    "Marketing Name": "Mach",
    "Device": "C8680",
    "Model": "Mach"
  },
  {
    "Retail Branding": "Cellon",
    "Marketing Name": "Newman N2",
    "Device": "C8690",
    "Model": "Newman N2"
  },
  {
    "Retail Branding": "Cellon",
    "Marketing Name": "Q",
    "Device": "M8047XT",
    "Model": "Q"
  },
  {
    "Retail Branding": "Cellon",
    "Marketing Name": "S21",
    "Device": "S21",
    "Model": "Q-Smart S21"
  },
  {
    "Retail Branding": "Cellon",
    "Marketing Name": "SI",
    "Device": "Dream-S1",
    "Model": "SI"
  },
  {
    "Retail Branding": "Cellon",
    "Marketing Name": "SM55",
    "Device": "C8660",
    "Model": "C8660"
  },
  {
    "Retail Branding": "Cellon",
    "Marketing Name": "SM55",
    "Device": "C8660",
    "Model": "SM55"
  },
  {
    "Retail Branding": "Cellon",
    "Marketing Name": "Starmobile KNIGHT",
    "Device": "KNIGHT",
    "Model": "Starmobile KNIGHT"
  },
  {
    "Retail Branding": "Cellon",
    "Marketing Name": "VEON_C8680",
    "Device": "C8680",
    "Model": "VEON_C8680"
  },
  {
    "Retail Branding": "Cellon",
    "Marketing Name": "i-STYLE7",
    "Device": "c8669SA",
    "Model": "i-mobile i-STYLE 7"
  },
  {
    "Retail Branding": "Cellon",
    "Marketing Name": "i-STYLE7A",
    "Device": "c8669SA",
    "Model": "i-mobile i-STYLE 7A"
  },
  {
    "Retail Branding": "Cellon",
    "Marketing Name": "i-mobile IQ X",
    "Device": "M8047SA",
    "Model": "i-mobile IQ X"
  },
  {
    "Retail Branding": "Cellon",
    "Marketing Name": "i-mobile IQ X",
    "Device": "M8047SA",
    "Model": "i-mobile IQ XA"
  },
  {
    "Retail Branding": "Cellon",
    "Marketing Name": "i-mobile IQ X2A",
    "Device": "M8050SA",
    "Model": "i-mobile IQ X2"
  },
  {
    "Retail Branding": "Cellon",
    "Marketing Name": "i-mobile IQ X2A",
    "Device": "M8050SA",
    "Model": "i-mobile IQ X2A"
  },
  {
    "Retail Branding": "Cellon",
    "Marketing Name": "iris pro 30",
    "Device": "pro30",
    "Model": "iris pro 30"
  },
  {
    "Retail Branding": "Cellon",
    "Marketing Name": "starTIM1",
    "Device": "starTIM1",
    "Model": "starTIM1"
  },
  {
    "Retail Branding": "Cellution",
    "Marketing Name": "COSMAS_T",
    "Device": "COSMAS_T",
    "Model": "COSMAS T"
  },
  {
    "Retail Branding": "Cellution",
    "Marketing Name": "COSMAS_TF",
    "Device": "COSMAS_TF",
    "Model": "COSMAS_TF"
  },
  {
    "Retail Branding": "Cellution",
    "Marketing Name": "COSMAS_X",
    "Device": "COSMAS_X",
    "Model": "COSMAS X"
  },
  {
    "Retail Branding": "Cellution",
    "Marketing Name": "CT_Cosmas_V",
    "Device": "CT_Cosmas_V",
    "Model": "CT_Cosmas_V"
  },
  {
    "Retail Branding": "Cellution",
    "Marketing Name": "Cosmas",
    "Device": "Cosmas",
    "Model": "Cosmas"
  },
  {
    "Retail Branding": "Cellution",
    "Marketing Name": "IRIS",
    "Device": "IRIS",
    "Model": "IRIS"
  },
  {
    "Retail Branding": "Cellution",
    "Marketing Name": "IRIS_EV",
    "Device": "IRIS_EV",
    "Model": "IRIS_EV"
  },
  {
    "Retail Branding": "Cellution",
    "Marketing Name": "PADUA",
    "Device": "PADUA",
    "Model": "PADUA"
  },
  {
    "Retail Branding": "Cellution",
    "Marketing Name": "PADUA_1",
    "Device": "PADUA_1",
    "Model": "PADUA_1"
  },
  {
    "Retail Branding": "Celtiis",
    "Marketing Name": "Celtiis Smart 2",
    "Device": "H6032",
    "Model": "Celtiis Smart 2"
  },
  {
    "Retail Branding": "Centerm",
    "Marketing Name": "CTA Q7",
    "Device": "SmartPOS",
    "Model": "CTA Q7"
  },
  {
    "Retail Branding": "Centerm",
    "Marketing Name": "K6",
    "Device": "K6",
    "Model": "K6"
  },
  {
    "Retail Branding": "Centric",
    "Marketing Name": "Centric L3",
    "Device": "L3",
    "Model": "Centric CM3331"
  },
  {
    "Retail Branding": "Centric",
    "Marketing Name": "Centric L4",
    "Device": "Centric_L4",
    "Model": "Centric L4"
  },
  {
    "Retail Branding": "Centric",
    "Marketing Name": "G1",
    "Device": "CM4331",
    "Model": "CM4331"
  },
  {
    "Retail Branding": "Centric",
    "Marketing Name": "G1",
    "Device": "CM4331",
    "Model": "G1"
  },
  {
    "Retail Branding": "CenturyLink",
    "Marketing Name": "PureTV",
    "Device": "ctl_iptv_mrvl",
    "Model": "CTLPlayer"
  },
  {
    "Retail Branding": "CenturyLink",
    "Marketing Name": "PureTV",
    "Device": "ctl_iptv_mrvl",
    "Model": "S60CLI"
  },
  {
    "Retail Branding": "ChaCh",
    "Marketing Name": "CH_101",
    "Device": "CH-101",
    "Model": "CH-101"
  },
  {
    "Retail Branding": "Challenger",
    "Marketing Name": "4K Smart TV",
    "Device": "gangbyeon",
    "Model": "Challenger 4K AI Smart TV"
  },
  {
    "Retail Branding": "Challenger",
    "Marketing Name": "55BO67",
    "Device": "barking",
    "Model": "CHALLENGER AndroidTV"
  },
  {
    "Retail Branding": "Challenger",
    "Marketing Name": "Android TV",
    "Device": "R1",
    "Model": "ATV R1"
  },
  {
    "Retail Branding": "Challenger",
    "Marketing Name": "Android TV",
    "Device": "R2",
    "Model": "ATV R2"
  },
  {
    "Retail Branding": "Challenger",
    "Marketing Name": "CHALLENGER",
    "Device": "jagalchi",
    "Model": "2K SMART TV"
  },
  {
    "Retail Branding": "Challenger",
    "Marketing Name": "CHALLENGER",
    "Device": "lavender",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "Challenger",
    "Marketing Name": "CHALLENGER",
    "Device": "mountbaker",
    "Model": "2K SMART TV"
  },
  {
    "Retail Branding": "Challenger",
    "Marketing Name": "R3",
    "Device": "R3",
    "Model": "R3"
  },
  {
    "Retail Branding": "Challenger",
    "Marketing Name": "R3_GTV",
    "Device": "R3_GTV",
    "Model": "R3G"
  },
  {
    "Retail Branding": "Challenger",
    "Marketing Name": "R4",
    "Device": "R4",
    "Model": "R4"
  },
  {
    "Retail Branding": "Challenger",
    "Marketing Name": "R4_GTV",
    "Device": "R4_GTV",
    "Model": "R4G"
  },
  {
    "Retail Branding": "Challenger",
    "Marketing Name": "Smart TV",
    "Device": "osaki",
    "Model": "2K AI Smart TV"
  },
  {
    "Retail Branding": "Challenger",
    "Marketing Name": "challenger",
    "Device": "elliniko",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "Challenger",
    "Marketing Name": "challenger",
    "Device": "stanford",
    "Model": "40DCOL"
  },
  {
    "Retail Branding": "Challenger",
    "Marketing Name": "challenger",
    "Device": "zhongshan",
    "Model": "43FCOL"
  },
  {
    "Retail Branding": "Chameleon",
    "Marketing Name": "Chameleon-H",
    "Device": "Chameleon-H",
    "Model": "E9XG-A05-M"
  },
  {
    "Retail Branding": "Champtek",
    "Marketing Name": "X-120",
    "Device": "X-120",
    "Model": "X-120"
  },
  {
    "Retail Branding": "Chanbly",
    "Marketing Name": "q7",
    "Device": "q7",
    "Model": "q7"
  },
  {
    "Retail Branding": "Changhong",
    "Marketing Name": "Android TV",
    "Device": "ikebukuro",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "Changhong",
    "Marketing Name": "Android TV",
    "Device": "sindorim",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "Changhong",
    "Marketing Name": "G7P",
    "Device": "hapjeong",
    "Model": "AI PONT PLUS"
  },
  {
    "Retail Branding": "Changhong",
    "Marketing Name": "GIU6060",
    "Device": "GIU6060",
    "Model": "GIU6060"
  },
  {
    "Retail Branding": "Changhong",
    "Marketing Name": "GIU6860",
    "Device": "GIU6860",
    "Model": "GIU6860"
  },
  {
    "Retail Branding": "Changhong",
    "Marketing Name": "H7",
    "Device": "redwood",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "Changhong",
    "Marketing Name": "L32H7",
    "Device": "ikebukuro",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "Changhong",
    "Marketing Name": "L32H7",
    "Device": "ikebukuro",
    "Model": "CHiQ AI Center"
  },
  {
    "Retail Branding": "Changhong",
    "Marketing Name": "Smart TV",
    "Device": "dangni",
    "Model": "evvoli Google TV"
  },
  {
    "Retail Branding": "Changhong",
    "Marketing Name": "Smart TV",
    "Device": "longshan",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "Changhong",
    "Marketing Name": "U50H7",
    "Device": "samseong",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "Changhong",
    "Marketing Name": "U50H7",
    "Device": "samseong",
    "Model": "CHiQ AI Center"
  },
  {
    "Retail Branding": "Changhong",
    "Marketing Name": "UHD Android TV",
    "Device": "sindorim",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "Channel Master",
    "Marketing Name": "Stream+",
    "Device": "dwt765cha",
    "Model": "CM-7600"
  },
  {
    "Retail Branding": "Chargespot",
    "Marketing Name": "Stackable_Unit",
    "Device": "Stackable_Unit",
    "Model": "CSAP04011"
  },
  {
    "Retail Branding": "Chemist Warehouse",
    "Marketing Name": "JR-MB603",
    "Device": "JR_MB603",
    "Model": "JR_MB603"
  },
  {
    "Retail Branding": "Chenrui",
    "Marketing Name": "M40",
    "Device": "M40",
    "Model": "M40"
  },
  {
    "Retail Branding": "Cherry Mobile",
    "Marketing Name": "A1090",
    "Device": "A1090",
    "Model": "A1090"
  },
  {
    "Retail Branding": "Cherry Mobile",
    "Marketing Name": "A1100",
    "Device": "A1100",
    "Model": "A1100"
  },
  {
    "Retail Branding": "Cherry Mobile",
    "Marketing Name": "A1130",
    "Device": "A1130",
    "Model": "A1130"
  },
  {
    "Retail Branding": "Cherry Mobile",
    "Marketing Name": "A1240",
    "Device": "A1240",
    "Model": "A1240"
  },
  {
    "Retail Branding": "Cherry Mobile",
    "Marketing Name": "A810",
    "Device": "A810",
    "Model": "Superion S1 Plus DTV"
  },
  {
    "Retail Branding": "Cherry Mobile",
    "Marketing Name": "A840",
    "Device": "A840",
    "Model": "Flare Tab Ultra"
  },
  {
    "Retail Branding": "Cherry Mobile",
    "Marketing Name": "A850",
    "Device": "A850",
    "Model": "A850"
  },
  {
    "Retail Branding": "Cherry Mobile",
    "Marketing Name": "A860",
    "Device": "A860",
    "Model": "A860"
  },
  {
    "Retail Branding": "Cherry Mobile",
    "Marketing Name": "A890",
    "Device": "A890",
    "Model": "A890"
  },
  {
    "Retail Branding": "Cherry Mobile",
    "Marketing Name": "A930",
    "Device": "A930",
    "Model": "A930"
  },
  {
    "Retail Branding": "Cherry Mobile",
    "Marketing Name": "A940",
    "Device": "A940",
    "Model": "A940"
  },
  {
    "Retail Branding": "Cherry Mobile",
    "Marketing Name": "Aqua S10",
    "Device": "Aqua_S10",
    "Model": "Aqua S10"
  },
  {
    "Retail Branding": "Cherry Mobile",
    "Marketing Name": "Aqua S10 Pro",
    "Device": "Aqua_S10_Pro",
    "Model": "Aqua S10 Pro"
  },
  {
    "Retail Branding": "Cherry Mobile",
    "Marketing Name": "Aqua S10 Pro 5G",
    "Device": "Aqua_S10_Pro_5G",
    "Model": "Aqua S10 Pro 5G"
  },
  {
    "Retail Branding": "Cherry Mobile",
    "Marketing Name": "Aqua S9",
    "Device": "Aqua_S9",
    "Model": "Aqua S9"
  },
  {
    "Retail Branding": "Cherry Mobile",
    "Marketing Name": "Aqua S9 Lite",
    "Device": "X1020",
    "Model": "Aqua S9 lite"
  },
  {
    "Retail Branding": "Cherry Mobile",
    "Marketing Name": "Aqua S9 Max",
    "Device": "Aqua_S9_Max",
    "Model": "Aqua S9 Max"
  },
  {
    "Retail Branding": "Cherry Mobile",
    "Marketing Name": "Aqua SV",
    "Device": "Aqua_SV",
    "Model": "Aqua SV"
  },
  {
    "Retail Branding": "Cherry Mobile",
    "Marketing Name": "Aqua Tab",
    "Device": "Cherry_Aqua_Tab_S1",
    "Model": "A870"
  },
  {
    "Retail Branding": "Cherry Mobile",
    "Marketing Name": "Aqua Tab Deluxe",
    "Device": "A950",
    "Model": "A950"
  },
  {
    "Retail Branding": "Cherry Mobile",
    "Marketing Name": "Aqua_Infinity",
    "Device": "Aqua_Infinity",
    "Model": "Aqua_Infinity"
  },
  {
    "Retail Branding": "Cherry Mobile",
    "Marketing Name": "Aqua_Pad",
    "Device": "Aqua_Pad",
    "Model": "Aqua Pad"
  },
  {
    "Retail Branding": "Cherry Mobile",
    "Marketing Name": "Aqua_Tab_S1_2023",
    "Device": "Aqua_Tab_S1_2023",
    "Model": "A1250"
  },
  {
    "Retail Branding": "Cherry Mobile",
    "Marketing Name": "Aqua_Tab_S2_Pro",
    "Device": "Aqua_Tab_S2_Pro",
    "Model": "Aqua_Tab_S2_Pro"
  },
  {
    "Retail Branding": "Cherry Mobile",
    "Marketing Name": "Aqua_Tab_Ultra",
    "Device": "Aqua_Tab_Ultra",
    "Model": "Aqua_Tab_Ultra"
  },
  {
    "Retail Branding": "Cherry Mobile",
    "Marketing Name": "Cherry Comet",
    "Device": "Cherry_Comet",
    "Model": "A870"
  },
  {
    "Retail Branding": "Cherry Mobile",
    "Marketing Name": "Cherry S8 Deluxe",
    "Device": "Flare_S8_Deluxe",
    "Model": "Flare_S8_Deluxe"
  },
  {
    "Retail Branding": "Cherry Mobile",
    "Marketing Name": "Cherry W900 LTE",
    "Device": "al7",
    "Model": "W900 LTE"
  },
  {
    "Retail Branding": "Cherry Mobile",
    "Marketing Name": "CherryRoam",
    "Device": "CherryRoam",
    "Model": "CherryRoam"
  },
  {
    "Retail Branding": "Cherry Mobile",
    "Marketing Name": "DOH01",
    "Device": "DOH01",
    "Model": "DOH01"
  },
  {
    "Retail Branding": "Cherry Mobile",
    "Marketing Name": "DOH02",
    "Device": "DOH02",
    "Model": "DOH02"
  },
  {
    "Retail Branding": "Cherry Mobile",
    "Marketing Name": "Desire R6",
    "Device": "Desire_R6",
    "Model": "Desire R6"
  },
  {
    "Retail Branding": "Cherry Mobile",
    "Marketing Name": "Desire R6 Lite",
    "Device": "Desire_R6_Lite",
    "Model": "Desire_R6_Lite"
  },
  {
    "Retail Branding": "Cherry Mobile",
    "Marketing Name": "Desire R6 Plus",
    "Device": "Desire_R6_plus",
    "Model": "Desire R6 plus"
  },
  {
    "Retail Branding": "Cherry Mobile",
    "Marketing Name": "Desire R7 Lite",
    "Device": "Desire_R7_Lite",
    "Model": "Desire R7 Lite"
  },
  {
    "Retail Branding": "Cherry Mobile",
    "Marketing Name": "Desire R8 Lite",
    "Device": "Desire_R8_Lite",
    "Model": "Desire R8 Lite"
  },
  {
    "Retail Branding": "Cherry Mobile",
    "Marketing Name": "FB100",
    "Device": "FB100",
    "Model": "FB100"
  },
  {
    "Retail Branding": "Cherry Mobile",
    "Marketing Name": "FLARE S6 Lite",
    "Device": "Flare_S6_Lite",
    "Model": "Flare_S6_Lite"
  },
  {
    "Retail Branding": "Cherry Mobile",
    "Marketing Name": "Flare 5",
    "Device": "X630",
    "Model": "Flare_5"
  },
  {
    "Retail Branding": "Cherry Mobile",
    "Marketing Name": "Flare A1",
    "Device": "FlareA1",
    "Model": "FlareA1"
  },
  {
    "Retail Branding": "Cherry Mobile",
    "Marketing Name": "Flare A2",
    "Device": "Flare_A2",
    "Model": "Flare_A2"
  },
  {
    "Retail Branding": "Cherry Mobile",
    "Marketing Name": "Flare A2 Lite",
    "Device": "Flare_A2_Lite",
    "Model": "Flare_A2_Lite"
  },
  {
    "Retail Branding": "Cherry Mobile",
    "Marketing Name": "Flare A5",
    "Device": "Cherry_X740",
    "Model": "Cherry_X740"
  },
  {
    "Retail Branding": "Cherry Mobile",
    "Marketing Name": "Flare HD 3",
    "Device": "Flare_HD_3",
    "Model": "Flare HD 3"
  },
  {
    "Retail Branding": "Cherry Mobile",
    "Marketing Name": "Flare HD 4",
    "Device": "Flare_HD_4",
    "Model": "Flare_HD_4"
  },
  {
    "Retail Branding": "Cherry Mobile",
    "Marketing Name": "Flare HD Max",
    "Device": "Flare_HD_MAX",
    "Model": "Flare_HD_MAX"
  },
  {
    "Retail Branding": "Cherry Mobile",
    "Marketing Name": "Flare J1 Lite",
    "Device": "Flare_J1_Lite",
    "Model": "Flare J1 Lite"
  },
  {
    "Retail Branding": "Cherry Mobile",
    "Marketing Name": "Flare J2 2018",
    "Device": "Flare_J2_2018",
    "Model": "Flare_J2_2018"
  },
  {
    "Retail Branding": "Cherry Mobile",
    "Marketing Name": "Flare J2 Lite",
    "Device": "Flare_J2_Lite",
    "Model": "Flare_J2_Lite"
  },
  {
    "Retail Branding": "Cherry Mobile",
    "Marketing Name": "Flare J2 Max",
    "Device": "Flare_J2_Max",
    "Model": "Flare_J2_Max"
  },
  {
    "Retail Branding": "Cherry Mobile",
    "Marketing Name": "Flare J2 Mini",
    "Device": "Flare_J2_Mini",
    "Model": "Flare J2 Mini"
  },
  {
    "Retail Branding": "Cherry Mobile",
    "Marketing Name": "Flare J2 Prime",
    "Device": "Flare_J2_Prime",
    "Model": "Flare_J2_Prime"
  },
  {
    "Retail Branding": "Cherry Mobile",
    "Marketing Name": "Flare J2S",
    "Device": "Flare_J2S",
    "Model": "Flare J2S"
  },
  {
    "Retail Branding": "Cherry Mobile",
    "Marketing Name": "Flare J3",
    "Device": "FlareJ3",
    "Model": "FlareJ3"
  },
  {
    "Retail Branding": "Cherry Mobile",
    "Marketing Name": "Flare J3",
    "Device": "H680",
    "Model": "Flare_J3"
  },
  {
    "Retail Branding": "Cherry Mobile",
    "Marketing Name": "Flare J3 2019",
    "Device": "Flare_J3_2019",
    "Model": "Flare J3 2019"
  },
  {
    "Retail Branding": "Cherry Mobile",
    "Marketing Name": "Flare J3 Max",
    "Device": "Flare_J3_Max",
    "Model": "Flare J3 Max"
  },
  {
    "Retail Branding": "Cherry Mobile",
    "Marketing Name": "Flare J3 Plus",
    "Device": "FlareJ3Plus",
    "Model": "FlareJ3Plus"
  },
  {
    "Retail Branding": "Cherry Mobile",
    "Marketing Name": "Flare J3 Plus",
    "Device": "H620",
    "Model": "Flare_J3_Plus"
  },
  {
    "Retail Branding": "Cherry Mobile",
    "Marketing Name": "Flare J3 mini",
    "Device": "Flare_J3_mini",
    "Model": "Flare J3 mini"
  },
  {
    "Retail Branding": "Cherry Mobile",
    "Marketing Name": "Flare J3s",
    "Device": "Flare_J3s",
    "Model": "Flare J3s"
  },
  {
    "Retail Branding": "Cherry Mobile",
    "Marketing Name": "Flare J5 Mini",
    "Device": "Flare_J5_Mini",
    "Model": "Flare J5 Mini"
  },
  {
    "Retail Branding": "Cherry Mobile",
    "Marketing Name": "Flare J5s",
    "Device": "Flare_J5s",
    "Model": "Flare J5s"
  },
  {
    "Retail Branding": "Cherry Mobile",
    "Marketing Name": "Flare J6",
    "Device": "Flare_J6",
    "Model": "Flare J6"
  },
  {
    "Retail Branding": "Cherry Mobile",
    "Marketing Name": "Flare J6 Plus",
    "Device": "Flare_J6_Plus",
    "Model": "Flare J6 Plus"
  },
  {
    "Retail Branding": "Cherry Mobile",
    "Marketing Name": "Flare J6 mini",
    "Device": "Flare_J6_mini",
    "Model": "Flare_J6_mini"
  },
  {
    "Retail Branding": "Cherry Mobile",
    "Marketing Name": "Flare J6S",
    "Device": "Flare_J6s",
    "Model": "Flare_J6s"
  },
  {
    "Retail Branding": "Cherry Mobile",
    "Marketing Name": "Flare J7",
    "Device": "Flare_J7",
    "Model": "Flare J7"
  },
  {
    "Retail Branding": "Cherry Mobile",
    "Marketing Name": "Flare J8",
    "Device": "Flare_J8",
    "Model": "Flare J8"
  },
  {
    "Retail Branding": "Cherry Mobile",
    "Marketing Name": "Flare J8 LTE",
    "Device": "Flare_J8_LTE",
    "Model": "Flare J8 LTE"
  },
  {
    "Retail Branding": "Cherry Mobile",
    "Marketing Name": "Flare Lite 3S",
    "Device": "Flare_Lite_3S",
    "Model": "Flare_Lite_3S"
  },
  {
    "Retail Branding": "Cherry Mobile",
    "Marketing Name": "Flare P1",
    "Device": "Flare_P1",
    "Model": "Flare P1"
  },
  {
    "Retail Branding": "Cherry Mobile",
    "Marketing Name": "Flare P1 Lite",
    "Device": "Flare_P1_Lite",
    "Model": "Flare_P1_Lite"
  },
  {
    "Retail Branding": "Cherry Mobile",
    "Marketing Name": "Flare P1 Mini",
    "Device": "Flare_P1_Mini",
    "Model": "Flare_P1_Mini"
  },
  {
    "Retail Branding": "Cherry Mobile",
    "Marketing Name": "Flare P1 Plus",
    "Device": "Flare_P1_Plus",
    "Model": "Flare P1 Plus"
  },
  {
    "Retail Branding": "Cherry Mobile",
    "Marketing Name": "Flare P3",
    "Device": "Flare_P3",
    "Model": "Flare_P3"
  },
  {
    "Retail Branding": "Cherry Mobile",
    "Marketing Name": "Flare P3 Plus",
    "Device": "Flare_P3_Plus",
    "Model": "Flare_P3_Plus"
  },
  {
    "Retail Branding": "Cherry Mobile",
    "Marketing Name": "Flare P3 lite",
    "Device": "Flare_P3_lite",
    "Model": "Flare_P3_lite"
  },
  {
    "Retail Branding": "Cherry Mobile",
    "Marketing Name": "Flare S5",
    "Device": "Flare_S5",
    "Model": "Flare S5"
  },
  {
    "Retail Branding": "Cherry Mobile",
    "Marketing Name": "Flare S5 Lite DTV",
    "Device": "FlareS5LiteDTV",
    "Model": "FlareS5LiteDTV"
  },
  {
    "Retail Branding": "Cherry Mobile",
    "Marketing Name": "Flare S5 Max",
    "Device": "FLARE_S5_MAX",
    "Model": "FLARE S5 MAX"
  },
  {
    "Retail Branding": "Cherry Mobile",
    "Marketing Name": "Flare S5 Plus",
    "Device": "Flare_S5_Plus",
    "Model": "Flare S5 Plus"
  },
  {
    "Retail Branding": "Cherry Mobile",
    "Marketing Name": "Flare S6",
    "Device": "Cherry_Flare_S6",
    "Model": "Flare S6"
  },
  {
    "Retail Branding": "Cherry Mobile",
    "Marketing Name": "Flare S6 Max",
    "Device": "Flare_S6_Max",
    "Model": "Flare_S6_Max"
  },
  {
    "Retail Branding": "Cherry Mobile",
    "Marketing Name": "Flare S6 Plus",
    "Device": "Flare_S6_Plus",
    "Model": "Flare_S6_Plus"
  },
  {
    "Retail Branding": "Cherry Mobile",
    "Marketing Name": "Flare S6 Power",
    "Device": "Cherry_S6_Power",
    "Model": "FLARE S6 POWER"
  },
  {
    "Retail Branding": "Cherry Mobile",
    "Marketing Name": "Flare S6 Selfie",
    "Device": "Cherry_Selfie",
    "Model": "Flare S6 Selfie"
  },
  {
    "Retail Branding": "Cherry Mobile",
    "Marketing Name": "Flare S7",
    "Device": "Flare_S7",
    "Model": "Flare_S7"
  },
  {
    "Retail Branding": "Cherry Mobile",
    "Marketing Name": "Flare S7 Deluxe",
    "Device": "Flare_S7_Deluxe",
    "Model": "Flare_S7_Deluxe"
  },
  {
    "Retail Branding": "Cherry Mobile",
    "Marketing Name": "Flare S7 Lite",
    "Device": "Flare_S7_Lite",
    "Model": "Flare S7 Lite"
  },
  {
    "Retail Branding": "Cherry Mobile",
    "Marketing Name": "Flare S7 Max",
    "Device": "Flare_S7_Max",
    "Model": "Flare S7 Max"
  },
  {
    "Retail Branding": "Cherry Mobile",
    "Marketing Name": "Flare S7 Mini",
    "Device": "Flare_S7_Mini",
    "Model": "Flare_S7_Mini"
  },
  {
    "Retail Branding": "Cherry Mobile",
    "Marketing Name": "Flare S7 Plus",
    "Device": "Flare_S7_Plus",
    "Model": "Flare S7 Plus"
  },
  {
    "Retail Branding": "Cherry Mobile",
    "Marketing Name": "Flare S7 Power",
    "Device": "Flare_S7_Power",
    "Model": "Flare_S7_Power"
  },
  {
    "Retail Branding": "Cherry Mobile",
    "Marketing Name": "Flare S8",
    "Device": "X930",
    "Model": "Flare S8"
  },
  {
    "Retail Branding": "Cherry Mobile",
    "Marketing Name": "Flare S8 2020",
    "Device": "X930A",
    "Model": "Flare S8 2020"
  },
  {
    "Retail Branding": "Cherry Mobile",
    "Marketing Name": "Flare S8 2020",
    "Device": "X930B",
    "Model": "Flare S8 2020"
  },
  {
    "Retail Branding": "Cherry Mobile",
    "Marketing Name": "Flare S8 Lite",
    "Device": "H1950",
    "Model": "Flare S8 Lite"
  },
  {
    "Retail Branding": "Cherry Mobile",
    "Marketing Name": "Flare S8 Max",
    "Device": "X970",
    "Model": "Flare S8 Max"
  },
  {
    "Retail Branding": "Cherry Mobile",
    "Marketing Name": "Flare S8e",
    "Device": "H1990",
    "Model": "Flare S8e"
  },
  {
    "Retail Branding": "Cherry Mobile",
    "Marketing Name": "Flare Tab",
    "Device": "A830",
    "Model": "Flare Tab"
  },
  {
    "Retail Branding": "Cherry Mobile",
    "Marketing Name": "Flare Tab Pro",
    "Device": "A820",
    "Model": "Flare Tab Pro"
  },
  {
    "Retail Branding": "Cherry Mobile",
    "Marketing Name": "Flare X",
    "Device": "Flare_X",
    "Model": "Flare_X_V2"
  },
  {
    "Retail Branding": "Cherry Mobile",
    "Marketing Name": "Flare X3",
    "Device": "Flare_X3",
    "Model": "Flare_X3"
  },
  {
    "Retail Branding": "Cherry Mobile",
    "Marketing Name": "Flare Y20",
    "Device": "X1010",
    "Model": "Flare Y20"
  },
  {
    "Retail Branding": "Cherry Mobile",
    "Marketing Name": "Flare Y3",
    "Device": "FlareY3",
    "Model": "Flare_Y3"
  },
  {
    "Retail Branding": "Cherry Mobile",
    "Marketing Name": "Flare Y3 Pro",
    "Device": "Flare_Y3_Pro",
    "Model": "Flare Y3 Pro"
  },
  {
    "Retail Branding": "Cherry Mobile",
    "Marketing Name": "Flare Y3 mini",
    "Device": "Flare_Y3_mini",
    "Model": "Flare Y3 mini"
  },
  {
    "Retail Branding": "Cherry Mobile",
    "Marketing Name": "Flare Y5",
    "Device": "H2050",
    "Model": "Flare Y5"
  },
  {
    "Retail Branding": "Cherry Mobile",
    "Marketing Name": "Flare Y6",
    "Device": "Flare_Y6",
    "Model": "Flare Y6"
  },
  {
    "Retail Branding": "Cherry Mobile",
    "Marketing Name": "Flare Y7",
    "Device": "Flare_Y7",
    "Model": "Flare_Y7"
  },
  {
    "Retail Branding": "Cherry Mobile",
    "Marketing Name": "Flare Y7 LTE",
    "Device": "Flare_Y7_LTE",
    "Model": "Flare_Y7_LTE"
  },
  {
    "Retail Branding": "Cherry Mobile",
    "Marketing Name": "Flare Y7 Pro",
    "Device": "Flare_Y7_Pro",
    "Model": "Flare_Y7_Pro"
  },
  {
    "Retail Branding": "Cherry Mobile",
    "Marketing Name": "Flare_A1_Roam",
    "Device": "Flare_A1_Roam",
    "Model": "Flare_A1_Roam"
  },
  {
    "Retail Branding": "Cherry Mobile",
    "Marketing Name": "Flare_HD_5",
    "Device": "Flare_HD_5",
    "Model": "Flare_HD_5"
  },
  {
    "Retail Branding": "Cherry Mobile",
    "Marketing Name": "Flare_J3_Lite",
    "Device": "Flare_J3_Lite",
    "Model": "Flare_J3_Lite"
  },
  {
    "Retail Branding": "Cherry Mobile",
    "Marketing Name": "Flare_S6_Lite",
    "Device": "Flare_S6_Lite",
    "Model": "Flare_S6_Lite"
  },
  {
    "Retail Branding": "Cherry Mobile",
    "Marketing Name": "Flare_S7_Prime",
    "Device": "Flare_S7_Prime",
    "Model": "Flare_S7_Prime"
  },
  {
    "Retail Branding": "Cherry Mobile",
    "Marketing Name": "Flare_S8_Plus",
    "Device": "Flare_S8_Plus",
    "Model": "Flare_S8_Plus"
  },
  {
    "Retail Branding": "Cherry Mobile",
    "Marketing Name": "Flare_S8_Prime",
    "Device": "Flare_S8_Prime",
    "Model": "Flare_S8_Prime"
  },
  {
    "Retail Branding": "Cherry Mobile",
    "Marketing Name": "Flare_S8_Pro",
    "Device": "Flare_S8_Pro",
    "Model": "Flare_S8_Pro"
  },
  {
    "Retail Branding": "Cherry Mobile",
    "Marketing Name": "Flare_Y6_Pro",
    "Device": "Flare_Y6_Pro",
    "Model": "Flare_Y6_Pro"
  },
  {
    "Retail Branding": "Cherry Mobile",
    "Marketing Name": "Fusion Aura 3s",
    "Device": "Fusion_Aura_3s",
    "Model": "Fusion Aura 3s"
  },
  {
    "Retail Branding": "Cherry Mobile",
    "Marketing Name": "H220",
    "Device": "ctih220_sprout",
    "Model": "H220"
  },
  {
    "Retail Branding": "Cherry Mobile",
    "Marketing Name": "Iris",
    "Device": "Iris",
    "Model": "iris"
  },
  {
    "Retail Branding": "Cherry Mobile",
    "Marketing Name": "Lenoxx",
    "Device": "CX940",
    "Model": "CX940"
  },
  {
    "Retail Branding": "Cherry Mobile",
    "Marketing Name": "Magnum 8s",
    "Device": "Cherry_Magnum_8s",
    "Model": "A870"
  },
  {
    "Retail Branding": "Cherry Mobile",
    "Marketing Name": "Omage Icon Lite 2",
    "Device": "Omega_Icon_Lite_2",
    "Model": "Omega Icon Lite 2"
  },
  {
    "Retail Branding": "Cherry Mobile",
    "Marketing Name": "Omega HD 3S",
    "Device": "H115",
    "Model": "OMEGA HD 3S"
  },
  {
    "Retail Branding": "Cherry Mobile",
    "Marketing Name": "Omega HD 4",
    "Device": "Cherry_Omega_HD_4",
    "Model": "Omega_HD_4"
  },
  {
    "Retail Branding": "Cherry Mobile",
    "Marketing Name": "Omega HD 5",
    "Device": "Omega_HD_5",
    "Model": "Omega HD 5"
  },
  {
    "Retail Branding": "Cherry Mobile",
    "Marketing Name": "Omega HD Duo",
    "Device": "Omega_HD_Duo",
    "Model": "Omega_HD_Duo"
  },
  {
    "Retail Branding": "Cherry Mobile",
    "Marketing Name": "Omega HD3",
    "Device": "H110",
    "Model": "Omega HD 3"
  },
  {
    "Retail Branding": "Cherry Mobile",
    "Marketing Name": "Omega Icon 2",
    "Device": "Omega_Icon_2",
    "Model": "Omega Icon 2"
  },
  {
    "Retail Branding": "Cherry Mobile",
    "Marketing Name": "Omega Lite 3C",
    "Device": "Omega_Lite_3C",
    "Model": "Omega_Lite_3C"
  },
  {
    "Retail Branding": "Cherry Mobile",
    "Marketing Name": "Omega Lite 3s",
    "Device": "Omega_Lite_3s",
    "Model": "Omega Lite 3s"
  },
  {
    "Retail Branding": "Cherry Mobile",
    "Marketing Name": "Omega Lite 4",
    "Device": "omega_lite_4",
    "Model": "omega_lite_4"
  },
  {
    "Retail Branding": "Cherry Mobile",
    "Marketing Name": "Omega Lite 4s",
    "Device": "Omega_Lite_4s",
    "Model": "Omega Lite 4s"
  },
  {
    "Retail Branding": "Cherry Mobile",
    "Marketing Name": "Omega X",
    "Device": "X960",
    "Model": "Omega X"
  },
  {
    "Retail Branding": "Cherry Mobile",
    "Marketing Name": "One",
    "Device": "H940_sprout",
    "Model": "H940"
  },
  {
    "Retail Branding": "Cherry Mobile",
    "Marketing Name": "Pulse",
    "Device": "Pulse",
    "Model": "Pulse"
  },
  {
    "Retail Branding": "Cherry Mobile",
    "Marketing Name": "Quantum_plus",
    "Device": "Cherry_Quantum_plus",
    "Model": "A870"
  },
  {
    "Retail Branding": "Cherry Mobile",
    "Marketing Name": "Rover 2",
    "Device": "Cherry_Rover_2",
    "Model": "Rover_2"
  },
  {
    "Retail Branding": "Cherry Mobile",
    "Marketing Name": "Selfie Two",
    "Device": "Selfie_Two",
    "Model": "Selfie_Two"
  },
  {
    "Retail Branding": "Cherry Mobile",
    "Marketing Name": "Spin Max",
    "Device": "H650",
    "Model": "Spin Max"
  },
  {
    "Retail Branding": "Cherry Mobile",
    "Marketing Name": "Spin Max 2",
    "Device": "Spin_Max_2",
    "Model": "Spin Max 2"
  },
  {
    "Retail Branding": "Cherry Mobile",
    "Marketing Name": "Superion Radar Deluxe 2",
    "Device": "Radar_Deluxe_2",
    "Model": "Radar Deluxe 2"
  },
  {
    "Retail Branding": "Cherry Mobile",
    "Marketing Name": "Superion Radar Duluxe",
    "Device": "Radar_Deluxe",
    "Model": "Superion Radar Deluxe"
  },
  {
    "Retail Branding": "Cherry Mobile",
    "Marketing Name": "Superion S1 DTV",
    "Device": "A800",
    "Model": "Superion S1 DTV"
  },
  {
    "Retail Branding": "Cherry Mobile",
    "Marketing Name": "Superion S2",
    "Device": "Superion_S2",
    "Model": "Superion_S2"
  },
  {
    "Retail Branding": "Cherry Mobile",
    "Marketing Name": "Superion S2+",
    "Device": "Superion_S2_Plus",
    "Model": "Superion_S2_Plus"
  },
  {
    "Retail Branding": "Cherry Mobile",
    "Marketing Name": "Superion Tab Pro",
    "Device": "Superion_Tab_Pro",
    "Model": "Superion Tab Pro"
  },
  {
    "Retail Branding": "Cherry Mobile",
    "Marketing Name": "Touch HD",
    "Device": "Touch_HD",
    "Model": "Cherry_Mobile_Touch_HD"
  },
  {
    "Retail Branding": "Cherry Mobile",
    "Marketing Name": "X1090",
    "Device": "X1090",
    "Model": "X1090"
  },
  {
    "Retail Branding": "Cherry Mobile",
    "Marketing Name": "X1100",
    "Device": "X1100",
    "Model": "X1100"
  },
  {
    "Retail Branding": "Cherry Mobile",
    "Marketing Name": "ZP785",
    "Device": "ZP785",
    "Model": "ZP785"
  },
  {
    "Retail Branding": "Chessnut",
    "Marketing Name": "CC100",
    "Device": "Chessnut_Companion",
    "Model": "Chessnut_Companion"
  },
  {
    "Retail Branding": "Chessnut",
    "Marketing Name": "CC101",
    "Device": "Chessnut_Companion",
    "Model": "Chessnut_Companion"
  },
  {
    "Retail Branding": "Chessnut",
    "Marketing Name": "CE200",
    "Device": "CE200",
    "Model": "CE200"
  },
  {
    "Retail Branding": "Chessnut",
    "Marketing Name": "CE201",
    "Device": "CE201",
    "Model": "CE201"
  },
  {
    "Retail Branding": "ChicoMobile",
    "Marketing Name": "LGU-PQv1",
    "Device": "LGU-PQv1",
    "Model": "LGU-PQv1"
  },
  {
    "Retail Branding": "China Mobile",
    "Marketing Name": "A3",
    "Device": "M651G",
    "Model": "M651G"
  },
  {
    "Retail Branding": "China Mobile",
    "Marketing Name": "A5",
    "Device": "M654G",
    "Model": "M654G"
  },
  {
    "Retail Branding": "China Mobile",
    "Marketing Name": "M762G",
    "Device": "M762G",
    "Model": "M762G"
  },
  {
    "Retail Branding": "China Mobile",
    "Marketing Name": "n1 max",
    "Device": "m823_cmcc",
    "Model": "M823"
  },
  {
    "Retail Branding": "China Network System (CNS)",
    "Marketing Name": "STB-9642C1",
    "Device": "BCM72604",
    "Model": "STB-9642C1"
  },
  {
    "Retail Branding": "Chosunbiz",
    "Marketing Name": "Chosunbiz",
    "Device": "kPad",
    "Model": "kPad"
  },
  {
    "Retail Branding": "ChurchDesk",
    "Marketing Name": "ChurchDeskP1",
    "Device": "ChurchDeskP1",
    "Model": "ChurchDeskP1"
  },
  {
    "Retail Branding": "Chuwi",
    "Marketing Name": "AuPad",
    "Device": "AuPad",
    "Model": "AuPad"
  },
  {
    "Retail Branding": "Chuwi",
    "Marketing Name": "AupadMini",
    "Device": "AupadMini",
    "Model": "AupadMini"
  },
  {
    "Retail Branding": "Chuwi",
    "Marketing Name": "CHUWI",
    "Device": "Hi9Air",
    "Model": "Hi9Air"
  },
  {
    "Retail Branding": "Chuwi",
    "Marketing Name": "Hi10_XPro",
    "Device": "Hi10_XPro",
    "Model": "Hi10 XPro"
  },
  {
    "Retail Branding": "Chuwi",
    "Marketing Name": "Hi10_XPro_Pad",
    "Device": "Hi10_XPro_Pad",
    "Model": "Hi10_XPro_Pad"
  },
  {
    "Retail Branding": "Chuwi",
    "Marketing Name": "Hi10_XPro_Pad_EEA",
    "Device": "Hi10_XPro_Pad_EEA",
    "Model": "Hi10 XPro"
  },
  {
    "Retail Branding": "Chuwi",
    "Marketing Name": "Hi10_XPro_Pad_EEA",
    "Device": "Hi10_XPro_Pad_EEA",
    "Model": "Hi10_XPro_Pad"
  },
  {
    "Retail Branding": "Chuwi",
    "Marketing Name": "Hi10_XPro_RUU",
    "Device": "Hi10_XPro_RUU",
    "Model": "Hi10 Xpro"
  },
  {
    "Retail Branding": "Chuwi",
    "Marketing Name": "Hi9",
    "Device": "Hi9",
    "Model": "Hi9"
  },
  {
    "Retail Branding": "Chuwi",
    "Marketing Name": "Hi9Pro",
    "Device": "Hi9Pro",
    "Model": "Hi9Pro"
  },
  {
    "Retail Branding": "Chuwi",
    "Marketing Name": "HiPad 11",
    "Device": "HiPad_11",
    "Model": "HiPad 11"
  },
  {
    "Retail Branding": "Chuwi",
    "Marketing Name": "HiPad Max",
    "Device": "HiPad_Max",
    "Model": "HiPad Max"
  },
  {
    "Retail Branding": "Chuwi",
    "Marketing Name": "HiPad-Air",
    "Device": "HiPad-Air",
    "Model": "HiPad-Air"
  },
  {
    "Retail Branding": "Chuwi",
    "Marketing Name": "HiPad-Air-EEA",
    "Device": "HiPad-Air",
    "Model": "HiPad-Air"
  },
  {
    "Retail Branding": "Chuwi",
    "Marketing Name": "HiPadPlus-2_EEA",
    "Device": "HiPadPlus",
    "Model": "HiPadPlus"
  },
  {
    "Retail Branding": "Chuwi",
    "Marketing Name": "HiPadPlus-3_ROW",
    "Device": "HiPadPlus",
    "Model": "HiPadPlus"
  },
  {
    "Retail Branding": "Chuwi",
    "Marketing Name": "HiPadPlus_11_EEA",
    "Device": "HiPadPlus",
    "Model": "HiPadPlus"
  },
  {
    "Retail Branding": "Chuwi",
    "Marketing Name": "HiPadPlus_EEA",
    "Device": "HiPadPlus",
    "Model": "HiPad Plus"
  },
  {
    "Retail Branding": "Chuwi",
    "Marketing Name": "HiPadPlus_ROW",
    "Device": "HiPadPlus",
    "Model": "HiPadPlus"
  },
  {
    "Retail Branding": "Chuwi",
    "Marketing Name": "HiPadPlus_RU",
    "Device": "HiPadPlus",
    "Model": "HiPadPlus"
  },
  {
    "Retail Branding": "Chuwi",
    "Marketing Name": "HiPadPlus_TR",
    "Device": "HiPadPlus",
    "Model": "HiPadPlus"
  },
  {
    "Retail Branding": "Chuwi",
    "Marketing Name": "HiPadPro",
    "Device": "HiPadPro",
    "Model": "HiPadPro"
  },
  {
    "Retail Branding": "Chuwi",
    "Marketing Name": "HiPadX-1_EEA",
    "Device": "HiPadX",
    "Model": "HiPad X"
  },
  {
    "Retail Branding": "Chuwi",
    "Marketing Name": "HiPadX_11",
    "Device": "HiPadX",
    "Model": "HiPadX"
  },
  {
    "Retail Branding": "Chuwi",
    "Marketing Name": "HiPadX_ROW",
    "Device": "HiPadX",
    "Model": "HiPadX"
  },
  {
    "Retail Branding": "Chuwi",
    "Marketing Name": "HiPad_11_EEA",
    "Device": "HiPad_11",
    "Model": "HiPad 11"
  },
  {
    "Retail Branding": "Chuwi",
    "Marketing Name": "HiPad_Pro",
    "Device": "CH108Q",
    "Model": "HiPad Pro"
  },
  {
    "Retail Branding": "Chuwi",
    "Marketing Name": "HiPad_X",
    "Device": "HiPad_X",
    "Model": "HiPad X"
  },
  {
    "Retail Branding": "Chuwi",
    "Marketing Name": "HiPad_XPro",
    "Device": "HiPad_XPro",
    "Model": "HiPad XPro"
  },
  {
    "Retail Branding": "Chuwi",
    "Marketing Name": "HiPad_XPro_EEA",
    "Device": "HiPad_XPro_EEA",
    "Model": "HiPad XPro"
  },
  {
    "Retail Branding": "Chuwi",
    "Marketing Name": "HiPad_XPro_EEA13",
    "Device": "HiPad_XPro",
    "Model": "HiPad XPro"
  },
  {
    "Retail Branding": "Chuwi",
    "Marketing Name": "HiPad_XPro_ROW13",
    "Device": "HiPad_XPro",
    "Model": "HiPad XPro"
  },
  {
    "Retail Branding": "Chuwi",
    "Marketing Name": "HiPad_XPro_RU",
    "Device": "HiPad_XPro",
    "Model": "HiPad XPro"
  },
  {
    "Retail Branding": "Chuwi",
    "Marketing Name": "HiPad_Xpro_Pad",
    "Device": "HiPad_Xpro_Pad",
    "Model": "HiPad XPro"
  },
  {
    "Retail Branding": "Chuwi",
    "Marketing Name": "HiPad_Xpro_Pad_EEA",
    "Device": "HiPad_Xpro_Pad_EEA",
    "Model": "HiPad XPro"
  },
  {
    "Retail Branding": "Chuwi",
    "Marketing Name": "HipadX",
    "Device": "HipadX",
    "Model": "HiPad X"
  },
  {
    "Retail Branding": "Chuwi",
    "Marketing Name": "HipadX_eea_1",
    "Device": "HipadX",
    "Model": "HiPad X"
  },
  {
    "Retail Branding": "Chuwi",
    "Marketing Name": "HipadX_ru",
    "Device": "HipadX",
    "Model": "HiPad X"
  },
  {
    "Retail Branding": "Chuwi",
    "Marketing Name": "Surpad",
    "Device": "Surpad",
    "Model": "Surpad"
  },
  {
    "Retail Branding": "Cidea",
    "Marketing Name": "CM14000Plus",
    "Device": "CM14000Plus",
    "Model": "CM14000Plus"
  },
  {
    "Retail Branding": "Cidea",
    "Marketing Name": "CM76",
    "Device": "CM76_EEA",
    "Model": "CM76"
  },
  {
    "Retail Branding": "Cidea",
    "Marketing Name": "CM77",
    "Device": "CM77",
    "Model": "CM77"
  },
  {
    "Retail Branding": "Cidea",
    "Marketing Name": "CM81",
    "Device": "CM81_EEA",
    "Model": "CM81"
  },
  {
    "Retail Branding": "Cidea",
    "Marketing Name": "CM82",
    "Device": "CM82",
    "Model": "CM82"
  },
  {
    "Retail Branding": "Cidea",
    "Marketing Name": "CM826",
    "Device": "CM826",
    "Model": "CM826"
  },
  {
    "Retail Branding": "Cidea",
    "Marketing Name": "CM90",
    "Device": "CM90",
    "Model": "CM90"
  },
  {
    "Retail Branding": "Cidea",
    "Marketing Name": "CM91_EEA",
    "Device": "CM91_EEA",
    "Model": "CM91_EEA"
  },
  {
    "Retail Branding": "Cidea",
    "Marketing Name": "CM92_EEA",
    "Device": "CM92_EEA",
    "Model": "CM92"
  },
  {
    "Retail Branding": "Cidea",
    "Marketing Name": "CM93",
    "Device": "CM93",
    "Model": "CM93"
  },
  {
    "Retail Branding": "Cidea",
    "Marketing Name": "P100",
    "Device": "P100",
    "Model": "P100"
  },
  {
    "Retail Branding": "Cidea",
    "Marketing Name": "P1100",
    "Device": "P1100",
    "Model": "P1100"
  },
  {
    "Retail Branding": "Cidea",
    "Marketing Name": "P1150",
    "Device": "P1150",
    "Model": "P1150"
  },
  {
    "Retail Branding": "Cidea",
    "Marketing Name": "P1200",
    "Device": "P1200",
    "Model": "P1200"
  },
  {
    "Retail Branding": "Cidea",
    "Marketing Name": "P1250",
    "Device": "P1250",
    "Model": "P1250"
  },
  {
    "Retail Branding": "Cidea",
    "Marketing Name": "P1300",
    "Device": "P1300",
    "Model": "P1300"
  },
  {
    "Retail Branding": "Cidea",
    "Marketing Name": "P1350",
    "Device": "P1350",
    "Model": "P1350"
  },
  {
    "Retail Branding": "Cidea",
    "Marketing Name": "P150",
    "Device": "P150",
    "Model": "P150"
  },
  {
    "Retail Branding": "Cidea",
    "Marketing Name": "P200",
    "Device": "P200",
    "Model": "P200"
  },
  {
    "Retail Branding": "Cidea",
    "Marketing Name": "R1036",
    "Device": "R1036",
    "Model": "R1036"
  },
  {
    "Retail Branding": "CignalPlayTV",
    "Marketing Name": "CIGSEI100",
    "Device": "CIGSEI100",
    "Model": "CIGSEI100"
  },
  {
    "Retail Branding": "Ciontek",
    "Marketing Name": "CS20",
    "Device": "CS20",
    "Model": "CS20"
  },
  {
    "Retail Branding": "Ciontek",
    "Marketing Name": "CS30",
    "Device": "CS30",
    "Model": "CS30"
  },
  {
    "Retail Branding": "Ciontek",
    "Marketing Name": "CS50",
    "Device": "CS50",
    "Model": "CS50"
  },
  {
    "Retail Branding": "Ciontek",
    "Marketing Name": "CS50C",
    "Device": "CS50C",
    "Model": "CS50C"
  },
  {
    "Retail Branding": "Ciontek",
    "Marketing Name": "CS50_EEA",
    "Device": "CS50",
    "Model": "CS50"
  },
  {
    "Retail Branding": "Cipherlab",
    "Marketing Name": "Cipherlab RK25",
    "Device": "RK25",
    "Model": "RK25"
  },
  {
    "Retail Branding": "Cipherlab",
    "Marketing Name": "Hera51",
    "Device": "Hera51",
    "Model": "Hera51"
  },
  {
    "Retail Branding": "Cipherlab",
    "Marketing Name": "RK25",
    "Device": "RK25",
    "Model": "RK25"
  },
  {
    "Retail Branding": "Cipherlab",
    "Marketing Name": "RK25WO",
    "Device": "RK25WO",
    "Model": "RK25WO"
  },
  {
    "Retail Branding": "Cipherlab",
    "Marketing Name": "RK26",
    "Device": "RK26",
    "Model": "RK26"
  },
  {
    "Retail Branding": "Cipherlab",
    "Marketing Name": "RK26 U",
    "Device": "RK26PLUS",
    "Model": "RK26"
  },
  {
    "Retail Branding": "Cipherlab",
    "Marketing Name": "RK95",
    "Device": "RK95",
    "Model": "RK95"
  },
  {
    "Retail Branding": "Cipherlab",
    "Marketing Name": "RS10",
    "Device": "RS10",
    "Model": "RS10"
  },
  {
    "Retail Branding": "Cipherlab",
    "Marketing Name": "RS30",
    "Device": "Mercury",
    "Model": "CipherLab RS30"
  },
  {
    "Retail Branding": "Cipherlab",
    "Marketing Name": "RS31",
    "Device": "RS31",
    "Model": "RS31"
  },
  {
    "Retail Branding": "Cipherlab",
    "Marketing Name": "RS35",
    "Device": "RS35",
    "Model": "RS35"
  },
  {
    "Retail Branding": "Cipherlab",
    "Marketing Name": "RS36",
    "Device": "RS36",
    "Model": "RS36"
  },
  {
    "Retail Branding": "Cipherlab",
    "Marketing Name": "RS36 U",
    "Device": "RS36PLUS",
    "Model": "RS36"
  },
  {
    "Retail Branding": "Cipherlab",
    "Marketing Name": "RS38",
    "Device": "RS38",
    "Model": "RS38"
  },
  {
    "Retail Branding": "Cipherlab",
    "Marketing Name": "RS51_HS",
    "Device": "RS51_HS",
    "Model": "RS51_HS"
  },
  {
    "Retail Branding": "Cipherlab",
    "Marketing Name": "Saturn",
    "Device": "RS50",
    "Model": "RS50"
  },
  {
    "Retail Branding": "Cisco",
    "Marketing Name": "CP-860",
    "Device": 860,
    "Model": "CP-860"
  },
  {
    "Retail Branding": "Cisco",
    "Marketing Name": "CP-860S",
    "Device": 860,
    "Model": "CP-860S"
  },
  {
    "Retail Branding": "Cisco",
    "Marketing Name": "CP-DX650",
    "Device": "CP-DX650",
    "Model": "CP-DX650"
  },
  {
    "Retail Branding": "Cisco",
    "Marketing Name": "DX70",
    "Device": "CP-DX70",
    "Model": "CP-DX70"
  },
  {
    "Retail Branding": "Cisco",
    "Marketing Name": "Desktop Collaboration Experience DX70",
    "Device": "CP-DX70",
    "Model": "CP-DX70"
  },
  {
    "Retail Branding": "Cisco",
    "Marketing Name": "Desktop Collaboration Experience DX80",
    "Device": "CP-DX80",
    "Model": "CP-DX80"
  },
  {
    "Retail Branding": "Citycall",
    "Marketing Name": "Life Lite 4G",
    "Device": "KL5011C",
    "Model": "Life Lite 4G"
  },
  {
    "Retail Branding": "Citycall",
    "Marketing Name": "Life Power 9",
    "Device": "Life_Power_9",
    "Model": "Life Power 9"
  },
  {
    "Retail Branding": "Citycall",
    "Marketing Name": "Life_10_Pro",
    "Device": "Life_10_Pro",
    "Model": "Life 10 Pro"
  },
  {
    "Retail Branding": "Citycall",
    "Marketing Name": "Life_Pro_7",
    "Device": "Life_Pro_7",
    "Model": "Life Pro 7"
  },
  {
    "Retail Branding": "Citycall",
    "Marketing Name": "SS5007C",
    "Device": "SS5007C",
    "Model": "SS5007C"
  },
  {
    "Retail Branding": "Ckypad",
    "Marketing Name": "Cpad10EEA",
    "Device": "Cpad10EEA",
    "Model": "Cpad10EEA"
  },
  {
    "Retail Branding": "Ckypad",
    "Marketing Name": "Ctab12_EEA",
    "Device": "Ctab12_EEA",
    "Model": "Ctab 12_EEA"
  },
  {
    "Retail Branding": "Ckypad",
    "Marketing Name": "Ctab14EEA",
    "Device": "Ctab14EEA",
    "Model": "Ctab14EEA"
  },
  {
    "Retail Branding": "Claresta",
    "Marketing Name": "F3",
    "Device": "F3",
    "Model": "F3"
  },
  {
    "Retail Branding": "Claresta",
    "Marketing Name": "G4",
    "Device": "G4",
    "Model": "G4"
  },
  {
    "Retail Branding": "Claresta",
    "Marketing Name": "G5",
    "Device": "G5",
    "Model": "G5"
  },
  {
    "Retail Branding": "Claresta",
    "Marketing Name": "G6",
    "Device": "G6",
    "Model": "G6"
  },
  {
    "Retail Branding": "Claresta",
    "Marketing Name": "S6Plus",
    "Device": "S6Plus",
    "Model": "S6Plus"
  },
  {
    "Retail Branding": "Clarmin",
    "Marketing Name": "B5Pro",
    "Device": "B5Pro",
    "Model": "B5Pro"
  },
  {
    "Retail Branding": "Clarmin",
    "Marketing Name": "B8",
    "Device": "B8",
    "Model": "B8"
  },
  {
    "Retail Branding": "Clarmin",
    "Marketing Name": "B8Lite",
    "Device": "B8Lite",
    "Model": "B8Lite"
  },
  {
    "Retail Branding": "Clarmin",
    "Marketing Name": "B8plus",
    "Device": "B8plus",
    "Model": "B8plus"
  },
  {
    "Retail Branding": "Clarmin",
    "Marketing Name": "CLARMIN C1",
    "Device": "CLARMIN_C1",
    "Model": "CLARMIN C1"
  },
  {
    "Retail Branding": "Claro",
    "Marketing Name": "B866V2",
    "Device": "B866V2_V1_0_0",
    "Model": "B866V2"
  },
  {
    "Retail Branding": "Claro",
    "Marketing Name": "B866W12M",
    "Device": "CLARO_CO_B866W12M",
    "Model": "B866W12M"
  },
  {
    "Retail Branding": "Claro",
    "Marketing Name": "CLARO  TV Box 4k",
    "Device": "SEI800AMX",
    "Model": "Claro TV Box 4k"
  },
  {
    "Retail Branding": "Claro",
    "Marketing Name": "CLARO BOX TV",
    "Device": "SEI810CCOA",
    "Model": "CLARO BOX TV"
  },
  {
    "Retail Branding": "Claro",
    "Marketing Name": "CLARO TV Box 4K",
    "Device": "SEI800AMX",
    "Model": "Claro TV Box 4k"
  },
  {
    "Retail Branding": "Claro",
    "Marketing Name": "Claro 4k advanced",
    "Device": "SEI820AMX",
    "Model": "Claro 4k advanced"
  },
  {
    "Retail Branding": "Claro",
    "Marketing Name": "Claro 4k advanced",
    "Device": "claro_vsb3918",
    "Model": "Claro 4k advanced"
  },
  {
    "Retail Branding": "Claro",
    "Marketing Name": "Claro Colombia STB",
    "Device": "SEI800CCOA",
    "Model": "Claro Colombia STB"
  },
  {
    "Retail Branding": "Claro",
    "Marketing Name": "Claro STB",
    "Device": "SEI810CPR",
    "Model": "Claro STB"
  },
  {
    "Retail Branding": "Claro",
    "Marketing Name": "Claro TV Box 4k",
    "Device": "B866VH",
    "Model": "Claro TV Box 4k"
  },
  {
    "Retail Branding": "Claro",
    "Marketing Name": "Claro TV Stick 4k​",
    "Device": "SEI900AMXS",
    "Model": "Claro TV Stick 4k"
  },
  {
    "Retail Branding": "Claro",
    "Marketing Name": "ClaroTV+ Mini",
    "Device": "SEI700CPR",
    "Model": "Claro TV+ Mini"
  },
  {
    "Retail Branding": "Claro",
    "Marketing Name": "S4KW3",
    "Device": "m393_4l",
    "Model": "S4KW3"
  },
  {
    "Retail Branding": "Claro",
    "Marketing Name": "SEI810CPR",
    "Device": "SEI810CPR",
    "Model": "Claro STB"
  },
  {
    "Retail Branding": "Claro",
    "Marketing Name": "STICK 4K",
    "Device": "SEI900CCOAS",
    "Model": "STICK 4K"
  },
  {
    "Retail Branding": "Classpro",
    "Marketing Name": "CGS55UHD",
    "Device": "samseong",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "Classpro",
    "Marketing Name": "EGS42FHD",
    "Device": "ikebukuro",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "Classpro",
    "Marketing Name": "G7N",
    "Device": "redwood",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "Classpro",
    "Marketing Name": "Smart TV",
    "Device": "longshan",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "Classpro",
    "Marketing Name": "Smart TV",
    "Device": "osaka",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "ClearTouch",
    "Marketing Name": "CTI_60XXNova_UH50",
    "Device": "oversea_v",
    "Model": "60XX_Nova"
  },
  {
    "Retail Branding": "ClearTouch",
    "Marketing Name": "NEXT_TDED",
    "Device": "rk3588_t",
    "Model": "CTI_NEXT_TDED_S10"
  },
  {
    "Retail Branding": "ClearTouch",
    "Marketing Name": "six_zero_XXAplus",
    "Device": "rk3588_t",
    "Model": "six_zero_XXAplus"
  },
  {
    "Retail Branding": "Clearsounds",
    "Marketing Name": "CSTAAP8D",
    "Device": "CSTAAP8D",
    "Model": "CSTAAP8D"
  },
  {
    "Retail Branding": "Clementoni",
    "Marketing Name": "CLEMPAD10_2023",
    "Device": "CLEMPAD10_2023",
    "Model": "CLEMPAD10_2023"
  },
  {
    "Retail Branding": "Clementoni",
    "Marketing Name": "CLEMPAD_2018",
    "Device": "CLEMPAD_2018",
    "Model": "CLEMPAD_2018"
  },
  {
    "Retail Branding": "Clementoni",
    "Marketing Name": "Clempad 4.4 Basic Special",
    "Device": "Clempad2_special",
    "Model": "Clempad2_special"
  },
  {
    "Retail Branding": "Clementoni",
    "Marketing Name": "Clempad 4.4 Plus",
    "Device": "Clempad2_plus",
    "Model": "Clempad2_plus"
  },
  {
    "Retail Branding": "Clementoni",
    "Marketing Name": "Clempad 4.4 XL",
    "Device": "Clempad2_XL",
    "Model": "Clempad2_XL"
  },
  {
    "Retail Branding": "Clementoni",
    "Marketing Name": "Clempad 5.0 XL",
    "Device": "Clempad_HR_XL",
    "Model": "Clempad_HR_XL"
  },
  {
    "Retail Branding": "Clementoni",
    "Marketing Name": "Clempad 6.0",
    "Device": "Clempad_6",
    "Model": "Clempad_6"
  },
  {
    "Retail Branding": "Clementoni",
    "Marketing Name": "Clempad 6.0 XL",
    "Device": "Clempad_6_XL",
    "Model": "Clempad_6_XL"
  },
  {
    "Retail Branding": "Clementoni",
    "Marketing Name": "Clempad 8",
    "Device": "Clempad_8",
    "Model": "Clempad_8"
  },
  {
    "Retail Branding": "Clementoni",
    "Marketing Name": "Clempad Call",
    "Device": "CLEMPADCALL",
    "Model": "CLEMPADCALL"
  },
  {
    "Retail Branding": "Clementoni",
    "Marketing Name": "Clempad HR",
    "Device": "Clempad_HR",
    "Model": "Clempad_HR"
  },
  {
    "Retail Branding": "Clementoni",
    "Marketing Name": "Clempad HR Plus",
    "Device": "Clempad_HR_Plus",
    "Model": "Clempad_HR_Plus"
  },
  {
    "Retail Branding": "Clementoni",
    "Marketing Name": "Clempad_6_S",
    "Device": "Clempad_6_S",
    "Model": "Clempad_6_S"
  },
  {
    "Retail Branding": "Clementoni",
    "Marketing Name": "Clempad_7_S",
    "Device": "Clempad_7_S",
    "Model": "Clempad_7_S"
  },
  {
    "Retail Branding": "Clementoni",
    "Marketing Name": "Clempad_9",
    "Device": "Clempad_9",
    "Model": "CLEMPAD_2019"
  },
  {
    "Retail Branding": "Clementoni",
    "Marketing Name": "Clemphone",
    "Device": "ClemPhone",
    "Model": "ClemPhone"
  },
  {
    "Retail Branding": "Clementoni",
    "Marketing Name": "Clemphone 7.0",
    "Device": "ClemPhone_7",
    "Model": "ClemPhone_7"
  },
  {
    "Retail Branding": "Clementoni",
    "Marketing Name": "MFC_2018",
    "Device": "MFC_2018",
    "Model": "MFC_2018"
  },
  {
    "Retail Branding": "Clementoni",
    "Marketing Name": "MFC_8",
    "Device": "MFC_8",
    "Model": "MFC_8"
  },
  {
    "Retail Branding": "Clementoni",
    "Marketing Name": "MFClempadP_9",
    "Device": "MFClempadP_9",
    "Model": "MFC8_2019"
  },
  {
    "Retail Branding": "Clementoni",
    "Marketing Name": "MFClempad_9",
    "Device": "MFClempad_9",
    "Model": "MFC7_2019"
  },
  {
    "Retail Branding": "Clementoni",
    "Marketing Name": "My First Clempad 6.0",
    "Device": "MFC_6",
    "Model": "MFC_6"
  },
  {
    "Retail Branding": "Clementoni",
    "Marketing Name": "My First Clempad 7",
    "Device": "MFC_7",
    "Model": "MFC_7"
  },
  {
    "Retail Branding": "Clementoni",
    "Marketing Name": "My First Clempad HR",
    "Device": "MFC_HR",
    "Model": "MFC_HR"
  },
  {
    "Retail Branding": "Clementoni",
    "Marketing Name": "My First Clempad HR Plus",
    "Device": "MFC_HR_Plus",
    "Model": "MFC_HR_Plus"
  },
  {
    "Retail Branding": "Clementoni",
    "Marketing Name": "My first Clempad 4.4 Basic Special",
    "Device": "MFC2_Special",
    "Model": "MFC2_Special"
  },
  {
    "Retail Branding": "Clementoni",
    "Marketing Name": "My first Clempad 4.4 Plus",
    "Device": "MFC2_Plus",
    "Model": "MFC2_Plus"
  },
  {
    "Retail Branding": "Clementoni",
    "Marketing Name": "Neo_Clempad_2021",
    "Device": "Neo_Clempad_2021",
    "Model": "Neo_Clempad_2021"
  },
  {
    "Retail Branding": "Clevertouch",
    "Marketing Name": "Clevertouch LUX Mini",
    "Device": "rk3588_t",
    "Model": "LUX_Mini"
  },
  {
    "Retail Branding": "Clevertouch",
    "Marketing Name": "Clevertouch LUX Mini",
    "Device": "rk3588_t",
    "Model": "LUX_Mini_Module"
  },
  {
    "Retail Branding": "Clevertouch",
    "Marketing Name": "IMPACT Lux",
    "Device": "rk3588_t",
    "Model": "Impact_Lux_Display"
  },
  {
    "Retail Branding": "Clevertouch",
    "Marketing Name": "Pro-C",
    "Device": "rk3576_u",
    "Model": "Pro_C_Display"
  },
  {
    "Retail Branding": "Clevertouch",
    "Marketing Name": "Pro_Series_3",
    "Device": "rk3576_u",
    "Model": "Pro_Series_3_Display"
  },
  {
    "Retail Branding": "Clevertouch",
    "Marketing Name": "UX Pro Edge",
    "Device": "rk3588_t",
    "Model": "UX_Pro_Edge_Display"
  },
  {
    "Retail Branding": "Clevertouch",
    "Marketing Name": "X5",
    "Device": "MT9679",
    "Model": "X5_Display"
  },
  {
    "Retail Branding": "Click",
    "Marketing Name": "M9021G",
    "Device": "M9021G",
    "Model": "M9021G"
  },
  {
    "Retail Branding": "Click",
    "Marketing Name": "S7043G",
    "Device": "S7043G",
    "Model": "S7043G"
  },
  {
    "Retail Branding": "Click",
    "Marketing Name": "Tab 7",
    "Device": "I7043G",
    "Model": "I7043G"
  },
  {
    "Retail Branding": "ClickN Kids",
    "Marketing Name": "ClickN Kids",
    "Device": "g04e",
    "Model": "CK07T"
  },
  {
    "Retail Branding": "Clickonica Exclusive",
    "Marketing Name": "iTabS10",
    "Device": "iTabS10",
    "Model": "iTabS10"
  },
  {
    "Retail Branding": "Clickonica Exclusive",
    "Marketing Name": "itabx",
    "Device": "itabx",
    "Model": "itabx"
  },
  {
    "Retail Branding": "Clicktabds",
    "Marketing Name": "F19",
    "Device": "F19",
    "Model": "F19"
  },
  {
    "Retail Branding": "ClipSonic",
    "Marketing Name": "DVI37BT",
    "Device": "DVI37BT",
    "Model": "DV137BT"
  },
  {
    "Retail Branding": "Cloud (TruConnect)",
    "Marketing Name": "AEW7",
    "Device": "AEW7",
    "Model": "AEW7"
  },
  {
    "Retail Branding": "Cloud (TruConnect)",
    "Marketing Name": "AEW7A",
    "Device": "AEW7A",
    "Model": "AEW7A"
  },
  {
    "Retail Branding": "Cloud (TruConnect)",
    "Marketing Name": "Cirrus_C2",
    "Device": "Cirrus_C2",
    "Model": "Cirrus_C2"
  },
  {
    "Retail Branding": "Cloud (TruConnect)",
    "Marketing Name": "Cyclone_C4",
    "Device": "Cyclone_C4",
    "Model": "Cyclone_C4"
  },
  {
    "Retail Branding": "Cloud (TruConnect)",
    "Marketing Name": "OTTTAB3",
    "Device": "OTTTAB3",
    "Model": "OTTTAB3"
  },
  {
    "Retail Branding": "Cloud (TruConnect)",
    "Marketing Name": "Storm C3",
    "Device": "Storm_C3",
    "Model": "Storm_C3"
  },
  {
    "Retail Branding": "Cloud (TruConnect)",
    "Marketing Name": "Stratus_C5",
    "Device": "Stratus_C5",
    "Model": "Stratus_C5"
  },
  {
    "Retail Branding": "Cloud (TruConnect)",
    "Marketing Name": "Stratus_C5_Elite",
    "Device": "Stratus_C5_Elite",
    "Model": "Stratus_C5_Elite"
  },
  {
    "Retail Branding": "Cloud (TruConnect)",
    "Marketing Name": "Stratus_C7",
    "Device": "Stratus_C7",
    "Model": "Stratus_C7"
  },
  {
    "Retail Branding": "Cloud (TruConnect)",
    "Marketing Name": "Sunshine_T1",
    "Device": "Sunshine_T1",
    "Model": "Sunshine_T1"
  },
  {
    "Retail Branding": "Cloud (TruConnect)",
    "Marketing Name": "Sunshine_T1_Elite",
    "Device": "Sunshine_T1_Elite",
    "Model": "Sunshine_T1_Elite"
  },
  {
    "Retail Branding": "Cloud (TruConnect)",
    "Marketing Name": "Typhoon_C6",
    "Device": "Typhoon_C6",
    "Model": "Typhoon_C6"
  },
  {
    "Retail Branding": "CloudFone",
    "Marketing Name": "CloudFone Excite Prime 2",
    "Device": "Excite_Prime_2",
    "Model": "Excite Prime 2"
  },
  {
    "Retail Branding": "CloudFone",
    "Marketing Name": "CloudFone Next Infinity Plus",
    "Device": "Next_Infinity_Plus",
    "Model": "Next Infinity Plus"
  },
  {
    "Retail Branding": "CloudFone",
    "Marketing Name": "CloudFone Next Infinity Pro",
    "Device": "Next_Infinity_Pro",
    "Model": "Next Infinity Pro"
  },
  {
    "Retail Branding": "CloudFone",
    "Marketing Name": "CloudFone Thrill Boost 3",
    "Device": "Thrill_Boost_3",
    "Model": "Thrill Boost 3"
  },
  {
    "Retail Branding": "CloudFone",
    "Marketing Name": "CloudFone Thrill Plus 2",
    "Device": "Thrill_Plus_2",
    "Model": "Thrill Plus 2"
  },
  {
    "Retail Branding": "CloudFone",
    "Marketing Name": "CloudFone Thrill Snap",
    "Device": "Thrill_Snap",
    "Model": "Thrill Snap"
  },
  {
    "Retail Branding": "CloudFone",
    "Marketing Name": "Cloudpad One 6.95",
    "Device": "one695_1_coho",
    "Model": "one695_1"
  },
  {
    "Retail Branding": "CloudFone",
    "Marketing Name": "Cloudpad One 6.95",
    "Device": "one695_1_coho",
    "Model": "one695_1_coho"
  },
  {
    "Retail Branding": "CloudFone",
    "Marketing Name": "Cloudpad One 7.0",
    "Device": "one7_0_4_coho",
    "Model": "one7_0_4"
  },
  {
    "Retail Branding": "CloudFone",
    "Marketing Name": "Cloudpad One 7.0",
    "Device": "one7_0_4_coho",
    "Model": "one7_0_4_coho"
  },
  {
    "Retail Branding": "CloudFone",
    "Marketing Name": "Cloudpad One 8.0",
    "Device": "one8_0_1_coho",
    "Model": "one8_0_1"
  },
  {
    "Retail Branding": "CloudFone",
    "Marketing Name": "Cloudpad One 8.0",
    "Device": "one8_0_1_coho",
    "Model": "one8_0_1_coho"
  },
  {
    "Retail Branding": "CloudFone",
    "Marketing Name": "Excite Prime 2",
    "Device": "Excite_Prime_2",
    "Model": "Excite Prime 2"
  },
  {
    "Retail Branding": "CloudFone",
    "Marketing Name": "Excite Prime 2 Pro",
    "Device": "Excite_Prime_2_Pro",
    "Model": "Excite Prime 2 Pro"
  },
  {
    "Retail Branding": "CloudFone",
    "Marketing Name": "Go Connect Lite 2",
    "Device": "Go_Connect_Lite_2",
    "Model": "Go Connect Lite 2"
  },
  {
    "Retail Branding": "CloudFone",
    "Marketing Name": "Go SP 2",
    "Device": "Go_SP_2",
    "Model": "Go SP 2"
  },
  {
    "Retail Branding": "CloudFone",
    "Marketing Name": "Next Infinity",
    "Device": "Next_Infinity",
    "Model": "Next Infinity"
  },
  {
    "Retail Branding": "CloudFone",
    "Marketing Name": "Next Infinity Quattro",
    "Device": "Next_Infinity_4",
    "Model": "Next Infinity Quattro"
  },
  {
    "Retail Branding": "CloudFone",
    "Marketing Name": "Thrill Boost 2",
    "Device": "Thrill_Boost_2",
    "Model": "Thrill Boost 2"
  },
  {
    "Retail Branding": "CloudFone",
    "Marketing Name": "Thrill Plus 2",
    "Device": "Thrill_Plus_2",
    "Model": "Thrill Plus 2"
  },
  {
    "Retail Branding": "CloudFone",
    "Marketing Name": "Thrill Power N",
    "Device": "Thrill_Power_N",
    "Model": "Thrill Power N"
  },
  {
    "Retail Branding": "CloudFone",
    "Marketing Name": "Thrill Snap",
    "Device": "Thrill_Snap",
    "Model": "Thrill Snap"
  },
  {
    "Retail Branding": "CloudFone",
    "Marketing Name": "Thrill View",
    "Device": "Thrill_View",
    "Model": "Thrill View"
  },
  {
    "Retail Branding": "CloudFone",
    "Marketing Name": "ThrillBoost2Plus",
    "Device": "ThrillBoost2Plus",
    "Model": "Thrill Boost 2 Plus"
  },
  {
    "Retail Branding": "CloudMinds",
    "Marketing Name": "A1-901",
    "Device": "A1-901",
    "Model": "A1-901"
  },
  {
    "Retail Branding": "CloudMinds",
    "Marketing Name": "OTTTAB2",
    "Device": "OTTTAB2",
    "Model": "OTTTAB2"
  },
  {
    "Retail Branding": "Cloud_Mobile",
    "Marketing Name": "C9 Prime",
    "Device": "Stratus_C9_Prime",
    "Model": "Stratus C9 Prime"
  },
  {
    "Retail Branding": "Cloud_Mobile",
    "Marketing Name": "MC8B654B100136",
    "Device": "MC8B654B",
    "Model": "MC8B654B"
  },
  {
    "Retail Branding": "Cloud_Mobile",
    "Marketing Name": "Stratus_C8",
    "Device": "Stratus_C8",
    "Model": "Stratus C8"
  },
  {
    "Retail Branding": "Cloud_Mobile",
    "Marketing Name": "Stratus_C9",
    "Device": "Stratus_C9",
    "Model": "Stratus C9"
  },
  {
    "Retail Branding": "Cloud_Mobile",
    "Marketing Name": "Sunshine_T2_Elite",
    "Device": "Sunshine_T2_Elite",
    "Model": "Sunshine_T2_Elite"
  },
  {
    "Retail Branding": "Clout",
    "Marketing Name": "Hind 5.1",
    "Device": "Hind_5_1",
    "Model": "Hind 5.1"
  },
  {
    "Retail Branding": "Clout",
    "Marketing Name": "X425 Shavit",
    "Device": "X425_Shavit",
    "Model": "X425 Shavit"
  },
  {
    "Retail Branding": "Clout",
    "Marketing Name": "X428 Astute",
    "Device": "X428_Astute",
    "Model": "X428 Astute"
  },
  {
    "Retail Branding": "Clover",
    "Marketing Name": "FTab",
    "Device": "FTab",
    "Model": "FTab"
  },
  {
    "Retail Branding": "Clover",
    "Marketing Name": "G11",
    "Device": "G11",
    "Model": "G11"
  },
  {
    "Retail Branding": "Clover",
    "Marketing Name": "G11A",
    "Device": "G11A",
    "Model": "G11"
  },
  {
    "Retail Branding": "Clover",
    "Marketing Name": "K1196",
    "Device": "K1196",
    "Model": "K1196"
  },
  {
    "Retail Branding": "Clover",
    "Marketing Name": "KD101",
    "Device": "KD101",
    "Model": "KD101"
  },
  {
    "Retail Branding": "Cobalt",
    "Marketing Name": "CP101P",
    "Device": "POS",
    "Model": "CP101P"
  },
  {
    "Retail Branding": "Cobalt",
    "Marketing Name": "Cobalt T10 wifi",
    "Device": "Cobalt_T10_wifi",
    "Model": "Cobalt_T10_wifi"
  },
  {
    "Retail Branding": "Cobalt",
    "Marketing Name": "Cobalt-T7_3G",
    "Device": "Cobalt-T7_3G",
    "Model": "Cobalt-T7_3G"
  },
  {
    "Retail Branding": "Cobalt",
    "Marketing Name": "Cobalt_T10_3G",
    "Device": "Cobalt_T10_3G",
    "Model": "Cobalt_T10_3G"
  },
  {
    "Retail Branding": "Cobalt",
    "Marketing Name": "Cobalt_T7_wifi",
    "Device": "Cobalt_T7_wifi",
    "Model": "Cobalt_T7_wifi"
  },
  {
    "Retail Branding": "Cobalt",
    "Marketing Name": "SM5",
    "Device": "Cobalt_SM_5",
    "Model": "Cobalt_SM_5"
  },
  {
    "Retail Branding": "Cobalt",
    "Marketing Name": "SM55",
    "Device": "Cobalt_SM_55",
    "Model": "Cobalt_SM_55"
  },
  {
    "Retail Branding": "Cobalt",
    "Marketing Name": "SM6",
    "Device": "Cobalt_SM_6",
    "Model": "Cobalt_SM_6"
  },
  {
    "Retail Branding": "Cobia",
    "Marketing Name": "Brazil",
    "Device": "nippori",
    "Model": "Cobia 2K Android TV"
  },
  {
    "Retail Branding": "Cobia",
    "Marketing Name": "Cobia",
    "Device": "seocho",
    "Model": "Cobia 4K Android TV"
  },
  {
    "Retail Branding": "Cobia",
    "Marketing Name": "Cobia",
    "Device": "sugamo",
    "Model": "Cobia 2K Android TV"
  },
  {
    "Retail Branding": "Cobia",
    "Marketing Name": "R3",
    "Device": "R3",
    "Model": "R3"
  },
  {
    "Retail Branding": "Cobia",
    "Marketing Name": "R4",
    "Device": "R4",
    "Model": "R4"
  },
  {
    "Retail Branding": "Coby",
    "Marketing Name": "CTB761",
    "Device": "CTB761",
    "Model": "CTB761"
  },
  {
    "Retail Branding": "Coby",
    "Marketing Name": "Dorado",
    "Device": "Dorado",
    "Model": "Dorado"
  },
  {
    "Retail Branding": "Coby",
    "Marketing Name": "MID-CBY1108",
    "Device": "MID-CBY1108",
    "Model": "MID-CBY1108"
  },
  {
    "Retail Branding": "Coby",
    "Marketing Name": "MID7052",
    "Device": "MID7052",
    "Model": "MID7052"
  },
  {
    "Retail Branding": "Coby",
    "Marketing Name": "MID8072",
    "Device": "MID8072",
    "Model": "MID8072"
  },
  {
    "Retail Branding": "Code",
    "Marketing Name": "CR4900",
    "Device": "cr4900",
    "Model": "CR4900"
  },
  {
    "Retail Branding": "Cogeco",
    "Marketing Name": "EPICO 4K",
    "Device": "m393gena_c",
    "Model": "EPICO 4K"
  },
  {
    "Retail Branding": "CoinComputers",
    "Marketing Name": "1100AS_plus",
    "Device": "1100AS_plus",
    "Model": "1100AS_plus"
  },
  {
    "Retail Branding": "CoinComputers",
    "Marketing Name": "1200AS",
    "Device": "1200AS",
    "Model": "1200AS"
  },
  {
    "Retail Branding": "CoinComputers",
    "Marketing Name": "1200AS_plus",
    "Device": "1200AS_plus",
    "Model": "1200AS_plus"
  },
  {
    "Retail Branding": "CoinComputers",
    "Marketing Name": "TF10EA2",
    "Device": "TF10EA2_5",
    "Model": "TF10EA2"
  },
  {
    "Retail Branding": "ColorsMobile",
    "Marketing Name": "P40_Pride_1",
    "Device": "P40_Pride_1",
    "Model": "P40_Pride_1"
  },
  {
    "Retail Branding": "ColorsMobile",
    "Marketing Name": "P45",
    "Device": "Colors_P45",
    "Model": "Colors P45"
  },
  {
    "Retail Branding": "ColorsMobile",
    "Marketing Name": "P50_Plus",
    "Device": "Colors_P50_Plus",
    "Model": "Colors P50 Plus"
  },
  {
    "Retail Branding": "ColorsMobile",
    "Marketing Name": "P65",
    "Device": "Colors_P65",
    "Model": "Colors P65"
  },
  {
    "Retail Branding": "ColorsMobile",
    "Marketing Name": "P77_Pride_1E",
    "Device": "P77_Pride_1E",
    "Model": "P77_Pride_1E"
  },
  {
    "Retail Branding": "ColorsMobile",
    "Marketing Name": "P88_Pride_1X",
    "Device": "P88_Pride_1X",
    "Model": "P88_Pride_1X"
  },
  {
    "Retail Branding": "ColorsMobile",
    "Marketing Name": "P95_Pride_7s",
    "Device": "P95_Pride_7s",
    "Model": "P95_Pride_7s"
  },
  {
    "Retail Branding": "ColorsMobile",
    "Marketing Name": "PRIDE 5E",
    "Device": "P60",
    "Model": "P60"
  },
  {
    "Retail Branding": "ColorsMobile",
    "Marketing Name": "Pride 5C",
    "Device": "P52_Pride5C",
    "Model": "P52_Pride5C"
  },
  {
    "Retail Branding": "ColorsMobile",
    "Marketing Name": "Pride5X",
    "Device": "P90_Pride5X",
    "Model": "P90_Pride5X"
  },
  {
    "Retail Branding": "ColorsMobile",
    "Marketing Name": "Pride_1A",
    "Device": "Pride_1A",
    "Model": "Pride_1A"
  },
  {
    "Retail Branding": "ColorsMobile",
    "Marketing Name": "S1",
    "Device": "Colors_S1",
    "Model": "Colors S1"
  },
  {
    "Retail Branding": "ColorsMobile",
    "Marketing Name": "S11",
    "Device": "Colors_S11",
    "Model": "Colors S11"
  },
  {
    "Retail Branding": "ColorsMobile",
    "Marketing Name": "S9",
    "Device": "Colors_S9",
    "Model": "Colors S9"
  },
  {
    "Retail Branding": "Comio",
    "Marketing Name": "AD7003",
    "Device": "AD7003",
    "Model": "AD7003"
  },
  {
    "Retail Branding": "Comio",
    "Marketing Name": "COMIO C1",
    "Device": "ComioC1",
    "Model": "COMIO C1"
  },
  {
    "Retail Branding": "Comio",
    "Marketing Name": "COMIO C1 Pro",
    "Device": "ComioC1Pro",
    "Model": "Comio C1 Pro"
  },
  {
    "Retail Branding": "Comio",
    "Marketing Name": "COMIO C2",
    "Device": "ComioC2",
    "Model": "COMIO C2"
  },
  {
    "Retail Branding": "Comio",
    "Marketing Name": "COMIO C2 Lite",
    "Device": "ComioC2Lite",
    "Model": "Comio C2 Lite"
  },
  {
    "Retail Branding": "Comio",
    "Marketing Name": "COMIO P1",
    "Device": "ComioP1",
    "Model": "COMIO P1"
  },
  {
    "Retail Branding": "Comio",
    "Marketing Name": "COMIO S1",
    "Device": "ComioS1",
    "Model": "COMIO S1"
  },
  {
    "Retail Branding": "Comio",
    "Marketing Name": "COMIO S1 Lite",
    "Device": "ComioS1Lite",
    "Model": "COMIO S1 Lite"
  },
  {
    "Retail Branding": "Comio",
    "Marketing Name": "COMIO X1",
    "Device": "ComioX1",
    "Model": "Comio X1"
  },
  {
    "Retail Branding": "CommBox",
    "Marketing Name": "CommBox Classic S5",
    "Device": "rk3576_u",
    "Model": "CommBox_Classic_S5"
  },
  {
    "Retail Branding": "Commodore",
    "Marketing Name": "CTABMAX_EEA",
    "Device": "CTABMAX",
    "Model": "CTAB-MAX"
  },
  {
    "Retail Branding": "Compal",
    "Marketing Name": "",
    "Device": "CA22",
    "Model": "COSMO DUO"
  },
  {
    "Retail Branding": "Compal",
    "Marketing Name": "",
    "Device": "CAP5",
    "Model": "A600"
  },
  {
    "Retail Branding": "Compal",
    "Marketing Name": "",
    "Device": "CAP6",
    "Model": "A600"
  },
  {
    "Retail Branding": "Compal",
    "Marketing Name": "",
    "Device": "CAP7",
    "Model": "A300"
  },
  {
    "Retail Branding": "Compal",
    "Marketing Name": "",
    "Device": "CAP7",
    "Model": "A8"
  },
  {
    "Retail Branding": "Compal",
    "Marketing Name": "",
    "Device": "CAP7",
    "Model": "W12"
  },
  {
    "Retail Branding": "Compal",
    "Marketing Name": "",
    "Device": "cap2",
    "Model": "Andy"
  },
  {
    "Retail Branding": "Compal",
    "Marketing Name": "",
    "Device": "penguin",
    "Model": "AX 8.6"
  },
  {
    "Retail Branding": "Compal",
    "Marketing Name": "TANK 4.5",
    "Device": "ka09",
    "Model": "TANK 4.5"
  },
  {
    "Retail Branding": "Compaq",
    "Marketing Name": "Android TV",
    "Device": "R1",
    "Model": "ATV R1"
  },
  {
    "Retail Branding": "Compaq",
    "Marketing Name": "Android TV",
    "Device": "R2",
    "Model": "ATV R2"
  },
  {
    "Retail Branding": "Compaq",
    "Marketing Name": "COMPAQ",
    "Device": "stanford",
    "Model": "SMART TV"
  },
  {
    "Retail Branding": "Compaq",
    "Marketing Name": "COMPAQ",
    "Device": "zhongshan",
    "Model": "SMART TV"
  },
  {
    "Retail Branding": "Compaq",
    "Marketing Name": "COMPAQ SMART TV",
    "Device": "marina",
    "Model": "COMPAQ SMART TV"
  },
  {
    "Retail Branding": "Compaq",
    "Marketing Name": "COMPAQ SMART TV",
    "Device": "nagata",
    "Model": "COMPAQ SMART TV"
  },
  {
    "Retail Branding": "Compaq",
    "Marketing Name": "CT101",
    "Device": "fireball",
    "Model": "CT101"
  },
  {
    "Retail Branding": "Compaq",
    "Marketing Name": "CT201",
    "Device": "CT201",
    "Model": "CT201"
  },
  {
    "Retail Branding": "Compaq",
    "Marketing Name": "CT211",
    "Device": "CT211",
    "Model": "CT211"
  },
  {
    "Retail Branding": "Compaq",
    "Marketing Name": "CT301T",
    "Device": "CT301T",
    "Model": "CT301T"
  },
  {
    "Retail Branding": "Compaq",
    "Marketing Name": "CT311T",
    "Device": "CT311T",
    "Model": "CT311T"
  },
  {
    "Retail Branding": "Compaq",
    "Marketing Name": "Colombia",
    "Device": "sepolia",
    "Model": "COMPAQ TV"
  },
  {
    "Retail Branding": "Compaq",
    "Marketing Name": "Compaq_Q3",
    "Device": "Compaq_Q3",
    "Model": "Compaq_Q3"
  },
  {
    "Retail Branding": "Compaq",
    "Marketing Name": "India/Srilanka/Bangladesh/GCC",
    "Device": "guandu",
    "Model": "COMPAQ ANDROID 4K TV"
  },
  {
    "Retail Branding": "Compaq",
    "Marketing Name": "India/Srilanka/Bangladesh/GCC",
    "Device": "martin",
    "Model": "COMPAQ ANDROID 2K TV"
  },
  {
    "Retail Branding": "Compaq",
    "Marketing Name": "K101_pro",
    "Device": "K101_pro",
    "Model": "K101_pro"
  },
  {
    "Retail Branding": "Compaq",
    "Marketing Name": "Q5",
    "Device": "Q5",
    "Model": "Q5"
  },
  {
    "Retail Branding": "Compaq",
    "Marketing Name": "Q5 PRO",
    "Device": "Q5_PRO",
    "Model": "Q5_PRO"
  },
  {
    "Retail Branding": "Compaq",
    "Marketing Name": "Q6",
    "Device": "Q6",
    "Model": "Q6"
  },
  {
    "Retail Branding": "Compaq",
    "Marketing Name": "QT10",
    "Device": "Compaq_QT10",
    "Model": "QT10"
  },
  {
    "Retail Branding": "Compaq",
    "Marketing Name": "QT10",
    "Device": "QT10",
    "Model": "QT10"
  },
  {
    "Retail Branding": "Compaq",
    "Marketing Name": "QT11AVHE464M",
    "Device": "Q_PAD",
    "Model": "Q_PAD"
  },
  {
    "Retail Branding": "Compaq",
    "Marketing Name": "QT12AVHE6128M",
    "Device": "Q_Pad_Plus",
    "Model": "Q_Pad_Plus"
  },
  {
    "Retail Branding": "Compaq",
    "Marketing Name": "QT9AVHE464Q",
    "Device": "QT9AVHE464Q",
    "Model": "Q_Tab"
  },
  {
    "Retail Branding": "Compaq",
    "Marketing Name": "QTAB",
    "Device": "QTAB",
    "Model": "QTAB"
  },
  {
    "Retail Branding": "Compaq",
    "Marketing Name": "QTAB10_1",
    "Device": "QTAB10_1",
    "Model": "QTAB10.1"
  },
  {
    "Retail Branding": "Compaq",
    "Marketing Name": "QTAB10_1",
    "Device": "QTAB10_1",
    "Model": "QTAB10_1"
  },
  {
    "Retail Branding": "Compaq",
    "Marketing Name": "QTAB10_PLUS",
    "Device": "QTAB10_PLUS",
    "Model": "QTAB10 PLUS"
  },
  {
    "Retail Branding": "Compaq",
    "Marketing Name": "QTAB10_PLUS",
    "Device": "QTAB10_PLUS",
    "Model": "QTAB10_PLUS"
  },
  {
    "Retail Branding": "Compaq",
    "Marketing Name": "QTAB8",
    "Device": "QTAB8",
    "Model": "QTAB8"
  },
  {
    "Retail Branding": "Compaq",
    "Marketing Name": "QTAB_NOTE",
    "Device": "QTAB_NOTE",
    "Model": "QTAB_NOTE"
  },
  {
    "Retail Branding": "Compaq",
    "Marketing Name": "QTAB_PLUS_LTE",
    "Device": "QTAB_PLUS_LTE",
    "Model": "QTAB_PLUS_LTE"
  },
  {
    "Retail Branding": "Compaq",
    "Marketing Name": "QTab10.1_LTE",
    "Device": "QTab10_LTE",
    "Model": "QTab10_LTE"
  },
  {
    "Retail Branding": "Compaq",
    "Marketing Name": "QTab8",
    "Device": "QTab8",
    "Model": "QTab8"
  },
  {
    "Retail Branding": "Compaq",
    "Marketing Name": "QTab8_LTE",
    "Device": "QTab8_LTE",
    "Model": "QTab8_LTE"
  },
  {
    "Retail Branding": "Compaq",
    "Marketing Name": "QTabPro",
    "Device": "QTabPro",
    "Model": "QTabPro"
  },
  {
    "Retail Branding": "Compaq",
    "Marketing Name": "QTabPro",
    "Device": "Qtab",
    "Model": "QTabPro"
  },
  {
    "Retail Branding": "Compaq",
    "Marketing Name": "QTab_87",
    "Device": "QTab_87",
    "Model": "QTab_87"
  },
  {
    "Retail Branding": "Compaq",
    "Marketing Name": "Qtab 10.1 with keyboard",
    "Device": "Qtab10",
    "Model": "Qtab 10.1 with keyboard"
  },
  {
    "Retail Branding": "Compaq",
    "Marketing Name": "Qtab10Plus",
    "Device": "Qtab10Plus",
    "Model": "Qtab10Plus"
  },
  {
    "Retail Branding": "Compaq",
    "Marketing Name": "Qtab_Ultra",
    "Device": "Qtab_Ultra",
    "Model": "Qtab Ultra"
  },
  {
    "Retail Branding": "Compaq",
    "Marketing Name": "South Africa",
    "Device": "sepolia",
    "Model": "COMPAQ GOOGLE TV"
  },
  {
    "Retail Branding": "Compaq",
    "Marketing Name": "Venezuela",
    "Device": "marina",
    "Model": "COMPAQ SMART 4K TV"
  },
  {
    "Retail Branding": "Compaq",
    "Marketing Name": "Venezuela",
    "Device": "nagata",
    "Model": "COMPAQ SMART 2K TV"
  },
  {
    "Retail Branding": "Concord",
    "Marketing Name": "A10",
    "Device": "A10",
    "Model": "A10"
  },
  {
    "Retail Branding": "Concord",
    "Marketing Name": "C-708",
    "Device": "C-708",
    "Model": "C-708"
  },
  {
    "Retail Branding": "Concord",
    "Marketing Name": "Concord M15",
    "Device": "Concord_M15",
    "Model": "Concord M15"
  },
  {
    "Retail Branding": "Concord",
    "Marketing Name": "Concord_RANGE_HS",
    "Device": "Concord_RANGE_HS",
    "Model": "Concord_RANGE_HS"
  },
  {
    "Retail Branding": "Concord",
    "Marketing Name": "Concord_Range_S9",
    "Device": "Concord_Range_S9",
    "Model": "Concord_Range_S9"
  },
  {
    "Retail Branding": "Concord",
    "Marketing Name": "Dream_Edition_C-754",
    "Device": "Dream_Edition_C-754",
    "Model": "Dream_Edition_C-754"
  },
  {
    "Retail Branding": "Concord",
    "Marketing Name": "M20 TERMINAL",
    "Device": "Concord_M20",
    "Model": "Concord_M20"
  },
  {
    "Retail Branding": "Concord",
    "Marketing Name": "Plus-7_C777",
    "Device": "Plus-7_C777",
    "Model": "Plus-7_C777"
  },
  {
    "Retail Branding": "Concord",
    "Marketing Name": "Plus-9_C778",
    "Device": "Plus-9_C778",
    "Model": "Plus-9_C778"
  },
  {
    "Retail Branding": "Concord",
    "Marketing Name": "Plus_M19_C779",
    "Device": "Plus_M19_C779",
    "Model": "Plus_M19_C779"
  },
  {
    "Retail Branding": "Concord",
    "Marketing Name": "SmartPad-3G_C-708",
    "Device": "SmartPad_3G",
    "Model": "SmartPad-3G_C-708"
  },
  {
    "Retail Branding": "Condor",
    "Marketing Name": "32SD520",
    "Device": "ikebukuro",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "Condor",
    "Marketing Name": "80Pro",
    "Device": "80Pro",
    "Model": "80Pro"
  },
  {
    "Retail Branding": "Condor",
    "Marketing Name": "A9",
    "Device": "PGN_507",
    "Model": "PGN-507"
  },
  {
    "Retail Branding": "Condor",
    "Marketing Name": "Algeria",
    "Device": "samseong",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "Condor",
    "Marketing Name": "Allure  M1",
    "Device": "Allure_M1",
    "Model": "Allure M1"
  },
  {
    "Retail Branding": "Condor",
    "Marketing Name": "Allure A55 Plus",
    "Device": "PGN613",
    "Model": "PGN613"
  },
  {
    "Retail Branding": "Condor",
    "Marketing Name": "Allure M1",
    "Device": "Allure_M1",
    "Model": "Allure M1"
  },
  {
    "Retail Branding": "Condor",
    "Marketing Name": "Allure M1 Plus",
    "Device": "Allure_M1_Plus",
    "Model": "Allure M1 Plus"
  },
  {
    "Retail Branding": "Condor",
    "Marketing Name": "Allure M2",
    "Device": "Allure_M2",
    "Model": "Allure M2"
  },
  {
    "Retail Branding": "Condor",
    "Marketing Name": "Allure M3",
    "Device": "Allure_M3",
    "Model": "Allure M3"
  },
  {
    "Retail Branding": "Condor",
    "Marketing Name": "Allure M3 Lite",
    "Device": "Allure_M3_Lite",
    "Model": "Allure M3 Lite"
  },
  {
    "Retail Branding": "Condor",
    "Marketing Name": "Allure M3 lite",
    "Device": "Allure_M3_Lite",
    "Model": "Allure M3 Lite"
  },
  {
    "Retail Branding": "Condor",
    "Marketing Name": "Allure X",
    "Device": "Allure_X",
    "Model": "Allure X"
  },
  {
    "Retail Branding": "Condor",
    "Marketing Name": "Allure_A8_Pro",
    "Device": "Allure_A8_Pro",
    "Model": "Allure A8 Pro"
  },
  {
    "Retail Branding": "Condor",
    "Marketing Name": "Android TV",
    "Device": "R2",
    "Model": "ATV R2"
  },
  {
    "Retail Branding": "Condor",
    "Marketing Name": "C1+",
    "Device": "C1Plus",
    "Model": "C1+"
  },
  {
    "Retail Branding": "Condor",
    "Marketing Name": "C6+",
    "Device": "PGN_508",
    "Model": "PGN-508"
  },
  {
    "Retail Branding": "Condor",
    "Marketing Name": "C7",
    "Device": "PGN_506",
    "Model": "PGN-506"
  },
  {
    "Retail Branding": "Condor",
    "Marketing Name": "C_5",
    "Device": "u970_5",
    "Model": "C-6"
  },
  {
    "Retail Branding": "Condor",
    "Marketing Name": "Customer need debug",
    "Device": "TB108W",
    "Model": "TB108W"
  },
  {
    "Retail Branding": "Condor",
    "Marketing Name": "G6 Pro",
    "Device": "PHQ526",
    "Model": "PHQ526"
  },
  {
    "Retail Branding": "Condor",
    "Marketing Name": "GT 80Pro",
    "Device": "GT_80Pro",
    "Model": "GT 80Pro"
  },
  {
    "Retail Branding": "Condor",
    "Marketing Name": "GT60 PRO",
    "Device": "GT60_PRO",
    "Model": "GT60 PRO"
  },
  {
    "Retail Branding": "Condor",
    "Marketing Name": "Griffe G5",
    "Device": "PHQ520",
    "Model": "Griffe G5"
  },
  {
    "Retail Branding": "Condor",
    "Marketing Name": "Griffe G5",
    "Device": "PHQ520",
    "Model": "PHQ520"
  },
  {
    "Retail Branding": "Condor",
    "Marketing Name": "Griffe G5 Plus",
    "Device": "PAM524",
    "Model": "PAM524"
  },
  {
    "Retail Branding": "Condor",
    "Marketing Name": "Griffe T1",
    "Device": "Griffe_T1",
    "Model": "SP413"
  },
  {
    "Retail Branding": "Condor",
    "Marketing Name": "Griffe T10",
    "Device": "Griffe_T10",
    "Model": "Griffe T10"
  },
  {
    "Retail Branding": "Condor",
    "Marketing Name": "Griffe T3",
    "Device": "SP414",
    "Model": "Griffe T3"
  },
  {
    "Retail Branding": "Condor",
    "Marketing Name": "Griffe T4",
    "Device": "SP531",
    "Model": "SP531"
  },
  {
    "Retail Branding": "Condor",
    "Marketing Name": "Griffe T5",
    "Device": "Griffe_T5",
    "Model": "Griffe T5"
  },
  {
    "Retail Branding": "Condor",
    "Marketing Name": "Griffe T6",
    "Device": "Griffe_T6",
    "Model": "Griffe T6"
  },
  {
    "Retail Branding": "Condor",
    "Marketing Name": "Griffe T7",
    "Device": "Griffe_T7",
    "Model": "Griffe T7"
  },
  {
    "Retail Branding": "Condor",
    "Marketing Name": "Griffe T7_TE",
    "Device": "Griffe_T7",
    "Model": "Griffe T7"
  },
  {
    "Retail Branding": "Condor",
    "Marketing Name": "Griffe T8",
    "Device": "Griffe_T8",
    "Model": "Griffe T8"
  },
  {
    "Retail Branding": "Condor",
    "Marketing Name": "Griffe T8 Plus",
    "Device": "SP641",
    "Model": "Griffe T8 Plus"
  },
  {
    "Retail Branding": "Condor",
    "Marketing Name": "Griffe T9",
    "Device": "Griffe_T9",
    "Model": "Griffe T9"
  },
  {
    "Retail Branding": "Condor",
    "Marketing Name": "Griffe T9 Plus",
    "Device": "Griffe_T9_Plus",
    "Model": "Griffe T9 Plus"
  },
  {
    "Retail Branding": "Condor",
    "Marketing Name": "Griffe_T5",
    "Device": "Griffe_T5",
    "Model": "Griffe T5"
  },
  {
    "Retail Branding": "Condor",
    "Marketing Name": "Griffe_T7",
    "Device": "Griffe_T7",
    "Model": "Griffe T7"
  },
  {
    "Retail Branding": "Condor",
    "Marketing Name": "HS-U939",
    "Device": "u939e_6",
    "Model": "HS-U939"
  },
  {
    "Retail Branding": "Condor",
    "Marketing Name": "Infinity E5",
    "Device": "Infinity_E5",
    "Model": "Infinity E5"
  },
  {
    "Retail Branding": "Condor",
    "Marketing Name": "Infinity E5 Pro",
    "Device": "Infinity_E5_Pro",
    "Model": "Infinity e5 pro"
  },
  {
    "Retail Branding": "Condor",
    "Marketing Name": "Infinity_E4",
    "Device": "Infinity_e4",
    "Model": "Infinity e4"
  },
  {
    "Retail Branding": "Condor",
    "Marketing Name": "Infinity_a4",
    "Device": "Infinity_a4",
    "Model": "Infinity a4"
  },
  {
    "Retail Branding": "Condor",
    "Marketing Name": "Infinity_i5",
    "Device": "Infinity_i5",
    "Model": "Infinity_i5"
  },
  {
    "Retail Branding": "Condor",
    "Marketing Name": "NOVA 80",
    "Device": "NOVA_80",
    "Model": "NOVA 80"
  },
  {
    "Retail Branding": "Condor",
    "Marketing Name": "NOVA60",
    "Device": "NOVA60",
    "Model": "NOVA60"
  },
  {
    "Retail Branding": "Condor",
    "Marketing Name": "PGN404",
    "Device": "PGN404",
    "Model": "PGN404"
  },
  {
    "Retail Branding": "Condor",
    "Marketing Name": "PGN409",
    "Device": "PGN409",
    "Model": "PGN409"
  },
  {
    "Retail Branding": "Condor",
    "Marketing Name": "PGN410",
    "Device": "PGN410",
    "Model": "PGN410"
  },
  {
    "Retail Branding": "Condor",
    "Marketing Name": "PGN507",
    "Device": "PGN507",
    "Model": "PGN-507"
  },
  {
    "Retail Branding": "Condor",
    "Marketing Name": "PGN509",
    "Device": "PGN509",
    "Model": "PGN509"
  },
  {
    "Retail Branding": "Condor",
    "Marketing Name": "PGN511",
    "Device": "PGN511",
    "Model": "PGN511"
  },
  {
    "Retail Branding": "Condor",
    "Marketing Name": "PGN513",
    "Device": "PGN513",
    "Model": "PGN513"
  },
  {
    "Retail Branding": "Condor",
    "Marketing Name": "PGN514",
    "Device": "PGN514",
    "Model": "PGN514"
  },
  {
    "Retail Branding": "Condor",
    "Marketing Name": "PGN515",
    "Device": "PGN515",
    "Model": "PGN515"
  },
  {
    "Retail Branding": "Condor",
    "Marketing Name": "PGN516",
    "Device": "PGN516",
    "Model": "PGN516"
  },
  {
    "Retail Branding": "Condor",
    "Marketing Name": "PGN517",
    "Device": "PGN517",
    "Model": "PGN517"
  },
  {
    "Retail Branding": "Condor",
    "Marketing Name": "PGN518",
    "Device": "PGN518",
    "Model": "PGN518"
  },
  {
    "Retail Branding": "Condor",
    "Marketing Name": "PGN521",
    "Device": "PGN521",
    "Model": "PGN521"
  },
  {
    "Retail Branding": "Condor",
    "Marketing Name": "PGN522",
    "Device": "PGN522",
    "Model": "PGN522"
  },
  {
    "Retail Branding": "Condor",
    "Marketing Name": "PGN523",
    "Device": "PGN523",
    "Model": "PGN523"
  },
  {
    "Retail Branding": "Condor",
    "Marketing Name": "PGN605",
    "Device": "PGN605",
    "Model": "PGN605"
  },
  {
    "Retail Branding": "Condor",
    "Marketing Name": "PGN606",
    "Device": "PGN606",
    "Model": "PGN606"
  },
  {
    "Retail Branding": "Condor",
    "Marketing Name": "PGN607",
    "Device": "PGN607",
    "Model": "PGN607"
  },
  {
    "Retail Branding": "Condor",
    "Marketing Name": "PGN608",
    "Device": "PGN608",
    "Model": "PGN608"
  },
  {
    "Retail Branding": "Condor",
    "Marketing Name": "PGN609",
    "Device": "PGN609",
    "Model": "PGN609"
  },
  {
    "Retail Branding": "Condor",
    "Marketing Name": "PGN610",
    "Device": "PGN610",
    "Model": "PGN610"
  },
  {
    "Retail Branding": "Condor",
    "Marketing Name": "PGN611",
    "Device": "PGN611",
    "Model": "PGN611"
  },
  {
    "Retail Branding": "Condor",
    "Marketing Name": "PGN612",
    "Device": "PGN612",
    "Model": "PGN612"
  },
  {
    "Retail Branding": "Condor",
    "Marketing Name": "PHQ525",
    "Device": "PHQ525",
    "Model": "PHQ525"
  },
  {
    "Retail Branding": "Condor",
    "Marketing Name": "Plume A8 Plus",
    "Device": "PGN612",
    "Model": "PGN612"
  },
  {
    "Retail Branding": "Condor",
    "Marketing Name": "Plume H1",
    "Device": "SP620",
    "Model": "Plume H1"
  },
  {
    "Retail Branding": "Condor",
    "Marketing Name": "Plume L1",
    "Device": "SP622",
    "Model": "Plume L1"
  },
  {
    "Retail Branding": "Condor",
    "Marketing Name": "Plume L1 Plus",
    "Device": "Plume_L1_Plus",
    "Model": "Plume L1 Plus"
  },
  {
    "Retail Branding": "Condor",
    "Marketing Name": "Plume L2",
    "Device": "Plume_L2",
    "Model": "Plume L2"
  },
  {
    "Retail Branding": "Condor",
    "Marketing Name": "Plume L2 Pro",
    "Device": "Plume_L2_Pro",
    "Model": "Plume L2 Pro"
  },
  {
    "Retail Branding": "Condor",
    "Marketing Name": "Plume L3",
    "Device": "Plume_L3",
    "Model": "Plume L3"
  },
  {
    "Retail Branding": "Condor",
    "Marketing Name": "Plume L4",
    "Device": "Plume_L4",
    "Model": "Plume L4"
  },
  {
    "Retail Branding": "Condor",
    "Marketing Name": "Plume L4 Pro",
    "Device": "Plume_L4_Pro",
    "Model": "Plume L4 Pro"
  },
  {
    "Retail Branding": "Condor",
    "Marketing Name": "Plume L5",
    "Device": "Plume_L5",
    "Model": "Plume L5"
  },
  {
    "Retail Branding": "Condor",
    "Marketing Name": "Plume L6 Pro",
    "Device": "Plume_L6_Pro",
    "Model": "Plume L6 Pro"
  },
  {
    "Retail Branding": "Condor",
    "Marketing Name": "Plume L8 Pro",
    "Device": "Plume_L8_Pro",
    "Model": "Plume L8 Pro"
  },
  {
    "Retail Branding": "Condor",
    "Marketing Name": "Plume P4 Plus",
    "Device": "PGN527",
    "Model": "PGN527"
  },
  {
    "Retail Branding": "Condor",
    "Marketing Name": "Plume P6 Pro LTE",
    "Device": "PGN528",
    "Model": "PGN528"
  },
  {
    "Retail Branding": "Condor",
    "Marketing Name": "Plume P8 Lite",
    "Device": "PGN610",
    "Model": "PGN610"
  },
  {
    "Retail Branding": "Condor",
    "Marketing Name": "Plume P8 Pro",
    "Device": "Plume_P8_Pro",
    "Model": "Plume P8 Pro"
  },
  {
    "Retail Branding": "Condor",
    "Marketing Name": "Plume_L2_Pro",
    "Device": "Plume_L2_Pro",
    "Model": "Plume L2 Pro"
  },
  {
    "Retail Branding": "Condor",
    "Marketing Name": "Plume_L2_Pro_EEA",
    "Device": "Plume_L2_Pro",
    "Model": "Plume L2 Pro"
  },
  {
    "Retail Branding": "Condor",
    "Marketing Name": "Plume_L3_Plus",
    "Device": "Plume_L3_Plus",
    "Model": "Plume L3 Plus"
  },
  {
    "Retail Branding": "Condor",
    "Marketing Name": "Plume_L4_Pro_EEA",
    "Device": "Plume_L4_Pro",
    "Model": "Plume L4 Pro"
  },
  {
    "Retail Branding": "Condor",
    "Marketing Name": "Plume_L4_Pro_TE",
    "Device": "Plume_L4_Pro",
    "Model": "Plume L4 Pro"
  },
  {
    "Retail Branding": "Condor",
    "Marketing Name": "Plume_L5_Pro",
    "Device": "Plume_L5_Pro",
    "Model": "Plume L5 Pro"
  },
  {
    "Retail Branding": "Condor",
    "Marketing Name": "R4",
    "Device": "R4",
    "Model": "R4"
  },
  {
    "Retail Branding": "Condor",
    "Marketing Name": "SP530",
    "Device": "SP530",
    "Model": "Griffe T2"
  },
  {
    "Retail Branding": "Condor",
    "Marketing Name": "SP638",
    "Device": "SP638",
    "Model": "Plume L3 Smart"
  },
  {
    "Retail Branding": "Condor",
    "Marketing Name": "SP659",
    "Device": "NOVA60_i",
    "Model": "NOVA60 i"
  },
  {
    "Retail Branding": "Condor",
    "Marketing Name": "SP661",
    "Device": "GT60",
    "Model": "GT60"
  },
  {
    "Retail Branding": "Condor",
    "Marketing Name": "SP662",
    "Device": "NOVA_70SE",
    "Model": "NOVA 70SE"
  },
  {
    "Retail Branding": "Condor",
    "Marketing Name": "SP663",
    "Device": "NOVA_70i",
    "Model": "NOVA 70i"
  },
  {
    "Retail Branding": "Condor",
    "Marketing Name": "SP664",
    "Device": "NOVA_70",
    "Model": "NOVA 70"
  },
  {
    "Retail Branding": "Condor",
    "Marketing Name": "SP664_2",
    "Device": "NOVA_70",
    "Model": "NOVA 70"
  },
  {
    "Retail Branding": "Condor",
    "Marketing Name": "SP665",
    "Device": "GT_70",
    "Model": "GT 70"
  },
  {
    "Retail Branding": "Condor",
    "Marketing Name": "SP666",
    "Device": "MATE_70",
    "Model": "MATE 70"
  },
  {
    "Retail Branding": "Condor",
    "Marketing Name": "SP667",
    "Device": "NOVA_70S",
    "Model": "NOVA 70S"
  },
  {
    "Retail Branding": "Condor",
    "Marketing Name": "SP668",
    "Device": "NOVA_70PRO",
    "Model": "NOVA 70PRO"
  },
  {
    "Retail Branding": "Condor",
    "Marketing Name": "SP669",
    "Device": "NOVA_80A",
    "Model": "NOVA 80A"
  },
  {
    "Retail Branding": "Condor",
    "Marketing Name": "SP670",
    "Device": "NOVA_80i",
    "Model": "NOVA 80i"
  },
  {
    "Retail Branding": "Condor",
    "Marketing Name": "SP672",
    "Device": "NOVA_80Pro",
    "Model": "NOVA 80Pro"
  },
  {
    "Retail Branding": "Condor",
    "Marketing Name": "Smart TV",
    "Device": "alimos",
    "Model": "Condor Google TV"
  },
  {
    "Retail Branding": "Condor",
    "Marketing Name": "Smart TV",
    "Device": "bridgeport",
    "Model": "AI PONT PLUS FF"
  },
  {
    "Retail Branding": "Condor",
    "Marketing Name": "Smart TV",
    "Device": "dangni",
    "Model": "Condor Google TV"
  },
  {
    "Retail Branding": "Condor",
    "Marketing Name": "Smart TV",
    "Device": "osaka",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "Condor",
    "Marketing Name": "Smart TV",
    "Device": "redwood",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "Condor",
    "Marketing Name": "T705",
    "Device": "TGW710G",
    "Model": "TGW710G"
  },
  {
    "Retail Branding": "Condor",
    "Marketing Name": "TB105L",
    "Device": "TB105L",
    "Model": "TB105L"
  },
  {
    "Retail Branding": "Condor",
    "Marketing Name": "TB109L",
    "Device": "TB109L",
    "Model": "TB109L"
  },
  {
    "Retail Branding": "Condor",
    "Marketing Name": "TB113",
    "Device": "PAD_10",
    "Model": "PAD 10"
  },
  {
    "Retail Branding": "Condor",
    "Marketing Name": "TB716",
    "Device": "TB716",
    "Model": "TB716"
  },
  {
    "Retail Branding": "Condor",
    "Marketing Name": "TB717G",
    "Device": "TB717G",
    "Model": "TB717G"
  },
  {
    "Retail Branding": "Condor",
    "Marketing Name": "TB717G_8_1",
    "Device": "TB717G",
    "Model": "TB717G"
  },
  {
    "Retail Branding": "Condor",
    "Marketing Name": "TB717L",
    "Device": "TB717L",
    "Model": "TB717L"
  },
  {
    "Retail Branding": "Condor",
    "Marketing Name": "TB718",
    "Device": "TB718",
    "Model": "TB718"
  },
  {
    "Retail Branding": "Condor",
    "Marketing Name": "TB802L",
    "Device": "TB802L",
    "Model": "TB802L"
  },
  {
    "Retail Branding": "Condor",
    "Marketing Name": "TFX711G",
    "Device": "TFX711G",
    "Model": "TFX711G"
  },
  {
    "Retail Branding": "Condor",
    "Marketing Name": "TFX712G",
    "Device": "TFX712G",
    "Model": "TFX712G"
  },
  {
    "Retail Branding": "Condor",
    "Marketing Name": "TFX713L",
    "Device": "TFX713L",
    "Model": "TFX713L"
  },
  {
    "Retail Branding": "Condor",
    "Marketing Name": "TFX714L",
    "Device": "TFX714L",
    "Model": "TFX714L"
  },
  {
    "Retail Branding": "Condor",
    "Marketing Name": "TGW102L",
    "Device": "TGW102L",
    "Model": "TGW102L"
  },
  {
    "Retail Branding": "Condor",
    "Marketing Name": "TGW706",
    "Device": "TGW706",
    "Model": "TGW706"
  },
  {
    "Retail Branding": "Condor",
    "Marketing Name": "TGW801G",
    "Device": "TGW801G",
    "Model": "TGW801G"
  },
  {
    "Retail Branding": "Condor",
    "Marketing Name": "TGW801L",
    "Device": "TGW801L",
    "Model": "TGW801L"
  },
  {
    "Retail Branding": "Condor",
    "Marketing Name": "TMK715L",
    "Device": "TMK715L",
    "Model": "TMK715L"
  },
  {
    "Retail Branding": "Condor",
    "Marketing Name": "UTS800",
    "Device": "UTS800",
    "Model": "UTS800"
  },
  {
    "Retail Branding": "CongoTelecom",
    "Marketing Name": "Speed",
    "Device": "Speed",
    "Model": "Speed"
  },
  {
    "Retail Branding": "Connectce",
    "Marketing Name": "Connect Alpha",
    "Device": "CNT07002",
    "Model": "CNT07002"
  },
  {
    "Retail Branding": "Connectce",
    "Marketing Name": "Connect Core 6",
    "Device": "Connect_Core_6",
    "Model": "CP6001A"
  },
  {
    "Retail Branding": "Connectce",
    "Marketing Name": "Connected_Chef",
    "Device": "Connected_Chef",
    "Model": "Kitchen_Tablet"
  },
  {
    "Retail Branding": "Connex",
    "Marketing Name": "CTAB-1044",
    "Device": "CTAB-1044",
    "Model": "CTAB-1044"
  },
  {
    "Retail Branding": "Connex",
    "Marketing Name": "CTAB1044hn",
    "Device": "CTAB1044hn",
    "Model": "CTAB1044hn"
  },
  {
    "Retail Branding": "Connex",
    "Marketing Name": "SEN_1055_ARM",
    "Device": "SEN_1055_ARM",
    "Model": "SEN_1055_ARM"
  },
  {
    "Retail Branding": "Connex",
    "Marketing Name": "SEN_1055_ARM1064",
    "Device": "SEN_1055_ARM",
    "Model": "SEN_1055_ARM1064"
  },
  {
    "Retail Branding": "Connexion TV",
    "Marketing Name": "VIP6102W FCGOV",
    "Device": "vip6102w",
    "Model": "VIP6102W"
  },
  {
    "Retail Branding": "Conquest",
    "Marketing Name": "CONQUEST S12Pro",
    "Device": "S12Pro",
    "Model": "S12Pro"
  },
  {
    "Retail Branding": "Conquest",
    "Marketing Name": "CONQUEST-S23",
    "Device": "CONQUEST-S23",
    "Model": "CONQUEST-S23"
  },
  {
    "Retail Branding": "Conquest",
    "Marketing Name": "Conquest-F5",
    "Device": "F5",
    "Model": "F5"
  },
  {
    "Retail Branding": "Conquest",
    "Marketing Name": "S11",
    "Device": "conquest-S11",
    "Model": "S11"
  },
  {
    "Retail Branding": "Conquest",
    "Marketing Name": "S21",
    "Device": "S21",
    "Model": "CONQUEST S21"
  },
  {
    "Retail Branding": "Conquest",
    "Marketing Name": "S21_EEA",
    "Device": "S21",
    "Model": "CONQUEST S21"
  },
  {
    "Retail Branding": "Conquest",
    "Marketing Name": "S21_RU",
    "Device": "S21",
    "Model": "CONQUEST S21"
  },
  {
    "Retail Branding": "Conquest",
    "Marketing Name": "conquest-EX101",
    "Device": "conquest-EX101",
    "Model": "conquest-EX101"
  },
  {
    "Retail Branding": "Conquest",
    "Marketing Name": "conquest-F5",
    "Device": "F5",
    "Model": "F5"
  },
  {
    "Retail Branding": "Conquest",
    "Marketing Name": "conquest-S20",
    "Device": "conquest-S20",
    "Model": "conquest-S20"
  },
  {
    "Retail Branding": "Conquest",
    "Marketing Name": "conquest-S20_RU",
    "Device": "conquest-S20",
    "Model": "conquest-S20"
  },
  {
    "Retail Branding": "Conquest",
    "Marketing Name": "conquest_S16",
    "Device": "conquest_S16",
    "Model": "conquest_S16"
  },
  {
    "Retail Branding": "Conquest",
    "Marketing Name": "conquest_S16_RU",
    "Device": "conquest_S16",
    "Model": "conquest_S16"
  },
  {
    "Retail Branding": "Conquest",
    "Marketing Name": "conquest_S20_EEA",
    "Device": "conquest_S20",
    "Model": "conquest_S20"
  },
  {
    "Retail Branding": "ConsumerCellular",
    "Marketing Name": "IRIS Connect 2",
    "Device": "SN512CC",
    "Model": "SN512CC"
  },
  {
    "Retail Branding": "Contex",
    "Marketing Name": "Egypt",
    "Device": "tamachi",
    "Model": "AiPlus2K"
  },
  {
    "Retail Branding": "Contex",
    "Marketing Name": "Egypt",
    "Device": "yeongdeungpo",
    "Model": "AiPlus4K"
  },
  {
    "Retail Branding": "Conti",
    "Marketing Name": "CONTI",
    "Device": "elliniko",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "Conti",
    "Marketing Name": "CONTI",
    "Device": "stanford",
    "Model": "2K SMART TV"
  },
  {
    "Retail Branding": "Conti",
    "Marketing Name": "CONTI",
    "Device": "zhongshan",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "Continental Edison",
    "Marketing Name": "CDI SMART TV",
    "Device": "cottongreen",
    "Model": "CDI SMART TV"
  },
  {
    "Retail Branding": "Continental Edison",
    "Marketing Name": "CDI SMART TV",
    "Device": "marina",
    "Model": "CDI SMART TV"
  },
  {
    "Retail Branding": "Continental Edison",
    "Marketing Name": "CDI SMART TV",
    "Device": "nagata",
    "Model": "CDI SMART TV"
  },
  {
    "Retail Branding": "Continental Edison",
    "Marketing Name": "CE10402",
    "Device": "CE10402",
    "Model": "CE10402"
  },
  {
    "Retail Branding": "Continental Edison",
    "Marketing Name": "Continental Edison",
    "Device": "yeongdeungpo",
    "Model": "B UHD Android TV"
  },
  {
    "Retail Branding": "Continental Edison",
    "Marketing Name": "ContinentalEdison 2K Android",
    "Device": "lasalle",
    "Model": "ContinentalEdison 2K Android"
  },
  {
    "Retail Branding": "Continental Edison",
    "Marketing Name": "ContinentalEdison 2K Android",
    "Device": "lasalle",
    "Model": "ContinentalEdison 2K Android TV"
  },
  {
    "Retail Branding": "Continental Edison",
    "Marketing Name": "ContinentalEdison 4K Android",
    "Device": "kenton",
    "Model": "ContinentalEdison 4K Android"
  },
  {
    "Retail Branding": "Continental Edison",
    "Marketing Name": "ContinentalEdison 4K Android",
    "Device": "kenton",
    "Model": "ContinentalEdison 4K Android TV"
  },
  {
    "Retail Branding": "Continental Edison",
    "Marketing Name": "ContinentalEdison 4K Android TV",
    "Device": "kenton",
    "Model": "ContinentalEdison 4K Android TV"
  },
  {
    "Retail Branding": "Continental Edison",
    "Marketing Name": "Continential_Edison",
    "Device": "bangbae",
    "Model": "Continental 4K Android TV"
  },
  {
    "Retail Branding": "Continental Edison",
    "Marketing Name": "EU、UK、AP",
    "Device": "martin",
    "Model": "Continental Edison Android TV"
  },
  {
    "Retail Branding": "Continental Edison",
    "Marketing Name": "France",
    "Device": "guandu",
    "Model": "Continental Edison Android TV"
  },
  {
    "Retail Branding": "Continental Edison",
    "Marketing Name": "France",
    "Device": "tamachi",
    "Model": "Continental Android TV"
  },
  {
    "Retail Branding": "Continential",
    "Marketing Name": "CE10412",
    "Device": "CE10412",
    "Model": "CE10412"
  },
  {
    "Retail Branding": "Continential",
    "Marketing Name": "Edison-Continential",
    "Device": "komagome",
    "Model": "Continental 2K Android TV"
  },
  {
    "Retail Branding": "Contixo",
    "Marketing Name": "A1-64G",
    "Device": "A1-64G",
    "Model": "A1-64G"
  },
  {
    "Retail Branding": "Contixo",
    "Marketing Name": "A10",
    "Device": "A10",
    "Model": "A10"
  },
  {
    "Retail Branding": "Contixo",
    "Marketing Name": "A7",
    "Device": "A7",
    "Model": "A7"
  },
  {
    "Retail Branding": "Contixo",
    "Marketing Name": "A7_1",
    "Device": "A7_1",
    "Model": "A7"
  },
  {
    "Retail Branding": "Contixo",
    "Marketing Name": "CONTIXO_V8",
    "Device": "CONTIXO-V8",
    "Model": "V8"
  },
  {
    "Retail Branding": "Contixo",
    "Marketing Name": "K101",
    "Device": "K101",
    "Model": "K101"
  },
  {
    "Retail Branding": "Contixo",
    "Marketing Name": "K101A",
    "Device": "K101A",
    "Model": "K101A"
  },
  {
    "Retail Branding": "Contixo",
    "Marketing Name": "K102",
    "Device": "K102",
    "Model": "K102"
  },
  {
    "Retail Branding": "Contixo",
    "Marketing Name": "K102E",
    "Device": "K102E",
    "Model": "K102"
  },
  {
    "Retail Branding": "Contixo",
    "Marketing Name": "K102_A",
    "Device": "K102_A",
    "Model": "K102_A"
  },
  {
    "Retail Branding": "Contixo",
    "Marketing Name": "K103",
    "Device": "K103",
    "Model": "K103"
  },
  {
    "Retail Branding": "Contixo",
    "Marketing Name": "K103A",
    "Device": "K103A",
    "Model": "K103A"
  },
  {
    "Retail Branding": "Contixo",
    "Marketing Name": "K4",
    "Device": "K4",
    "Model": "K4"
  },
  {
    "Retail Branding": "Contixo",
    "Marketing Name": "K80",
    "Device": "K80",
    "Model": "K80"
  },
  {
    "Retail Branding": "Contixo",
    "Marketing Name": "K81",
    "Device": "K81",
    "Model": "K81"
  },
  {
    "Retail Branding": "Contixo",
    "Marketing Name": "LA703R",
    "Device": "LA703R",
    "Model": "LA703R"
  },
  {
    "Retail Branding": "Contixo",
    "Marketing Name": "V10",
    "Device": "V10",
    "Model": "V10"
  },
  {
    "Retail Branding": "Contixo",
    "Marketing Name": "V10A",
    "Device": "V10A",
    "Model": "V10A"
  },
  {
    "Retail Branding": "Contixo",
    "Marketing Name": "V10E",
    "Device": "V10E",
    "Model": "V10E"
  },
  {
    "Retail Branding": "Contixo",
    "Marketing Name": "V10M",
    "Device": "V10M",
    "Model": "V10M"
  },
  {
    "Retail Branding": "Contixo",
    "Marketing Name": "V10S",
    "Device": "V10S",
    "Model": "IT_701A"
  },
  {
    "Retail Branding": "Contixo",
    "Marketing Name": "V10S",
    "Device": "V10S",
    "Model": "V10S"
  },
  {
    "Retail Branding": "Contixo",
    "Marketing Name": "V10X",
    "Device": "V10X",
    "Model": "V10X"
  },
  {
    "Retail Branding": "Contixo",
    "Marketing Name": "V11",
    "Device": "V11",
    "Model": "V11"
  },
  {
    "Retail Branding": "Contixo",
    "Marketing Name": "V8",
    "Device": "V8_A",
    "Model": "V8"
  },
  {
    "Retail Branding": "Contixo",
    "Marketing Name": "V80",
    "Device": "V80",
    "Model": "V80"
  },
  {
    "Retail Branding": "Contixo",
    "Marketing Name": "V8E",
    "Device": "V8",
    "Model": "V8"
  },
  {
    "Retail Branding": "Contixo",
    "Marketing Name": "V8S",
    "Device": "V8S",
    "Model": "V8S"
  },
  {
    "Retail Branding": "Contixo",
    "Marketing Name": "V8X",
    "Device": "V8X",
    "Model": "V8X"
  },
  {
    "Retail Branding": "Contixo",
    "Marketing Name": "V9",
    "Device": "CONTIXO-V9",
    "Model": "V9"
  },
  {
    "Retail Branding": "Contixo",
    "Marketing Name": "V90",
    "Device": "V90",
    "Model": "V90"
  },
  {
    "Retail Branding": "Contixo",
    "Marketing Name": "V9A",
    "Device": "V9A",
    "Model": "V9A"
  },
  {
    "Retail Branding": "Contixo",
    "Marketing Name": "V9S",
    "Device": "V9S",
    "Model": "V9S"
  },
  {
    "Retail Branding": "Contixo",
    "Marketing Name": "V9X",
    "Device": "V9X",
    "Model": "V9X"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "",
    "Device": "7019_msm7627a",
    "Model": "Coolpad 7019"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "",
    "Device": "7560U",
    "Model": "Nivo"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "",
    "Device": "801E",
    "Model": "801E"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "",
    "Device": 8710,
    "Model": 8710
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "",
    "Device": 9960,
    "Model": "YL-Coolpad 9960"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "",
    "Device": "CP5832",
    "Model": 5832
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "",
    "Device": "CP5880",
    "Model": 5880
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "",
    "Device": "CP7728",
    "Model": "Coolpad7728"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "",
    "Device": "CP8870",
    "Model": 8870
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "",
    "Device": "CP9130",
    "Model": "N930"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "",
    "Device": "Coolpad7290",
    "Model": "Coolpad 7290"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "",
    "Device": "Coolpad9080W",
    "Model": "Coolpad 9080W"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "",
    "Device": "dkb",
    "Model": 8150
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "",
    "Device": "dkb",
    "Model": 8180
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "",
    "Device": "dkb",
    "Model": 8810
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "",
    "Device": "msm7627_5820",
    "Model": "Coolpad 5820"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "",
    "Device": "msm7627_SP150",
    "Model": "MTS-SP150"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "",
    "Device": "msm7627_surf",
    "Model": 5860
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "",
    "Device": "msm7627_surf",
    "Model": 7260
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "",
    "Device": "msm7627_w706",
    "Model": "Coolpad W706+"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "",
    "Device": "msm7627_w706T",
    "Model": "Coolpad W706+"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "",
    "Device": "msm7627_w708",
    "Model": "Coolpad W708"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "",
    "Device": "msm7627a_5860S",
    "Model": "5860S"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "",
    "Device": "msm7627a_5870",
    "Model": 5870
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "",
    "Device": "msm7627a_7230",
    "Model": 7230
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "",
    "Device": "msm7627a_7266",
    "Model": 7266
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "",
    "Device": "msm7627a_9120",
    "Model": 9120
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "",
    "Device": "msm7627a_PAP4000",
    "Model": "PAP4000"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "",
    "Device": "msm7627a_cp5910",
    "Model": 5910
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "",
    "Device": "msm7627a_ea58",
    "Model": "Coolpad 5010"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "",
    "Device": "msm7627a_ea92",
    "Model": "Coolpad 5210"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "",
    "Device": "msm7627a_sku3",
    "Model": 5110
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "",
    "Device": "msm7627a_sku3",
    "Model": "5860A"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "",
    "Device": "msm7627a_sku3",
    "Model": "7260A"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "",
    "Device": "msm8660_9900",
    "Model": 9900
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "",
    "Device": "msm8660_CP8950",
    "Model": 8950
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": 1803,
    "Device": "Coolpad_1803",
    "Model": 1803
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "1825-I01",
    "Device": "1825-I01",
    "Model": "1825-I01"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": 1826,
    "Device": "Cool_3_Pro",
    "Model": 1826
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "1826-I01",
    "Device": "1826-I01",
    "Model": "1826-I01"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": 1827,
    "Device": 1827,
    "Model": 1827
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": 1903,
    "Device": 1903,
    "Model": 1903
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": 1904,
    "Device": 1904,
    "Model": 1904
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": 1921,
    "Device": 1921,
    "Model": 1921
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": 1932,
    "Device": 1932,
    "Model": 1932
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": 1939,
    "Device": "coolpad_Cool_X",
    "Model": 1939
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "3300A",
    "Device": "3300A",
    "Model": "Coolpad 3300A"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "3320A",
    "Device": "cp3320a",
    "Model": "Coolpad 3320A"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "3503I",
    "Device": "CP3503I",
    "Model": "Coolpad 3503I"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "3503I",
    "Device": "CP3503I",
    "Model": "Coolpad CP3503I"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "3505I_A00",
    "Device": "CP3505I",
    "Model": "Coolpad E503"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "3505I_U00",
    "Device": "CP3505I_U00",
    "Model": "Coolpad E503"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "3600i",
    "Device": "CP3600I",
    "Model": "3600I"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "3600i",
    "Device": "CP3600I",
    "Model": "Coolpad 3600I"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "3622A",
    "Device": "cp3622a",
    "Model": "Coolpad 3622A"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "3622A-mpcs",
    "Device": "cp3622a",
    "Model": "Coolpad 3622A"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "3623A",
    "Device": "cp3623a",
    "Model": "Coolpad 3623A"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": 3631,
    "Device": "CP12t",
    "Model": "CP12t"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "3632A",
    "Device": "cp3632a",
    "Model": "Coolpad 3632A"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "3632A-mpcs",
    "Device": "cp3632a",
    "Model": "Coolpad 3632A"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "3636a",
    "Device": "cp3636a",
    "Model": "cp3636a"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "3700A",
    "Device": "3700A",
    "Model": "CP3700A"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "3705A",
    "Device": "lithium",
    "Model": "cp3705A"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": 5109,
    "Device": "Coolpad5109",
    "Model": "Coolpad 5109"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": 5200,
    "Device": "Coolpad5200",
    "Model": "Coolpad 5200"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "5216D",
    "Device": "5216D",
    "Model": "Coolpad 5216D"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": 5217,
    "Device": "msm8610",
    "Model": "Coolpad 5217"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "5218S",
    "Device": "msm8x25q_a5y_5218s",
    "Model": "Coolpad 5218S"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": 5219,
    "Device": 5219,
    "Model": "Coolpad 5219"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "5219_C00",
    "Device": "5219_C00",
    "Model": "Coolpad 5219_C00"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": 5267,
    "Device": "Coolpad5267",
    "Model": "Coolpad 5267"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "5267C",
    "Device": "Coolpad5267",
    "Model": "Coolpad 5267"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": 5270,
    "Device": "Coolpad5270",
    "Model": "Coolpad 5270"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": 5367,
    "Device": "Coolpad5367",
    "Model": "Coolpad 5367"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "5367C",
    "Device": "Coolpad5367C",
    "Model": "Coolpad 5367C"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": 5370,
    "Device": "Coolpad5370",
    "Model": "Coolpad 5370"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "5380CA",
    "Device": "Coolpad5380CA",
    "Model": "Coolpad 5380CA"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "5860E",
    "Device": "CP5860E",
    "Model": "5860E"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": 5891,
    "Device": "Coolpad5891",
    "Model": "Coolpad 5891"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "5891S",
    "Device": "Coolpad5891S",
    "Model": "Coolpad 5891S"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": 5951,
    "Device": "Coolpad5951",
    "Model": "Coolpad 5951"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": 7061,
    "Device": "CP7061",
    "Model": "Coolpad 7061"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "7230S",
    "Device": "Coolpad7230S",
    "Model": "Coolpad 7230S"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": 7232,
    "Device": "CP7232",
    "Model": "Coolpad 7232"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": 7251,
    "Device": "Coolpad7251",
    "Model": "Coolpad 7251"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": 7270,
    "Device": "Coolpad7270",
    "Model": "Coolpad 7270"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "7270I",
    "Device": "7270I",
    "Model": "Idea ULTRA Pro"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": 7275,
    "Device": "CP7275",
    "Model": "Coolpad 7275"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "7295A",
    "Device": "Coolpad7295A",
    "Model": "Coolpad 7295+"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "7295A",
    "Device": "Coolpad7295A",
    "Model": "Coolpad 7295A"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": 7296,
    "Device": "Coolpad7296",
    "Model": "Coolpad 7296"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "7620L",
    "Device": "Coolpad7620L",
    "Model": "Coolpad 7620L"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "801EM",
    "Device": "801EM",
    "Model": "801EM"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": 8079,
    "Device": "Coolpad8079",
    "Model": "Coolpad 8079"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": 8122,
    "Device": "Coolpad8122",
    "Model": "Coolpad 8122"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "8198W",
    "Device": "Coolpad8198W",
    "Model": "Coolpad 8198W"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "8297D",
    "Device": "Coolpad8297D",
    "Model": "Coolpad 8297D"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "8297L-I00",
    "Device": "Coolpad8297L-I00",
    "Model": "Coolpad 8297L-I00"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "8298-M02",
    "Device": "CP8298_M02",
    "Model": "CP8298_M02"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "8676-I03",
    "Device": "CP8676_I03",
    "Model": "CP8676_I03"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": 8712,
    "Device": "CP8712",
    "Model": "Coolpad 8712"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "8712SV",
    "Device": "Coolpad8712",
    "Model": "Coolpad 8712"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": 8718,
    "Device": "Coolpad8718",
    "Model": "Coolpad 8718"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": 8722,
    "Device": "CP8722",
    "Model": "Coolpad 8722"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "8722-U00",
    "Device": "CP8722_U00",
    "Model": "Coolpad E570"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "8722V",
    "Device": "CP8722",
    "Model": "Coolpad 8722V"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "8722_S00",
    "Device": "CP8722_S00",
    "Model": "Coolpad E570"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": 8729,
    "Device": "Coolpad8729",
    "Model": "Coolpad 8729"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "8730L",
    "Device": "Coolpad8730L",
    "Model": "Coolpad 8730L"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": 8736,
    "Device": 8736,
    "Model": "Coolpad 8736"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "8737A",
    "Device": "Coolpad8737A",
    "Model": "Coolpad 8737A"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "8970L",
    "Device": "8970L",
    "Model": "Coolpad 8970L"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": 8971,
    "Device": 8971,
    "Model": "Coolpad 8971"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "9150W",
    "Device": "Coolpad9150W",
    "Model": "Coolpad 9150W"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "9190_T00",
    "Device": "Coolpad9190_T00",
    "Model": "Coolpad 9190_T00"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "9970L",
    "Device": "9970L",
    "Model": "Coolpad 9970L"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "9976A",
    "Device": "Coolpad9976A",
    "Model": "Coolpad 9976A"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "A20",
    "Device": "A20",
    "Model": "A20"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "A8",
    "Device": "A8",
    "Model": "Coolpad A8"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "A8-831",
    "Device": "A8-831",
    "Model": "Coolpad A8-831"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "A8-930",
    "Device": "A8-930",
    "Model": "Coolpad A8-930"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "A8-931",
    "Device": "A8-931",
    "Model": "Coolpad A8-931"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "A8-931",
    "Device": "A8-931",
    "Model": "Coolpad A8-931N"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "A8-932",
    "Device": "A8-932",
    "Model": "Coolpad A8-932"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "B770",
    "Device": "B770",
    "Model": "Coolpad B770"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "B770S",
    "Device": "CoolpadB770S",
    "Model": "Coolpad B770S"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "Bs501",
    "Device": "cp8870u",
    "Model": "Bs 501"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "C1-S02",
    "Device": "C1-S02",
    "Model": "Coolpad R116"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "C103",
    "Device": "C103",
    "Model": "C103"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "C106-8",
    "Device": "cool_c1",
    "Model": "C106-8"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "C35",
    "Device": "K17",
    "Model": "K17"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "C35 Plus",
    "Device": "K21",
    "Model": "K21"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "CK2-01",
    "Device": "CK2-01",
    "Model": "CK2-01"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "CK3-01",
    "Device": "CK3-01",
    "Model": "CK3-01"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "CK3-01",
    "Device": "CK3-01",
    "Model": "CK3-M1"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "CM001",
    "Device": "CoolpadCM001",
    "Model": "Coolpad CM001"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "COOL 20S 5G",
    "Device": "CP07",
    "Model": "CP07"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "COOL 40i",
    "Device": "K04L",
    "Model": "CP12Q"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "COOLPAD_C202",
    "Device": "COOLPAD_C202",
    "Model": "COOLPAD C202"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "COOLPAD_C203",
    "Device": "COOLPAD_C203",
    "Model": "COOLPAD C203"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "CP12",
    "Device": "CP12",
    "Model": "CP12"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "CP12 Neo",
    "Device": "K18",
    "Model": "K18"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "CP12 Neo",
    "Device": "K18D",
    "Model": "K18"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "CP12P",
    "Device": "CP12p",
    "Model": "CP12p"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "CP12p_S0",
    "Device": "CP12p",
    "Model": "CP12p"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "CP12s",
    "Device": "CP12s",
    "Model": "CP12s"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "CP15",
    "Device": "CP32",
    "Model": "CP32"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "CP32",
    "Device": "CP32",
    "Model": "CP32"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "CP32t",
    "Device": "CP32t",
    "Model": "CP32t"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "CP3503L",
    "Device": "CP3503L",
    "Model": "CP3503L"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "CP3504L",
    "Device": "CP3504L",
    "Model": "CP3504L"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "CP5108",
    "Device": "msm7627a_a8_5108_new",
    "Model": "Coolpad 5108"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "CP5210A",
    "Device": "msm7627a_d7_5210a",
    "Model": "Coolpad 5210A"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "CP5310",
    "Device": "cp5310",
    "Model": "Coolpad 5310"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "CP5660S",
    "Device": "5560S",
    "Model": "5560S"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "CP5952",
    "Device": "Coolpad5952",
    "Model": "Coolpad 5952"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "CP8021",
    "Device": "Coolpad8021",
    "Model": "Coolpad 8021"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "CP8089",
    "Device": "CP8089",
    "Model": "Coolpad 8089"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "CP8089Q",
    "Device": "CP8089Q",
    "Model": "Coolpad 8089Q"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "CP8295M",
    "Device": "8295M",
    "Model": "Coolpad8295M"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "CP8735",
    "Device": 8735,
    "Model": "Coolpad 8735"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "CP8750",
    "Device": 8750,
    "Model": "Coolpad8750"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "CP9190L",
    "Device": "Coolpad9190L",
    "Model": "Coolpad 9190L"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "CP9250L",
    "Device": "Coolpad9250L",
    "Model": "Coolpad 9250L"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "CP9970",
    "Device": 9970,
    "Model": "Coolpad 9970"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "CPA520",
    "Device": "CoolpadA520",
    "Model": "Coolpad A520"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "CPT1",
    "Device": "CoolpadT1",
    "Model": "Coolpad T1"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "Cool 10",
    "Device": 2040,
    "Model": 2040
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "Cool 10A",
    "Device": "Coolpad_2041",
    "Model": "Coolpad_2041"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "Cool 10A",
    "Device": "Coolpad_2041_S0",
    "Model": "Coolpad_2041_S0"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "Cool 10A",
    "Device": "Coolpad_2041_T3",
    "Model": "Coolpad_2041_T3"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "Cool 10A",
    "Device": "Coolpad_2041_U0",
    "Model": "Coolpad_2041_U0"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "Cool 12A",
    "Device": 2042,
    "Model": "coolpad Cool 12A"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "Cool 12A",
    "Device": "Coolpad_2042_U0",
    "Model": 2042
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "Cool 20",
    "Device": "k69v1_64",
    "Model": "CP03"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "Cool 20 pro",
    "Device": "CP05",
    "Model": "CP05"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "Cool 20s 5G",
    "Device": "CP07",
    "Model": "CP07"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "Cool 40",
    "Device": "K16",
    "Model": "K16"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "Cool C1",
    "Device": "cool_c1",
    "Model": "C106"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "Cool C1",
    "Device": "cool_c1",
    "Model": "C106-6"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "Cool C1",
    "Device": "cool_c1",
    "Model": "C106-7"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "Cool C1",
    "Device": "cool_c1",
    "Model": "C106-9"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "Cool C1",
    "Device": "cool_c1",
    "Model": "C107-9"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "Cool S",
    "Device": 2039,
    "Model": 2039
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "Cool6",
    "Device": 1901,
    "Model": 1901
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "Coolmini",
    "Device": "Coolmini",
    "Model": "Coolmini"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "Coolpad 1821",
    "Device": 1821,
    "Model": 1821
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "Coolpad 3310A",
    "Device": "ventura",
    "Model": "Coolpad 3310A"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "Coolpad 3636a_m",
    "Device": "cp3636a",
    "Model": "cp3636a"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "Coolpad 3706AS",
    "Device": "apollo",
    "Model": "CP3706AS"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "Coolpad 5370_I00",
    "Device": "CoolpadE2",
    "Model": "coolpad E2"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "Coolpad C1-U02",
    "Device": "C103",
    "Model": "C1-U02"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "Coolpad C16",
    "Device": "K11",
    "Model": "K11"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "Coolpad COL-A0",
    "Device": "Civic",
    "Model": "COL-A0"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "Coolpad COR-I0",
    "Device": "clover",
    "Model": "Coolpad COR-I0"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "Coolpad CVC-A0",
    "Device": "Civic",
    "Model": "CVC-A0"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "Coolpad CVC-M0",
    "Device": "Civic",
    "Model": "CVC-M0"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "Coolpad GRA-M0",
    "Device": "GRA",
    "Model": "GRA-M0"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "Coolpad POL-A0",
    "Device": "pollux",
    "Model": "POL-A0"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "Coolpad Suva",
    "Device": "CP3669AS",
    "Model": "CP3669AS"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "Coolpad Tasker",
    "Device": "CP3667AT",
    "Model": "CP3667AT"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "Coolpad VCR-I0",
    "Device": "victor",
    "Model": "VCR-I0"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "Coolpad5218D",
    "Device": "msm7627a_a5y_5218d",
    "Model": "Coolpad_5218D"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "Coolpad5315",
    "Device": "msm8610_s10_cp5315",
    "Model": "Coolpad 5315"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "Coolpad5872",
    "Device": "Coolpad5872",
    "Model": "Coolpad 5872"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "Coolpad5879T",
    "Device": "Coolpad5879T",
    "Model": "Coolpad 5879T"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "Coolpad5891Q",
    "Device": "Coolpad5891Q",
    "Model": "Coolpad 5891Q"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "Coolpad5892",
    "Device": "Coolpad5892",
    "Model": "Coolpad 5892"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "Coolpad5950",
    "Device": "Coolpad5950",
    "Model": "Coolpad 5950"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "Coolpad5950T",
    "Device": "Coolpad5950T",
    "Model": "Coolpad 5950T"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "Coolpad7270_W00",
    "Device": "Coolpad7270_W00",
    "Model": "Coolpad 7270_W00"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "Coolpad7295C",
    "Device": "Coolpad7295C",
    "Model": "Coolpad 7295C"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "Coolpad7295C_C00",
    "Device": "Coolpad7295C_C00",
    "Model": "Coolpad 7295C_C00"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "Coolpad7295I",
    "Device": "Coolpad7295I",
    "Model": "Spice Mi-515"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "Coolpad7295T",
    "Device": "Coolpad7295T",
    "Model": "Coolpad 7295T"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "Coolpad7296S",
    "Device": "Coolpad7296S",
    "Model": "Coolpad 7296S"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "Coolpad7298A",
    "Device": "Coolpad7298A",
    "Model": "Coolpad 7298A"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "Coolpad7298D",
    "Device": "Coolpad7298D",
    "Model": "Coolpad 7298D"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "Coolpad7320",
    "Device": "Coolpad7320",
    "Model": "Coolpad 7320"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "Coolpad7920",
    "Device": 7920,
    "Model": "Coolpad7920"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "Coolpad801ES",
    "Device": "801ES",
    "Model": "801ES"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "Coolpad8085Q",
    "Device": "Coolpad8085Q",
    "Model": "Coolpad8085Q"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "Coolpad8198T",
    "Device": "8198T",
    "Model": "Coolpad8198T"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "Coolpad8297W",
    "Device": "Coolpad8297W",
    "Model": "Coolpad 8297W"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "Coolpad8705",
    "Device": "Coolpad8705",
    "Model": "Coolpad 8705"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "Coolpad8720L",
    "Device": "Coolpad8720L",
    "Model": "Coolpad 8720L"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "Coolpad8908",
    "Device": 8908,
    "Model": "Coolpad8908"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "E561",
    "Device": "E561",
    "Model": "Coolpad E561"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "Flo",
    "Device": "7560T",
    "Model": "Coolpad Flo"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "Forward_EVOLVE",
    "Device": "Forward_EVOLVE",
    "Model": "Forward_EVOLVE"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "Idea ULTRA",
    "Device": "Coolpad7295S",
    "Model": "Idea ULTRA"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "K2L_S00",
    "Device": "K2L_S00",
    "Model": "Coolpad E580"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "Karbonn Titanium S5 Plus",
    "Device": "Karbonn",
    "Model": "Karbonn Titanium S5 Plus"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "MEDION P5001",
    "Device": "MEDION",
    "Model": "MEDION P5001"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "MEDION P5001",
    "Device": "P5001",
    "Model": "MEDION P5001"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "MOBODO MOBO K1",
    "Device": "MOBOK1",
    "Model": "MOBOK1"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "Mtag 353",
    "Device": "msm7627a_ea92_mts",
    "Model": "Mtag 353"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "R106",
    "Device": "cpy90_g00",
    "Model": "Coolpad R106"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "R108",
    "Device": "R108",
    "Model": "Coolpad R108"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "SK3-U00",
    "Device": "E561_EU",
    "Model": "Coolpad E561_EU"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "SS1-03",
    "Device": "SS1-03",
    "Model": "ivvi SS1-03"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "SS2-01",
    "Device": "SS2-01",
    "Model": "SS2-01"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "SS2-01",
    "Device": "SS2-01",
    "Model": "ivvi SS2-01"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "STARADDICT III",
    "Device": "cp8861u",
    "Model": "STARADDICT III"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "Spice Mi-496",
    "Device": "Coolpad7268I",
    "Model": "Spice Mi-496"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "VCR-A0",
    "Device": "victor",
    "Model": "VCR-A0"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "Vodafone Smart 4G",
    "Device": "cp8860u",
    "Model": "Vodafone Smart 4G"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "VodafoneSmart4",
    "Device": "VodafoneSmart4",
    "Model": "Vodafone Smart 4"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "VodafoneSmart4turbo",
    "Device": "VodafoneSmart4turbo",
    "Model": "Vodafone Smart 4 turbo"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "X20",
    "Device": "X20",
    "Model": "X20"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "Y72-921",
    "Device": "Y72-921",
    "Model": "Coolpad Y72-921"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "Y72-921",
    "Device": "Y72_921",
    "Model": "Coolpad E571"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "Y803-8",
    "Device": "CPY803_8",
    "Model": "Coolpad Y803-8"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "Y803-9",
    "Device": "CPY803_9",
    "Model": "Coolpad Y803-9"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "Y83-900",
    "Device": "Y83-900",
    "Model": "Coolpad Y83-900"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "Y83-I00",
    "Device": "CPY83_I00",
    "Model": "Coolpad Y83-I00"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "Y83_S00",
    "Device": "CPY83_S00",
    "Model": "Coolpad E502"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "Y83_U00",
    "Device": "CPY83_U00",
    "Model": "Coolpad E502"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "Y90",
    "Device": "Y90",
    "Model": "Coolpad Y90"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "Y91-921",
    "Device": "Y91",
    "Model": "Coolpad Y891"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "Y91-921",
    "Device": "Y91",
    "Model": "Coolpad Y91-921"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "Y92-9",
    "Device": "Y92-9",
    "Model": "Coolpad Y92-9"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "Z1",
    "Device": "Z1",
    "Model": "Z1"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "coolpad 5651",
    "Device": "CP12p",
    "Model": "CP12p"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "coolpad C15",
    "Device": "CP32",
    "Model": "CP32"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "coolpad C16 s",
    "Device": "K12",
    "Model": "K12"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "coolpad C16 s",
    "Device": "K12B",
    "Model": "K12"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "coolpad COOL 20",
    "Device": "k69v1_64",
    "Model": "CP03"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "coolpad COOL 30 Play",
    "Device": "CP36t",
    "Model": "CP36t"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "coolpad COOL 30i",
    "Device": "CP12Q",
    "Model": "CP12Q"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "coolpad CP12",
    "Device": "CP12",
    "Model": "CP12"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "coolpad CP12s",
    "Device": "CP12s",
    "Model": "CP12s"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "coolpad N7 Air",
    "Device": 2021,
    "Model": 2021
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "coolpad N7 Plus",
    "Device": "coolpad_N7_Plus",
    "Model": 2032
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "cp3648A",
    "Device": "cp3648a",
    "Model": "cp3648A"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "cp3648AT",
    "Device": "cp3648at",
    "Model": "cp3648AT"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "cp7236",
    "Device": "msm8610_w7_cp7236",
    "Model": "Coolpad 7236"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "i1",
    "Device": "i1",
    "Model": "ivvi i1"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "i1-01",
    "Device": "i1-01",
    "Model": "ivvi i1-01"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "i3-M1",
    "Device": "i3-M1",
    "Model": "ivvi i3-M1"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "ivvi SK5",
    "Device": "SK5",
    "Model": "ivvi SK5"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "ivvi SK5_S",
    "Device": "SK5_S",
    "Model": "ivvi SK5_S"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "ivvi V1M-S",
    "Device": "V1M-S",
    "Model": "ivvi V1M-S"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "ivvi i1-S",
    "Device": "V4701_FR1",
    "Model": "ivvi i1-S"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "ivvi i3-01",
    "Device": "i3-01",
    "Model": "ivvi i3-01"
  },
  {
    "Retail Branding": "Coolpad",
    "Marketing Name": "ivvi i3P-02",
    "Device": "i3P-02",
    "Model": "ivvi i3P-02"
  },
  {
    "Retail Branding": "Coppel",
    "Marketing Name": "ROCKET",
    "Device": "ROCKET",
    "Model": "ROCKET"
  },
  {
    "Retail Branding": "Coppernic",
    "Marketing Name": "C-One",
    "Device": "C-One_v2",
    "Model": "C-One"
  },
  {
    "Retail Branding": "Coppernic",
    "Marketing Name": "C-One",
    "Device": "C-One_v2_NFC",
    "Model": "C-One"
  },
  {
    "Retail Branding": "Coppernic",
    "Marketing Name": "C-eight",
    "Device": "C-eight",
    "Model": "C-eight"
  },
  {
    "Retail Branding": "Coppernic",
    "Marketing Name": "C-five",
    "Device": "C-five",
    "Model": "C-five"
  },
  {
    "Retail Branding": "Coppernic",
    "Marketing Name": "C-five",
    "Device": "C-five-WIFI",
    "Model": "C-five"
  },
  {
    "Retail Branding": "Coppernic",
    "Marketing Name": "C-one",
    "Device": "C-One_v2_e-ID",
    "Model": "C-One"
  },
  {
    "Retail Branding": "Coppernic",
    "Marketing Name": "TN502A1",
    "Device": "access",
    "Model": "access"
  },
  {
    "Retail Branding": "CoralPhone",
    "Marketing Name": "CoralPhone",
    "Device": "CoralNeural3",
    "Model": "Coral Neural 3"
  },
  {
    "Retail Branding": "Core Innovations",
    "Marketing Name": "CRTB7001",
    "Device": "CRTB7001",
    "Model": "CRTB7001"
  },
  {
    "Retail Branding": "Core Innovations",
    "Marketing Name": "CTB1016G",
    "Device": "CTB1016G",
    "Model": "CTB1016G"
  },
  {
    "Retail Branding": "CosMedia",
    "Marketing Name": "Meta-C1",
    "Device": "YYT",
    "Model": "4K Google TV Stick"
  },
  {
    "Retail Branding": "Covia",
    "Marketing Name": "CP-G3",
    "Device": "CP-G3",
    "Model": "CP-G3"
  },
  {
    "Retail Branding": "Covia",
    "Marketing Name": "CP-J55a",
    "Device": "x5090_rh_j9_covia",
    "Model": "CP-J55a"
  },
  {
    "Retail Branding": "Covia",
    "Marketing Name": "CP-J55aW",
    "Device": "CP_J55aW",
    "Model": "CP-J55aW"
  },
  {
    "Retail Branding": "Covia",
    "Marketing Name": "CP-K19",
    "Device": "CP-K19",
    "Model": "CP-K19"
  },
  {
    "Retail Branding": "Covia",
    "Marketing Name": "CP-L45s",
    "Device": "CP-L45s",
    "Model": "CP-L45s"
  },
  {
    "Retail Branding": "Covia",
    "Marketing Name": "CP-W5s",
    "Device": "CP-W5s",
    "Model": "CP-W5s"
  },
  {
    "Retail Branding": "Covia",
    "Marketing Name": "g06+",
    "Device": "g06",
    "Model": "g06"
  },
  {
    "Retail Branding": "Cozyla",
    "Marketing Name": "Calendar+",
    "Device": "Calendar",
    "Model": "CD-8V543F0"
  },
  {
    "Retail Branding": "Cozyla",
    "Marketing Name": "Calendar+",
    "Device": "Calendar",
    "Model": "CD-8V543F2"
  },
  {
    "Retail Branding": "Cozyla",
    "Marketing Name": "Calendar+",
    "Device": "Calendar",
    "Model": "Calendar+"
  },
  {
    "Retail Branding": "Cozyla",
    "Marketing Name": "Calendar2",
    "Device": "Calendar2",
    "Model": "Calendar2"
  },
  {
    "Retail Branding": "Cozyla",
    "Marketing Name": "Calendar2_16",
    "Device": "Calendar2_16",
    "Model": "Calendar2_16"
  },
  {
    "Retail Branding": "Cozyla",
    "Marketing Name": "Calendar2_24",
    "Device": "Calendar2_24",
    "Model": "Calendar2_24"
  },
  {
    "Retail Branding": "Cozyla",
    "Marketing Name": "Calendar2_32",
    "Device": "Calendar2_32",
    "Model": "Calendar2_32"
  },
  {
    "Retail Branding": "Cozyla",
    "Marketing Name": "Calendar_Go",
    "Device": "Calendar_Go",
    "Model": "Calendar_Go"
  },
  {
    "Retail Branding": "Crafty",
    "Marketing Name": "Crafty-IFPD",
    "Device": "rk3588_t",
    "Model": "ELP-4391K"
  },
  {
    "Retail Branding": "Crafty",
    "Marketing Name": "Crafty-IFPD",
    "Device": "rk3588_t",
    "Model": "ELT-6502K"
  },
  {
    "Retail Branding": "Creato",
    "Marketing Name": "DVT101B",
    "Device": "mdt1005_mk_32",
    "Model": "DVT101B"
  },
  {
    "Retail Branding": "CredenceID",
    "Marketing Name": "CredenceECO",
    "Device": "CredenceECO",
    "Model": "CE1-CID-16-4G-011"
  },
  {
    "Retail Branding": "Crelander",
    "Marketing Name": "A101",
    "Device": "A101",
    "Model": "A101"
  },
  {
    "Retail Branding": "Crelander",
    "Marketing Name": "A102",
    "Device": "A102",
    "Model": "A102"
  },
  {
    "Retail Branding": "Crelander",
    "Marketing Name": "E101",
    "Device": "E101",
    "Model": "E101"
  },
  {
    "Retail Branding": "Crelander",
    "Marketing Name": "E102",
    "Device": "E102",
    "Model": "E102"
  },
  {
    "Retail Branding": "Crelander",
    "Marketing Name": "E105",
    "Device": "E105",
    "Model": "E105"
  },
  {
    "Retail Branding": "Crelander",
    "Marketing Name": "T118",
    "Device": "T118",
    "Model": "T118"
  },
  {
    "Retail Branding": "Crelander",
    "Marketing Name": "T66",
    "Device": "T66",
    "Model": "T66"
  },
  {
    "Retail Branding": "Crelander",
    "Marketing Name": "T88-EEA",
    "Device": "T88-EEA",
    "Model": "T88-EEA"
  },
  {
    "Retail Branding": "Crelander",
    "Marketing Name": "T88-ROW",
    "Device": "T88-ROW",
    "Model": "T88-ROW"
  },
  {
    "Retail Branding": "Crelander",
    "Marketing Name": "W30",
    "Device": "W30",
    "Model": "W30"
  },
  {
    "Retail Branding": "Crelander",
    "Marketing Name": "W30",
    "Device": "W30",
    "Model": "crelander_android15"
  },
  {
    "Retail Branding": "Crelander",
    "Marketing Name": "W30",
    "Device": "W30",
    "Model": "crelander_android16"
  },
  {
    "Retail Branding": "Crelander",
    "Marketing Name": "W30-EEA",
    "Device": "W30-EEA",
    "Model": "W30-EEA"
  },
  {
    "Retail Branding": "Crelander",
    "Marketing Name": "W87-EEA",
    "Device": "W87-EEA",
    "Model": "W87-EEA"
  },
  {
    "Retail Branding": "Crelander",
    "Marketing Name": "Z103",
    "Device": "Z103",
    "Model": "Z103"
  },
  {
    "Retail Branding": "Crema",
    "Marketing Name": "CREMA0810T",
    "Device": "crema0810t",
    "Model": "CREMA0810T"
  },
  {
    "Retail Branding": "Cricket",
    "Marketing Name": "Cricket Debut S2™",
    "Device": "U380AC",
    "Model": "U380AC"
  },
  {
    "Retail Branding": "Cricket",
    "Marketing Name": "Cricket Icon® Plus - 2026",
    "Device": "SN333C",
    "Model": "SN333C"
  },
  {
    "Retail Branding": "Cricket",
    "Marketing Name": "Cricket Icon™6",
    "Device": "SL219C",
    "Model": "SL219C"
  },
  {
    "Retail Branding": "Cricket",
    "Marketing Name": "Cricket Outlast™ 5G",
    "Device": "SN509C",
    "Model": "SN509C"
  },
  {
    "Retail Branding": "Cricket",
    "Marketing Name": "Cricket® Dream 5G",
    "Device": "EC211001",
    "Model": "EC211001"
  },
  {
    "Retail Branding": "Cricket",
    "Marketing Name": "Cricket® Icon 3",
    "Device": "EC211002",
    "Model": "EC211002"
  },
  {
    "Retail Branding": "Cricket",
    "Marketing Name": "Cricket® Icon 4",
    "Device": "WTCKT01",
    "Model": "WTCKT01"
  },
  {
    "Retail Branding": "Cricket",
    "Marketing Name": "Cricket® Influence",
    "Device": "v350c",
    "Model": "V350C"
  },
  {
    "Retail Branding": "Cricket",
    "Marketing Name": "Cricket® Innovate 5G",
    "Device": "EC211004",
    "Model": "EC211004"
  },
  {
    "Retail Branding": "Cricket",
    "Marketing Name": "Cricket® Magic 5G",
    "Device": "U6080AC",
    "Model": "U6080AC"
  },
  {
    "Retail Branding": "Cricket",
    "Marketing Name": "Cricket® Ovation 2",
    "Device": "ZON",
    "Model": "EC1002"
  },
  {
    "Retail Branding": "Cricket",
    "Marketing Name": "Cricket® Splendor",
    "Device": "EC211003",
    "Model": "EC211003"
  },
  {
    "Retail Branding": "Cricket",
    "Marketing Name": "DEMK4115",
    "Device": "SL100EA",
    "Model": "SL100EA"
  },
  {
    "Retail Branding": "Cricket",
    "Marketing Name": "DEMK4119",
    "Device": "SL101AE",
    "Model": "SL101AE"
  },
  {
    "Retail Branding": "Cricket",
    "Marketing Name": "DEMK4120",
    "Device": "SL100EA",
    "Model": "SL100EA"
  },
  {
    "Retail Branding": "Cricket",
    "Marketing Name": "SN304AE",
    "Device": "SN304AE",
    "Model": "SN304AE"
  },
  {
    "Retail Branding": "Cricket",
    "Marketing Name": "U304AC",
    "Device": "U304AC",
    "Model": "U304AC"
  },
  {
    "Retail Branding": "Cricket",
    "Marketing Name": "U325AC",
    "Device": "U325AC",
    "Model": "U325AC"
  },
  {
    "Retail Branding": "Cricket",
    "Marketing Name": "U705AC",
    "Device": "U705AC",
    "Model": "U705AC"
  },
  {
    "Retail Branding": "Cristor",
    "Marketing Name": "Glory_Z1",
    "Device": "Glory_Z1",
    "Model": "Glory Z1"
  },
  {
    "Retail Branding": "Cristor",
    "Marketing Name": "Smart TV",
    "Device": "redwood",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "Cristor",
    "Marketing Name": "Trendy_1",
    "Device": "Trendy_1",
    "Model": "Trendy 1"
  },
  {
    "Retail Branding": "Cristor",
    "Marketing Name": "Trendy_2",
    "Device": "Trendy_2",
    "Model": "Trendy 2"
  },
  {
    "Retail Branding": "Croatian Telecom",
    "Marketing Name": "KSTB6044",
    "Device": "KSTB6044",
    "Model": "KSTB6044"
  },
  {
    "Retail Branding": "Croma",
    "Marketing Name": "43FDVRCHG5SP",
    "Device": "ikebukuro",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "Crosscall",
    "Marketing Name": "AD-Z5",
    "Device": "L790",
    "Model": "AD-Z5"
  },
  {
    "Retail Branding": "Crosscall",
    "Marketing Name": "Action-X3",
    "Device": "HS8937QC",
    "Model": "ACTION-X3"
  },
  {
    "Retail Branding": "Crosscall",
    "Marketing Name": "Action-X3",
    "Device": "HS8937QC",
    "Model": "Action-X3"
  },
  {
    "Retail Branding": "Crosscall",
    "Marketing Name": "Action-X3",
    "Device": "HS8937QC",
    "Model": "Action-X3 Pro"
  },
  {
    "Retail Branding": "Crosscall",
    "Marketing Name": "Action-X3",
    "Device": "HS8937QCs",
    "Model": "ACTION-X3"
  },
  {
    "Retail Branding": "Crosscall",
    "Marketing Name": "Action-X3",
    "Device": "HS8937QCs",
    "Model": "Action-X3"
  },
  {
    "Retail Branding": "Crosscall",
    "Marketing Name": "Action-X5",
    "Device": "L752",
    "Model": "Action-X5"
  },
  {
    "Retail Branding": "Crosscall",
    "Marketing Name": "CORE-M4",
    "Device": "CORE-M4",
    "Model": "CORE-M4"
  },
  {
    "Retail Branding": "Crosscall",
    "Marketing Name": "CORE-M4 GO",
    "Device": "CORE-M4-GO",
    "Model": "CORE-M4 GO"
  },
  {
    "Retail Branding": "Crosscall",
    "Marketing Name": "Core- X3",
    "Device": "HS8917QC",
    "Model": "Core-X3"
  },
  {
    "Retail Branding": "Crosscall",
    "Marketing Name": "Core-M5",
    "Device": "L751",
    "Model": "Core-M5"
  },
  {
    "Retail Branding": "Crosscall",
    "Marketing Name": "Core-M5",
    "Device": "L751_02",
    "Model": "Core-M5"
  },
  {
    "Retail Branding": "Crosscall",
    "Marketing Name": "Core-M6",
    "Device": "L768",
    "Model": "Core-M6"
  },
  {
    "Retail Branding": "Crosscall",
    "Marketing Name": "Core-T4",
    "Device": "L810",
    "Model": "Core-T4"
  },
  {
    "Retail Branding": "Crosscall",
    "Marketing Name": "Core-T5",
    "Device": "L820",
    "Model": "Core-T4 Neo"
  },
  {
    "Retail Branding": "Crosscall",
    "Marketing Name": "Core-T5",
    "Device": "L820",
    "Model": "Core-T5"
  },
  {
    "Retail Branding": "Crosscall",
    "Marketing Name": "Core-X4",
    "Device": "L762",
    "Model": "Core-X4"
  },
  {
    "Retail Branding": "Crosscall",
    "Marketing Name": "Core-X4 Neo",
    "Device": "L770",
    "Model": "Core-X4 Neo"
  },
  {
    "Retail Branding": "Crosscall",
    "Marketing Name": "Core-X5",
    "Device": "L771",
    "Model": "Core-X5"
  },
  {
    "Retail Branding": "Crosscall",
    "Marketing Name": "Core-Z5",
    "Device": "L790",
    "Model": "Core-Z5"
  },
  {
    "Retail Branding": "Crosscall",
    "Marketing Name": "Core-Z5",
    "Device": "L790_02",
    "Model": "Core-Z5"
  },
  {
    "Retail Branding": "Crosscall",
    "Marketing Name": "ODYSSEY",
    "Device": "ODYSSEY3G",
    "Model": "ODYSSEY"
  },
  {
    "Retail Branding": "Crosscall",
    "Marketing Name": "Stellar-M6",
    "Device": "L768",
    "Model": "Stellar-M6"
  },
  {
    "Retail Branding": "Crosscall",
    "Marketing Name": "Stellar-M6E",
    "Device": "L768",
    "Model": "Stellar-M6E"
  },
  {
    "Retail Branding": "Crosscall",
    "Marketing Name": "Stellar-X5",
    "Device": "L780",
    "Model": "Stellar-X5"
  },
  {
    "Retail Branding": "Crosscall",
    "Marketing Name": "TREKKER- X3",
    "Device": "HS8952QC",
    "Model": "TREKKER-X3"
  },
  {
    "Retail Branding": "Crosscall",
    "Marketing Name": "TREKKER-M1 CORE",
    "Device": "HS8909QC",
    "Model": "TREKKER-M1 CORE"
  },
  {
    "Retail Branding": "Crosscall",
    "Marketing Name": "Trekker- M1",
    "Device": "HS8916QC",
    "Model": "Trekker-M1"
  },
  {
    "Retail Branding": "Crosscall",
    "Marketing Name": "Trekker- X4",
    "Device": "HSSDM660QC",
    "Model": "Trekker-X4"
  },
  {
    "Retail Branding": "CryptoDATA",
    "Marketing Name": "HidR_EVO",
    "Device": "HidR_EVO",
    "Model": "EVO"
  },
  {
    "Retail Branding": "CryptoDATA",
    "Marketing Name": "Hidr S1 PRO",
    "Device": "Hidr_S1_PRO",
    "Model": "Hidr_S1_PRO"
  },
  {
    "Retail Branding": "CryptoDATA",
    "Marketing Name": "Hidr S1 PRO ROW",
    "Device": "Hidr_S1_PRO",
    "Model": "Hidr_S1_PRO"
  },
  {
    "Retail Branding": "CryptoDATA",
    "Marketing Name": "Hidr S1 PRO RU",
    "Device": "Hidr_S1_PRO",
    "Model": "Hidr_S1_PRO"
  },
  {
    "Retail Branding": "Cspire",
    "Marketing Name": "FT7",
    "Device": "FT7_tw",
    "Model": "Android Tablet FT7"
  },
  {
    "Retail Branding": "Ctroniq",
    "Marketing Name": "CTRONIQ-SNOOK-X10",
    "Device": "CTRONIQ-SNOOK-X10",
    "Model": "CTRONIQ-SNOOK-X10"
  },
  {
    "Retail Branding": "Ctroniq",
    "Marketing Name": "CTRONIQ-SNOOK-X10L",
    "Device": "CTRONIQ-SNOOK-X10L",
    "Model": "CTRONIQ-SNOOK-X10L"
  },
  {
    "Retail Branding": "Ctroniq",
    "Marketing Name": "CTRONIQ-SNOOK-X10S",
    "Device": "CTRONIQ-SNOOK-X10S",
    "Model": "CTRONIQ-SNOOK-X10S"
  },
  {
    "Retail Branding": "Ctroniq",
    "Marketing Name": "Ctroniq_Snook_B70",
    "Device": "Ctroniq_B70",
    "Model": "Ctroniq_Snook_B70"
  },
  {
    "Retail Branding": "Ctroniq",
    "Marketing Name": "Ctroniq_Snook_W10",
    "Device": "Ctroniq_Snook_W10",
    "Model": "Ctroniq_Snook_W10"
  },
  {
    "Retail Branding": "Ctroniq",
    "Marketing Name": "Ctroniq_Snook_W70",
    "Device": "Ctroniq_Snook_W70",
    "Model": "Ctroniq_Snook_W70"
  },
  {
    "Retail Branding": "Ctroniq",
    "Marketing Name": "K9",
    "Device": "K9",
    "Model": "K9"
  },
  {
    "Retail Branding": "Ctroniq",
    "Marketing Name": "SNOOK-X10",
    "Device": "4G_TABLET",
    "Model": "SNOOK-X10"
  },
  {
    "Retail Branding": "Ctroniq",
    "Marketing Name": "SNOOK-X10",
    "Device": "SNOOK-X10",
    "Model": "SNOOK-X10"
  },
  {
    "Retail Branding": "Ctroniq",
    "Marketing Name": "SNOOK-X75",
    "Device": "SNOOK-X75",
    "Model": "SNOOK-X75"
  },
  {
    "Retail Branding": "Ctroniq",
    "Marketing Name": "SNOOK-X80",
    "Device": "SNOOK-X80",
    "Model": "SNOOK-X80"
  },
  {
    "Retail Branding": "Cubot",
    "Marketing Name": "A10",
    "Device": "A10",
    "Model": "A10"
  },
  {
    "Retail Branding": "Cubot",
    "Marketing Name": "A1_EEA",
    "Device": "A1",
    "Model": "A1"
  },
  {
    "Retail Branding": "Cubot",
    "Marketing Name": "A20",
    "Device": "A20",
    "Model": "A20"
  },
  {
    "Retail Branding": "Cubot",
    "Marketing Name": "A30",
    "Device": "A30",
    "Model": "A30"
  },
  {
    "Retail Branding": "Cubot",
    "Marketing Name": "A40",
    "Device": "A40",
    "Model": "A40"
  },
  {
    "Retail Branding": "Cubot",
    "Marketing Name": "C20",
    "Device": "C20",
    "Model": "C20"
  },
  {
    "Retail Branding": "Cubot",
    "Marketing Name": "C30",
    "Device": "C30",
    "Model": "C30"
  },
  {
    "Retail Branding": "Cubot",
    "Marketing Name": "CUBOT CHEETAH 2",
    "Device": "CUBOT_CHEETAH_2",
    "Model": "CUBOT CHEETAH 2"
  },
  {
    "Retail Branding": "Cubot",
    "Marketing Name": "CUBOT H3",
    "Device": "CUBOT_H3",
    "Model": "CUBOT H3"
  },
  {
    "Retail Branding": "Cubot",
    "Marketing Name": "CUBOT J9",
    "Device": "CUBOT_J9",
    "Model": "CUBOT J9"
  },
  {
    "Retail Branding": "Cubot",
    "Marketing Name": "CUBOT MAGIC",
    "Device": "CUBOT_MAGIC",
    "Model": "CUBOT MAGIC"
  },
  {
    "Retail Branding": "Cubot",
    "Marketing Name": "CUBOT MAGIC",
    "Device": "CUBOT_R9",
    "Model": "CUBOT R9"
  },
  {
    "Retail Branding": "Cubot",
    "Marketing Name": "CUBOT NOTE Plus",
    "Device": "CUBOT_NOTE_Plus",
    "Model": "CUBOT NOTE Plus"
  },
  {
    "Retail Branding": "Cubot",
    "Marketing Name": "CUBOT R11",
    "Device": "CUBOT_R11",
    "Model": "CUBOT R11"
  },
  {
    "Retail Branding": "Cubot",
    "Marketing Name": "CUBOT X18",
    "Device": "CUBOT_X18",
    "Model": "CUBOT X18"
  },
  {
    "Retail Branding": "Cubot",
    "Marketing Name": "CUBOT_A5",
    "Device": "CUBOT_A5",
    "Model": "CUBOT A5"
  },
  {
    "Retail Branding": "Cubot",
    "Marketing Name": "CUBOT_J3",
    "Device": "CUBOT_J3",
    "Model": "CUBOT_J3"
  },
  {
    "Retail Branding": "Cubot",
    "Marketing Name": "CUBOT_J3_PRO",
    "Device": "CUBOT_J3_PRO",
    "Model": "CUBOT J3 PRO"
  },
  {
    "Retail Branding": "Cubot",
    "Marketing Name": "CUBOT_NOVA",
    "Device": "CUBOT_NOVA",
    "Model": "CUBOT_NOVA"
  },
  {
    "Retail Branding": "Cubot",
    "Marketing Name": "CUBOT_POWER",
    "Device": "CUBOT_POWER",
    "Model": "CUBOT_POWER"
  },
  {
    "Retail Branding": "Cubot",
    "Marketing Name": "DINOSAUR",
    "Device": "x5623_h6013_cubot",
    "Model": "CUBOT DINOSAUR"
  },
  {
    "Retail Branding": "Cubot",
    "Marketing Name": "ECHO",
    "Device": "CUBOT_ECHO",
    "Model": "CUBOT ECHO"
  },
  {
    "Retail Branding": "Cubot",
    "Marketing Name": "J10",
    "Device": "J10",
    "Model": "J10"
  },
  {
    "Retail Branding": "Cubot",
    "Marketing Name": "J20",
    "Device": "J20",
    "Model": "J20"
  },
  {
    "Retail Branding": "Cubot",
    "Marketing Name": "J5",
    "Device": "J5",
    "Model": "J5"
  },
  {
    "Retail Branding": "Cubot",
    "Marketing Name": "J7",
    "Device": "J7",
    "Model": "J7"
  },
  {
    "Retail Branding": "Cubot",
    "Marketing Name": "J8",
    "Device": "J8",
    "Model": "J8"
  },
  {
    "Retail Branding": "Cubot",
    "Marketing Name": "KING KONG CS",
    "Device": "KING_KONG_CS",
    "Model": "KING KONG CS"
  },
  {
    "Retail Branding": "Cubot",
    "Marketing Name": "KINGKING ACE 5",
    "Device": "KINGKONG_ACE_5",
    "Model": "KINGKONG ACE 5"
  },
  {
    "Retail Branding": "Cubot",
    "Marketing Name": "KINGKONG 11",
    "Device": "KINGKONG_11",
    "Model": "KINGKONG 11"
  },
  {
    "Retail Branding": "Cubot",
    "Marketing Name": "KINGKONG 5",
    "Device": "KINGKONG_5",
    "Model": "KINGKONG 5"
  },
  {
    "Retail Branding": "Cubot",
    "Marketing Name": "KINGKONG 5 Pro",
    "Device": "KINGKONG_5_Pro",
    "Model": "KINGKONG 5 Pro"
  },
  {
    "Retail Branding": "Cubot",
    "Marketing Name": "KINGKONG 6",
    "Device": "KINGKONG_6",
    "Model": "KINGKONG 6"
  },
  {
    "Retail Branding": "Cubot",
    "Marketing Name": "KINGKONG 7",
    "Device": "KINGKONG_7",
    "Model": "KINGKONG 7"
  },
  {
    "Retail Branding": "Cubot",
    "Marketing Name": "KINGKONG 8",
    "Device": "KINGKONG_8",
    "Model": "KINGKONG 8"
  },
  {
    "Retail Branding": "Cubot",
    "Marketing Name": "KINGKONG 9",
    "Device": "KINGKONG_9",
    "Model": "KINGKONG 9"
  },
  {
    "Retail Branding": "Cubot",
    "Marketing Name": "KINGKONG ACE 2",
    "Device": "KINGKONG_ACE_2",
    "Model": "KINGKONG ACE 2"
  },
  {
    "Retail Branding": "Cubot",
    "Marketing Name": "KINGKONG ACE 3",
    "Device": "KINGKONG_ACE_3",
    "Model": "KINGKONG ACE 3"
  },
  {
    "Retail Branding": "Cubot",
    "Marketing Name": "KINGKONG CS",
    "Device": "KING_KONG_CS",
    "Model": "KING KONG CS"
  },
  {
    "Retail Branding": "Cubot",
    "Marketing Name": "KINGKONG ES",
    "Device": "KINGKONG_ES",
    "Model": "KINGKONG_ES"
  },
  {
    "Retail Branding": "Cubot",
    "Marketing Name": "KINGKONG ES 3",
    "Device": "KINGKONG_ES_3",
    "Model": "KINGKONG ES 3"
  },
  {
    "Retail Branding": "Cubot",
    "Marketing Name": "KINGKONG MINI 3",
    "Device": "KINGKONGMINI3",
    "Model": "KINGKONG MINI 3"
  },
  {
    "Retail Branding": "Cubot",
    "Marketing Name": "KINGKONG MINI 4",
    "Device": "KINGKONG_MINI_4",
    "Model": "KINGKONG MINI 4"
  },
  {
    "Retail Branding": "Cubot",
    "Marketing Name": "KINGKONG MINI2",
    "Device": "KINGKONG_MINI2",
    "Model": "KINGKONG MINI2"
  },
  {
    "Retail Branding": "Cubot",
    "Marketing Name": "KINGKONG MINI2 Pro",
    "Device": "KINGKONG_MINI2_Pro",
    "Model": "KINGKONG MINI2 Pro"
  },
  {
    "Retail Branding": "Cubot",
    "Marketing Name": "KINGKONG MINI2 Pro",
    "Device": "KINGKONG_MINI2_Pro",
    "Model": "KINGKONG_MINI2_Pro"
  },
  {
    "Retail Branding": "Cubot",
    "Marketing Name": "KINGKONG POWER 3",
    "Device": "KINGKONG_POWER_3",
    "Model": "KINGKONG POWER 3"
  },
  {
    "Retail Branding": "Cubot",
    "Marketing Name": "KINGKONG STAR",
    "Device": "KINGKONG_STAR",
    "Model": "KINGKONG STAR"
  },
  {
    "Retail Branding": "Cubot",
    "Marketing Name": "KINGKONG STAR 2",
    "Device": "KINGKONG_STAR_2",
    "Model": "KINGKONG STAR 2"
  },
  {
    "Retail Branding": "Cubot",
    "Marketing Name": "KINGKONG X",
    "Device": "KINGKONG_X",
    "Model": "KINGKONG X"
  },
  {
    "Retail Branding": "Cubot",
    "Marketing Name": "KINGKONG_MINI",
    "Device": "KINGKONG_MINI",
    "Model": "KINGKONG_MINI"
  },
  {
    "Retail Branding": "Cubot",
    "Marketing Name": "KINGKONG_POWER_5",
    "Device": "KINGKONG_POWER_5",
    "Model": "KINGKONG POWER 5"
  },
  {
    "Retail Branding": "Cubot",
    "Marketing Name": "KING_KONG_3",
    "Device": "KING_KONG_3",
    "Model": "KING_KONG_3"
  },
  {
    "Retail Branding": "Cubot",
    "Marketing Name": "MANITO",
    "Device": "CUBOT_MANITO",
    "Model": "CUBOT_MANITO"
  },
  {
    "Retail Branding": "Cubot",
    "Marketing Name": "MAX",
    "Device": "x6069_cubot_5365u",
    "Model": "CUBOT MAX"
  },
  {
    "Retail Branding": "Cubot",
    "Marketing Name": "MAX  2",
    "Device": "MAX_2",
    "Model": "MAX 2"
  },
  {
    "Retail Branding": "Cubot",
    "Marketing Name": "MAX 3",
    "Device": "MAX_3",
    "Model": "MAX 3"
  },
  {
    "Retail Branding": "Cubot",
    "Marketing Name": "MAX 5",
    "Device": "MAX_5",
    "Model": "MAX 5"
  },
  {
    "Retail Branding": "Cubot",
    "Marketing Name": "NOTE 20",
    "Device": "NOTE_20",
    "Model": "NOTE 20"
  },
  {
    "Retail Branding": "Cubot",
    "Marketing Name": "NOTE 20 PRO",
    "Device": "NOTE_20_PRO",
    "Model": "NOTE 20 PRO"
  },
  {
    "Retail Branding": "Cubot",
    "Marketing Name": "NOTE 30",
    "Device": "NOTE_30",
    "Model": "NOTE 30"
  },
  {
    "Retail Branding": "Cubot",
    "Marketing Name": "NOTE 40",
    "Device": "NOTE_40",
    "Model": "NOTE 40"
  },
  {
    "Retail Branding": "Cubot",
    "Marketing Name": "NOTE 50",
    "Device": "NOTE_50",
    "Model": "NOTE 50"
  },
  {
    "Retail Branding": "Cubot",
    "Marketing Name": "NOTE 60",
    "Device": "NOTE_60",
    "Model": "NOTE 60"
  },
  {
    "Retail Branding": "Cubot",
    "Marketing Name": "NOTE 7",
    "Device": "NOTE_7",
    "Model": "NOTE 7"
  },
  {
    "Retail Branding": "Cubot",
    "Marketing Name": "NOTE 8",
    "Device": "NOTE_8",
    "Model": "NOTE 8"
  },
  {
    "Retail Branding": "Cubot",
    "Marketing Name": "NOTE 9",
    "Device": "NOTE_9",
    "Model": "NOTE 9"
  },
  {
    "Retail Branding": "Cubot",
    "Marketing Name": "NOTE S",
    "Device": "CUBOT_CHEETAH_2",
    "Model": "CUBOT CHEETAH 2"
  },
  {
    "Retail Branding": "Cubot",
    "Marketing Name": "NOTE S",
    "Device": "CUBOT_NOTE_S",
    "Model": "CUBOT_NOTE_S"
  },
  {
    "Retail Branding": "Cubot",
    "Marketing Name": "NOTE_7P",
    "Device": "NOTE_7P",
    "Model": "NOTE 7P"
  },
  {
    "Retail Branding": "Cubot",
    "Marketing Name": "P30",
    "Device": "P30",
    "Model": "P30"
  },
  {
    "Retail Branding": "Cubot",
    "Marketing Name": "P40",
    "Device": "P40",
    "Model": "P40"
  },
  {
    "Retail Branding": "Cubot",
    "Marketing Name": "P50",
    "Device": "P50",
    "Model": "P50"
  },
  {
    "Retail Branding": "Cubot",
    "Marketing Name": "P60",
    "Device": "P60",
    "Model": "P60"
  },
  {
    "Retail Branding": "Cubot",
    "Marketing Name": "P80",
    "Device": "P80",
    "Model": "P80"
  },
  {
    "Retail Branding": "Cubot",
    "Marketing Name": "P90",
    "Device": "P90",
    "Model": "P90"
  },
  {
    "Retail Branding": "Cubot",
    "Marketing Name": "POCKET 3",
    "Device": "POCKET_3",
    "Model": "POCKET 3"
  },
  {
    "Retail Branding": "Cubot",
    "Marketing Name": "Pocket",
    "Device": "Pocket",
    "Model": "Pocket"
  },
  {
    "Retail Branding": "Cubot",
    "Marketing Name": "QUEST",
    "Device": "QUEST",
    "Model": "QUEST"
  },
  {
    "Retail Branding": "Cubot",
    "Marketing Name": "QUEST LITE",
    "Device": "QUEST_LITE",
    "Model": "QUEST LITE"
  },
  {
    "Retail Branding": "Cubot",
    "Marketing Name": "R15",
    "Device": "R15",
    "Model": "R15"
  },
  {
    "Retail Branding": "Cubot",
    "Marketing Name": "R15_PRO",
    "Device": "R15_PRO",
    "Model": "R15_PRO"
  },
  {
    "Retail Branding": "Cubot",
    "Marketing Name": "R19",
    "Device": "R19",
    "Model": "R19"
  },
  {
    "Retail Branding": "Cubot",
    "Marketing Name": "RAINBOW 2",
    "Device": "RAINBOW_2",
    "Model": "RAINBOW 2"
  },
  {
    "Retail Branding": "Cubot",
    "Marketing Name": "Rainbow",
    "Device": "RAINBOW",
    "Model": "RAINBOW"
  },
  {
    "Retail Branding": "Cubot",
    "Marketing Name": "TAB  60",
    "Device": "TAB_60",
    "Model": "TAB 60"
  },
  {
    "Retail Branding": "Cubot",
    "Marketing Name": "TAB 10",
    "Device": "TAB_10",
    "Model": "TAB 10"
  },
  {
    "Retail Branding": "Cubot",
    "Marketing Name": "TAB 20",
    "Device": "TAB_20",
    "Model": "TAB 20"
  },
  {
    "Retail Branding": "Cubot",
    "Marketing Name": "TAB 40",
    "Device": "TAB_40",
    "Model": "TAB 40"
  },
  {
    "Retail Branding": "Cubot",
    "Marketing Name": "TAB 50",
    "Device": "TAB_50",
    "Model": "TAB 50"
  },
  {
    "Retail Branding": "Cubot",
    "Marketing Name": "TAB 65",
    "Device": "TAB_65",
    "Model": "TAB 65"
  },
  {
    "Retail Branding": "Cubot",
    "Marketing Name": "TAB KINGKONG",
    "Device": "TAB_KINGKONG",
    "Model": "TAB KINGKONG"
  },
  {
    "Retail Branding": "Cubot",
    "Marketing Name": "TAB KINGKONG 2",
    "Device": "TAB_KINGKONG_2",
    "Model": "TAB KINGKONG 2"
  },
  {
    "Retail Branding": "Cubot",
    "Marketing Name": "TAB_70",
    "Device": "TAB_70",
    "Model": "TAB_70"
  },
  {
    "Retail Branding": "Cubot",
    "Marketing Name": "X100",
    "Device": "X100",
    "Model": "X100"
  },
  {
    "Retail Branding": "Cubot",
    "Marketing Name": "X19",
    "Device": "X19",
    "Model": "X19"
  },
  {
    "Retail Branding": "Cubot",
    "Marketing Name": "X19_S",
    "Device": "X19_S",
    "Model": "X19 S"
  },
  {
    "Retail Branding": "Cubot",
    "Marketing Name": "X20",
    "Device": "X20",
    "Model": "X20"
  },
  {
    "Retail Branding": "Cubot",
    "Marketing Name": "X20_PRO",
    "Device": "X20_PRO",
    "Model": "X20 PRO"
  },
  {
    "Retail Branding": "Cubot",
    "Marketing Name": "X30",
    "Device": "X30",
    "Model": "X30"
  },
  {
    "Retail Branding": "Cubot",
    "Marketing Name": "X30P",
    "Device": "X30P",
    "Model": "X30P"
  },
  {
    "Retail Branding": "Cubot",
    "Marketing Name": "X50",
    "Device": "X50",
    "Model": "X50"
  },
  {
    "Retail Branding": "Cubot",
    "Marketing Name": "X70",
    "Device": "X70",
    "Model": "X70"
  },
  {
    "Retail Branding": "Cubot",
    "Marketing Name": "X90",
    "Device": "X90",
    "Model": "X90"
  },
  {
    "Retail Branding": "Cubot",
    "Marketing Name": "note_9",
    "Device": "NOTE_9",
    "Model": "NOTE 9"
  },
  {
    "Retail Branding": "Custom",
    "Marketing Name": "Ares",
    "Device": "Ares",
    "Model": "Ares"
  },
  {
    "Retail Branding": "Custom",
    "Marketing Name": "CUSTOM_G700",
    "Device": "CUSTOM_G700",
    "Model": "CUSTOM_G700"
  },
  {
    "Retail Branding": "Custom",
    "Marketing Name": "K-Ranger",
    "Device": "K-Ranger",
    "Model": "K-Ranger"
  },
  {
    "Retail Branding": "Custom",
    "Marketing Name": "K-Ranger",
    "Device": "K-Ranger",
    "Model": "K-Ranger_ROW"
  },
  {
    "Retail Branding": "Custom",
    "Marketing Name": "K-Ranger",
    "Device": "K-Ranger",
    "Model": "K-Ranger_RU"
  },
  {
    "Retail Branding": "Custom",
    "Marketing Name": "P-Ranger",
    "Device": "P-Ranger",
    "Model": "P-Ranger"
  },
  {
    "Retail Branding": "Custom",
    "Marketing Name": "P-Ranger",
    "Device": "P-Ranger",
    "Model": "P-Ranger_ROW"
  },
  {
    "Retail Branding": "Custom",
    "Marketing Name": "P-Ranger",
    "Device": "P-Ranger",
    "Model": "P-Ranger_RU"
  },
  {
    "Retail Branding": "Custom",
    "Marketing Name": "P-Ranger",
    "Device": "P_Ranger",
    "Model": "P-Ranger"
  },
  {
    "Retail Branding": "Cutepad",
    "Marketing Name": "Tab_4_M7078",
    "Device": "Tab_4_M7078",
    "Model": "Tab_4_M7078"
  },
  {
    "Retail Branding": "Cybernetyx",
    "Marketing Name": "EyeRIS_Canvas_Series",
    "Device": "Canvas_E",
    "Model": "EyeRIS_Canvas_Series"
  },
  {
    "Retail Branding": "Cyrus",
    "Marketing Name": "CM17",
    "Device": "CM17",
    "Model": "CM17"
  },
  {
    "Retail Branding": "Cyrus",
    "Marketing Name": "CM17XA",
    "Device": "CM17XA",
    "Model": "CM17XA"
  },
  {
    "Retail Branding": "Cyrus",
    "Marketing Name": "CM17XA_EEA",
    "Device": "CM17XA",
    "Model": "CM17XA_EEA"
  },
  {
    "Retail Branding": "Cyrus",
    "Marketing Name": "CM450XA_EEA",
    "Device": "CM450XA",
    "Model": "CM450XA"
  },
  {
    "Retail Branding": "Cyrus",
    "Marketing Name": "CS22",
    "Device": "CS22",
    "Model": "CS22"
  },
  {
    "Retail Branding": "Cyrus",
    "Marketing Name": "CS22XA",
    "Device": "CS22XA",
    "Model": "CS22XA"
  },
  {
    "Retail Branding": "Cyrus",
    "Marketing Name": "CS22XA_EEA",
    "Device": "CS22XA_EEA",
    "Model": "CS22XA_EEA"
  },
  {
    "Retail Branding": "Cyrus",
    "Marketing Name": "CS24",
    "Device": "CS24",
    "Model": "CS24"
  },
  {
    "Retail Branding": "Cyrus",
    "Marketing Name": "CS40",
    "Device": "CS40",
    "Model": "CS40"
  },
  {
    "Retail Branding": "Cyrus",
    "Marketing Name": "CS45XA",
    "Device": "CS45XA",
    "Model": "CS45XA"
  },
  {
    "Retail Branding": "Cyrus",
    "Marketing Name": "CS45XA",
    "Device": "CS45XA2",
    "Model": "CS45XA"
  },
  {
    "Retail Branding": "Cyrus",
    "Marketing Name": "CS45XA_EEA",
    "Device": "CS45XA2",
    "Model": "CS45XA_EEA"
  },
  {
    "Retail Branding": "Cyrus",
    "Marketing Name": "CS45XA_EEA",
    "Device": "CS45XA_EEA",
    "Model": "CS45XA_EEA"
  },
  {
    "Retail Branding": "Cyrus",
    "Marketing Name": "ORSY_Controller",
    "Device": "ORSY_Controller",
    "Model": "ORSY_Controller"
  },
  {
    "Retail Branding": "D-Tech",
    "Marketing Name": "D5L",
    "Device": "D5-L",
    "Model": "D5-L"
  },
  {
    "Retail Branding": "D-Tech",
    "Marketing Name": "D5L",
    "Device": "D5L",
    "Model": "D5L"
  },
  {
    "Retail Branding": "D-Tech",
    "Marketing Name": "D5S",
    "Device": "D5S",
    "Model": "D5S"
  },
  {
    "Retail Branding": "D-Tech",
    "Marketing Name": "DT07",
    "Device": "DT07",
    "Model": "DT07"
  },
  {
    "Retail Branding": "D-Tech",
    "Marketing Name": "DT08-TAB4G",
    "Device": "DT08-TAB4G",
    "Model": "DT08-TAB4G"
  },
  {
    "Retail Branding": "D-Tech",
    "Marketing Name": "DT10-TAB4G",
    "Device": "DT10-TAB4G",
    "Model": "DT10-TAB4G"
  },
  {
    "Retail Branding": "D-Tech",
    "Marketing Name": "DT10-TAB4G-T101",
    "Device": "DT10-TAB4G-T101",
    "Model": "DT10-TAB4G-T101"
  },
  {
    "Retail Branding": "D-Tech",
    "Marketing Name": "H70_G",
    "Device": "H70_G",
    "Model": "H70_G"
  },
  {
    "Retail Branding": "D-Tech",
    "Marketing Name": "LM-01",
    "Device": "LM_01",
    "Model": "LM-01"
  },
  {
    "Retail Branding": "DABLIU",
    "Marketing Name": "E13R",
    "Device": "E13R_B100G",
    "Model": "E13R"
  },
  {
    "Retail Branding": "DABLIU",
    "Marketing Name": "E13R",
    "Device": "E13R_B75G",
    "Model": "E13R"
  },
  {
    "Retail Branding": "DABLIU",
    "Marketing Name": "E13R",
    "Device": "E13R_B86G",
    "Model": "E13R"
  },
  {
    "Retail Branding": "DABLIU",
    "Marketing Name": "E13R_B65G",
    "Device": "rk3588_E13R",
    "Model": "E13R"
  },
  {
    "Retail Branding": "DABLIU",
    "Marketing Name": "E1M",
    "Device": "E1M",
    "Model": "E1M"
  },
  {
    "Retail Branding": "DABLIU",
    "Marketing Name": "E1N",
    "Device": "E1N",
    "Model": "E1N"
  },
  {
    "Retail Branding": "DABLIU",
    "Marketing Name": "L1R",
    "Device": "L1R",
    "Model": "L1R"
  },
  {
    "Retail Branding": "DAIICHI",
    "Marketing Name": "Vietnam",
    "Device": "martin",
    "Model": "Daiichi 2K SMART TV"
  },
  {
    "Retail Branding": "DAIICHI",
    "Marketing Name": "Vietnam",
    "Device": "tamachi",
    "Model": "Daiichi FHD Android TV"
  },
  {
    "Retail Branding": "DAIICHI",
    "Marketing Name": "Vietnam",
    "Device": "yeongdeungpo",
    "Model": "Daiichi UHD Android TV"
  },
  {
    "Retail Branding": "DAIKO",
    "Marketing Name": "DAIKO UHD TV",
    "Device": "OD0M_EA_T32",
    "Model": "DAIKO UHD TV"
  },
  {
    "Retail Branding": "DAIKO",
    "Marketing Name": "Smart TV",
    "Device": "alimos",
    "Model": "Daiko Google TV"
  },
  {
    "Retail Branding": "DAIKO",
    "Marketing Name": "Smart TV",
    "Device": "dangni",
    "Model": "ASTECH Google TV"
  },
  {
    "Retail Branding": "DAIKO",
    "Marketing Name": "Smart TV",
    "Device": "dangni",
    "Model": "Daiko Google TV"
  },
  {
    "Retail Branding": "DAIKO",
    "Marketing Name": "Smart TV",
    "Device": "osaka",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "DAIYU",
    "Marketing Name": "MBTWDY01",
    "Device": "Mediabox",
    "Model": "MBTWDY01"
  },
  {
    "Retail Branding": "DAMASCO",
    "Marketing Name": "DAMASCO MOBILE SERIE M-300 VISION",
    "Device": "SERIE_M_300",
    "Model": "SERIE_M_300"
  },
  {
    "Retail Branding": "DAMASCO",
    "Marketing Name": "SERIE_M_100",
    "Device": "SERIE_M_100",
    "Model": "SERIE_M_100"
  },
  {
    "Retail Branding": "DAMASCO",
    "Marketing Name": "SERIE_M_200",
    "Device": "SERIE_M_200",
    "Model": "SERIE_M_200"
  },
  {
    "Retail Branding": "DAMASCO",
    "Marketing Name": "T8620-6",
    "Device": "T8620-6",
    "Model": "T8620-6"
  },
  {
    "Retail Branding": "DAMASCO",
    "Marketing Name": "TAB-T101-4",
    "Device": "TAB-T101-4",
    "Model": "TAB-T101-4"
  },
  {
    "Retail Branding": "DAMASCO",
    "Marketing Name": "TAB-T104-6",
    "Device": "TAB-T104-6",
    "Model": "TAB-T104-6"
  },
  {
    "Retail Branding": "DAMASCO",
    "Marketing Name": "TAB-T126-8",
    "Device": "TAB-T126-8",
    "Model": "TAB-T126-8"
  },
  {
    "Retail Branding": "DAMASCO",
    "Marketing Name": "TAB-T537-10",
    "Device": "TAB-T537-10",
    "Model": "TAB-T537-10"
  },
  {
    "Retail Branding": "DAMASCO",
    "Marketing Name": "TAB-T863-3",
    "Device": "TAB-T863-3",
    "Model": "TAB-T863-3"
  },
  {
    "Retail Branding": "DANDOON",
    "Marketing Name": "A2",
    "Device": "A2",
    "Model": "A2"
  },
  {
    "Retail Branding": "DBM Maroc",
    "Marketing Name": "ACCENT SURF 1000",
    "Device": "SURF1000",
    "Model": "SURF1000"
  },
  {
    "Retail Branding": "DBM Maroc",
    "Marketing Name": "Accent Speed Y2",
    "Device": "Speed-Y2",
    "Model": "Speed-Y2"
  },
  {
    "Retail Branding": "DBM Maroc",
    "Marketing Name": "Accent Speed Y3",
    "Device": "Speed-Y3",
    "Model": "Speed-Y3"
  },
  {
    "Retail Branding": "DBM Maroc",
    "Marketing Name": "FAST A6",
    "Device": "FAST_A6",
    "Model": "FAST A6"
  },
  {
    "Retail Branding": "DBM Maroc",
    "Marketing Name": "FAST7 4G",
    "Device": "FAST7_4G",
    "Model": "FAST7_4G"
  },
  {
    "Retail Branding": "DBM Maroc",
    "Marketing Name": "Pearl A2",
    "Device": "PEARL_A2",
    "Model": "PEARL_A2"
  },
  {
    "Retail Branding": "DBM Maroc",
    "Marketing Name": "Speed X2",
    "Device": "Speed-X2",
    "Model": "Speed-X2"
  },
  {
    "Retail Branding": "DCG-INSPIRATECH",
    "Marketing Name": "DCG-N10",
    "Device": "DCG-N10",
    "Model": "DCG-N10"
  },
  {
    "Retail Branding": "DEA Factory",
    "Marketing Name": "KTAB",
    "Device": "KTAB",
    "Model": "KTAB"
  },
  {
    "Retail Branding": "DEED",
    "Marketing Name": "DC-WT15",
    "Device": "DC-WT15",
    "Model": "DC-WT15"
  },
  {
    "Retail Branding": "DEERTiME",
    "Marketing Name": "E10_EEA",
    "Device": "E10_EEA",
    "Model": "E10_EEA"
  },
  {
    "Retail Branding": "DEERTiME",
    "Marketing Name": "E10_US",
    "Device": "E10_US",
    "Model": "E10_US"
  },
  {
    "Retail Branding": "DEERTiME",
    "Marketing Name": "E11_EEA",
    "Device": "E11_EEA",
    "Model": "E11_EEA"
  },
  {
    "Retail Branding": "DEERTiME",
    "Marketing Name": "E11_US",
    "Device": "E11_US",
    "Model": "E11_US"
  },
  {
    "Retail Branding": "DEERTiME",
    "Marketing Name": "E15_EEA",
    "Device": "E15_EEA",
    "Model": "E15_EEA"
  },
  {
    "Retail Branding": "DEERTiME",
    "Marketing Name": "E15_US",
    "Device": "E15_US",
    "Model": "E15_US"
  },
  {
    "Retail Branding": "DEERTiME",
    "Marketing Name": "E15_V_EEA",
    "Device": "E15_V_EEA",
    "Model": "E15_V_EEA"
  },
  {
    "Retail Branding": "DEERTiME",
    "Marketing Name": "E15_V_US",
    "Device": "E15_V_US",
    "Model": "E15_V_US"
  },
  {
    "Retail Branding": "DEERTiME",
    "Marketing Name": "E6_EEA",
    "Device": "E6_EEA",
    "Model": "E6_EEA"
  },
  {
    "Retail Branding": "DEERTiME",
    "Marketing Name": "E6_RU",
    "Device": "E6_RU",
    "Model": "E6_RU"
  },
  {
    "Retail Branding": "DEERTiME",
    "Marketing Name": "E6_US",
    "Device": "E6_US",
    "Model": "E6_US"
  },
  {
    "Retail Branding": "DEERTiME",
    "Marketing Name": "E9-EU",
    "Device": "E9-EU",
    "Model": "E9-EU"
  },
  {
    "Retail Branding": "DEERTiME",
    "Marketing Name": "E9-W",
    "Device": "E9-W",
    "Model": "E9-W"
  },
  {
    "Retail Branding": "DEERTiME",
    "Marketing Name": "E9_EEA",
    "Device": "E9_EEA",
    "Model": "E9_EEA"
  },
  {
    "Retail Branding": "DEERTiME",
    "Marketing Name": "E9_US",
    "Device": "E9_US",
    "Model": "E9_US"
  },
  {
    "Retail Branding": "DEPLAY",
    "Marketing Name": "BS101_EEA",
    "Device": "BS101_EEA",
    "Model": "BS101_EEA"
  },
  {
    "Retail Branding": "DEPLAY",
    "Marketing Name": "BS703_EEA",
    "Device": "BS703_EEA",
    "Model": "BS703_EEA"
  },
  {
    "Retail Branding": "DEPLAY",
    "Marketing Name": "BS801",
    "Device": "BS801_EEA",
    "Model": "BS801"
  },
  {
    "Retail Branding": "DEPLAY",
    "Marketing Name": "E101GCM",
    "Device": "E101GCM",
    "Model": "E101GCM"
  },
  {
    "Retail Branding": "DEPLAY",
    "Marketing Name": "E108GCM",
    "Device": "E108GCM",
    "Model": "E108GCM"
  },
  {
    "Retail Branding": "DEPLAY",
    "Marketing Name": "LITE4_EEA",
    "Device": "LITE4_EEA",
    "Model": "LITE4_EEA"
  },
  {
    "Retail Branding": "DEPLAY",
    "Marketing Name": "PRO4",
    "Device": "PRO4",
    "Model": "PRO4"
  },
  {
    "Retail Branding": "DEVOPS",
    "Marketing Name": "DEVOPS",
    "Device": "DEVOPS_IFPD",
    "Model": "DEVOPS_MT9679"
  },
  {
    "Retail Branding": "DEWSOD",
    "Marketing Name": "C9",
    "Device": "C9",
    "Model": "C9"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "A.350",
    "Device": "A350",
    "Model": "A350"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "A150",
    "Device": "A150",
    "Model": "A150"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "A160",
    "Device": "A160",
    "Model": "A160"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "A240",
    "Device": "A240",
    "Model": "A240"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "A250",
    "Device": "A250",
    "Model": "A250"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "A340",
    "Device": "A340",
    "Model": "A340"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "A345",
    "Device": "A345",
    "Model": "A345"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "A355",
    "Device": "A355",
    "Model": "A355"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "A360",
    "Device": "A360",
    "Model": "A360"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "A440",
    "Device": "A440",
    "Model": "A440"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "A455",
    "Device": "A455",
    "Model": "A455"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "A555",
    "Device": "A555",
    "Model": "A555"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "AL140",
    "Device": "AL140",
    "Model": "AL140"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "AL240",
    "Device": "AL240",
    "Model": "AL240"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "AL250",
    "Device": "AL250",
    "Model": "AL250"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "AL350",
    "Device": "AL350",
    "Model": "AL350"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "AS155",
    "Device": "AS155",
    "Model": "AS155"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "AS160",
    "Device": "AS160",
    "Model": "AS160"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "AS260",
    "Device": "AS260",
    "Model": "AS260"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "AS360",
    "Device": "AS360",
    "Model": "AS360"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "B11",
    "Device": "B11",
    "Model": "B11"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "B140",
    "Device": "B140",
    "Model": "B140"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "B155",
    "Device": "B155",
    "Model": "B155"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "B17",
    "Device": "B17",
    "Model": "B17"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "B18",
    "Device": "B18",
    "Model": "B18"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "B21",
    "Device": "B21",
    "Model": "B21"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "B245",
    "Device": "B245",
    "Model": "B245"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "B260",
    "Device": "B260",
    "Model": "B260"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "B27",
    "Device": "B27",
    "Model": "B27"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "B28",
    "Device": "B28",
    "Model": "B28"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "B31",
    "Device": "B31",
    "Model": "B31"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "B340",
    "Device": "B340",
    "Model": "B340"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "B350",
    "Device": "B350",
    "Model": "B350"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "B355",
    "Device": "B355",
    "Model": "B355"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "B38",
    "Device": "B38",
    "Model": "B38"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "B450",
    "Device": "B450",
    "Model": "B450"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "BL150",
    "Device": "BL150",
    "Model": "BL150"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "BL155",
    "Device": "BL155",
    "Model": "BL155"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "BL160",
    "Device": "BL160",
    "Model": "BL160"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "BL250",
    "Device": "BL250",
    "Model": "BL250"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "BL350",
    "Device": "BL350",
    "Model": "BL350"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "BS150",
    "Device": "BS150",
    "Model": "BS150"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "BS155",
    "Device": "BS155",
    "Model": "BS155"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "BS160",
    "Device": "BS160",
    "Model": "BS160"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "BS250",
    "Device": "BS250",
    "Model": "BS250"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "BS550",
    "Device": "BS550",
    "Model": "BS550"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "BS650",
    "Device": "BS650",
    "Model": "BS650"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "C18",
    "Device": "C18",
    "Model": "C18"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "C37",
    "Device": "C37",
    "Model": "C37"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "C38",
    "Device": "C38",
    "Model": "C38"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "D11",
    "Device": "D11",
    "Model": "D11"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "D21",
    "Device": "D21",
    "Model": "D21"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "DEXP B145",
    "Device": "B145",
    "Model": "B145"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "DEXP B255",
    "Device": "B255",
    "Model": "B255"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "DEXP G150",
    "Device": "G150",
    "Model": "G150"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "DEXP Ixion M850",
    "Device": "M850",
    "Model": "Ixion M850"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "DEXP Ixion X150",
    "Device": "Ixion_X150",
    "Model": "Ixion X150"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "DEXP Ixion_ES1050",
    "Device": "ES1050",
    "Model": "DEXP_ES1050"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "DEXP M110",
    "Device": "M110",
    "Model": "M110"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "DEXP M210",
    "Device": "M210",
    "Model": "M210"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "DEXP P170",
    "Device": "P170",
    "Model": "P170"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "DEXP S110",
    "Device": "S110",
    "Model": "S110"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "DEXP S380",
    "Device": "S380",
    "Model": "S380"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "DEXP Ursus N169",
    "Device": "N169",
    "Model": "N169"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "DEXP Ursus P310",
    "Device": "P310",
    "Model": "P310"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "DEXP Ursus S169",
    "Device": "S169",
    "Model": "S169"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "DEXP_B160",
    "Device": "B160",
    "Model": "B160"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "DNS_DEXP XL150 Project",
    "Device": "XL150",
    "Model": "XL150"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "Dexp Ursus P210",
    "Device": "P210",
    "Model": "P210"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "Dexp Ursus P380",
    "Device": "P380",
    "Model": "P380"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "Dexp Ursus S170i",
    "Device": "S170i",
    "Model": "S170i"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "Dexp Ursus S270",
    "Device": "S270",
    "Model": "S270"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "E110",
    "Device": "E110",
    "Model": "E110"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "E170",
    "Device": "E170",
    "Model": "E170"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "E180",
    "Device": "E180",
    "Model": "E180"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "E210",
    "Device": "E210",
    "Model": "E210"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "EL450",
    "Device": "EL450",
    "Model": "Ixion EL450"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "ERA",
    "Device": "G155",
    "Model": "G155"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "ERA",
    "Device": "MS550",
    "Model": "MS550"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "ES355",
    "Device": "ES355",
    "Model": "Ixion ES355"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "ES550",
    "Device": "ES550",
    "Model": "Ixion ES550"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "ES750",
    "Device": "ES750",
    "Model": "ES750"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "ES850",
    "Device": "ES850",
    "Model": "Ixion ES850"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "EX111",
    "Device": "EX111",
    "Model": "EX111"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "G250",
    "Device": "G250",
    "Model": "G250"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "G253",
    "Device": "G253",
    "Model": "G253"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "G255",
    "Device": "G255",
    "Model": "G255"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "G355",
    "Device": "G355",
    "Model": "G355"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "G450",
    "Device": "G450",
    "Model": "G450"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "G450 2021",
    "Device": "G450_2021",
    "Model": "G450 2021"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "G550",
    "Device": "G550",
    "Model": "G550"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "G660",
    "Device": "G660",
    "Model": "G660"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "GL255",
    "Device": "GL255",
    "Model": "GL255"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "GL355",
    "Device": "GL355",
    "Model": "GL355"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "GS150",
    "Device": "GS150",
    "Model": "GS150"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "GS153",
    "Device": "GS153",
    "Model": "GS153"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "GS155",
    "Device": "GS155",
    "Model": "GS155"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "H110",
    "Device": "H110",
    "Model": "H110"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "H170",
    "Device": "H170",
    "Model": "H170"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "H210",
    "Device": "H210",
    "Model": "H210"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "H270",
    "Device": "H270",
    "Model": "H270"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "H28",
    "Device": "H28",
    "Model": "H28"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "H310",
    "Device": "H310",
    "Model": "H310"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "H370",
    "Device": "H370",
    "Model": "H370"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "H410",
    "Device": "H410",
    "Model": "H410"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "Ixion M355",
    "Device": "M355",
    "Model": "Ixion M355"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "Ixion ML350",
    "Device": "ML350",
    "Model": "Ixion ML350"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "Ixion ML450",
    "Device": "ML450",
    "Model": "ML450"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "Ixion P350",
    "Device": "P350",
    "Model": "Ixion P350"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "K11",
    "Device": "K11",
    "Model": "K11"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "K17",
    "Device": "K17",
    "Model": "K17"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "K18",
    "Device": "K18",
    "Model": "K18"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "K21",
    "Device": "K21",
    "Model": "K21"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "K28",
    "Device": "K28",
    "Model": "K28"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "K28_",
    "Device": "K28_",
    "Model": "K28"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "K31",
    "Device": "K31",
    "Model": "K31"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "K31_",
    "Device": "K31_",
    "Model": "K31"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "K38",
    "Device": "K38",
    "Model": "K38"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "K41",
    "Device": "K41",
    "Model": "K41"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "K41_",
    "Device": "K41_",
    "Model": "K41"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "K48",
    "Device": "K48",
    "Model": "K48"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "K51",
    "Device": "K51",
    "Model": "K51"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "K61",
    "Device": "K61",
    "Model": "K61"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "L110",
    "Device": "L110",
    "Model": "L110"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "L170",
    "Device": "L170",
    "Model": "L170"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "L180",
    "Device": "L180",
    "Model": "L180"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "L210",
    "Device": "L210",
    "Model": "L210"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "L270",
    "Device": "L270",
    "Model": "L270"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "L310i",
    "Device": "L310i",
    "Model": "L310i"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "L370i",
    "Device": "L370i",
    "Model": "L370i"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "L470",
    "Device": "L470",
    "Model": "L470"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "M170",
    "Device": "M170",
    "Model": "M170"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "M340",
    "Device": "M340",
    "Model": "Ixion M340"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "M545",
    "Device": "M545",
    "Model": "Ixion M545"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "M750",
    "Device": "M750",
    "Model": "Ixion M750"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "ML245",
    "Device": "ML245",
    "Model": "Ixion ML245"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "MS650",
    "Device": "MS650",
    "Model": "MS650"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "N180i",
    "Device": "N180i",
    "Model": "N180i"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "N210",
    "Device": "N210",
    "Model": "N210"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "N280",
    "Device": "N280",
    "Model": "N280"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "N280i",
    "Device": "N280i",
    "Model": "N280i"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "N310",
    "Device": "N310",
    "Model": "N310"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "N370",
    "Device": "N370",
    "Model": "N370"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "N380i",
    "Device": "N380i",
    "Model": "N380i"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "N410",
    "Device": "N410",
    "Model": "N410"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "N470",
    "Device": "N470",
    "Model": "N470"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "N570",
    "Device": "N570",
    "Model": "N570"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "P11",
    "Device": "P11",
    "Model": "P11"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "P280",
    "Device": "P280",
    "Model": "P280"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "P380i",
    "Device": "P380i",
    "Model": "P380i"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "P410",
    "Device": "P410",
    "Model": "P410"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "P510",
    "Device": "P510",
    "Model": "P510"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "Q110",
    "Device": "Q110",
    "Model": "Q110"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "Q180",
    "Device": "Q180",
    "Model": "Q180"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "Q210",
    "Device": "Q210",
    "Model": "Q210"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "Q280",
    "Device": "Q280",
    "Model": "Q280"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "Q310",
    "Device": "Q310",
    "Model": "Q310"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "R110",
    "Device": "R110",
    "Model": "R110"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "R180",
    "Device": "R180",
    "Model": "R180"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "S180",
    "Device": "S180",
    "Model": "S180"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "S190",
    "Device": "S190",
    "Model": "S190"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "S270i",
    "Device": "S270i",
    "Model": "S270i"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "S280",
    "Device": "S280",
    "Model": "S280"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "S290",
    "Device": "S290",
    "Model": "S290"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "S370",
    "Device": "S370",
    "Model": "S370"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "S470",
    "Device": "S470",
    "Model": "S470"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "S570",
    "Device": "S570",
    "Model": "S570"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "S670",
    "Device": "S670",
    "Model": "S670"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "S770",
    "Device": "S770",
    "Model": "S770"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "S770i",
    "Device": "S770i",
    "Model": "S770i"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "Senior",
    "Device": "SENIOR",
    "Model": "SENIOR"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "T155",
    "Device": "T155",
    "Model": "T155"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "T21",
    "Device": "T21",
    "Model": "T21"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "URSUS S180i",
    "Device": "S180i",
    "Model": "S180i"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "VA110",
    "Device": "VA110",
    "Model": "VA110"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "VA170",
    "Device": "VA170",
    "Model": "VA170"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "VA210",
    "Device": "VA210",
    "Model": "VA210"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "XL155",
    "Device": "XL155",
    "Model": "Ixion XL155"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "Z150",
    "Device": "Z150",
    "Model": "Z150"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "Z155",
    "Device": "Z155",
    "Model": "Z155"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "Z250",
    "Device": "Z250",
    "Model": "Z250"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "Z255",
    "Device": "Z255",
    "Model": "Z255"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "Z355",
    "Device": "Z355",
    "Model": "Z355"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "Z455",
    "Device": "Z455",
    "Model": "Z455"
  },
  {
    "Retail Branding": "DEXP",
    "Marketing Name": "lxion MS255",
    "Device": "MS255",
    "Model": "Ixion MS255"
  },
  {
    "Retail Branding": "DEYI",
    "Marketing Name": "DEYI-10M18",
    "Device": "DEYI-10M18",
    "Model": "DEYI-10M18"
  },
  {
    "Retail Branding": "DEYI",
    "Marketing Name": "DEYI10M18",
    "Device": "DEYI10M18A53",
    "Model": "DEYI10M18A53"
  },
  {
    "Retail Branding": "DEZLTID",
    "Marketing Name": "M128",
    "Device": "M128",
    "Model": "M128"
  },
  {
    "Retail Branding": "DGTEC",
    "Marketing Name": "11_inch_tablet",
    "Device": "11_inch_tablet",
    "Model": "DG11PROGN"
  },
  {
    "Retail Branding": "DGTEC",
    "Marketing Name": "DG101HSTB",
    "Device": "DG101HSTB",
    "Model": "DG101HSTB"
  },
  {
    "Retail Branding": "DGTEC",
    "Marketing Name": "DG101SVCB",
    "Device": "DG101SVCB",
    "Model": "DG101SVCB"
  },
  {
    "Retail Branding": "DGTEC",
    "Marketing Name": "DG101TBIPS",
    "Device": "DG101TBIPS",
    "Model": "DG101TBIPS"
  },
  {
    "Retail Branding": "DGTEC",
    "Marketing Name": "DG101TBLS",
    "Device": "DG101TBLS",
    "Model": "DG101TBLS"
  },
  {
    "Retail Branding": "DGTEC",
    "Marketing Name": "DG7TBIPSBT",
    "Device": "DG7TBIPSBT",
    "Model": "DG7TBIPSBT"
  },
  {
    "Retail Branding": "DGTEC",
    "Marketing Name": "DG7TBIPSDG",
    "Device": "DG7TBIPSDG",
    "Model": "DG7TBIPSDG"
  },
  {
    "Retail Branding": "DGTEC",
    "Marketing Name": "DG7TBIPSG",
    "Device": "DG7TBIPSG",
    "Model": "DG7TBIPSG"
  },
  {
    "Retail Branding": "DGTEC",
    "Marketing Name": "DG7TBIPSPA",
    "Device": "DG7TBIPSPA",
    "Model": "DG7TBIPSPA"
  },
  {
    "Retail Branding": "DGTEC",
    "Marketing Name": "DGIPS7",
    "Device": "DGIPS7",
    "Model": "DGIPS7"
  },
  {
    "Retail Branding": "DGTEC",
    "Marketing Name": "Dg_1522",
    "Device": "Dg_1522",
    "Model": "Dg_1522"
  },
  {
    "Retail Branding": "DGTEC",
    "Marketing Name": "Dg_1523",
    "Device": "Dg_1523",
    "Model": "Dg_1523"
  },
  {
    "Retail Branding": "DGTEC",
    "Marketing Name": "Dg_1524",
    "Device": "Dg_1524",
    "Model": "Dg_1524"
  },
  {
    "Retail Branding": "DIADEM",
    "Marketing Name": "CUTE_5",
    "Device": "CUTE_5",
    "Model": "CUTE 5"
  },
  {
    "Retail Branding": "DIALN",
    "Marketing Name": "G10",
    "Device": "G10",
    "Model": "G10"
  },
  {
    "Retail Branding": "DIALN",
    "Marketing Name": "G65",
    "Device": "G65",
    "Model": "G65"
  },
  {
    "Retail Branding": "DIALN",
    "Marketing Name": "G68",
    "Device": "G68",
    "Model": "G68"
  },
  {
    "Retail Branding": "DIALN",
    "Marketing Name": "NEO2024",
    "Device": "NEO2024",
    "Model": "NEO2024"
  },
  {
    "Retail Branding": "DIALN",
    "Marketing Name": "NOVA2024",
    "Device": "NOVA2024",
    "Model": "NOVA2024"
  },
  {
    "Retail Branding": "DIALN",
    "Marketing Name": "Neo",
    "Device": "Neo",
    "Model": "Neo"
  },
  {
    "Retail Branding": "DIALN",
    "Marketing Name": "Neo",
    "Device": "NeoA",
    "Model": "Neo"
  },
  {
    "Retail Branding": "DIALN",
    "Marketing Name": "Nova",
    "Device": "Nova",
    "Model": "Nova"
  },
  {
    "Retail Branding": "DIALN",
    "Marketing Name": "Nova",
    "Device": "NovaA",
    "Model": "Nova"
  },
  {
    "Retail Branding": "DIALN",
    "Marketing Name": "S10",
    "Device": "S10",
    "Model": "S10"
  },
  {
    "Retail Branding": "DIALN",
    "Marketing Name": "S8",
    "Device": "S8",
    "Model": "S8"
  },
  {
    "Retail Branding": "DIALN",
    "Marketing Name": "X10 Pulse",
    "Device": "X10_Pulse",
    "Model": "X10 Pulse"
  },
  {
    "Retail Branding": "DIALN",
    "Marketing Name": "X10G",
    "Device": "X10G",
    "Model": "X10G"
  },
  {
    "Retail Branding": "DIALN",
    "Marketing Name": "X10ULTRA",
    "Device": "X10ULTRA",
    "Model": "X10ULTRA"
  },
  {
    "Retail Branding": "DIALN",
    "Marketing Name": "X62",
    "Device": "X62",
    "Model": "X62"
  },
  {
    "Retail Branding": "DIALN",
    "Marketing Name": "X62",
    "Device": "X62A",
    "Model": "X62"
  },
  {
    "Retail Branding": "DIALN",
    "Marketing Name": "X62",
    "Device": "X62B",
    "Model": "X62"
  },
  {
    "Retail Branding": "DIALN",
    "Marketing Name": "X62",
    "Device": "X62C",
    "Model": "X62"
  },
  {
    "Retail Branding": "DIALN",
    "Marketing Name": "X62S",
    "Device": "X62S",
    "Model": "X62S"
  },
  {
    "Retail Branding": "DIALN",
    "Marketing Name": "X65",
    "Device": "X65",
    "Model": "X65"
  },
  {
    "Retail Branding": "DIALN",
    "Marketing Name": "X65",
    "Device": "X65A",
    "Model": "X65"
  },
  {
    "Retail Branding": "DIALN",
    "Marketing Name": "X65",
    "Device": "X65B",
    "Model": "X65"
  },
  {
    "Retail Branding": "DIALN",
    "Marketing Name": "X65",
    "Device": "X65C",
    "Model": "X65"
  },
  {
    "Retail Branding": "DIALN",
    "Marketing Name": "X68",
    "Device": "X68",
    "Model": "X68"
  },
  {
    "Retail Branding": "DIALN",
    "Marketing Name": "X68",
    "Device": "X68B",
    "Model": "X68"
  },
  {
    "Retail Branding": "DIALN",
    "Marketing Name": "X8G",
    "Device": "X8G",
    "Model": "X8G"
  },
  {
    "Retail Branding": "DIALN",
    "Marketing Name": "X8PRO",
    "Device": "X8PRO",
    "Model": "X8 PRO"
  },
  {
    "Retail Branding": "DIALN",
    "Marketing Name": "X8ULTRA",
    "Device": "X8ULTRA",
    "Model": "X8ULTRA"
  },
  {
    "Retail Branding": "DIAMANT",
    "Marketing Name": "EU",
    "Device": "tamachi",
    "Model": "DIAMANT Android TV"
  },
  {
    "Retail Branding": "DIAMANT",
    "Marketing Name": "EU",
    "Device": "yeongdeungpo",
    "Model": "DIAMANT Android TV"
  },
  {
    "Retail Branding": "DIDIK",
    "Marketing Name": "DT24Plus",
    "Device": "DT24Plus",
    "Model": "DT24Plus"
  },
  {
    "Retail Branding": "DIDIK_TAB",
    "Marketing Name": "DT24",
    "Device": "DT24",
    "Model": "DT24"
  },
  {
    "Retail Branding": "DIFRNCE",
    "Marketing Name": "DIT702201",
    "Device": "DIT702201",
    "Model": "NID_7010"
  },
  {
    "Retail Branding": "DIGMA_PRO",
    "Marketing Name": "Edge TA2D1M01",
    "Device": "TA2D1M01",
    "Model": "Edge TA2D1M01"
  },
  {
    "Retail Branding": "DIGMA_PRO",
    "Marketing Name": "Edge TA3D1M01",
    "Device": "TA3D1M01",
    "Model": "Edge TA3D1M01"
  },
  {
    "Retail Branding": "DIGMA_PRO",
    "Marketing Name": "Edge TA3E1M01",
    "Device": "TA3E1M01",
    "Model": "Edge TA3E1M01"
  },
  {
    "Retail Branding": "DIGMA_PRO",
    "Marketing Name": "K16_EEA",
    "Device": "K16_EEA",
    "Model": "K16_EEA"
  },
  {
    "Retail Branding": "DIGMA_PRO",
    "Marketing Name": "Pulse",
    "Device": "Pulse",
    "Model": "Pulse"
  },
  {
    "Retail Branding": "DIGMA_PRO",
    "Marketing Name": "TA2D5P02",
    "Device": "Wave_TA2D5P02",
    "Model": "Wave TA2D5P02"
  },
  {
    "Retail Branding": "DIGMA_PRO",
    "Marketing Name": "TA2D5P02",
    "Device": "Wave_TA2D5P02",
    "Model": "Wave TAXX5P0X"
  },
  {
    "Retail Branding": "DIGMA_PRO",
    "Marketing Name": "TA3E2M03",
    "Device": "TA3E2M03",
    "Model": "Evolution TA3E2M03"
  },
  {
    "Retail Branding": "DIGMA_PRO",
    "Marketing Name": "Zenith_II",
    "Device": "TAXX1P0X",
    "Model": "Zenith II TAXX1P0X"
  },
  {
    "Retail Branding": "DIGMA_PRO",
    "Marketing Name": "Zoom_II",
    "Device": "TAXX0P0X",
    "Model": "Zoom II TAXX0P0X"
  },
  {
    "Retail Branding": "DIJITSU",
    "Marketing Name": "DCT 90",
    "Device": "DCT_90",
    "Model": "DCT 90"
  },
  {
    "Retail Branding": "DIJITSU",
    "Marketing Name": "DIJITSU",
    "Device": "hongkong",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "DIJITSU",
    "Marketing Name": "DIJITSU",
    "Device": "mountbaker",
    "Model": "2K SMART TV"
  },
  {
    "Retail Branding": "DIJITSU",
    "Marketing Name": "Smart A11s",
    "Device": "Smart_A11s",
    "Model": "DIJITSU_Smart_A11s"
  },
  {
    "Retail Branding": "DIMENSIONS",
    "Marketing Name": "DISHM7863",
    "Device": "DISHM7863",
    "Model": "DISHM7863"
  },
  {
    "Retail Branding": "DIRECTV",
    "Marketing Name": "DIRECTV",
    "Device": "c71kw400-4gb",
    "Model": "AT&T TV"
  },
  {
    "Retail Branding": "DIRECTV",
    "Marketing Name": "DIRECTV",
    "Device": "c71kw400-BEAM",
    "Model": "AT&T TV"
  },
  {
    "Retail Branding": "DIRECTV",
    "Marketing Name": "DIRECTV STREAM",
    "Device": "c71kw200",
    "Model": "AT&T TV"
  },
  {
    "Retail Branding": "DIRECTV",
    "Marketing Name": "DIRECTV STREAM",
    "Device": "c71kw200",
    "Model": "c71kw200"
  },
  {
    "Retail Branding": "DIRECTV",
    "Marketing Name": "DIRECTV STREAM",
    "Device": "c71kw400",
    "Model": "AT&T TV"
  },
  {
    "Retail Branding": "DIRECTV",
    "Marketing Name": "LK02",
    "Device": "HYS0A",
    "Model": "LK02"
  },
  {
    "Retail Branding": "DIRECTV",
    "Marketing Name": "OTT-01",
    "Device": "HP40A",
    "Model": "OTT-01"
  },
  {
    "Retail Branding": "DIRECTV",
    "Marketing Name": "Pendant",
    "Device": "p21kw500",
    "Model": "Pendant"
  },
  {
    "Retail Branding": "DIZOPRO",
    "Marketing Name": "KGZ_PRO",
    "Device": "K10",
    "Model": "K10"
  },
  {
    "Retail Branding": "DL",
    "Marketing Name": 3406,
    "Device": "G02DL",
    "Model": "Tablet DL 3406"
  },
  {
    "Retail Branding": "DL",
    "Marketing Name": 3420,
    "Device": "Tablet_DL_3420",
    "Model": "Tablet DL 3420"
  },
  {
    "Retail Branding": "DL",
    "Marketing Name": 3420,
    "Device": "Tablet_DL_3420",
    "Model": "Tablet_DL_3420"
  },
  {
    "Retail Branding": "DL",
    "Marketing Name": 3903,
    "Device": "Tablet_DL_3903",
    "Model": "Tablet_DL_3903"
  },
  {
    "Retail Branding": "DL",
    "Marketing Name": "Creative Kids",
    "Device": "Tablet_DL_3721",
    "Model": "Tablet_DL_3721"
  },
  {
    "Retail Branding": "DL",
    "Marketing Name": "Creative Tab",
    "Device": "Tablet_DL_3723",
    "Model": "Tablet_DL_3723"
  },
  {
    "Retail Branding": "DL",
    "Marketing Name": "Creative kids",
    "Device": "Tablet_DL_3725",
    "Model": "Tablet_DL_3725"
  },
  {
    "Retail Branding": "DL",
    "Marketing Name": "DL3920",
    "Device": "Tablet_DL_3920",
    "Model": "Tablet_DL_3920"
  },
  {
    "Retail Branding": "DL",
    "Marketing Name": "Horizon H8",
    "Device": "DL_Horizon_H8",
    "Model": "Smartphone DL Horizon H8"
  },
  {
    "Retail Branding": "DL",
    "Marketing Name": "Horizon Tab T10",
    "Device": "Tablet_DL_4010",
    "Model": "Tablet_DL_4010"
  },
  {
    "Retail Branding": "DL",
    "Marketing Name": "Mobi Tab",
    "Device": "Tablet_DL_2810",
    "Model": "Tablet_DL_2810"
  },
  {
    "Retail Branding": "DL",
    "Marketing Name": "Mobi Tab",
    "Device": "Tablet_DL_2811",
    "Model": "Tablet_DL_2811"
  },
  {
    "Retail Branding": "DL",
    "Marketing Name": "Sabichões",
    "Device": "Tablet_DL_3722",
    "Model": "Tablet_DL_3722"
  },
  {
    "Retail Branding": "DL",
    "Marketing Name": "Smartphone DL Horizon Selfie",
    "Device": "DL_Horizon_Selfie",
    "Model": "DL_Horizon_Selfie"
  },
  {
    "Retail Branding": "DL",
    "Marketing Name": "TabFácil",
    "Device": "Tablet_DL_2820",
    "Model": "Tablet_DL_2820"
  },
  {
    "Retail Branding": "DL",
    "Marketing Name": "TabKids Plus",
    "Device": "TabKids_Plus",
    "Model": "Tablet DL 3411"
  },
  {
    "Retail Branding": "DL",
    "Marketing Name": "TabPhone 710 pro",
    "Device": "Tablet_DL_3421",
    "Model": "Tablet DL 3421"
  },
  {
    "Retail Branding": "DL",
    "Marketing Name": "Tablet_DL_3724",
    "Device": "Tablet_DL_3724",
    "Model": "Tablet_DL_3724"
  },
  {
    "Retail Branding": "DL",
    "Marketing Name": "X_Quad_Pro",
    "Device": "X_Quad_Pro",
    "Model": "Tablet DL 3410"
  },
  {
    "Retail Branding": "DL",
    "Marketing Name": "YZU_DS53",
    "Device": "Smartphone_YZU_DS53",
    "Model": "Smartphone_YZU_DS53"
  },
  {
    "Retail Branding": "DL",
    "Marketing Name": "i-Player_KIDS",
    "Device": "Tablet_DL_3910",
    "Model": "Tablet_DL_3910"
  },
  {
    "Retail Branding": "DMOAO",
    "Marketing Name": "D11_EEA",
    "Device": "D11_EEA",
    "Model": "D11_EEA"
  },
  {
    "Retail Branding": "DMOAO",
    "Marketing Name": "D2_EEA",
    "Device": "D2_EEA",
    "Model": "D2_EEA"
  },
  {
    "Retail Branding": "DMOAO",
    "Marketing Name": "D2_US",
    "Device": "D2_US",
    "Model": "D2_US"
  },
  {
    "Retail Branding": "DMOAO",
    "Marketing Name": "D3_EEA",
    "Device": "D3_EEA",
    "Model": "D3_EEA"
  },
  {
    "Retail Branding": "DMOAO",
    "Marketing Name": "D3_EU",
    "Device": "D3_EU",
    "Model": "D3_EU"
  },
  {
    "Retail Branding": "DMOAO",
    "Marketing Name": "D3_US",
    "Device": "D3_US",
    "Model": "D3_US"
  },
  {
    "Retail Branding": "DMOAO",
    "Marketing Name": "D3_V_EEA",
    "Device": "D3_V_EEA",
    "Model": "D3_V_EEA"
  },
  {
    "Retail Branding": "DMOAO",
    "Marketing Name": "D3_V_US",
    "Device": "D3_V_US",
    "Model": "D3_V_US"
  },
  {
    "Retail Branding": "DMOAO",
    "Marketing Name": "D5-EEA",
    "Device": "D5-EEA",
    "Model": "D5-EEA"
  },
  {
    "Retail Branding": "DMOAO",
    "Marketing Name": "D5-EU",
    "Device": "D5-EU",
    "Model": "D5-EU"
  },
  {
    "Retail Branding": "DMOAO",
    "Marketing Name": "D5-T-EEA",
    "Device": "D5-T-EEA",
    "Model": "D5-T-EEA"
  },
  {
    "Retail Branding": "DMOAO",
    "Marketing Name": "D5-T-EEA",
    "Device": "D5-T-EEA",
    "Model": "Z19"
  },
  {
    "Retail Branding": "DMOAO",
    "Marketing Name": "D5-T-US",
    "Device": "D5-T-US",
    "Model": "D5-T-US"
  },
  {
    "Retail Branding": "DMOAO",
    "Marketing Name": "D5-US",
    "Device": "D5-US",
    "Model": "D5-US"
  },
  {
    "Retail Branding": "DMOAO",
    "Marketing Name": "D5_EEA",
    "Device": "D5_EEA",
    "Model": "D5_EEA"
  },
  {
    "Retail Branding": "DMOAO",
    "Marketing Name": "D5_US",
    "Device": "D5_US",
    "Model": "D5_US"
  },
  {
    "Retail Branding": "DMOAO",
    "Marketing Name": "D6_EEA",
    "Device": "D6_EEA",
    "Model": "D6_EEA"
  },
  {
    "Retail Branding": "DMOAO",
    "Marketing Name": "D6_US",
    "Device": "D6_US",
    "Model": "D6_US"
  },
  {
    "Retail Branding": "DMOAO",
    "Marketing Name": "D7_EEA",
    "Device": "D7_EEA",
    "Model": "D7_EEA"
  },
  {
    "Retail Branding": "DMOAO",
    "Marketing Name": "D7_US",
    "Device": "D7_US",
    "Model": "D7_US"
  },
  {
    "Retail Branding": "DMOAO",
    "Marketing Name": "DMOAO_D2_EEA",
    "Device": "DMOAO_D2_EEA",
    "Model": "DMOAO_D2_EEA"
  },
  {
    "Retail Branding": "DMOAO",
    "Marketing Name": "DMOAO_D2_US",
    "Device": "DMOAO_D2_US",
    "Model": "DMOAO_D2_US"
  },
  {
    "Retail Branding": "DNA",
    "Marketing Name": "DNA",
    "Device": "dctiw384",
    "Model": "DNA Android TV"
  },
  {
    "Retail Branding": "DNA",
    "Marketing Name": "DNA Hubi 2.0",
    "Device": "m393gena",
    "Model": "DNA Hubi 2.0"
  },
  {
    "Retail Branding": "DNA",
    "Marketing Name": "DNA Hubi Soundbox",
    "Device": "m393vsb_dna",
    "Model": "DNA Hubi Soundbox"
  },
  {
    "Retail Branding": "DNA",
    "Marketing Name": "DNA TV-hubi",
    "Device": "dctiw384",
    "Model": "DNA Android TV"
  },
  {
    "Retail Branding": "DNS:NET",
    "Marketing Name": "DNSNETB866VW",
    "Device": "DNSNETB866VW",
    "Model": "DNSNETB866VW"
  },
  {
    "Retail Branding": "DO Mobile",
    "Marketing Name": "DO_Mate2",
    "Device": "Mate2",
    "Model": "Mate2"
  },
  {
    "Retail Branding": "DO Mobile",
    "Marketing Name": "Mate1",
    "Device": "Mate1",
    "Model": "DO_S1"
  },
  {
    "Retail Branding": "DO Mobile",
    "Marketing Name": "Mate1",
    "Device": "Mate1",
    "Model": "Mate1"
  },
  {
    "Retail Branding": "DO Mobile",
    "Marketing Name": "Mate6 Pro",
    "Device": "Mate6_Pro",
    "Model": "Mate6 Pro"
  },
  {
    "Retail Branding": "DO Mobile",
    "Marketing Name": "S10_Plus",
    "Device": "S10_Plus",
    "Model": "S10_Plus"
  },
  {
    "Retail Branding": "DOEL",
    "Marketing Name": "TT 7.0",
    "Device": "TT_7_0",
    "Model": "TT 7.0"
  },
  {
    "Retail Branding": "DOMATON",
    "Marketing Name": "D102",
    "Device": "D102",
    "Model": "D102"
  },
  {
    "Retail Branding": "DOMATON",
    "Marketing Name": "D103",
    "Device": "D103",
    "Model": "D103"
  },
  {
    "Retail Branding": "DOMATON",
    "Marketing Name": "D718",
    "Device": "D718",
    "Model": "D718"
  },
  {
    "Retail Branding": "DOMATON",
    "Marketing Name": "K111",
    "Device": "K111",
    "Model": "K111"
  },
  {
    "Retail Branding": "DOMATON",
    "Marketing Name": "K712",
    "Device": "K712",
    "Model": "K712"
  },
  {
    "Retail Branding": "DOMATON",
    "Marketing Name": "MID_1099IPS",
    "Device": "MID_1099IPS",
    "Model": "MID_1099IPS"
  },
  {
    "Retail Branding": "DOMATON",
    "Marketing Name": "Ocean_K10",
    "Device": "Ocean_K10",
    "Model": "Ocean K10"
  },
  {
    "Retail Branding": "DOMO",
    "Marketing Name": "M90",
    "Device": "M90",
    "Model": "M90"
  },
  {
    "Retail Branding": "DOMO",
    "Marketing Name": "Slate_F11",
    "Device": "Slate_F11",
    "Model": "F11"
  },
  {
    "Retail Branding": "DOMO",
    "Marketing Name": "VT502A",
    "Device": "VT502A",
    "Model": "VT502A"
  },
  {
    "Retail Branding": "DORA",
    "Marketing Name": "Android TV",
    "Device": "R1",
    "Model": "ATV R1"
  },
  {
    "Retail Branding": "DORA",
    "Marketing Name": "Android TV",
    "Device": "R2",
    "Model": "ATV R2"
  },
  {
    "Retail Branding": "DORA",
    "Marketing Name": "Smart TV",
    "Device": "longshan",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "DORA",
    "Marketing Name": "Smart TV",
    "Device": "redwood",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "DOUNDY",
    "Marketing Name": "DA10",
    "Device": "DA10",
    "Model": "DA10"
  },
  {
    "Retail Branding": "DOUNDY",
    "Marketing Name": "DH10XS",
    "Device": "DH10XS",
    "Model": "DH10Kids"
  },
  {
    "Retail Branding": "DOUNDY",
    "Marketing Name": "DH10XS",
    "Device": "DH10XS",
    "Model": "DH10XS"
  },
  {
    "Retail Branding": "DOUNDY",
    "Marketing Name": "DK10",
    "Device": "rk3562_ugo",
    "Model": "DK10"
  },
  {
    "Retail Branding": "DPIN",
    "Marketing Name": "DPIN ONE",
    "Device": "DPIN_ONE",
    "Model": "W051"
  },
  {
    "Retail Branding": "DPSTec",
    "Marketing Name": "DKM651_4G",
    "Device": "DKM651_4G",
    "Model": "DKM651-4G"
  },
  {
    "Retail Branding": "DPSTec",
    "Marketing Name": "DTB",
    "Device": "DTB",
    "Model": "DTB"
  },
  {
    "Retail Branding": "DREAMTECH",
    "Marketing Name": "DTECH10",
    "Device": "DTECH10",
    "Model": "DTECH10"
  },
  {
    "Retail Branding": "DREAMTECH",
    "Marketing Name": "KIDDOTAB10",
    "Device": "KIDDOTAB10",
    "Model": "KIDDOTAB10"
  },
  {
    "Retail Branding": "DREAMTECH",
    "Marketing Name": "KIDDOTAB8",
    "Device": "KIDDOTAB8",
    "Model": "KIDDOTAB8"
  },
  {
    "Retail Branding": "DREAMTECH",
    "Marketing Name": "STARPAD",
    "Device": "STARPAD",
    "Model": "STARPAD"
  },
  {
    "Retail Branding": "DREAMTECH",
    "Marketing Name": "STARPAD_PLUS",
    "Device": "STARPAD_PLUS",
    "Model": "STARPAD PLUS"
  },
  {
    "Retail Branding": "DREAMTECH",
    "Marketing Name": "VOLTA_X",
    "Device": "VOLTA_X",
    "Model": "VOLTA X"
  },
  {
    "Retail Branding": "DSIC",
    "Marketing Name": "Mobilebase DS50",
    "Device": "DS50",
    "Model": "DS50"
  },
  {
    "Retail Branding": "DSIC",
    "Marketing Name": "Mobilebase DS6",
    "Device": "ds6",
    "Model": "DS6"
  },
  {
    "Retail Branding": "DSIC",
    "Marketing Name": "Mobilebase DS60S",
    "Device": "DS60S",
    "Model": "DS60S"
  },
  {
    "Retail Branding": "DSIC",
    "Marketing Name": "RD86QE",
    "Device": "RD86QE",
    "Model": "RD86QE"
  },
  {
    "Retail Branding": "DSPREAD",
    "Marketing Name": "F6",
    "Device": "F6",
    "Model": "F6"
  },
  {
    "Retail Branding": "DSTechnology",
    "Marketing Name": "MATE ONE",
    "Device": "MO_Pro",
    "Model": "MO_Series"
  },
  {
    "Retail Branding": "DTAB",
    "Marketing Name": "TK-P617_3.3Ghz",
    "Device": "TK_P617_3_3Ghz",
    "Model": "TK_P617_3_3Ghz"
  },
  {
    "Retail Branding": "DTAB",
    "Marketing Name": "TK_P617_3_3Ghz",
    "Device": "TK_P617_3_3Ghz",
    "Model": "TK_P617_3_3Ghz"
  },
  {
    "Retail Branding": "DTC products",
    "Marketing Name": "S10",
    "Device": "S10",
    "Model": "S10"
  },
  {
    "Retail Branding": "DTC products",
    "Marketing Name": "S30",
    "Device": "S30",
    "Model": "S30"
  },
  {
    "Retail Branding": "DTResearch",
    "Marketing Name": "DA323EO",
    "Device": "DA300EX",
    "Model": "DA300EX"
  },
  {
    "Retail Branding": "DTResearch",
    "Marketing Name": "DA323EO",
    "Device": "DA300EX",
    "Model": "DA323EO"
  },
  {
    "Retail Branding": "DTV (Thai)",
    "Marketing Name": "P3",
    "Device": "Digital_Life_P3",
    "Model": "P3"
  },
  {
    "Retail Branding": "DUNHOO",
    "Marketing Name": "UPad2",
    "Device": "UPad2",
    "Model": "UPad2"
  },
  {
    "Retail Branding": "DUNN",
    "Marketing Name": "QT 808",
    "Device": "DUNNQT",
    "Model": "QT 808"
  },
  {
    "Retail Branding": "DUODUOGO",
    "Marketing Name": "10 Plus",
    "Device": "10_Plus",
    "Model": "10 Plus"
  },
  {
    "Retail Branding": "DUODUOGO",
    "Marketing Name": "S10",
    "Device": "S10",
    "Model": "S10"
  },
  {
    "Retail Branding": "DUODUOGO",
    "Marketing Name": "S10_EEA",
    "Device": "S10_EEA",
    "Model": "S10_EEA"
  },
  {
    "Retail Branding": "DUODUOGO",
    "Marketing Name": "S30",
    "Device": "S30",
    "Model": "S30"
  },
  {
    "Retail Branding": "DUODUOGO",
    "Marketing Name": "S7_EEA",
    "Device": "S7_EEA",
    "Model": "S7_EEA"
  },
  {
    "Retail Branding": "DUODUOGO",
    "Marketing Name": "S8",
    "Device": "S8",
    "Model": "S8"
  },
  {
    "Retail Branding": "DUODUOGO",
    "Marketing Name": "TAB_A7_US",
    "Device": "TAB_A7_US",
    "Model": "TAB_A7_US"
  },
  {
    "Retail Branding": "DUODUOGO",
    "Marketing Name": "TAB_S2",
    "Device": "TAB_S2",
    "Model": "TAB_S2"
  },
  {
    "Retail Branding": "DUODUOGO",
    "Marketing Name": "TAB_S2_EEA",
    "Device": "TAB_S2_EEA",
    "Model": "TAB_S2_EEA"
  },
  {
    "Retail Branding": "DUODUOGO",
    "Marketing Name": "Tab_A7",
    "Device": "Tab_A7",
    "Model": "Tab_A7"
  },
  {
    "Retail Branding": "DUODUOGO",
    "Marketing Name": "Tablet-P8_A",
    "Device": "Tablet-P8_A",
    "Model": "Tablet-P8_A"
  },
  {
    "Retail Branding": "DUODUOGO",
    "Marketing Name": "Tablet-P8_EEA",
    "Device": "Tablet-P8_EEA",
    "Model": "Tablet-P8_EEA"
  },
  {
    "Retail Branding": "Daehap",
    "Marketing Name": "DH-B301K",
    "Device": "DH-B301K",
    "Model": "DH-B301K"
  },
  {
    "Retail Branding": "Daelim_System",
    "Marketing Name": "Daelim System_IFPD",
    "Device": "Daelim_System_RK3588",
    "Model": "ULTRA_DS11386"
  },
  {
    "Retail Branding": "Daewoo",
    "Marketing Name": "4K Smart TV",
    "Device": "pioneer",
    "Model": "4K SA Smart TV"
  },
  {
    "Retail Branding": "Daewoo",
    "Marketing Name": "4K Smart TV",
    "Device": "pioneer",
    "Model": "DAEWOO 4K SA Smart TV"
  },
  {
    "Retail Branding": "Daewoo",
    "Marketing Name": "AI SMART TV",
    "Device": "beomil",
    "Model": "AI SMART TV"
  },
  {
    "Retail Branding": "Daewoo",
    "Marketing Name": "AI SMART TV",
    "Device": "eleonas",
    "Model": "AI SMART TV"
  },
  {
    "Retail Branding": "Daewoo",
    "Marketing Name": "DAEWOO",
    "Device": "hongkong",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "Daewoo",
    "Marketing Name": "DAEWOO",
    "Device": "lavender",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "Daewoo",
    "Marketing Name": "DAEWOO",
    "Device": "mountbaker",
    "Model": "2K SMART TV"
  },
  {
    "Retail Branding": "Daewoo",
    "Marketing Name": "DAEWOO",
    "Device": "mountbaker",
    "Model": "DAEWOO SMART TV"
  },
  {
    "Retail Branding": "Daewoo",
    "Marketing Name": "DAEWOO AI SMART TV",
    "Device": "beomil",
    "Model": "DAEWOO AI SMART TV"
  },
  {
    "Retail Branding": "Daewoo",
    "Marketing Name": "DAEWOO AI SMART TV",
    "Device": "eleonas",
    "Model": "DAEWOO AI SMART TV"
  },
  {
    "Retail Branding": "Daewoo",
    "Marketing Name": "DAEWOO SMART TV",
    "Device": "SW6H",
    "Model": "DAEWOO SMART TV"
  },
  {
    "Retail Branding": "Daewoo",
    "Marketing Name": "DAEWOO SMART TV",
    "Device": "eleonas",
    "Model": "DAEWOO SMART TV"
  },
  {
    "Retail Branding": "Daewoo",
    "Marketing Name": "DAEWOO SMART TV",
    "Device": "sunnyvale",
    "Model": "DAEWOO SMART TV"
  },
  {
    "Retail Branding": "Daewoo",
    "Marketing Name": "DAEWOO SMART TV WF",
    "Device": "SW6H",
    "Model": "DAEWOO SMART TV WF"
  },
  {
    "Retail Branding": "Daewoo",
    "Marketing Name": "DW-TN7RK16",
    "Device": "DW-TN7RK16",
    "Model": "DW-TN7RK16"
  },
  {
    "Retail Branding": "Daewoo",
    "Marketing Name": "Daewoo 4K TV",
    "Device": "SW4H_FF",
    "Model": "Daewoo 4K TV"
  },
  {
    "Retail Branding": "Daewoo",
    "Marketing Name": "Neon",
    "Device": "Neon",
    "Model": "Neon"
  },
  {
    "Retail Branding": "Daewoo",
    "Marketing Name": "Smart TV",
    "Device": "alimos",
    "Model": "DAEWOO Google TV"
  },
  {
    "Retail Branding": "Daewoo",
    "Marketing Name": "Smart TV",
    "Device": "dangni",
    "Model": "DAEWOO Google TV"
  },
  {
    "Retail Branding": "Daewoo",
    "Marketing Name": "Smart TV",
    "Device": "mateo",
    "Model": "2K SA Smart TV"
  },
  {
    "Retail Branding": "Daewoo",
    "Marketing Name": "Smart TV",
    "Device": "mateo",
    "Model": "DAEWOO 2K SA Smart TV"
  },
  {
    "Retail Branding": "Daewoo",
    "Marketing Name": "Smart TV",
    "Device": "osaka",
    "Model": "AI PONT SA"
  },
  {
    "Retail Branding": "Daewoo",
    "Marketing Name": "X7",
    "Device": "X7",
    "Model": "X7"
  },
  {
    "Retail Branding": "Daewoo",
    "Marketing Name": "X9",
    "Device": "X9",
    "Model": "X9"
  },
  {
    "Retail Branding": "Dafeng Media Group",
    "Marketing Name": "D1",
    "Device": "DADA_1319D",
    "Model": "DADA1319D"
  },
  {
    "Retail Branding": "Dahl Sweden",
    "Marketing Name": "People Plus",
    "Device": "People_Plus",
    "Model": "People_Plus"
  },
  {
    "Retail Branding": "Dahua",
    "Marketing Name": "DAHUA",
    "Device": "elliniko",
    "Model": "4K SA SMART TV"
  },
  {
    "Retail Branding": "Dahua",
    "Marketing Name": "DAHUA",
    "Device": "elliniko",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "Dahua",
    "Marketing Name": "DAHUA",
    "Device": "hongkong",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "Dahua",
    "Marketing Name": "DAHUA",
    "Device": "hongkong",
    "Model": "EcoTV Plus A"
  },
  {
    "Retail Branding": "Dahua",
    "Marketing Name": "DAHUA",
    "Device": "mountbaker",
    "Model": "2K SMART TV"
  },
  {
    "Retail Branding": "Dahua",
    "Marketing Name": "DAHUA",
    "Device": "mountbaker",
    "Model": "EcoTV FHD"
  },
  {
    "Retail Branding": "Dahua",
    "Marketing Name": "DAHUA",
    "Device": "stanford",
    "Model": "2K SMART TV"
  },
  {
    "Retail Branding": "Dahua",
    "Marketing Name": "DAHUA",
    "Device": "stanford",
    "Model": "40DSA"
  },
  {
    "Retail Branding": "Dahua",
    "Marketing Name": "DAHUA",
    "Device": "zhongshan",
    "Model": "43FCOL"
  },
  {
    "Retail Branding": "Dahua",
    "Marketing Name": "DAHUA",
    "Device": "zhongshan",
    "Model": "43FSA"
  },
  {
    "Retail Branding": "Dahua",
    "Marketing Name": "DAHUA",
    "Device": "zhongshan",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "Daihatsu",
    "Marketing Name": "A-DA",
    "Device": "balticaAA",
    "Model": "MY22ADA"
  },
  {
    "Retail Branding": "Daiwa",
    "Marketing Name": "2K DATV",
    "Device": "capitolhill",
    "Model": "2K DATV"
  },
  {
    "Retail Branding": "Daiwa",
    "Marketing Name": "2K DATV",
    "Device": "capitolhill",
    "Model": "Daiwa 2K Google TV"
  },
  {
    "Retail Branding": "Daiwa",
    "Marketing Name": "4K DATV",
    "Device": "keoneae",
    "Model": "4K DATV"
  },
  {
    "Retail Branding": "Daiwa",
    "Marketing Name": "4K DATV",
    "Device": "keoneae",
    "Model": "Daiwa 4K Google TV"
  },
  {
    "Retail Branding": "Daiwa",
    "Marketing Name": "4K DATV-Z",
    "Device": "keoneae",
    "Model": "4K DATV-Z"
  },
  {
    "Retail Branding": "Daiwa",
    "Marketing Name": "4K DATV-Z",
    "Device": "keoneae",
    "Model": "Daiwa 4K Google TV-Z"
  },
  {
    "Retail Branding": "Daiwa",
    "Marketing Name": "DAIWA",
    "Device": "elliniko",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "Daiwa",
    "Marketing Name": "DAIWA",
    "Device": "elliniko",
    "Model": "DAIWA SMART TV"
  },
  {
    "Retail Branding": "Daiwa",
    "Marketing Name": "DAIWA",
    "Device": "hongkong",
    "Model": "4K DVB SMART TV"
  },
  {
    "Retail Branding": "Daiwa",
    "Marketing Name": "DAIWA",
    "Device": "jagalchi",
    "Model": "DAIWA SMART TV"
  },
  {
    "Retail Branding": "Daiwa",
    "Marketing Name": "DAIWA",
    "Device": "mountbaker",
    "Model": "2K SMART TV"
  },
  {
    "Retail Branding": "Daiwa",
    "Marketing Name": "DAIWA",
    "Device": "mountbaker",
    "Model": "DAIWA 2K SMART TV"
  },
  {
    "Retail Branding": "Danew",
    "Marketing Name": "D809ProPlus",
    "Device": "D809ProPlus",
    "Model": "D809ProPlus"
  },
  {
    "Retail Branding": "Danew",
    "Marketing Name": "DSlide 710",
    "Device": "Dslide710",
    "Model": "Dslide710"
  },
  {
    "Retail Branding": "Danew",
    "Marketing Name": "DSlide 750",
    "Device": "Danew_DSlide750",
    "Model": "DSlide750"
  },
  {
    "Retail Branding": "Danew",
    "Marketing Name": "Dbook112_EEA",
    "Device": "Dbook112_EEA",
    "Model": "Dbook112_EEA"
  },
  {
    "Retail Branding": "Danew",
    "Marketing Name": "Dbook_110",
    "Device": "Dbook_110",
    "Model": "Dbook_110"
  },
  {
    "Retail Branding": "Danew",
    "Marketing Name": "Dbook_110_EEA",
    "Device": "Dbook_110",
    "Model": "Dbook_110"
  },
  {
    "Retail Branding": "Danew",
    "Marketing Name": "Dbook_111",
    "Device": "Dbook_111",
    "Model": "Dbook_111"
  },
  {
    "Retail Branding": "Danew",
    "Marketing Name": "Dbook_121",
    "Device": "Dbook_121",
    "Model": "Dbook_121"
  },
  {
    "Retail Branding": "Danew",
    "Marketing Name": "Dslide 1013",
    "Device": "DSlide1013",
    "Model": "DSlide 1013"
  },
  {
    "Retail Branding": "Danew",
    "Marketing Name": "Dslide 1013QC",
    "Device": "Dslide1013QC_v2",
    "Model": "Dslide1013QC_v2"
  },
  {
    "Retail Branding": "Danew",
    "Marketing Name": "Dslide 1013QC",
    "Device": "Dslide1013QC_v3",
    "Model": "Dslide1013QC_v3"
  },
  {
    "Retail Branding": "Danew",
    "Marketing Name": "Dslide 714",
    "Device": "Dslide714_v2",
    "Model": "Dslide714_v2"
  },
  {
    "Retail Branding": "Danew",
    "Marketing Name": "Dslide1013QC_V4",
    "Device": "Dslide1013QC_v4",
    "Model": "Dslide1013QC_v4"
  },
  {
    "Retail Branding": "Danew",
    "Marketing Name": "Dslide1014",
    "Device": "Dslide1014",
    "Model": "Dslide1014"
  },
  {
    "Retail Branding": "Danew",
    "Marketing Name": "Dslide1016",
    "Device": "Dslide1016",
    "Model": "Dslide1016"
  },
  {
    "Retail Branding": "Danew",
    "Marketing Name": "Dslide1016_V2_EEA",
    "Device": "Dslide1016_V2",
    "Model": "Dslide1016_V2"
  },
  {
    "Retail Branding": "Danew",
    "Marketing Name": "Dslide1019",
    "Device": "Dslide1019",
    "Model": "Dslide1019"
  },
  {
    "Retail Branding": "Danew",
    "Marketing Name": "Dslide1023_EEA",
    "Device": "Dslide1023",
    "Model": "Dslide1023"
  },
  {
    "Retail Branding": "Danew",
    "Marketing Name": "Dslide113_V2_EEA",
    "Device": "Dslide113_V2",
    "Model": "Dslide113_V2"
  },
  {
    "Retail Branding": "Danew",
    "Marketing Name": "Dslide113_V3",
    "Device": "Dslide113_V3",
    "Model": "Dslide113_V3"
  },
  {
    "Retail Branding": "Danew",
    "Marketing Name": "Dslide714",
    "Device": "Dslide714",
    "Model": "Dslide714"
  },
  {
    "Retail Branding": "Danew",
    "Marketing Name": "Dslide716",
    "Device": "Dslide716",
    "Model": "Dslide716"
  },
  {
    "Retail Branding": "Danew",
    "Marketing Name": "Dslide807",
    "Device": "Dslide807",
    "Model": "Dslide807"
  },
  {
    "Retail Branding": "Danew",
    "Marketing Name": "Dslide808",
    "Device": "Dslide808",
    "Model": "Dslide808"
  },
  {
    "Retail Branding": "Danew",
    "Marketing Name": "Dslide971DC",
    "Device": "Dslide971DC",
    "Model": "Dslide971DC"
  },
  {
    "Retail Branding": "Danew",
    "Marketing Name": "Dslide_1020",
    "Device": "Dslide_1020",
    "Model": "Dslide_1020"
  },
  {
    "Retail Branding": "Danew",
    "Marketing Name": "Dslide_1020M",
    "Device": "Dslide_1020M",
    "Model": "Dslide_1020M"
  },
  {
    "Retail Branding": "Danew",
    "Marketing Name": "Dslide_1020Pro_EEA",
    "Device": "Dslide_1020Pro",
    "Model": "Dslide_1020Pro"
  },
  {
    "Retail Branding": "Danew",
    "Marketing Name": "Dslide_1021C",
    "Device": "Dslide_1021C",
    "Model": "Dslide_1021C"
  },
  {
    "Retail Branding": "Danew",
    "Marketing Name": "Dslide_1021_EEA",
    "Device": "Dslide_1021",
    "Model": "Dslide_1021"
  },
  {
    "Retail Branding": "Danew",
    "Marketing Name": "Dslide_1025V2_EEA",
    "Device": "Dslide_1025V2",
    "Model": "Dslide_1025V2"
  },
  {
    "Retail Branding": "Danew",
    "Marketing Name": "Dslide_1025V2_EEA",
    "Device": "Dslide_1025V2",
    "Model": "Dslide_1025v2"
  },
  {
    "Retail Branding": "Danew",
    "Marketing Name": "Dslide_1025_EEA",
    "Device": "Dslide_1025_EEA",
    "Model": "Dslide_1025"
  },
  {
    "Retail Branding": "Danew",
    "Marketing Name": "Dslide_1095_EEA",
    "Device": "Dslide_1095",
    "Model": "Dslide_1095"
  },
  {
    "Retail Branding": "Danew",
    "Marketing Name": "Dslide_113",
    "Device": "Dslide_113",
    "Model": "Dslide_113"
  },
  {
    "Retail Branding": "Danew",
    "Marketing Name": "Dslide_114",
    "Device": "Dslide_114",
    "Model": "Dslide_114"
  },
  {
    "Retail Branding": "Danew",
    "Marketing Name": "Dslide_115_EEA",
    "Device": "Dslide_115",
    "Model": "Dslide_115"
  },
  {
    "Retail Branding": "Danew",
    "Marketing Name": "Dslide_116_EEA",
    "Device": "Dslide_116",
    "Model": "Dslide_116"
  },
  {
    "Retail Branding": "Danew",
    "Marketing Name": "Dslide_117",
    "Device": "Dslide_117",
    "Model": "Dslide_117"
  },
  {
    "Retail Branding": "Danew",
    "Marketing Name": "Dslide_809",
    "Device": "Dslide_809_EEA",
    "Model": "Dslide_809"
  },
  {
    "Retail Branding": "Danew",
    "Marketing Name": "Dslide_809Pro_EEA",
    "Device": "Dslide_809Pro",
    "Model": "Dslide_809Pro"
  },
  {
    "Retail Branding": "Danew",
    "Marketing Name": "G27",
    "Device": "G27",
    "Model": "G27"
  },
  {
    "Retail Branding": "Danew",
    "Marketing Name": "KECHAODA_S10",
    "Device": "KECHAODA_S10",
    "Model": "KECHAODA_S10"
  },
  {
    "Retail Branding": "Danew",
    "Marketing Name": "Konnect 402",
    "Device": "Konnect402",
    "Model": "Konnect402"
  },
  {
    "Retail Branding": "Danew",
    "Marketing Name": "Konnect 502",
    "Device": "Konnect_502",
    "Model": "Konnect_502"
  },
  {
    "Retail Branding": "Danew",
    "Marketing Name": "Konnect 503",
    "Device": "Konnect503",
    "Model": "Konnect503"
  },
  {
    "Retail Branding": "Danew",
    "Marketing Name": "Konnect 504",
    "Device": "Konnect_504",
    "Model": "Konnect_504"
  },
  {
    "Retail Branding": "Danew",
    "Marketing Name": "Konnect 506",
    "Device": "Konnect506",
    "Model": "Konnect506"
  },
  {
    "Retail Branding": "Danew",
    "Marketing Name": "Konnect 510 colors",
    "Device": "Konnect_510",
    "Model": "Konnect_510_colors"
  },
  {
    "Retail Branding": "Danew",
    "Marketing Name": "Konnect 556",
    "Device": "DANEW_Konnect_556",
    "Model": "Konnect_556"
  },
  {
    "Retail Branding": "Danew",
    "Marketing Name": "Konnect 560 Cinépix",
    "Device": "Konnect_560",
    "Model": "Konnect_560"
  },
  {
    "Retail Branding": "Danew",
    "Marketing Name": "Konnect 602",
    "Device": "Konnect602",
    "Model": "Konnect602"
  },
  {
    "Retail Branding": "Danew",
    "Marketing Name": "Konnect_508",
    "Device": "Konnect_508",
    "Model": "Konnect_508"
  },
  {
    "Retail Branding": "Danew",
    "Marketing Name": "Konnect_509",
    "Device": "Konnect_509",
    "Model": "Konnect_509"
  },
  {
    "Retail Branding": "Danew",
    "Marketing Name": "Konnect_557",
    "Device": "Konnect_557",
    "Model": "Konnect_557"
  },
  {
    "Retail Branding": "Danew",
    "Marketing Name": "Konnect_607",
    "Device": "Konnect_607",
    "Model": "Konnect_607"
  },
  {
    "Retail Branding": "Danew",
    "Marketing Name": "Konnect_608",
    "Device": "Konnect_608",
    "Model": "Konnect_608"
  },
  {
    "Retail Branding": "Danew",
    "Marketing Name": "Konnect_660",
    "Device": "Konnect_660",
    "Model": "Konnect 660"
  },
  {
    "Retail Branding": "Danew",
    "Marketing Name": "Surnaturel_R500",
    "Device": "Surnaturel_R500",
    "Model": "Surnaturel_R500"
  },
  {
    "Retail Branding": "Danew",
    "Marketing Name": "TRACE ONE",
    "Device": "T_ONE",
    "Model": "T_ONE"
  },
  {
    "Retail Branding": "Danew",
    "Marketing Name": "konnect 601",
    "Device": "Konnect_601",
    "Model": "Konnect_601"
  },
  {
    "Retail Branding": "Danew_Talla",
    "Marketing Name": "Dslide_1095ml",
    "Device": "Dslide_1095ml",
    "Model": "Dslide_1095ml"
  },
  {
    "Retail Branding": "Dangbei",
    "Marketing Name": "DBOD02",
    "Device": "himalaya",
    "Model": "DBOD02"
  },
  {
    "Retail Branding": "Dangbei",
    "Marketing Name": "DBOX02",
    "Device": "khandala",
    "Model": "DBOX02"
  },
  {
    "Retail Branding": "Dangbei",
    "Marketing Name": "DBPADGO1",
    "Device": "DBPADGO1",
    "Model": "DBPADGO1"
  },
  {
    "Retail Branding": "Dany",
    "Marketing Name": "MAXX_05",
    "Device": "MAXX_05",
    "Model": "MAXX_05"
  },
  {
    "Retail Branding": "Dany",
    "Marketing Name": "Signature-S8",
    "Device": "Signature-S8",
    "Model": "Signature-S8"
  },
  {
    "Retail Branding": "Daria",
    "Marketing Name": "hormoz",
    "Device": "hormoz",
    "Model": "DM-B70104"
  },
  {
    "Retail Branding": "Daria",
    "Marketing Name": "huma",
    "Device": "huma",
    "Model": "DM-B70104"
  },
  {
    "Retail Branding": "Daria",
    "Marketing Name": "lavan",
    "Device": "lavan",
    "Model": "DM-B70204"
  },
  {
    "Retail Branding": "Daria",
    "Marketing Name": "qoqnoos",
    "Device": "qoqnoos",
    "Model": "DM-B51104"
  },
  {
    "Retail Branding": "Daria",
    "Marketing Name": "zahedan",
    "Device": "zahedan",
    "Model": "DM-B50104"
  },
  {
    "Retail Branding": "Datalogic",
    "Marketing Name": "Datalogic MEMOR 10",
    "Device": "dl35",
    "Model": "MEMOR 10"
  },
  {
    "Retail Branding": "Datalogic",
    "Marketing Name": "Joya Smart/Smart+",
    "Device": "soho",
    "Model": "Joya Smart"
  },
  {
    "Retail Branding": "Datalogic",
    "Marketing Name": "Joya Touch 22",
    "Device": "jta11",
    "Model": "Joya Touch 22"
  },
  {
    "Retail Branding": "Datalogic",
    "Marketing Name": "Joya Touch 22",
    "Device": "jta11f",
    "Model": "Joya Touch 22"
  },
  {
    "Retail Branding": "Datalogic",
    "Marketing Name": "MEMOR 1",
    "Device": "M1_AOSP",
    "Model": "Memor 1"
  },
  {
    "Retail Branding": "Datalogic",
    "Marketing Name": "MEMOR 1",
    "Device": "M1_HANDHELD",
    "Model": "Memor 1"
  },
  {
    "Retail Branding": "Datalogic",
    "Marketing Name": "MEMOR 1",
    "Device": "M1_PISTOL",
    "Model": "Memor 1"
  },
  {
    "Retail Branding": "Datalogic",
    "Marketing Name": "MEMOR 11",
    "Device": "m11",
    "Model": "Memor 11"
  },
  {
    "Retail Branding": "Datalogic",
    "Marketing Name": "Memor 12",
    "Device": "tomcat_pda",
    "Model": "Memor 12"
  },
  {
    "Retail Branding": "Datalogic",
    "Marketing Name": "Memor 17",
    "Device": "tomcat_pda",
    "Model": "Memor 17"
  },
  {
    "Retail Branding": "Datalogic",
    "Marketing Name": "Memor 20",
    "Device": "Q10",
    "Model": "Memor 20"
  },
  {
    "Retail Branding": "Datalogic",
    "Marketing Name": "Memor 20",
    "Device": "Q10A",
    "Model": "Memor 20"
  },
  {
    "Retail Branding": "Datalogic",
    "Marketing Name": "Memor 30/30X",
    "Device": "nebula_pda",
    "Model": "Memor 30/30X"
  },
  {
    "Retail Branding": "Datalogic",
    "Marketing Name": "Memor 35/35X",
    "Device": "nebula_pda",
    "Model": "Memor 35/35X"
  },
  {
    "Retail Branding": "Datalogic",
    "Marketing Name": "Memor K",
    "Device": "memor_k",
    "Model": "Memor K"
  },
  {
    "Retail Branding": "Datalogic",
    "Marketing Name": "Memor K20",
    "Device": "mk2",
    "Model": "Memor K2"
  },
  {
    "Retail Branding": "Datalogic",
    "Marketing Name": "Memor K25",
    "Device": "mk2",
    "Model": "Memor K2"
  },
  {
    "Retail Branding": "Datalogic",
    "Marketing Name": "Skorpio X5",
    "Device": "sx5",
    "Model": "Skorpio X5"
  },
  {
    "Retail Branding": "Datamini",
    "Marketing Name": "K508101",
    "Device": "K508101",
    "Model": "K508101"
  },
  {
    "Retail Branding": "Datamini",
    "Marketing Name": "K908H4G",
    "Device": "K908H4G",
    "Model": "K908H4G"
  },
  {
    "Retail Branding": "Datamini",
    "Marketing Name": "T1004G",
    "Device": "T1004G",
    "Model": "T1004G"
  },
  {
    "Retail Branding": "Datamini",
    "Marketing Name": "T104G",
    "Device": "T104G",
    "Model": "T104G"
  },
  {
    "Retail Branding": "Datamini",
    "Marketing Name": "T104G_DTIL",
    "Device": "T104G",
    "Model": "T104G"
  },
  {
    "Retail Branding": "Datamini",
    "Marketing Name": "T104G_T610",
    "Device": "T104G_T610",
    "Model": "T104G_T610"
  },
  {
    "Retail Branding": "Datamini",
    "Marketing Name": "T104G_T618",
    "Device": "T104G",
    "Model": "T104G"
  },
  {
    "Retail Branding": "Datamini",
    "Marketing Name": "T104G_T618_A14",
    "Device": "T104G_T618_A14",
    "Model": "T104G"
  },
  {
    "Retail Branding": "Datamini",
    "Marketing Name": "T115G",
    "Device": "T115G",
    "Model": "T115G"
  },
  {
    "Retail Branding": "Datamini",
    "Marketing Name": "T74G",
    "Device": "T74G",
    "Model": "T74G"
  },
  {
    "Retail Branding": "Datamini",
    "Marketing Name": "T8004G",
    "Device": "T8004G",
    "Model": "T8004G"
  },
  {
    "Retail Branding": "Datamini",
    "Marketing Name": "T84G",
    "Device": "T84G",
    "Model": "T84G"
  },
  {
    "Retail Branding": "Datamini",
    "Marketing Name": "T84G",
    "Device": "T84G_OC",
    "Model": "T84G_OC"
  },
  {
    "Retail Branding": "Datamini",
    "Marketing Name": "T84G",
    "Device": "T84G_T310",
    "Model": "T84G"
  },
  {
    "Retail Branding": "Datamini",
    "Marketing Name": "T84G_T310A14",
    "Device": "T84G_T310A14",
    "Model": "T84G"
  },
  {
    "Retail Branding": "Datamini",
    "Marketing Name": "T84G_T310A14",
    "Device": "T84G_T310A14",
    "Model": "T84G_T310A14"
  },
  {
    "Retail Branding": "Datamini",
    "Marketing Name": "T84G_T310_332",
    "Device": "T84G_T310_332",
    "Model": "T84G_T310_332"
  },
  {
    "Retail Branding": "Datamini",
    "Marketing Name": "TPOS74G-IGF720",
    "Device": "TPOS74G-IGF720",
    "Model": "TPOS74G-IGF720"
  },
  {
    "Retail Branding": "Datatron",
    "Marketing Name": "Datatron_3588",
    "Device": "Datatron_3588",
    "Model": "Datatron_3588"
  },
  {
    "Retail Branding": "Datecs",
    "Marketing Name": "BlueCash-05",
    "Device": "BlueCash-05",
    "Model": "BlueCash-05"
  },
  {
    "Retail Branding": "Datecs",
    "Marketing Name": "BlueCash_05S",
    "Device": "BlueCash_05S",
    "Model": "BlueCash_05S"
  },
  {
    "Retail Branding": "Datsun",
    "Marketing Name": "D5000",
    "Device": "D5000",
    "Model": "D5000"
  },
  {
    "Retail Branding": "Datsun",
    "Marketing Name": "D6000",
    "Device": "D6000",
    "Model": "D6000"
  },
  {
    "Retail Branding": "Datsun",
    "Marketing Name": "Datsun_D5001",
    "Device": "Datsun_D5001",
    "Model": "Datsun_D5001"
  },
  {
    "Retail Branding": "Datsun",
    "Marketing Name": "Datsun_D5500",
    "Device": "D5500",
    "Model": "DATSUN_D5500"
  },
  {
    "Retail Branding": "Dawlance",
    "Marketing Name": "DAWLANCE GSMART 2KTV",
    "Device": "umeda",
    "Model": "DAWLANCE GSMART 2KTV"
  },
  {
    "Retail Branding": "Dawlance",
    "Marketing Name": "DAWLANCE GSMART 4KTV",
    "Device": "SW6H",
    "Model": "DAWLANCE GSMART 4KTV"
  },
  {
    "Retail Branding": "Dawlance",
    "Marketing Name": "DAWLANCE GSMART 4KTV",
    "Device": "anaheim",
    "Model": "DAWLANCE GSMART 4KTV"
  },
  {
    "Retail Branding": "Dawlance",
    "Marketing Name": "Dawlance Nano QLED",
    "Device": "aberdeen",
    "Model": "Dawlance Nano QLED"
  },
  {
    "Retail Branding": "Dawlance",
    "Marketing Name": "Dawlance OLED Google TV",
    "Device": "aberdeen",
    "Model": "Dawlance OLED Google TV"
  },
  {
    "Retail Branding": "DayMark",
    "Marketing Name": "IT119345",
    "Device": "IT119345",
    "Model": "IT119345"
  },
  {
    "Retail Branding": "DayMark",
    "Marketing Name": "IT119411",
    "Device": "IT119411",
    "Model": "IT119411"
  },
  {
    "Retail Branding": "Dcode",
    "Marketing Name": "Cypher",
    "Device": "Dcode_Cypher",
    "Model": "DS-CR1"
  },
  {
    "Retail Branding": "Dcode",
    "Marketing Name": "DS-CL4",
    "Device": "DS_CL4",
    "Model": "DS-CL4"
  },
  {
    "Retail Branding": "Dcode",
    "Marketing Name": "DS-X1",
    "Device": "DS-X1",
    "Model": "DS-X1"
  },
  {
    "Retail Branding": "Dcode",
    "Marketing Name": "DS_BD1",
    "Device": "DS_BD1",
    "Model": "DS-BD1"
  },
  {
    "Retail Branding": "Dcode",
    "Marketing Name": "DS_BD2",
    "Device": "DS_BD2",
    "Model": "DS-BD2"
  },
  {
    "Retail Branding": "Dcode",
    "Marketing Name": "DS_BD4_Pro",
    "Device": "DS_BD4_Pro",
    "Model": "DS-BD4 Pro"
  },
  {
    "Retail Branding": "Dcode",
    "Marketing Name": "DS_CL1",
    "Device": "DS_CL1",
    "Model": "DS-CL1"
  },
  {
    "Retail Branding": "Dcode",
    "Marketing Name": "DS_CL2_Lite",
    "Device": "DS_CL2_Lite",
    "Model": "DS-CL2 Lite"
  },
  {
    "Retail Branding": "Dcode",
    "Marketing Name": "DS_CL2_Pro",
    "Device": "DS_CL2_Pro",
    "Model": "DS-CL2 Pro"
  },
  {
    "Retail Branding": "Dcode",
    "Marketing Name": "DS_CL4_Lite",
    "Device": "DS_CL4_Lite",
    "Model": "DS-CL4 Lite"
  },
  {
    "Retail Branding": "Dcode",
    "Marketing Name": "DS_CL4_Lite_C",
    "Device": "DS_CL4_Lite",
    "Model": "DS-CL4 Lite"
  },
  {
    "Retail Branding": "Dcode",
    "Marketing Name": "DS_CL4_Pro",
    "Device": "DS_CL4_Pro",
    "Model": "DS-CL4 Pro"
  },
  {
    "Retail Branding": "Dcode",
    "Marketing Name": "DS_CL_Evo",
    "Device": "DS_CL_Evo",
    "Model": "Cygnal Evo"
  },
  {
    "Retail Branding": "Dcode",
    "Marketing Name": "DS_CL_Prime",
    "Device": "DS_CL_Prime",
    "Model": "Cygnal Prime"
  },
  {
    "Retail Branding": "Dcode",
    "Marketing Name": "DS_CL_X",
    "Device": "DS_CL_X",
    "Model": "Cygnal X"
  },
  {
    "Retail Branding": "Dcolor",
    "Marketing Name": "Dcolor",
    "Device": "YHT",
    "Model": "Dcolor GD2"
  },
  {
    "Retail Branding": "Dcolor",
    "Marketing Name": "GD1 4K",
    "Device": "YUL",
    "Model": "GD1 4K"
  },
  {
    "Retail Branding": "Ddm",
    "Marketing Name": "ANDY 5EI",
    "Device": "AM5E3I047",
    "Model": "ANDY 5EI"
  },
  {
    "Retail Branding": "DeWALT",
    "Marketing Name": "DeWalt md501",
    "Device": "md501",
    "Model": "md501"
  },
  {
    "Retail Branding": "Decaview",
    "Marketing Name": "Decaview 2K Google TV",
    "Device": "capitolhill",
    "Model": "Decaview  2K Google TV"
  },
  {
    "Retail Branding": "Decaview",
    "Marketing Name": "Decaview 4K Google TV",
    "Device": "keoneae",
    "Model": "Decaview 4K Google TV"
  },
  {
    "Retail Branding": "Decenta",
    "Marketing Name": "OPS_A012_D",
    "Device": "OPS_A012_D",
    "Model": "OPS_A012_D"
  },
  {
    "Retail Branding": "DeepHub",
    "Marketing Name": "DeepHub Pro",
    "Device": "mensa_an64",
    "Model": "ST470"
  },
  {
    "Retail Branding": "DeepHub",
    "Marketing Name": "DeepHub Ultimate",
    "Device": "rk3588_t",
    "Model": "MC480-U"
  },
  {
    "Retail Branding": "DeepHub",
    "Marketing Name": "Interactive_display",
    "Device": "mensa_an64",
    "Model": "ST430"
  },
  {
    "Retail Branding": "Delephas",
    "Marketing Name": "Chang Co., Ltd",
    "Device": "seocho",
    "Model": "Delephas 4K Android TV"
  },
  {
    "Retail Branding": "Dell",
    "Marketing Name": "",
    "Device": "Dell_Grappa",
    "Model": "Dell Aero"
  },
  {
    "Retail Branding": "Dell",
    "Marketing Name": "",
    "Device": "Dell_Grappa",
    "Model": "Mini_3iG"
  },
  {
    "Retail Branding": "Dell",
    "Marketing Name": "",
    "Device": "Streak10Pro",
    "Model": "Dell Streak 10 Pro"
  },
  {
    "Retail Branding": "Dell",
    "Marketing Name": "",
    "Device": "qsd8250_surf",
    "Model": "Dell Mini 5"
  },
  {
    "Retail Branding": "Dell",
    "Marketing Name": "",
    "Device": "qsd8250_surf",
    "Model": "Dell Streak"
  },
  {
    "Retail Branding": "Dell",
    "Marketing Name": "",
    "Device": "streak7",
    "Model": "Dell Streak 7"
  },
  {
    "Retail Branding": "Dell",
    "Marketing Name": "",
    "Device": "streak7",
    "Model": "streak7"
  },
  {
    "Retail Branding": "Dell",
    "Marketing Name": "",
    "Device": "streakpro",
    "Model": "101DL"
  },
  {
    "Retail Branding": "Dell",
    "Marketing Name": "",
    "Device": "streakpro",
    "Model": "Dell V04B"
  },
  {
    "Retail Branding": "Dell",
    "Marketing Name": "",
    "Device": "streakpro",
    "Model": "GS01"
  },
  {
    "Retail Branding": "Dell",
    "Marketing Name": "",
    "Device": "venue",
    "Model": "BizSmartPhone"
  },
  {
    "Retail Branding": "Dell",
    "Marketing Name": "",
    "Device": "venue",
    "Model": "Dell Venue"
  },
  {
    "Retail Branding": "Dell",
    "Marketing Name": "Chromebook 11 Model 3180",
    "Device": "kefka_cheets",
    "Model": "Chromebook 11 Model 3180"
  },
  {
    "Retail Branding": "Dell",
    "Marketing Name": "Chromebook 11 Model 3180",
    "Device": "kefka_cheets",
    "Model": "Dell Chromebook 11 (3180)"
  },
  {
    "Retail Branding": "Dell",
    "Marketing Name": "Chromebook 13 3380",
    "Device": "asuka_cheets",
    "Model": "Dell Chromebook 13 (3380)"
  },
  {
    "Retail Branding": "Dell",
    "Marketing Name": "Chromebook 13 3380",
    "Device": "asuka_cheets",
    "Model": "Dell Chromebook 13 3380"
  },
  {
    "Retail Branding": "Dell",
    "Marketing Name": "Chromebook 13 7310",
    "Device": "lulu_cheets",
    "Model": "Dell Chromebook 13 (7310)"
  },
  {
    "Retail Branding": "Dell",
    "Marketing Name": "Chromebook 13 7310",
    "Device": "lulu_cheets",
    "Model": "Dell Chromebook 13 7310"
  },
  {
    "Retail Branding": "Dell",
    "Marketing Name": "Cloud Connect",
    "Device": "capri_wyse",
    "Model": "CS-1A13"
  },
  {
    "Retail Branding": "Dell",
    "Marketing Name": "Dell Latitude Chromebook Enterprise",
    "Device": "sarien_cheets",
    "Model": "Dell Latitude 5400 Chromebook Enterprise"
  },
  {
    "Retail Branding": "Dell",
    "Marketing Name": "Dell Latitude Chromebook Enterprise",
    "Device": "sarien_cheets",
    "Model": "sarien"
  },
  {
    "Retail Branding": "Dell",
    "Marketing Name": "Latitude 7000",
    "Device": "drallion_cheets",
    "Model": "drallion"
  },
  {
    "Retail Branding": "Dell",
    "Marketing Name": "Streak",
    "Device": "streak",
    "Model": "001DL"
  },
  {
    "Retail Branding": "Dell",
    "Marketing Name": "Streak",
    "Device": "streak",
    "Model": "Dell M01M"
  },
  {
    "Retail Branding": "Dell",
    "Marketing Name": "Streak",
    "Device": "streak",
    "Model": "Dell Streak"
  },
  {
    "Retail Branding": "Dell",
    "Marketing Name": "Venue 10",
    "Device": "SO",
    "Model": "Venue 10 5050"
  },
  {
    "Retail Branding": "Dell",
    "Marketing Name": "Venue 7",
    "Device": "LW",
    "Model": "Venue 7 3741"
  },
  {
    "Retail Branding": "Dell",
    "Marketing Name": "Venue 7",
    "Device": "Venue7",
    "Model": "Venue 7 3740"
  },
  {
    "Retail Branding": "Dell",
    "Marketing Name": "Venue 7",
    "Device": "Venue7",
    "Model": "Venue7 3740"
  },
  {
    "Retail Branding": "Dell",
    "Marketing Name": "Venue 7",
    "Device": "Venue7",
    "Model": "Venue7 3740 LTE"
  },
  {
    "Retail Branding": "Dell",
    "Marketing Name": "Venue 7",
    "Device": "thunderbird",
    "Model": "Venue 7 3730"
  },
  {
    "Retail Branding": "Dell",
    "Marketing Name": "Venue 7",
    "Device": "thunderbird",
    "Model": "Venue 7 HSPA+"
  },
  {
    "Retail Branding": "Dell",
    "Marketing Name": "Venue 7040",
    "Device": "EP",
    "Model": "Venue 10 7040"
  },
  {
    "Retail Branding": "Dell",
    "Marketing Name": "Venue 8",
    "Device": "BB",
    "Model": "Venue 8 7840"
  },
  {
    "Retail Branding": "Dell",
    "Marketing Name": "Venue 8",
    "Device": "BB",
    "Model": "Venue 8 7840 LTE"
  },
  {
    "Retail Branding": "Dell",
    "Marketing Name": "Venue 8",
    "Device": "Venue8",
    "Model": "Venue 8 3840"
  },
  {
    "Retail Branding": "Dell",
    "Marketing Name": "Venue 8",
    "Device": "Venue8",
    "Model": "Venue8 3840"
  },
  {
    "Retail Branding": "Dell",
    "Marketing Name": "Venue 8",
    "Device": "Venue8",
    "Model": "Venue8 3840 LTE"
  },
  {
    "Retail Branding": "Dell",
    "Marketing Name": "Venue 8",
    "Device": "yellowtail",
    "Model": "Venue 8 3830"
  },
  {
    "Retail Branding": "Dell",
    "Marketing Name": "Venue 8",
    "Device": "yellowtail",
    "Model": "Venue 8 HSPA+"
  },
  {
    "Retail Branding": "Delm",
    "Marketing Name": "D1018",
    "Device": "D1018",
    "Model": "D1018"
  },
  {
    "Retail Branding": "Delm",
    "Marketing Name": "D718",
    "Device": "D718",
    "Model": "D718"
  },
  {
    "Retail Branding": "Delta",
    "Marketing Name": "TH_series",
    "Device": "rk3576_u",
    "Model": "TH_series"
  },
  {
    "Retail Branding": "Den Networks",
    "Marketing Name": "GL7220",
    "Device": "GK7661C",
    "Model": "GL7220"
  },
  {
    "Retail Branding": "Denali",
    "Marketing Name": "DT0702W08",
    "Device": "DT0702W08",
    "Model": "DT0702W08"
  },
  {
    "Retail Branding": "Denali",
    "Marketing Name": "DT0704K08",
    "Device": "DT0704K08",
    "Model": "DT0704K08"
  },
  {
    "Retail Branding": "Denali",
    "Marketing Name": "ETAB3",
    "Device": "DT0706W08",
    "Model": "ETAB3"
  },
  {
    "Retail Branding": "Denali",
    "Marketing Name": "Etab2",
    "Device": "DT0705W08",
    "Model": "DT0705W08"
  },
  {
    "Retail Branding": "Dengo",
    "Marketing Name": "Dengo D25",
    "Device": "Dengo_D25",
    "Model": "Dengo D25"
  },
  {
    "Retail Branding": "Denka",
    "Marketing Name": "Android TV",
    "Device": "R1",
    "Model": "ATV R1"
  },
  {
    "Retail Branding": "Denka",
    "Marketing Name": "Android TV",
    "Device": "R2",
    "Model": "ATV R2"
  },
  {
    "Retail Branding": "Dens TV",
    "Marketing Name": "B866V2FA V5.1",
    "Device": "B866V2FAV5_DensTV",
    "Model": "B866V2FA V5.1"
  },
  {
    "Retail Branding": "Denso Wave",
    "Marketing Name": "BHT-1600",
    "Device": "BHT1600",
    "Model": "BHT1600"
  },
  {
    "Retail Branding": "Denso Wave",
    "Marketing Name": "BHT-1700BWB-A7",
    "Device": "BHT-1700BWB-1-A7",
    "Model": "BHT-1700BWB-1-A7"
  },
  {
    "Retail Branding": "Denso Wave",
    "Marketing Name": "BHT-1700QLWB-A7-P",
    "Device": "BHT-1700QLWB-P-A7",
    "Model": "BHT-1700QLWB-P-A7"
  },
  {
    "Retail Branding": "Denso Wave",
    "Marketing Name": "BHT-1700QWB-1-A7",
    "Device": "BHT-1700QWB-1-A7",
    "Model": "BHT-1700QWB-1-A7"
  },
  {
    "Retail Branding": "Denso Wave",
    "Marketing Name": "BHT-1700QWB-2-A7",
    "Device": "BHT-1700QWB-2-A7",
    "Model": "BHT-1700QWB-2-A7"
  },
  {
    "Retail Branding": "Denso Wave",
    "Marketing Name": "BHT-1700QWBG-1-A7",
    "Device": "BHT-1700QWBG-1-A7",
    "Model": "BHT-1700QWBG-1-A7"
  },
  {
    "Retail Branding": "Denso Wave",
    "Marketing Name": "BHT-1700QWBG-2-A7",
    "Device": "BHT-1700QWBG-2-A7",
    "Model": "BHT-1700QWBG-2-A7"
  },
  {
    "Retail Branding": "Denso Wave",
    "Marketing Name": "BHT-1800QWB-1-A7",
    "Device": "BHT-1800QWB-1-A7",
    "Model": "BHT-1800QWB-1-A7"
  },
  {
    "Retail Branding": "Denso Wave",
    "Marketing Name": "BHT-1800QWB-2-A7",
    "Device": "BHT-1800QWB-2-A7",
    "Model": "BHT-1800QWB-2-A7"
  },
  {
    "Retail Branding": "Denso Wave",
    "Marketing Name": "BHT-1800QWB-3-A7",
    "Device": "BHT-1800QWB-3-A7",
    "Model": "BHT-1800QWB-3-A7"
  },
  {
    "Retail Branding": "Denso Wave",
    "Marketing Name": "BHT-1800QWBG-1-A7",
    "Device": "BHT-1800QWBG-1-A7",
    "Model": "BHT-1800QWBG-1-A7"
  },
  {
    "Retail Branding": "Denso Wave",
    "Marketing Name": "BHT-1800QWBG-2-A7",
    "Device": "BHT-1800QWBG-2-A7",
    "Model": "BHT-1800QWBG-2-A7"
  },
  {
    "Retail Branding": "Denso Wave",
    "Marketing Name": "BHT-1800QWBG-3-A7",
    "Device": "BHT-1800QWBG-3-A7",
    "Model": "BHT-1800QWBG-3-A7"
  },
  {
    "Retail Branding": "Denso Wave",
    "Marketing Name": "BHT-M60-QW-A10",
    "Device": "BHT-M60-QW-A10",
    "Model": "BHT-M60-QW-A10"
  },
  {
    "Retail Branding": "Denso Wave",
    "Marketing Name": "BHT-M60-QW-A10N",
    "Device": "BHT-M60-QW-A10N",
    "Model": "BHT-M60-QW-A10N"
  },
  {
    "Retail Branding": "Denso Wave",
    "Marketing Name": "BHT-M60-QWG-A10",
    "Device": "BHT-M60-QWG-A10",
    "Model": "BHT-M60-QWG-A10"
  },
  {
    "Retail Branding": "Denso Wave",
    "Marketing Name": "BHT-M60-QWG-A10N",
    "Device": "BHT-M60-QWG-A10N",
    "Model": "BHT-M60-QWG-A10N"
  },
  {
    "Retail Branding": "Denso Wave",
    "Marketing Name": "BHT-M70-QW-A10",
    "Device": "BHT-M70-QW-A10",
    "Model": "BHT-M70-QW-A10"
  },
  {
    "Retail Branding": "Denso Wave",
    "Marketing Name": "BHT-M70-QWG-A10",
    "Device": "BHT-M70-QWG-A10",
    "Model": "BHT-M70-QWG-A10"
  },
  {
    "Retail Branding": "Denso Wave",
    "Marketing Name": "BHT-M80-QW-A10",
    "Device": "BHT-M80-QW-A10",
    "Model": "BHT-M80-QW-A10"
  },
  {
    "Retail Branding": "Denso Wave",
    "Marketing Name": "BHT-M80-QWG-A10",
    "Device": "BHT-M80-QWG-A10",
    "Model": "BHT-M80-QWG-A10"
  },
  {
    "Retail Branding": "Denso Wave",
    "Marketing Name": "X-N10",
    "Device": "X-N10",
    "Model": "X-N10"
  },
  {
    "Retail Branding": "Denso Wave",
    "Marketing Name": "X-N15",
    "Device": "X-N15",
    "Model": "X-N15"
  },
  {
    "Retail Branding": "Denver Electronics",
    "Marketing Name": "SCQ-50001G",
    "Device": "SCQ-50001G",
    "Model": "SCQ-50001G"
  },
  {
    "Retail Branding": "Denver Electronics",
    "Marketing Name": "SDQ-55034L",
    "Device": "SDQ-55034L",
    "Model": "SDQ-55034L"
  },
  {
    "Retail Branding": "Denver Electronics",
    "Marketing Name": "SDQ-55044L",
    "Device": "SDQ-55044L",
    "Model": "SDQ-55044L"
  },
  {
    "Retail Branding": "Denver Electronics",
    "Marketing Name": "SDQ-57004L",
    "Device": "SDQ-57004L",
    "Model": "SDQ-57004L"
  },
  {
    "Retail Branding": "Denver Electronics",
    "Marketing Name": "SDQ_52001G",
    "Device": "SDQ_52001G",
    "Model": "SDQ_52001G"
  },
  {
    "Retail Branding": "Denver Electronics",
    "Marketing Name": "SDQ_52004L",
    "Device": "SDQ_52004L",
    "Model": "SDQ_52004L"
  },
  {
    "Retail Branding": "Denver Electronics",
    "Marketing Name": "TAQ-10",
    "Device": "TAQ10",
    "Model": "TAQ-10"
  },
  {
    "Retail Branding": "Denver Electronics",
    "Marketing Name": "TAQ-102",
    "Device": "TAQ102",
    "Model": "TAQ-102"
  },
  {
    "Retail Branding": "Denver Electronics",
    "Marketing Name": "TAQ-104A",
    "Device": "TAQ-104A",
    "Model": "TAQ_104A"
  },
  {
    "Retail Branding": "Denver Electronics",
    "Marketing Name": "TAQ-70",
    "Device": "TAQ70",
    "Model": "TAQ-70"
  },
  {
    "Retail Branding": "Denver Electronics",
    "Marketing Name": "TAQ-703A",
    "Device": "TAQ-703A",
    "Model": "TAQ_703A"
  },
  {
    "Retail Branding": "Denver Electronics",
    "Marketing Name": "TAQ-90",
    "Device": "TAQ90",
    "Model": "TAQ-90"
  },
  {
    "Retail Branding": "Denver Electronics",
    "Marketing Name": "TAQ70",
    "Device": "TAQ70",
    "Model": "TAQ-70"
  },
  {
    "Retail Branding": "Denver Electronics",
    "Marketing Name": "TAQ_10G",
    "Device": "TAQ_10G",
    "Model": "TAQ_10G"
  },
  {
    "Retail Branding": "Denver Electronics",
    "Marketing Name": "TAQ_703_eea",
    "Device": "TAQ_703_eea",
    "Model": "TAQ_703_eea"
  },
  {
    "Retail Branding": "Denver Electronics",
    "Marketing Name": "TIQ-10",
    "Device": "TIQ-10",
    "Model": "TIQ-10"
  },
  {
    "Retail Branding": "Denver Electronics",
    "Marketing Name": "TIQ-102",
    "Device": "TIQ102",
    "Model": "TIQ-102"
  },
  {
    "Retail Branding": "Denver Electronics",
    "Marketing Name": "TIQ-104",
    "Device": "TIQ104",
    "Model": "TIQ-104"
  },
  {
    "Retail Branding": "Denver Electronics",
    "Marketing Name": "TIQ-1044",
    "Device": "TIQ-1044",
    "Model": "TIQ-1044"
  },
  {
    "Retail Branding": "Denver Electronics",
    "Marketing Name": "TIQ-1049",
    "Device": "TIQ-1049",
    "Model": "TIQ-1049"
  },
  {
    "Retail Branding": "Denver Electronics",
    "Marketing Name": "TIQ-70",
    "Device": "TIQ-70",
    "Model": "TIQ-70"
  },
  {
    "Retail Branding": "Denver Electronics",
    "Marketing Name": "TIQ_1048",
    "Device": "TIQ_1048",
    "Model": "TIQ-1048"
  },
  {
    "Retail Branding": "Detco",
    "Marketing Name": "Detco 4K Google TV",
    "Device": "keoneae",
    "Model": "Detco 4K Google TV"
  },
  {
    "Retail Branding": "Deutsche Telekom",
    "Marketing Name": "T Phone",
    "Device": "Jaguar",
    "Model": "T Phone"
  },
  {
    "Retail Branding": "Deutsche Telekom",
    "Marketing Name": "T Phone 2",
    "Device": "PUMA",
    "Model": "T Phone 2"
  },
  {
    "Retail Branding": "Deutsche Telekom",
    "Marketing Name": "T Phone 2 Pro",
    "Device": "CHEETAH",
    "Model": "T Phone 2 Pro"
  },
  {
    "Retail Branding": "Deutsche Telekom",
    "Marketing Name": "T Phone 3",
    "Device": "Lynx",
    "Model": "T Phone 3"
  },
  {
    "Retail Branding": "Deutsche Telekom",
    "Marketing Name": "T Phone 3 Pro",
    "Device": "Caracal",
    "Model": "T Phone 3 Pro"
  },
  {
    "Retail Branding": "Deutsche Telekom",
    "Marketing Name": "T Phone Pro",
    "Device": "Lion",
    "Model": "T Phone Pro"
  },
  {
    "Retail Branding": "Deutsche Telekom",
    "Marketing Name": "T Phone Pro (2023)",
    "Device": "Tiger",
    "Model": "T Phone Pro (2023)"
  },
  {
    "Retail Branding": "Deutsche Telekom",
    "Marketing Name": "T Phone （2023）",
    "Device": "Leopard",
    "Model": "T Phone (2023)"
  },
  {
    "Retail Branding": "Deutsche Telekom",
    "Marketing Name": "T Tablet",
    "Device": "Hubbs",
    "Model": "T Tablet"
  },
  {
    "Retail Branding": "Deutsche Telekom",
    "Marketing Name": "T Tablet 2",
    "Device": "BELUGA",
    "Model": "TTablet2"
  },
  {
    "Retail Branding": "Devant",
    "Marketing Name": "Smart TV",
    "Device": "alimos",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "Devant",
    "Marketing Name": "Smart TV",
    "Device": "dangni",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "Dghrti",
    "Marketing Name": "TAB20_EEA",
    "Device": "TAB20_EEA",
    "Model": "TAB20_EEA"
  },
  {
    "Retail Branding": "Dghrti",
    "Marketing Name": "TAB20_US",
    "Device": "TAB20_US",
    "Model": "TAB20_US"
  },
  {
    "Retail Branding": "Dghrti",
    "Marketing Name": "TAB30-EU",
    "Device": "TAB30-EU",
    "Model": "TAB30"
  },
  {
    "Retail Branding": "Dghrti",
    "Marketing Name": "TAB30-EU",
    "Device": "TAB30-EU",
    "Model": "TAB30-EU"
  },
  {
    "Retail Branding": "Dghrti",
    "Marketing Name": "TAB30-W",
    "Device": "TAB30-W",
    "Model": "TAB30"
  },
  {
    "Retail Branding": "Dghrti",
    "Marketing Name": "TAB30-W",
    "Device": "TAB30-W",
    "Model": "TAB30-W"
  },
  {
    "Retail Branding": "Dghrti",
    "Marketing Name": "TAB30_EEA",
    "Device": "TAB30_EEA",
    "Model": "TAB30_EEA"
  },
  {
    "Retail Branding": "Dghrti",
    "Marketing Name": "TAB30_US",
    "Device": "TAB30_US",
    "Model": "TAB30_US"
  },
  {
    "Retail Branding": "Dghrti",
    "Marketing Name": "TAB50_EEA",
    "Device": "TAB50_EEA",
    "Model": "TAB50_EEA"
  },
  {
    "Retail Branding": "Dghrti",
    "Marketing Name": "TAB50_US",
    "Device": "TAB50_US",
    "Model": "TAB50_US"
  },
  {
    "Retail Branding": "Dghrti",
    "Marketing Name": "TAB8_EEA",
    "Device": "TAB8_EEA",
    "Model": "TAB8_EEA"
  },
  {
    "Retail Branding": "Dghrti",
    "Marketing Name": "TAB8_US",
    "Device": "TAB8_US",
    "Model": "TAB8_US"
  },
  {
    "Retail Branding": "DiDi (Japan)",
    "Marketing Name": "DDT-001",
    "Device": "DDT-001",
    "Model": "DDT-001"
  },
  {
    "Retail Branding": "DiMora Mobile",
    "Marketing Name": "Adrenalin Pro",
    "Device": "Adrenalin_Pro",
    "Model": "Adrenalin Pro"
  },
  {
    "Retail Branding": "DiMora Mobile",
    "Marketing Name": "DiMora_LUX",
    "Device": "DiMora_LUX",
    "Model": "DiMora_LUX"
  },
  {
    "Retail Branding": "DiMora Mobile",
    "Marketing Name": "InnoV8",
    "Device": "InnoV8",
    "Model": "InnoV8"
  },
  {
    "Retail Branding": "DiMora Mobile",
    "Marketing Name": "InnoV8_PRO",
    "Device": "InnoV8_PRO",
    "Model": "InnoV8_PRO"
  },
  {
    "Retail Branding": "DiO (fr)",
    "Marketing Name": "DIOVDP_SC01_EEA",
    "Device": "DIOVDP_SC01_EEA",
    "Model": "DIOVDP_SC01_EEA"
  },
  {
    "Retail Branding": "Dialog",
    "Marketing Name": "4K Android Hybrid",
    "Device": "DV8829_Dialog",
    "Model": "4K Android Hybrid"
  },
  {
    "Retail Branding": "Dialog",
    "Marketing Name": "N9106H_B",
    "Device": "N9106H_B_Dialog",
    "Model": "N9106H_B"
  },
  {
    "Retail Branding": "Dialog",
    "Marketing Name": "SEI103DL",
    "Device": "SEI103",
    "Model": "SEI103DL"
  },
  {
    "Retail Branding": "Dialog",
    "Marketing Name": "Sri Lanka",
    "Device": "N9106H_B_Dialog",
    "Model": "N9106H_B"
  },
  {
    "Retail Branding": "Dialog Blaze",
    "Marketing Name": "5701A",
    "Device": "5701A",
    "Model": "5701A"
  },
  {
    "Retail Branding": "Dialog Blaze",
    "Marketing Name": "Dialog_Blaze_Mini",
    "Device": "Dialog_Blaze_Mini",
    "Model": "Dialog_Blaze_Mini"
  },
  {
    "Retail Branding": "Dialog Blaze",
    "Marketing Name": "M50E-1A",
    "Device": "M50E-1A",
    "Model": "M50E-1A"
  },
  {
    "Retail Branding": "Dialog_TV",
    "Marketing Name": "Dialog ViU Mini",
    "Device": "Dialog_ViU_Mini",
    "Model": "Dialog ViU Mini"
  },
  {
    "Retail Branding": "Dialog_TV",
    "Marketing Name": "Viu Mini",
    "Device": "DV6067H-Dialog",
    "Model": "Viu Mini"
  },
  {
    "Retail Branding": "Diamond",
    "Marketing Name": "A1046DRI",
    "Device": "A1046DRI",
    "Model": "A1046DRI"
  },
  {
    "Retail Branding": "Diamond",
    "Marketing Name": "DIB100",
    "Device": "DIB100",
    "Model": "DIB100"
  },
  {
    "Retail Branding": "Diamond",
    "Marketing Name": "DIM100",
    "Device": "DIM100",
    "Model": "DIM100"
  },
  {
    "Retail Branding": "Diamond",
    "Marketing Name": "Luxuary-X",
    "Device": "Luxuary-X",
    "Model": "Luxuary-X"
  },
  {
    "Retail Branding": "Diamond",
    "Marketing Name": "MC32020",
    "Device": "MC32020",
    "Model": "MC32020"
  },
  {
    "Retail Branding": "Diamond",
    "Marketing Name": "MC32020B",
    "Device": "MC32020B",
    "Model": "MC32020B"
  },
  {
    "Retail Branding": "Diamond",
    "Marketing Name": "PSPCL30A0",
    "Device": "PSPCL30A0",
    "Model": "PSPCL30A0"
  },
  {
    "Retail Branding": "Dicle",
    "Marketing Name": "DTABC2",
    "Device": "DTABC2",
    "Model": "DTABC2"
  },
  {
    "Retail Branding": "Dicle",
    "Marketing Name": "DTABPLUS",
    "Device": "DTABPLUS",
    "Model": "DTABPLUS"
  },
  {
    "Retail Branding": "Dicle",
    "Marketing Name": "Dicle Tab Kpad",
    "Device": "Dicle_Dtab_Kpad",
    "Model": "Dicle_Dtab_Kpad"
  },
  {
    "Retail Branding": "Dicle",
    "Marketing Name": "Dicle Tab Lite 10.5 M",
    "Device": "Dicle_Tab_Lite_M",
    "Model": "Dicle_Tab_Lite_M"
  },
  {
    "Retail Branding": "Dicle",
    "Marketing Name": "DicleTab iPlay40 Pro",
    "Device": "DICLE_IPLAY40_PRO",
    "Model": "DICLE_IPLAY40_PRO"
  },
  {
    "Retail Branding": "Dicle_Tab",
    "Marketing Name": "Dicle Tab Active S",
    "Device": "Dicle_Dtab_Active_S",
    "Model": "Dicle_Dtab_Active_S"
  },
  {
    "Retail Branding": "Dicle_Tab",
    "Marketing Name": "Dicle Tab MyPen P1",
    "Device": "Tab_MyPen_P1",
    "Model": "Tab_MyPen_P1"
  },
  {
    "Retail Branding": "Dicle_Tab",
    "Marketing Name": "Dicle Tab U1008",
    "Device": "Dicle_Dtab_U1008",
    "Model": "Dicle_Dtab_U1008"
  },
  {
    "Retail Branding": "Dicle_Tab",
    "Marketing Name": "Dicle Tab Ultra",
    "Device": "Tab_Ultra",
    "Model": "Tab_Ultra"
  },
  {
    "Retail Branding": "Dicle_Tab",
    "Marketing Name": "Dicle Tab XPAD",
    "Device": "Dicle_Tab_XPAD",
    "Model": "U1101"
  },
  {
    "Retail Branding": "Dicle_Tab",
    "Marketing Name": "Dicle_Tab_Active",
    "Device": "Active",
    "Model": "Active"
  },
  {
    "Retail Branding": "Digi",
    "Marketing Name": "DIGI R2A",
    "Device": "DIGI_R2A",
    "Model": "DIGI R2A"
  },
  {
    "Retail Branding": "Digi",
    "Marketing Name": "Digi C1",
    "Device": "Digi_C1",
    "Model": "Digi C1"
  },
  {
    "Retail Branding": "Digi",
    "Marketing Name": "Digi C2",
    "Device": "Digi_C2",
    "Model": "Digi C2"
  },
  {
    "Retail Branding": "Digi",
    "Marketing Name": "Digi K2",
    "Device": "Digi_K2",
    "Model": "Digi K2"
  },
  {
    "Retail Branding": "Digi",
    "Marketing Name": "Digi R1",
    "Device": "Digi_R1",
    "Model": "Digi R1"
  },
  {
    "Retail Branding": "Digi",
    "Marketing Name": "Digi R2",
    "Device": "Digi_R2",
    "Model": "Digi R2"
  },
  {
    "Retail Branding": "Digi",
    "Marketing Name": "Digi_K2_EEA",
    "Device": "Digi_K2",
    "Model": "Digi K2"
  },
  {
    "Retail Branding": "Digi",
    "Marketing Name": "Digiking 4K Google TV",
    "Device": "keoneae",
    "Model": "Digiking 4K Google TV"
  },
  {
    "Retail Branding": "Digi",
    "Marketing Name": "INFINITY MAX",
    "Device": "DIGIT_INFINITY_MAX",
    "Model": "DIGIT INFINITY MAX"
  },
  {
    "Retail Branding": "DigiKing",
    "Marketing Name": "DigiKing 2K Android",
    "Device": "lasalle",
    "Model": "DigiKing 2K Android TV"
  },
  {
    "Retail Branding": "DigiKing",
    "Marketing Name": "DigiKing 4K Android",
    "Device": "kenton",
    "Model": "DigiKing 4K Android TV"
  },
  {
    "Retail Branding": "DigiKing",
    "Marketing Name": "Digiking 2K Google TV",
    "Device": "capitolhill",
    "Model": "Digiking 2K Google TV"
  },
  {
    "Retail Branding": "DigiKing",
    "Marketing Name": "Digiking 4K Google TV-A",
    "Device": "keoneae",
    "Model": "Digiking 4K Google TV-A"
  },
  {
    "Retail Branding": "DigiKing",
    "Marketing Name": "Smart TV",
    "Device": "alimos",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "DigiKing",
    "Marketing Name": "Smart TV",
    "Device": "dangni",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "DigiLand",
    "Marketing Name": 10542843,
    "Device": 10542843,
    "Model": 10542843
  },
  {
    "Retail Branding": "DigiLand",
    "Marketing Name": "206886-01",
    "Device": "mdt9003",
    "Model": "206886-01"
  },
  {
    "Retail Branding": "DigiLand",
    "Marketing Name": "Compumax Blue",
    "Device": "mid1016_ma",
    "Model": "Compumax Blue"
  },
  {
    "Retail Branding": "DigiLand",
    "Marketing Name": "CompumaxBlue",
    "Device": "mid1016_mk_64",
    "Model": "CompumaxBlue"
  },
  {
    "Retail Branding": "DigiLand",
    "Marketing Name": "CompumaxBlue",
    "Device": "mid1024_e",
    "Model": "Compumax_Blue_6030-805-0001"
  },
  {
    "Retail Branding": "DigiLand",
    "Marketing Name": "DC-7015",
    "Device": "MID7015A-MK",
    "Model": "DC-7015"
  },
  {
    "Retail Branding": "DigiLand",
    "Marketing Name": "DL1001",
    "Device": "DL1001",
    "Model": "DL1001"
  },
  {
    "Retail Branding": "DigiLand",
    "Marketing Name": "DL1002",
    "Device": "DL1002",
    "Model": "DL1002"
  },
  {
    "Retail Branding": "DigiLand",
    "Marketing Name": "DL1003",
    "Device": "DL9003",
    "Model": "DL9003"
  },
  {
    "Retail Branding": "DigiLand",
    "Marketing Name": "DL1008M",
    "Device": "mid1008l_emmc",
    "Model": "DL1008M"
  },
  {
    "Retail Branding": "DigiLand",
    "Marketing Name": "DL1010Q",
    "Device": "DL1010Q",
    "Model": "DL1010Q"
  },
  {
    "Retail Branding": "DigiLand",
    "Marketing Name": "DL1016",
    "Device": "mid1016",
    "Model": "DL1016"
  },
  {
    "Retail Branding": "DigiLand",
    "Marketing Name": "DL1018A",
    "Device": "mid1024_e",
    "Model": "DL1018A"
  },
  {
    "Retail Branding": "DigiLand",
    "Marketing Name": "DL1025GH",
    "Device": "DL1025GH",
    "Model": "DL1025GH"
  },
  {
    "Retail Branding": "DigiLand",
    "Marketing Name": "DL1026",
    "Device": "DL1026",
    "Model": "DL1026"
  },
  {
    "Retail Branding": "DigiLand",
    "Marketing Name": "DL1031",
    "Device": "mid1031",
    "Model": "mid1031_mp_64"
  },
  {
    "Retail Branding": "DigiLand",
    "Marketing Name": "DL1036",
    "Device": "DL1036",
    "Model": "DL-1036"
  },
  {
    "Retail Branding": "DigiLand",
    "Marketing Name": "DL1039",
    "Device": "mid1032_mr_32",
    "Model": "DL1039"
  },
  {
    "Retail Branding": "DigiLand",
    "Marketing Name": "DL1050",
    "Device": "DL1050",
    "Model": "DL1050"
  },
  {
    "Retail Branding": "DigiLand",
    "Marketing Name": "DL1168A",
    "Device": "mid1102",
    "Model": "DL1168A"
  },
  {
    "Retail Branding": "DigiLand",
    "Marketing Name": "DL7006",
    "Device": "DL7006",
    "Model": "DL7006"
  },
  {
    "Retail Branding": "DigiLand",
    "Marketing Name": "DL700D",
    "Device": "DL700D",
    "Model": "DL700D"
  },
  {
    "Retail Branding": "DigiLand",
    "Marketing Name": "DL701Q",
    "Device": "DL701Q",
    "Model": "DL701Q"
  },
  {
    "Retail Branding": "DigiLand",
    "Marketing Name": "DL718M",
    "Device": "mid713l_lp",
    "Model": "DL718M"
  },
  {
    "Retail Branding": "DigiLand",
    "Marketing Name": "DL721RB",
    "Device": "DL721-RB",
    "Model": "DL721-RB"
  },
  {
    "Retail Branding": "DigiLand",
    "Marketing Name": "DL785D",
    "Device": "DL785D",
    "Model": "PLT7803G"
  },
  {
    "Retail Branding": "DigiLand",
    "Marketing Name": "DL8006",
    "Device": "DL8006",
    "Model": "DL8006"
  },
  {
    "Retail Branding": "DigiLand",
    "Marketing Name": "DL9002",
    "Device": "DL9002",
    "Model": "DL9002"
  },
  {
    "Retail Branding": "DigiLand",
    "Marketing Name": "DL9003mk",
    "Device": "mdt9003",
    "Model": "DL9003MK"
  },
  {
    "Retail Branding": "DigiLand",
    "Marketing Name": "Digiland_mid1032_mr",
    "Device": "mid1032_mr",
    "Model": "DL1036"
  },
  {
    "Retail Branding": "DigiLand",
    "Marketing Name": "EVERPAD",
    "Device": "EVERPAD",
    "Model": "SC-725"
  },
  {
    "Retail Branding": "DigiLand",
    "Marketing Name": "H10XS",
    "Device": "H10XS",
    "Model": "H10XS"
  },
  {
    "Retail Branding": "DigiLand",
    "Marketing Name": "H11",
    "Device": "H11",
    "Model": "H11"
  },
  {
    "Retail Branding": "DigiLand",
    "Marketing Name": "K08Plus",
    "Device": "rk3562_ugo",
    "Model": "K08Plus"
  },
  {
    "Retail Branding": "DigiLand",
    "Marketing Name": "KTAB17",
    "Device": "KTAB17",
    "Model": "KTAB17"
  },
  {
    "Retail Branding": "DigiLand",
    "Marketing Name": "Leotec",
    "Device": "mid1016_mk_32",
    "Model": "Supernova"
  },
  {
    "Retail Branding": "DigiLand",
    "Marketing Name": "MID1008_Digiland",
    "Device": "mid1008",
    "Model": "DL1008M"
  },
  {
    "Retail Branding": "DigiLand",
    "Marketing Name": "MID8006_Digiland",
    "Device": "mid8006_mk_32",
    "Model": "mid8006_mk_32"
  },
  {
    "Retail Branding": "DigiLand",
    "Marketing Name": "NBDVDTAB9",
    "Device": "NBDVDTAB9",
    "Model": "NBDVDTAB9"
  },
  {
    "Retail Branding": "DigiLand",
    "Marketing Name": "NS-P16AT08",
    "Device": "mid8005",
    "Model": "NS-P16AT08"
  },
  {
    "Retail Branding": "DigiLand",
    "Marketing Name": "NS-P16AT785HD",
    "Device": "MID7802RA",
    "Model": "NS-P16AT785HD"
  },
  {
    "Retail Branding": "DigiLand",
    "Marketing Name": "ONN",
    "Device": "mid7015_mk_32",
    "Model": 100005206
  },
  {
    "Retail Branding": "DigiLand",
    "Marketing Name": "PCBOX",
    "Device": "Kova_2_PCB-T731",
    "Model": "PCB-T731"
  },
  {
    "Retail Branding": "DigiLand",
    "Marketing Name": "R11",
    "Device": "mid1109_mx",
    "Model": "R11"
  },
  {
    "Retail Branding": "DigiLand",
    "Marketing Name": "SLTDVD1023",
    "Device": "mdt1005",
    "Model": "SLTDVD1023"
  },
  {
    "Retail Branding": "DigiLand",
    "Marketing Name": "TP1_N",
    "Device": "TP1_N",
    "Model": "TP1_N"
  },
  {
    "Retail Branding": "DigiLand",
    "Marketing Name": "TPC-705Kids_EEA",
    "Device": "MID7015A-MK",
    "Model": "TPC-705Kids"
  },
  {
    "Retail Branding": "DigiLand",
    "Marketing Name": "Tab-T10",
    "Device": "Tab-T10",
    "Model": "Tab-T10"
  },
  {
    "Retail Branding": "DigiLand",
    "Marketing Name": "Tab-T11",
    "Device": "Tab-T11",
    "Model": "MID1109-SC"
  },
  {
    "Retail Branding": "DigiLand",
    "Marketing Name": "ismart",
    "Device": "MID1016-MK",
    "Model": "MID1016-MK"
  },
  {
    "Retail Branding": "Digicel",
    "Marketing Name": "DL3",
    "Device": "DL3",
    "Model": "DL3"
  },
  {
    "Retail Branding": "Digicel",
    "Marketing Name": "DL3Plus",
    "Device": "DL3Plus",
    "Model": "DL3Plus"
  },
  {
    "Retail Branding": "Digicel",
    "Marketing Name": "DL3Plus",
    "Device": "DL3Plus",
    "Model": "DL3PlusPro"
  },
  {
    "Retail Branding": "Digicel",
    "Marketing Name": "DL3PlusPro",
    "Device": "DL3PlusPro",
    "Model": "DL3PlusPro"
  },
  {
    "Retail Branding": "Digicel",
    "Marketing Name": "DL3_3G",
    "Device": "DL3_3G",
    "Model": "DL3_3G"
  },
  {
    "Retail Branding": "Digicel",
    "Marketing Name": "DL4_Plus",
    "Device": "DL4_Plus",
    "Model": "DL4 Plus"
  },
  {
    "Retail Branding": "Digicel",
    "Marketing Name": "DL4s_TC",
    "Device": "DL4s_TC",
    "Model": "DL4s-TC"
  },
  {
    "Retail Branding": "Digicel",
    "Marketing Name": "DL501",
    "Device": "DL501",
    "Model": "DL501"
  },
  {
    "Retail Branding": "Digicel",
    "Marketing Name": "DL5_Pro",
    "Device": "DL5_Pro",
    "Model": "DL5 Pro"
  },
  {
    "Retail Branding": "Digicel",
    "Marketing Name": "Digi K1",
    "Device": "Digi_K1",
    "Model": "Digi_K1"
  },
  {
    "Retail Branding": "Digicel",
    "Marketing Name": "Digicel DL4",
    "Device": "DL4_2022",
    "Model": "DL4"
  },
  {
    "Retail Branding": "Digicel",
    "Marketing Name": "GO Onyx",
    "Device": "GO_Onyx",
    "Model": "GO Onyx"
  },
  {
    "Retail Branding": "Digicom",
    "Marketing Name": "Digicom_A7_LTE",
    "Device": "Digicom_A7_LTE",
    "Model": "Digicom_A7_LTE"
  },
  {
    "Retail Branding": "Digicom",
    "Marketing Name": "Digicom_DTOK",
    "Device": "Digicom_DTOK",
    "Model": "Digicom DTOK"
  },
  {
    "Retail Branding": "Digicom",
    "Marketing Name": "Tribe",
    "Device": "Tribe",
    "Model": "Digicom Tribe"
  },
  {
    "Retail Branding": "Digicom",
    "Marketing Name": "V7_LTE",
    "Device": "V7_LTE",
    "Model": "V7_LTE"
  },
  {
    "Retail Branding": "Digidragon",
    "Marketing Name": "706Z",
    "Device": "706Z",
    "Model": "706Z"
  },
  {
    "Retail Branding": "Digidragon",
    "Marketing Name": "708Z",
    "Device": "708Z",
    "Model": "708Z"
  },
  {
    "Retail Branding": "Digidragon",
    "Marketing Name": "DS502",
    "Device": "DS502",
    "Model": "DS502"
  },
  {
    "Retail Branding": "Digidragon",
    "Marketing Name": "DS571",
    "Device": "DS571",
    "Model": "DS571"
  },
  {
    "Retail Branding": "Digidragon",
    "Marketing Name": "DS6018",
    "Device": "DS6018",
    "Model": "DS6018"
  },
  {
    "Retail Branding": "Digidragon",
    "Marketing Name": "DS6261",
    "Device": "DS6261",
    "Model": "DS6261"
  },
  {
    "Retail Branding": "Digilite",
    "Marketing Name": "TA70CA1",
    "Device": "TA70CA1",
    "Model": "TA70CA1"
  },
  {
    "Retail Branding": "Digilite",
    "Marketing Name": "TA70CA2",
    "Device": "TA70CA2_1",
    "Model": "TA70CA2"
  },
  {
    "Retail Branding": "Digilite",
    "Marketing Name": "TA70CA3",
    "Device": "TA70CA3_1",
    "Model": "TA70CA3"
  },
  {
    "Retail Branding": "Digilite",
    "Marketing Name": "TR10CD1",
    "Device": "TR10CD1_5",
    "Model": "TR10CD1"
  },
  {
    "Retail Branding": "Digilite",
    "Marketing Name": "TR10CS1",
    "Device": "TR10CS1_3",
    "Model": "TR10CS1"
  },
  {
    "Retail Branding": "Diginnos",
    "Marketing Name": "DG-A97QT",
    "Device": "DG_A97QT",
    "Model": "DG-A97QT"
  },
  {
    "Retail Branding": "Diginnos",
    "Marketing Name": "DG-D07S/GP",
    "Device": "DG-D07SGP",
    "Model": "DG-D07SGP"
  },
  {
    "Retail Branding": "Diginnos",
    "Marketing Name": "DG-Q08M",
    "Device": "DG-Q08M",
    "Model": "DG-Q08M"
  },
  {
    "Retail Branding": "Digiquest",
    "Marketing Name": "DigiquestEA",
    "Device": "GIU7720D",
    "Model": "DigiquestEA"
  },
  {
    "Retail Branding": "Digiquest",
    "Marketing Name": "EU、UK、AP",
    "Device": "martin",
    "Model": "Digiquest 2K Android TV"
  },
  {
    "Retail Branding": "Digiquest",
    "Marketing Name": "Italy",
    "Device": "tamachi",
    "Model": "Digiquest 2K Android TV"
  },
  {
    "Retail Branding": "Digiquest",
    "Marketing Name": "Italy",
    "Device": "yeongdeungpo",
    "Model": "Digiquest 4K Android TV"
  },
  {
    "Retail Branding": "Digit",
    "Marketing Name": "D0068",
    "Device": "D0068",
    "Model": "D0068"
  },
  {
    "Retail Branding": "Digit",
    "Marketing Name": "DIGIT INFINITY",
    "Device": "DIGIT_INFINITY",
    "Model": "DIGIT INFINITY"
  },
  {
    "Retail Branding": "Digit",
    "Marketing Name": "Digit Chrome",
    "Device": "Digit_Chrome",
    "Model": "Digit Chrome"
  },
  {
    "Retail Branding": "Digit",
    "Marketing Name": "Digit Sahara60",
    "Device": "Digit_Sahara60",
    "Model": "Digit Sahara60"
  },
  {
    "Retail Branding": "Digit",
    "Marketing Name": "DigitPad10",
    "Device": "DigitPad10",
    "Model": "DigitPad10"
  },
  {
    "Retail Branding": "Digit",
    "Marketing Name": "Digit_Chrome",
    "Device": "Digit_Chrome",
    "Model": "Digit chrome"
  },
  {
    "Retail Branding": "Digit",
    "Marketing Name": "Digit_Glory",
    "Device": "Digit_Glory1",
    "Model": "Digit Glory1"
  },
  {
    "Retail Branding": "Digit",
    "Marketing Name": "Digitplay1",
    "Device": "Digitplay1",
    "Model": "Digitplay1"
  },
  {
    "Retail Branding": "Digit",
    "Marketing Name": "NOTE 14",
    "Device": "NOTE_14",
    "Model": "NOTE 14"
  },
  {
    "Retail Branding": "Digit",
    "Marketing Name": "NOTE 16",
    "Device": "NOTE_16",
    "Model": "NOTE 16"
  },
  {
    "Retail Branding": "Digit",
    "Marketing Name": "NOTE 20",
    "Device": "NOTE_20",
    "Model": "NOTE 20"
  },
  {
    "Retail Branding": "Digit",
    "Marketing Name": "Sonic_One",
    "Device": "Sonic_One",
    "Model": "Sonic One"
  },
  {
    "Retail Branding": "Digital2",
    "Marketing Name": "Deluxe",
    "Device": "nuclear-D2_Deluxe",
    "Model": "Digital2-Deluxe"
  },
  {
    "Retail Branding": "Digital2",
    "Marketing Name": "Platinum",
    "Device": "D2-963G",
    "Model": "Digital2 Platinum"
  },
  {
    "Retail Branding": "Digital2",
    "Marketing Name": "Plus",
    "Device": "Digital2Plus",
    "Model": "Digital2 Plus"
  },
  {
    "Retail Branding": "DigitalStream",
    "Marketing Name": "DWA1015D Tablet",
    "Device": "DWA1015D",
    "Model": "DWA1015D"
  },
  {
    "Retail Branding": "Digitron",
    "Marketing Name": "i-Buddie",
    "Device": "TR10CD1_10",
    "Model": "TR10CD1"
  },
  {
    "Retail Branding": "Digitron",
    "Marketing Name": "i_Buddie",
    "Device": "TR10CS1_12",
    "Model": "TR10CS1"
  },
  {
    "Retail Branding": "Digix",
    "Marketing Name": "TAB-740_G",
    "Device": "TAB-740_G",
    "Model": "TAB-740_G"
  },
  {
    "Retail Branding": "Digma",
    "Marketing Name": "1402D_4G",
    "Device": "WS1250PL",
    "Model": "1402D 4G WS1250PL"
  },
  {
    "Retail Branding": "Digma",
    "Marketing Name": "CITI 609",
    "Device": "CS6063ML",
    "Model": "CITI 609 4G CS6063ML"
  },
  {
    "Retail Branding": "Digma",
    "Marketing Name": "CITI_1312C_4G",
    "Device": "CS1272PL",
    "Model": "CITI 1312C 4G CS1272PL"
  },
  {
    "Retail Branding": "Digma",
    "Marketing Name": "CITI_13_X703_4G",
    "Device": "CS3242ML",
    "Model": "CITI 13 X703 4G CS3242ML"
  },
  {
    "Retail Branding": "Digma",
    "Marketing Name": "CITI_13_X703_4G",
    "Device": "CS3242ML",
    "Model": "CITI_13_X703_4G_CS3242ML"
  },
  {
    "Retail Branding": "Digma",
    "Marketing Name": "CITI_1590_3G_CS1207MG",
    "Device": "CS1207MG",
    "Model": "CITI 1590 3G CS1207MG"
  },
  {
    "Retail Branding": "Digma",
    "Marketing Name": "CITI_1593_3G_CS1210MG",
    "Device": "CS1210MG",
    "Model": "CITI 1593 3G CS1210MG"
  },
  {
    "Retail Branding": "Digma",
    "Marketing Name": "CITI_7586_3G",
    "Device": "TS7203MG",
    "Model": "CITI_7586_3G_TS7203MG"
  },
  {
    "Retail Branding": "Digma",
    "Marketing Name": "CITI_7591_3G_CS7208MG",
    "Device": "CS7208MG",
    "Model": "CITI 7591 3G CS7208MG"
  },
  {
    "Retail Branding": "Digma",
    "Marketing Name": "CITI_8443E_4G",
    "Device": "CS8271PL",
    "Model": "CITI 8443E 4G CS8271PL"
  },
  {
    "Retail Branding": "Digma",
    "Marketing Name": "CITI_8589_3G_CS8206MG",
    "Device": "CS8206MG",
    "Model": "CITI 8589 3G CS8206MG"
  },
  {
    "Retail Branding": "Digma",
    "Marketing Name": "CITI_Kids",
    "Device": "CS7216MG",
    "Model": "CITI Kids CS7216MG"
  },
  {
    "Retail Branding": "Digma",
    "Marketing Name": "CITI_Kids_10",
    "Device": "CS1232MG",
    "Model": "CITI Kids 10 CS1232MG"
  },
  {
    "Retail Branding": "Digma",
    "Marketing Name": "CITI_Kids_80",
    "Device": "CS8239RW",
    "Model": "CITI Kids 80 CS8239RW"
  },
  {
    "Retail Branding": "Digma",
    "Marketing Name": "CITI_Kids_81_CS8233MG",
    "Device": "CS8233MG",
    "Model": "CITI Kids 81 CS8233MG"
  },
  {
    "Retail Branding": "Digma",
    "Marketing Name": "CITI_Kids_CS7216MG",
    "Device": "CS7216MG",
    "Model": "CITI Kids CS7216MG"
  },
  {
    "Retail Branding": "Digma",
    "Marketing Name": "CITI_Octa_10_CS1219PL",
    "Device": "CS1219PL",
    "Model": "CITI Octa 10 CS1219PL"
  },
  {
    "Retail Branding": "Digma",
    "Marketing Name": "CS1235PL",
    "Device": "CS1235PL",
    "Model": "CITI 10 E402 4G CS1235PL"
  },
  {
    "Retail Branding": "Digma",
    "Marketing Name": "CS7113PL",
    "Device": "CS7113PL",
    "Model": "CITI 7507 4G CS7113PL"
  },
  {
    "Retail Branding": "Digma",
    "Marketing Name": "CS7204MG",
    "Device": "CS7204MG",
    "Model": "CITI 7587 3G CS7204MG"
  },
  {
    "Retail Branding": "Digma",
    "Marketing Name": "CS7217PL",
    "Device": "CS7217PL",
    "Model": "CITI Octa 70 CS7217PL"
  },
  {
    "Retail Branding": "Digma",
    "Marketing Name": "CS7234PL",
    "Device": "CS7234PL",
    "Model": "CITI 7 E401 4G CS7234PL"
  },
  {
    "Retail Branding": "Digma",
    "Marketing Name": "CS8205PG",
    "Device": "CS8205PG",
    "Model": "CITI_8588_3G_CS8205PG"
  },
  {
    "Retail Branding": "Digma",
    "Marketing Name": "CS8218PL",
    "Device": "CS8218PL",
    "Model": "CITI Octa 80 CS8218PL"
  },
  {
    "Retail Branding": "Digma",
    "Marketing Name": "CS8231PL",
    "Device": "CS8231PL",
    "Model": "CITI 8 E400 4G CS8231PL"
  },
  {
    "Retail Branding": "Digma",
    "Marketing Name": "CS8268PL",
    "Device": "CS8268PL",
    "Model": "CITI 8313C 4G CS8268PL"
  },
  {
    "Retail Branding": "Digma",
    "Marketing Name": "DIGMA CITI 1508 4G CS1114ML",
    "Device": "CS1114ML",
    "Model": "CITI_1508_4G_CS1114ML"
  },
  {
    "Retail Branding": "Digma",
    "Marketing Name": "DIGMA CITI 1532 3G CS1144MG",
    "Device": "CS1144MG",
    "Model": "CITI 1532 3G CS1144MG"
  },
  {
    "Retail Branding": "Digma",
    "Marketing Name": "DIGMA CITI 1544 3G CS1154MG",
    "Device": "CS1154MG",
    "Model": "CITI_1544_3G_CS1154MG"
  },
  {
    "Retail Branding": "Digma",
    "Marketing Name": "DIGMA CITI 1576 3G CS1194MG",
    "Device": "CS1194MG",
    "Model": "CITI 1576 3G CS1194MG"
  },
  {
    "Retail Branding": "Digma",
    "Marketing Name": "DIGMA CITI 1577 3G CS1195MG",
    "Device": "CS1195MG",
    "Model": "CITI 1577 3G CS1195MG"
  },
  {
    "Retail Branding": "Digma",
    "Marketing Name": "DIGMA CITI 1578 4G CS1196ML",
    "Device": "CS1196ML",
    "Model": "CITI 1578 4G CS1196ML"
  },
  {
    "Retail Branding": "Digma",
    "Marketing Name": "DIGMA CITI 3000 4G CS3001ML",
    "Device": "CS3001ML",
    "Model": "CITI 3000 4G CS3001ML"
  },
  {
    "Retail Branding": "Digma",
    "Marketing Name": "DIGMA CITI 7507 4G CS7113PL",
    "Device": "CS7113PL",
    "Model": "CITI_7507_4G_CS7113PL"
  },
  {
    "Retail Branding": "Digma",
    "Marketing Name": "DIGMA CITI 7543 3G CS7153MG",
    "Device": "CS7153MG",
    "Model": "CITI_7543_3G_CS7153MG"
  },
  {
    "Retail Branding": "Digma",
    "Marketing Name": "DIGMA CITI 7575 3G CS7193MG",
    "Device": "CS7193MG",
    "Model": "CITI 7575 3G CS7193MG"
  },
  {
    "Retail Branding": "Digma",
    "Marketing Name": "DIGMA CITI 8527 4G CS8139ML",
    "Device": "CS8139ML",
    "Model": "CITI_8527_4G_CS8139ML"
  },
  {
    "Retail Branding": "Digma",
    "Marketing Name": "DIGMA CITI 8531 3G CS8143MG",
    "Device": "CS8143MG",
    "Model": "CITI 8531 3G CS8143MG"
  },
  {
    "Retail Branding": "Digma",
    "Marketing Name": "DIGMA CITI 8542 4G CS8152ML",
    "Device": "CS8152ML",
    "Model": "CITI_8542_4G_CS8152ML"
  },
  {
    "Retail Branding": "Digma",
    "Marketing Name": "DIGMA HIT Q401 3G HT4039PG",
    "Device": "HT4039PG",
    "Model": "HIT Q401 3G HT4039PG"
  },
  {
    "Retail Branding": "Digma",
    "Marketing Name": "DIGMA HIT Q500 3G HT5035PG",
    "Device": "HT5035PG",
    "Model": "HIT Q500 3G HT5035PG"
  },
  {
    "Retail Branding": "Digma",
    "Marketing Name": "DIGMA LINX A453 3G LT4038PG",
    "Device": "LT4038PG",
    "Model": "LINX A453 3G LT4038PG"
  },
  {
    "Retail Branding": "Digma",
    "Marketing Name": "DIGMA LINX ARGO 3G LT4054MG",
    "Device": "LT4054MG",
    "Model": "Linx Argo 3G LT4054MG"
  },
  {
    "Retail Branding": "Digma",
    "Marketing Name": "DIGMA LINX ATOM 3G LT4049PG",
    "Device": "LT4049PG",
    "Model": "LINX ATOM 3G LT4049PG"
  },
  {
    "Retail Branding": "Digma",
    "Marketing Name": "DIGMA LINX B510 3G LT5037MG",
    "Device": "LT5037MG",
    "Model": "LINX B510 3G LT5037MG"
  },
  {
    "Retail Branding": "Digma",
    "Marketing Name": "DIGMA LINX BASE 4G LT5052ML",
    "Device": "LT5052ML",
    "Model": "Linx Base 4G LT5052ML"
  },
  {
    "Retail Branding": "Digma",
    "Marketing Name": "DIGMA LINX Joy 3G LT5048MG",
    "Device": "LT5048MG",
    "Model": "LINX JOY 3G LT5048MG"
  },
  {
    "Retail Branding": "Digma",
    "Marketing Name": "DIGMA LINX PAY 4G LS5053ML",
    "Device": "LS5053ML",
    "Model": "Linx Pay 4G LS5053ML"
  },
  {
    "Retail Branding": "Digma",
    "Marketing Name": "DIGMA LINX RAGE 4G LS5040PL",
    "Device": "LS5040PL",
    "Model": "LINX RAGE 4G LS5040PL"
  },
  {
    "Retail Branding": "Digma",
    "Marketing Name": "DIGMA LINX TRIX 4G LS5041PL",
    "Device": "LS5041PL",
    "Model": "LINX TRIX 4G LS5041PL"
  },
  {
    "Retail Branding": "Digma",
    "Marketing Name": "DIGMA Optima 1022N 3G TS1184MG",
    "Device": "TS1184MG",
    "Model": "Optima 1022N 3G TS1184MG"
  },
  {
    "Retail Branding": "Digma",
    "Marketing Name": "DIGMA Optima 1023N 3G TS1186MG",
    "Device": "TS1186MG",
    "Model": "Optima 1023N 3G TS1186MG"
  },
  {
    "Retail Branding": "Digma",
    "Marketing Name": "DIGMA Optima 1024N 4G TT1188PL",
    "Device": "TT1188PL",
    "Model": "Optima 1024N 4G TT1188PL"
  },
  {
    "Retail Branding": "Digma",
    "Marketing Name": "DIGMA Optima 1025N 4G TS1190ML",
    "Device": "TS1190ML",
    "Model": "Optima 1025N 4G TS1190ML"
  },
  {
    "Retail Branding": "Digma",
    "Marketing Name": "DIGMA Optima 1026N 3G TT1192PG",
    "Device": "TT1192PG",
    "Model": "Optima 1026N 3G TT1192PG"
  },
  {
    "Retail Branding": "Digma",
    "Marketing Name": "DIGMA Optima 7016N 3G TS7175MG",
    "Device": "TS7175MG",
    "Model": "Optima 7016N 3G TS7175MG"
  },
  {
    "Retail Branding": "Digma",
    "Marketing Name": "DIGMA Optima 7017N 3G TS7177MG",
    "Device": "TS7177MG",
    "Model": "Optima 7017N 3G TS7177MG"
  },
  {
    "Retail Branding": "Digma",
    "Marketing Name": "DIGMA Optima 7018N 4G TS7179ML",
    "Device": "TS7179ML",
    "Model": "Optima 7018N 4G TS7179ML"
  },
  {
    "Retail Branding": "Digma",
    "Marketing Name": "DIGMA Optima Prime 3 3G TS7131MG",
    "Device": "TS7131MG",
    "Model": "Optima_Prime_3_3G_TS7131MG"
  },
  {
    "Retail Branding": "Digma",
    "Marketing Name": "DIGMA Optima Prime 4 3G TT7174PG",
    "Device": "TT7174PG",
    "Model": "Optima Prime 4 3G TT7174PG"
  },
  {
    "Retail Branding": "Digma",
    "Marketing Name": "DIGMA Plane 1523 3G PS1135MG",
    "Device": "PS1135MG",
    "Model": "Plane_1523_3G_PS1135MG"
  },
  {
    "Retail Branding": "Digma",
    "Marketing Name": "DIGMA Plane 1524 3G PS1136MG",
    "Device": "PS1136MG",
    "Model": "Plane_1524_3G_PS1136MG"
  },
  {
    "Retail Branding": "Digma",
    "Marketing Name": "DIGMA Plane 1525 3G PS1137MG",
    "Device": "PS1137MG",
    "Model": "Plane_1525_3G_PS1137MG"
  },
  {
    "Retail Branding": "Digma",
    "Marketing Name": "DIGMA Plane 1526 4G PS1138ML",
    "Device": "PS1138ML",
    "Model": "Plane_1526_4G_PS1138ML"
  },
  {
    "Retail Branding": "Digma",
    "Marketing Name": "DIGMA Plane 1537E 3G PS1149MG",
    "Device": "PS1149MG",
    "Model": "Plane_1537E_3G_PS1149MG"
  },
  {
    "Retail Branding": "Digma",
    "Marketing Name": "DIGMA Plane 1538E 3G PS1150ML",
    "Device": "PS1150ML",
    "Model": "Plane_1538E_4G_PS1150ML"
  },
  {
    "Retail Branding": "Digma",
    "Marketing Name": "DIGMA Plane 1541E 4G PS1157ML",
    "Device": "PS1157ML",
    "Model": "Plane_1541E_4G_PS1157ML"
  },
  {
    "Retail Branding": "Digma",
    "Marketing Name": "DIGMA Plane 1550S 3G PS1163MG",
    "Device": "PS1163MG",
    "Model": "Plane_1550S_3G_PS1163MG"
  },
  {
    "Retail Branding": "Digma",
    "Marketing Name": "DIGMA Plane 1551S 4G PS1164ML",
    "Device": "PS1164ML",
    "Model": "Plane_1551S_4G_PS1164ML"
  },
  {
    "Retail Branding": "Digma",
    "Marketing Name": "DIGMA Plane 1553M 4G PS1166ML",
    "Device": "PS1166ML",
    "Model": "Plane_1553M_4G_PS1166ML"
  },
  {
    "Retail Branding": "Digma",
    "Marketing Name": "DIGMA Plane 1559 4G PS1173PL",
    "Device": "PS1173PL",
    "Model": "Plane_1559_4G_PS1173PL"
  },
  {
    "Retail Branding": "Digma",
    "Marketing Name": "DIGMA Plane 1570N 3G PS1185MG",
    "Device": "PS1185MG",
    "Model": "Plane 1570N 3G PS1185MG"
  },
  {
    "Retail Branding": "Digma",
    "Marketing Name": "DIGMA Plane 1572N 3G PS1187MG",
    "Device": "PS1187MG",
    "Model": "Plane 1572N 3G PS1187MG"
  },
  {
    "Retail Branding": "Digma",
    "Marketing Name": "DIGMA Plane 1713T 3G PT1138MG",
    "Device": "PT1138MG",
    "Model": "Plane 1713T 3G PT1138MG"
  },
  {
    "Retail Branding": "Digma",
    "Marketing Name": "DIGMA Plane 1715T 4G PT1139PL",
    "Device": "PT1139PL",
    "Model": "Plane 1715T 4G PT1139PL"
  },
  {
    "Retail Branding": "Digma",
    "Marketing Name": "DIGMA Plane 7006 4G PS7041PL",
    "Device": "PS7041PL",
    "Model": "Plane_7006_4G_PS7041PL"
  },
  {
    "Retail Branding": "Digma",
    "Marketing Name": "DIGMA Plane 7535E 3G PS7147MG",
    "Device": "PS7147MG",
    "Model": "Plane_7535E_3G_PS7147MG"
  },
  {
    "Retail Branding": "Digma",
    "Marketing Name": "DIGMA Plane 7539E 4G PS7155ML",
    "Device": "PS7155ML",
    "Model": "Plane 7539E 4G PS7155ML"
  },
  {
    "Retail Branding": "Digma",
    "Marketing Name": "DIGMA Plane 7545V 3G PS7151MG",
    "Device": "PS7151MG",
    "Model": "Plane_7545V_3G_PS7151MG"
  },
  {
    "Retail Branding": "Digma",
    "Marketing Name": "DIGMA Plane 7552M 3G PS7165MG",
    "Device": "PS7165MG",
    "Model": "Plane_7552M_3G_PS7165MG"
  },
  {
    "Retail Branding": "Digma",
    "Marketing Name": "DIGMA Plane 7556 3G PS7170MG",
    "Device": "PS7170MG",
    "Model": "Plane_7556_3G_PS7170MG"
  },
  {
    "Retail Branding": "Digma",
    "Marketing Name": "DIGMA Plane 7557 4G PS7171PL",
    "Device": "PS7171PL",
    "Model": "Plane_7557_4G_PS7171PL"
  },
  {
    "Retail Branding": "Digma",
    "Marketing Name": "DIGMA Plane 7561N 3G PS7176MG",
    "Device": "PS7176MG",
    "Model": "Plane 7561N 3G PS7176MG"
  },
  {
    "Retail Branding": "Digma",
    "Marketing Name": "DIGMA Plane 7563N 4G PS7178ML",
    "Device": "PS7178ML",
    "Model": "Plane 7563N 4G PS7178ML"
  },
  {
    "Retail Branding": "Digma",
    "Marketing Name": "DIGMA Plane 7565N 3G PS7180PG",
    "Device": "PS7180PG",
    "Model": "Plane 7565N 3G PS7180PG"
  },
  {
    "Retail Branding": "Digma",
    "Marketing Name": "DIGMA Plane 7574S 4G PS7191PL",
    "Device": "PS7191PL",
    "Model": "Plane 7574S 4G PS7191PL"
  },
  {
    "Retail Branding": "Digma",
    "Marketing Name": "DIGMA Plane 8021N 4G PS8183ML",
    "Device": "PS8183ML",
    "Model": "Plane 8021N 4G PS8183ML"
  },
  {
    "Retail Branding": "Digma",
    "Marketing Name": "DIGMA Plane 8540E 4G PS8156ML",
    "Device": "PS8156ML",
    "Model": "Plane_8540E_4G_PS8156ML"
  },
  {
    "Retail Branding": "Digma",
    "Marketing Name": "DIGMA Plane 8558 4G PS8172PL",
    "Device": "PS8172PL",
    "Model": "Plane_8558_4G_PS8172PL"
  },
  {
    "Retail Branding": "Digma",
    "Marketing Name": "DIGMA Plane 8566N 3G PS8181MG",
    "Device": "PS8181MG",
    "Model": "Plane 8566N 3G PS8181MG"
  },
  {
    "Retail Branding": "Digma",
    "Marketing Name": "DIGMA Plane 9634 3G PS9146MG",
    "Device": "PS9146MG",
    "Model": "Plane_9634_3G_PS9146MG"
  },
  {
    "Retail Branding": "Digma",
    "Marketing Name": "DIGMA Plane 9654M 3G PS9167PG",
    "Device": "PS9167PG",
    "Model": "Plane_9654M_3G_PS9167PG"
  },
  {
    "Retail Branding": "Digma",
    "Marketing Name": "DIGMA VOX E502 4G VS5036PL",
    "Device": "VS5036PL",
    "Model": "VOX E502 4G VS5036PL"
  },
  {
    "Retail Branding": "Digma",
    "Marketing Name": "DIGMA VOX Flash 4G VS5015ML",
    "Device": "VS5015ML",
    "Model": "VOX Flash 4G VS5015ML"
  },
  {
    "Retail Branding": "Digma",
    "Marketing Name": "DIGMA VOX G450 3G VS4001PG",
    "Device": "VS4001PG",
    "Model": "VOX G450 3G VS4001PG"
  },
  {
    "Retail Branding": "Digma",
    "Marketing Name": "DIGMA VOX G501 4G VS5033ML",
    "Device": "VS5033ML",
    "Model": "VOX_G501_4G_VS5033ML"
  },
  {
    "Retail Branding": "Digma",
    "Marketing Name": "DIGMA VOX S513 4G VS5035ML",
    "Device": "VS5035ML",
    "Model": "VOX_S513_4G_VS5035ML"
  },
  {
    "Retail Branding": "Digma",
    "Marketing Name": "Digma LINX Alfa 3G LT4047MG",
    "Device": "LT4047MG",
    "Model": "LINX ALFA 3G LT4047MG"
  },
  {
    "Retail Branding": "Digma",
    "Marketing Name": "Digma Optima Prime 5 3G TS7198PG",
    "Device": "TS7198PG",
    "Model": "Optima Prime 5 3G TS7198PG"
  },
  {
    "Retail Branding": "Digma",
    "Marketing Name": "Digma Plane 1584S 3G PS1201PG",
    "Device": "PS1201PG",
    "Model": "Plane 1584S 3G PS1201PG"
  },
  {
    "Retail Branding": "Digma",
    "Marketing Name": "Digma Plane 1585S 4G PS1502PL",
    "Device": "PS1202PL",
    "Model": "Plane 1585S 4G PS1202PL"
  },
  {
    "Retail Branding": "Digma",
    "Marketing Name": "Digma Plane 7580S 4G PS7192PL",
    "Device": "PS7192PL",
    "Model": "Plane 7580S 4G PS7192PL"
  },
  {
    "Retail Branding": "Digma",
    "Marketing Name": "Digma Plane 8580 4G PS8199ML",
    "Device": "PS8199ML",
    "Model": "Plane 8580 4G PS8199ML"
  },
  {
    "Retail Branding": "Digma",
    "Marketing Name": "Digma Platina 1579M 4G NS1800ML",
    "Device": "NS1800ML",
    "Model": "Platina 1579M 4G NS1800ML"
  },
  {
    "Retail Branding": "Digma",
    "Marketing Name": "G8_DA6B8P02",
    "Device": "DA6B8P02",
    "Model": "G8 DA6B8P02"
  },
  {
    "Retail Branding": "Digma",
    "Marketing Name": "HIT Q500 3G HT5035PG",
    "Device": "HT5035PG",
    "Model": "HIT Q500 3G HT5035PG"
  },
  {
    "Retail Branding": "Digma",
    "Marketing Name": "K10_PLUS",
    "Device": "DA1C0P02",
    "Model": "K10 PLUS DA1C0P02"
  },
  {
    "Retail Branding": "Digma",
    "Marketing Name": "LINX A452 3G",
    "Device": "LT4030PG",
    "Model": "LINX A452 3G LT4030PG"
  },
  {
    "Retail Branding": "Digma",
    "Marketing Name": "Linx X1 PRO 3G LS4051MG",
    "Device": "LS4051MG",
    "Model": "Linx X1 PRO 3G LS4051MG"
  },
  {
    "Retail Branding": "Digma",
    "Marketing Name": "Odyssey",
    "Device": "TA4E1M01",
    "Model": "Odyssey TA4E1M01"
  },
  {
    "Retail Branding": "Digma",
    "Marketing Name": "Optima 10 E600 3G TS1246PG",
    "Device": "TS1246PG",
    "Model": "Optima 10 E600 3G TS1246PG"
  },
  {
    "Retail Branding": "Digma",
    "Marketing Name": "Optima 1028 3G TS1215PG",
    "Device": "TS1215PG",
    "Model": "Optima 1028 3G TS1215PG"
  },
  {
    "Retail Branding": "Digma",
    "Marketing Name": "Optima 1411D 4G TS1273PL",
    "Device": "TS1273PL",
    "Model": "Optima 1411D 4G TS1273PL"
  },
  {
    "Retail Branding": "Digma",
    "Marketing Name": "Optima 1440E 4G TS1269PL",
    "Device": "TS1269PL",
    "Model": "Optima 1440E 4G TS1269PL"
  },
  {
    "Retail Branding": "Digma",
    "Marketing Name": "Optima 7 A102 3G TS7243PG",
    "Device": "TS7243PG",
    "Model": "Optima 7 A102 3G TS7243PG"
  },
  {
    "Retail Branding": "Digma",
    "Marketing Name": "Optima 7 E200 3G TS7244PG",
    "Device": "TS7244PG",
    "Model": "Optima 7 E200 3G TS7244PG"
  },
  {
    "Retail Branding": "Digma",
    "Marketing Name": "Optima 8258C 4G TS8275ML",
    "Device": "TS8275ML",
    "Model": "Optima 8258C 4G TS8275ML"
  },
  {
    "Retail Branding": "Digma",
    "Marketing Name": "Optima Kids 7",
    "Device": "TS7203RW",
    "Model": "Optima Kids 7 TS7203RW"
  },
  {
    "Retail Branding": "Digma",
    "Marketing Name": "Optima_10_A500S_3G_TS1220PG",
    "Device": "TS1220PG",
    "Model": "Optima 10 A500S 3G TS1220PG"
  },
  {
    "Retail Branding": "Digma",
    "Marketing Name": "Optima_10_A502_3G_TS1245PG",
    "Device": "TS1245PG",
    "Model": "Optima 10 A502 3G TS1245PG"
  },
  {
    "Retail Branding": "Digma",
    "Marketing Name": "Optima_10_X702_4G",
    "Device": "TS1228PL",
    "Model": "Optima 10 X702 4G TS1228PL"
  },
  {
    "Retail Branding": "Digma",
    "Marketing Name": "Optima_1200B",
    "Device": "TS1266RW",
    "Model": "Optima 1200B TS1266RW"
  },
  {
    "Retail Branding": "Digma",
    "Marketing Name": "Optima_7_A100S_3G_TS7222PG",
    "Device": "TS7222PG",
    "Model": "Optima 7 A100S 3G TS7222PG"
  },
  {
    "Retail Branding": "Digma",
    "Marketing Name": "Optima_7_A101_3G",
    "Device": "TT7223PG",
    "Model": "Optima 7 A101 3G TT7223PG"
  },
  {
    "Retail Branding": "Digma",
    "Marketing Name": "Optima_7_X700_4G",
    "Device": "TS7224PL",
    "Model": "Optima 7 X700 4G TS7224PL"
  },
  {
    "Retail Branding": "Digma",
    "Marketing Name": "Optima_8019N_4G",
    "Device": "TS8182ML",
    "Model": "Optima 8019N 4G TS8182ML"
  },
  {
    "Retail Branding": "Digma",
    "Marketing Name": "Optima_8027_3G",
    "Device": "TS8211PG",
    "Model": "Optima_8027_3G_TS8211PG"
  },
  {
    "Retail Branding": "Digma",
    "Marketing Name": "Optima_8250C",
    "Device": "TS8274AW",
    "Model": "TS8274AW"
  },
  {
    "Retail Branding": "Digma",
    "Marketing Name": "Optima_8_X701_4G",
    "Device": "TS8226PL",
    "Model": "Optima 8 X701 4G TS8226PL"
  },
  {
    "Retail Branding": "Digma",
    "Marketing Name": "Optima_8_Z801_4G",
    "Device": "TS8227PL",
    "Model": "Optima 8 Z801 4G TS8227PL"
  },
  {
    "Retail Branding": "Digma",
    "Marketing Name": "PRO 1600E 4G",
    "Device": "RS1248PL",
    "Model": "PRO 1600E 4G RS1248PL"
  },
  {
    "Retail Branding": "Digma",
    "Marketing Name": "PRO 1800F 4G",
    "Device": "RS1249PL",
    "Model": "PRO 1800F 4G RS1249PL"
  },
  {
    "Retail Branding": "Digma",
    "Marketing Name": "PS7210PG",
    "Device": "PS7210PG",
    "Model": "Plane 7594 3G PS7210PG"
  },
  {
    "Retail Branding": "Digma",
    "Marketing Name": "PS8163PL",
    "Device": "PS8163PL",
    "Model": "Plane 8550S 4G PS8163PL"
  },
  {
    "Retail Branding": "Digma",
    "Marketing Name": "Plane 7012M 3G PS7082MG",
    "Device": "PS7082MG",
    "Model": "Plane_7012M_3G_PS7082MG"
  },
  {
    "Retail Branding": "Digma",
    "Marketing Name": "Plane 7546S 3G",
    "Device": "PS7158PG",
    "Model": "Plane_7546S_3G_PS7158PG"
  },
  {
    "Retail Branding": "Digma",
    "Marketing Name": "Plane 7547S 3G",
    "Device": "PS7159PG",
    "Model": "Plane_7547S_3G_PS7159PG"
  },
  {
    "Retail Branding": "Digma",
    "Marketing Name": "Plane 7547S 3G PS7159PG",
    "Device": "PS7159PG",
    "Model": "Plane 7547S 3G PS7159PG"
  },
  {
    "Retail Branding": "Digma",
    "Marketing Name": "Plane 8522 3G PS8135MG",
    "Device": "PS8135MG",
    "Model": "Plane_8522_3G_PS8135MG"
  },
  {
    "Retail Branding": "Digma",
    "Marketing Name": "Plane 8536E 3G PS8148MG",
    "Device": "PS8148MG",
    "Model": "Plane_8536E_3G_PS8148MG"
  },
  {
    "Retail Branding": "Digma",
    "Marketing Name": "Plane 8555M 4G PS8168ML",
    "Device": "PS8168ML",
    "Model": "Plane 8555M 4G PS8168ML"
  },
  {
    "Retail Branding": "Digma",
    "Marketing Name": "Plane 8595 3G PS8212PG",
    "Device": "PS8212PG",
    "Model": "Plane 8595 3G PS8212PG"
  },
  {
    "Retail Branding": "Digma",
    "Marketing Name": "Plane_1573N_4G/",
    "Device": "PS1189ML",
    "Model": "Plane 1573N 4G PS1189ML"
  },
  {
    "Retail Branding": "Digma",
    "Marketing Name": "Plane_1596_3G_PS1213PG",
    "Device": "PS1213PG",
    "Model": "Plane 1596 3G PS1213PG"
  },
  {
    "Retail Branding": "Digma",
    "Marketing Name": "Plane_7548S_4G_PS7160PL",
    "Device": "PS7160PL",
    "Model": "Plane_7548S_4G_PS7160PL"
  },
  {
    "Retail Branding": "Digma",
    "Marketing Name": "Plane_8548S_3G",
    "Device": "PS8161PG",
    "Model": "Plane_8548S_3G_PS8161PG"
  },
  {
    "Retail Branding": "Digma",
    "Marketing Name": "Plane_8549S_4G",
    "Device": "PS8162PL",
    "Model": "Plane_8549S_4G_PS8162PL"
  },
  {
    "Retail Branding": "Digma",
    "Marketing Name": "Pro 1480E 4G",
    "Device": "RS1267PL",
    "Model": "Pro 1480E 4G RS1267PL"
  },
  {
    "Retail Branding": "Digma",
    "Marketing Name": "R8",
    "Device": "DA1C8P02",
    "Model": "R8 DA1C8P02"
  },
  {
    "Retail Branding": "Digma",
    "Marketing Name": "RS1253PL",
    "Device": "RS1253PL",
    "Model": "PRO 1400E 4G RS1253PL"
  },
  {
    "Retail Branding": "Digma",
    "Marketing Name": "TS1221PL",
    "Device": "TS1221PL",
    "Model": "Optima 10 A501S 4G TS1221PL"
  },
  {
    "Retail Branding": "Digma",
    "Marketing Name": "TS1229PL",
    "Device": "TS1229PL",
    "Model": "Optima 10 Z802 4G TS1229PL"
  },
  {
    "Retail Branding": "Digma",
    "Marketing Name": "TS1277ML",
    "Device": "TS1277ML",
    "Model": "Optima 1245C 4G"
  },
  {
    "Retail Branding": "Digma",
    "Marketing Name": "TS7225PL",
    "Device": "TS7225PL",
    "Model": "Optima 7 Z800 4G TS7225PL"
  },
  {
    "Retail Branding": "Digma",
    "Marketing Name": "TT1236PG",
    "Device": "TT1236PG",
    "Model": "Optima 1027N 3G TT1236PG"
  },
  {
    "Retail Branding": "Digma",
    "Marketing Name": "VOX E502 4G VS5036PL",
    "Device": "VS5036PL",
    "Model": "VOX E502 4G VS5036PL"
  },
  {
    "Retail Branding": "Digma",
    "Marketing Name": "VOX FIRE 4G VS5037PL",
    "Device": "VS5037PL",
    "Model": "VOX FIRE 4G VS5037PL"
  },
  {
    "Retail Branding": "Digma",
    "Marketing Name": "VOX_S508_3G",
    "Device": "VS5031PG",
    "Model": "VOX S508 3G VS5031PG"
  },
  {
    "Retail Branding": "Digma",
    "Marketing Name": "VOX_S509_3G",
    "Device": "VS5032PG",
    "Model": "VOX S509 3G VS5032PG"
  },
  {
    "Retail Branding": "Digma",
    "Marketing Name": "Vox V40 3G VT4055MG",
    "Device": "VT4055MG",
    "Model": "Vox V40 3G VT4055MG"
  },
  {
    "Retail Branding": "Digma",
    "Marketing Name": "Z10",
    "Device": "DA6B0P01",
    "Model": "Z10 DA6B0P01"
  },
  {
    "Retail Branding": "Dinax",
    "Marketing Name": "DX_TA7001",
    "Device": "DX_TA7001",
    "Model": "DX_TA7001"
  },
  {
    "Retail Branding": "Dinax",
    "Marketing Name": "DX_TABDELTA1",
    "Device": "DX_TABDELTA1",
    "Model": "DX_TABDELTA1"
  },
  {
    "Retail Branding": "Dinax",
    "Marketing Name": "DX_TASL83",
    "Device": "DX_TASL83",
    "Model": "DX_TASL83"
  },
  {
    "Retail Branding": "Dinax",
    "Marketing Name": "DX_TA_7001",
    "Device": "DX_TA_7001",
    "Model": "DX_TA_7001"
  },
  {
    "Retail Branding": "Dinax",
    "Marketing Name": "DX_TA_SL83",
    "Device": "DX_TA_SL83",
    "Model": "DX_TA_SL83"
  },
  {
    "Retail Branding": "DingDong",
    "Marketing Name": "IB101F_UAG",
    "Device": "IB101F_UAG",
    "Model": "IB101F_UAG"
  },
  {
    "Retail Branding": "Dingding",
    "Marketing Name": "X10",
    "Device": "X10",
    "Model": "X10"
  },
  {
    "Retail Branding": "Dingding",
    "Marketing Name": "X11",
    "Device": "X11",
    "Model": "X11"
  },
  {
    "Retail Branding": "Dingding",
    "Marketing Name": "X11S",
    "Device": "X11S",
    "Model": "X11S"
  },
  {
    "Retail Branding": "Dingding",
    "Marketing Name": "X12",
    "Device": "X12",
    "Model": "X12"
  },
  {
    "Retail Branding": "Dintech",
    "Marketing Name": "STAB8765B2-16",
    "Device": "STAB8765B2-16",
    "Model": "STAB8765B2-16"
  },
  {
    "Retail Branding": "Dish",
    "Marketing Name": "AirTV Player",
    "Device": "uiw4010ech",
    "Model": "AirTV Player"
  },
  {
    "Retail Branding": "Dish",
    "Marketing Name": "CSSL104DBL16",
    "Device": "SL104D",
    "Model": "SL104D"
  },
  {
    "Retail Branding": "Dish",
    "Marketing Name": "Celero 5G",
    "Device": "Jupiter",
    "Model": "WTCELERO5G"
  },
  {
    "Retail Branding": "Dish",
    "Marketing Name": "Celero 5G 2.0",
    "Device": "DSH98123",
    "Model": "Celero5G"
  },
  {
    "Retail Branding": "Dish",
    "Marketing Name": "Celero3 5G",
    "Device": "U653DS",
    "Model": "Celero3 5G"
  },
  {
    "Retail Branding": "Dish",
    "Marketing Name": "Celero3 5G+",
    "Device": "U695DS",
    "Model": "Celero3 5G+"
  },
  {
    "Retail Branding": "Dish",
    "Marketing Name": "Celero5G SC",
    "Device": "SN339D",
    "Model": "SN339D"
  },
  {
    "Retail Branding": "Dish",
    "Marketing Name": "EU001",
    "Device": "EU001",
    "Model": "EU001"
  },
  {
    "Retail Branding": "Dish",
    "Marketing Name": "EVOLVE",
    "Device": "dish_cable_bcm",
    "Model": "SH960C-DS"
  },
  {
    "Retail Branding": "Dish",
    "Marketing Name": "EVOLVE 2",
    "Device": "m377_dish",
    "Model": "EVOLVE 2"
  },
  {
    "Retail Branding": "Dish",
    "Marketing Name": "Hopper Plus",
    "Device": "SNAP2",
    "Model": "Hopper Plus"
  },
  {
    "Retail Branding": "Dish",
    "Marketing Name": "Joey 4",
    "Device": "ATVMJ4",
    "Model": "Joey 4"
  },
  {
    "Retail Branding": "Dish",
    "Marketing Name": "SL201D",
    "Device": "SL201D",
    "Model": "SL201D"
  },
  {
    "Retail Branding": "Dish",
    "Marketing Name": "SV10",
    "Device": "HiCast",
    "Model": "SV10"
  },
  {
    "Retail Branding": "Dish",
    "Marketing Name": "Summit 5G",
    "Device": "SN339D-SMT",
    "Model": "SN339D-SMT"
  },
  {
    "Retail Branding": "Dish",
    "Marketing Name": "Wireless Joey 4",
    "Device": "ATVWJ4",
    "Model": "Wireless Joey 4"
  },
  {
    "Retail Branding": "DishTV (IN)",
    "Marketing Name": "D-805XATV HD",
    "Device": "SEI110",
    "Model": "D-805XATV HD"
  },
  {
    "Retail Branding": "DishTV (IN)",
    "Marketing Name": "DV-905XSTV",
    "Device": "smart4K",
    "Model": "DV-905XSTV"
  },
  {
    "Retail Branding": "DishTV (IN)",
    "Marketing Name": "DV-905XSTV HTL",
    "Device": "smart4K",
    "Model": "DV-905XSTV HTL"
  },
  {
    "Retail Branding": "DishTV-NZ",
    "Marketing Name": "A7070",
    "Device": "STB",
    "Model": "A7070"
  },
  {
    "Retail Branding": "DishTV-NZ",
    "Marketing Name": "A7080",
    "Device": "SEI730BSVU",
    "Model": "A7080"
  },
  {
    "Retail Branding": "DishTV-NZ",
    "Marketing Name": "SV10",
    "Device": "HiCast",
    "Model": "SV10"
  },
  {
    "Retail Branding": "DishTV-NZ",
    "Marketing Name": "SV11",
    "Device": "ICN",
    "Model": "SV11"
  },
  {
    "Retail Branding": "DishTV-NZ",
    "Marketing Name": "SV11HD",
    "Device": "IAD",
    "Model": "SV11HD"
  },
  {
    "Retail Branding": "DishTV-NZ",
    "Marketing Name": "SmartVU Freeview Projector | Google TV",
    "Device": "tianshan",
    "Model": "SVPro1"
  },
  {
    "Retail Branding": "Disney",
    "Marketing Name": "DISNEYTAB",
    "Device": "DISNEYTAB",
    "Model": "DISNEYTAB"
  },
  {
    "Retail Branding": "Disney",
    "Marketing Name": "Frozen_G9",
    "Device": "Frozen_G9",
    "Model": "Frozen_G9"
  },
  {
    "Retail Branding": "Disney",
    "Marketing Name": "Princess_G9",
    "Device": "Princess_G9",
    "Model": "Princess_G9"
  },
  {
    "Retail Branding": "Disney Frozen",
    "Marketing Name": "BMF00001",
    "Device": "BMF00001",
    "Model": "Frozen"
  },
  {
    "Retail Branding": "Disney Frozen",
    "Marketing Name": "DC_COMICS",
    "Device": "DC_COMICS",
    "Model": "DC_COMICS"
  },
  {
    "Retail Branding": "Disney Frozen",
    "Marketing Name": "DYF00001",
    "Device": "DYF00001",
    "Model": "DYF00001"
  },
  {
    "Retail Branding": "Disney Frozen",
    "Marketing Name": "FROZEN",
    "Device": "FROZEN",
    "Model": "FROZEN"
  },
  {
    "Retail Branding": "Disney Frozen",
    "Marketing Name": "MARVEL",
    "Device": "MARVEL",
    "Model": "MARVEL"
  },
  {
    "Retail Branding": "Disney Frozen",
    "Marketing Name": "PRINCESS",
    "Device": "PRINCESS",
    "Model": "PRINCESS"
  },
  {
    "Retail Branding": "Disney Pixar",
    "Marketing Name": "Toy_story",
    "Device": "Toy_story",
    "Model": "Toy_story"
  },
  {
    "Retail Branding": "Ditecma",
    "Marketing Name": "Blade",
    "Device": "Blade",
    "Model": "Blade"
  },
  {
    "Retail Branding": "Ditecma",
    "Marketing Name": "M1092R",
    "Device": "M1092R",
    "Model": "M1092R"
  },
  {
    "Retail Branding": "Ditecma",
    "Marketing Name": "M1092RV5",
    "Device": "M1092RV5",
    "Model": "M1092RV5"
  },
  {
    "Retail Branding": "Ditecma",
    "Marketing Name": "M1092Rv4",
    "Device": "M1092Rv4",
    "Model": "M1092Rv4"
  },
  {
    "Retail Branding": "Ditecma",
    "Marketing Name": "Smart TV",
    "Device": "longshan",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "Ditecma",
    "Marketing Name": "XP",
    "Device": "XP",
    "Model": "XP"
  },
  {
    "Retail Branding": "Ditigron",
    "Marketing Name": "i-Buddie",
    "Device": "TR10CD1_11",
    "Model": "TR10CD1"
  },
  {
    "Retail Branding": "Diva",
    "Marketing Name": "QC1004GM",
    "Device": "QC1004GM",
    "Model": "QC1004GM"
  },
  {
    "Retail Branding": "Diva",
    "Marketing Name": "QC7704GM",
    "Device": "QC7704GM",
    "Model": "QC7704GM"
  },
  {
    "Retail Branding": "Diva",
    "Marketing Name": "QC804GM",
    "Device": "QC804GM",
    "Model": "QC804GM"
  },
  {
    "Retail Branding": "Diva",
    "Marketing Name": "T10K_Plus",
    "Device": "T10K_Plus",
    "Model": "T10K_Plus"
  },
  {
    "Retail Branding": "Diva",
    "Marketing Name": "T7K_PLUS_SE3_EEA",
    "Device": "T7K_PLUS_SE3_EEA",
    "Model": "T7K_PLUS_SE3_EEA"
  },
  {
    "Retail Branding": "Dixon",
    "Marketing Name": "ACK1010",
    "Device": "ACK1010",
    "Model": "ACK1010"
  },
  {
    "Retail Branding": "Dixon",
    "Marketing Name": "DFM48",
    "Device": "DFM48",
    "Model": "DFM48"
  },
  {
    "Retail Branding": "Dixon",
    "Marketing Name": "DN6015",
    "Device": "DN6015",
    "Model": "DN6015"
  },
  {
    "Retail Branding": "Dixon",
    "Marketing Name": "DN6023D",
    "Device": "DN6023D",
    "Model": "DN6023D"
  },
  {
    "Retail Branding": "Dixon",
    "Marketing Name": "DN6901",
    "Device": "DN6901",
    "Model": "DN6901"
  },
  {
    "Retail Branding": "Dixon",
    "Marketing Name": "HK7-3502",
    "Device": "HK7-3502",
    "Model": "HK7-3502"
  },
  {
    "Retail Branding": "Dixon",
    "Marketing Name": "KT5509",
    "Device": "KT5509",
    "Model": "KT5509"
  },
  {
    "Retail Branding": "Dixon",
    "Marketing Name": "KT5512",
    "Device": "KT5512",
    "Model": "KT5512"
  },
  {
    "Retail Branding": "Dixon",
    "Marketing Name": "L-5",
    "Device": "L-5",
    "Model": "L-5"
  },
  {
    "Retail Branding": "Dixon",
    "Marketing Name": "L1",
    "Device": "L1",
    "Model": "L1"
  },
  {
    "Retail Branding": "Dixon",
    "Marketing Name": "S5790",
    "Device": "S5790",
    "Model": "S5790"
  },
  {
    "Retail Branding": "Dixon",
    "Marketing Name": "S90",
    "Device": "S90",
    "Model": "S90"
  },
  {
    "Retail Branding": "Dixon",
    "Marketing Name": "TS-M105D",
    "Device": "TS-M105D",
    "Model": "TS-M105D"
  },
  {
    "Retail Branding": "Dixon",
    "Marketing Name": "TS-M105D-MKII",
    "Device": "TS-M105D-MKII",
    "Model": "TS-M105D-MKII"
  },
  {
    "Retail Branding": "Dixon",
    "Marketing Name": "TS-M105G-1",
    "Device": "TS-M105G-1",
    "Model": "TS-M105G-1"
  },
  {
    "Retail Branding": "Dixon",
    "Marketing Name": "TS-M704F-1",
    "Device": "TS-M704F-1",
    "Model": "TS-M704F-1"
  },
  {
    "Retail Branding": "Dixon",
    "Marketing Name": "TS-M704G",
    "Device": "TS-M704G",
    "Model": "TS-M704G"
  },
  {
    "Retail Branding": "Dixon",
    "Marketing Name": "TS_M103A",
    "Device": "TS_M103A",
    "Model": "TS_M103A"
  },
  {
    "Retail Branding": "Docomo",
    "Marketing Name": "F-06F",
    "Device": "F06F",
    "Model": "F-06F"
  },
  {
    "Retail Branding": "Docomo",
    "Marketing Name": "Japan",
    "Device": "TT01",
    "Model": "TT01"
  },
  {
    "Retail Branding": "Docomo",
    "Marketing Name": "MEDIAS TAB UL N-08D",
    "Device": "N-08D",
    "Model": "N-08D"
  },
  {
    "Retail Branding": "Docomo",
    "Marketing Name": "TT02",
    "Device": "TT02",
    "Model": "TT02"
  },
  {
    "Retail Branding": "Docomo",
    "Marketing Name": "d-01J",
    "Device": "d-01J",
    "Model": "d-01J"
  },
  {
    "Retail Branding": "Docomo",
    "Marketing Name": "d-01K",
    "Device": "d-01K",
    "Model": "d-01K"
  },
  {
    "Retail Branding": "Docomo",
    "Marketing Name": "d-02K",
    "Device": "d-02K",
    "Model": "d-02K"
  },
  {
    "Retail Branding": "Dolamee",
    "Marketing Name": "D8",
    "Device": "DV8235",
    "Model": "D8"
  },
  {
    "Retail Branding": "Dom.ru",
    "Marketing Name": "Movix Pro",
    "Device": "SEI200",
    "Model": "Movix Pro"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "B10",
    "Device": "1932_2",
    "Model": "B10"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "BL12000",
    "Device": "Selfie",
    "Model": "BL12000"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "BL12000 PRO",
    "Device": "t758_dg_a67t_n",
    "Model": "BL12000 PRO"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "BL5000",
    "Device": "BL5000",
    "Model": "BL5000"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "BL5500_Lite",
    "Device": "BL5500_Lite",
    "Model": "BL5500_Lite"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "BL7000",
    "Device": "BL7000",
    "Model": "BL7000"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "Blade GT",
    "Device": "M24C",
    "Model": "Blade GT"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "Blade GT Play",
    "Device": "ZN140",
    "Model": "Blade GT Play"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "Blade GT Pro",
    "Device": "M24C",
    "Model": "Blade GT"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "Blade GT Pro",
    "Device": "ZN140S",
    "Model": "Blade GT Pro"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "Blade GT Ultra",
    "Device": "M24CT",
    "Model": "Blade GT Ultra"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "Blade GT Ultra",
    "Device": "M24CT_2",
    "Model": "Blade GT Ultra"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "Blade10",
    "Device": "F1CK",
    "Model": "Blade10"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "Blade10 Energy",
    "Device": "F1CK_Pro",
    "Model": "Blade10 Energy"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "Blade10 Max",
    "Device": "F1P",
    "Model": "Blade10 Max"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "Blade10 Power",
    "Device": "F1G",
    "Model": "Blade10 Power"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "Blade10 Pro",
    "Device": "F1C",
    "Model": "Blade10 Pro"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "Blade10 Pro Energy",
    "Device": "F1C_Pro",
    "Model": "Blade10 Pro Energy"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "Blade10 Ultra",
    "Device": "F1CT",
    "Model": "Blade10 Ultra"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "Blade10 Ultra Energy",
    "Device": "F1CT_Pro",
    "Model": "Blade10 Ultra Energy"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "Blade20",
    "Device": "F1GC",
    "Model": "Blade20"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "Blade20 Max",
    "Device": "F1GT",
    "Model": "Blade20 Max"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "Blade20 Play",
    "Device": "F1T",
    "Model": "Blade20 Play"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "Blade20 Pro",
    "Device": "F1TK",
    "Model": "Blade20 Pro"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "Blade20 Pro Max",
    "Device": "F1PT",
    "Model": "Blade20 Pro Max"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "Blade20 Turbo",
    "Device": "F1_Plus",
    "Model": "Blade20 Turbo"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "Blade20 Ultra",
    "Device": "F1PS",
    "Model": "Blade20 Ultra"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "DK10",
    "Device": "ZN138",
    "Model": "DK10"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "F10",
    "Device": "F1",
    "Model": "F10"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "F10S",
    "Device": "F1C",
    "Model": "Blade10 Pro"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "F10S",
    "Device": "F1C",
    "Model": "F10S"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "Fire 3",
    "Device": "M21SC",
    "Model": "Fire 3"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "Fire 3 Max",
    "Device": "M21SU",
    "Model": "Fire 3 Max"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "Fire 3 Pro",
    "Device": "M21SE",
    "Model": "Fire 3 Pro"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "Fire 3 Ultra",
    "Device": "M21ST",
    "Model": "Fire 3 Ultra"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "Fire 5",
    "Device": "G1C",
    "Model": "Fire 5"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "Fire 5 Pro",
    "Device": "G1",
    "Model": "Fire 5 Pro"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "Fire 5 Ultra",
    "Device": "G1E",
    "Model": "Fire 5 Ultra"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "Fire 6",
    "Device": "F1SE",
    "Model": "Fire 6"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "Fire 6 Max",
    "Device": "M24SE",
    "Model": "Fire 6 Max"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "Fire 6 Power",
    "Device": "F1S",
    "Model": "Fire 6 Power"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "Fire 7",
    "Device": "G1T",
    "Model": "Fire 7"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "Fire 7 Max",
    "Device": "G2T",
    "Model": "Fire 7 Ultra"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "Fire 7 Pro",
    "Device": "G1TS",
    "Model": "Fire 7 Pro"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "Fire_6",
    "Device": "F1SE",
    "Model": "Fire 6"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "Fire_6_Power",
    "Device": "F1S",
    "Model": "F10 Pro"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "Fire_6_Power",
    "Device": "F1S",
    "Model": "Fire 6 Power"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "M30 Max",
    "Device": "1930P",
    "Model": "M30 Pro"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "MIX",
    "Device": "t766_dg_n_mix",
    "Model": "MIX"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "MIX Lite",
    "Device": "t766_dg_a66",
    "Model": "MIX Lite"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "Mix",
    "Device": "MIX",
    "Model": "MIX"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "N10",
    "Device": "Y7",
    "Model": "N10"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "N100",
    "Device": "N100",
    "Model": "N100"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "N10_EEA",
    "Device": "Y7",
    "Model": "N10"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "N10_EEA",
    "Device": "Y7",
    "Model": "N10_EEA"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "N20",
    "Device": "N20",
    "Model": "N20"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "N20Pro",
    "Device": "N20Pro",
    "Model": "N20Pro"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "N30",
    "Device": "N30",
    "Model": "N30"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "N30E",
    "Device": "N30E",
    "Model": "N30E"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "N40Plus",
    "Device": "N40Plus",
    "Model": "N40Pro"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "N40Pro",
    "Device": "N40Pro",
    "Model": "N40Pro"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "N40Pro_RU",
    "Device": "N40Pro",
    "Model": "N40Pro"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "N50",
    "Device": "1918Y",
    "Model": "N50"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "N50 Plus",
    "Device": "1918P",
    "Model": "N50 Plus"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "N50Pro",
    "Device": "1918N",
    "Model": "N50Pro"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "N50S",
    "Device": "1918D",
    "Model": "N50S"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "N53",
    "Device": "1928D",
    "Model": "N53"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "N55",
    "Device": 1928,
    "Model": "N55"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "N55 Plus",
    "Device": "1928Y",
    "Model": "N55 Plus"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "N55 Pro",
    "Device": "1928P",
    "Model": "N55 Pro"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "N55S",
    "Device": "1928S",
    "Model": "N55S"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "N56",
    "Device": "1928E",
    "Model": "N56"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "N56 Max",
    "Device": "1928N",
    "Model": "N56 Max"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "N56 Plus",
    "Device": "1928P",
    "Model": "N55 Pro"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "N56 Plus",
    "Device": "1928P",
    "Model": "N56 Plus"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "N56 Pro",
    "Device": "1928T",
    "Model": "N56 Pro"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "N60Pro",
    "Device": 1919,
    "Model": "N60Pro"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "N70",
    "Device": "1925T",
    "Model": "N70"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "Note 56",
    "Device": "1928C",
    "Model": "Note 56"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "Note 56X",
    "Device": "1928SC",
    "Model": "Note56 X"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "Note 58",
    "Device": "1929C",
    "Model": "Note 58"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "Note 59",
    "Device": "1929SC",
    "Model": "Note 59"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "Note56 Plus",
    "Device": "1928CV",
    "Model": "Note56 Plus"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "Note56 Pro",
    "Device": "1928CT",
    "Model": "Note56 Pro"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "Note56X Pro",
    "Device": "1928SE",
    "Model": "Note56X Pro"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "Note58 Pro",
    "Device": "1929H",
    "Model": "Note58 Pro"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "Note59 Pro",
    "Device": "1929SH",
    "Model": "Note59 Pro"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "Note59 Pro+",
    "Device": "1929ST",
    "Model": "Note59 Pro+"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "P3Mini Kid",
    "Device": "P3Mini_Kid",
    "Model": "T20Mini Kid"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "R08",
    "Device": "PT3",
    "Model": "R08"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "R10",
    "Device": "PT1",
    "Model": "R10"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "R10",
    "Device": "PT1",
    "Model": "R10 Pro"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "R20",
    "Device": "PT2",
    "Model": "R20"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "S cyber",
    "Device": "M22GS",
    "Model": "S cyber"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "S cyber Pro",
    "Device": "M22GTS",
    "Model": "S cyber Pro"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "S punk",
    "Device": "M22C",
    "Model": "S punk"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "S punk Pro",
    "Device": "M22CT",
    "Model": "S Punk Pro"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "S100",
    "Device": "M22",
    "Model": "S100"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "S100Pro",
    "Device": "M22H",
    "Model": "S100Pro"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "S108",
    "Device": "M22G",
    "Model": "S108"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "S108",
    "Device": "M22G",
    "Model": "S118"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "S110",
    "Device": "M22P",
    "Model": "S110"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "S118",
    "Device": "M22G",
    "Model": "S118"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "S118 Pro",
    "Device": "M23UT",
    "Model": "S118 Pro"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "S119",
    "Device": "F2PS",
    "Model": "S119"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "S119 Pro",
    "Device": "F2PH_2",
    "Model": "S119 Pro"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "S120",
    "Device": "M22C",
    "Model": "S punk"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "S200",
    "Device": "M24P",
    "Model": "S200"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "S200 Max",
    "Device": "M24S",
    "Model": "S200 Max"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "S200 Plus",
    "Device": "M24PS",
    "Model": "S200 Plus"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "S200 Plus",
    "Device": "M24PST",
    "Model": "S200 Plus"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "S200 Plus",
    "Device": "M24PS_2",
    "Model": "S200 Plus"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "S200 Pro",
    "Device": "M24PS",
    "Model": "S200 Plus"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "S200 Ultra",
    "Device": "M24PX",
    "Model": "S200 Ultra"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "S200 X",
    "Device": "M24PT",
    "Model": "S200 X"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "S30",
    "Device": "S30",
    "Model": "S30"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "S300 Plus",
    "Device": "M25T",
    "Model": "S300 Plus"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "S300 Plus Thermal",
    "Device": "M25S",
    "Model": "S300 Plus Thermal"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "S35",
    "Device": "S35",
    "Model": "S35"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "S35",
    "Device": "S35H",
    "Model": "S35"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "S35Pro",
    "Device": "S35Pro",
    "Model": "S35Pro"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "S35T",
    "Device": "S35T",
    "Model": "S35T"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "S35_RU",
    "Device": "S35",
    "Model": "S35"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "S40",
    "Device": "S40",
    "Model": "S40"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "S40Lite",
    "Device": "S40Lite",
    "Model": "S40Lite"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "S40Pro",
    "Device": "S40Pro",
    "Model": "S40Pro"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "S41",
    "Device": "M21",
    "Model": "S41"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "S41",
    "Device": "M21TE",
    "Model": "S41T"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "S41 Max",
    "Device": "M21TU",
    "Model": "S41 Max"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "S41 Plus",
    "Device": "M21TP",
    "Model": "S41 Plus"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "S41Pro",
    "Device": "M21T",
    "Model": "S41Pro"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "S41T",
    "Device": "M21T",
    "Model": "S41Pro"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "S41T",
    "Device": "M21TE",
    "Model": "S41T"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "S50",
    "Device": "t758_dg_m3t_n",
    "Model": "S50"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "S51",
    "Device": "S51",
    "Model": "S51"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "S55",
    "Device": "S55",
    "Model": "S55"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "S55_Lite",
    "Device": "S55_Lite",
    "Model": "S55_Lite"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "S58Pro",
    "Device": "S58Pro",
    "Model": "S58Pro"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "S59",
    "Device": "S59",
    "Model": "S59"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "S59Pro",
    "Device": "S59Pro",
    "Model": "S59Pro"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "S60",
    "Device": "S60",
    "Model": "S60"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "S60 Lite",
    "Device": "t777_dg_m1_65_n",
    "Model": "S60 Lite"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "S60Lite",
    "Device": "S60Lite",
    "Model": "S60Lite"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "S61",
    "Device": "S61",
    "Model": "S61"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "S61Pro",
    "Device": "M19H",
    "Model": "S61Pro"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "S68Pro",
    "Device": "S68Pro",
    "Model": "S68Pro"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "S70",
    "Device": "S70",
    "Model": "S70"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "S70Lite",
    "Device": "S70Lite",
    "Model": "S70Lite"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "S80",
    "Device": "S80",
    "Model": "S80"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "S80Lite",
    "Device": "S80Lite",
    "Model": "S80Lite"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "S86",
    "Device": "S86",
    "Model": "S86"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "S86Pro",
    "Device": "S86Pro",
    "Model": "S86Pro"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "S88Plus",
    "Device": "S88Plus",
    "Model": "S88Plus"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "S88Pro",
    "Device": "S88Pro",
    "Model": "S88Pro"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "S89",
    "Device": "S89",
    "Model": "S89"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "S89Pro",
    "Device": "S89Pro",
    "Model": "S89Pro"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "S90C",
    "Device": "S90C",
    "Model": "S90C"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "S90Pro",
    "Device": "S90Pro",
    "Model": "S90Pro"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "S90pro",
    "Device": "S90Pro",
    "Model": "S90Pro"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "S95",
    "Device": "S95",
    "Model": "S95"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "S95Pro",
    "Device": "S95Pro",
    "Model": "S95Pro"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "S96GT",
    "Device": "S96Pro",
    "Model": "S96GT"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "S96Pro",
    "Device": "S96Pro",
    "Model": "S96Pro"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "S97Pro",
    "Device": "S97Pro",
    "Model": "S97Pro"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "S97Pro_RU",
    "Device": "S97Pro",
    "Model": "S97Pro"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "S98",
    "Device": "S98",
    "Model": "S98"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "S98Pro",
    "Device": "S98Pro",
    "Model": "S98Pro"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "S99",
    "Device": "ZN136T",
    "Model": "S99"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "Shoot_ 1",
    "Device": "Shoot_1",
    "Model": "Shoot_1"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "Smini",
    "Device": "ZN137",
    "Model": "Smini"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "T10",
    "Device": "P1",
    "Model": "T10"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "T10",
    "Device": "P1_2",
    "Model": "T10"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "T10 Pro",
    "Device": "P1S_2",
    "Model": "T10Pro"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "T10E",
    "Device": "P4",
    "Model": "T10E"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "T10E",
    "Device": "P4",
    "Model": "T40"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "T10Plus",
    "Device": "P1T",
    "Model": "T10PLUS"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "T10Plus",
    "Device": "P1T",
    "Model": "T10Plus"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "T10Pro",
    "Device": "P1_2",
    "Model": "T10Pro"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "T10S",
    "Device": "P1D",
    "Model": "T10S"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "T10SE",
    "Device": "P4",
    "Model": "T10E"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "T10W",
    "Device": "P1TC",
    "Model": "T10W"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "T10W",
    "Device": "T1",
    "Model": "T10W"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "T20",
    "Device": "P2",
    "Model": "T20"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "T20",
    "Device": "P2_2",
    "Model": "T20"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "T20 Pro",
    "Device": "P2TE",
    "Model": "T20 Pro"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "T20Mini",
    "Device": "P3Mini",
    "Model": "T20Mini"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "T20Mini Pro",
    "Device": "P3MiniS",
    "Model": "T20Mini Pro"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "T20S",
    "Device": "P2D",
    "Model": "T20S"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "T20Ultra",
    "Device": "P2T",
    "Model": "T20Ultra"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "T30 Max",
    "Device": "P3T",
    "Model": "T30 Max"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "T30 Mini",
    "Device": "P3MiniTE_2",
    "Model": "T30 Mini"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "T30 Mini Pro",
    "Device": "P3MiniT",
    "Model": "T30 Mini Pro"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "T30 SE",
    "Device": "P3C",
    "Model": "T30 SE"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "T30E",
    "Device": "P3G",
    "Model": "T30E"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "T30E Pro",
    "Device": "P3GS",
    "Model": "T30E Pro"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "T30Pro",
    "Device": "P3Pro",
    "Model": "T30Pro"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "T30Pro",
    "Device": "P3Pro",
    "Model": "T35"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "T30S",
    "Device": "P3D",
    "Model": "T30S"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "T30S",
    "Device": "P3D_2",
    "Model": "T30S"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "T30Ultra",
    "Device": "P3",
    "Model": "T30Ultra"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "T36",
    "Device": "P7",
    "Model": "T36"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "T40",
    "Device": "P3_Plus",
    "Model": "T40"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "T40 Pro",
    "Device": "P2TH",
    "Model": "T40 Pro"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "T5",
    "Device": "T5",
    "Model": "T5"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "T5S",
    "Device": "T5S",
    "Model": "T5S"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "Tab A9",
    "Device": "RK5",
    "Model": "Tab A9"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "Tab A9 Pro",
    "Device": "RK5Kid",
    "Model": "Tab A9 Pro"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "Tab A9 Pro",
    "Device": "RK5S",
    "Model": "Tab A9 Pro"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "Tab A9 Pro Kid",
    "Device": "RK5SKid_2",
    "Model": "Tab A9 Pro Kid"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "Tab A9 Pro+",
    "Device": "T2CS",
    "Model": "Tab A9 Pro+"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "Tab A9+",
    "Device": "T2C",
    "Model": "Tab A9+"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "Tab E3",
    "Device": "P4S",
    "Model": "Tab E3"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "Tab E3 Max",
    "Device": "P6",
    "Model": "Tab E3 Max"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "Tab E3 Max",
    "Device": "P6T",
    "Model": "Tab E3 Max"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "Tab E3 Pro",
    "Device": "P5S",
    "Model": "Tab E3 Pro"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "Tab E3 Pro",
    "Device": "P5S_2",
    "Model": "Tab E3 Pro"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "Tab E3+",
    "Device": "P7S",
    "Model": "Tab E3+"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "Tab G5",
    "Device": "T5",
    "Model": "Tab G5"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "Tab G6",
    "Device": "T3",
    "Model": "Tab G6"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "Tab G6 Max",
    "Device": "P8",
    "Model": "Tab G6 Max"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "Tab G6 Pro",
    "Device": "P7W",
    "Model": "Tab G6 Pro"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "Tab G6+",
    "Device": "T4",
    "Model": "Tab G6+"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "U10",
    "Device": "RK1",
    "Model": "U10"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "U10 Pro",
    "Device": "RK1S",
    "Model": "U10 Pro"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "U10KID",
    "Device": "RK1KID",
    "Model": "U10 Kid"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "U10KID",
    "Device": "RK1KID",
    "Model": "U10Kid"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "U11",
    "Device": "T2",
    "Model": "T2"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "U11",
    "Device": "T2",
    "Model": "U11"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "U11 Kid",
    "Device": "T2Kid",
    "Model": "U11 Kid"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "U11 Pro",
    "Device": "T2U",
    "Model": "U11 Pro"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "U11 Pro Kid",
    "Device": "T2UKid",
    "Model": "U11 Kid Pro"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "U12",
    "Device": "P7C",
    "Model": "U12"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "U13",
    "Device": "P5C",
    "Model": "U13"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "U8",
    "Device": "RK3",
    "Model": "U8"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "U8 Kid",
    "Device": "RK3KID",
    "Model": "U8 Kid"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "U9",
    "Device": "RK2",
    "Model": "U9"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "U9 Kid",
    "Device": "RK2KID",
    "Model": "U9 Kid"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "U9Pro",
    "Device": "T1",
    "Model": "U9 Pro"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "V MAX",
    "Device": "M23H",
    "Model": "V Max"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "V Max",
    "Device": "M23H",
    "Model": "V Max"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "V Max",
    "Device": "M23HR",
    "Model": "V Max"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "V Max 2 Pro",
    "Device": "M25H",
    "Model": "V Max 2 Pro"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "V Max LR",
    "Device": "ZN139S",
    "Model": "V Max LR"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "V Max Play",
    "Device": "ZN139T",
    "Model": "V Max Play"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "V Max Plus",
    "Device": "M23HT",
    "Model": "V Max Plus"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "V Max Pro",
    "Device": "M23HC",
    "Model": "V Max Pro"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "V Max Pro",
    "Device": "M23HC_1",
    "Model": "V Max Pro"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "V Max S",
    "Device": "M23HE",
    "Model": "V Max S"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "V Pad",
    "Device": "P2TU",
    "Model": "V Pad"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "V10",
    "Device": "V10",
    "Model": "V10"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "V10",
    "Device": "V10",
    "Model": "V11"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "V20",
    "Device": "V20",
    "Model": "V20"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "V20Pro",
    "Device": "ZN133T",
    "Model": "V20Pro"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "V20S",
    "Device": "ZN133S",
    "Model": "V20S"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "V30",
    "Device": "M23",
    "Model": "V30"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "V30Pro",
    "Device": "M23",
    "Model": "V30"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "V30Pro",
    "Device": "M23U",
    "Model": "V30Pro"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "V30T",
    "Device": "M23T",
    "Model": "V30T"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "V31GT",
    "Device": "M23S",
    "Model": "V31GT"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "V40",
    "Device": "ZN138",
    "Model": "DK10"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "V40",
    "Device": "ZN138N",
    "Model": "V40"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "V40",
    "Device": "ZN138PE",
    "Model": "V40"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "V40 Max",
    "Device": "ZN138PS",
    "Model": "V40 Max"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "V40 Pro",
    "Device": "ZN138P",
    "Model": "V40 Pro"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "V40 X",
    "Device": "ZN138PET",
    "Model": "V40 X"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "V50 Ultra",
    "Device": "M25P",
    "Model": "V50 Pro"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "X10",
    "Device": "doogee-X10",
    "Model": "DOOGEE X10"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "X100",
    "Device": "X100",
    "Model": "X100"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "X11",
    "Device": "X11",
    "Model": "X11"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "X12",
    "Device": "X12",
    "Model": "X12"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "X20",
    "Device": "X20",
    "Model": "X20"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "X20L",
    "Device": "X20L",
    "Model": "X20L"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "X30",
    "Device": "X30",
    "Model": "X30"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "X5  MAX",
    "Device": "X5max",
    "Model": "X5max"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "X5 max pro",
    "Device": "X5max_PRO",
    "Model": "X5max_PRO"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "X50",
    "Device": "X50",
    "Model": "X50"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "X50L",
    "Device": "X50L",
    "Model": "X50L"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "X53",
    "Device": "X53",
    "Model": "X53"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "X55",
    "Device": "X55",
    "Model": "X55"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "X60",
    "Device": "X60",
    "Model": "X60"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "X60L",
    "Device": "X60L",
    "Model": "X60L"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "X60L",
    "Device": "t596_dg_d5506_x60l",
    "Model": "X60L"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "X60L",
    "Device": "t596_dg_x60l",
    "Model": "X60L"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "X6pro",
    "Device": "x5602_fxkj_k20",
    "Model": "X6pro"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "X7",
    "Device": "s6061_dg_a50_m",
    "Model": "X7"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "X70",
    "Device": "X70",
    "Model": "X70"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "X70",
    "Device": "X70_RU",
    "Model": "X70"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "X7Pro",
    "Device": "x6069_dg_a50_37m65",
    "Model": "X7pro"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "X80",
    "Device": "X80",
    "Model": "X80"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "X9 Mini",
    "Device": "X9_Mini",
    "Model": "X9 Mini"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "X9 Mini",
    "Device": "t530_dg_a54",
    "Model": "X9 Mini"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "X9 Pro",
    "Device": "X9pro",
    "Model": "X9pro"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "X90",
    "Device": "X90",
    "Model": "X90"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "X90L",
    "Device": "X90L",
    "Model": "X90L"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "X93",
    "Device": "X93",
    "Model": "X93"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "X93Pro",
    "Device": "X93Pro",
    "Model": "X93Pro"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "X95",
    "Device": "X95",
    "Model": "X95"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "X95Pro",
    "Device": "X95Pro",
    "Model": "X95Pro"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "X95i",
    "Device": "X95i",
    "Model": "X95i"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "X96",
    "Device": "X96",
    "Model": "X96"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "X96",
    "Device": "X96T",
    "Model": "X96"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "X96Pro",
    "Device": "X96Pro",
    "Model": "X96Pro"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "X96Pro",
    "Device": "X96ProT",
    "Model": "X96Pro"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "X97",
    "Device": 1917,
    "Model": "X97"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "X97Pro",
    "Device": "X97Pro",
    "Model": "X97Pro"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "X98",
    "Device": 1918,
    "Model": "X98"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "X98Pro",
    "Device": "1918T",
    "Model": "X98Pro"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "X9S",
    "Device": "X9S",
    "Model": "X9S"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "Y10",
    "Device": "Y10",
    "Model": "Y10"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "Y6",
    "Device": "Y6",
    "Model": "Y6"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "Y6 C",
    "Device": "Y6C",
    "Model": "Y6C"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "Y6 Max",
    "Device": "Y6_Max",
    "Model": "Y6 Max"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "Y7",
    "Device": "Y7",
    "Model": "Y7"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "Y7Plus",
    "Device": "Y7Plus",
    "Model": "Y7Plus"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "Y8",
    "Device": "Y8",
    "Model": "Y8"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "Y8C",
    "Device": "Y8C",
    "Model": "Y8C"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "Y8plus",
    "Device": "Y8Plus",
    "Model": "Y8 Plus"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "Y9Plus",
    "Device": "Y9Plus",
    "Model": "Y9Plus"
  },
  {
    "Retail Branding": "Doogee",
    "Marketing Name": "shoot 2",
    "Device": "t591_dga57_we",
    "Model": "Shoot_2"
  },
  {
    "Retail Branding": "Doopro",
    "Marketing Name": "C1",
    "Device": "C1",
    "Model": "C1"
  },
  {
    "Retail Branding": "Doopro",
    "Marketing Name": "C1_Pro",
    "Device": "C1_Pro",
    "Model": "C1_Pro"
  },
  {
    "Retail Branding": "Doopro",
    "Marketing Name": "G10",
    "Device": "T1_2",
    "Model": "G10"
  },
  {
    "Retail Branding": "Doopro",
    "Marketing Name": "G11",
    "Device": "P4_2",
    "Model": "G11"
  },
  {
    "Retail Branding": "Doopro",
    "Marketing Name": "G20",
    "Device": "P1TE",
    "Model": "G20"
  },
  {
    "Retail Branding": "Doopro",
    "Marketing Name": "G8",
    "Device": "RK3_2",
    "Model": "G8"
  },
  {
    "Retail Branding": "Doopro",
    "Marketing Name": "G8 Kid",
    "Device": "RK3KID_2",
    "Model": "G8 Kid"
  },
  {
    "Retail Branding": "Doopro",
    "Marketing Name": "P1",
    "Device": "P1",
    "Model": "P1"
  },
  {
    "Retail Branding": "Doopro",
    "Marketing Name": "P1_Pro",
    "Device": "P1_Pro",
    "Model": "P1_Pro"
  },
  {
    "Retail Branding": "Doopro",
    "Marketing Name": "P2",
    "Device": "br6580_weg_n",
    "Model": "P2"
  },
  {
    "Retail Branding": "Doopro",
    "Marketing Name": "P2_Pro",
    "Device": "P2_Pro",
    "Model": "P2_Pro"
  },
  {
    "Retail Branding": "Doopro",
    "Marketing Name": "P4",
    "Device": "P4",
    "Model": "P4"
  },
  {
    "Retail Branding": "Doopro",
    "Marketing Name": "P4_Pro",
    "Device": "P4_Pro",
    "Model": "P4_Pro"
  },
  {
    "Retail Branding": "Doopro",
    "Marketing Name": "Play 10 Pro",
    "Device": "P3_Mini_TE",
    "Model": "Play 10 Pro"
  },
  {
    "Retail Branding": "Doopro",
    "Marketing Name": "Play 11",
    "Device": "P3F",
    "Model": "Play 11"
  },
  {
    "Retail Branding": "Doopro",
    "Marketing Name": "Play 11 Pro",
    "Device": "P3_2",
    "Model": "Play 11 Pro"
  },
  {
    "Retail Branding": "Doopro",
    "Marketing Name": "Y10",
    "Device": "P3A",
    "Model": "Y10"
  },
  {
    "Retail Branding": "Doopro",
    "Marketing Name": "Y10 Plus",
    "Device": "P3AE",
    "Model": "Y10 Plus"
  },
  {
    "Retail Branding": "Doopro",
    "Marketing Name": "Y10 Pro",
    "Device": "P3D_3",
    "Model": "Y10 Pro"
  },
  {
    "Retail Branding": "Doopro",
    "Marketing Name": "Y10 Ultra",
    "Device": "P3AS",
    "Model": "Y10 Ultra"
  },
  {
    "Retail Branding": "Dopo",
    "Marketing Name": "DP7856K",
    "Device": "DP7856K",
    "Model": "DP7856K"
  },
  {
    "Retail Branding": "Dopo",
    "Marketing Name": "DPA23D",
    "Device": "polaris-wifionly",
    "Model": "DPA23D"
  },
  {
    "Retail Branding": "Dopo",
    "Marketing Name": "DPM1081",
    "Device": "RCT6203W46",
    "Model": "DPM1081"
  },
  {
    "Retail Branding": "Dopo",
    "Marketing Name": "DPM7827",
    "Device": "RCT6773W22",
    "Model": "DPM7827"
  },
  {
    "Retail Branding": "Dopo",
    "Marketing Name": "EM63 Tablet",
    "Device": "EM63",
    "Model": "EM63"
  },
  {
    "Retail Branding": "Dopo",
    "Marketing Name": "GS-918",
    "Device": "GS_918",
    "Model": "GS-918"
  },
  {
    "Retail Branding": "Doppio",
    "Marketing Name": "Allure M2",
    "Device": "Doppio_DP355",
    "Model": "Doppio DP355"
  },
  {
    "Retail Branding": "Doppio",
    "Marketing Name": "DP500",
    "Device": "DP500",
    "Model": "DP500"
  },
  {
    "Retail Branding": "Doppio",
    "Marketing Name": "Doppio Capuchino",
    "Device": "Doppio_S4128",
    "Model": "Doppio Capuchino"
  },
  {
    "Retail Branding": "Doppio",
    "Marketing Name": "Doppio SL548",
    "Device": "Doppio_SL548",
    "Model": "SL548"
  },
  {
    "Retail Branding": "Doppio",
    "Marketing Name": "Doppio_SL505",
    "Device": "Doppio_SL505",
    "Model": "SL505"
  },
  {
    "Retail Branding": "Doppio",
    "Marketing Name": "SG402",
    "Device": "SG402",
    "Model": "SG402"
  },
  {
    "Retail Branding": "Doppio",
    "Marketing Name": "SG504",
    "Device": "SG504",
    "Model": "SG504"
  },
  {
    "Retail Branding": "Doppio",
    "Marketing Name": "SL452",
    "Device": "SL452",
    "Model": "SL452"
  },
  {
    "Retail Branding": "Doppio",
    "Marketing Name": "SL513",
    "Device": "SL513",
    "Model": "SL513"
  },
  {
    "Retail Branding": "Doppio",
    "Marketing Name": "SL558",
    "Device": "Doppio_SL558",
    "Model": "SL558"
  },
  {
    "Retail Branding": "Doppio",
    "Marketing Name": "U400",
    "Device": "U400",
    "Model": "U400"
  },
  {
    "Retail Branding": "Doppio",
    "Marketing Name": "U450",
    "Device": "U450",
    "Model": "U450"
  },
  {
    "Retail Branding": "Doppio",
    "Marketing Name": "U500",
    "Device": "U500",
    "Model": "U500"
  },
  {
    "Retail Branding": "Doppio",
    "Marketing Name": "U503",
    "Device": "U503",
    "Model": "U503"
  },
  {
    "Retail Branding": "Doro",
    "Marketing Name": "8020x",
    "Device": "Doro_8020x",
    "Model": "Doro_8020x"
  },
  {
    "Retail Branding": "Doro",
    "Marketing Name": 8031,
    "Device": "DSB0010",
    "Model": "Doro 8031"
  },
  {
    "Retail Branding": "Doro",
    "Marketing Name": 8040,
    "Device": "DSB0090",
    "Model": "Doro 8040"
  },
  {
    "Retail Branding": "Doro",
    "Marketing Name": 822,
    "Device": "DSB0010",
    "Model": "Doro 8030"
  },
  {
    "Retail Branding": "Doro",
    "Marketing Name": 822,
    "Device": "DSB0010",
    "Model": "Doro 8031"
  },
  {
    "Retail Branding": "Doro",
    "Marketing Name": 824,
    "Device": "825A",
    "Model": "Doro 824"
  },
  {
    "Retail Branding": "Doro",
    "Marketing Name": "825A",
    "Device": "825A",
    "Model": "Doro 824"
  },
  {
    "Retail Branding": "Doro",
    "Marketing Name": "825A",
    "Device": "825A",
    "Model": "Doro Liberto 825"
  },
  {
    "Retail Branding": "Doro",
    "Marketing Name": "DSB-0220",
    "Device": "DSB0220",
    "Model": "DSB-0220"
  },
  {
    "Retail Branding": "Doro",
    "Marketing Name": "DSB-0230",
    "Device": "DSB0230",
    "Model": "DSB-0230"
  },
  {
    "Retail Branding": "Doro",
    "Marketing Name": "DSB0010",
    "Device": "DSB0010",
    "Model": "Doro 8030"
  },
  {
    "Retail Branding": "Doro",
    "Marketing Name": "DSB0010",
    "Device": "DSB0010",
    "Model": "Doro 8030/8031/8028"
  },
  {
    "Retail Branding": "Doro",
    "Marketing Name": "Doro 8031",
    "Device": "DSB0010",
    "Model": "Doro 8031"
  },
  {
    "Retail Branding": "Doro",
    "Marketing Name": "Doro 8035",
    "Device": "DSB0170",
    "Model": "Doro 8035"
  },
  {
    "Retail Branding": "Doro",
    "Marketing Name": "Doro 8040",
    "Device": "DSB0090",
    "Model": "Doro 8040"
  },
  {
    "Retail Branding": "Doro",
    "Marketing Name": "Doro 8042",
    "Device": "DSB0110",
    "Model": "Doro 8042"
  },
  {
    "Retail Branding": "Doro",
    "Marketing Name": "Doro 8050",
    "Device": "DSB0230",
    "Model": "Doro 8050"
  },
  {
    "Retail Branding": "Doro",
    "Marketing Name": "Doro 8100",
    "Device": "DSB0400",
    "Model": "Doro 8100"
  },
  {
    "Retail Branding": "Doro",
    "Marketing Name": "Doro 8200",
    "Device": "DSB0440",
    "Model": "Doro 8200"
  },
  {
    "Retail Branding": "Doro",
    "Marketing Name": "Doro 8220",
    "Device": "DSB0440",
    "Model": "Doro 8200"
  },
  {
    "Retail Branding": "Doro",
    "Marketing Name": "Doro 824",
    "Device": "825A",
    "Model": "Doro 824"
  },
  {
    "Retail Branding": "Doro",
    "Marketing Name": "Doro Aurora A10",
    "Device": "DSB0550",
    "Model": "Doro Aurora A10"
  },
  {
    "Retail Branding": "Doro",
    "Marketing Name": "Doro Aurora A20",
    "Device": "DSC0540",
    "Model": "Doro Aurora A20"
  },
  {
    "Retail Branding": "Doro",
    "Marketing Name": "Doro Aurora A30",
    "Device": "DSB0560",
    "Model": "Doro Aurora A30"
  },
  {
    "Retail Branding": "Doro",
    "Marketing Name": "Doro Tablet",
    "Device": "DTO0410",
    "Model": "Doro Tablet"
  },
  {
    "Retail Branding": "Doro",
    "Marketing Name": "Liberto 810",
    "Device": "Liberto810",
    "Model": "Doro Liberto 810"
  },
  {
    "Retail Branding": "Doro",
    "Marketing Name": "Liberto 810",
    "Device": "Liberto810",
    "Model": "Doro Liberto 810-orange"
  },
  {
    "Retail Branding": "Doro",
    "Marketing Name": "Liberto 810",
    "Device": "Liberto810_S12",
    "Model": "Doro Liberto 810"
  },
  {
    "Retail Branding": "Doro",
    "Marketing Name": "Liberto 820",
    "Device": "Liberto820",
    "Model": "Doro Liberto 820"
  },
  {
    "Retail Branding": "Doro",
    "Marketing Name": "Liberto 820 Mini",
    "Device": "820Mini",
    "Model": "Doro Liberto 820 Mini"
  },
  {
    "Retail Branding": "Doro",
    "Marketing Name": "Liberto 822 / 8030",
    "Device": "DSB0010",
    "Model": "Doro 8030"
  },
  {
    "Retail Branding": "Doro",
    "Marketing Name": "Liberto 822 / 8030",
    "Device": "DSB0010",
    "Model": "Doro 8030/8031/8028"
  },
  {
    "Retail Branding": "Doro",
    "Marketing Name": "Liberto 822 / 8030",
    "Device": "DSB0010",
    "Model": "Doro 8031"
  },
  {
    "Retail Branding": "Doro",
    "Marketing Name": "Liberto 822 / 8030",
    "Device": "DSB0010",
    "Model": "Doro Liberto 822"
  },
  {
    "Retail Branding": "Doro",
    "Marketing Name": "Liberto 825",
    "Device": "825A",
    "Model": "825_T-Mobile"
  },
  {
    "Retail Branding": "Dotpad",
    "Marketing Name": "Fire V8",
    "Device": "FIRE_V8",
    "Model": "FIRE_V8"
  },
  {
    "Retail Branding": "Dragontouch",
    "Marketing Name": "DragonTouch",
    "Device": "MAX-10",
    "Model": "MAX-10"
  },
  {
    "Retail Branding": "Dragontouch",
    "Marketing Name": "DragonTouch",
    "Device": "MAX-10_EEA",
    "Model": "MAX-10_EEA"
  },
  {
    "Retail Branding": "Dragontouch",
    "Marketing Name": "Dragon_Touch",
    "Device": "MAX_10",
    "Model": "MAX_10"
  },
  {
    "Retail Branding": "Dragontouch",
    "Marketing Name": "K8",
    "Device": "K8",
    "Model": "K8"
  },
  {
    "Retail Branding": "Dragontouch",
    "Marketing Name": "KidzPad_Y80",
    "Device": "KidzPad_Y80",
    "Model": "KidzPad_Y80"
  },
  {
    "Retail Branding": "Dragontouch",
    "Marketing Name": "KidzPad_Y88X_8",
    "Device": "KidzPad_Y88X_8",
    "Model": "KidzPad_Y88X_8"
  },
  {
    "Retail Branding": "Dragontouch",
    "Marketing Name": "KidzPad_Y88X_8_EEA",
    "Device": "KidzPad_Y88X_8_EEA",
    "Model": "KidzPad_Y88X_8_EEA"
  },
  {
    "Retail Branding": "Dragontouch",
    "Marketing Name": "M10",
    "Device": "M10",
    "Model": "M10"
  },
  {
    "Retail Branding": "Dragontouch",
    "Marketing Name": "M7",
    "Device": "M7",
    "Model": "M7"
  },
  {
    "Retail Branding": "Dragontouch",
    "Marketing Name": "MAX_10",
    "Device": "MAX_10",
    "Model": "MAX 10"
  },
  {
    "Retail Branding": "Dragontouch",
    "Marketing Name": "MAX_10_EEA",
    "Device": "MAX_10_EEA",
    "Model": "MAX 10"
  },
  {
    "Retail Branding": "Dragontouch",
    "Marketing Name": "MAX_10_eea",
    "Device": "MAX_10_EEA",
    "Model": "MAX_10"
  },
  {
    "Retail Branding": "Dragontouch",
    "Marketing Name": "NotePad_101_B",
    "Device": "NotePad_101_B",
    "Model": "NotePad_101_B"
  },
  {
    "Retail Branding": "Dragontouch",
    "Marketing Name": "NotePad_101_B_EEA",
    "Device": "NotePad_101_B",
    "Model": "NotePad_101_B"
  },
  {
    "Retail Branding": "Dragontouch",
    "Marketing Name": "NotePad_101_B_EEA",
    "Device": "NotePad_101_B",
    "Model": "NotePad_101_B_EEA"
  },
  {
    "Retail Branding": "Dragontouch",
    "Marketing Name": "NotePad_102",
    "Device": "NotePad_102",
    "Model": "NotePad_102"
  },
  {
    "Retail Branding": "Dragontouch",
    "Marketing Name": "NotePad_Y80",
    "Device": "NotePad_Y80",
    "Model": "NotePad_Y80"
  },
  {
    "Retail Branding": "Dragontouch",
    "Marketing Name": "Notepad-K10",
    "Device": "Notepad-K10",
    "Model": "Notepad-K10"
  },
  {
    "Retail Branding": "Dragontouch",
    "Marketing Name": "Notepad102",
    "Device": "Notepad102",
    "Model": "Notepad 102"
  },
  {
    "Retail Branding": "Dragontouch",
    "Marketing Name": "Notepad102_EEA",
    "Device": "Notepad102_EEA",
    "Model": "Notepad 102"
  },
  {
    "Retail Branding": "Dragontouch",
    "Marketing Name": "NotepadGo801",
    "Device": "NotepadGo801",
    "Model": "Notepad_Go_801"
  },
  {
    "Retail Branding": "Dragontouch",
    "Marketing Name": "NotepadGo801_EEA",
    "Device": "NotepadGo801_EEA",
    "Model": "Notepad_Go_801_EEA"
  },
  {
    "Retail Branding": "Dragontouch",
    "Marketing Name": "Notepad_Go_801",
    "Device": "Notepad_Go_801",
    "Model": "Notepad_Go_801"
  },
  {
    "Retail Branding": "Dragontouch",
    "Marketing Name": "Notepad_Go_801_EEA",
    "Device": "Notepad_Go_801",
    "Model": "Notepad_Go_801_EEA"
  },
  {
    "Retail Branding": "Dragontouch",
    "Marketing Name": "Notepad_Go_803",
    "Device": "Notepad_Go_803",
    "Model": "Notepad_Go_803"
  },
  {
    "Retail Branding": "Dragontouch",
    "Marketing Name": "S10M",
    "Device": "S10M",
    "Model": "S10M"
  },
  {
    "Retail Branding": "Dragontouch",
    "Marketing Name": "S10M_EEA",
    "Device": "S10M_EEA",
    "Model": "S10M_EEA"
  },
  {
    "Retail Branding": "Dragontouch",
    "Marketing Name": "S11M",
    "Device": "S11M",
    "Model": "S11M"
  },
  {
    "Retail Branding": "Dragontouch",
    "Marketing Name": "T10M",
    "Device": "T10M",
    "Model": "T10M"
  },
  {
    "Retail Branding": "Dragontouch",
    "Marketing Name": "T10M_EEA",
    "Device": "T10M_EEA",
    "Model": "T10M_EEA"
  },
  {
    "Retail Branding": "Dragontouch",
    "Marketing Name": "T11M",
    "Device": "T11M",
    "Model": "T11M"
  },
  {
    "Retail Branding": "Dragontouch",
    "Marketing Name": "T12M",
    "Device": "T12M",
    "Model": "T12M"
  },
  {
    "Retail Branding": "Dragontouch",
    "Marketing Name": "T12M_EEA",
    "Device": "T12M_EEA",
    "Model": "T12M_EEA"
  },
  {
    "Retail Branding": "Dragontouch",
    "Marketing Name": "V10",
    "Device": "V10",
    "Model": "V10"
  },
  {
    "Retail Branding": "Dragontouch",
    "Marketing Name": "X10",
    "Device": "X10A",
    "Model": "X10"
  },
  {
    "Retail Branding": "Dragontouch",
    "Marketing Name": "X10",
    "Device": "tulip-d210",
    "Model": "X10"
  },
  {
    "Retail Branding": "Dragontouch",
    "Marketing Name": "X7",
    "Device": "X7",
    "Model": "X7"
  },
  {
    "Retail Branding": "Dragontouch",
    "Marketing Name": "X80",
    "Device": "X80",
    "Model": "X80"
  },
  {
    "Retail Branding": "Dragontouch",
    "Marketing Name": "X80 Plus",
    "Device": "X80PLUS",
    "Model": "X80 Plus"
  },
  {
    "Retail Branding": "Dragontouch",
    "Marketing Name": "Y80",
    "Device": "Y80",
    "Model": "Y80"
  },
  {
    "Retail Branding": "Dragontouch",
    "Marketing Name": "Y88X Plus",
    "Device": "Y88X_A",
    "Model": "Y88X_A"
  },
  {
    "Retail Branding": "Dragontouch",
    "Marketing Name": "Y88X Plus",
    "Device": "Y88X_PLUS",
    "Model": "Y88X Plus"
  },
  {
    "Retail Branding": "Dragontouch",
    "Marketing Name": "Y88X Plus",
    "Device": "Y88X_PLUS",
    "Model": "Y88X_PLUS"
  },
  {
    "Retail Branding": "Dragontouch",
    "Marketing Name": "Y88X_PRO",
    "Device": "Y88X_PRO",
    "Model": "Y88X_PRO"
  },
  {
    "Retail Branding": "Dragontouch",
    "Marketing Name": "Y88X_PRO_EEA",
    "Device": "Y88X_PRO",
    "Model": "Y88X_PRO"
  },
  {
    "Retail Branding": "Dragontouch",
    "Marketing Name": "Y88X__PLUS",
    "Device": "Y88X__PLUS",
    "Model": "Y88X__PLUS"
  },
  {
    "Retail Branding": "DreamMaker",
    "Marketing Name": "DreamMaker",
    "Device": "DPLAY",
    "Model": "DPLAY"
  },
  {
    "Retail Branding": "DreamPos",
    "Marketing Name": "LeoPos7_EEA",
    "Device": "LeoPos7_EEA",
    "Model": "DreamPos"
  },
  {
    "Retail Branding": "Dreamax",
    "Marketing Name": "DMX-ST7A",
    "Device": "DMX-ST7A",
    "Model": "DMX-ST7A"
  },
  {
    "Retail Branding": "Dreame",
    "Marketing Name": "DREAME SMART 2KTV",
    "Device": "beomil",
    "Model": "DREAME SMART 2KTV"
  },
  {
    "Retail Branding": "Dreame",
    "Marketing Name": "DREAME SMART 4KTV",
    "Device": "anaheim",
    "Model": "DREAME SMART 4KTV"
  },
  {
    "Retail Branding": "Dreame",
    "Marketing Name": "DREAME SMART 4KTV",
    "Device": "byculla",
    "Model": "DREAME SMART 4KTV"
  },
  {
    "Retail Branding": "Dreame",
    "Marketing Name": "DREAME SMART 4KTV",
    "Device": "eleonas",
    "Model": "DREAME SMART 4KTV"
  },
  {
    "Retail Branding": "Dreame",
    "Marketing Name": "Dreame Smartphone E1",
    "Device": "DREAME_W1",
    "Model": "W5110"
  },
  {
    "Retail Branding": "Dreamstar",
    "Marketing Name": "Dreamstar 2K SMART TV",
    "Device": "nagata",
    "Model": "Dreamstar 2K SMART TV"
  },
  {
    "Retail Branding": "Dreamstar",
    "Marketing Name": "Dreamstar 4K SMART TV",
    "Device": "marina",
    "Model": "Dreamstar 4K SMART TV"
  },
  {
    "Retail Branding": "Dreamstar",
    "Marketing Name": "Dreamstar Smart TV",
    "Device": "dongnae",
    "Model": "Dreamstar Smart TV"
  },
  {
    "Retail Branding": "Dreamstar",
    "Marketing Name": "Nova",
    "Device": "YYZ",
    "Model": "Nova"
  },
  {
    "Retail Branding": "Dreamstar",
    "Marketing Name": "Turkey",
    "Device": "sepolia",
    "Model": "Dreamstar Smart TV"
  },
  {
    "Retail Branding": "Dreamtek",
    "Marketing Name": "V1",
    "Device": "V1",
    "Model": "V1"
  },
  {
    "Retail Branding": "Drei",
    "Marketing Name": "ZTE 4K TV BOX CH1",
    "Device": "B866VH_Hutchison",
    "Model": "ZTE 4K TV BOX CH1"
  },
  {
    "Retail Branding": "Drkumo",
    "Marketing Name": "KumoPal",
    "Device": "XL100",
    "Model": "XL100"
  },
  {
    "Retail Branding": "Dtac",
    "Marketing Name": "Phone M2",
    "Device": "dtacPhoneM2",
    "Model": "dtacPhoneM2"
  },
  {
    "Retail Branding": "Dtac",
    "Marketing Name": "Phone S2",
    "Device": "dtacPhoneS2",
    "Model": "dtac_Phone_S2"
  },
  {
    "Retail Branding": "Dtac",
    "Marketing Name": "Phone S3",
    "Device": "dtacPhoneS3",
    "Model": "dtacPhoneS3"
  },
  {
    "Retail Branding": "Dtac",
    "Marketing Name": "Phone T2",
    "Device": "dtacPhoneT2",
    "Model": "dtacPhoneT2"
  },
  {
    "Retail Branding": "Dtac",
    "Marketing Name": "Phone X3",
    "Device": "dtacPhoneX3",
    "Model": "dtacPhoneX3"
  },
  {
    "Retail Branding": "Dtac",
    "Marketing Name": "dtacPhoneS3",
    "Device": "dtacPhoneS3",
    "Model": "dtacPhoneS3"
  },
  {
    "Retail Branding": "Dtac",
    "Marketing Name": "dtacPhoneT3",
    "Device": "dtacPhoneT3",
    "Model": "dtacPhoneT3"
  },
  {
    "Retail Branding": "Dtac",
    "Marketing Name": "dtac_Phone_S2",
    "Device": "dtacPhoneS2",
    "Model": "dtac_Phone_S2"
  },
  {
    "Retail Branding": "Dual",
    "Marketing Name": "BDL0948",
    "Device": "BDL0948",
    "Model": "BDL0948"
  },
  {
    "Retail Branding": "Dual",
    "Marketing Name": "Dual",
    "Device": "bangbae",
    "Model": "Dual 4K Android TV"
  },
  {
    "Retail Branding": "Dual",
    "Marketing Name": "Dual",
    "Device": "komagome",
    "Model": "Dual 2K Android TV"
  },
  {
    "Retail Branding": "Dual",
    "Marketing Name": "Dual 2K Android TV",
    "Device": "lasalle",
    "Model": "Dual 2K Android TV"
  },
  {
    "Retail Branding": "Dual",
    "Marketing Name": "Dual 4K Android TV",
    "Device": "kenton",
    "Model": "Dual 4K Android TV"
  },
  {
    "Retail Branding": "Dunns",
    "Marketing Name": "Dunns Pulse Pro",
    "Device": "Dunns_Pulse_Pro",
    "Model": "Dunns Pulse Pro"
  },
  {
    "Retail Branding": "Dunns",
    "Marketing Name": "Dunns Slinger",
    "Device": "DunnsSlinger",
    "Model": "Dunns Slinger"
  },
  {
    "Retail Branding": "Dunns",
    "Marketing Name": "ETAB_M9041G",
    "Device": "ETAB_M9041G",
    "Model": "ETAB_M9041G"
  },
  {
    "Retail Branding": "Dunns",
    "Marketing Name": "Smarty II",
    "Device": "Smarty_II",
    "Model": "Smarty_II"
  },
  {
    "Retail Branding": "DuraGo",
    "Marketing Name": "DG3200RTV",
    "Device": "DG3200RTV",
    "Model": "DG3200RTV"
  },
  {
    "Retail Branding": "Durabrand",
    "Marketing Name": "Central America",
    "Device": "nippori",
    "Model": "Durabrand 2K Android TV"
  },
  {
    "Retail Branding": "Durabrand",
    "Marketing Name": "DB Android TV 2K",
    "Device": "broadway",
    "Model": "DB Android TV 2K"
  },
  {
    "Retail Branding": "Durabrand",
    "Marketing Name": "DB Android TV 4K",
    "Device": "dupont",
    "Model": "DB Android TV 4K"
  },
  {
    "Retail Branding": "Durabrand",
    "Marketing Name": "DURABRAND",
    "Device": "elliniko",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "Durabrand",
    "Marketing Name": "Durabrand android TV",
    "Device": "hanyang",
    "Model": "Durabrand 4K Android TV"
  },
  {
    "Retail Branding": "Duubee",
    "Marketing Name": "D601L",
    "Device": "Gaia",
    "Model": "D601L"
  },
  {
    "Retail Branding": "Duubee",
    "Marketing Name": "DT1052",
    "Device": "DT1052",
    "Model": "DT1052"
  },
  {
    "Retail Branding": "Duubee",
    "Marketing Name": "W1",
    "Device": "W1",
    "Model": "W1"
  },
  {
    "Retail Branding": "Duubee",
    "Marketing Name": "W2",
    "Device": "W2",
    "Model": "W2"
  },
  {
    "Retail Branding": "Dwsummus",
    "Marketing Name": "DWSUMMUS Smart TV",
    "Device": "dongnae",
    "Model": "DWSUMMUS Smart TV"
  },
  {
    "Retail Branding": "Dwsummus",
    "Marketing Name": "DWsummus",
    "Device": "DS_RK3588",
    "Model": "QK6535P"
  },
  {
    "Retail Branding": "Dwsummus",
    "Marketing Name": "DWsummus",
    "Device": "DS_RK3588",
    "Model": "QK7535P"
  },
  {
    "Retail Branding": "Dwsummus",
    "Marketing Name": "DWsummus",
    "Device": "DS_RK3588",
    "Model": "QK8635P"
  },
  {
    "Retail Branding": "Dwsummus",
    "Marketing Name": "Korea",
    "Device": "sepolia",
    "Model": "DWSUMMUS Smart TV"
  },
  {
    "Retail Branding": "DynaScan",
    "Marketing Name": "D",
    "Device": "mensa_an64",
    "Model": "D"
  },
  {
    "Retail Branding": "Dynalink",
    "Marketing Name": "DL-Google TV",
    "Device": "XNA",
    "Model": "DL-GT18"
  },
  {
    "Retail Branding": "Dynalink",
    "Marketing Name": "DL-Google TV",
    "Device": "YOC",
    "Model": "DL-Google TV36"
  },
  {
    "Retail Branding": "Dynalink",
    "Marketing Name": "STI6130-D350",
    "Device": "sti6130d350",
    "Model": "Dynalink TV Box"
  },
  {
    "Retail Branding": "Dyon",
    "Marketing Name": "DYON",
    "Device": "elliniko",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "Dyon",
    "Marketing Name": "DYON",
    "Device": "jagalchi",
    "Model": "2K SMART TV"
  },
  {
    "Retail Branding": "Dyon",
    "Marketing Name": "DYON",
    "Device": "zhongshan",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "Dyon",
    "Marketing Name": "DYON 2K Google TV",
    "Device": "capitolhill",
    "Model": "DYON 2K Google TV"
  },
  {
    "Retail Branding": "Dyon",
    "Marketing Name": "DYON 4K Google TV",
    "Device": "keoneae",
    "Model": "DYON 4K Google TV"
  },
  {
    "Retail Branding": "Dyon",
    "Marketing Name": "Dyon",
    "Device": "bangbae",
    "Model": "Dyon 4K Android TV"
  },
  {
    "Retail Branding": "Dyon",
    "Marketing Name": "Dyon",
    "Device": "komagome",
    "Model": "Dyon 2K Android TV"
  },
  {
    "Retail Branding": "Dyon",
    "Marketing Name": "Dyon",
    "Device": "stanford",
    "Model": "2K SMART TV"
  },
  {
    "Retail Branding": "E-Boda",
    "Marketing Name": "Eclipse G400M",
    "Device": "Eclipse_G400M",
    "Model": "Eclipse_G400M"
  },
  {
    "Retail Branding": "E-Boda",
    "Marketing Name": "Eclipse G500HD",
    "Device": "E-Boda_Eclipse_G500HD",
    "Model": "Eclipse G500HD"
  },
  {
    "Retail Branding": "E-Boda",
    "Marketing Name": "Eclipse G500M",
    "Device": "Eclipse_G500M",
    "Model": "Eclipse_G500M"
  },
  {
    "Retail Branding": "E-LEAD",
    "Marketing Name": "RSE",
    "Device": "RSE",
    "Model": "EL-712"
  },
  {
    "Retail Branding": "E-LEAD",
    "Marketing Name": "RSE",
    "Device": "RSE",
    "Model": "EL-719"
  },
  {
    "Retail Branding": "E-LEAD",
    "Marketing Name": "_712_TAM1A_RSE",
    "Device": "_712_TAM1A_RSE",
    "Model": "_712_TAM1A_RSE"
  },
  {
    "Retail Branding": "E-TACHI",
    "Marketing Name": "A10_SMART",
    "Device": "A10_SMART",
    "Model": "A10_SMART"
  },
  {
    "Retail Branding": "E-TACHI",
    "Marketing Name": "A5SLIM",
    "Device": "A5SLIM",
    "Model": "A5SLIM"
  },
  {
    "Retail Branding": "E-TACHI",
    "Marketing Name": "A8_SMART",
    "Device": "A8_SMART",
    "Model": "A8_SMART"
  },
  {
    "Retail Branding": "E-Tel",
    "Marketing Name": "E-tel_M1",
    "Device": "E-tel_M1",
    "Model": "E-tel_M1"
  },
  {
    "Retail Branding": "E-Tel",
    "Marketing Name": "E-tel_Q5",
    "Device": "E-tel_Q5",
    "Model": "E-tel_Q5"
  },
  {
    "Retail Branding": "E-Tel",
    "Marketing Name": "E-tel_i20",
    "Device": "E-tel_i20",
    "Model": "E-tel_i20"
  },
  {
    "Retail Branding": "E-Tel",
    "Marketing Name": "E-tel_i250",
    "Device": "E-tel_i250",
    "Model": "E-tel_i250"
  },
  {
    "Retail Branding": "E-Tel",
    "Marketing Name": "M4",
    "Device": "M4",
    "Model": "M4"
  },
  {
    "Retail Branding": "E-Tel",
    "Marketing Name": "Q25",
    "Device": "Q25",
    "Model": "Q25"
  },
  {
    "Retail Branding": "E-Tel",
    "Marketing Name": "Q30",
    "Device": "Q30",
    "Model": "Q30"
  },
  {
    "Retail Branding": "E-Tel",
    "Marketing Name": "Q7",
    "Device": "E-tel_Q7",
    "Model": "E-tel_Q7"
  },
  {
    "Retail Branding": "E-Tel",
    "Marketing Name": "Zen_One",
    "Device": "Zen_One",
    "Model": "Zen One"
  },
  {
    "Retail Branding": "E-Tel",
    "Marketing Name": "i240",
    "Device": "i240",
    "Model": "E-tel i240"
  },
  {
    "Retail Branding": "E-Wealth Mobile",
    "Marketing Name": "E508",
    "Device": "E508",
    "Model": "E508"
  },
  {
    "Retail Branding": "E-Wealth Mobile",
    "Marketing Name": "E5701",
    "Device": "E5701",
    "Model": "E5701"
  },
  {
    "Retail Branding": "EACHPAI",
    "Marketing Name": 706,
    "Device": 706,
    "Model": 706
  },
  {
    "Retail Branding": "EACHPAI",
    "Marketing Name": "86v",
    "Device": "86v",
    "Model": "86v"
  },
  {
    "Retail Branding": "EACHPAI",
    "Marketing Name": "Q8",
    "Device": "Q8",
    "Model": "Q8"
  },
  {
    "Retail Branding": "EACRUGGED",
    "Marketing Name": "EP500",
    "Device": "EP500",
    "Model": "EP500"
  },
  {
    "Retail Branding": "EACRUGGED",
    "Marketing Name": "RG80",
    "Device": "RG80",
    "Model": "RG80"
  },
  {
    "Retail Branding": "EACRUGGED",
    "Marketing Name": "Serenity-B8",
    "Device": "Serenity-B8",
    "Model": "Serenity-B8"
  },
  {
    "Retail Branding": "EACRUGGED",
    "Marketing Name": "Wolf10R",
    "Device": "Wolf10R",
    "Model": "Wolf10R"
  },
  {
    "Retail Branding": "EARSON",
    "Marketing Name": "EarsoN02",
    "Device": "EarsoN02",
    "Model": "EarsoN02"
  },
  {
    "Retail Branding": "EARTHTREK",
    "Marketing Name": "ET_tablet",
    "Device": "Byond",
    "Model": "VC5"
  },
  {
    "Retail Branding": "EAS ELECTRIC",
    "Marketing Name": "Android TV",
    "Device": "R1",
    "Model": "ATV R1"
  },
  {
    "Retail Branding": "EAS ELECTRIC",
    "Marketing Name": "Android TV",
    "Device": "R2",
    "Model": "ATV R2"
  },
  {
    "Retail Branding": "EASYTECK",
    "Marketing Name": "EK10",
    "Device": "EK10",
    "Model": "EK10"
  },
  {
    "Retail Branding": "EASYTECK",
    "Marketing Name": "EK12",
    "Device": "EK12",
    "Model": "EK12"
  },
  {
    "Retail Branding": "EBN",
    "Marketing Name": "NEBUPOS3",
    "Device": "UY3A",
    "Model": "NEBUPOS3"
  },
  {
    "Retail Branding": "ECHOSONIC",
    "Marketing Name": "EchosonicTV",
    "Device": "shinagawa",
    "Model": "EchosonicTV"
  },
  {
    "Retail Branding": "ECONNECT",
    "Marketing Name": "BH105",
    "Device": "BH105",
    "Model": "BH105"
  },
  {
    "Retail Branding": "ECONNECT",
    "Marketing Name": "BH505GS",
    "Device": "BH505GS",
    "Model": "BH505GS"
  },
  {
    "Retail Branding": "ECONNECT",
    "Marketing Name": "RH511G",
    "Device": "RH511G",
    "Model": "RH511G"
  },
  {
    "Retail Branding": "ECONNECT",
    "Marketing Name": "SQ126G",
    "Device": "SQ126G",
    "Model": "SQ126G"
  },
  {
    "Retail Branding": "ECOPAD",
    "Marketing Name": "A30L1_EEA",
    "Device": "A30L1",
    "Model": "A30L1"
  },
  {
    "Retail Branding": "ECOPAD",
    "Marketing Name": "A30Pro_A",
    "Device": "A30Pro_A",
    "Model": "A30Pro_A"
  },
  {
    "Retail Branding": "ECOPAD",
    "Marketing Name": "A30Pro_A_EEA",
    "Device": "A30Pro_A",
    "Model": "A30Pro_A"
  },
  {
    "Retail Branding": "ECOPAD",
    "Marketing Name": "C5Pro",
    "Device": "C5Pro",
    "Model": "C5Pro"
  },
  {
    "Retail Branding": "ECOPAD",
    "Marketing Name": "C5Pro_EEA",
    "Device": "C5Pro",
    "Model": "C5Pro"
  },
  {
    "Retail Branding": "ECOPAD",
    "Marketing Name": "K12L1",
    "Device": "K12L1",
    "Model": "K12L1"
  },
  {
    "Retail Branding": "ECOPAD",
    "Marketing Name": "K90",
    "Device": "K90",
    "Model": "K90"
  },
  {
    "Retail Branding": "ECS",
    "Marketing Name": "RealPad MA7BX2",
    "Device": "RealPad_MA7BX2_1",
    "Model": "RealPad MA7BX2"
  },
  {
    "Retail Branding": "ECS",
    "Marketing Name": "TC69CA2",
    "Device": "TC69CA2_1",
    "Model": "TC69CA2"
  },
  {
    "Retail Branding": "ECS",
    "Marketing Name": "TC70RA1",
    "Device": "TC70RA1_2",
    "Model": "TC70RA1"
  },
  {
    "Retail Branding": "ECS",
    "Marketing Name": "TF10EA2",
    "Device": "TF10EA2_2",
    "Model": "TF10EA2"
  },
  {
    "Retail Branding": "ECS",
    "Marketing Name": "TF10EA2",
    "Device": "TF10EA2_4",
    "Model": "TF10EA2"
  },
  {
    "Retail Branding": "ECS",
    "Marketing Name": "TF10EA2",
    "Device": "TF10EA2_P61_2",
    "Model": "TF10EA2_P61"
  },
  {
    "Retail Branding": "ECS",
    "Marketing Name": "TF10EA2",
    "Device": "TF10EA2_P8_1",
    "Model": "TF10EA2_P8"
  },
  {
    "Retail Branding": "ECS",
    "Marketing Name": "TF10MK1",
    "Device": "TF10MK1_1",
    "Model": "TF10MK1"
  },
  {
    "Retail Branding": "ECS",
    "Marketing Name": "TF10MK1",
    "Device": "TF10MK1_3",
    "Model": "TF10MK1"
  },
  {
    "Retail Branding": "ECS",
    "Marketing Name": "TI10RA1",
    "Device": "TI10RA1_1",
    "Model": "TI10RA1"
  },
  {
    "Retail Branding": "ECS",
    "Marketing Name": "TL10RA2",
    "Device": "TL10RA2_1",
    "Model": "TL10RA2"
  },
  {
    "Retail Branding": "ECS",
    "Marketing Name": "TP10RA1",
    "Device": "TP10RA1_1",
    "Model": "TP10RA1"
  },
  {
    "Retail Branding": "ECS",
    "Marketing Name": "TR10CS1",
    "Device": "TR10CS1_12",
    "Model": "TR10CS1"
  },
  {
    "Retail Branding": "ECS",
    "Marketing Name": "TR10CS1",
    "Device": "TR10CS1_8",
    "Model": "TR10CS1"
  },
  {
    "Retail Branding": "ECS",
    "Marketing Name": "TR10RS1",
    "Device": "TR10RS1_11",
    "Model": "TR10RS1"
  },
  {
    "Retail Branding": "ECS",
    "Marketing Name": "TR10RS1",
    "Device": "TR10RS1_19",
    "Model": "TR10RS1"
  },
  {
    "Retail Branding": "ECS",
    "Marketing Name": "TR10RS1",
    "Device": "TR10RS1_2",
    "Model": "TR10RS1"
  },
  {
    "Retail Branding": "ECS",
    "Marketing Name": "TU10MK",
    "Device": "TU10MK_3",
    "Model": "TU10MK"
  },
  {
    "Retail Branding": "ECS",
    "Marketing Name": "TU11MK2",
    "Device": "TU11MK2",
    "Model": "TU11MK2"
  },
  {
    "Retail Branding": "EDENWOOD",
    "Marketing Name": "EDENWOOD",
    "Device": "bangbae",
    "Model": "EDENWOOD 4K Android TV"
  },
  {
    "Retail Branding": "EDENWOOD",
    "Marketing Name": "EDENWOOD",
    "Device": "komagome",
    "Model": "EDENWOOD 2K Android TV"
  },
  {
    "Retail Branding": "EDENWOOD",
    "Marketing Name": "EDENWOOD 4K Android TV",
    "Device": "kenton",
    "Model": "EDENWOOD 4K Android TV"
  },
  {
    "Retail Branding": "EDUTAB",
    "Marketing Name": "EDUTAB_X1100S",
    "Device": "EDUTAB_X1100S",
    "Model": "X1100S"
  },
  {
    "Retail Branding": "EDUTAB",
    "Marketing Name": "ELITE_10",
    "Device": "ELITE_10",
    "Model": "ELITE_10"
  },
  {
    "Retail Branding": "EDUTAB",
    "Marketing Name": "ELITE_10_PRO",
    "Device": "ELITE_10_PRO",
    "Model": "ELITE_10_PRO"
  },
  {
    "Retail Branding": "EGBOK",
    "Marketing Name": "P803",
    "Device": "P803",
    "Model": "P803"
  },
  {
    "Retail Branding": "EGOBOO",
    "Marketing Name": "EB101",
    "Device": "EB101",
    "Model": "EB101"
  },
  {
    "Retail Branding": "EGOBOO",
    "Marketing Name": "EB104",
    "Device": "EB104",
    "Model": "EB104"
  },
  {
    "Retail Branding": "EGOTEK",
    "Marketing Name": "AK10",
    "Device": "AK10",
    "Model": "AK10"
  },
  {
    "Retail Branding": "EGOTEK",
    "Marketing Name": "EGO1003",
    "Device": "EGO1003",
    "Model": "EGO1003"
  },
  {
    "Retail Branding": "EGOTEK",
    "Marketing Name": "ET868",
    "Device": "ET868",
    "Model": "ET868"
  },
  {
    "Retail Branding": "EGOTEK",
    "Marketing Name": "G10N",
    "Device": "G10N",
    "Model": "G10N"
  },
  {
    "Retail Branding": "EGOTEK",
    "Marketing Name": "Mars8",
    "Device": "Mars8",
    "Model": "Mars8"
  },
  {
    "Retail Branding": "EGOTEK",
    "Marketing Name": "Penguin",
    "Device": "Penguin",
    "Model": "Penguin"
  },
  {
    "Retail Branding": "EGOTEK",
    "Marketing Name": "Venus10",
    "Device": "Venus10",
    "Model": "Venus10"
  },
  {
    "Retail Branding": "EJBOARD",
    "Marketing Name": "EJ_IFPD",
    "Device": "oversea_v",
    "Model": "EB-Q_series"
  },
  {
    "Retail Branding": "EJBOARD",
    "Marketing Name": "EJ_IFPD",
    "Device": "rk3588_t",
    "Model": "EP_Series"
  },
  {
    "Retail Branding": "EKEMP",
    "Marketing Name": "T80 EEA",
    "Device": "T80",
    "Model": "T80"
  },
  {
    "Retail Branding": "EKINOX",
    "Marketing Name": "E6",
    "Device": "E6",
    "Model": "E6"
  },
  {
    "Retail Branding": "EKINOX",
    "Marketing Name": "E8_Ultra",
    "Device": "E8_Ultra",
    "Model": "E8_Ultra"
  },
  {
    "Retail Branding": "EKINOX",
    "Marketing Name": "G1",
    "Device": "G1",
    "Model": "G1"
  },
  {
    "Retail Branding": "EKINOX",
    "Marketing Name": "G1 Pro",
    "Device": "G1_Pro",
    "Model": "G1 Pro"
  },
  {
    "Retail Branding": "EKINOX",
    "Marketing Name": "G2",
    "Device": "G2",
    "Model": "G2"
  },
  {
    "Retail Branding": "EKINOX",
    "Marketing Name": "K5",
    "Device": "K5",
    "Model": "K5"
  },
  {
    "Retail Branding": "EKO",
    "Marketing Name": "AUSTRALIA, EU, JAPAN, MIDDLE EAST",
    "Device": "guandu",
    "Model": "EKO 4K Android TV"
  },
  {
    "Retail Branding": "EKO",
    "Marketing Name": "Ara 5.7 A5719",
    "Device": "A5719",
    "Model": "Ara 5.7 A5719"
  },
  {
    "Retail Branding": "EKO",
    "Marketing Name": "Australia",
    "Device": "nippori",
    "Model": "EKO Android TV 2K"
  },
  {
    "Retail Branding": "EKO",
    "Marketing Name": "Australia",
    "Device": "tamachi",
    "Model": "EKO Android TV"
  },
  {
    "Retail Branding": "EKO",
    "Marketing Name": "Australia",
    "Device": "yeongdeungpo",
    "Model": "EKO Android TV"
  },
  {
    "Retail Branding": "EKO",
    "Marketing Name": "Australia,Japan, Germany,Italy",
    "Device": "martin",
    "Model": "EKO Android Monitor"
  },
  {
    "Retail Branding": "EKO",
    "Marketing Name": "Australia,Japan,Germany,Italy(No Tuner)",
    "Device": "patrick",
    "Model": "EKO Android Monitor"
  },
  {
    "Retail Branding": "EKO",
    "Marketing Name": "EKO",
    "Device": "bangbae",
    "Model": "EKO 4K Android TV"
  },
  {
    "Retail Branding": "EKO",
    "Marketing Name": "EKO",
    "Device": "dongmae",
    "Model": "EKO 2KTV"
  },
  {
    "Retail Branding": "EKO",
    "Marketing Name": "EKO",
    "Device": "expo",
    "Model": "4K EKO Google TV"
  },
  {
    "Retail Branding": "EKO",
    "Marketing Name": "EKO",
    "Device": "hongkong",
    "Model": "EKO 4K Android TV"
  },
  {
    "Retail Branding": "EKO",
    "Marketing Name": "EKO",
    "Device": "kaitak",
    "Model": "EKO Google TV"
  },
  {
    "Retail Branding": "EKO",
    "Marketing Name": "EKO",
    "Device": "komagome",
    "Model": "EKO 2K Android TV"
  },
  {
    "Retail Branding": "EKO",
    "Marketing Name": "EKO",
    "Device": "lavender",
    "Model": "EKO 4K Android TV"
  },
  {
    "Retail Branding": "EKO",
    "Marketing Name": "EKO",
    "Device": "mountbaker",
    "Model": "EKO 2K Android TV"
  },
  {
    "Retail Branding": "EKO",
    "Marketing Name": "EKO",
    "Device": "shilin",
    "Model": "EKO 4K Android TV"
  },
  {
    "Retail Branding": "EKO",
    "Marketing Name": "EKO",
    "Device": "tennoji",
    "Model": "2K EKO Google TV"
  },
  {
    "Retail Branding": "EKO",
    "Marketing Name": "EKO",
    "Device": "zhongshan",
    "Model": "EKO 4K Android TV"
  },
  {
    "Retail Branding": "EKO",
    "Marketing Name": "EKO 2K Google TV",
    "Device": "capitolhill",
    "Model": "EKO 2K Google TV"
  },
  {
    "Retail Branding": "EKO",
    "Marketing Name": "EKO 4K Google TV",
    "Device": "keoneae",
    "Model": "EKO 4K Google TV"
  },
  {
    "Retail Branding": "EKO",
    "Marketing Name": "EKO Google TV",
    "Device": "bandra",
    "Model": "EKO Google TV"
  },
  {
    "Retail Branding": "EKO",
    "Marketing Name": "EKO OMEGA LTE Q60",
    "Device": "EKO_OMEGA_LTE_Q60",
    "Model": "EKO OMEGA LTE Q60"
  },
  {
    "Retail Branding": "EKO",
    "Marketing Name": "EKO OMEGA Q55",
    "Device": "EKO_OMEGA_Q55",
    "Model": "EKO OMEGA Q55"
  },
  {
    "Retail Branding": "EKO",
    "Marketing Name": "EKO Star LTE G60",
    "Device": "EKO_Star_LTE_G60",
    "Model": "EKO Star LTE G60"
  },
  {
    "Retail Branding": "EKO",
    "Marketing Name": "EKO android TV",
    "Device": "hanyang",
    "Model": "Ayonz Android TV"
  },
  {
    "Retail Branding": "EKO",
    "Marketing Name": "EKO android TV ISDB",
    "Device": "hanyang",
    "Model": "EKO 4K Android TV"
  },
  {
    "Retail Branding": "EKO",
    "Marketing Name": "EU、UK、AP",
    "Device": "martin",
    "Model": "EKO 2K Android TV"
  },
  {
    "Retail Branding": "EKO",
    "Marketing Name": "EU、UK、AP",
    "Device": "martin",
    "Model": "EKO 2K Android TV"
  },
  {
    "Retail Branding": "EKO",
    "Marketing Name": "Eko",
    "Device": "stanford",
    "Model": "EKO 2K Android TV"
  },
  {
    "Retail Branding": "EKO",
    "Marketing Name": "JVC",
    "Device": "bruno",
    "Model": "EKO 2K Android TV"
  },
  {
    "Retail Branding": "EKO",
    "Marketing Name": "KATV10",
    "Device": "ICN",
    "Model": "KATV10"
  },
  {
    "Retail Branding": "EKO",
    "Marketing Name": "Star 4.0 G40",
    "Device": "Star_4_0_G40",
    "Model": "Star 4.0 G40"
  },
  {
    "Retail Branding": "EKO",
    "Marketing Name": "Star 5.0 G50",
    "Device": "Star_5_0_G50",
    "Model": "Star 5.0 G50"
  },
  {
    "Retail Branding": "EKO",
    "Marketing Name": "Star 5.5 G55",
    "Device": "Star_5_5_G55",
    "Model": "Star 5.5 G55"
  },
  {
    "Retail Branding": "EKO",
    "Marketing Name": "Star 6.0 G65",
    "Device": "Star_6_0_G65",
    "Model": "Star 6.0 G65"
  },
  {
    "Retail Branding": "EKO",
    "Marketing Name": "Star_5.5_G55",
    "Device": "Star_5_5_G55",
    "Model": "Star 5.5 G55"
  },
  {
    "Retail Branding": "EKO",
    "Marketing Name": "Star_6.0_G65",
    "Device": "Star_6_0_G65",
    "Model": "Star 6.0 G65"
  },
  {
    "Retail Branding": "EL (Africa)",
    "Marketing Name": "D58",
    "Device": "D58",
    "Model": "D58"
  },
  {
    "Retail Branding": "EL (Africa)",
    "Marketing Name": "D60_Pro",
    "Device": "D60_Pro",
    "Model": "D60 Pro"
  },
  {
    "Retail Branding": "EL (Africa)",
    "Marketing Name": "D68",
    "Device": "D68",
    "Model": "D68"
  },
  {
    "Retail Branding": "EL (Africa)",
    "Marketing Name": "W45S",
    "Device": "W45S",
    "Model": "W45S"
  },
  {
    "Retail Branding": "EL (Africa)",
    "Marketing Name": "W60",
    "Device": "W60",
    "Model": "W60"
  },
  {
    "Retail Branding": "EL (Africa)",
    "Marketing Name": "X60 Pro",
    "Device": "X60_PRO",
    "Model": "X60 Pro"
  },
  {
    "Retail Branding": "EL (Africa)",
    "Marketing Name": "X70",
    "Device": "X70",
    "Model": "X70"
  },
  {
    "Retail Branding": "EL (Africa)",
    "Marketing Name": "X80",
    "Device": "X80",
    "Model": "X80"
  },
  {
    "Retail Branding": "EL (Africa)",
    "Marketing Name": "X90",
    "Device": "X90a",
    "Model": "X90"
  },
  {
    "Retail Branding": "EL(elongmobile)",
    "Marketing Name": "Pad-S11",
    "Device": "Pad-S11",
    "Model": "Pad-S11"
  },
  {
    "Retail Branding": "EL(elongmobile)",
    "Marketing Name": "Pad_S7",
    "Device": "Pad_S7",
    "Model": "Pad_S7"
  },
  {
    "Retail Branding": "EL(elongmobile)",
    "Marketing Name": "Pad_S8",
    "Device": "Pad_S8",
    "Model": "Pad_S8"
  },
  {
    "Retail Branding": "ELC(cn)",
    "Marketing Name": "M108",
    "Device": "M108",
    "Model": "M108"
  },
  {
    "Retail Branding": "ELDMandate",
    "Marketing Name": "10BIZ332",
    "Device": "10BIZ332",
    "Model": "10BIZ332"
  },
  {
    "Retail Branding": "ELEPHAS",
    "Marketing Name": "K350",
    "Device": "himalaya",
    "Model": "K350"
  },
  {
    "Retail Branding": "ELEVIA",
    "Marketing Name": "Elevia E1",
    "Device": "EL-E110",
    "Model": "EL-E110"
  },
  {
    "Retail Branding": "ELEXIA",
    "Marketing Name": "ELEXIA",
    "Device": "bangbae",
    "Model": "ELEXIA 4K Android TV"
  },
  {
    "Retail Branding": "ELEXIA",
    "Marketing Name": "ELEXIA",
    "Device": "bruno",
    "Model": "ELEXIA2KAndroidTV"
  },
  {
    "Retail Branding": "ELEXIA",
    "Marketing Name": "ELEXIA",
    "Device": "expo",
    "Model": "4K ELEXIA Google TV"
  },
  {
    "Retail Branding": "ELEXIA",
    "Marketing Name": "ELEXIA",
    "Device": "komagome",
    "Model": "ELEXIA 2K Android TV"
  },
  {
    "Retail Branding": "ELEXIA",
    "Marketing Name": "ELEXIA",
    "Device": "tennoji",
    "Model": "2K ELEXIA Google TV"
  },
  {
    "Retail Branding": "ELITESOFT",
    "Marketing Name": "Tab101",
    "Device": "Tab101",
    "Model": "Tab101"
  },
  {
    "Retail Branding": "ELMO",
    "Marketing Name": "ELXXR5G",
    "Device": "ELXXR5G",
    "Model": "ELXXR5X"
  },
  {
    "Retail Branding": "ELO Touch",
    "Marketing Name": "10-inch I-Series 5",
    "Device": "10in-I-Series-5",
    "Model": "10in-I-Series-5"
  },
  {
    "Retail Branding": "ELO Touch",
    "Marketing Name": "10in-I-Series-4",
    "Device": "10in-I-Series-4",
    "Model": "10in-I-Series-4"
  },
  {
    "Retail Branding": "ELO Touch",
    "Marketing Name": "10in-I-Series-4-Value",
    "Device": "10in-I-Series-4-Value",
    "Model": "10in-I-Series-4-Value"
  },
  {
    "Retail Branding": "ELO Touch",
    "Marketing Name": "10in-I-Series-5-Value",
    "Device": "10in-I-Series-5-Value",
    "Model": "10in-I-Series-5-Value"
  },
  {
    "Retail Branding": "ELO Touch",
    "Marketing Name": "14in-E-Series-1",
    "Device": "14in-E-Series-1",
    "Model": "14in-E-Series-1"
  },
  {
    "Retail Branding": "ELO Touch",
    "Marketing Name": "14in-E-Series-5",
    "Device": "14in-E-Series-5",
    "Model": "14in-E-Series-5"
  },
  {
    "Retail Branding": "ELO Touch",
    "Marketing Name": "15in-I-Series-4",
    "Device": "15in-I-Series-4",
    "Model": "15in-I-Series-4"
  },
  {
    "Retail Branding": "ELO Touch",
    "Marketing Name": "15in-I-Series-4-USB-C",
    "Device": "15in-I-Series-4-USB-C",
    "Model": "15in-I-Series-4-USB-C"
  },
  {
    "Retail Branding": "ELO Touch",
    "Marketing Name": "15in-I-Series-4-USBC-V",
    "Device": "15in-I-Series-4-USBC-V",
    "Model": "15in-I-Series-4-USBC-V"
  },
  {
    "Retail Branding": "ELO Touch",
    "Marketing Name": "15in-I-Series-4-Value",
    "Device": "15in-I-Series-4-Value",
    "Model": "15in-I-Series-4-Value"
  },
  {
    "Retail Branding": "ELO Touch",
    "Marketing Name": "15in-I-Series-5",
    "Device": "15in-I-Series-5",
    "Model": "15in-I-Series-5"
  },
  {
    "Retail Branding": "ELO Touch",
    "Marketing Name": "15in-I-Series-5-USB-C",
    "Device": "15in-I-Series-5-USB-C",
    "Model": "15in-I-Series-5-USB-C"
  },
  {
    "Retail Branding": "ELO Touch",
    "Marketing Name": "22in-I-Series 4-Value",
    "Device": "22in-I-Series-4-Value",
    "Model": "22in-I-Series-4-Value"
  },
  {
    "Retail Branding": "ELO Touch",
    "Marketing Name": "22in-I-Series-4",
    "Device": "22in-I-Series-4",
    "Model": "22in-I-Series-4"
  },
  {
    "Retail Branding": "ELO Touch",
    "Marketing Name": "22in-I-Series-5",
    "Device": "22in-I-Series-5",
    "Model": "22in-I-Series-5"
  },
  {
    "Retail Branding": "ELO Touch",
    "Marketing Name": "22in-I-Series-5-Value",
    "Device": "22in-I-Series-5-Value",
    "Model": "22in-I-Series-5-Value"
  },
  {
    "Retail Branding": "ELO Touch",
    "Marketing Name": "Backpack-4",
    "Device": "Backpack-4",
    "Model": "Backpack-4"
  },
  {
    "Retail Branding": "ELO Touch",
    "Marketing Name": "Backpack-4-Value",
    "Device": "Backpack-4-Value",
    "Model": "Backpack-4-Value"
  },
  {
    "Retail Branding": "ELO Touch",
    "Marketing Name": "Backpack-5",
    "Device": "Backpack-5",
    "Model": "Backpack-5"
  },
  {
    "Retail Branding": "ELO Touch",
    "Marketing Name": "Backpack-5-Value",
    "Device": "Backpack-5-Value",
    "Model": "Backpack-5-Value"
  },
  {
    "Retail Branding": "ELO Touch",
    "Marketing Name": "EMC-M51",
    "Device": "EMC-M51",
    "Model": "EMC-M51"
  },
  {
    "Retail Branding": "ELO Touch",
    "Marketing Name": "EMC-M51C",
    "Device": "EMC-M51C",
    "Model": "EMC-M51C"
  },
  {
    "Retail Branding": "ELO Touch",
    "Marketing Name": "Elo-i3-15Std",
    "Device": "Elo-i3-15Std",
    "Model": "Elo-i3-15Std"
  },
  {
    "Retail Branding": "ELO Touch",
    "Marketing Name": "Elo-i3-PUCK",
    "Device": "Elo-i3-PUCK",
    "Model": "Elo-i3-PUCK"
  },
  {
    "Retail Branding": "ELO Touch",
    "Marketing Name": "I-Series 3.0 for Android",
    "Device": "Elo-i3-10Std",
    "Model": "Elo-i3-10Std"
  },
  {
    "Retail Branding": "ELO Touch",
    "Marketing Name": "I-Series 3.0 for Android",
    "Device": "Elo-i3-22Std",
    "Model": "Elo-i3-22Std"
  },
  {
    "Retail Branding": "ELO Touch",
    "Marketing Name": "I-Series Pay 7",
    "Device": "7in-I-Series-Pay",
    "Model": "7in-I-Series-Pay"
  },
  {
    "Retail Branding": "ELO Touch",
    "Marketing Name": "M100",
    "Device": "M100",
    "Model": "M100"
  },
  {
    "Retail Branding": "ELO Touch",
    "Marketing Name": "M100C",
    "Device": "M100C",
    "Model": "M100C"
  },
  {
    "Retail Branding": "ELO Touch",
    "Marketing Name": "M50",
    "Device": "M50",
    "Model": "M50"
  },
  {
    "Retail Branding": "ELO Touch",
    "Marketing Name": "M50C",
    "Device": "M50C",
    "Model": "M50C"
  },
  {
    "Retail Branding": "ELO Touch",
    "Marketing Name": "M60-Pay",
    "Device": "M60-Pay",
    "Model": "M60-Pay"
  },
  {
    "Retail Branding": "ELO Touch",
    "Marketing Name": "M60C-Pay",
    "Device": "M60C-Pay",
    "Model": "M60C-Pay"
  },
  {
    "Retail Branding": "ELO Touch",
    "Marketing Name": "M61",
    "Device": "M61",
    "Model": "M61"
  },
  {
    "Retail Branding": "ELO Touch",
    "Marketing Name": "M61C",
    "Device": "M61C",
    "Model": "M61C"
  },
  {
    "Retail Branding": "ELO Touch",
    "Marketing Name": "PayPoint® Plus for Android",
    "Device": "Elo-PP3-15",
    "Model": "Elo-PP3-15"
  },
  {
    "Retail Branding": "ELO Touch",
    "Marketing Name": "PayPoint® for Android",
    "Device": "Elo-PP3-13",
    "Model": "Elo-PP3-13"
  },
  {
    "Retail Branding": "ELSONIC",
    "Marketing Name": "ECQ-DAT01",
    "Device": "ECQ-DAT01",
    "Model": "ECQ-DAT01"
  },
  {
    "Retail Branding": "ELSONIC",
    "Marketing Name": "ESD",
    "Device": "redwood",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "EMCALI",
    "Marketing Name": "N9119M",
    "Device": "N9119M",
    "Model": "N9119M"
  },
  {
    "Retail Branding": "ENACOM",
    "Marketing Name": "M765P",
    "Device": "M765P",
    "Model": "M765P"
  },
  {
    "Retail Branding": "ENACOM",
    "Marketing Name": "PIXBA2019",
    "Device": "PIXBA2019",
    "Model": "PIXBA2019"
  },
  {
    "Retail Branding": "ENDO",
    "Marketing Name": "FX-560N",
    "Device": "FX-560N",
    "Model": "FX-560N"
  },
  {
    "Retail Branding": "ENDO Lighting",
    "Marketing Name": "FX438NA",
    "Device": "FX438NA",
    "Model": "FX438NA"
  },
  {
    "Retail Branding": "ENDO Lighting",
    "Marketing Name": "FX_438N",
    "Device": "FX_438N",
    "Model": "FX-438N"
  },
  {
    "Retail Branding": "ENIE",
    "Marketing Name": "E4Pro",
    "Device": "E4Pro",
    "Model": "E4Pro"
  },
  {
    "Retail Branding": "ENIE",
    "Marketing Name": "E6",
    "Device": "E6",
    "Model": "E6"
  },
  {
    "Retail Branding": "ENIE",
    "Marketing Name": "EH3",
    "Device": "EH3",
    "Model": "EH3"
  },
  {
    "Retail Branding": "ENIE",
    "Marketing Name": "ENIE_E2",
    "Device": "ENIE_E2",
    "Model": "ENIE_E2"
  },
  {
    "Retail Branding": "ENIE",
    "Marketing Name": "SKT119",
    "Device": "SKT119",
    "Model": "SKT119"
  },
  {
    "Retail Branding": "ENIE",
    "Marketing Name": "SKT706",
    "Device": "SKT706",
    "Model": "SKT706"
  },
  {
    "Retail Branding": "ENIE",
    "Marketing Name": "VT8216",
    "Device": "VT8216",
    "Model": "VT8216"
  },
  {
    "Retail Branding": "ENTITY",
    "Marketing Name": "GDENTMY7317",
    "Device": "GDENTMY7317",
    "Model": "GDENTMY7317"
  },
  {
    "Retail Branding": "ENV(EC)",
    "Marketing Name": "A18",
    "Device": "A18",
    "Model": "A18"
  },
  {
    "Retail Branding": "ENV(EC)",
    "Marketing Name": "A20",
    "Device": "A20",
    "Model": "A20"
  },
  {
    "Retail Branding": "ENV(EC)",
    "Marketing Name": "ENV_Kidz_10",
    "Device": "ENV_Kidz_10",
    "Model": "ENV Kidz 10"
  },
  {
    "Retail Branding": "ENV(EC)",
    "Marketing Name": "ENV_Kidz_8",
    "Device": "ENV_Kidz_8",
    "Model": "ENV_Kidz_8"
  },
  {
    "Retail Branding": "ENV(EC)",
    "Marketing Name": "ENV_NOTE_X",
    "Device": "ENV_NOTE_X",
    "Model": "ENV NOTE X"
  },
  {
    "Retail Branding": "ENV(EC)",
    "Marketing Name": "ENV_PAD_PRO",
    "Device": "ENV_PAD_PRO",
    "Model": "ENV PAD PRO"
  },
  {
    "Retail Branding": "ENV(EC)",
    "Marketing Name": "ENV_PAD_PRO_XS",
    "Device": "ENV_PAD_PRO_XS",
    "Model": "ENV_PAD_PRO_XS"
  },
  {
    "Retail Branding": "ENV(EC)",
    "Marketing Name": "ENV_Spartan_GT99",
    "Device": "ENV_Spartan_GT99",
    "Model": "ENV Spartan GT99"
  },
  {
    "Retail Branding": "ENV(EC)",
    "Marketing Name": "ENV_TAB_Go",
    "Device": "ENV_TAB_Go",
    "Model": "ENV_TAB_Go"
  },
  {
    "Retail Branding": "ENV(EC)",
    "Marketing Name": "ENV_TAB_Go_Pro",
    "Device": "ENV_TAB_Go_Pro",
    "Model": "ENV_TAB_Go_Pro"
  },
  {
    "Retail Branding": "ENV(EC)",
    "Marketing Name": "ENV_note_20",
    "Device": "ENV_note_20",
    "Model": "ENV_note_20"
  },
  {
    "Retail Branding": "ENV(EC)",
    "Marketing Name": "NEO PRO MAX",
    "Device": "NEO_PRO_MAX",
    "Model": "NEO PRO MAX"
  },
  {
    "Retail Branding": "ENV(EC)",
    "Marketing Name": "note 16",
    "Device": "note_16",
    "Model": "note 16"
  },
  {
    "Retail Branding": "EONSmartBox",
    "Marketing Name": "CHOTT0102",
    "Device": "CHOTT0102",
    "Model": "CHOTT0102"
  },
  {
    "Retail Branding": "EONSmartBox",
    "Marketing Name": "CHSTB02",
    "Device": "CHSTB02",
    "Model": "CHSTB02"
  },
  {
    "Retail Branding": "EONSmartBox",
    "Marketing Name": "EONSmartBox",
    "Device": "KNSTB02",
    "Model": "KNSTB02"
  },
  {
    "Retail Branding": "EONSmartBox",
    "Marketing Name": "SDOTT0202",
    "Device": "DV8519",
    "Model": "SDOTT0202"
  },
  {
    "Retail Branding": "EONSmartBox",
    "Marketing Name": "SDSTB01",
    "Device": "DV8945C-KSU",
    "Model": "SDSTB01"
  },
  {
    "Retail Branding": "EPI(Columbia)",
    "Marketing Name": "TAB-001",
    "Device": "TAB-001",
    "Model": "TAB-001"
  },
  {
    "Retail Branding": "EPIC",
    "Marketing Name": "EPIC 2K Android TV",
    "Device": "martin",
    "Model": "EPIC 2K Android TV"
  },
  {
    "Retail Branding": "EPIC",
    "Marketing Name": "Guatemala/Honduras",
    "Device": "patrick",
    "Model": "EPIC Android TV"
  },
  {
    "Retail Branding": "EPIC",
    "Marketing Name": "martin",
    "Device": "martin",
    "Model": "EPIC Android TV"
  },
  {
    "Retail Branding": "EPIKONE",
    "Marketing Name": "K400",
    "Device": "K400",
    "Model": "K400"
  },
  {
    "Retail Branding": "EPIKONE",
    "Marketing Name": "K405",
    "Device": "K405",
    "Model": "K405"
  },
  {
    "Retail Branding": "EPIKONE",
    "Marketing Name": "K406",
    "Device": "K406",
    "Model": "K406"
  },
  {
    "Retail Branding": "EPIKONE",
    "Marketing Name": "K500",
    "Device": "K500",
    "Model": "K500"
  },
  {
    "Retail Branding": "EPIKONE",
    "Marketing Name": "K501",
    "Device": "K501",
    "Model": "K501"
  },
  {
    "Retail Branding": "EPIKONE",
    "Marketing Name": "K501_Plus",
    "Device": "K501_Plus",
    "Model": "K501 Plus"
  },
  {
    "Retail Branding": "EPIKONE",
    "Marketing Name": "K502",
    "Device": "K502",
    "Model": "K502"
  },
  {
    "Retail Branding": "EPIKONE",
    "Marketing Name": "K503HD",
    "Device": "K503HD",
    "Model": "K503HD"
  },
  {
    "Retail Branding": "EPIKONE",
    "Marketing Name": "K503S",
    "Device": "K503S",
    "Model": "K503S"
  },
  {
    "Retail Branding": "EPIKONE",
    "Marketing Name": "K503T",
    "Device": "K503T",
    "Model": "K503T"
  },
  {
    "Retail Branding": "EPIKONE",
    "Marketing Name": "K504",
    "Device": "K504",
    "Model": "K504"
  },
  {
    "Retail Branding": "EPIKONE",
    "Marketing Name": "K506",
    "Device": "K506",
    "Model": "K506"
  },
  {
    "Retail Branding": "EPIKONE",
    "Marketing Name": "K507",
    "Device": "K507",
    "Model": "K507"
  },
  {
    "Retail Branding": "EPIKONE",
    "Marketing Name": "K510",
    "Device": "K510",
    "Model": "K510"
  },
  {
    "Retail Branding": "EPIKONE",
    "Marketing Name": "K511",
    "Device": "K511",
    "Model": "K511"
  },
  {
    "Retail Branding": "EPIKONE",
    "Marketing Name": "K534",
    "Device": "K534",
    "Model": "K534"
  },
  {
    "Retail Branding": "EPIKONE",
    "Marketing Name": "K535",
    "Device": "K535",
    "Model": "K535"
  },
  {
    "Retail Branding": "EPIKONE",
    "Marketing Name": "K536",
    "Device": "K536",
    "Model": "K536"
  },
  {
    "Retail Branding": "EPIKONE",
    "Marketing Name": "K545",
    "Device": "K545",
    "Model": "K545"
  },
  {
    "Retail Branding": "EPIKONE",
    "Marketing Name": "K546",
    "Device": "K546",
    "Model": "K546"
  },
  {
    "Retail Branding": "EPIKONE",
    "Marketing Name": "K573",
    "Device": "K573",
    "Model": "K573"
  },
  {
    "Retail Branding": "EPIKONE",
    "Marketing Name": "K600",
    "Device": "K600",
    "Model": "K600"
  },
  {
    "Retail Branding": "EPIKONE",
    "Marketing Name": "K601",
    "Device": "K600",
    "Model": "K600"
  },
  {
    "Retail Branding": "EPIKONE",
    "Marketing Name": "K601",
    "Device": "K601",
    "Model": "K601"
  },
  {
    "Retail Branding": "EPIKONE",
    "Marketing Name": "K604",
    "Device": "K604",
    "Model": "K604"
  },
  {
    "Retail Branding": "EPIKONE",
    "Marketing Name": "K605",
    "Device": "K605",
    "Model": "K605"
  },
  {
    "Retail Branding": "EPIKONE",
    "Marketing Name": "RS550",
    "Device": "RS550",
    "Model": "RS550"
  },
  {
    "Retail Branding": "EPIKONE",
    "Marketing Name": "T700",
    "Device": "T700",
    "Model": "T700"
  },
  {
    "Retail Branding": "EPIKONE",
    "Marketing Name": "TX1000",
    "Device": "TX1000",
    "Model": "TX1000"
  },
  {
    "Retail Branding": "EPIKONE",
    "Marketing Name": "TX800",
    "Device": "TX800",
    "Model": "TX800"
  },
  {
    "Retail Branding": "EPIKONE",
    "Marketing Name": "X400",
    "Device": "X400",
    "Model": "X400"
  },
  {
    "Retail Branding": "EPIKONE",
    "Marketing Name": "X410",
    "Device": "X410",
    "Model": "X410"
  },
  {
    "Retail Branding": "EPIKONE",
    "Marketing Name": "X430",
    "Device": "X430",
    "Model": "X430"
  },
  {
    "Retail Branding": "EPIKONE",
    "Marketing Name": "X500",
    "Device": "X500",
    "Model": "X500"
  },
  {
    "Retail Branding": "EPIKONE",
    "Marketing Name": "X503",
    "Device": "X503",
    "Model": "X503"
  },
  {
    "Retail Branding": "EPIKONE",
    "Marketing Name": "X507",
    "Device": "X507",
    "Model": "X507"
  },
  {
    "Retail Branding": "EPIKONE",
    "Marketing Name": "X507T",
    "Device": "X507T",
    "Model": "X507T"
  },
  {
    "Retail Branding": "EPIKONE",
    "Marketing Name": "X515",
    "Device": "X515",
    "Model": "X515"
  },
  {
    "Retail Branding": "EPIKONE",
    "Marketing Name": "X516",
    "Device": "X516",
    "Model": "X516"
  },
  {
    "Retail Branding": "EPIKONE",
    "Marketing Name": "X547",
    "Device": "X547",
    "Model": "X547"
  },
  {
    "Retail Branding": "EPIKONE",
    "Marketing Name": "X572",
    "Device": "X572",
    "Model": "X572"
  },
  {
    "Retail Branding": "EPIKONE",
    "Marketing Name": "X610",
    "Device": "X610",
    "Model": "X610"
  },
  {
    "Retail Branding": "EPIKONE",
    "Marketing Name": "X618",
    "Device": "X618",
    "Model": "X618"
  },
  {
    "Retail Branding": "EPIKONE",
    "Marketing Name": "X620",
    "Device": "X620",
    "Model": "X620"
  },
  {
    "Retail Branding": "EPIKONE",
    "Marketing Name": "X650",
    "Device": "X650",
    "Model": "X650"
  },
  {
    "Retail Branding": "EPIKONE",
    "Marketing Name": "X650_tigo",
    "Device": "X650",
    "Model": "X650"
  },
  {
    "Retail Branding": "EPIKONE",
    "Marketing Name": "X655",
    "Device": "X655",
    "Model": "X655"
  },
  {
    "Retail Branding": "EPIKONE",
    "Marketing Name": "k503",
    "Device": "K503",
    "Model": "K503"
  },
  {
    "Retail Branding": "EPSON-PowerBoard_Pro",
    "Marketing Name": "Epson India Private Limited",
    "Device": "Interactive_Display",
    "Model": "EI-XXXXP"
  },
  {
    "Retail Branding": "EQUINOXE",
    "Marketing Name": "Europe",
    "Device": "martin",
    "Model": "SE 2K Android Monitor"
  },
  {
    "Retail Branding": "ER-Telecom",
    "Marketing Name": "Movix Pro Voice",
    "Device": "SEI700ER",
    "Model": "Movix Pro Voice"
  },
  {
    "Retail Branding": "ESI Enterprises",
    "Marketing Name": "CKT3",
    "Device": "CKT3",
    "Model": "CKT3"
  },
  {
    "Retail Branding": "ESI Enterprises",
    "Marketing Name": "DT101Bv51",
    "Device": "DT101Bv51",
    "Model": "DT101Bv51"
  },
  {
    "Retail Branding": "ESI Enterprises",
    "Marketing Name": "DT7v51B",
    "Device": "DT7v51B",
    "Model": "DT7v51B"
  },
  {
    "Retail Branding": "ESI Enterprises",
    "Marketing Name": "EPIK Learning Tab 8\\'\\'",
    "Device": "ELT0801",
    "Model": "ELT0801"
  },
  {
    "Retail Branding": "ESI Enterprises",
    "Marketing Name": "EPIK Learning Tab Jr.",
    "Device": "ELT0702",
    "Model": "ELT0702"
  },
  {
    "Retail Branding": "ESI Enterprises",
    "Marketing Name": "EPIK_ELT0703",
    "Device": "ELT0703",
    "Model": "ELT0703"
  },
  {
    "Retail Branding": "ESI Enterprises",
    "Marketing Name": "Monster M7 Tablet",
    "Device": "MONSTERM7",
    "Model": "M7"
  },
  {
    "Retail Branding": "ESI Enterprises",
    "Marketing Name": "Trinity T101",
    "Device": "Trinity_T101",
    "Model": "Trinity T101"
  },
  {
    "Retail Branding": "ESI Enterprises",
    "Marketing Name": "Trinity T900",
    "Device": "Trinity_T900",
    "Model": "Trinity T900"
  },
  {
    "Retail Branding": "ESOL",
    "Marketing Name": "CCBEK",
    "Device": "rk3588_t",
    "Model": "CCBEK"
  },
  {
    "Retail Branding": "ESOL",
    "Marketing Name": "ESOL_Board",
    "Device": "rk3588_t",
    "Model": "HCB"
  },
  {
    "Retail Branding": "ESOL",
    "Marketing Name": "HCB_5186",
    "Device": "Interactive_White_Board",
    "Model": "HCB_5186"
  },
  {
    "Retail Branding": "ESOL",
    "Marketing Name": "HCB_52series",
    "Device": "Interactive_White_Board",
    "Model": "HCB_52series"
  },
  {
    "Retail Branding": "ETELPREMIUM",
    "Marketing Name": "E26",
    "Device": "E26",
    "Model": "E26"
  },
  {
    "Retail Branding": "ETELPREMIUM",
    "Marketing Name": "E27",
    "Device": "ETEL_E27",
    "Model": "ETEL P27"
  },
  {
    "Retail Branding": "ETELPREMIUM",
    "Marketing Name": "E65",
    "Device": "E65",
    "Model": "E65"
  },
  {
    "Retail Branding": "ETELPREMIUM",
    "Marketing Name": "ETEL E67",
    "Device": "ETEL-E67",
    "Model": "ETEL-E67"
  },
  {
    "Retail Branding": "ETELPREMIUM",
    "Marketing Name": "ETEL P29",
    "Device": "ETEL_P29",
    "Model": "ETEL P29"
  },
  {
    "Retail Branding": "ETELPREMIUM",
    "Marketing Name": "ETEL P65",
    "Device": "ETEL-P65",
    "Model": "ETEL-P65"
  },
  {
    "Retail Branding": "ETELPREMIUM",
    "Marketing Name": "ETEL P66",
    "Device": "ETEL-P66",
    "Model": "ETEL-P66"
  },
  {
    "Retail Branding": "ETELPREMIUM",
    "Marketing Name": "Etel P64",
    "Device": "Etel_P64",
    "Model": "Etel_P64"
  },
  {
    "Retail Branding": "ETELPREMIUM",
    "Marketing Name": "Etel P64 Ultra",
    "Device": "Etel_P64",
    "Model": "Etel P64 Ultra"
  },
  {
    "Retail Branding": "ETELPREMIUM",
    "Marketing Name": "NOTE 25 ULTRA",
    "Device": "NOTE_25_ULTRA",
    "Model": "N2500"
  },
  {
    "Retail Branding": "ETELPREMIUM",
    "Marketing Name": "P68",
    "Device": "ETEL_P68",
    "Model": "ETEL P68"
  },
  {
    "Retail Branding": "ETEL_premium",
    "Marketing Name": "E68",
    "Device": "E68",
    "Model": "E68"
  },
  {
    "Retail Branding": "ETEL_premium",
    "Marketing Name": "ETEL-E28",
    "Device": "ETEL-E28",
    "Model": "E28"
  },
  {
    "Retail Branding": "ETERNITY",
    "Marketing Name": "HERO-SP001",
    "Device": "HERO-SP001",
    "Model": "HERO-SP001"
  },
  {
    "Retail Branding": "ETERNITY",
    "Marketing Name": "HEROSP001",
    "Device": "HEROSP001",
    "Model": "SP-001"
  },
  {
    "Retail Branding": "ETERNITY",
    "Marketing Name": "ZEUSs68",
    "Device": "UWS68",
    "Model": "ZEUSs68"
  },
  {
    "Retail Branding": "ETG（G）",
    "Marketing Name": "ETG-BT1121",
    "Device": "ETG-BT1121",
    "Model": "ETG-BT1121"
  },
  {
    "Retail Branding": "ETOE",
    "Marketing Name": "A1324",
    "Device": "himalaya",
    "Model": "A1324"
  },
  {
    "Retail Branding": "ETOE",
    "Marketing Name": "A1363",
    "Device": "himalaya",
    "Model": "A1363"
  },
  {
    "Retail Branding": "ETOE",
    "Marketing Name": "D1221",
    "Device": "YUL",
    "Model": "D1221"
  },
  {
    "Retail Branding": "ETOE",
    "Marketing Name": "D2861",
    "Device": "XNA",
    "Model": "D2861"
  },
  {
    "Retail Branding": "EUDORA",
    "Marketing Name": "E10Pro",
    "Device": "E10Pro",
    "Model": "E10Pro"
  },
  {
    "Retail Branding": "EUDORA",
    "Marketing Name": "E62 Plus",
    "Device": "E62Plus",
    "Model": "E62 Plus"
  },
  {
    "Retail Branding": "EUDORA",
    "Marketing Name": "EUDORA_E55_PLUS",
    "Device": "EUDORA_E55_PLUS",
    "Model": "E55_PLUS"
  },
  {
    "Retail Branding": "EUDORA",
    "Marketing Name": "Eudora E66F",
    "Device": "Eudora_E66F",
    "Model": "Eudora E66F"
  },
  {
    "Retail Branding": "EUDORA",
    "Marketing Name": "EudoraE65Pro",
    "Device": "E65Pro",
    "Model": "E65 Pro"
  },
  {
    "Retail Branding": "EUDORA",
    "Marketing Name": "R10 Pro",
    "Device": "R10_Pro",
    "Model": "R10 Pro"
  },
  {
    "Retail Branding": "EVEREST-EVERPAD",
    "Marketing Name": "DC-1032",
    "Device": "mid1032_mk",
    "Model": "DC-1032"
  },
  {
    "Retail Branding": "EVEREST-EVERPAD",
    "Marketing Name": "DC-8015",
    "Device": "mid7015_mk",
    "Model": "DC-8015"
  },
  {
    "Retail Branding": "EVEREST-EVERPAD",
    "Marketing Name": "DC-M700",
    "Device": "DC-M700",
    "Model": "DC-M700"
  },
  {
    "Retail Branding": "EVO FUSE 4K",
    "Marketing Name": "EVO FUSE 4K",
    "Device": "SEI700L",
    "Model": "FUSE 4K"
  },
  {
    "Retail Branding": "EVO FUSE 4K",
    "Marketing Name": "EVOFUSE4K-BS",
    "Device": "SEI700TV",
    "Model": "FUSE4K-Bluestream"
  },
  {
    "Retail Branding": "EVO FUSE 4K",
    "Marketing Name": "EVOFUSE4K-BUCKEYE",
    "Device": "SEI700MOBI",
    "Model": "FUSE-MOBI"
  },
  {
    "Retail Branding": "EVO FUSE 4K",
    "Marketing Name": "EVOFUSE4K-MOBI",
    "Device": "SEI700MOBI",
    "Model": "FUSE-MOBI"
  },
  {
    "Retail Branding": "EVO FUSE 4K",
    "Marketing Name": "EVOFUSE4K-SHENTEL",
    "Device": "SEI700MOBI",
    "Model": "FUSE-MOBI"
  },
  {
    "Retail Branding": "EVOFORCE1",
    "Marketing Name": "FRC1-ABB",
    "Device": "SEI800ABB",
    "Model": "FRC1-ABB"
  },
  {
    "Retail Branding": "EVOFORCE1",
    "Marketing Name": "FRC1-Armstrong",
    "Device": "SEI800AS",
    "Model": "FRC1-Armstrong"
  },
  {
    "Retail Branding": "EVOFORCE1",
    "Marketing Name": "FRC1-BlueRidge",
    "Device": "SEI800BR",
    "Model": "FRC1-BlueRidge"
  },
  {
    "Retail Branding": "EVOFORCE1",
    "Marketing Name": "FRC1-BlueStream",
    "Device": "SEI800BS",
    "Model": "FRC1-BlueStream"
  },
  {
    "Retail Branding": "EVOFORCE1",
    "Marketing Name": "FRC1-CBT",
    "Device": "SEI800CB",
    "Model": "FRC1-CBT"
  },
  {
    "Retail Branding": "EVOFORCE1",
    "Marketing Name": "FRC1-CableCo",
    "Device": "SEI800TV",
    "Model": "FRC1-CableCo"
  },
  {
    "Retail Branding": "EVOFORCE1",
    "Marketing Name": "FRC1-Eastlink",
    "Device": "SEI800ESTL",
    "Model": "FRC1-ESTL"
  },
  {
    "Retail Branding": "EVOFORCE1",
    "Marketing Name": "FRC1-Eastlink",
    "Device": "SEI800ESTL",
    "Model": "FRC1-Eastlink"
  },
  {
    "Retail Branding": "EVOFORCE1",
    "Marketing Name": "FRC1-MDCOM",
    "Device": "SEI800MDCOM",
    "Model": "FRC1-MDCOM"
  },
  {
    "Retail Branding": "EVOFORCE1",
    "Marketing Name": "FRC1-MOBI",
    "Device": "SEI800MOBI",
    "Model": "FRC1-MOBI"
  },
  {
    "Retail Branding": "EVOFORCE1",
    "Marketing Name": "FRC1-Midco",
    "Device": "SEI800MC",
    "Model": "FRC1-Midco"
  },
  {
    "Retail Branding": "EVOFORCE1",
    "Marketing Name": "FRC1-RCN",
    "Device": "SEI800RCN",
    "Model": "FRC1-RCN"
  },
  {
    "Retail Branding": "EVOFORCE1",
    "Marketing Name": "FRC1-SECV",
    "Device": "SEI800SECV",
    "Model": "FRC1-SECV"
  },
  {
    "Retail Branding": "EVOFORCE1",
    "Marketing Name": "FRC1-SHENTEL",
    "Device": "SEI800MOBI",
    "Model": "FRC1-SHENTEL"
  },
  {
    "Retail Branding": "EVOFORCE1",
    "Marketing Name": "FRC1-TDS",
    "Device": "SEI800TDS",
    "Model": "FRC1-TDS"
  },
  {
    "Retail Branding": "EVOFORCE1",
    "Marketing Name": "MOBI-Buckeye",
    "Device": "SEI800MOBI",
    "Model": "FRC1-MOBI"
  },
  {
    "Retail Branding": "EVOFORCE1",
    "Marketing Name": "MOBI-Buckeye",
    "Device": "SEI800MOBI",
    "Model": "MOBI-Buckeye"
  },
  {
    "Retail Branding": "EVOFORCE1",
    "Marketing Name": "MOBI-SECTV",
    "Device": "SEI800MOBI",
    "Model": "FRC1-MOBI"
  },
  {
    "Retail Branding": "EVOFORCE1",
    "Marketing Name": "MOBI-SECTV",
    "Device": "SEI800MOBI",
    "Model": "MOBI-SECTV"
  },
  {
    "Retail Branding": "EVOPRO",
    "Marketing Name": "EVO Force Pro",
    "Device": "SEID00BEV",
    "Model": "EVO Force Pro"
  },
  {
    "Retail Branding": "EVOPRO",
    "Marketing Name": "EVO Fuse Pro",
    "Device": "SEID00DEV",
    "Model": "EVO Fuse Pro"
  },
  {
    "Retail Branding": "EVOPRO",
    "Marketing Name": "EVOPRO",
    "Device": "SEI500EV",
    "Model": "EVOPRO"
  },
  {
    "Retail Branding": "EVOTA",
    "Marketing Name": "EVOTA_EP",
    "Device": "MTK9679",
    "Model": "EVOTA_EP"
  },
  {
    "Retail Branding": "EVVO",
    "Marketing Name": "Android TV",
    "Device": "R1",
    "Model": "ATV R1"
  },
  {
    "Retail Branding": "EVVO",
    "Marketing Name": "Android TV",
    "Device": "R2",
    "Model": "ATV R2"
  },
  {
    "Retail Branding": "EVVO",
    "Marketing Name": "R3",
    "Device": "R3",
    "Model": "R3"
  },
  {
    "Retail Branding": "EVVO",
    "Marketing Name": "R4",
    "Device": "R4",
    "Model": "R4"
  },
  {
    "Retail Branding": "EWIS",
    "Marketing Name": "OCTA-T700M",
    "Device": "OCTA-T700M",
    "Model": "EWIS OCTA-T700M"
  },
  {
    "Retail Branding": "EWIS",
    "Marketing Name": "OCTA-T700M-T2",
    "Device": "OCTA-T700M-T2",
    "Model": "OCTA-T700M-T2"
  },
  {
    "Retail Branding": "EWIS",
    "Marketing Name": "T800MC",
    "Device": "T800MC",
    "Model": "T800MC"
  },
  {
    "Retail Branding": "EXCEED",
    "Marketing Name": "E10G21",
    "Device": "E10G21",
    "Model": "E10G21"
  },
  {
    "Retail Branding": "EXCEED",
    "Marketing Name": "E10G22",
    "Device": "E10G22",
    "Model": "E10G22"
  },
  {
    "Retail Branding": "EXCEED",
    "Marketing Name": "E10W10",
    "Device": "E10W10",
    "Model": "E10W10"
  },
  {
    "Retail Branding": "EXCEED",
    "Marketing Name": "E22",
    "Device": "Exceed_E22",
    "Model": "E22"
  },
  {
    "Retail Branding": "EXCEED",
    "Marketing Name": "EX10S10",
    "Device": "EX10S10",
    "Model": "EX10S10"
  },
  {
    "Retail Branding": "EXCEED",
    "Marketing Name": "EX10S4",
    "Device": "EX10S4",
    "Model": "EX10S4"
  },
  {
    "Retail Branding": "EXCEED",
    "Marketing Name": "EX7L4",
    "Device": "EX7L4",
    "Model": "EX7L4"
  },
  {
    "Retail Branding": "EXCEED",
    "Marketing Name": "EX7S4",
    "Device": "EX7S4",
    "Model": "EX7S4"
  },
  {
    "Retail Branding": "EXCEED",
    "Marketing Name": "EX7SL4",
    "Device": "EX7SL4",
    "Model": "EX7SL4"
  },
  {
    "Retail Branding": "EXCEED",
    "Marketing Name": "EX7W1",
    "Device": "EX7W1",
    "Model": "EX7W1"
  },
  {
    "Retail Branding": "EXCEED",
    "Marketing Name": "EX7W1S",
    "Device": "EX7W1S",
    "Model": "EX7W1S"
  },
  {
    "Retail Branding": "EXCEED",
    "Marketing Name": "EX7W4",
    "Device": "EX7W4",
    "Model": "EX7W4"
  },
  {
    "Retail Branding": "EXCEED",
    "Marketing Name": "EX7X4",
    "Device": "EX7X4",
    "Model": "EX7X4"
  },
  {
    "Retail Branding": "EXCEED",
    "Marketing Name": "EX8S1",
    "Device": "EX8S1",
    "Model": "EX8S1"
  },
  {
    "Retail Branding": "EXO S.A.",
    "Marketing Name": "EXO_Wave_i716",
    "Device": "EXO_Wave_i716",
    "Model": "EXO_Wave_i716"
  },
  {
    "Retail Branding": "EXO S.A.",
    "Marketing Name": "EXO_Wave_i726",
    "Device": "EXO_Wave_i726",
    "Model": "EXO_Wave_i726"
  },
  {
    "Retail Branding": "EXO S.A.",
    "Marketing Name": "Wave i007Kids",
    "Device": "Wave_i007Kids",
    "Model": "Wave i007Kids"
  },
  {
    "Retail Branding": "EXO S.A.",
    "Marketing Name": "Wave i007T",
    "Device": "Wave_i007T",
    "Model": "Wave i007T"
  },
  {
    "Retail Branding": "EXO S.A.",
    "Marketing Name": "Wave_i007Kids",
    "Device": "Wave_i007Kids",
    "Model": "Wave i007Kids"
  },
  {
    "Retail Branding": "EXO S.A.",
    "Marketing Name": "Wave_i101G",
    "Device": "Wave_i101G",
    "Model": "Wave_i101G"
  },
  {
    "Retail Branding": "EXO S.A.",
    "Marketing Name": "Wave_i101MC",
    "Device": "Wave_i101MC",
    "Model": "Wave_i101MC"
  },
  {
    "Retail Branding": "EXO S.A.",
    "Marketing Name": "Wave_i101T4",
    "Device": "Wave_i101T4",
    "Model": "Wave_i101T4"
  },
  {
    "Retail Branding": "EXO S.A.",
    "Marketing Name": "Wave_i101u",
    "Device": "Wave_i101u",
    "Model": "Wave_i101u"
  },
  {
    "Retail Branding": "EXO S.A.",
    "Marketing Name": "i101GMC",
    "Device": "i101GMC",
    "Model": "i101GMC"
  },
  {
    "Retail Branding": "EXO S.A.",
    "Marketing Name": "i101T2",
    "Device": "i101T2",
    "Model": "TabletEXO_Wave_i101T2"
  },
  {
    "Retail Branding": "EXO S.A.",
    "Marketing Name": "wave-i007w",
    "Device": "wave-i007w",
    "Model": "wave-i007w"
  },
  {
    "Retail Branding": "EZDS",
    "Marketing Name": "G-SCAN ZII",
    "Device": "Z7_JP",
    "Model": "Z7_JP"
  },
  {
    "Retail Branding": "EZYSMART",
    "Marketing Name": "Nexus",
    "Device": "Nexus",
    "Model": "Nexus"
  },
  {
    "Retail Branding": "EZYSMART",
    "Marketing Name": "Vision 1",
    "Device": "Vision_1",
    "Model": "Vision 1"
  },
  {
    "Retail Branding": "EZYSMART",
    "Marketing Name": "Zechin - Windriver",
    "Device": "Vision_Pro",
    "Model": "Vision_Pro"
  },
  {
    "Retail Branding": "Eaglesoar",
    "Marketing Name": "E-764-EEA",
    "Device": "E-764-EEA",
    "Model": "E-764-EEA"
  },
  {
    "Retail Branding": "Eaglesoar",
    "Marketing Name": "E10A_A15_EEA",
    "Device": "E10A_EEA",
    "Model": "E10A_EEA"
  },
  {
    "Retail Branding": "Eaglesoar",
    "Marketing Name": "E10A_EEA",
    "Device": "E10A_EEA",
    "Model": "E10A_EEA"
  },
  {
    "Retail Branding": "Eaglesoar",
    "Marketing Name": "EE-35_EEA",
    "Device": "EE-35_EEA",
    "Model": "EE-35_EEA"
  },
  {
    "Retail Branding": "Eaglesoar",
    "Marketing Name": "EE-P30_EEA",
    "Device": "EE-P30_EEA",
    "Model": "EE-P30_EEA"
  },
  {
    "Retail Branding": "Eaglesoar",
    "Marketing Name": "EE1010_EEA",
    "Device": "EE1010_EEA",
    "Model": "EE1010_EEA"
  },
  {
    "Retail Branding": "Eaglesoar",
    "Marketing Name": "EE10A",
    "Device": "EE10A",
    "Model": "EE10A"
  },
  {
    "Retail Branding": "Eaglesoar",
    "Marketing Name": "EE_35_EEA",
    "Device": "EE_35_EEA",
    "Model": "EE_35_EEA"
  },
  {
    "Retail Branding": "Eaglesoar",
    "Marketing Name": "E_764_EEA",
    "Device": "E_764_EEA",
    "Model": "E_764_EEA"
  },
  {
    "Retail Branding": "Eaglesoar",
    "Marketing Name": "Z_766_EEA",
    "Device": "Z_766_EEA",
    "Model": "Z_766_EEA"
  },
  {
    "Retail Branding": "EasyPhone",
    "Marketing Name": 100,
    "Device": 100,
    "Model": 100
  },
  {
    "Retail Branding": "Easymer",
    "Marketing Name": "K6Pro",
    "Device": "K6Pro",
    "Model": "K6Pro"
  },
  {
    "Retail Branding": "Easymer",
    "Marketing Name": "K6Pro_EEA",
    "Device": "K6Pro",
    "Model": "K6Pro"
  },
  {
    "Retail Branding": "Easymer",
    "Marketing Name": "K6m",
    "Device": "K6m",
    "Model": "K6m"
  },
  {
    "Retail Branding": "Easymer",
    "Marketing Name": "K6m_EEA",
    "Device": "K6m",
    "Model": "K6m"
  },
  {
    "Retail Branding": "Easymer",
    "Marketing Name": "X6",
    "Device": "X6",
    "Model": "X6"
  },
  {
    "Retail Branding": "Easymer",
    "Marketing Name": "X6Pro",
    "Device": "X6Pro",
    "Model": "X6Pro"
  },
  {
    "Retail Branding": "Easymer",
    "Marketing Name": "X6Pro_EEA",
    "Device": "X6Pro",
    "Model": "X6Pro"
  },
  {
    "Retail Branding": "Easymer",
    "Marketing Name": "X6_EEA",
    "Device": "X6",
    "Model": "X6"
  },
  {
    "Retail Branding": "Echo Mobiles",
    "Marketing Name": "ECHO_HOLI",
    "Device": "HOLI",
    "Model": "ECHO_HOLI"
  },
  {
    "Retail Branding": "Echo Mobiles",
    "Marketing Name": "FEELING",
    "Device": "FEELING",
    "Model": "FEELING"
  },
  {
    "Retail Branding": "Echo Mobiles",
    "Marketing Name": "FUSION",
    "Device": "ECHO_FUSION",
    "Model": "ECHO_FUSION"
  },
  {
    "Retail Branding": "Echo Mobiles",
    "Marketing Name": "HORIZON",
    "Device": "HORIZON",
    "Model": "HORIZON"
  },
  {
    "Retail Branding": "Echo Mobiles",
    "Marketing Name": "HORIZON LITE",
    "Device": "ECHO_HORIZON_LITE",
    "Model": "ECHO_HORIZON_LITE"
  },
  {
    "Retail Branding": "Echo Mobiles",
    "Marketing Name": "LOOK",
    "Device": "LOOK",
    "Model": "LOOK"
  },
  {
    "Retail Branding": "Echo Mobiles",
    "Marketing Name": "MODELABS MOBILES",
    "Device": "HORIZON_M",
    "Model": "HORIZON_M"
  },
  {
    "Retail Branding": "Echo Mobiles",
    "Marketing Name": "Moon",
    "Device": "MOON",
    "Model": "MOON"
  },
  {
    "Retail Branding": "Echo Mobiles",
    "Marketing Name": "SURF",
    "Device": "SURF",
    "Model": "SURF"
  },
  {
    "Retail Branding": "Echo Mobiles",
    "Marketing Name": "Stellar 4G",
    "Device": "Stellar_4G",
    "Model": "Stellar 4G"
  },
  {
    "Retail Branding": "Echolink",
    "Marketing Name": "ENOVA STICK",
    "Device": "IAD",
    "Model": "ENOVA STICK"
  },
  {
    "Retail Branding": "Echolink",
    "Marketing Name": "Echolink TV",
    "Device": "shinagawa",
    "Model": "Echolink TV"
  },
  {
    "Retail Branding": "EcoStar",
    "Marketing Name": "ECOSTAR",
    "Device": "elliniko",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "EcoStar",
    "Marketing Name": "ECOSTAR",
    "Device": "khardi",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "EcoStar",
    "Marketing Name": "ECOSTAR",
    "Device": "mountbaker",
    "Model": "2K SMART TV"
  },
  {
    "Retail Branding": "EcoStar",
    "Marketing Name": "ECOSTAR",
    "Device": "stanford",
    "Model": "40D"
  },
  {
    "Retail Branding": "EcoStar",
    "Marketing Name": "ECOSTAR",
    "Device": "zhongshan",
    "Model": "43F"
  },
  {
    "Retail Branding": "EcoStar",
    "Marketing Name": "ECOSTAR SMART TV",
    "Device": "SW4H",
    "Model": "ECOSTAR SMART TV"
  },
  {
    "Retail Branding": "EcoStar",
    "Marketing Name": "EcostarTV",
    "Device": "shibuya",
    "Model": "EcostarTV"
  },
  {
    "Retail Branding": "Ecopower",
    "Marketing Name": "EP-A100",
    "Device": "EP-A100",
    "Model": "EP-A100"
  },
  {
    "Retail Branding": "Edcon",
    "Marketing Name": "Motion E1.1",
    "Device": "MotionE11",
    "Model": "MotionE11"
  },
  {
    "Retail Branding": "Edcon",
    "Marketing Name": "Platiunm vp.1",
    "Device": "VerssedVP1",
    "Model": "Verssed VP1"
  },
  {
    "Retail Branding": "Edcon",
    "Marketing Name": "Platiunm vp.2",
    "Device": "VerssedVP2",
    "Model": "Verssed VP2"
  },
  {
    "Retail Branding": "Edcon",
    "Marketing Name": "VERSSED platinum vp.2.1",
    "Device": "VERSSEDvp2-1",
    "Model": "VERSSED vp2.1"
  },
  {
    "Retail Branding": "Edcon",
    "Marketing Name": "Verssed Platinum VP3.0",
    "Device": "VERSSED_Vp3",
    "Model": "VERSSED vp3"
  },
  {
    "Retail Branding": "Edong",
    "Marketing Name": "1EY4G",
    "Device": "1EY4G",
    "Model": "1EY4G"
  },
  {
    "Retail Branding": "Edong",
    "Marketing Name": "LOL-775",
    "Device": "LOL_775",
    "Model": "LOL-775"
  },
  {
    "Retail Branding": "Edong",
    "Marketing Name": "PortableS",
    "Device": "PortableS",
    "Model": "PortableS"
  },
  {
    "Retail Branding": "Ehlel",
    "Marketing Name": "Defender",
    "Device": "Ehlel_Defender_D23",
    "Model": "Defender D23"
  },
  {
    "Retail Branding": "Ehlel",
    "Marketing Name": "Ehlel C7 PRO",
    "Device": "Ehlel-C7PRO",
    "Model": "Ehlel C7 PRO"
  },
  {
    "Retail Branding": "Ehlel",
    "Marketing Name": "HULAN21 PLUS",
    "Device": "Ehlel-Hulan21",
    "Model": "HULAN21 PLUS"
  },
  {
    "Retail Branding": "Eigou",
    "Marketing Name": "M5501_B",
    "Device": "M5501_B",
    "Model": "M5501_B"
  },
  {
    "Retail Branding": "Einstein",
    "Marketing Name": "ENTAB3",
    "Device": "ENTAB3",
    "Model": "EinsteinT3"
  },
  {
    "Retail Branding": "Einstein",
    "Marketing Name": "Tablet3Pro",
    "Device": "Tablet3Pro",
    "Model": "Tablet3Pro"
  },
  {
    "Retail Branding": "Ekotek",
    "Marketing Name": "Sonata",
    "Device": "Sonata",
    "Model": "Sonata"
  },
  {
    "Retail Branding": "Ekron",
    "Marketing Name": "DE-T414",
    "Device": "DE-T414",
    "Model": "DE-T414"
  },
  {
    "Retail Branding": "Eks Mobility",
    "Marketing Name": "S45U",
    "Device": "S45U",
    "Model": "EKS S45U"
  },
  {
    "Retail Branding": "Eks Mobility",
    "Marketing Name": "S5LS",
    "Device": "S5LS",
    "Model": "S5LS"
  },
  {
    "Retail Branding": "Eks Mobility",
    "Marketing Name": "S5US",
    "Device": "S5US",
    "Model": "S5US"
  },
  {
    "Retail Branding": "Eks Mobility",
    "Marketing Name": "T4",
    "Device": "T4",
    "Model": "T4"
  },
  {
    "Retail Branding": "Eks Mobility",
    "Marketing Name": "X4U+",
    "Device": "X4UPlus",
    "Model": "X4UPlus"
  },
  {
    "Retail Branding": "Eks Mobility",
    "Marketing Name": "X6",
    "Device": "X6",
    "Model": "X6"
  },
  {
    "Retail Branding": "Eks Mobility",
    "Marketing Name": "Z5",
    "Device": "Z5",
    "Model": "Z5"
  },
  {
    "Retail Branding": "Eks Mobility",
    "Marketing Name": "x7",
    "Device": "X7",
    "Model": "X7"
  },
  {
    "Retail Branding": "Elecost",
    "Marketing Name": "QuadTab E10.1",
    "Device": "QuadTab_E101",
    "Model": "QuadTab E10.1"
  },
  {
    "Retail Branding": "Elecson",
    "Marketing Name": "Meeplus_1",
    "Device": "Meeplus_1",
    "Model": "Meeplus_1"
  },
  {
    "Retail Branding": "Elecson",
    "Marketing Name": "Prime X",
    "Device": "PrimeX1",
    "Model": "Prime X"
  },
  {
    "Retail Branding": "Electroland Ghana",
    "Marketing Name": "NASCO_Allure",
    "Device": "NASCO_Allure",
    "Model": "NASCO_Allure"
  },
  {
    "Retail Branding": "Electroman",
    "Marketing Name": "ELECTROMAN",
    "Device": "mountbaker",
    "Model": "Smart FHD TV"
  },
  {
    "Retail Branding": "Electroman",
    "Marketing Name": "Electroman",
    "Device": "hongkong",
    "Model": "Smart UHD TV"
  },
  {
    "Retail Branding": "Electroman",
    "Marketing Name": "Electroman",
    "Device": "stanford",
    "Model": "Smart FHD TV"
  },
  {
    "Retail Branding": "Electroman",
    "Marketing Name": "Electroman",
    "Device": "zhongshan",
    "Model": "Smart UHD TV"
  },
  {
    "Retail Branding": "Electroneum",
    "Marketing Name": "electroneumM1",
    "Device": "electroneumM1",
    "Model": "electroneumM1"
  },
  {
    "Retail Branding": "Element",
    "Marketing Name": "ELEMENT",
    "Device": "hongkong",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "Element",
    "Marketing Name": "ELEMENT",
    "Device": "khardi",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "Element",
    "Marketing Name": "Element",
    "Device": "bruno",
    "Model": "Element2KAndroidTV"
  },
  {
    "Retail Branding": "Element",
    "Marketing Name": "Element",
    "Device": "expo",
    "Model": "ElementDeluxe4k"
  },
  {
    "Retail Branding": "Element",
    "Marketing Name": "Element",
    "Device": "kaitak",
    "Model": "ElementPlatiumTV"
  },
  {
    "Retail Branding": "Element",
    "Marketing Name": "Element",
    "Device": "shilin",
    "Model": "Element4KAndroidTV"
  },
  {
    "Retail Branding": "Element",
    "Marketing Name": "Element",
    "Device": "tennoji",
    "Model": "ElementDeluxe2K"
  },
  {
    "Retail Branding": "Element",
    "Marketing Name": "Smart TV",
    "Device": "osaka",
    "Model": "E300AF32PBG"
  },
  {
    "Retail Branding": "Element",
    "Marketing Name": "USA & CANADA",
    "Device": "Tiger838",
    "Model": "TU43GDX"
  },
  {
    "Retail Branding": "Elephone",
    "Marketing Name": "A2",
    "Device": "A2",
    "Model": "A2"
  },
  {
    "Retail Branding": "Elephone",
    "Marketing Name": "A3_Pro",
    "Device": "A3_Pro",
    "Model": "A3_Pro"
  },
  {
    "Retail Branding": "Elephone",
    "Marketing Name": "A4",
    "Device": "A4",
    "Model": "A4"
  },
  {
    "Retail Branding": "Elephone",
    "Marketing Name": "A4_Pro",
    "Device": "A4_Pro",
    "Model": "A4_Pro"
  },
  {
    "Retail Branding": "Elephone",
    "Marketing Name": "A5",
    "Device": "A5",
    "Model": "A5"
  },
  {
    "Retail Branding": "Elephone",
    "Marketing Name": "A6_Max",
    "Device": "A6_Max",
    "Model": "A6_Max"
  },
  {
    "Retail Branding": "Elephone",
    "Marketing Name": "A6_mini",
    "Device": "A6_mini",
    "Model": "A6_mini"
  },
  {
    "Retail Branding": "Elephone",
    "Marketing Name": "A7H",
    "Device": "A7H",
    "Model": "A7H"
  },
  {
    "Retail Branding": "Elephone",
    "Marketing Name": "E10",
    "Device": "E10",
    "Model": "E10"
  },
  {
    "Retail Branding": "Elephone",
    "Marketing Name": "E10_Pro",
    "Device": "E10_Pro",
    "Model": "E10_Pro"
  },
  {
    "Retail Branding": "Elephone",
    "Marketing Name": "Elephone S8",
    "Device": "S8",
    "Model": "S8"
  },
  {
    "Retail Branding": "Elephone",
    "Marketing Name": "P11",
    "Device": "P11",
    "Model": "P11"
  },
  {
    "Retail Branding": "Elephone",
    "Marketing Name": "P8 3D",
    "Device": "P8_3D",
    "Model": "P8_3D"
  },
  {
    "Retail Branding": "Elephone",
    "Marketing Name": "P8 Max",
    "Device": "P8_Max",
    "Model": "P8_Max"
  },
  {
    "Retail Branding": "Elephone",
    "Marketing Name": "PX",
    "Device": "PX",
    "Model": "PX"
  },
  {
    "Retail Branding": "Elephone",
    "Marketing Name": "PX_Pro",
    "Device": "PX_Pro",
    "Model": "PX_Pro"
  },
  {
    "Retail Branding": "Elephone",
    "Marketing Name": "Soldier",
    "Device": "Soldier",
    "Model": "Soldier"
  },
  {
    "Retail Branding": "Elephone",
    "Marketing Name": "U",
    "Device": "Elephone_U",
    "Model": "U"
  },
  {
    "Retail Branding": "Elephone",
    "Marketing Name": "U2",
    "Device": "U2",
    "Model": "U2"
  },
  {
    "Retail Branding": "Elephone",
    "Marketing Name": "U3H",
    "Device": "U3H",
    "Model": "U3H"
  },
  {
    "Retail Branding": "Elephone",
    "Marketing Name": "U5",
    "Device": "U5",
    "Model": "U5"
  },
  {
    "Retail Branding": "Elephone",
    "Marketing Name": "U_Pro",
    "Device": "U_Pro",
    "Model": "U_Pro"
  },
  {
    "Retail Branding": "Elephone",
    "Marketing Name": "W3",
    "Device": "W3",
    "Model": "W3"
  },
  {
    "Retail Branding": "Elevate",
    "Marketing Name": "G50",
    "Device": "G50",
    "Model": "G50"
  },
  {
    "Retail Branding": "Elevate",
    "Marketing Name": "G55_LITE",
    "Device": "G55_LITE",
    "Model": "G55 LITE"
  },
  {
    "Retail Branding": "Elevate",
    "Marketing Name": "LUNA G5",
    "Device": "G5",
    "Model": "LUNA G5"
  },
  {
    "Retail Branding": "Elevate",
    "Marketing Name": "LUNA G50",
    "Device": "LUNA_G50",
    "Model": "LUNA G50"
  },
  {
    "Retail Branding": "Elevate",
    "Marketing Name": "LUNA G58",
    "Device": "G58",
    "Model": "LUNA G58"
  },
  {
    "Retail Branding": "Elevate",
    "Marketing Name": "LUNA G60",
    "Device": "G60",
    "Model": "LUNA G60"
  },
  {
    "Retail Branding": "Elevate",
    "Marketing Name": "LUNA G60X",
    "Device": "G60X",
    "Model": "LUNA G60X"
  },
  {
    "Retail Branding": "Elevate",
    "Marketing Name": "LUNA G62",
    "Device": "G62",
    "Model": "LUNA G62"
  },
  {
    "Retail Branding": "Elevate",
    "Marketing Name": "LUNA V55",
    "Device": "V55",
    "Model": "LUNA V55"
  },
  {
    "Retail Branding": "Elevate",
    "Marketing Name": "LUNA V55A",
    "Device": "V55A",
    "Model": "LUNA V55A"
  },
  {
    "Retail Branding": "Elevate",
    "Marketing Name": "LUNA V57",
    "Device": "V57",
    "Model": "LUNA V57"
  },
  {
    "Retail Branding": "Elevate",
    "Marketing Name": "R50A",
    "Device": "R50A",
    "Model": "R50A"
  },
  {
    "Retail Branding": "Elevate",
    "Marketing Name": "V55C",
    "Device": "V55C",
    "Model": "V55C"
  },
  {
    "Retail Branding": "Elink",
    "Marketing Name": "L863-10",
    "Device": "L863-10",
    "Model": "L863-10"
  },
  {
    "Retail Branding": "Elink",
    "Marketing Name": "T201",
    "Device": "T201",
    "Model": "T201"
  },
  {
    "Retail Branding": "Elink",
    "Marketing Name": "Winnovo",
    "Device": "T7",
    "Model": "T7"
  },
  {
    "Retail Branding": "Elisa",
    "Marketing Name": "B866V2F01",
    "Device": "STB_ELISA_B866V2F01",
    "Model": "B866V2F01"
  },
  {
    "Retail Branding": "Elisa",
    "Marketing Name": "Viihde Sound",
    "Device": "HP4AD-Elisa",
    "Model": "Helo3"
  },
  {
    "Retail Branding": "Elitelux",
    "Marketing Name": "Australia",
    "Device": "yeongdeungpo",
    "Model": "AiPlus4K"
  },
  {
    "Retail Branding": "ElliQ",
    "Marketing Name": "ElliQTablet",
    "Device": "ElliQTablet",
    "Model": "ElliQTablet"
  },
  {
    "Retail Branding": "Elong Mobile",
    "Marketing Name": "6AT",
    "Device": "6AT",
    "Model": "6AT"
  },
  {
    "Retail Branding": "Elong Mobile",
    "Marketing Name": "6CS",
    "Device": "6CS",
    "Model": "6CS"
  },
  {
    "Retail Branding": "Elong Mobile",
    "Marketing Name": "Y50",
    "Device": "Y50",
    "Model": "Y50"
  },
  {
    "Retail Branding": "Elong Mobile",
    "Marketing Name": "Y50s",
    "Device": "Y50s",
    "Model": "Y50s"
  },
  {
    "Retail Branding": "Elsys",
    "Marketing Name": "ETRI01",
    "Device": "SEI103",
    "Model": "ETRI01"
  },
  {
    "Retail Branding": "Elsys",
    "Marketing Name": "ETRI02",
    "Device": "tai",
    "Model": "ETRI02"
  },
  {
    "Retail Branding": "Ematic",
    "Marketing Name": "7\\'\\' dvd tablet",
    "Device": "PBDV704DVD",
    "Model": "PBDV704DVD"
  },
  {
    "Retail Branding": "Ematic",
    "Marketing Name": "Cubby",
    "Device": "SproutChannelCubby",
    "Model": "SproutChannelCubby"
  },
  {
    "Retail Branding": "Ematic",
    "Marketing Name": "EBM104JB",
    "Device": "EBM104JB",
    "Model": "EBM104JB"
  },
  {
    "Retail Branding": "Ematic",
    "Marketing Name": "EGD078",
    "Device": "EGD078",
    "Model": "EGD078"
  },
  {
    "Retail Branding": "Ematic",
    "Marketing Name": "EGD103",
    "Device": "EGD103",
    "Model": "EGD103"
  },
  {
    "Retail Branding": "Ematic",
    "Marketing Name": "EGD170",
    "Device": "EGD170",
    "Model": "Ematic EGD170"
  },
  {
    "Retail Branding": "Ematic",
    "Marketing Name": "EGD172",
    "Device": "EGD172",
    "Model": "EGD172"
  },
  {
    "Retail Branding": "Ematic",
    "Marketing Name": "EGD213",
    "Device": "EGD213",
    "Model": "EGD213"
  },
  {
    "Retail Branding": "Ematic",
    "Marketing Name": "EGQ101",
    "Device": "EGQ101",
    "Model": "EGQ101"
  },
  {
    "Retail Branding": "Ematic",
    "Marketing Name": "EGQ178",
    "Device": "EGQ178",
    "Model": "EGQ178"
  },
  {
    "Retail Branding": "Ematic",
    "Marketing Name": "EGQ180",
    "Device": "EGQ180",
    "Model": "EGQ180"
  },
  {
    "Retail Branding": "Ematic",
    "Marketing Name": "EGQ223",
    "Device": "EGQ223",
    "Model": "EGQ223"
  },
  {
    "Retail Branding": "Ematic",
    "Marketing Name": "EGQ235SK",
    "Device": "EGQ235SK",
    "Model": "EGQ235SK"
  },
  {
    "Retail Branding": "Ematic",
    "Marketing Name": "EGQ236BD",
    "Device": "EGQ236BD",
    "Model": "EGQ236BD"
  },
  {
    "Retail Branding": "Ematic",
    "Marketing Name": "EGQ238BD",
    "Device": "EGQ238BD",
    "Model": "EGQ238BD"
  },
  {
    "Retail Branding": "Ematic",
    "Marketing Name": "EGQ307",
    "Device": "EGQ307",
    "Model": "EGQ307"
  },
  {
    "Retail Branding": "Ematic",
    "Marketing Name": "EGQ327M",
    "Device": "EGQ327M",
    "Model": "EGQ327M"
  },
  {
    "Retail Branding": "Ematic",
    "Marketing Name": "EGQ337",
    "Device": "EGQ337",
    "Model": "EGQ337"
  },
  {
    "Retail Branding": "Ematic",
    "Marketing Name": "EGQ347",
    "Device": "EGQ347",
    "Model": "EGQ347"
  },
  {
    "Retail Branding": "Ematic",
    "Marketing Name": "EGQ367",
    "Device": "EGQ367",
    "Model": "EGQ367"
  },
  {
    "Retail Branding": "Ematic",
    "Marketing Name": "EGQ375",
    "Device": "EGQ375",
    "Model": "EGQ375"
  },
  {
    "Retail Branding": "Ematic",
    "Marketing Name": "EGQ377",
    "Device": "EGQ377",
    "Model": "EGQ377"
  },
  {
    "Retail Branding": "Ematic",
    "Marketing Name": "EGQ780",
    "Device": "EGQ780",
    "Model": "EGQ780"
  },
  {
    "Retail Branding": "Ematic",
    "Marketing Name": "EGS017",
    "Device": "EGS017",
    "Model": "EGS017"
  },
  {
    "Retail Branding": "Ematic",
    "Marketing Name": "EMATICEGS109",
    "Device": "EGS109",
    "Model": "EGS109"
  },
  {
    "Retail Branding": "Ematic",
    "Marketing Name": "ETH102",
    "Device": "ETH102",
    "Model": "ETH102"
  },
  {
    "Retail Branding": "Ematic",
    "Marketing Name": "Ematic",
    "Device": "EGQ239BD",
    "Model": "EGQ239BD"
  },
  {
    "Retail Branding": "Ematic",
    "Marketing Name": "FunTab 2",
    "Device": "FunTab2",
    "Model": "FunTab2"
  },
  {
    "Retail Branding": "Ematic",
    "Marketing Name": "FunTab 3",
    "Device": "Funtab3",
    "Model": "FunTabPlay"
  },
  {
    "Retail Branding": "Ematic",
    "Marketing Name": "FunTab 3",
    "Device": "Funtab3",
    "Model": "Funtab3"
  },
  {
    "Retail Branding": "Ematic",
    "Marketing Name": "FunTab4",
    "Device": "FunTab4",
    "Model": "FunTab4"
  },
  {
    "Retail Branding": "Ematic",
    "Marketing Name": "GTB103B",
    "Device": "Stealth_GTB103M",
    "Model": "GTB103M"
  },
  {
    "Retail Branding": "Ematic",
    "Marketing Name": "Jetstream AGT418",
    "Device": "DV8235",
    "Model": "AGT419"
  },
  {
    "Retail Branding": "Ematic",
    "Marketing Name": "Jetstream AGT418",
    "Device": "DV8235",
    "Model": "Jetstream AGT418"
  },
  {
    "Retail Branding": "Ematic",
    "Marketing Name": "PBS Kids PlayPad",
    "Device": "PBSKD12",
    "Model": "PBSKD12"
  },
  {
    "Retail Branding": "Ematic",
    "Marketing Name": "PBSKD7001",
    "Device": "PBSKD7001",
    "Model": "PBSKD7001"
  },
  {
    "Retail Branding": "Ematic",
    "Marketing Name": "PBSKD7200",
    "Device": "PBSKD7200",
    "Model": "PBSKD7200"
  },
  {
    "Retail Branding": "Ematic",
    "Marketing Name": "PBSKD7201",
    "Device": "PBSKD7201",
    "Model": "PBSKD7201"
  },
  {
    "Retail Branding": "Ematic",
    "Marketing Name": "Sprout Channel Cubby",
    "Device": "Cubby",
    "Model": "SproutChannelCubby"
  },
  {
    "Retail Branding": "Ematic",
    "Marketing Name": "USA",
    "Device": "Jetstream",
    "Model": "AGT418"
  },
  {
    "Retail Branding": "Emdoor",
    "Marketing Name": "ARKENSTONE",
    "Device": "ARKENSTONE_US",
    "Model": "ARKENSTONE"
  },
  {
    "Retail Branding": "Emdoor",
    "Marketing Name": "EM_I8180",
    "Device": "em_i8180",
    "Model": "em_i8180"
  },
  {
    "Retail Branding": "Emerson",
    "Marketing Name": "EID-1400",
    "Device": "EID-1400",
    "Model": "EID-1400"
  },
  {
    "Retail Branding": "Emerson",
    "Marketing Name": "EID_1001",
    "Device": "EID_1001",
    "Model": "EID-1001"
  },
  {
    "Retail Branding": "Emerson",
    "Marketing Name": "EID_1050",
    "Device": "EID_1050",
    "Model": "EID-1050"
  },
  {
    "Retail Branding": "Emerson",
    "Marketing Name": "EID_1061",
    "Device": "EID_1061",
    "Model": "EID-1061"
  },
  {
    "Retail Branding": "Emerson",
    "Marketing Name": "EID_1062",
    "Device": "EID_1062",
    "Model": "EID-1062"
  },
  {
    "Retail Branding": "Emerson",
    "Marketing Name": "EID_9000",
    "Device": "EID_9000",
    "Model": "EID-9000"
  },
  {
    "Retail Branding": "Emerson",
    "Marketing Name": "EM749/748",
    "Device": "EM749_748",
    "Model": "EM749_748"
  },
  {
    "Retail Branding": "Emerson",
    "Marketing Name": "EM9",
    "Device": "EM9",
    "Model": "EM9"
  },
  {
    "Retail Branding": "Emporia",
    "Marketing Name": "E5mini",
    "Device": "E5mini",
    "Model": "E5mini"
  },
  {
    "Retail Branding": "Emporia",
    "Marketing Name": "E6_EEA",
    "Device": "E6",
    "Model": "E6"
  },
  {
    "Retail Branding": "Emporia",
    "Marketing Name": "E6mini",
    "Device": "E6mini",
    "Model": "E6mini"
  },
  {
    "Retail Branding": "Emporia",
    "Marketing Name": "Emporia SMART 3",
    "Device": "S3",
    "Model": "S3"
  },
  {
    "Retail Branding": "Emporia",
    "Marketing Name": "S3mini",
    "Device": "S3mini",
    "Model": "S3mini"
  },
  {
    "Retail Branding": "Emporia",
    "Marketing Name": "S4i",
    "Device": "S4",
    "Model": "S4"
  },
  {
    "Retail Branding": "Emporia",
    "Marketing Name": "S5_EEA",
    "Device": "S5",
    "Model": "S5"
  },
  {
    "Retail Branding": "Emporia",
    "Marketing Name": "SE",
    "Device": "SE",
    "Model": "SE"
  },
  {
    "Retail Branding": "Emporia",
    "Marketing Name": "SEi",
    "Device": "SE",
    "Model": "SE"
  },
  {
    "Retail Branding": "Emporia",
    "Marketing Name": "TAB1",
    "Device": "TAB1",
    "Model": "TAB1"
  },
  {
    "Retail Branding": "Emporia",
    "Marketing Name": "TAB1A",
    "Device": "TAB1A",
    "Model": "TAB1A"
  },
  {
    "Retail Branding": "Emporia",
    "Marketing Name": "emporiaSMART.4",
    "Device": "S4",
    "Model": "S4"
  },
  {
    "Retail Branding": "Emporia",
    "Marketing Name": "emporiaSMART.7lite",
    "Device": "E7LT",
    "Model": "E7LT"
  },
  {
    "Retail Branding": "Emtec",
    "Marketing Name": "F400",
    "Device": "f400",
    "Model": "f400"
  },
  {
    "Retail Branding": "Emtec",
    "Marketing Name": "Gaming Android Gem Box",
    "Device": "F500",
    "Model": "Gem Box F500"
  },
  {
    "Retail Branding": "Emtec",
    "Marketing Name": "PBSKD7001",
    "Device": "PBSKD7001",
    "Model": "PBSKD7001"
  },
  {
    "Retail Branding": "Energizer",
    "Marketing Name": "EnergyE500",
    "Device": "EnergyE500",
    "Model": "EnergyE500"
  },
  {
    "Retail Branding": "Energizer",
    "Marketing Name": "EnergyE500S_EU",
    "Device": "EnergyE500S_EU",
    "Model": "EnergyE500S_EU"
  },
  {
    "Retail Branding": "Energizer",
    "Marketing Name": "EnergyE500S_US",
    "Device": "EnergyE500S_US",
    "Model": "EnergyE500S_US"
  },
  {
    "Retail Branding": "Energizer",
    "Marketing Name": "H550S",
    "Device": "HARDCASEH550S",
    "Model": "HARDCASEH550S"
  },
  {
    "Retail Branding": "Energizer",
    "Marketing Name": "H67G",
    "Device": "H67G",
    "Model": "H67G"
  },
  {
    "Retail Branding": "Energizer",
    "Marketing Name": "HARDCASEH500S",
    "Device": "HARDCASEH500S",
    "Model": "HARDCASEH500S"
  },
  {
    "Retail Branding": "Energizer",
    "Marketing Name": "Hardcase H620S",
    "Device": "H620SEU",
    "Model": "H620SEU"
  },
  {
    "Retail Branding": "Energizer",
    "Marketing Name": "Hardcase H621S",
    "Device": "H621SEU",
    "Model": "H621SEU"
  },
  {
    "Retail Branding": "Energizer",
    "Marketing Name": "PowerMaxP490",
    "Device": "PowerMaxP490",
    "Model": "PowerMaxP490"
  },
  {
    "Retail Branding": "Energizer",
    "Marketing Name": "PowerMaxP490S_AP",
    "Device": "PowerMaxP490S_AP",
    "Model": "PowerMaxP490S_AP"
  },
  {
    "Retail Branding": "Energizer",
    "Marketing Name": "PowerMaxP490S_AS",
    "Device": "PowerMaxP490S_AS",
    "Model": "PowerMaxP490S_AS"
  },
  {
    "Retail Branding": "Energizer",
    "Marketing Name": "PowerMaxP490S_EU",
    "Device": "PowerMaxP490S_EU",
    "Model": "PowerMaxP490S_EU"
  },
  {
    "Retail Branding": "Energizer",
    "Marketing Name": "PowerMaxP550S",
    "Device": "PowerMaxP550S",
    "Model": "P550S"
  },
  {
    "Retail Branding": "Energizer",
    "Marketing Name": "PowerMaxP600S",
    "Device": "PowerMaxP600S",
    "Model": "PowerMaxP600S"
  },
  {
    "Retail Branding": "Energizer",
    "Marketing Name": "S550",
    "Device": "S550",
    "Model": "S550"
  },
  {
    "Retail Branding": "Energizer",
    "Marketing Name": "U505S",
    "Device": "U505S",
    "Model": "U505S"
  },
  {
    "Retail Branding": "Energizer",
    "Marketing Name": "U506S",
    "Device": "U506S",
    "Model": "U506S"
  },
  {
    "Retail Branding": "Energizer",
    "Marketing Name": "U608S",
    "Device": "U608S",
    "Model": "U608S"
  },
  {
    "Retail Branding": "Energizer",
    "Marketing Name": "U652S",
    "Device": "U652S",
    "Model": "U652S"
  },
  {
    "Retail Branding": "Energizer",
    "Marketing Name": "U652S+",
    "Device": "U652S_PLUS",
    "Model": "U652S+"
  },
  {
    "Retail Branding": "Energizer",
    "Marketing Name": "U683S",
    "Device": "U683S",
    "Model": "U683S"
  },
  {
    "Retail Branding": "Energizer",
    "Marketing Name": "U6GEU256",
    "Device": "U6GEU256",
    "Model": "U6G"
  },
  {
    "Retail Branding": "Energizer",
    "Marketing Name": "U6GEU64",
    "Device": "U6GEU64",
    "Model": "U6G"
  },
  {
    "Retail Branding": "Energizer",
    "Marketing Name": "U6GNEU64",
    "Device": "U6GNEU64",
    "Model": "U6G"
  },
  {
    "Retail Branding": "Energizer",
    "Marketing Name": "Ultimate U710S",
    "Device": "Ultimate_U710S",
    "Model": "Ultimate U710S"
  },
  {
    "Retail Branding": "EnergySistem",
    "Marketing Name": "adelroth",
    "Device": "adelroth",
    "Model": "Energy Tablet Pro 4"
  },
  {
    "Retail Branding": "Enerpres",
    "Marketing Name": "SMIG_V",
    "Device": "SMIG_V",
    "Model": "SMIG_V"
  },
  {
    "Retail Branding": "Engage",
    "Marketing Name": "EN_1DS",
    "Device": "EN_1DS",
    "Model": "Digital Signage"
  },
  {
    "Retail Branding": "Engel",
    "Marketing Name": "4K Smart TV",
    "Device": "pioneer",
    "Model": "4K PA Smart TV"
  },
  {
    "Retail Branding": "Engel",
    "Marketing Name": "ENGEL",
    "Device": "bangbae",
    "Model": "Engel 4K Android TV"
  },
  {
    "Retail Branding": "Engel",
    "Marketing Name": "Smart TV",
    "Device": "mateo",
    "Model": "2K PA Smart TV"
  },
  {
    "Retail Branding": "Engel",
    "Marketing Name": "Smart TV",
    "Device": "osaki",
    "Model": "2K AI Smart TV"
  },
  {
    "Retail Branding": "Englaon",
    "Marketing Name": "ENGLAON",
    "Device": "elliniko",
    "Model": "ENGLAON 4K GOOGLE TV"
  },
  {
    "Retail Branding": "Englaon",
    "Marketing Name": "ENGLAON",
    "Device": "mountbaker",
    "Model": "2K SMART TV"
  },
  {
    "Retail Branding": "Englaon",
    "Marketing Name": "ENGLAON",
    "Device": "mountbaker",
    "Model": "ENGLAON 2K Google TV"
  },
  {
    "Retail Branding": "Englaon",
    "Marketing Name": "ENGLAON",
    "Device": "stanford",
    "Model": "2K SMART TV"
  },
  {
    "Retail Branding": "Enspert",
    "Marketing Name": "",
    "Device": "E-TAB",
    "Model": "E-TAB"
  },
  {
    "Retail Branding": "Enspert",
    "Marketing Name": "",
    "Device": "ESP_E301",
    "Model": "ESP_E301BK"
  },
  {
    "Retail Branding": "Enspert",
    "Marketing Name": "",
    "Device": "ESP_E301",
    "Model": "ESP_E301V"
  },
  {
    "Retail Branding": "Enspert",
    "Marketing Name": "",
    "Device": "ESP_E301",
    "Model": "ESP_E301VD"
  },
  {
    "Retail Branding": "Enspert",
    "Marketing Name": "",
    "Device": "ESP_E301",
    "Model": "ESP_E301VE"
  },
  {
    "Retail Branding": "Enspert",
    "Marketing Name": "",
    "Device": "e201",
    "Model": "ESP_E201V7"
  },
  {
    "Retail Branding": "Enspert",
    "Marketing Name": "",
    "Device": "e201",
    "Model": "enspert_e201"
  },
  {
    "Retail Branding": "Enspert",
    "Marketing Name": "",
    "Device": "illuminus",
    "Model": "ITP-S100WD"
  },
  {
    "Retail Branding": "Enspert",
    "Marketing Name": "",
    "Device": "s8073",
    "Model": "Miracle"
  },
  {
    "Retail Branding": "Enspert",
    "Marketing Name": "CINK KING",
    "Device": "s9081",
    "Model": "CINK KING"
  },
  {
    "Retail Branding": "Enspert",
    "Marketing Name": "CINK KING",
    "Device": "s9081",
    "Model": "Cynus T2"
  },
  {
    "Retail Branding": "Enspert",
    "Marketing Name": "CINK KING",
    "Device": "s9081",
    "Model": "IMD501"
  },
  {
    "Retail Branding": "Enspert",
    "Marketing Name": "CINK KING",
    "Device": "s9081",
    "Model": "freebit PandA"
  },
  {
    "Retail Branding": "Enspert",
    "Marketing Name": "CINK SLIM",
    "Device": "s8073",
    "Model": "CINK SLIM"
  },
  {
    "Retail Branding": "Enspert",
    "Marketing Name": "CINK SLIM",
    "Device": "s8073",
    "Model": "Fly_IQ442"
  },
  {
    "Retail Branding": "Enspert",
    "Marketing Name": "CINK SLIM",
    "Device": "s8073",
    "Model": "WIKO-CINK SLIM"
  },
  {
    "Retail Branding": "Enspert",
    "Marketing Name": "Carrefour CT1010",
    "Device": "Carrefour",
    "Model": "CT1010"
  },
  {
    "Retail Branding": "Enspert",
    "Marketing Name": "Cynus F3",
    "Device": "s7511",
    "Model": "Cynus F3"
  },
  {
    "Retail Branding": "Enspert",
    "Marketing Name": "DARKSIDE",
    "Device": "s9301",
    "Model": "Cinema"
  },
  {
    "Retail Branding": "Enspert",
    "Marketing Name": "DARKSIDE",
    "Device": "s9301",
    "Model": "DARKSIDE"
  },
  {
    "Retail Branding": "Enspert",
    "Marketing Name": "Lazer X40E",
    "Device": "X40E",
    "Model": "X40E"
  },
  {
    "Retail Branding": "Enspert",
    "Marketing Name": "MG",
    "Device": "MGA930",
    "Model": "A930"
  },
  {
    "Retail Branding": "Enspert",
    "Marketing Name": "STAIRWAY",
    "Device": "s9111",
    "Model": "STAIRWAY"
  },
  {
    "Retail Branding": "Enspert",
    "Marketing Name": "WIKO CINK PEAX",
    "Device": "s9091",
    "Model": "CINK PEAX"
  },
  {
    "Retail Branding": "Enspert",
    "Marketing Name": "WIKO CINK PEAX",
    "Device": "s9091",
    "Model": "EverClassic"
  },
  {
    "Retail Branding": "Enspert",
    "Marketing Name": "WIKO CINK+",
    "Device": "s7505",
    "Model": "CINKPLUS"
  },
  {
    "Retail Branding": "Enspert",
    "Marketing Name": "WIKO SUBLIM",
    "Device": "s9070",
    "Model": "SUBLIM"
  },
  {
    "Retail Branding": "Enspert",
    "Marketing Name": "Wiko CINK FIVE",
    "Device": "s9201",
    "Model": "CINK FIVE"
  },
  {
    "Retail Branding": "Enspert",
    "Marketing Name": "Wiko CINK FIVE",
    "Device": "s9201",
    "Model": "Cynus T5"
  },
  {
    "Retail Branding": "Enspert",
    "Marketing Name": "orion",
    "Device": "orion",
    "Model": "NGM Orion"
  },
  {
    "Retail Branding": "Enspert",
    "Marketing Name": "vanitysmart",
    "Device": "vanitysmart",
    "Model": "NGM Vanity Smart"
  },
  {
    "Retail Branding": "Entabeni",
    "Marketing Name": "Entabeni_Tablet",
    "Device": "Entabeni_Tablet",
    "Model": "Entabeni_Tablet"
  },
  {
    "Retail Branding": "Entel",
    "Marketing Name": "DECO ENTEL",
    "Device": "DIW585",
    "Model": "DECO ENTEL"
  },
  {
    "Retail Branding": "Entel",
    "Marketing Name": "DECO ENTEL DIW586",
    "Device": "DV8957X-KCE",
    "Model": "DECO ENTEL DIW586"
  },
  {
    "Retail Branding": "Entel",
    "Marketing Name": "DECO ENTEL VSB3930",
    "Device": "m393vsb_entel",
    "Model": "DECO ENTEL VSB3930"
  },
  {
    "Retail Branding": "Entel",
    "Marketing Name": "OWN I62S",
    "Device": "OWN-I62S",
    "Model": "OWN-I62S"
  },
  {
    "Retail Branding": "Entel",
    "Marketing Name": "S3015",
    "Device": "S3015",
    "Model": "S3015"
  },
  {
    "Retail Branding": "Entity",
    "Marketing Name": "ENT11QF12",
    "Device": "ENT11QF12",
    "Model": "ENT11QF12"
  },
  {
    "Retail Branding": "Entity",
    "Marketing Name": "ENT1529I20",
    "Device": "ENT1529I20",
    "Model": "ENT1529I20"
  },
  {
    "Retail Branding": "Entity",
    "Marketing Name": "ENT15QF220",
    "Device": "ENT15QF220",
    "Model": "ENT15QF220"
  },
  {
    "Retail Branding": "Entity",
    "Marketing Name": "ENT71QF12",
    "Device": "ENT71QF12",
    "Model": "ENT71QF12"
  },
  {
    "Retail Branding": "Entity",
    "Marketing Name": "ENT75QF620_EEA",
    "Device": "ENT75QF620",
    "Model": "ENT75QF620"
  },
  {
    "Retail Branding": "Entity",
    "Marketing Name": "ENTG1011",
    "Device": "ENTG1011",
    "Model": "ENTG1011"
  },
  {
    "Retail Branding": "Entity",
    "Marketing Name": "ENTITY_G10",
    "Device": "ENTITY_G102IN1HARDKB",
    "Model": "ENTITY_G102IN1HARDKB"
  },
  {
    "Retail Branding": "Entity",
    "Marketing Name": "EntityG12Pro",
    "Device": "EntityG12Pro",
    "Model": "EntityG12Pro"
  },
  {
    "Retail Branding": "Entity",
    "Marketing Name": "G10XM",
    "Device": "G10XM",
    "Model": "G10XM"
  },
  {
    "Retail Branding": "Entity",
    "Marketing Name": "G10_2IN1_GEN2",
    "Device": "G10_2IN1_GEN2",
    "Model": "G10_2IN1_GEN2"
  },
  {
    "Retail Branding": "Entity",
    "Marketing Name": "HW304_HW291",
    "Device": "HW304_HW291",
    "Model": "HW304_HW291"
  },
  {
    "Retail Branding": "Envizen",
    "Marketing Name": "ClickTabDSh18",
    "Device": "ClickTabDSh18",
    "Model": "ClickTabDSh18"
  },
  {
    "Retail Branding": "Envizen",
    "Marketing Name": "V1018A",
    "Device": "V1018A",
    "Model": "V1018A"
  },
  {
    "Retail Branding": "Envizen",
    "Marketing Name": "VMD9002",
    "Device": "VMD9002",
    "Model": "VMD9002"
  },
  {
    "Retail Branding": "Envizen Digital",
    "Marketing Name": "V100MD",
    "Device": "V100MD",
    "Model": "V100MD"
  },
  {
    "Retail Branding": "Envizen Digital",
    "Marketing Name": "V917G",
    "Device": "GK-MID9022",
    "Model": "V917G"
  },
  {
    "Retail Branding": "Envizen Digital",
    "Marketing Name": "VMD1029",
    "Device": "VMD1029",
    "Model": "VMD1029"
  },
  {
    "Retail Branding": "Epson",
    "Marketing Name": "EF-12/EH-LS300",
    "Device": "sti6200d101",
    "Model": "Projector"
  },
  {
    "Retail Branding": "Epson",
    "Marketing Name": "EF-30",
    "Device": "ooty",
    "Model": "HC43"
  },
  {
    "Retail Branding": "Epson",
    "Marketing Name": "EF-61",
    "Device": "ooty",
    "Model": "HB72"
  },
  {
    "Retail Branding": "Epson",
    "Marketing Name": "EF-62",
    "Device": "kodaikanal",
    "Model": "HB73"
  },
  {
    "Retail Branding": "Epson",
    "Marketing Name": "EF-71",
    "Device": "ooty",
    "Model": "HB79"
  },
  {
    "Retail Branding": "Epson",
    "Marketing Name": "EF-72",
    "Device": "kodaikanal",
    "Model": "HB76"
  },
  {
    "Retail Branding": "Epson",
    "Marketing Name": "EH-LS650",
    "Device": "sti6290d101",
    "Model": "projector"
  },
  {
    "Retail Branding": "Epson",
    "Marketing Name": "EH-LS670",
    "Device": "kasauli",
    "Model": "HB82"
  },
  {
    "Retail Branding": "Epson",
    "Marketing Name": "EH-LS800",
    "Device": "sti6202d101",
    "Model": "HA90"
  },
  {
    "Retail Branding": "Epson",
    "Marketing Name": "EH-LS970",
    "Device": "kasauli",
    "Model": "HB83"
  },
  {
    "Retail Branding": "Epson",
    "Marketing Name": "ELPAP12",
    "Device": "Bushi",
    "Model": "STI6110"
  },
  {
    "Retail Branding": "Epson",
    "Marketing Name": "Epson",
    "Device": "embt4",
    "Model": "EMBT4"
  },
  {
    "Retail Branding": "Epson",
    "Marketing Name": "HB35",
    "Device": "himalaya",
    "Model": "HB35"
  },
  {
    "Retail Branding": "Epson",
    "Marketing Name": "Projector",
    "Device": "sti6200d101",
    "Model": "Projector"
  },
  {
    "Retail Branding": "Epson",
    "Marketing Name": "STI6110",
    "Device": "Bushi",
    "Model": "STI6110"
  },
  {
    "Retail Branding": "Epson",
    "Marketing Name": "embt4",
    "Device": "embt4",
    "Model": "EMBT4"
  },
  {
    "Retail Branding": "Epson",
    "Marketing Name": "embt4cn",
    "Device": "embt4",
    "Model": "EMBT4"
  },
  {
    "Retail Branding": "Epson",
    "Marketing Name": "embt4ru",
    "Device": "embt4",
    "Model": "EMBT4"
  },
  {
    "Retail Branding": "Equator",
    "Marketing Name": "Axis",
    "Device": "Axis",
    "Model": "Axis"
  },
  {
    "Retail Branding": "Ergo",
    "Marketing Name": "Android TV",
    "Device": "longshan",
    "Model": "ERGOGS"
  },
  {
    "Retail Branding": "Ergo",
    "Marketing Name": "B502 Basic",
    "Device": "B502_Basic",
    "Model": "B502 Basic"
  },
  {
    "Retail Branding": "Ergo",
    "Marketing Name": "B504_Unit",
    "Device": "B504_Unit",
    "Model": "B504_Unit"
  },
  {
    "Retail Branding": "Ergo",
    "Marketing Name": "B505_Unit_4G",
    "Device": "B505_Unit_4G",
    "Model": "B505_Unit_4G"
  },
  {
    "Retail Branding": "Ergo",
    "Marketing Name": "ERGO",
    "Device": "B506_Intro",
    "Model": "B506_Intro"
  },
  {
    "Retail Branding": "Ergo",
    "Marketing Name": "ERGO 2K SMART TV",
    "Device": "beomil",
    "Model": "ERGO 2K SMART TV"
  },
  {
    "Retail Branding": "Ergo",
    "Marketing Name": "ERGO 4K SMART TV",
    "Device": "eleonas",
    "Model": "ERGO 4K SMART TV"
  },
  {
    "Retail Branding": "Ergo",
    "Marketing Name": "ERGO 4K SMART TV FF",
    "Device": "eleonas",
    "Model": "ERGO 4K SMART TV FF"
  },
  {
    "Retail Branding": "Ergo",
    "Marketing Name": "ERGO B500",
    "Device": "B500",
    "Model": "ERGO B500 First"
  },
  {
    "Retail Branding": "Ergo",
    "Marketing Name": "ERGO B501",
    "Device": "B501",
    "Model": "B501"
  },
  {
    "Retail Branding": "Ergo",
    "Marketing Name": "ERGO V551 Aura",
    "Device": "V551_Aura",
    "Model": "V551 Aura"
  },
  {
    "Retail Branding": "Ergo",
    "Marketing Name": "ERGO V552 Intense",
    "Device": "ERGO_V552_Intense",
    "Model": "ERGO V552 Intense"
  },
  {
    "Retail Branding": "Ergo",
    "Marketing Name": "ERGO V600 Vega",
    "Device": "ERGO_V600_Vega",
    "Model": "ERGO V600 Vega"
  },
  {
    "Retail Branding": "Ergo",
    "Marketing Name": "ERGO2KSMARTTV",
    "Device": "umeda",
    "Model": "ERGO2KSMARTTV"
  },
  {
    "Retail Branding": "Ergo",
    "Marketing Name": "ERGO4KSMARTTV",
    "Device": "SW6H",
    "Model": "ERGO4KSMARTTV"
  },
  {
    "Retail Branding": "Ergo",
    "Marketing Name": "ERGO4KSMARTTV",
    "Device": "byculla",
    "Model": "ERGO4KSMARTTV"
  },
  {
    "Retail Branding": "Ergo",
    "Marketing Name": "ERGO_A556",
    "Device": "ERGO_A556",
    "Model": "ERGO_A556"
  },
  {
    "Retail Branding": "Ergo",
    "Marketing Name": "ERGO_V552_Intense",
    "Device": "ERGO_V552_Intense",
    "Model": "ERGO V552 Intense"
  },
  {
    "Retail Branding": "Ergo",
    "Marketing Name": "ERGO_V600_Vega",
    "Device": "ERGO_V600_Vega",
    "Model": "ERGO V600 Vega"
  },
  {
    "Retail Branding": "Ergo",
    "Marketing Name": "F501_Magic",
    "Device": "F501_Magic",
    "Model": "F501_Magic"
  },
  {
    "Retail Branding": "Ergo",
    "Marketing Name": "GHS55",
    "Device": "redwood",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "Ergo",
    "Marketing Name": "GHS55",
    "Device": "redwood",
    "Model": "ERGOGS"
  },
  {
    "Retail Branding": "Ergo",
    "Marketing Name": "Smart TV",
    "Device": "longshan",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "Ergo",
    "Marketing Name": "Tablet_PC",
    "Device": "Tablet_PC",
    "Model": "Tablet_PC"
  },
  {
    "Retail Branding": "Ergo",
    "Marketing Name": "V500_Vector",
    "Device": "V500_Vector",
    "Model": "V500_Vector"
  },
  {
    "Retail Branding": "Ergo",
    "Marketing Name": "V540_Level",
    "Device": "V540_Level",
    "Model": "V540_Level"
  },
  {
    "Retail Branding": "Ergo",
    "Marketing Name": "V550_Vision",
    "Device": "V550_Vision",
    "Model": "V550_Vision"
  },
  {
    "Retail Branding": "Ergo",
    "Marketing Name": "V570_BIG_BEN",
    "Device": "V570_BIG_BEN",
    "Model": "V570_BIG_BEN"
  },
  {
    "Retail Branding": "Erito",
    "Marketing Name": "Android TV",
    "Device": "R1",
    "Model": "ATV R1"
  },
  {
    "Retail Branding": "Erito",
    "Marketing Name": "Vietnam",
    "Device": "samseong",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "Essential Products",
    "Marketing Name": "Essential",
    "Device": "Essential",
    "Model": "Essential"
  },
  {
    "Retail Branding": "Essential Products",
    "Marketing Name": "PH-1",
    "Device": "mata",
    "Model": "PH-1"
  },
  {
    "Retail Branding": "EssentielB",
    "Marketing Name": "Android TV",
    "Device": "R1",
    "Model": "ATV R1"
  },
  {
    "Retail Branding": "EssentielB",
    "Marketing Name": "Android TV",
    "Device": "R2",
    "Model": "ATV R2"
  },
  {
    "Retail Branding": "EssentielB",
    "Marketing Name": "Black Diamond",
    "Device": "bird77_a_cu_ics2",
    "Model": "Essentielb-Black Diamond"
  },
  {
    "Retail Branding": "EssentielB",
    "Marketing Name": "Pyxis",
    "Device": "pyxis_boulanger",
    "Model": "Essentielb-Pixis"
  },
  {
    "Retail Branding": "EssentielB",
    "Marketing Name": "R3",
    "Device": "R3",
    "Model": "R3"
  },
  {
    "Retail Branding": "EssentielB",
    "Marketing Name": "R4",
    "Device": "R4",
    "Model": "R4"
  },
  {
    "Retail Branding": "EssentielB",
    "Marketing Name": "ST7001 Tablet",
    "Device": "ST7001",
    "Model": "ST7001"
  },
  {
    "Retail Branding": "EssentielB",
    "Marketing Name": "Smart\\'TAB 7800",
    "Device": "fiber-785q6",
    "Model": "Smart\\'Tab_7800"
  },
  {
    "Retail Branding": "EssentielB",
    "Marketing Name": "Smart\\'TAB 9001",
    "Device": "fiber-smart",
    "Model": "Smart\\'TAB 9001"
  },
  {
    "Retail Branding": "EssentielB",
    "Marketing Name": "SmartTAB1008",
    "Device": "SmartTAB1008",
    "Model": "SmartTAB1008"
  },
  {
    "Retail Branding": "EssentielB",
    "Marketing Name": "SmartTab1007",
    "Device": "SmartTAB1007",
    "Model": "SmartTAB1007"
  },
  {
    "Retail Branding": "Estalky",
    "Marketing Name": "Estalky-E618",
    "Device": "E618",
    "Model": "E618"
  },
  {
    "Retail Branding": "Estar",
    "Marketing Name": "1021W_URBAN",
    "Device": "1021W_URBAN",
    "Model": "MID1021W"
  },
  {
    "Retail Branding": "Estar",
    "Marketing Name": "BEAUTY 2 HD Quad core",
    "Device": "MID7378",
    "Model": "eSTAR BEAUTY 2 HD Quad core"
  },
  {
    "Retail Branding": "Estar",
    "Marketing Name": "Digni-Smart",
    "Device": "Digni-Smart",
    "Model": "Digni-Smart"
  },
  {
    "Retail Branding": "Estar",
    "Marketing Name": "EU、UK、AP",
    "Device": "martin",
    "Model": "eSTAR 2K Android TV"
  },
  {
    "Retail Branding": "Estar",
    "Marketing Name": "Europe",
    "Device": "sepolia",
    "Model": "eSTAR 4K Smart TV"
  },
  {
    "Retail Branding": "Estar",
    "Marketing Name": "GO! HD Quad core 3G",
    "Device": "MID7438G",
    "Model": "eSTAR GO HD Quad core 3G"
  },
  {
    "Retail Branding": "Estar",
    "Marketing Name": "GO! IPS Quad core 3G",
    "Device": "MID7458G",
    "Model": "eSTAR GO! IPS Quad core 3G"
  },
  {
    "Retail Branding": "Estar",
    "Marketing Name": "GRAND HD Quad Core",
    "Device": "MID1198",
    "Model": "eSTAR GRAND HD Quad core"
  },
  {
    "Retail Branding": "Estar",
    "Marketing Name": "Grand IPS Quad core 3G",
    "Device": "MID1258G",
    "Model": "eSTAR Grand IPS Quad core 3G"
  },
  {
    "Retail Branding": "Estar",
    "Marketing Name": "Lithuania",
    "Device": "tamachi",
    "Model": "eSTAR FHD Android TV"
  },
  {
    "Retail Branding": "Estar",
    "Marketing Name": "Lithuania",
    "Device": "yeongdeungpo",
    "Model": "eSTAR UHD Android TV"
  },
  {
    "Retail Branding": "Estar",
    "Marketing Name": "MID1020L",
    "Device": "MID1020L",
    "Model": "MID1020L"
  },
  {
    "Retail Branding": "Estar",
    "Marketing Name": "MID7399",
    "Device": "MID7399",
    "Model": "eSTAR BEAUTY 3 HD Quad core"
  },
  {
    "Retail Branding": "Estar",
    "Marketing Name": "MID7399_BM",
    "Device": "MID7399_BM",
    "Model": "MID7399_BM"
  },
  {
    "Retail Branding": "Estar",
    "Marketing Name": "MID7399_HP",
    "Device": "MID7399_HP",
    "Model": "MID7399_HP"
  },
  {
    "Retail Branding": "Estar",
    "Marketing Name": "MID7399_SD",
    "Device": "MID7399_SD",
    "Model": "MID7399_SD"
  },
  {
    "Retail Branding": "Estar",
    "Marketing Name": "MID7399_WW",
    "Device": "MID7399_WW",
    "Model": "MID7399_WW"
  },
  {
    "Retail Branding": "Estar",
    "Marketing Name": "eSTAR 2K Smart TV",
    "Device": "dongnae",
    "Model": "eSTAR 2K Smart TV"
  },
  {
    "Retail Branding": "Estar",
    "Marketing Name": "eSTAR BEAUTY 2 HD Quad core",
    "Device": "MID7388",
    "Model": "eSTAR BEAUTY 2 HD Quad core"
  },
  {
    "Retail Branding": "Estar",
    "Marketing Name": "eSTAR GRAND HD Quad Core",
    "Device": "MID1298",
    "Model": "eSTAR GRAND HD Quad core"
  },
  {
    "Retail Branding": "Estar",
    "Marketing Name": "eSTAR_PAD_B8",
    "Device": "eSTAR_PAD_B8",
    "Model": "eSTAR_PAD_B8"
  },
  {
    "Retail Branding": "Estelle",
    "Marketing Name": "EST-001-BLA",
    "Device": "EST_001_BLA",
    "Model": "EST_001_BLA"
  },
  {
    "Retail Branding": "Estelle",
    "Marketing Name": "EST-001-BLA",
    "Device": "EST_001_BLK",
    "Model": "EST_001_BLK"
  },
  {
    "Retail Branding": "Estla",
    "Marketing Name": "Android TV",
    "Device": "longshan",
    "Model": "AI PONT NA"
  },
  {
    "Retail Branding": "Estla",
    "Marketing Name": "Smart TV",
    "Device": "alimos",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "Estla",
    "Marketing Name": "Smart TV",
    "Device": "dangni",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "Estla",
    "Marketing Name": "Smart TV",
    "Device": "osaka",
    "Model": "AI PONT NA"
  },
  {
    "Retail Branding": "Estla",
    "Marketing Name": "UHD Android TV",
    "Device": "sindorim",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "Eten",
    "Marketing Name": "ET660",
    "Device": "ETEN",
    "Model": "ET660"
  },
  {
    "Retail Branding": "Ethio Telecom",
    "Marketing Name": "Ethio Telecom B866W11A",
    "Device": "ET_B866W11A",
    "Model": "Ethio Telecom B866W11A"
  },
  {
    "Retail Branding": "Etisalat",
    "Marketing Name": "eLife TV",
    "Device": "KSTB6076",
    "Model": "KSTB6076"
  },
  {
    "Retail Branding": "Etuline",
    "Marketing Name": "ETL-S4521",
    "Device": "u939e_2",
    "Model": "ETL-S4521"
  },
  {
    "Retail Branding": "Etuline",
    "Marketing Name": "ETL-S5042",
    "Device": "u970_4",
    "Model": "ETL-S5042"
  },
  {
    "Retail Branding": "EuroLeague",
    "Marketing Name": "I7a",
    "Device": "Euroleague",
    "Model": "EuroleaguePhone"
  },
  {
    "Retail Branding": "Euskaltel",
    "Marketing Name": "Deco 4K con Android TV",
    "Device": "m392",
    "Model": "Deco 4K con Android TV"
  },
  {
    "Retail Branding": "Euskaltel",
    "Marketing Name": "Deco 4K con Android TV",
    "Device": "m393gena_esk",
    "Model": "Deco 4K con Android TV"
  },
  {
    "Retail Branding": "Euskaltel",
    "Marketing Name": "Deco 4K con Android TV",
    "Device": "uze4052ekt",
    "Model": "Deco 4K con Android TV"
  },
  {
    "Retail Branding": "Euskaltel",
    "Marketing Name": "Euskaltel",
    "Device": "dciw384eus",
    "Model": "Sagemcom_4k ATV"
  },
  {
    "Retail Branding": "Evercoss",
    "Marketing Name": "A75 MAX",
    "Device": "A75_MAX",
    "Model": "A75 MAX"
  },
  {
    "Retail Branding": "Evercoss",
    "Marketing Name": "A75B",
    "Device": "EVERCOSS_A75B",
    "Model": "A75B"
  },
  {
    "Retail Branding": "Evercoss",
    "Marketing Name": "AT8B",
    "Device": "AT8B",
    "Model": "AT8B"
  },
  {
    "Retail Branding": "Evercoss",
    "Marketing Name": "M40A",
    "Device": "EVERCOSS_M40A",
    "Model": "M40A"
  },
  {
    "Retail Branding": "Evercoss",
    "Marketing Name": "M50",
    "Device": "EVERCOSS_M50",
    "Model": "M50"
  },
  {
    "Retail Branding": "Evercoss",
    "Marketing Name": "M50 MAX",
    "Device": "EVERCOSS_M50_MAX",
    "Model": "M50 MAX"
  },
  {
    "Retail Branding": "Evercoss",
    "Marketing Name": "M50 PRO",
    "Device": "M50_PRO",
    "Model": "M50 PRO"
  },
  {
    "Retail Branding": "Evercoss",
    "Marketing Name": "M50 STAR",
    "Device": "EVERCOSS_M50_STAR",
    "Model": "M50 STAR"
  },
  {
    "Retail Branding": "Evercoss",
    "Marketing Name": "M50A",
    "Device": "EVERCOSS_M50A",
    "Model": "M50A"
  },
  {
    "Retail Branding": "Evercoss",
    "Marketing Name": "M50A MAX",
    "Device": "EVERCOSS_M50A_MAX",
    "Model": "M50A MAX"
  },
  {
    "Retail Branding": "Evercoss",
    "Marketing Name": "M53",
    "Device": "M53",
    "Model": "M53"
  },
  {
    "Retail Branding": "Evercoss",
    "Marketing Name": "M55",
    "Device": "M55",
    "Model": "M55"
  },
  {
    "Retail Branding": "Evercoss",
    "Marketing Name": "M55A",
    "Device": "M55A",
    "Model": "M55A"
  },
  {
    "Retail Branding": "Evercoss",
    "Marketing Name": "M55B",
    "Device": "M55B",
    "Model": "M55B"
  },
  {
    "Retail Branding": "Evercoss",
    "Marketing Name": "M55C",
    "Device": "M55C",
    "Model": "M55C"
  },
  {
    "Retail Branding": "Evercoss",
    "Marketing Name": "M6",
    "Device": "M6",
    "Model": "M6"
  },
  {
    "Retail Branding": "Evercoss",
    "Marketing Name": "M60",
    "Device": "M60",
    "Model": "M60"
  },
  {
    "Retail Branding": "Evercoss",
    "Marketing Name": "M6A",
    "Device": "M6A",
    "Model": "M6A"
  },
  {
    "Retail Branding": "Evercoss",
    "Marketing Name": "M70",
    "Device": "M70",
    "Model": "M70"
  },
  {
    "Retail Branding": "Evercoss",
    "Marketing Name": "M80",
    "Device": "EVERCOSS_M80",
    "Model": "M80"
  },
  {
    "Retail Branding": "Evercoss",
    "Marketing Name": "One X",
    "Device": "A65_sprout",
    "Model": "EVERCOSS A65"
  },
  {
    "Retail Branding": "Evercoss",
    "Marketing Name": "R40K",
    "Device": "R40K",
    "Model": "R40K"
  },
  {
    "Retail Branding": "Evercoss",
    "Marketing Name": "R45",
    "Device": "EVERCOSS_R45",
    "Model": "R45"
  },
  {
    "Retail Branding": "Evercoss",
    "Marketing Name": "R5C",
    "Device": "R5C",
    "Model": "R5C"
  },
  {
    "Retail Branding": "Evercoss",
    "Marketing Name": "R6",
    "Device": "R6",
    "Model": "R6"
  },
  {
    "Retail Branding": "Evercoss",
    "Marketing Name": "R70",
    "Device": "R70",
    "Model": "R70"
  },
  {
    "Retail Branding": "Evercoss",
    "Marketing Name": "R70A",
    "Device": "R70A",
    "Model": "R70A"
  },
  {
    "Retail Branding": "Evercoss",
    "Marketing Name": "S45",
    "Device": "EVERCOSS_S45",
    "Model": "S45"
  },
  {
    "Retail Branding": "Evercoss",
    "Marketing Name": "S45B",
    "Device": "S45B",
    "Model": "S45B"
  },
  {
    "Retail Branding": "Evercoss",
    "Marketing Name": "S50",
    "Device": "EVERCOSS_S50",
    "Model": "S50"
  },
  {
    "Retail Branding": "Evercoss",
    "Marketing Name": "S55A",
    "Device": "S55A",
    "Model": "S55A"
  },
  {
    "Retail Branding": "Evercoss",
    "Marketing Name": "S55B",
    "Device": "S55B",
    "Model": "S55B"
  },
  {
    "Retail Branding": "Evercoss",
    "Marketing Name": "S57",
    "Device": "S57",
    "Model": "S57"
  },
  {
    "Retail Branding": "Evercoss",
    "Marketing Name": "S6",
    "Device": "S6",
    "Model": "S6"
  },
  {
    "Retail Branding": "Evercoss",
    "Marketing Name": "U50",
    "Device": "U50",
    "Model": "U50"
  },
  {
    "Retail Branding": "Evercoss",
    "Marketing Name": "U50A",
    "Device": "U50A",
    "Model": "U50A"
  },
  {
    "Retail Branding": "Evercoss",
    "Marketing Name": "U50A MAX",
    "Device": "U50A_MAX",
    "Model": "U50A MAX"
  },
  {
    "Retail Branding": "Evercoss",
    "Marketing Name": "U50A_PLUS",
    "Device": "U50A_PLUS",
    "Model": "U50A_PLUS"
  },
  {
    "Retail Branding": "Evercoss",
    "Marketing Name": "U50B",
    "Device": "U50B",
    "Model": "U50B"
  },
  {
    "Retail Branding": "Evercoss",
    "Marketing Name": "U50C",
    "Device": "U50C",
    "Model": "U50C"
  },
  {
    "Retail Branding": "Evercoss",
    "Marketing Name": "U55",
    "Device": "U55",
    "Model": "U55"
  },
  {
    "Retail Branding": "Evercoss",
    "Marketing Name": "U6",
    "Device": "EVERCOSS_U6",
    "Model": "U6"
  },
  {
    "Retail Branding": "Evercoss",
    "Marketing Name": "U6 PRIME",
    "Device": "EVERCOSS_U6_PRIME",
    "Model": "U6 PRIME"
  },
  {
    "Retail Branding": "Evercoss",
    "Marketing Name": "U60",
    "Device": "EVERCOSS_U60",
    "Model": "U60"
  },
  {
    "Retail Branding": "Evercoss",
    "Marketing Name": "U60A",
    "Device": "EVERCOSS_U60A",
    "Model": "U60A"
  },
  {
    "Retail Branding": "Evercoss",
    "Marketing Name": "U6A",
    "Device": "EVERCOSS_U6A",
    "Model": "U6A"
  },
  {
    "Retail Branding": "Evercoss",
    "Marketing Name": "U6A",
    "Device": "U6A_PLUS",
    "Model": "U6A"
  },
  {
    "Retail Branding": "Evercoss",
    "Marketing Name": "U6B",
    "Device": "U6B",
    "Model": "U6B"
  },
  {
    "Retail Branding": "Evercoss",
    "Marketing Name": "U6C",
    "Device": "U6C",
    "Model": "U6C"
  },
  {
    "Retail Branding": "Evercoss",
    "Marketing Name": "U70",
    "Device": "U70",
    "Model": "U70"
  },
  {
    "Retail Branding": "Evercoss",
    "Marketing Name": "U70A",
    "Device": "EVERCOSS_U70A",
    "Model": "U70A"
  },
  {
    "Retail Branding": "Evercoss",
    "Marketing Name": "U70B",
    "Device": "U70B",
    "Model": "U70B"
  },
  {
    "Retail Branding": "Evercoss",
    "Marketing Name": "U70C",
    "Device": "U70C",
    "Model": "U70C"
  },
  {
    "Retail Branding": "Evercoss",
    "Marketing Name": "X7",
    "Device": "X7",
    "Model": "X7"
  },
  {
    "Retail Branding": "Evercoss",
    "Marketing Name": "X7A",
    "Device": "X7A",
    "Model": "X7A"
  },
  {
    "Retail Branding": "Evercoss",
    "Marketing Name": "X8",
    "Device": "X8",
    "Model": "X8"
  },
  {
    "Retail Branding": "Evercoss",
    "Marketing Name": "X8_3gb",
    "Device": "X8_3gb",
    "Model": "X8"
  },
  {
    "Retail Branding": "Evercoss",
    "Marketing Name": "X9",
    "Device": "X9",
    "Model": "X9"
  },
  {
    "Retail Branding": "Everex",
    "Marketing Name": "Fine 7B",
    "Device": "Fine_7B",
    "Model": "FINE 7B"
  },
  {
    "Retail Branding": "Everex",
    "Marketing Name": "Fine 7B",
    "Device": "Fine_7B",
    "Model": "Fine 7B"
  },
  {
    "Retail Branding": "Everis",
    "Marketing Name": "E0109",
    "Device": "E0109",
    "Model": "E0109"
  },
  {
    "Retail Branding": "Everis",
    "Marketing Name": "E0111",
    "Device": "E0111",
    "Model": "E0111"
  },
  {
    "Retail Branding": "Everis",
    "Marketing Name": "E0112",
    "Device": "E0112",
    "Model": "E0112"
  },
  {
    "Retail Branding": "Everis",
    "Marketing Name": "E0113",
    "Device": "E0113",
    "Model": "E0113"
  },
  {
    "Retail Branding": "Everis",
    "Marketing Name": "E0114",
    "Device": "E0114",
    "Model": "E0114"
  },
  {
    "Retail Branding": "Everis",
    "Marketing Name": "E0115",
    "Device": "E0115",
    "Model": "E0115"
  },
  {
    "Retail Branding": "Everis",
    "Marketing Name": "E0116",
    "Device": "E0116",
    "Model": "E0116"
  },
  {
    "Retail Branding": "Everis",
    "Marketing Name": "E0117",
    "Device": "E0117",
    "Model": "E0117"
  },
  {
    "Retail Branding": "Everis",
    "Marketing Name": "E0118",
    "Device": "E0118",
    "Model": "E0118"
  },
  {
    "Retail Branding": "Everis",
    "Marketing Name": "E0120",
    "Device": "E0120",
    "Model": "E0120"
  },
  {
    "Retail Branding": "Evermyth",
    "Marketing Name": "KB1008_EEA",
    "Device": "KB1008",
    "Model": "KB1008"
  },
  {
    "Retail Branding": "Evermyth",
    "Marketing Name": "KB1009",
    "Device": "KB1009",
    "Model": "KB1009"
  },
  {
    "Retail Branding": "Evermyth",
    "Marketing Name": "KB1009_EEA",
    "Device": "KB1009",
    "Model": "KB1009"
  },
  {
    "Retail Branding": "Everpad",
    "Marketing Name": "EW2010",
    "Device": "EW2010",
    "Model": "EW2010"
  },
  {
    "Retail Branding": "Everpad",
    "Marketing Name": "EW2020",
    "Device": "EW2020",
    "Model": "EW2020"
  },
  {
    "Retail Branding": "Everpad",
    "Marketing Name": "EW2021",
    "Device": "EVERPAD-EW2021",
    "Model": "EW2021"
  },
  {
    "Retail Branding": "Everpad",
    "Marketing Name": "EW2022",
    "Device": "EW2022",
    "Model": "EW2022"
  },
  {
    "Retail Branding": "Everpad",
    "Marketing Name": "HappyKids",
    "Device": "HappyKids",
    "Model": "HappyKids"
  },
  {
    "Retail Branding": "Everpad",
    "Marketing Name": "SC730",
    "Device": "EVERPAD-SC730",
    "Model": "SC730"
  },
  {
    "Retail Branding": "Everpad",
    "Marketing Name": "VORTEX_V10",
    "Device": "VORTEX_V10",
    "Model": "VORTEX_V10"
  },
  {
    "Retail Branding": "Evertek",
    "Marketing Name": "E7224HG",
    "Device": "E7224HG",
    "Model": "E7224HG"
  },
  {
    "Retail Branding": "Evertek",
    "Marketing Name": "E8224HG",
    "Device": "E8224HG",
    "Model": "E8224HG"
  },
  {
    "Retail Branding": "Evertek",
    "Marketing Name": "Hero",
    "Device": "Hero",
    "Model": "Hero"
  },
  {
    "Retail Branding": "Evertek",
    "Marketing Name": "M10",
    "Device": "M10",
    "Model": "M10"
  },
  {
    "Retail Branding": "Evertek",
    "Marketing Name": "M10 Nano",
    "Device": "M10_Nano",
    "Model": "M10 Nano"
  },
  {
    "Retail Branding": "Evertek",
    "Marketing Name": "M10_Max",
    "Device": "EVERTEK_M10_Max",
    "Model": "M10+Max"
  },
  {
    "Retail Branding": "Evertek",
    "Marketing Name": "M10_Pro",
    "Device": "Evertek_M10_Pro",
    "Model": "M10_Pro"
  },
  {
    "Retail Branding": "Evertek",
    "Marketing Name": "M20",
    "Device": "M20",
    "Model": "M20"
  },
  {
    "Retail Branding": "Evertek",
    "Marketing Name": "M20 Mini",
    "Device": "M20_Mini",
    "Model": "M20 Mini"
  },
  {
    "Retail Branding": "Evertek",
    "Marketing Name": "M20 NANO",
    "Device": "M20_NANO",
    "Model": "M20 NANO"
  },
  {
    "Retail Branding": "Evertek",
    "Marketing Name": "M20+Pro",
    "Device": "M20_Pro",
    "Model": "M20+Pro"
  },
  {
    "Retail Branding": "Evertek",
    "Marketing Name": "M20S_Mini",
    "Device": "EVERTEK_M20S_Mini",
    "Model": "M20S Mini"
  },
  {
    "Retail Branding": "Evertek",
    "Marketing Name": "M20_Pro",
    "Device": "M20_Pro",
    "Model": "M20_Pro"
  },
  {
    "Retail Branding": "Evertek",
    "Marketing Name": "M20_S",
    "Device": "M20_S",
    "Model": "M20 S"
  },
  {
    "Retail Branding": "Evertek",
    "Marketing Name": "M20_Ultra",
    "Device": "M20_Ultra",
    "Model": "M20_Ultra"
  },
  {
    "Retail Branding": "Evertek",
    "Marketing Name": "P17",
    "Device": "P17",
    "Model": "P17"
  },
  {
    "Retail Branding": "Evertek",
    "Marketing Name": "P17_Pro",
    "Device": "P17_Pro",
    "Model": "P17_Pro"
  },
  {
    "Retail Branding": "Evertek",
    "Marketing Name": "P18_Pro",
    "Device": "P18_Pro",
    "Model": "P18_Pro"
  },
  {
    "Retail Branding": "Evertek",
    "Marketing Name": "V4",
    "Device": "V4",
    "Model": "EVERTEK V4"
  },
  {
    "Retail Branding": "Evertek",
    "Marketing Name": "V4 Nano",
    "Device": "V4_Nano",
    "Model": "V4 Nano"
  },
  {
    "Retail Branding": "Evertek",
    "Marketing Name": "V4+",
    "Device": "V4_Plus",
    "Model": "V4+"
  },
  {
    "Retail Branding": "Evertek",
    "Marketing Name": "V5",
    "Device": "V5",
    "Model": "V5"
  },
  {
    "Retail Branding": "Evertek",
    "Marketing Name": "V5 Nano",
    "Device": "V5_Nano",
    "Model": "V5_Nano"
  },
  {
    "Retail Branding": "Evertek",
    "Marketing Name": "V5+",
    "Device": "V5_Plus",
    "Model": "V5+"
  },
  {
    "Retail Branding": "Evertek",
    "Marketing Name": "V6",
    "Device": "V6",
    "Model": "V6"
  },
  {
    "Retail Branding": "Evertek",
    "Marketing Name": "V8",
    "Device": "V8",
    "Model": "V8"
  },
  {
    "Retail Branding": "Evertek",
    "Marketing Name": "V9+",
    "Device": "V9_Plus",
    "Model": "V9+"
  },
  {
    "Retail Branding": "Every",
    "Marketing Name": "E701",
    "Device": "E701",
    "Model": "E701"
  },
  {
    "Retail Branding": "Eviant",
    "Marketing Name": "EVC10Q",
    "Device": "EVIANT_EVT10Q",
    "Model": "EVIANT_EVT10Q"
  },
  {
    "Retail Branding": "Eviant",
    "Marketing Name": "EVC8Q",
    "Device": "EVIANT_EVC8Q",
    "Model": "EVC8Q"
  },
  {
    "Retail Branding": "Evoca",
    "Marketing Name": "EvocaTV",
    "Device": "f511",
    "Model": "Pilot"
  },
  {
    "Retail Branding": "Evolio",
    "Marketing Name": "M5Pro",
    "Device": "Evolio_M5Pro",
    "Model": "Evolio_M5Pro"
  },
  {
    "Retail Branding": "Evolio",
    "Marketing Name": "M6",
    "Device": "Evolio_M6",
    "Model": "Evolio_M6"
  },
  {
    "Retail Branding": "Evolio",
    "Marketing Name": "M8",
    "Device": "Evolio_M8",
    "Model": "Evolio_M8"
  },
  {
    "Retail Branding": "Evolute",
    "Marketing Name": "eM61",
    "Device": "eM61",
    "Model": "eM61"
  },
  {
    "Retail Branding": "Evolveo",
    "Marketing Name": "EVOLVEO StrongPhone G2",
    "Device": "EVOLVEOG2",
    "Model": "EVOLVEO StrongPhone G2"
  },
  {
    "Retail Branding": "Evolveo",
    "Marketing Name": "EVOLVEO StrongPhone G4",
    "Device": "EVOLVEOG4",
    "Model": "EVOLVEO StrongPhone G4"
  },
  {
    "Retail Branding": "Evolveo",
    "Marketing Name": "EVOLVEO StrongPhone G6",
    "Device": "EVOLVEO_StrongPhone_G6",
    "Model": "EVOLVEO StrongPhone G6"
  },
  {
    "Retail Branding": "Evolveo",
    "Marketing Name": "EVOLVEO StrongPhone G7",
    "Device": "StrongPhone_G7",
    "Model": "EVOLVEO StrongPhone G7"
  },
  {
    "Retail Branding": "Evolveo",
    "Marketing Name": "EVOLVEO StrongPhone G8",
    "Device": "EVOLVEOG8",
    "Model": "EVOLVEO StrongPhone G8"
  },
  {
    "Retail Branding": "Evolveo",
    "Marketing Name": "EVOLVEO StrongPhone G9",
    "Device": "StrongPhone_G9",
    "Model": "EVOLVEO StrongPhone G9"
  },
  {
    "Retail Branding": "Evolveo",
    "Marketing Name": "GM6 DS",
    "Device": "StrongPhoneG5",
    "Model": "EVOLVEO StrongPhone G5"
  },
  {
    "Retail Branding": "Evolveo",
    "Marketing Name": "StrongPhone Q9",
    "Device": "StrongPhoneQ9",
    "Model": "StrongPhoneQ9"
  },
  {
    "Retail Branding": "Evoo",
    "Marketing Name": "EV-A-101-1",
    "Device": "EV-A-101-1",
    "Model": "EV-A-101-1"
  },
  {
    "Retail Branding": "Evoo",
    "Marketing Name": "EV-A-101-3",
    "Device": "EV-A-101-3",
    "Model": "EV-A-101-3"
  },
  {
    "Retail Branding": "Evoo",
    "Marketing Name": "EV-A-116-1",
    "Device": "EV-A-116-1",
    "Model": "EV-A-116-1"
  },
  {
    "Retail Branding": "Evoo",
    "Marketing Name": "EV-A-133-1",
    "Device": "EV-A-133-1",
    "Model": "EV-A-133-1"
  },
  {
    "Retail Branding": "Evoo",
    "Marketing Name": "EV-A-156-1",
    "Device": "EV-A-156-1",
    "Model": "EV-A-156-1"
  },
  {
    "Retail Branding": "Evoo",
    "Marketing Name": "EV-A-81-7-1",
    "Device": "EV-A-81-7-1",
    "Model": "EV-A-81-7-1"
  },
  {
    "Retail Branding": "Evoo",
    "Marketing Name": "EV-A-81-8-1",
    "Device": "EV-A-81-8-1",
    "Model": "EV-A-81-8-1"
  },
  {
    "Retail Branding": "Evoo",
    "Marketing Name": "EV-A-81-8-2",
    "Device": "EV-A-81-8-2",
    "Model": "EV-A-81-8-2"
  },
  {
    "Retail Branding": "Evoo",
    "Marketing Name": "EVM4G3",
    "Device": "EVM4G3",
    "Model": "EVM4G3"
  },
  {
    "Retail Branding": "Evoo",
    "Marketing Name": "EVM4G6",
    "Device": "EVM4G6",
    "Model": "EVM4G6"
  },
  {
    "Retail Branding": "Evoo",
    "Marketing Name": "EVMFV2",
    "Device": "EVMFV2",
    "Model": "EVMFV2"
  },
  {
    "Retail Branding": "Evvoli",
    "Marketing Name": "Android TV",
    "Device": "R1",
    "Model": "ATV R1"
  },
  {
    "Retail Branding": "Evvoli",
    "Marketing Name": "Android TV",
    "Device": "R2",
    "Model": "ATV R2"
  },
  {
    "Retail Branding": "Evvoli",
    "Marketing Name": "R3",
    "Device": "R3",
    "Model": "R3"
  },
  {
    "Retail Branding": "Evvoli",
    "Marketing Name": "R4",
    "Device": "R4",
    "Model": "R4"
  },
  {
    "Retail Branding": "Evvoli",
    "Marketing Name": "Smart TV",
    "Device": "alimos",
    "Model": "evvoli Google TV"
  },
  {
    "Retail Branding": "Evvoli",
    "Marketing Name": "Smart TV",
    "Device": "osaka",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "Evvoli",
    "Marketing Name": "vileparle",
    "Device": "vileparle",
    "Model": "R6G"
  },
  {
    "Retail Branding": "Excelvan",
    "Marketing Name": "SMY-M07R7",
    "Device": "SMY_M07R7",
    "Model": "M07R7_EEA"
  },
  {
    "Retail Branding": "Excelvan",
    "Marketing Name": "SMY_M07R7",
    "Device": "SMY_M07R7",
    "Model": "M07R7"
  },
  {
    "Retail Branding": "Exclusiv",
    "Marketing Name": "Columbia",
    "Device": "marina",
    "Model": "Apollo Premium4K TV"
  },
  {
    "Retail Branding": "Excotek",
    "Marketing Name": "X20-T616",
    "Device": "X20-T616",
    "Model": "X20"
  },
  {
    "Retail Branding": "Exertis",
    "Marketing Name": "7GW_eea",
    "Device": "7GW",
    "Model": "7GW"
  },
  {
    "Retail Branding": "Exertis",
    "Marketing Name": "SMB-H8009",
    "Device": "SMB-H8009",
    "Model": "SMB-H8009"
  },
  {
    "Retail Branding": "Explay",
    "Marketing Name": "4Game",
    "Device": "4Game",
    "Model": "4Game"
  },
  {
    "Retail Branding": "Explay",
    "Marketing Name": "ATV",
    "Device": "ATV",
    "Model": "ATV"
  },
  {
    "Retail Branding": "Explay",
    "Marketing Name": "Air",
    "Device": "Air",
    "Model": "Air"
  },
  {
    "Retail Branding": "Explay",
    "Marketing Name": "Atom",
    "Device": "Atom",
    "Model": "Atom"
  },
  {
    "Retail Branding": "Explay",
    "Marketing Name": "Bit",
    "Device": "Bit",
    "Model": "Bit"
  },
  {
    "Retail Branding": "Explay",
    "Marketing Name": "Brilliant",
    "Device": "Cosmic",
    "Model": "Brilliant"
  },
  {
    "Retail Branding": "Explay",
    "Marketing Name": "Cosmic",
    "Device": "Cosmic",
    "Model": "Cosmic"
  },
  {
    "Retail Branding": "Explay",
    "Marketing Name": "Craft",
    "Device": "Craft",
    "Model": "Craft"
  },
  {
    "Retail Branding": "Explay",
    "Marketing Name": "Discovery",
    "Device": "Prime",
    "Model": "Discovery"
  },
  {
    "Retail Branding": "Explay",
    "Marketing Name": "Easy",
    "Device": "Easy",
    "Model": "Easy"
  },
  {
    "Retail Branding": "Explay",
    "Marketing Name": "Favorite",
    "Device": "Favorite",
    "Model": "Favorite"
  },
  {
    "Retail Branding": "Explay",
    "Marketing Name": "Fog",
    "Device": "Fog",
    "Model": "Fog"
  },
  {
    "Retail Branding": "Explay",
    "Marketing Name": "Fresh",
    "Device": "Fresh",
    "Model": "Fresh"
  },
  {
    "Retail Branding": "Explay",
    "Marketing Name": "Fresh",
    "Device": "Fresh_NF",
    "Model": "Fresh_NF"
  },
  {
    "Retail Branding": "Explay",
    "Marketing Name": "Gravity",
    "Device": "T4728",
    "Model": "Gravity"
  },
  {
    "Retail Branding": "Explay",
    "Marketing Name": "Hit",
    "Device": "Hit",
    "Model": "Hit"
  },
  {
    "Retail Branding": "Explay",
    "Marketing Name": "Imperium 7",
    "Device": "T4729",
    "Model": "Imperium7"
  },
  {
    "Retail Branding": "Explay",
    "Marketing Name": "Imperium 8",
    "Device": "T4730",
    "Model": "Imperium8"
  },
  {
    "Retail Branding": "Explay",
    "Marketing Name": "Indigo",
    "Device": "Indigo",
    "Model": "Indigo"
  },
  {
    "Retail Branding": "Explay",
    "Marketing Name": "Joy TV",
    "Device": "Joy_TV",
    "Model": "Joy_TV"
  },
  {
    "Retail Branding": "Explay",
    "Marketing Name": "Leader",
    "Device": "Leader",
    "Model": "Leader"
  },
  {
    "Retail Branding": "Explay",
    "Marketing Name": "Light",
    "Device": "Light",
    "Model": "Light"
  },
  {
    "Retail Branding": "Explay",
    "Marketing Name": "Light 3G",
    "Device": "Prime",
    "Model": "Light"
  },
  {
    "Retail Branding": "Explay",
    "Marketing Name": "M1 Plus",
    "Device": "Fog",
    "Model": "M1_Plus"
  },
  {
    "Retail Branding": "Explay",
    "Marketing Name": "Onliner 4",
    "Device": "G4187",
    "Model": "Onliner4"
  },
  {
    "Retail Branding": "Explay",
    "Marketing Name": "Onyx",
    "Device": "Onyx",
    "Model": "Onyx"
  },
  {
    "Retail Branding": "Explay",
    "Marketing Name": "Party",
    "Device": "Party",
    "Model": "Party"
  },
  {
    "Retail Branding": "Explay",
    "Marketing Name": "Phantom",
    "Device": "Phantom",
    "Model": "Phantom"
  },
  {
    "Retail Branding": "Explay",
    "Marketing Name": "Planet",
    "Device": "G4187",
    "Model": "Planet"
  },
  {
    "Retail Branding": "Explay",
    "Marketing Name": "Prime",
    "Device": "Prime",
    "Model": "Prime"
  },
  {
    "Retail Branding": "Explay",
    "Marketing Name": "Pulsar",
    "Device": "Pulsar",
    "Model": "Pulsar"
  },
  {
    "Retail Branding": "Explay",
    "Marketing Name": "Rio Play",
    "Device": "RioPlay",
    "Model": "RioPlay"
  },
  {
    "Retail Branding": "Explay",
    "Marketing Name": "Shine",
    "Device": "T5246",
    "Model": "Shine"
  },
  {
    "Retail Branding": "Explay",
    "Marketing Name": "Style",
    "Device": "T5246",
    "Model": "Style"
  },
  {
    "Retail Branding": "Explay",
    "Marketing Name": "Surfer777 3G",
    "Device": "Leader",
    "Model": "Surfer7773G"
  },
  {
    "Retail Branding": "Explay",
    "Marketing Name": "Tab Mini",
    "Device": "TabMini",
    "Model": "TabMini"
  },
  {
    "Retail Branding": "Explay",
    "Marketing Name": "Tornado",
    "Device": "Tornado",
    "Model": "Tornado"
  },
  {
    "Retail Branding": "Explay",
    "Marketing Name": "Tornado 3G",
    "Device": "Tornado3G",
    "Model": "Tornado3G"
  },
  {
    "Retail Branding": "Explay",
    "Marketing Name": "Vega",
    "Device": "Vega",
    "Model": "Vega"
  },
  {
    "Retail Branding": "Explay",
    "Marketing Name": "Winner",
    "Device": "T4728",
    "Model": "Winner"
  },
  {
    "Retail Branding": "Explay",
    "Marketing Name": "Winner 7",
    "Device": "T4729",
    "Model": "Winner7"
  },
  {
    "Retail Branding": "Explay",
    "Marketing Name": "Winner 8",
    "Device": "T4730",
    "Model": "Winner8"
  },
  {
    "Retail Branding": "Express Gifts Limited",
    "Marketing Name": "EGL11QF6",
    "Device": "EGL11QF6",
    "Model": "EGL11QF6"
  },
  {
    "Retail Branding": "Express Gifts Limited",
    "Marketing Name": "EGL1529I",
    "Device": "EGL1529I",
    "Model": "EGL1529I"
  },
  {
    "Retail Branding": "Express Gifts Limited",
    "Marketing Name": "EGL15QF6",
    "Device": "EGL15QF6",
    "Model": "EGL15QF6"
  },
  {
    "Retail Branding": "Express Gifts Limited",
    "Marketing Name": "EGLM103",
    "Device": "EGLM103",
    "Model": "EGLM103"
  },
  {
    "Retail Branding": "Express Gifts Limited",
    "Marketing Name": "EGLMW1528I",
    "Device": "EGLMW1528I",
    "Model": "EGLMW1528I"
  },
  {
    "Retail Branding": "Express Gifts Limited",
    "Marketing Name": "R726",
    "Device": "R726",
    "Model": "R726"
  },
  {
    "Retail Branding": "Extrem",
    "Marketing Name": "Infinity",
    "Device": "Infinity",
    "Model": "Infinity"
  },
  {
    "Retail Branding": "Extrem",
    "Marketing Name": "Rock_X11",
    "Device": "ROCK_X11",
    "Model": "ROCK_X11"
  },
  {
    "Retail Branding": "EyePay",
    "Marketing Name": "IG-EP100",
    "Device": "IG-EP100",
    "Model": "IG-EP100"
  },
  {
    "Retail Branding": "EyeTech",
    "Marketing Name": "EyeOnGo10",
    "Device": "EyeOnGo",
    "Model": "EyeOnGo"
  },
  {
    "Retail Branding": "F&U (Fandu)",
    "Marketing Name": "EU、UK、AP",
    "Device": "martin",
    "Model": "FandU Android TV"
  },
  {
    "Retail Branding": "F&U (Fandu)",
    "Marketing Name": "Europe",
    "Device": "sepolia",
    "Model": "FU Smart TV"
  },
  {
    "Retail Branding": "F&U (Fandu)",
    "Marketing Name": "FU 2K SMART TV",
    "Device": "nagata",
    "Model": "FU 2K SMART TV"
  },
  {
    "Retail Branding": "F&U (Fandu)",
    "Marketing Name": "FU Smart TV",
    "Device": "dongnae",
    "Model": "FU Smart TV"
  },
  {
    "Retail Branding": "F&U (Fandu)",
    "Marketing Name": "Greece",
    "Device": "marina",
    "Model": "FU 4K SMART TV"
  },
  {
    "Retail Branding": "F&U (Fandu)",
    "Marketing Name": "Greece",
    "Device": "tamachi",
    "Model": "F and U Android TV"
  },
  {
    "Retail Branding": "F&U (Fandu)",
    "Marketing Name": "Greece",
    "Device": "yeongdeungpo",
    "Model": "F and U Android TV"
  },
  {
    "Retail Branding": "F-Plus",
    "Marketing Name": "R570E",
    "Device": "R570E",
    "Model": "R570E"
  },
  {
    "Retail Branding": "F-Plus",
    "Marketing Name": "RT800",
    "Device": "RT800",
    "Model": "RT800"
  },
  {
    "Retail Branding": "F-Plus",
    "Marketing Name": "SA50_21620",
    "Device": "SA50_21620",
    "Model": "SA50_21620"
  },
  {
    "Retail Branding": "F-Plus",
    "Marketing Name": "SA55_21624",
    "Device": "SA55_21624",
    "Model": "SA55 2GB/16GB 2400mAh GMS"
  },
  {
    "Retail Branding": "F-Plus",
    "Marketing Name": "SH60_23230",
    "Device": "SH60_23230",
    "Model": "SH60_23230"
  },
  {
    "Retail Branding": "F-Plus",
    "Marketing Name": "SH65_23248",
    "Device": "SH65_23248",
    "Model": "SH65 2GB/32GB 4800mAh GMS"
  },
  {
    "Retail Branding": "F-Plus",
    "Marketing Name": "SH65_23248",
    "Device": "SH65_23248",
    "Model": "SH65_23248"
  },
  {
    "Retail Branding": "F-Plus",
    "Marketing Name": "T1100",
    "Device": "T1100",
    "Model": "T1100"
  },
  {
    "Retail Branding": "F150",
    "Marketing Name": "Air1",
    "Device": "Air1",
    "Model": "Air1"
  },
  {
    "Retail Branding": "F150",
    "Marketing Name": "Air1 Pro",
    "Device": "Air1_Pro",
    "Model": "Air1 Pro"
  },
  {
    "Retail Branding": "F150",
    "Marketing Name": "B1",
    "Device": "B1",
    "Model": "B1"
  },
  {
    "Retail Branding": "F150",
    "Marketing Name": "B1 Pro",
    "Device": "B1_Pro",
    "Model": "B1 Pro"
  },
  {
    "Retail Branding": "F150",
    "Marketing Name": "B2021",
    "Device": "B2021",
    "Model": "B2021"
  },
  {
    "Retail Branding": "F150",
    "Marketing Name": "B2021",
    "Device": "H2022",
    "Model": "H2022"
  },
  {
    "Retail Branding": "F150",
    "Marketing Name": "B2021_EEA",
    "Device": "B2021",
    "Model": "B2021"
  },
  {
    "Retail Branding": "F150",
    "Marketing Name": "Bison2021_EEA",
    "Device": "Bison2021",
    "Model": "Bison2021"
  },
  {
    "Retail Branding": "F150",
    "Marketing Name": "H2022_EEA",
    "Device": "H2022",
    "Model": "H2022"
  },
  {
    "Retail Branding": "F150",
    "Marketing Name": "R2022",
    "Device": "R2022",
    "Model": "R2022"
  },
  {
    "Retail Branding": "F150",
    "Marketing Name": "R2022_EEA",
    "Device": "R2022",
    "Model": "R2022"
  },
  {
    "Retail Branding": "F2 Mobile",
    "Marketing Name": "C8Finger",
    "Device": "C8Finger",
    "Model": "C8Finger"
  },
  {
    "Retail Branding": "F2 Mobile",
    "Marketing Name": "F2 F80s_plus",
    "Device": "F80s_plus",
    "Model": "F80s_plus"
  },
  {
    "Retail Branding": "F2 Mobile",
    "Marketing Name": "F2_LT5216",
    "Device": "LT5216",
    "Model": "LT5216"
  },
  {
    "Retail Branding": "F2 Mobile",
    "Marketing Name": "I8_PRO",
    "Device": "I8_PRO",
    "Model": "I8_PRO"
  },
  {
    "Retail Branding": "F2 Mobile",
    "Marketing Name": "LT16",
    "Device": "LT16",
    "Model": "LT16"
  },
  {
    "Retail Branding": "F2 Mobile",
    "Marketing Name": "LT18",
    "Device": "LT18",
    "Model": "LT18"
  },
  {
    "Retail Branding": "F2 Mobile",
    "Marketing Name": "Z8PLUS",
    "Device": "Z8PLUS",
    "Model": "Z8PLUS"
  },
  {
    "Retail Branding": "F2 Mobile",
    "Marketing Name": "Z8POCKET",
    "Device": "Z8POCKET",
    "Model": "Z8POCKET"
  },
  {
    "Retail Branding": "F2 Mobile",
    "Marketing Name": "i8_ROKR",
    "Device": "i8_ROKR",
    "Model": "i8_ROKR"
  },
  {
    "Retail Branding": "FACETEL",
    "Marketing Name": "A12",
    "Device": "A12",
    "Model": "A12"
  },
  {
    "Retail Branding": "FACETEL",
    "Marketing Name": "Q10-EEA",
    "Device": "Q10-EEA",
    "Model": "Q10-EEA"
  },
  {
    "Retail Branding": "FACETEL",
    "Marketing Name": "Q10-Pro",
    "Device": "Q10-Pro",
    "Model": "Q10-Pro"
  },
  {
    "Retail Branding": "FACETEL",
    "Marketing Name": "Q10-US",
    "Device": "Q10-US",
    "Model": "Q10-US"
  },
  {
    "Retail Branding": "FACETEL",
    "Marketing Name": "Q10_EEA",
    "Device": "Q10_EEA",
    "Model": "Q10_EEA"
  },
  {
    "Retail Branding": "FACETEL",
    "Marketing Name": "Q10_T_EEA",
    "Device": "Q10_T_EEA",
    "Model": "Q10_T_EEA"
  },
  {
    "Retail Branding": "FACETEL",
    "Marketing Name": "Q10_T_US",
    "Device": "Q10_T_US",
    "Model": "Q10_T_US"
  },
  {
    "Retail Branding": "FACETEL",
    "Marketing Name": "Q3-EEA",
    "Device": "Q3-EEA",
    "Model": "Q3-EEA"
  },
  {
    "Retail Branding": "FACETEL",
    "Marketing Name": "Q3-pro",
    "Device": "Q3_pro",
    "Model": "Q3_pro"
  },
  {
    "Retail Branding": "FACETEL",
    "Marketing Name": "Q3_EEA",
    "Device": "Q3_EEA",
    "Model": "Q3_EEA"
  },
  {
    "Retail Branding": "FACETEL",
    "Marketing Name": "Q3pro",
    "Device": "Q3pro",
    "Model": "Q3pro"
  },
  {
    "Retail Branding": "FACETEL",
    "Marketing Name": "Q3pro_eea",
    "Device": "Q3pro_eea",
    "Model": "Q3pro_eea"
  },
  {
    "Retail Branding": "FACETEL",
    "Marketing Name": "Q5_EEA",
    "Device": "Q5_EEA",
    "Model": "3W_EEA"
  },
  {
    "Retail Branding": "FACETEL",
    "Marketing Name": "Q5_US",
    "Device": "Q5_US",
    "Model": "3W_US"
  },
  {
    "Retail Branding": "FACETEL",
    "Marketing Name": "Q6_US",
    "Device": "Q6_US",
    "Model": "Q6_US"
  },
  {
    "Retail Branding": "FACETEL",
    "Marketing Name": "Q7_EEA",
    "Device": "Q7_EEA",
    "Model": "Q7_EEA"
  },
  {
    "Retail Branding": "FACETEL",
    "Marketing Name": "Q7_US",
    "Device": "Q7_US",
    "Model": "Q7_US"
  },
  {
    "Retail Branding": "FACETEL",
    "Marketing Name": "W3_T_EEA",
    "Device": "W3_T_EEA",
    "Model": "3W_EEA"
  },
  {
    "Retail Branding": "FACETEL",
    "Marketing Name": "W3_T_US",
    "Device": "W3_T_US",
    "Model": "3W_US"
  },
  {
    "Retail Branding": "FACILOTAB",
    "Marketing Name": "Facilotab_L_Rubis",
    "Device": "Facilotab_L_Rubis",
    "Model": "Facilotab L Rubis"
  },
  {
    "Retail Branding": "FALCON",
    "Marketing Name": "AT16RT4F_FALCON",
    "Device": "AT16RT4F_FALCON",
    "Model": "AT16RT4F"
  },
  {
    "Retail Branding": "FAMIX",
    "Marketing Name": "F10L",
    "Device": "F10L",
    "Model": "F10L"
  },
  {
    "Retail Branding": "FAMIX",
    "Marketing Name": "F11",
    "Device": "F11",
    "Model": "F11"
  },
  {
    "Retail Branding": "FANCYAUG",
    "Marketing Name": "XT50",
    "Device": "XT50",
    "Model": "XT50"
  },
  {
    "Retail Branding": "FANGOR",
    "Marketing Name": "F-863",
    "Device": "F-863",
    "Model": "F-863"
  },
  {
    "Retail Branding": "FANGOR",
    "Marketing Name": "F-C10",
    "Device": "F-C10",
    "Model": "F-C10"
  },
  {
    "Retail Branding": "FANGOR",
    "Marketing Name": "F-X10",
    "Device": "F-X10",
    "Model": "F-X10"
  },
  {
    "Retail Branding": "FANGOR",
    "Marketing Name": "UJ_1098",
    "Device": "UJ_1098",
    "Model": "UJ_1098"
  },
  {
    "Retail Branding": "FASTWD",
    "Marketing Name": "L231",
    "Device": "L231",
    "Model": "L231"
  },
  {
    "Retail Branding": "FASTWD",
    "Marketing Name": "L231-EEA",
    "Device": "L231-EEA",
    "Model": "L231-EEA"
  },
  {
    "Retail Branding": "FASTWD",
    "Marketing Name": "L251",
    "Device": "L251",
    "Model": "L251"
  },
  {
    "Retail Branding": "FASTWD",
    "Marketing Name": "L251-EEA",
    "Device": "L251-EEA",
    "Model": "L251-EEA"
  },
  {
    "Retail Branding": "FASTWD",
    "Marketing Name": "M193-EEA",
    "Device": "M193-EEA",
    "Model": "M193-EEA"
  },
  {
    "Retail Branding": "FASTWD",
    "Marketing Name": "M20L",
    "Device": "M20L",
    "Model": "M20L"
  },
  {
    "Retail Branding": "FASTWD",
    "Marketing Name": "M518-EEA",
    "Device": "M518-EEA",
    "Model": "M518-EEA"
  },
  {
    "Retail Branding": "FASTWD",
    "Marketing Name": "M986-EEA",
    "Device": "M986-EEA",
    "Model": "M986-EEA"
  },
  {
    "Retail Branding": "FASTWD",
    "Marketing Name": "Tablet",
    "Device": "M109-EEA",
    "Model": "M109-EEA"
  },
  {
    "Retail Branding": "FATARUS",
    "Marketing Name": "K10",
    "Device": "K10",
    "Model": "K10"
  },
  {
    "Retail Branding": "FAVORITT",
    "Marketing Name": "R3",
    "Device": "R3",
    "Model": "R3"
  },
  {
    "Retail Branding": "FAVORITT",
    "Marketing Name": "R4",
    "Device": "R4",
    "Model": "R4"
  },
  {
    "Retail Branding": "FBC",
    "Marketing Name": "M24IS810",
    "Device": "MX24",
    "Model": "TDA02"
  },
  {
    "Retail Branding": "FBC",
    "Marketing Name": "M24IS820",
    "Device": "fst01ms",
    "Model": "M24IS820"
  },
  {
    "Retail Branding": "FCC Movil",
    "Marketing Name": "GK738_3G",
    "Device": "GK738_3G",
    "Model": "GK738_3G"
  },
  {
    "Retail Branding": "FCC Movil",
    "Marketing Name": "GK788",
    "Device": "GK788",
    "Model": "GK788"
  },
  {
    "Retail Branding": "FCC Movil",
    "Marketing Name": "GK879",
    "Device": "GK879",
    "Model": "GK879"
  },
  {
    "Retail Branding": "FCNT",
    "Marketing Name": "A401FC",
    "Device": "A401FC",
    "Model": "A401FC"
  },
  {
    "Retail Branding": "FCNT",
    "Marketing Name": "AW02",
    "Device": "AW02",
    "Model": "AW02"
  },
  {
    "Retail Branding": "FCNT",
    "Marketing Name": "F-52B",
    "Device": "F52B",
    "Model": "F-52B"
  },
  {
    "Retail Branding": "FCNT",
    "Marketing Name": "F-53E",
    "Device": "F53E",
    "Model": "F-53E"
  },
  {
    "Retail Branding": "FCNT",
    "Marketing Name": "MR01",
    "Device": "MR01",
    "Model": "MR01"
  },
  {
    "Retail Branding": "FCNT",
    "Marketing Name": "SD01",
    "Device": "SD01",
    "Model": "SD01"
  },
  {
    "Retail Branding": "FCNT",
    "Marketing Name": "arrows Alpha F-51F",
    "Device": "F-51F",
    "Model": "F-51F"
  },
  {
    "Retail Branding": "FCNT",
    "Marketing Name": "arrows Alpha M08",
    "Device": "fuji",
    "Model": "M08"
  },
  {
    "Retail Branding": "FCNT",
    "Marketing Name": "arrows BZ02",
    "Device": "BZ02",
    "Model": "BZ02"
  },
  {
    "Retail Branding": "FCNT",
    "Marketing Name": "arrows BZ03",
    "Device": "BZ03",
    "Model": "BZ03"
  },
  {
    "Retail Branding": "FCNT",
    "Marketing Name": "arrows Be4 Plus F-41B",
    "Device": "F41B",
    "Model": "F-41B"
  },
  {
    "Retail Branding": "FCNT",
    "Marketing Name": "arrows N F-51C",
    "Device": "F51C",
    "Model": "F-51C"
  },
  {
    "Retail Branding": "FCNT",
    "Marketing Name": "arrows We A101FC",
    "Device": "A101FC",
    "Model": "A101FC"
  },
  {
    "Retail Branding": "FCNT",
    "Marketing Name": "arrows We F-51B",
    "Device": "F51B",
    "Model": "F-51B"
  },
  {
    "Retail Branding": "FCNT",
    "Marketing Name": "arrows We FCG01",
    "Device": "FCG01",
    "Model": "FCG01"
  },
  {
    "Retail Branding": "FCNT",
    "Marketing Name": "arrows We2 A402FC",
    "Device": "A402FC",
    "Model": "A402FC"
  },
  {
    "Retail Branding": "FCNT",
    "Marketing Name": "arrows We2 F-52E",
    "Device": "F52E",
    "Model": "F-52E"
  },
  {
    "Retail Branding": "FCNT",
    "Marketing Name": "arrows We2 FCG02",
    "Device": "FCG02",
    "Model": "FCG02"
  },
  {
    "Retail Branding": "FCNT",
    "Marketing Name": "arrows We2 M07",
    "Device": "M07",
    "Model": "M07"
  },
  {
    "Retail Branding": "FCNT",
    "Marketing Name": "arrows We2 Plus F-51E",
    "Device": "F51E",
    "Model": "F-51E"
  },
  {
    "Retail Branding": "FCNT",
    "Marketing Name": "arrows We2 Plus M06",
    "Device": "M06",
    "Model": "M06"
  },
  {
    "Retail Branding": "FEITIAN",
    "Marketing Name": "F100",
    "Device": "F100",
    "Model": "F100"
  },
  {
    "Retail Branding": "FEITIAN",
    "Marketing Name": "F100_EEA",
    "Device": "F100",
    "Model": "F100"
  },
  {
    "Retail Branding": "FEITIAN",
    "Marketing Name": "F310 P",
    "Device": "F310P",
    "Model": "F310P"
  },
  {
    "Retail Branding": "FELUX",
    "Marketing Name": "LUXE 3",
    "Device": "LUXE_3",
    "Model": "LUXE 3"
  },
  {
    "Retail Branding": "FELUX",
    "Marketing Name": "X-ONE",
    "Device": "X-ONE",
    "Model": "X-ONE"
  },
  {
    "Retail Branding": "FELUX",
    "Marketing Name": "X_Pro",
    "Device": "X_Pro",
    "Model": "X Pro"
  },
  {
    "Retail Branding": "FEONAL",
    "Marketing Name": "D105_EEA",
    "Device": "D105_EEA",
    "Model": "D105_EEA"
  },
  {
    "Retail Branding": "FEONAL",
    "Marketing Name": "D106_EEA",
    "Device": "D106_EEA",
    "Model": "D106_EEA"
  },
  {
    "Retail Branding": "FEONAL",
    "Marketing Name": "D108_EEA",
    "Device": "D108_EEA",
    "Model": "D108_EEA"
  },
  {
    "Retail Branding": "FEONAL",
    "Marketing Name": "D109_EEA",
    "Device": "D109_EEA",
    "Model": "D109_EEA"
  },
  {
    "Retail Branding": "FEONAL",
    "Marketing Name": "D115",
    "Device": "D115",
    "Model": "D115"
  },
  {
    "Retail Branding": "FEONAL",
    "Marketing Name": "D115_EEA",
    "Device": "D115_EEA",
    "Model": "D115_EEA"
  },
  {
    "Retail Branding": "FEONAL",
    "Marketing Name": "D118_EEA",
    "Device": "D118_EEA",
    "Model": "D118_EEA"
  },
  {
    "Retail Branding": "FEONAL",
    "Marketing Name": "D122_EEA",
    "Device": "D122_EEA",
    "Model": "D122_EEA"
  },
  {
    "Retail Branding": "FEONAL",
    "Marketing Name": "D123_EEA",
    "Device": "D123_EEA",
    "Model": "D123_EEA"
  },
  {
    "Retail Branding": "FEONAL",
    "Marketing Name": "D138_EEA",
    "Device": "D138_EEA",
    "Model": "D138_EEA"
  },
  {
    "Retail Branding": "FEONAL",
    "Marketing Name": "K104",
    "Device": "K104",
    "Model": "K104"
  },
  {
    "Retail Branding": "FEONAL",
    "Marketing Name": "K110_EEA",
    "Device": "K110_EEA",
    "Model": "K110_EEA"
  },
  {
    "Retail Branding": "FEONAL",
    "Marketing Name": "K118_EEA",
    "Device": "K118_EEA",
    "Model": "K118_EEA"
  },
  {
    "Retail Branding": "FEONAL",
    "Marketing Name": "K711_EEA",
    "Device": "K711_EEA",
    "Model": "K711_EEA"
  },
  {
    "Retail Branding": "FFFSMARTLIFE",
    "Marketing Name": "F3T10A3",
    "Device": "F3T10A3",
    "Model": "F3T10A3"
  },
  {
    "Retail Branding": "FFFSMARTLIFE",
    "Marketing Name": "F3T10B1",
    "Device": "F3T10B1",
    "Model": "F3T10B1"
  },
  {
    "Retail Branding": "FFFSMARTLIFE",
    "Marketing Name": "F3T10WD4",
    "Device": "F3T10WD4",
    "Model": "F3T10WD4"
  },
  {
    "Retail Branding": "FFFSMARTLIFE",
    "Marketing Name": "F3T7B1",
    "Device": "F3T7B1",
    "Model": "F3T7B1"
  },
  {
    "Retail Branding": "FFFSMARTLIFE",
    "Marketing Name": "FFFTAB10",
    "Device": "FFFTAB10",
    "Model": "FFFTAB10"
  },
  {
    "Retail Branding": "FFFSMARTLIFE",
    "Marketing Name": "FFFTAB10a0",
    "Device": "FFFTAB10a0",
    "Model": "FFFTAB10a0"
  },
  {
    "Retail Branding": "FFFSMARTLIFE",
    "Marketing Name": "FFFTAB10a1",
    "Device": "FFFTAB10a1",
    "Model": "FFFTAB10a1"
  },
  {
    "Retail Branding": "FFFSMARTLIFE",
    "Marketing Name": "FFFTAB10a2",
    "Device": "FFFTAB10a2",
    "Model": "FFFTAB10a2"
  },
  {
    "Retail Branding": "FFFSMARTLIFE",
    "Marketing Name": "FFFTAB10a3",
    "Device": "FFFTAB10a3",
    "Model": "FFFTAB10a3"
  },
  {
    "Retail Branding": "FFFSMARTLIFE",
    "Marketing Name": "FFFTAB10a4",
    "Device": "FFFTAB10a4",
    "Model": "FFFTAB10a4"
  },
  {
    "Retail Branding": "FFFSMARTLIFE",
    "Marketing Name": "FFFTAB10b0",
    "Device": "FFFTAB10b0",
    "Model": "FFFTAB10b0"
  },
  {
    "Retail Branding": "FFFSMARTLIFE",
    "Marketing Name": "FFFTAB10b1",
    "Device": "FFFTAB10b1",
    "Model": "FFFTAB10b1"
  },
  {
    "Retail Branding": "FFFSMARTLIFE",
    "Marketing Name": "FFFTAB10b3",
    "Device": "FFFTAB10b3",
    "Model": "FFFTAB10b3"
  },
  {
    "Retail Branding": "FFFSMARTLIFE",
    "Marketing Name": "FFFTAB7",
    "Device": "FFFTAB7",
    "Model": "FFFTAB7"
  },
  {
    "Retail Branding": "FFFSMARTLIFE",
    "Marketing Name": "FFFTAB8",
    "Device": "FFFTAB8",
    "Model": "FFFTAB8"
  },
  {
    "Retail Branding": "FILY",
    "Marketing Name": "F8",
    "Device": "F8",
    "Model": "FILY"
  },
  {
    "Retail Branding": "FIREFLY MOBILE",
    "Marketing Name": "AURII_AMUSE_3G",
    "Device": "AURII_AMUSE_3G",
    "Model": "AURII_AMUSE_3G"
  },
  {
    "Retail Branding": "FIREFLY MOBILE",
    "Marketing Name": "FIREFLY MOBILE",
    "Device": "AURII_XCITE",
    "Model": "AURII_XCITE"
  },
  {
    "Retail Branding": "FIREFLY MOBILE",
    "Marketing Name": "INTENSE_XT",
    "Device": "INTENSE_XT",
    "Model": "INTENSE_XT"
  },
  {
    "Retail Branding": "FIREFLY MOBILE",
    "Marketing Name": "Inspire_4G",
    "Device": "INSPIRE_4G",
    "Model": "INSPIRE_4G"
  },
  {
    "Retail Branding": "FIREFLY MOBILE",
    "Marketing Name": "SECRET_XR",
    "Device": "SECRET_XR",
    "Model": "SECRET_XR"
  },
  {
    "Retail Branding": "FIREFLY MOBILE",
    "Marketing Name": "VIVID_PRO",
    "Device": "VIVID_PRO",
    "Model": "VIVID_PRO"
  },
  {
    "Retail Branding": "FIRICH_ENTERPRISE_CO",
    "Marketing Name": "PPX13X_Series",
    "Device": "PPX13X",
    "Model": "PPX13X"
  },
  {
    "Retail Branding": "FIVAHIVA",
    "Marketing Name": "F-764",
    "Device": "F-764",
    "Model": "F-764"
  },
  {
    "Retail Branding": "FIVAHIVA",
    "Marketing Name": "F10A",
    "Device": "F10A",
    "Model": "F10A"
  },
  {
    "Retail Branding": "FIVAHIVA",
    "Marketing Name": "F10A_A15",
    "Device": "F10A",
    "Model": "F10A"
  },
  {
    "Retail Branding": "FIVAHIVA",
    "Marketing Name": "FF-35",
    "Device": "FF-35",
    "Model": "FF-35"
  },
  {
    "Retail Branding": "FIVAHIVA",
    "Marketing Name": "FF1010",
    "Device": "FF1010",
    "Model": "FF1010"
  },
  {
    "Retail Branding": "FIVAHIVA",
    "Marketing Name": "FF10A",
    "Device": "FF10A",
    "Model": "FF10A"
  },
  {
    "Retail Branding": "FIVAHIVA",
    "Marketing Name": "FF_35",
    "Device": "FF_35",
    "Model": "FF_35"
  },
  {
    "Retail Branding": "FIVAHIVA",
    "Marketing Name": "F_764",
    "Device": "F_764",
    "Model": "F_764"
  },
  {
    "Retail Branding": "FIVAHIVA",
    "Marketing Name": "MM-P30",
    "Device": "MM-P30",
    "Model": "MM-P30"
  },
  {
    "Retail Branding": "FIVAHIVA",
    "Marketing Name": "YY_766",
    "Device": "YY_766",
    "Model": "YY_766"
  },
  {
    "Retail Branding": "FIVAHIVA",
    "Marketing Name": "YY_766_EEA",
    "Device": "YY_766_EEA",
    "Model": "YY_766_EEA"
  },
  {
    "Retail Branding": "FLEX MOBILE",
    "Marketing Name": "S9",
    "Device": "S9",
    "Model": "S9"
  },
  {
    "Retail Branding": "FLYCOAY",
    "Marketing Name": "M602-EEA",
    "Device": "M602-EEA",
    "Model": "M602-EEA"
  },
  {
    "Retail Branding": "FMC",
    "Marketing Name": "Digital Experience",
    "Device": "belford",
    "Model": "Infotainment-system"
  },
  {
    "Retail Branding": "FMC",
    "Marketing Name": "Digital Experience",
    "Device": "belford",
    "Model": "SYNC"
  },
  {
    "Retail Branding": "FOLG",
    "Marketing Name": "FOLG_GT_10",
    "Device": "FOLG_GT_10",
    "Model": "FOLG GT 10"
  },
  {
    "Retail Branding": "FOLG",
    "Marketing Name": "FOLG_Tab_10s",
    "Device": "FOLG_Tab_10s",
    "Model": "S20"
  },
  {
    "Retail Branding": "FOLG",
    "Marketing Name": "FT01",
    "Device": "FT01",
    "Model": "Folg Sky 1"
  },
  {
    "Retail Branding": "FOLG",
    "Marketing Name": "FT02",
    "Device": "FT02",
    "Model": "FT02"
  },
  {
    "Retail Branding": "FOLG",
    "Marketing Name": "GT_1201",
    "Device": "FOLG_GT_12_PRO",
    "Model": "FOLG GT 12 PRO"
  },
  {
    "Retail Branding": "FOLG",
    "Marketing Name": "GT_1202",
    "Device": "FOLG_GT_12",
    "Model": "FOLG GT 12"
  },
  {
    "Retail Branding": "FOLG",
    "Marketing Name": "KS20",
    "Device": "KS20",
    "Model": "KidS Prime 1"
  },
  {
    "Retail Branding": "FOLG",
    "Marketing Name": "S18",
    "Device": "S18",
    "Model": "S18"
  },
  {
    "Retail Branding": "FOLG",
    "Marketing Name": "S19",
    "Device": "S19",
    "Model": "S19"
  },
  {
    "Retail Branding": "FOLG",
    "Marketing Name": "S20",
    "Device": "FOLG_TAB_10",
    "Model": "FOLG TAB 10"
  },
  {
    "Retail Branding": "FOLG",
    "Marketing Name": "S30",
    "Device": "S30",
    "Model": "S30"
  },
  {
    "Retail Branding": "FORCE PRO",
    "Marketing Name": "ForcePro",
    "Device": "SEI800EV",
    "Model": "ForcePro"
  },
  {
    "Retail Branding": "FORCO",
    "Marketing Name": "K1028G",
    "Device": "K1028G",
    "Model": "CQS1084LKA01"
  },
  {
    "Retail Branding": "FORCO",
    "Marketing Name": "K1028G",
    "Device": "K1028G",
    "Model": "K1028G"
  },
  {
    "Retail Branding": "FORCO",
    "Marketing Name": "K8T",
    "Device": "K8T",
    "Model": "K8T"
  },
  {
    "Retail Branding": "FOSSiBOT",
    "Marketing Name": "DT1 Lite",
    "Device": "DT1_Lite",
    "Model": "DT1 Lite"
  },
  {
    "Retail Branding": "FOSSiBOT",
    "Marketing Name": "DT1_Lite",
    "Device": "DT1_Lite",
    "Model": "DT1 Lite"
  },
  {
    "Retail Branding": "FOSSiBOT",
    "Marketing Name": "DT2",
    "Device": "DT2",
    "Model": "DT2"
  },
  {
    "Retail Branding": "FOSSiBOT",
    "Marketing Name": "DT3",
    "Device": "DT3",
    "Model": "DT3"
  },
  {
    "Retail Branding": "FOSSiBOT",
    "Marketing Name": "F101",
    "Device": "F101",
    "Model": "F101"
  },
  {
    "Retail Branding": "FOSSiBOT",
    "Marketing Name": "F101",
    "Device": "F101_P",
    "Model": "F101"
  },
  {
    "Retail Branding": "FOSSiBOT",
    "Marketing Name": "F101 P",
    "Device": "F101_P",
    "Model": "F101 P"
  },
  {
    "Retail Branding": "FOSSiBOT",
    "Marketing Name": "F101 Pro",
    "Device": "F101_Pro",
    "Model": "F101 Pro"
  },
  {
    "Retail Branding": "FOSSiBOT",
    "Marketing Name": "F102",
    "Device": "F102",
    "Model": "F102"
  },
  {
    "Retail Branding": "FOSSiBOT",
    "Marketing Name": "F102 ROW",
    "Device": "F102",
    "Model": "F102"
  },
  {
    "Retail Branding": "FOSSiBOT",
    "Marketing Name": "F105",
    "Device": "F105",
    "Model": "F105"
  },
  {
    "Retail Branding": "FOSSiBOT",
    "Marketing Name": "F106 Pro EEA",
    "Device": "F106_Pro",
    "Model": "F106 Pro"
  },
  {
    "Retail Branding": "FOSSiBOT",
    "Marketing Name": "F106 Pro ROW",
    "Device": "F106_Pro",
    "Model": "F106 Pro"
  },
  {
    "Retail Branding": "FOSSiBOT",
    "Marketing Name": "F106 ROW",
    "Device": "F106",
    "Model": "F106"
  },
  {
    "Retail Branding": "FOSSiBOT",
    "Marketing Name": "F107 Pro",
    "Device": "F107_Pro",
    "Model": "F107 Pro"
  },
  {
    "Retail Branding": "FOSSiBOT",
    "Marketing Name": "F109",
    "Device": "F109",
    "Model": "F109"
  },
  {
    "Retail Branding": "FOSSiBOT",
    "Marketing Name": "F109 S",
    "Device": "F109_S",
    "Model": "F109 S"
  },
  {
    "Retail Branding": "FOSSiBOT",
    "Marketing Name": "F110 Pro",
    "Device": "F110_Pro",
    "Model": "F110 Pro"
  },
  {
    "Retail Branding": "FOSSiBOT",
    "Marketing Name": "F110L",
    "Device": "F110L",
    "Model": "F110L"
  },
  {
    "Retail Branding": "FOSSiBOT",
    "Marketing Name": "F112 Pro",
    "Device": "F112_Pro",
    "Model": "F112 Pro"
  },
  {
    "Retail Branding": "FOSSiBOT",
    "Marketing Name": "F113",
    "Device": "F113",
    "Model": "F113"
  },
  {
    "Retail Branding": "FOSSiBOT",
    "Marketing Name": "F114",
    "Device": "F114",
    "Model": "F114"
  },
  {
    "Retail Branding": "FOSSiBOT",
    "Marketing Name": "F115_Ultra",
    "Device": "F115_Ultra",
    "Model": "F115 Ultra"
  },
  {
    "Retail Branding": "FOSSiBOT",
    "Marketing Name": "F116 Pro",
    "Device": "F116_Pro",
    "Model": "F116 Pro"
  },
  {
    "Retail Branding": "FOSSiBOT",
    "Marketing Name": "S1",
    "Device": "S1",
    "Model": "S1"
  },
  {
    "Retail Branding": "FOSSiBOT",
    "Marketing Name": "S2",
    "Device": "FOSSiBOT_S2",
    "Model": "S2"
  },
  {
    "Retail Branding": "FOSSiBOT",
    "Marketing Name": "S3_Pro",
    "Device": "S3_Pro",
    "Model": "S3 Pro"
  },
  {
    "Retail Branding": "FOSSiBOT",
    "Marketing Name": "S3_ROW",
    "Device": "S3",
    "Model": "S3"
  },
  {
    "Retail Branding": "FOSSiBOT",
    "Marketing Name": "S5",
    "Device": "S5",
    "Model": "S5"
  },
  {
    "Retail Branding": "FOSSiBOT",
    "Marketing Name": "S5 Pro",
    "Device": "S5_Pro",
    "Model": "S5_Pro"
  },
  {
    "Retail Branding": "FOSSiBOT",
    "Marketing Name": "S6",
    "Device": "S6",
    "Model": "S6"
  },
  {
    "Retail Branding": "FOSSiBOT",
    "Marketing Name": "S7",
    "Device": "S7",
    "Model": "S7"
  },
  {
    "Retail Branding": "FOSSiBOT",
    "Marketing Name": "Tab 11",
    "Device": "Tab_11",
    "Model": "Tab 11"
  },
  {
    "Retail Branding": "FOSSiBOT",
    "Marketing Name": "Tab 13",
    "Device": "Tab13",
    "Model": "Tab 13"
  },
  {
    "Retail Branding": "FOSSiBOT",
    "Marketing Name": "Tab_12",
    "Device": "Tab_12",
    "Model": "Tab 12"
  },
  {
    "Retail Branding": "FOXX",
    "Marketing Name": "A55AM",
    "Device": "A55AM",
    "Model": "A55AM"
  },
  {
    "Retail Branding": "FOXX",
    "Marketing Name": "A65S",
    "Device": "A65S",
    "Model": "A65S"
  },
  {
    "Retail Branding": "FOXX",
    "Marketing Name": "A67M",
    "Device": "A67M",
    "Model": "A67M"
  },
  {
    "Retail Branding": "FOXX",
    "Marketing Name": "A67M_Lite",
    "Device": "A67M_Lite",
    "Model": "A67M_Lite"
  },
  {
    "Retail Branding": "FOXX",
    "Marketing Name": "FOXX S13 5G",
    "Device": "S13_5G",
    "Model": "FOXX S13 5G"
  },
  {
    "Retail Branding": "FOXX",
    "Marketing Name": "G1",
    "Device": "G1",
    "Model": "FOXX G1"
  },
  {
    "Retail Branding": "FOXX",
    "Marketing Name": "T8C",
    "Device": "T8C",
    "Model": "T8C"
  },
  {
    "Retail Branding": "FOXX",
    "Marketing Name": "V8",
    "Device": "V8",
    "Model": "V8"
  },
  {
    "Retail Branding": "FOXXD",
    "Marketing Name": "A10U",
    "Device": "A10U",
    "Model": "A10U"
  },
  {
    "Retail Branding": "FOXXD",
    "Marketing Name": "A2023",
    "Device": "A2023",
    "Model": "A2023"
  },
  {
    "Retail Branding": "FOXXD",
    "Marketing Name": "A55",
    "Device": "A55",
    "Model": "A55"
  },
  {
    "Retail Branding": "FOXXD",
    "Marketing Name": "A55",
    "Device": "A55",
    "Model": "A55L"
  },
  {
    "Retail Branding": "FOXXD",
    "Marketing Name": "A551",
    "Device": "A551",
    "Model": "A551"
  },
  {
    "Retail Branding": "FOXXD",
    "Marketing Name": "A56",
    "Device": "A56",
    "Model": "A56"
  },
  {
    "Retail Branding": "FOXXD",
    "Marketing Name": "A56",
    "Device": "A56",
    "Model": "A56L"
  },
  {
    "Retail Branding": "FOXXD",
    "Marketing Name": "A5Pro",
    "Device": "A5Pro",
    "Model": "A5Pro"
  },
  {
    "Retail Branding": "FOXXD",
    "Marketing Name": "A62",
    "Device": "A62",
    "Model": "A62"
  },
  {
    "Retail Branding": "FOXXD",
    "Marketing Name": "A63",
    "Device": "A63",
    "Model": "A63"
  },
  {
    "Retail Branding": "FOXXD",
    "Marketing Name": "A65",
    "Device": "A65",
    "Model": "A65"
  },
  {
    "Retail Branding": "FOXXD",
    "Marketing Name": "A65L",
    "Device": "A65L",
    "Model": "A65L"
  },
  {
    "Retail Branding": "FOXXD",
    "Marketing Name": "A65L_L",
    "Device": "A65L",
    "Model": "A65L"
  },
  {
    "Retail Branding": "FOXXD",
    "Marketing Name": "A65M",
    "Device": "A65M",
    "Model": "A65M"
  },
  {
    "Retail Branding": "FOXXD",
    "Marketing Name": "A65Plus",
    "Device": "A65Plus",
    "Model": "A65Plus"
  },
  {
    "Retail Branding": "FOXXD",
    "Marketing Name": "A65U",
    "Device": "A65U",
    "Model": "A65U"
  },
  {
    "Retail Branding": "FOXXD",
    "Marketing Name": "A67L",
    "Device": "A67L",
    "Model": "A67L"
  },
  {
    "Retail Branding": "FOXXD",
    "Marketing Name": "A67U",
    "Device": "A67U",
    "Model": "A67U"
  },
  {
    "Retail Branding": "FOXXD",
    "Marketing Name": "A67W",
    "Device": "A67W",
    "Model": "A67W"
  },
  {
    "Retail Branding": "FOXXD",
    "Marketing Name": "A67W_Lite",
    "Device": "A67W_Lite",
    "Model": "A67W Lite"
  },
  {
    "Retail Branding": "FOXXD",
    "Marketing Name": "A6_Plus",
    "Device": "A6_Plus",
    "Model": "A6 Plus"
  },
  {
    "Retail Branding": "FOXXD",
    "Marketing Name": "AS65U",
    "Device": "AS65U",
    "Model": "AS65U"
  },
  {
    "Retail Branding": "FOXXD",
    "Marketing Name": "AS65U",
    "Device": "AS65U",
    "Model": "Sail 3"
  },
  {
    "Retail Branding": "FOXXD",
    "Marketing Name": "AS65U",
    "Device": "AS65U",
    "Model": "T2"
  },
  {
    "Retail Branding": "FOXXD",
    "Marketing Name": "C10",
    "Device": "C10",
    "Model": "C10"
  },
  {
    "Retail Branding": "FOXXD",
    "Marketing Name": "FOXXD C10 Pro",
    "Device": "C10_Pro",
    "Model": "FOXXD C10 Pro"
  },
  {
    "Retail Branding": "FOXXD",
    "Marketing Name": "FOXXD C65",
    "Device": "FOXXD_C65",
    "Model": "FOXXD C65"
  },
  {
    "Retail Branding": "FOXXD",
    "Marketing Name": "FOXXD C69M",
    "Device": "C69M",
    "Model": "FOXXD C69M"
  },
  {
    "Retail Branding": "FOXXD",
    "Marketing Name": "FOXXD HTH C67",
    "Device": "HTH_C67",
    "Model": "FOXXD HTH C67"
  },
  {
    "Retail Branding": "FOXXD",
    "Marketing Name": "FOXXD HTH S67",
    "Device": "HTH_S67",
    "Model": "FOXXD HTH S67"
  },
  {
    "Retail Branding": "FOXXD",
    "Marketing Name": "FOXXD S67",
    "Device": "FOXXD_S67",
    "Model": "FOXXD S67"
  },
  {
    "Retail Branding": "FOXXD",
    "Marketing Name": "FOXXD S67L",
    "Device": "S67L",
    "Model": "FOXXD S67L"
  },
  {
    "Retail Branding": "FOXXD",
    "Marketing Name": "MIRO",
    "Device": "L590A",
    "Model": "L590A"
  },
  {
    "Retail Branding": "FOXXD",
    "Marketing Name": "N5",
    "Device": "N5",
    "Model": "N5"
  },
  {
    "Retail Branding": "FOXXD",
    "Marketing Name": "P10",
    "Device": "P10",
    "Model": "P10"
  },
  {
    "Retail Branding": "FOXXD",
    "Marketing Name": "P8",
    "Device": "P8",
    "Model": "P8"
  },
  {
    "Retail Branding": "FOXXD",
    "Marketing Name": "T10A",
    "Device": "T10A",
    "Model": "T10A"
  },
  {
    "Retail Branding": "FOXXD",
    "Marketing Name": "T55",
    "Device": "T55",
    "Model": "T55"
  },
  {
    "Retail Branding": "FOXXD",
    "Marketing Name": "T8",
    "Device": "T8",
    "Model": "T8"
  },
  {
    "Retail Branding": "FOXXD",
    "Marketing Name": "T8A",
    "Device": "T8A",
    "Model": "T8A"
  },
  {
    "Retail Branding": "FOXXD",
    "Marketing Name": "T8B",
    "Device": "T8B",
    "Model": "T8B"
  },
  {
    "Retail Branding": "FOXXD",
    "Marketing Name": "T8M",
    "Device": "T8M",
    "Model": "T8M"
  },
  {
    "Retail Branding": "FOXXD",
    "Marketing Name": "T8Plus",
    "Device": "T8Plus",
    "Model": "T8 Plus"
  },
  {
    "Retail Branding": "FOXXD",
    "Marketing Name": "T8Pro",
    "Device": "T8Pro",
    "Model": "T8Pro"
  },
  {
    "Retail Branding": "FPD",
    "Marketing Name": "CP08-C1",
    "Device": "CP08-C1",
    "Model": "CP08-C1"
  },
  {
    "Retail Branding": "FPD",
    "Marketing Name": "CP08-C1",
    "Device": "CP08-C1",
    "Model": "CP08_C1"
  },
  {
    "Retail Branding": "FPD",
    "Marketing Name": "CP08_J1",
    "Device": "CP08_J1",
    "Model": "CP08_J1"
  },
  {
    "Retail Branding": "FPD",
    "Marketing Name": "CP10-J1",
    "Device": "CP10",
    "Model": "CP10-J1"
  },
  {
    "Retail Branding": "FPD",
    "Marketing Name": "CP11_J1",
    "Device": "CP11_J1",
    "Model": "CP11_J1"
  },
  {
    "Retail Branding": "FPD",
    "Marketing Name": "EcoTV1 Plus",
    "Device": "elliniko",
    "Model": "EcoTV1 Plus"
  },
  {
    "Retail Branding": "FPD",
    "Marketing Name": "FPD",
    "Device": "elliniko",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "FPD",
    "Marketing Name": "FPD",
    "Device": "hongkong",
    "Model": "EcoTV Pro A"
  },
  {
    "Retail Branding": "FPD",
    "Marketing Name": "FPD",
    "Device": "hongkong",
    "Model": "EcoTV Pro D"
  },
  {
    "Retail Branding": "FPD",
    "Marketing Name": "FPD",
    "Device": "hongkong",
    "Model": "EcoTV Pro I"
  },
  {
    "Retail Branding": "FPD",
    "Marketing Name": "FPD",
    "Device": "khardi",
    "Model": "EcoTV Pre A"
  },
  {
    "Retail Branding": "FPD",
    "Marketing Name": "FPD",
    "Device": "khardi",
    "Model": "EcoTV Pre D"
  },
  {
    "Retail Branding": "FPD",
    "Marketing Name": "FPD",
    "Device": "khardi",
    "Model": "EcoTV Pre I"
  },
  {
    "Retail Branding": "FPD",
    "Marketing Name": "FPD",
    "Device": "lavender",
    "Model": "EcoTV Plus C"
  },
  {
    "Retail Branding": "FPD",
    "Marketing Name": "FPD",
    "Device": "lavender",
    "Model": "EcoTV Plus D"
  },
  {
    "Retail Branding": "FPD",
    "Marketing Name": "FPD",
    "Device": "lavender",
    "Model": "EcoTV Plus I"
  },
  {
    "Retail Branding": "FPD",
    "Marketing Name": "FPD",
    "Device": "minami",
    "Model": "EcoTV3 J"
  },
  {
    "Retail Branding": "FPD",
    "Marketing Name": "FPD",
    "Device": "mountbaker",
    "Model": "EcoTV A"
  },
  {
    "Retail Branding": "FPD",
    "Marketing Name": "FPD",
    "Device": "mountbaker",
    "Model": "EcoTV C"
  },
  {
    "Retail Branding": "FPD",
    "Marketing Name": "FPD",
    "Device": "mountbaker",
    "Model": "EcoTV D"
  },
  {
    "Retail Branding": "FPD",
    "Marketing Name": "FPD",
    "Device": "mountbaker",
    "Model": "EcoTV I"
  },
  {
    "Retail Branding": "FPT Telecom",
    "Marketing Name": "FPT ATV Play Box",
    "Device": "DV8236",
    "Model": "FPT ATV Play Box"
  },
  {
    "Retail Branding": "FPT Telecom",
    "Marketing Name": "FPT Play Box +",
    "Device": "DV8536-KVF",
    "Model": "FPT Play Box +"
  },
  {
    "Retail Branding": "FPT Telecom",
    "Marketing Name": "FPT Play Box +",
    "Device": "SEI500FPT",
    "Model": "FPT Play Box +"
  },
  {
    "Retail Branding": "FPT Telecom",
    "Marketing Name": "FPT Play Box S",
    "Device": "SEI610FPT",
    "Model": "FPT Play Box S"
  },
  {
    "Retail Branding": "FPT Telecom",
    "Marketing Name": "SEI500FPT",
    "Device": "SEI500FPT",
    "Model": "FPT Play Box +"
  },
  {
    "Retail Branding": "FPT Telecom",
    "Marketing Name": "SEI610FPT",
    "Device": "SEI610FPT",
    "Model": "FPT Play Box S"
  },
  {
    "Retail Branding": "FPT Trading",
    "Marketing Name": "A15",
    "Device": "A15_01",
    "Model": "A15"
  },
  {
    "Retail Branding": "FPT Trading",
    "Marketing Name": "FPT S68 4G",
    "Device": "FPT_S68_4G",
    "Model": "FPT S68 4G"
  },
  {
    "Retail Branding": "FPT Trading",
    "Marketing Name": "FPT X10",
    "Device": "X10",
    "Model": "FPT_X10"
  },
  {
    "Retail Branding": "FPT Trading",
    "Marketing Name": "FPT X3",
    "Device": "FPT_X3",
    "Model": "FPT X3"
  },
  {
    "Retail Branding": "FPT Trading",
    "Marketing Name": "FPT X9",
    "Device": "X9",
    "Model": "FPT_X9"
  },
  {
    "Retail Branding": "FPT Trading",
    "Marketing Name": "FPT_X15",
    "Device": "FPT_X15",
    "Model": "FPT_X15"
  },
  {
    "Retail Branding": "FPT Trading",
    "Marketing Name": "FPT_X50",
    "Device": "FPT_X50",
    "Model": "FPT X50"
  },
  {
    "Retail Branding": "FPT Trading",
    "Marketing Name": "X50",
    "Device": "FPT_X50",
    "Model": "FPT X50"
  },
  {
    "Retail Branding": "FREESTREAM",
    "Marketing Name": 3500,
    "Device": 3500,
    "Model": 3500
  },
  {
    "Retail Branding": "FUEGO",
    "Marketing Name": "Europe",
    "Device": "sepolia",
    "Model": "FUEGO Smart TV"
  },
  {
    "Retail Branding": "FUEGO",
    "Marketing Name": "FUEGO 2K SMART TV",
    "Device": "nagata",
    "Model": "FUEGO 2K SMART TV"
  },
  {
    "Retail Branding": "FUEGO",
    "Marketing Name": "FUEGO 4K SMART TV",
    "Device": "marina",
    "Model": "FUEGO 4K SMART TV"
  },
  {
    "Retail Branding": "FUEGO",
    "Marketing Name": "FUEGO Smart TV",
    "Device": "dongnae",
    "Model": "FUEGO Smart TV"
  },
  {
    "Retail Branding": "FUNKER",
    "Marketing Name": "E500i",
    "Device": "E500i",
    "Model": "E500i"
  },
  {
    "Retail Branding": "FUNPAD",
    "Marketing Name": "KISOK",
    "Device": "Kiosk_LP4",
    "Model": "LP4"
  },
  {
    "Retail Branding": "FUNPAD",
    "Marketing Name": "KISOK LP",
    "Device": "KIOSK",
    "Model": "LP"
  },
  {
    "Retail Branding": "FUSE4K",
    "Marketing Name": "FUSE 4K",
    "Device": "SEI700TV",
    "Model": "FUSE 4K"
  },
  {
    "Retail Branding": "FUSHIZK",
    "Marketing Name": "RT-08MG",
    "Device": "RT-08MG",
    "Model": "RT-08MG"
  },
  {
    "Retail Branding": "FaceVsion",
    "Marketing Name": "OC1020A",
    "Device": "OC1020A",
    "Model": "FV-FG6"
  },
  {
    "Retail Branding": "Facime",
    "Marketing Name": "FLEET_7",
    "Device": "FLEET_7",
    "Model": "FLEET_7"
  },
  {
    "Retail Branding": "Faiba",
    "Marketing Name": "M1",
    "Device": "M1",
    "Model": "M1"
  },
  {
    "Retail Branding": "Fairphone",
    "Marketing Name": "FP2",
    "Device": "FP2",
    "Model": "FP2"
  },
  {
    "Retail Branding": "Fairphone",
    "Marketing Name": "Fairphone 5 5G",
    "Device": "FP5",
    "Model": "FP5"
  },
  {
    "Retail Branding": "Fairphone",
    "Marketing Name": "Fairphone3",
    "Device": "FP3",
    "Model": "FP3"
  },
  {
    "Retail Branding": "Fairphone",
    "Marketing Name": "Fairphone4",
    "Device": "FP4",
    "Model": "FP4"
  },
  {
    "Retail Branding": "Fairphone",
    "Marketing Name": "The Fairphone (Gen. 6)",
    "Device": "FP6",
    "Model": "Fairphone 6"
  },
  {
    "Retail Branding": "Famous Fones",
    "Marketing Name": "Famous Red 5+",
    "Device": "Famous_Red_5Plus",
    "Model": "Famous Red 5+"
  },
  {
    "Retail Branding": "Famous Fones",
    "Marketing Name": "Famous_5",
    "Device": "Famous_5",
    "Model": "Famous 5"
  },
  {
    "Retail Branding": "Famous Fones",
    "Marketing Name": "Famous_5Plus",
    "Device": "Famous_5Plus",
    "Model": "Famous 5Plus"
  },
  {
    "Retail Branding": "Famous Fones",
    "Marketing Name": "Famous_TAB_10",
    "Device": "Famous_TAB_10",
    "Model": "Famous_TAB_10"
  },
  {
    "Retail Branding": "Famous Fones",
    "Marketing Name": "Fonos-O1",
    "Device": "Fonos-O1",
    "Model": "Fonos-O1"
  },
  {
    "Retail Branding": "Famous Fones",
    "Marketing Name": "Red_Royal_Edition",
    "Device": "Red_Royal_Edition",
    "Model": "Red Royal Edition"
  },
  {
    "Retail Branding": "Fanconn",
    "Marketing Name": "DC685",
    "Device": "GMJ",
    "Model": "SC228"
  },
  {
    "Retail Branding": "FancyDay",
    "Marketing Name": "C10",
    "Device": "C10",
    "Model": "C10"
  },
  {
    "Retail Branding": "FancyDay",
    "Marketing Name": "C10US",
    "Device": "C10",
    "Model": "C10"
  },
  {
    "Retail Branding": "Fantec",
    "Marketing Name": "FANTEC M200H",
    "Device": "M200H",
    "Model": "M200H"
  },
  {
    "Retail Branding": "Fantec",
    "Marketing Name": "FANTEC M300H",
    "Device": "M300H",
    "Model": "FAN-M300H"
  },
  {
    "Retail Branding": "Fanvil",
    "Marketing Name": "W635C",
    "Device": "W635C",
    "Model": "W635C"
  },
  {
    "Retail Branding": "Fanvil",
    "Marketing Name": "W635W",
    "Device": "W635W",
    "Model": "W635W"
  },
  {
    "Retail Branding": "Fanvil",
    "Marketing Name": "W638C",
    "Device": "W638C",
    "Model": "W638C"
  },
  {
    "Retail Branding": "FarEasTone",
    "Marketing Name": "Smart 403",
    "Device": "msm8226",
    "Model": "Smart 403"
  },
  {
    "Retail Branding": "FarEasTone",
    "Marketing Name": "Smart 505",
    "Device": "Smart505",
    "Model": "Smart 505"
  },
  {
    "Retail Branding": "FarEasTone",
    "Marketing Name": "Smart 509",
    "Device": "Smart509",
    "Model": "Smart509"
  },
  {
    "Retail Branding": "FarEasTone",
    "Marketing Name": "Smart 550",
    "Device": "Smart550",
    "Model": "Smart550"
  },
  {
    "Retail Branding": "FarEasTone",
    "Marketing Name": "Smart501",
    "Device": "Smart501",
    "Model": "Smart501"
  },
  {
    "Retail Branding": "FarEasTone",
    "Marketing Name": "Smart503",
    "Device": "MC2",
    "Model": "Smart503"
  },
  {
    "Retail Branding": "FarEasTone",
    "Marketing Name": "Smart601",
    "Device": "Smart601",
    "Model": "Smart601"
  },
  {
    "Retail Branding": "Fastlife",
    "Marketing Name": "FASTLIFE",
    "Device": "zhongshan",
    "Model": "SMART TV"
  },
  {
    "Retail Branding": "Fastway",
    "Marketing Name": "AR-5003MSB",
    "Device": "FW_SMART_4K_Box",
    "Model": "AR-5003MSB"
  },
  {
    "Retail Branding": "Fastway",
    "Marketing Name": "FW-Plus Ultra 4K Box1",
    "Device": "DV8545-C-KIF",
    "Model": "FW-Plus Ultra 4K Box1"
  },
  {
    "Retail Branding": "Fero",
    "Marketing Name": "A4001 Plus 2019",
    "Device": "A4001_Plus_2019",
    "Model": "Fero A4001 Plus 2019"
  },
  {
    "Retail Branding": "Fero",
    "Marketing Name": "A5000",
    "Device": "A5000",
    "Model": "A5000"
  },
  {
    "Retail Branding": "Fero",
    "Marketing Name": "A5003",
    "Device": "A5003",
    "Model": "A5003"
  },
  {
    "Retail Branding": "Fero",
    "Marketing Name": "A5003",
    "Device": "A5003_512",
    "Model": "A5003"
  },
  {
    "Retail Branding": "Fero",
    "Marketing Name": "A5500",
    "Device": "A5500",
    "Model": "A5500"
  },
  {
    "Retail Branding": "Fero",
    "Marketing Name": "FERO ROYALE Y2",
    "Device": "Royale_Y2",
    "Model": "Royale Y2"
  },
  {
    "Retail Branding": "Fero",
    "Marketing Name": "Fero Vibe",
    "Device": "Fero_Vibe",
    "Model": "Fero Vibe"
  },
  {
    "Retail Branding": "Fero",
    "Marketing Name": "POWER 3",
    "Device": "Power_3",
    "Model": "Power 3"
  },
  {
    "Retail Branding": "Fero",
    "Marketing Name": "Royale A1",
    "Device": "Royale_A1",
    "Model": "Royale A1"
  },
  {
    "Retail Branding": "Fero",
    "Marketing Name": "Royale X2",
    "Device": "Royale_X2",
    "Model": "Royale_X2"
  },
  {
    "Retail Branding": "Fero",
    "Marketing Name": "Royale Y2 Lite",
    "Device": "Royale_Y2_Lite",
    "Model": "Royale Y2 Lite"
  },
  {
    "Retail Branding": "FieldBio",
    "Marketing Name": "FieldBio_500",
    "Device": "FieldBio_500",
    "Model": "FieldBio_500"
  },
  {
    "Retail Branding": "Fiesta Duo",
    "Marketing Name": "S6",
    "Device": "S6",
    "Model": "S6"
  },
  {
    "Retail Branding": "Fiesta Duo",
    "Marketing Name": "iX",
    "Device": "iX",
    "Model": "iX"
  },
  {
    "Retail Branding": "Figgers",
    "Marketing Name": "F-tab",
    "Device": "F-tab",
    "Model": "F-tab"
  },
  {
    "Retail Branding": "Figgers",
    "Marketing Name": "Figgers DragonX",
    "Device": "Figgers_DragonX",
    "Model": "Figgers DragonX"
  },
  {
    "Retail Branding": "Figgers",
    "Marketing Name": "Figgers F3",
    "Device": "Figgers_F3",
    "Model": "Figgers F3"
  },
  {
    "Retail Branding": "Figi",
    "Marketing Name": "FIGI Fone",
    "Device": "Fone",
    "Model": "Fone"
  },
  {
    "Retail Branding": "Figi",
    "Marketing Name": "FIGI Ftwo",
    "Device": "Ftwo",
    "Model": "Ftwo"
  },
  {
    "Retail Branding": "Figi",
    "Marketing Name": "FIGI Gone",
    "Device": "Gone",
    "Model": "Gone"
  },
  {
    "Retail Branding": "Figi",
    "Marketing Name": "FX",
    "Device": "FX",
    "Model": "FX"
  },
  {
    "Retail Branding": "Figi",
    "Marketing Name": "FXs",
    "Device": "FXs",
    "Model": "FXs"
  },
  {
    "Retail Branding": "Figi",
    "Marketing Name": "Fj",
    "Device": "Fj",
    "Model": "Fj"
  },
  {
    "Retail Branding": "Figi",
    "Marketing Name": "G4",
    "Device": "G4",
    "Model": "G4"
  },
  {
    "Retail Branding": "Figi",
    "Marketing Name": "G5",
    "Device": "G5",
    "Model": "G5"
  },
  {
    "Retail Branding": "Figi",
    "Marketing Name": "G6",
    "Device": "G6",
    "Model": "G6"
  },
  {
    "Retail Branding": "Figi",
    "Marketing Name": "Gtwo",
    "Device": "Gtwo",
    "Model": "Gtwo"
  },
  {
    "Retail Branding": "Figi",
    "Marketing Name": "Hola",
    "Device": "Hola",
    "Model": "Hola"
  },
  {
    "Retail Branding": "Figi",
    "Marketing Name": "Mone",
    "Device": "Mone",
    "Model": "Mone"
  },
  {
    "Retail Branding": "Figi",
    "Marketing Name": "Mtwo",
    "Device": "Mtwo",
    "Model": "Mtwo"
  },
  {
    "Retail Branding": "Figi",
    "Marketing Name": "Nopal",
    "Device": "Nopal",
    "Model": "Nopal"
  },
  {
    "Retail Branding": "Figi",
    "Marketing Name": "Note 1",
    "Device": "Note_1",
    "Model": "Note 1"
  },
  {
    "Retail Branding": "Figi",
    "Marketing Name": "Note_11_Pro",
    "Device": "Note_11_Pro",
    "Model": "Note_11_Pro"
  },
  {
    "Retail Branding": "Figi",
    "Marketing Name": "Note_1C",
    "Device": "Note_1C",
    "Model": "Note_1C"
  },
  {
    "Retail Branding": "Figi",
    "Marketing Name": "Note_1_Lite",
    "Device": "Note_1_Lite",
    "Model": "Note_1_Lite"
  },
  {
    "Retail Branding": "Figi",
    "Marketing Name": "Note_3_Pro",
    "Device": "Note_3_Pro",
    "Model": "Note_3_Pro"
  },
  {
    "Retail Branding": "Figi",
    "Marketing Name": "Note_5",
    "Device": "Note_5",
    "Model": "Note_5"
  },
  {
    "Retail Branding": "Figi",
    "Marketing Name": "Note_7_Pro",
    "Device": "Note_7_Pro",
    "Model": "Note_7_Pro"
  },
  {
    "Retail Branding": "Figo",
    "Marketing Name": "A9",
    "Device": "A9",
    "Model": "A9"
  },
  {
    "Retail Branding": "Figo",
    "Marketing Name": "ATRIUM II F55L2",
    "Device": "F55L2",
    "Model": "ATRIUM II F55L2"
  },
  {
    "Retail Branding": "Figo",
    "Marketing Name": "CENTRIC S50G",
    "Device": "S50G",
    "Model": "CENTRIC S50G"
  },
  {
    "Retail Branding": "Figo",
    "Marketing Name": "F40G2",
    "Device": "F40G2",
    "Model": "F40G2"
  },
  {
    "Retail Branding": "Figo",
    "Marketing Name": "Fierce_L5510",
    "Device": "Telecell",
    "Model": "L5510"
  },
  {
    "Retail Branding": "Figo",
    "Marketing Name": "J9",
    "Device": "J9",
    "Model": "J9"
  },
  {
    "Retail Branding": "Figo",
    "Marketing Name": "M50L",
    "Device": "M50L",
    "Model": "M50L"
  },
  {
    "Retail Branding": "Figo",
    "Marketing Name": "Orbit_ll",
    "Device": "Orbit_ll",
    "Model": "Orbit_ll"
  },
  {
    "Retail Branding": "Figo",
    "Marketing Name": "Ultra J8",
    "Device": "UltraJ8",
    "Model": "UltraJ8"
  },
  {
    "Retail Branding": "Filih",
    "Marketing Name": "FX4423",
    "Device": "FX4423",
    "Model": "FX4423"
  },
  {
    "Retail Branding": "Finggo",
    "Marketing Name": "FWSP-S1000",
    "Device": "FWSP-S1000-HW",
    "Model": "FWSP-S1000"
  },
  {
    "Retail Branding": "Finggo",
    "Marketing Name": "FWTA-T1000",
    "Device": "FWTA-T1000",
    "Model": "FWTA-T1000"
  },
  {
    "Retail Branding": "Firehawk",
    "Marketing Name": "FP-600",
    "Device": "FP-600",
    "Model": "FP-600"
  },
  {
    "Retail Branding": "Firehawk",
    "Marketing Name": "Firehawk",
    "Device": "ToughDroid_Pro",
    "Model": "FT-810"
  },
  {
    "Retail Branding": "Firehawk",
    "Marketing Name": "ToughDroid",
    "Device": "ToughDroid",
    "Model": "ToughDroid"
  },
  {
    "Retail Branding": "FirstNationalBank",
    "Marketing Name": "FNB",
    "Device": "SP5045V",
    "Model": "SP5045V"
  },
  {
    "Retail Branding": "Fitbit",
    "Marketing Name": "Fitbit Ace LTE",
    "Device": "p11",
    "Model": "Fitbit Ace LTE"
  },
  {
    "Retail Branding": "Fitbit",
    "Marketing Name": "Fitbit Ace LTE",
    "Device": "p11",
    "Model": "P11"
  },
  {
    "Retail Branding": "Fiteye",
    "Marketing Name": "Mobile smart screen",
    "Device": "FIT-32",
    "Model": "FIT-32"
  },
  {
    "Retail Branding": "Flash",
    "Marketing Name": "Ivory",
    "Device": "Ivory",
    "Model": "Ivory"
  },
  {
    "Retail Branding": "Flash",
    "Marketing Name": "Live",
    "Device": "Live",
    "Model": "Live"
  },
  {
    "Retail Branding": "Flash",
    "Marketing Name": "PRIME_1",
    "Device": "PRIME_1",
    "Model": "PRIME 1"
  },
  {
    "Retail Branding": "Flnet",
    "Marketing Name": "BANDOTT",
    "Device": "ba101",
    "Model": "ba101"
  },
  {
    "Retail Branding": "Flnet",
    "Marketing Name": "BANDOTT Sandwich",
    "Device": "ba201",
    "Model": "ba201"
  },
  {
    "Retail Branding": "Flnet",
    "Marketing Name": "BandOTT",
    "Device": "ba101",
    "Model": "ba101"
  },
  {
    "Retail Branding": "Flow",
    "Marketing Name": "FlowBox-F1",
    "Device": "HP40A2",
    "Model": "FlowBox-F1"
  },
  {
    "Retail Branding": "Flow",
    "Marketing Name": "FlowBox-F2",
    "Device": "HP44H",
    "Model": "FlowBox-F2"
  },
  {
    "Retail Branding": "Flow",
    "Marketing Name": "FlowBox-F4",
    "Device": "HP4CH-Telecom",
    "Model": "FlowBox-F4"
  },
  {
    "Retail Branding": "Flow",
    "Marketing Name": "FlowBox-S2",
    "Device": "m250_t",
    "Model": "FlowBox-S2"
  },
  {
    "Retail Branding": "Flow",
    "Marketing Name": "FlowBox-Z3",
    "Device": "B866V2F_FLOW",
    "Model": "FlowBox-Z3"
  },
  {
    "Retail Branding": "Flow",
    "Marketing Name": "FlowBox-Z4",
    "Device": "B866V6N_FLOW",
    "Model": "FlowBox-Z4"
  },
  {
    "Retail Branding": "Flow",
    "Marketing Name": "FlowSoundBox",
    "Device": "m393gena_teco",
    "Model": "FlowSoundBox"
  },
  {
    "Retail Branding": "Flow",
    "Marketing Name": "Flowbox-F1",
    "Device": "HP40A2",
    "Model": "FlowBox-F1"
  },
  {
    "Retail Branding": "Fluo",
    "Marketing Name": "F",
    "Device": "F",
    "Model": "F"
  },
  {
    "Retail Branding": "Fluo",
    "Marketing Name": "F Plus",
    "Device": "F_Plus",
    "Model": "F_Plus"
  },
  {
    "Retail Branding": "Fluo",
    "Marketing Name": "F2",
    "Device": "F2",
    "Model": "F2"
  },
  {
    "Retail Branding": "Fluo",
    "Marketing Name": "Fluo",
    "Device": "S504050",
    "Model": "S504050"
  },
  {
    "Retail Branding": "Fluo",
    "Marketing Name": "N",
    "Device": "N",
    "Model": "N"
  },
  {
    "Retail Branding": "Fluo",
    "Marketing Name": "N",
    "Device": "S574020S",
    "Model": "N"
  },
  {
    "Retail Branding": "Fluo",
    "Marketing Name": "S554020",
    "Device": "S554020",
    "Model": "S554020"
  },
  {
    "Retail Branding": "Fluo",
    "Marketing Name": "S574010S",
    "Device": "S574010S",
    "Model": "S574010S"
  },
  {
    "Retail Branding": "Fluo",
    "Marketing Name": "T100020_EEA",
    "Device": "T100020_EEA",
    "Model": "T100020_EEA"
  },
  {
    "Retail Branding": "Fluo",
    "Marketing Name": "T100020_TR",
    "Device": "T100020_TR",
    "Model": "T100020_TR"
  },
  {
    "Retail Branding": "Fluo",
    "Marketing Name": "X2 Max",
    "Device": "S624010S",
    "Model": "X2 Max"
  },
  {
    "Retail Branding": "Fluo",
    "Marketing Name": "X2_Max",
    "Device": "X2_Max",
    "Model": "X2 Max"
  },
  {
    "Retail Branding": "Fly",
    "Marketing Name": "5_S",
    "Device": "5_S",
    "Model": "5S"
  },
  {
    "Retail Branding": "Fly",
    "Marketing Name": "Champ",
    "Device": "Champ",
    "Model": "FS529"
  },
  {
    "Retail Branding": "Fly",
    "Marketing Name": "Cirrus 11",
    "Device": "Cirrus_11",
    "Model": "FS517"
  },
  {
    "Retail Branding": "Fly",
    "Marketing Name": "Cirrus 12",
    "Device": "Cirrus_12",
    "Model": "FS516"
  },
  {
    "Retail Branding": "Fly",
    "Marketing Name": "Cirrus 13",
    "Device": "Cirrus_13",
    "Model": "FS518"
  },
  {
    "Retail Branding": "Fly",
    "Marketing Name": "Cirrus 14",
    "Device": "Cirrus_14",
    "Model": "FS522"
  },
  {
    "Retail Branding": "Fly",
    "Marketing Name": "Cirrus 16",
    "Device": "Cirrus_16",
    "Model": "FS523"
  },
  {
    "Retail Branding": "Fly",
    "Marketing Name": "Cirrus 17",
    "Device": "Cirrus_17",
    "Model": "FS525"
  },
  {
    "Retail Branding": "Fly",
    "Marketing Name": "Cirrus 2",
    "Device": "Cirrus_2",
    "Model": "FS504"
  },
  {
    "Retail Branding": "Fly",
    "Marketing Name": "Cirrus 3",
    "Device": "Cirrus_3",
    "Model": "FS506"
  },
  {
    "Retail Branding": "Fly",
    "Marketing Name": "Cirrus 4",
    "Device": "Cirrus_4",
    "Model": "FS507"
  },
  {
    "Retail Branding": "Fly",
    "Marketing Name": "Cirrus 6",
    "Device": "Cirrus_6",
    "Model": "Cirrus 6"
  },
  {
    "Retail Branding": "Fly",
    "Marketing Name": "Cirrus 6",
    "Device": "Cirrus_6",
    "Model": "FS508"
  },
  {
    "Retail Branding": "Fly",
    "Marketing Name": "Cirrus 7",
    "Device": "Cirrus_7",
    "Model": "FS511"
  },
  {
    "Retail Branding": "Fly",
    "Marketing Name": "Cirrus 8",
    "Device": "Cirrus_8",
    "Model": "FS514"
  },
  {
    "Retail Branding": "Fly",
    "Marketing Name": "Cirrus 9",
    "Device": "Cirrus_9",
    "Model": "FS553"
  },
  {
    "Retail Branding": "Fly",
    "Marketing Name": "Compact 4G",
    "Device": "Compact_4G",
    "Model": "Life Compact 4G"
  },
  {
    "Retail Branding": "Fly",
    "Marketing Name": "Dune 3",
    "Device": "Dune_3",
    "Model": "IQ4507"
  },
  {
    "Retail Branding": "Fly",
    "Marketing Name": "Dune 4",
    "Device": "Dune_4",
    "Model": "Fly IQ4508"
  },
  {
    "Retail Branding": "Fly",
    "Marketing Name": "ERA Nano 7",
    "Device": "Fly_IQ4407",
    "Model": "IQ4407"
  },
  {
    "Retail Branding": "Fly",
    "Marketing Name": "EVO Chic 1",
    "Device": "IQ4405_Quad",
    "Model": "Fly IQ4405_Quad"
  },
  {
    "Retail Branding": "Fly",
    "Marketing Name": "Ego Art 2",
    "Device": "Fly_Ego_Art_2",
    "Model": "Fly Ego Art 2"
  },
  {
    "Retail Branding": "Fly",
    "Marketing Name": "Era Energy 1",
    "Device": "IQ4502_Quad",
    "Model": "IQ4502 Quad"
  },
  {
    "Retail Branding": "Fly",
    "Marketing Name": "Era Life 2",
    "Device": "IQ456",
    "Model": "IQ456"
  },
  {
    "Retail Branding": "Fly",
    "Marketing Name": "Era Nano 6",
    "Device": "Era_Nano_6",
    "Model": "IQ4406"
  },
  {
    "Retail Branding": "Fly",
    "Marketing Name": "Era Nano 8",
    "Device": "IQ4400",
    "Model": "IQ4400"
  },
  {
    "Retail Branding": "Fly",
    "Marketing Name": "Era Nano 9",
    "Device": "IQ436i",
    "Model": "IQ436i"
  },
  {
    "Retail Branding": "Fly",
    "Marketing Name": "Era Style 3",
    "Device": "IQ4415_Quad",
    "Model": "IQ4415 Quad"
  },
  {
    "Retail Branding": "Fly",
    "Marketing Name": "Evo Chic 2",
    "Device": "IQ459",
    "Model": "IQ459"
  },
  {
    "Retail Branding": "Fly",
    "Marketing Name": "Evo Chic 2",
    "Device": "IQ459",
    "Model": "IQ459 Quad"
  },
  {
    "Retail Branding": "Fly",
    "Marketing Name": "Evo Energy4",
    "Device": "IQ4501",
    "Model": "Evo Energy4"
  },
  {
    "Retail Branding": "Fly",
    "Marketing Name": "Evo Tech 3",
    "Device": "IQ4414_Quad",
    "Model": "IQ4414 Quad"
  },
  {
    "Retail Branding": "Fly",
    "Marketing Name": "F22 Star",
    "Device": "F22_star",
    "Model": "F22 star"
  },
  {
    "Retail Branding": "Fly",
    "Marketing Name": "FS402",
    "Device": "Stratus_2",
    "Model": "FS402"
  },
  {
    "Retail Branding": "Fly",
    "Marketing Name": "FS451",
    "Device": "Nimbus1",
    "Model": "FS451"
  },
  {
    "Retail Branding": "Fly",
    "Marketing Name": "FS502",
    "Device": "Cirrus_1",
    "Model": "FS502"
  },
  {
    "Retail Branding": "Fly",
    "Marketing Name": "Fly Life Play",
    "Device": "LifePlay",
    "Model": "Life Play"
  },
  {
    "Retail Branding": "Fly",
    "Marketing Name": "Fly View Max",
    "Device": "ViewMax",
    "Model": "View Max"
  },
  {
    "Retail Branding": "Fly",
    "Marketing Name": "Flylife Connect 10.1",
    "Device": "Flylife_Connect_101_3G_2",
    "Model": "Flylife Connect 10.1 3G 2"
  },
  {
    "Retail Branding": "Fly",
    "Marketing Name": "Flylife Connect 7 3G 2",
    "Device": "Flylife7",
    "Model": "Flylife Connect 7 3G 2"
  },
  {
    "Retail Branding": "Fly",
    "Marketing Name": "Flylife Connect 7.85 3G 2",
    "Device": "Flylife",
    "Model": "Flylife Connect 7.85 3G 2"
  },
  {
    "Retail Branding": "Fly",
    "Marketing Name": "IQ434",
    "Device": "IQ434",
    "Model": "IQ434"
  },
  {
    "Retail Branding": "Fly",
    "Marketing Name": "IQ4401",
    "Device": "IQ4401",
    "Model": "IQ4401"
  },
  {
    "Retail Branding": "Fly",
    "Marketing Name": "IQ4409 Quad",
    "Device": "IQ4409_Quad",
    "Model": "IQ4409 Quad"
  },
  {
    "Retail Branding": "Fly",
    "Marketing Name": "IQ4413 Quad",
    "Device": "IQ4413_Quad",
    "Model": "IQ4413_Quad"
  },
  {
    "Retail Branding": "Fly",
    "Marketing Name": "IQ4415",
    "Device": "IQ4415",
    "Model": "IQ4415"
  },
  {
    "Retail Branding": "Fly",
    "Marketing Name": "IQ4416",
    "Device": "IQ4416",
    "Model": "IQ4416"
  },
  {
    "Retail Branding": "Fly",
    "Marketing Name": "IQ4417 Quad",
    "Device": "IQ4417_Quad",
    "Model": "IQ4417 Quad"
  },
  {
    "Retail Branding": "Fly",
    "Marketing Name": "IQ4418",
    "Device": "IQ4418",
    "Model": "Fly IQ4418 AF"
  },
  {
    "Retail Branding": "Fly",
    "Marketing Name": "IQ4418",
    "Device": "IQ4418",
    "Model": "IQ4418"
  },
  {
    "Retail Branding": "Fly",
    "Marketing Name": "IQ4420 Quad",
    "Device": "IQ4420_Quad",
    "Model": "IQ4420 Quad"
  },
  {
    "Retail Branding": "Fly",
    "Marketing Name": "IQ4421 Quad",
    "Device": "IQ4421_Quad",
    "Model": "IQ4421 Quad"
  },
  {
    "Retail Branding": "Fly",
    "Marketing Name": "IQ4490i",
    "Device": "IQ4490i",
    "Model": "IQ4490i"
  },
  {
    "Retail Branding": "Fly",
    "Marketing Name": "IQ4503",
    "Device": "IQ4503",
    "Model": "FLY IQ4503"
  },
  {
    "Retail Branding": "Fly",
    "Marketing Name": "IQ4503 Quad",
    "Device": "IQ4503_Quad",
    "Model": "IQ4503 Quad"
  },
  {
    "Retail Branding": "Fly",
    "Marketing Name": "IQ4504 Quad",
    "Device": "IQ4504_Quad",
    "Model": "IQ4504 Quad"
  },
  {
    "Retail Branding": "Fly",
    "Marketing Name": "IQ4505",
    "Device": "IQ4505",
    "Model": "Fly IQ4505"
  },
  {
    "Retail Branding": "Fly",
    "Marketing Name": "IQ4505 Quad",
    "Device": "IQ4505_Quad",
    "Model": "IQ4505 Quad"
  },
  {
    "Retail Branding": "Fly",
    "Marketing Name": "IQ4509",
    "Device": "IQ4509",
    "Model": "IQ4509"
  },
  {
    "Retail Branding": "Fly",
    "Marketing Name": "IQ4512 Quad",
    "Device": "IQ4512_Quad",
    "Model": "IQ4512 Quad"
  },
  {
    "Retail Branding": "Fly",
    "Marketing Name": "IQ4513",
    "Device": "IQ4513",
    "Model": "IQ4513"
  },
  {
    "Retail Branding": "Fly",
    "Marketing Name": "IQ4513 Octa",
    "Device": "IQ4513_Octa",
    "Model": "IQ4513 Octa"
  },
  {
    "Retail Branding": "Fly",
    "Marketing Name": "IQ4514 Quad",
    "Device": "IQ4514_Quad",
    "Model": "Fly IQ4514"
  },
  {
    "Retail Branding": "Fly",
    "Marketing Name": "IQ4514 Quad",
    "Device": "IQ4514_Quad",
    "Model": "Fly IQ4514 AF"
  },
  {
    "Retail Branding": "Fly",
    "Marketing Name": "IQ4514 Quad",
    "Device": "IQ4514_Quad",
    "Model": "IQ4514 Quad"
  },
  {
    "Retail Branding": "Fly",
    "Marketing Name": "IQ4515 Quad",
    "Device": "IQ4515_Quad",
    "Model": "IQ4515 Quad"
  },
  {
    "Retail Branding": "Fly",
    "Marketing Name": "IQ4516 Octa",
    "Device": "IQ4516_Octa",
    "Model": "IQ4516"
  },
  {
    "Retail Branding": "Fly",
    "Marketing Name": "IQ4516 Octa",
    "Device": "IQ4516_Octa",
    "Model": "IQ4516 Octa"
  },
  {
    "Retail Branding": "Fly",
    "Marketing Name": "IQ4551",
    "Device": "Epic_Note",
    "Model": "IQ4551"
  },
  {
    "Retail Branding": "Fly",
    "Marketing Name": "IQ458 Quad Evo Tech 2",
    "Device": "IQ458",
    "Model": "IQ458 Quad"
  },
  {
    "Retail Branding": "Fly",
    "Marketing Name": "IQ4601",
    "Device": "IQ4601",
    "Model": "IQ4601"
  },
  {
    "Retail Branding": "Fly",
    "Marketing Name": "IQ4602",
    "Device": "Fly_IQ4602",
    "Model": "Fly IQ4602"
  },
  {
    "Retail Branding": "Fly",
    "Marketing Name": "IQ4602",
    "Device": "IQ4602_Quad",
    "Model": "IQ4602 Quad"
  },
  {
    "Retail Branding": "Fly",
    "Marketing Name": "Iris",
    "Device": "FLY_IQ4400",
    "Model": "FLY_IQ4400_AF"
  },
  {
    "Retail Branding": "Fly",
    "Marketing Name": "Knockout",
    "Device": "Knockout",
    "Model": "FS524"
  },
  {
    "Retail Branding": "Fly",
    "Marketing Name": "Life Compact",
    "Device": "Life_Compact",
    "Model": "Compact"
  },
  {
    "Retail Branding": "Fly",
    "Marketing Name": "Life Geo",
    "Device": "LifeGeo",
    "Model": "Life Geo"
  },
  {
    "Retail Branding": "Fly",
    "Marketing Name": "Life Jet",
    "Device": "LifeJet",
    "Model": "Life Jet"
  },
  {
    "Retail Branding": "Fly",
    "Marketing Name": "Life Mega",
    "Device": "Life_Mega",
    "Model": "Mega"
  },
  {
    "Retail Branding": "Fly",
    "Marketing Name": "Life Vista",
    "Device": "Life_Vista",
    "Model": "Vista"
  },
  {
    "Retail Branding": "Fly",
    "Marketing Name": "Life Zen",
    "Device": "LifeZen",
    "Model": "Life Zen"
  },
  {
    "Retail Branding": "Fly",
    "Marketing Name": "Memory Plus",
    "Device": "Memory_Plus",
    "Model": "FS528"
  },
  {
    "Retail Branding": "Fly",
    "Marketing Name": "Nimbus 10",
    "Device": "Nimbus_10",
    "Model": "FS512"
  },
  {
    "Retail Branding": "Fly",
    "Marketing Name": "Nimbus 11",
    "Device": "Nimbus_11",
    "Model": "FS455"
  },
  {
    "Retail Branding": "Fly",
    "Marketing Name": "Nimbus 12",
    "Device": "Nimbus_12",
    "Model": "FS510"
  },
  {
    "Retail Branding": "Fly",
    "Marketing Name": "Nimbus 14",
    "Device": "Nimbus_14",
    "Model": "FS456"
  },
  {
    "Retail Branding": "Fly",
    "Marketing Name": "Nimbus 15",
    "Device": "Nimbus_15",
    "Model": "FS457"
  },
  {
    "Retail Branding": "Fly",
    "Marketing Name": "Nimbus 16",
    "Device": "Nimbus_16",
    "Model": "FS459"
  },
  {
    "Retail Branding": "Fly",
    "Marketing Name": "Nimbus 17",
    "Device": "Nimbus_17",
    "Model": "FS527"
  },
  {
    "Retail Branding": "Fly",
    "Marketing Name": "Nimbus 2",
    "Device": "Nimbus_2",
    "Model": "FS452"
  },
  {
    "Retail Branding": "Fly",
    "Marketing Name": "Nimbus 4",
    "Device": "Nimbus_4",
    "Model": "FS551"
  },
  {
    "Retail Branding": "Fly",
    "Marketing Name": "Nimbus 7",
    "Device": "Nimbus_7",
    "Model": "FS505"
  },
  {
    "Retail Branding": "Fly",
    "Marketing Name": "Nimbus 8",
    "Device": "Nimbus_8",
    "Model": "FS454"
  },
  {
    "Retail Branding": "Fly",
    "Marketing Name": "Nimbus 9",
    "Device": "Nimbus_9",
    "Model": "Nimbus 9"
  },
  {
    "Retail Branding": "Fly",
    "Marketing Name": "Nimbus3",
    "Device": "Nimbus3",
    "Model": "FS501"
  },
  {
    "Retail Branding": "Fly",
    "Marketing Name": "Phoenix 2",
    "Device": "IQ4410i",
    "Model": "Phoenix 2"
  },
  {
    "Retail Branding": "Fly",
    "Marketing Name": "Photo Pro",
    "Device": "Photo_Pro",
    "Model": "Photo Pro"
  },
  {
    "Retail Branding": "Fly",
    "Marketing Name": "Power Plus 1",
    "Device": "Power_Plus_1",
    "Model": "FS521"
  },
  {
    "Retail Branding": "Fly",
    "Marketing Name": "Power Plus 2",
    "Device": "Power_Plus_2",
    "Model": "FS526"
  },
  {
    "Retail Branding": "Fly",
    "Marketing Name": "Power Plus 3",
    "Device": "PowerPlus3",
    "Model": "Power Plus 3"
  },
  {
    "Retail Branding": "Fly",
    "Marketing Name": "Power Plus FHD",
    "Device": "Power_Plus_FHD",
    "Model": "FS554"
  },
  {
    "Retail Branding": "Fly",
    "Marketing Name": "Power Plus XXL",
    "Device": "Power_Plus_XXL",
    "Model": "FS530"
  },
  {
    "Retail Branding": "Fly",
    "Marketing Name": "Selfie 1",
    "Device": "Selfie_1",
    "Model": "FS520"
  },
  {
    "Retail Branding": "Fly",
    "Marketing Name": "Slimline",
    "Device": "Slimline",
    "Model": "Slimline"
  },
  {
    "Retail Branding": "Fly",
    "Marketing Name": "Stratus",
    "Device": "Stratus_6",
    "Model": "FS407"
  },
  {
    "Retail Branding": "Fly",
    "Marketing Name": "Stratus 1",
    "Device": "Stratus1",
    "Model": "FS401"
  },
  {
    "Retail Branding": "Fly",
    "Marketing Name": "Stratus 3",
    "Device": "Stratus_3",
    "Model": "FS404"
  },
  {
    "Retail Branding": "Fly",
    "Marketing Name": "Stratus 4",
    "Device": "Stratus_4",
    "Model": "FS405"
  },
  {
    "Retail Branding": "Fly",
    "Marketing Name": "Stratus 5",
    "Device": "Stratus_5",
    "Model": "FS406"
  },
  {
    "Retail Branding": "Fly",
    "Marketing Name": "Stratus 7",
    "Device": "Stratus_7",
    "Model": "FS458"
  },
  {
    "Retail Branding": "Fly",
    "Marketing Name": "Stratus 8",
    "Device": "Stratus_8",
    "Model": "FS408"
  },
  {
    "Retail Branding": "Fly",
    "Marketing Name": "Stratus 9",
    "Device": "Stratus_9",
    "Model": "FS409"
  },
  {
    "Retail Branding": "Fly",
    "Marketing Name": "Tornado One",
    "Device": "IQ4511_Octa",
    "Model": "FLY IQ4511"
  },
  {
    "Retail Branding": "Fly",
    "Marketing Name": "Tornado One",
    "Device": "IQ4511_Octa",
    "Model": "IQ4511 Octa"
  },
  {
    "Retail Branding": "Fly",
    "Marketing Name": "Tornado One",
    "Device": "IQ4511_Octa",
    "Model": "IQ4511 TR"
  },
  {
    "Retail Branding": "Fly",
    "Marketing Name": "View",
    "Device": "View",
    "Model": "View"
  },
  {
    "Retail Branding": "Fly_Tech",
    "Marketing Name": "T101",
    "Device": "T101",
    "Model": "T101"
  },
  {
    "Retail Branding": "Fobem",
    "Marketing Name": "2K SMART TV",
    "Device": "nagata",
    "Model": "Fobem 2K SMART TV"
  },
  {
    "Retail Branding": "Fobem",
    "Marketing Name": "Fobem 4K SMART TV",
    "Device": "marina",
    "Model": "Fobem 4K SMART TV"
  },
  {
    "Retail Branding": "FollowMe",
    "Marketing Name": "PM01",
    "Device": "PM01",
    "Model": "27PM01"
  },
  {
    "Retail Branding": "Fone Haus",
    "Marketing Name": "Blaze",
    "Device": "Blaze",
    "Model": "Blaze"
  },
  {
    "Retail Branding": "Fone Haus",
    "Marketing Name": "Bolt",
    "Device": "Bolt",
    "Model": "Bolt"
  },
  {
    "Retail Branding": "Fone Haus",
    "Marketing Name": "CoolminttTribe",
    "Device": "CoolMinttTribe",
    "Model": "CoolMinttTribe"
  },
  {
    "Retail Branding": "Fonos",
    "Marketing Name": "FONOS O2",
    "Device": "O2",
    "Model": "O2"
  },
  {
    "Retail Branding": "Fonos",
    "Marketing Name": "M1",
    "Device": "M1",
    "Model": "M1"
  },
  {
    "Retail Branding": "Fonos",
    "Marketing Name": "O3_EEA",
    "Device": "O3",
    "Model": "O3"
  },
  {
    "Retail Branding": "Ford",
    "Marketing Name": "Omni 8",
    "Device": "Omni8",
    "Model": "Omni8"
  },
  {
    "Retail Branding": "Formovie",
    "Marketing Name": "Formovie Cinema Edge Laser Projector",
    "Device": "koroli",
    "Model": "Formovie Google TV"
  },
  {
    "Retail Branding": "Formovie",
    "Marketing Name": "Formovie Theater Premium Laser TV",
    "Device": "koroli",
    "Model": "L206FGN-X2"
  },
  {
    "Retail Branding": "Formovie",
    "Marketing Name": "Theater Laser Projector",
    "Device": "hanlla",
    "Model": "Formovie Laser 4K projector"
  },
  {
    "Retail Branding": "Formuler",
    "Marketing Name": "GTV",
    "Device": "GTV",
    "Model": "GTV"
  },
  {
    "Retail Branding": "Fortus",
    "Marketing Name": "PayTab_PT10",
    "Device": "PayTab_PT10",
    "Model": "PayTab_PT10"
  },
  {
    "Retail Branding": "Foryoudigital",
    "Marketing Name": "IWB_FYD_F",
    "Device": "IWB_FYD_F",
    "Model": "IWB_FYD_F"
  },
  {
    "Retail Branding": "Fossil",
    "Marketing Name": "Fossil Gen 5 LTE",
    "Device": "gila",
    "Model": "Fossil G5L"
  },
  {
    "Retail Branding": "Fossil",
    "Marketing Name": "Fossil Gen 5 LTE",
    "Device": "gila",
    "Model": "Fossil Gen 5 LTE"
  },
  {
    "Retail Branding": "Fossil",
    "Marketing Name": "Fossil Gen 5e",
    "Device": "sole",
    "Model": "Fossil 5e"
  },
  {
    "Retail Branding": "Fossil",
    "Marketing Name": "Fossil Gen 5e",
    "Device": "sole",
    "Model": "Fossil SS"
  },
  {
    "Retail Branding": "Fossil",
    "Marketing Name": "Fossil Gen 6",
    "Device": "hoki",
    "Model": "Fossil Gen 6"
  },
  {
    "Retail Branding": "Fossil",
    "Marketing Name": "Fossil Gen 6",
    "Device": "hoki",
    "Model": "Fossil Gen 6 Venture Edition"
  },
  {
    "Retail Branding": "Fossil",
    "Marketing Name": "Fossil Gen 6",
    "Device": "hoki",
    "Model": "Gen 6 Wellness"
  },
  {
    "Retail Branding": "Fossil",
    "Marketing Name": "Fossil Gen 6",
    "Device": "hoki",
    "Model": "Gen 6 Wellness Edition"
  },
  {
    "Retail Branding": "Fossil",
    "Marketing Name": "Fossil Sport",
    "Device": "darter",
    "Model": "Fadelite"
  },
  {
    "Retail Branding": "Fossil",
    "Marketing Name": "Fossil Sport",
    "Device": "darter",
    "Model": "Hugo"
  },
  {
    "Retail Branding": "Fossil",
    "Marketing Name": "Fossil Sport",
    "Device": "darter",
    "Model": "MK Go"
  },
  {
    "Retail Branding": "Fossil",
    "Marketing Name": "Fossil Sport",
    "Device": "darter",
    "Model": "MKGO"
  },
  {
    "Retail Branding": "Fossil",
    "Marketing Name": "Fossil Sport",
    "Device": "darter",
    "Model": "PumaSmartwatch"
  },
  {
    "Retail Branding": "Fossil",
    "Marketing Name": "Fossil Sport",
    "Device": "darter",
    "Model": "Q Sport 41"
  },
  {
    "Retail Branding": "Fossil",
    "Marketing Name": "Fossil Sport",
    "Device": "darter",
    "Model": "Q Sport 43"
  },
  {
    "Retail Branding": "Fossil",
    "Marketing Name": "Fossil Sport",
    "Device": "darter",
    "Model": "Vapor X"
  },
  {
    "Retail Branding": "Fossil",
    "Marketing Name": "Q Founder",
    "Device": "grant",
    "Model": "Q Founder"
  },
  {
    "Retail Branding": "Fossil",
    "Marketing Name": "Q Wander / Q Marshal / Q Founder 2.0 / Bradshaw / Dylan",
    "Device": "gar",
    "Model": "Bradshaw"
  },
  {
    "Retail Branding": "Fossil",
    "Marketing Name": "Q Wander / Q Marshal / Q Founder 2.0 / Bradshaw / Dylan",
    "Device": "gar",
    "Model": "Q Marshal"
  },
  {
    "Retail Branding": "Fossil",
    "Marketing Name": "Q Wander / Q Marshal / Q Founder 2.0 / Bradshaw / Dylan",
    "Device": "gar",
    "Model": "Q Wander"
  },
  {
    "Retail Branding": "Fossil",
    "Marketing Name": "Wear",
    "Device": "bluegill",
    "Model": "Alberto"
  },
  {
    "Retail Branding": "Fossil",
    "Marketing Name": "Wear",
    "Device": "bluegill",
    "Model": "EA Connected"
  },
  {
    "Retail Branding": "Fossil",
    "Marketing Name": "Wear",
    "Device": "bluegill",
    "Model": "Grayson"
  },
  {
    "Retail Branding": "Fossil",
    "Marketing Name": "Wear",
    "Device": "firefish",
    "Model": "AX Connected"
  },
  {
    "Retail Branding": "Fossil",
    "Marketing Name": "Wear",
    "Device": "firefish",
    "Model": "Q Explorist HR"
  },
  {
    "Retail Branding": "Fossil",
    "Marketing Name": "Wear",
    "Device": "firefish",
    "Model": "Vapor 2"
  },
  {
    "Retail Branding": "Fossil",
    "Marketing Name": "Wear",
    "Device": "mullet",
    "Model": "Vapor"
  },
  {
    "Retail Branding": "Fossil",
    "Marketing Name": "Wear",
    "Device": "ray",
    "Model": "EA Connected"
  },
  {
    "Retail Branding": "Fossil",
    "Marketing Name": "Wear",
    "Device": "ray",
    "Model": "Q Venture HR"
  },
  {
    "Retail Branding": "Fossil",
    "Marketing Name": "Wear",
    "Device": "ray",
    "Model": "Runway"
  },
  {
    "Retail Branding": "Fossil",
    "Marketing Name": "Wear",
    "Device": "ray",
    "Model": "scallop"
  },
  {
    "Retail Branding": "Fossil",
    "Marketing Name": "Wear",
    "Device": "shiner",
    "Model": "Riley Touch"
  },
  {
    "Retail Branding": "Fossil",
    "Marketing Name": "Wear",
    "Device": "shiner",
    "Model": "Riley Touchscreen"
  },
  {
    "Retail Branding": "Fossil",
    "Marketing Name": "Wear",
    "Device": "shiner",
    "Model": "Sofie"
  },
  {
    "Retail Branding": "Fossil",
    "Marketing Name": "Wear OS",
    "Device": "mullet",
    "Model": "Vapor"
  },
  {
    "Retail Branding": "Fossil",
    "Marketing Name": "Wear OS by Google Smartwatch",
    "Device": "triggerfish",
    "Model": "Julianna HR"
  },
  {
    "Retail Branding": "Fossil",
    "Marketing Name": "Wear OS by Google Smartwatch",
    "Device": "triggerfish",
    "Model": "Lexington 2"
  },
  {
    "Retail Branding": "Four Mobile",
    "Marketing Name": "S186_Sky_3",
    "Device": "S186_Sky_3",
    "Model": "S186_Sky_3"
  },
  {
    "Retail Branding": "Four Mobile",
    "Marketing Name": "S62_Eco_3",
    "Device": "S62_Eco_3",
    "Model": "S62_Eco_3"
  },
  {
    "Retail Branding": "Four Mobile",
    "Marketing Name": "S710 Ruby",
    "Device": "S710_Ruby",
    "Model": "S710 Ruby"
  },
  {
    "Retail Branding": "Four Mobile",
    "Marketing Name": "Sapphire",
    "Device": "S750",
    "Model": "Sapphire"
  },
  {
    "Retail Branding": "Four Mobile",
    "Marketing Name": "Thunder",
    "Device": "S350",
    "Model": "Thunder"
  },
  {
    "Retail Branding": "Fox_and_Sheep",
    "Marketing Name": "Kidstablet1",
    "Device": "Kidstablet1",
    "Model": "Kidstablet_231"
  },
  {
    "Retail Branding": "Fox_and_Sheep",
    "Marketing Name": "KidstabletOne",
    "Device": "KidstabletOne",
    "Model": "KidstabletOne"
  },
  {
    "Retail Branding": "Foxconn",
    "Marketing Name": "",
    "Device": "A1",
    "Model": "MUCHTEL A1"
  },
  {
    "Retail Branding": "Foxconn",
    "Marketing Name": "",
    "Device": "A800",
    "Model": "WellcoM-A800"
  },
  {
    "Retail Branding": "Foxconn",
    "Marketing Name": "",
    "Device": "Boston",
    "Model": "Boston"
  },
  {
    "Retail Branding": "Foxconn",
    "Marketing Name": "",
    "Device": "Boston",
    "Model": "Orange_Boston"
  },
  {
    "Retail Branding": "Foxconn",
    "Marketing Name": "",
    "Device": "FE6",
    "Model": "FE6"
  },
  {
    "Retail Branding": "Foxconn",
    "Marketing Name": "",
    "Device": "G1305",
    "Model": "GSmart-G1305"
  },
  {
    "Retail Branding": "Foxconn",
    "Marketing Name": "",
    "Device": "K2",
    "Model": "E120"
  },
  {
    "Retail Branding": "Foxconn",
    "Marketing Name": "",
    "Device": "K3",
    "Model": "E130"
  },
  {
    "Retail Branding": "Foxconn",
    "Marketing Name": "",
    "Device": "SF4Y6",
    "Model": "SF4Y6"
  },
  {
    "Retail Branding": "Foxconn",
    "Marketing Name": "",
    "Device": "a1",
    "Model": "Rstream-A1"
  },
  {
    "Retail Branding": "Foxconn",
    "Marketing Name": "",
    "Device": "a800",
    "Model": "WellcoM-A800"
  },
  {
    "Retail Branding": "Foxconn",
    "Marketing Name": "",
    "Device": "a89",
    "Model": "WellcoM-A89"
  },
  {
    "Retail Branding": "Foxconn",
    "Marketing Name": "",
    "Device": "a99",
    "Model": "WellcoM-A99"
  },
  {
    "Retail Branding": "Foxconn",
    "Marketing Name": "",
    "Device": "axioo",
    "Model": "PICOpad-QGN"
  },
  {
    "Retail Branding": "Foxconn",
    "Marketing Name": "",
    "Device": "fb0",
    "Model": "FIH-FB0"
  },
  {
    "Retail Branding": "Foxconn",
    "Marketing Name": "",
    "Device": "fm600",
    "Model": "Camangi-FM600"
  },
  {
    "Retail Branding": "Foxconn",
    "Marketing Name": "",
    "Device": "hd710",
    "Model": "Commtiva-HD710"
  },
  {
    "Retail Branding": "Foxconn",
    "Marketing Name": "",
    "Device": "m500",
    "Model": "MUSN-M500"
  },
  {
    "Retail Branding": "Foxconn",
    "Marketing Name": "",
    "Device": "magnumhd",
    "Model": "cherry-MagnumHD"
  },
  {
    "Retail Branding": "Foxconn",
    "Marketing Name": "",
    "Device": "mangrove7",
    "Model": "Camangi-Mangrove7"
  },
  {
    "Retail Branding": "Foxconn",
    "Marketing Name": "",
    "Device": "mi410",
    "Model": "CSL-MI410"
  },
  {
    "Retail Branding": "Foxconn",
    "Marketing Name": "",
    "Device": "msm7627_surf",
    "Model": "EV-S110"
  },
  {
    "Retail Branding": "Foxconn",
    "Marketing Name": "",
    "Device": "msm7627_surf",
    "Model": "FIH-F0X"
  },
  {
    "Retail Branding": "Foxconn",
    "Marketing Name": "",
    "Device": "msm7627_surf",
    "Model": "FIH-FM6"
  },
  {
    "Retail Branding": "Foxconn",
    "Marketing Name": "",
    "Device": "msm7627_surf",
    "Model": "KT-F100"
  },
  {
    "Retail Branding": "Foxconn",
    "Marketing Name": "",
    "Device": "msm7627_surf",
    "Model": "KT-S110"
  },
  {
    "Retail Branding": "Foxconn",
    "Marketing Name": "",
    "Device": "muchtela2",
    "Model": "MUCHTEL-A2"
  },
  {
    "Retail Branding": "Foxconn",
    "Marketing Name": "",
    "Device": "musn-t800",
    "Model": "Cherry-MUSN-T800"
  },
  {
    "Retail Branding": "Foxconn",
    "Marketing Name": "",
    "Device": "superion",
    "Model": "cherry mobile-SUPERION"
  },
  {
    "Retail Branding": "Foxconn",
    "Marketing Name": "",
    "Device": "t800",
    "Model": "MUSN-T800"
  },
  {
    "Retail Branding": "Foxconn",
    "Marketing Name": "",
    "Device": "vigo410",
    "Model": "Axioo-VIGO410"
  },
  {
    "Retail Branding": "Foxconn",
    "Marketing Name": "",
    "Device": "vt100",
    "Model": "V-T100"
  },
  {
    "Retail Branding": "Foxconn",
    "Marketing Name": "A5",
    "Device": "A5",
    "Model": "A5"
  },
  {
    "Retail Branding": "Foxconn",
    "Marketing Name": "CSL Spice MI700",
    "Device": "mi700",
    "Model": "CSL_Spice_MI700"
  },
  {
    "Retail Branding": "Foxconn",
    "Marketing Name": "CSL Spice MI700",
    "Device": "mi700",
    "Model": "Spice_MI700"
  },
  {
    "Retail Branding": "Foxconn",
    "Marketing Name": "Casper_VIA_A6108",
    "Device": "SI1",
    "Model": "Casper_VIA_A6108"
  },
  {
    "Retail Branding": "Foxconn",
    "Marketing Name": "Commtiva N700",
    "Device": "n700",
    "Model": "Commtiva-N700"
  },
  {
    "Retail Branding": "Foxconn",
    "Marketing Name": "Dolphin 70e Black",
    "Device": "dblack",
    "Model": "Dolphin 70e Black"
  },
  {
    "Retail Branding": "Foxconn",
    "Marketing Name": "InFocus IN260",
    "Device": "IN260",
    "Model": "IN260"
  },
  {
    "Retail Branding": "Foxconn",
    "Marketing Name": "MUSN COUPLE",
    "Device": "couple",
    "Model": "COUPLE"
  },
  {
    "Retail Branding": "Foxconn",
    "Marketing Name": "SH530U",
    "Device": "sh530u",
    "Model": "SH530U"
  },
  {
    "Retail Branding": "Foxconn",
    "Marketing Name": "SH930W",
    "Device": "FCN",
    "Model": "SH930W"
  },
  {
    "Retail Branding": "Foxconn",
    "Marketing Name": "SHARP  SH837W",
    "Device": "S1U",
    "Model": "SH837W"
  },
  {
    "Retail Branding": "Foxconn",
    "Marketing Name": "SHARP SH630E",
    "Device": "SAE",
    "Model": "SHP-SH630E"
  },
  {
    "Retail Branding": "Foxconn",
    "Marketing Name": "SHARP SH631W",
    "Device": "S2U",
    "Model": "SH631W"
  },
  {
    "Retail Branding": "Foxconn",
    "Marketing Name": "SHARP SH837W",
    "Device": "S1U",
    "Model": "SH837W"
  },
  {
    "Retail Branding": "Foxconn",
    "Marketing Name": "ViewPhone3",
    "Device": "viewphone3",
    "Model": "ViewPhone3"
  },
  {
    "Retail Branding": "Foxconn",
    "Marketing Name": "XOLO",
    "Device": "AZ510",
    "Model": "X900"
  },
  {
    "Retail Branding": "Foxconn",
    "Marketing Name": "XOLO_X1000",
    "Device": "SI1",
    "Model": "XOLO_X1000"
  },
  {
    "Retail Branding": "Foxconn",
    "Marketing Name": "vizio VP700",
    "Device": "S1U",
    "Model": "VP700"
  },
  {
    "Retail Branding": "Foxconn",
    "Marketing Name": "vizio VP800",
    "Device": "FCN",
    "Model": "VP800"
  },
  {
    "Retail Branding": "Foxtel",
    "Marketing Name": "Foxtel Now box",
    "Device": "dwt765fxt",
    "Model": "Foxtel Now box"
  },
  {
    "Retail Branding": "Free",
    "Marketing Name": "Free_Liberty_Plus",
    "Device": "Free_Liberty_Plus",
    "Model": "Free_Liberty_Plus"
  },
  {
    "Retail Branding": "Free",
    "Marketing Name": "Liberty",
    "Device": "Liberty",
    "Model": "Liberty"
  },
  {
    "Retail Branding": "Free",
    "Marketing Name": "Liberty 4G",
    "Device": "Liberty_4G",
    "Model": "Liberty 4G"
  },
  {
    "Retail Branding": "Free Vision",
    "Marketing Name": "FR-CK718",
    "Device": "FR-CK718",
    "Model": "FR-CK718"
  },
  {
    "Retail Branding": "FreeYond",
    "Marketing Name": "F9",
    "Device": "F9",
    "Model": "F9"
  },
  {
    "Retail Branding": "FreeYond",
    "Marketing Name": "F9S",
    "Device": "F9S",
    "Model": "2306004M"
  },
  {
    "Retail Branding": "FreeYond",
    "Marketing Name": "F9S",
    "Device": "F9S",
    "Model": "F9S"
  },
  {
    "Retail Branding": "FreeYond",
    "Marketing Name": "F9S",
    "Device": "F9S_EEA",
    "Model": "F9S"
  },
  {
    "Retail Branding": "FreeYond",
    "Marketing Name": "FreeYondA5",
    "Device": "FreeYondA5",
    "Model": "A5"
  },
  {
    "Retail Branding": "FreeYond",
    "Marketing Name": "FreeYondA5_RU",
    "Device": "FreeYondA5",
    "Model": "A5"
  },
  {
    "Retail Branding": "FreeYond",
    "Marketing Name": "FreeYondP6",
    "Device": "FreeYondP6",
    "Model": "FreeYond P6"
  },
  {
    "Retail Branding": "FreeYond",
    "Marketing Name": "FreeYondP6",
    "Device": "FreeYondP6",
    "Model": "FreeYondP6"
  },
  {
    "Retail Branding": "FreeYond",
    "Marketing Name": "FreeYondP6",
    "Device": "FreeYondP6",
    "Model": "P6"
  },
  {
    "Retail Branding": "FreeYond",
    "Marketing Name": "FreeYondP6_RU",
    "Device": "FreeYondP6",
    "Model": "P6"
  },
  {
    "Retail Branding": "FreeYond",
    "Marketing Name": "M5",
    "Device": "M5",
    "Model": "M5"
  },
  {
    "Retail Branding": "FreeYond",
    "Marketing Name": "M5A",
    "Device": "M5A",
    "Model": "2305003M"
  },
  {
    "Retail Branding": "FreeYond",
    "Marketing Name": "M6",
    "Device": "M6",
    "Model": "2308005M"
  },
  {
    "Retail Branding": "Freebit",
    "Marketing Name": "A55J",
    "Device": "arima6735_65u_l1",
    "Model": "TONE m15"
  },
  {
    "Retail Branding": "Freebit",
    "Marketing Name": "TONE m15",
    "Device": "TONE_m15",
    "Model": "TONE m15"
  },
  {
    "Retail Branding": "Freebit",
    "Marketing Name": "Tone m15",
    "Device": "TONE_m15",
    "Model": "TONE m15"
  },
  {
    "Retail Branding": "Freebox",
    "Marketing Name": "Freebox Player POP",
    "Device": "fbx8am",
    "Model": "Freebox Player POP"
  },
  {
    "Retail Branding": "Freebox",
    "Marketing Name": "Mini 4K",
    "Device": "fbx6lc",
    "Model": "Freebox Player Mini"
  },
  {
    "Retail Branding": "Freebox",
    "Marketing Name": "Mini 4K",
    "Device": "fbx6lcv2",
    "Model": "Freebox Player Mini v2"
  },
  {
    "Retail Branding": "Freemobile",
    "Marketing Name": "FS500",
    "Device": "FS500",
    "Model": "FS500"
  },
  {
    "Retail Branding": "Freeski",
    "Marketing Name": "C109_EEA",
    "Device": "C109",
    "Model": "C109"
  },
  {
    "Retail Branding": "Freeski",
    "Marketing Name": "C12",
    "Device": "C12",
    "Model": "C12"
  },
  {
    "Retail Branding": "Freeski",
    "Marketing Name": "C12A",
    "Device": "C12",
    "Model": "C12"
  },
  {
    "Retail Branding": "Freeski",
    "Marketing Name": "C12A_EEA",
    "Device": "C12",
    "Model": "C12"
  },
  {
    "Retail Branding": "Freeski",
    "Marketing Name": "C12_EEA",
    "Device": "C12",
    "Model": "C12"
  },
  {
    "Retail Branding": "Freetel",
    "Marketing Name": "Cricket Wave",
    "Device": "Cricket_Wave",
    "Model": "FTU18A00"
  },
  {
    "Retail Branding": "Freetel",
    "Marketing Name": "FUN PLUS",
    "Device": "FUNPLUS",
    "Model": "FUN PLUS"
  },
  {
    "Retail Branding": "Freetel",
    "Marketing Name": "ICE2",
    "Device": "ICE2",
    "Model": "FTE161E"
  },
  {
    "Retail Branding": "Freetel",
    "Marketing Name": "ICE2plus",
    "Device": "ICE2plus",
    "Model": "FTE161G"
  },
  {
    "Retail Branding": "Freetel",
    "Marketing Name": "ICE3",
    "Device": "ICE3",
    "Model": "FTE171A"
  },
  {
    "Retail Branding": "Freetel",
    "Marketing Name": "Miyabi 2 Dual",
    "Device": "Miyabi2_Dual",
    "Model": "FTJ17B00"
  },
  {
    "Retail Branding": "Freetel",
    "Marketing Name": "Priori 5",
    "Device": "Priori5",
    "Model": "FTJ17C00"
  },
  {
    "Retail Branding": "Freetel",
    "Marketing Name": "Priori4",
    "Device": "Priori4",
    "Model": "FT162D"
  },
  {
    "Retail Branding": "Freetel",
    "Marketing Name": "Priori4",
    "Device": "Priori4",
    "Model": "FTJ162D"
  },
  {
    "Retail Branding": "Freetel",
    "Marketing Name": "RAIJIN",
    "Device": "RAIJIN",
    "Model": "FTJ162E"
  },
  {
    "Retail Branding": "Freetel",
    "Marketing Name": "SAKURA_FTE1",
    "Device": "SAKURA_FTE1",
    "Model": "SAKURA_FTE1"
  },
  {
    "Retail Branding": "Freetel",
    "Marketing Name": "SAMURAI REI",
    "Device": "FTJ161B",
    "Model": "FTJ161B"
  },
  {
    "Retail Branding": "Freetel",
    "Marketing Name": "SAMURAI REI 2",
    "Device": "SAMURAI_REI2",
    "Model": "FTJ17A00"
  },
  {
    "Retail Branding": "Frekuent",
    "Marketing Name": "Frekuent Spot Compact",
    "Device": "spotcompact",
    "Model": "FS-C1"
  },
  {
    "Retail Branding": "Frekuent",
    "Marketing Name": "Frekuent Spot Pro",
    "Device": "spotpro",
    "Model": "FS-P1"
  },
  {
    "Retail Branding": "Fresh",
    "Marketing Name": "Egypt",
    "Device": "tamachi",
    "Model": "Fresh FHD Android TV"
  },
  {
    "Retail Branding": "Fresh",
    "Marketing Name": "Egypt",
    "Device": "yeongdeungpo",
    "Model": "Fresh UHD Android TV"
  },
  {
    "Retail Branding": "Fresh",
    "Marketing Name": "FRESH SMART TV",
    "Device": "SW4H",
    "Model": "FRESH SMART TV"
  },
  {
    "Retail Branding": "Fresh",
    "Marketing Name": "FreshTV",
    "Device": "shinagawa",
    "Model": "FreshTV"
  },
  {
    "Retail Branding": "Fresh",
    "Marketing Name": "R3",
    "Device": "R3",
    "Model": "R3"
  },
  {
    "Retail Branding": "Fresh",
    "Marketing Name": "R3_GTV",
    "Device": "R3_GTV",
    "Model": "R3G"
  },
  {
    "Retail Branding": "Fresh",
    "Marketing Name": "R4",
    "Device": "R4",
    "Model": "R4"
  },
  {
    "Retail Branding": "Fresh",
    "Marketing Name": "Smart TV",
    "Device": "alimos",
    "Model": "FRESH GOOGLE TV"
  },
  {
    "Retail Branding": "Fresh",
    "Marketing Name": "Smart TV",
    "Device": "dangni",
    "Model": "FRESH GOOGLE TV"
  },
  {
    "Retail Branding": "Frunsi",
    "Marketing Name": "RubensTab_T11",
    "Device": "RubensTab_T11",
    "Model": "RubensTab_T11"
  },
  {
    "Retail Branding": "Frunsi",
    "Marketing Name": "RubensTab_T12",
    "Device": "RubensTab_T12",
    "Model": "RubensTab T12"
  },
  {
    "Retail Branding": "Frunsi",
    "Marketing Name": "RubensTab_T14",
    "Device": "RubensTab_T14",
    "Model": "RubensTab T14"
  },
  {
    "Retail Branding": "Frunsi",
    "Marketing Name": "RubensTab_T8",
    "Device": "RubensTab_T8",
    "Model": "T8"
  },
  {
    "Retail Branding": "Frunsi",
    "Marketing Name": "T11Pro",
    "Device": "T11Pro",
    "Model": "T11Pro"
  },
  {
    "Retail Branding": "Fujitsu",
    "Marketing Name": "801FJ",
    "Device": "SBM801FJ",
    "Model": "801FJ"
  },
  {
    "Retail Branding": "Fujitsu",
    "Marketing Name": "901FJ",
    "Device": "YM901FJ",
    "Model": "901FJ"
  },
  {
    "Retail Branding": "Fujitsu",
    "Marketing Name": "ARROWS A SoftBank 101F",
    "Device": "SBM101F",
    "Model": "101F"
  },
  {
    "Retail Branding": "Fujitsu",
    "Marketing Name": "ARROWS A SoftBank 201F",
    "Device": "SBM201F",
    "Model": "201F"
  },
  {
    "Retail Branding": "Fujitsu",
    "Marketing Name": "ARROWS A SoftBank 202F",
    "Device": "SBM202F",
    "Model": "202F"
  },
  {
    "Retail Branding": "Fujitsu",
    "Marketing Name": "ARROWS A SoftBank 301F",
    "Device": "SBM301F",
    "Model": "301F"
  },
  {
    "Retail Branding": "Fujitsu",
    "Marketing Name": "ARROWS ES IS12F",
    "Device": "FJI12",
    "Model": "IS12F"
  },
  {
    "Retail Branding": "Fujitsu",
    "Marketing Name": "ARROWS Kiss F-03D",
    "Device": "f11sky",
    "Model": "F-03D"
  },
  {
    "Retail Branding": "Fujitsu",
    "Marketing Name": "ARROWS Kiss F-03E",
    "Device": "F03E",
    "Model": "F-03E"
  },
  {
    "Retail Branding": "Fujitsu",
    "Marketing Name": "ARROWS M01",
    "Device": "M01",
    "Model": "M01"
  },
  {
    "Retail Branding": "Fujitsu",
    "Marketing Name": "ARROWS M305",
    "Device": "M305",
    "Model": "M305"
  },
  {
    "Retail Branding": "Fujitsu",
    "Marketing Name": "ARROWS M357",
    "Device": "M357",
    "Model": "M357"
  },
  {
    "Retail Branding": "Fujitsu",
    "Marketing Name": "ARROWS M555",
    "Device": "M555",
    "Model": "M555"
  },
  {
    "Retail Branding": "Fujitsu",
    "Marketing Name": "ARROWS M555",
    "Device": "M555SB",
    "Model": "M555"
  },
  {
    "Retail Branding": "Fujitsu",
    "Marketing Name": "ARROWS Me F-11D",
    "Device": "F11D",
    "Model": "F-11D"
  },
  {
    "Retail Branding": "Fujitsu",
    "Marketing Name": "ARROWS NX F-06E",
    "Device": "F06E",
    "Model": "F-06E"
  },
  {
    "Retail Branding": "Fujitsu",
    "Marketing Name": "ARROWS S EM01F",
    "Device": "EM01F",
    "Model": "EM01F"
  },
  {
    "Retail Branding": "Fujitsu",
    "Marketing Name": "ARROWS Tab F-05E",
    "Device": "F05E",
    "Model": "F-05E"
  },
  {
    "Retail Branding": "Fujitsu",
    "Marketing Name": "ARROWS Tab FJT21",
    "Device": "FJT21_jp_kdi",
    "Model": "FJT21"
  },
  {
    "Retail Branding": "Fujitsu",
    "Marketing Name": "ARROWS Tab LTE F-01D",
    "Device": "blaze_tablet",
    "Model": "F-01D"
  },
  {
    "Retail Branding": "Fujitsu",
    "Marketing Name": "ARROWS Tab Wi-Fi FAR70B",
    "Device": "FAR70B",
    "Model": "FAR70B"
  },
  {
    "Retail Branding": "Fujitsu",
    "Marketing Name": "ARROWS Tab Wi-Fi FAR75A/70A",
    "Device": "blaze_tablet",
    "Model": "FAR7"
  },
  {
    "Retail Branding": "Fujitsu",
    "Marketing Name": "ARROWS V F-04E",
    "Device": "F04E",
    "Model": "F-04E"
  },
  {
    "Retail Branding": "Fujitsu",
    "Marketing Name": "ARROWS X F-02E",
    "Device": "F02E",
    "Model": "F-02E"
  },
  {
    "Retail Branding": "Fujitsu",
    "Marketing Name": "ARROWS X F-10D",
    "Device": "F10D",
    "Model": "F-10D"
  },
  {
    "Retail Branding": "Fujitsu",
    "Marketing Name": "ARROWS X LTE F-05D",
    "Device": "blaze",
    "Model": "F-05D"
  },
  {
    "Retail Branding": "Fujitsu",
    "Marketing Name": "ARROWS Z FJL22",
    "Device": "FJL22_jp_kdi",
    "Model": "FJL22"
  },
  {
    "Retail Branding": "Fujitsu",
    "Marketing Name": "ARROWS Z ISW11F",
    "Device": "FJI11",
    "Model": "ISW11F"
  },
  {
    "Retail Branding": "Fujitsu",
    "Marketing Name": "ARROWS Z ISW13F",
    "Device": "FJI13",
    "Model": "ISW13F"
  },
  {
    "Retail Branding": "Fujitsu",
    "Marketing Name": "ARROWS ef FJL21",
    "Device": "FJL21",
    "Model": "FJL21"
  },
  {
    "Retail Branding": "Fujitsu",
    "Marketing Name": "ARROWS mu F-07D",
    "Device": "f11apo",
    "Model": "F-074"
  },
  {
    "Retail Branding": "Fujitsu",
    "Marketing Name": "ARROWS mu F-07D",
    "Device": "f11apo",
    "Model": "F-07D"
  },
  {
    "Retail Branding": "Fujitsu",
    "Marketing Name": "ARROWS mu F-07D",
    "Device": "f11apo",
    "Model": "FJJB091"
  },
  {
    "Retail Branding": "Fujitsu",
    "Marketing Name": "AW01",
    "Device": "AW01",
    "Model": "AW01"
  },
  {
    "Retail Branding": "Fujitsu",
    "Marketing Name": "AceReal One",
    "Device": "AceReal0100",
    "Model": "AceReal0100"
  },
  {
    "Retail Branding": "Fujitsu",
    "Marketing Name": "BZ01",
    "Device": "BZ01",
    "Model": "BZ01"
  },
  {
    "Retail Branding": "Fujitsu",
    "Marketing Name": "Disney Mobile on docomo F-07E",
    "Device": "F07E",
    "Model": "F-07E"
  },
  {
    "Retail Branding": "Fujitsu",
    "Marketing Name": "Disney Mobile on docomo F-08D",
    "Device": "blaze",
    "Model": "F-08D"
  },
  {
    "Retail Branding": "Fujitsu",
    "Marketing Name": "F-01F",
    "Device": "F01F",
    "Model": "F-01F"
  },
  {
    "Retail Branding": "Fujitsu",
    "Marketing Name": "F-01H",
    "Device": "F01H",
    "Model": "F-01H"
  },
  {
    "Retail Branding": "Fujitsu",
    "Marketing Name": "F-01J",
    "Device": "F01J",
    "Model": "F-01J"
  },
  {
    "Retail Branding": "Fujitsu",
    "Marketing Name": "F-01K",
    "Device": "F01K",
    "Model": "F-01K"
  },
  {
    "Retail Branding": "Fujitsu",
    "Marketing Name": "F-01L",
    "Device": "F01L",
    "Model": "F-01L"
  },
  {
    "Retail Branding": "Fujitsu",
    "Marketing Name": "F-02F",
    "Device": "F02F",
    "Model": "F-02F"
  },
  {
    "Retail Branding": "Fujitsu",
    "Marketing Name": "F-02G",
    "Device": "F02G",
    "Model": "F-02G"
  },
  {
    "Retail Branding": "Fujitsu",
    "Marketing Name": "F-02H",
    "Device": "F02H",
    "Model": "F-02H"
  },
  {
    "Retail Branding": "Fujitsu",
    "Marketing Name": "F-02K",
    "Device": "F02K",
    "Model": "F-02K"
  },
  {
    "Retail Branding": "Fujitsu",
    "Marketing Name": "F-02L",
    "Device": "F02L",
    "Model": "F-02L"
  },
  {
    "Retail Branding": "Fujitsu",
    "Marketing Name": "F-03F",
    "Device": "F03F",
    "Model": "F-03F"
  },
  {
    "Retail Branding": "Fujitsu",
    "Marketing Name": "F-03G",
    "Device": "F03G",
    "Model": "F-03G"
  },
  {
    "Retail Branding": "Fujitsu",
    "Marketing Name": "F-03H",
    "Device": "F03H",
    "Model": "F-03H"
  },
  {
    "Retail Branding": "Fujitsu",
    "Marketing Name": "F-03K",
    "Device": "F03K",
    "Model": "F-03K"
  },
  {
    "Retail Branding": "Fujitsu",
    "Marketing Name": "F-04F",
    "Device": "F04F",
    "Model": "F-04F"
  },
  {
    "Retail Branding": "Fujitsu",
    "Marketing Name": "F-04G",
    "Device": "F04G",
    "Model": "F-04G"
  },
  {
    "Retail Branding": "Fujitsu",
    "Marketing Name": "F-04H",
    "Device": "F04H",
    "Model": "F-04H"
  },
  {
    "Retail Branding": "Fujitsu",
    "Marketing Name": "F-04J",
    "Device": "F04J",
    "Model": "F-04J"
  },
  {
    "Retail Branding": "Fujitsu",
    "Marketing Name": "F-04K",
    "Device": "F04K",
    "Model": "F-04K"
  },
  {
    "Retail Branding": "Fujitsu",
    "Marketing Name": "F-05F",
    "Device": "F05F",
    "Model": "F-05F"
  },
  {
    "Retail Branding": "Fujitsu",
    "Marketing Name": "F-05G",
    "Device": "F05G",
    "Model": "F-05G"
  },
  {
    "Retail Branding": "Fujitsu",
    "Marketing Name": "F-05J",
    "Device": "F05J",
    "Model": "F-05J"
  },
  {
    "Retail Branding": "Fujitsu",
    "Marketing Name": "F-06F",
    "Device": "F06F",
    "Model": "F-06F"
  },
  {
    "Retail Branding": "Fujitsu",
    "Marketing Name": "F-09D ANTEPRIMA",
    "Device": "F09D",
    "Model": "F-09D"
  },
  {
    "Retail Branding": "Fujitsu",
    "Marketing Name": "F-09E",
    "Device": "F09E",
    "Model": "F-09E"
  },
  {
    "Retail Branding": "Fujitsu",
    "Marketing Name": "F-12C",
    "Device": "f11eif",
    "Model": "F-12C"
  },
  {
    "Retail Branding": "Fujitsu",
    "Marketing Name": "F-42A",
    "Device": "F42A",
    "Model": "F-42A"
  },
  {
    "Retail Branding": "Fujitsu",
    "Marketing Name": "F-51A",
    "Device": "F51A",
    "Model": "F-51A"
  },
  {
    "Retail Branding": "Fujitsu",
    "Marketing Name": "FARTM9334P1",
    "Device": "FARTM9334",
    "Model": "FARTM9334P1"
  },
  {
    "Retail Branding": "Fujitsu",
    "Marketing Name": "FARTM933KZ",
    "Device": "FARTM933KZ",
    "Model": "FARTM933KZ"
  },
  {
    "Retail Branding": "Fujitsu",
    "Marketing Name": "FARTMB611Y",
    "Device": "FARTMB611Y",
    "Model": "FARTMB611Y"
  },
  {
    "Retail Branding": "Fujitsu",
    "Marketing Name": "FHMD001",
    "Device": "FHMD001",
    "Model": "FHMD001"
  },
  {
    "Retail Branding": "Fujitsu",
    "Marketing Name": "FMP179R",
    "Device": "FMP179R",
    "Model": "FMP179R"
  },
  {
    "Retail Branding": "Fujitsu",
    "Marketing Name": "FMP181L",
    "Device": "FMP181L",
    "Model": "FMP181L"
  },
  {
    "Retail Branding": "Fujitsu",
    "Marketing Name": "INTERACTIVE_PANEL",
    "Device": "rk3588_t",
    "Model": "IWxx2_DX"
  },
  {
    "Retail Branding": "Fujitsu",
    "Marketing Name": "IWxx2_DXx",
    "Device": "oversea_v",
    "Model": "IWxx2_DXx"
  },
  {
    "Retail Branding": "Fujitsu",
    "Marketing Name": "IWxx2_Ultra",
    "Device": "oversea_v",
    "Model": "IWxx2_Ultra"
  },
  {
    "Retail Branding": "Fujitsu",
    "Marketing Name": "M02",
    "Device": "M02",
    "Model": "M02"
  },
  {
    "Retail Branding": "Fujitsu",
    "Marketing Name": "M305",
    "Device": "M305",
    "Model": "M305"
  },
  {
    "Retail Branding": "Fujitsu",
    "Marketing Name": "M305",
    "Device": "M305SB",
    "Model": "M305"
  },
  {
    "Retail Branding": "Fujitsu",
    "Marketing Name": "M359",
    "Device": "M359",
    "Model": "M359"
  },
  {
    "Retail Branding": "Fujitsu",
    "Marketing Name": "M363/P",
    "Device": "UY1",
    "Model": "M363/P"
  },
  {
    "Retail Branding": "Fujitsu",
    "Marketing Name": "M555",
    "Device": "M555",
    "Model": "M555"
  },
  {
    "Retail Branding": "Fujitsu",
    "Marketing Name": "Patio100",
    "Device": "Patio100",
    "Model": "Patio100"
  },
  {
    "Retail Branding": "Fujitsu",
    "Marketing Name": "Patio100",
    "Device": "Patio100_3G",
    "Model": "Patio100_3G"
  },
  {
    "Retail Branding": "Fujitsu",
    "Marketing Name": "Patio600",
    "Device": "Patio600",
    "Model": "Patio600"
  },
  {
    "Retail Branding": "Fujitsu",
    "Marketing Name": "Patio730",
    "Device": "Patio730",
    "Model": "Patio730"
  },
  {
    "Retail Branding": "Fujitsu",
    "Marketing Name": "REGZA Phone IS11T",
    "Device": "TSI11",
    "Model": "IS11T"
  },
  {
    "Retail Branding": "Fujitsu",
    "Marketing Name": "REGZA Phone T-01C",
    "Device": "tg03",
    "Model": "IS04"
  },
  {
    "Retail Branding": "Fujitsu",
    "Marketing Name": "REGZA Phone T-01C",
    "Device": "tg03",
    "Model": "T-01C"
  },
  {
    "Retail Branding": "Fujitsu",
    "Marketing Name": "REGZA Phone T-01D",
    "Device": "blaze",
    "Model": "T-01D"
  },
  {
    "Retail Branding": "Fujitsu",
    "Marketing Name": "REGZA Phone T-02D",
    "Device": "T02D",
    "Model": "T-02D"
  },
  {
    "Retail Branding": "Fujitsu",
    "Marketing Name": "RM02",
    "Device": "M02",
    "Model": "RM02"
  },
  {
    "Retail Branding": "Fujitsu",
    "Marketing Name": "Raku-Raku SMART PHONE F-12D",
    "Device": "F12D",
    "Model": "F-12D"
  },
  {
    "Retail Branding": "Fujitsu",
    "Marketing Name": "Raku-Raku SMART PHONE2 F-08E",
    "Device": "F08E",
    "Model": "F-08E"
  },
  {
    "Retail Branding": "Fujitsu",
    "Marketing Name": "STYLISTIC M350/CA2",
    "Device": "M350",
    "Model": "M350"
  },
  {
    "Retail Branding": "Fujitsu",
    "Marketing Name": "STYLISTIC M532",
    "Device": "mx532",
    "Model": "M532"
  },
  {
    "Retail Branding": "Fujitsu",
    "Marketing Name": "STYLISTIC M702",
    "Device": "M702",
    "Model": "M702"
  },
  {
    "Retail Branding": "Fujitsu",
    "Marketing Name": "STYLISTIC MH350",
    "Device": "MH350",
    "Model": "MH350"
  },
  {
    "Retail Branding": "Fujitsu",
    "Marketing Name": "STYLISTIC S01",
    "Device": "S01",
    "Model": "S01-orange"
  },
  {
    "Retail Branding": "Fujitsu",
    "Marketing Name": "SZJ-JS101",
    "Device": "SZJ101",
    "Model": "SZJ-JS101"
  },
  {
    "Retail Branding": "Fujitsu",
    "Marketing Name": "TM20",
    "Device": "STF",
    "Model": "TM20"
  },
  {
    "Retail Branding": "Fujitsu",
    "Marketing Name": "TONE m17",
    "Device": "TONEm17",
    "Model": "TONE-m17"
  },
  {
    "Retail Branding": "Fujitsu",
    "Marketing Name": "arrows Be4 F-41A",
    "Device": "F41A",
    "Model": "F-41A"
  },
  {
    "Retail Branding": "Fujitsu",
    "Marketing Name": "arrows M02",
    "Device": "M02",
    "Model": "M02"
  },
  {
    "Retail Branding": "Fujitsu",
    "Marketing Name": "arrows M03",
    "Device": "M03",
    "Model": "arrowsM03"
  },
  {
    "Retail Branding": "Fujitsu",
    "Marketing Name": "arrows M04",
    "Device": "M04",
    "Model": "arrowsM04"
  },
  {
    "Retail Branding": "Fujitsu",
    "Marketing Name": "arrows M04 PREMIUM",
    "Device": "M04P",
    "Model": "arrowsM04-PREMIUM"
  },
  {
    "Retail Branding": "Fujitsu",
    "Marketing Name": "arrows M05",
    "Device": "arrowsM05",
    "Model": "arrowsM05"
  },
  {
    "Retail Branding": "Fujitsu",
    "Marketing Name": "arrows NX9 F-52A",
    "Device": "F52A",
    "Model": "F-52A"
  },
  {
    "Retail Branding": "Fujitsu",
    "Marketing Name": "arrows RX",
    "Device": "arrowsRX",
    "Model": "arrowsRX"
  },
  {
    "Retail Branding": "Fujitsu",
    "Marketing Name": "arrows Tab M01T",
    "Device": "M01T",
    "Model": "M01T"
  },
  {
    "Retail Branding": "Funai Electric",
    "Marketing Name": "",
    "Device": "smdkv210",
    "Model": "ALM-001J"
  },
  {
    "Retail Branding": "Funai Electric",
    "Marketing Name": "FAS_K2150",
    "Device": "FAS_K2150",
    "Model": "FAS_K2150"
  },
  {
    "Retail Branding": "Funai Electric",
    "Marketing Name": "POE-SMB400-FN1",
    "Device": "daitou",
    "Model": "POE-SMB400-FN1"
  },
  {
    "Retail Branding": "Funai Electric",
    "Marketing Name": "Smart TV",
    "Device": "peach",
    "Model": "FUNAI 4K TV"
  },
  {
    "Retail Branding": "Funkwerk",
    "Marketing Name": "focX2",
    "Device": "focX2",
    "Model": "focX2"
  },
  {
    "Retail Branding": "Funkwerk",
    "Marketing Name": "focX2_Row",
    "Device": "focX2",
    "Model": "focX2_Row"
  },
  {
    "Retail Branding": "Fusion5",
    "Marketing Name": "F104Bv2",
    "Device": "F104Bv2",
    "Model": "F104Bv2"
  },
  {
    "Retail Branding": "Fusion5",
    "Marketing Name": "F104Bv2_EEA",
    "Device": "F104Bv2_EEA",
    "Model": "F104Bv2_EEA"
  },
  {
    "Retail Branding": "Fusion5",
    "Marketing Name": "F104Bv2_PRO",
    "Device": "F104Bv2_PRO",
    "Model": "F104Bv2_PRO"
  },
  {
    "Retail Branding": "Fusion5",
    "Marketing Name": "F104BvII_PRO",
    "Device": "F104BvII_PRO",
    "Model": "F104BvII_PRO"
  },
  {
    "Retail Branding": "Fusion5",
    "Marketing Name": "F104Ev2",
    "Device": "F104Ev2",
    "Model": "F104Ev2"
  },
  {
    "Retail Branding": "Fusion5",
    "Marketing Name": "F104Ev2_EEA",
    "Device": "F104Ev2_EEA",
    "Model": "F104Ev2_EEA"
  },
  {
    "Retail Branding": "Fusion5",
    "Marketing Name": "F104Ev2_PRO",
    "Device": "F104Ev2_PRO",
    "Model": "F104Ev2_PRO"
  },
  {
    "Retail Branding": "Fusion5",
    "Marketing Name": "F104Ev2_PRO_EEA",
    "Device": "F104Ev2_PRO_EEA",
    "Model": "F104Ev2_PRO_EEA"
  },
  {
    "Retail Branding": "Fusion5",
    "Marketing Name": "F104EvII",
    "Device": "F104EvII",
    "Model": "F104EvII"
  },
  {
    "Retail Branding": "Fusion5",
    "Marketing Name": "F104EvII_EEA",
    "Device": "F104EvII_EEA",
    "Model": "F104EvII_EEA"
  },
  {
    "Retail Branding": "Fusion5",
    "Marketing Name": "F104EvII_PRO",
    "Device": "F104EvII_PRO",
    "Model": "F104EvII_PRO"
  },
  {
    "Retail Branding": "Fusion5",
    "Marketing Name": "F104EvII_PRO_EEA",
    "Device": "F104EvII_PRO_EEA",
    "Model": "F104EvII_PRO_EEA"
  },
  {
    "Retail Branding": "Fusion5",
    "Marketing Name": "F105D_128",
    "Device": "F105D_128",
    "Model": "F105D_128"
  },
  {
    "Retail Branding": "Fusion5",
    "Marketing Name": "F105D_128GB",
    "Device": "F105D_128GB",
    "Model": "F105D_128GB"
  },
  {
    "Retail Branding": "Fusion5",
    "Marketing Name": "F105Dv2",
    "Device": "F105Dv2",
    "Model": "F105Dv2"
  },
  {
    "Retail Branding": "Fusion5",
    "Marketing Name": "F105DvII",
    "Device": "F105DvII",
    "Model": "F105DvII"
  },
  {
    "Retail Branding": "Fusion5",
    "Marketing Name": "F202_8G",
    "Device": "F202_8G",
    "Model": "F202_8G"
  },
  {
    "Retail Branding": "Fusion5",
    "Marketing Name": "F202_8G_EEA",
    "Device": "F202_8G_EEA",
    "Model": "F202_8G_EEA"
  },
  {
    "Retail Branding": "Fusion5",
    "Marketing Name": "F202_UK",
    "Device": "F202_UK",
    "Model": "F202_UK"
  },
  {
    "Retail Branding": "Fusion5",
    "Marketing Name": "F202_US",
    "Device": "F202_US",
    "Model": "F202_US"
  },
  {
    "Retail Branding": "Fusion5",
    "Marketing Name": "F202_v2_EEA",
    "Device": "F202_v2_EEA",
    "Model": "F202_v2_EEA"
  },
  {
    "Retail Branding": "Fusion5",
    "Marketing Name": "F704Bv2",
    "Device": "F704Bv2",
    "Model": "F704Bv2"
  },
  {
    "Retail Branding": "Fusion5",
    "Marketing Name": "F704Bv2_EEA",
    "Device": "F704Bv2_EEA",
    "Model": "F704Bv2_EEA"
  },
  {
    "Retail Branding": "Fusion5",
    "Marketing Name": "Fusion5",
    "Device": "Fusion5_F104B",
    "Model": "Fusion5_F104B"
  },
  {
    "Retail Branding": "Fusion5",
    "Marketing Name": "Fusion5",
    "Device": "W104Plus",
    "Model": "W104Plus"
  },
  {
    "Retail Branding": "Fusion5",
    "Marketing Name": "Fusion5_108",
    "Device": "Fusion5_108",
    "Model": "Fusion5_108"
  },
  {
    "Retail Branding": "Fusion5",
    "Marketing Name": "Fusion5_F104Bv2",
    "Device": "Fusion5_F104Bv2",
    "Model": "Fusion5_F104Bv2"
  },
  {
    "Retail Branding": "Fusion5",
    "Marketing Name": "Fusion5_F104E_EEA",
    "Device": "Fusion5_F104E",
    "Model": "Fusion5_F104E"
  },
  {
    "Retail Branding": "Fusion5",
    "Marketing Name": "Fusion5_F105D",
    "Device": "Fusion5_F105D",
    "Model": "Fusion5_F105D"
  },
  {
    "Retail Branding": "Fusion5",
    "Marketing Name": "Fusion5_F704B",
    "Device": "Fusion5_F704B",
    "Model": "Fusion5_F704B"
  },
  {
    "Retail Branding": "Fusion5",
    "Marketing Name": "KD095",
    "Device": "KD095",
    "Model": "KD095"
  },
  {
    "Retail Branding": "Fusion5",
    "Marketing Name": "KD095_EEA",
    "Device": "KD095_EEA",
    "Model": "KD095_EEA"
  },
  {
    "Retail Branding": "Fusion5",
    "Marketing Name": "T099",
    "Device": "T099",
    "Model": "T099"
  },
  {
    "Retail Branding": "Future Mobile Technology",
    "Marketing Name": "B-52",
    "Device": "176HS1050232",
    "Model": "176HS1050232"
  },
  {
    "Retail Branding": "Future Mobile Technology",
    "Marketing Name": "CP80K",
    "Device": "CP80K",
    "Model": "CP80K"
  },
  {
    "Retail Branding": "Future Mobile Technology",
    "Marketing Name": "CP80K",
    "Device": "CP80K",
    "Model": "FunPad-8Max"
  },
  {
    "Retail Branding": "Future Mobile Technology",
    "Marketing Name": "DRONE",
    "Device": "FMT-NM7108-01",
    "Model": "FMT-NM7108-01"
  },
  {
    "Retail Branding": "Future Mobile Technology",
    "Marketing Name": "Dual 8",
    "Device": "FMT-NT8A42-01",
    "Model": "FMT-NT8A42-01"
  },
  {
    "Retail Branding": "Future Mobile Technology",
    "Marketing Name": "Eagle",
    "Device": "175WT1050231",
    "Model": "175WT1050231"
  },
  {
    "Retail Branding": "Future Mobile Technology",
    "Marketing Name": "FMT-NM7054-01",
    "Device": "FMT-NM7054-01",
    "Model": "FMT-NM7054-01"
  },
  {
    "Retail Branding": "Future Mobile Technology",
    "Marketing Name": "FMT-NM7054-03",
    "Device": "FMT-NM7054-03",
    "Model": "FMT-NM7054-03"
  },
  {
    "Retail Branding": "Future Mobile Technology",
    "Marketing Name": "FMT-NM7058-03",
    "Device": "FMT-NM7058-03",
    "Model": "FMT-NM7058-03"
  },
  {
    "Retail Branding": "Future Mobile Technology",
    "Marketing Name": "FXT113R",
    "Device": "FXT113R",
    "Model": "FXT113R"
  },
  {
    "Retail Branding": "Future Mobile Technology",
    "Marketing Name": "FXT810R",
    "Device": "FXT810R",
    "Model": "FXT810R"
  },
  {
    "Retail Branding": "Future Mobile Technology",
    "Marketing Name": "FXTK13R",
    "Device": "FXTK13R",
    "Model": "FXTK13R"
  },
  {
    "Retail Branding": "Future Mobile Technology",
    "Marketing Name": "Falcon",
    "Device": "176HS1050531",
    "Model": "176HS1050531"
  },
  {
    "Retail Branding": "Future Mobile Technology",
    "Marketing Name": "Flash",
    "Device": "FMT-NM7058-02",
    "Model": "FMT-NM7058-02"
  },
  {
    "Retail Branding": "Future Mobile Technology",
    "Marketing Name": "Global3_B01",
    "Device": "Global3_B01",
    "Model": "Global3 B01"
  },
  {
    "Retail Branding": "Future Mobile Technology",
    "Marketing Name": "Netsurfer STORM",
    "Device": "16M4HI105024",
    "Model": "16M4HI105024"
  },
  {
    "Retail Branding": "Future Mobile Technology",
    "Marketing Name": "Netsurfer TYPHOON",
    "Device": "16M5HI105023",
    "Model": "16M5HI105023"
  },
  {
    "Retail Branding": "Future Mobile Technology",
    "Marketing Name": "ROBI",
    "Device": "ROBI",
    "Model": "ROBI"
  },
  {
    "Retail Branding": "Future Mobile Technology",
    "Marketing Name": "Tomcat",
    "Device": "175HS1050231",
    "Model": "175HS1050231"
  },
  {
    "Retail Branding": "Future Mobile Technology",
    "Marketing Name": "Viper",
    "Device": "175FT1050241",
    "Model": "175FT1050241"
  },
  {
    "Retail Branding": "Future Mobile Technology",
    "Marketing Name": "netsurferDUAL 7",
    "Device": "FMT-NM7116-01",
    "Model": "FMT-NM7116-01"
  },
  {
    "Retail Branding": "Fx_tec_Pro1X",
    "Marketing Name": "QX-1050",
    "Device": "QX1050",
    "Model": "QX1050"
  },
  {
    "Retail Branding": "Fx_tec_Pro1X",
    "Marketing Name": "QX1050",
    "Device": "QX1050",
    "Model": "QX1050"
  },
  {
    "Retail Branding": "Fxtec",
    "Marketing Name": "Fxtec QX1000",
    "Device": "QX1000",
    "Model": "QX1000"
  },
  {
    "Retail Branding": "G Y P NEW TREE SA",
    "Marketing Name": "VIEWPAD M10M",
    "Device": "M10M",
    "Model": "VIEWPAD M10M"
  },
  {
    "Retail Branding": "G-Anica",
    "Marketing Name": "HL_1088_A133P",
    "Device": "HL_1088_A133P",
    "Model": "HL_1088_A133P"
  },
  {
    "Retail Branding": "G-Guard",
    "Marketing Name": "G Guard SMART TV",
    "Device": "SW4H",
    "Model": "G Guard SMART TV"
  },
  {
    "Retail Branding": "G-Guard",
    "Marketing Name": "G GuardTV",
    "Device": "shibuya",
    "Model": "G GuardTV"
  },
  {
    "Retail Branding": "G-Guard",
    "Marketing Name": "G GuardTV",
    "Device": "shibuya",
    "Model": "GGuardTV"
  },
  {
    "Retail Branding": "G-Guard",
    "Marketing Name": "R3_GTV",
    "Device": "R3_GTV",
    "Model": "R3G"
  },
  {
    "Retail Branding": "G-Guard",
    "Marketing Name": "R4_GTV",
    "Device": "R4_GTV",
    "Model": "R4G"
  },
  {
    "Retail Branding": "G-Guard",
    "Marketing Name": "Smart TV",
    "Device": "alimos",
    "Model": "G-Guard Google TV"
  },
  {
    "Retail Branding": "G-Guard",
    "Marketing Name": "Smart TV",
    "Device": "bridgeport",
    "Model": "AI PONT PLUS FF"
  },
  {
    "Retail Branding": "G-Guard",
    "Marketing Name": "Smart TV",
    "Device": "dangni",
    "Model": "G-Guard Google TV"
  },
  {
    "Retail Branding": "G-Guard",
    "Marketing Name": "fushan_Guard",
    "Device": "hamamatsucho",
    "Model": "Smart TV"
  },
  {
    "Retail Branding": "G-Guard",
    "Marketing Name": "vileparle",
    "Device": "vileparle",
    "Model": "R6G"
  },
  {
    "Retail Branding": "G-Guard",
    "Marketing Name": "xiaoyushan_emG",
    "Device": "xiaoyushan",
    "Model": "HiSmartTV A4"
  },
  {
    "Retail Branding": "G-TOUCH",
    "Marketing Name": "SPEED_2021",
    "Device": "SPEED_2021",
    "Model": "SPEED_2021"
  },
  {
    "Retail Branding": "G-TOUCH",
    "Marketing Name": "Stella Omega Plus",
    "Device": "Stella_Omega_Plus",
    "Model": "Stella Omega Plus"
  },
  {
    "Retail Branding": "G-TOUCH",
    "Marketing Name": "Stella X",
    "Device": "Stella_X",
    "Model": "Stella X"
  },
  {
    "Retail Branding": "G-TOUCH",
    "Marketing Name": "Stella X Plus",
    "Device": "Stella_X_Plus",
    "Model": "Stella X Plus"
  },
  {
    "Retail Branding": "G-TOUCH",
    "Marketing Name": "Stella XS",
    "Device": "Stella_XS",
    "Model": "Stella XS"
  },
  {
    "Retail Branding": "G-TOUCH",
    "Marketing Name": "Stella_Omega",
    "Device": "Stella_Omega",
    "Model": "Stella Omega"
  },
  {
    "Retail Branding": "G-Tab",
    "Marketing Name": "C10",
    "Device": "C10-pro",
    "Model": "C10"
  },
  {
    "Retail Branding": "G-Tab",
    "Marketing Name": "C10X",
    "Device": "C10X",
    "Model": "C10X"
  },
  {
    "Retail Branding": "G-Tab",
    "Marketing Name": "C10_1",
    "Device": "C10_1",
    "Model": "C10"
  },
  {
    "Retail Branding": "G-Tab",
    "Marketing Name": "C10_2",
    "Device": "C10_2",
    "Model": "C10"
  },
  {
    "Retail Branding": "G-Tab",
    "Marketing Name": "C20",
    "Device": "C20",
    "Model": "C20"
  },
  {
    "Retail Branding": "G-Tab",
    "Marketing Name": "C3",
    "Device": "C3",
    "Model": "C3"
  },
  {
    "Retail Branding": "G-Tab",
    "Marketing Name": "C30",
    "Device": "C30",
    "Model": "C30"
  },
  {
    "Retail Branding": "G-Tab",
    "Marketing Name": "C9",
    "Device": "C9",
    "Model": "C9"
  },
  {
    "Retail Branding": "G-Tab",
    "Marketing Name": "F1",
    "Device": "F1",
    "Model": "F1"
  },
  {
    "Retail Branding": "G-Tab",
    "Marketing Name": "F10",
    "Device": "F10",
    "Model": "F10"
  },
  {
    "Retail Branding": "G-Tab",
    "Marketing Name": "F1_1",
    "Device": "F1_1",
    "Model": "F1_1"
  },
  {
    "Retail Branding": "G-Tab",
    "Marketing Name": "F1_2",
    "Device": "F1_2",
    "Model": "F1_2"
  },
  {
    "Retail Branding": "G-Tab",
    "Marketing Name": "F2",
    "Device": "F2",
    "Model": "F2"
  },
  {
    "Retail Branding": "G-Tab",
    "Marketing Name": "F2X",
    "Device": "F2X",
    "Model": "F2X"
  },
  {
    "Retail Branding": "G-Tab",
    "Marketing Name": "F4",
    "Device": "F4",
    "Model": "F4"
  },
  {
    "Retail Branding": "G-Tab",
    "Marketing Name": "F8",
    "Device": "F8",
    "Model": "F8"
  },
  {
    "Retail Branding": "G-Tab",
    "Marketing Name": "F8X",
    "Device": "F8X",
    "Model": "F8X"
  },
  {
    "Retail Branding": "G-Tab",
    "Marketing Name": "F8_1",
    "Device": "F8_1",
    "Model": "F8"
  },
  {
    "Retail Branding": "G-Tab",
    "Marketing Name": "G10",
    "Device": "G10",
    "Model": "G10"
  },
  {
    "Retail Branding": "G-Tab",
    "Marketing Name": "G4",
    "Device": "G4",
    "Model": "G4"
  },
  {
    "Retail Branding": "G-Tab",
    "Marketing Name": "G5",
    "Device": "G5",
    "Model": "G5"
  },
  {
    "Retail Branding": "G-Tab",
    "Marketing Name": "G9",
    "Device": "G9",
    "Model": "G9"
  },
  {
    "Retail Branding": "G-Tab",
    "Marketing Name": "G9",
    "Device": "G9_1",
    "Model": "G9"
  },
  {
    "Retail Branding": "G-Tab",
    "Marketing Name": "GTab_X",
    "Device": "X",
    "Model": "X"
  },
  {
    "Retail Branding": "G-Tab",
    "Marketing Name": "N271",
    "Device": "N271",
    "Model": "N271"
  },
  {
    "Retail Branding": "G-Tab",
    "Marketing Name": "N28",
    "Device": "N28",
    "Model": "N28"
  },
  {
    "Retail Branding": "G-Tab",
    "Marketing Name": "N281",
    "Device": "N281",
    "Model": "N281"
  },
  {
    "Retail Branding": "G-Tab",
    "Marketing Name": "P2000",
    "Device": "P2000",
    "Model": "P2000"
  },
  {
    "Retail Branding": "G-Tab",
    "Marketing Name": "P7000",
    "Device": "P7000",
    "Model": "P7000"
  },
  {
    "Retail Branding": "G-Tab",
    "Marketing Name": "P733",
    "Device": "P733",
    "Model": "P733"
  },
  {
    "Retail Branding": "G-Tab",
    "Marketing Name": "PAD10",
    "Device": "PAD10",
    "Model": "PAD10"
  },
  {
    "Retail Branding": "G-Tab",
    "Marketing Name": "PAD10_PRO",
    "Device": "PAD10_PRO",
    "Model": "PAD10_PRO"
  },
  {
    "Retail Branding": "G-Tab",
    "Marketing Name": "PAD10_PRO_NEO",
    "Device": "PAD10_PRO_NEO",
    "Model": "PAD10_PRO"
  },
  {
    "Retail Branding": "G-Tab",
    "Marketing Name": "PAD11",
    "Device": "PAD11",
    "Model": "PAD11"
  },
  {
    "Retail Branding": "G-Tab",
    "Marketing Name": "PAD11_1",
    "Device": "PAD11",
    "Model": "PAD11_1"
  },
  {
    "Retail Branding": "G-Tab",
    "Marketing Name": "PAD7",
    "Device": "PAD7",
    "Model": "PAD7"
  },
  {
    "Retail Branding": "G-Tab",
    "Marketing Name": "PL1000B",
    "Device": "S30",
    "Model": "S30"
  },
  {
    "Retail Branding": "G-Tab",
    "Marketing Name": "Q2",
    "Device": "Q2",
    "Model": "Q2"
  },
  {
    "Retail Branding": "G-Tab",
    "Marketing Name": "Q2S",
    "Device": "Q2S",
    "Model": "Q2S"
  },
  {
    "Retail Branding": "G-Tab",
    "Marketing Name": "Q3",
    "Device": "Q3",
    "Model": "Q3"
  },
  {
    "Retail Branding": "G-Tab",
    "Marketing Name": "Q4",
    "Device": "Q4",
    "Model": "Q4"
  },
  {
    "Retail Branding": "G-Tab",
    "Marketing Name": "Q5",
    "Device": "Q5",
    "Model": "Q5"
  },
  {
    "Retail Branding": "G-Tab",
    "Marketing Name": "Q6",
    "Device": "Q6",
    "Model": "Q6"
  },
  {
    "Retail Branding": "G-Tab",
    "Marketing Name": "Q69",
    "Device": "Q69",
    "Model": "Q69"
  },
  {
    "Retail Branding": "G-Tab",
    "Marketing Name": "Q7",
    "Device": "Q7",
    "Model": "Q7"
  },
  {
    "Retail Branding": "G-Tab",
    "Marketing Name": "S10",
    "Device": "S10",
    "Model": "S10"
  },
  {
    "Retail Branding": "G-Tab",
    "Marketing Name": "S12",
    "Device": "S12",
    "Model": "S12"
  },
  {
    "Retail Branding": "G-Tab",
    "Marketing Name": "S20",
    "Device": "S20",
    "Model": "S20"
  },
  {
    "Retail Branding": "G-Tab",
    "Marketing Name": "S3",
    "Device": "S3",
    "Model": "S3"
  },
  {
    "Retail Branding": "G-Tab",
    "Marketing Name": "S30_1",
    "Device": "S30_1",
    "Model": "S30_1"
  },
  {
    "Retail Branding": "G-Tab",
    "Marketing Name": "S40",
    "Device": "S40",
    "Model": "S40"
  },
  {
    "Retail Branding": "G-Tab",
    "Marketing Name": "S40-1",
    "Device": "S40-1",
    "Model": "S40"
  },
  {
    "Retail Branding": "G-Tab",
    "Marketing Name": "S50",
    "Device": "S50",
    "Model": "S50"
  },
  {
    "Retail Branding": "G-Tab",
    "Marketing Name": "S50-pro",
    "Device": "S50-pro",
    "Model": "S50"
  },
  {
    "Retail Branding": "G-Tab",
    "Marketing Name": "S8",
    "Device": "S8",
    "Model": "S8"
  },
  {
    "Retail Branding": "G-Tab",
    "Marketing Name": "S8K_1",
    "Device": "S8K_1",
    "Model": "S8K"
  },
  {
    "Retail Branding": "G-Tab",
    "Marketing Name": "S8K_2",
    "Device": "S8K_2",
    "Model": "S8K"
  },
  {
    "Retail Branding": "G-Tab",
    "Marketing Name": "S8X",
    "Device": "S8X",
    "Model": "S8X"
  },
  {
    "Retail Branding": "G-Tab",
    "Marketing Name": "T10",
    "Device": "T10_1",
    "Model": "GOPAD"
  },
  {
    "Retail Branding": "G-Tab",
    "Marketing Name": "T10",
    "Device": "T10_1",
    "Model": "T10"
  },
  {
    "Retail Branding": "G-Tab",
    "Marketing Name": "T11_1",
    "Device": "T11_1",
    "Model": "GOPAD"
  },
  {
    "Retail Branding": "G-Tab",
    "Marketing Name": "T11_1",
    "Device": "T11_1",
    "Model": "T11"
  },
  {
    "Retail Branding": "G-Tab",
    "Marketing Name": "T11_1",
    "Device": "T11_1",
    "Model": "T11_1"
  },
  {
    "Retail Branding": "G-Tab",
    "Marketing Name": "T11_PRO",
    "Device": "T11_PRO",
    "Model": "T11_PRO"
  },
  {
    "Retail Branding": "G-Tab",
    "Marketing Name": "T13",
    "Device": "T13",
    "Model": "T13"
  },
  {
    "Retail Branding": "G-Tab",
    "Marketing Name": "T14",
    "Device": "T14",
    "Model": "T14"
  },
  {
    "Retail Branding": "G-Tab",
    "Marketing Name": "T8S_1",
    "Device": "T8S_1",
    "Model": "T8S"
  },
  {
    "Retail Branding": "G-Tab",
    "Marketing Name": "T8_1",
    "Device": "T8_1",
    "Model": "T8"
  },
  {
    "Retail Branding": "G-Tab",
    "Marketing Name": "T9_1",
    "Device": "T9_1",
    "Model": "T9"
  },
  {
    "Retail Branding": "G-Tab",
    "Marketing Name": "T9_PRO",
    "Device": "T9_PRO",
    "Model": "T9 PRO"
  },
  {
    "Retail Branding": "G-Tab",
    "Marketing Name": "Tablet",
    "Device": "Tablet",
    "Model": "T12"
  },
  {
    "Retail Branding": "G-Tab",
    "Marketing Name": "Y",
    "Device": "Y",
    "Model": "Y"
  },
  {
    "Retail Branding": "G-TiDE",
    "Marketing Name": "EX750",
    "Device": "EX750",
    "Model": "EX750"
  },
  {
    "Retail Branding": "G-TiDE",
    "Marketing Name": "EXTREME X9",
    "Device": "EXTREME_X9",
    "Model": "EXTREME X9"
  },
  {
    "Retail Branding": "G-TiDE",
    "Marketing Name": "FANS7",
    "Device": "FANS7",
    "Model": "G-TiDE FANS7"
  },
  {
    "Retail Branding": "G-TiDE",
    "Marketing Name": "G-TiDE_H1_1",
    "Device": "G-TiDE_H1_1",
    "Model": "G-TiDE_H1"
  },
  {
    "Retail Branding": "G-TiDE",
    "Marketing Name": "G-TiDE_H1_2",
    "Device": "G-TiDE_H1_2",
    "Model": "G-TiDE_H1"
  },
  {
    "Retail Branding": "G-TiDE",
    "Marketing Name": "G-TiDE_H1_3",
    "Device": "G-TiDE_H1_3",
    "Model": "G-TiDE_H1"
  },
  {
    "Retail Branding": "G-TiDE",
    "Marketing Name": "G-TiDE_H1_3G",
    "Device": "G-TiDE_H1_3G",
    "Model": "G-TiDE_H1_3G"
  },
  {
    "Retail Branding": "G-TiDE",
    "Marketing Name": "G-TiDE_H1_4",
    "Device": "G-TiDE_H1_4",
    "Model": "G-TiDE_H1"
  },
  {
    "Retail Branding": "G-TiDE",
    "Marketing Name": "G-TiDE_H1_4G",
    "Device": "G-TiDE_H1_4G",
    "Model": "G-TiDE_H1_4G"
  },
  {
    "Retail Branding": "G-TiDE",
    "Marketing Name": "G-TiDE_H1_EEA",
    "Device": "G-TiDE_H1_EEA",
    "Model": "G-TiDE_H1_EEA"
  },
  {
    "Retail Branding": "G-TiDE",
    "Marketing Name": "G-TiDE_P1",
    "Device": "G-TiDE_P1",
    "Model": "G-TiDE_P1"
  },
  {
    "Retail Branding": "G-TiDE",
    "Marketing Name": "G-TiDE_P1_1",
    "Device": "G-TiDE_P1_1",
    "Model": "G-TiDE_P1"
  },
  {
    "Retail Branding": "G-TiDE",
    "Marketing Name": "G-TiDE_P1_2",
    "Device": "G-TiDE_P1_2",
    "Model": "G-TiDE_P1"
  },
  {
    "Retail Branding": "G-TiDE",
    "Marketing Name": "G-TiDE_P1_3",
    "Device": "G-TiDE_P1_3",
    "Model": "G-TiDE_P1"
  },
  {
    "Retail Branding": "G-TiDE",
    "Marketing Name": "G-TiDE_P1_3G",
    "Device": "G-TiDE_P1_3G",
    "Model": "G-TiDE_P1_3G"
  },
  {
    "Retail Branding": "G-TiDE",
    "Marketing Name": "G-TiDE_P1_4",
    "Device": "G-TiDE_P1_4",
    "Model": "G-TiDE_P1"
  },
  {
    "Retail Branding": "G-TiDE",
    "Marketing Name": "G-TiDE_P1_4G",
    "Device": "G-TiDE_P1_4G",
    "Model": "G-TiDE_P1_4G"
  },
  {
    "Retail Branding": "G-TiDE",
    "Marketing Name": "H2R",
    "Device": "H2R",
    "Model": "H2R"
  },
  {
    "Retail Branding": "G-TiDE",
    "Marketing Name": "Klap_S1",
    "Device": "Klap_S1",
    "Model": "Klap_S1"
  },
  {
    "Retail Branding": "G-TiDE",
    "Marketing Name": "Klap_S1_EEA",
    "Device": "Klap_S1_EEA",
    "Model": "Klap_S1"
  },
  {
    "Retail Branding": "G-TiDE",
    "Marketing Name": "PL1080",
    "Device": "G-TiDE_H1_4G_EEA",
    "Model": "G-TiDE_H1_4G"
  },
  {
    "Retail Branding": "G-TiDE",
    "Marketing Name": "V1",
    "Device": "V1",
    "Model": "V1"
  },
  {
    "Retail Branding": "G-TiDE",
    "Marketing Name": "V1_3G",
    "Device": "V1_3G",
    "Model": "V1_3G"
  },
  {
    "Retail Branding": "G-TiDE",
    "Marketing Name": "V1_4G",
    "Device": "V1_4G",
    "Model": "V1_4G"
  },
  {
    "Retail Branding": "G-TiDE",
    "Marketing Name": "Zeal1",
    "Device": "Zeal1",
    "Model": "Zeal1"
  },
  {
    "Retail Branding": "G-TiDE EXTREME",
    "Marketing Name": "EX10",
    "Device": "EX10",
    "Model": "EX10"
  },
  {
    "Retail Branding": "G-TiDE EXTREME",
    "Marketing Name": "EX760",
    "Device": "EX760",
    "Model": "EX760"
  },
  {
    "Retail Branding": "G53",
    "Marketing Name": "TA71CA3",
    "Device": "TA71CA3_1",
    "Model": "TA71CA3"
  },
  {
    "Retail Branding": "G7 Mobiles",
    "Marketing Name": "G7S54P3CR",
    "Device": "G7S54P3CR",
    "Model": "G7S54P3CR"
  },
  {
    "Retail Branding": "GABA",
    "Marketing Name": "GABA",
    "Device": "bangbae",
    "Model": "GABA 4K Android TV"
  },
  {
    "Retail Branding": "GABA",
    "Marketing Name": "GABA",
    "Device": "komagome",
    "Model": "GABA 2K Android TV"
  },
  {
    "Retail Branding": "GC(TECH)",
    "Marketing Name": "GC AA1",
    "Device": "GC-AA1",
    "Model": "GC-AA1"
  },
  {
    "Retail Branding": "GD Classbook",
    "Marketing Name": "TA80CA1",
    "Device": "TA80CA1_2",
    "Model": "TA80CA1"
  },
  {
    "Retail Branding": "GDL(BD)",
    "Marketing Name": "G200",
    "Device": "G200",
    "Model": "G200"
  },
  {
    "Retail Branding": "GDL(BD)",
    "Marketing Name": "GDL GigaX Y21",
    "Device": "GigaX_Y21",
    "Model": "GDL GigaX Y21"
  },
  {
    "Retail Branding": "GDL(BD)",
    "Marketing Name": "GDL Gigax Y10",
    "Device": "Gigax_Y10",
    "Model": "Gigax Y10"
  },
  {
    "Retail Branding": "GDL(BD)",
    "Marketing Name": "GDL Xtreme6",
    "Device": "Xtreme_6",
    "Model": "Xtreme 6"
  },
  {
    "Retail Branding": "GDL(BD)",
    "Marketing Name": "GigaX Y11",
    "Device": "Y11",
    "Model": "GigaX Y11"
  },
  {
    "Retail Branding": "GDL(BD)",
    "Marketing Name": "GigaX Y30",
    "Device": "Y30",
    "Model": "GigaX Y30"
  },
  {
    "Retail Branding": "GDL(BD)",
    "Marketing Name": "GigaX_S7",
    "Device": "GigaX_S7",
    "Model": "GigaX S7"
  },
  {
    "Retail Branding": "GDL(BD)",
    "Marketing Name": "GigaX_S7_Plus",
    "Device": "GigaX_S7_Plus",
    "Model": "GigaX S7 Plus"
  },
  {
    "Retail Branding": "GDM (es)",
    "Marketing Name": "MB10",
    "Device": "MB10",
    "Model": "MB10"
  },
  {
    "Retail Branding": "GDM (es)",
    "Marketing Name": "MB9",
    "Device": "MB9",
    "Model": "MB9"
  },
  {
    "Retail Branding": "GDM (es)",
    "Marketing Name": "MB9_PRO",
    "Device": "MB9_PRO",
    "Model": "MB9_PRO"
  },
  {
    "Retail Branding": "GDM (es)",
    "Marketing Name": "P4R",
    "Device": "P4R",
    "Model": "P4R"
  },
  {
    "Retail Branding": "GDM (es)",
    "Marketing Name": "P4R_PRO",
    "Device": "P4R_PRO",
    "Model": "P4R_PRO"
  },
  {
    "Retail Branding": "GE Appliances",
    "Marketing Name": "Kitchen Hub",
    "Device": "syklone",
    "Model": "uvh1301"
  },
  {
    "Retail Branding": "GENESIS",
    "Marketing Name": "GT-7550",
    "Device": "GT-7550",
    "Model": "GT-7550"
  },
  {
    "Retail Branding": "GEOFOX",
    "Marketing Name": "GEOFOX_MID743",
    "Device": "GEOFOX_MID743",
    "Model": "GEOFOX_MID743"
  },
  {
    "Retail Branding": "GETESA",
    "Marketing Name": "GETESA Sky blue",
    "Device": "GETESA_Sky_blue",
    "Model": "GETESA Sky blue"
  },
  {
    "Retail Branding": "GETESA",
    "Marketing Name": "GETESA_niebla",
    "Device": "GETESA_niebla",
    "Model": "GETESA_niebla"
  },
  {
    "Retail Branding": "GFF",
    "Marketing Name": "S2",
    "Device": "StayOnYou-S2",
    "Model": "StayOnYou-S2"
  },
  {
    "Retail Branding": "GFive",
    "Marketing Name": "Gpad701",
    "Device": "Gpad701",
    "Model": "Gpad701"
  },
  {
    "Retail Branding": "GFive",
    "Marketing Name": "HS6605",
    "Device": "Vision_Pro",
    "Model": "Vision Pro"
  },
  {
    "Retail Branding": "GFive",
    "Marketing Name": "Note_25",
    "Device": "Note_25",
    "Model": "Note_25"
  },
  {
    "Retail Branding": "GFive",
    "Marketing Name": "Note_25_ULTRA",
    "Device": "Note_25_ULTRA",
    "Model": "Note_25_ULTRA"
  },
  {
    "Retail Branding": "GFive",
    "Marketing Name": "PRESIDENT_GOLD_10",
    "Device": "PRESIDENT_GOLD_10",
    "Model": "PRESIDENT_GOLD_10"
  },
  {
    "Retail Branding": "GFive",
    "Marketing Name": "PRESIDENT_GOLD_9",
    "Device": "PRESIDENT_GOLD_9",
    "Model": "PRESIDENT_GOLD_9"
  },
  {
    "Retail Branding": "GFive",
    "Marketing Name": "PRO_16",
    "Device": "PRO_16",
    "Model": "PRO_16"
  },
  {
    "Retail Branding": "GFive",
    "Marketing Name": "President_Classic_9",
    "Device": "President_Classic_9",
    "Model": "President_Classic_9"
  },
  {
    "Retail Branding": "GFive",
    "Marketing Name": "President_smart_5",
    "Device": "President_smart_5",
    "Model": "President_smart_5"
  },
  {
    "Retail Branding": "GFive",
    "Marketing Name": "Speedo",
    "Device": "Speedo",
    "Model": "Speedo"
  },
  {
    "Retail Branding": "GFive",
    "Marketing Name": "Speedo_1",
    "Device": "Speedo_1",
    "Model": "Speedo_1"
  },
  {
    "Retail Branding": "GFive",
    "Marketing Name": "Stark",
    "Device": "Stark",
    "Model": "Stark"
  },
  {
    "Retail Branding": "GFive",
    "Marketing Name": "Thunder",
    "Device": "Thunder",
    "Model": "Thunder"
  },
  {
    "Retail Branding": "GFive",
    "Marketing Name": "Vision 1",
    "Device": "Vision_1",
    "Model": "Vision 1"
  },
  {
    "Retail Branding": "GFive",
    "Marketing Name": "Xhero_7",
    "Device": "Xhero_7",
    "Model": "Xhero_7"
  },
  {
    "Retail Branding": "GHIA KIDS",
    "Marketing Name": "GTKIDS7",
    "Device": "GTKIDS7",
    "Model": "GTKIDS7"
  },
  {
    "Retail Branding": "GIGI",
    "Marketing Name": "U1",
    "Device": "GIGI_U1",
    "Model": "GIGI_U1"
  },
  {
    "Retail Branding": "GIRASOLE",
    "Marketing Name": "TAB5",
    "Device": "TAB5",
    "Model": "TAB5"
  },
  {
    "Retail Branding": "GIRASOLE",
    "Marketing Name": "X9",
    "Device": "X9",
    "Model": "X9"
  },
  {
    "Retail Branding": "GLOBAL3",
    "Marketing Name": "B02",
    "Device": "B02",
    "Model": "B02"
  },
  {
    "Retail Branding": "GLX(IR)",
    "Marketing Name": "Shahin_IV",
    "Device": "Shahin_IV",
    "Model": "SHAHIN IV"
  },
  {
    "Retail Branding": "GMMZ",
    "Marketing Name": "DongleTV1",
    "Device": "DongleTV1",
    "Model": "DongleTV1"
  },
  {
    "Retail Branding": "GOMDUSA",
    "Marketing Name": "X23",
    "Device": "X23",
    "Model": "X23"
  },
  {
    "Retail Branding": "GOMDUSA",
    "Marketing Name": "X23_Pro",
    "Device": "X23_Pro",
    "Model": "X23_Pro"
  },
  {
    "Retail Branding": "GOMDUSA",
    "Marketing Name": "X23_TAB",
    "Device": "X23_TAB",
    "Model": "X23 TAB"
  },
  {
    "Retail Branding": "GOODEE",
    "Marketing Name": "GD500Plus",
    "Device": "himalaya",
    "Model": "GD500Plus"
  },
  {
    "Retail Branding": "GOODEE",
    "Marketing Name": "YG600-Movin",
    "Device": "altai",
    "Model": "YG381"
  },
  {
    "Retail Branding": "GOODTEL",
    "Marketing Name": "G10_EEA",
    "Device": "G10_EEA",
    "Model": "G10_EEA"
  },
  {
    "Retail Branding": "GOODTEL",
    "Marketing Name": "G10_T_EEA",
    "Device": "G10_T_EEA",
    "Model": "G10_T_EEA"
  },
  {
    "Retail Branding": "GOODTEL",
    "Marketing Name": "G10_T_US",
    "Device": "G10_T_US",
    "Model": "G10_T_US"
  },
  {
    "Retail Branding": "GOODTEL",
    "Marketing Name": "G10_US",
    "Device": "G10_US",
    "Model": "G10_US"
  },
  {
    "Retail Branding": "GOODTEL",
    "Marketing Name": "G10_V_EEA",
    "Device": "G10",
    "Model": "G10"
  },
  {
    "Retail Branding": "GOODTEL",
    "Marketing Name": "G10_V_EEA",
    "Device": "G10",
    "Model": "G10_V_EEA"
  },
  {
    "Retail Branding": "GOODTEL",
    "Marketing Name": "G10_V_US",
    "Device": "G10",
    "Model": "G10"
  },
  {
    "Retail Branding": "GOODTEL",
    "Marketing Name": "G11_U_EEA",
    "Device": "G11_U_EEA",
    "Model": "G11_U_EEA"
  },
  {
    "Retail Branding": "GOODTEL",
    "Marketing Name": "G11_U_US",
    "Device": "G11_U_US",
    "Model": "G11_U_US"
  },
  {
    "Retail Branding": "GOODTEL",
    "Marketing Name": "G2-EEA",
    "Device": "G2-EEA",
    "Model": "G2-EEA"
  },
  {
    "Retail Branding": "GOODTEL",
    "Marketing Name": "G2_A_EEA",
    "Device": "G2_A_EEA",
    "Model": "G2_A_EEA"
  },
  {
    "Retail Branding": "GOODTEL",
    "Marketing Name": "G2_EEA",
    "Device": "G2_EEA",
    "Model": "G2_EEA"
  },
  {
    "Retail Branding": "GOODTEL",
    "Marketing Name": "G2_T_EEA",
    "Device": "G2_T_EEA",
    "Model": "G2_T_EEA"
  },
  {
    "Retail Branding": "GOODTEL",
    "Marketing Name": "G2_T_US",
    "Device": "G2_T_US",
    "Model": "G2_T_US"
  },
  {
    "Retail Branding": "GOODTEL",
    "Marketing Name": "G2_U_EEA",
    "Device": "G2_U_EEA",
    "Model": "G2_U_EEA"
  },
  {
    "Retail Branding": "GOODTEL",
    "Marketing Name": "G2_U_US",
    "Device": "G2_U_US",
    "Model": "G2_U_US"
  },
  {
    "Retail Branding": "GOODTEL",
    "Marketing Name": "G3",
    "Device": "G3",
    "Model": "G3"
  },
  {
    "Retail Branding": "GOODTEL",
    "Marketing Name": "G3",
    "Device": "G3",
    "Model": "G3_EEA"
  },
  {
    "Retail Branding": "GOODTEL",
    "Marketing Name": "G3-EEA",
    "Device": "G3-EEA",
    "Model": "G3-EEA"
  },
  {
    "Retail Branding": "GOODTEL",
    "Marketing Name": "G3-US",
    "Device": "G3-US",
    "Model": "G3-US"
  },
  {
    "Retail Branding": "GOODTEL",
    "Marketing Name": "G3_EEA",
    "Device": "G3_EEA",
    "Model": "G3_EEA"
  },
  {
    "Retail Branding": "GOODTEL",
    "Marketing Name": "G3_US",
    "Device": "G3_US",
    "Model": "G3_US"
  },
  {
    "Retail Branding": "GOODTEL",
    "Marketing Name": "G6",
    "Device": "G6",
    "Model": "G6"
  },
  {
    "Retail Branding": "GOODTEL",
    "Marketing Name": "G6_EEA",
    "Device": "G6_EEA",
    "Model": "G6"
  },
  {
    "Retail Branding": "GOODTEL",
    "Marketing Name": "G7",
    "Device": "G7",
    "Model": "G7"
  },
  {
    "Retail Branding": "GOODTEL",
    "Marketing Name": "G7_EEA",
    "Device": "G7_EEA",
    "Model": "G7"
  },
  {
    "Retail Branding": "GOODTEL",
    "Marketing Name": "G7_EEA_T",
    "Device": "G7_EEA_T",
    "Model": "G7_EEA"
  },
  {
    "Retail Branding": "GOODTEL",
    "Marketing Name": "G7_T",
    "Device": "G7_T",
    "Model": "G7_US"
  },
  {
    "Retail Branding": "GOODTEL",
    "Marketing Name": "G7_V_EEA",
    "Device": "G7",
    "Model": "G7"
  },
  {
    "Retail Branding": "GOODTEL",
    "Marketing Name": "G7_V_EEA",
    "Device": "G7",
    "Model": "G7_V_EEA"
  },
  {
    "Retail Branding": "GOODTEL",
    "Marketing Name": "G7_V_US",
    "Device": "G7",
    "Model": "G7"
  },
  {
    "Retail Branding": "GOODTEL",
    "Marketing Name": "G9_EEA",
    "Device": "G9_EEA",
    "Model": "G9_EEA"
  },
  {
    "Retail Branding": "GOODTEL",
    "Marketing Name": "G9_US",
    "Device": "G9_US",
    "Model": "G9_US"
  },
  {
    "Retail Branding": "GOODTEL",
    "Marketing Name": "G9_U_EEA",
    "Device": "G9_U_EEA",
    "Model": "G9_U_EEA"
  },
  {
    "Retail Branding": "GOODTEL",
    "Marketing Name": "G9_U_US",
    "Device": "G9_U_US",
    "Model": "G9_U_US"
  },
  {
    "Retail Branding": "GOODTEL",
    "Marketing Name": "G9_V_EEA",
    "Device": "G9",
    "Model": "G9"
  },
  {
    "Retail Branding": "GOODTEL",
    "Marketing Name": "G9_V_EEA",
    "Device": "G9",
    "Model": "G9_V_EEA"
  },
  {
    "Retail Branding": "GOODTEL",
    "Marketing Name": "G9_V_US",
    "Device": "G9",
    "Model": "G9"
  },
  {
    "Retail Branding": "GOTV",
    "Marketing Name": "SEID04GM",
    "Device": "SEID04GM",
    "Model": "GO TV Box"
  },
  {
    "Retail Branding": "GOtv",
    "Marketing Name": "GO700FR",
    "Device": "GoFreeTV",
    "Model": "GO700FR"
  },
  {
    "Retail Branding": "GOtv",
    "Marketing Name": "GOtv S",
    "Device": "GoFreeTV",
    "Model": "GO700FR"
  },
  {
    "Retail Branding": "GOtv",
    "Marketing Name": "GOtv Y",
    "Device": "HP4BA-GOTV",
    "Model": "GO710FR"
  },
  {
    "Retail Branding": "GOtv",
    "Marketing Name": "SEI600GO",
    "Device": "HND",
    "Model": "SEI600GO"
  },
  {
    "Retail Branding": "GP-electronic",
    "Marketing Name": "YC-08P",
    "Device": "YC-08P",
    "Model": "YC-08P"
  },
  {
    "Retail Branding": "GP-electronic",
    "Marketing Name": "YC-102D",
    "Device": "YC-102D",
    "Model": "YC-102D"
  },
  {
    "Retail Branding": "GP-electronic",
    "Marketing Name": "YC-3135D",
    "Device": "YC-3135D",
    "Model": "YC-3135D"
  },
  {
    "Retail Branding": "GP-electronic",
    "Marketing Name": "YC-83P",
    "Device": "YC-83P",
    "Model": "YC-83P"
  },
  {
    "Retail Branding": "GP-electronic",
    "Marketing Name": "YC-83T",
    "Device": "YC-83T",
    "Model": "YC-83T"
  },
  {
    "Retail Branding": "GPOA",
    "Marketing Name": "UAI PRO",
    "Device": "UAI_PRO",
    "Model": "UAI_Series"
  },
  {
    "Retail Branding": "GPX_US",
    "Marketing Name": "TBDV1093",
    "Device": "TBDV1093",
    "Model": "TBDV1093"
  },
  {
    "Retail Branding": "GREATASIA",
    "Marketing Name": "E101GC",
    "Device": "E101GC",
    "Model": "E101GC"
  },
  {
    "Retail Branding": "GREATASIA",
    "Marketing Name": "E101GC4G",
    "Device": "E101GC4G",
    "Model": "E101GC4G"
  },
  {
    "Retail Branding": "GREATASIA",
    "Marketing Name": "E101GCM",
    "Device": "E101GCM",
    "Model": "E101GCM"
  },
  {
    "Retail Branding": "GREATASIA",
    "Marketing Name": "E108GC",
    "Device": "E108GC",
    "Model": "E108GC"
  },
  {
    "Retail Branding": "GREATASIA",
    "Marketing Name": "E10A133_EEA",
    "Device": "E10A133_EEA",
    "Model": "E10A133_EEA"
  },
  {
    "Retail Branding": "GREATASIA",
    "Marketing Name": "E10_A133_EEA",
    "Device": "E10_A133_EEA",
    "Model": "E10_A133_EEA"
  },
  {
    "Retail Branding": "GREATASIA",
    "Marketing Name": "E700_Kids_EEA",
    "Device": "E700_Kids_EEA",
    "Model": "E700_Kids_EEA"
  },
  {
    "Retail Branding": "GREATASIA",
    "Marketing Name": "E720_EEA",
    "Device": "E720_EEA",
    "Model": "E720_EEA"
  },
  {
    "Retail Branding": "GREATASIA",
    "Marketing Name": "E9863",
    "Device": "E9863",
    "Model": "E9863"
  },
  {
    "Retail Branding": "GREATASIA",
    "Marketing Name": "ET103G",
    "Device": "ET103G",
    "Model": "ET103G"
  },
  {
    "Retail Branding": "GREATASIA",
    "Marketing Name": "Kidpad_M7",
    "Device": "Kidpa_M7",
    "Model": "Kidpa_M7"
  },
  {
    "Retail Branding": "GREATASIA",
    "Marketing Name": "Pad_M30",
    "Device": "Pad_M30",
    "Model": "Pad_M30"
  },
  {
    "Retail Branding": "GREATASIA",
    "Marketing Name": "TK-E8765",
    "Device": "TK-E8765",
    "Model": "TK-E8765"
  },
  {
    "Retail Branding": "GREATASIA",
    "Marketing Name": "TK-P1197",
    "Device": "TK-P1197",
    "Model": "TK-P1197"
  },
  {
    "Retail Branding": "GREATASIA",
    "Marketing Name": "TK-P86",
    "Device": "TK-P86",
    "Model": "TK-P86"
  },
  {
    "Retail Branding": "GREATASIA",
    "Marketing Name": "TK_E109GCM",
    "Device": "TK_E109GCM",
    "Model": "TK_E109GCM"
  },
  {
    "Retail Branding": "GREATASIA",
    "Marketing Name": "TK_E720_EEA",
    "Device": "TK_E720_EEA",
    "Model": "TK_E720_EEA"
  },
  {
    "Retail Branding": "GRID Communications (SG)",
    "Marketing Name": "GS6100",
    "Device": "GRID_GS6100",
    "Model": "GS6100"
  },
  {
    "Retail Branding": "GSmart",
    "Marketing Name": "Akta A4",
    "Device": "Akta_A4",
    "Model": "Akta_A4"
  },
  {
    "Retail Branding": "GSmart",
    "Marketing Name": "Aku A1",
    "Device": "Aku_A1",
    "Model": "GSmart Aku A1"
  },
  {
    "Retail Branding": "GSmart",
    "Marketing Name": "Alto A2",
    "Device": "Alto_A2",
    "Model": "GSmart Alto A2"
  },
  {
    "Retail Branding": "GSmart",
    "Marketing Name": "Arty A3",
    "Device": "Arty_A3",
    "Model": "GSmart Arty A3"
  },
  {
    "Retail Branding": "GSmart",
    "Marketing Name": "Classic",
    "Device": "Classic",
    "Model": "Classic"
  },
  {
    "Retail Branding": "GSmart",
    "Marketing Name": "Classic_Pro",
    "Device": "Classic_Pro",
    "Model": "Classic_Pro"
  },
  {
    "Retail Branding": "GSmart",
    "Marketing Name": "Elite",
    "Device": "Elite",
    "Model": "Elite"
  },
  {
    "Retail Branding": "GSmart",
    "Marketing Name": "GS202+",
    "Device": "GSmart_GS202",
    "Model": "GSmart GS202+"
  },
  {
    "Retail Branding": "GSmart",
    "Marketing Name": "GSmart SX1",
    "Device": "GBC_bravo",
    "Model": "GSmart SX1"
  },
  {
    "Retail Branding": "GSmart",
    "Marketing Name": "GX2",
    "Device": "GBC_ares",
    "Model": "GX2"
  },
  {
    "Retail Branding": "GSmart",
    "Marketing Name": "Guru G1",
    "Device": "Guru_G1",
    "Model": "GSmart Guru G1"
  },
  {
    "Retail Branding": "GSmart",
    "Marketing Name": "Maya M1",
    "Device": "MayaM1",
    "Model": "GSmart Maya M1"
  },
  {
    "Retail Branding": "GSmart",
    "Marketing Name": "Maya M1 v2",
    "Device": "Maya_M1_v2",
    "Model": "GSmart Maya M1 v2"
  },
  {
    "Retail Branding": "GSmart",
    "Marketing Name": "Mika M2",
    "Device": "Mika_M2",
    "Model": "GSmart Mika M2"
  },
  {
    "Retail Branding": "GSmart",
    "Marketing Name": "Mika M3",
    "Device": "Mika_M3",
    "Model": "GSmart Mika M3"
  },
  {
    "Retail Branding": "GSmart",
    "Marketing Name": "Rey R3",
    "Device": "Rey_R3",
    "Model": "GSmart Rey R3"
  },
  {
    "Retail Branding": "GSmart",
    "Marketing Name": "Rio R1",
    "Device": "Rio_R1",
    "Model": "GSmart Rio R1"
  },
  {
    "Retail Branding": "GSmart",
    "Marketing Name": "Roma R2",
    "Device": "Roma_R2",
    "Model": "GSmart Roma R2"
  },
  {
    "Retail Branding": "GSmart",
    "Marketing Name": "SX1",
    "Device": "bravo",
    "Model": "GSmart SX1"
  },
  {
    "Retail Branding": "GSmart",
    "Marketing Name": "Saga_S3",
    "Device": "Saga_S3",
    "Model": "GSmart Saga S3"
  },
  {
    "Retail Branding": "GSmart",
    "Marketing Name": "Sierra S1",
    "Device": "GSmart_Sierra_S1",
    "Model": "GSmart Sierra S1"
  },
  {
    "Retail Branding": "GSmart",
    "Marketing Name": "Simba SX1",
    "Device": "GBC_bravo",
    "Model": "Simba SX1"
  },
  {
    "Retail Branding": "GSmart",
    "Marketing Name": "Simba SX1",
    "Device": "bravo",
    "Model": "Simba SX1"
  },
  {
    "Retail Branding": "GSmart",
    "Marketing Name": "T4",
    "Device": "GSmart_T4",
    "Model": "GSmart T4"
  },
  {
    "Retail Branding": "GSmart",
    "Marketing Name": "Tuku T2",
    "Device": "Tuku_T2",
    "Model": "GSmart Tuku T2"
  },
  {
    "Retail Branding": "GTI-PRO",
    "Marketing Name": "GTI_T60",
    "Device": "GTI_T60",
    "Model": "GTI_T60"
  },
  {
    "Retail Branding": "GTPL",
    "Marketing Name": "Inspire 4.0",
    "Device": "Inspire_4",
    "Model": "Inspire_4"
  },
  {
    "Retail Branding": "GTPL",
    "Marketing Name": "Shockwave",
    "Device": "Shockwave",
    "Model": "Shockwave"
  },
  {
    "Retail Branding": "GTX(A)",
    "Marketing Name": "GTX_JACULUS",
    "Device": "GTX_JACULUS",
    "Model": "GTX_JACULUS"
  },
  {
    "Retail Branding": "GTX(A)",
    "Marketing Name": "GTX_JACULUS_01",
    "Device": "GTX_JACULUS_01",
    "Model": "GTX_JACULUS_01"
  },
  {
    "Retail Branding": "GTX(A)",
    "Marketing Name": "Jaculus_V2",
    "Device": "Jaculus_V2",
    "Model": "Jaculus V2"
  },
  {
    "Retail Branding": "GUIDE_SAMJUNG",
    "Marketing Name": "GSJ",
    "Device": "rk3588_i",
    "Model": "GSJ"
  },
  {
    "Retail Branding": "GYGAR",
    "Marketing Name": "IPG-xxH",
    "Device": "IPG-xxH",
    "Model": "IPG-xxH"
  },
  {
    "Retail Branding": "GYRO",
    "Marketing Name": "S6001",
    "Device": "S6001",
    "Model": "GYRO S6001"
  },
  {
    "Retail Branding": "Galactic",
    "Marketing Name": "ETAB_M7043G",
    "Device": "ETAB_M7043G",
    "Model": "ETAB_M7043G"
  },
  {
    "Retail Branding": "Galactic",
    "Marketing Name": "Galactic_Astro",
    "Device": "Galactic_Astro",
    "Model": "Galactic_Astro"
  },
  {
    "Retail Branding": "Galapad",
    "Marketing Name": "Galapad S6",
    "Device": "GALAPAD_S6",
    "Model": "GALAPAD_S6"
  },
  {
    "Retail Branding": "Galax",
    "Marketing Name": "F5",
    "Device": "F5",
    "Model": "F5"
  },
  {
    "Retail Branding": "Galexia",
    "Marketing Name": "GL9002",
    "Device": "GL9002",
    "Model": "GL9002"
  },
  {
    "Retail Branding": "Gangnam",
    "Marketing Name": "GANGNAM",
    "Device": "anglelake",
    "Model": "GNG41RF"
  },
  {
    "Retail Branding": "Gangnam",
    "Marketing Name": "Gangnam",
    "Device": "waiawa",
    "Model": "GNG51RU"
  },
  {
    "Retail Branding": "Garad",
    "Marketing Name": "GARAD_fire",
    "Device": "GARAD_fire",
    "Model": "GARAD_fire"
  },
  {
    "Retail Branding": "Garmin",
    "Marketing Name": "",
    "Device": "a10",
    "Model": "Garmin-Asus A10"
  },
  {
    "Retail Branding": "Garmin",
    "Marketing Name": "Monterra",
    "Device": "monterra",
    "Model": "Monterra"
  },
  {
    "Retail Branding": "Garmin",
    "Marketing Name": "Nuvi 3595",
    "Device": "scorpio",
    "Model": "nuvi 3595"
  },
  {
    "Retail Branding": "Garmin",
    "Marketing Name": "Nuvifone",
    "Device": "a50",
    "Model": "Garmin-Asus A50"
  },
  {
    "Retail Branding": "Garmin",
    "Marketing Name": "Nuvifone",
    "Device": "a50",
    "Model": "Garminfone"
  },
  {
    "Retail Branding": "Garmin",
    "Marketing Name": "Nuvifone",
    "Device": "a50",
    "Model": "nuvifone A50"
  },
  {
    "Retail Branding": "Garmin",
    "Marketing Name": "Nuvifone",
    "Device": "a50",
    "Model": "nüvifone A50"
  },
  {
    "Retail Branding": "Garmin",
    "Marketing Name": "nuvi 3590",
    "Device": "scorpio",
    "Model": "nuvi 3590"
  },
  {
    "Retail Branding": "Garmin",
    "Marketing Name": "nuvi 3592",
    "Device": "scorpio",
    "Model": "nuvi 3592"
  },
  {
    "Retail Branding": "Garmin",
    "Marketing Name": "nuvi 3595",
    "Device": "scorpio",
    "Model": "nuvi 3595"
  },
  {
    "Retail Branding": "Gasei S.A.",
    "Marketing Name": "MGTABX",
    "Device": "MGTABX",
    "Model": "MGTABX"
  },
  {
    "Retail Branding": "Gasei S.A.",
    "Marketing Name": "Retailer Stores",
    "Device": "SENSE901",
    "Model": "SENSE901"
  },
  {
    "Retail Branding": "Gasei S.A.",
    "Marketing Name": "SENSE1003G",
    "Device": "SENSE1003G",
    "Model": "SENSE1003G"
  },
  {
    "Retail Branding": "Gasei S.A.",
    "Marketing Name": "SENSE701",
    "Device": "SENSE701",
    "Model": "SENSE701"
  },
  {
    "Retail Branding": "Gasei S.A.",
    "Marketing Name": "SENSE704G",
    "Device": "SENSE704G",
    "Model": "SENSE704G"
  },
  {
    "Retail Branding": "Gateway",
    "Marketing Name": "GAKM10822",
    "Device": "GAKM10822",
    "Model": "GAKM10822"
  },
  {
    "Retail Branding": "Gateway",
    "Marketing Name": "GATA30812",
    "Device": "GATA30812",
    "Model": "GATA30812"
  },
  {
    "Retail Branding": "Gateway",
    "Marketing Name": "GATA31012",
    "Device": "GATA31012",
    "Model": "GATA31012"
  },
  {
    "Retail Branding": "Gateway",
    "Marketing Name": "GATM10822",
    "Device": "GATM10822",
    "Model": "GATM10822"
  },
  {
    "Retail Branding": "Gateway",
    "Marketing Name": "GATM11022",
    "Device": "GATM11022",
    "Model": "GATM11022"
  },
  {
    "Retail Branding": "Gateway",
    "Marketing Name": "GATM11033",
    "Device": "GATM11033",
    "Model": "GATM11033"
  },
  {
    "Retail Branding": "Gateway",
    "Marketing Name": "GWAT10_1",
    "Device": "GWAT10_1",
    "Model": "GWAT10_1"
  },
  {
    "Retail Branding": "Gateway",
    "Marketing Name": "GWAT8_1",
    "Device": "GWAT8_1",
    "Model": "GWAT8_1"
  },
  {
    "Retail Branding": "Gazer",
    "Marketing Name": "GAZER",
    "Device": "stanford",
    "Model": "2K SMART TV"
  },
  {
    "Retail Branding": "Gazer",
    "Marketing Name": "GAZER",
    "Device": "zhongshan",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "Geanee",
    "Marketing Name": "ADP-503G",
    "Device": "ADP-503G",
    "Model": "ADP-503G"
  },
  {
    "Retail Branding": "Geanee",
    "Marketing Name": "FXC-5A",
    "Device": "FXC-5A",
    "Model": "FXC-5A"
  },
  {
    "Retail Branding": "Geanee",
    "Marketing Name": "HT-001",
    "Device": "HT-001",
    "Model": "HT-001"
  },
  {
    "Retail Branding": "Geanee",
    "Marketing Name": "JT07-90",
    "Device": "JT07-90",
    "Model": "JT07-90"
  },
  {
    "Retail Branding": "Geanee",
    "Marketing Name": "JT10-90",
    "Device": "JT10-90",
    "Model": "JT10-90"
  },
  {
    "Retail Branding": "Geant",
    "Marketing Name": "GEANT T1",
    "Device": "GEANT_T1",
    "Model": "T1"
  },
  {
    "Retail Branding": "Gear Mobile",
    "Marketing Name": "Feel_1008S",
    "Device": "Feel_1008S",
    "Model": "1008S"
  },
  {
    "Retail Branding": "Gear Mobile",
    "Marketing Name": "Feel_7013N",
    "Device": "Feel_7013N",
    "Model": "Feel_7013N"
  },
  {
    "Retail Branding": "Gear Mobile",
    "Marketing Name": "Feel_8002N",
    "Device": "Feel_8002N",
    "Model": "8002N"
  },
  {
    "Retail Branding": "Gear Mobile",
    "Marketing Name": "GM10",
    "Device": "GM10",
    "Model": "GM10"
  },
  {
    "Retail Branding": "Gear Mobile",
    "Marketing Name": "GM30",
    "Device": "GM30",
    "Model": "GM30"
  },
  {
    "Retail Branding": "Gear Mobile",
    "Marketing Name": "GM7",
    "Device": "GM7",
    "Model": "GM7"
  },
  {
    "Retail Branding": "Gear Mobile",
    "Marketing Name": "Gear_PRO",
    "Device": "Gear_PRO",
    "Model": "Gear_PRO"
  },
  {
    "Retail Branding": "Gear Mobile",
    "Marketing Name": "Gear_PRO2",
    "Device": "Gear_PRO2",
    "Model": "Gear_PRO2"
  },
  {
    "Retail Branding": "Gear Mobile",
    "Marketing Name": "Space",
    "Device": "Space",
    "Model": "Space"
  },
  {
    "Retail Branding": "Gear Mobile",
    "Marketing Name": "Space_Pro",
    "Device": "Space_Pro",
    "Model": "Space_Pro"
  },
  {
    "Retail Branding": "Geecoo",
    "Marketing Name": "G1",
    "Device": "G1",
    "Model": "G1"
  },
  {
    "Retail Branding": "Geecoo",
    "Marketing Name": "G1_3g",
    "Device": "G1_3g",
    "Model": "G1_3g"
  },
  {
    "Retail Branding": "Geecoo",
    "Marketing Name": "G2",
    "Device": "G2",
    "Model": "G2"
  },
  {
    "Retail Branding": "Geecoo",
    "Marketing Name": "G3",
    "Device": "G3",
    "Model": "G3"
  },
  {
    "Retail Branding": "Geecoo",
    "Marketing Name": "G4",
    "Device": "G4",
    "Model": "G4"
  },
  {
    "Retail Branding": "Geeken",
    "Marketing Name": "Geeken_IFPD",
    "Device": "IFPD",
    "Model": "GI-IFP"
  },
  {
    "Retail Branding": "Gen2Wave",
    "Marketing Name": "Prime RS01",
    "Device": "Prime_RS01",
    "Model": "G2W-RS55HD"
  },
  {
    "Retail Branding": "Gen2Wave",
    "Marketing Name": "RP70A",
    "Device": "RP70A",
    "Model": "RP70A"
  },
  {
    "Retail Branding": "General Dynamics",
    "Marketing Name": "GD Tough Mobile",
    "Device": "granite",
    "Model": "GD Tough Mobile"
  },
  {
    "Retail Branding": "General Dynamics",
    "Marketing Name": "GD Tough mobile",
    "Device": "granite",
    "Model": "GD Tough Mobile"
  },
  {
    "Retail Branding": "General Mobile",
    "Marketing Name": "4G",
    "Device": "gm4g_s_sprout",
    "Model": "General Mobile 4G"
  },
  {
    "Retail Branding": "General Mobile",
    "Marketing Name": "4G",
    "Device": "gm4gtkc_s_sprout",
    "Model": "General Mobile 4G"
  },
  {
    "Retail Branding": "General Mobile",
    "Marketing Name": "4G Dual",
    "Device": "gm4g_sprout",
    "Model": "General Mobile 4G Dual"
  },
  {
    "Retail Branding": "General Mobile",
    "Marketing Name": 5,
    "Device": "gm5_s_sprout",
    "Model": "GM 5"
  },
  {
    "Retail Branding": "General Mobile",
    "Marketing Name": "Discovery Air",
    "Device": "Discovery_Air",
    "Model": "Discovery Air"
  },
  {
    "Retail Branding": "General Mobile",
    "Marketing Name": "Discovery II Mini",
    "Device": "Discovery_II_Mini",
    "Model": "Discovery II Mini"
  },
  {
    "Retail Branding": "General Mobile",
    "Marketing Name": "E-tab 4",
    "Device": "mehmet",
    "Model": "e-tab4"
  },
  {
    "Retail Branding": "General Mobile",
    "Marketing Name": "Era 30 PRO",
    "Device": "G519",
    "Model": "G519"
  },
  {
    "Retail Branding": "General Mobile",
    "Marketing Name": "Etab5",
    "Device": "Etab5",
    "Model": "Etab5"
  },
  {
    "Retail Branding": "General Mobile",
    "Marketing Name": "G310",
    "Device": "G310",
    "Model": "G310"
  },
  {
    "Retail Branding": "General Mobile",
    "Marketing Name": "G518",
    "Device": "G518",
    "Model": "G518"
  },
  {
    "Retail Branding": "General Mobile",
    "Marketing Name": "G903",
    "Device": "G903",
    "Model": "G903"
  },
  {
    "Retail Branding": "General Mobile",
    "Marketing Name": "G904",
    "Device": "G904",
    "Model": "G904"
  },
  {
    "Retail Branding": "General Mobile",
    "Marketing Name": "GM 20",
    "Device": "G301",
    "Model": "G301"
  },
  {
    "Retail Branding": "General Mobile",
    "Marketing Name": "GM 20 PRO",
    "Device": "G501",
    "Model": "G501"
  },
  {
    "Retail Branding": "General Mobile",
    "Marketing Name": "GM 20 Pro",
    "Device": "G501",
    "Model": "G501"
  },
  {
    "Retail Branding": "General Mobile",
    "Marketing Name": "GM 21",
    "Device": "G310",
    "Model": "G310"
  },
  {
    "Retail Branding": "General Mobile",
    "Marketing Name": "GM 21 Plus",
    "Device": "G510",
    "Model": "G510"
  },
  {
    "Retail Branding": "General Mobile",
    "Marketing Name": "GM 21 Pro",
    "Device": "G700",
    "Model": "G700"
  },
  {
    "Retail Branding": "General Mobile",
    "Marketing Name": "GM 22",
    "Device": "G312",
    "Model": "G312"
  },
  {
    "Retail Branding": "General Mobile",
    "Marketing Name": "GM 22 Plus",
    "Device": "G512",
    "Model": "G512"
  },
  {
    "Retail Branding": "General Mobile",
    "Marketing Name": "GM 22 Pro",
    "Device": "G702",
    "Model": "G702"
  },
  {
    "Retail Branding": "General Mobile",
    "Marketing Name": "GM 23 Dual",
    "Device": "G316",
    "Model": "G316"
  },
  {
    "Retail Branding": "General Mobile",
    "Marketing Name": "GM 23 SE Dual",
    "Device": "G314",
    "Model": "G314"
  },
  {
    "Retail Branding": "General Mobile",
    "Marketing Name": "GM 23 SE Single",
    "Device": "G314",
    "Model": "G314"
  },
  {
    "Retail Branding": "General Mobile",
    "Marketing Name": "GM 23 Single",
    "Device": "G316",
    "Model": "G316"
  },
  {
    "Retail Branding": "General Mobile",
    "Marketing Name": "GM 24",
    "Device": "G319",
    "Model": "G319"
  },
  {
    "Retail Branding": "General Mobile",
    "Marketing Name": "GM 24 Pro",
    "Device": "G514",
    "Model": "G514"
  },
  {
    "Retail Branding": "General Mobile",
    "Marketing Name": "GM 26 5G",
    "Device": "G905",
    "Model": "G905"
  },
  {
    "Retail Branding": "General Mobile",
    "Marketing Name": "GM 6 d",
    "Device": "GM6_d_sprout",
    "Model": "GM 6 d"
  },
  {
    "Retail Branding": "General Mobile",
    "Marketing Name": "GM 6 ds",
    "Device": "G100",
    "Model": "G100"
  },
  {
    "Retail Branding": "General Mobile",
    "Marketing Name": "GM 6 s",
    "Device": "GM6_s_sprout",
    "Model": "GM 6"
  },
  {
    "Retail Branding": "General Mobile",
    "Marketing Name": "GM 6 s",
    "Device": "GM6_s_sprout",
    "Model": "GM6"
  },
  {
    "Retail Branding": "General Mobile",
    "Marketing Name": "GM 8",
    "Device": "GM8_sprout",
    "Model": "GM 8"
  },
  {
    "Retail Branding": "General Mobile",
    "Marketing Name": "GM 8 d",
    "Device": "GM8_d_sprout",
    "Model": "GM 8 d"
  },
  {
    "Retail Branding": "General Mobile",
    "Marketing Name": "GM 9 Go",
    "Device": "G008",
    "Model": "G008"
  },
  {
    "Retail Branding": "General Mobile",
    "Marketing Name": "GM 9 Go",
    "Device": "G008_d",
    "Model": "G008"
  },
  {
    "Retail Branding": "General Mobile",
    "Marketing Name": "GM 9 Plus",
    "Device": "GM9PLUS_s",
    "Model": "GM 9 Plus"
  },
  {
    "Retail Branding": "General Mobile",
    "Marketing Name": "GM 9 Pro",
    "Device": "GM9PRO_d_sprout",
    "Model": "GM 9 Pro d"
  },
  {
    "Retail Branding": "General Mobile",
    "Marketing Name": "GM 9 Pro",
    "Device": "GM9PRO_sprout",
    "Model": "GM 9 Pro"
  },
  {
    "Retail Branding": "General Mobile",
    "Marketing Name": "GM Era 50",
    "Device": "G318",
    "Model": "G318"
  },
  {
    "Retail Branding": "General Mobile",
    "Marketing Name": "GM Phoenix 5G d",
    "Device": "G901",
    "Model": "G901"
  },
  {
    "Retail Branding": "General Mobile",
    "Marketing Name": "GM10",
    "Device": "G300",
    "Model": "G300"
  },
  {
    "Retail Branding": "General Mobile",
    "Marketing Name": "GM5 Plus",
    "Device": "gm5plus_s_sprout",
    "Model": "GM 5 Plus"
  },
  {
    "Retail Branding": "General Mobile",
    "Marketing Name": "GM5 Plus Turkcell",
    "Device": "gm5plustkc_s_sprout",
    "Model": "GM 5 Plus"
  },
  {
    "Retail Branding": "General Mobile",
    "Marketing Name": "GM5 Plus d",
    "Device": "gm5plus_sprout",
    "Model": "GM 5 Plus d"
  },
  {
    "Retail Branding": "General Mobile",
    "Marketing Name": "GM8",
    "Device": "GM8_d_sprout",
    "Model": "GM 8 d"
  },
  {
    "Retail Branding": "General Mobile",
    "Marketing Name": "GM8",
    "Device": "GM8_sprout",
    "Model": "GM 8"
  },
  {
    "Retail Branding": "General Mobile",
    "Marketing Name": "GM8 Go",
    "Device": "GM8_go",
    "Model": "GM8 go"
  },
  {
    "Retail Branding": "General Mobile",
    "Marketing Name": "GM8 Go",
    "Device": "GM8_go_sc",
    "Model": "GM8 go"
  },
  {
    "Retail Branding": "General Mobile",
    "Marketing Name": "General Mobile 5 d",
    "Device": "gm5_sprout",
    "Model": "GM 5 d"
  },
  {
    "Retail Branding": "General Mobile",
    "Marketing Name": "e-tab 20",
    "Device": "e-tab20",
    "Model": "e-tab 20"
  },
  {
    "Retail Branding": "General Mobile",
    "Marketing Name": "e-tab 20",
    "Device": "e-tab20_variant",
    "Model": "e-tab 20"
  },
  {
    "Retail Branding": "General Motors",
    "Marketing Name": "Infotainment 3.7",
    "Device": "gminfo37",
    "Model": "gminfo37"
  },
  {
    "Retail Branding": "General Motors",
    "Marketing Name": "Infotainment 3.8",
    "Device": "gminfo37",
    "Model": "gminfo38"
  },
  {
    "Retail Branding": "General Motors",
    "Marketing Name": "VCU",
    "Device": "aegean",
    "Model": "GM Infotainment System"
  },
  {
    "Retail Branding": "General Motors",
    "Marketing Name": "VCU",
    "Device": "aegean",
    "Model": "Infotainment System"
  },
  {
    "Retail Branding": "General Motors",
    "Marketing Name": "VCU",
    "Device": "aegean",
    "Model": "aegean"
  },
  {
    "Retail Branding": "General Motors",
    "Marketing Name": "VCU",
    "Device": "burmese",
    "Model": "GM Infotainment System"
  },
  {
    "Retail Branding": "General Motors",
    "Marketing Name": "VCU",
    "Device": "burmese",
    "Model": "Premium Infotainment System"
  },
  {
    "Retail Branding": "General Motors",
    "Marketing Name": "VCU",
    "Device": "burmese",
    "Model": "burmese"
  },
  {
    "Retail Branding": "GeneralMobile",
    "Marketing Name": "E-Tab10",
    "Device": "blue_eye",
    "Model": "E-Tab10"
  },
  {
    "Retail Branding": "GeneralSupreme",
    "Marketing Name": "Smart TV",
    "Device": "alimos",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "GeneralSupreme",
    "Marketing Name": "Smart TV",
    "Device": "longshan",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "General_luxe",
    "Marketing Name": "F35",
    "Device": "F35",
    "Model": "F35"
  },
  {
    "Retail Branding": "General_luxe",
    "Marketing Name": "Shahin_III",
    "Device": "Shahin_III",
    "Model": "SHAHIN III"
  },
  {
    "Retail Branding": "Geniatech",
    "Marketing Name": "ATV495MAX",
    "Device": "enjoytv",
    "Model": "ATV495MAX"
  },
  {
    "Retail Branding": "Geniatech",
    "Marketing Name": "Enjoy TV Quad-Core Box",
    "Device": "ATV581",
    "Model": "Enjoy TV Quad-Core Box"
  },
  {
    "Retail Branding": "Geniatech",
    "Marketing Name": "EnjoyTV",
    "Device": "enjoytv",
    "Model": "ATV495MAX"
  },
  {
    "Retail Branding": "Geniatech",
    "Marketing Name": "Enjoytv_hybrid",
    "Device": "enjoytv_hybrid",
    "Model": "ATV598MAX"
  },
  {
    "Retail Branding": "Geniora",
    "Marketing Name": "GEN1",
    "Device": "GEN1",
    "Model": "GEN1"
  },
  {
    "Retail Branding": "Geo (GeoTechVision)",
    "Marketing Name": "GEO10",
    "Device": "GEO10",
    "Model": "GEO10X"
  },
  {
    "Retail Branding": "GeoMax",
    "Marketing Name": "GeoMax Zenius08",
    "Device": "Zenius08",
    "Model": "GMT-08QA-2301"
  },
  {
    "Retail Branding": "GeoPhone",
    "Marketing Name": "geo_s7",
    "Device": "geo_S7",
    "Model": "Geo S7"
  },
  {
    "Retail Branding": "Geoelectron",
    "Marketing Name": "P9IV",
    "Device": "P9IV_Handheld",
    "Model": "P9IV"
  },
  {
    "Retail Branding": "Geoelectron",
    "Marketing Name": "P9IV_Handheld_EEA",
    "Device": "P9IV_Handheld",
    "Model": "P9IV"
  },
  {
    "Retail Branding": "Gertec",
    "Marketing Name": "SK-210",
    "Device": "SK-210",
    "Model": "SK-210"
  },
  {
    "Retail Branding": "Gesellschaft für SMK mBH",
    "Marketing Name": "Tough Mobile",
    "Device": "granite",
    "Model": "CP600"
  },
  {
    "Retail Branding": "Geshem",
    "Marketing Name": "GS0882T",
    "Device": "GS0882T",
    "Model": "GS0882T"
  },
  {
    "Retail Branding": "Geshem",
    "Marketing Name": "GS0883T",
    "Device": "GS0883T",
    "Model": "GS0883T"
  },
  {
    "Retail Branding": "Geshem",
    "Marketing Name": "GS1081T",
    "Device": "GS1081T",
    "Model": "GS1081T"
  },
  {
    "Retail Branding": "Geshem",
    "Marketing Name": "GS109M2A_EEA",
    "Device": "GS109M2A",
    "Model": "GS109M2A"
  },
  {
    "Retail Branding": "Geshem",
    "Marketing Name": "GS109M3A_EEA",
    "Device": "GS109M3A",
    "Model": "GS109M3A"
  },
  {
    "Retail Branding": "Geshem",
    "Marketing Name": "GS81TE",
    "Device": "GS81TE",
    "Model": "GS81TE"
  },
  {
    "Retail Branding": "Get",
    "Marketing Name": 66896,
    "Device": 72839,
    "Model": 66896
  },
  {
    "Retail Branding": "Get",
    "Marketing Name": "Get Box",
    "Device": "dciw387get",
    "Model": "Get boX"
  },
  {
    "Retail Branding": "Get",
    "Marketing Name": "Get Box",
    "Device": "dciw387get",
    "Model": "Get box"
  },
  {
    "Retail Branding": "Get",
    "Marketing Name": "Get Box",
    "Device": "dciw387get",
    "Model": "Telia box"
  },
  {
    "Retail Branding": "Getac",
    "Marketing Name": "MX50",
    "Device": "mx50",
    "Model": "MX50"
  },
  {
    "Retail Branding": "Getac",
    "Marketing Name": "MX50",
    "Device": "mx50",
    "Model": "mx50"
  },
  {
    "Retail Branding": "Getac",
    "Marketing Name": "Z710",
    "Device": "z710",
    "Model": "Getac Z710"
  },
  {
    "Retail Branding": "Getac",
    "Marketing Name": "ZX10",
    "Device": "zx10",
    "Model": "ZX10"
  },
  {
    "Retail Branding": "Getac",
    "Marketing Name": "ZX10G2",
    "Device": "zx10g2",
    "Model": "ZX10G2"
  },
  {
    "Retail Branding": "Getac",
    "Marketing Name": "ZX70",
    "Device": "zx70",
    "Model": "ZX70"
  },
  {
    "Retail Branding": "Getac",
    "Marketing Name": "ZX70",
    "Device": "zx70",
    "Model": "zx70"
  },
  {
    "Retail Branding": "Getac",
    "Marketing Name": "ZX70G2",
    "Device": "zx70g2",
    "Model": "ZX70G2"
  },
  {
    "Retail Branding": "Getac",
    "Marketing Name": "ZX80",
    "Device": "zx80",
    "Model": "ZX80"
  },
  {
    "Retail Branding": "Getnord",
    "Marketing Name": "LYNX",
    "Device": "LYNX",
    "Model": "LYNX"
  },
  {
    "Retail Branding": "Gevo",
    "Marketing Name": "Gevo E10",
    "Device": "E10",
    "Model": "GEVO E10"
  },
  {
    "Retail Branding": "Gevo",
    "Marketing Name": "Gevo V20",
    "Device": "V20",
    "Model": "Gevo S6801"
  },
  {
    "Retail Branding": "Gevo",
    "Marketing Name": "V10",
    "Device": "Gevo_V10",
    "Model": "V10"
  },
  {
    "Retail Branding": "Gfast",
    "Marketing Name": "MD_97_S464A",
    "Device": "MD_97_S464A",
    "Model": "MD_97_S464A"
  },
  {
    "Retail Branding": "Ghia",
    "Marketing Name": "A7LED2",
    "Device": "A7LED2",
    "Model": "A7LED2"
  },
  {
    "Retail Branding": "Ghia",
    "Marketing Name": "A7_3G",
    "Device": "A7_3G",
    "Model": "A7_3G"
  },
  {
    "Retail Branding": "Ghia",
    "Marketing Name": "A7_SLIM",
    "Device": "A7_SLIM",
    "Model": "A7_SLIM"
  },
  {
    "Retail Branding": "Ghia",
    "Marketing Name": "A7_WF",
    "Device": "A7_WF",
    "Model": "A7_WF"
  },
  {
    "Retail Branding": "Ghia",
    "Marketing Name": "AXIS7_LED",
    "Device": "AXIS7_LED",
    "Model": "AXIS7_LED"
  },
  {
    "Retail Branding": "Ghia",
    "Marketing Name": "AXIS7_SLIM",
    "Device": "AXIS7_SLIM",
    "Model": "AXIS7_SLIM"
  },
  {
    "Retail Branding": "Ghia",
    "Marketing Name": "Beetle7",
    "Device": "Beetle7",
    "Model": "Beetle7"
  },
  {
    "Retail Branding": "Ghia",
    "Marketing Name": "G1",
    "Device": "G1",
    "Model": "G1"
  },
  {
    "Retail Branding": "Ghia",
    "Marketing Name": "GA7133",
    "Device": "GA7133",
    "Model": "GA7133"
  },
  {
    "Retail Branding": "Ghia",
    "Marketing Name": "GA7333",
    "Device": "GA7333",
    "Model": "GA7333"
  },
  {
    "Retail Branding": "Ghia",
    "Marketing Name": "GA8N",
    "Device": "GA8N",
    "Model": "GA8N"
  },
  {
    "Retail Branding": "Ghia",
    "Marketing Name": "GA8N2",
    "Device": "GA8N2",
    "Model": "GA8N2"
  },
  {
    "Retail Branding": "Ghia",
    "Marketing Name": "GHIA",
    "Device": "stanford",
    "Model": "SMART TV"
  },
  {
    "Retail Branding": "Ghia",
    "Marketing Name": "GHIA",
    "Device": "zhongshan",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "Ghia",
    "Marketing Name": "GHIA_A1",
    "Device": "GHIA_A1",
    "Model": "GHIA_A1"
  },
  {
    "Retail Branding": "Ghia",
    "Marketing Name": "GHIA_A7",
    "Device": "GHIA_A7",
    "Model": "GHIA_A7"
  },
  {
    "Retail Branding": "Ghia",
    "Marketing Name": "GHIA_AXIS7",
    "Device": "GHIA_AXIS7",
    "Model": "GHIA_AXIS7"
  },
  {
    "Retail Branding": "Ghia",
    "Marketing Name": "GHIA_AXIS7P",
    "Device": "GHIA_AXIS7P",
    "Model": "GHIA_AXIS7P"
  },
  {
    "Retail Branding": "Ghia",
    "Marketing Name": "GHIA_L1",
    "Device": "GHIA_L1",
    "Model": "GHIA_L1"
  },
  {
    "Retail Branding": "Ghia",
    "Marketing Name": "GHIA_VECTOR_3G",
    "Device": "GHIA_VECTOR_3G",
    "Model": "GHIA_VECTOR_3G"
  },
  {
    "Retail Branding": "Ghia",
    "Marketing Name": "GK133",
    "Device": "GK133",
    "Model": "GK133"
  },
  {
    "Retail Branding": "Ghia",
    "Marketing Name": "GK133D24",
    "Device": "GK133D24",
    "Model": "GK133D24"
  },
  {
    "Retail Branding": "Ghia",
    "Marketing Name": "GK133M24",
    "Device": "GK133M24",
    "Model": "GK133M24"
  },
  {
    "Retail Branding": "Ghia",
    "Marketing Name": "GK133M3",
    "Device": "GK133M3",
    "Model": "GK133M3"
  },
  {
    "Retail Branding": "Ghia",
    "Marketing Name": "GK133N3",
    "Device": "GK133N3",
    "Model": "GK133N3"
  },
  {
    "Retail Branding": "Ghia",
    "Marketing Name": "GK133P24",
    "Device": "GK133P24",
    "Model": "GK133P24"
  },
  {
    "Retail Branding": "Ghia",
    "Marketing Name": "GK133S24",
    "Device": "GK133S24",
    "Model": "GK133S24"
  },
  {
    "Retail Branding": "Ghia",
    "Marketing Name": "GK133S3",
    "Device": "GK133S3",
    "Model": "GK133S3"
  },
  {
    "Retail Branding": "Ghia",
    "Marketing Name": "GK133T3",
    "Device": "GK133T3",
    "Model": "GK133T3"
  },
  {
    "Retail Branding": "Ghia",
    "Marketing Name": "GK133U24",
    "Device": "GK133U24",
    "Model": "GK133U24"
  },
  {
    "Retail Branding": "Ghia",
    "Marketing Name": "GK133V3",
    "Device": "GK133V3",
    "Model": "GK133V3"
  },
  {
    "Retail Branding": "Ghia",
    "Marketing Name": "GK333M25",
    "Device": "GK333M25",
    "Model": "GK333M25"
  },
  {
    "Retail Branding": "Ghia",
    "Marketing Name": "GK333P25",
    "Device": "GK333P25",
    "Model": "GK333P25"
  },
  {
    "Retail Branding": "Ghia",
    "Marketing Name": "GK333U25",
    "Device": "GK333U25",
    "Model": "GK333U25"
  },
  {
    "Retail Branding": "Ghia",
    "Marketing Name": "GK523A24",
    "Device": "GK523A24",
    "Model": "GK523A24"
  },
  {
    "Retail Branding": "Ghia",
    "Marketing Name": "GK537",
    "Device": "GK537",
    "Model": "GK537"
  },
  {
    "Retail Branding": "Ghia",
    "Marketing Name": "GP333",
    "Device": "GP333",
    "Model": "GP333"
  },
  {
    "Retail Branding": "Ghia",
    "Marketing Name": "GPND133",
    "Device": "GPND133",
    "Model": "GPND133"
  },
  {
    "Retail Branding": "Ghia",
    "Marketing Name": "GPND133V4",
    "Device": "GPND133V4",
    "Model": "GPND133V4"
  },
  {
    "Retail Branding": "Ghia",
    "Marketing Name": "GRINV1",
    "Device": "GRINV1",
    "Model": "GRINV1"
  },
  {
    "Retail Branding": "Ghia",
    "Marketing Name": "GS3G",
    "Device": "GS3G",
    "Model": "GS3G"
  },
  {
    "Retail Branding": "Ghia",
    "Marketing Name": "GTA7PLUS",
    "Device": "GTA7PLUS",
    "Model": "GTA7PLUS"
  },
  {
    "Retail Branding": "Ghia",
    "Marketing Name": "GTA7WF",
    "Device": "GTA7WF",
    "Model": "GTA7WF"
  },
  {
    "Retail Branding": "Ghia",
    "Marketing Name": "GTAB718",
    "Device": "GTAB718",
    "Model": "GTAB718"
  },
  {
    "Retail Branding": "Ghia",
    "Marketing Name": "GTABKIDS",
    "Device": "GTABKIDS",
    "Model": "GTABKIDS"
  },
  {
    "Retail Branding": "Ghia",
    "Marketing Name": "GTABPND",
    "Device": "GTABPND",
    "Model": "GTABPND"
  },
  {
    "Retail Branding": "Ghia",
    "Marketing Name": "GTKIDS7-100",
    "Device": "GTKIDS7-100",
    "Model": "GTKIDS7-100"
  },
  {
    "Retail Branding": "Ghia",
    "Marketing Name": "GTKIDS7A",
    "Device": "GTKIDS7A",
    "Model": "GTKIDS7A"
  },
  {
    "Retail Branding": "Ghia",
    "Marketing Name": "GTKIDS7B",
    "Device": "GTKIDS7B",
    "Model": "GTKIDS7B"
  },
  {
    "Retail Branding": "Ghia",
    "Marketing Name": "GTKIDS7R",
    "Device": "GTKIDS7R",
    "Model": "GTKIDS7R"
  },
  {
    "Retail Branding": "Ghia",
    "Marketing Name": "GTKIDS7R8",
    "Device": "GTKIDS7R8",
    "Model": "GTKIDS7R8"
  },
  {
    "Retail Branding": "Ghia",
    "Marketing Name": "GTKIDS7V",
    "Device": "GTKIDS7V",
    "Model": "GTKIDS7V"
  },
  {
    "Retail Branding": "Ghia",
    "Marketing Name": "GTKIDS7V8",
    "Device": "GTKIDS7V8",
    "Model": "GTKIDS7V8"
  },
  {
    "Retail Branding": "Ghia",
    "Marketing Name": "GTPND7",
    "Device": "GTPND7",
    "Model": "GTPND7"
  },
  {
    "Retail Branding": "Ghia",
    "Marketing Name": "GTTODD7",
    "Device": "GTTODD7",
    "Model": "GTTODD7"
  },
  {
    "Retail Branding": "Ghia",
    "Marketing Name": "GTVR10S",
    "Device": "GTVR10S",
    "Model": "GTVR10S"
  },
  {
    "Retail Branding": "Ghia",
    "Marketing Name": "GVLTE13",
    "Device": "GVLTE13",
    "Model": "GVLTE"
  },
  {
    "Retail Branding": "Ghia",
    "Marketing Name": "GVLTE2",
    "Device": "GVLTE2",
    "Model": "GVLTE2"
  },
  {
    "Retail Branding": "Ghia",
    "Marketing Name": "GVP133",
    "Device": "GVP133",
    "Model": "GVP133"
  },
  {
    "Retail Branding": "Ghia",
    "Marketing Name": "GVPN2",
    "Device": "GVPN2",
    "Model": "GVPN2"
  },
  {
    "Retail Branding": "Ghia",
    "Marketing Name": "GVPNT",
    "Device": "GVPNT",
    "Model": "GVPNT"
  },
  {
    "Retail Branding": "Ghia",
    "Marketing Name": "I1",
    "Device": "I1",
    "Model": "I1"
  },
  {
    "Retail Branding": "Ghia",
    "Marketing Name": "TREO_TAB8G",
    "Device": "TREO_TAB8G",
    "Model": "TREO_TAB8G"
  },
  {
    "Retail Branding": "Ghia",
    "Marketing Name": "VECTOR10.1",
    "Device": "VECTOR10_1",
    "Model": "VECTOR10.1"
  },
  {
    "Retail Branding": "Ghia",
    "Marketing Name": "VECTOR10Plus",
    "Device": "VECTOR10Plus",
    "Model": "VECTOR10Plus"
  },
  {
    "Retail Branding": "Ghia",
    "Marketing Name": "VECTOR_SLIM",
    "Device": "VECTOR_SLIM",
    "Model": "VECTOR_SLIM"
  },
  {
    "Retail Branding": "Ghia",
    "Marketing Name": "VECTOR_SLIM2",
    "Device": "VECTOR_SLIM2",
    "Model": "VECTOR_SLIM2"
  },
  {
    "Retail Branding": "Ghia",
    "Marketing Name": "Vector_3G",
    "Device": "Vector_3G",
    "Model": "Vector_3G"
  },
  {
    "Retail Branding": "Ghia",
    "Marketing Name": "Venus7",
    "Device": "Venus7",
    "Model": "Venus7"
  },
  {
    "Retail Branding": "Ghia",
    "Marketing Name": "ZEUS 3G",
    "Device": "N2",
    "Model": "GHIA_ZEUS_3G"
  },
  {
    "Retail Branding": "Gigabyte",
    "Marketing Name": "",
    "Device": "G1317S",
    "Model": "GSmart G1317S"
  },
  {
    "Retail Branding": "Gigabyte",
    "Marketing Name": 9788,
    "Device": 9788,
    "Model": 9788
  },
  {
    "Retail Branding": "Gigabyte",
    "Marketing Name": "Boston 4G",
    "Device": "boston_4g",
    "Model": "Boston 4G"
  },
  {
    "Retail Branding": "Gigabyte",
    "Marketing Name": "E9771",
    "Device": "E9771",
    "Model": "E9771"
  },
  {
    "Retail Branding": "Gigabyte",
    "Marketing Name": "EL-20-3710",
    "Device": "TCV5",
    "Model": "EL-20-3050"
  },
  {
    "Retail Branding": "Gigabyte",
    "Marketing Name": "EL-20-3710",
    "Device": "TCV5",
    "Model": "EL-20-3710"
  },
  {
    "Retail Branding": "Gigabyte",
    "Marketing Name": "GSmart G1310",
    "Device": "G1310",
    "Model": "GSmart G1310"
  },
  {
    "Retail Branding": "Gigabyte",
    "Marketing Name": "GSmart G1315",
    "Device": "G1315",
    "Model": "GSmart G1315"
  },
  {
    "Retail Branding": "Gigabyte",
    "Marketing Name": "GSmart G1317",
    "Device": "G1317D",
    "Model": "GSmart G1317D"
  },
  {
    "Retail Branding": "Gigabyte",
    "Marketing Name": "GSmart G1342",
    "Device": "msm7627a",
    "Model": "GSmart G1342"
  },
  {
    "Retail Branding": "Gigabyte",
    "Marketing Name": "GSmart G1345",
    "Device": "msm7627_sku2",
    "Model": "GSmart G1345"
  },
  {
    "Retail Branding": "Gigabyte",
    "Marketing Name": "GSmart G1355",
    "Device": "G1355",
    "Model": "GSmart G1355"
  },
  {
    "Retail Branding": "Gigabyte",
    "Marketing Name": "GSmart G1362",
    "Device": "G1362",
    "Model": "GSmart G1362"
  },
  {
    "Retail Branding": "Gigabyte",
    "Marketing Name": "GSmart GS202",
    "Device": "GS202",
    "Model": "GSmart GS202"
  },
  {
    "Retail Branding": "Gigabyte",
    "Marketing Name": "Hipstreet 9DTB7 / Lazer MY9308P",
    "Device": "AMLMY9308P",
    "Model": "9DTB7"
  },
  {
    "Retail Branding": "Gigabyte",
    "Marketing Name": "Hipstreet 9DTB7 / Lazer MY9308P",
    "Device": "AMLMY9308P",
    "Model": "MY9308P"
  },
  {
    "Retail Branding": "Gigabyte",
    "Marketing Name": "P102g",
    "Device": "P102g",
    "Model": "P102G"
  },
  {
    "Retail Branding": "Gigabyte",
    "Marketing Name": "PAPILIO G1",
    "Device": "inhon77_cidals",
    "Model": "INHON PAPILIO G1"
  },
  {
    "Retail Branding": "Gigabyte",
    "Marketing Name": "PROSCAN PLT1066 / MAG MAGPAD / TEAC TEACTAB / DOPO GS-1008",
    "Device": "MID1005_K",
    "Model": "GS-1008"
  },
  {
    "Retail Branding": "Gigabyte",
    "Marketing Name": "PROSCAN PLT1066 / MAG MAGPAD / TEAC TEACTAB / DOPO GS-1008",
    "Device": "MID1005_K",
    "Model": "MAGPAD"
  },
  {
    "Retail Branding": "Gigabyte",
    "Marketing Name": "PROSCAN PLT1066 / MAG MAGPAD / TEAC TEACTAB / DOPO GS-1008",
    "Device": "MID1005_K",
    "Model": "PLT1066"
  },
  {
    "Retail Branding": "Gigabyte",
    "Marketing Name": "PROSCAN PLT1066 / MAG MAGPAD / TEAC TEACTAB / DOPO GS-1008",
    "Device": "MID1005_K",
    "Model": "TEACTAB"
  },
  {
    "Retail Branding": "Gigabyte",
    "Marketing Name": "SAF3011",
    "Device": "SAF3011",
    "Model": "SAF3011"
  },
  {
    "Retail Branding": "Gigabyte",
    "Marketing Name": "SB506",
    "Device": "SB506",
    "Model": "SB506"
  },
  {
    "Retail Branding": "Gigabyte",
    "Marketing Name": "SB510 / IBT-102",
    "Device": "SB510",
    "Model": "SB510"
  },
  {
    "Retail Branding": "Gigabyte",
    "Marketing Name": "TB100",
    "Device": "TB100",
    "Model": "Gigabyte TB100"
  },
  {
    "Retail Branding": "Gigabyte",
    "Marketing Name": "TB100",
    "Device": "TB100",
    "Model": "TB100"
  },
  {
    "Retail Branding": "Gigabyte",
    "Marketing Name": "TECNO P3S",
    "Device": "P3S",
    "Model": "TECNO P3S"
  },
  {
    "Retail Branding": "Gigabyte",
    "Marketing Name": "TM105",
    "Device": "TM105",
    "Model": "TM105"
  },
  {
    "Retail Branding": "Gigabyte",
    "Marketing Name": "TM105A",
    "Device": "TM105A",
    "Model": "Aero1021/P1021HCBA4C1VXX"
  },
  {
    "Retail Branding": "Gigabyte",
    "Marketing Name": "TM105A",
    "Device": "TM105A",
    "Model": "Glacier"
  },
  {
    "Retail Branding": "Gigabyte",
    "Marketing Name": "TM105A",
    "Device": "TM105A",
    "Model": "Qrypton1010"
  },
  {
    "Retail Branding": "Gigabyte",
    "Marketing Name": "TM105A",
    "Device": "TM105A",
    "Model": "TM105A"
  },
  {
    "Retail Branding": "Gigabyte",
    "Marketing Name": "TM75A",
    "Device": "TM75A",
    "Model": "GSmart7Tab"
  },
  {
    "Retail Branding": "Gigabyte",
    "Marketing Name": "TM75A",
    "Device": "TM75A",
    "Model": "Qrypton7"
  },
  {
    "Retail Branding": "Gigabyte",
    "Marketing Name": "TM75A",
    "Device": "TM75A",
    "Model": "TM75A"
  },
  {
    "Retail Branding": "Gigabyte",
    "Marketing Name": "TM75A",
    "Device": "TM75A",
    "Model": "Voyager"
  },
  {
    "Retail Branding": "Gigabyte",
    "Marketing Name": "TM75A-V",
    "Device": "TM75A-V",
    "Model": "TM75A-V"
  },
  {
    "Retail Branding": "Gigabyte",
    "Marketing Name": "W5510",
    "Device": "W5510",
    "Model": "W5510"
  },
  {
    "Retail Branding": "Gigabyte",
    "Marketing Name": "W6360",
    "Device": "W6360",
    "Model": "W6360"
  },
  {
    "Retail Branding": "Gigabyte",
    "Marketing Name": "huangshan_gigabyte",
    "Device": "huangshan",
    "Model": "SmartTV 4K FFM"
  },
  {
    "Retail Branding": "Gigabyte",
    "Marketing Name": "mexico",
    "Device": "Lanix",
    "Model": "iliumPAD"
  },
  {
    "Retail Branding": "Gigaset",
    "Marketing Name": "GIG-X14",
    "Device": "GIG-X14",
    "Model": "GIG-X14"
  },
  {
    "Retail Branding": "Gigaset",
    "Marketing Name": "GP20",
    "Device": "GP20",
    "Model": "GP20"
  },
  {
    "Retail Branding": "Gigaset",
    "Marketing Name": "GS100",
    "Device": "GS100",
    "Model": "GS100"
  },
  {
    "Retail Branding": "Gigaset",
    "Marketing Name": "GS110",
    "Device": "GS110",
    "Model": "GS110"
  },
  {
    "Retail Branding": "Gigaset",
    "Marketing Name": "GS160",
    "Device": "GS160",
    "Model": "Gigaset GS160"
  },
  {
    "Retail Branding": "Gigaset",
    "Marketing Name": "GS170",
    "Device": "GS170",
    "Model": "Gigaset GS170"
  },
  {
    "Retail Branding": "Gigaset",
    "Marketing Name": "GS180",
    "Device": "GS180",
    "Model": "GS180"
  },
  {
    "Retail Branding": "Gigaset",
    "Marketing Name": "GS185",
    "Device": "GS185",
    "Model": "GS185"
  },
  {
    "Retail Branding": "Gigaset",
    "Marketing Name": "GS190",
    "Device": "GS190",
    "Model": "GS190"
  },
  {
    "Retail Branding": "Gigaset",
    "Marketing Name": "GS195",
    "Device": "GS195",
    "Model": "GS195"
  },
  {
    "Retail Branding": "Gigaset",
    "Marketing Name": "GS280",
    "Device": "GS280",
    "Model": "GS280"
  },
  {
    "Retail Branding": "Gigaset",
    "Marketing Name": "GS290",
    "Device": "GS290",
    "Model": "GS290"
  },
  {
    "Retail Branding": "Gigaset",
    "Marketing Name": "GS5",
    "Device": "GS5",
    "Model": "E940-2796-00"
  },
  {
    "Retail Branding": "Gigaset",
    "Marketing Name": "GS5 LITE",
    "Device": "GS5_LITE",
    "Model": "E940-2878-03"
  },
  {
    "Retail Branding": "Gigaset",
    "Marketing Name": "GS5 PRO",
    "Device": "GS5_PRO",
    "Model": "E940-2796-05"
  },
  {
    "Retail Branding": "Gigaset",
    "Marketing Name": "GS5 Senior",
    "Device": "GS5_Senior",
    "Model": "E940-2878-03S"
  },
  {
    "Retail Branding": "Gigaset",
    "Marketing Name": "GS6",
    "Device": "GS6",
    "Model": "E940-3042-00"
  },
  {
    "Retail Branding": "Gigaset",
    "Marketing Name": "GS6 PRO",
    "Device": "GS6_Venus",
    "Model": "E940-3043-00"
  },
  {
    "Retail Branding": "Gigaset",
    "Marketing Name": "GS6_PRO",
    "Device": "GS6_PRO",
    "Model": "E940-2940-00"
  },
  {
    "Retail Branding": "Gigaset",
    "Marketing Name": "GS80",
    "Device": "GS80",
    "Model": "GS80"
  },
  {
    "Retail Branding": "Gigaset",
    "Marketing Name": "GTX50",
    "Device": "GTX50",
    "Model": "E940-3060-00"
  },
  {
    "Retail Branding": "Gigaset",
    "Marketing Name": "GX290",
    "Device": "GX290",
    "Model": "GX290"
  },
  {
    "Retail Branding": "Gigaset",
    "Marketing Name": "Gigaset GS170",
    "Device": "GS170",
    "Model": "Gigaset GS170"
  },
  {
    "Retail Branding": "Gigaset",
    "Marketing Name": "Gigaset GS185",
    "Device": "GS185",
    "Model": "GS185"
  },
  {
    "Retail Branding": "Gigaset",
    "Marketing Name": "Gigaset GS270",
    "Device": "Gigaset_GS270",
    "Model": "GS270"
  },
  {
    "Retail Branding": "Gigaset",
    "Marketing Name": "Gigaset GS270 plus",
    "Device": "Gigaset_GS270_plus",
    "Model": "GS270 plus"
  },
  {
    "Retail Branding": "Gigaset",
    "Marketing Name": "Gigaset GS3",
    "Device": "GS3",
    "Model": "E940-2766-00"
  },
  {
    "Retail Branding": "Gigaset",
    "Marketing Name": "Gigaset GS370",
    "Device": "GS370",
    "Model": "GS370"
  },
  {
    "Retail Branding": "Gigaset",
    "Marketing Name": "Gigaset GS370_Plus",
    "Device": "GS370_Plus",
    "Model": "GS370_Plus"
  },
  {
    "Retail Branding": "Gigaset",
    "Marketing Name": "Gigaset GS4",
    "Device": "Gigaset_GS4",
    "Model": "E940-2795-00"
  },
  {
    "Retail Branding": "Gigaset",
    "Marketing Name": "Gigaset GX4",
    "Device": "GX4",
    "Model": "E940-2797-00"
  },
  {
    "Retail Branding": "Gigaset",
    "Marketing Name": "Gigaset GX4 PRO",
    "Device": "GX4_PRO",
    "Model": "E940-2797-01"
  },
  {
    "Retail Branding": "Gigaset",
    "Marketing Name": "Gigaset GX6",
    "Device": "GX6",
    "Model": "E940-2849-00"
  },
  {
    "Retail Branding": "Gigaset",
    "Marketing Name": "Gigaset GX6 PRO",
    "Device": "GX6_PRO",
    "Model": "E940-2849-01"
  },
  {
    "Retail Branding": "Gigaset",
    "Marketing Name": "Gigaset Maxwell 10",
    "Device": "maxwell_10",
    "Model": "Maxwell-10"
  },
  {
    "Retail Branding": "Gigaset",
    "Marketing Name": "ME",
    "Device": "ME",
    "Model": "GS55-6"
  },
  {
    "Retail Branding": "Gigaset",
    "Marketing Name": "ME Pro",
    "Device": "MEpro",
    "Model": "GS57-6"
  },
  {
    "Retail Branding": "Gigaset",
    "Marketing Name": "ME Pure",
    "Device": "MEpure",
    "Model": "GS53-6"
  },
  {
    "Retail Branding": "Gigaset",
    "Marketing Name": "Maxwell 10",
    "Device": "maxwell_10",
    "Model": "80-1"
  },
  {
    "Retail Branding": "Gigaset",
    "Marketing Name": "Maxwell-10",
    "Device": "maxwell_10",
    "Model": "80-1"
  },
  {
    "Retail Branding": "Gigaset",
    "Marketing Name": "Maxwell-10",
    "Device": "maxwell_10",
    "Model": "Maxwell-10"
  },
  {
    "Retail Branding": "Gigaset",
    "Marketing Name": "QV1030",
    "Device": "FG6Q",
    "Model": "Gigaset QV1030"
  },
  {
    "Retail Branding": "Gigaset",
    "Marketing Name": "QV830",
    "Device": "UY8",
    "Model": "Gigaset QV830"
  },
  {
    "Retail Branding": "Gigaset",
    "Marketing Name": "QV831",
    "Device": "UY8",
    "Model": "Gigaset QV831"
  },
  {
    "Retail Branding": "Gigaset",
    "Marketing Name": "SL930",
    "Device": "lion_s",
    "Model": "SL930"
  },
  {
    "Retail Branding": "Gini",
    "Marketing Name": "GINI_Tab_V8",
    "Device": "GINI_Tab_V8",
    "Model": "GINI_Tab_V8"
  },
  {
    "Retail Branding": "Gini",
    "Marketing Name": "Gini n9",
    "Device": "Gini_n9",
    "Model": "Gini n9"
  },
  {
    "Retail Branding": "Gini",
    "Marketing Name": "Gini s5Pro",
    "Device": "Gini_s5Pro",
    "Model": "s5Pro"
  },
  {
    "Retail Branding": "Gini",
    "Marketing Name": "Gini w7",
    "Device": "Gini_w7",
    "Model": "Gini w7"
  },
  {
    "Retail Branding": "Gini",
    "Marketing Name": "N6",
    "Device": "N6",
    "Model": "N6"
  },
  {
    "Retail Branding": "Gini",
    "Marketing Name": "e6_plus",
    "Device": "e6",
    "Model": "e6"
  },
  {
    "Retail Branding": "Gini",
    "Marketing Name": "e6_plus",
    "Device": "e6_plus",
    "Model": "e6_plus"
  },
  {
    "Retail Branding": "Gini",
    "Marketing Name": "n7",
    "Device": "n7",
    "Model": "n7"
  },
  {
    "Retail Branding": "Gini",
    "Marketing Name": "n8",
    "Device": "Gini_n8",
    "Model": "Gini n8"
  },
  {
    "Retail Branding": "Gini",
    "Marketing Name": "s4",
    "Device": "s4",
    "Model": "s4"
  },
  {
    "Retail Branding": "Gini",
    "Marketing Name": "s4_pro",
    "Device": "s4_pro",
    "Model": "s4_pro"
  },
  {
    "Retail Branding": "Gini",
    "Marketing Name": "w5",
    "Device": "w5",
    "Model": "w5"
  },
  {
    "Retail Branding": "Gini",
    "Marketing Name": "w6",
    "Device": "w6",
    "Model": "w6"
  },
  {
    "Retail Branding": "Ginzzu",
    "Marketing Name": "GT-1015",
    "Device": "GT-1015",
    "Model": "GT-1015"
  },
  {
    "Retail Branding": "Ginzzu",
    "Marketing Name": "GT-1045",
    "Device": "GT-1045",
    "Model": "GT-1045"
  },
  {
    "Retail Branding": "Ginzzu",
    "Marketing Name": "GT-1050",
    "Device": "GT-1050",
    "Model": "Ginzzu GT-1050"
  },
  {
    "Retail Branding": "Ginzzu",
    "Marketing Name": "GT-7100",
    "Device": "GT-7100",
    "Model": "GT-7100"
  },
  {
    "Retail Branding": "Ginzzu",
    "Marketing Name": "GT-7115",
    "Device": "GT-7115",
    "Model": "Ginzzu GT-7115"
  },
  {
    "Retail Branding": "Ginzzu",
    "Marketing Name": "GT-7205",
    "Device": "GT-7205",
    "Model": "GT-7205"
  },
  {
    "Retail Branding": "Ginzzu",
    "Marketing Name": "GT-7210",
    "Device": "GT-7210",
    "Model": "Ginzzu GT-7210"
  },
  {
    "Retail Branding": "Ginzzu",
    "Marketing Name": "GT-8105",
    "Device": "GT-8105",
    "Model": "GT-8105"
  },
  {
    "Retail Branding": "Ginzzu",
    "Marketing Name": "GT-8110",
    "Device": "GT-8110",
    "Model": "Ginzzu GT-8110"
  },
  {
    "Retail Branding": "Ginzzu",
    "Marketing Name": "RS8501",
    "Device": "RS8501",
    "Model": "RS8501"
  },
  {
    "Retail Branding": "Ginzzu",
    "Marketing Name": "RS8502",
    "Device": "RS8502",
    "Model": "RS8502"
  },
  {
    "Retail Branding": "Ginzzu",
    "Marketing Name": "RS9602",
    "Device": "RS9602",
    "Model": "RS9602"
  },
  {
    "Retail Branding": "Ginzzu",
    "Marketing Name": "S5002",
    "Device": "S5002",
    "Model": "S5002"
  },
  {
    "Retail Branding": "Ginzzu",
    "Marketing Name": "S5021",
    "Device": "S5021",
    "Model": "S5021"
  },
  {
    "Retail Branding": "Ginzzu",
    "Marketing Name": "S5230",
    "Device": "S5230",
    "Model": "S5230"
  },
  {
    "Retail Branding": "Ginzzu",
    "Marketing Name": "SMART Race 4G",
    "Device": "x2605b_fm45_mtc",
    "Model": "SMART Race 4G"
  },
  {
    "Retail Branding": "Gionee",
    "Marketing Name": "A1",
    "Device": "GIONEE_SWW1609",
    "Model": "GIONEE A1"
  },
  {
    "Retail Branding": "Gionee",
    "Marketing Name": "A1 Lite",
    "Device": "GIONEE_SWW1618",
    "Model": "A1 lite"
  },
  {
    "Retail Branding": "Gionee",
    "Marketing Name": "A1 Plus",
    "Device": "GIONEE_SWW1617",
    "Model": "A1 Plus"
  },
  {
    "Retail Branding": "Gionee",
    "Marketing Name": "A1 lite",
    "Device": "GIONEE_SWW1618",
    "Model": "A1 lite"
  },
  {
    "Retail Branding": "Gionee",
    "Marketing Name": "E8",
    "Device": "GiONEE_GN9008",
    "Model": "E8"
  },
  {
    "Retail Branding": "Gionee",
    "Marketing Name": "E8",
    "Device": "GiONEE_GN9008",
    "Model": "GN9008"
  },
  {
    "Retail Branding": "Gionee",
    "Marketing Name": "F10",
    "Device": "F10",
    "Model": "GIONEE F10"
  },
  {
    "Retail Branding": "Gionee",
    "Marketing Name": "F10 Plus",
    "Device": "F10_Plus",
    "Model": "GIONEE F10 Plus"
  },
  {
    "Retail Branding": "Gionee",
    "Marketing Name": "F100",
    "Device": "GIONEE_GBL7358",
    "Model": "F100"
  },
  {
    "Retail Branding": "Gionee",
    "Marketing Name": "F100A",
    "Device": "GIONEE_GBL7358",
    "Model": "F100A"
  },
  {
    "Retail Branding": "Gionee",
    "Marketing Name": "F100B",
    "Device": "GIONEE_GBL7370",
    "Model": "F100B"
  },
  {
    "Retail Branding": "Gionee",
    "Marketing Name": "F100L",
    "Device": "GIONEE_GBL7370",
    "Model": "F100L"
  },
  {
    "Retail Branding": "Gionee",
    "Marketing Name": "F100S",
    "Device": "GIONEE_GBL7370",
    "Model": "F100S"
  },
  {
    "Retail Branding": "Gionee",
    "Marketing Name": "F103",
    "Device": "GiONEE_GBL7319",
    "Model": "F103"
  },
  {
    "Retail Branding": "Gionee",
    "Marketing Name": "F103 Pro",
    "Device": "GIONEE_GBL7360",
    "Model": "F103 Pro"
  },
  {
    "Retail Branding": "Gionee",
    "Marketing Name": "F103L",
    "Device": "GiONEE_GBL7319",
    "Model": "F103L"
  },
  {
    "Retail Branding": "Gionee",
    "Marketing Name": "F103S",
    "Device": "GiONEE_F103S",
    "Model": "F103S"
  },
  {
    "Retail Branding": "Gionee",
    "Marketing Name": "F105",
    "Device": "GiONEE_GBL7335",
    "Model": "F105"
  },
  {
    "Retail Branding": "Gionee",
    "Marketing Name": "F105L",
    "Device": "GiONEE_GBL7335",
    "Model": "F105L"
  },
  {
    "Retail Branding": "Gionee",
    "Marketing Name": "F106",
    "Device": "GIONEE_SWG1613",
    "Model": "F106"
  },
  {
    "Retail Branding": "Gionee",
    "Marketing Name": "F106L",
    "Device": "GIONEE_SW17G03",
    "Model": "F106L"
  },
  {
    "Retail Branding": "Gionee",
    "Marketing Name": "F109L",
    "Device": "GIONEE_SW17G09",
    "Model": "GIONEE F109L"
  },
  {
    "Retail Branding": "Gionee",
    "Marketing Name": "F109N",
    "Device": "GIONEE_SW17G09",
    "Model": "GIONEE F109N"
  },
  {
    "Retail Branding": "Gionee",
    "Marketing Name": "F11VE",
    "Device": "F11VE",
    "Model": "GIONEE F11VE"
  },
  {
    "Retail Branding": "Gionee",
    "Marketing Name": "F205",
    "Device": "GIONEE_SW17G18",
    "Model": "GIONEE F205"
  },
  {
    "Retail Branding": "Gionee",
    "Marketing Name": "F301",
    "Device": "F301",
    "Model": "F301"
  },
  {
    "Retail Branding": "Gionee",
    "Marketing Name": "F303",
    "Device": "F303",
    "Model": "F303"
  },
  {
    "Retail Branding": "Gionee",
    "Marketing Name": "F5",
    "Device": "GIONEE_SWG1608",
    "Model": "F5"
  },
  {
    "Retail Branding": "Gionee",
    "Marketing Name": "F5L",
    "Device": "GIONEE_SWG1608",
    "Model": "F5L"
  },
  {
    "Retail Branding": "Gionee",
    "Marketing Name": "F6",
    "Device": "GIONEE_SW17G15",
    "Model": "GIONEE F6"
  },
  {
    "Retail Branding": "Gionee",
    "Marketing Name": "F6L",
    "Device": "GIONEE_SW17G15",
    "Model": "GIONEE F6L"
  },
  {
    "Retail Branding": "Gionee",
    "Marketing Name": "F8_Neo",
    "Device": "F8_Neo",
    "Model": "GIONEE F8 Neo"
  },
  {
    "Retail Branding": "Gionee",
    "Marketing Name": "F9",
    "Device": "F9",
    "Model": "GIONEE F9"
  },
  {
    "Retail Branding": "Gionee",
    "Marketing Name": "F9 Plus",
    "Device": "F9_Plus",
    "Model": "GIONEE F9 Plus"
  },
  {
    "Retail Branding": "Gionee",
    "Marketing Name": "ForwardZero",
    "Device": "V6L",
    "Model": "V6L"
  },
  {
    "Retail Branding": "Gionee",
    "Marketing Name": "GIONEE F109",
    "Device": "GIONEE_SW17G09",
    "Model": "GIONEE F109"
  },
  {
    "Retail Branding": "Gionee",
    "Marketing Name": "GIONEE F109L",
    "Device": "GIONEE_SW17G09",
    "Model": "GIONEE F109L"
  },
  {
    "Retail Branding": "Gionee",
    "Marketing Name": "GIONEE F109N",
    "Device": "GIONEE_SW17G09",
    "Model": "GIONEE F109N"
  },
  {
    "Retail Branding": "Gionee",
    "Marketing Name": "GIONEE F11",
    "Device": "GIONEE_F11",
    "Model": "GIONEE F11"
  },
  {
    "Retail Branding": "Gionee",
    "Marketing Name": "GIONEE F205L",
    "Device": "GIONEE_SW17G18",
    "Model": "GIONEE F205L"
  },
  {
    "Retail Branding": "Gionee",
    "Marketing Name": "GIONEE GN5007",
    "Device": "GIONEE_BJ17G16",
    "Model": "GIONEE GN5007"
  },
  {
    "Retail Branding": "Gionee",
    "Marketing Name": "GIONEE GN5007L",
    "Device": "GIONEE_BJ17G16",
    "Model": "GIONEE GN5007L"
  },
  {
    "Retail Branding": "Gionee",
    "Marketing Name": "GIONEE H601",
    "Device": "GIONEE_H601",
    "Model": "GIONEE S12"
  },
  {
    "Retail Branding": "Gionee",
    "Marketing Name": "GIONEE M15",
    "Device": "GIONEE_M15",
    "Model": "GIONEE M15"
  },
  {
    "Retail Branding": "Gionee",
    "Marketing Name": "GIONEE M7L",
    "Device": "GIONEE_SW17G07",
    "Model": "GIONEE M7L"
  },
  {
    "Retail Branding": "Gionee",
    "Marketing Name": "GIONEE MAX",
    "Device": "GIONEE_MAX",
    "Model": "GIONEE MAX"
  },
  {
    "Retail Branding": "Gionee",
    "Marketing Name": "GIONEE MAX Pro",
    "Device": "GIONEE_MAX_Pro",
    "Model": "GIONEE_MAX Pro"
  },
  {
    "Retail Branding": "Gionee",
    "Marketing Name": "GIONEE P15",
    "Device": "GIONEE_P15",
    "Model": "GIONEE P15"
  },
  {
    "Retail Branding": "Gionee",
    "Marketing Name": "GIONEE P15 Pro",
    "Device": "P15_Pro",
    "Model": "P15 Pro"
  },
  {
    "Retail Branding": "Gionee",
    "Marketing Name": "GIONEE X1",
    "Device": "GIONEE_SWW1631",
    "Model": "GIONEE X1"
  },
  {
    "Retail Branding": "Gionee",
    "Marketing Name": "GIONEE_H603",
    "Device": "GIONEE_H603",
    "Model": "GIONEE M12"
  },
  {
    "Retail Branding": "Gionee",
    "Marketing Name": "GIONEE_H603B",
    "Device": "GIONEE_H603",
    "Model": "GIONEE M12"
  },
  {
    "Retail Branding": "Gionee",
    "Marketing Name": "GIONEE_M100",
    "Device": "GIONEE_M100",
    "Model": "M100"
  },
  {
    "Retail Branding": "Gionee",
    "Marketing Name": "GIONEE_M11",
    "Device": "GIONEE_M11",
    "Model": "M11"
  },
  {
    "Retail Branding": "Gionee",
    "Marketing Name": "GIONEE_P12",
    "Device": "GIONEE_P12",
    "Model": "GIONEE P12"
  },
  {
    "Retail Branding": "Gionee",
    "Marketing Name": "GN152",
    "Device": "GiONEE_CBL7320",
    "Model": "GN152"
  },
  {
    "Retail Branding": "Gionee",
    "Marketing Name": "GN3001",
    "Device": "GiONEE_GBL7523",
    "Model": "GN3001"
  },
  {
    "Retail Branding": "Gionee",
    "Marketing Name": "GN3001L",
    "Device": "GiONEE_GBL7523",
    "Model": "GN3001L"
  },
  {
    "Retail Branding": "Gionee",
    "Marketing Name": "GN3002",
    "Device": "GIONEE_GBL7356",
    "Model": "GN3002"
  },
  {
    "Retail Branding": "Gionee",
    "Marketing Name": "GN3002L",
    "Device": "GIONEE_GBL7356L",
    "Model": "GN3002L"
  },
  {
    "Retail Branding": "Gionee",
    "Marketing Name": "GN3003",
    "Device": "GIONEE_GBL7359",
    "Model": "GN3003"
  },
  {
    "Retail Branding": "Gionee",
    "Marketing Name": "GN3003L",
    "Device": "GIONEE_GBL7359L",
    "Model": "GN3003L"
  },
  {
    "Retail Branding": "Gionee",
    "Marketing Name": "GN5001",
    "Device": "GiONEE_BBL7332",
    "Model": "GN5001"
  },
  {
    "Retail Branding": "Gionee",
    "Marketing Name": "GN5001L",
    "Device": "GiONEE_BBL7332",
    "Model": "GN5001L"
  },
  {
    "Retail Branding": "Gionee",
    "Marketing Name": "GN5001S",
    "Device": "GiONEE_BBL7332",
    "Model": "GN5001S"
  },
  {
    "Retail Branding": "Gionee",
    "Marketing Name": "GN5002",
    "Device": "GiONEE_GBL7333",
    "Model": "GN5002"
  },
  {
    "Retail Branding": "Gionee",
    "Marketing Name": "GN5003",
    "Device": "GiONEE_BBL7337A",
    "Model": "GN5003"
  },
  {
    "Retail Branding": "Gionee",
    "Marketing Name": "GN5005",
    "Device": "GIONEE_G1605A",
    "Model": "GN5005"
  },
  {
    "Retail Branding": "Gionee",
    "Marketing Name": "GN5005",
    "Device": "GIONEE_G1605A",
    "Model": "GN5005L"
  },
  {
    "Retail Branding": "Gionee",
    "Marketing Name": "GN8001",
    "Device": "GiONEE_BBL7505",
    "Model": "GN8001"
  },
  {
    "Retail Branding": "Gionee",
    "Marketing Name": "GN8001L",
    "Device": "GiONEE_BBL7505",
    "Model": "GN8001L"
  },
  {
    "Retail Branding": "Gionee",
    "Marketing Name": "GN8003L",
    "Device": "GiONEE_BBL7515A",
    "Model": "GN8003L"
  },
  {
    "Retail Branding": "Gionee",
    "Marketing Name": "GN9000",
    "Device": "S5_5",
    "Model": "GN9000"
  },
  {
    "Retail Branding": "Gionee",
    "Marketing Name": "GN9006",
    "Device": "GN9006",
    "Model": "GN9006"
  },
  {
    "Retail Branding": "Gionee",
    "Marketing Name": "GN9006",
    "Device": "GN9006",
    "Model": "GiONEE S7"
  },
  {
    "Retail Branding": "Gionee",
    "Marketing Name": "GN9007",
    "Device": "GiONEE_CBL7503",
    "Model": "GN9007"
  },
  {
    "Retail Branding": "Gionee",
    "Marketing Name": "GN9010L",
    "Device": "GiONEE_CBL7513",
    "Model": "GN9010L"
  },
  {
    "Retail Branding": "Gionee",
    "Marketing Name": "GN9012",
    "Device": "GIONEE_GBL7529",
    "Model": "GN9012"
  },
  {
    "Retail Branding": "Gionee",
    "Marketing Name": "Gtel_X5pro",
    "Device": "Gtel_X5pro",
    "Model": "Gtel_X5pro"
  },
  {
    "Retail Branding": "Gionee",
    "Marketing Name": "India",
    "Device": "F205_Pro",
    "Model": "GIONEE F205 Pro"
  },
  {
    "Retail Branding": "Gionee",
    "Marketing Name": "M2",
    "Device": "M2",
    "Model": "M2"
  },
  {
    "Retail Branding": "Gionee",
    "Marketing Name": "M2017",
    "Device": "GIONEE_GBL8918",
    "Model": "M2017"
  },
  {
    "Retail Branding": "Gionee",
    "Marketing Name": "M2mini",
    "Device": "GiONEE_WBW5612",
    "Model": "M2mini"
  },
  {
    "Retail Branding": "Gionee",
    "Marketing Name": "M3",
    "Device": "GiONEE_M3",
    "Model": "M3"
  },
  {
    "Retail Branding": "Gionee",
    "Marketing Name": "M3",
    "Device": "M3",
    "Model": "M3"
  },
  {
    "Retail Branding": "Gionee",
    "Marketing Name": "M3S",
    "Device": "GiONEE_M3S",
    "Model": "M3S"
  },
  {
    "Retail Branding": "Gionee",
    "Marketing Name": "M3mini",
    "Device": "GiONEE_WBL7315",
    "Model": "M3mini"
  },
  {
    "Retail Branding": "Gionee",
    "Marketing Name": "M4",
    "Device": "GiONEE_M3",
    "Model": "M4"
  },
  {
    "Retail Branding": "Gionee",
    "Marketing Name": "M5",
    "Device": "M5",
    "Model": "M5"
  },
  {
    "Retail Branding": "Gionee",
    "Marketing Name": "M5 Lite",
    "Device": "GiONEE_BBL7332",
    "Model": "M5_lite"
  },
  {
    "Retail Branding": "Gionee",
    "Marketing Name": "M5 Plus",
    "Device": "GiONEE_BBL7505",
    "Model": "M5 Plus"
  },
  {
    "Retail Branding": "Gionee",
    "Marketing Name": "M5 mini",
    "Device": "GiONEE_WBW5616",
    "Model": "M5 mini"
  },
  {
    "Retail Branding": "Gionee",
    "Marketing Name": "M5L",
    "Device": "M5",
    "Model": "M5L"
  },
  {
    "Retail Branding": "Gionee",
    "Marketing Name": "M6",
    "Device": "GiONEE_BBL7515A",
    "Model": "GN8003"
  },
  {
    "Retail Branding": "Gionee",
    "Marketing Name": "M6",
    "Device": "GiONEE_BBL7515A",
    "Model": "M6"
  },
  {
    "Retail Branding": "Gionee",
    "Marketing Name": "M6 Lite",
    "Device": "GIONEE_WBL7361",
    "Model": "M6 lite"
  },
  {
    "Retail Branding": "Gionee",
    "Marketing Name": "M6 Plus",
    "Device": "GIONEE_BBL7516A",
    "Model": "GN8002"
  },
  {
    "Retail Branding": "Gionee",
    "Marketing Name": "M6 Plus",
    "Device": "GIONEE_BBL7516A01",
    "Model": "GN8002S"
  },
  {
    "Retail Branding": "Gionee",
    "Marketing Name": "M6 mirror",
    "Device": "GIONEE_WBL7372",
    "Model": "M6 mirror"
  },
  {
    "Retail Branding": "Gionee",
    "Marketing Name": "M61",
    "Device": "M61",
    "Model": "M61"
  },
  {
    "Retail Branding": "Gionee",
    "Marketing Name": "M6SLPlus",
    "Device": "GIONEE_G1602A",
    "Model": "M6SLPlus"
  },
  {
    "Retail Branding": "Gionee",
    "Marketing Name": "M6SPlus",
    "Device": "GIONEE_G1602A",
    "Model": "M6SPlus"
  },
  {
    "Retail Branding": "Gionee",
    "Marketing Name": "M7",
    "Device": "GIONEE_SW17G07",
    "Model": "GIONEE M7"
  },
  {
    "Retail Branding": "Gionee",
    "Marketing Name": "M7 Power",
    "Device": "GIONEE_BJ17G16",
    "Model": "M7 Power"
  },
  {
    "Retail Branding": "Gionee",
    "Marketing Name": "M7Plus",
    "Device": "GIONEE_BJ17G08A",
    "Model": "GIONEE M7Plus"
  },
  {
    "Retail Branding": "Gionee",
    "Marketing Name": "P16",
    "Device": "P16",
    "Model": "P16"
  },
  {
    "Retail Branding": "Gionee",
    "Marketing Name": "P2M",
    "Device": "GiONEE_WBW5612",
    "Model": "P2M"
  },
  {
    "Retail Branding": "Gionee",
    "Marketing Name": "P3S",
    "Device": "GiONEE_WBW5613",
    "Model": "P3S"
  },
  {
    "Retail Branding": "Gionee",
    "Marketing Name": "P4",
    "Device": "P4",
    "Model": "P4"
  },
  {
    "Retail Branding": "Gionee",
    "Marketing Name": "P4S",
    "Device": "P4S",
    "Model": "P4S"
  },
  {
    "Retail Branding": "Gionee",
    "Marketing Name": "P5 mini",
    "Device": "GiONEE_WBW5617",
    "Model": "P5 mini"
  },
  {
    "Retail Branding": "Gionee",
    "Marketing Name": "P5L",
    "Device": "GiONEE_WBL7352",
    "Model": "P5"
  },
  {
    "Retail Branding": "Gionee",
    "Marketing Name": "P5L",
    "Device": "GiONEE_WBL7352",
    "Model": "P5L"
  },
  {
    "Retail Branding": "Gionee",
    "Marketing Name": "P5W",
    "Device": "GiONEE_WBW5615",
    "Model": "P5W"
  },
  {
    "Retail Branding": "Gionee",
    "Marketing Name": "P6",
    "Device": "P6",
    "Model": "P6"
  },
  {
    "Retail Branding": "Gionee",
    "Marketing Name": "P61",
    "Device": "P61",
    "Model": "P61"
  },
  {
    "Retail Branding": "Gionee",
    "Marketing Name": "P7",
    "Device": "GIONEE_G1605A",
    "Model": "GIONEE P7"
  },
  {
    "Retail Branding": "Gionee",
    "Marketing Name": "P7",
    "Device": "GIONEE_WBL7365",
    "Model": "GIONEE P7"
  },
  {
    "Retail Branding": "Gionee",
    "Marketing Name": "P7",
    "Device": "GIONEE_WBL7365",
    "Model": "P7"
  },
  {
    "Retail Branding": "Gionee",
    "Marketing Name": "P7 Max",
    "Device": "GIONEE_WBL5708",
    "Model": "P7 Max"
  },
  {
    "Retail Branding": "Gionee",
    "Marketing Name": "P8 Max",
    "Device": "GIONEE_WBL7372",
    "Model": "P8 Max"
  },
  {
    "Retail Branding": "Gionee",
    "Marketing Name": "P8M",
    "Device": "GIONEE_SW17W04",
    "Model": "P8M"
  },
  {
    "Retail Branding": "Gionee",
    "Marketing Name": "P8W",
    "Device": "GIONEE_WBW5620",
    "Model": "P8W"
  },
  {
    "Retail Branding": "Gionee",
    "Marketing Name": "S plus",
    "Device": "GiONEE_WBL7511",
    "Model": "S_plus"
  },
  {
    "Retail Branding": "Gionee",
    "Marketing Name": "S10",
    "Device": "GIONEE_SW17G04",
    "Model": "GIONEE S10"
  },
  {
    "Retail Branding": "Gionee",
    "Marketing Name": "S10 lite",
    "Device": "GIONEE_SW17G02",
    "Model": "GIONEE S10 lite"
  },
  {
    "Retail Branding": "Gionee",
    "Marketing Name": "S10B",
    "Device": "GIONEE_SW17G01",
    "Model": "GIONEE S10B"
  },
  {
    "Retail Branding": "Gionee",
    "Marketing Name": "S10BL",
    "Device": "GIONEE_SW17G01",
    "Model": "GIONEE S10BL"
  },
  {
    "Retail Branding": "Gionee",
    "Marketing Name": "S10C",
    "Device": "GIONEE_SW17G02",
    "Model": "GIONEE S10C"
  },
  {
    "Retail Branding": "Gionee",
    "Marketing Name": "S10CL",
    "Device": "GIONEE_SW17G02",
    "Model": "GIONEE S10CL"
  },
  {
    "Retail Branding": "Gionee",
    "Marketing Name": "S10L",
    "Device": "GIONEE_SW17G04",
    "Model": "GIONEE S10L"
  },
  {
    "Retail Branding": "Gionee",
    "Marketing Name": "S11",
    "Device": "GIONEE_SW17G13",
    "Model": "GIONEE S11"
  },
  {
    "Retail Branding": "Gionee",
    "Marketing Name": "S11 lite",
    "Device": "GIONEE_SW17G15",
    "Model": "GIONEE S11 lite"
  },
  {
    "Retail Branding": "Gionee",
    "Marketing Name": "S11L",
    "Device": "GIONEE_SW17G13",
    "Model": "GIONEE S11L"
  },
  {
    "Retail Branding": "Gionee",
    "Marketing Name": "S12 Lite",
    "Device": "S12_Lite",
    "Model": "S12 Lite"
  },
  {
    "Retail Branding": "Gionee",
    "Marketing Name": "S5.1",
    "Device": "GN9005",
    "Model": "GN9005"
  },
  {
    "Retail Branding": "Gionee",
    "Marketing Name": "S5.1",
    "Device": "S5_1",
    "Model": "S5.1"
  },
  {
    "Retail Branding": "Gionee",
    "Marketing Name": "S5.5",
    "Device": "S5_5",
    "Model": "S5.5"
  },
  {
    "Retail Branding": "Gionee",
    "Marketing Name": "S6",
    "Device": "GiONEE_CBL7513",
    "Model": "GN9010"
  },
  {
    "Retail Branding": "Gionee",
    "Marketing Name": "S6",
    "Device": "GiONEE_CBL7513",
    "Model": "S6"
  },
  {
    "Retail Branding": "Gionee",
    "Marketing Name": "S6 Pro",
    "Device": "GIONEE_GBL7529",
    "Model": "GN9012"
  },
  {
    "Retail Branding": "Gionee",
    "Marketing Name": "S6 Pro",
    "Device": "GIONEE_GBL7529",
    "Model": "S6 Pro"
  },
  {
    "Retail Branding": "Gionee",
    "Marketing Name": "S6Pro",
    "Device": "GIONEE_GBL7529",
    "Model": "GN9012"
  },
  {
    "Retail Branding": "Gionee",
    "Marketing Name": "S6s",
    "Device": "GIONEE_WBL7519",
    "Model": "S6s"
  },
  {
    "Retail Branding": "Gionee",
    "Marketing Name": "S8",
    "Device": "GIONEE_WBL7517",
    "Model": "GN9011"
  },
  {
    "Retail Branding": "Gionee",
    "Marketing Name": "S9",
    "Device": "GIONEE_GBL7553",
    "Model": "S9"
  },
  {
    "Retail Branding": "Gionee",
    "Marketing Name": "S9",
    "Device": "GIONEE_GBL7558",
    "Model": "S9"
  },
  {
    "Retail Branding": "Gionee",
    "Marketing Name": "S_plus",
    "Device": "GiONEE_WBL7511",
    "Model": "S_plus"
  },
  {
    "Retail Branding": "Gionee",
    "Marketing Name": "V4S",
    "Device": "V4S",
    "Model": "V4S"
  },
  {
    "Retail Branding": "Gionee",
    "Marketing Name": "V5",
    "Device": "V5",
    "Model": "V5"
  },
  {
    "Retail Branding": "Gionee",
    "Marketing Name": "W900S",
    "Device": "GiONEE_BFL7506A",
    "Model": "W900S"
  },
  {
    "Retail Branding": "Gionee",
    "Marketing Name": "W909",
    "Device": "GiONEE_BFL7512B",
    "Model": "W909"
  },
  {
    "Retail Branding": "Gionee",
    "Marketing Name": "W919",
    "Device": "GIONEE_BJ17G10",
    "Model": "GIONEE W919"
  },
  {
    "Retail Branding": "Gionee",
    "Marketing Name": "X1",
    "Device": "GIONEE_SWW1631",
    "Model": "GIONEE X1"
  },
  {
    "Retail Branding": "Gionee",
    "Marketing Name": "X1S",
    "Device": "GIONEE_SWW1627",
    "Model": "X1S"
  },
  {
    "Retail Branding": "Gionee",
    "Marketing Name": "gionee_A10",
    "Device": "gionee_A10",
    "Model": "gionee A10"
  },
  {
    "Retail Branding": "Gladwin",
    "Marketing Name": "All_IN_ONE_ADPM",
    "Device": "mensa_an64",
    "Model": "GLAD140Series"
  },
  {
    "Retail Branding": "Gladwin",
    "Marketing Name": "GLADWIN101",
    "Device": "GLADWIN101",
    "Model": "GLADWIN101"
  },
  {
    "Retail Branding": "GlobalSec",
    "Marketing Name": "BW819E_CR",
    "Device": "BW819E_CR_EEA",
    "Model": "BW819E_CR"
  },
  {
    "Retail Branding": "GlobalSec",
    "Marketing Name": "BW819E_SK",
    "Device": "BW819E_SK_EEA",
    "Model": "BW819E_SK"
  },
  {
    "Retail Branding": "GlobalSec",
    "Marketing Name": "TAB_TEN",
    "Device": "TAB_TEN",
    "Model": "GLOBALSEC TAB TEN"
  },
  {
    "Retail Branding": "Globe Phoenix",
    "Marketing Name": "DX768Pro",
    "Device": "DX768Pro",
    "Model": "DX768Pro"
  },
  {
    "Retail Branding": "Globe Phoenix",
    "Marketing Name": "PHPHOENIXONETAB",
    "Device": "PHPHOENIXONETAB",
    "Model": "PHPHOENIXONETAB"
  },
  {
    "Retail Branding": "Globe Phoenix",
    "Marketing Name": "Springboard",
    "Device": "CS790Pro",
    "Model": "CS790Pro"
  },
  {
    "Retail Branding": "Globe Streamwatch",
    "Marketing Name": "SEI530G",
    "Device": "SEI530G",
    "Model": "SEI530G"
  },
  {
    "Retail Branding": "Globe Telecom",
    "Marketing Name": "Globe",
    "Device": "SEI120G",
    "Model": "SEI-120G"
  },
  {
    "Retail Branding": "Globe Telecom",
    "Marketing Name": "SEI-120G",
    "Device": "SEI120G",
    "Model": "SEI-120G"
  },
  {
    "Retail Branding": "Globus_Infocom_Limited",
    "Marketing Name": "GS01-Series",
    "Device": "GS01-Series",
    "Model": "GS01-Series"
  },
  {
    "Retail Branding": "Globus_Infocom_Limited",
    "Marketing Name": "GS04-Series",
    "Device": "MTK9679",
    "Model": "GS04-Series"
  },
  {
    "Retail Branding": "Globus_Infocom_Limited",
    "Marketing Name": "GS08-Series",
    "Device": "GS08-Series",
    "Model": "GS08-Series"
  },
  {
    "Retail Branding": "Globus_Infocom_Limited",
    "Marketing Name": "GS08-Series",
    "Device": "Globus_IFPD",
    "Model": "GS08-Series"
  },
  {
    "Retail Branding": "Globus_Infocom_Limited",
    "Marketing Name": "GS18_Series",
    "Device": "Globus_Interactive_Display",
    "Model": "GS18_Series"
  },
  {
    "Retail Branding": "Glocalme",
    "Marketing Name": "P3S18",
    "Device": "P3S18",
    "Model": "P3S18"
  },
  {
    "Retail Branding": "Glocalme",
    "Marketing Name": "S20i",
    "Device": "S20iQ19",
    "Model": "S20iQ19"
  },
  {
    "Retail Branding": "Glofiish",
    "Marketing Name": "Gpad_U",
    "Device": "Gpad_U",
    "Model": "Gpad_U"
  },
  {
    "Retail Branding": "Gloria",
    "Marketing Name": "A30",
    "Device": "A30",
    "Model": "A30"
  },
  {
    "Retail Branding": "Gloria",
    "Marketing Name": "A50",
    "Device": "A50",
    "Model": "gloria A50"
  },
  {
    "Retail Branding": "Go Mobile",
    "Marketing Name": "G860",
    "Device": "G860",
    "Model": "G860"
  },
  {
    "Retail Branding": "Go Mobile",
    "Marketing Name": "GO Onyx",
    "Device": "GO_Onyx_LTE",
    "Model": "GO Onyx LTE"
  },
  {
    "Retail Branding": "Go Mobile",
    "Marketing Name": "GO Onyx HD",
    "Device": "Go_Onyx_HD",
    "Model": "Go Onyx HD"
  },
  {
    "Retail Branding": "Go Mobile",
    "Marketing Name": "GO Onyx mini",
    "Device": "GO_Onyx_mini",
    "Model": "GO Onyx mini"
  },
  {
    "Retail Branding": "Go Mobile",
    "Marketing Name": "GO SMART",
    "Device": "GO_SMART",
    "Model": "GO506"
  },
  {
    "Retail Branding": "Go Mobile",
    "Marketing Name": "GO1004",
    "Device": "GO1004",
    "Model": "GO1004"
  },
  {
    "Retail Branding": "Go Mobile",
    "Marketing Name": "GO1006",
    "Device": "GO1006",
    "Model": "GO1006"
  },
  {
    "Retail Branding": "Go Mobile",
    "Marketing Name": "GO1008",
    "Device": "GO1008",
    "Model": "GO1008"
  },
  {
    "Retail Branding": "Go Mobile",
    "Marketing Name": "GO1402S",
    "Device": "GO1402S",
    "Model": "GO1402S"
  },
  {
    "Retail Branding": "Go Mobile",
    "Marketing Name": "GO1452",
    "Device": "GO1452",
    "Model": "GO1452"
  },
  {
    "Retail Branding": "Go Mobile",
    "Marketing Name": "GO404",
    "Device": "GO404",
    "Model": "GO404"
  },
  {
    "Retail Branding": "Go Mobile",
    "Marketing Name": "X1",
    "Device": "X1",
    "Model": "X1"
  },
  {
    "Retail Branding": "Go Mobile",
    "Marketing Name": "X2",
    "Device": "X2",
    "Model": "X2"
  },
  {
    "Retail Branding": "Go Mobile",
    "Marketing Name": "X6",
    "Device": "GM",
    "Model": "X6"
  },
  {
    "Retail Branding": "Go3 Baltics",
    "Marketing Name": "Skyworth",
    "Device": "HP44H",
    "Model": "Go3 BOX"
  },
  {
    "Retail Branding": "GoClever",
    "Marketing Name": "INSIGNIA 550i",
    "Device": "INSIGNIA_550i",
    "Model": "INSIGNIA_550i"
  },
  {
    "Retail Branding": "GoClever",
    "Marketing Name": "QUANTUM 1010N",
    "Device": "QUANTUM_1010N",
    "Model": "QUANTUM_1010N"
  },
  {
    "Retail Branding": "GoClever",
    "Marketing Name": "QUANTUM 400 LITE",
    "Device": "QUANTUM_400_LITE",
    "Model": "QUANTUM_400_LITE"
  },
  {
    "Retail Branding": "GoClever",
    "Marketing Name": "QUANTUM_3_1010_MOBILE",
    "Device": "TQ31010MO",
    "Model": "QUANTUM_3_1010_MOBILE"
  },
  {
    "Retail Branding": "GoClever",
    "Marketing Name": "QUANTUM_550",
    "Device": "QUANTUM_550",
    "Model": "QUANTUM_550"
  },
  {
    "Retail Branding": "GoClever",
    "Marketing Name": "QUANTUM_700S/QUANTUM 700S",
    "Device": "QUANTUM_700S",
    "Model": "QUANTUM_700S"
  },
  {
    "Retail Branding": "GoClever",
    "Marketing Name": "Quantum 500 STEEL",
    "Device": "FQ_500R",
    "Model": "Quantum_500_STEEL"
  },
  {
    "Retail Branding": "GoClever",
    "Marketing Name": "TQ700/QUANTUM 700/TAB",
    "Device": "TQ700",
    "Model": "TQ700"
  },
  {
    "Retail Branding": "GoMo",
    "Marketing Name": "N11",
    "Device": "S5506LA",
    "Model": "S5506L"
  },
  {
    "Retail Branding": "GoPlus",
    "Marketing Name": "GoPlus 4k",
    "Device": "SEI700STL",
    "Model": "GoPlus 4k"
  },
  {
    "Retail Branding": "Goally",
    "Marketing Name": "P3_8",
    "Device": "P3_8",
    "Model": "P3_8"
  },
  {
    "Retail Branding": "Gobox",
    "Marketing Name": "T2",
    "Device": "T2",
    "Model": "T2"
  },
  {
    "Retail Branding": "Gol Mobile",
    "Marketing Name": "F10",
    "Device": "F10",
    "Model": "F10"
  },
  {
    "Retail Branding": "Gol Mobile",
    "Marketing Name": "F10_PRIME",
    "Device": "F10_PRIME",
    "Model": "F10_PRIME"
  },
  {
    "Retail Branding": "Gol Mobile",
    "Marketing Name": "F11",
    "Device": "F11",
    "Model": "F11"
  },
  {
    "Retail Branding": "Gol Mobile",
    "Marketing Name": "F3Prime",
    "Device": "F3Prime",
    "Model": "F3Prime"
  },
  {
    "Retail Branding": "Gol Mobile",
    "Marketing Name": "F4",
    "Device": "F4",
    "Model": "F4"
  },
  {
    "Retail Branding": "Gol Mobile",
    "Marketing Name": "F9",
    "Device": "F9",
    "Model": "F9"
  },
  {
    "Retail Branding": "Gol Mobile",
    "Marketing Name": "F9Prime",
    "Device": "F9prime",
    "Model": "F9prime"
  },
  {
    "Retail Branding": "Gol Mobile",
    "Marketing Name": "F9_PLUS",
    "Device": "F9_PLUS",
    "Model": "F9_PLUS"
  },
  {
    "Retail Branding": "Gol Mobile",
    "Marketing Name": "TEAM_7_3G",
    "Device": "TEAM_7_3G",
    "Model": "TEAM_7_3G"
  },
  {
    "Retail Branding": "Gol Mobile",
    "Marketing Name": "Team73G",
    "Device": "Team73G",
    "Model": "Team73G"
  },
  {
    "Retail Branding": "Gol Mobile",
    "Marketing Name": "Team_7",
    "Device": "Team_7",
    "Model": "Team 7.0"
  },
  {
    "Retail Branding": "Gol Mobile",
    "Marketing Name": "Team_7_Plus",
    "Device": "Team_7_Plus",
    "Model": "Team_7_Plus"
  },
  {
    "Retail Branding": "Goldentec",
    "Marketing Name": "GT_METAL_TAB10",
    "Device": "GT_METAL_TAB10",
    "Model": "GT_METAL_TAB10"
  },
  {
    "Retail Branding": "Goldentec",
    "Marketing Name": "GT_TAB10",
    "Device": "GT_TAB10",
    "Model": "GT_TAB10"
  },
  {
    "Retail Branding": "Goldentec",
    "Marketing Name": "GT_TAB7",
    "Device": "GT_TAB7",
    "Model": "GT_TAB7"
  },
  {
    "Retail Branding": "Goldentec",
    "Marketing Name": "GT_Tab",
    "Device": "GT_Tab",
    "Model": "GT_Tab"
  },
  {
    "Retail Branding": "Goldmaster",
    "Marketing Name": "BENGAL_6",
    "Device": "BENGAL_6",
    "Model": "BENGAL_6"
  },
  {
    "Retail Branding": "Goldmaster",
    "Marketing Name": "F_4",
    "Device": "F_4",
    "Model": "F_4"
  },
  {
    "Retail Branding": "Goldtech",
    "Marketing Name": "GT10-B16",
    "Device": "GT10-B16",
    "Model": "GT10-B16"
  },
  {
    "Retail Branding": "Goldtech",
    "Marketing Name": "GT7-B16",
    "Device": "GT7-B16",
    "Model": "GT7-B16"
  },
  {
    "Retail Branding": "Goldtech",
    "Marketing Name": "GT_Tab_3G",
    "Device": "GT_Tab_3G",
    "Model": "GT_Tab_3G"
  },
  {
    "Retail Branding": "Goldtech",
    "Marketing Name": "JTTAB035",
    "Device": "JTTAB035",
    "Model": "JTTAB035"
  },
  {
    "Retail Branding": "Gome",
    "Marketing Name": "GOME C7",
    "Device": "GOME_C7",
    "Model": "GOME_2018X07A"
  },
  {
    "Retail Branding": "Gome",
    "Marketing Name": "GOME C7 Note mini",
    "Device": "GOME_C7_Note_Mini",
    "Model": "GOME_C7_Note"
  },
  {
    "Retail Branding": "Gome",
    "Marketing Name": "GOME_C7_Note",
    "Device": "GOME_C7_Note",
    "Model": "GOME_C7_Note"
  },
  {
    "Retail Branding": "Gonna",
    "Marketing Name": "Zebra",
    "Device": "Zebra",
    "Model": "Zebra"
  },
  {
    "Retail Branding": "Goo",
    "Marketing Name": "g08",
    "Device": "v12dn",
    "Model": "View Prime"
  },
  {
    "Retail Branding": "Google",
    "Marketing Name": "AMD FP6 Chromebook",
    "Device": "guybrush_cheets",
    "Model": "guybrush"
  },
  {
    "Retail Branding": "Google",
    "Marketing Name": "AMD Mendocino FT6 Chromebook",
    "Device": "skyrim_cheets",
    "Model": "skyrim"
  },
  {
    "Retail Branding": "Google",
    "Marketing Name": "AMD Raven Ridge Chromebook",
    "Device": "zork_cheets",
    "Model": "zork"
  },
  {
    "Retail Branding": "Google",
    "Marketing Name": "AMD Stoney Ridge Chromebook",
    "Device": "grunt_cheets",
    "Model": "grunt"
  },
  {
    "Retail Branding": "Google",
    "Marketing Name": "Chromebase",
    "Device": "kalista_cheets",
    "Model": "kalista"
  },
  {
    "Retail Branding": "Google",
    "Marketing Name": "Chromebook 14 (CB3-431)",
    "Device": "edgar_cheets",
    "Model": "Acer Chromebook 14 (CB3-431)"
  },
  {
    "Retail Branding": "Google",
    "Marketing Name": "Chromebook 14 (CB3-431)",
    "Device": "edgar_cheets",
    "Model": "Chromebook 14 (CB3-431)"
  },
  {
    "Retail Branding": "Google",
    "Marketing Name": "Chromebook Pixel (2015)",
    "Device": "",
    "Model": ""
  },
  {
    "Retail Branding": "Google",
    "Marketing Name": "Chromebook Pixel (2015)",
    "Device": "samus_cheets",
    "Model": "Google Chromebook Pixel (2015)"
  },
  {
    "Retail Branding": "Google",
    "Marketing Name": "Chromebox",
    "Device": "fizz_cheets",
    "Model": "Chromebox Reference"
  },
  {
    "Retail Branding": "Google",
    "Marketing Name": "Chromebox",
    "Device": "fizz_cheets",
    "Model": "fizz"
  },
  {
    "Retail Branding": "Google",
    "Marketing Name": "Chromebox",
    "Device": "puff_cheets",
    "Model": "puff"
  },
  {
    "Retail Branding": "Google",
    "Marketing Name": "Chromecast Google TV",
    "Device": "sabrina",
    "Model": "Chromecast"
  },
  {
    "Retail Branding": "Google",
    "Marketing Name": "Chromecast Google TV (HD)",
    "Device": "boreal",
    "Model": "Chromecast HD"
  },
  {
    "Retail Branding": "Google",
    "Marketing Name": "Emualtor",
    "Device": "generic_x86_arm",
    "Model": "AOSP on IA Emulator"
  },
  {
    "Retail Branding": "Google",
    "Marketing Name": "Emulator",
    "Device": "generic_x86",
    "Model": "Android SDK built for x86"
  },
  {
    "Retail Branding": "Google",
    "Marketing Name": "Emulator",
    "Device": "generic_x86_64",
    "Model": "Android SDK built for x86_64"
  },
  {
    "Retail Branding": "Google",
    "Marketing Name": "Galaxy S4 Google Play edition",
    "Device": "jgedlte",
    "Model": "GT-I9505G"
  },
  {
    "Retail Branding": "Google",
    "Marketing Name": "Google Android Emulator",
    "Device": "generic_x86_arm",
    "Model": "sdk_gphone_x86"
  },
  {
    "Retail Branding": "Google",
    "Marketing Name": "Google Automotive Emulator",
    "Device": "emulator_car64_x86_64",
    "Model": "Android SDK built for x86_64"
  },
  {
    "Retail Branding": "Google",
    "Marketing Name": "Google Automotive Emulator",
    "Device": "emulator_car64_x86_64",
    "Model": "Car on x86_64 emulator"
  },
  {
    "Retail Branding": "Google",
    "Marketing Name": "Google Play Games on PC",
    "Device": "vsoc_kiwi_x86_64",
    "Model": "HPE device"
  },
  {
    "Retail Branding": "Google",
    "Marketing Name": "Google TV Streamer",
    "Device": "kirkwood",
    "Model": "Google TV Streamer"
  },
  {
    "Retail Branding": "Google",
    "Marketing Name": "Intel Alder Lake Chromebook",
    "Device": "brya_cheets",
    "Model": "brya"
  },
  {
    "Retail Branding": "Google",
    "Marketing Name": "Intel Alder Lake Chromebox",
    "Device": "brask_cheets",
    "Model": "brask"
  },
  {
    "Retail Branding": "Google",
    "Marketing Name": "Intel Alder Lake-N Chromebook",
    "Device": "nissa_cheets",
    "Model": "nirva"
  },
  {
    "Retail Branding": "Google",
    "Marketing Name": "Intel Alder Lake-N Chromebook",
    "Device": "nissa_cheets",
    "Model": "nissa"
  },
  {
    "Retail Branding": "Google",
    "Marketing Name": "Intel Amber Lake Y Chromebook",
    "Device": "rammus_cheets",
    "Model": "rammus"
  },
  {
    "Retail Branding": "Google",
    "Marketing Name": "Intel Apollo Lake Chromebook",
    "Device": "",
    "Model": ""
  },
  {
    "Retail Branding": "Google",
    "Marketing Name": "Intel Apollo Lake Chromebook",
    "Device": "coral_cheets",
    "Model": "coral"
  },
  {
    "Retail Branding": "Google",
    "Marketing Name": "Intel Apollo Lake Chromebook",
    "Device": "reef_cheets",
    "Model": "ASUS Chromebook C213NA"
  },
  {
    "Retail Branding": "Google",
    "Marketing Name": "Intel Apollo Lake Chromebook",
    "Device": "reef_cheets",
    "Model": "Intel Apollo Lake Chromebook"
  },
  {
    "Retail Branding": "Google",
    "Marketing Name": "Intel Apollo Lake Chromebook",
    "Device": "reef_cheets",
    "Model": "reef"
  },
  {
    "Retail Branding": "Google",
    "Marketing Name": "Intel Braswell Chromebook",
    "Device": "relm_cheets",
    "Model": "Braswell Chrome OS Device"
  },
  {
    "Retail Branding": "Google",
    "Marketing Name": "Intel Braswell Chromebook",
    "Device": "relm_cheets",
    "Model": "Intel Braswell Chromebook"
  },
  {
    "Retail Branding": "Google",
    "Marketing Name": "Intel Braswell Chromebook",
    "Device": "wizpig_cheets",
    "Model": "Intel Braswell Chromebook"
  },
  {
    "Retail Branding": "Google",
    "Marketing Name": "Intel Comet Lake U Chromebook",
    "Device": "hatch_cheets",
    "Model": "hatch"
  },
  {
    "Retail Branding": "Google",
    "Marketing Name": "Intel Gemini Lake Chromebook",
    "Device": "octopus_cheets",
    "Model": "octopus"
  },
  {
    "Retail Branding": "Google",
    "Marketing Name": "Intel Jasper Lake Chromebook",
    "Device": "dedede_cheets",
    "Model": "dedede"
  },
  {
    "Retail Branding": "Google",
    "Marketing Name": "Intel Jasper Lake Chromebook",
    "Device": "keeby_cheets",
    "Model": "keeby"
  },
  {
    "Retail Branding": "Google",
    "Marketing Name": "Intel Kaby Lake U Chromebook",
    "Device": "nami_cheets",
    "Model": "nami"
  },
  {
    "Retail Branding": "Google",
    "Marketing Name": "Intel Meteorlake-U Chromebook",
    "Device": "rex_cheets",
    "Model": "rex"
  },
  {
    "Retail Branding": "Google",
    "Marketing Name": "Intel Tiger Lake Chromebook",
    "Device": "volteer_cheets",
    "Model": "volteer"
  },
  {
    "Retail Branding": "Google",
    "Marketing Name": "Mediatek MT8183 Chromebook",
    "Device": "jacuzzi_cheets",
    "Model": "jacuzzi"
  },
  {
    "Retail Branding": "Google",
    "Marketing Name": "Mediatek MT8183 Tablet",
    "Device": "kukui_cheets",
    "Model": "kukui"
  },
  {
    "Retail Branding": "Google",
    "Marketing Name": "Mediatek MT8186 Chromebook",
    "Device": "corsola_cheets",
    "Model": "corsola"
  },
  {
    "Retail Branding": "Google",
    "Marketing Name": "Mediatek MT8186 Tablet",
    "Device": "staryu_cheets",
    "Model": "staryu"
  },
  {
    "Retail Branding": "Google",
    "Marketing Name": "Mediatek MT8188G Detachable",
    "Device": "geralt_cheets",
    "Model": "geralt"
  },
  {
    "Retail Branding": "Google",
    "Marketing Name": "Mediatek MT8189 Chromebook",
    "Device": "skywalker_cheets",
    "Model": "skywalker"
  },
  {
    "Retail Branding": "Google",
    "Marketing Name": "Mediatek MT8192 Chromebook",
    "Device": "asurada_cheets",
    "Model": "asurada"
  },
  {
    "Retail Branding": "Google",
    "Marketing Name": "Mediatek MT8195 Chromebook",
    "Device": "cherry_cheets",
    "Model": "cherry"
  },
  {
    "Retail Branding": "Google",
    "Marketing Name": "Mediatek MT8196 Chromebook",
    "Device": "rauru_cheets",
    "Model": "rauru"
  },
  {
    "Retail Branding": "Google",
    "Marketing Name": "Mediatek MTK8173 Chromebook",
    "Device": "hana_cheets",
    "Model": "Lenovo N23 Yoga/Flex 11 Chromebook"
  },
  {
    "Retail Branding": "Google",
    "Marketing Name": "Mediatek MTK8173 Chromebook",
    "Device": "hana_cheets",
    "Model": "Mediatek MT8173 Chromebook"
  },
  {
    "Retail Branding": "Google",
    "Marketing Name": "Mediatek MTK8173 Chromebook",
    "Device": "hana_cheets",
    "Model": "Mediatek MTK8173 Chromebook"
  },
  {
    "Retail Branding": "Google",
    "Marketing Name": "Pixel",
    "Device": "sailfish",
    "Model": "Pixel"
  },
  {
    "Retail Branding": "Google",
    "Marketing Name": "Pixel 10",
    "Device": "frankel",
    "Model": "Pixel 10"
  },
  {
    "Retail Branding": "Google",
    "Marketing Name": "Pixel 10 Pro",
    "Device": "blazer",
    "Model": "Pixel 10 Pro"
  },
  {
    "Retail Branding": "Google",
    "Marketing Name": "Pixel 10 Pro Fold",
    "Device": "rango",
    "Model": "Pixel 10 Pro Fold"
  },
  {
    "Retail Branding": "Google",
    "Marketing Name": "Pixel 10 Pro XL",
    "Device": "mustang",
    "Model": "Pixel 10 Pro XL"
  },
  {
    "Retail Branding": "Google",
    "Marketing Name": "Pixel 10a",
    "Device": "stallion",
    "Model": "Pixel 10a"
  },
  {
    "Retail Branding": "Google",
    "Marketing Name": "Pixel 2",
    "Device": "walleye",
    "Model": "Pixel 2"
  },
  {
    "Retail Branding": "Google",
    "Marketing Name": "Pixel 2 XL",
    "Device": "taimen",
    "Model": "Pixel 2 XL"
  },
  {
    "Retail Branding": "Google",
    "Marketing Name": "Pixel 3",
    "Device": "blueline",
    "Model": "Pixel 3"
  },
  {
    "Retail Branding": "Google",
    "Marketing Name": "Pixel 3 XL",
    "Device": "crosshatch",
    "Model": "Pixel 3 XL"
  },
  {
    "Retail Branding": "Google",
    "Marketing Name": "Pixel 3a",
    "Device": "sargo",
    "Model": "Pixel 3a"
  },
  {
    "Retail Branding": "Google",
    "Marketing Name": "Pixel 3a XL",
    "Device": "bonito",
    "Model": "Pixel 3a XL"
  },
  {
    "Retail Branding": "Google",
    "Marketing Name": "Pixel 4",
    "Device": "flame",
    "Model": "Pixel 4"
  },
  {
    "Retail Branding": "Google",
    "Marketing Name": "Pixel 4 XL",
    "Device": "coral",
    "Model": "Pixel 4 XL"
  },
  {
    "Retail Branding": "Google",
    "Marketing Name": "Pixel 4a",
    "Device": "sunfish",
    "Model": "Pixel 4a"
  },
  {
    "Retail Branding": "Google",
    "Marketing Name": "Pixel 4a (5G)",
    "Device": "bramble",
    "Model": "Pixel 4a (5G)"
  },
  {
    "Retail Branding": "Google",
    "Marketing Name": "Pixel 5",
    "Device": "redfin",
    "Model": "Pixel 5"
  },
  {
    "Retail Branding": "Google",
    "Marketing Name": "Pixel 5a 5G",
    "Device": "barbet",
    "Model": "Pixel 5a"
  },
  {
    "Retail Branding": "Google",
    "Marketing Name": "Pixel 6",
    "Device": "oriole",
    "Model": "Pixel 6"
  },
  {
    "Retail Branding": "Google",
    "Marketing Name": "Pixel 6 Pro",
    "Device": "raven",
    "Model": "Pixel 6 Pro"
  },
  {
    "Retail Branding": "Google",
    "Marketing Name": "Pixel 6a",
    "Device": "bluejay",
    "Model": "Pixel 6a"
  },
  {
    "Retail Branding": "Google",
    "Marketing Name": "Pixel 7",
    "Device": "panther",
    "Model": "Pixel 7"
  },
  {
    "Retail Branding": "Google",
    "Marketing Name": "Pixel 7 Pro",
    "Device": "cheetah",
    "Model": "Pixel 7 Pro"
  },
  {
    "Retail Branding": "Google",
    "Marketing Name": "Pixel 7a",
    "Device": "lynx",
    "Model": "Pixel 7a"
  },
  {
    "Retail Branding": "Google",
    "Marketing Name": "Pixel 8",
    "Device": "shiba",
    "Model": "Pixel 8"
  },
  {
    "Retail Branding": "Google",
    "Marketing Name": "Pixel 8 Pro",
    "Device": "husky",
    "Model": "Pixel 8 Pro"
  },
  {
    "Retail Branding": "Google",
    "Marketing Name": "Pixel 8a",
    "Device": "akita",
    "Model": "Pixel 8a"
  },
  {
    "Retail Branding": "Google",
    "Marketing Name": "Pixel 9",
    "Device": "tokay",
    "Model": "Pixel 9"
  },
  {
    "Retail Branding": "Google",
    "Marketing Name": "Pixel 9 Pro",
    "Device": "caiman",
    "Model": "Pixel 9 Pro"
  },
  {
    "Retail Branding": "Google",
    "Marketing Name": "Pixel 9 Pro Fold",
    "Device": "comet",
    "Model": "Pixel 9 Pro Fold"
  },
  {
    "Retail Branding": "Google",
    "Marketing Name": "Pixel 9 Pro XL",
    "Device": "komodo",
    "Model": "Pixel 9 Pro XL"
  },
  {
    "Retail Branding": "Google",
    "Marketing Name": "Pixel 9a",
    "Device": "tegu",
    "Model": "Pixel 9a"
  },
  {
    "Retail Branding": "Google",
    "Marketing Name": "Pixel C",
    "Device": "dragon",
    "Model": "Pixel C"
  },
  {
    "Retail Branding": "Google",
    "Marketing Name": "Pixel Fold",
    "Device": "felix",
    "Model": "Pixel Fold"
  },
  {
    "Retail Branding": "Google",
    "Marketing Name": "Pixel Slate",
    "Device": "nocturne_cheets",
    "Model": "Google Pixel Slate"
  },
  {
    "Retail Branding": "Google",
    "Marketing Name": "Pixel Slate",
    "Device": "nocturne_cheets",
    "Model": "Pixel Slate"
  },
  {
    "Retail Branding": "Google",
    "Marketing Name": "Pixel Slate",
    "Device": "nocturne_cheets",
    "Model": "nocturne"
  },
  {
    "Retail Branding": "Google",
    "Marketing Name": "Pixel Tablet",
    "Device": "tangorpro",
    "Model": "Pixel Tablet"
  },
  {
    "Retail Branding": "Google",
    "Marketing Name": "Pixel Watch",
    "Device": "r11",
    "Model": "Google Pixel Watch"
  },
  {
    "Retail Branding": "Google",
    "Marketing Name": "Pixel Watch",
    "Device": "r11btwifi",
    "Model": "Google Pixel Watch"
  },
  {
    "Retail Branding": "Google",
    "Marketing Name": "Pixel Watch 2",
    "Device": "aurora",
    "Model": "Google Pixel Watch 2"
  },
  {
    "Retail Branding": "Google",
    "Marketing Name": "Pixel Watch 2",
    "Device": "eos",
    "Model": "Google Pixel Watch 2"
  },
  {
    "Retail Branding": "Google",
    "Marketing Name": "Pixel Watch 4",
    "Device": "kenari_btwifi",
    "Model": "Pixel Watch 4"
  },
  {
    "Retail Branding": "Google",
    "Marketing Name": "Pixel Watch 4",
    "Device": "kenari_lte",
    "Model": "Pixel Watch 4"
  },
  {
    "Retail Branding": "Google",
    "Marketing Name": "Pixel Watch 4",
    "Device": "meridian_btwifi",
    "Model": "Pixel Watch 4"
  },
  {
    "Retail Branding": "Google",
    "Marketing Name": "Pixel Watch 4",
    "Device": "meridian_lte",
    "Model": "Pixel Watch 4"
  },
  {
    "Retail Branding": "Google",
    "Marketing Name": "Pixel XL",
    "Device": "marlin",
    "Model": "Pixel XL"
  },
  {
    "Retail Branding": "Google",
    "Marketing Name": "Pixel watch 3",
    "Device": "helios",
    "Model": "Pixel Watch 3"
  },
  {
    "Retail Branding": "Google",
    "Marketing Name": "Pixel watch 3",
    "Device": "luna",
    "Model": "Pixel Watch 3"
  },
  {
    "Retail Branding": "Google",
    "Marketing Name": "Pixel watch 3",
    "Device": "selene",
    "Model": "Pixel Watch 3"
  },
  {
    "Retail Branding": "Google",
    "Marketing Name": "Pixel watch 3",
    "Device": "sol",
    "Model": "Pixel Watch 3"
  },
  {
    "Retail Branding": "Google",
    "Marketing Name": "Pixelbook",
    "Device": "atlas_cheets",
    "Model": "Google Pixelbook Go"
  },
  {
    "Retail Branding": "Google",
    "Marketing Name": "Pixelbook",
    "Device": "atlas_cheets",
    "Model": "atlas"
  },
  {
    "Retail Branding": "Google",
    "Marketing Name": "Pixelbook",
    "Device": "eve_cheets",
    "Model": "Google Pixelbook"
  },
  {
    "Retail Branding": "Google",
    "Marketing Name": "Project Tango Tablet Development Kit",
    "Device": "yellowstone",
    "Model": "Project Tango Tablet Development Kit"
  },
  {
    "Retail Branding": "Google",
    "Marketing Name": "Project Tango Tablet Development Kit",
    "Device": "yellowstone",
    "Model": "Yellowstone"
  },
  {
    "Retail Branding": "Google",
    "Marketing Name": "Qualcomm SC7180 Chromebook",
    "Device": "trogdor_cheets",
    "Model": "trogdor"
  },
  {
    "Retail Branding": "Google",
    "Marketing Name": "Qualcomm SC7180 Chromebook",
    "Device": "trogdor_cheets",
    "Model": "trogdor64"
  },
  {
    "Retail Branding": "Google",
    "Marketing Name": "Qualcomm SC7180 Detachable",
    "Device": "strongbad_cheets",
    "Model": "strongbad"
  },
  {
    "Retail Branding": "Google",
    "Marketing Name": "Rockchip RK3288 Chromebook",
    "Device": "jerry_cheets",
    "Model": "RK3288 Chrome OS Device"
  },
  {
    "Retail Branding": "Google",
    "Marketing Name": "Rockchip RK3288 Chromebook",
    "Device": "jerry_cheets",
    "Model": "Rockchip RK3288 Chromebook"
  },
  {
    "Retail Branding": "Google",
    "Marketing Name": "Rockchip RK3288 Chromebook",
    "Device": "mighty_cheets",
    "Model": "RK3288 Chrome OS Device"
  },
  {
    "Retail Branding": "Google",
    "Marketing Name": "Rockchip RK3288 Chromebook",
    "Device": "mighty_cheets",
    "Model": "Rockchip RK3288 Chromebook"
  },
  {
    "Retail Branding": "Google",
    "Marketing Name": "emulator",
    "Device": "emu64xa",
    "Model": "sdk_gphone64_x86_64"
  },
  {
    "Retail Branding": "Google",
    "Marketing Name": "gcar emulator",
    "Device": "generic_64bitonly_x86_64",
    "Model": "Automotive SDK built for x86_64"
  },
  {
    "Retail Branding": "Google",
    "Marketing Name": "gcar emulator",
    "Device": "generic_x86",
    "Model": "AOSP on x86"
  },
  {
    "Retail Branding": "Google",
    "Marketing Name": "gcar emulator",
    "Device": "generic_x86",
    "Model": "Automotive SDK built for x86"
  },
  {
    "Retail Branding": "Gowin",
    "Marketing Name": "QT8-T310",
    "Device": "QT8-T310",
    "Model": "QT8"
  },
  {
    "Retail Branding": "Gplus",
    "Marketing Name": "F53",
    "Device": "GPLUS_F53",
    "Model": "GPLUS F53"
  },
  {
    "Retail Branding": "Gplus",
    "Marketing Name": "F68+",
    "Device": "F68",
    "Model": "F68+"
  },
  {
    "Retail Branding": "Gplus",
    "Marketing Name": "FW6950",
    "Device": "GPLUS_FW6950",
    "Model": "GPLUS_FW6950"
  },
  {
    "Retail Branding": "Gplus",
    "Marketing Name": "GNE-N001S",
    "Device": "GNE-N001S",
    "Model": "GNE-N001S"
  },
  {
    "Retail Branding": "Gplus",
    "Marketing Name": "GNE_N003S",
    "Device": "GNE_N003S",
    "Model": "GNE-N003S"
  },
  {
    "Retail Branding": "Gplus",
    "Marketing Name": "GPLUS_A2_Plus",
    "Device": "GPLUS_A2_Plus",
    "Model": "GPLUS_A2_Plus"
  },
  {
    "Retail Branding": "Gplus",
    "Marketing Name": "Gplus",
    "Device": "Q10",
    "Model": "Q10"
  },
  {
    "Retail Branding": "Gplus",
    "Marketing Name": "Gplus",
    "Device": "T10",
    "Model": "T10"
  },
  {
    "Retail Branding": "Gplus",
    "Marketing Name": "LTE960Plus",
    "Device": "LTE960Plus",
    "Model": "LTE960Plus"
  },
  {
    "Retail Branding": "Gplus",
    "Marketing Name": "P10",
    "Device": "P10",
    "Model": "Gplus P10"
  },
  {
    "Retail Branding": "Gplus",
    "Marketing Name": "P10 2022",
    "Device": "P10_2022",
    "Model": "Gplus P10 2022"
  },
  {
    "Retail Branding": "Gplus",
    "Marketing Name": "P10+",
    "Device": "P10_Plus",
    "Model": "Gplus P10+"
  },
  {
    "Retail Branding": "Gplus",
    "Marketing Name": "Q20",
    "Device": "Q20",
    "Model": "GMC-668M"
  },
  {
    "Retail Branding": "Gplus",
    "Marketing Name": "S10",
    "Device": "S10",
    "Model": "Gplus S10"
  },
  {
    "Retail Branding": "Gplus",
    "Marketing Name": "S9701",
    "Device": "GPLUS_S9701",
    "Model": "GPLUS_S9701"
  },
  {
    "Retail Branding": "Gplus",
    "Marketing Name": "X10",
    "Device": "X10",
    "Model": "Gplus X10"
  },
  {
    "Retail Branding": "Gplus",
    "Marketing Name": "X10+",
    "Device": "X10_Plus",
    "Model": "Gplus X10+"
  },
  {
    "Retail Branding": "Gplus",
    "Marketing Name": "Z10",
    "Device": "Z10",
    "Model": "Gplus Z10"
  },
  {
    "Retail Branding": "GraceCompany",
    "Marketing Name": "QuiltMotion_Tablet_8",
    "Device": "Tablet_8",
    "Model": "QuiltMotion Tablet 8"
  },
  {
    "Retail Branding": "Gradiente",
    "Marketing Name": "GTB_106",
    "Device": "GTB_106",
    "Model": "GTB_106"
  },
  {
    "Retail Branding": "Gradiente",
    "Marketing Name": "iphone C600",
    "Device": "GBC_bravo",
    "Model": "iphone C600"
  },
  {
    "Retail Branding": "Gradiente",
    "Marketing Name": "iphone C600",
    "Device": "bravo",
    "Model": "iphone C600"
  },
  {
    "Retail Branding": "Graetz",
    "Marketing Name": "GRAETZ",
    "Device": "hongkong",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "Graetz",
    "Marketing Name": "GRAETZ",
    "Device": "lavender",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "Graetz",
    "Marketing Name": "GRAETZ",
    "Device": "mountbaker",
    "Model": "2K SMART TV"
  },
  {
    "Retail Branding": "Graetz",
    "Marketing Name": "Graetz",
    "Device": "khardi",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "Grandstream",
    "Marketing Name": "Grandstream WP856",
    "Device": "WP856",
    "Model": "WP856"
  },
  {
    "Retail Branding": "Grandstream",
    "Marketing Name": "WP856",
    "Device": "WP856",
    "Model": "WP856"
  },
  {
    "Retail Branding": "Greatwall",
    "Marketing Name": 100011886,
    "Device": "tablet",
    "Model": 100011886
  },
  {
    "Retail Branding": "Greatwall",
    "Marketing Name": "100011886_GTW",
    "Device": "tablet",
    "Model": "100011886_GTW"
  },
  {
    "Retail Branding": "Greatwall",
    "Marketing Name": "GWPad-S11",
    "Device": "GWPad-S11",
    "Model": "GW Pad S11"
  },
  {
    "Retail Branding": "Greatwall",
    "Marketing Name": "GWPad-S11",
    "Device": "GWPad-S11",
    "Model": "GWPad-S11"
  },
  {
    "Retail Branding": "Greatwall",
    "Marketing Name": "GWPad-S11-1",
    "Device": "GWPad-S11-1",
    "Model": "GWPad-S11-1"
  },
  {
    "Retail Branding": "Greatwall",
    "Marketing Name": "K701",
    "Device": "K701",
    "Model": "K701"
  },
  {
    "Retail Branding": "Greatwall",
    "Marketing Name": "LM1105S-D",
    "Device": "LM1105S-D",
    "Model": "LM1105S-D"
  },
  {
    "Retail Branding": "Greatwall",
    "Marketing Name": "T709GW",
    "Device": "T709GW",
    "Model": "Great Wall T709"
  },
  {
    "Retail Branding": "Greatwall",
    "Marketing Name": "W710",
    "Device": "W710",
    "Model": "W710"
  },
  {
    "Retail Branding": "Green House",
    "Marketing Name": "2525PRE_GHTB",
    "Device": "2525PRE_GHTB",
    "Model": "2525PRE_GHTB"
  },
  {
    "Retail Branding": "Green House",
    "Marketing Name": "4K Smart TV",
    "Device": "pioneer",
    "Model": "4K SA Smart TV"
  },
  {
    "Retail Branding": "Green House",
    "Marketing Name": "GREEN HOUSE 2K SMART",
    "Device": "umeda",
    "Model": "GREEN HOUSE 2K SMART"
  },
  {
    "Retail Branding": "Green House",
    "Marketing Name": "GREEN HOUSE TV",
    "Device": "SW6H",
    "Model": "GREEN HOUSE TV"
  },
  {
    "Retail Branding": "Green House",
    "Marketing Name": "Smart TV",
    "Device": "mateo",
    "Model": "2K SA Smart TV"
  },
  {
    "Retail Branding": "GreenLion",
    "Marketing Name": "G-10_PRO",
    "Device": "G-10_PRO",
    "Model": "G-10 PRO"
  },
  {
    "Retail Branding": "GreenLion",
    "Marketing Name": "G-10_ULTRA",
    "Device": "G-10_ULTRA",
    "Model": "G-10 ULTRA"
  },
  {
    "Retail Branding": "GreenLion",
    "Marketing Name": "G-20ULTRA",
    "Device": "G-20ULTRA",
    "Model": "G-20ULTRA"
  },
  {
    "Retail Branding": "GreenLion",
    "Marketing Name": "G-30_ULTRA",
    "Device": "G-30_ULTRA",
    "Model": "G-30_ULTRA"
  },
  {
    "Retail Branding": "GreenLion",
    "Marketing Name": "G-30_ULTRA",
    "Device": "G-30_ULTRA",
    "Model": "Max Tab22"
  },
  {
    "Retail Branding": "GreenLion",
    "Marketing Name": "G-8_PRO",
    "Device": "G-8_PRO",
    "Model": "G-8 PRO"
  },
  {
    "Retail Branding": "Greentel",
    "Marketing Name": "A10Pro",
    "Device": "A10Pro",
    "Model": "A10Pro"
  },
  {
    "Retail Branding": "Greentel",
    "Marketing Name": "A10_premium",
    "Device": "A10_premium",
    "Model": "A10_premium"
  },
  {
    "Retail Branding": "Greentel",
    "Marketing Name": "A8",
    "Device": "A8",
    "Model": "A8"
  },
  {
    "Retail Branding": "Greentel",
    "Marketing Name": "A9",
    "Device": "A9",
    "Model": "A9"
  },
  {
    "Retail Branding": "Greentel",
    "Marketing Name": "A9Pro",
    "Device": "A9Pro",
    "Model": "A9Pro"
  },
  {
    "Retail Branding": "Greentel",
    "Marketing Name": "Greentel-A10",
    "Device": "Greentel-A10",
    "Model": "A10"
  },
  {
    "Retail Branding": "Greentel",
    "Marketing Name": "Tab-X",
    "Device": "Tab-X",
    "Model": "Tab-X"
  },
  {
    "Retail Branding": "Greentel",
    "Marketing Name": "V2",
    "Device": "V2",
    "Model": "V2"
  },
  {
    "Retail Branding": "Greentel",
    "Marketing Name": "X MAX",
    "Device": "X_MAX",
    "Model": "X MAX"
  },
  {
    "Retail Branding": "Greentel",
    "Marketing Name": "X1 Light",
    "Device": "X1_Light",
    "Model": "X1_Light"
  },
  {
    "Retail Branding": "Greentel",
    "Marketing Name": "X1_Light",
    "Device": "X1_Light",
    "Model": "X1 Light"
  },
  {
    "Retail Branding": "Greentel",
    "Marketing Name": "X1_Light_Lte",
    "Device": "X1_Light_Lte",
    "Model": "X1_Light_Lte"
  },
  {
    "Retail Branding": "Greentel",
    "Marketing Name": "X2",
    "Device": "X2",
    "Model": "X2"
  },
  {
    "Retail Branding": "Greentel",
    "Marketing Name": "X2 Premium",
    "Device": "X2_Premium",
    "Model": "X2 Premium"
  },
  {
    "Retail Branding": "Greentel",
    "Marketing Name": "Xmini",
    "Device": "P4072",
    "Model": "Xmini"
  },
  {
    "Retail Branding": "Greentel",
    "Marketing Name": "Xmini",
    "Device": "Xmini",
    "Model": "Xmini"
  },
  {
    "Retail Branding": "Greentel",
    "Marketing Name": "Xmini4G",
    "Device": "Xmini4G",
    "Model": "Xmini4G"
  },
  {
    "Retail Branding": "Grolier",
    "Marketing Name": "GSR",
    "Device": "GSR",
    "Model": "GSR"
  },
  {
    "Retail Branding": "Grolier",
    "Marketing Name": "GSR2",
    "Device": "GSR2",
    "Model": "GSR2"
  },
  {
    "Retail Branding": "Grundig",
    "Marketing Name": "GTB1030",
    "Device": "TA10CA2",
    "Model": "TA10CA2"
  },
  {
    "Retail Branding": "Grundig",
    "Marketing Name": "GTB1050",
    "Device": "GTB1050",
    "Model": "GTB 1050"
  },
  {
    "Retail Branding": "Grundig",
    "Marketing Name": "GTB850",
    "Device": "GTB850",
    "Model": "GTB 850"
  },
  {
    "Retail Branding": "Grundig",
    "Marketing Name": "Grundig 2K Google TV",
    "Device": "awaza",
    "Model": "Grundig 2K Google TV"
  },
  {
    "Retail Branding": "Grundig",
    "Marketing Name": "Grundig Android TV",
    "Device": "kunyang",
    "Model": "Grundig Android TV"
  },
  {
    "Retail Branding": "Grundig",
    "Marketing Name": "Grundig Android TV",
    "Device": "millbrae",
    "Model": "Grundig Android TV"
  },
  {
    "Retail Branding": "Grundig",
    "Marketing Name": "Grundig Android TV",
    "Device": "shinagawa",
    "Model": "Grundig Android TV"
  },
  {
    "Retail Branding": "Grundig",
    "Marketing Name": "Grundig Android TV",
    "Device": "sinchon",
    "Model": "Grundig Android TV"
  },
  {
    "Retail Branding": "Grundig",
    "Marketing Name": "Grundig Google TV",
    "Device": "wanchai",
    "Model": "Grundig Google TV"
  },
  {
    "Retail Branding": "Grundig",
    "Marketing Name": "Grundig Google TV OLED",
    "Device": "wanchai",
    "Model": "Grundig Google TV OLED"
  },
  {
    "Retail Branding": "Grundig",
    "Marketing Name": "Grundig Google TV QLED",
    "Device": "wanchai",
    "Model": "Grundig Google TV QLED"
  },
  {
    "Retail Branding": "Grundig",
    "Marketing Name": "Grundig Google TV UHD+",
    "Device": "wanchai",
    "Model": "Grundig Google TV UHD+"
  },
  {
    "Retail Branding": "Grundig",
    "Marketing Name": "Grundig Google UHD TV",
    "Device": "akropoli",
    "Model": "Grundig Google UHD TV"
  },
  {
    "Retail Branding": "Grundig",
    "Marketing Name": "Grundig Nano QLED",
    "Device": "aberdeen",
    "Model": "Grundig Nano QLED"
  },
  {
    "Retail Branding": "Grundig",
    "Marketing Name": "Grundig OLED Google TV",
    "Device": "aberdeen",
    "Model": "Grundig OLED Google TV"
  },
  {
    "Retail Branding": "Grundig",
    "Marketing Name": "Grundig QLED Google TV",
    "Device": "akropoli",
    "Model": "Grundig QLED Google TV"
  },
  {
    "Retail Branding": "Grundig",
    "Marketing Name": "Grundig UHD Android TV",
    "Device": "kunyang",
    "Model": "Grundig Android UHD TV"
  },
  {
    "Retail Branding": "Grundig",
    "Marketing Name": "R4",
    "Device": "R4",
    "Model": "R4"
  },
  {
    "Retail Branding": "Grundig",
    "Marketing Name": "TC69CA2",
    "Device": "GTB801",
    "Model": "GTB 801"
  },
  {
    "Retail Branding": "Grundig",
    "Marketing Name": "Turkey",
    "Device": "martin",
    "Model": "Grundig Android TV"
  },
  {
    "Retail Branding": "Grunhelm",
    "Marketing Name": "GT9HD32",
    "Device": "ikebukuro",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "Grunhelm",
    "Marketing Name": "GT9UHD",
    "Device": "samseong",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "Grunhelm",
    "Marketing Name": "Smart TV",
    "Device": "alimos",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "Grunhelm",
    "Marketing Name": "Smart TV",
    "Device": "dangni",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "Grunhelm",
    "Marketing Name": "Smart TV",
    "Device": "longshan",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "Grunhelm",
    "Marketing Name": "Smart TV",
    "Device": "redwood",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "Grunkel",
    "Marketing Name": "EU、UK、AP",
    "Device": "martin",
    "Model": "Grunkel 2K Android TV"
  },
  {
    "Retail Branding": "Grunkel",
    "Marketing Name": "Europe",
    "Device": "nagata",
    "Model": "GRUNKEL SMART TV"
  },
  {
    "Retail Branding": "Grunkel",
    "Marketing Name": "GRUNKEL SMART TV",
    "Device": "marina",
    "Model": "GRUNKEL SMART TV"
  },
  {
    "Retail Branding": "Grunkel",
    "Marketing Name": "Spain",
    "Device": "tamachi",
    "Model": "GRUNKEL FHD Android TV"
  },
  {
    "Retail Branding": "Grunkel",
    "Marketing Name": "Spain",
    "Device": "yeongdeungpo",
    "Model": "GRUNKEL UHD Android TV"
  },
  {
    "Retail Branding": "Gryphon",
    "Marketing Name": "Veil",
    "Device": "granite",
    "Model": "Veil"
  },
  {
    "Retail Branding": "Gtel",
    "Marketing Name": "17X",
    "Device": "17X",
    "Model": "17X"
  },
  {
    "Retail Branding": "Gtel",
    "Marketing Name": "A7100 X3",
    "Device": "A7100_X3",
    "Model": "A7100_X3"
  },
  {
    "Retail Branding": "Gtel",
    "Marketing Name": "A7101_X3_mini",
    "Device": "A7101_X3_mini",
    "Model": "A7101_X3_mini"
  },
  {
    "Retail Branding": "Gtel",
    "Marketing Name": "A713_Vivo_Pro",
    "Device": "A713_Vivo_Pro",
    "Model": "A713_Vivo_Pro"
  },
  {
    "Retail Branding": "Gtel",
    "Marketing Name": "A714 Vivo Play",
    "Device": "A714_Vivo_Play",
    "Model": "A714_Vivo_Play"
  },
  {
    "Retail Branding": "Gtel",
    "Marketing Name": "A7155_X4_mini",
    "Device": "A7155_X4_mini",
    "Model": "A7155_X4_mini"
  },
  {
    "Retail Branding": "Gtel",
    "Marketing Name": "A715_Inspire_One",
    "Device": "A715_Inspire_One",
    "Model": "A715_Inspire_One"
  },
  {
    "Retail Branding": "Gtel",
    "Marketing Name": "A716 Inspire Life",
    "Device": "A716_Inspire_Life",
    "Model": "A716_Inspire_Life"
  },
  {
    "Retail Branding": "Gtel",
    "Marketing Name": "A726 Infinity Lite",
    "Device": "A726_Infinity_Lite",
    "Model": "A726_Infinity_Lite"
  },
  {
    "Retail Branding": "Gtel",
    "Marketing Name": "A727_Infinity_Pro",
    "Device": "A727_Infinity_Pro",
    "Model": "A727_Infinity_Pro"
  },
  {
    "Retail Branding": "Gtel",
    "Marketing Name": "A728_XP2",
    "Device": "A728_XP2",
    "Model": "A728_XP2"
  },
  {
    "Retail Branding": "Gtel",
    "Marketing Name": "A737_XploraZ",
    "Device": "A737_XploraZ",
    "Model": "A737_XploraZ"
  },
  {
    "Retail Branding": "Gtel",
    "Marketing Name": "A770_SL8_Pro",
    "Device": "A770_SL8_Pro",
    "Model": "A770_SL8_Pro"
  },
  {
    "Retail Branding": "Gtel",
    "Marketing Name": "A770_XL7",
    "Device": "A770_XL7",
    "Model": "A770_XL7"
  },
  {
    "Retail Branding": "Gtel",
    "Marketing Name": "Delta_14",
    "Device": "Delta_14",
    "Model": "Delta_14"
  },
  {
    "Retail Branding": "Gtel",
    "Marketing Name": "Gtel Infinity 8s",
    "Device": "Gtel_Infinity_8s",
    "Model": "Gtel Infinity 8s"
  },
  {
    "Retail Branding": "Gtel",
    "Marketing Name": "Gtel Mx5",
    "Device": "Gtel_Mx5",
    "Model": "Gtel Mx5"
  },
  {
    "Retail Branding": "Gtel",
    "Marketing Name": "Gtel X6mini",
    "Device": "Gtel_X6mini",
    "Model": "Gtel X6mini"
  },
  {
    "Retail Branding": "Gtel",
    "Marketing Name": "Gtel X6plus",
    "Device": "Gtel_X6plus",
    "Model": "Gtel X6plus"
  },
  {
    "Retail Branding": "Gtel",
    "Marketing Name": "Gtel X6pro",
    "Device": "Gtel_X6pro",
    "Model": "Gtel X6pro"
  },
  {
    "Retail Branding": "Gtel",
    "Marketing Name": "Gtel X6s",
    "Device": "Gtel_X6s",
    "Model": "Gtel X6s"
  },
  {
    "Retail Branding": "Gtel",
    "Marketing Name": "Gtel X7plus",
    "Device": "Gtel_X7plus",
    "Model": "Gtel X7plus"
  },
  {
    "Retail Branding": "Gtel",
    "Marketing Name": "Gtel X7pro",
    "Device": "Gtel_X7pro",
    "Model": "Gtel X7pro"
  },
  {
    "Retail Branding": "Gtel",
    "Marketing Name": "Gtel X7s",
    "Device": "Gtel_X7s",
    "Model": "Gtel X7s"
  },
  {
    "Retail Branding": "Gtel",
    "Marketing Name": "Gtel_Delta_16",
    "Device": "Gtel_Delta_16",
    "Model": "Gtel Delta 16"
  },
  {
    "Retail Branding": "Gtel",
    "Marketing Name": "Gtel_Delta_17",
    "Device": "Gtel_Delta_17",
    "Model": "Gtel_Delta_17"
  },
  {
    "Retail Branding": "Gtel",
    "Marketing Name": "Gtel_Infinity_9",
    "Device": "Gtel_Infinity_9",
    "Model": "Gtel Infinity 9"
  },
  {
    "Retail Branding": "Gtel",
    "Marketing Name": "Gtel_Infinity_X",
    "Device": "Gtel_Infinity_X",
    "Model": "Gtel Infinity X"
  },
  {
    "Retail Branding": "Gtel",
    "Marketing Name": "Gtel_Vivo3",
    "Device": "Gtel_Vivo3",
    "Model": "Gtel_Vivo3"
  },
  {
    "Retail Branding": "Gtel",
    "Marketing Name": "Gtel_X5mini",
    "Device": "Gtel_X5mini",
    "Model": "Gtel_X5mini"
  },
  {
    "Retail Branding": "Gtel",
    "Marketing Name": "Gtel_X5s",
    "Device": "Gtel_X5s",
    "Model": "Gtel_X5s"
  },
  {
    "Retail Branding": "Gtel",
    "Marketing Name": "Infinity 7 Plus",
    "Device": "Infinity7Plus",
    "Model": "Infinity 7 Plus"
  },
  {
    "Retail Branding": "Gtel",
    "Marketing Name": "Infinity 7 Pro",
    "Device": "Infinity7Pro",
    "Model": "Infinity 7 Pro"
  },
  {
    "Retail Branding": "Gtel",
    "Marketing Name": "Infinity_13",
    "Device": "Infinity_13",
    "Model": "Infinity_13"
  },
  {
    "Retail Branding": "Gtel",
    "Marketing Name": "Mx6",
    "Device": "Mx6",
    "Model": "Mx6"
  },
  {
    "Retail Branding": "Gtel",
    "Marketing Name": "X5",
    "Device": "Gtel_X5",
    "Model": "Gtel X5"
  },
  {
    "Retail Branding": "Gtel",
    "Marketing Name": "X5plus",
    "Device": "Gtel_X5plus",
    "Model": "Gtel X5plus"
  },
  {
    "Retail Branding": "Guess",
    "Marketing Name": "Wear",
    "Device": "glowlight",
    "Model": "GUESS Connect"
  },
  {
    "Retail Branding": "Guophone",
    "Marketing Name": "X3",
    "Device": "X3",
    "Model": "X3"
  },
  {
    "Retail Branding": "Guophone",
    "Marketing Name": "XP9800",
    "Device": "Guophone_XP9800",
    "Model": "XP9800"
  },
  {
    "Retail Branding": "H(tab)",
    "Marketing Name": "H_Tab_Go",
    "Device": "H_Tab_Go",
    "Model": "H_Tab_Go"
  },
  {
    "Retail Branding": "H(tab)",
    "Marketing Name": "H_Tab_Lite",
    "Device": "H_Tab_Lite",
    "Model": "H_Tab_Lite"
  },
  {
    "Retail Branding": "H(tab)",
    "Marketing Name": "H_tab_1",
    "Device": "H_tab_1",
    "Model": "H_tab_1"
  },
  {
    "Retail Branding": "H(tab)",
    "Marketing Name": "H_tab_1Pro",
    "Device": "H_tab_1Pro",
    "Model": "H_tab_1Pro"
  },
  {
    "Retail Branding": "H(tab)",
    "Marketing Name": "H_tab_1_plus",
    "Device": "H_tab_1_plus",
    "Model": "H_tab_1_plus"
  },
  {
    "Retail Branding": "H133",
    "Marketing Name": "Betacrux",
    "Device": "Betacrux",
    "Model": "Betacrux"
  },
  {
    "Retail Branding": "H3Cmagic",
    "Marketing Name": "M8781",
    "Device": "M8781",
    "Model": "M8781"
  },
  {
    "Retail Branding": "H819E",
    "Marketing Name": "MINTAKA",
    "Device": "MINTAKA",
    "Model": "MINTAKA"
  },
  {
    "Retail Branding": "HAAM",
    "Marketing Name": "HAAM TV 4K",
    "Device": "eleonas",
    "Model": "HAAM TV 4K"
  },
  {
    "Retail Branding": "HAAM",
    "Marketing Name": "HAAM TV 4K FF",
    "Device": "eleonas",
    "Model": "HAAM TV 4K FF"
  },
  {
    "Retail Branding": "HAAM",
    "Marketing Name": "R3",
    "Device": "R3",
    "Model": "R3"
  },
  {
    "Retail Branding": "HAAM",
    "Marketing Name": "R3_GTV",
    "Device": "R3_GTV",
    "Model": "R3G"
  },
  {
    "Retail Branding": "HAAM",
    "Marketing Name": "R4_GTV",
    "Device": "R4_GTV",
    "Model": "R4G"
  },
  {
    "Retail Branding": "HAAM",
    "Marketing Name": "vileparle",
    "Device": "vileparle",
    "Model": "R6G"
  },
  {
    "Retail Branding": "HAEXC",
    "Marketing Name": "FP103Ex",
    "Device": "FP103Ex",
    "Model": "FP103Ex"
  },
  {
    "Retail Branding": "HAEXC",
    "Marketing Name": "SP104Ex",
    "Device": "SP104Ex",
    "Model": "SP104Ex"
  },
  {
    "Retail Branding": "HAKO",
    "Marketing Name": "HAKO Pro",
    "Device": "YXU",
    "Model": "HAKO Pro"
  },
  {
    "Retail Branding": "HAKO",
    "Marketing Name": "HAKO mini",
    "Device": "GMP",
    "Model": "HAKO mini"
  },
  {
    "Retail Branding": "HALA",
    "Marketing Name": "B1 PDA",
    "Device": "B1_PDA",
    "Model": "B1_PDA"
  },
  {
    "Retail Branding": "HANASIS",
    "Marketing Name": "BLAZE",
    "Device": "BLAZE",
    "Model": "BLAZE"
  },
  {
    "Retail Branding": "HANDELSON",
    "Marketing Name": "H14",
    "Device": "H14",
    "Model": "H14"
  },
  {
    "Retail Branding": "HANET",
    "Marketing Name": "T432",
    "Device": "SmartEdu",
    "Model": "T432"
  },
  {
    "Retail Branding": "HANKOOK-CREA",
    "Marketing Name": "HANKOOK_CREA_IFPD",
    "Device": "oversea_v",
    "Model": "HKCREA_Series"
  },
  {
    "Retail Branding": "HANKOOK_CREA",
    "Marketing Name": "HANKOOK_CREA_IFPD",
    "Device": "HANKOOK_CREA_RK3588",
    "Model": "CREA_86135_Series"
  },
  {
    "Retail Branding": "HANSUNGCOMPUTER",
    "Marketing Name": "HSC-IFPD",
    "Device": "rk3588_t",
    "Model": "HSG_Series"
  },
  {
    "Retail Branding": "HANSUNGCOMPUTER",
    "Marketing Name": "HSC-IFPD",
    "Device": "rk3588_t",
    "Model": "HSN_Series"
  },
  {
    "Retail Branding": "HANYEAL",
    "Marketing Name": "E101GC",
    "Device": "E101GC",
    "Model": "E101GC"
  },
  {
    "Retail Branding": "HANYEAL",
    "Marketing Name": "E108GC4G",
    "Device": "E108GC4G",
    "Model": "E108GC4G"
  },
  {
    "Retail Branding": "HAOVM",
    "Marketing Name": "HP10",
    "Device": "HP10",
    "Model": "P10"
  },
  {
    "Retail Branding": "HAOVM",
    "Marketing Name": "HP10_EEA",
    "Device": "HP10_EEA",
    "Model": "P10_EEA"
  },
  {
    "Retail Branding": "HAOVM",
    "Marketing Name": "HP20",
    "Device": "HP20",
    "Model": "P20"
  },
  {
    "Retail Branding": "HAOVM",
    "Marketing Name": "MediaPad C8",
    "Device": "HC8",
    "Model": "C8"
  },
  {
    "Retail Branding": "HAOVM",
    "Marketing Name": "MediaPadP8",
    "Device": "P8",
    "Model": "P8"
  },
  {
    "Retail Branding": "HAOVM",
    "Marketing Name": "P10_2024",
    "Device": "P10_2024",
    "Model": "P10"
  },
  {
    "Retail Branding": "HAOVM",
    "Marketing Name": "P10_Pro",
    "Device": "P10_Pro",
    "Model": "P10_Pro"
  },
  {
    "Retail Branding": "HAOVM",
    "Marketing Name": "P20",
    "Device": "P20",
    "Model": "P20"
  },
  {
    "Retail Branding": "HAOVM",
    "Marketing Name": "P8",
    "Device": "HP8",
    "Model": "P8"
  },
  {
    "Retail Branding": "HAOVM",
    "Marketing Name": "P9",
    "Device": "P9",
    "Model": "P9"
  },
  {
    "Retail Branding": "HAOVM",
    "Marketing Name": "P9_EEA",
    "Device": "P9_EEA",
    "Model": "P9_EEA"
  },
  {
    "Retail Branding": "HAOVM",
    "Marketing Name": "PS30",
    "Device": "PS30",
    "Model": "S30"
  },
  {
    "Retail Branding": "HAOVM",
    "Marketing Name": "Q16W",
    "Device": "Q16W",
    "Model": "Q16W"
  },
  {
    "Retail Branding": "HAOVM",
    "Marketing Name": "T2000",
    "Device": "T2000",
    "Model": "T2000"
  },
  {
    "Retail Branding": "HAOVM",
    "Marketing Name": "T30W",
    "Device": "T30W",
    "Model": "T30W"
  },
  {
    "Retail Branding": "HAOVM",
    "Marketing Name": "V5",
    "Device": "V5",
    "Model": "V5"
  },
  {
    "Retail Branding": "HAOVM",
    "Marketing Name": "W10",
    "Device": "W10",
    "Model": "W10"
  },
  {
    "Retail Branding": "HAOWEI",
    "Marketing Name": "HBDC-1122",
    "Device": "HBDC-1122",
    "Model": "HBDC-1122"
  },
  {
    "Retail Branding": "HAOWEI",
    "Marketing Name": "HBDC-822",
    "Device": "HBDC-822",
    "Model": "HBDC-822"
  },
  {
    "Retail Branding": "HAPPRUN",
    "Marketing Name": "D9",
    "Device": "himalaya",
    "Model": "D9"
  },
  {
    "Retail Branding": "HAPPRUN",
    "Marketing Name": "J7Pro",
    "Device": "himalaya",
    "Model": "J7Pro"
  },
  {
    "Retail Branding": "HAPPRUN",
    "Marketing Name": "K7",
    "Device": "himalaya",
    "Model": "K7"
  },
  {
    "Retail Branding": "HAPPRUN",
    "Marketing Name": "Q7",
    "Device": "himalaya",
    "Model": "Q7"
  },
  {
    "Retail Branding": "HAPPYNET",
    "Marketing Name": "HPN-QA15",
    "Device": "HPN-QA15",
    "Model": "HPN-QA15"
  },
  {
    "Retail Branding": "HAVIT",
    "Marketing Name": "PJ209APlus",
    "Device": "himalaya",
    "Model": "PJ209APlus"
  },
  {
    "Retail Branding": "HAZARD_TALK",
    "Marketing Name": "M2",
    "Device": "M2",
    "Model": "M2"
  },
  {
    "Retail Branding": "HBESTORE",
    "Marketing Name": "HL_1068_A133",
    "Device": "HL_1068_A133",
    "Model": "HL_1068_A133"
  },
  {
    "Retail Branding": "HCNCP",
    "Marketing Name": "HA10",
    "Device": "HA10",
    "Model": "HA10"
  },
  {
    "Retail Branding": "HCNCP",
    "Marketing Name": "HA10Kids",
    "Device": "HA10Kids",
    "Model": "HA10Kids"
  },
  {
    "Retail Branding": "HCNCP",
    "Marketing Name": "HT10Pro",
    "Device": "HT10Pro",
    "Model": "HT10Pro"
  },
  {
    "Retail Branding": "HCNCP",
    "Marketing Name": "HT11",
    "Device": "HT11",
    "Model": "MID1109A-SC"
  },
  {
    "Retail Branding": "HDC S.A.",
    "Marketing Name": "H10_ONE",
    "Device": "H10_ONE",
    "Model": "H10_ONE"
  },
  {
    "Retail Branding": "HDC S.A.",
    "Marketing Name": "H7_ONE",
    "Device": "H7_ONE",
    "Model": "H7_ONE"
  },
  {
    "Retail Branding": "HDC S.A.",
    "Marketing Name": "HDC",
    "Device": "TK718",
    "Model": "TK718"
  },
  {
    "Retail Branding": "HDC S.A.",
    "Marketing Name": "T10I-4128",
    "Device": "T10I-4128",
    "Model": "T10I-4128"
  },
  {
    "Retail Branding": "HDC S.A.",
    "Marketing Name": "T10_232",
    "Device": "T10_232",
    "Model": "T10_232"
  },
  {
    "Retail Branding": "HDC S.A.",
    "Marketing Name": "T700B",
    "Device": "T700B",
    "Model": "T700B"
  },
  {
    "Retail Branding": "HDC S.A.",
    "Marketing Name": "T7I_232",
    "Device": "T7I_232",
    "Model": "T7I_232"
  },
  {
    "Retail Branding": "HDD SAT",
    "Marketing Name": "Tab_i_excess",
    "Device": "Tab_i_excess",
    "Model": "Tab_i_excess"
  },
  {
    "Retail Branding": "HDFocus",
    "Marketing Name": "Interactive-Board",
    "Device": "t7_an400",
    "Model": "HDFocusC8"
  },
  {
    "Retail Branding": "HD_Plus",
    "Marketing Name": "HD+ IP TV-Stick",
    "Device": "SEI900HDPLUS",
    "Model": "HD+ IP TV-Stick"
  },
  {
    "Retail Branding": "HEADWOLF",
    "Marketing Name": "F2A",
    "Device": "F2A",
    "Model": "F2"
  },
  {
    "Retail Branding": "HEADWOLF",
    "Marketing Name": "F3A",
    "Device": "F3A",
    "Model": "F3A"
  },
  {
    "Retail Branding": "HEADWOLF",
    "Marketing Name": "F5",
    "Device": "Fpad5",
    "Model": "F5"
  },
  {
    "Retail Branding": "HEADWOLF",
    "Marketing Name": "F5A",
    "Device": "F5A",
    "Model": "F5A"
  },
  {
    "Retail Branding": "HEADWOLF",
    "Marketing Name": "F6",
    "Device": "F6",
    "Model": "F6"
  },
  {
    "Retail Branding": "HEADWOLF",
    "Marketing Name": "F6E",
    "Device": "F6E",
    "Model": "F6E"
  },
  {
    "Retail Branding": "HEADWOLF",
    "Marketing Name": "F7",
    "Device": "F7",
    "Model": "F7"
  },
  {
    "Retail Branding": "HEADWOLF",
    "Marketing Name": "F8",
    "Device": "F8",
    "Model": "Titan 1"
  },
  {
    "Retail Branding": "HEADWOLF",
    "Marketing Name": "Fpad1",
    "Device": "Fpad1",
    "Model": "F1"
  },
  {
    "Retail Branding": "HEADWOLF",
    "Marketing Name": "Fpad2",
    "Device": "Fpad2",
    "Model": "Fpad2"
  },
  {
    "Retail Branding": "HEADWOLF",
    "Marketing Name": "Fpad3",
    "Device": "Fpad3",
    "Model": "F3"
  },
  {
    "Retail Branding": "HEADWOLF",
    "Marketing Name": "H3",
    "Device": "Hpad3",
    "Model": "H3"
  },
  {
    "Retail Branding": "HEADWOLF",
    "Marketing Name": "H5",
    "Device": "Hpad5",
    "Model": "H5"
  },
  {
    "Retail Branding": "HEADWOLF",
    "Marketing Name": "HPAD1A",
    "Device": "HPAD1A",
    "Model": "H1A"
  },
  {
    "Retail Branding": "HEADWOLF",
    "Marketing Name": "HPAD6",
    "Device": "HPAD6",
    "Model": "H6"
  },
  {
    "Retail Branding": "HEADWOLF",
    "Marketing Name": "Hpad1",
    "Device": "Hpad1",
    "Model": "Hpad1"
  },
  {
    "Retail Branding": "HEADWOLF",
    "Marketing Name": "Hpad2",
    "Device": "Hpad2",
    "Model": "H2"
  },
  {
    "Retail Branding": "HEADWOLF",
    "Marketing Name": "Hpad2",
    "Device": "Hpad2",
    "Model": "H2A"
  },
  {
    "Retail Branding": "HEADWOLF",
    "Marketing Name": "Hpad5",
    "Device": "Hpad5",
    "Model": "H5A"
  },
  {
    "Retail Branding": "HEADWOLF",
    "Marketing Name": "L1",
    "Device": "L1",
    "Model": "L1"
  },
  {
    "Retail Branding": "HEADWOLF",
    "Marketing Name": "L1",
    "Device": "L1",
    "Model": "Lpad1"
  },
  {
    "Retail Branding": "HEADWOLF",
    "Marketing Name": "W5",
    "Device": "W5",
    "Model": "W5"
  },
  {
    "Retail Branding": "HEADWOLF",
    "Marketing Name": "W5A",
    "Device": "W5A",
    "Model": "W5A"
  },
  {
    "Retail Branding": "HEADWOLF",
    "Marketing Name": "W6A",
    "Device": "W6A",
    "Model": "W6"
  },
  {
    "Retail Branding": "HEADWOLF",
    "Marketing Name": "W6B",
    "Device": "W6B",
    "Model": "W6B"
  },
  {
    "Retail Branding": "HEADWOLF",
    "Marketing Name": "W6C",
    "Device": "W6C",
    "Model": "W6C"
  },
  {
    "Retail Branding": "HEADWOLF",
    "Marketing Name": "W7",
    "Device": "W7",
    "Model": "W7"
  },
  {
    "Retail Branding": "HEADWOLF",
    "Marketing Name": "W7B",
    "Device": "W7B",
    "Model": "W7B"
  },
  {
    "Retail Branding": "HEADWOLF",
    "Marketing Name": "WPAD2",
    "Device": "WPAD2",
    "Model": "W2"
  },
  {
    "Retail Branding": "HEADWOLF",
    "Marketing Name": "Wpad1",
    "Device": "Wpad1",
    "Model": "W1"
  },
  {
    "Retail Branding": "HEADWOLF",
    "Marketing Name": "Wpad2",
    "Device": "Wpad2",
    "Model": "W2"
  },
  {
    "Retail Branding": "HEALTHJAY",
    "Marketing Name": "JayPad_2_0",
    "Device": "JayPad_2_0",
    "Model": "JayPad_2_0"
  },
  {
    "Retail Branding": "HEATZ",
    "Marketing Name": "HZ9950",
    "Device": "HZ9950",
    "Model": "HZ9950"
  },
  {
    "Retail Branding": "HEATZ",
    "Marketing Name": "Z9910A",
    "Device": "Z9910A",
    "Model": "Z9910"
  },
  {
    "Retail Branding": "HEATZ",
    "Marketing Name": "Z9950",
    "Device": "Z9950",
    "Model": "Z9950"
  },
  {
    "Retail Branding": "HELIX_INC",
    "Marketing Name": "C-TABLET",
    "Device": "C-TABLET",
    "Model": "C-TABLET"
  },
  {
    "Retail Branding": "HELLCAT",
    "Marketing Name": "TAB10_1",
    "Device": "TAB10_1",
    "Model": "TAB10"
  },
  {
    "Retail Branding": "HELLCAT",
    "Marketing Name": "TAB11GT",
    "Device": "TAB11GT",
    "Model": "TAB11GT"
  },
  {
    "Retail Branding": "HELLCAT",
    "Marketing Name": "TAB8-1",
    "Device": "TAB8-1",
    "Model": "TAB8"
  },
  {
    "Retail Branding": "HERAN",
    "Marketing Name": "Smart TV",
    "Device": "alimos",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "HERAN",
    "Marketing Name": "Smart TV",
    "Device": "bridgeport",
    "Model": "AI PONT PLUS FF"
  },
  {
    "Retail Branding": "HERAN",
    "Marketing Name": "Smart TV",
    "Device": "dangni",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "HEROFUN",
    "Marketing Name": "BH502G",
    "Device": "BH502G",
    "Model": "BH502G"
  },
  {
    "Retail Branding": "HEROFUN",
    "Marketing Name": "BH558G",
    "Device": "BH558G",
    "Model": "BH558G"
  },
  {
    "Retail Branding": "HEROFUN",
    "Marketing Name": "BH805G",
    "Device": "BH805G",
    "Model": "BH805G"
  },
  {
    "Retail Branding": "HIGRACE",
    "Marketing Name": "G15",
    "Device": "G15",
    "Model": "G15"
  },
  {
    "Retail Branding": "HIGRACE",
    "Marketing Name": "G15_EEA",
    "Device": "G15",
    "Model": "G15"
  },
  {
    "Retail Branding": "HIGRACE",
    "Marketing Name": "OC101",
    "Device": "OC101",
    "Model": "OC101"
  },
  {
    "Retail Branding": "HIGRACE",
    "Marketing Name": "OC101",
    "Device": "OC101_EEA",
    "Model": "OC101"
  },
  {
    "Retail Branding": "HIKVISION",
    "Marketing Name": "DS-MDT202",
    "Device": "DS-MDT202",
    "Model": "DS-MDT202"
  },
  {
    "Retail Branding": "HIKVISION",
    "Marketing Name": "DS-MDT301",
    "Device": "DS-MDT301",
    "Model": "DS-MDT301"
  },
  {
    "Retail Branding": "HIKVISION",
    "Marketing Name": "DS_D5C75RB_A",
    "Device": "DS_D5C65RB_A",
    "Model": "DS_D5C65RB_A"
  },
  {
    "Retail Branding": "HIKVISION",
    "Marketing Name": "HIK_3576",
    "Device": "HIK_3576",
    "Model": "HIK_3576"
  },
  {
    "Retail Branding": "HIKVISION",
    "Marketing Name": "HIK_3588",
    "Device": "HIK_3588",
    "Model": "HIK_3588"
  },
  {
    "Retail Branding": "HIKVISION",
    "Marketing Name": "HIK_9679",
    "Device": "HIK_9679",
    "Model": "HIK_9679"
  },
  {
    "Retail Branding": "HIMADE",
    "Marketing Name": "HIMADE",
    "Device": "shilin",
    "Model": "HIMADE4KAndroidTV"
  },
  {
    "Retail Branding": "HIMADE",
    "Marketing Name": "UHD Android TV",
    "Device": "sindorim",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "HISORL",
    "Marketing Name": "P50",
    "Device": "P50",
    "Model": "P50"
  },
  {
    "Retail Branding": "HISORL",
    "Marketing Name": "P50",
    "Device": "P50",
    "Model": "T10"
  },
  {
    "Retail Branding": "HISORL",
    "Marketing Name": "P50",
    "Device": "P50",
    "Model": "Y101P"
  },
  {
    "Retail Branding": "HISORL",
    "Marketing Name": "P80-EEA",
    "Device": "P80-EEA",
    "Model": "P80"
  },
  {
    "Retail Branding": "HISORL",
    "Marketing Name": "P80-ROW",
    "Device": "P80-ROW",
    "Model": "P80"
  },
  {
    "Retail Branding": "HISORL",
    "Marketing Name": "T10P",
    "Device": "T10P",
    "Model": "T10P"
  },
  {
    "Retail Branding": "HISORL",
    "Marketing Name": "T901_EEA",
    "Device": "T901_EEA",
    "Model": "T901"
  },
  {
    "Retail Branding": "HISORL",
    "Marketing Name": "T901_ROW",
    "Device": "T901_ROW",
    "Model": "T901"
  },
  {
    "Retail Branding": "HISORL",
    "Marketing Name": "TAB10_EEA",
    "Device": "TAB10_EEA",
    "Model": "TAB10_EEA"
  },
  {
    "Retail Branding": "HISORL",
    "Marketing Name": "TAB10_ROW",
    "Device": "TAB10_ROW",
    "Model": "TAB10_ROW"
  },
  {
    "Retail Branding": "HISORL",
    "Marketing Name": "TAB_10",
    "Device": "TAB_10",
    "Model": "TAB_10"
  },
  {
    "Retail Branding": "HISORL",
    "Marketing Name": "TB02_EEA",
    "Device": "TB02_EEA",
    "Model": "TB02"
  },
  {
    "Retail Branding": "HISORL",
    "Marketing Name": "TB02_ROW",
    "Device": "TB02_ROW",
    "Model": "TB02"
  },
  {
    "Retail Branding": "HISORL",
    "Marketing Name": "Y101P",
    "Device": "Y101P",
    "Model": "Y101P"
  },
  {
    "Retail Branding": "HKC",
    "Marketing Name": "A79 Tablet",
    "Device": "EM62",
    "Model": "A79"
  },
  {
    "Retail Branding": "HKC Elec",
    "Marketing Name": "4K Smart TV",
    "Device": "gangbyeon",
    "Model": "HKC 4K AI Smart TV"
  },
  {
    "Retail Branding": "HKC Elec",
    "Marketing Name": "4K Smart TV",
    "Device": "gangbyeon",
    "Model": "TATUNG 4K AI Smart TV"
  },
  {
    "Retail Branding": "HKC Elec",
    "Marketing Name": "4K Smart TV",
    "Device": "pioneer",
    "Model": "4K PA Smart TV"
  },
  {
    "Retail Branding": "HKC Elec",
    "Marketing Name": "4K Smart TV",
    "Device": "pioneer",
    "Model": "4K SA Smart TV"
  },
  {
    "Retail Branding": "HKC Elec",
    "Marketing Name": "4K Smart TV",
    "Device": "pioneer",
    "Model": "HKC 4K SA Smart TV"
  },
  {
    "Retail Branding": "HKC Elec",
    "Marketing Name": "Google Monitor",
    "Device": "caoya",
    "Model": "2851F Google Monitor"
  },
  {
    "Retail Branding": "HKC Elec",
    "Marketing Name": "Google Monitor",
    "Device": "caoya",
    "Model": "Google Monitor"
  },
  {
    "Retail Branding": "HKC Elec",
    "Marketing Name": "Google TV",
    "Device": "burbank",
    "Model": "4K KR Google TV"
  },
  {
    "Retail Branding": "HKC Elec",
    "Marketing Name": "Google TV",
    "Device": "burbank",
    "Model": "4K PA Google TV"
  },
  {
    "Retail Branding": "HKC Elec",
    "Marketing Name": "Google TV",
    "Device": "burbank",
    "Model": "4K SA Google TV"
  },
  {
    "Retail Branding": "HKC Elec",
    "Marketing Name": "Google TV",
    "Device": "kannai",
    "Model": "2K JP Google TV"
  },
  {
    "Retail Branding": "HKC Elec",
    "Marketing Name": "Google TV",
    "Device": "lakeside",
    "Model": "4K COL Google TV"
  },
  {
    "Retail Branding": "HKC Elec",
    "Marketing Name": "Google TV",
    "Device": "lakeside",
    "Model": "4K PA Google TV"
  },
  {
    "Retail Branding": "HKC Elec",
    "Marketing Name": "Google TV",
    "Device": "lakeside",
    "Model": "4K SA Google TV"
  },
  {
    "Retail Branding": "HKC Elec",
    "Marketing Name": "Google TV",
    "Device": "lakeside",
    "Model": "4K US Google TV"
  },
  {
    "Retail Branding": "HKC Elec",
    "Marketing Name": "Google TV",
    "Device": "lakeside",
    "Model": "POLYTRON 4K"
  },
  {
    "Retail Branding": "HKC Elec",
    "Marketing Name": "Google TV",
    "Device": "nagai",
    "Model": "2K COL Google TV"
  },
  {
    "Retail Branding": "HKC Elec",
    "Marketing Name": "Google TV",
    "Device": "nagai",
    "Model": "2K PA Google TV"
  },
  {
    "Retail Branding": "HKC Elec",
    "Marketing Name": "Google TV",
    "Device": "nagai",
    "Model": "2K SA Google TV"
  },
  {
    "Retail Branding": "HKC Elec",
    "Marketing Name": "Google TV",
    "Device": "nagai",
    "Model": "2K US Google TV"
  },
  {
    "Retail Branding": "HKC Elec",
    "Marketing Name": "Google TV",
    "Device": "nagai",
    "Model": "POLYTRON 2K"
  },
  {
    "Retail Branding": "HKC Elec",
    "Marketing Name": "Google TV",
    "Device": "panormou",
    "Model": "4K 9676 Google TV"
  },
  {
    "Retail Branding": "HKC Elec",
    "Marketing Name": "Google TV",
    "Device": "piha",
    "Model": "4K JP ACAS Google TV"
  },
  {
    "Retail Branding": "HKC Elec",
    "Marketing Name": "Google TV",
    "Device": "piha",
    "Model": "4K JP BCAS Google TV"
  },
  {
    "Retail Branding": "HKC Elec",
    "Marketing Name": "HKC TV",
    "Device": "kannai",
    "Model": "2K JP Google TV"
  },
  {
    "Retail Branding": "HKC Elec",
    "Marketing Name": "Smart Monitor",
    "Device": "mateo",
    "Model": "2K Smart Monitor"
  },
  {
    "Retail Branding": "HKC Elec",
    "Marketing Name": "Smart TV",
    "Device": "mateo",
    "Model": "2K PA Smart TV"
  },
  {
    "Retail Branding": "HKC Elec",
    "Marketing Name": "Smart TV",
    "Device": "mateo",
    "Model": "2K US Smart TV"
  },
  {
    "Retail Branding": "HKC Elec",
    "Marketing Name": "Smart TV",
    "Device": "mateo",
    "Model": "HKC 2K SA Smart TV"
  },
  {
    "Retail Branding": "HKC Elec",
    "Marketing Name": "Smart TV",
    "Device": "pioneer",
    "Model": "4K PA Smart TV"
  },
  {
    "Retail Branding": "HKT",
    "Marketing Name": "eye3",
    "Device": "UY3-PCW",
    "Model": "eye3"
  },
  {
    "Retail Branding": "HMD",
    "Marketing Name": "HMD ARC",
    "Device": "NYX",
    "Model": "HMD ARC"
  },
  {
    "Retail Branding": "HMD",
    "Marketing Name": "HMD Aura",
    "Device": "RCK",
    "Model": "HMD Aura"
  },
  {
    "Retail Branding": "HMD",
    "Marketing Name": "HMD Barça Fusion",
    "Device": "NHK",
    "Model": "HMD Fusion"
  },
  {
    "Retail Branding": "HMD",
    "Marketing Name": "HMD CREST",
    "Device": "ARW",
    "Model": "Arrow"
  },
  {
    "Retail Branding": "HMD",
    "Marketing Name": "HMD CREST",
    "Device": "ARW",
    "Model": "HMD CREST"
  },
  {
    "Retail Branding": "HMD",
    "Marketing Name": "HMD CREST MAX",
    "Device": "ARP",
    "Model": "ArrowPro"
  },
  {
    "Retail Branding": "HMD",
    "Marketing Name": "HMD CREST MAX",
    "Device": "ARP",
    "Model": "HMD CREST MAX"
  },
  {
    "Retail Branding": "HMD",
    "Marketing Name": "HMD Fuse",
    "Device": "NHK",
    "Model": "HMD Fusion"
  },
  {
    "Retail Branding": "HMD",
    "Marketing Name": "HMD Fusion",
    "Device": "NHK",
    "Model": "HMD Fusion"
  },
  {
    "Retail Branding": "HMD",
    "Marketing Name": "HMD Fusion Business Edition",
    "Device": "NHK",
    "Model": "HMD Fusion Business Edition"
  },
  {
    "Retail Branding": "HMD",
    "Marketing Name": "HMD Fusion X1",
    "Device": "NHK",
    "Model": "HMD Fusion"
  },
  {
    "Retail Branding": "HMD",
    "Marketing Name": "HMD KEY",
    "Device": "CMT",
    "Model": "HMD KEY"
  },
  {
    "Retail Branding": "HMD",
    "Marketing Name": "HMD Pearl",
    "Device": "CMR",
    "Model": "HMD Pearl"
  },
  {
    "Retail Branding": "HMD",
    "Marketing Name": "HMD Pulse",
    "Device": "LGD",
    "Model": "HMD Pulse"
  },
  {
    "Retail Branding": "HMD",
    "Marketing Name": "HMD Pulse Pro",
    "Device": "LGR",
    "Model": "HMD Pulse Pro"
  },
  {
    "Retail Branding": "HMD",
    "Marketing Name": "HMD Pulse+",
    "Device": "LGP",
    "Model": "HMD Pulse Plus"
  },
  {
    "Retail Branding": "HMD",
    "Marketing Name": "HMD Skyline",
    "Device": "TCT",
    "Model": "HMD Skyline"
  },
  {
    "Retail Branding": "HMD",
    "Marketing Name": "HMD Skyline Business Edition",
    "Device": "TCT",
    "Model": "HMD Skyline Business Edition"
  },
  {
    "Retail Branding": "HMD",
    "Marketing Name": "HMD T21",
    "Device": "AGTAH",
    "Model": "HMD T21"
  },
  {
    "Retail Branding": "HMD",
    "Marketing Name": "HMD T21",
    "Device": "AGTH",
    "Model": "HMD T21"
  },
  {
    "Retail Branding": "HMD",
    "Marketing Name": "HMD Vibe",
    "Device": "SHK",
    "Model": "N159V"
  },
  {
    "Retail Branding": "HMD",
    "Marketing Name": "HMD XR21",
    "Device": "SNT",
    "Model": "HMD XR21"
  },
  {
    "Retail Branding": "HMD",
    "Marketing Name": "M-KOPA X2",
    "Device": "LGD",
    "Model": "M-KOPA X2"
  },
  {
    "Retail Branding": "HMD",
    "Marketing Name": "M-KOPA X20",
    "Device": "LGR",
    "Model": "M-KOPA X20"
  },
  {
    "Retail Branding": "HMR NETWORKS",
    "Marketing Name": "HMR NETWORKS (PTY) LTD",
    "Device": "HMR5012",
    "Model": "HMR5012"
  },
  {
    "Retail Branding": "HOLO",
    "Marketing Name": "USA",
    "Device": "VE1983",
    "Model": "VE1983"
  },
  {
    "Retail Branding": "HOLO",
    "Marketing Name": "VE0319",
    "Device": "VE0319",
    "Model": "VE0319"
  },
  {
    "Retail Branding": "HOLO",
    "Marketing Name": "X10",
    "Device": "X10",
    "Model": "X10"
  },
  {
    "Retail Branding": "HOLO",
    "Marketing Name": "X20",
    "Device": "K12B",
    "Model": "X20"
  },
  {
    "Retail Branding": "HOLO",
    "Marketing Name": "XPLAY3",
    "Device": "XPLAY3",
    "Model": "XPLAY3"
  },
  {
    "Retail Branding": "HOLO",
    "Marketing Name": "XULTRA2",
    "Device": "XULTRA2",
    "Model": "XULTRA2"
  },
  {
    "Retail Branding": "HOLO",
    "Marketing Name": "XULTRA3",
    "Device": "XULTRA3",
    "Model": "XULTRA3"
  },
  {
    "Retail Branding": "HOLO",
    "Marketing Name": "XULTRAPLUS",
    "Device": "XULTRAPLUS",
    "Model": "XULTRAPLUS"
  },
  {
    "Retail Branding": "HOLO",
    "Marketing Name": "XULTRAPLUS3",
    "Device": "XULTRAPLUS3",
    "Model": "XULTRAPLUS3"
  },
  {
    "Retail Branding": "HOLO",
    "Marketing Name": "X_Play_Ultra",
    "Device": "X_Play_Ultra",
    "Model": "X_Play_Ultra"
  },
  {
    "Retail Branding": "HOMII",
    "Marketing Name": "HOMII M6",
    "Device": "M6",
    "Model": "M6"
  },
  {
    "Retail Branding": "HOMII",
    "Marketing Name": "XBOOK",
    "Device": "XBOOK",
    "Model": "XBOOK"
  },
  {
    "Retail Branding": "HOMII",
    "Marketing Name": "XBOOK_12",
    "Device": "XBOOK_12",
    "Model": "P33 Pro Max"
  },
  {
    "Retail Branding": "HOMII",
    "Marketing Name": "XBOOK_12",
    "Device": "XBOOK_12",
    "Model": "T11"
  },
  {
    "Retail Branding": "HOMII",
    "Marketing Name": "XBOOK_12",
    "Device": "XBOOK_12",
    "Model": "XBOOK 12"
  },
  {
    "Retail Branding": "HOMII",
    "Marketing Name": "XBOOK_12",
    "Device": "XBOOK_12",
    "Model": "XBOOK_12"
  },
  {
    "Retail Branding": "HOMII",
    "Marketing Name": "XBOOK_8M",
    "Device": "XBOOK_8M",
    "Model": "XBOOK 8M"
  },
  {
    "Retail Branding": "HOMII",
    "Marketing Name": "XBOOK_PRO",
    "Device": "XBOOK_PRO",
    "Model": "XBOOK_PRO"
  },
  {
    "Retail Branding": "HOMII",
    "Marketing Name": "Xbook_Plus",
    "Device": "Xbook_Plus",
    "Model": "Xbook_Plus"
  },
  {
    "Retail Branding": "HOMII",
    "Marketing Name": "Xbookkids",
    "Device": "Xbookkids",
    "Model": "Xbookkids"
  },
  {
    "Retail Branding": "HOMTOM",
    "Marketing Name": "C13",
    "Device": "C13",
    "Model": "C13"
  },
  {
    "Retail Branding": "HOMTOM",
    "Marketing Name": "C2",
    "Device": "C2",
    "Model": "C2"
  },
  {
    "Retail Branding": "HOMTOM",
    "Marketing Name": "C8",
    "Device": "C8",
    "Model": "C8"
  },
  {
    "Retail Branding": "HOMTOM",
    "Marketing Name": "C9",
    "Device": "C9",
    "Model": "C9"
  },
  {
    "Retail Branding": "HOMTOM",
    "Marketing Name": "H1",
    "Device": "H1",
    "Model": "H1"
  },
  {
    "Retail Branding": "HOMTOM",
    "Marketing Name": "H3",
    "Device": "H3",
    "Model": "H3"
  },
  {
    "Retail Branding": "HOMTOM",
    "Marketing Name": "H5",
    "Device": "H5",
    "Model": "H5"
  },
  {
    "Retail Branding": "HOMTOM",
    "Marketing Name": "HT16S",
    "Device": "HT16S",
    "Model": "HT16S"
  },
  {
    "Retail Branding": "HOMTOM",
    "Marketing Name": "HT70",
    "Device": "HT70",
    "Model": "HT70"
  },
  {
    "Retail Branding": "HOMTOM",
    "Marketing Name": "HT80",
    "Device": "HT80",
    "Model": "HT80"
  },
  {
    "Retail Branding": "HOMTOM",
    "Marketing Name": "P30 pro",
    "Device": "P30_Pro",
    "Model": "P30 Pro"
  },
  {
    "Retail Branding": "HOMTOM",
    "Marketing Name": "S16",
    "Device": "S16",
    "Model": "S16"
  },
  {
    "Retail Branding": "HOMTOM",
    "Marketing Name": "S17",
    "Device": "S17",
    "Model": "S17"
  },
  {
    "Retail Branding": "HOMTOM",
    "Marketing Name": "S7",
    "Device": "S7",
    "Model": "S7"
  },
  {
    "Retail Branding": "HOMTOM",
    "Marketing Name": "S8",
    "Device": "S8",
    "Model": "S8"
  },
  {
    "Retail Branding": "HOMTOM",
    "Marketing Name": "S9 Plus",
    "Device": "S9_Plus",
    "Model": "S9_Plus"
  },
  {
    "Retail Branding": "HOMTOM",
    "Marketing Name": "S99",
    "Device": "S99",
    "Model": "S99"
  },
  {
    "Retail Branding": "HOMTOM",
    "Marketing Name": "S99i",
    "Device": "S99i",
    "Model": "S99i"
  },
  {
    "Retail Branding": "HOMTOM",
    "Marketing Name": "Z8",
    "Device": "Z8",
    "Model": "Z8"
  },
  {
    "Retail Branding": "HOMTOM",
    "Marketing Name": "c1",
    "Device": "C1",
    "Model": "C1"
  },
  {
    "Retail Branding": "HONKUAHG",
    "Marketing Name": "EV10",
    "Device": "EV10",
    "Model": "EV10"
  },
  {
    "Retail Branding": "HOPE",
    "Marketing Name": "S25u",
    "Device": "HOPE_S25u",
    "Model": "S25u"
  },
  {
    "Retail Branding": "HORIZON",
    "Marketing Name": "EU",
    "Device": "tamachi",
    "Model": "HORIZON Android TV"
  },
  {
    "Retail Branding": "HORIZON",
    "Marketing Name": "EU",
    "Device": "yeongdeungpo",
    "Model": "HORIZON Android TV"
  },
  {
    "Retail Branding": "HORIZON",
    "Marketing Name": "ID65HZA3B1_C",
    "Device": "Interactive_White_Board",
    "Model": "ID65HZA3B1_C"
  },
  {
    "Retail Branding": "HORIZON",
    "Marketing Name": "ID75HZA3B1_C",
    "Device": "Interactive_White_Board",
    "Model": "ID75HZA3B1_C"
  },
  {
    "Retail Branding": "HORIZON",
    "Marketing Name": "ID86HZA3B1_C",
    "Device": "Interactive_White_Board",
    "Model": "ID86HZA3B1_C"
  },
  {
    "Retail Branding": "HOSHI",
    "Marketing Name": "iPro_BOARD",
    "Device": "rk3588_t",
    "Model": "iPro_BOARD"
  },
  {
    "Retail Branding": "HOT (il)",
    "Marketing Name": "CONNECT_V5",
    "Device": "DIW252_ALT_ME",
    "Model": "HOT Streamer V5"
  },
  {
    "Retail Branding": "HOT (il)",
    "Marketing Name": "HOT ONE",
    "Device": "VSB3918_ALT_ME",
    "Model": "HOT ONE"
  },
  {
    "Retail Branding": "HOT (il)",
    "Marketing Name": "HOT Streamer",
    "Device": "DV8555-KIH",
    "Model": "HOT Streamer"
  },
  {
    "Retail Branding": "HOT (il)",
    "Marketing Name": "StreamerV3",
    "Device": "DIW377_ALT_ME",
    "Model": "HOT Streamer V3"
  },
  {
    "Retail Branding": "HOTWIRE",
    "Marketing Name": "Fision TV Plus",
    "Device": "uiw4054hwc",
    "Model": "Fision TV Plus"
  },
  {
    "Retail Branding": "HP",
    "Marketing Name": 10,
    "Device": "spruce",
    "Model": "HP 10"
  },
  {
    "Retail Branding": "HP",
    "Marketing Name": "10 Plus",
    "Device": "torsa",
    "Model": "HP 10 Plus"
  },
  {
    "Retail Branding": "HP",
    "Marketing Name": "7 G2",
    "Device": "redwood",
    "Model": "HP 7 G2"
  },
  {
    "Retail Branding": "HP",
    "Marketing Name": "7 Plus",
    "Device": "Ilex",
    "Model": "HP 7 Plus"
  },
  {
    "Retail Branding": "HP",
    "Marketing Name": "7 Plus G2",
    "Device": "deschutes",
    "Model": "HP 7 Plus G2"
  },
  {
    "Retail Branding": "HP",
    "Marketing Name": "7 Tablet",
    "Device": "Mesquite",
    "Model": "HP 7"
  },
  {
    "Retail Branding": "HP",
    "Marketing Name": "7 Voice Tab",
    "Device": "klondike",
    "Model": "HP 7 VoiceTab"
  },
  {
    "Retail Branding": "HP",
    "Marketing Name": "7 VoiceTab",
    "Device": "yukon",
    "Model": "HP 7 VoiceTab"
  },
  {
    "Retail Branding": "HP",
    "Marketing Name": 7.1,
    "Device": "Holly",
    "Model": "HP 7.1"
  },
  {
    "Retail Branding": "HP",
    "Marketing Name": 8,
    "Device": "Fir",
    "Model": "HP 8"
  },
  {
    "Retail Branding": "HP",
    "Marketing Name": "8 G2",
    "Device": "maple",
    "Model": "HP 8 G2"
  },
  {
    "Retail Branding": "HP",
    "Marketing Name": "Bonsai 10 HD",
    "Device": "bonsai10",
    "Model": "HP Slate 10 HD"
  },
  {
    "Retail Branding": "HP",
    "Marketing Name": "Chromebook x2",
    "Device": "soraka_cheets",
    "Model": "HP Chromebook x2"
  },
  {
    "Retail Branding": "HP",
    "Marketing Name": "Chromebook x2",
    "Device": "soraka_cheets",
    "Model": "soraka"
  },
  {
    "Retail Branding": "HP",
    "Marketing Name": "Chromebook x360 11 G1 EE",
    "Device": "snappy_cheets",
    "Model": "HP Chromebook x360 11 G1 EE"
  },
  {
    "Retail Branding": "HP",
    "Marketing Name": "Columbia",
    "Device": "sepolia",
    "Model": "HP TV"
  },
  {
    "Retail Branding": "HP",
    "Marketing Name": "HP BRIDGE",
    "Device": "Pioneer",
    "Model": "HP BRIDGE"
  },
  {
    "Retail Branding": "HP",
    "Marketing Name": "HP Chromebook 11 G5 / 11-vxxx",
    "Device": "setzer_cheets",
    "Model": "HP Chromebook 11 G5"
  },
  {
    "Retail Branding": "HP",
    "Marketing Name": "HP Chromebook 11 G5 / 11-vxxx",
    "Device": "setzer_cheets",
    "Model": "HP Chromebook 11 G5 / HP Chromebook 11-vxxx"
  },
  {
    "Retail Branding": "HP",
    "Marketing Name": "HP Chromebook 13 G1",
    "Device": "chell_cheets",
    "Model": "HP Chromebook 13 G1"
  },
  {
    "Retail Branding": "HP",
    "Marketing Name": "HP Engage Go 10 Mobile System",
    "Device": "piper_gw",
    "Model": "HP Engage Go 10 Mobile System"
  },
  {
    "Retail Branding": "HP",
    "Marketing Name": "HP Engage One Essential All-in-One System",
    "Device": "napa_gw",
    "Model": "HP Engage One Essential All-in-One System"
  },
  {
    "Retail Branding": "HP",
    "Marketing Name": "HP Engage One Pro AIO System",
    "Device": "anderson_gw",
    "Model": "HP Engage One Pro AIO System"
  },
  {
    "Retail Branding": "HP",
    "Marketing Name": "HP Engage One Pro AIO System",
    "Device": "anderson_gw_i3",
    "Model": "HP Engage One Pro AIO System"
  },
  {
    "Retail Branding": "HP",
    "Marketing Name": "HP Engage One Pro AIO System",
    "Device": "anderson_gw_i5",
    "Model": "HP Engage One Pro AIO System"
  },
  {
    "Retail Branding": "HP",
    "Marketing Name": "HP GOOGLE TV",
    "Device": "dongnae",
    "Model": "HP GOOGLE TV"
  },
  {
    "Retail Branding": "HP",
    "Marketing Name": "HP SMART TV",
    "Device": "dongnae",
    "Model": "HP SMART TV"
  },
  {
    "Retail Branding": "HP",
    "Marketing Name": "HP TV",
    "Device": "dongnae",
    "Model": "HP TV"
  },
  {
    "Retail Branding": "HP",
    "Marketing Name": "HP_WW_2885",
    "Device": "pangyo",
    "Model": "HP OMEN 32x"
  },
  {
    "Retail Branding": "HP",
    "Marketing Name": "Pro 8 Tablet with Voice",
    "Device": "neetu",
    "Model": "HP Pro 8 Tablet with Voice"
  },
  {
    "Retail Branding": "HP",
    "Marketing Name": "Pro Slate 10 EE G1",
    "Device": "bulldog",
    "Model": "HP Pro Slate 10 EE G1"
  },
  {
    "Retail Branding": "HP",
    "Marketing Name": "Pro Slate 10 EE G1",
    "Device": "hound",
    "Model": "HP Pro Slate 10 EE G1"
  },
  {
    "Retail Branding": "HP",
    "Marketing Name": "Pro Slate 10 EE G1",
    "Device": "poodle",
    "Model": "HP Pro Slate 10 EE G1"
  },
  {
    "Retail Branding": "HP",
    "Marketing Name": "Pro Slate 10 EE G1",
    "Device": "terrier",
    "Model": "HP Pro Slate 10 EE G1"
  },
  {
    "Retail Branding": "HP",
    "Marketing Name": "Pro Slate 12",
    "Device": "dane",
    "Model": "HP Pro Slate 12"
  },
  {
    "Retail Branding": "HP",
    "Marketing Name": "Pro Slate 8",
    "Device": "malamute",
    "Model": "HP Pro Slate 8"
  },
  {
    "Retail Branding": "HP",
    "Marketing Name": "Slate 10 HD",
    "Device": "bonsai10",
    "Model": "HP Slate 10 HD"
  },
  {
    "Retail Branding": "HP",
    "Marketing Name": "Slate 10 Plus",
    "Device": "linkplus",
    "Model": "HP Slate 10 Plus"
  },
  {
    "Retail Branding": "HP",
    "Marketing Name": "Slate 17",
    "Device": "franky",
    "Model": "HP Slate 17"
  },
  {
    "Retail Branding": "HP",
    "Marketing Name": "Slate 21 Pro",
    "Device": "ranger",
    "Model": "Slate 21 Pro"
  },
  {
    "Retail Branding": "HP",
    "Marketing Name": "Slate 6 Voice Tab",
    "Device": "pomegranate",
    "Model": "HP Slate 6 Voice Tab"
  },
  {
    "Retail Branding": "HP",
    "Marketing Name": "Slate 6 Voice Tab II",
    "Device": "avocado",
    "Model": "HP Slate 6 Voice Tab II"
  },
  {
    "Retail Branding": "HP",
    "Marketing Name": "Slate 6 VoiceTab Plus",
    "Device": "mekong",
    "Model": "HP Slate 6 VoiceTab Plus"
  },
  {
    "Retail Branding": "HP",
    "Marketing Name": "Slate 7",
    "Device": "pine",
    "Model": "HP Slate 7"
  },
  {
    "Retail Branding": "HP",
    "Marketing Name": "Slate 7 Beats Special Edition",
    "Device": "fairfax",
    "Model": "HP Slate 7 Beats Special Edition"
  },
  {
    "Retail Branding": "HP",
    "Marketing Name": "Slate 7 Beats Special Edition",
    "Device": "fairfax",
    "Model": "HP Slate7 Beats Special Edition"
  },
  {
    "Retail Branding": "HP",
    "Marketing Name": "Slate 7 Extreme",
    "Device": "olive",
    "Model": "HP Slate7 Extreme"
  },
  {
    "Retail Branding": "HP",
    "Marketing Name": "Slate 7 HD",
    "Device": "bonsai10",
    "Model": "HP Slate 10 HD"
  },
  {
    "Retail Branding": "HP",
    "Marketing Name": "Slate 7 HD",
    "Device": "bonsai7",
    "Model": "HP Slate 7 HD"
  },
  {
    "Retail Branding": "HP",
    "Marketing Name": "Slate 7 Voice Tab",
    "Device": "almond",
    "Model": "HP Slate 7 Voice Tab"
  },
  {
    "Retail Branding": "HP",
    "Marketing Name": "Slate 7 VoiceTab Ultra",
    "Device": "charm",
    "Model": "HP Slate 7 VoiceTab Ultra"
  },
  {
    "Retail Branding": "HP",
    "Marketing Name": "Slate 8 Plus",
    "Device": "vogue",
    "Model": "HP Slate 8 Plus"
  },
  {
    "Retail Branding": "HP",
    "Marketing Name": "Slate 8 Pro",
    "Device": "dogwood",
    "Model": "HP Slate 8 Pro"
  },
  {
    "Retail Branding": "HP",
    "Marketing Name": "Slate21",
    "Device": "phobos",
    "Model": "Slate 21"
  },
  {
    "Retail Branding": "HP",
    "Marketing Name": "Slate7 Plus",
    "Device": "birch",
    "Model": "HP Slate 7 Plus"
  },
  {
    "Retail Branding": "HP",
    "Marketing Name": "Slate8 Pro",
    "Device": "fig",
    "Model": "HP Slate 8 Pro"
  },
  {
    "Retail Branding": "HP",
    "Marketing Name": "SlateBook 10 x2 PC",
    "Device": 3645,
    "Model": "HP SlateBook 10 x2 PC"
  },
  {
    "Retail Branding": "HP",
    "Marketing Name": "SlateBook 14",
    "Device": "200a",
    "Model": "HP SlateBook 14 PC"
  },
  {
    "Retail Branding": "HP",
    "Marketing Name": "South America",
    "Device": "sepolia",
    "Model": "HP GOOGLE TV"
  },
  {
    "Retail Branding": "HP",
    "Marketing Name": "Tablet 10",
    "Device": "balsa",
    "Model": "HP_10_Tablet"
  },
  {
    "Retail Branding": "HP",
    "Marketing Name": "Voice Tab 7",
    "Device": "almond",
    "Model": "HP Slate 7 Voice Tab"
  },
  {
    "Retail Branding": "HQ_bel",
    "Marketing Name": "Tablet_HQ_T616",
    "Device": "Tablet_HQ_T616",
    "Model": "T700"
  },
  {
    "Retail Branding": "HQ_bel",
    "Marketing Name": "Tablet_HQ_T616",
    "Device": "Tablet_HQ_T616",
    "Model": "Tablet_HQ_T616"
  },
  {
    "Retail Branding": "HQ_bel",
    "Marketing Name": "Tablet_HQ_T616",
    "Device": "Tablet_HQ_T616",
    "Model": "l11"
  },
  {
    "Retail Branding": "HQ_bel",
    "Marketing Name": "Tablet_HQ_T616",
    "Device": "Tablet_HQ_T616",
    "Model": "redbeat A2"
  },
  {
    "Retail Branding": "HRSolutions",
    "Marketing Name": "HRS2000",
    "Device": "HRS2000",
    "Model": "HRS2000"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "",
    "Device": "express",
    "Model": "HTC Flyer"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "",
    "Device": "express",
    "Model": "PG41200"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "",
    "Device": "expresskt",
    "Model": "HTC_P515E"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "",
    "Device": "rider",
    "Model": "HTC_X515E"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "",
    "Device": "tagh",
    "Model": "HTC Incredible E S715e"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "0P3P5",
    "Device": "t6ul",
    "Model": "HTC_0P3P5"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "0P4E2",
    "Device": "zara",
    "Model": "HTC_0P4E2"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "0P9C8",
    "Device": "htc_a5dwgl",
    "Model": "HTC 0P9C8"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "0P9C8",
    "Device": "htc_a5dwgl",
    "Model": "HTC Desire 816 dual sim"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "0PFJ50",
    "Device": "htc_a51tuhl",
    "Model": "HTC_0PFJ50"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "0PK72",
    "Device": "htc_hiaur_ml_tuhl",
    "Model": "HTC 0PK72"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "0PK72",
    "Device": "htc_hiaur_ml_tuhl",
    "Model": "HTC One M9PLUS"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": 10,
    "Device": "htc_pmec2tuhl",
    "Model": "HTC 10"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": 10,
    "Device": "htc_pmec2tuhl",
    "Model": "HTC 10 Lifestyle"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": 10,
    "Device": "htc_pmec2tuhl",
    "Model": "HTC 2PS63"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": 10,
    "Device": "htc_pmec2tuhl",
    "Model": "HTC M10u"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": 10,
    "Device": "htc_pmeuhl",
    "Model": "HTC 10"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": 10,
    "Device": "htc_pmeuhl",
    "Model": "HTC 2PS6200"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": 10,
    "Device": "htc_pmeuhl",
    "Model": "HTC M10h"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": 10,
    "Device": "htc_pmeuhl",
    "Model": "HTC_M10h"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": 10,
    "Device": "htc_pmeuhljapan",
    "Model": "HTV32"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": 10,
    "Device": "htc_pmewhl",
    "Model": "2PS64"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": 10,
    "Device": "htc_pmewl",
    "Model": "HTC 10"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": 10,
    "Device": "htc_pmewl",
    "Model": "HTC6545LVW"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": 10,
    "Device": "htc_pmewl",
    "Model": "MSM8996 for arm64"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "10 evo",
    "Device": "htc_acauhl",
    "Model": "HTC 10 evo"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "10 evo",
    "Device": "htc_acauhl",
    "Model": "HTC_M10f"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "10 evo",
    "Device": "htc_acawhl",
    "Model": "HTC 10 evo"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "5060 dual sim",
    "Device": "z4dug",
    "Model": "HTC Desire 500 dual sim"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "601e",
    "Device": "m4",
    "Model": "HTC 601e"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "606w",
    "Device": "cp3dug",
    "Model": "HTC 606w"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "606w",
    "Device": "cp3dug",
    "Model": "HTC Desire 600"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "606w",
    "Device": "cp3dug",
    "Model": "HTC Desire 600 dual sim"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "606w",
    "Device": "cp3dug",
    "Model": "HTC PO49120"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "608t",
    "Device": "cp3dtg",
    "Model": "HTC 608t"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "609d",
    "Device": "cp3dcg",
    "Model": "HTC 609d"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": 6160,
    "Device": "zaradug",
    "Model": "HTC 6160"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "619d",
    "Device": "zarawl",
    "Model": "HTC 619d"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": 7060,
    "Device": "cp5dug",
    "Model": "HTC_7060"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "710C",
    "Device": "htc_a5chl",
    "Model": "710C"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "802d",
    "Device": "m7cdwg",
    "Model": "HTC 802d"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "803e",
    "Device": "t6ul",
    "Model": "HTC 803e"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": 8060,
    "Device": "t6dug",
    "Model": "HTC 8060"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": 8088,
    "Device": "t6tl",
    "Model": "HTC 8088"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "809d",
    "Device": "t6dwg",
    "Model": "HTC 809d"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": 8160,
    "Device": "t6uhl",
    "Model": "HTC 8160"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": 9060,
    "Device": "dlxpul",
    "Model": "HTC 901e"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": 9060,
    "Device": "m7",
    "Model": "HTC 801e"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": 9060,
    "Device": "m7cdug",
    "Model": "HTC 802w"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": 9088,
    "Device": "dlpdtu",
    "Model": "HTC 9088"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "919d",
    "Device": "dlpdwg",
    "Model": "HTC 919d"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "A510c",
    "Device": "marvelc",
    "Model": "HTC_A510c"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "ADR6325",
    "Device": "lexikon",
    "Model": "ADR6325"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "ADR6330VW",
    "Device": "blissc",
    "Model": "ADR6330VW"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "ADR6425LVW",
    "Device": "vigor",
    "Model": "ADR6425LVW"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "AT&T HTC One X+",
    "Device": "evitareul",
    "Model": "HTC EVARE_UL"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "AT&T HTC One X+",
    "Device": "evitareul",
    "Model": "HTC One X+"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Amaze_4G",
    "Device": "ruby",
    "Model": "HTC Amaze 4G"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Amaze_4G",
    "Device": "ruby",
    "Model": "HTC Ruby"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Amaze_4G",
    "Device": "ruby",
    "Model": "HTC_Amaze_4G"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Aria",
    "Device": "liberty",
    "Model": "HTC Aria"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Aria",
    "Device": "liberty",
    "Model": "HTC Aria A6380"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Aria",
    "Device": "liberty",
    "Model": "HTC Gratia A6380"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Aria",
    "Device": "liberty",
    "Model": "HTC Liberty"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Butterfly",
    "Device": "dlxu",
    "Model": "HTC Butterfly"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Butterfly",
    "Device": "dlxu",
    "Model": "HTC DLX_U"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Butterfly",
    "Device": "dlxu",
    "Model": "HTC X920e"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Butterfly",
    "Device": "dlxub1",
    "Model": "HTC Butterfly"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Butterfly",
    "Device": "dlxub1",
    "Model": "HTC DLXUB1"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Butterfly 2",
    "Device": "htc_b2ul",
    "Model": "HTC Butterfly 2"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Butterfly 2",
    "Device": "htc_b2ul",
    "Model": "HTC_B810x"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Butterfly 3",
    "Device": "htc_b3tuhl",
    "Model": "HTC_B830x"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Butterfly S",
    "Device": "dlxpul",
    "Model": "HTC Butterfly s"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Butterfly S",
    "Device": "dlxpul",
    "Model": "HTC_Butterfly_s_901s"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Butterfly s 9060",
    "Device": "dlpdug",
    "Model": "HTC 9060"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Chacha",
    "Device": "chacha",
    "Model": "HTC ChaCha A810b"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Chacha",
    "Device": "chacha",
    "Model": "HTC ChaCha A810e"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Chacha",
    "Device": "chacha",
    "Model": "HTC ChaChaCha A810e"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Chacha",
    "Device": "chacha",
    "Model": "HTC Status"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "D10w",
    "Device": "htc_a56dj_pro_dtwl",
    "Model": "HTC D10w"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "D316d",
    "Device": "htc_v2_c",
    "Model": "HTC D316d"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "D610t",
    "Device": "htc_a3tl",
    "Model": "HTC D610t"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "D616t",
    "Device": "htc_a32ml_dtul",
    "Model": "HTC D626t"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "D626q",
    "Device": "htc_a32ml_dtul",
    "Model": "HTC Desire 626 dual sim"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "D626q",
    "Device": "htc_a32ml_dtul",
    "Model": "HTC_D626q"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "D626t",
    "Device": "htc_a32ml_dtul",
    "Model": "HTC D626t"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "D628u",
    "Device": "htc_v36bml_uhl",
    "Model": "HTC_D628u"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "D728w",
    "Device": "htc_a50cml_dtul",
    "Model": "HTC D728w"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "D728w",
    "Device": "htc_a50cml_dtul",
    "Model": "HTC Desire 728 dual sim"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "D728x",
    "Device": "htc_a50cml_dtul",
    "Model": "HTC_D728x"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "D816d",
    "Device": "htc_a5dwg",
    "Model": "HTC D816d"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "D816d",
    "Device": "htc_a5dwg",
    "Model": "HTC_D816d"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "D816e",
    "Device": "htc_a5dugl",
    "Model": "HTC D816e"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "D816h",
    "Device": "htc_a5mgp_dug",
    "Model": "HTC D816h"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "D816t",
    "Device": "htc_a5tl",
    "Model": "HTC D816t"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "D816v",
    "Device": "htc_a5dwgl",
    "Model": "HTC D816v"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "D816w",
    "Device": "htc_a5dug",
    "Model": "HTC D816w"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "D820 Mini",
    "Device": "htc_a31dtul",
    "Model": "HTC D820mt"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "D820f",
    "Device": "htc_a51tuhl",
    "Model": "HTC_D820f"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "D820t",
    "Device": "htc_a51dtul",
    "Model": "HTC D820t"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "D820u",
    "Device": "htc_a51dtul",
    "Model": "HTC D820u"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "D820u",
    "Device": "htc_a51dtul",
    "Model": "HTC_D820u"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "D820ys",
    "Device": "htc_a50ml",
    "Model": "HTC_D820ts"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "D820ys",
    "Device": "htc_a50ml",
    "Model": "HTC_D820ys"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "D820ys",
    "Device": "htc_a50ml_dtul",
    "Model": "HTC_D820ys"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "D826t",
    "Device": "htc_a52dtul",
    "Model": "HTC D826t"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "DROID DNA",
    "Device": "dlx",
    "Model": "HTC6435LRA"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "DROID Incredible 4G LTE",
    "Device": "fireball",
    "Model": "ADR6410LRA"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "DROID Incredible 4G LTE",
    "Device": "fireball",
    "Model": "ADR6410LVW"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "DROID Incredible 4G LTE",
    "Device": "fireball",
    "Model": "ADR6410OM"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire",
    "Device": "bravo",
    "Model": "HTC Desire"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire",
    "Device": "bravo",
    "Model": "X06HT"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire",
    "Device": "bravoc",
    "Model": "PB99400"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 10 compact",
    "Device": "htc_a37dj_dugl",
    "Model": "HTC 2PZS1"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 10 compact",
    "Device": "htc_a37dj_dugl",
    "Model": "HTC Desire 10 compact"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 10 compact",
    "Device": "htc_a37dj_dugl",
    "Model": "a37dj dugl"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 10 lifestyle",
    "Device": "htc_a56djdugl",
    "Model": "HTC Desire 10 lifestyle"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 10 lifestyle",
    "Device": "htc_a56djuhl",
    "Model": "HTC Desire 10 lifestyle"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 10 lifestyle",
    "Device": "htc_a56djuhl",
    "Model": "HTC_D10u"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 10 lifestyle",
    "Device": "htc_a56djul",
    "Model": "HTC Desire 10 lifestyle"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 10 pro",
    "Device": "htc_a56dj_pro_dtwl",
    "Model": "HTC Desire 10 pro"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 10 pro",
    "Device": "htc_a56dj_pro_dugl",
    "Model": "HTC Desire 10 pro"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 10 pro",
    "Device": "htc_a56dj_pro_dugl",
    "Model": "HTC_D10i"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 10 pro",
    "Device": "htc_a56dj_pro_uhl",
    "Model": "HTC 2PYA3"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 10 pro",
    "Device": "htc_a56dj_pro_uhl",
    "Model": "HTC Desire 10 pro"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 12",
    "Device": "htc_breeze_dugl",
    "Model": "HTC 2Q5V1"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 12",
    "Device": "htc_breeze_dugl",
    "Model": "HTC Desire 12"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 12",
    "Device": "htc_breeze_ul",
    "Model": "HTC 2Q5V200"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 12",
    "Device": "htc_breeze_ul",
    "Model": "HTC Desire 12 (2Q5V200)"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 12+",
    "Device": "htc_brepdugl",
    "Model": "HTC 2Q5W1"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 12+",
    "Device": "htc_brepdugl",
    "Model": "HTC 2Q5W2"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 12+",
    "Device": "htc_brepdugl",
    "Model": "HTC Desire 12+"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 12+",
    "Device": "htc_brepdugl",
    "Model": "HTC ZQ5W10000"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 12+",
    "Device": "htc_brepuhl",
    "Model": "HTC Desire 12+"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 12s",
    "Device": "htc_bre2dugl",
    "Model": "HTC 2Q721"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 12s",
    "Device": "htc_bre2dugl",
    "Model": "HTC Desire 12s"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 12s",
    "Device": "htc_bre2exdugl",
    "Model": "EXODUS 1s"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 12s",
    "Device": "htc_bre2exdugl",
    "Model": "HTC Desire 12s"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 20 Pro",
    "Device": "htc_bymdugl",
    "Model": "2Q9J100"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 20 Pro",
    "Device": "htc_bymdugl",
    "Model": "HTC Desire 20 Pro"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 200",
    "Device": "gtou",
    "Model": "HTC Desire 200"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 200",
    "Device": "gtou",
    "Model": "HTC_Desire_200"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 210 dual sim",
    "Device": "htc_v0_dug",
    "Model": "HTC Desire 210 dual sim"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 300",
    "Device": "g3u",
    "Model": "HTC 301e"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 300",
    "Device": "g3u",
    "Model": "HTC Desire 300"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 300",
    "Device": "g3u",
    "Model": "HTC_0P6A1"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 300",
    "Device": "g3u",
    "Model": "HTC_Desire_300"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 310",
    "Device": "htc_v1_dug",
    "Model": "HTC D310w"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 310",
    "Device": "htc_v1_dug",
    "Model": "HTC Desire 310 dual sim"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 310",
    "Device": "htc_v1_u",
    "Model": "HTC Desire 310"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 310",
    "Device": "htc_v1_u",
    "Model": "HTC_D310n"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 310",
    "Device": "htc_v1_u",
    "Model": "HTC_V1"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 320",
    "Device": "htc_v01_u",
    "Model": "HTC 0PF11"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 320",
    "Device": "htc_v01_u",
    "Model": "HTC 0PF120"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 320",
    "Device": "htc_v01_u",
    "Model": "HTC Desire 320"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 326G dual sim",
    "Device": "htc_v01a_dug",
    "Model": "HTC 2PNT1"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 326G dual sim",
    "Device": "htc_v01a_dug",
    "Model": "HTC Desire 326G dual sim"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 500",
    "Device": "z4u",
    "Model": "HTC Desire 500"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 500",
    "Device": "z4u",
    "Model": "HTC_Desire_500"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 500 dual sim",
    "Device": "z4dug",
    "Model": "HTC 5060"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 500 dual sim",
    "Device": "z4dug",
    "Model": "HTC Desire 500 dual sim"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 501",
    "Device": "htc_csnu",
    "Model": "HTC Desire 501"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 501",
    "Device": "htc_csnu",
    "Model": "HTC_603h"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 501 dual sim",
    "Device": "",
    "Model": ""
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 501 dual sim",
    "Device": "csndug",
    "Model": "HTC Desire 501 dual sim"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 5088",
    "Device": "z4td",
    "Model": "HTC 5088"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 510",
    "Device": "htc_a11chl",
    "Model": "0PCV1"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 510",
    "Device": "htc_a11ul",
    "Model": "HTC 0PCV20"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 510",
    "Device": "htc_a11ul",
    "Model": "HTC Desire 510"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 510",
    "Device": "htc_a11ul",
    "Model": "HTC_0PCV2"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 510",
    "Device": "htc_a11ul8x26",
    "Model": "HTC Desire 510"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 512",
    "Device": "htc_a11aul8x26",
    "Model": "HTC Desire 512"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 516",
    "Device": "htc_v2_dcg",
    "Model": "HTC D516d"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 516",
    "Device": "htc_v2_dtg",
    "Model": "HTC D516t"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 516",
    "Device": "htc_v2_dug",
    "Model": "HTC C2"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 516",
    "Device": "htc_v2_dug",
    "Model": "HTC D516w"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 516",
    "Device": "htc_v2_dug",
    "Model": "HTC V2"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 516 dual sim",
    "Device": "htc_v2_dcg",
    "Model": "HTC Desire 516 dual sim"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 516 dual sim",
    "Device": "htc_v2_dug",
    "Model": "HTC Desire 516 dual sim"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 516 dual sim",
    "Device": "htc_v2_dug",
    "Model": "HTC V2"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 520",
    "Device": "htc_a12ul",
    "Model": "HTC 0PGQ1"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 526",
    "Device": "htc_a13wl",
    "Model": "HTC 0PM31"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 526",
    "Device": "htc_a13wl",
    "Model": "HTC Desire 526"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 526",
    "Device": "htc_a13wl",
    "Model": "HTCD100LVW"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 526",
    "Device": "htc_a13wlpp",
    "Model": "HTCD100LVWPP"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 526G+ dual sim",
    "Device": "htc_v02_dug",
    "Model": "HTC 0PL41"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 526G+ dual sim",
    "Device": "htc_v02_dug",
    "Model": "HTC 0PL4100"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 526G+ dual sim",
    "Device": "htc_v02_dug",
    "Model": "HTC Desire 526G dual sim"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 526G+ dual sim",
    "Device": "htc_v02_dug",
    "Model": "HTC Desire 526GPLUS dual sim"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 526G+ dual sim",
    "Device": "htc_v02_dug",
    "Model": "HTC_D526h"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 526GPLUS",
    "Device": "htc_v02_u",
    "Model": "HTC 0PL41"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 526GPLUS",
    "Device": "htc_v02_u",
    "Model": "HTC Desire 526G"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 530",
    "Device": "htc_a16ul",
    "Model": "HTC 2PST1"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 530",
    "Device": "htc_a16ul",
    "Model": "HTC 2PST2"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 530",
    "Device": "htc_a16ul",
    "Model": "HTC Desire 530"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 530",
    "Device": "htc_a16ul",
    "Model": "HTC_D530u"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 530",
    "Device": "htc_a16wl",
    "Model": "HTC 2PST3"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 530",
    "Device": "htc_a16wl",
    "Model": "HTC Desire 530"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 530",
    "Device": "htc_a16wl",
    "Model": "HTCD160LVW"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 530",
    "Device": "htc_a16wl",
    "Model": "HTCD160LVWPP"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 550/ 555",
    "Device": "htc_a15ul",
    "Model": "HTC Desire 550"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 550/ 555",
    "Device": "htc_a15ul",
    "Model": "HTC Desire 555"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 600",
    "Device": "cp3dug",
    "Model": "HTC Desire 600"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 600 Dual SIM",
    "Device": "cp3dug",
    "Model": "HTC Desire 600 dual sim"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 600c Dual SIM",
    "Device": "cp3dcg",
    "Model": "HTC 609d"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 600c Dual SIM",
    "Device": "cp3dcg",
    "Model": "HTC Desire 600c dual sim"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 601",
    "Device": "",
    "Model": ""
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 601",
    "Device": "zara",
    "Model": "HTC Desire 601"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 601",
    "Device": "zara",
    "Model": "HTC_0P4E2"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 601",
    "Device": "zaracl",
    "Model": "HTC Desire 601"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 601",
    "Device": "zaracl",
    "Model": "HTC0P4E1"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 601 dual sim",
    "Device": "zaradug",
    "Model": "HTC Desire 601 dual sim"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 606w",
    "Device": "cp3dug",
    "Model": "HTC 606w"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 609d",
    "Device": "cp3dcg",
    "Model": "HTC 609d"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 610",
    "Device": "htc_a3qhdul",
    "Model": "HTC Desire 610"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 610",
    "Device": "htc_a3qhdul",
    "Model": "HTC_0P9O2"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 610",
    "Device": "htc_a3qhdul",
    "Model": "HTC_D610x"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 610",
    "Device": "htc_a3ul",
    "Model": "HTC Desire 610"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 612",
    "Device": "htc_a3qhdcl",
    "Model": "HTC 0P9O30"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 612",
    "Device": "htc_a3qhdcl",
    "Model": "HTC Desire 612"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 616 dual sim",
    "Device": "htc_v3_dug",
    "Model": "HTC D616w"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 616 dual sim",
    "Device": "htc_v3_dug",
    "Model": "HTC Desire 616 dual sim"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 616 dual sim",
    "Device": "htc_v3_dug",
    "Model": "HTC V3"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 620",
    "Device": "htc_a31ul",
    "Model": "HTC 0PE64"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 620",
    "Device": "htc_a31ul",
    "Model": "HTC Desire 620"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 620 dual sim",
    "Device": "htc_a31dtul",
    "Model": "HTC_D620u"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 620G dual sim",
    "Device": "htc_a31mg_dug",
    "Model": "HTC 0PE65"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 620G dual sim",
    "Device": "htc_a31mg_dug",
    "Model": "HTC Desire 620G dual sim"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 620G dual sim",
    "Device": "htc_a31mg_dug",
    "Model": "HTC_D620h"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 626",
    "Device": "htc_a32dcgl",
    "Model": "HTC D626d"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 626",
    "Device": "htc_a32ewl",
    "Model": "HTCD200LVW"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 626",
    "Device": "htc_a32ewlpp",
    "Model": "HTCD200LVWPP"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 626",
    "Device": "htc_a32ul",
    "Model": "HTC Desire 626"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 626",
    "Device": "htc_a32ul",
    "Model": "HTC_D626x"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 626",
    "Device": "htc_a32ul",
    "Model": "HTC_D630x"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 626",
    "Device": "htc_a32ul_emea",
    "Model": "HTC Desire 626"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 626",
    "Device": "htc_a32ul_emea",
    "Model": "HTC_0PKX2"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 626 dual sim",
    "Device": "htc_a32ml_dtul",
    "Model": "HTC Desire 626 dual sim"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 626G+ dual sim",
    "Device": "htc_a32mg_dug",
    "Model": "HTC 0PM11"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 626G+ dual sim",
    "Device": "htc_a32mg_dug",
    "Model": "HTC Desire 626G dual sim"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 626G+ dual sim",
    "Device": "htc_a32mg_dug",
    "Model": "HTC Desire 626GPLUS dual sim"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 626G+ dual sim",
    "Device": "htc_a32mg_dug",
    "Model": "HTC_D626ph"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 626s",
    "Device": "htc_a32eul",
    "Model": "HTC Desire 625"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 626s",
    "Device": "htc_a32eul",
    "Model": "HTC Desire 626s"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 626s",
    "Device": "htc_a32eul_la",
    "Model": "HTC Desire 626s"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 626s",
    "Device": "htc_a32ewhl",
    "Model": "0PM92"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 626s",
    "Device": "htc_a32ewhl",
    "Model": "HTC 0PM92"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 626s",
    "Device": "htc_a32ewhl",
    "Model": "HTC Desire 626s"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 628",
    "Device": "htc_v36bml_uhl",
    "Model": "HTC Desire 628"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 628 dual sim",
    "Device": "htc_v36bml_dugl",
    "Model": "HTC Desire 628 dual sim"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 630 dual sim",
    "Device": "htc_a16dwgl",
    "Model": "HTC 2PST5"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 630 dual sim",
    "Device": "htc_a16dwgl",
    "Model": "HTC Desire 630 dual sim"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 650",
    "Device": "htc_a17uhl",
    "Model": "HTC 2PYR1"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 650",
    "Device": "htc_a17uhl",
    "Model": "HTC Desire 650"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 650",
    "Device": "htc_a17uhl",
    "Model": "HTC_D650h"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 650 dual sim",
    "Device": "htc_a37_dugl",
    "Model": "A37 DUGL"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 650 dual sim",
    "Device": "htc_a37_dugl",
    "Model": "HTC Desire 650 dual sim"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 700 dual sim",
    "Device": "",
    "Model": ""
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 700 dual sim",
    "Device": "cp5dug",
    "Model": "HTC Desire 700 dual sim"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 700 dual sim",
    "Device": "cp5dwg",
    "Model": "HTC Desire 700 dual sim"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 700 dual sim",
    "Device": "cp5dwg",
    "Model": "HTC_709d"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 7060",
    "Device": "cp5dug",
    "Model": "HTC_7060"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 7088",
    "Device": "cp5dtu",
    "Model": "HTC 7088"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 709d",
    "Device": "cp5dwg",
    "Model": "HTC 709d"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 728",
    "Device": "htc_a50cml_tuhl",
    "Model": "HTC 2PQ84"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 728",
    "Device": "htc_a50cml_tuhl",
    "Model": "HTC Desire 728"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 728 dual sim",
    "Device": "htc_a50cml_dtul",
    "Model": "HTC Desire 728 dual sim"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 728G dual sim",
    "Device": "htc_a50cmg_dwg",
    "Model": "HTC 2PQ83"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 728G dual sim",
    "Device": "htc_a50cmg_dwg",
    "Model": "HTC Desire 728G dual sim"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 816",
    "Device": "htc_a5chl",
    "Model": "HTC Desire 816"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 816",
    "Device": "htc_a5ul",
    "Model": "HTC Desire 816"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 816",
    "Device": "htc_a5ul",
    "Model": "HTC_0P9C2"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 816",
    "Device": "htc_a5ul",
    "Model": "HTC_D816x"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 816 dual sim",
    "Device": "htc_a5dug",
    "Model": "HTC Desire 816 dual sim"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 816 dual sim",
    "Device": "htc_a5dwg",
    "Model": "HTC Desire 816 dual sim"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 816G dual",
    "Device": "htc_a5mgp_dug",
    "Model": "HTC Desire 816G dual sim"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 816G dual sim",
    "Device": "htc_a5mg_dug",
    "Model": "HTC Desire 816G dual sim"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 816G dual sim",
    "Device": "htc_a5mgp_dug",
    "Model": "HTC D816h"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 816G dual sim",
    "Device": "htc_a5mgp_dug",
    "Model": "HTC Desire 816G dual sim"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 820",
    "Device": "htc_a51ul",
    "Model": "HTC 0PFJ4"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 820",
    "Device": "htc_a51ul",
    "Model": "HTC Desire 820"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 820 dual sim",
    "Device": "htc_a51dtul",
    "Model": "HTC Desire 820 dual sim"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 820G PLUS dual sim",
    "Device": "htc_a50mgp_dug",
    "Model": "HTC Desire 820G PLUS dual sim"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 820G PLUS dual sim",
    "Device": "htc_a50mgp_dug",
    "Model": "HTC Desire 820G dual sim"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 820G PLUS dual sim",
    "Device": "htc_a50mgp_dug",
    "Model": "HTC_D820pi"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 820q dual sim",
    "Device": "htc_a50dtul",
    "Model": "HTC Desire 820q dual sim"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 820s",
    "Device": "htc_a50ml_dtul",
    "Model": "HTC D820ts"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 820s",
    "Device": "htc_a50ml_dtul",
    "Model": "HTC D820us"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 820s",
    "Device": "htc_a50ml_dtul",
    "Model": "HTC Desire 820s dual sim"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 820s dual sim",
    "Device": "htc_a50ml",
    "Model": "HTC Desire 820s dual sim"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 825",
    "Device": "htc_a56uhl",
    "Model": "HTC 2PUK2"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 825",
    "Device": "htc_a56uhl",
    "Model": "HTC Desire 825"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 825",
    "Device": "htc_a56uhl",
    "Model": "HTC_D825u"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 825 dual sim",
    "Device": "htc_a56dugl",
    "Model": "HTC 2PUK1"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 825 dual sim",
    "Device": "htc_a56dugl",
    "Model": "HTC Desire 825 dual sim"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 826",
    "Device": "htc_a52dtul",
    "Model": "HTC D826w"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 826",
    "Device": "htc_a52dwgl",
    "Model": "HTC D826d"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 826",
    "Device": "htc_a52tuhl",
    "Model": "HTC_D826y"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 826 4G 移動公開版(双卡双待)",
    "Device": "htc_a52dtul",
    "Model": "HTC D826t"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 826 dual sim",
    "Device": "htc_a52dtul",
    "Model": "HTC Desire 826 dual sim"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 826 dual sim",
    "Device": "htc_a52dwgl",
    "Model": "HTC Desire 826 dual sim"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 828",
    "Device": "htc_a51bml_dtul",
    "Model": "HTC D828w"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 828",
    "Device": "htc_a51bml_dtul",
    "Model": "HTC_D828x"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 828",
    "Device": "htc_a51bml_tuhl",
    "Model": "HTC 2PRE4"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 828",
    "Device": "htc_a51bml_tuhl",
    "Model": "HTC Desire 828"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 828",
    "Device": "htc_a51bml_tuhl",
    "Model": "HTC_D828g"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 828 dual sim",
    "Device": "htc_a51bml_dtul",
    "Model": "HTC Desire 828 dual sim"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 828 dual sim",
    "Device": "htc_a51bml_dwgl",
    "Model": "HTC 2PRE2"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 828 dual sim",
    "Device": "htc_a51bml_dwgl",
    "Model": "HTC Desire 828 dual sim"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 830",
    "Device": "htc_a51cml_tuhl",
    "Model": "HTC Desire 830"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 830",
    "Device": "htc_a51cml_tuhl",
    "Model": "HTC_D830x"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 830 dual sim",
    "Device": "htc_a51cml_dtul",
    "Model": "HTC 2PVD1"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 830 dual sim",
    "Device": "htc_a51cml_dtul",
    "Model": "HTC D830u"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire 830 dual sim",
    "Device": "htc_a51cml_dtul",
    "Model": "HTC Desire 830 dual sim"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire C",
    "Device": "golfc",
    "Model": "HTC Desire C"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire C",
    "Device": "golfu",
    "Model": "HTC Desire C"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire D626w",
    "Device": "htc_a32ml_dtul",
    "Model": "HTC D626w"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire D820mini",
    "Device": "htc_a31dtul",
    "Model": "HTC D820mt"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire D820mini",
    "Device": "htc_a31dtul",
    "Model": "HTC D820mu"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire D826",
    "Device": "htc_a52dwgl",
    "Model": "HTC D826d"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire EYE",
    "Device": "htc_eyetuhl",
    "Model": "HTC 0PFH2"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire EYE",
    "Device": "htc_eyetuhl",
    "Model": "HTC Desire EYE"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire EYE",
    "Device": "htc_eyetuhl",
    "Model": "HTC_M910x"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire EYE",
    "Device": "htc_eyeul",
    "Model": "HTC 0PFH11"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire EYE",
    "Device": "htc_eyeul",
    "Model": "HTC Desire EYE"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire EYE",
    "Device": "htc_eyeul_att",
    "Model": "HTC Desire Eye"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire HD",
    "Device": "ace",
    "Model": "001HT"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire HD",
    "Device": "ace",
    "Model": "Desire HD"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire HD",
    "Device": "ace",
    "Model": "HTC Desire HD A9191"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire HD",
    "Device": "ace",
    "Model": "Inspire HD"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire L by HTC",
    "Device": "cp2u",
    "Model": "Desire L by HTC"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire L dual sim",
    "Device": "cp2dug",
    "Model": "HTC Desire L dual sim"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire P",
    "Device": "magniu",
    "Model": "HTC Desire P"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire S",
    "Device": "saga",
    "Model": "HTC Desire S"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire SV",
    "Device": "magnids",
    "Model": "HTC Desire SV"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire V",
    "Device": "primods",
    "Model": "HTC Desire Q"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire V",
    "Device": "primods",
    "Model": "HTC Desire U"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire V",
    "Device": "primods",
    "Model": "HTC Desire U dual sim"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire V",
    "Device": "primods",
    "Model": "HTC Desire V"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire V",
    "Device": "primods",
    "Model": "HTC PROMIN_U"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire V",
    "Device": "primods",
    "Model": "HTC PRO_DS"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire V",
    "Device": "primods",
    "Model": "HTC T327w"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire V",
    "Device": "primods",
    "Model": "HTC T328w"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire VC",
    "Device": "primodd",
    "Model": "HTC Desire VC"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire VC",
    "Device": "primodd",
    "Model": "HTC Desire VC T328d"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire VC",
    "Device": "primodd",
    "Model": "HTC PRO_DD"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire VC",
    "Device": "primodd",
    "Model": "HTC T328d"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire X",
    "Device": "protou",
    "Model": "HTC Desire X"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire X",
    "Device": "protou",
    "Model": "HTC POO_U"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire X dual sim",
    "Device": "protodug",
    "Model": "HTC Desire X dual sim"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire XC dual sim",
    "Device": "protodcg",
    "Model": "HTC Desire XC dual sim"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire320",
    "Device": "htc_v01_u",
    "Model": "HTC_Desire_320"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire626",
    "Device": "htc_a32ul_emea",
    "Model": "HTC 0PKX2"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire626",
    "Device": "htc_a32ul_emea",
    "Model": "HTC Desire 626"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire626s",
    "Device": "htc_a32eulatt",
    "Model": "HTC 0PM912"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire626s",
    "Device": "htc_a32eulatt",
    "Model": "HTC Desire 626"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desire815G",
    "Device": "htc_a5mgp_u",
    "Model": "HTC Desire 816G"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desrie D530",
    "Device": "htc_a16ul",
    "Model": "HTC 2PST1"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Desrie D530",
    "Device": "htc_a16ul",
    "Model": "HTC Desire 530"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Droid DNA",
    "Device": "dlx",
    "Model": "HTC6435LRA"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Droid DNA",
    "Device": "dlx",
    "Model": "HTC6435LVW"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Droid Eris",
    "Device": "desirec",
    "Model": "Eris"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Droid Eris",
    "Device": "desirec",
    "Model": "Pulse"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Droid Incredible",
    "Device": "inc",
    "Model": "ADR6300"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "E9pt",
    "Device": "htc_a55ml_dtul",
    "Model": "HTC E9pt"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "E9pw",
    "Device": "htc_a55ml_dtul",
    "Model": "HTC E9pw"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "E9pw",
    "Device": "htc_a55ml_dtul",
    "Model": "HTC_E9pw"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "E9t",
    "Device": "htc_a53ml_dtul",
    "Model": "HTC E9t"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "E9w",
    "Device": "htc_a53ml_dtul",
    "Model": "HTC E9w"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "E9x",
    "Device": "htc_a53ml_dtul",
    "Model": "HTC_E9x"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "EVO 3D",
    "Device": "shooter",
    "Model": "HTCEVOV4G"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "EVO 3D",
    "Device": "shooter",
    "Model": "PG86100"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "EVO 3D ISW12HT",
    "Device": "shooterk",
    "Model": "ISW12HT"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "EVO 3D X515m",
    "Device": "shooteru",
    "Model": "HTC EVO 3D X515a"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "EVO 3D X515m",
    "Device": "shooteru",
    "Model": "HTC EVO 3D X515m"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "EVO 3D X515m",
    "Device": "shooteru",
    "Model": "HTC Inspire 3D"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "EVO 4G LTE",
    "Device": "jewel",
    "Model": "EVO"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "EVO LTE 4G",
    "Device": "jewel",
    "Model": "EVO"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "EVO Shift 4G",
    "Device": "speedy",
    "Model": "PG06100"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "EXODUS 1",
    "Device": "htc_exodugl",
    "Model": "EXODUS 1"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "EXODUS 1",
    "Device": "htc_exouhl",
    "Model": "EXODUS 1"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Evo 4G",
    "Device": "supersonic",
    "Model": "PC36100"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Explorer A310e",
    "Device": "pico",
    "Model": "HTC Explorer"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Explorer A310e",
    "Device": "pico",
    "Model": "HTC Explorer A310b"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Explorer A310e",
    "Device": "pico",
    "Model": "HTC Explorer A310e"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Flyer",
    "Device": "flyer",
    "Model": "HTC Flyer"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Flyer",
    "Device": "flyer",
    "Model": "HTC Flyer P510e"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Flyer",
    "Device": "flyer",
    "Model": "HTC Flyer P511e"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Flyer",
    "Device": "flyer",
    "Model": "HTC Flyer P512"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Flyer",
    "Device": "flyer",
    "Model": "HTC_Flyer_P512_NA"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "G1",
    "Device": "dream",
    "Model": "HTC Dream"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "G2",
    "Device": "vision",
    "Model": "HTC Vision"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "G2",
    "Device": "vision",
    "Model": "T-Mobile G2"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "HTC 10 evo",
    "Device": "htc_acawhl",
    "Model": "HTC 10 evo"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "HTC 5G HUB",
    "Device": "htc_rtx",
    "Model": "HTC 5G Hub"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "HTC 5G Hub",
    "Device": "htc_rtx",
    "Model": "HTC 5G Hub"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "HTC 5G Hub",
    "Device": "htc_rtxcmcc",
    "Model": "HTC 5G Hub"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "HTC 5G Hub",
    "Device": "htc_rtxspcs",
    "Model": "HTC 5G Hub"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "HTC A100",
    "Device": "HTC_A100",
    "Model": "HTC A100"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "HTC A101",
    "Device": "HTC_A101",
    "Model": "HTC A101"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "HTC A101 Plus",
    "Device": "HTC_A101_Plus",
    "Model": "HTC A101 Plus"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "HTC A102",
    "Device": "HTC_A102",
    "Model": "HTC A102"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "HTC A103",
    "Device": "HTC_A103",
    "Model": "HTC A103"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "HTC A103 Plus",
    "Device": "HTC_A103_Plus",
    "Model": "HTC A103 Plus"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "HTC A104",
    "Device": "HTC_A104",
    "Model": "HTC A104"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "HTC A105 Plus",
    "Device": "HTC_A105_Plus",
    "Model": "HTC A105 Plus"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "HTC AT01",
    "Device": "HTC_AT01",
    "Model": "HTC AT01"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "HTC AT01 Plus",
    "Device": "HTC_AT01_Plus",
    "Model": "HTC AT01 Plus"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "HTC AT02 Plus",
    "Device": "HTC_AT02_Plus",
    "Model": "HTC AT02 Plus"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "HTC Desire 19s",
    "Device": "htc_zddugl",
    "Model": "2Q8L10000"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "HTC Desire 19s",
    "Device": "htc_zddugl",
    "Model": "HTC Desire 19s"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "HTC Desire 20 Pro",
    "Device": "htc_bymdugl",
    "Model": "HTC 2Q9J10000"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "HTC Desire 20 Pro",
    "Device": "htc_bymdugl",
    "Model": "HTC Desire 20 Pro"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "HTC Desire 20+",
    "Device": "htc_srcdugl",
    "Model": "2Q9U100"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "HTC Desire 20+",
    "Device": "htc_srcdugl",
    "Model": "HTC Desire 20+"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "HTC Desire 21 Pro 5G",
    "Device": "htc_thudugl",
    "Model": "2QAG100"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "HTC Desire 21 Pro 5G",
    "Device": "htc_thudugl",
    "Model": "HTC Desire 21 pro 5G"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "HTC Desire 21 pro 5G",
    "Device": "htc_thudugl",
    "Model": "2QAG100"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "HTC Desire 21 pro 5G",
    "Device": "htc_thudugl",
    "Model": "HTC Desire 21 pro 5G"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "HTC Desire 22 5G",
    "Device": "htc_botdugls",
    "Model": "2QBK100"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "HTC Desire 22 5G",
    "Device": "htc_botdugls",
    "Model": "2QBK10000"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "HTC Desire 22 5G",
    "Device": "htc_botdugls",
    "Model": "HTC Desire 22 pro"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "HTC Desire 610",
    "Device": "htc_a3ul",
    "Model": "HTC Desire 610"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "HTC Desire 628 dual sim",
    "Device": "htc_v36bml_dugl",
    "Model": "HTC 2PVG2"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "HTC Desire 628 dual sim",
    "Device": "htc_v36bml_dugl",
    "Model": "HTC Desire 628 dual sim"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "HTC Desire19+",
    "Device": "htc_bre2pdugl",
    "Model": "2Q74100"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "HTC Desire19+",
    "Device": "htc_bre2pdugl",
    "Model": "HTC Desire 19+"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "HTC One",
    "Device": "m7wls",
    "Model": "HTC One"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "HTC One X9 dual sim",
    "Device": "htc_e56ml_dtul",
    "Model": "HTC One X9 dual sim"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "HTC One mini",
    "Device": "m4",
    "Model": "HTC One mini"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "HTC U11",
    "Device": "htc_ocnuhl",
    "Model": "HTC 2PZC100"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "HTC U11 Camera+",
    "Device": "htc_haydtwla",
    "Model": "HTC 2Q4R400"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "HTC U11 EYEs",
    "Device": "htc_haydtwl",
    "Model": "HTC 2Q4R300"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "HTC U11 EYEs",
    "Device": "htc_haydtwl",
    "Model": "HTC 2Q4R400"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "HTC U11 EYEs",
    "Device": "htc_haydugl",
    "Model": "HTC 2Q4R1"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "HTC U11 EYEs",
    "Device": "htc_haydugl",
    "Model": "HTC 2Q4R100"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "HTC U11 EYEs",
    "Device": "htc_haydugl",
    "Model": "HTC U11 EYEs"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "HTC U11 life",
    "Device": "htc_ocla1_sprout",
    "Model": "HTC U11 life"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "HTC U11 life",
    "Device": "htc_oclul",
    "Model": "HTC U11 Life"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "HTC U11 life",
    "Device": "htc_oclul",
    "Model": "HTC U11 life"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "HTC U11+",
    "Device": "htc_ocmdtwl",
    "Model": "HTC 2Q4D200"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "HTC U11+",
    "Device": "htc_ocmdugl",
    "Model": "HTC U11 plus"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "HTC U11+",
    "Device": "htc_ocmdugl",
    "Model": "HTC_2Q4D100"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "HTC U19e",
    "Device": "htc_tetdugl",
    "Model": "HTC 2Q7A100"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "HTC U23",
    "Device": "htc_twrdugls",
    "Model": "HTC U23"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "HTC U23 pro",
    "Device": "htc_soodugls",
    "Model": "2QC9100"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "HTC U23 pro",
    "Device": "htc_soodugls",
    "Model": "HTC U23 pro"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "HTC Wildfire X",
    "Device": "htc_h11dugl",
    "Model": "HTC Wildfire X"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "HTC6435LVW",
    "Device": "dlx",
    "Model": "HTC6435LVW"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "HTC909d",
    "Device": "dlpdwg",
    "Model": "HTC 919d"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "HTCDesire612VZW",
    "Device": "htc_a3qhdcl",
    "Model": "HTC331ZLVW"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "HTCDesire612VZW",
    "Device": "htc_a3qhdcl",
    "Model": "HTC331ZLVWPP"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "HTCEVODesign4G",
    "Device": "kingdom",
    "Model": "HTC Acquire"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "HTCEVODesign4G",
    "Device": "kingdom",
    "Model": "HTC EVO Design C715e"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "HTCEVODesign4G",
    "Device": "kingdom",
    "Model": "HTC Hero S"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "HTCEVODesign4G",
    "Device": "kingdom",
    "Model": "HTC Kingdom"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "HTCEVODesign4G",
    "Device": "kingdom",
    "Model": "HTCEVODesign4G"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "HTCEVODesign4G",
    "Device": "kingdom",
    "Model": "PH44100"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "HTCOneMaxVZW",
    "Device": "t6wl",
    "Model": "HTC6600LVW"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "HTL23",
    "Device": "htc_b2wlj",
    "Model": "HTL23"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "HTV31",
    "Device": "htc_b3uhl",
    "Model": "HTV31"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Hero",
    "Device": "hero",
    "Model": "ERA G2 Touch"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Hero",
    "Device": "hero",
    "Model": "HTC Hero"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Hero",
    "Device": "hero",
    "Model": "T-Mobile G2 Touch"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Hero",
    "Device": "hero",
    "Model": "T-Mobile_G2_Touch"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Hero",
    "Device": "hero",
    "Model": "dopod A6288"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Hero",
    "Device": "heroc",
    "Model": "HERO200"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "ISW13HT",
    "Device": "valentewx",
    "Model": "ISW13HT"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Incredible 2",
    "Device": "vivow",
    "Model": "ADR6350"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Incredible 2",
    "Device": "vivow",
    "Model": "HTC IncredibleS S710d"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Incredible S",
    "Device": "vivo",
    "Model": "HTC Incredible S"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Incredible S",
    "Device": "vivo",
    "Model": "HTC_S710E"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "J Butterfly",
    "Device": "dlxj",
    "Model": "HTL21"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "J One",
    "Device": "m7wlj",
    "Model": "HTL22"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "J Z321e",
    "Device": "valentewxc9",
    "Model": "HTC J Z321e"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "KDDI Infobar A02",
    "Device": "imnj",
    "Model": "HTX21"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Legend",
    "Device": "legend",
    "Model": "HTC Legend"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "M10",
    "Device": "htc_pmeuhl",
    "Model": "HTC 10"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "M8si",
    "Device": "htc_m8qltuhl",
    "Model": "HTC M8si"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "M8t",
    "Device": "htc_m8tl",
    "Model": "HTC M8t"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "M9",
    "Device": "htc_himaulatt",
    "Model": "HTC One M9"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "M9e",
    "Device": "htc_himaruhl",
    "Model": "HTC M9e"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "M9e",
    "Device": "htc_himaruhl",
    "Model": "HTC One M9_Prime Camera Edition"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "M9e",
    "Device": "htc_himaruhl",
    "Model": "HTC One M9s"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "M9e",
    "Device": "htc_himaruhl",
    "Model": "HTC_M9e"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "M9et",
    "Device": "htc_hima_ace_ml_dtul",
    "Model": "HTC M9et"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "M9ew",
    "Device": "htc_hima_ace_ml_dtul",
    "Model": "HTC M9ew"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "M9ew",
    "Device": "htc_hima_ace_ml_dtul",
    "Model": "HTC_M9ew"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "M9pw",
    "Device": "htc_hiau_ml_tuhl",
    "Model": "HTC M9pw"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "M9pw",
    "Device": "htc_hiaur_ml_tuhl",
    "Model": "HTC M9pw"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "M9px",
    "Device": "htc_hiaur_ml_tuhl",
    "Model": "HTC_M9px"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "M9w",
    "Device": "htc_himauhl",
    "Model": "HTC M9w"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Nexus 9",
    "Device": "flounder",
    "Model": "Nexus 9"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Nexus 9 LTE",
    "Device": "flounder_lte",
    "Model": "Nexus 9"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Nexus One",
    "Device": "passion",
    "Model": "Nexus One"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "ONE",
    "Device": "m7cdug",
    "Model": "HTC One dual sim"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "ONE M8s",
    "Device": "htc_m8qlul",
    "Model": "HTC One M8s"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "ONE M8s",
    "Device": "htc_m8qlul",
    "Model": "HTC_0PKV1"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "ONE S",
    "Device": "ville",
    "Model": "HTC One S"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "ONE SV",
    "Device": "k2u",
    "Model": "HTC K2_U"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "ONE SV",
    "Device": "k2u",
    "Model": "HTC One SV"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "ONE SV",
    "Device": "k2ul",
    "Model": "HTC One SV"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "One",
    "Device": "m7",
    "Model": "HTC 801e"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "One",
    "Device": "m7",
    "Model": "HTC One"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "One",
    "Device": "m7",
    "Model": "HTC One 801e"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "One",
    "Device": "m7",
    "Model": "HTC_PN071"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "One",
    "Device": "m7cdtu",
    "Model": "HTC 802t"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "One",
    "Device": "m7cdtu",
    "Model": "HTC 802t 16GB"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "One",
    "Device": "m7cdug",
    "Model": "HTC 802w"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "One",
    "Device": "m7cdug",
    "Model": "HTC One dual sim"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "One",
    "Device": "m7cdwg",
    "Model": "HTC 802d"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "One",
    "Device": "m7cdwg",
    "Model": "HTC One dual 802d"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "One",
    "Device": "m7cdwg",
    "Model": "HTC One dual sim"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "One",
    "Device": "m7wls",
    "Model": "HTC One"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "One",
    "Device": "m7wls",
    "Model": "HTCONE"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "One",
    "Device": "m7wlv",
    "Model": "HTC One"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "One",
    "Device": "m7wlv",
    "Model": "HTC6500LVW"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "One (E8)",
    "Device": "htc_mecdwg",
    "Model": "HTC M8Sd"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "One (E8)",
    "Device": "htc_mectl",
    "Model": "HTC M8St"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "One (E8)",
    "Device": "htc_mectl",
    "Model": "HTC One_E8"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "One (E8)",
    "Device": "htc_mecul",
    "Model": "HTC One_E8"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "One (E8)",
    "Device": "htc_mecul",
    "Model": "HTC_M8Sx"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "One (E8)",
    "Device": "htc_mecwhl",
    "Model": "0PAJ5"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "One (E8) dual sim",
    "Device": "htc_mecdug",
    "Model": "HTC One_E8 dual sim"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "One (E8) dual sim",
    "Device": "htc_mecdug",
    "Model": "HTC_M8Sy"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "One (E8) dual sim",
    "Device": "htc_mecdwg",
    "Model": "HTC 0PAJ4"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "One (E8) dual sim",
    "Device": "htc_mecdwg",
    "Model": "HTC M8Sd"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "One (E8) dual sim",
    "Device": "htc_mecdwg",
    "Model": "HTC One_E8 dual sim"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "One (E8) 时尚版",
    "Device": "htc_mectl",
    "Model": "HTC M8St"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "One (E8) 时尚版   4G LTE双卡双待联通版",
    "Device": "htc_mecdug",
    "Model": "HTC M8Sw"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "One (E8) 時尚版4G LTE 移动版",
    "Device": "htc_mectl",
    "Model": "HTC M8Ss"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "One (M8 EYE)",
    "Device": "htc_melsuhl",
    "Model": "HTC 0P6B900"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "One (M8 EYE)",
    "Device": "htc_melsuhl",
    "Model": "HTC One_M8 Eye"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "One (M8 Eye)",
    "Device": "htc_melsuhl",
    "Model": "HTC 0P6B9"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "One (M8 Eye)",
    "Device": "htc_melsuhl",
    "Model": "HTC One_M8 Eye"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "One (M8)",
    "Device": "htc_m8",
    "Model": "HTC M8w"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "One (M8)",
    "Device": "htc_m8",
    "Model": "HTC One_M8"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "One (M8)",
    "Device": "htc_m8",
    "Model": "HTC_0P6B"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "One (M8)",
    "Device": "htc_m8",
    "Model": "HTC_0P6B6"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "One (M8)",
    "Device": "htc_m8",
    "Model": "HTC_M8x"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "One (M8)",
    "Device": "htc_m8dug",
    "Model": "HTC One_M8 dual sim"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "One (M8)",
    "Device": "htc_m8dwg",
    "Model": "HTC M8d"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "One (M8)",
    "Device": "htc_m8whl",
    "Model": "831C"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "One (M8)",
    "Device": "htc_m8wl",
    "Model": "HTC One_M8"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "One (M8)",
    "Device": "htc_m8wl",
    "Model": "HTC6525LVW"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "One (M8) (4G LTE 双卡双待 联通版)",
    "Device": "htc_m8dug",
    "Model": "HTC M8e"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "One 801e",
    "Device": "m7",
    "Model": "HTC One 801e"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "One 801e",
    "Device": "m7",
    "Model": "HTC One 801s"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "One A9",
    "Device": "htc_hiaetuhl",
    "Model": "HTC A9w"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "One A9",
    "Device": "htc_hiaeuhl",
    "Model": "HTC One A9"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "One A9",
    "Device": "htc_hiaeuhl",
    "Model": "HTC_A9u"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "One A9",
    "Device": "htc_hiaeul",
    "Model": "HTC One A9"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "One A9",
    "Device": "htc_hiaewhl",
    "Model": "2PQ93"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "One A9s",
    "Device": "htc_e36_ml_uhl",
    "Model": "HTC 2PWD1"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "One A9s",
    "Device": "htc_e36_ml_uhl",
    "Model": "HTC One A9s"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "One A9s",
    "Device": "htc_e36_ml_uhl",
    "Model": "HTC_A9sx"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "One A9s",
    "Device": "htc_e36_ml_ul",
    "Model": "HTC 2PWD2"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "One A9s",
    "Device": "htc_e36_ml_ul",
    "Model": "HTC One A9s"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "One Dual 802d",
    "Device": "m7cdwg",
    "Model": "HTC One dual 802d"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "One Dual Sim",
    "Device": "m7cdwg",
    "Model": "HTC One dual sim"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "One E8 dual",
    "Device": "htc_mecdwg",
    "Model": "HTC_M8Sd"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "One E9 dual sim",
    "Device": "htc_a53ml_dtul",
    "Model": "HTC 0PL31"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "One E9 dual sim",
    "Device": "htc_a53ml_dtul",
    "Model": "HTC One E9 dual sim"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "One E9PLUS dual sim",
    "Device": "htc_a55ml_dtul",
    "Model": "HTC One E9PLUS dual sim"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "One E9s dual sim",
    "Device": "htc_a50aml",
    "Model": "HTC D826sw"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "One E9s dual sim",
    "Device": "htc_a50aml",
    "Model": "HTC One E9s dual sim"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "One E9s dual sim",
    "Device": "htc_a50aml",
    "Model": "HTC_E9sx"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "One Google Play edition",
    "Device": "m7",
    "Model": "HTC One"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "One M8 eye 4G LTE",
    "Device": "htc_melstuhl",
    "Model": "HTC M8Et"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "One M8 eye 4G LTE",
    "Device": "htc_melsuhl",
    "Model": "HTC M8Ew"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "One M9",
    "Device": "htc_himauhl",
    "Model": "0PJA10"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "One M9",
    "Device": "htc_himauhl",
    "Model": "HTC 0PJA10"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "One M9",
    "Device": "htc_himauhl",
    "Model": "HTC One M9"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "One M9",
    "Device": "htc_himauhl",
    "Model": "HTC_0PJA10"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "One M9",
    "Device": "htc_himauhl",
    "Model": "HTC_M9u"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "One M9",
    "Device": "htc_himaul",
    "Model": "HTC One M9"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "One M9",
    "Device": "htc_himaulatt",
    "Model": "HTC One M9"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "One M9",
    "Device": "htc_himawhl",
    "Model": "0PJA2"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "One M9",
    "Device": "htc_himawhl",
    "Model": "HTC One M9"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "One M9",
    "Device": "htc_himawl",
    "Model": "HTC6535LRA"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "One M9",
    "Device": "htc_himawl",
    "Model": "HTC6535LVW"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "One M9+",
    "Device": "htc_hiau_ml_tuhl",
    "Model": "HTC 0PK71"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "One M9+",
    "Device": "htc_hiau_ml_tuhl",
    "Model": "HTC M9pt"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "One M9+",
    "Device": "htc_hiau_ml_tuhl",
    "Model": "HTC One M9PLUS"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "One M9+",
    "Device": "htc_hiau_ml_tuhl",
    "Model": "HTC_M9pw"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "One M9+ (Prime Camera Edition)",
    "Device": "htc_hiaur2_ml_tuhl",
    "Model": "HTC 0PK71"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "One M9+ (Prime Camera Edition)",
    "Device": "htc_hiaur2_ml_tuhl",
    "Model": "HTC One M9PLUS_Prime Camera Edition"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "One M9PLUS",
    "Device": "htc_hiau_ml_tuhl",
    "Model": "HTC One M9PLUS"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "One ME dual sim",
    "Device": "htc_hima_ace_ml_dtul",
    "Model": "HTC 0PLA1"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "One ME dual sim",
    "Device": "htc_hima_ace_ml_dtul",
    "Model": "HTC One ME dual sim"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "One S",
    "Device": "ville",
    "Model": "HTC One S"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "One S",
    "Device": "ville",
    "Model": "HTC VLE_U"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "One S",
    "Device": "villec2",
    "Model": "HTC One S"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "One S",
    "Device": "villec2",
    "Model": "HTC Z560e"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "One S Special Edition",
    "Device": "villeplus",
    "Model": "HTC One S Special Edition"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "One S9",
    "Device": "htc_himar2uhl",
    "Model": "HTC 2PRG100"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "One S9",
    "Device": "htc_himar2uhl",
    "Model": "HTC One S9"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "One S9",
    "Device": "htc_himar2uhl",
    "Model": "HTC_S9u"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "One SC",
    "Device": "cp2dcg",
    "Model": "HTC One SC"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "One SC",
    "Device": "cp2dcg",
    "Model": "HTC One SC T528d"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "One SV",
    "Device": "k2cl",
    "Model": "C525c"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "One SV",
    "Device": "k2plccl",
    "Model": "HTC One SV"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "One SV",
    "Device": "k2ul",
    "Model": "HTC K2_UL"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "One SV",
    "Device": "k2ul",
    "Model": "HTC One SV"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "One SV BLK",
    "Device": "k2plccl",
    "Model": "HTC One SV"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "One SV BLK",
    "Device": "k2plccl",
    "Model": "HTC One SV BLK"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "One V",
    "Device": "primoc",
    "Model": "HTC One V"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "One V",
    "Device": "primou",
    "Model": "HTC ONE V"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "One V",
    "Device": "primou",
    "Model": "HTC One V"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "One VX",
    "Device": "totemc2",
    "Model": "HTC One VX"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "One X",
    "Device": "endeavoru",
    "Model": "HTC One X"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "One X",
    "Device": "endeavoru",
    "Model": "HTC S720e"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "One X",
    "Device": "evita",
    "Model": "HTC One X"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "One X+",
    "Device": "enrc2b",
    "Model": "HTC One X+"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "One X+",
    "Device": "evitareul",
    "Model": "HTC One X+"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "One X10",
    "Device": "htc_e66_dtwl",
    "Model": "HTC 2PXH1"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "One X10",
    "Device": "htc_e66_dtwl",
    "Model": "HTC One X10"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "One X10",
    "Device": "htc_e66_dugl",
    "Model": "HTC 2PXH2"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "One X10",
    "Device": "htc_e66_dugl",
    "Model": "HTC One X10"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "One X10",
    "Device": "htc_e66_dugl",
    "Model": "HTC_X10u"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "One X10",
    "Device": "htc_e66_uhl",
    "Model": "HTC 2PXH3"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "One X9",
    "Device": "htc_e56ml_tuhl",
    "Model": "HTC 2PS5200"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "One X9 dual sim",
    "Device": "htc_e56ml_dtul",
    "Model": "HTC One X9 dual sim"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "One X9 dual sim",
    "Device": "htc_e56ml_dtul",
    "Model": "HTC X9u"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "One X9 dual sim",
    "Device": "htc_e56ml_dtul",
    "Model": "HTC_X9u"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "One XL",
    "Device": "evita",
    "Model": "HTC One X"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "One XL",
    "Device": "evita",
    "Model": "HTC One XL"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "One XL",
    "Device": "evita",
    "Model": "HTC_One_XL"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "One XL",
    "Device": "evitautl",
    "Model": "HTC EVA_UTL"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "One max",
    "Device": "t6ul",
    "Model": "HTC One max"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "One max",
    "Device": "t6ul",
    "Model": "HTC_One_max"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "One max",
    "Device": "t6whl",
    "Model": "HTC0P3P7"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "One mini",
    "Device": "htc_m4",
    "Model": "HTC One mini"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "One mini",
    "Device": "m4",
    "Model": "HTC One mini"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "One mini",
    "Device": "m4",
    "Model": "HTC_One_mini_601e"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "One mini",
    "Device": "m4",
    "Model": "HTC_PO582"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "One mini 2",
    "Device": "htc_memul",
    "Model": "HTC One mini 2"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "One mini 2",
    "Device": "htc_memul",
    "Model": "HTC_M8MINx"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "One mini 2",
    "Device": "htc_memul",
    "Model": "HTC_One_mini_2"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "One mini 601E",
    "Device": "m4",
    "Model": "HTC_One_mini_601e"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "One remix",
    "Device": "htc_memwl",
    "Model": "HTC6515LVW"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "One_E8",
    "Device": "htc_mecul_emea",
    "Model": "HTC One_E8"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Onex X",
    "Device": "endeavoru",
    "Model": "HTC One X"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "PO091",
    "Device": "csndug",
    "Model": "HTC PO091"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Puccini",
    "Device": "puccinilte",
    "Model": "HTC PG09410"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Puccini",
    "Device": "puccinilte",
    "Model": "HTC-P715a"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Rhyme S510b",
    "Device": "bliss",
    "Model": "HTC Rhyme S510b"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "S720e",
    "Device": "endeavoru",
    "Model": "HTC S720e"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Salsa C510e",
    "Device": "icong",
    "Model": "HTC Salsa C510b"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Salsa C510e",
    "Device": "icong",
    "Model": "HTC Salsa C510e"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Sensation 4G",
    "Device": "pyramid",
    "Model": "HTC Sensation"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Sensation 4G",
    "Device": "pyramid",
    "Model": "HTC Sensation 4G"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Sensation 4G",
    "Device": "pyramid",
    "Model": "HTC Sensation XE with Beats Audio"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Sensation 4G",
    "Device": "pyramid",
    "Model": "HTC Sensation XE with Beats Audio Z715a"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Sensation 4G",
    "Device": "pyramid",
    "Model": "HTC Sensation XE with Beats Audio Z715e"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Sensation 4G",
    "Device": "pyramid",
    "Model": "HTC Sensation Z710a"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Sensation 4G",
    "Device": "pyramid",
    "Model": "HTC Sensation Z710e"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Sensation 4G",
    "Device": "pyramid",
    "Model": "HTC-Z710a"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Sensation XL with Beats Audio X315e",
    "Device": "runnymede",
    "Model": "HTC Sensation XL with Beats Audio X315b"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Sensation XL with Beats Audio X315e",
    "Device": "runnymede",
    "Model": "HTC Sensation XL with Beats Audio X315e"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Sensation XL with Beats Audio X315e",
    "Device": "runnymede",
    "Model": "HTC-X315E"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Sensation XL with Beats Audio X315e",
    "Device": "runnymede",
    "Model": "Sensation XL with Beats Audio"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "T329d",
    "Device": "protodcg",
    "Model": "HTC T329d"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "T528w",
    "Device": "cp2dug",
    "Model": "HTC Desire L dual sim"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Telstra Signature™ Premium",
    "Device": "htc_hiaeuhl",
    "Model": "HTC 2PQ910"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Thunderbolt",
    "Device": "mecha",
    "Model": "ADR6400L"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Thunderbolt",
    "Device": "mecha",
    "Model": "HTC Mecha"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "U Play",
    "Device": "htc_alpine_dugl",
    "Model": "HTC U Play"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "U Play",
    "Device": "htc_alpine_dugl",
    "Model": "HTC_U-2u"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "U Play",
    "Device": "htc_alpine_uhl",
    "Model": "HTC 2PZM3"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "U Play",
    "Device": "htc_alpine_uhl",
    "Model": "HTC U Play"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "U Play",
    "Device": "htc_e36_ml_uhl",
    "Model": "HTC 2PWD1"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "U Ultra",
    "Device": "htc_ocedtwl",
    "Model": "HTC U-1w"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "U Ultra",
    "Device": "htc_ocedugl",
    "Model": "HTC U Ultra"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "U Ultra",
    "Device": "htc_ocedugl",
    "Model": "HTC_U-1u"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "U Ultra",
    "Device": "htc_oceuhl",
    "Model": "HTC 2PZF1"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "U Ultra",
    "Device": "htc_oceuhl",
    "Model": "HTC U Ultra"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "U11",
    "Device": "htc_ocndtwl",
    "Model": "HTC U-3w"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "U11",
    "Device": "htc_ocndugl",
    "Model": "HTC U11"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "U11",
    "Device": "htc_ocndugl",
    "Model": "HTC_U-3u"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "U11",
    "Device": "htc_ocnuhl",
    "Model": "HTC 2PZC100"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "U11",
    "Device": "htc_ocnuhl",
    "Model": "HTC U11"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "U11",
    "Device": "htc_ocnuhljapan",
    "Model": "601HT"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "U11",
    "Device": "htc_ocnuhljapan",
    "Model": "HTC U11"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "U11",
    "Device": "htc_ocnuhljapan",
    "Model": "HTV33"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "U11",
    "Device": "htc_ocnwhl",
    "Model": "2PZC5"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "U11",
    "Device": "htc_ocnwhl",
    "Model": "HTC U11"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "U11 Life",
    "Device": "htc_ocluhljapan",
    "Model": "HTC U11 Life"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "U11 Life",
    "Device": "htc_ocluhljapan",
    "Model": "HTC U11 life"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "U12 +",
    "Device": "htc_imedtwl",
    "Model": "HTC 2Q55300"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "U12 Life",
    "Device": "htc_imldugl",
    "Model": "HTC 2Q6E1"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "U12 Life",
    "Device": "htc_imldugl",
    "Model": "HTC U12 life"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "U12+",
    "Device": "htc_imedugl",
    "Model": "HTC 2Q551"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "U12+",
    "Device": "htc_imedugl",
    "Model": "HTC 2Q551+"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "U12+",
    "Device": "htc_imedugl",
    "Model": "HTC 2Q55100"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "U12+",
    "Device": "htc_imedugl",
    "Model": "HTC U12+"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "U12+",
    "Device": "htc_imeuhl",
    "Model": "HTC 2Q552"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "U12+",
    "Device": "htc_imeuhl",
    "Model": "HTC U12+"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "U12+",
    "Device": "htc_imeuhljp",
    "Model": "HTC U12+"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "U20 5G",
    "Device": "htc_flhdugl",
    "Model": "2Q9F100"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "U20 5G",
    "Device": "htc_flhdugl",
    "Model": "HTC U20 5G"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Velocity 4G",
    "Device": "holiday",
    "Model": "HTC PH39100"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Velocity 4G",
    "Device": "holiday",
    "Model": "HTC Raider X710e"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Velocity 4G",
    "Device": "holiday",
    "Model": "HTC Velocity 4G"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Velocity 4G",
    "Device": "holiday",
    "Model": "HTC Velocity 4G X710s"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Velocity 4G",
    "Device": "holiday",
    "Model": "HTC-X710a"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "WF5w",
    "Device": "htc_a50bml",
    "Model": "HTC WF5w"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Wildfire",
    "Device": "buzz",
    "Model": "HTC Wildfire"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Wildfire CDMA",
    "Device": "bee",
    "Model": "HTC Bee"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Wildfire CDMA",
    "Device": "bee",
    "Model": "HTC Wildfire"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Wildfire E",
    "Device": "Wildfire_E",
    "Model": "Wildfire E"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Wildfire E Lite",
    "Device": "Wildfire_E_Lite",
    "Model": "Wildfire E Lite"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Wildfire E plus",
    "Device": "Wildfire_E_plus",
    "Model": "Wildfire E plus"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Wildfire E star",
    "Device": "Wildfire_E_star",
    "Model": "Wildfire E star"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Wildfire E ultra",
    "Device": "Wildfire_E_ultra",
    "Model": "Wildfire E ultra"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Wildfire E1",
    "Device": "Wildfire-E1",
    "Model": "HTC Wildfire E1"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Wildfire E1",
    "Device": "Wildfire-E1",
    "Model": "Wildfire E1"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Wildfire E1 Plus",
    "Device": "Wildfire_E1_Plus",
    "Model": "Wildfire E1 Plus"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Wildfire E2",
    "Device": "Wildfire_E2",
    "Model": "Wildfire E2"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Wildfire E2 play",
    "Device": "Wildfire_E2_play",
    "Model": "Wildfire E2 play"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Wildfire E2 plus",
    "Device": "Wildfire_E2_plus",
    "Model": "Wildfire E2 plus"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Wildfire E3",
    "Device": "Wildfire_E3",
    "Model": "Wildfire E3"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Wildfire E3 lite",
    "Device": "Wildfire_E3_lite",
    "Model": "Wildfire E3 lite"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Wildfire E4",
    "Device": "Wildfire_E4",
    "Model": "Wildfire E4"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Wildfire E4 Plus",
    "Device": "Wildfire_E4_Plus",
    "Model": "Wildfire E4 Plus"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Wildfire E5",
    "Device": "Wildfire_E5",
    "Model": "Wildfire E5"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Wildfire E5 Elite",
    "Device": "Wildfire_E5_Elite",
    "Model": "Wildfire E5 Elite"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Wildfire E5 Life",
    "Device": "Wildfire_E5_Life",
    "Model": "Wildfire E5 Life"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Wildfire E5 Plus",
    "Device": "Wildfire_E5_Plus",
    "Model": "Wildfire E5 Plus"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Wildfire E6",
    "Device": "Wildfire_E6",
    "Model": "Wildfire E6"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Wildfire E6 Elite",
    "Device": "Wildfire_E6_Elite",
    "Model": "Wildfire E6 Elite"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Wildfire E6 Plus",
    "Device": "Wildfire_E6_Plus",
    "Model": "Wildfire E6 Plus"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Wildfire E6 Star",
    "Device": "Wildfire_E6_Star",
    "Model": "Wildfire E6 Star"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Wildfire E7",
    "Device": "Wildfire_E7",
    "Model": "Wildfire E7"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Wildfire E7 Elite",
    "Device": "Wildfire_E7_Elite",
    "Model": "Wildfire E7 Elite"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Wildfire E7 Life",
    "Device": "Wildfire_E7_Life",
    "Model": "Wildfire E7 Life"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Wildfire E7 Plus",
    "Device": "Wildfire_E7_Plus",
    "Model": "Wildfire E7 Plus"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Wildfire E8",
    "Device": "Wildfire_E8",
    "Model": "Wildfire E8"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Wildfire E8 Plus",
    "Device": "Wildfire_E8_Plus",
    "Model": "Wildfire E8 Plus"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Wildfire S",
    "Device": "marvel",
    "Model": "HTC Wildfire S"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Wildfire S",
    "Device": "marvel",
    "Model": "HTC Wildfire S A510b"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Wildfire S",
    "Device": "marvel",
    "Model": "HTC Wildfire S A510e"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Wildfire S",
    "Device": "marvel",
    "Model": "HTC-A510a"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Wildfire S A515c",
    "Device": "marvelc",
    "Model": "HTC Wildfire S A515c"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Wildfire S A515c",
    "Device": "marvelc",
    "Model": "HTC-PG762"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Wildfire S A515c",
    "Device": "marvelc",
    "Model": "USCCADR6230US"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Wildfire_E1_Plus",
    "Device": "Wildfire_E1_Plus",
    "Model": "Wildfire E1 Plus"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "Wildfire_R70",
    "Device": "Wildfire_R70",
    "Model": "Wildfire R70"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "X2-HT",
    "Device": "htc_ocla1_sprout",
    "Model": "X2-HT"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "desire 400 dual sim",
    "Device": "cp2dug",
    "Model": "HTC Desire 400 dual sim"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "desire 608t",
    "Device": "cp3dtg",
    "Model": "HTC 608t"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "desire 610",
    "Device": "htc_a3qhdul",
    "Model": "HTC Desire 610"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "desire x",
    "Device": "protou",
    "Model": "HTC Desire X"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "enodugls_02401",
    "Device": "htc_enodugls",
    "Model": "HTC U24 pro"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "first",
    "Device": "mystul",
    "Model": "HTC first"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "myTouch 3G",
    "Device": "sapphire",
    "Model": "HTC Magic"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "myTouch 3G",
    "Device": "sapphire",
    "Model": "T-Mobile myTouch 3G"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "myTouch 3G Slide",
    "Device": "espresso",
    "Model": "T-Mobile myTouch 3G Slide"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "myTouch 4G",
    "Device": "glacier",
    "Model": "HTC Glacier"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "myTouch 4G",
    "Device": "glacier",
    "Model": "HTC Panache"
  },
  {
    "Retail Branding": "HTC",
    "Marketing Name": "myTouch 4G Slide",
    "Device": "doubleshot",
    "Model": "myTouch_4G_Slide"
  },
  {
    "Retail Branding": "HTOWAV",
    "Marketing Name": "Cyber 13",
    "Device": "Cyber_13",
    "Model": "Cyber 13"
  },
  {
    "Retail Branding": "HTStyle",
    "Marketing Name": "HMX70",
    "Device": "T5",
    "Model": "HTStyle HMX70"
  },
  {
    "Retail Branding": "HUAVI",
    "Marketing Name": "Eastaeon - Mediatek",
    "Device": "KHATARH10mini",
    "Model": "KHATAR H-10 mini"
  },
  {
    "Retail Branding": "HUAVI",
    "Marketing Name": "KHATAR H-20 PRO",
    "Device": "KHATARH20PRO",
    "Model": "KHATAR H-20 PRO"
  },
  {
    "Retail Branding": "HUAVI",
    "Marketing Name": "SH_700",
    "Device": "GOLD_77",
    "Model": "GOLD_77"
  },
  {
    "Retail Branding": "HUGEROCK",
    "Marketing Name": "E101_EEA",
    "Device": "E101",
    "Model": "E101"
  },
  {
    "Retail Branding": "HUGEROCK",
    "Marketing Name": "H8",
    "Device": "H8",
    "Model": "H8"
  },
  {
    "Retail Branding": "HUGEROCK",
    "Marketing Name": "H81",
    "Device": "H81-M50",
    "Model": "H81"
  },
  {
    "Retail Branding": "HUGEROCK",
    "Marketing Name": "T-Smart",
    "Device": "H81-4G-M45",
    "Model": "T-Smart"
  },
  {
    "Retail Branding": "HUIHUANG",
    "Marketing Name": "C90",
    "Device": "C90",
    "Model": "C90"
  },
  {
    "Retail Branding": "HUIHUANG",
    "Marketing Name": "C90_EEA",
    "Device": "C90",
    "Model": "C90"
  },
  {
    "Retail Branding": "HUIHUANG",
    "Marketing Name": "E10_A",
    "Device": "E10_A",
    "Model": "E10_A"
  },
  {
    "Retail Branding": "HUIHUANG",
    "Marketing Name": "E10_A_EEA",
    "Device": "E10_A",
    "Model": "E10_A"
  },
  {
    "Retail Branding": "HUIHUANG",
    "Marketing Name": "M10_EU",
    "Device": "M10",
    "Model": "M10"
  },
  {
    "Retail Branding": "HUIHUANG",
    "Marketing Name": "M10_ROW",
    "Device": "M10",
    "Model": "M10"
  },
  {
    "Retail Branding": "HUIHUANG",
    "Marketing Name": "T3L2",
    "Device": "T3L2",
    "Model": "T3L2"
  },
  {
    "Retail Branding": "HUIHUANG",
    "Marketing Name": "T3L2_EEA",
    "Device": "T3L2",
    "Model": "T3L2"
  },
  {
    "Retail Branding": "HUSHIDA",
    "Marketing Name": "Interactivewhiteboard",
    "Device": "D2",
    "Model": "CW-SPCM"
  },
  {
    "Retail Branding": "HYF(heyuefeng)",
    "Marketing Name": "SQ126G",
    "Device": "SQ126G",
    "Model": "SQ126G"
  },
  {
    "Retail Branding": "HYPERTECH",
    "Marketing Name": "THATAB",
    "Device": "THATAB",
    "Model": "THATAB"
  },
  {
    "Retail Branding": "HYPRO",
    "Marketing Name": "S6",
    "Device": "HYPRO_S6",
    "Model": "HYPRO S6"
  },
  {
    "Retail Branding": "HYUNDAI_MAESTRO",
    "Marketing Name": "HDT-7427GU",
    "Device": "HDT-7427GU",
    "Model": "HDT-7427GU"
  },
  {
    "Retail Branding": "HYUNDAI_MAESTRO",
    "Marketing Name": "HDT-7433X",
    "Device": "HDT-7433X",
    "Model": "HDT-7433X"
  },
  {
    "Retail Branding": "HYUNDAI_MAESTRO",
    "Marketing Name": "HDT-9421G",
    "Device": "HDT-9421G",
    "Model": "HDT-9421G"
  },
  {
    "Retail Branding": "HYUNDAI_MAESTRO",
    "Marketing Name": "HDT-9421GU",
    "Device": "HDT-9421GU",
    "Model": "HDT-9421GU"
  },
  {
    "Retail Branding": "HYUNDAI_MAESTRO",
    "Marketing Name": "HDT-9433X",
    "Device": "HDT-9433X",
    "Model": "HDT-9433X"
  },
  {
    "Retail Branding": "HYUNDAI_MAESTRO",
    "Marketing Name": "HDT-A421GU",
    "Device": "HDT-A421GU",
    "Model": "HDT-A421GU"
  },
  {
    "Retail Branding": "HYUNDAI_MAESTRO",
    "Marketing Name": "HDT-A435G4",
    "Device": "HDT_A435G4",
    "Model": "HDT-A435G4"
  },
  {
    "Retail Branding": "HYUNDAI_MAESTRO",
    "Marketing Name": "HDT_1064GS",
    "Device": "HDT_1064GS",
    "Model": "HDT_1064GS"
  },
  {
    "Retail Branding": "HYUNDAI_MAESTRO",
    "Marketing Name": "HDT_7427G",
    "Device": "HDT_7427G",
    "Model": "HDT_7427G"
  },
  {
    "Retail Branding": "HYUNDAI_MAESTRO",
    "Marketing Name": "HDT_7427G_PLUS",
    "Device": "HDT_7427G_PLUS",
    "Model": "HDT_7427G_PLUS"
  },
  {
    "Retail Branding": "HYUNDAI_MAESTRO",
    "Marketing Name": "HDT_7433H_PLUS",
    "Device": "HDT_7433H_PLUS",
    "Model": "HDT_7433H_PLUS"
  },
  {
    "Retail Branding": "Hackers",
    "Marketing Name": "HackersTab",
    "Device": "Hackers_Tab",
    "Model": "Hackers_Tab"
  },
  {
    "Retail Branding": "Haehne",
    "Marketing Name": "A863K_EEA",
    "Device": "A863K_EEA",
    "Model": "HAEHNE"
  },
  {
    "Retail Branding": "Haehne",
    "Marketing Name": "HAEHNE_M7",
    "Device": "HAEHNE_M7",
    "Model": "M7"
  },
  {
    "Retail Branding": "Hafury",
    "Marketing Name": "A7",
    "Device": "A7",
    "Model": "A7"
  },
  {
    "Retail Branding": "Hafury",
    "Marketing Name": "G20",
    "Device": "G20",
    "Model": "G20"
  },
  {
    "Retail Branding": "Hafury",
    "Marketing Name": "GT20",
    "Device": "GT20",
    "Model": "GT20"
  },
  {
    "Retail Branding": "Hafury",
    "Marketing Name": "HAFURY MIX",
    "Device": "HAFURY_MIX",
    "Model": "HAFURY MIX"
  },
  {
    "Retail Branding": "Hafury",
    "Marketing Name": "HAFURY UMAX",
    "Device": "HAFURY_UMAX",
    "Model": "HAFURY UMAX"
  },
  {
    "Retail Branding": "Hafury",
    "Marketing Name": "K30",
    "Device": "K30",
    "Model": "K30"
  },
  {
    "Retail Branding": "Hafury",
    "Marketing Name": "K30 PRO",
    "Device": "K30_PRO",
    "Model": "K30 PRO"
  },
  {
    "Retail Branding": "Hafury",
    "Marketing Name": "M20",
    "Device": "M20",
    "Model": "M20"
  },
  {
    "Retail Branding": "Hafury",
    "Marketing Name": "MEET",
    "Device": "MEET",
    "Model": "MEET"
  },
  {
    "Retail Branding": "Hafury",
    "Marketing Name": "NOTE 10",
    "Device": "NOTE_10",
    "Model": "NOTE 10"
  },
  {
    "Retail Branding": "Hafury",
    "Marketing Name": "V1",
    "Device": "V1",
    "Model": "V1"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "2K Haier TV",
    "Device": "umeda",
    "Model": "2K Haier TV"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "A-TT00",
    "Device": "A-TT00",
    "Model": "A-TT00"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "A36C5H",
    "Device": "A36C5H",
    "Model": "Andromax A36C5H"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "A42P",
    "Device": "A42P",
    "Model": "Haier A42P"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "A4_Lite",
    "Device": "A4_Lite",
    "Model": "A4_Lite"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "A81G",
    "Device": "A81G",
    "Model": "A81G"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "AD6B1H",
    "Device": "AD6B1H",
    "Model": "Smartfren Andromax AD6B1H"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "AL40",
    "Device": "AL40",
    "Model": "Haier_AL40"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "AP54",
    "Device": "ts18_ap54_kliver",
    "Model": "AP54"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "APAC",
    "Device": "nippori",
    "Model": "CANDY Android TV 2K"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "AT7003",
    "Device": "AT7003",
    "Model": "AT7003"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "Alpha A1",
    "Device": "A1",
    "Model": "A1"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "Alpha A2",
    "Device": "A2",
    "Model": "A2"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "Alpha A3",
    "Device": "A3",
    "Model": "A3"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "Alpha A3 Lite",
    "Device": "A3_Lite",
    "Model": "A3_Lite"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "Alpha A6",
    "Device": "A6",
    "Model": "A6"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "Beeline Smart 3",
    "Device": "Beeline_Smart3",
    "Model": "Beeline Smart 3"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "C46B2H",
    "Device": "C46B2H",
    "Model": "Andromax C46B2H"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "CANDY Android TV DVB",
    "Device": "dupont",
    "Model": "CANDY Android TV DVB"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "CANDY Android TV DVB2K",
    "Device": "broadway",
    "Model": "CANDY Android TV DVB2K"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "CANDY Android TV FF Pro",
    "Device": "daan",
    "Model": "CANDY Android TV FF Pro"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "CANDY Android TV PRO",
    "Device": "daan",
    "Model": "CANDY Android TV PRO"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "CANDY MatrixTV BE",
    "Device": "jordan",
    "Model": "CANDY MatrixTV BE"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "CANDY MatrixTV CE",
    "Device": "deto",
    "Model": "CANDY MatrixTV CE"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "CANDY MatrixTV DE",
    "Device": "omonia",
    "Model": "CANDY MatrixTV DE"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "CANDY MatrixTV DR",
    "Device": "holargos",
    "Model": "CANDY MatrixTV DR"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "CANDY MatrixTV EE",
    "Device": "omonia",
    "Model": "CANDY MatrixTV EE"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "CANDY MatrixTV ER",
    "Device": "holargos",
    "Model": "CANDY MatrixTV ER"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "CANDY MatrixTV GE",
    "Device": "haeundae",
    "Model": "CANDY MatrixTV GE"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "CDP7TAB4C8",
    "Device": "CDP7TAB4C8",
    "Model": "CDP7TAB4C8"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "CDP8TAB16SD",
    "Device": "CDP8TAB16SD",
    "Model": "CDP8TAB16SD"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "CEDTAB70616W8",
    "Device": "CEDTAB70616W8",
    "Model": "CEDTAB70616W8"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "CETAB10KML9",
    "Device": "CETAB10KML9",
    "Model": "CETAB10KML9"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "CETAB7ML9",
    "Device": "CETAB7ML9",
    "Model": "CETAB7ML9"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "CETAB9ML9",
    "Device": "CETAB9ML9",
    "Model": "CETAB9ML9"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "CMP_765",
    "Device": "CMP_765",
    "Model": "CMP_765"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "CT1030",
    "Device": "CT1030",
    "Model": "CT1030"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "CT301_W818",
    "Device": "msm7627a",
    "Model": "CT301_W818"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "CT825",
    "Device": "fiber-a31stm",
    "Model": "CT825"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "CYCLONE_ODYSSEY",
    "Device": "CYCLONE_ODYSSEY",
    "Model": "CYCLONE_ODYSSEY"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "D2-721",
    "Device": "D2-721G",
    "Model": "D2-721G"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "D2-751G",
    "Device": "d2PAD",
    "Model": "D2-751G"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "D2-927G",
    "Device": "D2-927G",
    "Model": "D2-927G"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "D2-961G",
    "Device": "D2-961G",
    "Model": "D2-961G"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "Dongle Matrix",
    "Device": "YQB",
    "Model": "Dongle Matrix"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "EU",
    "Device": "nippori",
    "Model": "HEC Android TV 2K"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "EVVO Android TV",
    "Device": "hanyang",
    "Model": "EVVO 4K Android TV"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "Ecuador",
    "Device": "nippori",
    "Model": "EVVO 2K Android TV"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "Ecuador",
    "Device": "nippori",
    "Model": "INNOVA 2K Android TV"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "Elegance E13",
    "Device": "E13",
    "Model": "E13"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "Elegance E7",
    "Device": "E7",
    "Model": "E7"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "Elegance E9",
    "Device": "E9",
    "Model": "E9"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "Fast",
    "Device": "HM-G551-FL",
    "Model": "Beeline Fast"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "G21",
    "Device": "HM-G303-W",
    "Model": "G21"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "G30",
    "Device": "G30",
    "Model": "G30"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "G31s",
    "Device": "G31s",
    "Model": "G31s"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "G40",
    "Device": "G40",
    "Model": "G40"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "G50",
    "Device": "HM-G551-FL",
    "Model": "G50"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "G51",
    "Device": "HM-G553-FL",
    "Model": "HM-G553-FL"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "G55",
    "Device": "G55",
    "Model": "G55"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "G7",
    "Device": "HM-G552-FL",
    "Model": "G7"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "G7",
    "Device": "HM-G552-FL",
    "Model": "HM-G552-FL"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "G700",
    "Device": "G700",
    "Model": "G700"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "G7s",
    "Device": "G7s",
    "Model": "G7s"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "GF88",
    "Device": "I7A-LE",
    "Model": "I7A-LE"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "Galaxy TV AEL",
    "Device": "irvine",
    "Model": "Galaxy TV AEL"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "Galaxy TV FE",
    "Device": "burrard",
    "Model": "Galaxy TV FE"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "Galaxy TV FR",
    "Device": "nanaimo",
    "Model": "Galaxy TV FR"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "HEC Android TV",
    "Device": "hanyang",
    "Model": "HEC Android TV"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "HEC Android TV DVB",
    "Device": "dupont",
    "Model": "HEC Android TV DVB"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "HEC Android TV DVB2K",
    "Device": "broadway",
    "Model": "HEC Android TV DVB2K"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "HEC MatrixTV ER",
    "Device": "holargos",
    "Model": "HEC MatrixTV ER"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "HG-9041",
    "Device": "HG-9041",
    "Model": "HG-9041"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "HM-I557-FL",
    "Device": "HM-I557-FL",
    "Model": "HM-I557-FL"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "HM-N501-FL",
    "Device": "HM-N501-FL",
    "Model": "HM-N501-FL"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "HS-10DTB4",
    "Device": "HS-10DTB4",
    "Model": "HS-10DTB4"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "HS-7DTB25",
    "Device": "HS-7DTB25",
    "Model": "HS-7DTB25"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "HS-7DTB29-8GB",
    "Device": "HS-7DTB29-8GB",
    "Model": "HS-7DTB29-8GB"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "HS-9DTB37",
    "Device": "HS_9DTB37",
    "Model": "HS_9DTB37"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "HT-I860",
    "Device": "HT-I860",
    "Model": "HT-I860"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "HW-I509-W",
    "Device": "HM-I509-W",
    "Model": "FORZA"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "Haier",
    "Device": "Homesurf744",
    "Model": "Binatone Homesurf744 / Hubble Smart7 (Homesurf744)"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "Haier",
    "Device": "PAD69H",
    "Model": "PAD69H"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "Haier",
    "Device": "PAD_D85",
    "Model": "pad_d85"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "Haier",
    "Device": "W627",
    "Model": "W627"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "Haier",
    "Device": "W861",
    "Model": "W861"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "Haier 2K Android TV",
    "Device": "nippori",
    "Model": "Haier 2K Android TV"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "Haier 4K Android TV",
    "Device": "hanyang",
    "Model": "Haier 4K Android TV"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "Haier Android TV",
    "Device": "hongik",
    "Model": "haierATVhongik"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "Haier Android TV",
    "Device": "uguisudani",
    "Model": "haierATVuguisudani"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "Haier Android TV DVB",
    "Device": "dupont",
    "Model": "Haier Android TV DVB"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "Haier Android TV DVB2K",
    "Device": "broadway",
    "Model": "Haier Android TV DVB2K"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "Haier Android TV FF Pro",
    "Device": "daan",
    "Model": "Haier Android TV FF Pro"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "Haier Android TV FF Pro ISDB",
    "Device": "daan",
    "Model": "Haier Android TV FFProISDB"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "Haier Android TV ISDB",
    "Device": "dupont",
    "Model": "Haier Android TV ISDB"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "Haier Android TV ISDB2K",
    "Device": "broadway",
    "Model": "Haier Android TV ISDB2K"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "Haier Android TV PRO",
    "Device": "daan",
    "Model": "Haier Android TV PRO"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "Haier Android TV PRO ISDB",
    "Device": "daan",
    "Model": "Haier Android TV PRO ISDB"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "Haier Leisure L7",
    "Device": "Haier_Leisure_L7",
    "Model": "HM-N700-FL"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "Haier MatrixTV AE",
    "Device": "irvine",
    "Model": "Haier MatrixTV AE"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "Haier MatrixTV AEL",
    "Device": "irvine",
    "Model": "Haier MatrixTV AEL"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "Haier MatrixTV AR",
    "Device": "yongchun",
    "Model": "Haier MatrixTV AR"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "Haier MatrixTV AS",
    "Device": "irvine",
    "Model": "Haier MatrixTV AS"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "Haier MatrixTV AS",
    "Device": "irvine",
    "Model": "Haier OLED TV AS"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "Haier MatrixTV BE",
    "Device": "jordan",
    "Model": "Haier MatrixTV BE"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "Haier MatrixTV BN",
    "Device": "jordan",
    "Model": "Haier MatrixTV BN"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "Haier MatrixTV BS",
    "Device": "jordan",
    "Model": "Haier MatrixTV BS"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "Haier MatrixTV CE",
    "Device": "deto",
    "Model": "Haier MatrixTV CE"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "Haier MatrixTV CN",
    "Device": "deto",
    "Model": "Haier MatrixTV CN"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "Haier MatrixTV CS",
    "Device": "deto",
    "Model": "Haier MatrixTV CS"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "Haier MatrixTV DE",
    "Device": "omonia",
    "Model": "Haier MatrixTV DE"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "Haier MatrixTV DR",
    "Device": "holargos",
    "Model": "Haier MatrixTV DR"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "Haier MatrixTV EE",
    "Device": "omonia",
    "Model": "Haier MatrixTV EE"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "Haier MatrixTV ER",
    "Device": "holargos",
    "Model": "Haier MatrixTV ER"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "Haier MatrixTV FE",
    "Device": "burrard",
    "Model": "Haier MatrixTV FE"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "Haier MatrixTV FR",
    "Device": "nanaimo",
    "Model": "Haier MatrixTV FR"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "Haier MatrixTV GE",
    "Device": "haeundae",
    "Model": "Haier MatrixTV GE"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "Haier OLED TV AE",
    "Device": "irvine",
    "Model": "Haier OLED TV AE"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "Haier TV",
    "Device": "SW6H",
    "Model": "Haier TV"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "Haier TV FF",
    "Device": "SW6H",
    "Model": "Haier TV FF"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "Haier Titan T5",
    "Device": "Titan_T5",
    "Model": "Titan_T5"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "HaierG61",
    "Device": "HM-G701-FL",
    "Model": "HM-G701-FL"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "Haitech android TV",
    "Device": "hanyang",
    "Model": "Haitech Android TV"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "HomeSurf742_AT7003",
    "Device": "HomeSurf742_AT7003",
    "Model": "HomeSurf742_AT7003"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "Homesurf844",
    "Device": "Homesurf844",
    "Model": "Binatone Homesurf844 / Hubble Smart8 (Homesurf844)"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "Hyasong T1",
    "Device": "HyasongT1",
    "Model": "HyasongT1"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "I4",
    "Device": "I4",
    "Model": "I4"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "I50",
    "Device": "i50_b1b8",
    "Model": "I50"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "I6_Infinity",
    "Device": "I6_Infinity",
    "Model": "I6_Infinity"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "INGO-TAB",
    "Device": "INGO-TAB",
    "Model": "INGO-TAB"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "INNOVA android TV",
    "Device": "hanyang",
    "Model": "INNOVA 4K Android TV"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "India",
    "Device": "nippori",
    "Model": "MAGELITE Android TV 2K"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "Kogan Agora 8",
    "Device": "Kogan_Agora_8",
    "Model": "Kogan Agora 8"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "Konnect_350",
    "Device": "Konnect_350",
    "Model": "Konnect_350"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "L11",
    "Device": "HM-G152-FL",
    "Model": "HM-G152-FL"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "L50",
    "Device": "M916-D500-PAK",
    "Model": "L50"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "L52",
    "Device": "Haier_L52",
    "Model": "L52"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "LE32U5000A",
    "Device": "LE32U5000A",
    "Model": "LE32U5000A"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "LE39M7000CF",
    "Device": "LE39M7000CF",
    "Model": "LE39M7000CF"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "LE40U5000A",
    "Device": "LE40U5000A",
    "Model": "LE40U5000A"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "LE43B7600A",
    "Device": "LE43B7600A",
    "Model": "LE43B7600A"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "LE43U5000A",
    "Device": "LE43U5000A",
    "Model": "LE43U5000A"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "LE48M7000CF",
    "Device": "LE48M7000CF",
    "Model": "LE48M7000CF"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "LE49U5000A",
    "Device": "LE49U5000A",
    "Model": "LE49U5000A"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "LE55M7000CF",
    "Device": "LE55M7000CF",
    "Model": "LE55M7000CF"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "Logicom S9782",
    "Device": "Logicom-S9782",
    "Model": "Logicom-S9782"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "M53-52401",
    "Device": "M53-52401",
    "Model": "M53-52401"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "M53-52401",
    "Device": "M53-524O1",
    "Model": "M53-52401"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "M53-52401",
    "Device": "M5352401",
    "Model": "M53-52401"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "M7808",
    "Device": "M7808",
    "Model": "M7808"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "MD-01P",
    "Device": "MD-01P",
    "Model": "MD-01P"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "MD210",
    "Device": "MD210",
    "Model": "MD210"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "MEGAFON MS3A",
    "Device": "Megafon",
    "Model": "MS3A"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "MT-700",
    "Device": "MT-700",
    "Model": "MT-700"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "MXG308",
    "Device": "MXG308",
    "Model": "MXG308"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "MXG408",
    "Device": "MXG408",
    "Model": "MXG408"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "Magelite android TV",
    "Device": "hanyang",
    "Model": "MAGELITE Android TV"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "NEO10-1",
    "Device": "NEO10-1",
    "Model": "NEO10-1"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "NEO7-1",
    "Device": "NEO7-1",
    "Model": "NEO7-1"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "NEO7-2",
    "Device": "NEO7-2",
    "Model": "NEO7-2"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "NEO8-1",
    "Device": "NEO8-1",
    "Model": "NEO8-1"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "OLED TV S9",
    "Device": "SW4H_FF",
    "Model": "OLED TV S9"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "P2",
    "Device": "P2",
    "Model": "P2"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "P20",
    "Device": "P20",
    "Model": "P20"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "P20_M64G3M",
    "Device": "P20_Tablet_PC",
    "Model": "P20"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "P20_M66G8M",
    "Device": "P20_Tablet_PC",
    "Model": "P20"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "P20_M84G3M",
    "Device": "P20_Tablet_PC",
    "Model": "P20"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "P20_M88G3M",
    "Device": "P20_Tablet_PC",
    "Model": "P20"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "PA",
    "Device": "nippori",
    "Model": "Haitech Android TV 2K"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "PAD1021",
    "Device": "PAD1021",
    "Model": "PAD1021"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "PAD1042",
    "Device": "PAD1042",
    "Model": "PAD1042"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "PAD712",
    "Device": "PAD712",
    "Model": "PAD712"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "PAD722",
    "Device": "PAD722",
    "Model": "PAD722"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "PAD841",
    "Device": "PAD841",
    "Model": "PAD841"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "PADCT1010W",
    "Device": "PADCT1010W",
    "Model": "PADCT1010W"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "PAD_1042",
    "Device": "PAD_1042",
    "Model": "PAD_1042"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "PNDPP410GP",
    "Device": "PNDPP410GP",
    "Model": "PNDPP410GP"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "PNDPP44Q7GPBLK",
    "Device": "PNDPP44Q7GPBLK",
    "Model": "PNDPP44Q7GPBLK"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "PNDPP47GP",
    "Device": "PNDPP47GP",
    "Model": "PNDPP47GP"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "Power P10",
    "Device": "P10",
    "Model": "P10"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "Power P11",
    "Device": "P11",
    "Model": "P11"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "Power P8",
    "Device": "P8",
    "Model": "P8"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "S5_Silk",
    "Device": "S5_Silk",
    "Model": "S5 Silk"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "SP-5100",
    "Device": "SP-5100",
    "Model": "SP-5100"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "Skill",
    "Device": "Skill",
    "Model": "Skill"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "Smartfren Andromax AD681H",
    "Device": "AD681H",
    "Model": "Smartfren Andromax AD681H"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "Smartfren Andromax AD9A1H",
    "Device": "AD9A1H",
    "Model": "Smartfren Andromax AD9A1H"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "StarQ_Q5002",
    "Device": "StarQ_Q5002",
    "Model": "Q5002"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "T50",
    "Device": "Haier_T50",
    "Model": "Haier T50"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "T52P",
    "Device": "T52P",
    "Model": "Haier T52P"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "T54P",
    "Device": "Haier_T54P",
    "Model": "Haier T54P"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "T785B",
    "Device": "T785B",
    "Model": "T785B"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "TAB-700",
    "Device": "TAB_700",
    "Model": "TAB-700"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "TAB-700",
    "Device": "TAB_700",
    "Model": "TAB700MPG"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "TMK27A2",
    "Device": "TMK27A2",
    "Model": "TMK27A2"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "Tablet_P20",
    "Device": "Tablet_P20",
    "Model": "Tablet_P20"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "Titan T3 Pro",
    "Device": "Titan_T3_Pro",
    "Model": "Titan_T3_Pro"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "Titan_T1",
    "Device": "Titan_T1",
    "Model": "Titan_T1"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "Titan_T3",
    "Device": "Titan_T3",
    "Model": "Titan_T3"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "V3",
    "Device": "V3",
    "Model": "V3"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "Voyage V6",
    "Device": "HM-V6",
    "Model": "HM-V6"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "W717",
    "Device": "W717",
    "Model": "W717"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "W757",
    "Device": "W757",
    "Model": "W757"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "W860",
    "Device": "W860",
    "Model": "W860"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "candy android TV",
    "Device": "hanyang",
    "Model": "CANDY Android TV"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "haier lesure L7",
    "Device": "Haier_Leisure_L7",
    "Model": "HM-N700-FL"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "haierATV",
    "Device": "hanyang",
    "Model": "haierATV"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "haierATVnippori",
    "Device": "nippori",
    "Model": "haierATVnippori"
  },
  {
    "Retail Branding": "Haier",
    "Marketing Name": "i50",
    "Device": "i50",
    "Model": "Haier_i50"
  },
  {
    "Retail Branding": "Haitech",
    "Marketing Name": "HIP-T66",
    "Device": "HIP-T66",
    "Model": "HIP-T66"
  },
  {
    "Retail Branding": "Haitech",
    "Marketing Name": "HPAD-M2",
    "Device": "HPAD-M2",
    "Model": "HPAD-M2"
  },
  {
    "Retail Branding": "Haitech",
    "Marketing Name": "HPAD-T80",
    "Device": "HPAD-T80",
    "Model": "HPAD-T80"
  },
  {
    "Retail Branding": "Haitech",
    "Marketing Name": "HPAD_IA65",
    "Device": "HPAD_IA65",
    "Model": "HPAD_IA65"
  },
  {
    "Retail Branding": "Haitech",
    "Marketing Name": "HPAD_IA65",
    "Device": "Tablet",
    "Model": "KITYPRO"
  },
  {
    "Retail Branding": "Haitech",
    "Marketing Name": "HPAD_IP8045",
    "Device": "HPAD_IP8045",
    "Model": "HPAD_IP8045"
  },
  {
    "Retail Branding": "Haitech",
    "Marketing Name": "HPAD_IP8045_1",
    "Device": "HPAD_IP8045_1",
    "Model": "HPAD_IP8045_1"
  },
  {
    "Retail Branding": "Haitech",
    "Marketing Name": "T69-A",
    "Device": "T69-A",
    "Model": "T69-A"
  },
  {
    "Retail Branding": "Hakaug",
    "Marketing Name": "X109",
    "Device": "X109",
    "Model": "X109"
  },
  {
    "Retail Branding": "Hakaug",
    "Marketing Name": "X109_EEA",
    "Device": "X109",
    "Model": "X109"
  },
  {
    "Retail Branding": "HaloBop (ShenZhen)",
    "Marketing Name": "BG001",
    "Device": "HelloGenius",
    "Model": "BG001"
  },
  {
    "Retail Branding": "Hami TV",
    "Marketing Name": "HamiVideo",
    "Device": "HamiVideo",
    "Model": "HamiVideo"
  },
  {
    "Retail Branding": "Hamic",
    "Marketing Name": "MIELS",
    "Device": "MIELS",
    "Model": "MIELS"
  },
  {
    "Retail Branding": "Hamic",
    "Marketing Name": "POCKET",
    "Device": "POCKET",
    "Model": "POCKET"
  },
  {
    "Retail Branding": "Hamlet",
    "Marketing Name": "Hamlet_XZPAD412W",
    "Device": "XZPAD412W",
    "Model": "Hamlet_XZPAD412W"
  },
  {
    "Retail Branding": "Hamlet",
    "Marketing Name": "XZPAD412LTE",
    "Device": "XZPAD412LTE",
    "Model": "XZPAD412LTE"
  },
  {
    "Retail Branding": "Hamlet",
    "Marketing Name": "XZPAD414LTE",
    "Device": "XZPAD414LTE",
    "Model": "XZPAD414LTE"
  },
  {
    "Retail Branding": "Hamlet",
    "Marketing Name": "XZPAD414W",
    "Device": "XZPAD414W",
    "Model": "XZPAD414W"
  },
  {
    "Retail Branding": "Hamlet",
    "Marketing Name": "XZPAD470LTE",
    "Device": "XZPAD470LTE",
    "Model": "XZPAD470LTE"
  },
  {
    "Retail Branding": "Hammer",
    "Marketing Name": "Energy_X2_EEA",
    "Device": "Hammer_Energy_X2",
    "Model": "Energy_X2"
  },
  {
    "Retail Branding": "Hammer",
    "Marketing Name": "Hammer Blade 3",
    "Device": "Hammer_Blade_3",
    "Model": "Hammer_Blade_3"
  },
  {
    "Retail Branding": "Hammer",
    "Marketing Name": "Hammer Blade 4",
    "Device": "Hammer_Blade_4",
    "Model": "Hammer_Blade_4"
  },
  {
    "Retail Branding": "Hammer",
    "Marketing Name": "Hammer Blade 5G",
    "Device": "Hammer_Blade_5G",
    "Model": "Hammer_Blade_5G"
  },
  {
    "Retail Branding": "Hammer",
    "Marketing Name": "Hammer Blade Va 5G EEA",
    "Device": "HS2402",
    "Model": "Hammer Blade Va 5G"
  },
  {
    "Retail Branding": "Hammer",
    "Marketing Name": "Hammer Construction",
    "Device": "Hammer_Construction",
    "Model": "Hammer_Construction"
  },
  {
    "Retail Branding": "Hammer",
    "Marketing Name": "Hammer Energy 2 2022",
    "Device": "Energy_2_2022",
    "Model": "Hammer_Energy_2_2022"
  },
  {
    "Retail Branding": "Hammer",
    "Marketing Name": "Hammer Explorer Plus",
    "Device": "Explorer_Plus",
    "Model": "Hammer_Explorer_Plus"
  },
  {
    "Retail Branding": "Hammer",
    "Marketing Name": "Hammer Explorer Pro",
    "Device": "Hammer_Expl_Pro",
    "Model": "Hammer_Explorer_Pro"
  },
  {
    "Retail Branding": "Hammer",
    "Marketing Name": "Hammer_Construction_2_5G_EEA",
    "Device": "HS2403x",
    "Model": "Hammer_Construction_2_5G"
  },
  {
    "Retail Branding": "Hammer",
    "Marketing Name": "Hammer_Construction_2_Thermal_5G_EEA",
    "Device": "HS2404x",
    "Model": "Hammer_Construction_2_Thermal_5G"
  },
  {
    "Retail Branding": "Hammer",
    "Marketing Name": "Hammer_Iron_6",
    "Device": "HS2512",
    "Model": "Hammer_Iron_6"
  },
  {
    "Retail Branding": "Hammer",
    "Marketing Name": "Hammer_Iron_6_5G",
    "Device": "Hammer_Iron_6_5G",
    "Model": "Hammer_Iron_6_5G"
  },
  {
    "Retail Branding": "Hammer",
    "Marketing Name": "Hammer_Iron_Va_EEA",
    "Device": "HS2401x",
    "Model": "Iron Va"
  },
  {
    "Retail Branding": "Handetec",
    "Marketing Name": "C6",
    "Device": "C6",
    "Model": "C6"
  },
  {
    "Retail Branding": "Handetec",
    "Marketing Name": "C6_EEA",
    "Device": "C6_EEA",
    "Model": "C6"
  },
  {
    "Retail Branding": "Handetec",
    "Marketing Name": "Handetec_Tablet",
    "Device": "Handetec_Tablet",
    "Model": "Handetec_Tablet"
  },
  {
    "Retail Branding": "Handheld Group",
    "Marketing Name": "ALGIZ RT10",
    "Device": "ALGIZ_RT10",
    "Model": "ALGIZ_RT10"
  },
  {
    "Retail Branding": "Handheld Group",
    "Marketing Name": "ALGIZ RT8",
    "Device": "ALGIZ_RT8",
    "Model": "ALGIZ_RT8"
  },
  {
    "Retail Branding": "Handheld Group",
    "Marketing Name": "Algiz RT7",
    "Device": "algizRT7",
    "Model": "Algiz RT7"
  },
  {
    "Retail Branding": "Handheld Group",
    "Marketing Name": "HandHeld NAUTIZ X2",
    "Device": "NAUTIZ_X2",
    "Model": "NAUTIZ_X2"
  },
  {
    "Retail Branding": "Handheld Group",
    "Marketing Name": "NAUTIZ X21",
    "Device": "condor",
    "Model": "Nautiz X21"
  },
  {
    "Retail Branding": "Handheld Group",
    "Marketing Name": "NAUTIZ X6",
    "Device": "NAUTIZ_X6",
    "Model": "NAUTIZ_X6"
  },
  {
    "Retail Branding": "Handheld Group",
    "Marketing Name": "NAUTIZ X6",
    "Device": "NAUTIZ_X6P",
    "Model": "NAUTIZ_X6P"
  },
  {
    "Retail Branding": "Handheld Group",
    "Marketing Name": "NAUTIZ_X6",
    "Device": "NAUTIZ_X6",
    "Model": "NAUTIZ_X6"
  },
  {
    "Retail Branding": "Handheld Group",
    "Marketing Name": "Nautiz X2",
    "Device": "alta_GL",
    "Model": "Nautiz X2"
  },
  {
    "Retail Branding": "Handheld Group",
    "Marketing Name": "Nautiz X2 EEA",
    "Device": "alta_EEA",
    "Model": "Nautiz X2"
  },
  {
    "Retail Branding": "Handheld Group",
    "Marketing Name": "Nautiz X41",
    "Device": "albatross_GL",
    "Model": "Nautiz X41"
  },
  {
    "Retail Branding": "Handheld Group",
    "Marketing Name": "Nautiz X41 EEA",
    "Device": "albatross_EEA",
    "Model": "Nautiz X41"
  },
  {
    "Retail Branding": "Handheld Group",
    "Marketing Name": "Nautiz X6 Pro",
    "Device": "eagle-pro",
    "Model": "Nautiz X6 Pro"
  },
  {
    "Retail Branding": "Handheld Group",
    "Marketing Name": "Nautiz X81",
    "Device": "Nautiz_X81",
    "Model": "Nautiz X81"
  },
  {
    "Retail Branding": "Handheld Group",
    "Marketing Name": "Nautiz X9",
    "Device": "Nautiz_X9P",
    "Model": "Nautiz X9P"
  },
  {
    "Retail Branding": "Handheld Group",
    "Marketing Name": "Nautiz_X2",
    "Device": "NAUTIZ_X2",
    "Model": "NAUTIZ_X2"
  },
  {
    "Retail Branding": "Handheld Group",
    "Marketing Name": "Nautiz_X9",
    "Device": "Nautiz_X9",
    "Model": "Nautiz_X9"
  },
  {
    "Retail Branding": "Handheld-Wireless",
    "Marketing Name": "C6",
    "Device": "C6",
    "Model": "C6"
  },
  {
    "Retail Branding": "Handheld-Wireless",
    "Marketing Name": "C6_EEA",
    "Device": "C6",
    "Model": "C6"
  },
  {
    "Retail Branding": "Handheld-Wireless",
    "Marketing Name": "C6_TU",
    "Device": "C6",
    "Model": "C6"
  },
  {
    "Retail Branding": "Handheld-Wireless",
    "Marketing Name": "F1",
    "Device": "F1",
    "Model": "F1"
  },
  {
    "Retail Branding": "Handheld-Wireless",
    "Marketing Name": "F2",
    "Device": "F2",
    "Model": "F2"
  },
  {
    "Retail Branding": "Handheld-Wireless",
    "Marketing Name": "X6",
    "Device": "X6",
    "Model": "X6"
  },
  {
    "Retail Branding": "Handsfree",
    "Marketing Name": "R5",
    "Device": "R5",
    "Model": "R5"
  },
  {
    "Retail Branding": "Handtop",
    "Marketing Name": "HTA11",
    "Device": "HTA11",
    "Model": "HTA11"
  },
  {
    "Retail Branding": "HannSpree",
    "Marketing Name": "HSD0001",
    "Device": "Reader",
    "Model": "HannsNote2"
  },
  {
    "Retail Branding": "HannSpree",
    "Marketing Name": "HSD0001A",
    "Device": "Reader",
    "Model": "HannsNote2"
  },
  {
    "Retail Branding": "HannSpree",
    "Marketing Name": "HSG1279",
    "Device": "HANNSpad",
    "Model": "HSG1279"
  },
  {
    "Retail Branding": "HannSpree",
    "Marketing Name": "HSG1341",
    "Device": "mid1024_e",
    "Model": "HSG1341"
  },
  {
    "Retail Branding": "HannSpree",
    "Marketing Name": "HSG1351",
    "Device": "HSG1351",
    "Model": "HSG1351"
  },
  {
    "Retail Branding": "HannSpree",
    "Marketing Name": "HSG1351",
    "Device": "rk3368_32",
    "Model": "HSG1351"
  },
  {
    "Retail Branding": "HannSpree",
    "Marketing Name": "HSG1360",
    "Device": "HANNSPAD",
    "Model": "HSG1360"
  },
  {
    "Retail Branding": "HannSpree",
    "Marketing Name": "HSG1376",
    "Device": "HSG1376_MT8163",
    "Model": "HSG1376"
  },
  {
    "Retail Branding": "HannSpree",
    "Marketing Name": "HSG1415",
    "Device": "HSG1415",
    "Model": "HSG1415"
  },
  {
    "Retail Branding": "HannSpree",
    "Marketing Name": "HSG1416",
    "Device": "HANNSPAD",
    "Model": "HSG1416"
  },
  {
    "Retail Branding": "HannSpree",
    "Marketing Name": "HSG1472",
    "Device": "HSG1472",
    "Model": "HSG1472"
  },
  {
    "Retail Branding": "HannSpree",
    "Marketing Name": "HSG1500",
    "Device": "HSG1500",
    "Model": "HSG1500"
  },
  {
    "Retail Branding": "HannSpree",
    "Marketing Name": "HSG1501",
    "Device": "HSG1501",
    "Model": "HSG1501"
  },
  {
    "Retail Branding": "HannSpree",
    "Marketing Name": "HSG1501A",
    "Device": "HSG1501A",
    "Model": "HSG1501A"
  },
  {
    "Retail Branding": "HannSpree",
    "Marketing Name": "Hannspad",
    "Device": "Hannspad",
    "Model": "Hannspad"
  },
  {
    "Retail Branding": "HannSpree",
    "Marketing Name": "HannspadPro",
    "Device": "HannspadPro",
    "Model": "HannspadPro"
  },
  {
    "Retail Branding": "HannSpree",
    "Marketing Name": "Product Name HSG1416A",
    "Device": "HSG1416A",
    "Model": "HSG1416A"
  },
  {
    "Retail Branding": "HannSpree",
    "Marketing Name": "SN08HD1B",
    "Device": "SN08HD1B",
    "Model": "SN08HD1B"
  },
  {
    "Retail Branding": "HannSpree",
    "Marketing Name": "SN08HD1B_EEA",
    "Device": "SN08HD1B",
    "Model": "SN08HD1B"
  },
  {
    "Retail Branding": "HannSpree",
    "Marketing Name": "SN10HD1B",
    "Device": "SN10HD1B",
    "Model": "SN10HD1B"
  },
  {
    "Retail Branding": "HannSpree",
    "Marketing Name": "SN10HR4B",
    "Device": "Ambi_Paper_Tablet",
    "Model": "HSD0008"
  },
  {
    "Retail Branding": "Hanshow",
    "Marketing Name": "VisCart",
    "Device": "Clip-on_Smart_Trolley",
    "Model": "CT10-W0C3"
  },
  {
    "Retail Branding": "Haoqin",
    "Marketing Name": "SpaceTab_H20",
    "Device": "SpaceTab_H20",
    "Model": "SpaceTab_H20"
  },
  {
    "Retail Branding": "Haoqin",
    "Marketing Name": "SpaceTab_H20_EEA",
    "Device": "SpaceTab_H20_EEA",
    "Model": "SpaceTab_H20_EEA"
  },
  {
    "Retail Branding": "Harman TV",
    "Marketing Name": "JBL link bar",
    "Device": "atom",
    "Model": "JBL LINK BAR"
  },
  {
    "Retail Branding": "Harris",
    "Marketing Name": "12131-1000",
    "Device": "msm8660_cougar",
    "Model": "Harris 12131-1000"
  },
  {
    "Retail Branding": "Harris",
    "Marketing Name": "LMC-1000",
    "Device": "granite",
    "Model": "LMC-1000"
  },
  {
    "Retail Branding": "Harris",
    "Marketing Name": "RF-3590-RT",
    "Device": "msm8660_cougar",
    "Model": "Harris 12131-1000"
  },
  {
    "Retail Branding": "Hatch",
    "Marketing Name": "101S",
    "Device": "101S",
    "Model": "Hatch_101S"
  },
  {
    "Retail Branding": "Hatch",
    "Marketing Name": "Hatch_103S",
    "Device": "Hatch_103S",
    "Model": "Hatch_103S"
  },
  {
    "Retail Branding": "Hathway",
    "Marketing Name": "DVB-ATV100",
    "Device": "SEI111H",
    "Model": "DVB-ATV100"
  },
  {
    "Retail Branding": "Hathway",
    "Marketing Name": "OTH-100",
    "Device": "SEI103",
    "Model": "OTH-100"
  },
  {
    "Retail Branding": "Haus",
    "Marketing Name": "HAUS JS408",
    "Device": "HAUS_JS408",
    "Model": "HAUS JS408"
  },
  {
    "Retail Branding": "Haus",
    "Marketing Name": "HAUS_JS410",
    "Device": "HAUS_JS410",
    "Model": "JS410"
  },
  {
    "Retail Branding": "Haus",
    "Marketing Name": "JS409",
    "Device": "JS409",
    "Model": "JS409"
  },
  {
    "Retail Branding": "Haus",
    "Marketing Name": "JS420",
    "Device": "JS420",
    "Model": "JS420"
  },
  {
    "Retail Branding": "Haus",
    "Marketing Name": "JS550",
    "Device": "JS550",
    "Model": "JS550"
  },
  {
    "Retail Branding": "Helgi",
    "Marketing Name": "HELGI_C_Series_PRO",
    "Device": "rk3576_u",
    "Model": "HCPxx10"
  },
  {
    "Retail Branding": "Helgi",
    "Marketing Name": "HXxx10",
    "Device": "rk3588_t",
    "Model": "Helgi_HX10"
  },
  {
    "Retail Branding": "Helio",
    "Marketing Name": "Helio S5",
    "Device": "Helio_S5",
    "Model": "Helio S5"
  },
  {
    "Retail Branding": "Helio",
    "Marketing Name": "S10",
    "Device": "S10",
    "Model": "S10"
  },
  {
    "Retail Branding": "Helio",
    "Marketing Name": "S2",
    "Device": "WBL7519SY",
    "Model": "S2"
  },
  {
    "Retail Branding": "Helio",
    "Marketing Name": "S25",
    "Device": "HelioS25",
    "Model": "S25"
  },
  {
    "Retail Branding": "Helio",
    "Marketing Name": "helio 15",
    "Device": "helio_15",
    "Model": "helio 15"
  },
  {
    "Retail Branding": "Helio",
    "Marketing Name": "helio 20",
    "Device": "helio_20",
    "Model": "helio 20"
  },
  {
    "Retail Branding": "Helio",
    "Marketing Name": "helio 22",
    "Device": "helio_22",
    "Model": "helio 22"
  },
  {
    "Retail Branding": "Helio",
    "Marketing Name": "helio 40",
    "Device": "helio_40",
    "Model": "helio 40"
  },
  {
    "Retail Branding": "Helio",
    "Marketing Name": "helio 50",
    "Device": "helio_50",
    "Model": "helio 50"
  },
  {
    "Retail Branding": "Helio",
    "Marketing Name": "helio_45",
    "Device": "helio_45",
    "Model": "helio 45"
  },
  {
    "Retail Branding": "Helio",
    "Marketing Name": "helio_55",
    "Device": "helio_55",
    "Model": "helio 55"
  },
  {
    "Retail Branding": "HelloPro",
    "Marketing Name": "PK81R",
    "Device": "PK81R",
    "Model": "PK81R"
  },
  {
    "Retail Branding": "HemiltonPro",
    "Marketing Name": "Tab1000",
    "Device": "Tab1000",
    "Model": "Tab1000"
  },
  {
    "Retail Branding": "Hercls",
    "Marketing Name": "HERCLS A15",
    "Device": "A15",
    "Model": "A15"
  },
  {
    "Retail Branding": "Hercls",
    "Marketing Name": "HERCLS L925",
    "Device": "L925",
    "Model": "L925"
  },
  {
    "Retail Branding": "Hero",
    "Marketing Name": "HERO 4ALL",
    "Device": "HERO_4ALL",
    "Model": "HERO 4ALL"
  },
  {
    "Retail Branding": "Hero",
    "Marketing Name": "HERO B1",
    "Device": "HERO_B1",
    "Model": "HERO B1"
  },
  {
    "Retail Branding": "HexaByte",
    "Marketing Name": "HB_X7",
    "Device": "HB_X7",
    "Model": "HB_X7"
  },
  {
    "Retail Branding": "Hezire",
    "Marketing Name": "HBook-Prime",
    "Device": "HBook-Prime",
    "Model": "HBook-Prime"
  },
  {
    "Retail Branding": "Hezire",
    "Marketing Name": "HBook-Pro",
    "Device": "HBook-Pro",
    "Model": "HBook-Pro"
  },
  {
    "Retail Branding": "Hezire",
    "Marketing Name": "HTB801",
    "Device": "HTB801",
    "Model": "HTB801"
  },
  {
    "Retail Branding": "Hi TFG",
    "Marketing Name": "Boost Max",
    "Device": "Boost_Max",
    "Model": "Boost_Max"
  },
  {
    "Retail Branding": "Hi TFG",
    "Marketing Name": "Crusader",
    "Device": "Crusader",
    "Model": "Crusader"
  },
  {
    "Retail Branding": "Hi TFG",
    "Marketing Name": "Spitfire",
    "Device": "Spitfire",
    "Model": "Spitfire"
  },
  {
    "Retail Branding": "Hi(HMR)",
    "Marketing Name": "Boost Hypa",
    "Device": "Boost_Hypa",
    "Model": "Boost Hypa"
  },
  {
    "Retail Branding": "Hi-online",
    "Marketing Name": "Boost Ultra",
    "Device": "Boost_Ultra",
    "Model": "Boost Ultra"
  },
  {
    "Retail Branding": "Hi-online",
    "Marketing Name": "HMR5450",
    "Device": "HMR5450",
    "Model": "HMR5450"
  },
  {
    "Retail Branding": "HiMedia",
    "Marketing Name": "RES102",
    "Device": "Station",
    "Model": "RES102"
  },
  {
    "Retail Branding": "HiMedia",
    "Marketing Name": "S500",
    "Device": "HiBox",
    "Model": "S500"
  },
  {
    "Retail Branding": "HiStone",
    "Marketing Name": "HK566",
    "Device": "HK566",
    "Model": "HK566"
  },
  {
    "Retail Branding": "Hicel",
    "Marketing Name": "Hope_Plus",
    "Device": "Hope_Plus",
    "Model": "Hope Plus"
  },
  {
    "Retail Branding": "Hicel",
    "Marketing Name": "STAR_1",
    "Device": "STAR_1",
    "Model": "STAR 1"
  },
  {
    "Retail Branding": "Hicel",
    "Marketing Name": "SUN 1",
    "Device": "SUN1",
    "Model": "SUN 1"
  },
  {
    "Retail Branding": "HighScreen",
    "Marketing Name": "Bay",
    "Device": "Bay",
    "Model": "Bay"
  },
  {
    "Retail Branding": "HighScreen",
    "Marketing Name": "Easy Power",
    "Device": "Easy-Power",
    "Model": "Easy-Power"
  },
  {
    "Retail Branding": "HighScreen",
    "Marketing Name": "Easy Power Pro",
    "Device": "Easy-Power-Pro",
    "Model": "Easy-Power-Pro"
  },
  {
    "Retail Branding": "HighScreen",
    "Marketing Name": "Easy XL",
    "Device": "Easy_XL",
    "Model": "Easy_XL"
  },
  {
    "Retail Branding": "HighScreen",
    "Marketing Name": "Easy XL Pro",
    "Device": "Easy_XL_Pro",
    "Model": "Easy_XL_Pro"
  },
  {
    "Retail Branding": "HighScreen",
    "Marketing Name": "Expanse",
    "Device": "Expanse",
    "Model": "Expanse"
  },
  {
    "Retail Branding": "HighScreen",
    "Marketing Name": "Fest",
    "Device": "Fest",
    "Model": "Fest"
  },
  {
    "Retail Branding": "HighScreen",
    "Marketing Name": "Fest XL",
    "Device": "FestXL",
    "Model": "FestXL"
  },
  {
    "Retail Branding": "HighScreen",
    "Marketing Name": "Fest XL PRO",
    "Device": "FestXL-Pro",
    "Model": "FestXL-Pro"
  },
  {
    "Retail Branding": "HighScreen",
    "Marketing Name": "HS_Boost_4",
    "Device": "HS_Boost_4",
    "Model": "HS Boost 4"
  },
  {
    "Retail Branding": "HighScreen",
    "Marketing Name": "K2050 C1 Fest Pro",
    "Device": "Fest-Pro",
    "Model": "Fest-Pro"
  },
  {
    "Retail Branding": "HighScreen",
    "Marketing Name": "Max3",
    "Device": "Max3",
    "Model": "Max3"
  },
  {
    "Retail Branding": "HighScreen",
    "Marketing Name": "Power Five",
    "Device": "PowerFive",
    "Model": "PowerFive"
  },
  {
    "Retail Branding": "HighScreen",
    "Marketing Name": "Power Four",
    "Device": "PowerFour",
    "Model": "PowerFour"
  },
  {
    "Retail Branding": "HighScreen",
    "Marketing Name": "Power Ice",
    "Device": "BBL7353RV",
    "Model": "Power Ice"
  },
  {
    "Retail Branding": "HighScreen",
    "Marketing Name": "Power Ice EVO",
    "Device": "PowerIceEvo",
    "Model": "Power Ice Evo"
  },
  {
    "Retail Branding": "HighScreen",
    "Marketing Name": "Power Rage",
    "Device": "PowerRage",
    "Model": "Power Rage"
  },
  {
    "Retail Branding": "HighScreen",
    "Marketing Name": "PowerFiveMax2",
    "Device": "PowerFiveMax2",
    "Model": "PowerFiveMax2"
  },
  {
    "Retail Branding": "HighScreen",
    "Marketing Name": "PowerFiveMaxLite",
    "Device": "PowerFiveMaxLite",
    "Model": "PowerFiveMaxLite"
  },
  {
    "Retail Branding": "HighScreen",
    "Marketing Name": "PowerIceMax",
    "Device": "PowerIceMax",
    "Model": "Power Ice Max"
  },
  {
    "Retail Branding": "HighScreen",
    "Marketing Name": "PowerRageEvo",
    "Device": "PowerRageEvo",
    "Model": "Power Rage Evo"
  },
  {
    "Retail Branding": "HighScreen",
    "Marketing Name": "Prime L",
    "Device": "PrimeL",
    "Model": "Prime L"
  },
  {
    "Retail Branding": "HighScreen",
    "Marketing Name": "Tasty",
    "Device": "Tasty",
    "Model": "Tasty"
  },
  {
    "Retail Branding": "High_Q",
    "Marketing Name": "ELT0704H",
    "Device": "ELT0704H",
    "Model": "ELT0704H"
  },
  {
    "Retail Branding": "High_Q",
    "Marketing Name": "ELT0704H9",
    "Device": "ELT0704H9",
    "Model": "ELT0704H9"
  },
  {
    "Retail Branding": "High_Q",
    "Marketing Name": "ELT0706H",
    "Device": "ELT0706H",
    "Model": "ELT0706H"
  },
  {
    "Retail Branding": "High_Q",
    "Marketing Name": "ELT0802H",
    "Device": "ELT0802H",
    "Model": "ELT0802H"
  },
  {
    "Retail Branding": "High_Q",
    "Marketing Name": "ELT0802H9",
    "Device": "ELT0802H9",
    "Model": "ELT0802H9"
  },
  {
    "Retail Branding": "High_Q",
    "Marketing Name": "ELT10101H9",
    "Device": "ELT10101H9",
    "Model": "ELT10101H9"
  },
  {
    "Retail Branding": "Hihi",
    "Marketing Name": "HIHI-40KH-TAB-01",
    "Device": "HIHI-40KH-TAB",
    "Model": "HIHI-40KH-TAB-01"
  },
  {
    "Retail Branding": "Hihi",
    "Marketing Name": "HIHI-41KH-TAB-1",
    "Device": "HIHI-41KH-TAB-1",
    "Model": "HIHI-41KH-TAB-1"
  },
  {
    "Retail Branding": "Hihi",
    "Marketing Name": "HIHI-41KH-TAB-1-EEA",
    "Device": "HIHI-41KH-TAB-1-EEA",
    "Model": "HIHI-41KH-TAB-1-EEA"
  },
  {
    "Retail Branding": "Hihi",
    "Marketing Name": "HIHI-50KH-TAB-01-EEA",
    "Device": "HIHI-50KH-TAB-01-EEA",
    "Model": "HIHI-50KH-TAB-1"
  },
  {
    "Retail Branding": "Hiking",
    "Marketing Name": "A19",
    "Device": "A19",
    "Model": "A19"
  },
  {
    "Retail Branding": "Hiking",
    "Marketing Name": "A20",
    "Device": "A20",
    "Model": "A20"
  },
  {
    "Retail Branding": "Hiking",
    "Marketing Name": "A21",
    "Device": "A21",
    "Model": "A21"
  },
  {
    "Retail Branding": "Hiking",
    "Marketing Name": "A22",
    "Device": "A22",
    "Model": "A22"
  },
  {
    "Retail Branding": "Hiking",
    "Marketing Name": "A23",
    "Device": "A23",
    "Model": "A23"
  },
  {
    "Retail Branding": "Hiking",
    "Marketing Name": "A26",
    "Device": "A26",
    "Model": "A26"
  },
  {
    "Retail Branding": "Hiking",
    "Marketing Name": "A27",
    "Device": "A27",
    "Model": "A27"
  },
  {
    "Retail Branding": "Hiking",
    "Marketing Name": "A28",
    "Device": "A28",
    "Model": "A28"
  },
  {
    "Retail Branding": "Hiking",
    "Marketing Name": "A30",
    "Device": "A30",
    "Model": "A30"
  },
  {
    "Retail Branding": "Hiking",
    "Marketing Name": "A40",
    "Device": "A40",
    "Model": "A40"
  },
  {
    "Retail Branding": "Hiking",
    "Marketing Name": "A42",
    "Device": "A42",
    "Model": "A42"
  },
  {
    "Retail Branding": "Hiking",
    "Marketing Name": "A43",
    "Device": "A43",
    "Model": "A43"
  },
  {
    "Retail Branding": "Hiking",
    "Marketing Name": "A44",
    "Device": "A44",
    "Model": "A44"
  },
  {
    "Retail Branding": "Hiking",
    "Marketing Name": "A45",
    "Device": "A45",
    "Model": "A45"
  },
  {
    "Retail Branding": "Hiking",
    "Marketing Name": "A46",
    "Device": "A46",
    "Model": "A46"
  },
  {
    "Retail Branding": "Hiking",
    "Marketing Name": "A47",
    "Device": "A42_A47",
    "Model": "A42_A47"
  },
  {
    "Retail Branding": "Hiking",
    "Marketing Name": "A48",
    "Device": "A43_A48",
    "Model": "A43_A48"
  },
  {
    "Retail Branding": "Hiking",
    "Marketing Name": "A49",
    "Device": "A49",
    "Model": "A49"
  },
  {
    "Retail Branding": "Hiking",
    "Marketing Name": "A51",
    "Device": "A51",
    "Model": "A51"
  },
  {
    "Retail Branding": "Hiking",
    "Marketing Name": "A52",
    "Device": "A52",
    "Model": "A52"
  },
  {
    "Retail Branding": "Hiking",
    "Marketing Name": "A55",
    "Device": "A55",
    "Model": "A55"
  },
  {
    "Retail Branding": "Hiking",
    "Marketing Name": "A56",
    "Device": "A56",
    "Model": "A56"
  },
  {
    "Retail Branding": "Hiking",
    "Marketing Name": "Fun5",
    "Device": "Fun5",
    "Model": "Fun5"
  },
  {
    "Retail Branding": "Hiking",
    "Marketing Name": "HIKING_A18",
    "Device": "HIKING_A18",
    "Model": "HIKING_A18"
  },
  {
    "Retail Branding": "Hiking",
    "Marketing Name": "HK-MH501",
    "Device": "HK-MH501",
    "Model": "HK-MH501"
  },
  {
    "Retail Branding": "Hiking",
    "Marketing Name": "KIDS_1",
    "Device": "KIDS_1",
    "Model": "KIDS_1"
  },
  {
    "Retail Branding": "Hiking",
    "Marketing Name": "P16_TU",
    "Device": "P16_TU",
    "Model": "P16"
  },
  {
    "Retail Branding": "Hiking",
    "Marketing Name": "P16_TU",
    "Device": "P16_TU",
    "Model": "P16_TU"
  },
  {
    "Retail Branding": "Hiking",
    "Marketing Name": "Rugged S2",
    "Device": "Rugged_S2",
    "Model": "Rugged S2"
  },
  {
    "Retail Branding": "Hiking",
    "Marketing Name": "Rugged_S1",
    "Device": "Rugged_S1",
    "Model": "Rugged S1"
  },
  {
    "Retail Branding": "Hillpos",
    "Marketing Name": "HT65",
    "Device": "HT65",
    "Model": "HT65"
  },
  {
    "Retail Branding": "Himax",
    "Marketing Name": "M21",
    "Device": "M21",
    "Model": "M21"
  },
  {
    "Retail Branding": "Himax",
    "Marketing Name": "M25i",
    "Device": "M25i",
    "Model": "M25i"
  },
  {
    "Retail Branding": "Hime TV",
    "Marketing Name": "PANZTE-0001",
    "Device": "HIME_B866V2FAS",
    "Model": "PANZTE-0001"
  },
  {
    "Retail Branding": "Hipstreet",
    "Marketing Name": "785TB4",
    "Device": "785TB4",
    "Model": "785TB4"
  },
  {
    "Retail Branding": "Hipstreet",
    "Marketing Name": "7DTB25",
    "Device": "7DTB25",
    "Model": "7DTB25"
  },
  {
    "Retail Branding": "Hipstreet",
    "Marketing Name": "7DTB37",
    "Device": "7DTB37",
    "Model": "7DTB37"
  },
  {
    "Retail Branding": "Hipstreet",
    "Marketing Name": "9DTB38",
    "Device": "9DTB38",
    "Model": "9DTB38"
  },
  {
    "Retail Branding": "Hipstreet",
    "Marketing Name": "9DTB39",
    "Device": "9DTB39",
    "Model": "9DTB39"
  },
  {
    "Retail Branding": "Hipstreet",
    "Marketing Name": "Beeline Smart 4",
    "Device": "Beeline_Smart_4",
    "Model": "Beeline Smart 4"
  },
  {
    "Retail Branding": "Hipstreet",
    "Marketing Name": "Beeline Smart 5",
    "Device": "Beeline_Smart_5",
    "Model": "Beeline Smart 5"
  },
  {
    "Retail Branding": "Hipstreet",
    "Marketing Name": "CP-VL5A",
    "Device": "CP-VL5A",
    "Model": "CP-VL5A"
  },
  {
    "Retail Branding": "Hipstreet",
    "Marketing Name": "ETAB_M7023G",
    "Device": "ETAB_M7023G",
    "Model": "ETAB_M7023G"
  },
  {
    "Retail Branding": "Hipstreet",
    "Marketing Name": "Electron",
    "Device": "8DTB38",
    "Model": "8DTB38"
  },
  {
    "Retail Branding": "Hipstreet",
    "Marketing Name": "Electron 2",
    "Device": "8DTB40",
    "Model": "8DTB40"
  },
  {
    "Retail Branding": "Hipstreet",
    "Marketing Name": "F100",
    "Device": "f100_65u",
    "Model": "f100_65u"
  },
  {
    "Retail Branding": "Hipstreet",
    "Marketing Name": "HS-10DTB12",
    "Device": "Hipstreet",
    "Model": "HS-10DTB12"
  },
  {
    "Retail Branding": "Hipstreet",
    "Marketing Name": "HS-10DTB12A",
    "Device": "10DTB12A",
    "Model": "10DTB12A"
  },
  {
    "Retail Branding": "Hipstreet",
    "Marketing Name": "HS-10DTB12A",
    "Device": "RCT6203W46",
    "Model": "HS_10DTB12A"
  },
  {
    "Retail Branding": "Hipstreet",
    "Marketing Name": "HS-10DTB41",
    "Device": "HS-10DTB41-8GB",
    "Model": "HS-10DTB41-8GB"
  },
  {
    "Retail Branding": "Hipstreet",
    "Marketing Name": "HS-10DTB8",
    "Device": "HS-10DTB8",
    "Model": "HS-10DTB8"
  },
  {
    "Retail Branding": "Hipstreet",
    "Marketing Name": "HS-7DTB27",
    "Device": "HS-7DTB27",
    "Model": "HS-7DTB27"
  },
  {
    "Retail Branding": "Hipstreet",
    "Marketing Name": "HS-7DTB35",
    "Device": "HS-7DTB35",
    "Model": "HS-7DTB35"
  },
  {
    "Retail Branding": "Hipstreet",
    "Marketing Name": "HS-7DTB35",
    "Device": "RCT6773W22",
    "Model": "HS_7DTB35"
  },
  {
    "Retail Branding": "Hipstreet",
    "Marketing Name": "HS-7DTB39",
    "Device": "HS-7DTB39",
    "Model": "HS-7DTB39"
  },
  {
    "Retail Branding": "Hipstreet",
    "Marketing Name": "HS-7DTB40",
    "Device": "HS-7DTB40-8GB",
    "Model": "HS-7DTB40-8GB"
  },
  {
    "Retail Branding": "Hipstreet",
    "Marketing Name": "HS-9DTB7A",
    "Device": "HS-9DTB7A",
    "Model": "HS-9DTB7A"
  },
  {
    "Retail Branding": "Hipstreet",
    "Marketing Name": "Joey Jet 2",
    "Device": "Joey_Jet_2",
    "Model": "Dtac phone Joey Jet 2"
  },
  {
    "Retail Branding": "Hipstreet",
    "Marketing Name": "LS-4004",
    "Device": "LS-4004",
    "Model": "LS-4004"
  },
  {
    "Retail Branding": "Hipstreet",
    "Marketing Name": "LS-5013",
    "Device": "LS-5013",
    "Model": "LS-5013"
  },
  {
    "Retail Branding": "Hipstreet",
    "Marketing Name": "LS-5017",
    "Device": "LS-5017",
    "Model": "LS-5017"
  },
  {
    "Retail Branding": "Hipstreet",
    "Marketing Name": "LS-5507",
    "Device": "LYF_LS_5507",
    "Model": "LS-5507"
  },
  {
    "Retail Branding": "Hipstreet",
    "Marketing Name": "LS-6001",
    "Device": "LS-6001",
    "Model": "LS-6001"
  },
  {
    "Retail Branding": "Hipstreet",
    "Marketing Name": "Micron",
    "Device": "7DTB41",
    "Model": "7DTB41"
  },
  {
    "Retail Branding": "Hipstreet",
    "Marketing Name": "Nanho T775",
    "Device": "Nanho_T775",
    "Model": "Nanho_T775"
  },
  {
    "Retail Branding": "Hipstreet",
    "Marketing Name": "Phantom",
    "Device": "Phantom",
    "Model": "10DTB10"
  },
  {
    "Retail Branding": "Hipstreet",
    "Marketing Name": "Phantom2",
    "Device": "10DTB44",
    "Model": "10DTB44"
  },
  {
    "Retail Branding": "Hipstreet",
    "Marketing Name": "Phoenix2",
    "Device": "Phoenix2",
    "Model": "Phoenix2"
  },
  {
    "Retail Branding": "Hipstreet",
    "Marketing Name": "Pilot",
    "Device": "10DTB42",
    "Model": "10DTB42"
  },
  {
    "Retail Branding": "Hipstreet",
    "Marketing Name": "Synergy",
    "Device": "11DTB1",
    "Model": "11DTB1"
  },
  {
    "Retail Branding": "Hipstreet",
    "Marketing Name": "TITAN X",
    "Device": "TitanX",
    "Model": "TitanX"
  },
  {
    "Retail Branding": "Hipstreet",
    "Marketing Name": "Yupiroid",
    "Device": "Yupiroid",
    "Model": "Yupiroid"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "",
    "Device": "AD683G",
    "Model": "AD683G"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "",
    "Device": "AD685G",
    "Model": "New Andromax-i"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "",
    "Device": "E820",
    "Model": "HS-E820"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "",
    "Device": "E910",
    "Model": "E910"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "",
    "Device": "E910",
    "Model": "HS-E910"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "",
    "Device": "E912",
    "Model": "HS-E912"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "",
    "Device": "E912S",
    "Model": "HS-E912S"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "",
    "Device": "E920",
    "Model": "HS-E920"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "",
    "Device": "E926",
    "Model": "E926"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "",
    "Device": "E930",
    "Model": "HS-E930"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "",
    "Device": "E956",
    "Model": "HS-E956"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "",
    "Device": "E956Q",
    "Model": "HS-E956Q"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "",
    "Device": "EG870",
    "Model": "HS-EG870"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "",
    "Device": "EG876",
    "Model": "HS-EG876"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "",
    "Device": "EG901",
    "Model": "HS-EG901"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "",
    "Device": "EG909",
    "Model": "HS-EG909"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "",
    "Device": "EG950",
    "Model": "HS-EG950"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "",
    "Device": "EG970",
    "Model": "HS-EG970"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "",
    "Device": "P4013",
    "Model": "MEDION-P4013"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "",
    "Device": "SIMPlus",
    "Model": "MegaFon SIM+"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "",
    "Device": "T818",
    "Model": "HS-T818"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "",
    "Device": "TP9101",
    "Model": "HS-M170AT"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "",
    "Device": "TP9102",
    "Model": "M1101AT"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "",
    "Device": "U2",
    "Model": "U2"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "",
    "Device": "U8",
    "Model": "HS-U8"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "",
    "Device": "U820",
    "Model": "HS-U820"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "",
    "Device": "U820A",
    "Model": "HS-U820"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "",
    "Device": "U820A",
    "Model": "U1+"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "",
    "Device": "U820AVN",
    "Model": "HS-U820"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "",
    "Device": "U860",
    "Model": "HS-U860"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "",
    "Device": "U909",
    "Model": "HS-U909"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "",
    "Device": "U909B",
    "Model": "HS-U909B"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "",
    "Device": "U909B_6",
    "Model": "HS-U909"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "",
    "Device": "U909B_MN",
    "Model": "U2S"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "",
    "Device": "U912",
    "Model": "HS-U912"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "",
    "Device": "U950",
    "Model": "HS-U950"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "",
    "Device": "U950_6",
    "Model": "HS-U950"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "",
    "Device": "U950_MN",
    "Model": "U3"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "",
    "Device": "U950_ae",
    "Model": "HS-U950"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "",
    "Device": "U958",
    "Model": "HS-U958"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "",
    "Device": "U960Q",
    "Model": "HS-U960Q"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "",
    "Device": "W2400",
    "Model": "W2400"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "",
    "Device": "m3101",
    "Model": "M3101BW"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "",
    "Device": "m370",
    "Model": "M370BW"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "",
    "Device": "t909",
    "Model": "HS-T909"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "",
    "Device": "t950",
    "Model": "HS-T950"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "",
    "Device": "t958",
    "Model": "HS-T958"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "",
    "Device": "t960",
    "Model": "HS-T960"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "2K TV",
    "Device": "songshan",
    "Model": "2K Smart TV"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "32S6S",
    "Device": "Granite",
    "Model": "FollowMe"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "4K TV",
    "Device": "songshan",
    "Model": "Smart TV"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "4K TV",
    "Device": "songshan",
    "Model": "SmartTV 4K"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "4K TV",
    "Device": "songshan",
    "Model": "SmartTV 4K FFM"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "55H6SG",
    "Device": "Vision",
    "Model": "Vision"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "700T",
    "Device": "HSSDM660QC",
    "Model": "HLTE700T"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": 9980,
    "Device": "taishan",
    "Model": "SmartTV 8K FFM"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "A2",
    "Device": "HS8937QC",
    "Model": "Hisense A2"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "A2M",
    "Device": "HS8953QC",
    "Model": "Hisense A2M"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "A2T",
    "Device": "HS8953QC",
    "Model": "Hisense A2T"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "A5",
    "Device": "HLTE202N",
    "Model": "HLTE202N"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "A5 Pro",
    "Device": "HLTE203T",
    "Model": "HLTE203T"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "A6L",
    "Device": "HLTE730T",
    "Model": "HLTE730T"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "AGM  X2",
    "Device": "HS8976QC",
    "Model": "AGM X2"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "AGM  X2",
    "Device": "HS8976QC",
    "Model": "X2 SE"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "AGM  X2",
    "Device": "HS8976QC",
    "Model": "X2_SE"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "AGM A7",
    "Device": "HS8909QC",
    "Model": "AGM A7"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "AGM X1",
    "Device": "HS8952QC",
    "Model": "AGM X1"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "AGM X3",
    "Device": "HSSDM845QC",
    "Model": "AGM X3"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "AJM X2",
    "Device": "HS8976QC",
    "Model": "AGM X2"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Andromax-c",
    "Device": "AD686G",
    "Model": "Andromax-c"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "C-4",
    "Device": "C_4",
    "Model": "C-4"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "C1",
    "Device": "HS8929QC",
    "Model": "Hisense C1"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "C1AE",
    "Device": "HS8929QC",
    "Model": "Hisense C1"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "C1AE-1",
    "Device": "HS8929QC",
    "Model": "Hisense C1"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "C1AE-2",
    "Device": "HS8929QC",
    "Model": "Hisense C1"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "C1BE",
    "Device": "HS8929QC",
    "Model": "Hisense C1"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "C1M",
    "Device": "HS8929QC",
    "Model": "Hisense C1M"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "C1T",
    "Device": "HS8929QC",
    "Model": "Hisense C1T"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "C20F",
    "Device": "HS8929QC",
    "Model": "Hisense C20"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "C20FE-1",
    "Device": "HS8929QC",
    "Model": "Hisense C20"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "C20S",
    "Device": "C20S",
    "Model": "Hisense C20S"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "C20W",
    "Device": "HS8929QC",
    "Model": "Hisense C20"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "C30",
    "Device": "HS8937QC",
    "Model": "Hisense C30"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "C30",
    "Device": "HS8937QC",
    "Model": "Hisense C30_02"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "C30 Lite",
    "Device": "HS6737MT",
    "Model": "Hisense C30 Lite"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "C30 Lite",
    "Device": "HS6737MT",
    "Model": "STARACTIVE 2"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "C30 Lite",
    "Device": "HS6737MT",
    "Model": "SX40"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "CMB405",
    "Device": "L690AE",
    "Model": "CMB405"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "CMB501",
    "Device": "u970_carrefour",
    "Model": "CMB501"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "CMB510",
    "Device": "L696",
    "Model": "CMB510"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "D1-M",
    "Device": "D1_M",
    "Model": "Hisense D1-M"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "D2-M",
    "Device": "HS6735MT",
    "Model": "D2-M"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "D5",
    "Device": "HS8909QC",
    "Model": "Hisense D5"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "E10",
    "Device": "HS8909QC",
    "Model": "E10"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "E100T",
    "Device": "E100T",
    "Model": "Hisense E100T"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "E100TAE",
    "Device": "E100TAE",
    "Model": "LT-W1"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "E200T",
    "Device": "E200T",
    "Model": "HS-E200T"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "E2070",
    "Device": "mt8312",
    "Model": "E2070"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "E20T",
    "Device": "HS8952QC",
    "Model": "Hisense E20T"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "E22",
    "Device": "HITV102C",
    "Model": "HITV102C"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "E23",
    "Device": "HITV103C",
    "Model": "HITV103C"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "E2371CH",
    "Device": "rk3026",
    "Model": "E2371CH"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "E260T",
    "Device": "E260T",
    "Model": "HS-E260T"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "E260U",
    "Device": "E260U",
    "Model": "Hisense E260U"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "E270BSA",
    "Device": "E270BSA",
    "Model": "E270BSA"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "E30",
    "Device": "HITV200C",
    "Model": "HITV200C"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "E30",
    "Device": "HITV201C",
    "Model": "HITV201C"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "E360M",
    "Device": "e360m",
    "Model": "Hisense E360M"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "E50-T",
    "Device": "HS8909QC",
    "Model": "Hisense E50-T"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "E51-F",
    "Device": "HS8909QC",
    "Model": "Hisense E51"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "E51-M",
    "Device": "HS8909QC",
    "Model": "Hisense E51-M"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "E51-W",
    "Device": "HS8909QC",
    "Model": "Hisense E51"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "E600MH02",
    "Device": "E600MH02",
    "Model": "HS-E600M"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "E601M",
    "Device": "E601M",
    "Model": "E601M"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "E602T",
    "Device": "E602T",
    "Model": "Hisense E602T"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "E613M",
    "Device": "E613M",
    "Model": "Hisense E613M"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "E620M",
    "Device": "E602M",
    "Model": "Hisense E602M"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "E621T",
    "Device": "E621T",
    "Model": "Hisense E621T"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "E622M",
    "Device": "E622M",
    "Model": "Hisense E622M"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "E625T",
    "Device": "E625T",
    "Model": "Hisense E625T"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "E70-T",
    "Device": "HS8929QC",
    "Model": "Hisense E70-T"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "E71-M",
    "Device": "HS8929QC",
    "Model": "Hisense E71-M"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "E71-T",
    "Device": "HS8929QC",
    "Model": "Hisense E71-T"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "E75M",
    "Device": "HS8929QC",
    "Model": "Hisense E75M"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "E75T",
    "Device": "HS8929QC",
    "Model": "Hisense E75T"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "E76",
    "Device": "HS8937QC",
    "Model": "Hisense E76"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "E76E_11",
    "Device": "HS8937QC",
    "Model": "Hisense E76"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "E77M",
    "Device": "HS8937QC",
    "Model": "Hisense E77M"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "E77MINI",
    "Device": "HS8937QC",
    "Model": "Hisense E77MINI"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "E860",
    "Device": "E860",
    "Model": "E860"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "E9",
    "Device": "HS8937QC",
    "Model": "Hisense E9"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "EG606",
    "Device": "EG606_TW",
    "Model": "EG606"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "EG680",
    "Device": "eg980ae",
    "Model": "EG680"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "EG68AE",
    "Device": "EG668AE",
    "Model": "LT668"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "EG929",
    "Device": "EG929_TW",
    "Model": "EG929"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "EG936D",
    "Device": "EG936D",
    "Model": "HS-EG936D"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "EG950",
    "Device": "EG950TW",
    "Model": "EG950"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "EG970",
    "Device": "EG970TW",
    "Model": "EG970"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "EG978",
    "Device": "EG978",
    "Model": "HS-EG978"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "EG98",
    "Device": "EG98",
    "Model": "EG98"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "EG98",
    "Device": "EG98TW",
    "Model": "EG98"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "EG981",
    "Device": "EG981",
    "Model": "HS-EG981"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Emeishanph",
    "Device": "hirano",
    "Model": "Hisense TV"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "F10",
    "Device": "HS6737MT",
    "Model": "BM001"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "F10",
    "Device": "HS6737MT",
    "Model": "Hisense F10"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "F10",
    "Device": "HS6737MT",
    "Model": "Hisense L675 PRO"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "F10",
    "Device": "HS6737MT",
    "Model": "Hisense L675 Pro"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "F10",
    "Device": "HS6737MT",
    "Model": "RIVIERA F10"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "F102",
    "Device": "HS6737MT",
    "Model": "Hisense F102"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "F102",
    "Device": "HS6737MT",
    "Model": "Hisense Hi 3"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "F20",
    "Device": "HS8909QC",
    "Model": "F20"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "F20",
    "Device": "HS8909QC",
    "Model": "Hisense F20"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "F20T",
    "Device": "HS8909QC",
    "Model": "Hisense F20T"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "F21T",
    "Device": "HS8909QC",
    "Model": "Hisense F21T"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "F22",
    "Device": "HS6737MT",
    "Model": "F22"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "F22",
    "Device": "HS6737MT",
    "Model": "Hisense F22"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "F22",
    "Device": "HS8917QC",
    "Model": "Hisense F22"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "F22M",
    "Device": "HS8917QC",
    "Model": "Hisense F22M"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "F23",
    "Device": "HS6737MT",
    "Model": "Hisense F23"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "F23",
    "Device": "HS6737MT",
    "Model": "Hisense T203"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "F23",
    "Device": "HS6737MT",
    "Model": "RIVIERA F23"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "F23",
    "Device": "HS8917QC",
    "Model": "Hisense F23"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "F23M",
    "Device": "HS8917QC",
    "Model": "Hisense F23M"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "F270BW",
    "Device": "F270BW",
    "Model": "F270BW"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "F30",
    "Device": "HS6735MT",
    "Model": "F30"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "F30",
    "Device": "HS6735MT",
    "Model": "Hisense F30"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "F31",
    "Device": "HS8937QC",
    "Model": "Hisense F31"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "F31E_11",
    "Device": "HS8937QC",
    "Model": "Hisense F31"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "F31M",
    "Device": "HS8937QC",
    "Model": "Hisense F31M"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "F32",
    "Device": "HS8937QC",
    "Model": "Hisense F32"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "F50+",
    "Device": "HNR551T",
    "Model": "HNR551T"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "F5070",
    "Device": "mt8389",
    "Model": "F5070"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "F5180",
    "Device": "f5180",
    "Model": "F5180"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "F5281CH",
    "Device": "rk3288",
    "Model": "F5281CH"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "G1",
    "Device": "G1",
    "Model": "G1"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "G2-3GP",
    "Device": "G2-3GP",
    "Model": "G2-3GP"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "G610M",
    "Device": "G610M",
    "Model": "Hisense G610M"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Goboard Series",
    "Device": "changjiang",
    "Model": "HIDB 4K"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Goboard Series",
    "Device": "huaihe",
    "Model": "HIDB 4K"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Goboard Series",
    "Device": "huanghe",
    "Model": "HIDB 4K"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "H5500F",
    "Device": "harajuku",
    "Model": "HiSmart 2K ATV4"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "H800T",
    "Device": "H800T",
    "Model": "HS-H800T"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "H910",
    "Device": "HS8929QC",
    "Model": "Hisense H910"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "H910",
    "Device": "HS8939QC",
    "Model": "Hisense H910"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "H910-F01",
    "Device": "HS8939QC",
    "Model": "Hisense H910"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "HITV101C",
    "Device": "HITV101C",
    "Model": "HITV101C"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "HITV105C",
    "Device": "HITV105C",
    "Model": "HITV105C"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "HITV300C",
    "Device": "HS8937QC",
    "Model": "HITV300C"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "HITV512C",
    "Device": "HSSDA450QC",
    "Model": "HITV512C"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "HLTE100M",
    "Device": "HS9850SC",
    "Model": "HLTE100M"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "HLTE200M",
    "Device": "HS8917QC",
    "Model": "HLTE200M"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "HLTE200T",
    "Device": "HS8917QC",
    "Model": "HLTE200T"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "HLTE210T",
    "Device": "HS8937QC",
    "Model": "HLTE210T"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "HLTE212T",
    "Device": "HS8917QC",
    "Model": "HLTE212T"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "HLTE213T",
    "Device": "HSSDM439QC",
    "Model": "HLTE213T"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "HLTE229E",
    "Device": "HLTE229E_01",
    "Model": "HLTE229E"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "HLTE229E",
    "Device": "HLTE229E_01",
    "Model": "Hisense E40"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "HLTE230E",
    "Device": "SC9863A",
    "Model": "Hisense Infinity H40 Lite"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "HLTE243E",
    "Device": "",
    "Model": "Hisense U43"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "HLTE243E",
    "Device": "HLTE243E",
    "Model": "Hisense E33"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "HLTE243E",
    "Device": "HLTE243E",
    "Model": "Hisense E34"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "HLTE243E",
    "Device": "HLTE243E",
    "Model": "Hisense E35"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "HLTE243E",
    "Device": "HLTE243E",
    "Model": "Hisense F35 Pro"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "HLTE243E",
    "Device": "HLTE243E",
    "Model": "Hisense M50"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "HLTE243E",
    "Device": "HLTE243E",
    "Model": "Hisense M72 Pro"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "HLTE243E",
    "Device": "HLTE243E",
    "Model": "Hisense T1 Pro"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "HLTE243E",
    "Device": "HLTE243E",
    "Model": "Hisense T2 Pro"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "HLTE243E",
    "Device": "HLTE243E",
    "Model": "Hisense T3"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "HLTE243E",
    "Device": "HLTE243E",
    "Model": "Hisense T55"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "HLTE243E",
    "Device": "HLTE243E",
    "Model": "Hisense U43"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "HLTE243E",
    "Device": "HLTE243E",
    "Model": "Hisense U967"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "HLTE243E",
    "Device": "HLTE243E",
    "Model": "Hisense Y83 Pro"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "HLTE300E_ 02",
    "Device": "HS8937QC",
    "Model": "HLTE300E"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "HLTE300E_ 02",
    "Device": "HS8937QC",
    "Model": "HLTE300E_02"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "HLTE300E_ 02",
    "Device": "HS8937QC",
    "Model": "Hisense Infinity H11"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "HLTE300T",
    "Device": "HS8937QC",
    "Model": "HLTE300T"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "HLTE310M",
    "Device": "HSSDM450QC",
    "Model": "HLTE310M"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "HLTE310T",
    "Device": "HSSDM450QC",
    "Model": "HLTE310T"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "HLTE311T",
    "Device": "HSSDM636QC",
    "Model": "HLTE311T"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "HLTE500T",
    "Device": "HSSDM630QC",
    "Model": "HLTE500T"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "HLTE501N",
    "Device": "HSSDM660QC",
    "Model": "HLTE501N"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "HLTE510M",
    "Device": "HSSDM636QC",
    "Model": "HLTE510M"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "HNR550T",
    "Device": "HNR550T",
    "Model": "HNR550T"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "HS- G610",
    "Device": "HS8916QC",
    "Model": "HS-G610"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "HS- L682",
    "Device": "HS8916QC",
    "Model": "HS-L682"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "HS-E600M",
    "Device": "E600M",
    "Model": "HS-E600M"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "HS-E620M",
    "Device": "E620M",
    "Model": "HS-E620M"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "HS-E917",
    "Device": "E917",
    "Model": "HS-E917"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "HS-E936",
    "Device": "E936",
    "Model": "HS-E936"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "HS-E968",
    "Device": "E968",
    "Model": "HS-E968"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "HS-EG916",
    "Device": "EG916",
    "Model": "HS-EG916"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "HS-EG929",
    "Device": "EG929",
    "Model": "HS-EG929"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "HS-EG929",
    "Device": "EG929",
    "Model": "msm8625"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "HS-EG939",
    "Device": "EG939",
    "Model": "HS-EG939"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "HS-EG958",
    "Device": "EG958",
    "Model": "HS-EG958"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "HS-EG966",
    "Device": "EG966",
    "Model": "HS-EG966"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "HS-EG971",
    "Device": "EG971",
    "Model": "HS-EG971"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "HS-EG980",
    "Device": "eg980",
    "Model": "HS-EG980"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "HS-EG98C",
    "Device": "EG98C",
    "Model": "HS-EG98C"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "HS-G610",
    "Device": "HS8916QC",
    "Model": "HS-G610"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "HS-I630M",
    "Device": "msm8226",
    "Model": "HS-I630M"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "HS-I630T",
    "Device": "msm8226",
    "Model": "HS-I630T"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "HS-T9",
    "Device": "T9",
    "Model": "HS-T9"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "HS-T926",
    "Device": "t926",
    "Model": "HS-T926"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "HS-T928",
    "Device": "t928",
    "Model": "HS-T928"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "HS-T939",
    "Device": "HS-T939",
    "Model": "HS-T939"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "HS-T959",
    "Device": "t959",
    "Model": "HS-T959"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "HS-T959S",
    "Device": "t959s",
    "Model": "HS-T959S"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "HS-T959S1",
    "Device": "t959s1",
    "Model": "HS-T959S1"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "HS-T966",
    "Device": "HS-T966",
    "Model": "HS-T966"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "HS-T967",
    "Device": "HS-T967",
    "Model": "HS-T967"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "HS-T968",
    "Device": "t968",
    "Model": "HS-T968"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "HS-T968S",
    "Device": "t968s",
    "Model": "HS-T968S"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "HS-T970",
    "Device": "t970",
    "Model": "HS-T970"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "HS-T978",
    "Device": "t978",
    "Model": "HS-T978"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "HS-T980",
    "Device": "t980",
    "Model": "HS-T980"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "HS-U601",
    "Device": "HS7731SP",
    "Model": "HS-U601"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "HS-U820",
    "Device": "U820B",
    "Model": "HS-U820"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "HS-U9",
    "Device": "U9",
    "Model": "HS-U9"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "HS-U912",
    "Device": "U912A_1",
    "Model": "HS-U912"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "HS-U912",
    "Device": "U912B",
    "Model": "HS-U912"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "HS-U912",
    "Device": "U912C",
    "Model": "HS-U912"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "HS-U929",
    "Device": "u929de",
    "Model": "HS-U929"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "HS-U929",
    "Device": "u929de_3",
    "Model": "HS-U929"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "HS-U936",
    "Device": "U936",
    "Model": "HS-U936"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "HS-U939",
    "Device": "u939",
    "Model": "HS-U939"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "HS-U939",
    "Device": "u939e_1",
    "Model": "HS-U939"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "HS-U939",
    "Device": "u939e_3",
    "Model": "HS-U939"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "HS-U939",
    "Device": "u939e_4",
    "Model": "HS-U939"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "HS-U939",
    "Device": "u939e_5",
    "Model": "HS-U939"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "HS-U950",
    "Device": "U950_5",
    "Model": "HS-U950"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "HS-U961",
    "Device": "HS6572MT",
    "Model": "HS-U961"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "HS-U961",
    "Device": "u961",
    "Model": "HS-U961"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "HS-U961",
    "Device": "u961e_1",
    "Model": "HS-U961"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "HS-U966",
    "Device": "u966",
    "Model": "HS-U966"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "HS-U966",
    "Device": "u966ae",
    "Model": "HS-U966"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "HS-U970",
    "Device": "u970e_6",
    "Model": "HS-U970"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "HS-U970",
    "Device": "u970s_export",
    "Model": "HS-U970"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "HS-U970E",
    "Device": "u970t",
    "Model": "HS-U970E"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "HS-U971",
    "Device": "U971AE",
    "Model": "HS-U971"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "HS-U978",
    "Device": "u978",
    "Model": "HS-U978"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "HS-U98",
    "Device": "U98",
    "Model": "U98"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "HS-U98",
    "Device": "U98_FR",
    "Model": "HS-U98"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "HS-U980",
    "Device": "u980",
    "Model": "HS-U980"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "HS-U980",
    "Device": "u980b",
    "Model": "HS-U980"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "HS-U980",
    "Device": "u980be",
    "Model": "HS-U980"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "HS-U980",
    "Device": "u980be_1",
    "Model": "HS-U980"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "HS-U980",
    "Device": "u980be_2",
    "Model": "HS-U980"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "HS-U980",
    "Device": "u980ce_1",
    "Model": "HS-U980"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "HS-U980",
    "Device": "u980ce_3",
    "Model": "HS-U980"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "HS-U980",
    "Device": "u980ce_4",
    "Model": "HS-U980"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "HS-U980",
    "Device": "u980ce_5",
    "Model": "HS-U980"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "HS-X5T",
    "Device": "X5T",
    "Model": "HS-X5T"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "HS-X68T",
    "Device": "x68t",
    "Model": "HS-X68T"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "HS-X6T",
    "Device": "X6T",
    "Model": "HS-X6T"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "HS-X8C",
    "Device": "x8c",
    "Model": "HS-X8C"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "HS-X8T",
    "Device": "X8T",
    "Model": "HS-X8T"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "HS-X8U",
    "Device": "x8u",
    "Model": "HS-X8U"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense  E7  Pro",
    "Device": "HS6739MT",
    "Model": "Hisense E7 Pro"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense  E7  Pro",
    "Device": "HS6739MT",
    "Model": "Hisense F17 Pro"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense  F17  Pro",
    "Device": "HS6739MT",
    "Model": "Hisense F17 Pro"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense  F23  PLUS",
    "Device": "HS6739MT",
    "Model": "Hisense F23 PLUS"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense  Hi  2",
    "Device": "HS6737MT",
    "Model": "Hisense Hi 2"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense  Infinity  F17",
    "Device": "HS6739MT",
    "Model": "Hisense Infinity F17"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense  Infinity  H12",
    "Device": "HSSDM450QC",
    "Model": "Hisense H12"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense  Infinity  H12",
    "Device": "HSSDM450QC",
    "Model": "Hisense Infinity H12"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense E MAX",
    "Device": "SC9863A_RU",
    "Model": "Hisense E MAX"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense E20",
    "Device": "HLTE103E_20",
    "Model": "HLTE103E"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense E20",
    "Device": "HLTE103E_21",
    "Model": "Hisense E20"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense E20",
    "Device": "HLTE103E_22",
    "Model": "Hisense E20"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense E20",
    "Device": "HLTE103E_23",
    "Model": "Hisense E20"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense E20",
    "Device": "HLTE103E_24",
    "Model": "HLTE103E E20"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense E20",
    "Device": "HLTE103E_24",
    "Model": "Hisense E20"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense E20S",
    "Device": "HLTE103E_40",
    "Model": "Hisense E20s"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense E20s",
    "Device": "HLTE103E_41",
    "Model": "Hisense E20s"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense E30",
    "Device": "HS6763MT",
    "Model": "HLTE220E"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense E30",
    "Device": "HS6763MT",
    "Model": "Hisense E30"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense E30",
    "Device": "HS6763MT",
    "Model": "Hisense Infinity E30"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense E31 Lite",
    "Device": "HLTE105E",
    "Model": "Hisense E31 Lite"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense E31 Lite",
    "Device": "HLTE105E_02",
    "Model": "Hisense E31 Lite"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense E31 Lite",
    "Device": "HLTE105E_03",
    "Model": "Hisense E31 Lite"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense E33",
    "Device": "HLTE243E_01",
    "Model": "Hisense E33"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense E40",
    "Device": "HLTE229E",
    "Model": "HLTE229E"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense E40",
    "Device": "HLTE229E",
    "Model": "Hisense E40"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense E40",
    "Device": "HLTE229E_10",
    "Model": "HLTE229E"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense E40",
    "Device": "HLTE229E_10",
    "Model": "Hisense E40"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense E40",
    "Device": "HLTE229E_11",
    "Model": "HLTE229E"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense E40",
    "Device": "HLTE229E_11",
    "Model": "Hisense E40"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense E40",
    "Device": "HLTE229E_12",
    "Model": "HLTE229E"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense E40",
    "Device": "HLTE229E_12",
    "Model": "Hisense V40"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense E50",
    "Device": "HLTE232E",
    "Model": "Hisense E50"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense E50",
    "Device": "HLTE232E_01",
    "Model": "Hisense E50"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense E50",
    "Device": "HLTE232E_02",
    "Model": "Hisense E50"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense E50",
    "Device": "HLTE232E_10",
    "Model": "Hisense E50"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense E50",
    "Device": "HLTE232E_11",
    "Model": "Hisense E50"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense E50",
    "Device": "HLTE232E_12",
    "Model": "Hisense E50"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense E50",
    "Device": "HLTE232E_20",
    "Model": "Hisense E50 128G"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense E50 128G",
    "Device": "HLTE232E_21",
    "Model": "Hisense E50 128G"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense E50 Lite",
    "Device": "HLTE228E",
    "Model": "Hisense E50 Lite"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense E50 Lite",
    "Device": "HLTE228E_01",
    "Model": "Hisense E50 Lite"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense E50 Lite",
    "Device": "HLTE228E_02",
    "Model": "Hisense E50 Lite"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense E50 Lite",
    "Device": "HLTE228E_10",
    "Model": "Hisense E50 Lite"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense E50 Lite",
    "Device": "HLTE228E_11",
    "Model": "Hisense E50 Lite"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense E50 Lite",
    "Device": "HLTE228E_12",
    "Model": "Hisense E50 Lite"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense E50 Lite",
    "Device": "HLTE228E_14",
    "Model": "Hisense E50 Lite"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense E50 Lite 64G",
    "Device": "HLTE228E_20",
    "Model": "Hisense E50 Lite 64GB"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense E50 Lite 64G",
    "Device": "HLTE228E_21",
    "Model": "Hisense E50 Lite 64GB"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense E50 Lite 64GB",
    "Device": "HLTE228E_22",
    "Model": "Hisense E50 Lite 64GB"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense E60 Lite",
    "Device": "HLTE235E",
    "Model": "Hisense E60 Lite"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense E60 Lite",
    "Device": "HLTE235E_12",
    "Model": "Hisense E60 Lite"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense E60 Lite",
    "Device": "HLTE235E_20",
    "Model": "Hisense E60 Lite"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense E70",
    "Device": "HLTE262E",
    "Model": "Hisense E70"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense E70",
    "Device": "HLTE262E_01",
    "Model": "Hisense E70"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense E70 Pro",
    "Device": "HLTE263E",
    "Model": "Hisense E70 Pro"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense E76MINIM",
    "Device": "HS8937QC",
    "Model": "Hisense E76MINIM"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense E77",
    "Device": "HS8937QC",
    "Model": "Hisense E77"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense Enigma",
    "Device": "HLTE272E",
    "Model": "Hisense Enigma"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense Enigma",
    "Device": "HLTE272E",
    "Model": "Hisense Enigma SE"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense F15",
    "Device": "HS6739MT",
    "Model": "Hisense F15"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense F16",
    "Device": "HS6739MT",
    "Model": "Hisense F16"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense F16",
    "Device": "HS6739MT",
    "Model": "Hisense Infinity E6"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense F16",
    "Device": "SC9863A",
    "Model": "HLTE221E.20"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense F16",
    "Device": "SC9863A",
    "Model": "Hisense F16"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense F17",
    "Device": "HS6580MT",
    "Model": "Hisense F17"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense F17",
    "Device": "HS6580MT",
    "Model": "Hisense Infinity E7"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense F18",
    "Device": "HS6739MT",
    "Model": "Hisense F18"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense F19",
    "Device": "SC9863A",
    "Model": "HLTE223E"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense F19",
    "Device": "SC9863A",
    "Model": "HLTE223E.40"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense F19",
    "Device": "SC9863A",
    "Model": "Hisense E40 Lite"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense F19",
    "Device": "SC9863A",
    "Model": "Hisense F19"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense F24",
    "Device": "HS6737MT",
    "Model": "Hisense F24"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense F27",
    "Device": "HS6739MT",
    "Model": "Hisense F27"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense F28M",
    "Device": "HS8937QC",
    "Model": "HLTE210M"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense F35",
    "Device": "HS6739MT",
    "Model": "Hisense F28"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense F35",
    "Device": "HS6739MT",
    "Model": "Hisense F35"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense F72 Pro",
    "Device": "HLTE268E_10",
    "Model": "Hisense F72 Pro"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense F8 MINI",
    "Device": "HSSC9850",
    "Model": "Hisense F8 MINI"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense H20",
    "Device": "HSSDM636QC",
    "Model": "HLTE510T"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense H30",
    "Device": "HLTE315E",
    "Model": "Hisense H30"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense H30",
    "Device": "HLTE315E",
    "Model": "Hisense Infinity H30"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense H40",
    "Device": "HLTE321E",
    "Model": "Hisense H40"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense H40",
    "Device": "HLTE321E",
    "Model": "Hisense Infinity H40"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense H40 Lite",
    "Device": "SC9863A",
    "Model": "HLTE230E"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense H40 Lite",
    "Device": "SC9863A",
    "Model": "Hisense H40 Lite"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense H50 Lite",
    "Device": "HLTE233E_12",
    "Model": "Hisense H50 Lite"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense H60 Smart",
    "Device": "HLTE240E",
    "Model": "Hisense H60 Smart"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense Infinity E30 Lite",
    "Device": "SC9832E",
    "Model": "Hisense Infinity E30 Lite"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense Infinity H12 Pro",
    "Device": "HSSDM636QC",
    "Model": "Hisense Infinity H12 Pro"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense Infinity H40 Lite",
    "Device": "HLTE230E_01",
    "Model": "HLTE230E_01"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense Infinity H40 Lite",
    "Device": "HLTE230E_01",
    "Model": "Hisense Infinity H40 Lite"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense Infinity H40 Lite",
    "Device": "HLTE230E_20",
    "Model": "Hisense Infinity H40 Lite"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense Infinity H50",
    "Device": "HLTE322E",
    "Model": "Hisense H50"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense Infinity H50",
    "Device": "HLTE322E",
    "Model": "Hisense Infinity H50"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense Infinity H50 Lite",
    "Device": "HLTE233E",
    "Model": "Hisense Infinity H50 Lite"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense Infinity H50 Lite",
    "Device": "HLTE233E_01",
    "Model": "Hisense Infinity H50 Lite"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense Infinity H50 ZOOM",
    "Device": "HLTE234E",
    "Model": "Hisense Infinity H50 ZOOM"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense Infinity H50S 5G",
    "Device": "HNR500E",
    "Model": "Hisense Infinity H50S 5G"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense Infinity H50S 5G",
    "Device": "HNR500E_02",
    "Model": "Hisense Infinity H50S 5G"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense Infinity H50S 5G",
    "Device": "HNR500E_03",
    "Model": "Hisense Infinity H50S 5G"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense Infinity H60 5G",
    "Device": "HNR510E",
    "Model": "Hisense Infinity H60 5G"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense Infinity H72 Pro",
    "Device": "HLTE271E",
    "Model": "Hisense H73"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense Infinity H72 Pro",
    "Device": "HLTE271E",
    "Model": "Hisense Infinity H72 Pro"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense M36",
    "Device": "HS8909QC",
    "Model": "Hisense M36"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense M51",
    "Device": "HLTE115E",
    "Model": "Hisense M51"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense P1",
    "Device": "HS8953QC",
    "Model": "Hisense P1"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense T17",
    "Device": "HS6580MT",
    "Model": "Hisense T17"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense T5",
    "Device": "HS6737MT",
    "Model": "Hisense T5"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense T5 Pro",
    "Device": "HS6737MT",
    "Model": "Hisense T5 Pro"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense T965",
    "Device": "HS6580MT",
    "Model": "Hisense T965"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense TV",
    "Device": "hirano",
    "Model": "Hisense TV"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense TV HK",
    "Device": "hirano",
    "Model": "Hisense TV HK"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense U3 2021",
    "Device": "HLTE100E_20",
    "Model": "Hisense U3 2021"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense U3 2021",
    "Device": "HLTE100E_21",
    "Model": "Hisense U3 2021"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense U3 2021",
    "Device": "HLTE100E_22",
    "Model": "Hisense U3 2021"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense U30",
    "Device": "HLTE106E_30",
    "Model": "Hisense U30"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense U30",
    "Device": "HLTE106E_31",
    "Model": "Hisense U30"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense U30 32GB",
    "Device": "HLTE106E_40",
    "Model": "Hisense U30 32GB"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense U30 32GB",
    "Device": "HLTE106E_41",
    "Model": "Hisense U30 32GB"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense U40",
    "Device": "HLTE103E_30",
    "Model": "Hisense U40"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense U40",
    "Device": "HLTE103E_31",
    "Model": "Hisense U40"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense U40",
    "Device": "HLTE103E_32",
    "Model": "Hisense U40"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense U40",
    "Device": "HLTE103E_33",
    "Model": "Hisense U40"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense U40",
    "Device": "SC9832E",
    "Model": "Hisense U40"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense U50",
    "Device": "HLTE222E",
    "Model": "Hisense U50"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense U50",
    "Device": "HLTE222E_01",
    "Model": "Hisense U50"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense U50",
    "Device": "HLTE222E_02",
    "Model": "Hisense U50"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense U50",
    "Device": "HLTE233E_10",
    "Model": "Hisense H50 Lite"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense U54",
    "Device": "HLTE124E",
    "Model": "Hisense U54"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense U605",
    "Device": "HS7731ESP",
    "Model": "HWCD101E"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense U605",
    "Device": "HS7731ESP",
    "Model": "HWCD102E"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense U605",
    "Device": "HS7731ESP",
    "Model": "Hisense M50 Lite"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense U605",
    "Device": "HS7731ESP",
    "Model": "Hisense M50 Lite 2021"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense U605",
    "Device": "HS7731ESP",
    "Model": "Hisense U30"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense U605",
    "Device": "HS7731ESP",
    "Model": "Hisense U50"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense U605",
    "Device": "HS7731ESP",
    "Model": "Hisense U605"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense U605",
    "Device": "HS7731ESP",
    "Model": "Hisense U606"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense U605",
    "Device": "Hisense",
    "Model": "Hisense U605"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense U62 Pro",
    "Device": "HLTE121E",
    "Model": "Hisense U62 Pro"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense U70 Pro",
    "Device": "HLTE109E",
    "Model": "Hisense C90 Pro"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense U70 Pro",
    "Device": "HLTE109E",
    "Model": "Hisense M71 Pro"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense U70 Pro",
    "Device": "HLTE109E",
    "Model": "Hisense U53"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense U70 Pro",
    "Device": "HLTE109E",
    "Model": "Hisense U62 Pro"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense U70 Pro",
    "Device": "HLTE109E",
    "Model": "Hisense U70 Pro"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense U70 Pro",
    "Device": "HLTE109E",
    "Model": "Hisense Y81 Pro"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense U70 Pro",
    "Device": "HLTE109E",
    "Model": "Hisense Y82 Pro"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense U70 Pro",
    "Device": "HLTE109E",
    "Model": "Hisense Y82 Pro MAX"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense U70 Pro",
    "Device": "HLTE109E",
    "Model": "Hisense Y83"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense U70 Pro",
    "Device": "HLTE109E_01",
    "Model": "Hisense U53"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense U70 Pro",
    "Device": "HLTE109E_01",
    "Model": "Hisense U70 Pro"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense U70 Pro",
    "Device": "HLTE109E_02",
    "Model": "Hisense U70 Pro"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense U70 Pro",
    "Device": "HLTE109E_03",
    "Model": "Hisense U70 Pro"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense U70 Pro",
    "Device": "HLTE109E_03",
    "Model": "Hisense U71 Pro"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense U70 Pro",
    "Device": "HLTE120E_01",
    "Model": "Hisense U71 Pro"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense U71 Pro",
    "Device": "HLTE120E",
    "Model": "Hisense U71 Pro"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense U71 Pro",
    "Device": "HLTE120E_01",
    "Model": "Hisense U71 Pro"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense U963",
    "Device": "HLTE100E_11",
    "Model": "Hisense U963"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense U963",
    "Device": "HLTE100E_12",
    "Model": "Hisense U963"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense U963",
    "Device": "HLTE100E_13",
    "Model": "Hisense U963"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense U963",
    "Device": "HLTE100E_14",
    "Model": "Hisense U963"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense U963",
    "Device": "SC9832E",
    "Model": "HLTE100E_10"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense U963",
    "Device": "SC9832E",
    "Model": "Hisense U963"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense U963",
    "Device": "SC9832E",
    "Model": "Hisense V40"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense U964",
    "Device": "HLTE106E_01",
    "Model": "Hisense E32 Lite"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense U964",
    "Device": "HLTE106E_01",
    "Model": "Hisense U60"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense U964",
    "Device": "HLTE106E_01",
    "Model": "Hisense U964"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense U964",
    "Device": "HLTE106E_01",
    "Model": "Hisense U965"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense U964",
    "Device": "HLTE106E_02",
    "Model": "Hisense E32 Lite"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense U964",
    "Device": "HLTE106E_02",
    "Model": "Hisense T2"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense U964",
    "Device": "HLTE106E_02",
    "Model": "Hisense U32"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense U964",
    "Device": "HLTE106E_02",
    "Model": "Hisense U607"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense U964",
    "Device": "HLTE106E_02",
    "Model": "Hisense U608"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense U964",
    "Device": "HLTE106E_02",
    "Model": "Hisense U964"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense U964",
    "Device": "HLTE106E_02",
    "Model": "Hisense U965"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense U964",
    "Device": "HS7731ESP",
    "Model": "HWCD100E"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense U964",
    "Device": "HS7731ESP",
    "Model": "Hisense U40 Lite"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense U964",
    "Device": "HS7731ESP",
    "Model": "Hisense U50 Lite"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense U964",
    "Device": "HS7731ESP",
    "Model": "Hisense U50 lite"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense U964",
    "Device": "HS7731ESP",
    "Model": "Hisense U60 Lite"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense U964",
    "Device": "HS7731ESP",
    "Model": "Hisense U61"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense U964",
    "Device": "HS7731ESP",
    "Model": "Hisense U70"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense U964",
    "Device": "HS7731ESP",
    "Model": "Hisense U71"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense U964",
    "Device": "HS7731ESP",
    "Model": "Hisense U964"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense U965",
    "Device": "HS6580MT",
    "Model": "Hisense Hi 1 PRO"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense U965",
    "Device": "HS6580MT",
    "Model": "Hisense U965"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense V40",
    "Device": "HLTE229E_13",
    "Model": "Hisense V40"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense V40",
    "Device": "HLTE229E_14",
    "Model": "Hisense V40"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense V40S",
    "Device": "HLTE229E_30",
    "Model": "Hisense V40S"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense V40S",
    "Device": "HLTE229E_30",
    "Model": "Hisense V40s"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Hisense V50",
    "Device": "HLTE233E_11",
    "Model": "Hisense V50"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "I300T",
    "Device": "I300T",
    "Model": "Hisense I300T"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "I56D2G",
    "Device": "HS8929QC",
    "Model": "Andromax I56D2G"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "I630U",
    "Device": "I630U",
    "Model": "Hisense I630U"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "I631M",
    "Device": "i631m",
    "Model": "Hisense I631M"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "I632M",
    "Device": "I632M",
    "Model": "Hisense I632M"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "I632T",
    "Device": "I632T",
    "Model": "Hisense I632T"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "I635T",
    "Device": "HS8916QC",
    "Model": "Hisense I635T"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "I639M",
    "Device": "I639M",
    "Model": "Hisense I639M"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "I639T",
    "Device": "I639T",
    "Model": "Hisense I639T"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "I639T",
    "Device": "I639TA",
    "Model": "Hisense I639T"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "I639T",
    "Device": "I639TA1",
    "Model": "Hisense I639T"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "IRON  2",
    "Device": "HS8937QC",
    "Model": "IRON 2"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "K1",
    "Device": "HS8937QC",
    "Model": "Hisense K1"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "K220_FHD",
    "Device": "mst628",
    "Model": "K220_FHD"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "L635E_1",
    "Device": "HS8916QC",
    "Model": "Trekker-M1"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "L671",
    "Device": "HS8929QC",
    "Model": "HS-L671"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "L671",
    "Device": "HS8929QC",
    "Model": "Hisense L671"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "L671W",
    "Device": "HS8929QC",
    "Model": "HS-L671"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "L671W",
    "Device": "HS8929QC",
    "Model": "Hisense L671"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "L671WE_1",
    "Device": "HS8929QC",
    "Model": "Hisense L671"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "L671WE_2",
    "Device": "HS8929QC",
    "Model": "Hisense L671"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "L675",
    "Device": "HS6735MT",
    "Model": "Hisense L675"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "L676BE-1",
    "Device": "HS8929QC",
    "Model": "Hisense L676"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "L676BE-2",
    "Device": "HS8929QC",
    "Model": "Hisense L676"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "L678",
    "Device": "HS8916QC",
    "Model": "Hisense L678"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "L681",
    "Device": "HS8916QC",
    "Model": "L681"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "L682",
    "Device": "HS8916QC",
    "Model": "HS-L682"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "L682",
    "Device": "HS8916QC",
    "Model": "Hisense L682"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "L691",
    "Device": "l691",
    "Model": "HS-L691"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "L691",
    "Device": "l691e_2",
    "Model": "HS-L691"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "L691AE",
    "Device": "msm8226",
    "Model": "HS-L691"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "L695",
    "Device": "HS8929QC",
    "Model": "HS-L695"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "L695W",
    "Device": "HS8929QC",
    "Model": "HS-L695"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "L695W",
    "Device": "HS8929QC",
    "Model": "Hisense L695"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "L695WE_2",
    "Device": "HS8929QC",
    "Model": "Hisense L695"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "L697",
    "Device": "HS8952QC",
    "Model": "L697"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "L730",
    "Device": "HS8937QC",
    "Model": "STARADDICT 6"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "LED32G180",
    "Device": "hisenseLED32G180",
    "Model": "LED32G180"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "LED32K220",
    "Device": "mst628",
    "Model": "LED32K220"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "LED32K280J3D",
    "Device": "mt5880",
    "Model": "LED32K280J3D"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "LED32K360",
    "Device": "mt5880",
    "Model": "LED32K360"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "LED32K360J",
    "Device": "mt5880",
    "Model": "LED32K360J"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "LED32K360J3D",
    "Device": "mt5880",
    "Model": "LED32K360J3D"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "LED32K360X3D",
    "Device": "mt5880",
    "Model": "LED32K360X3D"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "LED32K370",
    "Device": "mt5880",
    "Model": "LED32K370"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "LED32K600J",
    "Device": "mt5880",
    "Model": "LED32K600J"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "LED32K600X3D",
    "Device": "mt5880",
    "Model": "LED32K600X3D"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "LED32K610X3D",
    "Device": "mt5880",
    "Model": "LED32K610X3D"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "LED32L288",
    "Device": "mt5880",
    "Model": "LED32L288"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "LED39K280J3D",
    "Device": "mt5880",
    "Model": "LED39K280J3D"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "LED39K360J",
    "Device": "mt5880",
    "Model": "LED39K360J"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "LED39K360X3D",
    "Device": "mt5880",
    "Model": "LED39K360X3D"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "LED39K600X3D",
    "Device": "mt5880",
    "Model": "LED39K600X3D"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "LED39K600X3DU",
    "Device": "mst901",
    "Model": "LED39K600X3DU"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "LED39K610X3D",
    "Device": "mt5880",
    "Model": "LED39K610X3D"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "LED39K680X3DU",
    "Device": "mt5327",
    "Model": "LED39K680X3DU"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "LED40K260X3D",
    "Device": "mt5880",
    "Model": "LED40K260X3D"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "LED40K360J",
    "Device": "mt5880",
    "Model": "LED40K360J"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "LED40K360X3D",
    "Device": "mt5880",
    "Model": "LED40K360X3D"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "LED40K370",
    "Device": "mt5880",
    "Model": "LED40K370"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "LED40K681X3DU",
    "Device": "msd6a918",
    "Model": "LED40K681X3DU"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "LED40L288",
    "Device": "mt5880",
    "Model": "LED40L288"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "LED42G200",
    "Device": "hisenseLED42G200",
    "Model": "LED42G200"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "LED42K280J3D",
    "Device": "mt5880",
    "Model": "LED42K280J3D"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "LED42K330X3D",
    "Device": "mt5880",
    "Model": "LED42K330X3D"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "LED42K360J",
    "Device": "mt5880",
    "Model": "LED42K360J"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "LED42K360X3D",
    "Device": "mt5880",
    "Model": "LED42K360X3D"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "LED42K370",
    "Device": "mt5880",
    "Model": "LED42K370"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "LED42K380U",
    "Device": "msd6a918",
    "Model": "LED42K380U"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "LED42K560X3D",
    "Device": "hisenseLED42K560X3D",
    "Model": "LED42K560X3D"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "LED42K600A3D",
    "Device": "mt5880",
    "Model": "LED42K600A3D"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "LED42K600X3D",
    "Device": "mt5880",
    "Model": "LED42K600X3D"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "LED42K610J3DP",
    "Device": "mt5880",
    "Model": "LED42K610J3DP"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "LED42K610X3D",
    "Device": "mt5880",
    "Model": "LED42K610X3D"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "LED42K660X3D",
    "Device": "hisenseLED42K660X3D",
    "Model": "LED42K660X3D"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "LED42K680X3DU",
    "Device": "mt5327",
    "Model": "LED42K680X3DU"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "LED42L288",
    "Device": "mt5880",
    "Model": "LED42L288"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "LED46K260X3D",
    "Device": "mt5880",
    "Model": "LED46K260X3D"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "LED46K280J3D",
    "Device": "mt5880",
    "Model": "LED46K280J3D"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "LED46K330X3D",
    "Device": "mt5880",
    "Model": "LED46K330X3D"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "LED46K360J",
    "Device": "mt5880",
    "Model": "LED46K360J"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "LED46K360X3D",
    "Device": "mt5880",
    "Model": "LED46K360X3D"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "LED46K660X3D",
    "Device": "hisense6a801",
    "Model": "LED46K660X3D"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "LED47K560J3D",
    "Device": "hisenseLED47K560J3D",
    "Model": "LED47K560J3D"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "LED47K600X3D",
    "Device": "mt5880",
    "Model": "LED47K600X3D"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "LED47K610J3DP",
    "Device": "mt5880",
    "Model": "LED47K610J3DP"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "LED48K360X3D",
    "Device": "mt5880",
    "Model": "LED48K360X3D"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "LED48K370",
    "Device": "mt5880",
    "Model": "LED48K370"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "LED48K380U",
    "Device": "msd6a918",
    "Model": "LED48K380U"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "LED48K681X3DU",
    "Device": "msd6a918",
    "Model": "LED48K681X3DU"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "LED48L288",
    "Device": "mt5880",
    "Model": "LED48L288"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "LED50G05",
    "Device": "hisenseLED50G05",
    "Model": "LED50G05"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "LED50K260X3D",
    "Device": "mt5880",
    "Model": "LED50K260X3D"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "LED50K360J",
    "Device": "mt5880",
    "Model": "LED50K360J"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "LED50K360X3D",
    "Device": "mt5880",
    "Model": "LED50K360X3D"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "LED50K370",
    "Device": "mt5880",
    "Model": "LED50K370"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "LED50K380U",
    "Device": "msd6a918",
    "Model": "LED50K380U"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "LED50K610X3D",
    "Device": "mt5880",
    "Model": "LED50K610X3D"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "LED50K660X3D",
    "Device": "hisenseLED50K660X3D",
    "Model": "LED50K660X3D"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "LED50K680X3DU",
    "Device": "mt5327",
    "Model": "LED50K680X3DU"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "LED50L288",
    "Device": "mt5880",
    "Model": "LED50L288"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "LED50XT880G3D",
    "Device": "hisenseLED50XT880G3D",
    "Model": "LED50XT880G3D"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "LED50XT880G3DU",
    "Device": "mst901",
    "Model": "LED50XT880G3DU"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "LED50XT900X3DU",
    "Device": "mt5327",
    "Model": "LED50XT900X3DU"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "LED55K260X3D",
    "Device": "mt5880",
    "Model": "LED55K260X3D"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "LED55K360X3D",
    "Device": "mt5880",
    "Model": "Hisense LED55K360X3D"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "LED55K370",
    "Device": "mt5880",
    "Model": "LED55K370"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "LED55K380U",
    "Device": "msd6a918",
    "Model": "LED55K380U"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "LED55K600A3D",
    "Device": "mt5880",
    "Model": "LED55K600A3D"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "LED55K600X3D",
    "Device": "mt5880",
    "Model": "LED55K600X3D"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "LED55K610X3D",
    "Device": "mt5880",
    "Model": "LED55K610X3D"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "LED55K680X3DU",
    "Device": "mt5327",
    "Model": "LED55K680X3DU"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "LED55L288",
    "Device": "mt5880",
    "Model": "LED55L288"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "LED55XT780G3D",
    "Device": "hisenseLED55XT780G3D",
    "Model": "LED55XT780G3D"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "LED55XT810X3DU",
    "Device": "msd6a918",
    "Model": "LED55XT810X3DU"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "LED55XT880G3DU",
    "Device": "mst901",
    "Model": "LED55XT880G3DU"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "LED55XT900X3DU",
    "Device": "mt5327",
    "Model": "LED55XT900X3DU"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "LED58K280J",
    "Device": "mt5880",
    "Model": "LED58K280J"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "LED58K280U",
    "Device": "mt5327",
    "Model": "LED58K280U"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "LED58K610X3D",
    "Device": "mt5880",
    "Model": "LED58K610X3D"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "LED58K680X3DU",
    "Device": "mt5327",
    "Model": "LED58K680X3DU"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "LED58XT880G3D",
    "Device": "hisenseLED58XT880G3D",
    "Model": "LED58XT880G3D"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "LED58XT880J3DU",
    "Device": "mst901",
    "Model": "LED58XT880J3DU"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "LED60K380",
    "Device": "mt5327",
    "Model": "LED60K380"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "LED65K560J3DTB",
    "Device": "hisenseLED65K560J3DTB",
    "Model": "LED65K560J3DTB"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "LED65K560J3DTR",
    "Device": "hisenseLED65K560J3DTR",
    "Model": "LED65K560J3DTR"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "LED65K600X3D",
    "Device": "mt5880",
    "Model": "LED65K600X3D"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "LED65K680X3DU",
    "Device": "mt5327",
    "Model": "LED65K680X3DU"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "LED65XT780G3D",
    "Device": "hisenseLED65XT780G3D",
    "Model": "LED65XT780G3D"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "LED65XT800X3DU",
    "Device": "mt5327",
    "Model": "LED65XT800X3DU"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "LED65XT810X3DU",
    "Device": "msd6a918",
    "Model": "LED65XT810X3DU"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "LED65XT880G3D",
    "Device": "hisenseLED65XT880G3D",
    "Model": "LED65XT880G3D"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "LED65XT880G3DF",
    "Device": "hisenseLED65XT880G3DF",
    "Model": "LED65XT880G3DF"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "LED65XT880G3DU",
    "Device": "mst901",
    "Model": "LED65XT880G3DU"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "LED65XT890G3D",
    "Device": "hisenseLED65XT890G3D",
    "Model": "LED65XT890G3D"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "LED65XT900G3DU",
    "Device": "mst901",
    "Model": "LED65XT900G3DU"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "LED65XT900X3DU",
    "Device": "mt5327",
    "Model": "LED65XT900X3DU"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "LED75XT890G3D",
    "Device": "mst901",
    "Model": "LED75XT890G3D"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "LED75XT910G3DU",
    "Device": "mt5327",
    "Model": "LED75XT910G3DU"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "LED84XT900G3D",
    "Device": "hisenseLED84XT900G3D",
    "Model": "LED84XT900G3D"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "LED85XT910G3DU",
    "Device": "mt5327",
    "Model": "Vision20"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "LT100K6900A",
    "Device": "mt5327",
    "Model": "LT100K6900A"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "LT610",
    "Device": "LT610",
    "Model": "LT610"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Laser TV",
    "Device": "wuyishan",
    "Model": "SmartTV 4K"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "M10-M",
    "Device": "HS9830SP",
    "Model": "Hisense M10-M"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "M20- T",
    "Device": "HS8909QC",
    "Model": "Hisense M20-T"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "M20-M",
    "Device": "HS9830SP",
    "Model": "Hisense M20-M"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "M30",
    "Device": "HS8909QC",
    "Model": "Hisense M30"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "M30M",
    "Device": "HS9830SP",
    "Model": "Hisense M30M"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "M30T",
    "Device": "HS8909QC",
    "Model": "Hisense M30T"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "M3101BCD",
    "Device": "m3101bcd",
    "Model": "M3101BCD"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "M36",
    "Device": "HS8909QC",
    "Model": "Hisense M36"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "M470BSA",
    "Device": "m470",
    "Model": "M470BSA"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "M470BSD",
    "Device": "m470bsd",
    "Model": "M470BSD"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "M470BSE",
    "Device": "m470bse",
    "Model": "M470BSE"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "M470BSG",
    "Device": "m470bsg",
    "Model": "M470BSG"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "M470BSS",
    "Device": "m470bss",
    "Model": "M470BSS"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "M701",
    "Device": "M701",
    "Model": "M701"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "M821",
    "Device": "HS8916QC",
    "Model": "M821"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "M821H",
    "Device": "HS8916QC",
    "Model": "M821H"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "M821T",
    "Device": "HS8916QC",
    "Model": "SMART 4G HD Voice"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "MEDION E4001",
    "Device": "E4001",
    "Model": "MEDION E4001"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "MEDION X4701",
    "Device": "x4701",
    "Model": "MEDION X4701"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Mexico",
    "Device": "HLTE226E",
    "Model": "Hisense Infinity H40 Rock"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Mexico",
    "Device": "HLTE226E",
    "Model": "Hisense Rocks 6"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Oysters Pacific 800",
    "Device": "x4701ae",
    "Model": "Oysters Pacific 800"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "PX10",
    "Device": "PX10",
    "Model": "PX10"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "PX1900",
    "Device": "atm7039c",
    "Model": "PX1900"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "PX1900ES",
    "Device": "atm7039c",
    "Model": "PX7"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "PX2000",
    "Device": "hisensepx2000",
    "Model": "PX2000"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "PX2700",
    "Device": "g18ref",
    "Model": "PX2700"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "PX2800",
    "Device": "hisensepx2800",
    "Model": "PX2800"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "PX3000",
    "Device": "mt5880",
    "Model": "Hisense PX3000"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "PX3000",
    "Device": "mt5880",
    "Model": "PX3000"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "PX3100",
    "Device": "mt5880",
    "Model": "PX3100"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "PX510",
    "Device": "PX510",
    "Model": "PX510"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "PX530",
    "Device": "PX8",
    "Model": "PX8"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "PX9",
    "Device": "PX9",
    "Model": "PX9"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "S1",
    "Device": "HS8937QC",
    "Model": "S1"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "SKi630t",
    "Device": "msm8226",
    "Model": "SKi630t"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "STARSHINE 4",
    "Device": "HS6572MT",
    "Model": "STARSHINE 4"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "STARTRAIL  9",
    "Device": "HS6737MT",
    "Model": "S40"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "STARTRAIL  9",
    "Device": "HS6737MT",
    "Model": "STARTRAIL 9"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "STARTRAIL 6 4G",
    "Device": "L681",
    "Model": "STARTRAIL 6 4G"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Sero 7",
    "Device": "rk3168",
    "Model": "E2171CA"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Sero 7",
    "Device": "rk3168",
    "Model": "E2171MX"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Sero 7",
    "Device": "rk3168",
    "Model": "E2171TK"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Sero 8",
    "Device": "rk3188",
    "Model": "E2281"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Sero 8",
    "Device": "rk3188",
    "Model": "E2281CA"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Sero 8",
    "Device": "rk3188",
    "Model": "E2281MX"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Sero 8",
    "Device": "rk3188",
    "Model": "E2281TK"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Sero 8",
    "Device": "rk3188",
    "Model": "E2281UK"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Sero 8 pro",
    "Device": "rk3288",
    "Model": "F5281"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Sero7",
    "Device": "rk3168",
    "Model": "E2171SS"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Sero7 LE",
    "Device": "rk3026",
    "Model": "E2371"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Sero8",
    "Device": "rk3188",
    "Model": "E2281SS"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "SmartLaser 4K",
    "Device": "hengshan",
    "Model": "SmartLaser 4K"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "SmartTV 4K",
    "Device": "hengshan",
    "Model": "SmartTV 4K"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "SmartTV 4K FFM",
    "Device": "wutaishan",
    "Model": "SmartTV 4K FFM"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "SoundTab MA-317",
    "Device": "rk3028a",
    "Model": "Hisense SoundTab MA-317"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "SoundTab MA-327",
    "Device": "rk3028a",
    "Model": "Hisense SoundTab MA-327"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "T963",
    "Device": "HS7331CSC",
    "Model": "Hisense T963"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "TV",
    "Device": "hisense_gx1200v",
    "Model": "hisense_gx1200v"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Toshiba_TV",
    "Device": "MTK9639",
    "Model": "Toshiba_TV"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "U601S",
    "Device": "HS7731CSP",
    "Model": "Hisense U601S"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "U601S  Pro",
    "Device": "HS7731CSP",
    "Model": "U601S Pro"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "U602",
    "Device": "HS6580MT",
    "Model": "HS-U602"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "U606",
    "Device": "U606",
    "Model": "STARSHINE III"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "U606AE",
    "Device": "U606AE",
    "Model": "HS-U606"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "U606AE",
    "Device": "U606AE",
    "Model": "PHS-402"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "U607",
    "Device": "U607",
    "Model": "Bouygues Telecom Bs 403"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "U609",
    "Device": "U609",
    "Model": "HS-U609"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "U610",
    "Device": "U610",
    "Model": "HS-U610"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "U610",
    "Device": "U610E_1",
    "Model": "HS-U610"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "U688",
    "Device": "U688",
    "Model": "HS-U688"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "U688BE",
    "Device": "MSM8212",
    "Model": "HS-U688"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "U800",
    "Device": "U800",
    "Model": "HS-U800"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "U800E-1",
    "Device": "U800E_1",
    "Model": "HS-U800"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "U800E-1",
    "Device": "U800E_1",
    "Model": "HS-U800E-1"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "U963",
    "Device": "HS7331CSC",
    "Model": "Hisense U963"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "U963",
    "Device": "HS7331CSC",
    "Model": "RIVIERA U963"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "U966",
    "Device": "u966e_1",
    "Model": "U966"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "U970",
    "Device": "u970e_8",
    "Model": "U970"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "U988",
    "Device": "U988",
    "Model": "HS-U988"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "U988AE",
    "Device": "MSM8212",
    "Model": "HS-U988"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "U988E-1",
    "Device": "U988E_1",
    "Model": "HS-U988"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "U988E-2",
    "Device": "U988E_2",
    "Model": "HS-U988"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "U989",
    "Device": "HS6580MT",
    "Model": "Hisense U989"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "U989 Pro",
    "Device": "HS6580MT",
    "Model": "Hisense U989 Pro"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "ULED",
    "Device": "hengshan",
    "Model": "SmartTV 4K FFM"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "ULED",
    "Device": "wuyishan",
    "Model": "SmartTV 4K FFM"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "VH777",
    "Device": "VH777",
    "Model": "VH777"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "VIDAA_TV",
    "Device": "Hi3751",
    "Model": "VIDAA_TV"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "VIDAA_TV",
    "Device": "Hi3751v351",
    "Model": "VIDAA_TV"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "VIDAA_TV",
    "Device": "Hi3751v551",
    "Model": "VIDAA_TV"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "VIDAA_TV",
    "Device": "Hi3751v620",
    "Model": "VIDAA_TV"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "VIDAA_TV",
    "Device": "Hi3751v811",
    "Model": "VIDAA_TV"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "VIDAA_TV",
    "Device": "MSD6A348",
    "Model": "VIDAA_TV"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "VIDAA_TV",
    "Device": "MSD6A648",
    "Model": "VIDAA_TV"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "VIDAA_TV",
    "Device": "MSD6A828",
    "Model": "VIDAA_TV"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "VIDAA_TV",
    "Device": "MSD6A838",
    "Model": "VIDAA_TV"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "VIDAA_TV",
    "Device": "MSD6A938",
    "Model": "VIDAA_TV"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "VIDAA_TV",
    "Device": "MT9669",
    "Model": "VIDAA_TV"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "VIDAA_TV",
    "Device": "MTK9255",
    "Model": "VIDAA_TV"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "VIDAA_TV",
    "Device": "MTK9632",
    "Model": "VIDAA_TV"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "VIDAA_TV",
    "Device": "MTK9638",
    "Model": "VIDAA_TV"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "VIDAA_TV",
    "Device": "MTK9652",
    "Model": "VIDAA_TV"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "VIDAA_TV",
    "Device": "NOVA72673",
    "Model": "VIDAA_TV"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "VIDAA_TV",
    "Device": "NOVA72685",
    "Model": "VIDAA_TV"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "VIDAA_TV",
    "Device": "NOVA72691",
    "Model": "VIDAA_TV"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "VIDAA_TV",
    "Device": "RTK2851D",
    "Model": "VIDAA_TV"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "VIDAA_TV",
    "Device": "mt5861",
    "Model": "VIDAA_TV"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "VIDAA_TV",
    "Device": "mt5890",
    "Model": "VIDAA_TV"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Vidaa",
    "Device": "helium3",
    "Model": "H7"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Vision",
    "Device": "Vision",
    "Model": "Vision"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "Vision 2.5",
    "Device": "vision2_5",
    "Model": "vision2_5"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "VisionBoard",
    "Device": "mt9679_u",
    "Model": "WE3FE"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "W2",
    "Device": "EG606_YE",
    "Model": "W2"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "W270BD",
    "Device": "W270BD",
    "Model": "W270BD"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "WA912",
    "Device": "U912ATW",
    "Model": "WA912"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "WA960",
    "Device": "U960Q_1",
    "Model": "WA960"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "WM8",
    "Device": "wm8980s",
    "Model": "WM8"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "X1E1",
    "Device": "X1E1",
    "Model": "HS-X1"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "XOLO",
    "Device": "us9230e1",
    "Model": "XOLO T1000"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "c20",
    "Device": "HS8929QC",
    "Model": "Hisense C20"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "c20ae",
    "Device": "HS8929QC",
    "Model": "C20"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "c20fe-3",
    "Device": "HS8929QC",
    "Model": "Hisense C20"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "e76mini",
    "Device": "HS8937QC",
    "Model": "Hisense E76mini"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "emeishan",
    "Device": "hirano",
    "Model": "SmartTV"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "fushan_2",
    "Device": "hamamatsucho",
    "Model": "HiSmart TV"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "fushan_em",
    "Device": "hamamatsucho",
    "Model": "HiSmart 2K ATV4"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "fushan_emeu",
    "Device": "hamamatsucho",
    "Model": "HiSmart 2K ATV4"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "fushan_sa",
    "Device": "hamamatsucho",
    "Model": "HiSmart 2K ATV4"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "fushan_sa",
    "Device": "hamamatsucho",
    "Model": "HiSmart TV"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "huangshan",
    "Device": "huangshan",
    "Model": "SmartTV 4K"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "huangshan",
    "Device": "huangshan",
    "Model": "SmartTV 4K FFM"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "l676be",
    "Device": "HS8929QC",
    "Model": "Hisense L676"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "l691",
    "Device": "msm8226",
    "Model": "HS-L691"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "l830",
    "Device": "HS8937QC",
    "Model": "Hisense L830"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "l830",
    "Device": "HS8937QC",
    "Model": "STARXTREM 6"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "laohushan",
    "Device": "laohushan",
    "Model": "HiSmart 4K A4FFM"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "laoshan",
    "Device": "laoshan",
    "Model": "HAT4KDTV"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "laoshan-Hisense",
    "Device": "laoshan",
    "Model": "HAT4KDTV"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "laoshan-emT",
    "Device": "laoshan",
    "Model": "HAT4KDTV"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "laoshan_HK",
    "Device": "laoshan",
    "Model": "HKU7A"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "laoshan_emH",
    "Device": "laoshan",
    "Model": "HAT4KDTV"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "laoshan_laser",
    "Device": "laoshan",
    "Model": "HAT4KDTV"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "lt971",
    "Device": "LT971",
    "Model": "LT971"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "lushan",
    "Device": "lushan",
    "Model": "SmartTV 4K FFM"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "lushan-NF",
    "Device": "lushan",
    "Model": "SmartTV 4K"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "qingshan_hisense",
    "Device": "moeraki",
    "Model": "HJ4KAndroidTV"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "songshan",
    "Device": "songshan",
    "Model": "SmartTV 4K"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "u972",
    "Device": "HS7731SP",
    "Model": "U972"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "vision2_1",
    "Device": "vision2_1",
    "Model": "vision2_1"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "xiaoyushan",
    "Device": "xiaoyushan",
    "Model": "HAT4KDTV"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "xiaoyushan",
    "Device": "xiaoyushan",
    "Model": "HiSmartTV A4"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "xiaoyushan-em",
    "Device": "xiaoyushan",
    "Model": "HiSmartTV A4"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "xiaoyushan-sa",
    "Device": "xiaoyushan",
    "Model": "HiSmartTV A4"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "xinhaoshan",
    "Device": "xinhaoshan",
    "Model": "HiSmart 4K ATV4"
  },
  {
    "Retail Branding": "Hisense",
    "Marketing Name": "天翼1号",
    "Device": "HNR552T",
    "Model": "TYH201H"
  },
  {
    "Retail Branding": "Hitachi",
    "Marketing Name": "Android TV",
    "Device": "R1",
    "Model": "ATV R1"
  },
  {
    "Retail Branding": "Hitachi",
    "Marketing Name": "Android TV",
    "Device": "R2",
    "Model": "ATV R2"
  },
  {
    "Retail Branding": "Hitachi",
    "Marketing Name": "Hitachi",
    "Device": "bangbae",
    "Model": "Hitachi 4K Android TV"
  },
  {
    "Retail Branding": "Hitachi",
    "Marketing Name": "Hitachi",
    "Device": "komagome",
    "Model": "Hitachi 2K Android TV"
  },
  {
    "Retail Branding": "Hitachi",
    "Marketing Name": "HitachiTV",
    "Device": "shinjuku",
    "Model": "HitachiTV"
  },
  {
    "Retail Branding": "Hitachi",
    "Marketing Name": "LD50CHS04U",
    "Device": "samseong",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "Hiya",
    "Marketing Name": "5-0",
    "Device": "5-0",
    "Model": "5-0"
  },
  {
    "Retail Branding": "Hiya",
    "Marketing Name": "5-0",
    "Device": "5_0",
    "Model": "5-0"
  },
  {
    "Retail Branding": "Hiya",
    "Marketing Name": "5-0",
    "Device": "HIYA_5_0",
    "Model": "5-0"
  },
  {
    "Retail Branding": "Hiya",
    "Marketing Name": 5.5,
    "Device": "5_5",
    "Model": 5.5
  },
  {
    "Retail Branding": "Hiya",
    "Marketing Name": 5.5,
    "Device": "HIYA5_5",
    "Model": 5.5
  },
  {
    "Retail Branding": "Hllo",
    "Marketing Name": "8TT-A_EEA",
    "Device": "8TT-A",
    "Model": "8TT-A"
  },
  {
    "Retail Branding": "Hodgur",
    "Marketing Name": "HJTD",
    "Device": "rk3576_u",
    "Model": "HJTD"
  },
  {
    "Retail Branding": "Hoffmann",
    "Marketing Name": "X Max",
    "Device": "X-Max",
    "Model": "X-Max"
  },
  {
    "Retail Branding": "Hoffmann",
    "Marketing Name": "X-Go",
    "Device": "X-Go",
    "Model": "X-Go"
  },
  {
    "Retail Branding": "Hoffmann",
    "Marketing Name": "X-Ultra",
    "Device": "X_Ultra",
    "Model": "X_Ultra"
  },
  {
    "Retail Branding": "Hoffmann",
    "Marketing Name": "X_Prime",
    "Device": "X_Prime",
    "Model": "HOFFMANN X-Prime"
  },
  {
    "Retail Branding": "Homatics",
    "Marketing Name": "Box HD",
    "Device": "MIA",
    "Model": "Box HD"
  },
  {
    "Retail Branding": "Homatics",
    "Marketing Name": "Box Q",
    "Device": "HND",
    "Model": "Box Q"
  },
  {
    "Retail Branding": "Homatics",
    "Marketing Name": "Box R 4K Plus",
    "Device": "YYJ",
    "Model": "Box R 4K Plus"
  },
  {
    "Retail Branding": "Homatics",
    "Marketing Name": "CTV 4K BOX",
    "Device": "SEI700CG",
    "Model": "CTV 4K BOX"
  },
  {
    "Retail Branding": "Homatics",
    "Marketing Name": "Dongle 4K Plus",
    "Device": "SEID00DBYG",
    "Model": "Dongle 4K Plus"
  },
  {
    "Retail Branding": "Homatics",
    "Marketing Name": "Dongle Q",
    "Device": "ICN",
    "Model": "Dongle Q"
  },
  {
    "Retail Branding": "Homatics",
    "Marketing Name": "Dongle R 4K",
    "Device": "YQB",
    "Model": "Dongle R 4K"
  },
  {
    "Retail Branding": "Homatics",
    "Marketing Name": "Global",
    "Device": "YQB",
    "Model": "Dongle R 4K"
  },
  {
    "Retail Branding": "Homatics",
    "Marketing Name": "Global",
    "Device": "YQX",
    "Model": "Dongle G 4K"
  },
  {
    "Retail Branding": "Homatics",
    "Marketing Name": "Kickpi",
    "Device": "YYZ",
    "Model": "KP1"
  },
  {
    "Retail Branding": "Homatics",
    "Marketing Name": "MB730",
    "Device": "emStream730",
    "Model": "MB730"
  },
  {
    "Retail Branding": "Homatics",
    "Marketing Name": "SEI600HM",
    "Device": "HND",
    "Model": "Box Q"
  },
  {
    "Retail Branding": "Homatics",
    "Marketing Name": "SEI700HMG",
    "Device": "SEI700HMG",
    "Model": "Dongle 4K"
  },
  {
    "Retail Branding": "Homatics",
    "Marketing Name": "Stick 4K",
    "Device": "YZF",
    "Model": "Stick 4K"
  },
  {
    "Retail Branding": "Homatics",
    "Marketing Name": "Stick HD",
    "Device": "IAD",
    "Model": "Stick HD"
  },
  {
    "Retail Branding": "Homatics",
    "Marketing Name": "TG STREAM 2",
    "Device": "TL_4KOA",
    "Model": "TG STREAM 2"
  },
  {
    "Retail Branding": "Homatics",
    "Marketing Name": "XG Glasses",
    "Device": "SEI700GHMG",
    "Model": "XR Theater G"
  },
  {
    "Retail Branding": "Home Elite",
    "Marketing Name": "Android TV",
    "Device": "R1",
    "Model": "ATV R1"
  },
  {
    "Retail Branding": "Home Elite",
    "Marketing Name": "Android TV",
    "Device": "R2",
    "Model": "ATV R2"
  },
  {
    "Retail Branding": "Home Planet",
    "Marketing Name": "R4",
    "Device": "R4",
    "Model": "R4"
  },
  {
    "Retail Branding": "Homeplustv",
    "Marketing Name": "HCA6010",
    "Device": "HCA6010",
    "Model": "HCA-6010"
  },
  {
    "Retail Branding": "Homeplustv",
    "Marketing Name": "Homeplus_ATV HCA-6010",
    "Device": "HCA6010",
    "Model": "HCA-6010"
  },
  {
    "Retail Branding": "Homeplustv",
    "Marketing Name": "STB-6252C",
    "Device": "STB6252C",
    "Model": "STB-6252C"
  },
  {
    "Retail Branding": "Homeplustv",
    "Marketing Name": "VSB-3918",
    "Device": "vsb3918_apac",
    "Model": "VSB-3918"
  },
  {
    "Retail Branding": "Hometech",
    "Marketing Name": "7_PREMIUM_PRO",
    "Device": "7_PREMIUM_PRO",
    "Model": "7_PREMIUM_PRO"
  },
  {
    "Retail Branding": "Hometech",
    "Marketing Name": "ALFA 10RC",
    "Device": "ALFA_10RC",
    "Model": "ALFA_10RC"
  },
  {
    "Retail Branding": "Hometech",
    "Marketing Name": "ALFA 8RC",
    "Device": "ALFA_8RC",
    "Model": "ALFA_8RC"
  },
  {
    "Retail Branding": "Hometech",
    "Marketing Name": "ALFA 8RX",
    "Device": "ALFA_8RX",
    "Model": "ALFA_8RX"
  },
  {
    "Retail Branding": "Hometech",
    "Marketing Name": "ALFA10MX",
    "Device": "ALFA10MX",
    "Model": "ALFA10MX"
  },
  {
    "Retail Branding": "Hometech",
    "Marketing Name": "ALFA10MX",
    "Device": "ALFA10MX",
    "Model": "Alfa 10MX"
  },
  {
    "Retail Branding": "Hometech",
    "Marketing Name": "ALFA10TB",
    "Device": "ALFA10TB",
    "Model": "ALFA10TB"
  },
  {
    "Retail Branding": "Hometech",
    "Marketing Name": "ALFA10TX",
    "Device": "ALFA10TX",
    "Model": "ALFA10TX"
  },
  {
    "Retail Branding": "Hometech",
    "Marketing Name": "ALFA10TX_PRO",
    "Device": "ALFA10TX_PRO",
    "Model": "ALFA10TX_PRO"
  },
  {
    "Retail Branding": "Hometech",
    "Marketing Name": "ALFA_10BS",
    "Device": "ALFA_10BS",
    "Model": "ALFA_10BS"
  },
  {
    "Retail Branding": "Hometech",
    "Marketing Name": "ALFA_10BT",
    "Device": "ALFA_10BT",
    "Model": "ALFA_10BT"
  },
  {
    "Retail Branding": "Hometech",
    "Marketing Name": "ALFA_10BT_V2",
    "Device": "ALFA_10BT_V2",
    "Model": "ALFA_10BT_V2"
  },
  {
    "Retail Branding": "Hometech",
    "Marketing Name": "ALFA_10RX",
    "Device": "ALFA_10RX",
    "Model": "ALFA_10RX"
  },
  {
    "Retail Branding": "Hometech",
    "Marketing Name": "ALFA_10YC",
    "Device": "ALFA_10YC",
    "Model": "ALFA_10YC"
  },
  {
    "Retail Branding": "Hometech",
    "Marketing Name": "ALFA_7M",
    "Device": "ALFA_7M",
    "Model": "ALFA_7M"
  },
  {
    "Retail Branding": "Hometech",
    "Marketing Name": "ALFA_7MD",
    "Device": "ALFA_7MD",
    "Model": "ALFA_7MD"
  },
  {
    "Retail Branding": "Hometech",
    "Marketing Name": "ALFA_7RC",
    "Device": "ALFA_7RC",
    "Model": "ALFA_7RC"
  },
  {
    "Retail Branding": "Hometech",
    "Marketing Name": "ALFA_8SL",
    "Device": "ALFA_8SL",
    "Model": "ALFA_8SL"
  },
  {
    "Retail Branding": "Hometech",
    "Marketing Name": "ALFA_8ST",
    "Device": "ALFA_8ST",
    "Model": "ALFA_8ST"
  },
  {
    "Retail Branding": "Hometech",
    "Marketing Name": "ALFA_8TX",
    "Device": "ALFA_8TX",
    "Model": "ALFA 8TX"
  },
  {
    "Retail Branding": "Hometech",
    "Marketing Name": "Alfa10LT",
    "Device": "Alfa10LT",
    "Model": "Alfa10LT"
  },
  {
    "Retail Branding": "Hometech",
    "Marketing Name": "Alfa_11_BT",
    "Device": "Alfa_11_BT",
    "Model": "Alfa 11 BT"
  },
  {
    "Retail Branding": "Hometech",
    "Marketing Name": "Alfa_12_GX_Pro",
    "Device": "Alfa_12_GX_Pro",
    "Model": "Alfa_12_GX_Pro"
  },
  {
    "Retail Branding": "Hometech",
    "Marketing Name": "EMEA",
    "Device": "ALFA_7RS",
    "Model": "ALFA 7RS"
  },
  {
    "Retail Branding": "Hometech",
    "Marketing Name": "HOMETECH",
    "Device": "mid7015_32",
    "Model": "Alfa7LM"
  },
  {
    "Retail Branding": "Hometech",
    "Marketing Name": "HT_7RT Tablet PC",
    "Device": "HT_7RT",
    "Model": "HT_7RT"
  },
  {
    "Retail Branding": "Hometech",
    "Marketing Name": "HT_8MZ",
    "Device": "HT_8MZ",
    "Model": "HT_8MZ"
  },
  {
    "Retail Branding": "Hometech",
    "Marketing Name": "MID1032_MR",
    "Device": "mid1032_mr_32",
    "Model": "Alfa10LA"
  },
  {
    "Retail Branding": "Hometech",
    "Marketing Name": "Turkey",
    "Device": "ALFA_7MRC",
    "Model": "ALFA_7MRC"
  },
  {
    "Retail Branding": "Hon Hai Precision Industry Co., Ltd.",
    "Marketing Name": "",
    "Device": "EP10_wifi",
    "Model": "PocketBook A10"
  },
  {
    "Retail Branding": "Hon Hai Precision Industry Co., Ltd.",
    "Marketing Name": "",
    "Device": "EP5A_wifi",
    "Model": "PocketBook A7"
  },
  {
    "Retail Branding": "Hon Hai Precision Industry Co., Ltd.",
    "Marketing Name": "Germany",
    "Device": "S9714",
    "Model": "LIFETAB_S9714"
  },
  {
    "Retail Branding": "Hon Hai Precision Industry Co., Ltd.",
    "Marketing Name": "nabi_XD",
    "Device": "XD",
    "Model": "NABIXD-NV10C"
  },
  {
    "Retail Branding": "Honda",
    "Marketing Name": "A-DA",
    "Device": "e1853",
    "Model": "14A-DA"
  },
  {
    "Retail Branding": "Honda",
    "Marketing Name": "A-DA",
    "Device": "e1853",
    "Model": "MY15ADA"
  },
  {
    "Retail Branding": "Honda",
    "Marketing Name": "A-DA",
    "Device": "sakura",
    "Model": "MY18ADA"
  },
  {
    "Retail Branding": "Honda",
    "Marketing Name": "A-DA",
    "Device": "vcm30t30",
    "Model": "MY17ADA"
  },
  {
    "Retail Branding": "Honda",
    "Marketing Name": "A-DA",
    "Device": "vcm30t30",
    "Model": "MY18ADA"
  },
  {
    "Retail Branding": "Honda",
    "Marketing Name": "A-DA",
    "Device": "yebisuAA",
    "Model": "MY20ADA"
  },
  {
    "Retail Branding": "Honda",
    "Marketing Name": "A-DA",
    "Device": "yebisuBA",
    "Model": "MY20ADA"
  },
  {
    "Retail Branding": "Honda",
    "Marketing Name": "A-DA",
    "Device": "yebisuCA",
    "Model": "MY21ADA"
  },
  {
    "Retail Branding": "Honda",
    "Marketing Name": "A-DA",
    "Device": "yebisuDA",
    "Model": "MY21ADA"
  },
  {
    "Retail Branding": "Honda",
    "Marketing Name": "A-DA",
    "Device": "yebisuFA",
    "Model": "MY22ADA"
  },
  {
    "Retail Branding": "Honda",
    "Marketing Name": "A-DA",
    "Device": "yebisuGA",
    "Model": "MY22ADA"
  },
  {
    "Retail Branding": "Honda",
    "Marketing Name": "A-DA",
    "Device": "yebisuHA",
    "Model": "MY22ADA"
  },
  {
    "Retail Branding": "Honda",
    "Marketing Name": "Accord",
    "Device": "koelsch",
    "Model": "MY16ADA"
  },
  {
    "Retail Branding": "Honda",
    "Marketing Name": "Gathers",
    "Device": "pl0a",
    "Model": "22M Gathers"
  },
  {
    "Retail Branding": "Honda",
    "Marketing Name": "Gathers",
    "Device": "pr3a_arm64",
    "Model": "Gathers PR3A"
  },
  {
    "Retail Branding": "Honda",
    "Marketing Name": "IVI-SYSTEM",
    "Device": "emu_pub_h_30a_g_car",
    "Model": "IVI-SYSTEM"
  },
  {
    "Retail Branding": "Honda",
    "Marketing Name": "IVI-SYSTEM",
    "Device": "msmnile_au",
    "Model": "IVI-SYSTEM"
  },
  {
    "Retail Branding": "Honda",
    "Marketing Name": "MY15ADA",
    "Device": "koelsch",
    "Model": "MY15ADA"
  },
  {
    "Retail Branding": "Honda",
    "Marketing Name": "NSX",
    "Device": "koelsch",
    "Model": "MY15ADA"
  },
  {
    "Retail Branding": "Honda",
    "Marketing Name": "Pilot",
    "Device": "koelsch",
    "Model": "MY15ADA"
  },
  {
    "Retail Branding": "Honda",
    "Marketing Name": "Ridgeline",
    "Device": "koelsch",
    "Model": "MY15ADA"
  },
  {
    "Retail Branding": "Honda",
    "Marketing Name": "Ridgline",
    "Device": "koelsch",
    "Model": "MY15ADA"
  },
  {
    "Retail Branding": "Honda",
    "Marketing Name": "S660",
    "Device": "koelsch",
    "Model": "MY19ADA"
  },
  {
    "Retail Branding": "Honda",
    "Marketing Name": "Spirior",
    "Device": "koelsch",
    "Model": "MY15ADA"
  },
  {
    "Retail Branding": "Honda",
    "Marketing Name": "Unit Assy AVN",
    "Device": "h16",
    "Model": "SiRFSoC Android"
  },
  {
    "Retail Branding": "Honeywell",
    "Marketing Name": "70eL00",
    "Device": "dblack",
    "Model": "Dolphin 70e Black"
  },
  {
    "Retail Branding": "Honeywell",
    "Marketing Name": "70eLGN",
    "Device": "dblack_gn",
    "Model": "Dolphin 70e Black"
  },
  {
    "Retail Branding": "Honeywell",
    "Marketing Name": "70eLGN",
    "Device": "dblack_go",
    "Model": "Dolphin 70e Black"
  },
  {
    "Retail Branding": "Honeywell",
    "Marketing Name": "70eLW0",
    "Device": "dblack_wo",
    "Model": "Dolphin 70e Black"
  },
  {
    "Retail Branding": "Honeywell",
    "Marketing Name": "70eLWN",
    "Device": "dblack_wn",
    "Model": "Dolphin 70e Black"
  },
  {
    "Retail Branding": "Honeywell",
    "Marketing Name": "CK62",
    "Device": "CK62",
    "Model": "CK62"
  },
  {
    "Retail Branding": "Honeywell",
    "Marketing Name": "CK65",
    "Device": "CK65-L0-C",
    "Model": "CK65"
  },
  {
    "Retail Branding": "Honeywell",
    "Marketing Name": "CK65",
    "Device": "CK65-L0-N",
    "Model": "CK65"
  },
  {
    "Retail Branding": "Honeywell",
    "Marketing Name": "CK67",
    "Device": "CK67",
    "Model": "CK67"
  },
  {
    "Retail Branding": "Honeywell",
    "Marketing Name": "CK75",
    "Device": "CK75",
    "Model": "CX75 AC0"
  },
  {
    "Retail Branding": "Honeywell",
    "Marketing Name": "CK75",
    "Device": "CK75",
    "Model": "CX75 AN0"
  },
  {
    "Retail Branding": "Honeywell",
    "Marketing Name": "CN51",
    "Device": "CN51_NC0",
    "Model": "CN51 NC0"
  },
  {
    "Retail Branding": "Honeywell",
    "Marketing Name": "CN51",
    "Device": "CN51_NCF",
    "Model": "CN51 NCF"
  },
  {
    "Retail Branding": "Honeywell",
    "Marketing Name": "CN51",
    "Device": "CN51_NCU",
    "Model": "CN51 NCU"
  },
  {
    "Retail Branding": "Honeywell",
    "Marketing Name": "CN51",
    "Device": "CN51_NN0",
    "Model": "CN51 NN0"
  },
  {
    "Retail Branding": "Honeywell",
    "Marketing Name": "CN51",
    "Device": "CN51_QC0",
    "Model": "CN51 QC0"
  },
  {
    "Retail Branding": "Honeywell",
    "Marketing Name": "CN51",
    "Device": "CN51_QCF",
    "Model": "CN51 QCF"
  },
  {
    "Retail Branding": "Honeywell",
    "Marketing Name": "CN51",
    "Device": "CN51_QCU",
    "Model": "CN51 QCU"
  },
  {
    "Retail Branding": "Honeywell",
    "Marketing Name": "CN51",
    "Device": "CN51_QN0",
    "Model": "CN51 QN0"
  },
  {
    "Retail Branding": "Honeywell",
    "Marketing Name": "CN75",
    "Device": "CN75",
    "Model": "CX75 NC0"
  },
  {
    "Retail Branding": "Honeywell",
    "Marketing Name": "CN75",
    "Device": "CN75",
    "Model": "CX75 NCF"
  },
  {
    "Retail Branding": "Honeywell",
    "Marketing Name": "CN75",
    "Device": "CN75",
    "Model": "CX75 QC0"
  },
  {
    "Retail Branding": "Honeywell",
    "Marketing Name": "CN75",
    "Device": "CN75",
    "Model": "CX75 QCF"
  },
  {
    "Retail Branding": "Honeywell",
    "Marketing Name": "CN75E",
    "Device": "CN75E",
    "Model": "CX75 NC0"
  },
  {
    "Retail Branding": "Honeywell",
    "Marketing Name": "CN75E",
    "Device": "CN75E",
    "Model": "CX75 NCF"
  },
  {
    "Retail Branding": "Honeywell",
    "Marketing Name": "CN75E",
    "Device": "CN75E",
    "Model": "CX75 QC0"
  },
  {
    "Retail Branding": "Honeywell",
    "Marketing Name": "CN75E",
    "Device": "CN75E",
    "Model": "CX75 QCF"
  },
  {
    "Retail Branding": "Honeywell",
    "Marketing Name": "CN80",
    "Device": "CN80-L0-C",
    "Model": "CN80"
  },
  {
    "Retail Branding": "Honeywell",
    "Marketing Name": "CN80",
    "Device": "CN80-L0-N",
    "Model": "CN80"
  },
  {
    "Retail Branding": "Honeywell",
    "Marketing Name": "CN80",
    "Device": "CN80-L1-C",
    "Model": "CN80"
  },
  {
    "Retail Branding": "Honeywell",
    "Marketing Name": "CN80",
    "Device": "CN80-L1-N",
    "Model": "CN80"
  },
  {
    "Retail Branding": "Honeywell",
    "Marketing Name": "CN80",
    "Device": "CN80G-L0-C",
    "Model": "CN80"
  },
  {
    "Retail Branding": "Honeywell",
    "Marketing Name": "CN80",
    "Device": "CN80G-L0-C-B",
    "Model": "CN80"
  },
  {
    "Retail Branding": "Honeywell",
    "Marketing Name": "CN80",
    "Device": "CN80G-L0-N",
    "Model": "CN80"
  },
  {
    "Retail Branding": "Honeywell",
    "Marketing Name": "CN80",
    "Device": "CN80G-L0-N-B",
    "Model": "CN80"
  },
  {
    "Retail Branding": "Honeywell",
    "Marketing Name": "CN80",
    "Device": "CN80G-L1-N",
    "Model": "CN80"
  },
  {
    "Retail Branding": "Honeywell",
    "Marketing Name": "CN85",
    "Device": "CN85-L0-C",
    "Model": "CN85"
  },
  {
    "Retail Branding": "Honeywell",
    "Marketing Name": "CN85",
    "Device": "CN85-L1-C",
    "Model": "CN85"
  },
  {
    "Retail Branding": "Honeywell",
    "Marketing Name": "CS32",
    "Device": "CS32",
    "Model": "CS32"
  },
  {
    "Retail Branding": "Honeywell",
    "Marketing Name": "CT30XP",
    "Device": "CT30P",
    "Model": "CT30P"
  },
  {
    "Retail Branding": "Honeywell",
    "Marketing Name": "CT32",
    "Device": "CT32",
    "Model": "CT32"
  },
  {
    "Retail Branding": "Honeywell",
    "Marketing Name": "CT37",
    "Device": "CT37",
    "Model": "CT37"
  },
  {
    "Retail Branding": "Honeywell",
    "Marketing Name": "CT37",
    "Device": "CT37T",
    "Model": "CT37"
  },
  {
    "Retail Branding": "Honeywell",
    "Marketing Name": "CT40",
    "Device": "CT40-L0-C",
    "Model": "CT40"
  },
  {
    "Retail Branding": "Honeywell",
    "Marketing Name": "CT40",
    "Device": "CT40-L0-CA",
    "Model": "CT40"
  },
  {
    "Retail Branding": "Honeywell",
    "Marketing Name": "CT40",
    "Device": "CT40-L1-C",
    "Model": "CT40"
  },
  {
    "Retail Branding": "Honeywell",
    "Marketing Name": "CT40P",
    "Device": "CT40P-L1-D",
    "Model": "CT40"
  },
  {
    "Retail Branding": "Honeywell",
    "Marketing Name": "CT40P-L0-D",
    "Device": "CT40P-L0-D",
    "Model": "CT40"
  },
  {
    "Retail Branding": "Honeywell",
    "Marketing Name": "CT40XP",
    "Device": "CT40P-L0-F",
    "Model": "CT40"
  },
  {
    "Retail Branding": "Honeywell",
    "Marketing Name": "CT40XP",
    "Device": "CT40P-L1-F",
    "Model": "CT40"
  },
  {
    "Retail Branding": "Honeywell",
    "Marketing Name": "CT45",
    "Device": "CT45",
    "Model": "CT45"
  },
  {
    "Retail Branding": "Honeywell",
    "Marketing Name": "CT45 XP",
    "Device": "CT45P",
    "Model": "CT45P"
  },
  {
    "Retail Branding": "Honeywell",
    "Marketing Name": "CT45XP",
    "Device": "CT45P",
    "Model": "CT45P"
  },
  {
    "Retail Branding": "Honeywell",
    "Marketing Name": "CT47",
    "Device": "CT47",
    "Model": "CT47"
  },
  {
    "Retail Branding": "Honeywell",
    "Marketing Name": "CT50",
    "Device": "CT50L0N-CS12S",
    "Model": "CT50"
  },
  {
    "Retail Branding": "Honeywell",
    "Marketing Name": "CT50",
    "Device": "CT50L0N-CS15S",
    "Model": "CT50"
  },
  {
    "Retail Branding": "Honeywell",
    "Marketing Name": "CT50",
    "Device": "CT50L0N-CS16S",
    "Model": "CT50"
  },
  {
    "Retail Branding": "Honeywell",
    "Marketing Name": "CT50",
    "Device": "CT50LFN-CS16S",
    "Model": "CT50"
  },
  {
    "Retail Branding": "Honeywell",
    "Marketing Name": "CT50",
    "Device": "CT50LUN-CS12S",
    "Model": "CT50"
  },
  {
    "Retail Branding": "Honeywell",
    "Marketing Name": "CT50",
    "Device": "CT50LUN-CS15S",
    "Model": "CT50"
  },
  {
    "Retail Branding": "Honeywell",
    "Marketing Name": "CT50",
    "Device": "CT50LUN-CS16S",
    "Model": "CT50"
  },
  {
    "Retail Branding": "Honeywell",
    "Marketing Name": "CT60",
    "Device": "CT60-L0-C",
    "Model": "CT60"
  },
  {
    "Retail Branding": "Honeywell",
    "Marketing Name": "CT60",
    "Device": "CT60-L0N-ASC",
    "Model": "CT60"
  },
  {
    "Retail Branding": "Honeywell",
    "Marketing Name": "CT60",
    "Device": "CT60-L1-C",
    "Model": "CT60"
  },
  {
    "Retail Branding": "Honeywell",
    "Marketing Name": "CT70",
    "Device": "CT70",
    "Model": "CT70"
  },
  {
    "Retail Branding": "Honeywell",
    "Marketing Name": "CW45",
    "Device": "CW45",
    "Model": "CW45"
  },
  {
    "Retail Branding": "Honeywell",
    "Marketing Name": "D75E",
    "Device": "75E-L0N",
    "Model": "D75E"
  },
  {
    "Retail Branding": "Honeywell",
    "Marketing Name": "Dolphin 70e Black",
    "Device": "dblack_gn",
    "Model": "Dolphin 70e Black"
  },
  {
    "Retail Branding": "Honeywell",
    "Marketing Name": "Dolphin 70e Black",
    "Device": "dblack_go",
    "Model": "Dolphin 70e Black"
  },
  {
    "Retail Branding": "Honeywell",
    "Marketing Name": "Dolphin 70e Black",
    "Device": "dblack_wn",
    "Model": "Dolphin 70e Black"
  },
  {
    "Retail Branding": "Honeywell",
    "Marketing Name": "Dolphin 70e Black",
    "Device": "dblack_wo",
    "Model": "Dolphin 70e Black"
  },
  {
    "Retail Branding": "Honeywell",
    "Marketing Name": "Dolphin CT50",
    "Device": "CT50L0N-CS13S",
    "Model": "CT50"
  },
  {
    "Retail Branding": "Honeywell",
    "Marketing Name": "Dolphin CT50",
    "Device": "CT50LFN-CS13S",
    "Model": "CT50"
  },
  {
    "Retail Branding": "Honeywell",
    "Marketing Name": "Dolphin CT50",
    "Device": "CT50LUN-CS13S",
    "Model": "CT50"
  },
  {
    "Retail Branding": "Honeywell",
    "Marketing Name": "EDA10A",
    "Device": "EDA10A",
    "Model": "EDA10A"
  },
  {
    "Retail Branding": "Honeywell",
    "Marketing Name": "EDA40",
    "Device": "EDA40-0",
    "Model": "EDA40"
  },
  {
    "Retail Branding": "Honeywell",
    "Marketing Name": "EDA40",
    "Device": "EDA40-1",
    "Model": "EDA40"
  },
  {
    "Retail Branding": "Honeywell",
    "Marketing Name": "EDA50",
    "Device": "eda50-011",
    "Model": "EDA50"
  },
  {
    "Retail Branding": "Honeywell",
    "Marketing Name": "EDA50",
    "Device": "eda50-111",
    "Model": "EDA50"
  },
  {
    "Retail Branding": "Honeywell",
    "Marketing Name": "EDA50",
    "Device": "eda50-111",
    "Model": "Glory50"
  },
  {
    "Retail Branding": "Honeywell",
    "Marketing Name": "EDA50",
    "Device": "eda50-211",
    "Model": "EDA50"
  },
  {
    "Retail Branding": "Honeywell",
    "Marketing Name": "EDA50K",
    "Device": "eda50k-0",
    "Model": "EDA50K"
  },
  {
    "Retail Branding": "Honeywell",
    "Marketing Name": "EDA50K",
    "Device": "eda50k-1",
    "Model": "EDA50K"
  },
  {
    "Retail Branding": "Honeywell",
    "Marketing Name": "EDA50K",
    "Device": "eda50k-1",
    "Model": "Glory EDA50K"
  },
  {
    "Retail Branding": "Honeywell",
    "Marketing Name": "EDA50P",
    "Device": "EDA50P-0",
    "Model": "EDA50P"
  },
  {
    "Retail Branding": "Honeywell",
    "Marketing Name": "EDA50P",
    "Device": "EDA50P-1",
    "Model": "EDA50P"
  },
  {
    "Retail Branding": "Honeywell",
    "Marketing Name": "EDA51",
    "Device": "EDA51-0",
    "Model": "EDA51"
  },
  {
    "Retail Branding": "Honeywell",
    "Marketing Name": "EDA51",
    "Device": "EDA51-1",
    "Model": "EDA51"
  },
  {
    "Retail Branding": "Honeywell",
    "Marketing Name": "EDA51K",
    "Device": "EDA51K-0",
    "Model": "EDA51K"
  },
  {
    "Retail Branding": "Honeywell",
    "Marketing Name": "EDA51K",
    "Device": "EDA51K-1",
    "Model": "EDA51K"
  },
  {
    "Retail Branding": "Honeywell",
    "Marketing Name": "EDA52",
    "Device": "EDA52",
    "Model": "EDA52"
  },
  {
    "Retail Branding": "Honeywell",
    "Marketing Name": "EDA56",
    "Device": "EDA56",
    "Model": "EDA56"
  },
  {
    "Retail Branding": "Honeywell",
    "Marketing Name": "EDA56-0",
    "Device": "EDA52",
    "Model": "EDA56"
  },
  {
    "Retail Branding": "Honeywell",
    "Marketing Name": "EDA57",
    "Device": "EDA57",
    "Model": "EDA57"
  },
  {
    "Retail Branding": "Honeywell",
    "Marketing Name": "EDA5S",
    "Device": "EDA5S",
    "Model": "EDA5S"
  },
  {
    "Retail Branding": "Honeywell",
    "Marketing Name": "EDA61K",
    "Device": "EDA61K-0C",
    "Model": "EDA61K"
  },
  {
    "Retail Branding": "Honeywell",
    "Marketing Name": "EDA61K",
    "Device": "EDA61K-0U",
    "Model": "EDA61K"
  },
  {
    "Retail Branding": "Honeywell",
    "Marketing Name": "EDA61K",
    "Device": "EDA61K-1C",
    "Model": "EDA61K"
  },
  {
    "Retail Branding": "Honeywell",
    "Marketing Name": "EDA61K",
    "Device": "EDA61K-1U",
    "Model": "EDA61K"
  },
  {
    "Retail Branding": "Honeywell",
    "Marketing Name": "EDA70",
    "Device": "eda70-0",
    "Model": "EDA70"
  },
  {
    "Retail Branding": "Honeywell",
    "Marketing Name": "EDA70",
    "Device": "eda70-3",
    "Model": "EDA70"
  },
  {
    "Retail Branding": "Honeywell",
    "Marketing Name": "EDA71",
    "Device": "EDA71-0",
    "Model": "EDA71_G"
  },
  {
    "Retail Branding": "Honeywell",
    "Marketing Name": "EDA71",
    "Device": "EDA71-1",
    "Model": "EDA71_G"
  },
  {
    "Retail Branding": "Honeywell",
    "Marketing Name": "EdA50",
    "Device": "eda50-211",
    "Model": "EDA50"
  },
  {
    "Retail Branding": "Honeywell",
    "Marketing Name": "HMS-PD-X1C-3",
    "Device": "HMS-PD-X1C-3",
    "Model": "HMS-PD-X1C-3"
  },
  {
    "Retail Branding": "Honeywell",
    "Marketing Name": "MT10",
    "Device": "MT10",
    "Model": "MT10"
  },
  {
    "Retail Branding": "Honeywell",
    "Marketing Name": "RT10A",
    "Device": "TA60A-L0-C",
    "Model": "RT10A"
  },
  {
    "Retail Branding": "Honeywell",
    "Marketing Name": "RT10A",
    "Device": "TA60A-L0-C",
    "Model": "TA60A"
  },
  {
    "Retail Branding": "Honeywell",
    "Marketing Name": "RT10A",
    "Device": "TA60A-L1-C",
    "Model": "RT10A"
  },
  {
    "Retail Branding": "Honeywell",
    "Marketing Name": "RT10A",
    "Device": "TA60A-L1-C",
    "Model": "TA60A"
  },
  {
    "Retail Branding": "Honeywell",
    "Marketing Name": "RT60A",
    "Device": "TA60A-L1-C",
    "Model": "TA60A"
  },
  {
    "Retail Branding": "Honeywell",
    "Marketing Name": "Thor VM1A",
    "Device": "VM1A-L0-N",
    "Model": "VM1A"
  },
  {
    "Retail Branding": "Honeywell",
    "Marketing Name": "Thor VM1A",
    "Device": "VM1A-L0-P",
    "Model": "VM1A"
  },
  {
    "Retail Branding": "Honeywell",
    "Marketing Name": "Thor VM3A",
    "Device": "VM3A-L0-N",
    "Model": "VM3A"
  },
  {
    "Retail Branding": "Honeywell",
    "Marketing Name": "Thor VM3A",
    "Device": "VM3A-L0-P",
    "Model": "VM3A"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "Elsa",
    "Device": "HNELA-M",
    "Model": "ELA-LX2"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "Elsa",
    "Device": "HNELA-M",
    "Model": "ELA-LX3"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "HONOR  X9d",
    "Device": "HNMTN-Q1",
    "Model": "MTN-NX1"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "HONOR 100",
    "Device": "HNMAA",
    "Model": "MAA-AN00"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "HONOR 100 Pro",
    "Device": "HNMAP",
    "Model": "MAA-AN10"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "HONOR 200",
    "Device": "HNELI",
    "Model": "ELI-AN00"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "HONOR 200",
    "Device": "HNELIX",
    "Model": "ELI-NX9"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "HONOR 200 Pro",
    "Device": "HNELP",
    "Model": "ELP-AN00"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "HONOR 200 Pro",
    "Device": "HNELPX",
    "Model": "ELP-NX9"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "HONOR 200 Smart",
    "Device": "HNALT-Q1",
    "Model": "ALT-NX1"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "HONOR 200 Smart",
    "Device": "HNALT-Q2",
    "Model": "ALT-NX3"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "HONOR 400",
    "Device": "HNDNYX",
    "Model": "DNY-NX9"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "HONOR 400 Lite",
    "Device": "HNABR-M",
    "Model": "ABR-NX1"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "HONOR 400 Lite",
    "Device": "HNABR-M",
    "Model": "ABR-NX3"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "HONOR 400 Pro",
    "Device": "HNDNPX",
    "Model": "DNP-NX9"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "HONOR 400 Smart",
    "Device": "HNLGN-Q1",
    "Model": "LGN-NX1"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "HONOR 400 Smart",
    "Device": "HNLGN-Q1",
    "Model": "LGN-NX3"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "HONOR 50",
    "Device": "HNNTH",
    "Model": "NTH-NX9"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "HONOR 50 Lite",
    "Device": "HNNTN",
    "Model": "NTN-L22"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "HONOR 50 Lite",
    "Device": "HNNTN",
    "Model": "NTN-LX1"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "HONOR 50 Lite",
    "Device": "HNNTN",
    "Model": "NTN-LX3"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "HONOR 500",
    "Device": "HNMEY",
    "Model": "MEY-AN00"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "HONOR 600 Lite",
    "Device": "HNLNA-M1",
    "Model": "LNA-NX1"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "HONOR 600e",
    "Device": "HNLNA-M1",
    "Model": "LNA-NX3"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "HONOR 70",
    "Device": "HNFNE",
    "Model": "FNE-NX9"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "HONOR 70 Lite",
    "Device": "HNRBN-Q",
    "Model": "RBN-NX1"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "HONOR 90",
    "Device": "HNREA",
    "Model": "REA-NX9"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "HONOR 90 GT",
    "Device": "HNMAG",
    "Model": "MAG-AN00"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "HONOR 90 Lite",
    "Device": "HNCRT-M2",
    "Model": "CRT-NX1"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "HONOR 90 Lite",
    "Device": "HNCRT-M2",
    "Model": "CRT-NX3"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "HONOR 90 Smart",
    "Device": "HNCLK-M1",
    "Model": "CLK-NX1"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "HONOR 90 Smart",
    "Device": "HNCLK-M1",
    "Model": "CLK-NX3"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "HONOR Magic V2",
    "Device": "HNVER",
    "Model": "VER-N49"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "HONOR Magic V3",
    "Device": "HNFCPX",
    "Model": "FCP-N49"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "HONOR Magic V5",
    "Device": "HNMBHX",
    "Model": "MBH-N49"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "HONOR Magic Vs",
    "Device": "HNFRI",
    "Model": "FRI-NX9"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "HONOR Magic4 Lite",
    "Device": "HNANY-Q1",
    "Model": "ANY-LX1"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "HONOR Magic4 Lite 5G",
    "Device": "HNANY-Q",
    "Model": "ANY-NX1"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "HONOR Magic4 Pro",
    "Device": "HNLGE",
    "Model": "LGE-NX9"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "HONOR Magic5",
    "Device": "HNPGT",
    "Model": "PGT-N09"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "HONOR Magic5 Lite 5G",
    "Device": "HNRMO-Q",
    "Model": "RMO-NX1"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "HONOR Magic5 Lite 5G",
    "Device": "HNRMO-Q",
    "Model": "RMO-NX3"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "HONOR Magic5 Pro",
    "Device": "HNPGT",
    "Model": "PGT-N19"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "HONOR Magic6",
    "Device": "HNBVL-AN00",
    "Model": "BVL-AN00"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "HONOR Magic6 Lite 5G",
    "Device": "HNALI-Q",
    "Model": "ALI-NX1"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "HONOR Magic6 Lite 5G",
    "Device": "HNALI-Q",
    "Model": "ALI-NX3"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "HONOR Magic6 Pro",
    "Device": "HNBVL",
    "Model": "BVL-AN16"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "HONOR Magic6 Pro",
    "Device": "HNBVL",
    "Model": "BVL-N49"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "HONOR Magic7",
    "Device": "HNPLPX",
    "Model": "PTP-N29"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "HONOR Magic7 Lite",
    "Device": "HNBRP-Q1",
    "Model": "BRP-NX1M"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "HONOR Magic7 Lite",
    "Device": "HNBRP-Q1",
    "Model": "BRP-NX3"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "HONOR Magic7 Pro",
    "Device": "HNPTPX",
    "Model": "PTP-N49"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "HONOR Magic8 Lite",
    "Device": "HNMTN-Q1",
    "Model": "MTN-NX1M"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "HONOR Magic8 Lite",
    "Device": "HNMTN-Q1",
    "Model": "MTN-NX3"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "HONOR Magic8 pro",
    "Device": "HNBKQ",
    "Model": "BKQ-N49"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "HONOR MagicPad2",
    "Device": "HNROD2-Q",
    "Model": "ROD2-W09"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "HONOR MagicPad2",
    "Device": "HNROD2-Q1",
    "Model": "ROD2-W09"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "HONOR MagicPad3",
    "Device": "HNCGA-Q1",
    "Model": "CGA-W00"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "HONOR MagicPad4",
    "Device": "HNYLE-Q1",
    "Model": "YLE-W09"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "HONOR Pad 10",
    "Device": "HNHEY3-Q1",
    "Model": "HEY3-N09"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "HONOR Pad 10",
    "Device": "HNHEY3-Q1",
    "Model": "HEY3-W00"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "HONOR Pad 8",
    "Device": "HNHEY-Q",
    "Model": "HEY-W09"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "HONOR Pad 9",
    "Device": "HNHEY2-Q",
    "Model": "HEY2-N09"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "HONOR Pad 9",
    "Device": "HNHEY2-Q",
    "Model": "HEY2-W09"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "HONOR Pad V9",
    "Device": "HNROL-M1",
    "Model": "ROL-W00"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "HONOR Pad X7",
    "Device": "JMS-W09",
    "Model": "JMS-W09"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "HONOR Pad X8",
    "Device": "HNAGM3",
    "Model": "AGM3-AL09HN"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "HONOR Pad X8",
    "Device": "HNAGM3",
    "Model": "AGM3-W09HN"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "HONOR Pad X8 Lite",
    "Device": "HNAGM",
    "Model": "AGM-W09HN"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "HONOR Pad X8a",
    "Device": "HNNDL-Q",
    "Model": "NDL-L03"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "HONOR Pad X8a",
    "Device": "HNNDL-Q",
    "Model": "NDL-L09"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "HONOR Pad X8a",
    "Device": "HNNDL-Q",
    "Model": "NDL-W09"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "HONOR Pad X8b",
    "Device": "HNNDL2-Q",
    "Model": "NDL2-L03"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "HONOR Pad X8b",
    "Device": "HNNDL2-Q",
    "Model": "NDL2-L09"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "HONOR Pad X8b",
    "Device": "HNNDL2-Q",
    "Model": "NDL2-W09"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "HONOR Pad X9",
    "Device": "HNELN-Q",
    "Model": "ELN-L03"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "HONOR Pad X9",
    "Device": "HNELN-Q",
    "Model": "ELN-L09"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "HONOR Pad X9",
    "Device": "HNELN-Q",
    "Model": "ELN-W09"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "HONOR Pad X9a",
    "Device": "HNELN2-Q1",
    "Model": "ELN2-L23"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "HONOR Pad X9a",
    "Device": "HNELN2-Q1",
    "Model": "ELN2-L29"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "HONOR Pad X9a",
    "Device": "HNELN2-Q1",
    "Model": "ELN2-W29"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "HONOR Play9A",
    "Device": "HNGFY-M",
    "Model": "GFY-LX3"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "HONOR Play9C",
    "Device": "HNNIC-M1",
    "Model": "NIC-LX3P"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "HONOR X5",
    "Device": "HNVNA-M",
    "Model": "VNA-LX2"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "HONOR X5",
    "Device": "HNVNA-M",
    "Model": "VNA-LX3"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "HONOR X5 Plus",
    "Device": "HNWDY-M",
    "Model": "WOD-LX1"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "HONOR X5 Plus",
    "Device": "HNWDY-M",
    "Model": "WOD-LX2"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "HONOR X5 Plus",
    "Device": "HNWDY-M",
    "Model": "WOD-LX3"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "HONOR X5b",
    "Device": "HNGFY-M",
    "Model": "GFY-LX2"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "HONOR X5b",
    "Device": "HNGFY-M",
    "Model": "GFY-LX3"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "HONOR X5b Plus",
    "Device": "HNGFY-M",
    "Model": "GFY-LX2P"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "HONOR X5c",
    "Device": "HNNLA-M",
    "Model": "NLA-LX2"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "HONOR X5c",
    "Device": "HNNLA-M",
    "Model": "NLA-LX3"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "HONOR X5c Plus",
    "Device": "HNNLA-M",
    "Model": "NLA-LX1"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "HONOR X5c Plus",
    "Device": "HNNLA-M",
    "Model": "NLA-LX2P"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "HONOR X5d",
    "Device": "HNNLA-M",
    "Model": "NAA-LX2"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "HONOR X5d Plus",
    "Device": "HNNLA-M",
    "Model": "NAA-LX2P"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "HONOR X6",
    "Device": "HNVNE-M",
    "Model": "VNE-LX1"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "HONOR X6",
    "Device": "HNVNE-M",
    "Model": "VNE-LX2"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "HONOR X6",
    "Device": "HNVNE-M",
    "Model": "VNE-LX3"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "HONOR X6a",
    "Device": "HNWDY-M",
    "Model": "WDY-LX1"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "HONOR X6a",
    "Device": "HNWDY-M",
    "Model": "WDY-LX2"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "HONOR X6a",
    "Device": "HNWDY-M",
    "Model": "WDY-LX3"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "HONOR X6b",
    "Device": "HNJDY-M1",
    "Model": "JDY-LX1"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "HONOR X6b",
    "Device": "HNJDY-M1",
    "Model": "JDY-LX2"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "HONOR X6b",
    "Device": "HNJDY-M1",
    "Model": "JDY-LX3P"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "HONOR X6b 5G",
    "Device": "HNALT-Q2",
    "Model": "ALT-NX3"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "HONOR X6b Plus",
    "Device": "HNJDY-M1",
    "Model": "JDY-LX3"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "HONOR X6c",
    "Device": "HNNIC-M1",
    "Model": "NIC-LX1"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "HONOR X6c",
    "Device": "HNNIC-M1",
    "Model": "NIC-LX2"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "HONOR X6c",
    "Device": "HNNIC-M1",
    "Model": "NIC-LX3"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "HONOR X6d 5G",
    "Device": "HNNLA-M2",
    "Model": "NLA-NX1"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "HONOR X6d 5G",
    "Device": "HNNLA-M2",
    "Model": "NLA-NX3"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "HONOR X7",
    "Device": "HNCMA-Q",
    "Model": "CMA-LX1"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "HONOR X7",
    "Device": "HNCMA-Q",
    "Model": "CMA-LX2"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "HONOR X7",
    "Device": "HNCMA-Q",
    "Model": "CMA-LX3"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "HONOR X7a",
    "Device": "HNRKY-M1",
    "Model": "RKY-LX1"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "HONOR X7a",
    "Device": "HNRKY-M1",
    "Model": "RKY-LX2"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "HONOR X7a",
    "Device": "HNRKY-M1",
    "Model": "RKY-LX3"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "HONOR X7b",
    "Device": "",
    "Model": "CLK-LX1"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "HONOR X7b",
    "Device": "HNCLK-Q",
    "Model": "CLK-LX1"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "HONOR X7b",
    "Device": "HNCLK-Q",
    "Model": "CLK-LX2"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "HONOR X7b",
    "Device": "HNCLK-Q",
    "Model": "CLK-LX3"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "HONOR X7b 5G",
    "Device": "HNCLK-M1",
    "Model": "CLK-NX1"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "HONOR X7b 5G",
    "Device": "HNCLK-M1",
    "Model": "CLK-NX2"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "HONOR X7c",
    "Device": "HNALT-QL",
    "Model": "ALT-LX1"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "HONOR X7c",
    "Device": "HNALT-QL",
    "Model": "ALT-LX2"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "HONOR X7c",
    "Device": "HNALT-QL",
    "Model": "ALT-LX3"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "HONOR X7c 5G",
    "Device": "HNALT-Q1",
    "Model": "ALT-NX1"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "HONOR X7d",
    "Device": "HNLGN-QL",
    "Model": "LGN-LX1"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "HONOR X7d",
    "Device": "HNLGN-QL",
    "Model": "LGN-LX2"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "HONOR X7d",
    "Device": "HNLGN-QL",
    "Model": "LGN-LX3"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "HONOR X8",
    "Device": "HNTFY-Q",
    "Model": "TFY-LX1"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "HONOR X8",
    "Device": "HNTFY-Q",
    "Model": "TFY-LX2"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "HONOR X8",
    "Device": "HNTFY-Q",
    "Model": "TFY-LX3"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "HONOR X8 5G",
    "Device": "HNVNE-Q",
    "Model": "VNE-N41"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "HONOR X8a",
    "Device": "HNCRT-M1",
    "Model": "CRT-LX1"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "HONOR X8a",
    "Device": "HNCRT-M1",
    "Model": "CRT-LX2"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "HONOR X8a",
    "Device": "HNCRT-M1",
    "Model": "CRT-LX3"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "HONOR X8a 5G",
    "Device": "HNRBN-Q",
    "Model": "RBN-NX3"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "HONOR X8b",
    "Device": "HNLLY-Q",
    "Model": "LLY-LX1"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "HONOR X8b",
    "Device": "HNLLY-Q",
    "Model": "LLY-LX2"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "HONOR X8b",
    "Device": "HNLLY-Q",
    "Model": "LLY-LX3"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "HONOR X8c",
    "Device": "HNABR-Q",
    "Model": "ABR-LX1"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "HONOR X8c",
    "Device": "HNABR-Q",
    "Model": "ABR-LX2"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "HONOR X8c",
    "Device": "HNABR-Q",
    "Model": "ABR-LX3"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "HONOR X8d",
    "Device": "HNLNA-Q",
    "Model": "LNA-LX2"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "HONOR X8d",
    "Device": "HNLNA-Q",
    "Model": "LNA-LX3"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "HONOR X9",
    "Device": "HNANY-Q1",
    "Model": "ANY-LX1"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "HONOR X9",
    "Device": "HNANY-Q1",
    "Model": "ANY-LX2"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "HONOR X9",
    "Device": "HNANY-Q1",
    "Model": "ANY-LX3"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "HONOR X9 5G",
    "Device": "HNANY-Q",
    "Model": "ANY-NX1"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "HONOR X9a 5G",
    "Device": "HNRMO-Q",
    "Model": "RMO-NX1"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "HONOR X9b 5G",
    "Device": "HNALI-Q",
    "Model": "ALI-NX1"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "HONOR X9c",
    "Device": "HNBRP-Q1",
    "Model": "BRP-NX1"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "Honor 200 Lite",
    "Device": "HNLLY-M1",
    "Model": "LLY-NX1"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "Honor 200 Lite",
    "Device": "HNLLY-M1",
    "Model": "LLY-NX3"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "Honor X9b 5G",
    "Device": "HNALI-Q",
    "Model": "ALI-NX3P"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "Honor X9c Smart",
    "Device": "HNBRC-M1",
    "Model": "BRC-NX1"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "MagicPad 3",
    "Device": "HNCGA-Q",
    "Model": "CGA-W00"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "MagicPad3 Pro 13.3",
    "Device": "HNYLP-Q",
    "Model": "YLP-W00"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "PORSCHE DESIGN HONOR Magic V2 RSR",
    "Device": "HNVER",
    "Model": "VER-N49DP"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "PORSCHE DESIGN HONOR Magic6",
    "Device": "HNBVL",
    "Model": "BVL-N59"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "PORSCHE DESIGN HONOR Magic6 RSR",
    "Device": "HNBVL",
    "Model": "BVL-AN20"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "PORSCHE DESIGN HONOR Magic7 RSR",
    "Device": "HNPTPX",
    "Model": "PTP-N59"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "荣耀Magic8 Pro Air",
    "Device": "HNLDY-M",
    "Model": "LDY-AN00"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "荣耀Power",
    "Device": "HNDVD-Q",
    "Model": "DVD-AN00"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "荣耀Power",
    "Device": "HNDVD-Q",
    "Model": "DVD-AN80"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "荣耀Power2",
    "Device": "HNSER-M",
    "Model": "SER-AN00"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "荣耀V Purse",
    "Device": "HNVCA-Q",
    "Model": "VCA-AN00"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "荣耀X60",
    "Device": "HNBRC-M",
    "Model": "BRC-AN00"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "荣耀X60 PRO",
    "Device": "HNBRP-Q",
    "Model": "BRP-AN00"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "荣耀X60 PRO",
    "Device": "HNBRP-Q",
    "Model": "BRP-AN80"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "荣耀X70",
    "Device": "HNMTN-Q",
    "Model": "MTN-AN00"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "荣耀X70",
    "Device": "HNMTN-Q",
    "Model": "MTN-AN80"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "荣耀平板 10",
    "Device": "HNHEY3-Q",
    "Model": "HEY3-W00"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "荣耀平板10",
    "Device": "HNHEY3-Q",
    "Model": "HEY3-W10"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "荣耀平板GT",
    "Device": "HNROL-M",
    "Model": "ROL-W60"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "荣耀平板GT PRO",
    "Device": "HNROD2-Q",
    "Model": "ROD2-W69"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "荣耀平板GT2 Pro",
    "Device": "HNCHG-Q",
    "Model": "CHG-W60"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "荣耀平板V9",
    "Device": "HNROL-M",
    "Model": "ROL-W00"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "荣耀平板V9",
    "Device": "HNROL-M",
    "Model": "ROL-W10"
  },
  {
    "Retail Branding": "Honor",
    "Marketing Name": "荣耀平板V9",
    "Device": "HNROL-M",
    "Model": "tb8792p1_64_wifi"
  },
  {
    "Retail Branding": "Hoozo",
    "Marketing Name": "AL-10",
    "Device": "AL-10",
    "Model": "AL-10"
  },
  {
    "Retail Branding": "Hoozo",
    "Marketing Name": "AL-10-EEA",
    "Device": "AL-10",
    "Model": "AL-10"
  },
  {
    "Retail Branding": "Hoozo",
    "Marketing Name": "AL-13-EEA",
    "Device": "AL-13",
    "Model": "AL-13"
  },
  {
    "Retail Branding": "Hoozo",
    "Marketing Name": "AX10",
    "Device": "AX10",
    "Model": "AX10"
  },
  {
    "Retail Branding": "Hoozo",
    "Marketing Name": "AX10_EEA",
    "Device": "AX10_EEA",
    "Model": "AX10_EEA"
  },
  {
    "Retail Branding": "Hoozo",
    "Marketing Name": "AX13",
    "Device": "AX13",
    "Model": "AX13"
  },
  {
    "Retail Branding": "Hoozo",
    "Marketing Name": "AX13_EEA",
    "Device": "AX13_EEA",
    "Model": "AX13_EEA"
  },
  {
    "Retail Branding": "Hoozo",
    "Marketing Name": "F13",
    "Device": "F13",
    "Model": "F13"
  },
  {
    "Retail Branding": "Hoozo",
    "Marketing Name": "F13_EEA",
    "Device": "F13_EEA",
    "Model": "F13_EEA"
  },
  {
    "Retail Branding": "Hoozo",
    "Marketing Name": "HZ0010",
    "Device": "HZ0010",
    "Model": "HZ0010"
  },
  {
    "Retail Branding": "Hoozo",
    "Marketing Name": "HZ0010J",
    "Device": "HZ0010J",
    "Model": "HZ0010J"
  },
  {
    "Retail Branding": "Hoozo",
    "Marketing Name": "HZ0011",
    "Device": "HZ0011",
    "Model": "HZ0011"
  },
  {
    "Retail Branding": "Hoozo",
    "Marketing Name": "HZ1012",
    "Device": "HZ1012",
    "Model": "HZ1012"
  },
  {
    "Retail Branding": "Hoozo",
    "Marketing Name": "KTLA133",
    "Device": "KTLA133",
    "Model": "KTLA133"
  },
  {
    "Retail Branding": "Hoozo",
    "Marketing Name": "MA768",
    "Device": "MA768",
    "Model": "MA768"
  },
  {
    "Retail Branding": "Hoozo",
    "Marketing Name": "MBR05",
    "Device": "MBR05",
    "Model": "MBR05"
  },
  {
    "Retail Branding": "Hoozo",
    "Marketing Name": "MBR05_EEA",
    "Device": "MBR05_EEA",
    "Model": "MBR05_EEA"
  },
  {
    "Retail Branding": "Hoozo",
    "Marketing Name": "MID",
    "Device": "MID",
    "Model": "MID"
  },
  {
    "Retail Branding": "Hoozo",
    "Marketing Name": "MR768",
    "Device": "MR768",
    "Model": "MR768"
  },
  {
    "Retail Branding": "Hoozo",
    "Marketing Name": "MR7863",
    "Device": "MR7863",
    "Model": "MR7863"
  },
  {
    "Retail Branding": "Hoozo",
    "Marketing Name": "MTP30",
    "Device": "MTP30",
    "Model": "MTP30"
  },
  {
    "Retail Branding": "Hoozo",
    "Marketing Name": "MTP30_EEA",
    "Device": "MTP30_EEA",
    "Model": "MTP30_EEA"
  },
  {
    "Retail Branding": "Hoozo",
    "Marketing Name": "MZ10863",
    "Device": "MZ10863",
    "Model": "MZ10863"
  },
  {
    "Retail Branding": "Hoozo",
    "Marketing Name": "MZ10863W",
    "Device": "MZ10863W",
    "Model": "MZ10863W"
  },
  {
    "Retail Branding": "Hoozo",
    "Marketing Name": "MZS10",
    "Device": "MZS10",
    "Model": "MZS10"
  },
  {
    "Retail Branding": "Hoozo",
    "Marketing Name": "T10A",
    "Device": "T10A",
    "Model": "T10A"
  },
  {
    "Retail Branding": "Hoozo",
    "Marketing Name": "YK_P30",
    "Device": "YK_P30",
    "Model": "YK_P30"
  },
  {
    "Retail Branding": "Hoozo",
    "Marketing Name": "YK_P30_EEA",
    "Device": "YK_P30_EEA",
    "Model": "YK_P30_EEA"
  },
  {
    "Retail Branding": "Horion",
    "Marketing Name": "IFPD",
    "Device": "65W72B",
    "Model": "W72B"
  },
  {
    "Retail Branding": "Horion",
    "Marketing Name": "K7A",
    "Device": "K7A",
    "Model": "K7A"
  },
  {
    "Retail Branding": "Horion",
    "Marketing Name": "M6APro",
    "Device": "M6APro",
    "Model": "M6APro"
  },
  {
    "Retail Branding": "Horion",
    "Marketing Name": "M6AProV2",
    "Device": "M6AProV2",
    "Model": "M6AProV2"
  },
  {
    "Retail Branding": "HorusVision",
    "Marketing Name": "FieldHub1_0_EEA",
    "Device": "FieldHub1_0",
    "Model": "FieldHub1_0"
  },
  {
    "Retail Branding": "HorusVision",
    "Marketing Name": "FieldHub1_0_ROW",
    "Device": "FieldHub1_0",
    "Model": "FieldHub1_0"
  },
  {
    "Retail Branding": "Hosoton",
    "Marketing Name": "H101_EEA",
    "Device": "H101",
    "Model": "H101"
  },
  {
    "Retail Branding": "Hot Pepper",
    "Marketing Name": "15 Pro Max",
    "Device": "15_Pro_Max",
    "Model": "15 Pro Max"
  },
  {
    "Retail Branding": "Hot Pepper",
    "Marketing Name": "18 Pro",
    "Device": "18_Pro",
    "Model": "18 Pro"
  },
  {
    "Retail Branding": "Hot Pepper",
    "Marketing Name": "19 Pro Max",
    "Device": "19_Pro_Max",
    "Model": "19 Pro Max"
  },
  {
    "Retail Branding": "Hot Pepper",
    "Marketing Name": "AJI",
    "Device": "AJI",
    "Model": "HPPR10A"
  },
  {
    "Retail Branding": "Hot Pepper",
    "Marketing Name": "AP17",
    "Device": "AP17",
    "Model": "AP17"
  },
  {
    "Retail Branding": "Hot Pepper",
    "Marketing Name": "Bola",
    "Device": "Bola",
    "Model": "Bola"
  },
  {
    "Retail Branding": "Hot Pepper",
    "Marketing Name": "Chilaca",
    "Device": "HPPL60A",
    "Model": "HPPL60A"
  },
  {
    "Retail Branding": "Hot Pepper",
    "Marketing Name": "Chilaca Plus",
    "Device": "HPPL60A",
    "Model": "HPPL60A"
  },
  {
    "Retail Branding": "Hot Pepper",
    "Marketing Name": "Chilaca Plus",
    "Device": "HPPL60B",
    "Model": "HPPL60B"
  },
  {
    "Retail Branding": "Hot Pepper",
    "Marketing Name": "DT10",
    "Device": "DT10_EEA",
    "Model": "DT10"
  },
  {
    "Retail Branding": "Hot Pepper",
    "Marketing Name": "Datil",
    "Device": "HPPL67A",
    "Model": "HPPL67A"
  },
  {
    "Retail Branding": "Hot Pepper",
    "Marketing Name": "Ghost",
    "Device": "HPP-GS1",
    "Model": "HPP-GS1"
  },
  {
    "Retail Branding": "Hot Pepper",
    "Marketing Name": "H5",
    "Device": "H5",
    "Model": "H5"
  },
  {
    "Retail Branding": "Hot Pepper",
    "Marketing Name": "HPPAP16",
    "Device": "HPPAP16",
    "Model": "HPPAP16"
  },
  {
    "Retail Branding": "Hot Pepper",
    "Marketing Name": "HPPAP33",
    "Device": "Puya_Plus",
    "Model": "HPPAP33"
  },
  {
    "Retail Branding": "Hot Pepper",
    "Marketing Name": "HPPH82A",
    "Device": "HPPH82A",
    "Model": "HPPH82A"
  },
  {
    "Retail Branding": "Hot Pepper",
    "Marketing Name": "HPPH88C",
    "Device": "Cascabel",
    "Model": "HPPH88C"
  },
  {
    "Retail Branding": "Hot Pepper",
    "Marketing Name": "K82A",
    "Device": "K82A",
    "Model": "K82A"
  },
  {
    "Retail Branding": "Hot Pepper",
    "Marketing Name": "KR10",
    "Device": "KR10",
    "Model": "KR10"
  },
  {
    "Retail Branding": "Hot Pepper",
    "Marketing Name": "KT10",
    "Device": "KT10",
    "Model": "KT10"
  },
  {
    "Retail Branding": "Hot Pepper",
    "Marketing Name": "KT10_EEA",
    "Device": "KT10_EEA",
    "Model": "KT10_EEA"
  },
  {
    "Retail Branding": "Hot Pepper",
    "Marketing Name": "Panca",
    "Device": "HPPL63A",
    "Model": "HPPL63A"
  },
  {
    "Retail Branding": "Hot Pepper",
    "Marketing Name": "Pulla",
    "Device": "HPPL63A",
    "Model": "HPPL63A"
  },
  {
    "Retail Branding": "Hot Pepper",
    "Marketing Name": "Pulla",
    "Device": "Pulla",
    "Model": "Pulla"
  },
  {
    "Retail Branding": "Hot Pepper",
    "Marketing Name": "Puya",
    "Device": "Puya4",
    "Model": "HPPAP40"
  },
  {
    "Retail Branding": "Hot Pepper",
    "Marketing Name": "Puya_Plus",
    "Device": "Puya_Plus",
    "Model": "HPPAP35"
  },
  {
    "Retail Branding": "Hot Pepper",
    "Marketing Name": "ROJO",
    "Device": "ROJO",
    "Model": "HPPR20A"
  },
  {
    "Retail Branding": "Hot Pepper",
    "Marketing Name": "S10",
    "Device": "HPPN10A",
    "Model": "HPPN10A"
  },
  {
    "Retail Branding": "Hot Pepper",
    "Marketing Name": "Serrano",
    "Device": "HPP-L55",
    "Model": "HPP-L55"
  },
  {
    "Retail Branding": "Hot Pepper",
    "Marketing Name": "Serrano",
    "Device": "HPP-L55B",
    "Model": "HPP-L55B"
  },
  {
    "Retail Branding": "Hot Pepper",
    "Marketing Name": "Stylo 7plus",
    "Device": "Stylo_7plus",
    "Model": "Stylo 7plus"
  },
  {
    "Retail Branding": "Hot Pepper",
    "Marketing Name": "T11 Pro",
    "Device": "T11_Pro",
    "Model": "T11 Pro"
  },
  {
    "Retail Branding": "Hot Pepper",
    "Marketing Name": "T21 Pro",
    "Device": "T21_Pro",
    "Model": "T21 Pro"
  },
  {
    "Retail Branding": "Hot Pepper",
    "Marketing Name": "VLE5",
    "Device": "VLE5",
    "Model": "VLE5"
  },
  {
    "Retail Branding": "Hot Pepper",
    "Marketing Name": "VLE5",
    "Device": "VLE5A",
    "Model": "VLE5A"
  },
  {
    "Retail Branding": "Hot Pepper",
    "Marketing Name": "Verde",
    "Device": "HPPH88L",
    "Model": "HPPH88L"
  },
  {
    "Retail Branding": "HotLight",
    "Marketing Name": "C108",
    "Device": "C108",
    "Model": "C108"
  },
  {
    "Retail Branding": "HotLight",
    "Marketing Name": "C108_EEA",
    "Device": "C108",
    "Model": "C108"
  },
  {
    "Retail Branding": "HotLight",
    "Marketing Name": "G9A",
    "Device": "G9A",
    "Model": "G9A"
  },
  {
    "Retail Branding": "HotLight",
    "Marketing Name": "G9A_EEA",
    "Device": "G9A",
    "Model": "G9A"
  },
  {
    "Retail Branding": "HotLight",
    "Marketing Name": "TP1003",
    "Device": "TP1003",
    "Model": "TP1003"
  },
  {
    "Retail Branding": "HotLight",
    "Marketing Name": "TP1003",
    "Device": "TP1003_EEA",
    "Model": "TP1003"
  },
  {
    "Retail Branding": "Hotwav",
    "Marketing Name": "A1",
    "Device": "A1",
    "Model": "A1"
  },
  {
    "Retail Branding": "Hotwav",
    "Marketing Name": "A16 Max",
    "Device": "A16_Max",
    "Model": "A16 Max"
  },
  {
    "Retail Branding": "Hotwav",
    "Marketing Name": "A16 Pro Max",
    "Device": "A16_Pro_Max",
    "Model": "A16 Pro Max"
  },
  {
    "Retail Branding": "Hotwav",
    "Marketing Name": "A16 Pro Max",
    "Device": "A16_Pro_Max",
    "Model": "A17 Pro Max"
  },
  {
    "Retail Branding": "Hotwav",
    "Marketing Name": "A17 Pro Max",
    "Device": "A17_Pro_Max",
    "Model": "A17 Pro Max"
  },
  {
    "Retail Branding": "Hotwav",
    "Marketing Name": "A1_Plus",
    "Device": "A1_Plus",
    "Model": "A1 Plus"
  },
  {
    "Retail Branding": "Hotwav",
    "Marketing Name": "A25 Ultra",
    "Device": "A25_Ultra",
    "Model": "A25 Ultra"
  },
  {
    "Retail Branding": "Hotwav",
    "Marketing Name": "A25 Ultra",
    "Device": "A25_Ultra",
    "Model": "A26 Ultra"
  },
  {
    "Retail Branding": "Hotwav",
    "Marketing Name": "A36",
    "Device": "A36",
    "Model": "A25 Ultra"
  },
  {
    "Retail Branding": "Hotwav",
    "Marketing Name": "A36",
    "Device": "A36",
    "Model": "A26 Ultra"
  },
  {
    "Retail Branding": "Hotwav",
    "Marketing Name": "A36",
    "Device": "A36",
    "Model": "A36"
  },
  {
    "Retail Branding": "Hotwav",
    "Marketing Name": "A36",
    "Device": "A36",
    "Model": "A56"
  },
  {
    "Retail Branding": "Hotwav",
    "Marketing Name": "A56",
    "Device": "A56",
    "Model": "A56"
  },
  {
    "Retail Branding": "Hotwav",
    "Marketing Name": "Cosmos",
    "Device": "Cosmos",
    "Model": "Cosmos"
  },
  {
    "Retail Branding": "Hotwav",
    "Marketing Name": "Cosmos_U",
    "Device": "Cosmos_U",
    "Model": "Cosmos U"
  },
  {
    "Retail Branding": "Hotwav",
    "Marketing Name": "Cyber 15",
    "Device": "Cyber_15",
    "Model": "Cyber 15"
  },
  {
    "Retail Branding": "Hotwav",
    "Marketing Name": "Cyber 16 Pro",
    "Device": "Cyber_16_Pro",
    "Model": "Cyber 16 Pro"
  },
  {
    "Retail Branding": "Hotwav",
    "Marketing Name": "Cyber 17",
    "Device": "Cyber_17",
    "Model": "Cyber 17"
  },
  {
    "Retail Branding": "Hotwav",
    "Marketing Name": "Cyber 18",
    "Device": "Cyber_18",
    "Model": "Cyber 18"
  },
  {
    "Retail Branding": "Hotwav",
    "Marketing Name": "Cyber 7",
    "Device": "Cyber_7",
    "Model": "Cyber 7"
  },
  {
    "Retail Branding": "Hotwav",
    "Marketing Name": "Cyber 8",
    "Device": "Cyber_8",
    "Model": "Cyber 8"
  },
  {
    "Retail Branding": "Hotwav",
    "Marketing Name": "Cyber 9 Pro",
    "Device": "Cyber_9_Pro",
    "Model": "Cyber 9 Pro"
  },
  {
    "Retail Branding": "Hotwav",
    "Marketing Name": "Cyber X",
    "Device": "Cyber_X",
    "Model": "Cyber X"
  },
  {
    "Retail Branding": "Hotwav",
    "Marketing Name": "Cyber X Pro",
    "Device": "Cyber_X_Pro",
    "Model": "Cyber X Pro"
  },
  {
    "Retail Branding": "Hotwav",
    "Marketing Name": "Cyber_11",
    "Device": "Cyber_11",
    "Model": "Cyber 11"
  },
  {
    "Retail Branding": "Hotwav",
    "Marketing Name": "Cyber_13_Pro",
    "Device": "Cyber_13_Pro",
    "Model": "Cyber 13 Pro"
  },
  {
    "Retail Branding": "Hotwav",
    "Marketing Name": "H1",
    "Device": "H1",
    "Model": "H1"
  },
  {
    "Retail Branding": "Hotwav",
    "Marketing Name": "HOT 6",
    "Device": "HOT_6",
    "Model": "HOT 6"
  },
  {
    "Retail Branding": "Hotwav",
    "Marketing Name": "Hyper 7",
    "Device": "Hyper_7",
    "Model": "Hyper 7"
  },
  {
    "Retail Branding": "Hotwav",
    "Marketing Name": "Hyper 7 Pro",
    "Device": "Hyper_7_Pro",
    "Model": "Hyper 7 Pro"
  },
  {
    "Retail Branding": "Hotwav",
    "Marketing Name": "Hyper 7S",
    "Device": "Hyper_7S",
    "Model": "Hyper 7S"
  },
  {
    "Retail Branding": "Hotwav",
    "Marketing Name": "Hyper 8 Pro",
    "Device": "Hyper_8_Pro",
    "Model": "Hyper 8 Pro"
  },
  {
    "Retail Branding": "Hotwav",
    "Marketing Name": "Hyper 8 Ultra",
    "Device": "Hyper_8_Ultra",
    "Model": "Hyper 8 Ultra"
  },
  {
    "Retail Branding": "Hotwav",
    "Marketing Name": "M5",
    "Device": "M5",
    "Model": "M5"
  },
  {
    "Retail Branding": "Hotwav",
    "Marketing Name": "M5 Plus",
    "Device": "M5_Plus",
    "Model": "M5 Plus"
  },
  {
    "Retail Branding": "Hotwav",
    "Marketing Name": "M5_2021",
    "Device": "M5_2021",
    "Model": "M5 2021"
  },
  {
    "Retail Branding": "Hotwav",
    "Marketing Name": "M5i",
    "Device": "M5i",
    "Model": "M5i"
  },
  {
    "Retail Branding": "Hotwav",
    "Marketing Name": "M6",
    "Device": "M6",
    "Model": "M6"
  },
  {
    "Retail Branding": "Hotwav",
    "Marketing Name": "Magic 11",
    "Device": "Magic_11",
    "Model": "Magic 11"
  },
  {
    "Retail Branding": "Hotwav",
    "Marketing Name": "Magic 13",
    "Device": "Magic_13",
    "Model": "Magic 13"
  },
  {
    "Retail Branding": "Hotwav",
    "Marketing Name": "Magic 5",
    "Device": "Magic_5",
    "Model": "Magic 5"
  },
  {
    "Retail Branding": "Hotwav",
    "Marketing Name": "Magic 6",
    "Device": "Magic_6",
    "Model": "Magic 6"
  },
  {
    "Retail Branding": "Hotwav",
    "Marketing Name": "Magic 8",
    "Device": "Magic_8",
    "Model": "Magic 8"
  },
  {
    "Retail Branding": "Hotwav",
    "Marketing Name": "Magic 9",
    "Device": "Magic_9",
    "Model": "Magic 9"
  },
  {
    "Retail Branding": "Hotwav",
    "Marketing Name": "Magic Q8",
    "Device": "Magic_Q8",
    "Model": "Magic Q8"
  },
  {
    "Retail Branding": "Hotwav",
    "Marketing Name": "Magic Q8 Plus",
    "Device": "Magic_Q8_Plus",
    "Model": "Magic Q8 Plus"
  },
  {
    "Retail Branding": "Hotwav",
    "Marketing Name": "Magic_5_Plus",
    "Device": "Magic_5_Plus",
    "Model": "Magic 5 Plus"
  },
  {
    "Retail Branding": "Hotwav",
    "Marketing Name": "Note 12",
    "Device": "Note_12_2024",
    "Model": "Note 12"
  },
  {
    "Retail Branding": "Hotwav",
    "Marketing Name": "Note 12E",
    "Device": "Note_12E_EEA",
    "Model": "Note 12E"
  },
  {
    "Retail Branding": "Hotwav",
    "Marketing Name": "Note 13 Max",
    "Device": "Note_13_Max",
    "Model": "Note 13 Max"
  },
  {
    "Retail Branding": "Hotwav",
    "Marketing Name": "Note 15",
    "Device": "Note_15",
    "Model": "Note 15"
  },
  {
    "Retail Branding": "Hotwav",
    "Marketing Name": "Note 15 EEA",
    "Device": "Note_15",
    "Model": "Note 15"
  },
  {
    "Retail Branding": "Hotwav",
    "Marketing Name": "Note 15 Pro",
    "Device": "Note_15_Pro",
    "Model": "Note 15 Pro"
  },
  {
    "Retail Branding": "Hotwav",
    "Marketing Name": "Note 16",
    "Device": "Note_16",
    "Model": "Note 16"
  },
  {
    "Retail Branding": "Hotwav",
    "Marketing Name": "Note 18 GT",
    "Device": "Note_18_GT",
    "Model": "Note 18 GT"
  },
  {
    "Retail Branding": "Hotwav",
    "Marketing Name": "Note 18 Pro",
    "Device": "Note_18_Pro",
    "Model": "Note 18 Pro"
  },
  {
    "Retail Branding": "Hotwav",
    "Marketing Name": "Note _12 _EF",
    "Device": "Note_12_EF",
    "Model": "Note 12 EF"
  },
  {
    "Retail Branding": "Hotwav",
    "Marketing Name": "Note15",
    "Device": "Note15",
    "Model": "Note 15"
  },
  {
    "Retail Branding": "Hotwav",
    "Marketing Name": "Note_12_EF",
    "Device": "Note_12_EF",
    "Model": "Note 12 EF"
  },
  {
    "Retail Branding": "Hotwav",
    "Marketing Name": "Note_13",
    "Device": "Note_13",
    "Model": "Note 13"
  },
  {
    "Retail Branding": "Hotwav",
    "Marketing Name": "Note_13_Pro_EEA",
    "Device": "Note_13_Pro",
    "Model": "Note 13 Pro"
  },
  {
    "Retail Branding": "Hotwav",
    "Marketing Name": "Note_18",
    "Device": "Note_18",
    "Model": "Note 18"
  },
  {
    "Retail Branding": "Hotwav",
    "Marketing Name": "Pad 11",
    "Device": "Pad_11_EEA",
    "Model": "Pad 11"
  },
  {
    "Retail Branding": "Hotwav",
    "Marketing Name": "Pad 12",
    "Device": "Pad_12",
    "Model": "Pad 12"
  },
  {
    "Retail Branding": "Hotwav",
    "Marketing Name": "Pad 12 Pro",
    "Device": "Pad_12_Pro",
    "Model": "Pad 12 Pro"
  },
  {
    "Retail Branding": "Hotwav",
    "Marketing Name": "Pad_13",
    "Device": "Pad_13",
    "Model": "Pad 13"
  },
  {
    "Retail Branding": "Hotwav",
    "Marketing Name": "Pad_13_Pro",
    "Device": "Pad_13_Pro",
    "Model": "Pad 13 Pro"
  },
  {
    "Retail Branding": "Hotwav",
    "Marketing Name": "Pad_8",
    "Device": "Pad_8",
    "Model": "Pad 8"
  },
  {
    "Retail Branding": "Hotwav",
    "Marketing Name": "Pearl K1",
    "Device": "Pearl_K1",
    "Model": "Pearl K1"
  },
  {
    "Retail Branding": "Hotwav",
    "Marketing Name": "Pearl K2",
    "Device": "Pearl_K2",
    "Model": "Pearl K2"
  },
  {
    "Retail Branding": "Hotwav",
    "Marketing Name": "Pearl K3",
    "Device": "Pearl_K3",
    "Model": "Pearl K3"
  },
  {
    "Retail Branding": "Hotwav",
    "Marketing Name": "Pearl_K2_Prime",
    "Device": "Pearl_K2_Prime",
    "Model": "Pearl K2 Prime"
  },
  {
    "Retail Branding": "Hotwav",
    "Marketing Name": "Pearl_K3_Lite",
    "Device": "Pearl_K3",
    "Model": "Pearl K3"
  },
  {
    "Retail Branding": "Hotwav",
    "Marketing Name": "Symbol",
    "Device": "Symbol",
    "Model": "Symbol"
  },
  {
    "Retail Branding": "Hotwav",
    "Marketing Name": "Symbol M1",
    "Device": "Symbol_M1",
    "Model": "Symbol M1"
  },
  {
    "Retail Branding": "Hotwav",
    "Marketing Name": "Symbol M1Plus",
    "Device": "Symbol_M1_Plus",
    "Model": "Symbol M1 Plus"
  },
  {
    "Retail Branding": "Hotwav",
    "Marketing Name": "Symbol Max",
    "Device": "Symbol_Max",
    "Model": "Symbol Max"
  },
  {
    "Retail Branding": "Hotwav",
    "Marketing Name": "Symbol X",
    "Device": "Symbol_X",
    "Model": "Symbol X"
  },
  {
    "Retail Branding": "Hotwav",
    "Marketing Name": "T5 Pro",
    "Device": "T5_Pro",
    "Model": "T5 Pro"
  },
  {
    "Retail Branding": "Hotwav",
    "Marketing Name": "T7 EEA",
    "Device": "T7",
    "Model": "T7"
  },
  {
    "Retail Branding": "Hotwav",
    "Marketing Name": "T7 Pro EEA",
    "Device": "T7_Pro",
    "Model": "T7 Pro"
  },
  {
    "Retail Branding": "Hotwav",
    "Marketing Name": "T8",
    "Device": "T8",
    "Model": "T8"
  },
  {
    "Retail Branding": "Hotwav",
    "Marketing Name": "TAB R11 Pro",
    "Device": "TAB_R11_Pro",
    "Model": "TAB R11 Pro"
  },
  {
    "Retail Branding": "Hotwav",
    "Marketing Name": "TAB R5",
    "Device": "TAB_R5",
    "Model": "TAB R5"
  },
  {
    "Retail Branding": "Hotwav",
    "Marketing Name": "TAB R6 Pro",
    "Device": "TAB_R6_Pro",
    "Model": "TAB R6 Pro"
  },
  {
    "Retail Branding": "Hotwav",
    "Marketing Name": "TAB R6 Ultra",
    "Device": "TAB_R6_Ultra",
    "Model": "TAB R6 Ultra"
  },
  {
    "Retail Branding": "Hotwav",
    "Marketing Name": "TAB R8",
    "Device": "TAB_R8",
    "Model": "TAB R8"
  },
  {
    "Retail Branding": "Hotwav",
    "Marketing Name": "TAB R9 Plus",
    "Device": "TAB_R9_Pro",
    "Model": "TAB R9 Plus"
  },
  {
    "Retail Branding": "Hotwav",
    "Marketing Name": "TAB R9 Pro EEA",
    "Device": "TAB_R9_Pro",
    "Model": "TAB R9 Pro"
  },
  {
    "Retail Branding": "Hotwav",
    "Marketing Name": "TAB_R10_Pro",
    "Device": "TAB_R10_Pro",
    "Model": "TAB R10 Pro"
  },
  {
    "Retail Branding": "Hotwav",
    "Marketing Name": "TAB_R7",
    "Device": "TAB_R7",
    "Model": "TAB R7"
  },
  {
    "Retail Branding": "Hotwav",
    "Marketing Name": "TAB_R9_Pro_Max",
    "Device": "TAB_R9_Pro_Max",
    "Model": "TAB R9 Pro Max"
  },
  {
    "Retail Branding": "Hotwav",
    "Marketing Name": "Venus",
    "Device": "Venus",
    "Model": "Venus"
  },
  {
    "Retail Branding": "Hotwav",
    "Marketing Name": "W10",
    "Device": "W10",
    "Model": "W10"
  },
  {
    "Retail Branding": "Hotwav",
    "Marketing Name": "W10 Pro",
    "Device": "W10_Pro",
    "Model": "W10 Pro"
  },
  {
    "Retail Branding": "Hotwav",
    "Marketing Name": "W11",
    "Device": "W11",
    "Model": "W11"
  },
  {
    "Retail Branding": "Hotwav",
    "Marketing Name": "X100 GT",
    "Device": "X100_GT",
    "Model": "X100 GT"
  },
  {
    "Retail Branding": "How",
    "Marketing Name": "1001-G",
    "Device": "1001-G",
    "Model": "1001-G"
  },
  {
    "Retail Branding": "How",
    "Marketing Name": "1001_G",
    "Device": "1001-G_Go",
    "Model": "1001-G Go"
  },
  {
    "Retail Branding": "How",
    "Marketing Name": "705-G",
    "Device": "705-G",
    "Model": "705-G"
  },
  {
    "Retail Branding": "How",
    "Marketing Name": "705-G Go",
    "Device": "705-G_Go",
    "Model": "705-G Go"
  },
  {
    "Retail Branding": "How",
    "Marketing Name": "HT-704",
    "Device": "HT704",
    "Model": "HT-704"
  },
  {
    "Retail Branding": "How",
    "Marketing Name": "HT-704plus",
    "Device": "HT704plus",
    "Model": "HT-704plus"
  },
  {
    "Retail Branding": "How",
    "Marketing Name": "HT-705",
    "Device": "HT705",
    "Model": "HT-705"
  },
  {
    "Retail Branding": "How",
    "Marketing Name": "HT-705PRO",
    "Device": "HT-705PRO",
    "Model": "HT-705PRO"
  },
  {
    "Retail Branding": "How",
    "Marketing Name": "HT-705XS",
    "Device": "HT-705XS",
    "Model": "HT-705XS"
  },
  {
    "Retail Branding": "How",
    "Marketing Name": "HT-705_Go",
    "Device": "HT-705_Go",
    "Model": "HT-705 Go"
  },
  {
    "Retail Branding": "How",
    "Marketing Name": "HT704-G",
    "Device": "704-G",
    "Model": "704-G"
  },
  {
    "Retail Branding": "How",
    "Marketing Name": "HT705GO",
    "Device": "HT705GO-01",
    "Model": "HT-705"
  },
  {
    "Retail Branding": "How",
    "Marketing Name": "HT_705XS",
    "Device": "HT-705XS",
    "Model": "HT-705XS"
  },
  {
    "Retail Branding": "How",
    "Marketing Name": "HT_705_G_PLUS",
    "Device": "HOW_HT_705_G_PLUS",
    "Model": "HT-705-G PLUS"
  },
  {
    "Retail Branding": "How",
    "Marketing Name": "kids 3g",
    "Device": "sp7731c_1h10",
    "Model": "kids 3g"
  },
  {
    "Retail Branding": "Huangmi",
    "Marketing Name": "F8",
    "Device": "F8",
    "Model": "F8"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "C8600",
    "Model": "C8600"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "CHT8000",
    "Model": "CHT8000"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "HuaweiU8180",
    "Model": "Huawei Ideos X1"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "HuaweiU8180",
    "Model": "HuaweiU8180"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "HuaweiU8180",
    "Model": "IDEOS X1"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "HuaweiU8180",
    "Model": "Kyivstar Terra"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "HuaweiU8180",
    "Model": "Starshine"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "HuaweiU8180",
    "Model": "Stockholm"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "HuaweiU8180",
    "Model": "U8180"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "Pulse",
    "Model": "Pulse"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "T8300",
    "Model": "HUAWEI T8300"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "T8600",
    "Model": "HUAWEI T8600"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "T8828",
    "Model": "HUAWEI T8828"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "U8110",
    "Model": "EQ U8110"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "U8110",
    "Model": "Huawei"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "U8110",
    "Model": "Huawei U8110"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "U8110",
    "Model": "MTC_A"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "U8110",
    "Model": "Pulse Mini"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "U8110",
    "Model": "TSP21"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "U8110",
    "Model": "Turkcell T10"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "U8110",
    "Model": "U8110"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "U8110",
    "Model": "life:) Android"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "U8300",
    "Model": "U8300"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "U8500",
    "Model": "HUAWEI IDEOS U8500"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "U8500",
    "Model": "MTC_EVO"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "dtab01",
    "Model": "dtab01"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwC8813Q",
    "Model": "HUAWEI C8813Q"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwC8860E",
    "Model": "HUAWEI C8860E"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwG520-T10",
    "Model": "HUAWEI G520-T10"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwS42HW",
    "Model": "S42HW"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwS7-901w",
    "Model": "A01HW"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwT8830Pro",
    "Model": "T8830Pro"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwU9202L",
    "Model": "U9202L-1"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwU9202L",
    "Model": "U9202L-3"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwc8500",
    "Model": "C8500"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwc8511",
    "Model": "C8511"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwc8511",
    "Model": "MTS-SP101"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwc8512",
    "Model": "C8512"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwc8600",
    "Model": "C8600"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwc8650",
    "Model": "C8650"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwc8650e",
    "Model": "HUAWEI C8650+"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwc8655",
    "Model": "HUAWEI C8655"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwc8800",
    "Model": "C8800"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwc8800",
    "Model": "MTS-SP140"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwc8810",
    "Model": "HUAWEI C8810"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwc8812E",
    "Model": "HUAWEI C8812E"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwc8813",
    "Model": "HUAWEI C8813"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwc8825D",
    "Model": "HUAWEI C8825D"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwc8860E",
    "Model": "HUAWEI C8860E"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwc8860V",
    "Model": "C8860V"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwc8950D",
    "Model": "HUAWEI C8950D"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwcm980",
    "Model": "CM980"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwh866c",
    "Model": "H866C"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwh866c",
    "Model": "HUAWEI H866C"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwh867g",
    "Model": "Huawei-H867G"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwh868c",
    "Model": "HUAWEI H868C"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwh881c",
    "Model": "HUAWEI H881C"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwm650",
    "Model": "Express"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwm650",
    "Model": "M650"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwm660",
    "Model": "M660"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwm860",
    "Model": "HUAWEI-M860"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwm865c",
    "Model": "M865C"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwm866",
    "Model": "HUAWEI M866"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwm866",
    "Model": "M866"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwm866",
    "Model": "USCCADR3310"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwm886",
    "Model": "M886"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwm920",
    "Model": "HUAWEI-M920"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwm931",
    "Model": "HUAWEI-M931"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwp2-0000",
    "Model": "HUAWEI P2-0000"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwp2-6011",
    "Model": "HUAWEI P2-6011"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwp2-6011",
    "Model": "HUAWEI P2-6011-orange"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hws10101u",
    "Model": "MediaPad 10 FHD"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hws10101w",
    "Model": "GT01"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hws10101w",
    "Model": "MediaPad 10 FHD"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hws10201u",
    "Model": "MediaPad 10 LINK"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hws7300c",
    "Model": "HUAWEI MediaPad"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hws7300u",
    "Model": "HUAWEI MediaPad"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hws7300u",
    "Model": "Huawei S7-312u"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hws7300u",
    "Model": "MediaPad"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hws7300u",
    "Model": "SpringBoard"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hws7300w",
    "Model": "HUAWEI MediaPad"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hws7930w",
    "Model": "MediaPad 7 Lite"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwt8620",
    "Model": "T8620"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwt8830",
    "Model": "T8830"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwt8833",
    "Model": "HUAWEI T8833"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwt8950",
    "Model": "HUAWEI T8950"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwt8950N",
    "Model": "HUAWEI T8950N"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwt8951",
    "Model": "HUAWEI T8951"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwt9200",
    "Model": "T9200"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwt9510e",
    "Model": "T9510E"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwu8180",
    "Model": "Netphone 501"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwu8180",
    "Model": "U8180"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwu8185",
    "Model": "U8185"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwu8186",
    "Model": "U8186"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwu8230",
    "Model": "U8230"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwu8350",
    "Model": "Barcelona"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwu8350",
    "Model": "GM FOX"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwu8350",
    "Model": "HuaweiU8350"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwu8350",
    "Model": "MTC Pro"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwu8350",
    "Model": "Personal U8350"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwu8350",
    "Model": "Temptation"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwu8350",
    "Model": "U8350"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwu8350",
    "Model": "U8350-51"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwu8500",
    "Model": "Grameenphone Crystal"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwu8500",
    "Model": "HUAWEI_IDEOS_U8500"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwu8500",
    "Model": "HuaweiU8500"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwu8500",
    "Model": "ICE"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwu8500",
    "Model": "MF8503"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwu8500",
    "Model": "MTC Evo"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwu8500",
    "Model": "MegaFon U8500"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwu8500",
    "Model": "U8500"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwu8510",
    "Model": "Beeline_E500"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwu8510",
    "Model": "GM Ultimate Slim"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwu8510",
    "Model": "Huawei IDEOS X3"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwu8510",
    "Model": "HuaweiU8510"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwu8510",
    "Model": "MTC Bravo"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwu8510",
    "Model": "S41HW"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwu8510",
    "Model": "U8510"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwu8520",
    "Model": "U8520"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwu8600",
    "Model": "U8600"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwu8650",
    "Model": "HUAWEI SONIC"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwu8650",
    "Model": "HUAWEI_IDEOS_U8650"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwu8650",
    "Model": "HuaweiU8650"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwu8650",
    "Model": "Kyivstar Aqua"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwu8650",
    "Model": "MTC 955"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwu8650",
    "Model": "SONIC"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwu8650",
    "Model": "Turkcell T20"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwu8650",
    "Model": "U8650"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwu8650",
    "Model": "U8650-1"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwu8651",
    "Model": "Astro"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwu8651",
    "Model": "Prism"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwu8651",
    "Model": "U8651"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwu8651",
    "Model": "U8651T"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwu8652-51",
    "Model": "U8652-51"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwu8655",
    "Model": "Etisalat"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwu8655",
    "Model": "HUAWEI IDEOS Y 200"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwu8655",
    "Model": "Personal U8655-51"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwu8655",
    "Model": "STARTRAIL II"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwu8655",
    "Model": "U8655"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwu8655",
    "Model": "U8655-1"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwu8655",
    "Model": "U8655-51"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwu8660",
    "Model": "SONIC"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwu8661",
    "Model": "HUAWEI U8661"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwu8666",
    "Model": "MTC Fit"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwu8666",
    "Model": "U8666-1"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwu8666",
    "Model": "U8666-51"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwu8666-51",
    "Model": "U8666-51"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwu8666e",
    "Model": "HUAWEI U8666E"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwu8666e",
    "Model": "MegaFon SP-A3"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwu8666e-51",
    "Model": "HUAWEI U8666E"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwu8666e-51",
    "Model": "HUAWEI U8666E-51"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwu8666n",
    "Model": "HUAWEI U8666N"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwu8667",
    "Model": "U8667"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwu8680",
    "Model": "T-Mobile myTouch"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwu8681",
    "Model": "HUAWEI U8681"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwu8730",
    "Model": "T-Mobile myTouch Q"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwu8800",
    "Model": "IDEOS X5"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwu8800",
    "Model": "MTC Neo"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwu8800",
    "Model": "U8800"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwu8800",
    "Model": "Ucell"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwu8800",
    "Model": "u8800"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwu8800Pro",
    "Model": "HUAWEI_IDEOS_X5"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwu8800Pro",
    "Model": "HuaweiU8800Pro"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwu8800Pro",
    "Model": "IDEOS X5"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwu8800Pro",
    "Model": "MTC Neo"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwu8800Pro",
    "Model": "RBM_HD"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwu8800Pro",
    "Model": "U8800 Pro"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwu8800Pro",
    "Model": "U8800Pro"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwu8815",
    "Model": "HUAWEI Ascend G 300"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwu8815",
    "Model": "HUAWEI U8815"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwu8815",
    "Model": "HUAWEI_Ascend G 300"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwu8815",
    "Model": "Personal U8815-51"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwu8815",
    "Model": "U8815"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwu8815",
    "Model": "U8815-51"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwu8815n",
    "Model": "HUAWEI U8815N"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwu8815n",
    "Model": "U8815N"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwu8816",
    "Model": "MTC Viva"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwu8816",
    "Model": "U8816"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwu8818",
    "Model": "HUAWEI U8818"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwu8818",
    "Model": "U8818"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwu8820",
    "Model": "U8820"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwu8825-1",
    "Model": "Bs 401"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwu8825-1",
    "Model": "HUAWEI Ascend G 330"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwu8825-1",
    "Model": "HUAWEI U8825-1"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwu8825D",
    "Model": "HUAWEI U8825D"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwu8850",
    "Model": "007HW"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwu8860",
    "Model": "GS02"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwu8860",
    "Model": "HUAWEI_U8860"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwu8860",
    "Model": "TURKCELL MaxiPRO5"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwu8860",
    "Model": "U8860"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwu8860",
    "Model": "U8860-51"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwu8867Z",
    "Model": "U8867Z"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwu8950-1",
    "Model": "HUAWEI U8950-1"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwu8950-51",
    "Model": "HUAWEI U8950-51"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwu8950D",
    "Model": "HUAWEI U8950D"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwu8950N-1",
    "Model": "HUAWEI U8950N-1"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwu8950N-51",
    "Model": "HUAWEI U8950N-51"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwu9200",
    "Model": "U9200"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwu9200",
    "Model": "U9200E"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwu9200-92",
    "Model": "GS03"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwu9200-92",
    "Model": "U9200"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwu9200E",
    "Model": "U9200E"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwu9201L",
    "Model": "201HW"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwu9500",
    "Model": "U9500E"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwu9501L",
    "Model": "HW-01E"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwu9508",
    "Model": "HUAWEI U9508"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwu9510",
    "Model": "HUAWEI U9510"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwu9510",
    "Model": "U9510"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwu9510e",
    "Model": "HUAWEI U9510E"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwu9700L",
    "Model": "GL07S"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwum840",
    "Model": "UM840"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwy210-0010",
    "Model": "HUAWEI Y210-0010"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwy210-0100",
    "Model": "HUAWEI Ascend Y 210"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwy210-0100",
    "Model": "HUAWEI Y210-0100"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwy210-0151",
    "Model": "HUAWEI Y210-0151"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwy210-0200",
    "Model": "HUAWEI Ascend Y 210D"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwy210-0200",
    "Model": "HUAWEI Asend Y 210D"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwy210-0200",
    "Model": "HUAWEI Y210-0200"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwy210-0200",
    "Model": "Leopard MF808"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwy210-0200",
    "Model": "NATCOM N8302"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwy210-0200",
    "Model": "VIETTEL V8404"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwy210-0251",
    "Model": "HUAWEI Y210-0251"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "hwy210-2010",
    "Model": "HUAWEI Y210-2010"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "msm7201a",
    "Model": "Pulse"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "msm7201a",
    "Model": "U8230"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "msm7225",
    "Model": "Beeline_E300"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "msm7225",
    "Model": "Grameenphone Crystal"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "msm7225",
    "Model": "HUAWEI IDEOS U8500"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "msm7225",
    "Model": "HUAWEI_IDEOS_U8500"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "msm7225",
    "Model": "Huawei"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "msm7225",
    "Model": "HuaweiU8300"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "msm7225",
    "Model": "Ideos"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "msm7225",
    "Model": "MTC Evo"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "msm7225",
    "Model": "Pulse Mini"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "msm7225",
    "Model": "RBM C"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "msm7225",
    "Model": "S31HW"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "msm7225",
    "Model": "Smile"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "msm7225",
    "Model": "Tactile internet"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "msm7225",
    "Model": "Turkcell T10"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "msm7225",
    "Model": "U8110"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "msm7225",
    "Model": "U8300"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "msm7225",
    "Model": "U8500"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "msm7225",
    "Model": "Vodafone 845"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "msm7227",
    "Model": "004HW"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "msm7230",
    "Model": "IDEOS X5"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "msm7230",
    "Model": "u8800"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "msm7625",
    "Model": "C8600"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "msm7625",
    "Model": "HUAWEI-M860"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "msm7625",
    "Model": "Ideos"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "msm7625",
    "Model": "M860"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "msm7625",
    "Model": "U8180"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "orinoquiac8688V",
    "Model": "ORINOQUIA C8688V"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "qsd8k_s7",
    "Model": "HUAWEI-S7"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "qsd8k_s7",
    "Model": "IDEOS S7"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "qsd8k_s7",
    "Model": "Ideos S7"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "qsd8k_s7",
    "Model": "Oysters SmaKit S7"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "qsd8k_s7",
    "Model": "S7"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "qsd8k_slim",
    "Model": "IDEOS S7 Slim"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "",
    "Device": "u8800",
    "Model": "u8800"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "A199",
    "Device": "hwa199",
    "Model": "HUAWEI A199"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "ATH-TL00",
    "Device": "HWATH",
    "Model": "ATH-TL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "ATH-TL00H",
    "Device": "HWATH",
    "Model": "ATH-TL00H"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "ATH-UL00",
    "Device": "HWATH",
    "Model": "ATH-UL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Ascend D",
    "Device": "hwu9500",
    "Model": "U9500"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Ascend G510",
    "Device": "hwG510-0251",
    "Model": "HUAWEI G510-0251"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Ascend G525",
    "Device": "hwG525-U00",
    "Model": "HUAWEI Ascend G525"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Ascend G525",
    "Device": "hwG525-U00",
    "Model": "HUAWEI G525-U00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "B199",
    "Device": "hwB199",
    "Model": "HUAWEI B199"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "C199",
    "Device": "hwC199",
    "Model": "HUAWEI C199"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "C199s",
    "Device": "hwC199s",
    "Model": "HUAWEI C199s"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "C8812",
    "Device": "hwc8812",
    "Model": "HUAWEI C8812"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "C8813D",
    "Device": "hwc8813",
    "Model": "HUAWEI C8813D"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "C8813DQ",
    "Device": "hwC8813DQ",
    "Model": "HUAWEI C8813DQ"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "C8815",
    "Device": "hwC8815",
    "Model": "HUAWEI C8815"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "C8816",
    "Device": "hwC8816",
    "Model": "HUAWEI C8816"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "C8816D",
    "Device": "hwC8816D",
    "Model": "HUAWEI C8816D"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "C8817D",
    "Device": "hwC8817D",
    "Model": "C8817D"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "C8817E",
    "Device": "hwC8817E",
    "Model": "HUAWEI C8817E"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "C8817L",
    "Device": "hwC8817L",
    "Model": "HUAWEI C8817L"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "C8818",
    "Device": "hwC8818",
    "Model": "HUAWEI C8818"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "C8826D",
    "Device": "hwc8826D",
    "Model": "HUAWEI C8826D"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "C8850",
    "Device": "hwc8850",
    "Model": "HUAWEI-C8850"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "CHC-U03",
    "Device": "hwCHC-H",
    "Model": "CHC-U03"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "CHC-U23",
    "Device": "hwCHC-H",
    "Model": "CHC-U23"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "CHM-CL00",
    "Device": "hwCHM-Q",
    "Model": "CHM-CL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "CHM-U01",
    "Device": "hwCHM-H",
    "Model": "CHM-U01"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "CM990",
    "Device": "hwCM990",
    "Model": "CM990"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "CUN-AL00",
    "Device": "HWCUN-L6735",
    "Model": "CUN-AL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "CUN-TL00",
    "Device": "HWCUN-L6735",
    "Model": "CUN-TL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Che1-CL10",
    "Device": "Che1",
    "Model": "Che1-CL10"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Che1-CL20",
    "Device": "Che1",
    "Model": "Che1-CL20"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Che1-L04",
    "Device": "Che1",
    "Model": "Che1-L04"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Che2-L11",
    "Device": "hwChe2",
    "Model": "Che2-L11"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Che2-L23",
    "Device": "hwChe2",
    "Model": "Che2-L23"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Che2-TL00",
    "Device": "hwChe2",
    "Model": "Che2-TL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Che2-TL00H",
    "Device": "hwChe2",
    "Model": "Che2-TL00H"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Che2-TL00M",
    "Device": "hwChe2",
    "Model": "Che2-TL00M"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Che2-UL00",
    "Device": "hwChe2",
    "Model": "Che2-UL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Cherry Mini",
    "Device": "hwCHC-H",
    "Model": "CHC-U01"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "China",
    "Device": "m330",
    "Model": "M330"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Copper Plus",
    "Device": "HWH1611-Q",
    "Model": "H1611"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Copper Plus",
    "Device": "HWH1611-Q",
    "Model": "HUAWEI H1611"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "D2",
    "Device": "hwD2-0082",
    "Model": "HUAWEI D2-0082"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "D2",
    "Device": "hwD2-2010",
    "Model": "HUAWEI D2-2010"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "D2",
    "Device": "hwD2-6070",
    "Model": "HUAWEI D2-6070"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "DAV",
    "Device": "HWP8max",
    "Model": "HUAWEI P8max"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "ECO",
    "Device": "HWLUA-L6735",
    "Model": "HUAWEI LUA-L03"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "ECO",
    "Device": "HWLUA-L6735",
    "Model": "HUAWEI LUA-L13"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "ECO",
    "Device": "HWLUA-L6735",
    "Model": "HUAWEI LUA-L23"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "ECO",
    "Device": "HWLUA-U6582",
    "Model": "HUAWEI LUA-U03"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "ECO",
    "Device": "HWLUA-U6582",
    "Model": "HUAWEI LUA-U23"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "ES8100",
    "Device": "hwes8100",
    "Model": "ES8100"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "ES8500",
    "Device": "hwes8500",
    "Model": "HuaweiES8500"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "FIG-LX1",
    "Device": "HWFIG-H",
    "Model": "FIG-LX1"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "FRD-L02",
    "Device": "HWFRD",
    "Model": "FRD-L02"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Fusion 2",
    "Device": "hwu8665",
    "Model": "Huawei-U8665"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "G350",
    "Device": "hwg350",
    "Model": "HUAWEI G350"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "G350",
    "Device": "hwg350",
    "Model": "HUAWEI G350-U00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "G350-U20",
    "Device": "HWG350",
    "Model": "HUAWEI G350-U20"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "G506",
    "Device": "hwG506-U151",
    "Model": "HUAWEI G506-U151"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "G510",
    "Device": "hwG510-0010",
    "Model": "HUAWEI G510-0010"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "G510",
    "Device": "hwG510-0100",
    "Model": "HUAWEI G510-0100"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "G510",
    "Device": "hwG510-0100",
    "Model": "HuaweiG510-0100"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "G510",
    "Device": "hwG510-0100",
    "Model": "HuaweiG510-0100-orange"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "G510",
    "Device": "hwG510-0200",
    "Model": "HUAWEI Ascend G510"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "G510",
    "Device": "hwG510-0200",
    "Model": "HUAWEI G510-0200"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "G510",
    "Device": "hwG510-0200",
    "Model": "Orange Daytona"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "G520",
    "Device": "hwG520-5000",
    "Model": "HUAWEI G520-5000"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "G521-L076",
    "Device": "HWG521-L",
    "Model": "HUAWEI G521-L076"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "G521-L176",
    "Device": "HWG521-L",
    "Model": "HUAWEI G521-L176"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "G526",
    "Device": "hwG526-L11",
    "Model": "G526-L11"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "G526",
    "Device": "hwG526-L22",
    "Model": "G526-L22"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "G526",
    "Device": "hwG526-L33",
    "Model": "G526-L33"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "G527",
    "Device": "hwG527-U081",
    "Model": "G527-U081"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "G535-L11",
    "Device": "hwG535-L11",
    "Model": "HUAWEI G535-L11"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "G535-L11",
    "Device": "hwG535-L11",
    "Model": "Kestrel"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "G535-L11",
    "Device": "hwG535-L11",
    "Model": "Orange Gova"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "G535-L11",
    "Device": "hwG535-L11",
    "Model": "Speedsurfer"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "G535-L11",
    "Device": "hwG535-L11",
    "Model": "Ultym5"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "G6",
    "Device": "hwG6-T00",
    "Model": "HUAWEI G6-T00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "G6-C00",
    "Device": "hwG6-C00",
    "Model": "HUAWEI G6-C00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "G6-L11",
    "Device": "hwG6-L11",
    "Model": "HUAWEI G6-L11"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "G6-L22",
    "Device": "hwG6-L22",
    "Model": "HUAWEI G6-L22"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "G6-L33",
    "Device": "hwG6-L33",
    "Model": "HUAWEI G6-L33"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "G6-U00",
    "Device": "hwG6-U00",
    "Model": "HUAWEI G6-U00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "G6-U10",
    "Device": "hwG6-U10",
    "Model": "HUAWEI G6-U10"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "G6-U251",
    "Device": "hwG6-U251",
    "Model": "HUAWEI G6-U251"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "G6-U34",
    "Device": "hwG6-U34",
    "Model": "HUAWEI G6-U34"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "G606",
    "Device": "HWG606",
    "Model": "HUAWEI G606-T00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "G606-T00",
    "Device": "HWG606-T00",
    "Model": "HUAWEI G606-T00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "G610",
    "Device": "hwG610-T00",
    "Model": "HUAWEI G610-T00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "G610",
    "Device": "hwG610-U00",
    "Model": "G610-U00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "G610",
    "Device": "hwG610-U00",
    "Model": "HUAWEI G610-U00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "G610",
    "Device": "hwG610-U30",
    "Model": "HUAWEI G610-U30"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "G610-T01",
    "Device": "hwG610-T01",
    "Model": "HUAWEI G610-T01"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "G610-T11",
    "Device": "hwG610-T11",
    "Model": "HUAWEI G610-T11"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "G610-U15",
    "Device": "hwG610-U15",
    "Model": "HUAWEI G610-U15"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "G610-U20",
    "Device": "hwG610-U20",
    "Model": "HUAWEI G610-U20"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "G610C",
    "Device": "hwG610-C00",
    "Model": "HUAWEI G610-C00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "G615-U10",
    "Device": "hwG615-U10",
    "Model": "G615-U10"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "G615-U10",
    "Device": "hwG615-U10",
    "Model": "HUAWEI G615-U10"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "G616-L076",
    "Device": "HWG616-L",
    "Model": "HUAWEI G616-L076"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "G620-A2",
    "Device": "hwG620-A2",
    "Model": "HUAWEI G620-A2"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "G620-L72",
    "Device": "hwG620-L72",
    "Model": "HUAWEI G620-L72"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "G620-L75",
    "Device": "hwG620-L75",
    "Model": "G620-L75"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "G620S-L01",
    "Device": "hwG620S-L01",
    "Model": "G620S-L01"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "G620S-L02",
    "Device": "hwG620S-L02",
    "Model": "G620S-L02"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "G620S-L03",
    "Device": "hwG620S-L03",
    "Model": "G620S-L03"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "G620S-L03",
    "Device": "hwG620S-L03",
    "Model": "HUAWEI G620"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "G620S-L03",
    "Device": "hwG620S-L03",
    "Model": "Personal Huawei G620S"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "G620S-UL00",
    "Device": "hwG620S-UL00",
    "Model": "G620S-UL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "G621-TL00",
    "Device": "hwG621-TL00",
    "Model": "G621-TL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "G621-TL00M",
    "Device": "hwG621-TL00",
    "Model": "G621-TL00M"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "G628-TL00",
    "Device": "HWG628-TL",
    "Model": "HUAWEI G628-TL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "G629-UL00",
    "Device": "HWG629-UL",
    "Model": "HUAWEI G629-UL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "G630",
    "Device": "hwG630-T00",
    "Model": "HUAWEI G630-T00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "G630-U00",
    "Device": "hwG630-U00",
    "Model": "HUAWEI G630-U00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "G630-U10",
    "Device": "hwG630-U10",
    "Model": "G630-U10"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "G630-U20",
    "Device": "hwG630-U20",
    "Model": "G630-U20"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "G630-U251",
    "Device": "hwG630-U251",
    "Model": "G630-U251"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "G630-U251",
    "Device": "hwG630-U251",
    "Model": "HUAWEI G630-U251"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "G660-L075",
    "Device": "hwG660-L075",
    "Model": "HUAWEI G660-L075"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "G7 Plus",
    "Device": "HWRIO",
    "Model": "HUAWEI RIO-TL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "G7 Plus",
    "Device": "HWRIO",
    "Model": "HUAWEI RIO-UL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "G7-L01",
    "Device": "hwG7-L01",
    "Model": "G7-L01"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "G7-L01",
    "Device": "hwG7-L01",
    "Model": "HUAWEI G7-L01"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "G7-L02",
    "Device": "hwG7-L02",
    "Model": "HUAWEI G7-L02"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "G7-L03",
    "Device": "hwG7-L03",
    "Model": "G7-L03"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "G7-L03",
    "Device": "hwG7-L03",
    "Model": "HUAWEI G7"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "G7-L03",
    "Device": "hwG7-L03",
    "Model": "HUAWEI G7-L03"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "G7-L11",
    "Device": "hwG7-L11",
    "Model": "HUAWEI G7-L11"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "G7-TL00",
    "Device": "hwG7-TL00",
    "Model": "G7-TL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "G7-TL00",
    "Device": "hwG7-TL00",
    "Model": "HUAWEI G7-TL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "G7-UL20",
    "Device": "hwG7-UL20",
    "Model": "HUAWEI G7-UL20"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "G700",
    "Device": "hwG700-T00",
    "Model": "HUAWEI G700-T00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "G700",
    "Device": "hwG700-U00",
    "Model": "HUAWEI G700-U00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "G700-T01",
    "Device": "hwG700-T01",
    "Model": "HUAWEI G700-T01"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "G700-U10",
    "Device": "hwG700-U10",
    "Model": "HUAWEI G700-U10"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "G700-U20",
    "Device": "hwG700-U20",
    "Model": "HUAWEI G700-U20"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "G716",
    "Device": "hwG716-L070",
    "Model": "HUAWEI G716-L070"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "G718",
    "Device": "hwg718",
    "Model": "HUAWEI G718"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "G730",
    "Device": "hwG730-C00",
    "Model": "HUAWEI G730-C00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "G730",
    "Device": "hwG730-T00",
    "Model": "HUAWEI G730-T00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "G730",
    "Device": "hwG730-U00",
    "Model": "HUAWEI G730-U00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "G730-L075",
    "Device": "hwG730-L075",
    "Model": "HUAWEI G730-L075"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "G730-U10",
    "Device": "hwG730-U10",
    "Model": "HUAWEI G730-U10"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "G730-U251",
    "Device": "hwG730-U251",
    "Model": "HUAWEI G730-U251"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "G730-U27",
    "Device": "hwG730-U27",
    "Model": "HUAWEI G730-U27"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "G730-U30",
    "Device": "hwG730-U30",
    "Model": "HUAWEI G730-U30"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "G735-L03",
    "Device": "hwG735",
    "Model": "G735-L03"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "G735-L12",
    "Device": "hwG735",
    "Model": "G735-L12"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "G735-L23",
    "Device": "hwG735",
    "Model": "G735-L23"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "G740",
    "Device": "hwG740-L00",
    "Model": "G740-L00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "G740",
    "Device": "hwG740-L00",
    "Model": "Orange Yumo"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "G750-T00",
    "Device": "hwG750-T00",
    "Model": "HUAWEI G750-T00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "G750-T01",
    "Device": "hwG750-T01",
    "Model": "HUAWEI G750-T01"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "G750-T01M",
    "Device": "hwG750-T01M",
    "Model": "HUAWEI G750-T01M"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "G750-T20",
    "Device": "hwG750-T20",
    "Model": "HUAWEI G750-T20"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "G750-U10",
    "Device": "hwG750-U10",
    "Model": "HUAWEI G750-U10"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "G7500",
    "Device": "HWG7500",
    "Model": "HUAWEI G7500"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "G8",
    "Device": "HWRIO",
    "Model": "HUAWEI RIO-L02"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "G8",
    "Device": "HWRIO",
    "Model": "HUAWEI RIO-L03"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "G8",
    "Device": "HWRIO",
    "Model": "RIO-L03"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "G8",
    "Device": "hwRIO-L02",
    "Model": "HUAWEI RIO-L02"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "G8",
    "Device": "hwRIO-L03",
    "Model": "HUAWEI RIO-L03"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "G9 Plus",
    "Device": "HWMLA",
    "Model": "HUAWEI MLA-TL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "G9 Plus",
    "Device": "HWMLA",
    "Model": "HUAWEI MLA-TL10"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "G9 Plus",
    "Device": "HWMLA",
    "Model": "HUAWEI MLA-UL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "G9 Plus",
    "Device": "HWMLA",
    "Model": "MLA-TL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "G9 Plus",
    "Device": "HWMLA",
    "Model": "MLA-UL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "G9青春版",
    "Device": "HWVNS-Q",
    "Model": "HUAWEI VNS-AL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "GR3",
    "Device": "HWTAG-L6753",
    "Model": "HUAWEI TAG-L01"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "GR3",
    "Device": "HWTAG-L6753",
    "Model": "HUAWEI TAG-L03"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "GR3",
    "Device": "HWTAG-L6753",
    "Model": "HUAWEI TAG-L13"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "GR3",
    "Device": "HWTAG-L6753",
    "Model": "HUAWEI TAG-L21"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "GR3",
    "Device": "HWTAG-L6753",
    "Model": "HUAWEI TAG-L22"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "GR3",
    "Device": "HWTAG-L6753",
    "Model": "HUAWEI TAG-L23"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "GR3 2017",
    "Device": "HWDIG-L8940",
    "Model": "DIG-L01"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "GR3 2017",
    "Device": "HWDIG-L8940",
    "Model": "DIG-L21"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "GR3 2017",
    "Device": "HWDIG-L8940",
    "Model": "DIG-L22"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "GR3 Smart touch",
    "Device": "HWTAG-L6753",
    "Model": "HUAWEI TAG-L32"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "GR5",
    "Device": "HWKII-Q",
    "Model": "HUAWEI KII-L03"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "GR5",
    "Device": "HWKII-Q",
    "Model": "HUAWEI KII-L05"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "GR5",
    "Device": "HWKII-Q",
    "Model": "HUAWEI KII-L21"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "GR5",
    "Device": "HWKII-Q",
    "Model": "HUAWEI KII-L22"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "GR5",
    "Device": "HWKII-Q",
    "Model": "HUAWEI KII-L23"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "GR5",
    "Device": "HWKII-Q",
    "Model": "HUAWEI KII-L33"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "GR5",
    "Device": "HWKII-Q",
    "Model": "KII-L21"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "GR5W",
    "Device": "HWH1621-Q",
    "Model": "H1621"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "GT3",
    "Device": "HWNMO-H",
    "Model": "HUAWEI NMO-L21"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "GT3",
    "Device": "HWNMO-H",
    "Model": "HUAWEI NMO-L22"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "GT3",
    "Device": "HWNMO-H",
    "Model": "HUAWEI NMO-L23"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "GT3",
    "Device": "HWNMO-H",
    "Model": "HUAWEI NMO-L31"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "GX8",
    "Device": "hwRIO-L01",
    "Model": "HUAWEI"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "GX8",
    "Device": "hwRIO-L01",
    "Model": "HUAWEI RIO-L01"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Gran_Roraima",
    "Device": "hws7721u",
    "Model": "Orinoquia Gran Roraima + S7-722u"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "H30-C00",
    "Device": "hwH30-C00",
    "Model": "H30-C00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "H30-L01",
    "Device": "hwH30",
    "Model": "HONOR H30-L01"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "H30-L01M",
    "Device": "hwH30",
    "Model": "HONOR H30-L01M"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "H30-L02",
    "Device": "hwH30",
    "Model": "H30-L02"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "H30-L02",
    "Device": "hwH30",
    "Model": "HONOR H30-L02"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "H30-T00",
    "Device": "hwH30-T00",
    "Model": "H30-T00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "H60",
    "Device": "hwH60",
    "Model": "H60-L01"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "H60-J1",
    "Device": "hwH60",
    "Model": "HW-H60-J1"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "H60-L01",
    "Device": "hwH60",
    "Model": "H60-L01"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "H60-L02",
    "Device": "hwH60",
    "Model": "H60-L02"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "H60-L03",
    "Device": "hwH60",
    "Model": "H60-L03"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "H60-L04",
    "Device": "hwH60",
    "Model": "H60-L04"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "H60-L11",
    "Device": "hwH60",
    "Model": "H60-L11"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "H60-L12",
    "Device": "hwH60",
    "Model": "H60-L12"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "H60-L21",
    "Device": "hwH60",
    "Model": "H60-L21"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "H60-L21",
    "Device": "hwH60-L21",
    "Model": "H60-L21"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "H871G",
    "Device": "hwh871g",
    "Model": "HUAWEI H871G"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "H882L",
    "Device": "hwh882l",
    "Model": "H882L"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "H891L",
    "Device": "hwH891L",
    "Model": "HUAWEI H891L"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "H892L",
    "Device": "hwH892L",
    "Model": "HUAWEI H892L"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HAUWEI Y5 Lite 2018",
    "Device": "HWCAG-L6737M",
    "Model": "CAG-L22"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HONOR 10i",
    "Device": "HWHRY-HF",
    "Model": "HRY-LX1T"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HONOR 20",
    "Device": "HWYAL",
    "Model": "YAL-AL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HONOR 20",
    "Device": "HWYAL",
    "Model": "YAL-L21"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HONOR 20",
    "Device": "HWYAL",
    "Model": "YAL-TL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HONOR 20 LITE",
    "Device": "HWMAR",
    "Model": "MAR-LX1R"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HONOR 20 PRO",
    "Device": "HWYAL",
    "Model": "YAL-AL10"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HONOR 20 PRO",
    "Device": "HWYAL",
    "Model": "YAL-L41"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HONOR 20S",
    "Device": "HWMAR",
    "Model": "MAR-LX1H"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HONOR 20e",
    "Device": "HWHRY-HF",
    "Model": "HRY-LX1T"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HONOR 20i",
    "Device": "HWHRY-HF",
    "Model": "HRY-AL00Ta"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HONOR 4X",
    "Device": "hwChe2",
    "Model": "Che2-L12"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HONOR 8A Pro",
    "Device": "HWJAT-M",
    "Model": "JAT-L29"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HONOR 8A Pro",
    "Device": "HWJAT-M",
    "Model": "JAT-L41"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HONOR 8A Pro",
    "Device": "HWJAT-M",
    "Model": "JAT-LX1"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HONOR 8A Pro",
    "Device": "HWJAT-M",
    "Model": "JAT-LX3"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HONOR 8S",
    "Device": "HWKSA-M",
    "Model": "KSA-LX2"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HONOR 8S",
    "Device": "HWKSA-M",
    "Model": "KSA-LX3"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HONOR 8S",
    "Device": "HWKSA-M",
    "Model": "KSA-LX9"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HONOR 9A",
    "Device": "HWDUB-Q",
    "Model": "DUB-LX1"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HONOR 9X",
    "Device": "HWSTK-HF",
    "Model": "STK-L22"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HONOR 9X",
    "Device": "HWSTK-HF",
    "Model": "STK-LX1"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HONOR 9X",
    "Device": "HWSTK-HF",
    "Model": "STK-LX3"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HONOR 9X Lite",
    "Device": "HWJSN-H",
    "Model": "JSN-L21"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HONOR 9X lite",
    "Device": "HWJSN-H",
    "Model": "JSN-L21"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HONOR 9X lite",
    "Device": "HWJSN-H",
    "Model": "JSN-L22"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HONOR 9X lite",
    "Device": "HWJSN-H",
    "Model": "JSN-L23"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HONOR V20",
    "Device": "HWPCT",
    "Model": "PCT-TL10"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HONOR View20",
    "Device": "HWPCT",
    "Model": "PCT-AL10"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HONOR View20",
    "Device": "HWPCT",
    "Model": "PCT-L29"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HUAWEI G Elite Plus",
    "Device": "HWSLA-Q",
    "Model": "SLA-L03"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HUAWEI GR5 2017",
    "Device": "HWBLN-H",
    "Model": "BLL-L21"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HUAWEI GR5 2017",
    "Device": "HWBLN-H",
    "Model": "BLL-L22"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HUAWEI GR5 2017",
    "Device": "HWBLN-H",
    "Model": "HUAWEI BLL-L21"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HUAWEI GR5 2017",
    "Device": "HWBLN-H",
    "Model": "HUAWEI BLL-L22"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HUAWEI Mate 20",
    "Device": "HWHMA",
    "Model": "HMA-L09"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HUAWEI Mate 20",
    "Device": "HWHMA",
    "Model": "HMA-L29"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HUAWEI Mate 20 Pro",
    "Device": "HWLYA",
    "Model": "LYA-L0C"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HUAWEI Mate 20 Pro",
    "Device": "HWLYA",
    "Model": "LYA-L29"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HUAWEI Mate 20 X (5G)",
    "Device": "HWEVR",
    "Model": "EVR-AN00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HUAWEI Mate 20 X (5G)",
    "Device": "HWEVR",
    "Model": "EVR-N29"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HUAWEI Mate 20 lite",
    "Device": "HWSNE",
    "Model": "SNE-LX1"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HUAWEI Mate 9 lite",
    "Device": "HWBLN-H",
    "Model": "BLL-L23"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HUAWEI Mate 9 lite",
    "Device": "HWBLN-H",
    "Model": "HUAWEI BLL-L23"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HUAWEI Mate SE",
    "Device": "HWBND-H",
    "Model": "BND-L34"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HUAWEI MediaPad M3 Lite",
    "Device": "HWCPN-Q",
    "Model": "701HW"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HUAWEI MediaPad M3 Lite",
    "Device": "HWCPN-Q",
    "Model": "702HW"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HUAWEI MediaPad M3 Lite",
    "Device": "HWCPN-Q",
    "Model": "CPN-AL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HUAWEI MediaPad M3 Lite",
    "Device": "HWCPN-Q",
    "Model": "CPN-L09"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HUAWEI MediaPad M3 Lite",
    "Device": "HWCPN-Q",
    "Model": "CPN-W09"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HUAWEI MediaPad M3 Lite 10 wp",
    "Device": "HWHDN-H",
    "Model": "HDN-L09"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HUAWEI MediaPad M3 Lite 10 wp",
    "Device": "HWHDN-H",
    "Model": "HDN-W09"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HUAWEI MediaPad M5 10.8",
    "Device": "HWCMR09",
    "Model": "CMR-AL09"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HUAWEI MediaPad M5 10.8",
    "Device": "HWCMR09",
    "Model": "CMR-W09"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HUAWEI MediaPad M5 8.4",
    "Device": "HWSHT",
    "Model": "SHT-AL09"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HUAWEI MediaPad M5 8.4",
    "Device": "HWSHT",
    "Model": "SHT-W09"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HUAWEI MediaPad M5 Pro",
    "Device": "HWCMR",
    "Model": "CMR-AL19"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HUAWEI MediaPad M5 Pro",
    "Device": "HWCMR",
    "Model": "CMR-W19"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HUAWEI MediaPad M5 lite",
    "Device": "HWBAH2",
    "Model": "BAH2-L09"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HUAWEI MediaPad M5 lite",
    "Device": "HWBAH2",
    "Model": "BAH2-W19"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HUAWEI MediaPad M5 lite",
    "Device": "HWJDN2",
    "Model": "JDN2-L09"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HUAWEI MediaPad M5 lite",
    "Device": "HWJDN2",
    "Model": "JDN2-W09"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HUAWEI MediaPad T3 10",
    "Device": "HWAGS-Q",
    "Model": "AGS-L03"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HUAWEI MediaPad T3 10",
    "Device": "HWAGS-Q",
    "Model": "AGS-L09"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HUAWEI MediaPad T3 10",
    "Device": "HWAGS-Q",
    "Model": "AGS-W09"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HUAWEI MediaPad T3 7",
    "Device": "HWBG2",
    "Model": "BG2-U03"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HUAWEI MediaPad T5",
    "Device": "HWAGS2",
    "Model": "AGS2-W09"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HUAWEI Nova 3i",
    "Device": "HWINE",
    "Model": "INE-LX1"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HUAWEI P smart",
    "Device": "HWFIG-H",
    "Model": "FIG-LA1"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HUAWEI P smart",
    "Device": "HWFIG-H",
    "Model": "FIG-LX2"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HUAWEI P smart",
    "Device": "HWFIG-H",
    "Model": "FIG-LX3"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HUAWEI P smart 2019",
    "Device": "HWPOT-H",
    "Model": "POT-LX1"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HUAWEI P smart 2019",
    "Device": "HWPOT-H",
    "Model": "POT-LX1AF"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HUAWEI P smart 2019",
    "Device": "HWPOT-H",
    "Model": "POT-LX3"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HUAWEI P smart 2020",
    "Device": "HWPOT-H",
    "Model": "POT-LX1A"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HUAWEI P smart 2020",
    "Device": "HWPOT-H",
    "Model": "POT-LX3"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HUAWEI P smart Pro",
    "Device": "HWSTK-HF",
    "Model": "STK-L21"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HUAWEI P smart Pro",
    "Device": "HWSTK-HF",
    "Model": "STK-LX1"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HUAWEI P smart Z",
    "Device": "HWSTK-HF",
    "Model": "STK-LX1"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HUAWEI P smart+ 2019",
    "Device": "HWPOT-H",
    "Model": "POT-LX1T"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HUAWEI P20 Lite",
    "Device": "HWANE",
    "Model": "ANE-LX2J"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HUAWEI P20 Lite",
    "Device": "HWANE",
    "Model": "HWV32"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HUAWEI P30",
    "Device": "HWELE",
    "Model": "ELE-AL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HUAWEI P30",
    "Device": "HWELE",
    "Model": "ELE-L04"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HUAWEI P30",
    "Device": "HWELE",
    "Model": "ELE-L09"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HUAWEI P30",
    "Device": "HWELE",
    "Model": "ELE-L14"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HUAWEI P30",
    "Device": "HWELE",
    "Model": "ELE-L29"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HUAWEI P30",
    "Device": "HWELE",
    "Model": "ELE-L39"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HUAWEI P30",
    "Device": "HWELE",
    "Model": "ELE-L49"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HUAWEI P30",
    "Device": "HWELE",
    "Model": "ELE-TL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HUAWEI P30 lite",
    "Device": "HWMAR",
    "Model": "HWV33"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HUAWEI P30 lite",
    "Device": "HWMAR",
    "Model": "MAR-LX1A"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HUAWEI P30 lite",
    "Device": "HWMAR",
    "Model": "MAR-LX1Am"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HUAWEI P30 lite",
    "Device": "HWMAR",
    "Model": "MAR-LX1B"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HUAWEI P30 lite",
    "Device": "HWMAR",
    "Model": "MAR-LX1M"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HUAWEI P30 lite",
    "Device": "HWMAR",
    "Model": "MAR-LX1Mm"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HUAWEI P30 lite",
    "Device": "HWMAR",
    "Model": "MAR-LX2"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HUAWEI P30 lite",
    "Device": "HWMAR",
    "Model": "MAR-LX2B"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HUAWEI P30 lite",
    "Device": "HWMAR",
    "Model": "MAR-LX2m"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HUAWEI P30 lite",
    "Device": "HWMAR",
    "Model": "MAR-LX3A"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HUAWEI P30 lite",
    "Device": "HWMAR",
    "Model": "MAR-LX3Am"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HUAWEI P30 lite",
    "Device": "HWMAR",
    "Model": "MAR-LX3Bm"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HUAWEI P9 lite mini",
    "Device": "HWSLA-Q",
    "Model": "SLA-L02"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HUAWEI P9 lite mini",
    "Device": "HWSLA-Q",
    "Model": "SLA-L22"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HUAWEI P9 lite mini",
    "Device": "HWSLA-Q",
    "Model": "SLA-L23"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HUAWEI Y MAX",
    "Device": "HWARS-Q",
    "Model": "ARS-L22"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HUAWEI Y3 2017",
    "Device": "HWCRO-L6737M",
    "Model": "CRO-L02"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HUAWEI Y3 2017",
    "Device": "HWCRO-L6737M",
    "Model": "CRO-L22"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HUAWEI Y3 2017",
    "Device": "HWCRO-L6737M",
    "Model": "HUAWEI CRO-L02"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HUAWEI Y3 2017",
    "Device": "HWCRO-L6737M",
    "Model": "HUAWEI CRO-L22"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HUAWEI Y3 2018",
    "Device": "HWCAG-L6737M",
    "Model": "CAG-L02"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HUAWEI Y3 2018",
    "Device": "HWCAG-L6737M",
    "Model": "CAG-L22"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HUAWEI Y5 2018",
    "Device": "HWDRA-M",
    "Model": "DRA-L01"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HUAWEI Y5 2018",
    "Device": "HWDRA-M",
    "Model": "DRA-L21"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HUAWEI Y5 2018",
    "Device": "HWDRA-M",
    "Model": "DRA-LX2"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HUAWEI Y5 2018",
    "Device": "HWDRA-MG",
    "Model": "DRA-LX3"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HUAWEI Y5 2019",
    "Device": "HWAMN-M",
    "Model": "AMN-LX1"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HUAWEI Y5 2019",
    "Device": "HWAMN-M",
    "Model": "AMN-LX2"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HUAWEI Y5 2019",
    "Device": "HWAMN-M",
    "Model": "AMN-LX3"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HUAWEI Y5 2019",
    "Device": "HWAMN-M",
    "Model": "AMN-LX9"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HUAWEI Y5 Prime 2018",
    "Device": "HWDRA-M",
    "Model": "DRA-LX2"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HUAWEI Y5 lite",
    "Device": "HWDRA-MG",
    "Model": "DRA-LX5"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HUAWEI Y5 lite 2017",
    "Device": "HWCRO-L6737M",
    "Model": "CRO-L03"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HUAWEI Y5 lite 2017",
    "Device": "HWCRO-L6737M",
    "Model": "CRO-L23"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HUAWEI Y5 lite 2017",
    "Device": "HWCRO-L6737M",
    "Model": "HUAWEI CRO-L03"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HUAWEI Y5 lite 2017",
    "Device": "HWCRO-L6737M",
    "Model": "HUAWEI CRO-L23"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HUAWEI Y5 lite 2018",
    "Device": "HWCAG-L6737M",
    "Model": "CAG-L03"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HUAWEI Y5 lite 2018",
    "Device": "HWCAG-L6737M",
    "Model": "CAG-L23"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HUAWEI Y6 2017",
    "Device": "HWMYA-L6737",
    "Model": "MYA-L11"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HUAWEI Y6 2018",
    "Device": "HWATU-QG",
    "Model": "ATU-L11"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HUAWEI Y6 2018",
    "Device": "HWATU-QG",
    "Model": "ATU-L21"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HUAWEI Y6 2018",
    "Device": "HWATU-QG",
    "Model": "ATU-L22"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HUAWEI Y6 2018",
    "Device": "HWATU-QG",
    "Model": "ATU-LX3"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HUAWEI Y6 2019",
    "Device": "HWMRD-M1",
    "Model": "MRD-LX1"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HUAWEI Y6 2019",
    "Device": "HWMRD-M1",
    "Model": "MRD-LX1F"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HUAWEI Y6 2019",
    "Device": "HWMRD-M1",
    "Model": "MRD-LX1N"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HUAWEI Y6 2019",
    "Device": "HWMRD-M1",
    "Model": "MRD-LX3"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HUAWEI Y6 Prime 2018",
    "Device": "HWATU-QG",
    "Model": "ATU-L31"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HUAWEI Y6 Prime 2018",
    "Device": "HWATU-QG",
    "Model": "ATU-L42"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HUAWEI Y6 Pro 2019",
    "Device": "HWMRD-M1",
    "Model": "MRD-LX2"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HUAWEI Y6II",
    "Device": "HWCAM-H",
    "Model": "HUAWEI CAM-L53"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HUAWEI Y6s",
    "Device": "HWJAT-M",
    "Model": "JAT-L29"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HUAWEI Y6s",
    "Device": "HWJAT-M",
    "Model": "JAT-L41"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HUAWEI Y6s",
    "Device": "HWJAT-M",
    "Model": "JAT-LX1"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HUAWEI Y6s",
    "Device": "HWJAT-M",
    "Model": "JAT-LX3"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HUAWEI Y7 2018",
    "Device": "HWLDN-Q",
    "Model": "LDN-L01"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HUAWEI Y7 2018",
    "Device": "HWLDN-Q",
    "Model": "LDN-L21"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HUAWEI Y7 2018",
    "Device": "HWLDN-Q",
    "Model": "LDN-LX3"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HUAWEI Y7 2019",
    "Device": "HWDUB-Q",
    "Model": "DUB-LX1"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HUAWEI Y7 2019",
    "Device": "HWDUB-Q",
    "Model": "DUB-LX3"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HUAWEI Y7 Prime 2018",
    "Device": "HWLDN-Q",
    "Model": "LDN-L21"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HUAWEI Y7 Prime 2018",
    "Device": "HWLDN-Q",
    "Model": "LDN-LX2"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HUAWEI Y7 Pro 2019",
    "Device": "HWDUB-Q",
    "Model": "DUB-LX2"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HUAWEI Y7s",
    "Device": "HWDUB-Q",
    "Model": "DUB-LX1"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HUAWEI Y7s",
    "Device": "HWDUB-Q",
    "Model": "DUB-LX2"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HUAWEI Y7s",
    "Device": "HWDUB-Q",
    "Model": "DUB-LX3"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HUAWEI Y8s",
    "Device": "HWJKM-H",
    "Model": "JKM-LX1"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HUAWEI Y8s",
    "Device": "HWJKM-H",
    "Model": "JKM-LX2"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HUAWEI Y8s",
    "Device": "HWJKM-H",
    "Model": "JKM-LX3"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HUAWEI Y9 2018",
    "Device": "HWFLA-H",
    "Model": "FLA-LX1"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HUAWEI Y9 2018",
    "Device": "HWFLA-H",
    "Model": "FLA-LX2"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HUAWEI Y9 2018",
    "Device": "HWFLA-H",
    "Model": "FLA-LX3"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HUAWEI Y9 2019",
    "Device": "HWJKM-H",
    "Model": "JKM-LX1"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HUAWEI Y9 2019",
    "Device": "HWJKM-H",
    "Model": "JKM-LX2"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HUAWEI Y9 2019",
    "Device": "HWJKM-H",
    "Model": "JKM-LX3"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HUAWEI Y9 Prime 2019",
    "Device": "HWSTK-HF",
    "Model": "STK-L21"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HUAWEI Y9s",
    "Device": "HWSTK-HF",
    "Model": "STK-L21"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HUAWEI Y9s",
    "Device": "HWSTK-HF",
    "Model": "STK-L22"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HUAWEI Y9s",
    "Device": "HWSTK-HF",
    "Model": "STK-LX3"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HUAWEI nova 2 Plus",
    "Device": "HWBAC",
    "Model": "BAC-L21"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HUAWEI nova 2 Plus",
    "Device": "HWBAC",
    "Model": "BAC-L22"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HUAWEI nova 2 lite",
    "Device": "HWLDN-Q",
    "Model": "LDN-LX2"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HUAWEI nova 5T",
    "Device": "HWYAL",
    "Model": "YAL-L21"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HUAWEI nova 5T Pro",
    "Device": "HWYAL",
    "Model": "YAL-L41"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HUAWEI nova lite 2",
    "Device": "HWFIG-H",
    "Model": "704HW"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HUAWEI nova lite 3",
    "Device": "HWPOT-H",
    "Model": "POT-LX2J"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HUAWEI nova lite 3+",
    "Device": "HWPOT-H",
    "Model": "POT-LX2J"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HUAWEI nova lite for Y!mobile",
    "Device": "HWPRA-H",
    "Model": "608HW"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HUWEI MediaPad T3",
    "Device": "HWKobe-Q",
    "Model": "KOB-L09"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HUWEI MediaPad T3",
    "Device": "HWKobe-Q",
    "Model": "KOB-W09"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HW-03E",
    "Device": "HW-03E",
    "Model": "HW-03E"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "HWT31",
    "Device": "hwfdra04l",
    "Model": "HWT31"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Hol-T00",
    "Device": "HWHol-T",
    "Model": "Hol-T00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Hol-U10",
    "Device": "HWHol-U",
    "Model": "Hol-U10"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Hol-U19",
    "Device": "HWHol-U",
    "Model": "Hol-U19"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Honor 10",
    "Device": "HWCOL",
    "Model": "COL-AL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Honor 10",
    "Device": "HWCOL",
    "Model": "COL-AL10"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Honor 10",
    "Device": "HWCOL",
    "Model": "COL-L29"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Honor 10",
    "Device": "HWCOL",
    "Model": "COL-TL10"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Honor 10 Lite",
    "Device": "HWHRY-H",
    "Model": "HRY-AL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Honor 10 Lite",
    "Device": "HWHRY-HF",
    "Model": "HRY-AL00a"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Honor 20i",
    "Device": "HWHRY-HF",
    "Model": "HRY-AL00Ta"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Honor 4A",
    "Device": "hnSCC-Q",
    "Model": "SCC-U21"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Honor 4A",
    "Device": "hnSCL-Q",
    "Model": "SCL-AL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Honor 4A",
    "Device": "hnSCL-Q",
    "Model": "SCL-CL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Honor 4A",
    "Device": "hnSCL-Q",
    "Model": "SCL-TL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Honor 4A",
    "Device": "hnSCL-Q",
    "Model": "SCL-TL00H"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Honor 5A",
    "Device": "HWLYO-L6735",
    "Model": "HUAWEI LYO-L21"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Honor 5A",
    "Device": "HWLYO-L6735",
    "Model": "LYO-L21"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Honor 5C",
    "Device": "HNNEM-H",
    "Model": "NEM-L21"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Honor 5C",
    "Device": "HNNEM-H",
    "Model": "NEM-L22"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Honor 5C",
    "Device": "HNNEM-H",
    "Model": "NEM-L51"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Honor 5X",
    "Device": "HNKIW-Q",
    "Model": "KIW-L21"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Honor 5X",
    "Device": "HNKIW-Q",
    "Model": "KIW-TL00H"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Honor 6A",
    "Device": "HWDLI-Q",
    "Model": "DLI-L22"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Honor 6A",
    "Device": "HWDLI-Q",
    "Model": "DLI-TL20"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Honor 6X",
    "Device": "HWBLN-H",
    "Model": "BLN-L24"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Honor 7",
    "Device": "HWPLK",
    "Model": "PLK-AL10"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Honor 7",
    "Device": "HWPLK",
    "Model": "PLK-CL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Honor 7",
    "Device": "HWPLK",
    "Model": "PLK-L01"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Honor 7",
    "Device": "HWPLK",
    "Model": "PLK-TL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Honor 7",
    "Device": "HWPLK",
    "Model": "PLK-TL01H"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Honor 7",
    "Device": "HWPLK",
    "Model": "PLK-UL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Honor 7A",
    "Device": "HWAUM-Q",
    "Model": "AUM-AL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Honor 7A",
    "Device": "HWAUM-Q",
    "Model": "AUM-AL20"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Honor 7A",
    "Device": "HWAUM-Q",
    "Model": "AUM-L29"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Honor 7A",
    "Device": "HWAUM-Q",
    "Model": "AUM-L33"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Honor 7A",
    "Device": "HWAUM-Q",
    "Model": "AUM-TL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Honor 7A",
    "Device": "HWAUM-Q",
    "Model": "AUM-TL20"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Honor 7A",
    "Device": "HWDUA-M",
    "Model": "DUA-L22"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Honor 7C",
    "Device": "HWAUM-Q",
    "Model": "AUM-L41"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Honor 7C",
    "Device": "HWLND-Q",
    "Model": "LND-AL30"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Honor 7C",
    "Device": "HWLND-Q",
    "Model": "LND-AL40"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Honor 7C",
    "Device": "HWLND-Q",
    "Model": "LND-L29"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Honor 7C",
    "Device": "HWLND-Q",
    "Model": "LND-TL30"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Honor 7C",
    "Device": "HWLND-Q",
    "Model": "LND-TL40"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Honor 7S",
    "Device": "HWDRA-MG",
    "Model": "DRA-LX5"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Honor 7S",
    "Device": "HWDUA-M",
    "Model": "DUA-AL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Honor 7S",
    "Device": "HWDUA-M",
    "Model": "DUA-L22"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Honor 7S",
    "Device": "HWDUA-M",
    "Model": "DUA-LX3"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Honor 7X",
    "Device": "HWBND-H",
    "Model": "BND-L21"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Honor 7X",
    "Device": "HWBND-H",
    "Model": "BND-L24"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Honor 7X",
    "Device": "HWBND-H",
    "Model": "BND-L31"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Honor 7i",
    "Device": "HWATH",
    "Model": "ATH-AL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Honor 7i",
    "Device": "HWATH",
    "Model": "ATH-CL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Honor 8",
    "Device": "HWFRD",
    "Model": "FRD-AL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Honor 8",
    "Device": "HWFRD",
    "Model": "FRD-AL10"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Honor 8",
    "Device": "HWFRD",
    "Model": "FRD-DL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Honor 8",
    "Device": "HWFRD",
    "Model": "FRD-L04"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Honor 8",
    "Device": "HWFRD",
    "Model": "FRD-L09"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Honor 8",
    "Device": "HWFRD",
    "Model": "FRD-L14"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Honor 8",
    "Device": "HWFRD",
    "Model": "FRD-L19"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Honor 8",
    "Device": "HWFRD",
    "Model": "FRD-L24"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Honor 8",
    "Device": "HWFRD",
    "Model": "FRD-TL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Honor 8 Lite",
    "Device": "HWPRA-H",
    "Model": "PRA-LX1"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Honor 8 Pro",
    "Device": "HWDUK",
    "Model": "DUK-L09"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Honor 8 Smart",
    "Device": "HWVNS-H",
    "Model": "VEN-L22"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Honor 8A",
    "Device": "HWJAT-M",
    "Model": "JAT-AL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Honor 8A",
    "Device": "HWJAT-M",
    "Model": "JAT-L29"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Honor 8A",
    "Device": "HWJAT-M",
    "Model": "JAT-L41"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Honor 8A",
    "Device": "HWJAT-M",
    "Model": "JAT-LX1"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Honor 8A",
    "Device": "HWJAT-M",
    "Model": "JAT-LX3"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Honor 8C",
    "Device": "HWBKK-Q",
    "Model": "BKK-L21"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Honor 8X",
    "Device": "HWJSN-H",
    "Model": "JSN-L21"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Honor 8X",
    "Device": "HWJSN-H",
    "Model": "JSN-L22"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Honor 8X",
    "Device": "HWJSN-H",
    "Model": "JSN-L23"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Honor 8X Max",
    "Device": "HWARE-QC",
    "Model": "ARE-L22HN"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Honor 8x",
    "Device": "HWJSN-H",
    "Model": "JSN-L42"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Honor 9",
    "Device": "HWSTF",
    "Model": "STF-AL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Honor 9",
    "Device": "HWSTF",
    "Model": "STF-AL10"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Honor 9",
    "Device": "HWSTF",
    "Model": "STF-L09"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Honor 9",
    "Device": "HWSTF",
    "Model": "STF-L09S"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Honor 9",
    "Device": "HWSTF",
    "Model": "STF-TL10"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Honor 9 Lite",
    "Device": "HWLLD-H",
    "Model": "LLD-L21"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Honor 9 Lite",
    "Device": "HWLLD-H",
    "Model": "LLD-L31"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Honor 9N",
    "Device": "HWLLD-H2",
    "Model": "LLD-AL20"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Honor Box",
    "Device": "m321",
    "Model": "M321"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Honor Box Pro",
    "Device": "hwHiTV-M1",
    "Model": "HiTV-M1"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Honor Box voice",
    "Device": "HWM311",
    "Model": "M311"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Honor Magic",
    "Device": "HWNTS",
    "Model": "HUAWEI NTS-AL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Honor Magic",
    "Device": "HWNTS",
    "Model": "NTS-AL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Honor Magic 2",
    "Device": "HWTNY",
    "Model": "TNY-AL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Honor Magic 2",
    "Device": "HWTNY",
    "Model": "TNY-TL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Honor Note10",
    "Device": "HWRVL",
    "Model": "RVL-AL09"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Honor Play",
    "Device": "HWCOR",
    "Model": "COR-AL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Honor Play",
    "Device": "HWCOR",
    "Model": "COR-AL10"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Honor Play",
    "Device": "HWCOR",
    "Model": "COR-L29"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Honor Play",
    "Device": "HWCOR",
    "Model": "COR-TL10"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Honor V10",
    "Device": "HWBKL",
    "Model": "BKL-AL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Honor V10",
    "Device": "HWBKL",
    "Model": "BKL-AL20"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Honor V10",
    "Device": "HWBKL",
    "Model": "BKL-TL10"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Honor V8",
    "Device": "HWKNT",
    "Model": "KNT-AL10"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Honor V8",
    "Device": "HWKNT",
    "Model": "KNT-AL20"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Honor V8",
    "Device": "HWKNT",
    "Model": "KNT-TL10"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Honor V8",
    "Device": "HWKNT",
    "Model": "KNT-UL10"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Honor V9",
    "Device": "HWDUK",
    "Model": "DUK-AL20"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Honor V9",
    "Device": "HWDUK",
    "Model": "DUK-TL30"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Honor View 10",
    "Device": "HWBKL",
    "Model": "BKL-L04"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Honor View 10",
    "Device": "HWBKL",
    "Model": "BKL-L09"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Honor3",
    "Device": "hwH30-T10",
    "Model": "H30-T10"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Honor3",
    "Device": "hwH30-U10",
    "Model": "H30-U10"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Honor3",
    "Device": "hwhn3-u00",
    "Model": "HUAWEI HN3-U00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Honor3",
    "Device": "hwhn3-u01",
    "Model": "HUAWEI HN3-U01"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Honor 8A",
    "Device": "HWJAT-M",
    "Model": "JAT-AL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Huawei Ascend XT2™",
    "Device": "HWH1711-Q",
    "Model": "H1711"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Huawei Elate™",
    "Device": "HWH1711-Q",
    "Model": "H1711z"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Huawei Mate 20 X",
    "Device": "HWEVR",
    "Model": "EVR-L29"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Huawei Mate 20 X",
    "Device": "HWEVR",
    "Model": "EVR-TL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Huawei Mate 20 X (5G)",
    "Device": "HWEVR",
    "Model": "EVR-N29"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Huawei MediaPad T5",
    "Device": "HWAGS2",
    "Model": "AGS2-L03"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Huawei MediaPad T5",
    "Device": "HWAGS2",
    "Model": "AGS2-L09"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Huawei MediaPad T5",
    "Device": "HWAGS2",
    "Model": "AGS2-W19"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Huawei Nova 2",
    "Device": "HWPIC",
    "Model": "PIC-LX9"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Huawei P30",
    "Device": "HWELE",
    "Model": "ELE-L09"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Huawei Y9 2019",
    "Device": "HWJKM-HM",
    "Model": "JKM-AL00a"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Huawei Y9s",
    "Device": "HWSTK-HF",
    "Model": "STK-L21"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Huwei Mate 20 X",
    "Device": "HWEVR",
    "Model": "EVR-AL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "IDEOS",
    "Device": "U8150",
    "Model": "Comet"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "IDEOS",
    "Device": "U8150",
    "Model": "Ideos"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "IDEOS",
    "Device": "u8150",
    "Model": "Ideos"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Ice-Twist",
    "Device": "Ice-Twist",
    "Model": "Ice-Twist"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Ideos X5",
    "Device": "hwu8800-51",
    "Model": "Huawei U8800-51"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Ideos X5",
    "Device": "hwu8800-51",
    "Model": "IDEOS X5"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Ideos X5",
    "Device": "hwu8800-51",
    "Model": "U8800"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Ideos X5",
    "Device": "hwu8800-51",
    "Model": "U8800-51"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Kiwi-2",
    "Device": "HWH710VL-Q",
    "Model": "H1622"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "LISZT",
    "Device": "hwliszt",
    "Model": "HUAWEI M2-A01L"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "LISZT",
    "Device": "hwliszt",
    "Model": "HUAWEI M2-A01W"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "M2",
    "Device": "HWMozart",
    "Model": "HUAWEI M2-801L"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "M2",
    "Device": "HWMozart",
    "Model": "HUAWEI M2-801W"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "M2",
    "Device": "HWMozart",
    "Model": "HUAWEI M2-802L"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "M2",
    "Device": "HWMozart",
    "Model": "HUAWEI M2-803L"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "M220",
    "Device": "hwmediaqm220",
    "Model": "M220"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "M220",
    "Device": "hwmediaqm220",
    "Model": "M220c"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "M220",
    "Device": "hwmediaqm220",
    "Model": "dTV01"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "M3",
    "Device": "hwbeethoven",
    "Model": "BTV-DL09"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "M3",
    "Device": "hwbeethoven",
    "Model": "BTV-W09"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "M310",
    "Device": "hwsingleboxm310w",
    "Model": "M310"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "M620",
    "Device": "M620",
    "Model": "M620"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "M620",
    "Device": "M620",
    "Model": "TB01"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "M835",
    "Device": "hwm835",
    "Model": "HUAWEI-M835"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "M860",
    "Device": "M860",
    "Model": "M860"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "M865",
    "Device": "hwm865",
    "Model": "M865"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "M865",
    "Device": "hwm865",
    "Model": "USCCADR3305"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "M868",
    "Device": "hwm868",
    "Model": "HUAWEI M868"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "MAIMANG 6",
    "Device": "HWRNE",
    "Model": "RNE-AL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "MAIMANG 7",
    "Device": "HWSNE",
    "Model": "SNE-AL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "MS4C",
    "Device": "hwMS4C",
    "Model": "MS4C"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "MT1",
    "Device": "hwmt1-u06",
    "Model": "HUAWEI MT1-U06"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "MT2-L01",
    "Device": "hwmt2-l01",
    "Model": "HUAWEI MT2-L01"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "MT2-L02",
    "Device": "hwmt2-l02",
    "Model": "HUAWEI MT2-L02"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "MT2-L03",
    "Device": "hwMT2L03",
    "Model": "MT2L03"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "MT2-L05",
    "Device": "hwmt2-l05",
    "Model": "HUAWEI MT2-L05"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "MT2L03LITE",
    "Device": "hwMT2L03LITE",
    "Model": "MT2L03"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Mate",
    "Device": "hwmt1-t00",
    "Model": "HUAWEI MT1-T00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Mate 10",
    "Device": "HWALP",
    "Model": "ALP-AL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Mate 10",
    "Device": "HWALP",
    "Model": "ALP-L09"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Mate 10",
    "Device": "HWALP",
    "Model": "ALP-L29"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Mate 10",
    "Device": "HWALP",
    "Model": "ALP-TL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Mate 10 Pro",
    "Device": "HWBLA",
    "Model": "BLA-A09"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Mate 10 Pro",
    "Device": "HWBLA",
    "Model": "BLA-AL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Mate 10 Pro",
    "Device": "HWBLA",
    "Model": "BLA-L09"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Mate 10 Pro",
    "Device": "HWBLA",
    "Model": "BLA-L29"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Mate 10 Pro",
    "Device": "HWBLA",
    "Model": "BLA-TL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Mate 10 lite",
    "Device": "HWRNE",
    "Model": "RNE-L01"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Mate 10 lite",
    "Device": "HWRNE",
    "Model": "RNE-L03"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Mate 10 lite",
    "Device": "HWRNE",
    "Model": "RNE-L21"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Mate 10 lite",
    "Device": "HWRNE",
    "Model": "RNE-L23"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Mate 20",
    "Device": "HWHMA",
    "Model": "HMA-AL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Mate 20",
    "Device": "HWHMA",
    "Model": "HMA-L09"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Mate 20",
    "Device": "HWHMA",
    "Model": "HMA-L29"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Mate 20",
    "Device": "HWHMA",
    "Model": "HMA-TL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Mate 20 Pro",
    "Device": "HWLYA",
    "Model": "LYA-AL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Mate 20 Pro",
    "Device": "HWLYA",
    "Model": "LYA-AL10"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Mate 20 Pro",
    "Device": "HWLYA",
    "Model": "LYA-L09"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Mate 20 Pro",
    "Device": "HWLYA",
    "Model": "LYA-L29"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Mate 20 Pro",
    "Device": "HWLYA",
    "Model": "LYA-TL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Mate 20 RS",
    "Device": "HWLYA",
    "Model": "LYA-AL00P"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Mate 20 lite",
    "Device": "HWSNE",
    "Model": "SNE-LX1"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Mate 20 lite",
    "Device": "HWSNE",
    "Model": "SNE-LX2"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Mate 20 lite",
    "Device": "HWSNE",
    "Model": "SNE-LX3"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Mate 7",
    "Device": "hwmt7",
    "Model": "HUAWEI MT7-CL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Mate 7",
    "Device": "hwmt7",
    "Model": "HUAWEI MT7-J1"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Mate 7",
    "Device": "hwmt7",
    "Model": "HUAWEI MT7-L09"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Mate 7",
    "Device": "hwmt7",
    "Model": "HUAWEI MT7-TL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Mate 7",
    "Device": "hwmt7",
    "Model": "HUAWEI MT7-TL10"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Mate 7",
    "Device": "hwmt7",
    "Model": "HUAWEI MT7-UL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Mate 8",
    "Device": "HWNXT",
    "Model": "HUAWEI NXT-AL10"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Mate 8",
    "Device": "HWNXT",
    "Model": "HUAWEI NXT-CL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Mate 8",
    "Device": "HWNXT",
    "Model": "HUAWEI NXT-DL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Mate 8",
    "Device": "HWNXT",
    "Model": "HUAWEI NXT-L09"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Mate 8",
    "Device": "HWNXT",
    "Model": "HUAWEI NXT-L29"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Mate 8",
    "Device": "HWNXT",
    "Model": "HUAWEI NXT-TL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Mate 8",
    "Device": "HWNXT",
    "Model": "HUAWEI NXT-TL00B"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Mate 8",
    "Device": "HWNXT",
    "Model": "NXT-AL10"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Mate 8",
    "Device": "HWNXT",
    "Model": "NXT-CL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Mate 8",
    "Device": "HWNXT",
    "Model": "NXT-DL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Mate 8",
    "Device": "HWNXT",
    "Model": "NXT-L09"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Mate 8",
    "Device": "HWNXT",
    "Model": "NXT-L29"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Mate 8",
    "Device": "HWNXT",
    "Model": "NXT-TL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Mate 9",
    "Device": "HWMHA",
    "Model": "MHA-AL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Mate 9",
    "Device": "HWMHA",
    "Model": "MHA-L09"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Mate 9",
    "Device": "HWMHA",
    "Model": "MHA-L29"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Mate 9",
    "Device": "HWMHA",
    "Model": "MHA-TL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Mate 9 Pro",
    "Device": "HWLON",
    "Model": "LON-AL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Mate 9 Pro",
    "Device": "HWLON",
    "Model": "LON-L29"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Mate S",
    "Device": "HWCRR",
    "Model": "HUAWEI CRR-CL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Mate S",
    "Device": "HWCRR",
    "Model": "HUAWEI CRR-CL20"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Mate S",
    "Device": "HWCRR",
    "Model": "HUAWEI CRR-L09"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Mate S",
    "Device": "HWCRR",
    "Model": "HUAWEI CRR-TL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Mate S",
    "Device": "HWCRR",
    "Model": "HUAWEI CRR-UL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Mate S",
    "Device": "HWCRR",
    "Model": "HUAWEI CRR-UL20"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Mate2",
    "Device": "hwmt2-c00",
    "Model": "HUAWEI MT2-C00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "MediaPad",
    "Device": "hwt1701",
    "Model": "HUAWEI MediaPad T1 7.0 3G"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "MediaPad",
    "Device": "hwt1701",
    "Model": "T1 7.0"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "MediaPad",
    "Device": "hwt1701",
    "Model": "T1-701u"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "MediaPad",
    "Device": "hwt1701",
    "Model": "T1-701ua"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "MediaPad",
    "Device": "hwt1701",
    "Model": "T1-701us"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "MediaPad",
    "Device": "hwt1701",
    "Model": "T1-701w"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "MediaPad",
    "Device": "hwt1701",
    "Model": "Telpad QS"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "MediaPad 10 FHD",
    "Device": "hws10101l",
    "Model": "MediaPad 10 FHD"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "MediaPad 10 Link",
    "Device": "hws10201w",
    "Model": "MediaPad 10 LINK"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "MediaPad 10 Link",
    "Device": "hws10201w",
    "Model": "dtab 01"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "MediaPad 10 Link+",
    "Device": "hws10231l",
    "Model": "402HW"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "MediaPad 10 Link+",
    "Device": "hws10231l",
    "Model": "MediaPad 10 Link+"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "MediaPad 10 Link+",
    "Device": "hws10231l",
    "Model": "S10-232L"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "MediaPad 10 Link+",
    "Device": "hws10231l",
    "Model": "SpeedTAB"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "MediaPad 7 Lite",
    "Device": "hws7930u",
    "Model": "MediaPad 7 Lite"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "MediaPad 7 Lite Quad",
    "Device": "hws7961w",
    "Model": "Telpad QS"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "MediaPad 7 Lite Quad",
    "Device": "hws7961w",
    "Model": "Telpad Quad S"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "MediaPad 7 Vogue",
    "Device": "hws7601us",
    "Model": "MediaPad 7 Vogue"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "MediaPad 7 Youth2",
    "Device": "hws7721u",
    "Model": "MediaPad 7 Youth 2"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "MediaPad 7 Youth2",
    "Device": "hws7721u",
    "Model": "S7-721u"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "MediaPad M1 8.0",
    "Device": "hws8301l",
    "Model": "403HW"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "MediaPad M1 8.0",
    "Device": "hws8301l",
    "Model": "CNPC Security Pad S1"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "MediaPad M1 8.0",
    "Device": "hws8301l",
    "Model": "HUAWEI MediaPad M1 8.0"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "MediaPad M1 8.0",
    "Device": "hws8301l",
    "Model": "MediaPad M1 8.0"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "MediaPad M1 8.0",
    "Device": "hws8301l",
    "Model": "MediaPad M1 8.0 (LTE)"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "MediaPad M1 8.0",
    "Device": "hws8301l",
    "Model": "MediaPad M1 8.0 (WIFI)"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "MediaPad M1 8.0",
    "Device": "hws8301l",
    "Model": "S8-303L"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "MediaPad M1 8.0",
    "Device": "hws8301l",
    "Model": "S8-303LT"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "MediaPad M1 8.0",
    "Device": "hws8301l",
    "Model": "S8-306L"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "MediaPad M3 Lite 10",
    "Device": "HWBAH-Q",
    "Model": "BAH-AL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "MediaPad M3 Lite 10",
    "Device": "HWBAH-Q",
    "Model": "BAH-L09"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "MediaPad M3 Lite 10",
    "Device": "HWBAH-Q",
    "Model": "BAH-W09"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "MediaPad T2 10.0 Pro",
    "Device": "hwfdr",
    "Model": "605HW"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "MediaPad T2 10.0 Pro",
    "Device": "hwfdr",
    "Model": "606HW"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "MediaPad T2 10.0 Pro",
    "Device": "hwfdr",
    "Model": "FDR-A05L"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "MediaPad T2 10.0 pro",
    "Device": "HWFDR",
    "Model": "FDR-A01L"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "MediaPad T2 10.0 pro",
    "Device": "HWFDR",
    "Model": "FDR-A01w"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "MediaPad T2 10.0 pro",
    "Device": "HWFDR",
    "Model": "FDR-A03L"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "MediaPad T2 7.0",
    "Device": "hwbgo",
    "Model": "BGO-DL09"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "MediaPad T2 7.0",
    "Device": "hwbgo",
    "Model": "BGO-L03"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "MediaPad T2 8.0 Pro",
    "Device": "hwjdn",
    "Model": "JDN-AL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "MediaPad T2 8.0 Pro",
    "Device": "hwjdn",
    "Model": "JDN-L01"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "MediaPad T2 8.0 Pro",
    "Device": "hwjdn",
    "Model": "JDN-W09"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "MediaPad T3 7",
    "Device": "HWBG2",
    "Model": "BG2-U01"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "MediaPad T3 7",
    "Device": "hwbg2",
    "Model": "BG2-W09"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "MediaPad Vogue",
    "Device": "hws7601u",
    "Model": "MediaPad 7 Lite II"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "MediaPad Vogue",
    "Device": "hws7601u",
    "Model": "MediaPad 7 Vogue"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "MediaPad X1 7.0",
    "Device": "hw7d501l",
    "Model": "7D-501u"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "MediaPad X1 7.0",
    "Device": "hw7d501l",
    "Model": "MediaPad X1"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "MediaPad X1 7.0",
    "Device": "hw7d501l",
    "Model": "MediaPad X1 7.0"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "MediaPad X1 7.0",
    "Device": "hw7d501l",
    "Model": "X1 7.0"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "MediaPad Youth",
    "Device": "hws7701w",
    "Model": "MediaPad 7 Youth"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "MediaPad7",
    "Device": "hws7601w",
    "Model": "MediaPad 7 Vogue"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "MediaQ M380",
    "Device": "HWM380",
    "Model": "M380-10"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Nexus 6P",
    "Device": "angler",
    "Model": "Nexus 6P"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Nova 3i",
    "Device": "HWINE",
    "Model": "INE-LX2r"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "P10",
    "Device": "HWVTR",
    "Model": "VTR-AL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "P10",
    "Device": "HWVTR",
    "Model": "VTR-L09"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "P10",
    "Device": "HWVTR",
    "Model": "VTR-L29"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "P10",
    "Device": "HWVTR",
    "Model": "VTR-TL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "P10 Plus",
    "Device": "HWVKY",
    "Model": "VKY-AL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "P10 Plus",
    "Device": "HWVKY",
    "Model": "VKY-L09"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "P10 Plus",
    "Device": "HWVKY",
    "Model": "VKY-L29"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "P10 Plus",
    "Device": "HWVKY",
    "Model": "VKY-TL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "P10 lite",
    "Device": "HWWAS-H",
    "Model": "WAS-L03T"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "P10 lite",
    "Device": "HWWAS-H",
    "Model": "WAS-LX1"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "P10 lite",
    "Device": "HWWAS-H",
    "Model": "WAS-LX1A"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "P10 lite",
    "Device": "HWWAS-H",
    "Model": "WAS-LX2"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "P10 lite",
    "Device": "HWWAS-H",
    "Model": "WAS-LX2J"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "P10 lite",
    "Device": "HWWAS-H",
    "Model": "WAS-LX3"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "P2",
    "Device": "hwp2-6070",
    "Model": "HUAWEI P2-6070"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "P20",
    "Device": "HWEML",
    "Model": "EML-AL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "P20",
    "Device": "HWEML",
    "Model": "EML-L09"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "P20",
    "Device": "HWEML",
    "Model": "EML-L29"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "P20",
    "Device": "HWEML",
    "Model": "EML-TL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "P20 Pro",
    "Device": "HW-01K",
    "Model": "HW-01K"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "P20 Pro",
    "Device": "HWCLT",
    "Model": "CLT-AL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "P20 Pro",
    "Device": "HWCLT",
    "Model": "CLT-AL00l"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "P20 Pro",
    "Device": "HWCLT",
    "Model": "CLT-AL01"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "P20 Pro",
    "Device": "HWCLT",
    "Model": "CLT-L04"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "P20 Pro",
    "Device": "HWCLT",
    "Model": "CLT-L09"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "P20 Pro",
    "Device": "HWCLT",
    "Model": "CLT-L29"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "P20 Pro",
    "Device": "HWCLT",
    "Model": "CLT-TL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "P20 Pro",
    "Device": "HWCLT",
    "Model": "CLT-TL01"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "P20 lite",
    "Device": "HWANE",
    "Model": "ANE-LX1"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "P20 lite",
    "Device": "HWANE",
    "Model": "ANE-LX2"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "P20 lite",
    "Device": "HWANE",
    "Model": "ANE-LX3"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "P20Pro",
    "Device": "HWCLT",
    "Model": "CLT-L09"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "P20Pro",
    "Device": "HWCLT",
    "Model": "CLT-L29"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "P30 Pro",
    "Device": "HW-02L",
    "Model": "HW-02L"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "P30 Pro",
    "Device": "HWVOG",
    "Model": "VOG-AL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "P30 Pro",
    "Device": "HWVOG",
    "Model": "VOG-AL10"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "P30 Pro",
    "Device": "HWVOG",
    "Model": "VOG-L04"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "P30 Pro",
    "Device": "HWVOG",
    "Model": "VOG-L09"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "P30 Pro",
    "Device": "HWVOG",
    "Model": "VOG-L29"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "P30 Pro",
    "Device": "HWVOG",
    "Model": "VOG-TL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "P30 lite",
    "Device": "HWMAR",
    "Model": "MAR-LX2J"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "P6",
    "Device": "hwp6-c00",
    "Model": "HUAWEI P6-C00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "P6",
    "Device": "hwp6-t00",
    "Model": "HUAWEI P6-T00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "P6",
    "Device": "hwp6-t00",
    "Model": "HUAWEI P6-T00V"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "P6",
    "Device": "hwp6-u06",
    "Model": "HUAWEI Ascend P6"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "P6",
    "Device": "hwp6-u06",
    "Model": "HUAWEI P6-U06"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "P6",
    "Device": "hwp6-u06",
    "Model": "HUAWEI P6-U06-orange"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "P6S",
    "Device": "hwP6s-l04",
    "Model": "P6 S-L04"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "P6S-L04",
    "Device": "hwp6s-l04",
    "Model": "302HW"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "P6S-U06",
    "Device": "hwp6s-u06",
    "Model": "HUAWEI P6 S-U06"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "P7",
    "Device": "hwp7",
    "Model": "HUAWEI P7-L00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "P7",
    "Device": "hwp7",
    "Model": "HUAWEI P7-L05"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "P7",
    "Device": "hwp7",
    "Model": "HUAWEI P7-L07"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "P7",
    "Device": "hwp7",
    "Model": "HUAWEI P7-L10"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "P7",
    "Device": "hwp7",
    "Model": "HUAWEI P7-L11"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "P7",
    "Device": "hwp7",
    "Model": "HUAWEI P7-L12"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "P7 mini",
    "Device": "hwP7Mini",
    "Model": "HUAWEI P7 mini"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "P7-L09",
    "Device": "hwp7",
    "Model": "HUAWEI P7-L09"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "P8",
    "Device": "HWGRA",
    "Model": "HUAWEI GRA-CL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "P8",
    "Device": "HWGRA",
    "Model": "HUAWEI GRA-CL10"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "P8",
    "Device": "HWGRA",
    "Model": "HUAWEI GRA-L09"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "P8",
    "Device": "HWGRA",
    "Model": "HUAWEI GRA-TL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "P8",
    "Device": "HWGRA",
    "Model": "HUAWEI GRA-UL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "P8",
    "Device": "HWGRA",
    "Model": "HUAWEI GRA-UL10"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "P8 Lite",
    "Device": "hwALE-H",
    "Model": "503HW"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "P8 Lite",
    "Device": "hwALE-H",
    "Model": "ALE-L02"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "P8 Lite",
    "Device": "hwALE-H",
    "Model": "ALE-L21"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "P8 Lite",
    "Device": "hwALE-H",
    "Model": "ALE-L23"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "P8 Lite",
    "Device": "hwALE-H",
    "Model": "Autana LTE"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "P8 Lite",
    "Device": "hwALE-Q",
    "Model": "HUAWEI ALE-CL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "P8 Lite",
    "Device": "hwALE-Q",
    "Model": "HUAWEI ALE-L04"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "P8 lite 2017",
    "Device": "HWPRA-H",
    "Model": "PRA-LA1"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "P8 lite 2017",
    "Device": "HWPRA-H",
    "Model": "PRA-LX1"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "P8 青春版",
    "Device": "hwALE-H",
    "Model": "ALE-TL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "P8 青春版",
    "Device": "hwALE-H",
    "Model": "ALE-UL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "P8max",
    "Device": "HWP8max",
    "Model": "HUAWEI P8max"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "P9",
    "Device": "HWEVA",
    "Model": "EVA-AL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "P9",
    "Device": "HWEVA",
    "Model": "EVA-AL10"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "P9",
    "Device": "HWEVA",
    "Model": "EVA-CL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "P9",
    "Device": "HWEVA",
    "Model": "EVA-DL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "P9",
    "Device": "HWEVA",
    "Model": "EVA-L09"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "P9",
    "Device": "HWEVA",
    "Model": "EVA-L19"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "P9",
    "Device": "HWEVA",
    "Model": "EVA-L29"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "P9",
    "Device": "HWEVA",
    "Model": "EVA-TL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "P9 Lite PREMIUM",
    "Device": "HWVNS-Q",
    "Model": "HUAWEI VNS-L52"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "P9 Plus",
    "Device": "HWVIE",
    "Model": "VIE-AL10"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "P9 Plus",
    "Device": "HWVIE",
    "Model": "VIE-L09"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "P9 Plus",
    "Device": "HWVIE",
    "Model": "VIE-L29"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "P9 lite",
    "Device": "HWVNS-H",
    "Model": "HUAWEI VNS-L21"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "P9 lite",
    "Device": "HWVNS-H",
    "Model": "HUAWEI VNS-L22"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "P9 lite",
    "Device": "HWVNS-H",
    "Model": "HUAWEI VNS-L23"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "P9 lite",
    "Device": "HWVNS-H",
    "Model": "HUAWEI VNS-L31"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "P9 lite",
    "Device": "HWVNS-H",
    "Model": "HUAWEI VNS-L53"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "P9 lite",
    "Device": "HWVNS-Q",
    "Model": "HUAWEI VNS-L62"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "P9 lite smart",
    "Device": "HWDIG-L8940",
    "Model": "DIG-L03"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "P9 lite smart",
    "Device": "HWDIG-L8940",
    "Model": "DIG-L23"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "PE-CL00",
    "Device": "hwPE",
    "Model": "PE-CL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "PE-TL00M",
    "Device": "hwPE",
    "Model": "PE-TL00M"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "PE-TL10",
    "Device": "hwPE",
    "Model": "PE-TL10"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "PE-TL20",
    "Device": "hwPE",
    "Model": "PE-TL20"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "PE-UL00",
    "Device": "hwPE",
    "Model": "PE-UL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "PORSCHE DESIGN HUAWEI Mate RS",
    "Device": "HWNEO",
    "Model": "NEO-AL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "PORSCHE DESIGN HUAWEI Mate RS",
    "Device": "HWNEO",
    "Model": "NEO-L29"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Prism II",
    "Device": "hwu8686",
    "Model": "Prism II"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Q22",
    "Device": "HWQ22",
    "Model": "Q22"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "RIO-CL00",
    "Device": "hwRIO-CL00",
    "Model": "HUAWEI RIO-CL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "S10",
    "Device": "hws10103l",
    "Model": "MediaPad 10 FHD"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "S10",
    "Device": "hws10201l",
    "Model": "MediaPad 10 LINK"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "S7",
    "Device": "hws7601c",
    "Model": "MediaPad 7 Vogue"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "S7",
    "Device": "hws7601w",
    "Model": "MediaPad 7 Vogue"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "S7",
    "Device": "hws7701u",
    "Model": "MediaPad 7 Youth"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "S7",
    "Device": "hws7930u",
    "Model": "Orinoquia Roraima S7-932u"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "S7",
    "Device": "hws7951w",
    "Model": "MediaPad 7 Lite+"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "S7",
    "Device": "hws7951w",
    "Model": "Telpad Dual S"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "SC-CL00",
    "Device": "HWSC-CL00",
    "Model": "HUAWEI SC-CL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "SC-UL10",
    "Device": "HWSC-UL10",
    "Model": "HUAWEI SC-UL10"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Sensa LTE",
    "Device": "HWH710VL-Q",
    "Model": "H710VL"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Sensa LTE",
    "Device": "HWH715BL-Q",
    "Model": "H715BL"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "ShotX",
    "Device": "HWATH",
    "Model": "HUAWEI ATH-UL01"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "ShotX",
    "Device": "HWATH",
    "Model": "HUAWEI ATH-UL06"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "T-Mobile Pulse",
    "Device": "U8100",
    "Model": "Huawei_8100-9"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "T-Mobile Pulse",
    "Device": "U8100",
    "Model": "Tactile internet"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "T-Mobile Pulse",
    "Device": "U8100",
    "Model": "U8100"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "T-Mobile Pulse",
    "Device": "U8100",
    "Model": "Videocon_V7400"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "T1",
    "Device": "hwt1821l",
    "Model": "T1-821L"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "T1",
    "Device": "hwt1821l",
    "Model": "T1-821W"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "T1",
    "Device": "hwt1821l",
    "Model": "T1-821w"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "T1",
    "Device": "hwt1821l",
    "Model": "T1-823L"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "T1",
    "Device": "hwt1823l",
    "Model": "T1-823L"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "T1 10",
    "Device": "hwt1a21l",
    "Model": "HUAWEI MediaPad T1 10 4G"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "T1 10",
    "Device": "hwt1a21l",
    "Model": "T1-A21L"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "T1 10",
    "Device": "hwt1a21l",
    "Model": "T1-A21W"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "T1 10",
    "Device": "hwt1a21l",
    "Model": "T1-A21w"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "T1 10",
    "Device": "hwt1a21l",
    "Model": "T1-A22L"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "T1 10",
    "Device": "hwt1a21l",
    "Model": "T1-A23L"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "T101",
    "Device": "hwt101",
    "Model": "T-101"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "T101",
    "Device": "hwt101",
    "Model": "T101 PAD"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "T102",
    "Device": "hwt102",
    "Model": "QH-10"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "T102",
    "Device": "hwt102",
    "Model": "T102 PAD"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "T801",
    "Device": "hwt801",
    "Model": "T801 PAD"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "T802",
    "Device": "hwt802",
    "Model": "MT-803G"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "T802",
    "Device": "hwt802",
    "Model": "T802 PAD"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "T8808D",
    "Device": "hwT8808D",
    "Model": "HUAWEI T8808D"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "TANGO",
    "Device": "HWTAG-L6753",
    "Model": "HUAWEI TAG-AL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "TANGO",
    "Device": "HWTAG-L6753",
    "Model": "HUAWEI TAG-CL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "TANGO",
    "Device": "HWTAG-L6753",
    "Model": "HUAWEI TAG-TL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "U8120",
    "Device": "U8120",
    "Model": "Vodafone 845"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "U8220",
    "Device": "U8220",
    "Model": "Pulse"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "U8220",
    "Device": "U8220",
    "Model": "U8220"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "U8220",
    "Device": "U8220",
    "Model": "U8220PLUS"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "U8230",
    "Device": "U8230",
    "Model": "U8230"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "U8652",
    "Device": "hwu8652",
    "Model": "Huawei-U8652"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "U8652",
    "Device": "hwu8652",
    "Model": "U8652"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "U8687",
    "Device": "hwu8687",
    "Model": "Huawei-U8687"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "U8812D",
    "Device": "hwu8812D",
    "Model": "U8812D"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "U8832D",
    "Device": "hwu8832D",
    "Model": "U8832D"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "U8836D",
    "Device": "hwu8836D",
    "Model": "U8836D"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "U8850",
    "Device": "hwu8850",
    "Model": "HUAWEI-U8850"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "U9000",
    "Device": "hwu9000",
    "Model": "HUAWEI-U9000"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "UNION",
    "Device": "hwY538",
    "Model": "Y538"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "V858",
    "Device": "hwu8160",
    "Model": "Huawei 858"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "V858",
    "Device": "hwu8160",
    "Model": "MTC 950"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "V858",
    "Device": "hwu8160",
    "Model": "MTC Mini"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "V858",
    "Device": "hwu8160",
    "Model": "Vodafone 858"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Vogue7",
    "Device": "hws7601u",
    "Model": "MediaPad 7 Classic"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Vogue7",
    "Device": "hws7601u",
    "Model": "MediaPad 7 Lite II"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Vogue7",
    "Device": "hws7601u",
    "Model": "MediaPad 7 Vogue"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "WATCH",
    "Device": "sturgeon",
    "Model": "HUAWEI WATCH"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "WATCH",
    "Device": "sturgeon",
    "Model": "HUAWEI-WATCH"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Watch 2",
    "Device": "sawfish",
    "Model": "LEO-BX9"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Watch 2",
    "Device": "sawshark",
    "Model": "LEO-DLXX"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "X2",
    "Device": "HWGemini",
    "Model": "GEM-701L"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "X2",
    "Device": "HWGemini",
    "Model": "GEM-702L"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "X2",
    "Device": "HWGemini",
    "Model": "GEM-703L"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "X2",
    "Device": "HWGemini",
    "Model": "GEM-703LT"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y210",
    "Device": "oay210",
    "Model": "Orinoquia Auyantepui Y210"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y220",
    "Device": "HWY220-U",
    "Model": "Y220-U00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y220",
    "Device": "HWY220-U",
    "Model": "Y220-U05"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y220",
    "Device": "HWY220-U",
    "Model": "Y220-U17"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y220-T10",
    "Device": "hwy220-t10",
    "Model": "HUAWEI Y220-T10"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y220-U10",
    "Device": "HWY220-U",
    "Model": "Y220-U10"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y220T",
    "Device": "hwy220t",
    "Model": "HUAWEI Y 220T"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y221-U03",
    "Device": "HWY221-U",
    "Model": "HUAWEI Y221-U03"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y221-U03",
    "Device": "QAY221-U",
    "Model": "ORINOQUIA Auyantepui+Y221-U03"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y221-U12",
    "Device": "HWY221-U",
    "Model": "HUAWEI Y221-U12"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y221-U22",
    "Device": "HWY221-U",
    "Model": "HUAWEI Y221-U22"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y221-U33",
    "Device": "HWY221-U",
    "Model": "HUAWEI Y221-U33"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y221-U43",
    "Device": "HWY221-U",
    "Model": "HUAWEI Y221-U43"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y221-U53",
    "Device": "HWY221-U",
    "Model": "HUAWEI Y221-U53"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y300",
    "Device": "hwY300-0100",
    "Model": "HUAWEI Ascend Y300"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y300",
    "Device": "hwY300-0100",
    "Model": "HUAWEI Y300-0100"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y300",
    "Device": "hwY300-0151",
    "Model": "HUAWEI Y300-0151"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y300",
    "Device": "hwY300-0151",
    "Model": "Pelephone-Y300-"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y300-0000",
    "Device": "hwY300-0000",
    "Model": "HUAWEI Y300-0000"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y301A1",
    "Device": "hwY301A1",
    "Model": "Huawei Y301A1"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y301A2",
    "Device": "hwY301A2",
    "Model": "Huawei Y301A2"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y310-5000",
    "Device": "hwy310-5000",
    "Model": "HUAWEI Y310-5000"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y310-T10",
    "Device": "hwy310-t10",
    "Model": "HUAWEI Y310-T10"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y320",
    "Device": "hwy320-c00",
    "Model": "HUAWEI Y320-C00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y320-T00",
    "Device": "HWY320-T00",
    "Model": "HUAWEI Y320-T00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y320-U01",
    "Device": "HWY320",
    "Model": "HUAWEI Y320-U01"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y320-U01",
    "Device": "HWY320",
    "Model": "Y320-U01"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y320-U10",
    "Device": "HWY320-U",
    "Model": "HUAWEI Y320-U10"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y320-U151",
    "Device": "HWY320-U",
    "Model": "HUAWEI Y320-U151"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y320-U30",
    "Device": "HWY320-U",
    "Model": "HUAWEI Y320-U30"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y320-U351",
    "Device": "HWY320-U",
    "Model": "HUAWEI Y320-U351"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y321",
    "Device": "HWY321-U",
    "Model": "HUAWEI Y321-U051"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y321",
    "Device": "hwy321-c00",
    "Model": "HUAWEI Y321-C00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y325-T00",
    "Device": "HWY325-T",
    "Model": "HUAWEI Y325-T00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y330",
    "Device": "hwY330-U05",
    "Model": "Bucare Y330-U05"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y330",
    "Device": "hwY330-U05",
    "Model": "HUAWEI Y330-U05"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y330",
    "Device": "hwY330-U21",
    "Model": "HUAWEI Y330-U21"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y330-C00",
    "Device": "hwY330-C00",
    "Model": "HUAWEI Y330-C00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y330-U01",
    "Device": "hwY330-U01",
    "Model": "HUAWEI Y330-U01"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y330-U01",
    "Device": "hwY330-U01",
    "Model": "Luno"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y330-U07",
    "Device": "hwY330-U07",
    "Model": "HUAWEI Y330-U07"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y330-U08",
    "Device": "hwY330-U08",
    "Model": "HUAWEI Y330-U08"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y330-U11",
    "Device": "hwY330-U11",
    "Model": "HUAWEI Y330-U11"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y330-U11",
    "Device": "hwY330-U11",
    "Model": "V8510"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y330-U15",
    "Device": "hwY330-U15",
    "Model": "HUAWEI Y330-U15"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y330-U17",
    "Device": "hwY330-U17",
    "Model": "HUAWEI Y330-U17"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y336-A1",
    "Device": "hwY336-A1",
    "Model": "HUAWEI Y336-A1"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y336-U02",
    "Device": "HWY336-U",
    "Model": "HUAWEI Y336-U02"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y336-U12",
    "Device": "HWY336-U",
    "Model": "HUAWEI Y336-U12"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y340-U081",
    "Device": "hwY340-U081",
    "Model": "Y340-U081"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y360-U03",
    "Device": "HWY360-U",
    "Model": "HUAWEI Y360-U03"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y360-U103",
    "Device": "HWY360-U6572",
    "Model": "HUAWEI Y360-U103"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y360-U12",
    "Device": "HWY360-U",
    "Model": "HUAWEI Y360-U12"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y360-U23",
    "Device": "HWY360-U",
    "Model": "HUAWEI Y360-U23"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y360-U31",
    "Device": "HWY360-U",
    "Model": "HUAWEI Y360-U31"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y360-U42",
    "Device": "HWY360-U",
    "Model": "HUAWEI Y360-U42"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y360-U61",
    "Device": "HWY360-U",
    "Model": "HUAWEI Y360-U61"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y360-U72",
    "Device": "HWY360-U6572",
    "Model": "HUAWEI Y360-U72"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y360-U82",
    "Device": "HWY360-U6572",
    "Model": "HUAWEI Y360-U82"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y360-U93",
    "Device": "HWY360-U6572",
    "Model": "Delta Y360-U93"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y360-U93",
    "Device": "HWY360-U6572",
    "Model": "HUAWEI Y360-U93"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y3II",
    "Device": "HWLUA-L6735",
    "Model": "HUAWEI LUA-L01"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y3II",
    "Device": "HWLUA-L6735",
    "Model": "HUAWEI LUA-L02"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y3II",
    "Device": "HWLUA-L6735",
    "Model": "HUAWEI LUA-L21"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y3II",
    "Device": "HWLUA-U6582",
    "Model": "HUAWEI LUA-U02"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y3II",
    "Device": "HWLUA-U6582",
    "Model": "HUAWEI LUA-U22"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y3III",
    "Device": "HWCRO-U6580M",
    "Model": "CRO-U00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y3III",
    "Device": "HWCRO-U6580M",
    "Model": "CRO-U23"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y3III",
    "Device": "HWCRO-U6580M",
    "Model": "HUAWEI CRO-U00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y3III",
    "Device": "HWCRO-U6580M",
    "Model": "HUAWEI CRO-U23"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y5",
    "Device": "HWY560-L",
    "Model": "HUAWEI Y560-L02"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y5",
    "Device": "HWY560-L",
    "Model": "HUAWEI Y560-L23"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y5",
    "Device": "HWY560-U",
    "Model": "HUAWEI Y560-U03"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y5 2017",
    "Device": "HWMYA-L6737",
    "Model": "MYA-AL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y5 2017",
    "Device": "HWMYA-L6737",
    "Model": "MYA-L02"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y5 2017",
    "Device": "HWMYA-L6737",
    "Model": "MYA-L03"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y5 2017",
    "Device": "HWMYA-L6737",
    "Model": "MYA-L13"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y5 2017",
    "Device": "HWMYA-L6737",
    "Model": "MYA-L22"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y5 2017",
    "Device": "HWMYA-L6737",
    "Model": "MYA-L23"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y5 2017",
    "Device": "HWMYA-L6737",
    "Model": "MYA-TL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y5 2017",
    "Device": "HWMYA-U6580",
    "Model": "MYA-U29"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y500-T00",
    "Device": "HWY500-T00",
    "Model": "HUAWEI Y500-T00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y511-T00",
    "Device": "HWY511-T",
    "Model": "HUAWEI Y511-T00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y511-T00",
    "Device": "HWY511-T",
    "Model": "Y511-T00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y511-U00",
    "Device": "HWY511-U",
    "Model": "Y511-U00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y511-U10",
    "Device": "HWY511-U",
    "Model": "HUAWEI Y511-U10"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y511-U251",
    "Device": "HWY511-U",
    "Model": "HUAWEI Y511-U251"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y511-U30",
    "Device": "HWY511-U",
    "Model": "HUAWEI Y511-U30"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y511-U30",
    "Device": "HWY511-U",
    "Model": "VIETTEL V8506"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y516-",
    "Device": "HWY516-T",
    "Model": "HUAWEI Y516-T00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y518-T00",
    "Device": "HWY518-T",
    "Model": "HUAWEI Y518-T00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y520-U03",
    "Device": "HWY520-U",
    "Model": "HUAWEI Y520-U03"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y520-U12",
    "Device": "HWY520-U",
    "Model": "HUAWEI Y520-U12"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y520-U22",
    "Device": "HWY520-U",
    "Model": "HUAWEI Y520-U22"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y520-U33",
    "Device": "HWY520-U",
    "Model": "HUAWEI Y520-U33"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y523-L076",
    "Device": "HWY523",
    "Model": "HUAWEI Y523-L076"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y523-L176",
    "Device": "HWY523",
    "Model": "HUAWEI Y523-L176"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y530",
    "Device": "hwY530-U00",
    "Model": "HUAWEI Y530-U00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y530-U051",
    "Device": "hwY530-U051",
    "Model": "HUAWEI Y530"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y530-U051",
    "Device": "hwY530-U051",
    "Model": "HUAWEI Y530-U051"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y535",
    "Device": "HWY535-C00",
    "Model": "HUAWEI Y535-C00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y535D-C00",
    "Device": "HWY535D-C00",
    "Model": "HUAWEI Y535D-C00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y536-A1",
    "Device": "hwY536A1",
    "Model": "HUAWEI Y536A1"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y540-U01",
    "Device": "HWY540-U",
    "Model": "HUAWEI Y540-U01"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y541-U02",
    "Device": "HWY541-U",
    "Model": "HUAWEI Y541-U02"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y541-U02",
    "Device": "HWY541-U",
    "Model": "Y541-U02"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y545-U05",
    "Device": "hwY545-U05",
    "Model": "Y545-U05"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y550-L01",
    "Device": "hwY550-L01",
    "Model": "HUAWEI Y550-L01"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y550-L02",
    "Device": "hwY550-L02",
    "Model": "HUAWEI Y550-L02"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y550-L02",
    "Device": "hwY550-L02",
    "Model": "Y550-L02"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y550-L03",
    "Device": "hwY550-L03",
    "Model": "HUAWEI Y550"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y550-L03",
    "Device": "hwY550-L03",
    "Model": "HUAWEI Y550-L03"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y550-L03",
    "Device": "hwY550-L03",
    "Model": "Personal Huawei Y550"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y550-L03",
    "Device": "hwY550-L03",
    "Model": "Y550-L03"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y560-CL00",
    "Device": "HWY560-CL",
    "Model": "HUAWEI Y560-CL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y560-L01",
    "Device": "HWY560-L",
    "Model": "HUAWEI Y560-L01"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y560-L03",
    "Device": "HWY560-L",
    "Model": "HUAWEI Y560-L03"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y560-U02",
    "Device": "HWY560-U",
    "Model": "HUAWEI Y560-U02"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y560-U12",
    "Device": "HWY560-U",
    "Model": "HUAWEI Y560-U12"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y560-U23",
    "Device": "HWY560-U",
    "Model": "HUAWEI Y560-U23"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y5II",
    "Device": "HWCUN-L6735",
    "Model": "CUN-L22"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y5II",
    "Device": "HWCUN-L6735",
    "Model": "HUAWEI CUN-L01"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y5II",
    "Device": "HWCUN-L6735",
    "Model": "HUAWEI CUN-L02"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y5II",
    "Device": "HWCUN-L6735",
    "Model": "HUAWEI CUN-L03"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y5II",
    "Device": "HWCUN-L6735",
    "Model": "HUAWEI CUN-L21"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y5II",
    "Device": "HWCUN-L6735",
    "Model": "HUAWEI CUN-L22"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y5II",
    "Device": "HWCUN-L6735",
    "Model": "HUAWEI CUN-L23"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y5II",
    "Device": "HWCUN-L6735",
    "Model": "HUAWEI CUN-L33"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y5II",
    "Device": "HWCUN-U6582",
    "Model": "HUAWEI CUN-U29"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y6",
    "Device": "hwSCC-Q",
    "Model": "HUAWEI SCC-U21"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y6",
    "Device": "hwSCC-Q",
    "Model": "SCC-U21"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y6",
    "Device": "hwSCL-Q",
    "Model": "HUAWEI SCL-L01"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y6",
    "Device": "hwSCL-Q",
    "Model": "HUAWEI SCL-L02"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y6",
    "Device": "hwSCL-Q",
    "Model": "HUAWEI SCL-L03"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y6",
    "Device": "hwSCL-Q",
    "Model": "HUAWEI SCL-L04"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y6",
    "Device": "hwSCL-Q",
    "Model": "HUAWEI SCL-L21"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y6",
    "Device": "hwSCL-Q",
    "Model": "HW-SCL-L32"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y6",
    "Device": "hwSCL-Q",
    "Model": "SCL-L01"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y6",
    "Device": "hwSCLU-Q",
    "Model": "HUAWEI SCL-U23"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y6",
    "Device": "hwSCLU-Q",
    "Model": "HUAWEI SCL-U31"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y6",
    "Device": "hwSCLU-Q",
    "Model": "SCL-U23"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y6 2017",
    "Device": "HWMYA-L6737",
    "Model": "MYA-L41"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y6 Elite",
    "Device": "HWLYO-L6735",
    "Model": "HUAWEI LYO-L02"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y6 Pro",
    "Device": "HWTIT-AL00",
    "Model": "HUAWEI TIT-AL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y6 Pro",
    "Device": "HWTIT-L6735",
    "Model": "HUAWEI TIT-AL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y6 Pro",
    "Device": "HWTIT-L6735",
    "Model": "HUAWEI TIT-CL10"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y6 Pro",
    "Device": "HWTIT-L6735",
    "Model": "HUAWEI TIT-L01"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y6 Pro",
    "Device": "HWTIT-L6735",
    "Model": "HUAWEI TIT-TL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y6 Pro",
    "Device": "HWTIT-L6735",
    "Model": "TIT-AL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y6 Pro",
    "Device": "HWTIT-L6735",
    "Model": "TIT-L01"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y6 Pro",
    "Device": "HWTIT-L8916",
    "Model": "HUAWEI TIT-CL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y6 Pro",
    "Device": "HWTIT-U6582",
    "Model": "HUAWEI TIT-U02"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y6 Ⅱ Compact",
    "Device": "HWLYO-L6735",
    "Model": "HUAWEI LYO-L01"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y600",
    "Device": "HWY600-U",
    "Model": "HUAWEI Y600-U00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y600",
    "Device": "HWY600-U",
    "Model": "HUAWEI Y600-U151"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y600",
    "Device": "HWY600-U",
    "Model": "HUAWEI Y600-U20"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y600-U351",
    "Device": "HWY600-U",
    "Model": "HUAWEI Y600-U351"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y600-U40",
    "Device": "HWY600-U",
    "Model": "HUAWEI Y600-U40"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y600D-C00",
    "Device": "HWY600D-C00",
    "Model": "HUAWEI Y600D-C00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y610",
    "Device": "HWY610-U",
    "Model": "HUAWEI Y610-U00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y618",
    "Device": "HWY618-T",
    "Model": "HUAWEI Y618-T00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y625-U03",
    "Device": "KVY625-U",
    "Model": "Kavak Y625-U03"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y625-U13",
    "Device": "HWY625-U",
    "Model": "HUAWEI Y625-U13"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y625-U21",
    "Device": "HWY625-U",
    "Model": "HUAWEI Y625-U21"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y625-U32",
    "Device": "HWY625-U",
    "Model": "HUAWEI Y625-U32"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y625-U43",
    "Device": "HWY625-U",
    "Model": "HUAWEI Y625-U43"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y625-U51",
    "Device": "HWY625-U",
    "Model": "HUAWEI Y625-U51"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y635-CL00",
    "Device": "hwY635",
    "Model": "HUAWEI Y635-CL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y635-L01",
    "Device": "hwY635",
    "Model": "Y635-L01"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y635-L02",
    "Device": "hwY635",
    "Model": "HUAWEI Y635-L02"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y635-L02",
    "Device": "hwY635",
    "Model": "Y635-L02"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y635-L03",
    "Device": "hwY635",
    "Model": "HUAWEI Y635-L03"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y635-L03",
    "Device": "hwY635",
    "Model": "Y635-L03"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y635-L21",
    "Device": "hwY635",
    "Model": "Y635-L21"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y635-TL00",
    "Device": "hwY635",
    "Model": "HUAWEI Y635-TL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y635-TL00",
    "Device": "hwY635",
    "Model": "Y635-TL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y6II",
    "Device": "HWCAM-H",
    "Model": "CAM-L03"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y6II",
    "Device": "HWCAM-H",
    "Model": "CAM-L21"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y6II",
    "Device": "HWCAM-H",
    "Model": "CAM-L23"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y6II",
    "Device": "HWCAM-H",
    "Model": "CAM-U22"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y6II",
    "Device": "HWCAM-H",
    "Model": "HUAWEI CAM-L03"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y6II",
    "Device": "HWCAM-H",
    "Model": "HUAWEI CAM-L21"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y6II",
    "Device": "HWCAM-H",
    "Model": "HUAWEI CAM-L23"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y6II",
    "Device": "HWCAM-H",
    "Model": "HUAWEI CAM-U22"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y6II",
    "Device": "HWCAM-Q",
    "Model": "CAM-L32"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y6ⅡCompact",
    "Device": "HWLYO-L6735",
    "Model": "HUAWEI LYO-L03"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y7",
    "Device": "HWTRT-Q",
    "Model": "TRT-L21A"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y7",
    "Device": "HWTRT-Q",
    "Model": "TRT-L53"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y7",
    "Device": "HWTRT-Q",
    "Model": "TRT-LX1"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y7",
    "Device": "HWTRT-Q",
    "Model": "TRT-LX2"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y7",
    "Device": "HWTRT-Q",
    "Model": "TRT-LX3"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y7 Prime 2019",
    "Device": "HWDUB-Q",
    "Model": "DUB-LX1"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y7 Pro 2019",
    "Device": "HWDUB-Q",
    "Model": "DUB-AL20"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y9 Prime 2019",
    "Device": "HWSTK-HF",
    "Model": "STK-L21"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y9 Prime 2019",
    "Device": "HWSTK-HF",
    "Model": "STK-L22"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Y9 Prime 2019",
    "Device": "HWSTK-HF",
    "Model": "STK-LX3"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "Youth",
    "Device": "hws7701u",
    "Model": "Orinoquia Gran Roraima S7-702u"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "ascend-5w",
    "Device": "HWH1621-Q",
    "Model": "H1623"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "d-01G",
    "Device": "d-01G",
    "Model": "d-01G"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "d-01H",
    "Device": "d-01H",
    "Model": "d-01H"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "d-02H",
    "Device": "d-02H",
    "Model": "d-02H"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "eH811",
    "Device": "hweH811",
    "Model": "eH811"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "honor 10 Lite",
    "Device": "HWHRY-H",
    "Model": "HRY-LX1"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "honor 10 Lite",
    "Device": "HWHRY-H",
    "Model": "HRY-LX1MEB"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "honor 10 Lite",
    "Device": "HWHRY-H",
    "Model": "HRY-LX2"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "honor 10 Lite",
    "Device": "HWHRY-HF",
    "Model": "HRY-AL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "honor 5X",
    "Device": "HNKIW-Q",
    "Model": "KIW-L22"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "honor 5X",
    "Device": "HNKIW-Q",
    "Model": "KIW-L23"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "honor 5X",
    "Device": "HNKIW-Q",
    "Model": "KIW-L24"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "honor 6A Pro",
    "Device": "HWDLI-Q",
    "Model": "DLI-L42"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "honor 6C",
    "Device": "HWDIG-L8940",
    "Model": "DIG-L21HN"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "honor 6C Pro",
    "Device": "HWJMM",
    "Model": "JMM-L22"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "honor 6x",
    "Device": "HWBLN-H",
    "Model": "BLN-L21"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "honor 6x",
    "Device": "HWBLN-H",
    "Model": "BLN-L22"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "honor 8C",
    "Device": "HWBKK-Q",
    "Model": "BKK-AL10"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "honor 8C",
    "Device": "HWBKK-Q",
    "Model": "BKK-L21"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "honor 8C",
    "Device": "HWBKK-Q",
    "Model": "BKK-L22"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "honor 8C",
    "Device": "HWBKK-Q",
    "Model": "BKK-LX2"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "huawei nova 2",
    "Device": "HWPIC",
    "Model": "HWV31"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "hw204HW",
    "Device": "hw204HW",
    "Model": "204HW"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "m881",
    "Device": "hwm881",
    "Model": "HUAWEI M881"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "nova",
    "Device": "HWCAN",
    "Model": "HUAWEI CAN-AL10"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "nova",
    "Device": "HWCAN",
    "Model": "HUAWEI CAN-L01"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "nova",
    "Device": "HWCAN",
    "Model": "HUAWEI CAN-L02"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "nova",
    "Device": "HWCAN",
    "Model": "HUAWEI CAN-L03"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "nova",
    "Device": "HWCAN",
    "Model": "HUAWEI CAN-L11"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "nova",
    "Device": "HWCAN",
    "Model": "HUAWEI CAN-L12"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "nova",
    "Device": "HWCAN",
    "Model": "HUAWEI CAN-L13"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "nova",
    "Device": "HWCAN",
    "Model": "HUAWEI CAZ-AL10"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "nova",
    "Device": "HWCAZ",
    "Model": "HUAWEI CAZ-AL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "nova",
    "Device": "HWCAZ",
    "Model": "HUAWEI CAZ-AL10"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "nova",
    "Device": "HWCAZ",
    "Model": "HUAWEI CAZ-TL10"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "nova",
    "Device": "HWCAZ",
    "Model": "HUAWEI CAZ-TL20"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "nova 2",
    "Device": "HWPIC",
    "Model": "PIC-AL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "nova 2",
    "Device": "HWPIC",
    "Model": "PIC-TL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "nova 2 Plus",
    "Device": "HWBAC",
    "Model": "BAC-AL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "nova 2 Plus",
    "Device": "HWBAC",
    "Model": "BAC-L01"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "nova 2 Plus",
    "Device": "HWBAC",
    "Model": "BAC-L03"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "nova 2 Plus",
    "Device": "HWBAC",
    "Model": "BAC-L23"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "nova 2 Plus",
    "Device": "HWBAC",
    "Model": "BAC-TL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "nova 2i",
    "Device": "HWRNE",
    "Model": "RNE-L02"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "nova 2i",
    "Device": "HWRNE",
    "Model": "RNE-L22"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "nova 2s",
    "Device": "HWHWI",
    "Model": "HWI-AL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "nova 2s",
    "Device": "HWHWI",
    "Model": "HWI-TL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "nova 3",
    "Device": "HWPAR",
    "Model": "PAR-AL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "nova 3",
    "Device": "HWPAR",
    "Model": "PAR-L21"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "nova 3",
    "Device": "HWPAR",
    "Model": "PAR-L29"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "nova 3",
    "Device": "HWPAR",
    "Model": "PAR-LX1"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "nova 3",
    "Device": "HWPAR",
    "Model": "PAR-LX1M"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "nova 3",
    "Device": "HWPAR",
    "Model": "PAR-LX9"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "nova 3",
    "Device": "HWPAR",
    "Model": "PAR-TL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "nova 3",
    "Device": "HWPAR",
    "Model": "PAR-TL20"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "nova 3e",
    "Device": "HWANE",
    "Model": "ANE-AL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "nova 3e",
    "Device": "HWANE",
    "Model": "ANE-TL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "nova 3i",
    "Device": "HWINE",
    "Model": "INE-AL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "nova 3i",
    "Device": "HWINE",
    "Model": "INE-LX1"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "nova 3i",
    "Device": "HWINE",
    "Model": "INE-LX1r"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "nova 3i",
    "Device": "HWINE",
    "Model": "INE-LX2"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "nova 3i",
    "Device": "HWINE",
    "Model": "INE-TL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "nova 4",
    "Device": "HWVCE",
    "Model": "VCE-AL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "nova 4",
    "Device": "HWVCE",
    "Model": "VCE-L22"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "nova 4",
    "Device": "HWVCE",
    "Model": "VCE-TL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "nova 4e",
    "Device": "HWMAR",
    "Model": "MAR-AL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "nova 4e",
    "Device": "HWMAR",
    "Model": "MAR-TL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "nova lite",
    "Device": "HWPRA-H",
    "Model": "PRA-LX2"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "nova lite",
    "Device": "HWPRA-H",
    "Model": "PRA-LX3"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "nova plus",
    "Device": "HWMLA",
    "Model": "HUAWEI MLA-L01"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "nova plus",
    "Device": "HWMLA",
    "Model": "HUAWEI MLA-L02"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "nova plus",
    "Device": "HWMLA",
    "Model": "HUAWEI MLA-L03"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "nova plus",
    "Device": "HWMLA",
    "Model": "HUAWEI MLA-L11"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "nova plus",
    "Device": "HWMLA",
    "Model": "HUAWEI MLA-L12"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "nova plus",
    "Device": "HWMLA",
    "Model": "HUAWEI MLA-L13"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "nova plus",
    "Device": "HWMLA",
    "Model": "MLA-L01"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "nova plus",
    "Device": "HWMLA",
    "Model": "MLA-L02"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "nova plus",
    "Device": "HWMLA",
    "Model": "MLA-L03"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "nova plus",
    "Device": "HWMLA",
    "Model": "MLA-L11"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "nova plus",
    "Device": "HWMLA",
    "Model": "MLA-L12"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "nova plus",
    "Device": "HWMLA",
    "Model": "MLA-L13"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "nova 青春版本",
    "Device": "HWWAS-H",
    "Model": "WAS-AL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "nova 青春版本",
    "Device": "HWWAS-H",
    "Model": "WAS-TL10"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "t1_8p0",
    "Device": "hws8701",
    "Model": "MediaPad T1 8.0"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "t1_8p0",
    "Device": "hws8701",
    "Model": "S8-701u"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "t1_8p0",
    "Device": "hws8701",
    "Model": "S8-701w"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "t1_8p0lte",
    "Device": "hwt1821l",
    "Model": "HUAWEI MediaPad T1 8.0 4G"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "t1_8p0lte",
    "Device": "hwt1821l",
    "Model": "Honor T1 8.0"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "t1_8p0lte",
    "Device": "hwt1821l",
    "Model": "MediaPad T1 8.0 Pro"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "t1_8p0lte",
    "Device": "hwt1821l",
    "Model": "S8-821w"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "t1_8p0lte",
    "Device": "hwt1821l",
    "Model": "T1-821w"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "t1_8p0lte",
    "Device": "hwt1821l",
    "Model": "T1-823L"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "华为G9青春版",
    "Device": "HWVNS-H",
    "Model": "HUAWEI VNS-DL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "华为G9青春版",
    "Device": "HWVNS-H",
    "Model": "HUAWEI VNS-TL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "华为平板 C5",
    "Device": "HWBZT",
    "Model": "BZT-AL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "华为平板 C5",
    "Device": "HWBZT",
    "Model": "BZT-AL10"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "华为平板 C5",
    "Device": "HWBZT",
    "Model": "BZT-W09"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "华为平板 C5",
    "Device": "HWHDL",
    "Model": "BZW-AL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "华为平板 C5",
    "Device": "HWHDL",
    "Model": "BZW-AL10"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "华为平板 C5",
    "Device": "HWMON-Q",
    "Model": "MON-AL19"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "华为平板 C5",
    "Device": "HWMON-Q",
    "Model": "MON-AL19B"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "华为平板 C5",
    "Device": "HWMON-Q",
    "Model": "MON-W19"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "华为平板 M5 青春版",
    "Device": "HWBAH2",
    "Model": "BAH2-AL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "华为平板 M5 青春版",
    "Device": "HWBAH2",
    "Model": "BAH2-AL10"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "华为平板 M5 青春版",
    "Device": "HWBAH2",
    "Model": "BAH2-W09"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "华为平板M5青春版",
    "Device": "HWJDN2",
    "Model": "JDN2-AL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "华为平板M5青春版",
    "Device": "HWJDN2",
    "Model": "JDN2-W09"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "华为平板T3 8行业专享版",
    "Device": "HWBZK-Q",
    "Model": "BZK-L00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "华为平板T3 8行业专享版",
    "Device": "HWBZK-Q",
    "Model": "BZK-W00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "华为揽阅M2青春版7.0",
    "Device": "hwple703l",
    "Model": "PLE-701L"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "华为揽阅M2青春版7.0",
    "Device": "hwple703l",
    "Model": "PLE-703L"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "华为畅享 8e 青春",
    "Device": "HWDRA-M",
    "Model": "DRA-AL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "华为畅享 8e 青春",
    "Device": "HWDRA-M",
    "Model": "DRA-TL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "华为畅享 9S",
    "Device": "HWPOT-HF",
    "Model": "POT-AL00a"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "华为畅享 9S",
    "Device": "HWPOT-HF",
    "Model": "POT-TL00a"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "华为畅享 9e",
    "Device": "HWMRD-M",
    "Model": "MRD-AL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "华为畅享 9e",
    "Device": "HWMRD-M",
    "Model": "MRD-TL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "华为畅享 MAX",
    "Device": "HWARS-Q",
    "Model": "ARS-AL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "华为畅享 MAX",
    "Device": "HWARS-Q",
    "Model": "ARS-TL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "华为畅享10 Plus",
    "Device": "HWSTK-HF",
    "Model": "STK-AL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "华为畅享10 Plus",
    "Device": "HWSTK-HF",
    "Model": "STK-TL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "华为畅享6",
    "Device": "HWNCE-L6750",
    "Model": "NCE-AL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "华为畅享6",
    "Device": "HWNCE-L6750",
    "Model": "NCE-AL10"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "华为畅享6",
    "Device": "HWNCE-L6750",
    "Model": "NCE-TL10"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "华为畅享6S",
    "Device": "HWDIG-L8940",
    "Model": "DIG-AL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "华为畅享6S",
    "Device": "HWDIG-L8940",
    "Model": "DIG-TL10"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "华为畅享7",
    "Device": "HWSLA-Q",
    "Model": "SLA-AL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "华为畅享7",
    "Device": "HWSLA-Q",
    "Model": "SLA-TL10"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "华为畅享7S",
    "Device": "HWFIG-H",
    "Model": "FIG-AL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "华为畅享7S",
    "Device": "HWFIG-H",
    "Model": "FIG-AL10"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "华为畅享7S",
    "Device": "HWFIG-H",
    "Model": "FIG-TL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "华为畅享7S",
    "Device": "HWFIG-H",
    "Model": "FIG-TL10"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "华为畅享8",
    "Device": "HWLDN-Q",
    "Model": "LDN-AL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "华为畅享8",
    "Device": "HWLDN-Q",
    "Model": "LDN-AL10"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "华为畅享8",
    "Device": "HWLDN-Q",
    "Model": "LDN-AL20"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "华为畅享8",
    "Device": "HWLDN-Q",
    "Model": "LDN-TL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "华为畅享8",
    "Device": "HWLDN-Q",
    "Model": "LDN-TL10"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "华为畅享8",
    "Device": "HWLDN-Q",
    "Model": "LDN-TL20"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "华为畅享8 Plus",
    "Device": "HWFLA-H",
    "Model": "FLA-AL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "华为畅享8 Plus",
    "Device": "HWFLA-H",
    "Model": "FLA-AL10"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "华为畅享8 Plus",
    "Device": "HWFLA-H",
    "Model": "FLA-AL20"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "华为畅享8 Plus",
    "Device": "HWFLA-H",
    "Model": "FLA-TL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "华为畅享8 Plus",
    "Device": "HWFLA-H",
    "Model": "FLA-TL10"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "华为畅享8e",
    "Device": "HWATU-QC",
    "Model": "ATU-AL10"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "华为畅享8e",
    "Device": "HWATU-QC",
    "Model": "ATU-TL10"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "华为畅享9",
    "Device": "HWDUB-Q",
    "Model": "DUB-AL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "华为畅享9",
    "Device": "HWDUB-Q",
    "Model": "DUB-AL00a"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "华为畅享9",
    "Device": "HWDUB-Q",
    "Model": "DUB-AL20"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "华为畅享9",
    "Device": "HWDUB-Q",
    "Model": "DUB-TL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "华为畅享9",
    "Device": "HWDUB-Q",
    "Model": "DUB-TL00a"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "华为畅享9 Plus",
    "Device": "HWJKM-H",
    "Model": "JKM-AL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "华为畅享9 Plus",
    "Device": "HWJKM-H",
    "Model": "JKM-TL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "华为畅享9 Plus",
    "Device": "HWJKM-HM",
    "Model": "JKM-AL00a"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "华为畅享9 Plus",
    "Device": "HWJKM-HM",
    "Model": "JKM-AL00b"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "华为畅享平板",
    "Device": "HWAGS2",
    "Model": "AGS2-AL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "荣耀 8X",
    "Device": "HWJSN-H",
    "Model": "JSN-AL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "荣耀 8X",
    "Device": "HWJSN-H",
    "Model": "JSN-TL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "荣耀 8X",
    "Device": "HWJSN-HM",
    "Model": "JSN-AL00a"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "荣耀 V9 play",
    "Device": "HWJMM-Q",
    "Model": "JMM-AL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "荣耀 V9 play",
    "Device": "HWJMM-Q",
    "Model": "JMM-AL10"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "荣耀 V9 play",
    "Device": "HWJMM-Q",
    "Model": "JMM-TL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "荣耀 V9 play",
    "Device": "HWJMM-Q",
    "Model": "JMM-TL10"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "荣耀10青春版",
    "Device": "HWHRY-H",
    "Model": "HRY-TL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "荣耀20i",
    "Device": "HWHRY-H",
    "Model": "HRY-AL00T"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "荣耀20i",
    "Device": "HWHRY-HF",
    "Model": "HRY-TL00T"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "荣耀4A",
    "Device": "hwSCL-Q",
    "Model": "SCL-AL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "荣耀5X",
    "Device": "HNKIW-Q",
    "Model": "KIW-AL10"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "荣耀5X",
    "Device": "HNKIW-Q",
    "Model": "KIW-AL20"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "荣耀5X",
    "Device": "HNKIW-Q",
    "Model": "KIW-CL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "荣耀5X",
    "Device": "HNKIW-Q",
    "Model": "KIW-TL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "荣耀5X",
    "Device": "HNKIW-Q",
    "Model": "KIW-UL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "荣耀8X Max",
    "Device": "HWARE-Q",
    "Model": "ARE-AL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "荣耀8X Max",
    "Device": "HWARE-Q",
    "Model": "ARE-TL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "荣耀8X Max",
    "Device": "HWARE-QC",
    "Model": "ARE-AL10"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "荣耀8青春版",
    "Device": "HWPRA-H",
    "Model": "PRA-AL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "荣耀8青春版",
    "Device": "HWPRA-H",
    "Model": "PRA-AL00X"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "荣耀8青春版",
    "Device": "HWPRA-H",
    "Model": "PRA-TL10"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "荣耀9X",
    "Device": "HWHLK-H",
    "Model": "HLK-AL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "荣耀9i",
    "Device": "HWLLD-H2",
    "Model": "LLD-AL20"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "荣耀9i",
    "Device": "HWLLD-H2",
    "Model": "LLD-AL30"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "荣耀9青春版",
    "Device": "HWLLD-H",
    "Model": "LLD-AL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "荣耀9青春版",
    "Device": "HWLLD-H",
    "Model": "LLD-AL10"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "荣耀9青春版",
    "Device": "HWLLD-H",
    "Model": "LLD-TL10"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "荣耀Note8",
    "Device": "hwedison",
    "Model": "EDI-AL10"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "荣耀Note8",
    "Device": "hwedison",
    "Model": "EDI-DL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "荣耀Waterplay 8英寸",
    "Device": "HWHDL",
    "Model": "HDL-AL09"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "荣耀Waterplay 8英寸",
    "Device": "HWHDL",
    "Model": "HDL-W09"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "荣耀平板5",
    "Device": "HWAGS2",
    "Model": "AGS2-AL00HN"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "荣耀平板5",
    "Device": "HWAGS2",
    "Model": "AGS2-W09HN"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "荣耀平板5",
    "Device": "HWJDN2",
    "Model": "JDN2-AL00HN"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "荣耀平板5",
    "Device": "HWJDN2",
    "Model": "JDN2-W09HN"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "荣耀畅享7 Plus",
    "Device": "HWTRT-Q",
    "Model": "TRT-AL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "荣耀畅享7 Plus",
    "Device": "HWTRT-Q",
    "Model": "TRT-AL00A"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "荣耀畅享7 Plus",
    "Device": "HWTRT-Q",
    "Model": "TRT-TL10"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "荣耀畅享7 Plus",
    "Device": "HWTRT-Q",
    "Model": "TRT-TL10A"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "荣耀畅玩 6X",
    "Device": "HWBLN-H",
    "Model": "BLN-AL10"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "荣耀畅玩 6X",
    "Device": "HWBLN-H",
    "Model": "BLN-AL20"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "荣耀畅玩 6X",
    "Device": "HWBLN-H",
    "Model": "BLN-AL30"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "荣耀畅玩 6X",
    "Device": "HWBLN-H",
    "Model": "BLN-AL40"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "荣耀畅玩 6X",
    "Device": "HWBLN-H",
    "Model": "BLN-TL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "荣耀畅玩 6X",
    "Device": "HWBLN-H",
    "Model": "BLN-TL10"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "荣耀畅玩4C",
    "Device": "hwCHM-H",
    "Model": "CHM-TL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "荣耀畅玩4C",
    "Device": "hwCHM-H",
    "Model": "CHM-TL00H"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "荣耀畅玩4C",
    "Device": "hwCHM-H",
    "Model": "CHM-UL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "荣耀畅玩4X",
    "Device": "hnCHE-H",
    "Model": "CHE-TL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "荣耀畅玩4X",
    "Device": "hnCHE-H",
    "Model": "CHE-TL00H"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "荣耀畅玩5A",
    "Device": "HNCAM-H",
    "Model": "CAM-TL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "荣耀畅玩5A",
    "Device": "HNCAM-H",
    "Model": "CAM-TL00H"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "荣耀畅玩5A",
    "Device": "HNCAM-H",
    "Model": "CAM-UL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "荣耀畅玩5A",
    "Device": "HNCAM-Q",
    "Model": "CAM-AL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "荣耀畅玩5A",
    "Device": "HNCAM-Q",
    "Model": "CAM-CL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "荣耀畅玩5A",
    "Device": "HWCAM-H",
    "Model": "CAM-TL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "荣耀畅玩5A",
    "Device": "HWCAM-H",
    "Model": "CAM-TL00H"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "荣耀畅玩5A",
    "Device": "HWCAM-H",
    "Model": "CAM-UL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "荣耀畅玩5A",
    "Device": "HWCAM-Q",
    "Model": "CAM-AL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "荣耀畅玩5C",
    "Device": "HNNEM-H",
    "Model": "NEM-AL10"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "荣耀畅玩5C",
    "Device": "HNNEM-H",
    "Model": "NEM-TL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "荣耀畅玩5C",
    "Device": "HNNEM-H",
    "Model": "NEM-TL00H"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "荣耀畅玩5C",
    "Device": "HNNEM-H",
    "Model": "NEM-UL10"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "荣耀畅玩6",
    "Device": "HWMYA-L6737",
    "Model": "MYA-AL10"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "荣耀畅玩6",
    "Device": "HWMYA-L6737",
    "Model": "MYA-TL10"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "荣耀畅玩6A",
    "Device": "HWDLI-Q",
    "Model": "DLI-AL10"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "荣耀畅玩7",
    "Device": "HWDUA-M",
    "Model": "DUA-AL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "荣耀畅玩7",
    "Device": "HWDUA-M",
    "Model": "DUA-TL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "荣耀畅玩7X",
    "Device": "HWBND-H",
    "Model": "BND-AL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "荣耀畅玩7X",
    "Device": "HWBND-H",
    "Model": "BND-AL10"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "荣耀畅玩7X",
    "Device": "HWBND-H",
    "Model": "BND-TL10"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "荣耀畅玩8",
    "Device": "HWKSA-M",
    "Model": "KSA-AL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "荣耀畅玩8",
    "Device": "HWKSA-M",
    "Model": "KSA-TL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "荣耀畅玩8A",
    "Device": "HWJAT-M",
    "Model": "JAT-AL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "荣耀畅玩8A",
    "Device": "HWJAT-M",
    "Model": "JAT-TL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "荣耀畅玩8C",
    "Device": "HWBKK-Q",
    "Model": "BKK-AL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "荣耀畅玩8C",
    "Device": "HWBKK-Q",
    "Model": "BKK-AL10"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "荣耀畅玩8C",
    "Device": "HWBKK-Q",
    "Model": "BKK-TL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "荣耀畅玩平板2 9.6",
    "Device": "HWBZA-Q",
    "Model": "BZA-L00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "荣耀畅玩平板2 9.6",
    "Device": "HWBZA-Q",
    "Model": "BZA-W00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "麦芒 8",
    "Device": "HWPOT-H",
    "Model": "POT-AL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "麦芒 8",
    "Device": "HWPOT-HF",
    "Model": "POT-AL10"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "麦芒4",
    "Device": "hwRIO-AL00",
    "Model": "HUAWEI RIO-AL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "麦芒5",
    "Device": "HWMLA",
    "Model": "HUAWEI MLA-AL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "麦芒5",
    "Device": "HWMLA",
    "Model": "HUAWEI MLA-AL10"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "麦芒5",
    "Device": "HWMLA",
    "Model": "MLA-AL00"
  },
  {
    "Retail Branding": "Huawei",
    "Marketing Name": "麦芒5",
    "Device": "HWMLA",
    "Model": "MLA-AL10"
  },
  {
    "Retail Branding": "Hublot",
    "Marketing Name": "Big Bang e Gen 3",
    "Device": "turbot",
    "Model": "BIG BANG e Gen 3"
  },
  {
    "Retail Branding": "Hublot",
    "Marketing Name": "Hublot Big Bang e",
    "Device": "halibut",
    "Model": "Big Bang e"
  },
  {
    "Retail Branding": "Huion",
    "Marketing Name": "KT1101",
    "Device": "KT1101",
    "Model": "Kamvas Slate 11"
  },
  {
    "Retail Branding": "Huion",
    "Marketing Name": "KT1101_EEA",
    "Device": "KT1101",
    "Model": "Kamvas Slate 11"
  },
  {
    "Retail Branding": "Huion",
    "Marketing Name": "KT1201",
    "Device": "KT1201",
    "Model": "Kamvas Slate 13"
  },
  {
    "Retail Branding": "Huion",
    "Marketing Name": "KT1201_EEA",
    "Device": "KT1201",
    "Model": "Kamvas Slate 13"
  },
  {
    "Retail Branding": "Huion",
    "Marketing Name": "KamvasSlate10",
    "Device": "KamvasSlate10",
    "Model": "AT13"
  },
  {
    "Retail Branding": "Huion",
    "Marketing Name": "KamvasSlate10",
    "Device": "KamvasSlate10",
    "Model": "KamvasSlate10"
  },
  {
    "Retail Branding": "Huion",
    "Marketing Name": "KamvasSlate10_EEA",
    "Device": "KamvasSlate10_EEA",
    "Model": "KamvasSlate10_EEA"
  },
  {
    "Retail Branding": "HumanWare",
    "Marketing Name": "Connect12V21",
    "Device": "Connect12V21",
    "Model": "Connect12V21"
  },
  {
    "Retail Branding": "HumanWare",
    "Marketing Name": "Connect12V21_EEA",
    "Device": "Connect12V21_EEA",
    "Model": "Connect12V21_EEA"
  },
  {
    "Retail Branding": "Human_Acadaemy",
    "Marketing Name": "HA-007",
    "Device": "HA-007",
    "Model": "HA-007"
  },
  {
    "Retail Branding": "Human_Academy",
    "Marketing Name": "HA-008",
    "Device": "HA-008",
    "Model": "HA-008"
  },
  {
    "Retail Branding": "HumaxDigital",
    "Marketing Name": "Descodificador Orange TV",
    "Device": "b604tnw",
    "Model": "Descodificador Orange TV"
  },
  {
    "Retail Branding": "HumaxDigital",
    "Marketing Name": "FVP-4KGTR",
    "Device": "fvp4kgtr",
    "Model": "FVP-4KGTR"
  },
  {
    "Retail Branding": "HumaxDigital",
    "Marketing Name": "H5_DLIVE",
    "Device": "h5mini",
    "Model": "H5_DLIVE"
  },
  {
    "Retail Branding": "HumaxDigital",
    "Marketing Name": "TMAU400",
    "Device": "tmau400",
    "Model": "tmau400"
  },
  {
    "Retail Branding": "HumaxDigital",
    "Marketing Name": "VISION W1",
    "Device": "vision",
    "Model": "VISION W1"
  },
  {
    "Retail Branding": "Hurricane",
    "Marketing Name": "Ace",
    "Device": "Ace",
    "Model": "Ace"
  },
  {
    "Retail Branding": "Hurricane",
    "Marketing Name": "Air",
    "Device": "Air",
    "Model": "Air"
  },
  {
    "Retail Branding": "Hurricane",
    "Marketing Name": "Archer",
    "Device": "Archer",
    "Model": "Archer"
  },
  {
    "Retail Branding": "Hurricane",
    "Marketing Name": "Atlas",
    "Device": "Atlas",
    "Model": "Atlas"
  },
  {
    "Retail Branding": "Hurricane",
    "Marketing Name": "Beam",
    "Device": "Beam",
    "Model": "Beam"
  },
  {
    "Retail Branding": "Hurricane",
    "Marketing Name": "Blast",
    "Device": "Blast",
    "Model": "Blast"
  },
  {
    "Retail Branding": "Hurricane",
    "Marketing Name": "Blaze",
    "Device": "Blaze",
    "Model": "Blaze"
  },
  {
    "Retail Branding": "Hurricane",
    "Marketing Name": "Bolt",
    "Device": "Bolt",
    "Model": "Hurricane_Bolt"
  },
  {
    "Retail Branding": "Hurricane",
    "Marketing Name": "Boost",
    "Device": "Boost",
    "Model": "Boost"
  },
  {
    "Retail Branding": "Hurricane",
    "Marketing Name": "Charge",
    "Device": "Charge",
    "Model": "Charge"
  },
  {
    "Retail Branding": "Hurricane",
    "Marketing Name": "Cobra",
    "Device": "Cobra",
    "Model": "Cobra"
  },
  {
    "Retail Branding": "Hurricane",
    "Marketing Name": "Curve",
    "Device": "Curve",
    "Model": "Curve"
  },
  {
    "Retail Branding": "Hurricane",
    "Marketing Name": "DZIRE",
    "Device": "DZIRE",
    "Model": "DZIRE"
  },
  {
    "Retail Branding": "Hurricane",
    "Marketing Name": "Edge",
    "Device": "Edge",
    "Model": "Edge"
  },
  {
    "Retail Branding": "Hurricane",
    "Marketing Name": "Epic",
    "Device": "Epic",
    "Model": "Epic"
  },
  {
    "Retail Branding": "Hurricane",
    "Marketing Name": "Excite",
    "Device": "Excite",
    "Model": "Excite"
  },
  {
    "Retail Branding": "Hurricane",
    "Marketing Name": "Fire",
    "Device": "Fire",
    "Model": "Fire"
  },
  {
    "Retail Branding": "Hurricane",
    "Marketing Name": "Flame",
    "Device": "Flame",
    "Model": "Flame"
  },
  {
    "Retail Branding": "Hurricane",
    "Marketing Name": "Flame_Plus",
    "Device": "Flame_Plus",
    "Model": "Flame_Plus"
  },
  {
    "Retail Branding": "Hurricane",
    "Marketing Name": "Flex",
    "Device": "Flex",
    "Model": "Flex"
  },
  {
    "Retail Branding": "Hurricane",
    "Marketing Name": "Flint",
    "Device": "Flint",
    "Model": "Flint"
  },
  {
    "Retail Branding": "Hurricane",
    "Marketing Name": "Fuel",
    "Device": "Fuel",
    "Model": "Fuel"
  },
  {
    "Retail Branding": "Hurricane",
    "Marketing Name": "Fuse",
    "Device": "Fuse",
    "Model": "Fuse"
  },
  {
    "Retail Branding": "Hurricane",
    "Marketing Name": "Galaxy",
    "Device": "Galaxy",
    "Model": "Galaxy"
  },
  {
    "Retail Branding": "Hurricane",
    "Marketing Name": "Giga",
    "Device": "HURRICANE_GIGA",
    "Model": "HURRICANE_GIGA"
  },
  {
    "Retail Branding": "Hurricane",
    "Marketing Name": "Glaze",
    "Device": "Glaze",
    "Model": "Glaze"
  },
  {
    "Retail Branding": "Hurricane",
    "Marketing Name": "Hurricane_IGNITE",
    "Device": "Hurricane_IGNITE",
    "Model": "Hurricane_IGNITE"
  },
  {
    "Retail Branding": "Hurricane",
    "Marketing Name": "INFINITY",
    "Device": "INFINITY",
    "Model": "INFINITY"
  },
  {
    "Retail Branding": "Hurricane",
    "Marketing Name": "Icon",
    "Device": "Icon",
    "Model": "Icon"
  },
  {
    "Retail Branding": "Hurricane",
    "Marketing Name": "Iris",
    "Device": "Iris",
    "Model": "Iris"
  },
  {
    "Retail Branding": "Hurricane",
    "Marketing Name": "Iris_Plus",
    "Device": "Iris_Plus",
    "Model": "Iris_Plus"
  },
  {
    "Retail Branding": "Hurricane",
    "Marketing Name": "LINK",
    "Device": "LINK",
    "Model": "LINK"
  },
  {
    "Retail Branding": "Hurricane",
    "Marketing Name": "Lynx",
    "Device": "Lynx",
    "Model": "Lynx"
  },
  {
    "Retail Branding": "Hurricane",
    "Marketing Name": "Onyx",
    "Device": "Hurricane_Onyx",
    "Model": "Onyx"
  },
  {
    "Retail Branding": "Hurricane",
    "Marketing Name": "PULSE",
    "Device": "pulse",
    "Model": "pulse"
  },
  {
    "Retail Branding": "Hurricane",
    "Marketing Name": "Panther",
    "Device": "Panther",
    "Model": "Panther"
  },
  {
    "Retail Branding": "Hurricane",
    "Marketing Name": "Ridge",
    "Device": "Ridge",
    "Model": "Ridge"
  },
  {
    "Retail Branding": "Hurricane",
    "Marketing Name": "Ridge Plus",
    "Device": "Ridge_Plus",
    "Model": "Ridge Plus"
  },
  {
    "Retail Branding": "Hurricane",
    "Marketing Name": "Rush",
    "Device": "Hurricane",
    "Model": "Rush"
  },
  {
    "Retail Branding": "Hurricane",
    "Marketing Name": "Rush Plus",
    "Device": "Rush_Plus",
    "Model": "Rush Plus"
  },
  {
    "Retail Branding": "Hurricane",
    "Marketing Name": "S43",
    "Device": "S43",
    "Model": "S43"
  },
  {
    "Retail Branding": "Hurricane",
    "Marketing Name": "SAGE",
    "Device": "SAGE",
    "Model": "SAGE"
  },
  {
    "Retail Branding": "Hurricane",
    "Marketing Name": "STELLA",
    "Device": "STELLA",
    "Model": "STELLA"
  },
  {
    "Retail Branding": "Hurricane",
    "Marketing Name": "SWIRL",
    "Device": "Swirl",
    "Model": "Swirl"
  },
  {
    "Retail Branding": "Hurricane",
    "Marketing Name": "Slam",
    "Device": "Slam",
    "Model": "Slam"
  },
  {
    "Retail Branding": "Hurricane",
    "Marketing Name": "Splash",
    "Device": "Splash",
    "Model": "Splash"
  },
  {
    "Retail Branding": "Hurricane",
    "Marketing Name": "Sprint",
    "Device": "Sprint",
    "Model": "Sprint"
  },
  {
    "Retail Branding": "Hurricane",
    "Marketing Name": "Storm",
    "Device": "Storm",
    "Model": "Storm"
  },
  {
    "Retail Branding": "Hurricane",
    "Marketing Name": "Surge",
    "Device": "Surge",
    "Model": "Surge"
  },
  {
    "Retail Branding": "Hurricane",
    "Marketing Name": "Swift",
    "Device": "Swift",
    "Model": "Swift"
  },
  {
    "Retail Branding": "Hurricane",
    "Marketing Name": "T10",
    "Device": "T10",
    "Model": "T10"
  },
  {
    "Retail Branding": "Hurricane",
    "Marketing Name": "Touch",
    "Device": "Touch",
    "Model": "Touch"
  },
  {
    "Retail Branding": "Hurricane",
    "Marketing Name": "Ultra",
    "Device": "Ultra",
    "Model": "Ultra"
  },
  {
    "Retail Branding": "Hurricane",
    "Marketing Name": "Vega",
    "Device": "Vega",
    "Model": "Vega"
  },
  {
    "Retail Branding": "Hurricane",
    "Marketing Name": "Vegas",
    "Device": "Vegas",
    "Model": "Vegas"
  },
  {
    "Retail Branding": "Hurricane",
    "Marketing Name": "Vibe",
    "Device": "Vibe",
    "Model": "VIBE"
  },
  {
    "Retail Branding": "Hurricane",
    "Marketing Name": "Volt",
    "Device": "Hurricane",
    "Model": "Volt"
  },
  {
    "Retail Branding": "Hurricane",
    "Marketing Name": "Volt_Plus",
    "Device": "Volt_Plus",
    "Model": "Volt_Plus"
  },
  {
    "Retail Branding": "Hurricane",
    "Marketing Name": "Volt_Plus",
    "Device": "VortexPlus",
    "Model": "VortexPlus"
  },
  {
    "Retail Branding": "Hurricane",
    "Marketing Name": "Vortex",
    "Device": "C9",
    "Model": "HURRICANE VORTEX"
  },
  {
    "Retail Branding": "Hurricane",
    "Marketing Name": "Vulcan",
    "Device": "Vulcan",
    "Model": "Vulcan"
  },
  {
    "Retail Branding": "Hurricane",
    "Marketing Name": "Wave",
    "Device": "Hurricane",
    "Model": "Wave"
  },
  {
    "Retail Branding": "Hurricane",
    "Marketing Name": "Wave_Plus",
    "Device": "Wave_Plus",
    "Model": "Wave_Plus"
  },
  {
    "Retail Branding": "Huskee",
    "Marketing Name": "HELIOS",
    "Device": "HELIOS",
    "Model": "HELIOS"
  },
  {
    "Retail Branding": "Huskee",
    "Marketing Name": "HELIOS_Plus",
    "Device": "HELIOS_Plus",
    "Model": "HELIOS_Plus"
  },
  {
    "Retail Branding": "Huskee",
    "Marketing Name": "ST-810",
    "Device": "ST-810",
    "Model": "ST-810"
  },
  {
    "Retail Branding": "Huskee",
    "Marketing Name": "VULKANO",
    "Device": "VULKANO",
    "Model": "VULKANO"
  },
  {
    "Retail Branding": "Huskee",
    "Marketing Name": "VULKANO_Plus",
    "Device": "VULKANO_Plus",
    "Model": "VULKANO_Plus"
  },
  {
    "Retail Branding": "Hyatta",
    "Marketing Name": "Model 4",
    "Device": "Model_4",
    "Model": "Model 4"
  },
  {
    "Retail Branding": "Hyatta",
    "Marketing Name": "Model 4",
    "Device": "Model_4EEA",
    "Model": "Model 4"
  },
  {
    "Retail Branding": "Hyatta",
    "Marketing Name": "Model 4",
    "Device": "Model_4TR",
    "Model": "Model 4"
  },
  {
    "Retail Branding": "Hyatta",
    "Marketing Name": "Model 6s",
    "Device": "Model_6s",
    "Model": "Model 6s"
  },
  {
    "Retail Branding": "Hyatta",
    "Marketing Name": "Model_10",
    "Device": "Model_10",
    "Model": "Model 10"
  },
  {
    "Retail Branding": "Hyatta",
    "Marketing Name": "Model_5",
    "Device": "Model_5",
    "Model": "Model 5"
  },
  {
    "Retail Branding": "Hyatta",
    "Marketing Name": "Model_6s_RU",
    "Device": "Model_6s",
    "Model": "Model 6s"
  },
  {
    "Retail Branding": "Hyatta",
    "Marketing Name": "Model_6s_TR",
    "Device": "Model_6s",
    "Model": "Model 6s"
  },
  {
    "Retail Branding": "Hyatta",
    "Marketing Name": "Model_7_EEA",
    "Device": "Model_7",
    "Model": "Model_7"
  },
  {
    "Retail Branding": "Hyjoy",
    "Marketing Name": "KT1006",
    "Device": "KT1006",
    "Model": "KT1006"
  },
  {
    "Retail Branding": "Hyjoy",
    "Marketing Name": "P11",
    "Device": "P11",
    "Model": "P11"
  },
  {
    "Retail Branding": "Hyjoy",
    "Marketing Name": "P11_EEA",
    "Device": "P11_EEA",
    "Model": "P11_EEA"
  },
  {
    "Retail Branding": "Hykker",
    "Marketing Name": "Smart Box Android TV",
    "Device": "DV8038",
    "Model": "Smart Box Android TV"
  },
  {
    "Retail Branding": "Hyper",
    "Marketing Name": "Hyper Board",
    "Device": "Hyper",
    "Model": "Hyper"
  },
  {
    "Retail Branding": "Hytel",
    "Marketing Name": "HOT MINI",
    "Device": "HOT_MINI",
    "Model": "HOT MINI"
  },
  {
    "Retail Branding": "Hytel",
    "Marketing Name": "M15A",
    "Device": "M15A",
    "Model": "M15A"
  },
  {
    "Retail Branding": "Hytel",
    "Marketing Name": "M30A",
    "Device": "M30A",
    "Model": "M30A"
  },
  {
    "Retail Branding": "Hytera",
    "Marketing Name": "PDC550",
    "Device": "PDC550",
    "Model": "PDC550"
  },
  {
    "Retail Branding": "Hytera",
    "Marketing Name": "PDC680",
    "Device": "PDC680",
    "Model": "PDC680"
  },
  {
    "Retail Branding": "Hytera",
    "Marketing Name": "PDC760",
    "Device": "PDC760",
    "Model": "PDC760"
  },
  {
    "Retail Branding": "Hytera",
    "Marketing Name": "PDM680",
    "Device": "PDM680",
    "Model": "PDM680"
  },
  {
    "Retail Branding": "Hytera",
    "Marketing Name": "PNC460",
    "Device": "PNC460",
    "Model": "PNC460"
  },
  {
    "Retail Branding": "Hytera",
    "Marketing Name": "PNC460_TR",
    "Device": "PNC460",
    "Model": "PNC460"
  },
  {
    "Retail Branding": "Hytera",
    "Marketing Name": "PNC550",
    "Device": "PNC550",
    "Model": "PNC550"
  },
  {
    "Retail Branding": "Hytera",
    "Marketing Name": "PNC550_P_TU",
    "Device": "PNC550",
    "Model": "PNC550"
  },
  {
    "Retail Branding": "Hytera",
    "Marketing Name": "PNC560",
    "Device": "PNC560",
    "Model": "PNC560"
  },
  {
    "Retail Branding": "Hytera",
    "Marketing Name": "PNC660",
    "Device": "PNC660",
    "Model": "PNC660"
  },
  {
    "Retail Branding": "Hytera",
    "Marketing Name": "PTC680",
    "Device": "PTC680",
    "Model": "PTC680"
  },
  {
    "Retail Branding": "Hytera",
    "Marketing Name": "PTC760",
    "Device": "PTC760",
    "Model": "PTC760"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "10LA2",
    "Device": "10LA2",
    "Model": "10LA2"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "10LB4",
    "Device": "10LB4",
    "Model": "10LB4"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "10LC1-3",
    "Device": "10LC1-3",
    "Model": "10LC1-3"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "4K Smart TV",
    "Device": "gangbyeon",
    "Model": "HYUNDAI 4K AI Smart TV"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "4K Smart TV",
    "Device": "gangbyeon",
    "Model": "HYUNDAI 4K Smart TV"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "7LB1",
    "Device": "7LB1",
    "Model": "7LB1"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "8LAB1",
    "Device": "8LAB1",
    "Model": "8LAB1"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "8LAB1-3",
    "Device": "8LAB1-3",
    "Model": "8LAB1-3"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "A25563L",
    "Device": "A25563L",
    "Model": "A25563L"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "A26062L",
    "Device": "A26062L",
    "Model": "A26062L"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "A26062k",
    "Device": "A26062K",
    "Model": "A26062K"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "Android TV",
    "Device": "R1",
    "Model": "ATV R1"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "Android TV",
    "Device": "R2",
    "Model": "ATV R2"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "Android TV",
    "Device": "ikebukuro",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "Android TV",
    "Device": "redwood",
    "Model": "AI PONT NA"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "Android TV",
    "Device": "redwood",
    "Model": "AI PONT SA"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "Android TV",
    "Device": "sindorim",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "BOLIVIA",
    "Device": "marina",
    "Model": "HYUNDAI SMART 4K TV"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "BOLIVIA",
    "Device": "nagata",
    "Model": "HYUNDAI SMART 2K TV"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "BS5002",
    "Device": "redwood",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "Blade_C5",
    "Device": "Blade_C5",
    "Model": "Blade_C5"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "Blade_C6",
    "Device": "Blade_C6",
    "Model": "Blade_C6"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "Blade_C7",
    "Device": "Blade_C7",
    "Model": "Blade_C7"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "CAR AVN SYSTEM",
    "Device": "koecn",
    "Model": "TCC893X_EVM"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "Charisboard_Xai",
    "Device": "IFPD",
    "Model": "Charis_Series"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "E435 Plus",
    "Device": "E435_Plus",
    "Model": "E435 Plus"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "E456GO",
    "Device": "E465GO",
    "Model": "E465GO"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "E475",
    "Device": "E475",
    "Model": "E475"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "E485",
    "Device": "E485",
    "Model": "E485"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "E503F",
    "Device": "E503F",
    "Model": "E503F"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "E506",
    "Device": "E506",
    "Model": "E506"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "E553",
    "Device": "E553",
    "Model": "E553"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "E554",
    "Device": "E554",
    "Model": "E554"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "E601F",
    "Device": "E601F",
    "Model": "E601F"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "E602",
    "Device": "E602",
    "Model": "E602"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "E603",
    "Device": "E603",
    "Model": "E603"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "EU、UK、AP",
    "Device": "martin",
    "Model": "HYUNDAI ANDROID TV"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "Ecuador",
    "Device": "nippori",
    "Model": "HYUNDAI 2K Android TV"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "Eternity A24",
    "Device": "A25024L",
    "Model": "A25024L"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "Eternity G22",
    "Device": "G25022K",
    "Model": "G25022K"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "Eternity G23",
    "Device": "G25523K",
    "Model": "G25523K"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "Eternity G24",
    "Device": "G25524K",
    "Model": "G25524K"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "Eternity G27",
    "Device": "G24027K",
    "Model": "G24027K"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "Eternity H68",
    "Device": "H25568K",
    "Model": "Eternity_H68"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "Eternity W42",
    "Device": "W25042L",
    "Model": "W25042L"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "Eternity W44",
    "Device": "W25544L",
    "Model": "W25544L"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "Eternity_G25",
    "Device": "Eternity_G25",
    "Model": "Eternity_G25"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "Eternity_H66",
    "Device": "H25566K",
    "Model": "Eternity_H66"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "Eternity_P7",
    "Device": "HT4P7128LB",
    "Model": "Eternity_P7"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "Eternity_P7",
    "Device": "HT4P764LB",
    "Model": "Eternity_P7"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "G9S",
    "Device": "ikebukuro",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "H-LED32ES5008",
    "Device": "ikebukuro",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "H-LED32ES5108",
    "Device": "ikebukuro",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "H-LED50EU7008",
    "Device": "samseong",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "HATV-58AA100",
    "Device": "samseong",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "HDT-7433H",
    "Device": "HDT-7433H",
    "Model": "HDT-7433H"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "HDT-7433X",
    "Device": "HDT-7433X",
    "Model": "HDT-7433X"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "HT0702W08",
    "Device": "HT0702W08",
    "Model": "HT0702W08"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "HT0703W08",
    "Device": "HT0703W08",
    "Model": "HT0703W08"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "HT0705W08/Koral_7W4",
    "Device": "HT0705W08",
    "Model": "Koral 7W4"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "HT0802W16/Koral_8W2",
    "Device": "HT0802W16",
    "Model": "Koral_8W2"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "HT10LA1MSGNA02",
    "Device": "HT10LA1MSGNA02",
    "Model": "10LA1"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "HT10LA2MSGNA01",
    "Device": "HT10LA2MSGNA01",
    "Model": "HT10LA2MSGNA01"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "HT10LB2MBKLTM",
    "Device": "HT10LB2MBKLTM",
    "Model": "10LB2"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "HT10LB2MBKLTM02",
    "Device": "HT10LB2MBKLTM02",
    "Model": "HT10LB2MBKLTM02"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "HT10LB3MBKLTM",
    "Device": "HT10LB3MBKLTM",
    "Model": "HT10LB3MBKLTM"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "HT10LB3MBKWW",
    "Device": "HT10LB3MBKWW",
    "Model": "HT10LB3MBKWW"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "HT10LB4MSGNA01",
    "Device": "HT10LB4MSGNA01",
    "Model": "10LB4"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "HT10LC1MBKLTM",
    "Device": "HT10LC1MBKLTM",
    "Model": "HT10LC1MBKLTM"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "HT10LC1MBKLTM01",
    "Device": "HT10LC1MBKLTM01",
    "Model": "HT10LC1MBKLTM01"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "HT10LC1MBKLTM_K1",
    "Device": "HT10LC1MBKLTM_K1",
    "Model": "HT10LC1MBKLTM"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "HT10LC1MBKWW01",
    "Device": "HT10LC1MBKWW01",
    "Model": "HT10LC1MBKWW01"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "HT10LC2MBKLTM",
    "Device": "HT10LC2MBKLTM",
    "Model": "HT10LC2MBKLTM"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "HT10LC2MBKWW01",
    "Device": "HT10LC2MBKWW01",
    "Model": "HT10LC2MBKWW01"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "HT10WB2MSG01",
    "Device": "HT10WB2MSG01",
    "Model": "10WB2"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "HT10WB3MSG01",
    "Device": "HT10WB3MSG01",
    "Model": "10WB3"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "HT7GB1MBK_",
    "Device": "HT7GB1MBK_",
    "Model": "7GB1"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "HT7WB1RBK",
    "Device": "HT7WB1RBK",
    "Model": "HT7WB1RBK"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "HT7WC1PBK",
    "Device": "HT7WC1PBK",
    "Model": "HT7WC1PBK"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "HT8LA1RBKNA01",
    "Device": "HT8LA1RBKNA01",
    "Model": "8LA1"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "HT8LAB1PBKLTM",
    "Device": "HT8LAB1PBKLTM",
    "Model": "HT8LAB1PBKLTM"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "HT8LAB1PBKWW01",
    "Device": "HT8LAB1PBKWW01",
    "Model": "HT8LAB1PBKWW01"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "HT8LAB1PBKWW01",
    "Device": "HT8LAB1PBKWW01",
    "Model": "HT8LAB1RBKWW01"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "HT8WB1RBK01",
    "Device": "HT8WB1RBK01",
    "Model": "HT8WB1RBK01"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "HT8WB1RBK02",
    "Device": "HT8WB1RBK02",
    "Model": "HT8WB1RBK02"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "HT8WB1RBK02A",
    "Device": "HT8WB1RBK02A",
    "Model": "HT8WB1RBK02A"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "HT8WB1RBK02_12",
    "Device": "HT8WB1RBK02_12",
    "Model": "8WB1"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "HT8WB1RBK03",
    "Device": "HT8WB1RBK03",
    "Model": "HT8WB1RBK03"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "HY1-5085",
    "Device": "HY1_5085",
    "Model": "HY1-5085"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "HYLED5015A4KM",
    "Device": "samseong",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "HYLine_Plus",
    "Device": "57PB1",
    "Model": "57PB1"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "HYLine_Pro",
    "Device": "65PA2",
    "Model": "65PA2"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "HYUNDAI",
    "Device": "bruno",
    "Model": "HYUNDAI2KAndroidTV"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "HYUNDAI",
    "Device": "elliniko",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "HYUNDAI",
    "Device": "elliniko",
    "Model": "EcoTV1 Plus"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "HYUNDAI",
    "Device": "hongkong",
    "Model": "4K SMART ATSC TV"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "HYUNDAI",
    "Device": "hongkong",
    "Model": "4K SMART COL TV"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "HYUNDAI",
    "Device": "hongkong",
    "Model": "4K SMART ISDB TV"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "HYUNDAI",
    "Device": "hongkong",
    "Model": "HYUNDAI 4K SMART TV"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "HYUNDAI",
    "Device": "khardi",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "HYUNDAI",
    "Device": "lavender",
    "Model": "4K SMART COL TV"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "HYUNDAI",
    "Device": "lavender",
    "Model": "4K SMART ISDB TV"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "HYUNDAI",
    "Device": "lavender",
    "Model": "HYUNDAI 4K SMART TV"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "HYUNDAI",
    "Device": "mountbaker",
    "Model": "2K SMART TV"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "HYUNDAI",
    "Device": "mountbaker",
    "Model": "HYUNDAI 2K SMART TV"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "HYUNDAI",
    "Device": "stanford",
    "Model": "2K SMART TV"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "HYUNDAI",
    "Device": "templeton",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "HYUNDAI 2K Android TV",
    "Device": "lasalle",
    "Model": "HYUNDAI 2K Android TV"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "HYUNDAI 2K Android TV-A",
    "Device": "lasalle",
    "Model": "HYUNDAI 2K Android TV-A"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "HYUNDAI 2K Google TV",
    "Device": "capitolhill",
    "Model": "HYUNDAI  2K Google TV"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "HYUNDAI 2K Google TV-E",
    "Device": "capitolhill",
    "Model": "HYUNDAI 2K Google TV-E"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "HYUNDAI 4K Android TV",
    "Device": "kenton",
    "Model": "HYUNDAI 4K Android TV"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "HYUNDAI 4K Google TV",
    "Device": "keoneae",
    "Model": "HYUNDAI 4K Google TV"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "HYUNDAI SMART 2K TV",
    "Device": "nagata",
    "Model": "Hyundai 2K Smart TV"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "HYUNDAI SMART TV",
    "Device": "SW6H",
    "Model": "HYUNDAI SMART TV"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "HYUNDAI SMART TV",
    "Device": "sunnyvale",
    "Model": "HYUNDAI SMART TV"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "HY_BDL163G_001",
    "Device": "HY_BDL163G_001_EEA",
    "Model": "HY-BDL163G-001"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "HyLine_Plus",
    "Device": "HY65PB1401NA",
    "Model": "65PB1"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "HyLine_Plus_2",
    "Device": "HY65PB1401NA",
    "Model": "65PB1"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "HyLine_Pro",
    "Device": "HT10LA3MSGNA01",
    "Model": "10LA3"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "HyLine_Pro",
    "Device": "HY65PA1402NA",
    "Model": "65PA1"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "HyLine_Pro_X",
    "Device": "HY65PA1401NA",
    "Model": "65PA1"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "HyTab_Plus_10LC2",
    "Device": "HyTab_Plus_10LC2",
    "Model": "HyTab Plus 10LC2"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "HyTab_Plus_7WA1",
    "Device": "7WA1",
    "Model": "7WA1"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "Hytab Plus 8LB1",
    "Device": "HT8LB1PBK01",
    "Model": "8LB1"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "Hytab Plus 8LB1",
    "Device": "HT8LB1PBK01",
    "Model": "8LB1_TMO"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "Hytab_Plus",
    "Device": "HT10WB4MSG01",
    "Model": "10WB4"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "Hytab_Plus",
    "Device": "HT8WB3RBK01",
    "Model": "8WB3"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "Hytab_Pro",
    "Device": "10LC1",
    "Model": "10LC1"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "Hyundai",
    "Device": "bangbae",
    "Model": "Hyundai 4K Android TV"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "Hyundai",
    "Device": "komagome",
    "Model": "Hyundai 2K Android TV"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "Hyundai",
    "Device": "stanford",
    "Model": "COL 2K SMART TV"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "Hyundai",
    "Device": "stanford",
    "Model": "SA 2K SMART TV"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "Hyundai 2K TV",
    "Device": "shinjuku",
    "Model": "Hyundai 2K TV"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "Hyundai 4K Smart TV",
    "Device": "marina",
    "Model": "Hyundai 4K Smart TV"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "Hyundai Eternity G50L",
    "Device": "HT1G50L",
    "Model": "Hyundai_Eternity_G50L"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "Hyundai HyTab Pro 10LC1",
    "Device": "HyTab_Pro_10LC1",
    "Model": "HyTab Pro 10LC1"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "Hyundai Koral 10W",
    "Device": "HT1002W16",
    "Model": "HT1002W16"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "Hyundai Koral 10X",
    "Device": "HT1003X16",
    "Model": "HT1003X16"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "Hyundai Koral 7M3X",
    "Device": "HT0703K",
    "Model": "HT0703K16"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "Hyundai Koral_7M4",
    "Device": "HT0704K08",
    "Model": "HT0704K08"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "Hyundai Koral_7XL",
    "Device": "HT0701L16",
    "Model": "HT0701L16"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "Hyundai Smartboard",
    "Device": "HDIT_IFPD",
    "Model": "HDP"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "Hyundai TV",
    "Device": "SW4H",
    "Model": "Hyundai TV"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "Hyundai android TV",
    "Device": "hanyang",
    "Model": "HYUNDAI 4K Android TV"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "Hyundai_Eternity_G50",
    "Device": "HT1G50K",
    "Model": "Hyundai_Eternity_G50"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "Hyundai_Eternity_G50",
    "Device": "HT2G50KBK",
    "Model": "Hyundai_Eternity_G50"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "Hyundai_Eternity_G50W",
    "Device": "HT1G50KFBK",
    "Model": "Hyundai_Eternity_G50W"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "Hyundai_Eternity_G57",
    "Device": "HT2G57L",
    "Model": "Hyundai_Eternity_G57L"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "Hyundai_Eternity_G60",
    "Device": "HT3G60L",
    "Model": "Hyundai_Eternity_G60"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "Hyundai_Home",
    "Device": "Hyundai_Home",
    "Model": "HTSH10W216"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "Intelliboard_Xai",
    "Device": "IFPD",
    "Model": "HD_series"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "Italy",
    "Device": "tamachi",
    "Model": "HYUNDAI 2K Android TV"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "Italy",
    "Device": "yeongdeungpo",
    "Model": "HYUNDAI 4K Android TV"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "Italy, Città del Vaticano, San Marino, European countries",
    "Device": "guandu",
    "Model": "HYUNDAI ANDROID TV"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "K131",
    "Device": "E505",
    "Model": "E505"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "Koral",
    "Device": "Koral_10WB1",
    "Model": "10WB1"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "Koral",
    "Device": "Koral_7WB1",
    "Model": "7WB1"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "Koral",
    "Device": "Koral_7WC1",
    "Model": "7WC1"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "Koral",
    "Device": "Koral_7WD1",
    "Model": "7WD1"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "Koral",
    "Device": "Koral_8WC1",
    "Model": "8WC1"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "Koral 10W2",
    "Device": "HT1003W16",
    "Model": "HT1003W16"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "Koral 10XL",
    "Device": "HT1004L16",
    "Model": "HT1004L16"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "Koral_10LB1",
    "Device": "10LB1",
    "Model": "10LB1"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "Koral_10X2",
    "Device": "HT1004X16",
    "Model": "Koral_10X2"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "Koral_10X3",
    "Device": "Koral_10X3",
    "Model": "HT1002W32"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "Koral_10XL",
    "Device": "Koral_10XL",
    "Model": "HT1004LI16"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "Koral_10XL_Plus",
    "Device": "Koral_10XL_Plus",
    "Model": "HT1002LI32"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "Koral_7LC1",
    "Device": "7LC1",
    "Model": "7LC1"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "Koral_7W4X",
    "Device": "Koral_7W4X",
    "Model": "HT0701W16"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "Koral_7XL",
    "Device": "Koral_7XL",
    "Model": "HT0701LI16"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "L465",
    "Device": "L465",
    "Model": "L465"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "L500U",
    "Device": "L500U",
    "Model": "L500U"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "L501",
    "Device": "L501",
    "Model": "L501"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "L502",
    "Device": "Hyundai_L502",
    "Model": "L502"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "L503F",
    "Device": "L503F",
    "Model": "L503F"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "L503F Plus",
    "Device": "L503F_Plus",
    "Model": "L503F Plus"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "L506",
    "Device": "L506",
    "Model": "L506"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "L553",
    "Device": "L553",
    "Model": "L553"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "L575",
    "Device": "L575",
    "Model": "L575"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "L601F",
    "Device": "L601F",
    "Model": "L601F"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "L604",
    "Device": "L604",
    "Model": "L604"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "L610",
    "Device": "L610",
    "Model": "L610"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "L622",
    "Device": "L622",
    "Model": "L622"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "L651",
    "Device": "L651",
    "Model": "L651"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "L681",
    "Device": "L681",
    "Model": "L681"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "R3",
    "Device": "R3",
    "Model": "R3"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "R4",
    "Device": "R4",
    "Model": "R4"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "Seoul 9",
    "Device": "Seoul_9",
    "Model": "Seoul 9"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "Seoul X",
    "Device": "Seoul_X",
    "Model": "Seoul X"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "Seoul_S8",
    "Device": "Seoul_S8",
    "Model": "Seoul S8"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "Smart TV",
    "Device": "alimos",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "Smart TV",
    "Device": "dangni",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "Smart TV",
    "Device": "dangni",
    "Model": "HYUNDAI Google TV"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "Smart TV",
    "Device": "kanda",
    "Model": "HYUNDAI 2K Smart TV"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "Smart TV",
    "Device": "longshan",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "Smart TV",
    "Device": "osaka",
    "Model": "AI PONT CO"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "Smart TV",
    "Device": "osaka",
    "Model": "AI PONT NA"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "Smart TV",
    "Device": "osaka",
    "Model": "AI PONT SA"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "Smart TV",
    "Device": "osaki",
    "Model": "HYUNDAI 2K AI Smart TV"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "Smart TV",
    "Device": "redwood",
    "Model": "AI PONT CO"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "UHD Android TV",
    "Device": "sindorim",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "Ultra Active",
    "Device": "Ultra_Active",
    "Model": "Ultra Active"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "Ultra Charm",
    "Device": "Ultra_Charm",
    "Model": "Ultra Charm"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "Ultra Dream",
    "Device": "Ultra_Dream",
    "Model": "Ultra Dream"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "Ultra Energy Lite",
    "Device": "Ultra_Energy_Lite",
    "Model": "Ultra Energy Lite"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "Ultra Energy Plus",
    "Device": "Ultra_Energy_Plus",
    "Model": "Ultra Energy Plus"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "Ultra Latitude",
    "Device": "Ultra_Latitude",
    "Model": "Ultra Latitude"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "Ultra Live II",
    "Device": "HYUNDAI_Ultra_Live_II",
    "Model": "Ultra Live II"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "Ultra Shadow",
    "Device": "Ultra_Shadow",
    "Model": "Ultra Shadow"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "Ultra Shine",
    "Device": "Ultra_Shine",
    "Model": "Ultra Shine"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "Ultra Storm",
    "Device": "Ultra_Storm",
    "Model": "Ultra Storm"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "Ultra Style",
    "Device": "Ultra_Style",
    "Model": "Ultra Style"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "Ultra Sync",
    "Device": "Ultra_Sync",
    "Model": "Ultra Sync"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "Ultra Trend",
    "Device": "Ultra_Trend",
    "Model": "Ultra Trend"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "Ultra Vision",
    "Device": "Ultra_Vision",
    "Model": "Ultra Vision"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "Ultra Vision Plus",
    "Device": "Ultra_Vision_Plus",
    "Model": "Ultra_Vision_Plus"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "e501",
    "Device": "e501",
    "Model": "e501"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "e502",
    "Device": "e502",
    "Model": "e502"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "e551",
    "Device": "e551",
    "Model": "e551"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "e551 Lite",
    "Device": "e551_Lite",
    "Model": "e551 Lite"
  },
  {
    "Retail Branding": "Hyundai",
    "Marketing Name": "hyundai",
    "Device": "stanford",
    "Model": "SMART TV"
  },
  {
    "Retail Branding": "Hyve",
    "Marketing Name": "Buzz BU01",
    "Device": "buzz_bu01",
    "Model": "BU01"
  },
  {
    "Retail Branding": "Hyve",
    "Marketing Name": "Pryme01",
    "Device": "pryme01",
    "Model": "Pryme 01"
  },
  {
    "Retail Branding": "Hyve",
    "Marketing Name": "Storm ST01",
    "Device": "storm_st01",
    "Model": "ST01"
  },
  {
    "Retail Branding": "I-Bridge",
    "Marketing Name": "South Korea",
    "Device": "IBT01H",
    "Model": "IBT01H"
  },
  {
    "Retail Branding": "I-Bridge",
    "Marketing Name": "South Korea",
    "Device": "IBT01H_BDS",
    "Model": "IBT01H"
  },
  {
    "Retail Branding": "I-Bridge",
    "Marketing Name": "South Korea",
    "Device": "IBT02H",
    "Model": "IBT02H"
  },
  {
    "Retail Branding": "I-Scream",
    "Marketing Name": "E1012T",
    "Device": "ET1012T",
    "Model": "ET1012T"
  },
  {
    "Retail Branding": "I-Scream",
    "Marketing Name": "i-Screamedu",
    "Device": "HL106",
    "Model": "HL106"
  },
  {
    "Retail Branding": "I3-TECHNOLOGIES",
    "Marketing Name": "GOOGLE EDLA CERTIFIED SLOT-IN OPS",
    "Device": "i3COMPUTER-A01-OPS",
    "Model": "i3COMPUTER-A01-OPS"
  },
  {
    "Retail Branding": "I3-TECHNOLOGIES",
    "Marketing Name": "i3CONNECT_ELM-2",
    "Device": "RK3576",
    "Model": "ELM-2"
  },
  {
    "Retail Branding": "I3-TECHNOLOGIES",
    "Marketing Name": "i3SIXTY-3",
    "Device": "i3SIXTY-3",
    "Model": "i3SIXTY-3"
  },
  {
    "Retail Branding": "I3-TECHNOLOGIES",
    "Marketing Name": "i3TOUCH-X3",
    "Device": "i3TOUCH-X3",
    "Model": "i3TOUCH-X3"
  },
  {
    "Retail Branding": "IACTIVE",
    "Marketing Name": "lactive_IA75",
    "Device": "lactive_IA75",
    "Model": "IACTIVE"
  },
  {
    "Retail Branding": "IAIWAI",
    "Marketing Name": "A103",
    "Device": "A103",
    "Model": "A103"
  },
  {
    "Retail Branding": "ICE_Board",
    "Marketing Name": "ICE_Board_X_2",
    "Device": "ICE_Board_X",
    "Model": "ICE_Board_X"
  },
  {
    "Retail Branding": "ICL-KME CS OJSC",
    "Marketing Name": "TR10CD1",
    "Device": "TR10CD1_7",
    "Model": "TR10CD1"
  },
  {
    "Retail Branding": "ICOM",
    "Marketing Name": "CTGED01",
    "Device": "CTGED01",
    "Model": "CTGED01"
  },
  {
    "Retail Branding": "ICOM",
    "Marketing Name": "CTGED02",
    "Device": "CTGED02",
    "Model": "CTGED02"
  },
  {
    "Retail Branding": "ICOM",
    "Marketing Name": "CTGED03",
    "Device": "CTGED03",
    "Model": "CTGED03"
  },
  {
    "Retail Branding": "IDC",
    "Marketing Name": "EVO_G4",
    "Device": "EVO_G4",
    "Model": "EVO G4"
  },
  {
    "Retail Branding": "IDEA",
    "Marketing Name": "i4901",
    "Device": "i4901",
    "Model": "i4901"
  },
  {
    "Retail Branding": "IDEMIA",
    "Marketing Name": "ID Screen",
    "Device": "ID_Screen",
    "Model": "MPH-MB003A"
  },
  {
    "Retail Branding": "IDEMIA",
    "Marketing Name": "ID Screen 60",
    "Device": "ID_Screen_60",
    "Model": "MPH-MB004A"
  },
  {
    "Retail Branding": "IDONDRDO",
    "Marketing Name": "Discovery-X1",
    "Device": "Discovery-X1",
    "Model": "Discovery-X1"
  },
  {
    "Retail Branding": "IDspire",
    "Marketing Name": "IRA_Biometric",
    "Device": "TPSeries_1",
    "Model": "IRA_Biometric"
  },
  {
    "Retail Branding": "IDspire",
    "Marketing Name": "TPSeries_1",
    "Device": "TPSeries_1",
    "Model": "TPSeries_1"
  },
  {
    "Retail Branding": "IIIF150",
    "Marketing Name": "Action 15",
    "Device": "Action_15",
    "Model": "Action 15"
  },
  {
    "Retail Branding": "IIIF150",
    "Marketing Name": "Action A5Pro",
    "Device": "Action_A5Pro",
    "Model": "Action A5Pro"
  },
  {
    "Retail Branding": "IIIF150",
    "Marketing Name": "Air1",
    "Device": "Air1",
    "Model": "Air1"
  },
  {
    "Retail Branding": "IIIF150",
    "Marketing Name": "Air1 Pro",
    "Device": "Air1_Pro",
    "Model": "Air1 Pro"
  },
  {
    "Retail Branding": "IIIF150",
    "Marketing Name": "Air1 Ultra",
    "Device": "Air1_Ultra",
    "Model": "Air1 Ultra"
  },
  {
    "Retail Branding": "IIIF150",
    "Marketing Name": "Air1 Ultra+",
    "Device": "Air1_Ultra_Pro",
    "Model": "Air1 Ultra Pro"
  },
  {
    "Retail Branding": "IIIF150",
    "Marketing Name": "Air2_Pro_EEA",
    "Device": "Air2_Pro",
    "Model": "Air2 Pro"
  },
  {
    "Retail Branding": "IIIF150",
    "Marketing Name": "Air3S",
    "Device": "Air3S",
    "Model": "Air3S"
  },
  {
    "Retail Branding": "IIIF150",
    "Marketing Name": "Air3_EEA",
    "Device": "Air3",
    "Model": "Air3"
  },
  {
    "Retail Branding": "IIIF150",
    "Marketing Name": "B1",
    "Device": "B1",
    "Model": "B1"
  },
  {
    "Retail Branding": "IIIF150",
    "Marketing Name": "B1 Pro",
    "Device": "B1_Pro",
    "Model": "B1 Pro"
  },
  {
    "Retail Branding": "IIIF150",
    "Marketing Name": "B2",
    "Device": "B2",
    "Model": "B2"
  },
  {
    "Retail Branding": "IIIF150",
    "Marketing Name": "B2 Pro",
    "Device": "B2_Pro",
    "Model": "B2 Pro"
  },
  {
    "Retail Branding": "IIIF150",
    "Marketing Name": "B2 Ultra",
    "Device": "B2_Ultra",
    "Model": "B2 Ultra"
  },
  {
    "Retail Branding": "IIIF150",
    "Marketing Name": "B2 Ultra",
    "Device": "B2_Ultra",
    "Model": "B2 Ultra 2026"
  },
  {
    "Retail Branding": "IIIF150",
    "Marketing Name": "B3C",
    "Device": "B3C",
    "Model": "B3C"
  },
  {
    "Retail Branding": "IIIF150",
    "Marketing Name": "B3_EEA",
    "Device": "B3",
    "Model": "B3"
  },
  {
    "Retail Branding": "IIIF150",
    "Marketing Name": "Raptor LTD",
    "Device": "Raptor",
    "Model": "Raptor"
  },
  {
    "Retail Branding": "IKALL",
    "Marketing Name": "I KALL Z13",
    "Device": "I_KALL_Z13",
    "Model": "Z13"
  },
  {
    "Retail Branding": "IKALL",
    "Marketing Name": "IKALL",
    "Device": "IKALL",
    "Model": "IKALL"
  },
  {
    "Retail Branding": "IKALL",
    "Marketing Name": "K510",
    "Device": "K510",
    "Model": "K510"
  },
  {
    "Retail Branding": "IKALL",
    "Marketing Name": "N4",
    "Device": "N4",
    "Model": "N4"
  },
  {
    "Retail Branding": "IKALL",
    "Marketing Name": "N5",
    "Device": "N5",
    "Model": "N5"
  },
  {
    "Retail Branding": "IKALL",
    "Marketing Name": "S3",
    "Device": "S3",
    "Model": "S3"
  },
  {
    "Retail Branding": "IKALL",
    "Marketing Name": "Z19",
    "Device": "Z19",
    "Model": "Z19"
  },
  {
    "Retail Branding": "IKALL",
    "Marketing Name": "Z20",
    "Device": "Z20",
    "Model": "Z20"
  },
  {
    "Retail Branding": "IMAGO",
    "Marketing Name": "AIOS",
    "Device": "AIOS",
    "Model": "PRIME"
  },
  {
    "Retail Branding": "IMARFLEX",
    "Marketing Name": "IMARFLEX 2K Android TV",
    "Device": "lasalle",
    "Model": "IMARFLEX 2K Android TV"
  },
  {
    "Retail Branding": "IMARFLEX",
    "Marketing Name": "IMARFLEX 4K Android TV",
    "Device": "kenton",
    "Model": "IMARFLEX 4K Android TV"
  },
  {
    "Retail Branding": "IMARFLEX",
    "Marketing Name": "imarflex 2K Google TV",
    "Device": "capitolhill",
    "Model": "imarflex 2K Google TV"
  },
  {
    "Retail Branding": "IMARFLEX",
    "Marketing Name": "imarflex 4K Google TV",
    "Device": "keoneae",
    "Model": "imarflex 4K Google TV"
  },
  {
    "Retail Branding": "IMARFLEX",
    "Marketing Name": "imarflex 4K Google TV-A",
    "Device": "keoneae",
    "Model": "imarflex 4K Google TV-A"
  },
  {
    "Retail Branding": "IMO(In My Opinion)",
    "Marketing Name": "IMO Q",
    "Device": "IMO_Q",
    "Model": "IMO Q"
  },
  {
    "Retail Branding": "IMO(In My Opinion)",
    "Marketing Name": "IMO Q2 Plus",
    "Device": "IMO_Q2_Plus",
    "Model": "IMO Q2 Plus"
  },
  {
    "Retail Branding": "IMO(In My Opinion)",
    "Marketing Name": "IMO Q2 Pro",
    "Device": "IMO_Q2_Pro",
    "Model": "IMO Q2 Pro"
  },
  {
    "Retail Branding": "IMO(In My Opinion)",
    "Marketing Name": "IMO Q3 Plus",
    "Device": "IMO_Q3_Plus",
    "Model": "IMO Q3 Plus"
  },
  {
    "Retail Branding": "IMO(In My Opinion)",
    "Marketing Name": "IMO Q4 Pro",
    "Device": "IMO_Q4_Pro",
    "Model": "IMO Q4 Pro"
  },
  {
    "Retail Branding": "IMO(In My Opinion)",
    "Marketing Name": "IMO Q5",
    "Device": "IMO_Q5",
    "Model": "IMO Q5"
  },
  {
    "Retail Branding": "IMO(In My Opinion)",
    "Marketing Name": "IMO S2",
    "Device": "S2",
    "Model": "IMO S2"
  },
  {
    "Retail Branding": "IMOTOR",
    "Marketing Name": "TP Serials",
    "Device": "auto_rk_t60",
    "Model": "IMTOS Pro"
  },
  {
    "Retail Branding": "IMPECCA",
    "Marketing Name": "4K Smart TV",
    "Device": "gangbyeon",
    "Model": "IMPECCA 4K Smart TV"
  },
  {
    "Retail Branding": "IMPECCA",
    "Marketing Name": "Smart TV",
    "Device": "kanda",
    "Model": "IMPECCA 2K Smart TV"
  },
  {
    "Retail Branding": "IMPEX",
    "Marketing Name": "GRANDE UHD TV",
    "Device": "OD0M_EA_T32",
    "Model": "GRANDE UHD TV"
  },
  {
    "Retail Branding": "IMPEX",
    "Marketing Name": "Grande FHD TV",
    "Device": "takao",
    "Model": "GRANDE FHD TV"
  },
  {
    "Retail Branding": "IMPEX",
    "Marketing Name": "IMPEX evoQ 2K",
    "Device": "nagata",
    "Model": "IMPEX evoQ 2K"
  },
  {
    "Retail Branding": "IMPEX",
    "Marketing Name": "IMPEX evoQ 4K",
    "Device": "marina",
    "Model": "IMPEX evoQ 4K"
  },
  {
    "Retail Branding": "IMPEX",
    "Marketing Name": "Saudi Arabia",
    "Device": "sepolia",
    "Model": "Impex Smart TV"
  },
  {
    "Retail Branding": "IMPEX",
    "Marketing Name": "Smart TV",
    "Device": "alimos",
    "Model": "IMPEX evoQ 4K"
  },
  {
    "Retail Branding": "IMPEX",
    "Marketing Name": "Smart TV",
    "Device": "dangni",
    "Model": "IMPEX evoQ 2K"
  },
  {
    "Retail Branding": "IMPEX",
    "Marketing Name": "Smart TV",
    "Device": "osaka",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "IMTO",
    "Marketing Name": "GKL089",
    "Device": "GKL089",
    "Model": "GKL089"
  },
  {
    "Retail Branding": "INFINITON",
    "Marketing Name": "INFINITON 2K SMART TV",
    "Device": "nagata",
    "Model": "INFINITON 2K Smart TV"
  },
  {
    "Retail Branding": "INFINITON",
    "Marketing Name": "INITON 4K SMART TV",
    "Device": "marina",
    "Model": "INFINITON 4K Smart TV"
  },
  {
    "Retail Branding": "INFINITON",
    "Marketing Name": "Infiniton",
    "Device": "bruno",
    "Model": "Infiniton2KAndroidTV"
  },
  {
    "Retail Branding": "INFINITON",
    "Marketing Name": "Infiniton",
    "Device": "shilin",
    "Model": "Infiniton4KAndroidTV"
  },
  {
    "Retail Branding": "INFINITON",
    "Marketing Name": "SPAIN, MOROCCO, PORTUGAL",
    "Device": "tamachi",
    "Model": "INFINITON Android TV"
  },
  {
    "Retail Branding": "INFINITON",
    "Marketing Name": "SPAIN, MOROCCO, PORTUGAL",
    "Device": "yeongdeungpo",
    "Model": "INFINITON Android TV"
  },
  {
    "Retail Branding": "INGSCREEN",
    "Marketing Name": "IS-Pro-Series",
    "Device": "IS_Panel",
    "Model": "IS-Pro-Series"
  },
  {
    "Retail Branding": "INGSCREEN",
    "Marketing Name": "IS_6518_Pro",
    "Device": "IS_Panel",
    "Model": "IS_6518"
  },
  {
    "Retail Branding": "INMO",
    "Marketing Name": "IMA301",
    "Device": "IMA301",
    "Model": "IMA301"
  },
  {
    "Retail Branding": "INNOCN",
    "Marketing Name": "32S1U Pro",
    "Device": "32S1U_Pro",
    "Model": "32S1U_Pro"
  },
  {
    "Retail Branding": "INNOCN",
    "Marketing Name": "32S1U_Pro",
    "Device": "32S1U_Pro",
    "Model": "32S1U_Pro"
  },
  {
    "Retail Branding": "INNOCN",
    "Marketing Name": "32S2U_Pro",
    "Device": "32S2U_Pro",
    "Model": "32S2U Pro"
  },
  {
    "Retail Branding": "INNOCN",
    "Marketing Name": "S1",
    "Device": "YUL",
    "Model": "S1"
  },
  {
    "Retail Branding": "INNOVA",
    "Marketing Name": "INNOVA",
    "Device": "elliniko",
    "Model": "INNOVA GOOGLE TV 4K"
  },
  {
    "Retail Branding": "INNOVA",
    "Marketing Name": "INNOVA",
    "Device": "jagalchi",
    "Model": "INNOVA GOOGLE TV"
  },
  {
    "Retail Branding": "INNOVA",
    "Marketing Name": "INNOVA 2K Android TV",
    "Device": "lasalle",
    "Model": "INNOVA 2K Android TV"
  },
  {
    "Retail Branding": "INNOVA",
    "Marketing Name": "INNOVA 2K Google TV",
    "Device": "capitolhill",
    "Model": "INNOVA 2K Google TV"
  },
  {
    "Retail Branding": "INNOVA",
    "Marketing Name": "INNOVA 4K Android TV",
    "Device": "kenton",
    "Model": "INNOVA 4K Android TV"
  },
  {
    "Retail Branding": "INNOVA",
    "Marketing Name": "INNOVA 4K Google TV",
    "Device": "keoneae",
    "Model": "INNOVA 4K Google TV"
  },
  {
    "Retail Branding": "INOI",
    "Marketing Name": "A126",
    "Device": "A126",
    "Model": "A126"
  },
  {
    "Retail Branding": "INOI",
    "Marketing Name": "A14",
    "Device": "INOI_A14",
    "Model": "A140"
  },
  {
    "Retail Branding": "INOI",
    "Marketing Name": "A150",
    "Device": "A150",
    "Model": "A150"
  },
  {
    "Retail Branding": "INOI",
    "Marketing Name": "A160",
    "Device": "A160",
    "Model": "A160"
  },
  {
    "Retail Branding": "INOI",
    "Marketing Name": "A181",
    "Device": "A181",
    "Model": "A181"
  },
  {
    "Retail Branding": "INOI",
    "Marketing Name": "A181",
    "Device": "A181",
    "Model": "A181_Plus"
  },
  {
    "Retail Branding": "INOI",
    "Marketing Name": "INOI 1 Lite",
    "Device": "INOI_1_Lite",
    "Model": "INOI_1_Lite"
  },
  {
    "Retail Branding": "INOI",
    "Marketing Name": "INOI 2 Lite 2019",
    "Device": "INOI_2_Lite_2019",
    "Model": "INOI 2 Lite 2019"
  },
  {
    "Retail Branding": "INOI",
    "Marketing Name": "INOI 2 Lite 2021",
    "Device": "INOI_2_Lite_2021",
    "Model": "INOI 2 Lite 2021"
  },
  {
    "Retail Branding": "INOI",
    "Marketing Name": "INOI 2 Lite 4Gb",
    "Device": "INOI_2_Lite_4Gb",
    "Model": "INOI 2 Lite 4Gb"
  },
  {
    "Retail Branding": "INOI",
    "Marketing Name": "INOI 3 LITE",
    "Device": "INOI_3_LITE",
    "Model": "INOI_3_LITE"
  },
  {
    "Retail Branding": "INOI",
    "Marketing Name": "INOI 5 Pro",
    "Device": "INOI_5_Pro",
    "Model": "INOI_5_Pro"
  },
  {
    "Retail Branding": "INOI",
    "Marketing Name": "INOI A151",
    "Device": "A151",
    "Model": "A151"
  },
  {
    "Retail Branding": "INOI",
    "Marketing Name": "INOI A16",
    "Device": "INOI_A16",
    "Model": "A152"
  },
  {
    "Retail Branding": "INOI",
    "Marketing Name": "INOI A34",
    "Device": "INOI_A34",
    "Model": "A340"
  },
  {
    "Retail Branding": "INOI",
    "Marketing Name": "INOI A35 Adventure",
    "Device": "INOI_A35_Adventure",
    "Model": "A350"
  },
  {
    "Retail Branding": "INOI",
    "Marketing Name": "INOI A52 Lite 32GB",
    "Device": "A150",
    "Model": "A150"
  },
  {
    "Retail Branding": "INOI",
    "Marketing Name": "INOI A55 Spectre 5G",
    "Device": "INOI_A55_Spectre_5G",
    "Model": "A550"
  },
  {
    "Retail Branding": "INOI",
    "Marketing Name": "INOI A62 64GB",
    "Device": "A161",
    "Model": "A161"
  },
  {
    "Retail Branding": "INOI",
    "Marketing Name": "INOI A62 64GB",
    "Device": "A161_Plus",
    "Model": "A161_Plus"
  },
  {
    "Retail Branding": "INOI",
    "Marketing Name": "INOI A72",
    "Device": "A170",
    "Model": "A170"
  },
  {
    "Retail Branding": "INOI",
    "Marketing Name": "INOI A72",
    "Device": "A170",
    "Model": "A170_Plus"
  },
  {
    "Retail Branding": "INOI",
    "Marketing Name": "INOI A72",
    "Device": "A171",
    "Model": "A171"
  },
  {
    "Retail Branding": "INOI",
    "Marketing Name": "INOI A72",
    "Device": "A171",
    "Model": "A171_Plus"
  },
  {
    "Retail Branding": "INOI",
    "Marketing Name": "INOI A75 Elegance",
    "Device": "INOI_A75_Elegance",
    "Model": "A750"
  },
  {
    "Retail Branding": "INOI",
    "Marketing Name": "INOI Flip",
    "Device": "INOI_Flip",
    "Model": "A880"
  },
  {
    "Retail Branding": "INOI",
    "Marketing Name": "INOI Note 12",
    "Device": "A180",
    "Model": "A180"
  },
  {
    "Retail Branding": "INOI",
    "Marketing Name": "INOI Note 12",
    "Device": "A180",
    "Model": "A180_Plus"
  },
  {
    "Retail Branding": "INOI",
    "Marketing Name": "INOI _7i_Lite",
    "Device": "INOI_7i_Lite",
    "Model": "INOI_7i_Lite"
  },
  {
    "Retail Branding": "INOI",
    "Marketing Name": "INOI_1",
    "Device": "INOI_1",
    "Model": "INOI 1"
  },
  {
    "Retail Branding": "INOI",
    "Marketing Name": "INOI_1_Lite_2020",
    "Device": "INOI_1_Lite_2020",
    "Model": "INOI 1 Lite 2020"
  },
  {
    "Retail Branding": "INOI",
    "Marketing Name": "INOI_2",
    "Device": "INOI_2",
    "Model": "INOI_2"
  },
  {
    "Retail Branding": "INOI",
    "Marketing Name": "INOI_2_2019",
    "Device": "INOI_2_2019",
    "Model": "INOI 2 2019"
  },
  {
    "Retail Branding": "INOI",
    "Marketing Name": "INOI_2_2021",
    "Device": "INOI_2_2021",
    "Model": "INOI 2 2021"
  },
  {
    "Retail Branding": "INOI",
    "Marketing Name": "INOI_2_LITE",
    "Device": "INOI_2_LITE",
    "Model": "INOI_2_LITE"
  },
  {
    "Retail Branding": "INOI",
    "Marketing Name": "INOI_2_Lite_4Gb",
    "Device": "INOI_2_Lite_4Gb",
    "Model": "INOI 2 Lite 4Gb"
  },
  {
    "Retail Branding": "INOI",
    "Marketing Name": "INOI_3",
    "Device": "INOI_3",
    "Model": "INOI_3"
  },
  {
    "Retail Branding": "INOI",
    "Marketing Name": "INOI_3_LITE",
    "Device": "INOI_3_LITE",
    "Model": "INOI_3_LITE"
  },
  {
    "Retail Branding": "INOI",
    "Marketing Name": "INOI_3_POWER",
    "Device": "INOI_3_POWER",
    "Model": "INOI_3_POWER"
  },
  {
    "Retail Branding": "INOI",
    "Marketing Name": "INOI_5X",
    "Device": "INOI_5X",
    "Model": "INOI_5X"
  },
  {
    "Retail Branding": "INOI",
    "Marketing Name": "INOI_5X_Lite",
    "Device": "INOI_5X_Lite",
    "Model": "INOI_5X_Lite"
  },
  {
    "Retail Branding": "INOI",
    "Marketing Name": "INOI_5_2021",
    "Device": "INOI_5_2021",
    "Model": "INOI 5 2021"
  },
  {
    "Retail Branding": "INOI",
    "Marketing Name": "INOI_5_Lite_2021",
    "Device": "INOI_5_Lite_2021",
    "Model": "INOI 5 Lite 2021"
  },
  {
    "Retail Branding": "INOI",
    "Marketing Name": "INOI_5i",
    "Device": "INOI_5i",
    "Model": "INOI_5i"
  },
  {
    "Retail Branding": "INOI",
    "Marketing Name": "INOI_5i_Lite",
    "Device": "INOI_5i_Lite",
    "Model": "INOI_5i_Lite"
  },
  {
    "Retail Branding": "INOI",
    "Marketing Name": "INOI_5i_Pro",
    "Device": "INOI_5i_Pro",
    "Model": "INOI_5i_Pro"
  },
  {
    "Retail Branding": "INOI",
    "Marketing Name": "INOI_6",
    "Device": "INOI_6",
    "Model": "INOI_6"
  },
  {
    "Retail Branding": "INOI",
    "Marketing Name": "INOI_6_LITE",
    "Device": "INOI_6_Lite",
    "Model": "INOI_6_Lite"
  },
  {
    "Retail Branding": "INOI",
    "Marketing Name": "INOI_6i",
    "Device": "INOI_6i",
    "Model": "INOI_6i"
  },
  {
    "Retail Branding": "INOI",
    "Marketing Name": "INOI_6i_Lite",
    "Device": "INOI_6i_Lite",
    "Model": "INOI_6i_Lite"
  },
  {
    "Retail Branding": "INOI",
    "Marketing Name": "INOI_7_2020",
    "Device": "INOI_7_2020",
    "Model": "INOI 7 2020"
  },
  {
    "Retail Branding": "INOI",
    "Marketing Name": "INOI_7_4_64_2021",
    "Device": "INOI_7_4_64_2021",
    "Model": "INOI 7 4+64 2021"
  },
  {
    "Retail Branding": "INOI",
    "Marketing Name": "INOI_7_LITE",
    "Device": "INOI_7_LITE",
    "Model": "INOI_7_LITE"
  },
  {
    "Retail Branding": "INOI",
    "Marketing Name": "INOI_7i",
    "Device": "INOI_7i",
    "Model": "INOI_7i"
  },
  {
    "Retail Branding": "INOI",
    "Marketing Name": "INOI_A14",
    "Device": "INOI_A14",
    "Model": "A140"
  },
  {
    "Retail Branding": "INOI",
    "Marketing Name": "INOI_A14E",
    "Device": "INOI_A14",
    "Model": "A140"
  },
  {
    "Retail Branding": "INOI",
    "Marketing Name": "Note 15",
    "Device": "INOI_Note_15",
    "Model": "A184"
  },
  {
    "Retail Branding": "INOI",
    "Marketing Name": "Note_13s128",
    "Device": "Note_13s",
    "Model": "A180"
  },
  {
    "Retail Branding": "INOI",
    "Marketing Name": "Note_13s256",
    "Device": "Note_13s",
    "Model": "A180"
  },
  {
    "Retail Branding": "INOI",
    "Marketing Name": "T100",
    "Device": "T100",
    "Model": "inoiPad 64GB Wi-Fi+3G"
  },
  {
    "Retail Branding": "INOI",
    "Marketing Name": "T107",
    "Device": "T107",
    "Model": "inoiPad 128+4GB Wi-Fi+4G"
  },
  {
    "Retail Branding": "INOI",
    "Marketing Name": "T107_Plus",
    "Device": "T107_Plus",
    "Model": "inoiPad Pro"
  },
  {
    "Retail Branding": "INOI",
    "Marketing Name": "T108",
    "Device": "T108",
    "Model": "inoiPad 64GB Wi-Fi +4G"
  },
  {
    "Retail Branding": "INOI",
    "Marketing Name": "easyphone",
    "Device": "easyphone",
    "Model": "INOI easyphone"
  },
  {
    "Retail Branding": "INOI",
    "Marketing Name": "inoiPad",
    "Device": "inoiPad",
    "Model": "inoiPad 2+32 Wi-Fi+3G"
  },
  {
    "Retail Branding": "INOI",
    "Marketing Name": "inoiPad_Max",
    "Device": "T109",
    "Model": "inoiPad Max"
  },
  {
    "Retail Branding": "INOI",
    "Marketing Name": "inoiPad_Pro",
    "Device": "inoiPad_Pro",
    "Model": "inoiPad Pro"
  },
  {
    "Retail Branding": "INOI",
    "Marketing Name": "inoiPad_Pro",
    "Device": "inoiPad_Pro",
    "Model": "inoiPad_Pro"
  },
  {
    "Retail Branding": "INOI",
    "Marketing Name": "inoiPad_mini_3G",
    "Device": "inoiPad_mini_3G",
    "Model": "inoiPad mini 2+32 Wi-Fi+3G"
  },
  {
    "Retail Branding": "INOI",
    "Marketing Name": "inoiPad_mini_WiFi",
    "Device": "inoiPad_mini_Wi-Fi",
    "Model": "inoiPad mini 1+16 Wi-Fi"
  },
  {
    "Retail Branding": "INOVA",
    "Marketing Name": "Northlight_4G",
    "Device": "Northlight_4G",
    "Model": "IV_4G_1"
  },
  {
    "Retail Branding": "INOVALLEY",
    "Marketing Name": "MID_106_3G",
    "Device": "MID106-3G",
    "Model": "MID106-3G"
  },
  {
    "Retail Branding": "INOVALLEY",
    "Marketing Name": "MID_109_Oreo_BTH",
    "Device": "MID_109_Oreo_BTH",
    "Model": "MID_109_Oreo_BTH"
  },
  {
    "Retail Branding": "INOVIO",
    "Marketing Name": "EVO_TAB7",
    "Device": "EVO_TAB7",
    "Model": "EVO_TAB7"
  },
  {
    "Retail Branding": "INQ Mobile",
    "Marketing Name": "",
    "Device": "camden",
    "Model": "Camden"
  },
  {
    "Retail Branding": "INQ Mobile",
    "Marketing Name": "",
    "Device": "camden",
    "Model": "INQ Cloud Touch"
  },
  {
    "Retail Branding": "INQ Mobile",
    "Marketing Name": "",
    "Device": "camden",
    "Model": "INQ Cloud Touch -parrot"
  },
  {
    "Retail Branding": "INQ Mobile",
    "Marketing Name": "",
    "Device": "msm7627_surf",
    "Model": "INQ Mayfair (EU)"
  },
  {
    "Retail Branding": "INSANE",
    "Marketing Name": "INSANE_V10",
    "Device": "INSANE_V10",
    "Model": "INSANE_V10"
  },
  {
    "Retail Branding": "INSYS",
    "Marketing Name": "AF9- AT701_ EEA",
    "Device": "AF9-AT701_EEA",
    "Model": "AF9-AT701_EEA"
  },
  {
    "Retail Branding": "INSYS",
    "Marketing Name": "GW2-L1049",
    "Device": "GW2-L1049",
    "Model": "GW2-L1049"
  },
  {
    "Retail Branding": "INSYS",
    "Marketing Name": "HK9-4010_EEA",
    "Device": "HK9-4010",
    "Model": "HK9-4010"
  },
  {
    "Retail Branding": "INSYS",
    "Marketing Name": "HK9-K5023",
    "Device": "HK9-K5023",
    "Model": "HK9-K5023"
  },
  {
    "Retail Branding": "INSYS",
    "Marketing Name": "HN2-M16P",
    "Device": "HN2-M16P",
    "Model": "HN2-M16P"
  },
  {
    "Retail Branding": "INSYS",
    "Marketing Name": "HN2-M16Q",
    "Device": "HN2-M16Q",
    "Model": "HN2-M16Q"
  },
  {
    "Retail Branding": "INSYS",
    "Marketing Name": "HN2-M87P",
    "Device": "HN2-M87P",
    "Model": "HN2-M87P"
  },
  {
    "Retail Branding": "INSYS",
    "Marketing Name": "IH8-S559",
    "Device": "IH8-S559",
    "Model": "IH8-S559"
  },
  {
    "Retail Branding": "INSYS",
    "Marketing Name": "IH9-L614",
    "Device": "IH9-L614",
    "Model": "IH9-L614"
  },
  {
    "Retail Branding": "INSYS",
    "Marketing Name": "KP1_S10",
    "Device": "KP1_S10",
    "Model": "KP1_S10"
  },
  {
    "Retail Branding": "INSYS",
    "Marketing Name": "KT9-70RA",
    "Device": "KT9-70RA",
    "Model": "KT9-70RA"
  },
  {
    "Retail Branding": "INSYS",
    "Marketing Name": "WH2-9832",
    "Device": "WH2-9832",
    "Model": "WH2-9832"
  },
  {
    "Retail Branding": "INTELITY",
    "Marketing Name": "IN101",
    "Device": "IN101",
    "Model": "IN101"
  },
  {
    "Retail Branding": "INTOUCH",
    "Marketing Name": "Smartboard",
    "Device": "int999G",
    "Model": "int999G"
  },
  {
    "Retail Branding": "INUSUAL",
    "Marketing Name": "INUTAB21",
    "Device": "INUTAB21",
    "Model": "INUTAB21"
  },
  {
    "Retail Branding": "ION ELECTRONICS",
    "Marketing Name": "Gravity",
    "Device": "Gravity",
    "Model": "Gravity"
  },
  {
    "Retail Branding": "ION ELECTRONICS",
    "Marketing Name": "Kids",
    "Device": "Kids",
    "Model": "Kids"
  },
  {
    "Retail Branding": "ION ELECTRONICS",
    "Marketing Name": "Orbit",
    "Device": "Orbit",
    "Model": "Orbit"
  },
  {
    "Retail Branding": "IPRODA",
    "Marketing Name": "T1144",
    "Device": "T1144",
    "Model": "T1144"
  },
  {
    "Retail Branding": "IQ Touch",
    "Marketing Name": "IFP",
    "Device": "rk3588_t",
    "Model": "IFP"
  },
  {
    "Retail Branding": "IQ Touch",
    "Marketing Name": "VIATABQX1040",
    "Device": "VIATABQX1040",
    "Model": "VIATABQX1040"
  },
  {
    "Retail Branding": "IQ Touch",
    "Marketing Name": "VIATABQX730",
    "Device": "VIATABQX730",
    "Model": "VIATABQX730"
  },
  {
    "Retail Branding": "IQ Touch",
    "Marketing Name": "VIATABQX740",
    "Device": "VIATABQX740",
    "Model": "VIATABQX740"
  },
  {
    "Retail Branding": "IQ Touch",
    "Marketing Name": "iMax_EC1053",
    "Device": "iMax_EC1053",
    "Model": "iMax_EC1053"
  },
  {
    "Retail Branding": "IQTOUCH",
    "Marketing Name": "IQTOUCH",
    "Device": "t7_an400",
    "Model": "QA_Series"
  },
  {
    "Retail Branding": "IQU(SZ)",
    "Marketing Name": "IQUSMARTEASYT10W",
    "Device": "IQUSMARTEASYT10W",
    "Model": "IQU SmartEasy T10w"
  },
  {
    "Retail Branding": "IQU(SZ)",
    "Marketing Name": "IQUSMARTEASYT10W",
    "Device": "IQUSMARTEASYT10W",
    "Model": "IQUSMARTEASYT10W"
  },
  {
    "Retail Branding": "IQU_GROUP",
    "Marketing Name": "IQUSMARTEASYT8W",
    "Device": "IQUSMARTEASYT8W",
    "Model": "IQU SMARTEasy T8w"
  },
  {
    "Retail Branding": "IQU_GROUP",
    "Marketing Name": "IQUSMARTEASYT8W",
    "Device": "IQUSMARTEASYT8W",
    "Model": "IQU SmartEasy T8w"
  },
  {
    "Retail Branding": "IQU_GROUP",
    "Marketing Name": "IQU_T10_4G",
    "Device": "IQU_T10_4G",
    "Model": "IQU T10 4G"
  },
  {
    "Retail Branding": "IQU_GROUP",
    "Marketing Name": "IQU_T8_4G",
    "Device": "IQU_T8_4G",
    "Model": "IQU T8 4G"
  },
  {
    "Retail Branding": "IQU_GROUP",
    "Marketing Name": "SMARTEasy_Q50",
    "Device": "SMARTEasy_Q50",
    "Model": "SMARTEasy_Q50"
  },
  {
    "Retail Branding": "IQU_GROUP",
    "Marketing Name": "SMARTEasy_Q60",
    "Device": "SMARTEasy_Q60",
    "Model": "SMARTEasy_Q60"
  },
  {
    "Retail Branding": "IRA (explore more)",
    "Marketing Name": "IRA explore more",
    "Device": "IRA_BHARATAB_1021",
    "Model": "IRA_BHARATAB_1021"
  },
  {
    "Retail Branding": "IRA (explore more)",
    "Marketing Name": "IRA801",
    "Device": "IRA801",
    "Model": "IRA801"
  },
  {
    "Retail Branding": "IRA (explore more)",
    "Marketing Name": "IRABIO",
    "Device": "IRABIO",
    "Model": "IRABIO"
  },
  {
    "Retail Branding": "IRA (explore more)",
    "Marketing Name": "IRADUO_PRO",
    "Device": "IRA_DUO_PRO",
    "Model": "IRA_DUO_PRO"
  },
  {
    "Retail Branding": "IRA (explore more)",
    "Marketing Name": "IRAT803",
    "Device": "IRAT803",
    "Model": "IRAT803"
  },
  {
    "Retail Branding": "IRA (explore more)",
    "Marketing Name": "IRAT803",
    "Device": "IRAT803",
    "Model": "Ira_bharatab_803"
  },
  {
    "Retail Branding": "IRA (explore more)",
    "Marketing Name": "IRA_BIO",
    "Device": "IRA_BIO",
    "Model": "IRA_BIO"
  },
  {
    "Retail Branding": "IRA (explore more)",
    "Marketing Name": "IRA_BIOA",
    "Device": "IRA_BIOA",
    "Model": "IRA_BIOA"
  },
  {
    "Retail Branding": "IRA (explore more)",
    "Marketing Name": "IRA_DUO_PLUS",
    "Device": "IRA_DUO_PLUS",
    "Model": "IRA_DUO_PLUS"
  },
  {
    "Retail Branding": "IRA (explore more)",
    "Marketing Name": "IRA_DUO_PRO_5G",
    "Device": "IRA_DUO_PRO_5G",
    "Model": "IRA DUO PRO 5G"
  },
  {
    "Retail Branding": "IRA (explore more)",
    "Marketing Name": "IRA_T1029",
    "Device": "IRA_T1029",
    "Model": "IRA_T1029"
  },
  {
    "Retail Branding": "IRA (explore more)",
    "Marketing Name": "IRA_T1030M",
    "Device": "IRA_T1030M",
    "Model": "IRA_T1030M"
  },
  {
    "Retail Branding": "IRA (explore more)",
    "Marketing Name": "IRA_T803M",
    "Device": "IRA_T803M",
    "Model": "IRA_T803M"
  },
  {
    "Retail Branding": "IRA (explore more)",
    "Marketing Name": "IRA_T803M",
    "Device": "VPTB8A",
    "Model": "Vision Plus Tab 8A"
  },
  {
    "Retail Branding": "IRA (explore more)",
    "Marketing Name": "IRA_T808M",
    "Device": "IRA_T808M",
    "Model": "IRA_T808M"
  },
  {
    "Retail Branding": "IRA (explore more)",
    "Marketing Name": "IRA_W801",
    "Device": "IRA_W801",
    "Model": "IRA_W801"
  },
  {
    "Retail Branding": "IRA (explore more)",
    "Marketing Name": "T1015",
    "Device": "T1015",
    "Model": "IRA_T1015"
  },
  {
    "Retail Branding": "IRA (explore more)",
    "Marketing Name": "T1021",
    "Device": "T1021",
    "Model": "T1021"
  },
  {
    "Retail Branding": "IRA (explore more)",
    "Marketing Name": "T1030A",
    "Device": "T1030A",
    "Model": "T1030A"
  },
  {
    "Retail Branding": "IRA (explore more)",
    "Marketing Name": "T803",
    "Device": "T803",
    "Model": "T803"
  },
  {
    "Retail Branding": "IRA (explore more)",
    "Marketing Name": "T808",
    "Device": "IRA_T808",
    "Model": "IRA T808"
  },
  {
    "Retail Branding": "IRA (explore more)",
    "Marketing Name": "T808",
    "Device": "T808",
    "Model": "T808"
  },
  {
    "Retail Branding": "IRA (explore more)",
    "Marketing Name": "Wishtel Pvt Ltd",
    "Device": "IRA_T1021",
    "Model": "IRA_T1021"
  },
  {
    "Retail Branding": "IRA (explore more)",
    "Marketing Name": "Wishtel_IRA_T1029",
    "Device": "Wishtel_IRA_T1029",
    "Model": "Wishtel_IRA_T1029"
  },
  {
    "Retail Branding": "IRIE",
    "Marketing Name": "FFF-TAB10H",
    "Device": "FFF-TAB10H",
    "Model": "FFF-TAB10H"
  },
  {
    "Retail Branding": "IRIS_OHYAMA",
    "Marketing Name": "IB-75UED01B",
    "Device": "IB-75UED01B",
    "Model": "IB-75UED01B"
  },
  {
    "Retail Branding": "IRIS_OHYAMA",
    "Marketing Name": "LUCA Tablet TM152",
    "Device": "TM152M4",
    "Model": "TM152"
  },
  {
    "Retail Branding": "IRIS_OHYAMA",
    "Marketing Name": "LUCA Tablet TM152",
    "Device": "TM152M8",
    "Model": "TM152"
  },
  {
    "Retail Branding": "IRIS_OHYAMA",
    "Marketing Name": "R4",
    "Device": "R4",
    "Model": "R4"
  },
  {
    "Retail Branding": "IRIS_OHYAMA",
    "Marketing Name": "Smart TV",
    "Device": "osaka",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "IRIS_OHYAMA",
    "Marketing Name": "TA10E1W63",
    "Device": "TA10E1W63",
    "Model": "TA10E1W63"
  },
  {
    "Retail Branding": "IRIS_OHYAMA",
    "Marketing Name": "TE081N1",
    "Device": "Apollo_8_4G",
    "Model": "TE081"
  },
  {
    "Retail Branding": "IRIS_OHYAMA",
    "Marketing Name": "TE082M2",
    "Device": "Luna",
    "Model": "TE082M2"
  },
  {
    "Retail Branding": "IRIS_OHYAMA",
    "Marketing Name": "TE083M3",
    "Device": "TE083M3",
    "Model": "TE083"
  },
  {
    "Retail Branding": "IRIS_OHYAMA",
    "Marketing Name": "TE084",
    "Device": "TE084",
    "Model": "TE084"
  },
  {
    "Retail Branding": "IRIS_OHYAMA",
    "Marketing Name": "TE08D1M64",
    "Device": "TE08D1M64",
    "Model": "TE08D1M64"
  },
  {
    "Retail Branding": "IRIS_OHYAMA",
    "Marketing Name": "TE08D2M64",
    "Device": "TE08D2M64",
    "Model": "TE08D2M64"
  },
  {
    "Retail Branding": "IRIS_OHYAMA",
    "Marketing Name": "TE101N1",
    "Device": "Aquaman_10_Smart_WIFI",
    "Model": "TE101"
  },
  {
    "Retail Branding": "IRIS_OHYAMA",
    "Marketing Name": "TE102M3",
    "Device": "TE102M3",
    "Model": "TE102"
  },
  {
    "Retail Branding": "IRIS_OHYAMA",
    "Marketing Name": "TE103M3",
    "Device": "TE103M3",
    "Model": "TE103"
  },
  {
    "Retail Branding": "IRIS_OHYAMA",
    "Marketing Name": "TE104",
    "Device": "TE104",
    "Model": "TE104M4"
  },
  {
    "Retail Branding": "IRIS_OHYAMA",
    "Marketing Name": "TE10D1M64",
    "Device": "TE10D1M64",
    "Model": "TE10D1M64"
  },
  {
    "Retail Branding": "IRIS_OHYAMA",
    "Marketing Name": "TE10D2M64",
    "Device": "TE10D2M64",
    "Model": "TE10D2M64"
  },
  {
    "Retail Branding": "IRIS_OHYAMA",
    "Marketing Name": "TM082",
    "Device": "TM082",
    "Model": "TM082M4"
  },
  {
    "Retail Branding": "IRIS_OHYAMA",
    "Marketing Name": "TM083",
    "Device": "TM083",
    "Model": "TM083"
  },
  {
    "Retail Branding": "IRIS_OHYAMA",
    "Marketing Name": "TM083",
    "Device": "TM083",
    "Model": "TM083M4"
  },
  {
    "Retail Branding": "IRIS_OHYAMA",
    "Marketing Name": "TM08E2W74",
    "Device": "TM08E2W74",
    "Model": "TM08E2W74"
  },
  {
    "Retail Branding": "IRIS_OHYAMA",
    "Marketing Name": "TM101",
    "Device": "Odin",
    "Model": "TM101"
  },
  {
    "Retail Branding": "IRIS_OHYAMA",
    "Marketing Name": "TM101",
    "Device": "Odin2",
    "Model": "TM101"
  },
  {
    "Retail Branding": "IRIS_OHYAMA",
    "Marketing Name": "TM102",
    "Device": "TM102",
    "Model": "TM102M4"
  },
  {
    "Retail Branding": "IRIS_OHYAMA",
    "Marketing Name": "TM103",
    "Device": "TM103",
    "Model": "TM103M4"
  },
  {
    "Retail Branding": "IRIS_OHYAMA",
    "Marketing Name": "TM12E2W74",
    "Device": "TM12E2W74",
    "Model": "TM12E2W74"
  },
  {
    "Retail Branding": "IRIS_OHYAMA",
    "Marketing Name": "TM12E3W74",
    "Device": "TM12E3W74",
    "Model": "TM12E3W74"
  },
  {
    "Retail Branding": "IRIS_OHYAMA",
    "Marketing Name": "TM153M6",
    "Device": "TM153M6",
    "Model": "TM153"
  },
  {
    "Retail Branding": "IRIS_OHYAMA",
    "Marketing Name": "TM15F1Q74",
    "Device": "TM15F1Q74",
    "Model": "TM15F1Q74"
  },
  {
    "Retail Branding": "ISCED",
    "Marketing Name": "ISCEDTAB21",
    "Device": "ISCEDTAB21",
    "Model": "ISCEDTAB21"
  },
  {
    "Retail Branding": "ISCS",
    "Marketing Name": "QA3O_M110",
    "Device": "QA3O_M110",
    "Model": "QA3O-M110"
  },
  {
    "Retail Branding": "ISCS",
    "Marketing Name": "QA3O_M110",
    "Device": "QA3O_M110",
    "Model": "QA3O_M110"
  },
  {
    "Retail Branding": "ITAB",
    "Marketing Name": "ITAB_X40L_Plus",
    "Device": "ITAB_X40L_Plus",
    "Model": "ITAB_X40L_Plus"
  },
  {
    "Retail Branding": "ITAB",
    "Marketing Name": "X40L",
    "Device": "X40L",
    "Model": "X40L"
  },
  {
    "Retail Branding": "ITOS",
    "Marketing Name": "IC-51",
    "Device": "IC_51",
    "Model": "IC_51"
  },
  {
    "Retail Branding": "ITOS",
    "Marketing Name": "IC-58",
    "Device": "IC_58",
    "Model": "IC_58"
  },
  {
    "Retail Branding": "ITOS",
    "Marketing Name": "IC-59",
    "Device": "IC_59",
    "Model": "IC_59"
  },
  {
    "Retail Branding": "ITOS",
    "Marketing Name": "IC_51R",
    "Device": "IC_51R",
    "Model": "IC_51"
  },
  {
    "Retail Branding": "ITOS",
    "Marketing Name": "IC_55",
    "Device": "IC_55",
    "Model": "IC_55"
  },
  {
    "Retail Branding": "ITOS",
    "Marketing Name": "IC_56_EEA",
    "Device": "IC_56",
    "Model": "IC_56"
  },
  {
    "Retail Branding": "ITOS",
    "Marketing Name": "IC_59",
    "Device": "IC_59",
    "Model": "IC_59"
  },
  {
    "Retail Branding": "ITOS",
    "Marketing Name": "IC_61",
    "Device": "IC_61",
    "Model": "IC_61"
  },
  {
    "Retail Branding": "ITOS",
    "Marketing Name": "IT_51",
    "Device": "IT_51",
    "Model": "IT_51"
  },
  {
    "Retail Branding": "IUNI",
    "Marketing Name": "N1",
    "Device": "IUNI_N1",
    "Model": "IUNI N1"
  },
  {
    "Retail Branding": "IUSA",
    "Marketing Name": "TR10CS1",
    "Device": "TR10CS1_7",
    "Model": "TR10CS1"
  },
  {
    "Retail Branding": "IUSA",
    "Marketing Name": "TR10CS1",
    "Device": "TR10CS1_8",
    "Model": "TR10CS1"
  },
  {
    "Retail Branding": "IVA Mobile",
    "Marketing Name": "LAMCY L400",
    "Device": "LAMCY_L400",
    "Model": "LAMCY L400"
  },
  {
    "Retail Branding": "IVA Mobile",
    "Marketing Name": "Smart8",
    "Device": "Smart8",
    "Model": "Smart8"
  },
  {
    "Retail Branding": "IVOX",
    "Marketing Name": "TWBXXX24A",
    "Device": "TWBXXX24A1",
    "Model": "TWBXXX24A"
  },
  {
    "Retail Branding": "IView",
    "Marketing Name": "1016TPC",
    "Device": "1016TPC",
    "Model": "1016TPC"
  },
  {
    "Retail Branding": "IView",
    "Marketing Name": "1070TPC",
    "Device": "tulip-d100",
    "Model": "1070TPC"
  },
  {
    "Retail Branding": "IView",
    "Marketing Name": "769TPC",
    "Device": "tulip-d86v",
    "Model": "769TPC"
  },
  {
    "Retail Branding": "IView",
    "Marketing Name": "776TPCIII",
    "Device": "776TPCIII",
    "Model": "776TPCIII"
  },
  {
    "Retail Branding": "IView",
    "Marketing Name": "778TPC",
    "Device": "778TPC",
    "Model": "778TPC"
  },
  {
    "Retail Branding": "IView",
    "Marketing Name": "788TPCII",
    "Device": "iView_788TPCII",
    "Model": "788TPCII"
  },
  {
    "Retail Branding": "IView",
    "Marketing Name": "816TPC",
    "Device": "816TPC",
    "Model": "816TPC"
  },
  {
    "Retail Branding": "IView",
    "Marketing Name": "885TPC",
    "Device": "885TPC",
    "Model": "885TPC"
  },
  {
    "Retail Branding": "IView",
    "Marketing Name": "920TPC",
    "Device": "920TPC",
    "Model": "920TPC"
  },
  {
    "Retail Branding": "IView",
    "Marketing Name": "IVIEW",
    "Device": "IVIEW_1170TPC",
    "Model": "1170TPC"
  },
  {
    "Retail Branding": "IView",
    "Marketing Name": "Retailer Stores",
    "Device": "730TPC",
    "Model": "730TPC"
  },
  {
    "Retail Branding": "IView",
    "Marketing Name": "SupraPad i700",
    "Device": "g01i",
    "Model": "i700"
  },
  {
    "Retail Branding": "IView",
    "Marketing Name": "SupraPad i785Q",
    "Device": "anchor",
    "Model": "i785Q"
  },
  {
    "Retail Branding": "IWRIST",
    "Marketing Name": "IWRIST_M11",
    "Device": "IWRIST_M11",
    "Model": "IWRIST_M11"
  },
  {
    "Retail Branding": "IWRIST",
    "Marketing Name": "IWRIST_M7",
    "Device": "IWRIST_M7",
    "Model": "IWRIST_M7"
  },
  {
    "Retail Branding": "IWRIST",
    "Marketing Name": "IWRIST_M8",
    "Device": "IWRIST_M8",
    "Model": "IWRIST_M8"
  },
  {
    "Retail Branding": "IXTECH",
    "Marketing Name": "IX1011",
    "Device": "IX1011",
    "Model": "IX1011"
  },
  {
    "Retail Branding": "IXTECH",
    "Marketing Name": "IX1012",
    "Device": "IX1012",
    "Model": "IX1012"
  },
  {
    "Retail Branding": "IXTECH",
    "Marketing Name": "IX1013",
    "Device": "IX1013",
    "Model": "IX1013"
  },
  {
    "Retail Branding": "IXTECH",
    "Marketing Name": "IX701",
    "Device": "IX701",
    "Model": "IX701"
  },
  {
    "Retail Branding": "IZZI Telecom",
    "Marketing Name": "B866V2FI",
    "Device": "B866V2Fi",
    "Model": "B866V2FI"
  },
  {
    "Retail Branding": "IZZI Telecom",
    "Marketing Name": "HP2714",
    "Device": "HPH65",
    "Model": "HP2714"
  },
  {
    "Retail Branding": "IZZI Telecom",
    "Marketing Name": "HP46A",
    "Device": "HP46A",
    "Model": "HP4633"
  },
  {
    "Retail Branding": "IZZI Telecom",
    "Marketing Name": "Mexico",
    "Device": "B820C-A15_ZTE",
    "Model": "B820C-A15"
  },
  {
    "Retail Branding": "IZZI Telecom",
    "Marketing Name": "SKYWORTH-HY4002",
    "Device": "HY40A1",
    "Model": "SKYWORTH-HY4002"
  },
  {
    "Retail Branding": "I_KALL",
    "Marketing Name": "S6501",
    "Device": "S6501",
    "Model": "S6501"
  },
  {
    "Retail Branding": "Ice",
    "Marketing Name": "ICE",
    "Device": "stanford",
    "Model": "SMART TV"
  },
  {
    "Retail Branding": "Ice",
    "Marketing Name": "ICE",
    "Device": "zhongshan",
    "Model": "Smart UHD TV"
  },
  {
    "Retail Branding": "Ice Phone",
    "Marketing Name": "Mini",
    "Device": "ice_phone_mini",
    "Model": "Ice-Phone Mini"
  },
  {
    "Retail Branding": "Icon",
    "Marketing Name": "Portal_10i",
    "Device": "Portal_10i",
    "Model": "NTMC17"
  },
  {
    "Retail Branding": "IguanaPad",
    "Marketing Name": "XM14G",
    "Device": "XM14G",
    "Model": "XM14G"
  },
  {
    "Retail Branding": "Ikimobile",
    "Marketing Name": "BLESSPLUS",
    "Device": "BLESSPLUS",
    "Model": "BLESSPLUS"
  },
  {
    "Retail Branding": "Ikimobile",
    "Marketing Name": "BLESS_GO55",
    "Device": "BLESS_GO55",
    "Model": "BLESS_GO55"
  },
  {
    "Retail Branding": "Ikimobile",
    "Marketing Name": "GO4.5S",
    "Device": "GO4_5S",
    "Model": "GO4.5S"
  },
  {
    "Retail Branding": "Ikimobile",
    "Marketing Name": "GO5_55",
    "Device": "GO5_55",
    "Model": "GO5_55"
  },
  {
    "Retail Branding": "Ikimobile",
    "Marketing Name": "KF45",
    "Device": "KF45",
    "Model": "KF45"
  },
  {
    "Retail Branding": "Ikimobile",
    "Marketing Name": "Tab4you_6",
    "Device": "Tab4you_6",
    "Model": "Tab4you_6"
  },
  {
    "Retail Branding": "Ikon",
    "Marketing Name": "IK-1025",
    "Device": "IK-1025",
    "Model": "IK-1025"
  },
  {
    "Retail Branding": "Ikon",
    "Marketing Name": "IK-1106",
    "Device": "IK-1106",
    "Model": "IK-1106"
  },
  {
    "Retail Branding": "Ikon",
    "Marketing Name": "IK-7108",
    "Device": "IK-7108",
    "Model": "IK-7108"
  },
  {
    "Retail Branding": "Ikon",
    "Marketing Name": "IK-787",
    "Device": "IK-787",
    "Model": "IK-787"
  },
  {
    "Retail Branding": "Ikon",
    "Marketing Name": "IK-869",
    "Device": "IK-869",
    "Model": "IK-869"
  },
  {
    "Retail Branding": "Ikon",
    "Marketing Name": "IK-T808",
    "Device": "IK-T808",
    "Model": "IK-T808"
  },
  {
    "Retail Branding": "Ikon",
    "Marketing Name": "IK-WT028i",
    "Device": "IK-WT028i",
    "Model": "IK-WT028i"
  },
  {
    "Retail Branding": "Ikon",
    "Marketing Name": "IK-WT1080",
    "Device": "IK-WT1080",
    "Model": "IK-WT1080"
  },
  {
    "Retail Branding": "Ikon",
    "Marketing Name": "IK-WT1088",
    "Device": "IK-WT1088",
    "Model": "IK-WT1088"
  },
  {
    "Retail Branding": "Ikon",
    "Marketing Name": "IKON",
    "Device": "IK-1028",
    "Model": "IK-1028"
  },
  {
    "Retail Branding": "Ikon",
    "Marketing Name": "IKON 2K Google TV",
    "Device": "capitolhill",
    "Model": "IKON 2K Google TV"
  },
  {
    "Retail Branding": "Ikon",
    "Marketing Name": "IKON 4K Google TV",
    "Device": "keoneae",
    "Model": "IKON 4K Google TV"
  },
  {
    "Retail Branding": "Ikon",
    "Marketing Name": "IK_WA024",
    "Device": "IK_WA024",
    "Model": "IK_WA024"
  },
  {
    "Retail Branding": "IkuMobile",
    "Marketing Name": "A10",
    "Device": "A10",
    "Model": "A10"
  },
  {
    "Retail Branding": "IkuMobile",
    "Marketing Name": "A10s",
    "Device": "A10s",
    "Model": "A10s"
  },
  {
    "Retail Branding": "IkuMobile",
    "Marketing Name": "A11",
    "Device": "A11",
    "Model": "A11"
  },
  {
    "Retail Branding": "IkuMobile",
    "Marketing Name": "A12",
    "Device": "A12",
    "Model": "A12"
  },
  {
    "Retail Branding": "IkuMobile",
    "Marketing Name": "A20",
    "Device": "A20",
    "Model": "A20"
  },
  {
    "Retail Branding": "IkuMobile",
    "Marketing Name": "A21",
    "Device": "A21",
    "Model": "A21"
  },
  {
    "Retail Branding": "IkuMobile",
    "Marketing Name": "A23",
    "Device": "A23",
    "Model": "A23"
  },
  {
    "Retail Branding": "IkuMobile",
    "Marketing Name": "A30",
    "Device": "A30",
    "Model": "A30"
  },
  {
    "Retail Branding": "IkuMobile",
    "Marketing Name": "A35",
    "Device": "A35",
    "Model": "A35"
  },
  {
    "Retail Branding": "IkuMobile",
    "Marketing Name": "A4",
    "Device": "A4",
    "Model": "A4"
  },
  {
    "Retail Branding": "IkuMobile",
    "Marketing Name": "A50",
    "Device": "A50",
    "Model": "iKU A50"
  },
  {
    "Retail Branding": "IkuMobile",
    "Marketing Name": "A6",
    "Device": "A6",
    "Model": "A6"
  },
  {
    "Retail Branding": "IkuMobile",
    "Marketing Name": "A6_2022",
    "Device": "A6_2022",
    "Model": "IKU A6 2022"
  },
  {
    "Retail Branding": "IkuMobile",
    "Marketing Name": "A7",
    "Device": "A7",
    "Model": "A7"
  },
  {
    "Retail Branding": "IkuMobile",
    "Marketing Name": "A70",
    "Device": "A70",
    "Model": "iKU A70"
  },
  {
    "Retail Branding": "IkuMobile",
    "Marketing Name": "A7_Plus",
    "Device": "A7_Plus",
    "Model": "A7 Plus"
  },
  {
    "Retail Branding": "IkuMobile",
    "Marketing Name": "I3",
    "Device": "I3",
    "Model": "IKU i3"
  },
  {
    "Retail Branding": "IkuMobile",
    "Marketing Name": "IKU",
    "Device": "IKU",
    "Model": "K10"
  },
  {
    "Retail Branding": "IkuMobile",
    "Marketing Name": "IKU A36",
    "Device": "A36",
    "Model": "iKU A36"
  },
  {
    "Retail Branding": "IkuMobile",
    "Marketing Name": "IKU A4",
    "Device": "A4",
    "Model": "IKU A4"
  },
  {
    "Retail Branding": "IkuMobile",
    "Marketing Name": "IKU A40",
    "Device": "A40",
    "Model": "IKU A40"
  },
  {
    "Retail Branding": "IkuMobile",
    "Marketing Name": "IKU_T3",
    "Device": "IKU_T3",
    "Model": "IKU_T3"
  },
  {
    "Retail Branding": "IkuMobile",
    "Marketing Name": "IKU_T_max",
    "Device": "IKU_T_max",
    "Model": "IKU_T_max"
  },
  {
    "Retail Branding": "IkuMobile",
    "Marketing Name": "IKU_i1",
    "Device": "IKU_i1",
    "Model": "i1"
  },
  {
    "Retail Branding": "IkuMobile",
    "Marketing Name": "K2",
    "Device": "IKU_K2",
    "Model": "K2"
  },
  {
    "Retail Branding": "IkuMobile",
    "Marketing Name": "K3",
    "Device": "K3",
    "Model": "IKU K3"
  },
  {
    "Retail Branding": "IkuMobile",
    "Marketing Name": "K5",
    "Device": "K5",
    "Model": "K5"
  },
  {
    "Retail Branding": "IkuMobile",
    "Marketing Name": "Note_10",
    "Device": "Note_10",
    "Model": "Note 10"
  },
  {
    "Retail Branding": "IkuMobile",
    "Marketing Name": "T1",
    "Device": "T1",
    "Model": "iKU T1"
  },
  {
    "Retail Branding": "IkuMobile",
    "Marketing Name": "T4",
    "Device": "T4",
    "Model": "T4"
  },
  {
    "Retail Branding": "IkuMobile",
    "Marketing Name": "T5",
    "Device": "T5",
    "Model": "T5"
  },
  {
    "Retail Branding": "IkuMobile",
    "Marketing Name": "T6",
    "Device": "T6",
    "Model": "T6"
  },
  {
    "Retail Branding": "IkuMobile",
    "Marketing Name": "T8",
    "Device": "T8",
    "Model": "T8"
  },
  {
    "Retail Branding": "IkuMobile",
    "Marketing Name": "X1",
    "Device": "X1",
    "Model": "X1"
  },
  {
    "Retail Branding": "IkuMobile",
    "Marketing Name": "X2",
    "Device": "X2",
    "Model": "iKU X2"
  },
  {
    "Retail Branding": "IkuMobile",
    "Marketing Name": "X3",
    "Device": "X3",
    "Model": "iKU X3"
  },
  {
    "Retail Branding": "IkuMobile",
    "Marketing Name": "X4",
    "Device": "X4",
    "Model": "X4"
  },
  {
    "Retail Branding": "IkuMobile",
    "Marketing Name": "X5",
    "Device": "X5",
    "Model": "X5"
  },
  {
    "Retail Branding": "IkuMobile",
    "Marketing Name": "X8",
    "Device": "X8",
    "Model": "X8"
  },
  {
    "Retail Branding": "IkuMobile",
    "Marketing Name": "X9",
    "Device": "X9",
    "Model": "X9"
  },
  {
    "Retail Branding": "IkuMobile",
    "Marketing Name": "Y2",
    "Device": "Y2",
    "Model": "Y2"
  },
  {
    "Retail Branding": "IkuMobile",
    "Marketing Name": "Y3",
    "Device": "Y3",
    "Model": "Y3"
  },
  {
    "Retail Branding": "IkuMobile",
    "Marketing Name": "Y5",
    "Device": "Y5",
    "Model": "Y5"
  },
  {
    "Retail Branding": "IkuMobile",
    "Marketing Name": "Y7",
    "Device": "Y7",
    "Model": "Y7"
  },
  {
    "Retail Branding": "IkuMobile",
    "Marketing Name": "iKU A45",
    "Device": "A45",
    "Model": "iKU A45"
  },
  {
    "Retail Branding": "IkuMobile",
    "Marketing Name": "iKU_A22",
    "Device": "iKU_A22",
    "Model": "iKU A22"
  },
  {
    "Retail Branding": "Ilike",
    "Marketing Name": "P3",
    "Device": "P3",
    "Model": "P3"
  },
  {
    "Retail Branding": "Ilike",
    "Marketing Name": "X3_PRO_SLIM",
    "Device": "X3_PRO_SLIM",
    "Model": "X3 PRO SLIM"
  },
  {
    "Retail Branding": "Ilike",
    "Marketing Name": "X5_PRO",
    "Device": "X5_PRO",
    "Model": "X5_PRO"
  },
  {
    "Retail Branding": "ImageMobile",
    "Marketing Name": "Ipanema",
    "Device": "C001",
    "Model": "C001"
  },
  {
    "Retail Branding": "ImageMobile",
    "Marketing Name": "Rio",
    "Device": "Rio",
    "Model": "B001"
  },
  {
    "Retail Branding": "Imagineear",
    "Marketing Name": "Sonato_EEA",
    "Device": "Sonato_EEA",
    "Model": "Sonato by imagineear"
  },
  {
    "Retail Branding": "Imi Tech",
    "Marketing Name": "M88",
    "Device": "M88",
    "Model": "M88"
  },
  {
    "Retail Branding": "Imi Tech",
    "Marketing Name": "Vin6",
    "Device": "Vin6",
    "Model": "Vin6"
  },
  {
    "Retail Branding": "Impecca",
    "Marketing Name": "ET7050D",
    "Device": "ET7050D",
    "Model": "ET7050D"
  },
  {
    "Retail Branding": "Imperial",
    "Marketing Name": "R3_GTV",
    "Device": "R3_GTV",
    "Model": "R3G"
  },
  {
    "Retail Branding": "Imperial",
    "Marketing Name": "R4_GTV",
    "Device": "R4_GTV",
    "Model": "R4G"
  },
  {
    "Retail Branding": "Impression",
    "Marketing Name": "ImPAD_P101",
    "Device": "ImPAD_P101",
    "Model": "ImPAD_P101"
  },
  {
    "Retail Branding": "Impression",
    "Marketing Name": "ImPAD_P701",
    "Device": "ImPAD_P701",
    "Model": "ImPAD_P701"
  },
  {
    "Retail Branding": "Inco",
    "Marketing Name": "Bloom4",
    "Device": "Bloom4",
    "Model": "Bloom4"
  },
  {
    "Retail Branding": "Inco",
    "Marketing Name": "Colossus_4",
    "Device": "Colossus_4",
    "Model": "Colossus_4"
  },
  {
    "Retail Branding": "Inco",
    "Marketing Name": "Flex-3",
    "Device": "Flex-3",
    "Model": "Flex-3"
  },
  {
    "Retail Branding": "Inco",
    "Marketing Name": "Horizon",
    "Device": "HORIZON",
    "Model": "HORIZON"
  },
  {
    "Retail Branding": "Inco",
    "Marketing Name": "Horizon +",
    "Device": "Horizon",
    "Model": "Horizon +"
  },
  {
    "Retail Branding": "Inco",
    "Marketing Name": "Horizon_S",
    "Device": "Horizon_S",
    "Model": "Horizon_S"
  },
  {
    "Retail Branding": "Inco",
    "Marketing Name": "MATTER",
    "Device": "MATTER",
    "Model": "MATTER"
  },
  {
    "Retail Branding": "Inco",
    "Marketing Name": "MINI",
    "Device": "MINI",
    "Model": "MINI"
  },
  {
    "Retail Branding": "Inco",
    "Marketing Name": "Rouge1",
    "Device": "Rouge1",
    "Model": "Rouge1"
  },
  {
    "Retail Branding": "Inco",
    "Marketing Name": "eco_s",
    "Device": "eco_s",
    "Model": "eco_s"
  },
  {
    "Retail Branding": "IndiHome",
    "Marketing Name": "B860H V5.0",
    "Device": "B860HV5_Telkom",
    "Model": "B860H V5.0"
  },
  {
    "Retail Branding": "IndiHome",
    "Marketing Name": "B866F V1.1",
    "Device": "B866FV1_1",
    "Model": "B866F V1.1"
  },
  {
    "Retail Branding": "IndiHome",
    "Marketing Name": "HG680_FJ",
    "Device": "HG680",
    "Model": "HG680_FJ"
  },
  {
    "Retail Branding": "Indurama",
    "Marketing Name": "INDURAMA",
    "Device": "jagalchi",
    "Model": "INDURAMA GOOGLE TV"
  },
  {
    "Retail Branding": "Indurama",
    "Marketing Name": "INDURAMA",
    "Device": "stanford",
    "Model": "INDURAMA SMART TV 2K"
  },
  {
    "Retail Branding": "Indurama",
    "Marketing Name": "INDURAMA",
    "Device": "zhongshan",
    "Model": "INDURAMA SMART TV 4K"
  },
  {
    "Retail Branding": "Indurama",
    "Marketing Name": "Indurama",
    "Device": "elliniko",
    "Model": "INDURAMA GOOGLE TV 4K"
  },
  {
    "Retail Branding": "Indurama",
    "Marketing Name": "Indurama",
    "Device": "hongkong",
    "Model": "INDURAMA GOOGLE TV 4K"
  },
  {
    "Retail Branding": "Indurama",
    "Marketing Name": "Indurama",
    "Device": "lavender",
    "Model": "INDURAMA GOOGLE TV 4K"
  },
  {
    "Retail Branding": "Indurama",
    "Marketing Name": "Indurama",
    "Device": "mountbaker",
    "Model": "INDURAMA GOOGLE TV"
  },
  {
    "Retail Branding": "Indurama",
    "Marketing Name": "Indurama",
    "Device": "stanford",
    "Model": "CSV2K"
  },
  {
    "Retail Branding": "Indurama",
    "Marketing Name": "Indurama",
    "Device": "zhongshan",
    "Model": "CSV4K"
  },
  {
    "Retail Branding": "Indurama",
    "Marketing Name": "Indurama 4K smart TV",
    "Device": "eleonas",
    "Model": "Indurama 4K smart TV"
  },
  {
    "Retail Branding": "Indurama",
    "Marketing Name": "indurama 2K TV",
    "Device": "shinjuku",
    "Model": "indurama 2K TV"
  },
  {
    "Retail Branding": "Indurama",
    "Marketing Name": "indurama 4K TV",
    "Device": "SW4H",
    "Model": "indurama 4K TV"
  },
  {
    "Retail Branding": "Indurama",
    "Marketing Name": "indurama Smart TV",
    "Device": "sunnyvale",
    "Model": "indurama Smart TV"
  },
  {
    "Retail Branding": "Indurama",
    "Marketing Name": "indurama smart TV",
    "Device": "SW4H_FF",
    "Model": "indurama smart TV"
  },
  {
    "Retail Branding": "Inet-Tablet",
    "Marketing Name": "D711HC_PG",
    "Device": "D711HC_PG",
    "Model": "D711HC_PG"
  },
  {
    "Retail Branding": "Inet-Tablet",
    "Marketing Name": "D7911L3BC_OGS",
    "Device": "D7911L3BC_OGS",
    "Model": "D7911L3BC_OGS"
  },
  {
    "Retail Branding": "InfiRay",
    "Marketing Name": "PX1",
    "Device": "PX1",
    "Model": "PX1"
  },
  {
    "Retail Branding": "Infinity",
    "Marketing Name": "10.1-v2",
    "Device": "Infinity-101-v2",
    "Model": "Infinity-10.1-v2"
  },
  {
    "Retail Branding": "Infinity",
    "Marketing Name": "10.1-v3",
    "Device": "Infinity_101_v3",
    "Model": "Infinity-10.1-v3"
  },
  {
    "Retail Branding": "Infinity",
    "Marketing Name": "Infinity",
    "Device": "Infinity",
    "Model": "Infinity"
  },
  {
    "Retail Branding": "InfinityPro",
    "Marketing Name": "IN-9679",
    "Device": "mensa_an64",
    "Model": "InfinityPro-Y1"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "32X1",
    "Device": "ikebukuro",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "43X3",
    "Device": "beaudry",
    "Model": "Infinix AndroidTV"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "50X3",
    "Device": "barking",
    "Model": "Infinix AndroidTV"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "55X1",
    "Device": "samseong",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "GT 10 Pro",
    "Device": "Infinix-X6739",
    "Model": "Infinix X6739"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "GT 20 Pro",
    "Device": "Infinix-X6871",
    "Model": "Infinix X6871"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "GT 30",
    "Device": "Infinix-X6876",
    "Model": "Infinix X6876"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "GT 30 Pro",
    "Device": "Infinix-X6873",
    "Model": "Infinix X6873"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "GT 50 Pro",
    "Device": "Infinix-X6891",
    "Model": "Infinix X6891"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "HOT",
    "Device": "Infinix-X689F",
    "Model": "Infinix X689F"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "HOT 10",
    "Device": "Infinix-X682B",
    "Model": "Infinix X682B"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "HOT 10",
    "Device": "Infinix-X682C",
    "Model": "Infinix X682C"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "HOT 10 Lite",
    "Device": "Infinix-X657B",
    "Model": "Infinix X657B"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "HOT 10 Play",
    "Device": "Infinix-X688B",
    "Model": "Infinix X688B"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "HOT 10 Play",
    "Device": "Infinix-X688C",
    "Model": "Infinix X688C"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "HOT 10 lite",
    "Device": "Infinix-X657B",
    "Model": "Infinix X657B"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "HOT 10i",
    "Device": "Infinix-X658B",
    "Model": "Infinix X658B"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "HOT 10i",
    "Device": "Infinix-X658E",
    "Model": "Infinix X658E"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "HOT 10i",
    "Device": "Infinix-X659",
    "Model": "Infinix X659"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "HOT 10i",
    "Device": "Infinix-X659B",
    "Model": "Infinix X659B"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "HOT 11",
    "Device": "Infinix-X662",
    "Model": "Infinix X662"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "HOT 11",
    "Device": "Infinix-X662B",
    "Model": "Infinix X662B"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "HOT 11",
    "Device": "Infinix-X689F",
    "Model": "Infinix X689F"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "HOT 11 2022",
    "Device": "Infinix-X675",
    "Model": "Infinix X675"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "HOT 11S",
    "Device": "Infinix-X6812",
    "Model": "Infinix X6812"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "HOT 12i",
    "Device": "Infinix-X665",
    "Model": "Infinix X665"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "HOT 12i",
    "Device": "Infinix-X665B",
    "Model": "Infinix X665B"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "HOT 2",
    "Device": "Infinix_X510",
    "Model": "Infinix X510"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "HOT 20 5G",
    "Device": "Infinix-X666",
    "Model": "Infinix X666"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "HOT 20 PLAY",
    "Device": "Infinix-X6825",
    "Model": "Infinix X6825"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "HOT 20S",
    "Device": "Infinix-X6827",
    "Model": "Infinix X6827"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "HOT 20i",
    "Device": "Infinix-X665C",
    "Model": "Infinix X665C"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "HOT 20i",
    "Device": "Infinix-X665E",
    "Model": "Infinix X665E"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "HOT 3",
    "Device": "INFINIX-X554",
    "Model": "Infinix HOT 3 Pro"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "HOT 3",
    "Device": "INFINIX-X554",
    "Model": "Infinix-X554"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "HOT 3 LTE",
    "Device": "INFINIX-X553",
    "Model": "Infinix HOT 3 LTE"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "HOT 3 LTE",
    "Device": "INFINIX-X553-A1",
    "Model": "Infinix HOT 3 LTE"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "HOT 30 5G",
    "Device": "Infinix-X6832",
    "Model": "Infinix X6832"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "HOT 4",
    "Device": "Infinix-X5511",
    "Model": "Infinix HOT 4"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "HOT 4",
    "Device": "Infinix-X5511",
    "Model": "Infinix HOT4 LTE"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "HOT 4",
    "Device": "X557",
    "Model": "Infinix HOT 4"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "HOT 4",
    "Device": "X557",
    "Model": "Infinix X557"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "HOT 4",
    "Device": "X557-Lite",
    "Model": "Infinix HOT 4"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "HOT 4 Lite",
    "Device": "X557-Lite",
    "Model": "Infinix HOT 4"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "HOT 4 Lite",
    "Device": "X557-Lite",
    "Model": "Infinix HOT 4 Lite"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "HOT 4 PRO",
    "Device": "X556",
    "Model": "Infinix HOT 4 Pro"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "HOT 4 PRO",
    "Device": "X556",
    "Model": "Infinix_X556_LTE"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "HOT 4 Pro",
    "Device": "Infinix-X5511-13M",
    "Model": "Infinix HOT 4 Pro"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "HOT 4 Pro",
    "Device": "X556",
    "Model": "Infinix HOT 4 Pro"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "HOT 50 Pro+",
    "Device": "Infinix-X6880",
    "Model": "Infinix X6880"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "HOT 6",
    "Device": "Infinix-X606",
    "Model": "Infinix X606"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "HOT 6",
    "Device": "Infinix-X606B",
    "Model": "Infinix X606B"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "HOT 6",
    "Device": "Infinix-X606C",
    "Model": "Infinix X606C"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "HOT 6",
    "Device": "Infinix-X606D",
    "Model": "Infinix X606D"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "HOT 6 Pro",
    "Device": "Infinix-X608",
    "Model": "Infinix X608"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "HOT 60 5G",
    "Device": "Infinix-X6726",
    "Model": "Infinix X6726"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "HOT 60 5G",
    "Device": "Infinix-X6726B",
    "Model": "Infinix X6726B"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "HOT 60 Pro+",
    "Device": "Infinix-X6886",
    "Model": "Infinix X6886"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "HOT 60i",
    "Device": "Infinix-X6728",
    "Model": "Infinix X6728"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "HOT 60i 5G",
    "Device": "Infinix-X6730",
    "Model": "Infinix X6730"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "HOT 60i 5G",
    "Device": "Infinix-X6730B",
    "Model": "Infinix X6730B"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "HOT 7",
    "Device": "Infinix-X624",
    "Model": "Infinix X624"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "HOT 7",
    "Device": "Infinix-X624B",
    "Model": "Infinix X624B"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "HOT 7 PRO",
    "Device": "Infinix-X625",
    "Model": "Infinix X625B"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "HOT 7 PRO",
    "Device": "Infinix-X625D",
    "Model": "Infinix X625D"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "HOT 8",
    "Device": "Infinix-X650B",
    "Model": "Infinix X650B"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "HOT 8",
    "Device": "Infinix-X650C",
    "Model": "Infinix X650C"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "HOT 8",
    "Device": "Infinix-X650D",
    "Model": "Infinix X650D"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "HOT 8 Lite",
    "Device": "Infinix-X650",
    "Model": "Infinix X650"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "HOT NOTE",
    "Device": "Infinix-X551",
    "Model": "Infinix-X551"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "HOT Play",
    "Device": "Infinix-X688B",
    "Model": "Infinix X688B"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "HOT Play",
    "Device": "Infinix-X688C",
    "Model": "Infinix X688C"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "HOT S3",
    "Device": "Infinix-X573",
    "Model": "Infinix X573"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "HOT S3",
    "Device": "Infinix-X573",
    "Model": "Infinix X573S"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "HOT S3",
    "Device": "Infinix-X573B",
    "Model": "Infinix X573B"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "HOT S3X",
    "Device": "Infinix-X622",
    "Model": "Infinix X622"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "HOT5",
    "Device": "Infinix-X559C",
    "Model": "Infinix X559C"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "HOT5",
    "Device": "Infinix-X559C",
    "Model": "Infinix X559F"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "HOT5 Lite",
    "Device": "Infinix-X559",
    "Model": "Infinix X559"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "HOT5 Lite",
    "Device": "X557",
    "Model": "Infinix HOT 4"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "Hot 4 Pro",
    "Device": "Infinix-X5511-13M",
    "Model": "Infinix HOT 4 Pro"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "Infinix Google TV",
    "Device": "kualakai",
    "Model": "Infinix Google TV"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "Infinix HOT 10 Lite",
    "Device": "Infinix-X657B",
    "Model": "Infinix X657B"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "Infinix HOT 10S",
    "Device": "Infinix-X689",
    "Model": "Infinix X689"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "Infinix HOT 10S",
    "Device": "Infinix-X689B",
    "Model": "Infinix X689B"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "Infinix HOT 10S NFC",
    "Device": "Infinix-X689D",
    "Model": "Infinix X689D"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "Infinix HOT 10T",
    "Device": "Infinix-X689C",
    "Model": "Infinix X689C"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "Infinix HOT 10i",
    "Device": "Infinix-PR652B",
    "Model": "Infinix PR652B"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "Infinix HOT 10i",
    "Device": "Infinix-PR652C",
    "Model": "Infinix PR652C"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "Infinix HOT 11S NFC",
    "Device": "Infinix-X6812B",
    "Model": "Infinix X6812B"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "Infinix HOT 12",
    "Device": "Infinix-X6817",
    "Model": "Infinix X6817"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "Infinix HOT 12 PRO",
    "Device": "Infinix-X668",
    "Model": "Infinix X668"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "Infinix HOT 12 PRO",
    "Device": "Infinix-X668C",
    "Model": "Infinix X668C"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "Infinix HOT 12 Play",
    "Device": "Infinix-X6816C",
    "Model": "Infinix X6816C"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "Infinix HOT 12 Play NFC",
    "Device": "Infinix-X6816D",
    "Model": "Infinix X6816D"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "Infinix HOT 20",
    "Device": "Infinix-X6826",
    "Model": "Infinix X6826"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "Infinix HOT 20",
    "Device": "Infinix-X6826B",
    "Model": "Infinix X6826B"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "Infinix HOT 20",
    "Device": "Infinix-X6826C",
    "Model": "Infinix X6826C"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "Infinix HOT 30 PLAY",
    "Device": "Infinix-X6835",
    "Model": "Infinix X6835"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "Infinix HOT 30 PLAY",
    "Device": "Infinix-X6835B",
    "Model": "Infinix X6835B"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "Infinix HOT 30i",
    "Device": "Infinix-X669",
    "Model": "Infinix X669"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "Infinix HOT 30i",
    "Device": "Infinix-X669C",
    "Model": "Infinix X669C"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "Infinix HOT 30i",
    "Device": "Infinix-X669D",
    "Model": "Infinix X669D"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "Infinix HOT 40",
    "Device": "Infinix-X6836",
    "Model": "Infinix X6836"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "Infinix HOT 40 Pro",
    "Device": "Infinix-X6837",
    "Model": "Infinix X6837"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "Infinix HOT 40i",
    "Device": "Infinix-X6528",
    "Model": "Infinix X6528"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "Infinix HOT 40i",
    "Device": "Infinix-X6528B",
    "Model": "Infinix X6528B"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "Infinix HOT 50",
    "Device": "Infinix-X6882",
    "Model": "Infinix X6882"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "Infinix HOT 50",
    "Device": "Infinix-X6882B",
    "Model": "Infinix X6882B"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "Infinix HOT 50 5G",
    "Device": "Infinix-X6720",
    "Model": "Infinix X6720"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "Infinix HOT 50 5G",
    "Device": "Infinix-X6720B",
    "Model": "Infinix X6720B"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "Infinix HOT 50 Pro",
    "Device": "Infinix-X6881",
    "Model": "Infinix X6881"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "Infinix HOT 50i",
    "Device": "Infinix-X6531",
    "Model": "Infinix X6531"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "Infinix HOT 50i",
    "Device": "Infinix-X6531B",
    "Model": "Infinix X6531B"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "Infinix HOT 60 Pro",
    "Device": "Infinix-X6885",
    "Model": "Infinix X6885"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "Infinix HOT 60i",
    "Device": "Infinix-X6728",
    "Model": "Infinix X6728"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "Infinix HOT 60i",
    "Device": "Infinix-X6728B",
    "Model": "Infinix X6728B"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "Infinix HOT 6X",
    "Device": "Infinix-X623",
    "Model": "Infinix X623"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "Infinix HOT 6X",
    "Device": "Infinix-X623",
    "Model": "Infinix X623B"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "Infinix HOT 7",
    "Device": "Infinix-X625C",
    "Model": "Infinix X625C"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "Infinix HOT 7 pro",
    "Device": "Infinix-X625C",
    "Model": "Infinix X625C"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "Infinix HOT 70",
    "Device": "Infinix-X6895",
    "Model": "Infinix X6895"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "Infinix HOT 70",
    "Device": "Infinix-X6895B",
    "Model": "Infinix X6895B"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "Infinix HOT 9",
    "Device": "Infinix-X655",
    "Model": "Infinix X655"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "Infinix HOT 9",
    "Device": "Infinix-X655C",
    "Model": "Infinix X655C"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "Infinix HOT 9",
    "Device": "Infinix-X655D",
    "Model": "Infinix X655D"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "Infinix HOT 9 Play",
    "Device": "Infinix-X680",
    "Model": "Infinix X680"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "Infinix HOT 9 Play",
    "Device": "Infinix-X680B",
    "Model": "Infinix X680B"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "Infinix HOT 9 Play",
    "Device": "Infinix-X680C",
    "Model": "Infinix X680C"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "Infinix HOT 9 Play",
    "Device": "Infinix-X680E",
    "Model": "Infinix X680E"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "Infinix HOT 9 Play",
    "Device": "Infinix-X680F",
    "Model": "Infinix X680F"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "Infinix HOT 9 Pro",
    "Device": "Infinix-X655F",
    "Model": "Infinix X655F"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "Infinix NOTE 10",
    "Device": "Infinix-X693",
    "Model": "Infinix X693"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "Infinix NOTE 11",
    "Device": "Infinix-X663B",
    "Model": "Infinix X663B"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "Infinix NOTE 11i",
    "Device": "Infinix-X693",
    "Model": "Infinix X693"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "Infinix NOTE 12",
    "Device": "Infinix-X663C",
    "Model": "Infinix X663C"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "Infinix NOTE 12 2023",
    "Device": "Infinix-X676C",
    "Model": "Infinix X676C"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "Infinix NOTE 12 5G",
    "Device": "Infinix-X671",
    "Model": "Infinix X671"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "Infinix NOTE 12 PRO",
    "Device": "Infinix-X676B",
    "Model": "Infinix X676B"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "Infinix NOTE 12 Pro 5G",
    "Device": "Infinix-X671B",
    "Model": "Infinix X671B"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "Infinix NOTE 12i",
    "Device": "Infinix-X6819",
    "Model": "Infinix X6819"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "Infinix NOTE 30",
    "Device": "Infinix-X6833B",
    "Model": "Infinix X6833B"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "Infinix NOTE 30 5G",
    "Device": "Infinix-X6711",
    "Model": "Infinix X6711"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "Infinix NOTE 40",
    "Device": "Infinix-X6853",
    "Model": "Infinix X6853"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "Infinix NOTE 40 5G",
    "Device": "Infinix-X6852",
    "Model": "Infinix X6852"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "Infinix NOTE 40 Pro",
    "Device": "Infinix-X6850",
    "Model": "Infinix X6850"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "Infinix NOTE 40 Pro 5G",
    "Device": "Infinix-X6851",
    "Model": "Infinix X6851"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "Infinix NOTE 40S",
    "Device": "Infinix-X6850B",
    "Model": "Infinix X6850B"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "Infinix NOTE 40X 5G",
    "Device": "Infinix-X6838",
    "Model": "Infinix X6838"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "Infinix NOTE 5",
    "Device": "Infinix-X604_sprout",
    "Model": "Infinix X604"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "Infinix NOTE 5",
    "Device": "Infinix-X604_sprout",
    "Model": "Infinix X604B"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "Infinix NOTE 5 Stylus",
    "Device": "Infinix-X605_sprout",
    "Model": "Infinix X605"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "Infinix NOTE 50S 5G",
    "Device": "Infinix-X6870",
    "Model": "Infinix X6870"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "Infinix NOTE 60",
    "Device": "Infinix-X6879",
    "Model": "Infinix X6879"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "Infinix NOTE 60 Ultra",
    "Device": "Infinix-X6877",
    "Model": "Infinix X6877"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "Infinix NOTE 7 Lite",
    "Device": "Infinix-X656",
    "Model": "Infinix X656"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "Infinix Note 5",
    "Device": "Infinix-X604_sprout",
    "Model": "Infinix X604"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "Infinix Note 5",
    "Device": "Infinix-X604_sprout",
    "Model": "Infinix X604B"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "Infinix SMART 10",
    "Device": "Infinix-X6725",
    "Model": "Infinix X6725"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "Infinix SMART 10",
    "Device": "Infinix-X6725D",
    "Model": "Infinix X6725D"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "Infinix SMART 10 HD",
    "Device": "Infinix-X6525D",
    "Model": "Infinix X6525D"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "Infinix SMART 4",
    "Device": "Infinix-X680",
    "Model": "Infinix X680"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "Infinix SMART 4 Plus",
    "Device": "Infinix-X680D",
    "Model": "Infinix X680D"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "Infinix SMART 7",
    "Device": "Infinix-X6515",
    "Model": "Infinix X6515"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "Infinix SMART 7 HD",
    "Device": "Infinix-X6516",
    "Model": "Infinix X6516"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "Infinix SMART 8",
    "Device": "Infinix-X6525",
    "Model": "Infinix X6525"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "Infinix SMART 8",
    "Device": "Infinix-X6525D",
    "Model": "Infinix X6525D"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "Infinix SMART 8 HD",
    "Device": "Infinix-X6525",
    "Model": "Infinix X6525"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "Infinix SMART 8 PRO",
    "Device": "Infinix-X6525B",
    "Model": "Infinix X6525B"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "Infinix SMART 8 Plus",
    "Device": "Infinix-X6526",
    "Model": "Infinix X6526"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "Infinix SMART 8 Pro",
    "Device": "Infinix-X6525B",
    "Model": "Infinix X6525B"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "Infinix SMART 9 HD",
    "Device": "Infinix-X6532C",
    "Model": "Infinix X6532C"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "Infinix X5010",
    "Device": "Infinix-X5010",
    "Model": "Infinix X5010"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "Infinix X510",
    "Device": "Infinix_X510_sprout",
    "Model": "Infinix X510"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "Infinix X559",
    "Device": "Infinix-X559",
    "Model": "Infinix X559"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "Infinix X571",
    "Device": "Infinix-X571",
    "Model": "Infinix X571"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "Infinix X572",
    "Device": "Infinix-X572",
    "Model": "Infinix X572"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "Infinix XPAD 20 Edge",
    "Device": "Infinix-X1302",
    "Model": "Infinix X1302"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "Infinix XPAD 20 Slim",
    "Device": "Infinix-X1302",
    "Model": "Infinix X1302"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "Infinix ZERO 20",
    "Device": "Infinix-X6821",
    "Model": "Infinix X6821"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "Infinix ZERO 30",
    "Device": "Infinix-X6731B",
    "Model": "Infinix X6731B"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "Infinix ZERO 40",
    "Device": "Infinix-X6860",
    "Model": "Infinix X6860"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "Infinix ZERO 40 5G",
    "Device": "Infinix-X6861",
    "Model": "Infinix X6861"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "Infinix ZERO 5G",
    "Device": "Infinix-X6815B",
    "Model": "Infinix X6815B"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "Infinix ZERO 8i",
    "Device": "Infinix-X687B",
    "Model": "Infinix X687B"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "Infinix ZERO Flip",
    "Device": "Infinix-X6962",
    "Model": "Infinix X6962"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "Infinix ZERO X",
    "Device": "Infinix-X6811B",
    "Model": "Infinix X6811B"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "Infinix ZERO X NEO",
    "Device": "Infinix-X6810",
    "Model": "Infinix X6810"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "Infinix ZERO X Pro",
    "Device": "Infinix-X6811",
    "Model": "Infinix X6811"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "Infinix ZERO8",
    "Device": "Infinix-X687",
    "Model": "Infinix X687"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "NOTE",
    "Device": "Infinix-X663",
    "Model": "Infinix X663"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "NOTE 10 Pro",
    "Device": "Infinix-X695",
    "Model": "Infinix X695"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "NOTE 10 Pro",
    "Device": "Infinix-X695C",
    "Model": "Infinix X695C"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "NOTE 10 Pro",
    "Device": "Infinix-X695D",
    "Model": "Infinix X695D"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "NOTE 11 Pro",
    "Device": "Infinix-X697",
    "Model": "Infinix X697"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "NOTE 11S",
    "Device": "Infinix-X698",
    "Model": "Infinix X698"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "NOTE 12",
    "Device": "Infinix-X670",
    "Model": "Infinix X670"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "NOTE 12 VIP",
    "Device": "Infinix-X672",
    "Model": "Infinix X672"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "NOTE 12i 2022",
    "Device": "Infinix-X677",
    "Model": "Infinix X677"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "NOTE 3",
    "Device": "X601",
    "Model": "Infinix NOTE 3"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "NOTE 3 Pro",
    "Device": "X601-3G",
    "Model": "Infinix NOTE 3 Pro"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "NOTE 3 Pro",
    "Device": "X601-LTE",
    "Model": "Infinix NOTE 3 Pro"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "NOTE 3 Pro",
    "Device": "X601-LTE",
    "Model": "Infinix_X601_LTE"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "NOTE 30",
    "Device": "Infinix-X6716B",
    "Model": "Infinix X6716B"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "NOTE 30 Pro",
    "Device": "Infinix-X678B",
    "Model": "Infinix X678B"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "NOTE 30 VIP",
    "Device": "Infinix-X6710",
    "Model": "Infinix X6710"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "NOTE 30i",
    "Device": "Infinix-X6716",
    "Model": "Infinix X6716"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "NOTE 4",
    "Device": "Infinix-X572",
    "Model": "Infinix X572"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "NOTE 4",
    "Device": "Infinix-X572",
    "Model": "Infinix X572-LTE"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "NOTE 4 Pro",
    "Device": "Infinix-X571",
    "Model": "Infinix X571"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "NOTE 4 Pro",
    "Device": "Infinix-X571",
    "Model": "Infinix X571-LTE"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "NOTE 40 Pro+ 5G",
    "Device": "Infinix-X6851B",
    "Model": "Infinix X6851B"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "NOTE 50",
    "Device": "Infinix-X6858",
    "Model": "Infinix X6858"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "NOTE 50 Pro",
    "Device": "Infinix-X6855",
    "Model": "Infinix X6855"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "NOTE 50 Pro+ 5G",
    "Device": "Infinix-X6856",
    "Model": "Infinix X6856"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "NOTE 50X 5G",
    "Device": "Infinix-X6857",
    "Model": "Infinix X6857"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "NOTE 50X 5G",
    "Device": "Infinix-X6857B",
    "Model": "Infinix X6857B"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "NOTE 60 Pro",
    "Device": "Infinix-X6878",
    "Model": "Infinix X6878"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "NOTE 7",
    "Device": "Infinix-X690",
    "Model": "Infinix X690"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "NOTE 7",
    "Device": "Infinix-X690B",
    "Model": "Infinix X690B"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "NOTE 7",
    "Device": "Infinix-X690C",
    "Model": "Infinix X690C"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "NOTE 8",
    "Device": "Infinix-X692",
    "Model": "Infinix X692"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "NOTE 8i",
    "Device": "Infinix-X683",
    "Model": "Infinix X683"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "NOTE 8i",
    "Device": "Infinix-X683B",
    "Model": "Infinix X683B"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "NOTE Edge",
    "Device": "Infinix-X6887",
    "Model": "Infinix X6887"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "Note 6",
    "Device": "Infinix-X610",
    "Model": "Infinix X610B"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "RACE Blot2",
    "Device": "Infinix_X454",
    "Model": "Infinix X454"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "RACE Bolt 3",
    "Device": "X455",
    "Model": "Infinix X455"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "S2",
    "Device": "Infinix-X522",
    "Model": "Infinix S2"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "S2",
    "Device": "Infinix-X522",
    "Model": "Infinix S2 Pro"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "S4",
    "Device": "Infinix-X626",
    "Model": "Infinix X626"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "S4",
    "Device": "Infinix-X626B",
    "Model": "Infinix X626B"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "S4",
    "Device": "Infinix-X626B-LTE",
    "Model": "Infinix X626B LTE"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "S5",
    "Device": "Infinix-X652",
    "Model": "Infinix X652"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "S5",
    "Device": "Infinix-X652A",
    "Model": "Infinix X652A"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "S5 Lite",
    "Device": "Infinix-X652B",
    "Model": "Infinix X652B"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "S5 Lite",
    "Device": "Infinix-X652C",
    "Model": "Infinix X652C"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "S5 Pro",
    "Device": "Infinix-X660",
    "Model": "Infinix X660"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "S5 Pro",
    "Device": "Infinix-X660B",
    "Model": "Infinix X660B"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "S5 Pro",
    "Device": "Infinix-X660C",
    "Model": "Infinix X660C"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "SMART",
    "Device": "Infinix-X657",
    "Model": "Infinix X657"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "SMART",
    "Device": "Infinix-X657B",
    "Model": "Infinix X657B"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "SMART 10 PLUS",
    "Device": "Infinix-X6725B",
    "Model": "Infinix X6725B"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "SMART 10 PLUS",
    "Device": "Infinix-X6725C",
    "Model": "Infinix X6725C"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "SMART 20",
    "Device": "Infinix-X6840",
    "Model": "Infinix X6840"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "SMART 20",
    "Device": "Infinix-X6840B",
    "Model": "Infinix X6840B"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "SMART 5",
    "Device": "Infinix-X657C",
    "Model": "Infinix X657C"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "SMART 5 HD",
    "Device": "Infinix-X6511",
    "Model": "Infinix X6511"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "SMART 5(SMART 6)",
    "Device": "Infinix-X657B",
    "Model": "Infinix X657B"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "SMART 6",
    "Device": "Infinix-X6511",
    "Model": "Infinix X6511"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "SMART 6",
    "Device": "Infinix-X6511B",
    "Model": "Infinix X6511B"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "SMART 6",
    "Device": "Infinix-X6511E",
    "Model": "Infinix X6511E"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "SMART 6 HD",
    "Device": "Infinix-X6512",
    "Model": "Infinix X6512"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "SMART 6 PLUS",
    "Device": "Infinix-X6511G",
    "Model": "Infinix X6511G"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "SMART 6 PLUS",
    "Device": "Infinix-X6823",
    "Model": "Infinix X6823"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "SMART 6 PLUS",
    "Device": "Infinix-X6823C",
    "Model": "Infinix X6823C"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "SMART 7  or SMART 7 PLUS",
    "Device": "Infinix-X6517",
    "Model": "Infinix X6517"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "SMART 8 Plus",
    "Device": "Infinix-X6526",
    "Model": "Infinix X6526"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "SMART 9",
    "Device": "Infinix-X6532",
    "Model": "Infinix X6532"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "SMART HD",
    "Device": "Infinix-X612",
    "Model": "Infinix X612"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "SMART HD",
    "Device": "Infinix-X612B",
    "Model": "Infinix X612B"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "SMRAT 8 PRO",
    "Device": "Infinix-X6525B",
    "Model": "Infinix X6525B"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "SURF 2",
    "Device": "INFINIX_X511",
    "Model": "Infinix X511"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "Smart 2",
    "Device": "Infinix-X5515",
    "Model": "Infinix X5515"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "Smart 2",
    "Device": "Infinix-X5515F",
    "Model": "Infinix X5515F"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "Smart 2",
    "Device": "Infinix-X5515I",
    "Model": "Infinix X5515I"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "Smart 2 HD",
    "Device": "Infinix-X609",
    "Model": "Infinix X609"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "Smart 2 HD",
    "Device": "Infinix-X609B",
    "Model": "Infinix X609B"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "Smart 2 Pro",
    "Device": "Infinix-X5514",
    "Model": "Infinix X5514D"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "Smart 3",
    "Device": "Infinix-X5516",
    "Model": "Infinix X5516"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "Smart 3",
    "Device": "Infinix-X5516B",
    "Model": "Infinix X5516B"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "Smart 3",
    "Device": "Infinix-X5516C",
    "Model": "Infinix X5516C"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "Smart 3 Plus",
    "Device": "Infinix-X627STU",
    "Model": "Infinix X627"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "Smart 3 Plus",
    "Device": "Infinix-X627V",
    "Model": "Infinix X627V"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "Smart 3 Plus",
    "Device": "Infinix-X627W",
    "Model": "Infinix X627W"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "Smart 4",
    "Device": "Infinix-X653",
    "Model": "Infinix X653"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "Smart 4",
    "Device": "Infinix-X653C",
    "Model": "Infinix X653C"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "Smart TV",
    "Device": "longshan",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "X405",
    "Device": "up09_infinix_x405_gms",
    "Model": "Infinix X405"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "X505",
    "Device": "X505",
    "Model": "Infinix X505"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "X521",
    "Device": "Infinix-X521",
    "Model": "Infinix HOT S"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "X521",
    "Device": "Infinix-X521",
    "Model": "Infinix-X521"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "X521",
    "Device": "Infinix-X521",
    "Model": "Infinix-X521-LTE"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "X521",
    "Device": "Infinix-X521",
    "Model": "Infinix_X521"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "X521",
    "Device": "Infinix-X521-3G",
    "Model": "Infinix-X521"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "X521",
    "Device": "Infinix-X521-Pro",
    "Model": "Infinix-X521"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "X521",
    "Device": "Infinix-X521-Pro",
    "Model": "Infinix_X521"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "X521",
    "Device": "Infinix-X521-Pro",
    "Model": "Infinix_X521_LTE"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "X521-H1",
    "Device": "Infinix-X521-Pro",
    "Model": "Infinix-X521"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "X521-H1",
    "Device": "Infinix-X521-Pro",
    "Model": "Infinix_X521"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "X521-I1",
    "Device": "Infinix-X521",
    "Model": "Infinix_X521"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "X521E1",
    "Device": "Infinix-X521",
    "Model": "Infinix HOT S"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "X521E1",
    "Device": "Infinix-X521",
    "Model": "Infinix-X521"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "X521E1",
    "Device": "Infinix-X521",
    "Model": "Infinix_X521"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "X521G1",
    "Device": "Infinix-X521-Pro",
    "Model": "Infinix-X521"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "X521G1",
    "Device": "Infinix-X521-Pro",
    "Model": "Infinix-X521_LTE"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "X521G1",
    "Device": "Infinix-X521-Pro",
    "Model": "Infinix_X521"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "X521S",
    "Device": "Infinix-X521",
    "Model": "Infinix-X521S"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "X521S",
    "Device": "Infinix-X521",
    "Model": "Infinix_X521S"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "X551",
    "Device": "INFINIX-X551",
    "Model": "INFINIX-X551"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "X552",
    "Device": "INFINIX-X552",
    "Model": "Infinix Zero 3"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "X552",
    "Device": "INFINIX-X552",
    "Model": "Infinix-X552"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "X552-C1",
    "Device": "INFINIX-X552",
    "Model": "Infinix-X552"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "X552-E1",
    "Device": "INFINIX-X552-95M",
    "Model": "Infinix Zero 3"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "X552-E1",
    "Device": "INFINIX-X552-95M",
    "Model": "Infinix-X552"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "X552-F1",
    "Device": "INFINIX-X552-95M",
    "Model": "Infinix Zero 3"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "X552-F1",
    "Device": "INFINIX-X552-95M",
    "Model": "Infinix-X552"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "X555",
    "Device": "X555",
    "Model": "Infinix Zero 4"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "X557F1",
    "Device": "X557-Lite",
    "Model": "Infinix HOT 4"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "X572",
    "Device": "Infinix-X572",
    "Model": "Infinix X572"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "X572",
    "Device": "Infinix-X572",
    "Model": "Infinix X572-LTE"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "X600",
    "Device": "INFINIX-X600",
    "Model": "INFINIX-X600"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "X600",
    "Device": "INFINIX-X600-5M",
    "Model": "INFINIX-X600"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "X600",
    "Device": "INFINIX-X600-5M",
    "Model": "Infinix-X600"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "X600",
    "Device": "INFINIX-X600-H533-5M",
    "Model": "Infinix-X600-LTE"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "XPAD",
    "Device": "Infinix-X1101",
    "Model": "Infinix X1101"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "XPAD",
    "Device": "Infinix-X1101B",
    "Model": "Infinix X1101B"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "XPAD 20",
    "Device": "Infinix-X1102",
    "Model": "Infinix X1102"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "XPAD 20 Pro",
    "Device": "Infinix-X1201",
    "Model": "Infinix X1201"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "XPAD 30E",
    "Device": "Infinix-X1102B",
    "Model": "Infinix X1102B"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "ZERO 30 5G",
    "Device": "Infinix-X6731",
    "Model": "Infinix X6731"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "ZERO 5G",
    "Device": "Infinix-X6815",
    "Model": "Infinix X6815"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "ZERO 5G 2023",
    "Device": "Infinix-X6815C",
    "Model": "Infinix X6815C"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "ZERO 5G 2023",
    "Device": "Infinix-X6815D",
    "Model": "Infinix X6815D"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "ZERO ULTRA",
    "Device": "Infinix-X6820",
    "Model": "Infinix X6820"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "ZERO X Pro",
    "Device": "Infinix-X6811",
    "Model": "Infinix X6811"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "Zero 2",
    "Device": "Infinix_X509",
    "Model": "Infinix X509"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "Zero 4",
    "Device": "X555",
    "Model": "Infinix Zero 4"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "Zero 4 Plus",
    "Device": "X602",
    "Model": "Infinix Zero 4 Plus"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "Zero 5",
    "Device": "Infinix-X603",
    "Model": "Infinix X603"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "Zero 5 Pro",
    "Device": "Infinix-X603",
    "Model": "Infinix X603"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "Zero 5 Pro",
    "Device": "Infinix-X603",
    "Model": "Infinix X603-LTE"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "Zero 6",
    "Device": "Infinix-X620",
    "Model": "Infinix X620B"
  },
  {
    "Retail Branding": "Infinix",
    "Marketing Name": "Zero 6 Pro",
    "Device": "Infinix-X620",
    "Model": "Infinix X620"
  },
  {
    "Retail Branding": "Infocus",
    "Marketing Name": "A1S",
    "Device": "AE2",
    "Model": "InFocus M505"
  },
  {
    "Retail Branding": "Infocus",
    "Marketing Name": "Amazing A8",
    "Device": "D78",
    "Model": "Amazing A8"
  },
  {
    "Retail Branding": "Infocus",
    "Marketing Name": "Apex Challenger",
    "Device": "tianshan",
    "Model": "IN3048SL"
  },
  {
    "Retail Branding": "Infocus",
    "Marketing Name": "Apex Master",
    "Device": "tianshan",
    "Model": "IN3058SL"
  },
  {
    "Retail Branding": "Infocus",
    "Marketing Name": "Big Tab",
    "Device": "IF195a",
    "Model": "IF195a"
  },
  {
    "Retail Branding": "Infocus",
    "Marketing Name": "Big Tab",
    "Device": "IF236a",
    "Model": "IF236a"
  },
  {
    "Retail Branding": "Infocus",
    "Marketing Name": "C7",
    "Device": "C2107",
    "Model": "C2107"
  },
  {
    "Retail Branding": "Infocus",
    "Marketing Name": "CS1 8.0",
    "Device": "cs180",
    "Model": "CS180"
  },
  {
    "Retail Branding": "Infocus",
    "Marketing Name": "Epic 1",
    "Device": "JGZ",
    "Model": "TSP"
  },
  {
    "Retail Branding": "Infocus",
    "Marketing Name": "FP-U320-INF-WLTW",
    "Device": "U320-WF",
    "Model": "FP-U320-INF-WLTW"
  },
  {
    "Retail Branding": "Infocus",
    "Marketing Name": "IF9001",
    "Device": "AA2",
    "Model": "IF9001"
  },
  {
    "Retail Branding": "Infocus",
    "Marketing Name": "IF9002",
    "Device": "AB2",
    "Model": "IF9002"
  },
  {
    "Retail Branding": "Infocus",
    "Marketing Name": "IF9007",
    "Device": "AG2",
    "Model": "IF9007"
  },
  {
    "Retail Branding": "Infocus",
    "Marketing Name": "IF9007",
    "Device": "AG5",
    "Model": "IF9007"
  },
  {
    "Retail Branding": "Infocus",
    "Marketing Name": "IF9021",
    "Device": "AU8",
    "Model": "IF9021"
  },
  {
    "Retail Branding": "Infocus",
    "Marketing Name": "IF9035_IN",
    "Device": "A62",
    "Model": "IF9035"
  },
  {
    "Retail Branding": "Infocus",
    "Marketing Name": "IF9035_IN",
    "Device": "A62_mini",
    "Model": "IF9035"
  },
  {
    "Retail Branding": "Infocus",
    "Marketing Name": "IN260",
    "Device": "IN260",
    "Model": "IN260"
  },
  {
    "Retail Branding": "Infocus",
    "Marketing Name": "IN335",
    "Device": "IVM",
    "Model": "IN335"
  },
  {
    "Retail Branding": "Infocus",
    "Marketing Name": "IN610",
    "Device": "MG2",
    "Model": "IN610"
  },
  {
    "Retail Branding": "Infocus",
    "Marketing Name": "IN810",
    "Device": "VKY",
    "Model": "IN810"
  },
  {
    "Retail Branding": "Infocus",
    "Marketing Name": "IN815",
    "Device": "VK3",
    "Model": "IN815"
  },
  {
    "Retail Branding": "Infocus",
    "Marketing Name": "InFocus M6S",
    "Device": "AH2",
    "Model": "IF9003"
  },
  {
    "Retail Branding": "Infocus",
    "Marketing Name": "InFocus M7 Lite",
    "Device": "A02",
    "Model": "IF9031"
  },
  {
    "Retail Branding": "Infocus",
    "Marketing Name": "InFocus M7S",
    "Device": "A08",
    "Model": "IF9031"
  },
  {
    "Retail Branding": "Infocus",
    "Marketing Name": "JTouch 13e",
    "Device": "D014",
    "Model": "JTouch_Series_13ea"
  },
  {
    "Retail Branding": "Infocus",
    "Marketing Name": "JTouch 13e",
    "Device": "D014",
    "Model": "JTouch_Series_13eb"
  },
  {
    "Retail Branding": "Infocus",
    "Marketing Name": "JTouch Series 13",
    "Device": "D011",
    "Model": "JTouch_Series_13"
  },
  {
    "Retail Branding": "Infocus",
    "Marketing Name": "LE5039",
    "Device": "BX2",
    "Model": "LE5039"
  },
  {
    "Retail Branding": "Infocus",
    "Marketing Name": "M2",
    "Device": "LSO",
    "Model": "InFocus M2"
  },
  {
    "Retail Branding": "Infocus",
    "Marketing Name": "M2+",
    "Device": "LSC",
    "Model": "InFocus M2PLUS"
  },
  {
    "Retail Branding": "Infocus",
    "Marketing Name": "M210",
    "Device": "M210",
    "Model": "M210"
  },
  {
    "Retail Branding": "Infocus",
    "Marketing Name": "M260",
    "Device": "ZL2",
    "Model": "InFocus M260"
  },
  {
    "Retail Branding": "Infocus",
    "Marketing Name": "M2_3G",
    "Device": "G10",
    "Model": "InFocus M2_3G"
  },
  {
    "Retail Branding": "Infocus",
    "Marketing Name": "M310",
    "Device": "H1W",
    "Model": "InFocus M310"
  },
  {
    "Retail Branding": "Infocus",
    "Marketing Name": "M320",
    "Device": "M320",
    "Model": "InFocus M320"
  },
  {
    "Retail Branding": "Infocus",
    "Marketing Name": "M320e",
    "Device": "M320e",
    "Model": "InFocus M320e"
  },
  {
    "Retail Branding": "Infocus",
    "Marketing Name": "M320m",
    "Device": "M320m",
    "Model": "InFocus M320m"
  },
  {
    "Retail Branding": "Infocus",
    "Marketing Name": "M320u",
    "Device": "M320",
    "Model": "InFocus M320u"
  },
  {
    "Retail Branding": "Infocus",
    "Marketing Name": "M330",
    "Device": "D77",
    "Model": "InFocus M330"
  },
  {
    "Retail Branding": "Infocus",
    "Marketing Name": "M350",
    "Device": "G30",
    "Model": "InFocus M350"
  },
  {
    "Retail Branding": "Infocus",
    "Marketing Name": "M350",
    "Device": "G3E",
    "Model": "InFocus M350"
  },
  {
    "Retail Branding": "Infocus",
    "Marketing Name": "M370",
    "Device": "FOT",
    "Model": "M370"
  },
  {
    "Retail Branding": "Infocus",
    "Marketing Name": "M370i",
    "Device": "FAT",
    "Model": "M370i"
  },
  {
    "Retail Branding": "Infocus",
    "Marketing Name": "M372",
    "Device": "FOT",
    "Model": "M372"
  },
  {
    "Retail Branding": "Infocus",
    "Marketing Name": "M377",
    "Device": "FO7",
    "Model": "M377"
  },
  {
    "Retail Branding": "Infocus",
    "Marketing Name": "M415",
    "Device": "ZL3",
    "Model": "InFocus M415"
  },
  {
    "Retail Branding": "Infocus",
    "Marketing Name": "M425",
    "Device": "HGO",
    "Model": "InFocus M425"
  },
  {
    "Retail Branding": "Infocus",
    "Marketing Name": "M430",
    "Device": "HGO",
    "Model": "InFocus M430"
  },
  {
    "Retail Branding": "Infocus",
    "Marketing Name": "M460",
    "Device": "G3T",
    "Model": "InFocus M460"
  },
  {
    "Retail Branding": "Infocus",
    "Marketing Name": "M500",
    "Device": "InFocus_M500",
    "Model": "InFocus M500"
  },
  {
    "Retail Branding": "Infocus",
    "Marketing Name": "M510",
    "Device": "TID_CHT",
    "Model": "M510"
  },
  {
    "Retail Branding": "Infocus",
    "Marketing Name": "M510t",
    "Device": "TID",
    "Model": "InFocus M510t"
  },
  {
    "Retail Branding": "Infocus",
    "Marketing Name": "M511",
    "Device": "TID_CHT",
    "Model": "M510"
  },
  {
    "Retail Branding": "Infocus",
    "Marketing Name": "M511",
    "Device": "TID_TWN",
    "Model": "M511"
  },
  {
    "Retail Branding": "Infocus",
    "Marketing Name": "M512",
    "Device": "MC2_CN",
    "Model": "InFocus M512"
  },
  {
    "Retail Branding": "Infocus",
    "Marketing Name": "M512",
    "Device": "MC2_CN",
    "Model": "M512"
  },
  {
    "Retail Branding": "Infocus",
    "Marketing Name": "M518",
    "Device": "MC2_APT",
    "Model": "M518"
  },
  {
    "Retail Branding": "Infocus",
    "Marketing Name": "M530",
    "Device": "G20",
    "Model": "InFocus M530"
  },
  {
    "Retail Branding": "Infocus",
    "Marketing Name": "M535",
    "Device": "G40",
    "Model": "InFocus M535"
  },
  {
    "Retail Branding": "Infocus",
    "Marketing Name": "M535_00WW",
    "Device": "G40",
    "Model": "InFocus M535"
  },
  {
    "Retail Branding": "Infocus",
    "Marketing Name": "M550",
    "Device": "ZZ1",
    "Model": "InFocus M550"
  },
  {
    "Retail Branding": "Infocus",
    "Marketing Name": "M550 3D",
    "Device": "ZD1",
    "Model": "InFocus M550 3D"
  },
  {
    "Retail Branding": "Infocus",
    "Marketing Name": "M560",
    "Device": "ZM1",
    "Model": "InFocus M560"
  },
  {
    "Retail Branding": "Infocus",
    "Marketing Name": "M5s",
    "Device": "AB5",
    "Model": "IF9002"
  },
  {
    "Retail Branding": "Infocus",
    "Marketing Name": "M680",
    "Device": "G42",
    "Model": "InFocus M680"
  },
  {
    "Retail Branding": "Infocus",
    "Marketing Name": "M808",
    "Device": "ZM1",
    "Model": "InFocus M808"
  },
  {
    "Retail Branding": "Infocus",
    "Marketing Name": "M808i",
    "Device": "ZM1",
    "Model": "InFocus M808i"
  },
  {
    "Retail Branding": "Infocus",
    "Marketing Name": "M810",
    "Device": "VNA",
    "Model": "InFocus M810"
  },
  {
    "Retail Branding": "Infocus",
    "Marketing Name": "M810t",
    "Device": "VNA",
    "Model": "InFocus M810t"
  },
  {
    "Retail Branding": "Infocus",
    "Marketing Name": "M812",
    "Device": "VN2",
    "Model": "InFocus M812"
  },
  {
    "Retail Branding": "Infocus",
    "Marketing Name": "M812A",
    "Device": "VN2",
    "Model": "InFocus M812A"
  },
  {
    "Retail Branding": "Infocus",
    "Marketing Name": "M812i",
    "Device": "V2I",
    "Model": "InFocus M812i"
  },
  {
    "Retail Branding": "Infocus",
    "Marketing Name": "MADA",
    "Device": "A62_mini",
    "Model": "IF9035"
  },
  {
    "Retail Branding": "Infocus",
    "Marketing Name": "MEGA 3",
    "Device": "BX2",
    "Model": "LE5039"
  },
  {
    "Retail Branding": "Infocus",
    "Marketing Name": "Mega 3B",
    "Device": "BW2",
    "Model": "LE0139I"
  },
  {
    "Retail Branding": "Infocus",
    "Marketing Name": "NewTab F1",
    "Device": "f1",
    "Model": "NewTab F1"
  },
  {
    "Retail Branding": "Infocus",
    "Marketing Name": "Smart503",
    "Device": "MC2",
    "Model": "Smart503"
  },
  {
    "Retail Branding": "Infocus",
    "Marketing Name": "T3000",
    "Device": "P7M",
    "Model": "T3000"
  },
  {
    "Retail Branding": "Infocus",
    "Marketing Name": "UHD Android TV",
    "Device": "sindorim",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "Infocus",
    "Marketing Name": "VZH",
    "Device": "VZH",
    "Model": "VZH"
  },
  {
    "Retail Branding": "Infocus",
    "Marketing Name": "VZU",
    "Device": "VZH",
    "Model": "VZU"
  },
  {
    "Retail Branding": "Infocus",
    "Marketing Name": "Vision 3 Lite",
    "Device": "BU2",
    "Model": "IF9008"
  },
  {
    "Retail Branding": "Infocus",
    "Marketing Name": "Vision 3 Pro",
    "Device": "AY2",
    "Model": "IF9029"
  },
  {
    "Retail Branding": "Infocus",
    "Marketing Name": "XT-50IP600",
    "Device": "XT_50IP600",
    "Model": "XT_50IP600"
  },
  {
    "Retail Branding": "Ingenico",
    "Marketing Name": "AXIUM D7",
    "Device": "axium",
    "Model": "IngenicoAxium"
  },
  {
    "Retail Branding": "Ingenico",
    "Marketing Name": "AXIUM NX8",
    "Device": "ing_17",
    "Model": "NX8"
  },
  {
    "Retail Branding": "Ingenico",
    "Marketing Name": "Moby-M100",
    "Device": "Moby-M100",
    "Model": "Moby-M100"
  },
  {
    "Retail Branding": "Ingenico",
    "Marketing Name": "Moby-M120",
    "Device": "Moby-M120",
    "Model": "Moby-M120"
  },
  {
    "Retail Branding": "Ingenico",
    "Marketing Name": "Moby-M70",
    "Device": "Moby-M70",
    "Model": "IMS-M70-V02"
  },
  {
    "Retail Branding": "Ingenico",
    "Marketing Name": "Moby-M70",
    "Device": "Moby-M70",
    "Model": "Moby-M70"
  },
  {
    "Retail Branding": "Ingenico",
    "Marketing Name": "Moby-M70g",
    "Device": "Moby-M70g",
    "Model": "IMS-M70-V03"
  },
  {
    "Retail Branding": "Inhon",
    "Marketing Name": "E30",
    "Device": "E30",
    "Model": "E30"
  },
  {
    "Retail Branding": "Inhon",
    "Marketing Name": "L35",
    "Device": "L35",
    "Model": "L35"
  },
  {
    "Retail Branding": "Inhon",
    "Marketing Name": "L36",
    "Device": "L36",
    "Model": "L36"
  },
  {
    "Retail Branding": "Inhon",
    "Marketing Name": "L50",
    "Device": "INHON_L50",
    "Model": "L50"
  },
  {
    "Retail Branding": "Inhon",
    "Marketing Name": "L55",
    "Device": "L55",
    "Model": "L55"
  },
  {
    "Retail Branding": "Inhon",
    "Marketing Name": "V6",
    "Device": "V6",
    "Model": "Inhon_V6"
  },
  {
    "Retail Branding": "Innjoo",
    "Marketing Name": 3,
    "Device": "InnJoo_3",
    "Model": "InnJoo_3"
  },
  {
    "Retail Branding": "Innjoo",
    "Marketing Name": "Elite Dual",
    "Device": "Fire_5_LTE",
    "Model": "Fire_5_LTE"
  },
  {
    "Retail Branding": "Innjoo",
    "Marketing Name": "F102",
    "Device": "F102",
    "Model": "F102"
  },
  {
    "Retail Branding": "Innjoo",
    "Marketing Name": "F104",
    "Device": "F104",
    "Model": "F104"
  },
  {
    "Retail Branding": "Innjoo",
    "Marketing Name": "F106",
    "Device": "F106",
    "Model": "F106"
  },
  {
    "Retail Branding": "Innjoo",
    "Marketing Name": "F106_Plus",
    "Device": "F106_Plus",
    "Model": "F106_Plus"
  },
  {
    "Retail Branding": "Innjoo",
    "Marketing Name": "F5",
    "Device": "F5",
    "Model": "F5"
  },
  {
    "Retail Branding": "Innjoo",
    "Marketing Name": "F702",
    "Device": "F702",
    "Model": "F702"
  },
  {
    "Retail Branding": "Innjoo",
    "Marketing Name": "Fire 4",
    "Device": "Fire_4",
    "Model": "Fire 4"
  },
  {
    "Retail Branding": "Innjoo",
    "Marketing Name": "Fire 4 Plus",
    "Device": "Fire_4_Plus",
    "Model": "Fire 4 Plus"
  },
  {
    "Retail Branding": "Innjoo",
    "Marketing Name": "Fire 4 Pro",
    "Device": "Fire_4_Pro",
    "Model": "Fire 4 Pro"
  },
  {
    "Retail Branding": "Innjoo",
    "Marketing Name": "Halo 4 LTE",
    "Device": "Halo_4_LTE",
    "Model": "Halo 4 LTE"
  },
  {
    "Retail Branding": "Innjoo",
    "Marketing Name": "Halo 5 3 G",
    "Device": "Halo_5_3G",
    "Model": "Halo 5 3G"
  },
  {
    "Retail Branding": "Innjoo",
    "Marketing Name": "Halo2 3G",
    "Device": "Halo2_3G",
    "Model": "Halo2 3G"
  },
  {
    "Retail Branding": "Innjoo",
    "Marketing Name": "Halo2 LTE",
    "Device": "Halo2_LTE",
    "Model": "Halo2 LTE"
  },
  {
    "Retail Branding": "Innjoo",
    "Marketing Name": "Halo4 mini LTE",
    "Device": "Halo_4_mini_LTE",
    "Model": "Halo_4_mini_LTE"
  },
  {
    "Retail Branding": "Innjoo",
    "Marketing Name": "InnJoo-5",
    "Device": "InnJoo-5",
    "Model": "InnJoo-5"
  },
  {
    "Retail Branding": "Innjoo",
    "Marketing Name": "Max 4 Pro",
    "Device": "Max_4_Pro",
    "Model": "Max 4 Pro"
  },
  {
    "Retail Branding": "Innjoo",
    "Marketing Name": "Max3 LTE",
    "Device": "Max3_LTE",
    "Model": "Max3_LTE"
  },
  {
    "Retail Branding": "Innjoo",
    "Marketing Name": "Superb",
    "Device": "Superb",
    "Model": "Superb"
  },
  {
    "Retail Branding": "Innjoo",
    "Marketing Name": "VISION LTE",
    "Device": "VISION_LTE",
    "Model": "VISION LTE"
  },
  {
    "Retail Branding": "Innjoo",
    "Marketing Name": "VOOM_TAB_LTE",
    "Device": "VOOM_TAB_LTE",
    "Model": "VOOM_TAB_LTE"
  },
  {
    "Retail Branding": "Innopia",
    "Marketing Name": "IMTCTATV01",
    "Device": "IMTCTATV01",
    "Model": "IMTCTATV01"
  },
  {
    "Retail Branding": "Innopia",
    "Marketing Name": "INNOPIA",
    "Device": "IMTM4000R",
    "Model": "IMTM4000R"
  },
  {
    "Retail Branding": "Innopia",
    "Marketing Name": "KCTV",
    "Device": "IMTM5000R",
    "Model": "IMTM5000R"
  },
  {
    "Retail Branding": "Innowi",
    "Marketing Name": "mbadge",
    "Device": "CB_UWA6N4C_47",
    "Model": "mbadge"
  },
  {
    "Retail Branding": "Inovacel",
    "Marketing Name": "DX778Pro",
    "Device": "DX778Pro",
    "Model": "DX778Pro"
  },
  {
    "Retail Branding": "Inovacel",
    "Marketing Name": "INOVACEL S24",
    "Device": "S24",
    "Model": "S24"
  },
  {
    "Retail Branding": "Inrico",
    "Marketing Name": "IRC200",
    "Device": "IRC200",
    "Model": "Intelligent_Multi-mode_Radio"
  },
  {
    "Retail Branding": "Inrico",
    "Marketing Name": "IRC200EU",
    "Device": "IRC200EU",
    "Model": "Intelligent_Multi-mode_Radio"
  },
  {
    "Retail Branding": "Inrico",
    "Marketing Name": "S300Plus",
    "Device": "S300Plus",
    "Model": "S300Plus"
  },
  {
    "Retail Branding": "Inrico",
    "Marketing Name": "S300Pro",
    "Device": "S300Pro",
    "Model": "S300Pro"
  },
  {
    "Retail Branding": "Inrico",
    "Marketing Name": "S350",
    "Device": "S350",
    "Model": "S350"
  },
  {
    "Retail Branding": "InsGraf_Digital",
    "Marketing Name": "TWBXXX24A",
    "Device": "TWBXXX24A",
    "Model": "TWBXXX24A"
  },
  {
    "Retail Branding": "Insignia",
    "Marketing Name": "FLEX 8’’ LTE Android Tablet",
    "Device": "ns_15t8lte",
    "Model": "NS-15T8LTE"
  },
  {
    "Retail Branding": "Insignia",
    "Marketing Name": "Flex 10.1",
    "Device": "ns_14t004",
    "Model": "NS-14T004"
  },
  {
    "Retail Branding": "Insignia",
    "Marketing Name": "Flex 8",
    "Device": "ns_15at08",
    "Model": "NS-15AT08"
  },
  {
    "Retail Branding": "Insignia",
    "Marketing Name": "MID7802RA",
    "Device": "MID7802RA",
    "Model": "NS-P16AT785HD"
  },
  {
    "Retail Branding": "Insignia",
    "Marketing Name": "NS-14T002",
    "Device": "ns_14t002",
    "Model": "NS-14T002"
  },
  {
    "Retail Branding": "Insignia",
    "Marketing Name": "NS-15AT07",
    "Device": "NS-15AT07",
    "Model": "NS-15AT07"
  },
  {
    "Retail Branding": "Insignia",
    "Marketing Name": "NS-15AT10",
    "Device": "TA120",
    "Model": "NS-15AT10"
  },
  {
    "Retail Branding": "Insignia",
    "Marketing Name": "NS-P08A7100",
    "Device": "NS-P08A7100",
    "Model": "NS-P08A7100"
  },
  {
    "Retail Branding": "Insignia",
    "Marketing Name": "NS-P10A6100",
    "Device": "NS-P10A6100",
    "Model": "NS-P10A6100"
  },
  {
    "Retail Branding": "Insignia",
    "Marketing Name": "NS-P10A7100",
    "Device": "NS-P10A7100",
    "Model": "NS-P10A7100"
  },
  {
    "Retail Branding": "Insignia",
    "Marketing Name": "NS-P10A8100",
    "Device": "mid1023_ma",
    "Model": "NS-P10A8100"
  },
  {
    "Retail Branding": "Insignia",
    "Marketing Name": "NS-P10A8100K",
    "Device": "mid1028_ma",
    "Model": "NS-P10A8100K"
  },
  {
    "Retail Branding": "Insignia",
    "Marketing Name": "NS-P11A8100",
    "Device": "NS-P11A8100",
    "Model": "NS-P11A8100"
  },
  {
    "Retail Branding": "Insignia",
    "Marketing Name": "NS-P16AT08",
    "Device": "mid8005",
    "Model": "NS-P16AT08"
  },
  {
    "Retail Branding": "Insignia",
    "Marketing Name": "NS-P16AT10",
    "Device": "NS-P16AT10",
    "Model": "NS-P16AT10"
  },
  {
    "Retail Branding": "Inspire Mobile",
    "Marketing Name": "IMP-R01W",
    "Device": "IMP-R01W",
    "Model": "IMP-R01W"
  },
  {
    "Retail Branding": "Inspur",
    "Marketing Name": "start.ca IPBS9510",
    "Device": "S905",
    "Model": "start.ca IPBS9510"
  },
  {
    "Retail Branding": "InstoreScreen",
    "Marketing Name": "INFLEX",
    "Device": "INFLEX156",
    "Model": "INFLEX156"
  },
  {
    "Retail Branding": "Instto",
    "Marketing Name": "INTP01",
    "Device": "INTP01",
    "Model": "INTP01"
  },
  {
    "Retail Branding": "Intel",
    "Marketing Name": "",
    "Device": "SP-A20i",
    "Model": "SP-A20i"
  },
  {
    "Retail Branding": "Intel",
    "Marketing Name": "",
    "Device": "blackbay",
    "Model": "Xolo_X900"
  },
  {
    "Retail Branding": "Intel",
    "Marketing Name": "",
    "Device": "noonhill",
    "Model": "AZ210A"
  },
  {
    "Retail Branding": "Intel",
    "Marketing Name": "",
    "Device": "noonhill",
    "Model": "AZ210B"
  },
  {
    "Retail Branding": "Intel",
    "Marketing Name": "",
    "Device": "noonhill",
    "Model": "SP-A20i"
  },
  {
    "Retail Branding": "Intel",
    "Marketing Name": "AQ710A",
    "Device": "Salitpa",
    "Model": "AQ710A"
  },
  {
    "Retail Branding": "Intel",
    "Marketing Name": "Etisalat E-20",
    "Device": "zeeyabeach",
    "Model": "BT230"
  },
  {
    "Retail Branding": "Intel",
    "Marketing Name": "INTEX AQUA LIONS N1",
    "Device": "INTEX_AQUA_LIONS_N1",
    "Model": "INTEX AQUA LIONS N1"
  },
  {
    "Retail Branding": "Intel",
    "Marketing Name": "Orange San Diego",
    "Device": "AZ210A",
    "Model": "AZ210A"
  },
  {
    "Retail Branding": "Intel",
    "Marketing Name": "Orange avec Intel Inside",
    "Device": "AZ210B",
    "Model": "AZ210B"
  },
  {
    "Retail Branding": "Intel",
    "Marketing Name": "TR10CD1(PVT2)",
    "Device": "TR10CD1_4",
    "Model": "TR10CD1"
  },
  {
    "Retail Branding": "Intel",
    "Marketing Name": "TR10CD1(PVT2)",
    "Device": "TR10CD1_6",
    "Model": "TR10CD1"
  },
  {
    "Retail Branding": "Intel",
    "Marketing Name": "TR10CS1 (PVT2)",
    "Device": "TR10CS1_4",
    "Model": "TR10CS1"
  },
  {
    "Retail Branding": "Intel",
    "Marketing Name": "Xolo X500",
    "Device": "zeeyabeach",
    "Model": "Xolo_X500"
  },
  {
    "Retail Branding": "Intel",
    "Marketing Name": "Yolo",
    "Device": "zeeyabeach",
    "Model": "BT210"
  },
  {
    "Retail Branding": "Intelbras",
    "Marketing Name": "G Dongle 4K",
    "Device": "YYR",
    "Model": "G Dongle 4K"
  },
  {
    "Retail Branding": "Intelbras",
    "Marketing Name": "IZY01",
    "Device": "DV8038",
    "Model": "IZY01"
  },
  {
    "Retail Branding": "Intelligen",
    "Marketing Name": "IN-101",
    "Device": "IN-101",
    "Model": "IN-101"
  },
  {
    "Retail Branding": "Intenso",
    "Marketing Name": "Tab734",
    "Device": "Tab734",
    "Model": "Tab734"
  },
  {
    "Retail Branding": "Intenso",
    "Marketing Name": "Tab814S",
    "Device": "Tab814S",
    "Model": "Tab814S"
  },
  {
    "Retail Branding": "Intermec",
    "Marketing Name": "CN51",
    "Device": "CN51_NC0",
    "Model": "CN51 NC0"
  },
  {
    "Retail Branding": "Intermec",
    "Marketing Name": "CN51",
    "Device": "CN51_NCF",
    "Model": "CN51 NCF"
  },
  {
    "Retail Branding": "Intermec",
    "Marketing Name": "CN51",
    "Device": "CN51_NCU",
    "Model": "CN51 NCU"
  },
  {
    "Retail Branding": "Intermec",
    "Marketing Name": "CN51",
    "Device": "CN51_NN0",
    "Model": "CN51 NN0"
  },
  {
    "Retail Branding": "Intermec",
    "Marketing Name": "CN51",
    "Device": "CN51_QC0",
    "Model": "CN51 QC0"
  },
  {
    "Retail Branding": "Intermec",
    "Marketing Name": "CN51",
    "Device": "CN51_QCF",
    "Model": "CN51 QCF"
  },
  {
    "Retail Branding": "Intermec",
    "Marketing Name": "CN51",
    "Device": "CN51_QCU",
    "Model": "CN51 QCU"
  },
  {
    "Retail Branding": "Intermec",
    "Marketing Name": "CN51",
    "Device": "CN51_QN0",
    "Model": "CN51 QN0"
  },
  {
    "Retail Branding": "Intex",
    "Marketing Name": "AQUA 4G MINI",
    "Device": "INTEX_AQUA_4G_MINI",
    "Model": "INTEX AQUA 4G MINI"
  },
  {
    "Retail Branding": "Intex",
    "Marketing Name": "AQUA CRYSTAL",
    "Device": "INTEX_AQUA_CRYSTAL",
    "Model": "INTEX AQUA CRYSTAL"
  },
  {
    "Retail Branding": "Intex",
    "Marketing Name": "AQUA CRYSTAL+",
    "Device": "AQUA_CRYSTAL_PLUS",
    "Model": "INTEX AQUA CRYSTAL+"
  },
  {
    "Retail Branding": "Intex",
    "Marketing Name": "AQUA LIONS 2",
    "Device": "INTEX_AQUA_LIONS_2",
    "Model": "INTEX AQUA LIONS 2"
  },
  {
    "Retail Branding": "Intex",
    "Marketing Name": "AQUA LIONS T1 LITE",
    "Device": "AQUA_LIONS_T1_LITE",
    "Model": "INTEX AQUA LIONS T1 LITE"
  },
  {
    "Retail Branding": "Intex",
    "Marketing Name": "AQUA TREND LITE",
    "Device": "INTEX_AQUA_TREND_LITE",
    "Model": "INTEX AQUA TREND LITE"
  },
  {
    "Retail Branding": "Intex",
    "Marketing Name": "AQUA YOUNG 4G",
    "Device": "INTEX_AQUA_YOUNG_4G",
    "Model": "INTEX AQUA YOUNG 4G"
  },
  {
    "Retail Branding": "Intex",
    "Marketing Name": "AQUA ZENITH",
    "Device": "INTEX_AQUA_ZENITH",
    "Model": "INTEX AQUA ZENITH"
  },
  {
    "Retail Branding": "Intex",
    "Marketing Name": "AQUA_4.0_4G",
    "Device": "INTEX_AQUA_4_4G",
    "Model": "INTEX_AQUA_4.0_4G"
  },
  {
    "Retail Branding": "Intex",
    "Marketing Name": "AQUA_S3",
    "Device": "INTEX_AQUA_S3",
    "Model": "INTEX AQUA S3"
  },
  {
    "Retail Branding": "Intex",
    "Marketing Name": "Android TV",
    "Device": "R1",
    "Model": "ATV R1"
  },
  {
    "Retail Branding": "Intex",
    "Marketing Name": "Aqua 4.0 3G",
    "Device": "INTEX_AQUA_4_3G",
    "Model": "INTEX AQUA 4.0 3G"
  },
  {
    "Retail Branding": "Intex",
    "Marketing Name": "Aqua 4G mini",
    "Device": "INTEX_AQUA_4G_MINI",
    "Model": "INTEX AQUA 4G MINI"
  },
  {
    "Retail Branding": "Intex",
    "Marketing Name": "Aqua 5.5 VR",
    "Device": "Aqua_5_5_VR",
    "Model": "Aqua 5.5 VR"
  },
  {
    "Retail Branding": "Intex",
    "Marketing Name": "Aqua 5.5 VR+",
    "Device": "AQUA_5_5_VR_PLUS",
    "Model": "INTEX AQUA 5.5 VR+"
  },
  {
    "Retail Branding": "Intex",
    "Marketing Name": "Aqua A4",
    "Device": "INTEX_AQUA_A4",
    "Model": "INTEX AQUA A4"
  },
  {
    "Retail Branding": "Intex",
    "Marketing Name": "Aqua A4+",
    "Device": "INTEX_AQUA_A4_PLUS",
    "Model": "INTEX AQUA A4 PLUS"
  },
  {
    "Retail Branding": "Intex",
    "Marketing Name": "Aqua Aura 2GB",
    "Device": "Aqua_Aura_2GB",
    "Model": "Aqua Aura 2GB"
  },
  {
    "Retail Branding": "Intex",
    "Marketing Name": "Aqua Jewel 2",
    "Device": "INTEX_AQUA_JEWEL_2",
    "Model": "INTEX AQUA JEWEL 2"
  },
  {
    "Retail Branding": "Intex",
    "Marketing Name": "Aqua Lions 2",
    "Device": "INTEX_AQUA_LIONS_2",
    "Model": "INTEX AQUA LIONS 2"
  },
  {
    "Retail Branding": "Intex",
    "Marketing Name": "Aqua Lions 3",
    "Device": "INTEX_AQUA_LIONS_3",
    "Model": "IM0318ND"
  },
  {
    "Retail Branding": "Intex",
    "Marketing Name": "Aqua Lions 3",
    "Device": "INTEX_AQUA_LIONS_3",
    "Model": "INTEX AQUA LIONS 3"
  },
  {
    "Retail Branding": "Intex",
    "Marketing Name": "Aqua Power 4G",
    "Device": "Intex_Aqua_Power_4G",
    "Model": "Aqua Power 4G"
  },
  {
    "Retail Branding": "Intex",
    "Marketing Name": "Aqua Power IV",
    "Device": "INTEX_AQUA_POWER_IV",
    "Model": "INTEX AQUA POWER IV"
  },
  {
    "Retail Branding": "Intex",
    "Marketing Name": "Aqua Pride",
    "Device": "AquaPride",
    "Model": "Aqua Pride"
  },
  {
    "Retail Branding": "Intex",
    "Marketing Name": "Aqua Ring",
    "Device": "Aqua_Ring",
    "Model": "Aqua_Ring"
  },
  {
    "Retail Branding": "Intex",
    "Marketing Name": "Aqua Strong 5.1+",
    "Device": "Aqua_Strong_5_1_Plus",
    "Model": "Intex Aqua Strong 5.1+"
  },
  {
    "Retail Branding": "Intex",
    "Marketing Name": "Aqua Supreme+",
    "Device": "Aqua_Supreme_Plus",
    "Model": "Intex Aqua Supreme+"
  },
  {
    "Retail Branding": "Intex",
    "Marketing Name": "Aqua View",
    "Device": "AquaView",
    "Model": "Aqua View"
  },
  {
    "Retail Branding": "Intex",
    "Marketing Name": "Aqua_Lions_4G",
    "Device": "INTEX_AQUA_LIONS_4G",
    "Model": "INTEX AQUA LIONS 4G"
  },
  {
    "Retail Branding": "Intex",
    "Marketing Name": "Aqua_Q8",
    "Device": "Aqua_Q8",
    "Model": "Aqua Q8"
  },
  {
    "Retail Branding": "Intex",
    "Marketing Name": "Cloud AX1",
    "Device": "INTEX_CLOUD_AX1",
    "Model": "INTEX CLOUD AX1"
  },
  {
    "Retail Branding": "Intex",
    "Marketing Name": "Cloud style 4G",
    "Device": "Intex_Cloud_Style_4G",
    "Model": "Intex_Cloud_Style_4G"
  },
  {
    "Retail Branding": "Intex",
    "Marketing Name": "Cloud_Q11_4G",
    "Device": "Cloud_Q11_4G",
    "Model": "Cloud Q11 4G"
  },
  {
    "Retail Branding": "Intex",
    "Marketing Name": "Cloud_Q11_4G",
    "Device": "Cloud_Q11_4G",
    "Model": "Cloud_Q11_4G"
  },
  {
    "Retail Branding": "Intex",
    "Marketing Name": "ELYT E1",
    "Device": "INTEX_ELYT_E1",
    "Model": "INTEX ELYT E1"
  },
  {
    "Retail Branding": "Intex",
    "Marketing Name": "ELYT E7",
    "Device": "INTEX_ELYT_E7",
    "Model": "INTEX ELYT E7"
  },
  {
    "Retail Branding": "Intex",
    "Marketing Name": "Elite E1",
    "Device": "Intex_Elite_E1",
    "Model": "Intex Elite E1"
  },
  {
    "Retail Branding": "Intex",
    "Marketing Name": "INDIE 15",
    "Device": "AQUA_LIONS_X1",
    "Model": "INTEX AQUA LIONS X1"
  },
  {
    "Retail Branding": "Intex",
    "Marketing Name": "INDIE 15",
    "Device": "AQUA_LIONS_X1",
    "Model": "INTEX IM0418ND"
  },
  {
    "Retail Branding": "Intex",
    "Marketing Name": "INDIE 5",
    "Device": "INTEX_AQUA_LIONS_3",
    "Model": "INTEX AQUA LIONS 3"
  },
  {
    "Retail Branding": "Intex",
    "Marketing Name": "INFIE 77",
    "Device": "INTEX_IP0418ND",
    "Model": "INTEX IP0418ND"
  },
  {
    "Retail Branding": "Intex",
    "Marketing Name": "INTEX  AQUA Lions T1",
    "Device": "AQUA_LIONS_T1",
    "Model": "INTEX AQUA LIONS T1"
  },
  {
    "Retail Branding": "Intex",
    "Marketing Name": "INTEX AQUA AMAZE+",
    "Device": "INTEX_AQUA_AMAZE_PLUS",
    "Model": "INTEX AQUA AMAZE+"
  },
  {
    "Retail Branding": "Intex",
    "Marketing Name": "INTEX AQUA NOTE 5.5",
    "Device": "AQUA_NOTE_5_5",
    "Model": "INTEX AQUA NOTE 5.5"
  },
  {
    "Retail Branding": "Intex",
    "Marketing Name": "INTEX AQUA S1",
    "Device": "INTEX_AQUA_S1",
    "Model": "INTEX AQUA S1"
  },
  {
    "Retail Branding": "Intex",
    "Marketing Name": "INTEX AQUA STYLE 3",
    "Device": "INTEX_AQUA_STYLE_3",
    "Model": "INTEX AQUA STYLE 3"
  },
  {
    "Retail Branding": "Intex",
    "Marketing Name": "INTEX Aqua Selfie",
    "Device": "INTEX_AQUA_SELFIE",
    "Model": "INTEX AQUA SELFIE"
  },
  {
    "Retail Branding": "Intex",
    "Marketing Name": "INTEX_AQUA_S3",
    "Device": "INTEX_AQUA_S3",
    "Model": "INTEX AQUA S3"
  },
  {
    "Retail Branding": "Intex",
    "Marketing Name": "IV0318ND",
    "Device": "IV0318ND",
    "Model": "IV0318ND"
  },
  {
    "Retail Branding": "Intex",
    "Marketing Name": "Indie 22",
    "Device": "AQUA_FulVU_e5",
    "Model": "INTEX AQUA FulVU e5"
  },
  {
    "Retail Branding": "Intex",
    "Marketing Name": "Indie 22",
    "Device": "AQUA_FulVU_e5",
    "Model": "INTEX IP0518ND"
  },
  {
    "Retail Branding": "Intex",
    "Marketing Name": "STAARi 10",
    "Device": "AQUA_LIONS_X1_PLUS",
    "Model": "INTEX AQUA LIONS X1+"
  },
  {
    "Retail Branding": "Intex",
    "Marketing Name": "STAARi 10",
    "Device": "AQUA_LIONS_X1_PLUS",
    "Model": "INTEX IP0218ND"
  },
  {
    "Retail Branding": "Intex",
    "Marketing Name": "STAARi 12",
    "Device": "INTEX_ELYT_E6",
    "Model": "INTEX ELYT E6"
  },
  {
    "Retail Branding": "Intex",
    "Marketing Name": "T1 Plus",
    "Device": "INTEX_ELYT_DUAL",
    "Model": "INTEX ELYT DUAL"
  },
  {
    "Retail Branding": "Intex",
    "Marketing Name": "T1 Plus",
    "Device": "INTEX_ELYT_DUAL",
    "Model": "INTEX IM0118ND"
  },
  {
    "Retail Branding": "Intex",
    "Marketing Name": "i1",
    "Device": "INTEX_i1",
    "Model": "INTEX i1"
  },
  {
    "Retail Branding": "Invens",
    "Marketing Name": "CT1",
    "Device": "Beige",
    "Model": "CT1"
  },
  {
    "Retail Branding": "Invens",
    "Marketing Name": "Diamond",
    "Device": "Diamond",
    "Model": "Diamond"
  },
  {
    "Retail Branding": "Invens",
    "Marketing Name": "Eager",
    "Device": "Eager",
    "Model": "Eager"
  },
  {
    "Retail Branding": "Invens",
    "Marketing Name": "F1",
    "Device": "F1",
    "Model": "F1"
  },
  {
    "Retail Branding": "Invens",
    "Marketing Name": "F2",
    "Device": "F2",
    "Model": "F2"
  },
  {
    "Retail Branding": "Invens",
    "Marketing Name": "Fighter",
    "Device": "Fighter",
    "Model": "Fighter"
  },
  {
    "Retail Branding": "Invens",
    "Marketing Name": "K1",
    "Device": "K1",
    "Model": "K1"
  },
  {
    "Retail Branding": "Invens",
    "Marketing Name": "MAX3",
    "Device": "MAX3",
    "Model": "MAX3"
  },
  {
    "Retail Branding": "Invens",
    "Marketing Name": "MAX5",
    "Device": "MAX5",
    "Model": "MAX5"
  },
  {
    "Retail Branding": "Invens",
    "Marketing Name": "MAX8",
    "Device": "MAX8",
    "Model": "MAX8"
  },
  {
    "Retail Branding": "Invens",
    "Marketing Name": "MAX9",
    "Device": "MAX9",
    "Model": "MAX9"
  },
  {
    "Retail Branding": "Invens",
    "Marketing Name": "MAX_1",
    "Device": "MAX_1",
    "Model": "MAX_1"
  },
  {
    "Retail Branding": "Invens",
    "Marketing Name": "MAX_2",
    "Device": "MAX_2",
    "Model": "MAX_2"
  },
  {
    "Retail Branding": "Invens",
    "Marketing Name": "NOTE_12P",
    "Device": "NOTE_12P",
    "Model": "NOTE 12P"
  },
  {
    "Retail Branding": "Invens",
    "Marketing Name": "NOTE_15P_EEA",
    "Device": "NOTE_15P",
    "Model": "NOTE 15P"
  },
  {
    "Retail Branding": "Invens",
    "Marketing Name": "NOTE_5G",
    "Device": "NOTE_5G",
    "Model": "NOTE 5G"
  },
  {
    "Retail Branding": "Invens",
    "Marketing Name": "S1",
    "Device": "S1",
    "Model": "S1"
  },
  {
    "Retail Branding": "Invens",
    "Marketing Name": "Spain",
    "Device": "nagata",
    "Model": "INVES SMART TV"
  },
  {
    "Retail Branding": "Invens",
    "Marketing Name": "ULTRA 13P",
    "Device": "ULTRA_13P",
    "Model": "ULTRA 13P"
  },
  {
    "Retail Branding": "Invens",
    "Marketing Name": "UNO",
    "Device": "UNO",
    "Model": "UNO"
  },
  {
    "Retail Branding": "Invens",
    "Marketing Name": "WE1",
    "Device": "WE1",
    "Model": "WE1"
  },
  {
    "Retail Branding": "Inventus",
    "Marketing Name": "CT1",
    "Device": "Beige",
    "Model": "CT1"
  },
  {
    "Retail Branding": "Inventus",
    "Marketing Name": "CT7",
    "Device": "Aqua",
    "Model": "CT7"
  },
  {
    "Retail Branding": "Inverse Net",
    "Marketing Name": "EP172BZ",
    "Device": "EP172BZ",
    "Model": "EP172BZ"
  },
  {
    "Retail Branding": "Inverse Net",
    "Marketing Name": "EP172PR",
    "Device": "EP172PR",
    "Model": "EP172PR"
  },
  {
    "Retail Branding": "Inverse Net",
    "Marketing Name": "LT101",
    "Device": "LT101",
    "Model": "LT101"
  },
  {
    "Retail Branding": "Inves",
    "Marketing Name": "Europe",
    "Device": "marina",
    "Model": "INVES SMART TV"
  },
  {
    "Retail Branding": "Inves",
    "Marketing Name": "Spain",
    "Device": "tamachi",
    "Model": "INVES FHD Android TV"
  },
  {
    "Retail Branding": "Inves",
    "Marketing Name": "Spain",
    "Device": "yeongdeungpo",
    "Model": "INVES UHD Android TV"
  },
  {
    "Retail Branding": "Ipro",
    "Marketing Name": "Amber5S",
    "Device": "Amber5S",
    "Model": "Amber5S"
  },
  {
    "Retail Branding": "Ipro",
    "Marketing Name": "Amber5S_Pro",
    "Device": "Amber5S_Pro",
    "Model": "Amber5S_Pro"
  },
  {
    "Retail Branding": "Ipro",
    "Marketing Name": "Amber5S_Pro",
    "Device": "Mobilephone",
    "Model": "Amber5S_Pro"
  },
  {
    "Retail Branding": "Ipro",
    "Marketing Name": "Amber5S_Pro",
    "Device": "Mobilephone",
    "Model": "Y200"
  },
  {
    "Retail Branding": "Ipro",
    "Marketing Name": "Amber5s Plus",
    "Device": "Amber5s_Plus",
    "Model": "Amber5s Plus"
  },
  {
    "Retail Branding": "Ipro",
    "Marketing Name": "Amber6",
    "Device": "Amber6",
    "Model": "Amber6"
  },
  {
    "Retail Branding": "Ipro",
    "Marketing Name": "Amber7S",
    "Device": "Amber7S",
    "Model": "Amber7S"
  },
  {
    "Retail Branding": "Ipro",
    "Marketing Name": "Amber8",
    "Device": "Amber8",
    "Model": "Amber8"
  },
  {
    "Retail Branding": "Ipro",
    "Marketing Name": "Amber8S",
    "Device": "Amber8S",
    "Model": "Amber8S"
  },
  {
    "Retail Branding": "Ipro",
    "Marketing Name": "Amber8S plus",
    "Device": "Amber8S_plus",
    "Model": "Amber8S plus"
  },
  {
    "Retail Branding": "Ipro",
    "Marketing Name": "Amber8s Pro",
    "Device": "Amber8s_Pro",
    "Model": "Amber8s Pro"
  },
  {
    "Retail Branding": "Ipro",
    "Marketing Name": "Amber8s_Mate",
    "Device": "Amber8s_Mate",
    "Model": "Amber8s Mate"
  },
  {
    "Retail Branding": "Ipro",
    "Marketing Name": "BEQUE7S",
    "Device": "BEQUE7S",
    "Model": "BEQUE7S"
  },
  {
    "Retail Branding": "Ipro",
    "Marketing Name": "Benny",
    "Device": "Benny",
    "Model": "Benny"
  },
  {
    "Retail Branding": "Ipro",
    "Marketing Name": "Benny10",
    "Device": "Benny10",
    "Model": "Benny10"
  },
  {
    "Retail Branding": "Ipro",
    "Marketing Name": "BennyM",
    "Device": "BennyM",
    "Model": "BennyM"
  },
  {
    "Retail Branding": "Ipro",
    "Marketing Name": "IPRO S500",
    "Device": "S500",
    "Model": "S500"
  },
  {
    "Retail Branding": "Ipro",
    "Marketing Name": "Jade7s",
    "Device": "Jade7s",
    "Model": "Jade7s"
  },
  {
    "Retail Branding": "Ipro",
    "Marketing Name": "Jade8S",
    "Device": "Jade8S",
    "Model": "Jade8S"
  },
  {
    "Retail Branding": "Ipro",
    "Marketing Name": "KYLIN40",
    "Device": "KYLIN40",
    "Model": "KYLIN40"
  },
  {
    "Retail Branding": "Ipro",
    "Marketing Name": "Kylin 5.0",
    "Device": "Kylin_50",
    "Model": "Kylin 5.0"
  },
  {
    "Retail Branding": "Ipro",
    "Marketing Name": "Kylin 5.5",
    "Device": "Kylin_55",
    "Model": "Kylin 5.5"
  },
  {
    "Retail Branding": "Ipro",
    "Marketing Name": "Kylin 5.5S",
    "Device": "Kylin_55S",
    "Model": "Kylin 5.5S"
  },
  {
    "Retail Branding": "Ipro",
    "Marketing Name": "Kylin50i",
    "Device": "Kylin50i",
    "Model": "Kylin50i"
  },
  {
    "Retail Branding": "Ipro",
    "Marketing Name": "Kylin_5.0S",
    "Device": "Kylin_5_0S",
    "Model": "Kylin_5.0S"
  },
  {
    "Retail Branding": "Ipro",
    "Marketing Name": "MEGA",
    "Device": "MEGA",
    "Model": "MEGA"
  },
  {
    "Retail Branding": "Ipro",
    "Marketing Name": "MEGA",
    "Device": "MEGA2",
    "Model": "MEGA2"
  },
  {
    "Retail Branding": "Ipro",
    "Marketing Name": "Mega7",
    "Device": "MEGA7",
    "Model": "MEGA7"
  },
  {
    "Retail Branding": "Ipro",
    "Marketing Name": "Opal4S",
    "Device": "Opal4S",
    "Model": "Opal 4S"
  },
  {
    "Retail Branding": "Ipro",
    "Marketing Name": "PHOENIX 5.0",
    "Device": "PHOENIX_50",
    "Model": "PHOENIX 5.0"
  },
  {
    "Retail Branding": "Ipro",
    "Marketing Name": "Perla",
    "Device": "Perla",
    "Model": "Perla"
  },
  {
    "Retail Branding": "Ipro",
    "Marketing Name": "Phonenix50S",
    "Device": "Phonenix50S",
    "Model": "Phonenix50S"
  },
  {
    "Retail Branding": "Ipro",
    "Marketing Name": "Pro8S",
    "Device": "Pro8S",
    "Model": "Pro8S"
  },
  {
    "Retail Branding": "Ipro",
    "Marketing Name": "Ruby5S",
    "Device": "Ruby5S",
    "Model": "Ruby5S"
  },
  {
    "Retail Branding": "Ipro",
    "Marketing Name": "S100",
    "Device": "S100",
    "Model": "S100"
  },
  {
    "Retail Branding": "Ipro",
    "Marketing Name": "S100E",
    "Device": "S100E",
    "Model": "S100E"
  },
  {
    "Retail Branding": "Ipro",
    "Marketing Name": "S200M",
    "Device": "S200M",
    "Model": "S200M"
  },
  {
    "Retail Branding": "Ipro",
    "Marketing Name": "S300",
    "Device": "S300",
    "Model": "S300"
  },
  {
    "Retail Branding": "Ipro",
    "Marketing Name": "S401",
    "Device": "S401",
    "Model": "S401"
  },
  {
    "Retail Branding": "Ipro",
    "Marketing Name": "S401A",
    "Device": "S401A",
    "Model": "S401A"
  },
  {
    "Retail Branding": "Ipro",
    "Marketing Name": "S501",
    "Device": "S501",
    "Model": "S501"
  },
  {
    "Retail Branding": "Ipro",
    "Marketing Name": "S501A",
    "Device": "S501A",
    "Model": "S501A"
  },
  {
    "Retail Branding": "Ipro",
    "Marketing Name": "S501APlus",
    "Device": "S501APlus",
    "Model": "S501APlus"
  },
  {
    "Retail Branding": "Ipro",
    "Marketing Name": "S501Pro",
    "Device": "S501Pro",
    "Model": "S501 Plus"
  },
  {
    "Retail Branding": "Ipro",
    "Marketing Name": "SAMBA65S",
    "Device": "SAMBA65S",
    "Model": "SAMBA65S"
  },
  {
    "Retail Branding": "Ipro",
    "Marketing Name": "Soda6S",
    "Device": "Soda6S",
    "Model": "Soda6S"
  },
  {
    "Retail Branding": "Ipro",
    "Marketing Name": "WIN",
    "Device": "WIN",
    "Model": "WIN"
  },
  {
    "Retail Branding": "Ipro",
    "Marketing Name": "WePad",
    "Device": "WePad",
    "Model": "WePad"
  },
  {
    "Retail Branding": "Ipro",
    "Marketing Name": "X1",
    "Device": "IPRO_X1",
    "Model": "X1"
  },
  {
    "Retail Branding": "Ipro",
    "Marketing Name": "XPLAY",
    "Device": "XPLAY",
    "Model": "XPLAY"
  },
  {
    "Retail Branding": "Ipro",
    "Marketing Name": "Y100",
    "Device": "Y100",
    "Model": "Y100"
  },
  {
    "Retail Branding": "Ipro",
    "Marketing Name": "Y300",
    "Device": "Mobilephone",
    "Model": "Y300"
  },
  {
    "Retail Branding": "Ipro",
    "Marketing Name": "Zafiro",
    "Device": "Zafiro",
    "Model": "Zafiro"
  },
  {
    "Retail Branding": "Iproda",
    "Marketing Name": "GG",
    "Device": "GG",
    "Model": "GG"
  },
  {
    "Retail Branding": "Iproda",
    "Marketing Name": "T1045LI",
    "Device": "T1045LI",
    "Model": "T1045LI"
  },
  {
    "Retail Branding": "Iproda",
    "Marketing Name": "T1085P4LE",
    "Device": "T1085P4LE",
    "Model": "T1085P4LE"
  },
  {
    "Retail Branding": "Iproda",
    "Marketing Name": "T7044NP",
    "Device": "T7044NP",
    "Model": "T7044NP"
  },
  {
    "Retail Branding": "Irbis",
    "Marketing Name": "IRBIS TZ175",
    "Device": "TZ175",
    "Model": "TZ175"
  },
  {
    "Retail Branding": "Irbis",
    "Marketing Name": "IRBIS TZ176",
    "Device": "TZ176",
    "Model": "TZ176"
  },
  {
    "Retail Branding": "Irbis",
    "Marketing Name": "IRBIS TZ178",
    "Device": "TZ178",
    "Model": "TZ178"
  },
  {
    "Retail Branding": "Irbis",
    "Marketing Name": "IRBIS TZ198",
    "Device": "TZ198",
    "Model": "TZ198"
  },
  {
    "Retail Branding": "Irbis",
    "Marketing Name": "IRBIS TZ737",
    "Device": "TZ737",
    "Model": "TZ737"
  },
  {
    "Retail Branding": "Irbis",
    "Marketing Name": "IRBIS TZ747",
    "Device": "TZ747",
    "Model": "TZ747"
  },
  {
    "Retail Branding": "Irbis",
    "Marketing Name": "IRBIS TZ752",
    "Device": "TZ752",
    "Model": "TZ752"
  },
  {
    "Retail Branding": "Irbis",
    "Marketing Name": "IRBIS TZ753",
    "Device": "TZ753",
    "Model": "TZ753"
  },
  {
    "Retail Branding": "Irbis",
    "Marketing Name": "SP401",
    "Device": "SP401",
    "Model": "SP401"
  },
  {
    "Retail Branding": "Irbis",
    "Marketing Name": "SP402",
    "Device": "SP402",
    "Model": "SP402"
  },
  {
    "Retail Branding": "Irbis",
    "Marketing Name": "SP453",
    "Device": "SP453",
    "Model": "SP453"
  },
  {
    "Retail Branding": "Irbis",
    "Marketing Name": "SP454",
    "Device": "SP454",
    "Model": "SP454"
  },
  {
    "Retail Branding": "Irbis",
    "Marketing Name": "SP455",
    "Device": "SP455",
    "Model": "SP455"
  },
  {
    "Retail Branding": "Irbis",
    "Marketing Name": "SP510",
    "Device": "SP510",
    "Model": "SP510"
  },
  {
    "Retail Branding": "Irbis",
    "Marketing Name": "SP511",
    "Device": "SP511",
    "Model": "SP511"
  },
  {
    "Retail Branding": "Irbis",
    "Marketing Name": "SP514",
    "Device": "SP514",
    "Model": "SP514"
  },
  {
    "Retail Branding": "Irbis",
    "Marketing Name": "SP515",
    "Device": "SP515",
    "Model": "SP515"
  },
  {
    "Retail Branding": "Irbis",
    "Marketing Name": "SP517",
    "Device": "SP517",
    "Model": "SP517"
  },
  {
    "Retail Branding": "Irbis",
    "Marketing Name": "SP542",
    "Device": "SP542",
    "Model": "SP542"
  },
  {
    "Retail Branding": "Irbis",
    "Marketing Name": "SP550",
    "Device": "SP550",
    "Model": "SP550"
  },
  {
    "Retail Branding": "Irbis",
    "Marketing Name": "SP551",
    "Device": "SP551",
    "Model": "SP551"
  },
  {
    "Retail Branding": "Irbis",
    "Marketing Name": "SP552",
    "Device": "SP552",
    "Model": "SP552"
  },
  {
    "Retail Branding": "Irbis",
    "Marketing Name": "SP554",
    "Device": "SP554",
    "Model": "SP554"
  },
  {
    "Retail Branding": "Irbis",
    "Marketing Name": "SP571",
    "Device": "SP571",
    "Model": "SP571"
  },
  {
    "Retail Branding": "Irbis",
    "Marketing Name": "TZ08",
    "Device": "TZ08",
    "Model": "TZ08"
  },
  {
    "Retail Branding": "Irbis",
    "Marketing Name": "TZ150",
    "Device": "TZ150",
    "Model": "TZ150"
  },
  {
    "Retail Branding": "Irbis",
    "Marketing Name": "TZ151",
    "Device": "TZ151",
    "Model": "TZ151"
  },
  {
    "Retail Branding": "Irbis",
    "Marketing Name": "TZ165",
    "Device": "TZ165",
    "Model": "TZ165"
  },
  {
    "Retail Branding": "Irbis",
    "Marketing Name": "TZ170",
    "Device": "TZ170",
    "Model": "TZ170"
  },
  {
    "Retail Branding": "Irbis",
    "Marketing Name": "TZ177",
    "Device": "TZ177",
    "Model": "TZ177"
  },
  {
    "Retail Branding": "Irbis",
    "Marketing Name": "TZ179",
    "Device": "TZ179",
    "Model": "TZ179"
  },
  {
    "Retail Branding": "Irbis",
    "Marketing Name": "TZ180",
    "Device": "TZ180",
    "Model": "TZ180"
  },
  {
    "Retail Branding": "Irbis",
    "Marketing Name": "TZ183",
    "Device": "TZ183",
    "Model": "TZ183"
  },
  {
    "Retail Branding": "Irbis",
    "Marketing Name": "TZ184",
    "Device": "TZ184",
    "Model": "TZ184"
  },
  {
    "Retail Branding": "Irbis",
    "Marketing Name": "TZ195",
    "Device": "TZ195",
    "Model": "TZ195"
  },
  {
    "Retail Branding": "Irbis",
    "Marketing Name": "TZ197",
    "Device": "TZ197",
    "Model": "TZ197"
  },
  {
    "Retail Branding": "Irbis",
    "Marketing Name": "TZ199",
    "Device": "TZ199",
    "Model": "TZ199"
  },
  {
    "Retail Branding": "Irbis",
    "Marketing Name": "TZ200",
    "Device": "TZ200",
    "Model": "TZ200"
  },
  {
    "Retail Branding": "Irbis",
    "Marketing Name": "TZ55",
    "Device": "TZ55",
    "Model": "TZ55"
  },
  {
    "Retail Branding": "Irbis",
    "Marketing Name": "TZ711",
    "Device": "TZ711",
    "Model": "TZ711"
  },
  {
    "Retail Branding": "Irbis",
    "Marketing Name": "TZ712",
    "Device": "TZ712",
    "Model": "TZ712"
  },
  {
    "Retail Branding": "Irbis",
    "Marketing Name": "TZ714",
    "Device": "TZ714",
    "Model": "TZ714"
  },
  {
    "Retail Branding": "Irbis",
    "Marketing Name": "TZ716",
    "Device": "TZ716",
    "Model": "TZ716"
  },
  {
    "Retail Branding": "Irbis",
    "Marketing Name": "TZ717",
    "Device": "TZ717",
    "Model": "TZ717"
  },
  {
    "Retail Branding": "Irbis",
    "Marketing Name": "TZ718",
    "Device": "TZ718",
    "Model": "TZ718"
  },
  {
    "Retail Branding": "Irbis",
    "Marketing Name": "TZ719",
    "Device": "TZ719",
    "Model": "TZ719"
  },
  {
    "Retail Branding": "Irbis",
    "Marketing Name": "TZ720",
    "Device": "TZ720",
    "Model": "TZ720"
  },
  {
    "Retail Branding": "Irbis",
    "Marketing Name": "TZ721",
    "Device": "TZ721",
    "Model": "TZ721"
  },
  {
    "Retail Branding": "Irbis",
    "Marketing Name": "TZ722",
    "Device": "TZ722",
    "Model": "TZ722"
  },
  {
    "Retail Branding": "Irbis",
    "Marketing Name": "TZ725",
    "Device": "TZ725",
    "Model": "TZ725"
  },
  {
    "Retail Branding": "Irbis",
    "Marketing Name": "TZ726",
    "Device": "TZ726",
    "Model": "TZ726"
  },
  {
    "Retail Branding": "Irbis",
    "Marketing Name": "TZ727",
    "Device": "TZ727",
    "Model": "TZ727"
  },
  {
    "Retail Branding": "Irbis",
    "Marketing Name": "TZ728",
    "Device": "TZ728",
    "Model": "TZ728"
  },
  {
    "Retail Branding": "Irbis",
    "Marketing Name": "TZ742",
    "Device": "TZ742",
    "Model": "TZ742"
  },
  {
    "Retail Branding": "Irbis",
    "Marketing Name": "TZ754",
    "Device": "TZ754",
    "Model": "TZ754"
  },
  {
    "Retail Branding": "Irbis",
    "Marketing Name": "TZ757",
    "Device": "TZ757",
    "Model": "TZ757"
  },
  {
    "Retail Branding": "Irbis",
    "Marketing Name": "TZ762",
    "Device": "TZ762",
    "Model": "TZ762"
  },
  {
    "Retail Branding": "Irbis",
    "Marketing Name": "TZ771",
    "Device": "TZ771",
    "Model": "TZ771"
  },
  {
    "Retail Branding": "Irbis",
    "Marketing Name": "TZ772",
    "Device": "TZ772",
    "Model": "TZ772"
  },
  {
    "Retail Branding": "Irbis",
    "Marketing Name": "TZ773",
    "Device": "TZ773",
    "Model": "TZ773"
  },
  {
    "Retail Branding": "Irbis",
    "Marketing Name": "TZ777",
    "Device": "TZ777",
    "Model": "TZ777"
  },
  {
    "Retail Branding": "Irbis",
    "Marketing Name": "TZ781",
    "Device": "TZ781",
    "Model": "TZ781"
  },
  {
    "Retail Branding": "Irbis",
    "Marketing Name": "TZ794",
    "Device": "TZ794",
    "Model": "TZ794"
  },
  {
    "Retail Branding": "Irbis",
    "Marketing Name": "TZ797",
    "Device": "TZ797",
    "Model": "TZ797"
  },
  {
    "Retail Branding": "Irbis",
    "Marketing Name": "TZ831",
    "Device": "TZ831",
    "Model": "TZ831"
  },
  {
    "Retail Branding": "Irbis",
    "Marketing Name": "TZ832",
    "Device": "TZ832",
    "Model": "TZ832"
  },
  {
    "Retail Branding": "Irbis",
    "Marketing Name": "TZ841",
    "Device": "TZ841",
    "Model": "TZ841"
  },
  {
    "Retail Branding": "Irbis",
    "Marketing Name": "TZ855",
    "Device": "TZ855",
    "Model": "TZ855"
  },
  {
    "Retail Branding": "Irbis",
    "Marketing Name": "TZ856",
    "Device": "TZ856",
    "Model": "TZ856"
  },
  {
    "Retail Branding": "Irbis",
    "Marketing Name": "TZ872",
    "Device": "TZ872",
    "Model": "TZ872"
  },
  {
    "Retail Branding": "Irbis",
    "Marketing Name": "TZ874",
    "Device": "TZ874",
    "Model": "TZ874"
  },
  {
    "Retail Branding": "Irbis",
    "Marketing Name": "TZ877",
    "Device": "TZ877",
    "Model": "TZ877"
  },
  {
    "Retail Branding": "Irbis",
    "Marketing Name": "TZ885",
    "Device": "TZ885",
    "Model": "TZ885"
  },
  {
    "Retail Branding": "Irbis",
    "Marketing Name": "TZ890",
    "Device": "TZ890",
    "Model": "TZ890"
  },
  {
    "Retail Branding": "Irbis",
    "Marketing Name": "TZ892",
    "Device": "TZ892",
    "Model": "TZ892"
  },
  {
    "Retail Branding": "Irbis",
    "Marketing Name": "TZ897",
    "Device": "TZ897",
    "Model": "TZ897"
  },
  {
    "Retail Branding": "Irbis",
    "Marketing Name": "TZ960",
    "Device": "TZ960",
    "Model": "TZ960"
  },
  {
    "Retail Branding": "Irbis",
    "Marketing Name": "TZ961",
    "Device": "TZ961",
    "Model": "TZ961"
  },
  {
    "Retail Branding": "Irbis",
    "Marketing Name": "TZ962",
    "Device": "TZ962",
    "Model": "TZ962"
  },
  {
    "Retail Branding": "Irbis",
    "Marketing Name": "TZ963",
    "Device": "TZ963",
    "Model": "TZ963"
  },
  {
    "Retail Branding": "Irbis",
    "Marketing Name": "TZ964",
    "Device": "TZ964",
    "Model": "TZ964"
  },
  {
    "Retail Branding": "Irbis",
    "Marketing Name": "TZ965",
    "Device": "TZ965",
    "Model": "TZ965"
  },
  {
    "Retail Branding": "Irbis",
    "Marketing Name": "TZ967",
    "Device": "TZ967",
    "Model": "TZ967"
  },
  {
    "Retail Branding": "Irbis",
    "Marketing Name": "TZ968",
    "Device": "TZ968",
    "Model": "TZ968"
  },
  {
    "Retail Branding": "Irbis",
    "Marketing Name": "TZ969",
    "Device": "TZ969",
    "Model": "TZ969"
  },
  {
    "Retail Branding": "Iris",
    "Marketing Name": "A200PRO",
    "Device": "A200PRO",
    "Model": "A200PRO"
  },
  {
    "Retail Branding": "Iris",
    "Marketing Name": "G7060",
    "Device": "G7060",
    "Model": "G7060"
  },
  {
    "Retail Branding": "Iris",
    "Marketing Name": "G7100",
    "Device": "G7100",
    "Model": "G7100"
  },
  {
    "Retail Branding": "Iris",
    "Marketing Name": "G8060",
    "Device": "G8060",
    "Model": "G8060"
  },
  {
    "Retail Branding": "Iris",
    "Marketing Name": "IRIS 2K SmartTV",
    "Device": "beomil",
    "Model": "IRIS 2K SmartTV"
  },
  {
    "Retail Branding": "Iris",
    "Marketing Name": "IRIS 2K SmartTV",
    "Device": "umeda",
    "Model": "IRIS 2K SmartTV"
  },
  {
    "Retail Branding": "Iris",
    "Marketing Name": "IRIS 4K Android TV",
    "Device": "SW4H_FF",
    "Model": "IRIS 4K Android TV"
  },
  {
    "Retail Branding": "Iris",
    "Marketing Name": "IRIS 4K Smart TV Plus",
    "Device": "anaheim",
    "Model": "IRIS 4K Smart TV Plus"
  },
  {
    "Retail Branding": "Iris",
    "Marketing Name": "IRIS 4K SmartTV",
    "Device": "SW6H",
    "Model": "IRIS 4K SmartTV"
  },
  {
    "Retail Branding": "Iris",
    "Marketing Name": "IRIS 4K SmartTV",
    "Device": "eleonas",
    "Model": "IRIS 4K SmartTV"
  },
  {
    "Retail Branding": "Iris",
    "Marketing Name": "IRIS 4K SmartTV FF",
    "Device": "SW6H",
    "Model": "IRIS 4K SmartTV FF"
  },
  {
    "Retail Branding": "Iris",
    "Marketing Name": "IRIS 4K SmartTV FF",
    "Device": "eleonas",
    "Model": "IRIS 4K SmartTV FF"
  },
  {
    "Retail Branding": "Iris",
    "Marketing Name": "IRIS Music TV",
    "Device": "byculla",
    "Model": "IRIS Music TV"
  },
  {
    "Retail Branding": "Iris",
    "Marketing Name": "IRIS Smart TV",
    "Device": "SW4H",
    "Model": "IRIS Smart TV"
  },
  {
    "Retail Branding": "Iris",
    "Marketing Name": "IS2PLUS",
    "Device": "IS2PLUS",
    "Model": "IS2PLUS"
  },
  {
    "Retail Branding": "Iris",
    "Marketing Name": "IS2S",
    "Device": "IS2S",
    "Model": "IS2S"
  },
  {
    "Retail Branding": "Iris",
    "Marketing Name": "IS2_Plus",
    "Device": "IS2_Plus",
    "Model": "IS2_Plus"
  },
  {
    "Retail Branding": "Iris",
    "Marketing Name": "IS6Plus",
    "Device": "IS6Plus",
    "Model": "IS6Plus"
  },
  {
    "Retail Branding": "Iris",
    "Marketing Name": "Iris 2K TV",
    "Device": "shinagawa",
    "Model": "Iris 2K TV"
  },
  {
    "Retail Branding": "Iris",
    "Marketing Name": "N30",
    "Device": "N30",
    "Model": "N30"
  },
  {
    "Retail Branding": "Iris",
    "Marketing Name": "NEXT P",
    "Device": "NEXT_P",
    "Model": "NEXT_P"
  },
  {
    "Retail Branding": "Iris",
    "Marketing Name": "NEXT P+",
    "Device": "NEXT_P_PLUS",
    "Model": "NEXT P+"
  },
  {
    "Retail Branding": "Iris",
    "Marketing Name": "NEXT U",
    "Device": "NEXT_U",
    "Model": "NEXT U"
  },
  {
    "Retail Branding": "Iris",
    "Marketing Name": "Next_P_PRO",
    "Device": "Next_P_PRO",
    "Model": "Next_P_PRO"
  },
  {
    "Retail Branding": "Iris",
    "Marketing Name": "V10",
    "Device": "V10",
    "Model": "V10"
  },
  {
    "Retail Branding": "Iris",
    "Marketing Name": "V50",
    "Device": "V50",
    "Model": "V50"
  },
  {
    "Retail Branding": "Iris",
    "Marketing Name": "VOX  4s",
    "Device": "VOX_4s",
    "Model": "VOX 4s"
  },
  {
    "Retail Branding": "Iris",
    "Marketing Name": "VOX  Energy",
    "Device": "VOX_Energy",
    "Model": "VOX Energy"
  },
  {
    "Retail Branding": "Iris",
    "Marketing Name": "VOX  STEEL Plus",
    "Device": "VOX_STEEL_Plus",
    "Model": "VOX STEEL Plus"
  },
  {
    "Retail Branding": "Iris",
    "Marketing Name": "VOX  STEEL Plus",
    "Device": "VOX_STEEL_Plus_V2",
    "Model": "VOX STEEL Plus"
  },
  {
    "Retail Branding": "Iris",
    "Marketing Name": "VOX Alpha",
    "Device": "VOX_Alpha",
    "Model": "VOX Alpha"
  },
  {
    "Retail Branding": "Iris",
    "Marketing Name": "VOX Alpha Plus",
    "Device": "VOX_Alpha_Plus",
    "Model": "VOX Alpha Plus"
  },
  {
    "Retail Branding": "Iris",
    "Marketing Name": "VOX POP Pro",
    "Device": "VOX_POP_Pro",
    "Model": "VOX POP Pro"
  },
  {
    "Retail Branding": "Iris",
    "Marketing Name": "VOX POP plus",
    "Device": "VOX_POP_plus",
    "Model": "VOX POP plus"
  },
  {
    "Retail Branding": "Iris",
    "Marketing Name": "Vox_5S",
    "Device": "Vox_5S",
    "Model": "Vox_5S"
  },
  {
    "Retail Branding": "Isafe",
    "Marketing Name": "IS330",
    "Device": "IS330",
    "Model": "IS330"
  },
  {
    "Retail Branding": "Isafe",
    "Marketing Name": "IS520",
    "Device": "IS520",
    "Model": "IS520"
  },
  {
    "Retail Branding": "Isafe",
    "Marketing Name": "IS520.1",
    "Device": "IS520_1",
    "Model": "IS520_1"
  },
  {
    "Retail Branding": "Isafe",
    "Marketing Name": "IS530",
    "Device": "IS530",
    "Model": "IS530"
  },
  {
    "Retail Branding": "Isafe",
    "Marketing Name": "IS655",
    "Device": "IS655",
    "Model": "IS655"
  },
  {
    "Retail Branding": "Isafe",
    "Marketing Name": "IS880",
    "Device": "IS880",
    "Model": "IS880"
  },
  {
    "Retail Branding": "Isafe",
    "Marketing Name": "IS910.1",
    "Device": "IS910_1",
    "Model": "IS910_1"
  },
  {
    "Retail Branding": "Isafe",
    "Marketing Name": "IS930",
    "Device": "IS930",
    "Model": "IS930"
  },
  {
    "Retail Branding": "Isafe",
    "Marketing Name": "IS940",
    "Device": "IS940",
    "Model": "IS940"
  },
  {
    "Retail Branding": "Iskon",
    "Marketing Name": "Iskon.Play TV",
    "Device": "HY44G",
    "Model": "Iskon.Play TV"
  },
  {
    "Retail Branding": "Iskon",
    "Marketing Name": "Iskon.TV",
    "Device": "wh220_iskon",
    "Model": "Iskon.TV"
  },
  {
    "Retail Branding": "Iskon",
    "Marketing Name": "wh220_iskon",
    "Device": "wh220_iskon",
    "Model": "Iskon.TV"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "A05S",
    "Device": "itel-A663L",
    "Model": "itel A663L"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "A05s",
    "Device": "itel-A663L",
    "Model": "itel A663L"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "A05s",
    "Device": "itel-A663LC",
    "Model": "itel A663LC"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "A11",
    "Device": "itel_A11",
    "Model": "itel A11"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "A12",
    "Device": "itel_A12",
    "Model": "itel A12"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "A13",
    "Device": "itel_A13",
    "Model": "itel A13"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "A13 Plus",
    "Device": "itel-A13Plus",
    "Model": "itel A13Plus"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "A14",
    "Device": "itel-A14",
    "Model": "itel A14RU"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "A15",
    "Device": "itel-A15",
    "Model": "itel A15"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "A15",
    "Device": "itel-A15",
    "Model": "itel A15R"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "A17",
    "Device": "itel-W5006X",
    "Model": "itel W5006X"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "A21",
    "Device": "itel_A21",
    "Model": "itel A21"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "A22",
    "Device": "itel-A22",
    "Model": "itel A22"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "A22 Pro",
    "Device": "itel-A22-Pro",
    "Model": "itel A22 Pro"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "A23",
    "Device": "itel-A23F",
    "Model": "itel A23P"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "A23",
    "Device": "itel-L5006",
    "Model": "itel L5006"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "A23 Pro",
    "Device": "itel-L5006",
    "Model": "itel L5006"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "A23 Pro",
    "Device": "itel-L5006C",
    "Model": "itel L5006C"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "A23 Pro",
    "Device": "itel-L5006S",
    "Model": "itel L5006S"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "A25",
    "Device": "itel-L5002",
    "Model": "itel L5002"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "A25 Pro",
    "Device": "itel-L5002P",
    "Model": "itel L5002P"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "A26",
    "Device": "itel-A571L",
    "Model": "itel A571L"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "A26",
    "Device": "itel-A571LK",
    "Model": "itel A571LK"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "A26",
    "Device": "itel-A571LL",
    "Model": "itel A571LL"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "A31 Plus",
    "Device": "itel-A31Plus",
    "Model": "itel A31Plus"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "A32F",
    "Device": "itel-A32F",
    "Model": "itel A32F"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "A35",
    "Device": "itel-W5002",
    "Model": "itel W5002"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "A37",
    "Device": "itel-A571W",
    "Model": "itel A571W"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "A41",
    "Device": "itel_A41",
    "Model": "itel A41"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "A41 Plus",
    "Device": "itel_A41Plus",
    "Model": "itel A41 Plus"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "A43",
    "Device": "itel-A43",
    "Model": "itel A43"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "A44",
    "Device": "itel-A44",
    "Model": "itel A44"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "A44 Air",
    "Device": "itel-L5502",
    "Model": "itel L5502"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "A44 Pro",
    "Device": "itel-A44-Pro",
    "Model": "itel A44 Pro"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "A45",
    "Device": "itel-A45",
    "Model": "itel A45"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "A46",
    "Device": "itel-L5503",
    "Model": "itel L5503"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "A46",
    "Device": "itel-L5503L",
    "Model": "itel L5503L"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "A49",
    "Device": "itel-A661L",
    "Model": "itel A661L"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "A50",
    "Device": "itel-A667L",
    "Model": "itel A667L"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "A51",
    "Device": "itel_A51",
    "Model": "itel A51"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "A512W",
    "Device": "itel-A512W",
    "Model": "itel A512W"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "A515W",
    "Device": "itel-A515W",
    "Model": "itel A515W"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "A52B",
    "Device": "itel-A52B",
    "Model": "itel A52B"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "A55",
    "Device": "itel-W6003",
    "Model": "itel W6003"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "A58",
    "Device": "itel-A661W",
    "Model": "itel A661W"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "A58 Lite",
    "Device": "itel-A631W",
    "Model": "itel A631W"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "A58 Pro",
    "Device": "itel-A661WP",
    "Model": "itel A661WP"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "A58 lite",
    "Device": "itel-A631W",
    "Model": "itel A631W"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "A62",
    "Device": "itel-A62",
    "Model": "itel A62"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "A671L-OP",
    "Device": "itel-A671L",
    "Model": "itel A671L"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "A70",
    "Device": "itel-A665L",
    "Model": "itel A665L"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "A90",
    "Device": "itel-A6610L",
    "Model": "itel A6610L"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "City100",
    "Device": "itel-C671L",
    "Model": "itel C671L"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "F311",
    "Device": "Spice-F311",
    "Model": "Spice F311"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "F3116",
    "Device": "itel-A571WM",
    "Model": "itel A571W"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "F3116",
    "Device": "itel-A571WM",
    "Model": "itel A571WM"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "G4310IE",
    "Device": "ikebukuro",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "G4350",
    "Device": "beaudry",
    "Model": "itel AndroidTV"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "G5524BE",
    "Device": "samseong",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "G5550",
    "Device": "barking",
    "Model": "itel Android TV"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "ITEL",
    "Device": "stanford",
    "Model": "SMART TV"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "ITEL",
    "Device": "zhongshan",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "ITELL_K4700Q",
    "Device": "ITELL_K4700Q",
    "Model": "ITELL K4700Q"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "ITELMOBILE GP10X2019",
    "Device": "GP10X2019",
    "Model": "GP10X2019"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "Itel A58 Lite",
    "Device": "itel-A631W",
    "Model": "itel A631W"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "Orange Nola Up",
    "Device": "Nola_Up",
    "Model": "Orange Nola up"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "Orange Nola fun 3",
    "Device": "Nola_fun_3",
    "Model": "Orange Nola fun 3"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "P11",
    "Device": "itel_P11",
    "Model": "itel P11"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "P11025G-IN",
    "Device": "itel-P11025G",
    "Model": "itel P11025G"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "P1102GT-OP",
    "Device": "itel-P1102GT",
    "Model": "itel P1102GT"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "P12",
    "Device": "itel_P12",
    "Model": "itel P12"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "P13",
    "Device": "itel-P13",
    "Model": "itel P13"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "P13 Plus",
    "Device": "itel-P13-Plus",
    "Model": "itel P13 Plus"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "P13001L",
    "Device": "itel-P13001L",
    "Model": "itel P13001L"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "P15",
    "Device": "itel-W5005",
    "Model": "itel W5005"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "P15",
    "Device": "itel-W5005P",
    "Model": "itel W5005P"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "P31",
    "Device": "itel-P31",
    "Model": "itel P31"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "P32",
    "Device": "itel-P32",
    "Model": "itel P32"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "P33",
    "Device": "itel-W5504",
    "Model": "itel W5504"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "P33 Plus",
    "Device": "itel-W6001",
    "Model": "itel W6001"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "P36",
    "Device": "itel-W6501",
    "Model": "itel W6501"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "P37",
    "Device": "itel-P651W",
    "Model": "itel P651W"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "P37 Pro（Vision2 Plus）",
    "Device": "itel-P681LM",
    "Model": "itel P681LM"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "P38",
    "Device": "itel-P661W",
    "Model": "itel P661W"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "P51",
    "Device": "P51",
    "Model": "itel P51"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "P65",
    "Device": "itel-P671L",
    "Model": "itel P671L"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "P65",
    "Device": "itel-P671LN",
    "Model": "itel P671LN"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "POWER 80",
    "Device": "itel-P685L",
    "Model": "itel P685L"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "Pad  1 mini",
    "Device": "itel-IKP-31",
    "Model": "IKP-31"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "Pad-2",
    "Device": "itel-Pad-2",
    "Model": "itel-P10002L"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "Pad1",
    "Device": "itel-P10001L",
    "Model": "itel P10001L"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "Pad2 mini",
    "Device": "itel-Pad",
    "Model": "itel-P8002L"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "Prime 4",
    "Device": "itel_Prime4",
    "Model": "itel Prime 4"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "S11",
    "Device": "S11",
    "Model": "itel S11"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "S11 Plus",
    "Device": "S11Plus",
    "Model": "itel S11 Plus"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "S11 Plus",
    "Device": "S11Plus",
    "Model": "itel S11Plus"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "S11 Pro",
    "Device": "itel-S11-Pro",
    "Model": "itel S11 Pro"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "S11X",
    "Device": "itel-S11X",
    "Model": "itel S11X"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "S13",
    "Device": "itel-S13",
    "Model": "itel S13"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "S13",
    "Device": "itel-S13Pro",
    "Model": "itel S13 Pro"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "S15",
    "Device": "itel-W6002",
    "Model": "itel W6002"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "S15",
    "Device": "itel-W6002E",
    "Model": "itel W6002E"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "S15 Pro(VISION)",
    "Device": "itel-L6002P",
    "Model": "itel L6002P"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "S16",
    "Device": "itel-W6502",
    "Model": "itel W6502"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "S21",
    "Device": "itel-S21",
    "Model": "itel S21"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "S31",
    "Device": "S31",
    "Model": "itel S31"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "S32",
    "Device": "itel-S32",
    "Model": "itel S32"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "S32 Mini",
    "Device": "itel-W5003",
    "Model": "itel W5003"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "S33",
    "Device": "itel-S33",
    "Model": "itel S33"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "S41",
    "Device": "itel_S41",
    "Model": "itel S41"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "S42",
    "Device": "itel-S42",
    "Model": "itel S42"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "SP591",
    "Device": "itel-W6004",
    "Model": "itel W6004"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "Smart TV",
    "Device": "redwood",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "VIMOQ A19S",
    "Device": "VIMOQ-A507LA",
    "Model": "VIMOQ A507LA"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "VIMOQ A19S",
    "Device": "VIMOQ-A507LT",
    "Model": "VIMOQ A507LT"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "Vision 3",
    "Device": "itel-S661LP",
    "Model": "itel S661LP"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "Vision 3",
    "Device": "itel-S661LPN",
    "Model": "itel S661LPN"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "Vision1",
    "Device": "itel-L6005",
    "Model": "itel L6005"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "Vision1 Plus(P36 Pro LTE)",
    "Device": "itel-L6501",
    "Model": "itel L6501"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "Vision1Pro",
    "Device": "itel-L6502",
    "Model": "itel L6502"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "W4001S",
    "Device": "itel-W4001S",
    "Model": "itel W4001S"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "WOW TV",
    "Device": "umeda",
    "Model": "WOW TV"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "it1355",
    "Device": "itel_it1355",
    "Model": "itel it1355"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "it1355M",
    "Device": "itel_it1355M",
    "Model": "itel it1355M"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "it1407",
    "Device": "itel_it1407",
    "Model": "itel it1407"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "it1408",
    "Device": "itel_it1408",
    "Model": "itel it1408"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "it1408",
    "Device": "itel_it1408C",
    "Model": "itel it1408"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "it1409",
    "Device": "itel_it1409",
    "Model": "itel it1409"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "it1460",
    "Device": "itel-it1460-Pro",
    "Model": "itel it1460"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "it1460",
    "Device": "itel-it1460-Pro",
    "Model": "itel it1460 Pro"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "it1505",
    "Device": "itel_it1505",
    "Model": "itel_it1505"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "it1506",
    "Device": "itel_it1506",
    "Model": "itel it1506"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "it1507",
    "Device": "itel_it1507",
    "Model": "itel it1507"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "it1507",
    "Device": "itel_it1507C",
    "Model": "itel it1507"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "it1508",
    "Device": "itel_it1508",
    "Model": "itel it1508"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "it1508",
    "Device": "itel_it1508C",
    "Model": "itel it1508"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "it1508",
    "Device": "itel_it1508C",
    "Model": "itel it1508 GPS"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "it1508 Plus",
    "Device": "itel_it1508Plus",
    "Model": "itel it1508"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "it1508 Plus",
    "Device": "itel_it1508Plus",
    "Model": "itel it1508 Plus"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "it1512",
    "Device": "it1512",
    "Model": "it1512"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "it1513",
    "Device": "itel_it1513",
    "Model": "itel it1513"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "it1516 Plus",
    "Device": "itel_it1516Plus",
    "Model": "itel it1516 Plus"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "it1518",
    "Device": "itel_it1518",
    "Model": "itel it1518"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "it1520",
    "Device": "itel-it1520",
    "Model": "itel-it1520"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "it1550",
    "Device": "itel_it1550",
    "Model": "itel_it1550"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "it1551",
    "Device": "itel_it1551",
    "Model": "itel it1551"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "it1551",
    "Device": "itel_it1551C",
    "Model": "itel it1551"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "it1553",
    "Device": "itel-it1553",
    "Model": "itel-it1553"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "it1556",
    "Device": "itel_it1556",
    "Model": "itel it1556"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "it1556 Plus",
    "Device": "itel_it1556Plus",
    "Model": "itel it1556 Plus"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "it1556 Plus",
    "Device": "itel_it1556Plus",
    "Model": "itel it1556 plus"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "it1655",
    "Device": "itel_it1655",
    "Model": "itel it1655"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "it1655S",
    "Device": "itel_it1655S",
    "Model": "itel it1655S"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "it1702",
    "Device": "itel_it1702",
    "Model": "itel it1702"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "it1703",
    "Device": "itel_it1703",
    "Model": "itel it1703"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel  A24",
    "Device": "itel-A507LN",
    "Model": "itel A507LN"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel  A24 2023",
    "Device": "itel-A507LX",
    "Model": "itel A507LX"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel  A48",
    "Device": "itel-L6006F",
    "Model": "itel L6006F"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel  A58 Lite",
    "Device": "itel-A631W-R2",
    "Model": "itel A631W"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel  AC50",
    "Device": "itel-A507LM",
    "Model": "itel A507LM"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel  V51 LTE",
    "Device": "itel-A507LP",
    "Model": "itel A507LP"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel 4K TV",
    "Device": "SW4H",
    "Model": "itel 4K TV"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel A04",
    "Device": "itel-A632W",
    "Model": "itel A632W"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel A04",
    "Device": "itel-A632WM",
    "Model": "itel A632WM"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel A04s",
    "Device": "itel-A632L",
    "Model": "itel A632L"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel A100",
    "Device": "itel-A673L",
    "Model": "itel A673L"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel A100C",
    "Device": "itel-A6611L",
    "Model": "itel A6611L"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel A11",
    "Device": "itel_A11",
    "Model": "itel A11"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel A14",
    "Device": "itel-A14",
    "Model": "itel A14"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel A14",
    "Device": "itel-A14",
    "Model": "itel A14TZ"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel A14 Max",
    "Device": "itel-W4003",
    "Model": "itel W4003"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel A14 Plus",
    "Device": "itel-W4002",
    "Model": "itel W4002"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel A14S",
    "Device": "itel-A14S",
    "Model": "itel A14S"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel A16",
    "Device": "itel-A16",
    "Model": "itel A16"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel A16",
    "Device": "itel-A16",
    "Model": "itel A16TZ"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel A16",
    "Device": "itel-A16-BD",
    "Model": "itel A16"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel A16 Plus",
    "Device": "itel-A16-Plus",
    "Model": "itel A16 Plus"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel A16 Plus",
    "Device": "itel-A16-Plus",
    "Model": "itel A16 Plus RU"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel A16 Plus",
    "Device": "itel-A16-Plus-BD",
    "Model": "itel A16 Plus"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel A17",
    "Device": "itel-W5006X",
    "Model": "itel W5006X"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel A18",
    "Device": "itel-A512W",
    "Model": "itel A512W"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel A18s",
    "Device": "itel-A513W",
    "Model": "itel A513W"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel A20",
    "Device": "itel-A20",
    "Model": "itel A20"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel A200",
    "Device": "itel-A675L",
    "Model": "itel A675L"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel A200+",
    "Device": "itel-A676L",
    "Model": "itel A676L"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel A23",
    "Device": "itel-A23",
    "Model": "itel A23"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel A23",
    "Device": "itel-A23",
    "Model": "itel A23R"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel A23",
    "Device": "itel-A23F",
    "Model": "itel A23"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel A23",
    "Device": "itel-A23S",
    "Model": "itel A23S"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel A23S",
    "Device": "itel-A511LQ",
    "Model": "itel A511LQ"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel A24",
    "Device": "itel-A507LM",
    "Model": "itel A507LM"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel A24",
    "Device": "itel-A507LN",
    "Model": "itel A507LN"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel A24",
    "Device": "itel-A507LS",
    "Model": "itel A507LS"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel A24",
    "Device": "itel-L5007",
    "Model": "itel L5007"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel A24 2023",
    "Device": "itel-A507LC",
    "Model": "itel A507LC"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel A24 2023",
    "Device": "itel-A507LNP",
    "Model": "itel A507LNP"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel A24 2023",
    "Device": "itel-A507LSP",
    "Model": "itel A507LSP"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel A24 Pro",
    "Device": "itel-A507LSU",
    "Model": "itel A507LSU"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel A24 Pro",
    "Device": "itel-A511LP2",
    "Model": "itel A511LP"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel A25",
    "Device": "itel-L5002R",
    "Model": "itel L5002"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel A27(P17 Pro 4G)",
    "Device": "itel-A551L",
    "Model": "itel A551L"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel A27(P17 Pro 4G)",
    "Device": "itel-A551L-Pro",
    "Model": "itel A551L"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel A31",
    "Device": "itel_A31",
    "Model": "itel A31"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel A33 Plus",
    "Device": "itel-A509WP",
    "Model": "itel A509WP"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel A36",
    "Device": "itel-W5505",
    "Model": "itel W5505"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel A40",
    "Device": "itel-A40",
    "Model": "itel A40"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel A41",
    "Device": "itel_A41",
    "Model": "itel A41"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel A42 Plus",
    "Device": "itel-A42Plus",
    "Model": "itel A42 Plus"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel A44 Air",
    "Device": "itel-L5502S",
    "Model": "itel L5502S"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel A44 Power",
    "Device": "itel-A44-Power",
    "Model": "itel A44 Power"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel A45",
    "Device": "itel-A45",
    "Model": "itel A45"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel A47",
    "Device": "itel-L5505",
    "Model": "itel L5505"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel A48",
    "Device": "itel-L6006",
    "Model": "itel L6006"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel A48",
    "Device": "itel-L6006L",
    "Model": "itel L6006L"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel A49 Play",
    "Device": "itel-A631L",
    "Model": "itel A631L"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel A50",
    "Device": "itel-A667L",
    "Model": "itel A667L"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel A50",
    "Device": "itel-A667LP",
    "Model": "itel A667LP"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel A50C",
    "Device": "itel-A669L",
    "Model": "itel A669L"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel A510W",
    "Device": "itel-A510W",
    "Model": "itel A510W"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel A52",
    "Device": "itel-A52",
    "Model": "itel A52"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel A52 Lite",
    "Device": "itel-A52-Lite",
    "Model": "itel A52 Lite"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel A52S Lite",
    "Device": "itel-A52S-Lite",
    "Model": "itel A52S Lite"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel A55 LTE",
    "Device": "itel-L6003P",
    "Model": "itel L6003P"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel A56 LTE",
    "Device": "itel-L6004",
    "Model": "itel L6004"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel A56 Pro",
    "Device": "itel-W6004P",
    "Model": "itel W6004P"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel A56 Pro LTE",
    "Device": "itel-L6004P",
    "Model": "itel L6004P"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel A57",
    "Device": "itel-A611W",
    "Model": "itel A611W"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel A57 2GB",
    "Device": "itel-A611WP",
    "Model": "itel A611WP"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel A58 Lite",
    "Device": "itel-A631W",
    "Model": "itel A631W"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel A58 Lite",
    "Device": "itel-A631W-R2",
    "Model": "itel A631W"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel A58 lite",
    "Device": "itel-A631W",
    "Model": "itel A631W"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel A58 lite",
    "Device": "itel-A631W-R2",
    "Model": "itel A631W"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel A60",
    "Device": "itel-A662L",
    "Model": "itel A662L"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel A60E",
    "Device": "itel-A662L",
    "Model": "itel A662L"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel A60S",
    "Device": "itel-A662LM",
    "Model": "itel A662LM"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel A60s",
    "Device": "itel-A662LM",
    "Model": "itel A662LM"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel A662L",
    "Device": "itel-A662L",
    "Model": "itel A662L"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel A80",
    "Device": "itel-A671LC",
    "Model": "itel A671LC"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel A90",
    "Device": "itel-A6610L",
    "Model": "itel A6610L"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel A95 5G",
    "Device": "itel-A671N",
    "Model": "itel A671N"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel AC12",
    "Device": "itel-A14",
    "Model": "itel A14"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel AC13",
    "Device": "itel-W4001",
    "Model": "itel W4001"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel AC13",
    "Device": "itel-W4001P",
    "Model": "itel W4001P"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel AC32",
    "Device": "itel-A16S",
    "Model": "itel A16S"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel AC32",
    "Device": "itel-W5004",
    "Model": "itel W5004"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel AC50",
    "Device": "itel-A507LMO",
    "Model": "itel A507LMO"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel AC50",
    "Device": "itel-L5007D",
    "Model": "itel L5007D"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel AC50 Pro",
    "Device": "itel-A507LMO",
    "Model": "itel A507LMO"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel AC51",
    "Device": "itel-A507LMU",
    "Model": "itel A507LMU"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel AC60",
    "Device": "itel-L6004L",
    "Model": "itel L6004L"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel Alpha Lite",
    "Device": "itel-W5008",
    "Model": "itel W5008"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel CITY 200",
    "Device": "itel-C681L",
    "Model": "itel C681L"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel CITY 200",
    "Device": "itel-C681LN",
    "Model": "itel C681LN"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel CITY 200+",
    "Device": "itel-C672L",
    "Model": "itel C672L"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel City100",
    "Device": "itel-C671L",
    "Model": "itel C671L"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel KidPad 1",
    "Device": "Itel-W7001",
    "Model": "Itel W7001"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel L5007A",
    "Device": "itel-L5007A",
    "Model": "itel L5007A"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel L5007S",
    "Device": "itel-L5007S",
    "Model": "itel L5007S"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel L6006F",
    "Device": "itel-L6006F",
    "Model": "itel L6006F"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel L6006S",
    "Device": "itel-L6006S",
    "Model": "itel L6006S"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel MC20",
    "Device": "itel-A23F",
    "Model": "itel A23"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel P17",
    "Device": "itel-P551W",
    "Model": "itel P551W"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel P17 Pro",
    "Device": "itel-P552W",
    "Model": "itel P552W"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel P37 Pro(Vision2 Plus)",
    "Device": "itel-P681L",
    "Model": "itel P681L"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel P38 Pro(Vision 3 Plus)",
    "Device": "itel-P682L",
    "Model": "itel P682L"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel P40",
    "Device": "itel-P662L",
    "Model": "itel P662L"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel P40+",
    "Device": "itel-P683L",
    "Model": "itel P683L"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel P41",
    "Device": "itel_P41",
    "Model": "itel P41"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel P55",
    "Device": "itel-A666L",
    "Model": "itel A666L"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel P55",
    "Device": "itel-A666LN",
    "Model": "itel A666LN"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel P55 5G",
    "Device": "itel-P661N",
    "Model": "itel P661N"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel P55+",
    "Device": "itel-P663L",
    "Model": "itel P663L"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel P55+",
    "Device": "itel-P663LN",
    "Model": "itel P663LN"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel P55T",
    "Device": "itel-P665L",
    "Model": "itel P665L"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel P65",
    "Device": "itel-P671L",
    "Model": "itel P671L"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel P65",
    "Device": "itel-P671LN",
    "Model": "itel P671LN"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel P65C",
    "Device": "itel-P666L",
    "Model": "itel P666L"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel Prime 4",
    "Device": "itel_Prime4",
    "Model": "itel Prime 4"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel PrimeTab 1",
    "Device": "itel-W7002",
    "Model": "itel W7002"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel PrimeTab 1",
    "Device": "itel-W7002P",
    "Model": "itel W7002P"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel RS4",
    "Device": "itel-S666LN",
    "Model": "itel S666LN"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel S12",
    "Device": "itel-S12",
    "Model": "itel S12"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel S16 Pro",
    "Device": "itel-W6503",
    "Model": "itel W6503"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel S16 Pro（Vision 2）",
    "Device": "itel-L6503",
    "Model": "itel L6503"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel S17",
    "Device": "itel-S661W",
    "Model": "itel S661W"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel S18",
    "Device": "itel-S663L",
    "Model": "itel S663L"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel S18 Pro",
    "Device": "itel-S662L",
    "Model": "itel S662L"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel S23",
    "Device": "itel-S665L",
    "Model": "itel S665L"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel S23",
    "Device": "itel-S665LN",
    "Model": "itel S665LN"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel S23+",
    "Device": "itel-S681LN",
    "Model": "itel S681LN"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel S24",
    "Device": "itel-S667LN",
    "Model": "itel S667LN"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel S25",
    "Device": "itel-S685LN",
    "Model": "itel S685LN"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel S25 Ultra",
    "Device": "itel-S686LN",
    "Model": "itel S686LN"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel S32LTE",
    "Device": "itel-S32LTE",
    "Model": "itel S32LTE"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel Super 26 Ultra",
    "Device": "itel-S688LN",
    "Model": "itel S688LN"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel TV",
    "Device": "shibuya",
    "Model": "itel TV"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel V41",
    "Device": "itel-W4001S",
    "Model": "itel W4001S"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel V51 LTE",
    "Device": "itel-L5007S",
    "Model": "itel L5007S"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel V52 lite",
    "Device": "itel-A507LV",
    "Model": "itel A507LV"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel V52A",
    "Device": "itel-A507LX",
    "Model": "itel A507LX"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel V52A",
    "Device": "itel-A507LXU",
    "Model": "itel A507LXU"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel V52LTE",
    "Device": "itel-A507LV",
    "Model": "itel A507LV"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel V53",
    "Device": "itel-A507LVU",
    "Model": "itel A507LVU"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel VISION 5 Plus",
    "Device": "itel-S662LCN",
    "Model": "itel S662LCN"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel Vision 3",
    "Device": "itel-S661L",
    "Model": "itel S661L"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel Vision 3",
    "Device": "itel-S661LN",
    "Model": "itel S661LN"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel Vision 3 Plus",
    "Device": "itel-P682LPN",
    "Model": "itel P682LPN"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel Vision 3 Plus(P38 Pro)",
    "Device": "itel-P682LP",
    "Model": "itel P682LP"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel Vision 5",
    "Device": "itel-S663LC",
    "Model": "itel S663LC"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel Vision1(P36 Play)",
    "Device": "itel-L6005",
    "Model": "itel L6005"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel Vision2s",
    "Device": "itel-P651L",
    "Model": "itel P651L"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel VistaTab  30",
    "Device": "itel-P10003L",
    "Model": "itel P10003L"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel VistaTab 10",
    "Device": "itel-P10004L",
    "Model": "itel P10004L"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel VistaTab 11",
    "Device": "itel-P10005L",
    "Model": "itel P10005L"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel VistaTab 30S",
    "Device": "itel-P11002L",
    "Model": "itel P11002L"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel VistaTab go",
    "Device": "itel-P08003L",
    "Model": "itel P08003L"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel W4001",
    "Device": "itel-W4001",
    "Model": "itel W4001"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel W4001O",
    "Device": "itel-W4001O",
    "Model": "itel W4001O"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel W4001OZ",
    "Device": "itel-W4001OZ",
    "Model": "itel W4001O"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel W4001SZ",
    "Device": "itel-W4001SZ",
    "Model": "itel W4001S"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel W4001Z",
    "Device": "itel-W4001Z",
    "Model": "itel W4001"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel W4002P",
    "Device": "itel-W4002P",
    "Model": "itel W4002"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel W4003",
    "Device": "itel-W4003",
    "Model": "itel W4003"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel W5001P",
    "Device": "itel-W5001P",
    "Model": "itel W5001P"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel W5004D",
    "Device": "itel-W5004D",
    "Model": "itel W5004D"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel W5004DZ",
    "Device": "itel-W5004DZ",
    "Model": "itel W5004D"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel W5004V",
    "Device": "itel-W5004V",
    "Model": "itel W5004V"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel W5004VZ",
    "Device": "itel-W5004VZ",
    "Model": "itel W5004V"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel W5503",
    "Device": "itel-W5503",
    "Model": "itel W5503"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel-A16-Plus",
    "Device": "itel-A16-Plus",
    "Model": "itel A16 Plus"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel-A510W",
    "Device": "itel-A510W",
    "Model": "itel A510W"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel-IKP-31",
    "Device": "itel-IKP-31",
    "Model": "IKP-31"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel-L5007S",
    "Device": "itel-L5007S",
    "Model": "itel L5007S"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel-Pad-2",
    "Device": "itel-Pad-2",
    "Model": "itel-P10002L"
  },
  {
    "Retail Branding": "Itel",
    "Marketing Name": "itel-Pad-2-Pro",
    "Device": "itel-Pad-2-Pro",
    "Model": "itel-P10002LP"
  },
  {
    "Retail Branding": "Itworks",
    "Marketing Name": "TM705",
    "Device": "TM705",
    "Model": "NID_7010"
  },
  {
    "Retail Branding": "J-COM (cn)",
    "Marketing Name": "SC40",
    "Device": "SC40",
    "Model": "SC40"
  },
  {
    "Retail Branding": "J:COM",
    "Marketing Name": "KSTB7043",
    "Device": "KSTB6165",
    "Model": "KSTB7043"
  },
  {
    "Retail Branding": "J:COM",
    "Marketing Name": "XA401",
    "Device": "XA401",
    "Model": "XA401"
  },
  {
    "Retail Branding": "J:COM",
    "Marketing Name": "XA402",
    "Device": "XA402",
    "Model": "XA402"
  },
  {
    "Retail Branding": "J:COM",
    "Marketing Name": "XA403",
    "Device": "sti6260d195",
    "Model": "XA403"
  },
  {
    "Retail Branding": "JAV Smart-box",
    "Marketing Name": "Smart-box",
    "Device": "rk3588_t",
    "Model": "BOX_1"
  },
  {
    "Retail Branding": "JAV Smartboard",
    "Marketing Name": "Flagship model",
    "Device": "rk3588_t",
    "Model": "LEDxxH16S"
  },
  {
    "Retail Branding": "JAV Smartboard",
    "Marketing Name": "H10S_PRO-Series",
    "Device": "mt9679_u",
    "Model": "LEDxxH10S_PRO"
  },
  {
    "Retail Branding": "JAY-TECH",
    "Marketing Name": "TPC-G1010",
    "Device": "TPC-G1010_EEA",
    "Model": "TPC-G1010"
  },
  {
    "Retail Branding": "JAY-TECH",
    "Marketing Name": "TPC-G1011LTE",
    "Device": "TPC-G1011LTE",
    "Model": "TPC-G1011LTE"
  },
  {
    "Retail Branding": "JAY-TECH",
    "Marketing Name": "TPC-G109_EEA",
    "Device": "TPC-G109",
    "Model": "TPC-G109"
  },
  {
    "Retail Branding": "JCB_Phone",
    "Marketing Name": "ToughPhone_E10_EEA",
    "Device": "ToughPhone_E10",
    "Model": "Toughphone E10"
  },
  {
    "Retail Branding": "JCB_UK",
    "Marketing Name": "JCB_TP231",
    "Device": "JCB_TP231",
    "Model": "JCB TP231"
  },
  {
    "Retail Branding": "JECTNOTE",
    "Marketing Name": "Interactive_whiteboard",
    "Device": "JT_PH86TOC",
    "Model": "JT_PH86TOC"
  },
  {
    "Retail Branding": "JECTOR",
    "Marketing Name": "FM-U",
    "Device": "FM-U",
    "Model": "FM-U"
  },
  {
    "Retail Branding": "JECTOR",
    "Marketing Name": "FM-VSeries",
    "Device": "FM-VSeries",
    "Model": "FM-VSeries"
  },
  {
    "Retail Branding": "JEEMAK",
    "Marketing Name": "M70",
    "Device": "M70",
    "Model": "M70"
  },
  {
    "Retail Branding": "JEEMAK",
    "Marketing Name": "M70E",
    "Device": "M70E",
    "Model": "M70E"
  },
  {
    "Retail Branding": "JHZL",
    "Marketing Name": "J101",
    "Device": "J101",
    "Model": "J101"
  },
  {
    "Retail Branding": "JHZL",
    "Marketing Name": "J101-EEA",
    "Device": "J101-EEA",
    "Model": "J101-EEA"
  },
  {
    "Retail Branding": "JIZHAO",
    "Marketing Name": "JZP57",
    "Device": "JZP57",
    "Model": "JZP57"
  },
  {
    "Retail Branding": "JLC ELECTRONICS",
    "Marketing Name": "Colombia",
    "Device": "sepolia",
    "Model": "JLC 4K GOOGLE TV"
  },
  {
    "Retail Branding": "JLT Mobile",
    "Marketing Name": "JLT6012A",
    "Device": "JLT6012A",
    "Model": "JLT6012A"
  },
  {
    "Retail Branding": "JLab",
    "Marketing Name": "PRO-7",
    "Device": "polaris-p1gms",
    "Model": "JLab PRO-7"
  },
  {
    "Retail Branding": "JMGO",
    "Marketing Name": "C61A",
    "Device": "holan",
    "Model": "C61A"
  },
  {
    "Retail Branding": "JMGO",
    "Marketing Name": "C62A",
    "Device": "holan",
    "Model": "C62A"
  },
  {
    "Retail Branding": "JMGO",
    "Marketing Name": "K62A",
    "Device": "holan",
    "Model": "K62A"
  },
  {
    "Retail Branding": "JMGO",
    "Marketing Name": "K80A",
    "Device": "holan",
    "Model": "K80A"
  },
  {
    "Retail Branding": "JMGO",
    "Marketing Name": "N1S Infinity",
    "Device": "lonavla",
    "Model": "K92A"
  },
  {
    "Retail Branding": "JMGO",
    "Marketing Name": "N1S Pro",
    "Device": "lonavla",
    "Model": "K93A"
  },
  {
    "Retail Branding": "JMGO",
    "Marketing Name": "S91A",
    "Device": "lonavla",
    "Model": "S91A"
  },
  {
    "Retail Branding": "JMGO",
    "Marketing Name": "V62A",
    "Device": "holan",
    "Model": "V62A"
  },
  {
    "Retail Branding": "JMTMEDIA",
    "Marketing Name": "e_Smart",
    "Device": "e_Smart",
    "Model": "e_Smart"
  },
  {
    "Retail Branding": "JOVI",
    "Marketing Name": "JOVI V50 Lite 5G",
    "Device": "V2440B",
    "Model": "V2440"
  },
  {
    "Retail Branding": "JOVI",
    "Marketing Name": "JOVI V70 5G",
    "Device": "J2507",
    "Model": "J2507"
  },
  {
    "Retail Branding": "JOVI",
    "Marketing Name": "JOVI Y19s",
    "Device": "V2419B",
    "Model": "V2425"
  },
  {
    "Retail Branding": "JOVI",
    "Marketing Name": "JOVI Y19s",
    "Device": "V2419B",
    "Model": "V2454"
  },
  {
    "Retail Branding": "JOVI",
    "Marketing Name": "JOVI Y21",
    "Device": "J2503",
    "Model": "J2503"
  },
  {
    "Retail Branding": "JOVI",
    "Marketing Name": "JOVI Y21 5G",
    "Device": "J2508",
    "Model": "J2508"
  },
  {
    "Retail Branding": "JOVI",
    "Marketing Name": "JOVI Y29",
    "Device": "V2434B",
    "Model": "V2445"
  },
  {
    "Retail Branding": "JOVI",
    "Marketing Name": "JOVI Y29s 5G",
    "Device": "V2446B",
    "Model": "V2459"
  },
  {
    "Retail Branding": "JOVI",
    "Marketing Name": "JOVI Y31",
    "Device": "J2506",
    "Model": "J2506"
  },
  {
    "Retail Branding": "JOVI",
    "Marketing Name": "V50",
    "Device": "V2427B",
    "Model": "V2427"
  },
  {
    "Retail Branding": "JOYSURF",
    "Marketing Name": "TB-JS100A",
    "Device": "TB-JS100A",
    "Model": "TB-JS100A"
  },
  {
    "Retail Branding": "JOYSURF",
    "Marketing Name": "TB-JS101A",
    "Device": "TB-JS101A",
    "Model": "TB-JS101A"
  },
  {
    "Retail Branding": "JP Sacouto",
    "Marketing Name": "Flag Mill v2",
    "Device": "MG101A2T_BT",
    "Model": "Flag Mill v2"
  },
  {
    "Retail Branding": "JP Sacouto",
    "Marketing Name": "Flag Mill v2",
    "Device": "MG101A2T_BT_A50",
    "Model": "Flag Mill v2"
  },
  {
    "Retail Branding": "JP Sacouto",
    "Marketing Name": "Flag Mill v2",
    "Device": "MG101A2T_BT_W32",
    "Model": "Flag Mill v2"
  },
  {
    "Retail Branding": "JP Sacouto",
    "Marketing Name": "MOVE_S201",
    "Device": "move_S201_2_32_Z8350",
    "Model": "MOVE_S201"
  },
  {
    "Retail Branding": "JP Sacouto",
    "Marketing Name": "Mini Mill v2",
    "Device": "MG070A2T_BT",
    "Model": "Mini Mill v2"
  },
  {
    "Retail Branding": "JP Sacouto",
    "Marketing Name": "TF10EA2",
    "Device": "TF10EA2_Medical_2",
    "Model": "CASEBOOK_3"
  },
  {
    "Retail Branding": "JP Sacouto",
    "Marketing Name": "Verdite Hill",
    "Device": "JP_MOVE_S101",
    "Model": "Verdite Hill"
  },
  {
    "Retail Branding": "JP Sacouto",
    "Marketing Name": "mymaga CLASS Plus 2",
    "Device": "MG101A4T",
    "Model": "mymaga CLASS Plus 2"
  },
  {
    "Retail Branding": "JREN",
    "Marketing Name": "J10",
    "Device": "J10",
    "Model": "J10"
  },
  {
    "Retail Branding": "JREN",
    "Marketing Name": "J10PLUS",
    "Device": "J10PLUS",
    "Model": "J10PLUS"
  },
  {
    "Retail Branding": "JREN",
    "Marketing Name": "J10PRO",
    "Device": "J10PRO",
    "Model": "J10PRO"
  },
  {
    "Retail Branding": "JREN",
    "Marketing Name": "J11",
    "Device": "J11",
    "Model": "J11"
  },
  {
    "Retail Branding": "JREN",
    "Marketing Name": "J11A",
    "Device": "J11A",
    "Model": "J11A"
  },
  {
    "Retail Branding": "JREN",
    "Marketing Name": "J11B",
    "Device": "J11B",
    "Model": "J11B"
  },
  {
    "Retail Branding": "JREN",
    "Marketing Name": "J11PLUS",
    "Device": "J11PLUS",
    "Model": "J11PLUS"
  },
  {
    "Retail Branding": "JREN",
    "Marketing Name": "J12-1",
    "Device": "J12-1",
    "Model": "J12-1"
  },
  {
    "Retail Branding": "JREN",
    "Marketing Name": "J12NEW",
    "Device": "J12NEW",
    "Model": "J12NEW"
  },
  {
    "Retail Branding": "JREN",
    "Marketing Name": "J7",
    "Device": "J7",
    "Model": "J7"
  },
  {
    "Retail Branding": "JREN",
    "Marketing Name": "JR-101",
    "Device": "JR-101",
    "Model": "JR-101"
  },
  {
    "Retail Branding": "JREN",
    "Marketing Name": "JR-802",
    "Device": "JR-802",
    "Model": "JR-802"
  },
  {
    "Retail Branding": "JREN",
    "Marketing Name": "JR-J10A",
    "Device": "JR-J10A",
    "Model": "JR-J10A"
  },
  {
    "Retail Branding": "JREN",
    "Marketing Name": "JR-J10B",
    "Device": "JR-J10B",
    "Model": "JR-J10B"
  },
  {
    "Retail Branding": "JREN",
    "Marketing Name": "JR-J10C",
    "Device": "JR-J10C",
    "Model": "JR-J10C"
  },
  {
    "Retail Branding": "JREN",
    "Marketing Name": "JR-J71",
    "Device": "JR-J71",
    "Model": "JR-J71"
  },
  {
    "Retail Branding": "JREN",
    "Marketing Name": "JR-J8",
    "Device": "JR-J8",
    "Model": "JR-J8"
  },
  {
    "Retail Branding": "JREN",
    "Marketing Name": "JR_J1063",
    "Device": "JR_J1063",
    "Model": "JR_J1063"
  },
  {
    "Retail Branding": "JREN",
    "Marketing Name": "JR_J7",
    "Device": "JR_J7",
    "Model": "JR_J7"
  },
  {
    "Retail Branding": "JTV",
    "Marketing Name": "Smart TV",
    "Device": "alimos",
    "Model": "JTV Google TV"
  },
  {
    "Retail Branding": "JTV",
    "Marketing Name": "Smart TV",
    "Device": "dangni",
    "Model": "JTV Google TV"
  },
  {
    "Retail Branding": "JTWORKS",
    "Marketing Name": "JTWORKS-IFPD",
    "Device": "rk3588_t",
    "Model": "JTW"
  },
  {
    "Retail Branding": "JTYPAD",
    "Marketing Name": "KT14Pro-EEA",
    "Device": "KT14Pro",
    "Model": "KT14Pro"
  },
  {
    "Retail Branding": "JTYPDA",
    "Marketing Name": "X20L",
    "Device": "X20L",
    "Model": "X20L"
  },
  {
    "Retail Branding": "JUEDUR",
    "Marketing Name": "R500 EEA",
    "Device": "R500_EEA",
    "Model": "R500_EEA"
  },
  {
    "Retail Branding": "JUEDUR",
    "Marketing Name": "R500 US",
    "Device": "R500_US",
    "Model": "R500_US"
  },
  {
    "Retail Branding": "JUEDUR",
    "Marketing Name": "R500_V_EEA",
    "Device": "R500_V_EEA",
    "Model": "R500_V_EEA"
  },
  {
    "Retail Branding": "JUEDUR",
    "Marketing Name": "R500_V_US",
    "Device": "R500_V_US",
    "Model": "R500_V_US"
  },
  {
    "Retail Branding": "JUEDUR",
    "Marketing Name": "R700_EEA",
    "Device": "R700_EEA",
    "Model": "R700_EEA"
  },
  {
    "Retail Branding": "JUEDUR",
    "Marketing Name": "R700_US",
    "Device": "R700_US",
    "Model": "R700_US"
  },
  {
    "Retail Branding": "JUEDUR",
    "Marketing Name": "R800-EU",
    "Device": "R800-EU",
    "Model": "R800-EEA"
  },
  {
    "Retail Branding": "JUEDUR",
    "Marketing Name": "R800_EEA",
    "Device": "R800_EEA",
    "Model": "R800_EEA"
  },
  {
    "Retail Branding": "JUEDUR",
    "Marketing Name": "R800_US",
    "Device": "R800_US",
    "Model": "R800_US"
  },
  {
    "Retail Branding": "JUEDUR",
    "Marketing Name": "R800_U_EEA",
    "Device": "R800_U_EEA",
    "Model": "R800_EEA"
  },
  {
    "Retail Branding": "JUEDUR",
    "Marketing Name": "R800_U_EEA",
    "Device": "R800_U_EEA",
    "Model": "R800_U_EEA"
  },
  {
    "Retail Branding": "JUEDUR",
    "Marketing Name": "R800_U_US",
    "Device": "R800_U_US",
    "Model": "R800_US"
  },
  {
    "Retail Branding": "JUEDUR",
    "Marketing Name": "R800_U_US",
    "Device": "R800_U_US",
    "Model": "R800_U_US"
  },
  {
    "Retail Branding": "JUEDUR",
    "Marketing Name": "R900_EEA",
    "Device": "R900_EEA",
    "Model": "R900_EEA"
  },
  {
    "Retail Branding": "JUEDUR",
    "Marketing Name": "R900_US",
    "Device": "R900_US",
    "Model": "R900_US"
  },
  {
    "Retail Branding": "JUSYEA",
    "Marketing Name": "J10_EEA",
    "Device": "J10_EEA",
    "Model": "J10_EEA"
  },
  {
    "Retail Branding": "JUSYEA",
    "Marketing Name": "J10_US",
    "Device": "J10_US",
    "Model": "J10_US"
  },
  {
    "Retail Branding": "JUSYEA",
    "Marketing Name": "J3",
    "Device": "JUSYEA_J3",
    "Model": "J3"
  },
  {
    "Retail Branding": "JUSYEA",
    "Marketing Name": "J3_EEA",
    "Device": "J3_EEA",
    "Model": "J3"
  },
  {
    "Retail Branding": "JUSYEA",
    "Marketing Name": "J5-EEA",
    "Device": "J5-EEA",
    "Model": "J5-EEA"
  },
  {
    "Retail Branding": "JUSYEA",
    "Marketing Name": "J5_EEA",
    "Device": "J5_EEA",
    "Model": "J5_EEA"
  },
  {
    "Retail Branding": "JUSYEA",
    "Marketing Name": "J5_M",
    "Device": "J5_M",
    "Model": "J5_M"
  },
  {
    "Retail Branding": "JUSYEA",
    "Marketing Name": "J6_EEA",
    "Device": "J6_EEA",
    "Model": "J6_EEA"
  },
  {
    "Retail Branding": "JUSYEA",
    "Marketing Name": "J6_US",
    "Device": "J6_US",
    "Model": "J6_US"
  },
  {
    "Retail Branding": "JUSYEA",
    "Marketing Name": "J8",
    "Device": "J8",
    "Model": "J8"
  },
  {
    "Retail Branding": "JUSYEA",
    "Marketing Name": "J8_EEA",
    "Device": "J8_EEA",
    "Model": "J8_EEA"
  },
  {
    "Retail Branding": "JUSYEA",
    "Marketing Name": "J8_EEA_T",
    "Device": "J8_EEA_T",
    "Model": "J8_EEA"
  },
  {
    "Retail Branding": "JUSYEA",
    "Marketing Name": "J8_T",
    "Device": "J8_T",
    "Model": "J8_US"
  },
  {
    "Retail Branding": "JUSYEA",
    "Marketing Name": "J9_EEA",
    "Device": "J9_EEA",
    "Model": "J9_EEA"
  },
  {
    "Retail Branding": "JUSYEA",
    "Marketing Name": "J9_US",
    "Device": "J9_US",
    "Model": "J9_US"
  },
  {
    "Retail Branding": "JVC",
    "Marketing Name": "",
    "Device": "gener",
    "Model": "RY-AP1"
  },
  {
    "Retail Branding": "JVC",
    "Marketing Name": "4K Smart TV",
    "Device": "SW6H",
    "Model": "4K Smart TV"
  },
  {
    "Retail Branding": "JVC",
    "Marketing Name": "4K Smart TV",
    "Device": "gangbyeon",
    "Model": "4K AI Smart TV"
  },
  {
    "Retail Branding": "JVC",
    "Marketing Name": "4K Smart TV",
    "Device": "pioneer",
    "Model": "4K SA Smart TV"
  },
  {
    "Retail Branding": "JVC",
    "Marketing Name": "4K Smart TV Plus",
    "Device": "SW6H",
    "Model": "4K Smart TV Plus"
  },
  {
    "Retail Branding": "JVC",
    "Marketing Name": "4K_Edition",
    "Device": "Android_TV_BOX",
    "Model": "4K_Edition"
  },
  {
    "Retail Branding": "JVC",
    "Marketing Name": "AV-08NT310",
    "Device": "AV-08NT310",
    "Model": "AV-08NT310"
  },
  {
    "Retail Branding": "JVC",
    "Marketing Name": "AV-10NT310",
    "Device": "AV-10NT310",
    "Model": "AV-10NT310"
  },
  {
    "Retail Branding": "JVC",
    "Marketing Name": "AV-11NT510",
    "Device": "AV-11NT510",
    "Model": "AV-11NT510"
  },
  {
    "Retail Branding": "JVC",
    "Marketing Name": "Android TV",
    "Device": "R1",
    "Model": "ATV R1"
  },
  {
    "Retail Branding": "JVC",
    "Marketing Name": "Android TV",
    "Device": "R2",
    "Model": "ATV R2"
  },
  {
    "Retail Branding": "JVC",
    "Marketing Name": "Android TV",
    "Device": "ikebukuro",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "JVC",
    "Marketing Name": "Android TV",
    "Device": "sindorim",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "JVC",
    "Marketing Name": "Australia",
    "Device": "martin",
    "Model": "JVC 2K Android TV"
  },
  {
    "Retail Branding": "JVC",
    "Marketing Name": "Australia",
    "Device": "sepolia",
    "Model": "JVC 4K Smart TV"
  },
  {
    "Retail Branding": "JVC",
    "Marketing Name": "Australia, URUGUAY/PARAGUAY, UAE, INDIA, SAUDI ARABIA ISAREL/KUWAIT/SRI LANKA PAKISTAN",
    "Device": "guandu",
    "Model": "JVC 4K Android TV"
  },
  {
    "Retail Branding": "JVC",
    "Marketing Name": "Australia, URUGUAY/PARAGUAY, UAE, INDIA, SAUDI ARABIA ISAREL/KUWAIT/SRI LANKA PAKISTAN",
    "Device": "guandu",
    "Model": "JVC Android TV"
  },
  {
    "Retail Branding": "JVC",
    "Marketing Name": "COL",
    "Device": "stanford",
    "Model": "COL 2K SMART TV"
  },
  {
    "Retail Branding": "JVC",
    "Marketing Name": "Canada",
    "Device": "martin",
    "Model": "Android TV"
  },
  {
    "Retail Branding": "JVC",
    "Marketing Name": "DM65UXR\\\\DM65USR\\\\DM85UXR",
    "Device": "mstarnapoli_atsc",
    "Model": "DM65UXR"
  },
  {
    "Retail Branding": "JVC",
    "Marketing Name": "Dixons",
    "Device": "sadang",
    "Model": "UK 4K Android TV"
  },
  {
    "Retail Branding": "JVC",
    "Marketing Name": "EUROPE",
    "Device": "guandu",
    "Model": "JVC Android TV"
  },
  {
    "Retail Branding": "JVC",
    "Marketing Name": "EU、UK、AP",
    "Device": "martin",
    "Model": "JVC Android TV"
  },
  {
    "Retail Branding": "JVC",
    "Marketing Name": "France",
    "Device": "yeongdeungpo",
    "Model": "JVC 4K Android TV"
  },
  {
    "Retail Branding": "JVC",
    "Marketing Name": "JVC",
    "Device": "bangbae",
    "Model": "EU 4K Android TV"
  },
  {
    "Retail Branding": "JVC",
    "Marketing Name": "JVC",
    "Device": "bangbae",
    "Model": "JVC 4K Android TV"
  },
  {
    "Retail Branding": "JVC",
    "Marketing Name": "JVC",
    "Device": "bangbae",
    "Model": "JVC EU 4K Android TV"
  },
  {
    "Retail Branding": "JVC",
    "Marketing Name": "JVC",
    "Device": "bruno",
    "Model": "JVC PA 2K Android TV"
  },
  {
    "Retail Branding": "JVC",
    "Marketing Name": "JVC",
    "Device": "bruno",
    "Model": "JVC UK 2K Android TV"
  },
  {
    "Retail Branding": "JVC",
    "Marketing Name": "JVC",
    "Device": "bruno",
    "Model": "JVC2KAndroid TV"
  },
  {
    "Retail Branding": "JVC",
    "Marketing Name": "JVC",
    "Device": "dongmae",
    "Model": "JVC PA 2K Android TV"
  },
  {
    "Retail Branding": "JVC",
    "Marketing Name": "JVC",
    "Device": "elliniko",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "JVC",
    "Marketing Name": "JVC",
    "Device": "expo",
    "Model": "JVCPA 4KAndroid TV"
  },
  {
    "Retail Branding": "JVC",
    "Marketing Name": "JVC",
    "Device": "expo",
    "Model": "JVCSA 4KGoogle TV"
  },
  {
    "Retail Branding": "JVC",
    "Marketing Name": "JVC",
    "Device": "expo",
    "Model": "JVCTV 4K"
  },
  {
    "Retail Branding": "JVC",
    "Marketing Name": "JVC",
    "Device": "expo",
    "Model": "JVCUS 4K TV"
  },
  {
    "Retail Branding": "JVC",
    "Marketing Name": "JVC",
    "Device": "hongkong",
    "Model": "JVC 4K ATSC TV"
  },
  {
    "Retail Branding": "JVC",
    "Marketing Name": "JVC",
    "Device": "hongkong",
    "Model": "JVC 4K DVB TV"
  },
  {
    "Retail Branding": "JVC",
    "Marketing Name": "JVC",
    "Device": "hongkong",
    "Model": "JVC 4K ISDB TV"
  },
  {
    "Retail Branding": "JVC",
    "Marketing Name": "JVC",
    "Device": "jagalchi",
    "Model": "2K SMART TV"
  },
  {
    "Retail Branding": "JVC",
    "Marketing Name": "JVC",
    "Device": "kaitak",
    "Model": "4KGoogle TV"
  },
  {
    "Retail Branding": "JVC",
    "Marketing Name": "JVC",
    "Device": "kaitak",
    "Model": "JVCPA 4KAndroid TV"
  },
  {
    "Retail Branding": "JVC",
    "Marketing Name": "JVC",
    "Device": "kaitak",
    "Model": "JVCSA 4KGoogle TV"
  },
  {
    "Retail Branding": "JVC",
    "Marketing Name": "JVC",
    "Device": "kaitak",
    "Model": "JVCSA 4KGoogleTV"
  },
  {
    "Retail Branding": "JVC",
    "Marketing Name": "JVC",
    "Device": "kaitak",
    "Model": "Platinum Google TV"
  },
  {
    "Retail Branding": "JVC",
    "Marketing Name": "JVC",
    "Device": "khardi",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "JVC",
    "Marketing Name": "JVC",
    "Device": "komagome",
    "Model": "EU 2K Android TV"
  },
  {
    "Retail Branding": "JVC",
    "Marketing Name": "JVC",
    "Device": "komagome",
    "Model": "JVC 2K Android TV"
  },
  {
    "Retail Branding": "JVC",
    "Marketing Name": "JVC",
    "Device": "komagome",
    "Model": "JVC EU 2K Android TV"
  },
  {
    "Retail Branding": "JVC",
    "Marketing Name": "JVC",
    "Device": "lavender",
    "Model": "JVC 4K DVB TV"
  },
  {
    "Retail Branding": "JVC",
    "Marketing Name": "JVC",
    "Device": "lavender",
    "Model": "JVC 4K ISDB TV"
  },
  {
    "Retail Branding": "JVC",
    "Marketing Name": "JVC",
    "Device": "maniatika",
    "Model": "JVC UltraTV"
  },
  {
    "Retail Branding": "JVC",
    "Marketing Name": "JVC",
    "Device": "mountbaker",
    "Model": "JVC 2K ATSC TV"
  },
  {
    "Retail Branding": "JVC",
    "Marketing Name": "JVC",
    "Device": "mountbaker",
    "Model": "JVC 2K DVB TV"
  },
  {
    "Retail Branding": "JVC",
    "Marketing Name": "JVC",
    "Device": "mountbaker",
    "Model": "JVC 2K ISDB TV"
  },
  {
    "Retail Branding": "JVC",
    "Marketing Name": "JVC",
    "Device": "mountbaker",
    "Model": "JVC 2K TV"
  },
  {
    "Retail Branding": "JVC",
    "Marketing Name": "JVC",
    "Device": "nishijin",
    "Model": "JVC Super TV"
  },
  {
    "Retail Branding": "JVC",
    "Marketing Name": "JVC",
    "Device": "seocho",
    "Model": "JVC 4K Android TV"
  },
  {
    "Retail Branding": "JVC",
    "Marketing Name": "JVC",
    "Device": "seocho",
    "Model": "JVC SA 4K Android TV"
  },
  {
    "Retail Branding": "JVC",
    "Marketing Name": "JVC",
    "Device": "seocho",
    "Model": "JVC US 4K Android TV"
  },
  {
    "Retail Branding": "JVC",
    "Marketing Name": "JVC",
    "Device": "seocho",
    "Model": "SA 4K Android TV"
  },
  {
    "Retail Branding": "JVC",
    "Marketing Name": "JVC",
    "Device": "shilin",
    "Model": "JVC PA 4K Android TV"
  },
  {
    "Retail Branding": "JVC",
    "Marketing Name": "JVC",
    "Device": "shilin",
    "Model": "JVC UK 4K Android TV"
  },
  {
    "Retail Branding": "JVC",
    "Marketing Name": "JVC",
    "Device": "shilin",
    "Model": "JVC4KAndroid TV"
  },
  {
    "Retail Branding": "JVC",
    "Marketing Name": "JVC",
    "Device": "stanford",
    "Model": "2K SMART TV"
  },
  {
    "Retail Branding": "JVC",
    "Marketing Name": "JVC",
    "Device": "sugamo",
    "Model": "JVC 2K Android TV"
  },
  {
    "Retail Branding": "JVC",
    "Marketing Name": "JVC",
    "Device": "sugamo",
    "Model": "JVC SA 2K Android TV"
  },
  {
    "Retail Branding": "JVC",
    "Marketing Name": "JVC",
    "Device": "sugamo",
    "Model": "JVC US 2K Android TV"
  },
  {
    "Retail Branding": "JVC",
    "Marketing Name": "JVC",
    "Device": "sugamo",
    "Model": "US 2K Android TV"
  },
  {
    "Retail Branding": "JVC",
    "Marketing Name": "JVC",
    "Device": "tennoji",
    "Model": "JVCPA 2KAndroid TV"
  },
  {
    "Retail Branding": "JVC",
    "Marketing Name": "JVC",
    "Device": "tennoji",
    "Model": "JVCSA 2KGoogle TV"
  },
  {
    "Retail Branding": "JVC",
    "Marketing Name": "JVC",
    "Device": "zhongshan",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "JVC",
    "Marketing Name": "JVC",
    "Device": "zhongshan",
    "Model": "COL 4K SMART TV"
  },
  {
    "Retail Branding": "JVC",
    "Marketing Name": "JVC 2K Smart TV",
    "Device": "dongnae",
    "Model": "JVC 2K Smart TV"
  },
  {
    "Retail Branding": "JVC",
    "Marketing Name": "JVC 4K Smart TV NZ",
    "Device": "SW6H",
    "Model": "JVC 4K Smart TV NZ"
  },
  {
    "Retail Branding": "JVC",
    "Marketing Name": "JVC 4K Smart TV NZ",
    "Device": "SW6H",
    "Model": "JVC eplay 4KTV FF"
  },
  {
    "Retail Branding": "JVC",
    "Marketing Name": "JVC 4K Smart TV Plus",
    "Device": "anaheim",
    "Model": "JVC 4K Smart TV Plus"
  },
  {
    "Retail Branding": "JVC",
    "Marketing Name": "JVC G24 TV",
    "Device": "anaheim",
    "Model": "JVC G24 TV"
  },
  {
    "Retail Branding": "JVC",
    "Marketing Name": "JVC J20",
    "Device": "Cunda",
    "Model": "J20"
  },
  {
    "Retail Branding": "JVC",
    "Marketing Name": "JVC UHD TV G0325",
    "Device": "eleonas",
    "Model": "JVC UHD TV G0325"
  },
  {
    "Retail Branding": "JVC",
    "Marketing Name": "KR",
    "Device": "expo",
    "Model": "Premium 4K GTV"
  },
  {
    "Retail Branding": "JVC",
    "Marketing Name": "LT-32N3115A",
    "Device": "ikebukuro",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "JVC",
    "Marketing Name": "LT-40N5115A",
    "Device": "ikebukuro",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "JVC",
    "Marketing Name": "LT-50KD507",
    "Device": "samseong",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "JVC",
    "Marketing Name": "LT-50N7115A",
    "Device": "samseong",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "JVC",
    "Marketing Name": "MTC",
    "Device": "tennoji",
    "Model": "JVCUS 2K Google TV"
  },
  {
    "Retail Branding": "JVC",
    "Marketing Name": "R3",
    "Device": "R3",
    "Model": "R3"
  },
  {
    "Retail Branding": "JVC",
    "Marketing Name": "R4",
    "Device": "R4",
    "Model": "R4"
  },
  {
    "Retail Branding": "JVC",
    "Marketing Name": "Smart TV",
    "Device": "mateo",
    "Model": "2K SA Smart TV"
  },
  {
    "Retail Branding": "JVC",
    "Marketing Name": "Smart TV",
    "Device": "osaka",
    "Model": "JVC TV"
  },
  {
    "Retail Branding": "JVC",
    "Marketing Name": "Smart TV",
    "Device": "osaki",
    "Model": "2K AI Smart TV"
  },
  {
    "Retail Branding": "JVC",
    "Marketing Name": "South Africa",
    "Device": "martin",
    "Model": "JVC Android TV SA"
  },
  {
    "Retail Branding": "JVC",
    "Marketing Name": "South Africa/Australia /Israel/Paraguay",
    "Device": "tamachi",
    "Model": "JVC Android TV"
  },
  {
    "Retail Branding": "JVC",
    "Marketing Name": "South Africa/Australia /Israel/Paraguay",
    "Device": "yeongdeungpo",
    "Model": "JVC Android TV"
  },
  {
    "Retail Branding": "JVC",
    "Marketing Name": "UHD Android TV",
    "Device": "sindorim",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "JVC",
    "Marketing Name": "UK",
    "Device": "tabata",
    "Model": "UK 2K Android TV"
  },
  {
    "Retail Branding": "JVC",
    "Marketing Name": "france",
    "Device": "tamachi",
    "Model": "JVC 2K Android TV"
  },
  {
    "Retail Branding": "JVL (Australia)",
    "Marketing Name": "JVL070TAB812BLK",
    "Device": "JVL070TAB812BLK",
    "Model": "JVL070TAB812BLK"
  },
  {
    "Retail Branding": "JVL (Australia)",
    "Marketing Name": "JVL101TAB811BLK",
    "Device": "JVL101TAB811BLK",
    "Model": "JVL101TAB811BLK"
  },
  {
    "Retail Branding": "JZIOT",
    "Marketing Name": "Handheld_Terminal_EEA",
    "Device": "Handheld_Terminal",
    "Model": "Handheld_Terminal"
  },
  {
    "Retail Branding": "JabrBox",
    "Marketing Name": "H460",
    "Device": "H460",
    "Model": "H460"
  },
  {
    "Retail Branding": "JabrBox",
    "Marketing Name": "H460B01",
    "Device": "H460",
    "Model": "H460"
  },
  {
    "Retail Branding": "JabrBox",
    "Marketing Name": "S502",
    "Device": "S502",
    "Model": "S502"
  },
  {
    "Retail Branding": "Jam",
    "Marketing Name": "JAM",
    "Device": "elliniko",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "Jam",
    "Marketing Name": "JAM",
    "Device": "hongkong",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "Jam",
    "Marketing Name": "JAM",
    "Device": "jagalchi",
    "Model": "2K SMART TV"
  },
  {
    "Retail Branding": "Jam",
    "Marketing Name": "JAM",
    "Device": "mountbaker",
    "Model": "2K SMART TV"
  },
  {
    "Retail Branding": "Jambo_Technology",
    "Marketing Name": "JamboPhone",
    "Device": "JP1",
    "Model": "JP1"
  },
  {
    "Retail Branding": "Jambo_Technology",
    "Marketing Name": "JamboPhone2",
    "Device": "JP2",
    "Model": "JP2"
  },
  {
    "Retail Branding": "Janam",
    "Marketing Name": "HT1",
    "Device": "HT1",
    "Model": "HT1"
  },
  {
    "Retail Branding": "Janam",
    "Marketing Name": "XG200",
    "Device": "XG200",
    "Model": "XG200"
  },
  {
    "Retail Branding": "Janam",
    "Marketing Name": "XG4",
    "Device": "XG4",
    "Model": "XG4"
  },
  {
    "Retail Branding": "Janam",
    "Marketing Name": "XG5",
    "Device": "XG5",
    "Model": "XG5"
  },
  {
    "Retail Branding": "Janam",
    "Marketing Name": "XM75",
    "Device": "XM75",
    "Model": "XM75"
  },
  {
    "Retail Branding": "Janam",
    "Marketing Name": "XM75",
    "Device": "XM75P",
    "Model": "XM75"
  },
  {
    "Retail Branding": "Janam",
    "Marketing Name": "XR2",
    "Device": "XR2",
    "Model": "XR2"
  },
  {
    "Retail Branding": "Janam",
    "Marketing Name": "XT100",
    "Device": "XT100",
    "Model": "XT100"
  },
  {
    "Retail Branding": "Janam",
    "Marketing Name": "XT2",
    "Device": "XT2",
    "Model": "XT2"
  },
  {
    "Retail Branding": "Janam",
    "Marketing Name": "XT200",
    "Device": "XT200",
    "Model": "XT200"
  },
  {
    "Retail Branding": "Janam",
    "Marketing Name": "XT3",
    "Device": "XT3",
    "Model": "XT3"
  },
  {
    "Retail Branding": "Janam",
    "Marketing Name": "XT30",
    "Device": "XT30",
    "Model": "XT30"
  },
  {
    "Retail Branding": "Janam",
    "Marketing Name": "XT4",
    "Device": "XT4",
    "Model": "XT4"
  },
  {
    "Retail Branding": "Janam",
    "Marketing Name": "XT40",
    "Device": "XT40",
    "Model": "XT40"
  },
  {
    "Retail Branding": "Janam",
    "Marketing Name": "XT75",
    "Device": "XM75",
    "Model": "XM75"
  },
  {
    "Retail Branding": "Japan Digital Serve",
    "Marketing Name": "Amigo7xJDS",
    "Device": "Amigo7xJDS",
    "Model": "Amigo7xJDS"
  },
  {
    "Retail Branding": "JapanTaxi",
    "Marketing Name": "IRIS ITAB05",
    "Device": "IRIS_ITAB05",
    "Model": "IRIS_ITAB05"
  },
  {
    "Retail Branding": "Jawwy TV",
    "Marketing Name": "JAWWY-TV-2.0",
    "Device": "HP40A",
    "Model": "JAWWY-TV-2.0"
  },
  {
    "Retail Branding": "Jckkcfug",
    "Marketing Name": "A10Pro_EEA",
    "Device": "A10Pro_EEA",
    "Model": "A10Pro_EEA"
  },
  {
    "Retail Branding": "Jckkcfug",
    "Marketing Name": "A10Pro_ROW",
    "Device": "A10Pro_ROW",
    "Model": "A10Pro_ROW"
  },
  {
    "Retail Branding": "Jckkcfug",
    "Marketing Name": "A10_PLUS_EEA",
    "Device": "A10_PLUS",
    "Model": "A10 PLUS"
  },
  {
    "Retail Branding": "Jckkcfug",
    "Marketing Name": "A10_PLUS_ROW",
    "Device": "A10_PLUS",
    "Model": "A10 PLUS"
  },
  {
    "Retail Branding": "Jckkcfug",
    "Marketing Name": "A20Pro_EEA",
    "Device": "A20Pro_EEA",
    "Model": "A20Plus_EEA"
  },
  {
    "Retail Branding": "Jckkcfug",
    "Marketing Name": "A20Pro_EEA",
    "Device": "A20Pro_EEA",
    "Model": "A20Pro_EEA"
  },
  {
    "Retail Branding": "Jckkcfug",
    "Marketing Name": "A20Pro_EEA",
    "Device": "A20Pro_EEA",
    "Model": "A20_EEA"
  },
  {
    "Retail Branding": "Jckkcfug",
    "Marketing Name": "A20Pro_ROW",
    "Device": "A20Pro_ROW",
    "Model": "A20Plus_ROW"
  },
  {
    "Retail Branding": "Jckkcfug",
    "Marketing Name": "A20Pro_ROW",
    "Device": "A20Pro_ROW",
    "Model": "A20Pro_ROW"
  },
  {
    "Retail Branding": "Jckkcfug",
    "Marketing Name": "A20Pro_ROW",
    "Device": "A20Pro_ROW",
    "Model": "A20_ROW"
  },
  {
    "Retail Branding": "Jeazans",
    "Marketing Name": "A13",
    "Device": "A13",
    "Model": "A13"
  },
  {
    "Retail Branding": "Jeazans",
    "Marketing Name": "KT1016",
    "Device": "KT1016",
    "Model": "KT1016"
  },
  {
    "Retail Branding": "Jeazans",
    "Marketing Name": "KT1016_EEA",
    "Device": "KT1016",
    "Model": "KT1016"
  },
  {
    "Retail Branding": "Jeazans",
    "Marketing Name": "X100L",
    "Device": "X100L",
    "Model": "X100L"
  },
  {
    "Retail Branding": "Jeazans",
    "Marketing Name": "X100L_EEA",
    "Device": "X100L",
    "Model": "X100L"
  },
  {
    "Retail Branding": "Jeazans",
    "Marketing Name": "X100PRO",
    "Device": "X100PRO",
    "Model": "X100PRO"
  },
  {
    "Retail Branding": "Jeazans",
    "Marketing Name": "X100PRO_EEA",
    "Device": "X100PRO",
    "Model": "X100PRO"
  },
  {
    "Retail Branding": "Jenesis",
    "Marketing Name": "A94GT_Plus",
    "Device": "A94GT_Plus",
    "Model": "A94GT_Plus"
  },
  {
    "Retail Branding": "Jenesis",
    "Marketing Name": "JT07-81B",
    "Device": "JT07-81B",
    "Model": "JT07-81B"
  },
  {
    "Retail Branding": "Jenesis",
    "Marketing Name": "JT10-81B",
    "Device": "JT10-81B",
    "Model": "JT10-81B"
  },
  {
    "Retail Branding": "Jesy",
    "Marketing Name": "J11",
    "Device": "J11",
    "Model": "J11"
  },
  {
    "Retail Branding": "Jesy",
    "Marketing Name": "J9S",
    "Device": "J9S",
    "Model": "J9S"
  },
  {
    "Retail Branding": "Jesy",
    "Marketing Name": "JESY J20",
    "Device": "JESY_J20",
    "Model": "JESY J20"
  },
  {
    "Retail Branding": "Jesy",
    "Marketing Name": "JESY K1",
    "Device": "JESY_K1",
    "Model": "JESY K1"
  },
  {
    "Retail Branding": "Jesy",
    "Marketing Name": "JESY_K1",
    "Device": "JESY_K1",
    "Model": "JESY_K1"
  },
  {
    "Retail Branding": "Jetpoint",
    "Marketing Name": "Smart TV",
    "Device": "longshan",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "Jetpoint",
    "Marketing Name": "Smart TV",
    "Device": "redwood",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "Jettom",
    "Marketing Name": "P2000",
    "Device": "P2000",
    "Model": "P2000"
  },
  {
    "Retail Branding": "Jettom",
    "Marketing Name": "P2000_EEA",
    "Device": "P2000_EEA",
    "Model": "P2000_EEA"
  },
  {
    "Retail Branding": "Jettom",
    "Marketing Name": "RobotPad-A1",
    "Device": "RobotPad-A1",
    "Model": "RobotPad-A1"
  },
  {
    "Retail Branding": "Jettom",
    "Marketing Name": "RobotPad-A1_EEA",
    "Device": "RobotPad-A1_EEA",
    "Model": "RobotPad-A1_EEA"
  },
  {
    "Retail Branding": "Jide",
    "Marketing Name": "Remix Mini",
    "Device": "rm1g",
    "Model": "Remix Mini"
  },
  {
    "Retail Branding": "Jimi",
    "Marketing Name": "K108",
    "Device": "K108",
    "Model": "K108"
  },
  {
    "Retail Branding": "Jimi",
    "Marketing Name": "KN C4",
    "Device": "JIMI_KNC4",
    "Model": "JIMI_KNC4"
  },
  {
    "Retail Branding": "Jimi",
    "Marketing Name": "Senwa S471",
    "Device": "Senwa_S471",
    "Model": "S471"
  },
  {
    "Retail Branding": "Jimo",
    "Marketing Name": "S5006",
    "Device": "S5006",
    "Model": "S5006"
  },
  {
    "Retail Branding": "Jinga",
    "Marketing Name": "GoalPlus",
    "Device": "GoalPlus",
    "Model": "GoalPlus"
  },
  {
    "Retail Branding": "Jinga",
    "Marketing Name": "Jinga Hit",
    "Device": "Hit",
    "Model": "Hit"
  },
  {
    "Retail Branding": "Jinga",
    "Marketing Name": "Jinga Hit4G",
    "Device": "Hit4G",
    "Model": "Hit4G"
  },
  {
    "Retail Branding": "Jinga",
    "Marketing Name": "Jinga Joy",
    "Device": "JI55A_189BW",
    "Model": "Joy"
  },
  {
    "Retail Branding": "Jinga",
    "Marketing Name": "Jinga Pass4G",
    "Device": "JI50AG2_189HP",
    "Model": "Pass4G"
  },
  {
    "Retail Branding": "Jinga",
    "Marketing Name": "JoyPRO",
    "Device": "JI55B_189BW",
    "Model": "JoyPRO"
  },
  {
    "Retail Branding": "Jinga",
    "Marketing Name": "Neon",
    "Device": "Neon",
    "Model": "Neon"
  },
  {
    "Retail Branding": "Jinga",
    "Marketing Name": "Optim 4G",
    "Device": "Optim4G",
    "Model": "Optim4G"
  },
  {
    "Retail Branding": "Jinga",
    "Marketing Name": "Optim4G",
    "Device": "Optim4G",
    "Model": "Optim4G"
  },
  {
    "Retail Branding": "Jinga",
    "Marketing Name": "Pass",
    "Device": "Pass",
    "Model": "Pass"
  },
  {
    "Retail Branding": "Jinga",
    "Marketing Name": "Pass Plus",
    "Device": "JI55AG_189ID",
    "Model": "PassPlus"
  },
  {
    "Retail Branding": "Jinga",
    "Marketing Name": "Pass3G",
    "Device": "JI50AG1_189HP",
    "Model": "Pass3G"
  },
  {
    "Retail Branding": "Jinga",
    "Marketing Name": "Picasso Note",
    "Device": "PicassoNote",
    "Model": "PicassoNote"
  },
  {
    "Retail Branding": "Jinga",
    "Marketing Name": "SmartPRO",
    "Device": "JI55_216M",
    "Model": "SmartPRO"
  },
  {
    "Retail Branding": "Jinga",
    "Marketing Name": "Start",
    "Device": "JI50AG2_169HP",
    "Model": "Start"
  },
  {
    "Retail Branding": "Jinga",
    "Marketing Name": "Start 3G",
    "Device": "Start3G",
    "Model": "Start3G"
  },
  {
    "Retail Branding": "Jinga",
    "Marketing Name": "StartLTE",
    "Device": "JI50AG1_169HP",
    "Model": "StartLTE"
  },
  {
    "Retail Branding": "Jinga",
    "Marketing Name": "Touch 4G",
    "Device": "Touch4G",
    "Model": "Touch4G"
  },
  {
    "Retail Branding": "Jinga",
    "Marketing Name": "WinPRO",
    "Device": "WinPRO",
    "Model": "WinPRO"
  },
  {
    "Retail Branding": "Jio",
    "Marketing Name": "JioPhone Next",
    "Device": "LS1542QW",
    "Model": "LS1542QW"
  },
  {
    "Retail Branding": "Jio",
    "Marketing Name": "JioPhone Next",
    "Device": "LS1542QWN",
    "Model": "LS1542QWN"
  },
  {
    "Retail Branding": "Jivi",
    "Marketing Name": "Energy E12",
    "Device": "Energy_E12",
    "Model": "Energy E12"
  },
  {
    "Retail Branding": "Jivi",
    "Marketing Name": "JSP Q65",
    "Device": "JSPQ65",
    "Model": "JSPQ65"
  },
  {
    "Retail Branding": "Jivi",
    "Marketing Name": "Opus S3",
    "Device": "Opus_S3",
    "Model": "Opus S3"
  },
  {
    "Retail Branding": "Jivi",
    "Marketing Name": "Prime P30",
    "Device": "Prime_P30",
    "Model": "Prime P30"
  },
  {
    "Retail Branding": "Jivi",
    "Marketing Name": "Prime P300",
    "Device": "Prime_P300",
    "Model": "Prime P300"
  },
  {
    "Retail Branding": "Jivi",
    "Marketing Name": "Prime P444",
    "Device": "Prime_P444",
    "Model": "Prime P444"
  },
  {
    "Retail Branding": "Jivi",
    "Marketing Name": "Prime P4442",
    "Device": "Prime_P4442",
    "Model": "Prime P4442"
  },
  {
    "Retail Branding": "Jivi",
    "Marketing Name": "Revolution TnT3",
    "Device": "Revolution_TnT3",
    "Model": "Revolution TnT3"
  },
  {
    "Retail Branding": "Jivi",
    "Marketing Name": "TnT5",
    "Device": "TnT5",
    "Model": "TnT5"
  },
  {
    "Retail Branding": "Jivi",
    "Marketing Name": "Xtreme  XT84",
    "Device": "Xtreme_XT84",
    "Model": "Xtreme XT84"
  },
  {
    "Retail Branding": "Jivi",
    "Marketing Name": "Xtreme XT309",
    "Device": "Xtreme_XT309",
    "Model": "Xtreme XT309"
  },
  {
    "Retail Branding": "Jivi",
    "Marketing Name": "Xtreme XT309 Plus",
    "Device": "Xtreme_XT309_Plus",
    "Model": "Xtreme XT309 Plus"
  },
  {
    "Retail Branding": "Jivi",
    "Marketing Name": "Xtreme_1",
    "Device": "Xtreme_1",
    "Model": "Xtreme 1"
  },
  {
    "Retail Branding": "Jivi",
    "Marketing Name": "Xtreme_3",
    "Device": "Xtreme_3",
    "Model": "Xtreme_3"
  },
  {
    "Retail Branding": "Jivi",
    "Marketing Name": "Xtreme_3x",
    "Device": "Xtreme_3x",
    "Model": "Xtreme_3x"
  },
  {
    "Retail Branding": "Jivi",
    "Marketing Name": "Xtreme_7",
    "Device": "Xtreme_7",
    "Model": "Xtreme_7"
  },
  {
    "Retail Branding": "Jooyon",
    "Marketing Name": "J110A",
    "Device": "J110A",
    "Model": "J110A"
  },
  {
    "Retail Branding": "Jooyon",
    "Marketing Name": "J210A",
    "Device": "J210A",
    "Model": "J210A"
  },
  {
    "Retail Branding": "Jooyon",
    "Marketing Name": "Q27CMA11",
    "Device": "Q27CMA11",
    "Model": "Q27CMA11"
  },
  {
    "Retail Branding": "Jooyon",
    "Marketing Name": "UHD Android TV",
    "Device": "sindorim",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "JoyStar",
    "Marketing Name": "J6",
    "Device": "J6",
    "Model": "Joystar J6"
  },
  {
    "Retail Branding": "JoyStar",
    "Marketing Name": "JoyStar_J10",
    "Device": "JoyStar_J10",
    "Model": "JoyStar_J10"
  },
  {
    "Retail Branding": "JoyStar",
    "Marketing Name": "Joystar_J16",
    "Device": "Joystar_J16",
    "Model": "Joystar J16"
  },
  {
    "Retail Branding": "JoyStar",
    "Marketing Name": "Joystar_J16",
    "Device": "Joystar_J16",
    "Model": "Joystar_J16"
  },
  {
    "Retail Branding": "JoyStar",
    "Marketing Name": "Joystar_J16",
    "Device": "Joystar_J16",
    "Model": "K10"
  },
  {
    "Retail Branding": "JoyStar",
    "Marketing Name": "Joystar_J16",
    "Device": "Joystar_J16",
    "Model": "Pad12ultra"
  },
  {
    "Retail Branding": "Jubiter",
    "Marketing Name": "K10_ROW",
    "Device": "AJK10SC",
    "Model": "K10"
  },
  {
    "Retail Branding": "Jubiter",
    "Marketing Name": "M25",
    "Device": "M25",
    "Model": "M25"
  },
  {
    "Retail Branding": "Jumper",
    "Marketing Name": "EZpad_M10S",
    "Device": "EZpad_M10S",
    "Model": "EZpad M10S"
  },
  {
    "Retail Branding": "Jumper",
    "Marketing Name": "EZpad_M10S_ROW",
    "Device": "EZpad_M10S_ROW",
    "Model": "EZpad M10S"
  },
  {
    "Retail Branding": "Jumper",
    "Marketing Name": "EZpad_M10_EEA",
    "Device": "EZpad_M10",
    "Model": "EZpad M10"
  },
  {
    "Retail Branding": "Jumper",
    "Marketing Name": "EZpad_M10_HD",
    "Device": "EZpad_M10_HD",
    "Model": "EZpad M10 HD"
  },
  {
    "Retail Branding": "Jumper",
    "Marketing Name": "EZpad_M11",
    "Device": "EZpad_M11",
    "Model": "EZpad_M11"
  },
  {
    "Retail Branding": "Jumper",
    "Marketing Name": "EZpad_M11",
    "Device": "EZpad_M11",
    "Model": "TDV0808"
  },
  {
    "Retail Branding": "Jumper",
    "Marketing Name": "EZpad_M11_Pro",
    "Device": "EZpad_M11_Pro",
    "Model": "EZpad M11 Pro"
  },
  {
    "Retail Branding": "Jumper",
    "Marketing Name": "Z1",
    "Device": "Z1",
    "Model": "Z1"
  },
  {
    "Retail Branding": "Juniper Systems",
    "Marketing Name": "Cedar CT8",
    "Device": "CT8",
    "Model": "Cedar CT8"
  },
  {
    "Retail Branding": "Juniper Systems",
    "Marketing Name": "Mesa3",
    "Device": "MS3A",
    "Model": "MS3A"
  },
  {
    "Retail Branding": "Just5",
    "Marketing Name": "CF8",
    "Device": "CF8",
    "Model": "CF8"
  },
  {
    "Retail Branding": "Just5",
    "Marketing Name": "COSMO L707",
    "Device": "COSMO_L707",
    "Model": "COSMO_L707"
  },
  {
    "Retail Branding": "Just5",
    "Marketing Name": "COSMO_L808",
    "Device": "COSMO_L808",
    "Model": "COSMO L808"
  },
  {
    "Retail Branding": "Just5",
    "Marketing Name": "FREEDOM C100",
    "Device": "FREEDOM_C100",
    "Model": "FREEDOM C100"
  },
  {
    "Retail Branding": "Just5",
    "Marketing Name": "FREEDOM C100",
    "Device": "FREEDOM_C105",
    "Model": "FREEDOM C105"
  },
  {
    "Retail Branding": "Just5",
    "Marketing Name": "FREEDOM X1",
    "Device": "FREEDOM_X1",
    "Model": "FREEDOM X1"
  },
  {
    "Retail Branding": "Just5",
    "Marketing Name": "Freedom M303",
    "Device": "FREEDOM_M303",
    "Model": "FREEDOM_M303"
  },
  {
    "Retail Branding": "Just5",
    "Marketing Name": "GINI Tab V7",
    "Device": "GINI_Tab_V7",
    "Model": "GINI_Tab_V7"
  },
  {
    "Retail Branding": "Just5",
    "Marketing Name": "Konrow",
    "Device": "Konrow",
    "Model": "Just5"
  },
  {
    "Retail Branding": "Just5",
    "Marketing Name": "M503",
    "Device": "M503",
    "Model": "M503"
  },
  {
    "Retail Branding": "Just5",
    "Marketing Name": "Mode1 MD-02P",
    "Device": "MD-02P",
    "Model": "MD-02P"
  },
  {
    "Retail Branding": "Jyonetsu Kakaku",
    "Marketing Name": "YMR8",
    "Device": "YMR8",
    "Model": "YMR8"
  },
  {
    "Retail Branding": "K-ELEC",
    "Marketing Name": "K-ELEC",
    "Device": "bangbae",
    "Model": "K-Elec 4K Android TV"
  },
  {
    "Retail Branding": "K-ELEC",
    "Marketing Name": "KELEC",
    "Device": "stanford",
    "Model": "40D"
  },
  {
    "Retail Branding": "K-ELEC",
    "Marketing Name": "KELEC",
    "Device": "zhongshan",
    "Model": "43F"
  },
  {
    "Retail Branding": "K-LEADTONE",
    "Marketing Name": "K2",
    "Device": "K2",
    "Model": "K2"
  },
  {
    "Retail Branding": "K-Lite,",
    "Marketing Name": "F1+4G",
    "Device": "K_Lite_F1_4G",
    "Model": "K-Lite F1+4G"
  },
  {
    "Retail Branding": "K-Lite,",
    "Marketing Name": "K-LITE NEXT M1",
    "Device": "K-LITE_NEXT_M1",
    "Model": "K-LITE_NEXT_M1"
  },
  {
    "Retail Branding": "K-Lite,",
    "Marketing Name": "KLITE_TAB_Z",
    "Device": "KLITE_TAB_Z",
    "Model": "K-Lite TAB X"
  },
  {
    "Retail Branding": "K-Lite,",
    "Marketing Name": "TAB Z",
    "Device": "KLITE_TAB_Z",
    "Model": "K-Lite TAB Z"
  },
  {
    "Retail Branding": "K-Lite,",
    "Marketing Name": "TAB_ALPHA",
    "Device": "TAB_ALPHA",
    "Model": "TAB_ALPHA"
  },
  {
    "Retail Branding": "K-Touch",
    "Marketing Name": "",
    "Device": "whistler",
    "Model": "W808"
  },
  {
    "Retail Branding": "K-Touch",
    "Marketing Name": "K-Touch920",
    "Device": "KTOUCH920",
    "Model": "K-Touch 920"
  },
  {
    "Retail Branding": "K-Touch",
    "Marketing Name": "K3",
    "Device": "K3",
    "Model": "K-Touch K3"
  },
  {
    "Retail Branding": "K-Touch",
    "Marketing Name": "L5",
    "Device": "L5",
    "Model": "L5"
  },
  {
    "Retail Branding": "K-Touch",
    "Marketing Name": "L930i",
    "Device": "L930i",
    "Model": "K-Touch L930i"
  },
  {
    "Retail Branding": "K-Touch",
    "Marketing Name": "M2s",
    "Device": "M2s",
    "Model": "K-Touch M2s"
  },
  {
    "Retail Branding": "K-Touch",
    "Marketing Name": "Pace 2",
    "Device": "Pace_2",
    "Model": "Pace 2"
  },
  {
    "Retail Branding": "K-Touch",
    "Marketing Name": "Pace 2 Lite",
    "Device": "Pace_2_Lite",
    "Model": "Pace 2 Lite"
  },
  {
    "Retail Branding": "K-Touch",
    "Marketing Name": "S5",
    "Device": "S5",
    "Model": "S5"
  },
  {
    "Retail Branding": "K-Touch",
    "Marketing Name": "S6",
    "Device": "S6",
    "Model": "S6"
  },
  {
    "Retail Branding": "K-Touch",
    "Marketing Name": "Touch 2C",
    "Device": "Touch2c",
    "Model": "K-Touch Tou ch 2c"
  },
  {
    "Retail Branding": "K3I（Indonesia）",
    "Marketing Name": "K3I",
    "Device": "K3I",
    "Model": "K3I"
  },
  {
    "Retail Branding": "K90Pro",
    "Marketing Name": "K90Pro_ROW",
    "Device": "K90Pro_ROW",
    "Model": "K90Pro_ROW"
  },
  {
    "Retail Branding": "KAAN",
    "Marketing Name": "A1",
    "Device": "KAAN_A1",
    "Model": "KAAN_A1"
  },
  {
    "Retail Branding": "KAAN",
    "Marketing Name": "KAAN_N2",
    "Device": "KAAN_N2",
    "Model": "KAAN_N2"
  },
  {
    "Retail Branding": "KAGIS",
    "Marketing Name": "Australia",
    "Device": "tamachi",
    "Model": "KAGIS Android TV"
  },
  {
    "Retail Branding": "KAGIS",
    "Marketing Name": "Australia",
    "Device": "yeongdeungpo",
    "Model": "KAGIS Android TV"
  },
  {
    "Retail Branding": "KAISSEN",
    "Marketing Name": "KT700M",
    "Device": "KT700M",
    "Model": "KT700M"
  },
  {
    "Retail Branding": "KAJITO",
    "Marketing Name": "Smart TV",
    "Device": "alimos",
    "Model": "KAJITO Google TV"
  },
  {
    "Retail Branding": "KAJITO",
    "Marketing Name": "Smart TV",
    "Device": "osaka",
    "Model": "KAJITO Google TV"
  },
  {
    "Retail Branding": "KAKTIN",
    "Marketing Name": "D08",
    "Device": "D08",
    "Model": "D08"
  },
  {
    "Retail Branding": "KAKTIN",
    "Marketing Name": "D9",
    "Device": "D9",
    "Model": "D9"
  },
  {
    "Retail Branding": "KAKTIN",
    "Marketing Name": "SM1",
    "Device": "SM1",
    "Model": "SM1"
  },
  {
    "Retail Branding": "KAMON",
    "Marketing Name": "K101_Plus",
    "Device": "K101_Plus",
    "Model": "K101_Plus"
  },
  {
    "Retail Branding": "KANSELIR",
    "Marketing Name": "KTB-168",
    "Device": "KTB-168",
    "Model": "KTB-168"
  },
  {
    "Retail Branding": "KAT(AF)",
    "Marketing Name": "SM1_Tablet",
    "Device": "SM1_Tablet",
    "Model": "SM1"
  },
  {
    "Retail Branding": "KAZAM",
    "Marketing Name": "TROOPER X3.5",
    "Device": "KAZAM",
    "Model": "Trooper_X35"
  },
  {
    "Retail Branding": "KAZAM",
    "Marketing Name": "TROOPER X4.0",
    "Device": "KAZAM",
    "Model": "Trooper_X40"
  },
  {
    "Retail Branding": "KAZAM",
    "Marketing Name": "TROOPER X5.5",
    "Device": "KAZAM",
    "Model": "Trooper_X55"
  },
  {
    "Retail Branding": "KAZAM",
    "Marketing Name": "TV 4.5",
    "Device": "KOT49H",
    "Model": "KAZAM TV 45"
  },
  {
    "Retail Branding": "KAZAM",
    "Marketing Name": "TV 4.5",
    "Device": "TV_45",
    "Model": "KAZAM TV 45"
  },
  {
    "Retail Branding": "KAZAM",
    "Marketing Name": "Thunder 345",
    "Device": "Thunder_345",
    "Model": "KAZAM Thunder 345"
  },
  {
    "Retail Branding": "KAZAM",
    "Marketing Name": "Thunder 345 LTE",
    "Device": "Thunder_345_LTE",
    "Model": "KAZAM Thunder 345 LTE"
  },
  {
    "Retail Branding": "KAZAM",
    "Marketing Name": "Thunder 345 LTE",
    "Device": "Thunder_345_LTE",
    "Model": "Thunder3 45 LTE"
  },
  {
    "Retail Branding": "KAZAM",
    "Marketing Name": "Thunder 345L",
    "Device": "Thunder_345L",
    "Model": "KAZAM Thunder 345L"
  },
  {
    "Retail Branding": "KAZAM",
    "Marketing Name": "Thunder 347",
    "Device": "Thunder_347",
    "Model": "Thunder 347"
  },
  {
    "Retail Branding": "KAZAM",
    "Marketing Name": "Thunder 350L",
    "Device": "Thunder_350L",
    "Model": "KAZAM Thunder 350L"
  },
  {
    "Retail Branding": "KAZAM",
    "Marketing Name": "Thunder 550",
    "Device": "TH55025",
    "Model": "KAZAM Thunder 550"
  },
  {
    "Retail Branding": "KAZAM",
    "Marketing Name": "Thunder 550L",
    "Device": "TH5L5025",
    "Model": "KAZAM Thunder 550L"
  },
  {
    "Retail Branding": "KAZAM",
    "Marketing Name": "Thunder2 45L",
    "Device": "Thunder2_45",
    "Model": "KAZAM THUNDER2 45L"
  },
  {
    "Retail Branding": "KAZAM",
    "Marketing Name": "Thunder2 50",
    "Device": "Thunder2_50",
    "Model": "KAZAM Thunder2 50"
  },
  {
    "Retail Branding": "KAZAM",
    "Marketing Name": "Tornado 348",
    "Device": "Tornado_348",
    "Model": "Tornado 348"
  },
  {
    "Retail Branding": "KAZAM",
    "Marketing Name": "Tornado 350",
    "Device": "KAZAM_Tornado_350",
    "Model": "KAZAM Tornado 350"
  },
  {
    "Retail Branding": "KAZAM",
    "Marketing Name": "Tornado 455L",
    "Device": "KAZAM_Tornado_455L",
    "Model": "KAZAM Tornado 455L"
  },
  {
    "Retail Branding": "KAZAM",
    "Marketing Name": "Tornado2 50",
    "Device": "Tornado2_50",
    "Model": "KAZAM Tornado2 50"
  },
  {
    "Retail Branding": "KAZAM",
    "Marketing Name": "Trooper 440L",
    "Device": "Trooper_440L",
    "Model": "KAZAM Trooper 440L"
  },
  {
    "Retail Branding": "KAZAM",
    "Marketing Name": "Trooper 445L",
    "Device": "TR4L4544",
    "Model": "KAZAM Trooper 445L"
  },
  {
    "Retail Branding": "KAZAM",
    "Marketing Name": "Trooper 450",
    "Device": "KAZAM_Trooper_450",
    "Model": "KAZAM Trooper 450"
  },
  {
    "Retail Branding": "KAZAM",
    "Marketing Name": "Trooper 450L",
    "Device": "KAZAM_Trooper_450L",
    "Model": "KAZAM_Trooper_450L"
  },
  {
    "Retail Branding": "KAZAM",
    "Marketing Name": "Trooper 451",
    "Device": "Trooper_451",
    "Model": "KAZAM Trooper 451"
  },
  {
    "Retail Branding": "KAZAM",
    "Marketing Name": "Trooper 455",
    "Device": "TR45544",
    "Model": "KAZAM Trooper 455"
  },
  {
    "Retail Branding": "KAZAM",
    "Marketing Name": "Trooper 540",
    "Device": "TR54015",
    "Model": "KAZAM Trooper 540"
  },
  {
    "Retail Branding": "KAZAM",
    "Marketing Name": "Trooper 550L",
    "Device": "TR5L5025",
    "Model": "KAZAM Trooper 550L"
  },
  {
    "Retail Branding": "KAZAM",
    "Marketing Name": "Trooper 551",
    "Device": "TR550115",
    "Model": "KAZAM Trooper 551"
  },
  {
    "Retail Branding": "KAZAM",
    "Marketing Name": "Trooper 555",
    "Device": "TR55515",
    "Model": "KAZAM Trooper 555"
  },
  {
    "Retail Branding": "KAZAM",
    "Marketing Name": "Trooper 650",
    "Device": "TR65035",
    "Model": "KAZAM Trooper 650"
  },
  {
    "Retail Branding": "KAZAM",
    "Marketing Name": "Trooper 650 4G",
    "Device": "TR6L5035",
    "Model": "KAZAM Trooper 650 4G"
  },
  {
    "Retail Branding": "KAZAM",
    "Marketing Name": "Trooper2 40",
    "Device": "Trooper2_40",
    "Model": "KAZAM Trooper2 40"
  },
  {
    "Retail Branding": "KAZAM",
    "Marketing Name": "Trooper2 45",
    "Device": "Trooper2_45",
    "Model": "Trooper2 45"
  },
  {
    "Retail Branding": "KAZAM",
    "Marketing Name": "Trooper2 50",
    "Device": "Trooper2_50",
    "Model": "KAZAM Trooper2 50"
  },
  {
    "Retail Branding": "KAZAM",
    "Marketing Name": "Trooper2 60",
    "Device": "Trooper2_60",
    "Model": "Kazam Trooper2 60"
  },
  {
    "Retail Branding": "KCCL",
    "Marketing Name": "N9109M",
    "Device": "N9109M",
    "Model": "N9109M"
  },
  {
    "Retail Branding": "KCTV",
    "Marketing Name": "CJ680CM",
    "Device": "jj680cm",
    "Model": "GX-JJ680CM"
  },
  {
    "Retail Branding": "KCTV",
    "Marketing Name": "MAU9001D",
    "Device": "mau9000d",
    "Model": "MAU9001D"
  },
  {
    "Retail Branding": "KD Interactive",
    "Marketing Name": "C15100i",
    "Device": "C15100i",
    "Model": "C15100i"
  },
  {
    "Retail Branding": "KD Interactive",
    "Marketing Name": "C15100m",
    "Device": "Pixi3-7_KD",
    "Model": "C15100m"
  },
  {
    "Retail Branding": "KD Interactive",
    "Marketing Name": "C15150m",
    "Device": "Pixi3-7_KD",
    "Model": "C15150m"
  },
  {
    "Retail Branding": "KD Interactive",
    "Marketing Name": "Kurio Phone",
    "Device": "C14500",
    "Model": "KurioPhone"
  },
  {
    "Retail Branding": "KD Interactive",
    "Marketing Name": "Kurio Tab - Extrem",
    "Device": "g03k",
    "Model": "C14100"
  },
  {
    "Retail Branding": "KD Interactive",
    "Marketing Name": "Kurio10S",
    "Device": "C13300A",
    "Model": "Kurio10S"
  },
  {
    "Retail Branding": "KD Interactive",
    "Marketing Name": "Kurio4S",
    "Device": "C13200A",
    "Model": "Kurio4S"
  },
  {
    "Retail Branding": "KD Interactive",
    "Marketing Name": "Kurio7S",
    "Device": "C13000A",
    "Model": "Kurio7S"
  },
  {
    "Retail Branding": "KD Interactive",
    "Marketing Name": "TAB3-Premium-XTREME3",
    "Device": "Pixi4-7_WIFI_KD",
    "Model": "01016"
  },
  {
    "Retail Branding": "KD Interactive",
    "Marketing Name": "TAB3-Premium-XTREME3",
    "Device": "Pixi4-7_WIFI_KD",
    "Model": "01516"
  },
  {
    "Retail Branding": "KD Interactive",
    "Marketing Name": "TabXL-Smart-Smart2in1-Tab10",
    "Device": "U3A_10_WIFI_KD",
    "Model": "02018"
  },
  {
    "Retail Branding": "KDDI",
    "Marketing Name": "C02AS5",
    "Device": "C02AS5",
    "Model": "C02AS5"
  },
  {
    "Retail Branding": "KDDI",
    "Marketing Name": "CablePlus STB",
    "Device": "C02AS",
    "Model": "C02AS"
  },
  {
    "Retail Branding": "KDDI",
    "Marketing Name": "Cableplus STB-2",
    "Device": "C02AS5",
    "Model": "C02AS5"
  },
  {
    "Retail Branding": "KDDI",
    "Marketing Name": "Power Up Unit",
    "Device": "C02BB1",
    "Model": "C02BB1"
  },
  {
    "Retail Branding": "KDDI",
    "Marketing Name": "STA3000",
    "Device": "sti6030d111",
    "Model": "STA3000"
  },
  {
    "Retail Branding": "KDDI",
    "Marketing Name": "STW2000",
    "Device": "H02ST1",
    "Model": "STW2000"
  },
  {
    "Retail Branding": "KDDI",
    "Marketing Name": "SmartTV Box",
    "Device": "C01AS",
    "Model": "SMARTTVBOX"
  },
  {
    "Retail Branding": "KEFEYA",
    "Marketing Name": "Touch-Screen-Monitor",
    "Device": "G2",
    "Model": "G2"
  },
  {
    "Retail Branding": "KEMPLER STRAUSS",
    "Marketing Name": "11PRO",
    "Device": "ZKEMPLER_11PRO",
    "Model": "ZKEMPLER_11PRO"
  },
  {
    "Retail Branding": "KEMPLER STRAUSS",
    "Marketing Name": "4K Smart TV",
    "Device": "gangbyeon",
    "Model": "4K Smart TV"
  },
  {
    "Retail Branding": "KEMPLER STRAUSS",
    "Marketing Name": "KEMP1HEAD",
    "Device": "KEMP1HEAD",
    "Model": "KEMP1HEAD"
  },
  {
    "Retail Branding": "KEMPLER STRAUSS",
    "Marketing Name": "KEMPLER 9",
    "Device": "KEMPLER_9",
    "Model": "KEMPLER_9"
  },
  {
    "Retail Branding": "KEMPLER STRAUSS",
    "Marketing Name": "KEMPLER TV",
    "Device": "KEMPLER_TV",
    "Model": "KEMPLER_TV"
  },
  {
    "Retail Branding": "KEMPLER STRAUSS",
    "Marketing Name": "KEMPLERP1_Amateur",
    "Device": "P1_Amateur",
    "Model": "P1 Amateur"
  },
  {
    "Retail Branding": "KEMPLER STRAUSS",
    "Marketing Name": "KEMPLER_8_PLUS",
    "Device": "KEMPLER_8_PLUS",
    "Model": "KEMPLER_8_PLUS"
  },
  {
    "Retail Branding": "KEMPLER STRAUSS",
    "Marketing Name": "KEMPLER_P1",
    "Device": "KEMPLER_P1",
    "Model": "KEMPLER_P1"
  },
  {
    "Retail Branding": "KEMPLER STRAUSS",
    "Marketing Name": "KEMPLER_P1_AMATEUR_PLUS",
    "Device": "KEMPLER_P1_AMATEUR_PLUS",
    "Model": "P1_AMATEUR"
  },
  {
    "Retail Branding": "KEMPLER STRAUSS",
    "Marketing Name": "KEMPLER_P3",
    "Device": "KEMPLER_P3",
    "Model": "KEMPLER_P3"
  },
  {
    "Retail Branding": "KEMPLER STRAUSS",
    "Marketing Name": "KEMPLER_X_TV",
    "Device": "KEMPLER_X_TV",
    "Model": "KEMPLER_X_TV"
  },
  {
    "Retail Branding": "KEMPLER STRAUSS",
    "Marketing Name": "KemplerP1pro",
    "Device": "P1pro",
    "Model": "P1 Pro"
  },
  {
    "Retail Branding": "KEMPLER STRAUSS",
    "Marketing Name": "Kempler_X_Pro",
    "Device": "Kempler_X_Pro",
    "Model": "Kempler_X_Pro"
  },
  {
    "Retail Branding": "KEMPLER STRAUSS",
    "Marketing Name": "Smart TV",
    "Device": "kanda",
    "Model": "2K Smart TV"
  },
  {
    "Retail Branding": "KEMPLER STRAUSS",
    "Marketing Name": "ZKEMPLER",
    "Device": "ZKEMPLER",
    "Model": "ZKEMPLER"
  },
  {
    "Retail Branding": "KEMPLER STRAUSS",
    "Marketing Name": "ZKEMPLER PRO",
    "Device": "ZKEMPLER_PRO",
    "Model": "ZKEMPLERPRO"
  },
  {
    "Retail Branding": "KEMPLER STRAUSS",
    "Marketing Name": "ZKEMPLER11",
    "Device": "ZKEMPLER11",
    "Model": "ZKEMPLER11"
  },
  {
    "Retail Branding": "KEMPLER STRAUSS",
    "Marketing Name": "ZKEMPLER11PLUS",
    "Device": "ZKEMPLER11PLUS",
    "Model": "ZKEMPLER11PLUS"
  },
  {
    "Retail Branding": "KEMPLER STRAUSS",
    "Marketing Name": "ZKEMPLER11PRO",
    "Device": "ZKEMPLER11PRO",
    "Model": "ZKEMPLER11PRO"
  },
  {
    "Retail Branding": "KEMPLER STRAUSS",
    "Marketing Name": "ZKEMPLERMAX",
    "Device": "ZKEMPLERMAX",
    "Model": "ZKEMPLERMAX"
  },
  {
    "Retail Branding": "KEMPLER STRAUSS",
    "Marketing Name": "ZKEMPLER_11",
    "Device": "ZKEMPLER_11",
    "Model": "ZKEMPLER_11"
  },
  {
    "Retail Branding": "KEMPLER STRAUSS",
    "Marketing Name": "ZKEMPLER_MAX",
    "Device": "ZKEMPLER_MAX",
    "Model": "ZKEMPLER_MAX"
  },
  {
    "Retail Branding": "KEMPLER STRAUSS",
    "Marketing Name": "ZKEMPLER_PLUS",
    "Device": "ZKEMPLER_PLUS",
    "Model": "ZKEMPLER PLUS"
  },
  {
    "Retail Branding": "KENSHI",
    "Marketing Name": "Armor C1 Max",
    "Device": "Armor_C1_Max",
    "Model": "Armor C1 Max"
  },
  {
    "Retail Branding": "KENSHI",
    "Marketing Name": "Armor C1s",
    "Device": "Armor_C1s",
    "Model": "Armor C1s"
  },
  {
    "Retail Branding": "KENSHI",
    "Marketing Name": "Armor H1s",
    "Device": "Armor_H1s",
    "Model": "Armor H1s"
  },
  {
    "Retail Branding": "KENSHI",
    "Marketing Name": "Armor H2s",
    "Device": "Armor_H2s",
    "Model": "Armor H2s"
  },
  {
    "Retail Branding": "KENSHI",
    "Marketing Name": "Armor I1 Slim",
    "Device": "Armor_I1_Slim",
    "Model": "Armor I1 Slim"
  },
  {
    "Retail Branding": "KENSHI",
    "Marketing Name": "Armor I1w",
    "Device": "Armor_I1w",
    "Model": "Armor I1w"
  },
  {
    "Retail Branding": "KENSHI",
    "Marketing Name": "Armor P1 Pro",
    "Device": "Armor_P1_Pro",
    "Model": "Armor P1 Pro"
  },
  {
    "Retail Branding": "KENSHI",
    "Marketing Name": "Armor P1w",
    "Device": "Armor_P1w",
    "Model": "Armor P1w"
  },
  {
    "Retail Branding": "KENSHI",
    "Marketing Name": "Armor V1s",
    "Device": "Armor_V1s",
    "Model": "Armor V1s"
  },
  {
    "Retail Branding": "KENSHI",
    "Marketing Name": "Armor_C1w_RU",
    "Device": "Armor_C1w",
    "Model": "Armor_C1w"
  },
  {
    "Retail Branding": "KENSHI",
    "Marketing Name": "Armor_H1w",
    "Device": "Armor_H1w",
    "Model": "Armor_H1w"
  },
  {
    "Retail Branding": "KENSHI",
    "Marketing Name": "Armor_I2w",
    "Device": "Armor_I2w",
    "Model": "Armor I2w"
  },
  {
    "Retail Branding": "KENSHI",
    "Marketing Name": "Armor_P1s",
    "Device": "Armor_P1s",
    "Model": "Armor P1s"
  },
  {
    "Retail Branding": "KENSHI",
    "Marketing Name": "E10",
    "Device": "E10",
    "Model": "E10"
  },
  {
    "Retail Branding": "KENSHI",
    "Marketing Name": "E11",
    "Device": "E11",
    "Model": "E11"
  },
  {
    "Retail Branding": "KENSHI",
    "Marketing Name": "E12",
    "Device": "E12",
    "Model": "E12"
  },
  {
    "Retail Branding": "KENSHI",
    "Marketing Name": "E17_RU",
    "Device": "E17",
    "Model": "E17"
  },
  {
    "Retail Branding": "KENSHI",
    "Marketing Name": "E18_RU",
    "Device": "E18",
    "Model": "E18"
  },
  {
    "Retail Branding": "KENSHI",
    "Marketing Name": "E28",
    "Device": "E28",
    "Model": "E28"
  },
  {
    "Retail Branding": "KENSHI",
    "Marketing Name": "EAUBBFV_PAD",
    "Device": "EAUBBFV_PAD",
    "Model": "PAD"
  },
  {
    "Retail Branding": "KENSHI",
    "Marketing Name": "EBUABFV_PAD",
    "Device": "EBUABFV_PAD",
    "Model": "PAD"
  },
  {
    "Retail Branding": "KENSHI",
    "Marketing Name": "EDMDCEV_PRO",
    "Device": "EDMDCEV_PRO",
    "Model": "Pad Pro"
  },
  {
    "Retail Branding": "KENSHI",
    "Marketing Name": "H10",
    "Device": "H10",
    "Model": "H10"
  },
  {
    "Retail Branding": "KENSHI",
    "Marketing Name": "H11",
    "Device": "H11",
    "Model": "H11"
  },
  {
    "Retail Branding": "KENSHI",
    "Marketing Name": "H14",
    "Device": "H14",
    "Model": "H14"
  },
  {
    "Retail Branding": "KENSHI",
    "Marketing Name": "H15",
    "Device": "H15",
    "Model": "H15"
  },
  {
    "Retail Branding": "KENSHI",
    "Marketing Name": "H16",
    "Device": "H16",
    "Model": "H16"
  },
  {
    "Retail Branding": "KENSHI",
    "Marketing Name": "H17_RU",
    "Device": "H17",
    "Model": "H17"
  },
  {
    "Retail Branding": "KENSHI",
    "Marketing Name": "H18_RU",
    "Device": "H18",
    "Model": "H18"
  },
  {
    "Retail Branding": "KENSHI",
    "Marketing Name": "H19",
    "Device": "H19",
    "Model": "H19"
  },
  {
    "Retail Branding": "KENSHI",
    "Marketing Name": "H20",
    "Device": "H20",
    "Model": "H20"
  },
  {
    "Retail Branding": "KENSHI",
    "Marketing Name": "H21",
    "Device": "H21",
    "Model": "H21"
  },
  {
    "Retail Branding": "KENSHI",
    "Marketing Name": "H24",
    "Device": "H24",
    "Model": "H24"
  },
  {
    "Retail Branding": "KENSHI",
    "Marketing Name": "H34",
    "Device": "H34",
    "Model": "H34"
  },
  {
    "Retail Branding": "KENSHI",
    "Marketing Name": "H38",
    "Device": "H38",
    "Model": "H38"
  },
  {
    "Retail Branding": "KENSHI",
    "Marketing Name": "H44",
    "Device": "H44",
    "Model": "H44"
  },
  {
    "Retail Branding": "KENSHI",
    "Marketing Name": "Kenshi KP10",
    "Device": "KP10",
    "Model": "KP10"
  },
  {
    "Retail Branding": "KENSHI",
    "Marketing Name": "Kenshi KP11",
    "Device": "KP11",
    "Model": "KP11"
  },
  {
    "Retail Branding": "KENSHI",
    "Marketing Name": "Kenshi_K10",
    "Device": "Kenshi_K10",
    "Model": "Kenshi_K10"
  },
  {
    "Retail Branding": "KENSHI",
    "Marketing Name": "O8",
    "Device": "O8",
    "Model": "O8"
  },
  {
    "Retail Branding": "KENSHI",
    "Marketing Name": "Pad_Lite_E48",
    "Device": "Pad_Lite_E48",
    "Model": "Pad Lite E48"
  },
  {
    "Retail Branding": "KENSHI",
    "Marketing Name": "Pad_Lite_E58",
    "Device": "Pad_Lite_E58",
    "Model": "Pad Lite E58"
  },
  {
    "Retail Branding": "KENSHI",
    "Marketing Name": "Pad_Plus_E113",
    "Device": "Pad_Plus_E113",
    "Model": "Pad Plus E113"
  },
  {
    "Retail Branding": "KENSHI",
    "Marketing Name": "Pad_Pro_E110",
    "Device": "Pad_Pro_E110",
    "Model": "Pad Pro E110"
  },
  {
    "Retail Branding": "KENSHI",
    "Marketing Name": "Pad_Pro_E111",
    "Device": "Pad_Pro_E111",
    "Model": "Pad Pro E111"
  },
  {
    "Retail Branding": "KENSHI",
    "Marketing Name": "Pad_Pro_E112",
    "Device": "Pad_Pro_E112",
    "Model": "Pad Pro E112"
  },
  {
    "Retail Branding": "KENSHI",
    "Marketing Name": "Pad_Pro_E113",
    "Device": "Pad_Pro_E113",
    "Model": "Pad Pro E113"
  },
  {
    "Retail Branding": "KENSHI",
    "Marketing Name": "Pad_Pro_E90",
    "Device": "Pad_Pro_E90",
    "Model": "Pad Pro E90"
  },
  {
    "Retail Branding": "KEP-Tech",
    "Marketing Name": "K-S18",
    "Device": "K-S18",
    "Model": "K-S18"
  },
  {
    "Retail Branding": "KEP-Tech",
    "Marketing Name": "Tablet",
    "Device": "M1513",
    "Model": "M1513"
  },
  {
    "Retail Branding": "KEYENCE",
    "Marketing Name": "BT-A2000",
    "Device": "BT-A2000",
    "Model": "BT-A2000"
  },
  {
    "Retail Branding": "KEYENCE",
    "Marketing Name": "BT-A2000M",
    "Device": "BT-A2000",
    "Model": "BT-A2000M"
  },
  {
    "Retail Branding": "KEYENCE",
    "Marketing Name": "BT-A500GA",
    "Device": "BTA500",
    "Model": "BTA500"
  },
  {
    "Retail Branding": "KEYENCE",
    "Marketing Name": "BT-A600",
    "Device": "BT-A600",
    "Model": "BT-A600"
  },
  {
    "Retail Branding": "KEYENCE",
    "Marketing Name": "BT-A600M",
    "Device": "BT-A600",
    "Model": "BT-A600M"
  },
  {
    "Retail Branding": "KEYENCE",
    "Marketing Name": "BTA700",
    "Device": "BTA700",
    "Model": "BTA700"
  },
  {
    "Retail Branding": "KEYENCE",
    "Marketing Name": "DX-A400",
    "Device": "DX-A400",
    "Model": "DX-A400"
  },
  {
    "Retail Branding": "KEYENCE",
    "Marketing Name": "DX-A600",
    "Device": "DX-A600",
    "Model": "DX-A600"
  },
  {
    "Retail Branding": "KEYENCE",
    "Marketing Name": "DXA800",
    "Device": "DXA800",
    "Model": "DXA800"
  },
  {
    "Retail Branding": "KGMotors",
    "Marketing Name": "mibot",
    "Device": "mibot",
    "Model": "mibot"
  },
  {
    "Retail Branding": "KGTEL",
    "Marketing Name": "A56",
    "Device": "A56",
    "Model": "A56"
  },
  {
    "Retail Branding": "KGTEL",
    "Marketing Name": "Better10",
    "Device": "Better10",
    "Model": "Better10"
  },
  {
    "Retail Branding": "KGTEL",
    "Marketing Name": "Hello 10 Pro 4G",
    "Device": "Hello_10_Pro_4G",
    "Model": "Hello 10 Pro 4G"
  },
  {
    "Retail Branding": "KGTEL",
    "Marketing Name": "Mate_20_Pro_4G",
    "Device": "Mate20_Pro_4G",
    "Model": "Mate 20 Pro 4G"
  },
  {
    "Retail Branding": "KGTEL",
    "Marketing Name": "Nova_10_Pro_4G",
    "Device": "Nova_10_Pro_4G",
    "Model": "Nova_10_Pro_4G"
  },
  {
    "Retail Branding": "KGTEL",
    "Marketing Name": "R10",
    "Device": "R10A",
    "Model": "R10"
  },
  {
    "Retail Branding": "KGTEL",
    "Marketing Name": "X5",
    "Device": "X5A",
    "Model": "X5"
  },
  {
    "Retail Branding": "KGTEL",
    "Marketing Name": "X55E",
    "Device": "X55E",
    "Model": "X55E"
  },
  {
    "Retail Branding": "KINGTOP",
    "Marketing Name": "KP26_EEA",
    "Device": "KP26",
    "Model": "KP26"
  },
  {
    "Retail Branding": "KINHANK",
    "Marketing Name": "G1",
    "Device": "YEG",
    "Model": "G1"
  },
  {
    "Retail Branding": "KIRISUN",
    "Marketing Name": "KIRISUN T650",
    "Device": "T650",
    "Model": "T650"
  },
  {
    "Retail Branding": "KISA phone",
    "Marketing Name": "KPAU04",
    "Device": "KPAU04",
    "Model": "KPAU04"
  },
  {
    "Retail Branding": "KJ_Board",
    "Marketing Name": "KJG IR13",
    "Device": "KJG_IR13",
    "Model": "KJG_Series"
  },
  {
    "Retail Branding": "KNC (LK)",
    "Marketing Name": "TPC_XTE10D",
    "Device": "TPC_XTE10D",
    "Model": "TPC_XTE10D"
  },
  {
    "Retail Branding": "KOESIO_SCREEN_ISITOUCH",
    "Marketing Name": "K_SIT_M2",
    "Device": "K_SIT_M2",
    "Model": "KOESIO SCREEN ISITOUCH"
  },
  {
    "Retail Branding": "KONDE",
    "Marketing Name": "KD2",
    "Device": "KD2",
    "Model": "KD2"
  },
  {
    "Retail Branding": "KONDE",
    "Marketing Name": "KIDS_FIVE",
    "Device": "KIDS_FIVE",
    "Model": "KIDS_FIVE"
  },
  {
    "Retail Branding": "KONKA",
    "Marketing Name": "Asia Pacific, Europe, MiddleEast，Africa",
    "Device": "nippori",
    "Model": "KONKA Android TV 2K"
  },
  {
    "Retail Branding": "KONKA",
    "Marketing Name": "Cygnus",
    "Device": "Cygnus",
    "Model": "Cygnus"
  },
  {
    "Retail Branding": "KONKA",
    "Marketing Name": "HK 2K Google TV",
    "Device": "capitolhill",
    "Model": "HK 2K Google TV"
  },
  {
    "Retail Branding": "KONKA",
    "Marketing Name": "HK 4K Google TV-A",
    "Device": "keoneae",
    "Model": "HK 4K Google TV-A"
  },
  {
    "Retail Branding": "KONKA",
    "Marketing Name": "HK 4K Google TV-B",
    "Device": "keoneae",
    "Model": "HK 4K Google TV-B"
  },
  {
    "Retail Branding": "KONKA",
    "Marketing Name": "HK 4K Google TV-C",
    "Device": "keoneae",
    "Model": "HK 4K Google TV-C"
  },
  {
    "Retail Branding": "KONKA",
    "Marketing Name": "HK 4K Google TV-D",
    "Device": "keoneae",
    "Model": "HK 4K Google TV-D"
  },
  {
    "Retail Branding": "KONKA",
    "Marketing Name": "HK Google TV-A",
    "Device": "bandra",
    "Model": "HK Google TV-A"
  },
  {
    "Retail Branding": "KONKA",
    "Marketing Name": "HYUNDAI 4K Google TV-E",
    "Device": "keoneae",
    "Model": "HYUNDAI 4K Google TV-E"
  },
  {
    "Retail Branding": "KONKA",
    "Marketing Name": "KC516",
    "Device": "KC516",
    "Model": "KC516"
  },
  {
    "Retail Branding": "KONKA",
    "Marketing Name": "KC516_Pro",
    "Device": "KC516_Pro",
    "Model": "KC516 Pro"
  },
  {
    "Retail Branding": "KONKA",
    "Marketing Name": "KKRTK2851FGTV_K",
    "Device": "clara",
    "Model": "KONKA 4K Google TV"
  },
  {
    "Retail Branding": "KONKA",
    "Marketing Name": "KKRTK2875P_K",
    "Device": "coxwell",
    "Model": "KONKA 4KP Google TV"
  },
  {
    "Retail Branding": "KONKA",
    "Marketing Name": "KM7012BK",
    "Device": "KM7012BK",
    "Model": "KM7012BK"
  },
  {
    "Retail Branding": "KONKA",
    "Marketing Name": "KONKA",
    "Device": "seocho",
    "Model": "KONKA 4K Android TV"
  },
  {
    "Retail Branding": "KONKA",
    "Marketing Name": "KONKA",
    "Device": "sugamo",
    "Model": "KONKA 2K Android TV"
  },
  {
    "Retail Branding": "KONKA",
    "Marketing Name": "KONKA  N188",
    "Device": "N188",
    "Model": "KONKA-N188"
  },
  {
    "Retail Branding": "KONKA",
    "Marketing Name": "KONKA  Y109",
    "Device": "Y109",
    "Model": "KONKA-Y109"
  },
  {
    "Retail Branding": "KONKA",
    "Marketing Name": "KONKA 2K Android TV",
    "Device": "lasalle",
    "Model": "KONKA 2K Android TV"
  },
  {
    "Retail Branding": "KONKA",
    "Marketing Name": "KONKA 2K Android TV-A",
    "Device": "lasalle",
    "Model": "KONKA 2K Android TV-A"
  },
  {
    "Retail Branding": "KONKA",
    "Marketing Name": "KONKA 2K Android TV-B",
    "Device": "lasalle",
    "Model": "KONKA 2K Android TV-B"
  },
  {
    "Retail Branding": "KONKA",
    "Marketing Name": "KONKA 2K Google TV",
    "Device": "aalter",
    "Model": "KONKA 2K Google TV"
  },
  {
    "Retail Branding": "KONKA",
    "Marketing Name": "KONKA 4K Android TV",
    "Device": "kenton",
    "Model": "KONKA 4K Android TV"
  },
  {
    "Retail Branding": "KONKA",
    "Marketing Name": "KONKA 4K Android TV-A",
    "Device": "kenton",
    "Model": "KONKA 4K Android TV-A"
  },
  {
    "Retail Branding": "KONKA",
    "Marketing Name": "KONKA 4K Android TV-B",
    "Device": "kenton",
    "Model": "KONKA 4K Android TV-B"
  },
  {
    "Retail Branding": "KONKA",
    "Marketing Name": "KONKA 4K Google TV",
    "Device": "keoneae",
    "Model": "HK 4K Google TV"
  },
  {
    "Retail Branding": "KONKA",
    "Marketing Name": "KONKA 4K OLED Google TV",
    "Device": "bandra",
    "Model": "HK Google TV"
  },
  {
    "Retail Branding": "KONKA",
    "Marketing Name": "KONKA Android TV",
    "Device": "hongik",
    "Model": "KONKA 4K Android TV"
  },
  {
    "Retail Branding": "KONKA",
    "Marketing Name": "Konka Android TV",
    "Device": "uguisudani",
    "Model": "KONKA 2K Android TV"
  },
  {
    "Retail Branding": "KONKA",
    "Marketing Name": "Konka android tv",
    "Device": "hanyang",
    "Model": "KONKA Android TV 4K"
  },
  {
    "Retail Branding": "KONKA",
    "Marketing Name": "M27S",
    "Device": "M27S",
    "Model": "M27S"
  },
  {
    "Retail Branding": "KONKA",
    "Marketing Name": "MOON",
    "Device": "MOON",
    "Model": "MOON"
  },
  {
    "Retail Branding": "KONKA",
    "Marketing Name": "N15",
    "Device": "N15",
    "Model": "N15"
  },
  {
    "Retail Branding": "KONKA",
    "Marketing Name": "N17",
    "Device": "N17",
    "Model": "N17"
  },
  {
    "Retail Branding": "KONKA",
    "Marketing Name": "N7",
    "Device": "N7",
    "Model": "N7"
  },
  {
    "Retail Branding": "KONKA",
    "Marketing Name": "RE1",
    "Device": "RE1",
    "Model": "RE1"
  },
  {
    "Retail Branding": "KONKA",
    "Marketing Name": "RU1",
    "Device": "RU1",
    "Model": "RU1"
  },
  {
    "Retail Branding": "KONKA",
    "Marketing Name": "SE1",
    "Device": "SE1",
    "Model": "SE1"
  },
  {
    "Retail Branding": "KONKA",
    "Marketing Name": "SE2",
    "Device": "SE2",
    "Model": "SE2"
  },
  {
    "Retail Branding": "KONKA",
    "Marketing Name": "SP10",
    "Device": "SP10",
    "Model": "SP10"
  },
  {
    "Retail Branding": "KONKA",
    "Marketing Name": "SP20",
    "Device": "SP20",
    "Model": "SP20"
  },
  {
    "Retail Branding": "KONKA",
    "Marketing Name": "SP3",
    "Device": "SP3",
    "Model": "SP3"
  },
  {
    "Retail Branding": "KONKA",
    "Marketing Name": "SP5",
    "Device": "SP5",
    "Model": "SP5"
  },
  {
    "Retail Branding": "KONKA",
    "Marketing Name": "SP9",
    "Device": "SP9",
    "Model": "SP9"
  },
  {
    "Retail Branding": "KONKA",
    "Marketing Name": "TE1011",
    "Device": "TE1011",
    "Model": "TE1011"
  },
  {
    "Retail Branding": "KONKA",
    "Marketing Name": "TP701",
    "Device": "TP701",
    "Model": "TP701"
  },
  {
    "Retail Branding": "KONKA",
    "Marketing Name": "VISION E1 Series",
    "Device": "VISION_E1_Series",
    "Model": "VISION_E1_Series"
  },
  {
    "Retail Branding": "KONKA",
    "Marketing Name": "sp6",
    "Device": "SP6",
    "Model": "SP6"
  },
  {
    "Retail Branding": "KOOLMAAX",
    "Marketing Name": "GEMINI",
    "Device": "GEMINI",
    "Model": "GEMINI"
  },
  {
    "Retail Branding": "KOOLNEE",
    "Marketing Name": "K1",
    "Device": "KOOLNEE_K1",
    "Model": "K1"
  },
  {
    "Retail Branding": "KOOLNEE",
    "Marketing Name": "K1 Trio",
    "Device": "K1_Trio",
    "Model": "K1 Trio"
  },
  {
    "Retail Branding": "KOOLNEE",
    "Marketing Name": "K3",
    "Device": "K3",
    "Model": "K3"
  },
  {
    "Retail Branding": "KOOLNEE",
    "Marketing Name": "RAINBOW",
    "Device": "RAINBOW",
    "Model": "RAINBOW"
  },
  {
    "Retail Branding": "KOOMII",
    "Marketing Name": "KOOMII_A6",
    "Device": "KOOMII_A6",
    "Model": "KOOMII A6"
  },
  {
    "Retail Branding": "KOOOK",
    "Marketing Name": "C600",
    "Device": "GBC_bravo",
    "Model": "C600"
  },
  {
    "Retail Branding": "KPHONE",
    "Marketing Name": "S1",
    "Device": "S1",
    "Model": "S1"
  },
  {
    "Retail Branding": "KPN",
    "Marketing Name": "KPN TV+ Box",
    "Device": "m250_k",
    "Model": "KPN DIW7022"
  },
  {
    "Retail Branding": "KPN",
    "Marketing Name": "KPN TV+ Soundbox",
    "Device": "m393vsb_kpn",
    "Model": "KPN VSB3918"
  },
  {
    "Retail Branding": "KRAVEiN",
    "Marketing Name": "KR_T01",
    "Device": "KR-T01",
    "Model": "KR-T01"
  },
  {
    "Retail Branding": "KRIP",
    "Marketing Name": "K4b",
    "Device": "K4b",
    "Model": "K4b"
  },
  {
    "Retail Branding": "KRIP",
    "Marketing Name": "K4m",
    "Device": "K4m",
    "Model": "K4m"
  },
  {
    "Retail Branding": "KRIP",
    "Marketing Name": "K5",
    "Device": "K5",
    "Model": "K5"
  },
  {
    "Retail Branding": "KRIP",
    "Marketing Name": "K50",
    "Device": "K50",
    "Model": "K50"
  },
  {
    "Retail Branding": "KRIP",
    "Marketing Name": "K51",
    "Device": "K51",
    "Model": "K51"
  },
  {
    "Retail Branding": "KRIP",
    "Marketing Name": "K55g",
    "Device": "K55g",
    "Model": "K55g"
  },
  {
    "Retail Branding": "KRIP",
    "Marketing Name": "K55h",
    "Device": "K55h",
    "Model": "K55h"
  },
  {
    "Retail Branding": "KRIP",
    "Marketing Name": "K56",
    "Device": "K56",
    "Model": "K56"
  },
  {
    "Retail Branding": "KRIP",
    "Marketing Name": "K57",
    "Device": "K57",
    "Model": "K57"
  },
  {
    "Retail Branding": "KRIP",
    "Marketing Name": "K58",
    "Device": "K58",
    "Model": "K58"
  },
  {
    "Retail Branding": "KRIP",
    "Marketing Name": "K58b",
    "Device": "K58b",
    "Model": "K58b"
  },
  {
    "Retail Branding": "KRIP",
    "Marketing Name": "K5b",
    "Device": "K5b",
    "Model": "K5b"
  },
  {
    "Retail Branding": "KRIP",
    "Marketing Name": "K5c",
    "Device": "K5c",
    "Model": "K5c"
  },
  {
    "Retail Branding": "KRIP",
    "Marketing Name": "K5d",
    "Device": "K5d",
    "Model": "K5d"
  },
  {
    "Retail Branding": "KRIP",
    "Marketing Name": "K5m",
    "Device": "K5m",
    "Model": "K5m"
  },
  {
    "Retail Branding": "KRIP",
    "Marketing Name": "K6",
    "Device": "K6",
    "Model": "K6"
  },
  {
    "Retail Branding": "KRIP",
    "Marketing Name": "K60",
    "Device": "K60",
    "Model": "K60"
  },
  {
    "Retail Branding": "KRIP",
    "Marketing Name": "K65",
    "Device": "K65",
    "Model": "K65"
  },
  {
    "Retail Branding": "KRIP",
    "Marketing Name": "K66",
    "Device": "K66",
    "Model": "K66"
  },
  {
    "Retail Branding": "KRIP",
    "Marketing Name": "K6b",
    "Device": "K6b",
    "Model": "K6b"
  },
  {
    "Retail Branding": "KRIP",
    "Marketing Name": "K700A",
    "Device": "KRIP_K700A",
    "Model": "K700A"
  },
  {
    "Retail Branding": "KRIP",
    "Marketing Name": "KRIP K68",
    "Device": "K68",
    "Model": "K68"
  },
  {
    "Retail Branding": "KRIP",
    "Marketing Name": "KRIP K69",
    "Device": "K69",
    "Model": "K69"
  },
  {
    "Retail Branding": "KRIP",
    "Marketing Name": "KRIP_K4",
    "Device": "KRIP_K4",
    "Model": "KRIP_K4"
  },
  {
    "Retail Branding": "KRIP",
    "Marketing Name": "KRIP_K55",
    "Device": "KRIP_K55",
    "Model": "KRIP_K55"
  },
  {
    "Retail Branding": "KT Tech",
    "Marketing Name": "",
    "Device": "s120",
    "Model": "KM-S120"
  },
  {
    "Retail Branding": "KT Tech",
    "Marketing Name": "",
    "Device": "s200",
    "Model": "KM-S200"
  },
  {
    "Retail Branding": "KT Tech",
    "Marketing Name": "",
    "Device": "s220",
    "Model": "KM-S220"
  },
  {
    "Retail Branding": "KT Tech",
    "Marketing Name": "",
    "Device": "s220H",
    "Model": "KM-S220H"
  },
  {
    "Retail Branding": "KT Tech",
    "Marketing Name": "",
    "Device": "s300",
    "Model": "KM-S300"
  },
  {
    "Retail Branding": "KT Tech",
    "Marketing Name": "",
    "Device": "s330",
    "Model": "KM-S330"
  },
  {
    "Retail Branding": "KT Tech",
    "Marketing Name": "EV-S100",
    "Device": "s100",
    "Model": "EV-S100"
  },
  {
    "Retail Branding": "KT Tech",
    "Marketing Name": "TAKE SUIT",
    "Device": "e100",
    "Model": "KM-E100"
  },
  {
    "Retail Branding": "KTC",
    "Marketing Name": "EcoTV1 J",
    "Device": "catlins",
    "Model": "EcoTV1 J"
  },
  {
    "Retail Branding": "KTC",
    "Marketing Name": "EcoTVCOL",
    "Device": "lavender",
    "Model": "EcoTV C"
  },
  {
    "Retail Branding": "KTC",
    "Marketing Name": "EcoTVDVB",
    "Device": "lavender",
    "Model": "EcoTV D"
  },
  {
    "Retail Branding": "KTC",
    "Marketing Name": "EcoTVISDB",
    "Device": "lavender",
    "Model": "EcoTV"
  },
  {
    "Retail Branding": "KTC",
    "Marketing Name": "KTC",
    "Device": "hongkong",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "KTC",
    "Marketing Name": "KTC",
    "Device": "jagalchi",
    "Model": "2K SMART TV"
  },
  {
    "Retail Branding": "KTC",
    "Marketing Name": "KTC",
    "Device": "mountbaker",
    "Model": "2K SMART TV"
  },
  {
    "Retail Branding": "KTC",
    "Marketing Name": "SD_GM01",
    "Device": "Capricorn",
    "Model": "Eco Smart Display"
  },
  {
    "Retail Branding": "KTC",
    "Marketing Name": "SD_GM02",
    "Device": "Leo",
    "Model": "Eco Smart Display ME"
  },
  {
    "Retail Branding": "KTC",
    "Marketing Name": "SD_GM03",
    "Device": "Sagittarius",
    "Model": "Eco Smart Display Lite"
  },
  {
    "Retail Branding": "KTC",
    "Marketing Name": "W83B-LANGO3576",
    "Device": "W83B-F2-RK3576",
    "Model": "W83B-F2-RK3576"
  },
  {
    "Retail Branding": "KTC",
    "Marketing Name": "W93B_A",
    "Device": "W93B_A",
    "Model": "W93B_A"
  },
  {
    "Retail Branding": "KTC (PD)",
    "Marketing Name": "BLISS503",
    "Device": "BLISS503",
    "Model": "BLISS503"
  },
  {
    "Retail Branding": "KTC (PD)",
    "Marketing Name": "BLISS_8",
    "Device": "BLISS_8",
    "Model": "BLISS_8"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "ADSUN",
    "Device": "stanford",
    "Model": "2K SMART TV"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "ADSUN",
    "Device": "zhongshan",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "AKAI",
    "Device": "hongkong",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "AP",
    "Device": "stanford",
    "Model": "40D"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "ASAANO",
    "Device": "hongkong",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "ASAANO",
    "Device": "lavender",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "ASAANO",
    "Device": "mountbaker",
    "Model": "2K SMART TV"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "BANANA",
    "Device": "elliniko",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "BANANA",
    "Device": "jagalchi",
    "Model": "2K SMART TV"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "Banana",
    "Device": "stanford",
    "Model": "2K SMART TV"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "Banana",
    "Device": "zhongshan",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "CHIMEI",
    "Device": "elliniko",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "CHIMEI",
    "Device": "hongkong",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "CHIMEI",
    "Device": "zhongshan",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "COL",
    "Device": "stanford",
    "Model": "40DCOL"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "COL",
    "Device": "zhongshan",
    "Model": "43FCOL"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "COLORVIEW",
    "Device": "lavender",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "COLORVIEW",
    "Device": "mountbaker",
    "Model": "2K SMART TV"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "CONTINUUS",
    "Device": "stanford",
    "Model": "SMART TV"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "DAIWA",
    "Device": "hongkong",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "DAIWA",
    "Device": "lavender",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "DAMASCO",
    "Device": "elliniko",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "DAMASCO",
    "Device": "hongkong",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "DAMASCO",
    "Device": "jagalchi",
    "Model": "2K SMART TV"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "DAMASCO",
    "Device": "khardi",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "DAMASCO",
    "Device": "lavender",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "DAMASCO",
    "Device": "mountbaker",
    "Model": "2K SMART TV"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "DANILUX",
    "Device": "hongkong",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "DANILUX",
    "Device": "lavender",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "DANILUX",
    "Device": "mountbaker",
    "Model": "2K SMART TV"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "DEC",
    "Device": "hongkong",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "DIGGIO",
    "Device": "elliniko",
    "Model": "DIGGIO GOOGLE TV 4K"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "DIGGIO",
    "Device": "hongkong",
    "Model": "DIGGIO GOOGLE TV 4K"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "DIGGIO",
    "Device": "lavender",
    "Model": "DIGGIO GOOGLE TV 4K"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "DIGGIO",
    "Device": "mountbaker",
    "Model": "DIGGIO GOOGLE TV"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "DIGGIO",
    "Device": "stanford",
    "Model": "CSV2K"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "DIGGIO",
    "Device": "zhongshan",
    "Model": "CSV4K"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "DREAMVIEW",
    "Device": "stanford",
    "Model": "SMART TV"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "DYANORA",
    "Device": "stanford",
    "Model": "2K SMART TV"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "DYANORA",
    "Device": "zhongshan",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "ELECTRA",
    "Device": "elliniko",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "ELECTRA",
    "Device": "jagalchi",
    "Model": "2K SMART TV"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "ELEMENT",
    "Device": "mountbaker",
    "Model": "2K SMART TV"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "ESLEY",
    "Device": "elliniko",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "ESLEY",
    "Device": "hongkong",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "ESLEY",
    "Device": "lavender",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "ESLEY",
    "Device": "mountbaker",
    "Model": "2K SMART TV"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "Eco Smart Monitor",
    "Device": "kaisyuan",
    "Model": "Eco Smart Monitor"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "EcoTV Plus A",
    "Device": "hongkong",
    "Model": "EcoTV Plus A"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "EcoTV Plus C",
    "Device": "hongkong",
    "Model": "EcoTV Plus C"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "EcoTV Plus D",
    "Device": "hongkong",
    "Model": "EcoTV Plus D"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "EcoTV1",
    "Device": "jagalchi",
    "Model": "EcoTV1"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "EcoTV2",
    "Device": "kapellen",
    "Model": "EcoTV2"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "FOL",
    "Device": "hongkong",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "FOL",
    "Device": "mountbaker",
    "Model": "2K SMART TV"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "FPS",
    "Device": "elliniko",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "FPS",
    "Device": "hongkong",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "GOTO",
    "Device": "elliniko",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "GOTO",
    "Device": "templeton",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "GTRONIC",
    "Device": "elliniko",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "Global",
    "Device": "elliniko",
    "Model": "GLOBAL GOOGLE TV 4K"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "Global",
    "Device": "hongkong",
    "Model": "GLOBAL GOOGLE TV 4K"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "Global",
    "Device": "lavender",
    "Model": "GLOBAL GOOGLE TV 4K"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "Global",
    "Device": "mountbaker",
    "Model": "GLOBAL GOOGLE TV"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "Global",
    "Device": "stanford",
    "Model": "CSV2K"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "Golbal",
    "Device": "zhongshan",
    "Model": "CSV4K"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "HARMON-TEC",
    "Device": "hongkong",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "HARMON-TEC",
    "Device": "mountbaker",
    "Model": "2K SMART TV"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "HAUSTEC",
    "Device": "elliniko",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "IBG",
    "Device": "hongkong",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "IBG",
    "Device": "lavender",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "IBG",
    "Device": "mountbaker",
    "Model": "2K SMART TV"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "IHOME",
    "Device": "elliniko",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "IHOME",
    "Device": "hongkong",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "IHOME",
    "Device": "mountbaker",
    "Model": "2K SMART TV"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "IMMER",
    "Device": "hongkong",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "INCLO",
    "Device": "hongkong",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "INCLO",
    "Device": "khardi",
    "Model": "INCLO GOOGLE TV 4K"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "INNO-HIT",
    "Device": "hongkong",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "INNO-HIT",
    "Device": "khardi",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "INNO-HIT",
    "Device": "lavender",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "INNO-HIT",
    "Device": "mountbaker",
    "Model": "2K SMART TV"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "INNOVA",
    "Device": "hongkong",
    "Model": "INNOVA GOOGLE TV 4K"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "INNOVA",
    "Device": "lavender",
    "Model": "INNOVA GOOGLE TV 4K"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "INNOVA",
    "Device": "mountbaker",
    "Model": "INNOVA GOOGLE TV"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "INNOVA",
    "Device": "stanford",
    "Model": "CSV2K"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "INNOVA",
    "Device": "zhongshan",
    "Model": "CSV4K"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "IQWORLD",
    "Device": "lavender",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "JAMUNA",
    "Device": "elliniko",
    "Model": "JAMUNA SMART TV"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "JAMUNA",
    "Device": "jagalchi",
    "Model": "JAMUNA SMART TV"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "JANUS",
    "Device": "elliniko",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "JSW",
    "Device": "elliniko",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "JVCO",
    "Device": "elliniko",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "KIUNIT",
    "Device": "stanford",
    "Model": "SMART TV"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "KIUNIT",
    "Device": "zhongshan",
    "Model": "Smart UHD TV"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "KTC",
    "Device": "elliniko",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "KTC",
    "Device": "stanford",
    "Model": "2K SMART TV"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "KTC",
    "Device": "zhongshan",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "Leading Smart TV",
    "Device": "minami",
    "Model": "EcoTV J"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "LikeMe",
    "Device": "zhongshan",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "MARSRIVA",
    "Device": "elliniko",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "MARSRIVA",
    "Device": "jagalchi",
    "Model": "2K SMART TV"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "MAXEN",
    "Device": "elliniko",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "MAXIPOWER",
    "Device": "elliniko",
    "Model": "MAXIPOWER SMART TV"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "MITSUKI",
    "Device": "lavender",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "MULTISMART",
    "Device": "elliniko",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "MULTISMART",
    "Device": "lavender",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "MULTISMART",
    "Device": "mountbaker",
    "Model": "2K SMART TV"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "NA",
    "Device": "stanford",
    "Model": "40DNA"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "NA",
    "Device": "zhongshan",
    "Model": "43FNA"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "NAKAMICHI",
    "Device": "hongkong",
    "Model": "NAKAMICHI GOOGLE TV 4K"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "NAKAMICHI",
    "Device": "lavender",
    "Model": "NAKAMICHI GOOGLE TV 4K"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "NAKAMICHI",
    "Device": "mountbaker",
    "Model": "NAKAMICHI GOOGLE TV"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "NAKAMICHI",
    "Device": "stanford",
    "Model": "CSV2K"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "NAKAMICHI",
    "Device": "zhongshan",
    "Model": "CSV4K"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "NEXTSTAR",
    "Device": "elliniko",
    "Model": "NEXTSTAR SMART TV"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "NEXUS",
    "Device": "lavender",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "NEXUS",
    "Device": "mountbaker",
    "Model": "2K SMART TV"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "ONN",
    "Device": "elliniko",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "OZON",
    "Device": "stanford",
    "Model": "2K SMART TV"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "OZON",
    "Device": "zhongshan",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "PHIMARK",
    "Device": "hongkong",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "PHIMARK",
    "Device": "lavender",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "PHIMARK",
    "Device": "mountbaker",
    "Model": "2K SMART TV"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "POWEROLOGY",
    "Device": "hongkong",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "QRIOM",
    "Device": "elliniko",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "QRIOM",
    "Device": "hongkong",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "QRIOM",
    "Device": "lavender",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "QRIOM",
    "Device": "minami",
    "Model": "2K SMART TV"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "QRIOM",
    "Device": "mountbaker",
    "Model": "2K SMART TV"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "RANCON",
    "Device": "elliniko",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "RANCON",
    "Device": "jagalchi",
    "Model": "RANCON GOOGLE TV"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "RANCON",
    "Device": "khardi",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "RANCON",
    "Device": "mountbaker",
    "Model": "2K SMART TV"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "RENYA",
    "Device": "mountbaker",
    "Model": "2K SMART TV"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "REYNA",
    "Device": "hongkong",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "REYNA",
    "Device": "lavender",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "ROOMI",
    "Device": "hongkong",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "RZTK",
    "Device": "stanford",
    "Model": "2K SMART TV"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "RZTK",
    "Device": "zhongshan",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "SA",
    "Device": "hongkong",
    "Model": "EcoTV Plus"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "SA",
    "Device": "stanford",
    "Model": "40DSA"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "SA",
    "Device": "zhongshan",
    "Model": "43FSA"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "SEUCOM",
    "Device": "templeton",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "SIERA",
    "Device": "stanford",
    "Model": "2K Siera SMART TV"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "SKY-ONE",
    "Device": "stanford",
    "Model": "2K SMART TV"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "SKY-ONE",
    "Device": "zhongshan",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "SLCD_24PGV2",
    "Device": "araku",
    "Model": "EcoPro"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "STAR-TRACK",
    "Device": "lavender",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "STAR-TRACK",
    "Device": "lavender",
    "Model": "STAR-TRACK 4K SMART TV"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "SVISION",
    "Device": "hongkong",
    "Model": "SVISION 4K Android TV"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "Siera",
    "Device": "zhongshan",
    "Model": "4K Siera SMART TV"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "Smart TV",
    "Device": "mountbaker",
    "Model": "EcoTV FHD"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "THEUHD",
    "Device": "hongkong",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "TOMMATECH",
    "Device": "elliniko",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "TRIBOSS",
    "Device": "mountbaker",
    "Model": "2K SMART TV"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "VAMVO",
    "Device": "araku",
    "Model": "EcoPro"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "VEIRA",
    "Device": "lavender",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "VEIRA",
    "Device": "mountbaker",
    "Model": "2K SMART TV"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "VIMEEL",
    "Device": "elliniko",
    "Model": "VIMEEL GOOGLE TV 4K"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "VIMEEL",
    "Device": "lavender",
    "Model": "VIMEEL GOOGLE TV 4K"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "VIMEEL",
    "Device": "mountbaker",
    "Model": "VIMEEL GOOGLE TV"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "VINCENT",
    "Device": "elliniko",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "VINCENT",
    "Device": "mountbaker",
    "Model": "2K SMART TV"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "VIOTTO",
    "Device": "elliniko",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "VIOTTO",
    "Device": "elliniko",
    "Model": "VIOTTO SMART TV"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "VIOTTO",
    "Device": "hongkong",
    "Model": "4K SMART ISDB TV"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "VIOTTO",
    "Device": "hongkong",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "VIOTTO",
    "Device": "khardi",
    "Model": "4K SMART ISDB TV"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "VIOTTO",
    "Device": "khardi",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "VIOTTO",
    "Device": "lavender",
    "Model": "4K SMART ISDB TV"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "VIOTTO",
    "Device": "lavender",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "VIOTTO",
    "Device": "mountbaker",
    "Model": "2K SMART ISDB TV"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "VIOTTO",
    "Device": "mountbaker",
    "Model": "2K SMART TV"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "VISTA",
    "Device": "stanford",
    "Model": "2K SMART TV"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "VISTA",
    "Device": "zhongshan",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "VON",
    "Device": "stanford",
    "Model": "2K SMART TV"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "VON",
    "Device": "zhongshan",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "VOXELECTRONICS",
    "Device": "elliniko",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "VOXELECTRONICS",
    "Device": "hongkong",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "VOXELECTRONICS",
    "Device": "mountbaker",
    "Model": "2K SMART TV"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "WESTWAY",
    "Device": "mountbaker",
    "Model": "2K SMART TV"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "WYBOR",
    "Device": "elliniko",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "WYBOR",
    "Device": "hongkong",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "WYBOR",
    "Device": "lavender",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "WYBOR",
    "Device": "mountbaker",
    "Model": "2K SMART TV"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "X-VISION",
    "Device": "elliniko",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "XELL",
    "Device": "hongkong",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "XELL",
    "Device": "mountbaker",
    "Model": "2K SMART TV"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "YARA",
    "Device": "hongkong",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "ZENET",
    "Device": "elliniko",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "ZITRO",
    "Device": "mountbaker",
    "Model": "2K SMART TV"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "Zitro",
    "Device": "elliniko",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "Zitro",
    "Device": "stanford",
    "Model": "40DSA"
  },
  {
    "Retail Branding": "KTCtv",
    "Marketing Name": "Zitro",
    "Device": "zhongshan",
    "Model": "43FSA"
  },
  {
    "Retail Branding": "KTS (JP)",
    "Marketing Name": "IPN99_RTD1319_TOA",
    "Device": "TMS-KR01P",
    "Model": "TMS-KR01P"
  },
  {
    "Retail Branding": "KTV",
    "Marketing Name": "PureKTV",
    "Device": "DV8219",
    "Model": "Pure"
  },
  {
    "Retail Branding": "KTV",
    "Marketing Name": "PureKTV",
    "Device": "DV8219",
    "Model": "PureKTV"
  },
  {
    "Retail Branding": "KUBIK",
    "Marketing Name": "KUBIK_GENTA_10",
    "Device": "KUBIK_GENTA_10",
    "Model": "KUBIK_GENTA_10"
  },
  {
    "Retail Branding": "KUNFT",
    "Marketing Name": "K5130H43U",
    "Device": "samseong",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "KUNFT",
    "Marketing Name": "K5132H32H",
    "Device": "ikebukuro",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "KUNFT",
    "Marketing Name": "Smart TV",
    "Device": "alimos",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "KUNFT",
    "Marketing Name": "Smart TV",
    "Device": "dangni",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "KUNFT",
    "Marketing Name": "Smart TV",
    "Device": "redwood",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "KURAEMON",
    "Marketing Name": "KCG02",
    "Device": "KURAEMON_KCG02",
    "Model": "KCG02"
  },
  {
    "Retail Branding": "KURAEMON",
    "Marketing Name": "KURAEMON_Pad",
    "Device": "KURAEMON_Pad_Mini_Tough",
    "Model": "KMG05"
  },
  {
    "Retail Branding": "KUU-Tech",
    "Marketing Name": "UPAD2021_EEA",
    "Device": "UPAD2021",
    "Model": "UPad"
  },
  {
    "Retail Branding": "KUVA",
    "Marketing Name": "Pad",
    "Device": "Pad",
    "Model": "KUVA Pad"
  },
  {
    "Retail Branding": "KWUMSY",
    "Marketing Name": "G1",
    "Device": "G1",
    "Model": "G1"
  },
  {
    "Retail Branding": "KXD mobile",
    "Marketing Name": "A06",
    "Device": "A06",
    "Model": "A06"
  },
  {
    "Retail Branding": "KXD mobile",
    "Marketing Name": "A07",
    "Device": "A07",
    "Model": "A07"
  },
  {
    "Retail Branding": "KXD mobile",
    "Marketing Name": "A07 go",
    "Device": "A07_go",
    "Model": "A07_go"
  },
  {
    "Retail Branding": "KXD mobile",
    "Marketing Name": "A07_go",
    "Device": "A07_go",
    "Model": "A07_go"
  },
  {
    "Retail Branding": "KXD mobile",
    "Marketing Name": "A08",
    "Device": "A08",
    "Model": "A08"
  },
  {
    "Retail Branding": "KXD mobile",
    "Marketing Name": "A11",
    "Device": "A11",
    "Model": "A11"
  },
  {
    "Retail Branding": "KXD mobile",
    "Marketing Name": "A17 PLUS",
    "Device": "A17_PLUS",
    "Model": "A17_PLUS"
  },
  {
    "Retail Branding": "KXD mobile",
    "Marketing Name": "A6",
    "Device": "A6",
    "Model": "A6"
  },
  {
    "Retail Branding": "KXD mobile",
    "Marketing Name": "Blus Sea S25 Plus",
    "Device": "Blus_Sea_S25_Plus",
    "Model": "Blus_Sea_S25_Plus"
  },
  {
    "Retail Branding": "KXD mobile",
    "Marketing Name": "Blus_Sea_S25_Plus",
    "Device": "Blus_Sea_S25_Plus",
    "Model": "Blus_Sea_S25_Plus"
  },
  {
    "Retail Branding": "KXD mobile",
    "Marketing Name": "D68S",
    "Device": "D68S",
    "Model": "D68S"
  },
  {
    "Retail Branding": "KXD mobile",
    "Marketing Name": "D70R",
    "Device": "D70R",
    "Model": "D70R"
  },
  {
    "Retail Branding": "KXD mobile",
    "Marketing Name": "Universe S24_Plus",
    "Device": "Universe_S24_Plus",
    "Model": "Universe_S24_Plus"
  },
  {
    "Retail Branding": "KXD mobile",
    "Marketing Name": "Universe_S24_Plus",
    "Device": "Universe_S24_Plus",
    "Model": "Universe_S24_Plus"
  },
  {
    "Retail Branding": "KYASTER",
    "Marketing Name": "KPad_U2",
    "Device": "KPad_U2",
    "Model": "KPad_U2"
  },
  {
    "Retail Branding": "KYASTER",
    "Marketing Name": "KPad_U2_P",
    "Device": "KPad_U2_P",
    "Model": "KPad_U2_P"
  },
  {
    "Retail Branding": "KYASTER",
    "Marketing Name": "KPad_U2_Pro",
    "Device": "KPad_U2_Pro",
    "Model": "KPad_U2_Pro"
  },
  {
    "Retail Branding": "KYASTER",
    "Marketing Name": "KPad_U2_Pro_EEA",
    "Device": "KPad_U2_Pro_EEA",
    "Model": "KPad_U2_Pro_EEA"
  },
  {
    "Retail Branding": "KYASTER",
    "Marketing Name": "KPad_U4",
    "Device": "KPad_U4",
    "Model": "KPad_U4"
  },
  {
    "Retail Branding": "KYASTER",
    "Marketing Name": "KPad_U4_EEA",
    "Device": "KPad_U4_EEA",
    "Model": "KPad_U4_EEA"
  },
  {
    "Retail Branding": "KYDOS",
    "Marketing Name": "Europe",
    "Device": "sepolia",
    "Model": "KYDOS Smart TV"
  },
  {
    "Retail Branding": "KYODO-TV",
    "Marketing Name": "KARAxKARA",
    "Device": "KARAxKARA",
    "Model": "KARAxKARA"
  },
  {
    "Retail Branding": "KZG (Ke Zhi Guang)",
    "Marketing Name": "Dream one",
    "Device": "Dream_one",
    "Model": "Dream one"
  },
  {
    "Retail Branding": "KZG (Ke Zhi Guang)",
    "Marketing Name": "KZG Scope",
    "Device": "KZG_Scope",
    "Model": "KZG Scope"
  },
  {
    "Retail Branding": "KZG (Ke Zhi Guang)",
    "Marketing Name": "KZG_Scope",
    "Device": "KZG_Scope",
    "Model": "KZG Scope"
  },
  {
    "Retail Branding": "Kaicom",
    "Marketing Name": "H702",
    "Device": "H702",
    "Model": "H702"
  },
  {
    "Retail Branding": "Kaicom",
    "Marketing Name": "K7-40",
    "Device": "K7-40",
    "Model": "K7-40"
  },
  {
    "Retail Branding": "Kaicom",
    "Marketing Name": "K901",
    "Device": "K901",
    "Model": "K901"
  },
  {
    "Retail Branding": "Kaicom",
    "Marketing Name": "K901",
    "Device": "K901_2",
    "Model": "K901"
  },
  {
    "Retail Branding": "Kaicom",
    "Marketing Name": "KAICOM W660",
    "Device": "W660",
    "Model": "W660"
  },
  {
    "Retail Branding": "Kaliho",
    "Marketing Name": "H3",
    "Device": "H3",
    "Model": "H3"
  },
  {
    "Retail Branding": "Kalley",
    "Marketing Name": "Android TV",
    "Device": "R1",
    "Model": "ATV R1"
  },
  {
    "Retail Branding": "Kalley",
    "Marketing Name": "Android TV",
    "Device": "R2",
    "Model": "ATV R2"
  },
  {
    "Retail Branding": "Kalley",
    "Marketing Name": "BLACK_PRO",
    "Device": "BLACK_PRO",
    "Model": "BLACK_PRO"
  },
  {
    "Retail Branding": "Kalley",
    "Marketing Name": "Black",
    "Device": "Black",
    "Model": "Black"
  },
  {
    "Retail Branding": "Kalley",
    "Marketing Name": "Black 1",
    "Device": "Black_1",
    "Model": "Black 1"
  },
  {
    "Retail Branding": "Kalley",
    "Marketing Name": "Black G",
    "Device": "Black_G",
    "Model": "Black G"
  },
  {
    "Retail Branding": "Kalley",
    "Marketing Name": "Black G3",
    "Device": "Black_G3",
    "Model": "Black G3"
  },
  {
    "Retail Branding": "Kalley",
    "Marketing Name": "Black G4S",
    "Device": "Black_G4S",
    "Model": "Black G4S"
  },
  {
    "Retail Branding": "Kalley",
    "Marketing Name": "Black S",
    "Device": "Black_S",
    "Model": "Black S"
  },
  {
    "Retail Branding": "Kalley",
    "Marketing Name": "Black Z1",
    "Device": "Black_Z1",
    "Model": "Black Z1"
  },
  {
    "Retail Branding": "Kalley",
    "Marketing Name": "Black Z2",
    "Device": "Black_Z2",
    "Model": "Black Z2"
  },
  {
    "Retail Branding": "Kalley",
    "Marketing Name": "Black_3C",
    "Device": "Black_3",
    "Model": "Black 3"
  },
  {
    "Retail Branding": "Kalley",
    "Marketing Name": "Black_3CR",
    "Device": "Black_3",
    "Model": "Black 3"
  },
  {
    "Retail Branding": "Kalley",
    "Marketing Name": "Black_5",
    "Device": "Black_5",
    "Model": "Black_5"
  },
  {
    "Retail Branding": "Kalley",
    "Marketing Name": "Black_5C",
    "Device": "Black_5",
    "Model": "Black_5"
  },
  {
    "Retail Branding": "Kalley",
    "Marketing Name": "Black_6C",
    "Device": "Black_6C",
    "Model": "Black 6"
  },
  {
    "Retail Branding": "Kalley",
    "Marketing Name": "Black_6C2",
    "Device": "Black_6C",
    "Model": "Black 6"
  },
  {
    "Retail Branding": "Kalley",
    "Marketing Name": "Black_6G",
    "Device": "Black_6C",
    "Model": "Black 6"
  },
  {
    "Retail Branding": "Kalley",
    "Marketing Name": "Black_C_Plus",
    "Device": "Black_C_Plus",
    "Model": "Black C Plus"
  },
  {
    "Retail Branding": "Kalley",
    "Marketing Name": "Black_E",
    "Device": "Black_E",
    "Model": "Black_E"
  },
  {
    "Retail Branding": "Kalley",
    "Marketing Name": "Black_E2C",
    "Device": "Black_E2",
    "Model": "Black E2"
  },
  {
    "Retail Branding": "Kalley",
    "Marketing Name": "Black_G4",
    "Device": "Black_G4",
    "Model": "Black G4"
  },
  {
    "Retail Branding": "Kalley",
    "Marketing Name": "Black_G_2",
    "Device": "Black_G_2",
    "Model": "Black_G_2"
  },
  {
    "Retail Branding": "Kalley",
    "Marketing Name": "Black_X",
    "Device": "Black_X",
    "Model": "Black X"
  },
  {
    "Retail Branding": "Kalley",
    "Marketing Name": "Black_Z",
    "Device": "Black_Z",
    "Model": "Black_Z"
  },
  {
    "Retail Branding": "Kalley",
    "Marketing Name": "Black_Z2",
    "Device": "Black_Z2",
    "Model": "Black Z2"
  },
  {
    "Retail Branding": "Kalley",
    "Marketing Name": "ELEMENT MAX",
    "Device": "ELEMENT_MAX",
    "Model": "ELEMENT MAX"
  },
  {
    "Retail Branding": "Kalley",
    "Marketing Name": "ELEMENT PLUS",
    "Device": "ELEMENT_PLUS",
    "Model": "ELEMENT PLUS"
  },
  {
    "Retail Branding": "Kalley",
    "Marketing Name": "ELEMENT_PRO",
    "Device": "ELEMENT_PRO",
    "Model": "ELEMENT_PRO"
  },
  {
    "Retail Branding": "Kalley",
    "Marketing Name": "ELEMENT_PRO_2",
    "Device": "ELEMENT_PRO_2",
    "Model": "ELEMENT_PRO_2"
  },
  {
    "Retail Branding": "Kalley",
    "Marketing Name": "Element 4",
    "Device": "Element_4",
    "Model": "Element 4"
  },
  {
    "Retail Branding": "Kalley",
    "Marketing Name": "Element 4 Plus",
    "Device": "smartphone",
    "Model": "Element 4 Plus"
  },
  {
    "Retail Branding": "Kalley",
    "Marketing Name": "Element 5",
    "Device": "Element_5",
    "Model": "Element 5"
  },
  {
    "Retail Branding": "Kalley",
    "Marketing Name": "Element 5 Plus",
    "Device": "Element_5",
    "Model": "Element 5"
  },
  {
    "Retail Branding": "Kalley",
    "Marketing Name": "Element Play",
    "Device": "ELEMENT_PLAY",
    "Model": "ELEMENT PLAY"
  },
  {
    "Retail Branding": "Kalley",
    "Marketing Name": "Gold Pro",
    "Device": "GOLD_PRO",
    "Model": "GOLD_PRO"
  },
  {
    "Retail Branding": "Kalley",
    "Marketing Name": "K-BOOK73G",
    "Device": "K_BOOK73G",
    "Model": "K-BOOK73G"
  },
  {
    "Retail Branding": "Kalley",
    "Marketing Name": "Kalley TV",
    "Device": "beomil",
    "Model": "Kalley TV"
  },
  {
    "Retail Branding": "Kalley",
    "Marketing Name": "Kalley TV",
    "Device": "eleonas",
    "Model": "Kalley TV"
  },
  {
    "Retail Branding": "Kalley",
    "Marketing Name": "Kalley TV",
    "Device": "katehaki",
    "Model": "Kalley TV"
  },
  {
    "Retail Branding": "Kalley",
    "Marketing Name": "Kalley_FlexTab_11",
    "Device": "Kalley_FlexTab_11",
    "Model": "Kalley_FlexTab 11"
  },
  {
    "Retail Branding": "Kalley",
    "Marketing Name": "Klic",
    "Device": "SA",
    "Model": "K4-02 4G"
  },
  {
    "Retail Branding": "Kalley",
    "Marketing Name": "R10G",
    "Device": "R10G",
    "Model": "R10G"
  },
  {
    "Retail Branding": "Kalley",
    "Marketing Name": "R3",
    "Device": "R3",
    "Model": "R3"
  },
  {
    "Retail Branding": "Kalley",
    "Marketing Name": "R3_GTV",
    "Device": "R3_GTV",
    "Model": "R3G"
  },
  {
    "Retail Branding": "Kalley",
    "Marketing Name": "R4",
    "Device": "R4",
    "Model": "R4"
  },
  {
    "Retail Branding": "Kalley",
    "Marketing Name": "R4_GTV",
    "Device": "R4_GTV",
    "Model": "R4G"
  },
  {
    "Retail Branding": "Kalley",
    "Marketing Name": "SILVER_MAX",
    "Device": "SILVER_MAX",
    "Model": "SILVER_MAX"
  },
  {
    "Retail Branding": "Kalley",
    "Marketing Name": "Silver Max Lite",
    "Device": "Silver_Max_Lite",
    "Model": "Silver Max Lite"
  },
  {
    "Retail Branding": "Kalley",
    "Marketing Name": "Silver Max Pro",
    "Device": "Silver_Max_Pro",
    "Model": "Silver Max Pro"
  },
  {
    "Retail Branding": "Kalley",
    "Marketing Name": "Silver P5",
    "Device": "P5",
    "Model": "P5"
  },
  {
    "Retail Branding": "Kalley",
    "Marketing Name": "Silver_Max_Pro_2",
    "Device": "Silver_Max_Pro_2",
    "Model": "Silver_Max_Pro_2"
  },
  {
    "Retail Branding": "Kalley",
    "Marketing Name": "xiaoyushan_kalley",
    "Device": "xiaoyushan",
    "Model": "HiSmartTV A4"
  },
  {
    "Retail Branding": "Kammunica",
    "Marketing Name": "Kammunica_500V",
    "Device": "Kammunica_500V",
    "Model": "Kammunica_500V"
  },
  {
    "Retail Branding": "Kammunica",
    "Marketing Name": "Kammunica_800",
    "Device": "Kammunica_800",
    "Model": "Kammunica_800"
  },
  {
    "Retail Branding": "Kammunica",
    "Marketing Name": "Kammunica_XD",
    "Device": "Kammunica_XD",
    "Model": "Kammunica_XD"
  },
  {
    "Retail Branding": "KanDao",
    "Marketing Name": "Kandao Meeting Ultra",
    "Device": "MT1001",
    "Model": "MT1001"
  },
  {
    "Retail Branding": "Kanji",
    "Marketing Name": "ARGENTINA",
    "Device": "martin",
    "Model": "KANJI 2K Android TV"
  },
  {
    "Retail Branding": "Kanji",
    "Marketing Name": "ARGENTINA",
    "Device": "patrick",
    "Model": "KANJI 4K Android TV"
  },
  {
    "Retail Branding": "Kanji",
    "Marketing Name": "ARGENTINA",
    "Device": "sepolia",
    "Model": "KANJI 4K TV"
  },
  {
    "Retail Branding": "Kanji",
    "Marketing Name": "KANJI_AC05",
    "Device": "KANJI-AC05",
    "Model": "KJ-AC05"
  },
  {
    "Retail Branding": "Kanji",
    "Marketing Name": "KJ-AC02",
    "Device": "KJ-AC02",
    "Model": "KJ-AC02"
  },
  {
    "Retail Branding": "Kanji",
    "Marketing Name": "KJ-AC05",
    "Device": "KJ_AC05",
    "Model": "KJ-AC05"
  },
  {
    "Retail Branding": "Kanji",
    "Marketing Name": "KJ-AC05",
    "Device": "KJ_AC051",
    "Model": "KJ-AC05"
  },
  {
    "Retail Branding": "Kanji",
    "Marketing Name": "KJ-ARIZONA",
    "Device": "KJ_ARIZONA",
    "Model": "KJ-ARIZONA"
  },
  {
    "Retail Branding": "Kanji",
    "Marketing Name": "KJ-OB02",
    "Device": "KJ-OB02",
    "Model": "KJ-OB02"
  },
  {
    "Retail Branding": "Kanji",
    "Marketing Name": "KJ-YUBI",
    "Device": "KJ-YUBI",
    "Model": "KJ-YUBI"
  },
  {
    "Retail Branding": "Kanji",
    "Marketing Name": "KJ_AC05",
    "Device": "KJAC05",
    "Model": "KJ_AC05"
  },
  {
    "Retail Branding": "Kanji",
    "Marketing Name": "KJ_ALFARK",
    "Device": "KJ_ALFARK",
    "Model": "KJ-ALFARK"
  },
  {
    "Retail Branding": "Kanji",
    "Marketing Name": "KJ_ALFARK",
    "Device": "KJ_ALFARK",
    "Model": "KJ_ALFARK"
  },
  {
    "Retail Branding": "Kanji",
    "Marketing Name": "KJ_ARIZONA1",
    "Device": "KJ_ARIZONA1",
    "Model": "KJ_ARIZONA1"
  },
  {
    "Retail Branding": "Kanji",
    "Marketing Name": "KJ_OB02",
    "Device": "KJ_OB02",
    "Model": "KJ_OB02"
  },
  {
    "Retail Branding": "Kanji",
    "Marketing Name": "KJ_OB03",
    "Device": "KJ_OB03",
    "Model": "KJ_OB03"
  },
  {
    "Retail Branding": "Kanji",
    "Marketing Name": "KJ_YUBI",
    "Device": "KJ_YUBI",
    "Model": "KJ_YUBI"
  },
  {
    "Retail Branding": "Kanji",
    "Marketing Name": "KJ_YU_BI",
    "Device": "KJ_YU_BI",
    "Model": "KJ_YU_BI"
  },
  {
    "Retail Branding": "KaonMedia",
    "Marketing Name": "KM_SH368AT",
    "Device": "KM_SH368AT",
    "Model": "KM_SH368AT"
  },
  {
    "Retail Branding": "KaonMedia",
    "Marketing Name": "KSTB4252",
    "Device": "KSTB4252",
    "Model": "KSTB4252"
  },
  {
    "Retail Branding": "KaonMedia",
    "Marketing Name": "KSTB6077",
    "Device": "KSTB6077",
    "Model": "KSTB6077"
  },
  {
    "Retail Branding": "Kapsys",
    "Marketing Name": "SmartVision2",
    "Device": "r889",
    "Model": "KAP11000"
  },
  {
    "Retail Branding": "Kapsys",
    "Marketing Name": "SmartVision3",
    "Device": "SmartVision3",
    "Model": "SmartVision3"
  },
  {
    "Retail Branding": "Kapsys",
    "Marketing Name": "SmartVision3",
    "Device": "SmartVision3us",
    "Model": "SmartVision3"
  },
  {
    "Retail Branding": "Karbonn",
    "Marketing Name": "A1 Indian",
    "Device": "A1_Indian",
    "Model": "A1 Indian"
  },
  {
    "Retail Branding": "Karbonn",
    "Marketing Name": "A40 Indian",
    "Device": "A40_Indian",
    "Model": "A40 Indian"
  },
  {
    "Retail Branding": "Karbonn",
    "Marketing Name": "A40 Indian Plus",
    "Device": "A40_Indian_Plus",
    "Model": "A40 Indian Plus"
  },
  {
    "Retail Branding": "Karbonn",
    "Marketing Name": "A41 Power",
    "Device": "A41_Power",
    "Model": "A41 Power"
  },
  {
    "Retail Branding": "Karbonn",
    "Marketing Name": "A45 Indian",
    "Device": "A45_Indian",
    "Model": "A45 Indian"
  },
  {
    "Retail Branding": "Karbonn",
    "Marketing Name": "A545",
    "Device": "A545",
    "Model": "KARBONN A545"
  },
  {
    "Retail Branding": "Karbonn",
    "Marketing Name": "A9_Indian",
    "Device": "A9_Indian",
    "Model": "A9 Indian"
  },
  {
    "Retail Branding": "Karbonn",
    "Marketing Name": "Aura  4G",
    "Device": "Aura_4G",
    "Model": "Aura 4G"
  },
  {
    "Retail Branding": "Karbonn",
    "Marketing Name": "Aura Champ",
    "Device": "Aura_Champ",
    "Model": "Aura Champ"
  },
  {
    "Retail Branding": "Karbonn",
    "Marketing Name": "Aura Note 2",
    "Device": "Aura_Note_2",
    "Model": "Aura Note 2"
  },
  {
    "Retail Branding": "Karbonn",
    "Marketing Name": "Aura Note 4G",
    "Device": "AuraNote4G",
    "Model": "Aura Note 4G"
  },
  {
    "Retail Branding": "Karbonn",
    "Marketing Name": "Aura Note Play",
    "Device": "Aura_Note_Play",
    "Model": "Aura Note Play"
  },
  {
    "Retail Branding": "Karbonn",
    "Marketing Name": "Aura Power",
    "Device": "Aura_Power",
    "Model": "Aura_Power"
  },
  {
    "Retail Branding": "Karbonn",
    "Marketing Name": "Aura Power 4G",
    "Device": "AuraPower4G",
    "Model": "Aura Power 4G"
  },
  {
    "Retail Branding": "Karbonn",
    "Marketing Name": "Aura Power 4G",
    "Device": "Aura_Power_4G_Plus",
    "Model": "Aura Power 4G Plus"
  },
  {
    "Retail Branding": "Karbonn",
    "Marketing Name": "Aura Power 4G Plus",
    "Device": "Aura_Power_4G_Plus",
    "Model": "Aura Power 4G Plus"
  },
  {
    "Retail Branding": "Karbonn",
    "Marketing Name": "Aura Seek Plus",
    "Device": "Aura_Sleek_Plus",
    "Model": "Aura Sleek Plus"
  },
  {
    "Retail Branding": "Karbonn",
    "Marketing Name": "Aura Sleek 4G",
    "Device": "AuraSleek4G",
    "Model": "Aura Sleek 4G"
  },
  {
    "Retail Branding": "Karbonn",
    "Marketing Name": "Aura Storm",
    "Device": "Aura_Storm",
    "Model": "Aura Storm"
  },
  {
    "Retail Branding": "Karbonn",
    "Marketing Name": "Indian9",
    "Device": "Indian9",
    "Model": "Indian9"
  },
  {
    "Retail Branding": "Karbonn",
    "Marketing Name": "K9 Kavach 4G",
    "Device": "K9_Kavach",
    "Model": "K9 Kavach 4G"
  },
  {
    "Retail Branding": "Karbonn",
    "Marketing Name": "K9 Smart 4G",
    "Device": "K9Smart4G",
    "Model": "K9 Smart 4G"
  },
  {
    "Retail Branding": "Karbonn",
    "Marketing Name": "K9 Smart Eco",
    "Device": "K9_Smart_Eco",
    "Model": "K9 Smart Eco"
  },
  {
    "Retail Branding": "Karbonn",
    "Marketing Name": "K9 Smart Eco Plus",
    "Device": "K9_Smart_Eco_Plus",
    "Model": "K9 Smart Eco Plus"
  },
  {
    "Retail Branding": "Karbonn",
    "Marketing Name": "K9 Smart Grand",
    "Device": "K9_Smart_Grand",
    "Model": "K9 Smart Grand"
  },
  {
    "Retail Branding": "Karbonn",
    "Marketing Name": "K9 Smart Selfie",
    "Device": "K9_Smart_Selfie",
    "Model": "K9 Smart Selfie"
  },
  {
    "Retail Branding": "Karbonn",
    "Marketing Name": "K9 Smart Yuva",
    "Device": "K9_Smart_Yuva",
    "Model": "K9 Smart Yuva"
  },
  {
    "Retail Branding": "Karbonn",
    "Marketing Name": "K9 Viraat 4G",
    "Device": "K9_VIRAAT_4G",
    "Model": "K9 VIRAAT 4G"
  },
  {
    "Retail Branding": "Karbonn",
    "Marketing Name": "K9_Smart_Plus",
    "Device": "K9_Smart_Plus",
    "Model": "K9_Smart_Plus"
  },
  {
    "Retail Branding": "Karbonn",
    "Marketing Name": "K9_Viraat_Plus",
    "Device": "K9_Viraat_Plus",
    "Model": "K9_Viraat_Plus"
  },
  {
    "Retail Branding": "Karbonn",
    "Marketing Name": "Karbonn K9 Music 4G",
    "Device": "K9Music4G",
    "Model": "K9 Music 4G"
  },
  {
    "Retail Branding": "Karbonn",
    "Marketing Name": "Karbonn Smart TV",
    "Device": "stanford",
    "Model": "40D"
  },
  {
    "Retail Branding": "Karbonn",
    "Marketing Name": "Karbonn X21",
    "Device": "X21",
    "Model": "Karbonn X21"
  },
  {
    "Retail Branding": "Karbonn",
    "Marketing Name": "Karbonn Yuva2",
    "Device": "Karbonn_Yuva_2",
    "Model": "Karbonn Yuva 2"
  },
  {
    "Retail Branding": "Karbonn",
    "Marketing Name": "Platinum P9",
    "Device": "Platinum_P9",
    "Model": "Platinum P9"
  },
  {
    "Retail Branding": "Karbonn",
    "Marketing Name": "Platinum P9 Pro",
    "Device": "Platinum_P9_Pro",
    "Model": "Platinum P9 Pro"
  },
  {
    "Retail Branding": "Karbonn",
    "Marketing Name": "ST101",
    "Device": "ST101",
    "Model": "ST101"
  },
  {
    "Retail Branding": "Karbonn",
    "Marketing Name": "ST102",
    "Device": "ST102",
    "Model": "ST102"
  },
  {
    "Retail Branding": "Karbonn",
    "Marketing Name": "Sparkle V",
    "Device": "Sparkle_V_sprout",
    "Model": "Sparkle V"
  },
  {
    "Retail Branding": "Karbonn",
    "Marketing Name": "Titanium Frames S7",
    "Device": "Titanium_Frames_S7",
    "Model": "Titanium Frames S7"
  },
  {
    "Retail Branding": "Karbonn",
    "Marketing Name": "Titanium Jumbo",
    "Device": "Titanium_Jumbo",
    "Model": "Titanium Jumbo"
  },
  {
    "Retail Branding": "Karbonn",
    "Marketing Name": "Titanium Jumbo 2",
    "Device": "Titanium_Jumbo_2",
    "Model": "Titanium Jumbo 2"
  },
  {
    "Retail Branding": "Karbonn",
    "Marketing Name": "Titanium S501",
    "Device": "Titanium_S501",
    "Model": "Titanium S501"
  },
  {
    "Retail Branding": "Karbonn",
    "Marketing Name": "Titanium S601",
    "Device": "Titanium_S601",
    "Model": "Titanium S601"
  },
  {
    "Retail Branding": "Karbonn",
    "Marketing Name": "Titanium S9 Plus",
    "Device": "Titanium_S9_Plus",
    "Model": "Titanium_S9_Plus"
  },
  {
    "Retail Branding": "Karbonn",
    "Marketing Name": "Titanium Vista 4G",
    "Device": "TitaniumVista4G",
    "Model": "Titanium Vista 4G"
  },
  {
    "Retail Branding": "Karbonn",
    "Marketing Name": "TitaniumS9_Plus",
    "Device": "TitaniumS9_Plus",
    "Model": "TitaniumS9_Plus"
  },
  {
    "Retail Branding": "Karbonn",
    "Marketing Name": "Titanium_S9Plus",
    "Device": "Titanium_S9Plus",
    "Model": "Titanium_S9Plus"
  },
  {
    "Retail Branding": "Karbonn",
    "Marketing Name": "Titanium_S9_Plus",
    "Device": "Karbonn_Titanium_S9_Plus",
    "Model": "Titanium_S9_Plus"
  },
  {
    "Retail Branding": "Karbonn",
    "Marketing Name": "X23",
    "Device": "X23",
    "Model": "X23"
  },
  {
    "Retail Branding": "Karma",
    "Marketing Name": "KG555 Pro",
    "Device": "KG555_Pro",
    "Model": "KG555 Pro"
  },
  {
    "Retail Branding": "Karma",
    "Marketing Name": "KG777 Pro",
    "Device": "KG777Pro",
    "Model": "KG777 Pro"
  },
  {
    "Retail Branding": "Karvy",
    "Marketing Name": "KA7Q3",
    "Device": "KA7Q3",
    "Model": "KA7Q3"
  },
  {
    "Retail Branding": "KateMedia",
    "Marketing Name": "KT-2-EEA",
    "Device": "KT-2-EEA",
    "Model": "KT-2-EEA"
  },
  {
    "Retail Branding": "KateMedia",
    "Marketing Name": "KT-2-other",
    "Device": "KT-2-other",
    "Model": "KT-2-other"
  },
  {
    "Retail Branding": "Kbro",
    "Marketing Name": "A0BRTD1325",
    "Device": "A0B_RTD1325",
    "Model": "A0BRTD1325"
  },
  {
    "Retail Branding": "Kbro",
    "Marketing Name": "A0_S905X2",
    "Device": "sti6160d19",
    "Model": "A0_S905X2"
  },
  {
    "Retail Branding": "Kbro",
    "Marketing Name": "A25751P",
    "Device": "A2_5751P",
    "Model": "A25751P"
  },
  {
    "Retail Branding": "Kbro",
    "Marketing Name": "A2S905X4",
    "Device": "A2_S905X4",
    "Model": "A2S905X4"
  },
  {
    "Retail Branding": "Kbro",
    "Marketing Name": "N97_A1B_72115",
    "Device": "A1B_72115",
    "Model": "N97_A1B_72115"
  },
  {
    "Retail Branding": "Kbro",
    "Marketing Name": "N97_A1_3796",
    "Device": "A1_3796",
    "Model": "N97_A1_3796"
  },
  {
    "Retail Branding": "Kbro",
    "Marketing Name": "Taiwan",
    "Device": "A2_X4_N",
    "Model": "A2X4N"
  },
  {
    "Retail Branding": "Keian",
    "Marketing Name": "KI-R10",
    "Device": "KI-R10",
    "Model": "KI-R10"
  },
  {
    "Retail Branding": "Keian",
    "Marketing Name": "KI-R10S",
    "Device": "KI-R10S",
    "Model": "KI-R10S"
  },
  {
    "Retail Branding": "Keian",
    "Marketing Name": "KI-R7",
    "Device": "KI-R7",
    "Model": "KI-R7"
  },
  {
    "Retail Branding": "Keian",
    "Marketing Name": "KI-Z101E",
    "Device": "KI-Z101E",
    "Model": "KI-Z101E"
  },
  {
    "Retail Branding": "Kelyx",
    "Marketing Name": "AKS01_KL783",
    "Device": "AKS01_KL783",
    "Model": "AKS01_KL783"
  },
  {
    "Retail Branding": "Kempler Strauss",
    "Marketing Name": "Alumini 3 Plus",
    "Device": "Alumini_3_Plus",
    "Model": "Alumini_3_Plus"
  },
  {
    "Retail Branding": "Kempler Strauss",
    "Marketing Name": "KEMPLER 8",
    "Device": "KEMPLER_8",
    "Model": "KEMPLER_8"
  },
  {
    "Retail Branding": "Kempler Strauss",
    "Marketing Name": "KEMPLER_X",
    "Device": "KEMPLER_X",
    "Model": "KEMPLER_X"
  },
  {
    "Retail Branding": "Kenbo",
    "Marketing Name": "B19",
    "Device": "B19",
    "Model": "B19"
  },
  {
    "Retail Branding": "Kenbo",
    "Marketing Name": "E111",
    "Device": "E111",
    "Model": "E111"
  },
  {
    "Retail Branding": "Kenbo",
    "Marketing Name": "E121",
    "Device": "E121",
    "Model": "E121"
  },
  {
    "Retail Branding": "Kenbo",
    "Marketing Name": "E61Pro",
    "Device": "E61Pro",
    "Model": "E61Pro"
  },
  {
    "Retail Branding": "Kenbo",
    "Marketing Name": "K6",
    "Device": "K6",
    "Model": "K6"
  },
  {
    "Retail Branding": "Kenbo",
    "Marketing Name": "K7",
    "Device": "K7",
    "Model": "K7"
  },
  {
    "Retail Branding": "Kenbo",
    "Marketing Name": "K9",
    "Device": "K9",
    "Model": "K9"
  },
  {
    "Retail Branding": "Kenbo",
    "Marketing Name": "K9Pro",
    "Device": "K9Pro",
    "Model": "K9Pro"
  },
  {
    "Retail Branding": "Kenbo",
    "Marketing Name": "O51",
    "Device": "O51",
    "Model": "O51"
  },
  {
    "Retail Branding": "Kenbo",
    "Marketing Name": "O61",
    "Device": "O61",
    "Model": "O61"
  },
  {
    "Retail Branding": "Kenbo",
    "Marketing Name": "O71",
    "Device": "O71",
    "Model": "O71"
  },
  {
    "Retail Branding": "Kennex",
    "Marketing Name": "MD7053G",
    "Device": "MD7053G",
    "Model": "MD7053G"
  },
  {
    "Retail Branding": "Kenstar",
    "Marketing Name": "KENSTAR",
    "Device": "stanford",
    "Model": "2K SMART TV"
  },
  {
    "Retail Branding": "Kenwood",
    "Marketing Name": "KENWOOD",
    "Device": "mountbaker",
    "Model": "KENWOOD 2K TV"
  },
  {
    "Retail Branding": "Kenwood",
    "Marketing Name": "KWSA80K",
    "Device": "XP8800",
    "Model": "KWSA80K"
  },
  {
    "Retail Branding": "Kenwood",
    "Marketing Name": "Kenwood",
    "Device": "elliniko",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "Kenwood",
    "Marketing Name": "Kenwood",
    "Device": "hongkong",
    "Model": "KENWOOD ATSC 4K TV"
  },
  {
    "Retail Branding": "Kenwood",
    "Marketing Name": "Kenwood",
    "Device": "hongkong",
    "Model": "KENWOOD DVB 4K TV"
  },
  {
    "Retail Branding": "Kenwood",
    "Marketing Name": "Kenwood",
    "Device": "hongkong",
    "Model": "KENWOOD ISDB 4K TV"
  },
  {
    "Retail Branding": "Kenwood",
    "Marketing Name": "Kenwood",
    "Device": "lavender",
    "Model": "KENWOOD DVB 4K TV"
  },
  {
    "Retail Branding": "Kenwood",
    "Marketing Name": "Kenwood",
    "Device": "lavender",
    "Model": "KENWOOD ISDB 4K TV"
  },
  {
    "Retail Branding": "Kenwood",
    "Marketing Name": "Kenwood",
    "Device": "mountbaker",
    "Model": "KENWOOD ATSC 2K TV"
  },
  {
    "Retail Branding": "Kenwood",
    "Marketing Name": "Kenwood",
    "Device": "mountbaker",
    "Model": "KENWOOD DVB 2K TV"
  },
  {
    "Retail Branding": "Kenwood",
    "Marketing Name": "Kenwood",
    "Device": "mountbaker",
    "Model": "KENWOOD ISDB 2K TV"
  },
  {
    "Retail Branding": "Kenxinda",
    "Marketing Name": "6Cb",
    "Device": "6Cb",
    "Model": "6Cb"
  },
  {
    "Retail Branding": "Kenxinda",
    "Marketing Name": "9_Pro",
    "Device": "9_Pro",
    "Model": "9 Pro"
  },
  {
    "Retail Branding": "Kenxinda",
    "Marketing Name": "A1",
    "Device": "A1",
    "Model": "A1"
  },
  {
    "Retail Branding": "Kenxinda",
    "Marketing Name": "A1s",
    "Device": "A1s",
    "Model": "A1s"
  },
  {
    "Retail Branding": "Kenxinda",
    "Marketing Name": "A8",
    "Device": "A8",
    "Model": "A8M"
  },
  {
    "Retail Branding": "Kenxinda",
    "Marketing Name": "A9",
    "Device": "A9",
    "Model": "A9"
  },
  {
    "Retail Branding": "Kenxinda",
    "Marketing Name": "D26",
    "Device": "D26",
    "Model": "D26"
  },
  {
    "Retail Branding": "Kenxinda",
    "Marketing Name": "D58",
    "Device": "D58",
    "Model": "D58"
  },
  {
    "Retail Branding": "Kenxinda",
    "Marketing Name": "D70",
    "Device": "D70",
    "Model": "D70"
  },
  {
    "Retail Branding": "Kenxinda",
    "Marketing Name": "K10",
    "Device": "K10",
    "Model": "K10"
  },
  {
    "Retail Branding": "Kenxinda",
    "Marketing Name": "K20M",
    "Device": "K20M",
    "Model": "K20M"
  },
  {
    "Retail Branding": "Kenxinda",
    "Marketing Name": "K30M",
    "Device": "K30M",
    "Model": "K30M"
  },
  {
    "Retail Branding": "Kenxinda",
    "Marketing Name": "Nitro_55R",
    "Device": "Nitro_55R",
    "Model": "Nitro_55R"
  },
  {
    "Retail Branding": "Kenxinda",
    "Marketing Name": "T50",
    "Device": "T50",
    "Model": "T50"
  },
  {
    "Retail Branding": "Kenxinda",
    "Marketing Name": "T50Y",
    "Device": "T50Y",
    "Model": "T50Y"
  },
  {
    "Retail Branding": "Kenxinda",
    "Marketing Name": "T55",
    "Device": "T55",
    "Model": "T55"
  },
  {
    "Retail Branding": "Kenxinda",
    "Marketing Name": "T55S",
    "Device": "T55S",
    "Model": "T55S"
  },
  {
    "Retail Branding": "Kenxinda",
    "Marketing Name": "W40S",
    "Device": "W40S",
    "Model": "W40S"
  },
  {
    "Retail Branding": "Kenxinda",
    "Marketing Name": "W41",
    "Device": "W41",
    "Model": "W41"
  },
  {
    "Retail Branding": "Kenxinda",
    "Marketing Name": "W45S",
    "Device": "W45S",
    "Model": "W45S"
  },
  {
    "Retail Branding": "Kenxinda",
    "Marketing Name": "W50M",
    "Device": "W50M",
    "Model": "W50M"
  },
  {
    "Retail Branding": "Kenxinda",
    "Marketing Name": "W50Y",
    "Device": "W50Y",
    "Model": "W50Y"
  },
  {
    "Retail Branding": "Kenxinda",
    "Marketing Name": "W55M",
    "Device": "W55M",
    "Model": "W55M"
  },
  {
    "Retail Branding": "Kenxinda",
    "Marketing Name": "W55Y",
    "Device": "W55Y",
    "Model": "W55Y"
  },
  {
    "Retail Branding": "Kenxinda",
    "Marketing Name": "X10",
    "Device": "X10",
    "Model": "X10"
  },
  {
    "Retail Branding": "Kenxinda",
    "Marketing Name": "X10g",
    "Device": "X10g",
    "Model": "X10g"
  },
  {
    "Retail Branding": "Kenxinda",
    "Marketing Name": "X7",
    "Device": "X7",
    "Model": "X7"
  },
  {
    "Retail Branding": "Kenxinda",
    "Marketing Name": "X7g",
    "Device": "X7g",
    "Model": "X7g"
  },
  {
    "Retail Branding": "Kenxinda",
    "Marketing Name": "X7s",
    "Device": "X7s",
    "Model": "X7s"
  },
  {
    "Retail Branding": "Kenxinda",
    "Marketing Name": "X8",
    "Device": "X8",
    "Model": "X8"
  },
  {
    "Retail Branding": "Kenxinda",
    "Marketing Name": "X85",
    "Device": "X85",
    "Model": "X85"
  },
  {
    "Retail Branding": "Kenxinda",
    "Marketing Name": "X8a",
    "Device": "X8a",
    "Model": "X8a"
  },
  {
    "Retail Branding": "Kenxinda",
    "Marketing Name": "X8g",
    "Device": "X8g",
    "Model": "X8g"
  },
  {
    "Retail Branding": "Kenxinda",
    "Marketing Name": "Y10",
    "Device": "Y10",
    "Model": "Y10"
  },
  {
    "Retail Branding": "Kenxinda",
    "Marketing Name": "Y20",
    "Device": "Y20",
    "Model": "Y20"
  },
  {
    "Retail Branding": "Kenxinda",
    "Marketing Name": "Y30",
    "Device": "Y30",
    "Model": "Y30"
  },
  {
    "Retail Branding": "Ketablet",
    "Marketing Name": "Ketablet",
    "Device": "TR10CS1_6",
    "Model": "TR10CS1"
  },
  {
    "Retail Branding": "Keyphone",
    "Marketing Name": "KP523",
    "Device": "KP523",
    "Model": "KP523"
  },
  {
    "Retail Branding": "Kiano",
    "Marketing Name": "ELEGANCE 6",
    "Device": "ELEGANCE_6",
    "Model": "ELEGANCE 6"
  },
  {
    "Retail Branding": "Kiano",
    "Marketing Name": "Elegance 4.0 black",
    "Device": "Elegance_4_0_black",
    "Model": "Elegance_4_0_black"
  },
  {
    "Retail Branding": "Kiano",
    "Marketing Name": "Elegance 5.1",
    "Device": "Elegance_5_1",
    "Model": "Elegance_5_1"
  },
  {
    "Retail Branding": "Kiano",
    "Marketing Name": "Elegance 5.1 Pro",
    "Device": "ELEGANCE_5_1_PRO",
    "Model": "ELEGANCE_5_1_PRO"
  },
  {
    "Retail Branding": "Kiano",
    "Marketing Name": "Elegance 5.5",
    "Device": "Elegance_5_5",
    "Model": "Elegance_5_5"
  },
  {
    "Retail Branding": "Kiano",
    "Marketing Name": "Elegance 5.5 Pro",
    "Device": "Elegance_5_5_Pro",
    "Model": "Elegance_5_5_Pro"
  },
  {
    "Retail Branding": "Kiano",
    "Marketing Name": "Elegance61P_EEA",
    "Device": "Elegance61P_EEA",
    "Model": "Elegance61P_EEA"
  },
  {
    "Retail Branding": "Kiano",
    "Marketing Name": "Slim_Tab_8",
    "Device": "Slim_Tab_8",
    "Model": "Slim_Tab_8"
  },
  {
    "Retail Branding": "Kids_and_Us",
    "Marketing Name": "KIDSPAD",
    "Device": "Kids_and_Us",
    "Model": "KIDSPAD"
  },
  {
    "Retail Branding": "Kids_and_Us",
    "Marketing Name": "KIDSPAD_V2",
    "Device": "KIDSPAD_V2",
    "Model": "KIDSPAD_V2"
  },
  {
    "Retail Branding": "Kimfly",
    "Marketing Name": "E1",
    "Device": "E1",
    "Model": "E1"
  },
  {
    "Retail Branding": "Kimfly",
    "Marketing Name": "KIMFLY ES",
    "Device": "ES",
    "Model": "ES"
  },
  {
    "Retail Branding": "Kimfly",
    "Marketing Name": "Kimfly MC",
    "Device": "MC",
    "Model": "MC"
  },
  {
    "Retail Branding": "Kimfly",
    "Marketing Name": "MX",
    "Device": "MX",
    "Model": "MX"
  },
  {
    "Retail Branding": "Kimlok",
    "Marketing Name": "D103_EEA",
    "Device": "D103_EEA",
    "Model": "D103_EEA"
  },
  {
    "Retail Branding": "Kimlok",
    "Marketing Name": "K712_EEA",
    "Device": "K712_EEA",
    "Model": "K712_EEA"
  },
  {
    "Retail Branding": "Kindermann",
    "Marketing Name": "KindermannTD-12xx",
    "Device": "Kindermann_TD-12xx",
    "Model": "Kindermann_TD-12xx"
  },
  {
    "Retail Branding": "Kinetic",
    "Marketing Name": "RSTV-A4K-16",
    "Device": "DV8219",
    "Model": "RSTV-A4K-16"
  },
  {
    "Retail Branding": "Kingcomm",
    "Marketing Name": "C500",
    "Device": "C500",
    "Model": "Kingcomm C500"
  },
  {
    "Retail Branding": "Kingcomm",
    "Marketing Name": "E550",
    "Device": "E550",
    "Model": "Kingcomm E550"
  },
  {
    "Retail Branding": "Kinstone",
    "Marketing Name": "CON_102",
    "Device": "CON_102",
    "Model": "CON_102"
  },
  {
    "Retail Branding": "Kinstone",
    "Marketing Name": "KST070CH_D",
    "Device": "KST070CH_D",
    "Model": "KST070CH_D"
  },
  {
    "Retail Branding": "Kinstone",
    "Marketing Name": "KST102SA-EEA",
    "Device": "KST102SA-EEA",
    "Model": "KST102SA-EEA"
  },
  {
    "Retail Branding": "Kinstone",
    "Marketing Name": "KST102SF",
    "Device": "KST102SF",
    "Model": "KST102SF"
  },
  {
    "Retail Branding": "Kinstone",
    "Marketing Name": "KST102SF_EA",
    "Device": "KST102SF_EA",
    "Model": "KST102SF_EA"
  },
  {
    "Retail Branding": "Kinstone",
    "Marketing Name": "KST103RC",
    "Device": "KST103RC",
    "Model": "KST103RC"
  },
  {
    "Retail Branding": "Kinstone",
    "Marketing Name": "KST103SD",
    "Device": "KST103SD",
    "Model": "KST103SD"
  },
  {
    "Retail Branding": "Kinstone",
    "Marketing Name": "KST103SD-L",
    "Device": "KST103SD-L",
    "Model": "KST103SD-L"
  },
  {
    "Retail Branding": "Kinstone",
    "Marketing Name": "KST103SD_J",
    "Device": "KST103SD_J",
    "Model": "KST103SD_J"
  },
  {
    "Retail Branding": "Kinstone",
    "Marketing Name": "SA070",
    "Device": "Kinstone_SA070",
    "Model": "KJ-YUBI"
  },
  {
    "Retail Branding": "Kinstone",
    "Marketing Name": "SA070",
    "Device": "Kinstone_SA070",
    "Model": "SA070"
  },
  {
    "Retail Branding": "Kioto",
    "Marketing Name": "CHILE",
    "Device": "patrick",
    "Model": "KIOTO 4K Android TV"
  },
  {
    "Retail Branding": "Kioto",
    "Marketing Name": "Chile",
    "Device": "martin",
    "Model": "KIOTO 2K Android TV"
  },
  {
    "Retail Branding": "Kioto",
    "Marketing Name": "MID1021",
    "Device": "MID1021",
    "Model": "MID1021"
  },
  {
    "Retail Branding": "Kioto",
    "Marketing Name": "MID1028",
    "Device": "MID1028",
    "Model": "MID1028"
  },
  {
    "Retail Branding": "Kioto",
    "Marketing Name": "MID1036",
    "Device": "MID1036",
    "Model": "MID1036"
  },
  {
    "Retail Branding": "Kiowa",
    "Marketing Name": "A5_CRISTAL",
    "Device": "A5_CRISTAL",
    "Model": "A5_CRISTAL"
  },
  {
    "Retail Branding": "Kiowa",
    "Marketing Name": "KIOWA",
    "Device": "hongkong",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "Kiowa",
    "Marketing Name": "KIOWA",
    "Device": "lavender",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "Kiowa",
    "Marketing Name": "KIOWA",
    "Device": "mountbaker",
    "Model": "2K SMART TV"
  },
  {
    "Retail Branding": "Kiowa",
    "Marketing Name": "KIOWA",
    "Device": "stanford",
    "Model": "2K SMART TV"
  },
  {
    "Retail Branding": "Kiowa",
    "Marketing Name": "KIOWA",
    "Device": "zhongshan",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "Kiowa",
    "Marketing Name": "S5_CRISTAL",
    "Device": "S5_CRISTAL",
    "Model": "S5_CRISTAL"
  },
  {
    "Retail Branding": "Kiowa",
    "Marketing Name": "X4 Plus",
    "Device": "X4_Plus",
    "Model": "X4_Plus"
  },
  {
    "Retail Branding": "Kiowa",
    "Marketing Name": "X4_CRISTAL",
    "Device": "X4_CRISTAL",
    "Model": "X4_CRISTAL"
  },
  {
    "Retail Branding": "Kiowa",
    "Marketing Name": "X4_LTE",
    "Device": "X4_LTE",
    "Model": "X4_LTE"
  },
  {
    "Retail Branding": "Kivi",
    "Marketing Name": "KIVI",
    "Device": "bangbae",
    "Model": "KIVI 4K Android TV"
  },
  {
    "Retail Branding": "Kivi",
    "Marketing Name": "KIVI",
    "Device": "bruno",
    "Model": "KIVI 2K Android TV"
  },
  {
    "Retail Branding": "Kivi",
    "Marketing Name": "KIVI",
    "Device": "elliniko",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "Kivi",
    "Marketing Name": "KIVI",
    "Device": "komagome",
    "Model": "KIVI 2K Android TV"
  },
  {
    "Retail Branding": "Kivi",
    "Marketing Name": "KIVI",
    "Device": "stanford",
    "Model": "2K T56 Smart TV"
  },
  {
    "Retail Branding": "Kivi",
    "Marketing Name": "KIVI",
    "Device": "zhongshan",
    "Model": "4K T31 Smart TV"
  },
  {
    "Retail Branding": "Kivi",
    "Marketing Name": "Smart TV",
    "Device": "osaka",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "Kivi",
    "Marketing Name": "Smart TV",
    "Device": "osaka",
    "Model": "KIVI"
  },
  {
    "Retail Branding": "Klipad",
    "Marketing Name": "7588AN",
    "Device": "tulip-d9003",
    "Model": "7588AN"
  },
  {
    "Retail Branding": "Klipad",
    "Marketing Name": "7588AN",
    "Device": "tulip-d9003",
    "Model": "KL3838"
  },
  {
    "Retail Branding": "Klipad",
    "Marketing Name": "KL1018",
    "Device": "KL1018",
    "Model": "KL1018"
  },
  {
    "Retail Branding": "Klipad",
    "Marketing Name": "KL1018E",
    "Device": "KL1018E_EEA",
    "Model": "KL1018E_EEA"
  },
  {
    "Retail Branding": "Klipad",
    "Marketing Name": "KL1018N_EEA",
    "Device": "KL1018N_EEA",
    "Model": "KL1018N"
  },
  {
    "Retail Branding": "Klipad",
    "Marketing Name": "KL1019_EEA",
    "Device": "KL1019_EEA",
    "Model": "KL1019"
  },
  {
    "Retail Branding": "Klipad",
    "Marketing Name": "KL1088",
    "Device": "KL1088",
    "Model": "KL1088"
  },
  {
    "Retail Branding": "Klipad",
    "Marketing Name": "KL2018R",
    "Device": "KL2018R",
    "Model": "KL2018R"
  },
  {
    "Retail Branding": "Klipad",
    "Marketing Name": "KL2108NBE",
    "Device": "KL2108NBE",
    "Model": "KL2108NBE"
  },
  {
    "Retail Branding": "Klipad",
    "Marketing Name": "KL2109NB_EEA",
    "Device": "KL2109NB_EEA",
    "Model": "KL2109NB_EEA"
  },
  {
    "Retail Branding": "Klipad",
    "Marketing Name": "KL300",
    "Device": "KL300",
    "Model": "KL300"
  },
  {
    "Retail Branding": "Klipad",
    "Marketing Name": "KL3669A",
    "Device": "KL3669A",
    "Model": "KL3669A"
  },
  {
    "Retail Branding": "Klipad",
    "Marketing Name": "KL3669E_EEA",
    "Device": "KL3669E_EEA",
    "Model": "KL3669E_EEA"
  },
  {
    "Retail Branding": "Klipad",
    "Marketing Name": "KL3669_EEA",
    "Device": "KL3669_EEA",
    "Model": "KL3669_EEA"
  },
  {
    "Retail Branding": "Klipad",
    "Marketing Name": "KL3678E_EEA",
    "Device": "KL3678E_EEA",
    "Model": "KL3678E_EEA"
  },
  {
    "Retail Branding": "Klipad",
    "Marketing Name": "KL3889",
    "Device": "KL3889",
    "Model": "KL3889"
  },
  {
    "Retail Branding": "Klipad",
    "Marketing Name": "KL450",
    "Device": "KL450",
    "Model": "KL450"
  },
  {
    "Retail Branding": "Klipad",
    "Marketing Name": "KL456LD",
    "Device": "KL456LD",
    "Model": "KL456LD"
  },
  {
    "Retail Branding": "Klipad",
    "Marketing Name": "KL4889B_EEA",
    "Device": "KL4889B",
    "Model": "KL4889B"
  },
  {
    "Retail Branding": "Klipad",
    "Marketing Name": "KL4889C",
    "Device": "KL4889C",
    "Model": "KL4889C"
  },
  {
    "Retail Branding": "Klipad",
    "Marketing Name": "KL4890",
    "Device": "KL4890",
    "Model": "KL4890"
  },
  {
    "Retail Branding": "Klipad",
    "Marketing Name": "KL4891",
    "Device": "KL4891",
    "Model": "KL4891"
  },
  {
    "Retail Branding": "Klipad",
    "Marketing Name": "KL4891_A50_EEA",
    "Device": "KL4891-A50",
    "Model": "KL4891_A50"
  },
  {
    "Retail Branding": "Klipad",
    "Marketing Name": "KL4898",
    "Device": "KL4898",
    "Model": "KL4898"
  },
  {
    "Retail Branding": "Klipad",
    "Marketing Name": "KL4898_A50",
    "Device": "KL4898_A50",
    "Model": "KL4898_A50"
  },
  {
    "Retail Branding": "Klipad",
    "Marketing Name": "KL4899",
    "Device": "KL4899",
    "Model": "KL4899"
  },
  {
    "Retail Branding": "Klipad",
    "Marketing Name": "KL4899A",
    "Device": "KL4899A",
    "Model": "KL4899A"
  },
  {
    "Retail Branding": "Klipad",
    "Marketing Name": "KL4899B",
    "Device": "KL4899B",
    "Model": "KL4899B"
  },
  {
    "Retail Branding": "Klipad",
    "Marketing Name": "KL500",
    "Device": "KL500",
    "Model": "KL500"
  },
  {
    "Retail Branding": "Klipad",
    "Marketing Name": "KL502",
    "Device": "KL502",
    "Model": "KL502"
  },
  {
    "Retail Branding": "Klipad",
    "Marketing Name": "KL503",
    "Device": "KL503",
    "Model": "KL503"
  },
  {
    "Retail Branding": "Klipad",
    "Marketing Name": "KL505",
    "Device": "KL505",
    "Model": "KL505"
  },
  {
    "Retail Branding": "Klipad",
    "Marketing Name": "KL551",
    "Device": "KL551",
    "Model": "KL551"
  },
  {
    "Retail Branding": "Klipad",
    "Marketing Name": "KL553",
    "Device": "KL553",
    "Model": "KL553_EEA"
  },
  {
    "Retail Branding": "Klipad",
    "Marketing Name": "KL600",
    "Device": "KLIPAD_KL600",
    "Model": "KLIPAD_KL600"
  },
  {
    "Retail Branding": "Klipad",
    "Marketing Name": "KL600B",
    "Device": "KLIPAD_KL600B",
    "Model": "KL600B"
  },
  {
    "Retail Branding": "Klipad",
    "Marketing Name": "KL601",
    "Device": "KL601",
    "Model": "KL601"
  },
  {
    "Retail Branding": "Klipad",
    "Marketing Name": "KL602",
    "Device": "KL602",
    "Model": "KL602"
  },
  {
    "Retail Branding": "Klipad",
    "Marketing Name": "KL605_EEA",
    "Device": "KL605",
    "Model": "KL605"
  },
  {
    "Retail Branding": "Klipad",
    "Marketing Name": "KL606",
    "Device": "KL606",
    "Model": "KL606"
  },
  {
    "Retail Branding": "Klipad",
    "Marketing Name": "KL608",
    "Device": "KL608",
    "Model": "KL608"
  },
  {
    "Retail Branding": "Klipad",
    "Marketing Name": "KL628KO",
    "Device": "KL628KO",
    "Model": "KL628KO"
  },
  {
    "Retail Branding": "Klipad",
    "Marketing Name": "KL6889B",
    "Device": "KL6889B",
    "Model": "KL6889B"
  },
  {
    "Retail Branding": "Klipad",
    "Marketing Name": "KL7590",
    "Device": "KL7590",
    "Model": "KL7590"
  },
  {
    "Retail Branding": "Klipad",
    "Marketing Name": "KL7590_eea",
    "Device": "KL7590",
    "Model": "KL7590"
  },
  {
    "Retail Branding": "Klipad",
    "Marketing Name": "KL7591",
    "Device": "KL7591",
    "Model": "KL7591"
  },
  {
    "Retail Branding": "Klipad",
    "Marketing Name": "KL7599",
    "Device": "KL7599",
    "Model": "KL7599"
  },
  {
    "Retail Branding": "Klipad",
    "Marketing Name": "KL7809",
    "Device": "KL7809",
    "Model": "KL7809"
  },
  {
    "Retail Branding": "Klipad",
    "Marketing Name": "KL830_EEA",
    "Device": "KL830_EEA",
    "Model": "KL830"
  },
  {
    "Retail Branding": "Klipad",
    "Marketing Name": "KL8889",
    "Device": "KL8889",
    "Model": "KL8889"
  },
  {
    "Retail Branding": "Klipad",
    "Marketing Name": "KL9878",
    "Device": "KL9878",
    "Model": "KL9878"
  },
  {
    "Retail Branding": "Klipad",
    "Marketing Name": "KL9878AE",
    "Device": "KL9878AE",
    "Model": "KL9878AE"
  },
  {
    "Retail Branding": "Klipad",
    "Marketing Name": "KL9878A_EEA",
    "Device": "KL9878A_EEA",
    "Model": "KL9878A_EEA"
  },
  {
    "Retail Branding": "Klipad",
    "Marketing Name": "KL988HPC",
    "Device": "KL988HPC",
    "Model": "KL988HPC"
  },
  {
    "Retail Branding": "Klipad",
    "Marketing Name": "KLI747",
    "Device": "KLI747",
    "Model": "KLI747"
  },
  {
    "Retail Branding": "Klipad",
    "Marketing Name": "KLI750",
    "Device": "KLI750",
    "Model": "KL I750"
  },
  {
    "Retail Branding": "Klipad",
    "Marketing Name": "KLI750_EEA",
    "Device": "KLI750",
    "Model": "KL I750"
  },
  {
    "Retail Branding": "Klipad",
    "Marketing Name": "KLI758",
    "Device": "KLI758",
    "Model": "KLIPAD_SMART_KLI758"
  },
  {
    "Retail Branding": "Klipad",
    "Marketing Name": "KLIPAD",
    "Device": "KLIPAD",
    "Model": "KL628_HL"
  },
  {
    "Retail Branding": "Klipad",
    "Marketing Name": "KLIPAD_A1040M",
    "Device": "A1040M",
    "Model": "A1040M"
  },
  {
    "Retail Branding": "Klipad",
    "Marketing Name": "KLIPAD_KL4888",
    "Device": "KL4888",
    "Model": "KL4888"
  },
  {
    "Retail Branding": "Klipad",
    "Marketing Name": "KLIPAD_SMART_D71",
    "Device": "KLIPAD_SMART_D71",
    "Model": "KLIPAD_SMART_D71"
  },
  {
    "Retail Branding": "Klipad",
    "Marketing Name": "KLIPAD_SMART_I746",
    "Device": "KLIPAD_SMART_I746",
    "Model": "KLIPAD_SMART_I746"
  },
  {
    "Retail Branding": "Klipad",
    "Marketing Name": "KL_6888",
    "Device": "KL_6888",
    "Model": "KL_6888"
  },
  {
    "Retail Branding": "Klipad",
    "Marketing Name": "PRO_I746",
    "Device": "KLIPAD_PRO_I746",
    "Model": "KLIPAD_PRO_I746"
  },
  {
    "Retail Branding": "Klipad",
    "Marketing Name": "SMART_D791",
    "Device": "KLIPAD_SMART_D791",
    "Model": "KLIPAD_SMART_D791"
  },
  {
    "Retail Branding": "Klipad",
    "Marketing Name": "SMART_I745",
    "Device": "KLIPAD_SMART_I745",
    "Model": "KLIPAD_SMART_I745"
  },
  {
    "Retail Branding": "Klipad",
    "Marketing Name": "V350",
    "Device": "V350",
    "Model": "V350"
  },
  {
    "Retail Branding": "Klipad",
    "Marketing Name": "V355",
    "Device": "V355",
    "Model": "KLIPAD_V355"
  },
  {
    "Retail Branding": "Klipad",
    "Marketing Name": "V355B",
    "Device": "V355B",
    "Model": "KLIPAD_V355B"
  },
  {
    "Retail Branding": "Klipad",
    "Marketing Name": "V356",
    "Device": "V356",
    "Model": "V356"
  },
  {
    "Retail Branding": "Klipad",
    "Marketing Name": "V356B",
    "Device": "V356B",
    "Model": "V356B"
  },
  {
    "Retail Branding": "Klipad",
    "Marketing Name": "V358",
    "Device": "V358",
    "Model": "V358"
  },
  {
    "Retail Branding": "Klipad",
    "Marketing Name": "V51A",
    "Device": "V51A",
    "Model": "V51A"
  },
  {
    "Retail Branding": "Klipad",
    "Marketing Name": "V51B",
    "Device": "V51B",
    "Model": "V51B"
  },
  {
    "Retail Branding": "Kobo",
    "Marketing Name": "Arc",
    "Device": "zeus",
    "Model": "Arc"
  },
  {
    "Retail Branding": "Kobo",
    "Marketing Name": "Arc 10HD",
    "Device": "macallan",
    "Model": "arc 10HD"
  },
  {
    "Retail Branding": "Kobo",
    "Marketing Name": "Arc 7",
    "Device": "lbp8",
    "Model": "arc 7"
  },
  {
    "Retail Branding": "Kobo",
    "Marketing Name": "Arc 7HD",
    "Device": "cardhu",
    "Model": "arc 7HD"
  },
  {
    "Retail Branding": "Kobo",
    "Marketing Name": "Vox",
    "Device": "pegasus",
    "Model": "Vox"
  },
  {
    "Retail Branding": "Kodak",
    "Marketing Name": "Columbia,Panama",
    "Device": "sepolia",
    "Model": "KODAK 4K Smart TV"
  },
  {
    "Retail Branding": "Kodak",
    "Marketing Name": "D50PRO",
    "Device": "Kodak_D50PRO",
    "Model": "D50PRO"
  },
  {
    "Retail Branding": "Kodak",
    "Marketing Name": "Ektra",
    "Device": "KodakEktra",
    "Model": "Ektra"
  },
  {
    "Retail Branding": "Kodak",
    "Marketing Name": "IM5",
    "Device": "IM5",
    "Model": "IM5"
  },
  {
    "Retail Branding": "Kodak",
    "Marketing Name": "K10_EEA",
    "Device": "K10_EEA",
    "Model": "K10_EEA"
  },
  {
    "Retail Branding": "Kodak",
    "Marketing Name": "K10_US",
    "Device": "K10_US",
    "Model": "K10_US"
  },
  {
    "Retail Branding": "Kodak",
    "Marketing Name": "K11_EU",
    "Device": "K11_EU",
    "Model": "K11_EU"
  },
  {
    "Retail Branding": "Kodak",
    "Marketing Name": "K11_ROW",
    "Device": "K11_ROW",
    "Model": "K11_ROW"
  },
  {
    "Retail Branding": "Kodak",
    "Marketing Name": "K12_EU",
    "Device": "K12_EU",
    "Model": "K12_EU"
  },
  {
    "Retail Branding": "Kodak",
    "Marketing Name": "K12_US",
    "Device": "K12_US",
    "Model": "K12_US"
  },
  {
    "Retail Branding": "Kodak",
    "Marketing Name": "KD10112TB",
    "Device": "KD10112TB",
    "Model": "KD10112TB"
  },
  {
    "Retail Branding": "Kodak",
    "Marketing Name": "KODAK",
    "Device": "bruno",
    "Model": "KODAK2KAndroidTV"
  },
  {
    "Retail Branding": "Kodak",
    "Marketing Name": "KODAK",
    "Device": "shilin",
    "Model": "KODAK4KAndroidTV"
  },
  {
    "Retail Branding": "Kodak",
    "Marketing Name": "KODAK SMARTWAY L1 PRO",
    "Device": "L1_PRO",
    "Model": "KODAK SMARTWAY L1 PRO"
  },
  {
    "Retail Branding": "Kodak",
    "Marketing Name": "KODAK SMARTWAY T3",
    "Device": "SMARTWAY_T3",
    "Model": "KODAK SMARTWAY T3"
  },
  {
    "Retail Branding": "Kodak",
    "Marketing Name": "KODAK_SMARTWAY_L1",
    "Device": "KODAK_SMARTWAY_L1",
    "Model": "KODAK_SMARTWAY_L1"
  },
  {
    "Retail Branding": "Kodak",
    "Marketing Name": "KODAK_SMARTWAY_T2",
    "Device": "KODAK_SMARTWAY_T2",
    "Model": "KODAK_SMARTWAY_T2"
  },
  {
    "Retail Branding": "Kodak",
    "Marketing Name": "KODAK_SMARTWAY_X2",
    "Device": "SMARTWAY_X2",
    "Model": "KODAK_SMARTWAY_X2"
  },
  {
    "Retail Branding": "Kodak",
    "Marketing Name": "KT102_EEA",
    "Device": "KT102_EEA",
    "Model": "KT102_EEA"
  },
  {
    "Retail Branding": "Kodak",
    "Marketing Name": "KT102_US",
    "Device": "KT102_US",
    "Model": "KT102_US"
  },
  {
    "Retail Branding": "Kodak",
    "Marketing Name": "KodakTV",
    "Device": "shibuya",
    "Model": "KodakTV"
  },
  {
    "Retail Branding": "Kodak",
    "Marketing Name": "Kodak_D40",
    "Device": "Kodak_D40",
    "Model": "D40"
  },
  {
    "Retail Branding": "Kodak",
    "Marketing Name": "Kodak_D50L",
    "Device": "Kodak_D50L",
    "Model": "D50L"
  },
  {
    "Retail Branding": "Kodak",
    "Marketing Name": "Kodak_D50PROL",
    "Device": "Kodak_D50PROL",
    "Model": "D50PROL"
  },
  {
    "Retail Branding": "Kodak",
    "Marketing Name": "Kodak_D55L",
    "Device": "Kodak_D55L",
    "Model": "D55L"
  },
  {
    "Retail Branding": "Kodak",
    "Marketing Name": "Kodak_D55L_R",
    "Device": "Kodak_D55L",
    "Model": "D55L"
  },
  {
    "Retail Branding": "Kodak",
    "Marketing Name": "Kodak_D60LX",
    "Device": "Kodak_D60LX",
    "Model": "D60LX"
  },
  {
    "Retail Branding": "Kodak",
    "Marketing Name": "Kodak_D61L",
    "Device": "Kodak_D61L",
    "Model": "D61L"
  },
  {
    "Retail Branding": "Kodak",
    "Marketing Name": "Kodak_D65L",
    "Device": "Kodak_D65L",
    "Model": "D65L"
  },
  {
    "Retail Branding": "Kodak",
    "Marketing Name": "Kodak_D65LX",
    "Device": "Kodak_D65LX",
    "Model": "D65LX"
  },
  {
    "Retail Branding": "Kodak",
    "Marketing Name": "Kodak_D9PRO",
    "Device": "Kodak_D9PRO",
    "Model": "D9PRO"
  },
  {
    "Retail Branding": "Kodak",
    "Marketing Name": "Kodak_KD50",
    "Device": "Kodak_KD50",
    "Model": "KD50"
  },
  {
    "Retail Branding": "Kodak",
    "Marketing Name": "Panama",
    "Device": "marina",
    "Model": "KODAK 4K Smart TV"
  },
  {
    "Retail Branding": "Kodak",
    "Marketing Name": "SMARTWAY L2",
    "Device": "SMARTWAY_L2",
    "Model": "SMARTWAY L2"
  },
  {
    "Retail Branding": "Kodak",
    "Marketing Name": "SMARTWAY M2",
    "Device": "SMARTWAY_M2",
    "Model": "KODAK SMARTWAY M2"
  },
  {
    "Retail Branding": "Kodak",
    "Marketing Name": "SMARTWAY_F1",
    "Device": "SMARTWAY_F1",
    "Model": "SMARTWAY_F1"
  },
  {
    "Retail Branding": "Kodak",
    "Marketing Name": "SOUTH AMERICA",
    "Device": "nagata",
    "Model": "KODAK 2K TV"
  },
  {
    "Retail Branding": "Kodak",
    "Marketing Name": "SP4",
    "Device": "SP4",
    "Model": "SP4"
  },
  {
    "Retail Branding": "Kodak",
    "Marketing Name": "Smartway_T1",
    "Device": "Smartway_T1",
    "Model": "Smartway_T1"
  },
  {
    "Retail Branding": "Kodak",
    "Marketing Name": "South America",
    "Device": "marina",
    "Model": "KODAK Smart TV"
  },
  {
    "Retail Branding": "Kodak",
    "Marketing Name": "South America",
    "Device": "sepolia",
    "Model": "KODAK Smart TV"
  },
  {
    "Retail Branding": "Kogan",
    "Marketing Name": "Agora 6 Plus",
    "Device": "Kogan_Agora_6Plus",
    "Model": "Kogan Agora 6Plus"
  },
  {
    "Retail Branding": "Kogan",
    "Marketing Name": "Android TV",
    "Device": "samseong",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "Kogan",
    "Marketing Name": "Australia",
    "Device": "nippori",
    "Model": "Kogan SmarterTV 2K"
  },
  {
    "Retail Branding": "Kogan",
    "Marketing Name": "Australia",
    "Device": "shibuya",
    "Model": "KoganTVAP"
  },
  {
    "Retail Branding": "Kogan",
    "Marketing Name": "Australia",
    "Device": "tamachi",
    "Model": "Kogan TV"
  },
  {
    "Retail Branding": "Kogan",
    "Marketing Name": "Australia",
    "Device": "yeongdeungpo",
    "Model": "Kogan TV"
  },
  {
    "Retail Branding": "Kogan",
    "Marketing Name": "Australia and New Zeeland",
    "Device": "guandu",
    "Model": "Kogan 4K TV"
  },
  {
    "Retail Branding": "Kogan",
    "Marketing Name": "Australia, New Zealand",
    "Device": "sepolia",
    "Model": "Kogan G6"
  },
  {
    "Retail Branding": "Kogan",
    "Marketing Name": "EU、UK、AP",
    "Device": "martin",
    "Model": "Kogan TV"
  },
  {
    "Retail Branding": "Kogan",
    "Marketing Name": "KAKT10164SA",
    "Device": "KAKT10164SA",
    "Model": "KAKT10164SA"
  },
  {
    "Retail Branding": "Kogan",
    "Marketing Name": "KAKT74128BA",
    "Device": "KAKT74128BA",
    "Model": "KAKT74128BA"
  },
  {
    "Retail Branding": "Kogan",
    "Marketing Name": "KALED32RH9210STA",
    "Device": "ikebukuro",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "Kogan",
    "Marketing Name": "KATB10128WPA",
    "Device": "KATB10128WPA",
    "Model": "KATB10128WPA"
  },
  {
    "Retail Branding": "Kogan",
    "Marketing Name": "KATB1064CGRY",
    "Device": "KATB1064CGRY",
    "Model": "KATB1064CGRY"
  },
  {
    "Retail Branding": "Kogan",
    "Marketing Name": "KATB1064WGRY",
    "Device": "KATB1064WGRY",
    "Model": "KATB1064WGRY"
  },
  {
    "Retail Branding": "Kogan",
    "Marketing Name": "KATB21064CPA",
    "Device": "KATB21064CPA",
    "Model": "KATB21064CPA"
  },
  {
    "Retail Branding": "Kogan",
    "Marketing Name": "KATB2P1064WPA",
    "Device": "KATB2P1064WPA",
    "Model": "KATB2P1064WPA"
  },
  {
    "Retail Branding": "Kogan",
    "Marketing Name": "KATB311PLSPA",
    "Device": "KATB311PLSPA",
    "Model": "KATB311PLSPA"
  },
  {
    "Retail Branding": "Kogan",
    "Marketing Name": "Kogan 4K Android TV",
    "Device": "SW4H",
    "Model": "Kogan 4K Android TV"
  },
  {
    "Retail Branding": "Kogan",
    "Marketing Name": "Kogan 4K PRO Android TV",
    "Device": "SW4H_FF",
    "Model": "Kogan 4K PRO Android TV"
  },
  {
    "Retail Branding": "Kogan",
    "Marketing Name": "Kogan Agora 8 Plus",
    "Device": "Agora_8_Plus",
    "Model": "Agora 8 Plus"
  },
  {
    "Retail Branding": "Kogan",
    "Marketing Name": "Kogan Agora 9",
    "Device": "Kogan_Agora_9",
    "Model": "Kogan Agora 9"
  },
  {
    "Retail Branding": "Kogan",
    "Marketing Name": "Kogan Agora Go",
    "Device": "Agora_Go",
    "Model": "Agora Go"
  },
  {
    "Retail Branding": "Kogan",
    "Marketing Name": "Kogan Agora XI",
    "Device": "AGORA_XI",
    "Model": "AGORA XI"
  },
  {
    "Retail Branding": "Kogan",
    "Marketing Name": "Kogan Agora XS",
    "Device": "Kogan_Agora_XS",
    "Model": "Agora XS"
  },
  {
    "Retail Branding": "Kogan",
    "Marketing Name": "Kogan G5",
    "Device": "marina",
    "Model": "Kogan G5"
  },
  {
    "Retail Branding": "Kogan",
    "Marketing Name": "Kogan G5",
    "Device": "nagata",
    "Model": "Kogan G5"
  },
  {
    "Retail Branding": "Kogan",
    "Marketing Name": "Kogan G7",
    "Device": "cottongreen",
    "Model": "Kogan G7"
  },
  {
    "Retail Branding": "Kogan",
    "Marketing Name": "Kogan SmarterTV",
    "Device": "hanyang",
    "Model": "Kogan SmarterTV"
  },
  {
    "Retail Branding": "Kogan",
    "Marketing Name": "RF9220",
    "Device": "redwood",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "Kogan",
    "Marketing Name": "Smart TV",
    "Device": "alimos",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "Kogan",
    "Marketing Name": "Smart TV",
    "Device": "bridgeport",
    "Model": "AI PONT PLUS FF"
  },
  {
    "Retail Branding": "Kogan",
    "Marketing Name": "Smart TV",
    "Device": "dangni",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "Kogan",
    "Marketing Name": "Smart TV",
    "Device": "longshan",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "Kogan",
    "Marketing Name": "Smart TV",
    "Device": "osaka",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "Kolin",
    "Marketing Name": "KOLIN",
    "Device": "elliniko",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "Kolin",
    "Marketing Name": "KOLIN",
    "Device": "hongkong",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "Kolin",
    "Marketing Name": "Smart TV",
    "Device": "longshan",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "Kolin",
    "Marketing Name": "Smart TV",
    "Device": "redwood",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "Kolke",
    "Marketing Name": "KTK-611",
    "Device": "KTK-611",
    "Model": "Kolke_KTK611"
  },
  {
    "Retail Branding": "Komu",
    "Marketing Name": "K22",
    "Device": "K22",
    "Model": "K22"
  },
  {
    "Retail Branding": "Konchris",
    "Marketing Name": "Konchris 2K Android",
    "Device": "lasalle",
    "Model": "Konchris 2K Android TV"
  },
  {
    "Retail Branding": "Konchris",
    "Marketing Name": "Konchris 4K Android TV",
    "Device": "kenton",
    "Model": "Konchris 4K Android TV"
  },
  {
    "Retail Branding": "Konrow",
    "Marketing Name": "CITY",
    "Device": "CITY",
    "Model": "CITY"
  },
  {
    "Retail Branding": "Konrow",
    "Marketing Name": "CITY4_EEA",
    "Device": "CITY4",
    "Model": "CITY4"
  },
  {
    "Retail Branding": "Konrow",
    "Marketing Name": "CITY5",
    "Device": "CITY5",
    "Model": "CITY5"
  },
  {
    "Retail Branding": "Konrow",
    "Marketing Name": "CITY55",
    "Device": "CITY55",
    "Model": "CITY55"
  },
  {
    "Retail Branding": "Konrow",
    "Marketing Name": "EASY S55P 2021",
    "Device": "EASY_S55P_2021",
    "Model": "EASY S55P 2021"
  },
  {
    "Retail Branding": "Konrow",
    "Marketing Name": "EASY5",
    "Device": "EASY5",
    "Model": "EASY5"
  },
  {
    "Retail Branding": "Konrow",
    "Marketing Name": "EASY55",
    "Device": "EASY55",
    "Model": "EASY55"
  },
  {
    "Retail Branding": "Konrow",
    "Marketing Name": "EASY62",
    "Device": "EASY62",
    "Model": "EASY62"
  },
  {
    "Retail Branding": "Konrow",
    "Marketing Name": "EASY_5",
    "Device": "EASY_5",
    "Model": "EASY_5_EEA"
  },
  {
    "Retail Branding": "Konrow",
    "Marketing Name": "EASY_K55",
    "Device": "EASY_K55",
    "Model": "EASY K55"
  },
  {
    "Retail Branding": "Konrow",
    "Marketing Name": "EASY_S55P",
    "Device": "EASY_S55P",
    "Model": "EASY_S55P_EEA"
  },
  {
    "Retail Branding": "Konrow",
    "Marketing Name": "K-TAB1005",
    "Device": "K-TAB1005",
    "Model": "K-TAB1005"
  },
  {
    "Retail Branding": "Konrow",
    "Marketing Name": "K-TAB703",
    "Device": "K-TAB703",
    "Model": "K-TAB703"
  },
  {
    "Retail Branding": "Konrow",
    "Marketing Name": "K-TAB801",
    "Device": "K-TAB801",
    "Model": "K-TAB801"
  },
  {
    "Retail Branding": "Konrow",
    "Marketing Name": "KONROW",
    "Device": "KONROW_701X",
    "Model": "KONROW_701X"
  },
  {
    "Retail Branding": "Konrow",
    "Marketing Name": "KTAB704",
    "Device": "KTAB704",
    "Model": "KTAB704"
  },
  {
    "Retail Branding": "Konrow",
    "Marketing Name": "KTAB_1003",
    "Device": "KTAB_1003",
    "Model": "KTAB_1003"
  },
  {
    "Retail Branding": "Konrow",
    "Marketing Name": "KTAB_1004",
    "Device": "KTAB_1004",
    "Model": "KTAB_1004"
  },
  {
    "Retail Branding": "Konrow",
    "Marketing Name": "LINK55",
    "Device": "LINK55",
    "Model": "LINK55"
  },
  {
    "Retail Branding": "Konrow",
    "Marketing Name": "MUST",
    "Device": "MUST",
    "Model": "MUST"
  },
  {
    "Retail Branding": "Konrow",
    "Marketing Name": "Primo",
    "Device": "PRIMO",
    "Model": "PRIMO"
  },
  {
    "Retail Branding": "Konrow",
    "Marketing Name": "SKY LITE",
    "Device": "KONROW_SKY_LITE",
    "Model": "SKY LITE"
  },
  {
    "Retail Branding": "Konrow",
    "Marketing Name": "SKY PLUS",
    "Device": "KONROW_SKY_PLUS",
    "Model": "SKY PLUS"
  },
  {
    "Retail Branding": "Konrow",
    "Marketing Name": "SKY55",
    "Device": "SKY55",
    "Model": "SKY55_EEA"
  },
  {
    "Retail Branding": "Konrow",
    "Marketing Name": "SKY63",
    "Device": "SKY63",
    "Model": "SKY63"
  },
  {
    "Retail Branding": "Konrow",
    "Marketing Name": "SKY_55",
    "Device": "SKY_55",
    "Model": "SKY_55_EEA"
  },
  {
    "Retail Branding": "Konrow",
    "Marketing Name": "SOFT5",
    "Device": "SOFT5",
    "Model": "SOFT5"
  },
  {
    "Retail Branding": "Konrow",
    "Marketing Name": "SOFT5P",
    "Device": "SOFT5P",
    "Model": "SOFT5P"
  },
  {
    "Retail Branding": "Konrow",
    "Marketing Name": "SWEET5",
    "Device": "SWEET5",
    "Model": "SWEET5"
  },
  {
    "Retail Branding": "Konrow",
    "Marketing Name": "SWEET_55",
    "Device": "SWEET_55",
    "Model": "SWEET 55"
  },
  {
    "Retail Branding": "Konrow",
    "Marketing Name": "Sky",
    "Device": "Sky",
    "Model": "Sky"
  },
  {
    "Retail Branding": "Konrow",
    "Marketing Name": "Smartfive",
    "Device": "KONROW_Smartfive",
    "Model": "Smartfive"
  },
  {
    "Retail Branding": "Konrow",
    "Marketing Name": "TOUCH55PLUS",
    "Device": "TOUCH55PLUS",
    "Model": "KONROW"
  },
  {
    "Retail Branding": "Kooda",
    "Marketing Name": "KOODA 2K TV",
    "Device": "shibuya",
    "Model": "KOODA 2K TV"
  },
  {
    "Retail Branding": "Korea Telecom",
    "Marketing Name": "KG2100",
    "Device": "KG2100",
    "Model": "KG2100"
  },
  {
    "Retail Branding": "Korea Telecom",
    "Marketing Name": "KG3100",
    "Device": "KG3100",
    "Model": "KG3100"
  },
  {
    "Retail Branding": "Korea Telecom",
    "Marketing Name": "KG4100",
    "Device": "KG4100",
    "Model": "KG4100"
  },
  {
    "Retail Branding": "Korea Telecom",
    "Marketing Name": "KI1101",
    "Device": "KI1101",
    "Model": "KI1101"
  },
  {
    "Retail Branding": "Korea Telecom",
    "Marketing Name": "KSTB6188",
    "Device": "KSTB6188",
    "Model": "KSTB6188"
  },
  {
    "Retail Branding": "Korea Telecom",
    "Marketing Name": "MA4000",
    "Device": "MA4000",
    "Model": "MA4000"
  },
  {
    "Retail Branding": "Korea Telecom",
    "Marketing Name": "MA4100",
    "Device": "MA4100",
    "Model": "MA4100"
  },
  {
    "Retail Branding": "Korea Telecom",
    "Marketing Name": "MAR4510C",
    "Device": "MAR4510C",
    "Model": "MAR4510C"
  },
  {
    "Retail Branding": "Korea Telecom",
    "Marketing Name": "MAU4800D",
    "Device": "mau4800d",
    "Model": "MAU4800D"
  },
  {
    "Retail Branding": "Krik Krak",
    "Marketing Name": "Freedom",
    "Device": "Freedom",
    "Model": "Freedom"
  },
  {
    "Retail Branding": "Krono",
    "Marketing Name": "776PLUS",
    "Device": "KRONO_776PLUS",
    "Model": "776PLUS"
  },
  {
    "Retail Branding": "Krono",
    "Marketing Name": "COLORS",
    "Device": "COLORS",
    "Model": "COLORS"
  },
  {
    "Retail Branding": "Krono",
    "Marketing Name": "KIDS_COLORS_PLUS",
    "Device": "KIDS_COLORS_PLUS",
    "Model": "KIDS_COLORS_PLUS"
  },
  {
    "Retail Branding": "Krono",
    "Marketing Name": "Krono_Kids_Play",
    "Device": "Krono_Kids_Play",
    "Model": "Krono_Kids_Play"
  },
  {
    "Retail Branding": "Krono",
    "Marketing Name": "MATRIX PRO",
    "Device": "MATRIX_PRO",
    "Model": "MATRIX_PRO"
  },
  {
    "Retail Branding": "Krono",
    "Marketing Name": "NEOW",
    "Device": "NEOW",
    "Model": "KONROW"
  },
  {
    "Retail Branding": "Krono",
    "Marketing Name": "NET-X2",
    "Device": "NET_X2",
    "Model": "NET_X2"
  },
  {
    "Retail Branding": "Krono",
    "Marketing Name": "NETWORK",
    "Device": "NETWORK",
    "Model": "NETWORK"
  },
  {
    "Retail Branding": "Krono",
    "Marketing Name": "NET_ADVANCE",
    "Device": "NET_ADVANCE",
    "Model": "NET_ADVANCE"
  },
  {
    "Retail Branding": "Krono",
    "Marketing Name": "NET_ALPHA",
    "Device": "NET_ALPHA",
    "Model": "NET ALPHA"
  },
  {
    "Retail Branding": "Krono",
    "Marketing Name": "NET_G",
    "Device": "NET_G",
    "Model": "NET_G"
  },
  {
    "Retail Branding": "Krono",
    "Marketing Name": "NET_HIT",
    "Device": "NET_HIT",
    "Model": "NET HIT"
  },
  {
    "Retail Branding": "Krono",
    "Marketing Name": "NET_K7",
    "Device": "NET_K7",
    "Model": "NET_K7"
  },
  {
    "Retail Branding": "Krono",
    "Marketing Name": "NET_K7_PLUS",
    "Device": "NET_K7_PLUS",
    "Model": "NET_K7_PLUS"
  },
  {
    "Retail Branding": "Krono",
    "Marketing Name": "NET_LITE",
    "Device": "NET_LITE",
    "Model": "NET_LITE"
  },
  {
    "Retail Branding": "Krono",
    "Marketing Name": "NET_MATRIX",
    "Device": "NET_MATRIX",
    "Model": "NET_MATRIX"
  },
  {
    "Retail Branding": "Krono",
    "Marketing Name": "NET_MAX",
    "Device": "NET_MAX",
    "Model": "NET_MAX"
  },
  {
    "Retail Branding": "Krono",
    "Marketing Name": "NET_ONE",
    "Device": "NET_ONE",
    "Model": "NET_ONE"
  },
  {
    "Retail Branding": "Krono",
    "Marketing Name": "NET_R7",
    "Device": "NET_R7",
    "Model": "NET_R7"
  },
  {
    "Retail Branding": "Krono",
    "Marketing Name": "NET_TITAN",
    "Device": "NET_TITAN",
    "Model": "NET_TITAN"
  },
  {
    "Retail Branding": "Krono",
    "Marketing Name": "NET_VOLT",
    "Device": "NET_VOLT",
    "Model": "NET_VOLT"
  },
  {
    "Retail Branding": "Krono",
    "Marketing Name": "NET_X2",
    "Device": "NET_X2",
    "Model": "NET_X2"
  },
  {
    "Retail Branding": "Krono",
    "Marketing Name": "NET_Y",
    "Device": "NET_Y",
    "Model": "NET_Y"
  },
  {
    "Retail Branding": "Krono",
    "Marketing Name": "Net_Max_Go",
    "Device": "Net_Max_Go",
    "Model": "Net_Max_Go"
  },
  {
    "Retail Branding": "Krono",
    "Marketing Name": "SKY",
    "Device": "SKY",
    "Model": "SKY"
  },
  {
    "Retail Branding": "Krono",
    "Marketing Name": "TOUCH55",
    "Device": "TOUCH55",
    "Model": "KONROW"
  },
  {
    "Retail Branding": "Krono",
    "Marketing Name": "ULTRA",
    "Device": "ULTRA",
    "Model": "ULTRA"
  },
  {
    "Retail Branding": "Krono",
    "Marketing Name": "kIDS_FIVE",
    "Device": "KIDS_FIVE",
    "Model": "KIDS_FIVE"
  },
  {
    "Retail Branding": "KrossElegance",
    "Marketing Name": "AS10LXPro",
    "Device": "AS10LXPro",
    "Model": "SOSPIRO-AS10LXPro"
  },
  {
    "Retail Branding": "KrossElegance",
    "Marketing Name": "KE-TB1032OF",
    "Device": "KE-TB1032OF",
    "Model": "KE-TB1032OF"
  },
  {
    "Retail Branding": "KrossElegance",
    "Marketing Name": "KE-TB815",
    "Device": "KE-TB815",
    "Model": "KE-TB815"
  },
  {
    "Retail Branding": "KrossElegance",
    "Marketing Name": "KE-TB816OF",
    "Device": "KE-TB816OF",
    "Model": "KE-TB816OF"
  },
  {
    "Retail Branding": "Kruger&Matz",
    "Marketing Name": "DRIVE 5",
    "Device": "Drive_5",
    "Model": "Kruger&Matz Drive 5"
  },
  {
    "Retail Branding": "Kruger&Matz",
    "Marketing Name": "DRIVE 8",
    "Device": "DRIVE_8",
    "Model": "DRIVE 8"
  },
  {
    "Retail Branding": "Kruger&Matz",
    "Marketing Name": "DRIVE9",
    "Device": "DRIVE9",
    "Model": "DRIVE9"
  },
  {
    "Retail Branding": "Kruger&Matz",
    "Marketing Name": "DRIVE_6",
    "Device": "DRIVE_6",
    "Model": "DRIVE_6"
  },
  {
    "Retail Branding": "Kruger&Matz",
    "Marketing Name": "DRIVE_6SS",
    "Device": "DRIVE_6S",
    "Model": "DRIVE_6S"
  },
  {
    "Retail Branding": "Kruger&Matz",
    "Marketing Name": "EAGLE 1070",
    "Device": "KM1070",
    "Model": "KM1070"
  },
  {
    "Retail Branding": "Kruger&Matz",
    "Marketing Name": "EAGLE 701",
    "Device": "EAGLE_KM0701_1",
    "Model": "KM0701_1"
  },
  {
    "Retail Branding": "Kruger&Matz",
    "Marketing Name": "EAGLE 804",
    "Device": "EAGLE_KM0804_1",
    "Model": "KM0804_1"
  },
  {
    "Retail Branding": "Kruger&Matz",
    "Marketing Name": "EAGLE 805",
    "Device": "EAGLE_KM0805_1",
    "Model": "KM0805_1"
  },
  {
    "Retail Branding": "Kruger&Matz",
    "Marketing Name": "EAGLE_1068",
    "Device": "EAGLE_1068",
    "Model": "EAGLE_1068"
  },
  {
    "Retail Branding": "Kruger&Matz",
    "Marketing Name": "EAGLE_961",
    "Device": "EAGLE_961",
    "Model": "EAGLE_961"
  },
  {
    "Retail Branding": "Kruger&Matz",
    "Marketing Name": "EAGLE_962",
    "Device": "EAGLE_962",
    "Model": "EAGLE_962"
  },
  {
    "Retail Branding": "Kruger&Matz",
    "Marketing Name": "Eagle 806",
    "Device": "Eagle_806",
    "Model": "Eagle 806"
  },
  {
    "Retail Branding": "Kruger&Matz",
    "Marketing Name": "Eagle_1074",
    "Device": "KM1074",
    "Model": "Eagle_1074"
  },
  {
    "Retail Branding": "Kruger&Matz",
    "Marketing Name": "Eagle_1075",
    "Device": "KM1075",
    "Model": "Eagle_1075"
  },
  {
    "Retail Branding": "Kruger&Matz",
    "Marketing Name": "Eagle_1076",
    "Device": "KM1076",
    "Model": "Eagle_1076"
  },
  {
    "Retail Branding": "Kruger&Matz",
    "Marketing Name": "Eagle_702",
    "Device": "Eagle_702",
    "Model": "KM0702"
  },
  {
    "Retail Branding": "Kruger&Matz",
    "Marketing Name": "Eagle_806_EEA",
    "Device": "KM08061",
    "Model": "Eagle_806"
  },
  {
    "Retail Branding": "Kruger&Matz",
    "Marketing Name": "Eagle_807",
    "Device": "KM0807",
    "Model": "Eagle_807"
  },
  {
    "Retail Branding": "Kruger&Matz",
    "Marketing Name": "FLOW",
    "Device": "Kruger_Matz_FLOW",
    "Model": "FLOW"
  },
  {
    "Retail Branding": "Kruger&Matz",
    "Marketing Name": "FLOW 5",
    "Device": "FLOW_5",
    "Model": "FLOW_5"
  },
  {
    "Retail Branding": "Kruger&Matz",
    "Marketing Name": "FLOW 5+",
    "Device": "FLOW5PLUS",
    "Model": "FLOW5PLUS"
  },
  {
    "Retail Branding": "Kruger&Matz",
    "Marketing Name": "FLOW6",
    "Device": "FLOW6",
    "Model": "FLOW6"
  },
  {
    "Retail Branding": "Kruger&Matz",
    "Marketing Name": "FLOW6Lite",
    "Device": "FLOW6Lite",
    "Model": "FLOW6Lite"
  },
  {
    "Retail Branding": "Kruger&Matz",
    "Marketing Name": "FLOW6S",
    "Device": "FLOW6S",
    "Model": "FLOW6S"
  },
  {
    "Retail Branding": "Kruger&Matz",
    "Marketing Name": "FLOW7",
    "Device": "FLOW7",
    "Model": "FLOW7"
  },
  {
    "Retail Branding": "Kruger&Matz",
    "Marketing Name": "FLOW_11_EEA",
    "Device": "FLOW_11",
    "Model": "FLOW 11"
  },
  {
    "Retail Branding": "Kruger&Matz",
    "Marketing Name": "FLOW_11_NF_EEA",
    "Device": "FLOW_11",
    "Model": "FLOW 11"
  },
  {
    "Retail Branding": "Kruger&Matz",
    "Marketing Name": "Flow_7S_EEA",
    "Device": "Flow_7S",
    "Model": "Flow 7S"
  },
  {
    "Retail Branding": "Kruger&Matz",
    "Marketing Name": "Flow_9_EEA",
    "Device": "Flow_9",
    "Model": "Flow 9"
  },
  {
    "Retail Branding": "Kruger&Matz",
    "Marketing Name": "KM 2K TV",
    "Device": "capitolhill",
    "Model": "KM 2K TV"
  },
  {
    "Retail Branding": "Kruger&Matz",
    "Marketing Name": "KM 4K TV",
    "Device": "keoneae",
    "Model": "KM 4K TV"
  },
  {
    "Retail Branding": "Kruger&Matz",
    "Marketing Name": "KM0708",
    "Device": "KM0708",
    "Model": "KM0708"
  },
  {
    "Retail Branding": "Kruger&Matz",
    "Marketing Name": "KM0808",
    "Device": "KM0808",
    "Model": "KM0808"
  },
  {
    "Retail Branding": "Kruger&Matz",
    "Marketing Name": "KM0HD FHD",
    "Device": "eeklo",
    "Model": "KM0HD FHD"
  },
  {
    "Retail Branding": "Kruger&Matz",
    "Marketing Name": "KM0UHD",
    "Device": "galway",
    "Model": "KM0UHD"
  },
  {
    "Retail Branding": "Kruger&Matz",
    "Marketing Name": "KM1008",
    "Device": "KM1008",
    "Model": "KM1008"
  },
  {
    "Retail Branding": "Kruger&Matz",
    "Marketing Name": "KM1066",
    "Device": "EAGLE_1066",
    "Model": "KM1066"
  },
  {
    "Retail Branding": "Kruger&Matz",
    "Marketing Name": "KM1067",
    "Device": "EAGLE_1067",
    "Model": "KM1067"
  },
  {
    "Retail Branding": "Kruger&Matz",
    "Marketing Name": "KM1072",
    "Device": "EAGLE_1072",
    "Model": "KM1072"
  },
  {
    "Retail Branding": "Kruger&Matz",
    "Marketing Name": "KM1073",
    "Device": "EAGLE_1073",
    "Model": "KM1073"
  },
  {
    "Retail Branding": "Kruger&Matz",
    "Marketing Name": "LIVE 5",
    "Device": "LIVE_5",
    "Model": "Krüger&Matz _LIVE5_KM0450"
  },
  {
    "Retail Branding": "Kruger&Matz",
    "Marketing Name": "LIVE 5 PLUS",
    "Device": "LIVE_5_PLUS",
    "Model": "LIVE 5 PLUS"
  },
  {
    "Retail Branding": "Kruger&Matz",
    "Marketing Name": "LIVE 7",
    "Device": "LIVE_7",
    "Model": "LIVE 7"
  },
  {
    "Retail Branding": "Kruger&Matz",
    "Marketing Name": "LIVE 7S",
    "Device": "LIVE_7S",
    "Model": "LIVE 7S"
  },
  {
    "Retail Branding": "Kruger&Matz",
    "Marketing Name": "LIVE_11_EEA",
    "Device": "LIVE_11",
    "Model": "LIVE 11"
  },
  {
    "Retail Branding": "Kruger&Matz",
    "Marketing Name": "LIVE_11_NN_EEA",
    "Device": "LIVE_11",
    "Model": "LIVE 11"
  },
  {
    "Retail Branding": "Kruger&Matz",
    "Marketing Name": "LIVE_6plus",
    "Device": "LIVE_6plus",
    "Model": "LIVE_6plus"
  },
  {
    "Retail Branding": "Kruger&Matz",
    "Marketing Name": "LIVE_7",
    "Device": "LIVE_7",
    "Model": "LIVE 7"
  },
  {
    "Retail Branding": "Kruger&Matz",
    "Marketing Name": "Live 8 EEA",
    "Device": "Live_8",
    "Model": "Live 8"
  },
  {
    "Retail Branding": "Kruger&Matz",
    "Marketing Name": "Live 9 EEA",
    "Device": "Live_9",
    "Model": "Live 9"
  },
  {
    "Retail Branding": "Kruger&Matz",
    "Marketing Name": "Live 9S EEA",
    "Device": "Live_9S",
    "Model": "Live 9S"
  },
  {
    "Retail Branding": "Kruger&Matz",
    "Marketing Name": "MOVE 7",
    "Device": "MOVE_7",
    "Model": "MOVE_7"
  },
  {
    "Retail Branding": "Kruger&Matz",
    "Marketing Name": "MOVE8",
    "Device": "MOVE_8",
    "Model": "MOVE_8"
  },
  {
    "Retail Branding": "Kruger&Matz",
    "Marketing Name": "MOVE8mini",
    "Device": "MOVE8mini",
    "Model": "MOVE8mini"
  },
  {
    "Retail Branding": "Kruger&Matz",
    "Marketing Name": "MOVE8mini",
    "Device": "MOVE8mini_Q",
    "Model": "MOVE8mini"
  },
  {
    "Retail Branding": "Kruger&Matz",
    "Marketing Name": "MOVE9",
    "Device": "MOVE9",
    "Model": "MOVE9"
  },
  {
    "Retail Branding": "Kruger&Matz",
    "Marketing Name": "MOVE_8.1",
    "Device": "MOVE_8_1",
    "Model": "MOVE_8"
  },
  {
    "Retail Branding": "Kruger_Matz",
    "Marketing Name": "EAGLE_1077",
    "Device": "KM1077",
    "Model": "KM1077"
  },
  {
    "Retail Branding": "Kruger_Matz",
    "Marketing Name": "EAGLE_1077S",
    "Device": "KM1077S",
    "Model": "KM1077S"
  },
  {
    "Retail Branding": "Kruger_Matz",
    "Marketing Name": "EAGLE_1078",
    "Device": "KM1078",
    "Model": "KM1078"
  },
  {
    "Retail Branding": "Kruger_Matz",
    "Marketing Name": "EAGLE_1078S",
    "Device": "KM1078S",
    "Model": "KM1078S"
  },
  {
    "Retail Branding": "Kruger_Matz",
    "Marketing Name": "LIVE_12_EEA",
    "Device": "LIVE_12",
    "Model": "LIVE 12"
  },
  {
    "Retail Branding": "Kst(TH)",
    "Marketing Name": "KST",
    "Device": "KST-900pro",
    "Model": "KST-900pro"
  },
  {
    "Retail Branding": "Kubo",
    "Marketing Name": "F99",
    "Device": "F99",
    "Model": "F99"
  },
  {
    "Retail Branding": "Kubo",
    "Marketing Name": "K5",
    "Device": "K5",
    "Model": "K5"
  },
  {
    "Retail Branding": "Kubo",
    "Marketing Name": "Smart TV",
    "Device": "samseong",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "Kudae",
    "Marketing Name": "K10",
    "Device": "K10",
    "Model": "K10"
  },
  {
    "Retail Branding": "Kudae",
    "Marketing Name": "K10 PRO",
    "Device": "K10_PRO",
    "Model": "K10 PRO"
  },
  {
    "Retail Branding": "Kudae",
    "Marketing Name": "K101",
    "Device": "K101",
    "Model": "K101"
  },
  {
    "Retail Branding": "Kult",
    "Marketing Name": "Gladiator",
    "Device": "Gladiator",
    "Model": "Gladiator"
  },
  {
    "Retail Branding": "Kult",
    "Marketing Name": "KT05",
    "Device": "KT05",
    "Model": "KT05"
  },
  {
    "Retail Branding": "Kult",
    "Marketing Name": "Kult Ambition",
    "Device": "Ambition",
    "Model": "Ambition"
  },
  {
    "Retail Branding": "Kult",
    "Marketing Name": "Kult Beyond",
    "Device": "Beyond",
    "Model": "Beyond"
  },
  {
    "Retail Branding": "Kunfabo",
    "Marketing Name": "F99Pro",
    "Device": "F99Pro",
    "Model": "F99Pro"
  },
  {
    "Retail Branding": "Kuori",
    "Marketing Name": "KH3566",
    "Device": "Kivi",
    "Model": "KH3566"
  },
  {
    "Retail Branding": "Kuori",
    "Marketing Name": "KH3588S",
    "Device": "Graniitti",
    "Model": "KH3588S"
  },
  {
    "Retail Branding": "Kuori",
    "Marketing Name": "KH3588S_NFC",
    "Device": "Graniitti",
    "Model": "KH3588S_NFC"
  },
  {
    "Retail Branding": "Kuori",
    "Marketing Name": "KH660",
    "Device": "Nupiton",
    "Model": "KH660"
  },
  {
    "Retail Branding": "Kurio",
    "Marketing Name": "K01023",
    "Device": "K01023",
    "Model": "K01023"
  },
  {
    "Retail Branding": "Kurio",
    "Marketing Name": "K01023",
    "Device": "K01023",
    "Model": "KURIO_01023"
  },
  {
    "Retail Branding": "Kurio",
    "Marketing Name": "K01023US",
    "Device": "K01023US",
    "Model": "K01023US"
  },
  {
    "Retail Branding": "Kurio",
    "Marketing Name": "K01524",
    "Device": "K01524",
    "Model": "K01524"
  },
  {
    "Retail Branding": "Kurio",
    "Marketing Name": "KURIO LITE GO NEW",
    "Device": "U3A_7_WIFI_Refresh_KD",
    "Model": "9309S"
  },
  {
    "Retail Branding": "Kurio",
    "Marketing Name": "KURIO LITE GO NEW",
    "Device": "U3A_7_WIFI_Refresh_KD",
    "Model": "9309S2"
  },
  {
    "Retail Branding": "Kurio",
    "Marketing Name": "KURIO LITE GO NEW",
    "Device": "U3A_7_WIFI_Refresh_KD",
    "Model": "9309S2_EEA"
  },
  {
    "Retail Branding": "Kurio",
    "Marketing Name": "KURIO LITE GO NEW",
    "Device": "U3A_7_WIFI_Refresh_KD",
    "Model": "9309S_EEA"
  },
  {
    "Retail Branding": "Kurio",
    "Marketing Name": "Kurio Smart 2 in 1 PRO",
    "Device": "Aquaman_10_WIFI",
    "Model": "8391X"
  },
  {
    "Retail Branding": "Kurio",
    "Marketing Name": "Kurio Smart 2 in 1 PRO",
    "Device": "Aquaman_10_WIFI",
    "Model": "8391X_EEA"
  },
  {
    "Retail Branding": "Kurio",
    "Marketing Name": "Kurio Tab",
    "Device": "Hulk_7_KIDS_WIFI",
    "Model": 8076
  },
  {
    "Retail Branding": "Kurio",
    "Marketing Name": "Kurio Tab",
    "Device": "Hulk_7_KIDS_WIFI",
    "Model": "8076_EEA"
  },
  {
    "Retail Branding": "Kurio",
    "Marketing Name": "Smart Tab 7",
    "Device": "Phoenix_7_KD",
    "Model": "9317H"
  },
  {
    "Retail Branding": "Kurio",
    "Marketing Name": "Smart Tab 7",
    "Device": "Phoenix_7_KD",
    "Model": "9317H1"
  },
  {
    "Retail Branding": "Kurio",
    "Marketing Name": "TabGo Next Connect",
    "Device": "M7006A",
    "Model": "01519"
  },
  {
    "Retail Branding": "Kyocera",
    "Marketing Name": "",
    "Device": "SCP-8600",
    "Model": "Zio"
  },
  {
    "Retail Branding": "Kyocera",
    "Marketing Name": "",
    "Device": "WX06K",
    "Model": "WX06K"
  },
  {
    "Retail Branding": "Kyocera",
    "Marketing Name": "404KC",
    "Device": "404KC",
    "Model": "404KC"
  },
  {
    "Retail Branding": "Kyocera",
    "Marketing Name": "503KC",
    "Device": "503KC",
    "Model": "503KC"
  },
  {
    "Retail Branding": "Kyocera",
    "Marketing Name": "602KC",
    "Device": "602KC",
    "Model": "602KC"
  },
  {
    "Retail Branding": "Kyocera",
    "Marketing Name": "704KC",
    "Device": "704KC",
    "Model": "704KC"
  },
  {
    "Retail Branding": "Kyocera",
    "Marketing Name": "705KC",
    "Device": "705KC",
    "Model": "705KC"
  },
  {
    "Retail Branding": "Kyocera",
    "Marketing Name": "Android One S10",
    "Device": "S10-KC_sprout",
    "Model": "S10-KC"
  },
  {
    "Retail Branding": "Kyocera",
    "Marketing Name": "Android One S2",
    "Device": "S2_sprout",
    "Model": "S2"
  },
  {
    "Retail Branding": "Kyocera",
    "Marketing Name": "Android One S9",
    "Device": "S9-KC_sprout",
    "Model": "S9-KC"
  },
  {
    "Retail Branding": "Kyocera",
    "Marketing Name": "BASIO",
    "Device": "KYV32",
    "Model": "KYV32"
  },
  {
    "Retail Branding": "Kyocera",
    "Marketing Name": "BASIO 3",
    "Device": "KYV43",
    "Model": "KYV43"
  },
  {
    "Retail Branding": "Kyocera",
    "Marketing Name": "BASIO active3",
    "Device": "KY24L-SN100",
    "Model": "KYG04"
  },
  {
    "Retail Branding": "Kyocera",
    "Marketing Name": "BASIO4",
    "Device": "KYV47",
    "Model": "KYV47"
  },
  {
    "Retail Branding": "Kyocera",
    "Marketing Name": "BASIO4",
    "Device": "KYV47",
    "Model": "KYV47-j"
  },
  {
    "Retail Branding": "Kyocera",
    "Marketing Name": "BASIO4",
    "Device": "KYV47",
    "Model": "KYV47-u"
  },
  {
    "Retail Branding": "Kyocera",
    "Marketing Name": "Brigadier",
    "Device": "E6782",
    "Model": "E6782"
  },
  {
    "Retail Branding": "Kyocera",
    "Marketing Name": "DIGNO",
    "Device": "KYI11",
    "Model": "ISW11K"
  },
  {
    "Retail Branding": "Kyocera",
    "Marketing Name": "DIGNO",
    "Device": "KYL22",
    "Model": "KYL22"
  },
  {
    "Retail Branding": "Kyocera",
    "Marketing Name": "DIGNO BX",
    "Device": "901KC",
    "Model": "901KC"
  },
  {
    "Retail Branding": "Kyocera",
    "Marketing Name": "DIGNO BX2",
    "Device": "KY21L-ST100",
    "Model": "A101KC"
  },
  {
    "Retail Branding": "Kyocera",
    "Marketing Name": "DIGNO BX3",
    "Device": "KY24L-ST100",
    "Model": "A401KC"
  },
  {
    "Retail Branding": "Kyocera",
    "Marketing Name": "DIGNO BX3 Plus",
    "Device": "KY24L-ST100",
    "Model": "A403KC"
  },
  {
    "Retail Branding": "Kyocera",
    "Marketing Name": "DIGNO BX3 カメラレス",
    "Device": "KY24L-ST100",
    "Model": "A402KC"
  },
  {
    "Retail Branding": "Kyocera",
    "Marketing Name": "DIGNO Dual",
    "Device": "WX04K",
    "Model": "WX04K"
  },
  {
    "Retail Branding": "Kyocera",
    "Marketing Name": "DIGNO L",
    "Device": "KYV36",
    "Model": "KYV36"
  },
  {
    "Retail Branding": "Kyocera",
    "Marketing Name": "DIGNO R",
    "Device": "202K",
    "Model": "202K"
  },
  {
    "Retail Branding": "Kyocera",
    "Marketing Name": "DIGNO S",
    "Device": "KYL21",
    "Model": "KYL21"
  },
  {
    "Retail Branding": "Kyocera",
    "Marketing Name": "DIGNO SANGA edition",
    "Device": "KC-S304",
    "Model": "KC-S304"
  },
  {
    "Retail Branding": "Kyocera",
    "Marketing Name": "DIGNO SX2",
    "Device": "KY21L-ST100",
    "Model": "KC-S302"
  },
  {
    "Retail Branding": "Kyocera",
    "Marketing Name": "DIGNO SX3",
    "Device": "KY22L-ST200",
    "Model": "KYG02"
  },
  {
    "Retail Branding": "Kyocera",
    "Marketing Name": "DIGNO SX4",
    "Device": "KY24L-ST200",
    "Model": "KC-S305"
  },
  {
    "Retail Branding": "Kyocera",
    "Marketing Name": "DIGNO SX4 Wi-Fi",
    "Device": "KY24L-ST300",
    "Model": "KC-S205"
  },
  {
    "Retail Branding": "Kyocera",
    "Marketing Name": "DIGNO SX5",
    "Device": "KY25L-ST100",
    "Model": "KC-S306"
  },
  {
    "Retail Branding": "Kyocera",
    "Marketing Name": "DIGNO SX5",
    "Device": "KY25L-ST100",
    "Model": "KYG07"
  },
  {
    "Retail Branding": "Kyocera",
    "Marketing Name": "DIGNO T",
    "Device": "302KC",
    "Model": "302KC"
  },
  {
    "Retail Branding": "Kyocera",
    "Marketing Name": "DIGNO Tab",
    "Device": "KYT34",
    "Model": "KYT34"
  },
  {
    "Retail Branding": "Kyocera",
    "Marketing Name": "DIGNO Tab2 5G",
    "Device": "KY24L-TB100",
    "Model": "KC-T306"
  },
  {
    "Retail Branding": "Kyocera",
    "Marketing Name": "DIGNO Tab2 5G",
    "Device": "KY24L-TB100",
    "Model": "KYT35"
  },
  {
    "Retail Branding": "Kyocera",
    "Marketing Name": "DIGNO Tab2 5G",
    "Device": "KY24L-TB200",
    "Model": "A404KC"
  },
  {
    "Retail Branding": "Kyocera",
    "Marketing Name": "DIGNO V",
    "Device": "KYV42",
    "Model": "KYV42_u"
  },
  {
    "Retail Branding": "Kyocera",
    "Marketing Name": "DIGNO W",
    "Device": "KYV40",
    "Model": "KYV40U"
  },
  {
    "Retail Branding": "Kyocera",
    "Marketing Name": "DIGNO WX",
    "Device": "KC-S303",
    "Model": "KC-S303"
  },
  {
    "Retail Branding": "Kyocera",
    "Marketing Name": "DIGNO rafre",
    "Device": "KYV36",
    "Model": "KYV36"
  },
  {
    "Retail Branding": "Kyocera",
    "Marketing Name": "DM015K",
    "Device": "DM015K",
    "Model": "DM015K"
  },
  {
    "Retail Branding": "Kyocera",
    "Marketing Name": "DURA FORCE PRO",
    "Device": "KC-S702",
    "Model": "KC-S702"
  },
  {
    "Retail Branding": "Kyocera",
    "Marketing Name": "DuraForce",
    "Device": "E6560",
    "Model": "KYOCERA-E6560"
  },
  {
    "Retail Branding": "Kyocera",
    "Marketing Name": "DuraForce",
    "Device": "E6560C",
    "Model": "E6560C"
  },
  {
    "Retail Branding": "Kyocera",
    "Marketing Name": "DuraForce",
    "Device": "E6560L",
    "Model": "E6560L"
  },
  {
    "Retail Branding": "Kyocera",
    "Marketing Name": "DuraForce",
    "Device": "E6560T",
    "Model": "E6560T"
  },
  {
    "Retail Branding": "Kyocera",
    "Marketing Name": "DuraForce",
    "Device": "E6762",
    "Model": "USCC-E6762"
  },
  {
    "Retail Branding": "Kyocera",
    "Marketing Name": "DuraForce EX",
    "Device": "KY-51D",
    "Model": "KY-51D"
  },
  {
    "Retail Branding": "Kyocera",
    "Marketing Name": "DuraForce EX",
    "Device": "KY23L-RG100",
    "Model": "A301KC"
  },
  {
    "Retail Branding": "Kyocera",
    "Marketing Name": "DuraForce EX",
    "Device": "KY23L-RG100",
    "Model": "KC-S603"
  },
  {
    "Retail Branding": "Kyocera",
    "Marketing Name": "DuraForce EX",
    "Device": "KY23L-RG100",
    "Model": "KC-S703"
  },
  {
    "Retail Branding": "Kyocera",
    "Marketing Name": "DuraForce PRO",
    "Device": "E6820",
    "Model": "KYOCERA-E6820"
  },
  {
    "Retail Branding": "Kyocera",
    "Marketing Name": "DuraForce PRO",
    "Device": "E6820TM_3GB",
    "Model": "E6820TM"
  },
  {
    "Retail Branding": "Kyocera",
    "Marketing Name": "DuraForce PRO",
    "Device": "E6820_3GB",
    "Model": "KYOCERA-E6820"
  },
  {
    "Retail Branding": "Kyocera",
    "Marketing Name": "DuraForce PRO",
    "Device": "E6830",
    "Model": "E6830"
  },
  {
    "Retail Branding": "Kyocera",
    "Marketing Name": "DuraForce PRO",
    "Device": "E6833",
    "Model": "E6833"
  },
  {
    "Retail Branding": "Kyocera",
    "Marketing Name": "DuraForce PRO 2 with Sapphire shield",
    "Device": "E6910",
    "Model": "E6910"
  },
  {
    "Retail Branding": "Kyocera",
    "Marketing Name": "DuraForce PRO 3",
    "Device": "KY22M-RG100",
    "Model": "E7200"
  },
  {
    "Retail Branding": "Kyocera",
    "Marketing Name": "DuraForce PRO with Sapphire Shield",
    "Device": "E6810",
    "Model": "E6810"
  },
  {
    "Retail Branding": "Kyocera",
    "Marketing Name": "DuraForce PRO with Sapphire Shield",
    "Device": "E6810_3GB",
    "Model": "E6810"
  },
  {
    "Retail Branding": "Kyocera",
    "Marketing Name": "DuraForce Pro 2",
    "Device": "E6920",
    "Model": "E6921"
  },
  {
    "Retail Branding": "Kyocera",
    "Marketing Name": "DuraForce Pro 2",
    "Device": "E6920",
    "Model": "KYOCERA-E6920"
  },
  {
    "Retail Branding": "Kyocera",
    "Marketing Name": "DuraForce Ultra 5G",
    "Device": "E7110",
    "Model": "E7110"
  },
  {
    "Retail Branding": "Kyocera",
    "Marketing Name": "DuraForce XD",
    "Device": "E6790",
    "Model": "KYOCERA-E6790"
  },
  {
    "Retail Branding": "Kyocera",
    "Marketing Name": "DuraForce XD",
    "Device": "E6790TM",
    "Model": "E6790TM"
  },
  {
    "Retail Branding": "Kyocera",
    "Marketing Name": "DuraScout",
    "Device": "E6782L",
    "Model": "E6782L"
  },
  {
    "Retail Branding": "Kyocera",
    "Marketing Name": "DuraSport 5G",
    "Device": "KY21L-RG100",
    "Model": "C6930"
  },
  {
    "Retail Branding": "Kyocera",
    "Marketing Name": "DuraSport 5G",
    "Device": "KY21L-RG100",
    "Model": "C6931"
  },
  {
    "Retail Branding": "Kyocera",
    "Marketing Name": "Echo",
    "Device": "KSP8000",
    "Model": "KSP8000"
  },
  {
    "Retail Branding": "Kyocera",
    "Marketing Name": "Echo",
    "Device": "M9300",
    "Model": "M9300"
  },
  {
    "Retail Branding": "Kyocera",
    "Marketing Name": "Event",
    "Device": "C5133",
    "Model": "Event"
  },
  {
    "Retail Branding": "Kyocera",
    "Marketing Name": "GRATINA",
    "Device": "KYV48",
    "Model": "KYV48"
  },
  {
    "Retail Branding": "Kyocera",
    "Marketing Name": "HONEY BEE",
    "Device": "101K",
    "Model": "101K"
  },
  {
    "Retail Branding": "Kyocera",
    "Marketing Name": "Honeybee Touch",
    "Device": "201K",
    "Model": "201K"
  },
  {
    "Retail Branding": "Kyocera",
    "Marketing Name": "Hydro",
    "Device": "C5170",
    "Model": "C5170"
  },
  {
    "Retail Branding": "Kyocera",
    "Marketing Name": "Hydro",
    "Device": "C5171",
    "Model": "Hydro"
  },
  {
    "Retail Branding": "Kyocera",
    "Marketing Name": "Hydro AIR",
    "Device": "C6745",
    "Model": "KYOCERA-C6745"
  },
  {
    "Retail Branding": "Kyocera",
    "Marketing Name": "Hydro EDGE",
    "Device": "C5215",
    "Model": "C5215"
  },
  {
    "Retail Branding": "Kyocera",
    "Marketing Name": "Hydro Elite",
    "Device": "C6750",
    "Model": "C6750"
  },
  {
    "Retail Branding": "Kyocera",
    "Marketing Name": "Hydro ICON",
    "Device": "C6730",
    "Model": "C6730"
  },
  {
    "Retail Branding": "Kyocera",
    "Marketing Name": "Hydro LIFE",
    "Device": "C6530",
    "Model": "C6530"
  },
  {
    "Retail Branding": "Kyocera",
    "Marketing Name": "Hydro LIFE",
    "Device": "C6530N",
    "Model": "C6530N"
  },
  {
    "Retail Branding": "Kyocera",
    "Marketing Name": "Hydro PLUS",
    "Device": "C5171R",
    "Model": "Hydro"
  },
  {
    "Retail Branding": "Kyocera",
    "Marketing Name": "Hydro PLUS",
    "Device": "C5171R",
    "Model": "Hydro_PLUS"
  },
  {
    "Retail Branding": "Kyocera",
    "Marketing Name": "Hydro REACH",
    "Device": "C6743",
    "Model": "C6743"
  },
  {
    "Retail Branding": "Kyocera",
    "Marketing Name": "Hydro SHORE",
    "Device": "C6742A",
    "Model": "KYOCERA-C6742A"
  },
  {
    "Retail Branding": "Kyocera",
    "Marketing Name": "Hydro VIBE",
    "Device": "C6725",
    "Model": "C6725"
  },
  {
    "Retail Branding": "Kyocera",
    "Marketing Name": "Hydro VIEW",
    "Device": "C6742",
    "Model": "C6742"
  },
  {
    "Retail Branding": "Kyocera",
    "Marketing Name": "Hydro VIEW",
    "Device": "C6742",
    "Model": "KYOCERA-C6742"
  },
  {
    "Retail Branding": "Kyocera",
    "Marketing Name": "Hydro WAVE",
    "Device": "C6740",
    "Model": "C6740"
  },
  {
    "Retail Branding": "Kyocera",
    "Marketing Name": "Hydro WAVE",
    "Device": "C6740N",
    "Model": "C6740N"
  },
  {
    "Retail Branding": "Kyocera",
    "Marketing Name": "Hydro XTRM",
    "Device": "C6522",
    "Model": "C6522"
  },
  {
    "Retail Branding": "Kyocera",
    "Marketing Name": "Hydro XTRM",
    "Device": "C6522N",
    "Model": "C6522N"
  },
  {
    "Retail Branding": "Kyocera",
    "Marketing Name": "Hydro XTRM",
    "Device": "C6721",
    "Model": "USCC-C6721"
  },
  {
    "Retail Branding": "Kyocera",
    "Marketing Name": "INFOBAR A03",
    "Device": "KYV33",
    "Model": "KYV33"
  },
  {
    "Retail Branding": "Kyocera",
    "Marketing Name": "K5G-C-100A",
    "Device": "K5G-C-100A",
    "Model": "K5G-C-100A"
  },
  {
    "Retail Branding": "Kyocera",
    "Marketing Name": "KC-01",
    "Device": "KC-01",
    "Model": "KC-01"
  },
  {
    "Retail Branding": "Kyocera",
    "Marketing Name": "KC-T302DT",
    "Device": "KC-T302DT",
    "Model": "KC-T302DT"
  },
  {
    "Retail Branding": "Kyocera",
    "Marketing Name": "KC-T302DT",
    "Device": "SZJ202",
    "Model": "SZJ-JS202"
  },
  {
    "Retail Branding": "Kyocera",
    "Marketing Name": "KC-T303DT",
    "Device": "SZJ203",
    "Model": "SZJ-JS203"
  },
  {
    "Retail Branding": "Kyocera",
    "Marketing Name": "KC-T304",
    "Device": "KC-T304",
    "Model": "KC-T304"
  },
  {
    "Retail Branding": "Kyocera",
    "Marketing Name": "KC-T305",
    "Device": "KY24L-TB300",
    "Model": "KC-T305CN"
  },
  {
    "Retail Branding": "Kyocera",
    "Marketing Name": "KC-T308",
    "Device": "KY25L-TB100",
    "Model": "KC-T308"
  },
  {
    "Retail Branding": "Kyocera",
    "Marketing Name": "LUCE",
    "Device": "KCP01K",
    "Model": "KCP01K"
  },
  {
    "Retail Branding": "Kyocera",
    "Marketing Name": "LifeWatch Universal Gateway",
    "Device": "CD8100",
    "Model": "CD8100"
  },
  {
    "Retail Branding": "Kyocera",
    "Marketing Name": "Milano",
    "Device": "C5120",
    "Model": "C5120"
  },
  {
    "Retail Branding": "Kyocera",
    "Marketing Name": "Milano",
    "Device": "C5121",
    "Model": "C5121"
  },
  {
    "Retail Branding": "Kyocera",
    "Marketing Name": "Qua phone",
    "Device": "KYV42",
    "Model": "KYV42"
  },
  {
    "Retail Branding": "Kyocera",
    "Marketing Name": "Qua phone (KYV37)",
    "Device": "KYV37",
    "Model": "KYV37"
  },
  {
    "Retail Branding": "Kyocera",
    "Marketing Name": "Qua phone QZ",
    "Device": "KYV44",
    "Model": "KYV44"
  },
  {
    "Retail Branding": "Kyocera",
    "Marketing Name": "Qua phone QZ",
    "Device": "KYV44",
    "Model": "KYV44_u"
  },
  {
    "Retail Branding": "Kyocera",
    "Marketing Name": "Qua tab 01",
    "Device": "KYT31",
    "Model": "KYT31"
  },
  {
    "Retail Branding": "Kyocera",
    "Marketing Name": "Qua tab QZ10",
    "Device": "KYT33",
    "Model": "KYT33"
  },
  {
    "Retail Branding": "Kyocera",
    "Marketing Name": "Qua tab QZ8",
    "Device": "KYT32",
    "Model": "KYT32"
  },
  {
    "Retail Branding": "Kyocera",
    "Marketing Name": "Rise",
    "Device": "C5155",
    "Model": "C5155"
  },
  {
    "Retail Branding": "Kyocera",
    "Marketing Name": "Rise",
    "Device": "C5156",
    "Model": "Rise"
  },
  {
    "Retail Branding": "Kyocera",
    "Marketing Name": "S301",
    "Device": "KC-S301AE",
    "Model": "KC-S301AE"
  },
  {
    "Retail Branding": "Kyocera",
    "Marketing Name": "S4",
    "Device": "S4-KC_sprout",
    "Model": "S4-KC"
  },
  {
    "Retail Branding": "Kyocera",
    "Marketing Name": "S6",
    "Device": "S6-KC_sprout",
    "Model": "S6-KC"
  },
  {
    "Retail Branding": "Kyocera",
    "Marketing Name": "S8",
    "Device": "S8-KC_sprout",
    "Model": "S8-KC"
  },
  {
    "Retail Branding": "Kyocera",
    "Marketing Name": "SZJ201",
    "Device": "SZJ201",
    "Model": "SZJ-JS201"
  },
  {
    "Retail Branding": "Kyocera",
    "Marketing Name": "TORQUE",
    "Device": "KC-100S",
    "Model": "KC-100S"
  },
  {
    "Retail Branding": "Kyocera",
    "Marketing Name": "TORQUE",
    "Device": "SKT01",
    "Model": "SKT01"
  },
  {
    "Retail Branding": "Kyocera",
    "Marketing Name": "TORQUE G01",
    "Device": "KYY24",
    "Model": "KYY24"
  },
  {
    "Retail Branding": "Kyocera",
    "Marketing Name": "TORQUE G02",
    "Device": "KYV35",
    "Model": "KYV35"
  },
  {
    "Retail Branding": "Kyocera",
    "Marketing Name": "TORQUE G03",
    "Device": "KYV41",
    "Model": "KYV41"
  },
  {
    "Retail Branding": "Kyocera",
    "Marketing Name": "TORQUE G04",
    "Device": "KYV46",
    "Model": "KYV46"
  },
  {
    "Retail Branding": "Kyocera",
    "Marketing Name": "TORQUE G06",
    "Device": "KY23M-RG100",
    "Model": "KYG03"
  },
  {
    "Retail Branding": "Kyocera",
    "Marketing Name": "TORQUE G07",
    "Device": "KY25M-RG100",
    "Model": "KYG06"
  },
  {
    "Retail Branding": "Kyocera",
    "Marketing Name": "TORQUE(KC-S701)",
    "Device": "KC-S701",
    "Model": "KC-S701"
  },
  {
    "Retail Branding": "Kyocera",
    "Marketing Name": "TORQUE(R) 5G",
    "Device": "KYG01",
    "Model": "KYG01"
  },
  {
    "Retail Branding": "Kyocera",
    "Marketing Name": "Torque",
    "Device": "E6710",
    "Model": "Torque"
  },
  {
    "Retail Branding": "Kyocera",
    "Marketing Name": "TorqueXT",
    "Device": "E6715",
    "Model": "E6715"
  },
  {
    "Retail Branding": "Kyocera",
    "Marketing Name": "URBANO L01",
    "Device": "KYY21",
    "Model": "KYY21"
  },
  {
    "Retail Branding": "Kyocera",
    "Marketing Name": "URBANO L02",
    "Device": "KYY22",
    "Model": "KYY22"
  },
  {
    "Retail Branding": "Kyocera",
    "Marketing Name": "URBANO L03",
    "Device": "KYY23",
    "Model": "KYY23"
  },
  {
    "Retail Branding": "Kyocera",
    "Marketing Name": "URBANO PROGRESSO",
    "Device": "KYY04",
    "Model": "URBANO PROGRESSO"
  },
  {
    "Retail Branding": "Kyocera",
    "Marketing Name": "URBANO V01",
    "Device": "KYV31",
    "Model": "KYV31"
  },
  {
    "Retail Branding": "Kyocera",
    "Marketing Name": "URBANO V02",
    "Device": "KYV34",
    "Model": "KYV34"
  },
  {
    "Retail Branding": "Kyocera",
    "Marketing Name": "URBANO V03",
    "Device": "KYV38",
    "Model": "KYV38"
  },
  {
    "Retail Branding": "Kyocera",
    "Marketing Name": "URBANO V04",
    "Device": "KYV45",
    "Model": "KYV45"
  },
  {
    "Retail Branding": "Kyocera",
    "Marketing Name": "WX10K",
    "Device": "WX10K",
    "Model": "WX10K"
  },
  {
    "Retail Branding": "Kyocera",
    "Marketing Name": "X3",
    "Device": "X3-KC_sprout",
    "Model": "X3-KC"
  },
  {
    "Retail Branding": "Kyocera",
    "Marketing Name": "Zio",
    "Device": "SCP-8600",
    "Model": "Zio"
  },
  {
    "Retail Branding": "Kyocera",
    "Marketing Name": "mamorino 5",
    "Device": "KYF40",
    "Model": "KYF40"
  },
  {
    "Retail Branding": "Kyocera",
    "Marketing Name": "miraie",
    "Device": "KYL23",
    "Model": "KYL23"
  },
  {
    "Retail Branding": "Kyocera",
    "Marketing Name": "miraie f",
    "Device": "KYV39",
    "Model": "KYV39"
  },
  {
    "Retail Branding": "Kyocera",
    "Marketing Name": "rafre",
    "Device": "KYV40",
    "Model": "KYV40"
  },
  {
    "Retail Branding": "Kyocera",
    "Marketing Name": "zio",
    "Device": "msm7627_kb60",
    "Model": "Zio"
  },
  {
    "Retail Branding": "Kyocera",
    "Marketing Name": "zio",
    "Device": "msm7627_surf",
    "Model": "Zio"
  },
  {
    "Retail Branding": "Kyocera",
    "Marketing Name": "zio",
    "Device": "pls8600",
    "Model": "Zio"
  },
  {
    "Retail Branding": "Kyocera",
    "Marketing Name": "あんしんスマホ",
    "Device": "KY-51B",
    "Model": "KY-51B"
  },
  {
    "Retail Branding": "Kyocera",
    "Marketing Name": "おてがるスマホ01",
    "Device": "KYV44_u2",
    "Model": "KYV44_u2"
  },
  {
    "Retail Branding": "Kyocera",
    "Marketing Name": "かんたんスマホ2+",
    "Device": "A201KC",
    "Model": "A201KC"
  },
  {
    "Retail Branding": "Kyocera",
    "Marketing Name": "かんたんスマホ3",
    "Device": "KY22L-SN300",
    "Model": "A205KC"
  },
  {
    "Retail Branding": "Kyocera",
    "Marketing Name": "かんたんスマホ２",
    "Device": "A001KC",
    "Model": "A001KC"
  },
  {
    "Retail Branding": "Kyowon",
    "Marketing Name": "All&G PAD",
    "Device": "mypad2",
    "Model": "KA-E410W"
  },
  {
    "Retail Branding": "Kzen",
    "Marketing Name": "Eva_E01",
    "Device": "Eva_E01",
    "Model": "Eva_E01"
  },
  {
    "Retail Branding": "Kzen",
    "Marketing Name": "Lamia_L01",
    "Device": "Lamia_L01",
    "Model": "Lamia L01"
  },
  {
    "Retail Branding": "LAGENIO",
    "Marketing Name": "A10_EEA",
    "Device": "A10",
    "Model": "A10"
  },
  {
    "Retail Branding": "LAGENIO",
    "Marketing Name": "A10_Pro_EEA",
    "Device": "A10_Pro",
    "Model": "A10 Pro"
  },
  {
    "Retail Branding": "LAGENIO",
    "Marketing Name": "A11_Pro_EEA",
    "Device": "A11_Pro",
    "Model": "A11 Pro"
  },
  {
    "Retail Branding": "LAGENIO",
    "Marketing Name": "A11_V_EEA",
    "Device": "A11",
    "Model": "A11"
  },
  {
    "Retail Branding": "LAGENIO",
    "Marketing Name": "A12_EEA",
    "Device": "A12",
    "Model": "A12"
  },
  {
    "Retail Branding": "LAGENIO",
    "Marketing Name": "A12_Pro_EEA",
    "Device": "A12_Pro",
    "Model": "A12 Pro"
  },
  {
    "Retail Branding": "LAGENIO",
    "Marketing Name": "Panther1_EEA",
    "Device": "Panther1",
    "Model": "Panther1"
  },
  {
    "Retail Branding": "LAGENIO",
    "Marketing Name": "Panther2_EEA",
    "Device": "Panther2",
    "Model": "Panther2"
  },
  {
    "Retail Branding": "LAGENIO",
    "Marketing Name": "Panther2_Pro_EEA",
    "Device": "Panther2_Pro",
    "Model": "Panther2 Pro"
  },
  {
    "Retail Branding": "LAGENIO",
    "Marketing Name": "Rhino 1 Pro",
    "Device": "Rhino_1_Pro",
    "Model": "Rhino 1 Pro"
  },
  {
    "Retail Branding": "LAMINA",
    "Marketing Name": "LTT8A4G_EEA",
    "Device": "LTT8A4G_EEA",
    "Model": "LTT8A4G"
  },
  {
    "Retail Branding": "LAMZIEN",
    "Marketing Name": "LAMZIEN_P2",
    "Device": "LAMZIEN_P2",
    "Model": "LAMZIEN_P2"
  },
  {
    "Retail Branding": "LANDI",
    "Marketing Name": "C20Pro",
    "Device": "AN-LFC",
    "Model": "C20Pro"
  },
  {
    "Retail Branding": "LANDI",
    "Marketing Name": "C20ProN00",
    "Device": "C20Pro-G-00",
    "Model": "C20Pro"
  },
  {
    "Retail Branding": "LANDI",
    "Marketing Name": "C20ProSE",
    "Device": "AN-LFC",
    "Model": "C20ProSE"
  },
  {
    "Retail Branding": "LANDI",
    "Marketing Name": "M10SE",
    "Device": "M10SE",
    "Model": "M10SE"
  },
  {
    "Retail Branding": "LANDI",
    "Marketing Name": "M20",
    "Device": "M20",
    "Model": "M20"
  },
  {
    "Retail Branding": "LANDI",
    "Marketing Name": "M20SE",
    "Device": "M20SE",
    "Model": "M20SE"
  },
  {
    "Retail Branding": "LANDI",
    "Marketing Name": "M50SEN00",
    "Device": "M50SE-G-00",
    "Model": "M50SE"
  },
  {
    "Retail Branding": "LANDI",
    "Marketing Name": "P30TN00",
    "Device": "P30T-G-00",
    "Model": "P30 Tablet"
  },
  {
    "Retail Branding": "LANDI",
    "Marketing Name": "P9",
    "Device": "P9",
    "Model": "P9"
  },
  {
    "Retail Branding": "LANDI",
    "Marketing Name": "Pad6plus",
    "Device": "Pad6plus",
    "Model": "Pad6plus"
  },
  {
    "Retail Branding": "LARVAND",
    "Marketing Name": "M863TabH8",
    "Device": "M863TabH8",
    "Model": "M863TabH8"
  },
  {
    "Retail Branding": "LARVAND",
    "Marketing Name": "M863TabH8",
    "Device": "M863TabH8",
    "Model": "TabH8"
  },
  {
    "Retail Branding": "LAUNCH",
    "Marketing Name": "Diagnostic_Device",
    "Device": "Diagnostic_Device",
    "Model": "AI_System_EN_P13_03"
  },
  {
    "Retail Branding": "LAUNCH",
    "Marketing Name": "Diagnostic_PDV5",
    "Device": "Diagnostic_PDV5",
    "Model": "AI_System_EN_P10_04_EU"
  },
  {
    "Retail Branding": "LAUNCH",
    "Marketing Name": "Diagnostic_PRO3SV6",
    "Device": "Diagnostic_PRO3SV6",
    "Model": "AI_System_EN_PO10_06"
  },
  {
    "Retail Branding": "LAUNCH",
    "Marketing Name": "Diagnostic_Tablet",
    "Device": "Diagnostic_Tablet",
    "Model": "AI_System_EN_P13_02"
  },
  {
    "Retail Branding": "LAUNCH",
    "Marketing Name": "Diagnostic_Tool",
    "Device": "Diagnostic_Tool",
    "Model": "AI_System_EN_P10_04"
  },
  {
    "Retail Branding": "LAUNCH",
    "Marketing Name": "X-431 PAD VII",
    "Device": "X-431PADVII",
    "Model": "AI System EN P133-01"
  },
  {
    "Retail Branding": "LAZOR",
    "Marketing Name": "InfinityT10101",
    "Device": "InfinityT10101",
    "Model": "InfinityT10101"
  },
  {
    "Retail Branding": "LBQ (UK)",
    "Marketing Name": "LbQ-F10v2",
    "Device": "LbQ-F10v2",
    "Model": "K102L"
  },
  {
    "Retail Branding": "LBQ (UK)",
    "Marketing Name": "LbQ_F8v2",
    "Device": "LbQ_F8v2",
    "Model": "LbQ-F8v2"
  },
  {
    "Retail Branding": "LEADER",
    "Marketing Name": "LEADER 2K Android TV",
    "Device": "lasalle",
    "Model": "LEADER 2K Android TV"
  },
  {
    "Retail Branding": "LEADER",
    "Marketing Name": "LEADER 4K Android TV",
    "Device": "kenton",
    "Model": "LEADER 4K Android TV"
  },
  {
    "Retail Branding": "LEGEND",
    "Marketing Name": "ACE_I",
    "Device": "ACE_I",
    "Model": "ACE_I"
  },
  {
    "Retail Branding": "LEGEND",
    "Marketing Name": "IPF10",
    "Device": "IPF10",
    "Model": "IPF10"
  },
  {
    "Retail Branding": "LEGEND",
    "Marketing Name": "J10PRO",
    "Device": "J10PRO",
    "Model": "J10PRO"
  },
  {
    "Retail Branding": "LEGEND",
    "Marketing Name": "NEBULAE",
    "Device": "NEBULAE",
    "Model": "NEBULAE"
  },
  {
    "Retail Branding": "LEGEND",
    "Marketing Name": "X701",
    "Device": "LEGEND_X701",
    "Model": "X701"
  },
  {
    "Retail Branding": "LENIX",
    "Marketing Name": "LENIX Pro",
    "Device": "LENIX_Pro",
    "Model": "LENIX Pro"
  },
  {
    "Retail Branding": "LENIX",
    "Marketing Name": "LENIX Standard",
    "Device": "LENIX_Standard",
    "Model": "LENIX Standard"
  },
  {
    "Retail Branding": "LEOMO",
    "Marketing Name": "LEM-TS1",
    "Device": "LMS",
    "Model": "LEM-TS1"
  },
  {
    "Retail Branding": "LEVEL TV",
    "Marketing Name": "Smart TV",
    "Device": "osaki",
    "Model": "2K AI Smart TV"
  },
  {
    "Retail Branding": "LEVIRTU",
    "Marketing Name": "M128-EEA",
    "Device": "M128-EEA",
    "Model": "M128-EEA"
  },
  {
    "Retail Branding": "LEVIRTU",
    "Marketing Name": "M309-EEA",
    "Device": "M309-EEA",
    "Model": "M309-EEA"
  },
  {
    "Retail Branding": "LEVIRTU",
    "Marketing Name": "M893-EEA",
    "Device": "M893-EEA",
    "Model": "M893-EEA"
  },
  {
    "Retail Branding": "LEXA",
    "Marketing Name": "Uruguay",
    "Device": "nagata",
    "Model": "LEXA SMART 2K TV"
  },
  {
    "Retail Branding": "LEYO",
    "Marketing Name": "EY-TAB8161G",
    "Device": "EY-TAB8161G",
    "Model": "EY-TAB8161G"
  },
  {
    "Retail Branding": "LG HelloVision",
    "Marketing Name": "K1100UA",
    "Device": "K1100UA",
    "Model": "K1100UA"
  },
  {
    "Retail Branding": "LG HelloVision",
    "Marketing Name": "K1200UA",
    "Device": "K1200UA",
    "Model": "K1200UA"
  },
  {
    "Retail Branding": "LG HelloVision",
    "Marketing Name": "T1100UA",
    "Device": "uce4027cjh",
    "Model": "T1100UA"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "",
    "Device": "AS855",
    "Model": "LG-AS855"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "",
    "Device": "LGP970",
    "Model": "LG-P970"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "",
    "Device": "US855",
    "Model": "USCC-US855"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "",
    "Device": "alessi",
    "Model": "LG-E720"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "",
    "Device": "alessi",
    "Model": "LG-E720b"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "",
    "Device": "alohag_302-220",
    "Model": "LG-C710h"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "",
    "Device": "black",
    "Model": "LG-KU5900"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "",
    "Device": "bproj_214-07",
    "Model": "LG-P970"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "",
    "Device": "bproj_222-88",
    "Model": "LG-P970"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "",
    "Device": "bproj_226-10",
    "Model": "LG-P970"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "",
    "Device": "bproj_228-03",
    "Model": "LG-P970"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "",
    "Device": "bproj_231-01",
    "Model": "LG-P970"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "",
    "Device": "bproj_232-05",
    "Model": "LG-P970"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "",
    "Device": "bproj_234-33",
    "Model": "LG-P970"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "",
    "Device": "bproj_260-03",
    "Model": "LG-P970"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "",
    "Device": "bproj_454-xxx",
    "Model": "LG-P970"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "",
    "Device": "bproj_530-XXX",
    "Model": "LG-P970"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "",
    "Device": "bproj_BAL-xxx",
    "Model": "LG-P970"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "",
    "Device": "bproj_OPEN-CN",
    "Model": "LG-P970"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "",
    "Device": "bproj_VDF-XXX",
    "Model": "LG-P970"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "",
    "Device": "cosmo_268-06",
    "Model": "LG-P920"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "",
    "Device": "cosmo_302-720",
    "Model": "LG-P925g"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "",
    "Device": "cosmo_454-XXX",
    "Model": "LG-P920"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "",
    "Device": "cosmo_466-92",
    "Model": "LG-P920"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "",
    "Device": "cosmo_505-XXX",
    "Model": "LG-P920"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "",
    "Device": "cosmo_515-XXX",
    "Model": "LG-P920"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "",
    "Device": "cosmo_525-01",
    "Model": "LG-P920"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "",
    "Device": "cosmo_525-05",
    "Model": "LG-P920"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "",
    "Device": "cosmo_724-02",
    "Model": "LG-P920h"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "",
    "Device": "cosmo_724-05",
    "Model": "LG-P920h"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "",
    "Device": "cosmo_724-xxx",
    "Model": "LG-P920h"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "",
    "Device": "cosmo_BAL-XXX",
    "Model": "LG-P920"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "",
    "Device": "cosmo_CIS-XXX",
    "Model": "LG-P920"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "",
    "Device": "cosmo_ESA-XXX",
    "Model": "LG-P920"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "",
    "Device": "cosmo_H3G-XXX",
    "Model": "LG-P920"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "",
    "Device": "cosmo_MOR-XXX",
    "Model": "LG-P920"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "",
    "Device": "cosmo_OPEN-CN",
    "Model": "LG-P920"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "",
    "Device": "cosmo_OPT-XXX",
    "Model": "LG-P920"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "",
    "Device": "cosmo_TMO-XXX",
    "Model": "LG-P920"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "",
    "Device": "cosmo_VDF-XXX",
    "Model": "LG-P920"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "",
    "Device": "cosmo_tcl-mx",
    "Model": "LG-P920h"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "",
    "Device": "cosmo_viv-br",
    "Model": "LG-P920h"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "",
    "Device": "e510_724-XX",
    "Model": "LG-E510f"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "",
    "Device": "envt2",
    "Model": "USCC-US760"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "",
    "Device": "envt2",
    "Model": "VS761"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "",
    "Device": "envt2",
    "Model": "enV Pro"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "",
    "Device": "envt2",
    "Model": "enV Touch2"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "",
    "Device": "gelato_262-xx",
    "Model": "LG-P690"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "",
    "Device": "gelato_425-02",
    "Model": "LG-P690f"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "",
    "Device": "gelato_460-xx",
    "Model": "LG-P690"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "",
    "Device": "gelato_460-xx",
    "Model": "LG-P693"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "",
    "Device": "gelato_are-xx",
    "Model": "LG-P690"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "",
    "Device": "gelato_bal-xx",
    "Model": "LG-P690"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "",
    "Device": "gelato_hkg-xx",
    "Model": "LG-P690"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "",
    "Device": "gelato_mor-xx",
    "Model": "LG-P690"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "",
    "Device": "gelato_nfc_234-10",
    "Model": "LG-P692"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "",
    "Device": "gelato_nfc_530-24",
    "Model": "LG-P692"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "",
    "Device": "gelato_nfc_tim-it",
    "Model": "LG-P692"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "",
    "Device": "gelato_ngr-xx",
    "Model": "LG-P690"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "",
    "Device": "gelato_sgp-xx",
    "Model": "LG-P690"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "",
    "Device": "gelato_tmb-sk",
    "Model": "LG-P690"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "",
    "Device": "gelato_tur-xx",
    "Model": "LG-P690"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "",
    "Device": "gelato_win-it",
    "Model": "LG-P690"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "",
    "Device": "gelatods_bal-xxx",
    "Model": "LG-P698"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "",
    "Device": "gelatods_ngr-xxx",
    "Model": "LG-P698"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "",
    "Device": "gelatods_open-xx",
    "Model": "LG-P698"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "",
    "Device": "gelatods_tha-xxx",
    "Model": "LG-P698f"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "",
    "Device": "hub",
    "Model": "LG-LU3000"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "",
    "Device": "ku9500",
    "Model": "KU9500"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "",
    "Device": "l95g",
    "Model": "LG-L95G"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "",
    "Device": "ls700",
    "Model": "LG-LS700"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "",
    "Device": "lu2300",
    "Model": "LU2300"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "",
    "Device": "lu3100",
    "Model": "LG-LU3100"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "",
    "Device": "msm8660_surf",
    "Model": "LG-LU6200"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "",
    "Device": "p2",
    "Model": "LG-P940h"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "",
    "Device": "p925g",
    "Model": "LG-P925g"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "",
    "Device": "p940",
    "Model": "LG-P940"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "",
    "Device": "p990_208-10",
    "Model": "LG-P990"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "",
    "Device": "p990_214-01",
    "Model": "LG-P990"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "",
    "Device": "p990_219-10",
    "Model": "LG-P990"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "",
    "Device": "p990_226-01",
    "Model": "LG-P990"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "",
    "Device": "p990_228-01",
    "Model": "LG-P990"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "",
    "Device": "p990_234-xx",
    "Model": "LG-P990"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "",
    "Device": "p990_262-02",
    "Model": "LG-P990"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "",
    "Device": "p990_454-xxx",
    "Model": "LG-P990"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "",
    "Device": "p990_466-92",
    "Model": "LG-P990"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "",
    "Device": "p990_466-xxx",
    "Model": "LG-P990"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "",
    "Device": "p990_505-xxx",
    "Model": "LG-P990"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "",
    "Device": "p990_525-01",
    "Model": "LG-P990"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "",
    "Device": "p990_525-05",
    "Model": "LG-P990"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "",
    "Device": "p990_BAL-xxx",
    "Model": "LG-P990"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "",
    "Device": "p990_esa-xxx",
    "Model": "LG-P990"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "",
    "Device": "p990h",
    "Model": "LG-P990h"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "",
    "Device": "p990h_334-020",
    "Model": "LG-P990h"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "",
    "Device": "p990h_716-10",
    "Model": "LG-P990h"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "",
    "Device": "p990h_722-34",
    "Model": "LG-P990h"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "",
    "Device": "p990h_724-05",
    "Model": "LG-P990h"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "",
    "Device": "p990h_730-01",
    "Model": "LG-P990h"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "",
    "Device": "p990h_730-03",
    "Model": "LG-P990h"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "",
    "Device": "p990h_CTM-xxx",
    "Model": "LG-P990h"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "",
    "Device": "p990h_SSV-xxx",
    "Model": "LG-P990h"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "",
    "Device": "p993",
    "Model": "LG-P993"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "",
    "Device": "star",
    "Model": "LG-P990hN"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "",
    "Device": "univa_228-01",
    "Model": "LG-E510"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "",
    "Device": "univa_454-xx",
    "Model": "LG-E510"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "",
    "Device": "univa_525-01",
    "Model": "LG-E510"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "",
    "Device": "univa_525-05",
    "Model": "LG-E510"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "",
    "Device": "univa_722-34",
    "Model": "LG-E510g"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "",
    "Device": "univa_bal-xxx",
    "Model": "LG-E510"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "",
    "Device": "univa_neu-xx",
    "Model": "LG-E510"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "",
    "Device": "univa_open_cn",
    "Model": "LG-E510"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "",
    "Device": "univa_tha-xx",
    "Model": "LG-E510f"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "",
    "Device": "univa_tmo-gr",
    "Model": "LG-E510"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "",
    "Device": "univa_vdf-es",
    "Model": "LG-E510"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "",
    "Device": "v900aus",
    "Model": "LG-V900"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "",
    "Device": "v901twn",
    "Model": "LG-V901"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "",
    "Device": "x2_450-08",
    "Model": "LG-KU8800"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "",
    "Device": "x3",
    "Model": "LG-P880"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "070 touch",
    "Device": "w3voip",
    "Model": "LG-FL40L"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "10SM3TB",
    "Device": "lg_10sm3tb",
    "Model": "10sm3tb"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "AKA",
    "Device": "aka",
    "Model": "LG-F520L"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "AKA",
    "Device": "aka",
    "Model": "LG-F520S"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "AKA",
    "Device": "aka",
    "Model": "LG-H788"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Ally",
    "Device": "aloha",
    "Model": "AS740"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Ally",
    "Device": "aloha",
    "Model": "Ally"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Ally",
    "Device": "aloha",
    "Model": "Aloha"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Ally",
    "Device": "aloha",
    "Model": "US740"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Android TV",
    "Device": "cosmo",
    "Model": "LG Google TV"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Android TV",
    "Device": "eden",
    "Model": "LG Android TV V4"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Android TV",
    "Device": "eden",
    "Model": "LG Google TV G3"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Android TV",
    "Device": "eden",
    "Model": "LG Google TV G3 KR"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Android TV G3",
    "Device": "eden",
    "Model": "LG Google TV G3"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Aristo 4+",
    "Device": "mh5lm",
    "Model": "LM-X320"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "B6",
    "Device": "b6",
    "Model": "LG-V426"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "B6",
    "Device": "b6",
    "Model": "LGT02"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "DM-01G",
    "Device": "DM-01G",
    "Model": "DM-01G"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "DM-01K",
    "Device": "DM-01K",
    "Model": "DM-01K"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "DM-02H",
    "Device": "DM-02H",
    "Model": "DM-02H"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Enact",
    "Device": "fx3q",
    "Model": "VS890 4G"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Escape",
    "Device": "l1a",
    "Model": "LG-P870"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Eve",
    "Device": "EVE",
    "Model": "GW620"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Eve",
    "Device": "EVE",
    "Model": "LG GW620"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Eve",
    "Device": "EVE",
    "Model": "LG GW620F"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Eve",
    "Device": "EVE",
    "Model": "LG GW620R"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Eve",
    "Device": "EVE",
    "Model": "LG GW620g"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Eve",
    "Device": "EVE",
    "Model": "LG KH5200"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Eve",
    "Device": "EVE",
    "Model": "LG-GW620"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Eve",
    "Device": "EVE",
    "Model": "LG-KH5200"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "F60",
    "Device": "e2",
    "Model": "LG-D390"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "F60",
    "Device": "e2",
    "Model": "LG-D390AR"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "F60",
    "Device": "e2ds",
    "Model": "LG-D392"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "F60",
    "Device": "e2n",
    "Model": "LG-D390n"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "F60",
    "Device": "e2nac",
    "Model": "LG-D393"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "F60",
    "Device": "e2nam",
    "Model": "LGMS395"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "F60",
    "Device": "e2nas",
    "Model": "LGLS660"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "F60",
    "Device": "e2nav",
    "Model": "VS810PP"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "F70",
    "Device": "f70",
    "Model": "LGL31L"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Fortune",
    "Device": "lv1",
    "Model": "LG-M153"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Fortune",
    "Device": "lv1",
    "Model": "LG-M154"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Fortune 2",
    "Device": "cv1",
    "Model": "LM-X210CM"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Fortune 2",
    "Device": "cv1",
    "Model": "LM-X210CMR"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "G PADⅢ 10.1",
    "Device": "th10",
    "Model": "LG-X760"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "G PADⅢ 10.1",
    "Device": "th10",
    "Model": "LG-X760E"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "G PADⅢ 10.1",
    "Device": "th10",
    "Model": "LG-X760W"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "G Pad 10.1",
    "Device": "e9wifi",
    "Model": "LG-V700"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "G Pad 10.1",
    "Device": "e9wifin",
    "Model": "LG-V700WJ"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "G Pad 10.1",
    "Device": "e9wifin",
    "Model": "LG-V700n"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "G Pad 10.1 LTE",
    "Device": "e9lte",
    "Model": "LG-VK700"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "G Pad 10.1 LTE",
    "Device": "e9lte",
    "Model": "VK700"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "G Pad 5 10.1 FHD",
    "Device": "tf10",
    "Model": "LM-T600"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "G Pad 5 10.1 FHD",
    "Device": "tf10",
    "Model": "LM-T600L"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "G Pad 5 10.1 FHD",
    "Device": "tf10w",
    "Model": "LM-T605"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "G Pad 7.0",
    "Device": "e7wifi",
    "Model": "LG-V400"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "G Pad 7.0",
    "Device": "e7wifi",
    "Model": "LG-V400S1"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "G Pad 7.0",
    "Device": "e7wifi",
    "Model": "LG-V400Y1"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "G Pad 7.0",
    "Device": "e7wifi",
    "Model": "LG-V400Y7"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "G Pad 7.0 LTE",
    "Device": "e7lte",
    "Model": "LG-V410"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "G Pad 7.0 LTE",
    "Device": "e7lte",
    "Model": "LG-V411"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "G Pad 7.0 LTE",
    "Device": "e7lte",
    "Model": "LGUK410"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "G Pad 8+",
    "Device": "altev2",
    "Model": "AK815"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "G Pad 8.0",
    "Device": "e8wifi",
    "Model": "LG-V480"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "G Pad II 8.0",
    "Device": "t8wifi",
    "Model": "LG-V498"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "G Pad II 8.0",
    "Device": "t8wifi",
    "Model": "LG-V498S1"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "G Pad II 8.0",
    "Device": "t8wifi",
    "Model": "LG-V498S2"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "G Pad III 8.0 Homeboy",
    "Device": "b6",
    "Model": "LG-P451L"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "G Pad Ⅱ 10.1",
    "Device": "t1lte",
    "Model": "LGUK932"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "G Pad Ⅱ 10.1 FHD 4G LTE",
    "Device": "t1lte",
    "Model": "LG-V935"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "G Pad Ⅱ 10.1 FHD 4G LTE",
    "Device": "t1lte",
    "Model": "LG-V935T"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "G Pro Lite",
    "Device": "luv90ds",
    "Model": "LG-D685"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "G Pro Lite",
    "Device": "luv90ds",
    "Model": "LG-D686"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "G Pro Lite",
    "Device": "luv90nfc",
    "Model": "LG-D683"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "G Pro Lite",
    "Device": "luv90nfc",
    "Model": "LG-D684"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "G Pro Lite",
    "Device": "luv90ss",
    "Model": "LG-D680"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "G Pro Lite",
    "Device": "luv90ss",
    "Model": "LG-D681"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "G Pro Lite",
    "Device": "luv90ss",
    "Model": "LG-D682"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "G Pro Lite",
    "Device": "luv90ss",
    "Model": "LG-D682TR"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "G Pro2",
    "Device": "b1",
    "Model": "LG-F350K"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "G Pro2",
    "Device": "b1",
    "Model": "LG-F350L"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "G Pro2",
    "Device": "b1",
    "Model": "LG-F350S"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "G Pro2",
    "Device": "b1w",
    "Model": "LG-D838"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "G Stylo",
    "Device": "g4stylusw",
    "Model": "LG-F560K"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "G Vista",
    "Device": "b2lds",
    "Model": "LG-D690"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "G Vista",
    "Device": "x10",
    "Model": "VS880"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "G Vista",
    "Device": "x10",
    "Model": "VS880PP"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "G Watch",
    "Device": "dory",
    "Model": "G Watch"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "G Watch R",
    "Device": "lenok",
    "Model": "G Watch R"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "G pad 8.0",
    "Device": "e8wifi",
    "Model": "LG-V480"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "G pad 8.0 LTE",
    "Device": "e8lte",
    "Model": "LG-V490"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "G2 MINI",
    "Device": "g2m",
    "Model": "LG-D620"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "G2 MINI",
    "Device": "g2mds",
    "Model": "LG-D618"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "G2 MINI",
    "Device": "g2mss",
    "Model": "LG-D610"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "G2 MINI",
    "Device": "g2mss",
    "Model": "LG-D610AR"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "G2 MINI",
    "Device": "g2mss",
    "Model": "LG-D610TR"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "G2 MINI",
    "Device": "g2mv",
    "Model": "LG-D625"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "G2 mini 4G LTE",
    "Device": "g2mv",
    "Model": "LG-D625"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "G3 Beat",
    "Device": "jagdsnm",
    "Model": "LG-D726"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "G3 Beat",
    "Device": "jagdsnm",
    "Model": "LG-D728"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "G3 Beat",
    "Device": "jagdsnm",
    "Model": "LG-D729"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "G3 Beat",
    "Device": "jagn",
    "Model": "LG-F470K"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "G3 Beat",
    "Device": "jagn",
    "Model": "LG-F470L"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "G3 Beat",
    "Device": "jagn",
    "Model": "LG-F470S"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "G3 Beat",
    "Device": "jagnm",
    "Model": "LG-D722J"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "G3 Beat",
    "Device": "jagnm",
    "Model": "LG-D727"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "G3 S",
    "Device": "jag3gds",
    "Model": "LG-D724"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "G3 S",
    "Device": "jag3gss",
    "Model": "LG-D723"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "G3 S",
    "Device": "jagnm",
    "Model": "LG-D722"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "G3 S",
    "Device": "jagnm",
    "Model": "LG-D722AR"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "G3 S",
    "Device": "jagnm",
    "Model": "LG-D725PR"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "G3 Screen",
    "Device": "liger",
    "Model": "LG-F490L"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "G3 Stylus",
    "Device": "b2ldsn",
    "Model": "LG-D690n"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "G3 Stylus",
    "Device": "b2lss",
    "Model": "LG-D693"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "G3 Stylus",
    "Device": "b2lss",
    "Model": "LG-D693AR"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "G3 Stylus",
    "Device": "b2lss",
    "Model": "LG-D693TR"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "G3 Stylus",
    "Device": "b2lssn",
    "Model": "LG-D693n"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "G3 Vigor",
    "Device": "jagc",
    "Model": "LGLS885"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "G3 Vigor",
    "Device": "jagnm",
    "Model": "LG-D725"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "G6Fit",
    "Device": "lucye",
    "Model": "LM-Q850K"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "G6Fit",
    "Device": "lucye",
    "Model": "LM-Q850L"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "G6Fit",
    "Device": "lucye",
    "Model": "LM-Q850S"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "G7 fit",
    "Device": "falcon",
    "Model": "LM-Q850"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "G8S ThinQ",
    "Device": "betalm",
    "Model": "LM-G810"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "G8X ThinQ",
    "Device": "mh2lm",
    "Model": "901LG"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "G8X ThinQ",
    "Device": "mh2lm",
    "Model": "LM-G850"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "G8s",
    "Device": "betalm",
    "Model": "LM-G810"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "GA7800",
    "Device": "eden",
    "Model": "LG Android TV V4"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "GPAD 7.0 LTE",
    "Device": "e7lte",
    "Model": "VK410"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Gentle",
    "Device": "cf",
    "Model": "LG-F580L"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Gpad 7.0",
    "Device": "e7wifi",
    "Model": "LG-V400"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Gx2",
    "Device": "b2ln",
    "Model": "LG-F430L"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Homeboy2",
    "Device": "t8wi7u",
    "Model": "LG-V607L"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "I project",
    "Device": "blm",
    "Model": "LM-R910N"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Ice cream Smart",
    "Device": "vfpv",
    "Model": "LG-F440L"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Intuition",
    "Device": "batman_vzw",
    "Model": "VS950 4G"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "JOJO",
    "Device": "L-02K",
    "Model": "L-02K"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "K20",
    "Device": "lv517",
    "Model": "RS501"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "K22",
    "Device": "dh0lm",
    "Model": "LM-K200"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "K3 2017",
    "Device": "lv0",
    "Model": "LG-AS110"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "K3 2017",
    "Device": "lv0",
    "Model": "LGUS110"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "K30",
    "Device": "mh5lm-8m",
    "Model": "LM-X320"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "K32",
    "Device": "dh0lm",
    "Model": "LM-K200"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "K4",
    "Device": "lv1",
    "Model": "LG-M151"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "K4 (2017)",
    "Device": "lv1",
    "Model": "LGL157BL"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "K4 (2017)",
    "Device": "lv1",
    "Model": "LGL57BL"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "K42",
    "Device": "meh15lm",
    "Model": "LM-K420"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "K50S",
    "Device": "mmh45lm",
    "Model": "LM-X540"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "K51",
    "Device": "mdh30lm",
    "Model": "LGL555DL"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "K51",
    "Device": "mdh30lm",
    "Model": "LM-K500"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "K51",
    "Device": "mdh30xlm",
    "Model": "LM-K500"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "K51S",
    "Device": "mdh35lm",
    "Model": "LM-K510"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "K52",
    "Device": "meh35lm",
    "Model": "LM-K520"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "K61",
    "Device": "mdh40lm",
    "Model": "LM-Q630"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "K62",
    "Device": "meh35lm",
    "Model": "LM-K525"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "K62+",
    "Device": "meh35lm",
    "Model": "LM-K526"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "K71",
    "Device": "mdh50lm",
    "Model": "LM-Q730"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "K92",
    "Device": "acexlm",
    "Model": "LM-K920"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "L Bello",
    "Device": "luv80ds",
    "Model": "LG-D335"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "L Bello",
    "Device": "luv80ds",
    "Model": "LG-D335E"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "L Bello",
    "Device": "luv80ds",
    "Model": "LG-D337"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "L Fino",
    "Device": "l70p",
    "Model": "LG-D290"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "L Fino",
    "Device": "l70p",
    "Model": "LG-D290AR"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "L Fino",
    "Device": "l70pds",
    "Model": "LG-D295"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "L Fino",
    "Device": "l70pn",
    "Model": "LG-D290"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "L-01F",
    "Device": "g2",
    "Model": "L-01F"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "L-03K",
    "Device": "L-03K",
    "Model": "L-03K"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "L20",
    "Device": "luv20ds",
    "Model": "LG-D105"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "L20",
    "Device": "luv20ss",
    "Model": "LG-D100"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "L20",
    "Device": "luv20ss",
    "Model": "LG-D100AR"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "L20",
    "Device": "luv20ts",
    "Model": "LG-D107"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "L30 Sporty",
    "Device": "luv30ds",
    "Model": "LG-D125"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "L30 Sporty",
    "Device": "luv30ss",
    "Model": "LG-D120"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "L30 Sporty",
    "Device": "luv30ss",
    "Model": "LG-D120AR"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "L45",
    "Device": "lo_2",
    "Model": "LG-X130g"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "L45",
    "Device": "lo_2_ds",
    "Model": "LG-X132"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "L50 Sporty",
    "Device": "luv50ds",
    "Model": "LG-D221"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "L50 Sporty",
    "Device": "luv50ds",
    "Model": "LG-D227"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "L50 Sporty",
    "Device": "luv50ss",
    "Model": "LG-D213"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "L50 Sporty",
    "Device": "luv50ss",
    "Model": "LG-D213AR"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "L50 Sporty",
    "Device": "luv50ssn",
    "Model": "LG-D213"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "L5000",
    "Device": "l5000",
    "Model": "LG-F590"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "L60",
    "Device": "lo_1",
    "Model": "LG-X135"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "L60",
    "Device": "lo_1",
    "Model": "LG-X137"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "L60",
    "Device": "lo_1",
    "Model": "LG-X140"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "L60",
    "Device": "lo_1",
    "Model": "LG-X145"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "L60",
    "Device": "lo_1",
    "Model": "LG-X147"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "L65",
    "Device": "w55",
    "Model": "LG-D280"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "L65",
    "Device": "w55ds",
    "Model": "LG-D285"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "L65",
    "Device": "w55n",
    "Model": "LG-D280"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "L7 II",
    "Device": "vee7e",
    "Model": "LG-P712"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "L7 II",
    "Device": "vee7e",
    "Model": "LG-P714"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "L7 II Dual",
    "Device": "vee7ds",
    "Model": "LG-P716"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "L70",
    "Device": "w5",
    "Model": "LG-D320"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "L70",
    "Device": "w5",
    "Model": "LG-D320AR"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "L70",
    "Device": "w5",
    "Model": "LG-D321"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "L70",
    "Device": "w5",
    "Model": "LGAS323"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "L70",
    "Device": "w5",
    "Model": "LGMS323"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "L70",
    "Device": "w5c",
    "Model": "LGLS620"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "L70",
    "Device": "w5ds",
    "Model": "LG-D325"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "L70",
    "Device": "w5n",
    "Model": "LG-D320"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "L70",
    "Device": "w5n",
    "Model": "LG-D329"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "L70",
    "Device": "w5ts",
    "Model": "LG-D340f8"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "L70 CDMA",
    "Device": "w5c",
    "Model": "LGL41C"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "L80 Dual",
    "Device": "w6ds",
    "Model": "LG-D380"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "L80 Dual",
    "Device": "w6ds",
    "Model": "LG-D385"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "L80 Single",
    "Device": "w6",
    "Model": "LG-D370"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "L80 Single",
    "Device": "w6",
    "Model": "LG-D373"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "L80 Single",
    "Device": "w6",
    "Model": "LG-D375"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "L80 Single",
    "Device": "w6",
    "Model": "LG-D375AR"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "L90",
    "Device": "w7",
    "Model": "LG-D400"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "L90",
    "Device": "w7",
    "Model": "LG-D405"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "L90",
    "Device": "w7",
    "Model": "LG-D415"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "L90",
    "Device": "w7ds",
    "Model": "LG-D410"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "L90",
    "Device": "w7n",
    "Model": "LG-D400"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "L90",
    "Device": "w7n",
    "Model": "LG-D405"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "L90 Dual",
    "Device": "w7dsn",
    "Model": "LG-D410"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LBello",
    "Device": "luv80ss",
    "Model": "LG-D331"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LBello",
    "Device": "luv80ss",
    "Model": "LG-D331AR"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG AKA",
    "Device": "aka",
    "Model": "LG-H778"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG AKA",
    "Device": "aka",
    "Model": "LG-H779"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG AKA",
    "Device": "aka",
    "Model": "LG-H788"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG AKA",
    "Device": "aka",
    "Model": "LG-H788SG"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG AKA",
    "Device": "aka",
    "Model": "LG-H788TR"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG AKA",
    "Device": "aka",
    "Model": "LG-H788n"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Aristo",
    "Device": "lv3",
    "Model": "LGMS210"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Aristo 3",
    "Device": "cv1s",
    "Model": "LM-X220"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Aristo 3+",
    "Device": "cv1s",
    "Model": "LM-X220"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Bello II",
    "Device": "v10",
    "Model": "LG-X150"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Bello II",
    "Device": "v10",
    "Model": "LG-X155"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Bello II",
    "Device": "v10",
    "Model": "LG-X165g"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Bello II",
    "Device": "v10",
    "Model": "LG-X170g"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Class",
    "Device": "c100n",
    "Model": "LG-F620K"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Class",
    "Device": "c100n",
    "Model": "LG-F620L"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Class",
    "Device": "c100n",
    "Model": "LG-F620S"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Classic",
    "Device": "y30t",
    "Model": "LGL17AG"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Classic",
    "Device": "y30tc",
    "Model": "LGL18VC"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Connect 4G",
    "Device": "cayman",
    "Model": "LG-MS840"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG DOUBLEPLAY",
    "Device": "lgc729",
    "Model": "LG-C729"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Destiny",
    "Device": "y50",
    "Model": "LGL21G"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Enlighten",
    "Device": "VS700",
    "Model": "LG-VS700"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Enlighten",
    "Device": "VS700",
    "Model": "LG-VS700PP"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Escape 3",
    "Device": "m1v",
    "Model": "LG-K373"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Escape2",
    "Device": "c70n",
    "Model": "LG-H443"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Escape2",
    "Device": "c70n",
    "Model": "LG-H445"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Esteem",
    "Device": "MS910",
    "Model": "LG-MS910"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG F570S",
    "Device": "yg",
    "Model": "LG-F570S"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG F70",
    "Device": "f70n",
    "Model": "LG-D315"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG F70",
    "Device": "f70n",
    "Model": "LG-D315l"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG F70",
    "Device": "f70n",
    "Model": "LG-F370K"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG F70",
    "Device": "f70n",
    "Model": "LG-F370L"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG F70",
    "Device": "f70n",
    "Model": "LG-F370S"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Fiesta 2 LTE",
    "Device": "lv7",
    "Model": "LGL163BL"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Fiesta 2 LTE",
    "Device": "lv7",
    "Model": "LGL164VL"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Fiesta LTE",
    "Device": "lv7",
    "Model": "LGL63BL"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Fiesta LTE",
    "Device": "lv7",
    "Model": "LGL64VL"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG G Flex",
    "Device": "zee",
    "Model": "LG-D950"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG G Flex",
    "Device": "zee",
    "Model": "LG-D950G"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG G Flex",
    "Device": "zee",
    "Model": "LG-D951"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG G Flex",
    "Device": "zee",
    "Model": "LG-D955"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG G Flex",
    "Device": "zee",
    "Model": "LG-D956"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG G Flex",
    "Device": "zee",
    "Model": "LG-D958"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG G Flex",
    "Device": "zee",
    "Model": "LG-D959"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG G Flex",
    "Device": "zee",
    "Model": "LG-F340K"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG G Flex",
    "Device": "zee",
    "Model": "LG-F340L"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG G Flex",
    "Device": "zee",
    "Model": "LG-F340S"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG G Flex",
    "Device": "zee",
    "Model": "LG-LS995"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG G Flex",
    "Device": "zee",
    "Model": "LGL23"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG G Flex2",
    "Device": "z2",
    "Model": "LG-F510K"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG G Flex2",
    "Device": "z2",
    "Model": "LG-F510L"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG G Flex2",
    "Device": "z2",
    "Model": "LG-F510S"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG G Flex2",
    "Device": "z2",
    "Model": "LG-H950"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG G Flex2",
    "Device": "z2",
    "Model": "LG-H955"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG G Flex2",
    "Device": "z2",
    "Model": "LG-H959"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG G Flex2",
    "Device": "z2",
    "Model": "LGAS995"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG G Flex2",
    "Device": "z2",
    "Model": "LGLS996"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG G Flex2",
    "Device": "z2",
    "Model": "LGUS995"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG G Pad 8.0 L Edition",
    "Device": "e8lte",
    "Model": "LGT01"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG G Pad 8.0 LTE",
    "Device": "e8lte",
    "Model": "LG-P490L"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG G Pad 8.3",
    "Device": "awifi",
    "Model": "LG-V500"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG G Pad 8.3 Google Play Edition",
    "Device": "palman",
    "Model": "LG-V510"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG G Pad 8.3 LTE",
    "Device": "altev",
    "Model": "VK810 4G"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG G Pad 8.3 homeBoy",
    "Device": "awifi070u",
    "Model": "LG-V507L"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG G Pad F 8.0",
    "Device": "t8lte",
    "Model": "LG-AK495"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG G Pad F 8.0",
    "Device": "t8lte",
    "Model": "LG-UK495"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG G Pad F 8.0",
    "Device": "t8lte",
    "Model": "LG-V495"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG G Pad F 8.0",
    "Device": "t8lte",
    "Model": "LG-V496"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG G Pad F 8.0",
    "Device": "t8lte",
    "Model": "LG-V499"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG G Pad F2 8.0",
    "Device": "mth8",
    "Model": "LG-LK460"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG G Pad F7.0",
    "Device": "e7iilte",
    "Model": "LGLK430"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG G Pad F™ 8.0 2nd Gen",
    "Device": "t8lte",
    "Model": "LG-AK495"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG G Pad F™ 8.0 2nd Gen",
    "Device": "t8lte",
    "Model": "LG-UK495"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG G Pad II 10.1 FHD",
    "Device": "t1wifi",
    "Model": "LG-V940"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG G Pad II 10.1 FHD",
    "Device": "t1wifin",
    "Model": "LG-V940n"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG G Pad II 8.0LTE",
    "Device": "t8lte",
    "Model": "LG-V497"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG G Pad II 8.3",
    "Device": "altev2",
    "Model": "LG-P815L"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG G Pad III 10.1 FHD LTE",
    "Device": "b5",
    "Model": "LG-P755L"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG G Pad III 10.1 FHD LTE",
    "Device": "b5",
    "Model": "LG-V755"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG G Pad III 8.0",
    "Device": "b3",
    "Model": "LG-V522"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG G Pad III 8.0 FHD",
    "Device": "b3",
    "Model": "LG-V525"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG G Pad III 8.0 FHD",
    "Device": "b3",
    "Model": "LG-V525S1"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG G Pad III 8.0 FHD",
    "Device": "b3",
    "Model": "LG-V525S3"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG G Pad IV 8.0",
    "Device": "tf840",
    "Model": "LG-V533"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG G Pad IV 8.0 FHD LTE",
    "Device": "tf840",
    "Model": "LG-P530L"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG G Pad X 8.0",
    "Device": "b3",
    "Model": "LG-V521"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG G Pad X 8.3",
    "Device": "altev2",
    "Model": "VK815"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG G Pad X2 8.0 PLUS",
    "Device": "tf840",
    "Model": "LG-V530"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG G Pad X® II 10.1",
    "Device": "b5",
    "Model": "LGUK750"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG G Pad™ X 8.0",
    "Device": "b3",
    "Model": "LG-V520"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG G Stylo",
    "Device": "g4stylus",
    "Model": "LG-H634"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG G Stylo",
    "Device": "g4stylusc",
    "Model": "LGLS770"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG G Stylo",
    "Device": "g4stylusds",
    "Model": "LG-H630D"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG G Stylo",
    "Device": "g4stylusdsn",
    "Model": "LG-H630"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG G Stylo",
    "Device": "g4stylusn",
    "Model": "LG-H631"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG G Stylo",
    "Device": "g4stylusn",
    "Model": "LG-H631MX"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG G Stylo",
    "Device": "g4stylusn",
    "Model": "LG-H635"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG G Stylo",
    "Device": "g4stylusn",
    "Model": "LG-H635A"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG G Stylo",
    "Device": "g4stylusn",
    "Model": "LG-H636"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG G Stylo",
    "Device": "g4stylusn",
    "Model": "LGMS631"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG G Vista",
    "Device": "b2l",
    "Model": "LG-D631"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG G Vista 2",
    "Device": "p1v",
    "Model": "LG-H740"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG G2",
    "Device": "g2",
    "Model": "LG-D800"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG G2",
    "Device": "g2",
    "Model": "LG-D801"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG G2",
    "Device": "g2",
    "Model": "LG-D802"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG G2",
    "Device": "g2",
    "Model": "LG-D802T"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG G2",
    "Device": "g2",
    "Model": "LG-D802TR"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG G2",
    "Device": "g2",
    "Model": "LG-D803"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG G2",
    "Device": "g2",
    "Model": "LG-D805"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG G2",
    "Device": "g2",
    "Model": "LG-D806"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG G2",
    "Device": "g2",
    "Model": "LG-F320K"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG G2",
    "Device": "g2",
    "Model": "LG-F320L"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG G2",
    "Device": "g2",
    "Model": "LG-F320S"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG G2",
    "Device": "g2",
    "Model": "LG-LS980"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG G2",
    "Device": "g2",
    "Model": "VS980 4G"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG G3",
    "Device": "g3",
    "Model": "AS985"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG G3",
    "Device": "g3",
    "Model": "LG-AS990"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG G3",
    "Device": "g3",
    "Model": "LG-D850"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG G3",
    "Device": "g3",
    "Model": "LG-D851"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG G3",
    "Device": "g3",
    "Model": "LG-D852"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG G3",
    "Device": "g3",
    "Model": "LG-D852G"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG G3",
    "Device": "g3",
    "Model": "LG-D855"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG G3",
    "Device": "g3",
    "Model": "LG-D856"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG G3",
    "Device": "g3",
    "Model": "LG-D857"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG G3",
    "Device": "g3",
    "Model": "LG-D858"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG G3",
    "Device": "g3",
    "Model": "LG-D858HK"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG G3",
    "Device": "g3",
    "Model": "LG-D859"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG G3",
    "Device": "g3",
    "Model": "LG-F400K"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG G3",
    "Device": "g3",
    "Model": "LG-F400L"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG G3",
    "Device": "g3",
    "Model": "LG-F400S"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG G3",
    "Device": "g3",
    "Model": "LGL24"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG G3",
    "Device": "g3",
    "Model": "LGLS990"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG G3",
    "Device": "g3",
    "Model": "LGUS990"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG G3",
    "Device": "g3",
    "Model": "LGV31"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG G3",
    "Device": "g3",
    "Model": "VS985 4G"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG G3 A",
    "Device": "tigers",
    "Model": "LG-F410S"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG G3 Cat.6",
    "Device": "tiger6",
    "Model": "LG-F460K"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG G3 Cat.6",
    "Device": "tiger6",
    "Model": "LG-F460L"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG G3 Cat.6",
    "Device": "tiger6",
    "Model": "LG-F460S"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG G4",
    "Device": "p1",
    "Model": "AS986"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG G4",
    "Device": "p1",
    "Model": "LG-AS811"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG G4",
    "Device": "p1",
    "Model": "LG-AS991"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG G4",
    "Device": "p1",
    "Model": "LG-F500K"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG G4",
    "Device": "p1",
    "Model": "LG-F500L"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG G4",
    "Device": "p1",
    "Model": "LG-F500S"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG G4",
    "Device": "p1",
    "Model": "LG-H810"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG G4",
    "Device": "p1",
    "Model": "LG-H811"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG G4",
    "Device": "p1",
    "Model": "LG-H812"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG G4",
    "Device": "p1",
    "Model": "LG-H815"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG G4",
    "Device": "p1",
    "Model": "LG-H818"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG G4",
    "Device": "p1",
    "Model": "LG-H819"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG G4",
    "Device": "p1",
    "Model": "LGLS991"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG G4",
    "Device": "p1",
    "Model": "LGUS991"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG G4",
    "Device": "p1",
    "Model": "LGV32"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG G4",
    "Device": "p1",
    "Model": "VS986"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG G4 Beat",
    "Device": "p1bdsn",
    "Model": "LG-H736"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG G4 Beat",
    "Device": "p1bssn",
    "Model": "LG-H735"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG G4 Stylus",
    "Device": "mp1s3gds",
    "Model": "LG-H540"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG G4 Stylus",
    "Device": "mp1s3gss",
    "Model": "LG-H542"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG G4 vigor",
    "Device": "p1bssn",
    "Model": "LG-H731"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG G4c",
    "Device": "c90",
    "Model": "LG-H525"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG G4c",
    "Device": "c90n",
    "Model": "LG-H525n"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG G4s",
    "Device": "p1bds3g",
    "Model": "LG-H734"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG G5",
    "Device": "h1",
    "Model": "LG-F700K"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG G5",
    "Device": "h1",
    "Model": "LG-F700L"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG G5",
    "Device": "h1",
    "Model": "LG-F700S"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG G5",
    "Device": "h1",
    "Model": "LG-H820"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG G5",
    "Device": "h1",
    "Model": "LG-H820PR"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG G5",
    "Device": "h1",
    "Model": "LG-H830"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG G5",
    "Device": "h1",
    "Model": "LG-H831"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG G5",
    "Device": "h1",
    "Model": "LG-H850"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG G5",
    "Device": "h1",
    "Model": "LG-H858"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG G5",
    "Device": "h1",
    "Model": "LG-H860"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG G5",
    "Device": "h1",
    "Model": "LG-H868"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG G5",
    "Device": "h1",
    "Model": "LGAS992"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG G5",
    "Device": "h1",
    "Model": "LGLS992"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG G5",
    "Device": "h1",
    "Model": "LGUS992"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG G5",
    "Device": "h1",
    "Model": "RS988"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG G5",
    "Device": "h1",
    "Model": "VS987"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG G5 SE",
    "Device": "alicee",
    "Model": "LG-H840"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG G5 SE",
    "Device": "alicee",
    "Model": "LG-H845"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG G5 SE",
    "Device": "alicee",
    "Model": "LG-H848"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG G6",
    "Device": "lucye",
    "Model": "LG-AS993"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG G6",
    "Device": "lucye",
    "Model": "LG-H870"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG G6",
    "Device": "lucye",
    "Model": "LG-H870AR"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG G6",
    "Device": "lucye",
    "Model": "LG-H870DS"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG G6",
    "Device": "lucye",
    "Model": "LG-H870I"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG G6",
    "Device": "lucye",
    "Model": "LG-H870S"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG G6",
    "Device": "lucye",
    "Model": "LG-H871"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG G6",
    "Device": "lucye",
    "Model": "LG-H871S"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG G6",
    "Device": "lucye",
    "Model": "LG-H872"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG G6",
    "Device": "lucye",
    "Model": "LG-H872PR"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG G6",
    "Device": "lucye",
    "Model": "LG-H873"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG G6",
    "Device": "lucye",
    "Model": "LG-LS993"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG G6",
    "Device": "lucye",
    "Model": "LGM-G600K"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG G6",
    "Device": "lucye",
    "Model": "LGM-G600L"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG G6",
    "Device": "lucye",
    "Model": "LGM-G600S"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG G6",
    "Device": "lucye",
    "Model": "LGUS997"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG G6",
    "Device": "lucye",
    "Model": "VS988"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG G7 One",
    "Device": "phoenix_sprout",
    "Model": "LM-Q910"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG G7 ThinQ",
    "Device": "judyln",
    "Model": "LG-G710"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG G7 ThinQ",
    "Device": "judyln",
    "Model": "LM-G710"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG G7 ThinQ",
    "Device": "judyln",
    "Model": "LM-G710N"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG G7 ThinQ",
    "Device": "judyln",
    "Model": "LM-G710VM"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG G7 fit",
    "Device": "falcon",
    "Model": "LM-Q850"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG G8 ThinQ™",
    "Device": "alphaamz",
    "Model": "LM-G820"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG G8 ThinQ™",
    "Device": "alphalm",
    "Model": "LM-G820"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG G8 ThinQ™",
    "Device": "alphaplus",
    "Model": "LM-G820N"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG GRACE™ LTE",
    "Device": "lv517",
    "Model": "LGL59BL"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Gentle",
    "Device": "cfm",
    "Model": "LG-F660L"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Gpad X 10.1",
    "Device": "t1lte",
    "Model": "LG-V930"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Gx",
    "Device": "omega",
    "Model": "LG-F310L"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Gx",
    "Device": "omegar",
    "Model": "LG-F310LR"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Harmony",
    "Device": "lv517",
    "Model": "LG-M257"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Harmony 4",
    "Device": "mdh10xlm",
    "Model": "LM-K400"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Joy",
    "Device": "y30",
    "Model": "LG-H220"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Joy",
    "Device": "y30dsf",
    "Model": "LG-H222"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Joy",
    "Device": "y30f",
    "Model": "LG-H221"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Joy",
    "Device": "y30f",
    "Model": "LG-H221AR"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG K10",
    "Device": "m209n",
    "Model": "LG-K425"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG K10",
    "Device": "m209n",
    "Model": "LG-K428"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG K10",
    "Device": "m209n",
    "Model": "LGMS428"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG K10",
    "Device": "m216",
    "Model": "LG-K420"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG K10",
    "Device": "m216n",
    "Model": "LG-F670K"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG K10",
    "Device": "m216n",
    "Model": "LG-F670L"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG K10",
    "Device": "m216n",
    "Model": "LG-F670S"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG K10",
    "Device": "m216n",
    "Model": "LG-K420"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG K10",
    "Device": "m23g",
    "Model": "LG-K410"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG K10 (2017)",
    "Device": "lv517",
    "Model": "LG-M257PR"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG K10 (2017)",
    "Device": "mlv5",
    "Model": "LG-M250"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG K10 (2017)",
    "Device": "mlv5n",
    "Model": "LG-M250"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG K10 LTE",
    "Device": "m209",
    "Model": "LG-K420PR"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG K10 LTE",
    "Device": "m253",
    "Model": "LG-K430"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG K10 LTE",
    "Device": "m253n",
    "Model": "LG-K430"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG K10 Power",
    "Device": "mlv7",
    "Model": "LG-M320"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG K11",
    "Device": "mcv3",
    "Model": "LM-X410(FN)"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG K11",
    "Device": "mcv3",
    "Model": "LM-X410.F"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG K11",
    "Device": "mcv3",
    "Model": "LM-X410.FN"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG K11+",
    "Device": "mcv3",
    "Model": "LM-X410.F"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG K11+",
    "Device": "mcv3",
    "Model": "LM-X410.FN"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG K20",
    "Device": "lv517n",
    "Model": "LG-M255"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG K20 Plus",
    "Device": "lv517",
    "Model": "LG-TP260"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG K20 Plus",
    "Device": "lv517",
    "Model": "LGMP260"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG K20 V",
    "Device": "lv517",
    "Model": "VS501"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG K3",
    "Device": "lv0",
    "Model": "LGL48VL"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG K3",
    "Device": "me0",
    "Model": "LGLS450"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG K3 LTE",
    "Device": "mme0",
    "Model": "LG-K100"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG K3 LTE",
    "Device": "mme0n",
    "Model": "LG-K100"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG K30",
    "Device": "cv3",
    "Model": "LM-X410UM"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG K30",
    "Device": "mcv3",
    "Model": "LM-X410PM"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG K30",
    "Device": "mh5lm-8m",
    "Model": "LGL322DL"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG K30",
    "Device": "mh5lm-8m",
    "Model": "LM-X320"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG K31",
    "Device": "mdh5lm",
    "Model": "LGL355DL"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG K31",
    "Device": "mdh5lm",
    "Model": "LM-K300"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG K33",
    "Device": "mfh10lm",
    "Model": "LGL460DL"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG K33",
    "Device": "mfh10lm",
    "Model": "LM-K330"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG K35",
    "Device": "meh20lm",
    "Model": "LGL560DL"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG K35",
    "Device": "meh20lm",
    "Model": "LM-K420"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG K4",
    "Device": "e1q",
    "Model": "LG-K120GT"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG K4",
    "Device": "e1q",
    "Model": "LG-K121"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG K4",
    "Device": "e1q",
    "Model": "VS425"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG K4",
    "Device": "lv1",
    "Model": "LG-M160"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG K4 LTE",
    "Device": "me1",
    "Model": "LG-K120"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG K4 LTE",
    "Device": "me1ds",
    "Model": "LG-K130"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG K4/K7 (2017)",
    "Device": "mlv1",
    "Model": "LG-X230"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG K4/K7 (2017)",
    "Device": "mlv1",
    "Model": "LG-X230YK"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG K40",
    "Device": "mh4-pr",
    "Model": "LM-X420"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG K40",
    "Device": "mh4x",
    "Model": "LM-X420"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG K40",
    "Device": "mmh4x",
    "Model": "LM-X420"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG K40S",
    "Device": "mmh55lm",
    "Model": "LM-X430"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG K41S",
    "Device": "mdh15lm",
    "Model": "LM-K410"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG K5",
    "Device": "d3",
    "Model": "LG-X220"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG K50",
    "Device": "mmh4p-pr",
    "Model": "802LG"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG K50",
    "Device": "mmh4p-pr",
    "Model": "KF1919"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG K50",
    "Device": "mmh4p-pr",
    "Model": "LM-X520"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG K7",
    "Device": "m1",
    "Model": "LG-AS330"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG K7",
    "Device": "m1",
    "Model": "LG-K330"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG K7",
    "Device": "m1",
    "Model": "LGMS330"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG K7",
    "Device": "m13g",
    "Model": "LG-X210"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG K8",
    "Device": "lv3",
    "Model": "LG-M210"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG K8",
    "Device": "m1v",
    "Model": "LGAS375"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG K8",
    "Device": "m1v",
    "Model": "LGUS375"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG K8",
    "Device": "m1v",
    "Model": "RS500"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG K8",
    "Device": "mm1v",
    "Model": "LG-K350"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG K8 (2017)",
    "Device": "lv3",
    "Model": "LGUS215"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG K8 (2017)",
    "Device": "lv3n",
    "Model": "LG-M200"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG K8 (2017)",
    "Device": "mlv3",
    "Model": "LG-X240"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG K8 (2017) Dual",
    "Device": "lv3",
    "Model": "LG-M200"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG K8 LTE",
    "Device": "mm1vn",
    "Model": "LG-K350"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG K8 V",
    "Device": "m1v",
    "Model": "VS500"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG K8 V",
    "Device": "m1v",
    "Model": "VS500PP"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG K8(2018)",
    "Device": "cv1",
    "Model": "LM-X21(G)"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG K8(2018)",
    "Device": "cv1",
    "Model": "LM-X210"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG K8(2018)",
    "Device": "cv1",
    "Model": "LM-X210(G)"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG K8(2018)",
    "Device": "cv1",
    "Model": "LM-X212(G)"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG K8(2018)",
    "Device": "cv1",
    "Model": "LML211BL"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG K8(2018)",
    "Device": "cv1",
    "Model": "LML212VL"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG K8(2018)",
    "Device": "mcv150",
    "Model": "LM-X210"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG K8s",
    "Device": "cv1s",
    "Model": "LM-X220"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG K8s",
    "Device": "mcv1s",
    "Model": "LM-X220QMA"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG K9",
    "Device": "cv109",
    "Model": "LM-X210"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG L39C",
    "Device": "l4ii_cdma",
    "Model": "LGL39C"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG L455DL",
    "Device": "mdh10lm",
    "Model": "LGL455DL"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG L455DL",
    "Device": "mdh10lm",
    "Model": "LM-K400"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG LEON™ LTE",
    "Device": "c50",
    "Model": "LG-H345"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Lancet",
    "Device": "c50",
    "Model": "VS820"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Leon",
    "Device": "my50",
    "Model": "LG-H320"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Leon",
    "Device": "my50ds",
    "Model": "LG-H324"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Leon",
    "Device": "my50ds",
    "Model": "LG-H326"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Leon 4G LTE",
    "Device": "c50",
    "Model": "LG-H340"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Leon 4G LTE",
    "Device": "c50",
    "Model": "LG-H340AR"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Leon 4G LTE",
    "Device": "c50",
    "Model": "LG-H340GT"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Leon 4G LTE",
    "Device": "c50",
    "Model": "LG-H343"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Leon 4G LTE",
    "Device": "c50",
    "Model": "LGMS345"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Leon 4G LTE",
    "Device": "c50ds",
    "Model": "LG-H342"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Leon 4G LTE",
    "Device": "c50n",
    "Model": "LG-H340n"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Leon TV",
    "Device": "my50ds",
    "Model": "LG-H326"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Logos",
    "Device": "c70",
    "Model": "LGUS550"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Lucid",
    "Device": "cayman",
    "Model": "VS840 4G"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Lucid",
    "Device": "cayman",
    "Model": "VS840PP"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Lucid 2",
    "Device": "l1v",
    "Model": "VS870 4G"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Lucid 3",
    "Device": "x5",
    "Model": "VS876"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG M1",
    "Device": "m1ds",
    "Model": "LG-K332"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Mach™",
    "Device": "l2s",
    "Model": "LG-LS860"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Magna",
    "Device": "my90",
    "Model": "LG-H500"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Magna",
    "Device": "my90",
    "Model": "LG-T540"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Magna",
    "Device": "my90ds",
    "Model": "LG-H502"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Magna LTE",
    "Device": "mc90",
    "Model": "LG-H520"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Max",
    "Device": "v10",
    "Model": "LG-X155"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Max",
    "Device": "v10",
    "Model": "LG-X160"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Max",
    "Device": "v10",
    "Model": "LG-X165g"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Motion 4G",
    "Device": "l0",
    "Model": "LG-MS770"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG OPTIMUS M+",
    "Device": "m3_mpcs_us",
    "Model": "LG-MS695"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG OPTIMUS ZIP",
    "Device": "lgl75c",
    "Model": "LGL75C"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Optimus 3D",
    "Device": "cosmopolitan",
    "Model": "LG-P920"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Optimus 3D",
    "Device": "cosmopolitan",
    "Model": "LG-P925g"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Optimus 3D",
    "Device": "cosmopolitan",
    "Model": "LG-SU760"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Optimus ELITE™",
    "Device": "m3s",
    "Model": "LG-VM696"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Optimus Elite",
    "Device": "m3s",
    "Model": "LG Optimus Elite"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Optimus Elite",
    "Device": "m3s",
    "Model": "LG-LS696"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Optimus F3Q",
    "Device": "fx3q",
    "Model": "LG-D520"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Optimus F7",
    "Device": "fx1",
    "Model": "LG-AS780"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Optimus F7",
    "Device": "fx1",
    "Model": "LG-LG870"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Optimus F7",
    "Device": "fx1",
    "Model": "LG-US780"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Optimus G",
    "Device": "geeb",
    "Model": "LG-E970"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Optimus G",
    "Device": "geeb",
    "Model": "LG-E971"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Optimus G",
    "Device": "geeb",
    "Model": "LG-E973"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Optimus G",
    "Device": "geehdc",
    "Model": "L-01E"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Optimus G",
    "Device": "geehdc",
    "Model": "LGL21"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Optimus G",
    "Device": "geehrc",
    "Model": "LG-E975"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Optimus G",
    "Device": "geehrc",
    "Model": "LG-E975K"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Optimus G",
    "Device": "geehrc",
    "Model": "LG-E975T"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Optimus G",
    "Device": "geehrc",
    "Model": "LG-E976"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Optimus G",
    "Device": "geehrc",
    "Model": "LG-E977"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Optimus G",
    "Device": "geehrc",
    "Model": "LG-E987"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Optimus G",
    "Device": "geehrc",
    "Model": "LG-F180K"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Optimus G",
    "Device": "geehrc",
    "Model": "LG-F180S"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Optimus G",
    "Device": "geehrc4g",
    "Model": "LG-F180L"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Optimus G",
    "Device": "geehrc4g",
    "Model": "LG-LS970"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Optimus G Pro",
    "Device": "geefhd",
    "Model": "LG-E980"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Optimus G Pro",
    "Device": "geefhd",
    "Model": "LG-E980h"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Optimus G Pro",
    "Device": "geefhd",
    "Model": "LG-E981h"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Optimus G Pro",
    "Device": "geefhd",
    "Model": "LG-E986"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Optimus G Pro",
    "Device": "geefhd",
    "Model": "LG-E988"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Optimus G Pro",
    "Device": "geefhd",
    "Model": "LG-E989"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Optimus G Pro",
    "Device": "geefhd",
    "Model": "LG-F240K"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Optimus G Pro",
    "Device": "geefhd",
    "Model": "LG-F240S"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Optimus G Pro",
    "Device": "geefhd4g",
    "Model": "LG-F240L"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Optimus HUB",
    "Device": "univa_222-01",
    "Model": "LG-E510"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Optimus HUB",
    "Device": "univa_arb-xx",
    "Model": "LG-E510"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Optimus HUB",
    "Device": "univa_cis-xxx",
    "Model": "LG-E510"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Optimus HUB",
    "Device": "univa_esa-xx",
    "Model": "LG-E510"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Optimus HUB",
    "Device": "univa_eur-xx",
    "Model": "LG-E510"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Optimus HUB",
    "Device": "univa_open-eu",
    "Model": "LG-E510"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Optimus HUB",
    "Device": "univa_tur-xx",
    "Model": "LG-E510"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Optimus L1II",
    "Device": "v1",
    "Model": "LG-E410"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Optimus L1II",
    "Device": "v1",
    "Model": "LG-E410B"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Optimus L1II",
    "Device": "v1",
    "Model": "LG-E410c"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Optimus L1II",
    "Device": "v1",
    "Model": "LG-E410f"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Optimus L1II",
    "Device": "v1",
    "Model": "LG-E410g"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Optimus L1II",
    "Device": "v1",
    "Model": "LG-E410i"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Optimus L1II",
    "Device": "v1",
    "Model": "LG-E411f"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Optimus L1II",
    "Device": "v1",
    "Model": "LG-E411g"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Optimus L1II",
    "Device": "v1ds",
    "Model": "LG-E415f"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Optimus L1II",
    "Device": "v1ds",
    "Model": "LG-E415g"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Optimus L1II",
    "Device": "v1ds",
    "Model": "LG-E420"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Optimus L1II",
    "Device": "v1ds",
    "Model": "LG-E420f"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Optimus L1II",
    "Device": "v1ts",
    "Model": "LG-E475f"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Optimus L3",
    "Device": "e0",
    "Model": "LG-E400"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Optimus L3",
    "Device": "e0",
    "Model": "LG-E400R"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Optimus L3",
    "Device": "e0",
    "Model": "LG-E400b"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Optimus L3",
    "Device": "e0",
    "Model": "LG-E400f"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Optimus L3",
    "Device": "e0",
    "Model": "LG-E400g"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Optimus L3",
    "Device": "e0",
    "Model": "LG-L38C"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Optimus L3",
    "Device": "e0",
    "Model": "LGL35G"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Optimus L3",
    "Device": "e0_open_eur",
    "Model": "LG-E400"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Optimus L3 Dual",
    "Device": "e1",
    "Model": "LG-E405"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Optimus L3 Dual",
    "Device": "e1",
    "Model": "LG-E405f"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Optimus L3 II",
    "Device": "vee3ds",
    "Model": "LG-E435"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Optimus L3 II",
    "Device": "vee3ds",
    "Model": "LG-E435f"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Optimus L3 II",
    "Device": "vee3ds",
    "Model": "LG-E435g"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Optimus L3 II",
    "Device": "vee3ds",
    "Model": "LG-E435k"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Optimus L3 II",
    "Device": "vee3e",
    "Model": "LG-E425"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Optimus L3 II",
    "Device": "vee3e",
    "Model": "LG-E425c"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Optimus L3 II",
    "Device": "vee3e",
    "Model": "LG-E425f"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Optimus L3 II",
    "Device": "vee3e",
    "Model": "LG-E425g"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Optimus L3 II",
    "Device": "vee3e",
    "Model": "LG-E425j"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Optimus L3 II",
    "Device": "vee3e",
    "Model": "LG-E430"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Optimus L3 II",
    "Device": "vee3e",
    "Model": "LG-E431g"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Optimus L4 II",
    "Device": "vee4ss",
    "Model": "LG-E440"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Optimus L4 II",
    "Device": "vee4ss",
    "Model": "LG-E440f"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Optimus L4 II",
    "Device": "vee4ss",
    "Model": "LG-E440g"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Optimus L4 II",
    "Device": "vee4ss",
    "Model": "LG-E465f"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Optimus L4 II",
    "Device": "vee4ss",
    "Model": "LG-E465g"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Optimus L4 II Dual",
    "Device": "vee4ds",
    "Model": "LG-E445"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Optimus L4 II Dual",
    "Device": "vee4ds",
    "Model": "LG-E467f"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Optimus L4 II Tri",
    "Device": "vee4ts",
    "Model": "LG-E470f"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Optimus L5 Dual",
    "Device": "m4ds",
    "Model": "LG-E615"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Optimus L5 Dual",
    "Device": "m4ds",
    "Model": "LG-E615f"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Optimus L5 II",
    "Device": "vee5ds",
    "Model": "LG-E455"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Optimus L5 II",
    "Device": "vee5ds",
    "Model": "LG-E455f"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Optimus L5 II",
    "Device": "vee5ds",
    "Model": "LG-E455g"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Optimus L5 II",
    "Device": "vee5nfc",
    "Model": "LG-E460"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Optimus L5 II",
    "Device": "vee5nfc",
    "Model": "LG-E460f"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Optimus L5 II",
    "Device": "vee5ss",
    "Model": "LG-E450"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Optimus L5 II",
    "Device": "vee5ss",
    "Model": "LG-E450B"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Optimus L5 II",
    "Device": "vee5ss",
    "Model": "LG-E450f"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Optimus L5 II",
    "Device": "vee5ss",
    "Model": "LG-E450g"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Optimus L5 II",
    "Device": "vee5ss",
    "Model": "LG-E450j"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Optimus L5 II",
    "Device": "vee5ss",
    "Model": "LG-E451g"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Optimus L5 II",
    "Device": "vee5ss",
    "Model": "LG-E460"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Optimus L7",
    "Device": "u0",
    "Model": "LG-P700"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Optimus L7",
    "Device": "u0",
    "Model": "LG-P705"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Optimus L7",
    "Device": "u0",
    "Model": "LG-P705f"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Optimus L7",
    "Device": "u0",
    "Model": "LG-P705g"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Optimus L7",
    "Device": "u0",
    "Model": "LG-P708g"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Optimus L7",
    "Device": "u0",
    "Model": "LG-T280"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Optimus L7",
    "Device": "u0",
    "Model": "LGL96G"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Optimus L7",
    "Device": "vee7ds",
    "Model": "LG-P715"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Optimus L7 II",
    "Device": "vee7e",
    "Model": "LG-P710"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Optimus L7 II",
    "Device": "vee7e",
    "Model": "LG-P712"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Optimus L7 II",
    "Device": "vee7e",
    "Model": "LG-P713"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Optimus L7 II",
    "Device": "vee7e",
    "Model": "LG-P713GO"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Optimus L7 II",
    "Device": "vee7e",
    "Model": "LG-P713TR"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Optimus L7 II",
    "Device": "vee7e",
    "Model": "LG-P714"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Optimus L7II",
    "Device": "vee7ds",
    "Model": "LG-P715"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Optimus L7II",
    "Device": "vee7ds",
    "Model": "LG-P716"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Optimus L9",
    "Device": "u2",
    "Model": "LG-D700"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Optimus L9",
    "Device": "u2",
    "Model": "LG-P760"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Optimus L9",
    "Device": "u2",
    "Model": "LG-P765"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Optimus L9",
    "Device": "u2",
    "Model": "LG-P768"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Optimus L9",
    "Device": "u2",
    "Model": "LG-P769"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Optimus L9",
    "Device": "u2",
    "Model": "LG-P778"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Optimus L9",
    "Device": "u2",
    "Model": "LGMS769"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Optimus L9 (NFC)",
    "Device": "u2",
    "Model": "LG-P760"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Optimus L9 II",
    "Device": "l9ii",
    "Model": "LG-D605"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Optimus LTE Tag",
    "Device": "cayman",
    "Model": "LG-AS840"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Optimus LTE Tag",
    "Device": "cayman",
    "Model": "LG-F120K"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Optimus LTE Tag",
    "Device": "cayman",
    "Model": "LG-F120L"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Optimus LTE Tag",
    "Device": "cayman",
    "Model": "LG-F120S"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Optimus LTE Tag",
    "Device": "lge_120_kt",
    "Model": "LG-F120K"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Optimus LTE Tag",
    "Device": "lge_120_skt",
    "Model": "LG-F120S"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Optimus LTE2",
    "Device": "d1lkt",
    "Model": "LG-F160K"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Optimus LTE2",
    "Device": "d1lsk",
    "Model": "LG-F160S"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Optimus LTE2",
    "Device": "d1lu",
    "Model": "LG-F160L"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Optimus LTE2",
    "Device": "d1lu",
    "Model": "LG-F160LV"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Optimus LTE3",
    "Device": "fx1sk",
    "Model": "LG-F260S"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Optimus One",
    "Device": "thunderg",
    "Model": "LG-P500"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Optimus One",
    "Device": "thunderg",
    "Model": "LG-P500h"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Optimus One",
    "Device": "thunderg",
    "Model": "LG-P503"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Optimus One",
    "Device": "thunderg",
    "Model": "LG-P504"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Optimus One",
    "Device": "thunderg",
    "Model": "LG-P505"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Optimus One",
    "Device": "thunderg",
    "Model": "LG-P505CH"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Optimus One",
    "Device": "thunderg",
    "Model": "LG-P505R"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Optimus One",
    "Device": "thunderg",
    "Model": "LG-P506"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Optimus One",
    "Device": "thunderg",
    "Model": "LG-P509"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Optimus Regard",
    "Device": "l0",
    "Model": "LG-LW770"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Optimus Select",
    "Device": "u0_cdma",
    "Model": "LG-AS730"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Optimus Zone 2",
    "Device": "w3c",
    "Model": "VS415PP"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Pecan",
    "Device": "pecan",
    "Model": "LG-P350"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Pecan",
    "Device": "pecan",
    "Model": "LG-P350f"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Pecan",
    "Device": "pecan",
    "Model": "LG-P350g"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Phoenix 2",
    "Device": "m1v",
    "Model": "LG-K371"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Phoenix 4",
    "Device": "cv1",
    "Model": "LM-X210APM"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Power",
    "Device": "y50c",
    "Model": "LGL22C"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Premier Pro",
    "Device": "cv3",
    "Model": "LM-X410(FG)"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Premier Pro",
    "Device": "cv3",
    "Model": "LM-X410.F"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Premier Pro",
    "Device": "cv3",
    "Model": "LM-X410.FG"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Premier Pro",
    "Device": "cv3",
    "Model": "LM-X410.FGN"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Premier Pro",
    "Device": "cv3",
    "Model": "LML413DL"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Premier Pro",
    "Device": "cv3",
    "Model": "LML414DL"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Prime II",
    "Device": "v10",
    "Model": "LG-X170fTV"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Prime II",
    "Device": "v10",
    "Model": "LG-X170g"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Prime Plus 4G",
    "Device": "mc90ds",
    "Model": "LG-H522"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Q6",
    "Device": "mh",
    "Model": "LG-M700"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Q6",
    "Device": "mhn",
    "Model": "LG-M700"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Q6",
    "Device": "mhn",
    "Model": "LG-M703"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Q6",
    "Device": "mhn",
    "Model": "LG-US700"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Q6",
    "Device": "mhn",
    "Model": "LGM-X600K"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Q6",
    "Device": "mhn",
    "Model": "LGM-X600L"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Q6",
    "Device": "mhn",
    "Model": "LGM-X600S"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Q60",
    "Device": "mmh4p",
    "Model": "LM-X525"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Q7",
    "Device": "mcv5a",
    "Model": "LM-Q610.FG"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Q7",
    "Device": "mcv5a",
    "Model": "LM-Q610.FGN"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Q7",
    "Device": "mcv5a",
    "Model": "LM-Q617.FGN"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Q7+",
    "Device": "cv5a",
    "Model": "LM-Q610(FGN)"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Q7+",
    "Device": "cv5a",
    "Model": "LM-Q617.FGN"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Q7+",
    "Device": "cv5an",
    "Model": "LM-Q725K"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Q7+",
    "Device": "cv5an",
    "Model": "LM-Q725L"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Q7+",
    "Device": "cv5an",
    "Model": "LM-Q725S"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Q7+",
    "Device": "cv5an",
    "Model": "LM-Q727K"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Q7+",
    "Device": "cv5an",
    "Model": "LM-Q727L"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Q7+",
    "Device": "cv5an",
    "Model": "LM-Q727S"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Q70",
    "Device": "mh3",
    "Model": "LM-Q620"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Q70",
    "Device": "mh3-pl",
    "Model": "LM-Q730N"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Q9",
    "Device": "falcon",
    "Model": "LM-Q925K"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Q9",
    "Device": "falcon",
    "Model": "LM-Q925L"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Q9",
    "Device": "falcon",
    "Model": "LM-Q925S"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Q9 One",
    "Device": "phoenix_sprout",
    "Model": "LM-Q927L"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG RAY",
    "Device": "d2",
    "Model": "LG-X190"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Rebel",
    "Device": "e1q",
    "Model": "LGL43AL"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Rebel",
    "Device": "e1q",
    "Model": "LGL44VL"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Reflect",
    "Device": "mdh30lm",
    "Model": "LGL555DL"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Reflect",
    "Device": "mdh30lm",
    "Model": "LM-K500"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Revolution",
    "Device": "bryce",
    "Model": "VS910 4G"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG SUNSET",
    "Device": "c50",
    "Model": "LGL33L"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Smart Folder",
    "Device": "cf2",
    "Model": "LGM-X100L"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Smart Folder",
    "Device": "cf2",
    "Model": "LGM-X100S"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Solo LTE",
    "Device": "mh4",
    "Model": "LGL423DL"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Solo LTE",
    "Device": "mh4",
    "Model": "LM-X420"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Spectrum",
    "Device": "VS920",
    "Model": "VS920 4G"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Spirit",
    "Device": "my70",
    "Model": "LG-H420"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Spirit 4G LTE",
    "Device": "c70n",
    "Model": "LG-H440n"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Spirit LTE",
    "Device": "c70",
    "Model": "LG-H440"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Spirit LTE",
    "Device": "c70",
    "Model": "LG-H440AR"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Stylo 2",
    "Device": "ph1",
    "Model": "LG-K540"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Stylo 2",
    "Device": "ph1",
    "Model": "LGL81AL"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Stylo 2",
    "Device": "ph1",
    "Model": "LGL82VL"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Stylo 2",
    "Device": "ph1",
    "Model": "LGLS775"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Stylo 2 Plus",
    "Device": "ph2n",
    "Model": "LG-K550"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Stylo 2 Plus",
    "Device": "ph2n",
    "Model": "LG-K557"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Stylo 2 Plus",
    "Device": "ph2n",
    "Model": "LGMS550"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Stylo 3 Plus",
    "Device": "sf340n",
    "Model": "LG-M470"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Stylo 3 Plus",
    "Device": "sf340n",
    "Model": "LG-M470F"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Stylo 3 Plus",
    "Device": "sf340n",
    "Model": "LG-TP450"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Stylo 3 Plus",
    "Device": "sf340n",
    "Model": "LGMP450"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Stylo 4",
    "Device": "cv7a",
    "Model": "LM-Q710(FGN)"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Stylo 4",
    "Device": "cv7a",
    "Model": "LM-Q710.FG"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Stylo 4",
    "Device": "cv7a",
    "Model": "LM-Q710.FGN"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Stylo 4",
    "Device": "cv7a",
    "Model": "LML713DL"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Stylo 4",
    "Device": "mcv7a",
    "Model": "LG-Q710AL"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Stylo 4",
    "Device": "mcv7a",
    "Model": "LG-Q710PL"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Stylo 5",
    "Device": "cv7as",
    "Model": "LGL722DL"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Stylo 5",
    "Device": "cv7as",
    "Model": "LM-Q720"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Stylo 5+",
    "Device": "cv7as-pr",
    "Model": "LM-Q720"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Stylo 7",
    "Device": "fh50lm",
    "Model": "LM-K735"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Stylo3",
    "Device": "sf317",
    "Model": "LG-M430"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Stylo3",
    "Device": "sf317",
    "Model": "LGL83BL"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Stylo3",
    "Device": "sf317",
    "Model": "LGL84VL"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Stylo3",
    "Device": "sf340",
    "Model": "LG-LS777"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Stylus 2",
    "Device": "ph1",
    "Model": "LG-F720K"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Stylus 2",
    "Device": "ph1",
    "Model": "LG-F720L"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Stylus 2",
    "Device": "ph1",
    "Model": "LG-F720S"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Stylus 2",
    "Device": "ph1",
    "Model": "LG-K520"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Stylus2",
    "Device": "ph1n",
    "Model": "LG-K520"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Stylus2 4G",
    "Device": "ph2",
    "Model": "LG-K530"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Stylus2 4G",
    "Device": "ph2",
    "Model": "LG-K535"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Stylus2 Plus",
    "Device": "ph2n",
    "Model": "LG-K535"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Stylus2 Plus",
    "Device": "ph2n",
    "Model": "LG-K535n"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Stylus3",
    "Device": "msf3",
    "Model": "LG-M400"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Stylus3",
    "Device": "msf3n",
    "Model": "LG-M400"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Thrill 4G",
    "Device": "cosmopolitan",
    "Model": "LG-P925"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Treasure",
    "Device": "m1",
    "Model": "LGL51AL"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Treasure",
    "Device": "m1",
    "Model": "LGL52VL"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Tribute 2™",
    "Device": "c50",
    "Model": "LGLS665"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Tribute 5",
    "Device": "m1",
    "Model": "LGLS675"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Tribute Dynasty",
    "Device": "mcv150",
    "Model": "LG-SP200"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Tribute Empire",
    "Device": "mcv1s",
    "Model": "LM-X220PM"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Tribute Royal",
    "Device": "mmh5lm",
    "Model": "LM-X320"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG U",
    "Device": "bbg",
    "Model": "LG-F820L"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Ultra Tab",
    "Device": "jettalt",
    "Model": "10A30Q"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Ultra Tab",
    "Device": "solemiolt",
    "Model": "10A20S"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Ultra Tab",
    "Device": "solemiolt",
    "Model": "10AWM20S"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG V35 ThinQ",
    "Device": "judyp",
    "Model": "LM-V350"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG V35 ThinQ",
    "Device": "judyp",
    "Model": "LM-V350N"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG V50 ThinQ",
    "Device": "flashlmdd",
    "Model": "LM-V500"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG V50 ThinQ",
    "Device": "flashlmdd",
    "Model": "LM-V500N"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG V60 ThinQ",
    "Device": "timelm",
    "Model": "LM-V600"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG V60 ThinQ",
    "Device": "timelm",
    "Model": "LM-V600N"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG V60 ThinQ 5G",
    "Device": "L-51A",
    "Model": "L-51A"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG VELVET",
    "Device": "L-52A",
    "Model": "L-52A"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Venice",
    "Device": "u0_cdma",
    "Model": "LG-LG730"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Viper 4G LTE",
    "Device": "cayman",
    "Model": "LG-LS840"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Volt",
    "Device": "my70ds",
    "Model": "LG-H422"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Volt",
    "Device": "x5",
    "Model": "LGLS740"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Volt 4G",
    "Device": "c70ds",
    "Model": "LG-H442"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Volt II",
    "Device": "c90nas",
    "Model": "LGLS751"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Volt LTE",
    "Device": "c70w",
    "Model": "LG-F540K"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Volt LTE",
    "Device": "c70w",
    "Model": "LG-F540L"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Volt LTE",
    "Device": "c70w",
    "Model": "LG-F540S"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Volt S",
    "Device": "c90",
    "Model": "LG-F640S"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG WING",
    "Device": "winglm",
    "Model": "LM-F100"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG WING",
    "Device": "winglm",
    "Model": "LM-F100N"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Watch Sport",
    "Device": "swordfish",
    "Model": "LG Watch Sport"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Watch Style",
    "Device": "angelfish",
    "Model": "LG Watch Style"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Watch Urbane",
    "Device": "bass",
    "Model": "LG Watch Urbane"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Watch Urbane 2nd Edition LTE",
    "Device": "nemo",
    "Model": "LG Watch Urbane"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Watch W7",
    "Device": "narwhal",
    "Model": "LG Watch W7"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Wine Smart",
    "Device": "cf",
    "Model": "LG-H410"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Wine Smart Jazz",
    "Device": "cf",
    "Model": "LG-F610K"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Wine Smart Jazz",
    "Device": "cf",
    "Model": "LG-F610S"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG X Screen",
    "Device": "k5",
    "Model": "LGK500J"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG X Skin",
    "Device": "k6b",
    "Model": "LG-F740L"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG X Style",
    "Device": "k6b",
    "Model": "LG-K200"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG X Style",
    "Device": "k6b",
    "Model": "LGL53BL"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG X Style",
    "Device": "k6b",
    "Model": "LGL56VL"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG X Style",
    "Device": "k6b",
    "Model": "LGLS676"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG X Venture",
    "Device": "lv9",
    "Model": "LG-US701"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG X Venture",
    "Device": "lv9n",
    "Model": "LG-H700"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG X Venture",
    "Device": "lv9n",
    "Model": "LG-M710"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG X Venture",
    "Device": "lv9n",
    "Model": "LG-M710ds"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG X cam",
    "Device": "k7",
    "Model": "LG-F690L"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG X cam",
    "Device": "k7",
    "Model": "LG-F690S"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG X cam",
    "Device": "k7",
    "Model": "LG-K580"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG X cam",
    "Device": "k7n",
    "Model": "LG-K580"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG X cam",
    "Device": "k7n",
    "Model": "LG-K580Y"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG X charge",
    "Device": "lv7",
    "Model": "LG-M322"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG X charge",
    "Device": "lv7",
    "Model": "LG-M327"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG X charge",
    "Device": "mlv7",
    "Model": "LG-M320"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG X charge",
    "Device": "mlv7",
    "Model": "LG-US601"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG X charge",
    "Device": "mlv7",
    "Model": "LM-X510(FG)"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG X charge",
    "Device": "mlv7",
    "Model": "LM-X510.FG"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG X max",
    "Device": "mk6m",
    "Model": "LG-K240"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG X power",
    "Device": "k6p",
    "Model": "LG-K210"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG X power",
    "Device": "k6p",
    "Model": "LG-K212"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG X power",
    "Device": "k6p",
    "Model": "LG-K450"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG X power",
    "Device": "k6p",
    "Model": "LGUS610"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG X power",
    "Device": "mk6p",
    "Model": "LG-F750K"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG X power",
    "Device": "mk6p",
    "Model": "LG-K220"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG X power",
    "Device": "mk6p55",
    "Model": "LGLS755"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG X power",
    "Device": "mk6pn",
    "Model": "LG-K220"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG X power2",
    "Device": "lv7",
    "Model": "LG-M320G"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG X power2",
    "Device": "lv7",
    "Model": "LM-X510WM"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG X screen",
    "Device": "k5",
    "Model": "LG-F650K"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG X screen",
    "Device": "k5",
    "Model": "LG-F650L"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG X screen",
    "Device": "k5",
    "Model": "LG-F650S"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG X screen",
    "Device": "k5",
    "Model": "LG-K500"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG X screen",
    "Device": "k5",
    "Model": "LGS02"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG X screen",
    "Device": "k5n",
    "Model": "LG-K500"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG X screen",
    "Device": "k5n",
    "Model": "LG-K500n"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG X2",
    "Device": "cv109",
    "Model": "LM-X210K"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG X2",
    "Device": "cv109",
    "Model": "LM-X210L"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG X2",
    "Device": "cv109",
    "Model": "LM-X210S"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG X300",
    "Device": "lv3n",
    "Model": "LGM-K120K"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG X300",
    "Device": "lv3n",
    "Model": "LGM-K120L"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG X300",
    "Device": "lv3n",
    "Model": "LGM-K120S"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG X400",
    "Device": "mlv5n",
    "Model": "LGM-K121K"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG X400",
    "Device": "mlv5n",
    "Model": "LGM-K121L"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG X400",
    "Device": "mlv5n",
    "Model": "LGM-K121S"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG X400",
    "Device": "mlv5n",
    "Model": "LGM-X301K"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG X400",
    "Device": "mlv5n",
    "Model": "LGM-X301L"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG X400",
    "Device": "mlv5n",
    "Model": "LGM-X301S"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG X400",
    "Device": "mlv5n",
    "Model": "LGM-X401L"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG X400",
    "Device": "mlv5n",
    "Model": "LGM-X401S"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG X5",
    "Device": "mk6m",
    "Model": "LG-F770S"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG X5",
    "Device": "mlv7n",
    "Model": "LM-X510L"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG X500",
    "Device": "mlv7n",
    "Model": "LG-M320"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG X500",
    "Device": "mlv7n",
    "Model": "LGM-X320K"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG X500",
    "Device": "mlv7n",
    "Model": "LGM-X320L"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG X500",
    "Device": "mlv7n",
    "Model": "LGM-X320S"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG X500",
    "Device": "mlv7n",
    "Model": "LM-X510K"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG X500",
    "Device": "mlv7n",
    "Model": "LM-X510S"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Xpression Plus 2",
    "Device": "mmh4x",
    "Model": "LM-X420"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG ZONE",
    "Device": "d2",
    "Model": "LG-X180g"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG Zero",
    "Device": "c100",
    "Model": "LG-H650"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG it",
    "Device": "cv1",
    "Model": "LGV36"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG optimus it L-05D",
    "Device": "l_dcm",
    "Model": "L-05D"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG optimus it L-05E",
    "Device": "L05E",
    "Model": "L-05E"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG style2",
    "Device": "L-01L",
    "Model": "L-01L"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG style3",
    "Device": "L-41A",
    "Model": "L-41A"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG-AS876",
    "Device": "x5",
    "Model": "AS876"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG-D150",
    "Device": "w35",
    "Model": "LG-D150"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG-D157f",
    "Device": "w35ds",
    "Model": "LG-D157f"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG-E985T",
    "Device": "gvarfhd",
    "Model": "LG-E985"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG-E985T",
    "Device": "gvarfhd",
    "Model": "LG-E985T"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LG-K41S",
    "Device": "mdh15lm",
    "Model": "LM-K410"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LGL22",
    "Device": "g2",
    "Model": "LGL22"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LM-K420",
    "Device": "meh15lm",
    "Model": "LM-K420"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LM-X120",
    "Device": "mmh6lm",
    "Model": "LM-X120"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LM-X420",
    "Device": "mmh4",
    "Model": "LM-X420"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LM-X520",
    "Device": "mmh4p-pr",
    "Model": "LM-X520"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "LM-X525",
    "Device": "mmh4p",
    "Model": "LM-X525"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "MY LG Mobile",
    "Device": "mh5lm",
    "Model": "LM-X320"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Marquee",
    "Device": "L-07C",
    "Model": "L-07C"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Marquee",
    "Device": "LG855",
    "Model": "LG-LG855"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Marquee",
    "Device": "LS855",
    "Model": "LG-LS855"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Marquee",
    "Device": "bproj_CIS-xxx",
    "Model": "LG-P970"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "My touch 4G",
    "Device": "e739",
    "Model": "LG-E739"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Nexus 4",
    "Device": "mako",
    "Model": "Nexus 4"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Nexus 5",
    "Device": "hammerhead",
    "Model": "Nexus 5"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Nexus 5X",
    "Device": "bullhead",
    "Model": "Nexus 5X"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Optiimus Black",
    "Device": "bproj_208-01",
    "Model": "LG-P970"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Optimus  EX",
    "Device": "x2",
    "Model": "LG-SU880"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Optimus  LTE",
    "Device": "l1a",
    "Model": "LG-P870"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Optimus 2",
    "Device": "as680",
    "Model": "LG-AS680"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Optimus 2X",
    "Device": "p990",
    "Model": "LG-P990"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Optimus 2X",
    "Device": "p990",
    "Model": "LG-P990H"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Optimus 2X",
    "Device": "p990",
    "Model": "LG-P990h"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Optimus 2X",
    "Device": "p990_262-xx",
    "Model": "LG-P990"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Optimus 2X",
    "Device": "p990_CIS-xxx",
    "Model": "LG-P990"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Optimus 2X",
    "Device": "p990_EUR-xx",
    "Model": "LG-P990"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Optimus 2X",
    "Device": "p990hN",
    "Model": "LG-P990hN"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Optimus 2X",
    "Device": "p999",
    "Model": "LG-P999"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Optimus 2X",
    "Device": "star",
    "Model": "LG-P990"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Optimus 2X",
    "Device": "star",
    "Model": "LG-SU660"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Optimus 2X",
    "Device": "star_450-05",
    "Model": "LG-SU660"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Optimus 2X",
    "Device": "su660",
    "Model": "LG-SU660"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Optimus 3D",
    "Device": "cosmo_450-05",
    "Model": "LG-SU760"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Optimus 3D",
    "Device": "cosmo_EUR-XXX",
    "Model": "LG-P920"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Optimus 3D",
    "Device": "cosmo_MEA-XXX",
    "Model": "LG-P920"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Optimus 3D",
    "Device": "p920",
    "Model": "LG-P920"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Optimus 3D",
    "Device": "p920",
    "Model": "LG-P920h"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Optimus 3D",
    "Device": "su760",
    "Model": "LG-SU760"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Optimus 3D Cube",
    "Device": "cx2",
    "Model": "LG-SU870"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Optimus 3D MAX",
    "Device": "cx2",
    "Model": "LG-P720"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Optimus 3D MAX",
    "Device": "cx2",
    "Model": "LG-P720h"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Optimus 3D MAX",
    "Device": "cx2",
    "Model": "LG-P725"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Optimus 3D MAX",
    "Device": "cx2",
    "Model": "LG-SU870"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Optimus 4X HD",
    "Device": "x3",
    "Model": "LG-P880"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Optimus 4X HD",
    "Device": "x3",
    "Model": "LG-P880g"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Optimus Big",
    "Device": "justin",
    "Model": "LG-LU6800"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Optimus Big",
    "Device": "lu6800",
    "Model": "LG-LU6800"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Optimus Black",
    "Device": "LGL85C",
    "Model": "LGL85C"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Optimus Black",
    "Device": "black",
    "Model": "LG-KU5900"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Optimus Black",
    "Device": "blackg",
    "Model": "LG-P970"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Optimus Black",
    "Device": "blackg",
    "Model": "LG-P970h"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Optimus Black",
    "Device": "bproj_214-03",
    "Model": "LG-P970"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Optimus Black",
    "Device": "bproj_262-XXX",
    "Model": "LG-P970"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Optimus Black",
    "Device": "bproj_302-220",
    "Model": "LG-P970g"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Optimus Black",
    "Device": "bproj_334-020",
    "Model": "LG-P970h"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Optimus Black",
    "Device": "bproj_724-xxx",
    "Model": "LG-P970h"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Optimus Black",
    "Device": "bproj_ARE-XXX",
    "Model": "LG-P970"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Optimus Black",
    "Device": "bproj_EUR-XXX",
    "Model": "LG-P970"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Optimus Black",
    "Device": "bproj_sea-xxx",
    "Model": "LG-P970"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Optimus Black",
    "Device": "ku5900",
    "Model": "LG-KU5900"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Optimus Black",
    "Device": "lgp970",
    "Model": "LG-P970"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Optimus Black",
    "Device": "lgp970",
    "Model": "LG-P970g"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Optimus Black",
    "Device": "lgp970",
    "Model": "LG-P970h"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Optimus Chat",
    "Device": "hazel",
    "Model": "LG-C550"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Optimus Chat",
    "Device": "hazel",
    "Model": "LG-C555"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Optimus Core",
    "Device": "u0_cdma",
    "Model": "LGL86C"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Optimus EX",
    "Device": "x2",
    "Model": "IS11LG"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Optimus EX",
    "Device": "x2_450-05",
    "Model": "LG-SU880"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Optimus Exceed 2",
    "Device": "w5c",
    "Model": "LG-VS450PP"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Optimus F3",
    "Device": "fx3",
    "Model": "LG-LS720"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Optimus F3",
    "Device": "fx3",
    "Model": "LG-P655H"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Optimus F3",
    "Device": "fx3",
    "Model": "LG-P655K"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Optimus F3",
    "Device": "fx3",
    "Model": "LG-P659"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Optimus F3",
    "Device": "fx3",
    "Model": "LG-P659H"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Optimus F3",
    "Device": "fx3",
    "Model": "LGL25L"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Optimus F3",
    "Device": "fx3",
    "Model": "LGMS659"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Optimus F5",
    "Device": "l1e",
    "Model": "LG-P870h"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Optimus F5",
    "Device": "l1e",
    "Model": "LG-P875"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Optimus F5",
    "Device": "l1e",
    "Model": "LG-P875h"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Optimus F5",
    "Device": "l1v",
    "Model": "AS870 4G"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Optimus F6",
    "Device": "f6",
    "Model": "LG-D500"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Optimus F6",
    "Device": "f6",
    "Model": "LG-D505"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Optimus F6",
    "Device": "f6",
    "Model": "LGMS500"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Optimus Fuel",
    "Device": "w3c",
    "Model": "LGL34C"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Optimus G Pro",
    "Device": "geevl04e",
    "Model": "L-04E"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Optimus GJ",
    "Device": "geehdc",
    "Model": "LG-E975w"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Optimus GK",
    "Device": "gvfhd",
    "Model": "LG-F220K"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Optimus Hub",
    "Device": "lgc800",
    "Model": "LG-C800"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Optimus Hub",
    "Device": "lgc800g",
    "Model": "LG-C800G"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Optimus Hub",
    "Device": "univa_214-04",
    "Model": "LG-E510"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Optimus Hub",
    "Device": "univa_724-05",
    "Model": "LG-E510f"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Optimus Hub",
    "Device": "univa_730-01",
    "Model": "LG-E510g"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Optimus Hub",
    "Device": "univa_730-03",
    "Model": "LG-E510g"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Optimus Hub",
    "Device": "univa_740-01",
    "Model": "LG-E510g"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Optimus Hub",
    "Device": "univa_clr-br",
    "Model": "LG-E510f"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Optimus Hub",
    "Device": "univa_ctm-xxx",
    "Model": "LG-E510g"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Optimus Hub",
    "Device": "univa_ent-cl",
    "Model": "LG-E510g"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Optimus Hub",
    "Device": "univa_open-br",
    "Model": "LG-E510f"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Optimus Hub",
    "Device": "univa_open-de",
    "Model": "LG-E510"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Optimus Hub",
    "Device": "univa_ssv-xxx",
    "Model": "LG-E510g"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Optimus Hub",
    "Device": "univa_tcl-mx",
    "Model": "LG-E510f"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Optimus Hub",
    "Device": "univa_tlf-es",
    "Model": "LG-E510"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Optimus Hub",
    "Device": "univa_ufn-mx",
    "Model": "LG-E510g"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Optimus Hub",
    "Device": "univa_usc-mx",
    "Model": "LG-E510g"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Optimus Hub",
    "Device": "univa_viv-br",
    "Model": "LG-E510f"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Optimus L40",
    "Device": "w3",
    "Model": "LG-D160"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Optimus L40",
    "Device": "w3",
    "Model": "LG-D165"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Optimus L40",
    "Device": "w3",
    "Model": "LG-D165AR"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Optimus L40",
    "Device": "w3ds",
    "Model": "LG-D170"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Optimus L40",
    "Device": "w3ds",
    "Model": "LG-D175f"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Optimus L40",
    "Device": "w3ts",
    "Model": "LG-D180f"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Optimus L5",
    "Device": "m4",
    "Model": "LG-E610"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Optimus L5",
    "Device": "m4",
    "Model": "LG-E610v"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Optimus L5",
    "Device": "m4",
    "Model": "LG-E612"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Optimus L5",
    "Device": "m4",
    "Model": "LG-E612f"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Optimus L5",
    "Device": "m4",
    "Model": "LG-E612g"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Optimus L5",
    "Device": "m4",
    "Model": "LG-E617G"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Optimus L5",
    "Device": "m4",
    "Model": "LG-L40G"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Optimus L7II",
    "Device": "vee7ds",
    "Model": "LG-P716"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Optimus LIFE",
    "Device": "l1_dcm",
    "Model": "L-02E"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Optimus LTE",
    "Device": "i_dcm",
    "Model": "L-01D"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Optimus LTE",
    "Device": "i_skt",
    "Model": "LG-SU640"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Optimus LTE",
    "Device": "i_u",
    "Model": "LG-LU6200"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Optimus LTE",
    "Device": "iproj",
    "Model": "LG-P936"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Optimus LTE",
    "Device": "lgp930",
    "Model": "LG-P930"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Optimus LTE",
    "Device": "lgp935",
    "Model": "LG-P935"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Optimus Mach",
    "Device": "LU3000",
    "Model": "LG-LU3000"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Optimus Mach",
    "Device": "hub",
    "Model": "LG-LU3000"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Optimus Mach",
    "Device": "lu3000",
    "Model": "LG-LU3000"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Optimus Net",
    "Device": "gelato_302-610",
    "Model": "LG-P690b"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Optimus Net",
    "Device": "gelato_cis-xx",
    "Model": "LG-P690"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Optimus Net",
    "Device": "gelato_sea-xx",
    "Model": "LG-P690"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Optimus Net",
    "Device": "lgl45c",
    "Model": "LGL45C"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Optimus Net Dual",
    "Device": "gelatods_are-xxx",
    "Model": "LG-P698"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Optimus Net Dual",
    "Device": "gelatods_cis-xxx",
    "Model": "LG-P698"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Optimus Net Dual",
    "Device": "gelatods_ind-xxx",
    "Model": "LG-P698"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Optimus Net Dual",
    "Device": "gelatods_open-br",
    "Model": "LG-P698f"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Optimus Net Dual",
    "Device": "gelatods_sea-xxx",
    "Model": "LG-P698"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Optimus One",
    "Device": "ku3700",
    "Model": "LG-KU3700"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Optimus One",
    "Device": "lu3700",
    "Model": "LG-LU3700"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Optimus One",
    "Device": "su370",
    "Model": "LG-SU370"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Optimus One",
    "Device": "thunder_kor-05",
    "Model": "LG-SU370"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Optimus One",
    "Device": "thunder_kor-08",
    "Model": "LG-KU3700"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Optimus One",
    "Device": "thunder_kor-08",
    "Model": "LG-LU3700"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Optimus One",
    "Device": "thunderc",
    "Model": "LG-CX670"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Optimus One",
    "Device": "thunderc",
    "Model": "LG-LW690"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Optimus One",
    "Device": "thunderc",
    "Model": "LG-MS690"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Optimus One",
    "Device": "thunderc",
    "Model": "LG-US670"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Optimus One",
    "Device": "thunderc",
    "Model": "LS670"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Optimus One",
    "Device": "thunderc",
    "Model": "VM670"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Optimus One",
    "Device": "thunderc",
    "Model": "Vortex"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Optimus One",
    "Device": "thunderc",
    "Model": "thunderc"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Optimus PAD LTE",
    "Device": "express",
    "Model": "LG-LU8300"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Optimus Pad",
    "Device": "l06c",
    "Model": "L-06C"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Optimus Pad",
    "Device": "v900",
    "Model": "LG-V900"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Optimus Pad",
    "Device": "v900asia",
    "Model": "LG-V900"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Optimus Pad",
    "Device": "v901ar",
    "Model": "LG-V901"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Optimus Pad",
    "Device": "v901kr",
    "Model": "LG-V901"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Optimus Pad",
    "Device": "v901tr",
    "Model": "LG-V901"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Optimus Pad",
    "Device": "v905r",
    "Model": "LG-V905R"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Optimus Pad",
    "Device": "v909",
    "Model": "LG-V909"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Optimus Pad",
    "Device": "v909mkt",
    "Model": "LG-V909"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Optimus Plus",
    "Device": "m3_acg_us",
    "Model": "LG-AS695"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Optimus Pro",
    "Device": "muscat",
    "Model": "LG-C660"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Optimus Pro",
    "Device": "muscat",
    "Model": "LG-C660R"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Optimus Pro",
    "Device": "muscat",
    "Model": "LG-C660h"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Optimus Q",
    "Device": "lgl55c",
    "Model": "LGL55C"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Optimus Q2",
    "Device": "bssq",
    "Model": "LG-LU6500"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Optimus Q2",
    "Device": "bssq_450-06",
    "Model": "LG-LU6500"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Optimus Slider",
    "Device": "VM701",
    "Model": "LG-VM701"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Optimus Sol",
    "Device": "victor",
    "Model": "LG-E730"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Optimus Sol",
    "Device": "victor",
    "Model": "LG-E730f"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Optimus Spirit",
    "Device": "gelato_505-01",
    "Model": "LG-P690f"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Optimus Spirit",
    "Device": "gelato_eur-xx",
    "Model": "LG-P690"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Optimus Vu",
    "Device": 325,
    "Model": "LG-F100L"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Optimus Vu",
    "Device": "batman",
    "Model": "LG-F100L"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Optimus Vu",
    "Device": "batman",
    "Model": "LG-F100S"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Optimus Vu",
    "Device": "batman_dcm",
    "Model": "L-06DJOJO"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Optimus Vu",
    "Device": "batman_lgu",
    "Model": "LG-F100L"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Optimus Vu",
    "Device": "batman_skt",
    "Model": "LG-F100S"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Optimus Vu",
    "Device": "lge_325_skt",
    "Model": "LG-F100S"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Optimus Vu",
    "Device": "vu10",
    "Model": "LG-P895"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Optimus Vu",
    "Device": "vu10",
    "Model": "LG-P895qb"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Optimus Vu2",
    "Device": "vu2kt",
    "Model": "LG-F200K"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Optimus Vu2",
    "Device": "vu2sk",
    "Model": "LG-F200S"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Optimus Vu2",
    "Device": "vu2u",
    "Model": "LG-F200L"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Optimus Vu2",
    "Device": "vu2u",
    "Model": "LG-F200LS"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Optimus Vu:",
    "Device": "batman_dcm",
    "Model": "L-06D"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Optimus Z",
    "Device": "su950",
    "Model": "SU950"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Optimus Zone",
    "Device": "e0v",
    "Model": "LG-VS410PP"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Optimus chat",
    "Device": "elini",
    "Model": "L-04C"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "PRADA 3.0",
    "Device": "p2",
    "Model": "L-02D"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "PRADA 3.0",
    "Device": "p2",
    "Model": "LG-KU5400"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "PRADA 3.0",
    "Device": "p2",
    "Model": "LG-LU5400"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "PRADA 3.0",
    "Device": "p2",
    "Model": "LG-P940"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "PRADA 3.0",
    "Device": "p2",
    "Model": "LG-P940h"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "PRADA 3.0",
    "Device": "p2",
    "Model": "LG-SU540"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "PecanV",
    "Device": "pecanV",
    "Model": "LG-P355"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Phoenix 3",
    "Device": "lv1",
    "Model": "LG-M150"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Premier",
    "Device": "m209",
    "Model": "LGL61AL"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Premier",
    "Device": "m209",
    "Model": "LGL62VL"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Q31",
    "Device": "mdh5lm",
    "Model": "LM-Q310N"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Q51",
    "Device": "mdh30lm",
    "Model": "LM-Q510N"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Q52",
    "Device": "meh35lm",
    "Model": "LM-Q520N"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Q61",
    "Device": "mdh40lm",
    "Model": "LM-Q630"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Q61",
    "Device": "mdh40lm",
    "Model": "LM-Q630N"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Q62",
    "Device": "meh35lm",
    "Model": "LM-Q626N"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Q8",
    "Device": "anna",
    "Model": "LG-H970"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Q8",
    "Device": "anna",
    "Model": "LGM-X800K"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Q8",
    "Device": "anna",
    "Model": "LGM-X800L"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Q8",
    "Device": "cv7an",
    "Model": "LM-Q815K"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Q8",
    "Device": "cv7an",
    "Model": "LM-Q815L"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Q8",
    "Device": "cv7an",
    "Model": "LM-Q815S"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Q92",
    "Device": "acelm",
    "Model": "LM-Q920N"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "QStylus",
    "Device": "cv7a",
    "Model": "801LG"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "QStylus",
    "Device": "cv7a",
    "Model": "LM-Q710XM"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "QStylus",
    "Device": "mcv7a",
    "Model": "LM-Q710.FG"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "QStylus",
    "Device": "mcv7a",
    "Model": "LM-Q710.FGN"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "QStylus Plus",
    "Device": "mcv7a",
    "Model": "LM-Q710.FGN"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Qua phone PX",
    "Device": "JSG",
    "Model": "LGV33"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Qua tab PX",
    "Device": "b3",
    "Model": "LGT31"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Qua tab PZ",
    "Device": "b5",
    "Model": "LGT32"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Rebel 3",
    "Device": "lv1",
    "Model": "LGL158VL"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Rebel 3",
    "Device": "lv1",
    "Model": "LGL58VL"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Shine Plus with Google",
    "Device": "alohag",
    "Model": "LG-C710h"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Signature",
    "Device": "flashsignaturelm",
    "Model": "LM-V520N"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Smart Dios V8700",
    "Device": "SE_TF",
    "Model": "ref_SCTF"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Spectrum",
    "Device": "i_vzw",
    "Model": "VS920 4G"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Spectrum 2",
    "Device": "d1lv",
    "Model": "VS930 4G"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Spirit 4G",
    "Device": "l1m",
    "Model": "LG-MS870"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Splendor",
    "Device": "u0_cdma",
    "Model": "LG-US730"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Spray",
    "Device": "e2jps",
    "Model": "402LG"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Spree",
    "Device": "e1q",
    "Model": "LG-K120"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Stylo 2 V",
    "Device": "mph1",
    "Model": "VS835"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Stylo 6",
    "Device": "mdh50lm",
    "Model": "LM-Q730"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Swift",
    "Device": "swift",
    "Model": "GT540"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Swift",
    "Device": "swift",
    "Model": "GT540GO"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Swift",
    "Device": "swift",
    "Model": "GT540R"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Swift",
    "Device": "swift",
    "Model": "GT540f"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "TBD",
    "Device": "aka",
    "Model": "LG-F520K"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "TR3BF",
    "Device": "Hi3751V811",
    "Model": "55TR3BG-BX"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "TR3BF",
    "Device": "Hi3751V811",
    "Model": "65TR3BF"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "TR3BF",
    "Device": "Hi3751V811",
    "Model": "86TR3BF"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Thrill 4G",
    "Device": "cosmo_310-410",
    "Model": "LG-P925"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Thrill 4G",
    "Device": "p925",
    "Model": "LG-P925"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "V10",
    "Device": "pplus",
    "Model": "LG-F600K"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "V10",
    "Device": "pplus",
    "Model": "LG-F600L"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "V10",
    "Device": "pplus",
    "Model": "LG-F600S"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "V10",
    "Device": "pplus",
    "Model": "LG-H900"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "V10",
    "Device": "pplus",
    "Model": "LG-H900PR"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "V10",
    "Device": "pplus",
    "Model": "LG-H901"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "V10",
    "Device": "pplus",
    "Model": "LG-H960"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "V10",
    "Device": "pplus",
    "Model": "LG-H961AN"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "V10",
    "Device": "pplus",
    "Model": "LG-H961N"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "V10",
    "Device": "pplus",
    "Model": "LG-H961S"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "V10",
    "Device": "pplus",
    "Model": "LG-H962"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "V10",
    "Device": "pplus",
    "Model": "LG-H968"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "V10",
    "Device": "pplus",
    "Model": "RS987"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "V10",
    "Device": "pplus",
    "Model": "VS990"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "V20",
    "Device": "elsa",
    "Model": "LG-F800K"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "V20",
    "Device": "elsa",
    "Model": "LG-F800L"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "V20",
    "Device": "elsa",
    "Model": "LG-F800S"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "V20",
    "Device": "elsa",
    "Model": "LG-H910"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "V20",
    "Device": "elsa",
    "Model": "LG-H910PR"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "V20",
    "Device": "elsa",
    "Model": "LG-H915"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "V20",
    "Device": "elsa",
    "Model": "LG-H918"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "V20",
    "Device": "elsa",
    "Model": "LG-H990"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "V20",
    "Device": "elsa",
    "Model": "LG-LS997"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "V20",
    "Device": "elsa",
    "Model": "LG-US996"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "V20",
    "Device": "elsa",
    "Model": "LGV34"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "V20",
    "Device": "elsa",
    "Model": "VS995"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "V20 PRO",
    "Device": "L-01J",
    "Model": "L-01J"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "V30",
    "Device": "joan",
    "Model": "LG-AS998"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "V30",
    "Device": "joan",
    "Model": "LG-H930"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "V30",
    "Device": "joan",
    "Model": "LG-H931"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "V30",
    "Device": "joan",
    "Model": "LG-H932"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "V30",
    "Device": "joan",
    "Model": "LG-H932PR"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "V30",
    "Device": "joan",
    "Model": "LG-H933"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "V30",
    "Device": "joan",
    "Model": "LG-LS998"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "V30",
    "Device": "joan",
    "Model": "LG-US998"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "V30",
    "Device": "joan",
    "Model": "LGM-V300K"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "V30",
    "Device": "joan",
    "Model": "LGM-V300L"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "V30",
    "Device": "joan",
    "Model": "LGM-V300S"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "V30",
    "Device": "joan",
    "Model": "VS996"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "V30+",
    "Device": "L-01K",
    "Model": "L-01K"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "V30+",
    "Device": "joan",
    "Model": "LGV35"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "V40 ThinQ",
    "Device": "judypn",
    "Model": "LM-V405"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "V40 ThinQ",
    "Device": "judypn",
    "Model": "LM-V409N"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "V50",
    "Device": "flashlm",
    "Model": "LM-V500XM"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "V50 ThinQ",
    "Device": "flashlm",
    "Model": "LM-V450"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "V50 ThinQ",
    "Device": "flashlmdd",
    "Model": "LM-V500"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "V50S ThinQ",
    "Device": "mh2lm",
    "Model": "LM-V510N"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "V60 ThinQ",
    "Device": "timelm",
    "Model": "A001LG"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "V60 ThinQ",
    "Device": "timelm",
    "Model": "LM-V600"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "VELVET",
    "Device": "caymanlm",
    "Model": "LM-G900"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "VELVET",
    "Device": "caymanlm",
    "Model": "LM-G900N"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "VELVET",
    "Device": "caymanlm",
    "Model": "LM-G910N"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "VELVET",
    "Device": "caymanslm",
    "Model": "LM-G910"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "VELVET",
    "Device": "mcaymanlm",
    "Model": "LM-G900MM"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "VELVET",
    "Device": "mcaymanlm",
    "Model": "LM-G900TM"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "VELVET 2 PRO",
    "Device": "rainbowlm",
    "Model": "LM-V700N"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "VU3",
    "Device": "vu3",
    "Model": "LG-F300K"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "VU3",
    "Device": "vu3",
    "Model": "LG-F300L"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "VU3",
    "Device": "vu3",
    "Model": "LG-F300S"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Velvet",
    "Device": "caymanlm",
    "Model": "LM-G900"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "W10",
    "Device": "LMX130IM",
    "Model": "LMX130IM"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "W10 Alpha",
    "Device": "Neo2ALP",
    "Model": "LM-X210LMW"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "W11",
    "Device": "Neo11LM",
    "Model": "LM-K310IM"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "W30",
    "Device": "LM-X440IM",
    "Model": "LM-X440IM"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "W30",
    "Device": "LM-X440ZM",
    "Model": "LM-X440ZM"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "W30",
    "Device": "LM-X440ZMW",
    "Model": "LM-X440ZMW"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "W30 Pro",
    "Device": "Neo4LM",
    "Model": "LM-X600IM"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "W31",
    "Device": "Neo31LM",
    "Model": "LM-K315IM"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "W41",
    "Device": "mw41lm",
    "Model": "LM-K610IM"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "WM-LG8200",
    "Device": "b6",
    "Model": "LG-V425"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "WM-LG8200",
    "Device": "b6",
    "Model": "WM-LG8200"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Wine Smart",
    "Device": "cf",
    "Model": "LGS01"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Wine Smart",
    "Device": "vfp",
    "Model": "LG-D486"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Wine Smart",
    "Device": "vfp",
    "Model": "LG-F480K"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Wine Smart",
    "Device": "vfp",
    "Model": "LG-F480L"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Wine Smart",
    "Device": "vfp",
    "Model": "LG-F480S"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Wine Smart 3G",
    "Device": "vfp3g",
    "Model": "LG-T480K"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Wine Smart 3G",
    "Device": "vfp3g",
    "Model": "LG-T480S"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "X Mach",
    "Device": "sjr",
    "Model": "LG-K600"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "X charge",
    "Device": "mlv7",
    "Model": "LG-SP320"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "X2 2019",
    "Device": "mh5lm",
    "Model": "LM-X220N"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "X4",
    "Device": "cv3n",
    "Model": "LM-X410K"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "X4",
    "Device": "cv3n",
    "Model": "LM-X415K"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "X4(2019)",
    "Device": "mmh4",
    "Model": "LM-X420N"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "X4+",
    "Device": "cv3n",
    "Model": "LM-X410L"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "X4+",
    "Device": "cv3n",
    "Model": "LM-X410S"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "X4+",
    "Device": "cv3n",
    "Model": "LM-X415L"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "X4+",
    "Device": "cv3n",
    "Model": "LM-X415S"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "X5",
    "Device": "phoenix_sprout",
    "Model": "X5-LG"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "X6(2019)",
    "Device": "mmh4p",
    "Model": "LM-X525"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "X6(2019)",
    "Device": "mmh4p",
    "Model": "LM-X625N"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Y25",
    "Device": "y25",
    "Model": "LGL15G"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Y25",
    "Device": "y25c",
    "Model": "LGL16C"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "ZONE4",
    "Device": "cv1",
    "Model": "LM-X210VPP"
  },
  {
    "Retail Branding": "LGE",
    "Marketing Name": "Zone3",
    "Device": "e1q",
    "Model": "VS425PP"
  },
  {
    "Retail Branding": "LGU+",
    "Marketing Name": "TV G",
    "Device": "smartbox",
    "Model": "TI320-DU"
  },
  {
    "Retail Branding": "LGU+",
    "Marketing Name": "U+ tv UHD",
    "Device": "tvg2",
    "Model": "ST940I-UP"
  },
  {
    "Retail Branding": "LGU+",
    "Marketing Name": "U+ tv woofer",
    "Device": "hg2",
    "Model": "LAP250U"
  },
  {
    "Retail Branding": "LGU+",
    "Marketing Name": "U+ tv woofer 1.5",
    "Device": "hg2_iot",
    "Model": "LAP255U"
  },
  {
    "Retail Branding": "LGU+",
    "Marketing Name": "U+tv Soundbar Black",
    "Device": "ute7057lgu",
    "Model": "ute7057lgu"
  },
  {
    "Retail Branding": "LGU+",
    "Marketing Name": "U+tv Soundbar Black2",
    "Device": "uiy7057lgu",
    "Model": "uiy7057lgu"
  },
  {
    "Retail Branding": "LGU+",
    "Marketing Name": "U+tv UHD2",
    "Device": "tvg2a",
    "Model": "S60UPI"
  },
  {
    "Retail Branding": "LGU+",
    "Marketing Name": "U+tv UHD3",
    "Device": "uie4027lgu",
    "Model": "uie4027lgu"
  },
  {
    "Retail Branding": "LGU+",
    "Marketing Name": "U+tv soundbar",
    "Device": "woofer2",
    "Model": "S60UPA"
  },
  {
    "Retail Branding": "LGU+",
    "Marketing Name": "UHD4K",
    "Device": "UHD4K",
    "Model": "UHD4K"
  },
  {
    "Retail Branding": "LGU+",
    "Marketing Name": "UHD4T",
    "Device": "uie4057lgu",
    "Model": "uie4057lgu"
  },
  {
    "Retail Branding": "LGU+",
    "Marketing Name": "WA-U420D",
    "Device": "WA-U420D",
    "Model": "WA-U420D"
  },
  {
    "Retail Branding": "LG_Electronics",
    "Marketing Name": "TR3DK",
    "Device": "TR3DK",
    "Model": "TR3DK"
  },
  {
    "Retail Branding": "LG_Electronics",
    "Marketing Name": "TR3DQ-B",
    "Device": "TR3DQ-B",
    "Model": "TR3DQ-B"
  },
  {
    "Retail Branding": "LG_Electronics",
    "Marketing Name": "TR3ER-B",
    "Device": "TR3ER-B",
    "Model": "TR3ER-B"
  },
  {
    "Retail Branding": "LG_Electronics",
    "Marketing Name": "TR3PN",
    "Device": "rk3588_t",
    "Model": "TR3PN"
  },
  {
    "Retail Branding": "LIAONING YIYATONG",
    "Marketing Name": "DISNEY_Tablet_PC",
    "Device": "DISNEY_Tablet_PC",
    "Model": "DS2310-70LP"
  },
  {
    "Retail Branding": "LIAONING YIYATONG",
    "Marketing Name": "IRULU_MID",
    "Device": "IRULU_MID",
    "Model": "X10"
  },
  {
    "Retail Branding": "LIBERTON",
    "Marketing Name": "Smart TV",
    "Device": "longshan",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "LIBERTON",
    "Marketing Name": "Smart TV",
    "Device": "osaka",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "LIBERTON",
    "Marketing Name": "Smart TV",
    "Device": "redwood",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "LIFE Digital",
    "Marketing Name": "K3102_4G",
    "Device": "K3102_4G",
    "Model": "ITELL K3102 4G"
  },
  {
    "Retail Branding": "LIFE Digital",
    "Marketing Name": "K3102_W",
    "Device": "K3102_W",
    "Model": "K3102_W"
  },
  {
    "Retail Branding": "LIFE Digital",
    "Marketing Name": "K3102_WIFI",
    "Device": "K3102_WIFI",
    "Model": "K3102 WIFI"
  },
  {
    "Retail Branding": "LIFEPHONE",
    "Marketing Name": "HERO",
    "Device": "LIFEPHONE_HERO",
    "Model": "HERO"
  },
  {
    "Retail Branding": "LIFEPHONE",
    "Marketing Name": "IDOL",
    "Device": "LIFEPHONE_IDOL",
    "Model": "IDOL"
  },
  {
    "Retail Branding": "LIFEPHONE",
    "Marketing Name": "SIMPLE",
    "Device": "LIFEPHONE_SIMPLE",
    "Model": "SIMPLE"
  },
  {
    "Retail Branding": "LIFEPHONE",
    "Marketing Name": "STAR",
    "Device": "LIFEPHONE_STAR",
    "Model": "STAR"
  },
  {
    "Retail Branding": "LIFEPHONE",
    "Marketing Name": "VISION",
    "Device": "LIFEPHONE_VISION",
    "Model": "VISION"
  },
  {
    "Retail Branding": "LIFEPHONE",
    "Marketing Name": "WATER",
    "Device": "WATER",
    "Model": "WATER"
  },
  {
    "Retail Branding": "LIFEPHONE",
    "Marketing Name": "WORLD",
    "Device": "WORLD",
    "Model": "WORLD"
  },
  {
    "Retail Branding": "LINNEX",
    "Marketing Name": "LI22",
    "Device": "LI22",
    "Model": "LI22"
  },
  {
    "Retail Branding": "LINSAY",
    "Marketing Name": "F-7HD2CORE / F-7HD4CORE / F-10HD2CORE /F-10XHD4CORE",
    "Device": "F-7HD2CORE",
    "Model": "LINSAY F-7HD2CORE/F-7HD4CORE/F-10HD2CORE/F-10XHD4CORE"
  },
  {
    "Retail Branding": "LISTO",
    "Marketing Name": "France, Belgium, Germany, The Netherlands, Italy, Spain, Portugal",
    "Device": "yeongdeungpo",
    "Model": "LISTO Android TV"
  },
  {
    "Retail Branding": "LISTO",
    "Marketing Name": "Rumania",
    "Device": "tamachi",
    "Model": "LISTO Android TV"
  },
  {
    "Retail Branding": "LLA",
    "Marketing Name": "Orion",
    "Device": "SEI500L",
    "Model": "Orion"
  },
  {
    "Retail Branding": "LLA",
    "Marketing Name": "VIP6102W LLA-PA",
    "Device": "vip6102w",
    "Model": "VIP6102W"
  },
  {
    "Retail Branding": "LLA",
    "Marketing Name": "VIP6102W-LLA",
    "Device": "vip6102w",
    "Model": "VIP6102W"
  },
  {
    "Retail Branding": "LLOYD",
    "Marketing Name": "Android TV",
    "Device": "R1",
    "Model": "ATV R1"
  },
  {
    "Retail Branding": "LLOYD",
    "Marketing Name": "Android TV",
    "Device": "R2",
    "Model": "ATV R2"
  },
  {
    "Retail Branding": "LLOYD",
    "Marketing Name": "Havells India Ltd",
    "Device": "landen",
    "Model": "LLO41F"
  },
  {
    "Retail Branding": "LLOYD",
    "Marketing Name": "Havells India Ltd",
    "Device": "landen",
    "Model": "LLOYD SMART TV 2K"
  },
  {
    "Retail Branding": "LLOYD",
    "Marketing Name": "LLOYD 2K SMART TV",
    "Device": "umeda",
    "Model": "LLOYD 2K SMART TV"
  },
  {
    "Retail Branding": "LLOYD",
    "Marketing Name": "LLOYD 4K SMART NF TV",
    "Device": "SW6H",
    "Model": "LLOYD 4K SMART NF TV"
  },
  {
    "Retail Branding": "LLOYD",
    "Marketing Name": "LLOYD 4K SMART TV",
    "Device": "SW6H",
    "Model": "LLOYD 4K SMART TV"
  },
  {
    "Retail Branding": "LLOYD",
    "Marketing Name": "LLOYD 4K SMART TV",
    "Device": "anaheim",
    "Model": "LLOYD 4K SMART TV"
  },
  {
    "Retail Branding": "LLOYD",
    "Marketing Name": "R3",
    "Device": "R3",
    "Model": "R3"
  },
  {
    "Retail Branding": "LNMBBS",
    "Marketing Name": "H11-EEA",
    "Device": "H11-EEA",
    "Model": "H11-EEA"
  },
  {
    "Retail Branding": "LNMBBS",
    "Marketing Name": "L18",
    "Device": "L18",
    "Model": "L18"
  },
  {
    "Retail Branding": "LNMBBS",
    "Marketing Name": "L18-EEA",
    "Device": "L18-EEA",
    "Model": "L18-EEA"
  },
  {
    "Retail Branding": "LNMBBS",
    "Marketing Name": "L20",
    "Device": "L20",
    "Model": "L20"
  },
  {
    "Retail Branding": "LNMBBS",
    "Marketing Name": "L20-EEA",
    "Device": "L20-EEA",
    "Model": "L20-EEA"
  },
  {
    "Retail Branding": "LNMBBS",
    "Marketing Name": "L201-EEA",
    "Device": "L201-EEA",
    "Model": "L201-EEA"
  },
  {
    "Retail Branding": "LNMBBS",
    "Marketing Name": "L21-EEA",
    "Device": "L21-EEA",
    "Model": "L21-EEA"
  },
  {
    "Retail Branding": "LNMBBS",
    "Marketing Name": "L211",
    "Device": "L211",
    "Model": "L211"
  },
  {
    "Retail Branding": "LNMBBS",
    "Marketing Name": "L23",
    "Device": "L23",
    "Model": "L23"
  },
  {
    "Retail Branding": "LNMBBS",
    "Marketing Name": "L23-EEA",
    "Device": "L23-EEA",
    "Model": "L23-EEA"
  },
  {
    "Retail Branding": "LNMBBS",
    "Marketing Name": "L28-EEA",
    "Device": "L28-EEA",
    "Model": "L28-EEA"
  },
  {
    "Retail Branding": "LNMBBS",
    "Marketing Name": "L301",
    "Device": "L301",
    "Model": "L301"
  },
  {
    "Retail Branding": "LNMBBS",
    "Marketing Name": "L60",
    "Device": "L60",
    "Model": "L60"
  },
  {
    "Retail Branding": "LNMBBS",
    "Marketing Name": "L80",
    "Device": "L80",
    "Model": "L80"
  },
  {
    "Retail Branding": "LNMBBS",
    "Marketing Name": "L80-EEA",
    "Device": "L80-EEA",
    "Model": "L80-EEA"
  },
  {
    "Retail Branding": "LNMBBS",
    "Marketing Name": "L80_EEA",
    "Device": "L80_EEA",
    "Model": "L80_EEA"
  },
  {
    "Retail Branding": "LNMBBS",
    "Marketing Name": "L80_US",
    "Device": "L80_US",
    "Model": "L80_US"
  },
  {
    "Retail Branding": "LNMBBS",
    "Marketing Name": "P40-EEA",
    "Device": "P40-EEA",
    "Model": "P40-EEA"
  },
  {
    "Retail Branding": "LNMBBS",
    "Marketing Name": "P401",
    "Device": "P401",
    "Model": "P401"
  },
  {
    "Retail Branding": "LOFT",
    "Marketing Name": "D4xx",
    "Device": "D4",
    "Model": "D4_Interactive_Display"
  },
  {
    "Retail Branding": "LOGIC",
    "Marketing Name": "HX_Series",
    "Device": "MTK9679",
    "Model": "Logic_LT_IRXXHX"
  },
  {
    "Retail Branding": "LOGIC",
    "Marketing Name": "L65E",
    "Device": "L65E",
    "Model": "L65E"
  },
  {
    "Retail Branding": "LOGIC",
    "Marketing Name": "L66F",
    "Device": "L66F",
    "Model": "L66F"
  },
  {
    "Retail Branding": "LOGIC",
    "Marketing Name": "LOGIC L66M",
    "Device": "LOGIC_L66M",
    "Model": "LOGIC L66M"
  },
  {
    "Retail Branding": "LOGIC",
    "Marketing Name": "LOGIC_G2L",
    "Device": "LOGIC_G2L",
    "Model": "LOGIC G2L"
  },
  {
    "Retail Branding": "LOGIC",
    "Marketing Name": "LOGIC_L55V",
    "Device": "LOGIC_L55V",
    "Model": "LOGIC_L55V"
  },
  {
    "Retail Branding": "LOGIC",
    "Marketing Name": "Logic L68M Plus",
    "Device": "Logic_L68M_Plus",
    "Model": "Logic L68M Plus"
  },
  {
    "Retail Branding": "LOGIC",
    "Marketing Name": "Logic_L-PAD_PRO",
    "Device": "Logic_L-PAD_PRO",
    "Model": "Logic L-PAD_PRO"
  },
  {
    "Retail Branding": "LOGIC",
    "Marketing Name": "Online Instruments India Pvt. Ltd.",
    "Device": "rk3576_u",
    "Model": "Logic_LT_IRXXHX"
  },
  {
    "Retail Branding": "LOGIC",
    "Marketing Name": "ZX_Series",
    "Device": "rk3576_u",
    "Model": "Logic_LT_IRXXZX"
  },
  {
    "Retail Branding": "LONG-LIFE",
    "Marketing Name": "TabLL08_13_24",
    "Device": "TabLL08_13_24",
    "Model": "TabLL08_13_24"
  },
  {
    "Retail Branding": "LOOQS",
    "Marketing Name": "F102-EEA",
    "Device": "F102-EEA",
    "Model": "F102-EEA"
  },
  {
    "Retail Branding": "LOOQS",
    "Marketing Name": "F102-T610P-EEA",
    "Device": "F102-T610P-EEA",
    "Model": "F102-T610P-EEA"
  },
  {
    "Retail Branding": "LOOQS",
    "Marketing Name": "L108MR",
    "Device": "L108MR",
    "Model": "L108MR"
  },
  {
    "Retail Branding": "LOWI",
    "Marketing Name": "DECO LOWI DIW252",
    "Device": "m252_lowi",
    "Model": "DECO LOWI DIW252"
  },
  {
    "Retail Branding": "LP (TN)",
    "Marketing Name": "LP Legend",
    "Device": "LP_Legend",
    "Model": "LP Legend"
  },
  {
    "Retail Branding": "LP (TN)",
    "Marketing Name": "LP_N60",
    "Device": "LP_N60",
    "Model": "LP N60"
  },
  {
    "Retail Branding": "LP (TN)",
    "Marketing Name": "LP_Pro1",
    "Device": "LP_Pro1",
    "Model": "LP_Pro1"
  },
  {
    "Retail Branding": "LP (TN)",
    "Marketing Name": "LP_T70",
    "Device": "LP_T70",
    "Model": "LP_T70"
  },
  {
    "Retail Branding": "LP (TN)",
    "Marketing Name": "LP_T70_Lite",
    "Device": "LP_T70_Lite",
    "Model": "LP_T70_Lite"
  },
  {
    "Retail Branding": "LP (TN)",
    "Marketing Name": "Lisa Pro",
    "Device": "Lisa_Pro",
    "Model": "Lisa Pro"
  },
  {
    "Retail Branding": "LP (TN)",
    "Marketing Name": "N-50",
    "Device": "LP_N_50",
    "Model": "N-50"
  },
  {
    "Retail Branding": "LP (TN)",
    "Marketing Name": "N-57",
    "Device": "LP_N_57",
    "Model": "N-57"
  },
  {
    "Retail Branding": "LP (TN)",
    "Marketing Name": "N-57",
    "Device": "N-57",
    "Model": "N-57"
  },
  {
    "Retail Branding": "LP (TN)",
    "Marketing Name": "N-57+",
    "Device": "N-57-Plus",
    "Model": "N-57"
  },
  {
    "Retail Branding": "LP (TN)",
    "Marketing Name": "N-60",
    "Device": "N-60",
    "Model": "N-60"
  },
  {
    "Retail Branding": "LP (TN)",
    "Marketing Name": "N-60",
    "Device": "N60",
    "Model": "N-60"
  },
  {
    "Retail Branding": "LP (TN)",
    "Marketing Name": "T100",
    "Device": "T100",
    "Model": "LP_T100"
  },
  {
    "Retail Branding": "LP (TN)",
    "Marketing Name": "T100",
    "Device": "T100",
    "Model": "T100"
  },
  {
    "Retail Branding": "LP (TN)",
    "Marketing Name": "VYPER PRO",
    "Device": "Vyper_PRO",
    "Model": "Vyper PRO"
  },
  {
    "Retail Branding": "LP (TN)",
    "Marketing Name": "W55",
    "Device": "W55",
    "Model": "W55"
  },
  {
    "Retail Branding": "LSHUN",
    "Marketing Name": "C8P4",
    "Device": "C8P4",
    "Model": "C8P4"
  },
  {
    "Retail Branding": "LT Electronics",
    "Marketing Name": "K100",
    "Device": "K100",
    "Model": "K100"
  },
  {
    "Retail Branding": "LT Electronics",
    "Marketing Name": "K200",
    "Device": "K200",
    "Model": "K200"
  },
  {
    "Retail Branding": "LT Electronics",
    "Marketing Name": "K700",
    "Device": "SPURT_K700",
    "Model": "K700"
  },
  {
    "Retail Branding": "LT Electronics",
    "Marketing Name": "LT C4300",
    "Device": "LT_C4300",
    "Model": "LT C4300"
  },
  {
    "Retail Branding": "LT Electronics",
    "Marketing Name": "LT-NOTE-10S",
    "Device": "LT-NOTE-10S",
    "Model": "LT-NOTE 10S"
  },
  {
    "Retail Branding": "LT Electronics",
    "Marketing Name": "LT_C1500",
    "Device": "LT_C1500",
    "Model": "LT_C1500"
  },
  {
    "Retail Branding": "LT Electronics",
    "Marketing Name": "LT_C2100",
    "Device": "LT_C2100",
    "Model": "LT_C2100"
  },
  {
    "Retail Branding": "LT Electronics",
    "Marketing Name": "LT_C2200",
    "Device": "LT_C2200",
    "Model": "LT C2200"
  },
  {
    "Retail Branding": "LT Electronics",
    "Marketing Name": "LT_C3300",
    "Device": "LT_C3300",
    "Model": "LT_C3300"
  },
  {
    "Retail Branding": "LT Electronics",
    "Marketing Name": "LT_C3500",
    "Device": "LT_C3500",
    "Model": "LT_C3500"
  },
  {
    "Retail Branding": "LT Electronics",
    "Marketing Name": "LT_M7",
    "Device": "LT_M7",
    "Model": "LT M7"
  },
  {
    "Retail Branding": "LT Electronics",
    "Marketing Name": "LT_S10_Lite",
    "Device": "LT_S10_Lite",
    "Model": "LT_S10_Lite"
  },
  {
    "Retail Branding": "LT Electronics",
    "Marketing Name": "LT_S9_NOTE",
    "Device": "LT_S9_NOTE",
    "Model": "LT_S9_NOTE"
  },
  {
    "Retail Branding": "LT Electronics",
    "Marketing Name": "LT_X5",
    "Device": "LT_X5",
    "Model": "LT_X5"
  },
  {
    "Retail Branding": "LT Electronics",
    "Marketing Name": "SPURT_K300",
    "Device": "SPURT_K300",
    "Model": "K300"
  },
  {
    "Retail Branding": "LT Electronics",
    "Marketing Name": "SPURT_K400",
    "Device": "SPURT_K400",
    "Model": "K400"
  },
  {
    "Retail Branding": "LT Electronics",
    "Marketing Name": "SPURT_K500",
    "Device": "SPURT_K500",
    "Model": "K500"
  },
  {
    "Retail Branding": "LT Electronics",
    "Marketing Name": "SPURT_K600",
    "Device": "SPURT_K600",
    "Model": "K600"
  },
  {
    "Retail Branding": "LTC(LR)",
    "Marketing Name": "LTC1066",
    "Device": "LTC1066",
    "Model": "LTC1066"
  },
  {
    "Retail Branding": "LT_Mobile",
    "Marketing Name": "LT 2003",
    "Device": "LT_2003",
    "Model": "LT 2003"
  },
  {
    "Retail Branding": "LT_Mobile",
    "Marketing Name": "LT-E6707",
    "Device": "LT_Mobile_E6707",
    "Model": "LT-E6707"
  },
  {
    "Retail Branding": "LT_Mobile",
    "Marketing Name": "LT_6217",
    "Device": "LT_6217",
    "Model": "LT_6217"
  },
  {
    "Retail Branding": "LT_Mobile",
    "Marketing Name": "LT_6509",
    "Device": "LT_6509",
    "Model": "LT_6509"
  },
  {
    "Retail Branding": "LT_Mobile",
    "Marketing Name": "LT_8102",
    "Device": "LT_8102",
    "Model": "LT_8102"
  },
  {
    "Retail Branding": "LT_Mobile",
    "Marketing Name": "LT_8103",
    "Device": "LT_8103",
    "Model": "LT_8103"
  },
  {
    "Retail Branding": "LT_Mobile",
    "Marketing Name": "LT_8106",
    "Device": "LT_8106",
    "Model": "LT_8106"
  },
  {
    "Retail Branding": "LT_Mobile",
    "Marketing Name": "LT_8110",
    "Device": "LT_8110",
    "Model": "LT_8110"
  },
  {
    "Retail Branding": "LT_Mobile",
    "Marketing Name": "LT_8501",
    "Device": "LT_8501",
    "Model": "LT_8501"
  },
  {
    "Retail Branding": "LT_Mobile",
    "Marketing Name": "LT_9701",
    "Device": "LT_9701",
    "Model": "LT_9701"
  },
  {
    "Retail Branding": "LT_Mobile",
    "Marketing Name": "LT_9902",
    "Device": "LT_9902",
    "Model": "LT_9902"
  },
  {
    "Retail Branding": "LT_Mobile",
    "Marketing Name": "LT_9904",
    "Device": "LT_9904",
    "Model": "LT_9904"
  },
  {
    "Retail Branding": "LT_Mobile",
    "Marketing Name": "LT_9906",
    "Device": "LT_9906",
    "Model": "LT_9906"
  },
  {
    "Retail Branding": "LT_Mobile",
    "Marketing Name": "LT_K80",
    "Device": "LT_mobile_K80",
    "Model": "LT K80"
  },
  {
    "Retail Branding": "LT_Mobile",
    "Marketing Name": "LT_mobile_C26",
    "Device": "LT_mobile_C26",
    "Model": "LT C26"
  },
  {
    "Retail Branding": "LT_Mobile",
    "Marketing Name": "LT_mobile_C27",
    "Device": "LT_mobile_C27",
    "Model": "LT C27"
  },
  {
    "Retail Branding": "LT_Mobile",
    "Marketing Name": "LT_mobile_C60",
    "Device": "LT_mobile_C60",
    "Model": "LT C60"
  },
  {
    "Retail Branding": "LT_Mobile",
    "Marketing Name": "LT_mobile_E16",
    "Device": "LT_mobile_E16",
    "Model": "LT E16"
  },
  {
    "Retail Branding": "LT_Mobile",
    "Marketing Name": "LT_mobile_E18",
    "Device": "LT_mobile_E18",
    "Model": "LT E18"
  },
  {
    "Retail Branding": "LT_Mobile",
    "Marketing Name": "LT_mobile_K80",
    "Device": "LT_mobile_K80",
    "Model": "LT K80"
  },
  {
    "Retail Branding": "LT_Mobile",
    "Marketing Name": "LT_mobile_S22",
    "Device": "LT_mobile_S22",
    "Model": "S22"
  },
  {
    "Retail Branding": "LT_Mobile",
    "Marketing Name": "LT_mobile_S33",
    "Device": "LT_mobile_S33",
    "Model": "LT S33"
  },
  {
    "Retail Branding": "LT_Mobile",
    "Marketing Name": "LT_mobile_S34",
    "Device": "LT_mobile_S34",
    "Model": "LT S34"
  },
  {
    "Retail Branding": "LT_Mobile",
    "Marketing Name": "LT_mobile_S40",
    "Device": "LT_mobile_S40",
    "Model": "LT S40"
  },
  {
    "Retail Branding": "LUCOMS",
    "Marketing Name": "Android TV",
    "Device": "R1",
    "Model": "ATV R1"
  },
  {
    "Retail Branding": "LUCOMS",
    "Marketing Name": "Android TV",
    "Device": "R2",
    "Model": "ATV R2"
  },
  {
    "Retail Branding": "LUCOMS",
    "Marketing Name": "IWB",
    "Device": "rk3588_t",
    "Model": "siwxxf1x"
  },
  {
    "Retail Branding": "LUCOMS",
    "Marketing Name": "LUCMOS",
    "Device": "hongkong",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "LUCOMS",
    "Marketing Name": "LUCOMS",
    "Device": "elliniko",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "LUCOMS",
    "Marketing Name": "LUCOMS",
    "Device": "mountbaker",
    "Model": "2K SMART TV"
  },
  {
    "Retail Branding": "LUCOMS",
    "Marketing Name": "LUCOMS",
    "Device": "stanford",
    "Model": "2K SMART TV"
  },
  {
    "Retail Branding": "LUCOMS",
    "Marketing Name": "LUCOMS",
    "Device": "zhongshan",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "LUCOMS",
    "Marketing Name": "Smart TV",
    "Device": "alimos",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "LUCOMS",
    "Marketing Name": "UHD Android TV",
    "Device": "sindorim",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "LUKE",
    "Marketing Name": "AT11R464_LUKE",
    "Device": "AT11R464_LUKE",
    "Model": "AT11R464"
  },
  {
    "Retail Branding": "LUMIO",
    "Marketing Name": "LUMIO",
    "Device": "khardi",
    "Model": "LUMIO VISION"
  },
  {
    "Retail Branding": "LUMIO",
    "Marketing Name": "Lumio Arc 5",
    "Device": "himalaya",
    "Model": "Lumio Arc 5"
  },
  {
    "Retail Branding": "LUMIO",
    "Marketing Name": "Lumio Arc 7",
    "Device": "himalaya",
    "Model": "Lumio Arc 7"
  },
  {
    "Retail Branding": "LUMOS",
    "Marketing Name": "LUMOS_KIDS_TABLET",
    "Device": "LUMOS_KIDS_TABLET",
    "Model": "LUMOS_KIDS_TABLET"
  },
  {
    "Retail Branding": "LUMOS",
    "Marketing Name": "LUMOS_TABLET",
    "Device": "LUMOS_TABLET",
    "Model": "LUMOS_TABLET"
  },
  {
    "Retail Branding": "LUMOS",
    "Marketing Name": "LUMOS_TABLET_PRO",
    "Device": "LUMOS_TABLET_PRO",
    "Model": "LUMOS_TABLET_PRO"
  },
  {
    "Retail Branding": "LUMOS",
    "Marketing Name": "LUMOS_TABLET_ULTRA",
    "Device": "LUMOS_TABLET_ULTRA",
    "Model": "LUMOS_TABLET_ULTRA"
  },
  {
    "Retail Branding": "LUMUS",
    "Marketing Name": "INNOSR545",
    "Device": "INNOSR545",
    "Model": "INNOSR545"
  },
  {
    "Retail Branding": "LUMUS",
    "Marketing Name": "NEOSC600",
    "Device": "NEOSC600",
    "Model": "NEOSC600"
  },
  {
    "Retail Branding": "LUMUS",
    "Marketing Name": "NEOSR620",
    "Device": "NEOSR620",
    "Model": "NEOSR620"
  },
  {
    "Retail Branding": "LUNA",
    "Marketing Name": "LUNA G9",
    "Device": "LUNA_G9",
    "Model": "LUNA G9"
  },
  {
    "Retail Branding": "LUNA",
    "Marketing Name": "LUNA T10",
    "Device": "LUNA_T10",
    "Model": "LUNA T10"
  },
  {
    "Retail Branding": "LUNA",
    "Marketing Name": "LUNA V10",
    "Device": "LUNA_V10",
    "Model": "LUNA V10"
  },
  {
    "Retail Branding": "LUNA",
    "Marketing Name": "LUNA V6",
    "Device": "LUNA_V6",
    "Model": "LUNA V6"
  },
  {
    "Retail Branding": "LUNA",
    "Marketing Name": "LUNA V6 3GB",
    "Device": "LUNA_V6_3GB",
    "Model": "LUNA V6 3GB"
  },
  {
    "Retail Branding": "LUNA",
    "Marketing Name": "LUNA V6 4GB",
    "Device": "LUNA_V6_4GB",
    "Model": "LUNA V6 4GB"
  },
  {
    "Retail Branding": "LUNA",
    "Marketing Name": "LUNA_G6",
    "Device": "G6",
    "Model": "LUNA G6"
  },
  {
    "Retail Branding": "LUNA",
    "Marketing Name": "LUNA_G6E",
    "Device": "G6E",
    "Model": "LUNA G6E"
  },
  {
    "Retail Branding": "LUNAR",
    "Marketing Name": "Lunar Eclipse L1",
    "Device": "Lunar_Eclipse_L1",
    "Model": "Eclipse L1"
  },
  {
    "Retail Branding": "LUO(A)",
    "Marketing Name": "P70 Pro",
    "Device": "P70_Pro",
    "Model": "P70 Pro"
  },
  {
    "Retail Branding": "LUO(A)",
    "Marketing Name": "S15 Pro",
    "Device": "S15_Pro",
    "Model": "S15 Pro"
  },
  {
    "Retail Branding": "LUO(A)",
    "Marketing Name": "S16 Pro",
    "Device": "S16_Pro",
    "Model": "S16 Pro"
  },
  {
    "Retail Branding": "LUO(A)",
    "Marketing Name": "S17 Pro",
    "Device": "S17_Pro",
    "Model": "S17 Pro"
  },
  {
    "Retail Branding": "LUO(A)",
    "Marketing Name": "S18 Max",
    "Device": "S18_Max",
    "Model": "S18 Max"
  },
  {
    "Retail Branding": "LUSH_MINT",
    "Marketing Name": "L1582C",
    "Device": "L1582C",
    "Model": "L1582C"
  },
  {
    "Retail Branding": "LUSH_MINT",
    "Marketing Name": "L1589K",
    "Device": "L1589K",
    "Model": "L1589K"
  },
  {
    "Retail Branding": "LUSH_MINT",
    "Marketing Name": "LM5314G",
    "Device": "LM5314G",
    "Model": "LM5314G"
  },
  {
    "Retail Branding": "LUSH_MINT",
    "Marketing Name": "LM5414G",
    "Device": "LM5414G",
    "Model": "LM5414G"
  },
  {
    "Retail Branding": "LUSH_MINT",
    "Marketing Name": "LM5424G",
    "Device": "LM5424G",
    "Model": "LM5424G"
  },
  {
    "Retail Branding": "LUSH_MINT",
    "Marketing Name": "LM5514G",
    "Device": "LM5514G",
    "Model": "LM5514G"
  },
  {
    "Retail Branding": "LUVO",
    "Marketing Name": "001",
    "Device": "luvo_001",
    "Model": "Luvo 001"
  },
  {
    "Retail Branding": "LUVO",
    "Marketing Name": "001L",
    "Device": "LUVO-001L",
    "Model": "LUVO 001L"
  },
  {
    "Retail Branding": "LUXO",
    "Marketing Name": "LUXO C1",
    "Device": "C1",
    "Model": "C1"
  },
  {
    "Retail Branding": "LUXYA",
    "Marketing Name": "MID704DC Tablet / Bitmore Tab770",
    "Device": "MY7317P",
    "Model": "MID704DC"
  },
  {
    "Retail Branding": "LVILLE",
    "Marketing Name": "TP1005",
    "Device": "TP1005",
    "Model": "TP1005"
  },
  {
    "Retail Branding": "LVILLE",
    "Marketing Name": "TP1005_EEA",
    "Device": "TP1005_EEA",
    "Model": "TP1005"
  },
  {
    "Retail Branding": "LVILLE",
    "Marketing Name": "TPC1013",
    "Device": "TPC1013",
    "Model": "TPC1013"
  },
  {
    "Retail Branding": "LVILLE",
    "Marketing Name": "TPC1013_EEA",
    "Device": "TPC1013_EEA",
    "Model": "TPC1013_EEA"
  },
  {
    "Retail Branding": "LW",
    "Marketing Name": "LW688",
    "Device": "LW688",
    "Model": "LW688"
  },
  {
    "Retail Branding": "LW",
    "Marketing Name": "LW788",
    "Device": "LW788",
    "Model": "LW788"
  },
  {
    "Retail Branding": "LYKONDA",
    "Marketing Name": "LY523",
    "Device": "LY523",
    "Model": "LY523"
  },
  {
    "Retail Branding": "LYNKNEX",
    "Marketing Name": "LYNKNEX PX5",
    "Device": "LYNKNEX-PX5",
    "Model": "PX5"
  },
  {
    "Retail Branding": "LYNKNEX",
    "Marketing Name": "PX350",
    "Device": "PX350",
    "Model": "PX350"
  },
  {
    "Retail Branding": "LYNKNEX",
    "Marketing Name": "PX5",
    "Device": "LYNKNEX-PX5",
    "Model": "PX5"
  },
  {
    "Retail Branding": "LYOTECH_LABS",
    "Marketing Name": "LFi_ONE_EEA",
    "Device": "LFi_ONE",
    "Model": "LFi ONE"
  },
  {
    "Retail Branding": "LZF(shenzhen)",
    "Marketing Name": "Z2",
    "Device": "Z2",
    "Model": "Z2"
  },
  {
    "Retail Branding": "LZF(shenzhen)",
    "Marketing Name": "Z3",
    "Device": "Z3",
    "Model": "Z3"
  },
  {
    "Retail Branding": "LZU_lzu",
    "Marketing Name": "D113",
    "Device": "D113",
    "Model": "D113"
  },
  {
    "Retail Branding": "LZU_lzu",
    "Marketing Name": "D113_EEA",
    "Device": "D113_EEA",
    "Model": "D113_EEA"
  },
  {
    "Retail Branding": "Label_King_Turbo",
    "Marketing Name": "LKT_P1095",
    "Device": "LKT_P1095",
    "Model": "LKT_P1095"
  },
  {
    "Retail Branding": "Laiq",
    "Marketing Name": "GLAM",
    "Device": "LAIQ_Glam",
    "Model": "LAIQ Glam"
  },
  {
    "Retail Branding": "Laiq",
    "Marketing Name": "Glow",
    "Device": "Glow",
    "Model": "Glow"
  },
  {
    "Retail Branding": "Laiq",
    "Marketing Name": "STARTRAIL 8",
    "Device": "STARTRAIL",
    "Model": "STARTRAIL 8"
  },
  {
    "Retail Branding": "Lamborghini",
    "Marketing Name": "SDIS1",
    "Device": "sdis1",
    "Model": "Lamborghini tablet"
  },
  {
    "Retail Branding": "Land Rover",
    "Marketing Name": "Explore",
    "Device": "LRExplore",
    "Model": "Land Rover Explore"
  },
  {
    "Retail Branding": "Land Rover",
    "Marketing Name": "Land Rover Explore R",
    "Device": "LRExploreR",
    "Model": "Land Rover Explore R"
  },
  {
    "Retail Branding": "Landbyte",
    "Marketing Name": "LT5030",
    "Device": "LT5030",
    "Model": "LT5030"
  },
  {
    "Retail Branding": "Landbyte",
    "Marketing Name": "Lt6248",
    "Device": "Lt6248",
    "Model": "Lt6248"
  },
  {
    "Retail Branding": "Lango",
    "Marketing Name": "LANGO OPS8195",
    "Device": "OPS-8195A",
    "Model": "OPS-8195A-3-V0"
  },
  {
    "Retail Branding": "Lanix",
    "Marketing Name": "ALPHA 2",
    "Device": "ALPHA2",
    "Model": "ALPHA 2"
  },
  {
    "Retail Branding": "Lanix",
    "Marketing Name": "ALPHA 6",
    "Device": "ALPHA6",
    "Model": "ALPHA 6"
  },
  {
    "Retail Branding": "Lanix",
    "Marketing Name": "ALPHA4",
    "Device": "ALPHA4",
    "Model": "ALPHA 4"
  },
  {
    "Retail Branding": "Lanix",
    "Marketing Name": "Alpha 1R",
    "Device": "Alpha_1R",
    "Model": "Alpha 1R"
  },
  {
    "Retail Branding": "Lanix",
    "Marketing Name": "Alpha 1V",
    "Device": "Alpha_1V",
    "Model": "Alpha 1V"
  },
  {
    "Retail Branding": "Lanix",
    "Marketing Name": "Alpha 3R",
    "Device": "ALPHA_3R",
    "Model": "Alpha 3R"
  },
  {
    "Retail Branding": "Lanix",
    "Marketing Name": "Alpha 5V",
    "Device": "Alpha_5V",
    "Model": "Alpha 5V"
  },
  {
    "Retail Branding": "Lanix",
    "Marketing Name": "Alpha 9V",
    "Device": "Alpha_9V",
    "Model": "Alpha 9V"
  },
  {
    "Retail Branding": "Lanix",
    "Marketing Name": "Alpha_1VPlus",
    "Device": "Alpha_1VPlus",
    "Model": "Alpha 1V"
  },
  {
    "Retail Branding": "Lanix",
    "Marketing Name": "Alpha_3V",
    "Device": "Alpha_3V",
    "Model": "Alpha 3V"
  },
  {
    "Retail Branding": "Lanix",
    "Marketing Name": "Alpha_950",
    "Device": "Alpha_950",
    "Model": "Alpha 950"
  },
  {
    "Retail Branding": "Lanix",
    "Marketing Name": "Alpha_950XL",
    "Device": "Alpha_950XL",
    "Model": "Alpha 950XL"
  },
  {
    "Retail Branding": "Lanix",
    "Marketing Name": "ILIUM L1000",
    "Device": "Ilium_L1000",
    "Model": "ILIUM L1000"
  },
  {
    "Retail Branding": "Lanix",
    "Marketing Name": "ILIUM L1000",
    "Device": "Ilium_L1000",
    "Model": "Ilium_L1000"
  },
  {
    "Retail Branding": "Lanix",
    "Marketing Name": "ILIUM L200",
    "Device": "ILIUM_L200",
    "Model": "ILIUM L200"
  },
  {
    "Retail Branding": "Lanix",
    "Marketing Name": "ILIUM L820",
    "Device": "Ilium_L820",
    "Model": "Ilium L820"
  },
  {
    "Retail Branding": "Lanix",
    "Marketing Name": "ILIUM L900",
    "Device": "Ilium_L900",
    "Model": "ILIUM L900"
  },
  {
    "Retail Branding": "Lanix",
    "Marketing Name": "ILIUM L950",
    "Device": "Ilium_L950",
    "Model": "ILIUM L950"
  },
  {
    "Retail Branding": "Lanix",
    "Marketing Name": "ILIUM L950",
    "Device": "Ilium_L950",
    "Model": "Ilium_L950"
  },
  {
    "Retail Branding": "Lanix",
    "Marketing Name": "ILIUM PAD E10Si",
    "Device": "iLium_Pad_E10Si_1",
    "Model": "ILIUM PAD E10Si"
  },
  {
    "Retail Branding": "Lanix",
    "Marketing Name": "ILIUM PAD E8 V6",
    "Device": "IliumPAD_E8v6",
    "Model": "ILIUM PAD E8 V6"
  },
  {
    "Retail Branding": "Lanix",
    "Marketing Name": "ILIUM PAD I8",
    "Device": "Ilium_Padi8v3",
    "Model": "ilium PAD i8 v3"
  },
  {
    "Retail Branding": "Lanix",
    "Marketing Name": "ILIUM PAD RX10 Pro",
    "Device": "RX10ProV7",
    "Model": "RX10ProV7"
  },
  {
    "Retail Branding": "Lanix",
    "Marketing Name": "ILIUM S670",
    "Device": "Ilium_S670",
    "Model": "ILIUM S670"
  },
  {
    "Retail Branding": "Lanix",
    "Marketing Name": "ILIUM X110",
    "Device": "ILIUM_X110",
    "Model": "ILIUM X110"
  },
  {
    "Retail Branding": "Lanix",
    "Marketing Name": "ILIUMPAD_RX10v5",
    "Device": "ILIUMPAD_RX10v5",
    "Model": "ILIUM_PAD_RX10v5"
  },
  {
    "Retail Branding": "Lanix",
    "Marketing Name": "ILIUM_PADE7",
    "Device": "ILIUM_PADE7V10",
    "Model": "ILIUM_PADE7"
  },
  {
    "Retail Branding": "Lanix",
    "Marketing Name": "ILIUM_PAD_RX8_v5",
    "Device": "ILIUM_PAD_RX8_v5",
    "Model": "ILIUM_PAD_RX8_v5"
  },
  {
    "Retail Branding": "Lanix",
    "Marketing Name": "ILium M7s",
    "Device": "Ilium_M7s",
    "Model": "Ilium M7s"
  },
  {
    "Retail Branding": "Lanix",
    "Marketing Name": "Ilium Alpha 1s",
    "Device": "Ilium_Alpha_1s",
    "Model": "Ilium Alpha 1s"
  },
  {
    "Retail Branding": "Lanix",
    "Marketing Name": "Ilium Alpha 3",
    "Device": "Ilium_Alpha_3",
    "Model": "Ilium Alpha 3"
  },
  {
    "Retail Branding": "Lanix",
    "Marketing Name": "Ilium Alpha 5s",
    "Device": "Ilium_Alpha_5s",
    "Model": "Ilium Alpha 5s"
  },
  {
    "Retail Branding": "Lanix",
    "Marketing Name": "Ilium Alpha 9",
    "Device": "Ilium_Alpha_9",
    "Model": "Ilium Alpha 9"
  },
  {
    "Retail Branding": "Lanix",
    "Marketing Name": "Ilium L1050",
    "Device": "Ilium_L1050",
    "Model": "Ilium L1050"
  },
  {
    "Retail Branding": "Lanix",
    "Marketing Name": "Ilium L1100",
    "Device": "ILIUM_L1100",
    "Model": "ILIUM L1100"
  },
  {
    "Retail Branding": "Lanix",
    "Marketing Name": "Ilium L1120",
    "Device": "Ilium_L1120",
    "Model": "Ilium L1120"
  },
  {
    "Retail Branding": "Lanix",
    "Marketing Name": "Ilium L1200",
    "Device": "Ilium_L1200",
    "Model": "Ilium L1200"
  },
  {
    "Retail Branding": "Lanix",
    "Marketing Name": "Ilium L1300",
    "Device": "Ilium_L1300",
    "Model": "Ilium L1300"
  },
  {
    "Retail Branding": "Lanix",
    "Marketing Name": "Ilium L1400",
    "Device": "Ilium_L1400",
    "Model": "Ilium L1400"
  },
  {
    "Retail Branding": "Lanix",
    "Marketing Name": "Ilium L420",
    "Device": "Ilium_L420",
    "Model": "Ilium L420"
  },
  {
    "Retail Branding": "Lanix",
    "Marketing Name": "Ilium L420",
    "Device": "Ilium_L420",
    "Model": "Lanix Ilium L420"
  },
  {
    "Retail Branding": "Lanix",
    "Marketing Name": "Ilium L610",
    "Device": "Ilium_L610",
    "Model": "Ilium L610"
  },
  {
    "Retail Branding": "Lanix",
    "Marketing Name": "Ilium L620",
    "Device": "Ilium_L620",
    "Model": "Ilium L620"
  },
  {
    "Retail Branding": "Lanix",
    "Marketing Name": "Ilium L920",
    "Device": "Ilium_L920",
    "Model": "Ilium L920"
  },
  {
    "Retail Branding": "Lanix",
    "Marketing Name": "Ilium LT500",
    "Device": "Ilium_LT500",
    "Model": "Ilium LT500"
  },
  {
    "Retail Branding": "Lanix",
    "Marketing Name": "Ilium LT510",
    "Device": "Ilium_LT510",
    "Model": "Ilium LT510"
  },
  {
    "Retail Branding": "Lanix",
    "Marketing Name": "Ilium LT520",
    "Device": "Ilium_LT520",
    "Model": "Ilium LT520"
  },
  {
    "Retail Branding": "Lanix",
    "Marketing Name": "Ilium M1",
    "Device": "Ilium_M1",
    "Model": "Ilium M1"
  },
  {
    "Retail Branding": "Lanix",
    "Marketing Name": "Ilium M3",
    "Device": "Ilium_M3",
    "Model": "Ilium M3"
  },
  {
    "Retail Branding": "Lanix",
    "Marketing Name": "Ilium M5",
    "Device": "Ilium_M5",
    "Model": "Ilium M5"
  },
  {
    "Retail Branding": "Lanix",
    "Marketing Name": "Ilium M5s",
    "Device": "Ilium_M5s",
    "Model": "Ilium M5s"
  },
  {
    "Retail Branding": "Lanix",
    "Marketing Name": "Ilium M7",
    "Device": "Ilium_M7",
    "Model": "Ilium M7"
  },
  {
    "Retail Branding": "Lanix",
    "Marketing Name": "Ilium M7T",
    "Device": "Ilium_M7T",
    "Model": "Ilium M7T"
  },
  {
    "Retail Branding": "Lanix",
    "Marketing Name": "Ilium M7V",
    "Device": "Ilium_M7V",
    "Model": "Ilium M7V"
  },
  {
    "Retail Branding": "Lanix",
    "Marketing Name": "Ilium M9",
    "Device": "Ilium_M9",
    "Model": "Ilium M9"
  },
  {
    "Retail Branding": "Lanix",
    "Marketing Name": "Ilium M9V",
    "Device": "Ilium_M9V",
    "Model": "Ilium M9V"
  },
  {
    "Retail Branding": "Lanix",
    "Marketing Name": "Ilium M9s",
    "Device": "Ilium_M9s",
    "Model": "Ilium M9s"
  },
  {
    "Retail Branding": "Lanix",
    "Marketing Name": "Ilium PAD i7",
    "Device": "ILIUM_PADi7",
    "Model": "Ilium PAD i7"
  },
  {
    "Retail Branding": "Lanix",
    "Marketing Name": "Ilium PAD i7 v2",
    "Device": "ILIUM_PADi7V2",
    "Model": "Ilium PAD i7 v2"
  },
  {
    "Retail Branding": "Lanix",
    "Marketing Name": "Ilium Pad L8X",
    "Device": "Ilium_Pad_L8X",
    "Model": "Ilium Pad L8X"
  },
  {
    "Retail Branding": "Lanix",
    "Marketing Name": "Ilium Pad T7X",
    "Device": "Ilium_Pad_T7X",
    "Model": "Ilium Pad T7X"
  },
  {
    "Retail Branding": "Lanix",
    "Marketing Name": "Ilium Pad X10",
    "Device": "Ilium_Pad_X10",
    "Model": "Ilium Pad X10"
  },
  {
    "Retail Branding": "Lanix",
    "Marketing Name": "Ilium X110",
    "Device": "ILIUM_X110",
    "Model": "Ilium X110"
  },
  {
    "Retail Branding": "Lanix",
    "Marketing Name": "Ilium X120",
    "Device": "Ilium_X120",
    "Model": "Ilium X120"
  },
  {
    "Retail Branding": "Lanix",
    "Marketing Name": "Ilium X120B",
    "Device": "Ilium_X120B",
    "Model": "Ilium X120B"
  },
  {
    "Retail Branding": "Lanix",
    "Marketing Name": "Ilium X120C",
    "Device": "X120C",
    "Model": "X120C"
  },
  {
    "Retail Branding": "Lanix",
    "Marketing Name": "Ilium X200",
    "Device": "Ilium_X200",
    "Model": "Ilium X200"
  },
  {
    "Retail Branding": "Lanix",
    "Marketing Name": "Ilium X210",
    "Device": "Ilium_X210",
    "Model": "Ilium X210"
  },
  {
    "Retail Branding": "Lanix",
    "Marketing Name": "Ilium X220",
    "Device": "Ilium_X220",
    "Model": "Ilium X220"
  },
  {
    "Retail Branding": "Lanix",
    "Marketing Name": "Ilium X260",
    "Device": "Ilium_X260",
    "Model": "Ilium X260"
  },
  {
    "Retail Branding": "Lanix",
    "Marketing Name": "Ilium X500B",
    "Device": "Ilium_X500B",
    "Model": "Ilium X500B"
  },
  {
    "Retail Branding": "Lanix",
    "Marketing Name": "Ilium X510",
    "Device": "Ilium_X510",
    "Model": "Ilium X510"
  },
  {
    "Retail Branding": "Lanix",
    "Marketing Name": "Ilium X520",
    "Device": "Ilium_X520",
    "Model": "Ilium X520"
  },
  {
    "Retail Branding": "Lanix",
    "Marketing Name": "Ilium X710",
    "Device": "Ilium_X710",
    "Model": "Ilium X710"
  },
  {
    "Retail Branding": "Lanix",
    "Marketing Name": "IliumPad_RX10",
    "Device": "IliumPad_RX10",
    "Model": "ILIUM_PAD_RX10"
  },
  {
    "Retail Branding": "Lanix",
    "Marketing Name": "IliumPad_RX10v3",
    "Device": "IliumPad_RX10v3",
    "Model": "Ilium Pad RX10v3"
  },
  {
    "Retail Branding": "Lanix",
    "Marketing Name": "IliumPad_RX7",
    "Device": "IliumPad_RX7",
    "Model": "ILIUM_PAD_RX7"
  },
  {
    "Retail Branding": "Lanix",
    "Marketing Name": "IliumPad_RX8",
    "Device": "IliumPad_RX8",
    "Model": "IliumPad_RX8"
  },
  {
    "Retail Branding": "Lanix",
    "Marketing Name": "IliumPad_RX8v2",
    "Device": "IliumPad_RX8v2",
    "Model": "IliumPad_RX8v2"
  },
  {
    "Retail Branding": "Lanix",
    "Marketing Name": "Ilium_Alpha7",
    "Device": "Ilium_Alpha7",
    "Model": "Ilium Alpha 7"
  },
  {
    "Retail Branding": "Lanix",
    "Marketing Name": "Ilium_Alpha_1TT",
    "Device": "Ilium_Alpha_1TT",
    "Model": "Ilium Alpha 1T"
  },
  {
    "Retail Branding": "Lanix",
    "Marketing Name": "Ilium_Alpha_5T",
    "Device": "Ilium_Alpha_5T",
    "Model": "Ilium Alpha 5T"
  },
  {
    "Retail Branding": "Lanix",
    "Marketing Name": "Ilium_L1100",
    "Device": "Ilium_L1100",
    "Model": "ILIUM L1100"
  },
  {
    "Retail Branding": "Lanix",
    "Marketing Name": "Ilium_M8",
    "Device": "Ilium_M8",
    "Model": "Ilium_M8"
  },
  {
    "Retail Branding": "Lanix",
    "Marketing Name": "Ilium_Pad_X8",
    "Device": "Ilium_Pad_X8",
    "Model": "Ilium_Pad_X8"
  },
  {
    "Retail Branding": "Lanix",
    "Marketing Name": "Ilium_S130",
    "Device": "Ilium_S130",
    "Model": "Ilium S130"
  },
  {
    "Retail Branding": "Lanix",
    "Marketing Name": "Ilium_S130",
    "Device": "Ilium_S130",
    "Model": "Ilium_S130"
  },
  {
    "Retail Branding": "Lanix",
    "Marketing Name": "Ilium_S520",
    "Device": "Ilium_S520",
    "Model": "ILIUM S520"
  },
  {
    "Retail Branding": "Lanix",
    "Marketing Name": "L530",
    "Device": "L530",
    "Model": "L530"
  },
  {
    "Retail Branding": "Lanix",
    "Marketing Name": "L540",
    "Device": "L540",
    "Model": "L540"
  },
  {
    "Retail Branding": "Lanix",
    "Marketing Name": "LANIX",
    "Device": "elliniko",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "Lanix",
    "Marketing Name": "LANIX",
    "Device": "zhongshan",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "Lanix",
    "Marketing Name": "LANIX_PAD_E7",
    "Device": "ILIUM_PADE7V11",
    "Model": "LANIX_PAD_E7"
  },
  {
    "Retail Branding": "Lanix",
    "Marketing Name": "Llium L910",
    "Device": "Ilium_L910",
    "Model": "Ilium L910"
  },
  {
    "Retail Branding": "Lanix",
    "Marketing Name": "M1R",
    "Device": "M1R",
    "Model": "M1R"
  },
  {
    "Retail Branding": "Lanix",
    "Marketing Name": "M5",
    "Device": "M5",
    "Model": "M5"
  },
  {
    "Retail Branding": "Lanix",
    "Marketing Name": "M5e",
    "Device": "M5e",
    "Model": "M5e"
  },
  {
    "Retail Branding": "Lanix",
    "Marketing Name": "NA",
    "Device": "stanford",
    "Model": "2K SMART TV"
  },
  {
    "Retail Branding": "Lanix",
    "Marketing Name": "RX10v10",
    "Device": "RX10v10",
    "Model": "RX10v10"
  },
  {
    "Retail Branding": "Lanix",
    "Marketing Name": "RX10v8",
    "Device": "RX10v8",
    "Model": "RX10v8"
  },
  {
    "Retail Branding": "Lanix",
    "Marketing Name": "RX10v9",
    "Device": "RX10v9",
    "Model": "RX10v9"
  },
  {
    "Retail Branding": "Lanix",
    "Marketing Name": "RX11",
    "Device": "RX11",
    "Model": "RX11"
  },
  {
    "Retail Branding": "Lanix",
    "Marketing Name": "RX11v2",
    "Device": "RX11v2",
    "Model": "RX11v2"
  },
  {
    "Retail Branding": "Lanix",
    "Marketing Name": "RX12",
    "Device": "RX12",
    "Model": "RX12"
  },
  {
    "Retail Branding": "Lanix",
    "Marketing Name": "RX7V4",
    "Device": "RX7V4",
    "Model": "RX7V4"
  },
  {
    "Retail Branding": "Lanix",
    "Marketing Name": "RX7_v3",
    "Device": "RX7_v3",
    "Model": "RX7_v3"
  },
  {
    "Retail Branding": "Lanix",
    "Marketing Name": "RX8",
    "Device": "Ilium_PAD_RX8",
    "Model": "Ilium_PAD_RX8v4"
  },
  {
    "Retail Branding": "Lanix",
    "Marketing Name": "RX8v7",
    "Device": "RX8v7",
    "Model": "RX8v7"
  },
  {
    "Retail Branding": "Lanix",
    "Marketing Name": "X100",
    "Device": "ILIUM_X100",
    "Model": "ILIUM_X100"
  },
  {
    "Retail Branding": "Lanix",
    "Marketing Name": "X120C",
    "Device": "X120C",
    "Model": "X120C"
  },
  {
    "Retail Branding": "Lanix",
    "Marketing Name": "X1S",
    "Device": "X1S",
    "Model": "X1S"
  },
  {
    "Retail Branding": "Lanix",
    "Marketing Name": "X2",
    "Device": "X2",
    "Model": "X2"
  },
  {
    "Retail Branding": "Lanix",
    "Marketing Name": "X230",
    "Device": "X230",
    "Model": "X230"
  },
  {
    "Retail Branding": "Lanix",
    "Marketing Name": "X230A",
    "Device": "X230A",
    "Model": "X230A"
  },
  {
    "Retail Branding": "Lanix",
    "Marketing Name": "X240",
    "Device": "X240",
    "Model": "X240"
  },
  {
    "Retail Branding": "Lanix",
    "Marketing Name": "X400",
    "Device": "Ilium_X400",
    "Model": "ILIUM X400"
  },
  {
    "Retail Branding": "Lanix",
    "Marketing Name": "X5",
    "Device": "X5",
    "Model": "X5"
  },
  {
    "Retail Branding": "Lanix",
    "Marketing Name": "X530",
    "Device": "X530",
    "Model": "X530"
  },
  {
    "Retail Branding": "Lanix",
    "Marketing Name": "X540",
    "Device": "X540",
    "Model": "X540"
  },
  {
    "Retail Branding": "Lanix",
    "Marketing Name": "X550",
    "Device": "X550",
    "Model": "X550"
  },
  {
    "Retail Branding": "Lanix",
    "Marketing Name": "X560",
    "Device": "X560",
    "Model": "X560"
  },
  {
    "Retail Branding": "Lanix",
    "Marketing Name": "X570",
    "Device": "X570",
    "Model": "X570"
  },
  {
    "Retail Branding": "Lanix",
    "Marketing Name": "X570Lite",
    "Device": "X570Lite",
    "Model": "X570Lite"
  },
  {
    "Retail Branding": "Lanix",
    "Marketing Name": "X7",
    "Device": "X7",
    "Model": "X7"
  },
  {
    "Retail Branding": "Lanix",
    "Marketing Name": "X750",
    "Device": "X750",
    "Model": "X750"
  },
  {
    "Retail Branding": "Lanix",
    "Marketing Name": "X770",
    "Device": "X770",
    "Model": "X770"
  },
  {
    "Retail Branding": "Lanix",
    "Marketing Name": "X860",
    "Device": "X860",
    "Model": "X860"
  },
  {
    "Retail Branding": "Lanix",
    "Marketing Name": "ilium  PAD  E9",
    "Device": "ILium_PADE9",
    "Model": "ilium PAD E9"
  },
  {
    "Retail Branding": "Lanix",
    "Marketing Name": "ilium PAD E7",
    "Device": "ILIUM_PADE7",
    "Model": "ilium PAD E7"
  },
  {
    "Retail Branding": "Lanix",
    "Marketing Name": "ilium PAD E8",
    "Device": "ILIUM_PADE8",
    "Model": "ilium PAD E8"
  },
  {
    "Retail Branding": "Lanix",
    "Marketing Name": "ilium PAD E9",
    "Device": "ilium_PAD_E9",
    "Model": "ilium Pad E9"
  },
  {
    "Retail Branding": "Lanix",
    "Marketing Name": "ilium PAD i7",
    "Device": "Ilium_PAD_i7",
    "Model": "Ilium_PAD_i7"
  },
  {
    "Retail Branding": "Lanix",
    "Marketing Name": "ilium Pad E7",
    "Device": "ilium_Pad_E7",
    "Model": "ilium_Pad_E7"
  },
  {
    "Retail Branding": "Lanix",
    "Marketing Name": "ilium_PADE10",
    "Device": "ilium_PADE10",
    "Model": "ilium_PADE10"
  },
  {
    "Retail Branding": "Lanix",
    "Marketing Name": "ilium_PAD_RX10",
    "Device": "RX10V6",
    "Model": "Ilium_PAD_RX10V6"
  },
  {
    "Retail Branding": "Lanix",
    "Marketing Name": "ilium_S106",
    "Device": "Ilium_S106",
    "Model": "Ilium S106"
  },
  {
    "Retail Branding": "Lanix",
    "Marketing Name": "llium Pad L8",
    "Device": "llium_Pad_L8",
    "Model": "llium Pad L8"
  },
  {
    "Retail Branding": "Laptok",
    "Marketing Name": "G11",
    "Device": "G11",
    "Model": "G11"
  },
  {
    "Retail Branding": "Laptok",
    "Marketing Name": "G11L",
    "Device": "G11L",
    "Model": "G11L"
  },
  {
    "Retail Branding": "Laptok",
    "Marketing Name": "G11L_EEA",
    "Device": "G11L",
    "Model": "G11L"
  },
  {
    "Retail Branding": "Laptok",
    "Marketing Name": "G11_EEA",
    "Device": "G11",
    "Model": "G11"
  },
  {
    "Retail Branding": "Laptok",
    "Marketing Name": "G12L",
    "Device": "G12L",
    "Model": "G12L"
  },
  {
    "Retail Branding": "Laptok",
    "Marketing Name": "G12L_EEA",
    "Device": "G12L",
    "Model": "G12L"
  },
  {
    "Retail Branding": "Laptok",
    "Marketing Name": "X11",
    "Device": "X11",
    "Model": "X11"
  },
  {
    "Retail Branding": "Lark",
    "Marketing Name": "Cumulus 5 HD",
    "Device": "Cumulus_5_HD",
    "Model": "Cumulus_5_HD"
  },
  {
    "Retail Branding": "Lark",
    "Marketing Name": "Cumulus 5.5 HD",
    "Device": "Cumulus_55_HD",
    "Model": "Cumulus_5.5_HD"
  },
  {
    "Retail Branding": "Lark",
    "Marketing Name": "Cumulus 6 HD",
    "Device": "Cumulus_6_HD",
    "Model": "Cumulus_6_HD"
  },
  {
    "Retail Branding": "Lark",
    "Marketing Name": "Impress_Noda",
    "Device": "Impress_Noda",
    "Model": "Impress_Noda"
  },
  {
    "Retail Branding": "Lark",
    "Marketing Name": "PHABLET 7",
    "Device": "PHABLET7",
    "Model": "PHABLET 7"
  },
  {
    "Retail Branding": "Lark",
    "Marketing Name": "Ultimate X4 10.1 3G IPS",
    "Device": "UltimateX41013GIPS",
    "Model": "Ultimate X4 10.1 3G IPS"
  },
  {
    "Retail Branding": "Lark",
    "Marketing Name": "Ultimate X4 8s 3G",
    "Device": "UltimateX48s3G",
    "Model": "Ultimate X4 8s 3G"
  },
  {
    "Retail Branding": "Laser",
    "Marketing Name": "GRAND",
    "Device": "GRAND",
    "Model": "GRAND"
  },
  {
    "Retail Branding": "Laser",
    "Marketing Name": "MID-104GB-968",
    "Device": "MID-104GB-968",
    "Model": "MID-104GB-968"
  },
  {
    "Retail Branding": "Laser",
    "Marketing Name": "MID-1087",
    "Device": "MID-1087",
    "Model": "MID-1087"
  },
  {
    "Retail Branding": "Laser",
    "Marketing Name": "MID-1090IPS",
    "Device": "MID-1090IPS",
    "Model": "MID-1090IPS"
  },
  {
    "Retail Branding": "Laser",
    "Marketing Name": "MID-787",
    "Device": "MID-787",
    "Model": "MID-787"
  },
  {
    "Retail Branding": "Laser",
    "Marketing Name": "MID-787V8",
    "Device": "MID-787V8",
    "Model": "MID-787V8"
  },
  {
    "Retail Branding": "Laser",
    "Marketing Name": "MID-790IPS",
    "Device": "MID-790IPS",
    "Model": "MID-790IPS"
  },
  {
    "Retail Branding": "Laser",
    "Marketing Name": "MID_1085",
    "Device": "MID_1085",
    "Model": "MID_1085"
  },
  {
    "Retail Branding": "Laser",
    "Marketing Name": "MID_1085A100",
    "Device": "MID-1085A100",
    "Model": "MID_1085A100"
  },
  {
    "Retail Branding": "Laser",
    "Marketing Name": "MID_1087V9",
    "Device": "MID_1087V9",
    "Model": "MID_1087V9"
  },
  {
    "Retail Branding": "Laser",
    "Marketing Name": "MID_1089IPS",
    "Device": "MID_1089IPS",
    "Model": "MID_1089IPS"
  },
  {
    "Retail Branding": "Laser",
    "Marketing Name": "MID_1089IPSA100",
    "Device": "MID_1089IPSA100",
    "Model": "MID_1089IPSA100"
  },
  {
    "Retail Branding": "Laser",
    "Marketing Name": "MID_1089IPS_EEA",
    "Device": "MID_1089IPS",
    "Model": "MID_1089IPS"
  },
  {
    "Retail Branding": "Laser",
    "Marketing Name": "MID_1090IPSV9",
    "Device": "MID_1090IPSV9",
    "Model": "MID_1090IPSV9"
  },
  {
    "Retail Branding": "Laser",
    "Marketing Name": "MID_1099IPS_V13",
    "Device": "MID_1099IPS_V13",
    "Model": "MID_1099IPS"
  },
  {
    "Retail Branding": "Laser",
    "Marketing Name": "MID_785",
    "Device": "MID_785",
    "Model": "MID_785"
  },
  {
    "Retail Branding": "Laser",
    "Marketing Name": "MID_785A100",
    "Device": "MID-785A100",
    "Model": "MID_785A100"
  },
  {
    "Retail Branding": "Laser",
    "Marketing Name": "MID_787V9",
    "Device": "MID_787V9",
    "Model": "MID_787V9"
  },
  {
    "Retail Branding": "Laser",
    "Marketing Name": "MID_789",
    "Device": "MID_789",
    "Model": "MID_789"
  },
  {
    "Retail Branding": "Laser",
    "Marketing Name": "MID_789A100",
    "Device": "MID_789A100",
    "Model": "MID_789A100"
  },
  {
    "Retail Branding": "Laser",
    "Marketing Name": "MID_789IPS",
    "Device": "MID_789IPS",
    "Model": "MID_789IPS"
  },
  {
    "Retail Branding": "Laser",
    "Marketing Name": "MID_789IPSA100",
    "Device": "MID_789IPSA100",
    "Model": "MID_789IPSA100"
  },
  {
    "Retail Branding": "Laser",
    "Marketing Name": "MID_799IPS",
    "Device": "MID_799IPS",
    "Model": "MID_799IPS"
  },
  {
    "Retail Branding": "Laser",
    "Marketing Name": "MID_799IPS_V13",
    "Device": "MID_799IPS_V13",
    "Model": "MID_799IPS"
  },
  {
    "Retail Branding": "Laser",
    "Marketing Name": "MID_7A15",
    "Device": "MID-7A15",
    "Model": "MID-7A15"
  },
  {
    "Retail Branding": "Laser",
    "Marketing Name": "MID_899IPS",
    "Device": "MID_899IPS",
    "Model": "MID_899IPS"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "A1",
    "Device": "LAVAA1",
    "Model": "LAVAA1"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "A3",
    "Device": "LAVA_A3",
    "Model": "LAVA_A3"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "A3_mini",
    "Device": "A3_mini",
    "Model": "A3_mini"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "A44",
    "Device": "LAVA_A44",
    "Model": "LAVA_A44"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "A50",
    "Device": "A50",
    "Model": "A50"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "A52",
    "Device": "A52",
    "Model": "A52"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "A55",
    "Device": "A55",
    "Model": "A55"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "A67",
    "Device": "A67",
    "Model": "A67"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "A68",
    "Device": "A68",
    "Model": "A68"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "A71",
    "Device": "A71",
    "Model": "A71"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "A72",
    "Device": "A72",
    "Model": "A72"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "A73",
    "Device": "A73",
    "Model": "A73"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "A76Plus",
    "Device": "A76Plus",
    "Model": "A76Plus"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "A76plus",
    "Device": "A76Plus",
    "Model": "A76Plus"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "A77",
    "Device": "A77",
    "Model": "A77"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "A79",
    "Device": "LA79",
    "Model": "A79"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "A82",
    "Device": "LA82",
    "Model": "A82"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "A89",
    "Device": "A89",
    "Model": "Lava A89"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "A97",
    "Device": "A97",
    "Model": "A97"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "A97",
    "Device": "A97",
    "Model": "A97 IPS"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "A97 2GB",
    "Device": "A97_2GB",
    "Model": "A97 2GB"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "A97 2GB Plus",
    "Device": "A97_2GB_PLUS",
    "Model": "A97 2GB PLUS"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "Agni 3",
    "Device": "LXX518",
    "Model": "LXX518"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "Aura Plus",
    "Device": "Lava_Aura_Plus",
    "Model": "Aura_Plus"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "BE_U",
    "Device": "Be_U",
    "Model": "Lava Be_U"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "BLAZE",
    "Device": "LZX403",
    "Model": "LAVA Blaze"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "Blaze 2 Pro",
    "Device": "LZX406",
    "Model": "LAVA LZX406"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "ERA 1X",
    "Device": "era1X",
    "Model": "era1X"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "ERA 1X",
    "Device": "era1X",
    "Model": "era1Xpro"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "Era 2X 3GB",
    "Device": "XE2X3GB",
    "Model": "Era 2X 3GB"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "Era 4G",
    "Device": "era_4G",
    "Model": "era_4G"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "Flair P3",
    "Device": "P3",
    "Model": "P3"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "Flair S1",
    "Device": "S1",
    "Model": "S1"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "IRIS88",
    "Device": "iris88",
    "Model": "iris88"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "IRIS88S",
    "Device": "iris88s",
    "Model": "iris88s"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "Iris 505",
    "Device": "iris505",
    "Model": "iris505"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "Iris 50_Pro",
    "Device": "iris_50_Pro",
    "Model": "iris 50 Pro"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "Iris61",
    "Device": "LN9910",
    "Model": "LN9910"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "Iris820",
    "Device": "iris820",
    "Model": "iris820"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "Iris90",
    "Device": "iris90",
    "Model": "iris90"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "LAVA AGNI 5G",
    "Device": "LXX501",
    "Model": "LAVA LXX501"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "LAVA LXX503",
    "Device": "LXX503",
    "Model": "LAVA LXX503"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "LAVA LXX504",
    "Device": "LXX504",
    "Model": "LAVA LXX504"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "LAVA LXX505",
    "Device": "LXX505",
    "Model": "LAVA LXX505"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "LAVA LXX506",
    "Device": "LXX506",
    "Model": "LAVA LXX506"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "LAVA LXX507",
    "Device": "LXX507",
    "Model": "LAVA LXX507"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "LAVA LXX508",
    "Device": "LXX508",
    "Model": "LAVA LXX508"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "LAVA LXX510",
    "Device": "LXX510",
    "Model": "LAVA LXX510"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "LAVA LXX511",
    "Device": "LXX511",
    "Model": "LXX511"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "LAVA LXX513",
    "Device": "LXX513",
    "Model": "LXX513"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "LAVA LXX514",
    "Device": "LXX514",
    "Model": "LAVA LXX514"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "LAVA LXX515",
    "Device": "LXX515",
    "Model": "LXX515"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "LAVA LXX516",
    "Device": "LXX516",
    "Model": "LAVA LXX516"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "LAVA LXX521",
    "Device": "LXX521",
    "Model": "LAVA LXX521"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "LAVA LXX522",
    "Device": "LXX522",
    "Model": "LXX522"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "LAVA LXX523",
    "Device": "LXX523",
    "Model": "LXX523"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "LAVA LXX524",
    "Device": "LXX524",
    "Model": "LAVA LXX524"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "LAVA LXX525",
    "Device": "LXX525",
    "Model": "LXX525"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "LAVA LZG410",
    "Device": "LZG410",
    "Model": "LZG410"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "LAVA LZG411",
    "Device": "LZG411",
    "Model": "LAVA LZG411"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "LAVA LZX414",
    "Device": "LZX414",
    "Model": "LAVA LZX414"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "LAVA LZX419",
    "Device": "LZX419",
    "Model": "LAVA LZX419"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "LAVA LZX421",
    "Device": "LZX421",
    "Model": "LAVA LZX421"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "LAVA Z35",
    "Device": "Z35",
    "Model": "Z35"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "LAVA Z36",
    "Device": "LEX403",
    "Model": "LAVA LEX403"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "LAVA Z66",
    "Device": "Z66",
    "Model": "Lava Z66"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "LE000Z93P",
    "Device": "LE000Z93P",
    "Model": "LE000Z93P"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "LE9810",
    "Device": "LE9810",
    "Model": "LAVA LE9810"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "LE9820",
    "Device": "LE9820",
    "Model": "LAVA LE9820"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "LE9910",
    "Device": "LE9910",
    "Model": "LE9910"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "LF9810_2GB",
    "Device": "LF9810_2GB",
    "Model": "LAVA LF9810_2GB"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "LH9810",
    "Device": "LH9810",
    "Model": "LH9810"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "LMG02",
    "Device": "LMG02",
    "Model": "LAVA LMG02"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "LMX02",
    "Device": "LMX02",
    "Model": "LAVA LMX02"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "LN9810",
    "Device": "LN9810",
    "Model": "LAVA LN9810"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "LN9820",
    "Device": "LN9820",
    "Model": "LN9820"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "LN9820",
    "Device": "LN9820",
    "Model": "LN9821"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "LXX519",
    "Device": "LXX519",
    "Model": "LAVA LXX519"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "LZG01",
    "Device": "LZG01",
    "Model": "LAVA LZG01"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "Lava LXX517",
    "Device": "LXX517",
    "Model": "LXX517"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "Magnum Pro",
    "Device": "Magnum_Pro",
    "Model": "Magnum_Pro"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "P7",
    "Device": "P7",
    "Model": "P7"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "P7 Plus",
    "Device": "P7plus",
    "Model": "P7plus"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "P7plus",
    "Device": "P7plus",
    "Model": "P7plus"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "Pixel V1",
    "Device": "PixelV1G_sprout",
    "Model": "PixelV1"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "Pixel V1",
    "Device": "PixelV1_sprout",
    "Model": "PixelV1"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "R1",
    "Device": "LAVA_R1",
    "Model": "LAVA_R1"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "R1LITE",
    "Device": "R1_Lite",
    "Model": "R1_Lite"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "R2",
    "Device": "R2",
    "Model": "R2"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "R3",
    "Device": "R3",
    "Model": "R3"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "R3 Prime",
    "Device": "iris90",
    "Model": "iris90"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "T101",
    "Device": "LTN10RT",
    "Model": "LTN10RT"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "T101",
    "Device": "T101",
    "Model": "T101"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "T101N",
    "Device": "T101N",
    "Model": "T101N"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "T71",
    "Device": "T71",
    "Model": "T71"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "T71",
    "Device": "T71WW",
    "Model": "T71WW"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "T71N",
    "Device": "T71N",
    "Model": "T71N"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "T71N_M",
    "Device": "T71N_M",
    "Model": "T71N_M"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "T71_w",
    "Device": "T71_w",
    "Model": "T71_w"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "T81",
    "Device": "LTN8RT",
    "Model": "LTN8RT"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "T81",
    "Device": "T81",
    "Model": "T81"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "T81",
    "Device": "T81_PB",
    "Model": "T81_PB"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "T81N",
    "Device": "T81N",
    "Model": "T81N"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "V2 3GB",
    "Device": "V23GB",
    "Model": "V23GB"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "V2s",
    "Device": "V2s",
    "Model": "V2s"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "V2s",
    "Device": "V2s",
    "Model": "V2s M"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "V5",
    "Device": "V5",
    "Model": "LAVA V5"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "V5",
    "Device": "V5",
    "Model": "V5"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "V7",
    "Device": "LE9920_P",
    "Model": "LE9920_P"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "V7 Prime",
    "Device": "LE9940",
    "Model": "LAVA LE9940"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "V7s Prime",
    "Device": "LE9940_W",
    "Model": "LAVA LE9940_W"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "V8",
    "Device": "LE9910",
    "Model": "LE9910"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "X10",
    "Device": "X10",
    "Model": "LavaX10"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "X10",
    "Device": "X10",
    "Model": "X10"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "X11",
    "Device": "X11",
    "Model": "X11"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "X12",
    "Device": "X12",
    "Model": "X12"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "X17",
    "Device": "X17",
    "Model": "X17"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "X19",
    "Device": "X19",
    "Model": "X19"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "X2",
    "Device": "LZG403_225",
    "Model": "LAVA LZG403 225"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "X28",
    "Device": "X28",
    "Model": "X28"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "X28 Plus",
    "Device": "X28_plus",
    "Model": "X28 Plus"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "X28plus",
    "Device": "X28_plus",
    "Model": "X28 Plus"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "X3",
    "Device": "X3",
    "Model": "X3"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "X38",
    "Device": "X38",
    "Model": "X38"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "X38 2GB",
    "Device": "X382GB",
    "Model": "X38 2GB"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "X41",
    "Device": "X41",
    "Model": "X41"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "X41Plus",
    "Device": "X41_Plus",
    "Model": "X41 Plus"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "X46",
    "Device": "LX46",
    "Model": "X46"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "X50",
    "Device": "X50",
    "Model": "X50"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "X50 Plus",
    "Device": "X50_Plus",
    "Model": "X50 Plus"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "X81",
    "Device": "X81",
    "Model": "X81"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "XOLO LT900",
    "Device": "LT900",
    "Model": "LT900"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "XOLO One HD",
    "Device": "XOLO_One_HD",
    "Model": "XOLO One HD"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "XOLO era 4K",
    "Device": "XOLO_era_4K",
    "Model": "era 4K"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "Xolo Era 2X",
    "Device": "XE2X",
    "Model": "Era 2X"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "Xolo Era X",
    "Device": "era_X",
    "Model": "era_X"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "Xolo era 2",
    "Device": "era_2",
    "Model": "era 2"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "Y50",
    "Device": "AF9020",
    "Model": "AF9020"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "YUVA 2 PRO",
    "Device": "LZX408",
    "Model": "LAVA LZX408"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "YUVA 3",
    "Device": "LZX415",
    "Model": "LZX415"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "Yuva 4",
    "Device": "LZX417",
    "Model": "LZX417"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "Yuva Sar 2",
    "Device": "LZG410",
    "Model": "LZG410"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "Yuva Star",
    "Device": "LZG409",
    "Model": "LAVA LZG409"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "Z1",
    "Device": "Z1",
    "Model": "Z1"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "Z1 Pro",
    "Device": "LZG401",
    "Model": "LAVA LZG401"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "Z10",
    "Device": "LAVA_Z10",
    "Model": "Z10"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "Z100",
    "Device": "Z100",
    "Model": "Z100"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "Z1S",
    "Device": "LZG402_1",
    "Model": "LAVA LZG402_1"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "Z2",
    "Device": "LMG01",
    "Model": "LAVA LMG01"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "Z21",
    "Device": "LZG402_OM",
    "Model": "LAVA LZG402 OM"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "Z21",
    "Device": "LZG402_OMI",
    "Model": "LAVA LZG402 OMI"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "Z25",
    "Device": "Z25",
    "Model": "Z25"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "Z3",
    "Device": "LMX04",
    "Model": "LAVA LMX04"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "Z3",
    "Device": "LZG403",
    "Model": "LAVA LZG403"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "Z3",
    "Device": "Z3_UP",
    "Model": "LAVA Z3 UP"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "Z3",
    "Device": "Z3_UP_2",
    "Model": "LAVA Z3 UP 2"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "Z3 PRO",
    "Device": "LZG403_25",
    "Model": "LAVA LZG403 25"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "Z30",
    "Device": "AH9910",
    "Model": "AH9910"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "Z30",
    "Device": "AN9910",
    "Model": "AN9910"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "Z33",
    "Device": "LEX402",
    "Model": "LAVA LEX402"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "Z4/Z6",
    "Device": "LMX06",
    "Model": "LAVA LMX06"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "Z40",
    "Device": "Z40",
    "Model": "Z40"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "Z41 2GB",
    "Device": "LN9910_2GB",
    "Model": "LN9910_2GB"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "Z42",
    "Device": "AF9010_F",
    "Model": "AF9010_F"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "Z42 Pro",
    "Device": "AF9020",
    "Model": "AF9020"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "Z50",
    "Device": "Z50",
    "Model": "Z50"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "Z50_Pro",
    "Device": "Z50_Pro",
    "Model": "Z50_Pro"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "Z51",
    "Device": "Z51",
    "Model": "Z51"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "Z52 Pro",
    "Device": "LH9910",
    "Model": "LH9910"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "Z53",
    "Device": "LE9920",
    "Model": "LE9920"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "Z60",
    "Device": "Z60",
    "Model": "Z60"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "Z60S",
    "Device": "Z60s",
    "Model": "Z60s"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "Z60s",
    "Device": "Z60s",
    "Model": "Z60s"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "Z61",
    "Device": "Z61",
    "Model": "Z61"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "Z61-2GB",
    "Device": "Z61_2GB",
    "Model": "Z61_2GB"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "Z61P",
    "Device": "Z61P",
    "Model": "Lava Z61P"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "Z61_2GB",
    "Device": "Z61_2GB",
    "Model": "Z61_2GB"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "Z70",
    "Device": "Z70",
    "Model": "Z70"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "Z80",
    "Device": "Z80",
    "Model": "Z80"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "Z81",
    "Device": "Z81",
    "Model": "Z81"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "Z90",
    "Device": "Z90",
    "Model": "Z90"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "Z91",
    "Device": "Z91",
    "Model": "Z91"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "Z92",
    "Device": "Z92",
    "Model": "Z92"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "Z93P",
    "Device": "Z93P",
    "Model": "Lava Z93P"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "ZX",
    "Device": "ZX",
    "Model": "ZX"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "benco Y30",
    "Device": "AF9030",
    "Model": "LAVA AF9030"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "ir59",
    "Device": "LE9930",
    "Model": "LAVA LE9930"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "iris 46",
    "Device": "LH9950",
    "Model": "LAVA LH9950"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "iris 54",
    "Device": "LH9930",
    "Model": "LAVA LH9930"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "iris 54",
    "Device": "LH9931",
    "Model": "LAVA LH9931"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "iris 821",
    "Device": "iris821",
    "Model": "iris821"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "iris 880",
    "Device": "iris880",
    "Model": "iris880"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "iris Fuel F2",
    "Device": "IFF2",
    "Model": "Fuel F2"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "iris atom",
    "Device": "A1",
    "Model": "A1"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "iris atom 3",
    "Device": "A3",
    "Model": "A3"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "iris30",
    "Device": "iris30",
    "Model": "iris30"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "iris31",
    "Device": "iris31",
    "Model": "iris 31"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "iris40",
    "Device": "iris40",
    "Model": "iris40"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "iris42",
    "Device": "iris42",
    "Model": "iris42"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "iris46",
    "Device": "LH9950",
    "Model": "LAVA LH9950"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "iris50",
    "Device": "iris50",
    "Model": "iris50"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "iris50c",
    "Device": "iris50c",
    "Model": "iris50"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "iris51",
    "Device": "iris51",
    "Model": "iris51"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "iris512",
    "Device": "iris512",
    "Model": "iris512"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "iris515",
    "Device": "iris515",
    "Model": "iris515"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "iris53",
    "Device": "iris53",
    "Model": "iris53"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "iris560",
    "Device": "iris560",
    "Model": "iris560"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "iris565",
    "Device": "iris565",
    "Model": "iris565"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "iris60",
    "Device": "iris60",
    "Model": "iris60"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "iris605",
    "Device": "iris605",
    "Model": "iris605"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "iris60c",
    "Device": "iris60c",
    "Model": "iris60c"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "iris65",
    "Device": "iris65",
    "Model": "iris65"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "iris702",
    "Device": "iris702",
    "Model": "iris702"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "iris80",
    "Device": "iris80",
    "Model": "iris80"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "iris821",
    "Device": "iris821",
    "Model": "iris821"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "iris870",
    "Device": "iris870",
    "Model": "iris870"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "iris88",
    "Device": "iris88",
    "Model": "iris88"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "iris880",
    "Device": "iris880",
    "Model": "iris880"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "iris88_go",
    "Device": "iris88_go",
    "Model": "iris88_go"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "iris88_lite",
    "Device": "iris88_lite",
    "Model": "iris88_lite"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "iris88s",
    "Device": "iris88s",
    "Model": "iris88s"
  },
  {
    "Retail Branding": "Lava",
    "Marketing Name": "op200",
    "Device": "AF9010",
    "Model": "AF9010"
  },
  {
    "Retail Branding": "Laxton",
    "Marketing Name": "Chameleon_8",
    "Device": "Laxton_Chameleon_8_A13",
    "Model": "Chameleon_8_A13"
  },
  {
    "Retail Branding": "Lazer",
    "Marketing Name": "MD1005 Tablet",
    "Device": "MD1005",
    "Model": "MD1005"
  },
  {
    "Retail Branding": "Lazer",
    "Marketing Name": "MID9526CM",
    "Device": "MID9526CM",
    "Model": "S952"
  },
  {
    "Retail Branding": "Lazer",
    "Marketing Name": "MW-7615P",
    "Device": "MW-7615P",
    "Model": "MW-7615P"
  },
  {
    "Retail Branding": "Lazer",
    "Marketing Name": "MW6617",
    "Device": "MW6617",
    "Model": "MW6617"
  },
  {
    "Retail Branding": "Lazer",
    "Marketing Name": "MY1306P",
    "Device": "MY1306P",
    "Model": "MY1306P"
  },
  {
    "Retail Branding": "Lazer",
    "Marketing Name": "X4508",
    "Device": "X4508",
    "Model": "X4508"
  },
  {
    "Retail Branding": "Le",
    "Marketing Name": "LeTV X40",
    "Device": "X4_40",
    "Model": "X4-40"
  },
  {
    "Retail Branding": "Le Pan",
    "Marketing Name": "TC1010",
    "Device": "FG6A-LP",
    "Model": "Le Pan TC1010"
  },
  {
    "Retail Branding": "Le Pan",
    "Marketing Name": "TC1020",
    "Device": "FG6Q",
    "Model": "Le Pan TC1020"
  },
  {
    "Retail Branding": "Le Pan",
    "Marketing Name": "TC802A",
    "Device": "UY8",
    "Model": "Le Pan TC802A"
  },
  {
    "Retail Branding": "LeBest",
    "Marketing Name": "A1",
    "Device": "A1",
    "Model": "A1"
  },
  {
    "Retail Branding": "LeBest",
    "Marketing Name": "L3",
    "Device": "L3",
    "Model": "L3"
  },
  {
    "Retail Branding": "LeBest",
    "Marketing Name": "LeBest L2",
    "Device": "L2",
    "Model": "L2"
  },
  {
    "Retail Branding": "LeBest",
    "Marketing Name": "LeBest L22025",
    "Device": "L22025",
    "Model": "LeBest L22025"
  },
  {
    "Retail Branding": "LeBest",
    "Marketing Name": "S1",
    "Device": "S1",
    "Model": "S1"
  },
  {
    "Retail Branding": "LeTV",
    "Marketing Name": "Le 2",
    "Device": "le_s2",
    "Model": "Le X520"
  },
  {
    "Retail Branding": "LeTV",
    "Marketing Name": "Le 2",
    "Device": "le_s2_ww",
    "Model": "Le X526"
  },
  {
    "Retail Branding": "LeTV",
    "Marketing Name": "Le 2",
    "Device": "le_s2_ww",
    "Model": "Le X527"
  },
  {
    "Retail Branding": "LeTV",
    "Marketing Name": "Le Max",
    "Device": "max1_in",
    "Model": "Le Max"
  },
  {
    "Retail Branding": "LeTV",
    "Marketing Name": "Le X507",
    "Device": "X3_HK",
    "Model": "Le X507"
  },
  {
    "Retail Branding": "LeTV",
    "Marketing Name": "Le X507",
    "Device": "X3_HK",
    "Model": "Le X509"
  },
  {
    "Retail Branding": "LeTV",
    "Marketing Name": "Le X509",
    "Device": "X3_HK",
    "Model": "Le X509"
  },
  {
    "Retail Branding": "LeTV",
    "Marketing Name": "Le1",
    "Device": "Le1",
    "Model": "x600"
  },
  {
    "Retail Branding": "LeTV",
    "Marketing Name": "Max3-65",
    "Device": "L653AN_US",
    "Model": "Max3-65"
  },
  {
    "Retail Branding": "LeTV",
    "Marketing Name": "Super TV X3-55 Pro",
    "Device": "L553AN_US",
    "Model": "X3-55 Pro"
  },
  {
    "Retail Branding": "LeTV",
    "Marketing Name": "uMax85",
    "Device": "DemeterDV",
    "Model": "uMax85"
  },
  {
    "Retail Branding": "LeTV",
    "Marketing Name": "x600",
    "Device": "x600",
    "Model": "X600"
  },
  {
    "Retail Branding": "Leader Phone",
    "Marketing Name": "Alphatel_T1",
    "Device": "Alphatel_T1",
    "Model": "Alphatel_T1"
  },
  {
    "Retail Branding": "Leader Phone",
    "Marketing Name": "B-50",
    "Device": "B-50",
    "Model": "LP_B-50"
  },
  {
    "Retail Branding": "Leader Phone",
    "Marketing Name": "INFINITY light",
    "Device": "LP_INFINITY_light",
    "Model": "INFINITY_light"
  },
  {
    "Retail Branding": "Leader Phone",
    "Marketing Name": "LP_Spectrum_S2",
    "Device": "LP_Spectrum_S2",
    "Model": "LP_Spectrum_S2"
  },
  {
    "Retail Branding": "Leader Phone",
    "Marketing Name": "N-45",
    "Device": "N_45",
    "Model": "N-45"
  },
  {
    "Retail Branding": "Leader Phone",
    "Marketing Name": "N-45 light",
    "Device": "N_45_light",
    "Model": "N-45 light"
  },
  {
    "Retail Branding": "Leader Phone",
    "Marketing Name": "Vyper",
    "Device": "LP_Vyper",
    "Model": "Vyper"
  },
  {
    "Retail Branding": "Leagoo",
    "Marketing Name": "KIICAA MIX",
    "Device": "KIICAA_MIX",
    "Model": "KIICAA MIX"
  },
  {
    "Retail Branding": "Leagoo",
    "Marketing Name": "KIICAA POWER",
    "Device": "KIICAA_POWER",
    "Model": "KIICAA POWER"
  },
  {
    "Retail Branding": "Leagoo",
    "Marketing Name": "LeaPad X",
    "Device": "LeaPad_X",
    "Model": "LeaPad_X"
  },
  {
    "Retail Branding": "Leagoo",
    "Marketing Name": "M10",
    "Device": "M10",
    "Model": "M10"
  },
  {
    "Retail Branding": "Leagoo",
    "Marketing Name": "M10A",
    "Device": "M10A",
    "Model": "M10A"
  },
  {
    "Retail Branding": "Leagoo",
    "Marketing Name": "M11",
    "Device": "M11",
    "Model": "M11"
  },
  {
    "Retail Branding": "Leagoo",
    "Marketing Name": "M12",
    "Device": "M12",
    "Model": "M12"
  },
  {
    "Retail Branding": "Leagoo",
    "Marketing Name": "M12A",
    "Device": "M12A",
    "Model": "M12A"
  },
  {
    "Retail Branding": "Leagoo",
    "Marketing Name": "M13",
    "Device": "M13",
    "Model": "M13"
  },
  {
    "Retail Branding": "Leagoo",
    "Marketing Name": "M15",
    "Device": "M15",
    "Model": "M15"
  },
  {
    "Retail Branding": "Leagoo",
    "Marketing Name": "M9",
    "Device": "M9",
    "Model": "M9"
  },
  {
    "Retail Branding": "Leagoo",
    "Marketing Name": "M9 Pro",
    "Device": "M9_Pro",
    "Model": "M9 Pro"
  },
  {
    "Retail Branding": "Leagoo",
    "Marketing Name": "M9A Pro",
    "Device": "M9A_Pro",
    "Model": "M9A Pro"
  },
  {
    "Retail Branding": "Leagoo",
    "Marketing Name": "P1",
    "Device": "P1",
    "Model": "P1"
  },
  {
    "Retail Branding": "Leagoo",
    "Marketing Name": "P1 Pro",
    "Device": "P1_Pro",
    "Model": "P1 Pro"
  },
  {
    "Retail Branding": "Leagoo",
    "Marketing Name": "Power 2",
    "Device": "Power_2",
    "Model": "Power 2"
  },
  {
    "Retail Branding": "Leagoo",
    "Marketing Name": "Power 2 Pro",
    "Device": "Power_2_Pro",
    "Model": "Power 2 Pro"
  },
  {
    "Retail Branding": "Leagoo",
    "Marketing Name": "Power 5",
    "Device": "Power_5",
    "Model": "Power 5"
  },
  {
    "Retail Branding": "Leagoo",
    "Marketing Name": "Power 5 Lite",
    "Device": "Power_5_Lite",
    "Model": "Power 5 Lite"
  },
  {
    "Retail Branding": "Leagoo",
    "Marketing Name": "S10",
    "Device": "S10",
    "Model": "S10"
  },
  {
    "Retail Branding": "Leagoo",
    "Marketing Name": "S11",
    "Device": "S11",
    "Model": "S11"
  },
  {
    "Retail Branding": "Leagoo",
    "Marketing Name": "S8",
    "Device": "S8",
    "Model": "S8"
  },
  {
    "Retail Branding": "Leagoo",
    "Marketing Name": "S8 Pro",
    "Device": "S8Pro",
    "Model": "S8 Pro"
  },
  {
    "Retail Branding": "Leagoo",
    "Marketing Name": "S9",
    "Device": "S9",
    "Model": "S9"
  },
  {
    "Retail Branding": "Leagoo",
    "Marketing Name": "T5",
    "Device": "T5",
    "Model": "T5"
  },
  {
    "Retail Branding": "Leagoo",
    "Marketing Name": "T5c",
    "Device": "T5c",
    "Model": "T5c"
  },
  {
    "Retail Branding": "Leagoo",
    "Marketing Name": "T8",
    "Device": "T8",
    "Model": "T8"
  },
  {
    "Retail Branding": "Leagoo",
    "Marketing Name": "T8s",
    "Device": "T8s",
    "Model": "T8s"
  },
  {
    "Retail Branding": "Leagoo",
    "Marketing Name": "XRover",
    "Device": "XRover",
    "Model": "XRover"
  },
  {
    "Retail Branding": "Leagoo",
    "Marketing Name": "XRover C",
    "Device": "XRover_C",
    "Model": "XRover C"
  },
  {
    "Retail Branding": "Leagoo",
    "Marketing Name": "Z10",
    "Device": "Z10",
    "Model": "Z10"
  },
  {
    "Retail Branding": "Leagoo",
    "Marketing Name": "Z10-E",
    "Device": "Z10-E",
    "Model": "Z10-E"
  },
  {
    "Retail Branding": "Leagoo",
    "Marketing Name": "Z13",
    "Device": "Z13",
    "Model": "Z13"
  },
  {
    "Retail Branding": "Leagoo",
    "Marketing Name": "Z7",
    "Device": "Z7",
    "Model": "Z7"
  },
  {
    "Retail Branding": "Leagoo",
    "Marketing Name": "Z9",
    "Device": "Z9",
    "Model": "Z9"
  },
  {
    "Retail Branding": "Leagoo",
    "Marketing Name": "Z9A",
    "Device": "Z9A",
    "Model": "Z9A"
  },
  {
    "Retail Branding": "Lechpol",
    "Marketing Name": "EAGLE1069",
    "Device": "EAGLE_1069",
    "Model": "KM1069"
  },
  {
    "Retail Branding": "Lechpol",
    "Marketing Name": "LIVE 4 KM0438",
    "Device": "LIVE4_KM0438",
    "Model": "LIVE4_KM0438"
  },
  {
    "Retail Branding": "Lechpol",
    "Marketing Name": "LIVE 4 KM0439",
    "Device": "LIVE4_KM0439",
    "Model": "KrugerMatz_LIVE4"
  },
  {
    "Retail Branding": "Lechpol",
    "Marketing Name": "LIVE 4 KM0439",
    "Device": "LIVE4_KM0439",
    "Model": "LIVE4_KM0439"
  },
  {
    "Retail Branding": "Lechpol",
    "Marketing Name": "MOVE 6 mini",
    "Device": "MOVE_6_mini",
    "Model": "MOVE_6_mini"
  },
  {
    "Retail Branding": "Leeco",
    "Marketing Name": "Le Max2",
    "Device": "le_x2",
    "Model": "Le X820"
  },
  {
    "Retail Branding": "Leeco",
    "Marketing Name": "Le Max2",
    "Device": "le_x2",
    "Model": "Le X821"
  },
  {
    "Retail Branding": "Leeco",
    "Marketing Name": "Le Max2",
    "Device": "le_x2_na",
    "Model": "Le X829"
  },
  {
    "Retail Branding": "Leeco",
    "Marketing Name": "Le Pro3",
    "Device": "le_zl1",
    "Model": "LEX725"
  },
  {
    "Retail Branding": "Leeco",
    "Marketing Name": "Le Pro3",
    "Device": "le_zl1",
    "Model": "LEX727"
  },
  {
    "Retail Branding": "Leeco",
    "Marketing Name": "Le S3",
    "Device": "le_s2_na",
    "Model": "Le X522"
  },
  {
    "Retail Branding": "Leeco",
    "Marketing Name": "Le s2",
    "Device": "le_s2",
    "Model": "Le X520"
  },
  {
    "Retail Branding": "Leeco",
    "Marketing Name": "LePro3",
    "Device": "le_zl1",
    "Model": "LEX725"
  },
  {
    "Retail Branding": "Leeco",
    "Marketing Name": "LePro3",
    "Device": "le_zl1",
    "Model": "LEX727"
  },
  {
    "Retail Branding": "Leeco",
    "Marketing Name": "LeoPro3",
    "Device": "le_zl1",
    "Model": "LEX725"
  },
  {
    "Retail Branding": "Leeco",
    "Marketing Name": "X Serials(X43 Pro, X55, X65)",
    "Device": "DemeterUHD",
    "Model": "X4-55"
  },
  {
    "Retail Branding": "Legamaster",
    "Marketing Name": "EVOLVE2",
    "Device": "ETX",
    "Model": "ETX"
  },
  {
    "Retail Branding": "Legamaster",
    "Marketing Name": "EVOLVE3",
    "Device": "EVX",
    "Model": "EVX"
  },
  {
    "Retail Branding": "Legamaster",
    "Marketing Name": "NAVIGATOR",
    "Device": "NAV_RK",
    "Model": "NAV"
  },
  {
    "Retail Branding": "LegendComfortable",
    "Marketing Name": "SEP011037",
    "Device": "SEP011037",
    "Model": "SEP011037"
  },
  {
    "Retail Branding": "LeiaInc",
    "Marketing Name": "Lume Pad",
    "Device": "LumePad",
    "Model": "LPD-20W"
  },
  {
    "Retail Branding": "Leica",
    "Marketing Name": "Leica CSX8",
    "Device": "CSX8",
    "Model": "LGT-08QA-2301"
  },
  {
    "Retail Branding": "Leica",
    "Marketing Name": "Leica Laser",
    "Device": "wuyishan",
    "Model": "SmartTV 4K"
  },
  {
    "Retail Branding": "Lenco",
    "Marketing Name": "Israel",
    "Device": "sepolia",
    "Model": "LENCO 4K smart TV"
  },
  {
    "Retail Branding": "Lenco",
    "Marketing Name": "Lenovo Tab K8",
    "Device": "TB-8506N",
    "Model": "Lenovo TB-8506N"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "",
    "Device": "18382AU",
    "Model": "ThinkPad Tablet"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "",
    "Device": "A1_07",
    "Model": "A1_07"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "",
    "Device": "A2109A",
    "Model": "IdeaTabA2109A"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "",
    "Device": "A2207A-H",
    "Model": "IdeaTabA2207A-H"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "",
    "Device": "A278t",
    "Model": "Lenovo A278t"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "",
    "Device": "A288t",
    "Model": "Lenovo A288t"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "",
    "Device": "A298t",
    "Model": "Lenovo A298t"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "",
    "Device": "A30t",
    "Model": "A30t"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "",
    "Device": "A530_msm7627a_alps",
    "Model": "Lenovo A530"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "",
    "Device": "A560e_msm7627a",
    "Model": "LNV-Lenovo_A560e"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "",
    "Device": "A580",
    "Model": "Lenovo A580"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "",
    "Device": "A600e_msm8625",
    "Model": "LNV-Lenovo A600e"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "",
    "Device": "A60plus",
    "Model": "Lenovo A60+"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "",
    "Device": "A630",
    "Model": "Lenovo A630"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "",
    "Device": "A660",
    "Model": "Lenovo A660"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "",
    "Device": "A668t",
    "Model": "Lenovo A668t"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "",
    "Device": "A690",
    "Model": "Lenovo A690"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "",
    "Device": "A700e",
    "Model": "Lenovo A700e"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "",
    "Device": "A710e_msm7627a",
    "Model": "Lenovo A710e"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "",
    "Device": "A780_msm7627a",
    "Model": "Lenovo A780"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "",
    "Device": "A789",
    "Model": "Lenovo A789"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "",
    "Device": "A798t",
    "Model": "Lenovo A798t"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "",
    "Device": "A800",
    "Model": "Lenovo A800"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "",
    "Device": "Android",
    "Model": "Lenovo A60+"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "",
    "Device": "K1",
    "Model": "K1"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "",
    "Device": "K2110A-F",
    "Model": "IdeaTab K2110A-F"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "",
    "Device": "LIFETAB_S9512",
    "Model": "LIFETAB_S9512"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "",
    "Device": "Lenovo_S2",
    "Model": "Lenovo S2-38AH0"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "",
    "Device": "MD_LIFETAB_P9516",
    "Model": "MD_LIFETAB_P9516"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "",
    "Device": "P700i",
    "Model": "Lenovo P700i"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "",
    "Device": "P770",
    "Model": "Lenovo P770"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "",
    "Device": "S2005A-H",
    "Model": "S2005A-H"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "",
    "Device": "S2109A",
    "Model": "IdeaTabS2109A-F"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "",
    "Device": "S560",
    "Model": "Lenovo S560"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "",
    "Device": "S880i",
    "Model": "Lenovo S880i"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "",
    "Device": "S890",
    "Model": "Lenovo S890"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "",
    "Device": "S899t",
    "Model": "Lenovo S899t"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "",
    "Device": "S920_ROW",
    "Model": "Lenovo S920"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "",
    "Device": "S920_ROW",
    "Model": "Lenovo S920_ROW"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "",
    "Device": "SmartTabII7",
    "Model": "SmartTabII7"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "",
    "Device": "T702T",
    "Model": "A66t"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "",
    "Device": "a2_3g_data",
    "Model": "IdeaTab A2107A-H"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "",
    "Device": "a2_wifi",
    "Model": "IdeaTab A2107A-F"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "",
    "Device": "a2_wifi_row",
    "Model": "IdeaTab A2107A-F"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "",
    "Device": "a326",
    "Model": "Lenovo A326"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "",
    "Device": "a360",
    "Model": "Lenovo A360"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "",
    "Device": "a370",
    "Model": "Lenovo A370"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "",
    "Device": "a500plus",
    "Model": "Lenovo A500+"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "",
    "Device": "a520_gray",
    "Model": "Lenovo A520GRAY"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "",
    "Device": "a59wg",
    "Model": "Lenovo A500"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "",
    "Device": "a59wg",
    "Model": "Lenovo A500+"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "",
    "Device": "a60_campus",
    "Model": "Lenovo A60"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "",
    "Device": "a60id_tel",
    "Model": "Lenovo A60"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "",
    "Device": "a60os",
    "Model": "Lenovo A60"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "",
    "Device": "a60tw",
    "Model": "Lenovo A60"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "",
    "Device": "a65",
    "Model": "Lenovo A65"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "",
    "Device": "a65_ph_id_vn",
    "Model": "Lenovo A65"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "",
    "Device": "a65cu",
    "Model": "Lenovo A65"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "",
    "Device": "amazon_w",
    "Model": "Lenovo A1-32AB0"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "",
    "Device": "apollo_td",
    "Model": "Lenovo S2-38AT0"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "",
    "Device": "apollo_wg",
    "Model": "Lenovo S2-38AH0"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "",
    "Device": "apollohd_w",
    "Model": "Lenovo K2"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "",
    "Device": "apollozero_w",
    "Model": "Lenovo S760"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "",
    "Device": "aruba",
    "Model": "Lenovo A765e"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "",
    "Device": "austin",
    "Model": "Lenovo A300"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "",
    "Device": "ideatv_S31",
    "Model": "ideatv S31"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "",
    "Device": "lenovo13_td",
    "Model": "Lenovo A366t"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "",
    "Device": "lenovo15_td_ics",
    "Model": "Lenovo A698t"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "",
    "Device": "lenovo73_cu",
    "Model": "Lenovo A60"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "",
    "Device": "lenovo73_gb",
    "Model": "Lenovo A520"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "",
    "Device": "lenovo73_gb",
    "Model": "Lenovo P70"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "",
    "Device": "lenovo75_a2_att_ics",
    "Model": "A2107A-H"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "",
    "Device": "lenovo75_a2_ics",
    "Model": "IdeaTab A2107A-H"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "",
    "Device": "lenovo75_cu_gb",
    "Model": "Lenovo A750"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "",
    "Device": "lenovo75_cu_ics",
    "Model": "Lenovo A750"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "",
    "Device": "mfld_pr2",
    "Model": "Lenovo K800"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "",
    "Device": "mi_350",
    "Model": "Spice Mi-350"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "",
    "Device": "msm7627_ea95",
    "Model": "Lenovo A390e"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "",
    "Device": "msm7627_surf",
    "Model": "A68e"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "",
    "Device": "msm7627_surf",
    "Model": "Lenovo A68e"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "",
    "Device": "msm7627a",
    "Model": "LNV-Lenovo A790e"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "",
    "Device": "msm7627a_ha99",
    "Model": "Lenovo A780"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "",
    "Device": "msm8660_surf",
    "Model": "IdeaTab S2007A-F"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "",
    "Device": "msm8660_surf",
    "Model": "IdeaTab S2007A-H"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "",
    "Device": "msm8660_surf",
    "Model": "IdeaTab S2010A-D"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "",
    "Device": "msm8660_surf",
    "Model": "IdeaTab S2010A-F"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "",
    "Device": "msm8660_surf",
    "Model": "IdeaTab S2010A-H"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "",
    "Device": "msm8960",
    "Model": "IdeaTabS2110AF"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "",
    "Device": "msm8960",
    "Model": "IdeaTabS2110AH"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "",
    "Device": "msm8960",
    "Model": "SmartTabII10"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "",
    "Device": "p700",
    "Model": "Lenovo P700"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "",
    "Device": "p700_ph",
    "Model": "Lenovo P700"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "",
    "Device": "s880",
    "Model": "Lenovo S880"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "",
    "Device": "s880_row",
    "Model": "Lenovo S880"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "",
    "Device": "sanpaolo",
    "Model": "IdeaTabV2007A"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "",
    "Device": "santiago",
    "Model": "IdeaTabV2010A"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "",
    "Device": "santiago",
    "Model": "IdeaTabV2010A-W"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "",
    "Device": "sicily",
    "Model": "Lenovo S696"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "",
    "Device": "stuttgart_row",
    "Model": "Lenovo K860"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "",
    "Device": "ventana",
    "Model": "K1"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "32A3   40A3   43A3   49A3",
    "Device": "uzi",
    "Model": "LenovoTV 32A3"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "55E82,49E82,50U3A,58U3A,70UD30A,60UD30A,80UD30A,65UR30A",
    "Device": "sun",
    "Model": "AQUOS 50U3A"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "55E82,49E82,50U3A,58U3A,70UD30A,60UD30A,80UD30A,65UR30A",
    "Device": "sun",
    "Model": "AQUOS 65UR30A"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "55E82,49E82,50U3A,58U3A,70UD30A,60UD30A,80UD30A,65UR30A",
    "Device": "sun",
    "Model": "AQUOS 70UD30A"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "55E82,49E82,50U3A,58U3A,70UD30A,60UD30A,80UD30A,65UR30A",
    "Device": "sun",
    "Model": "AQUOS 70UG30A"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "55E82,49E82,50U3A,58U3A,70UD30A,60UD30A,80UD30A,65UR30A",
    "Device": "sun",
    "Model": "AQUOS 70XU30A"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "55E82,49E82,50U3A,58U3A,70UD30A,60UD30A,80UD30A,65UR30A",
    "Device": "sun",
    "Model": "LenovoTV 49E82"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "55E82,49E82,50U3A,58U3A,70UD30A,60UD30A,80UD30A,65UR30A",
    "Device": "sun",
    "Model": "LenovoTV 55E82"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "60K72",
    "Device": "ideatv_K72",
    "Model": "ideatv K72"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "A10",
    "Device": "A10",
    "Model": "IdeaPadA10"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "A10-70LC",
    "Device": "A10-70LC",
    "Model": "Lenovo TAB 2 A10-70LC"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "A1000",
    "Device": "A1000",
    "Model": "Lenovo A1000"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "A1000",
    "Device": "A1000F",
    "Model": "IdeaTabA1000-F"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "A1000-G",
    "Device": "A1000G",
    "Model": "IdeaTabA1000-G"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "A1000L",
    "Device": "A1000LF",
    "Model": "IdeaTabA1000L-F"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "A1000m",
    "Device": "scx35_sp7731gea_taichi",
    "Model": "Lenovo A1000m"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "A1010",
    "Device": "A1010a20",
    "Model": "Lenovo A1010a20"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "A1900",
    "Device": "A1900",
    "Model": "Lenovo A1900"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "A2010-a",
    "Device": "A2010-a",
    "Model": "Lenovo A2010-a"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "A2010l36",
    "Device": "A2010l36",
    "Model": "Lenovo A2010l36"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "A2016a40",
    "Device": "A2016a40",
    "Model": "Lenovo A2016a40"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "A2016b30",
    "Device": "A2016b30",
    "Model": "Lenovo A2016b30"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "A2016b31",
    "Device": "A2016b31",
    "Model": "Lenovo A2016b31"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "A2020a40",
    "Device": "angus3A4",
    "Model": "Lenovo A2020a40"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "A2020a40",
    "Device": "angus3A41",
    "Model": "Lenovo A2020a40"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "A208t",
    "Device": "A208t",
    "Model": "Lenovo A208t"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "A2105",
    "Device": "Lenovo_A2105",
    "Model": "Lenovo_A2105"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "A2107A",
    "Device": "A2107A-H",
    "Model": "A2107A-H"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "A218t",
    "Device": "A218t",
    "Model": "Lenovo A218t"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "A228t",
    "Device": "A228t",
    "Model": "Lenovo A228t"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "A238t",
    "Device": "A238t",
    "Model": "Lenovo A238t"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "A2580",
    "Device": "A2580",
    "Model": "Lenovo A2580"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "A269",
    "Device": "A269",
    "Model": "Lenovo A269"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "A269i",
    "Device": "A269i",
    "Model": "Lenovo A269i"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "A278t",
    "Device": "A278t",
    "Model": "Lenovo A278t"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "A2800",
    "Device": "A2800-d",
    "Model": "Lenovo A2800-d"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "A2860",
    "Device": "A2860",
    "Model": "Lenovo A2860"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "A3000",
    "Device": "A3000",
    "Model": "Lenovo A3000-H"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "A300t",
    "Device": "A300t",
    "Model": "Lenovo A300t"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "A301LV",
    "Device": "A301LV",
    "Model": "A301LV"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "A305E",
    "Device": "A305e",
    "Model": "LNV-Lenovo A305e"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "A305E",
    "Device": "A305e",
    "Model": "Lenovo A305e"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "A308t",
    "Device": "A308t",
    "Model": "Lenovo A308t"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "A316",
    "Device": "A316",
    "Model": "Lenovo A316"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "A316i",
    "Device": "A316i",
    "Model": "Lenovo A316i"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "A318t",
    "Device": "A318t",
    "Model": "Lenovo A318t"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "A319",
    "Device": "A319",
    "Model": "Lenovo A319"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "A31910t30",
    "Device": "angus3T3",
    "Model": "Lenovo A3910t30"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "A320t",
    "Device": "A320t",
    "Model": "Lenovo A320t"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "A328",
    "Device": "A328",
    "Model": "Lenovo A328"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "A328t",
    "Device": "A328t",
    "Model": "Lenovo A328t"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "A3300",
    "Device": "A3300-H",
    "Model": "LenovoA3300-H"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "A3300",
    "Device": "A3300-T",
    "Model": "Lenovo A3300-T"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "A3300-GV",
    "Device": "A3300-GV",
    "Model": "LenovoA3300-GV"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "A3300-HV",
    "Device": "A3300-HV",
    "Model": "Lenovo A3300-HV"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "A330e",
    "Device": "A330e",
    "Model": "Lenovo A330e"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "A338t",
    "Device": "A338t",
    "Model": "Lenovo A338t"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "A3500",
    "Device": "A3500",
    "Model": "Lenovo A3500"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "A3500",
    "Device": "A3500HV",
    "Model": "Lenovo A3500-HV"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "A3500-F",
    "Device": "A3500F",
    "Model": "EveryPad2"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "A3500-F",
    "Device": "A3500F",
    "Model": "Lenovo A3500-F"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "A3500-FL",
    "Device": "A3500FL",
    "Model": "Lenovo A3500-FL"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "A3500-H",
    "Device": "A3500H",
    "Model": "Lenovo A3500-H"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "A355e",
    "Device": "A355e",
    "Model": "Lenovo A355e"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "A358t",
    "Device": "A358t",
    "Model": "Lenovo A358t"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "A3600-D",
    "Device": "A3600-d",
    "Model": "Lenovo A3600-d"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "A3600u",
    "Device": "A3600u",
    "Model": "Lenovo A3600u"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "A360e",
    "Device": "A360e",
    "Model": "Lenovo A360e"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "A360t",
    "Device": "A360t",
    "Model": "Lenovo A360t"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "A368t",
    "Device": "A368t",
    "Model": "Lenovo A368t"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "A369",
    "Device": "A369",
    "Model": "Lenovo A369"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "A369i",
    "Device": "A369i",
    "Model": "Lenovo A369i"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "A370e",
    "Device": "A370e",
    "Model": "LNV-Lenovo A370e"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "A375e",
    "Device": "A375e",
    "Model": "LNV-Lenovo A375e"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "A376",
    "Device": "A376",
    "Model": "Lenovo A376"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "A378t",
    "Device": "A378t",
    "Model": "Lenovo A378t"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "A3800-D",
    "Device": "A3800-d",
    "Model": "Lenovo A3800-d"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "A380e",
    "Device": "A380e",
    "Model": "LNV-Lenovo A380e"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "A380t",
    "Device": "A380t",
    "Model": "Lenovo A380t"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "A385e",
    "Device": "A385e",
    "Model": "LNV-Lenovo A385e"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "A3860",
    "Device": "A3580",
    "Model": "Lenovo A3580"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "A3860",
    "Device": "A3860",
    "Model": "Lenovo A3860"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "A388t",
    "Device": "A388t",
    "Model": "Lenovo A388t"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "A390",
    "Device": "A390",
    "Model": "Lenovo A390"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "A390",
    "Device": "A390",
    "Model": "Lenovo A390_ROW"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "A3900",
    "Device": "pxa1L88H2",
    "Model": "Lenovo A3900"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "A390t",
    "Device": "A390t",
    "Model": "Lenovo A390t"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "A395e",
    "Device": "A395e",
    "Model": "LNV-Lenovo A395e"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "A396",
    "Device": "A396",
    "Model": "Lenovo A396"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "A396",
    "Device": "A396_TY",
    "Model": "Lenovo A396_TY"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "A398t",
    "Device": "A398t",
    "Model": "Lenovo A398t"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "A398t+",
    "Device": "A398tp",
    "Model": "Lenovo A398t+"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "A399",
    "Device": "Aiken",
    "Model": "Lenovo A399"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "A5000",
    "Device": "A5000",
    "Model": "Lenovo A5000"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "A505e",
    "Device": "A505e",
    "Model": "LNV-Lenovo A505e"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "A516",
    "Device": "A516",
    "Model": "Lenovo A516"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "A516",
    "Device": "A516_ROW",
    "Model": "Lenovo A516"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "A526",
    "Device": "A526",
    "Model": "Lenovo A526"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "A529",
    "Device": "A529",
    "Model": "Lenovo A529"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "A536",
    "Device": "A536",
    "Model": "Lenovo A536"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "A5500",
    "Device": "A5500",
    "Model": "Lenovo A5500"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "A5500-F",
    "Device": "A5500-F",
    "Model": "Lenovo A5500-F"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "A5500-H",
    "Device": "A5500-H",
    "Model": "Lenovo A5500-H"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "A5500-HV",
    "Device": "A5500-HV",
    "Model": "Lenovo A5500-HV"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "A560",
    "Device": "A560_msm8212",
    "Model": "Lenovo A560"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "A560",
    "Device": "A560_msm8610",
    "Model": "LNV-Lenovo A560"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "A5800-D",
    "Device": "A5800-D",
    "Model": "Lenovo A5800-D"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "A588t",
    "Device": "LenovoA588t",
    "Model": "LenovoA588t"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "A6000",
    "Device": "Kraft-A6000",
    "Model": "Lenovo A6000"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "A6000-l",
    "Device": "Kraft-A6000-l",
    "Model": "Lenovo A6000-l"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "A6010",
    "Device": "A6010",
    "Model": "Lenovo A6010"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "A606",
    "Device": "A606",
    "Model": "Lenovo A606"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "A616",
    "Device": "A616",
    "Model": "Lenovo A616"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "A628t",
    "Device": "A628t",
    "Model": "Lenovo A628t"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "A630",
    "Device": "A630e",
    "Model": "LNV-Lenovo A630e"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "A656",
    "Device": "A656",
    "Model": "Lenovo A656"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "A658T",
    "Device": "A658t",
    "Model": "Lenovo A658t"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "A6600",
    "Device": "A6600d40",
    "Model": "Lenovo A6600d40"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "A6600 Plus",
    "Device": "A6600a40",
    "Model": "Lenovo A6600a40"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "A670t",
    "Device": "A670t",
    "Model": "Lenovo A670t"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "A678t",
    "Device": "A678t",
    "Model": "Lenovo A678t"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "A680",
    "Device": "A680",
    "Model": "Lenovo A680"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "A680",
    "Device": "A680",
    "Model": "Lenovo A680_ROW"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "A6800",
    "Device": "A6800",
    "Model": "Lenovo A6800"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "A688t",
    "Device": "A688t",
    "Model": "Lenovo A688t"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "A690e",
    "Device": "A690e",
    "Model": "LNV-Lenovo A690e"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "A7",
    "Device": "AK47",
    "Model": "Lenovo L19111"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "A7-30GC",
    "Device": "A7-30GC",
    "Model": "Lenovo TAB 2 A7-30GC"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "A7-30H",
    "Device": "A7-30H",
    "Model": "Lenovo TAB 2 A7-30D"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "A7-30H",
    "Device": "A7-30H",
    "Model": "Lenovo TAB 2 A7-30H"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "A7-60HC",
    "Device": "A760HC",
    "Model": "Lenovo A7-60HC"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "A7000",
    "Device": "A7000-a",
    "Model": "Lenovo A7000-a"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "A7000 Plus",
    "Device": "A7000plus",
    "Model": "Lenovo A7000-a"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "A706",
    "Device": "armani",
    "Model": "Lenovo A706"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "A706_ROW",
    "Device": "armani_row",
    "Model": "Lenovo A706_ROW"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "A720e",
    "Device": "andorrap",
    "Model": "Lenovo A720e"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "A750e",
    "Device": "athenae",
    "Model": "Lenovo A750e"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "A760",
    "Device": "audi",
    "Model": "Lenovo A760"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "A7600",
    "Device": "A7600",
    "Model": "Lenovo A7600"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "A7600",
    "Device": "aiocmcc_ttp",
    "Model": "Lenovo A7600-m"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "A7600",
    "Device": "aiocu_wtfp",
    "Model": "Lenovo A7600"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "A7600-F",
    "Device": "A7600-F",
    "Model": "Lenovo A7600-F"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "A7600-H",
    "Device": "A7600-H",
    "Model": "Lenovo A7600-H"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "A7600-HV",
    "Device": "A7600-HV",
    "Model": "Lenovo A7600-HV"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "A766",
    "Device": "A766",
    "Model": "Lenovo A766"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "A768t",
    "Device": "airplayt",
    "Model": "Lenovo A768t"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "A7700",
    "Device": "A7700",
    "Model": "A7700"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "A7700",
    "Device": "A7700",
    "Model": "Lenovo A7700"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "A770e",
    "Device": "athenaep",
    "Model": "Lenovo A770e"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "A780e",
    "Device": "A780e",
    "Model": "LNV-Lenovo A780e"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "A785e",
    "Device": "A785e",
    "Model": "LNV-Lenovo A785e"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "A788t",
    "Device": "A788t",
    "Model": "Lenovo A788t"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "A8-50",
    "Device": "A8-50L",
    "Model": "Lenovo TAB 2 A8-50L"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "A8-50",
    "Device": "A8-50LC",
    "Model": "Lenovo 2 A8-50LC"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "A8-50",
    "Device": "A8-50LC",
    "Model": "Lenovo TAB 2 A8-50LC"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "A805e",
    "Device": "airplayep",
    "Model": "Lenovo A805e"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "A806",
    "Device": "A806",
    "Model": "Lenovo A806"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "A808t",
    "Device": "A808t",
    "Model": "Lenovo A808t"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "A808t-i",
    "Device": "A808t-i",
    "Model": "Lenovo A808t-i"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "A816",
    "Device": "airplayw",
    "Model": "Lenovo A5100"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "A816",
    "Device": "airplayw",
    "Model": "Lenovo A816"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "A820",
    "Device": "A820",
    "Model": "Lenovo A820"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "A820e",
    "Device": "andorra",
    "Model": "Lenovo A820e"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "A820t",
    "Device": "A820t",
    "Model": "Lenovo A820t"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "A828",
    "Device": "A858",
    "Model": "Lenovo A858"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "A828t",
    "Device": "A828t",
    "Model": "Lenovo A828t"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "A830",
    "Device": "A830",
    "Model": "Lenovo A830"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "A850",
    "Device": "A850",
    "Model": "Lenovo A850"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "A850",
    "Device": "A850_ROW",
    "Model": "Lenovo A850"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "A850+",
    "Device": "A850p",
    "Model": "Lenovo A850+"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "A858t",
    "Device": "A858t",
    "Model": "Lenovo A858t"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "A859",
    "Device": "A859_ROW",
    "Model": "Lenovo A859"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "A860e",
    "Device": "artini",
    "Model": "Lenovo A860e"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "A889",
    "Device": "A889",
    "Model": "Lenovo A889"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "A890e",
    "Device": "airbuse",
    "Model": "Lenovo A890e"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "A916",
    "Device": "A916",
    "Model": "Lenovo A916"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "A936",
    "Device": "A936",
    "Model": "Lenovo A936"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "A938t",
    "Device": "A938t",
    "Model": "Lenovo A938t"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "B6000-F",
    "Device": "B6000",
    "Model": "Lenovo B6000-F"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "B6000-H",
    "Device": "B6000",
    "Model": "Lenovo B6000-H"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "B6000-HV",
    "Device": "B6000",
    "Model": "Lenovo B6000-HV"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "B8000-F",
    "Device": "B8000",
    "Model": "Lenovo B8000-F"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "B8000-H",
    "Device": "B8000",
    "Model": "Lenovo B8000-H"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "B8080",
    "Device": "B8080",
    "Model": "Lenovo B8080-F"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "B8080-H",
    "Device": "B8080",
    "Model": "Lenovo B8080-H"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "B8080-HV",
    "Device": "B8080",
    "Model": "Lenovo B8080-HV"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "E4002",
    "Device": "E4002",
    "Model": "MEDION E4002"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "EveryPad",
    "Device": "A3000",
    "Model": "EveryPad"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "EveryPad",
    "Device": "A3000",
    "Model": "IdeaTab A3000-F"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "EveryPad2",
    "Device": "A3500F",
    "Model": "EveryPad2"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "IdeaTV",
    "Device": "msm8660_surf",
    "Model": "ideatv K91"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "IdeaTab A1000",
    "Device": "A1000LF",
    "Model": "LenovoA1000L-F"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "IdeaTab A1010",
    "Device": "A1010T",
    "Model": "IdeaTabA1010-T"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "IdeaTab A1020",
    "Device": "A1020T",
    "Model": "IdeaTabA1020-T"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "IdeaTab A3000",
    "Device": "A3000",
    "Model": "IdeaTab A3000-H"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "IdeaTab A3000",
    "Device": "A3000",
    "Model": "Vodafone Smart Tab III 7"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "IdeaTab A5000",
    "Device": "A5000E",
    "Model": "IdeaTabA5000-E"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "IdeaTab S6000",
    "Device": "S6000",
    "Model": "IdeaTab S6000-F"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "IdeaTab S6000",
    "Device": "S6000",
    "Model": "IdeaTab S6000-H"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "IdeaTab S6000",
    "Device": "S6000",
    "Model": "Vodafone Smart Tab III 10"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Indigo",
    "Device": "Indigo",
    "Model": "ThinkPad Tablet"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "K1",
    "Device": "K1",
    "Model": "K1"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "K10e70",
    "Device": "K10e70",
    "Model": "Lenovo K10e70"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "K3 Note",
    "Device": "K50a40",
    "Model": "Lenovo K50a40"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "K3 Note",
    "Device": "aio_3m_otfp_m",
    "Model": "Lenovo K50-t3s"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "K3 Note",
    "Device": "aio_otfp",
    "Model": "Lenovo K50-T5"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "K3 Note",
    "Device": "aio_otfp",
    "Model": "Lenovo K50-t5"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "K30-E",
    "Device": "Kraft-E",
    "Model": "Lenovo K30-E"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "K30-T",
    "Device": "Kraft-T",
    "Model": "Lenovo K30-T"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "K30-TM",
    "Device": "Kraft-TM",
    "Model": "Lenovo K30-TM"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "K30-W",
    "Device": "Kraft-W",
    "Model": "Lenovo K30-W"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "K32",
    "Device": "K32c36",
    "Model": "Lenovo K32c36"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "K32c30",
    "Device": "K32c30",
    "Model": "Lenovo K32c30"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "K350t",
    "Device": "K350t",
    "Model": "K350t"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "K5",
    "Device": "A6020a40",
    "Model": "Lenovo A6020a40"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "K5",
    "Device": "A6020a41",
    "Model": "Lenovo A6020a41"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "K5",
    "Device": "A6020l36",
    "Model": "Lenovo A6020l36"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "K5",
    "Device": "A6020l37",
    "Model": "Lenovo A6020l37"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "K5 Note",
    "Device": "A7020a40",
    "Model": "Lenovo A7020a40"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "K5 Note",
    "Device": "A7020a48",
    "Model": "Lenovo A7020a48"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "K5 Note",
    "Device": "austin2018",
    "Model": "Lenovo L38012"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "K5 Note",
    "Device": "k52_e78",
    "Model": "Lenovo K52e78"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "K5 Note",
    "Device": "k52_t58",
    "Model": "Lenovo K52t58"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "K5 Plus",
    "Device": "A6020a46",
    "Model": "Lenovo A6020a46"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "K5 S",
    "Device": "K5S",
    "Model": "Lenovo L38031"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "K50",
    "Device": "K50-t5",
    "Model": "Lenovo K50-t5"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "K50",
    "Device": "aio_3m_otfp",
    "Model": "Lenovo K50-t3s"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "K50-T5",
    "Device": "aio_otfp_m",
    "Model": "Lenovo K50-t5"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "K520",
    "Device": "seoul",
    "Model": "Lenovo K520"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "K520",
    "Device": "seoul",
    "Model": "Lenovo S680"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "K52t38",
    "Device": "k52_t38",
    "Model": "Lenovo K52t38"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "K52t38",
    "Device": "k52_t38",
    "Model": "Lenovo k52t38"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "K5X",
    "Device": "kunlun",
    "Model": "Lenovo L38041"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "K800",
    "Device": "K800",
    "Model": "Lenovo K800"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "K80M",
    "Device": "K80M",
    "Model": "Lenovo K80M"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "K860",
    "Device": "stuttgart",
    "Model": "Lenovo K860"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "K860i",
    "Device": "K860i",
    "Model": "Lenovo K860i"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "K9",
    "Device": "K9",
    "Model": "Lenovo L38043"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "K900",
    "Device": "K900",
    "Model": "Lenovo K900"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "K900",
    "Device": "K900_ROW",
    "Model": "Lenovo K900_ROW"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "K910",
    "Device": "kiton",
    "Model": "Lenovo K910"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "K910L",
    "Device": "K910L",
    "Model": "Lenovo K910L"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "K910e",
    "Device": "kitone",
    "Model": "LNV-Lenovo K910e"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "K910e",
    "Device": "kitone",
    "Model": "Lenovo K910e"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "K920/VIBE Z2",
    "Device": "kingdom_row",
    "Model": "Lenovo K920"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "K920/VIBE Z2 Pro",
    "Device": "kingdomt",
    "Model": "Lenovo K920"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "L38011",
    "Device": "k5",
    "Model": "Lenovo L38011"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "L38021",
    "Device": "k5_cmcc",
    "Model": "Lenovo L38021"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "L38082",
    "Device": "L38082",
    "Model": "Lenovo L38082"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "LIFETAB E10310",
    "Device": "LIFETAB_E10310",
    "Model": "LIFETAB_E10310"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "LIFETAB E7310",
    "Device": "LIFETAB_E7310",
    "Model": "LIFETAB_E7310"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "LIFETAB E7310",
    "Device": "LIFETAB_E7310",
    "Model": "LIFETAB_E7312"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Legion Tab Y700",
    "Device": "TB320FC",
    "Model": "TB320FC"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Legion Y70",
    "Device": "halo",
    "Model": "Lenovo L71091"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo",
    "Device": "A708t",
    "Model": "Lenovo A708t"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo",
    "Device": "A880",
    "Model": "Lenovo A880"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo",
    "Device": "PB1-770P",
    "Model": "Lenovo PB1-770P"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo A3300",
    "Device": "A3300-GV",
    "Model": "LenovoA3300-GV"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo A3300",
    "Device": "A3300-HV",
    "Model": "LenovoA3300-HV"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo A5",
    "Device": "L18011",
    "Model": "L18011"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo A5",
    "Device": "L18021",
    "Model": "Lenovo L18021"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo A5s",
    "Device": "A5s",
    "Model": "Lenovo L18081"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo A6 Note",
    "Device": "Lenovo_A6_Note",
    "Model": "Lenovo L19041"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo A8",
    "Device": "AK57",
    "Model": "L10041"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo A8",
    "Device": "AK57",
    "Model": "Lenovo L10041"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo Idea Tab / Lenovo Tab K11 Gen 2",
    "Device": "TB336FU",
    "Model": "TB336FU"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo Idea Tab / Lenovo Tab K11 Gen 2",
    "Device": "TB336ZU",
    "Model": "TB336ZU"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo Idea Tab Plus / Lenovo Tab K12",
    "Device": "TB361FU",
    "Model": "TB361FU"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo Idea Tab Pro",
    "Device": "TB373FU",
    "Model": "TB373FU"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo K11",
    "Device": "L38082",
    "Model": "Lenovo L38082"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo K11",
    "Device": "L38083",
    "Model": "Lenovo L38083"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo K12 Note",
    "Device": "guamp",
    "Model": "Lenovo K12 Note"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo K13 Note",
    "Device": "capri",
    "Model": "Lenovo K12 Note"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo K13 Note",
    "Device": "capri",
    "Model": "Lenovo K13 Note"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo K13 Pro",
    "Device": "caprip",
    "Model": "Lenovo K12 Note"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo K13 Pro",
    "Device": "caprip",
    "Model": "Lenovo K13 Pro"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo K8",
    "Device": "brady_f",
    "Model": "Lenovo K"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo K8",
    "Device": "brady_f",
    "Model": "Lenovo K8"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo K8 Note",
    "Device": "manning",
    "Model": "Lenovo K8 Note"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo K8 Note",
    "Device": "manning",
    "Model": "XT1902-3"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo K8 Plus",
    "Device": "marino_f",
    "Model": "Lenovo K"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo K8 Plus",
    "Device": "marino_f",
    "Model": "Lenovo K8 Plus"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo K9",
    "Device": "K9",
    "Model": "Lenovo L38043"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo Legion Tab",
    "Device": "TB320FC",
    "Model": "TB320FC"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo Legion Tab (8.8\\'\\',3)",
    "Device": "TB321FU",
    "Model": "TB321FU"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo Mirage Solo",
    "Device": "vega",
    "Model": "VR-1541F"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo N Series Chromebook",
    "Device": "reks_cheets",
    "Model": "Braswell Chrome OS Device"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo N Series Chromebook",
    "Device": "reks_cheets",
    "Model": "Intel Braswell Chromebook"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo N Series Chromebook",
    "Device": "reks_cheets",
    "Model": "Lenovo Intel Braswell Chromebook"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo N300",
    "Device": "Lindos2",
    "Model": "Lenovo N300"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo PHAB2",
    "Device": "PB2",
    "Model": "Lenovo PB2-650M"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo PHAB2",
    "Device": "PB2",
    "Model": "Lenovo PB2-650N"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo PHAB2",
    "Device": "PB2",
    "Model": "Lenovo PB2-650Y"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo PHAB2 Plus",
    "Device": "PB2-670M",
    "Model": "Lenovo PB2-670M"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo PHAB2 Plus",
    "Device": "PB2-670N",
    "Model": "Lenovo PB2-670N"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo PHAB2 Plus",
    "Device": "PB2-670Y",
    "Model": "Lenovo PB2-670Y"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo PHAB2 Pro",
    "Device": "PB2PRO",
    "Model": "Lenovo PB2-690M"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo PHAB2 Pro",
    "Device": "PB2PRO",
    "Model": "Lenovo PB2-690N"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo PHAB2 Pro",
    "Device": "PB2PRO",
    "Model": "Lenovo PB2-690Y"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo S5 Pro",
    "Device": "sprout",
    "Model": "Lenovo L58041"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo S820",
    "Device": "S820",
    "Model": "Lenovo S820"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo Smart Tab M10 FHD Plus with Amazon Alexa",
    "Device": "X606FA",
    "Model": "Lenovo TB-X606FA"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo Smart Tab M10 FHD Plus with Amazon Alexa",
    "Device": "X606XA",
    "Model": "Lenovo TB-X606XA"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo Smart Tab M8",
    "Device": "8505FS",
    "Model": "Lenovo TB-8505FS"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo Smart Tab M8",
    "Device": "8705F",
    "Model": "Lenovo TB-8705F"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo Smart Tab M8 (3rd Gen)",
    "Device": "TB-8506XS",
    "Model": "Lenovo TB-8506XS"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo Smrat Tab M8",
    "Device": "8505XC",
    "Model": "Lenovo TB-8505XC"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo Smrat Tab M8",
    "Device": "8505XS",
    "Model": "Lenovo TB-8505XS"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo TAB 10",
    "Device": "TB-X103F",
    "Model": "Lenovo TB-X103F"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo TAB 2 A10-30",
    "Device": "TB2-X30F",
    "Model": "Lenovo TB2-X30F"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo TAB 2 A10-30",
    "Device": "TB2-X30F",
    "Model": "Lenovo TB2-X30F_HFT"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo TAB 2 A10-30",
    "Device": "TB2-X30F",
    "Model": "Lenovo TB2-X30F_JLC"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo TAB 2 A10-30",
    "Device": "TB2-X30F",
    "Model": "Lenovo TB2-X30F_SCP"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo TAB 2 A10-30",
    "Device": "TB2-X30F",
    "Model": "Lenovo TB2-X30F_UK"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo TAB 2 A10-30",
    "Device": "TB2-X30F",
    "Model": "Lenovo TB2-X30F_YZA"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo TAB 2 A10-30",
    "Device": "TB2-X30L",
    "Model": "Lenovo TB2-X30L"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo TAB 2 A10-30",
    "Device": "TB2-X30M",
    "Model": "Lenovo TB2-X30M"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo TAB 2 A10-30",
    "Device": "TB2-X30M",
    "Model": "Lenovo TB2-X30M_PRC_YZ_A"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo TAB 7",
    "Device": "TB-7504F",
    "Model": "Lenovo TB-7504F"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo TAB 7",
    "Device": "TB-7504F",
    "Model": "PC-TE507JAW"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo TAB 7",
    "Device": "TB-7504N",
    "Model": "Lenovo TB-7504N"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo TAB 7",
    "Device": "TB-7504X",
    "Model": "Lenovo TB-7504X"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo TAB 7 Essential",
    "Device": "TB-7304F",
    "Model": "Lenovo TB-7304F"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo TAB 8",
    "Device": "TB-8304F",
    "Model": "Lenovo TB-8304F"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo TAB E8",
    "Device": "TB-8304F1",
    "Model": "Lenovo TB-8304F1"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo TAB M10 FHD Rel",
    "Device": "TB-X605FC",
    "Model": "Lenovo TB-X605FC"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo TAB M10 FHD Rel",
    "Device": "TB-X605LC",
    "Model": "Lenovo TB-X605LC"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo TAB3 10 Plus",
    "Device": "TB3-X70F",
    "Model": "Lenovo TB3-X70F"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo TAB3 10 Plus",
    "Device": "TB3-X70L",
    "Model": "Lenovo TB3-X70L"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo TAB3 10 Plus",
    "Device": "TB3-X70N",
    "Model": "Lenovo TB3-X70N"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo TAB3 7",
    "Device": "TB3-730F",
    "Model": "Lenovo TB3-730F"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo TAB3 7",
    "Device": "TB3-730M",
    "Model": "Lenovo TB3-730M"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo TAB3 7",
    "Device": "TB3-730X",
    "Model": "Lenovo TB3-730X"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo TAB3 7 Essential",
    "Device": "TB3-710F",
    "Model": "Lenovo TB3-710F"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo TAB3 7 Essential",
    "Device": "TB3-710I",
    "Model": "Lenovo TB3-710I"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo TAB3 7 Plus",
    "Device": "TB-7703F",
    "Model": "Lenovo TB-7703F"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo TAB3 7 Plus",
    "Device": "TB-7703N",
    "Model": "Lenovo TB-7703N"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo TAB3 7 Plus",
    "Device": "TB-7703X",
    "Model": "Lenovo TB-7703X"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo TAB3 8",
    "Device": "TB3-850F",
    "Model": "Lenovo TB3-850F"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo TAB3 8",
    "Device": "TB3-850M",
    "Model": "Lenovo TB3-850M"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo TAB3 8 Plus",
    "Device": "TB-8703F",
    "Model": "Lenovo TB-8703F"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo TAB3 8 Plus",
    "Device": "TB-8703N",
    "Model": "Lenovo TB-8703N"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo TAB3 8 Plus",
    "Device": "TB-8703R",
    "Model": "Lenovo TB-8703R"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo TAB3 8 Plus",
    "Device": "TB-8703X",
    "Model": "Lenovo TB-8703X"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo TAB3 8 Plus",
    "Device": "TB-8803F",
    "Model": "Lenovo TB-8803F"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo TAB4",
    "Device": "701LV",
    "Model": "701LV"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo TAB4",
    "Device": "702LV",
    "Model": "702LV"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo TAB4 10",
    "Device": "X304F",
    "Model": "Lenovo TB-X304F"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo TAB4 10",
    "Device": "X304F",
    "Model": "TB-X304F"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo TAB4 10",
    "Device": "X304L",
    "Model": "Lenovo TB-X304L"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo TAB4 10",
    "Device": "X304N",
    "Model": "Lenovo TB-X304N"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo TAB4 10",
    "Device": "X304N",
    "Model": "TB-X304N"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo TAB4 10",
    "Device": "X304X",
    "Model": "Lenovo TB-X304X"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo TAB4 10 Plus",
    "Device": "X704F",
    "Model": "Lenovo TB-X704F"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo TAB4 10 Plus",
    "Device": "X704L",
    "Model": "Lenovo TB-X704L"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo TAB4 10 Plus",
    "Device": "X704N",
    "Model": "Lenovo TB-X704N"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo TAB4 10 Plus",
    "Device": "X704N",
    "Model": "TB-X704N"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo TAB4 10 Plus",
    "Device": "X704V",
    "Model": "TB-X704V"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo TAB4 10 REL",
    "Device": "X504F",
    "Model": "Lenovo TB-X504F"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo TAB4 8",
    "Device": "TB-8504F",
    "Model": "Lenovo TB-8504F"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo TAB4 8",
    "Device": "TB-8504F",
    "Model": "TB-8504F"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo TAB4 8",
    "Device": "TB-8504N",
    "Model": "Lenovo TB-8504N"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo TAB4 8",
    "Device": "TB-8504X",
    "Model": "Lenovo TB-8504X"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo TAB4 8 Plus",
    "Device": "TB-8704F",
    "Model": "Lenovo TB-8704F"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo TAB4 8 Plus",
    "Device": "TB-8704N",
    "Model": "Lenovo TB-8704N"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo TAB4 8 Plus",
    "Device": "TB-8704V",
    "Model": "TB-8704V"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo TAB4 8 Plus",
    "Device": "TB-8704X",
    "Model": "Lenovo TB-8704X"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo TAB4 8 REL",
    "Device": "TB-8604F",
    "Model": "Lenovo TB-8604F"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo TAB4 8 REL",
    "Device": "TB-8X04F",
    "Model": "Lenovo TB-8X04F"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo TAB8",
    "Device": "A401LV",
    "Model": "A401LV"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo TB-8304F1",
    "Device": "TB-8304F1",
    "Model": "Lenovo TB-8304F1"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo Tab 7 Essential",
    "Device": "7304I",
    "Model": "Lenovo TB-7304I"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo Tab 7 Essential",
    "Device": "TB-7304I",
    "Model": "Lenovo TB-7304I"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo Tab 7 Essential",
    "Device": "TB-7304N",
    "Model": "Lenovo TB-7304N"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo Tab 7 Essential",
    "Device": "TB-7304X",
    "Model": "Lenovo TB-7304X"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo Tab E10",
    "Device": "X104F",
    "Model": "Lenovo TB-X104F"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo Tab E10",
    "Device": "X104F1",
    "Model": "Lenovo TB-X104F1"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo Tab E10",
    "Device": "X104L",
    "Model": "Lenovo TB-X104L"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo Tab E10",
    "Device": "X104N",
    "Model": "Lenovo TB-X104N"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo Tab E10",
    "Device": "X104X",
    "Model": "Lenovo TB-X104X"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo Tab E7",
    "Device": "TB7104F",
    "Model": "Lenovo TB-7104F"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo Tab E7",
    "Device": "TB7104I",
    "Model": "Lenovo TB-7104I"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo Tab Extreme",
    "Device": "TB570FU",
    "Model": "TB570FU"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo Tab Extreme",
    "Device": "TB570ZU",
    "Model": "TB570ZU"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo Tab K10",
    "Device": "X6C6F",
    "Model": "Lenovo TB-X6C6F"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo Tab K10",
    "Device": "X6C6L",
    "Model": "Lenovo TB-X6C6L"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo Tab K10",
    "Device": "X6C6NBF",
    "Model": "Lenovo TB-X6C6NBF"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo Tab K10",
    "Device": "X6C6NBL",
    "Model": "Lenovo TB-X6C6NBL"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo Tab K10",
    "Device": "X6C6NBX",
    "Model": "Lenovo TB-X6C6NBX"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo Tab K10",
    "Device": "X6C6X",
    "Model": "Lenovo TB-X6C6X"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo Tab K10 Gen 2 / Lenovo Tab",
    "Device": "TB311FU",
    "Model": "TB311FU"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo Tab K10 Gen 2 / Lenovo Tab",
    "Device": "TB311XU",
    "Model": "TB311XU"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo Tab K10 PRC",
    "Device": "TB-X6E6F",
    "Model": "Lenovo TB-X6E6F"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo Tab K10 PRC",
    "Device": "TB-X6E6F",
    "Model": "Lenovo TB-X6E6FC"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo Tab K10 PRC",
    "Device": "X6C6F",
    "Model": "Lenovo TB-X6C6F"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo Tab K10 PRC",
    "Device": "X6C6X",
    "Model": "Lenovo TB-X6C6X"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo Tab K10c",
    "Device": "TB-X6E6N",
    "Model": "Lenovo TB-X6E6N"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo Tab K11",
    "Device": "TB330FUP",
    "Model": "TB330FUP"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo Tab K11",
    "Device": "TB330XUP",
    "Model": "TB330XUP"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo Tab K11 Plus",
    "Device": "TB352FU",
    "Model": "TB352FU"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo Tab K11e",
    "Device": "TB330XUP",
    "Model": "TB330XUP"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo Tab K8",
    "Device": "TB-8506F",
    "Model": "Lenovo TB-8506F"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo Tab K9 / Lenovo Tab One",
    "Device": "TB305FU",
    "Model": "TB305FU"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo Tab K9 / Lenovo Tab One",
    "Device": "TB305XU",
    "Model": "TB305XU"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo Tab M10 (3rd Gen)",
    "Device": "TB328FU",
    "Model": "TB328FU"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo Tab M10 (3rd Gen)",
    "Device": "TB328XU",
    "Model": "TB328XU"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo Tab M10 (FHD)",
    "Device": "X605F",
    "Model": "Lenovo TB-X605F"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo Tab M10 (FHD)",
    "Device": "X605L",
    "Model": "Lenovo TB-X605L"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo Tab M10 (FHD)",
    "Device": "X605M",
    "Model": "Lenovo TB-X605M"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo Tab M10 (HD)",
    "Device": "TB-X505F",
    "Model": "Lenovo TB-X505F"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo Tab M10 (HD)",
    "Device": "TB-X505L",
    "Model": "Lenovo TB-X505L"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo Tab M10 (HD)",
    "Device": "TB-X505N",
    "Model": "Lenovo TB-X505N"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo Tab M10 (HD)",
    "Device": "TB-X505X",
    "Model": "Lenovo TB-X505X"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo Tab M10 5G",
    "Device": "TB360ZU",
    "Model": "TB360ZU"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo Tab M10 FHD Plus",
    "Device": "X606F",
    "Model": "Lenovo TB-X606F"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo Tab M10 FHD Plus",
    "Device": "X606M",
    "Model": "Lenovo TB-X606M"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo Tab M10 FHD Plus",
    "Device": "X606X",
    "Model": "Lenovo TB-X606X"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo Tab M10 FHD Plus",
    "Device": "X616F",
    "Model": "Lenovo TB-X616F"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo Tab M10 FHD Plus",
    "Device": "X616M",
    "Model": "Lenovo TB-X616M"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo Tab M10 FHD Rel",
    "Device": "801LV",
    "Model": "801LV"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo Tab M10 HD (2nd Gen)",
    "Device": "X306F",
    "Model": "Lenovo TB-X306F"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo Tab M10 HD (2nd Gen)",
    "Device": "X306FA",
    "Model": "Lenovo TB-X306FA"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo Tab M10 HD (2nd Gen)",
    "Device": "X306V",
    "Model": "Lenovo TB-X306V"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo Tab M10 HD (2nd Gen)",
    "Device": "X306X",
    "Model": "Lenovo TB-X306X"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo Tab M10 HD (2nd Gen)",
    "Device": "X306XA",
    "Model": "Lenovo TB-X306XA"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo Tab M10 HD (2nd Gen) PRC",
    "Device": "X306FC_PRC",
    "Model": "Lenovo TB-X306FC_PRC"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo Tab M10 HD (2nd Gen) PRC",
    "Device": "X306NC_PRC",
    "Model": "Lenovo TB-X306NC_PRC"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo Tab M10 Plus",
    "Device": "X606V",
    "Model": "Lenovo TB-X606V"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo Tab M10 Plus 3rd Gen",
    "Device": "TB125FU",
    "Model": "Lenovo TB125FU"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo Tab M10 Plus 3rd Gen",
    "Device": "TB128FU",
    "Model": "Lenovo TB128FU"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo Tab M10 Plus 3rd Gen",
    "Device": "TB128XU",
    "Model": "Lenovo TB128XU"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo Tab M10a 5G",
    "Device": "LET02",
    "Model": "LET02"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo Tab M11",
    "Device": "TB330FU",
    "Model": "TB330FU"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo Tab M11",
    "Device": "TB330XU",
    "Model": "TB330XU"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo Tab M11",
    "Device": "TB330XUP",
    "Model": "TB330XUP"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo Tab M7",
    "Device": "7305F",
    "Model": "Lenovo TB-7305F"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo Tab M7",
    "Device": "7305I",
    "Model": "Lenovo TB-7305I"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo Tab M7",
    "Device": "7305X",
    "Model": "Lenovo TB-7305X"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo Tab M7 (3rd Gen)",
    "Device": "7306F",
    "Model": "Lenovo TB-7306F"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo Tab M7 (3rd Gen)",
    "Device": "7306X",
    "Model": "Lenovo TB-7306X"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo Tab M7 HD",
    "Device": "7306V",
    "Model": "Lenovo TB-7306V"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo Tab M8",
    "Device": "8505F",
    "Model": "Lenovo TB-8505F"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo Tab M8",
    "Device": "8505FS",
    "Model": "Lenovo TB-8505FS"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo Tab M8",
    "Device": "8505N",
    "Model": "Lenovo TB-8505N"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo Tab M8",
    "Device": "8505X",
    "Model": "Lenovo TB-8505X"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo Tab M8",
    "Device": "8505XC",
    "Model": "Lenovo TB-8505XC"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo Tab M8",
    "Device": "8705F",
    "Model": "Lenovo TB-8705F"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo Tab M8",
    "Device": "8705N",
    "Model": "Lenovo TB-8705N"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo Tab M8",
    "Device": "8705X",
    "Model": "Lenovo TB-8705X"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo Tab M8 (3rd Gen)",
    "Device": "TB-8506F",
    "Model": "Lenovo TB-8506F"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo Tab M8 (3rd Gen)",
    "Device": "TB-8506FS",
    "Model": "Lenovo TB-8506FS"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo Tab M8 (3rd Gen)",
    "Device": "TB-8506X",
    "Model": "Lenovo TB-8506X"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo Tab M8 (4th Gen) 2024",
    "Device": "TB301FU",
    "Model": "TB301FU"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo Tab M8 (4th Gen) 2024",
    "Device": "TB301XU",
    "Model": "TB301XU"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo Tab M8 (4th gen)",
    "Device": "TB300FU",
    "Model": "TB300FU"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo Tab M8 (4th gen)",
    "Device": "TB300XU",
    "Model": "TB300XU"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo Tab M9",
    "Device": "TB310FU",
    "Model": "TB310FU"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo Tab M9",
    "Device": "TB310XU",
    "Model": "TB310XU"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo Tab P10",
    "Device": "X705F",
    "Model": "Lenovo TB-X705F"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo Tab P10",
    "Device": "X705L",
    "Model": "Lenovo TB-X705L"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo Tab P10",
    "Device": "X705M",
    "Model": "Lenovo TB-X705M"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo Tab P11",
    "Device": "J606F",
    "Model": "Lenovo TB-J606F"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo Tab P11",
    "Device": "J606L",
    "Model": "Lenovo TB-J606L"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo Tab P11 (2nd Gen)",
    "Device": "TB350FU",
    "Model": "TB350FU"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo Tab P11 (2nd Gen)",
    "Device": "TB350XU",
    "Model": "TB350XU"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo Tab P11 5G",
    "Device": "J607Z",
    "Model": "Lenovo TB-J607Z"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo Tab P11 Plus",
    "Device": "TB-J616F",
    "Model": "Lenovo TB-J616F"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo Tab P11 Plus",
    "Device": "TB-J616X",
    "Model": "Lenovo TB-J616X"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo Tab P11 Pro",
    "Device": "J706F",
    "Model": "Lenovo TB-J706F"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo Tab P11 Pro",
    "Device": "J706L",
    "Model": "Lenovo TB-J706L"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo Tab P11 Pro (2nd Gen)",
    "Device": "TB132FU",
    "Model": "TB132FU"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo Tab P12",
    "Device": "TB370FU",
    "Model": "TB370FU"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo Tab P12 Pro",
    "Device": "Q706F",
    "Model": "Lenovo TB-Q706F"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo Tab P12 Pro",
    "Device": "Q706Z",
    "Model": "Lenovo TB-Q706Z"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo Tab Plus",
    "Device": "TB351FU",
    "Model": "TB351FU"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo Tab QT K11",
    "Device": "TB-J6C6F",
    "Model": "Lenovo TB-J6C6F"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo Tab QT K11",
    "Device": "TB-J6C6N",
    "Model": "Lenovo TB-J6C6N"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo Tab QT K11 Pro 5G",
    "Device": "J607Z",
    "Model": "Lenovo TB-J607Z"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo Tab QT K11 Pro WIFI",
    "Device": "J607F",
    "Model": "Lenovo TB-J607F"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo Tab V7",
    "Device": "PB-6505M",
    "Model": "Lenovo PB-6505M"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo Tab V7",
    "Device": "PB-6505MC",
    "Model": "Lenovo PB-6505MC"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo Tab V7",
    "Device": "PB-6505NC",
    "Model": "Lenovo PB-6505NC"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo Tab V7",
    "Device": "PB-6505Y",
    "Model": "Lenovo PB-6505Y"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo Tab m11",
    "Device": "J606F",
    "Model": "Lenovo TB-J606F"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo Tab m11",
    "Device": "J606N",
    "Model": "Lenovo TB-J606N"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo Tab6",
    "Device": "A101LV",
    "Model": "A101LV"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo X2-CU/VIBE X2",
    "Device": "X2-CU",
    "Model": "Lenovo X2-CU"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo YOGA Laptop with Android",
    "Device": "YOGABOOK12",
    "Model": "Lenovo YB-Q501F"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo YOGA Tab 3 Plus",
    "Device": "YT-X703F",
    "Model": "Lenovo YT-X703F"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo YOGA Tab 3 Plus",
    "Device": "YT-X703L",
    "Model": "Lenovo YT-X703L"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo YOGA Tab 3 Plus",
    "Device": "YT-X703X",
    "Model": "Lenovo YT-X703X"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo Yoga Tab",
    "Device": "TB710FU",
    "Model": "TB710FU"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo Yoga Tab 11",
    "Device": "YT-J706F",
    "Model": "Lenovo YT-J706F"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo Yoga Tab 11",
    "Device": "YT-J706X",
    "Model": "Lenovo YT-J706X"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo Yoga Tab Plus",
    "Device": "TB520FU",
    "Model": "TB520FU"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo Z5 Pro",
    "Device": "heart",
    "Model": "Lenovo L78032"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo Z6 Pro 5G",
    "Device": "cream",
    "Model": "Lenovo L79041"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo-9",
    "Device": "zap",
    "Model": "Lenovo L78031"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "LenovoTAB2 A7-30DC",
    "Device": "A7-30HC",
    "Model": "Lenovo TAB 2 A7-30DC"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "LenovoTB-X607Z_EEA",
    "Device": "TB-X607Z",
    "Model": "Lenovo TB-X607Z"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "LenovoTV 40S9;LenovoTV 50S9;AQUOS 40U1;AQUOS 50U1；AQUOS 58U1; AQUOS 60LX765A",
    "Device": "jazz",
    "Model": "AQUOS 58U1"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "LenovoTV 40S9;LenovoTV 50S9;AQUOS 40U1;AQUOS 50U1；AQUOS 58U1; AQUOS 60LX765A",
    "Device": "jazz",
    "Model": "AQUOS 60LX765A"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "LenovoTV 40S9;LenovoTV 50S9;AQUOS 40U1;AQUOS 50U1；AQUOS 58U1; AQUOS 60LX765A",
    "Device": "jazz",
    "Model": "AQUOS 60UE20A"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "LenovoTV 40S9;LenovoTV 50S9;AQUOS 40U1;AQUOS 50U1；AQUOS 58U1; AQUOS 60LX765A",
    "Device": "jazz",
    "Model": "LenovoTV 40S9"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "LenovoTV 40S9;LenovoTV 50S9;AQUOS 40U1;AQUOS 50U1；AQUOS 58U1; AQUOS 60LX765A",
    "Device": "jazz",
    "Model": "LenovoTV 58S9"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "LenovoTV 50S52;AQUOS LCD-50S1A",
    "Device": "bumblebee",
    "Model": "AQUOS 50S1"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "LenovoTV 50S52;AQUOS LCD-50S1A",
    "Device": "bumblebee",
    "Model": "LenovoTV 50S52"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenovo_K320t",
    "Device": "Lenovo_K320t",
    "Model": "Lenovo K320t"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Lenvo S960",
    "Device": "S960_ROW",
    "Model": "Lenovo S960"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Moto E3",
    "Device": "taidos_row",
    "Model": "XT1700"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Moto E3 Power",
    "Device": "taido_row",
    "Model": "XT1706"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Moto TAB",
    "Device": "X704A",
    "Model": "TB-X704A"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Motorola M",
    "Device": "XT1663",
    "Model": "XT1663"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Motorola Moto M",
    "Device": "kungfu_m",
    "Model": "XT1662"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "N300",
    "Device": "Lindos2",
    "Model": "Lenovo N300"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "N308",
    "Device": "SmartAIO",
    "Model": "Lenovo N308"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "NEC  PC-TE507FAW",
    "Device": "TE507FAW",
    "Model": "PC-TE507FAW"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "NEC PC-TS508FAM",
    "Device": "PC-TS508FAM",
    "Model": "NEC PC-TS508FAM"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "NEC PC-TS508FAM",
    "Device": "PC-TS508FAM",
    "Model": "PC-TS508FAM"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "P1",
    "Device": "P1a42",
    "Model": "Lenovo P1a41"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "P1",
    "Device": "P1a42",
    "Model": "Lenovo P1a42"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "P1",
    "Device": "passion",
    "Model": "Lenovo P1c72"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "P1",
    "Device": "passionc5",
    "Model": "Lenovo P1c58"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "P2",
    "Device": "P2a42",
    "Model": "Lenovo P2a42"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "P2",
    "Device": "kuntao",
    "Model": "Lenovo P2c72"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "P70",
    "Device": "P70-A",
    "Model": "Lenovo P70-A"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "P70",
    "Device": "P70-t",
    "Model": "Lenovo P70-t"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "P780",
    "Device": "P780",
    "Model": "Lenovo P780"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "P780",
    "Device": "P780_ROW",
    "Model": "Lenovo P780"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "P780",
    "Device": "P780_ROW",
    "Model": "Lenovo P780_ROW"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "P90",
    "Device": "P90",
    "Model": "Lenovo P90"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "PB1-750M/Lenovo PHAB",
    "Device": "PB1-750M",
    "Model": "Lenovo PB1-750M"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "PB1-770M/Lenovo PHAB Plus",
    "Device": "PB1-770M",
    "Model": "EveryPad3"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "PB1-770M/Lenovo PHAB Plus",
    "Device": "PB1-770M",
    "Model": "Lenovo PB1-770M"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "PB1-770N",
    "Device": "PB1-770N",
    "Model": "Lenovo PB1-770N"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "PB2 plus",
    "Device": "PB2-670M1",
    "Model": "Lenovo PB2-670M1"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "S1",
    "Device": "S1a40",
    "Model": "Lenovo S1a40"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "S1La40",
    "Device": "S1La40",
    "Model": "Lenovo S1La40"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "S2",
    "Device": "S2",
    "Model": "S2"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "S5000",
    "Device": "S5000",
    "Model": "Lenovo S5000-F"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "S5000",
    "Device": "S5000",
    "Model": "Lenovo S5000-H"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "S580",
    "Device": "S580",
    "Model": "Lenovo S580"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "S60",
    "Device": "sisleylr",
    "Model": "Lenovo S60-a"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "S60",
    "Device": "sisleylt",
    "Model": "Lenovo S60-t"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "S60",
    "Device": "sisleylw",
    "Model": "Lenovo S60-w"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "S6000L",
    "Device": "S6000L",
    "Model": "Lenovo S6000L-F"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "S61",
    "Device": "ideatv_S61",
    "Model": "ideatv S61"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "S650",
    "Device": "S650",
    "Model": "Lenovo S650"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "S650_ROW",
    "Device": "S650_ROW",
    "Model": "Lenovo S650"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "S658t",
    "Device": "S658t",
    "Model": "Lenovo S658t"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "S660",
    "Device": "S660",
    "Model": "Lenovo S660"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "S668t",
    "Device": "S668t",
    "Model": "Lenovo S668t"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "S686",
    "Device": "Alaska",
    "Model": "Lenovo S686"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "S720",
    "Device": "S720",
    "Model": "Lenovo S720"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "S750",
    "Device": "S750",
    "Model": "Lenovo S750"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "S810t",
    "Device": "shellt",
    "Model": "Lenovo S810t"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "S820",
    "Device": "S820",
    "Model": "Lenovo S820"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "S820",
    "Device": "S820_AMX_ROW",
    "Model": "Lenovo S820"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "S820",
    "Device": "S820_ROW",
    "Model": "Lenovo S820"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "S820",
    "Device": "S820_ROW",
    "Model": "Lenovo S820_ROW"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "S820e",
    "Device": "applee",
    "Model": "Lenovo S820e"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "S850",
    "Device": "S850",
    "Model": "Lenovo S850"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "S850e",
    "Device": "sichuan",
    "Model": "Lenovo S850e"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "S850t",
    "Device": "S850t",
    "Model": "Lenovo S850t"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "S856",
    "Device": "shellamx",
    "Model": "Lenovo S856"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "S856",
    "Device": "shellr",
    "Model": "Lenovo S856"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "S856",
    "Device": "shellr_s",
    "Model": "Lenovo S856"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "S856",
    "Device": "shellw",
    "Model": "Lenovo S856"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "S858t",
    "Device": "Selected",
    "Model": "Lenovo S858t"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "S860",
    "Device": "S860",
    "Model": "Lenovo S860"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "S860e",
    "Device": "shelle",
    "Model": "Lenovo S860e"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "S868",
    "Device": "S868t",
    "Model": "Lenovo S868t"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "S870e",
    "Device": "S870e",
    "Model": "LNV-Lenovo S870e"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "S870e",
    "Device": "S870e",
    "Model": "Lenovo S870e"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "S898t",
    "Device": "S898t",
    "Model": "Lenovo S898t"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "S898t+",
    "Device": "S898tp",
    "Model": "Lenovo S898t+"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "S90",
    "Device": "sisleye",
    "Model": "Lenovo S90-e"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "S90-A",
    "Device": "sisleyr",
    "Model": "Lenovo S90-A"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "S90-L",
    "Device": "sisleyr_amx",
    "Model": "Lenovo S90-L"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "S90-T",
    "Device": "sisleyt",
    "Model": "Lenovo S90-t"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "S90-U",
    "Device": "sisleyw",
    "Model": "Lenovo S90-u"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "S920",
    "Device": "S920",
    "Model": "Lenovo S920"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "S930",
    "Device": "S930",
    "Model": "Lenovo S930"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "S930_ROW",
    "Device": "S930_ROW",
    "Model": "Lenovo S930"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "S938t",
    "Device": "S938t",
    "Model": "Lenovo S938t"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "S939",
    "Device": "S939",
    "Model": "Lenovo S939"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "S960",
    "Device": "S960",
    "Model": "Lenovo S960"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "S960",
    "Device": "S960_AMX_ROW",
    "Model": "Lenovo S960"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "S968t",
    "Device": "S968t",
    "Model": "Lenovo S968t"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Softbank 501LV",
    "Device": "501LV",
    "Model": "501LV"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "TAB 2 A10",
    "Device": "A10-70F",
    "Model": "Lenovo TAB 2 A10-70F"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "TAB 2 A10",
    "Device": "A10-70L",
    "Model": "Lenovo TAB 2 A10-70L"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "TAB 2 A10",
    "Device": "A10-70LC",
    "Model": "Lenovo TAB 2 A10-70LC"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "TAB 2 A7-10F",
    "Device": "Tab2A7-10F",
    "Model": "Tab2A7-10F"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "TAB 2 A7-20F",
    "Device": "Tab2A7-20F",
    "Model": "Tab2A7-20F"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "TAB 2 A7-30F",
    "Device": "A7-30F",
    "Model": "Lenovo TAB 2 A7-30F"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "TAB 2 A7-30HC",
    "Device": "A7-30HC",
    "Model": "Lenovo 2 A7-30HC"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "TAB 2 A7-30HC",
    "Device": "A7-30HC",
    "Model": "Lenovo TAB 2 A7-30HC"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "TAB 2 A7-30TC",
    "Device": "A7-30TC",
    "Model": "Lenovo 2 A7-30TC"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "TAB 2 A8-50F",
    "Device": "A8-50F",
    "Model": "Lenovo 2 A8-50F"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "TAB 2 A8-50F",
    "Device": "A8-50F",
    "Model": "Lenovo TAB 2 A8-50F"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "TAB A10-80HC",
    "Device": "A10_80HC",
    "Model": "TAB A10-80HC"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "TAB S8-50F",
    "Device": "S8-50F",
    "Model": "Lenovo TAB S8-50F"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "TAB S8-50L",
    "Device": "S8-50L",
    "Model": "Lenovo TAB S8-50L"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "TAB S8-50LC",
    "Device": "S8-50LC",
    "Model": "Lenovo S8-50LC"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "TAB S8-50LC",
    "Device": "S8-50LC",
    "Model": "Lenovo TAB S8-50LC"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "TAB4 10 Plus",
    "Device": "X704Y",
    "Model": "Lenovo TB-X704Y"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "TAB4 8",
    "Device": "TB-8504L",
    "Model": "Lenovo TB-8504L"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "TB3-601LV",
    "Device": "601LV",
    "Model": "601LV"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "TB3-602LV",
    "Device": "602LV",
    "Model": "602LV"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "TB3-X70I",
    "Device": "TB3-X70I",
    "Model": "Lenovo TB3-X70I"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "TB360ZJ",
    "Device": "TB360ZJ",
    "Model": "TB360ZJ"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "TB360ZU",
    "Device": "TB360ZU",
    "Model": "TB360ZU"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "TBD",
    "Device": "kunlun2",
    "Model": "Lenovo L38111"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Tab 7 Essential",
    "Device": "7304F",
    "Model": "Lenovo TB-7304F"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "ThinkPad 11e Chromebook 3rd Gen",
    "Device": "ultima_cheets",
    "Model": "Lenovo ThinkPad 11e 3rd Gen Chromebook"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "ThinkPad 11e Chromebook 3rd Gen",
    "Device": "ultima_cheets",
    "Model": "ThinkPad 11e Chromebook 3rd Gen (Yoga/Clamshell)"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "ThinkVision28",
    "Device": "ThinkVision28",
    "Model": "ThinkVision28"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Thinkpad 11e Chromebook (4th Gen)/Lenovo Thinkpad Yoga 11e Chromebook (4th Gen)",
    "Device": "pyro_cheets",
    "Model": "Lenovo ThinkPad 11e 4th Gen Chromebook"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Thinkpad 11e Chromebook (4th Gen)/Lenovo Thinkpad Yoga 11e Chromebook (4th Gen)",
    "Device": "pyro_cheets",
    "Model": "Lenovo Thinkpad 11e Chromebook (4th Gen)/Lenovo Thinkpad Yoga 11e Chromebook (4th Gen)"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Thinkpad 13 Chromebook",
    "Device": "sentry_cheets",
    "Model": "Lenovo ThinkPad 13"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Thinkpad 13 Chromebook",
    "Device": "sentry_cheets",
    "Model": "Thinkpad 13 Chromebook"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Thinkpad Stack projector",
    "Device": "pj_stack_acc",
    "Model": "M123"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "VIBE K10",
    "Device": "K10a40",
    "Model": "Lenovo K10a40"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "VIBE K6",
    "Device": "K33a48",
    "Model": "Lenovo K33a48"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "VIBE K6",
    "Device": "K33b36",
    "Model": "Lenovo K33b36"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "VIBE K6",
    "Device": "K33b37",
    "Model": "Lenovo K33b37"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "VIBE K6 Note",
    "Device": "K53a48",
    "Model": "Lenovo K53a48"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "VIBE K6 Note",
    "Device": "K53b36",
    "Model": "Lenovo K53b36"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "VIBE K6 Note",
    "Device": "K53b37",
    "Model": "Lenovo K53b37"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "VIBE K6 Power",
    "Device": "K33a42",
    "Model": "Lenovo K33a42"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "VIBE X3 Lite",
    "Device": "A7010a48",
    "Model": "Lenovo A7010a48"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "VIBE X3 Lite",
    "Device": "k5fp",
    "Model": "Lenovo K51c78"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "VIBE X3 Lite",
    "Device": "k5fp_m",
    "Model": "Lenovo K51c78"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "VR-S3",
    "Device": "VRS3",
    "Model": "VR-S3"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "X2",
    "Device": "X2-AP",
    "Model": "Lenovo X2-AP"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "X2",
    "Device": "X2-EU",
    "Model": "Lenovo X2-EU"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "X2 Pro",
    "Device": "s7",
    "Model": "Lenovo X2Pt5"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "X2 Pro",
    "Device": "s7",
    "Model": "VIBE X2Pt5"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "X2-TO/VIBE X2",
    "Device": "X2-TO",
    "Model": "Lenovo X2-TO"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "X2-TR/VIBE X2",
    "Device": "X2-TR",
    "Model": "Lenovo X2-TR"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "X3a40",
    "Device": "x3_row",
    "Model": "Lenovo X3a40"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "X3c50",
    "Device": "X3c50",
    "Model": "Lenovo X3c50"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "X3c70",
    "Device": "X3c70",
    "Model": "Lenovo X3c70"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "XiaoXin Pad",
    "Device": "J606F",
    "Model": "Lenovo TB-J606F"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "XiaoXin Pad",
    "Device": "J606F",
    "Model": "Lenovo TB-J606N"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "XiaoXin Pad",
    "Device": "J606N",
    "Model": "Lenovo TB-J606N"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "XiaoXin Pad Plus",
    "Device": "J607F",
    "Model": "Lenovo TB-J607F"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "XiaoXin Pad Plus",
    "Device": "J607Z",
    "Model": "Lenovo TB-J607Z"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "XiaoXin Pad Pro",
    "Device": "J706F",
    "Model": "Lenovo TB-J706F"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "XiaoXin Pad Pro",
    "Device": "J706N",
    "Model": "Lenovo TB-J706N"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "YOGA A12",
    "Device": "YOGA-A12",
    "Model": "Lenovo YB-Q501F"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "YOGA A12",
    "Device": "YOGA-A12",
    "Model": "Lenovo YB-Q501L"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "YOGA BOOK",
    "Device": "yeti",
    "Model": "Lenovo YB1-X90F"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "YOGA BOOK",
    "Device": "yeti",
    "Model": "Lenovo YB1-X90L"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "YOGA Laptop with Android",
    "Device": "YOGABOOK12",
    "Model": "Lenovo YB-Q501F"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "YOGA Laptop with Android",
    "Device": "YOGABOOK12",
    "Model": "Lenovo YB-Q501L"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "YOGA Pad Pro",
    "Device": "K606F",
    "Model": "Lenovo YT-K606F"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "YOGA Tab 3 10”",
    "Device": "YT3-X50F",
    "Model": "Lenovo YT3-X50F"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "YOGA Tab 3 10”",
    "Device": "YT3-X50L",
    "Model": "Lenovo YT3-X50L"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "YOGA Tab 3 10”",
    "Device": "YT3-X50M",
    "Model": "Lenovo YT3-X50M"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "YOGA Tab 3 8”",
    "Device": "YT3-850F",
    "Model": "Lenovo YT3-850F"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "YOGA Tab 3 8”",
    "Device": "YT3-850L",
    "Model": "Lenovo YT3-850L"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "YOGA Tab 3 8”",
    "Device": "YT3-850M",
    "Model": "Lenovo YT3-850M"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "YOGA Tab 3 PRO 10”",
    "Device": "YT3",
    "Model": "Lenovo YT3-X90F"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "YOGA Tab 3 PRO 10”",
    "Device": "YT3",
    "Model": "Lenovo YT3-X90L"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "YOGA Tab 3 PRO 10”",
    "Device": "YT3",
    "Model": "Lenovo YT3-X90X"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "YOGA Tab 3 PRO 10”",
    "Device": "YT3",
    "Model": "Lenovo YT3-X90Y"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "YOGA Tab 3 PRO 10”",
    "Device": "YT3",
    "Model": "Lenovo YT3-X90Z"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "YOGA Tab Pro AI Yuanqi",
    "Device": "TB520FU",
    "Model": "TB520FU"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "YOGA Tab Pro Max AI Yuanqi",
    "Device": "TB571FU",
    "Model": "TB571FU"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "YOGA Tablet Pro-1050L/Yoga Tablet 2",
    "Device": "YT2",
    "Model": "YOGA Tablet 2-1050L"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "YOGA Tablet Pro-1050LC/Yoga Tablet 2",
    "Device": "YT2",
    "Model": "YOGA Tablet 2-1050LC"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "YOGA Tablet Pro-1380F/Yoga Tablet 2 Pro",
    "Device": "YT2",
    "Model": "YOGA Tablet 2 Pro-1380F"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "YOGA Tablet Pro-1380L/Yoga Tablet 2 Pro",
    "Device": "YT2",
    "Model": "YOGA Tablet 2 Pro-1380L"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "YOGA Tablet Pro-830L/Yoga Tablet 2",
    "Device": "YT2",
    "Model": "YOGA Tablet 2-830L"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "YOGA Tablet Pro-830LC/Yoga Tablet 2",
    "Device": "YT2",
    "Model": "YOGA Tablet 2-830LC"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Yoga Smart Tab",
    "Device": "YT-X705F",
    "Model": "Lenovo YT-X705F"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Yoga Smart Tab",
    "Device": "YT-X705L",
    "Model": "Lenovo YT-X705L"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Yoga Smart Tab",
    "Device": "YT-X705M",
    "Model": "Lenovo YT-X705M"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Yoga Smart Tab",
    "Device": "YT-X705X",
    "Model": "Lenovo YT-X705X"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Yoga Tab 13(ROW)",
    "Device": "K606F",
    "Model": "Lenovo YT-K606F"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "YogaTablet2 -1050F",
    "Device": "YT2",
    "Model": "YOGA Tablet 2-1050F"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "YogaTbalet2-830F",
    "Device": "YT2",
    "Model": "YOGA Tablet 2-830F"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Z2",
    "Device": "z2r",
    "Model": "Lenovo Z2"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Z2",
    "Device": "z2t",
    "Model": "Lenovo Z2"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Z2w",
    "Device": "z2w",
    "Model": "Lenovo Z2w"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Z5",
    "Device": "jd2018",
    "Model": "Lenovo L78011"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Z5",
    "Device": "jd2018_cmcc",
    "Model": "Lenovo L78011"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Z5s",
    "Device": "jd2019",
    "Model": "Lenovo L78071"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Z6",
    "Device": "jd20",
    "Model": "Lenovo L78121"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Z6 Pro",
    "Device": "zippo",
    "Model": "Lenovo L78051"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Z6Pro",
    "Device": "zippo",
    "Model": "Lenovo L78051"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Z90/VIBE Shot",
    "Device": "zoom_fdd",
    "Model": "Lenovo Z90"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Z90/VIBE Shot",
    "Device": "zoom_fdd",
    "Model": "Lenovo Z90-7"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Z90/VIBE Shot",
    "Device": "zoom_tdd",
    "Model": "Lenovo Z90-3"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "Z90a40/VIBE Shot",
    "Device": "zoom_row",
    "Model": "Lenovo Z90a40"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "d-42A",
    "Device": "d-42A",
    "Model": "d-42A"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "d-52C",
    "Device": "d-52C",
    "Model": "d-52C"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "dtab d-51F",
    "Device": "d-51F",
    "Model": "d-51F"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "ideatv S52",
    "Device": "ideatv_S52",
    "Model": "ideatv S52"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "ideatvK82 60LX750A  52LX750A  46LX750A  60LX850A  70LX850A 80LX850A",
    "Device": "ideatv_K82",
    "Model": "ideatv K82"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "moto tab g62",
    "Device": "XT2261-1",
    "Model": "XT2261-1"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "moto tab g62 LTE",
    "Device": "XT2261-2",
    "Model": "XT2261-2"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "xiaoxin pad Pro 12.7",
    "Device": "TB371FC",
    "Model": "TB371FC"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "启天K10 Pro",
    "Device": "TB128FU",
    "Model": "TB128FU"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "启天K10 Pro",
    "Device": "TB128XC",
    "Model": "TB128XC"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "启天K10 Pro",
    "Device": "TB223FC",
    "Model": "Lenovo TB223FC"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "启天K10 Pro",
    "Device": "TB226XC",
    "Model": "Lenovo TB226XC"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "小新 Pad GT",
    "Device": "TB-J616F",
    "Model": "Lenovo TB-J616F"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "小新 Pad GT",
    "Device": "TB-J616N",
    "Model": "Lenovo TB-J616N"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "小新Pad Plus 2023",
    "Device": "TB350FU",
    "Model": "TB350FU"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "小新Pad Pro 12.6",
    "Device": "Q706F",
    "Model": "Lenovo TB-Q706F"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "小新Pad Pro 12.7 (天玑版）",
    "Device": "TB370FU",
    "Model": "TB370FU"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "小新Pad Pro 2021",
    "Device": "J716F",
    "Model": "Lenovo TB-J716F"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "小新Pad Pro 2022",
    "Device": "TB132FU",
    "Model": "TB132FU"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "小新Pad Pro 2022",
    "Device": "olivine",
    "Model": "TB138FC"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "小新学习平板",
    "Device": "TB372FC",
    "Model": "TB372FC"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "小新平板",
    "Device": "TB-8804F",
    "Model": "Lenovo TB-8804F"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "小新平板",
    "Device": "X804F",
    "Model": "Lenovo TB-X804F"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "拯救者平板Y700",
    "Device": "TB321FU",
    "Model": "TB321FU"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "拯救者平板Y900",
    "Device": "TB570FU",
    "Model": "TB570FU"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "拯救者平板Y900",
    "Device": "TB570ZU",
    "Model": "TB570ZU"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "拯救者电竞手机",
    "Device": "moba",
    "Model": "Lenovo L79031"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "拯救者电竞手机2 Pro",
    "Device": "doom",
    "Model": "Lenovo L70081"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "拯救者电竞手机2Pro",
    "Device": "doom",
    "Model": "Lenovo L70081"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "拯救者电竞手机二代",
    "Device": "doom",
    "Model": "Lenovo L70081"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "联想小新平板Pro GT",
    "Device": "TB710FU",
    "Model": "TB710FU"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "联想平板电脑 启天K10",
    "Device": "X6C6NBF",
    "Model": "Lenovo TB-X6C6NBF"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "联想平板电脑 启天K10",
    "Device": "X6C6NBX",
    "Model": "Lenovo TB-X6C6NBX"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "联想平板电脑 启天K10c",
    "Device": "TB330FU",
    "Model": "TB330FU"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "联想平板电脑 启天K10c",
    "Device": "TB330XC",
    "Model": "TB330XC"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "联想平板电脑 启天K11 Gen2",
    "Device": "TB230FC",
    "Model": "TB230FC"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "联想平板电脑 启天K11 Gen2",
    "Device": "TB230XC",
    "Model": "TB230XC"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "联想平板电脑 启天K12",
    "Device": "TB240FC",
    "Model": "TB240FC"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "联想平板电脑 昭阳K11",
    "Device": "TB336FU",
    "Model": "TB336FU"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "联想平板电脑 昭阳K11",
    "Device": "TB336ZU",
    "Model": "TB336ZU"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "联想平板电脑 昭阳K12c",
    "Device": "TB361FU",
    "Model": "TB361FU"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "联想平板电脑 昭阳K9",
    "Device": "TB305XC",
    "Model": "TB305XC"
  },
  {
    "Retail Branding": "Lenovo",
    "Marketing Name": "联想平板电脑K10 5G",
    "Device": "TB-X607Z",
    "Model": "Lenovo TB-X607Z"
  },
  {
    "Retail Branding": "Leotec",
    "Marketing Name": "LEOTEC",
    "Device": "LETAB731",
    "Model": "LETAB731"
  },
  {
    "Retail Branding": "Leotec",
    "Marketing Name": "Letab1020",
    "Device": "Letab1020",
    "Model": "SUPERNOVA Qi32"
  },
  {
    "Retail Branding": "Leotec",
    "Marketing Name": "Qi216",
    "Device": "Qi216",
    "Model": "Qi216"
  },
  {
    "Retail Branding": "Leotec",
    "Marketing Name": "Supernova_i216",
    "Device": "Supernova_i216",
    "Model": "Supernova_i216"
  },
  {
    "Retail Branding": "Leotec",
    "Marketing Name": "mid1016_mk_64",
    "Device": "mid1016_mk_64",
    "Model": "Supernova"
  },
  {
    "Retail Branding": "Lephone",
    "Marketing Name": "Lephone P2",
    "Device": "lephone_P2AF",
    "Model": "lephone P2"
  },
  {
    "Retail Branding": "Lephone",
    "Marketing Name": "Lephone W8",
    "Device": "lephone_W8",
    "Model": "lephone_W8"
  },
  {
    "Retail Branding": "Lephone",
    "Marketing Name": "S104G",
    "Device": "S104G",
    "Model": "S104G"
  },
  {
    "Retail Branding": "Lephone",
    "Marketing Name": "lephone P1",
    "Device": "lephoneP1",
    "Model": "lephoneP1"
  },
  {
    "Retail Branding": "Lephone",
    "Marketing Name": "lephone P1",
    "Device": "lephoneP1O",
    "Model": "lephoneP1"
  },
  {
    "Retail Branding": "Lephone",
    "Marketing Name": "lephone P1",
    "Device": "lephone_P1",
    "Model": "lephone P1"
  },
  {
    "Retail Branding": "Lephone",
    "Marketing Name": "lephone P2",
    "Device": "lephone_P2B",
    "Model": "lephone P2"
  },
  {
    "Retail Branding": "Lephone",
    "Marketing Name": "lephone P5",
    "Device": "lephone_P5",
    "Model": "lephone P5"
  },
  {
    "Retail Branding": "Lephone",
    "Marketing Name": "lephone P5",
    "Device": "lephone_P5B",
    "Model": "lephone P5"
  },
  {
    "Retail Branding": "Lephone",
    "Marketing Name": "lephone W10",
    "Device": "lephone_W10",
    "Model": "lephone_W10"
  },
  {
    "Retail Branding": "Lephone",
    "Marketing Name": "lephone W11",
    "Device": "lephone_W11",
    "Model": "lephone_W11"
  },
  {
    "Retail Branding": "Lephone",
    "Marketing Name": "lephone W15",
    "Device": "lephone_W15",
    "Model": "lephone_W15"
  },
  {
    "Retail Branding": "Lephone",
    "Marketing Name": "lephone W15",
    "Device": "lephone_W15a",
    "Model": "lephone_W15"
  },
  {
    "Retail Branding": "Lephone",
    "Marketing Name": "lephone W21",
    "Device": "lephone_W21",
    "Model": "lephone_W21"
  },
  {
    "Retail Branding": "Lephone",
    "Marketing Name": "lephone W7",
    "Device": "lephone_W7",
    "Model": "lephone_W7"
  },
  {
    "Retail Branding": "Lephone",
    "Marketing Name": "lephone W7",
    "Device": "lephone_W7s",
    "Model": "lephone_W7"
  },
  {
    "Retail Branding": "Lephone",
    "Marketing Name": "lephone W7+",
    "Device": "lephone_W7_plus",
    "Model": "lephone_W7_plus"
  },
  {
    "Retail Branding": "Lephone",
    "Marketing Name": "lephone W7R",
    "Device": "lephone_W7R",
    "Model": "lephone_W7R"
  },
  {
    "Retail Branding": "Lephone",
    "Marketing Name": "lephone_P2Plus",
    "Device": "lephone_P2Plus",
    "Model": "lephone P2Plus"
  },
  {
    "Retail Branding": "Lephone",
    "Marketing Name": "lephone_W10b",
    "Device": "lephone_W10b",
    "Model": "lephone_W10"
  },
  {
    "Retail Branding": "Lesia",
    "Marketing Name": "BRIGHT_20",
    "Device": "BRIGHT_20",
    "Model": "BRIGHT 20"
  },
  {
    "Retail Branding": "Lesia",
    "Marketing Name": "BRIGHT_3",
    "Device": "BRIGHT_3",
    "Model": "BRIGHT 3"
  },
  {
    "Retail Branding": "Lesia",
    "Marketing Name": "BRIGHT_6",
    "Device": "BRIGHT_6",
    "Model": "BRIGHT 6"
  },
  {
    "Retail Branding": "Lesia",
    "Marketing Name": "C2",
    "Device": "C2",
    "Model": "C2"
  },
  {
    "Retail Branding": "Lesia",
    "Marketing Name": "C5",
    "Device": "C5",
    "Model": "C5"
  },
  {
    "Retail Branding": "Lesia",
    "Marketing Name": "FUTURE 10",
    "Device": "FUTURE_10",
    "Model": "FUTURE 10"
  },
  {
    "Retail Branding": "Lesia",
    "Marketing Name": "HOT_30",
    "Device": "HOT_30",
    "Model": "HOT_30"
  },
  {
    "Retail Branding": "Lesia",
    "Marketing Name": "K2",
    "Device": "K2",
    "Model": "K2"
  },
  {
    "Retail Branding": "Lesia",
    "Marketing Name": "K2s",
    "Device": "K2s",
    "Model": "K2"
  },
  {
    "Retail Branding": "Lesia",
    "Marketing Name": "K5",
    "Device": "K5",
    "Model": "K5"
  },
  {
    "Retail Branding": "Lesia",
    "Marketing Name": "K6",
    "Device": "K6",
    "Model": "K6"
  },
  {
    "Retail Branding": "Lesia",
    "Marketing Name": "K7",
    "Device": "K7",
    "Model": "K7"
  },
  {
    "Retail Branding": "Lesia",
    "Marketing Name": "NEO_9",
    "Device": "NEO_9",
    "Model": "NEO_9"
  },
  {
    "Retail Branding": "Lesia",
    "Marketing Name": "P40",
    "Device": "P40",
    "Model": "P40"
  },
  {
    "Retail Branding": "Lesia",
    "Marketing Name": "Pad 12",
    "Device": "Pad_12",
    "Model": "Pad 12"
  },
  {
    "Retail Branding": "Lesia",
    "Marketing Name": "Pad_11",
    "Device": "Pad_11",
    "Model": "Pad_11"
  },
  {
    "Retail Branding": "Lesia",
    "Marketing Name": "SMART_7",
    "Device": "SMART_7",
    "Model": "SMART_7"
  },
  {
    "Retail Branding": "Lexia Mobile",
    "Marketing Name": "S1",
    "Device": "S1",
    "Model": "S1"
  },
  {
    "Retail Branding": "Lexia Mobile",
    "Marketing Name": "S2",
    "Device": "S2",
    "Model": "S2"
  },
  {
    "Retail Branding": "Lexia Mobile",
    "Marketing Name": "S3",
    "Device": "S3",
    "Model": "S3"
  },
  {
    "Retail Branding": "Lexibook",
    "Marketing Name": "Fluo",
    "Device": "MFC145FR1",
    "Model": "MFC145FR1"
  },
  {
    "Retail Branding": "Lexibook",
    "Marketing Name": "Fluo XL",
    "Device": "MFC191FR2",
    "Model": "MFC191FR2"
  },
  {
    "Retail Branding": "Lexibook",
    "Marketing Name": "Fluo XL Premium Edition",
    "Device": "MFC510FR1",
    "Model": "MFC510FR1"
  },
  {
    "Retail Branding": "Lexibook",
    "Marketing Name": "LT10",
    "Device": "LT10",
    "Model": "LT10"
  },
  {
    "Retail Branding": "Lexibook",
    "Marketing Name": "LT10EN_09",
    "Device": "LT10EN_09",
    "Model": "LT10EN_09"
  },
  {
    "Retail Branding": "Lexibook",
    "Marketing Name": "LT10_01_EEA",
    "Device": "LT10_01_EEA",
    "Model": "LT10_01_EEA"
  },
  {
    "Retail Branding": "Lexibook",
    "Marketing Name": "LT10_10",
    "Device": "LT10_10",
    "Model": "LT10_10"
  },
  {
    "Retail Branding": "Lexibook",
    "Marketing Name": "LexiTab 10",
    "Device": "MFC512",
    "Model": "MFC512FR"
  },
  {
    "Retail Branding": "Lexibook",
    "Marketing Name": "LexiTab 10\\'\\'",
    "Device": "mfc511",
    "Model": "MFC511DE"
  },
  {
    "Retail Branding": "Lexibook",
    "Marketing Name": "LexiTab 10\\'\\'",
    "Device": "mfc511",
    "Model": "MFC511EN"
  },
  {
    "Retail Branding": "Lexibook",
    "Marketing Name": "LexiTab 10\\'\\'",
    "Device": "mfc511",
    "Model": "MFC511FR"
  },
  {
    "Retail Branding": "Lexibook",
    "Marketing Name": "LexiTab 7",
    "Device": "MFC147",
    "Model": "MFC147FR"
  },
  {
    "Retail Branding": "Lexibook",
    "Marketing Name": "LexiTab 7\\'\\'",
    "Device": "MFC146DE",
    "Model": "MFC146DE"
  },
  {
    "Retail Branding": "Lexibook",
    "Marketing Name": "LexiTab 7\\'\\'",
    "Device": "MFC146EN",
    "Model": "MFC146EN"
  },
  {
    "Retail Branding": "Lexibook",
    "Marketing Name": "LexiTab 7\\'\\'",
    "Device": "MFC146ES",
    "Model": "MFC146ES"
  },
  {
    "Retail Branding": "Lexibook",
    "Marketing Name": "LexiTab 7\\'\\'",
    "Device": "MFC146FR",
    "Model": "MFC146FR"
  },
  {
    "Retail Branding": "Lexibook",
    "Marketing Name": "LexiTab® 10",
    "Device": "MFC513FR",
    "Model": "MFC513FR"
  },
  {
    "Retail Branding": "Lexibook",
    "Marketing Name": "LexiTab® 7",
    "Device": "MFC149FR",
    "Model": "MFC149FR"
  },
  {
    "Retail Branding": "Lexibook",
    "Marketing Name": "LexiTab® 7",
    "Device": "MFC148FR",
    "Model": "MFC148FR"
  },
  {
    "Retail Branding": "Lexibook",
    "Marketing Name": "LexiTab® Deluxe",
    "Device": "MFC514",
    "Model": "MFC514"
  },
  {
    "Retail Branding": "Lexibook",
    "Marketing Name": "LexiTab® Deluxe",
    "Device": "MFC514FR",
    "Model": "MFC514FR"
  },
  {
    "Retail Branding": "Lexibook",
    "Marketing Name": "LexiTab® Master",
    "Device": "MFC149",
    "Model": "MFC149"
  },
  {
    "Retail Branding": "Lexibook",
    "Marketing Name": "MFC149",
    "Device": "MFC149",
    "Model": "MFC149"
  },
  {
    "Retail Branding": "Lexibook",
    "Marketing Name": "MFC191",
    "Device": "MFC191",
    "Model": "S952"
  },
  {
    "Retail Branding": "Lexibook",
    "Marketing Name": "Playdroid",
    "Device": "lbox500",
    "Model": "LBOX500"
  },
  {
    "Retail Branding": "Lexibook",
    "Marketing Name": "TL70",
    "Device": "TL70",
    "Model": "TL70"
  },
  {
    "Retail Branding": "Lexibook",
    "Marketing Name": "TL70_04_EEA",
    "Device": "TL70_04_EEA",
    "Model": "TL70_04_EEA"
  },
  {
    "Retail Branding": "Lexibook",
    "Marketing Name": "TLN10FR",
    "Device": "TLN10FR",
    "Model": "TLN10FR"
  },
  {
    "Retail Branding": "Lexibook",
    "Marketing Name": "Tablet Phone",
    "Device": "MFS100",
    "Model": "MFS100"
  },
  {
    "Retail Branding": "Lgcns",
    "Marketing Name": "LPT_200AR",
    "Device": "LPT_200AR",
    "Model": "LPT_200AR"
  },
  {
    "Retail Branding": "Lgcns",
    "Marketing Name": "LPT_201AR",
    "Device": "LPT_201AR",
    "Model": "LPT_201AR"
  },
  {
    "Retail Branding": "LiGHTLIFE",
    "Marketing Name": "T10",
    "Device": "T10",
    "Model": "T10"
  },
  {
    "Retail Branding": "LiGHTLIFE",
    "Marketing Name": "T8",
    "Device": "T8",
    "Model": "T8"
  },
  {
    "Retail Branding": "LiGHTLIFE",
    "Marketing Name": "TL10P",
    "Device": "TL10P",
    "Model": "LiGHTLIFE TL10P"
  },
  {
    "Retail Branding": "LiGHTLIFE",
    "Marketing Name": "TL11",
    "Device": "TL11",
    "Model": "LiGHTLIFE TL11"
  },
  {
    "Retail Branding": "Libre",
    "Marketing Name": "W101",
    "Device": "W101",
    "Model": "W101"
  },
  {
    "Retail Branding": "Libre",
    "Marketing Name": "W808",
    "Device": "W808",
    "Model": "W808"
  },
  {
    "Retail Branding": "Life Stick",
    "Marketing Name": "LifeStick",
    "Device": "ts201",
    "Model": "LifeStick"
  },
  {
    "Retail Branding": "Life mobile",
    "Marketing Name": "LM1",
    "Device": "LM1",
    "Model": "LM1"
  },
  {
    "Retail Branding": "LifeWatch",
    "Marketing Name": "V , FGL-00004",
    "Device": "hp6577_cts",
    "Model": "LifeWatch V"
  },
  {
    "Retail Branding": "Lightwave",
    "Marketing Name": "africa",
    "Device": "sepolia",
    "Model": "LIGHTWAVE Google 4K TV"
  },
  {
    "Retail Branding": "Lilus",
    "Marketing Name": "TAL-750",
    "Device": "TAL-750",
    "Model": "TAL-750"
  },
  {
    "Retail Branding": "Lin",
    "Marketing Name": "LIN",
    "Device": "LINTAB_TB701",
    "Model": "LINTAB_TB701"
  },
  {
    "Retail Branding": "Lincor",
    "Marketing Name": "MWTerm311",
    "Device": "MWTerm311",
    "Model": "MWTerm311"
  },
  {
    "Retail Branding": "Lincplus",
    "Marketing Name": "M11_EU",
    "Device": "M11_US",
    "Model": "M11_EU"
  },
  {
    "Retail Branding": "Lincplus",
    "Marketing Name": "M8_EU",
    "Device": "M8_US",
    "Model": "M8_EU"
  },
  {
    "Retail Branding": "Lincplus",
    "Marketing Name": "T3_US",
    "Device": "T3_US",
    "Model": "T3_US"
  },
  {
    "Retail Branding": "Lincplus",
    "Marketing Name": "T4",
    "Device": "T4",
    "Model": "T4"
  },
  {
    "Retail Branding": "Lincplus",
    "Marketing Name": "T4_EU",
    "Device": "T4_EU",
    "Model": "T4_EU"
  },
  {
    "Retail Branding": "LinkNet",
    "Marketing Name": "One Stream+",
    "Device": "vsb3918_apac",
    "Model": "OneStream-VSB-001"
  },
  {
    "Retail Branding": "LinkNet",
    "Marketing Name": "SH960C-LN",
    "Device": "SH960C-LN",
    "Model": "SH960C-LN"
  },
  {
    "Retail Branding": "LinkNet",
    "Marketing Name": "ST950I-LN",
    "Device": "ST950I-LN",
    "Model": "ST950I-LN"
  },
  {
    "Retail Branding": "LinkNet",
    "Marketing Name": "Smart Box HD",
    "Device": "SH940C-LN",
    "Model": "SH940C-LN"
  },
  {
    "Retail Branding": "LinkNet",
    "Marketing Name": "X1 Prime",
    "Device": "DCN88_72604_LN",
    "Model": "DCN88_72604_LN"
  },
  {
    "Retail Branding": "LinkNet",
    "Marketing Name": "X1-Prime-R2",
    "Device": "DTC2160",
    "Model": "X1-Prime-R2"
  },
  {
    "Retail Branding": "LinkNet",
    "Marketing Name": "X1-Prime-c",
    "Device": "DTC2140",
    "Model": "X1-Prime-c"
  },
  {
    "Retail Branding": "LinkNet",
    "Marketing Name": "X1-Prime-c",
    "Device": "DTC9565",
    "Model": "X1-Prime-c"
  },
  {
    "Retail Branding": "LinkNet",
    "Marketing Name": "X1-Prime-i",
    "Device": "DTP2162",
    "Model": "X1-Prime-i"
  },
  {
    "Retail Branding": "LinkNet",
    "Marketing Name": "X1-Prime-i",
    "Device": "DTP9718",
    "Model": "X1-Prime-i"
  },
  {
    "Retail Branding": "LinkNet",
    "Marketing Name": "X1Lite",
    "Device": "DMTS21LC",
    "Model": "X1Lite"
  },
  {
    "Retail Branding": "Linsar",
    "Marketing Name": "Linsar",
    "Device": "bangbae",
    "Model": "Linsar 4K Android TV"
  },
  {
    "Retail Branding": "Linsar",
    "Marketing Name": "Linsar",
    "Device": "komagome",
    "Model": "Linsar 2K Android TV"
  },
  {
    "Retail Branding": "Linsar",
    "Marketing Name": "Linsar",
    "Device": "sadang",
    "Model": "Linsar UK 4K Android TV"
  },
  {
    "Retail Branding": "Linsar",
    "Marketing Name": "Linsar android TV",
    "Device": "hanyang",
    "Model": "Linsar Android TV"
  },
  {
    "Retail Branding": "Linsar",
    "Marketing Name": "Smart TV",
    "Device": "ueno",
    "Model": "Linsar 2K Android TV"
  },
  {
    "Retail Branding": "Linsay",
    "Marketing Name": "F10XIPG",
    "Device": "F10XIPG",
    "Model": "F10XIPG"
  },
  {
    "Retail Branding": "Linsay",
    "Marketing Name": "F10XIPGPLUS",
    "Device": "F10XIPGPLUS",
    "Model": "F10XIPGPLUS"
  },
  {
    "Retail Branding": "Linsay",
    "Marketing Name": "F10XIPS",
    "Device": "F10XIPS",
    "Model": "F10XIPS"
  },
  {
    "Retail Branding": "Linsay",
    "Marketing Name": "F10XIPS",
    "Device": "F10XIPS",
    "Model": "LINSAY F10XIPS"
  },
  {
    "Retail Branding": "Linsay",
    "Marketing Name": "F10XIPSQ",
    "Device": "F10XIPSQ",
    "Model": "F10XIPSQ"
  },
  {
    "Retail Branding": "Linsay",
    "Marketing Name": "F7HD4CORE",
    "Device": "F7HD4CORE",
    "Model": "F7HD4CORE"
  },
  {
    "Retail Branding": "Linsay",
    "Marketing Name": "F7UHD",
    "Device": "F7UHD",
    "Model": "F7UHD"
  },
  {
    "Retail Branding": "Linsay",
    "Marketing Name": "F_10XHD",
    "Device": "F_10XHD",
    "Model": "F_10XHD"
  },
  {
    "Retail Branding": "Linsay",
    "Marketing Name": "F_10XIPS",
    "Device": "F_10XIPS",
    "Model": "F_10XIPS"
  },
  {
    "Retail Branding": "Linsay",
    "Marketing Name": "F_7HD4CORE",
    "Device": "F_7HD4CORE",
    "Model": "F_7HD4CORE"
  },
  {
    "Retail Branding": "Linsay",
    "Marketing Name": "F_7UHD",
    "Device": "F_7UHD",
    "Model": "F_7UHD"
  },
  {
    "Retail Branding": "Linsay",
    "Marketing Name": "LINSAY_F10XHD",
    "Device": "LINSAY_F10XHD",
    "Model": "LINSAY_F10XHD"
  },
  {
    "Retail Branding": "Linsay",
    "Marketing Name": "LINSAY_F10XIPS",
    "Device": "LINSAY_F10XIPS",
    "Model": "LINSAY_F10XIPS"
  },
  {
    "Retail Branding": "Linsay",
    "Marketing Name": "LINSAY_F7HD4CORE",
    "Device": "LINSAY-F7HD4CORE",
    "Model": "LINSAY F7HD4CORE"
  },
  {
    "Retail Branding": "Linxdot",
    "Marketing Name": "HM-1005",
    "Device": "HM-1005",
    "Model": "HM-1005"
  },
  {
    "Retail Branding": "Lisheng",
    "Marketing Name": "LS-Q878",
    "Device": "LS-Q878",
    "Model": "LS-Q878"
  },
  {
    "Retail Branding": "Listo",
    "Marketing Name": "WEBPAD1002",
    "Device": "Listo",
    "Model": "WEBPAD1002"
  },
  {
    "Retail Branding": "LitByLeia",
    "Marketing Name": "LUME",
    "Device": "LPD-10W",
    "Model": "LPD-10W"
  },
  {
    "Retail Branding": "LitByLeia",
    "Marketing Name": "LUME",
    "Device": "LPD-11W",
    "Model": "LPD-11W"
  },
  {
    "Retail Branding": "LiteTEL",
    "Marketing Name": "X15",
    "Device": "X15",
    "Model": "X15"
  },
  {
    "Retail Branding": "LiteTEL",
    "Marketing Name": "X20",
    "Device": "X20",
    "Model": "X20"
  },
  {
    "Retail Branding": "LiteTEL",
    "Marketing Name": "X30",
    "Device": "X30",
    "Model": "X30"
  },
  {
    "Retail Branding": "Logic Instrument",
    "Marketing Name": "FieldBook E1",
    "Device": "FieldBook_E1",
    "Model": "FieldBook_E1"
  },
  {
    "Retail Branding": "Logic Instrument",
    "Marketing Name": "Fieldbook F1",
    "Device": "lifbf1",
    "Model": "Logic Instrument Fieldbook F1"
  },
  {
    "Retail Branding": "Logic Instrument",
    "Marketing Name": "Fieldbook F53",
    "Device": "lifbf53",
    "Model": "Logic Instrument Fieldbook F53"
  },
  {
    "Retail Branding": "Logic Instrument",
    "Marketing Name": "Fieldbook K80",
    "Device": "lifbk80",
    "Model": "Logic Instrument Fieldbook K80"
  },
  {
    "Retail Branding": "Logic Instrument",
    "Marketing Name": "Logic Instrument Fieldbook 57",
    "Device": "lifb57",
    "Model": "Logic Instrument Fieldbook F57"
  },
  {
    "Retail Branding": "Logic Instrument",
    "Marketing Name": "Logic Instrument Fieldbook KS80",
    "Device": "lifbks80",
    "Model": "Logic Instrument Fieldbook KS80"
  },
  {
    "Retail Branding": "Logic Instrument",
    "Marketing Name": "Logic Instrument Fieldbook N101",
    "Device": "lifbn101",
    "Model": "Logic Instrument Fieldbook N101"
  },
  {
    "Retail Branding": "Logic Instrument",
    "Marketing Name": "Logic Instrument Fieldbook N101G2",
    "Device": "lifbn101g2",
    "Model": "Logic Instrument Fieldbook N101G2"
  },
  {
    "Retail Branding": "Logic Instrument",
    "Marketing Name": "Logic Instrument Fieldbook N80",
    "Device": "lifbn80",
    "Model": "Logic Instrument Fieldbook N80"
  },
  {
    "Retail Branding": "Logic Mobility",
    "Marketing Name": "G1L",
    "Device": "LOGIC_G1L",
    "Model": "G1L"
  },
  {
    "Retail Branding": "Logic Mobility",
    "Marketing Name": "L4T",
    "Device": "L4T",
    "Model": "L4T"
  },
  {
    "Retail Branding": "Logic Mobility",
    "Marketing Name": "L50",
    "Device": "LOGIC_L50",
    "Model": "LOGIC L50"
  },
  {
    "Retail Branding": "Logic Mobility",
    "Marketing Name": "L50 Plus",
    "Device": "L50_PLUS",
    "Model": "L50 PLUS"
  },
  {
    "Retail Branding": "Logic Mobility",
    "Marketing Name": "L55A",
    "Device": "L55A",
    "Model": "L55A"
  },
  {
    "Retail Branding": "Logic Mobility",
    "Marketing Name": "L55B",
    "Device": "L55B",
    "Model": "L55B"
  },
  {
    "Retail Branding": "Logic Mobility",
    "Marketing Name": "L55S",
    "Device": "L55S",
    "Model": "LOGIC_L55S"
  },
  {
    "Retail Branding": "Logic Mobility",
    "Marketing Name": "L55SCLARO",
    "Device": "L55SCLARO",
    "Model": "L55SCLARO"
  },
  {
    "Retail Branding": "Logic Mobility",
    "Marketing Name": "L57",
    "Device": "Logic_L57",
    "Model": "Logic L57"
  },
  {
    "Retail Branding": "Logic Mobility",
    "Marketing Name": "L5G",
    "Device": "L5G",
    "Model": "L5G"
  },
  {
    "Retail Branding": "Logic Mobility",
    "Marketing Name": "L63A",
    "Device": "L63A",
    "Model": "LOGIC L63"
  },
  {
    "Retail Branding": "Logic Mobility",
    "Marketing Name": "L66",
    "Device": "L66",
    "Model": "L66"
  },
  {
    "Retail Branding": "Logic Mobility",
    "Marketing Name": "L66 LITE",
    "Device": "L66_LITE",
    "Model": "L66 LITE"
  },
  {
    "Retail Branding": "Logic Mobility",
    "Marketing Name": "L66 PRO",
    "Device": "L66_PRO",
    "Model": "LOGIC L66 PRO"
  },
  {
    "Retail Branding": "Logic Mobility",
    "Marketing Name": "L66M",
    "Device": "LOGIC_L66M",
    "Model": "L66M"
  },
  {
    "Retail Branding": "Logic Mobility",
    "Marketing Name": "L68",
    "Device": "LOGIC_L68",
    "Model": "LOGIC L68"
  },
  {
    "Retail Branding": "Logic Mobility",
    "Marketing Name": "L68 Ultra",
    "Device": "L68_Ultra",
    "Model": "L68_Ultra"
  },
  {
    "Retail Branding": "Logic Mobility",
    "Marketing Name": "LOGIC  L55V  PLUS",
    "Device": "LOGIC_L55V_PLUS",
    "Model": "LOGIC L55V PLUS"
  },
  {
    "Retail Branding": "Logic Mobility",
    "Marketing Name": "LOGIC L44",
    "Device": "LOGIC_L5M",
    "Model": "LOGIC L44"
  },
  {
    "Retail Branding": "Logic Mobility",
    "Marketing Name": "LOGIC L50T",
    "Device": "LOGIC_L50T",
    "Model": "LOGIC L50T"
  },
  {
    "Retail Branding": "Logic Mobility",
    "Marketing Name": "LOGIC L61",
    "Device": "LOGIC_L61",
    "Model": "LOGIC L61"
  },
  {
    "Retail Branding": "Logic Mobility",
    "Marketing Name": "LOGIC L63",
    "Device": "LOGIC_L63",
    "Model": "LOGIC L63"
  },
  {
    "Retail Branding": "Logic Mobility",
    "Marketing Name": "LOGIC L63M",
    "Device": "LOGIC_L63M",
    "Model": "L63M"
  },
  {
    "Retail Branding": "Logic Mobility",
    "Marketing Name": "LOGIC L65 LITE",
    "Device": "LOGIC_L65_LITE",
    "Model": "LOGIC L65 LITE"
  },
  {
    "Retail Branding": "Logic Mobility",
    "Marketing Name": "LOGIC L66M",
    "Device": "LOGIC_L66M",
    "Model": "L66M"
  },
  {
    "Retail Branding": "Logic Mobility",
    "Marketing Name": "LOGIC MV01",
    "Device": "LOGIC_MV01",
    "Model": "LOGIC MV01"
  },
  {
    "Retail Branding": "Logic Mobility",
    "Marketing Name": "LOGIC MV02",
    "Device": "LOGIC_MV02",
    "Model": "LOGIC MV02"
  },
  {
    "Retail Branding": "Logic Mobility",
    "Marketing Name": "LOGIC_L4T_1",
    "Device": "LOGIC_L4T",
    "Model": "LOGIC L4T"
  },
  {
    "Retail Branding": "Logic Mobility",
    "Marketing Name": "LOGIC_L55S",
    "Device": "LOGIC_L55S",
    "Model": "LOGIC L55S"
  },
  {
    "Retail Branding": "Logic Mobility",
    "Marketing Name": "LOGIC_L5D",
    "Device": "LOGIC_L5D",
    "Model": "LOGIC_L5D"
  },
  {
    "Retail Branding": "Logic Mobility",
    "Marketing Name": "LOGIC_L5M",
    "Device": "LOGIC_L5M",
    "Model": "LOGIC_L5M"
  },
  {
    "Retail Branding": "Logic Mobility",
    "Marketing Name": "LOGIC_L60",
    "Device": "LOGIC_L60",
    "Model": "LOGIC L60"
  },
  {
    "Retail Branding": "Logic Mobility",
    "Marketing Name": "LOGIC_L65",
    "Device": "LOGIC_L65",
    "Model": "LOGIC L65"
  },
  {
    "Retail Branding": "Logic Mobility",
    "Marketing Name": "LOGIC_L66M",
    "Device": "LOGIC_L66M",
    "Model": "L66M"
  },
  {
    "Retail Branding": "Logic Mobility",
    "Marketing Name": "LOGIC_L66M",
    "Device": "LOGIC_L66M",
    "Model": "LOGIC L66M"
  },
  {
    "Retail Branding": "Logic Mobility",
    "Marketing Name": "LOGIC_T10L_PLUS",
    "Device": "LOGIC_T10L_PLUS",
    "Model": "LOGIC_T10L_PLUS"
  },
  {
    "Retail Branding": "Logic Mobility",
    "Marketing Name": "LOGIC_T10M",
    "Device": "LOGIC_T10M",
    "Model": "LOGIC T10M"
  },
  {
    "Retail Branding": "Logic Mobility",
    "Marketing Name": "LOGIC_X40",
    "Device": "LOGIC_X40",
    "Model": "X40"
  },
  {
    "Retail Branding": "Logic Mobility",
    "Marketing Name": "LOGIC_X60G",
    "Device": "LOGIC_X60G",
    "Model": "LOGIC_X60G"
  },
  {
    "Retail Branding": "Logic Mobility",
    "Marketing Name": "T10B",
    "Device": "T10B",
    "Model": "T10B"
  },
  {
    "Retail Branding": "Logic Mobility",
    "Marketing Name": "T10L",
    "Device": "T10L",
    "Model": "T10L"
  },
  {
    "Retail Branding": "Logic Mobility",
    "Marketing Name": "T10W",
    "Device": "T10W",
    "Model": "LOGIC T10W"
  },
  {
    "Retail Branding": "Logic Mobility",
    "Marketing Name": "T3G",
    "Device": "T3G",
    "Model": "T3G"
  },
  {
    "Retail Branding": "Logic Mobility",
    "Marketing Name": "T3GPlus",
    "Device": "T3GPlus",
    "Model": "T3G"
  },
  {
    "Retail Branding": "Logic Mobility",
    "Marketing Name": "T4G",
    "Device": "T4G",
    "Model": "T4G"
  },
  {
    "Retail Branding": "Logic Mobility",
    "Marketing Name": "T7_plus",
    "Device": "T7_plus",
    "Model": "T7_plus"
  },
  {
    "Retail Branding": "Logic Mobility",
    "Marketing Name": "X4 Plus",
    "Device": "X4",
    "Model": "Logic X4 Plus"
  },
  {
    "Retail Branding": "Logic Mobility",
    "Marketing Name": "X50",
    "Device": "LOGIC_X50",
    "Model": "LOGIC X50"
  },
  {
    "Retail Branding": "Logic Mobility",
    "Marketing Name": "X50A",
    "Device": "X50A",
    "Model": "X50A"
  },
  {
    "Retail Branding": "Logic Mobility",
    "Marketing Name": "X55G",
    "Device": "X55G",
    "Model": "X55G"
  },
  {
    "Retail Branding": "Logic Mobility",
    "Marketing Name": "X55_PLUS_B125",
    "Device": "X55_PLUS",
    "Model": "X55_PLUS"
  },
  {
    "Retail Branding": "Logic Mobility",
    "Marketing Name": "X55_PLUS_B18",
    "Device": "X55_PLUS",
    "Model": "X55_PLUS"
  },
  {
    "Retail Branding": "Logic Mobility",
    "Marketing Name": "X57A",
    "Device": "LOGIC_X57A",
    "Model": "LOGIC X57A"
  },
  {
    "Retail Branding": "Logic Mobility",
    "Marketing Name": "X5A",
    "Device": "LOGIC_X5A",
    "Model": "LOGIC X5A"
  },
  {
    "Retail Branding": "Logic Mobility",
    "Marketing Name": "l409",
    "Device": "LOGIC_L40",
    "Model": "LOGIC L40"
  },
  {
    "Retail Branding": "Logic_Controls",
    "Marketing Name": "Elite_9550-A",
    "Device": "Elite_9550-A",
    "Model": "Elite_9550-A"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "AERO",
    "Device": "AERO_EEA",
    "Model": "AERO"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "B bot 50",
    "Device": "BBOT50",
    "Model": "B BOT 50"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "B bot 550",
    "Device": "BBOT550",
    "Model": "B BOT 550"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "C bot tab 100",
    "Device": "CBotTab100",
    "Model": "C Bot Tab 100"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "C bot tab 70",
    "Device": "C_Bot_Tab_70",
    "Model": "C Bot Tab 70"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "COMET",
    "Device": "COMET_EEA",
    "Model": "COMET"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "COSMO M2 PRO",
    "Device": "COSMO_M2_PRO",
    "Model": "COSMO M2 PRO"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "CT1080",
    "Device": "CT1080",
    "Model": "CT1080"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "Connect503",
    "Device": "L-ite502",
    "Model": "Connect503"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "E1052GP",
    "Device": "E1052GP",
    "Model": "E1052GP"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "E350",
    "Device": "E350",
    "Model": "E350"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "E400",
    "Device": "E400",
    "Model": "E400"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "E852GP",
    "Device": "E852GP",
    "Model": "E852GP"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "EZY 2",
    "Device": "EZY_2",
    "Model": "EZY 2"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "EZY_EEA",
    "Device": "EZY",
    "Model": "EZY"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "Elio",
    "Device": "Elio",
    "Model": "Elio"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "FIVE",
    "Device": "FIVE_EEA",
    "Model": "FIVE"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "FLOW",
    "Device": "FLOW_EEA",
    "Model": "FLOW"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "Five Pro",
    "Device": "Five_Pro",
    "Model": "Five Pro"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "Five Pro 32",
    "Device": "Five_Pro_32",
    "Model": "Five Pro 32"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "ID bot 53",
    "Device": "IDbot53",
    "Model": "ID bot 53"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "ID bot 553",
    "Device": "IDbot553",
    "Model": "IDbot553"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "ID bot 553+",
    "Device": "IDbot553PLUS",
    "Model": "IDbot553PLUS"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "ID bot 56",
    "Device": "ID_bot_56",
    "Model": "ID bot 56"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "IDbot53plus",
    "Device": "IDbot53plus",
    "Model": "ID bot 53+"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "L-EGANT  ONE-R",
    "Device": "L-EGANTONE-R",
    "Model": "L-EGANTONE-R"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "L-EGANT ONE",
    "Device": "L-EGANTONE",
    "Model": "L-EGANTONE"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "L-EMENT 401",
    "Device": "L-EMENT401",
    "Model": "L-EMENT401"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "L-EMENT 403",
    "Device": "L-EMENT_403",
    "Model": "L-EMENT_403"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "L-EMENT 505",
    "Device": "L-EMENT505",
    "Model": "L-EMENT 505"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "L-EMENT 553",
    "Device": "L-EMENT553",
    "Model": "L-EMENT 553"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "L-EMENT TAB 1040",
    "Device": "generic",
    "Model": "L-EMENT_TAB1040"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "L-EMENT TAB 1043 BTK",
    "Device": "L-EMENT_1043_BTK",
    "Model": "L-EMENT_1043_BTK"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "L-EMENT TAB 1043M",
    "Device": "L-EMENT_TAB1043M",
    "Model": "L-EMENT_TAB1043M"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "L-EMENT TAB 741",
    "Device": "LEMENTTAB741",
    "Model": "L-EMENT 741"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "L-EMENT TAB 742",
    "Device": "LEMENTTAB742",
    "Model": "L-EMENT 742"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "L-EMENT TAB 744",
    "Device": "L-ement_Tab_744",
    "Model": "L-ement_Tab_744"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "L-EMENT TAB 744P",
    "Device": "L-ementTab744P",
    "Model": "L-ementTab744P"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "L-EMENT350",
    "Device": "L-EMENT350",
    "Model": "L-EMENT350"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "L-EMENT400",
    "Device": "LEMENT400",
    "Model": "L-EMENT 400"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "L-EMENT500",
    "Device": "L-EMENT500L",
    "Model": "L-EMENT500L"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "L-EMENT501",
    "Device": "L-EMENT501",
    "Model": "L-EMENT501"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "L-EMENT503",
    "Device": "L-EMENT503",
    "Model": "L-EMENT503"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "L-EMENT550",
    "Device": "L-EMENT550",
    "Model": "L-EMENT550"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "L-EMENT551",
    "Device": "L-EMENT551",
    "Model": "L-EMENT551"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "L-EMENTTAB1042",
    "Device": "LEMENTTAB1042BTK",
    "Model": "L-EMENT_TAB1042BTK"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "L-EMENT_TAB1040_BT",
    "Device": "generic",
    "Model": "L-EMENT_TAB1040_BT"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "L-EMENT_TAB1043",
    "Device": "LEMENTTAB1043",
    "Model": "L-EMENT_TAB1043"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "L-ITE 400M",
    "Device": "L-ITE400M",
    "Model": "L-ITE 400M"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "L-ITE 502 PLUS",
    "Device": "L-ITE502PLUS",
    "Model": "L-ITE 502 PLUS"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "L-ITE 504 HD",
    "Device": "L-ITE504HD",
    "Model": "L-ITE 504 HD"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "L-ITE 506 HD",
    "Device": "L-ITE506HD",
    "Model": "L-ITE 506 HD"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "L-ITE 506R HD",
    "Device": "L-ITE506RHD",
    "Model": "L-ITE 506R HD"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "L-ITE 552 HD",
    "Device": "L-ITE552HD",
    "Model": "L-ITE 552 HD"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "L-ITE Tab 870 LTE",
    "Device": "L-ITETAB870LTE",
    "Model": "L-ITE Tab 870 LTE"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "L-ITE402",
    "Device": "L-ITE402",
    "Model": "L-ITE 402"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "L-ITE452",
    "Device": "L-ITE452",
    "Model": "L-ITE 452"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "L-ITE502",
    "Device": "L-ITE502",
    "Model": "L-ITE 502"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "L-ITE552",
    "Device": "L-ITE552",
    "Model": "L-ITE 552"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "L-IXIR TAB 1041",
    "Device": "generic",
    "Model": "LIXIR1041"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "L-IXIR TAB 1046HD",
    "Device": "L-IXIR_TAB_1046_HD",
    "Model": "L-IXIR_TAB_1046_HD"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "L-IXIR TAB 701 3G",
    "Device": "TAB701",
    "Model": "L-IXIR TAB 701 3G"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "L-IXIR TAB 840",
    "Device": "L-IXIR_TAB_840",
    "Model": "L-IXIR_TAB_840"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "L-ite_Tab1060",
    "Device": "LiteTab1060",
    "Model": "L-ite_Tab1060"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "L351",
    "Device": "L-EMENT351",
    "Model": "L-EMENT351"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "L65T",
    "Device": "LOGIC_L65T",
    "Model": "LOGIC L65T"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "L743",
    "Device": "L-EMENT743",
    "Model": "L-EMENT743"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "LA_TAB_LINK71",
    "Device": "LA_TAB_LINK71",
    "Model": "LOGICOM_LA_TAB_LINK_71"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "LEMENT TAB 740",
    "Device": "LEMENTTAB740",
    "Model": "L-EMENT 740"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "LEMENTTAB1042",
    "Device": "LEMENTTAB1042",
    "Model": "L-EMENT_TAB1042"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "LEMENTTAB901",
    "Device": "LEMENTTAB901",
    "Model": "LEMENT_TAB901"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "LIXIR1044",
    "Device": "LIXIR1044",
    "Model": "LIXIR1044"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "LOGIKIDS11",
    "Device": "LOGIKIDS11",
    "Model": "LOGIKIDS11"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "LOGIKIDS5",
    "Device": "LOGIKIDS5",
    "Model": "LOGIKIDS5"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "LOGIKIDS5",
    "Device": "LOGIKIDS5ED",
    "Model": "LOGIKIDS5ED"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "LOGIKIDS7",
    "Device": "LOGIKIDS7",
    "Model": "LOGIKIDS7"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "LOGIKIDS_11P",
    "Device": "LOGIKIDS_11P",
    "Model": "LOGIKIDS_11P"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "LOGIKIDS_5",
    "Device": "LOGIKIDS_5_Rev2_AF",
    "Model": "LOGIKIDS_5"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "LOGIKIDS_5_Rev2",
    "Device": "LOGIKIDS_5_Rev2",
    "Model": "LOGIKIDS_5"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "LOGIKIDS_STAR",
    "Device": "LOGIKIDS_STAR",
    "Model": "LOGIKIDS_STAR"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "LUNAR",
    "Device": "LUNAR_EEA",
    "Model": "LUNAR"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "LYRA",
    "Device": "LYRA",
    "Model": "LYRA"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "LYRA PLUS",
    "Device": "LYRA_PLUS_EEA",
    "Model": "LYRA PLUS"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "L_IXIR_TAB_1047HD",
    "Device": "L_IXIR_TAB_1047HD",
    "Model": "L_IXIR_TAB_1047HD"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "La Tab 105",
    "Device": "La_Tab_105",
    "Model": "La Tab 105"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "La Tab 106",
    "Device": "LaTab106",
    "Model": "La Tab 106"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "La Tab 107 HD",
    "Device": "La_Tab_107",
    "Model": "La Tab 107"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "La Tab 109 HD",
    "Device": "LaTab109HD",
    "Model": "La Tab 109 HD"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "La Tab 113",
    "Device": "La_Tab_113",
    "Model": "La_Tab_113"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "La Tab 123HD",
    "Device": "La_Tab_123HD",
    "Model": "La_Tab_123HD"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "La Tab 72",
    "Device": "La_Tab_72",
    "Model": "La Tab 72"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "La Tab 73",
    "Device": "La_Tab_73",
    "Model": "La_Tab_73"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "La Tab 90",
    "Device": "La_Tab_90",
    "Model": "La_Tab_90"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "La Tab Full HD",
    "Device": "La_Tab_Full_HD",
    "Model": "La Tab Full HD"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "La tab 124",
    "Device": "La_Tab_124_HD",
    "Model": "La_Tab_124_HD"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "LaTab109HD",
    "Device": "LaTab109HD",
    "Model": "La Tab 109 HD"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "La_Tab_105_P",
    "Device": "La_Tab_105_P",
    "Model": "La_Tab_105_P"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "La_Tab_105_P_Rev2_EEA",
    "Device": "La_Tab_105_P_Rev2",
    "Model": "La_Tab_105_P_Rev2"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "La_Tab_114",
    "Device": "La_Tab_114",
    "Model": "La_Tab_114"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "La_Tab_114_Rev2",
    "Device": "La_Tab_114_Rev2",
    "Model": "La_Tab_114"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "La_Tab_115",
    "Device": "La_Tab_115",
    "Model": "La_Tab_115"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "La_Tab_124_HD_Plus_EEA",
    "Device": "La_Tab_124_HD_Plus",
    "Model": "La_Tab_124_HD_Plus"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "La_Tab_126",
    "Device": "LT1012211F",
    "Model": "La_Tab_126"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "La_Tab_128",
    "Device": "La_Tab_128",
    "Model": "La_Tab_128"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "La_Tab_292",
    "Device": "La_Tab_292",
    "Model": "La Tab 292"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "La_Tab_74",
    "Device": "La_Tab_74",
    "Model": "La_Tab_74"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "La_Tab_74_Rev2",
    "Device": "La_Tab_74_Rev2_EEA",
    "Model": "La_Tab_74"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "La_Tab_74_Rev2_AF",
    "Device": "La_Tab_74_Rev2_AF",
    "Model": "La_Tab_74"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "La_Tab_75",
    "Device": "La_Tab_75",
    "Model": "La_Tab_75"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "La_Tab_Link_101",
    "Device": "La_Tab_Link_101",
    "Model": "LOGICOM La Tab Link 101"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "La_Tab_Link_71_P",
    "Device": "La_Tab_Link_71_P",
    "Model": "La_Tab_Link_71_P"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "La_Tab_Link_73",
    "Device": "La_Tab_Link_73",
    "Model": "La_Tab_Link_73"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "La_Tab_Stand",
    "Device": "La_Tab_Stand",
    "Model": "La Tab Stand"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "La_tab_link_74",
    "Device": "La_tab_link_74",
    "Model": "La_tab_link_74"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "Le Connect",
    "Device": "Le_Connect",
    "Model": "Le_Connect"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "Le Fit",
    "Device": "LeFit",
    "Model": "LeFit"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "Le Fit FR",
    "Device": "LeFitFR",
    "Model": "Le Fit FR"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "Le Fizz",
    "Device": "Le_Fizz",
    "Model": "Le Fizz"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "Le HELLO",
    "Device": "Le_Hello",
    "Model": "Le_Hello"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "Le Hola",
    "Device": "Le_Hola",
    "Model": "Le Hola"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "Le Hola",
    "Device": "Le_Hola",
    "Model": "Le_Hola"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "Le Hola FR",
    "Device": "Le_Hola_FR",
    "Model": "Le Hola FR"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "Le Hop",
    "Device": "Logicom_LeHop",
    "Model": "Le Hop"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "Le Lift",
    "Device": "LeLift",
    "Model": "Le Lift"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "Le Link",
    "Device": "Le_Link",
    "Model": "Le Link"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "Le Must",
    "Device": "LeMust",
    "Model": "Le Must"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "Le Must 2",
    "Device": "LeMust2",
    "Model": "Le Must 2"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "Le Omega",
    "Device": "Le_Omega",
    "Model": "Le Omega"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "Le Prime",
    "Device": "Le_Prime",
    "Model": "Le Prime"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "Le Prime",
    "Device": "Le_Prime",
    "Model": "Le_Prime"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "Le Smooth",
    "Device": "Le_Smooth",
    "Model": "Le Smooth"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "Le Spark",
    "Device": "Le_Spark",
    "Model": "Le_Spark"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "Le Starter L",
    "Device": "Le_Starter_L",
    "Model": "Le Starter L"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "Le Swipe",
    "Device": "LS0591121F",
    "Model": "Le Swipe"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "Le UP",
    "Device": "LeUp",
    "Model": "Le Up"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "Le Wave",
    "Device": "Le_Wave",
    "Model": "Le Wave"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "LeMoov2",
    "Device": "LeMoov2",
    "Model": "LeMoov2"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "Le_Link",
    "Device": "Le_Link",
    "Model": "Le Link"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "Le_Pulse",
    "Device": "Le_Pulse",
    "Model": "Le_Pulse"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "Le_Spark",
    "Device": "Le_Spark",
    "Model": "Le_Spark"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "LiteTab760",
    "Device": "LiteTab760",
    "Model": "LiteTab760"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "Logicom La Tab 127 HD",
    "Device": "La_Tab_127_HD_EEA",
    "Model": "Logicom La Tab 127 HD"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "Logikids",
    "Device": "Logikids_2",
    "Model": "Logikids_2"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "Logikids 3",
    "Device": "Logikids_3",
    "Model": "Logikids_3"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "Logikids 4",
    "Device": "logikids4",
    "Model": "logikids4"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "Logikids_10",
    "Device": "Logikids_10",
    "Model": "Logikids_10"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "Logikids_6",
    "Device": "Logikids_6",
    "Model": "Logikids_6"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "Logikids_Buddy",
    "Device": "Logikids_Buddy",
    "Model": "Logikids_Buddy"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "Luma",
    "Device": "Luma",
    "Model": "Luma"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "Lunar Pro",
    "Device": "Lunar_Pro",
    "Model": "Lunar Pro"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "M bot 51",
    "Device": "Mbot51",
    "Model": "M bot 51"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "M bot 54",
    "Device": "M_bot_54",
    "Model": "M bot 54"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "M bot 551",
    "Device": "M_BOT_551",
    "Model": "M BOT 551"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "M bot 60",
    "Device": "Mbot60",
    "Model": "M bot 60"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "M bot Tab 103",
    "Device": "MbotTab103",
    "Model": "M bot Tab 103"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "M bot Tab 1150",
    "Device": "M_bot_tab_1150",
    "Model": "M_bot_tab_1150"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "M bot Tab 71",
    "Device": "M_bot_tab_71",
    "Model": "M_bot_tab_71"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "M bot tab 10",
    "Device": "M_BOT_TAB_10",
    "Model": "M bot tab 10"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "M bot tab 100",
    "Device": "M_BOT_TAB_100",
    "Model": "M BOT TAB 100"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "M bot tab 101",
    "Device": "MBOTTAB101",
    "Model": "M BOT TAB 101"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "M bot tab 70",
    "Device": "M_BOT_TAB_70",
    "Model": "M BOT TAB 70"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "M_ bot_ 52",
    "Device": "M_bot_52",
    "Model": "M bot 52"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "ONIX",
    "Device": "ONIX",
    "Model": "ONIX"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "ORION E1",
    "Device": "ORION_E1",
    "Model": "ORION E1"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "ORION E1 PLUS",
    "Device": "ORION_E1_PLUS",
    "Model": "ORION E1 PLUS"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "POWER bot",
    "Device": "POWERBOT",
    "Model": "POWER BOT"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "Playtab 10",
    "Device": "LOGICOM_PLAYTAB_10",
    "Model": "LOGICOM_PLAYTAB_10"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "RIOPAD_7",
    "Device": "RIOPAD_7",
    "Model": "RIOPAD_7"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "S1052",
    "Device": "S1052",
    "Model": "S1052"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "S450",
    "Device": "S450",
    "Model": "S450"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "S504",
    "Device": "S504",
    "Model": "Connect 5"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "S504",
    "Device": "S504",
    "Model": "S504"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "S732",
    "Device": "rk3026",
    "Model": "S732"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "S7842",
    "Device": "S7842",
    "Model": "S7842"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "S952",
    "Device": "S952",
    "Model": "S952"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "SENSE",
    "Device": "SENSE_EEA",
    "Model": "SENSE"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "SMART PRO",
    "Device": "SMART_PRO_EEA",
    "Model": "SMART PRO"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "SOLAR",
    "Device": "SOLAR",
    "Model": "SOLAR"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "Solar Pro",
    "Device": "Solar_Pro",
    "Model": "Solar Pro"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "TAB134",
    "Device": "TAB134",
    "Model": "TAB134"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "TAB210",
    "Device": "TAB210",
    "Model": "TAB210"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "TAB76",
    "Device": "TAB76",
    "Model": "TAB76"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "TABLINK104",
    "Device": "Tab_Link_104",
    "Model": "Tab Link 104"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "TABXL14",
    "Device": "Tab_XL_14",
    "Model": "Tab XL 14"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "TABXL_14",
    "Device": "TABXL_14",
    "Model": "Tab_XL_14"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "TAB_FOLD_10",
    "Device": "TAB_FOLD_10",
    "Model": "TAB_FOLD_10"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "TAB_FOLD_12",
    "Device": "TAB_FOLD_12",
    "Model": "TAB_FOLD_12"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "TAB_STAND_PRO_2",
    "Device": "TAB_STAND_PRO_2",
    "Model": "TAB_STAND_PRO_2"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "TAB_XXL_14",
    "Device": "TAB_XXL_14",
    "Model": "TAB_XXL_14"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "Tab_80",
    "Device": "Tab_80",
    "Model": "E884"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "Tab_80",
    "Device": "Tab_80",
    "Model": "Tab_80"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "Tab_Stand_Pro",
    "Device": "Tab_Stand_Pro",
    "Model": "Tab_Stand_Pro"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "Tab_XL_14",
    "Device": "Tab_XL_14",
    "Model": "Tab_XL_14"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "Touch Tablet CT730",
    "Device": "CT730",
    "Model": "CT730"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "VISION_X3_MAX",
    "Device": "VISION_X3_MAX",
    "Model": "VISION X3 MAX"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "VRBOT552",
    "Device": "VRBOT552",
    "Model": "VR BOT 552"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "VRBOT552PLUS",
    "Device": "VRBOT552PLUS",
    "Model": "VR BOT 552 PLUS"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "Volt-R",
    "Device": "Volt-R",
    "Model": "Volt-R"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "WAVE  2s",
    "Device": "WAVE_2s",
    "Model": "WAVE 2s"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "Wave 2",
    "Device": "Wave_2",
    "Model": "Wave 2"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "Xtrem650",
    "Device": "Xtrem650",
    "Model": "Xtrem650"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "Yuno",
    "Device": "Yuno",
    "Model": "Yuno"
  },
  {
    "Retail Branding": "Logicom",
    "Marketing Name": "le Moov",
    "Device": "LeMoov",
    "Model": "LeMoov"
  },
  {
    "Retail Branding": "Logik",
    "Marketing Name": "LOGIK",
    "Device": "sadang",
    "Model": "LOGIK 4K Android TV"
  },
  {
    "Retail Branding": "Logik",
    "Marketing Name": "LOGIK",
    "Device": "tabata",
    "Model": "LOGIK 2K Android TV"
  },
  {
    "Retail Branding": "Logik",
    "Marketing Name": "Smart TV",
    "Device": "ueno",
    "Model": "2K Android TV"
  },
  {
    "Retail Branding": "Logitec",
    "Marketing Name": "LZ-AA10",
    "Device": "LZ-AA10",
    "Model": "LZ-AA10"
  },
  {
    "Retail Branding": "Logitec",
    "Marketing Name": "LZ-AA10MC",
    "Device": "LZ-AA10MC",
    "Model": "LZ-AA10MC"
  },
  {
    "Retail Branding": "Logitech",
    "Marketing Name": "GR0006",
    "Device": "GR0006",
    "Model": "GR0006"
  },
  {
    "Retail Branding": "Logitech",
    "Marketing Name": "Revue",
    "Device": "ka",
    "Model": "Revue"
  },
  {
    "Retail Branding": "Look2innovate",
    "Marketing Name": "LKTABLET3",
    "Device": "Look3",
    "Model": "Look3"
  },
  {
    "Retail Branding": "Louis Vuitton",
    "Marketing Name": "Tambour Horizon",
    "Device": "ling",
    "Model": "Tambour"
  },
  {
    "Retail Branding": "Louis Vuitton",
    "Marketing Name": "Tambour Horizon",
    "Device": "sundial",
    "Model": "Tambour"
  },
  {
    "Retail Branding": "Lucentel",
    "Marketing Name": "Siren_1",
    "Device": "Siren_1",
    "Model": "Siren_1"
  },
  {
    "Retail Branding": "Lumigon",
    "Marketing Name": "T2",
    "Device": "msm7630_fw8911",
    "Model": "T2"
  },
  {
    "Retail Branding": "Lumigon",
    "Marketing Name": "T2 HD",
    "Device": "T2HD",
    "Model": "T2HD"
  },
  {
    "Retail Branding": "Lumigon",
    "Marketing Name": "T3",
    "Device": "Lumigon_T3",
    "Model": "Lumigon_T3"
  },
  {
    "Retail Branding": "Lumitel",
    "Marketing Name": "L9502",
    "Device": "L9502",
    "Model": "L9502"
  },
  {
    "Retail Branding": "Lumitel",
    "Marketing Name": "L9503",
    "Device": "L9503",
    "Model": "L9503"
  },
  {
    "Retail Branding": "Lunnen",
    "Marketing Name": "TL42810L01",
    "Device": "TL42810L01",
    "Model": "Lunnen Ground 10.4"
  },
  {
    "Retail Branding": "Lunnen",
    "Marketing Name": "TL42810L01",
    "Device": "TL42810L01",
    "Model": "TL42810L01"
  },
  {
    "Retail Branding": "Lunnen",
    "Marketing Name": "TL4648S01",
    "Device": "TL4648S01",
    "Model": "TL4648S01"
  },
  {
    "Retail Branding": "Lunnen",
    "Marketing Name": "TL62810G01",
    "Device": "TL62810G01",
    "Model": "Lunnen Ground 10.4"
  },
  {
    "Retail Branding": "Lunnen",
    "Marketing Name": "TL62810G01",
    "Device": "TL62810G01",
    "Model": "TL62810G01"
  },
  {
    "Retail Branding": "Lunnen",
    "Marketing Name": "TL85611B01",
    "Device": "TL85611B01",
    "Model": "Lunnen Ground 11"
  },
  {
    "Retail Branding": "Lyf",
    "Marketing Name": "LS-4004",
    "Device": "LS-4004",
    "Model": "LS-4004"
  },
  {
    "Retail Branding": "Lyf",
    "Marketing Name": "LS-4006",
    "Device": "LS-4006",
    "Model": "LYF_LS-4006"
  },
  {
    "Retail Branding": "Lyf",
    "Marketing Name": "LS-4503",
    "Device": "LS-4503",
    "Model": "LS-4503"
  },
  {
    "Retail Branding": "Lyf",
    "Marketing Name": "LS-4505",
    "Device": "LS-4505",
    "Model": "LS-4505"
  },
  {
    "Retail Branding": "Lyf",
    "Marketing Name": "LS-4508",
    "Device": "C-451",
    "Model": "LS-4508"
  },
  {
    "Retail Branding": "Lyf",
    "Marketing Name": "LS-4510",
    "Device": "LS-4510",
    "Model": "LS-4510"
  },
  {
    "Retail Branding": "Lyf",
    "Marketing Name": "LS-4511",
    "Device": "LS-4511",
    "Model": "LS-4511"
  },
  {
    "Retail Branding": "Lyf",
    "Marketing Name": "LS-4512",
    "Device": "LS-4512",
    "Model": "LS-4512"
  },
  {
    "Retail Branding": "Lyf",
    "Marketing Name": "LS-5002",
    "Device": "LS-5002",
    "Model": "LS-5002"
  },
  {
    "Retail Branding": "Lyf",
    "Marketing Name": "LS-5004",
    "Device": "LS-5004",
    "Model": "LS-5004"
  },
  {
    "Retail Branding": "Lyf",
    "Marketing Name": "LS-5008",
    "Device": "P839F30",
    "Model": "LS-5008"
  },
  {
    "Retail Branding": "Lyf",
    "Marketing Name": "LS-5009",
    "Device": "LS-5009",
    "Model": "LS-5009"
  },
  {
    "Retail Branding": "Lyf",
    "Marketing Name": "LS-5013",
    "Device": "LS-5013",
    "Model": "LS-5013"
  },
  {
    "Retail Branding": "Lyf",
    "Marketing Name": "LS-5016",
    "Device": "LS-5016",
    "Model": "LS-5016"
  },
  {
    "Retail Branding": "Lyf",
    "Marketing Name": "LS-5018",
    "Device": "HL-L51P",
    "Model": "LS-5018"
  },
  {
    "Retail Branding": "Lyf",
    "Marketing Name": "LS-5020",
    "Device": "LS-5020",
    "Model": "LS-5020"
  },
  {
    "Retail Branding": "Lyf",
    "Marketing Name": "LS-5021",
    "Device": "ZTE_T920",
    "Model": "LS-5021"
  },
  {
    "Retail Branding": "Lyf",
    "Marketing Name": "LS-5027",
    "Device": "LS-5027",
    "Model": "LS-5027"
  },
  {
    "Retail Branding": "Lyf",
    "Marketing Name": "LS-5201",
    "Device": "panda01a_msm8952_64",
    "Model": "LS-5201"
  },
  {
    "Retail Branding": "Lyf",
    "Marketing Name": "LS-5503",
    "Device": "P839F50",
    "Model": "LS-5503"
  },
  {
    "Retail Branding": "Lyf",
    "Marketing Name": "LS-5504",
    "Device": "zx55q05_64",
    "Model": "LS-5504"
  },
  {
    "Retail Branding": "Lyf",
    "Marketing Name": "LS-6001",
    "Device": "LS-6001",
    "Model": "LS-6001"
  },
  {
    "Retail Branding": "Lyf",
    "Marketing Name": "LS1602UW",
    "Device": "LYF",
    "Model": "LS1602UW"
  },
  {
    "Retail Branding": "Lyf",
    "Marketing Name": "LT-8001",
    "Device": "LT-8001",
    "Model": "LT-8001"
  },
  {
    "Retail Branding": "Lyf",
    "Marketing Name": "LT-8001 IRIS",
    "Device": "LT-8001-IRIS",
    "Model": "LT-8001 IRIS"
  },
  {
    "Retail Branding": "Lyf",
    "Marketing Name": "WATER F1",
    "Device": "LS-5505",
    "Model": "LS-5505"
  },
  {
    "Retail Branding": "M-Horse",
    "Marketing Name": "A9",
    "Device": "A9",
    "Model": "A9"
  },
  {
    "Retail Branding": "M-Horse",
    "Marketing Name": "C67",
    "Device": "C67",
    "Model": "C67"
  },
  {
    "Retail Branding": "M-Horse",
    "Marketing Name": "C68",
    "Device": "C68",
    "Model": "C68"
  },
  {
    "Retail Branding": "M-Horse",
    "Marketing Name": "M-HORSE",
    "Device": "Pure1",
    "Model": "Pure1"
  },
  {
    "Retail Branding": "M-Horse",
    "Marketing Name": "M1",
    "Device": "M1",
    "Model": "M1"
  },
  {
    "Retail Branding": "M-Horse",
    "Marketing Name": "M2",
    "Device": "M2",
    "Model": "M2"
  },
  {
    "Retail Branding": "M-Horse",
    "Marketing Name": "M2S",
    "Device": "M2S",
    "Model": "M2S"
  },
  {
    "Retail Branding": "M-Horse",
    "Marketing Name": "M3",
    "Device": "M3",
    "Model": "M3"
  },
  {
    "Retail Branding": "M-Horse",
    "Marketing Name": "M5",
    "Device": "M5",
    "Model": "M5"
  },
  {
    "Retail Branding": "M-Horse",
    "Marketing Name": "MHORSE M",
    "Device": "M_HORSE_M",
    "Model": "M_HORSE_M"
  },
  {
    "Retail Branding": "M-Horse",
    "Marketing Name": "Note 50 Pro Max",
    "Device": "Note_50_Pro_Max",
    "Model": "Note 50 Pro Max"
  },
  {
    "Retail Branding": "M-Horse",
    "Marketing Name": "P1",
    "Device": "P1",
    "Model": "P1"
  },
  {
    "Retail Branding": "M-Horse",
    "Marketing Name": "Pure 2",
    "Device": "Pure-2",
    "Model": "Pure 2"
  },
  {
    "Retail Branding": "M-Horse",
    "Marketing Name": "Pure 3",
    "Device": "Pure_3",
    "Model": "Pure 3"
  },
  {
    "Retail Branding": "M-KOPA",
    "Marketing Name": "M-KOPA M10",
    "Device": "NYX",
    "Model": "M-KOPA M10"
  },
  {
    "Retail Branding": "M-KOPA",
    "Marketing Name": "S34",
    "Device": "S34",
    "Model": "S34"
  },
  {
    "Retail Branding": "M-KOPA",
    "Marketing Name": "S50",
    "Device": "S50",
    "Model": "S50"
  },
  {
    "Retail Branding": "M-tech",
    "Marketing Name": "Eros Power",
    "Device": "EROS_Power",
    "Model": "EROS Power"
  },
  {
    "Retail Branding": "M-tech",
    "Marketing Name": "Eros Smart",
    "Device": "Eros_Smart",
    "Model": "Eros Smart"
  },
  {
    "Retail Branding": "M-tech",
    "Marketing Name": "Eros_Star",
    "Device": "Eros_Star",
    "Model": "Eros_Star"
  },
  {
    "Retail Branding": "M-tech",
    "Marketing Name": "Shine",
    "Device": "Shine",
    "Model": "Shine"
  },
  {
    "Retail Branding": "M3 Mobile",
    "Marketing Name": "M3 SL20",
    "Device": "M3SL20",
    "Model": "M3SL20"
  },
  {
    "Retail Branding": "M3 Mobile",
    "Marketing Name": "M3 SM15N",
    "Device": "M3SM15N",
    "Model": "M3SM15N"
  },
  {
    "Retail Branding": "M3 Mobile",
    "Marketing Name": "M3 SM15X",
    "Device": "M3SM15X",
    "Model": "M3SM15X"
  },
  {
    "Retail Branding": "M3 Mobile",
    "Marketing Name": "M3 SM20",
    "Device": "M3SM20",
    "Model": "M3SM20"
  },
  {
    "Retail Branding": "M3 Mobile",
    "Marketing Name": "M3 UL20F",
    "Device": "M3UL20F",
    "Model": "M3UL20F"
  },
  {
    "Retail Branding": "M3 Mobile",
    "Marketing Name": "M3 UL20W",
    "Device": "M3UL20W",
    "Model": "M3UL20W"
  },
  {
    "Retail Branding": "M3 Mobile",
    "Marketing Name": "M3 UL20X",
    "Device": "M3UL20X",
    "Model": "M3UL20X"
  },
  {
    "Retail Branding": "M3 Mobile",
    "Marketing Name": "M3 US20W",
    "Device": "M3US20W",
    "Model": "M3US20W"
  },
  {
    "Retail Branding": "M3 Mobile",
    "Marketing Name": "M3 US20X",
    "Device": "M3US20X",
    "Model": "M3US20X"
  },
  {
    "Retail Branding": "M3 Mobile",
    "Marketing Name": "M3-SL10",
    "Device": "M3-SL10",
    "Model": "M3-SL10"
  },
  {
    "Retail Branding": "M3 Mobile",
    "Marketing Name": "M3PC10",
    "Device": "M3PC10",
    "Model": "M3PC10"
  },
  {
    "Retail Branding": "M3 Mobile",
    "Marketing Name": "M3SL10",
    "Device": "M3SL10",
    "Model": "M3SL10"
  },
  {
    "Retail Branding": "M3 Mobile",
    "Marketing Name": "M3SL20K",
    "Device": "M3SL20K",
    "Model": "M3SL20K"
  },
  {
    "Retail Branding": "M3 Mobile",
    "Marketing Name": "M3SL20PLUS",
    "Device": "M3SL20PLUS",
    "Model": "M3SL20PLUS"
  },
  {
    "Retail Branding": "M3 Mobile",
    "Marketing Name": "M3SL25",
    "Device": "M3SL25",
    "Model": "M3SL25"
  },
  {
    "Retail Branding": "M3 Mobile",
    "Marketing Name": "M3SM15N",
    "Device": "M3SM15N",
    "Model": "M3SM15N"
  },
  {
    "Retail Branding": "M3 Mobile",
    "Marketing Name": "M3SM15N_EEA",
    "Device": "M3SM15N",
    "Model": "M3SM15N"
  },
  {
    "Retail Branding": "M3 Mobile",
    "Marketing Name": "M3SM15X",
    "Device": "M3SM15X",
    "Model": "M3SM15X"
  },
  {
    "Retail Branding": "M3 Mobile",
    "Marketing Name": "M3SM15X_EEA",
    "Device": "M3SM15X",
    "Model": "M3SM15X"
  },
  {
    "Retail Branding": "M3 Mobile",
    "Marketing Name": "M3SM30",
    "Device": "M3SM30",
    "Model": "M3SM30"
  },
  {
    "Retail Branding": "M3 Mobile",
    "Marketing Name": "M3UL20F_EEA",
    "Device": "M3UL20F",
    "Model": "M3UL20F"
  },
  {
    "Retail Branding": "M3 Mobile",
    "Marketing Name": "M3UL20W_EEA",
    "Device": "M3UL20W",
    "Model": "M3UL20W"
  },
  {
    "Retail Branding": "M3 Mobile",
    "Marketing Name": "M3UL20X_EEA",
    "Device": "M3UL20X",
    "Model": "M3UL20X"
  },
  {
    "Retail Branding": "M3 Mobile",
    "Marketing Name": "M3UL30",
    "Device": "M3UL30",
    "Model": "M3UL30"
  },
  {
    "Retail Branding": "M3 Mobile",
    "Marketing Name": "M3US30",
    "Device": "M3US30",
    "Model": "M3US30"
  },
  {
    "Retail Branding": "M3 Mobile",
    "Marketing Name": "M3WD10",
    "Device": "M3WD10",
    "Model": "M3WD10"
  },
  {
    "Retail Branding": "M4tel",
    "Marketing Name": "M4 B1",
    "Device": "M4_B1",
    "Model": "M4_B1"
  },
  {
    "Retail Branding": "M4tel",
    "Marketing Name": "M4 B2",
    "Device": "M4_B2",
    "Model": "M4_B2"
  },
  {
    "Retail Branding": "M4tel",
    "Marketing Name": "M4 B3",
    "Device": "M4_B3",
    "Model": "M4_B3"
  },
  {
    "Retail Branding": "M4tel",
    "Marketing Name": "M4 R2",
    "Device": "M4_R2",
    "Model": "M4_R2"
  },
  {
    "Retail Branding": "M4tel",
    "Marketing Name": "M4 R2",
    "Device": "R2",
    "Model": "M4_R2"
  },
  {
    "Retail Branding": "M4tel",
    "Marketing Name": "M4 R3LIGHT",
    "Device": "R3LIGHT",
    "Model": "M4 R3 LIGHT"
  },
  {
    "Retail Branding": "M4tel",
    "Marketing Name": "M4 SS4450",
    "Device": "DREAMPLUS02A-S10A",
    "Model": "M4 SS4450"
  },
  {
    "Retail Branding": "M4tel",
    "Marketing Name": "M4 SS4450B",
    "Device": "DREAMPLUS02C-S10A",
    "Model": "M4 SS4450B"
  },
  {
    "Retail Branding": "M4tel",
    "Marketing Name": "M4 SS4451",
    "Device": "NOVA02A_S11A",
    "Model": "M4 SS4451"
  },
  {
    "Retail Branding": "M4tel",
    "Marketing Name": "M4 SS4452",
    "Device": "UDON02A_S10A",
    "Model": "M4 SS4452"
  },
  {
    "Retail Branding": "M4tel",
    "Marketing Name": "M4 SS4453",
    "Device": "TOUCHPLUS01A-S10A",
    "Model": "M4 SS4453"
  },
  {
    "Retail Branding": "M4tel",
    "Marketing Name": "M4 SS4453-R",
    "Device": "M4-SS4453-R",
    "Model": "M4-SS4453-R"
  },
  {
    "Retail Branding": "M4tel",
    "Marketing Name": "M4 SS4455",
    "Device": "NOVA03A_S22A",
    "Model": "M4 SS4455"
  },
  {
    "Retail Branding": "M4tel",
    "Marketing Name": "M4 SS4456",
    "Device": "UDON04A_S19A",
    "Model": "M4 SS4456"
  },
  {
    "Retail Branding": "M4tel",
    "Marketing Name": "M4 SS4457",
    "Device": "DREAMPLUS03A-S14A",
    "Model": "M4 SS4457"
  },
  {
    "Retail Branding": "M4tel",
    "Marketing Name": "M4 SS4457-R",
    "Device": "M4-SS4457-R",
    "Model": "M4 SS4457-R"
  },
  {
    "Retail Branding": "M4tel",
    "Marketing Name": "M4 SS4457-R",
    "Device": "M4-SS4457-R",
    "Model": "M4-SS4457-R"
  },
  {
    "Retail Branding": "M4tel",
    "Marketing Name": "M4 SS4458",
    "Device": "TOUCHPLUS02A-S17A",
    "Model": "M4 SS4458"
  },
  {
    "Retail Branding": "M4tel",
    "Marketing Name": "M4 SS4458-R",
    "Device": "M4-SS4458-R",
    "Model": "M4-SS4458-R"
  },
  {
    "Retail Branding": "M4tel",
    "Marketing Name": "R2 Plus",
    "Device": "R2_Plus",
    "Model": "R2_Plus"
  },
  {
    "Retail Branding": "MAG",
    "Marketing Name": "MAG",
    "Device": "elliniko",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "MAG",
    "Marketing Name": "MAG",
    "Device": "lavender",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "MAG",
    "Marketing Name": "MAG",
    "Device": "mountbaker",
    "Model": "2K SMART TV"
  },
  {
    "Retail Branding": "MAG",
    "Marketing Name": "MAG425A",
    "Device": "MAG425A",
    "Model": "MAG425A"
  },
  {
    "Retail Branding": "MAG",
    "Marketing Name": "MAG500A",
    "Device": "MAG500A",
    "Model": "MAG500A"
  },
  {
    "Retail Branding": "MAG",
    "Marketing Name": "MAG555",
    "Device": "YHT",
    "Model": "MAG555"
  },
  {
    "Retail Branding": "MAGCH",
    "Marketing Name": "M210",
    "Device": "M210",
    "Model": "M210"
  },
  {
    "Retail Branding": "MAGCH",
    "Marketing Name": "M220",
    "Device": "M220",
    "Model": "M220"
  },
  {
    "Retail Branding": "MAGCH",
    "Marketing Name": "M310-EEA",
    "Device": "M310-EEA",
    "Model": "M310-EEA"
  },
  {
    "Retail Branding": "MAGCH",
    "Marketing Name": "M321",
    "Device": "M321",
    "Model": "M321"
  },
  {
    "Retail Branding": "MAGCH",
    "Marketing Name": "M321-EEA",
    "Device": "M321-EEA",
    "Model": "M321-EEA"
  },
  {
    "Retail Branding": "MAGCH",
    "Marketing Name": "M520",
    "Device": "M520",
    "Model": "M520"
  },
  {
    "Retail Branding": "MAGCH",
    "Marketing Name": "M610",
    "Device": "M610",
    "Model": "M610"
  },
  {
    "Retail Branding": "MAGCH",
    "Marketing Name": "M610-EEA",
    "Device": "M610-EEA",
    "Model": "M610-EEA"
  },
  {
    "Retail Branding": "MAGCH",
    "Marketing Name": "M820",
    "Device": "M820",
    "Model": "M820"
  },
  {
    "Retail Branding": "MAGCH",
    "Marketing Name": "M820-EEA",
    "Device": "M820-EEA",
    "Model": "M820-EEA"
  },
  {
    "Retail Branding": "MAGCH",
    "Marketing Name": "M821",
    "Device": "M821",
    "Model": "M821"
  },
  {
    "Retail Branding": "MAGCH",
    "Marketing Name": "M821-EEA",
    "Device": "M821-EEA",
    "Model": "M821-EEA"
  },
  {
    "Retail Branding": "MAGCH",
    "Marketing Name": "M910",
    "Device": "M910",
    "Model": "M910"
  },
  {
    "Retail Branding": "MAGCH",
    "Marketing Name": "T7",
    "Device": "T7_Pro",
    "Model": "T7"
  },
  {
    "Retail Branding": "MAGICworld",
    "Marketing Name": "Smart TV",
    "Device": "longshan",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "MAGNUMTECH",
    "Marketing Name": "MG715",
    "Device": "MG715",
    "Model": "MG715"
  },
  {
    "Retail Branding": "MAIBENBEN",
    "Marketing Name": "PAD54G",
    "Device": "PAD54G11M87",
    "Model": "Pad 5"
  },
  {
    "Retail Branding": "MAIBENBEN",
    "Marketing Name": "PAD5WIFI",
    "Device": "PAD5WiFi11M87",
    "Model": "Pad 5"
  },
  {
    "Retail Branding": "MARUSYS",
    "Marketing Name": "MAU9000D",
    "Device": "mau9000d",
    "Model": "MAU9000D"
  },
  {
    "Retail Branding": "MARVUE",
    "Marketing Name": "M11",
    "Device": "M11",
    "Model": "M11"
  },
  {
    "Retail Branding": "MARVUE",
    "Marketing Name": "M12",
    "Device": "M12",
    "Model": "M12"
  },
  {
    "Retail Branding": "MARVUE",
    "Marketing Name": "M15",
    "Device": "M15",
    "Model": "M15"
  },
  {
    "Retail Branding": "MARVUE",
    "Marketing Name": "M18",
    "Device": "M18",
    "Model": "M18"
  },
  {
    "Retail Branding": "MARVUE",
    "Marketing Name": "M8",
    "Device": "M8",
    "Model": "M8"
  },
  {
    "Retail Branding": "MARVUE",
    "Marketing Name": "M81",
    "Device": "M81",
    "Model": "M81"
  },
  {
    "Retail Branding": "MARVUE",
    "Marketing Name": "M8_Pro",
    "Device": "M8_Pro",
    "Model": "M8_Pro"
  },
  {
    "Retail Branding": "MARVUE",
    "Marketing Name": "Pad_M10",
    "Device": "Pad_M10",
    "Model": "Pad_M10"
  },
  {
    "Retail Branding": "MARVUE",
    "Marketing Name": "Pad_M11_EEA",
    "Device": "Pad_M11",
    "Model": "Pad_M11"
  },
  {
    "Retail Branding": "MARVUE",
    "Marketing Name": "Pad_M11_EEA",
    "Device": "Pad_M11_EEA",
    "Model": "Pad_M11_EEA"
  },
  {
    "Retail Branding": "MASTERTECH",
    "Marketing Name": "77-EV",
    "Device": "77-EV",
    "Model": "77-EV"
  },
  {
    "Retail Branding": "MASTERTECH",
    "Marketing Name": "M2M-3T",
    "Device": "M2M-3T",
    "Model": "M2M-3T"
  },
  {
    "Retail Branding": "MASTERTECH",
    "Marketing Name": "MASTERTECH",
    "Device": "elliniko",
    "Model": "MASTERTECH GOOGLE TV"
  },
  {
    "Retail Branding": "MASTERTECH",
    "Marketing Name": "MASTERTECH",
    "Device": "jagalchi",
    "Model": "MASTERTECH GOOGLE TV"
  },
  {
    "Retail Branding": "MASTERTECH",
    "Marketing Name": "MASTERTECH",
    "Device": "lavender",
    "Model": "MASTERTECH GOOGLE TV"
  },
  {
    "Retail Branding": "MASTERTECH",
    "Marketing Name": "MASTERTECH",
    "Device": "mountbaker",
    "Model": "MASTERTECH GOOGLE TV"
  },
  {
    "Retail Branding": "MASTERTECH",
    "Marketing Name": "R3",
    "Device": "R3",
    "Model": "R3"
  },
  {
    "Retail Branding": "MASTERTECH",
    "Marketing Name": "R4",
    "Device": "R4",
    "Model": "R4"
  },
  {
    "Retail Branding": "MASTERTECH",
    "Marketing Name": "Smart TV",
    "Device": "alimos",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "MASTERTECH",
    "Marketing Name": "Smart TV",
    "Device": "dangni",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "MAXHUB",
    "Marketing Name": "E3",
    "Device": "E3",
    "Model": "maxhub_bytello_edla"
  },
  {
    "Retail Branding": "MAXHUB",
    "Marketing Name": "S2",
    "Device": "S2",
    "Model": "S2"
  },
  {
    "Retail Branding": "MAXHUB",
    "Marketing Name": "S_Line",
    "Device": "S_Line",
    "Model": "S_Line"
  },
  {
    "Retail Branding": "MAXHUB",
    "Marketing Name": "U30",
    "Device": "rk3588_t",
    "Model": "U30"
  },
  {
    "Retail Branding": "MAXHUB",
    "Marketing Name": "U4",
    "Device": "oversea_v",
    "Model": "U4"
  },
  {
    "Retail Branding": "MAXLEGEN",
    "Marketing Name": "M621",
    "Device": "M621",
    "Model": "M621"
  },
  {
    "Retail Branding": "MAXLEGEN",
    "Marketing Name": "M621-EEA",
    "Device": "M621-EEA",
    "Model": "M621-EEA"
  },
  {
    "Retail Branding": "MAXLEGEN",
    "Marketing Name": "M708-EEA",
    "Device": "M708-EEA",
    "Model": "M708-EEA"
  },
  {
    "Retail Branding": "MAXLEGEN",
    "Marketing Name": "Tablet_a",
    "Device": "M816-EEA",
    "Model": "M816-EEA"
  },
  {
    "Retail Branding": "MAXRON",
    "Marketing Name": "MXCORE",
    "Device": "MXCORE",
    "Model": "MXCORE"
  },
  {
    "Retail Branding": "MAXRON",
    "Marketing Name": "MXPAD",
    "Device": "MXPAD",
    "Model": "MXPAD"
  },
  {
    "Retail Branding": "MAXRON",
    "Marketing Name": "MXULTRA",
    "Device": "MXULTRA",
    "Model": "MXULTRA"
  },
  {
    "Retail Branding": "MAXX",
    "Marketing Name": "Grand Prime",
    "Device": "Grand_Prime",
    "Model": "Grand Prime"
  },
  {
    "Retail Branding": "MAXtv",
    "Marketing Name": "MAX",
    "Device": "elliniko",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "MAYA",
    "Marketing Name": "P4",
    "Device": "P4",
    "Model": "P4"
  },
  {
    "Retail Branding": "MAZE",
    "Marketing Name": "Alpha",
    "Device": "Alpha",
    "Model": "Alpha"
  },
  {
    "Retail Branding": "MAZE",
    "Marketing Name": "Alpha_X",
    "Device": "Alpha_X",
    "Model": "Alpha_X"
  },
  {
    "Retail Branding": "MAZE",
    "Marketing Name": "Comet",
    "Device": "Comet",
    "Model": "Comet"
  },
  {
    "Retail Branding": "MAZE",
    "Marketing Name": "SSB-408E",
    "Device": "SSB-408E",
    "Model": "SSB-408E"
  },
  {
    "Retail Branding": "MAZE",
    "Marketing Name": "SSB-508E",
    "Device": "SSB-508E",
    "Model": "SSB-508E"
  },
  {
    "Retail Branding": "MAZE",
    "Marketing Name": "SSB5518R",
    "Device": "SSB5518R",
    "Model": "SSB5518R"
  },
  {
    "Retail Branding": "MAZE",
    "Marketing Name": "SSB558R",
    "Device": "SSB558R",
    "Model": "SSB558R"
  },
  {
    "Retail Branding": "MAZE",
    "Marketing Name": "SSB700T",
    "Device": "SSB700T",
    "Model": "SSB700T"
  },
  {
    "Retail Branding": "MBO(Aolixin)",
    "Marketing Name": "16A Pro",
    "Device": "16A_Pro",
    "Model": "16A_Pro"
  },
  {
    "Retail Branding": "MBO(Aolixin)",
    "Marketing Name": "24S_Ultra",
    "Device": "24S_Ultra",
    "Model": "24S_Ultra"
  },
  {
    "Retail Branding": "MCTV",
    "Marketing Name": "MCIFPD",
    "Device": "rk3588_t",
    "Model": "MCIFPD"
  },
  {
    "Retail Branding": "MDC Store",
    "Marketing Name": "Grand",
    "Device": "Grand",
    "Model": "Grand"
  },
  {
    "Retail Branding": "MDC Store",
    "Marketing Name": "M100",
    "Device": "M100",
    "Model": "M100"
  },
  {
    "Retail Branding": "MDC Store",
    "Marketing Name": "M200",
    "Device": "M200",
    "Model": "M200"
  },
  {
    "Retail Branding": "MDC Store",
    "Marketing Name": "M300 4G",
    "Device": "M300",
    "Model": "M300 4G"
  },
  {
    "Retail Branding": "MDC Store",
    "Marketing Name": "MDC GrandPro",
    "Device": "MDC_Grand_Pro",
    "Model": "Grand Pro"
  },
  {
    "Retail Branding": "MDC Store",
    "Marketing Name": "MDC M5",
    "Device": "M5",
    "Model": "MDC M5"
  },
  {
    "Retail Branding": "MDC Store",
    "Marketing Name": "Nova",
    "Device": "Nova",
    "Model": "Nova"
  },
  {
    "Retail Branding": "MDC Store",
    "Marketing Name": "Nova Pro",
    "Device": "Nova_Pro",
    "Model": "Nova Pro"
  },
  {
    "Retail Branding": "MDC Store",
    "Marketing Name": "Optima",
    "Device": "Optima",
    "Model": "Optima"
  },
  {
    "Retail Branding": "MDC Store",
    "Marketing Name": "Prime_S",
    "Device": "Prime_S",
    "Model": "Prime_S"
  },
  {
    "Retail Branding": "MEDER",
    "Marketing Name": "MEDER",
    "Device": "smartguide210_eea",
    "Model": "SmartGuide_2.10"
  },
  {
    "Retail Branding": "MEDER",
    "Marketing Name": "SmartGuide210-464",
    "Device": "SmartGuide210-464",
    "Model": "SmartGuide210-464"
  },
  {
    "Retail Branding": "MEDER",
    "Marketing Name": "m60",
    "Device": "m60",
    "Model": "m60"
  },
  {
    "Retail Branding": "MEFERI",
    "Marketing Name": "CIAO",
    "Device": "CIAO",
    "Model": "CIAO"
  },
  {
    "Retail Branding": "MEFERI",
    "Marketing Name": "MC45",
    "Device": "MC45",
    "Model": "MC45"
  },
  {
    "Retail Branding": "MEFERI",
    "Marketing Name": "ME10",
    "Device": "ME10",
    "Model": "ME10"
  },
  {
    "Retail Branding": "MEFERI",
    "Marketing Name": "ME40K",
    "Device": "ME40K",
    "Model": "ME40K"
  },
  {
    "Retail Branding": "MEFERI",
    "Marketing Name": "ME40K",
    "Device": "ME40K_L",
    "Model": "ME40K"
  },
  {
    "Retail Branding": "MEFERI",
    "Marketing Name": "ME40M",
    "Device": "ME40K_M",
    "Model": "ME40K"
  },
  {
    "Retail Branding": "MEFERI",
    "Marketing Name": "ME61",
    "Device": "ME61",
    "Model": "ME61"
  },
  {
    "Retail Branding": "MEFERI",
    "Marketing Name": "ME61",
    "Device": "ME61_L",
    "Model": "ME61"
  },
  {
    "Retail Branding": "MEFERI",
    "Marketing Name": "ME63",
    "Device": "ME63",
    "Model": "ME63"
  },
  {
    "Retail Branding": "MEFERI",
    "Marketing Name": "ME65",
    "Device": "ME65",
    "Model": "ME65"
  },
  {
    "Retail Branding": "MEFERI",
    "Marketing Name": "ME74",
    "Device": "ME74",
    "Model": "ME74"
  },
  {
    "Retail Branding": "MEIZE",
    "Marketing Name": "D105",
    "Device": "D105",
    "Model": "D105"
  },
  {
    "Retail Branding": "MEIZE",
    "Marketing Name": "D106",
    "Device": "D106",
    "Model": "D106"
  },
  {
    "Retail Branding": "MEIZE",
    "Marketing Name": "D108",
    "Device": "D108",
    "Model": "D108"
  },
  {
    "Retail Branding": "MEIZE",
    "Marketing Name": "D115",
    "Device": "D115",
    "Model": "D115"
  },
  {
    "Retail Branding": "MEIZE",
    "Marketing Name": "D121",
    "Device": "D121",
    "Model": "D121"
  },
  {
    "Retail Branding": "MEIZE",
    "Marketing Name": "D121_EEA",
    "Device": "D121_EEA",
    "Model": "D121_EEA"
  },
  {
    "Retail Branding": "MEIZE",
    "Marketing Name": "D123",
    "Device": "D123",
    "Model": "D123"
  },
  {
    "Retail Branding": "MEIZE",
    "Marketing Name": "D125",
    "Device": "D125",
    "Model": "D125"
  },
  {
    "Retail Branding": "MEIZE",
    "Marketing Name": "D125_EEA",
    "Device": "D125_EEA",
    "Model": "D125_EEA"
  },
  {
    "Retail Branding": "MEIZE",
    "Marketing Name": "D126",
    "Device": "D126",
    "Model": "D126"
  },
  {
    "Retail Branding": "MEIZE",
    "Marketing Name": "D126_EEA",
    "Device": "D126_EEA",
    "Model": "D126_EEA"
  },
  {
    "Retail Branding": "MEIZE",
    "Marketing Name": "D126_TAB",
    "Device": "D126_TAB",
    "Model": "D126_TAB"
  },
  {
    "Retail Branding": "MEIZE",
    "Marketing Name": "D126_TAB_EEA",
    "Device": "D126_TAB_EEA",
    "Model": "D126_TAB_EEA"
  },
  {
    "Retail Branding": "MEIZE",
    "Marketing Name": "D131",
    "Device": "D131",
    "Model": "D131"
  },
  {
    "Retail Branding": "MEIZE",
    "Marketing Name": "D131_eea",
    "Device": "D131_eea",
    "Model": "D131_eea"
  },
  {
    "Retail Branding": "MEIZE",
    "Marketing Name": "D135",
    "Device": "D135",
    "Model": "D135"
  },
  {
    "Retail Branding": "MEIZE",
    "Marketing Name": "D138",
    "Device": "D138",
    "Model": "D138"
  },
  {
    "Retail Branding": "MEIZE",
    "Marketing Name": "I9_Plus_WIFIOnly_EEA",
    "Device": "I9_Plus_WIFIOnly_EEA",
    "Model": "I9_Plus"
  },
  {
    "Retail Branding": "MEO(Portugal)",
    "Marketing Name": "MEO TV Box 4K",
    "Device": "DV8555-MEO",
    "Model": "MEO TV Box 4K"
  },
  {
    "Retail Branding": "MEO(Portugal)",
    "Marketing Name": "MEO TV Box 4K",
    "Device": "DV8985-MEO",
    "Model": "MEOBox 4K DV8985"
  },
  {
    "Retail Branding": "MEO(Portugal)",
    "Marketing Name": "MEO TV Box 4K (DIW3930)",
    "Device": "DIW3930-MEO",
    "Model": "MEO TV Box 4K (DIW3930)"
  },
  {
    "Retail Branding": "MEO(Portugal)",
    "Marketing Name": "MEOBox 4K",
    "Device": "DIW3930-MEO",
    "Model": "MEO TV Box 4K (DIW3930)"
  },
  {
    "Retail Branding": "MEO(Portugal)",
    "Marketing Name": "MEOBox 4K VSB",
    "Device": "VSB3918-MEO",
    "Model": "MEOBox 4K (VSB3918)"
  },
  {
    "Retail Branding": "MEO(Portugal)",
    "Marketing Name": "MEOBox 4K v2",
    "Device": "DIW377-MEO",
    "Model": "MEO TV Box 4K (DIW377)"
  },
  {
    "Retail Branding": "MEO(Portugal)",
    "Marketing Name": "MEOBox Android TV 4K",
    "Device": "HP4C02-MEO",
    "Model": "MEOBox 4K (HP4C02)"
  },
  {
    "Retail Branding": "METHOD_XI",
    "Marketing Name": "KW_IWB",
    "Device": "KW_RK3588",
    "Model": "METHOD_XI_8600"
  },
  {
    "Retail Branding": "METZ",
    "Marketing Name": "86SG1",
    "Device": "86SG1",
    "Model": "86SG1"
  },
  {
    "Retail Branding": "MG Series",
    "Marketing Name": "Any 302",
    "Device": "TR10CS2_3",
    "Model": "TR10CS2"
  },
  {
    "Retail Branding": "MG series",
    "Marketing Name": "Any 302",
    "Device": "TR10CS1_15",
    "Model": "TR10CS1"
  },
  {
    "Retail Branding": "MG series",
    "Marketing Name": "Any 302",
    "Device": "TR10CS2_2",
    "Model": "TR10CS2"
  },
  {
    "Retail Branding": "MG series",
    "Marketing Name": "Any 302",
    "Device": "TR10CS2_3",
    "Model": "TR10CS2"
  },
  {
    "Retail Branding": "MG series",
    "Marketing Name": "Any 303",
    "Device": "TR10CD2_2",
    "Model": "TR10CD2"
  },
  {
    "Retail Branding": "MG series",
    "Marketing Name": "Any 303",
    "Device": "TR10CD2_3",
    "Model": "TR10CD2"
  },
  {
    "Retail Branding": "MGS",
    "Marketing Name": "MGS",
    "Device": "bangbae",
    "Model": "MGS 4K Android TV"
  },
  {
    "Retail Branding": "MGS",
    "Marketing Name": "MGS",
    "Device": "bruno",
    "Model": "MGS2KAndroidTV"
  },
  {
    "Retail Branding": "MGS",
    "Marketing Name": "MGS",
    "Device": "expo",
    "Model": "4K MGS Google TV"
  },
  {
    "Retail Branding": "MGS",
    "Marketing Name": "MGS",
    "Device": "komagome",
    "Model": "MGS 2K Android TV"
  },
  {
    "Retail Branding": "MGS",
    "Marketing Name": "MGS",
    "Device": "tennoji",
    "Model": "2K MGS Google TV"
  },
  {
    "Retail Branding": "MHL Mobile Company",
    "Marketing Name": "TRECFONE_A21S",
    "Device": "TRECFONE_A21S",
    "Model": "TRECFONE_A21S"
  },
  {
    "Retail Branding": "MIAPRODUCT",
    "Marketing Name": "AMBK290471",
    "Device": "AMBK290471",
    "Model": "AMBK290471"
  },
  {
    "Retail Branding": "MIFONE",
    "Marketing Name": "Model 6 Pro Max 4G",
    "Device": "Model-6-Pro-Max-4G",
    "Model": "Model-6-Pro-Max-4G"
  },
  {
    "Retail Branding": "MIKITECH",
    "Marketing Name": "MK-ES300",
    "Device": "MK-ES300",
    "Model": "MK-ES300"
  },
  {
    "Retail Branding": "MIKU",
    "Marketing Name": "TAB63A",
    "Device": "TAB63A",
    "Model": "TAB63A"
  },
  {
    "Retail Branding": "MILECTRIC",
    "Marketing Name": "SPAIN, MOROCCO, PORTUGAL",
    "Device": "tamachi",
    "Model": "MILECTRIC Android TV"
  },
  {
    "Retail Branding": "MILECTRIC",
    "Marketing Name": "SPAIN, MOROCCO, PORTUGAL",
    "Device": "yeongdeungpo",
    "Model": "MILECTRIC Android TV"
  },
  {
    "Retail Branding": "MINDEO",
    "Marketing Name": "D70",
    "Device": "D70",
    "Model": "D70"
  },
  {
    "Retail Branding": "MINDEO",
    "Marketing Name": "M50_EEA",
    "Device": "M50_EEA",
    "Model": "M50_EEA"
  },
  {
    "Retail Branding": "MINDEO",
    "Marketing Name": "MS8389",
    "Device": "MS8389",
    "Model": "MS8389"
  },
  {
    "Retail Branding": "MINDEO",
    "Marketing Name": "MS8389",
    "Device": "MS8389RU",
    "Model": "MS8389"
  },
  {
    "Retail Branding": "MINDEO",
    "Marketing Name": "MS8589",
    "Device": "MS8589",
    "Model": "MS8589"
  },
  {
    "Retail Branding": "MINDEO",
    "Marketing Name": "MS8589_RU",
    "Device": "MS8589RU",
    "Model": "MS8589"
  },
  {
    "Retail Branding": "MINIX",
    "Marketing Name": "MINIX NEO T5",
    "Device": "DV8553",
    "Model": "DV8553"
  },
  {
    "Retail Branding": "MIRAI_TOUCH",
    "Marketing Name": "IFP MIRAI TOUCH",
    "Device": "PE3S_Series",
    "Model": "PE3S_Series"
  },
  {
    "Retail Branding": "MIRAI_TOUCH",
    "Marketing Name": "MXXCE3XE",
    "Device": "rk3588_t",
    "Model": "MXXCE3XE"
  },
  {
    "Retail Branding": "MIRAI_TOUCH",
    "Marketing Name": "MXXCE4S",
    "Device": "InteractiveFlatPanelDisplay",
    "Model": "bytello_edla"
  },
  {
    "Retail Branding": "MIRAI_TOUCH",
    "Marketing Name": "PE4S",
    "Device": "PE4S_Series",
    "Model": "PE4S_Series"
  },
  {
    "Retail Branding": "MIRAY",
    "Marketing Name": "Android TV",
    "Device": "R1",
    "Model": "ATV R1"
  },
  {
    "Retail Branding": "MIRAY",
    "Marketing Name": "Android TV",
    "Device": "R2",
    "Model": "ATV R2"
  },
  {
    "Retail Branding": "MIRAY",
    "Marketing Name": "MIDM_737",
    "Device": "MIDM_737",
    "Model": "MIDM_737"
  },
  {
    "Retail Branding": "MIRAY",
    "Marketing Name": "MIDM_F10",
    "Device": "MIDM_F10",
    "Model": "MIDM_F10"
  },
  {
    "Retail Branding": "MIRAY",
    "Marketing Name": "Miray 2k google tv",
    "Device": "dongnae",
    "Model": "Miray 2k google tv"
  },
  {
    "Retail Branding": "MIRAY",
    "Marketing Name": "Peru",
    "Device": "sepolia",
    "Model": "Miray 4k google tv"
  },
  {
    "Retail Branding": "MIRAY",
    "Marketing Name": "R10G",
    "Device": "R10G",
    "Model": "R10G"
  },
  {
    "Retail Branding": "MIRAY",
    "Marketing Name": "R3",
    "Device": "R3",
    "Model": "R3"
  },
  {
    "Retail Branding": "MIRAY",
    "Marketing Name": "R3_GTV",
    "Device": "R3_GTV",
    "Model": "R3G"
  },
  {
    "Retail Branding": "MIRAY",
    "Marketing Name": "R4",
    "Device": "R4",
    "Model": "R4"
  },
  {
    "Retail Branding": "MIRAY",
    "Marketing Name": "R4_GTV",
    "Device": "R4_GTV",
    "Model": "R4G"
  },
  {
    "Retail Branding": "MIRAY",
    "Marketing Name": "TM4G_1006",
    "Device": "TM4G_1006",
    "Model": "TM4G_1006"
  },
  {
    "Retail Branding": "MIRAY",
    "Marketing Name": "TM4G_806",
    "Device": "TM4G_806",
    "Model": "TM4G_806"
  },
  {
    "Retail Branding": "MIRAY",
    "Marketing Name": "TPM4G_105",
    "Device": "TPM4G_105",
    "Model": "TPM4G_105"
  },
  {
    "Retail Branding": "MIRAY",
    "Marketing Name": "TPM4G_E108",
    "Device": "TPM4G_E108",
    "Model": "TPM4G_E108"
  },
  {
    "Retail Branding": "MIRAY",
    "Marketing Name": "TPM4G_E108_A",
    "Device": "TPM4G_E108_A",
    "Model": "TPM4G_E108"
  },
  {
    "Retail Branding": "MIRAY",
    "Marketing Name": "TPM4G_E9863",
    "Device": "TPM4G_E9863",
    "Model": "TPM4G_E9863"
  },
  {
    "Retail Branding": "MIRAY",
    "Marketing Name": "vileparle",
    "Device": "vileparle",
    "Model": "R6G"
  },
  {
    "Retail Branding": "MIRO",
    "Marketing Name": "A1",
    "Device": "A1",
    "Model": "MIRO A1"
  },
  {
    "Retail Branding": "MIRO",
    "Marketing Name": "MIRO C1",
    "Device": "C1",
    "Model": "MIRO C1"
  },
  {
    "Retail Branding": "MIRO",
    "Marketing Name": "Miro A67S",
    "Device": "Miro_A67S",
    "Model": "Miro A67S"
  },
  {
    "Retail Branding": "MIRO",
    "Marketing Name": "Miro C67",
    "Device": "Miro_C67",
    "Model": "Miro C67"
  },
  {
    "Retail Branding": "MIRO",
    "Marketing Name": "Miro C67S",
    "Device": "Miro_C67S",
    "Model": "Miro C67S"
  },
  {
    "Retail Branding": "MIRO",
    "Marketing Name": "Miro C69M Pro",
    "Device": "Miro_C69M_Pro",
    "Model": "Miro C69M Pro"
  },
  {
    "Retail Branding": "MIRO",
    "Marketing Name": "Miro S67",
    "Device": "Miro_S67",
    "Model": "Miro S67"
  },
  {
    "Retail Branding": "MIRO",
    "Marketing Name": "Miro S69 Pro",
    "Device": "S69_Pro",
    "Model": "Miro S69 Pro"
  },
  {
    "Retail Branding": "MITSUSHIBA",
    "Marketing Name": "MITSUSHIBA",
    "Device": "TP-10-0232P3G",
    "Model": "TP-10-0232P3G"
  },
  {
    "Retail Branding": "MITSUSHIBA",
    "Marketing Name": "TP-07-016",
    "Device": "TP-07-016",
    "Model": "TP-07-016"
  },
  {
    "Retail Branding": "MJS",
    "Marketing Name": "T2702",
    "Device": "T2702",
    "Model": "T2702"
  },
  {
    "Retail Branding": "MLAB",
    "Marketing Name": 8990,
    "Device": 8990,
    "Model": 8990
  },
  {
    "Retail Branding": "MLAB",
    "Marketing Name": 9095,
    "Device": 9095,
    "Model": 9095
  },
  {
    "Retail Branding": "MLAB",
    "Marketing Name": 9096,
    "Device": 9096,
    "Model": 9096
  },
  {
    "Retail Branding": "MLAB",
    "Marketing Name": 9098,
    "Device": 9098,
    "Model": 9098
  },
  {
    "Retail Branding": "MLAB",
    "Marketing Name": 9342,
    "Device": 9342,
    "Model": 9342
  },
  {
    "Retail Branding": "MLAB",
    "Marketing Name": 9343,
    "Device": 9343,
    "Model": 9343
  },
  {
    "Retail Branding": "MLAB",
    "Marketing Name": 9344,
    "Device": 9344,
    "Model": 9344
  },
  {
    "Retail Branding": "MLAB",
    "Marketing Name": 9593,
    "Device": 9593,
    "Model": 9593
  },
  {
    "Retail Branding": "MLAB",
    "Marketing Name": "MB4",
    "Device": "MB4",
    "Model": "MB4"
  },
  {
    "Retail Branding": "MLAB",
    "Marketing Name": "MB4 WIFI",
    "Device": "MB4_WIFI",
    "Model": "MB4 WIFI"
  },
  {
    "Retail Branding": "MLAB",
    "Marketing Name": "MB4_3G",
    "Device": "MB4_3G",
    "Model": "MB4_3G"
  },
  {
    "Retail Branding": "MLAB",
    "Marketing Name": "MB4_3G_PLUS_SE",
    "Device": "MB4_3G_PLUS_SE",
    "Model": "MB4_3G_PLUS_SE"
  },
  {
    "Retail Branding": "MLAB",
    "Marketing Name": "MB5 WIFI",
    "Device": "MB5_WIFI",
    "Model": "MB5 WIFI"
  },
  {
    "Retail Branding": "MLAB",
    "Marketing Name": "MB8715",
    "Device": "MB8715",
    "Model": "MB8715"
  },
  {
    "Retail Branding": "MLAB",
    "Marketing Name": "MB8717",
    "Device": "MB8717",
    "Model": "MB8717"
  },
  {
    "Retail Branding": "MLAB",
    "Marketing Name": "MB8866",
    "Device": "MB8866",
    "Model": "MB8866"
  },
  {
    "Retail Branding": "MLAB",
    "Marketing Name": "MB8992",
    "Device": "MB8992",
    "Model": "MB8992"
  },
  {
    "Retail Branding": "MLAB",
    "Marketing Name": "MLAB_GLOWY7",
    "Device": "MLAB_GLOWY7",
    "Model": "MLAB_GLOWY7"
  },
  {
    "Retail Branding": "MLAB",
    "Marketing Name": "MLAB_GLOWY8",
    "Device": "MLAB_GLOWY8",
    "Model": "MLAB_GLOWY8"
  },
  {
    "Retail Branding": "MLAB",
    "Marketing Name": "MLAB_KIDS_PLUS",
    "Device": "MLAB_KIDS_PLUS",
    "Model": "MLAB_KIDS_PLUS"
  },
  {
    "Retail Branding": "MLAB",
    "Marketing Name": "MLAB_TABLET_KID",
    "Device": "MLAB_TABLET_KID",
    "Model": "MLAB_TABLET_KID"
  },
  {
    "Retail Branding": "MLAB",
    "Marketing Name": "Studio_Phone_10",
    "Device": "Studio_Phone_10",
    "Model": "MLAB_9339"
  },
  {
    "Retail Branding": "MLAB",
    "Marketing Name": "Studio_Sleeve_Pro_10",
    "Device": "Studio_Sleeve_Pro_10",
    "Model": "MLAB_9617"
  },
  {
    "Retail Branding": "MLAB",
    "Marketing Name": "Studio_Suite_Pro_12",
    "Device": "Studio_Suite_Pro_12",
    "Model": "MLAB_9618"
  },
  {
    "Retail Branding": "MLINK",
    "Marketing Name": "M5013",
    "Device": "M5013",
    "Model": "M5013"
  },
  {
    "Retail Branding": "MLINK",
    "Marketing Name": "M6501B",
    "Device": "M6501B",
    "Model": "M6501"
  },
  {
    "Retail Branding": "MLINK",
    "Marketing Name": "M707",
    "Device": "M707",
    "Model": "M707"
  },
  {
    "Retail Branding": "MLINK",
    "Marketing Name": "M761",
    "Device": "M761",
    "Model": "M761"
  },
  {
    "Retail Branding": "MLINK",
    "Marketing Name": "M809",
    "Device": "M809",
    "Model": "M809"
  },
  {
    "Retail Branding": "MLOGIX",
    "Marketing Name": "10ML_012G",
    "Device": "10ML_012G",
    "Model": "10ML_012G"
  },
  {
    "Retail Branding": "MLOGIX",
    "Marketing Name": "7ML_73G",
    "Device": "7ML_73G",
    "Model": "7ML_73G"
  },
  {
    "Retail Branding": "MLOGIX",
    "Marketing Name": "8ML_08G",
    "Device": "8ML_08G",
    "Model": "8ML_08G"
  },
  {
    "Retail Branding": "MLS Innovation",
    "Marketing Name": "IQS805",
    "Device": "iQS805",
    "Model": "iQS805"
  },
  {
    "Retail Branding": "MLS Innovation",
    "Marketing Name": "IQW570",
    "Device": "iQW570",
    "Model": "iQW570"
  },
  {
    "Retail Branding": "MLS Innovation",
    "Marketing Name": "PTB7QSG_3G",
    "Device": "iQE200",
    "Model": "iQE200"
  },
  {
    "Retail Branding": "MLS Innovation",
    "Marketing Name": "iQ1060M",
    "Device": "iQ1060M",
    "Model": "iQ1060M"
  },
  {
    "Retail Branding": "MLS Innovation",
    "Marketing Name": "iQ1568",
    "Device": "iQ1568",
    "Model": "iQ1568"
  },
  {
    "Retail Branding": "MLS Innovation",
    "Marketing Name": "iQ1653",
    "Device": "iQ1653",
    "Model": "iQ1653"
  },
  {
    "Retail Branding": "MLS Innovation",
    "Marketing Name": "iQ411M",
    "Device": "iQ411M",
    "Model": "iQ411M"
  },
  {
    "Retail Branding": "MLS Innovation",
    "Marketing Name": "iQ8011",
    "Device": "iQ8011",
    "Model": "iQ8011"
  },
  {
    "Retail Branding": "MLS Innovation",
    "Marketing Name": "iQ8225_EEA",
    "Device": "iQ8225",
    "Model": "iQ8225"
  },
  {
    "Retail Branding": "MLS Innovation",
    "Marketing Name": "iQD10S",
    "Device": "iQD10S",
    "Model": "iQD10S"
  },
  {
    "Retail Branding": "MLS Innovation",
    "Marketing Name": "iQG550",
    "Device": "iQG550",
    "Model": "iQG550"
  },
  {
    "Retail Branding": "MLS Innovation",
    "Marketing Name": "iQL550",
    "Device": "iQL550",
    "Model": "iQL550"
  },
  {
    "Retail Branding": "MLS Innovation",
    "Marketing Name": "iQL626",
    "Device": "iQL626",
    "Model": "iQL626"
  },
  {
    "Retail Branding": "MLS Innovation",
    "Marketing Name": "iQM1518",
    "Device": "iQM1518",
    "Model": "iQM1518"
  },
  {
    "Retail Branding": "MLS Innovation",
    "Marketing Name": "iQM960L",
    "Device": "iQM960L",
    "Model": "iQM960L"
  },
  {
    "Retail Branding": "MLS Innovation",
    "Marketing Name": "iQME100",
    "Device": "iQME100",
    "Model": "iQME100"
  },
  {
    "Retail Branding": "MLS Innovation",
    "Marketing Name": "iQN700",
    "Device": "iQN700",
    "Model": "iQN700"
  },
  {
    "Retail Branding": "MLS Innovation",
    "Marketing Name": "iQS1001",
    "Device": "iQS1001",
    "Model": "iQS1001"
  },
  {
    "Retail Branding": "MLS Innovation",
    "Marketing Name": "iQS801",
    "Device": "iQS801",
    "Model": "iQS801"
  },
  {
    "Retail Branding": "MLS Innovation",
    "Marketing Name": "iQT1161",
    "Device": "iQT1161",
    "Model": "iQT1161"
  },
  {
    "Retail Branding": "MLS Innovation",
    "Marketing Name": "iQT610",
    "Device": "iQT610",
    "Model": "iQT610"
  },
  {
    "Retail Branding": "MLS Innovation",
    "Marketing Name": "iQW511T",
    "Device": "iQW511T",
    "Model": "iQW511T"
  },
  {
    "Retail Branding": "MLS Innovation",
    "Marketing Name": "iQW608",
    "Device": "iQW608",
    "Model": "iQW608"
  },
  {
    "Retail Branding": "MLS Innovation",
    "Marketing Name": "iQW626",
    "Device": "iQW626",
    "Model": "iQW626"
  },
  {
    "Retail Branding": "MNC NOW",
    "Marketing Name": "CYBORG001",
    "Device": "HP40A3",
    "Model": "CYBORG001"
  },
  {
    "Retail Branding": "MOBILE KINGDOM",
    "Marketing Name": "GENESIS_126",
    "Device": "GENESIS_126",
    "Model": "GENESIS_126"
  },
  {
    "Retail Branding": "MOBO",
    "Marketing Name": "MB_530",
    "Device": "MB_530",
    "Model": "MB_530"
  },
  {
    "Retail Branding": "MOBODO",
    "Marketing Name": "MOBODO MOBO K2",
    "Device": "MOBOK2",
    "Model": "MOBOK2"
  },
  {
    "Retail Branding": "MOBULAA",
    "Marketing Name": "K1",
    "Device": "K1",
    "Model": "K1"
  },
  {
    "Retail Branding": "MOBULAA",
    "Marketing Name": "K6",
    "Device": "K6",
    "Model": "K6"
  },
  {
    "Retail Branding": "MOBULAA",
    "Marketing Name": "MOBULAA Note4",
    "Device": "Note4",
    "Model": "Note4"
  },
  {
    "Retail Branding": "MOBULAA",
    "Marketing Name": "NOTE1",
    "Device": "NOTE1",
    "Model": "NOTE1"
  },
  {
    "Retail Branding": "MOBULAA",
    "Marketing Name": "NOTE2",
    "Device": "NOTE2",
    "Model": "NOTE2"
  },
  {
    "Retail Branding": "MOBULAA",
    "Marketing Name": "S11",
    "Device": "S11",
    "Model": "S11"
  },
  {
    "Retail Branding": "MOBULAA",
    "Marketing Name": "S6",
    "Device": "S6",
    "Model": "S6"
  },
  {
    "Retail Branding": "MOBULAA",
    "Marketing Name": "Tab-1",
    "Device": "Tab-1",
    "Model": "Tab-1"
  },
  {
    "Retail Branding": "MOLLIE",
    "Marketing Name": "Mollie_Tap",
    "Device": "Mollie_Tap",
    "Model": "Mollie Tap"
  },
  {
    "Retail Branding": "MOLLIE",
    "Marketing Name": "Mollie_Tap_EEA",
    "Device": "Mollie_Tap_EEA",
    "Model": "Mollie Tap EEA"
  },
  {
    "Retail Branding": "MONOMAX",
    "Marketing Name": "Max Play",
    "Device": "DV6071Z-KTM",
    "Model": "Max Play"
  },
  {
    "Retail Branding": "MOREFUN",
    "Marketing Name": "M90",
    "Device": "M90",
    "Model": "M90"
  },
  {
    "Retail Branding": "MOTREX",
    "Marketing Name": "RS300A",
    "Device": "RS300A",
    "Model": "RS300A"
  },
  {
    "Retail Branding": "MOVI",
    "Marketing Name": "Movi Projector Phone",
    "Device": "Movi",
    "Model": "Movi Projector Phone"
  },
  {
    "Retail Branding": "MOVIC",
    "Marketing Name": "A5501",
    "Device": "A5501",
    "Model": "A5501"
  },
  {
    "Retail Branding": "MOVIC",
    "Marketing Name": "Dual",
    "Device": "Dual",
    "Model": "Dual"
  },
  {
    "Retail Branding": "MOVIC",
    "Marketing Name": "F5003",
    "Device": "F5003",
    "Model": "F5003"
  },
  {
    "Retail Branding": "MOVIC",
    "Marketing Name": "K4",
    "Device": "K4",
    "Model": "K4"
  },
  {
    "Retail Branding": "MOVIC",
    "Marketing Name": "MOVIC-W2",
    "Device": "MOVIC-W2",
    "Model": "MOVIC-W2"
  },
  {
    "Retail Branding": "MOVIC",
    "Marketing Name": "Movic F4501",
    "Device": "F4501",
    "Model": "Movic F4501"
  },
  {
    "Retail Branding": "MOVIC",
    "Marketing Name": "S5501",
    "Device": "S5501",
    "Model": "S5501"
  },
  {
    "Retail Branding": "MOVISUN",
    "Marketing Name": "ASTROA1",
    "Device": "ASTROA1",
    "Model": "ASTROA1"
  },
  {
    "Retail Branding": "MOVISUN",
    "Marketing Name": "Astro_Pad10",
    "Device": "Astro_Pad10",
    "Model": "Astro_Pad10"
  },
  {
    "Retail Branding": "MOVISUN",
    "Marketing Name": "TAB-S1",
    "Device": "TAB-S1",
    "Model": "TAB-S1"
  },
  {
    "Retail Branding": "MOXNICE",
    "Marketing Name": "P50-EEA",
    "Device": "P50-EEA",
    "Model": "P50-EEA"
  },
  {
    "Retail Branding": "MOXNICE",
    "Marketing Name": "P50-ROW",
    "Device": "P50-ROW",
    "Model": "P50-ROW"
  },
  {
    "Retail Branding": "MOXNICE",
    "Marketing Name": "P63_EEA",
    "Device": "P63",
    "Model": "P63"
  },
  {
    "Retail Branding": "MPORT",
    "Marketing Name": "MPORT-IFPD",
    "Device": "rk3588_t",
    "Model": "e_Smarter"
  },
  {
    "Retail Branding": "MPman",
    "Marketing Name": "MPDC1006",
    "Device": "MPDC1006",
    "Model": "MPDC1006"
  },
  {
    "Retail Branding": "MPman",
    "Marketing Name": "MPDC706",
    "Device": "MPDC706",
    "Model": "MPDC706"
  },
  {
    "Retail Branding": "MSI",
    "Marketing Name": "Google Monitor",
    "Device": "caoya",
    "Model": "Google Monitor"
  },
  {
    "Retail Branding": "MSI",
    "Marketing Name": "MS-NDB3",
    "Device": "MS-NDB3",
    "Model": "MS-NDB3"
  },
  {
    "Retail Branding": "MSI",
    "Marketing Name": "NB32-Gen2",
    "Device": "NB32-Gen2",
    "Model": "NB32-Gen2"
  },
  {
    "Retail Branding": "MSI",
    "Marketing Name": "ND52-Gen2",
    "Device": "ND52-Gen2",
    "Model": "ND52-Gen2"
  },
  {
    "Retail Branding": "MSI",
    "Marketing Name": "Primo73",
    "Device": "N71J",
    "Model": "Primo73"
  },
  {
    "Retail Branding": "MSI",
    "Marketing Name": "Primo76",
    "Device": "N728",
    "Model": "Primo76"
  },
  {
    "Retail Branding": "MSI",
    "Marketing Name": "Primo81",
    "Device": "N821",
    "Model": "Primo 81"
  },
  {
    "Retail Branding": "MSI",
    "Marketing Name": "Primo81",
    "Device": "N821",
    "Model": "Primo81"
  },
  {
    "Retail Branding": "MSI",
    "Marketing Name": "Primo81",
    "Device": "Primo81",
    "Model": "Primo81"
  },
  {
    "Retail Branding": "MSI",
    "Marketing Name": "Summit13AI",
    "Device": "Summit13AI",
    "Model": "MS-NDB2"
  },
  {
    "Retail Branding": "MSota",
    "Marketing Name": "Nobby S400",
    "Device": "Nobby_S400",
    "Model": "Nobby S400"
  },
  {
    "Retail Branding": "MSota",
    "Marketing Name": "Nobby S500",
    "Device": "Nobby_S500",
    "Model": "Nobby S500"
  },
  {
    "Retail Branding": "MSota",
    "Marketing Name": "Nobby X800",
    "Device": "Nobby_X800",
    "Model": "Nobby X800"
  },
  {
    "Retail Branding": "MSota",
    "Marketing Name": "Nobby X800 Pro",
    "Device": "Nobby_X800_Pro",
    "Model": "Nobby X800 Pro"
  },
  {
    "Retail Branding": "MTC",
    "Marketing Name": 982,
    "Device": "MTC_982",
    "Model": "MTC 982"
  },
  {
    "Retail Branding": "MTC",
    "Marketing Name": "ANAM",
    "Device": "shilin",
    "Model": "ANAM4KAndroidTV"
  },
  {
    "Retail Branding": "MTC",
    "Marketing Name": "ANDRINO",
    "Device": "shilin",
    "Model": "andrino 4K Android TV"
  },
  {
    "Retail Branding": "MTC",
    "Marketing Name": "DWSUMMUS",
    "Device": "shilin",
    "Model": "DWSUMMUS4KAndroidTV"
  },
  {
    "Retail Branding": "MTC",
    "Marketing Name": "ENTV",
    "Device": "seocho",
    "Model": "ENTV 4K Android TV"
  },
  {
    "Retail Branding": "MTC",
    "Marketing Name": "ENTV",
    "Device": "shilin",
    "Model": "ENTV4KAndroidTV"
  },
  {
    "Retail Branding": "MTC",
    "Marketing Name": "GRANZ",
    "Device": "shilin",
    "Model": "GRANZ4KAndroidTV"
  },
  {
    "Retail Branding": "MTC",
    "Marketing Name": "Hansung",
    "Device": "seocho",
    "Model": "Hansung 4K Android TV"
  },
  {
    "Retail Branding": "MTC",
    "Marketing Name": "Hansung",
    "Device": "shilin",
    "Model": "Hansung4KAndroidTV"
  },
  {
    "Retail Branding": "MTC",
    "Marketing Name": "Infiniton",
    "Device": "bangbae",
    "Model": "Infiniton 4K Android TV"
  },
  {
    "Retail Branding": "MTC",
    "Marketing Name": "Infiniton",
    "Device": "komagome",
    "Model": "Infiniton 2K Android TV"
  },
  {
    "Retail Branding": "MTC",
    "Marketing Name": "JVC",
    "Device": "shilin",
    "Model": "JVC TV Ultra"
  },
  {
    "Retail Branding": "MTC",
    "Marketing Name": "JVC",
    "Device": "shilin",
    "Model": "JVC US 4K Android TV"
  },
  {
    "Retail Branding": "MTC",
    "Marketing Name": "KIVI",
    "Device": "shilin",
    "Model": "KIVI 4K Android TV"
  },
  {
    "Retail Branding": "MTC",
    "Marketing Name": "KLEINZ",
    "Device": "shilin",
    "Model": "KLEINZ4KAndroidTV"
  },
  {
    "Retail Branding": "MTC",
    "Marketing Name": "MTC",
    "Device": "seocho",
    "Model": "DWSUMMUS 4K Android TV"
  },
  {
    "Retail Branding": "MTC",
    "Marketing Name": "MTC",
    "Device": "seocho",
    "Model": "Posfic 4K Android TV"
  },
  {
    "Retail Branding": "MTC",
    "Marketing Name": "MTC",
    "Device": "seocho",
    "Model": "WasabiMango 4K Android TV"
  },
  {
    "Retail Branding": "MTC",
    "Marketing Name": "Monex",
    "Device": "shilin",
    "Model": "Monex4KAndroidTV"
  },
  {
    "Retail Branding": "MTC",
    "Marketing Name": "Olive",
    "Device": "bruno",
    "Model": "Olive 2K Android TV"
  },
  {
    "Retail Branding": "MTC",
    "Marketing Name": "Olive",
    "Device": "shilin",
    "Model": "Olive 4K Android TV"
  },
  {
    "Retail Branding": "MTC",
    "Marketing Name": "Osmartphona",
    "Device": "Osmartphona",
    "Model": "Osmartphona"
  },
  {
    "Retail Branding": "MTC",
    "Marketing Name": "Osmartphona Tablet",
    "Device": "Osmartphona_Tablet",
    "Model": "Osmartphona Tablet"
  },
  {
    "Retail Branding": "MTC",
    "Marketing Name": "S4000-C0C10",
    "Device": "S4000",
    "Model": "S4000-C0C10"
  },
  {
    "Retail Branding": "MTC",
    "Marketing Name": "Sansui",
    "Device": "shilin",
    "Model": "SANSUI4KAndroidTV"
  },
  {
    "Retail Branding": "MTC",
    "Marketing Name": "SmartEver",
    "Device": "seocho",
    "Model": "SmartEver 4K Android TV"
  },
  {
    "Retail Branding": "MTC",
    "Marketing Name": "SmartEver",
    "Device": "shilin",
    "Model": "SmartEver4KAndroidTV"
  },
  {
    "Retail Branding": "MTC",
    "Marketing Name": "Smart_Light",
    "Device": "Smart_Light",
    "Model": "Smart_Light"
  },
  {
    "Retail Branding": "MTC",
    "Marketing Name": "Tesla",
    "Device": "shilin",
    "Model": "Tesla4KAndroidTV"
  },
  {
    "Retail Branding": "MTC",
    "Marketing Name": "VINCENT",
    "Device": "bruno",
    "Model": "VINCENT 2K Android TV"
  },
  {
    "Retail Branding": "MTC",
    "Marketing Name": "VINCENT",
    "Device": "shilin",
    "Model": "VINCENT 4K Android TV"
  },
  {
    "Retail Branding": "MTC",
    "Marketing Name": "Vodafone Smart mini",
    "Device": "Vodafone_875",
    "Model": "MTC 970H"
  },
  {
    "Retail Branding": "MTC",
    "Marketing Name": "WasabiMango",
    "Device": "shilin",
    "Model": "WasabiMango4KAndroidTV"
  },
  {
    "Retail Branding": "MTC",
    "Marketing Name": "chile",
    "Device": "S2000",
    "Model": "S2000-Z0C11"
  },
  {
    "Retail Branding": "MTN",
    "Marketing Name": 5.99,
    "Device": "H6032_MTN",
    "Model": "H6032"
  },
  {
    "Retail Branding": "MTN",
    "Marketing Name": "Alola_Max",
    "Device": "Alola_Max",
    "Model": "Alola_Max"
  },
  {
    "Retail Branding": "MTN",
    "Marketing Name": "G56",
    "Device": "G56",
    "Model": "G56"
  },
  {
    "Retail Branding": "MTN",
    "Marketing Name": "Kabode Max",
    "Device": "H6032_MTN",
    "Model": "Kabode Max"
  },
  {
    "Retail Branding": "MTN",
    "Marketing Name": "MTN",
    "Device": "SEI740DEM",
    "Model": "MTN Smart TV Box"
  },
  {
    "Retail Branding": "MTN",
    "Marketing Name": "MTNsmart Plus",
    "Device": "GH67A1",
    "Model": "GH67A1"
  },
  {
    "Retail Branding": "MTN",
    "Marketing Name": "S5012",
    "Device": "S5012",
    "Model": "S5012"
  },
  {
    "Retail Branding": "MTN",
    "Marketing Name": "Te mi ni",
    "Device": "H6733",
    "Model": "Te mi ni"
  },
  {
    "Retail Branding": "MTN Group",
    "Marketing Name": "5982C3",
    "Device": "MTN-TBW5982C3",
    "Model": "MTN-TBW5982C3"
  },
  {
    "Retail Branding": "MTN Group",
    "Marketing Name": "8978P",
    "Device": "MTN-8978P",
    "Model": "MTN-8978P"
  },
  {
    "Retail Branding": "MTN Group",
    "Marketing Name": "K919",
    "Device": "K919",
    "Model": "K919"
  },
  {
    "Retail Branding": "MTN Group",
    "Marketing Name": "KaChocolate",
    "Device": "KaChocolate",
    "Model": "KaChocolate"
  },
  {
    "Retail Branding": "MTN Group",
    "Marketing Name": "MTN Sm@rt L840",
    "Device": "MTN-L840",
    "Model": "MTN Sm@rt L840"
  },
  {
    "Retail Branding": "MTN Group",
    "Marketing Name": "MTN Sm@rt L860",
    "Device": "MTN-L860",
    "Model": "MTN Sm@rt L860"
  },
  {
    "Retail Branding": "MTN Group",
    "Marketing Name": "MTN Sm@rt L860",
    "Device": "MTN-L860",
    "Model": "MTN-L860"
  },
  {
    "Retail Branding": "MTN Group",
    "Marketing Name": "MTN Smart S730",
    "Device": "MTN-S730",
    "Model": "MTN-S730"
  },
  {
    "Retail Branding": "MTN Group",
    "Marketing Name": "MTN Smart S735",
    "Device": "MTN-S735",
    "Model": "MTN-S735"
  },
  {
    "Retail Branding": "MTN Group",
    "Marketing Name": "MTN Smart S810",
    "Device": "MTN-S810",
    "Model": "MTN-S810"
  },
  {
    "Retail Branding": "MTN Group",
    "Marketing Name": "MTN Steppa 2 LTE",
    "Device": "Steppa2",
    "Model": "MTN Steppa 2 LTE"
  },
  {
    "Retail Branding": "MTN Group",
    "Marketing Name": "MTN sm@rt S750",
    "Device": "MTN_S750",
    "Model": "MTN sm@rt S750"
  },
  {
    "Retail Branding": "MTN Group",
    "Marketing Name": "S620",
    "Device": "MTN-S620",
    "Model": "MTN-S620"
  },
  {
    "Retail Branding": "MTN Group",
    "Marketing Name": "S720i",
    "Device": "MTN-S720i",
    "Model": "MTN-S720i"
  },
  {
    "Retail Branding": "MTN Group",
    "Marketing Name": "Sm@rt Mini S630",
    "Device": "MTN-S630",
    "Model": "MTN-S630"
  },
  {
    "Retail Branding": "MTN Group",
    "Marketing Name": "Sting",
    "Device": "Sting",
    "Model": "Sting"
  },
  {
    "Retail Branding": "MTN-E70",
    "Marketing Name": "MTN-E70",
    "Device": "MTN-E70",
    "Model": "MTN-E70"
  },
  {
    "Retail Branding": "MTR (MY)",
    "Marketing Name": "MT9",
    "Device": "MT9",
    "Model": "MT9"
  },
  {
    "Retail Branding": "MTS (RU)",
    "Marketing Name": "B866",
    "Device": "B866_MTS_IPTV",
    "Model": "B866"
  },
  {
    "Retail Branding": "MTS (RU)",
    "Marketing Name": "B866",
    "Device": "B866_MTS_OTT",
    "Model": "B866"
  },
  {
    "Retail Branding": "MTS (RU)",
    "Marketing Name": "DV8304-C",
    "Device": "DV8304C",
    "Model": "DV8304-C"
  },
  {
    "Retail Branding": "MTS (RU)",
    "Marketing Name": "DV9157-C",
    "Device": "DV9157-C-KRM",
    "Model": "DV9157-C"
  },
  {
    "Retail Branding": "MTS (RU)",
    "Marketing Name": "IPTVSTB",
    "Device": "DV9135-KRM",
    "Model": "DV9135"
  },
  {
    "Retail Branding": "MTS (RU)",
    "Marketing Name": "Smart_Bit",
    "Device": "Smart_Bit",
    "Model": "Smart Bit"
  },
  {
    "Retail Branding": "MTT",
    "Marketing Name": "Master",
    "Device": "Master",
    "Model": "M.T.T. Master"
  },
  {
    "Retail Branding": "MTT",
    "Marketing Name": "Smart Fun",
    "Device": "SmartFun",
    "Model": "M.T.T. Smart Fun"
  },
  {
    "Retail Branding": "MTab",
    "Marketing Name": "MT3",
    "Device": "MT3",
    "Model": "MT3"
  },
  {
    "Retail Branding": "MU (TH)",
    "Marketing Name": 3,
    "Device": 3,
    "Model": 3
  },
  {
    "Retail Branding": "MU (TH)",
    "Marketing Name": 8,
    "Device": 8,
    "Model": 8
  },
  {
    "Retail Branding": "MU (TH)",
    "Marketing Name": "mu 1",
    "Device": "mu_1",
    "Model": 1
  },
  {
    "Retail Branding": "MU (TH)",
    "Marketing Name": "mu6",
    "Device": "mu6",
    "Model": "mu6"
  },
  {
    "Retail Branding": "MUISOO",
    "Marketing Name": "KB10",
    "Device": "KB10",
    "Model": "KB10"
  },
  {
    "Retail Branding": "MUISOO",
    "Marketing Name": "KB10_EEA",
    "Device": "KB10",
    "Model": "KB10"
  },
  {
    "Retail Branding": "MUJENYZ",
    "Marketing Name": "A9",
    "Device": "A9",
    "Model": "A9"
  },
  {
    "Retail Branding": "MULTYNET",
    "Marketing Name": "MULTYNET TV G2K",
    "Device": "dongnae",
    "Model": "MULTYNET TV G2K"
  },
  {
    "Retail Branding": "MULTYNET",
    "Marketing Name": "Pakistan",
    "Device": "marina",
    "Model": "MULTYNET 4K SMART TV"
  },
  {
    "Retail Branding": "MULTYNET",
    "Marketing Name": "Pakistan",
    "Device": "nagata",
    "Model": "MULTYNET 2K SMART TV"
  },
  {
    "Retail Branding": "MULTYNET",
    "Marketing Name": "Pakistan",
    "Device": "tamachi",
    "Model": "MULTYNET FHD Android TV"
  },
  {
    "Retail Branding": "MULTYNET",
    "Marketing Name": "Pakistan",
    "Device": "yeongdeungpo",
    "Model": "MULTYNET UHD Android TV"
  },
  {
    "Retail Branding": "MULTYNET",
    "Marketing Name": "Parkistan",
    "Device": "sepolia",
    "Model": "MULTYNET TV G4K"
  },
  {
    "Retail Branding": "MUNBYN",
    "Marketing Name": "AS01",
    "Device": "AS01",
    "Model": "AS01"
  },
  {
    "Retail Branding": "MUNBYN",
    "Marketing Name": "AS01_EEA",
    "Device": "AS01",
    "Model": "AS01"
  },
  {
    "Retail Branding": "MUNGYO",
    "Marketing Name": "MUNGYO MGEB",
    "Device": "MGEB",
    "Model": "MGEB"
  },
  {
    "Retail Branding": "MYCOM",
    "Marketing Name": "COMEK C10",
    "Device": "COMEK_C10",
    "Model": "COMEK C10"
  },
  {
    "Retail Branding": "MYCOM",
    "Marketing Name": "COMEK smart 10",
    "Device": "COMEK_smart_10",
    "Model": "COMEK smart 10"
  },
  {
    "Retail Branding": "MYCOM",
    "Marketing Name": "COMEKPad",
    "Device": "COMEKPad",
    "Model": "COMEK Tab"
  },
  {
    "Retail Branding": "MYCOM",
    "Marketing Name": "COMEK_Pad10",
    "Device": "COMEK_Pad10",
    "Model": "COMEK Pad 10"
  },
  {
    "Retail Branding": "MYCOM",
    "Marketing Name": "COMEK_Pad_10",
    "Device": "COMEK_Pad_10",
    "Model": "COMEK Pad 10"
  },
  {
    "Retail Branding": "MYCOM",
    "Marketing Name": "COMEK_Tab_10",
    "Device": "COMEK_Tab_10",
    "Model": "COMEK Tab 10"
  },
  {
    "Retail Branding": "MYCOM",
    "Marketing Name": "COMEK_Tab_20",
    "Device": "COMEK_Tab_20",
    "Model": "COMEK Tab 20"
  },
  {
    "Retail Branding": "MaQ(Global)",
    "Marketing Name": "M.AI Phone Gen1",
    "Device": "MAG1",
    "Model": "MA1"
  },
  {
    "Retail Branding": "Mach Speed",
    "Marketing Name": "xtreme",
    "Device": "X_treme_Play_Tab",
    "Model": "X-treme Play Tab"
  },
  {
    "Retail Branding": "MachSpeed (Apollo Brands)",
    "Marketing Name": "STR-9.6-Tablet",
    "Device": "STR_96_Tablet",
    "Model": "STR-9.6-Tablet"
  },
  {
    "Retail Branding": "MachSpeed (Apollo Brands)",
    "Marketing Name": "Trio Stealth_10 Tablet",
    "Device": "D_10AL",
    "Model": "Trio Stealth_10"
  },
  {
    "Retail Branding": "MachSpeed (Apollo Brands)",
    "Marketing Name": "Trio Stealth_8 Tablet",
    "Device": "D_8AL",
    "Model": "Trio Stealth_8"
  },
  {
    "Retail Branding": "MachSpeed (Apollo Brands)",
    "Marketing Name": "Trio Stealth_9 Tablet",
    "Device": "D_9AL",
    "Model": "Trio Stealth_9"
  },
  {
    "Retail Branding": "MachSpeed (Apollo Brands)",
    "Marketing Name": "TrioStealth-7",
    "Device": "TrioStealth-7",
    "Model": "TrioStealth-7"
  },
  {
    "Retail Branding": "Mad Catz",
    "Marketing Name": "M.O.J.O.",
    "Device": "mojo",
    "Model": "Mad Catz M.O.J.O."
  },
  {
    "Retail Branding": "Mafe",
    "Marketing Name": "M8",
    "Device": "M8",
    "Model": "M8"
  },
  {
    "Retail Branding": "Mafe",
    "Marketing Name": "M825",
    "Device": "M825",
    "Model": "M825"
  },
  {
    "Retail Branding": "Mafe",
    "Marketing Name": "M8_Plus",
    "Device": "M8_Plus",
    "Model": "M8_Plus"
  },
  {
    "Retail Branding": "Mafe",
    "Marketing Name": "P2_Power",
    "Device": "P2_Power",
    "Model": "P2_Power"
  },
  {
    "Retail Branding": "Mafe",
    "Marketing Name": "V9",
    "Device": "V9",
    "Model": "V9"
  },
  {
    "Retail Branding": "Mafe",
    "Marketing Name": "Z1",
    "Device": "Z1",
    "Model": "Z1"
  },
  {
    "Retail Branding": "Mafe",
    "Marketing Name": "Z2",
    "Device": "Z2",
    "Model": "Z2"
  },
  {
    "Retail Branding": "Mafe",
    "Marketing Name": "Z7",
    "Device": "Z7",
    "Model": "Z7"
  },
  {
    "Retail Branding": "Magenta TV",
    "Marketing Name": "MagentaTV ONE",
    "Device": "HY44G",
    "Model": "MagentaTV ONE"
  },
  {
    "Retail Branding": "Magenta TV",
    "Marketing Name": "TV Box",
    "Device": "HY44G",
    "Model": "TV Box"
  },
  {
    "Retail Branding": "Magenta TV",
    "Marketing Name": "TV box",
    "Device": "HY44G",
    "Model": "TV Box"
  },
  {
    "Retail Branding": "MagentaTV",
    "Marketing Name": "DV6067Y-T",
    "Device": "DV6067Y_TVStick",
    "Model": "DV6067Y-T"
  },
  {
    "Retail Branding": "MagentaTV",
    "Marketing Name": "MagentaTV ONE",
    "Device": "HY44G",
    "Model": "MagentaTV ONE"
  },
  {
    "Retail Branding": "MagentaTV",
    "Marketing Name": "MagentaTV Stick (2. Gen.)",
    "Device": "IMTM840A",
    "Model": "MagentaTV Stick (2. Generation)"
  },
  {
    "Retail Branding": "MagentaTV",
    "Marketing Name": "OTT-G1",
    "Device": "DV6067Y",
    "Model": "OTT-G1"
  },
  {
    "Retail Branding": "MagentaTV",
    "Marketing Name": "One (2. Generation)",
    "Device": "SEI804DT",
    "Model": "MagentaTV One (2. Generation)"
  },
  {
    "Retail Branding": "Magnavox",
    "Marketing Name": "MMP848",
    "Device": "MMP848",
    "Model": "MMP848"
  },
  {
    "Retail Branding": "Magnavox",
    "Marketing Name": "Smart TV",
    "Device": "dangni",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "MagneticNorth",
    "Marketing Name": "Multiple_Applications_Display_Terminal",
    "Device": "Multiple_Applications_Display_Terminal",
    "Model": "P7"
  },
  {
    "Retail Branding": "Majestic",
    "Marketing Name": "JACK",
    "Device": "JACK",
    "Model": "JACK"
  },
  {
    "Retail Branding": "Majestic",
    "Marketing Name": "JOE",
    "Device": "JOE",
    "Model": "JOE"
  },
  {
    "Retail Branding": "Majestic",
    "Marketing Name": "MAJESTIC 2K Android TV",
    "Device": "lasalle",
    "Model": "MAJESTIC 2K Android TV"
  },
  {
    "Retail Branding": "Majestic",
    "Marketing Name": "MAJESTIC 4K Android TV",
    "Device": "kenton",
    "Model": "MAJESTIC 4K Android TV"
  },
  {
    "Retail Branding": "Majestic",
    "Marketing Name": "TAB 611 3G",
    "Device": "TAB_611_3G",
    "Model": "TAB 611 3G"
  },
  {
    "Retail Branding": "Majestic",
    "Marketing Name": "TAB-714",
    "Device": "TAB-714",
    "Model": "TAB-714"
  },
  {
    "Retail Branding": "Majestic",
    "Marketing Name": "TAB-746",
    "Device": "TAB-746",
    "Model": "TAB-746"
  },
  {
    "Retail Branding": "Majestic",
    "Marketing Name": "TAB_711_4G",
    "Device": "TAB_711_4G",
    "Model": "TAB 711 4G"
  },
  {
    "Retail Branding": "Majestic",
    "Marketing Name": "TAB_720_PLUS",
    "Device": "TAB_720_PLUS",
    "Model": "TAB 720 PLUS"
  },
  {
    "Retail Branding": "Majestic",
    "Marketing Name": "TAB_811_4G",
    "Device": "TAB_811_4G",
    "Model": "TAB_811_4G"
  },
  {
    "Retail Branding": "Majestic",
    "Marketing Name": "TAB_812_4G",
    "Device": "TAB_812_4G",
    "Model": "TAB_812_4G"
  },
  {
    "Retail Branding": "Majestic",
    "Marketing Name": "TAB_814",
    "Device": "TAB_814",
    "Model": "TAB_814"
  },
  {
    "Retail Branding": "Majestic",
    "Marketing Name": "TAB_847_3G",
    "Device": "TAB_847_3G",
    "Model": "TAB_847_3G"
  },
  {
    "Retail Branding": "Majestic",
    "Marketing Name": "TAB_911_3G",
    "Device": "TAB_911_3G",
    "Model": "TAB_911_3G"
  },
  {
    "Retail Branding": "Majestic",
    "Marketing Name": "TAB_912_4G",
    "Device": "TAB_912_4G",
    "Model": "TAB_912_4G"
  },
  {
    "Retail Branding": "Majestic",
    "Marketing Name": "TAB_912_PRO_4G",
    "Device": "TAB_912_PRO_4G",
    "Model": "TAB_912_PRO_4G"
  },
  {
    "Retail Branding": "Majestic",
    "Marketing Name": "TAB_914",
    "Device": "TAB_914",
    "Model": "TAB_914"
  },
  {
    "Retail Branding": "Majestic",
    "Marketing Name": "TAB_915_4G",
    "Device": "TAB_915_4G",
    "Model": "TAB_915_4G"
  },
  {
    "Retail Branding": "Majestic",
    "Marketing Name": "TAB_916_4G",
    "Device": "TAB_916_4G",
    "Model": "TAB_916_4G"
  },
  {
    "Retail Branding": "Majestic",
    "Marketing Name": "TAB_918_PRO_4G",
    "Device": "TAB_918_PRO_4G",
    "Model": "TAB_918_PRO_4G"
  },
  {
    "Retail Branding": "Majestic",
    "Marketing Name": "TAB_920_PLUS_4G",
    "Device": "TAB_920_PLUS_4G",
    "Model": "TAB_920_PLUS_4G"
  },
  {
    "Retail Branding": "Majestic",
    "Marketing Name": "TAB_922_MAX",
    "Device": "TAB_922_MAX",
    "Model": "TAB 922 MAX"
  },
  {
    "Retail Branding": "Making Life Simple",
    "Marketing Name": "Brace",
    "Device": "iQM801",
    "Model": "iQM801"
  },
  {
    "Retail Branding": "Making Life Simple",
    "Marketing Name": "MLS Novel 3G",
    "Device": "iQ181011N",
    "Model": "iQ181011N"
  },
  {
    "Retail Branding": "Making Life Simple",
    "Marketing Name": "MLS iQ1452aN",
    "Device": "iQ1452aN",
    "Model": "iQ1452aN"
  },
  {
    "Retail Branding": "Making Life Simple",
    "Marketing Name": "MLS_iQT800",
    "Device": "iQT800",
    "Model": "iQT800"
  },
  {
    "Retail Branding": "Making Life Simple",
    "Marketing Name": "Stage",
    "Device": "iQM1001",
    "Model": "iQM1001"
  },
  {
    "Retail Branding": "Making Life Simple",
    "Marketing Name": "iQ1012N",
    "Device": "iQ1012N",
    "Model": "iQ1012N"
  },
  {
    "Retail Branding": "Making Life Simple",
    "Marketing Name": "iQ1019N",
    "Device": "IQ1019N",
    "Model": "IQ1019N"
  },
  {
    "Retail Branding": "Making Life Simple",
    "Marketing Name": "iQ1805N",
    "Device": "iQ1805N",
    "Model": "iQ1805N"
  },
  {
    "Retail Branding": "Making Life Simple",
    "Marketing Name": "iQ5011_E",
    "Device": "iQ5011_E",
    "Model": "iQ5011_E"
  },
  {
    "Retail Branding": "Making Life Simple",
    "Marketing Name": "iQ9013_4N",
    "Device": "iQ9013_4N",
    "Model": "iQ9013_4N"
  },
  {
    "Retail Branding": "Making Life Simple",
    "Marketing Name": "iQA27X_E",
    "Device": "iQA27X_E",
    "Model": "iQA27X_E"
  },
  {
    "Retail Branding": "Making Life Simple",
    "Marketing Name": "iQD700",
    "Device": "iQD700",
    "Model": "iQD700"
  },
  {
    "Retail Branding": "Making Life Simple",
    "Marketing Name": "iQE200",
    "Device": "iQE200",
    "Model": "iQE200"
  },
  {
    "Retail Branding": "Making Life Simple",
    "Marketing Name": "iQF 200",
    "Device": "iQF200",
    "Model": "iQF 200"
  },
  {
    "Retail Branding": "Making Life Simple",
    "Marketing Name": "iQGW516",
    "Device": "iQGW516",
    "Model": "iQGW516"
  },
  {
    "Retail Branding": "Making Life Simple",
    "Marketing Name": "iQK700",
    "Device": "iQK700",
    "Model": "iQK700"
  },
  {
    "Retail Branding": "Making Life Simple",
    "Marketing Name": "iQM960",
    "Device": "iQM960",
    "Model": "iQM960"
  },
  {
    "Retail Branding": "Making Life Simple",
    "Marketing Name": "iQR704",
    "Device": "iQR704",
    "Model": "iQR704"
  },
  {
    "Retail Branding": "Making Life Simple",
    "Marketing Name": "iQS300",
    "Device": "iQS300",
    "Model": "iQS300"
  },
  {
    "Retail Branding": "Making Life Simple",
    "Marketing Name": "iQW503",
    "Device": "iQW503",
    "Model": "iQW503"
  },
  {
    "Retail Branding": "Making Life Simple",
    "Marketing Name": "iQW553N",
    "Device": "iQW553N",
    "Model": "iQW553N"
  },
  {
    "Retail Branding": "Making Life Simple",
    "Marketing Name": "iQW603",
    "Device": "iQW603",
    "Model": "iQW603"
  },
  {
    "Retail Branding": "Malata",
    "Marketing Name": "UR5",
    "Device": "UR5",
    "Model": "UR5"
  },
  {
    "Retail Branding": "Malata",
    "Marketing Name": "UR7",
    "Device": "UR7",
    "Model": "UR7"
  },
  {
    "Retail Branding": "Malata",
    "Marketing Name": "UV350",
    "Device": "UV350",
    "Model": "UV350"
  },
  {
    "Retail Branding": "Mango",
    "Marketing Name": "MANGO",
    "Device": "elliniko",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "Mango",
    "Marketing Name": "MANGO",
    "Device": "hongkong",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "Mango",
    "Marketing Name": "MANGO",
    "Device": "jagalchi",
    "Model": "2K SMART TV"
  },
  {
    "Retail Branding": "Mango",
    "Marketing Name": "Mango",
    "Device": "mountbaker",
    "Model": "2K SMART TV"
  },
  {
    "Retail Branding": "Mango",
    "Marketing Name": "Mango_S5",
    "Device": "Mango_S5",
    "Model": "Mango S5"
  },
  {
    "Retail Branding": "Mango",
    "Marketing Name": "Mango_SQ7",
    "Device": "Mango_SQ7",
    "Model": "Mango_SQ7"
  },
  {
    "Retail Branding": "Manta",
    "Marketing Name": "MSP4507",
    "Device": "MSP4507",
    "Model": "MSP4507"
  },
  {
    "Retail Branding": "Mantra",
    "Marketing Name": "MFSTAB",
    "Device": "MFSTAB",
    "Model": "MFSTAB"
  },
  {
    "Retail Branding": "Mantra",
    "Marketing Name": "MFSTABII",
    "Device": "MFSTABII",
    "Model": "MFSTABII"
  },
  {
    "Retail Branding": "Mantra",
    "Marketing Name": "MFSTABIV",
    "Device": "MFSTABIV",
    "Model": "MFSTABIV"
  },
  {
    "Retail Branding": "Mantra",
    "Marketing Name": "MFSTAB_74G",
    "Device": "MFSTAB_74G",
    "Model": "MFSTAB_74G"
  },
  {
    "Retail Branding": "Mantra",
    "Marketing Name": "MISTAB_74G",
    "Device": "MISTAB_74G",
    "Model": "MISTAB_74G"
  },
  {
    "Retail Branding": "Mantra",
    "Marketing Name": "MOXA7",
    "Device": "MOXA7",
    "Model": "MOXA7"
  },
  {
    "Retail Branding": "Mantra",
    "Marketing Name": "MOXA71",
    "Device": "MOXA71",
    "Model": "MOXA71"
  },
  {
    "Retail Branding": "Mantra",
    "Marketing Name": "MOXA7X",
    "Device": "Terminal",
    "Model": "MOXA7X"
  },
  {
    "Retail Branding": "Mantra",
    "Marketing Name": "MTR100",
    "Device": "MTR100",
    "Model": "MTR100"
  },
  {
    "Retail Branding": "Mantra",
    "Marketing Name": "mDESK",
    "Device": "mDESK",
    "Model": "mDESK"
  },
  {
    "Retail Branding": "Mantra",
    "Marketing Name": "mTerminal100",
    "Device": "Start",
    "Model": "Start"
  },
  {
    "Retail Branding": "MarQ",
    "Marketing Name": "DV6067H",
    "Device": "DV6067H",
    "Model": "DV6067H"
  },
  {
    "Retail Branding": "MarQ",
    "Marketing Name": "MarQ",
    "Device": "bangbae",
    "Model": "MarQ 4K Android TV"
  },
  {
    "Retail Branding": "MarQ",
    "Marketing Name": "MarQ",
    "Device": "komagome",
    "Model": "MarQ 2K Android TV"
  },
  {
    "Retail Branding": "MarQ",
    "Marketing Name": "MarQ 4K SMART TV",
    "Device": "SW6H",
    "Model": "MarQ 4K SMART TV"
  },
  {
    "Retail Branding": "MarQ",
    "Marketing Name": "MarQ SMART TV",
    "Device": "umeda",
    "Model": "MarQ SMART TV"
  },
  {
    "Retail Branding": "MarQ",
    "Marketing Name": "MarQ_M3",
    "Device": "GIONEE_MAX",
    "Model": "MarQ_M3"
  },
  {
    "Retail Branding": "Mara Phones",
    "Marketing Name": "MARA Z",
    "Device": "Mara_Z_sprout",
    "Model": "Mara Z"
  },
  {
    "Retail Branding": "Mara Phones",
    "Marketing Name": "Mara  Z1",
    "Device": "Mara_Z1",
    "Model": "Mara Phones Z1"
  },
  {
    "Retail Branding": "Mara Phones",
    "Marketing Name": "Mara Phones R",
    "Device": "MaraPhones_R",
    "Model": "Mara Phones R"
  },
  {
    "Retail Branding": "Mara Phones",
    "Marketing Name": "Mara S",
    "Device": "Mara_S",
    "Model": "Mara S"
  },
  {
    "Retail Branding": "Mara Phones",
    "Marketing Name": "Mara X",
    "Device": "Mara_X_sc",
    "Model": "Mara X"
  },
  {
    "Retail Branding": "Mara Phones",
    "Marketing Name": "Mara X dual",
    "Device": "Mara_X",
    "Model": "Mara X dual"
  },
  {
    "Retail Branding": "Mara Phones",
    "Marketing Name": "Mara X1",
    "Device": "Mara_X1",
    "Model": "Mara Phones X1"
  },
  {
    "Retail Branding": "Mara Phones",
    "Marketing Name": "Mara X1 MT",
    "Device": "Mara_X1_MT",
    "Model": "Mara Phones X1"
  },
  {
    "Retail Branding": "Mara Phones",
    "Marketing Name": "Mara X1 d",
    "Device": "Mara_X1_d",
    "Model": "Mara Phones X1"
  },
  {
    "Retail Branding": "Mara Phones",
    "Marketing Name": "Mara Z d",
    "Device": "Mara_Z_d_sprout",
    "Model": "Mara Z d"
  },
  {
    "Retail Branding": "Mara Phones",
    "Marketing Name": "Mara Z1 MT",
    "Device": "Mara_Z1_MT",
    "Model": "Mara Phones Z1"
  },
  {
    "Retail Branding": "Mara Phones",
    "Marketing Name": "Mara Z1 d",
    "Device": "Mara_Z1_d",
    "Model": "Mara Phones Z1"
  },
  {
    "Retail Branding": "Marcel",
    "Marketing Name": "4K Smart TV",
    "Device": "pioneer",
    "Model": "4K PA Smart TV"
  },
  {
    "Retail Branding": "Marcel",
    "Marketing Name": "Asia, EU (Including UK), Australia, Africa",
    "Device": "guandu",
    "Model": "MARCEL Android TV"
  },
  {
    "Retail Branding": "Marcel",
    "Marketing Name": "EU",
    "Device": "tamachi",
    "Model": "MARCEL Android TV"
  },
  {
    "Retail Branding": "Marcel",
    "Marketing Name": "EU",
    "Device": "yeongdeungpo",
    "Model": "MARCEL Android TV"
  },
  {
    "Retail Branding": "Marcel",
    "Marketing Name": "EU、UK、AP",
    "Device": "martin",
    "Model": "MARCEL Android TV"
  },
  {
    "Retail Branding": "Marcel",
    "Marketing Name": "MARCEL GSMART 2KTV",
    "Device": "umeda",
    "Model": "MARCEL GSMART 2KTV"
  },
  {
    "Retail Branding": "Marcel",
    "Marketing Name": "MARCEL GSMART5.0 2KTV",
    "Device": "beomil",
    "Model": "MARCEL GSMART5.0 2KTV"
  },
  {
    "Retail Branding": "Marcel",
    "Marketing Name": "MARCEL GSMART5.0 4KTV",
    "Device": "eleonas",
    "Model": "MARCEL GSMART5.0 4KTV"
  },
  {
    "Retail Branding": "Marcel",
    "Marketing Name": "MARCEL GSMART5.0 4KTV FF",
    "Device": "eleonas",
    "Model": "MARCEL GSMART5.0 4KTV FF"
  },
  {
    "Retail Branding": "Marcel",
    "Marketing Name": "Smart TV",
    "Device": "alimos",
    "Model": "MARCEL UHD GOOGLE TV 5.0"
  },
  {
    "Retail Branding": "Marcel",
    "Marketing Name": "Smart TV",
    "Device": "dangni",
    "Model": "MARCEL GOOGLE TV5.0"
  },
  {
    "Retail Branding": "Marcel",
    "Marketing Name": "Smart TV",
    "Device": "mateo",
    "Model": "2K US Smart TV"
  },
  {
    "Retail Branding": "MarkaTab",
    "Marketing Name": "Markatab-1",
    "Device": "Markatab-1",
    "Model": "Markatab-1"
  },
  {
    "Retail Branding": "MarkaTab",
    "Marketing Name": "Speadtrum",
    "Device": "Speadtrum",
    "Model": "Speadtrum"
  },
  {
    "Retail Branding": "Marshall",
    "Marketing Name": "London",
    "Device": "KB-1501",
    "Model": "London"
  },
  {
    "Retail Branding": "Marvie",
    "Marketing Name": "MARVIE_CT4",
    "Device": "MARVIE-CT4",
    "Model": "CT4"
  },
  {
    "Retail Branding": "Mascom",
    "Marketing Name": "MASCOM SS289",
    "Device": "MASCOM_SS289",
    "Model": "MASCOM SS289"
  },
  {
    "Retail Branding": "Mascom",
    "Marketing Name": "MASCOM WS517",
    "Device": "MASCOM_WS517",
    "Model": "MASCOM WS517"
  },
  {
    "Retail Branding": "Mascom",
    "Marketing Name": "Mascom_L850",
    "Device": "Mascom_L850",
    "Model": "Mascom_L850"
  },
  {
    "Retail Branding": "Mascom",
    "Marketing Name": "Mascom_S750",
    "Device": "Mascom_S750",
    "Model": "Mascom S750"
  },
  {
    "Retail Branding": "Mason",
    "Marketing Name": "MDQ300",
    "Device": "MDQ300A",
    "Model": "MDQ300"
  },
  {
    "Retail Branding": "Mason",
    "Marketing Name": "MGQ300",
    "Device": "MGQ300A",
    "Model": "MGQ300"
  },
  {
    "Retail Branding": "Masstel",
    "Marketing Name": "Hapi 15",
    "Device": "Masstel_Hapi_15",
    "Model": "Masstel Hapi 15"
  },
  {
    "Retail Branding": "Masstel",
    "Marketing Name": "Hapi_30",
    "Device": "Masstel_Hapi_30",
    "Model": "Masstel Hapi 30"
  },
  {
    "Retail Branding": "Masstel",
    "Marketing Name": "Juno_Q6",
    "Device": "Masstel_Juno_Q6",
    "Model": "Juno Q6"
  },
  {
    "Retail Branding": "Masstel",
    "Marketing Name": "LT52",
    "Device": "Masstel_LT52",
    "Model": "Masstel LT52"
  },
  {
    "Retail Branding": "Masstel",
    "Marketing Name": "Masstel",
    "Device": "Tab10Ultra",
    "Model": "Tab10Ultra"
  },
  {
    "Retail Branding": "Masstel",
    "Marketing Name": "Masstel Juno Q5",
    "Device": "Masstel_Juno_Q5",
    "Model": "Masstel_Juno_Q5"
  },
  {
    "Retail Branding": "Masstel",
    "Marketing Name": "Masstel Juno Q5 Plus",
    "Device": "Masstel_Juno_Q5Plus",
    "Model": "Masstel_Juno_Q5Plus"
  },
  {
    "Retail Branding": "Masstel",
    "Marketing Name": "Masstel Juno Q7",
    "Device": "Masstel_Juno_Q7",
    "Model": "Juno Q7"
  },
  {
    "Retail Branding": "Masstel",
    "Marketing Name": "Masstel Juno S6",
    "Device": "Masstel_Juno_S6",
    "Model": "Masstel_Juno_S6"
  },
  {
    "Retail Branding": "Masstel",
    "Marketing Name": "Masstel Tab 10S",
    "Device": "Masstel_Tab_10S",
    "Model": "Masstel_Tab_10S"
  },
  {
    "Retail Branding": "Masstel",
    "Marketing Name": "Masstel Tab 82",
    "Device": "Masstel_Tab_82",
    "Model": "Masstel_Tab_82"
  },
  {
    "Retail Branding": "Masstel",
    "Marketing Name": "Masstel Tab7",
    "Device": "3G_Tablet_PC",
    "Model": "Masstel Tab7"
  },
  {
    "Retail Branding": "Masstel",
    "Marketing Name": "Masstel Tab8",
    "Device": "Masstel_Tab8",
    "Model": "Masstel Tab8"
  },
  {
    "Retail Branding": "Masstel",
    "Marketing Name": "Masstel_Hapi_20",
    "Device": "Masstel_Hapi_20",
    "Model": "Masstel Hapi 20"
  },
  {
    "Retail Branding": "Masstel",
    "Marketing Name": "Masstel_Juno_Q3",
    "Device": "Masstel_Juno_Q3",
    "Model": "Masstel_Juno_Q3"
  },
  {
    "Retail Branding": "Masstel",
    "Marketing Name": "Masstel_Juno_Q5",
    "Device": "Masstel_Juno_Q5",
    "Model": "Masstel_Juno_Q5"
  },
  {
    "Retail Branding": "Masstel",
    "Marketing Name": "Masstel_S7",
    "Device": "Masstel_S7",
    "Model": "Masstel S7"
  },
  {
    "Retail Branding": "Masstel",
    "Marketing Name": "Masstel_S7",
    "Device": "Masstel_S7",
    "Model": "Masstel_S7"
  },
  {
    "Retail Branding": "Masstel",
    "Marketing Name": "Masstel_S9",
    "Device": "Masstel_S9",
    "Model": "Masstel S9"
  },
  {
    "Retail Branding": "Masstel",
    "Marketing Name": "Masstel_S9",
    "Device": "Masstel_S9",
    "Model": "Masstel_S9"
  },
  {
    "Retail Branding": "Masstel",
    "Marketing Name": "Masstel_Tab10",
    "Device": "Masstel_Tab10",
    "Model": "Masstel Tab10"
  },
  {
    "Retail Branding": "Masstel",
    "Marketing Name": "Masstel_Tab10_4G",
    "Device": "Masstel_Tab10_4G",
    "Model": "Masstel_Tab10_4G"
  },
  {
    "Retail Branding": "Masstel",
    "Marketing Name": "Masstel_Tab10_WiFi",
    "Device": "Masstel_Tab10_WiFi",
    "Model": "Masstel_Tab10_WiFi"
  },
  {
    "Retail Branding": "Masstel",
    "Marketing Name": "Masstel_Tab11_Pro_4G",
    "Device": "Masstel_Tab11_Pro_4G",
    "Model": "Masstel Tab 11 Pro 4G"
  },
  {
    "Retail Branding": "Masstel",
    "Marketing Name": "Masstel_Tab11_Pro_4G",
    "Device": "Masstel_Tab11_Pro_4G",
    "Model": "Masstel Tab11 Pro 4G"
  },
  {
    "Retail Branding": "Masstel",
    "Marketing Name": "Masstel_Tab8_4G",
    "Device": "Masstel_Tab8_4G",
    "Model": "Masstel_Tab8_4G"
  },
  {
    "Retail Branding": "Masstel",
    "Marketing Name": "Masstel_Tab8_Edu",
    "Device": "Masstel_Tab8_Edu",
    "Model": "Masstel Tab8 Edu"
  },
  {
    "Retail Branding": "Masstel",
    "Marketing Name": "Masstel_Tab_10.1Pro",
    "Device": "Masstel_Tab_101Pro",
    "Model": "Tab 10.1Pro"
  },
  {
    "Retail Branding": "Masstel",
    "Marketing Name": "Masstel_Tab_101",
    "Device": "Masstel_Tab_101",
    "Model": "Masstel_Tab_101"
  },
  {
    "Retail Branding": "Masstel",
    "Marketing Name": "Masstel_Tab_104",
    "Device": "Masstel_Tab_104",
    "Model": "Masstel_Tab_104"
  },
  {
    "Retail Branding": "Masstel",
    "Marketing Name": "Masstel_Tab_10E",
    "Device": "Masstel_Tab_10E",
    "Model": "Masstel Tab 10E"
  },
  {
    "Retail Branding": "Masstel",
    "Marketing Name": "Masstel_Tab_10M",
    "Device": "Masstel_Tab_10M",
    "Model": "Masstel Tab"
  },
  {
    "Retail Branding": "Masstel",
    "Marketing Name": "Masstel_Tab_83",
    "Device": "Masstel_Tab_83",
    "Model": "Masstel Tab 83"
  },
  {
    "Retail Branding": "Masstel",
    "Marketing Name": "Masstel_X1",
    "Device": "Masstel_X1",
    "Model": "Masstel X1"
  },
  {
    "Retail Branding": "Masstel",
    "Marketing Name": "Masstel_X5",
    "Device": "Masstel_X5",
    "Model": "Masstel X5"
  },
  {
    "Retail Branding": "Masstel",
    "Marketing Name": "Masstel_X6",
    "Device": "Masstel_X6",
    "Model": "Masstel X6"
  },
  {
    "Retail Branding": "Masstel",
    "Marketing Name": "Masstel_X9",
    "Device": "Masstel_X9",
    "Model": "Masstel_X9"
  },
  {
    "Retail Branding": "Masstel",
    "Marketing Name": "N535",
    "Device": "Masstel_N535",
    "Model": "Masstel N535"
  },
  {
    "Retail Branding": "Masstel",
    "Marketing Name": "Tab10_Edu",
    "Device": "Tab10_Edu",
    "Model": "Masstel Tab10 Edu"
  },
  {
    "Retail Branding": "Masstel",
    "Marketing Name": "Tab10_Edu",
    "Device": "Tab10_EduV2",
    "Model": "Tab10_Edu"
  },
  {
    "Retail Branding": "Masstel",
    "Marketing Name": "Tab11_Ultra_4G",
    "Device": "Tab11_Ultra_4G",
    "Model": "Tab11_Ultra_4G"
  },
  {
    "Retail Branding": "Masstel",
    "Marketing Name": "Tab7LTE",
    "Device": "Masstel_Tab7LTE",
    "Model": "Masstel_Tab7LTE"
  },
  {
    "Retail Branding": "Masstel",
    "Marketing Name": "Tab7Plus",
    "Device": "Tab7Plus",
    "Model": "Tab7Plus"
  },
  {
    "Retail Branding": "Masstel",
    "Marketing Name": "Tab8N",
    "Device": "Tab8N",
    "Model": "Masstel Tab8N"
  },
  {
    "Retail Branding": "Masstel",
    "Marketing Name": "Tab8Pro",
    "Device": "Tab8Pro",
    "Model": "Tab8Pro"
  },
  {
    "Retail Branding": "Masstel",
    "Marketing Name": "Tab8plus",
    "Device": "Tab8Plus",
    "Model": "Tab8Plus"
  },
  {
    "Retail Branding": "Masstel",
    "Marketing Name": "Tab_10A",
    "Device": "Tab_10A",
    "Model": "Masstel Tab 10A"
  },
  {
    "Retail Branding": "Masstel",
    "Marketing Name": "Tab_81",
    "Device": "Tab_81",
    "Model": "Masstel Tab 81"
  },
  {
    "Retail Branding": "Masstel",
    "Marketing Name": "Tab_8A",
    "Device": "Tab_8A",
    "Model": "Masstel Tab 8A"
  },
  {
    "Retail Branding": "Masstel",
    "Marketing Name": "X3",
    "Device": "Masstel_X3",
    "Model": "Masstel X3"
  },
  {
    "Retail Branding": "Masstel",
    "Marketing Name": "X8",
    "Device": "Masstel_X8",
    "Model": "Masstel_X8"
  },
  {
    "Retail Branding": "Master-G",
    "Marketing Name": "4K Smart TV",
    "Device": "pioneer",
    "Model": "4K SA Smart TV"
  },
  {
    "Retail Branding": "Master-G",
    "Marketing Name": "Android TV",
    "Device": "R1",
    "Model": "ATV R1"
  },
  {
    "Retail Branding": "Master-G",
    "Marketing Name": "Android TV",
    "Device": "R2",
    "Model": "ATV R2"
  },
  {
    "Retail Branding": "Master-G",
    "Marketing Name": "Chile, Bolivia,Peru,Argentina",
    "Device": "martin",
    "Model": "MASTER-G Android TV"
  },
  {
    "Retail Branding": "Master-G",
    "Marketing Name": "Chile, Bolivia,Peru,Argentina",
    "Device": "patrick",
    "Model": "MASTER-G Android TV"
  },
  {
    "Retail Branding": "Master-G",
    "Marketing Name": "Chile,Bolivia,Peru",
    "Device": "martin",
    "Model": "MASETR-G Android Monitor"
  },
  {
    "Retail Branding": "Master-G",
    "Marketing Name": "Chile,Bolivia,Peru",
    "Device": "martin",
    "Model": "MASTER-G Android Monitor"
  },
  {
    "Retail Branding": "Master-G",
    "Marketing Name": "MASTER-G",
    "Device": "elliniko",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "Master-G",
    "Marketing Name": "MASTER-G",
    "Device": "lavender",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "Master-G",
    "Marketing Name": "MGTBA10OC",
    "Device": "MGTBA10OC",
    "Model": "MGTBA10OC"
  },
  {
    "Retail Branding": "Master-G",
    "Marketing Name": "MGTBA8OC",
    "Device": "MGTBA8OC",
    "Model": "MGTBA8OC"
  },
  {
    "Retail Branding": "Master-G",
    "Marketing Name": "Master-G",
    "Device": "hongkong",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "Master-G",
    "Marketing Name": "Master-G",
    "Device": "mountbaker",
    "Model": "2K SMART TV"
  },
  {
    "Retail Branding": "Master-G",
    "Marketing Name": "R10G",
    "Device": "R10G",
    "Model": "R10G"
  },
  {
    "Retail Branding": "Master-G",
    "Marketing Name": "R3_GTV",
    "Device": "R3_GTV",
    "Model": "R3G"
  },
  {
    "Retail Branding": "Master-G",
    "Marketing Name": "R4_GTV",
    "Device": "R4_GTV",
    "Model": "R4G"
  },
  {
    "Retail Branding": "Master-G",
    "Marketing Name": "Smart TV",
    "Device": "mateo",
    "Model": "2K SA Smart TV"
  },
  {
    "Retail Branding": "Master-G",
    "Marketing Name": "Smart TV",
    "Device": "osaka",
    "Model": "AI PONT SA"
  },
  {
    "Retail Branding": "MauritiusTelcom",
    "Marketing Name": "HE2704",
    "Device": "MTIPTVBox",
    "Model": "HE2704"
  },
  {
    "Retail Branding": "MauritiusTelcom",
    "Marketing Name": "HP4411",
    "Device": "HY44G",
    "Model": "HP4411"
  },
  {
    "Retail Branding": "Maxcom",
    "Marketing Name": "MS453",
    "Device": "MS453",
    "Model": "MS453"
  },
  {
    "Retail Branding": "Maxcom",
    "Marketing Name": "MS457",
    "Device": "MS457",
    "Model": "MS457"
  },
  {
    "Retail Branding": "Maxcom",
    "Marketing Name": "MS457Orange",
    "Device": "MS457Orange",
    "Model": "MS457Orange"
  },
  {
    "Retail Branding": "Maxcom",
    "Marketing Name": "MS457PLUS",
    "Device": "MS457PLUS",
    "Model": "MS457PLUS"
  },
  {
    "Retail Branding": "Maxcom",
    "Marketing Name": "MS459",
    "Device": "MS459",
    "Model": "MS459"
  },
  {
    "Retail Branding": "Maxcom",
    "Marketing Name": "MS507_STRONG",
    "Device": "MS507_STRONG",
    "Model": "MS507_STRONG"
  },
  {
    "Retail Branding": "Maxcom",
    "Marketing Name": "MS514",
    "Device": "MS514",
    "Model": "MS514"
  },
  {
    "Retail Branding": "Maxcom",
    "Marketing Name": "MS515",
    "Device": "MS515",
    "Model": "MS515"
  },
  {
    "Retail Branding": "Maxcom",
    "Marketing Name": "MS553",
    "Device": "MS553",
    "Model": "MS553"
  },
  {
    "Retail Branding": "Maxcom",
    "Marketing Name": "MS554_eea",
    "Device": "Maxcom_MS554",
    "Model": "MS554"
  },
  {
    "Retail Branding": "Maxcom",
    "Marketing Name": "MS571",
    "Device": "MS571",
    "Model": "MS571"
  },
  {
    "Retail Branding": "Maxcom",
    "Marketing Name": "MS571",
    "Device": "MS571_plus",
    "Model": "MS571"
  },
  {
    "Retail Branding": "Maxcom",
    "Marketing Name": "MS572",
    "Device": "MS572",
    "Model": "MS572"
  },
  {
    "Retail Branding": "Maxcom",
    "Marketing Name": "MS601",
    "Device": "MS601",
    "Model": "MS601"
  },
  {
    "Retail Branding": "Maxcom",
    "Marketing Name": "MS651",
    "Device": "MS651",
    "Model": "MS651"
  },
  {
    "Retail Branding": "Maxcom",
    "Marketing Name": "MS652",
    "Device": "Maxcom_MS652",
    "Model": "MS652"
  },
  {
    "Retail Branding": "Maxcom",
    "Marketing Name": "RS-401",
    "Device": "RS_401",
    "Model": "RS-401"
  },
  {
    "Retail Branding": "Maxfone",
    "Marketing Name": "MAX 1X",
    "Device": "MAX_1X",
    "Model": "MAX 1X"
  },
  {
    "Retail Branding": "Maxfone",
    "Marketing Name": "Maxfone",
    "Device": "Maxfone",
    "Model": "Maxfone"
  },
  {
    "Retail Branding": "Maximus",
    "Marketing Name": "D1",
    "Device": "D1",
    "Model": "Maximus D1"
  },
  {
    "Retail Branding": "Maximus",
    "Marketing Name": "D7",
    "Device": "D7",
    "Model": "D7"
  },
  {
    "Retail Branding": "Maximus",
    "Marketing Name": "G10 max",
    "Device": "G10_max",
    "Model": "G10 max"
  },
  {
    "Retail Branding": "Maximus",
    "Marketing Name": "Noir X",
    "Device": "Noir_X",
    "Model": "Noir X"
  },
  {
    "Retail Branding": "Maximus",
    "Marketing Name": "P1",
    "Device": "MAXIMUS_P1",
    "Model": "P1"
  },
  {
    "Retail Branding": "Maximus",
    "Marketing Name": "P2",
    "Device": "P2",
    "Model": "P2"
  },
  {
    "Retail Branding": "Maximus",
    "Marketing Name": "P3",
    "Device": "P3",
    "Model": "P3"
  },
  {
    "Retail Branding": "Maximus",
    "Marketing Name": "P7",
    "Device": "P7",
    "Model": "P7"
  },
  {
    "Retail Branding": "Maximus",
    "Marketing Name": "P7_Plus",
    "Device": "P7_Plus",
    "Model": "P7 Plus"
  },
  {
    "Retail Branding": "Maximus",
    "Marketing Name": "R1_Pro",
    "Device": "R1_Pro",
    "Model": "R1 Pro"
  },
  {
    "Retail Branding": "Maxis",
    "Marketing Name": "NeXT M2",
    "Device": "VFD610",
    "Model": "VFD 610"
  },
  {
    "Retail Branding": "Maxis",
    "Marketing Name": "NeXT X1",
    "Device": "VFD710",
    "Model": "VFD 710"
  },
  {
    "Retail Branding": "Maxon",
    "Marketing Name": "MAXON_MX4",
    "Device": "Senwa_S40",
    "Model": "MX4"
  },
  {
    "Retail Branding": "Maxon",
    "Marketing Name": "MAXON_MX40_PRO",
    "Device": "MAXON_MX40_PRO",
    "Model": "MX40 PRO"
  },
  {
    "Retail Branding": "Maxon",
    "Marketing Name": "MAXON_MX50_PRO",
    "Device": "MAXON_MX50_PRO",
    "Model": "MX50 PRO"
  },
  {
    "Retail Branding": "Maxon",
    "Marketing Name": "MAXON_MX60PLUS",
    "Device": "MAXON_MX60PLUS",
    "Model": "MX60PLUS"
  },
  {
    "Retail Branding": "Maxon",
    "Marketing Name": "MAXON_MX60_PRO",
    "Device": "MAXON_MX60_PRO",
    "Model": "MX60 PRO"
  },
  {
    "Retail Branding": "Maxon",
    "Marketing Name": "MAXON_MX70PRO",
    "Device": "Acer_AC50",
    "Model": "MX70 PRO"
  },
  {
    "Retail Branding": "Maxon",
    "Marketing Name": "MAXON_MX70_PRO",
    "Device": "MAXON_MX70_PRO",
    "Model": "MX70 PRO"
  },
  {
    "Retail Branding": "Maxon",
    "Marketing Name": "MX50",
    "Device": "Maxon_MX50",
    "Model": "MX50"
  },
  {
    "Retail Branding": "Maxpac",
    "Marketing Name": "Parrot_3G",
    "Device": "Parrot_3G",
    "Model": "Parrot_3G"
  },
  {
    "Retail Branding": "Maxsonic Elite",
    "Marketing Name": "Maxsonic_elite",
    "Device": "stanford",
    "Model": "2K SMART TV"
  },
  {
    "Retail Branding": "Maxsonic Elite",
    "Marketing Name": "Maxsonic_elite",
    "Device": "zhongshan",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "Maxtron",
    "Marketing Name": "MAXTRON Genio",
    "Device": "MAXTRON_Genio",
    "Model": "MAXTRON Genio"
  },
  {
    "Retail Branding": "Maxtron",
    "Marketing Name": "MAXTRON_M2",
    "Device": "MAXTRON_M2",
    "Model": "MAXTRON M2"
  },
  {
    "Retail Branding": "Maxtron",
    "Marketing Name": "S9",
    "Device": "S9",
    "Model": "S9"
  },
  {
    "Retail Branding": "Maxtron",
    "Marketing Name": "smart",
    "Device": "smart",
    "Model": "smart"
  },
  {
    "Retail Branding": "Maxvi",
    "Marketing Name": "MS502_Orion",
    "Device": "MS502_Orion",
    "Model": "MS502_Orion"
  },
  {
    "Retail Branding": "Maxvi",
    "Marketing Name": "Maxvi_MS401",
    "Device": "Maxvi_MS401",
    "Model": "Maxvi_MS401"
  },
  {
    "Retail Branding": "Maxwest",
    "Marketing Name": "ASTRO 10R",
    "Device": "MX-A100RWW",
    "Model": "MX-A10R"
  },
  {
    "Retail Branding": "Maxwest",
    "Marketing Name": "ASTRO 10R",
    "Device": "MX-A101RWW",
    "Model": "MX-A10R"
  },
  {
    "Retail Branding": "Maxwest",
    "Marketing Name": "ASTRO 10R",
    "Device": "MX-A102RWW",
    "Model": "MX-A10R"
  },
  {
    "Retail Branding": "Maxwest",
    "Marketing Name": "ASTRO 10R",
    "Device": "MX-A10R1WW",
    "Model": "MX-A10R"
  },
  {
    "Retail Branding": "Maxwest",
    "Marketing Name": "ASTRO 10R",
    "Device": "MX-A10R2WW",
    "Model": "MX-A10R"
  },
  {
    "Retail Branding": "Maxwest",
    "Marketing Name": "ASTRO 10R",
    "Device": "MX-A10RWW",
    "Model": "MX-A10R"
  },
  {
    "Retail Branding": "Maxwest",
    "Marketing Name": "ASTRO 6T",
    "Device": "MX-A6T",
    "Model": "MX-A6T"
  },
  {
    "Retail Branding": "Maxwest",
    "Marketing Name": "ASTRO A55",
    "Device": "MX-A55WW",
    "Model": "ASTRO A55"
  },
  {
    "Retail Branding": "Maxwest",
    "Marketing Name": "ASTRO A6",
    "Device": "MX-A6UU",
    "Model": "ASTRO A6"
  },
  {
    "Retail Branding": "Maxwest",
    "Marketing Name": "ASTRO A6",
    "Device": "MX-A6WW",
    "Model": "ASTRO A6"
  },
  {
    "Retail Branding": "Maxwest",
    "Marketing Name": "ASTRO A64",
    "Device": "MX-A64",
    "Model": "MX-A64"
  },
  {
    "Retail Branding": "Maxwest",
    "Marketing Name": "ASTRO A65",
    "Device": "MX-A65",
    "Model": "MX-A65"
  },
  {
    "Retail Branding": "Maxwest",
    "Marketing Name": "ASTRO A66",
    "Device": "MX-A66WW",
    "Model": "ASTRO A66"
  },
  {
    "Retail Branding": "Maxwest",
    "Marketing Name": "ASTRO A67",
    "Device": "MX-A67WW",
    "Model": "ASTRO A67"
  },
  {
    "Retail Branding": "Maxwest",
    "Marketing Name": "ASTRO_10",
    "Device": "MX-A10WW",
    "Model": "MX-A10"
  },
  {
    "Retail Branding": "Maxwest",
    "Marketing Name": "ASTRO_10_1",
    "Device": "MX-AA10WW01",
    "Model": "MX-A10"
  },
  {
    "Retail Branding": "Maxwest",
    "Marketing Name": "ASTRO_10_A",
    "Device": "MX-A10WW",
    "Model": "MX-A10"
  },
  {
    "Retail Branding": "Maxwest",
    "Marketing Name": "ASTRO_8",
    "Device": "MX-AA8WW01",
    "Model": "MX-A8"
  },
  {
    "Retail Branding": "Maxwest",
    "Marketing Name": "ASTRO_8R",
    "Device": "MX-A80RWW",
    "Model": "MX-A8R"
  },
  {
    "Retail Branding": "Maxwest",
    "Marketing Name": "ASTRO_A63",
    "Device": "MX-A63",
    "Model": "MX-A63"
  },
  {
    "Retail Branding": "Maxwest",
    "Marketing Name": "ASTRO 8R",
    "Device": "MX-A81RWW",
    "Model": "MX-A8R"
  },
  {
    "Retail Branding": "Maxwest",
    "Marketing Name": "ASTRO 8R",
    "Device": "MX-A82RWW",
    "Model": "MX-A8R"
  },
  {
    "Retail Branding": "Maxwest",
    "Marketing Name": "Astro 4 PRO",
    "Device": "Astro_4_PRO",
    "Model": "Astro 4 PRO"
  },
  {
    "Retail Branding": "Maxwest",
    "Marketing Name": "Astro 4R",
    "Device": "Astro_4R",
    "Model": "Astro 4R"
  },
  {
    "Retail Branding": "Maxwest",
    "Marketing Name": "Astro 4T",
    "Device": "Astro_4T",
    "Model": "Astro 4T"
  },
  {
    "Retail Branding": "Maxwest",
    "Marketing Name": "Astro 5 Go LTE",
    "Device": "Astro_5_GO_LTE",
    "Model": "Astro_5_GO_LTE"
  },
  {
    "Retail Branding": "Maxwest",
    "Marketing Name": "Astro 5 PRO",
    "Device": "Astro_5_PRO",
    "Model": "Astro 5 PRO"
  },
  {
    "Retail Branding": "Maxwest",
    "Marketing Name": "Astro 55T",
    "Device": "Astro_55T",
    "Model": "Astro 55T"
  },
  {
    "Retail Branding": "Maxwest",
    "Marketing Name": "Astro 5N LTE",
    "Device": "Astro_5N_LTE",
    "Model": "Astro_5N_LTE"
  },
  {
    "Retail Branding": "Maxwest",
    "Marketing Name": "Astro 5P",
    "Device": "Astro_5P",
    "Model": "Astro 5P"
  },
  {
    "Retail Branding": "Maxwest",
    "Marketing Name": "Astro 63R",
    "Device": "Astro_63R",
    "Model": "Astro 63R"
  },
  {
    "Retail Branding": "Maxwest",
    "Marketing Name": "Astro 63T",
    "Device": "Astro_63T",
    "Model": "Astro 63T"
  },
  {
    "Retail Branding": "Maxwest",
    "Marketing Name": "Astro 6M",
    "Device": "Astro_6M",
    "Model": "Astro 6M"
  },
  {
    "Retail Branding": "Maxwest",
    "Marketing Name": "Astro 6S",
    "Device": "Astro_6S",
    "Model": "Astro_6S"
  },
  {
    "Retail Branding": "Maxwest",
    "Marketing Name": "Astro 8R",
    "Device": "Astro_8R",
    "Model": "Astro 8R"
  },
  {
    "Retail Branding": "Maxwest",
    "Marketing Name": "Astro 8T",
    "Device": "Astro_8T",
    "Model": "Astro 8T"
  },
  {
    "Retail Branding": "Maxwest",
    "Marketing Name": "Astro_4P",
    "Device": "Astro_4P",
    "Model": "Astro_4P"
  },
  {
    "Retail Branding": "Maxwest",
    "Marketing Name": "Astro_55N_LTE",
    "Device": "Astro_55N_LTE",
    "Model": "Astro 55N LTE"
  },
  {
    "Retail Branding": "Maxwest",
    "Marketing Name": "Astro_55R",
    "Device": "Astro_55R",
    "Model": "Astro 55R"
  },
  {
    "Retail Branding": "Maxwest",
    "Marketing Name": "Astro_5X",
    "Device": "Astro_5X",
    "Model": "Astro 5X"
  },
  {
    "Retail Branding": "Maxwest",
    "Marketing Name": "Astro 5T",
    "Device": "Astro_5T",
    "Model": "Astro 5T"
  },
  {
    "Retail Branding": "Maxwest",
    "Marketing Name": "Astro 8Q",
    "Device": "Astro_8Q",
    "Model": "Astro 8Q"
  },
  {
    "Retail Branding": "Maxwest",
    "Marketing Name": "GRAVITY G6",
    "Device": "GRAVITY_G6",
    "Model": "MX-GG6"
  },
  {
    "Retail Branding": "Maxwest",
    "Marketing Name": "GRAVITY G66",
    "Device": "MX-G66CS",
    "Model": "GRAVITY G66"
  },
  {
    "Retail Branding": "Maxwest",
    "Marketing Name": "GRAVITY G67",
    "Device": "MX-G67WW",
    "Model": "GRAVITY G67"
  },
  {
    "Retail Branding": "Maxwest",
    "Marketing Name": "GRAVITY G68",
    "Device": "MX-GG68WW",
    "Model": "GRAVITY G68"
  },
  {
    "Retail Branding": "Maxwest",
    "Marketing Name": "GRAVITY_G64",
    "Device": "MX-GG128WW",
    "Model": "GRAVITY G64"
  },
  {
    "Retail Branding": "Maxwest",
    "Marketing Name": "GRAVITY_G64",
    "Device": "MX-GG64WW",
    "Model": "GRAVITY G64"
  },
  {
    "Retail Branding": "Maxwest",
    "Marketing Name": "GRAVITY_G65",
    "Device": "MX-GG65",
    "Model": "MX-GG65"
  },
  {
    "Retail Branding": "Maxwest",
    "Marketing Name": "Gravity _55_ GO",
    "Device": "Gravity_55_GO",
    "Model": "Gravity_55_GO"
  },
  {
    "Retail Branding": "Maxwest",
    "Marketing Name": "Gravity_5_GO",
    "Device": "Gravity_5_GO",
    "Model": "Gravity_5_GO"
  },
  {
    "Retail Branding": "Maxwest",
    "Marketing Name": "Gravity_6P",
    "Device": "Gravity_6P",
    "Model": "Gravity_6P"
  },
  {
    "Retail Branding": "Maxwest",
    "Marketing Name": "Gravity_6P_Plus",
    "Device": "Gravity_6P_Plus",
    "Model": "Gravity_6P_Plus"
  },
  {
    "Retail Branding": "Maxwest",
    "Marketing Name": "Gravity_7P",
    "Device": "Gravity_7P",
    "Model": "Gravity_7P"
  },
  {
    "Retail Branding": "Maxwest",
    "Marketing Name": "MAXWEST",
    "Device": "Black765857703671",
    "Model": "AstroPhablet7s"
  },
  {
    "Retail Branding": "Maxwest",
    "Marketing Name": "MAX_TAB_7",
    "Device": "MAX_TAB_7",
    "Model": "MAX_TAB_7"
  },
  {
    "Retail Branding": "Maxwest",
    "Marketing Name": "MX-A4R",
    "Device": "MX-A4R",
    "Model": "MX-A4R"
  },
  {
    "Retail Branding": "Maxwest",
    "Marketing Name": "MX-N62",
    "Device": "MX-NN62WW01",
    "Model": "MX-NN62"
  },
  {
    "Retail Branding": "Maxwest",
    "Marketing Name": "MX-N62",
    "Device": "MX-NN62WW01",
    "Model": "NITRO N62"
  },
  {
    "Retail Branding": "Maxwest",
    "Marketing Name": "MX-N63",
    "Device": "MX-N63",
    "Model": "MX-N63"
  },
  {
    "Retail Branding": "Maxwest",
    "Marketing Name": "Maxwest ASTRO_65T",
    "Device": "MX-A65T",
    "Model": "MX-A65T"
  },
  {
    "Retail Branding": "Maxwest",
    "Marketing Name": "NITRO 55M",
    "Device": "MX-N55MWW",
    "Model": "MX-N55M"
  },
  {
    "Retail Branding": "Maxwest",
    "Marketing Name": "NITRO A55",
    "Device": "MX-NA55",
    "Model": "NITRO A55"
  },
  {
    "Retail Branding": "Maxwest",
    "Marketing Name": "NITRO A65",
    "Device": "MX-NA65",
    "Model": "NITRO A65"
  },
  {
    "Retail Branding": "Maxwest",
    "Marketing Name": "NITRO G55",
    "Device": "MX-G55",
    "Model": "NITRO_G55"
  },
  {
    "Retail Branding": "Maxwest",
    "Marketing Name": "NITRO G56",
    "Device": "MX-NG56",
    "Model": "NITRO G56"
  },
  {
    "Retail Branding": "Maxwest",
    "Marketing Name": "NITRO N6",
    "Device": "MX-NN6",
    "Model": "NITRO N6"
  },
  {
    "Retail Branding": "Maxwest",
    "Marketing Name": "NITRO N65",
    "Device": "MX-N65MM",
    "Model": "NITRO N65"
  },
  {
    "Retail Branding": "Maxwest",
    "Marketing Name": "NITRO N67",
    "Device": "MX-N67MM",
    "Model": "NITRO N67"
  },
  {
    "Retail Branding": "Maxwest",
    "Marketing Name": "NITRO_55S",
    "Device": "MX-N55S",
    "Model": "MX-N55S"
  },
  {
    "Retail Branding": "Maxwest",
    "Marketing Name": "NITRO_G56",
    "Device": "MX-NG56",
    "Model": "NITRO G56"
  },
  {
    "Retail Branding": "Maxwest",
    "Marketing Name": "Nitro 4N LTE",
    "Device": "Nitro_4N_LTE",
    "Model": "Nitro 4N LTE"
  },
  {
    "Retail Branding": "Maxwest",
    "Marketing Name": "Nitro 4X",
    "Device": "Nitro_4X",
    "Model": "Nitro_4X"
  },
  {
    "Retail Branding": "Maxwest",
    "Marketing Name": "Nitro 5 GO",
    "Device": "Nitro_5_GO",
    "Model": "Nitro 5 GO"
  },
  {
    "Retail Branding": "Maxwest",
    "Marketing Name": "Nitro 55A",
    "Device": "Nitro_55A",
    "Model": "Nitro 55A"
  },
  {
    "Retail Branding": "Maxwest",
    "Marketing Name": "Nitro 55E",
    "Device": "Nitro_55E",
    "Model": "MX-N55E"
  },
  {
    "Retail Branding": "Maxwest",
    "Marketing Name": "Nitro 55E",
    "Device": "Nitro_55E",
    "Model": "Nitro 55E"
  },
  {
    "Retail Branding": "Maxwest",
    "Marketing Name": "Nitro 55N",
    "Device": "Nitro_55N",
    "Model": "Nitro 55N"
  },
  {
    "Retail Branding": "Maxwest",
    "Marketing Name": "Nitro 55Q",
    "Device": "Nitro_55Q",
    "Model": "Nitro 55Q"
  },
  {
    "Retail Branding": "Maxwest",
    "Marketing Name": "Nitro 5N",
    "Device": "Nitro_5N",
    "Model": "Nitro_5N"
  },
  {
    "Retail Branding": "Maxwest",
    "Marketing Name": "Nitro 5R",
    "Device": "Nitro_5R",
    "Model": "Nitro_5R"
  },
  {
    "Retail Branding": "Maxwest",
    "Marketing Name": "Nitro_4s_LTE",
    "Device": "Nitro_4s_LTE",
    "Model": "Nitro 4s LTE"
  },
  {
    "Retail Branding": "Maxwest",
    "Marketing Name": "Nitro_55C",
    "Device": "Nitro_55C",
    "Model": "Nitro 55C"
  },
  {
    "Retail Branding": "Maxwest",
    "Marketing Name": "Nitro_55R",
    "Device": "Nitro_55R",
    "Model": "Nitro_55R"
  },
  {
    "Retail Branding": "Maxwest",
    "Marketing Name": "Nitro_5C",
    "Device": "Nitro_5C",
    "Model": "Nitro 5C"
  },
  {
    "Retail Branding": "Maxwest",
    "Marketing Name": "Nitro_5P",
    "Device": "Nitro_5P",
    "Model": "Nitro 5P"
  },
  {
    "Retail Branding": "Maxwest",
    "Marketing Name": "Nitro_5X",
    "Device": "Nitro_5X",
    "Model": "Nitro_5X"
  },
  {
    "Retail Branding": "Maxwest",
    "Marketing Name": "Nitro_7Q",
    "Device": "Nitro_7Q",
    "Model": "Nitro_7Q"
  },
  {
    "Retail Branding": "Maxwest",
    "Marketing Name": "Nitro_8",
    "Device": "Nitro_8",
    "Model": "Nitro 8"
  },
  {
    "Retail Branding": "Maxwest",
    "Marketing Name": "Nitro_Phablet_9s",
    "Device": "Nitro_Phablet_9s",
    "Model": "Nitro_Phablet_9s"
  },
  {
    "Retail Branding": "Maxwest",
    "Marketing Name": "ORBIT_TAB_7",
    "Device": "ORBIT_TAB_7",
    "Model": "ORBIT TAB 7"
  },
  {
    "Retail Branding": "Maxwest",
    "Marketing Name": "PANDA_KIDS_7",
    "Device": "PANDA_KIDS_7",
    "Model": "PANDA_KIDS_7"
  },
  {
    "Retail Branding": "Maxwest",
    "Marketing Name": "Panda_7",
    "Device": "Panda_7",
    "Model": "Panda_7"
  },
  {
    "Retail Branding": "Maxwest",
    "Marketing Name": "Ranger 5",
    "Device": "Ranger_5",
    "Model": "Ranger_5"
  },
  {
    "Retail Branding": "Maxwest",
    "Marketing Name": "TAB-9G",
    "Device": "TAB-9G",
    "Model": "TAB-9G"
  },
  {
    "Retail Branding": "Maxwest",
    "Marketing Name": "TAB_MAX_7",
    "Device": "TAB_MAX_7",
    "Model": "Byybuo"
  },
  {
    "Retail Branding": "Maxwest",
    "Marketing Name": "TAB_MAX_7",
    "Device": "TAB_MAX_7",
    "Model": "TAB_MAX_7"
  },
  {
    "Retail Branding": "Mazda",
    "Marketing Name": "Mazda Connect",
    "Device": "MAZDA_CONNECT_AA_G12",
    "Model": "MAZDA CONNECT"
  },
  {
    "Retail Branding": "Mazda",
    "Marketing Name": "Mazda Connect",
    "Device": "MAZDA_CONNECT_AA_G15",
    "Model": "MAZDA CONNECT"
  },
  {
    "Retail Branding": "Maze_speed",
    "Marketing Name": "M1582C",
    "Device": "M1582C",
    "Model": "M1582C"
  },
  {
    "Retail Branding": "Maze_speed",
    "Marketing Name": "M1582C MAX",
    "Device": "M1582C_MAX",
    "Model": "M1582C_MAX"
  },
  {
    "Retail Branding": "Maze_speed",
    "Marketing Name": "M1586K",
    "Device": "M1586K",
    "Model": "M1586K"
  },
  {
    "Retail Branding": "Maze_speed",
    "Marketing Name": "M1587K",
    "Device": "M1587K",
    "Model": "M1587K"
  },
  {
    "Retail Branding": "Maze_speed",
    "Marketing Name": "M65",
    "Device": "M65P",
    "Model": "M65P"
  },
  {
    "Retail Branding": "Maze_speed",
    "Marketing Name": "M6561",
    "Device": "M6561",
    "Model": "M6561"
  },
  {
    "Retail Branding": "Maze_speed",
    "Marketing Name": "MS5314G",
    "Device": "MS5314G",
    "Model": "MS5314G"
  },
  {
    "Retail Branding": "Maze_speed",
    "Marketing Name": "MS5414G",
    "Device": "MS5414G",
    "Model": "MS5414G"
  },
  {
    "Retail Branding": "Maze_speed",
    "Marketing Name": "MS5424G",
    "Device": "MS5424G",
    "Model": "MS5424G"
  },
  {
    "Retail Branding": "Maze_speed",
    "Marketing Name": "MS5514G",
    "Device": "MS5514G",
    "Model": "MS5514G"
  },
  {
    "Retail Branding": "Maze_speed",
    "Marketing Name": "MS5524G",
    "Device": "MS5524G",
    "Model": "MS5524G"
  },
  {
    "Retail Branding": "Maze_speed",
    "Marketing Name": "MS5528G",
    "Device": "MS5528G",
    "Model": "MS5528G"
  },
  {
    "Retail Branding": "Maze_speed",
    "Marketing Name": "MS5539G",
    "Device": "MS5539G",
    "Model": "MS5539G"
  },
  {
    "Retail Branding": "Maze_speed",
    "Marketing Name": "MS5614G",
    "Device": "MS5614G",
    "Model": "MS5614G"
  },
  {
    "Retail Branding": "Maze_speed",
    "Marketing Name": "MS650G",
    "Device": "MS650G",
    "Model": "MS650G"
  },
  {
    "Retail Branding": "Maze_speed",
    "Marketing Name": "SM4T",
    "Device": "SM4T",
    "Model": "SM4T"
  },
  {
    "Retail Branding": "Maze_speed",
    "Marketing Name": "SSB1000T",
    "Device": "SSB1000T",
    "Model": "SSB1000T"
  },
  {
    "Retail Branding": "Maze_speed",
    "Marketing Name": "SSB1001T",
    "Device": "SSB1001T",
    "Model": "SSB1001T"
  },
  {
    "Retail Branding": "Maze_speed",
    "Marketing Name": "SSB10T323",
    "Device": "SSB10T323",
    "Model": "SSB10T323"
  },
  {
    "Retail Branding": "Maze_speed",
    "Marketing Name": "SSB8C223",
    "Device": "SSB8C223",
    "Model": "SSB8C223"
  },
  {
    "Retail Branding": "Maze_speed",
    "Marketing Name": "SSB8T323",
    "Device": "SSB8T323",
    "Model": "SSB8T323"
  },
  {
    "Retail Branding": "Me_Mobile",
    "Marketing Name": "Grace 9",
    "Device": "Grace_9",
    "Model": "Grace 9"
  },
  {
    "Retail Branding": "MeanIT",
    "Marketing Name": "C4",
    "Device": "C4",
    "Model": "C4"
  },
  {
    "Retail Branding": "MeanIT",
    "Marketing Name": "K17",
    "Device": "K17",
    "Model": "K17"
  },
  {
    "Retail Branding": "MeanIT",
    "Marketing Name": "MTAB32_EEA",
    "Device": "MTAB32_EEA",
    "Model": "meanIT K10"
  },
  {
    "Retail Branding": "MeanIT",
    "Marketing Name": "MeanIt_X30",
    "Device": "MeanIt_X30_EEA",
    "Model": "MeanIt_X30"
  },
  {
    "Retail Branding": "MeanIT",
    "Marketing Name": "PK81",
    "Device": "PK81",
    "Model": "MeanIT PK81"
  },
  {
    "Retail Branding": "MeanIT",
    "Marketing Name": "PK81",
    "Device": "PK81",
    "Model": "PK81"
  },
  {
    "Retail Branding": "MeanIT",
    "Marketing Name": "PP101",
    "Device": "PP101",
    "Model": "PP101"
  },
  {
    "Retail Branding": "MeanIT",
    "Marketing Name": "START_S5",
    "Device": "START_S5",
    "Model": "START_S5"
  },
  {
    "Retail Branding": "MeanIT",
    "Marketing Name": "X3",
    "Device": "X3",
    "Model": "X3"
  },
  {
    "Retail Branding": "MeanIT",
    "Marketing Name": "X5",
    "Device": "Smartphone_X5",
    "Model": "Smartphone_X5"
  },
  {
    "Retail Branding": "MeanIT",
    "Marketing Name": "meanIT C80C81",
    "Device": "meanIT_C80C81",
    "Model": "meanIT_C80C81"
  },
  {
    "Retail Branding": "MeanIT",
    "Marketing Name": "meanIT X4",
    "Device": "meanIT_X4",
    "Model": "meanIT X4"
  },
  {
    "Retail Branding": "MeanIT",
    "Marketing Name": "meanIT-X10",
    "Device": "meanIT-X10",
    "Model": "meanIT X10"
  },
  {
    "Retail Branding": "MeanIT",
    "Marketing Name": "meanIT_C10C11",
    "Device": "meanIT_C10C11",
    "Model": "meanIT_C10C11"
  },
  {
    "Retail Branding": "MeanIT",
    "Marketing Name": "meanIT_K20",
    "Device": "meanIT_K20",
    "Model": "meanIT_K20"
  },
  {
    "Retail Branding": "MeanIT",
    "Marketing Name": "meanIT_K7",
    "Device": "meanIT_K7",
    "Model": "meanIT_K7"
  },
  {
    "Retail Branding": "MeanIT",
    "Marketing Name": "meanIT_X1",
    "Device": "meanIT_X1",
    "Model": "meanIT_X1"
  },
  {
    "Retail Branding": "MeanIT",
    "Marketing Name": "meanIT_X20",
    "Device": "meanIT_X20",
    "Model": "meanIT_X20"
  },
  {
    "Retail Branding": "MeanIT",
    "Marketing Name": "meanIT_X40",
    "Device": "meanIT_X40_EEA",
    "Model": "meanIT_X40"
  },
  {
    "Retail Branding": "MeanIT",
    "Marketing Name": "meanIT_X6",
    "Device": "meanIT_X6",
    "Model": "meanIT_X6"
  },
  {
    "Retail Branding": "MeanIT",
    "Marketing Name": "meanit_K28_EEA",
    "Device": "meanit_K28_EEA",
    "Model": "meanit K28"
  },
  {
    "Retail Branding": "MeanIT",
    "Marketing Name": "meanit_X50_EEA",
    "Device": "meanit_X50_EEA",
    "Model": "meanit X50"
  },
  {
    "Retail Branding": "Meberry",
    "Marketing Name": "M6",
    "Device": "M6",
    "Model": "M6"
  },
  {
    "Retail Branding": "Meberry",
    "Marketing Name": "M6_V_EEA",
    "Device": "M6",
    "Model": "M6"
  },
  {
    "Retail Branding": "Meberry",
    "Marketing Name": "M6_V_EEA",
    "Device": "M6",
    "Model": "M6_EEA"
  },
  {
    "Retail Branding": "Meberry",
    "Marketing Name": "M6_V_US",
    "Device": "M6",
    "Model": "M6"
  },
  {
    "Retail Branding": "Meberry",
    "Marketing Name": "M7",
    "Device": "M7",
    "Model": "M7"
  },
  {
    "Retail Branding": "Meberry",
    "Marketing Name": "M7Pro",
    "Device": "M7Pro",
    "Model": "M7Pro"
  },
  {
    "Retail Branding": "Meberry",
    "Marketing Name": "M7_EEA",
    "Device": "M7_EEA",
    "Model": "M7_EEA"
  },
  {
    "Retail Branding": "Meberry",
    "Marketing Name": "M7_M",
    "Device": "M7_M",
    "Model": "M7_M"
  },
  {
    "Retail Branding": "Meberry",
    "Marketing Name": "M7_US",
    "Device": "M7_US",
    "Model": "M7_US"
  },
  {
    "Retail Branding": "Meberry",
    "Marketing Name": "M7_V_EEA",
    "Device": "M7",
    "Model": "M7"
  },
  {
    "Retail Branding": "Meberry",
    "Marketing Name": "M7_V_EEA",
    "Device": "M7",
    "Model": "M7_EEA"
  },
  {
    "Retail Branding": "Meberry",
    "Marketing Name": "M7_V_US",
    "Device": "M7",
    "Model": "M7"
  },
  {
    "Retail Branding": "Meberry",
    "Marketing Name": "M8_EEA",
    "Device": "M8_EEA",
    "Model": "M8"
  },
  {
    "Retail Branding": "Meberry",
    "Marketing Name": "M8_EEA",
    "Device": "M8_EEA",
    "Model": "M8_EEA"
  },
  {
    "Retail Branding": "Meberry",
    "Marketing Name": "M8_US",
    "Device": "M8_US",
    "Model": "M8_US"
  },
  {
    "Retail Branding": "Mecer",
    "Marketing Name": "101P51C",
    "Device": "101P51C",
    "Model": "101P51C"
  },
  {
    "Retail Branding": "Mecer",
    "Marketing Name": "101P51D",
    "Device": "101P51D",
    "Model": "101P51D"
  },
  {
    "Retail Branding": "Mecer",
    "Marketing Name": "800P31C",
    "Device": "800P31C",
    "Model": "800P31C"
  },
  {
    "Retail Branding": "Mecer",
    "Marketing Name": "800P71D",
    "Device": "800P71D",
    "Model": "800P71D"
  },
  {
    "Retail Branding": "Mecer",
    "Marketing Name": "DX10-66",
    "Device": "DX10-66",
    "Model": "DX10-66"
  },
  {
    "Retail Branding": "Mecer",
    "Marketing Name": "DX10-66-LTE",
    "Device": "DX10-66-LTE",
    "Model": "DX10-66-LTE"
  },
  {
    "Retail Branding": "Mecer",
    "Marketing Name": "M17QF6-3Gplus",
    "Device": "M17QF6-3Gplus",
    "Model": "M17QF6-3Gplus"
  },
  {
    "Retail Branding": "Mecer",
    "Marketing Name": "M17QF6_3G",
    "Device": "M17QF6_3G",
    "Model": "M17QF6_3G"
  },
  {
    "Retail Branding": "Mecer",
    "Marketing Name": "M17QF6_4G",
    "Device": "M17QF6_4G",
    "Model": "M17QF6_4G"
  },
  {
    "Retail Branding": "Mecer",
    "Marketing Name": "M17QF7_4G",
    "Device": "M17QF7_4G",
    "Model": "M17QF7_4G"
  },
  {
    "Retail Branding": "Mecer",
    "Marketing Name": "M17QF8_4G",
    "Device": "M17QF8_4G",
    "Model": "M17QF8_4G"
  },
  {
    "Retail Branding": "Mecer",
    "Marketing Name": "M76QF6",
    "Device": "M76QF6",
    "Model": "M76QF6"
  },
  {
    "Retail Branding": "Mecer",
    "Marketing Name": "M77QF6",
    "Device": "M77QF6",
    "Model": "M77QF6"
  },
  {
    "Retail Branding": "Mecer",
    "Marketing Name": "M785P",
    "Device": "M785P",
    "Model": "M785P"
  },
  {
    "Retail Branding": "Mecer",
    "Marketing Name": "M78QF6-4G",
    "Device": "M78QF6-4G",
    "Model": "M78QF6-4G"
  },
  {
    "Retail Branding": "Mecer",
    "Marketing Name": "M86Q9-3G",
    "Device": "M86Q9-3G",
    "Model": "M86Q9-3G"
  },
  {
    "Retail Branding": "Mecer",
    "Marketing Name": "MF716",
    "Device": "MF716",
    "Model": "MF716"
  },
  {
    "Retail Branding": "Mecer",
    "Marketing Name": "MF716+",
    "Device": "MF716_Plus",
    "Model": "MF716+"
  },
  {
    "Retail Branding": "Mecer",
    "Marketing Name": "MK7000Pro",
    "Device": "MK7000PRO",
    "Model": "MK7000PRO"
  },
  {
    "Retail Branding": "Mecer",
    "Marketing Name": "MW16Q9-3G",
    "Device": "MW16Q9_3G",
    "Model": "MW16Q9_3G"
  },
  {
    "Retail Branding": "Mecer",
    "Marketing Name": "MW16Q9-4G",
    "Device": "MW16Q9_4G",
    "Model": "MW16Q9_4G"
  },
  {
    "Retail Branding": "Mecer",
    "Marketing Name": "TEI11011",
    "Device": "TEI11011MST",
    "Model": "TEI11011MST"
  },
  {
    "Retail Branding": "Mecer",
    "Marketing Name": "TF10EA2",
    "Device": "TF10EA2_11",
    "Model": "TF10EA2"
  },
  {
    "Retail Branding": "Mecer",
    "Marketing Name": "TF10MK1",
    "Device": "TF10MK1_2",
    "Model": "TF10MK1"
  },
  {
    "Retail Branding": "Mecer",
    "Marketing Name": "TF10MK1",
    "Device": "TF10MK1_3",
    "Model": "TF10MK1"
  },
  {
    "Retail Branding": "Mecool",
    "Marketing Name": "KA1",
    "Device": "KA1",
    "Model": "KA1"
  },
  {
    "Retail Branding": "Mecool",
    "Marketing Name": "KA2",
    "Device": "KA2",
    "Model": "KA2"
  },
  {
    "Retail Branding": "Mecool",
    "Marketing Name": "KD1",
    "Device": "KD1",
    "Model": "KD1"
  },
  {
    "Retail Branding": "Mecool",
    "Marketing Name": "KD2",
    "Device": "KD2",
    "Model": "KD2"
  },
  {
    "Retail Branding": "Mecool",
    "Marketing Name": "KD3",
    "Device": "YYT",
    "Model": "4K Google TV Stick"
  },
  {
    "Retail Branding": "Mecool",
    "Marketing Name": "KD5",
    "Device": "BOS",
    "Model": "TV Stick"
  },
  {
    "Retail Branding": "Mecool",
    "Marketing Name": "KM1",
    "Device": "KM1",
    "Model": "KM1"
  },
  {
    "Retail Branding": "Mecool",
    "Marketing Name": "KM2",
    "Device": "LAS",
    "Model": "LEAP-S1"
  },
  {
    "Retail Branding": "Mecool",
    "Marketing Name": "KM2 PLUS",
    "Device": "YYC",
    "Model": "4K Android TV Box"
  },
  {
    "Retail Branding": "Mecool",
    "Marketing Name": "KM3",
    "Device": "KM3",
    "Model": "KM3"
  },
  {
    "Retail Branding": "Mecool",
    "Marketing Name": "KM6",
    "Device": "KM6",
    "Model": "KM6"
  },
  {
    "Retail Branding": "Mecool",
    "Marketing Name": "KM7",
    "Device": "KM7",
    "Model": "KM7"
  },
  {
    "Retail Branding": "Mecool",
    "Marketing Name": "KM7 PLUS",
    "Device": "YDA",
    "Model": "4K Google TV Box"
  },
  {
    "Retail Branding": "Mecool",
    "Marketing Name": "KM8",
    "Device": "KM8",
    "Model": "KM8"
  },
  {
    "Retail Branding": "Mecool",
    "Marketing Name": "KM9PRO",
    "Device": "KM9PRO",
    "Model": "KM9PRO"
  },
  {
    "Retail Branding": "Mecool",
    "Marketing Name": "KM9PRO MAX",
    "Device": "RMQ",
    "Model": "UHD Google TV STB"
  },
  {
    "Retail Branding": "Mecool",
    "Marketing Name": "KT1",
    "Device": "KT1",
    "Model": "KT1"
  },
  {
    "Retail Branding": "Mecool",
    "Marketing Name": "KT2",
    "Device": "ROM",
    "Model": "KT2"
  },
  {
    "Retail Branding": "Mecool",
    "Marketing Name": "MEgo1 2K",
    "Device": "BKK",
    "Model": "FHD Streaming Stick"
  },
  {
    "Retail Branding": "Mecool",
    "Marketing Name": "MEgo1 4K",
    "Device": "KHH",
    "Model": "UHD Google TV Stick"
  },
  {
    "Retail Branding": "Mediabox",
    "Marketing Name": "MBX4K Maverick",
    "Device": "JFK",
    "Model": "MBX4K Maverick"
  },
  {
    "Retail Branding": "Mediabox",
    "Marketing Name": "MBX4K Ranger",
    "Device": "DV8235",
    "Model": "MBX4K Ranger"
  },
  {
    "Retail Branding": "Mediacom",
    "Marketing Name": "10edge",
    "Device": "10edge",
    "Model": "10edge"
  },
  {
    "Retail Branding": "Mediacom",
    "Marketing Name": "1AEC",
    "Device": "1AEC",
    "Model": "1AEC"
  },
  {
    "Retail Branding": "Mediacom",
    "Marketing Name": "1AY",
    "Device": "1AY",
    "Model": "1AY"
  },
  {
    "Retail Branding": "Mediacom",
    "Marketing Name": "1AZ2T",
    "Device": "1AZ2T",
    "Model": "1AZ2T"
  },
  {
    "Retail Branding": "Mediacom",
    "Marketing Name": "1AZ2T",
    "Device": "1AZ2T",
    "Model": "1AZ2TW"
  },
  {
    "Retail Branding": "Mediacom",
    "Marketing Name": "1AZ_EEA",
    "Device": "1AZ",
    "Model": "1AZ_eea"
  },
  {
    "Retail Branding": "Mediacom",
    "Marketing Name": "1BEC_eea",
    "Device": "1BEC_eea",
    "Model": "1BEC"
  },
  {
    "Retail Branding": "Mediacom",
    "Marketing Name": "1BY",
    "Device": "1BY",
    "Model": "1BY"
  },
  {
    "Retail Branding": "Mediacom",
    "Marketing Name": "1CY_EEA",
    "Device": "1CY",
    "Model": "1CY"
  },
  {
    "Retail Branding": "Mediacom",
    "Marketing Name": "1DY",
    "Device": "1DY",
    "Model": "1DY"
  },
  {
    "Retail Branding": "Mediacom",
    "Marketing Name": "1DY4G_eea",
    "Device": "1DY4G_eea",
    "Model": "1DY4G"
  },
  {
    "Retail Branding": "Mediacom",
    "Marketing Name": "1HY4G",
    "Device": "1HY4G",
    "Model": "1HY4G"
  },
  {
    "Retail Branding": "Mediacom",
    "Marketing Name": "1IY4G",
    "Device": "1IY4G",
    "Model": "1IY4G"
  },
  {
    "Retail Branding": "Mediacom",
    "Marketing Name": "7BY",
    "Device": "7BY",
    "Model": "7BY"
  },
  {
    "Retail Branding": "Mediacom",
    "Marketing Name": "7CY_eea",
    "Device": "7CY",
    "Model": "7CY"
  },
  {
    "Retail Branding": "Mediacom",
    "Marketing Name": "7DY_EEA",
    "Device": "7DY",
    "Model": "7DY"
  },
  {
    "Retail Branding": "Mediacom",
    "Marketing Name": "8AY",
    "Device": "8AY",
    "Model": "8AY"
  },
  {
    "Retail Branding": "Mediacom",
    "Marketing Name": "8BY_EEA",
    "Device": "8BY",
    "Model": "8BY"
  },
  {
    "Retail Branding": "Mediacom",
    "Marketing Name": "8CY",
    "Device": "8CY",
    "Model": "8CY"
  },
  {
    "Retail Branding": "Mediacom",
    "Marketing Name": "8DY",
    "Device": "M-SP8DY_EEA",
    "Model": "8DY"
  },
  {
    "Retail Branding": "Mediacom",
    "Marketing Name": "AZIMUT_4",
    "Device": "AZIMUT_4",
    "Model": "AZIMUT_4"
  },
  {
    "Retail Branding": "Mediacom",
    "Marketing Name": "G5M",
    "Device": "M-PPxG5M",
    "Model": "M-PPxG5M"
  },
  {
    "Retail Branding": "Mediacom",
    "Marketing Name": "M-PPAG4",
    "Device": "M-PPAG4",
    "Model": "M-PPAG4"
  },
  {
    "Retail Branding": "Mediacom",
    "Marketing Name": "M-PPxG4P",
    "Device": "G4P",
    "Model": "M-PPxG4P"
  },
  {
    "Retail Branding": "Mediacom",
    "Marketing Name": "M-PPxG5",
    "Device": "M-PPxG5",
    "Model": "M-PPxG5"
  },
  {
    "Retail Branding": "Mediacom",
    "Marketing Name": "M-PPxG7",
    "Device": "M-PPxG7",
    "Model": "M-PPxG7"
  },
  {
    "Retail Branding": "Mediacom",
    "Marketing Name": "M-PPxS5",
    "Device": "M-PPxS5",
    "Model": "M-PPxS5"
  },
  {
    "Retail Branding": "Mediacom",
    "Marketing Name": "M-PPxS5P",
    "Device": "M-PPxS5P",
    "Model": "M-PPxS5P"
  },
  {
    "Retail Branding": "Mediacom",
    "Marketing Name": "M-PPxS6",
    "Device": "M-PPxS6",
    "Model": "M-PPxS6"
  },
  {
    "Retail Branding": "Mediacom",
    "Marketing Name": "M-PPxS6P",
    "Device": "M-PPxS6P",
    "Model": "M-PPxS6P"
  },
  {
    "Retail Branding": "Mediacom",
    "Marketing Name": "M-PPxS7",
    "Device": "M-PPxS7",
    "Model": "M-PPxS7"
  },
  {
    "Retail Branding": "Mediacom",
    "Marketing Name": "M-PPxS7P",
    "Device": "M-PPxS7P",
    "Model": "M-PPxS7P"
  },
  {
    "Retail Branding": "Mediacom",
    "Marketing Name": "M-SP10HXxH",
    "Device": "M-SP10HXxH",
    "Model": "M-SP10HXxH"
  },
  {
    "Retail Branding": "Mediacom",
    "Marketing Name": "M-SP10KID",
    "Device": "M-SP10KID",
    "Model": "SmartKid10"
  },
  {
    "Retail Branding": "Mediacom",
    "Marketing Name": "M-SP10MXHA",
    "Device": "SmartPad",
    "Model": "M-SP10MXHA"
  },
  {
    "Retail Branding": "Mediacom",
    "Marketing Name": "M-SP10MXHL",
    "Device": "M-SP10MXHL",
    "Model": "M-SP10MXHL"
  },
  {
    "Retail Branding": "Mediacom",
    "Marketing Name": "M-SP1AGO3G",
    "Device": "M-SP1AGO3G",
    "Model": "M-SP1AGO3G"
  },
  {
    "Retail Branding": "Mediacom",
    "Marketing Name": "M-SP1AZ2TW_EEA",
    "Device": "M-SP1AZ2TW",
    "Model": "Azimut2"
  },
  {
    "Retail Branding": "Mediacom",
    "Marketing Name": "M-SP1AZ3L",
    "Device": "M-SP1AZ3L",
    "Model": "M-SP1AZ3L"
  },
  {
    "Retail Branding": "Mediacom",
    "Marketing Name": "M-SP1AZ3L2",
    "Device": "M-SP1AZ3L2",
    "Model": "Azimut 3 Lite"
  },
  {
    "Retail Branding": "Mediacom",
    "Marketing Name": "M-SP1AZ3P",
    "Device": "M-SP1AZ3P",
    "Model": "Azimut 3 Pro"
  },
  {
    "Retail Branding": "Mediacom",
    "Marketing Name": "M-SP1AZ3_EEA",
    "Device": "M-SP1AZ3",
    "Model": "M-SP1AZ3"
  },
  {
    "Retail Branding": "Mediacom",
    "Marketing Name": "M-SP1EY",
    "Device": "M-SP1EY_EEA",
    "Model": "1EY"
  },
  {
    "Retail Branding": "Mediacom",
    "Marketing Name": "M-SP1X10",
    "Device": "M-SP1X10",
    "Model": "BT10"
  },
  {
    "Retail Branding": "Mediacom",
    "Marketing Name": "M-SP1X10",
    "Device": "M-SP1X10",
    "Model": "X10"
  },
  {
    "Retail Branding": "Mediacom",
    "Marketing Name": "M-SP7HXAH",
    "Device": "M-SP7HXAH",
    "Model": "M-SP7HXAH"
  },
  {
    "Retail Branding": "Mediacom",
    "Marketing Name": "M-SP7xGO3G",
    "Device": "M-SP7xGO3G",
    "Model": "M-SP7xGO3G"
  },
  {
    "Retail Branding": "Mediacom",
    "Marketing Name": "M-SP8EY",
    "Device": "M-SP8EY",
    "Model": "8EY"
  },
  {
    "Retail Branding": "Mediacom",
    "Marketing Name": "M-SP8GY",
    "Device": "M-SP8GY",
    "Model": "SmartPad iyo8"
  },
  {
    "Retail Branding": "Mediacom",
    "Marketing Name": "M-SP8HXAH",
    "Device": "M-SP8HXAH",
    "Model": "M-SP8HXAH"
  },
  {
    "Retail Branding": "Mediacom",
    "Marketing Name": "M-SP8KID",
    "Device": "M-SP8KID",
    "Model": "M-SP8KID"
  },
  {
    "Retail Branding": "Mediacom",
    "Marketing Name": "M-SP8KID2",
    "Device": "M-SP8KID2",
    "Model": "SmartKid 8"
  },
  {
    "Retail Branding": "Mediacom",
    "Marketing Name": "M-SP8MXA",
    "Device": "SP8MXA",
    "Model": "M-SP8MXA"
  },
  {
    "Retail Branding": "Mediacom",
    "Marketing Name": "SP1AZ4_L",
    "Device": "SP1AZ4_L",
    "Model": "AZIMUT_4_LITE"
  },
  {
    "Retail Branding": "Mediacom",
    "Marketing Name": "SP1AZ4_L",
    "Device": "SP1AZ4_L",
    "Model": "E109GC"
  },
  {
    "Retail Branding": "Mediacom",
    "Marketing Name": "SP1AZ4_L",
    "Device": "SP1AZ4_L",
    "Model": "S700"
  },
  {
    "Retail Branding": "Mediacom",
    "Marketing Name": "SP1AZ4_P",
    "Device": "SP1AZ4_P",
    "Model": "AZIMUT_4_PRO"
  },
  {
    "Retail Branding": "Mediacom",
    "Marketing Name": "SP1AZ4_PL",
    "Device": "SP1AZ4_PL",
    "Model": "AZIMUT 4 PLUS"
  },
  {
    "Retail Branding": "Medion",
    "Marketing Name": "E1050X",
    "Device": "E1050X",
    "Model": "E1050X"
  },
  {
    "Retail Branding": "Medion",
    "Marketing Name": "E1051X",
    "Device": "E1051X",
    "Model": "E1051X"
  },
  {
    "Retail Branding": "Medion",
    "Marketing Name": "E1090X",
    "Device": "E1090X",
    "Model": "LIFETAB E1090X"
  },
  {
    "Retail Branding": "Medion",
    "Marketing Name": "E4502",
    "Device": "E4502",
    "Model": "MEDION E4502"
  },
  {
    "Retail Branding": "Medion",
    "Marketing Name": "E4506",
    "Device": "E4506",
    "Model": "MEDION E4506"
  },
  {
    "Retail Branding": "Medion",
    "Marketing Name": "E4507",
    "Device": "B4570",
    "Model": "B4570"
  },
  {
    "Retail Branding": "Medion",
    "Marketing Name": "E5004",
    "Device": "E5004",
    "Model": "MEDION E5004"
  },
  {
    "Retail Branding": "Medion",
    "Marketing Name": "E5005",
    "Device": "B5060",
    "Model": "B5060"
  },
  {
    "Retail Branding": "Medion",
    "Marketing Name": "E5006/P5006",
    "Device": "B5032",
    "Model": "B5032"
  },
  {
    "Retail Branding": "Medion",
    "Marketing Name": "E5008",
    "Device": "B5070",
    "Model": "B5070"
  },
  {
    "Retail Branding": "Medion",
    "Marketing Name": "E5504",
    "Device": "B5530",
    "Model": "MEDION B5530"
  },
  {
    "Retail Branding": "Medion",
    "Marketing Name": "E691X",
    "Device": "E691X",
    "Model": "E691X"
  },
  {
    "Retail Branding": "Medion",
    "Marketing Name": "E731x",
    "Device": "LIFETAB_E731X",
    "Model": "LIFETAB_E731X"
  },
  {
    "Retail Branding": "Medion",
    "Marketing Name": "LIFETAB E10316",
    "Device": "LIFETAB_E10316",
    "Model": "BOSCH_E10316"
  },
  {
    "Retail Branding": "Medion",
    "Marketing Name": "LIFETAB E10316",
    "Device": "LIFETAB_E10316",
    "Model": "LIFETAB_E10316"
  },
  {
    "Retail Branding": "Medion",
    "Marketing Name": "LIFETAB E10320",
    "Device": "LIFETAB_E10320",
    "Model": "LIFETAB_E10320"
  },
  {
    "Retail Branding": "Medion",
    "Marketing Name": "LIFETAB E10320",
    "Device": "LIFETAB_E10320",
    "Model": "MICROSTAR_E10319"
  },
  {
    "Retail Branding": "Medion",
    "Marketing Name": "LIFETAB E1041X",
    "Device": "E1041X",
    "Model": "E1041X"
  },
  {
    "Retail Branding": "Medion",
    "Marketing Name": "LIFETAB E1042X",
    "Device": "E1042X",
    "Model": "LIFETAB E1042X"
  },
  {
    "Retail Branding": "Medion",
    "Marketing Name": "LIFETAB E1043X",
    "Device": "E1043X",
    "Model": "LIFETAB E1043X"
  },
  {
    "Retail Branding": "Medion",
    "Marketing Name": "LIFETAB E1052X",
    "Device": "E1052X",
    "Model": "LIFETAB E1052X"
  },
  {
    "Retail Branding": "Medion",
    "Marketing Name": "LIFETAB E1053X",
    "Device": "E1053X",
    "Model": "LIFETAB E1053X"
  },
  {
    "Retail Branding": "Medion",
    "Marketing Name": "LIFETAB E1060X",
    "Device": "E1060X",
    "Model": "E1060X"
  },
  {
    "Retail Branding": "Medion",
    "Marketing Name": "LIFETAB E1070X",
    "Device": "E1070X",
    "Model": "LIFETAB E1070X"
  },
  {
    "Retail Branding": "Medion",
    "Marketing Name": "LIFETAB E1071X",
    "Device": "E1071X",
    "Model": "LIFETAB E1071X"
  },
  {
    "Retail Branding": "Medion",
    "Marketing Name": "LIFETAB E1081X",
    "Device": "E1081X",
    "Model": "LIFETAB E1081X"
  },
  {
    "Retail Branding": "Medion",
    "Marketing Name": "LIFETAB E723X",
    "Device": "LIFETAB_E723X",
    "Model": "LIFETAB_E723X"
  },
  {
    "Retail Branding": "Medion",
    "Marketing Name": "LIFETAB E7313",
    "Device": "LIFETAB_E7313",
    "Model": "LIFETAB_E7313"
  },
  {
    "Retail Branding": "Medion",
    "Marketing Name": "LIFETAB E7316",
    "Device": "LIFETAB_E7316",
    "Model": "LIFETAB_E7316"
  },
  {
    "Retail Branding": "Medion",
    "Marketing Name": "LIFETAB E7316",
    "Device": "LIFETAB_E7316",
    "Model": "LIFETAB_S7316"
  },
  {
    "Retail Branding": "Medion",
    "Marketing Name": "LIFETAB E732X",
    "Device": "LIFETAB_E732X",
    "Model": "LIFETAB_E732X"
  },
  {
    "Retail Branding": "Medion",
    "Marketing Name": "LIFETAB E732X",
    "Device": "LIFETAB_E733X",
    "Model": "LIFETAB_E733X"
  },
  {
    "Retail Branding": "Medion",
    "Marketing Name": "LIFETAB E732X",
    "Device": "LIFETAB_E733X",
    "Model": "LIFETAB_S733X"
  },
  {
    "Retail Branding": "Medion",
    "Marketing Name": "LIFETAB P1034X",
    "Device": "lifetab_p1034x",
    "Model": "LIFETAB_P1034X"
  },
  {
    "Retail Branding": "Medion",
    "Marketing Name": "LIFETAB P1075X",
    "Device": "P1075X",
    "Model": "LIFETAB_P1075X"
  },
  {
    "Retail Branding": "Medion",
    "Marketing Name": "LIFETAB P733x",
    "Device": "lifetab_p733x",
    "Model": "LIFETAB_P733X"
  },
  {
    "Retail Branding": "Medion",
    "Marketing Name": "LIFETAB P831X",
    "Device": "lifetab_p831x",
    "Model": "LIFETAB_P831X"
  },
  {
    "Retail Branding": "Medion",
    "Marketing Name": "LIFETAB P831X",
    "Device": "lifetab_p831x",
    "Model": "LIFETAB_P831X.2"
  },
  {
    "Retail Branding": "Medion",
    "Marketing Name": "LIFETAB P891X",
    "Device": "lifetab_p891x",
    "Model": "LIFETAB_P891X"
  },
  {
    "Retail Branding": "Medion",
    "Marketing Name": "LIFETAB P970X",
    "Device": "lifetab_p970x",
    "Model": "LIFETAB_P970X"
  },
  {
    "Retail Branding": "Medion",
    "Marketing Name": "LIFETAB S1032X",
    "Device": "S1032X",
    "Model": "S1032X"
  },
  {
    "Retail Branding": "Medion",
    "Marketing Name": "LIFETAB S1033X",
    "Device": "",
    "Model": ""
  },
  {
    "Retail Branding": "Medion",
    "Marketing Name": "LIFETAB S1033X",
    "Device": "LIFETAB_S1033X",
    "Model": "LIFETAB_S1033X"
  },
  {
    "Retail Branding": "Medion",
    "Marketing Name": "LIFETAB S1034X",
    "Device": "lifetab_s1034x",
    "Model": "LIFETAB_S1034X"
  },
  {
    "Retail Branding": "Medion",
    "Marketing Name": "LIFETAB S785X",
    "Device": "LIFETAB_S785X",
    "Model": "LIFETAB_S785X"
  },
  {
    "Retail Branding": "Medion",
    "Marketing Name": "LIFETAB S786x",
    "Device": "LIFETAB_S786X",
    "Model": "LIFETAB_S786X"
  },
  {
    "Retail Branding": "Medion",
    "Marketing Name": "LIFETAB S831X",
    "Device": "LIFETAB_S831X",
    "Model": "LIFETAB_S831X"
  },
  {
    "Retail Branding": "Medion",
    "Marketing Name": "LIFETAB_S1036X",
    "Device": "lifetab_s1036x",
    "Model": "LIFETAB_S1036X"
  },
  {
    "Retail Branding": "Medion",
    "Marketing Name": "Lifetab P9514",
    "Device": "LIFETAB_P9514",
    "Model": "LIFETAB_P9514"
  },
  {
    "Retail Branding": "Medion",
    "Marketing Name": "Media Base P740X",
    "Device": "P740X",
    "Model": "P740X"
  },
  {
    "Retail Branding": "Medion",
    "Marketing Name": "P1032X",
    "Device": "P1032X",
    "Model": "P1032X"
  },
  {
    "Retail Branding": "Medion",
    "Marketing Name": "P1035X",
    "Device": "P1035X",
    "Model": "P1035X"
  },
  {
    "Retail Branding": "Medion",
    "Marketing Name": "P1050X",
    "Device": "P1050X",
    "Model": "P1040X"
  },
  {
    "Retail Branding": "Medion",
    "Marketing Name": "P1050X",
    "Device": "P1050X",
    "Model": "P1050X"
  },
  {
    "Retail Branding": "Medion",
    "Marketing Name": "P1060X",
    "Device": "P1060X",
    "Model": "P1060X"
  },
  {
    "Retail Branding": "Medion",
    "Marketing Name": "P1060X",
    "Device": "P1060X",
    "Model": "X1060X"
  },
  {
    "Retail Branding": "Medion",
    "Marketing Name": "P1061X",
    "Device": "P1061X",
    "Model": "P1061X"
  },
  {
    "Retail Branding": "Medion",
    "Marketing Name": "P1071X",
    "Device": "P1071X",
    "Model": "LIFETAB P1071X"
  },
  {
    "Retail Branding": "Medion",
    "Marketing Name": "P1091X",
    "Device": "P1091X",
    "Model": "LIFETAB P1091X"
  },
  {
    "Retail Branding": "Medion",
    "Marketing Name": "P4501",
    "Device": "P4501",
    "Model": "P4501"
  },
  {
    "Retail Branding": "Medion",
    "Marketing Name": "P5004",
    "Device": "P5004",
    "Model": "MEDION P5004"
  },
  {
    "Retail Branding": "Medion",
    "Marketing Name": "P5005",
    "Device": "P5005",
    "Model": "MEDION P5005"
  },
  {
    "Retail Branding": "Medion",
    "Marketing Name": "P5015",
    "Device": "P5015",
    "Model": "MEDION P5015"
  },
  {
    "Retail Branding": "Medion",
    "Marketing Name": "P73035",
    "Device": "P72035",
    "Model": "P72035"
  },
  {
    "Retail Branding": "Medion",
    "Marketing Name": "P850X",
    "Device": "P850X",
    "Model": "P850X"
  },
  {
    "Retail Branding": "Medion",
    "Marketing Name": "P851X",
    "Device": "P851X",
    "Model": "P851X"
  },
  {
    "Retail Branding": "Medion",
    "Marketing Name": "P852X",
    "Device": "P852X",
    "Model": "P852X"
  },
  {
    "Retail Branding": "Medion",
    "Marketing Name": "S1035X",
    "Device": "S1035X",
    "Model": "S1035X"
  },
  {
    "Retail Branding": "Medion",
    "Marketing Name": "S5004",
    "Device": "S5004",
    "Model": "MEDION S5004"
  },
  {
    "Retail Branding": "Medion",
    "Marketing Name": "S5504",
    "Device": "B5531",
    "Model": "B5531"
  },
  {
    "Retail Branding": "Medion",
    "Marketing Name": "S7322",
    "Device": "LIFETAB_S732X",
    "Model": "LIFETAB_S732X"
  },
  {
    "Retail Branding": "Medion",
    "Marketing Name": "X1030x",
    "Device": "X1030X",
    "Model": "X1030X"
  },
  {
    "Retail Branding": "Medion",
    "Marketing Name": "X1031X",
    "Device": "X1031X",
    "Model": "X1031X"
  },
  {
    "Retail Branding": "Medion",
    "Marketing Name": "X5520",
    "Device": "B5532",
    "Model": "B5532"
  },
  {
    "Retail Branding": "Medion",
    "Marketing Name": "X6001",
    "Device": "X6001",
    "Model": "MEDION X6001"
  },
  {
    "Retail Branding": "Medion",
    "Marketing Name": "microstar E10319",
    "Device": "E10319",
    "Model": "E10319"
  },
  {
    "Retail Branding": "MegaFon",
    "Marketing Name": "KM8-ATV-MF",
    "Device": "MF8_ATV",
    "Model": "KM8-ATV-MF"
  },
  {
    "Retail Branding": "MegaFon",
    "Marketing Name": "Login 3",
    "Device": "MFLogin3",
    "Model": "MegaFon Login 3"
  },
  {
    "Retail Branding": "MegaFon",
    "Marketing Name": "MFLogin3T",
    "Device": "MFLogin3T",
    "Model": "MFLogin3T"
  },
  {
    "Retail Branding": "MegaFon",
    "Marketing Name": "MFLoginPh",
    "Device": "MFLoginPh",
    "Model": "MFLoginPh"
  },
  {
    "Retail Branding": "MegaFon",
    "Marketing Name": "MS4B",
    "Device": "Viper_LTE",
    "Model": "ALCATEL ONE TOUCH 7030R"
  },
  {
    "Retail Branding": "MegaFon",
    "Marketing Name": "MS4B",
    "Device": "Viper_LTE",
    "Model": "ALCATEL ONE TOUCH 7030Y"
  },
  {
    "Retail Branding": "MegaFon",
    "Marketing Name": "MS4B",
    "Device": "Viper_LTE",
    "Model": "MS4B"
  },
  {
    "Retail Branding": "MegaFon",
    "Marketing Name": "MT3A",
    "Device": "MT3A",
    "Model": "MT3A"
  },
  {
    "Retail Branding": "Megacable",
    "Marketing Name": "Mexico",
    "Device": "B826C-A12_ZTE",
    "Model": "B826C-A12"
  },
  {
    "Retail Branding": "Megacable",
    "Marketing Name": "Mexico",
    "Device": "B866V2_ZTE",
    "Model": "Xview+"
  },
  {
    "Retail Branding": "Megacable",
    "Marketing Name": "OTT Xview AV1",
    "Device": "HP46A",
    "Model": "OTT Xview AV1"
  },
  {
    "Retail Branding": "Megacable",
    "Marketing Name": "OTT Xview+ AV1",
    "Device": "B866V2F",
    "Model": "OTT Xview+ AV1"
  },
  {
    "Retail Branding": "Megacable",
    "Marketing Name": "XView+",
    "Device": "ucw4046meg",
    "Model": "Xview+"
  },
  {
    "Retail Branding": "Megacable",
    "Marketing Name": "XView+",
    "Device": "uiw4059meg",
    "Model": "XView+"
  },
  {
    "Retail Branding": "Megahouse",
    "Marketing Name": "CP-D403",
    "Device": "CP-D403",
    "Model": "CP-D403"
  },
  {
    "Retail Branding": "Megmeet",
    "Marketing Name": "MN_AIO_B",
    "Device": "MN_AIO_B",
    "Model": "MN_AIO_B"
  },
  {
    "Retail Branding": "Meiigoo",
    "Marketing Name": "S8",
    "Device": "MEIIGOO_S8",
    "Model": "S8"
  },
  {
    "Retail Branding": "Meiigoo",
    "Marketing Name": "S9",
    "Device": "S9",
    "Model": "S9"
  },
  {
    "Retail Branding": "Meitu",
    "Marketing Name": "M4",
    "Device": "M4",
    "Model": "Meitu M4"
  },
  {
    "Retail Branding": "Meitu",
    "Marketing Name": "M6",
    "Device": "M6",
    "Model": "MP1503"
  },
  {
    "Retail Branding": "Meitu",
    "Marketing Name": "M8s",
    "Device": "MayaS",
    "Model": "MP1709"
  },
  {
    "Retail Branding": "Meitu",
    "Marketing Name": "MI CC 9 Meitu Edition",
    "Device": "vela",
    "Model": "MI CC 9 Meitu Edition"
  },
  {
    "Retail Branding": "Meitu",
    "Marketing Name": "MI CC 9 Meitu Edition",
    "Device": "vela",
    "Model": "Vela"
  },
  {
    "Retail Branding": "Meitu",
    "Marketing Name": "Maya",
    "Device": "Maya",
    "Model": "MP1603"
  },
  {
    "Retail Branding": "Meitu",
    "Marketing Name": "Meitu T8s",
    "Device": "VictoriaS",
    "Model": "MP1701"
  },
  {
    "Retail Branding": "Meitu",
    "Marketing Name": "Meitu V6",
    "Device": "Vivian",
    "Model": "MP1605"
  },
  {
    "Retail Branding": "Meitu",
    "Marketing Name": "T9",
    "Device": "Melody",
    "Model": "MP1710"
  },
  {
    "Retail Branding": "Meitu",
    "Marketing Name": "T9",
    "Device": "Tiffany",
    "Model": "MP1718"
  },
  {
    "Retail Branding": "Meitu",
    "Marketing Name": "Tiffany",
    "Device": "Tiffany",
    "Model": "MP1718"
  },
  {
    "Retail Branding": "Meitu",
    "Marketing Name": "V4",
    "Device": "V4",
    "Model": "Meitu V4"
  },
  {
    "Retail Branding": "Meitu",
    "Marketing Name": "V4s",
    "Device": "V4s",
    "Model": "Meitu V4s"
  },
  {
    "Retail Branding": "Meitu",
    "Marketing Name": "Victoria",
    "Device": "Victoria",
    "Model": "MP1602"
  },
  {
    "Retail Branding": "Meizu",
    "Marketing Name": 15,
    "Device": 15,
    "Model": 15
  },
  {
    "Retail Branding": "Meizu",
    "Marketing Name": "15 Lite",
    "Device": "15Lite",
    "Model": "15 Lite"
  },
  {
    "Retail Branding": "Meizu",
    "Marketing Name": "15 Plus",
    "Device": "15Plus",
    "Model": "15 Plus"
  },
  {
    "Retail Branding": "Meizu",
    "Marketing Name": 16,
    "Device": 16,
    "Model": 16
  },
  {
    "Retail Branding": "Meizu",
    "Marketing Name": "16 X",
    "Device": "16X",
    "Model": "16 X"
  },
  {
    "Retail Branding": "Meizu",
    "Marketing Name": "16T",
    "Device": "meizu16T",
    "Model": "16T"
  },
  {
    "Retail Branding": "Meizu",
    "Marketing Name": "16s",
    "Device": "16s",
    "Model": "16s"
  },
  {
    "Retail Branding": "Meizu",
    "Marketing Name": "16s pro",
    "Device": "meizu16sPro",
    "Model": "16s Pro"
  },
  {
    "Retail Branding": "Meizu",
    "Marketing Name": "16th",
    "Device": "16th",
    "Model": "16th"
  },
  {
    "Retail Branding": "Meizu",
    "Marketing Name": "16th Plus",
    "Device": "16thPlus",
    "Model": "16th Plus"
  },
  {
    "Retail Branding": "Meizu",
    "Marketing Name": "E3",
    "Device": "MeizuE3",
    "Model": "MEIZU E3"
  },
  {
    "Retail Branding": "Meizu",
    "Marketing Name": "LynkCo Phone Note",
    "Device": "Meizu21Note",
    "Model": "LynkCo Phone Note"
  },
  {
    "Retail Branding": "Meizu",
    "Marketing Name": "LynkCo Phone Pro",
    "Device": "meizu21Pro",
    "Model": "LynkCo Phone Pro"
  },
  {
    "Retail Branding": "Meizu",
    "Marketing Name": "M15",
    "Device": "M15",
    "Model": "M15"
  },
  {
    "Retail Branding": "Meizu",
    "Marketing Name": "M1813",
    "Device": "M1813",
    "Model": "M1813"
  },
  {
    "Retail Branding": "Meizu",
    "Marketing Name": "M1816",
    "Device": "M1816",
    "Model": "M1816"
  },
  {
    "Retail Branding": "Meizu",
    "Marketing Name": "M1822",
    "Device": "M1822",
    "Model": "M1822"
  },
  {
    "Retail Branding": "Meizu",
    "Marketing Name": "M1852",
    "Device": "M1852",
    "Model": "M1852"
  },
  {
    "Retail Branding": "Meizu",
    "Marketing Name": "M6",
    "Device": "meizu_M6",
    "Model": "M6"
  },
  {
    "Retail Branding": "Meizu",
    "Marketing Name": "M6",
    "Device": "meizu_M6",
    "Model": "MEIZU M6"
  },
  {
    "Retail Branding": "Meizu",
    "Marketing Name": "M6 Note",
    "Device": "M6Note",
    "Model": "M6 Note"
  },
  {
    "Retail Branding": "Meizu",
    "Marketing Name": "M6T",
    "Device": "MeizuM6T",
    "Model": "M6T"
  },
  {
    "Retail Branding": "Meizu",
    "Marketing Name": "M6s",
    "Device": "MeizuM6s",
    "Model": "Meizu M6s"
  },
  {
    "Retail Branding": "Meizu",
    "Marketing Name": "M6s",
    "Device": "MeizumbluS6",
    "Model": "Meizu mblu S6"
  },
  {
    "Retail Branding": "Meizu",
    "Marketing Name": "M712C",
    "Device": "M712C",
    "Model": "M712C"
  },
  {
    "Retail Branding": "Meizu",
    "Marketing Name": "M8c",
    "Device": "MeizuM8c",
    "Model": "Meizu M8c"
  },
  {
    "Retail Branding": "Meizu",
    "Marketing Name": "MEIZU 18",
    "Device": "meizu18",
    "Model": "MEIZU 18"
  },
  {
    "Retail Branding": "Meizu",
    "Marketing Name": "MEIZU 18X",
    "Device": "meizu18X",
    "Model": "MEIZU 18X"
  },
  {
    "Retail Branding": "Meizu",
    "Marketing Name": "MEIZU 18s",
    "Device": "meizu18s",
    "Model": "MEIZU 18s"
  },
  {
    "Retail Branding": "Meizu",
    "Marketing Name": "MEIZU 18s Pro",
    "Device": "meizu18sPro",
    "Model": "MEIZU 18s Pro"
  },
  {
    "Retail Branding": "Meizu",
    "Marketing Name": "MEIZU 20 Inf",
    "Device": "meizu20Inf",
    "Model": "MEIZU 20 Inf"
  },
  {
    "Retail Branding": "Meizu",
    "Marketing Name": "MEIZU 20 Inf.sat",
    "Device": "meizu20Infsat",
    "Model": "MEIZU 20 Inf.sat"
  },
  {
    "Retail Branding": "Meizu",
    "Marketing Name": "MEIZU 22",
    "Device": "Meizu22",
    "Model": "MEIZU 22"
  },
  {
    "Retail Branding": "Meizu",
    "Marketing Name": "MEIZU Lucky 08",
    "Device": "MeizuVenus",
    "Model": "MEIZU Lucky 08"
  },
  {
    "Retail Branding": "Meizu",
    "Marketing Name": "MEIZU Note 21",
    "Device": "MEIZU_Note21",
    "Model": "MEIZU Note21"
  },
  {
    "Retail Branding": "Meizu",
    "Marketing Name": "MEIZU Note 21 Pro",
    "Device": "MEIZU_Note21_Pro",
    "Model": "MEIZU Note21 Pro"
  },
  {
    "Retail Branding": "Meizu",
    "Marketing Name": "MEIZU Note21",
    "Device": "MEIZU_Note21",
    "Model": "MEIZU Note21"
  },
  {
    "Retail Branding": "Meizu",
    "Marketing Name": "MEIZU Note21 Pro",
    "Device": "MEIZU_Note21_Pro",
    "Model": "MEIZU Note21 Pro"
  },
  {
    "Retail Branding": "Meizu",
    "Marketing Name": "MEIZU 21 Note",
    "Device": "Meizu21Note",
    "Model": "MEIZU 21 Note"
  },
  {
    "Retail Branding": "Meizu",
    "Marketing Name": "Mblu 21",
    "Device": "MEIZU_mblu",
    "Model": "Mblu 21"
  },
  {
    "Retail Branding": "Meizu",
    "Marketing Name": "Mblu 22",
    "Device": "MEIZU_Mblu22",
    "Model": "Mblu 22"
  },
  {
    "Retail Branding": "Meizu",
    "Marketing Name": "Mblu 22 Pro",
    "Device": "MEIZU_Mblu22Pro",
    "Model": "Mblu 22 Pro"
  },
  {
    "Retail Branding": "Meizu",
    "Marketing Name": "Meizu 6T",
    "Device": "Meizu6T",
    "Model": "Meizu 6T"
  },
  {
    "Retail Branding": "Meizu",
    "Marketing Name": "Meizu S6",
    "Device": "MeizuS6",
    "Model": "M712C"
  },
  {
    "Retail Branding": "Meizu",
    "Marketing Name": "Meizu S6",
    "Device": "MeizuS6",
    "Model": "Meizu S6"
  },
  {
    "Retail Branding": "Meizu",
    "Marketing Name": "Note 22",
    "Device": "MEIZU_Note22",
    "Model": "Note 22"
  },
  {
    "Retail Branding": "Meizu",
    "Marketing Name": "Note9",
    "Device": "Note9",
    "Model": "Note9"
  },
  {
    "Retail Branding": "Meizu",
    "Marketing Name": "PRO 7",
    "Device": "PRO7H",
    "Model": "PRO 7-H"
  },
  {
    "Retail Branding": "Meizu",
    "Marketing Name": "PRO 7",
    "Device": "PRO7S",
    "Model": "PRO 7"
  },
  {
    "Retail Branding": "Meizu",
    "Marketing Name": "PRO 7",
    "Device": "PRO7S",
    "Model": "PRO 7-S"
  },
  {
    "Retail Branding": "Meizu",
    "Marketing Name": "PRO 7 Plus",
    "Device": "PRO7Plus",
    "Model": "PRO 7 Plus"
  },
  {
    "Retail Branding": "Meizu",
    "Marketing Name": "PRO7S",
    "Device": "PRO7S",
    "Model": "PRO 7-S"
  },
  {
    "Retail Branding": "Meizu",
    "Marketing Name": "Polestar Phone",
    "Device": "PolestarPhone",
    "Model": "Polestar Phone"
  },
  {
    "Retail Branding": "Meizu",
    "Marketing Name": "meizu 16Xs",
    "Device": "meizu16Xs",
    "Model": "meizu 16Xs"
  },
  {
    "Retail Branding": "Meizu",
    "Marketing Name": "meizu 17",
    "Device": "meizu17",
    "Model": "meizu 17"
  },
  {
    "Retail Branding": "Meizu",
    "Marketing Name": "meizu 17 Pro",
    "Device": "meizu17Pro",
    "Model": "meizu 17 Pro"
  },
  {
    "Retail Branding": "Meizu",
    "Marketing Name": "meizu 18 Pro",
    "Device": "meizu18Pro",
    "Model": "MEIZU 18 Pro"
  },
  {
    "Retail Branding": "Meizu",
    "Marketing Name": "meizu 20",
    "Device": "meizu20",
    "Model": "MEIZU 20"
  },
  {
    "Retail Branding": "Meizu",
    "Marketing Name": "meizu 20 Pro",
    "Device": "meizu20Pro",
    "Model": "MEIZU 20 Pro"
  },
  {
    "Retail Branding": "Meizu",
    "Marketing Name": "meizu 21",
    "Device": "meizu21",
    "Model": "MEIZU 21"
  },
  {
    "Retail Branding": "Meizu",
    "Marketing Name": "meizu 21 PRO",
    "Device": "meizu21Pro",
    "Model": "MEIZU 21 Pro"
  },
  {
    "Retail Branding": "Meizu",
    "Marketing Name": "meizu C9",
    "Device": "meizuC9",
    "Model": "meizu C9"
  },
  {
    "Retail Branding": "Meizu",
    "Marketing Name": "meizu C9 pro",
    "Device": "meizuC9pro",
    "Model": "meizu C9 pro"
  },
  {
    "Retail Branding": "Meizu",
    "Marketing Name": "meizu M10",
    "Device": "meizuM10",
    "Model": "meizu M10"
  },
  {
    "Retail Branding": "Meizu",
    "Marketing Name": "meizu M6",
    "Device": "meizu_M6",
    "Model": "MEIZU M6"
  },
  {
    "Retail Branding": "Meizu",
    "Marketing Name": "meizu M6 Note",
    "Device": "M6Note",
    "Model": "M6 Note"
  },
  {
    "Retail Branding": "Meizu",
    "Marketing Name": "meizu M8",
    "Device": "meizuM8",
    "Model": "meizu M8"
  },
  {
    "Retail Branding": "Meizu",
    "Marketing Name": "meizu M8 lite",
    "Device": "M8lite",
    "Model": "meizu M8 lite"
  },
  {
    "Retail Branding": "Meizu",
    "Marketing Name": "meizu X8",
    "Device": "X8",
    "Model": "meizu X8"
  },
  {
    "Retail Branding": "Meizu",
    "Marketing Name": "meizu note8",
    "Device": "meizunote8",
    "Model": "meizu note8"
  },
  {
    "Retail Branding": "Meizu",
    "Marketing Name": "meizu note9",
    "Device": "meizunote9",
    "Model": "meizu note9"
  },
  {
    "Retail Branding": "Melefon",
    "Marketing Name": "Good",
    "Device": "Good",
    "Model": "Good"
  },
  {
    "Retail Branding": "Melita",
    "Marketing Name": "Melita-4K-TV",
    "Device": "DV8955C-C-KMM",
    "Model": "DV8955C-C"
  },
  {
    "Retail Branding": "Memorex",
    "Marketing Name": "MTAB-07530A",
    "Device": "MTAB-07530A",
    "Model": "MTAB-07530A"
  },
  {
    "Retail Branding": "Memorex",
    "Marketing Name": "MTAB-0753AK",
    "Device": "MTAB-07535AK",
    "Model": "MTAB-07535AK"
  },
  {
    "Retail Branding": "Memorex",
    "Marketing Name": "MTAB-08530A",
    "Device": "MTAB-08530A",
    "Model": "MTAB-08530A"
  },
  {
    "Retail Branding": "Memorex",
    "Marketing Name": "MTAB-09541AB",
    "Device": "MTAB-09541AB",
    "Model": "MTAB-09541AB"
  },
  {
    "Retail Branding": "Memorex",
    "Marketing Name": "MTAB_PRO_2600",
    "Device": "MTAB_PRO_2600",
    "Model": "MTAB_PRO_2600"
  },
  {
    "Retail Branding": "MengalTab",
    "Marketing Name": "ANZATECH",
    "Device": "Mengaltab_Echague_anzatech",
    "Model": "ANZATECH"
  },
  {
    "Retail Branding": "Mengdash",
    "Marketing Name": "M_Q58",
    "Device": "M_Q58",
    "Model": "M_Q58"
  },
  {
    "Retail Branding": "Mengdash",
    "Marketing Name": "M_Q58_EEA",
    "Device": "M_Q58_EEA",
    "Model": "M_Q58EEA"
  },
  {
    "Retail Branding": "Mengdash",
    "Marketing Name": "M_Q59",
    "Device": "M_Q59",
    "Model": "M_Q59"
  },
  {
    "Retail Branding": "Meswao",
    "Marketing Name": "MES-B3",
    "Device": "MES-B3",
    "Model": "MES-B3"
  },
  {
    "Retail Branding": "MetfoneTVBox",
    "Marketing Name": "MetfoneTVBox",
    "Device": "DV9135-KCM",
    "Model": "MetfoneTVBox"
  },
  {
    "Retail Branding": "Metro",
    "Marketing Name": "E2",
    "Device": "E2",
    "Model": "E2"
  },
  {
    "Retail Branding": "Metro",
    "Marketing Name": "Pro5",
    "Device": "Pro5",
    "Model": "Pro5"
  },
  {
    "Retail Branding": "Metro_Eye",
    "Marketing Name": "M50_L10",
    "Device": "Metro_Eye_M50_L10",
    "Model": "Metro_Eye_M50_L10"
  },
  {
    "Retail Branding": "Mgears",
    "Marketing Name": "Mstick4",
    "Device": "Mstick4-EEA",
    "Model": "Mstick4"
  },
  {
    "Retail Branding": "Mgears",
    "Marketing Name": "Mstick4-EEA",
    "Device": "Mstick4-EEA",
    "Model": "Mstick4-EEA"
  },
  {
    "Retail Branding": "Mgt electric",
    "Marketing Name": "Lumyai",
    "Device": "Lumyai",
    "Model": "Lumyai"
  },
  {
    "Retail Branding": "Mgt electric",
    "Marketing Name": "M2",
    "Device": "M2",
    "Model": "M2"
  },
  {
    "Retail Branding": "Mgt electric",
    "Marketing Name": "MGT_T4",
    "Device": "T4",
    "Model": "T4"
  },
  {
    "Retail Branding": "Mgt electric",
    "Marketing Name": "Super",
    "Device": "Super",
    "Model": "Super"
  },
  {
    "Retail Branding": "Mi",
    "Marketing Name": "Mi 11 X",
    "Device": "aliothin",
    "Model": "M2012K11AI"
  },
  {
    "Retail Branding": "MiBoard",
    "Marketing Name": "MiBoard_RK3576",
    "Device": "MiBoard_RK3576",
    "Model": "MiBoard_RK3576"
  },
  {
    "Retail Branding": "MiTAC",
    "Marketing Name": "N630",
    "Device": "surfing_pro",
    "Model": "N630"
  },
  {
    "Retail Branding": "MiTAC",
    "Marketing Name": "N635",
    "Device": "chiron_pro",
    "Model": "N635"
  },
  {
    "Retail Branding": "MiTAC",
    "Marketing Name": "N635_8",
    "Device": "skating",
    "Model": "N635_8"
  },
  {
    "Retail Branding": "MiTAC",
    "Marketing Name": "N650",
    "Device": "prometheus",
    "Model": "N650"
  },
  {
    "Retail Branding": "MiTAC",
    "Marketing Name": "N651",
    "Device": "centaur",
    "Model": "N651"
  },
  {
    "Retail Branding": "MiTAC",
    "Marketing Name": "N672",
    "Device": "hera_pro",
    "Model": "N672"
  },
  {
    "Retail Branding": "MiTAC",
    "Marketing Name": "hera_pro",
    "Device": "hera_pro",
    "Model": "N672"
  },
  {
    "Retail Branding": "MiTAC",
    "Marketing Name": "hera_pro_eea",
    "Device": "hera_pro",
    "Model": "N672"
  },
  {
    "Retail Branding": "MiTAC",
    "Marketing Name": "phaeton",
    "Device": "phaeton",
    "Model": "N722"
  },
  {
    "Retail Branding": "MicroTouch",
    "Marketing Name": "IDC_Series",
    "Device": "IDC_Series",
    "Model": "IDC_Series"
  },
  {
    "Retail Branding": "MicroTouch",
    "Marketing Name": "M1-101RT-A1",
    "Device": "X10",
    "Model": "M1-101RT-A1"
  },
  {
    "Retail Branding": "MicroTouch",
    "Marketing Name": "M1_IC0_N702",
    "Device": "MACH_10",
    "Model": "MACH_10"
  },
  {
    "Retail Branding": "MicroTouch",
    "Marketing Name": "M1_IC0_N702_MP",
    "Device": "MACH_MP",
    "Model": "MACH_MP"
  },
  {
    "Retail Branding": "MicroTouch",
    "Marketing Name": "M1_IC1_N700_4G",
    "Device": "IDC_Series_4G",
    "Model": "IDC_Series_4G"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "32CAM6SHD",
    "Device": "ikebukuro",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "A110",
    "Device": "s9081",
    "Model": "Micromax A110"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "A111",
    "Device": "A111",
    "Model": "A111"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "A116",
    "Device": "A116",
    "Model": "A116"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "A240",
    "Device": "A240",
    "Model": "A240"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "A27",
    "Device": "A27",
    "Model": "A27"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "A44",
    "Device": "tinnoes13_s7050",
    "Model": "A44"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "A45",
    "Device": "tinnoes73_s8030_2g",
    "Model": "A45"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "A50",
    "Device": "kpt73_gb",
    "Model": "Micromax A50"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "A54",
    "Device": "A54",
    "Model": "A54"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "A56",
    "Device": "A56",
    "Model": "Micromax A56"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "A57",
    "Device": "A57",
    "Model": "A57"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "A57",
    "Device": "A57",
    "Model": "Micromax A57"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "A62",
    "Device": "A62",
    "Model": "Micromax A62"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "A72",
    "Device": "A72",
    "Model": "Micromax A72"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "A73",
    "Device": "A73",
    "Model": "A73"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "A73",
    "Device": "A73",
    "Model": "Micromax A73"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "A75",
    "Device": "A75",
    "Model": "A75"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "A78",
    "Device": "Micromax",
    "Model": "A78"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "A84",
    "Device": "A84",
    "Model": "A84"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "A87",
    "Device": "A87",
    "Model": "A87"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "A87",
    "Device": "A87",
    "Model": "Micromax A87"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "A88",
    "Device": "A88",
    "Model": "A88"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "A89",
    "Device": "A89",
    "Model": "A89"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "A91",
    "Device": "A91",
    "Model": "A91"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "A91",
    "Device": "A91",
    "Model": "Micromax A91"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "ATV R1",
    "Device": "R1",
    "Model": "ATV R1"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "ATV R2",
    "Device": "R2",
    "Model": "ATV R2"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Android TV",
    "Device": "R2",
    "Model": "ATV R2"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "B5 Pro",
    "Device": "B5_Pro",
    "Model": "Micromax B5 Pro"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "B5_RU",
    "Device": "Bharat_5",
    "Model": "Micromax Bharat 5"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "BOLT",
    "Device": "A068",
    "Model": "A068"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "BOLT",
    "Device": "A069",
    "Model": "Micromax A069"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "BOLT",
    "Device": "A24",
    "Model": "Micromax A24"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "BOLT",
    "Device": "A34",
    "Model": "Micromax A34"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "BOLT",
    "Device": "A67",
    "Model": "Micromax A67"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "BOLT",
    "Device": "A69",
    "Model": "Micromax A69"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "BOLT",
    "Device": "A69_IN",
    "Model": "Micromax A69"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "BOLT",
    "Device": "Q332",
    "Model": "Micromax Q332"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "BOLT",
    "Device": "Q338",
    "Model": "Micromax Q338"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Bharat 4",
    "Device": "Q440Plus",
    "Model": "Micromax Q440Plus"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Bharat 5",
    "Device": "Bharat_5",
    "Model": "Micromax Bharat 5"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Bharat 5 Infinity Edition",
    "Device": "Q4204",
    "Model": "Micromax Q4204"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Bharat 5 Plus",
    "Device": "Bharat_5_Plus",
    "Model": "Micromax Bharat 5 Plus"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Bharat Go",
    "Device": "Q437",
    "Model": "Micromax Q437"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Bhart 5 PRO",
    "Device": "Bharat_5_Pro",
    "Model": "B5Pro"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Bolt",
    "Device": "A064",
    "Model": "Micromax A064"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Bolt",
    "Device": "A065",
    "Model": "Micromax A065"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Bolt",
    "Device": "A066",
    "Model": "Micromax A066"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Bolt",
    "Device": "A067",
    "Model": "Micromax A067"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Bolt",
    "Device": "A082",
    "Model": "Micromax A082"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Bolt",
    "Device": "A35",
    "Model": "A35"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Bolt",
    "Device": "A79",
    "Model": "Micromax A79"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Bolt",
    "Device": "A82",
    "Model": "Micromax A82"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Bolt",
    "Device": "AD3520",
    "Model": "Micromax AD3520"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Bolt",
    "Device": "AD4500",
    "Model": "Micromax AD4500"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Bolt",
    "Device": "D200",
    "Model": "Micromax_D200"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Bolt",
    "Device": "D303",
    "Model": "Micromax D303"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Bolt",
    "Device": "D304",
    "Model": "Micromax D304"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Bolt",
    "Device": "D305",
    "Model": "Micromax D305"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Bolt",
    "Device": "D320",
    "Model": "Micromax D320"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Bolt",
    "Device": "D321",
    "Model": "Micromax D321"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Bolt",
    "Device": "D333",
    "Model": "Micromax D333"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Bolt",
    "Device": "D340",
    "Model": "Micromax D340"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Bolt",
    "Device": "Q3001",
    "Model": "Micromax Q3001"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Bolt",
    "Device": "Q301",
    "Model": "Micromax Q301"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Bolt",
    "Device": "Q303",
    "Model": "Micromax Q303"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Bolt",
    "Device": "Q323",
    "Model": "Micromax Q323"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Bolt",
    "Device": "Q324",
    "Model": "Micromax Q324"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Bolt",
    "Device": "Q325",
    "Model": "Micromax Q325"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Bolt",
    "Device": "Q326",
    "Model": "Micromax Q326"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Bolt",
    "Device": "Q331",
    "Model": "Micromax Q331"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Bolt",
    "Device": "Q333",
    "Model": "Micromax Q333"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Bolt",
    "Device": "Q335",
    "Model": "Micromax Q335"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Bolt",
    "Device": "Q336",
    "Model": "Micromax Q336"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Bolt",
    "Device": "Q341",
    "Model": "Micromax Q341"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Bolt",
    "Device": "Q346",
    "Model": "Micromax Q346"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Bolt",
    "Device": "Q381",
    "Model": "Micromax Q381"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Bolt",
    "Device": "Q383",
    "Model": "Micromax Q383"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Bolt",
    "Device": "S300",
    "Model": "Micromax S300"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Bolt",
    "Device": "S301",
    "Model": "Micromax S301"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Bolt",
    "Device": "S302",
    "Model": "Micromax S302"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Bolt Juice",
    "Device": "Q3551",
    "Model": "Micromax Q3551"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Bolt Pace",
    "Device": "Q402",
    "Model": "Micromax Q402"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Bolt Prime 3G",
    "Device": "Q306",
    "Model": "Micromax Q306"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Bolt Q3301",
    "Device": "Q3301",
    "Model": "Micromax Q3301"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Bolt Selfie",
    "Device": "Q424",
    "Model": "Micromax Q424"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Bolt Supreme 4",
    "Device": "Q352",
    "Model": "Micromax Q352"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "CANVAS 2 COLOURS",
    "Device": "A120",
    "Model": "Micromax A120"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "CANVAS 2 PLUS",
    "Device": "A110Q",
    "Model": "A110Q"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "CANVAS 2 PLUS",
    "Device": "s9086b",
    "Model": "Micromax A110Q"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "CANVAS 4",
    "Device": "A210",
    "Model": "A210"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "CANVAS 4",
    "Device": "s9111b",
    "Model": "A210"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "CANVAS B20",
    "Device": "B6546",
    "Model": "B6546"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "CANVAS BEAT",
    "Device": "A114R",
    "Model": "Micromax A114R"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "CANVAS BLAZE",
    "Device": "MT500",
    "Model": "MT500"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "CANVAS DOODLE 3",
    "Device": "MicromaxA102",
    "Model": "Micromax A102"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "CANVAS DUET",
    "Device": "AE90",
    "Model": "Micromax AE90"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "CANVAS DUET 2",
    "Device": "EG111",
    "Model": "Micromax EG111"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "CANVAS ELANZA 2",
    "Device": "A121",
    "Model": "Micromax A121"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "CANVAS ENGAGE",
    "Device": "A091",
    "Model": "Micromax A091"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "CANVAS ENTICE",
    "Device": "A105",
    "Model": "Micromax A105"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "CANVAS GOLD",
    "Device": "A300",
    "Model": "Micromax A300"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "CANVAS KNIGHT",
    "Device": "A350",
    "Model": "Micromax A350"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "CANVAS KNIGHT",
    "Device": "s9320ae",
    "Model": "Micromax A350"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "CANVAS MAGNUS",
    "Device": "s9203",
    "Model": "Micromax A117"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "CANVAS POWER",
    "Device": "A96",
    "Model": "Micromax A96"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "CANVAS TUBE",
    "Device": "A118R",
    "Model": "Micromax A118R"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "CANVAS TURBO",
    "Device": "A250",
    "Model": "A250"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "CANVAS TURBO",
    "Device": "s9311",
    "Model": "A250"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "CANVAS TURBO MINI",
    "Device": "s8513a",
    "Model": "Micromax A200"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "CANVAS UNITE 2",
    "Device": "A106",
    "Model": "Micromax A106"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Canvas 2",
    "Device": "Q4310",
    "Model": "Micromax Q4310"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Canvas 4+",
    "Device": "A315",
    "Model": "Micromax A315"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Canvas 5",
    "Device": "E481",
    "Model": "Micromax E481"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Canvas 5 Lite",
    "Device": "Q463",
    "Model": "Micromax Q463"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Canvas 6",
    "Device": "E485",
    "Model": "Micromax E485"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Canvas 6 Pro",
    "Device": "E484",
    "Model": "Micromax E484"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Canvas A1",
    "Device": "AQ4501_sprout",
    "Model": "Micromax AQ4501"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Canvas A1",
    "Device": "AQ4502_sprout",
    "Model": "Micromax AQ4502"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Canvas AMAZE",
    "Device": "Q395",
    "Model": "Micromax Q395"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Canvas Blaze",
    "Device": "Q400",
    "Model": "Micromax Q400"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Canvas Blaze 4G Plus",
    "Device": "Q414",
    "Model": "Micromax Q414"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Canvas Doodle4",
    "Device": "Q391",
    "Model": "Micromax Q391"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Canvas Evok",
    "Device": "E483",
    "Model": "Micromax E483"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Canvas FIRE4G",
    "Device": "Q411",
    "Model": "Micromax Q411"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Canvas Fashion 3G",
    "Device": "Q3502",
    "Model": "Micromax Q3502"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Canvas Fire",
    "Device": "A093",
    "Model": "Micromax A093"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Canvas Fire",
    "Device": "A104",
    "Model": "Micromax A104"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Canvas Fire 4G",
    "Device": "Q462",
    "Model": "Micromax Q462"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Canvas Fire 5",
    "Device": "Q386",
    "Model": "Micromax Q386"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Canvas Fire 6",
    "Device": "Q428",
    "Model": "Micromax Q428"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Canvas Fire3",
    "Device": "A096",
    "Model": "Micromax A096"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Canvas Fire4",
    "Device": "A107",
    "Model": "Micromax A107"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Canvas Fun",
    "Device": "A76",
    "Model": "Micromax A76"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Canvas HD Plus",
    "Device": "A190",
    "Model": "Micromax A190"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Canvas Hue",
    "Device": "AQ5000",
    "Model": "Micromax AQ5000"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Canvas Hue 2",
    "Device": "A316",
    "Model": "Micromax A316"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Canvas Infinity",
    "Device": "HS2",
    "Model": "Micromax HS2"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Canvas Infinity Life",
    "Device": "HS1",
    "Model": "Micromax HS1"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Canvas Infinity Pro",
    "Device": "HS3",
    "Model": "Micromax_HS3"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Canvas Juice",
    "Device": "A77",
    "Model": "Micromax A77"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Canvas Juice 3+",
    "Device": "Q394",
    "Model": "Micromax Q394"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Canvas Juice 4",
    "Device": "Q382",
    "Model": "Micromax Q382"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Canvas Juice 4G",
    "Device": "Q461",
    "Model": "Micromax Q461"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Canvas Juice 6",
    "Device": "Q398",
    "Model": "Micromax Q398"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Canvas Juice2",
    "Device": "AQ5001",
    "Model": "Micromax AQ5001"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Canvas Juice3",
    "Device": "Q392",
    "Model": "Micromax Q392"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Canvas Knight Cameo",
    "Device": "A290",
    "Model": "Micromax A290"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Canvas Knight2",
    "Device": "KNIGHT2",
    "Model": "Micromax E471"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Canvas L",
    "Device": "A108",
    "Model": "Micromax A108"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Canvas Magnus",
    "Device": "A117",
    "Model": "Micromax A117"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Canvas Magnus HD",
    "Device": "Q421",
    "Model": "Micromax Q421"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Canvas Mega",
    "Device": "E353",
    "Model": "Micromax E353"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Canvas Mega",
    "Device": "Q417",
    "Model": "Micromax Q417"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Canvas Mega 2",
    "Device": "Q426",
    "Model": "Micromax Q426"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Canvas Nitro",
    "Device": "A310",
    "Model": "Micromax A310"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Canvas Nitro",
    "Device": "A311",
    "Model": "Micromax A311"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Canvas Nitro2",
    "Device": "E311",
    "Model": "Micromax E311"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Canvas Pace 4G",
    "Device": "Q416",
    "Model": "Micromax Q416"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Canvas Pace MIni",
    "Device": "Q401",
    "Model": "Micromax Q401"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Canvas Pep",
    "Device": "Q370",
    "Model": "Micromax Q370"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Canvas Pep",
    "Device": "Q371",
    "Model": "Micromax Q371"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Canvas Pep",
    "Device": "Q375",
    "Model": "Micromax Q375"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Canvas Play",
    "Device": "Q355",
    "Model": "Micromax Q355"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Canvas Play 4G",
    "Device": "Q412",
    "Model": "Micromax Q412"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Canvas Play4G",
    "Device": "Q469",
    "Model": "Micromax Q469"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Canvas Pulse",
    "Device": "E451",
    "Model": "Micromax E451"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Canvas SPARK2",
    "Device": "Q334",
    "Model": "Micromax Q334"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Canvas Selfie",
    "Device": "A255",
    "Model": "Micromax A255"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Canvas Selfie 4",
    "Device": "Q349",
    "Model": "Micromax Q349"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Canvas Selfie Lens",
    "Device": "Q345",
    "Model": "Micromax Q345"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Canvas Space 2",
    "Device": "Q480",
    "Model": "Micromax Q480"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Canvas Space 2+",
    "Device": "Q479",
    "Model": "Micromax Q479"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Canvas Spark",
    "Device": "Q380",
    "Model": "Micromax Q380"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Canvas Spark 2 Plus",
    "Device": "Q350",
    "Model": "Micromax Q350"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Canvas Spark 3",
    "Device": "Q380N",
    "Model": "Micromax Q380N"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Canvas Spark 3",
    "Device": "Q385",
    "Model": "Micromax Q385"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Canvas Spark 4G",
    "Device": "Q4201",
    "Model": "Micromax Q4201"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Canvas Tab",
    "Device": "F666",
    "Model": "MicromaxF666"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Canvas Tab",
    "Device": "P480",
    "Model": "MicromaxP480"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Canvas Tab",
    "Device": "P480",
    "Model": "P480"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Canvas Tab",
    "Device": "P681",
    "Model": "Micromax P681"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Canvas Tab",
    "Device": "P690",
    "Model": "Micromax P690"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Canvas Tab",
    "Device": "P701",
    "Model": "Micromax P701"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Canvas Tab",
    "Device": "P702",
    "Model": "MicromaxP702"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Canvas Tab",
    "Device": "P70221",
    "Model": "P70221"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Canvas Tab",
    "Device": "P802",
    "Model": "MicromaxP802"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Canvas Tab",
    "Device": "P810",
    "Model": "Micromax P810"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Canvas Tabby",
    "Device": "P469",
    "Model": "P469"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Canvas Turbo",
    "Device": "A250",
    "Model": "Micromax A250"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Canvas Unite 4",
    "Device": "Q427",
    "Model": "Micromax Q427"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Canvas Unite 4 Pro",
    "Device": "Q465",
    "Model": "Micromax Q465"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Canvas XL2",
    "Device": "A109",
    "Model": "Micromax A109"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Canvas Xpress",
    "Device": "A99",
    "Model": "Micromax A99"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Canvas Xpress 2",
    "Device": "E314",
    "Model": "Micromax E314"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Canvas Xpress 4g",
    "Device": "Q413",
    "Model": "Micromax Q413"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Canvas fashion 3g",
    "Device": "Q3502",
    "Model": "Micromax Q3502"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Canvas tab",
    "Device": "P290",
    "Model": "Micromax P290"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Canvas tab",
    "Device": "P470",
    "Model": "P470"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Canvas tab",
    "Device": "P666",
    "Model": "Micromax P666"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Canvas tab",
    "Device": "P680",
    "Model": "MicromaxP680"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Doodle 4",
    "Device": "Q491",
    "Model": "Micromax Q491"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Dual 4",
    "Device": "E4816",
    "Model": "Micromax E4816"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "EVOK DUAL NOTE",
    "Device": "E4815",
    "Model": "Micromax E4815"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Evok Dual Note",
    "Device": "E4817",
    "Model": "Micromax E4817"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Evok Note",
    "Device": "E453",
    "Model": "Micromax E453"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Evok Power",
    "Device": "Q4260",
    "Model": "Micromax Q4260"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "IN1b",
    "Device": "E6523",
    "Model": "Micromax E6523"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "IN1b",
    "Device": "E7533",
    "Model": "Micromax E7533"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "IN_2b",
    "Device": "E7544",
    "Model": "IN_2b"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "IN_2c",
    "Device": "E6533",
    "Model": "IN_2c"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "IN_Note1",
    "Device": "E7746",
    "Model": "IN_Note1"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "IN_Note2",
    "Device": "E7446",
    "Model": "E7446"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "In1",
    "Device": "E6746",
    "Model": "IN1"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "In_Note1",
    "Device": "E7746",
    "Model": "IN_Note1"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Infinity N Series N12",
    "Device": "N8301",
    "Model": "N8301"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Ione Note",
    "Device": "N8305",
    "Model": "ione note"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "MAD",
    "Device": "A94",
    "Model": "Micromax A94"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "MIcromax Bharat 4",
    "Device": "Q440",
    "Model": "Micromax Q440"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Micromax Bharat 2 Plus",
    "Device": "Q402Plus",
    "Model": "Micromax Q402+"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Micromax Bharat 2 Plus",
    "Device": "Q402Plus",
    "Model": "Micromax Q402Plus"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Micromax C1",
    "Device": "C1",
    "Model": "Micromax C1"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Micromax C2A",
    "Device": "C2A",
    "Model": "Micromax C2A"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Micromax C2APLS",
    "Device": "C2APlus",
    "Model": "Micromax C2APLS"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Micromax Canvas 1",
    "Device": "C1",
    "Model": "Micromax C1"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Micromax Canvas Music M1",
    "Device": "Q4261",
    "Model": "Micromax Q4261"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Micromax Canvax 1(2018)",
    "Device": "C1A",
    "Model": "Micromax C1A"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Micromax Kicka 6",
    "Device": "N4120",
    "Model": "Micromax N4120"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Micromax Q353",
    "Device": "Q353",
    "Model": "Micromax_Q353"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Micromax Q353 Plus",
    "Device": "Q353P",
    "Model": "Micromax_Q353P"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Micromax Q402+",
    "Device": "Q402Plus",
    "Model": "Micromax Q402+"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Micromax Q437",
    "Device": "Q437",
    "Model": "Micromax Q437"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Micromax Q440",
    "Device": "Q440",
    "Model": "Micromax Q440"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Micromax Q454",
    "Device": "Q454",
    "Model": "Micromax Q454"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Micromax Selfie 2",
    "Device": "Q4311",
    "Model": "Micromax Q4311"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Micromax Selfie 2 Note",
    "Device": "Q4601",
    "Model": "Micromax Q4601"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Micromax Spark 4G Prime(2017)",
    "Device": "Q452",
    "Model": "Micromax Q452"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Nitro 3",
    "Device": "E352",
    "Model": "Micromax E352"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Nitro 4G",
    "Device": "E455",
    "Model": "Micromax E455"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "P275",
    "Device": "P275",
    "Model": "P275"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "P300",
    "Device": "crane-M701C_mmx",
    "Model": "P300"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Q327",
    "Device": "Q327",
    "Model": "Micromax Q327"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Q350R",
    "Device": "Q350R",
    "Model": "Micromax Q350R"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Q354",
    "Device": "Q354",
    "Model": "Micromax Q354"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "R1",
    "Device": "R1",
    "Model": "ATV R1"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "SUPREME BOLT",
    "Device": "Q300",
    "Model": "Micromax Q300"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Selfie 2",
    "Device": "Q340",
    "Model": "Micromax Q340"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Selfie 3",
    "Device": "E460",
    "Model": "Micromax E460"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Selfie 3",
    "Device": "Q348",
    "Model": "Micromax Q348"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Sliver 5",
    "Device": "Q450",
    "Model": "Micromax Q450"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Spark  4G(2017)",
    "Device": "Q409",
    "Model": "Micromax Q409"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Spark 4g",
    "Device": "Q4002",
    "Model": "Micromax Q4002"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Spark Go",
    "Device": "Q409A",
    "Model": "Micromax Q409A"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "UNITE",
    "Device": "A092",
    "Model": "Micromax A092"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Unite 3",
    "Device": "Q379",
    "Model": "Micromax Q379"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Unite2",
    "Device": "A106",
    "Model": "Micromax A106"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Unite3",
    "Device": "Q372",
    "Model": "Micromax Q372"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Vdeo 1",
    "Device": "Q4001",
    "Model": "Micromax Q4001"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Vdeo 2",
    "Device": "Q4101_Ru",
    "Model": "Micromax Q4101"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Vdeo 3",
    "Device": "Q4202",
    "Model": "Micromax Q4202"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Vdeo 4",
    "Device": "Q4251",
    "Model": "Micromax Q4251"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Vdeo 5",
    "Device": "Q4220",
    "Model": "Micromax Q4220"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Xpress 2",
    "Device": "E313",
    "Model": "Micromax E313"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "YU ACE",
    "Device": "YU5014",
    "Model": "YU5014"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "YUNIQUE",
    "Device": "YUNIQUE",
    "Model": "YU4711"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "YUREKA S",
    "Device": "YUREKA2",
    "Model": "YU5200"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "YUREKA S",
    "Device": "YUREKA2",
    "Model": "YU5551"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Yunique 2 Plus",
    "Device": "YU5012",
    "Model": "YU5012"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Yuphoria",
    "Device": "YUPHORIA",
    "Model": "YU5010"
  },
  {
    "Retail Branding": "Micromax",
    "Marketing Name": "Yutopia",
    "Device": "YUTOPIA",
    "Model": "YU5050"
  },
  {
    "Retail Branding": "Micropos",
    "Marketing Name": "P12",
    "Device": "P12",
    "Model": "P12"
  },
  {
    "Retail Branding": "Microtech",
    "Marketing Name": "ETL101A_EEA",
    "Device": "ETL101A_EEA",
    "Model": "ETL101A_EEA"
  },
  {
    "Retail Branding": "Microtech",
    "Marketing Name": "ETL101GB",
    "Device": "ETL101GB",
    "Model": "ETL101GB"
  },
  {
    "Retail Branding": "Microtech",
    "Marketing Name": "ETW101GT_C_EEA",
    "Device": "ETW101GT_C_EEA",
    "Model": "ETW101GT_C"
  },
  {
    "Retail Branding": "Microtech",
    "Marketing Name": "ETW101GT_EEA",
    "Device": "ETW101GT_EEA",
    "Model": "ETW101GT"
  },
  {
    "Retail Branding": "Microtech",
    "Marketing Name": "Microtech_e-tab_Style",
    "Device": "Microtech_etabStyle",
    "Model": "Microtech_etabStyle"
  },
  {
    "Retail Branding": "Microtech",
    "Marketing Name": "e-tab_Style",
    "Device": "e-tab_Style",
    "Model": "e-tab_Style"
  },
  {
    "Retail Branding": "Microtech",
    "Marketing Name": "e-tab_style_rev.3",
    "Device": "e-tab_style_REV3",
    "Model": "e-tab_style_REV3"
  },
  {
    "Retail Branding": "Microtech",
    "Marketing Name": "etab_LTE",
    "Device": "etab_LTE",
    "Model": "ETL101AL"
  },
  {
    "Retail Branding": "Mightier",
    "Marketing Name": "MT003-19",
    "Device": "MT003-19",
    "Model": "MT003-19"
  },
  {
    "Retail Branding": "Mightier",
    "Marketing Name": "MT003-20",
    "Device": "MT003-20",
    "Model": "MT003-20"
  },
  {
    "Retail Branding": "Mightier",
    "Marketing Name": "MT003-21",
    "Device": "MT003-21",
    "Model": "MT003-21"
  },
  {
    "Retail Branding": "Mightier",
    "Marketing Name": "MT003_22",
    "Device": "MT003_22",
    "Model": "MT003-22"
  },
  {
    "Retail Branding": "Mightier",
    "Marketing Name": "MT004_20",
    "Device": "MT004_20",
    "Model": "MT004_20"
  },
  {
    "Retail Branding": "Migu",
    "Marketing Name": "MGV2002",
    "Device": "MGV2002",
    "Model": "MGV2002"
  },
  {
    "Retail Branding": "MiiA",
    "Marketing Name": "MT-733G",
    "Device": "MT-733G",
    "Model": "MT-733G"
  },
  {
    "Retail Branding": "MiiA",
    "Marketing Name": "MiiA",
    "Device": "TA10CA1_2",
    "Model": "TA10CA1"
  },
  {
    "Retail Branding": "Mikona",
    "Marketing Name": "MFHD_BT1067QC16IPS2",
    "Device": "MFHD_BT1067QC16IPS2",
    "Model": "MFHD_BT1067QC16IPS2"
  },
  {
    "Retail Branding": "Mikona",
    "Marketing Name": "MHDBT10267",
    "Device": "MHDBT10267",
    "Model": "MHDBT10267"
  },
  {
    "Retail Branding": "Mikona",
    "Marketing Name": "MIKONA",
    "Device": "MSW_BT767QC8TN",
    "Model": "MSW_BT767QC8TN"
  },
  {
    "Retail Branding": "Mimio",
    "Marketing Name": "MimioPro-G XX5",
    "Device": "rk3588_t",
    "Model": "MimioProG5"
  },
  {
    "Retail Branding": "Mimo",
    "Marketing Name": "MCT_101EDL",
    "Device": "MCT_101EDL",
    "Model": "MCT-101EDL"
  },
  {
    "Retail Branding": "Mindphone",
    "Marketing Name": "Mindphone2",
    "Device": "Mindphone2",
    "Model": "Mindphone2"
  },
  {
    "Retail Branding": "Mingtronics",
    "Marketing Name": "RM-M6DA09",
    "Device": "RM-M6DA09",
    "Model": "RM-M6DA09"
  },
  {
    "Retail Branding": "Minimal_Phone",
    "Marketing Name": "MP01",
    "Device": "MP01",
    "Model": "MP01"
  },
  {
    "Retail Branding": "Minister",
    "Marketing Name": "Android TV",
    "Device": "R1",
    "Model": "ATV R1"
  },
  {
    "Retail Branding": "Minister",
    "Marketing Name": "Android TV",
    "Device": "R2",
    "Model": "ATV R2"
  },
  {
    "Retail Branding": "Minister",
    "Marketing Name": "Smart TV",
    "Device": "alimos",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "Minister",
    "Marketing Name": "Smart TV",
    "Device": "dangni",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "Minister",
    "Marketing Name": "Smart TV",
    "Device": "osaka",
    "Model": "AI PONT BD"
  },
  {
    "Retail Branding": "Mint",
    "Marketing Name": "Clover",
    "Device": "M4CR",
    "Model": "M4CR"
  },
  {
    "Retail Branding": "Mint",
    "Marketing Name": "Clover",
    "Device": "M4CR",
    "Model": "M4CRD"
  },
  {
    "Retail Branding": "Mint",
    "Marketing Name": "Emerald",
    "Device": "Emerald",
    "Model": "Emerald_M55CR"
  },
  {
    "Retail Branding": "Mint",
    "Marketing Name": "Emerald",
    "Device": "Emerald",
    "Model": "Emerald_M55CRD"
  },
  {
    "Retail Branding": "Mint",
    "Marketing Name": "M3CR2",
    "Device": "Mint_Fox_Plus",
    "Model": "Mint Fox+"
  },
  {
    "Retail Branding": "Mint",
    "Marketing Name": "M4",
    "Device": "M4",
    "Model": "M4"
  },
  {
    "Retail Branding": "Mint",
    "Marketing Name": "M4CR2",
    "Device": "Mint_Clover_Plus",
    "Model": "Mint Clover+"
  },
  {
    "Retail Branding": "Mint",
    "Marketing Name": "M5",
    "Device": "MINT-M5",
    "Model": "M5"
  },
  {
    "Retail Branding": "Mint",
    "Marketing Name": "M55LD",
    "Device": "Mint_fire",
    "Model": "Mint_M55LD"
  },
  {
    "Retail Branding": "Mint",
    "Marketing Name": "MINT M341",
    "Device": "Mint_M341",
    "Model": "M341"
  },
  {
    "Retail Branding": "Mint",
    "Marketing Name": "MINT M341",
    "Device": "Mint_M341",
    "Model": "Mint_M341"
  },
  {
    "Retail Branding": "Mint",
    "Marketing Name": "MINT Pandora",
    "Device": "MINT_Pandora",
    "Model": "MINT Pandora"
  },
  {
    "Retail Branding": "Mint",
    "Marketing Name": "MINT_LEGEND",
    "Device": "MINT_LEGEND",
    "Model": "Legend"
  },
  {
    "Retail Branding": "Mint",
    "Marketing Name": "MINT_Pearl_plus",
    "Device": "MINT_Pearl_plus",
    "Model": "Pearl+_M5PD"
  },
  {
    "Retail Branding": "Mint",
    "Marketing Name": "MM5514G",
    "Device": "MM5114G",
    "Model": "MM5114G"
  },
  {
    "Retail Branding": "Mint",
    "Marketing Name": "Mint Fusion",
    "Device": "Mint_Fusion",
    "Model": "Mint Fusion"
  },
  {
    "Retail Branding": "Mint",
    "Marketing Name": "Mint Leo",
    "Device": "Mint_Leo",
    "Model": "Mint Leo"
  },
  {
    "Retail Branding": "Mint",
    "Marketing Name": "Mint Triton",
    "Device": "Mint_Triton",
    "Model": "Mint Triton"
  },
  {
    "Retail Branding": "Mint",
    "Marketing Name": "Mint VirGo",
    "Device": "Mint_VirGo",
    "Model": "Mint VirGo"
  },
  {
    "Retail Branding": "Mint",
    "Marketing Name": "Orion_DS",
    "Device": "Orion_DS",
    "Model": "Orion_DS"
  },
  {
    "Retail Branding": "Mint",
    "Marketing Name": "Pearl_Neo",
    "Device": "Pearl_Neo",
    "Model": "Pearl_Neo"
  },
  {
    "Retail Branding": "Mint",
    "Marketing Name": "ULTRAMINTT_X5",
    "Device": "ULTRAMINTT_X5",
    "Model": "ULTRAMINTT X5"
  },
  {
    "Retail Branding": "Mintt",
    "Marketing Name": "A1",
    "Device": "A1",
    "Model": "A1"
  },
  {
    "Retail Branding": "Mintt",
    "Marketing Name": "Blaze 3",
    "Device": "Blaze_3",
    "Model": "Blaze 3"
  },
  {
    "Retail Branding": "Mintt",
    "Marketing Name": "COOLMINTT NIU",
    "Device": "COOLMINTT_NIU",
    "Model": "COOLMINTT NIU"
  },
  {
    "Retail Branding": "Mintt",
    "Marketing Name": "COOLMINTT_RIVAL_3",
    "Device": "COOLMINTT_RIVAL_3",
    "Model": "COOLMINTT RIVAL 3"
  },
  {
    "Retail Branding": "Mintt",
    "Marketing Name": "COOLMINTT_X10",
    "Device": "COOLMINTT_X10",
    "Model": "COOLMINTT X10"
  },
  {
    "Retail Branding": "Mintt",
    "Marketing Name": "COOLMINTT_X7",
    "Device": "COOLMINTT_X7",
    "Model": "COOLMINTT X7"
  },
  {
    "Retail Branding": "Mintt",
    "Marketing Name": "COOLMINTT_X9",
    "Device": "COOLMINTT_X9",
    "Model": "COOLMINTT X9"
  },
  {
    "Retail Branding": "Mintt",
    "Marketing Name": "CoolMintt",
    "Device": "MINTT_M5",
    "Model": "MINTT_M5"
  },
  {
    "Retail Branding": "Mintt",
    "Marketing Name": "CoolMintt Rival",
    "Device": "CoolMintt_Rival",
    "Model": "CoolMintt Rival"
  },
  {
    "Retail Branding": "Mintt",
    "Marketing Name": "CoolMinttA3",
    "Device": "CoolMinttA3",
    "Model": "CoolMinttA3"
  },
  {
    "Retail Branding": "Mintt",
    "Marketing Name": "CoolMinttA5",
    "Device": "CoolMinttA5",
    "Model": "CoolMinttA5"
  },
  {
    "Retail Branding": "Mintt",
    "Marketing Name": "CoolMinttBlaze",
    "Device": "CoolMinttBlaze",
    "Model": "CoolMinttBlaze"
  },
  {
    "Retail Branding": "Mintt",
    "Marketing Name": "CoolMinttDUO3",
    "Device": "CoolMinttDUO3",
    "Model": "CoolMinttDUO3"
  },
  {
    "Retail Branding": "Mintt",
    "Marketing Name": "CoolMinttM2",
    "Device": "CoolMinttM2",
    "Model": "CoolMinttM2"
  },
  {
    "Retail Branding": "Mintt",
    "Marketing Name": "CoolMintt_A3",
    "Device": "CoolMintt_A3",
    "Model": "CoolMinttA3"
  },
  {
    "Retail Branding": "Mintt",
    "Marketing Name": "CoolMintt_Blaze_2",
    "Device": "CoolMintt_Blaze_2",
    "Model": "CoolMintt Blaze 2"
  },
  {
    "Retail Branding": "Mintt",
    "Marketing Name": "Coolmintt P2",
    "Device": "Coolmintt_P2",
    "Model": "Coolmintt_P2"
  },
  {
    "Retail Branding": "Mintt",
    "Marketing Name": "DIGI",
    "Device": "DIGI",
    "Model": "DIGI"
  },
  {
    "Retail Branding": "Mintt",
    "Marketing Name": "FRESHMINTTA7",
    "Device": "FRESHMINTTA7",
    "Model": "FRESHMINTTA7"
  },
  {
    "Retail Branding": "Mintt",
    "Marketing Name": "M1",
    "Device": "M1",
    "Model": "M1"
  },
  {
    "Retail Branding": "Mintt",
    "Marketing Name": "MINTT-DIGI",
    "Device": "MINTT-DIGI",
    "Model": "MINTT-DIGI"
  },
  {
    "Retail Branding": "Mintt",
    "Marketing Name": "MINTT_ASPIRE_X9",
    "Device": "MINTT_ASPIRE_X9",
    "Model": "MINTT ASPIRE X9"
  },
  {
    "Retail Branding": "Mintt",
    "Marketing Name": "MINTT_DIGI_2",
    "Device": "MINTT_DIGI_2",
    "Model": "Mintt__Digi__2"
  },
  {
    "Retail Branding": "Mintt",
    "Marketing Name": "MINTT_PRIME_S11",
    "Device": "MINTT_PRIME_S11",
    "Model": "MINTT PRIME S11"
  },
  {
    "Retail Branding": "Mintt",
    "Marketing Name": "MINTT_T11",
    "Device": "MINTT_T11",
    "Model": "MINTT_T11"
  },
  {
    "Retail Branding": "Mintt",
    "Marketing Name": "MinttM3",
    "Device": "Mintt_M3",
    "Model": "Mintt M3"
  },
  {
    "Retail Branding": "Mintt",
    "Marketing Name": "MinttM3",
    "Device": "Mintt_M3",
    "Model": "Mintt__M3"
  },
  {
    "Retail Branding": "Mintt",
    "Marketing Name": "MinttPoro",
    "Device": "MinttPoro",
    "Model": "MinttPoro"
  },
  {
    "Retail Branding": "Mintt",
    "Marketing Name": "Mintt_T11_SE",
    "Device": "Mintt_T11_SE",
    "Model": "Mintt T11 SE"
  },
  {
    "Retail Branding": "Mintt",
    "Marketing Name": "Mintt_T3_SE",
    "Device": "Mintt_T3_SE",
    "Model": "Mintt T3 SE"
  },
  {
    "Retail Branding": "Mintt",
    "Marketing Name": "Mintt_Tab_T1",
    "Device": "Mintt_Tab_T1",
    "Model": "Mintt_Tab_T1"
  },
  {
    "Retail Branding": "Mintt",
    "Marketing Name": "P25",
    "Device": "P25",
    "Model": "P25"
  },
  {
    "Retail Branding": "Mintt",
    "Marketing Name": "P25+",
    "Device": "P25_PLUS",
    "Model": "P25+"
  },
  {
    "Retail Branding": "Mintt",
    "Marketing Name": "Rival_2",
    "Device": "CoolMintt_Rival_2",
    "Model": "CoolMintt Rival 2"
  },
  {
    "Retail Branding": "Mintt",
    "Marketing Name": "T3",
    "Device": "T3",
    "Model": "P08"
  },
  {
    "Retail Branding": "Mintt",
    "Marketing Name": "T3",
    "Device": "T3",
    "Model": "T3"
  },
  {
    "Retail Branding": "Mintt",
    "Marketing Name": "ULTRAMINTT A5",
    "Device": "ULTRAMINTT_A5",
    "Model": "ULTRAMINTT A5"
  },
  {
    "Retail Branding": "Mintt",
    "Marketing Name": "ULTRAMINTT Y3",
    "Device": "ULTRAMINTT_Y3",
    "Model": "ULTRAMINTT Y3"
  },
  {
    "Retail Branding": "Mintt",
    "Marketing Name": "ULTRAMINTT Y5",
    "Device": "ULTRAMINTT_Y5",
    "Model": "ULTRAMINTT Y5"
  },
  {
    "Retail Branding": "Mintt",
    "Marketing Name": "ULTRAMINTT_A6",
    "Device": "ULTRAMINTT_A6",
    "Model": "ULTRAMINTT A6"
  },
  {
    "Retail Branding": "Mintt",
    "Marketing Name": "ULTRAMINTT_P3",
    "Device": "ULTRAMINTT_P3",
    "Model": "COOLMINTT P3"
  },
  {
    "Retail Branding": "Mintt",
    "Marketing Name": "ULTRAMINTT_X6",
    "Device": "ULTRAMINTT_X6",
    "Model": "ULTRAMINTT X6"
  },
  {
    "Retail Branding": "Mintt",
    "Marketing Name": "UltraMinttS2",
    "Device": "UltraMinttS2",
    "Model": "UltraMinttS2"
  },
  {
    "Retail Branding": "Mintt",
    "Marketing Name": "UltraMinttT10",
    "Device": "UltraMinttT10",
    "Model": "UltraMintt_T10"
  },
  {
    "Retail Branding": "Mintt",
    "Marketing Name": "UltraMinttT2",
    "Device": "UltraMinttT2",
    "Model": "UltraMinttT2"
  },
  {
    "Retail Branding": "Mintt",
    "Marketing Name": "UltraMinttX2",
    "Device": "UltraMinttX2",
    "Model": "UltraMinttX2"
  },
  {
    "Retail Branding": "Mintt",
    "Marketing Name": "Ultramintt R1",
    "Device": "Ultramintt_R1",
    "Model": "Ultramintt R1"
  },
  {
    "Retail Branding": "Mio Tab",
    "Marketing Name": "MI106",
    "Device": "MI106",
    "Model": "MI106"
  },
  {
    "Retail Branding": "Mio Tab",
    "Marketing Name": "MI706",
    "Device": "MI706",
    "Model": "MI706"
  },
  {
    "Retail Branding": "Mio Tab",
    "Marketing Name": "MI86",
    "Device": "MI86",
    "Model": "MI86"
  },
  {
    "Retail Branding": "Mio Tab",
    "Marketing Name": "MP0101632",
    "Device": "MP0101632",
    "Model": "MP0101632"
  },
  {
    "Retail Branding": "Mio Tab",
    "Marketing Name": "MP0101788",
    "Device": "MP0101788",
    "Model": "MP0101788"
  },
  {
    "Retail Branding": "Mio Tab",
    "Marketing Name": "MP0101789",
    "Device": "MP0101789",
    "Model": "MP0101789"
  },
  {
    "Retail Branding": "Mio Tab",
    "Marketing Name": "MioTab",
    "Device": "MioTab2016",
    "Model": "MioTab 2016"
  },
  {
    "Retail Branding": "Mio Tab",
    "Marketing Name": "MioTab MP0101635",
    "Device": "MP0101635",
    "Model": "MP0101635"
  },
  {
    "Retail Branding": "Mio Tab",
    "Marketing Name": "MioTab2017",
    "Device": "MioTab2017",
    "Model": "MioTab2017"
  },
  {
    "Retail Branding": "Mio Tab",
    "Marketing Name": "Mio_Tab_2019",
    "Device": "Mio_Tab_2019",
    "Model": "Mio_Tab_2019"
  },
  {
    "Retail Branding": "Mione",
    "Marketing Name": "A10",
    "Device": "MIONEI",
    "Model": "A10"
  },
  {
    "Retail Branding": "Mione",
    "Marketing Name": "F1",
    "Device": "mione_F1",
    "Model": "F1"
  },
  {
    "Retail Branding": "Mione",
    "Marketing Name": "M-701Plus",
    "Device": "M-701Plus",
    "Model": "M-701Plus"
  },
  {
    "Retail Branding": "Mione",
    "Marketing Name": "Mione_PUBG_1",
    "Device": "Mione_PUBG_1",
    "Model": "Mione_PUBG_1"
  },
  {
    "Retail Branding": "Mione",
    "Marketing Name": "Mione_Pro",
    "Device": "MIONEI",
    "Model": "Mione_Pro"
  },
  {
    "Retail Branding": "Mione",
    "Marketing Name": "Mione_Pro_Plus",
    "Device": "Mione_Pro_Plus",
    "Model": "Mione Pro Plus"
  },
  {
    "Retail Branding": "Mione",
    "Marketing Name": "mione_M1",
    "Device": "mione_M1",
    "Model": "mione M1"
  },
  {
    "Retail Branding": "Mione",
    "Marketing Name": "mione_S20",
    "Device": "mione_S20",
    "Model": "mione_S20"
  },
  {
    "Retail Branding": "Miophone",
    "Marketing Name": "Mio Phone",
    "Device": "MioPhone2016",
    "Model": "Mio Phone 2016"
  },
  {
    "Retail Branding": "Miophone",
    "Marketing Name": "Mio Phone",
    "Device": "MioPhone2017",
    "Model": "MioPhone2017"
  },
  {
    "Retail Branding": "Mira",
    "Marketing Name": "X1",
    "Device": "X1",
    "Model": "X1"
  },
  {
    "Retail Branding": "Mira",
    "Marketing Name": "X2",
    "Device": "X2",
    "Model": "X2"
  },
  {
    "Retail Branding": "Mira",
    "Marketing Name": "X3",
    "Device": "X3",
    "Model": "X3"
  },
  {
    "Retail Branding": "Mira",
    "Marketing Name": "X4",
    "Device": "X4",
    "Model": "X4"
  },
  {
    "Retail Branding": "Mirage",
    "Marketing Name": "43T",
    "Device": "MI-JI-43T",
    "Model": "MI-JI-43T"
  },
  {
    "Retail Branding": "Mirage",
    "Marketing Name": "44T",
    "Device": "MI-JI-44T",
    "Model": "MI-JI-44T"
  },
  {
    "Retail Branding": "Mirage",
    "Marketing Name": "62S",
    "Device": "62S",
    "Model": "62S"
  },
  {
    "Retail Branding": "Mirage",
    "Marketing Name": "64T",
    "Device": "MI-JI-64T",
    "Model": "MI-JI-64T"
  },
  {
    "Retail Branding": "Mirage",
    "Marketing Name": "82S",
    "Device": "MI-CH-82S",
    "Model": "MI-CH-82S"
  },
  {
    "Retail Branding": "Mirage",
    "Marketing Name": "MI-SO-81T",
    "Device": "MI-SO-81T",
    "Model": "MI-SO-81T"
  },
  {
    "Retail Branding": "Miramage",
    "Marketing Name": "MF3D2211",
    "Device": "MF3D2211",
    "Model": "MF3D2211"
  },
  {
    "Retail Branding": "Miramage",
    "Marketing Name": "MTJ-X43FLS",
    "Device": "barking",
    "Model": "Miramage Smart Display"
  },
  {
    "Retail Branding": "Miramage",
    "Marketing Name": "Miramage AndroidTV",
    "Device": "barking",
    "Model": "Miramage AndroidTV KR"
  },
  {
    "Retail Branding": "Miramage",
    "Marketing Name": "Miramage Google TV",
    "Device": "surface",
    "Model": "Smart TV"
  },
  {
    "Retail Branding": "Miramage",
    "Marketing Name": "Miramage Smart Display",
    "Device": "beaudry",
    "Model": "Miramage Smart Display"
  },
  {
    "Retail Branding": "Miramage",
    "Marketing Name": "Smart TV 2K",
    "Device": "alken",
    "Model": "Smart TV 2K"
  },
  {
    "Retail Branding": "Miramage",
    "Marketing Name": "TV3223HDA11SMARTG",
    "Device": "beaudry",
    "Model": "Miramage AndroidTV"
  },
  {
    "Retail Branding": "Miramage",
    "Marketing Name": "TV5023UHDA11SMARTG",
    "Device": "barking",
    "Model": "Miramage AndroidTV"
  },
  {
    "Retail Branding": "Mito",
    "Marketing Name": "4K Smart TV",
    "Device": "pioneer",
    "Model": "4K PA Smart TV"
  },
  {
    "Retail Branding": "Mito",
    "Marketing Name": "A10",
    "Device": "A10_sprout",
    "Model": "MITO A10"
  },
  {
    "Retail Branding": "Mito",
    "Marketing Name": "A10",
    "Device": "A10_sprout",
    "Model": "MITO_A10"
  },
  {
    "Retail Branding": "Mito",
    "Marketing Name": "A62",
    "Device": "A62",
    "Model": "A62"
  },
  {
    "Retail Branding": "Mito",
    "Marketing Name": "A67",
    "Device": "A67",
    "Model": "Mito A67"
  },
  {
    "Retail Branding": "Mito",
    "Marketing Name": "A880",
    "Device": "A880",
    "Model": "MITO A880"
  },
  {
    "Retail Branding": "Mito",
    "Marketing Name": "MITO A17",
    "Device": "MITO_A17",
    "Model": "MITO A17"
  },
  {
    "Retail Branding": "Mito",
    "Marketing Name": "MITO A21",
    "Device": "A21",
    "Model": "MITO A21"
  },
  {
    "Retail Branding": "Mito",
    "Marketing Name": "MITO A39",
    "Device": "A39",
    "Model": "mito A39"
  },
  {
    "Retail Branding": "Mito",
    "Marketing Name": "MITO T8",
    "Device": "MITO_T8",
    "Model": "MITO T8"
  },
  {
    "Retail Branding": "Mito",
    "Marketing Name": "MITO T85",
    "Device": "T85",
    "Model": "MITO T85"
  },
  {
    "Retail Branding": "Mito",
    "Marketing Name": "MITO_A19_1GB",
    "Device": "MITO_A19_1GB",
    "Model": "MITO_A19_1GB"
  },
  {
    "Retail Branding": "Mito",
    "Marketing Name": "MITO_A19_2GB",
    "Device": "MITO_A19_2GB",
    "Model": "MITO_A19_2GB"
  },
  {
    "Retail Branding": "Mito",
    "Marketing Name": "MITO_T18",
    "Device": "MITO_T18",
    "Model": "MITO_T18"
  },
  {
    "Retail Branding": "Mito",
    "Marketing Name": "MITO_T7",
    "Device": "MITO_T7",
    "Model": "MITO_T7"
  },
  {
    "Retail Branding": "Mito",
    "Marketing Name": "Mito_A35",
    "Device": "Mito_A35",
    "Model": "Mito_A35"
  },
  {
    "Retail Branding": "Mito",
    "Marketing Name": "Mito_A36_W1",
    "Device": "MITO_A36_W1",
    "Model": "MITO_A36_W1"
  },
  {
    "Retail Branding": "Mito",
    "Marketing Name": "Mito_A37_Z1",
    "Device": "MITO_A37_Z1",
    "Model": "MITO_A37_Z1"
  },
  {
    "Retail Branding": "Mito",
    "Marketing Name": "Mito_A37_Z1",
    "Device": "MITO_A37_Z1plus",
    "Model": "MITO_A37_Z1plus"
  },
  {
    "Retail Branding": "Mito",
    "Marketing Name": "Smart TV",
    "Device": "mateo",
    "Model": "2K PA Smart TV"
  },
  {
    "Retail Branding": "Mito",
    "Marketing Name": "T5091A",
    "Device": "MITO_A16",
    "Model": "MITO A16"
  },
  {
    "Retail Branding": "Mito",
    "Marketing Name": "T8",
    "Device": "T8",
    "Model": "T8"
  },
  {
    "Retail Branding": "MoT(Mobility Technologies)",
    "Marketing Name": "S22-8A",
    "Device": "S22-8A",
    "Model": "S22-8A"
  },
  {
    "Retail Branding": "Mobell",
    "Marketing Name": "4K Smart TV",
    "Device": "pioneer",
    "Model": "4K PA Smart TV"
  },
  {
    "Retail Branding": "Mobell",
    "Marketing Name": "MBLTab81",
    "Device": "MBLTab81",
    "Model": "MBL Tab 8.1"
  },
  {
    "Retail Branding": "Mobell",
    "Marketing Name": "Mobell S50",
    "Device": "Mobell_S50",
    "Model": "Mobell S50"
  },
  {
    "Retail Branding": "Mobell",
    "Marketing Name": "NOVA P3",
    "Device": "NOVA_P3",
    "Model": "NOVA P3"
  },
  {
    "Retail Branding": "Mobell",
    "Marketing Name": "P41",
    "Device": "P41",
    "Model": "P41"
  },
  {
    "Retail Branding": "Mobell",
    "Marketing Name": "S40",
    "Device": "S40",
    "Model": "S40"
  },
  {
    "Retail Branding": "Mobell",
    "Marketing Name": "S41",
    "Device": "S41",
    "Model": "S41"
  },
  {
    "Retail Branding": "Mobell",
    "Marketing Name": "S47",
    "Device": "S47",
    "Model": "S47"
  },
  {
    "Retail Branding": "Mobell",
    "Marketing Name": "S51",
    "Device": "S51",
    "Model": "S51"
  },
  {
    "Retail Branding": "Mobell",
    "Marketing Name": "S60",
    "Device": "mobell_S60",
    "Model": "S60"
  },
  {
    "Retail Branding": "Mobell",
    "Marketing Name": "S61",
    "Device": "S61",
    "Model": "S61"
  },
  {
    "Retail Branding": "MobiIoT",
    "Marketing Name": "Hotah",
    "Device": "HotahOTG_N",
    "Model": "HotahOTG"
  },
  {
    "Retail Branding": "MobiIoT",
    "Marketing Name": "Hotah",
    "Device": "HotahOTG_V",
    "Model": "HotahOTG"
  },
  {
    "Retail Branding": "MobiIoT",
    "Marketing Name": "MobiGo",
    "Device": "WM19",
    "Model": "WM19"
  },
  {
    "Retail Branding": "MobiIoT",
    "Marketing Name": "MobiGo 2+",
    "Device": "MobiGo2P",
    "Model": "MobiGo2P"
  },
  {
    "Retail Branding": "MobiIoT",
    "Marketing Name": "MobiGo 2+",
    "Device": "MobiGo2PQV",
    "Model": "MobiGo2P"
  },
  {
    "Retail Branding": "MobiIoT",
    "Marketing Name": "MobiGo 2+ Pro",
    "Device": "MobiGo2PP",
    "Model": "MobiGo2PP"
  },
  {
    "Retail Branding": "MobiIoT",
    "Marketing Name": "MobiGo 2+ Pro",
    "Device": "WM18PPv2",
    "Model": "WM18PPv2"
  },
  {
    "Retail Branding": "MobiIoT",
    "Marketing Name": "MobiIoT",
    "Device": "WM58",
    "Model": "WM58"
  },
  {
    "Retail Branding": "MobiIoT",
    "Marketing Name": "MobiPrint 5",
    "Device": "MP5",
    "Model": "MP5"
  },
  {
    "Retail Branding": "MobiIoT",
    "Marketing Name": "MobiPrint4_Plus",
    "Device": "MobiPrint4_Plus",
    "Model": "MobiPrint4_Plus"
  },
  {
    "Retail Branding": "MobiIoT",
    "Marketing Name": "MobiScan",
    "Device": "NAT611",
    "Model": "NAT611"
  },
  {
    "Retail Branding": "MobiIoT",
    "Marketing Name": "Mobigo2",
    "Device": "MobiGo2",
    "Model": "MobiGo2"
  },
  {
    "Retail Branding": "MobiIoT",
    "Marketing Name": "Mobigo2L",
    "Device": "MobiGo2L",
    "Model": "MobiGo2L"
  },
  {
    "Retail Branding": "MobiIoT",
    "Marketing Name": "WM58",
    "Device": "WM58",
    "Model": "WM58"
  },
  {
    "Retail Branding": "MobiOcean",
    "Marketing Name": "MO-T3",
    "Device": "MO-T3",
    "Model": "MO-T3"
  },
  {
    "Retail Branding": "MobiOcean",
    "Marketing Name": "MOT102",
    "Device": "MOT102",
    "Model": "MOT102"
  },
  {
    "Retail Branding": "MobiOcean",
    "Marketing Name": "TPS900Q",
    "Device": "TPS900",
    "Model": "TPS900"
  },
  {
    "Retail Branding": "MobiVista",
    "Marketing Name": "MVT_1001",
    "Device": "MVT_1001",
    "Model": "MVT-1001"
  },
  {
    "Retail Branding": "MobiVista",
    "Marketing Name": "MVT_1001",
    "Device": "MVT_1001",
    "Model": "MVT_1001"
  },
  {
    "Retail Branding": "MobiVista",
    "Marketing Name": "VisioTab_10",
    "Device": "VisioTab_10",
    "Model": "VisioTab 10"
  },
  {
    "Retail Branding": "Mobicel",
    "Marketing Name": "F40",
    "Device": "F40",
    "Model": "F40"
  },
  {
    "Retail Branding": "Mobicel",
    "Marketing Name": "F41",
    "Device": "F41",
    "Model": "F41"
  },
  {
    "Retail Branding": "Mobicel",
    "Marketing Name": "F50",
    "Device": "F50",
    "Model": "F50"
  },
  {
    "Retail Branding": "Mobicel",
    "Marketing Name": "F51",
    "Device": "F51",
    "Model": "F51"
  },
  {
    "Retail Branding": "Mobicel",
    "Marketing Name": "F51",
    "Device": "F51",
    "Model": "F52"
  },
  {
    "Retail Branding": "Mobicel",
    "Marketing Name": "IX PLUS",
    "Device": "IX_PLUS",
    "Model": "IX_PLUS"
  },
  {
    "Retail Branding": "Mobicel",
    "Marketing Name": "MX3 PLUS",
    "Device": "MX3_PLUS",
    "Model": "MX3 PLUS"
  },
  {
    "Retail Branding": "Mobicel",
    "Marketing Name": "Mercury",
    "Device": "Mercury",
    "Model": "Mercury"
  },
  {
    "Retail Branding": "Mobicel",
    "Marketing Name": "MiPAD",
    "Device": "MiPAD",
    "Model": "MiPAD"
  },
  {
    "Retail Branding": "Mobicel",
    "Marketing Name": "Mobicel F42",
    "Device": "Mobicel_F42",
    "Model": "Mobicel_F42"
  },
  {
    "Retail Branding": "Mobicel",
    "Marketing Name": "Mobicel Mercury",
    "Device": "Mobicel_Mercury",
    "Model": "Mobicel Mercury"
  },
  {
    "Retail Branding": "Mobicel",
    "Marketing Name": "Mobicel P9",
    "Device": "Mobicel_P9",
    "Model": "Mobicel_P9"
  },
  {
    "Retail Branding": "Mobicel",
    "Marketing Name": "Mobicel_Z6",
    "Device": "P11_Plus",
    "Model": "Mobicel_Z6"
  },
  {
    "Retail Branding": "Mobicel",
    "Marketing Name": "P11",
    "Device": "P11",
    "Model": "P11"
  },
  {
    "Retail Branding": "Mobicel",
    "Marketing Name": "P11 Plus",
    "Device": "P11_Plus",
    "Model": "P11 Plus"
  },
  {
    "Retail Branding": "Mobicel",
    "Marketing Name": "P12",
    "Device": "P12",
    "Model": "P12"
  },
  {
    "Retail Branding": "Mobicel",
    "Marketing Name": "P12 Plus",
    "Device": "Mobicel_P12_Plus",
    "Model": "Mobicel P12 Plus"
  },
  {
    "Retail Branding": "Mobicel",
    "Marketing Name": "P5",
    "Device": "P5",
    "Model": "P5"
  },
  {
    "Retail Branding": "Mobicel",
    "Marketing Name": "P6",
    "Device": "P11_Plus",
    "Model": "P6"
  },
  {
    "Retail Branding": "Mobicel",
    "Marketing Name": "RX",
    "Device": "RX",
    "Model": "RX"
  },
  {
    "Retail Branding": "Mobicel",
    "Marketing Name": "Smart Tab 10 4G",
    "Device": "Smart_Tab_10",
    "Model": "Smart Tab 10 4G"
  },
  {
    "Retail Branding": "Mobicel",
    "Marketing Name": "Spectra J2",
    "Device": "Spectra_J2_VC",
    "Model": "Spectra_J2"
  },
  {
    "Retail Branding": "Mobicel",
    "Marketing Name": "SpectraTab2",
    "Device": "SpectraTab2",
    "Model": "SpectraTab2"
  },
  {
    "Retail Branding": "Mobicel",
    "Marketing Name": "VX21",
    "Device": "VX21",
    "Model": "VX21"
  },
  {
    "Retail Branding": "Mobicel",
    "Marketing Name": "Vodacom Smart Tab 8",
    "Device": "Smart_Tab_8",
    "Model": "Vodacom Smart Tab 8"
  },
  {
    "Retail Branding": "Mobicel",
    "Marketing Name": "X6",
    "Device": "X6",
    "Model": "X6"
  },
  {
    "Retail Branding": "Mobicel",
    "Marketing Name": "X7",
    "Device": "X7",
    "Model": "X7"
  },
  {
    "Retail Branding": "Mobicel",
    "Marketing Name": "Z4",
    "Device": "Z4",
    "Model": "Z4"
  },
  {
    "Retail Branding": "Mobicel",
    "Marketing Name": "Z6",
    "Device": "P11_Plus",
    "Model": "P11 Plus"
  },
  {
    "Retail Branding": "Mobicell",
    "Marketing Name": "4U",
    "Device": "4U",
    "Model": "4U"
  },
  {
    "Retail Branding": "Mobicell",
    "Marketing Name": "ARC",
    "Device": "ARC",
    "Model": "ARC"
  },
  {
    "Retail Branding": "Mobicell",
    "Marketing Name": "ASTRO",
    "Device": "ASTRO",
    "Model": "ASTRO"
  },
  {
    "Retail Branding": "Mobicell",
    "Marketing Name": "Air",
    "Device": "Mobicel_Air",
    "Model": "Air"
  },
  {
    "Retail Branding": "Mobicell",
    "Marketing Name": "BEAM",
    "Device": "BEAM",
    "Model": "BEAM"
  },
  {
    "Retail Branding": "Mobicell",
    "Marketing Name": "BERRY",
    "Device": "BERRY",
    "Model": "BERRY"
  },
  {
    "Retail Branding": "Mobicell",
    "Marketing Name": "BERRY PLUS",
    "Device": "BERRY_PLUS",
    "Model": "BERRY_PLUS"
  },
  {
    "Retail Branding": "Mobicell",
    "Marketing Name": "BERRY1",
    "Device": "BERRY1",
    "Model": "BERRY1"
  },
  {
    "Retail Branding": "Mobicell",
    "Marketing Name": "BERRY_PRO",
    "Device": "BERRY_PRO",
    "Model": "BERRY PRO"
  },
  {
    "Retail Branding": "Mobicell",
    "Marketing Name": "BLINK",
    "Device": "BLINK",
    "Model": "BLINK"
  },
  {
    "Retail Branding": "Mobicell",
    "Marketing Name": "Berry 2",
    "Device": "BERRY_2",
    "Model": "BERRY 2"
  },
  {
    "Retail Branding": "Mobicell",
    "Marketing Name": "CHAMP",
    "Device": "CHAMP",
    "Model": "CHAMP"
  },
  {
    "Retail Branding": "Mobicell",
    "Marketing Name": "CHERRY",
    "Device": "CHERRY",
    "Model": "CHERRY"
  },
  {
    "Retail Branding": "Mobicell",
    "Marketing Name": "CLIK",
    "Device": "CLIK",
    "Model": "CLIK"
  },
  {
    "Retail Branding": "Mobicell",
    "Marketing Name": "COSMO",
    "Device": "COSMO",
    "Model": "COSMO"
  },
  {
    "Retail Branding": "Mobicell",
    "Marketing Name": "CRAZE",
    "Device": "CRAZE",
    "Model": "CRAZE"
  },
  {
    "Retail Branding": "Mobicell",
    "Marketing Name": "Candy",
    "Device": "Candy",
    "Model": "Candy"
  },
  {
    "Retail Branding": "Mobicell",
    "Marketing Name": "Chrome LTE",
    "Device": "CHROME_LTE",
    "Model": "CHROME LTE"
  },
  {
    "Retail Branding": "Mobicell",
    "Marketing Name": "Chrome_LTE",
    "Device": "Chrome_LTE",
    "Model": "Chrome LTE"
  },
  {
    "Retail Branding": "Mobicell",
    "Marketing Name": "Clik plus",
    "Device": "Clik_plus",
    "Model": "Clik plus"
  },
  {
    "Retail Branding": "Mobicell",
    "Marketing Name": "Cosmo LTE",
    "Device": "Cosmo_LTE",
    "Model": "Cosmo LTE"
  },
  {
    "Retail Branding": "Mobicell",
    "Marketing Name": "Cosmo LTE_1",
    "Device": "Cosmo_LTE_1",
    "Model": "Cosmo LTE_1"
  },
  {
    "Retail Branding": "Mobicell",
    "Marketing Name": "D1",
    "Device": "PX12",
    "Model": "D1"
  },
  {
    "Retail Branding": "Mobicell",
    "Marketing Name": "D2",
    "Device": "PX12",
    "Model": "D2"
  },
  {
    "Retail Branding": "Mobicell",
    "Marketing Name": "D3",
    "Device": "VX20_PRO",
    "Model": "D3"
  },
  {
    "Retail Branding": "Mobicell",
    "Marketing Name": "DANDY",
    "Device": "DANDY",
    "Model": "DANDY"
  },
  {
    "Retail Branding": "Mobicell",
    "Marketing Name": "DANDY_RW",
    "Device": "DANDY_RW",
    "Model": "DANDY_RW"
  },
  {
    "Retail Branding": "Mobicell",
    "Marketing Name": "DANDY_ZAM",
    "Device": "DANDY_ZAM",
    "Model": "DANDY_ZAM"
  },
  {
    "Retail Branding": "Mobicell",
    "Marketing Name": "ECHO",
    "Device": "ECHO",
    "Model": "ECHO"
  },
  {
    "Retail Branding": "Mobicell",
    "Marketing Name": "EGO",
    "Device": "EGO",
    "Model": "EGO"
  },
  {
    "Retail Branding": "Mobicell",
    "Marketing Name": "EPIC MAX",
    "Device": "EPIC_MAX",
    "Model": "EPIC MAX"
  },
  {
    "Retail Branding": "Mobicell",
    "Marketing Name": "EPIC PRO 1",
    "Device": "EPIC_PRO_1",
    "Model": "EPIC PRO_1"
  },
  {
    "Retail Branding": "Mobicell",
    "Marketing Name": "EPIC PRO_2",
    "Device": "EPIC_PRO_2",
    "Model": "EPIC PRO_2"
  },
  {
    "Retail Branding": "Mobicell",
    "Marketing Name": "EPIC_1",
    "Device": "EPIC_1",
    "Model": "EPIC_1"
  },
  {
    "Retail Branding": "Mobicell",
    "Marketing Name": "EPIC_2",
    "Device": "EPIC_2",
    "Model": "EPIC_2"
  },
  {
    "Retail Branding": "Mobicell",
    "Marketing Name": "F50",
    "Device": "F50",
    "Model": "F50"
  },
  {
    "Retail Branding": "Mobicell",
    "Marketing Name": "FAME",
    "Device": "FAME",
    "Model": "FAME"
  },
  {
    "Retail Branding": "Mobicell",
    "Marketing Name": "FAME_DS",
    "Device": "FAME_DS",
    "Model": "FAME_DS"
  },
  {
    "Retail Branding": "Mobicell",
    "Marketing Name": "FENDY_DS",
    "Device": "FENDY_DS",
    "Model": "FENDY_DS"
  },
  {
    "Retail Branding": "Mobicell",
    "Marketing Name": "FEVER",
    "Device": "FEVER",
    "Model": "FEVER"
  },
  {
    "Retail Branding": "Mobicell",
    "Marketing Name": "FEVER_PLUS_H",
    "Device": "FEVER_PLUS_H",
    "Model": "FEVER_PLUS_H"
  },
  {
    "Retail Branding": "Mobicell",
    "Marketing Name": "FORCE",
    "Device": "FORCE",
    "Model": "FORCE"
  },
  {
    "Retail Branding": "Mobicell",
    "Marketing Name": "FRIO",
    "Device": "FRIO",
    "Model": "FRIO"
  },
  {
    "Retail Branding": "Mobicell",
    "Marketing Name": "Fendy plus",
    "Device": "Fendy_plus",
    "Model": "Fendy plus"
  },
  {
    "Retail Branding": "Mobicell",
    "Marketing Name": "Fever_Plus",
    "Device": "Fever_Plus",
    "Model": "Fever_Plus"
  },
  {
    "Retail Branding": "Mobicell",
    "Marketing Name": "Fever_Plus_J",
    "Device": "Fever_Plus_J",
    "Model": "Fever_Plus_J"
  },
  {
    "Retail Branding": "Mobicell",
    "Marketing Name": "GEO",
    "Device": "GEO",
    "Model": "GEO"
  },
  {
    "Retail Branding": "Mobicell",
    "Marketing Name": "GLO",
    "Device": "GLO",
    "Model": "GLO"
  },
  {
    "Retail Branding": "Mobicell",
    "Marketing Name": "GLO_2",
    "Device": "GLO_2",
    "Model": "GLO 2"
  },
  {
    "Retail Branding": "Mobicell",
    "Marketing Name": "HERO",
    "Device": "HERO",
    "Model": "HERO"
  },
  {
    "Retail Branding": "Mobicell",
    "Marketing Name": "HERO X",
    "Device": "HERO_X",
    "Model": "HERO_X"
  },
  {
    "Retail Branding": "Mobicell",
    "Marketing Name": "HERO_DS",
    "Device": "HERO_DS",
    "Model": "HERO_DS"
  },
  {
    "Retail Branding": "Mobicell",
    "Marketing Name": "HYPE",
    "Device": "HYPE",
    "Model": "HYPE"
  },
  {
    "Retail Branding": "Mobicell",
    "Marketing Name": "IX",
    "Device": "IX",
    "Model": "IX"
  },
  {
    "Retail Branding": "Mobicell",
    "Marketing Name": "IX PRO",
    "Device": "IX_PRO",
    "Model": "IX PRO"
  },
  {
    "Retail Branding": "Mobicell",
    "Marketing Name": "IX-1",
    "Device": "IX-1",
    "Model": "IX-1"
  },
  {
    "Retail Branding": "Mobicell",
    "Marketing Name": "Icon",
    "Device": "Mobicel_Icon",
    "Model": "Icon"
  },
  {
    "Retail Branding": "Mobicell",
    "Marketing Name": "LEGEND PRO_1",
    "Device": "LEGEND_PRO_1",
    "Model": "LEGEND PRO_1"
  },
  {
    "Retail Branding": "Mobicell",
    "Marketing Name": "LEGEND_MAX_LTE",
    "Device": "LEGEND_MAX",
    "Model": "LEGEND MAX"
  },
  {
    "Retail Branding": "Mobicell",
    "Marketing Name": "Legend",
    "Device": "Legend",
    "Model": "Legend"
  },
  {
    "Retail Branding": "Mobicell",
    "Marketing Name": "Legend Pro LTE",
    "Device": "Legend_Pro_LTE",
    "Model": "Legend Pro LTE"
  },
  {
    "Retail Branding": "Mobicell",
    "Marketing Name": "Legend_Max_2",
    "Device": "Legend_Max_2",
    "Model": "Legend Max_2"
  },
  {
    "Retail Branding": "Mobicell",
    "Marketing Name": "METRO2",
    "Device": "METRO2",
    "Model": "MOBICEL METRO2"
  },
  {
    "Retail Branding": "Mobicell",
    "Marketing Name": "MX1",
    "Device": "MX1",
    "Model": "MX1"
  },
  {
    "Retail Branding": "Mobicell",
    "Marketing Name": "MX2",
    "Device": "PX12",
    "Model": "MX2"
  },
  {
    "Retail Branding": "Mobicell",
    "Marketing Name": "MX2 PLUS",
    "Device": "MX2_PLUS",
    "Model": "MX2 PLUS"
  },
  {
    "Retail Branding": "Mobicell",
    "Marketing Name": "Matrix",
    "Device": "Matrix",
    "Model": "Matrix"
  },
  {
    "Retail Branding": "Mobicell",
    "Marketing Name": "Mobicel",
    "Device": "Sonic",
    "Model": "Sonic"
  },
  {
    "Retail Branding": "Mobicell",
    "Marketing Name": "Mobicel",
    "Device": "Venus",
    "Model": "Venus"
  },
  {
    "Retail Branding": "Mobicell",
    "Marketing Name": "Mobicel GEM",
    "Device": "GEM",
    "Model": "GEM"
  },
  {
    "Retail Branding": "Mobicell",
    "Marketing Name": "Mobicel ICE",
    "Device": "ICE",
    "Model": "ICE"
  },
  {
    "Retail Branding": "Mobicell",
    "Marketing Name": "Mobicel_R1",
    "Device": "Mobicel_R1",
    "Model": "Mobicel_R1"
  },
  {
    "Retail Branding": "Mobicell",
    "Marketing Name": "Mobicel_R6",
    "Device": "Mobicel_R6",
    "Model": "Mobicel_R6"
  },
  {
    "Retail Branding": "Mobicell",
    "Marketing Name": "NEO",
    "Device": "NEO",
    "Model": "NEO"
  },
  {
    "Retail Branding": "Mobicell",
    "Marketing Name": "NEO LTE",
    "Device": "Neo_LTE",
    "Model": "Neo LTE"
  },
  {
    "Retail Branding": "Mobicell",
    "Marketing Name": "NEO_1",
    "Device": "NEO_1",
    "Model": "NEO_1"
  },
  {
    "Retail Branding": "Mobicell",
    "Marketing Name": "Neo_Plus",
    "Device": "Neo_Plus",
    "Model": "Neo_Plus"
  },
  {
    "Retail Branding": "Mobicell",
    "Marketing Name": "ONYX",
    "Device": "ONYX",
    "Model": "ONYX"
  },
  {
    "Retail Branding": "Mobicell",
    "Marketing Name": "OREO",
    "Device": "OREO",
    "Model": "OREO"
  },
  {
    "Retail Branding": "Mobicell",
    "Marketing Name": "PLAY",
    "Device": "PLAY",
    "Model": "PLAY"
  },
  {
    "Retail Branding": "Mobicell",
    "Marketing Name": "PLUM",
    "Device": "PLUM",
    "Model": "PLUM"
  },
  {
    "Retail Branding": "Mobicell",
    "Marketing Name": "PULSE_1",
    "Device": "PULSE_1",
    "Model": "PULSE_1"
  },
  {
    "Retail Branding": "Mobicell",
    "Marketing Name": "PULSE_1_VDC",
    "Device": "PULSE_1_VDC",
    "Model": "PULSE_1_VDC"
  },
  {
    "Retail Branding": "Mobicell",
    "Marketing Name": "PURE",
    "Device": "PURE",
    "Model": "PURE"
  },
  {
    "Retail Branding": "Mobicell",
    "Marketing Name": "PURE MINI",
    "Device": "PURE_MINI",
    "Model": "PURE MINI"
  },
  {
    "Retail Branding": "Mobicell",
    "Marketing Name": "PURE_PLUS",
    "Device": "PURE_PLUS",
    "Model": "PURE PLUS"
  },
  {
    "Retail Branding": "Mobicell",
    "Marketing Name": "PX12",
    "Device": "PX12",
    "Model": "PX12"
  },
  {
    "Retail Branding": "Mobicell",
    "Marketing Name": "Q10",
    "Device": "Q10",
    "Model": "Q10"
  },
  {
    "Retail Branding": "Mobicell",
    "Marketing Name": "R1 Plus",
    "Device": "R1_Plus",
    "Model": "R1 Plus"
  },
  {
    "Retail Branding": "Mobicell",
    "Marketing Name": "R1Plus",
    "Device": "R1PLUS_1",
    "Model": "R1PLUS_1"
  },
  {
    "Retail Branding": "Mobicell",
    "Marketing Name": "R3",
    "Device": "R3",
    "Model": "R3"
  },
  {
    "Retail Branding": "Mobicell",
    "Marketing Name": "R4",
    "Device": "R4",
    "Model": "R4"
  },
  {
    "Retail Branding": "Mobicell",
    "Marketing Name": "R4 LTE",
    "Device": "R4_LTE",
    "Model": "R4 LTE"
  },
  {
    "Retail Branding": "Mobicell",
    "Marketing Name": "R6_PLUS",
    "Device": "R6_PLUS",
    "Model": "R6 PLUS"
  },
  {
    "Retail Branding": "Mobicell",
    "Marketing Name": "R7",
    "Device": "R7",
    "Model": "R7"
  },
  {
    "Retail Branding": "Mobicell",
    "Marketing Name": "R7",
    "Device": "R7_1",
    "Model": "R7_1"
  },
  {
    "Retail Branding": "Mobicell",
    "Marketing Name": "R7_2",
    "Device": "R7_2",
    "Model": "R7_2"
  },
  {
    "Retail Branding": "Mobicell",
    "Marketing Name": "R8",
    "Device": "R8",
    "Model": "R8"
  },
  {
    "Retail Branding": "Mobicell",
    "Marketing Name": "R9 Pro",
    "Device": "R9_Pro",
    "Model": "R9_Pro"
  },
  {
    "Retail Branding": "Mobicell",
    "Marketing Name": "R9_LITE",
    "Device": "R9_LITE",
    "Model": "R9 LITE"
  },
  {
    "Retail Branding": "Mobicell",
    "Marketing Name": "REBEL",
    "Device": "REBEL",
    "Model": "REBEL"
  },
  {
    "Retail Branding": "Mobicell",
    "Marketing Name": "RIO 2",
    "Device": "RIO_2",
    "Model": "RIO 2"
  },
  {
    "Retail Branding": "Mobicell",
    "Marketing Name": "RIO_BN",
    "Device": "RIO_BN",
    "Model": "RIO_BN"
  },
  {
    "Retail Branding": "Mobicell",
    "Marketing Name": "RIO_DS",
    "Device": "RIO_DS",
    "Model": "RIO_DS"
  },
  {
    "Retail Branding": "Mobicell",
    "Marketing Name": "RIO_GN",
    "Device": "RIO_GN",
    "Model": "RIO_GN"
  },
  {
    "Retail Branding": "Mobicell",
    "Marketing Name": "RIO_RW",
    "Device": "RIO_RW",
    "Model": "RIO_RW"
  },
  {
    "Retail Branding": "Mobicell",
    "Marketing Name": "RIO_SS",
    "Device": "RIO_SS",
    "Model": "RIO_SS"
  },
  {
    "Retail Branding": "Mobicell",
    "Marketing Name": "RIO_ZAM",
    "Device": "RIO_ZAM",
    "Model": "RIO_ZAM"
  },
  {
    "Retail Branding": "Mobicell",
    "Marketing Name": "RUBY",
    "Device": "RUBY",
    "Model": "RUBY"
  },
  {
    "Retail Branding": "Mobicell",
    "Marketing Name": "RUSH",
    "Device": "RUSH",
    "Model": "RUSH"
  },
  {
    "Retail Branding": "Mobicell",
    "Marketing Name": "RX PRO",
    "Device": "RX_PRO",
    "Model": "RX PRO"
  },
  {
    "Retail Branding": "Mobicell",
    "Marketing Name": "RX Plus",
    "Device": "RX_Plus",
    "Model": "RX Plus"
  },
  {
    "Retail Branding": "Mobicell",
    "Marketing Name": "RX17",
    "Device": "RX17",
    "Model": "RX17"
  },
  {
    "Retail Branding": "Mobicell",
    "Marketing Name": "Retro",
    "Device": "Retro",
    "Model": "Retro"
  },
  {
    "Retail Branding": "Mobicell",
    "Marketing Name": "SHIFT",
    "Device": "SHIFT",
    "Model": "SHIFT"
  },
  {
    "Retail Branding": "Mobicell",
    "Marketing Name": "STAR",
    "Device": "STAR",
    "Model": "STAR"
  },
  {
    "Retail Branding": "Mobicell",
    "Marketing Name": "SWITCH",
    "Device": "SWITCH",
    "Model": "SWITCH"
  },
  {
    "Retail Branding": "Mobicell",
    "Marketing Name": "SWITCH1",
    "Device": "SWITCH1",
    "Model": "SWITCH1"
  },
  {
    "Retail Branding": "Mobicell",
    "Marketing Name": "Samba",
    "Device": "Samba",
    "Model": "Samba"
  },
  {
    "Retail Branding": "Mobicell",
    "Marketing Name": "Switch GO",
    "Device": "Switch_GO",
    "Model": "Switch GO"
  },
  {
    "Retail Branding": "Mobicell",
    "Marketing Name": "TANGO_LITE",
    "Device": "TANGO_LITE",
    "Model": "TANGO_LITE"
  },
  {
    "Retail Branding": "Mobicell",
    "Marketing Name": "TRENDY 2",
    "Device": "TRENDY_2",
    "Model": "TRENDY 2"
  },
  {
    "Retail Branding": "Mobicell",
    "Marketing Name": "TRENDY_LITE",
    "Device": "TRENDY_LITE",
    "Model": "TRENDY_LITE"
  },
  {
    "Retail Branding": "Mobicell",
    "Marketing Name": "TRIP",
    "Device": "TRIP",
    "Model": "TRIP"
  },
  {
    "Retail Branding": "Mobicell",
    "Marketing Name": "Titan",
    "Device": "TITAN",
    "Model": "TITAN"
  },
  {
    "Retail Branding": "Mobicell",
    "Marketing Name": "Titan_1",
    "Device": "Titan_1",
    "Model": "Titan_1"
  },
  {
    "Retail Branding": "Mobicell",
    "Marketing Name": "Trendy",
    "Device": "TREDNY",
    "Model": "TREDNY"
  },
  {
    "Retail Branding": "Mobicell",
    "Marketing Name": "Trendy",
    "Device": "TRENDY",
    "Model": "TRENDY"
  },
  {
    "Retail Branding": "Mobicell",
    "Marketing Name": "Trendy Plus",
    "Device": "TRENDY_PLUS",
    "Model": "TRENDY PLUS"
  },
  {
    "Retail Branding": "Mobicell",
    "Marketing Name": "U2",
    "Device": "U2",
    "Model": "U2"
  },
  {
    "Retail Branding": "Mobicell",
    "Marketing Name": "ULTRA",
    "Device": "ULTRA",
    "Model": "ULTRA"
  },
  {
    "Retail Branding": "Mobicell",
    "Marketing Name": "V1",
    "Device": "V1",
    "Model": "V1"
  },
  {
    "Retail Branding": "Mobicell",
    "Marketing Name": "V2 LTE",
    "Device": "V2_LTE",
    "Model": "V2 LTE"
  },
  {
    "Retail Branding": "Mobicell",
    "Marketing Name": "V4",
    "Device": "V4",
    "Model": "V4"
  },
  {
    "Retail Branding": "Mobicell",
    "Marketing Name": "VEGA",
    "Device": "VEGA",
    "Model": "VEGA"
  },
  {
    "Retail Branding": "Mobicell",
    "Marketing Name": "VENUS_G",
    "Device": "VENUS_G",
    "Model": "VENUS_G"
  },
  {
    "Retail Branding": "Mobicell",
    "Marketing Name": "VIBE",
    "Device": "VIBE",
    "Model": "VIBE"
  },
  {
    "Retail Branding": "Mobicell",
    "Marketing Name": "VX16",
    "Device": "VX16",
    "Model": "VX16"
  },
  {
    "Retail Branding": "Mobicell",
    "Marketing Name": "VX18",
    "Device": "VX18",
    "Model": "VX18"
  },
  {
    "Retail Branding": "Mobicell",
    "Marketing Name": "VX18_1",
    "Device": "VX18_1",
    "Model": "VX18_1"
  },
  {
    "Retail Branding": "Mobicell",
    "Marketing Name": "VX19",
    "Device": "VX19",
    "Model": "VX19"
  },
  {
    "Retail Branding": "Mobicell",
    "Marketing Name": "VX20",
    "Device": "VX20",
    "Model": "VX20"
  },
  {
    "Retail Branding": "Mobicell",
    "Marketing Name": "VX20 PRO",
    "Device": "VX20_PRO",
    "Model": "VX20 PRO"
  },
  {
    "Retail Branding": "Mobicell",
    "Marketing Name": "VX_18",
    "Device": "VX18",
    "Model": "VX18"
  },
  {
    "Retail Branding": "Mobicell",
    "Marketing Name": "X1",
    "Device": "X1",
    "Model": "X1"
  },
  {
    "Retail Branding": "Mobicell",
    "Marketing Name": "X4",
    "Device": "X4",
    "Model": "X4"
  },
  {
    "Retail Branding": "Mobicell",
    "Marketing Name": "X6",
    "Device": "X6",
    "Model": "X6"
  },
  {
    "Retail Branding": "Mobicell",
    "Marketing Name": "X9",
    "Device": "X9",
    "Model": "X9"
  },
  {
    "Retail Branding": "Mobicell",
    "Marketing Name": "XV19",
    "Device": "VX19",
    "Model": "VX19"
  },
  {
    "Retail Branding": "Mobicell",
    "Marketing Name": "Z3",
    "Device": "RX17",
    "Model": "Z3"
  },
  {
    "Retail Branding": "Mobicell",
    "Marketing Name": "ZEN",
    "Device": "ZEN",
    "Model": "ZEN"
  },
  {
    "Retail Branding": "Mobicell",
    "Marketing Name": "ZOOM",
    "Device": "ZOOM",
    "Model": "ZOOM"
  },
  {
    "Retail Branding": "Mobicell",
    "Marketing Name": "ZOOM_1",
    "Device": "ZOOM_1",
    "Model": "ZOOM_1"
  },
  {
    "Retail Branding": "Mobicell",
    "Marketing Name": "ZOOM_H",
    "Device": "ZOOM_H",
    "Model": "ZOOM-H"
  },
  {
    "Retail Branding": "Mobicell",
    "Marketing Name": "Zoom",
    "Device": "ZOOM",
    "Model": "ZOOM"
  },
  {
    "Retail Branding": "Mobicell",
    "Marketing Name": "switch plus",
    "Device": "switch_plus",
    "Model": "switch plus"
  },
  {
    "Retail Branding": "MobiiStar",
    "Marketing Name": "C1 Lite",
    "Device": "C1_Lite",
    "Model": "C1 Lite"
  },
  {
    "Retail Branding": "MobiiStar",
    "Marketing Name": "C1 Power",
    "Device": "mobiistar_C1_Power",
    "Model": "mobiistar C1 Power"
  },
  {
    "Retail Branding": "MobiiStar",
    "Marketing Name": "LAI YUNA 1",
    "Device": "LAI_YUNA_1",
    "Model": "mobiistar LAI YUNA 1"
  },
  {
    "Retail Branding": "MobiiStar",
    "Marketing Name": "LAI Z1 4G",
    "Device": "LAI_Z1_4G",
    "Model": "mobiistar LAI Z1 4G"
  },
  {
    "Retail Branding": "MobiiStar",
    "Marketing Name": "LAI Z2",
    "Device": "mobiistar_LAI_Z2",
    "Model": "mobiistar_LAI_Z2"
  },
  {
    "Retail Branding": "MobiiStar",
    "Marketing Name": "LAI Zoro 3",
    "Device": "LAI_ZORO_3",
    "Model": "mobiistar LAI ZORO 3"
  },
  {
    "Retail Branding": "MobiiStar",
    "Marketing Name": "LAI Zumbo S 2017",
    "Device": "Zumbo_S_2017",
    "Model": "Zumbo_S_2017"
  },
  {
    "Retail Branding": "MobiiStar",
    "Marketing Name": "LAI Zumbo S 2017 Lite",
    "Device": "Zumbo_S_2017_Lite",
    "Model": "Zumbo_S_2017_Lite"
  },
  {
    "Retail Branding": "MobiiStar",
    "Marketing Name": "PRIME X MAX 2018",
    "Device": "PRIME_X_MAX_2018",
    "Model": "PRIME X MAX 2018"
  },
  {
    "Retail Branding": "MobiiStar",
    "Marketing Name": "S3 Dual",
    "Device": "S3_Dual",
    "Model": "S3 Dual"
  },
  {
    "Retail Branding": "MobiiStar",
    "Marketing Name": "X1 Dual",
    "Device": "X1_Dual",
    "Model": "X1 Dual"
  },
  {
    "Retail Branding": "MobiiStar",
    "Marketing Name": "X1 Notch",
    "Device": "X1_Notch",
    "Model": "X1 Notch"
  },
  {
    "Retail Branding": "MobiiStar",
    "Marketing Name": "X1 Selfie",
    "Device": "X1_Selfie",
    "Model": "X1 Selfie"
  },
  {
    "Retail Branding": "MobiiStar",
    "Marketing Name": "XQ Dual",
    "Device": "XQ_Dual",
    "Model": "XQ Dual"
  },
  {
    "Retail Branding": "MobiiStar",
    "Marketing Name": "ZORO 4G",
    "Device": "mobiistar_ZORO_4G",
    "Model": "mobiistar_ZORO_4G"
  },
  {
    "Retail Branding": "MobiiStar",
    "Marketing Name": "ZORO 5",
    "Device": "ZORO_5",
    "Model": "mobiistar ZORO 5"
  },
  {
    "Retail Branding": "MobiiStar",
    "Marketing Name": "ZUMBO J2",
    "Device": "Mobiistar_Zumbo_J2",
    "Model": "Mobiistar_Zumbo_J2"
  },
  {
    "Retail Branding": "MobiiStar",
    "Marketing Name": "ZUMBO Power",
    "Device": "ZUMBO_Power",
    "Model": "mobiistar ZUMBO Power"
  },
  {
    "Retail Branding": "MobiiStar",
    "Marketing Name": "ZUMBO S2",
    "Device": "mobiistar_Zumbo_S2",
    "Model": "mobiistar Zumbo S2"
  },
  {
    "Retail Branding": "MobiiStar",
    "Marketing Name": "ZUMBO_S2_Dual",
    "Device": "ZUMBO_S2_Dual",
    "Model": "mobiistar ZUMBO S2 Dual"
  },
  {
    "Retail Branding": "MobiiStar",
    "Marketing Name": "Zumbo_S_2017",
    "Device": "Zumbo_S_2017",
    "Model": "Zumbo S 2017"
  },
  {
    "Retail Branding": "MobiiStar",
    "Marketing Name": "mobiistar",
    "Device": "CQ",
    "Model": "CQ"
  },
  {
    "Retail Branding": "MobiiStar",
    "Marketing Name": "mobiistar C1",
    "Device": "mobiistar_C1",
    "Model": "mobiistar C1"
  },
  {
    "Retail Branding": "MobiiStar",
    "Marketing Name": "mobiistar C1 Shine",
    "Device": "mobiistar_C1_Shine",
    "Model": "mobiistar C1 Shine"
  },
  {
    "Retail Branding": "MobiiStar",
    "Marketing Name": "mobiistar C2",
    "Device": "mobiistar_C2",
    "Model": "mobiistar C2"
  },
  {
    "Retail Branding": "MobiiStar",
    "Marketing Name": "mobiistar E Selfie",
    "Device": "mobiistar_E_Selfie",
    "Model": "mobiistar E Selfie"
  },
  {
    "Retail Branding": "MobiiStar",
    "Marketing Name": "mobiistar E1",
    "Device": "mobiistar_E1",
    "Model": "mobiistar E1"
  },
  {
    "Retail Branding": "MobiiStar",
    "Marketing Name": "mobiistar E1 Selfie",
    "Device": "E1_Selfie",
    "Model": "E1 Selfie"
  },
  {
    "Retail Branding": "MobiiStar",
    "Marketing Name": "mobiistar X",
    "Device": "mobiistar_X",
    "Model": "mobiistar X"
  },
  {
    "Retail Branding": "Mobile Initiative",
    "Marketing Name": "ETHOS",
    "Device": "ETHOS",
    "Model": "ETHOS"
  },
  {
    "Retail Branding": "MobileDemand",
    "Marketing Name": "A1180",
    "Device": "A1180",
    "Model": "A1180"
  },
  {
    "Retail Branding": "MobileDemand",
    "Marketing Name": "Flex10AND",
    "Device": "Flex10AND",
    "Model": "Flex10AND"
  },
  {
    "Retail Branding": "MobileDemand",
    "Marketing Name": "xTablet-A680",
    "Device": "xTablet-A680",
    "Model": "xTablet-A680"
  },
  {
    "Retail Branding": "MobileDemand",
    "Marketing Name": "xTabletA680",
    "Device": "xTabletA680",
    "Model": "xTabletA680"
  },
  {
    "Retail Branding": "MobileTeleSystem",
    "Marketing Name": "MTC SMART Surf 4G",
    "Device": "MTC_SMART_Surf_4G",
    "Model": "MTC_SMART_Surf_4G"
  },
  {
    "Retail Branding": "MobileTeleSystem",
    "Marketing Name": "SMART Race2 4G",
    "Device": "SMART_Race2_4G",
    "Model": "SMART_Race2_4G"
  },
  {
    "Retail Branding": "MobileTeleSystem",
    "Marketing Name": "SMART Start 2",
    "Device": "MTC_SMART_Start_2",
    "Model": "MTC_SMART_Start_2"
  },
  {
    "Retail Branding": "MobileTeleSystem",
    "Marketing Name": "SMART Turbo 4G",
    "Device": "SMART_Turbo_4G",
    "Model": "SMART_Turbo_4G"
  },
  {
    "Retail Branding": "MobileTeleSystem",
    "Marketing Name": "SMART_Sprint_4G",
    "Device": "SMART_Sprint_4G",
    "Model": "MTC SMART Sprint 4G"
  },
  {
    "Retail Branding": "MobileTeleSystem",
    "Marketing Name": "Smart Surf2 4G",
    "Device": "SMART_Surf2_4G",
    "Model": "SMART Surf2 4G"
  },
  {
    "Retail Branding": "Mobily",
    "Marketing Name": "MDB342X",
    "Device": "qnbml",
    "Model": "MDB342X"
  },
  {
    "Retail Branding": "Mobiola",
    "Marketing Name": "Gaia",
    "Device": "MOBIOLA_MS55L1",
    "Model": "MS55L1"
  },
  {
    "Retail Branding": "Mobiola",
    "Marketing Name": "MS50L1",
    "Device": "MS50L1",
    "Model": "MS50L1"
  },
  {
    "Retail Branding": "Mobiola",
    "Marketing Name": "MS55E1",
    "Device": "MS55E1",
    "Model": "MS55E1"
  },
  {
    "Retail Branding": "Mobiola",
    "Marketing Name": "POLYS_MS45L1",
    "Device": "POLYS_MS45L1",
    "Model": "POLYS_MS45L1"
  },
  {
    "Retail Branding": "Mobistel",
    "Marketing Name": "Cynus E7",
    "Device": "Cynus_E7",
    "Model": "Cynus E7"
  },
  {
    "Retail Branding": "Mobistel",
    "Marketing Name": "Cynus F10",
    "Device": "Cynus_F10",
    "Model": "Cynus_F10"
  },
  {
    "Retail Branding": "Mobistel",
    "Marketing Name": "Cynus F9 4G",
    "Device": "Cynus_F9_4G",
    "Model": "Cynus_F9_4G"
  },
  {
    "Retail Branding": "Mobistel",
    "Marketing Name": "Cynus T6",
    "Device": "Cynus_T6",
    "Model": "Cynus T6"
  },
  {
    "Retail Branding": "Mobistel",
    "Marketing Name": "Cynus_E8",
    "Device": "Cynus_E8",
    "Model": "Cynus_E8"
  },
  {
    "Retail Branding": "Mobiwire",
    "Marketing Name": "ALTICE S35",
    "Device": "S35",
    "Model": "S35"
  },
  {
    "Retail Branding": "Mobiwire",
    "Marketing Name": "Ahiga",
    "Device": "Ahiga",
    "Model": "Ahiga"
  },
  {
    "Retail Branding": "Mobiwire",
    "Marketing Name": "Airtel Imagine",
    "Device": "H5032U",
    "Model": "Airtel Imagine"
  },
  {
    "Retail Branding": "Mobiwire",
    "Marketing Name": "Altice E55",
    "Device": "E55",
    "Model": "E55"
  },
  {
    "Retail Branding": "Mobiwire",
    "Marketing Name": "Awadjidjè",
    "Device": "H5111",
    "Model": "Awadjidje"
  },
  {
    "Retail Branding": "Mobiwire",
    "Marketing Name": "BUZZ_2",
    "Device": "BUZZ_2",
    "Model": "BUZZ_2"
  },
  {
    "Retail Branding": "Mobiwire",
    "Marketing Name": "Benin",
    "Device": "H6681_Pro",
    "Model": "Moov Smart Pro"
  },
  {
    "Retail Branding": "Mobiwire",
    "Marketing Name": "CHAT",
    "Device": "CHAT",
    "Model": "CHAT"
  },
  {
    "Retail Branding": "Mobiwire",
    "Marketing Name": "Celtiis Smart 1",
    "Device": "H5032U",
    "Model": "Smart 1"
  },
  {
    "Retail Branding": "Mobiwire",
    "Marketing Name": "Chenoa",
    "Device": "Chenoa",
    "Model": "Chenoa"
  },
  {
    "Retail Branding": "Mobiwire",
    "Marketing Name": "Cygnus",
    "Device": "Cygnus45",
    "Model": "Cygnus"
  },
  {
    "Retail Branding": "Mobiwire",
    "Marketing Name": "Cygnus",
    "Device": "Cygnus45",
    "Model": "Cygnus45"
  },
  {
    "Retail Branding": "Mobiwire",
    "Marketing Name": "Cygnus mini",
    "Device": "Cygnus_mini",
    "Model": "Cygnus mini"
  },
  {
    "Retail Branding": "Mobiwire",
    "Marketing Name": "Cygnus mini",
    "Device": "Cygnus_mini",
    "Model": "Cygnus_mini"
  },
  {
    "Retail Branding": "Mobiwire",
    "Marketing Name": "GH6733",
    "Device": "GH6733",
    "Model": "H6733"
  },
  {
    "Retail Branding": "Mobiwire",
    "Marketing Name": "H",
    "Device": "Halona",
    "Model": "Halona"
  },
  {
    "Retail Branding": "Mobiwire",
    "Marketing Name": "H5111",
    "Device": "H5111",
    "Model": "H5111"
  },
  {
    "Retail Branding": "Mobiwire",
    "Marketing Name": "H5111",
    "Device": "H5111",
    "Model": "Kicka 6 Plus 4G"
  },
  {
    "Retail Branding": "Mobiwire",
    "Marketing Name": "H5111L",
    "Device": "Giyafa",
    "Model": "Giyafa"
  },
  {
    "Retail Branding": "Mobiwire",
    "Marketing Name": "H5111L",
    "Device": "H5111L",
    "Model": "H5111L"
  },
  {
    "Retail Branding": "Mobiwire",
    "Marketing Name": "H5111L",
    "Device": "H5111L",
    "Model": "IKOSORA+"
  },
  {
    "Retail Branding": "Mobiwire",
    "Marketing Name": "H5111L",
    "Device": "H5111L_Mascom",
    "Model": "H5111L_Mascom"
  },
  {
    "Retail Branding": "Mobiwire",
    "Marketing Name": "H5111L_common",
    "Device": "H5111L",
    "Model": "H5111L_MTN"
  },
  {
    "Retail Branding": "Mobiwire",
    "Marketing Name": "H5112",
    "Device": "H5112",
    "Model": "H5112"
  },
  {
    "Retail Branding": "Mobiwire",
    "Marketing Name": "H6032",
    "Device": "H6032",
    "Model": "H6032"
  },
  {
    "Retail Branding": "Mobiwire",
    "Marketing Name": "H6032 Plus",
    "Device": "H6032_Plus",
    "Model": "H6032 Plus"
  },
  {
    "Retail Branding": "Mobiwire",
    "Marketing Name": "H6511",
    "Device": "H6511",
    "Model": "H6511"
  },
  {
    "Retail Branding": "Mobiwire",
    "Marketing Name": "H6682",
    "Device": "H6682",
    "Model": "H6682"
  },
  {
    "Retail Branding": "Mobiwire",
    "Marketing Name": "H6682_VDC_TZ",
    "Device": "H6682",
    "Model": "H6682_VDC_TZ"
  },
  {
    "Retail Branding": "Mobiwire",
    "Marketing Name": "H67A1",
    "Device": "H67A1",
    "Model": "H67A1"
  },
  {
    "Retail Branding": "Mobiwire",
    "Marketing Name": "H6821",
    "Device": "H6821",
    "Model": "H6821"
  },
  {
    "Retail Branding": "Mobiwire",
    "Marketing Name": "HALONA",
    "Device": "Halona",
    "Model": "Halona"
  },
  {
    "Retail Branding": "Mobiwire",
    "Marketing Name": "Hawk from EE",
    "Device": "Hawk_from_EE",
    "Model": "Hawk_from_EE"
  },
  {
    "Retail Branding": "Mobiwire",
    "Marketing Name": "Hotah",
    "Device": "Hotah",
    "Model": "Hotah"
  },
  {
    "Retail Branding": "Mobiwire",
    "Marketing Name": "IKOSORA+",
    "Device": "IKOSORA_Plus",
    "Model": "IKOSORA+"
  },
  {
    "Retail Branding": "Mobiwire",
    "Marketing Name": "Kicka 4 Plus",
    "Device": "Kicka_4_Plus",
    "Model": "Kicka_4_Plus"
  },
  {
    "Retail Branding": "Mobiwire",
    "Marketing Name": "Kicka 5",
    "Device": "Kicka_5",
    "Model": "Kicka 5"
  },
  {
    "Retail Branding": "Mobiwire",
    "Marketing Name": "Kicka 5",
    "Device": "Kicka_5_U",
    "Model": "Kicka 5"
  },
  {
    "Retail Branding": "Mobiwire",
    "Marketing Name": "Kicka 5 Plus",
    "Device": "Kicka_5_Plus",
    "Model": "Kicka 5 Plus"
  },
  {
    "Retail Branding": "Mobiwire",
    "Marketing Name": "Kicka 5 Plus 4G",
    "Device": "H5032U",
    "Model": "Kicka 5 Plus 4G"
  },
  {
    "Retail Branding": "Mobiwire",
    "Marketing Name": "Kicka 5 Plus 4G",
    "Device": "K5P_4G",
    "Model": "Kicka 5 Plus 4G"
  },
  {
    "Retail Branding": "Mobiwire",
    "Marketing Name": "Kicka 5 Plus 4G",
    "Device": "K5P_4G_U",
    "Model": "Kicka 5 Plus 4G"
  },
  {
    "Retail Branding": "Mobiwire",
    "Marketing Name": "Kicka 6 Plus 4G",
    "Device": "H5032U",
    "Model": "Kicka 6 Plus 4G"
  },
  {
    "Retail Branding": "Mobiwire",
    "Marketing Name": "Kicka Zoom",
    "Device": "Kicka_Zoom",
    "Model": "Kicka Zoom"
  },
  {
    "Retail Branding": "Mobiwire",
    "Marketing Name": "Kicka6",
    "Device": "Kicka6",
    "Model": "Kicka6"
  },
  {
    "Retail Branding": "Mobiwire",
    "Marketing Name": "Kiona",
    "Device": "Kiona",
    "Model": "Kiona"
  },
  {
    "Retail Branding": "Mobiwire",
    "Marketing Name": "Kohana",
    "Device": "Kohana",
    "Model": "Kohana"
  },
  {
    "Retail Branding": "Mobiwire",
    "Marketing Name": "Kosumi",
    "Device": "Kosumi",
    "Model": "Kosumi"
  },
  {
    "Retail Branding": "Mobiwire",
    "Marketing Name": "Kwanita",
    "Device": "Kwanita",
    "Model": "KWANITA"
  },
  {
    "Retail Branding": "Mobiwire",
    "Marketing Name": "Lonan",
    "Device": "Lonan",
    "Model": "Lonan"
  },
  {
    "Retail Branding": "Mobiwire",
    "Marketing Name": "MobiTab",
    "Device": "WM26",
    "Model": "WM26"
  },
  {
    "Retail Branding": "Mobiwire",
    "Marketing Name": "MobiWire Halona",
    "Device": "Halona",
    "Model": "Halona"
  },
  {
    "Retail Branding": "Mobiwire",
    "Marketing Name": "MobiWire Kanuna",
    "Device": "Kanuna_MobiWire",
    "Model": "KANUNA"
  },
  {
    "Retail Branding": "Mobiwire",
    "Marketing Name": "MobiWire Kaya",
    "Device": "Kaya_EU_SKU1",
    "Model": "KAYA"
  },
  {
    "Retail Branding": "Mobiwire",
    "Marketing Name": "MobiWire Kosumi",
    "Device": "Kosumi",
    "Model": "Kosumi"
  },
  {
    "Retail Branding": "Mobiwire",
    "Marketing Name": "Mobiwire Verda",
    "Device": "Verda",
    "Model": "Mobiwire Verda"
  },
  {
    "Retail Branding": "Mobiwire",
    "Marketing Name": "Moov Smart Max",
    "Device": "H67A1",
    "Model": "Moov Smart Max"
  },
  {
    "Retail Branding": "Mobiwire",
    "Marketing Name": "ONE",
    "Device": "H5032U",
    "Model": "ONE"
  },
  {
    "Retail Branding": "Mobiwire",
    "Marketing Name": "Pegasus",
    "Device": "Pegasus",
    "Model": "Pegasus"
  },
  {
    "Retail Branding": "Mobiwire",
    "Marketing Name": "S26",
    "Device": "H5112",
    "Model": "S26"
  },
  {
    "Retail Branding": "Mobiwire",
    "Marketing Name": "S4040",
    "Device": "S4040",
    "Model": "S4040"
  },
  {
    "Retail Branding": "Mobiwire",
    "Marketing Name": "STARSHINE 5",
    "Device": "Cygnus_mini",
    "Model": "STARSHINE5"
  },
  {
    "Retail Branding": "Mobiwire",
    "Marketing Name": "STARSHINE 5",
    "Device": "Cygnus_mini",
    "Model": "STARSHINE_5"
  },
  {
    "Retail Branding": "Mobiwire",
    "Marketing Name": "STARSHINE 5",
    "Device": "Cygnus_mini",
    "Model": "Smart_A25"
  },
  {
    "Retail Branding": "Mobiwire",
    "Marketing Name": "STARXTREM 5",
    "Device": "STARXTREM5",
    "Model": "STARXTREM5"
  },
  {
    "Retail Branding": "Mobiwire",
    "Marketing Name": "Smart C11",
    "Device": "Kicka_5_U",
    "Model": "Smart C11"
  },
  {
    "Retail Branding": "Mobiwire",
    "Marketing Name": "Smart E11",
    "Device": "Smart_E11",
    "Model": "SmartE11"
  },
  {
    "Retail Branding": "Mobiwire",
    "Marketing Name": "Smart E11",
    "Device": "Smart_E11_1",
    "Model": "SmartE11"
  },
  {
    "Retail Branding": "Mobiwire",
    "Marketing Name": "Smart E25",
    "Device": "Smart_E25",
    "Model": "Smart E25"
  },
  {
    "Retail Branding": "Mobiwire",
    "Marketing Name": "Smart Green",
    "Device": "MobiWire_Verda",
    "Model": "Smart_Green"
  },
  {
    "Retail Branding": "Mobiwire",
    "Marketing Name": "Smart Green",
    "Device": "MobiWire_Verda",
    "Model": "Vodafone Lite 4G"
  },
  {
    "Retail Branding": "Mobiwire",
    "Marketing Name": "Smart N11",
    "Device": "Smart_N11",
    "Model": "SmartN11"
  },
  {
    "Retail Branding": "Mobiwire",
    "Marketing Name": "Smart N12",
    "Device": "Smart_N12",
    "Model": "SmartN12"
  },
  {
    "Retail Branding": "Mobiwire",
    "Marketing Name": "Smart P24",
    "Device": "Smart_P24",
    "Model": "Smart_P24"
  },
  {
    "Retail Branding": "Mobiwire",
    "Marketing Name": "Smart V25",
    "Device": "Smart_V25",
    "Model": "Smart V25"
  },
  {
    "Retail Branding": "Mobiwire",
    "Marketing Name": "SmartT23",
    "Device": "Smart_T23",
    "Model": "SmartT23"
  },
  {
    "Retail Branding": "Mobiwire",
    "Marketing Name": "Tala",
    "Device": "Tala",
    "Model": "Tala"
  },
  {
    "Retail Branding": "Mobiwire",
    "Marketing Name": "Telenor SmartPlus",
    "Device": "Telenor_SmartPlus",
    "Model": "Telenor_SmartPlus"
  },
  {
    "Retail Branding": "Mobiwire",
    "Marketing Name": "Telstra Lite Plus",
    "Device": "Telstra_Lite_Plus",
    "Model": "Telstra Lite Plus"
  },
  {
    "Retail Branding": "Mobiwire",
    "Marketing Name": "V Lite 2",
    "Device": "V_Lite_2",
    "Model": "V Lite 2"
  },
  {
    "Retail Branding": "Mobiwire",
    "Marketing Name": "V Pro 2 4G",
    "Device": "V_Pro_2",
    "Model": "V Pro 2"
  },
  {
    "Retail Branding": "Mobiwire",
    "Marketing Name": "V Smart 2",
    "Device": "V_Smart_2",
    "Model": "V Smart 2"
  },
  {
    "Retail Branding": "Mobiwire",
    "Marketing Name": "V.40",
    "Device": "Nextel",
    "Model": "V.40"
  },
  {
    "Retail Branding": "Mobiwire",
    "Marketing Name": "V.45",
    "Device": "VSN",
    "Model": "V.45S"
  },
  {
    "Retail Branding": "Mobiwire",
    "Marketing Name": "VSN V.45",
    "Device": "up06_h26_v45",
    "Model": "V.45"
  },
  {
    "Retail Branding": "Mobiwire",
    "Marketing Name": "Verda",
    "Device": "MobiWire_Verda",
    "Model": "Smart_Green_EEA"
  },
  {
    "Retail Branding": "Mobiwire",
    "Marketing Name": "Verda",
    "Device": "MobiWire_Verda",
    "Model": "Verda"
  },
  {
    "Retail Branding": "Mobiwire",
    "Marketing Name": "Vodafone Lite 4G",
    "Device": "MobiWire_Verda",
    "Model": "Vodafone Lite 4G"
  },
  {
    "Retail Branding": "Mobiwire",
    "Marketing Name": "Vodafone Pro 4G",
    "Device": "Vodafone_Pro",
    "Model": "Vodafone Pro 4G"
  },
  {
    "Retail Branding": "Mobiwire",
    "Marketing Name": "Vodafone Smart 4G",
    "Device": "Vodafone_Smart",
    "Model": "Vodafone Smart 4G"
  },
  {
    "Retail Branding": "Mobiwire",
    "Marketing Name": "Éɖjròmi",
    "Device": "Edjromi",
    "Model": "Edjromi"
  },
  {
    "Retail Branding": "Mobvoi",
    "Marketing Name": "TicWatch Atlas;TicWatch Pro 5;TicWatch Pro 5 Enduro",
    "Device": "dace",
    "Model": "TicWatch Pro 5"
  },
  {
    "Retail Branding": "Mobvoi",
    "Marketing Name": "TicWatch C2",
    "Device": "skipjack",
    "Model": "TicWatch C2"
  },
  {
    "Retail Branding": "Mobvoi",
    "Marketing Name": "TicWatch C2",
    "Device": "skipjack",
    "Model": "TicWatch C2+"
  },
  {
    "Retail Branding": "Mobvoi",
    "Marketing Name": "TicWatch E2/S2",
    "Device": "tunny",
    "Model": "TicWatch E2"
  },
  {
    "Retail Branding": "Mobvoi",
    "Marketing Name": "TicWatch E2/S2",
    "Device": "tunny",
    "Model": "TicWatch S2"
  },
  {
    "Retail Branding": "Mobvoi",
    "Marketing Name": "TicWatch E3",
    "Device": "ricefish",
    "Model": "TicWatch E3"
  },
  {
    "Retail Branding": "Mobvoi",
    "Marketing Name": "TicWatch Pro",
    "Device": "catfish",
    "Model": "TicWatch Pro"
  },
  {
    "Retail Branding": "Mobvoi",
    "Marketing Name": "TicWatch Pro",
    "Device": "catfish_ext",
    "Model": "TicWatch Pro"
  },
  {
    "Retail Branding": "Mobvoi",
    "Marketing Name": "TicWatch Pro",
    "Device": "catfish_ext",
    "Model": "TicWatch Pro S"
  },
  {
    "Retail Branding": "Mobvoi",
    "Marketing Name": "TicWatch Pro 3",
    "Device": "rover",
    "Model": "TicWatch Pro 3"
  },
  {
    "Retail Branding": "Mobvoi",
    "Marketing Name": "TicWatch Pro 3",
    "Device": "rover",
    "Model": "TicWatch Pro X"
  },
  {
    "Retail Branding": "Mobvoi",
    "Marketing Name": "TicWatch Pro 3 Cellular/LTE; TicWatch Pro 3 Ultra",
    "Device": "rover",
    "Model": "TicWatch Pro 3"
  },
  {
    "Retail Branding": "Mobvoi",
    "Marketing Name": "TicWatch Pro 3 Cellular/LTE; TicWatch Pro 3 Ultra",
    "Device": "rover",
    "Model": "TicWatch Pro 3 Ultra"
  },
  {
    "Retail Branding": "Mobvoi",
    "Marketing Name": "TicWatch Pro 3 GPS; TicWatch Pro 3 Ultra GPS",
    "Device": "rubyfish",
    "Model": "TicWatch Pro 3 GPS"
  },
  {
    "Retail Branding": "Mobvoi",
    "Marketing Name": "TicWatch Pro 3 GPS; TicWatch Pro 3 Ultra GPS",
    "Device": "rubyfish",
    "Model": "TicWatch Pro 3 Ultra GPS"
  },
  {
    "Retail Branding": "Mobvoi",
    "Marketing Name": "TicWatch Pro 3 GPS; TicWatch Pro 3 Ultra GPS",
    "Device": "rubyfish",
    "Model": "TicWatch Pro 3U"
  },
  {
    "Retail Branding": "Mobvoi",
    "Marketing Name": "TicWatch Pro 4G",
    "Device": "catshark",
    "Model": "TicWatch Pro 4G"
  },
  {
    "Retail Branding": "Mobvoi",
    "Marketing Name": "Ticwatch Pro 4G",
    "Device": "catshark",
    "Model": "TicWatch Pro 4G"
  },
  {
    "Retail Branding": "Mobvoi",
    "Marketing Name": "Ticwatch S Smartwatch; Ticwatch E Smartwatch",
    "Device": "mooneye",
    "Model": "Ticwatch E"
  },
  {
    "Retail Branding": "Mobvoi",
    "Marketing Name": "Ticwatch S Smartwatch; Ticwatch E Smartwatch",
    "Device": "mooneye",
    "Model": "Ticwatch S"
  },
  {
    "Retail Branding": "MobyData",
    "Marketing Name": "M72",
    "Device": "M72",
    "Model": "M72"
  },
  {
    "Retail Branding": "MobyData",
    "Marketing Name": "M93",
    "Device": "M93",
    "Model": "M93"
  },
  {
    "Retail Branding": "MobyData",
    "Marketing Name": "M93_5G",
    "Device": "M93_5G",
    "Model": "M93 5G"
  },
  {
    "Retail Branding": "MobyData",
    "Marketing Name": "m63",
    "Device": "m63s",
    "Model": "m63"
  },
  {
    "Retail Branding": "Mode1",
    "Marketing Name": "MD-03P",
    "Device": "MD-03P",
    "Model": "MD-03P"
  },
  {
    "Retail Branding": "Mode1",
    "Marketing Name": "MD-04P",
    "Device": "MD-04P",
    "Model": "MD-04P"
  },
  {
    "Retail Branding": "Mode1",
    "Marketing Name": "MD-05P",
    "Device": "MD-05P",
    "Model": "MD-05P"
  },
  {
    "Retail Branding": "Mode1",
    "Marketing Name": "MD06P",
    "Device": "MD06P",
    "Model": "MD06P"
  },
  {
    "Retail Branding": "Mode1",
    "Marketing Name": "MP1",
    "Device": "MP1",
    "Model": "MD_G1212U"
  },
  {
    "Retail Branding": "Mode1",
    "Marketing Name": "Mode1Pocket",
    "Device": "MD-07P",
    "Model": "MD-07P"
  },
  {
    "Retail Branding": "ModeEarnPhone",
    "Marketing Name": "MEP2",
    "Device": "MEP2",
    "Model": "MEP2Q421G"
  },
  {
    "Retail Branding": "Modecom",
    "Marketing Name": "ECHO LOLLY",
    "Device": "ECHO_LOLLY",
    "Model": "ECHO LOLLY"
  },
  {
    "Retail Branding": "Modecom",
    "Marketing Name": "FreeTAB 10.1 Silver",
    "Device": "silver",
    "Model": "FreeTAB 10.1 Silver"
  },
  {
    "Retail Branding": "Modecom",
    "Marketing Name": "FreeTAB 8015 IPS X4 LTE",
    "Device": "reverie",
    "Model": "FreeTAB 8015 IPS X4"
  },
  {
    "Retail Branding": "Modecom",
    "Marketing Name": "Horizon Lite Plus",
    "Device": "HORIZON_LITE_PLUS",
    "Model": "HORIZON LITE PLUS"
  },
  {
    "Retail Branding": "Modecom",
    "Marketing Name": "Xino Z46 X4+",
    "Device": "xino_z46",
    "Model": "Xino Z46 X4+"
  },
  {
    "Retail Branding": "Mohu",
    "Marketing Name": "MH-CHANNELS",
    "Device": "MH-CHANNELS",
    "Model": "MH-CHANNELS"
  },
  {
    "Retail Branding": "MojaTV",
    "Marketing Name": "B866V2H",
    "Device": "STB_B866V2H",
    "Model": "B866V2H"
  },
  {
    "Retail Branding": "MojaTV",
    "Marketing Name": "MojaTV",
    "Device": "SEI530BHT",
    "Model": "Moja TV"
  },
  {
    "Retail Branding": "Moka",
    "Marketing Name": "POS_Device_Moka_Prime",
    "Device": "POS_Device",
    "Model": "Moka_Prime"
  },
  {
    "Retail Branding": "Mola TV",
    "Marketing Name": "PDBM11ADL",
    "Device": "DV8235_P",
    "Model": "PDBM11ADL"
  },
  {
    "Retail Branding": "Molvu",
    "Marketing Name": "M10PRO",
    "Device": "M10PRO",
    "Model": "M10PRO"
  },
  {
    "Retail Branding": "Molvu",
    "Marketing Name": "V7S",
    "Device": "V7S",
    "Model": "V7S"
  },
  {
    "Retail Branding": "Molvu",
    "Marketing Name": "V8S",
    "Device": "V8S",
    "Model": "V8S"
  },
  {
    "Retail Branding": "Mondial",
    "Marketing Name": "MONDIAL 4K TV",
    "Device": "SW4H",
    "Model": "MONDIAL 4K TV"
  },
  {
    "Retail Branding": "Mondial",
    "Marketing Name": "MONDIAL Smart TV",
    "Device": "sunnyvale",
    "Model": "MONDIAL Smart TV"
  },
  {
    "Retail Branding": "Mondial",
    "Marketing Name": "MONDIAL TV",
    "Device": "shinjuku",
    "Model": "MONDIAL TV"
  },
  {
    "Retail Branding": "Mondial",
    "Marketing Name": "TB-MONDIAL",
    "Device": "TB_MONDIAL",
    "Model": "TB_MONDIAL"
  },
  {
    "Retail Branding": "Mondial",
    "Marketing Name": "TB_MONDIAL_KID",
    "Device": "TB_MONDIAL_KID",
    "Model": "TB_MONDIAL_KID"
  },
  {
    "Retail Branding": "Monster",
    "Marketing Name": "M10",
    "Device": "M10",
    "Model": "M10"
  },
  {
    "Retail Branding": "Monster",
    "Marketing Name": "MONSTER",
    "Device": "shilin",
    "Model": "MONSTER4KAndroidTV"
  },
  {
    "Retail Branding": "Monsterpad",
    "Marketing Name": "Monsterpad7",
    "Device": "Monsterpad7",
    "Model": "Monsterpad7"
  },
  {
    "Retail Branding": "Montblanc",
    "Marketing Name": "SUMMIT",
    "Device": "lionfish",
    "Model": "MB SUMMIT"
  },
  {
    "Retail Branding": "Montblanc",
    "Marketing Name": "SUMMIT",
    "Device": "triton",
    "Model": "SUMMIT"
  },
  {
    "Retail Branding": "Montblanc",
    "Marketing Name": "Summit",
    "Device": "bluefish",
    "Model": "SUMMIT"
  },
  {
    "Retail Branding": "Montblanc",
    "Marketing Name": "Summit",
    "Device": "lionfish",
    "Model": "MB SUMMIT"
  },
  {
    "Retail Branding": "Montblanc",
    "Marketing Name": "Summit 2+",
    "Device": "coralia",
    "Model": "Summit 2+"
  },
  {
    "Retail Branding": "Montblanc",
    "Marketing Name": "Summit Lite",
    "Device": "icefish",
    "Model": "SUMMIT LITE"
  },
  {
    "Retail Branding": "Mookia",
    "Marketing Name": "FF-P30",
    "Device": "FF-P30",
    "Model": "FF-P30"
  },
  {
    "Retail Branding": "Mookia",
    "Marketing Name": "M-764",
    "Device": "M-764",
    "Model": "M-764"
  },
  {
    "Retail Branding": "Mookia",
    "Marketing Name": "M-764-EEA",
    "Device": "M-764-EEA",
    "Model": "M-764-EEA"
  },
  {
    "Retail Branding": "Mookia",
    "Marketing Name": "M10A",
    "Device": "M10A",
    "Model": "M10A"
  },
  {
    "Retail Branding": "Mookia",
    "Marketing Name": "MM-35",
    "Device": "MM-35",
    "Model": "MM-35"
  },
  {
    "Retail Branding": "Mookia",
    "Marketing Name": "MM-35_EEA",
    "Device": "MM-35_EEA",
    "Model": "MM-35_EEA"
  },
  {
    "Retail Branding": "Mookia",
    "Marketing Name": "MM10A",
    "Device": "MM10A",
    "Model": "MM10A"
  },
  {
    "Retail Branding": "Mookia",
    "Marketing Name": "YY-P30",
    "Device": "YY-P30",
    "Model": "YY-P30"
  },
  {
    "Retail Branding": "Moolah Mobile",
    "Marketing Name": "T10",
    "Device": "T10",
    "Model": "T10"
  },
  {
    "Retail Branding": "Moolah Mobile",
    "Marketing Name": "T100",
    "Device": "T100",
    "Model": "T100"
  },
  {
    "Retail Branding": "Moolah Mobile",
    "Marketing Name": "T10_Pro",
    "Device": "T10_Pro",
    "Model": "T10_Pro"
  },
  {
    "Retail Branding": "Moov",
    "Marketing Name": "MOOV SMART PRO PLUS",
    "Device": "H6573",
    "Model": "MOOV SMART PRO PLUS"
  },
  {
    "Retail Branding": "Moov_Africa",
    "Marketing Name": "S100",
    "Device": "S100",
    "Model": "S100"
  },
  {
    "Retail Branding": "Morep",
    "Marketing Name": "Mavic 10",
    "Device": "Mavic_30",
    "Model": "M850"
  },
  {
    "Retail Branding": "Morep",
    "Marketing Name": "Mavic 40",
    "Device": "mavic_40",
    "Model": "morep_mavic_40"
  },
  {
    "Retail Branding": "Morep",
    "Marketing Name": "Mavic_Plus_DS",
    "Device": "Mavic_Plus",
    "Model": "M610DS"
  },
  {
    "Retail Branding": "Morep",
    "Marketing Name": "Morep Mavic 10",
    "Device": "Mavic_10",
    "Model": "M830"
  },
  {
    "Retail Branding": "Morep",
    "Marketing Name": "Morep Mavic 20",
    "Device": "mavic_20",
    "Model": "morep_mavic_20"
  },
  {
    "Retail Branding": "Morep",
    "Marketing Name": "Morep Mavic Plus",
    "Device": "Mavic_Plus",
    "Model": "M610"
  },
  {
    "Retail Branding": "Morep",
    "Marketing Name": "Morep Pocket",
    "Device": "Morep_Pocket",
    "Model": "M320"
  },
  {
    "Retail Branding": "Morep",
    "Marketing Name": "Smart V1",
    "Device": "Smart_V1",
    "Model": "M521"
  },
  {
    "Retail Branding": "Morep",
    "Marketing Name": "v5",
    "Device": "morep_v5",
    "Model": "morep_v5"
  },
  {
    "Retail Branding": "Mosambee",
    "Marketing Name": "Qphone2 4110",
    "Device": "Qphone2_4110",
    "Model": "Qphone2_4110"
  },
  {
    "Retail Branding": "Mosambee",
    "Marketing Name": "SPPF 4110",
    "Device": "SPPF_4110",
    "Model": "SPPF_4110"
  },
  {
    "Retail Branding": "Mosambee",
    "Marketing Name": "Z100",
    "Device": "Z100",
    "Model": "Z100"
  },
  {
    "Retail Branding": "MoshiMore",
    "Marketing Name": "RG1",
    "Device": "RG1",
    "Model": "RG1"
  },
  {
    "Retail Branding": "Most Computers",
    "Marketing Name": "Revo You",
    "Device": "RevoYou",
    "Model": "RevoYou"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "",
    "Device": "A853",
    "Model": "Milestone"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "",
    "Device": "ArgonSpin",
    "Model": "XT550"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "",
    "Device": "Graham",
    "Model": "MZ505"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "",
    "Device": "TAHITI",
    "Model": "MT620"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "",
    "Device": "Triumph",
    "Model": "MOTWX435KT"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "",
    "Device": "XT311",
    "Model": "XT311"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "",
    "Device": "XT316",
    "Model": "XT316"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "",
    "Device": "XT317",
    "Model": "XT317"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "",
    "Device": "XT319",
    "Model": "XT319"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "",
    "Device": "XT530",
    "Model": "XT530"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "",
    "Device": "XT531",
    "Model": "XT531"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "",
    "Device": "XT532",
    "Model": "XT532"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "",
    "Device": "argonspin_umts",
    "Model": "XT550"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "",
    "Device": "cdma_kronos",
    "Model": "MB612"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "",
    "Device": "cdma_pax",
    "Model": "XT603"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "",
    "Device": "cdma_solana",
    "Model": "MILESTONE3"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "",
    "Device": "cdma_spyder",
    "Model": "DROID RAZR"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "",
    "Device": "cdma_spyder",
    "Model": "IS12M"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "",
    "Device": "cdma_spyder",
    "Model": "Motorola RAZR MAXX"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "",
    "Device": "cdma_targa",
    "Model": "DROID BIONIC"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "",
    "Device": "cg_tita2",
    "Model": "XT800+"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "",
    "Device": "choi",
    "Model": "XT711"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "",
    "Device": "choles",
    "Model": "XT701"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "",
    "Device": "destino",
    "Model": "i867"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "",
    "Device": "dominoq_umts",
    "Model": "XT316"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "",
    "Device": "edison",
    "Model": "MB865"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "",
    "Device": "edison",
    "Model": "ME865"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "",
    "Device": "fawnridge",
    "Model": "i940"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "",
    "Device": "fleming",
    "Model": "MZ607"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "",
    "Device": "fleming",
    "Model": "MZ608"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "",
    "Device": "fleming",
    "Model": "MZ609"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "",
    "Device": "fleming",
    "Model": "XOOM 2 ME"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "",
    "Device": "graham_wifi",
    "Model": "MZ505"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "",
    "Device": "iDEN",
    "Model": "Motorola_i1"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "",
    "Device": "morr",
    "Model": "MB200"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "",
    "Device": "pasteur",
    "Model": "MZ616"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "",
    "Device": "pasteur",
    "Model": "MZ617"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "",
    "Device": "pasteur",
    "Model": "XOOM 2"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "",
    "Device": "qilin",
    "Model": "XT806"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "",
    "Device": "scorpion_mini_u",
    "Model": "XT905"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "",
    "Device": "smq_u",
    "Model": "XT905"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "",
    "Device": "swordfish",
    "Model": "XT882"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "",
    "Device": "tinq_umts",
    "Model": "XT560"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "",
    "Device": "ttu_skt",
    "Model": "XT800W"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "",
    "Device": "umts_begonia",
    "Model": "MB610"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "",
    "Device": "umts_begonia",
    "Model": "MB611"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "",
    "Device": "umts_elway",
    "Model": "MB632"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "",
    "Device": "umts_elway",
    "Model": "ME632"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "",
    "Device": "umts_hubble",
    "Model": "MZ605"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "",
    "Device": "umts_kobe",
    "Model": "MB520"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "",
    "Device": "umts_lucky",
    "Model": "A1680"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "",
    "Device": "umts_sage",
    "Model": "MB508"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "",
    "Device": "umts_solana",
    "Model": "ME863"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "",
    "Device": "umts_solana",
    "Model": "XT860"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "",
    "Device": "umts_spyder",
    "Model": "XT910"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "",
    "Device": "umts_spyder",
    "Model": "XT910K"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "",
    "Device": "umts_spyder",
    "Model": "XT910S"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "",
    "Device": "umts_venus2",
    "Model": "XT610"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "",
    "Device": "wifi_hubble",
    "Model": "MZ604"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "",
    "Device": "zepp",
    "Model": "MB501"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "4K TV",
    "Device": "songshan",
    "Model": "SmartTV 4K"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "4K TV",
    "Device": "songshan",
    "Model": "SmartTV 4K FFM"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Android TV",
    "Device": "redwood",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Atrix",
    "Device": "olympus",
    "Model": "MB860"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Atrix",
    "Device": "olympus",
    "Model": "MB861"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Atrix",
    "Device": "olympus",
    "Model": "ME860"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Atrix HD",
    "Device": "qinara",
    "Model": "MB886"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Backflip",
    "Device": "motus",
    "Model": "MB300"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Backflip",
    "Device": "motus",
    "Model": "ME600"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "CLIQ",
    "Device": "morrison",
    "Model": "MB200"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "CLIQ",
    "Device": "morrison",
    "Model": "morrison"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Charm",
    "Device": "umts_basil",
    "Model": "MB502"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Citrus",
    "Device": "cdma_ciena",
    "Model": "WX442"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Citrus",
    "Device": "cdma_ciena",
    "Model": "WX445"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Citrus",
    "Device": "cdma_ciena",
    "Model": "XT301"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Cliq-XT",
    "Device": "zeppelin",
    "Model": "MB501"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Cliq-XT",
    "Device": "zeppelin",
    "Model": "ME501"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "DROID MAXX 2",
    "Device": "lux",
    "Model": "XT1021"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "DROID MAXX 2",
    "Device": "lux",
    "Model": "XT1565"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "DROID RAZR HD",
    "Device": "vanquish",
    "Model": "DROID RAZR HD"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "DROID RAZR HD",
    "Device": "vanquish_u",
    "Model": "RAZR HD"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "DROID RAZR HD",
    "Device": "vanquish_u",
    "Model": "XT925"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "DROID RAZR M",
    "Device": "scorpion_mini",
    "Model": "XT907"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "DROID RAZR i",
    "Device": "smi",
    "Model": "XT890"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "DROID Turbo 2",
    "Device": "kinzie",
    "Model": "XT1585"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "DROID4",
    "Device": "cdma_maserati",
    "Model": "DROID4"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "DVM4KA01",
    "Device": "GMP",
    "Model": "DVM4KA01"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Defy",
    "Device": "umts_jordan",
    "Model": "MB525"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Defy",
    "Device": "umts_jordan",
    "Model": "MB526"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Defy",
    "Device": "umts_jordan",
    "Model": "ME525"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Defy",
    "Device": "umts_jordan",
    "Model": "ME525+"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Defy",
    "Device": "umts_jordan",
    "Model": "unknown"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Defy Mini",
    "Device": "TinBoost",
    "Model": "XT320"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Defy Mini",
    "Device": "TinBoost",
    "Model": "XT321"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Defy Mini",
    "Device": "tinboost_umts",
    "Model": "XT320"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Defy Mini",
    "Device": "tinboost_umts",
    "Model": "XT321"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Defy Pro",
    "Device": "XT560",
    "Model": "XT560"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Devour",
    "Device": "calgary",
    "Model": "Devour"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Devour",
    "Device": "calgary",
    "Model": "calgary"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Droid",
    "Device": "miler",
    "Model": "A854"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Droid",
    "Device": "sholes",
    "Model": "Droid"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Droid",
    "Device": "umts_sholes",
    "Model": "A853"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Droid",
    "Device": "umts_sholes",
    "Model": "Milestone"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Droid",
    "Device": "umts_sholes",
    "Model": "XT701"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Droid",
    "Device": "umts_sholes",
    "Model": "XT702"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Droid",
    "Device": "umts_sholes",
    "Model": "XT720"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Droid",
    "Device": "umts_sholes",
    "Model": "umts"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Droid 3",
    "Device": "cdma_solana",
    "Model": "DROID3"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Droid 4",
    "Device": "cdma_maserati",
    "Model": "DROID4"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Droid Bionic",
    "Device": "cdma_targa",
    "Model": "DROID BIONIC"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Droid II",
    "Device": "cdma_droid2",
    "Model": "A955"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Droid II",
    "Device": "cdma_droid2",
    "Model": "DROID2"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Droid II",
    "Device": "cdma_droid2we",
    "Model": "DROID2 GLOBAL"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Droid MAXX",
    "Device": "obake-maxx",
    "Model": "XT1080"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Droid Mini",
    "Device": "obakem",
    "Model": "XT1030"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Droid Pro",
    "Device": "cdma_venus2",
    "Model": "DROID PRO"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Droid Pro",
    "Device": "cdma_venus2",
    "Model": "DROID Pro"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Droid Pro",
    "Device": "cdma_venus2",
    "Model": "Milestone PLUS"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Droid Pro",
    "Device": "cdma_venus2",
    "Model": "XT610"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Droid RAZR",
    "Device": "umts_spyder",
    "Model": "XT910"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Droid Razr M",
    "Device": "scorpion_mini_t",
    "Model": "201M"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Droid Turbo",
    "Device": "quark",
    "Model": "XT1250"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Droid Turbo",
    "Device": "quark",
    "Model": "XT1254"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Droid Ultra",
    "Device": "obake",
    "Model": "XT1080"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Droid X",
    "Device": "cdma_shadow",
    "Model": "DROIDX"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Droid X",
    "Device": "cdma_shadow",
    "Model": "MB810"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Droid X",
    "Device": "cdma_shadow",
    "Model": "ME811"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Droid X",
    "Device": "cdma_shadow",
    "Model": "Milestone X"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Droid X",
    "Device": "cdma_shadow",
    "Model": "MotoroiX"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Droid X2",
    "Device": "daytona",
    "Model": "DROID X2"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Droid X2",
    "Device": "daytona",
    "Model": "Milestone X2"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "ELECTRIFY 2",
    "Device": "cdma_yangtze",
    "Model": "XT881"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Electrify M",
    "Device": "solstice",
    "Model": "XT901"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Flipkart India Private Limited",
    "Device": "landen",
    "Model": "MOT41F"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "FlipkartTV",
    "Device": "SW4H",
    "Model": "FlipkartTV"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "FlipkartTVPro",
    "Device": "SW4H_FF",
    "Model": "FlipkartTVPro"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Flipout",
    "Device": "umts_ruth",
    "Model": "MB511"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Flipout",
    "Device": "umts_ruth",
    "Model": "ME511"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Flipout",
    "Device": "umts_ruth",
    "Model": "MotoMB511"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Glam XT800",
    "Device": "titanium",
    "Model": "XT800"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "HS1",
    "Device": "Motorola_HS1",
    "Model": "Motorola_HS1"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Iron Rock",
    "Device": "umts_irock",
    "Model": "XT627"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Lenovo K10",
    "Device": "pokerp",
    "Model": "Lenovo K10"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Lenovo K11",
    "Device": "fiji",
    "Model": "Lenovo K11"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Lenovo K11 Power",
    "Device": "blackjack",
    "Model": "Lenovo K11 Power"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Lenovo K12",
    "Device": "malta",
    "Model": "Lenovo K11"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Lenovo K12",
    "Device": "malta",
    "Model": "Lenovo K12"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Lenovo K12 Pro",
    "Device": "cebu",
    "Model": "Lenovo K12 Note"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Lenovo K12 Pro",
    "Device": "cebu",
    "Model": "Lenovo K12 Pro"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Lenovo K13",
    "Device": "maltalsc",
    "Model": "Lenovo K13"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Lenovo K13",
    "Device": "maltalsc",
    "Model": "maltalsc"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Lenovo K13 Note",
    "Device": "java",
    "Model": "Lenovo K13 Note"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Lenovo K14",
    "Device": "aruba",
    "Model": "Lenovo K14"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Lenovo K14 Note",
    "Device": "cofud",
    "Model": "Lenovo K12 Pro"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Lenovo K14 Note",
    "Device": "cofud",
    "Model": "Lenovo K14 Note"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Lenovo K14 Plus",
    "Device": "cyprus64",
    "Model": "Lenovo K14 Plus"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Lenovo K14 Plus",
    "Device": "cyprus64",
    "Model": "cyprus64"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Lenovo K15",
    "Device": "hawaii",
    "Model": "Hawaii"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Lenovo K15",
    "Device": "hawaii",
    "Model": "Lenovo K15"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Lenovo XT2081-4",
    "Device": "guam",
    "Model": "Lenovo XT2081-4"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Lenovo XT2091-7",
    "Device": "cebu",
    "Model": "Lenovo XT2091-7"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "MOTOROLA",
    "Device": "elliniko",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "MOTOROLA",
    "Device": "elliniko",
    "Model": "MOTOROLA GOOGLE TV 4K"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "MOTOROLA",
    "Device": "jagalchi",
    "Model": "MOTOROLA GOOGLE TV"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "MOTOROLA",
    "Device": "mountbaker",
    "Model": "MOTOROLA GOOGLE TV 2K"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "MOTOROLA",
    "Device": "stanford",
    "Model": "2K SMART TV"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "MOTOROLA",
    "Device": "stanford",
    "Model": "SMART TV"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "MOTOROLA",
    "Device": "stanford",
    "Model": "Smart FHD TV"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "MOTOROLA",
    "Device": "zhongshan",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "MOTOROLA",
    "Device": "zhongshan",
    "Model": "Smart UHD TV"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "MOTOROLA SMART TV",
    "Device": "umeda",
    "Model": "MOTOROLA SMART TV"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Master Touch",
    "Device": "umts_primus",
    "Model": "XT621"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Master Touch XT621",
    "Device": "umts_primus",
    "Model": "XT621"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Milestone2",
    "Device": "umts_milestone2",
    "Model": "A953"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Milestone2",
    "Device": "umts_milestone2",
    "Model": "ME722"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Milestone2",
    "Device": "umts_milestone2",
    "Model": "MotoA953"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Moto 360",
    "Device": "minnow",
    "Model": "Moto 360"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Moto 360",
    "Device": "mola",
    "Model": "Moto 360"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Moto 360 (2nd Gen)",
    "Device": "carp",
    "Model": "Moto 360"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Moto 360 (2nd Gen)",
    "Device": "smelt",
    "Model": "Moto 360"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Moto 360 Sport",
    "Device": "carp",
    "Model": "Moto 360"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Moto C",
    "Device": "namath",
    "Model": "Moto C"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Moto C",
    "Device": "namath",
    "Model": "XT1754"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Moto C",
    "Device": "namath",
    "Model": "XT1755"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Moto C",
    "Device": "watson",
    "Model": "Moto C"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Moto C Plus",
    "Device": "panell_d",
    "Model": "Moto C Plus"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Moto C Plus",
    "Device": "panell_dl",
    "Model": "Moto C Plus"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Moto C Plus",
    "Device": "panell_dt",
    "Model": "Moto C Plus"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Moto C Plus",
    "Device": "panell_s",
    "Model": "Moto C Plus"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Moto Defy XT",
    "Device": "XT535",
    "Model": "XT535"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Moto Defy XT",
    "Device": "tinboostplus_cdma",
    "Model": "XT555C"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Moto Defy XT",
    "Device": "tinboostplus_cdma",
    "Model": "XT556"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Moto Defy XT",
    "Device": "tinboostplus_cdma",
    "Model": "XT557"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Moto Defy XT",
    "Device": "tinboostplus_umts",
    "Model": "XT535"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Moto E (1st Gen)",
    "Device": "condor_cdma",
    "Model": "XT1019"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Moto E (1st Gen)",
    "Device": "condor_cdma",
    "Model": "XT830C"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Moto E (1st Gen)",
    "Device": "condor_udstv",
    "Model": "XT1025"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Moto E (1st Gen)",
    "Device": "condor_umts",
    "Model": "XT1021"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Moto E (1st Gen)",
    "Device": "condor_umts",
    "Model": "XT1023"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Moto E (1st Gen)",
    "Device": "condor_umtsds",
    "Model": "XT1022"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Moto E (2nd Gen)",
    "Device": "otus",
    "Model": "MotoE2"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Moto E (2nd Gen)",
    "Device": "otus",
    "Model": "XT0000"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Moto E (2nd Gen)",
    "Device": "otus_ds",
    "Model": "MotoE2"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Moto E (2nd Gen)",
    "Device": "otus_ds",
    "Model": "XT1021"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Moto E (4)",
    "Device": "perry",
    "Model": "Moto E (4)"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Moto E (4)",
    "Device": "perry_f",
    "Model": "Moto E (4)"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Moto E (4)",
    "Device": "sperry",
    "Model": "Moto E (4)"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Moto E (4)",
    "Device": "woods_f",
    "Model": "Moto E (4)"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Moto E (4)",
    "Device": "woods_fn",
    "Model": "Moto E (4)"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Moto E (4) Plus",
    "Device": "nicklaus_f",
    "Model": "Moto E (4) Plus"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Moto E (4) Plus",
    "Device": "nicklaus_fn",
    "Model": "Moto E (4) Plus"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Moto E (4) Plus",
    "Device": "owens",
    "Model": "Moto E (4) Plus"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Moto E (5)",
    "Device": "nora_8917",
    "Model": "Moto E"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Moto E (5)",
    "Device": "nora_8917",
    "Model": "moto e5"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Moto E (5)",
    "Device": "nora_8917_n",
    "Model": "Moto E"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Moto E (5)",
    "Device": "nora_8917_n",
    "Model": "moto e5"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Moto E (5) Play",
    "Device": "rjames_f",
    "Model": "moto e5 play"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Moto E with 4G LTE (2nd Gen)",
    "Device": "surnia_cdma",
    "Model": "MotoE2"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Moto E with 4G LTE (2nd Gen)",
    "Device": "surnia_cdma",
    "Model": "MotoE2(4G-LTE)"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Moto E with 4G LTE (2nd Gen)",
    "Device": "surnia_cdma",
    "Model": "XT1526"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Moto E with 4G LTE (2nd Gen)",
    "Device": "surnia_cdma",
    "Model": "XT1528"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Moto E with 4G LTE (2nd Gen)",
    "Device": "surnia_cdma",
    "Model": "XT1528O"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Moto E with 4G LTE (2nd Gen)",
    "Device": "surnia_uds",
    "Model": "MotoE2(4G-LTE)"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Moto E with 4G LTE (2nd Gen)",
    "Device": "surnia_udstv",
    "Model": "MotoE2(4G-LTE)"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Moto E with 4G LTE (2nd Gen)",
    "Device": "surnia_umts",
    "Model": "MotoE2(4G-LTE)"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Moto E3",
    "Device": "taidos_row",
    "Model": "XT1700"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Moto E3 Power",
    "Device": "taido_row",
    "Model": "XT1706"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Moto E4",
    "Device": "perry_f",
    "Model": "Moto E (4)"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Moto G (1st Gen)",
    "Device": "falcon_cdma",
    "Model": "XT1028"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Moto G (1st Gen)",
    "Device": "falcon_cdma",
    "Model": "XT1031"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Moto G (1st Gen)",
    "Device": "falcon_cdma",
    "Model": "XT937C"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Moto G (1st Gen)",
    "Device": "falcon_umts",
    "Model": "XT1002"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Moto G (1st Gen)",
    "Device": "falcon_umts",
    "Model": "XT1003"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Moto G (1st Gen)",
    "Device": "falcon_umts",
    "Model": "XT1008"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Moto G (1st Gen)",
    "Device": "falcon_umts",
    "Model": "XT1032"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Moto G (1st Gen)",
    "Device": "falcon_umts",
    "Model": "XT1034"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Moto G (1st Gen)",
    "Device": "falcon_umts",
    "Model": "XT939G"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Moto G (1st Gen)",
    "Device": "falcon_umtsds",
    "Model": "XT1033"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Moto G (2nd Gen)",
    "Device": "titan_udstv",
    "Model": "XT1069"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Moto G (2nd Gen)",
    "Device": "titan_udstv",
    "Model": "titan_retbr_dstv"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Moto G (2nd Gen)",
    "Device": "titan_umts",
    "Model": "XT1063"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Moto G (2nd Gen)",
    "Device": "titan_umts",
    "Model": "XT1064"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Moto G (2nd Gen)",
    "Device": "titan_umtsds",
    "Model": "XT1068"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Moto G (2nd Gen)",
    "Device": "titan_umtsds",
    "Model": "titan_niibr_ds"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Moto G (3rd Gen)",
    "Device": "osprey_cdma",
    "Model": "MotoG3"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Moto G (3rd Gen)",
    "Device": "osprey_u2",
    "Model": "MotoG3"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Moto G (3rd Gen)",
    "Device": "osprey_ud2",
    "Model": "MotoG3"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Moto G (3rd Gen)",
    "Device": "osprey_uds",
    "Model": "MotoG3"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Moto G (3rd Gen)",
    "Device": "osprey_udstv",
    "Model": "MotoG3"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Moto G (3rd Gen)",
    "Device": "osprey_umts",
    "Model": "MotoG3"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Moto G (4) Play",
    "Device": "harpia_n",
    "Model": "Moto G Play"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Moto G (5)",
    "Device": "cedric",
    "Model": "Moto G (5)"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Moto G (5) Plus",
    "Device": "potter_n",
    "Model": "Moto G (4)"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Moto G (5) Plus",
    "Device": "potter_n",
    "Model": "Moto G (5) Plus"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Moto G (5S)",
    "Device": "montana",
    "Model": "Moto G (5S)"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Moto G (5S)",
    "Device": "montana",
    "Model": "XT1799-1"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Moto G (5S)",
    "Device": "montana_n",
    "Model": "Moto G (5S)"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Moto G (5S)",
    "Device": "montana_n",
    "Model": "XT1799-2"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Moto G (5S) Plus",
    "Device": "sanders",
    "Model": "Moto G (5S) Plus"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Moto G (5S) Plus",
    "Device": "sanders_n",
    "Model": "Moto G (4)"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Moto G (5S) Plus",
    "Device": "sanders_n",
    "Model": "Moto G (5S) Plus"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Moto G (5S) Plus",
    "Device": "sanders_nt",
    "Model": "Moto G (4)"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Moto G (5S) Plus",
    "Device": "sanders_nt",
    "Model": "Moto G (5S) Plus"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Moto G (5th Gen)",
    "Device": "cedric",
    "Model": "Moto G (5)"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Moto G Google Play edition",
    "Device": "falcon_umts",
    "Model": "XT1032"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Moto G Plus (5th Gen)",
    "Device": "potter",
    "Model": "Moto G (5) Plus"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Moto G Plus (5th Gen)",
    "Device": "potter_nt",
    "Model": "Moto G (5) Plus"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Moto G Turbo Edition",
    "Device": "merlin",
    "Model": "MotoG3"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Moto G Turbo Edition",
    "Device": "merlin",
    "Model": "MotoG3-TE"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Moto G with 4G LTE (1st Gen)",
    "Device": "peregrine",
    "Model": "XT1039"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Moto G with 4G LTE (1st Gen)",
    "Device": "peregrine",
    "Model": "XT1040"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Moto G with 4G LTE (1st Gen)",
    "Device": "peregrine",
    "Model": "XT1042"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Moto G with 4G LTE (1st Gen)",
    "Device": "peregrine",
    "Model": "XT1045"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Moto G with 4G LTE (2nd Gen)",
    "Device": "thea",
    "Model": "XT1072"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Moto G with 4G LTE (2nd Gen)",
    "Device": "thea_ds",
    "Model": "XT1077"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Moto G with 4G LTE (2nd Gen)",
    "Device": "thea_ds",
    "Model": "XT1079"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Moto G with 4G LTE (2nd Gen)",
    "Device": "thea_umtsds",
    "Model": "XT1063"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Moto G with 4G LTE (2nd Gen)",
    "Device": "thea_umtsds",
    "Model": "XT1078"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Moto G(4)",
    "Device": "athene",
    "Model": "Moto G (4)"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Moto G(4)",
    "Device": "athene_t",
    "Model": "Moto G (4)"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Moto G(4) Plus",
    "Device": "athene_f",
    "Model": "Moto G (4)"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Moto G4 Play",
    "Device": "harpia",
    "Model": "Moto G Play"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Moto G4 Play",
    "Device": "harpia",
    "Model": "XT1609"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Moto G4 Play",
    "Device": "harpia_t",
    "Model": "Moto G Play"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Moto MAXX",
    "Device": "quark_umts",
    "Model": "XT1225"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Moto Tab g70",
    "Device": "mototabg70",
    "Model": "moto tab g70"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Moto Tab g70",
    "Device": "mototabg70LTE",
    "Model": "moto tab g70 LTE"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Moto Turbo",
    "Device": "quark_umts",
    "Model": "XT1225"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Moto X (1st Gen)",
    "Device": "ghost",
    "Model": "XT1049"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Moto X (1st Gen)",
    "Device": "ghost",
    "Model": "XT1050"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Moto X (1st Gen)",
    "Device": "ghost",
    "Model": "XT1052"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Moto X (1st Gen)",
    "Device": "ghost",
    "Model": "XT1053"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Moto X (1st Gen)",
    "Device": "ghost",
    "Model": "XT1055"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Moto X (1st Gen)",
    "Device": "ghost",
    "Model": "XT1056"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Moto X (1st Gen)",
    "Device": "ghost",
    "Model": "XT1058"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Moto X (1st Gen)",
    "Device": "ghost",
    "Model": "XT1060"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Moto X (2nd Gen)",
    "Device": "victara",
    "Model": "XT1085"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Moto X (2nd Gen)",
    "Device": "victara",
    "Model": "XT1092"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Moto X (2nd Gen)",
    "Device": "victara",
    "Model": "XT1093"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Moto X (2nd Gen)",
    "Device": "victara",
    "Model": "XT1094"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Moto X (2nd Gen)",
    "Device": "victara",
    "Model": "XT1095"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Moto X (2nd Gen)",
    "Device": "victara",
    "Model": "XT1096"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Moto X (2nd Gen)",
    "Device": "victara",
    "Model": "XT1097"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Moto X (2nd Gen)",
    "Device": "victara",
    "Model": "XT1098"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Moto X (4)",
    "Device": "payton",
    "Model": "XT1789-05"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Moto X (4)",
    "Device": "payton",
    "Model": "moto x4"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Moto X (4)",
    "Device": "payton_sprout",
    "Model": "moto x4"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Moto X Force",
    "Device": "kinzie",
    "Model": "XT1580"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Moto X Force",
    "Device": "kinzie_uds",
    "Model": "XT1580"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Moto X Force",
    "Device": "kinzie_uds",
    "Model": "XT1581"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Moto X Play",
    "Device": "lux",
    "Model": "Moto X Play"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Moto X Play",
    "Device": "lux",
    "Model": "XT1021"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Moto X Play",
    "Device": "lux",
    "Model": "XT1562"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Moto X Play",
    "Device": "lux",
    "Model": "XT1563"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Moto X Play",
    "Device": "lux",
    "Model": "XT1564"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Moto X Play",
    "Device": "lux_uds",
    "Model": "Moto X Play"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Moto X Play",
    "Device": "lux_uds",
    "Model": "XT1021"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Moto X Play",
    "Device": "lux_uds",
    "Model": "XT1562"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Moto X Play",
    "Device": "lux_uds",
    "Model": "XT1563"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Moto X Pro (China)",
    "Device": "shamu_t",
    "Model": "Moto X Pro"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Moto X Pure Edition",
    "Device": "clark",
    "Model": "XT1575"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Moto X Style",
    "Device": "clark",
    "Model": "XT1572"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Moto X Style",
    "Device": "clark_ds",
    "Model": "XT1570"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Moto X Style",
    "Device": "clark_ds",
    "Model": "XT1572"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Moto Z",
    "Device": "griffin",
    "Model": "XT1650"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Moto Z",
    "Device": "griffin",
    "Model": "XT1650-05"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Moto Z (2) Force",
    "Device": "nash",
    "Model": "Moto Z (2)"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Moto Z (2) Force",
    "Device": "nash",
    "Model": "XT1789-05"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Moto Z (2) Play",
    "Device": "albus",
    "Model": "Moto Z2 Play"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Moto Z (2) Play",
    "Device": "albus",
    "Model": "XT1710-02"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Moto Z (2) Play",
    "Device": "albus",
    "Model": "XT1710-08"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Moto Z (2) Play",
    "Device": "albus",
    "Model": "XT1710-11"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Moto Z Droid",
    "Device": "griffin",
    "Model": "XT1650"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Moto Z Play",
    "Device": "addison",
    "Model": "XT1563"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Moto Z Play",
    "Device": "addison",
    "Model": "XT1635-02"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Moto Z Play",
    "Device": "addison",
    "Model": "XT1635-03"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Moto Z Play Droid",
    "Device": "addison",
    "Model": "XT1635-01"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Moto Z(3)",
    "Device": "messi",
    "Model": "Moto Z (2)"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Moto Z(3)",
    "Device": "messi",
    "Model": "XT1929-15"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Moto Z(3)",
    "Device": "messi",
    "Model": "moto z3"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Motoluxe",
    "Device": "XT611",
    "Model": "XT611"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Motoluxe",
    "Device": "XT615",
    "Model": "XT615"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Motoluxe",
    "Device": "XT682",
    "Model": "XT682"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Motoluxe",
    "Device": "ironmax_umts",
    "Model": "XT615"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Motoluxe",
    "Device": "ironmax_umts",
    "Model": "XT685"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Motoluxe",
    "Device": "ironmaxct_cdma",
    "Model": "Motorola MOT-XT681"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Motoluxe",
    "Device": "ironmaxtv_umts",
    "Model": "XT687"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Motoluxe",
    "Device": "umts_irock",
    "Model": "XT626"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Motoluxe",
    "Device": "umts_irock",
    "Model": "XT627"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Motoroi",
    "Device": "sholest",
    "Model": "Milestone XT720"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Motoroi",
    "Device": "sholest",
    "Model": "Motorola XT720"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Motoroi",
    "Device": "sholest",
    "Model": "XT720"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Motorola",
    "Device": "hongkong",
    "Model": "MOTOROLA GOOGLE TV 4K"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Motorola",
    "Device": "hongkong",
    "Model": "MOTOROLA GOOGLE TV 4K ATSC"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Motorola",
    "Device": "khardi",
    "Model": "MOTOROLA GOOGLE TV 4K"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Motorola",
    "Device": "khardi",
    "Model": "MOTOROLA GOOGLE TV 4K N"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Motorola",
    "Device": "lavender",
    "Model": "MOTOROLA GOOGLE TV 4K"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Motorola",
    "Device": "mountbaker",
    "Model": "MOTOROLA GOOGLE TV"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Motorola",
    "Device": "mountbaker",
    "Model": "MOTOROLA GOOGLE TV NA"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Motorola",
    "Device": "stanford",
    "Model": "CSV2K"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Motorola",
    "Device": "templeton",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Motorola",
    "Device": "zhongshan",
    "Model": "CSV4K"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Motorola Android 9.0 TV",
    "Device": "shibuya",
    "Model": "FlipkartTV"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Motorola Defy",
    "Device": "bathena",
    "Model": "Motorola Defy"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Motorola Defy 2",
    "Device": "BM2S1E",
    "Model": "Defy 2"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Motorola TV",
    "Device": "beomil",
    "Model": "Motorola TV"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Motorola TV",
    "Device": "eleonas",
    "Model": "Motorola TV"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Motorola TV FF",
    "Device": "eleonas",
    "Model": "Motorola TV FF"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Motorola one",
    "Device": "deen_sprout",
    "Model": "motorola one"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "MotorolaTV",
    "Device": "hayward",
    "Model": "MotorolaTV"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Motosmart",
    "Device": "XT389",
    "Model": "XT389"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Motosmart",
    "Device": "XT390",
    "Model": "XT390"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Motosmart",
    "Device": "argonmini_umts",
    "Model": "XT389"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Motosmart",
    "Device": "argonmini_umts",
    "Model": "XT390"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Motosmart",
    "Device": "silversmart_umts",
    "Model": "XT303"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Motosmart",
    "Device": "silversmart_umts",
    "Model": "XT305"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Nexus 6",
    "Device": "shamu",
    "Model": "Nexus 6"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Opus One",
    "Device": "rubicon",
    "Model": "Motorola Titanium"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Opus One",
    "Device": "rubicon",
    "Model": "Titanium"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Photon",
    "Device": "asanti_c",
    "Model": "XT897"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Photon",
    "Device": "asanti_c",
    "Model": "XT897S"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Photon 4G",
    "Device": "sunfire",
    "Model": "ISW11M"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Photon 4G",
    "Device": "sunfire",
    "Model": "MB855"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Photon 4G",
    "Device": "sunfire",
    "Model": "Motorola Electrify"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Quench XT3",
    "Device": "XT502",
    "Model": "Motorola-XT502"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "R4",
    "Device": "R4",
    "Model": "R4"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "RAZR D1",
    "Device": "hawk35_umts",
    "Model": "XT914"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "RAZR D1",
    "Device": "hawk35_umts",
    "Model": "XT915"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "RAZR D1",
    "Device": "hawk35_umts",
    "Model": "XT916"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "RAZR D1",
    "Device": "hawk35_umts",
    "Model": "XT918"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "RAZR D3",
    "Device": "hawk40_umts",
    "Model": "XT919"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "RAZR D3",
    "Device": "hawk40_umts",
    "Model": "XT920"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "RAZR HD",
    "Device": "vanquish",
    "Model": "DROID RAZR HD"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "RAZR HD",
    "Device": "vanquish_u",
    "Model": "RAZR HD"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "RAZR M",
    "Device": "smq",
    "Model": "XT907"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "RAZR M",
    "Device": "smq_t",
    "Model": "201M"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "RAZR i",
    "Device": "smi",
    "Model": "XT890"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Razr V",
    "Device": "umts_yangtze",
    "Model": "XT885"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Razr V",
    "Device": "umts_yangtze",
    "Model": "XT886"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Smart TV",
    "Device": "longshan",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "Spice",
    "Device": "sesame",
    "Model": "XT300"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "ThinkPhone 25 by motorola",
    "Device": "vienna",
    "Model": "ThinkPhone 25 by motorola"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "ThinkPhone by Motorola",
    "Device": "bronco",
    "Model": "ThinkPhone by motorola"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "ThinkPhone by Motorola",
    "Device": "bronco",
    "Model": "motorola edge 30 pro"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "XOOM",
    "Device": "stingray",
    "Model": "Xoom"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "XOOM",
    "Device": "umts_everest",
    "Model": "MZ601"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "XOOM",
    "Device": "umts_hubble",
    "Model": "MZ601"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "XOOM",
    "Device": "umts_hubble",
    "Model": "MZ605"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "XOOM",
    "Device": "wifi_hubble",
    "Model": "MZ604"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "XOOM",
    "Device": "wifi_hubble",
    "Model": "MZ606"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "XOOM",
    "Device": "wingray",
    "Model": "Xoom"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "XOOM 2",
    "Device": "fleming",
    "Model": "MZ609"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "XOOM 2",
    "Device": "pasteur",
    "Model": "MZ617"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "XT2071-4",
    "Device": "smith",
    "Model": "XT2071-4"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "XT605",
    "Device": "umts_jorian",
    "Model": "XT605"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "XT627",
    "Device": "umts_irock",
    "Model": "XT627"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto G53",
    "Device": "penang",
    "Model": "XT2335-3"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto P30 NOTE",
    "Device": "chef",
    "Model": "XT1942-1"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto S30",
    "Device": "tundra",
    "Model": "XT2243-2"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto X30 屏下摄像版",
    "Device": "hiphid",
    "Model": "XT2201-6"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto X40",
    "Device": "rtwo",
    "Model": "XT2301-5"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto X70 Air",
    "Device": "roadstr",
    "Model": "XT2601-1"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto X70 Pro",
    "Device": "vantage",
    "Model": "XT2603-1"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto e",
    "Device": "ginna",
    "Model": "moto e"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto e (XT2052DL)",
    "Device": "ginna",
    "Model": "moto e (XT2052DL)"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto e(5) cruise",
    "Device": "james",
    "Model": "moto e5 cruise"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto e(5) cruise",
    "Device": "james",
    "Model": "moto e5 play"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto e(5) play",
    "Device": "james",
    "Model": "moto e5 play"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto e(5) plus",
    "Device": "rhannah",
    "Model": "Moto E"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto e(5) plus",
    "Device": "rhannah",
    "Model": "moto e5 plus"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto e(6i)",
    "Device": "fijisc",
    "Model": "fijisc"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto e(6i)",
    "Device": "fijisc",
    "Model": "moto e(6i)"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto e(7)",
    "Device": "malta",
    "Model": "malta"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto e(7)",
    "Device": "malta",
    "Model": "moto e(7)"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto e(7) plus",
    "Device": "guam",
    "Model": "moto e(7) plus"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto e(7) power",
    "Device": "malta",
    "Model": "malta"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto e(7) power",
    "Device": "malta",
    "Model": "moto e(7) power"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto e(7i) power",
    "Device": "maltalsc",
    "Model": "maltalsc"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto e(7i) power",
    "Device": "maltalsc",
    "Model": "moto e(7i) power"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto e13",
    "Device": "sabahl",
    "Model": "SabahLite"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto e13",
    "Device": "sabahl",
    "Model": "moto e13"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto e20",
    "Device": "aruba",
    "Model": "aruba"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto e20",
    "Device": "aruba",
    "Model": "moto e20"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto e22",
    "Device": "borag",
    "Model": "moto"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto e22",
    "Device": "borag",
    "Model": "moto e22"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto e22i",
    "Device": "borago",
    "Model": "moto"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto e22i",
    "Device": "borago",
    "Model": "moto e22i"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto e30",
    "Device": "cyprus",
    "Model": "cyprus"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto e30",
    "Device": "cyprus",
    "Model": "moto e30"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto e32",
    "Device": "hawaii",
    "Model": "Hawaii"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto e32",
    "Device": "hawaii",
    "Model": "moto e32"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto e40",
    "Device": "cyprus64",
    "Model": "cyprus64"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto e40",
    "Device": "cyprus64",
    "Model": "moto e40"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto e5",
    "Device": "nora",
    "Model": "moto e5 (XT1920DL)"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto e5",
    "Device": "nora_8917_n",
    "Model": "moto e5"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto e5 go",
    "Device": "rjames_go",
    "Model": "moto e5 go"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto e5 play",
    "Device": "james",
    "Model": "moto e5 play"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto e5 play",
    "Device": "pettyl",
    "Model": "Moto E"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto e5 play",
    "Device": "pettyl",
    "Model": "moto e5 play"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto e5 play",
    "Device": "rjames_f",
    "Model": "Moto E"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto e5 play",
    "Device": "rjames_f",
    "Model": "moto e5 play"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto e5 plus",
    "Device": "ahannah",
    "Model": "Moto E"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto e5 plus",
    "Device": "ahannah",
    "Model": "XT1924-9"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto e5 plus",
    "Device": "ahannah",
    "Model": "moto e5 plus"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto e5 plus",
    "Device": "hannah",
    "Model": "Moto E"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto e5 plus",
    "Device": "hannah",
    "Model": "moto e5 plus"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto e5 plus",
    "Device": "hannah",
    "Model": "moto e5 supra"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto e5 plus",
    "Device": "rhannah",
    "Model": "Moto E"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto e5 plus",
    "Device": "rhannah",
    "Model": "moto e5 plus"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto e6",
    "Device": "surfna",
    "Model": "moto e6"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto e6",
    "Device": "surfna",
    "Model": "moto e6 (XT2005DL)"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto e6",
    "Device": "surfna",
    "Model": "moto g(6)"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto e6 play",
    "Device": "bali",
    "Model": "moto e6 play"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto e6s",
    "Device": "fiji",
    "Model": "moto e6"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto e6s",
    "Device": "fiji",
    "Model": "moto e6s"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto edge X30",
    "Device": "hiphic",
    "Model": "XT2201-2"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto e⁶ plus",
    "Device": "pokerp",
    "Model": "moto e(6) plus"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto e⁶ˢ",
    "Device": "pokerp",
    "Model": "moto e(6s)"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g - 2025",
    "Device": "kansas",
    "Model": "moto g - 2025"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g - 2025",
    "Device": "kansas",
    "Model": "moto g play - 2024"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g 5G",
    "Device": "kiev",
    "Model": "moto g 5G"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g 5G",
    "Device": "kiev",
    "Model": "motorola edge"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g 5G (2022)",
    "Device": "austin",
    "Model": "moto g 5G (2022)"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g 5G (2022)",
    "Device": "austin",
    "Model": "moto g pure"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g 5G - 2023",
    "Device": "pnangn",
    "Model": "moto g 5G - 2023"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g 5G - 2023",
    "Device": "pnangn",
    "Model": "moto g stylus 5G (2022)"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g 5G - 2024",
    "Device": "fogo",
    "Model": "moto g 5G - 2023"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g 5G - 2024",
    "Device": "fogo",
    "Model": "moto g 5G - 2024"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g 5G plus",
    "Device": "nairo",
    "Model": "moto g 5G plus"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g fast",
    "Device": "rav",
    "Model": "moto g fast"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g play (2021)",
    "Device": "guamna",
    "Model": "moto g play (2021)"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g play (2021)",
    "Device": "guamna",
    "Model": "moto g play (XT2093DL)"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g play - 2024",
    "Device": "fogona",
    "Model": "moto g play - 2024"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g play - 2024",
    "Device": "fogona",
    "Model": "motorola edge 40 pro"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g power",
    "Device": "sofia",
    "Model": "moto g power"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g power (2021)",
    "Device": "borneo",
    "Model": "moto g power"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g power (2021)",
    "Device": "borneo",
    "Model": "moto g power (2021)"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g power (2022)",
    "Device": "tonga",
    "Model": "moto g power (2022)"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g power (XT2041DL)",
    "Device": "sofia",
    "Model": "moto g power (XT2041DL)"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g power - 2025",
    "Device": "vegas",
    "Model": "moto g power - 2025"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g power - 2025",
    "Device": "vegas",
    "Model": "moto g power 5G - 2024"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g power - 2026",
    "Device": "vegas26",
    "Model": "moto g power - 2025"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g power - 2026",
    "Device": "vegas26",
    "Model": "moto g power - 2026"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g power 5G - 2023",
    "Device": "devonn",
    "Model": "moto g power 5G - 2023"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g power 5G - 2023",
    "Device": "devonn",
    "Model": "moto g(50) 5G"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g power 5G - 2024",
    "Device": "cancunn",
    "Model": "moto g power 5G - 2023"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g power 5G - 2024",
    "Device": "cancunn",
    "Model": "moto g power 5G - 2024"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g pro",
    "Device": "sofiap_sprout",
    "Model": "moto g pro"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g pure",
    "Device": "ellis",
    "Model": "moto g power"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g pure",
    "Device": "ellis",
    "Model": "moto g pure"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g stylus",
    "Device": "sofiap",
    "Model": "moto g stylus"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g stylus (2021)",
    "Device": "minsk",
    "Model": "moto g stylus"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g stylus (2021)",
    "Device": "minsk",
    "Model": "moto g stylus (2021)"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g stylus (2021)",
    "Device": "minsk",
    "Model": "moto g stylus (XT2115DL)"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g stylus (2022)",
    "Device": "milan",
    "Model": "moto g stylus (2022)"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g stylus (2022)",
    "Device": "milan",
    "Model": "motorola"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g stylus (2023)",
    "Device": "gnevan",
    "Model": "moto g 5G (2022)"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g stylus (2023)",
    "Device": "gnevan",
    "Model": "moto g stylus (2023)"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g stylus 5G",
    "Device": "denver",
    "Model": "moto g stylus (2021)"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g stylus 5G",
    "Device": "denver",
    "Model": "moto g stylus 5G"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g stylus 5G (2022)",
    "Device": "milanf",
    "Model": "moto g stylus 5G (2022)"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g stylus 5G (2022)",
    "Device": "milanf",
    "Model": "moto g(50)"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g stylus 5G - 2023",
    "Device": "genevn",
    "Model": "moto g stylus 5G - 2023"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g stylus 5G - 2023",
    "Device": "genevn",
    "Model": "moto g stylus 5g"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g stylus 5G - 2024",
    "Device": "boston",
    "Model": "moto g stylus 5G - 2023"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g stylus 5G - 2024",
    "Device": "boston",
    "Model": "moto g stylus 5G - 2024"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g stylus 5G - 2025",
    "Device": "mona",
    "Model": "moto g stylus - 2025"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g stylus 5G - 2025",
    "Device": "mona",
    "Model": "motorola edge 50 fusion"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g(10)",
    "Device": "capri",
    "Model": "moto e(7) plus"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g(10)",
    "Device": "capri",
    "Model": "moto g(10)"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g(100)",
    "Device": "nio",
    "Model": "moto g(100)"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g(20)",
    "Device": "java",
    "Model": "moto g(20)"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g(20)",
    "Device": "java",
    "Model": "moto g20"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g(30)",
    "Device": "caprip",
    "Model": "moto g(30)"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g(50)",
    "Device": "ibiza",
    "Model": "XT2137-2"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g(50)",
    "Device": "ibiza",
    "Model": "moto g(50)"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g(50) 5G",
    "Device": "saipan",
    "Model": "moto g(50)"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g(50) 5G",
    "Device": "saipan",
    "Model": "moto g(50) 5G"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g(6)",
    "Device": "ali",
    "Model": "XT1925-10"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g(6)",
    "Device": "ali",
    "Model": "moto g(6)"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g(6)",
    "Device": "ali",
    "Model": "moto g(6) (XT1925DL)"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g(6)",
    "Device": "ali_n",
    "Model": "XT1790"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g(6)",
    "Device": "ali_n",
    "Model": "moto g(6)"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g(6) play",
    "Device": "aljeter",
    "Model": "Moto G Play"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g(6) play",
    "Device": "aljeter",
    "Model": "moto g(6) play"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g(6) play",
    "Device": "aljeter_n",
    "Model": "Moto G Play"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g(6) play",
    "Device": "aljeter_n",
    "Model": "moto g(6) play"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g(6) play",
    "Device": "jeter",
    "Model": "moto g(6) play"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g(6) plus",
    "Device": "evert",
    "Model": "moto g(6) plus"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g(6) plus",
    "Device": "evert_n",
    "Model": "Moto G (5) Plus"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g(6) plus",
    "Device": "evert_n",
    "Model": "moto g(6) plus"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g(6) plus",
    "Device": "evert_nt",
    "Model": "moto g(6) plus"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g(60)",
    "Device": "hanoip",
    "Model": "moto g(60)"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g(60)s",
    "Device": "lisbon",
    "Model": "moto g(60)"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g(60)s",
    "Device": "lisbon",
    "Model": "moto g(60)s"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g(7)",
    "Device": "river",
    "Model": "moto g(6)"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g(7)",
    "Device": "river",
    "Model": "moto g(7)"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g(7)",
    "Device": "river_n",
    "Model": "moto g(7)"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g(7) optimo (XT1952DL)",
    "Device": "channel",
    "Model": "moto g(7) optimo (XT1952DL)"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g(7) optimo maxx(XT1955DL)",
    "Device": "ocean",
    "Model": "moto g(7) optimo maxx(XT1955DL)"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g(7) play",
    "Device": "channel",
    "Model": "moto g(6)"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g(7) play",
    "Device": "channel",
    "Model": "moto g(7) play"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g(7) plus",
    "Device": "lake",
    "Model": "XT1965-6"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g(7) plus",
    "Device": "lake_n",
    "Model": "moto g(6) plus"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g(7) plus",
    "Device": "lake_n",
    "Model": "moto g(7) plus"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g(7) power",
    "Device": "ocean",
    "Model": "moto g(6) play"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g(7) power",
    "Device": "ocean",
    "Model": "moto g(7) power"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g(7) power",
    "Device": "ocean_n",
    "Model": "moto g(7) power"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g(7) power",
    "Device": "ocean_t",
    "Model": "moto g(7) power"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g(7) supra",
    "Device": "ocean",
    "Model": "moto g(7) supra"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g(8)",
    "Device": "rav",
    "Model": "moto g(8)"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g(8) play",
    "Device": "lima",
    "Model": "moto g(7) play"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g(8) play",
    "Device": "lima",
    "Model": "moto g(8) play"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g(8) plus",
    "Device": "doha",
    "Model": "moto g(7)"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g(8) plus",
    "Device": "doha",
    "Model": "moto g(8) plus"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g(8) plus",
    "Device": "doha_n",
    "Model": "moto g(8) plus"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g(8) power",
    "Device": "sofiar",
    "Model": "moto g(8) power"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g(8) power lite",
    "Device": "blackjack",
    "Model": "moto g(8) power lite"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g(8) power lite",
    "Device": "blackjack",
    "Model": "moto g8 power lite"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g(9)",
    "Device": "guamp",
    "Model": "moto g(9)"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g(9) play",
    "Device": "guamp",
    "Model": "moto g(9) play"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g(9) plus",
    "Device": "odessa",
    "Model": "moto g(9) plus"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g(9) power",
    "Device": "cebu",
    "Model": "moto g(9) power"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g04",
    "Device": "lion",
    "Model": "lion"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g04",
    "Device": "lion",
    "Model": "moto g04"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g04s",
    "Device": "lion",
    "Model": "moto g04"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g04s",
    "Device": "lion",
    "Model": "moto g04s"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g05",
    "Device": "lamul",
    "Model": "lamu_g"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g05",
    "Device": "lamul",
    "Model": "moto g05"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g06",
    "Device": "lagos",
    "Model": "moto g05"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g06",
    "Device": "lagos",
    "Model": "moto g06"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g06 power",
    "Device": "lagos",
    "Model": "moto g05"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g06 power",
    "Device": "lagos",
    "Model": "moto g06 power"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g10 power",
    "Device": "capri",
    "Model": "moto g(10) power"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g13",
    "Device": "penangf",
    "Model": "moto g13"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g13",
    "Device": "penangf",
    "Model": "penangf"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g14",
    "Device": "cancun",
    "Model": "cancun"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g14",
    "Device": "cancun",
    "Model": "moto g14"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g15",
    "Device": "lamu",
    "Model": "lamu_g"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g15",
    "Device": "lamu",
    "Model": "moto g15"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g200 5G",
    "Device": "xpeng",
    "Model": "moto g200 5G"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g200 5G",
    "Device": "xpeng",
    "Model": "motorola edge 20 pro"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g22",
    "Device": "hawaiip",
    "Model": "Lenovo K15 Plus"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g22",
    "Device": "hawaiip",
    "Model": "moto g22"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g23",
    "Device": "penangf",
    "Model": "moto g23"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g24",
    "Device": "fogorow",
    "Model": "moto g24"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g24 power",
    "Device": "fogorow",
    "Model": "moto g24 power"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g31",
    "Device": "cofud",
    "Model": "moto g31(w)"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g31",
    "Device": "cofud",
    "Model": "motorola"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g31",
    "Device": "coful",
    "Model": "moto g31"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g31",
    "Device": "coful",
    "Model": "motorola"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g32",
    "Device": "devon",
    "Model": "moto g(100)"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g32",
    "Device": "devon",
    "Model": "moto g32"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g34",
    "Device": "fogos",
    "Model": "XT2363-4"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g34 5G",
    "Device": "fogos",
    "Model": "moto g34 5G"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g34 5G",
    "Device": "fogos",
    "Model": "moto g53 5G"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g35 5G",
    "Device": "manila",
    "Model": "moto g35 5G"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g40 fusion",
    "Device": "hanoip",
    "Model": "moto g(40) fusion"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g41",
    "Device": "corfu",
    "Model": "moto g41"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g41",
    "Device": "corfu",
    "Model": "motorola"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g42",
    "Device": "hawao",
    "Model": "moto g(100)"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g42",
    "Device": "hawao",
    "Model": "moto g42"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g45 5G",
    "Device": "fogos",
    "Model": "moto g34 5GP"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g45 5G",
    "Device": "fogos",
    "Model": "moto g45 5G"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g51",
    "Device": "cypfq",
    "Model": "XT2171-3"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g51",
    "Device": "cypfq",
    "Model": "moto[SPACE]g(50)"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g51 5G",
    "Device": "cypfq",
    "Model": "moto g(50)"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g51 5G",
    "Device": "cypfq",
    "Model": "moto g51 5G"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g52",
    "Device": "rhode",
    "Model": "moto g(50)"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g52",
    "Device": "rhode",
    "Model": "moto g52"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g52j 5G",
    "Device": "cypfr",
    "Model": "moto g(50)"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g52j 5G",
    "Device": "cypfr",
    "Model": "moto g52j 5G"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g53 5G",
    "Device": "penang",
    "Model": "moto g stylus 5G (2022)"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g53 5G",
    "Device": "penang",
    "Model": "moto g53 5G"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g53j 5G",
    "Device": "penang",
    "Model": "moto g53j 5G"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g53s 5G",
    "Device": "penang",
    "Model": "moto g53s 5G"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g53y 5G",
    "Device": "penang",
    "Model": "moto g53y 5G"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g54 5G",
    "Device": "cancunf",
    "Model": "XT2343-3"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g54 5G",
    "Device": "cancunf",
    "Model": "moto g54 5G"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g54 5G",
    "Device": "cancunf",
    "Model": "moto g73 5G"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g55 5G",
    "Device": "taipei",
    "Model": "moto g54 5G"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g55 5G",
    "Device": "taipei",
    "Model": "moto g55 5G"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g56 5G",
    "Device": "bogota",
    "Model": "moto g54 5G"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g56 5G",
    "Device": "bogota",
    "Model": "moto g56 5G"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g57",
    "Device": "mumba",
    "Model": "moto g57"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g57",
    "Device": "mumba",
    "Model": "motorola edge 60 stylus"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g57 power",
    "Device": "mumba",
    "Model": "moto g57 power"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g57 power",
    "Device": "mumba",
    "Model": "motorola edge 60 stylus"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g6 play",
    "Device": "jeter",
    "Model": "Moto G Play"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g6 play",
    "Device": "jeter",
    "Model": "moto g(6) play"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g62 5G",
    "Device": "rhodec",
    "Model": "moto g51 5G"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g62 5G",
    "Device": "rhodec",
    "Model": "moto g62 5G"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g62 5G",
    "Device": "rhodei",
    "Model": "moto g62 5G"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g62 5G",
    "Device": "rhodei",
    "Model": "moto g71 5G"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g64 5G",
    "Device": "cancunf",
    "Model": "moto g54 5G"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g64 5G",
    "Device": "cancunf",
    "Model": "moto g64 5G"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g64y 5G",
    "Device": "cancunf",
    "Model": "moto g54 5G"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g64y 5G",
    "Device": "cancunf",
    "Model": "moto g64y 5G"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g66j 5G",
    "Device": "bogota",
    "Model": "moto g54 5G"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g66j 5G",
    "Device": "bogota",
    "Model": "moto g64 5G"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g66j 5G",
    "Device": "bogota",
    "Model": "moto g66j 5G"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g66y 5G",
    "Device": "bogota",
    "Model": "moto g64 5G"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g66y 5G",
    "Device": "bogota",
    "Model": "moto g66y 5G"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g67",
    "Device": "naples",
    "Model": "moto g - 2025"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g67",
    "Device": "naples",
    "Model": "moto g67"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g67 power 5G",
    "Device": "portov",
    "Model": "XT2533-4"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g67 power 5G",
    "Device": "portov",
    "Model": "moto g67 power 5G"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g67 power 5G",
    "Device": "portov",
    "Model": "motorola edge 60 stylus"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g71 5G",
    "Device": "corfur",
    "Model": "moto g(50)"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g71 5G",
    "Device": "corfur",
    "Model": "moto g71 5G"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g72",
    "Device": "vicky",
    "Model": "moto g(50) 5G"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g72",
    "Device": "vicky",
    "Model": "moto g72"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g73 5G",
    "Device": "devonf",
    "Model": "moto g(50) 5G"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g73 5G",
    "Device": "devonf",
    "Model": "moto g73 5G"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g75 5G",
    "Device": "sorap",
    "Model": "moto g75 5G"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g77",
    "Device": "naples",
    "Model": "moto g - 2025"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g77",
    "Device": "naples",
    "Model": "moto g77"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g82 5G",
    "Device": "rhodep",
    "Model": "XT2169-2"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g82 5G",
    "Device": "rhodep",
    "Model": "XT2225-2"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g82 5G",
    "Device": "rhodep",
    "Model": "moto g71 5G"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g82 5G",
    "Device": "rhodep",
    "Model": "moto g82 5G"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g84 5G",
    "Device": "bangkk",
    "Model": "moto g53 5G"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g84 5G",
    "Device": "bangkk",
    "Model": "moto g84 5G"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g85 5G",
    "Device": "malmo",
    "Model": "XT2427-4"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g85 5G",
    "Device": "malmo",
    "Model": "moto g85 5G"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g85 5G",
    "Device": "malmo",
    "Model": "motorola edge 40 pro"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g86 5G",
    "Device": "nice",
    "Model": "moto g86 5G"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g86 5G",
    "Device": "nice",
    "Model": "motorola edge 50 neo"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g86 power 5G",
    "Device": "nice",
    "Model": "moto g86 power 5G"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g86 power 5G",
    "Device": "nice",
    "Model": "motorola edge 50 neo"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g96 5G",
    "Device": "cuscoi",
    "Model": "moto g96 5G"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto g96 5G",
    "Device": "cuscoi",
    "Model": "motorola edge 50 fusion"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto p30",
    "Device": "robusta",
    "Model": "XT1943-1"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto p30 play",
    "Device": "deen",
    "Model": "XT1941-2"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto pad 60 neo",
    "Device": "XT2575-1",
    "Model": "XT2575-1"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto pad 60 neo",
    "Device": "XT2575-3",
    "Model": "XT2575-3"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto razr 40",
    "Device": "lynkco",
    "Model": "XT2323-3"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto razr 40 Ultra",
    "Device": "zeekr",
    "Model": "XT2321-2"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto razr 50",
    "Device": "arcfox",
    "Model": "XT2451-4"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto tab g20",
    "Device": "mototabg20",
    "Model": "moto tab g20"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto z3 play",
    "Device": "beckham",
    "Model": "Moto Z3 Play"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto z4",
    "Device": "foles",
    "Model": "Moto Z3 Play"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "moto z4",
    "Device": "foles",
    "Model": "moto z4"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "motorola defy x",
    "Device": "BM2S1E",
    "Model": "motorola defy x"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "motorola edge",
    "Device": "racer",
    "Model": "motorola edge"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "motorola edge (2021)",
    "Device": "berlna",
    "Model": "motorola edge (2021)"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "motorola edge (2021)",
    "Device": "berlna",
    "Model": "motorola edge plus"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "motorola edge (2022)",
    "Device": "tesla",
    "Model": "moto g(50) 5G"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "motorola edge (2022)",
    "Device": "tesla",
    "Model": "motorola edge (2022)"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "motorola edge 20",
    "Device": "berlin",
    "Model": "motorola edge 20"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "motorola edge 20",
    "Device": "berlin",
    "Model": "motorola edge plus"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "motorola edge 20 fusion",
    "Device": "kyoto",
    "Model": "motorola"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "motorola edge 20 fusion",
    "Device": "kyoto",
    "Model": "motorola edge 20 fusion"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "motorola edge 20 lite",
    "Device": "kyoto",
    "Model": "motorola"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "motorola edge 20 lite",
    "Device": "kyoto",
    "Model": "motorola edge 20 lite"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "motorola edge 20 pro",
    "Device": "pstar",
    "Model": "moto g(100)"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "motorola edge 20 pro",
    "Device": "pstar",
    "Model": "motorola edge 20 pro"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "motorola edge 2023",
    "Device": "aion",
    "Model": "motorola edge (2022)"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "motorola edge 2023",
    "Device": "aion",
    "Model": "motorola edge 2023"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "motorola edge 2024",
    "Device": "avatrn",
    "Model": "motorola edge 2023"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "motorola edge 2024",
    "Device": "avatrn",
    "Model": "motorola edge 2024"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "motorola edge 2025",
    "Device": "oulu",
    "Model": "motorola edge 2025"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "motorola edge 2025",
    "Device": "oulu",
    "Model": "motorola edge 50 neo"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "motorola edge 30",
    "Device": "dubai",
    "Model": "moto g200 5G"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "motorola edge 30",
    "Device": "dubai",
    "Model": "motorola edge 30"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "motorola edge 30 fusion",
    "Device": "tundra",
    "Model": "moto g200 5G"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "motorola edge 30 fusion",
    "Device": "tundra",
    "Model": "motorola edge 30 fusion"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "motorola edge 30 neo",
    "Device": "miami",
    "Model": "moto g71 5G"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "motorola edge 30 neo",
    "Device": "miami",
    "Model": "motorola edge 30 neo"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "motorola edge 30 pro",
    "Device": "hiphi",
    "Model": "motorola edge 30 pro"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "motorola edge 30 pro",
    "Device": "hiphi",
    "Model": "motorola edge plus"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "motorola edge 30 ultra",
    "Device": "eqs",
    "Model": "motorola edge"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "motorola edge 30 ultra",
    "Device": "eqs",
    "Model": "motorola edge 30 ultra"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "motorola edge 40",
    "Device": "lyriq",
    "Model": "moto g 5G (2022)"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "motorola edge 40",
    "Device": "lyriq",
    "Model": "motorola edge 40"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "motorola edge 40 neo",
    "Device": "manaus",
    "Model": "motorola edge (2022)"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "motorola edge 40 neo",
    "Device": "manaus",
    "Model": "motorola edge 40 neo"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "motorola edge 40 pro",
    "Device": "rtwo",
    "Model": "motorola edge 30 pro"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "motorola edge 40 pro",
    "Device": "rtwo",
    "Model": "motorola edge 40 pro"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "motorola edge 50",
    "Device": "tank",
    "Model": "motorola edge 50"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "motorola edge 50",
    "Device": "tank",
    "Model": "motorola razr 40"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "motorola edge 50 fusion",
    "Device": "cusco",
    "Model": "moto g stylus 5G - 2023"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "motorola edge 50 fusion",
    "Device": "cusco",
    "Model": "motorola edge 50 fusion"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "motorola edge 50 fusion",
    "Device": "cuscoi",
    "Model": "moto g stylus 5G - 2023"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "motorola edge 50 fusion",
    "Device": "cuscoi",
    "Model": "motorola edge 50 fusion"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "motorola edge 50 neo",
    "Device": "vienna",
    "Model": "motorola edge 50 neo"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "motorola edge 50 pro",
    "Device": "eqe",
    "Model": "motorola edge 40 pro"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "motorola edge 50 pro",
    "Device": "eqe",
    "Model": "motorola edge 50 pro"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "motorola edge 50 ultra",
    "Device": "ctwo",
    "Model": "motorola edge 40 pro"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "motorola edge 50 ultra",
    "Device": "ctwo",
    "Model": "motorola edge 50 ultra"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "motorola edge 5G UW (2021)",
    "Device": "berlna",
    "Model": "motorola edge 5G UW"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "motorola edge 5G UW (2021)",
    "Device": "berlna",
    "Model": "motorola edge 5G UW (2021)"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "motorola edge 60",
    "Device": "scout",
    "Model": "motorola edge 50 neo"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "motorola edge 60",
    "Device": "scout",
    "Model": "motorola edge 60"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "motorola edge 60 fusion",
    "Device": "scout",
    "Model": "motorola edge 50 neo"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "motorola edge 60 fusion",
    "Device": "scout",
    "Model": "motorola edge 60 fusion"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "motorola edge 60 neo",
    "Device": "vienna",
    "Model": "motorola edge 50 neo"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "motorola edge 60 neo",
    "Device": "vienna",
    "Model": "motorola edge 60 neo"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "motorola edge 60 pro",
    "Device": "cybert",
    "Model": "moto g play - 2024"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "motorola edge 60 pro",
    "Device": "cybert",
    "Model": "motorola edge 60 pro"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "motorola edge 60 stylus",
    "Device": "monai",
    "Model": "motorola edge 50 fusion"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "motorola edge 60 stylus",
    "Device": "monai",
    "Model": "motorola edge 60 stylus"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "motorola edge 60s pro",
    "Device": "cybert",
    "Model": "motorola edge 60s pro"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "motorola edge 70",
    "Device": "roadstr",
    "Model": "motorola edge 50 ultra"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "motorola edge 70",
    "Device": "roadstr",
    "Model": "motorola edge 70"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "motorola edge 70 fusion",
    "Device": "marvel",
    "Model": "motorola edge 50 ultra"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "motorola edge 70 fusion",
    "Device": "marvel",
    "Model": "motorola edge 70 fusion"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "motorola edge S30",
    "Device": "xpeng",
    "Model": "XT2175-2"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "motorola edge plus",
    "Device": "burton",
    "Model": "motorola edge plus"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "motorola edge plus (2022)",
    "Device": "hiphi",
    "Model": "motorola edge plus (2022)"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "motorola edge plus 2023",
    "Device": "rtwo",
    "Model": "motorola edge plus (2022)"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "motorola edge plus 2023",
    "Device": "rtwo",
    "Model": "motorola edge plus 2023"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "motorola edge plus 5G UW (2022)",
    "Device": "hiphi",
    "Model": "motorola edge plus 5G UW (2022)"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "motorola edge s",
    "Device": "nio",
    "Model": "XT2125-4"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "motorola edge s pro",
    "Device": "pstar",
    "Model": "XT2153-1"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "motorola edge 轻奢版",
    "Device": "berlin",
    "Model": "XT2143-1"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "motorola egde s",
    "Device": "nio",
    "Model": "XT2125-4"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "motorola one",
    "Device": "deen_sprout",
    "Model": "motorola one"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "motorola one 5G",
    "Device": "nairo",
    "Model": "moto g 5G plus"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "motorola one 5G",
    "Device": "nairo",
    "Model": "motorola one 5G"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "motorola one 5G UW",
    "Device": "nairo",
    "Model": "motorola one 5G"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "motorola one 5G UW",
    "Device": "nairo",
    "Model": "motorola one 5G UW"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "motorola one 5G UW ace",
    "Device": "kievv",
    "Model": "motorola one 5G UW ace"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "motorola one 5G UW ace",
    "Device": "kievv",
    "Model": "motorola one 5G ace"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "motorola one 5G ace",
    "Device": "kiev",
    "Model": "motorola one 5G ace"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "motorola one action",
    "Device": "troika",
    "Model": "motorola one action"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "motorola one action",
    "Device": "troika_sprout",
    "Model": "motorola one action"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "motorola one fusion",
    "Device": "astro",
    "Model": "motorola one fusion"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "motorola one fusion+",
    "Device": "liber",
    "Model": "motorola one fusion+"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "motorola one hyper",
    "Device": "def",
    "Model": "motorola one hyper"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "motorola one macro",
    "Device": "lima",
    "Model": "motorola one macro"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "motorola one power",
    "Device": "chef_sprout",
    "Model": "moto x4"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "motorola one power",
    "Device": "chef_sprout",
    "Model": "motorola one power"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "motorola one vision",
    "Device": "kane_sprout",
    "Model": "motorola one vision"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "motorola one vision plus",
    "Device": "doha_n",
    "Model": "motorola one vision plus"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "motorola one zoom",
    "Device": "parker",
    "Model": "moto z4"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "motorola one zoom",
    "Device": "parker",
    "Model": "motorola one zoom"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "motorola p50",
    "Device": "kane",
    "Model": "XT1970-5"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "motorola razr",
    "Device": "olson",
    "Model": "motorola razr"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "motorola razr (2020)",
    "Device": "smith",
    "Model": "motorola razr (2020)"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "motorola razr 2022",
    "Device": "oneli",
    "Model": "XT2251-1"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "motorola razr 2022",
    "Device": "oneli",
    "Model": "motorola edge 30 pro"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "motorola razr 2022",
    "Device": "oneli",
    "Model": "motorola razr 2022"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "motorola razr 2023",
    "Device": "lynkco",
    "Model": "motorola razr 2022"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "motorola razr 2023",
    "Device": "lynkco",
    "Model": "motorola razr 2023"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "motorola razr 2024",
    "Device": "aito",
    "Model": "motorola razr 2023"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "motorola razr 2024",
    "Device": "aito",
    "Model": "motorola razr 2024"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "motorola razr 2025",
    "Device": "aito",
    "Model": "motorola razr 2024"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "motorola razr 2025",
    "Device": "aito",
    "Model": "motorola razr 2025"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "motorola razr 40",
    "Device": "lynkco",
    "Model": "motorola razr 2022"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "motorola razr 40",
    "Device": "lynkco",
    "Model": "motorola razr 40"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "motorola razr 40 ultra",
    "Device": "zeekr",
    "Model": "motorola razr 2022"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "motorola razr 40 ultra",
    "Device": "zeekr",
    "Model": "motorola razr 40 ultra"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "motorola razr 40s",
    "Device": "lynkco",
    "Model": "motorola razr 40s"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "motorola razr 50",
    "Device": "aito",
    "Model": "XT2453-2"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "motorola razr 50",
    "Device": "aito",
    "Model": "motorola razr 40"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "motorola razr 50",
    "Device": "aito",
    "Model": "motorola razr 50"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "motorola razr 50 ultra",
    "Device": "arcfox",
    "Model": "motorola razr 40 ultra"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "motorola razr 50 ultra",
    "Device": "arcfox",
    "Model": "motorola razr 50 ultra"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "motorola razr 50d M-51E",
    "Device": "M-51E",
    "Model": "M-51E"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "motorola razr 50s",
    "Device": "aito",
    "Model": "motorola razr 50s"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "motorola razr 5G",
    "Device": "smith",
    "Model": "motorola razr 5G"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "motorola razr 60",
    "Device": "aito",
    "Model": "motorola razr 50"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "motorola razr 60",
    "Device": "aito",
    "Model": "motorola razr 60"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "motorola razr 60 ultra",
    "Device": "leap",
    "Model": "XT2551-3"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "motorola razr 60 ultra",
    "Device": "leap",
    "Model": "motorola razr 50 ultra"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "motorola razr 60 ultra",
    "Device": "leap",
    "Model": "motorola razr 60 ultra"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "motorola razr 60d M-51F",
    "Device": "M-51F",
    "Model": "M-51E"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "motorola razr 60d M-51F",
    "Device": "M-51F",
    "Model": "M-51F"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "motorola razr 60s",
    "Device": "aito",
    "Model": "motorola razr 50s"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "motorola razr 60s",
    "Device": "aito",
    "Model": "motorola razr 60s"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "motorola razr fold",
    "Device": "blanc",
    "Model": "motorola edge 50 ultra"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "motorola razr fold",
    "Device": "blanc",
    "Model": "motorola razr fold"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "motorola razr fold 2026",
    "Device": "blanc",
    "Model": "motorola edge 50 ultra"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "motorola razr plus 2023",
    "Device": "zeekr",
    "Model": "motorola razr 2022"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "motorola razr plus 2023",
    "Device": "zeekr",
    "Model": "motorola razr plus 2023"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "motorola razr plus 2024",
    "Device": "arcfox",
    "Model": "motorola razr plus 2023"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "motorola razr plus 2024",
    "Device": "arcfox",
    "Model": "motorola razr plus 2024"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "motorola razr plus 2025",
    "Device": "arcfox",
    "Model": "motorola razr plus 2024"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "motorola razr plus 2025",
    "Device": "arcfox",
    "Model": "motorola razr plus 2025"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "motorola razr ultra 2025",
    "Device": "leap",
    "Model": "motorola razr 50 ultra"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "motorola razr ultra 2025",
    "Device": "leap",
    "Model": "motorola razr ultra 2025"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "motorola signature",
    "Device": "vantage",
    "Model": "motorola edge 50 ultra"
  },
  {
    "Retail Branding": "Motorola",
    "Marketing Name": "motorola signature",
    "Device": "vantage",
    "Model": "motorola signature"
  },
  {
    "Retail Branding": "Motorola Solutions",
    "Marketing Name": "EVOLVE",
    "Device": "EVOLVE",
    "Model": "EVOLVE"
  },
  {
    "Retail Branding": "Motorola Solutions",
    "Marketing Name": "LEX F10",
    "Device": "LEXF10",
    "Model": "LEX F10"
  },
  {
    "Retail Branding": "Motorola Solutions",
    "Marketing Name": "LEX L10g",
    "Device": "lexl10g",
    "Model": "LEX L10g"
  },
  {
    "Retail Branding": "Motorola Solutions",
    "Marketing Name": "LEX L10ig",
    "Device": "lexl10ig",
    "Model": "LEX L10ig"
  },
  {
    "Retail Branding": "Motorola Solutions",
    "Marketing Name": "LEX L11",
    "Device": "lexl11g_64",
    "Model": "LEX L11"
  },
  {
    "Retail Branding": "Motorola Solutions",
    "Marketing Name": "LEX L11",
    "Device": "lexl11g_64",
    "Model": "LEX L11a"
  },
  {
    "Retail Branding": "Motorola Solutions",
    "Marketing Name": "LEX L11",
    "Device": "lexl11g_64",
    "Model": "LEX L11e"
  },
  {
    "Retail Branding": "Motorola Solutions",
    "Marketing Name": "LEX L11",
    "Device": "lexl11g_64",
    "Model": "LEX L11j"
  },
  {
    "Retail Branding": "Motorola Solutions",
    "Marketing Name": "LEX L11",
    "Device": "lexl11g_64",
    "Model": "LEX L11l"
  },
  {
    "Retail Branding": "Motorola Solutions",
    "Marketing Name": "MOTOTRBO ION",
    "Device": "mkz_sdm660_64",
    "Model": "MSLB-MKZ900"
  },
  {
    "Retail Branding": "Motorola Solutions",
    "Marketing Name": "MOTOTRBO ION",
    "Device": "mkz_sdm660_64",
    "Model": "MSLB-MKZ900i"
  },
  {
    "Retail Branding": "Motorola Solutions",
    "Marketing Name": "MOTOTRBO ION",
    "Device": "mkz_sdm660_64",
    "Model": "MSLB-MKZ900ti"
  },
  {
    "Retail Branding": "Motorola Solutions",
    "Marketing Name": "MOTOTRBO ION",
    "Device": "mkz_sdm660_64",
    "Model": "MSLB-MKZ920"
  },
  {
    "Retail Branding": "Motorola Solutions",
    "Marketing Name": "MOTOTRBO ION",
    "Device": "mkz_sdm660_64",
    "Model": "MSLB-MKZ920ti"
  },
  {
    "Retail Branding": "Motorola Solutions",
    "Marketing Name": "TC55",
    "Device": "TC55",
    "Model": "TC55"
  },
  {
    "Retail Branding": "Motorola Solutions",
    "Marketing Name": "TC55CH",
    "Device": "TC55CH",
    "Model": "TC55CH"
  },
  {
    "Retail Branding": "Motumation",
    "Marketing Name": "MTab8",
    "Device": "MTab8",
    "Model": "MTab8"
  },
  {
    "Retail Branding": "Movado",
    "Marketing Name": "Boss Touch / TH 24/7 YOU",
    "Device": "weever",
    "Model": "BOSS Touch"
  },
  {
    "Retail Branding": "Movado",
    "Marketing Name": "Boss Touch / TH 24/7 YOU",
    "Device": "weever",
    "Model": "TH 24/7 YOU"
  },
  {
    "Retail Branding": "Movado",
    "Marketing Name": "Movado Connect",
    "Device": "stargazer",
    "Model": "Movado Connect"
  },
  {
    "Retail Branding": "Movado",
    "Marketing Name": "Movado Connect",
    "Device": "stargazer",
    "Model": "Stargazer"
  },
  {
    "Retail Branding": "Movado",
    "Marketing Name": "Movado Connect 2.0",
    "Device": "tilefish",
    "Model": "Movado Connect 2"
  },
  {
    "Retail Branding": "Move",
    "Marketing Name": "MOVE OTT-Box 1",
    "Device": "DV8919-KSM",
    "Model": "MOVE OTT-Box 1"
  },
  {
    "Retail Branding": "Move",
    "Marketing Name": "MOVE OTT-Box 4",
    "Device": "SEID00TKSB",
    "Model": "MOVE OTT-Box 4"
  },
  {
    "Retail Branding": "Moveby",
    "Marketing Name": "LINNEX",
    "Device": "LX50",
    "Model": "LX50"
  },
  {
    "Retail Branding": "Movfast",
    "Marketing Name": "Ranger2",
    "Device": "MFT1522",
    "Model": "Ranger2"
  },
  {
    "Retail Branding": "Movfast",
    "Marketing Name": "Ranger2 Lite",
    "Device": "MFT1621",
    "Model": "Ranger2K"
  },
  {
    "Retail Branding": "Movfast",
    "Marketing Name": "Ranger2K",
    "Device": "MFT1621",
    "Model": "Ranger2K"
  },
  {
    "Retail Branding": "Movfast",
    "Marketing Name": "Ranger2KN",
    "Device": "MFT2251",
    "Model": "Ranger2KN"
  },
  {
    "Retail Branding": "Movfast",
    "Marketing Name": "Ranger2K_N",
    "Device": "MFT2221",
    "Model": "Ranger2K_N"
  },
  {
    "Retail Branding": "Movfast",
    "Marketing Name": "Ranger2_N",
    "Device": "MFT2351",
    "Model": "Ranger2_N"
  },
  {
    "Retail Branding": "Movic",
    "Marketing Name": "MOVIC_W5",
    "Device": "MOVIC_W5",
    "Model": "MOVIC-W5"
  },
  {
    "Retail Branding": "Movienet",
    "Marketing Name": "M7",
    "Device": "SFO",
    "Model": "M7"
  },
  {
    "Retail Branding": "Moviltelco Trade",
    "Marketing Name": "A58B",
    "Device": "A58B",
    "Model": "A58B"
  },
  {
    "Retail Branding": "Moviltelco Trade",
    "Marketing Name": "A85",
    "Device": "A85",
    "Model": "A85"
  },
  {
    "Retail Branding": "Moviltelco Trade",
    "Marketing Name": "A87",
    "Device": "A87",
    "Model": "A87"
  },
  {
    "Retail Branding": "Moviltelco Trade",
    "Marketing Name": "KIREI A5Q PLUS",
    "Device": "Azumi_KIREI_A5Q_PLUS",
    "Model": "KIREI A5Q PLUS"
  },
  {
    "Retail Branding": "Moviltelco Trade",
    "Marketing Name": "L506",
    "Device": "L506",
    "Model": "L506"
  },
  {
    "Retail Branding": "Moviltelco Trade",
    "Marketing Name": "L570",
    "Device": "L570",
    "Model": "L570"
  },
  {
    "Retail Branding": "Moviltelco Trade",
    "Marketing Name": "L570a",
    "Device": "L570a",
    "Model": "L570a"
  },
  {
    "Retail Branding": "Moviltelco Trade",
    "Marketing Name": "mtt L452",
    "Device": "L452",
    "Model": "L452"
  },
  {
    "Retail Branding": "Moviltelco Trade",
    "Marketing Name": "mtt L509",
    "Device": "L509",
    "Model": "MTT_L509"
  },
  {
    "Retail Branding": "Moviltelco Trade S.L",
    "Marketing Name": "A58B",
    "Device": "A58B",
    "Model": "A58B"
  },
  {
    "Retail Branding": "Moviltelco Trade S.L",
    "Marketing Name": "A76",
    "Device": "A76",
    "Model": "A76"
  },
  {
    "Retail Branding": "Moviltelco Trade S.L",
    "Marketing Name": "A86",
    "Device": "A86",
    "Model": "A86"
  },
  {
    "Retail Branding": "Movistar",
    "Marketing Name": "Jappy_Kids",
    "Device": "Jappy_Kids",
    "Model": "Jappy_Kids"
  },
  {
    "Retail Branding": "Movistar",
    "Marketing Name": "Telefonica ATV",
    "Device": "vip5242a",
    "Model": "VIP5242A"
  },
  {
    "Retail Branding": "Movitel",
    "Marketing Name": "M8414",
    "Device": "Movitel_M8414",
    "Model": "M8414"
  },
  {
    "Retail Branding": "Movitel",
    "Marketing Name": "M8415",
    "Device": "M8415",
    "Model": "M8415"
  },
  {
    "Retail Branding": "Movitel",
    "Marketing Name": "M8416",
    "Device": "M8416",
    "Model": "M8416"
  },
  {
    "Retail Branding": "Movitel",
    "Marketing Name": "M8418",
    "Device": "M8418",
    "Model": "M8418"
  },
  {
    "Retail Branding": "Movitel",
    "Marketing Name": "M8419",
    "Device": "M8419",
    "Model": "M8419"
  },
  {
    "Retail Branding": "Movitel",
    "Marketing Name": "M8420",
    "Device": "M8420",
    "Model": "M8420"
  },
  {
    "Retail Branding": "Movitel",
    "Marketing Name": "M8421",
    "Device": "M8421",
    "Model": "M8421"
  },
  {
    "Retail Branding": "Movitel",
    "Marketing Name": "M8422",
    "Device": "M8422",
    "Model": "M8422"
  },
  {
    "Retail Branding": "Movitel",
    "Marketing Name": "M8423",
    "Device": "M8423",
    "Model": "M8423"
  },
  {
    "Retail Branding": "Movitel",
    "Marketing Name": "M8424",
    "Device": "M8424",
    "Model": "M8424"
  },
  {
    "Retail Branding": "Movitel",
    "Marketing Name": "M8425",
    "Device": "M8425",
    "Model": "M8425"
  },
  {
    "Retail Branding": "Movitel",
    "Marketing Name": "M8426",
    "Device": "M8426",
    "Model": "M8426"
  },
  {
    "Retail Branding": "Movitel",
    "Marketing Name": "M8601",
    "Device": "Movitel_M8601",
    "Model": "M8601"
  },
  {
    "Retail Branding": "Movitel",
    "Marketing Name": "M9101A",
    "Device": "M9101A",
    "Model": "M9101A"
  },
  {
    "Retail Branding": "Movitel",
    "Marketing Name": "M9101B",
    "Device": "M9101B",
    "Model": "M9101B"
  },
  {
    "Retail Branding": "Movitel",
    "Marketing Name": "M9102A",
    "Device": "M9102A",
    "Model": "M9102A"
  },
  {
    "Retail Branding": "Movitel",
    "Marketing Name": "M9102B",
    "Device": "M9102B",
    "Model": "M9102B"
  },
  {
    "Retail Branding": "Movitel",
    "Marketing Name": "M9103",
    "Device": "M9103",
    "Model": "M9103"
  },
  {
    "Retail Branding": "Movitel",
    "Marketing Name": "M9105",
    "Device": "M9105",
    "Model": "M9105"
  },
  {
    "Retail Branding": "Movitel",
    "Marketing Name": "M9106",
    "Device": "M9106",
    "Model": "M9106"
  },
  {
    "Retail Branding": "Movitel",
    "Marketing Name": "M9107",
    "Device": "M9107",
    "Model": "M9107"
  },
  {
    "Retail Branding": "Movitel",
    "Marketing Name": "M9108",
    "Device": "M9108",
    "Model": "M9108"
  },
  {
    "Retail Branding": "Movitel",
    "Marketing Name": "M9109",
    "Device": "M9109",
    "Model": "M9109"
  },
  {
    "Retail Branding": "Movitel",
    "Marketing Name": "M9110",
    "Device": "M9110",
    "Model": "M9110"
  },
  {
    "Retail Branding": "Movitel",
    "Marketing Name": "M9111",
    "Device": "M9111",
    "Model": "M9111"
  },
  {
    "Retail Branding": "Movitel",
    "Marketing Name": "M9112",
    "Device": "M9112",
    "Model": "M9112"
  },
  {
    "Retail Branding": "Movitel",
    "Marketing Name": "M9113",
    "Device": "M9113",
    "Model": "M9113"
  },
  {
    "Retail Branding": "Movitel",
    "Marketing Name": "M9114",
    "Device": "M9114",
    "Model": "M9114"
  },
  {
    "Retail Branding": "Movitel",
    "Marketing Name": "M9116",
    "Device": "M9116",
    "Model": "M9116"
  },
  {
    "Retail Branding": "Movitel",
    "Marketing Name": "M9117",
    "Device": "M9117",
    "Model": "M9117"
  },
  {
    "Retail Branding": "Movitel",
    "Marketing Name": "Movitel_M9104",
    "Device": "Movitel_M9104",
    "Model": "Movitel_M9104"
  },
  {
    "Retail Branding": "Movix",
    "Marketing Name": "Movix",
    "Device": "MVX01",
    "Model": "Movix"
  },
  {
    "Retail Branding": "Movix",
    "Marketing Name": "Movix Go",
    "Device": "MVX02",
    "Model": "Movix Go"
  },
  {
    "Retail Branding": "Movix",
    "Marketing Name": "Movix Pro",
    "Device": "MVX03",
    "Model": "Movix Pro"
  },
  {
    "Retail Branding": "Moxalc",
    "Marketing Name": "AD116_EEA",
    "Device": "AD116",
    "Model": "AD116"
  },
  {
    "Retail Branding": "Moxalc",
    "Marketing Name": "AD116_ROW",
    "Device": "AD116",
    "Model": "AD116"
  },
  {
    "Retail Branding": "Moxee",
    "Marketing Name": "m2467",
    "Device": "m2467",
    "Model": "m2467"
  },
  {
    "Retail Branding": "Moxee Technologies",
    "Marketing Name": "MH-T6000",
    "Device": "MH-T6000",
    "Model": "MH-T6000"
  },
  {
    "Retail Branding": "Moxee Technologies",
    "Marketing Name": "MT-T800",
    "Device": "MT-T800",
    "Model": "MT-T800"
  },
  {
    "Retail Branding": "Moxee Technologies",
    "Marketing Name": "MT-T8B22",
    "Device": "MT-T8B22",
    "Model": "MT-T8B22"
  },
  {
    "Retail Branding": "Moxee Technologies",
    "Marketing Name": "Moxee_T2310",
    "Device": "T2310",
    "Model": "T2310"
  },
  {
    "Retail Branding": "Moxee Technologies",
    "Marketing Name": "X10",
    "Device": "X10",
    "Model": "X10"
  },
  {
    "Retail Branding": "Moxee Technologies",
    "Marketing Name": "X100",
    "Device": "X100",
    "Model": "X100"
  },
  {
    "Retail Branding": "Moxee Technologies",
    "Marketing Name": "m2307",
    "Device": "m2307",
    "Model": "m2307"
  },
  {
    "Retail Branding": "MozaTab",
    "Marketing Name": "MTN_E1",
    "Device": "MTN_E1",
    "Model": "TU10MK1"
  },
  {
    "Retail Branding": "Mpgio",
    "Marketing Name": "ATHENA_A10",
    "Device": "ATHENA_A10",
    "Model": "ATHENA_A10"
  },
  {
    "Retail Branding": "Mpgio",
    "Marketing Name": "ATHENA_X",
    "Device": "MID",
    "Model": "MID"
  },
  {
    "Retail Branding": "Mpgio",
    "Marketing Name": "IKP104",
    "Device": "IKP104",
    "Model": "IKP104"
  },
  {
    "Retail Branding": "Mpgio",
    "Marketing Name": "LEGEND_EZ",
    "Device": "LEGEND_EZ",
    "Model": "LEGEND_EZ"
  },
  {
    "Retail Branding": "Mpgio",
    "Marketing Name": "LEGEND_NEW7",
    "Device": "LEGEND_NEW7",
    "Model": "LEGEND_NEW7"
  },
  {
    "Retail Branding": "Mpgio",
    "Marketing Name": "LEGEND_R",
    "Device": "LEGEND_R",
    "Model": "LEGEND_R"
  },
  {
    "Retail Branding": "Mpgio",
    "Marketing Name": "LEGEND_R_PLUS",
    "Device": "LEGEND_R_PLUS",
    "Model": "LEGEND_R_PLUS"
  },
  {
    "Retail Branding": "Mpgio",
    "Marketing Name": "Legend_A",
    "Device": "Legend_A",
    "Model": "Legend_A"
  },
  {
    "Retail Branding": "Mpgio",
    "Marketing Name": "MAT10221",
    "Device": "MAT10221",
    "Model": "MAT10221"
  },
  {
    "Retail Branding": "Mpgio",
    "Marketing Name": "MAT10421",
    "Device": "MAT10421",
    "Model": "MAT10421"
  },
  {
    "Retail Branding": "Mpgio",
    "Marketing Name": "MAT80211B",
    "Device": "MAT80211B",
    "Model": "MAT80211B"
  },
  {
    "Retail Branding": "Mpgio",
    "Marketing Name": "MLT156001",
    "Device": "MLT156001",
    "Model": "MLT156001"
  },
  {
    "Retail Branding": "Mpgio",
    "Marketing Name": "MLT703824",
    "Device": "MLT703824",
    "Model": "MLT703824"
  },
  {
    "Retail Branding": "Mpgio",
    "Marketing Name": "MPGIO_10",
    "Device": "MPGIO_10",
    "Model": "MPGIO-10"
  },
  {
    "Retail Branding": "Mpgio",
    "Marketing Name": "MPGIO_8",
    "Device": "MPGIO_8",
    "Model": "MPGIO_8"
  },
  {
    "Retail Branding": "Mpgio",
    "Marketing Name": "MTabAir9",
    "Device": "MTabAir9",
    "Model": "MTabAir9"
  },
  {
    "Retail Branding": "Mpgio",
    "Marketing Name": "W100",
    "Device": "W100",
    "Model": "W100"
  },
  {
    "Retail Branding": "Mpman",
    "Marketing Name": "MPQC10",
    "Device": "MPQC10",
    "Model": "MPQC10"
  },
  {
    "Retail Branding": "Mpman",
    "Marketing Name": "MPQC_9",
    "Device": "MPQC_9",
    "Model": "MPQC_9"
  },
  {
    "Retail Branding": "Mpman",
    "Marketing Name": "PH574",
    "Device": "PH574",
    "Model": "PH574"
  },
  {
    "Retail Branding": "Mpman",
    "Marketing Name": "PH60",
    "Device": "PH60",
    "Model": "PH60"
  },
  {
    "Retail Branding": "Mpman",
    "Marketing Name": "PH604",
    "Device": "PH604",
    "Model": "PH604"
  },
  {
    "Retail Branding": "Mswipe",
    "Marketing Name": "WiseposGo",
    "Device": "L200",
    "Model": "L200"
  },
  {
    "Retail Branding": "Mtek",
    "Marketing Name": "MTEK",
    "Device": "elliniko",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "Mtek",
    "Marketing Name": "MTEK",
    "Device": "hongkong",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "Mtek",
    "Marketing Name": "MTEK",
    "Device": "lavender",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "Mtek",
    "Marketing Name": "MTEK",
    "Device": "mountbaker",
    "Model": "2K SMART TV"
  },
  {
    "Retail Branding": "Mtek",
    "Marketing Name": "MTEK",
    "Device": "stanford",
    "Model": "2K SMART TV"
  },
  {
    "Retail Branding": "Mtek",
    "Marketing Name": "MTEK",
    "Device": "zhongshan",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "Mtel",
    "Marketing Name": "HP44H",
    "Device": "HP44H-mtel",
    "Model": "HP44H-mtel"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "Brazil",
    "Device": "martin",
    "Model": "Multilaser Android TV"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "Brazil",
    "Device": "sepolia",
    "Model": "Multi smart TV"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "DI01_M7_WIFI",
    "Device": "DI01_M7_WIFI",
    "Model": "DI01_M7_WIFI"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "Discovery",
    "Device": "Discovery",
    "Model": "Discovery"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "F Max 2",
    "Device": "Multilaser_F_Max_2",
    "Model": "Multilaser_F_Max_2"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "G 3",
    "Device": "Multilaser_G_3",
    "Model": "Multilaser_G_3"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "G Max 2 SE",
    "Device": "Multilaser_G_Max_2_SE_64",
    "Model": "Multilaser_G_Max_2_SE_64"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "G Max 2 SE 128",
    "Device": "G_Max_2_SE_128",
    "Model": "Multilaser_G_Max_2_SE_128"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "G Pro 3",
    "Device": "Multilaser_G_Pro_3",
    "Model": "Multilaser_G_Pro_3"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "G Pro 3S",
    "Device": "Multilaser_G_Pro_3S",
    "Model": "Multilaser_G_Pro_3S"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "GMax 2 Payjoy",
    "Device": "GMAX_2_Payjoy",
    "Model": "Multilaser_GMAX_2_Payjoy"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "KIDPAD 3G",
    "Device": "ML-JI21-M7-3G-PLUS-KIDPAD",
    "Model": "KIDPAD-3G"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "KIDPAD LITE",
    "Device": "ML-SO06-M7S-LITE-KIDPAD",
    "Model": "KIDPAD_LITE"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "Kidpad-3G",
    "Device": "Kidpad-3G",
    "Model": "Kidpad-3G"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "M10 3G",
    "Device": "ML-JI16-M10-3G",
    "Model": "M10-3G"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "M10 3G",
    "Device": "ML_SO0Q_M10_3G",
    "Model": "M10_3G"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "M10 4G",
    "Device": "ML-JI0A-M10-4G",
    "Model": "M10-4G"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "M10 4G",
    "Device": "ML-WI0C-M10-4G",
    "Model": "M10-4G"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "M10 4G",
    "Device": "ML_JI0B_M10_4G",
    "Model": "M10_4G"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "M10 4G",
    "Device": "ML_JI0L_M10_4G",
    "Model": "M10_4G"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "M10 4G",
    "Device": "ML_JI0M_M10_4G",
    "Model": "M10_4G"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "M10 4G",
    "Device": "ML_SO0G_M10_4G",
    "Model": "M10_4G"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "M10 4G",
    "Device": "ML_SO0G_M10_4G",
    "Model": "M10_4G_PRO"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "M10 4G",
    "Device": "ML_SO0K_M10_4G_T3",
    "Model": "M10_4G_T3"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "M10 4G",
    "Device": "ML_SO2G_M10_4G_T1",
    "Model": "M10_4G_T1"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "M10 4G",
    "Device": "ML_SO4G_M10_4G_T3",
    "Model": "M10_4G_T3"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "M10 4G MC",
    "Device": "ML_JI0B_M10_4G_MC",
    "Model": "M10_4G_MONTES_CLAROS"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "M10 4G MC",
    "Device": "ML_SO0G_M10_4G_MC",
    "Model": "M10_4G_MONTES_CLAROS"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "M10 4G MON CLA",
    "Device": "WI0C_M10_4G_MON_CLA",
    "Model": "M10_4G_MON_CLA"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "M10 4G NOVA",
    "Device": "ML_SO0C_M10_4G_NOVA",
    "Model": "M10_4G_NOVA"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "M10 4G NOVA",
    "Device": "ML_SO1C_M10_4G_NOVA",
    "Model": "M10_4G_NOVA"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "M10 4G PRO",
    "Device": "ML_JI0B_M10_4G_PRO",
    "Model": "M10_4G_PRO"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "M10 4G PRO",
    "Device": "ML_JI0F_M10_4G_PRO",
    "Model": "M10_4G_PRO"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "M10 4G PRO",
    "Device": "ML_SO1G_M10_4G_PRO",
    "Model": "M10_4G_PRO"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "M10 4G T1",
    "Device": "ML_SO5C_M10_4G_T1",
    "Model": "M10_4G_T1"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "M10 4G T1",
    "Device": "ML_SO6C_M10_4G_T1",
    "Model": "M10_4G_T1"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "M10 4G T3",
    "Device": "ML-WI1C-M10-4G-T3",
    "Model": "M10-4G-T3"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "M10 4G TERE",
    "Device": "ML_JI0B_M10_4G_TERE",
    "Model": "M10_4G_TERESOPOLIS"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "M10 4G TERESOPOLIS",
    "Device": "ML_SO0G_M10_4G_T",
    "Model": "M10_4G_TERESOPOLIS"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "M10 WIFI",
    "Device": "ML_SO0U_M10_WIFI",
    "Model": "M10_WIFI"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "M10 WIFI",
    "Device": "ML_SO1U_M10_WIFI",
    "Model": "M10_WIFI"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "M10-3G",
    "Device": "ML-JI06-M10-3G",
    "Model": "M10-3G"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "M10-4G",
    "Device": "ML-JI03-M10-4G",
    "Model": "M10-4G"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "M10A",
    "Device": "M10A",
    "Model": "M10A"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "M10A-Lite",
    "Device": "M10A-Lite",
    "Model": "M10A-Lite"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "M10A_3G",
    "Device": "M10A_3G",
    "Model": "M10A_3G"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "M10A_Lite",
    "Device": "ML_SO0A_M10A_Lite",
    "Model": "M10A_Lite"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "M10_3G",
    "Device": "ML_JI0H_M10_3G",
    "Model": "M10_3G"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "M10_3G",
    "Device": "ML_SO0B_M10_3G",
    "Model": "M10_3G"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "M10_4G _AC",
    "Device": "ML_JI0C_M10_4G_AC",
    "Model": "M10_4G_AC"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "M10_4G_PRO",
    "Device": "ML-SO0C_M10_4G_PRO_PLUS",
    "Model": "M10_4G_PRO"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "M10_4G_PRO",
    "Device": "ML_SO0G_M10_4G_PRO_PLUS",
    "Model": "M10_4G_PRO"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "M10_4G_PRO_TERE",
    "Device": "WI0C_M10_4G_PRO_TERE",
    "Model": "M10_4G_PRO_TERE"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "M7 3G",
    "Device": "ML-WI1B-M7-3G",
    "Model": "M7-3G"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "M7 3G",
    "Device": "ML_JI0N_M7_3G",
    "Model": "M7_3G"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "M7 3G",
    "Device": "ML_JI1G_M7_3G",
    "Model": "M7_3G"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "M7 3G",
    "Device": "ML_JI2G_M7_3G",
    "Model": "M7_3G"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "M7 3G",
    "Device": "ML_WI0B_M7_3G",
    "Model": "M7_3G"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "M7 3G A10",
    "Device": "ML_WI4A_M7_3G_A10",
    "Model": "M7_3G_A10"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "M7 3G PLUS",
    "Device": "ML-JI0G-M7-3G-PLUS",
    "Model": "M7-3G-PLUS"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "M7 3G PLUS",
    "Device": "ML-JI11-M7_3G_PLUS",
    "Model": "M7_3G_PLUS"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "M7 3G PLUS",
    "Device": "ML-JI31-M7-3G-PLUS",
    "Model": "M7-3G-PLUS"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "M7 3G PLUS",
    "Device": "ML_WI0A_M7_3G_PLUS",
    "Model": "M7_3G_PLUS"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "M7 3G Plus",
    "Device": "ML_WI12_M7_3G_PLUS",
    "Model": "M7_3G_PLUS"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "M7 WIF",
    "Device": "ML_JI1D_M7_WIFI",
    "Model": "M7_WIFI"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "M7 WIFI",
    "Device": "ML_JI0O_M7_WIFI",
    "Model": "M7_WIFI"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "M7 WIFI",
    "Device": "ML_JI0S_M7_WIFI",
    "Model": "M7_WIFI"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "M7 WIFI",
    "Device": "ML_JI2D_M7_WIFI",
    "Model": "M7_WIFI"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "M7 WIFI",
    "Device": "ML_JI3D_M7_WIFI",
    "Model": "M7_WIFI"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "M7 WIFI",
    "Device": "ML_SO0AA_M7_WIFI",
    "Model": "M7_WIFI"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "M7 WIFI",
    "Device": "ML_SO0E_M7_WIFI",
    "Model": "M7_WIFI"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "M7 WIFI",
    "Device": "ML_SO0P_M7_WIFI",
    "Model": "M7_WIFI"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "M7 WIFI",
    "Device": "ML_SO0R_M7_WIFI",
    "Model": "M7_WIFI"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "M7 WIFI",
    "Device": "ML_SO0S_M7_WIFI",
    "Model": "M7_WIFI"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "M7 WIFI",
    "Device": "ML_SO1E_M7_Wifi",
    "Model": "M7_WIFI"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "M7 WIFI",
    "Device": "ML_SO1S_M7_WIFI",
    "Model": "M7_WIFI"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "M7 WIFI",
    "Device": "ML_SO2E_M7_WIFI",
    "Model": "M7_WIFI"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "M7-3G PLUS",
    "Device": "ML-JI21-M7-3G-PLUS",
    "Model": "M7-3G-PLUS"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "M7-3G PLUS",
    "Device": "ML-WI-M7_3G_PLUS",
    "Model": "ML-WI-M7_3G_PLUS"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "M7-4G",
    "Device": "ML-JI-M7-4G",
    "Model": "ML-JI-M7-4G"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "M7-4G",
    "Device": "ML-JI04-M7-4G",
    "Model": "M7-4G"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "M7I-3G",
    "Device": "M7I-3G",
    "Model": "M7I-3G"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "M7I-3G",
    "Device": "astar-ococci",
    "Model": "ML01-M7S-Quad-Core"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "M7S Go",
    "Device": "ML_SO0E_M7S_Go",
    "Model": "M7S_Go"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "M7S Go",
    "Device": "ML_SO26_M7S_Go",
    "Model": "M7S_Go"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "M7S LITE",
    "Device": "ML-JI07-M7S-LITE",
    "Model": "M7S_LITE"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "M7S PLUS",
    "Device": "ML-JI08-M7S-PLUS",
    "Model": "M7S_PLUS"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "M7S Plus",
    "Device": "ML_SO0F_M7S_Plus",
    "Model": "M7S_Plus"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "M7S Plus",
    "Device": "ML_SO17_M7S_Plus",
    "Model": "M7S_Plus"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "M7SQC Plus",
    "Device": "M7SQC_Plus",
    "Model": "M7SQC_Plus"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "M7SQC Plus",
    "Device": "ML-JI22-M7SQC_Plus",
    "Model": "M7SQC_Plus"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "M7SQC_ Plus",
    "Device": "ML-JI22-M7SQC_Plus",
    "Model": "M7SQC_Plus"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "M7S_LITE",
    "Device": "ML-JI07-M7S-LITE",
    "Model": "M7S_LITE"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "M7S_PLUS",
    "Device": "ML-JI08-M7S-PLUS",
    "Model": "M7S_PLUS"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "M7S_PLUS",
    "Device": "ML-SO07-M7S-PLUS",
    "Model": "M7S_PLUS"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "M7S_PLUS",
    "Device": "ML-SO07-M7S-PLUS",
    "Model": "M7S_PLUS_KIDPAD"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "M7S_PLUS",
    "Device": "ML-SO07-M7S-PLUS",
    "Model": "M7S_PLUS_PRINCESAS"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "M7_3G_A10",
    "Device": "ML_WI1A_M7_3G_A10",
    "Model": "M7_3G_A10"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "M7_3G_A10",
    "Device": "ML_WI2A_M7_3G_A10",
    "Model": "M7_3G_A10"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "M7_3G_A10",
    "Device": "ML_WI3A_M7_3G_A10",
    "Model": "M7_3G_A10"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "M7_WIFI",
    "Device": "ML_DI01_M7_WIFI",
    "Model": "M7_WIFI"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "M7_WIFI",
    "Device": "ML_JI0D_M7_WIFI",
    "Model": "M7_WIFI"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "M7s Dual Core",
    "Device": "NB116_NB117_NB118",
    "Model": "M7s Dual ML03"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "M7s Quad Core",
    "Device": "astar-ococci",
    "Model": "ML01-M7S-Quad-Core"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "M7sLite",
    "Device": "ML-SO06-M7sLite",
    "Model": "M7sLite"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "M8 4G",
    "Device": "ML-WI0G-M8-4G",
    "Model": "M8-4G"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "M8 4G",
    "Device": "ML_JI0I_M8_4G",
    "Model": "M8_4G"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "M8 4G",
    "Device": "ML_SO0J_M8_4G",
    "Model": "M8_4G"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "M8 4G",
    "Device": "ML_SO0T_M8_WIFI",
    "Model": "M8_WIFI"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "M8 4G",
    "Device": "ML_SO0V_M8_4G",
    "Model": "M8_4G"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "M8 4G",
    "Device": "ML_SO1J_M8_4G",
    "Model": "M8_4G"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "M8 4G",
    "Device": "ML_SO4J_M8_4G_T3",
    "Model": "M8_4G_T3"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "M8 Wifi",
    "Device": "ML_SO0F_M8_WIFI",
    "Model": "M8_WIFI"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "M8_4G",
    "Device": "ML_SO19_M8_4G",
    "Model": "M8_4G"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "M8_4G_T1",
    "Device": "ML_SO2J_M8_4G_T1",
    "Model": "M8_4G_T1"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "M9 3G",
    "Device": "ML-WI16-M9_3G",
    "Model": "M9_3G"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "M9 WIFI",
    "Device": "ML_JI0E_M9_WIFI",
    "Model": "M9_WIFI"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "M9 WIFI",
    "Device": "ML_SO0W_M9_WIFI",
    "Model": "M9_WIFI"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "M9 Wifi",
    "Device": "ML_SO08_M9_Wifi",
    "Model": "M9_Wifi"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "M9-3G",
    "Device": "M9-3G",
    "Model": "M9-3G"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "M9-3G",
    "Device": "ML-JI05-M9-3G",
    "Model": "M9-3G"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "M9-3G",
    "Device": "ML-SO-M9-3G",
    "Model": "ML-SO-M9-3G"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "M9-3G",
    "Device": "ML-WI-M9-3G",
    "Model": "ML-WI-M9-3G"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "M9-3G-2",
    "Device": "M9-3G_2",
    "Model": "M9-3G_2"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "M9S-Go",
    "Device": "ML-JI09-M9S-GO",
    "Model": "M9S-Go"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "M9_WIFI",
    "Device": "ML_JI0T_M9_WIFI",
    "Model": "M9_WIFI"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "M9_WIFI",
    "Device": "ML_JI0U_M9_WIFI",
    "Model": "M9_WIFI"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "ML-JI-M7_3G_PLUS",
    "Device": "ML-JI-M7_3G_PLUS",
    "Model": "ML-JI-M7_3G_PLUS"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "ML-JI11-M7_3G_PLUS",
    "Device": "ML-JI11-M7_3G_PLUS",
    "Model": "ML-JI11-M7_3G_PLUS"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "ML-SO-M7_3G_PLUS",
    "Device": "ML-SO-M7_3G_PLUS",
    "Model": "ML-SO-M7_3G_PLUS"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "ML-SO-MLX1",
    "Device": "ML-SO-MLX1",
    "Model": "ML-SO-MLX1"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "MLX8",
    "Device": "ML-WI23-MLX8",
    "Model": "MLX8"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "MLX8",
    "Device": "MLX8",
    "Model": "MLX8"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "MLX8 4G",
    "Device": "MLX8_4G",
    "Model": "MLX8_4G"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "MLX8_4G",
    "Device": "ML_SO09_MLX8_4G",
    "Model": "MLX8_4G"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "ML_GW0C_M10_4G",
    "Device": "ML_GW0C_M10_4G",
    "Model": "ML_GW0C_M10_4G"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "ML_JI1C_M7S_PLUS",
    "Device": "ML_JI1C_M7S_PLUS",
    "Model": "M7S_PLUS"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "ML_JI29_M9S_GO",
    "Device": "ML_JI29_M9S_GO",
    "Model": "M9S_GO"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "ML_JI37_M7S_LITE",
    "Device": "ML_JI37_M7S_LITE",
    "Model": "M7S_LITE"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "MS40G",
    "Device": "ML-TI-MS40G",
    "Model": "MS40G"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "MS40G_VIVO",
    "Device": "ML-TI-MS40G_VIVO",
    "Model": "MS40G_VIVO"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "MS40S",
    "Device": "MS40S",
    "Model": "MS40S"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "MS40s",
    "Device": "MS40S",
    "Model": "MS40S"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "MS45",
    "Device": "MS45",
    "Model": "MS45"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "MS45 4G",
    "Device": "ML-CH-MS45_4G",
    "Model": "ML-CH-MS45_4G"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "MS45S",
    "Device": "MS45S",
    "Model": "MS45S"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "MS45S",
    "Device": "MS45S_A6",
    "Model": "MS45S_A6"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "MS50",
    "Device": "MS50",
    "Model": "MS50"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "MS50G",
    "Device": "ML-TI-MS50G",
    "Model": "MS50G"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "MS50L",
    "Device": "MS50L",
    "Model": "MS50L"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "MS50L 4G",
    "Device": "MS50L_4G",
    "Model": "MS50L_4G"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "MS50M",
    "Device": "MS50M",
    "Model": "MS50M"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "MS50S",
    "Device": "MS50S",
    "Model": "MS50S"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "MS50X",
    "Device": "ML-TI-MS50X",
    "Model": "MS50X"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "MS50X_VIVO",
    "Device": "ML-TI-MS50X_VIVO",
    "Model": "MS50X_VIVO"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "MS50_4G",
    "Device": "MS50_4G",
    "Model": "MS50_4G"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "MS55",
    "Device": "MS55",
    "Model": "MS55"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "MS55M",
    "Device": "MS55M",
    "Model": "MS55M"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "MS60",
    "Device": "MS60",
    "Model": "MS60"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "MS60F",
    "Device": "MS60F",
    "Model": "MS60F"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "MS60F Plus",
    "Device": "MS60F_PLUS",
    "Model": "MS60F_PLUS"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "MS60X",
    "Device": "ML-TI0A-MS60X",
    "Model": "MS60X"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "MS60X",
    "Device": "ML-TI0C-MS60X",
    "Model": "MS60X"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "MS60Z",
    "Device": "ML-TI0B-MS60Z",
    "Model": "MS60Z"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "MS70",
    "Device": "MS70",
    "Model": "MS70"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "MS80",
    "Device": "ML-TI-MS80",
    "Model": "ML-TI-MS80"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "MS80X",
    "Device": "ML-TI0D-MS80X",
    "Model": "MS80X"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "MULTILASER",
    "Device": "zhongshan",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "Ms5",
    "Device": "MTL-MS5",
    "Model": "MS5"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "Ms6",
    "Device": "MS6",
    "Model": "MS6"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "Multi Google TV",
    "Device": "kualakai",
    "Model": "Multi Google TV"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "Multi smart TV",
    "Device": "dongnae",
    "Model": "Multi smart TV"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "Multilaser E",
    "Device": "Multilaser_E",
    "Model": "Multilaser_E"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "Multilaser E",
    "Device": "Multilaser_E_A10",
    "Model": "Multilaser_E"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "Multilaser E 2",
    "Device": "Multilaser_E_2",
    "Model": "Multilaser_E_2"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "Multilaser E Lite",
    "Device": "Multilaser_E_Lite",
    "Model": "Multilaser_E_Lite"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "Multilaser E Pro",
    "Device": "Multilaser_E_Pro",
    "Model": "Multilaser_E_Pro"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "Multilaser Elite 2",
    "Device": "Multilaser_Elite_2",
    "Model": "Multilaser_Elite_2"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "Multilaser F",
    "Device": "Multilaser_F_A10",
    "Model": "Multilaser_F"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "Multilaser F Pro",
    "Device": "Multilaser_F_Pro",
    "Model": "Multilaser_F_Pro"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "Multilaser F Pro 2",
    "Device": "Multilaser_F_Pro_2",
    "Model": "Multilaser_F_Pro_2"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "Multilaser F2",
    "Device": "Multilaser_F2",
    "Model": "Multilaser_F2"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "Multilaser G",
    "Device": "Multilaser_G",
    "Model": "Multilaser_G"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "Multilaser G 2",
    "Device": "Multilaser_G_2",
    "Model": "Multilaser_G_2"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "Multilaser G Max",
    "Device": "Multilaser_G_Max",
    "Model": "Multilaser_G_Max"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "Multilaser G Max 2",
    "Device": "Multilaser_GMAX_2_64",
    "Model": "Multilaser_GMAX_2"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "Multilaser G Max 2",
    "Device": "Multilaser_GMax_2_128",
    "Model": "Multilaser_GMax_2"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "Multilaser G Pro",
    "Device": "Multilaser_G_Pro",
    "Model": "Multilaser_G_Pro"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "Multilaser G Pro 2",
    "Device": "Multilaser_GPRO2",
    "Model": "Multilaser_GPRO2"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "Multilaser G VIVO",
    "Device": "Multilaser_G_VIVO",
    "Model": "Multilaser_G_VIVO"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "Multilaser H",
    "Device": "Multilaser_H",
    "Model": "Multilaser H"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "Multilaser H 5G",
    "Device": "Multilaser_H_5G",
    "Model": "Multilaser_H_5G"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "Multilaser_F",
    "Device": "Multilaser_F",
    "Model": "Multilaser_F"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "OBASMART",
    "Device": "Obasmart_Conectamax",
    "Model": "OBA_Conecta_Max"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "OBASMART 3",
    "Device": "OBASMART_3",
    "Model": "OBASMART_3"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "Oba Conecta 4G",
    "Device": "Oba_Conecta_4G",
    "Model": "Oba_Conecta_4G"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "Sikur",
    "Device": "Multilaser_GMax_2_Sikur",
    "Model": "Multilaser_GMax_2_Sikur"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "U10",
    "Device": "ML_SO0K_U10_MTK",
    "Model": "U10"
  },
  {
    "Retail Branding": "Multilaser",
    "Marketing Name": "ULTRA 10",
    "Device": "ML_SO0C_ULTRA_10",
    "Model": "ULTRA_10"
  },
  {
    "Retail Branding": "Mundo",
    "Marketing Name": "Chile",
    "Device": "S3001",
    "Model": "MundoGoTV"
  },
  {
    "Retail Branding": "MwalimuPlus",
    "Marketing Name": "MP01A3G",
    "Device": "MP01A3G",
    "Model": "MP01A3G"
  },
  {
    "Retail Branding": "My",
    "Marketing Name": "Android TV",
    "Device": "finch",
    "Model": "Android TV"
  },
  {
    "Retail Branding": "My",
    "Marketing Name": "Android TV",
    "Device": "shandao",
    "Model": "Android TV"
  },
  {
    "Retail Branding": "My",
    "Marketing Name": "Android TV",
    "Device": "tokyo",
    "Model": "Android TV"
  },
  {
    "Retail Branding": "My",
    "Marketing Name": "Android TV",
    "Device": "yeoksam",
    "Model": "Android TV"
  },
  {
    "Retail Branding": "My",
    "Marketing Name": "Android TV",
    "Device": "yeoksam",
    "Model": "AndroidTV"
  },
  {
    "Retail Branding": "My",
    "Marketing Name": "Android TV",
    "Device": "yeoksam",
    "Model": "Cosmos"
  },
  {
    "Retail Branding": "My Go",
    "Marketing Name": "GoTab GBT10",
    "Device": "GBT10",
    "Model": "GoTab_GBT10"
  },
  {
    "Retail Branding": "MyBox",
    "Marketing Name": "MBIF-H533",
    "Device": "DV8020",
    "Model": "MBIF-H533"
  },
  {
    "Retail Branding": "MyFon",
    "Marketing Name": "F3",
    "Device": "F3",
    "Model": "F3"
  },
  {
    "Retail Branding": "MyFon",
    "Marketing Name": "F6",
    "Device": "F6",
    "Model": "F6"
  },
  {
    "Retail Branding": "MyFon",
    "Marketing Name": "S2",
    "Device": "S2",
    "Model": "S2"
  },
  {
    "Retail Branding": "MyFon",
    "Marketing Name": "S5",
    "Device": "S5",
    "Model": "S5"
  },
  {
    "Retail Branding": "MyPhone (PL)",
    "Marketing Name": "C-Smart pix",
    "Device": "C-Smart_pix_JMP",
    "Model": "C-Smart_pix"
  },
  {
    "Retail Branding": "MyPhone (PL)",
    "Marketing Name": "Cube LTE",
    "Device": "CUBE_LTE_PLAY",
    "Model": "CUBE_LTE"
  },
  {
    "Retail Branding": "MyPhone (PL)",
    "Marketing Name": "Fun_LTE",
    "Device": "Fun_LTE",
    "Model": "myPhone Fun LTE"
  },
  {
    "Retail Branding": "MyPhone (PL)",
    "Marketing Name": "Hammer AXE PRO",
    "Device": "Hammer_AXE_Pro_OPM",
    "Model": "Hammer AXE Pro"
  },
  {
    "Retail Branding": "MyPhone (PL)",
    "Marketing Name": "Hammer Blade 2 Pro",
    "Device": "Hammer_Blade2_PRO",
    "Model": "Hammer_Blade2_PRO"
  },
  {
    "Retail Branding": "MyPhone (PL)",
    "Marketing Name": "Hammer IRON 3 LTE",
    "Device": "Hammer_IRON_3_LTE",
    "Model": "Hammer_IRON_3_LTE"
  },
  {
    "Retail Branding": "MyPhone (PL)",
    "Marketing Name": "Hammer Titan 2",
    "Device": "Hammer_Titan_2",
    "Model": "Hammer Titan 2"
  },
  {
    "Retail Branding": "MyPhone (PL)",
    "Marketing Name": "Hammer_Active",
    "Device": "HammerActive",
    "Model": "Hammer Active"
  },
  {
    "Retail Branding": "MyPhone (PL)",
    "Marketing Name": "Hammer_Energy_3G",
    "Device": "Hammer_Energy_3G",
    "Model": "Hammer Energy 3G"
  },
  {
    "Retail Branding": "MyPhone (PL)",
    "Marketing Name": "Hammer_Explorer",
    "Device": "Hammer_Explorer",
    "Model": "Hammer_Explorer"
  },
  {
    "Retail Branding": "MyPhone (PL)",
    "Marketing Name": "Hammer_IRON_3_LTE",
    "Device": "Hammer_IRON_3_LTEv2",
    "Model": "Hammer_IRON_3_LTE"
  },
  {
    "Retail Branding": "MyPhone (PL)",
    "Marketing Name": "Hammer_Iron_2",
    "Device": "Hammer_Iron_2",
    "Model": "Hammer Iron 2"
  },
  {
    "Retail Branding": "MyPhone (PL)",
    "Marketing Name": "Hykker MyTab10",
    "Device": "Hykker_MyTab10",
    "Model": "Hykker_MyTab10"
  },
  {
    "Retail Branding": "MyPhone (PL)",
    "Marketing Name": "MyPhone Go!",
    "Device": "myPhone_Go",
    "Model": "myPhone Go"
  },
  {
    "Retail Branding": "MyPhone (PL)",
    "Marketing Name": "Pocket_Pro",
    "Device": "myPhone_Pocket_Pro",
    "Model": "myPhone_Pocket_Pro"
  },
  {
    "Retail Branding": "MyPhone (PL)",
    "Marketing Name": "Prime 4 Lite",
    "Device": "Prime_4_Lite",
    "Model": "Prime_4_Lite"
  },
  {
    "Retail Branding": "MyPhone (PL)",
    "Marketing Name": "myPhone",
    "Device": "Q_Smart_BE",
    "Model": "Q_Smart_BE"
  },
  {
    "Retail Branding": "MyPhone (PL)",
    "Marketing Name": "myPhone C-Smart Glam",
    "Device": "C-Smart_Glam_JMP",
    "Model": "C-Smart_Glam"
  },
  {
    "Retail Branding": "MyPhone (PL)",
    "Marketing Name": "myPhone C-Smart IIIS",
    "Device": "C_Smart_IIIS",
    "Model": "C-Smart IIIS"
  },
  {
    "Retail Branding": "MyPhone (PL)",
    "Marketing Name": "myPhone City",
    "Device": "myPhone_City",
    "Model": "City"
  },
  {
    "Retail Branding": "MyPhone (PL)",
    "Marketing Name": "myPhone Fun 5",
    "Device": "FUN5_OPM",
    "Model": "FUN5"
  },
  {
    "Retail Branding": "MyPhone (PL)",
    "Marketing Name": "myPhone Fun 6",
    "Device": "myPhone_Fun_6",
    "Model": "myPhone_Fun_6"
  },
  {
    "Retail Branding": "MyPhone (PL)",
    "Marketing Name": "myPhone Fun 9",
    "Device": "myPhone_Fun_9",
    "Model": "myPhone_Fun_9"
  },
  {
    "Retail Branding": "MyPhone (PL)",
    "Marketing Name": "myPhone HAMMER ENERGY",
    "Device": "HAMMER_ENERGY_PLAY",
    "Model": "HAMMER_ENERGY"
  },
  {
    "Retail Branding": "MyPhone (PL)",
    "Marketing Name": "myPhone Hammer Energy",
    "Device": "Hammer_Energy",
    "Model": "Hammer Energy"
  },
  {
    "Retail Branding": "MyPhone (PL)",
    "Marketing Name": "myPhone Luna II",
    "Device": "LUNA_II_OPM",
    "Model": "LUNA_II"
  },
  {
    "Retail Branding": "MyPhone (PL)",
    "Marketing Name": "myPhone MAGNUS",
    "Device": "MAGNUS_JMP",
    "Model": "MAGNUS"
  },
  {
    "Retail Branding": "MyPhone (PL)",
    "Marketing Name": "myPhone PRIME PLUS",
    "Device": "Prime_Plus_OPM",
    "Model": "Prime_Plus"
  },
  {
    "Retail Branding": "MyPhone (PL)",
    "Marketing Name": "myPhone Pocket",
    "Device": "Pocket_OPM",
    "Model": "Pocket"
  },
  {
    "Retail Branding": "MyPhone (PL)",
    "Marketing Name": "myPhone Prime 3",
    "Device": "myPhone_Prime_3",
    "Model": "myPhone_Prime_3"
  },
  {
    "Retail Branding": "MyPhone (PL)",
    "Marketing Name": "myPhone Q-Smart Elite",
    "Device": "Q-Smart_Elite_JMP",
    "Model": "Q-Smart_Elite"
  },
  {
    "Retail Branding": "MyPhone (PL)",
    "Marketing Name": "myPhone Q-Smart Plus",
    "Device": "Q-Smart_Plus",
    "Model": "Q-Smart_Plus"
  },
  {
    "Retail Branding": "MyPhone (PL)",
    "Marketing Name": "myPhone_C-Smart _4",
    "Device": "myPhone_C-Smart_4",
    "Model": "myPhone_C-Smart_4"
  },
  {
    "Retail Branding": "MyPhone (PL)",
    "Marketing Name": "myPhone_City_2",
    "Device": "myPhone_City_2",
    "Model": "myPhone_City_2"
  },
  {
    "Retail Branding": "MyPhone (PL)",
    "Marketing Name": "myPhone_Fun5",
    "Device": "myPhone_Fun5",
    "Model": "Fun5"
  },
  {
    "Retail Branding": "MyPhone (PL)",
    "Marketing Name": "myPhone_Power",
    "Device": "myPhone_Power",
    "Model": "Power"
  },
  {
    "Retail Branding": "MyPhone (PL)",
    "Marketing Name": "myPhone_Prime_2",
    "Device": "myPhone_Prime_2",
    "Model": "Prime 2"
  },
  {
    "Retail Branding": "MyRepublic",
    "Marketing Name": "B866V2FA V3.3",
    "Device": "B866V2FAV3",
    "Model": "B866V2FA V3.3"
  },
  {
    "Retail Branding": "MyTab_pro",
    "Marketing Name": "My-10-13-1",
    "Device": "MyTab_Pro_13",
    "Model": "My-10-13-1"
  },
  {
    "Retail Branding": "MyXMS",
    "Marketing Name": "P1010002",
    "Device": "P1010002",
    "Model": "P1010002"
  },
  {
    "Retail Branding": "MyanmarNet",
    "Marketing Name": "TVie 1B",
    "Device": "SEI140FT",
    "Model": "TVie 1B"
  },
  {
    "Retail Branding": "MyoTab",
    "Marketing Name": "MyoTab10",
    "Device": "Tablet_PC",
    "Model": "MyoTab10"
  },
  {
    "Retail Branding": "Myphone",
    "Marketing Name": "CITY XL",
    "Device": "myPhone_CityXL",
    "Model": "CityXL"
  },
  {
    "Retail Branding": "Myphone",
    "Marketing Name": "CITY XL",
    "Device": "myPhone_CityXL",
    "Model": "myPhone CityXL"
  },
  {
    "Retail Branding": "Myphone",
    "Marketing Name": "CUBE",
    "Device": "myphone_cube",
    "Model": "myPhone Cube"
  },
  {
    "Retail Branding": "Myphone",
    "Marketing Name": "FUN_18x9",
    "Device": "myPhone_FUN_18x9_EEA",
    "Model": "myPhone_FUN_18x9_EEA"
  },
  {
    "Retail Branding": "Myphone",
    "Marketing Name": "Fun 18x9",
    "Device": "FUN_18x9",
    "Model": "FUN_18x9"
  },
  {
    "Retail Branding": "Myphone",
    "Marketing Name": "Fun 6 Lite",
    "Device": "Fun6Lite",
    "Model": "myPhone_Fun6Lite"
  },
  {
    "Retail Branding": "Myphone",
    "Marketing Name": "Fusion5_F803B",
    "Device": "Fusion5_F803B",
    "Model": "Fusion5_F803B"
  },
  {
    "Retail Branding": "Myphone",
    "Marketing Name": "HAMMER BOLT",
    "Device": "Hammer_Bolt",
    "Model": "Bolt"
  },
  {
    "Retail Branding": "Myphone",
    "Marketing Name": "HAMMER IRON V",
    "Device": "HS2302x",
    "Model": "Hammer Iron V"
  },
  {
    "Retail Branding": "Myphone",
    "Marketing Name": "Hammer AXE M LTE",
    "Device": "AXE_M_LTE_OPM",
    "Model": "HAMMER_AXE_M_LTE"
  },
  {
    "Retail Branding": "Myphone",
    "Marketing Name": "Hammer Active 2 LTE",
    "Device": "Hammer_Active2_LTE",
    "Model": "Hammer_Active2_LTE"
  },
  {
    "Retail Branding": "Myphone",
    "Marketing Name": "Hammer Blade",
    "Device": "Hammer_Blade",
    "Model": "Blade"
  },
  {
    "Retail Branding": "Myphone",
    "Marketing Name": "Hammer Energy",
    "Device": "Hammer_Energy",
    "Model": "Hammer Energy"
  },
  {
    "Retail Branding": "Myphone",
    "Marketing Name": "Hammer Energy 18x9",
    "Device": "Hammer_Energy_18x9",
    "Model": "Hammer_Energy_18x9"
  },
  {
    "Retail Branding": "Myphone",
    "Marketing Name": "Hammer Energy 2",
    "Device": "Hammer_Energy_2",
    "Model": "Hammer_Energy_2"
  },
  {
    "Retail Branding": "Myphone",
    "Marketing Name": "Hammer IRON 3",
    "Device": "Hammer_IRON_3",
    "Model": "Hammer_IRON_3"
  },
  {
    "Retail Branding": "Myphone",
    "Marketing Name": "Hammer IRON 4",
    "Device": "Hammer_IRON_4",
    "Model": "Hammer_IRON_4"
  },
  {
    "Retail Branding": "Myphone",
    "Marketing Name": "Hammer Iron 3 LTE",
    "Device": "Hammer_Iron_3_LTE",
    "Model": "Hammer_Iron_3_LTE"
  },
  {
    "Retail Branding": "Myphone",
    "Marketing Name": "Hammer_Active2",
    "Device": "Hammer_Active2",
    "Model": "Hammer_Active2"
  },
  {
    "Retail Branding": "Myphone",
    "Marketing Name": "Iron 2",
    "Device": "IRON_2_EN",
    "Model": "IRON_2"
  },
  {
    "Retail Branding": "Myphone",
    "Marketing Name": "Iron 2",
    "Device": "IRON_2_OPM",
    "Model": "IRON_2"
  },
  {
    "Retail Branding": "Myphone",
    "Marketing Name": "My phone PRIME PLUS",
    "Device": "Prime_Plus_EN",
    "Model": "Prime_Plus"
  },
  {
    "Retail Branding": "Myphone",
    "Marketing Name": "NB106M",
    "Device": "NB106M",
    "Model": "NB106M"
  },
  {
    "Retail Branding": "Myphone",
    "Marketing Name": "NB754",
    "Device": "NB754",
    "Model": "NB754"
  },
  {
    "Retail Branding": "Myphone",
    "Marketing Name": "NB961",
    "Device": "NB961",
    "Model": "NB961"
  },
  {
    "Retail Branding": "Myphone",
    "Marketing Name": "Pocket 18X9",
    "Device": "myPhone_Pocket_18x9",
    "Model": "myPhone_Pocket_18x9"
  },
  {
    "Retail Branding": "Myphone",
    "Marketing Name": "Pocket 18x9",
    "Device": "Pocket_18x9",
    "Model": "Pocket_18x9"
  },
  {
    "Retail Branding": "Myphone",
    "Marketing Name": "Pocket18X9 LTE",
    "Device": "Pocket_18x9_LTE",
    "Model": "Pocket_18x9_LTE"
  },
  {
    "Retail Branding": "Myphone",
    "Marketing Name": "Prime 18x9",
    "Device": "Prime_18x9",
    "Model": "Prime_18x9"
  },
  {
    "Retail Branding": "Myphone",
    "Marketing Name": "Prime 18x9 LTE",
    "Device": "Prime_18x9_LTE",
    "Model": "Prime_18x9_LTE"
  },
  {
    "Retail Branding": "Myphone",
    "Marketing Name": "Q-Smart_III",
    "Device": "myPhone_Q-Smart_III",
    "Model": "myPhone_Q-Smart_III"
  },
  {
    "Retail Branding": "Myphone",
    "Marketing Name": "SmartView_7_3G",
    "Device": "SmartView_7_3G",
    "Model": "SmartView_7_3G"
  },
  {
    "Retail Branding": "Myphone",
    "Marketing Name": "SmartView_8",
    "Device": "SmartView_8_LTE",
    "Model": "SmartView_8_LTE"
  },
  {
    "Retail Branding": "Myphone",
    "Marketing Name": "SmartView_9.6",
    "Device": "SmartView_9_6_3G",
    "Model": "SmartView_9_6_3G"
  },
  {
    "Retail Branding": "Myphone",
    "Marketing Name": "UNO",
    "Device": "UNO_sprout",
    "Model": "MyPhone UNO"
  },
  {
    "Retail Branding": "Myphone",
    "Marketing Name": "brown 1",
    "Device": "V4701_I01",
    "Model": "brown 1"
  },
  {
    "Retail Branding": "Myphone",
    "Marketing Name": "my17",
    "Device": "my17",
    "Model": "my17"
  },
  {
    "Retail Branding": "Myphone",
    "Marketing Name": "my28S",
    "Device": "MyPhone_my28S",
    "Model": "MyPhone my28S"
  },
  {
    "Retail Branding": "Myphone",
    "Marketing Name": "my28S DTV",
    "Device": "MyPhone_my28S_DTV",
    "Model": "MyPhone my28S DTV"
  },
  {
    "Retail Branding": "Myphone",
    "Marketing Name": "my28S Smart",
    "Device": "MyPhone_my28S_Smart",
    "Model": "my28S Smart"
  },
  {
    "Retail Branding": "Myphone",
    "Marketing Name": "my29S",
    "Device": "my29S",
    "Model": "my29S"
  },
  {
    "Retail Branding": "Myphone",
    "Marketing Name": "my71 DTV",
    "Device": "my71_DTV",
    "Model": "MyPhone my71 DTV"
  },
  {
    "Retail Branding": "Myphone",
    "Marketing Name": "my72 DTV",
    "Device": "MyPhone_my72_DTV",
    "Model": "MyPhone my72 DTV"
  },
  {
    "Retail Branding": "Myphone",
    "Marketing Name": "my73 DTV",
    "Device": "MyPhone_my73_DTV",
    "Model": "MyPhone my73 DTV"
  },
  {
    "Retail Branding": "Myphone",
    "Marketing Name": "my75 DTV",
    "Device": "MyPhone_my75_DTV",
    "Model": "MyPhone my75 DTV"
  },
  {
    "Retail Branding": "Myphone",
    "Marketing Name": "my76 DTV",
    "Device": "MyPhonemy76DTV",
    "Model": "MyPhone_my76 DTV"
  },
  {
    "Retail Branding": "Myphone",
    "Marketing Name": "my77 DTV",
    "Device": "MyPhone_my77_DTV",
    "Model": "MyPhone my77 DTV"
  },
  {
    "Retail Branding": "Myphone",
    "Marketing Name": "my81 DTV",
    "Device": "MyPhone_my81_DTV",
    "Model": "MyPhone my81 DTV"
  },
  {
    "Retail Branding": "Myphone",
    "Marketing Name": "my85 DTV",
    "Device": "MyPhone_my85_DTV",
    "Model": "MyPhone my85 DTV"
  },
  {
    "Retail Branding": "Myphone",
    "Marketing Name": "my86 DTV",
    "Device": "MyPhone_my86_DTV",
    "Model": "MyPhone_my86_DTV"
  },
  {
    "Retail Branding": "Myphone",
    "Marketing Name": "my87 DTV",
    "Device": "MyPhone_my87_DTV",
    "Model": "MyPhone my87 DTV"
  },
  {
    "Retail Branding": "Myphone",
    "Marketing Name": "my88 DTV",
    "Device": "MyPhone_my88_DTV",
    "Model": "MyPhone my88 DTV"
  },
  {
    "Retail Branding": "Myphone",
    "Marketing Name": "my89 DTV",
    "Device": "MyPhone_my89_DTV",
    "Model": "MyPhone my89 DTV"
  },
  {
    "Retail Branding": "Myphone",
    "Marketing Name": "my91 DTV",
    "Device": "my91_DTV",
    "Model": "MyPhone my91 DTV"
  },
  {
    "Retail Branding": "Myphone",
    "Marketing Name": "my92 DTV",
    "Device": "MyPhone_my92_DTV",
    "Model": "MyPhone my92 DTV"
  },
  {
    "Retail Branding": "Myphone",
    "Marketing Name": "my93 DTV",
    "Device": "MyPhone_my93_DTV",
    "Model": "MyPhone my93 DTV"
  },
  {
    "Retail Branding": "Myphone",
    "Marketing Name": "my95 DTV",
    "Device": "MyPhone_my95_DTV",
    "Model": "MyPhone my95 DTV"
  },
  {
    "Retail Branding": "Myphone",
    "Marketing Name": "my96 DTV",
    "Device": "MyPhone_my96_DTV",
    "Model": "MyPhone my96 DTV"
  },
  {
    "Retail Branding": "Myphone",
    "Marketing Name": "myA1",
    "Device": "MY801",
    "Model": "MY801"
  },
  {
    "Retail Branding": "Myphone",
    "Marketing Name": "myA1 Lite",
    "Device": "myA1_Lite",
    "Model": "myA1 Lite"
  },
  {
    "Retail Branding": "Myphone",
    "Marketing Name": "myA10",
    "Device": "myA10",
    "Model": "myA10"
  },
  {
    "Retail Branding": "Myphone",
    "Marketing Name": "myA11",
    "Device": "MYA11",
    "Model": "MYA11"
  },
  {
    "Retail Branding": "Myphone",
    "Marketing Name": "myA11i",
    "Device": "myA11i",
    "Model": "myA11i"
  },
  {
    "Retail Branding": "Myphone",
    "Marketing Name": "myA12",
    "Device": "myA12",
    "Model": "myA12"
  },
  {
    "Retail Branding": "Myphone",
    "Marketing Name": "myA13",
    "Device": "MYA13",
    "Model": "MYA13"
  },
  {
    "Retail Branding": "Myphone",
    "Marketing Name": "myA15",
    "Device": "myA15",
    "Model": "myA15"
  },
  {
    "Retail Branding": "Myphone",
    "Marketing Name": "myA16",
    "Device": "myA16",
    "Model": "myA16"
  },
  {
    "Retail Branding": "Myphone",
    "Marketing Name": "myA17",
    "Device": "myA17",
    "Model": "myA17"
  },
  {
    "Retail Branding": "Myphone",
    "Marketing Name": "myA18",
    "Device": "myA18",
    "Model": "myA18"
  },
  {
    "Retail Branding": "Myphone",
    "Marketing Name": "myA1_Plus",
    "Device": "myA1_Plus",
    "Model": "myA1_Plus"
  },
  {
    "Retail Branding": "Myphone",
    "Marketing Name": "myA2",
    "Device": "MY802",
    "Model": "MY802"
  },
  {
    "Retail Branding": "Myphone",
    "Marketing Name": "myA3",
    "Device": "MY803",
    "Model": "MY803"
  },
  {
    "Retail Branding": "Myphone",
    "Marketing Name": "myA5",
    "Device": "MY805",
    "Model": "MY805"
  },
  {
    "Retail Branding": "Myphone",
    "Marketing Name": "myA6_DTV",
    "Device": "MY806",
    "Model": "MY806"
  },
  {
    "Retail Branding": "Myphone",
    "Marketing Name": "myA7 DTV",
    "Device": "myA7_DTV",
    "Model": "myA7 DTV"
  },
  {
    "Retail Branding": "Myphone",
    "Marketing Name": "myA8 DTV",
    "Device": "myA8_DTV",
    "Model": "myA8 DTV"
  },
  {
    "Retail Branding": "Myphone",
    "Marketing Name": "myA9_DTV",
    "Device": "myA9_DTV",
    "Model": "myA9 DTV"
  },
  {
    "Retail Branding": "Myphone",
    "Marketing Name": "myG1",
    "Device": "myG1",
    "Model": "myG1"
  },
  {
    "Retail Branding": "Myphone",
    "Marketing Name": "myNX1",
    "Device": "myNX1",
    "Model": "myNX1"
  },
  {
    "Retail Branding": "Myphone",
    "Marketing Name": "myP1",
    "Device": "myP1",
    "Model": "myP1"
  },
  {
    "Retail Branding": "Myphone",
    "Marketing Name": "myPhone  Q-Smart III Plus",
    "Device": "Q-Smart_III_Plus",
    "Model": "Q-Smart_III_Plus"
  },
  {
    "Retail Branding": "Myphone",
    "Marketing Name": "myPhone FUN7 LTE",
    "Device": "myPhone_Fun_7_LTE",
    "Model": "myPhone_Fun_7_LTE"
  },
  {
    "Retail Branding": "Myphone",
    "Marketing Name": "myPhone Now eSIM",
    "Device": "myPhone_Now_eSIM",
    "Model": "myPhone_Now_eSIM"
  },
  {
    "Retail Branding": "Myphone",
    "Marketing Name": "myPhone Prime 3 Lite",
    "Device": "Prime3Lite",
    "Model": "Prime3Lite"
  },
  {
    "Retail Branding": "Myphone",
    "Marketing Name": "myPhone_Fun_8",
    "Device": "myPhone_Fun_8",
    "Model": "myPhone_Fun_8"
  },
  {
    "Retail Branding": "Myphone",
    "Marketing Name": "myPhone_N23_Plus_5G_EEA",
    "Device": "MS2402x",
    "Model": "myPhone N23 Plus 5G"
  },
  {
    "Retail Branding": "Myphone",
    "Marketing Name": "myPhone_N23_Plus_EEA",
    "Device": "MS2401x",
    "Model": "myPhone N23 Plus"
  },
  {
    "Retail Branding": "Myphone",
    "Marketing Name": "myPhone_Pocket_2",
    "Device": "myPhone_Pocket_2",
    "Model": "Pocket_2"
  },
  {
    "Retail Branding": "Myphone",
    "Marketing Name": "myPhone_Prime_5",
    "Device": "myPhone_Prime_5",
    "Model": "myPhone_Prime_5"
  },
  {
    "Retail Branding": "Myphone",
    "Marketing Name": "myT10",
    "Device": "myT10",
    "Model": "myT10"
  },
  {
    "Retail Branding": "Myphone",
    "Marketing Name": "myT3 DTV",
    "Device": "myT3_DTV",
    "Model": "myT3 DTV"
  },
  {
    "Retail Branding": "Myphone",
    "Marketing Name": "myT5 DTV",
    "Device": "myT5_DTV",
    "Model": "myT5 DTV"
  },
  {
    "Retail Branding": "Myphone",
    "Marketing Name": "myT6 DTV",
    "Device": "myT6_DTV",
    "Model": "myT6 DTV"
  },
  {
    "Retail Branding": "Myphone",
    "Marketing Name": "myT6S",
    "Device": "myT6S",
    "Model": "myT6S"
  },
  {
    "Retail Branding": "Myphone",
    "Marketing Name": "myT8",
    "Device": "myT8",
    "Model": "myT8"
  },
  {
    "Retail Branding": "Myphone",
    "Marketing Name": "myT8S",
    "Device": "myT8S",
    "Model": "myT8S"
  },
  {
    "Retail Branding": "Myphone",
    "Marketing Name": "myWX1 Lite",
    "Device": "myWX1_Lite",
    "Model": "myWX1 Lite"
  },
  {
    "Retail Branding": "Myphone",
    "Marketing Name": "myWX1 Plus",
    "Device": "myWX1_Plus",
    "Model": "myWX1 Plus"
  },
  {
    "Retail Branding": "Myphone",
    "Marketing Name": "myWX2",
    "Device": "myWX2",
    "Model": "myWX2"
  },
  {
    "Retail Branding": "Myphone",
    "Marketing Name": "myWX2 Pro",
    "Device": "myWX2_Pro",
    "Model": "myWX2 Pro"
  },
  {
    "Retail Branding": "Myphone",
    "Marketing Name": "myX1",
    "Device": "MY807",
    "Model": "MY807"
  },
  {
    "Retail Branding": "Myphone",
    "Marketing Name": "myX12",
    "Device": "myX12",
    "Model": "myX12"
  },
  {
    "Retail Branding": "Myphone",
    "Marketing Name": "myX2",
    "Device": "myX2",
    "Model": "myX2"
  },
  {
    "Retail Branding": "Myphone",
    "Marketing Name": "myX3",
    "Device": "MYX3",
    "Model": "MYX3"
  },
  {
    "Retail Branding": "Myphone",
    "Marketing Name": "myX5",
    "Device": "myX5",
    "Model": "myX5"
  },
  {
    "Retail Branding": "Myphone",
    "Marketing Name": "myX8",
    "Device": "myX8",
    "Model": "myX8"
  },
  {
    "Retail Branding": "Myphone",
    "Marketing Name": "myX9",
    "Device": "myX9",
    "Model": "myX9"
  },
  {
    "Retail Branding": "Myphone",
    "Marketing Name": "myXI1",
    "Device": "myXI1",
    "Model": "myXI1"
  },
  {
    "Retail Branding": "Myphone",
    "Marketing Name": "myXI1 Plus",
    "Device": "myXI1_Plus",
    "Model": "myXI1 Plus"
  },
  {
    "Retail Branding": "Myphone",
    "Marketing Name": "myXI1 Pro",
    "Device": "myXI1_Pro",
    "Model": "myXI1 Pro"
  },
  {
    "Retail Branding": "Myphone",
    "Marketing Name": "myXI3",
    "Device": "myXI3",
    "Model": "myXI3"
  },
  {
    "Retail Branding": "Myphone",
    "Marketing Name": "myphone_N23_5G_EEA",
    "Device": "MS2303x",
    "Model": "myphone N23 5G"
  },
  {
    "Retail Branding": "Myphone",
    "Marketing Name": "neocore_E1R1",
    "Device": "neocore_E1R1",
    "Model": "neocore_E1R1"
  },
  {
    "Retail Branding": "Myria",
    "Marketing Name": "3G MY8300",
    "Device": "3G_MY8300",
    "Model": "3G"
  },
  {
    "Retail Branding": "Myria",
    "Marketing Name": "Classic MY8301",
    "Device": "Classic_MY8301",
    "Model": "Classic"
  },
  {
    "Retail Branding": "Myria",
    "Marketing Name": "Classic MY8301",
    "Device": "MY8301",
    "Model": "Classic"
  },
  {
    "Retail Branding": "Myria",
    "Marketing Name": "Compact_E2_Plus",
    "Device": "Compact_E2_Plus",
    "Model": "Compact_E2_Plus"
  },
  {
    "Retail Branding": "Myria",
    "Marketing Name": "Cozy MY8302",
    "Device": "Cozy_MY8302",
    "Model": "Cozy"
  },
  {
    "Retail Branding": "Myria",
    "Marketing Name": "Cozy MY8302",
    "Device": "MY8302",
    "Model": "Cozy"
  },
  {
    "Retail Branding": "Myria",
    "Marketing Name": "Fancy",
    "Device": "Myria_Fancy",
    "Model": "Fancy"
  },
  {
    "Retail Branding": "Myria",
    "Marketing Name": "L500",
    "Device": "Myria_L500",
    "Model": "Myria L500"
  },
  {
    "Retail Branding": "Myria",
    "Marketing Name": "Myria 4G MY8303",
    "Device": "MY8303",
    "Model": "4G"
  },
  {
    "Retail Branding": "Myria",
    "Marketing Name": "Myria FIVE",
    "Device": "Myria_FIVE",
    "Model": "Myria_FIVE"
  },
  {
    "Retail Branding": "Myria",
    "Marketing Name": "Myria Giant MY8304",
    "Device": "MY8304",
    "Model": "Giant"
  },
  {
    "Retail Branding": "Myria",
    "Marketing Name": "Myria Grand 4G",
    "Device": "Myria_Grand_4G",
    "Model": "Myria_Grand_4G"
  },
  {
    "Retail Branding": "Myria",
    "Marketing Name": "Myria Wide 2",
    "Device": "Myria_Wide_2",
    "Model": "Myria_Wide_2"
  },
  {
    "Retail Branding": "Myria",
    "Marketing Name": "Myria Wide 4G",
    "Device": "Myria_Wide_4G",
    "Model": "Myria_Wide_4G"
  },
  {
    "Retail Branding": "Myria",
    "Marketing Name": "Myria_L550",
    "Device": "Myria_L550",
    "Model": "Myria_L550"
  },
  {
    "Retail Branding": "Myria",
    "Marketing Name": "Myria_L600",
    "Device": "Myria_L600",
    "Model": "Myria_L600"
  },
  {
    "Retail Branding": "Myros",
    "Marketing Name": "E70 Ultra",
    "Device": "E70_Ultra",
    "Model": "E70 Ultra"
  },
  {
    "Retail Branding": "Mystic",
    "Marketing Name": "Android TV",
    "Device": "R1",
    "Model": "ATV R1"
  },
  {
    "Retail Branding": "Mystic",
    "Marketing Name": "Android TV",
    "Device": "R2",
    "Model": "ATV R2"
  },
  {
    "Retail Branding": "Mystic",
    "Marketing Name": "MYSTIC",
    "Device": "elliniko",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "Mystic",
    "Marketing Name": "MYSTIC",
    "Device": "jagalchi",
    "Model": "2K SMART TV"
  },
  {
    "Retail Branding": "Mystic",
    "Marketing Name": "R3",
    "Device": "R3",
    "Model": "R3"
  },
  {
    "Retail Branding": "Mystic",
    "Marketing Name": "R3_GTV",
    "Device": "R3_GTV",
    "Model": "R3G"
  },
  {
    "Retail Branding": "Mystic",
    "Marketing Name": "R4",
    "Device": "R4",
    "Model": "R4"
  },
  {
    "Retail Branding": "Mystic",
    "Marketing Name": "R4_GTV",
    "Device": "R4_GTV",
    "Model": "R4G"
  },
  {
    "Retail Branding": "Mytron",
    "Marketing Name": "Pad_60",
    "Device": "Pad_60",
    "Model": "Pad_60"
  },
  {
    "Retail Branding": "N-one",
    "Marketing Name": "NpadAir",
    "Device": "NpadAir",
    "Model": "NpadAir"
  },
  {
    "Retail Branding": "N-one",
    "Marketing Name": "NpadQ",
    "Device": "NpadQ",
    "Model": "NpadQ"
  },
  {
    "Retail Branding": "N-one",
    "Marketing Name": "NpadS",
    "Device": "NpadS",
    "Model": "NpadS"
  },
  {
    "Retail Branding": "N-one",
    "Marketing Name": "NpadS1",
    "Device": "NpadS1",
    "Model": "Npad S1"
  },
  {
    "Retail Branding": "N-one",
    "Marketing Name": "NpadSE",
    "Device": "NpadSE",
    "Model": "NpadSE"
  },
  {
    "Retail Branding": "N-one",
    "Marketing Name": "NpadX1",
    "Device": "TAB005",
    "Model": "Npad X1"
  },
  {
    "Retail Branding": "N-one",
    "Marketing Name": "NpadY",
    "Device": "NpadY",
    "Model": "Npad Y1"
  },
  {
    "Retail Branding": "N-one",
    "Marketing Name": "NpadY",
    "Device": "NpadY",
    "Model": "NpadY"
  },
  {
    "Retail Branding": "N-one",
    "Marketing Name": "NpadY1",
    "Device": "NpadY1",
    "Model": "NpadY1"
  },
  {
    "Retail Branding": "N-one",
    "Marketing Name": "Npad_mini",
    "Device": "Npad_mini",
    "Model": "TAB011"
  },
  {
    "Retail Branding": "N-one",
    "Marketing Name": "Npad_ultra",
    "Device": "Npad_ultra",
    "Model": "TAB012"
  },
  {
    "Retail Branding": "N-one",
    "Marketing Name": "Npadplus",
    "Device": "Npadplus",
    "Model": "Npadplus"
  },
  {
    "Retail Branding": "NAGU",
    "Marketing Name": "R1",
    "Device": "NAGU_R1",
    "Model": "R1"
  },
  {
    "Retail Branding": "NASCO",
    "Marketing Name": "Allure_Plus",
    "Device": "NASCO_Allure_Plus",
    "Model": "NASCO_Allure_Plus"
  },
  {
    "Retail Branding": "NASCO",
    "Marketing Name": "CANDY2",
    "Device": "CANDY2",
    "Model": "CANDY2"
  },
  {
    "Retail Branding": "NASCO",
    "Marketing Name": "Hero",
    "Device": "NAS-510",
    "Model": "Hero"
  },
  {
    "Retail Branding": "NASCO",
    "Marketing Name": "MARS7",
    "Device": "MARS7",
    "Model": "MARS7"
  },
  {
    "Retail Branding": "NASCO",
    "Marketing Name": "Magic",
    "Device": "Magic",
    "Model": "Magic"
  },
  {
    "Retail Branding": "NASCO",
    "Marketing Name": "Magic-s",
    "Device": "NAS-503",
    "Model": "Magic-s"
  },
  {
    "Retail Branding": "NASCO",
    "Marketing Name": "Power Plus",
    "Device": "Power_Plus",
    "Model": "Power Plus"
  },
  {
    "Retail Branding": "NASCO",
    "Marketing Name": "Power Plus Pro",
    "Device": "PowerPlusPro",
    "Model": "Power Plus Pro"
  },
  {
    "Retail Branding": "NASCO",
    "Marketing Name": "SNAP",
    "Device": "SNAP",
    "Model": "SNAP"
  },
  {
    "Retail Branding": "NASCO",
    "Marketing Name": "SNAP PRO",
    "Device": "SNAP_PRO",
    "Model": "SNAP_PRO"
  },
  {
    "Retail Branding": "NASCO",
    "Marketing Name": "TANGO10",
    "Device": "TANGO10",
    "Model": "TANGO10"
  },
  {
    "Retail Branding": "NASCO",
    "Marketing Name": "Warrior",
    "Device": "NAS-400",
    "Model": "Warrior"
  },
  {
    "Retail Branding": "NAV Global",
    "Marketing Name": "NAV X1",
    "Device": "NAV_X1",
    "Model": "NAV X1"
  },
  {
    "Retail Branding": "NAVA",
    "Marketing Name": "P68",
    "Device": "P68",
    "Model": "P68"
  },
  {
    "Retail Branding": "NAXA",
    "Marketing Name": "NID-7011",
    "Device": "NID-7011",
    "Model": "NID-7011"
  },
  {
    "Retail Branding": "NAXA",
    "Marketing Name": "NID_7010",
    "Device": "NID_7010",
    "Model": "NID_7010"
  },
  {
    "Retail Branding": "NCTC",
    "Marketing Name": "KSTB2020",
    "Device": "KSTB2020",
    "Model": "KSTB2020"
  },
  {
    "Retail Branding": "NCTC",
    "Marketing Name": "KSTB2100",
    "Device": "KSTB2100",
    "Model": "KSTB2100"
  },
  {
    "Retail Branding": "NEC",
    "Marketing Name": "101T 　MEDIAS",
    "Device": "NEC-101",
    "Model": "NEC-101T"
  },
  {
    "Retail Branding": "NEC",
    "Marketing Name": "AGT10",
    "Device": "AGT10",
    "Model": "N8730-411"
  },
  {
    "Retail Branding": "NEC",
    "Marketing Name": "AGT10",
    "Device": "AGT10",
    "Model": "N8730-41101"
  },
  {
    "Retail Branding": "NEC",
    "Marketing Name": "AGT10",
    "Device": "AGT10",
    "Model": "N8730-41102"
  },
  {
    "Retail Branding": "NEC",
    "Marketing Name": "AGT10 D000-000039-001",
    "Device": "D000000039",
    "Model": "NEC-STR"
  },
  {
    "Retail Branding": "NEC",
    "Marketing Name": "CASIO G\\'zOne Commando 4G LTE",
    "Device": "C811",
    "Model": "C811 4G"
  },
  {
    "Retail Branding": "NEC",
    "Marketing Name": "Casio G\\'zOne Commando",
    "Device": "C771",
    "Model": "C771"
  },
  {
    "Retail Branding": "NEC",
    "Marketing Name": "Disney Mobile on docomoN-03E",
    "Device": "N-03E",
    "Model": "N-03E"
  },
  {
    "Retail Branding": "NEC",
    "Marketing Name": "G\\'z One IS11CA",
    "Device": "IS11CA",
    "Model": "IS11CA"
  },
  {
    "Retail Branding": "NEC",
    "Marketing Name": "G\\'zOne TYPE-L CAL21",
    "Device": "CAL21",
    "Model": "CAL21"
  },
  {
    "Retail Branding": "NEC",
    "Marketing Name": "G’zOne CA-201L",
    "Device": "CA201L",
    "Model": "CA-201L"
  },
  {
    "Retail Branding": "NEC",
    "Marketing Name": "LAVIE T11 112K1",
    "Device": "LAVIET11112K1",
    "Model": "LAVIE T11 112K1"
  },
  {
    "Retail Branding": "NEC",
    "Marketing Name": "LAVIE T11 11QHD1",
    "Device": "LAVIET1111QHD1",
    "Model": "LAVIE T11 11QHD1"
  },
  {
    "Retail Branding": "NEC",
    "Marketing Name": "LAVIE T8 8HD1",
    "Device": "LAVIET88HD1",
    "Model": "LAVIE T8 8HD1"
  },
  {
    "Retail Branding": "NEC",
    "Marketing Name": "LAVIE Tab 102K1",
    "Device": "LAVIETab102K1",
    "Model": "LAVIE Tab 102K1"
  },
  {
    "Retail Branding": "NEC",
    "Marketing Name": "LAVIE Tab E",
    "Device": "PC-TE410JAW",
    "Model": "PC-TE410JAW"
  },
  {
    "Retail Branding": "NEC",
    "Marketing Name": "LAVIE Tab E",
    "Device": "PC-TE508HAW",
    "Model": "PC-TE508HAW"
  },
  {
    "Retail Branding": "NEC",
    "Marketing Name": "LAVIE Tab E",
    "Device": "X704F",
    "Model": "PC-TE510HAW"
  },
  {
    "Retail Branding": "NEC",
    "Marketing Name": "LAVIE Tab E 10FHD1",
    "Device": "LAVIETabE10FHD1",
    "Model": "LAVIE Tab E 10FHD1"
  },
  {
    "Retail Branding": "NEC",
    "Marketing Name": "LAVIE Tab E 10FHD2",
    "Device": "LAVIETabE10FHD2",
    "Model": "LAVIE Tab E 10FHD2"
  },
  {
    "Retail Branding": "NEC",
    "Marketing Name": "LAVIE Tab E 7SD1",
    "Device": "LAVIETabE7SD1",
    "Model": "LAVIE Tab E 7SD1"
  },
  {
    "Retail Branding": "NEC",
    "Marketing Name": "LAVIE Tab E 8FHD1",
    "Device": "LAVIETabE8FHD1",
    "Model": "LAVIE Tab E 8FHD1"
  },
  {
    "Retail Branding": "NEC",
    "Marketing Name": "LAVIE Tab E 8HD1",
    "Device": "LAVIETabE8HD1",
    "Model": "LAVIE Tab E 8HD1"
  },
  {
    "Retail Branding": "NEC",
    "Marketing Name": "LAVIE Tab T10",
    "Device": "LAVIETab10FHD3",
    "Model": "LAVIE Tab 10FHD3"
  },
  {
    "Retail Branding": "NEC",
    "Marketing Name": "LAVIE Tab T11",
    "Device": "LAVIETab112K2",
    "Model": "LAVIE Tab 112K2"
  },
  {
    "Retail Branding": "NEC",
    "Marketing Name": "LAVIE Tab T11",
    "Device": "LAVIETab11FHD1",
    "Model": "LAVIE Tab 11FHD1"
  },
  {
    "Retail Branding": "NEC",
    "Marketing Name": "LAVIE Tab T11",
    "Device": "LAVIETab11QHD2",
    "Model": "LAVIE Tab 11QHD2"
  },
  {
    "Retail Branding": "NEC",
    "Marketing Name": "LAVIE Tab T11Nd",
    "Device": "LAVIETab11QHD3",
    "Model": "LAVIE Tab 11QHD3"
  },
  {
    "Retail Branding": "NEC",
    "Marketing Name": "LAVIE Tab T11Nd",
    "Device": "LAVIETab11QHD3",
    "Model": "LAVIETab11QHD3"
  },
  {
    "Retail Branding": "NEC",
    "Marketing Name": "LAVIE Tab T14",
    "Device": "LAVIETab143K1",
    "Model": "LAVIE Tab 143K1"
  },
  {
    "Retail Branding": "NEC",
    "Marketing Name": "LAVIE Tab T9",
    "Device": "LAVIETab9QHD1",
    "Model": "LAVIE Tab 9QHD1"
  },
  {
    "Retail Branding": "NEC",
    "Marketing Name": "LAVIETab T12 12QHD1",
    "Device": "LAVIETabT1212QHD1",
    "Model": "LAVIE Tab T12 12QHD1"
  },
  {
    "Retail Branding": "NEC",
    "Marketing Name": "LaVieTab PC-TE508BAW",
    "Device": "TE508BAW",
    "Model": "PC-TE508BAW"
  },
  {
    "Retail Branding": "NEC",
    "Marketing Name": "LaVieTab PC-TE508S1W/LaVieTab PC-TE508S1L",
    "Device": "PC-TE508S1_nec",
    "Model": "LaVieTab PC-TE508S1"
  },
  {
    "Retail Branding": "NEC",
    "Marketing Name": "LaVieTab PC-TE510S1L",
    "Device": "PC-TE510S1_nec",
    "Model": "LaVieTab PC-TE510S1"
  },
  {
    "Retail Branding": "NEC",
    "Marketing Name": "LifeTouch B",
    "Device": "LTB013",
    "Model": "D000-000013-101"
  },
  {
    "Retail Branding": "NEC",
    "Marketing Name": "LifeTouch B",
    "Device": "LTB018",
    "Model": "D000-000018-001"
  },
  {
    "Retail Branding": "NEC",
    "Marketing Name": "LifeTouch B",
    "Device": "LTB018",
    "Model": "D000-000018-002"
  },
  {
    "Retail Branding": "NEC",
    "Marketing Name": "LifeTouch B",
    "Device": "LTB018",
    "Model": "D000-000018-003"
  },
  {
    "Retail Branding": "NEC",
    "Marketing Name": "LifeTouch B",
    "Device": "LTB018",
    "Model": "D000-000018-004"
  },
  {
    "Retail Branding": "NEC",
    "Marketing Name": "LifeTouch B",
    "Device": "LTB018",
    "Model": "D000-000018-101"
  },
  {
    "Retail Branding": "NEC",
    "Marketing Name": "LifeTouch B",
    "Device": "LTB018",
    "Model": "D000-000018-102"
  },
  {
    "Retail Branding": "NEC",
    "Marketing Name": "LifeTouch B",
    "Device": "LTB018",
    "Model": "D000-000018-104"
  },
  {
    "Retail Branding": "NEC",
    "Marketing Name": "LifeTouch B",
    "Device": "LTB019G",
    "Model": "D000-000019-002"
  },
  {
    "Retail Branding": "NEC",
    "Marketing Name": "LifeTouch B",
    "Device": "LTB019W",
    "Model": "D000-000019-001"
  },
  {
    "Retail Branding": "NEC",
    "Marketing Name": "LifeTouch B",
    "Device": "LTB028",
    "Model": "LTB-HS"
  },
  {
    "Retail Branding": "NEC",
    "Marketing Name": "LifeTouch L",
    "Device": "D000000023",
    "Model": "LT-TLA"
  },
  {
    "Retail Branding": "NEC",
    "Marketing Name": "LifeTouch L",
    "Device": "D000000035",
    "Model": "NEC-STR"
  },
  {
    "Retail Branding": "NEC",
    "Marketing Name": "LifeTouch L",
    "Device": "D000000039",
    "Model": "NEC-STR"
  },
  {
    "Retail Branding": "NEC",
    "Marketing Name": "LifeTouch L",
    "Device": "LTTLA16",
    "Model": "LT-TLA"
  },
  {
    "Retail Branding": "NEC",
    "Marketing Name": "LifeTouch L",
    "Device": "LTTLA32",
    "Model": "LT-TLA"
  },
  {
    "Retail Branding": "NEC",
    "Marketing Name": "LifeTouch L D000-000035-001",
    "Device": "D000000035",
    "Model": "NEC-STR"
  },
  {
    "Retail Branding": "NEC",
    "Marketing Name": "LifeTouch L D000-000035-002",
    "Device": "D000000035",
    "Model": "NEC-STR"
  },
  {
    "Retail Branding": "NEC",
    "Marketing Name": "LifeTouch Note",
    "Device": "D000000010N",
    "Model": "D000-000010-N"
  },
  {
    "Retail Branding": "NEC",
    "Marketing Name": "LifeTouch Note",
    "Device": "D000000011N",
    "Model": "D000-000011-N"
  },
  {
    "Retail Branding": "NEC",
    "Marketing Name": "LifeTouch Note",
    "Device": "LTNA7",
    "Model": "LT-NA7"
  },
  {
    "Retail Branding": "NEC",
    "Marketing Name": "LifeTouch Note",
    "Device": "LTNA7F",
    "Model": "LT-NA7F"
  },
  {
    "Retail Branding": "NEC",
    "Marketing Name": "LifeTouch S",
    "Device": "LifeTouch_D1",
    "Model": "D000-000001-B01"
  },
  {
    "Retail Branding": "NEC",
    "Marketing Name": "LifeTouch S",
    "Device": "LifeTouch_D1",
    "Model": "D000-000001-B02"
  },
  {
    "Retail Branding": "NEC",
    "Marketing Name": "LifeTouch S",
    "Device": "LifeTouch_D1",
    "Model": "D000-000001-C01"
  },
  {
    "Retail Branding": "NEC",
    "Marketing Name": "LifeTouch S",
    "Device": "LifeTouch_D1",
    "Model": "D000-000001-K01"
  },
  {
    "Retail Branding": "NEC",
    "Marketing Name": "LifeTouch S",
    "Device": "LifeTouch_D1",
    "Model": "D000-000001-R01"
  },
  {
    "Retail Branding": "NEC",
    "Marketing Name": "LifeTouch S",
    "Device": "LifeTouch_D1",
    "Model": "D000-000001-R02"
  },
  {
    "Retail Branding": "NEC",
    "Marketing Name": "LifeTouch S",
    "Device": "LifeTouch_D1",
    "Model": "D000-000001-R03"
  },
  {
    "Retail Branding": "NEC",
    "Marketing Name": "LifeTouch S",
    "Device": "LifeTouch_D1",
    "Model": "D000-000001-R04"
  },
  {
    "Retail Branding": "NEC",
    "Marketing Name": "LifeTouch S",
    "Device": "LifeTouch_D1",
    "Model": "D000-000001-S00"
  },
  {
    "Retail Branding": "NEC",
    "Marketing Name": "LifeTouch S",
    "Device": "LifeTouch_D1",
    "Model": "D000-000001-S01"
  },
  {
    "Retail Branding": "NEC",
    "Marketing Name": "LifeTouch S",
    "Device": "LifeTouch_D1",
    "Model": "D000-000001-S05"
  },
  {
    "Retail Branding": "NEC",
    "Marketing Name": "LifeTouch S",
    "Device": "LifeTouch_D1",
    "Model": "D000-000001-S25"
  },
  {
    "Retail Branding": "NEC",
    "Marketing Name": "LifeTouch S",
    "Device": "LifeTouch_D1",
    "Model": "D000-000001-S85"
  },
  {
    "Retail Branding": "NEC",
    "Marketing Name": "LifeTouch S",
    "Device": "LifeTouch_D7",
    "Model": "D000-000007-D01"
  },
  {
    "Retail Branding": "NEC",
    "Marketing Name": "LifeTouch W",
    "Device": "LT-W1_1",
    "Model": "D000-000002-W01"
  },
  {
    "Retail Branding": "NEC",
    "Marketing Name": "LifeTouch W",
    "Device": "LT-W1_2",
    "Model": "D000-000002-W02"
  },
  {
    "Retail Branding": "NEC",
    "Marketing Name": "LifeTouch W",
    "Device": "LifeTouch_W1",
    "Model": "D000-000002-001"
  },
  {
    "Retail Branding": "NEC",
    "Marketing Name": "M002Q-2",
    "Device": "M002Q-2",
    "Model": "M002Q-2"
  },
  {
    "Retail Branding": "NEC",
    "Marketing Name": "MEDIAS  X N-06E",
    "Device": "N-06E",
    "Model": "N-06E"
  },
  {
    "Retail Branding": "NEC",
    "Marketing Name": "MEDIAS BR IS11N",
    "Device": "IS11N",
    "Model": "IS11N"
  },
  {
    "Retail Branding": "NEC",
    "Marketing Name": "MEDIAS CH 101N",
    "Device": "101N",
    "Model": "101N"
  },
  {
    "Retail Branding": "NEC",
    "Marketing Name": "MEDIAS ES N-05D",
    "Device": "N-05D",
    "Model": "N-05D"
  },
  {
    "Retail Branding": "NEC",
    "Marketing Name": "MEDIAS LTE N-04D",
    "Device": "N-04D",
    "Model": "N-04D"
  },
  {
    "Retail Branding": "NEC",
    "Marketing Name": "MEDIAS N-04C",
    "Device": "N-04C",
    "Model": "N-04C"
  },
  {
    "Retail Branding": "NEC",
    "Marketing Name": "MEDIAS NE-202",
    "Device": "NE-202",
    "Model": "NE-202"
  },
  {
    "Retail Branding": "NEC",
    "Marketing Name": "MEDIAS NEC-101S",
    "Device": "MAGNUM",
    "Model": "NEC-101S"
  },
  {
    "Retail Branding": "NEC",
    "Marketing Name": "MEDIAS NEC-101S",
    "Device": "NEC-101",
    "Model": "NEC-101S"
  },
  {
    "Retail Branding": "NEC",
    "Marketing Name": "MEDIAS NEC-102",
    "Device": "NEC-102",
    "Model": "NEC-102"
  },
  {
    "Retail Branding": "NEC",
    "Marketing Name": "MEDIAS PP N-01D",
    "Device": "N-01D",
    "Model": "N-01D"
  },
  {
    "Retail Branding": "NEC",
    "Marketing Name": "MEDIAS TAB N-06D",
    "Device": "N-06D",
    "Model": "N-06D"
  },
  {
    "Retail Branding": "NEC",
    "Marketing Name": "MEDIAS TAB UL N-08D",
    "Device": "N-08D",
    "Model": "N-08D"
  },
  {
    "Retail Branding": "NEC",
    "Marketing Name": "MEDIAS U N-02E",
    "Device": "N-02E",
    "Model": "N-02E"
  },
  {
    "Retail Branding": "NEC",
    "Marketing Name": "MEDIAS U NE-103T",
    "Device": "NE-103",
    "Model": "NE-103T"
  },
  {
    "Retail Branding": "NEC",
    "Marketing Name": "MEDIAS W N-05E",
    "Device": "N-05E",
    "Model": "N-05E"
  },
  {
    "Retail Branding": "NEC",
    "Marketing Name": "MEDIAS WP N-06C",
    "Device": "N-06C",
    "Model": "N-06C"
  },
  {
    "Retail Branding": "NEC",
    "Marketing Name": "MEDIAS X N-04E",
    "Device": "N-04E",
    "Model": "N-04E"
  },
  {
    "Retail Branding": "NEC",
    "Marketing Name": "MEDIAS X N-07D",
    "Device": "N-07D",
    "Model": "N-07D"
  },
  {
    "Retail Branding": "NEC",
    "Marketing Name": "NE-201",
    "Device": "NE-201",
    "Model": "NEC-NE-201A1A"
  },
  {
    "Retail Branding": "NEC",
    "Marketing Name": "NEC PC-TE510BAL",
    "Device": "PC-TE510BAL",
    "Model": "PC-TE510BAL"
  },
  {
    "Retail Branding": "NEC",
    "Marketing Name": "NEC909e",
    "Device": "NEC909e",
    "Model": "NEC909e"
  },
  {
    "Retail Branding": "NEC",
    "Marketing Name": "PC- TS507N1S",
    "Device": "PC-TS507N1S",
    "Model": "LaVieTab PC-TS507N1S"
  },
  {
    "Retail Branding": "NEC",
    "Marketing Name": "PC-508T1W",
    "Device": "508T1W",
    "Model": "PC-TS508T1W"
  },
  {
    "Retail Branding": "NEC",
    "Marketing Name": "PC-708T1W",
    "Device": "708T1W",
    "Model": "PC-TS708T1W"
  },
  {
    "Retail Branding": "NEC",
    "Marketing Name": "PC-TE307N1W",
    "Device": "PC-TE307N1W",
    "Model": "PC-TE307N1W"
  },
  {
    "Retail Branding": "NEC",
    "Marketing Name": "PC-TE510JAW",
    "Device": "PC-TE510JAW",
    "Model": "PC-TE510JAW"
  },
  {
    "Retail Branding": "NEC",
    "Marketing Name": "PC-TE510N1B",
    "Device": "LaVieTab",
    "Model": "LaVieTab PC-TE510N1B"
  },
  {
    "Retail Branding": "NEC",
    "Marketing Name": "Tab M7 3rd Gen",
    "Device": "LAVIET77SD1",
    "Model": "LAVIE T7 7SD1"
  },
  {
    "Retail Branding": "NELATECH",
    "Marketing Name": "TAB8V1",
    "Device": "TAB8V1",
    "Model": "TAB8V"
  },
  {
    "Retail Branding": "NELATECH",
    "Marketing Name": "TAB8V1",
    "Device": "TAB8V1",
    "Model": "TAB8V1"
  },
  {
    "Retail Branding": "NELATECH",
    "Marketing Name": "V22S1",
    "Device": "V22S1",
    "Model": "V22S"
  },
  {
    "Retail Branding": "NELATECH",
    "Marketing Name": "X1",
    "Device": "X1_Pro",
    "Model": "X1"
  },
  {
    "Retail Branding": "NEMO",
    "Marketing Name": "G99",
    "Device": "G99",
    "Model": "G99"
  },
  {
    "Retail Branding": "NEMO",
    "Marketing Name": "N16",
    "Device": "N16",
    "Model": "N16"
  },
  {
    "Retail Branding": "NEMO",
    "Marketing Name": "N36s",
    "Device": "N36s",
    "Model": "N36s"
  },
  {
    "Retail Branding": "NEO",
    "Marketing Name": "GF214-NEO",
    "Device": "GF214-NEO",
    "Model": "GF214-NEO"
  },
  {
    "Retail Branding": "NEO",
    "Marketing Name": "GF215-REY",
    "Device": "GF214-NEO",
    "Model": "GF215-REY"
  },
  {
    "Retail Branding": "NEO",
    "Marketing Name": "Neo-Tab-T606-Plus",
    "Device": "Neo-Tab-T606-Plus",
    "Model": "Neo-Tab-T606-Plus"
  },
  {
    "Retail Branding": "NEON",
    "Marketing Name": "Neon Tab 11",
    "Device": "Neon_Tab_11",
    "Model": "Neon Tab 11"
  },
  {
    "Retail Branding": "NEONIQ",
    "Marketing Name": "NQT-1013GIQ",
    "Device": "NQT-1013GIQ",
    "Model": "NQT-1013GIQ"
  },
  {
    "Retail Branding": "NEONIQ",
    "Marketing Name": "NQT-1014GIQ",
    "Device": "NQT-1014GIQ",
    "Model": "NQT-1014GIQ"
  },
  {
    "Retail Branding": "NEONIQ",
    "Marketing Name": "NQT-1014GIQA",
    "Device": "NQT-1014GIQA",
    "Model": "NQT-1014GIQA"
  },
  {
    "Retail Branding": "NEONIQ",
    "Marketing Name": "NQT-73GIQ",
    "Device": "NQT-73GIQ",
    "Model": "NQT-73GIQ"
  },
  {
    "Retail Branding": "NEONIQ",
    "Marketing Name": "NQT-73GIQ11",
    "Device": "NQT-73GIQ11",
    "Model": "NQT-73GIQ11"
  },
  {
    "Retail Branding": "NEONIQ",
    "Marketing Name": "NQT_7W",
    "Device": "NQT-7W",
    "Model": "NQT-7W"
  },
  {
    "Retail Branding": "NEOPAD",
    "Marketing Name": "AD115",
    "Device": "AD115",
    "Model": "AD115"
  },
  {
    "Retail Branding": "NEOPAD",
    "Marketing Name": "AD115_EEA",
    "Device": "AD115_EEA",
    "Model": "AD115_EEA"
  },
  {
    "Retail Branding": "NEOTAB",
    "Marketing Name": "SP1068A",
    "Device": "SP1068A",
    "Model": "SP1068A"
  },
  {
    "Retail Branding": "NESO",
    "Marketing Name": "N810 i7",
    "Device": "N810_i7_1",
    "Model": "N810 i7"
  },
  {
    "Retail Branding": "NETGREEN",
    "Marketing Name": "H10",
    "Device": "H10",
    "Model": "H10"
  },
  {
    "Retail Branding": "NETGREEN",
    "Marketing Name": "M11QF8",
    "Device": "M11QF8",
    "Model": "M11QF8"
  },
  {
    "Retail Branding": "NETGREEN",
    "Marketing Name": "M15QF6",
    "Device": "M15QF6",
    "Model": "M15QF6"
  },
  {
    "Retail Branding": "NETGREEN",
    "Marketing Name": "M15QF6AR",
    "Device": "M15QF6AR",
    "Model": "M15QF6AR"
  },
  {
    "Retail Branding": "NETGREEN",
    "Marketing Name": "M16QF11",
    "Device": "M16QF11",
    "Model": "M16QF11"
  },
  {
    "Retail Branding": "NETGREEN",
    "Marketing Name": "M16QF11AR",
    "Device": "M16QF11AR",
    "Model": "M16QF11AR"
  },
  {
    "Retail Branding": "NETGREEN",
    "Marketing Name": "M16QF9AR",
    "Device": "M16QF9AR",
    "Model": "M16QF9AR"
  },
  {
    "Retail Branding": "NETGREEN",
    "Marketing Name": "M16QF9ES",
    "Device": "M16QF9ES",
    "Model": "M16QF9ES"
  },
  {
    "Retail Branding": "NETGREEN",
    "Marketing Name": "MW75QF6",
    "Device": "MW75QF6",
    "Model": "MW75QF6"
  },
  {
    "Retail Branding": "NETOGY",
    "Marketing Name": "NOVA",
    "Device": "YXU",
    "Model": "NOVA"
  },
  {
    "Retail Branding": "NETTV",
    "Marketing Name": "NETTV",
    "Device": "SEI500NTV",
    "Model": "NETTV"
  },
  {
    "Retail Branding": "NEWORK",
    "Marketing Name": "Interactive Smart Display",
    "Device": "NewBoard",
    "Model": "NB_XXE1D_AM_W"
  },
  {
    "Retail Branding": "NEWORK",
    "Marketing Name": "NewBoard",
    "Device": "Interactive_Smart_Display",
    "Model": "NB_65P1D_WW_X"
  },
  {
    "Retail Branding": "NEWORK",
    "Marketing Name": "NewBoard",
    "Device": "Interactive_Smart_Display",
    "Model": "NB_XXPXX_XX_X"
  },
  {
    "Retail Branding": "NEWPAS",
    "Marketing Name": "N2138",
    "Device": "N2138",
    "Model": "N2138"
  },
  {
    "Retail Branding": "NEWPOS",
    "Marketing Name": "NEW9310Pro",
    "Device": "NEW9310Pro",
    "Model": "NEW9310Pro"
  },
  {
    "Retail Branding": "NEWPOS",
    "Marketing Name": "NEW9830",
    "Device": "NEW9830",
    "Model": "NEW9830"
  },
  {
    "Retail Branding": "NEWSUN",
    "Marketing Name": "S13",
    "Device": "S13",
    "Model": "S13"
  },
  {
    "Retail Branding": "NEWSUN",
    "Marketing Name": "S20",
    "Device": "S20",
    "Model": "S20"
  },
  {
    "Retail Branding": "NEWSUN",
    "Marketing Name": "S9",
    "Device": "S9",
    "Model": "S9"
  },
  {
    "Retail Branding": "NEWTON",
    "Marketing Name": "H1",
    "Device": "H1",
    "Model": "H1"
  },
  {
    "Retail Branding": "NEXA",
    "Marketing Name": "NexaN5a",
    "Device": "NexaN5a",
    "Model": "NexaN5a"
  },
  {
    "Retail Branding": "NEXG",
    "Marketing Name": "NEXG N28 Pro",
    "Device": "NEXG_N28_Pro",
    "Model": "N28 Pro"
  },
  {
    "Retail Branding": "NEXGO",
    "Marketing Name": "P300",
    "Device": "P300",
    "Model": "P300"
  },
  {
    "Retail Branding": "NEXGO",
    "Marketing Name": "P300",
    "Device": "P300_Pro",
    "Model": "P300__Pro"
  },
  {
    "Retail Branding": "NEXGO",
    "Marketing Name": "P300",
    "Device": "P300_mini",
    "Model": "P300__mini"
  },
  {
    "Retail Branding": "NEXWIN",
    "Marketing Name": "interactive flat panel display",
    "Device": "IFPD_RK3588",
    "Model": "NXW_GB86_13UP"
  },
  {
    "Retail Branding": "NGM Italia SRL",
    "Marketing Name": "Android TV",
    "Device": "R1",
    "Model": "ATV R1"
  },
  {
    "Retail Branding": "NGM Italia SRL",
    "Marketing Name": "Android TV",
    "Device": "R2",
    "Model": "ATV R2"
  },
  {
    "Retail Branding": "NGM Italia SRL",
    "Marketing Name": "Danamic Now",
    "Device": "DynamicNow",
    "Model": "Now"
  },
  {
    "Retail Branding": "NGM Italia SRL",
    "Marketing Name": "Dynamic Racing 3",
    "Device": "NGM_Dynamic_Racing_3",
    "Model": "Dynamic Racing 3"
  },
  {
    "Retail Branding": "NGM Italia SRL",
    "Marketing Name": "Dynamic_Stylo",
    "Device": "NGM_Dynamic_Stylo",
    "Model": "NGM_Dynamic_Stylo"
  },
  {
    "Retail Branding": "NGM Italia SRL",
    "Marketing Name": "E407",
    "Device": "E407",
    "Model": "E407"
  },
  {
    "Retail Branding": "NGM Italia SRL",
    "Marketing Name": "E451",
    "Device": "E451",
    "Model": "E451"
  },
  {
    "Retail Branding": "NGM Italia SRL",
    "Marketing Name": "E505 Plus",
    "Device": "E505plus",
    "Model": "E505plus"
  },
  {
    "Retail Branding": "NGM Italia SRL",
    "Marketing Name": "E506plus",
    "Device": "E506plus",
    "Model": "E506plus"
  },
  {
    "Retail Branding": "NGM Italia SRL",
    "Marketing Name": "E553",
    "Device": "E553",
    "Model": "E553"
  },
  {
    "Retail Branding": "NGM Italia SRL",
    "Marketing Name": "Endurance",
    "Device": "ForwardEndurance",
    "Model": "ForwardEndurance"
  },
  {
    "Retail Branding": "NGM Italia SRL",
    "Marketing Name": "ForwardZero",
    "Device": "ForwardZero",
    "Model": "ForwardZero"
  },
  {
    "Retail Branding": "NGM Italia SRL",
    "Marketing Name": "Forward_Prime",
    "Device": "Forward_Prime",
    "Model": "Forward_Prime"
  },
  {
    "Retail Branding": "NGM Italia SRL",
    "Marketing Name": "Infinity",
    "Device": "Infinity",
    "Model": "Infinity"
  },
  {
    "Retail Branding": "NGM Italia SRL",
    "Marketing Name": "LIFE",
    "Device": "Life",
    "Model": "Life"
  },
  {
    "Retail Branding": "NGM Italia SRL",
    "Marketing Name": "M500",
    "Device": "NGM_M500",
    "Model": "NGM M500"
  },
  {
    "Retail Branding": "NGM Italia SRL",
    "Marketing Name": "M502",
    "Device": "M502",
    "Model": "M502"
  },
  {
    "Retail Branding": "NGM Italia SRL",
    "Marketing Name": "NGM Youcolor E400",
    "Device": "E400",
    "Model": "E400"
  },
  {
    "Retail Branding": "NGM Italia SRL",
    "Marketing Name": "NGM Youcolor E450",
    "Device": "E450",
    "Model": "E450"
  },
  {
    "Retail Branding": "NGM Italia SRL",
    "Marketing Name": "NGM Youcolor E501",
    "Device": "E501",
    "Model": "E501"
  },
  {
    "Retail Branding": "NGM Italia SRL",
    "Marketing Name": "NGM Youcolor E505",
    "Device": "E505",
    "Model": "E505"
  },
  {
    "Retail Branding": "NGM Italia SRL",
    "Marketing Name": "NGM Youcolor E506",
    "Device": "E506",
    "Model": "E506"
  },
  {
    "Retail Branding": "NGM Italia SRL",
    "Marketing Name": "NGM Youcolor E507",
    "Device": "E507",
    "Model": "E507"
  },
  {
    "Retail Branding": "NGM Italia SRL",
    "Marketing Name": "P503",
    "Device": "NGM_P503",
    "Model": "NGM P503"
  },
  {
    "Retail Branding": "NGM Italia SRL",
    "Marketing Name": "P508",
    "Device": "P508",
    "Model": "P508"
  },
  {
    "Retail Branding": "NGM Italia SRL",
    "Marketing Name": "P509",
    "Device": "NGM_P509",
    "Model": "P509"
  },
  {
    "Retail Branding": "NGM Italia SRL",
    "Marketing Name": "P550",
    "Device": "NGM_P550",
    "Model": "NGM P550"
  },
  {
    "Retail Branding": "NGM Italia SRL",
    "Marketing Name": "P551",
    "Device": "NGM_P551",
    "Model": "P551"
  },
  {
    "Retail Branding": "NGM Italia SRL",
    "Marketing Name": "P552",
    "Device": "NGM_P552",
    "Model": "P552"
  },
  {
    "Retail Branding": "NGM Italia SRL",
    "Marketing Name": "Ruby",
    "Device": "ForwardRuby",
    "Model": "Forward Ruby"
  },
  {
    "Retail Branding": "NGM Italia SRL",
    "Marketing Name": "Ruby",
    "Device": "ForwardRuby",
    "Model": "ForwardRuby"
  },
  {
    "Retail Branding": "NGM Italia SRL",
    "Marketing Name": "Smart5",
    "Device": "Smart5",
    "Model": "Smart5"
  },
  {
    "Retail Branding": "NGM Italia SRL",
    "Marketing Name": "Smart5.5",
    "Device": "Smart55",
    "Model": "Smart5.5"
  },
  {
    "Retail Branding": "NGM Italia SRL",
    "Marketing Name": "Smart5.5Plus",
    "Device": "Smart55Plus",
    "Model": "Smart5.5Plus32GB"
  },
  {
    "Retail Branding": "NGM Italia SRL",
    "Marketing Name": "Smart5Plus",
    "Device": "Smart5Plus",
    "Model": "Smart5Plus"
  },
  {
    "Retail Branding": "NIKAI_PRO",
    "Marketing Name": "NIKAI_PRO",
    "Device": "elliniko",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "NIKAI_PRO",
    "Marketing Name": "NIKAI_PRO",
    "Device": "hongkong",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "NIKAI_PRO",
    "Marketing Name": "Smart TV",
    "Device": "alimos",
    "Model": "NIKAI PRO Google TV"
  },
  {
    "Retail Branding": "NIKAI_PRO",
    "Marketing Name": "Smart TV",
    "Device": "dangni",
    "Model": "NIKAI PRO Google TV"
  },
  {
    "Retail Branding": "NIO",
    "Marketing Name": "N2301",
    "Device": "davinci",
    "Model": "N2301"
  },
  {
    "Retail Branding": "NIO",
    "Marketing Name": "N2401",
    "Device": "picasso",
    "Model": "N2401"
  },
  {
    "Retail Branding": "NIS(NWTF)",
    "Marketing Name": "Hi10_XPro_ROW",
    "Device": "Hi10_XPro_ROW",
    "Model": "Hi10_XPro"
  },
  {
    "Retail Branding": "NISATO",
    "Marketing Name": "R3",
    "Device": "R3",
    "Model": "R3"
  },
  {
    "Retail Branding": "NISATO",
    "Marketing Name": "R4",
    "Device": "R4",
    "Model": "R4"
  },
  {
    "Retail Branding": "NOA Mobile",
    "Marketing Name": "Forte_se",
    "Device": "Forte_se",
    "Model": "Forte_se"
  },
  {
    "Retail Branding": "NOA Mobile",
    "Marketing Name": "Fresh 4G",
    "Device": "Fresh_4G",
    "Model": "Fresh_4G"
  },
  {
    "Retail Branding": "NOA Mobile",
    "Marketing Name": "Hummer",
    "Device": "Hummer",
    "Model": "Hummer"
  },
  {
    "Retail Branding": "NOA Mobile",
    "Marketing Name": "Hummer_2019_R",
    "Device": "Hummer_2019_R",
    "Model": "Hummer_2019_R"
  },
  {
    "Retail Branding": "NOA Mobile",
    "Marketing Name": "N1",
    "Device": "N1",
    "Model": "N1"
  },
  {
    "Retail Branding": "NOA Mobile",
    "Marketing Name": "N10",
    "Device": "NOA_N10",
    "Model": "N10"
  },
  {
    "Retail Branding": "NOA Mobile",
    "Marketing Name": "N20",
    "Device": "NOA_N20",
    "Model": "N20"
  },
  {
    "Retail Branding": "NOA Mobile",
    "Marketing Name": "N7",
    "Device": "NOA_N7",
    "Model": "N7"
  },
  {
    "Retail Branding": "NOA Mobile",
    "Marketing Name": "N8",
    "Device": "NOA_N8",
    "Model": "NOA_N8"
  },
  {
    "Retail Branding": "NOA Mobile",
    "Marketing Name": "NOA_F10_Pro_EEA",
    "Device": "NOA_F10_Pro",
    "Model": "F10 Pro"
  },
  {
    "Retail Branding": "NOA Mobile",
    "Marketing Name": "NOA_N20",
    "Device": "NOA_N20",
    "Model": "N20"
  },
  {
    "Retail Branding": "NOA Mobile",
    "Marketing Name": "NOA_P1",
    "Device": "NOA_P1",
    "Model": "P1"
  },
  {
    "Retail Branding": "NOA Mobile",
    "Marketing Name": "NextSE",
    "Device": "NextSE",
    "Model": "NextSE"
  },
  {
    "Retail Branding": "NOA Mobile",
    "Marketing Name": "P1",
    "Device": "NOA_P1",
    "Model": "P1"
  },
  {
    "Retail Branding": "NOA Mobile",
    "Marketing Name": "Primo_4G",
    "Device": "Primo_4G",
    "Model": "Primo_4G"
  },
  {
    "Retail Branding": "NOA Mobile",
    "Marketing Name": "SPRINT 4G",
    "Device": "SPRINT4G",
    "Model": "SPRINT4G"
  },
  {
    "Retail Branding": "NOA Mobile",
    "Marketing Name": "SparkSE",
    "Device": "SparkSE",
    "Model": "SparkSE"
  },
  {
    "Retail Branding": "NOA Mobile",
    "Marketing Name": "Vivo 4G_r",
    "Device": "Vivo4G_r",
    "Model": "Vivo 4G_r"
  },
  {
    "Retail Branding": "NOGA",
    "Marketing Name": "NOGA101GHD",
    "Device": "NOGA101GHD",
    "Model": "NOGAPAD101GHD"
  },
  {
    "Retail Branding": "NOGA",
    "Marketing Name": "NOGA7",
    "Device": "NOGAPAD7G",
    "Model": "NOGAPAD7G"
  },
  {
    "Retail Branding": "NOGA",
    "Marketing Name": "NOGA7G",
    "Device": "NOGA7G",
    "Model": "NOGAPAD7G"
  },
  {
    "Retail Branding": "NOGA",
    "Marketing Name": "NOGAPAD101GHD",
    "Device": "NOGAPAD101GHD",
    "Model": "NOGAPAD101GHD"
  },
  {
    "Retail Branding": "NOGA",
    "Marketing Name": "NOGAPAD101XTREME",
    "Device": "NOGAPAD101XTREME",
    "Model": "NOGAPAD101XTREME"
  },
  {
    "Retail Branding": "NOGA",
    "Marketing Name": "NOGAPAD7G",
    "Device": "NOGAPAD7G",
    "Model": "NOGAPAD7G"
  },
  {
    "Retail Branding": "NOS",
    "Marketing Name": "Box 4K",
    "Device": "DV9161-KPN",
    "Model": "Box 4K"
  },
  {
    "Retail Branding": "NOVATAB",
    "Marketing Name": "T10",
    "Device": "NOVAT-10",
    "Model": "NOVAT-10"
  },
  {
    "Retail Branding": "NOVOJOY",
    "Marketing Name": "NV10",
    "Device": "NV10",
    "Model": "NV10"
  },
  {
    "Retail Branding": "NOWADA",
    "Marketing Name": "NWD_G5",
    "Device": "G5",
    "Model": "NWD_G5"
  },
  {
    "Retail Branding": "NOWO",
    "Marketing Name": "DV 8535 4K",
    "Device": "DV8535-KPN",
    "Model": "DV 8535 4K"
  },
  {
    "Retail Branding": "NOWO",
    "Marketing Name": "DV 8935 X4",
    "Device": "DV8935-KPN",
    "Model": "DV 8935 X4"
  },
  {
    "Retail Branding": "NPsystem",
    "Marketing Name": "TAB-700",
    "Device": "TAB-700",
    "Model": "TAB-700"
  },
  {
    "Retail Branding": "NSDEVIL",
    "Marketing Name": "ET1095A",
    "Device": "ET1095A",
    "Model": "ET1095A"
  },
  {
    "Retail Branding": "NSPRE",
    "Marketing Name": "NX-20PRO1",
    "Device": "NX-20PRO1",
    "Model": "NX-20PRO1"
  },
  {
    "Retail Branding": "NSVauto",
    "Marketing Name": "UNUNI_1640P_RSE",
    "Device": "UNUNI-1640P-RSE",
    "Model": "UNUNI-1640P-RSE"
  },
  {
    "Retail Branding": "NSVauto",
    "Marketing Name": "UNUNI_1641P_RSE",
    "Device": "UNUNI-1641P-RSE",
    "Model": "UNUNI-1641P-RSE"
  },
  {
    "Retail Branding": "NURIBOM",
    "Marketing Name": "NRB-IFPD",
    "Device": "rk3588_t",
    "Model": "MP_Series"
  },
  {
    "Retail Branding": "NVIDIA",
    "Marketing Name": "SHIELD Android TV",
    "Device": "",
    "Model": ""
  },
  {
    "Retail Branding": "NVIDIA",
    "Marketing Name": "SHIELD Android TV",
    "Device": "foster",
    "Model": "SHIELD Android TV"
  },
  {
    "Retail Branding": "NVIDIA",
    "Marketing Name": "SHIELD Android TV",
    "Device": "foster",
    "Model": "SHIELD Console"
  },
  {
    "Retail Branding": "NVIDIA",
    "Marketing Name": "SHIELD TV",
    "Device": "darcy",
    "Model": "SHIELD Android TV"
  },
  {
    "Retail Branding": "NVIDIA",
    "Marketing Name": "SHIELD TV",
    "Device": "sif",
    "Model": "SHIELD Android TV"
  },
  {
    "Retail Branding": "NVIDIA",
    "Marketing Name": "SHIELD TV Pro",
    "Device": "mdarcy",
    "Model": "SHIELD Android TV"
  },
  {
    "Retail Branding": "NVIDIA",
    "Marketing Name": "SHIELD Tablet",
    "Device": "shieldtablet",
    "Model": "SHIELD Tablet"
  },
  {
    "Retail Branding": "NVIDIA",
    "Marketing Name": "Shield",
    "Device": "roth",
    "Model": "SHIELD"
  },
  {
    "Retail Branding": "NVIDIA",
    "Marketing Name": "TegraNote",
    "Device": "tegranote",
    "Model": "Tegra Note 7"
  },
  {
    "Retail Branding": "NVIDIA",
    "Marketing Name": "TegraNote",
    "Device": "tegranote",
    "Model": "TegraNote-P1640"
  },
  {
    "Retail Branding": "NVIDIA",
    "Marketing Name": "TegraNote",
    "Device": "tegranote",
    "Model": "TegraNote-Premium"
  },
  {
    "Retail Branding": "NVIDIA",
    "Marketing Name": "TegraNote",
    "Device": "tegranote7c",
    "Model": "Tegra Note 7"
  },
  {
    "Retail Branding": "NW(NORWIN)",
    "Marketing Name": "NW1",
    "Device": "NW1",
    "Model": "NW1"
  },
  {
    "Retail Branding": "NYX Mobile",
    "Marketing Name": "A1",
    "Device": "NYX_A1",
    "Model": "NYX_A1"
  },
  {
    "Retail Branding": "NYX Mobile",
    "Marketing Name": "ARGON",
    "Device": "ARGON",
    "Model": "ARGON"
  },
  {
    "Retail Branding": "NYX Mobile",
    "Marketing Name": "B1",
    "Device": "B1",
    "Model": "B1"
  },
  {
    "Retail Branding": "NYX Mobile",
    "Marketing Name": "BLINK",
    "Device": "BLiNK",
    "Model": "BLiNK"
  },
  {
    "Retail Branding": "NYX Mobile",
    "Marketing Name": "Click",
    "Device": "Click",
    "Model": "Click"
  },
  {
    "Retail Branding": "NYX Mobile",
    "Marketing Name": "Cobalt",
    "Device": "Cobalt",
    "Model": "Cobalt"
  },
  {
    "Retail Branding": "NYX Mobile",
    "Marketing Name": "FIT",
    "Device": "FIT",
    "Model": "FIT"
  },
  {
    "Retail Branding": "NYX Mobile",
    "Marketing Name": "GLAM",
    "Device": "GLAM",
    "Model": "GLAM"
  },
  {
    "Retail Branding": "NYX Mobile",
    "Marketing Name": "GO-X",
    "Device": "GO-X",
    "Model": "GO-X"
  },
  {
    "Retail Branding": "NYX Mobile",
    "Marketing Name": "HIT",
    "Device": "NYX_HIT",
    "Model": "NYX_HIT"
  },
  {
    "Retail Branding": "NYX Mobile",
    "Marketing Name": "ICE",
    "Device": "ICE",
    "Model": "ICE"
  },
  {
    "Retail Branding": "NYX Mobile",
    "Marketing Name": "KiN",
    "Device": "KiN",
    "Model": "KiN"
  },
  {
    "Retail Branding": "NYX Mobile",
    "Marketing Name": "L604",
    "Device": "L604",
    "Model": "L604"
  },
  {
    "Retail Branding": "NYX Mobile",
    "Marketing Name": "NICKEL",
    "Device": "NICKEL",
    "Model": "NICKEL"
  },
  {
    "Retail Branding": "NYX Mobile",
    "Marketing Name": "NOBA",
    "Device": "NOBA",
    "Model": "NOBA"
  },
  {
    "Retail Branding": "NYX Mobile",
    "Marketing Name": "REX",
    "Device": "Rex",
    "Model": "Rex"
  },
  {
    "Retail Branding": "NYX Mobile",
    "Marketing Name": "SENSE",
    "Device": "SENSE",
    "Model": "SENSE"
  },
  {
    "Retail Branding": "NYX Mobile",
    "Marketing Name": "SEVEN",
    "Device": "SEVEN",
    "Model": "SEVEN"
  },
  {
    "Retail Branding": "NYX Mobile",
    "Marketing Name": "SHADE",
    "Device": "NYX_SHADE",
    "Model": "NYX_SHADE"
  },
  {
    "Retail Branding": "NYX Mobile",
    "Marketing Name": "SILVERGT",
    "Device": "SILVERGT",
    "Model": "SILVER"
  },
  {
    "Retail Branding": "NYX Mobile",
    "Marketing Name": "SILVERMX",
    "Device": "SILVERMX",
    "Model": "SILVER"
  },
  {
    "Retail Branding": "NYX Mobile",
    "Marketing Name": "Scorpio",
    "Device": "Scorpio",
    "Model": "Scorpio"
  },
  {
    "Retail Branding": "NYX Mobile",
    "Marketing Name": "TQ14",
    "Device": "TQ14",
    "Model": "TQ14"
  },
  {
    "Retail Branding": "NYX Mobile",
    "Marketing Name": "UMBRA",
    "Device": "UMBRA",
    "Model": "UMBRA"
  },
  {
    "Retail Branding": "NYX Mobile",
    "Marketing Name": "WIDE",
    "Device": "WIDE",
    "Model": "WIDE"
  },
  {
    "Retail Branding": "Nabi",
    "Marketing Name": "2 Tablet",
    "Device": "mt799",
    "Model": "NABI2-NV7A"
  },
  {
    "Retail Branding": "Nabi",
    "Marketing Name": "2S Tablet",
    "Device": "nabi2S",
    "Model": "SNB02-NV7A"
  },
  {
    "Retail Branding": "Nabi",
    "Marketing Name": "American Girl Tablet",
    "Device": "NBTY07SMKG",
    "Model": "NBTY07SMKG"
  },
  {
    "Retail Branding": "Nabi",
    "Marketing Name": "Barbie Tablet",
    "Device": "NBTY07SMKG",
    "Model": "NBTY07SMKG"
  },
  {
    "Retail Branding": "Nabi",
    "Marketing Name": "Big Tab HD™ 20",
    "Device": "DMTAB-NV20A",
    "Model": "DMTAB-NV20A"
  },
  {
    "Retail Branding": "Nabi",
    "Marketing Name": "Big Tab HD™ 24",
    "Device": "DMTAB-NV24A",
    "Model": "DMTAB-NV24A"
  },
  {
    "Retail Branding": "Nabi",
    "Marketing Name": "DreamTab HD8 Tablet",
    "Device": "DMTAB",
    "Model": "DMTAB-IN08A"
  },
  {
    "Retail Branding": "Nabi",
    "Marketing Name": "DreamTab HD8 Tablet",
    "Device": "t8400n",
    "Model": "DMTAB-NV08B"
  },
  {
    "Retail Branding": "Nabi",
    "Marketing Name": "Fisher Price Learning Tablet",
    "Device": "NBFP07PMKG",
    "Model": "NBFP07PMKG"
  },
  {
    "Retail Branding": "Nabi",
    "Marketing Name": "Hot Wheels Tablet",
    "Device": "NBTY07SMKG",
    "Model": "NBTY07SMKG"
  },
  {
    "Retail Branding": "Nabi",
    "Marketing Name": "TOY 7",
    "Device": "NBTY07SMKG",
    "Model": "NBTY07SMKG"
  },
  {
    "Retail Branding": "Nakamichi",
    "Marketing Name": "Nakamichi NA3615",
    "Device": "NA3615",
    "Model": "NA3615"
  },
  {
    "Retail Branding": "Nanho",
    "Marketing Name": "F101",
    "Device": "F101",
    "Model": "F101"
  },
  {
    "Retail Branding": "Nano",
    "Marketing Name": "4K Smart TV",
    "Device": "gangbyeon",
    "Model": "nano 4K AI Smart TV"
  },
  {
    "Retail Branding": "Nano",
    "Marketing Name": "EU、UK、AP",
    "Device": "martin",
    "Model": "Nano Android TV"
  },
  {
    "Retail Branding": "Nano",
    "Marketing Name": "Nano 2K Smart TV",
    "Device": "dongnae",
    "Model": "Nano 2K Smart TV"
  },
  {
    "Retail Branding": "Nano",
    "Marketing Name": "Smart TV",
    "Device": "mateo",
    "Model": "2K PA Smart TV"
  },
  {
    "Retail Branding": "Nano",
    "Marketing Name": "Smart TV",
    "Device": "osaki",
    "Model": "nano 2K AI Smart TV"
  },
  {
    "Retail Branding": "Nano",
    "Marketing Name": "Thailand",
    "Device": "guandu",
    "Model": "Nano Android TV"
  },
  {
    "Retail Branding": "Nano",
    "Marketing Name": "Thailand",
    "Device": "marina",
    "Model": "Nano 4K SMART TV"
  },
  {
    "Retail Branding": "Nano",
    "Marketing Name": "Thailand",
    "Device": "nagata",
    "Model": "Nano 2K SMART TV"
  },
  {
    "Retail Branding": "Nano",
    "Marketing Name": "Thailand",
    "Device": "sepolia",
    "Model": "Nano 4K Smart TV"
  },
  {
    "Retail Branding": "Nano",
    "Marketing Name": "Thailand",
    "Device": "tamachi",
    "Model": "Nano FHD Android TV"
  },
  {
    "Retail Branding": "Nano",
    "Marketing Name": "Thailand",
    "Device": "yeongdeungpo",
    "Model": "Nano UHD Android TV"
  },
  {
    "Retail Branding": "NanoTech",
    "Marketing Name": "Nuvola NP-1",
    "Device": "nuvola",
    "Model": "Nuvola NP-1"
  },
  {
    "Retail Branding": "Naomi Phone",
    "Marketing Name": "Ambar",
    "Device": "NAOMIPHONE_Ambar",
    "Model": "NAOMIPHONE Ambar"
  },
  {
    "Retail Branding": "Natcom",
    "Marketing Name": "X1LTE",
    "Device": "X1LTE",
    "Model": "X1LTE"
  },
  {
    "Retail Branding": "Nautilus",
    "Marketing Name": "NFTM-LAR",
    "Device": "nftm_lar",
    "Model": "NFTM-LAR"
  },
  {
    "Retail Branding": "Nautilus",
    "Marketing Name": "NFTM-MED",
    "Device": "nftm_med",
    "Model": "NFTM-MED"
  },
  {
    "Retail Branding": "Nautilus",
    "Marketing Name": "NFTM-SMA",
    "Device": "nftm_sma",
    "Model": "NFTM-SMA"
  },
  {
    "Retail Branding": "Nautilus",
    "Marketing Name": "NFTM-XSMA",
    "Device": "nftm_xsma",
    "Model": "NFTM-XSMA"
  },
  {
    "Retail Branding": "Navcity",
    "Marketing Name": "NAVCITY NP-752",
    "Device": "NP_752",
    "Model": "NP-752"
  },
  {
    "Retail Branding": "Navcity",
    "Marketing Name": "NAVCITY NP-852",
    "Device": "NP-852",
    "Model": "NP-852"
  },
  {
    "Retail Branding": "Navcity",
    "Marketing Name": "NAVCITY NP-855",
    "Device": "NP_855",
    "Model": "NP-855"
  },
  {
    "Retail Branding": "Navcity",
    "Marketing Name": "NP-752GO",
    "Device": "NP-752Go",
    "Model": "NP-752Go"
  },
  {
    "Retail Branding": "Navcity",
    "Marketing Name": "NP-852",
    "Device": "NP-852",
    "Model": "NP-852"
  },
  {
    "Retail Branding": "Navcity",
    "Marketing Name": "NP-855",
    "Device": "NP-855",
    "Model": "NP-855"
  },
  {
    "Retail Branding": "Navcity",
    "Marketing Name": "NP752",
    "Device": "NP752",
    "Model": "NP-752"
  },
  {
    "Retail Branding": "Navcity",
    "Marketing Name": "NT-1714",
    "Device": "NT1714",
    "Model": "NT-1714"
  },
  {
    "Retail Branding": "Navcity",
    "Marketing Name": "NT-1716",
    "Device": "NT-1716",
    "Model": "NT-1716"
  },
  {
    "Retail Branding": "Navitel",
    "Marketing Name": "NAVITEL_T757LTE_EEA",
    "Device": "NAVITEL_T757LTE",
    "Model": "NAVITEL_T757LTE"
  },
  {
    "Retail Branding": "Navitel",
    "Marketing Name": "NAVITEL_T797_4G",
    "Device": "NAVITEL_T797_4G",
    "Model": "NAVITEL_T797_4G"
  },
  {
    "Retail Branding": "Navitel",
    "Marketing Name": "Navitel T700 3G Navi",
    "Device": "NAVITEL_T700_3G_NAVI",
    "Model": "NAVITEL T700 3G NAVI"
  },
  {
    "Retail Branding": "Navitel",
    "Marketing Name": "T500 3G",
    "Device": "T500_3G",
    "Model": "T500 3G"
  },
  {
    "Retail Branding": "Navitel",
    "Marketing Name": "T505PRO",
    "Device": "T505PRO",
    "Model": "T505PRO"
  },
  {
    "Retail Branding": "Navitel",
    "Marketing Name": "T700_3G_Pro",
    "Device": "T700_3G_Pro",
    "Model": "NAVITEL T700 3G PRO"
  },
  {
    "Retail Branding": "Navitel",
    "Marketing Name": "T707_3G",
    "Device": "T707_3G",
    "Model": "NAVITEL T707 3G"
  },
  {
    "Retail Branding": "Navitel",
    "Marketing Name": "T737PRO",
    "Device": "T737PRO",
    "Model": "T737PRO"
  },
  {
    "Retail Branding": "Navitel",
    "Marketing Name": "T787-4G",
    "Device": "T787-4G",
    "Model": "T787-4G"
  },
  {
    "Retail Branding": "Navon",
    "Marketing Name": "D455",
    "Device": "D455",
    "Model": "D455"
  },
  {
    "Retail Branding": "Navon",
    "Marketing Name": "D504",
    "Device": "D504",
    "Model": "D504"
  },
  {
    "Retail Branding": "Navon",
    "Marketing Name": "F552",
    "Device": "F552",
    "Model": "NAVON F552"
  },
  {
    "Retail Branding": "Navon",
    "Marketing Name": "IQ7",
    "Device": "IQ7",
    "Model": "IQ7"
  },
  {
    "Retail Branding": "Navon",
    "Marketing Name": "Infinity",
    "Device": "Infinity",
    "Model": "Navon_Infinity"
  },
  {
    "Retail Branding": "Navon",
    "Marketing Name": "M505",
    "Device": "M505_4G",
    "Model": "M505_4G"
  },
  {
    "Retail Branding": "Navon",
    "Marketing Name": "Navon Supreme  Pure",
    "Device": "Supreme_Pure",
    "Model": "Navon Supreme Pure"
  },
  {
    "Retail Branding": "Navon",
    "Marketing Name": "NavonOrpheus3G2020",
    "Device": "NavonOrpheus3G2020",
    "Model": "NavonOrpheus3G2020"
  },
  {
    "Retail Branding": "Navon",
    "Marketing Name": "Navon_IQ7_2020",
    "Device": "Navon_IQ7_2020",
    "Model": "IQ7"
  },
  {
    "Retail Branding": "Navon",
    "Marketing Name": "Navon_IQ8_2021",
    "Device": "Navon_IQ8_2021",
    "Model": "IQ8"
  },
  {
    "Retail Branding": "Navon",
    "Marketing Name": "Navon_IQ8_2021",
    "Device": "Navon_SPT1100",
    "Model": "Navon_SPT1100"
  },
  {
    "Retail Branding": "Navon",
    "Marketing Name": "Navon_Orpheus_3G",
    "Device": "Navon_Orpheus_3G",
    "Model": "Navon Orpheus 3G"
  },
  {
    "Retail Branding": "Navon",
    "Marketing Name": "Pad 10",
    "Device": "Pad_10",
    "Model": "Pad_10"
  },
  {
    "Retail Branding": "Navon",
    "Marketing Name": "Platinum 10 3G",
    "Device": "Platinum_10_3G",
    "Model": "Platinum 10 3G"
  },
  {
    "Retail Branding": "Navon",
    "Marketing Name": "Platinum 10 3G",
    "Device": "Platinum_10_3G_V2",
    "Model": "Platinum_10_3G_V2"
  },
  {
    "Retail Branding": "Navon",
    "Marketing Name": "Platinum103G2019",
    "Device": "Platinum103G2019",
    "Model": "Platinum103G2019"
  },
  {
    "Retail Branding": "Navon",
    "Marketing Name": "Predator 10",
    "Device": "Predator_10",
    "Model": "Predator 10"
  },
  {
    "Retail Branding": "Navon",
    "Marketing Name": "Predator 3G",
    "Device": "Predator_3G",
    "Model": "Predator 3G"
  },
  {
    "Retail Branding": "Navon",
    "Marketing Name": "Pure Micro",
    "Device": "Pure_Micro",
    "Model": "Pure Micro"
  },
  {
    "Retail Branding": "Navon",
    "Marketing Name": "S450",
    "Device": "S450",
    "Model": "S450"
  },
  {
    "Retail Branding": "Navon",
    "Marketing Name": "SKY",
    "Device": "Sky",
    "Model": "Sky"
  },
  {
    "Retail Branding": "Navon",
    "Marketing Name": "Spirit",
    "Device": "Spirit",
    "Model": "Spirit"
  },
  {
    "Retail Branding": "Navon",
    "Marketing Name": "Spirit Plus",
    "Device": "Spirit_Plus",
    "Model": "Spirit_Plus"
  },
  {
    "Retail Branding": "Navon",
    "Marketing Name": "Superme_Max",
    "Device": "Superme_Max",
    "Model": "Superme_Max"
  },
  {
    "Retail Branding": "Navon",
    "Marketing Name": "Supreme Chief",
    "Device": "Supreme_Chief",
    "Model": "Supreme Chief"
  },
  {
    "Retail Branding": "Navon",
    "Marketing Name": "Supreme Fine",
    "Device": "Supreme_Fine",
    "Model": "Supreme_Fine"
  },
  {
    "Retail Branding": "Navon",
    "Marketing Name": "Supreme Fine Mini",
    "Device": "Supreme_Fine_Mini",
    "Model": "Supreme_Fine_Mini"
  },
  {
    "Retail Branding": "Navon",
    "Marketing Name": "Supreme Fine Plus",
    "Device": "Supreme_Fine_Plus",
    "Model": "Supreme Fine Plus"
  },
  {
    "Retail Branding": "Navon",
    "Marketing Name": "Supreme Pro",
    "Device": "Supreme_Pro",
    "Model": "Supreme_Pro"
  },
  {
    "Retail Branding": "Navon",
    "Marketing Name": "Supreme_Fine_Micro",
    "Device": "Supreme_Fine_Micro",
    "Model": "Supreme_Fine_Micro"
  },
  {
    "Retail Branding": "Navon",
    "Marketing Name": "Supreme_Pure_Plus",
    "Device": "Supreme_Pure_Plus",
    "Model": "Supreme_Pure_Plus"
  },
  {
    "Retail Branding": "Navon",
    "Marketing Name": "T400",
    "Device": "T400",
    "Model": "T400"
  },
  {
    "Retail Branding": "Navon",
    "Marketing Name": "T400 3G",
    "Device": "T400_3G",
    "Model": "T400 3G 2017"
  },
  {
    "Retail Branding": "Navon",
    "Marketing Name": "T452",
    "Device": "T452",
    "Model": "T452"
  },
  {
    "Retail Branding": "Navon",
    "Marketing Name": "T503",
    "Device": "T503",
    "Model": "T503"
  },
  {
    "Retail Branding": "Navon",
    "Marketing Name": "Vision Tab 10",
    "Device": "Vision_Tab_10",
    "Model": "Vision_Tab_10"
  },
  {
    "Retail Branding": "Navon",
    "Marketing Name": "Vision_Tab_7",
    "Device": "Vision_Tab_7",
    "Model": "Vision_Tab_7"
  },
  {
    "Retail Branding": "Navon",
    "Marketing Name": "iQ7 2018",
    "Device": "iQ7_2018",
    "Model": "iQ7_2018"
  },
  {
    "Retail Branding": "Naxa",
    "Marketing Name": "NID-1020",
    "Device": "NID_1020",
    "Model": "NID-1020"
  },
  {
    "Retail Branding": "Naxa",
    "Marketing Name": "NID-1050",
    "Device": "NID-1050",
    "Model": "NID-1050"
  },
  {
    "Retail Branding": "Naxa",
    "Marketing Name": "NID-7020",
    "Device": "NID_7020",
    "Model": "NID-7020"
  },
  {
    "Retail Branding": "Naxa",
    "Marketing Name": "NID1009",
    "Device": "NID1009",
    "Model": "NID-1009"
  },
  {
    "Retail Branding": "Naxa",
    "Marketing Name": "NID7019",
    "Device": "NID7019",
    "Model": "NID-7019"
  },
  {
    "Retail Branding": "Naxa",
    "Marketing Name": "NID9009",
    "Device": "NID9009",
    "Model": "NID-9009"
  },
  {
    "Retail Branding": "Naxa",
    "Marketing Name": "NID_1021",
    "Device": "NID_1021",
    "Model": "NID-1021"
  },
  {
    "Retail Branding": "Naxa",
    "Marketing Name": "NID_1056",
    "Device": "NID_1056",
    "Model": "NID-1056"
  },
  {
    "Retail Branding": "Naxa",
    "Marketing Name": "NID_1070",
    "Device": "NID_1070",
    "Model": "NID_1070"
  },
  {
    "Retail Branding": "Naxa",
    "Marketing Name": "NID_7021",
    "Device": "NID_7021",
    "Model": "NID-7021"
  },
  {
    "Retail Branding": "Naxa",
    "Marketing Name": "NID_7022",
    "Device": "NID_7022",
    "Model": "NID-7022"
  },
  {
    "Retail Branding": "Naxa",
    "Marketing Name": "NID_7056",
    "Device": "NID_7056",
    "Model": "NID-7056"
  },
  {
    "Retail Branding": "Naxa",
    "Marketing Name": "Naxa",
    "Device": "NID_1055",
    "Model": "NID-1055"
  },
  {
    "Retail Branding": "Naxa",
    "Marketing Name": "Naxa",
    "Device": "NID_7055",
    "Model": "NID-7055"
  },
  {
    "Retail Branding": "Ncredible",
    "Marketing Name": "NV8",
    "Device": "NV8",
    "Model": "NV8"
  },
  {
    "Retail Branding": "Ncredible",
    "Marketing Name": "NV8-HD",
    "Device": "NV8-HD",
    "Model": "NV8"
  },
  {
    "Retail Branding": "Nebula",
    "Marketing Name": "Capsule Air",
    "Device": "taihang",
    "Model": "D4112"
  },
  {
    "Retail Branding": "Nebula",
    "Marketing Name": "Cosmos_4K_SE",
    "Device": "lavasa",
    "Model": "D2342"
  },
  {
    "Retail Branding": "Nebula",
    "Marketing Name": "D0480",
    "Device": "CJU",
    "Model": "D0480"
  },
  {
    "Retail Branding": "Nebula",
    "Marketing Name": "D2130",
    "Device": "D2140-Cosmos",
    "Model": "D2130"
  },
  {
    "Retail Branding": "Nebula",
    "Marketing Name": "D2140",
    "Device": "D2140-Cosmos",
    "Model": "D2140"
  },
  {
    "Retail Branding": "Nebula",
    "Marketing Name": "D2150",
    "Device": "D2140-Cosmos",
    "Model": "D2150"
  },
  {
    "Retail Branding": "Nebula",
    "Marketing Name": "D2160",
    "Device": "D2140-Cosmos",
    "Model": "D2160"
  },
  {
    "Retail Branding": "Nebula",
    "Marketing Name": "D2241",
    "Device": "DM8260",
    "Model": "D2241"
  },
  {
    "Retail Branding": "Nebula",
    "Marketing Name": "D2421",
    "Device": "DM8261",
    "Model": "D2421"
  },
  {
    "Retail Branding": "Nebula",
    "Marketing Name": "Nebula X1",
    "Device": "lavasa",
    "Model": "D2351"
  },
  {
    "Retail Branding": "Nebula",
    "Marketing Name": "Nebula_Capsule_3",
    "Device": "taihang",
    "Model": "D2425"
  },
  {
    "Retail Branding": "Nebula",
    "Marketing Name": "Nebula_Capsule_3_Laser",
    "Device": "matheran",
    "Model": "D2426"
  },
  {
    "Retail Branding": "Nebula",
    "Marketing Name": "Nebula_Mars_2_V2",
    "Device": "taihang",
    "Model": "D2325"
  },
  {
    "Retail Branding": "Nebullar",
    "Marketing Name": "Gemini1_SE",
    "Device": "Gemini1_SE",
    "Model": "Gemini1_SE"
  },
  {
    "Retail Branding": "Nebullar",
    "Marketing Name": "Pegasus 1",
    "Device": "Pegasus1",
    "Model": "Pegasus1"
  },
  {
    "Retail Branding": "Nebullar",
    "Marketing Name": "Pegasus 1",
    "Device": "Pegasus1",
    "Model": "Pegasus1_Payment"
  },
  {
    "Retail Branding": "Necnon",
    "Marketing Name": "3L-2",
    "Device": "3L-2",
    "Model": "3L-2"
  },
  {
    "Retail Branding": "Necnon",
    "Marketing Name": "M002K-2",
    "Device": "M002K-2",
    "Model": "M002K-2"
  },
  {
    "Retail Branding": "Necnon",
    "Marketing Name": "M002K-2",
    "Device": "M002K_2",
    "Model": "M002K-2"
  },
  {
    "Retail Branding": "Necnon",
    "Marketing Name": "M002N",
    "Device": "M002N",
    "Model": "M002N"
  },
  {
    "Retail Branding": "Necnon",
    "Marketing Name": "M002Q-2",
    "Device": "M002Q-2",
    "Model": "M002Q-2"
  },
  {
    "Retail Branding": "Necnon",
    "Marketing Name": "M002U-2T",
    "Device": "M002U-2T",
    "Model": "M002U-2T"
  },
  {
    "Retail Branding": "Necnon",
    "Marketing Name": "M002U_2T",
    "Device": "M002U_2T",
    "Model": "M002U-2T"
  },
  {
    "Retail Branding": "Necnon",
    "Marketing Name": "M002W-2T",
    "Device": "M002W-2T",
    "Model": "M002W-2T"
  },
  {
    "Retail Branding": "Necnon",
    "Marketing Name": "MOO2N-3T",
    "Device": "M002N-3T",
    "Model": "M002N-3T"
  },
  {
    "Retail Branding": "Neffos",
    "Marketing Name": "C5",
    "Device": "C5",
    "Model": "Neffos C5"
  },
  {
    "Retail Branding": "Neffos",
    "Marketing Name": "C5 Max",
    "Device": "C5_Max",
    "Model": "Neffos C5 Max"
  },
  {
    "Retail Branding": "Neffos",
    "Marketing Name": "C5L",
    "Device": "QC601",
    "Model": "TP601A"
  },
  {
    "Retail Branding": "Neffos",
    "Marketing Name": "C5L",
    "Device": "QC601",
    "Model": "TP601B"
  },
  {
    "Retail Branding": "Neffos",
    "Marketing Name": "C5L",
    "Device": "QC601",
    "Model": "TP601C"
  },
  {
    "Retail Branding": "Neffos",
    "Marketing Name": "C5L",
    "Device": "QC601",
    "Model": "TP601E"
  },
  {
    "Retail Branding": "Neffos",
    "Marketing Name": "Neffos  A5",
    "Device": "A5",
    "Model": "Neffos A5"
  },
  {
    "Retail Branding": "Neffos",
    "Marketing Name": "Neffos  C9 Max",
    "Device": "C9_Max",
    "Model": "Neffos C9 Max"
  },
  {
    "Retail Branding": "Neffos",
    "Marketing Name": "Neffos  C9s",
    "Device": "C9s",
    "Model": "Neffos C9s"
  },
  {
    "Retail Branding": "Neffos",
    "Marketing Name": "Neffos C5 Plus",
    "Device": "C5_Plus",
    "Model": "Neffos C5 Plus"
  },
  {
    "Retail Branding": "Neffos",
    "Marketing Name": "Neffos C7",
    "Device": "C7",
    "Model": "Neffos C7"
  },
  {
    "Retail Branding": "Neffos",
    "Marketing Name": "Neffos C7",
    "Device": "C7",
    "Model": "Neffos_C7"
  },
  {
    "Retail Branding": "Neffos",
    "Marketing Name": "Neffos C7 Lite",
    "Device": "C7_Lite",
    "Model": "Neffos C7 Lite"
  },
  {
    "Retail Branding": "Neffos",
    "Marketing Name": "Neffos C7s",
    "Device": "C7s",
    "Model": "Neffos C7s"
  },
  {
    "Retail Branding": "Neffos",
    "Marketing Name": "Neffos C9",
    "Device": "C9",
    "Model": "Neffos_C9"
  },
  {
    "Retail Branding": "Neffos",
    "Marketing Name": "Neffos C9A",
    "Device": "C9A",
    "Model": "Neffos_C9A"
  },
  {
    "Retail Branding": "Neffos",
    "Marketing Name": "Neffos N1",
    "Device": "N1",
    "Model": "Neffos N1"
  },
  {
    "Retail Branding": "Neffos",
    "Marketing Name": "Neffos X1",
    "Device": "X1",
    "Model": "Neffos X1"
  },
  {
    "Retail Branding": "Neffos",
    "Marketing Name": "Neffos X1 Max",
    "Device": "X1_Max",
    "Model": "Neffos X1 Max"
  },
  {
    "Retail Branding": "Neffos",
    "Marketing Name": "Neffos X20",
    "Device": "X20",
    "Model": "Neffos X20"
  },
  {
    "Retail Branding": "Neffos",
    "Marketing Name": "Neffos X20 Pro",
    "Device": "X20_Pro",
    "Model": "Neffos X20 Pro"
  },
  {
    "Retail Branding": "Neffos",
    "Marketing Name": "Neffos X9",
    "Device": "X9",
    "Model": "Neffos_X9"
  },
  {
    "Retail Branding": "Neffos",
    "Marketing Name": "Neffos Y5i",
    "Device": "Y5i",
    "Model": "Neffos Y5i"
  },
  {
    "Retail Branding": "Neffos",
    "Marketing Name": "Neffos Y5s",
    "Device": "Y5s",
    "Model": "Neffos Y5s"
  },
  {
    "Retail Branding": "Neffos",
    "Marketing Name": "Neffos Y6",
    "Device": "Y6",
    "Model": "Neffos Y6"
  },
  {
    "Retail Branding": "Neffos",
    "Marketing Name": "Neffos Y7",
    "Device": "Y7",
    "Model": "Neffos Y7"
  },
  {
    "Retail Branding": "Neffos",
    "Marketing Name": "Neffos Y7",
    "Device": "Y7",
    "Model": "Neffos_Y7"
  },
  {
    "Retail Branding": "Neffos",
    "Marketing Name": "TP703A",
    "Device": "C5a",
    "Model": "Neffos C5a"
  },
  {
    "Retail Branding": "Neffos",
    "Marketing Name": "TP704A",
    "Device": "C5s",
    "Model": "Neffos C5s"
  },
  {
    "Retail Branding": "Neffos",
    "Marketing Name": "TP704A",
    "Device": "Y5_Lite",
    "Model": "Neffos Y5 Lite"
  },
  {
    "Retail Branding": "Neffos",
    "Marketing Name": "TP705",
    "Device": "C7A",
    "Model": "Neffos_C7A"
  },
  {
    "Retail Branding": "Neffos",
    "Marketing Name": "X1 Lite",
    "Device": "X1_Lite",
    "Model": "Neffos X1 Lite"
  },
  {
    "Retail Branding": "Neffos",
    "Marketing Name": "Y5",
    "Device": "Y5",
    "Model": "Neffos Y5"
  },
  {
    "Retail Branding": "Neffos",
    "Marketing Name": "Y50",
    "Device": "Y50",
    "Model": "Neffos Y50"
  },
  {
    "Retail Branding": "Neffos",
    "Marketing Name": "Y5L",
    "Device": "Y5L",
    "Model": "Neffos Y5L"
  },
  {
    "Retail Branding": "Neffos",
    "Marketing Name": "Y5L",
    "Device": "Y5LM",
    "Model": "Neffos Y5L"
  },
  {
    "Retail Branding": "Nelson Mandela",
    "Marketing Name": "Freedom 5.0",
    "Device": "Freedom_5_0",
    "Model": "Freedom 5.0"
  },
  {
    "Retail Branding": "Nelson Mandela",
    "Marketing Name": "Freedom 5.2",
    "Device": "Freedom_5_2",
    "Model": "Freedom 5.2"
  },
  {
    "Retail Branding": "Nelson Mandela",
    "Marketing Name": "Freedom 5.5",
    "Device": "Freedom_55",
    "Model": "Freedom 5.5"
  },
  {
    "Retail Branding": "Neoregent",
    "Marketing Name": "KT1007_EEA",
    "Device": "KT1007_EEA",
    "Model": "KT1007_EEA"
  },
  {
    "Retail Branding": "Neostra",
    "Marketing Name": "Neostra-R10",
    "Device": "Neostra-R10",
    "Model": "Neostra-R10"
  },
  {
    "Retail Branding": "Neostra",
    "Marketing Name": "Neostra-R10C",
    "Device": "Neostra-R10C",
    "Model": "Neostra-R10C"
  },
  {
    "Retail Branding": "Neostra",
    "Marketing Name": "Neostra-R7",
    "Device": "Neostra-R7",
    "Model": "Neostra-R7"
  },
  {
    "Retail Branding": "Neostra",
    "Marketing Name": "ViewPad 7A",
    "Device": "ViewPad-Kids-7A",
    "Model": "ViewPad-Kids-7A"
  },
  {
    "Retail Branding": "Neotouch",
    "Marketing Name": "MT-xxMU",
    "Device": "MT-xxMU",
    "Model": "MT-xxMU"
  },
  {
    "Retail Branding": "Net+",
    "Marketing Name": "TV",
    "Device": "uzw4068nps",
    "Model": "Box TV"
  },
  {
    "Retail Branding": "Net+",
    "Marketing Name": "TV",
    "Device": "uzx4020nps",
    "Model": "TV"
  },
  {
    "Retail Branding": "Netgear",
    "Marketing Name": "NeoTVPrime",
    "Device": "NeoTV",
    "Model": "GTV100"
  },
  {
    "Retail Branding": "Netmak",
    "Marketing Name": "NETPAD7",
    "Device": "NM-NETPAD7",
    "Model": "NM-NETPAD7"
  },
  {
    "Retail Branding": "Netmak",
    "Marketing Name": "NM-VELOCITY",
    "Device": "NM_VELOCITY",
    "Model": "NM-VELOCITY"
  },
  {
    "Retail Branding": "Netmak",
    "Marketing Name": "NM_PADPRO",
    "Device": "NM_PADPRO",
    "Model": "NM_PADPRO"
  },
  {
    "Retail Branding": "Netmak",
    "Marketing Name": "NM_VISION",
    "Device": "NM_VISION",
    "Model": "NM_VISION"
  },
  {
    "Retail Branding": "Netmak",
    "Marketing Name": "NM_VISION",
    "Device": "NM_VISION",
    "Model": "SMART KIDS A10"
  },
  {
    "Retail Branding": "Neusoft",
    "Marketing Name": "S611",
    "Device": "S611",
    "Model": "S611"
  },
  {
    "Retail Branding": "New Balance",
    "Marketing Name": "Run IQ",
    "Device": "shasta",
    "Model": "NB RunIQ"
  },
  {
    "Retail Branding": "NewBridge",
    "Marketing Name": "NBTB101",
    "Device": "NBTB101",
    "Model": "NBTB101"
  },
  {
    "Retail Branding": "NewBridge",
    "Marketing Name": "NBTB101b",
    "Device": "NBTB101b",
    "Model": "NBTB101"
  },
  {
    "Retail Branding": "NewBridge",
    "Marketing Name": "NBTB102",
    "Device": "NBTB102",
    "Model": "NBTB102"
  },
  {
    "Retail Branding": "Newal",
    "Marketing Name": "Europe",
    "Device": "sepolia",
    "Model": "NEWAL Smart TV"
  },
  {
    "Retail Branding": "Newal",
    "Marketing Name": "NEWAL Smart TV",
    "Device": "dongnae",
    "Model": "NEWAL Smart TV"
  },
  {
    "Retail Branding": "Newal",
    "Marketing Name": "Newal 2K SMART TV",
    "Device": "nagata",
    "Model": "Newal 2K SMART TV"
  },
  {
    "Retail Branding": "Newal",
    "Marketing Name": "Newal 4K SMART TV",
    "Device": "marina",
    "Model": "Newal 4K SMART TV"
  },
  {
    "Retail Branding": "Newings",
    "Marketing Name": "T18",
    "Device": "T18",
    "Model": "T18"
  },
  {
    "Retail Branding": "Newland",
    "Marketing Name": "MT93",
    "Device": "MT93",
    "Model": "NLS-MT93"
  },
  {
    "Retail Branding": "Newland",
    "Marketing Name": "N950",
    "Device": "SmartPOS",
    "Model": "N950"
  },
  {
    "Retail Branding": "Newland",
    "Marketing Name": "NLS-MT6550-AM",
    "Device": "NLS-MT6550-AM",
    "Model": "NLS-MT65"
  },
  {
    "Retail Branding": "Newland",
    "Marketing Name": "NLS-MT6552-EEA",
    "Device": "NLS-MT6552-EEA",
    "Model": "NLS-MT65"
  },
  {
    "Retail Branding": "Newland",
    "Marketing Name": "NLS-MT6552-GL",
    "Device": "NLS-MT6552-GL",
    "Model": "NLS-MT65"
  },
  {
    "Retail Branding": "Newland",
    "Marketing Name": "NLS-MT6552-RU",
    "Device": "NLS-MT6552-RU",
    "Model": "NLS-MT65"
  },
  {
    "Retail Branding": "Newland",
    "Marketing Name": "NLS-MT6555-GL",
    "Device": "NLS-MT6555-GL",
    "Model": "NLS-MT65"
  },
  {
    "Retail Branding": "Newland",
    "Marketing Name": "NLS-MT6755-GL",
    "Device": "NLS-MT6755-GL",
    "Model": "NLS-MT67"
  },
  {
    "Retail Branding": "Newland",
    "Marketing Name": "NLS-MT6757",
    "Device": "NLS-MT6757",
    "Model": "NLS-MT67"
  },
  {
    "Retail Branding": "Newland",
    "Marketing Name": "NLS-MT9050-AM",
    "Device": "NLS-MT9052-GL",
    "Model": "NLS-MT90"
  },
  {
    "Retail Branding": "Newland",
    "Marketing Name": "NLS-MT9052-EEA",
    "Device": "NLS-MT9052-GL",
    "Model": "NLS-MT90"
  },
  {
    "Retail Branding": "Newland",
    "Marketing Name": "NLS-MT9052-GL",
    "Device": "NLS-MT9052-GL",
    "Model": "NLS-MT90"
  },
  {
    "Retail Branding": "Newland",
    "Marketing Name": "NLS-MT9052-RU",
    "Device": "NLS-MT9052-GL",
    "Model": "NLS-MT90"
  },
  {
    "Retail Branding": "Newland",
    "Marketing Name": "NLS-MT9055-GL",
    "Device": "NLS-MT9055-GL",
    "Model": "NLS-MT90"
  },
  {
    "Retail Branding": "Newland",
    "Marketing Name": "NLS-MT93",
    "Device": "NLS-MT93",
    "Model": "NLS-MT93"
  },
  {
    "Retail Branding": "Newland",
    "Marketing Name": "NLS-MT95",
    "Device": "NLS-MT95",
    "Model": "NLS-MT95"
  },
  {
    "Retail Branding": "Newland",
    "Marketing Name": "NLS-MT9556",
    "Device": "NLS-MT9556",
    "Model": "NLS-MT95"
  },
  {
    "Retail Branding": "Newland",
    "Marketing Name": "NLS-N7",
    "Device": "NLS-N7",
    "Model": "NLS-N7"
  },
  {
    "Retail Branding": "Newland",
    "Marketing Name": "NLS-NFT10",
    "Device": "NLS-NFT10-GL",
    "Model": "NLS-NFT10"
  },
  {
    "Retail Branding": "Newland",
    "Marketing Name": "NLS-NFT10",
    "Device": "NLS-NFT10-RU",
    "Model": "NLS-NFT10"
  },
  {
    "Retail Branding": "Newland",
    "Marketing Name": "NLS-SD100P",
    "Device": "NLS-SD100P",
    "Model": "NLS-SD100P"
  },
  {
    "Retail Branding": "Newland",
    "Marketing Name": "Newland NLS-MT90",
    "Device": "NLS-MT90-GL",
    "Model": "NLS-MT90"
  },
  {
    "Retail Branding": "Newland",
    "Marketing Name": "Newland NLS-N7",
    "Device": "NLS-N7-GL",
    "Model": "NLS-N7"
  },
  {
    "Retail Branding": "Newland",
    "Marketing Name": "Newland NLS-NQuire",
    "Device": "NLS-NQuire",
    "Model": "NLS-NQuire"
  },
  {
    "Retail Branding": "Newland",
    "Marketing Name": "S30",
    "Device": "S30",
    "Model": "S30"
  },
  {
    "Retail Branding": "Newland",
    "Marketing Name": "S90Pro",
    "Device": "S90",
    "Model": "S90"
  },
  {
    "Retail Branding": "Newland",
    "Marketing Name": "X70",
    "Device": "X70",
    "Model": "X70"
  },
  {
    "Retail Branding": "Newline",
    "Marketing Name": "23Q",
    "Device": "23Q",
    "Model": "23Q"
  },
  {
    "Retail Branding": "Newline",
    "Marketing Name": "23QA",
    "Device": "velvet",
    "Model": "LGA311D2"
  },
  {
    "Retail Branding": "Newline",
    "Marketing Name": "Newline 26Q",
    "Device": "newline26Q",
    "Model": "newline26Q"
  },
  {
    "Retail Branding": "Newline",
    "Marketing Name": "Newline_Q_Pro_Elite",
    "Device": "Q25ELT",
    "Model": "Newline Q Pro Elite"
  },
  {
    "Retail Branding": "Newline",
    "Marketing Name": "Newline_Q_Pro_Elite",
    "Device": "Q25ELT",
    "Model": "Newline_Q_Pro_Elite"
  },
  {
    "Retail Branding": "Newline",
    "Marketing Name": "Q23",
    "Device": "rk3588_t",
    "Model": "Q23"
  },
  {
    "Retail Branding": "Newline",
    "Marketing Name": "WB55860W",
    "Device": "WB55860W",
    "Model": "WB55860W"
  },
  {
    "Retail Branding": "Newline",
    "Marketing Name": "WB76110A",
    "Device": "WB76110A",
    "Model": "WB76110A"
  },
  {
    "Retail Branding": "Newline",
    "Marketing Name": "Z Pro Series",
    "Device": "Z24",
    "Model": "24ZPro"
  },
  {
    "Retail Branding": "Newsday",
    "Marketing Name": "A1",
    "Device": "Newsday_A1",
    "Model": "Newsday_A1"
  },
  {
    "Retail Branding": "Newsday",
    "Marketing Name": "A2",
    "Device": "Newsday_A2",
    "Model": "Newsday_A2"
  },
  {
    "Retail Branding": "Newsday",
    "Marketing Name": "E1",
    "Device": "Newsday_E1",
    "Model": "Newsday_E1"
  },
  {
    "Retail Branding": "Newsday",
    "Marketing Name": "Newsday_N2+",
    "Device": "Newsday_N2_",
    "Model": "Newsday_N2+"
  },
  {
    "Retail Branding": "Newsday",
    "Marketing Name": "U5",
    "Device": "GIGI_U5",
    "Model": "U5"
  },
  {
    "Retail Branding": "Nexall",
    "Marketing Name": "N90_EEA",
    "Device": "N90",
    "Model": "N90"
  },
  {
    "Retail Branding": "Nexall",
    "Marketing Name": "N90_NEU",
    "Device": "N90",
    "Model": "N90"
  },
  {
    "Retail Branding": "Nexel",
    "Marketing Name": "Infinity",
    "Device": "Infinity",
    "Model": "Infinity"
  },
  {
    "Retail Branding": "Nexian",
    "Marketing Name": "journey one",
    "Device": "Mi438S_sprout",
    "Model": "Mi438S"
  },
  {
    "Retail Branding": "Next",
    "Marketing Name": "4K TV Stick",
    "Device": "YYT",
    "Model": "4K Google TV Stick"
  },
  {
    "Retail Branding": "Next",
    "Marketing Name": "NEXT",
    "Device": "elliniko",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "Next",
    "Marketing Name": "NEXT",
    "Device": "stanford",
    "Model": "2K SMART TV"
  },
  {
    "Retail Branding": "Next",
    "Marketing Name": "NEXT",
    "Device": "zhongshan",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "Next",
    "Marketing Name": "STARTPRO",
    "Device": "RMQ",
    "Model": "UHD Google TV STB"
  },
  {
    "Retail Branding": "Next",
    "Marketing Name": "Start-4K",
    "Device": "YDA",
    "Model": "4K Google TV Box"
  },
  {
    "Retail Branding": "Next Learning",
    "Marketing Name": "Nexttab N3",
    "Device": "N3",
    "Model": "N3"
  },
  {
    "Retail Branding": "Next Technologies",
    "Marketing Name": "GO7BSC",
    "Device": "GO7BSC",
    "Model": "GO7BSC"
  },
  {
    "Retail Branding": "Next Technologies",
    "Marketing Name": "N7526",
    "Device": "N7526",
    "Model": "N7526"
  },
  {
    "Retail Branding": "Next-G",
    "Marketing Name": "NEXT-G",
    "Device": "elliniko",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "Next-G",
    "Marketing Name": "NEXT-G",
    "Device": "jagalchi",
    "Model": "2K SMART TV"
  },
  {
    "Retail Branding": "Next-G",
    "Marketing Name": "NEXT_G",
    "Device": "stanford",
    "Model": "2K SMART TV"
  },
  {
    "Retail Branding": "Next-G",
    "Marketing Name": "NEXT_G",
    "Device": "zhongshan",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "Nexta",
    "Marketing Name": "Smart_Study_1",
    "Device": "Smart_Study_1",
    "Model": "Smart_Study_1"
  },
  {
    "Retail Branding": "Nexta",
    "Marketing Name": "Smart_Study_2",
    "Device": "Smart_Study_2",
    "Model": "Smart_Study_2"
  },
  {
    "Retail Branding": "Nextbase",
    "Marketing Name": "GoPlayer",
    "Device": "NBCGGP01",
    "Model": "NBCGGP01"
  },
  {
    "Retail Branding": "Nextbit",
    "Marketing Name": "Robin",
    "Device": "ether",
    "Model": "Robin"
  },
  {
    "Retail Branding": "Nextbook",
    "Marketing Name": "BRT81",
    "Device": "BRT81",
    "Model": "BRT81"
  },
  {
    "Retail Branding": "Nextbook",
    "Marketing Name": "M-MP7NB3G",
    "Device": "7_Plus_HD3G",
    "Model": "M-MP7NB3G"
  },
  {
    "Retail Branding": "Nextbook",
    "Marketing Name": "N11A",
    "Device": "N11A",
    "Model": "N11A"
  },
  {
    "Retail Branding": "Nextbook",
    "Marketing Name": "NX16A10132S",
    "Device": "NX16A10132S",
    "Model": "NX16A10132S"
  },
  {
    "Retail Branding": "Nextbook",
    "Marketing Name": "NX16A10132SPS",
    "Device": "NX16A10132SPS",
    "Model": "NX16A10132SPS"
  },
  {
    "Retail Branding": "Nextbook",
    "Marketing Name": "NX16A11264",
    "Device": "NX16A11264",
    "Model": "NX16A11264"
  },
  {
    "Retail Branding": "Nextbook",
    "Marketing Name": "NX16A8116K",
    "Device": "NX16A8116K",
    "Model": "NX16A8116K"
  },
  {
    "Retail Branding": "Nextbook",
    "Marketing Name": "NX16A8116KP",
    "Device": "NX16A8116KP",
    "Model": "NX16A8116KP"
  },
  {
    "Retail Branding": "Nextbook",
    "Marketing Name": "NX700QC",
    "Device": "nxm7100lvd_wm",
    "Model": "NX700QC"
  },
  {
    "Retail Branding": "Nextbook",
    "Marketing Name": "NX785QC",
    "Device": "nxm865lvd_wm",
    "Model": "NX785QC"
  },
  {
    "Retail Branding": "Nextbook",
    "Marketing Name": "NX785QC8G",
    "Device": "NXM865FD",
    "Model": "NX785QC8G"
  },
  {
    "Retail Branding": "Nextbook",
    "Marketing Name": "NXA101LTE116",
    "Device": "NXA101LTE116",
    "Model": "NXA101LTE116"
  },
  {
    "Retail Branding": "Nextbook",
    "Marketing Name": "NXA116QC164",
    "Device": "NXA116QC164",
    "Model": "NXA116QC164"
  },
  {
    "Retail Branding": "Nextbook",
    "Marketing Name": "NXA8LTE116",
    "Device": "NXA8LTE116",
    "Model": "NXA8LTE116"
  },
  {
    "Retail Branding": "Nextbook",
    "Marketing Name": "NXA8QC116",
    "Device": "NXA8QC116",
    "Model": "NXA8QC116"
  },
  {
    "Retail Branding": "Nextel",
    "Marketing Name": "V.35",
    "Device": "up11_vsn_h1_single",
    "Model": "Nextel V.35"
  },
  {
    "Retail Branding": "Nextel",
    "Marketing Name": "V.45",
    "Device": "H26-VSN",
    "Model": "NII Nextel"
  },
  {
    "Retail Branding": "Nextel",
    "Marketing Name": "V.45",
    "Device": "H26-VSN",
    "Model": "V.45"
  },
  {
    "Retail Branding": "Nextgear",
    "Marketing Name": "Nextgear n1",
    "Device": "Nextgear_n1",
    "Model": "Nextgear n1"
  },
  {
    "Retail Branding": "Nextlife",
    "Marketing Name": "T8metal",
    "Device": "T8metal",
    "Model": "T8metal"
  },
  {
    "Retail Branding": "Nexvoo",
    "Marketing Name": "NexFone N380",
    "Device": "N380",
    "Model": "N380"
  },
  {
    "Retail Branding": "Nexvoo",
    "Marketing Name": "NexFone N380",
    "Device": "N380_EEA",
    "Model": "N380_EEA"
  },
  {
    "Retail Branding": "Nikkei",
    "Marketing Name": "Android TV",
    "Device": "longshan",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "Nikkei",
    "Marketing Name": "Android TV",
    "Device": "redwood",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "Nikkei",
    "Marketing Name": "NI32HG7NA9",
    "Device": "ikebukuro",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "Nikkei",
    "Marketing Name": "NI43UG7NA9",
    "Device": "samseong",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "Nikkei",
    "Marketing Name": "R3",
    "Device": "R3",
    "Model": "R3"
  },
  {
    "Retail Branding": "Nikkei",
    "Marketing Name": "R4",
    "Device": "R4",
    "Model": "R4"
  },
  {
    "Retail Branding": "Nikkei",
    "Marketing Name": "Smart TV",
    "Device": "osaka",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "Nikon",
    "Marketing Name": "COOLPIX",
    "Device": "S800c",
    "Model": "COOLPIX S800c"
  },
  {
    "Retail Branding": "Nikon",
    "Marketing Name": "COOLPIX S810c",
    "Device": "s810c",
    "Model": "COOLPIX S810c"
  },
  {
    "Retail Branding": "Niotek",
    "Marketing Name": "AxxNE",
    "Device": "rk3588_t",
    "Model": "AxxNE"
  },
  {
    "Retail Branding": "Nissan",
    "Marketing Name": "NissanConnect",
    "Device": "aivi2_b",
    "Model": "AIVI2 B"
  },
  {
    "Retail Branding": "Nissan",
    "Marketing Name": "NissanConnect",
    "Device": "aivi2_n_full",
    "Model": "AIVI2_N_FULL"
  },
  {
    "Retail Branding": "Nixon",
    "Marketing Name": "The Mission",
    "Device": "sculpin",
    "Model": "The Mission"
  },
  {
    "Retail Branding": "Njoy",
    "Marketing Name": "Arcas 7",
    "Device": "Arcas_7",
    "Model": "nJoy_Arcas_7"
  },
  {
    "Retail Branding": "Njoy",
    "Marketing Name": "Chronos 10",
    "Device": "Chronos_10",
    "Model": "Chronos_10"
  },
  {
    "Retail Branding": "Njoy",
    "Marketing Name": "Deimos 7",
    "Device": "SYTB_7QAFY0B_CC01B",
    "Model": "Deimos 7"
  },
  {
    "Retail Branding": "Njoy",
    "Marketing Name": "Kali 8",
    "Device": "Kali_8",
    "Model": "Kali_8"
  },
  {
    "Retail Branding": "Njoy",
    "Marketing Name": "Tityos 10",
    "Device": "Tityos_10",
    "Model": "nJoy_Tityos_10"
  },
  {
    "Retail Branding": "Njoy",
    "Marketing Name": "Turnus 8",
    "Device": "Turnus_8",
    "Model": "nJoy_Turnus_8"
  },
  {
    "Retail Branding": "Njoy",
    "Marketing Name": "nJoy Theia 10",
    "Device": "nJoy_Theia_10",
    "Model": "Theia_10"
  },
  {
    "Retail Branding": "Nobby",
    "Marketing Name": "A200",
    "Device": "A200",
    "Model": "A200"
  },
  {
    "Retail Branding": "Nobby",
    "Marketing Name": "S300",
    "Device": "Nobby_S300",
    "Model": "Nobby S300"
  },
  {
    "Retail Branding": "Nobby",
    "Marketing Name": "S300 pro",
    "Device": "Nobby_S300_Pro",
    "Model": "Nobby S300 Pro"
  },
  {
    "Retail Branding": "Nobis",
    "Marketing Name": "NB07",
    "Device": "NB07",
    "Model": "NB07"
  },
  {
    "Retail Branding": "Nobis",
    "Marketing Name": "NB09",
    "Device": "M9025",
    "Model": "NB09"
  },
  {
    "Retail Branding": "Nobis",
    "Marketing Name": "NB1022",
    "Device": "RCT6203W46",
    "Model": "NB1022"
  },
  {
    "Retail Branding": "Nobis",
    "Marketing Name": "NB7022S",
    "Device": "NB7022S",
    "Model": "NB7022S"
  },
  {
    "Retail Branding": "Nobis",
    "Marketing Name": "NB7850S",
    "Device": "NB7850S",
    "Model": "NB7850S"
  },
  {
    "Retail Branding": "NobleSkiodo",
    "Marketing Name": "2K NSTV",
    "Device": "umeda",
    "Model": "2K NSTV"
  },
  {
    "Retail Branding": "NobleSkiodo",
    "Marketing Name": "32VRCHG5SP",
    "Device": "ikebukuro",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "NobleSkiodo",
    "Marketing Name": "43UDVRCHG7H",
    "Device": "samseong",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "NobleSkiodo",
    "Marketing Name": "NS 2K SmartTV",
    "Device": "sunnyvale",
    "Model": "NS 2K SmartTV"
  },
  {
    "Retail Branding": "NobleSkiodo",
    "Marketing Name": "NSTV",
    "Device": "SW6H",
    "Model": "NSTV"
  },
  {
    "Retail Branding": "NobleSkiodo",
    "Marketing Name": "NSTV FF",
    "Device": "SW6H",
    "Model": "NSTV FF"
  },
  {
    "Retail Branding": "NobleSkiodo",
    "Marketing Name": "Noble Skiodo TV",
    "Device": "beomil",
    "Model": "Noble Skiodo TV"
  },
  {
    "Retail Branding": "NobleSkiodo",
    "Marketing Name": "Smart TV",
    "Device": "alimos",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "NobleSkiodo",
    "Marketing Name": "Smart TV",
    "Device": "dangni",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "Noblex",
    "Marketing Name": "4K Smart FF TV",
    "Device": "SW6H",
    "Model": "4K Smart FF TV"
  },
  {
    "Retail Branding": "Noblex",
    "Marketing Name": "4K Smart GMTV",
    "Device": "anaheim",
    "Model": "4K Smart GMTV"
  },
  {
    "Retail Branding": "Noblex",
    "Marketing Name": "A50",
    "Device": "A50UNS",
    "Model": "A50UNS"
  },
  {
    "Retail Branding": "Noblex",
    "Marketing Name": "A60",
    "Device": "A60UNS",
    "Model": "A60UNS"
  },
  {
    "Retail Branding": "Noblex",
    "Marketing Name": "B30",
    "Device": "NOBLEX_B30",
    "Model": "B30"
  },
  {
    "Retail Branding": "Noblex",
    "Marketing Name": "Go Action",
    "Device": "N551",
    "Model": "N551"
  },
  {
    "Retail Branding": "Noblex",
    "Marketing Name": "Go Move",
    "Device": "N552",
    "Model": "N552"
  },
  {
    "Retail Branding": "Noblex",
    "Marketing Name": "Go Street",
    "Device": "N504",
    "Model": "N504"
  },
  {
    "Retail Branding": "Noblex",
    "Marketing Name": "Go Urban",
    "Device": "N503",
    "Model": "N503"
  },
  {
    "Retail Branding": "Noblex",
    "Marketing Name": "LILYPAD",
    "Device": "LILYPAD",
    "Model": "LILYPAD"
  },
  {
    "Retail Branding": "Noblex",
    "Marketing Name": "N52",
    "Device": "NOBLEX_N52",
    "Model": "N52"
  },
  {
    "Retail Branding": "Noblex",
    "Marketing Name": "N54",
    "Device": "NOBLEX_N54",
    "Model": "N54"
  },
  {
    "Retail Branding": "Noblex",
    "Marketing Name": "N601",
    "Device": "N601",
    "Model": "N601"
  },
  {
    "Retail Branding": "Noblex",
    "Marketing Name": "N62",
    "Device": "NOBLEX_N62",
    "Model": "N62"
  },
  {
    "Retail Branding": "Noblex",
    "Marketing Name": "NBX-T1014N",
    "Device": "TA10CA2",
    "Model": "TA10CA2"
  },
  {
    "Retail Branding": "Noblex",
    "Marketing Name": "NBX-T7014",
    "Device": "E270BSA",
    "Model": "NBX-T7014"
  },
  {
    "Retail Branding": "Noblex",
    "Marketing Name": "NOBLEX Smart TV",
    "Device": "sunnyvale",
    "Model": "NOBLEX Smart TV"
  },
  {
    "Retail Branding": "Noblex",
    "Marketing Name": "Noblex TV",
    "Device": "SW4H",
    "Model": "Noblex TV"
  },
  {
    "Retail Branding": "Noblex",
    "Marketing Name": "NoblexTV",
    "Device": "shinjuku",
    "Model": "NoblexTV"
  },
  {
    "Retail Branding": "Noblex",
    "Marketing Name": "R3",
    "Device": "R3",
    "Model": "R3"
  },
  {
    "Retail Branding": "Noblex",
    "Marketing Name": "Smart TV",
    "Device": "umeda",
    "Model": "Smart TV"
  },
  {
    "Retail Branding": "Noblex",
    "Marketing Name": "Smart TV 4K",
    "Device": "SW6H",
    "Model": "Smart TV 4K"
  },
  {
    "Retail Branding": "Noblex",
    "Marketing Name": "T7A6INC",
    "Device": "T7A6INC",
    "Model": "T7A6INC"
  },
  {
    "Retail Branding": "Noblex",
    "Marketing Name": "T7A6N",
    "Device": "Tablet",
    "Model": "T7A6N"
  },
  {
    "Retail Branding": "Noblex",
    "Marketing Name": "TN11A6128",
    "Device": "TN11A6128",
    "Model": "MXCORE"
  },
  {
    "Retail Branding": "Noblex",
    "Marketing Name": "TN11A6128",
    "Device": "TN11A6128",
    "Model": "TN11A6128"
  },
  {
    "Retail Branding": "Noblex",
    "Marketing Name": "X7500",
    "Device": "songshan",
    "Model": "SmartTV 4K"
  },
  {
    "Retail Branding": "Noblex",
    "Marketing Name": "X9500",
    "Device": "songshan",
    "Model": "SmartTV 4K FFM"
  },
  {
    "Retail Branding": "Nobrand",
    "Marketing Name": "Nobrand",
    "Device": "stanford",
    "Model": "Smart FHD TV"
  },
  {
    "Retail Branding": "Nodizz",
    "Marketing Name": "Npad99",
    "Device": "Npad99",
    "Model": "Npad99"
  },
  {
    "Retail Branding": "Noel",
    "Marketing Name": "MBW100",
    "Device": "MBW100",
    "Model": "MBW100"
  },
  {
    "Retail Branding": "Nokia",
    "Marketing Name": "4K Smart TV",
    "Device": "pioneer",
    "Model": "4K PA Smart TV"
  },
  {
    "Retail Branding": "Nokia",
    "Marketing Name": "Android TV",
    "Device": "R1",
    "Model": "ATV R1"
  },
  {
    "Retail Branding": "Nokia",
    "Marketing Name": "Android TV",
    "Device": "R2",
    "Model": "ATV R2"
  },
  {
    "Retail Branding": "Nokia",
    "Marketing Name": "DVN2KA01",
    "Device": "DV6068H_Nokia",
    "Model": "DVN2KA01"
  },
  {
    "Retail Branding": "Nokia",
    "Marketing Name": "N1",
    "Device": "Nokia_N1",
    "Model": "N1"
  },
  {
    "Retail Branding": "Nokia",
    "Marketing Name": "Nokia 1",
    "Device": "FRT",
    "Model": "Nokia 1"
  },
  {
    "Retail Branding": "Nokia",
    "Marketing Name": "Nokia 1 Plus",
    "Device": "ANT",
    "Model": "Nokia 1 Plus"
  },
  {
    "Retail Branding": "Nokia",
    "Marketing Name": "Nokia 1.3",
    "Device": "DRX",
    "Model": "Nokia 1.3"
  },
  {
    "Retail Branding": "Nokia",
    "Marketing Name": "Nokia 1.4",
    "Device": "CBL",
    "Model": "Cable"
  },
  {
    "Retail Branding": "Nokia",
    "Marketing Name": "Nokia 1.4",
    "Device": "CBL",
    "Model": "Nokia 1.4"
  },
  {
    "Retail Branding": "Nokia",
    "Marketing Name": "Nokia 2",
    "Device": "E1M",
    "Model": "Nokia 2"
  },
  {
    "Retail Branding": "Nokia",
    "Marketing Name": "Nokia 2 V",
    "Device": "EVW",
    "Model": "Nokia 2 V"
  },
  {
    "Retail Branding": "Nokia",
    "Marketing Name": "Nokia 2 V Tella",
    "Device": "ARV_VZW",
    "Model": "Nokia 2 V Tella"
  },
  {
    "Retail Branding": "Nokia",
    "Marketing Name": "Nokia 2.1",
    "Device": "E2M",
    "Model": "Nokia 2.1"
  },
  {
    "Retail Branding": "Nokia",
    "Marketing Name": "Nokia 2.2",
    "Device": "WSP_sprout",
    "Model": "Nokia 2.2"
  },
  {
    "Retail Branding": "Nokia",
    "Marketing Name": "Nokia 2.3",
    "Device": "IRM_sprout",
    "Model": "Nokia 2.3"
  },
  {
    "Retail Branding": "Nokia",
    "Marketing Name": "Nokia 2.4",
    "Device": "WVR",
    "Model": "Nokia 2.4"
  },
  {
    "Retail Branding": "Nokia",
    "Marketing Name": "Nokia 2.4",
    "Device": "WVR_sprout",
    "Model": "Nokia 2.4"
  },
  {
    "Retail Branding": "Nokia",
    "Marketing Name": "Nokia 3",
    "Device": "NE1",
    "Model": "TA-1020"
  },
  {
    "Retail Branding": "Nokia",
    "Marketing Name": "Nokia 3",
    "Device": "NE1",
    "Model": "TA-1028"
  },
  {
    "Retail Branding": "Nokia",
    "Marketing Name": "Nokia 3",
    "Device": "NE1",
    "Model": "TA-1032"
  },
  {
    "Retail Branding": "Nokia",
    "Marketing Name": "Nokia 3",
    "Device": "NE1",
    "Model": "TA-1038"
  },
  {
    "Retail Branding": "Nokia",
    "Marketing Name": "Nokia 3 V",
    "Device": "DPL_VZW",
    "Model": "Nokia 3 V"
  },
  {
    "Retail Branding": "Nokia",
    "Marketing Name": "Nokia 3.1",
    "Device": "ES2N_sprout",
    "Model": "Nokia 3.1"
  },
  {
    "Retail Branding": "Nokia",
    "Marketing Name": "Nokia 3.1",
    "Device": "ES2_sprout",
    "Model": "Nokia 3.1"
  },
  {
    "Retail Branding": "Nokia",
    "Marketing Name": "Nokia 3.1 A",
    "Device": "EAG",
    "Model": "Nokia 3.1 A"
  },
  {
    "Retail Branding": "Nokia",
    "Marketing Name": "Nokia 3.1 C",
    "Device": "EAG",
    "Model": "Nokia 3.1 C"
  },
  {
    "Retail Branding": "Nokia",
    "Marketing Name": "Nokia 3.1 Plus",
    "Device": "RHD",
    "Model": "Nokia 3.1 Plus"
  },
  {
    "Retail Branding": "Nokia",
    "Marketing Name": "Nokia 3.1 Plus",
    "Device": "ROO",
    "Model": "Nokia 3.1 Plus"
  },
  {
    "Retail Branding": "Nokia",
    "Marketing Name": "Nokia 3.1 Plus",
    "Device": "ROON_sprout",
    "Model": "Nokia 3.1 Plus"
  },
  {
    "Retail Branding": "Nokia",
    "Marketing Name": "Nokia 3.1 Plus",
    "Device": "ROO_sprout",
    "Model": "Nokia 3.1 Plus"
  },
  {
    "Retail Branding": "Nokia",
    "Marketing Name": "Nokia 3.2",
    "Device": "DPL_sprout",
    "Model": "Nokia 3.2"
  },
  {
    "Retail Branding": "Nokia",
    "Marketing Name": "Nokia 3.4",
    "Device": "DRS",
    "Model": "Nokia 3.4"
  },
  {
    "Retail Branding": "Nokia",
    "Marketing Name": "Nokia 3.4",
    "Device": "DRSA_sprout",
    "Model": "Nokia 3.4"
  },
  {
    "Retail Branding": "Nokia",
    "Marketing Name": "Nokia 3.4",
    "Device": "DRS_sprout",
    "Model": "Nokia 3.4"
  },
  {
    "Retail Branding": "Nokia",
    "Marketing Name": "Nokia 4.2",
    "Device": "PAN_sprout",
    "Model": "Nokia 4.2"
  },
  {
    "Retail Branding": "Nokia",
    "Marketing Name": "Nokia 4.2",
    "Device": "Panther_00EEE",
    "Model": "Nokia 4.2"
  },
  {
    "Retail Branding": "Nokia",
    "Marketing Name": "Nokia 5",
    "Device": "ND1",
    "Model": "TA-1024"
  },
  {
    "Retail Branding": "Nokia",
    "Marketing Name": "Nokia 5",
    "Device": "ND1",
    "Model": "TA-1027"
  },
  {
    "Retail Branding": "Nokia",
    "Marketing Name": "Nokia 5",
    "Device": "ND1",
    "Model": "TA-1044"
  },
  {
    "Retail Branding": "Nokia",
    "Marketing Name": "Nokia 5",
    "Device": "ND1",
    "Model": "TA-1053"
  },
  {
    "Retail Branding": "Nokia",
    "Marketing Name": "Nokia 5.1",
    "Device": "CO2N_sprout",
    "Model": "Nokia 5.1"
  },
  {
    "Retail Branding": "Nokia",
    "Marketing Name": "Nokia 5.1",
    "Device": "CO2_sprout",
    "Model": "Nokia 5.1"
  },
  {
    "Retail Branding": "Nokia",
    "Marketing Name": "Nokia 5.1 Plus",
    "Device": "PDA_sprout",
    "Model": "Nokia 5.1 Plus"
  },
  {
    "Retail Branding": "Nokia",
    "Marketing Name": "Nokia 5.3",
    "Device": "CAP",
    "Model": "Nokia 5.3"
  },
  {
    "Retail Branding": "Nokia",
    "Marketing Name": "Nokia 5.3",
    "Device": "CAP_sprout",
    "Model": "Nokia 5.3"
  },
  {
    "Retail Branding": "Nokia",
    "Marketing Name": "Nokia 5.4",
    "Device": "DRD",
    "Model": "Nokia 5.4"
  },
  {
    "Retail Branding": "Nokia",
    "Marketing Name": "Nokia 5.4",
    "Device": "DRDA_sprout",
    "Model": "Nokia 5.4"
  },
  {
    "Retail Branding": "Nokia",
    "Marketing Name": "Nokia 5.4",
    "Device": "DRD_sprout",
    "Model": "Nokia 5.4"
  },
  {
    "Retail Branding": "Nokia",
    "Marketing Name": "Nokia 6",
    "Device": "D1C",
    "Model": "TA-1000"
  },
  {
    "Retail Branding": "Nokia",
    "Marketing Name": "Nokia 6",
    "Device": "D1C",
    "Model": "TA-1003"
  },
  {
    "Retail Branding": "Nokia",
    "Marketing Name": "Nokia 6",
    "Device": "PL2",
    "Model": "TA-1054"
  },
  {
    "Retail Branding": "Nokia",
    "Marketing Name": "Nokia 6",
    "Device": "PLE",
    "Model": "TA-1021"
  },
  {
    "Retail Branding": "Nokia",
    "Marketing Name": "Nokia 6",
    "Device": "PLE",
    "Model": "TA-1025"
  },
  {
    "Retail Branding": "Nokia",
    "Marketing Name": "Nokia 6",
    "Device": "PLE",
    "Model": "TA-1033"
  },
  {
    "Retail Branding": "Nokia",
    "Marketing Name": "Nokia 6",
    "Device": "PLE",
    "Model": "TA-1039"
  },
  {
    "Retail Branding": "Nokia",
    "Marketing Name": "Nokia 6.1",
    "Device": "PL2",
    "Model": "Nokia 6.1"
  },
  {
    "Retail Branding": "Nokia",
    "Marketing Name": "Nokia 6.1",
    "Device": "PL2_sprout",
    "Model": "Nokia 6.1"
  },
  {
    "Retail Branding": "Nokia",
    "Marketing Name": "Nokia 6.1 Plus",
    "Device": "DRG_sprout",
    "Model": "Nokia 6.1 Plus"
  },
  {
    "Retail Branding": "Nokia",
    "Marketing Name": "Nokia 6.2",
    "Device": "SLDA_sprout",
    "Model": "Nokia 6.2"
  },
  {
    "Retail Branding": "Nokia",
    "Marketing Name": "Nokia 6.2",
    "Device": "SLD_sprout",
    "Model": "Nokia 6.2"
  },
  {
    "Retail Branding": "Nokia",
    "Marketing Name": "Nokia 7",
    "Device": "C1N",
    "Model": "TA-1041"
  },
  {
    "Retail Branding": "Nokia",
    "Marketing Name": "Nokia 7 plus",
    "Device": "B2N",
    "Model": "Nokia 7 plus"
  },
  {
    "Retail Branding": "Nokia",
    "Marketing Name": "Nokia 7 plus",
    "Device": "B2N_sprout",
    "Model": "Nokia 7 plus"
  },
  {
    "Retail Branding": "Nokia",
    "Marketing Name": "Nokia 7.1",
    "Device": "CTL_sprout",
    "Model": "Nokia 7.1"
  },
  {
    "Retail Branding": "Nokia",
    "Marketing Name": "Nokia 7.2",
    "Device": "DDVA_sprout",
    "Model": "Nokia 7.2"
  },
  {
    "Retail Branding": "Nokia",
    "Marketing Name": "Nokia 7.2",
    "Device": "DDV_sprout",
    "Model": "Nokia 7.2"
  },
  {
    "Retail Branding": "Nokia",
    "Marketing Name": "Nokia 8",
    "Device": "NB1",
    "Model": "TA-1004"
  },
  {
    "Retail Branding": "Nokia",
    "Marketing Name": "Nokia 8",
    "Device": "NB1",
    "Model": "TA-1012"
  },
  {
    "Retail Branding": "Nokia",
    "Marketing Name": "Nokia 8",
    "Device": "NB1",
    "Model": "TA-1052"
  },
  {
    "Retail Branding": "Nokia",
    "Marketing Name": "Nokia 8 Sirocco",
    "Device": "A1N",
    "Model": "Nokia 8 Sirocco"
  },
  {
    "Retail Branding": "Nokia",
    "Marketing Name": "Nokia 8 Sirocco",
    "Device": "A1N_sprout",
    "Model": "Nokia 8 Sirocco"
  },
  {
    "Retail Branding": "Nokia",
    "Marketing Name": "Nokia 8 V 5G UW",
    "Device": "RAV_VZW",
    "Model": "Nokia 8 V 5G UW"
  },
  {
    "Retail Branding": "Nokia",
    "Marketing Name": "Nokia 8.1",
    "Device": "PNXN",
    "Model": "Nokia 8.1"
  },
  {
    "Retail Branding": "Nokia",
    "Marketing Name": "Nokia 8.1",
    "Device": "PNX_sprout",
    "Model": "Nokia 8.1"
  },
  {
    "Retail Branding": "Nokia",
    "Marketing Name": "Nokia 8.3 5G",
    "Device": "BGT",
    "Model": "Nokia 8.3 5G"
  },
  {
    "Retail Branding": "Nokia",
    "Marketing Name": "Nokia 8.3 5G",
    "Device": "BGT_sprout",
    "Model": "Nokia 8.3 5G"
  },
  {
    "Retail Branding": "Nokia",
    "Marketing Name": "Nokia 9",
    "Device": "AOP",
    "Model": "Nokia 9"
  },
  {
    "Retail Branding": "Nokia",
    "Marketing Name": "Nokia 9",
    "Device": "AOP_sprout",
    "Model": "Nokia 9"
  },
  {
    "Retail Branding": "Nokia",
    "Marketing Name": "Nokia C01 Plus",
    "Device": "IRS",
    "Model": "Nokia C01 Plus"
  },
  {
    "Retail Branding": "Nokia",
    "Marketing Name": "Nokia C02",
    "Device": "CYR",
    "Model": "Cypher"
  },
  {
    "Retail Branding": "Nokia",
    "Marketing Name": "Nokia C02",
    "Device": "CYR",
    "Model": "Nokia C02"
  },
  {
    "Retail Branding": "Nokia",
    "Marketing Name": "Nokia C1",
    "Device": "RKU",
    "Model": "Nokia C1"
  },
  {
    "Retail Branding": "Nokia",
    "Marketing Name": "Nokia C1 2nd Edition",
    "Device": "IRU",
    "Model": "Nokia C1 2nd Edition"
  },
  {
    "Retail Branding": "Nokia",
    "Marketing Name": "Nokia C1 Plus",
    "Device": "YDU",
    "Model": "Nokia C1 Plus"
  },
  {
    "Retail Branding": "Nokia",
    "Marketing Name": "Nokia C10",
    "Device": "MNT",
    "Model": "Nokia C10"
  },
  {
    "Retail Branding": "Nokia",
    "Marketing Name": "Nokia C100",
    "Device": "DKT",
    "Model": "N152DL"
  },
  {
    "Retail Branding": "Nokia",
    "Marketing Name": "Nokia C100",
    "Device": "DKT",
    "Model": "Nokia C100"
  },
  {
    "Retail Branding": "Nokia",
    "Marketing Name": "Nokia C110",
    "Device": "DGC",
    "Model": "Nokia C110"
  },
  {
    "Retail Branding": "Nokia",
    "Marketing Name": "Nokia C110",
    "Device": "DGF",
    "Model": "N156DL"
  },
  {
    "Retail Branding": "Nokia",
    "Marketing Name": "Nokia C12",
    "Device": "NVA",
    "Model": "Nokia C12"
  },
  {
    "Retail Branding": "Nokia",
    "Marketing Name": "Nokia C12 Pro",
    "Device": "NVA",
    "Model": "Nokia C12 Plus"
  },
  {
    "Retail Branding": "Nokia",
    "Marketing Name": "Nokia C12 Pro",
    "Device": "NVA",
    "Model": "Nokia C12 Pro"
  },
  {
    "Retail Branding": "Nokia",
    "Marketing Name": "Nokia C2",
    "Device": "NBL",
    "Model": "Nebula"
  },
  {
    "Retail Branding": "Nokia",
    "Marketing Name": "Nokia C2",
    "Device": "NBL",
    "Model": "Nokia C2"
  },
  {
    "Retail Branding": "Nokia",
    "Marketing Name": "Nokia C2 2nd Edition",
    "Device": "DMN",
    "Model": "Nokia C2 2nd Edition"
  },
  {
    "Retail Branding": "Nokia",
    "Marketing Name": "Nokia C2 Tennen",
    "Device": "ARV_CUS",
    "Model": "Nokia C2 Tennen"
  },
  {
    "Retail Branding": "Nokia",
    "Marketing Name": "Nokia C20",
    "Device": "COS",
    "Model": "Nokia C20"
  },
  {
    "Retail Branding": "Nokia",
    "Marketing Name": "Nokia C20 Plus",
    "Device": "SUS",
    "Model": "Nokia C20 Plus"
  },
  {
    "Retail Branding": "Nokia",
    "Marketing Name": "Nokia C200",
    "Device": "DRK",
    "Model": "N151DL"
  },
  {
    "Retail Branding": "Nokia",
    "Marketing Name": "Nokia C200",
    "Device": "DRK",
    "Model": "Nokia C200"
  },
  {
    "Retail Branding": "Nokia",
    "Marketing Name": "Nokia C21",
    "Device": "COR",
    "Model": "Nokia C21"
  },
  {
    "Retail Branding": "Nokia",
    "Marketing Name": "Nokia C21 Plus",
    "Device": "HPE",
    "Model": "Hope"
  },
  {
    "Retail Branding": "Nokia",
    "Marketing Name": "Nokia C21 Plus",
    "Device": "HPE",
    "Model": "Nokia C21 Plus"
  },
  {
    "Retail Branding": "Nokia",
    "Marketing Name": "Nokia C210",
    "Device": "RVOA",
    "Model": "Nokia C210"
  },
  {
    "Retail Branding": "Nokia",
    "Marketing Name": "Nokia C210",
    "Device": "RVTA",
    "Model": "Nokia C210"
  },
  {
    "Retail Branding": "Nokia",
    "Marketing Name": "Nokia C22",
    "Device": "HKEA",
    "Model": "Nokia C22"
  },
  {
    "Retail Branding": "Nokia",
    "Marketing Name": "Nokia C3",
    "Device": "GMR",
    "Model": "Nokia C3"
  },
  {
    "Retail Branding": "Nokia",
    "Marketing Name": "Nokia C30",
    "Device": "MNI",
    "Model": "Nokia C30"
  },
  {
    "Retail Branding": "Nokia",
    "Marketing Name": "Nokia C30",
    "Device": "MNR",
    "Model": "Nokia C30"
  },
  {
    "Retail Branding": "Nokia",
    "Marketing Name": "Nokia C300",
    "Device": "ORO",
    "Model": "Nokia C300"
  },
  {
    "Retail Branding": "Nokia",
    "Marketing Name": "Nokia C300",
    "Device": "ORT",
    "Model": "N155DL"
  },
  {
    "Retail Branding": "Nokia",
    "Marketing Name": "Nokia C31",
    "Device": "VSI",
    "Model": "Nokia C31"
  },
  {
    "Retail Branding": "Nokia",
    "Marketing Name": "Nokia C32",
    "Device": "MKDA",
    "Model": "Nokia C32"
  },
  {
    "Retail Branding": "Nokia",
    "Marketing Name": "Nokia C5 Endi",
    "Device": "PMC_CUS",
    "Model": "Nokia C5 Endi"
  },
  {
    "Retail Branding": "Nokia",
    "Marketing Name": "Nokia G10",
    "Device": "ROGA",
    "Model": "Nokia G10"
  },
  {
    "Retail Branding": "Nokia",
    "Marketing Name": "Nokia G10",
    "Device": "ROGA_sprout",
    "Model": "Nokia G10"
  },
  {
    "Retail Branding": "Nokia",
    "Marketing Name": "Nokia G100",
    "Device": "DPT",
    "Model": "N150DL"
  },
  {
    "Retail Branding": "Nokia",
    "Marketing Name": "Nokia G100",
    "Device": "DPT",
    "Model": "Nokia G100"
  },
  {
    "Retail Branding": "Nokia",
    "Marketing Name": "Nokia G11",
    "Device": "SCTA_sprout",
    "Model": "Nokia G11"
  },
  {
    "Retail Branding": "Nokia",
    "Marketing Name": "Nokia G11",
    "Device": "SCT_sprout",
    "Model": "Nokia G11"
  },
  {
    "Retail Branding": "Nokia",
    "Marketing Name": "Nokia G11 Plus",
    "Device": "MGKA",
    "Model": "Nokia G11 Plus"
  },
  {
    "Retail Branding": "Nokia",
    "Marketing Name": "Nokia G11 Plus",
    "Device": "MGKA_sprout",
    "Model": "Nokia G11 Plus"
  },
  {
    "Retail Branding": "Nokia",
    "Marketing Name": "Nokia G20",
    "Device": "RNN",
    "Model": "Nokia G20"
  },
  {
    "Retail Branding": "Nokia",
    "Marketing Name": "Nokia G20",
    "Device": "RNNA_sprout",
    "Model": "Nokia G20"
  },
  {
    "Retail Branding": "Nokia",
    "Marketing Name": "Nokia G20",
    "Device": "RNN_sprout",
    "Model": "Nokia G20"
  },
  {
    "Retail Branding": "Nokia",
    "Marketing Name": "Nokia G21",
    "Device": "SCP",
    "Model": "Nokia G21"
  },
  {
    "Retail Branding": "Nokia",
    "Marketing Name": "Nokia G21",
    "Device": "SCPA_sprout",
    "Model": "Nokia G21"
  },
  {
    "Retail Branding": "Nokia",
    "Marketing Name": "Nokia G21",
    "Device": "SCP_sprout",
    "Model": "Nokia G21"
  },
  {
    "Retail Branding": "Nokia",
    "Marketing Name": "Nokia G22",
    "Device": "SFI",
    "Model": "Nokia G22"
  },
  {
    "Retail Branding": "Nokia",
    "Marketing Name": "Nokia G22",
    "Device": "SFIA",
    "Model": "Nokia G22"
  },
  {
    "Retail Branding": "Nokia",
    "Marketing Name": "Nokia G300",
    "Device": "AKT",
    "Model": "N1374DL"
  },
  {
    "Retail Branding": "Nokia",
    "Marketing Name": "Nokia G310 5G",
    "Device": "SDT",
    "Model": "Nokia G310 5G"
  },
  {
    "Retail Branding": "Nokia",
    "Marketing Name": "Nokia G400 5G",
    "Device": "STM",
    "Model": "Nokia G400 5G"
  },
  {
    "Retail Branding": "Nokia",
    "Marketing Name": "Nokia G400 5G",
    "Device": "STO",
    "Model": "Nokia G400 5G"
  },
  {
    "Retail Branding": "Nokia",
    "Marketing Name": "Nokia G42 5G",
    "Device": "SDW",
    "Model": "Nokia G42 5G"
  },
  {
    "Retail Branding": "Nokia",
    "Marketing Name": "Nokia G42 5G",
    "Device": "SDWA",
    "Model": "Nokia G42 5G"
  },
  {
    "Retail Branding": "Nokia",
    "Marketing Name": "Nokia G50",
    "Device": "PHR",
    "Model": "Nokia G50"
  },
  {
    "Retail Branding": "Nokia",
    "Marketing Name": "Nokia G50",
    "Device": "PHR_sprout",
    "Model": "Nokia G50"
  },
  {
    "Retail Branding": "Nokia",
    "Marketing Name": "Nokia G60 5G",
    "Device": "APO_sprout",
    "Model": "Nokia G60 5G"
  },
  {
    "Retail Branding": "Nokia",
    "Marketing Name": "Nokia Steaming Box 8000",
    "Device": "HND",
    "Model": "Nokia Streaming Box 8000"
  },
  {
    "Retail Branding": "Nokia",
    "Marketing Name": "Nokia Streaming Box 8010",
    "Device": "YYJ",
    "Model": "Nokia Streaming Box 8010"
  },
  {
    "Retail Branding": "Nokia",
    "Marketing Name": "Nokia Streaming Stick 800",
    "Device": "IAD",
    "Model": "Nokia Streaming Stick 800"
  },
  {
    "Retail Branding": "Nokia",
    "Marketing Name": "Nokia T10",
    "Device": "PGN",
    "Model": "Nokia T10"
  },
  {
    "Retail Branding": "Nokia",
    "Marketing Name": "Nokia T20",
    "Device": "RDD",
    "Model": "Nokia T20"
  },
  {
    "Retail Branding": "Nokia",
    "Marketing Name": "Nokia T20",
    "Device": "RDDCN",
    "Model": "Nokia T20"
  },
  {
    "Retail Branding": "Nokia",
    "Marketing Name": "Nokia T21",
    "Device": "AGT",
    "Model": "Nokia T21"
  },
  {
    "Retail Branding": "Nokia",
    "Marketing Name": "Nokia T21",
    "Device": "AGTA",
    "Model": "Nokia T21"
  },
  {
    "Retail Branding": "Nokia",
    "Marketing Name": "Nokia TV",
    "Device": "marina",
    "Model": "Nokia TV"
  },
  {
    "Retail Branding": "Nokia",
    "Marketing Name": "Nokia TV",
    "Device": "nagata",
    "Model": "Nokia TV"
  },
  {
    "Retail Branding": "Nokia",
    "Marketing Name": "Nokia X10",
    "Device": "SCW",
    "Model": "Nokia X10"
  },
  {
    "Retail Branding": "Nokia",
    "Marketing Name": "Nokia X10",
    "Device": "SCW_sprout",
    "Model": "Nokia X10"
  },
  {
    "Retail Branding": "Nokia",
    "Marketing Name": "Nokia X100",
    "Device": "DM5",
    "Model": "Nokia X100"
  },
  {
    "Retail Branding": "Nokia",
    "Marketing Name": "Nokia X20",
    "Device": "QKS",
    "Model": "Nokia X20"
  },
  {
    "Retail Branding": "Nokia",
    "Marketing Name": "Nokia X20",
    "Device": "QKS_sprout",
    "Model": "Nokia X20"
  },
  {
    "Retail Branding": "Nokia",
    "Marketing Name": "Nokia X30 5G",
    "Device": "FCN_sprout",
    "Model": "Nokia X30 5G"
  },
  {
    "Retail Branding": "Nokia",
    "Marketing Name": "Nokia X5",
    "Device": "PDA",
    "Model": "Nokia X5"
  },
  {
    "Retail Branding": "Nokia",
    "Marketing Name": "Nokia X6",
    "Device": "DRG",
    "Model": "Nokia X6"
  },
  {
    "Retail Branding": "Nokia",
    "Marketing Name": "Nokia X7",
    "Device": "PNX",
    "Model": "Nokia X7"
  },
  {
    "Retail Branding": "Nokia",
    "Marketing Name": "Nokia X71",
    "Device": "TAS",
    "Model": "Nokia X71"
  },
  {
    "Retail Branding": "Nokia",
    "Marketing Name": "Nokia XR20",
    "Device": "TTG",
    "Model": "Nokia XR20"
  },
  {
    "Retail Branding": "Nokia",
    "Marketing Name": "Nokia XR20",
    "Device": "TTG_sprout",
    "Model": "Nokia XR20"
  },
  {
    "Retail Branding": "Nokia",
    "Marketing Name": "Nokia XR21",
    "Device": "SNT_sprout",
    "Model": "Nokia XR21"
  },
  {
    "Retail Branding": "Nokia",
    "Marketing Name": "R4",
    "Device": "R4",
    "Model": "R4"
  },
  {
    "Retail Branding": "Nokia",
    "Marketing Name": "Smart TV",
    "Device": "longshan",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "Nokia",
    "Marketing Name": "Smart TV",
    "Device": "mateo",
    "Model": "2K PA Smart TV"
  },
  {
    "Retail Branding": "Nokia",
    "Marketing Name": "Smart TV",
    "Device": "redwood",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "Nomi",
    "Marketing Name": "CORSA 3 LTE",
    "Device": "Nomi_C070030",
    "Model": "Nomi_C070030"
  },
  {
    "Retail Branding": "Nomi",
    "Marketing Name": "Corsa 3 3G",
    "Device": "Nomi_C070012",
    "Model": "Nomi_C070012"
  },
  {
    "Retail Branding": "Nomi",
    "Marketing Name": "I5032",
    "Device": "Nomi_i5032",
    "Model": "i5032"
  },
  {
    "Retail Branding": "Nomi",
    "Marketing Name": "Libra3 3G",
    "Device": "Nomi_C080012",
    "Model": "Nomi_C080012"
  },
  {
    "Retail Branding": "Nomi",
    "Marketing Name": "Nomi C070011",
    "Device": "Nomi_C070011",
    "Model": "Nomi C070011"
  },
  {
    "Retail Branding": "Nomi",
    "Marketing Name": "Nomi C080010",
    "Device": "Nomi_C080010_Libra2",
    "Model": "Nomi C080010 Libra2"
  },
  {
    "Retail Branding": "Nomi",
    "Marketing Name": "Nomi C101010",
    "Device": "Nomi_C101010_Ultra2",
    "Model": "C101010 Ultra2"
  },
  {
    "Retail Branding": "Nomi",
    "Marketing Name": "Nomi Ultra4 3G",
    "Device": "Nomi_C101014",
    "Model": "Nomi_C101014"
  },
  {
    "Retail Branding": "Nomi",
    "Marketing Name": "Nomi i5001",
    "Device": "Nomi_i5001",
    "Model": "Nomi_i5001"
  },
  {
    "Retail Branding": "Nomi",
    "Marketing Name": "Nomi i5001 Plus",
    "Device": "Nomi_i5001",
    "Model": "Nomi_i5001"
  },
  {
    "Retail Branding": "Nomi",
    "Marketing Name": "Nomi i5013",
    "Device": "i5013",
    "Model": "i5013"
  },
  {
    "Retail Branding": "Nomi",
    "Marketing Name": "Nomi i5050",
    "Device": "i5050",
    "Model": "i5050"
  },
  {
    "Retail Branding": "Nomi",
    "Marketing Name": "Nomi i5071",
    "Device": "Nomi_i5071",
    "Model": "Nomi i5071"
  },
  {
    "Retail Branding": "Nomi",
    "Marketing Name": "Nomi i5510",
    "Device": "Nomi_i5510",
    "Model": "i5510"
  },
  {
    "Retail Branding": "Nomi",
    "Marketing Name": "Nomi i5511",
    "Device": "Nomi_i5511",
    "Model": "Nomi_i5511"
  },
  {
    "Retail Branding": "Nomi",
    "Marketing Name": "Nomi i5532",
    "Device": "Nomi_i5532",
    "Model": "i5532"
  },
  {
    "Retail Branding": "Nomi",
    "Marketing Name": "Nomi i6030",
    "Device": "i6030",
    "Model": "Nomi i6030"
  },
  {
    "Retail Branding": "Nomi",
    "Marketing Name": "Nomi_C070034",
    "Device": "Nomi_C070034",
    "Model": "Nomi_C070034"
  },
  {
    "Retail Branding": "Nomi",
    "Marketing Name": "Nomi_C101034",
    "Device": "Nomi_C101034",
    "Model": "Nomi_C101034"
  },
  {
    "Retail Branding": "Nomi",
    "Marketing Name": "Nomi_C101044",
    "Device": "Nomi_C101044",
    "Model": "Nomi_C101044"
  },
  {
    "Retail Branding": "Nomi",
    "Marketing Name": "Nomi_Corsa 4 light 3G",
    "Device": "Nomi_C070014L",
    "Model": "Nomi_C070014L"
  },
  {
    "Retail Branding": "Nomi",
    "Marketing Name": "Nomi_Corsa4 3G",
    "Device": "Nomi_C070014",
    "Model": "Nomi_C070014"
  },
  {
    "Retail Branding": "Nomi",
    "Marketing Name": "Nomi_Corsa4 LTE Pro",
    "Device": "Nomi_C070044",
    "Model": "Nomi_C070044"
  },
  {
    "Retail Branding": "Nomi",
    "Marketing Name": "Nomi_Libra4 3G",
    "Device": "Nomi_C080014",
    "Model": "Nomi_C080014"
  },
  {
    "Retail Branding": "Nomi",
    "Marketing Name": "Nomi_Libra4 LTE",
    "Device": "Nomi_C080034",
    "Model": "Nomi_C080034"
  },
  {
    "Retail Branding": "Nomi",
    "Marketing Name": "Nomi_i4500",
    "Device": "Nomi_i4500",
    "Model": "Nomi_i4500"
  },
  {
    "Retail Branding": "Nomi",
    "Marketing Name": "Nomi_i5710",
    "Device": "Nomi_i5710",
    "Model": "Nomi_i5710"
  },
  {
    "Retail Branding": "Nomi",
    "Marketing Name": "Nomi_i5730",
    "Device": "Nomi_i5730",
    "Model": "Nomi_i5730"
  },
  {
    "Retail Branding": "Nomi",
    "Marketing Name": "ULTRA3 3G",
    "Device": "Nomi_C101012",
    "Model": "Nomi_C101012"
  },
  {
    "Retail Branding": "Nomi",
    "Marketing Name": "ULTRA3 LTE",
    "Device": "Nomi_C101030",
    "Model": "Nomi_C101030"
  },
  {
    "Retail Branding": "Nomi",
    "Marketing Name": "ULTRA3 LTE PRO",
    "Device": "Nomi_C101040",
    "Model": "Nomi_C101040"
  },
  {
    "Retail Branding": "Nomi",
    "Marketing Name": "i5012",
    "Device": "i5012",
    "Model": "i5012"
  },
  {
    "Retail Branding": "Nomi",
    "Marketing Name": "i5014",
    "Device": "i5014",
    "Model": "i5014"
  },
  {
    "Retail Branding": "Nomu",
    "Marketing Name": "EA200",
    "Device": "EA200",
    "Model": "EA200"
  },
  {
    "Retail Branding": "Nomu",
    "Marketing Name": "EA300",
    "Device": "EA300",
    "Model": "EA300"
  },
  {
    "Retail Branding": "Nomu",
    "Marketing Name": "G200",
    "Device": "G200",
    "Model": "G200"
  },
  {
    "Retail Branding": "Nomu",
    "Marketing Name": "G300",
    "Device": "G300",
    "Model": "G300"
  },
  {
    "Retail Branding": "Nomu",
    "Marketing Name": "G500",
    "Device": "G500",
    "Model": "G500"
  },
  {
    "Retail Branding": "Nomu",
    "Marketing Name": "G510",
    "Device": "G510",
    "Model": "G510"
  },
  {
    "Retail Branding": "Nomu",
    "Marketing Name": "M8",
    "Device": "M8",
    "Model": "M8"
  },
  {
    "Retail Branding": "Nomu",
    "Marketing Name": "S10",
    "Device": "S10",
    "Model": "S10"
  },
  {
    "Retail Branding": "Nomu",
    "Marketing Name": "S15",
    "Device": "S15",
    "Model": "S15"
  },
  {
    "Retail Branding": "Nomu",
    "Marketing Name": "S40",
    "Device": "S40",
    "Model": "S40"
  },
  {
    "Retail Branding": "Nomu",
    "Marketing Name": "S40+",
    "Device": "S40",
    "Model": "S40E"
  },
  {
    "Retail Branding": "Nomu",
    "Marketing Name": "S50 Pro",
    "Device": "S50_Pro",
    "Model": "S50PROE"
  },
  {
    "Retail Branding": "Nomu",
    "Marketing Name": "S50 Pro",
    "Device": "S50_Pro",
    "Model": "S50_Pro"
  },
  {
    "Retail Branding": "Nomu",
    "Marketing Name": "T20",
    "Device": "T20",
    "Model": "T20"
  },
  {
    "Retail Branding": "Nomu",
    "Marketing Name": "T20E",
    "Device": "T20",
    "Model": "T20E"
  },
  {
    "Retail Branding": "Nomu",
    "Marketing Name": "T38-450",
    "Device": "T38-450",
    "Model": "T38-450"
  },
  {
    "Retail Branding": "Nomu",
    "Marketing Name": "V31",
    "Device": "V31",
    "Model": "V31"
  },
  {
    "Retail Branding": "Nomu",
    "Marketing Name": "V31D",
    "Device": "V31D",
    "Model": "V31D"
  },
  {
    "Retail Branding": "Nomu",
    "Marketing Name": "V31E",
    "Device": "V31E",
    "Model": "V31E"
  },
  {
    "Retail Branding": "Nomu",
    "Marketing Name": "V58",
    "Device": "V58",
    "Model": "V58"
  },
  {
    "Retail Branding": "NoonEast",
    "Marketing Name": "Smart TV",
    "Device": "longshan",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "Nordalp",
    "Marketing Name": "Nordalp-X21-Pro",
    "Device": "Condor-Pro",
    "Model": "NX21EE"
  },
  {
    "Retail Branding": "Nordalp",
    "Marketing Name": "X6 Pro",
    "Device": "raptor",
    "Model": "X6 Pro"
  },
  {
    "Retail Branding": "NorthTech",
    "Marketing Name": "NT-P70",
    "Device": "NT-P70",
    "Model": "NT-P70"
  },
  {
    "Retail Branding": "NorthTech",
    "Marketing Name": "NT-S10",
    "Device": "NT-S10",
    "Model": "NT-S10"
  },
  {
    "Retail Branding": "Noryox",
    "Marketing Name": "Handheld-POS-EEA",
    "Device": "Handheld-POS",
    "Model": "Handheld-POS"
  },
  {
    "Retail Branding": "Noryox",
    "Marketing Name": "Handheld_POS",
    "Device": "Handheld_POS",
    "Model": "NB55"
  },
  {
    "Retail Branding": "Nothing",
    "Marketing Name": "Nothing Phone (1)",
    "Device": "Spacewar",
    "Model": "A063"
  },
  {
    "Retail Branding": "Nothing",
    "Marketing Name": "Nothing Phone (2)",
    "Device": "Pong",
    "Model": "A065"
  },
  {
    "Retail Branding": "Nothing",
    "Marketing Name": "Nothing Phone (2)",
    "Device": "Pong",
    "Model": "AIN065"
  },
  {
    "Retail Branding": "Nothing",
    "Marketing Name": "Nothing Phone (2a)",
    "Device": "Pacman",
    "Model": "A142"
  },
  {
    "Retail Branding": "Nothing",
    "Marketing Name": "Nothing Phone (2a) Plus",
    "Device": "PacmanPro",
    "Model": "A142P"
  },
  {
    "Retail Branding": "Nothing",
    "Marketing Name": "Nothing Phone (3)",
    "Device": "Metroid",
    "Model": "A024"
  },
  {
    "Retail Branding": "Nothing",
    "Marketing Name": "Nothing Phone (3a)",
    "Device": "Asteroids",
    "Model": "A059"
  },
  {
    "Retail Branding": "Nothing",
    "Marketing Name": "Nothing Phone (3a) Pro",
    "Device": "Asteroids",
    "Model": "A059P"
  },
  {
    "Retail Branding": "Nothing",
    "Marketing Name": "Nothing Phone (4a)",
    "Device": "Frogger",
    "Model": "A069"
  },
  {
    "Retail Branding": "Nothing",
    "Marketing Name": "Nothing Phone (4a) Pro",
    "Device": "FroggerPro",
    "Model": "A069P"
  },
  {
    "Retail Branding": "Nothing",
    "Marketing Name": "Phone (3a) Lite",
    "Device": "Galaxian",
    "Model": "A001T"
  },
  {
    "Retail Branding": "Nous",
    "Marketing Name": "Fabulous",
    "Device": "NS5005",
    "Model": "NS5005"
  },
  {
    "Retail Branding": "Nous",
    "Marketing Name": "NS5002",
    "Device": "NS5002",
    "Model": "NS5002"
  },
  {
    "Retail Branding": "Nous",
    "Marketing Name": "NS5502",
    "Device": "NS5502",
    "Model": "NS5502"
  },
  {
    "Retail Branding": "Nous",
    "Marketing Name": "Optimum",
    "Device": "NS5008",
    "Model": "NS5008"
  },
  {
    "Retail Branding": "Novey",
    "Marketing Name": "Alpha A16",
    "Device": "Alpha_A16",
    "Model": "Alpha A16"
  },
  {
    "Retail Branding": "Novey",
    "Marketing Name": "Pro_K10",
    "Device": "Pro_K10",
    "Model": "Pro K10"
  },
  {
    "Retail Branding": "Novinsun",
    "Marketing Name": "N11",
    "Device": "N11",
    "Model": "N11"
  },
  {
    "Retail Branding": "Novinsun",
    "Marketing Name": "TN618",
    "Device": "TN618",
    "Model": "TN618"
  },
  {
    "Retail Branding": "Novinsun",
    "Marketing Name": "TN618pro",
    "Device": "TN618pro",
    "Model": "TN618pro"
  },
  {
    "Retail Branding": "Now E",
    "Marketing Name": "Now E",
    "Device": "hk101",
    "Model": "hk101"
  },
  {
    "Retail Branding": "NowTV",
    "Marketing Name": "3103A",
    "Device": 3103,
    "Model": "Now TV Android TV 3103A"
  },
  {
    "Retail Branding": "Nowtha",
    "Marketing Name": "3HT2018",
    "Device": "3HT2018",
    "Model": "3HT2018"
  },
  {
    "Retail Branding": "NuAns",
    "Marketing Name": "NEO [Reloaded]",
    "Device": "NEO2",
    "Model": "NEO [Reloaded]"
  },
  {
    "Retail Branding": "Nubia",
    "Marketing Name": "NX401",
    "Device": "NX40X",
    "Model": "NX401"
  },
  {
    "Retail Branding": "Nubia",
    "Marketing Name": "NX501",
    "Device": "NX501",
    "Model": "NX501"
  },
  {
    "Retail Branding": "Nubia",
    "Marketing Name": "NX503A",
    "Device": "NX503A",
    "Model": "NX503A"
  },
  {
    "Retail Branding": "Nubia",
    "Marketing Name": "REDMAGIC 10 Air",
    "Device": "PQ83A06",
    "Model": "NX779J"
  },
  {
    "Retail Branding": "Nubia",
    "Marketing Name": "Z2472",
    "Device": "P606F20",
    "Model": "Z2472"
  },
  {
    "Retail Branding": "Nubia",
    "Marketing Name": "nubia Focus",
    "Device": "P616F03",
    "Model": "Z2455"
  },
  {
    "Retail Branding": "Nubia",
    "Marketing Name": "nubia Fold",
    "Device": "Z9900S",
    "Model": "A502ZT"
  },
  {
    "Retail Branding": "Nubia",
    "Marketing Name": "nubia_NB1001",
    "Device": "nubia_NB1001-UN",
    "Model": "nubia_NB1001"
  },
  {
    "Retail Branding": "Nubio_Lite",
    "Marketing Name": "N2 Lite",
    "Device": "LS032I",
    "Model": "LS032I"
  },
  {
    "Retail Branding": "Nubio_Lite",
    "Marketing Name": "N2 Lite",
    "Device": "LS032M",
    "Model": "LS032M"
  },
  {
    "Retail Branding": "Nuu",
    "Marketing Name": "A1",
    "Device": "NUU_A1",
    "Model": "NUU_A1"
  },
  {
    "Retail Branding": "Nuu",
    "Marketing Name": "A10L",
    "Device": "N5502LA",
    "Model": "N5502L"
  },
  {
    "Retail Branding": "Nuu",
    "Marketing Name": "A11L",
    "Device": "S5502LA",
    "Model": "S5502L"
  },
  {
    "Retail Branding": "Nuu",
    "Marketing Name": "A12L",
    "Device": "S5504LA",
    "Model": "S5504L"
  },
  {
    "Retail Branding": "Nuu",
    "Marketing Name": "A14",
    "Device": "S6007LA",
    "Model": "S6007L"
  },
  {
    "Retail Branding": "Nuu",
    "Marketing Name": "A15",
    "Device": "S6512LA",
    "Model": "S6512L"
  },
  {
    "Retail Branding": "Nuu",
    "Marketing Name": "A19L",
    "Device": "S6303LA_Go",
    "Model": "S6303L"
  },
  {
    "Retail Branding": "Nuu",
    "Marketing Name": "A23 Plus",
    "Device": "S6304LA",
    "Model": "S6304L"
  },
  {
    "Retail Branding": "Nuu",
    "Marketing Name": "A25",
    "Device": "S6703LA",
    "Model": "S6703L"
  },
  {
    "Retail Branding": "Nuu",
    "Marketing Name": "A3",
    "Device": "NUU_A3",
    "Model": "NUU_A3"
  },
  {
    "Retail Branding": "Nuu",
    "Marketing Name": "A3L",
    "Device": "NUU_A3L",
    "Model": "NUU_A3L"
  },
  {
    "Retail Branding": "Nuu",
    "Marketing Name": "A4L",
    "Device": "N5001L",
    "Model": "N5001L"
  },
  {
    "Retail Branding": "Nuu",
    "Marketing Name": "A5L",
    "Device": "N5501LA",
    "Model": "N5501L"
  },
  {
    "Retail Branding": "Nuu",
    "Marketing Name": "A5L+",
    "Device": "N5501LE",
    "Model": "N5501L"
  },
  {
    "Retail Branding": "Nuu",
    "Marketing Name": "A6L-C",
    "Device": "A6L-C",
    "Model": "A6L-C"
  },
  {
    "Retail Branding": "Nuu",
    "Marketing Name": "A6L-G",
    "Device": "A6L-G",
    "Model": "A6L-G"
  },
  {
    "Retail Branding": "Nuu",
    "Marketing Name": "A7",
    "Device": "N5002WE",
    "Model": "N5002W"
  },
  {
    "Retail Branding": "Nuu",
    "Marketing Name": "A7L",
    "Device": "N5002LA",
    "Model": "N5002L"
  },
  {
    "Retail Branding": "Nuu",
    "Marketing Name": "A7L",
    "Device": "N5002LATC",
    "Model": "N5002L"
  },
  {
    "Retail Branding": "Nuu",
    "Marketing Name": "A7L",
    "Device": "N5002LE",
    "Model": "N5002L"
  },
  {
    "Retail Branding": "Nuu",
    "Marketing Name": "A8L",
    "Device": "S5503LA",
    "Model": "S5503L"
  },
  {
    "Retail Branding": "Nuu",
    "Marketing Name": "A9L",
    "Device": "S6303LA",
    "Model": "S6303L"
  },
  {
    "Retail Branding": "Nuu",
    "Marketing Name": "A9L",
    "Device": "S6303LAT_Go",
    "Model": "S6303L"
  },
  {
    "Retail Branding": "Nuu",
    "Marketing Name": "A9L",
    "Device": "S6303LA_Go",
    "Model": "S6303L"
  },
  {
    "Retail Branding": "Nuu",
    "Marketing Name": "B10",
    "Device": "S6505LA",
    "Model": "S6505L"
  },
  {
    "Retail Branding": "Nuu",
    "Marketing Name": "B15",
    "Device": "S6701LA",
    "Model": "S6701L"
  },
  {
    "Retail Branding": "Nuu",
    "Marketing Name": "B20",
    "Device": "N6501LA",
    "Model": "N6501L"
  },
  {
    "Retail Branding": "Nuu",
    "Marketing Name": "B30",
    "Device": "S6702XA",
    "Model": "S6702X"
  },
  {
    "Retail Branding": "Nuu",
    "Marketing Name": "B30 Pro",
    "Device": "S6702XA",
    "Model": "S6702X"
  },
  {
    "Retail Branding": "Nuu",
    "Marketing Name": "B40",
    "Device": "S6710XA",
    "Model": "S6710X"
  },
  {
    "Retail Branding": "Nuu",
    "Marketing Name": "G1",
    "Device": "N5704LA",
    "Model": "N5704L"
  },
  {
    "Retail Branding": "Nuu",
    "Marketing Name": "G2",
    "Device": "S6001LE",
    "Model": "S6001L"
  },
  {
    "Retail Branding": "Nuu",
    "Marketing Name": "G4",
    "Device": "N6201L",
    "Model": "N6201L"
  },
  {
    "Retail Branding": "Nuu",
    "Marketing Name": "M19",
    "Device": "S5501LE",
    "Model": "S5501L"
  },
  {
    "Retail Branding": "Nuu",
    "Marketing Name": "M2",
    "Device": "NUU_M2",
    "Model": "NUU_M2"
  },
  {
    "Retail Branding": "Nuu",
    "Marketing Name": "M3",
    "Device": "NUU_M3",
    "Model": "NUU_M3"
  },
  {
    "Retail Branding": "Nuu",
    "Marketing Name": "M6",
    "Device": "S6503LE",
    "Model": "S6503L"
  },
  {
    "Retail Branding": "Nuu",
    "Marketing Name": "N10",
    "Device": "S6603LA",
    "Model": "S6603L"
  },
  {
    "Retail Branding": "Nuu",
    "Marketing Name": "N12",
    "Device": "S6008LA",
    "Model": "S6008L"
  },
  {
    "Retail Branding": "Nuu",
    "Marketing Name": "N13",
    "Device": "S6514LA",
    "Model": "S6514L"
  },
  {
    "Retail Branding": "Nuu",
    "Marketing Name": "N20",
    "Device": "S6603LA",
    "Model": "S6603L"
  },
  {
    "Retail Branding": "Nuu",
    "Marketing Name": "N21",
    "Device": "N6504LA",
    "Model": "N6504L"
  },
  {
    "Retail Branding": "Nuu",
    "Marketing Name": "N21",
    "Device": "N6505LA",
    "Model": "N6505L"
  },
  {
    "Retail Branding": "Nuu",
    "Marketing Name": "N22",
    "Device": "S6010LA",
    "Model": "S6010L"
  },
  {
    "Retail Branding": "Nuu",
    "Marketing Name": "N30",
    "Device": "S6704LA",
    "Model": "S6704L"
  },
  {
    "Retail Branding": "Nuu",
    "Marketing Name": "N4L",
    "Device": "N4L",
    "Model": "N4L"
  },
  {
    "Retail Branding": "Nuu",
    "Marketing Name": "N5L",
    "Device": "N5L",
    "Model": "N5L"
  },
  {
    "Retail Branding": "Nuu",
    "Marketing Name": "N6001L",
    "Device": "N6001LA",
    "Model": "N6001L"
  },
  {
    "Retail Branding": "Nuu",
    "Marketing Name": "NUU A3",
    "Device": "N5001WA",
    "Model": "A3"
  },
  {
    "Retail Branding": "Nuu",
    "Marketing Name": "NUU A3 (TC)",
    "Device": "N5001WA",
    "Model": "A3"
  },
  {
    "Retail Branding": "Nuu",
    "Marketing Name": "NUU G3",
    "Device": "N5702L",
    "Model": "N5702L"
  },
  {
    "Retail Branding": "Nuu",
    "Marketing Name": "NUU G5",
    "Device": "S6501LA",
    "Model": "S6501L"
  },
  {
    "Retail Branding": "Nuu",
    "Marketing Name": "NUU M4X_PRO",
    "Device": "S5701L",
    "Model": "S5701L"
  },
  {
    "Retail Branding": "Nuu",
    "Marketing Name": "NUU R1",
    "Device": "R5001LA",
    "Model": "R5001L"
  },
  {
    "Retail Branding": "Nuu",
    "Marketing Name": "NUU_A2",
    "Device": "S4001W",
    "Model": "S4001W"
  },
  {
    "Retail Branding": "Nuu",
    "Marketing Name": "S4090L",
    "Device": "S4090LA",
    "Model": "S4090L"
  },
  {
    "Retail Branding": "Nuu",
    "Marketing Name": "Tab 10",
    "Device": "T1001LA",
    "Model": "T1001L"
  },
  {
    "Retail Branding": "Nuu",
    "Marketing Name": "Tab 10 Plus",
    "Device": "T1005LAV1",
    "Model": "T1005L"
  },
  {
    "Retail Branding": "Nuu",
    "Marketing Name": "Tab 10A 5G",
    "Device": "T1016XA",
    "Model": "T1016X"
  },
  {
    "Retail Branding": "Nuu",
    "Marketing Name": "Tab 5",
    "Device": "N5005LA",
    "Model": "N5005L"
  },
  {
    "Retail Branding": "Nuu",
    "Marketing Name": "Tab 5",
    "Device": "N5005LA_F",
    "Model": "N5005L"
  },
  {
    "Retail Branding": "Nuu",
    "Marketing Name": "Tab 8",
    "Device": "T0801LAV1",
    "Model": "T0801L"
  },
  {
    "Retail Branding": "Nuu",
    "Marketing Name": "Tab 8",
    "Device": "T0801LAV2",
    "Model": "T0801L"
  },
  {
    "Retail Branding": "Nuu",
    "Marketing Name": "Tab 8",
    "Device": "T0801LAV2",
    "Model": "T0802L"
  },
  {
    "Retail Branding": "Nuu",
    "Marketing Name": "Tab 8 Plus",
    "Device": "T0805LAV1",
    "Model": "T0805L"
  },
  {
    "Retail Branding": "Nuu",
    "Marketing Name": "X10 5G",
    "Device": "S6707XA",
    "Model": "S6707X"
  },
  {
    "Retail Branding": "Nuu",
    "Marketing Name": "X10 5G",
    "Device": "S6707XA1",
    "Model": "S6707X"
  },
  {
    "Retail Branding": "Nuu",
    "Marketing Name": "X4",
    "Device": "X4",
    "Model": "X4"
  },
  {
    "Retail Branding": "Nuu",
    "Marketing Name": "X5",
    "Device": "NUU_X5",
    "Model": "NUU_X5"
  },
  {
    "Retail Branding": "Nuu",
    "Marketing Name": "X6",
    "Device": "S5702LA",
    "Model": "S5702L"
  },
  {
    "Retail Branding": "Nuu",
    "Marketing Name": "X6 Plus",
    "Device": "S6003LA",
    "Model": "S6003L"
  },
  {
    "Retail Branding": "Nuu",
    "Marketing Name": "X6mini",
    "Device": "S5702LA",
    "Model": "S5702L"
  },
  {
    "Retail Branding": "Nuu",
    "Marketing Name": "X6mini",
    "Device": "S5704LE",
    "Model": "S5704L"
  },
  {
    "Retail Branding": "Nuu",
    "Marketing Name": "X7",
    "Device": "S6006LA",
    "Model": "S6006L"
  },
  {
    "Retail Branding": "Nuu",
    "Marketing Name": "X7 Plus",
    "Device": "S6601LA",
    "Model": "S6601L"
  },
  {
    "Retail Branding": "Nuu",
    "Marketing Name": "X7 Plus",
    "Device": "S6601LA1",
    "Model": "S6601L"
  },
  {
    "Retail Branding": "Nuu",
    "Marketing Name": "Z8",
    "Device": "Z8",
    "Model": "Z8"
  },
  {
    "Retail Branding": "Nuvision",
    "Marketing Name": "TM101A530L",
    "Device": "TM101A530L",
    "Model": "TM101A530L"
  },
  {
    "Retail Branding": "Nuvision",
    "Marketing Name": "TM101A540N",
    "Device": "mid1008a-l",
    "Model": "TM101A540N"
  },
  {
    "Retail Branding": "Nuvision",
    "Marketing Name": "TM101A730M",
    "Device": "TM101AM",
    "Model": "TM101A730M"
  },
  {
    "Retail Branding": "Nuvision",
    "Marketing Name": "TM106A510L",
    "Device": "TM106A510L",
    "Model": "TM106A510L"
  },
  {
    "Retail Branding": "Nuvision",
    "Marketing Name": "TM1088",
    "Device": "fiber-wifibt",
    "Model": "CT1000"
  },
  {
    "Retail Branding": "Nuvision",
    "Marketing Name": "TM1088",
    "Device": "fiber-wifibt",
    "Model": "Endeavour101"
  },
  {
    "Retail Branding": "Nuvision",
    "Marketing Name": "TM1088",
    "Device": "fiber-wifibt",
    "Model": "TM1088"
  },
  {
    "Retail Branding": "Nuvision",
    "Marketing Name": "TM1088",
    "Device": "fiber-wifibt",
    "Model": "WEBPAD1002"
  },
  {
    "Retail Branding": "Nuvision",
    "Marketing Name": "TM700A520L",
    "Device": "TM700A",
    "Model": "TM700A520L"
  },
  {
    "Retail Branding": "Nuvision",
    "Marketing Name": "TM785M3",
    "Device": "TM785M3",
    "Model": "TM785M3"
  },
  {
    "Retail Branding": "Nuvision",
    "Marketing Name": "TM800A510L",
    "Device": "TM800A",
    "Model": "TM800A510L"
  },
  {
    "Retail Branding": "Nuvision",
    "Marketing Name": "TM800A550L",
    "Device": "TM800A550L",
    "Model": "TM800A550L"
  },
  {
    "Retail Branding": "Nuvision",
    "Marketing Name": "TM800A730M",
    "Device": "TM800AM",
    "Model": "TM800A730M"
  },
  {
    "Retail Branding": "Nuvision",
    "Marketing Name": "TM800A740M",
    "Device": "TM800AM",
    "Model": "TM800A740M"
  },
  {
    "Retail Branding": "O\\'NICE",
    "Marketing Name": "O\\'NICE I-TOUCH M1",
    "Device": "ONICE_I-TOUCH_M1",
    "Model": "i-touch M1"
  },
  {
    "Retail Branding": "O2.CZ",
    "Marketing Name": "O2 TV Box",
    "Device": "O2TV_B866V2",
    "Model": "O2 TV Box"
  },
  {
    "Retail Branding": "OASE",
    "Marketing Name": "EL-P1",
    "Device": "EL-P1",
    "Model": "EL-P1"
  },
  {
    "Retail Branding": "OASYS",
    "Marketing Name": "AudeaTablet",
    "Device": "AudeaTablet",
    "Model": "AudeaTablet"
  },
  {
    "Retail Branding": "OASYS",
    "Marketing Name": "OASTN_9301",
    "Device": "OASTN_9301",
    "Model": "OASTN_9301"
  },
  {
    "Retail Branding": "OASYS",
    "Marketing Name": "OASYS TEG9300",
    "Device": "TEG9300-AL",
    "Model": "TEG9300-AL"
  },
  {
    "Retail Branding": "OASYS",
    "Marketing Name": "OAS_9301",
    "Device": "OAS_9301",
    "Model": "OAS_9301"
  },
  {
    "Retail Branding": "OASYS",
    "Marketing Name": "TEG9300",
    "Device": "TEG9300",
    "Model": "TEG9300"
  },
  {
    "Retail Branding": "OASYS",
    "Marketing Name": "TEG9300-4",
    "Device": "TEG9300-4",
    "Model": "TEG9300-4"
  },
  {
    "Retail Branding": "OASYS",
    "Marketing Name": "TEG9300-4A",
    "Device": "TEG9300-4A",
    "Model": "TEG9300-4A"
  },
  {
    "Retail Branding": "OASYS",
    "Marketing Name": "TEG9300-5",
    "Device": "TEG9300-5",
    "Model": "TEG9300-5"
  },
  {
    "Retail Branding": "OASYS",
    "Marketing Name": "TEG9300-5A",
    "Device": "TEG9300-5A",
    "Model": "TEG9300-5A"
  },
  {
    "Retail Branding": "OASYS",
    "Marketing Name": "TEG9300-M",
    "Device": "TEG9300-M",
    "Model": "TEG9300-M"
  },
  {
    "Retail Branding": "OBOX",
    "Marketing Name": "OBOX4K.20",
    "Device": "DV8519-BOX",
    "Model": "OBOX4k.20"
  },
  {
    "Retail Branding": "ODS Corporation",
    "Marketing Name": "TA2C-DR9",
    "Device": "TA2C-DR9",
    "Model": "TA2C-DR9"
  },
  {
    "Retail Branding": "ODS Corporation",
    "Marketing Name": "TA2C-DR94G",
    "Device": "TA2C-DR94G",
    "Model": "TA2C-DR94G"
  },
  {
    "Retail Branding": "ODS Corporation",
    "Marketing Name": "TA2C-NF8",
    "Device": "TA2C-NF8",
    "Model": "TA2C-NF8"
  },
  {
    "Retail Branding": "ODYS",
    "Marketing Name": "FALCON_10_PLUS_3G",
    "Device": "FALCON_10_PLUS_3G",
    "Model": "FALCON_10_PLUS_3G"
  },
  {
    "Retail Branding": "ODYS",
    "Marketing Name": "GOAL_10_PLUS_3G",
    "Device": "GOAL_10_PLUS_3G",
    "Model": "GOAL_10_PLUS_3G"
  },
  {
    "Retail Branding": "ODYS",
    "Marketing Name": "JUNIOR_8_PRO_EEA",
    "Device": "JUNIOR_8_PRO",
    "Model": "JUNIOR_8_PRO"
  },
  {
    "Retail Branding": "ODYS",
    "Marketing Name": "MAVEN_X10_HD_LTE",
    "Device": "MAVEN_X10_HD_LTE",
    "Model": "MAVEN_X10_HD_LTE"
  },
  {
    "Retail Branding": "ODYS",
    "Marketing Name": "Maven_T10_pro",
    "Device": "Maven_T10_pro",
    "Model": "Maven_T10_pro"
  },
  {
    "Retail Branding": "ODYS",
    "Marketing Name": "NoteTab_Pro",
    "Device": "NoteTab_Pro",
    "Model": "NoteTab_Pro"
  },
  {
    "Retail Branding": "ODYS",
    "Marketing Name": "ODYS SPACE ONE 10SE",
    "Device": "T1021",
    "Model": "SPACE_ONE_10SE"
  },
  {
    "Retail Branding": "ODYS",
    "Marketing Name": "ODYS_SPACE_ONE_10",
    "Device": "T1011S",
    "Model": "SPACE_ONE10"
  },
  {
    "Retail Branding": "ODYS",
    "Marketing Name": "PACE 10",
    "Device": "PACE10",
    "Model": "PACE10"
  },
  {
    "Retail Branding": "ODYS",
    "Marketing Name": "THANOS_10",
    "Device": "THANOS_10",
    "Model": "THANOS_10"
  },
  {
    "Retail Branding": "ODYS",
    "Marketing Name": "Titan_10_LTE",
    "Device": "Titan_10_LTE",
    "Model": "Titan_10_LTE"
  },
  {
    "Retail Branding": "ODYS",
    "Marketing Name": "XELIO_HD10",
    "Device": "XELIO_HD10",
    "Model": "XELIO_HD10"
  },
  {
    "Retail Branding": "OFD(Display)",
    "Marketing Name": "D01",
    "Device": "D01",
    "Model": "D01"
  },
  {
    "Retail Branding": "OFD(Display)",
    "Marketing Name": "HSD-215",
    "Device": "HSD-215",
    "Model": "HSD-215"
  },
  {
    "Retail Branding": "OFD(Display)",
    "Marketing Name": "HSD01",
    "Device": "HSD01",
    "Model": "HSD01"
  },
  {
    "Retail Branding": "OK (Mediamark)",
    "Marketing Name": "32770H-TAB",
    "Device": "ikebukuro",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "OK (Mediamark)",
    "Marketing Name": "4K Smart TV",
    "Device": "pioneer",
    "Model": "4K PA Smart TV"
  },
  {
    "Retail Branding": "OK (Mediamark)",
    "Marketing Name": "Android TV",
    "Device": "longshan",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "OK (Mediamark)",
    "Marketing Name": "Android TV",
    "Device": "redwood",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "OK (Mediamark)",
    "Marketing Name": "EU",
    "Device": "tamachi",
    "Model": "OK 2K Android TV"
  },
  {
    "Retail Branding": "OK (Mediamark)",
    "Marketing Name": "ODL 32770H-TAB",
    "Device": "ikebukuro",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "OK (Mediamark)",
    "Marketing Name": "ODL50672U-TAB",
    "Device": "samseong",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "OK (Mediamark)",
    "Marketing Name": "OK",
    "Device": "bangbae",
    "Model": "OK 4K Android TV"
  },
  {
    "Retail Branding": "OK (Mediamark)",
    "Marketing Name": "OK",
    "Device": "kaitak",
    "Model": "OK Google TV"
  },
  {
    "Retail Branding": "OK (Mediamark)",
    "Marketing Name": "OK 2K TV",
    "Device": "shinagawa",
    "Model": "OK 2K TV"
  },
  {
    "Retail Branding": "OK (Mediamark)",
    "Marketing Name": "Smart TV",
    "Device": "longshan",
    "Model": "AI PONT DE"
  },
  {
    "Retail Branding": "OK (Mediamark)",
    "Marketing Name": "Smart TV",
    "Device": "mateo",
    "Model": "2K PA Smart TV"
  },
  {
    "Retail Branding": "OK (Mediamark)",
    "Marketing Name": "Smart TV",
    "Device": "osaka",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "OK (Mediamark)",
    "Marketing Name": "Smart TV",
    "Device": "osaka",
    "Model": "AI PONT DE"
  },
  {
    "Retail Branding": "OK (Mediamark)",
    "Marketing Name": "Smart TV",
    "Device": "osaki",
    "Model": "2K AI Smart TV"
  },
  {
    "Retail Branding": "OK (Mediamark)",
    "Marketing Name": "Smart TV",
    "Device": "redwood",
    "Model": "AI PONT DE"
  },
  {
    "Retail Branding": "OK (Mediamark)",
    "Marketing Name": "Smart TV",
    "Device": "samseong",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "OK (Mediamark)",
    "Marketing Name": "eu",
    "Device": "yeongdeungpo",
    "Model": "OK 4K Android TV"
  },
  {
    "Retail Branding": "OK (Mediamark)",
    "Marketing Name": "ok 2K TV",
    "Device": "umeda",
    "Model": "ok 2K TV"
  },
  {
    "Retail Branding": "OKAPI",
    "Marketing Name": "Okapi Rambo",
    "Device": "Okapi_Rambo",
    "Model": "Okapi Rambo"
  },
  {
    "Retail Branding": "OKAPI",
    "Marketing Name": "Okapi stone",
    "Device": "Okapi_stone",
    "Model": "Okapi stone"
  },
  {
    "Retail Branding": "OKAPI",
    "Marketing Name": "Okapi10",
    "Device": "Okapi10",
    "Model": "Okapi10"
  },
  {
    "Retail Branding": "OKAPI",
    "Marketing Name": "Okapi10_Pro",
    "Device": "Okapi10_Pro",
    "Model": "Okapi10 Pro"
  },
  {
    "Retail Branding": "OKAPI",
    "Marketing Name": "Okapi10_Pro_Max",
    "Device": "Okapi10_Pro_Max",
    "Model": "Okapi10 Pro Max"
  },
  {
    "Retail Branding": "OKAPI",
    "Marketing Name": "Okapi10_S",
    "Device": "Okapi10_S",
    "Model": "Okapi10_S"
  },
  {
    "Retail Branding": "OKAPI",
    "Marketing Name": "Okapi10_Sec",
    "Device": "Okapi10_Sec",
    "Model": "Okapi10 Sec"
  },
  {
    "Retail Branding": "OKAPI",
    "Marketing Name": "Okapi10_Simple",
    "Device": "Okapi10_Simple",
    "Model": "Okapi10_Simple"
  },
  {
    "Retail Branding": "OKAPI",
    "Marketing Name": "Okapi16 Rombo Ultra",
    "Device": "Okapi16_Rombo_Ultra",
    "Model": "Okapi16 Rombo Ultra"
  },
  {
    "Retail Branding": "OKAPI",
    "Marketing Name": "Okapi_Tab6",
    "Device": "Okapi_Tab6",
    "Model": "Okapi_Tab6"
  },
  {
    "Retail Branding": "OKAPI",
    "Marketing Name": "Okapi_Tab8",
    "Device": "Okapi_Tab8",
    "Model": "Okapi_Tab8"
  },
  {
    "Retail Branding": "OKAPI",
    "Marketing Name": "Tab10",
    "Device": "Tab10",
    "Model": "Tab10"
  },
  {
    "Retail Branding": "OKSI",
    "Marketing Name": "GEN-10",
    "Device": "GEN-10",
    "Model": "GEN-10"
  },
  {
    "Retail Branding": "OKSI",
    "Marketing Name": "GT1001",
    "Device": "GT1001",
    "Model": "GT1001"
  },
  {
    "Retail Branding": "OKView",
    "Marketing Name": "IFP",
    "Device": "mensa_an64",
    "Model": "IFP"
  },
  {
    "Retail Branding": "OKView",
    "Marketing Name": "IFP",
    "Device": "rk3588_t",
    "Model": "IFP"
  },
  {
    "Retail Branding": "OKView",
    "Marketing Name": "IFP86A1",
    "Device": "rk3588_t",
    "Model": "IFP"
  },
  {
    "Retail Branding": "OKWU",
    "Marketing Name": "PI Plus",
    "Device": "PI_Plus",
    "Model": "PI Plus"
  },
  {
    "Retail Branding": "OLAX",
    "Marketing Name": "Magic_Q1",
    "Device": "Magic_Q1",
    "Model": "Magic Q1"
  },
  {
    "Retail Branding": "OLAX",
    "Marketing Name": "Magic_Q8",
    "Device": "Magic_Q8",
    "Model": "Magic Q8"
  },
  {
    "Retail Branding": "OLAX",
    "Marketing Name": "Ocean K8",
    "Device": "Ocean_K8",
    "Model": "Ocean K8"
  },
  {
    "Retail Branding": "OLAX",
    "Marketing Name": "Ocean_F8",
    "Device": "Ocean_F8",
    "Model": "Ocean F8"
  },
  {
    "Retail Branding": "OLAX",
    "Marketing Name": "Ocean_K11_Pro_Plus",
    "Device": "Ocean_K11_Pro_Plus",
    "Model": "Ocean K11 Pro Plus"
  },
  {
    "Retail Branding": "OLAX",
    "Marketing Name": "Ocean_K8",
    "Device": "Ocean_K8",
    "Model": "Ocean K8"
  },
  {
    "Retail Branding": "OLAX",
    "Marketing Name": "Ocean_K8_Pro",
    "Device": "Ocean_K8_Pro",
    "Model": "Ocean K8 Pro"
  },
  {
    "Retail Branding": "OLAX",
    "Marketing Name": "Q101_EEA",
    "Device": "Q101_EEA",
    "Model": "Q101_EEA"
  },
  {
    "Retail Branding": "OMAGROUPLLC",
    "Marketing Name": "OM-A86",
    "Device": "OM-A86",
    "Model": "OM-A86"
  },
  {
    "Retail Branding": "OMAX",
    "Marketing Name": "7PAN",
    "Device": "7PAN",
    "Model": "7PAN"
  },
  {
    "Retail Branding": "OMAX",
    "Marketing Name": "FeelMooK",
    "Device": "rk3588_t",
    "Model": "FeelMooK"
  },
  {
    "Retail Branding": "OMAX",
    "Marketing Name": "FeelMook",
    "Device": "FeelMook",
    "Model": "FeelMook"
  },
  {
    "Retail Branding": "OMAX",
    "Marketing Name": "OMAX-IFPD",
    "Device": "rk3588_t",
    "Model": "HANJI"
  },
  {
    "Retail Branding": "OMIX",
    "Marketing Name": "MixTab Pro",
    "Device": "MixTab_Pro",
    "Model": "MixTab Pro"
  },
  {
    "Retail Branding": "OMIX",
    "Marketing Name": "MixTab Pro 2",
    "Device": "MixTab_Pro_2",
    "Model": "MixTab Pro 2"
  },
  {
    "Retail Branding": "OMIX",
    "Marketing Name": "X2032",
    "Device": "X2032",
    "Model": "O1 Neo"
  },
  {
    "Retail Branding": "OMIX",
    "Marketing Name": "X2033",
    "Device": "X2033",
    "Model": "O1 Icon"
  },
  {
    "Retail Branding": "OMIX",
    "Marketing Name": "X2034",
    "Device": "X2034",
    "Model": "X2034"
  },
  {
    "Retail Branding": "OMIX",
    "Marketing Name": "X3",
    "Device": "X3",
    "Model": "X3"
  },
  {
    "Retail Branding": "OMIX",
    "Marketing Name": "X300",
    "Device": "X300",
    "Model": "OMIX X300"
  },
  {
    "Retail Branding": "OMIX",
    "Marketing Name": "X3_1",
    "Device": "X3",
    "Model": "X3_1"
  },
  {
    "Retail Branding": "OMIX",
    "Marketing Name": "X4",
    "Device": "OMIX_X4",
    "Model": "X4"
  },
  {
    "Retail Branding": "OMIX",
    "Marketing Name": "X400",
    "Device": "X400",
    "Model": "X400"
  },
  {
    "Retail Branding": "OMIX",
    "Marketing Name": "X5",
    "Device": "X5",
    "Model": "X5"
  },
  {
    "Retail Branding": "OMIX",
    "Marketing Name": "X500",
    "Device": "X500",
    "Model": "OMIX X500"
  },
  {
    "Retail Branding": "OMIX",
    "Marketing Name": "X6",
    "Device": "X6",
    "Model": "X6"
  },
  {
    "Retail Branding": "OMIX",
    "Marketing Name": "X600",
    "Device": "X600",
    "Model": "X600"
  },
  {
    "Retail Branding": "OMIX",
    "Marketing Name": "X600 NFC",
    "Device": "X600_NFC",
    "Model": "X600 NFC"
  },
  {
    "Retail Branding": "OMIX",
    "Marketing Name": "X7",
    "Device": "X7",
    "Model": "X7"
  },
  {
    "Retail Branding": "OMIX",
    "Marketing Name": "X700",
    "Device": "X700",
    "Model": "OMIX X700"
  },
  {
    "Retail Branding": "OMIX",
    "Marketing Name": "X700",
    "Device": "X700",
    "Model": "X700"
  },
  {
    "Retail Branding": "ONDA TLC",
    "Marketing Name": "T7 Pro",
    "Device": "T7_PRO",
    "Model": "T7_PRO"
  },
  {
    "Retail Branding": "ONDA TLC",
    "Marketing Name": "T9 S",
    "Device": "T9S",
    "Model": "T9S"
  },
  {
    "Retail Branding": "ONENZ",
    "Marketing Name": "Smart V26",
    "Device": "Smart_V26",
    "Model": "Smart V26"
  },
  {
    "Retail Branding": "ONERugged",
    "Marketing Name": "M10X",
    "Device": "M10X",
    "Model": "M10X"
  },
  {
    "Retail Branding": "ONERugged",
    "Marketing Name": "M10XE",
    "Device": "M10XE",
    "Model": "M10XE"
  },
  {
    "Retail Branding": "ONERugged",
    "Marketing Name": "M185QE",
    "Device": "M185QE",
    "Model": "M185QE"
  },
  {
    "Retail Branding": "ONERugged",
    "Marketing Name": "M195T",
    "Device": "M195T",
    "Model": "M195T"
  },
  {
    "Retail Branding": "ONERugged",
    "Marketing Name": "M19TE",
    "Device": "M19TE",
    "Model": "M19TE"
  },
  {
    "Retail Branding": "ONERugged",
    "Marketing Name": "M86X",
    "Device": "M86X",
    "Model": "M86X"
  },
  {
    "Retail Branding": "ONERugged",
    "Marketing Name": "M86XE",
    "Device": "M86XE",
    "Model": "M86XE"
  },
  {
    "Retail Branding": "ONERugged",
    "Marketing Name": "M89T",
    "Device": "M89T",
    "Model": "M89T"
  },
  {
    "Retail Branding": "ONERugged",
    "Marketing Name": "MP1T",
    "Device": "MP1T",
    "Model": "MP1T"
  },
  {
    "Retail Branding": "ONERugged",
    "Marketing Name": "MP1TE",
    "Device": "MP1TE",
    "Model": "MP1TE"
  },
  {
    "Retail Branding": "ONERugged",
    "Marketing Name": "MP2ProT",
    "Device": "MP2ProT",
    "Model": "MP2ProT"
  },
  {
    "Retail Branding": "ONERugged",
    "Marketing Name": "MP2ProTE",
    "Device": "MP2ProTE",
    "Model": "MP2ProTE"
  },
  {
    "Retail Branding": "ONERugged",
    "Marketing Name": "MPC10T",
    "Device": "MPC10T",
    "Model": "MPC10T"
  },
  {
    "Retail Branding": "ONERugged",
    "Marketing Name": "MPC80T",
    "Device": "MPC80T",
    "Model": "MPC80T"
  },
  {
    "Retail Branding": "ONERugged",
    "Marketing Name": "MT1E",
    "Device": "MT1E",
    "Model": "MT1E"
  },
  {
    "Retail Branding": "ONERugged",
    "Marketing Name": "MT1MAX",
    "Device": "MT1MAX",
    "Model": "MT1MAX"
  },
  {
    "Retail Branding": "ONERugged",
    "Marketing Name": "MT1MAXE",
    "Device": "MT1MAXE",
    "Model": "MT1MAXE"
  },
  {
    "Retail Branding": "ONERugged",
    "Marketing Name": "MT1N",
    "Device": "MT1N",
    "Model": "MT1N"
  },
  {
    "Retail Branding": "ONERugged",
    "Marketing Name": "MT2U",
    "Device": "MT2U",
    "Model": "MT2U"
  },
  {
    "Retail Branding": "ONERugged",
    "Marketing Name": "MT2UE",
    "Device": "MT2UE",
    "Model": "MT2UE"
  },
  {
    "Retail Branding": "ONERugged",
    "Marketing Name": "MT50CE",
    "Device": "MT50CE",
    "Model": "MT50CE"
  },
  {
    "Retail Branding": "ONIDA",
    "Marketing Name": "MIRC Electronics Ltd.",
    "Device": "landen",
    "Model": "ONI41F"
  },
  {
    "Retail Branding": "ONIDA",
    "Marketing Name": "ONIDA 2K Android TV",
    "Device": "lasalle",
    "Model": "ONIDA 2K Android TV"
  },
  {
    "Retail Branding": "ONIDA",
    "Marketing Name": "ONIDA 4K Android TV",
    "Device": "kenton",
    "Model": "ONIDA 4K Android TV"
  },
  {
    "Retail Branding": "ONIDA",
    "Marketing Name": "R3",
    "Device": "R3",
    "Model": "R3"
  },
  {
    "Retail Branding": "ONIDA",
    "Marketing Name": "R4_GTV",
    "Device": "R4_GTV",
    "Model": "R4G"
  },
  {
    "Retail Branding": "ONPAD",
    "Marketing Name": "Vexon",
    "Device": "Vexon",
    "Model": "Vexon"
  },
  {
    "Retail Branding": "ONVO",
    "Marketing Name": "EMEA",
    "Device": "sepolia",
    "Model": "ONVO TV"
  },
  {
    "Retail Branding": "ONYX",
    "Marketing Name": "AKA Model A",
    "Device": "Model_A",
    "Model": "Model A"
  },
  {
    "Retail Branding": "ONYX",
    "Marketing Name": "BOOX",
    "Device": "BOOX",
    "Model": "BOOX"
  },
  {
    "Retail Branding": "ONYX",
    "Marketing Name": "OnyxBooxII",
    "Device": "OnyxBooxII",
    "Model": "OnyxBoox II"
  },
  {
    "Retail Branding": "ONYX",
    "Marketing Name": "QuartzT10-3",
    "Device": "QuartzT10-3",
    "Model": "QuartzT10-3"
  },
  {
    "Retail Branding": "ONYX",
    "Marketing Name": "TabBoox",
    "Device": "TabBoox",
    "Model": "TabBoox"
  },
  {
    "Retail Branding": "OPEN",
    "Marketing Name": "OPEN_PRO",
    "Device": "OPEN_PRO",
    "Model": "OPEN_PRO"
  },
  {
    "Retail Branding": "ORBYS",
    "Marketing Name": "F20",
    "Device": "F20",
    "Model": "F20"
  },
  {
    "Retail Branding": "ORBYS",
    "Marketing Name": "F21",
    "Device": "F21",
    "Model": "F21"
  },
  {
    "Retail Branding": "ORCA",
    "Marketing Name": "Kuwait",
    "Device": "tamachi",
    "Model": "ORCA FHD Android TV"
  },
  {
    "Retail Branding": "ORCA",
    "Marketing Name": "Kuwait",
    "Device": "yeongdeungpo",
    "Model": "ORCA UHD Android TV"
  },
  {
    "Retail Branding": "ORCA",
    "Marketing Name": "O-0202",
    "Device": "Orca_Display_2",
    "Model": "O-0202"
  },
  {
    "Retail Branding": "ORCA",
    "Marketing Name": "OR-50UX400S",
    "Device": "samseong",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "ORCA",
    "Marketing Name": "ORCA 2K Android TV",
    "Device": "lasalle",
    "Model": "ORCA 2K Android TV"
  },
  {
    "Retail Branding": "ORCA",
    "Marketing Name": "ORCA 4K Android TV",
    "Device": "kenton",
    "Model": "ORCA 4K Android TV"
  },
  {
    "Retail Branding": "ORCATAB",
    "Marketing Name": "ORCATAB_WT1_WT1Pro",
    "Device": "ORCATAB_WT1_WT1Pro",
    "Model": "ORCATAB WT1_WT1 Pro"
  },
  {
    "Retail Branding": "ORCATAB",
    "Marketing Name": "ORCATAB_WT1_WT1Pro",
    "Device": "ORCATAB_WT1_WT1Pro",
    "Model": "ORCATAB_WT1_WT1Pro"
  },
  {
    "Retail Branding": "ORION",
    "Marketing Name": "Doshisha 2K Smart TV",
    "Device": "umeda",
    "Model": "Doshisha 2K Smart TV"
  },
  {
    "Retail Branding": "ORION",
    "Marketing Name": "ORION",
    "Device": "elliniko",
    "Model": "ORION SMART TV"
  },
  {
    "Retail Branding": "ORION",
    "Marketing Name": "ORION",
    "Device": "templeton",
    "Model": "ORION SMART TV"
  },
  {
    "Retail Branding": "ORION",
    "Marketing Name": "Smart TV",
    "Device": "longshan",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "ORION",
    "Marketing Name": "Smart TV",
    "Device": "redwood",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "OSCAL",
    "Marketing Name": "C20",
    "Device": "C20",
    "Model": "C20"
  },
  {
    "Retail Branding": "OSCAL",
    "Marketing Name": "C20 Pro",
    "Device": "C20_Pro",
    "Model": "C20 Pro"
  },
  {
    "Retail Branding": "OSCAL",
    "Marketing Name": "C30",
    "Device": "C30",
    "Model": "C30"
  },
  {
    "Retail Branding": "OSCAL",
    "Marketing Name": "C30 Pro",
    "Device": "C30_Pro",
    "Model": "C30 Pro"
  },
  {
    "Retail Branding": "OSCAL",
    "Marketing Name": "C60",
    "Device": "C60",
    "Model": "C60"
  },
  {
    "Retail Branding": "OSCAL",
    "Marketing Name": "C70",
    "Device": "C70",
    "Model": "C70"
  },
  {
    "Retail Branding": "OSCAL",
    "Marketing Name": "C80",
    "Device": "C80",
    "Model": "C80"
  },
  {
    "Retail Branding": "OSCAL",
    "Marketing Name": "ELITE 1",
    "Device": "ELITE_1",
    "Model": "ELITE 1"
  },
  {
    "Retail Branding": "OSCAL",
    "Marketing Name": "FLAT 1C",
    "Device": "FLAT1C",
    "Model": "FLAT 1C"
  },
  {
    "Retail Branding": "OSCAL",
    "Marketing Name": "FLAT 2",
    "Device": "FLAT2_A15",
    "Model": "FLAT 2"
  },
  {
    "Retail Branding": "OSCAL",
    "Marketing Name": "FLAT 2",
    "Device": "FLAT_2",
    "Model": "FLAT 2"
  },
  {
    "Retail Branding": "OSCAL",
    "Marketing Name": "FLAT 2C",
    "Device": "FLAT_2C",
    "Model": "FLAT 2C"
  },
  {
    "Retail Branding": "OSCAL",
    "Marketing Name": "MARINE 1",
    "Device": "MARINE_1",
    "Model": "MARINE 1"
  },
  {
    "Retail Branding": "OSCAL",
    "Marketing Name": "MARINE 2",
    "Device": "MARINE_2",
    "Model": "MARINE 2"
  },
  {
    "Retail Branding": "OSCAL",
    "Marketing Name": "MARINE 3",
    "Device": "MARINE_3",
    "Model": "MARINE 3"
  },
  {
    "Retail Branding": "OSCAL",
    "Marketing Name": "MODERN 8",
    "Device": "MODERN_8",
    "Model": "MODERN 8"
  },
  {
    "Retail Branding": "OSCAL",
    "Marketing Name": "PILOT 1",
    "Device": "PILOT_1",
    "Model": "PILOT 1"
  },
  {
    "Retail Branding": "OSCAL",
    "Marketing Name": "PILOT 2",
    "Device": "PILOT_2",
    "Model": "PILOT 2"
  },
  {
    "Retail Branding": "OSCAL",
    "Marketing Name": "PILOT 3",
    "Device": "PILOT_3",
    "Model": "PILOT 3"
  },
  {
    "Retail Branding": "OSCAL",
    "Marketing Name": "PILOT 5",
    "Device": "PILOT_5",
    "Model": "PILOT 5"
  },
  {
    "Retail Branding": "OSCAL",
    "Marketing Name": "PILOT 6",
    "Device": "PILOT_6",
    "Model": "PILOT 6"
  },
  {
    "Retail Branding": "OSCAL",
    "Marketing Name": "Pad 100",
    "Device": "Pad_100",
    "Model": "Pad 100"
  },
  {
    "Retail Branding": "OSCAL",
    "Marketing Name": "Pad 15",
    "Device": "Pad15",
    "Model": "Pad 15"
  },
  {
    "Retail Branding": "OSCAL",
    "Marketing Name": "Pad 15",
    "Device": "Pad15_EEA",
    "Model": "Pad 15"
  },
  {
    "Retail Branding": "OSCAL",
    "Marketing Name": "Pad 15",
    "Device": "Pad15_RU",
    "Model": "Pad 15"
  },
  {
    "Retail Branding": "OSCAL",
    "Marketing Name": "Pad 16",
    "Device": "Pad16",
    "Model": "Pad 16"
  },
  {
    "Retail Branding": "OSCAL",
    "Marketing Name": "Pad 18",
    "Device": "Pad18",
    "Model": "Pad 18"
  },
  {
    "Retail Branding": "OSCAL",
    "Marketing Name": "Pad 200",
    "Device": "Pad_200",
    "Model": "Pad 200"
  },
  {
    "Retail Branding": "OSCAL",
    "Marketing Name": "Pad 30 WiFi",
    "Device": "Pad_30_WiFi",
    "Model": "Pad 30 WiFi"
  },
  {
    "Retail Branding": "OSCAL",
    "Marketing Name": "Pad 5",
    "Device": "Pad_5",
    "Model": "Pad 5"
  },
  {
    "Retail Branding": "OSCAL",
    "Marketing Name": "Pad 5 Kids",
    "Device": "Pad_5_Kids",
    "Model": "Pad 5 Kids"
  },
  {
    "Retail Branding": "OSCAL",
    "Marketing Name": "Pad 60 Kids",
    "Device": "Pad_60_Kids",
    "Model": "Pad 60 Kids"
  },
  {
    "Retail Branding": "OSCAL",
    "Marketing Name": "Pad 7",
    "Device": "Pad_7",
    "Model": "Pad 7"
  },
  {
    "Retail Branding": "OSCAL",
    "Marketing Name": "Pad 70",
    "Device": "Pad70_NEU",
    "Model": "Pad 70"
  },
  {
    "Retail Branding": "OSCAL",
    "Marketing Name": "Pad 70 WiFi",
    "Device": "Pad_70_WiFi",
    "Model": "Pad 70 WiFi"
  },
  {
    "Retail Branding": "OSCAL",
    "Marketing Name": "Pad 80 WiFi",
    "Device": "Pad_80_WiFi",
    "Model": "Pad 80 WiFi"
  },
  {
    "Retail Branding": "OSCAL",
    "Marketing Name": "Pad 9",
    "Device": "Pad_9",
    "Model": "Pad 9"
  },
  {
    "Retail Branding": "OSCAL",
    "Marketing Name": "Pad 90",
    "Device": "Pad_90",
    "Model": "Pad 90"
  },
  {
    "Retail Branding": "OSCAL",
    "Marketing Name": "Pad 90 Pro",
    "Device": "Pad_90_Pro",
    "Model": "Pad 90 Pro"
  },
  {
    "Retail Branding": "OSCAL",
    "Marketing Name": "Pad13_EEA",
    "Device": "Pad13_EEA",
    "Model": "Pad 13"
  },
  {
    "Retail Branding": "OSCAL",
    "Marketing Name": "Pad13_NEU",
    "Device": "Pad13_NEU",
    "Model": "Pad 13"
  },
  {
    "Retail Branding": "OSCAL",
    "Marketing Name": "Pad13_RU",
    "Device": "Pad13_NEU",
    "Model": "Pad 13"
  },
  {
    "Retail Branding": "OSCAL",
    "Marketing Name": "Pad60_EEA",
    "Device": "Pad60_EEA",
    "Model": "Pad 60"
  },
  {
    "Retail Branding": "OSCAL",
    "Marketing Name": "Pad60_NEU",
    "Device": "Pad60_NEU",
    "Model": "Pad 60"
  },
  {
    "Retail Branding": "OSCAL",
    "Marketing Name": "Pad_10_EEA",
    "Device": "Pad_10_EEA",
    "Model": "Pad 10"
  },
  {
    "Retail Branding": "OSCAL",
    "Marketing Name": "Pad_10_NEU",
    "Device": "Pad_10_NEU",
    "Model": "Pad 10"
  },
  {
    "Retail Branding": "OSCAL",
    "Marketing Name": "Pad_10_RU",
    "Device": "Pad_10_RU",
    "Model": "Pad 10"
  },
  {
    "Retail Branding": "OSCAL",
    "Marketing Name": "Pad_50_Kids_EEA",
    "Device": "Pad_50_Kids",
    "Model": "Pad 50 Kids"
  },
  {
    "Retail Branding": "OSCAL",
    "Marketing Name": "Pad_50_Kids_NEU",
    "Device": "Pad_50_Kids",
    "Model": "Pad 50 Kids"
  },
  {
    "Retail Branding": "OSCAL",
    "Marketing Name": "Pad_50_Kids_RU",
    "Device": "Pad_50_Kids",
    "Model": "Pad 50 Kids"
  },
  {
    "Retail Branding": "OSCAL",
    "Marketing Name": "Pad_50_WiFi_EEA",
    "Device": "Pad_50_WiFi",
    "Model": "Pad 50 WiFi"
  },
  {
    "Retail Branding": "OSCAL",
    "Marketing Name": "Pad_50_WiFi_NEU",
    "Device": "Pad_50_WiFi",
    "Model": "Pad 50 WiFi"
  },
  {
    "Retail Branding": "OSCAL",
    "Marketing Name": "Pad_50_WiFi_RU",
    "Device": "Pad_50_WiFi",
    "Model": "Pad 50 WiFi"
  },
  {
    "Retail Branding": "OSCAL",
    "Marketing Name": "S60",
    "Device": "S60",
    "Model": "S60"
  },
  {
    "Retail Branding": "OSCAL",
    "Marketing Name": "S60Pro",
    "Device": "S60Pro",
    "Model": "S60Pro"
  },
  {
    "Retail Branding": "OSCAL",
    "Marketing Name": "S70",
    "Device": "S70",
    "Model": "S70"
  },
  {
    "Retail Branding": "OSCAL",
    "Marketing Name": "S70 Pro",
    "Device": "S70_Pro",
    "Model": "S70 Pro"
  },
  {
    "Retail Branding": "OSCAL",
    "Marketing Name": "S80",
    "Device": "S80",
    "Model": "S80"
  },
  {
    "Retail Branding": "OSCAL",
    "Marketing Name": "S80_RU",
    "Device": "S80",
    "Model": "S80"
  },
  {
    "Retail Branding": "OSCAL",
    "Marketing Name": "SPIDER 10",
    "Device": "SPIDER_10",
    "Model": "SPIDER 10"
  },
  {
    "Retail Branding": "OSCAL",
    "Marketing Name": "Spider8_EEA",
    "Device": "Spider8",
    "Model": "Spider 8"
  },
  {
    "Retail Branding": "OSCAL",
    "Marketing Name": "Spider8_NEU",
    "Device": "Spider8",
    "Model": "Spider 8"
  },
  {
    "Retail Branding": "OSCAL",
    "Marketing Name": "Spider8_RU",
    "Device": "Spider8",
    "Model": "Spider 8"
  },
  {
    "Retail Branding": "OSCAL",
    "Marketing Name": "TANK 1",
    "Device": "TANK_1",
    "Model": "TANK 1"
  },
  {
    "Retail Branding": "OSCAL",
    "Marketing Name": "TIGER 10",
    "Device": "Tiger10",
    "Model": "TIGER 10"
  },
  {
    "Retail Branding": "OSCAL",
    "Marketing Name": "TIGER 12",
    "Device": "Tiger12",
    "Model": "TIGER 12"
  },
  {
    "Retail Branding": "OSCAL",
    "Marketing Name": "TIGER 13",
    "Device": "TIGER_13",
    "Model": "TIGER 13"
  },
  {
    "Retail Branding": "OSCAL",
    "Marketing Name": "TIGER 8",
    "Device": "TIGER_8",
    "Model": "TIGER 8"
  },
  {
    "Retail Branding": "OSCAL",
    "Marketing Name": "Tiger 10",
    "Device": "Tiger10",
    "Model": "TIGER 10"
  },
  {
    "Retail Branding": "OSCAL",
    "Marketing Name": "Tiger 12",
    "Device": "Tiger12",
    "Model": "TIGER 12"
  },
  {
    "Retail Branding": "OSN tv",
    "Marketing Name": "NGB22-OSN",
    "Device": "HY45N",
    "Model": "NGB22-OSN"
  },
  {
    "Retail Branding": "OTHO",
    "Marketing Name": "T1",
    "Device": "T1",
    "Model": "T1"
  },
  {
    "Retail Branding": "OTHO",
    "Marketing Name": "T3",
    "Device": "T3",
    "Model": "T3"
  },
  {
    "Retail Branding": "OTK",
    "Marketing Name": "BM57 lite",
    "Device": "BM57_lite",
    "Model": "BM57_lite"
  },
  {
    "Retail Branding": "OTOT",
    "Marketing Name": "B10",
    "Device": "B10",
    "Model": "B10"
  },
  {
    "Retail Branding": "OTOT",
    "Marketing Name": "B11",
    "Device": "B11",
    "Model": "B11"
  },
  {
    "Retail Branding": "OTOT",
    "Marketing Name": "E1",
    "Device": "EOS",
    "Model": "OTOT_E1"
  },
  {
    "Retail Branding": "OTOT",
    "Marketing Name": "H10",
    "Device": "H10",
    "Model": "H10"
  },
  {
    "Retail Branding": "OTOT",
    "Marketing Name": "PS8",
    "Device": "PS8",
    "Model": "PS8"
  },
  {
    "Retail Branding": "OTOT",
    "Marketing Name": "S11",
    "Device": "S11",
    "Model": "S11"
  },
  {
    "Retail Branding": "OTOT",
    "Marketing Name": "S7",
    "Device": "S7",
    "Model": "S7"
  },
  {
    "Retail Branding": "OTOT",
    "Marketing Name": "S8",
    "Device": "S8",
    "Model": "S8"
  },
  {
    "Retail Branding": "OTOT",
    "Marketing Name": "V350",
    "Device": "V350",
    "Model": "V350"
  },
  {
    "Retail Branding": "OTTO",
    "Marketing Name": "OTTO CR05",
    "Device": "OTTO_CR05",
    "Model": "OTTO CR05"
  },
  {
    "Retail Branding": "OUZRS",
    "Marketing Name": "OUZRSM4",
    "Device": "OUZRSM4",
    "Model": "M4"
  },
  {
    "Retail Branding": "OVERTECH",
    "Marketing Name": "OX7A",
    "Device": "OX7A",
    "Model": "OX7A"
  },
  {
    "Retail Branding": "OVERTECH",
    "Marketing Name": "OX7S",
    "Device": "OX7S",
    "Model": "OX7S"
  },
  {
    "Retail Branding": "OWXMobile",
    "Marketing Name": "W50s",
    "Device": "W50s",
    "Model": "W50s"
  },
  {
    "Retail Branding": "OWXMobile",
    "Marketing Name": "W77",
    "Device": "W77",
    "Model": "W77"
  },
  {
    "Retail Branding": "OXYGEN (in)",
    "Marketing Name": "India",
    "Device": "yeongdeungpo",
    "Model": "OXYGEN UHD Android TV"
  },
  {
    "Retail Branding": "OX_TAB",
    "Marketing Name": "Ox-p010-2",
    "Device": "OX_TAB_10",
    "Model": "Ox-p010-2"
  },
  {
    "Retail Branding": "OYYU",
    "Marketing Name": "T11",
    "Device": "OYYUT11",
    "Model": "OYYUT11"
  },
  {
    "Retail Branding": "OYYU",
    "Marketing Name": "T7Pro",
    "Device": "T7Pro",
    "Model": "T7Pro"
  },
  {
    "Retail Branding": "Oale",
    "Marketing Name": "APEX1",
    "Device": "Apex1",
    "Model": "Apex1"
  },
  {
    "Retail Branding": "Oale",
    "Marketing Name": "Apex2",
    "Device": "Apex2",
    "Model": "Apex2"
  },
  {
    "Retail Branding": "Oale",
    "Marketing Name": "Apex3",
    "Device": "Apex3",
    "Model": "Apex3"
  },
  {
    "Retail Branding": "Oale",
    "Marketing Name": "P1",
    "Device": "P1",
    "Model": "P1"
  },
  {
    "Retail Branding": "Oale",
    "Marketing Name": "P2",
    "Device": "P2",
    "Model": "P2"
  },
  {
    "Retail Branding": "Oale",
    "Marketing Name": "P3",
    "Device": "P3",
    "Model": "P3"
  },
  {
    "Retail Branding": "Oale",
    "Marketing Name": "P4",
    "Device": "P4",
    "Model": "P4"
  },
  {
    "Retail Branding": "Oale",
    "Marketing Name": "P5",
    "Device": "P5",
    "Model": "P5"
  },
  {
    "Retail Branding": "Oale",
    "Marketing Name": "P5S",
    "Device": "P5S",
    "Model": "P5S"
  },
  {
    "Retail Branding": "Oale",
    "Marketing Name": "P6",
    "Device": "P6",
    "Model": "P6"
  },
  {
    "Retail Branding": "Oale",
    "Marketing Name": "P6S",
    "Device": "P6S",
    "Model": "P6S"
  },
  {
    "Retail Branding": "Oale",
    "Marketing Name": "XS2_LTE",
    "Device": "XS2_LTE",
    "Model": "XS2_LTE"
  },
  {
    "Retail Branding": "Oale",
    "Marketing Name": "dbx",
    "Device": "dbx",
    "Model": "dbx"
  },
  {
    "Retail Branding": "Oangcc",
    "Marketing Name": "A13_EEA",
    "Device": "A13_EEA",
    "Model": "A13_EEA"
  },
  {
    "Retail Branding": "Oangcc",
    "Marketing Name": "A13_US",
    "Device": "A13_US",
    "Model": "A13_US"
  },
  {
    "Retail Branding": "Oangcc",
    "Marketing Name": "A15_EEA",
    "Device": "A15_EEA",
    "Model": "A15_EEA"
  },
  {
    "Retail Branding": "Oangcc",
    "Marketing Name": "A6_EEA",
    "Device": "A6_EEA",
    "Model": "A6_EEA"
  },
  {
    "Retail Branding": "Oangcc",
    "Marketing Name": "A6_US",
    "Device": "A6_US",
    "Model": "A6_US"
  },
  {
    "Retail Branding": "Oangcc",
    "Marketing Name": "A9-EEA",
    "Device": "A9-EEA",
    "Model": "A9-EEA"
  },
  {
    "Retail Branding": "Oangcc",
    "Marketing Name": "A9_EEA",
    "Device": "A9_EEA",
    "Model": "A9_EEA"
  },
  {
    "Retail Branding": "Oangcc",
    "Marketing Name": "A9_US",
    "Device": "A9_US",
    "Model": "A9_US"
  },
  {
    "Retail Branding": "Oangcc",
    "Marketing Name": "TAB_A8_EEA_T",
    "Device": "TAB_A8_EEA_T",
    "Model": "TAB_A8_EEA"
  },
  {
    "Retail Branding": "Oangcc",
    "Marketing Name": "TAB_A8_T",
    "Device": "TAB_A8_T",
    "Model": "TAB_A8_US"
  },
  {
    "Retail Branding": "Oangcc",
    "Marketing Name": "Tab-A8",
    "Device": "Tab-A8",
    "Model": "Tab-A8"
  },
  {
    "Retail Branding": "Oangcc",
    "Marketing Name": "Tab-A8_EEA",
    "Device": "Tab-A8_EEA",
    "Model": "Tab-A8_EEA"
  },
  {
    "Retail Branding": "Oangcc",
    "Marketing Name": "Tab_A6",
    "Device": "Tab_A6",
    "Model": "Tab_A6"
  },
  {
    "Retail Branding": "Oangcc",
    "Marketing Name": "Tab_A6_EEA",
    "Device": "Tab_A6_EEA",
    "Model": "Tab_A6_EEA"
  },
  {
    "Retail Branding": "Obi",
    "Marketing Name": "MV1",
    "Device": "yam",
    "Model": "OBI MV1"
  },
  {
    "Retail Branding": "Obi",
    "Marketing Name": "MV1",
    "Device": "yam",
    "Model": "Obi MV1"
  },
  {
    "Retail Branding": "Obi",
    "Marketing Name": "OBJ SJ1.5",
    "Device": "SJ1-5",
    "Model": "SJ1-5"
  },
  {
    "Retail Branding": "Oceusnetworks",
    "Marketing Name": "Xiphos®TMD",
    "Device": "granite",
    "Model": "Xiphos(R)TMD"
  },
  {
    "Retail Branding": "Ocilion",
    "Marketing Name": "Ocilion",
    "Device": "HP4CD-Ocilion",
    "Model": "Ocilion-p610"
  },
  {
    "Retail Branding": "Octopus",
    "Marketing Name": "Octopus_One",
    "Device": "Octopus_One",
    "Model": "Octopus_One"
  },
  {
    "Retail Branding": "Odea",
    "Marketing Name": "A10_EEA",
    "Device": "A10_EEA",
    "Model": "A10"
  },
  {
    "Retail Branding": "Odea",
    "Marketing Name": "A10_EEA",
    "Device": "A10_EEA",
    "Model": "A10_EEA"
  },
  {
    "Retail Branding": "Odea",
    "Marketing Name": "A10_ROW",
    "Device": "A10_ROW",
    "Model": "A10"
  },
  {
    "Retail Branding": "Odea",
    "Marketing Name": "A10_ROW",
    "Device": "A10_ROW",
    "Model": "A10_ROW"
  },
  {
    "Retail Branding": "Odea",
    "Marketing Name": "A11_EEA",
    "Device": "A11_EEA",
    "Model": "A11"
  },
  {
    "Retail Branding": "Odea",
    "Marketing Name": "A11_ROW",
    "Device": "A11_ROW",
    "Model": "A11"
  },
  {
    "Retail Branding": "Odea",
    "Marketing Name": "A12_B_EEA",
    "Device": "A12_B_EEA",
    "Model": "A12"
  },
  {
    "Retail Branding": "Odea",
    "Marketing Name": "A12_B_ROW",
    "Device": "A12_B_ROW",
    "Model": "A12"
  },
  {
    "Retail Branding": "Odea",
    "Marketing Name": "A12_EEA",
    "Device": "A12_EEA",
    "Model": "A12"
  },
  {
    "Retail Branding": "Odea",
    "Marketing Name": "A12_ROW",
    "Device": "A12_ROW",
    "Model": "A12"
  },
  {
    "Retail Branding": "Odea",
    "Marketing Name": "A12_RUS",
    "Device": "A12_RUS",
    "Model": "A12"
  },
  {
    "Retail Branding": "Odea",
    "Marketing Name": "A13_EEA",
    "Device": "A13",
    "Model": "A13_EEA"
  },
  {
    "Retail Branding": "Odea",
    "Marketing Name": "S11_EEA",
    "Device": "S11_EEA",
    "Model": "S11"
  },
  {
    "Retail Branding": "Odea",
    "Marketing Name": "S11_EEA",
    "Device": "S11_EEA",
    "Model": "S11_EEA"
  },
  {
    "Retail Branding": "Odea",
    "Marketing Name": "S11_ROW",
    "Device": "S11_ROW",
    "Model": "S11"
  },
  {
    "Retail Branding": "Odea",
    "Marketing Name": "S11_ROW",
    "Device": "S11_ROW",
    "Model": "S11_ROW"
  },
  {
    "Retail Branding": "Odido",
    "Marketing Name": "4K TV Box",
    "Device": "SEI800TFAS",
    "Model": "4K TV Box"
  },
  {
    "Retail Branding": "Odotpad",
    "Marketing Name": "FIRE_V7",
    "Device": "FIRE_V7",
    "Model": "FIRE_V7"
  },
  {
    "Retail Branding": "Odys",
    "Marketing Name": "UNO X10",
    "Device": "UNO_X10",
    "Model": "UNO X10"
  },
  {
    "Retail Branding": "Odys",
    "Marketing Name": "UNO X8",
    "Device": "UNO_X8",
    "Model": "UNO_X8"
  },
  {
    "Retail Branding": "Oioo",
    "Marketing Name": "Model 2",
    "Device": "wecct",
    "Model": "Model 2"
  },
  {
    "Retail Branding": "Oioo",
    "Marketing Name": "Model 3",
    "Device": "wecct3",
    "Model": "Model 3"
  },
  {
    "Retail Branding": "Okin",
    "Marketing Name": "FP2901",
    "Device": "FP2901",
    "Model": "FP2901"
  },
  {
    "Retail Branding": "Okin",
    "Marketing Name": "Tablet_FP",
    "Device": "FP290101",
    "Model": "FP290101"
  },
  {
    "Retail Branding": "Olike",
    "Marketing Name": "E1",
    "Device": "E1",
    "Model": "E1"
  },
  {
    "Retail Branding": "Olike",
    "Marketing Name": "E3",
    "Device": "E3",
    "Model": "E3"
  },
  {
    "Retail Branding": "Olimpo",
    "Marketing Name": "R3",
    "Device": "R3",
    "Model": "R3"
  },
  {
    "Retail Branding": "Olimpo",
    "Marketing Name": "R3_GTV",
    "Device": "R3_GTV",
    "Model": "R3G"
  },
  {
    "Retail Branding": "Olimpo",
    "Marketing Name": "R4",
    "Device": "R4",
    "Model": "R4"
  },
  {
    "Retail Branding": "Olimpo",
    "Marketing Name": "R4_GTV",
    "Device": "R4_GTV",
    "Model": "R4G"
  },
  {
    "Retail Branding": "Olive Oil",
    "Marketing Name": "CT4",
    "Device": "octopus-ct4",
    "Model": "Octopus A83 CT4"
  },
  {
    "Retail Branding": "Olive Oil",
    "Marketing Name": "OliveOil Model 3",
    "Device": "wecct3",
    "Model": "CT3"
  },
  {
    "Retail Branding": "Olivetti",
    "Marketing Name": "FORM300",
    "Device": "FORM300",
    "Model": "FORM300"
  },
  {
    "Retail Branding": "Olivetti",
    "Marketing Name": "Graphos A10",
    "Device": "Graphos_A10",
    "Model": "Graphos A10"
  },
  {
    "Retail Branding": "Olivetti",
    "Marketing Name": "OP110",
    "Device": "OP110",
    "Model": "OP110"
  },
  {
    "Retail Branding": "Olla",
    "Marketing Name": "M5",
    "Device": "M5",
    "Model": "M5"
  },
  {
    "Retail Branding": "Olla",
    "Marketing Name": "M6",
    "Device": "M6",
    "Model": "M6"
  },
  {
    "Retail Branding": "Olla",
    "Marketing Name": "M8",
    "Device": "M8",
    "Model": "M8"
  },
  {
    "Retail Branding": "Olla",
    "Marketing Name": "M8_PLUS",
    "Device": "M8_PLUS",
    "Model": "M8_PLUS"
  },
  {
    "Retail Branding": "Olla",
    "Marketing Name": "Note3",
    "Device": "Note3",
    "Model": "Note3"
  },
  {
    "Retail Branding": "Olla",
    "Marketing Name": "V9",
    "Device": "V9",
    "Model": "V9"
  },
  {
    "Retail Branding": "Ollee",
    "Marketing Name": "T07TR1W",
    "Device": "T07TR1W",
    "Model": "T07TR1W"
  },
  {
    "Retail Branding": "Ollee",
    "Marketing Name": "T08HM3MSA9",
    "Device": "T08HM3MSA9",
    "Model": "T08HM3MSA9"
  },
  {
    "Retail Branding": "Ollee",
    "Marketing Name": "XT080",
    "Device": "XT080",
    "Model": "XT080"
  },
  {
    "Retail Branding": "Olvy",
    "Marketing Name": "CH10PLUS",
    "Device": "CH10PLUS",
    "Model": "CH10PLUS"
  },
  {
    "Retail Branding": "Olympia",
    "Marketing Name": "NEO",
    "Device": "NEO",
    "Model": "NEO"
  },
  {
    "Retail Branding": "Olympia",
    "Marketing Name": "NEO_Mini",
    "Device": "NEO_Mini",
    "Model": "NEO_Mini"
  },
  {
    "Retail Branding": "Olympia",
    "Marketing Name": "Smartphone2",
    "Device": "NEO_Mini_Plus",
    "Model": "OLYMPIA Neo_Mini+"
  },
  {
    "Retail Branding": "Olympia",
    "Marketing Name": "TREK",
    "Device": "TREK",
    "Model": "TREK"
  },
  {
    "Retail Branding": "OneClick",
    "Marketing Name": "C2 Pro",
    "Device": "C2_pro",
    "Model": "C2 pro"
  },
  {
    "Retail Branding": "OneClick",
    "Marketing Name": "X1",
    "Device": "X1",
    "Model": "X1"
  },
  {
    "Retail Branding": "OneLern",
    "Marketing Name": "OneLernDB009",
    "Device": "OneLernDB009",
    "Model": "OneLernDB009"
  },
  {
    "Retail Branding": "OneLern",
    "Marketing Name": "OneLernDB010",
    "Device": "OneLernDB010",
    "Model": "OneLernDB010"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": 2,
    "Device": "OnePlus2",
    "Model": "ONE A2003"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": 3,
    "Device": "OnePlus3",
    "Model": "ONEPLUS A3000"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "C00",
    "Device": "Cebu",
    "Model": "C00"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "D00",
    "Device": "Dubai",
    "Model": "D00"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "E00",
    "Device": "Edinburgh",
    "Model": "E00"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "H93A",
    "Device": "songni",
    "Model": "H93A"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "N1",
    "Device": "songni",
    "Model": "S70A"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "N1 Pro",
    "Device": "songni",
    "Model": "H80A"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "Nord CE5",
    "Device": "OP613BL1",
    "Model": "CPH2717"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "Nord CE5",
    "Device": "OP613BL1",
    "Model": "CPH2719"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "One",
    "Device": "A0001",
    "Model": "A0001"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "One",
    "Device": "A0001",
    "Model": "One"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "OnePlus",
    "Device": "OnePlus",
    "Model": "ONE E1003"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "OnePlus 10 Pro",
    "Device": "OP516EL1",
    "Model": "NE2210"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "OnePlus 10 Pro 5G",
    "Device": "OP516FL1",
    "Model": "NE2211"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "OnePlus 10 Pro 5G",
    "Device": "OP516FL1",
    "Model": "NE2213"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "OnePlus 10 Pro 5G",
    "Device": "OP516FL1",
    "Model": "NE2215"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "OnePlus 10 Pro 5G",
    "Device": "OP516FL1",
    "Model": "NE2217"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "OnePlus 10R 5G",
    "Device": "OP5566L1",
    "Model": "CPH2411"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "OnePlus 10R 5G",
    "Device": "OP5567L1",
    "Model": "CPH2423"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "OnePlus 10T 5G",
    "Device": "OP5552L1",
    "Model": "CPH2413"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "OnePlus 10T 5G",
    "Device": "OP5552L1",
    "Model": "CPH2415"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "OnePlus 10T 5G",
    "Device": "OP5552L1",
    "Model": "CPH2417"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "OnePlus 10T 5G",
    "Device": "OP5552L1",
    "Model": "CPH2419"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "OnePlus 11 5G",
    "Device": "OP594DL1",
    "Model": "CPH2447"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "OnePlus 11 5G",
    "Device": "OP594DL1",
    "Model": "CPH2449"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "OnePlus 11 5G",
    "Device": "OP594DL1",
    "Model": "CPH2451"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "OnePlus 11 5G 中国版",
    "Device": "OP591BL1",
    "Model": "PHB110"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "OnePlus 11R 5G",
    "Device": "OP5961L1",
    "Model": "CPH2487"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "OnePlus 12",
    "Device": "OP5929L1",
    "Model": "PJD110"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "OnePlus 12",
    "Device": "OP595DL1",
    "Model": "CPH2573"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "OnePlus 12",
    "Device": "OP595DL1",
    "Model": "CPH2581"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "OnePlus 12",
    "Device": "OP595DL1",
    "Model": "CPH2583"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "OnePlus 12R",
    "Device": "OP5D35L1",
    "Model": "CPH2585"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "OnePlus 12R",
    "Device": "OP5D35L1",
    "Model": "CPH2609"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "OnePlus 12R",
    "Device": "OP5D35L1",
    "Model": "CPH2611"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "OnePlus 13",
    "Device": "OP5D0DL1",
    "Model": "PJZ110"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "OnePlus 13",
    "Device": "OP5D55L1",
    "Model": "CPH2649"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "OnePlus 13",
    "Device": "OP5D55L1",
    "Model": "CPH2653"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "OnePlus 13",
    "Device": "OP5D55L1",
    "Model": "CPH2655"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "OnePlus 13R",
    "Device": "OP5D3BL1",
    "Model": "CPH2645"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "OnePlus 13R",
    "Device": "OP5D3BL1",
    "Model": "CPH2647"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "OnePlus 13R",
    "Device": "OP5D3BL1",
    "Model": "CPH2691"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "OnePlus 13T",
    "Device": "OP60F5L1",
    "Model": "PKX110"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "OnePlus 13s",
    "Device": "OP612BL1",
    "Model": "CPH2723"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "OnePlus 15",
    "Device": "OP60FFL1",
    "Model": "PLK110"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "OnePlus 15",
    "Device": "OP611FL1",
    "Model": "CPH2745"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "OnePlus 15",
    "Device": "OP611FL1",
    "Model": "CPH2747"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "OnePlus 15",
    "Device": "OP611FL1",
    "Model": "CPH2749"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "OnePlus 15R",
    "Device": "OP612DL1",
    "Model": "CPH2767"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "OnePlus 15R",
    "Device": "OP612DL1",
    "Model": "CPH2769"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "OnePlus 15R",
    "Device": "OP612DL1",
    "Model": "CPH2771"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "OnePlus 15T",
    "Device": "OP64DDL1",
    "Model": "PLZ110"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "OnePlus 6",
    "Device": "OnePlus6",
    "Model": "ONEPLUS A6000"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "OnePlus 6",
    "Device": "OnePlus6",
    "Model": "ONEPLUS A6003"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "OnePlus 7",
    "Device": "OnePlus7",
    "Model": "GM1900"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "OnePlus 7",
    "Device": "OnePlus7",
    "Model": "GM1901"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "OnePlus 7",
    "Device": "OnePlus7",
    "Model": "GM1903"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "OnePlus 7",
    "Device": "OnePlus7",
    "Model": "GM1905"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "OnePlus 7 Pro",
    "Device": "OP7ProNRSpr",
    "Model": "GM1925"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "OnePlus 7 Pro",
    "Device": "OnePlus7Pro",
    "Model": "GM1910"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "OnePlus 7 Pro",
    "Device": "OnePlus7Pro",
    "Model": "GM1911"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "OnePlus 7 Pro",
    "Device": "OnePlus7Pro",
    "Model": "GM1913"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "OnePlus 7 Pro",
    "Device": "OnePlus7Pro",
    "Model": "GM1917"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "OnePlus 7 Pro",
    "Device": "OnePlus7ProTMO",
    "Model": "GM1915"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "OnePlus 7 Pro 5G",
    "Device": "OnePlus7ProNR",
    "Model": "GM1920"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "OnePlus 7T",
    "Device": "OnePlus7T",
    "Model": "HD1900"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "OnePlus 7T",
    "Device": "OnePlus7T",
    "Model": "HD1901"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "OnePlus 7T",
    "Device": "OnePlus7T",
    "Model": "HD1903"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "OnePlus 7T",
    "Device": "OnePlus7T",
    "Model": "HD1905"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "OnePlus 7T",
    "Device": "OnePlus7TTMO",
    "Model": "HD1907"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "OnePlus 7T Pro",
    "Device": "OnePlus7TPro",
    "Model": "HD1910"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "OnePlus 7T Pro",
    "Device": "OnePlus7TPro",
    "Model": "HD1911"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "OnePlus 7T Pro",
    "Device": "OnePlus7TPro",
    "Model": "HD1913"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "OnePlus 7T Pro 5G",
    "Device": "OnePlus7TProNR",
    "Model": "HD1925"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "OnePlus 8",
    "Device": "OnePlus8",
    "Model": "IN2010"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "OnePlus 8",
    "Device": "OnePlus8",
    "Model": "IN2011"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "OnePlus 8",
    "Device": "OnePlus8",
    "Model": "IN2013"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "OnePlus 8",
    "Device": "OnePlus8",
    "Model": "IN2015"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "OnePlus 8",
    "Device": "OnePlus8Visible",
    "Model": "IN2015"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "OnePlus 8 5G",
    "Device": "OnePlus8TMO",
    "Model": "IN2015"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "OnePlus 8 5G",
    "Device": "OnePlus8TMO",
    "Model": "IN2017"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "OnePlus 8 5G UW",
    "Device": "OnePlus8VZW",
    "Model": "IN2019"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "OnePlus 8 Pro",
    "Device": "OnePlus8Pro",
    "Model": "IN2020"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "OnePlus 8 Pro",
    "Device": "OnePlus8Pro",
    "Model": "IN2021"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "OnePlus 8 Pro",
    "Device": "OnePlus8Pro",
    "Model": "IN2023"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "OnePlus 8 Pro",
    "Device": "OnePlus8Pro",
    "Model": "IN2025"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "OnePlus 8T",
    "Device": "OnePlus8T",
    "Model": "KB2000"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "OnePlus 8T",
    "Device": "OnePlus8T",
    "Model": "KB2001"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "OnePlus 8T",
    "Device": "OnePlus8T",
    "Model": "KB2003"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "OnePlus 8T",
    "Device": "OnePlus8T",
    "Model": "KB2005"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "OnePlus 8T+ 5G",
    "Device": "OnePlus8TTMO",
    "Model": "KB2007"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "OnePlus 9 5G",
    "Device": "OnePlus9",
    "Model": "LE2110"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "OnePlus 9 5G",
    "Device": "OnePlus9",
    "Model": "LE2111"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "OnePlus 9 5G",
    "Device": "OnePlus9",
    "Model": "LE2113"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "OnePlus 9 5G",
    "Device": "OnePlus9",
    "Model": "LE2115"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "OnePlus 9 5G",
    "Device": "OnePlus9TMO",
    "Model": "LE2117"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "OnePlus 9 Pro 5G",
    "Device": "OnePlus9Pro",
    "Model": "LE2120"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "OnePlus 9 Pro 5G",
    "Device": "OnePlus9Pro",
    "Model": "LE2121"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "OnePlus 9 Pro 5G",
    "Device": "OnePlus9Pro",
    "Model": "LE2123"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "OnePlus 9 Pro 5G",
    "Device": "OnePlus9Pro",
    "Model": "LE2125"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "OnePlus 9 Pro 5G",
    "Device": "OnePlus9ProTMO",
    "Model": "LE2127"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "OnePlus 9R",
    "Device": "OnePlus9R",
    "Model": "LE2100"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "OnePlus 9R",
    "Device": "OnePlus9R",
    "Model": "LE2101"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "OnePlus 9RT 5G",
    "Device": "OP5154L1",
    "Model": "MT2110"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "OnePlus 9RT 5G",
    "Device": "OP5155L1",
    "Model": "MT2111"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "OnePlus Ace",
    "Device": "OP5565",
    "Model": "PGKM10"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "OnePlus Ace 3",
    "Device": "OP5CF9L1",
    "Model": "PJE110"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "OnePlus Ace 3V",
    "Device": "OP5CFBL1",
    "Model": "PJF110"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "OnePlus Ace 5",
    "Device": "OP5D2BL1",
    "Model": "PKG110"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "OnePlus Ace 5 Pro",
    "Device": "OP60EBL1",
    "Model": "PKR110"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "OnePlus Ace 5 竞速版",
    "Device": "OP60F9L1",
    "Model": "PLF110"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "OnePlus Ace 5 至尊版",
    "Device": "OP60EDL1",
    "Model": "PLC110"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "OnePlus Ace 6",
    "Device": "OP6113L1",
    "Model": "PLQ110"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "OnePlus Ace 竞速版",
    "Device": "OP5911",
    "Model": "PGZ110"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "OnePlus Nord",
    "Device": "Nord",
    "Model": "AC2001"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "OnePlus Nord",
    "Device": "Nord",
    "Model": "AC2003"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "OnePlus Nord 2T 5G",
    "Device": "OP557AL1",
    "Model": "CPH2399"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "OnePlus Nord 2T 5G",
    "Device": "OP557AL1",
    "Model": "CPH2401"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "OnePlus Nord 3 5G",
    "Device": "OP556FL1",
    "Model": "CPH2491"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "OnePlus Nord 3 5G",
    "Device": "OP556FL1",
    "Model": "CPH2493"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "OnePlus Nord 4",
    "Device": "OP5E93L1",
    "Model": "CPH2661"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "OnePlus Nord 4",
    "Device": "OP5E93L1",
    "Model": "CPH2663"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "OnePlus Nord 5",
    "Device": "OP6131L1",
    "Model": "CPH2707"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "OnePlus Nord 5",
    "Device": "OP6131L1",
    "Model": "CPH2709"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "OnePlus Nord CE 2",
    "Device": "OP555BL1",
    "Model": "IV2201"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "OnePlus Nord CE 2 Lite 5G",
    "Device": "OP535DL1",
    "Model": "CPH2381"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "OnePlus Nord CE 2 Lite 5G",
    "Device": "OP535DL1",
    "Model": "CPH2409"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "OnePlus Nord CE 3 Lite 5G",
    "Device": "OP5958L1",
    "Model": "CPH2465"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "OnePlus Nord CE 3 Lite 5G",
    "Device": "OP5958L1",
    "Model": "CPH2467"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "OnePlus Nord CE 5G",
    "Device": "OnePlusNordCE",
    "Model": "EB2101"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "OnePlus Nord CE 5G",
    "Device": "OnePlusNordCE",
    "Model": "EB2103"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "OnePlus Nord CE4",
    "Device": "OP5D3FL1",
    "Model": "CPH2613"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "OnePlus Nord CE4 Lite 5G",
    "Device": "OP5D49L1",
    "Model": "CPH2619"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "OnePlus Nord CE4 Lite 5G",
    "Device": "OP5D49L1",
    "Model": "CPH2621"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "OnePlus Nord N10 5G",
    "Device": "OnePlusN10",
    "Model": "BE2026"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "OnePlus Nord N10 5G",
    "Device": "OnePlusN10",
    "Model": "BE2028"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "OnePlus Nord N10 5G",
    "Device": "OnePlusN10",
    "Model": "BE2029"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "OnePlus Nord N10 5G",
    "Device": "OnePlusN10METRO",
    "Model": "BE2025"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "OnePlus Nord N10 5G",
    "Device": "OnePlusN10METRO",
    "Model": "BE2029"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "OnePlus Nord N10 5G",
    "Device": "OnePlusN10TMO",
    "Model": "BE2028"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "OnePlus Nord N10 5G",
    "Device": "OnePlusN10TMO",
    "Model": "BE2029"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "OnePlus Nord N100",
    "Device": "OnePlusN100",
    "Model": "BE2011"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "OnePlus Nord N100",
    "Device": "OnePlusN100",
    "Model": "BE2013"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "OnePlus Nord N100",
    "Device": "OnePlusN100METRO",
    "Model": "BE2015"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "OnePlus Nord N100",
    "Device": "OnePlusN100TMO",
    "Model": "BE2012"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "OnePlus Nord N100",
    "Device": "OnePlusN100TMO",
    "Model": "BE2013"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "OnePlus Nord N20 5G",
    "Device": "OP5159L1",
    "Model": "CPH2459"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "OnePlus Nord N20 5G",
    "Device": "OP515AL1",
    "Model": "GN2200"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "OnePlus Nord N200 5G",
    "Device": "OnePlusN200",
    "Model": "DE2117"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "OnePlus Nord N200 5G",
    "Device": "OnePlusN200TMO",
    "Model": "DE2118"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "OnePlus Nord N30 5G",
    "Device": "OP5958L1",
    "Model": "CPH2513"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "OnePlus Nord N30 5G",
    "Device": "OP5958L1",
    "Model": "CPH2515"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "OnePlus Nord N30 SE 5G",
    "Device": "OP5955L1",
    "Model": "CPH2605"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "OnePlus Nord2 5G",
    "Device": "OP515BL1",
    "Model": "DN2101"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "OnePlus Nord2 5G",
    "Device": "OP515BL1",
    "Model": "DN2103"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "OnePlus Pad",
    "Device": "OP59BCL1",
    "Model": "OPD2203"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "OnePlus Pad",
    "Device": "OP615AL1",
    "Model": "OPD2407"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "OnePlus Pad Go",
    "Device": "OP5DA6L1",
    "Model": "OPD2304"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "OnePlus Pad Lite",
    "Device": "OP6194L1",
    "Model": "OPD2480"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "OnePlus Pad Lite",
    "Device": "OP6195L1",
    "Model": "OPD2481"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "OnePlus Turbo 6",
    "Device": "OP60F0L1",
    "Model": "PLU110"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "OnePlus Turbo 6V",
    "Device": "OP64D3L1",
    "Model": "PLY110"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "OnePlus Watch 2",
    "Device": "OPWWE231",
    "Model": "OPWWE231"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "OnePlus Watch 2R",
    "Device": "OPWWE234",
    "Model": "OPWWE234"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "OnePlus Watch 3",
    "Device": "OPWWE251",
    "Model": "OPWWE251"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "OnePlus2",
    "Device": "OnePlus2",
    "Model": "ONE A2003"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "OnePlus3",
    "Device": "OnePlus3",
    "Model": "ONEPLUS A3000"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "OnePlus3T",
    "Device": "OnePlus3T",
    "Model": "ONEPLUS A3000"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "OnePlus5",
    "Device": "OnePlus5",
    "Model": "ONEPLUS A5000"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "OnePlus5T",
    "Device": "OnePlus5T",
    "Model": "ONEPLUS A5010"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "OnePlus6T",
    "Device": "OnePlus6T",
    "Model": "ONEPLUS A6010"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "OnePlus6T",
    "Device": "OnePlus6T",
    "Model": "ONEPLUS A6013"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "OnePlus6T",
    "Device": "OnePlus6TSingle",
    "Model": "ONEPLUS A6013"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "Oneplus Ace 2 Pro",
    "Device": "OP5943L1",
    "Model": "PJA110"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "Oneplus Ace 3 Pro",
    "Device": "OP5D06L1",
    "Model": "PJX110"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "Oneplus Pad2",
    "Device": "OP5DAAL1",
    "Model": "OPD2403"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "Oneplus_Dosa_IN",
    "Device": "Oneplus_Dosa_IN",
    "Model": "Oneplus_Dosa_IN"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "Open",
    "Device": "OP5973L1",
    "Model": "CPH2551"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "PHP110",
    "Device": "OP5927",
    "Model": "PHP110"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "Pad 3",
    "Device": "OP6190L1",
    "Model": "OPD2415"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "Pad Go 2",
    "Device": "OP6575L1",
    "Model": "OPD2504"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "Pad Go 2",
    "Device": "OP6575L1",
    "Model": "OPD2505"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "X",
    "Device": "OnePlus",
    "Model": "ONE E1003"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "Y Series",
    "Device": "shibuya",
    "Model": "Y Series"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "一加 Ace 6T",
    "Device": "OP6117L1",
    "Model": "PLR110"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "一加平板 2",
    "Device": "OP6543L1",
    "Model": "OPD2508"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "一加平板 2 Pro",
    "Device": "OP615EL1",
    "Model": "OPD2413"
  },
  {
    "Retail Branding": "OnePlus",
    "Marketing Name": "一加平板Pro",
    "Device": "OP5D77L1",
    "Model": "OPD2404"
  },
  {
    "Retail Branding": "OneScreen",
    "Marketing Name": "OPS LF with Android",
    "Device": "OneScreen-OPS-LF",
    "Model": "OneScreen-OPS-LFA"
  },
  {
    "Retail Branding": "OneScreen",
    "Marketing Name": "OneScreen T7",
    "Device": "rk3588_t",
    "Model": "T7"
  },
  {
    "Retail Branding": "OneScreen",
    "Marketing Name": "OneScreen Titan",
    "Device": "oversea_v",
    "Model": "Titan"
  },
  {
    "Retail Branding": "OneScreen",
    "Marketing Name": "OneScreen_Core",
    "Device": "OneScreen_Core",
    "Model": "Core"
  },
  {
    "Retail Branding": "OneScreen",
    "Marketing Name": "Wandr_W1",
    "Device": "Wandr",
    "Model": "OneScreen Wandr"
  },
  {
    "Retail Branding": "Onix",
    "Marketing Name": "AT101-1118",
    "Device": "AT101-1118",
    "Model": "AT101-1118"
  },
  {
    "Retail Branding": "Onkyo",
    "Marketing Name": "DP-CMX1",
    "Device": "Gravity_128",
    "Model": "DP-CMX1"
  },
  {
    "Retail Branding": "Onkyo",
    "Marketing Name": "DP-CTX1",
    "Device": "DP-CTX1",
    "Model": "DP-CTX1"
  },
  {
    "Retail Branding": "Onkyo",
    "Marketing Name": "DP-X1",
    "Device": "Rai_Zin_32",
    "Model": "DP-X1"
  },
  {
    "Retail Branding": "Onkyo",
    "Marketing Name": "DP-X1A",
    "Device": "Rai_Zin2R_64",
    "Model": "DP-X1A"
  },
  {
    "Retail Branding": "Onn (Walmart)",
    "Marketing Name": 100005207,
    "Device": 100005207,
    "Model": 100005207
  },
  {
    "Retail Branding": "Onn (Walmart)",
    "Marketing Name": 100005208,
    "Device": 100005208,
    "Model": 100005208
  },
  {
    "Retail Branding": "Onn (Walmart)",
    "Marketing Name": "100005208-CA",
    "Device": "100005208-CA",
    "Model": "100005208-CA"
  },
  {
    "Retail Branding": "Onn (Walmart)",
    "Marketing Name": 100005209,
    "Device": 100005209,
    "Model": 100005209
  },
  {
    "Retail Branding": "Onn (Walmart)",
    "Marketing Name": "100011886A",
    "Device": "100011886A",
    "Model": "100011886A"
  },
  {
    "Retail Branding": "Onn (Walmart)",
    "Marketing Name": "100011886CA",
    "Device": "100011886CA",
    "Model": "100011886CA"
  },
  {
    "Retail Branding": "Onn (Walmart)",
    "Marketing Name": "100015685-E",
    "Device": "100015685-E",
    "Model": "100015685-E"
  },
  {
    "Retail Branding": "Onn (Walmart)",
    "Marketing Name": 100026191,
    "Device": "mid7018_mr_32",
    "Model": 100026191
  },
  {
    "Retail Branding": "Onn (Walmart)",
    "Marketing Name": 100026203,
    "Device": "mid1035_mq",
    "Model": 100026203
  },
  {
    "Retail Branding": "Onn (Walmart)",
    "Marketing Name": 100043279,
    "Device": "mid1105_mp",
    "Model": 100043279
  },
  {
    "Retail Branding": "Onn (Walmart)",
    "Marketing Name": "M17QF21M",
    "Device": "M17QF21M",
    "Model": "M17QF21M"
  },
  {
    "Retail Branding": "Onn (Walmart)",
    "Marketing Name": "MID1032C",
    "Device": "mid1032_mr_32",
    "Model": "MID1032C"
  },
  {
    "Retail Branding": "Onn (Walmart)",
    "Marketing Name": "ONA19TB002",
    "Device": "ONA19TB002",
    "Model": "ONA19TB002"
  },
  {
    "Retail Branding": "Onn (Walmart)",
    "Marketing Name": "ONA19TB003",
    "Device": "ONA19TB003",
    "Model": "ONA19TB003"
  },
  {
    "Retail Branding": "Onn (Walmart)",
    "Marketing Name": "ONA19TB007",
    "Device": "ONA19TB007",
    "Model": "ONA19TB007"
  },
  {
    "Retail Branding": "Onn (Walmart)",
    "Marketing Name": "Onn 2k TV stick",
    "Device": "stephen",
    "Model": "Onn 2k TV stick"
  },
  {
    "Retail Branding": "Onn (Walmart)",
    "Marketing Name": "PM106A",
    "Device": "PM106A",
    "Model": "PM106A"
  },
  {
    "Retail Branding": "Onn (Walmart)",
    "Marketing Name": "PM108T",
    "Device": "PM108T",
    "Model": "PM108T"
  },
  {
    "Retail Branding": "Onn (Walmart)",
    "Marketing Name": "PM116TPro",
    "Device": "PM116TPro",
    "Model": "PM116TPro"
  },
  {
    "Retail Branding": "Onn (Walmart)",
    "Marketing Name": "PM82T",
    "Device": "PM82T",
    "Model": "PM82T"
  },
  {
    "Retail Branding": "Onn (Walmart)",
    "Marketing Name": "PP86AW",
    "Device": "PP86AW",
    "Model": "PP86AW"
  },
  {
    "Retail Branding": "Onn (Walmart)",
    "Marketing Name": "PP86A_W",
    "Device": "PP86A_W",
    "Model": "PP86A_W"
  },
  {
    "Retail Branding": "Onn (Walmart)",
    "Marketing Name": "TBBVNC100005207",
    "Device": "TBBVNC100005207",
    "Model": "TBBVNC100005207"
  },
  {
    "Retail Branding": "Onn (Walmart)",
    "Marketing Name": "TBBVNC100005208",
    "Device": "TBBVNC100005208",
    "Model": "TBBVNC100005208"
  },
  {
    "Retail Branding": "Onn (Walmart)",
    "Marketing Name": "TBBVNC100005209",
    "Device": "TBBVNC100005209",
    "Model": "TBBVNC100005209"
  },
  {
    "Retail Branding": "Onn (Walmart)",
    "Marketing Name": "W723",
    "Device": "W723",
    "Model": "W723"
  },
  {
    "Retail Branding": "Ooredoo",
    "Marketing Name": "Ooredoo TV",
    "Device": "diw387oor",
    "Model": "DIW387_UHD_OOR"
  },
  {
    "Retail Branding": "Ooredoo",
    "Marketing Name": "Ooredoo tv",
    "Device": "HP44J",
    "Model": "SKW-HP44J-OTV"
  },
  {
    "Retail Branding": "Ooredoo",
    "Marketing Name": "Smart10_Pro",
    "Device": "Smart10_Pro",
    "Model": "Smart10_Pro"
  },
  {
    "Retail Branding": "Opay",
    "Marketing Name": "M1 Lite",
    "Device": "M1_Lite",
    "Model": "M1 Lite"
  },
  {
    "Retail Branding": "Opay",
    "Marketing Name": "V9 Pro",
    "Device": "V9_Pro",
    "Model": "V9 Pro"
  },
  {
    "Retail Branding": "OpelMobile",
    "Marketing Name": "65SX",
    "Device": "OM65SX25B",
    "Model": "65SX"
  },
  {
    "Retail Branding": "OpelMobile",
    "Marketing Name": "67E 5G",
    "Device": "OM5G67E25B-L",
    "Model": "67E 5G"
  },
  {
    "Retail Branding": "OpelMobile",
    "Marketing Name": "EasySmart",
    "Device": "EasySmart",
    "Model": "EasySmart"
  },
  {
    "Retail Branding": "OpelMobile",
    "Marketing Name": "EasySmart 2",
    "Device": "Easy_Smart_2",
    "Model": "Easy_Smart_2"
  },
  {
    "Retail Branding": "OpelMobile",
    "Marketing Name": "OMSJ523B",
    "Device": "OpelMobile_OMSJ523B",
    "Model": "Smart J5"
  },
  {
    "Retail Branding": "OpelMobile",
    "Marketing Name": "Opel Mobile_Smart_J2",
    "Device": "Smart_J2",
    "Model": "Smart_J2"
  },
  {
    "Retail Branding": "OpelMobile",
    "Marketing Name": "Opel Smart60R",
    "Device": "OMS60R24B",
    "Model": "Smart60R"
  },
  {
    "Retail Branding": "OpelMobile",
    "Marketing Name": "Rugged60Q",
    "Device": "OMR60Q23O",
    "Model": "Rugged60Q"
  },
  {
    "Retail Branding": "OpelMobile",
    "Marketing Name": "S55",
    "Device": "OMS5525B",
    "Model": "S55"
  },
  {
    "Retail Branding": "OpelMobile",
    "Marketing Name": "S65",
    "Device": "OMS6524B",
    "Model": "S65"
  },
  {
    "Retail Branding": "OpelMobile",
    "Marketing Name": "SMARTJ5-M",
    "Device": "SMARTJ5-M",
    "Model": "SMARTJ5-M"
  },
  {
    "Retail Branding": "OpelMobile",
    "Marketing Name": "SMARTKIDS",
    "Device": "SMARTKIDS",
    "Model": "SMARTKIDS"
  },
  {
    "Retail Branding": "OpelMobile",
    "Marketing Name": "Smart X6",
    "Device": "SmartX6",
    "Model": "Opel Mobile SmartX6"
  },
  {
    "Retail Branding": "OpelMobile",
    "Marketing Name": "Smart55Q",
    "Device": "OMS55Q23B",
    "Model": "Smart55Q"
  },
  {
    "Retail Branding": "OpelMobile",
    "Marketing Name": "Smart55R",
    "Device": "Smart55R",
    "Model": "OMS55R24B"
  },
  {
    "Retail Branding": "OpelMobile",
    "Marketing Name": "Smart65E",
    "Device": "OMS65E24B",
    "Model": "Smart65E"
  },
  {
    "Retail Branding": "OpelMobile",
    "Marketing Name": "Smart65Q",
    "Device": "OMS65Q23B",
    "Model": "Smart65Q"
  },
  {
    "Retail Branding": "OpelMobile",
    "Marketing Name": "Smart65R",
    "Device": "OMS65R24B",
    "Model": "Smart65R"
  },
  {
    "Retail Branding": "OpelMobile",
    "Marketing Name": "SmartJX",
    "Device": "SmartJX",
    "Model": "OpelMobile_SmartJX"
  },
  {
    "Retail Branding": "OpelMobile",
    "Marketing Name": "SmartX1",
    "Device": "SmartX1",
    "Model": "OpelMobile_SmartX1"
  },
  {
    "Retail Branding": "OpelMobile",
    "Marketing Name": "SmartX65",
    "Device": "OMSX6524B",
    "Model": "SmartX65"
  },
  {
    "Retail Branding": "OpelMobile",
    "Marketing Name": "SmartZ6",
    "Device": "SmartZ6",
    "Model": "SmartZ6"
  },
  {
    "Retail Branding": "OpelMobile",
    "Marketing Name": "Tab_R8",
    "Device": "OMR8T25",
    "Model": "Tab_R8"
  },
  {
    "Retail Branding": "OpenPeak",
    "Marketing Name": "",
    "Device": "CIUS-7",
    "Model": "CIUS-7"
  },
  {
    "Retail Branding": "OpenPeak",
    "Marketing Name": "",
    "Device": "CIUS-7-AT",
    "Model": "CIUS-7-AT"
  },
  {
    "Retail Branding": "OpenPeak",
    "Marketing Name": "",
    "Device": "cius",
    "Model": "cius"
  },
  {
    "Retail Branding": "Ophone",
    "Marketing Name": "Active 5.0",
    "Device": "Active_5_0",
    "Model": "Active 5.0"
  },
  {
    "Retail Branding": "Ophone",
    "Marketing Name": "Beeta_4_0",
    "Device": "Beeta_4_0",
    "Model": "Beeta_4_0"
  },
  {
    "Retail Branding": "Ophone",
    "Marketing Name": "Sigma_4_0",
    "Device": "Sigma_4_0",
    "Model": "Sigma_4_0"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": 1100,
    "Device": 1100,
    "Model": 1100
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": 1105,
    "Device": 1105,
    "Model": 1105
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": 1107,
    "Device": 1107,
    "Model": 1107
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": 1201,
    "Device": 1201,
    "Model": 1201
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": 1206,
    "Device": 1206,
    "Model": 1206
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": 3000,
    "Device": 3000,
    "Model": 3000
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": 3001,
    "Device": "Mirror3",
    "Model": 3001
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": 3005,
    "Device": 3005,
    "Model": 3005
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": 3006,
    "Device": "Mirror3",
    "Model": 3006
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": 3007,
    "Device": 3007,
    "Model": 3007
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": 3008,
    "Device": 3008,
    "Model": 3008
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A1 Pro 5G",
    "Device": "OP5613",
    "Model": "PHQ110"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A11",
    "Device": "A11",
    "Model": "A11"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A11 中国版",
    "Device": "OP4A4D",
    "Model": "PCHM10"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A11 中国版",
    "Device": "OP4A4D",
    "Model": "PCHT10"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A11f",
    "Device": "A11",
    "Model": "A11f"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A11n中国版",
    "Device": "OP4A54",
    "Model": "PCHM00"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A11t",
    "Device": "A11",
    "Model": "A11t"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A11w",
    "Device": "A11w",
    "Model": "A11w"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A11x 中国版",
    "Device": "OP4A54",
    "Model": "PCHM30"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A11x 中国版",
    "Device": "OP4A54",
    "Model": "PCHT30"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A13t",
    "Device": "A31t",
    "Model": "A31t"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A1601",
    "Device": "A1601",
    "Model": "A1601"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A1601",
    "Device": "A1601",
    "Model": "A1601fw"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A1601fw",
    "Device": "A1601",
    "Model": "A1601fw"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A1603",
    "Device": "A1603",
    "Model": "A1603"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A16K",
    "Device": "OP5321",
    "Model": "CPH2351"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A17",
    "Device": "OP56F5",
    "Model": "CPH2477"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A17k",
    "Device": "OP56F5",
    "Model": "CPH2471"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A18",
    "Device": "OP575DL1",
    "Model": "CPH2591"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A1k",
    "Device": "OP486C",
    "Model": "CPH1923"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A2 5G",
    "Device": "OP5647",
    "Model": "PJB110"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A2x 5G",
    "Device": "OP5A0D",
    "Model": "PJS110"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A3",
    "Device": "CPH1837",
    "Model": "CPH1837"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A3",
    "Device": "OP5B16L1",
    "Model": "CPH2669"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A3 5G",
    "Device": "OP5B05L1",
    "Model": "A402OP"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A3 5G",
    "Device": "OP5EA7L1",
    "Model": "CPH2693"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A3 5G/A3i Plus 5G",
    "Device": "OP5A33",
    "Model": "PKA110"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A3 Pro 5G",
    "Device": "OP5B05L1",
    "Model": "CPH2665"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A3 Pro 5G/A3 5G/A80 5G",
    "Device": "OP5B05L1",
    "Model": "CPH2639"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A31",
    "Device": "A31t",
    "Model": "A31"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A31c",
    "Device": "A31c",
    "Model": "A31c"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A31u",
    "Device": "A31u",
    "Model": "A31u"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A32 中国版",
    "Device": "OP4E35",
    "Model": "PDVM00"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A33",
    "Device": "A33",
    "Model": "A33"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A33f",
    "Device": "A33",
    "Model": "A33f"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A33f",
    "Device": "A33",
    "Model": "A33fw"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A33fw",
    "Device": "A33",
    "Model": "A33fw"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A33m",
    "Device": "A33",
    "Model": "OPPO A33m"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A33t",
    "Device": "A33t",
    "Model": "A33t"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A33w",
    "Device": "A33w",
    "Model": "A33w"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A35",
    "Device": "A35",
    "Model": "OPPO A35"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A37",
    "Device": "A37",
    "Model": "OPPO A37"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A37",
    "Device": "A37",
    "Model": "OPPO A37m"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A37f",
    "Device": "A37f",
    "Model": "A37f"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A37f",
    "Device": "A37f",
    "Model": "A37fw"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A37fw",
    "Device": "A37f",
    "Model": "A37fw"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A37fw",
    "Device": "A37fs",
    "Model": "A37fw"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A37fw-International",
    "Device": "A37fs",
    "Model": "A37f"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A37m",
    "Device": "A37",
    "Model": "OPPO A37m"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A37t",
    "Device": "A37",
    "Model": "OPPO A37t"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A37tm",
    "Device": "A37",
    "Model": "OPPO A37tm"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A38",
    "Device": "OP5759L1",
    "Model": "CPH2579"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A39",
    "Device": "A39",
    "Model": "OPPO A39"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A39m",
    "Device": "A39",
    "Model": "OPPO A39m"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A39t",
    "Device": "A39",
    "Model": "OPPO A39t"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A39tm",
    "Device": "A39",
    "Model": "OPPO A39tm"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A3i 5G",
    "Device": "OP5DDF",
    "Model": "PKL110"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A3m 5G",
    "Device": "OP5A47",
    "Model": "PKD120"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A3s",
    "Device": "CPH1803",
    "Model": "CPH1803"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A3s",
    "Device": "CPH1853",
    "Model": "CPH1853"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A3x",
    "Device": "OP5B16L1",
    "Model": "CPH2641"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A3x 5G",
    "Device": "OP5A47",
    "Model": "PKD130"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A3x 5G",
    "Device": "OP5EA7L1",
    "Model": "CPH2681"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A3x/A20",
    "Device": "OP5B16L1",
    "Model": "CPH2641"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A3中国版",
    "Device": "PADM00",
    "Model": "PADM00"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A3中国版",
    "Device": "PADT00",
    "Model": "PADT00"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A3活力版 5G",
    "Device": "OP5A47",
    "Model": "PKD110"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A40/A3/A40m",
    "Device": "OP5B16L1",
    "Model": "CPH2669"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A40/A40m",
    "Device": "OP5B16L1",
    "Model": "CPH2669"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A5",
    "Device": "CPH1809",
    "Model": "CPH1809"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A5",
    "Device": "PBAM00",
    "Model": "PBAM00"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A5",
    "Device": "PBAT00",
    "Model": "PBAT00"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A5",
    "Device": "PBBM30",
    "Model": "PBBM30"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A5",
    "Device": "PBBT30",
    "Model": "PBBT30"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A5 2020",
    "Device": "OP4B79L1",
    "Model": "CPH1931"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A5 2020",
    "Device": "OP4B79L1",
    "Model": "CPH1933"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A5 2020",
    "Device": "OP4B80L1",
    "Model": "CPH1943"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A5 5G",
    "Device": "OP5EF7L1",
    "Model": "A502OP"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A5 5G",
    "Device": "OP5EF7L1",
    "Model": "CPH2735"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A5 5G",
    "Device": "OP5EF7L1",
    "Model": "CPH2751"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A5 Pro",
    "Device": "OP5ED9L1",
    "Model": "CPH2711"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A5 Pro 5G",
    "Device": "OP5DF3",
    "Model": "PKP110"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A5 Pro 5G",
    "Device": "OP5EBBL1",
    "Model": "CPH2695"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A5 活力版 5G/K13x 5G",
    "Device": "OP5DFB",
    "Model": "PKV110"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A5/A5m",
    "Device": "OP5EEDL1",
    "Model": "CPH2727"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A51",
    "Device": "A51",
    "Model": "A51"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A51",
    "Device": "A51",
    "Model": "Lava A51"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A51f",
    "Device": "A51",
    "Model": "A51f"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A51fa",
    "Device": "A51",
    "Model": "A51f"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A51kc",
    "Device": "A51kc",
    "Model": "A51kc"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A51w",
    "Device": "A51",
    "Model": "A51w"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A52",
    "Device": "OP4C77L1",
    "Model": "CPH2061"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A52",
    "Device": "OP4C7BL1",
    "Model": "CPH2069"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A52 中国版",
    "Device": "OP4AE7",
    "Model": "PDAM10"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A52 中国版",
    "Device": "OP4AE7",
    "Model": "PDAT10"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A53",
    "Device": "A53",
    "Model": "OPPO A53"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A53",
    "Device": "OP4EFDL1",
    "Model": "CPH2127"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A53",
    "Device": "OP4EFDL1",
    "Model": "CPH2131"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A53",
    "Device": "OP4EFDL1",
    "Model": "CPH2133"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A53",
    "Device": "OP4EFDL1",
    "Model": "CPH2139"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A53 5G",
    "Device": "OP4E49",
    "Model": "PECM20"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A53f",
    "Device": "A53",
    "Model": "A53f"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A53fw",
    "Device": "A53",
    "Model": "A53fw"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A53m",
    "Device": "A53",
    "Model": "OPPO A53m"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A53s",
    "Device": "OP4EFDL1",
    "Model": "CPH2135"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A53w",
    "Device": "A53",
    "Model": "A53w"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A54 5G",
    "Device": "OP4F39L1",
    "Model": "CPH2303"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A55 5G",
    "Device": "OP4E2F",
    "Model": "PEMM00"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A55 5G",
    "Device": "OP4E2F",
    "Model": "PEMT00"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A55 5G",
    "Device": "OP4E8C",
    "Model": "PEMT20"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A55s 5G",
    "Device": "OP52EBL1",
    "Model": "A102OP"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A57",
    "Device": "A57",
    "Model": "OPPO A57"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A57",
    "Device": "A57",
    "Model": "OPPO A57t"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A57",
    "Device": "OP5355",
    "Model": "CPH2387"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A57",
    "Device": "OP5355",
    "Model": "CPH2407"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A57s/A77",
    "Device": "OP5353L1",
    "Model": "CPH2385"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A57t",
    "Device": "A57",
    "Model": "OPPO A57t"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A58",
    "Device": "OP574FL1",
    "Model": "CPH2577"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A59",
    "Device": "A59",
    "Model": "OPPO A59"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A59",
    "Device": "A59",
    "Model": "OPPO A59m"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A59",
    "Device": "A59",
    "Model": "OPPO A59s"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A59 5G",
    "Device": "OP5AD5L1",
    "Model": "CPH2617"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A59m",
    "Device": "A59",
    "Model": "OPPO A59m"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A59st",
    "Device": "A59",
    "Model": "OPPO A59st"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A59t",
    "Device": "A59",
    "Model": "OPPO A59t"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A59tm",
    "Device": "A59",
    "Model": "OPPO A59tm"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A5i Pro",
    "Device": "OP5EEDL1",
    "Model": "CPH2755"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A5i Pro 5G",
    "Device": "OP5EF7L1",
    "Model": "CPH2821"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A5m",
    "Device": "OP5EEDL1",
    "Model": "CPH2759"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A5x",
    "Device": "OP5EEDL1",
    "Model": "CPH2725"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A5x 5G",
    "Device": "OP5EF7L1",
    "Model": "CPH2733"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A6",
    "Device": "OP62A3L1",
    "Model": "CPH2817"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A6 5G",
    "Device": "OP5E1C",
    "Model": "PLS120"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A6 5G",
    "Device": "OP5F2BL1",
    "Model": "CPH2785"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A6 5G",
    "Device": "OP5F2BL1",
    "Model": "CPH2831"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A6 Pro",
    "Device": "OP6285L1",
    "Model": "CPH2799"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A6 Pro 5G",
    "Device": "OP5DE3",
    "Model": "PLN110"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A6 Pro 5G",
    "Device": "OP5F2BL1",
    "Model": "CPH2827"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A60",
    "Device": "OP5AE7L1",
    "Model": "CPH2631"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A60",
    "Device": "OP5B16L1",
    "Model": "CPH3669"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A60 5G",
    "Device": "OP5EA7L1",
    "Model": "CPH2683"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A6c",
    "Device": "OP61C7L1",
    "Model": "PMC110"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A6c",
    "Device": "OP632F",
    "Model": "CPH2895"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A6k",
    "Device": "OP62A3L1",
    "Model": "CPH2891"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A6s",
    "Device": "OP62A3L1",
    "Model": "CPH2815"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A6s 5G",
    "Device": "OP5F2BL1",
    "Model": "CPH2789"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A6s 5G",
    "Device": "OP5F2BL1",
    "Model": "CPH2889"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A6t",
    "Device": "OP62A3L1",
    "Model": "CPH2847"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A6t 5G",
    "Device": "OP5F2BL1",
    "Model": "CPH2853"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A6t Pro",
    "Device": "OP62A3L1",
    "Model": "CPH2849"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A6t Pro 5G",
    "Device": "OP5F2BL1",
    "Model": "CPH2851"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A6x",
    "Device": "OP62A3L1",
    "Model": "CPH2819"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A6x 5G",
    "Device": "OP5F2BL1",
    "Model": "CPH2783"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A6x 5G",
    "Device": "OP5F2BL1",
    "Model": "CPH2823"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A7",
    "Device": "CPH1901",
    "Model": "CPH1901"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A7",
    "Device": "CPH1905",
    "Model": "CPH1905"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A7",
    "Device": "PBFM00",
    "Model": "PBFM00"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A7",
    "Device": "PBFT00",
    "Model": "PBFT00"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A72",
    "Device": "OP4C72L1",
    "Model": "CPH2067"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A73",
    "Device": "A73",
    "Model": "OPPO A73"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A73",
    "Device": "A79",
    "Model": "OPPO A73"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A73t",
    "Device": "A73t",
    "Model": "OPPO A73t"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A73t",
    "Device": "A79",
    "Model": "OPPO A73t"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A74",
    "Device": "OP4F11L1",
    "Model": "CPH2219"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A77",
    "Device": "A77",
    "Model": "OPPO A77"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A77",
    "Device": "A77",
    "Model": "OPPO A77t"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A77 5G",
    "Device": "OP52F3L1",
    "Model": "CPH2339"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A78",
    "Device": "OP5745L1",
    "Model": "CPH2565"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A78 5G",
    "Device": "OP52F3L1",
    "Model": "CPH2483"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A78 5G",
    "Device": "OP52F3L1",
    "Model": "CPH2495"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A79",
    "Device": "A79",
    "Model": "OPPO A79"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A79 5G",
    "Device": "OP573DL1",
    "Model": "A303OP"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A79 5G",
    "Device": "OP573DL1",
    "Model": "CPH2553"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A79 5G",
    "Device": "OP573DL1",
    "Model": "CPH2557"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A79k",
    "Device": "A79k",
    "Model": "OPPO A79k"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A79kt",
    "Device": "A79kt",
    "Model": "OPPO A79kt"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A79t",
    "Device": "A79",
    "Model": "OPPO A79t"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A79t",
    "Device": "A79t",
    "Model": "OPPO A79t"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A7n",
    "Device": "PCDT00",
    "Model": "PCDT00"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A7x 中国版",
    "Device": "PBBM00",
    "Model": "PBBM00"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A7x 中国版",
    "Device": "PBBT00",
    "Model": "PBBT00"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A80 5G",
    "Device": "OP5B05L1",
    "Model": "CPH2639"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A83",
    "Device": "A83",
    "Model": "OPPO A83"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A83t",
    "Device": "A83t",
    "Model": "OPPO A83t"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A9 2020",
    "Device": "OP4B80L1",
    "Model": "CPH1937"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A9 2020",
    "Device": "OP4B80L1",
    "Model": "CPH1941"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A9 中国版",
    "Device": "OP46F1",
    "Model": "PCAM10"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A9 中国版",
    "Device": "OP46F1",
    "Model": "PCAT10"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A91",
    "Device": "OP4ACF",
    "Model": "PCPM00"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A92",
    "Device": "OP4C72L1",
    "Model": "CPH2059"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A93",
    "Device": "OP4C51L1",
    "Model": "CPH2121"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A93",
    "Device": "OP4C51L1",
    "Model": "CPH2123"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A93 5G",
    "Device": "OP4E99",
    "Model": "PEHM00"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A94",
    "Device": "OP4F43L1",
    "Model": "CPH2203"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A96 5G",
    "Device": "OP5267",
    "Model": "PFUM10"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A98 5G",
    "Device": "OP56E8L1",
    "Model": "CPH2529"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A9x",
    "Device": "OP46F3",
    "Model": "PCEM00"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A9x",
    "Device": "OP46F3",
    "Model": "PCET00"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "AX5s",
    "Device": "CPH1920",
    "Model": "CPH1920"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "AX7",
    "Device": "CPH1903",
    "Model": "CPH1903"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A系列",
    "Device": "OP5A0D",
    "Model": "PJS110"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "A系列",
    "Device": "OP5A0D",
    "Model": "PJU110"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "CHP1705",
    "Device": "CPH1705",
    "Model": "CPH1705fw"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "CPH1605",
    "Device": "CPH1605",
    "Model": "CPH1605"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "CPH1605",
    "Device": "CPH1605",
    "Model": "OPPO CPH1605"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "CPH1605fw",
    "Device": "CPH1605",
    "Model": "CPH1605fw"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "CPH1609",
    "Device": "CPH1609",
    "Model": "CPH1609"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "CPH1609fw",
    "Device": "CPH1609",
    "Model": "CPH1609fw"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "CPH1613",
    "Device": "CPH1613",
    "Model": "CPH1613"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "CPH1613",
    "Device": "CPH1613",
    "Model": "CPH1613fw"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "CPH1701",
    "Device": "CPH1701",
    "Model": "CPH1701"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "CPH1701",
    "Device": "CPH1701",
    "Model": "CPH1701fw"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "CPH1705",
    "Device": "CPH1705",
    "Model": "CPH1705"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "CPH1707",
    "Device": "CPH1707",
    "Model": "CPH1707"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "CPH1707",
    "Device": "CPH1707",
    "Model": "CPH1707fw"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "CPH1715",
    "Device": "CPH1715",
    "Model": "CPH1715"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "CPH1717",
    "Device": "CPH1717",
    "Model": "CPH1717"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "CPH1719",
    "Device": "CPH1719",
    "Model": "CPH1719"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "CPH1721",
    "Device": "CPH1721",
    "Model": "CPH1721"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "CPH1723",
    "Device": "CPH1723",
    "Model": "CPH1723"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "CPH1725",
    "Device": "CPH1725",
    "Model": "CPH1725"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "CPH1727",
    "Device": "CPH1727",
    "Model": "CPH1727"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "CPH1729",
    "Device": "CPH1729",
    "Model": "CPH1729"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "CPH1801",
    "Device": "CPH1801",
    "Model": "CPH1801"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "CPH1803RU",
    "Device": "CPH1803",
    "Model": "CPH1803"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "CPH1805",
    "Device": "CPH1805",
    "Model": "CPH1805"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "CPH1807",
    "Device": "CPH1807",
    "Model": "CPH1807"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "CPH1808",
    "Device": "CPH1808",
    "Model": "CPH1808"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "CPH1827",
    "Device": "CPH1827",
    "Model": "CPH1827"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "CPH1851",
    "Device": "CPH1851",
    "Model": "CPH1851"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "CPH1853",
    "Device": "CPH1853",
    "Model": "CPH1853"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "CPH1893",
    "Device": "CPH1893",
    "Model": "CPH1893"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "CPH1893RU",
    "Device": "CPH1893",
    "Model": "CPH1893"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "CPH1903",
    "Device": "CPH1903",
    "Model": "CPH1903"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "CPH1907",
    "Device": "OP4B83L1",
    "Model": "CPH1907"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "CPH1909",
    "Device": "CPH1909",
    "Model": "CPH1909"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "CPH1938",
    "Device": "OP4883",
    "Model": "CPH1938"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "CPH1989",
    "Device": "OP4C4BL1",
    "Model": "CPH1989"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "CPH2001",
    "Device": "OP4B9B",
    "Model": "CPH2001"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "CPH2015",
    "Device": "OP4C7D",
    "Model": "CPH2015"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "CPH2021",
    "Device": "OP4B9B",
    "Model": "CPH2021"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "CPH2031",
    "Device": "OP4C7D",
    "Model": "CPH2031"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "CPH2043",
    "Device": "OP4B9EL1",
    "Model": "CPH2043"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "CPH2071",
    "Device": "OP4BFB",
    "Model": "CPH2071"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "CPH2073",
    "Device": "OP4C7D",
    "Model": "CPH2073"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "CPH2077",
    "Device": "OP4BFB",
    "Model": "CPH2077"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "CPH2081",
    "Device": "OP4C7D",
    "Model": "CPH2081"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "CPH2083",
    "Device": "OP4BFB",
    "Model": "CPH2083"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "CPH2095",
    "Device": "OP4EF3L1",
    "Model": "CPH2095"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "CPH2109",
    "Device": "OP4BA5L1",
    "Model": "CPH2109"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "CPH2113",
    "Device": "OP4BA5L1",
    "Model": "CPH2113"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "CPH2145",
    "Device": "OP4F1BL1",
    "Model": "CPH2145"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "CPH2159",
    "Device": "OP4F25L1",
    "Model": "CPH2159"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "CPH2161",
    "Device": "OP4EE8L1",
    "Model": "CPH2161"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "CPH2173",
    "Device": "OP4F57L1",
    "Model": "CPH2173"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "CPH2179",
    "Device": "OP4F2F",
    "Model": "CPH2179"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "CPH2185",
    "Device": "OP4F2F",
    "Model": "CPH2185"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "CPH2185",
    "Device": "OP4F2F",
    "Model": "CPH21859"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "CPH2195",
    "Device": "OP4F39L1",
    "Model": "CPH2195"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "CPH2197",
    "Device": "OP4F39L1",
    "Model": "CPH2197"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "CPH2201",
    "Device": "OP4F1FL1",
    "Model": "CPH2201"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "CPH2207",
    "Device": "OP4F0BL1",
    "Model": "CPH2207"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "CPH2211",
    "Device": "OP4F4DL1",
    "Model": "CPH2211"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "CPH2213",
    "Device": "OP4F4DL1",
    "Model": "CPH2213"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "CPH2219",
    "Device": "OP4F11L1",
    "Model": "CPH2219"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "CPH2223",
    "Device": "OP4F11L1",
    "Model": "CPH2223"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "CPH2235",
    "Device": "OP4F25L1",
    "Model": "CPH2235"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "CPH2237",
    "Device": "OP4FA7L1",
    "Model": "CPH2237"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "CPH2239",
    "Device": "OP4F2F",
    "Model": "CPH2239"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "CPH2241",
    "Device": "OP4F2F",
    "Model": "CPH2241"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "CPH2247",
    "Device": "OP4F7FL1",
    "Model": "CPH2247"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "CPH2249",
    "Device": "OP4F81L1",
    "Model": "CPH2249"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "CPH2251",
    "Device": "OP4F83L1",
    "Model": "CPH2251"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "CPH2263",
    "Device": "OP4F39L1",
    "Model": "CPH2263"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "CPH2269",
    "Device": "OP4F97",
    "Model": "CPH2269"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "CPH2271",
    "Device": "OP4F97",
    "Model": "CPH2271"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "CPH2273",
    "Device": "OP4F97",
    "Model": "CPH2273"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "CPH2275",
    "Device": "OP4F97",
    "Model": "CPH2275"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "CPH2293",
    "Device": "OP52E1L1",
    "Model": "CPH2293"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "CPH2309",
    "Device": "OP52EBL1",
    "Model": "CPH2309"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "CPH2325",
    "Device": "OP5303",
    "Model": "CPH2325"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "CPH2365",
    "Device": "OP4F11L1",
    "Model": "CPH2365"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "CPH2385",
    "Device": "OP571DL1",
    "Model": "CPH2385"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "CPH2387",
    "Device": "OP571F",
    "Model": "CPH2387"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "CPH2407",
    "Device": "OP571F",
    "Model": "CPH2407"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "CPH2421",
    "Device": "OP5325",
    "Model": "CPH2421"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "CPH2455",
    "Device": "OP56E1L1",
    "Model": "CPH2455"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "CPH2457",
    "Device": "OP56E1L1",
    "Model": "CPH2457"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "CPH2461",
    "Device": "OP533FL1",
    "Model": "CPH2461"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "CPH2473",
    "Device": "OP5637L1",
    "Model": "CPH2473"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "CPH2527",
    "Device": "OP56E7L1",
    "Model": "CPH2527"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "F11",
    "Device": "OP4883",
    "Model": "CPH1911"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "F11",
    "Device": "OP4883",
    "Model": "CPH1913"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "F11",
    "Device": "OP4883",
    "Model": "CPH1915"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "F11 Pro",
    "Device": "OP4863",
    "Model": "CPH1969"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "F11 Pro",
    "Device": "OP4863",
    "Model": "CPH1987"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "F17 Pro",
    "Device": "OP4C51L1",
    "Model": "CPH2119"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "F19 Pro",
    "Device": "OP4F43L1",
    "Model": "CPH2285"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "F1f",
    "Device": "F1f",
    "Model": "F1f"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "F1f",
    "Device": "F1f",
    "Model": "F1fw"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "F1f",
    "Device": "F1f",
    "Model": "F1w"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "F1fw",
    "Device": "F1f",
    "Model": "F1f"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "F1fw",
    "Device": "F1f",
    "Model": "F1fw"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "F1w",
    "Device": "F1f",
    "Model": "F1f"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "F1w",
    "Device": "F1f",
    "Model": "F1w"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "F25 Pro 5G",
    "Device": "OP5A0BL1",
    "Model": "CPH2603"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "F29 Pro 5G",
    "Device": "OP5ECFL1",
    "Model": "CPH2705"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "F31 Pro 5G",
    "Device": "OP5F19L1",
    "Model": "CPH2763"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "F31 Pro+ 5G",
    "Device": "OP5F15L1",
    "Model": "CPH2757"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "F7",
    "Device": "CPH1819",
    "Model": "CPH1819"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "F7",
    "Device": "CPH1821",
    "Model": "CPH1821"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "F9",
    "Device": "CPH1823",
    "Model": "CPH1823"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "F9",
    "Device": "CPH1825",
    "Model": "CPH1825"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "F9",
    "Device": "CPH1881",
    "Model": "CPH1881"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "Find 5",
    "Device": "FIND5",
    "Model": "X909"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "Find N",
    "Device": "OP4E75L1",
    "Model": "PEUM00"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "Find N2 Flip",
    "Device": "OP56CDL1",
    "Model": "CPH2437"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "Find N2 Flip 中国版",
    "Device": "OP5605",
    "Model": "PGT110"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "Find N3",
    "Device": "OP55F3L1",
    "Model": "PHN110"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "Find N3",
    "Device": "OP56BBL1",
    "Model": "CPH2499"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "Find N3 Flip",
    "Device": "OP5607L1",
    "Model": "PHT110"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "Find N3 Flip",
    "Device": "OP56CFL1",
    "Model": "CPH2519"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "Find N5",
    "Device": "OP5DC1L1",
    "Model": "PKH110"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "Find N5",
    "Device": "OP5E89L1",
    "Model": "CPH2671"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "Find N5 卫星通信版",
    "Device": "OP5DC1L1",
    "Model": "PKH120"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "Find N6",
    "Device": "OP61A9L1",
    "Model": "PLP110"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "Find N6",
    "Device": "OP6271L1",
    "Model": "CPH2765"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "Find N6 卫星通信版",
    "Device": "OP61A9L1",
    "Model": "PLP120"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "Find X",
    "Device": "CPH1871",
    "Model": "CPH1871"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "Find X",
    "Device": "CPH1875",
    "Model": "CPH1875"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "Find X",
    "Device": "PAFM00",
    "Model": "PAFM00"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "Find X",
    "Device": "PAFT00",
    "Model": "PAFT00"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "Find X 兰博基尼",
    "Device": "PAHM00",
    "Model": "PAHM00"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "Find X2",
    "Device": "OP4BA1L1",
    "Model": "CPH2023"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "Find X2 Lite",
    "Device": "OP4C41L1",
    "Model": "CPH2005"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "Find X2 Neo/Reno3 Pro",
    "Device": "OP4C2DL1",
    "Model": "CPH2009"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "Find X2 Pro",
    "Device": "OP4BA2L1",
    "Model": "CPH2025"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "Find X2 Pro",
    "Device": "OP4BA2L1",
    "Model": "OPG01"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "Find X2 Pro 中国版",
    "Device": "OP4A7A",
    "Model": "PDEM30"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "Find X2 中国版",
    "Device": "OP4A77",
    "Model": "PDEM10"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "Find X2 中国版",
    "Device": "OP4A77",
    "Model": "PDET10"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "Find X3 Pro",
    "Device": "OP4F57L1",
    "Model": "CPH2173"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "Find X3 Pro",
    "Device": "OP4F57L1",
    "Model": "OPG03"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "Find X3 Pro 中国版",
    "Device": "OP4E3F",
    "Model": "PEEM00"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "Find X3 中国版",
    "Device": "OP4E5D",
    "Model": "PEDM00"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "Find X5",
    "Device": "OP52D5L1",
    "Model": "CPH2307"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "Find X5 Pro",
    "Device": "OP52D1L1",
    "Model": "CPH2305"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "Find X6",
    "Device": "OP528F",
    "Model": "PGFM10"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "Find X6 Pro",
    "Device": "OP528BL1",
    "Model": "PGEM10"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "Find X7",
    "Device": "OP5661L1",
    "Model": "PHZ110"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "Find X7 Ultra",
    "Device": "OP565FL1",
    "Model": "PHY110"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "Find X7 Ultra 卫星通信版",
    "Device": "OP5660L1",
    "Model": "PHY120"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "Find X8",
    "Device": "OP5A3DL1",
    "Model": "PKB110"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "Find X8",
    "Device": "OP5AA5L1",
    "Model": "CPH2651"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "Find X8 Pro",
    "Device": "OP5A41L1",
    "Model": "PKC110"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "Find X8 Pro",
    "Device": "OP5AB0L1",
    "Model": "CPH2659"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "Find X8 Pro 卫星通信版",
    "Device": "OP5A41L1",
    "Model": "PKC130"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "Find X8 Ultra",
    "Device": "OP5DD3L1",
    "Model": "PKJ110"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "Find X8 Ultra 卫星通信版",
    "Device": "OP5DD2L1",
    "Model": "PKU110"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "Find X8s",
    "Device": "OP5DCBL1",
    "Model": "PKT110"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "Find X8s+",
    "Device": "OP5DCDL1",
    "Model": "PLB110"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "Find X9",
    "Device": "OP5E17L1",
    "Model": "PLJ110"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "Find X9",
    "Device": "OP5E8BL1",
    "Model": "CPH2797"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "Find X9",
    "Device": "OP5E8BL1",
    "Model": "OPG07"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "Find X9 Pro",
    "Device": "OP5E11L1",
    "Model": "PLG110"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "Find X9 Pro",
    "Device": "OP5E8EL1",
    "Model": "CPH2791"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "Find X9 Pro 卫星通信版",
    "Device": "OP5E11L1",
    "Model": "PLG120"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "Find5",
    "Device": "FIND5",
    "Model": "X909"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "Find5",
    "Device": "FIND5",
    "Model": "X909T"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "K1",
    "Device": "PBCM30",
    "Model": "PBCM30"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "K12 5G",
    "Device": "OP5A15L1",
    "Model": "PJR110"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "K12 Plus",
    "Device": "OP5DFDL1",
    "Model": "PKS110"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "K12s 5G",
    "Device": "OP5E01L1",
    "Model": "PLD110"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "K12x 5G",
    "Device": "OP5A1F",
    "Model": "PJT110"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "K12x 5G",
    "Device": "OP5B05L1",
    "Model": "CPH2667"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "K13 5G",
    "Device": "OP5EE3L1",
    "Model": "CPH2729"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "K13 Turbo 5G",
    "Device": "OP5E05L1",
    "Model": "PLM110"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "K13 Turbo 5G",
    "Device": "OP5EE9L1",
    "Model": "CPH2761"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "K13 Turbo Pro 5G",
    "Device": "OP5E03L1",
    "Model": "PLE110"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "K13 Turbo Pro 5G",
    "Device": "OP5EE7L1",
    "Model": "CPH2731"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "K13x 5G",
    "Device": "OP5EF7L1",
    "Model": "CPH2753"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "K14 5G",
    "Device": "OP5F2BL1",
    "Model": "CPH2869"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "K14x 5G",
    "Device": "OP5F2BL1",
    "Model": "CPH2871"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "K15 Pro",
    "Device": "OP61E9L1",
    "Model": "PMH110"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "K15 Pro+",
    "Device": "OP61E5L1",
    "Model": "PMG110"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "K3",
    "Device": "OP4679",
    "Model": "PCGM00"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "K3",
    "Device": "OP4679",
    "Model": "PCGT00"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "K3",
    "Device": "OP486B",
    "Model": "CPH1955"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "K5",
    "Device": "OP4AA7",
    "Model": "PCNM00"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "K7x 中国版",
    "Device": "OP4E7F",
    "Model": "PERM00"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "N1",
    "Device": "N1",
    "Model": "N1"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "N1 mimi",
    "Device": "N1mini",
    "Model": "N5111"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "N1 mimi",
    "Device": "N1mini",
    "Model": "N5116"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "N1T",
    "Device": "N1T",
    "Model": "N1T"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "N1W",
    "Device": "N1W",
    "Model": "N1W"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "N3",
    "Device": "N3",
    "Model": "N5206"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "N3",
    "Device": "N3",
    "Model": "N5207"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "N3",
    "Device": "N3",
    "Model": "N5209"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "N5110",
    "Device": "N5110",
    "Model": "N5110"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "N5117",
    "Device": "N5117",
    "Model": "N5117"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "OPD2102A",
    "Device": "OP5226L1",
    "Model": "OPD2102A"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "OPG02_jp_kdi",
    "Device": "OP4F39L1",
    "Model": "OPG02"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "OPPO A1 5G",
    "Device": "OP561D",
    "Model": "PHS110"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "OPPO A18",
    "Device": "OP575DL1",
    "Model": "CPH2591"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "OPPO A3 Pro 5G/OPPO A5 Plus 5G",
    "Device": "OP59FB",
    "Model": "PJY110"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "OPPO A33",
    "Device": "OP4EEA",
    "Model": "CPH2137"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "OPPO A35",
    "Device": "OP4E7B",
    "Model": "PEFM00"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "OPPO A38",
    "Device": "OP5759L1",
    "Model": "CPH2579"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "OPPO A5 5G",
    "Device": "OP5DF7",
    "Model": "PKQ110"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "OPPO A53 5G",
    "Device": "OP4E49",
    "Model": "PECM30"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "OPPO A53 5G",
    "Device": "OP4E49",
    "Model": "PECT30"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "OPPO A53s 5G",
    "Device": "OP4F53L1",
    "Model": "CPH2321"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "OPPO A54",
    "Device": "OP4E7B",
    "Model": "PEZM00"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "OPPO A57s",
    "Device": "OP5353L1",
    "Model": "CPH2385"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "OPPO A5i",
    "Device": "OP5B16L1",
    "Model": "CPH2773"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "OPPO A5x 5G",
    "Device": "OP5DF5L1",
    "Model": "PKW110"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "OPPO A6 Pro 5G",
    "Device": "OP5E1BL1",
    "Model": "CPH2781"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "OPPO A60 5G/ A3 5G",
    "Device": "OP5EA7L1",
    "Model": "CPH2683"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "OPPO A6i 5G",
    "Device": "OP5DF5L1",
    "Model": "PKW120"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "OPPO A74 5G",
    "Device": "OP4F39L1",
    "Model": "CPH2197"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "OPPO A95 5G",
    "Device": "OP4EB7",
    "Model": "PELM00"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "OPPO F21 Pro 5G",
    "Device": "OP532FL1",
    "Model": "CPH2341"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "OPPO F27 Pro+ 5G",
    "Device": "OP5B19L1",
    "Model": "CPH2643"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "OPPO F29 5G",
    "Device": "OP5ED7L1",
    "Model": "CPH2721"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "OPPO F31 5G",
    "Device": "OP5E1BL1",
    "Model": "CPH2781"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "OPPO K11 5G",
    "Device": "OP591D",
    "Model": "PJC110"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "OPPO K11x 5G",
    "Device": "OP5925",
    "Model": "PHF110"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "OPPO Pad",
    "Device": "OP5223",
    "Model": "OPD2101"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "OPPO Pad 2",
    "Device": "OP5989",
    "Model": "OPD2201"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "OPPO Pad 2",
    "Device": "OP59BBL1",
    "Model": "OPD2202"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "OPPO Pad 3",
    "Device": "OP6159L1",
    "Model": "OPD2405"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "OPPO Pad 3",
    "Device": "OP618BL1",
    "Model": "OPD2406"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "OPPO Pad 3 Pro",
    "Device": "OP5D76L1",
    "Model": "OPD2401"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "OPPO Pad 3 Pro",
    "Device": "OP5DA8L1",
    "Model": "OPD2402"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "OPPO Pad 5",
    "Device": "OP6542L1",
    "Model": "OPD2506"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "OPPO Pad Air",
    "Device": "OP5225",
    "Model": "OPD2102"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "OPPO Pad Neo",
    "Device": "OP5DA3L1",
    "Model": "OPD2302"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "OPPO Pad Neo",
    "Device": "OP5DA3L1",
    "Model": "OPD2303"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "OPPO Reno10 5G",
    "Device": "OP5655",
    "Model": "PHW110"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "OPPO Reno10 Pro 5G",
    "Device": "OP561F",
    "Model": "PHV110"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "OPPO Reno10 Pro+ 5G",
    "Device": "OP564B",
    "Model": "PHU110"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "OPPO Reno5 A",
    "Device": "OP4F2BL1",
    "Model": "A101OP"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "OPPO Reno5 A",
    "Device": "OP4F2BL1",
    "Model": "CPH2199"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "OPPO Reno5 Pro+ 5G",
    "Device": "OP4EA7",
    "Model": "PDRM00"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "OPPO Reno5 pro",
    "Device": "OP4F1FL1",
    "Model": "CPH2201"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "OPPO Reno6 Z 5G",
    "Device": "OP4FA7L1",
    "Model": "CPH2237"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "OPPO Reno7",
    "Device": "OP533FL1",
    "Model": "CPH2363"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "OPPO Reno7 5G",
    "Device": "OPD4A1L1",
    "Model": "CPH2371"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "OPPO Reno7 5G/Find X5 Lite",
    "Device": "OPD4A1L1",
    "Model": "CPH2371"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "OPPO Reno7 A",
    "Device": "OP532BL1",
    "Model": "A201OP"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "OPPO Reno7 A",
    "Device": "OP532BL1",
    "Model": "CPH2353"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "OPPO Reno7 A",
    "Device": "OP532BL1",
    "Model": "OPG04"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "OPPO Reno7 Z 5G",
    "Device": "OP532FL1",
    "Model": "CPH2343"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "OPPO Reno7 Z 5G/F21 Pro 5G/Reno8 Lite 5G",
    "Device": "OP532FL1",
    "Model": "CPH2343"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "OPPO Reno7/F21 Pro",
    "Device": "OP533FL1",
    "Model": "CPH2363"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "OPPO Reno8 5G",
    "Device": "OP5339L1",
    "Model": "CPH2359"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "OPPO Reno8 Pro 5G",
    "Device": "OP5335L1",
    "Model": "CPH2357"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "OPPO Reno8 T",
    "Device": "OP5709L1",
    "Model": "CPH2481"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "OPPO Reno9 Pro 5G",
    "Device": "OP5601",
    "Model": "PGX110"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "OPPO Watch",
    "Device": "beluga",
    "Model": "OPPO Watch"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "OPPO Watch",
    "Device": "orca",
    "Model": "OPPO Watch"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "OPPO Watch X",
    "Device": "OWWE231",
    "Model": "OWWE231"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "OPPO Watch X2",
    "Device": "OWWE251",
    "Model": "OWWE251"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "OPPO Watch X2 Mini",
    "Device": "OWWE242",
    "Model": "OWWE242"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "OnePlus Watch 3 43mm",
    "Device": "OPWE242",
    "Model": "OPWE242"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "PCRT01",
    "Device": "OP4AB5",
    "Model": "PCRT01"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "PDKM00",
    "Device": "OP4ABB",
    "Model": "PDKM00"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "PDKT00",
    "Device": "OP4ABB",
    "Model": "PDKT00"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "PDST00",
    "Device": "OP4EA3",
    "Model": "PDST00"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "PDYM20",
    "Device": "OP4E21",
    "Model": "PDYM20"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "PDYT20",
    "Device": "OP4E21",
    "Model": "PDYT20"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "PEAM00",
    "Device": "OP4E6B",
    "Model": "PEAM00"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "PEAT00",
    "Device": "OP4E6B",
    "Model": "PEAT00"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "PEGM00",
    "Device": "OP4E8F",
    "Model": "PEGM00"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "PEGM10",
    "Device": "OP4E59",
    "Model": "PEGM10"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "PEGT00",
    "Device": "OP4E8F",
    "Model": "PEGT00"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "PEGT10",
    "Device": "OP4E59",
    "Model": "PEGT10"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "PEHM00",
    "Device": "OP4E99",
    "Model": "PEHT00"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "PEMM20",
    "Device": "OP4E8C",
    "Model": "PEMM20"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "PEPM00",
    "Device": "OP4ECB",
    "Model": "PEPM00"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "PEQM00",
    "Device": "OP4ED5",
    "Model": "PEQM00"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "PEXM00",
    "Device": "OP4E9F",
    "Model": "PEXM00"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "PEYM00",
    "Device": "OP5245",
    "Model": "PEYM00"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "PFCM00",
    "Device": "OP5259",
    "Model": "PFCM00"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "PFDM00",
    "Device": "OP5217",
    "Model": "PFDM00"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "PFFM10",
    "Device": "OP520DL1",
    "Model": "PFFM10"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "PFFM20",
    "Device": "OP520F",
    "Model": "PFFM20"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "PFGM00",
    "Device": "OP5231",
    "Model": "PFGM00"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "PFTM10",
    "Device": "OP526D",
    "Model": "PFTM10"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "PFTM20",
    "Device": "OP526D",
    "Model": "PFTM20"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "PFZM10",
    "Device": "OP5281",
    "Model": "PFZM10"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "PGAM10",
    "Device": "OP5285",
    "Model": "PGAM10"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "PGBM10",
    "Device": "OP5287",
    "Model": "PGBM10"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "PGCM10",
    "Device": "OPD2A0",
    "Model": "PGCM10"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "PGGM10",
    "Device": "OP5295",
    "Model": "PGGM10"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "PGJM10",
    "Device": "OP5297",
    "Model": "PGJM10"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "PGW110",
    "Device": "OP55FF",
    "Model": "PGW110"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "PHM110",
    "Device": "OP5627",
    "Model": "PHM110"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "PLL110",
    "Device": "OP5DE2L1",
    "Model": "PLL110"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "PLT120",
    "Device": "OP5E1EL1",
    "Model": "PLT120"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "PLT130",
    "Device": "OP5E1EL1",
    "Model": "PLT130"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "Pad 4 Pro",
    "Device": "OP615CL1",
    "Model": "OPD2409"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "Pad Air5",
    "Device": "OP6541L1",
    "Model": "OPD2501"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "Pad Air5",
    "Device": "OP6541L1",
    "Model": "OPD2510"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "Pad SE",
    "Device": "OP6160L1",
    "Model": "OPD2417"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "Pad SE",
    "Device": "OP6192L1",
    "Model": "OPD2419"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "Pad SE",
    "Device": "OP6193L1",
    "Model": "OPD2420"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "R1001",
    "Device": "OPPO72_13076",
    "Model": "R1001"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "R1001",
    "Device": "R1001",
    "Model": "R1001"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "R1011",
    "Device": "R1011",
    "Model": "R1011"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "R1011w",
    "Device": "R1011",
    "Model": "R1011"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "R11",
    "Device": "R11",
    "Model": "OPPO R11"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "R11",
    "Device": "R11",
    "Model": "OPPO R11t"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "R11 Plus",
    "Device": "R11Plus",
    "Model": "OPPO R11 Plus"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "R11 Plusk",
    "Device": "R11Plusk",
    "Model": "OPPO R11 Plusk"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "R11 Pluskt",
    "Device": "R11Plusk",
    "Model": "OPPO R11 Pluskt"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "R11 Plust",
    "Device": "R11Plus",
    "Model": "OPPO R11 Plust"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "R11s",
    "Device": "R11s",
    "Model": "OPPO R11s"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "R11sPlus",
    "Device": "R11sPlus",
    "Model": "OPPO R11s Plus"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "R11sPlust",
    "Device": "R11sPlus",
    "Model": "OPPO R11s Plust"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "R11st",
    "Device": "R11s",
    "Model": "OPPO R11st"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "R15",
    "Device": "CPH1835",
    "Model": "CPH1835"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "R15 Pro",
    "Device": "CPH1831",
    "Model": "CPH1831"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "R15 Pro",
    "Device": "CPH1833",
    "Model": "CPH1833"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "R15 Pro",
    "Device": "CPH1833L1",
    "Model": "CPH1833"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "R15 中国版",
    "Device": "PACM00",
    "Model": "PACM00"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "R15 中国版",
    "Device": "PACT00",
    "Model": "PACT00"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "R15 梦境版",
    "Device": "PAAM00",
    "Model": "PAAM00"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "R15 梦境版",
    "Device": "PAAT00",
    "Model": "PAAT00"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "R15x",
    "Device": "PBCM10",
    "Model": "PBCM10"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "R15x",
    "Device": "PBCT10",
    "Model": "PBCT10"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "R17",
    "Device": "CPH1879",
    "Model": "CPH1879"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "R17",
    "Device": "PBEM00",
    "Model": "PBEM00"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "R17",
    "Device": "PBET00",
    "Model": "PBET00"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "R17 Pro",
    "Device": "CPH1877",
    "Model": "CPH1877"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "R17 Pro",
    "Device": "PBDM00",
    "Model": "PBDM00"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "R17 Pro",
    "Device": "PBDT00",
    "Model": "PBDT00"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "R2001",
    "Device": "R2001",
    "Model": "R2001"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "R2010",
    "Device": "R2010",
    "Model": "R2010"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "R2017",
    "Device": "R2017",
    "Model": "R2017"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "R5",
    "Device": "R5",
    "Model": "R8106"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "R5",
    "Device": "R5",
    "Model": "R8107"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "R5",
    "Device": "R5",
    "Model": "R8109"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "R6006",
    "Device": "R3",
    "Model": "R6006"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "R6007",
    "Device": "R6007",
    "Model": "R6007"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "R7",
    "Device": "R7",
    "Model": "OPPO R7"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "R7",
    "Device": "R7",
    "Model": "R7"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "R7 Lite",
    "Device": "R7f",
    "Model": "R7kf"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "R7 Plus",
    "Device": "R7Plus",
    "Model": "R7Plus"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "R7 Plusf",
    "Device": "R7Plusm",
    "Model": "R7plusf"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "R7 Plusm",
    "Device": "R7Plusm",
    "Model": "R7Plusm"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "R7005",
    "Device": "R3",
    "Model": "R7005"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "R7007",
    "Device": "R7007",
    "Model": "R7007"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "R7Plusf",
    "Device": "R7Plusm",
    "Model": "R7plusf"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "R7Plust",
    "Device": "R7Plus",
    "Model": "R7Plust"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "R7c",
    "Device": "R7c",
    "Model": "R7c"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "R7f",
    "Device": "R7f",
    "Model": "R7f"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "R7g",
    "Device": "R7f",
    "Model": "R7g"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "R7kc",
    "Device": "R7kc",
    "Model": "R7kc"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "R7kf",
    "Device": "R7f",
    "Model": "R7kf"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "R7kt",
    "Device": "R7",
    "Model": "R7kt"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "R7s",
    "Device": "R7s",
    "Model": "OPPO R7s"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "R7s",
    "Device": "R7s",
    "Model": "R7s"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "R7s Plus",
    "Device": "R7sPlus",
    "Model": "OPPO R7sPlus"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "R7sf",
    "Device": "R7sm",
    "Model": "R7sf"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "R7sfg",
    "Device": "R7sf",
    "Model": "R7sf"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "R7sm",
    "Device": "R7sm",
    "Model": "R7sm"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "R7st",
    "Device": "R7s",
    "Model": "R7st"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "R7t",
    "Device": "R7",
    "Model": "R7t"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "R8000",
    "Device": "R1S",
    "Model": "R8000"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "R8001",
    "Device": "R8001",
    "Model": "R8001"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "R8006",
    "Device": "R8006",
    "Model": "R8006"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "R8007",
    "Device": "R8007",
    "Model": "R8007"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "R809T",
    "Device": "R809T",
    "Model": "R809T"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "R8106",
    "Device": "R5",
    "Model": "R8106"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "R815",
    "Device": "R815",
    "Model": "R815"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "R815T",
    "Device": "R815T",
    "Model": "R815T"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "R815W",
    "Device": "R815W",
    "Model": "R815W"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "R819",
    "Device": "R819",
    "Model": "R819"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "R819T",
    "Device": "R819T",
    "Model": "R819T"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "R820",
    "Device": "R820",
    "Model": "R820"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "R8200",
    "Device": "R1C",
    "Model": "R8200"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "R8201",
    "Device": "R1x",
    "Model": "R8201"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "R8205",
    "Device": "R1C",
    "Model": "R8205"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "R8206",
    "Device": "R1x",
    "Model": "R8206"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "R8207",
    "Device": "R1C",
    "Model": "R8207"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "R821",
    "Device": "R821",
    "Model": "R821"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "R821T",
    "Device": "R821T",
    "Model": "R821T"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "R823T",
    "Device": "R823T",
    "Model": "R823T"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "R827",
    "Device": "R827",
    "Model": "R827"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "R827T",
    "Device": "R827T",
    "Model": "R827T"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "R829",
    "Device": "R829",
    "Model": "R829"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "R829T",
    "Device": "R829T",
    "Model": "R829T"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "R830",
    "Device": "R830",
    "Model": "R830"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "R830S",
    "Device": "R830S",
    "Model": "R830S"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "R831",
    "Device": "R831",
    "Model": "R831"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "R831",
    "Device": "R831T",
    "Model": "R831T"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "R831K",
    "Device": "R831K",
    "Model": "R831K"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "R831L",
    "Device": "R831L",
    "Model": "R831L"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "R831S",
    "Device": "R831S",
    "Model": "R831S"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "R831T",
    "Device": "R831T",
    "Model": "R831T"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "R833T",
    "Device": "OPPO82_13067",
    "Model": "R833T"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "R850",
    "Device": "R850",
    "Model": "R850"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "R9",
    "Device": "R9",
    "Model": "OPPO R9"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "R9",
    "Device": "R9",
    "Model": "OPPO R9km"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "R9",
    "Device": "R9",
    "Model": "OPPO R9m"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "R9",
    "Device": "R9",
    "Model": "OPPO R9tm"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "R9 Plus",
    "Device": "R9PlusA",
    "Model": "OPPO R9 Plusm A"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "R9 Plus",
    "Device": "R9PlusA",
    "Model": "OPPO R9 Plustm A"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "R9 Plus A",
    "Device": "R9PlusA",
    "Model": "OPPO R9 Plus A"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "R9Plus",
    "Device": "X9079",
    "Model": "X9079"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "R9PlusA",
    "Device": "R9PlusA",
    "Model": "OPPO R9 Plusm A"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "R9PlusA",
    "Device": "R9PlusA",
    "Model": "OPPO R9 Plustm A"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "R9PlusmA",
    "Device": "R9PlusA",
    "Model": "OPPO R9 Plusm A"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "R9PlustA",
    "Device": "R9PlusA",
    "Model": "OPPO R9 Plust A"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "R9PlustmA",
    "Device": "R9PlusA",
    "Model": "OPPO R9 Plustm A"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "R9k",
    "Device": "R9",
    "Model": "OPPO R9k"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "R9k",
    "Device": "R9",
    "Model": "OPPO R9km"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "R9k",
    "Device": "R9",
    "Model": "OPPO R9m"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "R9k",
    "Device": "R9",
    "Model": "OPPO R9tm"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "R9km",
    "Device": "R9",
    "Model": "OPPO R9km"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "R9m",
    "Device": "R9",
    "Model": "OPPO R9m"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "R9s",
    "Device": "CPH1607",
    "Model": "CPH1607"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "R9s",
    "Device": "CPH1607",
    "Model": "CPH1607fw"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "R9s",
    "Device": "R9s",
    "Model": "OPPO R9s"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "R9s Plus",
    "Device": "CPH1611",
    "Model": "CPH1611"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "R9s Plus",
    "Device": "R9sPlus",
    "Model": "OPPO R9s Plus"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "R9s Plus",
    "Device": "R9sPlus",
    "Model": "OPPO R9s Plust"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "R9s Plus",
    "Device": "R9sPlus",
    "Model": "OPPO R9sPlus"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "R9sk",
    "Device": "R9sk",
    "Model": "OPPO R9sk"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "R9sk",
    "Device": "R9sk",
    "Model": "OPPO R9skt"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "R9st",
    "Device": "R9s",
    "Model": "OPPO R9st"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "R9t",
    "Device": "R9",
    "Model": "OPPO R9t"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "R9tm",
    "Device": "R9",
    "Model": "OPPO R9tm"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "Reno",
    "Device": "OP47DD",
    "Model": "CPH1917"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "Reno",
    "Device": "OP47DDL1",
    "Model": "CPH1917"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "Reno 10x Room",
    "Device": "OP4847L1",
    "Model": "CPH1921"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "Reno 10x Zoom",
    "Device": "OP4845",
    "Model": "CPH1919"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "Reno 10x Zoom",
    "Device": "OP4845",
    "Model": "CPH1919RU"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "Reno 10x Zoom",
    "Device": "OP4845L1",
    "Model": "CPH1919"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "Reno 10x room",
    "Device": "OP4847",
    "Model": "CPH1921"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "Reno 10倍变焦版",
    "Device": "OP46C3",
    "Model": "PCCM00"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "Reno 10倍变焦版",
    "Device": "OP46C3",
    "Model": "PCCT00"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "Reno 11",
    "Device": "OP5ABFL1",
    "Model": "CPH2599"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "Reno 11 Pro",
    "Device": "OP5AD3L1",
    "Model": "CPH2607"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "Reno 2",
    "Device": "OP4B83L1",
    "Model": "CPH1907"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "Reno 2 中国版",
    "Device": "OP4A57",
    "Model": "PCKM00"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "Reno 4Z 5G",
    "Device": "OP4BDCL1",
    "Model": "CPH2065"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "Reno A",
    "Device": "OP47CFL1",
    "Model": "CPH1983"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "Reno Ace",
    "Device": "OP4A89",
    "Model": "PCLM10"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "Reno Ace2",
    "Device": "OP4AD9",
    "Model": "PDHM00"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "Reno Z",
    "Device": "OP48A1",
    "Model": "CPH1979"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "Reno Z",
    "Device": "OP48A1L1",
    "Model": "CPH1979"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "Reno Z 中国版",
    "Device": "OP4699",
    "Model": "PCDM10"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "Reno Z 中国版",
    "Device": "OP4699",
    "Model": "PCDT10"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "Reno 标准版",
    "Device": "OP46B1",
    "Model": "PCAM00"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "Reno 标准版",
    "Device": "OP46B1",
    "Model": "PCAT00"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "Reno10 5G",
    "Device": "OP5705L1",
    "Model": "CPH2531"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "Reno10 Pro 5G",
    "Device": "OP56DBL1",
    "Model": "A302OP"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "Reno10 Pro 5G",
    "Device": "OP56DBL1",
    "Model": "CPH2525"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "Reno10 Pro 5G",
    "Device": "OP56DBL1",
    "Model": "CPH2541"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "Reno10 Pro+ 5G",
    "Device": "OP56D3L1",
    "Model": "CPH2521"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "Reno11",
    "Device": "OP59EDL1",
    "Model": "PJH110"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "Reno11 A",
    "Device": "OP5A0BL1",
    "Model": "A401OP"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "Reno11 F 5G",
    "Device": "OP5A0BL1",
    "Model": "CPH2603"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "Reno11 F 5G/Reno11 A",
    "Device": "OP5A0BL1",
    "Model": "CPH2603"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "Reno11 Pro",
    "Device": "OP59EFL1",
    "Model": "PJJ110"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "Reno12",
    "Device": "OP5A29L1",
    "Model": "PJV110"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "Reno12 5G",
    "Device": "OP5ADDL1",
    "Model": "CPH2625"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "Reno12 F",
    "Device": "OP5EB1L1",
    "Model": "CPH2687"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "Reno12 F 5G",
    "Device": "OP5AF2L1",
    "Model": "CPH2637"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "Reno12 F/FS 5G",
    "Device": "OP5AF2L1",
    "Model": "CPH2637"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "Reno12 Pro",
    "Device": "OP5A2BL1",
    "Model": "PJW110"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "Reno12 Pro 5G",
    "Device": "OP5AE1L1",
    "Model": "CPH2629"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "Reno13",
    "Device": "OP5DD7L1",
    "Model": "PKM110"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "Reno13 5G",
    "Device": "OP5E9EL1",
    "Model": "CPH2689"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "Reno13 A",
    "Device": "OP5EC7L1",
    "Model": "A501OP"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "Reno13 A",
    "Device": "OP5EC7L1",
    "Model": "OPG05"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "Reno13 F",
    "Device": "OP5ECBL1",
    "Model": "CPH2701"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "Reno13 F 5G",
    "Device": "OP5EC7L1",
    "Model": "CPH2699"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "Reno13 F 5G / Reno13 A",
    "Device": "OP5EC7L1",
    "Model": "CPH2699"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "Reno13 Pro",
    "Device": "OP5DD5L1",
    "Model": "PKK110"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "Reno13 Pro 5G",
    "Device": "OP5EC5L1",
    "Model": "CPH2697"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "Reno14",
    "Device": "OP5E0BL1",
    "Model": "PLA110"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "Reno14 5G",
    "Device": "OP5F02L1",
    "Model": "CPH2737"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "Reno14 F 5G",
    "Device": "OP5F0FL1",
    "Model": "CPH2743"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "Reno14 F 5G/Reno14 FS 5G",
    "Device": "OP5F0FL1",
    "Model": "CPH2743"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "Reno14 Pro",
    "Device": "OP5E07L1",
    "Model": "PKZ110"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "Reno14 Pro 5G",
    "Device": "OP5F05L1",
    "Model": "CPH2739"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "Reno15",
    "Device": "OP61B7L1",
    "Model": "PLW110"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "Reno15 5G",
    "Device": "OP62B1L1",
    "Model": "CPH2825"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "Reno15 C 5G",
    "Device": "OP628FL1",
    "Model": "CPH2801"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "Reno15 F 5G",
    "Device": "OP628FL1",
    "Model": "CPH2801"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "Reno15 F 5G/Reno15 A",
    "Device": "OP628FL1",
    "Model": "CPH2801"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "Reno15 FS 5G/Reno15 F 5G",
    "Device": "OP628FL1",
    "Model": "CPH2801"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "Reno15 Pro",
    "Device": "OP61B3L1",
    "Model": "PLV110"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "Reno15 Pro 5G",
    "Device": "OP6293L1",
    "Model": "CPH2811"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "Reno15 Pro 5G",
    "Device": "OP629AL1",
    "Model": "CPH2813"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "Reno15 Pro Max 5G",
    "Device": "OP6293L1",
    "Model": "CPH2811"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "Reno15 Pro Mini 5G",
    "Device": "OP629AL1",
    "Model": "CPH2813"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "Reno15c",
    "Device": "OP61BBL1",
    "Model": "PMD110"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "Reno2 Z",
    "Device": "OP4B65L1",
    "Model": "CPH1945"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "Reno2 Z",
    "Device": "OP4B65L1",
    "Model": "CPH1951"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "Reno2 Z 中国版",
    "Device": "OP4A43",
    "Model": "PCKM80"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "Reno3",
    "Device": "OP4B9EL1",
    "Model": "CPH2043"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "Reno3 5G",
    "Device": "OP4C2DL1",
    "Model": "A001OP"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "Reno3 5G 中国版",
    "Device": "OP4ADD",
    "Model": "PDCM00"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "Reno3 A",
    "Device": "OP4BAFL1",
    "Model": "A002OP"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "Reno3 A",
    "Device": "OP4BAFL1",
    "Model": "CPH2013"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "Reno3 Pro",
    "Device": "OP4C2DL1",
    "Model": "CPH2009"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "Reno3 Pro",
    "Device": "OP4C5FL1",
    "Model": "CPH2035"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "Reno3 Pro",
    "Device": "OP4C5FL1",
    "Model": "CPH2036"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "Reno3 Pro",
    "Device": "OP4C5FL1",
    "Model": "CPH2037"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "Reno3 Pro 5G中国版",
    "Device": "OP4A9D",
    "Model": "PCRM00"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "Reno3 元气版 5G",
    "Device": "OP4AB5",
    "Model": "PCLM50"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "Reno4 5G",
    "Device": "OP4C45L1",
    "Model": "CPH2091"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "Reno4 F",
    "Device": "OP4C51L1",
    "Model": "CPH2209"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "Reno4 Lite",
    "Device": "OP4C51L1",
    "Model": "CPH2125"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "Reno4 Pro",
    "Device": "OP4AF7",
    "Model": "PDNT00"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "Reno4 Pro",
    "Device": "OP4C87L1",
    "Model": "CPH2089"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "Reno4 Pro 5G",
    "Device": "OP4C87L1",
    "Model": "CPH2089"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "Reno4 Pro 中国版",
    "Device": "OP4AF7",
    "Model": "PDNM00"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "Reno4 中国版",
    "Device": "OP4A47",
    "Model": "PDPM00"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "Reno4 中国版",
    "Device": "OP4A47",
    "Model": "PDPT00"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "Reno5",
    "Device": "OP4F25L1",
    "Model": "CPH2159"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "Reno5 A (eSIM)",
    "Device": "OP4F2BL1",
    "Model": "A103OP"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "Reno5 F",
    "Device": "OP4F43L1",
    "Model": "CPH2217"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "Reno5 Lite",
    "Device": "OP4F43L1",
    "Model": "CPH2205"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "Reno5 Pro 5G",
    "Device": "OP4EA3",
    "Model": "PDSM00"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "Reno6 Pro+ 5G",
    "Device": "OP4EC1",
    "Model": "PENM00"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "Reno7 Z 5G/Reno7 Lite 5G/Reno8 Lite 5G",
    "Device": "OP532FL1",
    "Model": "CPH2343"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "Reno7 中国版",
    "Device": "OP5227",
    "Model": "PFJM10"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "Reno8 T 5G",
    "Device": "OP56EDL1",
    "Model": "CPH2505"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "Reno9 A",
    "Device": "OP5701L1",
    "Model": "A301OP"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "Reno9 A",
    "Device": "OP5701L1",
    "Model": "CPH2523"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "U3",
    "Device": "U3",
    "Model": "U3"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "U707",
    "Device": "U707",
    "Model": "U707"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "U707T",
    "Device": "U707T",
    "Model": "U707T"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "U708",
    "Device": "U708",
    "Model": "U708"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "Ulike2",
    "Device": "U705W",
    "Model": "U705W"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "Ulike2",
    "Device": "Ulike2",
    "Model": "U705T"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "X9000",
    "Device": "X9000",
    "Model": "X9000"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "X9006",
    "Device": "X9006",
    "Model": "X9006"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "X9007",
    "Device": "X9007",
    "Model": "X9007"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "X9009",
    "Device": "X9009",
    "Model": "X9009"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "X9009fw",
    "Device": "X9009",
    "Model": "X9009fw"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "X9070",
    "Device": "X9070",
    "Model": "X9070"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "X9076",
    "Device": "X9076",
    "Model": "X9076"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "X9077",
    "Device": "FIND7",
    "Model": "X9077"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "X9077",
    "Device": "X9077",
    "Model": "X9077"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "X9079",
    "Device": "X9079",
    "Model": "X9079"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "X909",
    "Device": "FIND5",
    "Model": "X909"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "X909",
    "Device": "X909",
    "Model": "X909"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "X909",
    "Device": "X909T",
    "Model": "X909T"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "realme 1",
    "Device": "CPH1859",
    "Model": "CPH1859"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "realme 1",
    "Device": "CPH1861",
    "Model": "CPH1861"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "realme 2",
    "Device": "RMX1805",
    "Model": "RMX1805"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "realme 2",
    "Device": "RMX1809",
    "Model": "RMX1809"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "realme 2 Pro",
    "Device": "RMX1803",
    "Model": "RMX1803"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "realme 2 Pro",
    "Device": "RMX1807",
    "Model": "RMX1807"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "realme 3",
    "Device": "RMX1821",
    "Model": "RMX1821"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "realme 3",
    "Device": "RMX1822",
    "Model": "RMX1822"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "realme 3",
    "Device": "RMX1825",
    "Model": "RMX1825"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "realme 3Pro",
    "Device": "RMX1853",
    "Model": "RMX1853"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "realme 3i",
    "Device": "RMX1827",
    "Model": "RMX1827"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "realme 5",
    "Device": "RMX1911",
    "Model": "RMX1911"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "realme C1",
    "Device": "RMX1811",
    "Model": "RMX1811"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "realme C2",
    "Device": "RMX1941",
    "Model": "RMX1941"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "realme C2",
    "Device": "RMX1942",
    "Model": "RMX1942"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "realme C2",
    "Device": "RMX1943",
    "Model": "RMX1943"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "realme C2",
    "Device": "RMX1945",
    "Model": "RMX1945"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "realme C51",
    "Device": "RE58BC",
    "Model": "RMX3830"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "realme U1",
    "Device": "RMX1831",
    "Model": "RMX1831"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "realme U1",
    "Device": "RMX1833",
    "Model": "RMX1833"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "realme X",
    "Device": "RMX1901CN",
    "Model": "RMX1901"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "realme X Lite",
    "Device": "RMX1851CN",
    "Model": "RMX1851"
  },
  {
    "Retail Branding": "Oppo",
    "Marketing Name": "realme X50 5G",
    "Device": "RMX2051CN",
    "Model": "RMX2051"
  },
  {
    "Retail Branding": "Optage",
    "Marketing Name": "Amigo7xJP",
    "Device": "Amigo7xJP",
    "Model": "Amigo7xJP"
  },
  {
    "Retail Branding": "Opticon",
    "Marketing Name": "H-27",
    "Device": "H-27",
    "Model": "H-27"
  },
  {
    "Retail Branding": "Opticon",
    "Marketing Name": "H-31",
    "Device": "h31",
    "Model": "h31"
  },
  {
    "Retail Branding": "Opticon",
    "Marketing Name": "H-33",
    "Device": "h33",
    "Model": "h33"
  },
  {
    "Retail Branding": "Opticon",
    "Marketing Name": "H-35",
    "Device": "H-35",
    "Model": "H-35"
  },
  {
    "Retail Branding": "Optoma",
    "Marketing Name": "IFP3Gen3",
    "Device": "SXXSRK",
    "Model": "SXXSRK"
  },
  {
    "Retail Branding": "Optoma",
    "Marketing Name": "IFP5Gen3",
    "Device": "rk3588_t",
    "Model": "UXXSRK"
  },
  {
    "Retail Branding": "Optoma",
    "Marketing Name": "OPS200",
    "Device": "rk3588_t",
    "Model": "ACONZZ"
  },
  {
    "Retail Branding": "Oraimo",
    "Marketing Name": "R401",
    "Device": "oraimo-R401",
    "Model": "oraimo R401"
  },
  {
    "Retail Branding": "Oraimo",
    "Marketing Name": "R402",
    "Device": "oraimo-R402",
    "Model": "oraimo R402"
  },
  {
    "Retail Branding": "Oraimo",
    "Marketing Name": "oraimo R401S",
    "Device": "oraimo-R401",
    "Model": "oraimo R401S"
  },
  {
    "Retail Branding": "Orange",
    "Marketing Name": "DV8555",
    "Device": "DV8555-KPO",
    "Model": "DV8555"
  },
  {
    "Retail Branding": "Orange",
    "Marketing Name": "DV9651",
    "Device": "DV9651-KPO",
    "Model": "DV9651"
  },
  {
    "Retail Branding": "Orange",
    "Marketing Name": "Dive 30",
    "Device": "P635E40",
    "Model": "Orange Dive 30"
  },
  {
    "Retail Branding": "Orange",
    "Marketing Name": "Dive 30",
    "Device": "P635E40",
    "Model": "ZTE Blade A410"
  },
  {
    "Retail Branding": "Orange",
    "Marketing Name": "Dive 50",
    "Device": "pixi3_45_4g_orange",
    "Model": "Orange Dive 50"
  },
  {
    "Retail Branding": "Orange",
    "Marketing Name": "Dive 50 Dual",
    "Device": "pixi3_45_4g_orange",
    "Model": "Dive 50 Dual"
  },
  {
    "Retail Branding": "Orange",
    "Marketing Name": "Dive 71",
    "Device": "Orange_Dive_71",
    "Model": "Orange Dive 71"
  },
  {
    "Retail Branding": "Orange",
    "Marketing Name": "Dive72",
    "Device": "mickey6",
    "Model": "Orange-Dive72"
  },
  {
    "Retail Branding": "Orange",
    "Marketing Name": "Dive_70",
    "Device": "Dive_70",
    "Model": "SCL-L01"
  },
  {
    "Retail Branding": "Orange",
    "Marketing Name": "Five",
    "Device": "OrangeFive",
    "Model": "OrangeFive"
  },
  {
    "Retail Branding": "Orange",
    "Marketing Name": "H5032_Orange",
    "Device": "H5032",
    "Model": "H5032_Orange"
  },
  {
    "Retail Branding": "Orange",
    "Marketing Name": "Luno",
    "Device": "Luno",
    "Model": "Luno"
  },
  {
    "Retail Branding": "Orange",
    "Marketing Name": "Mahpee",
    "Device": "Mahpee",
    "Model": "Orange Mahpee"
  },
  {
    "Retail Branding": "Orange",
    "Marketing Name": "MouveTab7WIFI",
    "Device": "MouveTab7WIFI",
    "Model": "MouveTab7WIFI"
  },
  {
    "Retail Branding": "Orange",
    "Marketing Name": "NOS Roya",
    "Device": "Alto45",
    "Model": "NOS Roya"
  },
  {
    "Retail Branding": "Orange",
    "Marketing Name": "Neva 80",
    "Device": "Orange_Neva_80",
    "Model": "Orange Neva 80"
  },
  {
    "Retail Branding": "Orange",
    "Marketing Name": "Neva Rise S1",
    "Device": "Neva_Rise_S1",
    "Model": "Neva Rise S1"
  },
  {
    "Retail Branding": "Orange",
    "Marketing Name": "Neva leaf",
    "Device": "Neva_leaf",
    "Model": "Orange Neva leaf"
  },
  {
    "Retail Branding": "Orange",
    "Marketing Name": "Neva start",
    "Device": "Neva_start",
    "Model": "Orange Neva start"
  },
  {
    "Retail Branding": "Orange",
    "Marketing Name": "Nola fun",
    "Device": "Nola_fun",
    "Model": "Orange Nola fun"
  },
  {
    "Retail Branding": "Orange",
    "Marketing Name": "Nura",
    "Device": "M812",
    "Model": "Orange Nura"
  },
  {
    "Retail Branding": "Orange",
    "Marketing Name": "Nura2",
    "Device": "m823_orange",
    "Model": "Nura 2"
  },
  {
    "Retail Branding": "Orange",
    "Marketing Name": "Orange",
    "Device": "Rise_55",
    "Model": "Orange Rise 55"
  },
  {
    "Retail Branding": "Orange",
    "Marketing Name": "Orange ES VSB3918",
    "Device": "m393vsb_osp",
    "Model": "Orange ES VSB3918"
  },
  {
    "Retail Branding": "Orange",
    "Marketing Name": "Orange Neva leaf",
    "Device": "Neva_leaf",
    "Model": "Orange Neva leaf"
  },
  {
    "Retail Branding": "Orange",
    "Marketing Name": "Orange Neva play",
    "Device": "Neva_play",
    "Model": "Orange Neva play"
  },
  {
    "Retail Branding": "Orange",
    "Marketing Name": "Orange Neva sparkle",
    "Device": "Neva_sparkle",
    "Model": "Orange Neva sparkle"
  },
  {
    "Retail Branding": "Orange",
    "Marketing Name": "Orange Neva zen",
    "Device": "Neva_zen",
    "Model": "Orange Neva zen"
  },
  {
    "Retail Branding": "Orange",
    "Marketing Name": "Orange Nola XL",
    "Device": "Nola-ultra",
    "Model": "Orange Nola XL"
  },
  {
    "Retail Branding": "Orange",
    "Marketing Name": "Orange Nola XL 2",
    "Device": "Nola_XL_2",
    "Model": "Orange Nola XL 2"
  },
  {
    "Retail Branding": "Orange",
    "Marketing Name": "Orange Nola fun 3",
    "Device": "Nola_fun_3",
    "Model": "Orange Nola fun 3"
  },
  {
    "Retail Branding": "Orange",
    "Marketing Name": "Orange Nola play",
    "Device": "Nola_play",
    "Model": "Orange Nola play"
  },
  {
    "Retail Branding": "Orange",
    "Marketing Name": "Orange Nola play plus",
    "Device": "Nola_play_plus",
    "Model": "Orange Nola play plus"
  },
  {
    "Retail Branding": "Orange",
    "Marketing Name": "Orange Rise 33",
    "Device": "Rise33",
    "Model": "Orange_Rise_33"
  },
  {
    "Retail Branding": "Orange",
    "Marketing Name": "Orange Rise 53",
    "Device": "Rise_53",
    "Model": "Orange Rise 53"
  },
  {
    "Retail Branding": "Orange",
    "Marketing Name": "Orange SK VSB3918",
    "Device": "eu_vsb3918",
    "Model": "EU AVSB 3918"
  },
  {
    "Retail Branding": "Orange",
    "Marketing Name": "Orange V652L",
    "Device": "Orange-V652L",
    "Model": "Orange V652L"
  },
  {
    "Retail Branding": "Orange",
    "Marketing Name": "Orange_Tab_7_4G",
    "Device": "Orange_Tab_7_4G",
    "Model": "Orange_Tab_7_4G"
  },
  {
    "Retail Branding": "Orange",
    "Marketing Name": "Orange_Tab_8_4G",
    "Device": "Orange_Tab_8_4G",
    "Model": "Orange_Tab_8_4G"
  },
  {
    "Retail Branding": "Orange",
    "Marketing Name": "Race_1",
    "Device": "Race_1",
    "Model": "Race 1"
  },
  {
    "Retail Branding": "Orange",
    "Marketing Name": "Rise 30",
    "Device": "Pixi3-4",
    "Model": "Orange Rise 30"
  },
  {
    "Retail Branding": "Orange",
    "Marketing Name": "Rise 35",
    "Device": "Rise_35",
    "Model": "Orange Rise 35"
  },
  {
    "Retail Branding": "Orange",
    "Marketing Name": "Rise 40",
    "Device": "ZTE_BLADE_A110",
    "Model": "Orange Rise 40"
  },
  {
    "Retail Branding": "Orange",
    "Marketing Name": "Rise 50",
    "Device": "Rise50",
    "Model": "Rise50"
  },
  {
    "Retail Branding": "Orange",
    "Marketing Name": "Rise30",
    "Device": "Pixi3-4",
    "Model": "Orange-Rise30"
  },
  {
    "Retail Branding": "Orange",
    "Marketing Name": "Rise31",
    "Device": "Pixi4-4",
    "Model": "Orange-Rise31"
  },
  {
    "Retail Branding": "Orange",
    "Marketing Name": "Rise31",
    "Device": "Pixi4-4",
    "Model": "Orange-Rise34"
  },
  {
    "Retail Branding": "Orange",
    "Marketing Name": "Rise32",
    "Device": "Orange-Rise32",
    "Model": "Orange Rise32"
  },
  {
    "Retail Branding": "Orange",
    "Marketing Name": "Rise51",
    "Device": "PIXI4_5_4G",
    "Model": "Orange-Rise51"
  },
  {
    "Retail Branding": "Orange",
    "Marketing Name": "Rise51",
    "Device": "PIXI4_5_4G",
    "Model": "Orange-Rise51B"
  },
  {
    "Retail Branding": "Orange",
    "Marketing Name": "Rise52",
    "Device": "BUZZ6T4G",
    "Model": "Orange-Rise52"
  },
  {
    "Retail Branding": "Orange",
    "Marketing Name": "Rise_54",
    "Device": "Rise_54",
    "Model": "Orange Rise 54"
  },
  {
    "Retail Branding": "Orange",
    "Marketing Name": "Rise_54",
    "Device": "Rise_54",
    "Model": "Orange Rise 54 EEA"
  },
  {
    "Retail Branding": "Orange",
    "Marketing Name": "Roya",
    "Device": "Alto45",
    "Model": "Orange Roya"
  },
  {
    "Retail Branding": "Orange",
    "Marketing Name": "Sanza plus",
    "Device": "Sanza_plus",
    "Model": "Orange Sanza plus"
  },
  {
    "Retail Branding": "Orange",
    "Marketing Name": "Sanza_touch",
    "Device": "Sanza_touch",
    "Model": "Orange Sanza touch"
  },
  {
    "Retail Branding": "Orange",
    "Marketing Name": "Sego",
    "Device": "Orange_Sego",
    "Model": "Orange Sego"
  },
  {
    "Retail Branding": "Orange",
    "Marketing Name": "TV Box",
    "Device": "zc4455v_orb",
    "Model": "Orange TV Box"
  },
  {
    "Retail Branding": "Orange",
    "Marketing Name": "TV Box",
    "Device": "zi4450v_ors",
    "Model": "Orange TV Box"
  },
  {
    "Retail Branding": "Orange",
    "Marketing Name": "TV Box 4K",
    "Device": "zc4450v_orm",
    "Model": "Orange TV Box"
  },
  {
    "Retail Branding": "Orange",
    "Marketing Name": "Zilo",
    "Device": "Orange_Zilo",
    "Model": "Zilo"
  },
  {
    "Retail Branding": "Orange",
    "Marketing Name": "idol S",
    "Device": "Diablo_LTE",
    "Model": "Orange Niva"
  },
  {
    "Retail Branding": "Orange Polska",
    "Marketing Name": "opl_cherryV2",
    "Device": "m377_opl",
    "Model": "Orange PL DIW377"
  },
  {
    "Retail Branding": "Orange TV",
    "Marketing Name": "Descodificador Orange TV",
    "Device": "KSTB6130",
    "Model": "KSTB6130"
  },
  {
    "Retail Branding": "Orange TV",
    "Marketing Name": "Descodificador Orange TV",
    "Device": "KSTB7259",
    "Model": "KSTB7259"
  },
  {
    "Retail Branding": "Orbic",
    "Marketing Name": "FunLiberty",
    "Device": "Fun",
    "Model": "R678L5SLFP"
  },
  {
    "Retail Branding": "Orbic",
    "Marketing Name": "Magic",
    "Device": "R678EL",
    "Model": "R678EL"
  },
  {
    "Retail Branding": "Orbic",
    "Marketing Name": "O4S231AZ",
    "Device": "Fun2",
    "Model": "O4S23"
  },
  {
    "Retail Branding": "Orbic",
    "Marketing Name": "Orbic Fun Pro 5G",
    "Device": "Fun",
    "Model": "R678L5SFP"
  },
  {
    "Retail Branding": "Orbic",
    "Marketing Name": "Orbic Style 5G",
    "Device": "Style",
    "Model": "R678L5S"
  },
  {
    "Retail Branding": "Orbic",
    "Marketing Name": "R10L5TR",
    "Device": "R10L5TR",
    "Model": "R10L5TR"
  },
  {
    "Retail Branding": "Orbic",
    "Marketing Name": "R370H",
    "Device": "R370H",
    "Model": "R370L"
  },
  {
    "Retail Branding": "Orbic",
    "Marketing Name": "R4S14V_Visible",
    "Device": "JOY2",
    "Model": "R4S14V"
  },
  {
    "Retail Branding": "Orbic",
    "Marketing Name": "R4S14_VZW",
    "Device": "JOY2",
    "Model": "R4S14"
  },
  {
    "Retail Branding": "Orbic",
    "Marketing Name": "R667L5PB",
    "Device": "TrophyPlus",
    "Model": "R667L5P"
  },
  {
    "Retail Branding": "Orbic",
    "Marketing Name": "R667L5U_VZW",
    "Device": "Trophy",
    "Model": "R667L5U"
  },
  {
    "Retail Branding": "Orbic",
    "Marketing Name": "R678L5",
    "Device": "R678L5",
    "Model": "R678L5"
  },
  {
    "Retail Branding": "Orbic",
    "Marketing Name": "R678L5V",
    "Device": "R678L5",
    "Model": "R678L5V"
  },
  {
    "Retail Branding": "Orbic",
    "Marketing Name": "R8L5T",
    "Device": "R8L5T",
    "Model": "R8L5T"
  },
  {
    "Retail Branding": "Orbic",
    "Marketing Name": "RC10RL1T-RW",
    "Device": "VC_Device",
    "Model": "RC10RLT-RW"
  },
  {
    "Retail Branding": "Orbic",
    "Marketing Name": "RC10RLT",
    "Device": "VC_Device",
    "Model": "RC10RLT"
  },
  {
    "Retail Branding": "Orbic",
    "Marketing Name": "RC10RLT-RW1",
    "Device": "VC_Device",
    "Model": "RC10RLT-RW"
  },
  {
    "Retail Branding": "Orbic",
    "Marketing Name": "RC506LT",
    "Device": "Orbic-RC506LT",
    "Model": "RC506LT"
  },
  {
    "Retail Branding": "Orbic",
    "Marketing Name": "RC545L",
    "Device": "RC545L",
    "Model": "RC545L"
  },
  {
    "Retail Branding": "Orbic",
    "Marketing Name": "RC545LF",
    "Device": "RC545L",
    "Model": "RC545L"
  },
  {
    "Retail Branding": "Orbic",
    "Marketing Name": "RC608L2",
    "Device": "RC608L",
    "Model": "RC608L2"
  },
  {
    "Retail Branding": "Orbic",
    "Marketing Name": "RC609L",
    "Device": "RC609L",
    "Model": "RC609L"
  },
  {
    "Retail Branding": "Orbic",
    "Marketing Name": "RC609L2",
    "Device": "RC609L2",
    "Model": "RC609L2"
  },
  {
    "Retail Branding": "Orbic",
    "Marketing Name": "RC609LP-RWANZ",
    "Device": "RC609LP",
    "Model": "RC609LP"
  },
  {
    "Retail Branding": "Orbic",
    "Marketing Name": "RC609LP-RWANZ",
    "Device": "RC609LP",
    "Model": "RC609LP-RW"
  },
  {
    "Retail Branding": "Orbic",
    "Marketing Name": "RC609LSM",
    "Device": "RC609LSM",
    "Model": "RC609LSM"
  },
  {
    "Retail Branding": "Orbic",
    "Marketing Name": "RC656LMBTF",
    "Device": "JOY2",
    "Model": "RC656V"
  },
  {
    "Retail Branding": "Orbic",
    "Marketing Name": "RC656LTGL",
    "Device": "JOY2",
    "Model": "RC656L"
  },
  {
    "Retail Branding": "Orbic",
    "Marketing Name": "RC8L1T",
    "Device": "RC8L1T-RW",
    "Model": "RC8L1T"
  },
  {
    "Retail Branding": "Orbic",
    "Marketing Name": "RC8L1T-RW",
    "Device": "RC8L1T-RW",
    "Model": "RC8L1T-RW"
  },
  {
    "Retail Branding": "Orbic",
    "Marketing Name": "RC8L1T-RW1",
    "Device": "RC8L1T-RW",
    "Model": "RC8L1T-RW"
  },
  {
    "Retail Branding": "Orbic",
    "Marketing Name": "StyleVisible",
    "Device": "Style",
    "Model": "R678L5SV"
  },
  {
    "Retail Branding": "Orbic",
    "Marketing Name": "T1003R",
    "Device": "VC_Device",
    "Model": "RC10RLT-RW"
  },
  {
    "Retail Branding": "Orbic",
    "Marketing Name": "Trophy",
    "Device": "Trophy",
    "Model": "R667L5"
  },
  {
    "Retail Branding": "Orbic",
    "Marketing Name": "TrophyLiberty",
    "Device": "Trophy",
    "Model": "R667L5"
  },
  {
    "Retail Branding": "Orbic",
    "Marketing Name": "Wonder",
    "Device": "RC555L",
    "Model": "RC555L"
  },
  {
    "Retail Branding": "Orbit",
    "Marketing Name": "Smart TV",
    "Device": "dangni",
    "Model": "Orbit GOOGLE TV"
  },
  {
    "Retail Branding": "OrbitWorld",
    "Marketing Name": "OrbitHome_Tablet",
    "Device": "OrbitHome_Tablet",
    "Model": "OrbitWorld_Tablet"
  },
  {
    "Retail Branding": "OrbitWorld",
    "Marketing Name": "OrbitWorld_Tablet",
    "Device": "OrbitWorld_Tablet",
    "Model": "OrbitWorld_Tablet"
  },
  {
    "Retail Branding": "OrbitWorld",
    "Marketing Name": "Smart TV",
    "Device": "alimos",
    "Model": "Orbit GOOGLE TV"
  },
  {
    "Retail Branding": "Ordissimo",
    "Marketing Name": "Celia",
    "Device": "Celia",
    "Model": "Celia"
  },
  {
    "Retail Branding": "Ordissimo",
    "Marketing Name": "LeNumero2Mini EEA",
    "Device": "LeNumero2Mini",
    "Model": "LeNumero2Mini"
  },
  {
    "Retail Branding": "Ordissimo",
    "Marketing Name": "Ordissimo LeNumero2",
    "Device": "LeNumero2",
    "Model": "LeNumero2"
  },
  {
    "Retail Branding": "Ordissimo",
    "Marketing Name": "PixStarTouch",
    "Device": "PixStarTouch",
    "Model": "PixStarTouch"
  },
  {
    "Retail Branding": "Orient",
    "Marketing Name": "Android TV",
    "Device": "R1",
    "Model": "ATV R1"
  },
  {
    "Retail Branding": "Orient",
    "Marketing Name": "Android TV",
    "Device": "R2",
    "Model": "ATV R2"
  },
  {
    "Retail Branding": "Orient",
    "Marketing Name": "OrientTV",
    "Device": "shibuya",
    "Model": "OrientTV"
  },
  {
    "Retail Branding": "Orient",
    "Marketing Name": "R3",
    "Device": "R3",
    "Model": "R3"
  },
  {
    "Retail Branding": "Orient",
    "Marketing Name": "R4",
    "Device": "R4",
    "Model": "R4"
  },
  {
    "Retail Branding": "Orpyx",
    "Marketing Name": "OSIDDV1",
    "Device": "OSIDDV1",
    "Model": "OSIDDV1"
  },
  {
    "Retail Branding": "Oteeto",
    "Marketing Name": "OE1",
    "Device": "OE1",
    "Model": "OE1"
  },
  {
    "Retail Branding": "Oteeto",
    "Marketing Name": "OE1_EEA",
    "Device": "OE1_EEA",
    "Model": "OE1"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "ALMIIS-01",
    "Device": "ALMIIS-01",
    "Model": "ALMIIS-01"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "C10",
    "Device": "C10",
    "Model": "C10"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "C10 Pro",
    "Device": "C10_Pro",
    "Model": "C10 Pro"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "C11",
    "Device": "C11",
    "Model": "C11"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "C11 Pro",
    "Device": "C11_Pro",
    "Model": "C11_Pro"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "C11 S",
    "Device": "C11_S",
    "Model": "C11_S"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "C12",
    "Device": "C12",
    "Model": "C12"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "C12 Plus",
    "Device": "C12_Plus",
    "Model": "C12 Plus"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "C12 Pro",
    "Device": "C12_Pro",
    "Model": "C12 Pro"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "C13 Pro",
    "Device": "C13_Pro",
    "Model": "C13 Pro"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "C15 Pro",
    "Device": "C15_Pro",
    "Model": "C15 Pro"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "C16",
    "Device": "C16",
    "Model": "C16"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "C16 Pro",
    "Device": "C16_Pro",
    "Model": "C16_Pro"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "C17 Pro",
    "Device": "C17_Pro",
    "Model": "C17 Pro"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "C18 Plus",
    "Device": "C18_Plus",
    "Model": "C18_Plus"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "C18 Pro",
    "Device": "C18_Pro",
    "Model": "C18_Pro"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "C19",
    "Device": "C19",
    "Model": "C19"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "C19 Pro",
    "Device": "C19_Pro",
    "Model": "C19 Pro"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "C19 Pro_ROW",
    "Device": "C19_Pro",
    "Model": "C19 Pro"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "C1_Pro_EEA",
    "Device": "C1_Pro",
    "Model": "C1 Pro"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "C21",
    "Device": "C21",
    "Model": "C21"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "C21 Pro",
    "Device": "C21_Pro",
    "Model": "C21 Pro"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "C21_Plus_EEA",
    "Device": "C21_Plus",
    "Model": "C21 Plus"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "C21_Pro_EEA",
    "Device": "C21_Pro",
    "Model": "C21 Pro"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "C22",
    "Device": "C22",
    "Model": "C22"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "C23_Pro",
    "Device": "C23_Pro",
    "Model": "C23 Pro"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "C25_EEA",
    "Device": "C25",
    "Model": "C25"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "C25_RU",
    "Device": "C25",
    "Model": "C25"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "C26_EEA",
    "Device": "C26",
    "Model": "C26"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "C27_Pro_EEA",
    "Device": "C27_Pro",
    "Model": "C27 Pro"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "C30",
    "Device": "C30_EEA",
    "Model": "C30"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "C31_EEA",
    "Device": "C31",
    "Model": "C31"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "C31_Pro_EEA",
    "Device": "C31_Pro",
    "Model": "C31 Pro"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "C32_EEA",
    "Device": "C32",
    "Model": "C32"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "C32_Pro_EEA",
    "Device": "C32_Pro",
    "Model": "C32 Pro"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "C33_EEA",
    "Device": "C33",
    "Model": "C33"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "C35_EEA",
    "Device": "C35",
    "Model": "C35"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "C36_EEA",
    "Device": "C36",
    "Model": "C36"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "C36_T_EEA",
    "Device": "C36",
    "Model": "C36"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "C36_U_EEA",
    "Device": "C36",
    "Model": "C36"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "C37_EEA",
    "Device": "C37",
    "Model": "C37"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "C38_EEA",
    "Device": "C38",
    "Model": "C 38"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "C38_EEA",
    "Device": "C38",
    "Model": "C38"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "C50_EEA",
    "Device": "C50",
    "Model": "C50"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "C50_ROW",
    "Device": "C50",
    "Model": "C50"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "C51_EEA",
    "Device": "C51",
    "Model": "C51"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "C53",
    "Device": "C53",
    "Model": "C53"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "C57_Pro_EEA",
    "Device": "C57_Pro",
    "Model": "C57 Pro"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "C57_S_EEA",
    "Device": "C57_S",
    "Model": "C57 S"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "C58_EEA",
    "Device": "C58",
    "Model": "C58"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "C58_Pro_EEA",
    "Device": "C58_Pro",
    "Model": "C58 Pro"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "C59 Pro_A15_EEA",
    "Device": "C59_Pro_A15",
    "Model": "C59 Pro"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "C59_A15_EEA",
    "Device": "C59_A15",
    "Model": "C59"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "C59_Pro_EEA",
    "Device": "C59_Pro",
    "Model": "C59 Pro"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "C6 Pro",
    "Device": "C6_Pro",
    "Model": "C6 Pro"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "C60_Pro_EEA",
    "Device": "C60_Pro",
    "Model": "C60 Pro"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "C61_A15_EEA",
    "Device": "C61",
    "Model": "C61"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "C61_Plus_ROW",
    "Device": "C61_Plus",
    "Model": "C61 CDMA"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "C61_Pro",
    "Device": "C61_Pro",
    "Model": "C61 Pro"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "C61_Pro_A15_EEA",
    "Device": "C61_Pro",
    "Model": "C61 Pro"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "C61_Pro_A15_ROW",
    "Device": "C61_Pro",
    "Model": "C61 Pro"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "C61_Pro_EEA",
    "Device": "C61_Pro",
    "Model": "C61 Pro"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "C62_A15_EEA",
    "Device": "C62",
    "Model": "C62"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "C62_A15_ROW",
    "Device": "C62",
    "Model": "C62"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "C62_Pro_A15_EEA",
    "Device": "C62_Pro",
    "Model": "C62 Pro"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "C62_Pro_A15_ROW",
    "Device": "C62_Pro",
    "Model": "C62 Pro"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "C62_Pro_EEA",
    "Device": "C62_Pro",
    "Model": "C62 Pro"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "C63_EEA",
    "Device": "C63",
    "Model": "C63"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "C63_Pro_EEA",
    "Device": "C63_Pro",
    "Model": "C63 Pro"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "C65_EEA",
    "Device": "C65",
    "Model": "C65"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "C65_Pro_EEA",
    "Device": "C65_Pro",
    "Model": "C65 Pro"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "C66_EEA",
    "Device": "C66",
    "Model": "C66"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "C66_NFC_EEA",
    "Device": "C66_NFC",
    "Model": "C66"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "C66_NFC_ROW",
    "Device": "C66_NFC",
    "Model": "C66"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "C67_EEA",
    "Device": "C67",
    "Model": "C67"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "C68_EEA",
    "Device": "C68",
    "Model": "C68"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "C68_NFC_EEA",
    "Device": "C68",
    "Model": "C68"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "C68_NFC_ROW",
    "Device": "C68",
    "Model": "C68"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "C68_Plus_EEA",
    "Device": "C68_Plus",
    "Model": "C68 Plus"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "C68_Plus_NFC_EEA",
    "Device": "C68_Plus",
    "Model": "C68 Plus"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "C68_Plus_NFC_ROW",
    "Device": "C68_Plus",
    "Model": "C68 Plus"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "C68_Plus_ROW",
    "Device": "C68_Plus",
    "Model": "C68 Plus"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "C68_ROW",
    "Device": "C68",
    "Model": "C68"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "C69_EEA",
    "Device": "C69",
    "Model": "C69"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "C69_NFC_EEA",
    "Device": "C69",
    "Model": "C69"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "C69_NFC_ROW",
    "Device": "C69",
    "Model": "C69"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "C69_ROW",
    "Device": "C69",
    "Model": "C69"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "C6_EEA",
    "Device": "C6",
    "Model": "C6"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "C6_ROW",
    "Device": "C6",
    "Model": "C6"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "C71_EEA",
    "Device": "C71",
    "Model": "C71"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "C71_Pro_EEA",
    "Device": "C71_Pro",
    "Model": "C71 Pro"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "C72_EEA",
    "Device": "C72",
    "Model": "C72"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "C72_Pro_EEA",
    "Device": "C72_Pro",
    "Model": "C72 Pro"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "C7_EEA",
    "Device": "C7",
    "Model": "C7"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "C7_ROW",
    "Device": "C7",
    "Model": "C7"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "C8",
    "Device": "C8",
    "Model": "C8"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "C8 4G",
    "Device": "C8_4G",
    "Model": "C8 4G"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "C8_EEA",
    "Device": "C8",
    "Model": "C8"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "C8_ROW",
    "Device": "C8",
    "Model": "C8"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "C9",
    "Device": "C9",
    "Model": "C9"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "C90_EEA",
    "Device": "C90",
    "Model": "C90"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "C90_Pro_EEA",
    "Device": "C90_Pro",
    "Model": "C90 Pro"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "Coosea",
    "Device": "K3",
    "Model": "K3"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "Customer need debug",
    "Device": "WP32_Pro",
    "Model": "WP32 Pro"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "G1_A15_EEA",
    "Device": "G1",
    "Model": "G1"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "G1_A15_ROW",
    "Device": "G1",
    "Model": "G1"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "G1_EEA",
    "Device": "G1",
    "Model": "G1"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "G1_S_EEA",
    "Device": "G1_S",
    "Model": "G1 S"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "G1_S_ROW",
    "Device": "G1_S",
    "Model": "G1 S"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "G2-EEA",
    "Device": "G2",
    "Model": "G2"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "G6_EEA",
    "Device": "G6",
    "Model": "G6"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "G6_NFC_EEA",
    "Device": "G6",
    "Model": "G6"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "G7_EEA",
    "Device": "G7",
    "Model": "G7"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "G7_NFC_EEA",
    "Device": "G7",
    "Model": "G7"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "Industry_EEA",
    "Device": "Industry",
    "Model": "Industry"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "K10",
    "Device": "K10",
    "Model": "K10"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "K10000 Mix",
    "Device": "K10000_Mix",
    "Model": "K10000 Mix"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "K10000 Pro",
    "Device": "K10000_Pro",
    "Model": "K10000 Pro"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "K10000_Max",
    "Device": "K10000_Max",
    "Model": "K10000 Max"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "K12",
    "Device": "K12",
    "Model": "K12"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "K13 Pro",
    "Device": "K13_Pro",
    "Model": "K13_Pro"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "K15 Plus",
    "Device": "K15_Plus",
    "Model": "K15_Plus"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "K15_Plus_RU",
    "Device": "K15_Plus",
    "Model": "K15_Plus"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "K15_Pro_EEA",
    "Device": "K15_Pro",
    "Model": "K15 Pro"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "K16_EEA",
    "Device": "K16",
    "Model": "K16"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "K3",
    "Device": "K3",
    "Model": "K3"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "K3 Pro",
    "Device": "K3_Pro",
    "Model": "K3_Pro"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "K5",
    "Device": "K5",
    "Model": "K5"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "K5000",
    "Device": "K5000",
    "Model": "K5000"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "K6",
    "Device": "K6",
    "Model": "K6"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "K6000 Plus",
    "Device": "K6000_Plus",
    "Model": "K6000 Plus"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "K7",
    "Device": "OUKITEL_K7",
    "Model": "K7"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "K7 Power",
    "Device": "K7_Power",
    "Model": "K7 Power"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "K7_Power",
    "Device": "K7_Power",
    "Model": "K7 Power"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "K7_Pro",
    "Device": "K7_Pro",
    "Model": "K7_Pro"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "K8",
    "Device": "K8",
    "Model": "K8"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "K8000",
    "Device": "K8000",
    "Model": "K8000"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "K9",
    "Device": "K9",
    "Model": "K9"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "K9 Pro",
    "Device": "K9_Pro",
    "Model": "K9 Pro"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "MIX 2",
    "Device": "MIX_2",
    "Model": "MIX 2"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "OK6000 PLUS",
    "Device": "OK6000_Plus",
    "Model": "OK6000 Plus"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "OKC8 4G",
    "Device": "OKC8_4G",
    "Model": "OKC8 4G"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "OKT1",
    "Device": "OKT1",
    "Model": "OKT1"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "OKT3",
    "Device": "OKT3",
    "Model": "OKT3"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "OT11",
    "Device": "OT11",
    "Model": "OT11"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "OT11_ROW",
    "Device": "OT11",
    "Model": "OT11"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "OT12_EEA",
    "Device": "OT12",
    "Model": "OT12"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "OT12_EEA",
    "Device": "OT12",
    "Model": "P1095"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "OT12_ROW",
    "Device": "OT12",
    "Model": "OT12"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "OT13_A16_EEA",
    "Device": "OT13",
    "Model": "OT13"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "OT15_EEA",
    "Device": "OT15",
    "Model": "OT15"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "OT5_EEA",
    "Device": "OT5",
    "Model": "OT5"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "OT5_S_EEA",
    "Device": "OT5_S",
    "Model": "OT5 S"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "OT5_S_V_EEA",
    "Device": "OT5_S",
    "Model": "OT5 S"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "OT6_EEA",
    "Device": "OT6",
    "Model": "OT6"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "OT6_Kids_EEA",
    "Device": "OT6_Kids",
    "Model": "OT6 Kids"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "OT6_Pro_EEA",
    "Device": "OT6_Pro",
    "Model": "OT6 Pro"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "OT7_EEA",
    "Device": "OT7",
    "Model": "OT7"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "OT8_EEA",
    "Device": "OT8",
    "Model": "IHTPRO64"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "OT8_EEA",
    "Device": "OT8",
    "Model": "OT8"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "OT8_ROW",
    "Device": "OT8",
    "Model": "OT8"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "OT9",
    "Device": "OT9",
    "Model": "OT9"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "OUKITEL_C1_EEA",
    "Device": "OUKITEL_C1",
    "Model": "OUKITEL C1"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "OUKITEL_C1_Pro_EEA",
    "Device": "OUKITEL_C1_Pro",
    "Model": "OUKITEL C1 Pro"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "OUKITEL_C2_EEA",
    "Device": "OUKITEL_C2",
    "Model": "OUKITEL C2"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "OUKITEL_C2_EEA",
    "Device": "YJC235",
    "Model": "OUKITEL C1 Plus"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "OUKITEL_C2_EEA",
    "Device": "YJC235",
    "Model": "OUKITEL C1 plus"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "OUKITEL_C2_EEA",
    "Device": "YJC235",
    "Model": "OUKITEL C2"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "OUKITEL_C2_EEA",
    "Device": "YJC235",
    "Model": "OUKITEL C3"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "OUKITEL_C2_EEA",
    "Device": "YJC235",
    "Model": "OUKITEL C5"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "OUKITEL_C3_EEA",
    "Device": "OUKITEL_C3",
    "Model": "OUKITEL C3"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "OUKITEL_C59_EEA",
    "Device": "OUKITEL_C59",
    "Model": "C59"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "OUKITEL_C5_EEA",
    "Device": "OUKITEL_C5",
    "Model": "OUKITEL C5"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "OUKITEL_C60_EEA",
    "Device": "OUKITEL_C60",
    "Model": "C60"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "OUKITEL_C61_EEA",
    "Device": "OUKITEL_C61",
    "Model": "C61"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "OUKITEL_C61_ROW",
    "Device": "OUKITEL_C61",
    "Model": "C61"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "OUKITEL_C62_EEA",
    "Device": "OUKITEL_C62",
    "Model": "C62"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "OUKITEL_G3_EEA",
    "Device": "OUKITEL_G3",
    "Model": "OUKITEL G3"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "OUKITEL_G5_EEA",
    "Device": "OUKITEL_G5",
    "Model": "OUKITEL G5"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "OUKITEL_P1_EEA",
    "Device": "OUKITEL_P1",
    "Model": "P1"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "OUKITEL_WP32_EEA",
    "Device": "WP32",
    "Model": "WP32"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "P07_EEA",
    "Device": "P07",
    "Model": "RT7 TITAN 5G"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "P07_NFC_EEA",
    "Device": "P07",
    "Model": "RT7 TITAN 5G"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "P1_Pro_EEA",
    "Device": "P1_Pro",
    "Model": "P1 Pro"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "RT1",
    "Device": "RT1",
    "Model": "RT1"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "RT10_EEA",
    "Device": "RT10",
    "Model": "RT10"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "RT10_Pro_EEA",
    "Device": "RT10_Pro",
    "Model": "RT10 Pro"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "RT1_EEA",
    "Device": "RT1",
    "Model": "RT1"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "RT2_EEA",
    "Device": "RT2",
    "Model": "RT2"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "RT3_Plus_EEA",
    "Device": "RT3_Plus",
    "Model": "RT3 Plus"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "RT3_Pro_EEA",
    "Device": "RT3_Pro",
    "Model": "RT3 Pro"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "RT3_S_EEA",
    "Device": "RT3_EEA",
    "Model": "RT3"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "RT3_T",
    "Device": "RT3",
    "Model": "RT3"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "RT3_T_EEA",
    "Device": "RT3",
    "Model": "RT3"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "RT5_EEA",
    "Device": "RT5",
    "Model": "RT5"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "RT6_EEA",
    "Device": "RT6",
    "Model": "RT6"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "RT6_NFC_EEA",
    "Device": "RT6",
    "Model": "RT6"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "RT7_TITAN_5G_EEA",
    "Device": "RT7_TITAN_5G",
    "Model": "RT7 TITAN 5G"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "RT7_TITAN_EEA",
    "Device": "RT7_TITAN",
    "Model": "RT7 TITAN"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "RT8_EEA",
    "Device": "RT8",
    "Model": "RT8"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "RT9_EEA",
    "Device": "RT9",
    "Model": "RT9"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "S105B_RU",
    "Device": "S105B",
    "Model": "WP21 Ultra"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "S109_RU",
    "Device": "S109",
    "Model": "WP22"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "S115_EEA",
    "Device": "S115",
    "Model": "WP26"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "S115_RU",
    "Device": "S115",
    "Model": "WP26"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "S118_EEA",
    "Device": "S118",
    "Model": "WP28"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "S118_RU",
    "Device": "S118",
    "Model": "WP28"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "U11_Plus",
    "Device": "U11_Plus",
    "Model": "U11_Plus"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "U16 Max",
    "Device": "U16_Max",
    "Model": "U16 Max"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "U17",
    "Device": "U17",
    "Model": "U17"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "U18",
    "Device": "U18",
    "Model": "U18"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "U20_Plus",
    "Device": "U20_Plus",
    "Model": "U20_Plus"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "U22",
    "Device": "U22",
    "Model": "U22"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "U23",
    "Device": "U23",
    "Model": "U23"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "U25",
    "Device": "U25",
    "Model": "U25"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "U25 Pro",
    "Device": "U25_Pro",
    "Model": "U25_Pro"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "U7 Max",
    "Device": "U7_Max",
    "Model": "U7 Max"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "U7 Plus",
    "Device": "U7_Plus",
    "Model": "U7 Plus"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "WP1",
    "Device": "OUKITEL_WP1",
    "Model": "WP1"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "WP10",
    "Device": "WP10",
    "Model": "WP10"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "WP100_EEA",
    "Device": "WP100",
    "Model": "WP100"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "WP100_TITAN_EEA",
    "Device": "WP100_TITAN",
    "Model": "WP100 TITAN"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "WP12",
    "Device": "WP12",
    "Model": "WP12"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "WP12 Pro",
    "Device": "WP12_Pro",
    "Model": "WP12 Pro"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "WP12_Pro",
    "Device": "WP12_Pro",
    "Model": "WP12 Pro"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "WP12_Pro_EEA",
    "Device": "WP12_Pro",
    "Model": "WP12 Pro"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "WP13_EEA",
    "Device": "WP13",
    "Model": "WP13"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "WP13_RU",
    "Device": "WP13",
    "Model": "WP13"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "WP15",
    "Device": "WP15",
    "Model": "WP15"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "WP15",
    "Device": "WP15",
    "Model": "WP25"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "WP15 S",
    "Device": "WP15_S",
    "Model": "WP15 S"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "WP16_EEA",
    "Device": "WP16",
    "Model": "WP16"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "WP16_RU",
    "Device": "WP16",
    "Model": "WP16"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "WP17_EEA",
    "Device": "WP17",
    "Model": "WP17"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "WP18",
    "Device": "WP18_EEA",
    "Model": "WP18"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "WP18_P_R_EEA",
    "Device": "WP18_P_R_EEA",
    "Model": "WP18 Pro"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "WP18_P_R_RU",
    "Device": "WP18_P_R_EEA",
    "Model": "WP18 Pro"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "WP18_Pro_EEA",
    "Device": "WP18_Pro_EEA",
    "Model": "WP18 Pro"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "WP19_EEA",
    "Device": "WP19",
    "Model": "WP19"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "WP19_Pro",
    "Device": "WP19_Pro",
    "Model": "WP19 Pro"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "WP19_Pro_EEA",
    "Device": "WP19_Pro",
    "Model": "WP19 Pro"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "WP19_Pro_EEA",
    "Device": "WP19_Pro_15",
    "Model": "WP19 Pro"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "WP2",
    "Device": "WP2",
    "Model": "WP2"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "WP200_Pro_EEA",
    "Device": "WP200_Pro",
    "Model": "WP200 Pro"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "WP20_EEA",
    "Device": "WP20",
    "Model": "WP20"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "WP20_Pro",
    "Device": "WP20_Pro",
    "Model": "WP20 Pro"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "WP20_Pro_EEA",
    "Device": "WP20_Pro",
    "Model": "WP20 Pro"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "WP20_RU",
    "Device": "WP20",
    "Model": "WP20"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "WP21 Ultra",
    "Device": "S105B",
    "Model": "WP21 Ultra"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "WP210_Pro_EEA",
    "Device": "WP210_Pro",
    "Model": "WP210 Pro"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "WP21_EEA",
    "Device": "WP21",
    "Model": "WP21"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "WP21_RU",
    "Device": "WP21",
    "Model": "WP21"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "WP21_U_EEA",
    "Device": "WP21_U",
    "Model": "WP21"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "WP22",
    "Device": "S109",
    "Model": "WP22"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "WP23",
    "Device": "S111",
    "Model": "WP23"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "WP23_Plus_A15_EEA",
    "Device": "WP23_Plus",
    "Model": "WP23 Plus"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "WP23_Plus_A15_EEA",
    "Device": "WP23_Plus",
    "Model": "WP23 S"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "WP23_Plus_A15_ROW",
    "Device": "WP23_Plus",
    "Model": "WP23 Plus"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "WP23_Plus_A15_ROW",
    "Device": "WP23_Plus",
    "Model": "WP23 S"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "WP23_Plus_EEA",
    "Device": "WP23_Plus",
    "Model": "WP23 Plus"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "WP27_EEA",
    "Device": "WP27",
    "Model": "WP27"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "WP27_RU",
    "Device": "WP27",
    "Model": "WP27"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "WP28_E_A15_EEA",
    "Device": "WP28_E",
    "Model": "WP28 E"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "WP28_E_A15_ROW",
    "Device": "WP28_E",
    "Model": "WP28 E"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "WP28_E_EEA",
    "Device": "WP28_E",
    "Model": "WP28 E"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "WP28_S_EEA",
    "Device": "WP28_S",
    "Model": "WP28 S"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "WP300_EEA",
    "Device": "WP300",
    "Model": "WP300"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "WP30_Pro_EEA",
    "Device": "WP30_Pro",
    "Model": "WP30 Pro"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "WP32_EEA",
    "Device": "WP32",
    "Model": "WP32"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "WP32_Pro_U_EEA",
    "Device": "WP32_Pro_U",
    "Model": "WP32_Pro"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "WP33_Pro_EEA",
    "Device": "WP33_Pro",
    "Model": "WP33 Pro"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "WP33_Pro_U_EEA",
    "Device": "WP33_Pro",
    "Model": "WP33 Pro"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "WP35_A15_EEA",
    "Device": "WP35",
    "Model": "WP35"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "WP35_A15_ROW",
    "Device": "WP35",
    "Model": "WP35"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "WP35_EEA",
    "Device": "WP35",
    "Model": "WP35"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "WP35_Pro_EEA",
    "Device": "WP35_Pro",
    "Model": "WP35 Pro"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "WP35_S_EEA",
    "Device": "WP35_S",
    "Model": "WP35 S"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "WP35_U_EEA",
    "Device": "WP35",
    "Model": "WP35"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "WP36_A16_EEA",
    "Device": "WP36",
    "Model": "WP36"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "WP36_EEA",
    "Device": "WP36",
    "Model": "WP36"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "WP36_Pro_EEA",
    "Device": "WP36_Pro",
    "Model": "WP36 Pro"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "WP36_RU",
    "Device": "OUKITEL_WP36",
    "Model": "WP36"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "WP36_U_EEA",
    "Device": "OUKITEL_WP36",
    "Model": "WP36"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "WP38_EEA",
    "Device": "WP38",
    "Model": "WP38"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "WP38_RU",
    "Device": "OUKITEL_WP38",
    "Model": "WP38"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "WP38_U_EEA",
    "Device": "OUKITEL_WP38",
    "Model": "WP38"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "WP39_EEA",
    "Device": "WP39",
    "Model": "WP39"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "WP39_Pro_EEA",
    "Device": "WP39_Pro",
    "Model": "WP39 Pro"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "WP39_U_EEA",
    "Device": "WP39",
    "Model": "WP39"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "WP5",
    "Device": "WP5",
    "Model": "WP5"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "WP5 Pro",
    "Device": "WP5_Pro",
    "Model": "WP5 Pro"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "WP5000",
    "Device": "WP5000",
    "Model": "WP5000"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "WP500_EEA",
    "Device": "WP500",
    "Model": "WP500"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "WP50_EEA",
    "Device": "WP50",
    "Model": "WP50"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "WP52_EEA",
    "Device": "WP52",
    "Model": "WP52"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "WP53_EEA",
    "Device": "WP53",
    "Model": "WP53"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "WP53_Pro_EEA",
    "Device": "WP53_Pro",
    "Model": "WP53 Pro"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "WP53_S_EEA",
    "Device": "WP53_S",
    "Model": "WP53 S"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "WP55_EEA",
    "Device": "WP55",
    "Model": "WP55"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "WP55_S_EEA",
    "Device": "WP55_S",
    "Model": "WP55 S"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "WP55_Ultra_EEA",
    "Device": "WP55_Ultra",
    "Model": "WP55 Ultra"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "WP56",
    "Device": "WP56",
    "Model": "WP56"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "WP58_EEA",
    "Device": "WP58",
    "Model": "WP58"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "WP58_Pro_EEA",
    "Device": "WP58_Pro",
    "Model": "WP58 Pro"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "WP58_Pro_ROW",
    "Device": "WP58_Pro",
    "Model": "WP58 Pro"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "WP5_Pro_row",
    "Device": "WP5_Pro",
    "Model": "WP5 Pro"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "WP6",
    "Device": "WP6",
    "Model": "WP6"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "WP60_EEA",
    "Device": "WP60",
    "Model": "WP60"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "WP61_EEA",
    "Device": "WP61",
    "Model": "WP61"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "WP61_Plus_EEA",
    "Device": "WP61_Plus",
    "Model": "WP61 Plus"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "WP61_TI_EEA",
    "Device": "WP61_TI",
    "Model": "WP61 TI"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "WP61_Ultra_EEA",
    "Device": "WP61_Ultra",
    "Model": "WP61 Ultra"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "WP62_A15_EEA",
    "Device": "WP62",
    "Model": "WP62"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "WP62_A15_ROW",
    "Device": "WP62",
    "Model": "WP62"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "WP65_EEA",
    "Device": "WP65",
    "Model": "WP65"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "WP66_EEA",
    "Device": "WP66",
    "Model": "WP66"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "WP6_EEA",
    "Device": "WP6",
    "Model": "WP6"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "WP7",
    "Device": "WP7",
    "Model": "WP7"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "WP8_Pro",
    "Device": "WP8_Pro",
    "Model": "WP8 Pro"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "WP9",
    "Device": "WP9",
    "Model": "WP9"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "Y1000",
    "Device": "Y1000",
    "Model": "Y1000"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "Y4800",
    "Device": "Y4800",
    "Model": "Y4800"
  },
  {
    "Retail Branding": "Oukitel",
    "Marketing Name": "Y4800_EEA",
    "Device": "Y4800",
    "Model": "Y4800"
  },
  {
    "Retail Branding": "Overmax",
    "Marketing Name": "Livecore7032",
    "Device": "Livecore7032",
    "Model": "Livecore7032"
  },
  {
    "Retail Branding": "Overmax",
    "Marketing Name": "OV-Qualcore-1023-3G",
    "Device": "OV-Qualcore-1023-3G",
    "Model": "OV-Qualcore-1023-3G"
  },
  {
    "Retail Branding": "Overmax",
    "Marketing Name": "OV-Qualcore-7023-3G",
    "Device": "OV-Qualcore-7023-3G",
    "Model": "OV-Qualcore-7023-3G"
  },
  {
    "Retail Branding": "Overmax",
    "Marketing Name": "OV10273G",
    "Device": "OV10273G",
    "Model": "OV10273G"
  },
  {
    "Retail Branding": "Overmax",
    "Marketing Name": "OV10274G",
    "Device": "OV10274G",
    "Model": "OV10274G"
  },
  {
    "Retail Branding": "Ovion",
    "Marketing Name": "V11_Lite_TR",
    "Device": "V11_Lite",
    "Model": "V11 Lite"
  },
  {
    "Retail Branding": "Ovion",
    "Marketing Name": "V15_LITE",
    "Device": "V15_LITE",
    "Model": "V15_LITE"
  },
  {
    "Retail Branding": "Ovion",
    "Marketing Name": "V20_PRO_TR",
    "Device": "V20_PRO",
    "Model": "V20 PRO"
  },
  {
    "Retail Branding": "Ovion",
    "Marketing Name": "V21_Pro",
    "Device": "V21_Pro",
    "Model": "V21_Pro"
  },
  {
    "Retail Branding": "Ovion",
    "Marketing Name": "V30 Ultra",
    "Device": "V30_Ultra",
    "Model": "V30 Ultra"
  },
  {
    "Retail Branding": "Ovion",
    "Marketing Name": "V8_LITE",
    "Device": "OVION_V8_LITE",
    "Model": "OVION_V8_LITE"
  },
  {
    "Retail Branding": "OwnMobile",
    "Marketing Name": "FUN 6",
    "Device": "OWN_FUN_6",
    "Model": "OWN FUN 6"
  },
  {
    "Retail Branding": "OwnMobile",
    "Marketing Name": "FUN 7",
    "Device": "OWN_FUN_7",
    "Model": "OWN FUN 7"
  },
  {
    "Retail Branding": "OwnMobile",
    "Marketing Name": "FUN VALUE 4G",
    "Device": "FUNVALUE4G",
    "Model": "FUN VALUE 4G"
  },
  {
    "Retail Branding": "OwnMobile",
    "Marketing Name": "OWN Smart Ö2",
    "Device": "SMART_O2",
    "Model": "SMART_O2"
  },
  {
    "Retail Branding": "OwnMobile",
    "Marketing Name": "SMART 8",
    "Device": "Smart8",
    "Model": "Smart8"
  },
  {
    "Retail Branding": "OwnMobile",
    "Marketing Name": "SMART 9",
    "Device": "OWN_SMART_9",
    "Model": "OWN SMART 9"
  },
  {
    "Retail Branding": "OwnMobile",
    "Marketing Name": "Smart 9 Pro",
    "Device": "Smart_9_Pro",
    "Model": "Smart 9 Pro"
  },
  {
    "Retail Branding": "OwnMobile",
    "Marketing Name": "Smart Plus Lte",
    "Device": "SMART_PLUS_LTE",
    "Model": "SMART PLUS LTE"
  },
  {
    "Retail Branding": "Oxygen.id",
    "Marketing Name": "B866V2FA V3.4",
    "Device": "B866V2FA",
    "Model": "B866V2FA V3.4"
  },
  {
    "Retail Branding": "Oxygen.id",
    "Marketing Name": "SEI700MRT",
    "Device": "SEI700MRT",
    "Model": "SEI700MRT"
  },
  {
    "Retail Branding": "OyeFit",
    "Marketing Name": "T10_EEA",
    "Device": "T10",
    "Model": "T10"
  },
  {
    "Retail Branding": "OyeFit",
    "Marketing Name": "T10_ROW",
    "Device": "T10",
    "Model": "T10"
  },
  {
    "Retail Branding": "Oysters",
    "Marketing Name": "T72HM3G",
    "Device": "T72HM3G",
    "Model": "T72HM3G"
  },
  {
    "Retail Branding": "Oysters",
    "Marketing Name": "T72HMs 3G",
    "Device": "T72HM3G",
    "Model": "T72HMs_3G"
  },
  {
    "Retail Branding": "Oysters",
    "Marketing Name": "Universal Phone 1",
    "Device": "Universal_Phone_1",
    "Model": "UBS1"
  },
  {
    "Retail Branding": "PAITANRY",
    "Marketing Name": "C40",
    "Device": "C40",
    "Model": "C40"
  },
  {
    "Retail Branding": "PAITANRY",
    "Marketing Name": "C95",
    "Device": "C95",
    "Model": "C95"
  },
  {
    "Retail Branding": "PAITANRY",
    "Marketing Name": "CH10",
    "Device": "CH10",
    "Model": "CH10"
  },
  {
    "Retail Branding": "PAITANRY",
    "Marketing Name": "CH10PRO",
    "Device": "CH10PRO",
    "Model": "CH10_PRO"
  },
  {
    "Retail Branding": "PAITANRY",
    "Marketing Name": "CH10PROMAX",
    "Device": "CH10PROMAX",
    "Model": "CH10PROMAX"
  },
  {
    "Retail Branding": "PAITANRY",
    "Marketing Name": "CH10_EEA",
    "Device": "CH10_EEA",
    "Model": "CH10"
  },
  {
    "Retail Branding": "PAITANRY",
    "Marketing Name": "CH10_ROW",
    "Device": "CH10_ROW",
    "Model": "CH10"
  },
  {
    "Retail Branding": "PAITANRY",
    "Marketing Name": "R16",
    "Device": "R16",
    "Model": "R16"
  },
  {
    "Retail Branding": "PAITANRY",
    "Marketing Name": "R16-PRO",
    "Device": "R16-PRO",
    "Model": "R16 PRO"
  },
  {
    "Retail Branding": "PAITANRY",
    "Marketing Name": "R16PROMAX",
    "Device": "R16PROMAX",
    "Model": "R16PROMAX"
  },
  {
    "Retail Branding": "PAITANRY",
    "Marketing Name": "R16Pro_PAD_EEA",
    "Device": "R16Pro_PAD_EEA",
    "Model": "R16Pro_PAD_EEA"
  },
  {
    "Retail Branding": "PAITANRY",
    "Marketing Name": "R16Pro_PAD_ROW",
    "Device": "R16Pro_PAD_ROW",
    "Model": "R16Pro_PAD_ROW"
  },
  {
    "Retail Branding": "PAITANRY",
    "Marketing Name": "R95",
    "Device": "R95",
    "Model": "N868"
  },
  {
    "Retail Branding": "PAITANRY",
    "Marketing Name": "SSK10",
    "Device": "SSK10",
    "Model": "SSK10"
  },
  {
    "Retail Branding": "PAITANRY",
    "Marketing Name": "Y85",
    "Device": "Y85",
    "Model": "Y85"
  },
  {
    "Retail Branding": "PAITANRY",
    "Marketing Name": "Y86",
    "Device": "Y86",
    "Model": "Y86"
  },
  {
    "Retail Branding": "PAITANRY",
    "Marketing Name": "Y86_EEA",
    "Device": "Y86_EEA",
    "Model": "Y86"
  },
  {
    "Retail Branding": "PAITANRY",
    "Marketing Name": "Y95",
    "Device": "Y95",
    "Model": "Y95"
  },
  {
    "Retail Branding": "PALSONIC",
    "Marketing Name": "Android TV",
    "Device": "R1",
    "Model": "ATV R1"
  },
  {
    "Retail Branding": "PANORAMA",
    "Marketing Name": "Smart TV",
    "Device": "kualakai",
    "Model": "Smart TV"
  },
  {
    "Retail Branding": "PANORAMA",
    "Marketing Name": "SmartTV P",
    "Device": "kualakai",
    "Model": "Smart TV P"
  },
  {
    "Retail Branding": "PANORAMA",
    "Marketing Name": "SmartTV_KR",
    "Device": "kualakai",
    "Model": "Smart TV KR"
  },
  {
    "Retail Branding": "PAPAGO",
    "Marketing Name": "GoPad8",
    "Device": "GoPad8",
    "Model": "GoPad8"
  },
  {
    "Retail Branding": "PARTNER MOBILE",
    "Marketing Name": "E22",
    "Device": "E22",
    "Model": "E22"
  },
  {
    "Retail Branding": "PARTNER MOBILE",
    "Marketing Name": "EV1_PRO",
    "Device": "EV1_PRO",
    "Model": "EV1 PRO"
  },
  {
    "Retail Branding": "PATTERS",
    "Marketing Name": "P7",
    "Device": "P7",
    "Model": "P7"
  },
  {
    "Retail Branding": "PATTERS",
    "Marketing Name": "P9",
    "Device": "P9",
    "Model": "P9"
  },
  {
    "Retail Branding": "PAWBO",
    "Marketing Name": "Max12",
    "Device": "Max12",
    "Model": "Max12"
  },
  {
    "Retail Branding": "PAWBO",
    "Marketing Name": "T13",
    "Device": "T13",
    "Model": "T13"
  },
  {
    "Retail Branding": "PAWBO",
    "Marketing Name": "Tab-T13",
    "Device": "Tab-T13",
    "Model": "Tab-T13"
  },
  {
    "Retail Branding": "PAWBO",
    "Marketing Name": "Tab-T8",
    "Device": "Tab-T8",
    "Model": "Tab-T8"
  },
  {
    "Retail Branding": "PAWBO",
    "Marketing Name": "Tab_M12",
    "Device": "Tab_M12",
    "Model": "Tab M12"
  },
  {
    "Retail Branding": "PAX (CN)",
    "Marketing Name": "A50",
    "Device": "A50",
    "Model": "A50"
  },
  {
    "Retail Branding": "PAX (CN)",
    "Marketing Name": "A650",
    "Device": "A650",
    "Model": "A650"
  },
  {
    "Retail Branding": "PAX (CN)",
    "Marketing Name": "A6650",
    "Device": "A6650",
    "Model": "A6650"
  },
  {
    "Retail Branding": "PAX (CN)",
    "Marketing Name": "A6650_EEA",
    "Device": "A6650",
    "Model": "A6650"
  },
  {
    "Retail Branding": "PAX (CN)",
    "Marketing Name": "A6650_PEEA",
    "Device": "A6650",
    "Model": "A6650"
  },
  {
    "Retail Branding": "PAX (CN)",
    "Marketing Name": "A6650_PLUS",
    "Device": "A6650",
    "Model": "A6650"
  },
  {
    "Retail Branding": "PAX (CN)",
    "Marketing Name": "A77",
    "Device": "A77",
    "Model": "A77"
  },
  {
    "Retail Branding": "PAX (CN)",
    "Marketing Name": "A910S",
    "Device": "AXXX",
    "Model": "A910S"
  },
  {
    "Retail Branding": "PAX (CN)",
    "Marketing Name": "A950",
    "Device": "A950",
    "Model": "A950"
  },
  {
    "Retail Branding": "PAX (CN)",
    "Marketing Name": "A99",
    "Device": "AXXX",
    "Model": "A99"
  },
  {
    "Retail Branding": "PAX (CN)",
    "Marketing Name": "E600M",
    "Device": "E600M",
    "Model": "E600M"
  },
  {
    "Retail Branding": "PAX (CN)",
    "Marketing Name": "E700M",
    "Device": "E700M",
    "Model": "E700M"
  },
  {
    "Retail Branding": "PAX (CN)",
    "Marketing Name": "L1450P",
    "Device": "L1450P",
    "Model": "L1450P"
  },
  {
    "Retail Branding": "PAX (CN)",
    "Marketing Name": "L1620",
    "Device": "L1620",
    "Model": "L1620"
  },
  {
    "Retail Branding": "PAX (CN)",
    "Marketing Name": "M30",
    "Device": "PAXM30",
    "Model": "M30"
  },
  {
    "Retail Branding": "PAX (CN)",
    "Marketing Name": "M50",
    "Device": "PAXM50",
    "Model": "M50"
  },
  {
    "Retail Branding": "PAX (CN)",
    "Marketing Name": "M8",
    "Device": "M8",
    "Model": "M8"
  },
  {
    "Retail Branding": "PAX (CN)",
    "Marketing Name": "PAYTABLETM8",
    "Device": "PAYTABLETM8",
    "Model": "M8"
  },
  {
    "Retail Branding": "PAX (CN)",
    "Marketing Name": "Pay Phone M50",
    "Device": "PAYPHONEM50",
    "Model": "M50"
  },
  {
    "Retail Branding": "PAX (CN)",
    "Marketing Name": "Pay Phone M50 EEA",
    "Device": "PAYPHONEM50",
    "Model": "M50"
  },
  {
    "Retail Branding": "PBS Kids",
    "Marketing Name": "PBDV704DVDB",
    "Device": "PBDV704DVDB",
    "Model": "PBDV704DVDB"
  },
  {
    "Retail Branding": "PBS Kids",
    "Marketing Name": "PBS700DVD",
    "Device": "PBS700DVD",
    "Model": "PBS700DVD"
  },
  {
    "Retail Branding": "PC Smart",
    "Marketing Name": "PCSGOB10LTE-V2",
    "Device": "PCSGOB10LTE-V2",
    "Model": "PCSGOB10LTE-V2"
  },
  {
    "Retail Branding": "PC Smart",
    "Marketing Name": "PCSGOB10MVA-A",
    "Device": "PCSGOB10MVA-A",
    "Model": "PCSGOB10MVA-A"
  },
  {
    "Retail Branding": "PC Smart",
    "Marketing Name": "PCSGOB10SF-A",
    "Device": "PCSGOB10SF-A",
    "Model": "PCSGOB10SF-A"
  },
  {
    "Retail Branding": "PC Smart",
    "Marketing Name": "PCSMART",
    "Device": "PCSGOB10MVA_A",
    "Model": "PCSGOB10MVA_A"
  },
  {
    "Retail Branding": "PC Smart",
    "Marketing Name": "PTSGOB8",
    "Device": "PTSGOB8",
    "Model": "PC_Smart_PTSGOB8"
  },
  {
    "Retail Branding": "PC Smart",
    "Marketing Name": "QUICKTAB PLUS",
    "Device": "PHABLET",
    "Model": "QUICKTAB PLUS"
  },
  {
    "Retail Branding": "PCBOX",
    "Marketing Name": "Curi_Lite_PCB-T103",
    "Device": "mid1008",
    "Model": "PCB-T103 CURI LITE"
  },
  {
    "Retail Branding": "PCBOX",
    "Marketing Name": "Kova-PCB-T730",
    "Device": "Kova-PCB-T730",
    "Model": "Kova-PCB-T730"
  },
  {
    "Retail Branding": "PCBOX",
    "Marketing Name": "Kova_PCB-T730",
    "Device": "Kova_PCB-T730",
    "Model": "Kova_PCB-T730"
  },
  {
    "Retail Branding": "PCBOX",
    "Marketing Name": "PCB-T104",
    "Device": "mid1032_mk",
    "Model": "PCB-T104"
  },
  {
    "Retail Branding": "PCBOX",
    "Marketing Name": "PCB-T105",
    "Device": "PCB-T105",
    "Model": "PCB-T105"
  },
  {
    "Retail Branding": "PCBOX",
    "Marketing Name": "PCB-T106",
    "Device": "PCB-T106",
    "Model": "PCB-T106"
  },
  {
    "Retail Branding": "PCBOX",
    "Marketing Name": "PCB-T107",
    "Device": "PCB-T107",
    "Model": "PCB-T107"
  },
  {
    "Retail Branding": "PCBOX",
    "Marketing Name": "PCB-T732",
    "Device": "MID7015A-MK",
    "Model": "Kova 2 Plus PCB-T732"
  },
  {
    "Retail Branding": "PCBOX",
    "Marketing Name": "PCB_S1063",
    "Device": "PCB_S1063",
    "Model": "PCB_S1063"
  },
  {
    "Retail Branding": "PCBOX",
    "Marketing Name": "PCB_T801",
    "Device": "PCB_T801",
    "Model": "PCB_T801"
  },
  {
    "Retail Branding": "PCD Argentina",
    "Marketing Name": 610,
    "Device": 610,
    "Model": 610
  },
  {
    "Retail Branding": "PCD Argentina",
    "Marketing Name": "C58_ARG",
    "Device": "C58_ARG",
    "Model": "C58"
  },
  {
    "Retail Branding": "PCD Argentina",
    "Marketing Name": "P40",
    "Device": "P40",
    "Model": "P40"
  },
  {
    "Retail Branding": "PCD Argentina",
    "Marketing Name": "P41",
    "Device": "P41",
    "Model": "P41"
  },
  {
    "Retail Branding": "PCD Argentina",
    "Marketing Name": "P50",
    "Device": "P50",
    "Model": "P50"
  },
  {
    "Retail Branding": "PCD Argentina",
    "Marketing Name": "P50",
    "Device": "P50PR",
    "Model": "P50"
  },
  {
    "Retail Branding": "PCD Argentina",
    "Marketing Name": "P50",
    "Device": "P50_LPR",
    "Model": "P50 LPR"
  },
  {
    "Retail Branding": "PCD Argentina",
    "Marketing Name": "P55",
    "Device": "P55",
    "Model": "P55"
  },
  {
    "Retail Branding": "PCD Argentina",
    "Marketing Name": "P60 CENAM",
    "Device": "P60_CENAM",
    "Model": "P60 CENAM"
  },
  {
    "Retail Branding": "PCD Argentina",
    "Marketing Name": "P60_CA",
    "Device": "P60_CA",
    "Model": "P60_CA"
  },
  {
    "Retail Branding": "PCD Argentina",
    "Marketing Name": "P63L",
    "Device": "P63L_CA",
    "Model": "P63L"
  },
  {
    "Retail Branding": "PCD Argentina",
    "Marketing Name": "P63L",
    "Device": "P63L_PR",
    "Model": "P63L"
  },
  {
    "Retail Branding": "PCD Argentina",
    "Marketing Name": "P65",
    "Device": "P65_CA",
    "Model": "P65"
  },
  {
    "Retail Branding": "PCD Argentina",
    "Marketing Name": "P65",
    "Device": "P65_CA",
    "Model": "P65R"
  },
  {
    "Retail Branding": "PCD Argentina",
    "Marketing Name": "PCD508",
    "Device": "PCD508",
    "Model": "PCD508"
  },
  {
    "Retail Branding": "PCD Argentina",
    "Marketing Name": "PCD509",
    "Device": "PCD509",
    "Model": "PCD509"
  },
  {
    "Retail Branding": "PCD Argentina",
    "Marketing Name": "PD60",
    "Device": "P60",
    "Model": "P60"
  },
  {
    "Retail Branding": "PCD Argentina",
    "Marketing Name": "PH4003",
    "Device": "PH4003",
    "Model": "PH4003"
  },
  {
    "Retail Branding": "PCD Argentina",
    "Marketing Name": "PH4003 GO",
    "Device": "PH4003GO",
    "Model": "PH4003 GO"
  },
  {
    "Retail Branding": "PCD Argentina",
    "Marketing Name": "PH5003",
    "Device": "PH5003",
    "Model": "PH5003"
  },
  {
    "Retail Branding": "PCD Argentina",
    "Marketing Name": "PH5003 Go",
    "Device": "PH5003_Go",
    "Model": "PH5003 Go"
  },
  {
    "Retail Branding": "PCD Argentina",
    "Marketing Name": "PL4002",
    "Device": "PL4002",
    "Model": "PL4002"
  },
  {
    "Retail Branding": "PCD Argentina",
    "Marketing Name": "PL5003",
    "Device": "PL5003",
    "Model": "PL5003"
  },
  {
    "Retail Branding": "PCD Argentina",
    "Marketing Name": "PL504",
    "Device": "PL504",
    "Model": "PL504"
  },
  {
    "Retail Branding": "PCD Argentina",
    "Marketing Name": "PL550",
    "Device": "PL550",
    "Model": "PL550"
  },
  {
    "Retail Branding": "PCD Argentina",
    "Marketing Name": "PL5505",
    "Device": "PL5505",
    "Model": "PL5505"
  },
  {
    "Retail Branding": "PCD Argentina",
    "Marketing Name": "PL570",
    "Device": "PL570",
    "Model": "PL570"
  },
  {
    "Retail Branding": "PCD Argentina",
    "Marketing Name": "PL571",
    "Device": "PL571",
    "Model": "PL571"
  },
  {
    "Retail Branding": "PCD Argentina",
    "Marketing Name": "PL571US",
    "Device": "PL571US",
    "Model": "PL571US"
  },
  {
    "Retail Branding": "PCD Argentina",
    "Marketing Name": "PL620",
    "Device": "PL620",
    "Model": "PL620"
  },
  {
    "Retail Branding": "PCD LLC",
    "Marketing Name": "Bengal Max",
    "Device": "Bengal_Max_iW",
    "Model": "Bengal Max"
  },
  {
    "Retail Branding": "PCD LLC",
    "Marketing Name": "Bengal_Max",
    "Device": "Bengal_Max",
    "Model": "Bengal Max"
  },
  {
    "Retail Branding": "PCD LLC",
    "Marketing Name": "P41PR",
    "Device": "P41PR",
    "Model": "P41PR"
  },
  {
    "Retail Branding": "PCD LLC",
    "Marketing Name": "P55 US",
    "Device": "P55_US",
    "Model": "P55 US"
  },
  {
    "Retail Branding": "PCD LLC",
    "Marketing Name": "P62",
    "Device": "P62",
    "Model": "P62"
  },
  {
    "Retail Branding": "PCD LLC",
    "Marketing Name": "P65",
    "Device": "P65",
    "Model": "P65"
  },
  {
    "Retail Branding": "PCD LLC",
    "Marketing Name": "P65L",
    "Device": "P65L",
    "Model": "P65L"
  },
  {
    "Retail Branding": "PCD LLC",
    "Marketing Name": "T85",
    "Device": "T85",
    "Model": "T85"
  },
  {
    "Retail Branding": "PCD LLC",
    "Marketing Name": "T85US",
    "Device": "T85US",
    "Model": "T85US"
  },
  {
    "Retail Branding": "PEAQ",
    "Marketing Name": "PET-1008-F464E",
    "Device": "PET-1008-F464E",
    "Model": "PET 1008-F464E"
  },
  {
    "Retail Branding": "PEAQ",
    "Marketing Name": "PET-1008-H332E",
    "Device": "PET-1008-H332E",
    "Model": "PET 1008-H332E"
  },
  {
    "Retail Branding": "PEAQ",
    "Marketing Name": "PET-101-F464S",
    "Device": "PET-101-F464S",
    "Model": "PET-101-F464S"
  },
  {
    "Retail Branding": "PEAQ",
    "Marketing Name": "PET-101-H232E",
    "Device": "PET-101-H232E",
    "Model": "PET 101-H232E"
  },
  {
    "Retail Branding": "PEAQ",
    "Marketing Name": "PET-101-H232E",
    "Device": "PET-101-H232E",
    "Model": "PET 101-H232E-13"
  },
  {
    "Retail Branding": "PEAQ",
    "Marketing Name": "PET-101-H332S-W",
    "Device": "PET-101-H332S-W",
    "Model": "PET 101-H332S-W"
  },
  {
    "Retail Branding": "PEAQ",
    "Marketing Name": "PET-10182-H332E",
    "Device": "PET-10182-H332E",
    "Model": "PET 10182-H332E"
  },
  {
    "Retail Branding": "PEAQ",
    "Marketing Name": "PET-102-H232S",
    "Device": "PET-102-H232S",
    "Model": "PET-102-H232S"
  },
  {
    "Retail Branding": "PEAQ",
    "Marketing Name": "PET-10380-H628S",
    "Device": "PET-10380-H628S",
    "Model": "PET-10380-H628S"
  },
  {
    "Retail Branding": "PEAQ",
    "Marketing Name": "PET-1081-H232S",
    "Device": "PET-1081-H232S",
    "Model": "PET 1081-H232S"
  },
  {
    "Retail Branding": "PEAQ",
    "Marketing Name": "PET-1081-LH332S",
    "Device": "PET-1081-LH332S",
    "Model": "PET 1081-LH332S"
  },
  {
    "Retail Branding": "PEAQ",
    "Marketing Name": "PET-10980-F628E",
    "Device": "PET-10980-F628E",
    "Model": "PET-10980-F628E"
  },
  {
    "Retail Branding": "PEAQ",
    "Marketing Name": "PET-11080-2K628E",
    "Device": "PET-11080-2K628E",
    "Model": "PET 11080-2K628E"
  },
  {
    "Retail Branding": "PEAQ",
    "Marketing Name": "PET-11080-F428E",
    "Device": "PET-11080-F428E",
    "Model": "PET 11080-F428E"
  },
  {
    "Retail Branding": "PEAQ",
    "Marketing Name": "PET-882-H232S",
    "Device": "PET-882-H232S",
    "Model": "Lightyear 2"
  },
  {
    "Retail Branding": "PEAQ",
    "Marketing Name": "PET-882-H232S",
    "Device": "PET-882-H232S",
    "Model": "PET-882-H232S"
  },
  {
    "Retail Branding": "PEAQ",
    "Marketing Name": "PET_10180_H464S",
    "Device": "PET_10180_H464S",
    "Model": "PET_10180_H464S"
  },
  {
    "Retail Branding": "PEAQ",
    "Marketing Name": "PET_10181_H464S_EEA",
    "Device": "PET_10181_H464S",
    "Model": "PET_10181_H464S"
  },
  {
    "Retail Branding": "PEAQ",
    "Marketing Name": "PET_11080-F628S",
    "Device": "PET_11080-F628S",
    "Model": "PET_11080-F628S"
  },
  {
    "Retail Branding": "PEAQ",
    "Marketing Name": "PET_11080-F656S_EEA",
    "Device": "PET_11080-F656S",
    "Model": "PET 11080-F656S"
  },
  {
    "Retail Branding": "PEAQ",
    "Marketing Name": "PET_11080_H428S",
    "Device": "PET_11080_H428S",
    "Model": "PET_11080_H428S"
  },
  {
    "Retail Branding": "PEAQ",
    "Marketing Name": "PET_11081_H428S_EEA",
    "Device": "PET_11081_H428S",
    "Model": "PET_11081_H428S"
  },
  {
    "Retail Branding": "PEAQ",
    "Marketing Name": "PET_8040_H464S",
    "Device": "PET_8040_H464S",
    "Model": "PET_8040_H464S"
  },
  {
    "Retail Branding": "PEAQ",
    "Marketing Name": "PGS1000",
    "Device": "MKZ",
    "Model": "PGS1000"
  },
  {
    "Retail Branding": "PEAQ",
    "Marketing Name": "R4_GTV",
    "Device": "R4_GTV",
    "Model": "R4G"
  },
  {
    "Retail Branding": "PEAQ",
    "Marketing Name": "Smart TV",
    "Device": "alimos",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "PEAQ",
    "Marketing Name": "Smart TV",
    "Device": "alimos",
    "Model": "AI PONT IT"
  },
  {
    "Retail Branding": "PEAQ",
    "Marketing Name": "Smart TV",
    "Device": "dangni",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "PEAQ",
    "Marketing Name": "Smart TV",
    "Device": "dangni",
    "Model": "AI PONT IT"
  },
  {
    "Retail Branding": "PEAQ",
    "Marketing Name": "Smart TV",
    "Device": "osaka",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "PEAQ",
    "Marketing Name": "Smart TV",
    "Device": "osaka",
    "Model": "AI PONT DE"
  },
  {
    "Retail Branding": "PEICHENG",
    "Marketing Name": "A5",
    "Device": "A5",
    "Model": "A5"
  },
  {
    "Retail Branding": "PEICHENG",
    "Marketing Name": "AT11PROK",
    "Device": "AT11PROK",
    "Model": "AT11K"
  },
  {
    "Retail Branding": "PEICHENG",
    "Marketing Name": "AT74K",
    "Device": "AT74K",
    "Model": "AT74K"
  },
  {
    "Retail Branding": "PEICHENG",
    "Marketing Name": "CP20TGOLD",
    "Device": "CP20TGOLD",
    "Model": "CP20_GOLD"
  },
  {
    "Retail Branding": "PEICHENG",
    "Marketing Name": "CP20TGOLD_EEA",
    "Device": "CP20TGOLD",
    "Model": "CP20_GOLD"
  },
  {
    "Retail Branding": "PEICHENG",
    "Marketing Name": "CP31-4T",
    "Device": "CP31-4T",
    "Model": "CP31-4T"
  },
  {
    "Retail Branding": "PEICHENG",
    "Marketing Name": "CP31M",
    "Device": "CP31M",
    "Model": "CP31M"
  },
  {
    "Retail Branding": "PEICHENG",
    "Marketing Name": "CP31T",
    "Device": "CP31T",
    "Model": "CP31M"
  },
  {
    "Retail Branding": "PEICHENG",
    "Marketing Name": "CP31T_EEA",
    "Device": "CP31T",
    "Model": "CP31M"
  },
  {
    "Retail Branding": "PEICHENG",
    "Marketing Name": "CP31U",
    "Device": "CP31U",
    "Model": "CP31U"
  },
  {
    "Retail Branding": "PEICHENG",
    "Marketing Name": "CP81S_PRO",
    "Device": "CP81S_PRO",
    "Model": "CP81"
  },
  {
    "Retail Branding": "PEICHENG",
    "Marketing Name": "CP81S_PRO",
    "Device": "CP81S_PRO",
    "Model": "CP81S_PRO"
  },
  {
    "Retail Branding": "PEICHENG",
    "Marketing Name": "P13Max",
    "Device": "P13Max",
    "Model": "P13Max"
  },
  {
    "Retail Branding": "PEICHENG",
    "Marketing Name": "P13PRO",
    "Device": "P13PRO",
    "Model": "P13PRO"
  },
  {
    "Retail Branding": "PEICHENG",
    "Marketing Name": "P13TMax",
    "Device": "P13TMax",
    "Model": "P13Max"
  },
  {
    "Retail Branding": "PEICHENG",
    "Marketing Name": "P13TMax_EEA",
    "Device": "P13TMax",
    "Model": "P13Max"
  },
  {
    "Retail Branding": "PEICHENG",
    "Marketing Name": "P13Ultra",
    "Device": "P13Ultra",
    "Model": "P13Ultra"
  },
  {
    "Retail Branding": "PEICHENG",
    "Marketing Name": "Q1",
    "Device": "Q1",
    "Model": "Q1"
  },
  {
    "Retail Branding": "PEICHENG",
    "Marketing Name": "Q1",
    "Device": "Q1",
    "Model": "Q1K"
  },
  {
    "Retail Branding": "PEICHENG",
    "Marketing Name": "Q8",
    "Device": "Q8",
    "Model": "Q8"
  },
  {
    "Retail Branding": "PEICHENG",
    "Marketing Name": "Q8",
    "Device": "Q8",
    "Model": "Q8K"
  },
  {
    "Retail Branding": "PEICHENG",
    "Marketing Name": "Q8PRO",
    "Device": "Q8PRO",
    "Model": "Q8 PRO"
  },
  {
    "Retail Branding": "PEICHENG",
    "Marketing Name": "Q8PRO",
    "Device": "Q8PRO",
    "Model": "Q8K PRO"
  },
  {
    "Retail Branding": "PEICHENG",
    "Marketing Name": "Q8S_Pro",
    "Device": "Q8S_Pro",
    "Model": "Q8S_Pro"
  },
  {
    "Retail Branding": "PEICHENG",
    "Marketing Name": "YQ10SA_MAX",
    "Device": "YQ10SA_MAX",
    "Model": "YQ10S_MAX"
  },
  {
    "Retail Branding": "PEICHENG",
    "Marketing Name": "YQ10SC_MAX",
    "Device": "YQ10SC_MAX",
    "Model": "YQ10S_MAX"
  },
  {
    "Retail Branding": "PEICHENG",
    "Marketing Name": "YQ10SPRO",
    "Device": "YQ10SPRO",
    "Model": "YQ10S"
  },
  {
    "Retail Branding": "PEICHENG",
    "Marketing Name": "YQ10ST_MAX",
    "Device": "YQ10ST_MAX",
    "Model": "YQ10S_MAX"
  },
  {
    "Retail Branding": "PEICHENG",
    "Marketing Name": "YQ11M",
    "Device": "YQ11M",
    "Model": "YQ11M"
  },
  {
    "Retail Branding": "PEICHENG",
    "Marketing Name": "YQ11MK",
    "Device": "YQ11MK",
    "Model": "YQ11MK"
  },
  {
    "Retail Branding": "PEICHENG",
    "Marketing Name": "ZB31",
    "Device": "ZB31",
    "Model": "ZB31"
  },
  {
    "Retail Branding": "PEICHENG",
    "Marketing Name": "ZB32",
    "Device": "ZB32",
    "Model": "ZB32"
  },
  {
    "Retail Branding": "PEICHENG",
    "Marketing Name": "ZB32A",
    "Device": "ZB32A",
    "Model": "ZB32"
  },
  {
    "Retail Branding": "PEICHENG",
    "Marketing Name": "ZB32A",
    "Device": "ZB32A",
    "Model": "ZB32A"
  },
  {
    "Retail Branding": "PEICHENG",
    "Marketing Name": "ZB32V",
    "Device": "ZB32V",
    "Model": "ZB32V"
  },
  {
    "Retail Branding": "PEICHENG",
    "Marketing Name": "ZB32_PRO",
    "Device": "ZB32_PRO",
    "Model": "ZB32_PRO"
  },
  {
    "Retail Branding": "PEL (PAK)",
    "Marketing Name": "PEL",
    "Device": "elliniko",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "PEL (PAK)",
    "Marketing Name": "PEL",
    "Device": "lavender",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "PEL (PAK)",
    "Marketing Name": "PEL",
    "Device": "mountbaker",
    "Model": "2K SMART TV"
  },
  {
    "Retail Branding": "PENSONIC",
    "Marketing Name": "R3",
    "Device": "R3",
    "Model": "R3"
  },
  {
    "Retail Branding": "PENSONIC",
    "Marketing Name": "R4",
    "Device": "R4",
    "Model": "R4"
  },
  {
    "Retail Branding": "PEOTV",
    "Marketing Name": "SEI300SLT",
    "Device": "SEI300SLT",
    "Model": "SEI300SLT"
  },
  {
    "Retail Branding": "PERSONA",
    "Marketing Name": "86KTA_PRO_FULL",
    "Device": "86KTA_PRO_FULL",
    "Model": "86KTA_PRO_FULL"
  },
  {
    "Retail Branding": "PERSONA",
    "Marketing Name": "86KTA_PRO_PIS-AMLT982",
    "Device": "86KTA_PRO_PIS",
    "Model": "86KTA_PRO_PIS"
  },
  {
    "Retail Branding": "PERSONA",
    "Marketing Name": "MyTab_A8",
    "Device": "MyTab_A8",
    "Model": "MyTab_A8"
  },
  {
    "Retail Branding": "PHILCO (ar)",
    "Marketing Name": "P510",
    "Device": "P510",
    "Model": "P510"
  },
  {
    "Retail Branding": "PHILCO (ar)",
    "Marketing Name": "P610",
    "Device": "P610",
    "Model": "P610"
  },
  {
    "Retail Branding": "PHILCO (ar)",
    "Marketing Name": "TP10A464D",
    "Device": "TP10A464D",
    "Model": "TP10A464D"
  },
  {
    "Retail Branding": "PHILCO (ar)",
    "Marketing Name": "TP10A664",
    "Device": "TP10A664",
    "Model": "TP10A664"
  },
  {
    "Retail Branding": "PHYWE",
    "Marketing Name": "12998-99CobraSMARTlink",
    "Device": "12998-99",
    "Model": "12998-99"
  },
  {
    "Retail Branding": "PHYWE",
    "Marketing Name": "12998-99ECobraSMARTlink",
    "Device": "12998-99",
    "Model": "12998-99"
  },
  {
    "Retail Branding": "PHYWE",
    "Marketing Name": "SMARTlink",
    "Device": "SMARTlink",
    "Model": "SMARTlink"
  },
  {
    "Retail Branding": "PHYWE",
    "Marketing Name": "SMARTlink_EEA",
    "Device": "SMARTlink_EEA",
    "Model": "SMARTlink_EEA"
  },
  {
    "Retail Branding": "PILOT",
    "Marketing Name": "Android TV",
    "Device": "longshan",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "PILOT",
    "Marketing Name": "PQ55CH",
    "Device": "samseong",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "PILOT",
    "Marketing Name": "Smart TV",
    "Device": "alimos",
    "Model": "PILOT Google TV"
  },
  {
    "Retail Branding": "PILOT",
    "Marketing Name": "Smart TV",
    "Device": "dangni",
    "Model": "PILOT Google TV"
  },
  {
    "Retail Branding": "PILOT",
    "Marketing Name": "Smart TV",
    "Device": "redwood",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "PINOCCHIO",
    "Marketing Name": "SGWIFIPAD320093",
    "Device": "SGWIFIPAD320093",
    "Model": "SGWIFIPAD320093"
  },
  {
    "Retail Branding": "PIPO",
    "Marketing Name": "IconX_P109",
    "Device": "IconX_P109",
    "Model": "IconX_P109"
  },
  {
    "Retail Branding": "PIXART",
    "Marketing Name": "Pixart_P20",
    "Device": "Pixart_P20",
    "Model": "Pixart_P20"
  },
  {
    "Retail Branding": "PIXART",
    "Marketing Name": "SZ10M68",
    "Device": "SZ10M68",
    "Model": "SZ10M68"
  },
  {
    "Retail Branding": "PIXGOOD",
    "Marketing Name": "M103-EEA",
    "Device": "M103-EEA",
    "Model": "M103-EEA"
  },
  {
    "Retail Branding": "PIXGOOD",
    "Marketing Name": "M323-EEA",
    "Device": "M323-EEA",
    "Model": "M323-EEA"
  },
  {
    "Retail Branding": "PIXGOOD",
    "Marketing Name": "M328-EEA",
    "Device": "M328-EEA",
    "Model": "M328-EEA"
  },
  {
    "Retail Branding": "PIXGOOD",
    "Marketing Name": "M618-EEA",
    "Device": "M618-EEA",
    "Model": "M618-EEA"
  },
  {
    "Retail Branding": "PIXGOOD",
    "Marketing Name": "M902-EEA",
    "Device": "M902-EEA",
    "Model": "M902-EEA"
  },
  {
    "Retail Branding": "PIXPEAK",
    "Marketing Name": "L60-EEA",
    "Device": "L60-EEA",
    "Model": "L60-EEA"
  },
  {
    "Retail Branding": "PIXPEAK",
    "Marketing Name": "M186-EEA",
    "Device": "M186-EEA",
    "Model": "M186-EEA"
  },
  {
    "Retail Branding": "PIXPEAK",
    "Marketing Name": "M258-EEA",
    "Device": "M258-EEA",
    "Model": "M258-EEA"
  },
  {
    "Retail Branding": "PIXPEAK",
    "Marketing Name": "M832-EEA",
    "Device": "M832-EEA",
    "Model": "M832-EEA"
  },
  {
    "Retail Branding": "PIXPEAK",
    "Marketing Name": "P107-EEA",
    "Device": "P107-EEA",
    "Model": "P107-EEA"
  },
  {
    "Retail Branding": "PIXPEAK",
    "Marketing Name": "Tablet",
    "Device": "Tablet",
    "Model": "P7-EEA"
  },
  {
    "Retail Branding": "PIXPEAK",
    "Marketing Name": "U921",
    "Device": "U921",
    "Model": "U921"
  },
  {
    "Retail Branding": "PIXPEAK",
    "Marketing Name": "U921-EEA",
    "Device": "U921-EEA",
    "Model": "U921-EEA"
  },
  {
    "Retail Branding": "PIXPRO",
    "Marketing Name": "PIXPRO L1 PRO",
    "Device": "PIXPRO_L1_PRO",
    "Model": "PIXPRO L1 PRO"
  },
  {
    "Retail Branding": "PIXPRO",
    "Marketing Name": "PIXPRO T3",
    "Device": "T3",
    "Model": "PIXPRO T3"
  },
  {
    "Retail Branding": "PIXPRO",
    "Marketing Name": "VisionTab_10",
    "Device": "VT10_Rugged",
    "Model": "PX-M1025"
  },
  {
    "Retail Branding": "PLDT",
    "Marketing Name": "PLDT-GMB8260",
    "Device": "DS8942-KPP",
    "Model": "PLDT-GMB8260"
  },
  {
    "Retail Branding": "PLDT",
    "Marketing Name": "Smart Page 8 Pro",
    "Device": "Smart_Page_8_Pro",
    "Model": "Smart_Page_8_Pro"
  },
  {
    "Retail Branding": "PLDTHOME",
    "Marketing Name": "Video Sound Box",
    "Device": "vsb3918_apac",
    "Model": "VIDEO SOUND BOX"
  },
  {
    "Retail Branding": "PLOYER",
    "Marketing Name": "A1190",
    "Device": "A1190",
    "Model": "A1190"
  },
  {
    "Retail Branding": "PLOYER",
    "Marketing Name": "CP-518",
    "Device": "CP-518",
    "Model": "CP-518"
  },
  {
    "Retail Branding": "PLOYER",
    "Marketing Name": "CP-519",
    "Device": "CP-519",
    "Model": "CP-519"
  },
  {
    "Retail Branding": "PLUX",
    "Marketing Name": "Smart TV",
    "Device": "alimos",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "PLUX",
    "Marketing Name": "Smart TV",
    "Device": "dangni",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "PN_RAVEC",
    "Marketing Name": "PN_RAVEC_TABLETTE",
    "Device": "PN_RAVEC_TABLETTE",
    "Model": "UTAB R1030"
  },
  {
    "Retail Branding": "POC",
    "Marketing Name": "POC2",
    "Device": "CBL7509MM",
    "Model": "POC2"
  },
  {
    "Retail Branding": "POCKAM",
    "Marketing Name": "P10",
    "Device": "RK5S-P",
    "Model": "P10"
  },
  {
    "Retail Branding": "POCKAM",
    "Marketing Name": "P10 Kid",
    "Device": "RK5KID-P",
    "Model": "P10 Kid"
  },
  {
    "Retail Branding": "POCKAM",
    "Marketing Name": "P10 Pro",
    "Device": "T5-P",
    "Model": "P10 Pro"
  },
  {
    "Retail Branding": "POCKAM",
    "Marketing Name": "P11",
    "Device": "T2-P",
    "Model": "P11"
  },
  {
    "Retail Branding": "POCKAM",
    "Marketing Name": "P11 Pro",
    "Device": "T4-P",
    "Model": "P11 Pro"
  },
  {
    "Retail Branding": "POCKAM",
    "Marketing Name": "P12",
    "Device": "P7C-P",
    "Model": "P12"
  },
  {
    "Retail Branding": "POCKAM",
    "Marketing Name": "P12 Pro",
    "Device": "P7S-P",
    "Model": "P12 Pro"
  },
  {
    "Retail Branding": "POCKAM",
    "Marketing Name": "P13",
    "Device": "P8C-P",
    "Model": "P13"
  },
  {
    "Retail Branding": "POCKAM",
    "Marketing Name": "P13 Pro",
    "Device": "P8-P",
    "Model": "P13 Pro"
  },
  {
    "Retail Branding": "POCKAM",
    "Marketing Name": "P9T-P",
    "Device": "P9T-P",
    "Model": "P12 Plus"
  },
  {
    "Retail Branding": "POCO",
    "Marketing Name": "POCO C3",
    "Device": "angelicain",
    "Model": "M2006C3MI"
  },
  {
    "Retail Branding": "POCO",
    "Marketing Name": "POCO C31",
    "Device": "angelicain",
    "Model": "211033MI"
  },
  {
    "Retail Branding": "POCO",
    "Marketing Name": "POCO C50",
    "Device": "snow",
    "Model": "220733SPI"
  },
  {
    "Retail Branding": "POCO",
    "Marketing Name": "POCO C51",
    "Device": "water",
    "Model": "2302EPCC4H"
  },
  {
    "Retail Branding": "POCO",
    "Marketing Name": "POCO C51",
    "Device": "water",
    "Model": "2305EPCC4G"
  },
  {
    "Retail Branding": "POCO",
    "Marketing Name": "POCO C55",
    "Device": "earth",
    "Model": "22127PC95I"
  },
  {
    "Retail Branding": "POCO",
    "Marketing Name": "POCO C61",
    "Device": "blue",
    "Model": "2312BPC51H"
  },
  {
    "Retail Branding": "POCO",
    "Marketing Name": "POCO C61",
    "Device": "blue",
    "Model": "2312BPC51X"
  },
  {
    "Retail Branding": "POCO",
    "Marketing Name": "POCO C65",
    "Device": "gale",
    "Model": "2310FPCA4I"
  },
  {
    "Retail Branding": "POCO",
    "Marketing Name": "POCO C65",
    "Device": "gust",
    "Model": "2310FPCA4G"
  },
  {
    "Retail Branding": "POCO",
    "Marketing Name": "POCO C71",
    "Device": "serenity",
    "Model": "25028PC03G"
  },
  {
    "Retail Branding": "POCO",
    "Marketing Name": "POCO C71",
    "Device": "serenity",
    "Model": "25028PC03I"
  },
  {
    "Retail Branding": "POCO",
    "Marketing Name": "POCO C75",
    "Device": "lake",
    "Model": "2410FPCC5G"
  },
  {
    "Retail Branding": "POCO",
    "Marketing Name": "POCO C75 5G",
    "Device": "warm",
    "Model": "24116PCC1I"
  },
  {
    "Retail Branding": "POCO",
    "Marketing Name": "POCO C85",
    "Device": "dew",
    "Model": "25078PC3EE"
  },
  {
    "Retail Branding": "POCO",
    "Marketing Name": "POCO C85",
    "Device": "dew",
    "Model": "25078PC3EG"
  },
  {
    "Retail Branding": "POCO",
    "Marketing Name": "POCO C85 5G",
    "Device": "tornado",
    "Model": "2508CPC2BI"
  },
  {
    "Retail Branding": "POCO",
    "Marketing Name": "POCO C85x 5G",
    "Device": "somalia",
    "Model": "26020PC1AI"
  },
  {
    "Retail Branding": "POCO",
    "Marketing Name": "POCO F2 Pro",
    "Device": "lmi",
    "Model": "POCO F2 Pro"
  },
  {
    "Retail Branding": "POCO",
    "Marketing Name": "POCO F3",
    "Device": "alioth",
    "Model": "M2012K11AG"
  },
  {
    "Retail Branding": "POCO",
    "Marketing Name": "POCO F3 GT",
    "Device": "aresin",
    "Model": "M2104K10I"
  },
  {
    "Retail Branding": "POCO",
    "Marketing Name": "POCO F4",
    "Device": "munch",
    "Model": "22021211RG"
  },
  {
    "Retail Branding": "POCO",
    "Marketing Name": "POCO F4",
    "Device": "munch",
    "Model": "22021211RI"
  },
  {
    "Retail Branding": "POCO",
    "Marketing Name": "POCO F4 GT",
    "Device": "ingres",
    "Model": "21121210G"
  },
  {
    "Retail Branding": "POCO",
    "Marketing Name": "POCO F5",
    "Device": "marble",
    "Model": "23049PCD8G"
  },
  {
    "Retail Branding": "POCO",
    "Marketing Name": "POCO F5",
    "Device": "marble",
    "Model": "23049PCD8I"
  },
  {
    "Retail Branding": "POCO",
    "Marketing Name": "POCO F6",
    "Device": "peridot",
    "Model": "24069PC21G"
  },
  {
    "Retail Branding": "POCO",
    "Marketing Name": "POCO F6",
    "Device": "peridot",
    "Model": "24069PC21I"
  },
  {
    "Retail Branding": "POCO",
    "Marketing Name": "POCO F6 Pro",
    "Device": "vermeer",
    "Model": "23113RKC6G"
  },
  {
    "Retail Branding": "POCO",
    "Marketing Name": "POCO F8 Pro",
    "Device": "annibale",
    "Model": "2510DPC44G"
  },
  {
    "Retail Branding": "POCO",
    "Marketing Name": "POCO F8 Ultra",
    "Device": "myron",
    "Model": "25102PCBEG"
  },
  {
    "Retail Branding": "POCO",
    "Marketing Name": "POCO M2",
    "Device": "shiva",
    "Model": "M2004J19PI"
  },
  {
    "Retail Branding": "POCO",
    "Marketing Name": "POCO M2 Pro",
    "Device": "gram",
    "Model": "POCO M2 Pro"
  },
  {
    "Retail Branding": "POCO",
    "Marketing Name": "POCO M3",
    "Device": "citrus",
    "Model": "M2010J19CG"
  },
  {
    "Retail Branding": "POCO",
    "Marketing Name": "POCO M3",
    "Device": "citrus",
    "Model": "M2010J19CI"
  },
  {
    "Retail Branding": "POCO",
    "Marketing Name": "POCO M3 Pro 5G",
    "Device": "camellia",
    "Model": "M2103K19PI"
  },
  {
    "Retail Branding": "POCO",
    "Marketing Name": "POCO M3 Pro 5G",
    "Device": "camellian",
    "Model": "M2103K19PG"
  },
  {
    "Retail Branding": "POCO",
    "Marketing Name": "POCO M4 5G",
    "Device": "light",
    "Model": "22041219PI"
  },
  {
    "Retail Branding": "POCO",
    "Marketing Name": "POCO M4 5G",
    "Device": "thunder",
    "Model": "22041219PG"
  },
  {
    "Retail Branding": "POCO",
    "Marketing Name": "POCO M4 Pro",
    "Device": "fleur",
    "Model": "2201117PG"
  },
  {
    "Retail Branding": "POCO",
    "Marketing Name": "POCO M4 Pro",
    "Device": "miel",
    "Model": "2201117PI"
  },
  {
    "Retail Branding": "POCO",
    "Marketing Name": "POCO M4 Pro 5G",
    "Device": "evergreen",
    "Model": "21091116AG"
  },
  {
    "Retail Branding": "POCO",
    "Marketing Name": "POCO M5",
    "Device": "rock",
    "Model": "22071219CI"
  },
  {
    "Retail Branding": "POCO",
    "Marketing Name": "POCO M5",
    "Device": "stone",
    "Model": "22071219CG"
  },
  {
    "Retail Branding": "POCO",
    "Marketing Name": "POCO M5s",
    "Device": "rosemary",
    "Model": "2207117BPG"
  },
  {
    "Retail Branding": "POCO",
    "Marketing Name": "POCO M6",
    "Device": "moon",
    "Model": "2404APC5FG"
  },
  {
    "Retail Branding": "POCO",
    "Marketing Name": "POCO M6 Plus 5G",
    "Device": "breeze",
    "Model": "24066PC95I"
  },
  {
    "Retail Branding": "POCO",
    "Marketing Name": "POCO M6 Pro",
    "Device": "emerald",
    "Model": "2312FPCA6G"
  },
  {
    "Retail Branding": "POCO",
    "Marketing Name": "POCO M6 Pro 5G",
    "Device": "sky",
    "Model": "23076PC4BI"
  },
  {
    "Retail Branding": "POCO",
    "Marketing Name": "POCO M7",
    "Device": "creek",
    "Model": "25062PC34E"
  },
  {
    "Retail Branding": "POCO",
    "Marketing Name": "POCO M7",
    "Device": "creek",
    "Model": "25062PC34G"
  },
  {
    "Retail Branding": "POCO",
    "Marketing Name": "POCO M7 5G",
    "Device": "flame",
    "Model": "24108PCE2I"
  },
  {
    "Retail Branding": "POCO",
    "Marketing Name": "POCO M7 Plus 5G",
    "Device": "spring",
    "Model": "25057PC09I"
  },
  {
    "Retail Branding": "POCO",
    "Marketing Name": "POCO M7 Pro 5G",
    "Device": "beryl",
    "Model": "2409FPCC4I"
  },
  {
    "Retail Branding": "POCO",
    "Marketing Name": "POCO M8 5G",
    "Device": "kunzite",
    "Model": "25118PC98G"
  },
  {
    "Retail Branding": "POCO",
    "Marketing Name": "POCO M8 5G",
    "Device": "kunzite",
    "Model": "25118PC98I"
  },
  {
    "Retail Branding": "POCO",
    "Marketing Name": "POCO M8 Pro 5G",
    "Device": "flourite",
    "Model": "2510EPC8BG"
  },
  {
    "Retail Branding": "POCO",
    "Marketing Name": "POCO Pad",
    "Device": "dizi",
    "Model": "2405CPCFBG"
  },
  {
    "Retail Branding": "POCO",
    "Marketing Name": "POCO Pad M1",
    "Device": "flute",
    "Model": "2509ARPBDG"
  },
  {
    "Retail Branding": "POCO",
    "Marketing Name": "POCO X2",
    "Device": "phoenixin",
    "Model": "POCO X2"
  },
  {
    "Retail Branding": "POCO",
    "Marketing Name": "POCO X3",
    "Device": "karna",
    "Model": "M2007J20CI"
  },
  {
    "Retail Branding": "POCO",
    "Marketing Name": "POCO X3 NFC",
    "Device": "surya",
    "Model": "M2007J20CG"
  },
  {
    "Retail Branding": "POCO",
    "Marketing Name": "POCO X3 Pro",
    "Device": "bhima",
    "Model": "M2102J20SI"
  },
  {
    "Retail Branding": "POCO",
    "Marketing Name": "POCO X3 Pro",
    "Device": "vayu",
    "Model": "M2102J20SG"
  },
  {
    "Retail Branding": "POCO",
    "Marketing Name": "POCO X4 GT",
    "Device": "xaga",
    "Model": "22041216G"
  },
  {
    "Retail Branding": "POCO",
    "Marketing Name": "POCO X4 Pro 5G",
    "Device": "peux",
    "Model": "2201116PI"
  },
  {
    "Retail Branding": "POCO",
    "Marketing Name": "POCO X4 Pro 5G",
    "Device": "veux",
    "Model": "2201116PG"
  },
  {
    "Retail Branding": "POCO",
    "Marketing Name": "POCO X5 Pro 5G",
    "Device": "redwood",
    "Model": "22101320G"
  },
  {
    "Retail Branding": "POCO",
    "Marketing Name": "POCO X5 Pro 5G",
    "Device": "redwoodin",
    "Model": "22101320I"
  },
  {
    "Retail Branding": "POCO",
    "Marketing Name": "POCO X6 5G",
    "Device": "garnet",
    "Model": "23122PCD1G"
  },
  {
    "Retail Branding": "POCO",
    "Marketing Name": "POCO X6 5G",
    "Device": "garnet",
    "Model": "23122PCD1I"
  },
  {
    "Retail Branding": "POCO",
    "Marketing Name": "POCO X6 Pro 5G",
    "Device": "duchamp",
    "Model": "2311DRK48G"
  },
  {
    "Retail Branding": "POCO",
    "Marketing Name": "POCO X6 Pro 5G",
    "Device": "duchamp",
    "Model": "2311DRK48I"
  },
  {
    "Retail Branding": "POCO",
    "Marketing Name": "POCO X7",
    "Device": "malachite",
    "Model": "24095PCADG"
  },
  {
    "Retail Branding": "POCO",
    "Marketing Name": "POCO X7",
    "Device": "malachite",
    "Model": "24095PCADI"
  },
  {
    "Retail Branding": "POCO",
    "Marketing Name": "POCO X7 Pro",
    "Device": "rodin",
    "Model": "2412DPC0AG"
  },
  {
    "Retail Branding": "POCO",
    "Marketing Name": "POCO X7 Pro",
    "Device": "rodin",
    "Model": "2412DPC0AI"
  },
  {
    "Retail Branding": "POCO",
    "Marketing Name": "POCO X8 Pro",
    "Device": "klee",
    "Model": "2511FPC34G"
  },
  {
    "Retail Branding": "POCO",
    "Marketing Name": "POCO X8 Pro",
    "Device": "klee",
    "Model": "2511FPC34I"
  },
  {
    "Retail Branding": "POCO",
    "Marketing Name": "POCO X8 Pro Max",
    "Device": "dash",
    "Model": "2602BPC18G"
  },
  {
    "Retail Branding": "POCO",
    "Marketing Name": "POCO X8 Pro Max",
    "Device": "dash",
    "Model": "2602BPC18I"
  },
  {
    "Retail Branding": "POCO",
    "Marketing Name": "Poco F7",
    "Device": "onyx",
    "Model": "25053PC47G"
  },
  {
    "Retail Branding": "POCO",
    "Marketing Name": "Poco F7",
    "Device": "onyx",
    "Model": "25053PC47I"
  },
  {
    "Retail Branding": "POCO",
    "Marketing Name": "Poco F7 Pro",
    "Device": "zorn",
    "Model": "24117RK2CG"
  },
  {
    "Retail Branding": "POCO",
    "Marketing Name": "Poco F7 Ultra",
    "Device": "miro",
    "Model": "24122RKC7G"
  },
  {
    "Retail Branding": "POCO",
    "Marketing Name": "Poco M7 Pro 5G",
    "Device": "citrine",
    "Model": "2409FPCC4G"
  },
  {
    "Retail Branding": "POLSAT",
    "Marketing Name": "polsat soundbox 4K",
    "Device": "m391_polsat",
    "Model": "polsat soundbox 4K"
  },
  {
    "Retail Branding": "POOLS",
    "Marketing Name": "POOLS The DOLLAR",
    "Device": "POOLS_The_DOLLAR",
    "Model": "POOLS_The_DOLLAR"
  },
  {
    "Retail Branding": "POP TV",
    "Marketing Name": "POP TV N9000",
    "Device": "POPTV_B866V2F01",
    "Model": "POP TV N9000"
  },
  {
    "Retail Branding": "POPTEL",
    "Marketing Name": "Kammunica V10",
    "Device": "Kammunica_V10",
    "Model": "Kammunica_V10"
  },
  {
    "Retail Branding": "POPTEL",
    "Marketing Name": "P60",
    "Device": "P60",
    "Model": "P60"
  },
  {
    "Retail Branding": "POPTEL",
    "Marketing Name": "P8",
    "Device": "P8",
    "Model": "P8"
  },
  {
    "Retail Branding": "POPTEL",
    "Marketing Name": "P9000 MAX",
    "Device": "P9000_MAX",
    "Model": "P9000_MAX"
  },
  {
    "Retail Branding": "POPTEL",
    "Marketing Name": "P9000 Plus",
    "Device": "P9000_Plus",
    "Model": "P9000 Plus"
  },
  {
    "Retail Branding": "POPTEL",
    "Marketing Name": "POPTEL P10",
    "Device": "P10",
    "Model": "P10"
  },
  {
    "Retail Branding": "POPTEL",
    "Marketing Name": "V10",
    "Device": "V10",
    "Model": "V10"
  },
  {
    "Retail Branding": "POPTEL",
    "Marketing Name": "V9",
    "Device": "V9",
    "Model": "V9"
  },
  {
    "Retail Branding": "PORTFOLIO",
    "Marketing Name": "P9001",
    "Device": "P9001",
    "Model": "P9001"
  },
  {
    "Retail Branding": "POS Terminal",
    "Marketing Name": "ACT",
    "Device": "POS",
    "Model": "pCloud"
  },
  {
    "Retail Branding": "POS Terminal",
    "Marketing Name": "MINT",
    "Device": "POS",
    "Model": "pCloud"
  },
  {
    "Retail Branding": "POS Terminal",
    "Marketing Name": "PPGLOM81",
    "Device": "PAI",
    "Model": "pCloud"
  },
  {
    "Retail Branding": "POS Terminal",
    "Marketing Name": "mPOS",
    "Device": "POS",
    "Model": "pCloud"
  },
  {
    "Retail Branding": "POS Terminal",
    "Marketing Name": "mPOS-R",
    "Device": "POS",
    "Model": "pCloud"
  },
  {
    "Retail Branding": "POSSAFE",
    "Marketing Name": "OrderGo5_EEA",
    "Device": "OrderGo5",
    "Model": "OrderGo5"
  },
  {
    "Retail Branding": "POSSAFE",
    "Marketing Name": "OrderGo7",
    "Device": "OrderGo7",
    "Model": "OrderGo7"
  },
  {
    "Retail Branding": "POSSAFE",
    "Marketing Name": "OrderGo_6_TR",
    "Device": "OrderGo_6",
    "Model": "OrderGo 6"
  },
  {
    "Retail Branding": "POWERPAD",
    "Marketing Name": "G11pro",
    "Device": "G11pro",
    "Model": "G11pro"
  },
  {
    "Retail Branding": "POWMUS",
    "Marketing Name": "L211-EEA",
    "Device": "L211-EEA",
    "Model": "L211-EEA"
  },
  {
    "Retail Branding": "POWMUS",
    "Marketing Name": "L30",
    "Device": "L30",
    "Model": "L30"
  },
  {
    "Retail Branding": "POWMUS",
    "Marketing Name": "L60",
    "Device": "L60",
    "Model": "L60"
  },
  {
    "Retail Branding": "PRAZteck",
    "Marketing Name": "2-IN-1_Tablet_PC",
    "Device": "PT10EduPad21",
    "Model": "PT10EduPad21"
  },
  {
    "Retail Branding": "PRAZteck",
    "Marketing Name": "PT116LPREduPad",
    "Device": "Laptop",
    "Model": "PT116LPREduPad"
  },
  {
    "Retail Branding": "PRAZteck",
    "Marketing Name": "PT7EduPad",
    "Device": "PT7EduPad",
    "Model": "PT7EduPad"
  },
  {
    "Retail Branding": "PRIMA",
    "Marketing Name": "PRIMA 2K Android TV",
    "Device": "lasalle",
    "Model": "PRIMA 2K Android TV"
  },
  {
    "Retail Branding": "PRIMA",
    "Marketing Name": "PRIMA 4K Android TV",
    "Device": "kenton",
    "Model": "PRIMA 4K Android TV"
  },
  {
    "Retail Branding": "PRIMA",
    "Marketing Name": "Smart TV",
    "Device": "alimos",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "PRIMA",
    "Marketing Name": "Smart TV",
    "Device": "dangni",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "PRIMA",
    "Marketing Name": "Smart TV",
    "Device": "osaka",
    "Model": "AI PONT SA"
  },
  {
    "Retail Branding": "PRISMPLUS",
    "Marketing Name": "4K Smart TV Plus",
    "Device": "anaheim",
    "Model": "4K Smart TV Plus"
  },
  {
    "Retail Branding": "PRISMPLUS",
    "Marketing Name": "PrismPlus 2KA",
    "Device": "umeda",
    "Model": "PrismPlus 2KA"
  },
  {
    "Retail Branding": "PRISMPLUS",
    "Marketing Name": "PrismPlus 4K Android TV",
    "Device": "SW4H",
    "Model": "PrismPlus 4K Android TV"
  },
  {
    "Retail Branding": "PRISMPLUS",
    "Marketing Name": "PrismPlus 4K Pro Android TV",
    "Device": "SW4H_FF",
    "Model": "PrismPlus 4K Pro Android TV"
  },
  {
    "Retail Branding": "PRISMPLUS",
    "Marketing Name": "PrismPlus 4K TV",
    "Device": "eleonas",
    "Model": "PrismPlus 4K TV"
  },
  {
    "Retail Branding": "PRISMPLUS",
    "Marketing Name": "PrismPlus 4KA",
    "Device": "SW6H",
    "Model": "PrismPlus 4KA"
  },
  {
    "Retail Branding": "PRISMPLUS",
    "Marketing Name": "PrismPlus Android TV",
    "Device": "sunnyvale",
    "Model": "PrismPlus Android TV"
  },
  {
    "Retail Branding": "PRISMPLUS",
    "Marketing Name": "PrismPlus P4KA",
    "Device": "SW6H",
    "Model": "PrismPlus P4KA"
  },
  {
    "Retail Branding": "PRISMPLUS",
    "Marketing Name": "Prismplus TV",
    "Device": "shibuya",
    "Model": "Prismplus TV"
  },
  {
    "Retail Branding": "PROGRACE",
    "Marketing Name": "K726",
    "Device": "K726",
    "Model": "K726"
  },
  {
    "Retail Branding": "PROTON",
    "Marketing Name": "Glory_i30",
    "Device": "Glory_i30",
    "Model": "Glory_i30"
  },
  {
    "Retail Branding": "PROTON",
    "Marketing Name": "HyperX",
    "Device": "HyperX",
    "Model": "HyperX"
  },
  {
    "Retail Branding": "PROTON",
    "Marketing Name": "Infinity 8",
    "Device": "Infinity_8",
    "Model": "Infinity 8"
  },
  {
    "Retail Branding": "PROTON",
    "Marketing Name": "P25 Ultra",
    "Device": "P25_Ultra",
    "Model": "P25 Ultra"
  },
  {
    "Retail Branding": "PROTON",
    "Marketing Name": "PROTON 2K Android",
    "Device": "lasalle",
    "Model": "PROTON 2K Android"
  },
  {
    "Retail Branding": "PROTON",
    "Marketing Name": "PROTON 2K Google TV",
    "Device": "capitolhill",
    "Model": "PROTON 2K Google TV"
  },
  {
    "Retail Branding": "PROTON",
    "Marketing Name": "PROTON 4K Android",
    "Device": "kenton",
    "Model": "PROTON 4K Android"
  },
  {
    "Retail Branding": "PROTON",
    "Marketing Name": "PROTON 4K Google TV",
    "Device": "keoneae",
    "Model": "PROTON 4K Google TV"
  },
  {
    "Retail Branding": "PROTON",
    "Marketing Name": "PROTON Google TV",
    "Device": "bandra",
    "Model": "PROTON Google TV"
  },
  {
    "Retail Branding": "PROTON",
    "Marketing Name": "Proton_X10_Pro",
    "Device": "Proton_X10_Pro",
    "Model": "X10 Pro"
  },
  {
    "Retail Branding": "PROTON",
    "Marketing Name": "Smart TV",
    "Device": "alimos",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "PROTON",
    "Marketing Name": "Smart TV",
    "Device": "dangni",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "PROTON",
    "Marketing Name": "X20 Pro",
    "Device": "Proton_X20_Pro",
    "Model": "X20 Pro"
  },
  {
    "Retail Branding": "PS",
    "Marketing Name": "PS101",
    "Device": "PS101",
    "Model": "PS101"
  },
  {
    "Retail Branding": "PS_Mobile",
    "Marketing Name": "Neo_Pro",
    "Device": "Neo_Pro",
    "Model": "Neo Pro"
  },
  {
    "Retail Branding": "PS_Mobile",
    "Marketing Name": "neo",
    "Device": "neo",
    "Model": "neo"
  },
  {
    "Retail Branding": "PT mobile",
    "Marketing Name": "P10",
    "Device": "P10",
    "Model": "P10"
  },
  {
    "Retail Branding": "PTCL SHOQ TV",
    "Marketing Name": "PTCL B866V2F",
    "Device": "PTCLBox_B866V2F",
    "Model": "B866V2F"
  },
  {
    "Retail Branding": "PTEZ",
    "Marketing Name": "EZ24",
    "Device": "EZ24",
    "Model": "EZ24"
  },
  {
    "Retail Branding": "PYUR",
    "Marketing Name": "PYUR TV BOX",
    "Device": "m377genb_pyur",
    "Model": "PYUR TV BOX"
  },
  {
    "Retail Branding": "Packard Bell",
    "Marketing Name": "A4000",
    "Device": "A4000",
    "Model": "A4000"
  },
  {
    "Retail Branding": "Packard Bell",
    "Marketing Name": "A5000",
    "Device": "A5000",
    "Model": "A5000"
  },
  {
    "Retail Branding": "Packard Bell",
    "Marketing Name": "A5700",
    "Device": "A5700",
    "Model": "A5700"
  },
  {
    "Retail Branding": "Packard Bell",
    "Marketing Name": "DAYTONA-G12",
    "Device": "DAYTONA-G12",
    "Model": "DAYTONA-G12"
  },
  {
    "Retail Branding": "Packard Bell",
    "Marketing Name": "DAYTONA-G16",
    "Device": "DAYTONA-G16",
    "Model": "DAYTONA-G16"
  },
  {
    "Retail Branding": "Packard Bell",
    "Marketing Name": "DAYTONA-G16-PRO",
    "Device": "DAYTONA-G16-PRO",
    "Model": "DAYTONA-G16 PRO"
  },
  {
    "Retail Branding": "Packard Bell",
    "Marketing Name": "DAYTONA-G5",
    "Device": "BL_9UEEP_105",
    "Model": "DAYTONA-G5"
  },
  {
    "Retail Branding": "Packard Bell",
    "Marketing Name": "DAYTONA-G6",
    "Device": "DAYTONA-G6",
    "Model": "DAYTONA-G6"
  },
  {
    "Retail Branding": "Packard Bell",
    "Marketing Name": "DAYTONA-G6L",
    "Device": "BL_9UEEP_106",
    "Model": "DAYTONA-G6L"
  },
  {
    "Retail Branding": "Packard Bell",
    "Marketing Name": "DAYTONA_G8",
    "Device": "BL_9UEEP_104",
    "Model": "DAYTONA_G8"
  },
  {
    "Retail Branding": "Packard Bell",
    "Marketing Name": "INTERLAGOS-T32",
    "Device": "INTERLAGOS-T32",
    "Model": "INTERLAGOS-T32"
  },
  {
    "Retail Branding": "Packard Bell",
    "Marketing Name": "M10400",
    "Device": "M10400",
    "Model": "M10400"
  },
  {
    "Retail Branding": "Packard Bell",
    "Marketing Name": "M10500",
    "Device": "M10500",
    "Model": "M10500"
  },
  {
    "Retail Branding": "Packard Bell",
    "Marketing Name": "M10600",
    "Device": "M10600",
    "Model": "M10600"
  },
  {
    "Retail Branding": "Packard Bell",
    "Marketing Name": "M10905-32",
    "Device": "M10905-32",
    "Model": "M10905-32"
  },
  {
    "Retail Branding": "Packard Bell",
    "Marketing Name": "M10950",
    "Device": "M10950",
    "Model": "M10950"
  },
  {
    "Retail Branding": "Packard Bell",
    "Marketing Name": "M11550",
    "Device": "M11550",
    "Model": "M11550"
  },
  {
    "Retail Branding": "Packard Bell",
    "Marketing Name": "M7500",
    "Device": "M7500",
    "Model": "M7500"
  },
  {
    "Retail Branding": "Packard Bell",
    "Marketing Name": "M7600-D",
    "Device": "M7600-D",
    "Model": "M7600-D"
  },
  {
    "Retail Branding": "Packard Bell",
    "Marketing Name": "MONZA-T5",
    "Device": "MONZA-T5",
    "Model": "MONZA-T5"
  },
  {
    "Retail Branding": "Packard Bell",
    "Marketing Name": "MONZA-T7",
    "Device": "MONZA-T7",
    "Model": "MONZA-T7"
  },
  {
    "Retail Branding": "Packard Bell",
    "Marketing Name": "PB1009",
    "Device": "PB1009",
    "Model": "PB1009"
  },
  {
    "Retail Branding": "Packard Bell",
    "Marketing Name": "PB101",
    "Device": "PB101",
    "Model": "PB101"
  },
  {
    "Retail Branding": "Packard Bell",
    "Marketing Name": "PB9000-32",
    "Device": "PB9000-32",
    "Model": "PB9000-32"
  },
  {
    "Retail Branding": "Packard Bell",
    "Marketing Name": "SILVERSTONE-T10",
    "Device": "SILVERSTONE-T10",
    "Model": "SILVERSTONE-T10"
  },
  {
    "Retail Branding": "Packard Bell",
    "Marketing Name": "SILVERSTONE-T11",
    "Device": "SILVERSTONE-T11",
    "Model": "BL.9UEEP.209"
  },
  {
    "Retail Branding": "Packard Bell",
    "Marketing Name": "SILVERSTONE-T18",
    "Device": "SILVERSTONE-T18",
    "Model": "BL.9UEEP.210"
  },
  {
    "Retail Branding": "Packard Bell",
    "Marketing Name": "Silverstone-T10X",
    "Device": "Silverstone-T10X",
    "Model": "Silverstone-T10X"
  },
  {
    "Retail Branding": "Packard Bell",
    "Marketing Name": "T1000",
    "Device": "T1000",
    "Model": "T1000"
  },
  {
    "Retail Branding": "Packard Bell",
    "Marketing Name": "TARGA-F10PRO",
    "Device": "TARGA-F10PRO",
    "Model": "TARGA-F10PRO"
  },
  {
    "Retail Branding": "Packard Bell",
    "Marketing Name": "TARGA-F11PRO",
    "Device": "TARGA-F11PRO",
    "Model": "TARGA-F11PRO"
  },
  {
    "Retail Branding": "Packard Bell",
    "Marketing Name": "TARGA-F12PRO",
    "Device": "TARGA-F12PRO",
    "Model": "TARGA-F12PRO"
  },
  {
    "Retail Branding": "Packard Bell",
    "Marketing Name": "TARGA-F13PRO",
    "Device": "TARGA-F13PRO",
    "Model": "TARGA-F13PRO"
  },
  {
    "Retail Branding": "Packard Bell",
    "Marketing Name": "TARGA-F14PRO",
    "Device": "TARGA-F14PRO",
    "Model": "TARGA-F14PRO"
  },
  {
    "Retail Branding": "Packard Bell",
    "Marketing Name": "TARGA-F7",
    "Device": "TARGA-F7",
    "Model": "TARGA-F7"
  },
  {
    "Retail Branding": "Packard Bell",
    "Marketing Name": "TARGA-F8",
    "Device": "TARGA-F8",
    "Model": "RG-TB08-V2"
  },
  {
    "Retail Branding": "Packard Bell",
    "Marketing Name": "TARGA-F8",
    "Device": "TARGA-F8",
    "Model": "TARGA-F8"
  },
  {
    "Retail Branding": "PadBook",
    "Marketing Name": "PadBook",
    "Device": "PadBook",
    "Model": "PadBook"
  },
  {
    "Retail Branding": "Palm",
    "Marketing Name": "PVG100",
    "Device": "Pepito",
    "Model": "PVG100"
  },
  {
    "Retail Branding": "Palm",
    "Marketing Name": "PVG100E",
    "Device": "Pepito",
    "Model": "PVG100E"
  },
  {
    "Retail Branding": "Palm",
    "Marketing Name": "Palm",
    "Device": "Pepito",
    "Model": "PVG100C"
  },
  {
    "Retail Branding": "Palm",
    "Marketing Name": "Palm",
    "Device": "Pepito",
    "Model": "PVG100EU"
  },
  {
    "Retail Branding": "Palm",
    "Marketing Name": "Palm",
    "Device": "Pepito",
    "Model": "PVG100E_RU"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "",
    "Device": "H580VT_A",
    "Model": "JT-H580VT"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "",
    "Device": "H581VT_A",
    "Model": "JT-H581VT"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "",
    "Device": "P-08D",
    "Model": "P-08D"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "",
    "Device": "laputa",
    "Model": "P-07C"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "003P",
    "Device": "pana1",
    "Model": "003P"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "101P",
    "Device": "pana2_2s",
    "Model": "101P"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "102P",
    "Device": "pana2_4s",
    "Model": "102P"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "2KTV-5SH",
    "Device": "umeda",
    "Model": "2KTV-5SH"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "2KTV-5SHP",
    "Device": "umeda",
    "Model": "2KTV-5SHP"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "43DX400C",
    "Device": "DX01C",
    "Model": "DX01C"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "43GX580C",
    "Device": "GX580C",
    "Model": "9S61Z_ZQ20S"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "48AX600C",
    "Device": "mst918_4G",
    "Model": "48AX600C"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "4KTV-0SU",
    "Device": "SW4H",
    "Model": "4KTV-0SU"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "4KTV-0SUF",
    "Device": "SW4H_FF",
    "Model": "4KTV-0SUF"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "4KTV-0SUW",
    "Device": "SW4H",
    "Model": "4KTV-0SUW"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "4KTV-3SU",
    "Device": "SW6H",
    "Model": "4KTV-3SU"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "4KTV-3SUC",
    "Device": "SW6H",
    "Model": "4KTV-3SUC"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "4KTV-3SUF",
    "Device": "SW6H",
    "Model": "4KTV-3SUF"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "4KTV-3SUP",
    "Device": "SW6H",
    "Model": "4KTV-3SUP"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "4KTV-4SUH",
    "Device": "anaheim",
    "Model": "4KTV-4SUH"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "55AX600C",
    "Device": "mst918_4k2k",
    "Model": "55AX600C"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "55DX600C",
    "Device": "DX600C",
    "Model": "TH-55DX600C"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "A-DA",
    "Device": "balticaCA",
    "Model": "MY21ADA"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "A-DA",
    "Device": "balticaDA",
    "Model": "MY21ADA"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "AS650C",
    "Device": "AS650C",
    "Model": "AS650C"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "AX600C",
    "Device": "AX600C",
    "Model": "AX600C"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "Active Surface",
    "Device": "surface7",
    "Model": "surface7"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "Altus 18",
    "Device": "Altus18",
    "Model": "Altus 18"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "Altus 24",
    "Device": "Altus24",
    "Model": "Altus 24"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "Altus 32",
    "Device": "Altus32",
    "Model": "Altus 32"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "Altus 4K 24",
    "Device": "Altus4K24",
    "Model": "Qualcomm elite"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "Altus4K43",
    "Device": "Altus4K43",
    "Model": "Qualcomm elite"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "Android TV",
    "Device": "R1",
    "Model": "PANASONIC TV"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "Android TV",
    "Device": "R2",
    "Model": "PANASONIC TV"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "Asia",
    "Device": "globe_ap",
    "Model": "PanasonicTV"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "Boukenkun-reciever",
    "Device": "VW_RCBKK1",
    "Model": "VW_RCBKK1"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "EB-4063-X",
    "Device": "EB-4063-X",
    "Model": "EB-4063-X"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "ELUGA",
    "Device": "pana2_4o",
    "Model": "dL1"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "ELUGA A",
    "Device": "ELUGA_A",
    "Model": "Panasonic ELUGA A"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "ELUGA A3",
    "Device": "ELUGA_A3",
    "Model": "ELUGA_A3"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "ELUGA A3 Pro",
    "Device": "ELUGA_A3_Pro",
    "Model": "ELUGA_A3_Pro"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "ELUGA A4",
    "Device": "ELUGA_A4",
    "Model": "ELUGA A4"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "ELUGA C",
    "Device": "Panasonic_ELUGA_C",
    "Model": "Panasonic_ELUGA_C"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "ELUGA I",
    "Device": "ELUGA_I",
    "Model": "Panasonic ELUGA I"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "ELUGA I2 Activ",
    "Device": "ELUGA_I2_Activ",
    "Model": "ELUGA_I2_Activ"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "ELUGA I3 Mega",
    "Device": "Eluga_I3_Mega",
    "Model": "ELUGA I3 Mega"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "ELUGA I4",
    "Device": "ELUGA_I4",
    "Model": "ELUGA I4"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "ELUGA I5",
    "Device": "ELUGA_I5",
    "Model": "ELUGA_I5"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "ELUGA I6",
    "Device": "Eluga_I6",
    "Model": "Eluga I6"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "ELUGA I7",
    "Device": "ELUGA_I7",
    "Model": "ELUGA I7"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "ELUGA I7 EE",
    "Device": "ELUGA_I7_EE",
    "Model": "ELUGA_I7_EE"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "ELUGA I8",
    "Device": "Eluga_I8",
    "Model": "Eluga I8"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "ELUGA I9",
    "Device": "ELUGA_I9",
    "Model": "Eluga I9"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "ELUGA L 4G",
    "Device": "ELUGA_L_4G",
    "Model": "Panasonic ELUGA L 4G"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "ELUGA P",
    "Device": "P-03E",
    "Model": "P-03E"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "ELUGA PURE",
    "Device": "ELUGA_Pure",
    "Model": "Panasonic_ELUGA_Pure"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "ELUGA Power",
    "Device": "P-07D",
    "Model": "P-07D"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "ELUGA Prim",
    "Device": "ELUGA_Prim",
    "Model": "ELUGA Prim"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "ELUGA Ray 500",
    "Device": "ELUGA_Ray_500",
    "Model": "ELUGA Ray 500"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "ELUGA Ray 550",
    "Device": "ELUGA_Ray_550",
    "Model": "ELUGA Ray 550"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "ELUGA Ray 600",
    "Device": "ELUGA_Ray_600",
    "Model": "ELUGA Ray 600"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "ELUGA Ray 610",
    "Device": "ELUGA_Ray_610",
    "Model": "ELUGA Ray 610"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "ELUGA Ray 700",
    "Device": "Eluga_Ray_700",
    "Model": "Eluga_Ray_700"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "ELUGA Ray 810",
    "Device": "Eluga_Ray_810",
    "Model": "Eluga Ray 810"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "ELUGA S",
    "Device": "ELUGA_S",
    "Model": "Panasonic ELUGA S"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "ELUGA S Mini",
    "Device": "ELUGA_S_Mini",
    "Model": "Panasonic ELUGA S Mini"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "ELUGA Turbo",
    "Device": "ELUGA_Turbo",
    "Model": "ELUGA Turbo"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "ELUGA U",
    "Device": "ELUGA_U",
    "Model": "Panasonic ELUGA U"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "ELUGA U2",
    "Device": "ELUGA_U2",
    "Model": "Panasonic ELUGA U2"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "ELUGA U3",
    "Device": "ELUGA_U3",
    "Model": "ELUGA U3"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "ELUGA V",
    "Device": "P-06D",
    "Model": "P-06D"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "ELUGA WE",
    "Device": "ELUGA_WE",
    "Model": "Panasonic ELUGA WE"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "ELUGA X",
    "Device": "P-02E",
    "Model": "P-02E"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "ELUGA X1",
    "Device": "ELUGA_X1",
    "Model": "ELUGA X1"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "ELUGA Y",
    "Device": "ELUGA_Y",
    "Model": "ELUGA_Y"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "ELUGA Y Pro",
    "Device": "ELUGA_Y_Pro",
    "Model": "ELUGA_Y_Pro"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "ELUGA Z1",
    "Device": "ELUGA_Z1",
    "Model": "ELUGA Z1"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "ELUGA dL1",
    "Device": "pana2_4v",
    "Model": "Panasonic_dL1"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "ELUGA_F",
    "Device": "ELUGA_F",
    "Model": "ELUGA_F"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "EX00C",
    "Device": "EX00C",
    "Model": "EX00C"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "EX01C",
    "Device": "EX01C",
    "Model": "EX01C"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "EX02C",
    "Device": "EX02C",
    "Model": "EX02C"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "Eco10 v3",
    "Device": "ecov310",
    "Model": "Eco v3"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "Eco10 v3 Plus",
    "Device": "ecov3p10",
    "Model": "Eco v3 plus"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "Eco11 v2",
    "Device": "Eco11v2",
    "Model": "Eco11 v2"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "Eco12 v3",
    "Device": "ecov312",
    "Model": "Eco v3"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "Eco12 v3 Plus",
    "Device": "ecov3p12",
    "Model": "Eco v3 plus"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "Eco4K12A",
    "Device": "NEXT820",
    "Model": "NEXT"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "Eco4K13",
    "Device": "NEXT821",
    "Model": "NEXT"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "Eco4K13A",
    "Device": "NEXT820",
    "Model": "NEXT"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "Eco9 v1",
    "Device": "Eco",
    "Model": "Eco9 v1"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "Eco9 v2",
    "Device": "Ecov2",
    "Model": "Eco9 v2"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "EcoFW 10",
    "Device": "ecofw10",
    "Model": "Eco v3 plus"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "Elite 11",
    "Device": "Elite11",
    "Model": "Elite"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "Elite 11",
    "Device": "Elite11",
    "Model": "Elite 11"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "Elite 12",
    "Device": "Elite12",
    "Model": "Elite"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "Elite 12 v3",
    "Device": "Elitev3_12",
    "Model": "Elitev3"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "Elite 12 v3.1",
    "Device": "elitev3a_cam",
    "Model": "Elite v3a with camera"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "Elite 16",
    "Device": "Elite16",
    "Model": "Elite"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "Elite 16 v2",
    "Device": "Elite16",
    "Model": "Elite"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "Elite 18",
    "Device": "Elite18",
    "Model": "Elite"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "Elite 22",
    "Device": "elitev3p22",
    "Model": "Elite v3p22"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "Elite 4K 16",
    "Device": "NEXT821",
    "Model": "NEXT"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "Elite-4K 20",
    "Device": "NEXT820",
    "Model": "NEXT"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "Elite13 v3",
    "Device": "Elitev3_13",
    "Model": "Elitev3"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "Elite4K18A",
    "Device": "NEXT820",
    "Model": "NEXT"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "Elite4K32A",
    "Device": "NEXT820",
    "Model": "NEXT"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "Elitev3a",
    "Device": "elitev3a",
    "Model": "Elite v3a"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "Eluga A2",
    "Device": "Eluga_A2",
    "Model": "Eluga_A2"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "Eluga Arc",
    "Device": "ELUGA_Arc",
    "Model": "Panasonic ELUGA Arc"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "Eluga Arc 2",
    "Device": "Eluga_Arc_2",
    "Model": "Eluga_Arc_2"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "Eluga I2",
    "Device": "ELUGA_I2",
    "Model": "ELUGA_I2"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "Eluga I3",
    "Device": "Eluga_I3",
    "Model": "Panasonic_Eluga_I3"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "Eluga Icon 2",
    "Device": "ELUGA_Icon2",
    "Model": "Panasonic ELUGA Icon 2"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "Eluga Klik",
    "Device": "Eluga_Klik",
    "Model": "Eluga Klik"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "Eluga Mark 2",
    "Device": "Eluga_Mark_2",
    "Model": "Eluga_Mark_2"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "Eluga Pulse",
    "Device": "ELUGA_Pulse",
    "Model": "ELUGA_Pulse"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "Eluga Pulse X",
    "Device": "ELUGA_Pulse_X",
    "Model": "ELUGA_Pulse_X"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "Eluga Ray",
    "Device": "ELUGA_Ray",
    "Model": "ELUGA Ray"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "Eluga Ray 530",
    "Device": "ELUGA_Ray_530",
    "Model": "ELUGA Ray 530"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "Eluga Ray 710",
    "Device": "ELUGA_Ray_710",
    "Model": "ELUGA Ray 710"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "Eluga Ray 800",
    "Device": "Eluga_Ray_800",
    "Model": "Eluga_Ray_800"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "Eluga Ray Max",
    "Device": "ELUGA_Ray_Max",
    "Model": "ELUGA Ray Max"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "Eluga Ray X",
    "Device": "ELUGA_Ray_X",
    "Model": "ELUGA Ray X"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "Eluga Tapp",
    "Device": "Eluga_TAPP",
    "Model": "Panasonic ELUGA Tapp"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "Eluga Z",
    "Device": "ELUGA_Z",
    "Model": "Panasonic ELUGA Z"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "Eluga_Note",
    "Device": "ELUGA_Note",
    "Model": "ELUGA Note"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "FZ-A1",
    "Device": "toughpad",
    "Model": "FZ-A1B"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "FZ-A1B",
    "Device": "toughpad",
    "Model": "FZ-A1B"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "FZ-A2A",
    "Device": "fz_a2a",
    "Model": "FZ-A2A"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "FZ-A3",
    "Device": "FZ-A3",
    "Model": "FZ-A3"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "FZ-B2",
    "Device": "fz_b2bb",
    "Model": "FZ-B2B"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "FZ-B2D",
    "Device": "fz_b2d",
    "Model": "FZ-B2D"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "FZ-L1",
    "Device": "FZ-L1",
    "Model": "FZ-L1"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "FZ-L1",
    "Device": "FZ-L1A",
    "Model": "FZ-L1"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "FZ-L1",
    "Device": "FZ-L1AN",
    "Model": "FZ-L1"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "FZ-L1",
    "Device": "FZ-L1AN_A",
    "Model": "FZ-L1"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "FZ-L1",
    "Device": "FZ-L1AUN_A",
    "Model": "FZ-L1"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "FZ-L1",
    "Device": "FZ-L1U",
    "Model": "FZ-L1"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "FZ-L1",
    "Device": "FZ-L1UN",
    "Model": "FZ-L1"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "FZ-L1UN",
    "Device": "FZ-L1UN",
    "Model": "FZ-L1 AOSP"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "FZ-N1",
    "Device": "FZ-N1",
    "Model": "FZ-N1"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "FZ-N1",
    "Device": "FZ-N1CL",
    "Model": "FZ-N1"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "FZ-N1",
    "Device": "FZ-N1E",
    "Model": "FZ-N1"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "FZ-N1",
    "Device": "FZ-N1EVF",
    "Model": "FZ-N1"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "FZ-N1",
    "Device": "FZ-N1EVU",
    "Model": "FZ-N1"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "FZ-N1",
    "Device": "FZ-N1F",
    "Model": "FZ-N1"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "FZ-N1",
    "Device": "FZ-N1VU",
    "Model": "FZ-N1"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "FZ-N1",
    "Device": "FZ-N1VUC",
    "Model": "FZ-N1"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "FZ-N1",
    "Device": "FZ-N1VUCCL",
    "Model": "FZ-N1"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "FZ-N1",
    "Device": "FZ-N1VUCF",
    "Model": "FZ-N1"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "FZ-N1",
    "Device": "FZ-N1VUF",
    "Model": "FZ-N1"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "FZ-N1EVF",
    "Device": "FZ-N1EVF",
    "Model": "FZ-N1"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "FZ-N1EVFE",
    "Device": "FZ-N1EVFE",
    "Model": "FZ-N1"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "FZ-N1F",
    "Device": "FZ-N1F",
    "Model": "FZ-N1"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "FZ-N1VU",
    "Device": "FZ-N1VU",
    "Model": "FZ-N1"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "FZ-S1",
    "Device": "FZ-S1",
    "Model": "FZ-S1"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "FZ-T1",
    "Device": "FZ-T1A",
    "Model": "FZ-T1"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "FZ-T1",
    "Device": "FZ-T1AN",
    "Model": "FZ-T1"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "FZ-T1",
    "Device": "FZ-T1EAN",
    "Model": "FZ-T1"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "FZ-T1",
    "Device": "FZ-T1EUN",
    "Model": "FZ-T1"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "FZ-T1",
    "Device": "FZ-T1VUN",
    "Model": "FZ-T1"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "FZ-T1",
    "Device": "FZ-T1VUN",
    "Model": "FZ-T1 AOSP"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "FZ-T1AN",
    "Device": "FZ-T1AN",
    "Model": "FZ-T1"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "FZ-T1EUN",
    "Device": "FZ-T1EUN",
    "Model": "FZ-T1"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "FZ-T1VUN",
    "Device": "FZ-T1VUN",
    "Model": "FZ-T1"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "FZ-X1",
    "Device": "FZ-X1",
    "Model": "FZ-X1"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "FZ-X1",
    "Device": "FZ-X1VU",
    "Model": "FZ-X1"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "FZ-X1",
    "Device": "FZ-X1VUC",
    "Model": "FZ-X1"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "GS655",
    "Device": "shibuya",
    "Model": "GS655"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "GX600C",
    "Device": "GX600C",
    "Model": "GX600C"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "GX655",
    "Device": "SW3H_ATV",
    "Model": "GX655"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "GX655",
    "Device": "SW3_ATV",
    "Model": "GX655"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "GX655",
    "Device": "SW3_ATV",
    "Model": "PanasonicTV"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "GX700C",
    "Device": "GX700C",
    "Model": "GX700C"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "GX880C",
    "Device": "GX01C",
    "Model": "GX01C"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "GZ1000",
    "Device": "GZ01C",
    "Model": "GZ01C"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "HDPSEB v2",
    "Device": "HDPSEBv2",
    "Model": "HD PSEB v2"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "HDPSEB v3",
    "Device": "HDPSEBv3",
    "Model": "HD PSEB v3"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "HDPSEB v4",
    "Device": "HDPSEBv4",
    "Model": "HD PSEB v4"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "IPSC 1.5",
    "Device": "ipsc1_5",
    "Model": "IPSC1_5"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "IPSC 4",
    "Device": "ipsc4",
    "Model": "IPSC4"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "JT-B1",
    "Device": "B1",
    "Model": "JT-B1"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "JT-C52",
    "Device": "JT-C52",
    "Model": "JT-C52"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "JT-C60",
    "Device": "JT-C60",
    "Model": "JT-C60"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "JX700C",
    "Device": "JX700C",
    "Model": "Panasonic_TV"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "JX900C",
    "Device": "JX900C",
    "Model": "Panasonic_TV"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "KT",
    "Device": "LH_ETRXND",
    "Model": "Panasonic_IFPD"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "KX-PRXA10",
    "Device": "KX-PRXA10",
    "Model": "Panasonic KX-PRXA10"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "KX-PRXA15",
    "Device": "KX-PRXA15",
    "Model": "Panasonic KX-PRXA15"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "LH_86CT8NDCM",
    "Device": "RK3576",
    "Model": "LH_86CT8NDCM"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "LH_CTR",
    "Device": "MTK9679",
    "Model": "LH_CTR"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "LUMIX CM1",
    "Device": "DMC-CM1",
    "Model": "DMC-CM1"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "NEXT Crew Terminal - AutoChip",
    "Device": "NEXT820",
    "Model": "NEXT"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "NEXT Crew Terminal - IoT Chip",
    "Device": "NEXT821",
    "Model": "NEXT"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "NEXT Eco4K 12",
    "Device": "NEXT821",
    "Model": "NEXT"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "NEXT Elite-4K 16",
    "Device": "NEXT820",
    "Model": "NEXT"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "NEXT Elite-4K 24",
    "Device": "NEXT820",
    "Model": "NEXT"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "NEXT Elite-4K 43",
    "Device": "NEXT820",
    "Model": "NEXT"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "NEXT Premium Hand-Set (PHS)",
    "Device": "NEXT821",
    "Model": "NEXT"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "NEXT Theater-4K 24",
    "Device": "NEXT821",
    "Model": "NEXT"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "NEXT_WSCUwscu",
    "Device": "NEXT820",
    "Model": "NEXT"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "P-01D",
    "Device": "pana2_1",
    "Model": "P-01D"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "P-01K",
    "Device": "P-01K",
    "Model": "P-01K"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "P-02D",
    "Device": "pana2_2",
    "Model": "P-02D"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "P-04D",
    "Device": "pana2_4d",
    "Model": "P-04D"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "P-05D",
    "Device": "pana2_4a",
    "Model": "P-05D"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "P-07C",
    "Device": "pana1",
    "Model": "P-07C"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "P11",
    "Device": "P11",
    "Model": "Panasonic P11"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "P31",
    "Device": "P31",
    "Model": "Panasonic P31"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "P41",
    "Device": "P41",
    "Model": "Panasonic P41"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "P41 HD",
    "Device": "P41HD",
    "Model": "Panasonic P41HD"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "P51",
    "Device": "P51",
    "Model": "Panasonic P51"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "P55",
    "Device": "P55",
    "Model": "Panasonic P55"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "P55 Max",
    "Device": "P55_Max",
    "Model": "P55 Max"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "P55 Novo",
    "Device": "P55_Novo",
    "Model": "Panasonic P55 Novo"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "P55 Novo",
    "Device": "P55_Novo_4G",
    "Model": "P55 Novo 4G"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "P6",
    "Device": "P6",
    "Model": "Panasonic P6"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "P6",
    "Device": "P6_O",
    "Model": "Panasonic P6"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "P61",
    "Device": "P61",
    "Model": "Panasonic P61"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "P61",
    "Device": "P61",
    "Model": "Panasonic_P61"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "P66",
    "Device": "P66",
    "Model": "P66"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "P71",
    "Device": "P71",
    "Model": "P71"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "P75",
    "Device": "P75",
    "Model": "Panasonic P75"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "P77",
    "Device": "P77",
    "Model": "Panasonic P77"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "P81",
    "Device": "P81",
    "Model": "Panasonic P81"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "P85",
    "Device": "P85",
    "Model": "Panasonic P85"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "P88",
    "Device": "P88",
    "Model": "P88"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "P9",
    "Device": "P9",
    "Model": "P9"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "P91",
    "Device": "P91",
    "Model": "P91"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "P99",
    "Device": "Panasonic_P99",
    "Model": "Panasonic P99"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "POE-SMB400-PS1",
    "Device": "kadoma",
    "Model": "POE-SMB400-PS1"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "Panasonic",
    "Device": "Jupiter",
    "Model": "4KTV-JUP"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "Panasonic 2021 UHD Android TV",
    "Device": "OD0M_EA_T32",
    "Model": "Panasonic 2021 UHD Android TV"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "Panasonic 2021 UHD Android TV",
    "Device": "OD0M_EA_T32",
    "Model": "Panasonic UHD TV"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "Panasonic P100",
    "Device": "P100",
    "Model": "P100"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "Panasonic P100",
    "Device": "P100",
    "Model": "Panasonic P100"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "Panasonic P101",
    "Device": "P101",
    "Model": "P101"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "Panasonic P110",
    "Device": "Panasonic_P110",
    "Model": "Panasonic P110"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "Panasonic P55 NXT",
    "Device": "P55Nxt",
    "Model": "Panasonic P55 NXT"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "Panasonic P7",
    "Device": "Panasonic_P7",
    "Model": "Panasonic P7"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "Panasonic P85 NXT",
    "Device": "P85Nxt",
    "Model": "Panasonic P85 NXT"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "Panasonic P90",
    "Device": "Panasonic_P90",
    "Model": "Panasonic P90"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "Panasonic P90 3G",
    "Device": "Panasonic_P90_3G",
    "Model": "Panasonic P90 3G"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "Panasonic P95",
    "Device": "P95",
    "Model": "Panasonic P95"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "Panasonic T70",
    "Device": "T70",
    "Model": "Panasonic T70"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "Panasonic TV",
    "Device": "SW3H_ATV",
    "Model": "GX655"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "R3",
    "Device": "R3",
    "Model": "2KTV-2TH"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "R3_GTV",
    "Device": "",
    "Model": ""
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "R3_GTV",
    "Device": "R3_GTV",
    "Model": "2KTV-3MH"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "R4",
    "Device": "R4",
    "Model": "PANASONIC TV"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "R4_GTV",
    "Device": "R4_GTV",
    "Model": "4KTV-3MUP"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "RSE1708",
    "Device": "RSE1708",
    "Model": "RSE1708"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "SDU",
    "Device": "SDU",
    "Model": "9 inch SDU"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "SDU",
    "Device": "SDU",
    "Model": "SDU"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "SM17",
    "Device": "SM17",
    "Model": "Smart Monitor 17"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "SMLK2A",
    "Device": "SMLK2A",
    "Model": "SMLK2A"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "SPU-A05-SWG",
    "Device": "SPU-A05-SWG",
    "Model": "SPU-A05-SWG"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "SPU-A06L-LWG",
    "Device": "SPU-A06L-LWG",
    "Model": "SPU-A06L-LWG"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "SPU-A07-LSG",
    "Device": "SPU-A07-LSG",
    "Model": "SPU-A07-LSG"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "SV-ME1000",
    "Device": "K1",
    "Model": "Panasonic SV-ME1000"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "SmartTVBox",
    "Device": "C01AS",
    "Model": "SMARTTVBOX"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "T11",
    "Device": "T11",
    "Model": "Panasonic T11"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "T21",
    "Device": "T21",
    "Model": "Panasonic T21"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "T30",
    "Device": "T30",
    "Model": "Panasonic T30"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "T31",
    "Device": "T31",
    "Model": "Panasonic T31"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "T33",
    "Device": "T33",
    "Model": "Panasonic T33"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "T40",
    "Device": "T40",
    "Model": "Panasonic T40"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "T41",
    "Device": "T41",
    "Model": "Panasonic T41"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "T44",
    "Device": "T44",
    "Model": "Panasonic T44"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "T44 Lite",
    "Device": "T44-Lite",
    "Model": "Panasonic T44 Lite"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "T9",
    "Device": "T9",
    "Model": "Panasonic T9"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "TAB-A01",
    "Device": "TAB-A01",
    "Model": "TAB-A01-SD"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "TAB-A02",
    "Device": "TAB-A02",
    "Model": "TAB-A02-SD"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "TAB-A05-BA1",
    "Device": "TAB-A05-BA1",
    "Model": "TAB-A05-BA1"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "TAB-A05-EA",
    "Device": "TAB-A05-EA",
    "Model": "TAB-A05-EA"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "TAB-A05-SA",
    "Device": "TAB-A05",
    "Model": "TAB-A05"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "TAB-A05-SA2",
    "Device": "TAB-A05-SA2",
    "Model": "TAB-A05-SA2"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "TH-43JX580C",
    "Device": "Panasonic_848",
    "Model": "4S806_Z31S"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "TH-49DX400C",
    "Device": "DX00C",
    "Model": "DX00C"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "TH-55DR600C",
    "Device": "TH55DR600C",
    "Model": "TH55DR600C"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "TH-55DX700C",
    "Device": "TH_55DX700C",
    "Model": "TH_55DX700C"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "TH-65DR800C",
    "Device": "TH-65DR800C",
    "Model": "TH-65DR800C"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "TH-65DX400C",
    "Device": "TH_65DX400C",
    "Model": "TH_65DX400C"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "Tab 8",
    "Device": "Tab_8",
    "Model": "Tab 8"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "Theater v3",
    "Device": "theaterv3",
    "Model": "theaterv3"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "Theater12",
    "Device": "Theater12",
    "Model": "Theater"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "Translation device",
    "Device": "WA-P7",
    "Model": "WA-P7"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "UN-MT300",
    "Device": "A1",
    "Model": "Panasonic UN-MT300"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "UN-W700",
    "Device": "F1",
    "Model": "Panasonic UN-W700"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "VHS v2",
    "Device": "VHS",
    "Model": "Video Handset"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "VTSH v1",
    "Device": "VTSHv1",
    "Model": "VTSH v1"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "WSCU",
    "Device": "wscu",
    "Model": "WSCU3"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "Yaris M",
    "Device": "T31",
    "Model": "Panasonic T31"
  },
  {
    "Retail Branding": "Panasonic",
    "Marketing Name": "fz_b2dh",
    "Device": "fz_b2d",
    "Model": "FZ-B2D"
  },
  {
    "Retail Branding": "Panavox",
    "Marketing Name": "50 google tv/58 google tv/65 google tv/75 google tv",
    "Device": "songshan",
    "Model": "SmartTV 4K"
  },
  {
    "Retail Branding": "Panavox",
    "Marketing Name": "Panavox Android TV",
    "Device": "lushan",
    "Model": "Panavox Android TV"
  },
  {
    "Retail Branding": "Panavox",
    "Marketing Name": "fushan_panavox",
    "Device": "hamamatsucho",
    "Model": "Panavox Android TV"
  },
  {
    "Retail Branding": "Panavox",
    "Marketing Name": "xiaoyushan_panavox",
    "Device": "xiaoyushan",
    "Model": "Panavox Android TV"
  },
  {
    "Retail Branding": "Panodic",
    "Marketing Name": "IPHDCK16H",
    "Device": "IPHDCK16H",
    "Model": "IPHDCK16H"
  },
  {
    "Retail Branding": "Pantech",
    "Marketing Name": "ADR910L",
    "Device": "ADR910L",
    "Model": "ADR910L"
  },
  {
    "Retail Branding": "Pantech",
    "Marketing Name": "ADR930L",
    "Device": "ADR930L",
    "Model": "ADR930L"
  },
  {
    "Retail Branding": "Pantech",
    "Marketing Name": "AT1",
    "Device": "at1",
    "Model": "IM-T100K"
  },
  {
    "Retail Branding": "Pantech",
    "Marketing Name": "Apache",
    "Device": "ADR8995",
    "Model": "ADR8995"
  },
  {
    "Retail Branding": "Pantech",
    "Marketing Name": "Burst",
    "Device": "presto",
    "Model": "PantechP9070"
  },
  {
    "Retail Branding": "Pantech",
    "Marketing Name": "Crossover",
    "Device": "moon",
    "Model": "PantechP8000"
  },
  {
    "Retail Branding": "Pantech",
    "Marketing Name": "EF33S",
    "Device": "ef33s",
    "Model": "IM-A760S"
  },
  {
    "Retail Branding": "Pantech",
    "Marketing Name": "EF34K",
    "Device": "ef34k",
    "Model": "IM-A770K"
  },
  {
    "Retail Branding": "Pantech",
    "Marketing Name": "EF35L",
    "Device": "ef35l",
    "Model": "IM-A780L"
  },
  {
    "Retail Branding": "Pantech",
    "Marketing Name": "Element",
    "Device": "pororo",
    "Model": "PantechP4100"
  },
  {
    "Retail Branding": "Pantech",
    "Marketing Name": "Flex",
    "Device": "oscar",
    "Model": "PantechP8010"
  },
  {
    "Retail Branding": "Pantech",
    "Marketing Name": "IM-100GN",
    "Device": "ef71g",
    "Model": "IM-100GN"
  },
  {
    "Retail Branding": "Pantech",
    "Marketing Name": "IM-100K",
    "Device": "ef71k",
    "Model": "IM-100K"
  },
  {
    "Retail Branding": "Pantech",
    "Marketing Name": "IM-100S",
    "Device": "ef71s",
    "Model": "IM-100S"
  },
  {
    "Retail Branding": "Pantech",
    "Marketing Name": "IM-810K",
    "Device": "ef40k",
    "Model": "IM-A810K"
  },
  {
    "Retail Branding": "Pantech",
    "Marketing Name": "IM-840SP",
    "Device": "IM-A840SP",
    "Model": "IM-A840SP"
  },
  {
    "Retail Branding": "Pantech",
    "Marketing Name": "IM-A730S",
    "Device": "ef30s",
    "Model": "IM-A730S"
  },
  {
    "Retail Branding": "Pantech",
    "Marketing Name": "IM-A740S",
    "Device": "ef31s",
    "Model": "IM-A740S"
  },
  {
    "Retail Branding": "Pantech",
    "Marketing Name": "IM-A760S",
    "Device": "ef33s",
    "Model": "IM-A760S"
  },
  {
    "Retail Branding": "Pantech",
    "Marketing Name": "IM-A770K",
    "Device": "ef34k",
    "Model": "IM-A770K"
  },
  {
    "Retail Branding": "Pantech",
    "Marketing Name": "IM-A775C",
    "Device": "ef34c",
    "Model": "IM-A775C"
  },
  {
    "Retail Branding": "Pantech",
    "Marketing Name": "IM-A780L",
    "Device": "ef35l",
    "Model": "IM-A780L"
  },
  {
    "Retail Branding": "Pantech",
    "Marketing Name": "IM-A800S",
    "Device": "ef39s",
    "Model": "IM-A800S"
  },
  {
    "Retail Branding": "Pantech",
    "Marketing Name": "IM-A810K",
    "Device": "ef40k",
    "Model": "IM-A810K"
  },
  {
    "Retail Branding": "Pantech",
    "Marketing Name": "IM-A810S",
    "Device": "ef40s",
    "Model": "IM-A810S"
  },
  {
    "Retail Branding": "Pantech",
    "Marketing Name": "IM-A830K",
    "Device": "ef45k",
    "Model": "IM-A830K"
  },
  {
    "Retail Branding": "Pantech",
    "Marketing Name": "IM-A830KE",
    "Device": "ef45kv",
    "Model": "IM-A830KE"
  },
  {
    "Retail Branding": "Pantech",
    "Marketing Name": "IM-A830L",
    "Device": "ef46l",
    "Model": "IM-A830L"
  },
  {
    "Retail Branding": "Pantech",
    "Marketing Name": "IM-A830S",
    "Device": "ef47s",
    "Model": "IM-A830S"
  },
  {
    "Retail Branding": "Pantech",
    "Marketing Name": "IM-A840S",
    "Device": "IM-A840S",
    "Model": "IM-A840S"
  },
  {
    "Retail Branding": "Pantech",
    "Marketing Name": "IM-A850K",
    "Device": "ef49k",
    "Model": "IM-A850K"
  },
  {
    "Retail Branding": "Pantech",
    "Marketing Name": "IM-A850L",
    "Device": "ef50l",
    "Model": "IM-A850L"
  },
  {
    "Retail Branding": "Pantech",
    "Marketing Name": "IM-A850S",
    "Device": "ef48s",
    "Model": "IM-A850S"
  },
  {
    "Retail Branding": "Pantech",
    "Marketing Name": "IM-A860K",
    "Device": "ef51k",
    "Model": "IM-A860K"
  },
  {
    "Retail Branding": "Pantech",
    "Marketing Name": "IM-A860L",
    "Device": "ef51l",
    "Model": "IM-A860L"
  },
  {
    "Retail Branding": "Pantech",
    "Marketing Name": "IM-A860S",
    "Device": "ef51s",
    "Model": "IM-A860S"
  },
  {
    "Retail Branding": "Pantech",
    "Marketing Name": "IM-A870K",
    "Device": "ef52k",
    "Model": "IM-A870K"
  },
  {
    "Retail Branding": "Pantech",
    "Marketing Name": "IM-A870L",
    "Device": "ef52l",
    "Model": "IM-A870L"
  },
  {
    "Retail Branding": "Pantech",
    "Marketing Name": "IM-A870S",
    "Device": "ef52s",
    "Model": "IM-A870S"
  },
  {
    "Retail Branding": "Pantech",
    "Marketing Name": "IM-A880S",
    "Device": "EF56S",
    "Model": "IM-A880S"
  },
  {
    "Retail Branding": "Pantech",
    "Marketing Name": "IM-A910K",
    "Device": "ef63k",
    "Model": "IM-A910K"
  },
  {
    "Retail Branding": "Pantech",
    "Marketing Name": "IM-A910L",
    "Device": "ef63l",
    "Model": "IM-A910L"
  },
  {
    "Retail Branding": "Pantech",
    "Marketing Name": "IM-A910S",
    "Device": "ef63s",
    "Model": "IM-A910S"
  },
  {
    "Retail Branding": "Pantech",
    "Marketing Name": "IM-A920S",
    "Device": "ef65s",
    "Model": "IM-A920S"
  },
  {
    "Retail Branding": "Pantech",
    "Marketing Name": "IM-A940K",
    "Device": "ef65dk",
    "Model": "IM-A940K"
  },
  {
    "Retail Branding": "Pantech",
    "Marketing Name": "Izar",
    "Device": "sp33k",
    "Model": "SKY IM-A630K"
  },
  {
    "Retail Branding": "Pantech",
    "Marketing Name": "K-50",
    "Device": "K-50",
    "Model": "K-50"
  },
  {
    "Retail Branding": "Pantech",
    "Marketing Name": "MIRACH_J",
    "Device": "mirachj",
    "Model": "EIS01PT"
  },
  {
    "Retail Branding": "Pantech",
    "Marketing Name": "MIRACH_J",
    "Device": "mirachj",
    "Model": "IS11PT"
  },
  {
    "Retail Branding": "Pantech",
    "Marketing Name": "Mirach",
    "Device": "ef13l",
    "Model": "IM-A690L"
  },
  {
    "Retail Branding": "Pantech",
    "Marketing Name": "Mirach",
    "Device": "ef13s",
    "Model": "IM-A690S"
  },
  {
    "Retail Branding": "Pantech",
    "Marketing Name": "Mirach A",
    "Device": "ef32k",
    "Model": "IM-A750K"
  },
  {
    "Retail Branding": "Pantech",
    "Marketing Name": "P9090",
    "Device": "magnus",
    "Model": "PantechP9090"
  },
  {
    "Retail Branding": "Pantech",
    "Marketing Name": "PLANET",
    "Device": "mini",
    "Model": "PLANET"
  },
  {
    "Retail Branding": "Pantech",
    "Marketing Name": "PTL21",
    "Device": "maruko",
    "Model": "PTL21"
  },
  {
    "Retail Branding": "Pantech",
    "Marketing Name": "Pocket",
    "Device": "mini",
    "Model": "PantechP9060"
  },
  {
    "Retail Branding": "Pantech",
    "Marketing Name": "SIRIUS α",
    "Device": "jmasai",
    "Model": "IS06"
  },
  {
    "Retail Branding": "Pantech",
    "Marketing Name": "Sirius",
    "Device": "ef10s",
    "Model": "SKY IM-A600S"
  },
  {
    "Retail Branding": "Pantech",
    "Marketing Name": "V955",
    "Device": "HS8929QC",
    "Model": "Pantech V955"
  },
  {
    "Retail Branding": "Pantech",
    "Marketing Name": "VEGA RACER",
    "Device": "ef34k",
    "Model": "IM-A770K"
  },
  {
    "Retail Branding": "Pantech",
    "Marketing Name": "VEGA RACER",
    "Device": "ef35l",
    "Model": "IM-A780L"
  },
  {
    "Retail Branding": "Pantech",
    "Marketing Name": "VEGA Secret Note",
    "Device": "EF59K",
    "Model": "IM-A890K"
  },
  {
    "Retail Branding": "Pantech",
    "Marketing Name": "VEGA Secret Note",
    "Device": "EF59L",
    "Model": "IM-A890L"
  },
  {
    "Retail Branding": "Pantech",
    "Marketing Name": "VEGA Secret Note",
    "Device": "EF59S",
    "Model": "IM-A890S"
  },
  {
    "Retail Branding": "Pantech",
    "Marketing Name": "VEGA Secret UP",
    "Device": "EF60S",
    "Model": "IM-A900S"
  },
  {
    "Retail Branding": "Pantech",
    "Marketing Name": "VEGA Secret UP",
    "Device": "EF61K",
    "Model": "IM-A900K"
  },
  {
    "Retail Branding": "Pantech",
    "Marketing Name": "VEGA Secret UP",
    "Device": "EF62L",
    "Model": "IM-A900L"
  },
  {
    "Retail Branding": "Pantech",
    "Marketing Name": "VEGA Secret UP",
    "Device": "ef60s",
    "Model": "IM-A900S"
  },
  {
    "Retail Branding": "Pantech",
    "Marketing Name": "VEGA Secret UP",
    "Device": "ef61k",
    "Model": "IM-A900K"
  },
  {
    "Retail Branding": "Pantech",
    "Marketing Name": "VEGA Secret UP",
    "Device": "ef62l",
    "Model": "IM-A900L"
  },
  {
    "Retail Branding": "Pantech",
    "Marketing Name": "Vega",
    "Device": "ef12s",
    "Model": "SKY IM-A650S"
  },
  {
    "Retail Branding": "Pantech",
    "Marketing Name": "Vega LTE M",
    "Device": "ef65l",
    "Model": "IM-A820L"
  },
  {
    "Retail Branding": "Pantech",
    "Marketing Name": "Vega X",
    "Device": "ef14l",
    "Model": "IM-A720L"
  },
  {
    "Retail Branding": "Pantech",
    "Marketing Name": "Vega X",
    "Device": "ef18k",
    "Model": "IM-A710K"
  },
  {
    "Retail Branding": "Pantech",
    "Marketing Name": "ef14lv",
    "Device": "ef14lv",
    "Model": "IM-A725L"
  },
  {
    "Retail Branding": "Pantech",
    "Marketing Name": "v950",
    "Device": "HS8929QC",
    "Model": "Pantech V950"
  },
  {
    "Retail Branding": "Pantech",
    "Marketing Name": "v955",
    "Device": "HS8929QC",
    "Model": "Pantech V955"
  },
  {
    "Retail Branding": "Parrot Mobile",
    "Marketing Name": "Prestige",
    "Device": "Prestige",
    "Model": "Prestige"
  },
  {
    "Retail Branding": "Parrot Mobile",
    "Marketing Name": "Xplorer_2",
    "Device": "Xplorer_2",
    "Model": "Xplorer_2"
  },
  {
    "Retail Branding": "Partner",
    "Marketing Name": "A5_2_R",
    "Device": "A5_2_R",
    "Model": "A5-2-R"
  },
  {
    "Retail Branding": "Partner",
    "Marketing Name": "Batman",
    "Device": "Batman",
    "Model": "S70PCI"
  },
  {
    "Retail Branding": "Partner",
    "Marketing Name": "E15 Pro",
    "Device": "E15_Pro",
    "Model": "E15 Pro"
  },
  {
    "Retail Branding": "Partner",
    "Marketing Name": "OT-310",
    "Device": "OT-310",
    "Model": "OT-310"
  },
  {
    "Retail Branding": "Partner",
    "Marketing Name": "PartnerTV BOX",
    "Device": "SEI800PNTV",
    "Model": "PartnerTV BOX"
  },
  {
    "Retail Branding": "Partner",
    "Marketing Name": "PartnerTV-Box",
    "Device": "uzw4054ptn",
    "Model": "PartnerTV-Box"
  },
  {
    "Retail Branding": "Partner",
    "Marketing Name": "Partner_Evolution",
    "Device": "Partner_Evolution",
    "Model": "Partner Evolution"
  },
  {
    "Retail Branding": "Partner",
    "Marketing Name": "S70PCI",
    "Device": "Batman",
    "Model": "S70PCI"
  },
  {
    "Retail Branding": "Pastigio",
    "Marketing Name": "P15",
    "Device": "M10T2_P15",
    "Model": "P15"
  },
  {
    "Retail Branding": "Pastigio",
    "Marketing Name": "SMY_17_M07R6_EEA",
    "Device": "SMY-17-M07R6",
    "Model": "SMY-17-M07R6"
  },
  {
    "Retail Branding": "Pavapro",
    "Marketing Name": "PavaPro7bk",
    "Device": "Pavapro7bk",
    "Model": "Pavapro7bk"
  },
  {
    "Retail Branding": "Pavapro",
    "Marketing Name": "Pavapro10",
    "Device": "Pavapro10bk",
    "Model": "Pavapro10bk"
  },
  {
    "Retail Branding": "Pebble Quad",
    "Marketing Name": "PTPC01",
    "Device": "PTPC01",
    "Model": "Pebble_Quad"
  },
  {
    "Retail Branding": "Pebble Quad",
    "Marketing Name": "PTPC02",
    "Device": "PTPC02",
    "Model": "PTPC02"
  },
  {
    "Retail Branding": "Pegatron",
    "Marketing Name": "",
    "Device": "Duke3G",
    "Model": "Android Tablet PC"
  },
  {
    "Retail Branding": "Pegatron",
    "Marketing Name": "",
    "Device": "DukeWifi",
    "Model": "Android Tablet PC"
  },
  {
    "Retail Branding": "Pegatron",
    "Marketing Name": "",
    "Device": "TabletPC",
    "Model": "Android Tablet PC"
  },
  {
    "Retail Branding": "Pegatron",
    "Marketing Name": "MaxiIQ",
    "Device": "MaxiIQ",
    "Model": "MaxiIQ"
  },
  {
    "Retail Branding": "Pegatron",
    "Marketing Name": "Olipad",
    "Device": "OP111",
    "Model": "chagall"
  },
  {
    "Retail Branding": "Pegatron",
    "Marketing Name": "chagall",
    "Device": "chagall",
    "Model": "Chagall 10.1 WiFi"
  },
  {
    "Retail Branding": "Pegatron",
    "Marketing Name": "chagall",
    "Device": "chagall",
    "Model": "E-Tab 4G"
  },
  {
    "Retail Branding": "Pegatron",
    "Marketing Name": "chagall",
    "Device": "chagall",
    "Model": "chagall"
  },
  {
    "Retail Branding": "Pendo",
    "Marketing Name": "PNDP70M10BLK",
    "Device": "PNDP70M10BLK",
    "Model": "PNDP70M10BLK"
  },
  {
    "Retail Branding": "Pendo",
    "Marketing Name": "Pendo",
    "Device": "PNDP70M7BLK",
    "Model": "PNDP70M7BLK"
  },
  {
    "Retail Branding": "Peninsula",
    "Marketing Name": "WP20",
    "Device": "WP20",
    "Model": "WP20"
  },
  {
    "Retail Branding": "Peninsula",
    "Marketing Name": "WP20N",
    "Device": "WP20N",
    "Model": "WP20N"
  },
  {
    "Retail Branding": "Penta",
    "Marketing Name": "ETBA0552",
    "Device": "PENTA_83AAQ2",
    "Model": "PENTA_83AAQ2"
  },
  {
    "Retail Branding": "Penta",
    "Marketing Name": "ETBA0692",
    "Device": "PENTA_73AAQ1",
    "Model": "PENTA_73AAQ1"
  },
  {
    "Retail Branding": "Penta",
    "Marketing Name": "PENTA_73AAQ1",
    "Device": "ETBA0604",
    "Model": "PENTA_73AAQ1"
  },
  {
    "Retail Branding": "PeopleLink",
    "Marketing Name": "AILiveBoard-Core",
    "Device": "AILiveBoard-Core",
    "Model": "AILiveBoard-Core"
  },
  {
    "Retail Branding": "Pepperl+Fuchs",
    "Marketing Name": "Smart-Ex 03",
    "Device": "Smart-Ex03",
    "Model": "Smart-Ex03"
  },
  {
    "Retail Branding": "Pepperl+Fuchs",
    "Marketing Name": "Smart-Ex 203",
    "Device": "Smart-Ex203",
    "Model": "Smart-Ex203"
  },
  {
    "Retail Branding": "Pepperl+Fuchs",
    "Marketing Name": "Tab-IND 10 AND",
    "Device": "Tab-IND10AND",
    "Model": "Tab-IND 10 AND"
  },
  {
    "Retail Branding": "Pepperl+Fuchs",
    "Marketing Name": "oona1W15",
    "Device": "oona1W15",
    "Model": "oona1W15"
  },
  {
    "Retail Branding": "Pepperl+Fuchs",
    "Marketing Name": "oona22",
    "Device": "oona2W22",
    "Model": "oona2W22"
  },
  {
    "Retail Branding": "Performance",
    "Marketing Name": "PR7RKTNF",
    "Device": "PR7RKTNF",
    "Model": "PR7RKTNF"
  },
  {
    "Retail Branding": "Performance",
    "Marketing Name": "T7",
    "Device": "T7",
    "Model": "T7"
  },
  {
    "Retail Branding": "Performance",
    "Marketing Name": "T9",
    "Device": "T9",
    "Model": "T9"
  },
  {
    "Retail Branding": "Permaray",
    "Marketing Name": "Permaray-IFPD",
    "Device": "DZ-RK3588",
    "Model": "Permaray-IFPD"
  },
  {
    "Retail Branding": "Perseo TV",
    "Marketing Name": "Perseo TV Home 2nd Generation Ranger",
    "Device": "DV8219",
    "Model": "Perseo TV Home 2nd Generation Ranger"
  },
  {
    "Retail Branding": "Philco",
    "Marketing Name": "Android TV",
    "Device": "ikebukuro",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "Philco",
    "Marketing Name": "Android TV",
    "Device": "sindorim",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "Philco",
    "Marketing Name": "HIT P10a",
    "Device": "HIT_P10a",
    "Model": "HIT P10a"
  },
  {
    "Retail Branding": "Philco",
    "Marketing Name": "HIT_P8",
    "Device": "HIT_P8",
    "Model": "HIT P8"
  },
  {
    "Retail Branding": "Philco",
    "Marketing Name": "Hit Max",
    "Device": "Hit_Max",
    "Model": "Hit Max"
  },
  {
    "Retail Branding": "Philco",
    "Marketing Name": "Hit P10",
    "Device": "Hit_P10",
    "Model": "Hit P10"
  },
  {
    "Retail Branding": "Philco",
    "Marketing Name": "Hit P12",
    "Device": "Hit_P12",
    "Model": "Hit P12"
  },
  {
    "Retail Branding": "Philco",
    "Marketing Name": "Hit P6",
    "Device": "Hit_P6",
    "Model": "Hit P6"
  },
  {
    "Retail Branding": "Philco",
    "Marketing Name": "P13",
    "Device": "Hit_P13",
    "Model": "Hit P13"
  },
  {
    "Retail Branding": "Philco",
    "Marketing Name": "PCS01",
    "Device": "PCS01",
    "Model": "PCS01"
  },
  {
    "Retail Branding": "Philco",
    "Marketing Name": "PCS02",
    "Device": "PCS02",
    "Model": "PCS02"
  },
  {
    "Retail Branding": "Philco",
    "Marketing Name": "PHILCO",
    "Device": "elliniko",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "Philco",
    "Marketing Name": "PHILCO",
    "Device": "zhongshan",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "Philco",
    "Marketing Name": "PHILCO Smart TV",
    "Device": "SW4H",
    "Model": "PHILCO Smart TV"
  },
  {
    "Retail Branding": "Philco",
    "Marketing Name": "PHILCO_TP7A6",
    "Device": "PHILCO_TP7A6",
    "Model": "TP7A6"
  },
  {
    "Retail Branding": "Philco",
    "Marketing Name": "PTB7PAP_ PTB7PAB _ PTB7PAR",
    "Device": "PTB7PA",
    "Model": "PTB7PAP_PTB7PAB_PTB7PAR"
  },
  {
    "Retail Branding": "Philco",
    "Marketing Name": "PTB7QSG_3G",
    "Device": "PTB7QSG_3G",
    "Model": "PTB7QSG_3G"
  },
  {
    "Retail Branding": "Philco",
    "Marketing Name": "PTB7R",
    "Device": "PTB7R",
    "Model": "PTB7R"
  },
  {
    "Retail Branding": "Philco",
    "Marketing Name": "PTB8R",
    "Device": "PTB8R",
    "Model": "PTB8R"
  },
  {
    "Retail Branding": "Philco",
    "Marketing Name": "PTB8R4G",
    "Device": "PTB8R4G",
    "Model": "PTB8R4G"
  },
  {
    "Retail Branding": "Philco",
    "Marketing Name": "Philco",
    "Device": "stanford",
    "Model": "PHILCO SMART"
  },
  {
    "Retail Branding": "Philco",
    "Marketing Name": "Philco Smart Plus TV",
    "Device": "anaheim",
    "Model": "Philco Smart Plus TV"
  },
  {
    "Retail Branding": "Philco",
    "Marketing Name": "Philco Smart TV",
    "Device": "sunnyvale",
    "Model": "Philco Smart TV"
  },
  {
    "Retail Branding": "Philco",
    "Marketing Name": "Philco Smart plus TV",
    "Device": "SW6H",
    "Model": "Philco Smart plus TV"
  },
  {
    "Retail Branding": "Philco",
    "Marketing Name": "PhilcoTV",
    "Device": "shinjuku",
    "Model": "PhilcoTV"
  },
  {
    "Retail Branding": "Philco",
    "Marketing Name": "Smart TV",
    "Device": "alimos",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "Philco",
    "Marketing Name": "Smart TV",
    "Device": "dangni",
    "Model": "AI PONT BR"
  },
  {
    "Retail Branding": "Philco",
    "Marketing Name": "TP10A332",
    "Device": "TP10A332",
    "Model": "TP10A332"
  },
  {
    "Retail Branding": "Philco",
    "Marketing Name": "TP10A3N",
    "Device": "TP10A3N",
    "Model": "TP10A3N"
  },
  {
    "Retail Branding": "Philco",
    "Marketing Name": "TP10A464",
    "Device": "TP10A464",
    "Model": "TP10A464"
  },
  {
    "Retail Branding": "Philco",
    "Marketing Name": "TP10F",
    "Device": "TP10F",
    "Model": "TP10F"
  },
  {
    "Retail Branding": "Philco",
    "Marketing Name": "TP7A464",
    "Device": "TP7A464",
    "Model": "TP7A464"
  },
  {
    "Retail Branding": "Philco",
    "Marketing Name": "TP7A464D",
    "Device": "TP7A464D",
    "Model": "TP7A464D"
  },
  {
    "Retail Branding": "Philco",
    "Marketing Name": "TP7A4BB",
    "Device": "TP7A4BB",
    "Model": "TP7A4BB"
  },
  {
    "Retail Branding": "Philco",
    "Marketing Name": "TP7A4N",
    "Device": "TP7A4N",
    "Model": "TP7A4N"
  },
  {
    "Retail Branding": "Philco",
    "Marketing Name": "TP7A6PI",
    "Device": "TP7A6PI",
    "Model": "TP7A6"
  },
  {
    "Retail Branding": "Philips",
    "Marketing Name": "",
    "Device": "Philips_GGC3",
    "Model": "SA3CNT"
  },
  {
    "Retail Branding": "Philips",
    "Marketing Name": "",
    "Device": "Philips_PI5000",
    "Model": "Philips_PI5000"
  },
  {
    "Retail Branding": "Philips",
    "Marketing Name": "",
    "Device": "SA2CNTxx",
    "Model": "Philips GoGear Connect"
  },
  {
    "Retail Branding": "Philips",
    "Marketing Name": "2K Android TV",
    "Device": "gotanda",
    "Model": "FHD Android TV"
  },
  {
    "Retail Branding": "Philips",
    "Marketing Name": "2K Android TV",
    "Device": "takao",
    "Model": "2020 FHD Android TV"
  },
  {
    "Retail Branding": "Philips",
    "Marketing Name": "4K & Full HD Slim LED TV powered by Android™",
    "Device": "philips_MT5593FHT_EU",
    "Model": "QM152E"
  },
  {
    "Retail Branding": "Philips",
    "Marketing Name": "4K & Full HD Slim LED TV powered by Android™",
    "Device": "philips_MT5593HT_LT",
    "Model": "QM152E"
  },
  {
    "Retail Branding": "Philips",
    "Marketing Name": "4K LED TV powered by Android",
    "Device": "PH7M_EU_5596",
    "Model": "TPM171E"
  },
  {
    "Retail Branding": "Philips",
    "Marketing Name": "4K OLED TV powered by Android",
    "Device": "PH7M_LT_5596",
    "Model": "TPM171E"
  },
  {
    "Retail Branding": "Philips",
    "Marketing Name": "4K Razor Slim LED TV powered by Android TV™",
    "Device": "MT5593Uplus",
    "Model": "QM151E"
  },
  {
    "Retail Branding": "Philips",
    "Marketing Name": "4K Razor Slim OLED TV powered by Android TV",
    "Device": "QM16XE_UB",
    "Model": "QM161E"
  },
  {
    "Retail Branding": "Philips",
    "Marketing Name": "4K UHD Razor Slim LED TV powered by Android™",
    "Device": "QV151E",
    "Model": "QV151E"
  },
  {
    "Retail Branding": "Philips",
    "Marketing Name": "4K Ultra Slim LED TV powered by Android",
    "Device": "QM16XE_U",
    "Model": "QM163E"
  },
  {
    "Retail Branding": "Philips",
    "Marketing Name": "65BDL4152E",
    "Device": "65BDL4152E",
    "Model": "BDL4152E"
  },
  {
    "Retail Branding": "Philips",
    "Marketing Name": "Android 2014",
    "Device": "philipstv",
    "Model": "AND1E"
  },
  {
    "Retail Branding": "Philips",
    "Marketing Name": "BDL4252E",
    "Device": "rk3576_u",
    "Model": "BDL4252E"
  },
  {
    "Retail Branding": "Philips",
    "Marketing Name": "E1027",
    "Device": "E1027",
    "Model": "E1027"
  },
  {
    "Retail Branding": "Philips",
    "Marketing Name": "Essence 11",
    "Device": "PHILIPS-S6211",
    "Model": "PHILIPS S6211"
  },
  {
    "Retail Branding": "Philips",
    "Marketing Name": "Essence 21",
    "Device": "PHILIPS-S6311",
    "Model": "PHILIPS S6311"
  },
  {
    "Retail Branding": "Philips",
    "Marketing Name": "FHD Ultra Slim LED TV Powered by Android",
    "Device": "QM16XE_F",
    "Model": "QM164E"
  },
  {
    "Retail Branding": "Philips",
    "Marketing Name": "HMP8100/93",
    "Device": "HMP8100_ATV_93",
    "Model": "HMP8100_ATV_93"
  },
  {
    "Retail Branding": "Philips",
    "Marketing Name": "HMP8100/98",
    "Device": "HMP8100_ATV",
    "Model": "HMP8100_ATV_INT"
  },
  {
    "Retail Branding": "Philips",
    "Marketing Name": "Mediasuite",
    "Device": "PH8M_HE_5596",
    "Model": "TPM181HE"
  },
  {
    "Retail Branding": "Philips",
    "Marketing Name": "Mediasuite",
    "Device": "PH8M_HE_5596",
    "Model": "TPM191HN"
  },
  {
    "Retail Branding": "Philips",
    "Marketing Name": "NeoViu D1",
    "Device": "GMP",
    "Model": "NeoViu D1"
  },
  {
    "Retail Branding": "Philips",
    "Marketing Name": "OmniTab 1",
    "Device": "T8010",
    "Model": "T8010"
  },
  {
    "Retail Branding": "Philips",
    "Marketing Name": "PFT6130",
    "Device": "umeda",
    "Model": "PFT6130"
  },
  {
    "Retail Branding": "Philips",
    "Marketing Name": "PHILIPS",
    "Device": "TLE722G",
    "Model": "TLE722G"
  },
  {
    "Retail Branding": "Philips",
    "Marketing Name": "PHILIPS",
    "Device": "elliniko",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "Philips",
    "Marketing Name": "PHILIPS",
    "Device": "elliniko",
    "Model": "PHILIPS 4K SMART TV"
  },
  {
    "Retail Branding": "Philips",
    "Marketing Name": "PHILIPS",
    "Device": "hongkong",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "Philips",
    "Marketing Name": "PHILIPS",
    "Device": "hongkong",
    "Model": "4K SMART TV PH"
  },
  {
    "Retail Branding": "Philips",
    "Marketing Name": "PHILIPS",
    "Device": "jagalchi",
    "Model": "2K SMART TV"
  },
  {
    "Retail Branding": "Philips",
    "Marketing Name": "PHILIPS",
    "Device": "khardi",
    "Model": "4K SMART ISDB TV"
  },
  {
    "Retail Branding": "Philips",
    "Marketing Name": "PHILIPS",
    "Device": "khardi",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "Philips",
    "Marketing Name": "PHILIPS",
    "Device": "lavender",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "Philips",
    "Marketing Name": "PHILIPS",
    "Device": "lavender",
    "Model": "4K SMART TV PH"
  },
  {
    "Retail Branding": "Philips",
    "Marketing Name": "PHILIPS",
    "Device": "mountbaker",
    "Model": "2K SMART TV"
  },
  {
    "Retail Branding": "Philips",
    "Marketing Name": "PHILIPS",
    "Device": "mountbaker",
    "Model": "2K SMART TV PH"
  },
  {
    "Retail Branding": "Philips",
    "Marketing Name": "PHILIPS",
    "Device": "templeton",
    "Model": "EcoTV Ultra"
  },
  {
    "Retail Branding": "Philips",
    "Marketing Name": "PHILIPS S6210",
    "Device": "PHILIPS-S6210",
    "Model": "PHILIPS S6210"
  },
  {
    "Retail Branding": "Philips",
    "Marketing Name": "PHILIPS S6210T",
    "Device": "PHILIPS-S6210T",
    "Model": "PHILIPS S6210T"
  },
  {
    "Retail Branding": "Philips",
    "Marketing Name": "PHILIPS S6310",
    "Device": "PHILIPS-S6310",
    "Model": "PHILIPS S6310"
  },
  {
    "Retail Branding": "Philips",
    "Marketing Name": "PHILIPS S7710",
    "Device": "PHILIPS-S7710",
    "Model": "PHILIPS S7710"
  },
  {
    "Retail Branding": "Philips",
    "Marketing Name": "PHILIPS TV",
    "Device": "cocina",
    "Model": "PHILIPS TV"
  },
  {
    "Retail Branding": "Philips",
    "Marketing Name": "PHP-S221C4AFD",
    "Device": "MMD_WW",
    "Model": "G3SMNTS22"
  },
  {
    "Retail Branding": "Philips",
    "Marketing Name": "PHP-S231C4AFD",
    "Device": "G3SMNTS23",
    "Model": "G3SMNTS23"
  },
  {
    "Retail Branding": "Philips",
    "Marketing Name": "PI2000",
    "Device": "PI2000",
    "Model": "PI2000"
  },
  {
    "Retail Branding": "Philips",
    "Marketing Name": "PI2010",
    "Device": "PI2010",
    "Model": "PI2010"
  },
  {
    "Retail Branding": "Philips",
    "Marketing Name": "PI2011",
    "Device": "PI2011",
    "Model": "PI2011"
  },
  {
    "Retail Branding": "Philips",
    "Marketing Name": "PI3100/51",
    "Device": "PI3100_51",
    "Model": "PI3100"
  },
  {
    "Retail Branding": "Philips",
    "Marketing Name": "PI3100/58",
    "Device": "PI3100_58",
    "Model": "PI3100"
  },
  {
    "Retail Branding": "Philips",
    "Marketing Name": "PI3100/93",
    "Device": "PI3100_93",
    "Model": "PI3100-93"
  },
  {
    "Retail Branding": "Philips",
    "Marketing Name": "PI3100/98",
    "Device": "PI3100_98",
    "Model": "PI3100"
  },
  {
    "Retail Branding": "Philips",
    "Marketing Name": "PI3100Z3/93",
    "Device": "PI3100Z3_93",
    "Model": "PI3100Z3_93"
  },
  {
    "Retail Branding": "Philips",
    "Marketing Name": "PI3105",
    "Device": "PI3105",
    "Model": "PI3105"
  },
  {
    "Retail Branding": "Philips",
    "Marketing Name": "PI3106",
    "Device": "PI3106",
    "Model": "PI3106"
  },
  {
    "Retail Branding": "Philips",
    "Marketing Name": "PI3110",
    "Device": "PI3110",
    "Model": "PI3110"
  },
  {
    "Retail Branding": "Philips",
    "Marketing Name": "PI3205G",
    "Device": "PI3205G_93",
    "Model": "PI3205G"
  },
  {
    "Retail Branding": "Philips",
    "Marketing Name": "PI3210G",
    "Device": "PI3210G",
    "Model": "PI3210G"
  },
  {
    "Retail Branding": "Philips",
    "Marketing Name": "PI3900",
    "Device": "T7p_Duo_93",
    "Model": "PI3900-93"
  },
  {
    "Retail Branding": "Philips",
    "Marketing Name": "PI3900/51",
    "Device": "PI3900_51",
    "Model": "PI3900"
  },
  {
    "Retail Branding": "Philips",
    "Marketing Name": "PI3900/58",
    "Device": "PI3900_58",
    "Model": "PI3900"
  },
  {
    "Retail Branding": "Philips",
    "Marketing Name": "PI3900/98",
    "Device": "PI3900_98",
    "Model": "PI3900"
  },
  {
    "Retail Branding": "Philips",
    "Marketing Name": "PI3910",
    "Device": "PI3910",
    "Model": "PI3910"
  },
  {
    "Retail Branding": "Philips",
    "Marketing Name": "PI4010G",
    "Device": "PI4010G",
    "Model": "PI4010G"
  },
  {
    "Retail Branding": "Philips",
    "Marketing Name": "PI7100/93",
    "Device": "PI7100_93",
    "Model": "PI7100_93"
  },
  {
    "Retail Branding": "Philips",
    "Marketing Name": "PQT9030",
    "Device": "anaheim",
    "Model": "PQT9030"
  },
  {
    "Retail Branding": "Philips",
    "Marketing Name": "Philips Android TV",
    "Device": "PH0M_EA_T32",
    "Model": "2020/2021 FHD Android TV"
  },
  {
    "Retail Branding": "Philips",
    "Marketing Name": "Philips Android TV",
    "Device": "PH0M_EA_T32",
    "Model": "2020/2021 UHD Android TV"
  },
  {
    "Retail Branding": "Philips",
    "Marketing Name": "Philips Android TV",
    "Device": "PH0M_EA_T32",
    "Model": "Philips FHD Android TV"
  },
  {
    "Retail Branding": "Philips",
    "Marketing Name": "Philips Android TV",
    "Device": "PH0M_EA_T32",
    "Model": "Philips UHD Android TV"
  },
  {
    "Retail Branding": "Philips",
    "Marketing Name": "Philips Android TV",
    "Device": "PH1M_EA_9970A",
    "Model": "2021/22 Philips UHD Android TV"
  },
  {
    "Retail Branding": "Philips",
    "Marketing Name": "Philips Android TV",
    "Device": "PH9M_EA_5599",
    "Model": "TPM191E"
  },
  {
    "Retail Branding": "Philips",
    "Marketing Name": "Philips Android TV",
    "Device": "PH9M_EA_5599",
    "Model": "TPM191KN"
  },
  {
    "Retail Branding": "Philips",
    "Marketing Name": "Philips Android TV",
    "Device": "PH9M_EA_5599",
    "Model": "TPM191L"
  },
  {
    "Retail Branding": "Philips",
    "Marketing Name": "Philips Google TV TA1",
    "Device": "PH1M_WW_9972",
    "Model": "Philips Google TV TA1"
  },
  {
    "Retail Branding": "Philips",
    "Marketing Name": "Philips Google TV TA2",
    "Device": "PH1M_WW_9972",
    "Model": "Philips Google TV TA2"
  },
  {
    "Retail Branding": "Philips",
    "Marketing Name": "Philips Google TV TA5",
    "Device": "PH1M_WW_9972",
    "Model": "Philips Google TV TA5"
  },
  {
    "Retail Branding": "Philips",
    "Marketing Name": "Philips Google TV TA6",
    "Device": "kujo",
    "Model": "Philips Google TV TA6"
  },
  {
    "Retail Branding": "Philips",
    "Marketing Name": "Philips Google TV TA6",
    "Device": "kujo",
    "Model": "Philips Google TV TA6 LT"
  },
  {
    "Retail Branding": "Philips",
    "Marketing Name": "Philips Google TV TA7",
    "Device": "PH3M_AL_T32",
    "Model": "Philips Google TV TA7"
  },
  {
    "Retail Branding": "Philips",
    "Marketing Name": "Philips Google TV TB3",
    "Device": "PH1M_WW_9687",
    "Model": "Philips Google TV TB3"
  },
  {
    "Retail Branding": "Philips",
    "Marketing Name": "Philips S257",
    "Device": "S257",
    "Model": "Philips S257"
  },
  {
    "Retail Branding": "Philips",
    "Marketing Name": "Philips S260",
    "Device": "Philips_S260",
    "Model": "Philips_S260"
  },
  {
    "Retail Branding": "Philips",
    "Marketing Name": "Philips S310X",
    "Device": "Philips_S310X",
    "Model": "Philips S310X"
  },
  {
    "Retail Branding": "Philips",
    "Marketing Name": "Philips S318",
    "Device": "S318",
    "Model": "Philips S318"
  },
  {
    "Retail Branding": "Philips",
    "Marketing Name": "Philips S329",
    "Device": "Philips_S329",
    "Model": "Philips S329"
  },
  {
    "Retail Branding": "Philips",
    "Marketing Name": "Philips S337",
    "Device": "scx35_sp7731gea_hd",
    "Model": "Philips S337"
  },
  {
    "Retail Branding": "Philips",
    "Marketing Name": "Philips S338",
    "Device": "S338",
    "Model": "Philips S338"
  },
  {
    "Retail Branding": "Philips",
    "Marketing Name": "Philips S359",
    "Device": "S359",
    "Model": "Philips S359"
  },
  {
    "Retail Branding": "Philips",
    "Marketing Name": "Philips S369",
    "Device": "S369",
    "Model": "Philips S369"
  },
  {
    "Retail Branding": "Philips",
    "Marketing Name": "Philips S397",
    "Device": "Philips_S397",
    "Model": "S397"
  },
  {
    "Retail Branding": "Philips",
    "Marketing Name": "Philips S561",
    "Device": "S561",
    "Model": "Philips S561"
  },
  {
    "Retail Branding": "Philips",
    "Marketing Name": "Philips S562Z",
    "Device": "S562Z",
    "Model": "Philips S562Z"
  },
  {
    "Retail Branding": "Philips",
    "Marketing Name": "Philips S6206",
    "Device": "S6206",
    "Model": "S6206"
  },
  {
    "Retail Branding": "Philips",
    "Marketing Name": "Philips S6320T",
    "Device": "Philips-S6320T",
    "Model": "Philips S6320T"
  },
  {
    "Retail Branding": "Philips",
    "Marketing Name": "Philips S8310 EEA",
    "Device": "Philips_S8310",
    "Model": "Philips S8310"
  },
  {
    "Retail Branding": "Philips",
    "Marketing Name": "Philips S8320 EEA",
    "Device": "Philips_S8320",
    "Model": "Philips S8320"
  },
  {
    "Retail Branding": "Philips",
    "Marketing Name": "Philips S8325",
    "Device": "Philips_S8325",
    "Model": "Philips S8325"
  },
  {
    "Retail Branding": "Philips",
    "Marketing Name": "Philips Smart 2K TV",
    "Device": "beomil",
    "Model": "Philips Smart 2K TV"
  },
  {
    "Retail Branding": "Philips",
    "Marketing Name": "Philips SmartTV",
    "Device": "freesia",
    "Model": "PHILIPS 4K TV"
  },
  {
    "Retail Branding": "Philips",
    "Marketing Name": "Philips SmartTV",
    "Device": "freesia",
    "Model": "PHILIPS 4k TV"
  },
  {
    "Retail Branding": "Philips",
    "Marketing Name": "Philips V787",
    "Device": "Philips_Xenium_V787",
    "Model": "Philips Xenium V787"
  },
  {
    "Retail Branding": "Philips",
    "Marketing Name": "Philips X596",
    "Device": "X596",
    "Model": "Philips X596"
  },
  {
    "Retail Branding": "Philips",
    "Marketing Name": "Philips X598",
    "Device": "Philips_X598",
    "Model": "Philips X598"
  },
  {
    "Retail Branding": "Philips",
    "Marketing Name": "Philips X818",
    "Device": "X818_RU",
    "Model": "Philips X818"
  },
  {
    "Retail Branding": "Philips",
    "Marketing Name": "Philips-24NA-4K",
    "Device": "eleonas",
    "Model": "Philips-24NA-4K"
  },
  {
    "Retail Branding": "Philips",
    "Marketing Name": "Philips-Essence 01",
    "Device": "Philips-S6020",
    "Model": "Philips-S6020"
  },
  {
    "Retail Branding": "Philips",
    "Marketing Name": "Philps S398",
    "Device": "Philips_S398",
    "Model": "Philips S398"
  },
  {
    "Retail Branding": "Philips",
    "Marketing Name": "S221C3A",
    "Device": "MMD_WW",
    "Model": "G2SMNT"
  },
  {
    "Retail Branding": "Philips",
    "Marketing Name": "S308",
    "Device": "Philips_S308",
    "Model": "Philips S308"
  },
  {
    "Retail Branding": "Philips",
    "Marketing Name": "S309",
    "Device": "Philips",
    "Model": "Philips S309"
  },
  {
    "Retail Branding": "Philips",
    "Marketing Name": "S326",
    "Device": "S326",
    "Model": "Philips_S326"
  },
  {
    "Retail Branding": "Philips",
    "Marketing Name": "S327",
    "Device": "S327",
    "Model": "Philips S327"
  },
  {
    "Retail Branding": "Philips",
    "Marketing Name": "S337",
    "Device": "S337_AG",
    "Model": "Philips S337"
  },
  {
    "Retail Branding": "Philips",
    "Marketing Name": "S337",
    "Device": "S337_BG",
    "Model": "Philips S337"
  },
  {
    "Retail Branding": "Philips",
    "Marketing Name": "S337",
    "Device": "scx35_sp7731gea_hd",
    "Model": "Philips S337"
  },
  {
    "Retail Branding": "Philips",
    "Marketing Name": "S395",
    "Device": "S395",
    "Model": "Philips S395"
  },
  {
    "Retail Branding": "Philips",
    "Marketing Name": "S6122",
    "Device": "S6122",
    "Model": "S6122"
  },
  {
    "Retail Branding": "Philips",
    "Marketing Name": "S6133S",
    "Device": "S6133S",
    "Model": "S6133S"
  },
  {
    "Retail Branding": "Philips",
    "Marketing Name": "S7210",
    "Device": "S7210",
    "Model": "S7210"
  },
  {
    "Retail Branding": "Philips",
    "Marketing Name": "S7220",
    "Device": "S7220",
    "Model": "S7220"
  },
  {
    "Retail Branding": "Philips",
    "Marketing Name": "S8300",
    "Device": "S8300",
    "Model": "S8300"
  },
  {
    "Retail Branding": "Philips",
    "Marketing Name": "S8306",
    "Device": "S8306",
    "Model": "S8306"
  },
  {
    "Retail Branding": "Philips",
    "Marketing Name": "Smart TV",
    "Device": "dangni",
    "Model": "SWTV"
  },
  {
    "Retail Branding": "Philips",
    "Marketing Name": "Smart TV",
    "Device": "guui",
    "Model": "PHILIPS 4k TV"
  },
  {
    "Retail Branding": "Philips",
    "Marketing Name": "Smart TV",
    "Device": "hino",
    "Model": "PHILIPS TV"
  },
  {
    "Retail Branding": "Philips",
    "Marketing Name": "Smart TV",
    "Device": "queenstown",
    "Model": "Philips 4K A1"
  },
  {
    "Retail Branding": "Philips",
    "Marketing Name": "Smart TV",
    "Device": "sindap",
    "Model": "PHILIPS 4K TV"
  },
  {
    "Retail Branding": "Philips",
    "Marketing Name": "T7250",
    "Device": "T7250",
    "Model": "T7250"
  },
  {
    "Retail Branding": "Philips",
    "Marketing Name": "T7305L_EEA",
    "Device": "T7305L",
    "Model": "T7305L"
  },
  {
    "Retail Branding": "Philips",
    "Marketing Name": "T7305L_RU",
    "Device": "T7305L",
    "Model": "T7305L"
  },
  {
    "Retail Branding": "Philips",
    "Marketing Name": "T7305L_TU",
    "Device": "T7305L",
    "Model": "T7305L"
  },
  {
    "Retail Branding": "Philips",
    "Marketing Name": "T7305L_US",
    "Device": "T7305L",
    "Model": "T7305L"
  },
  {
    "Retail Branding": "Philips",
    "Marketing Name": "T7305_EEA",
    "Device": "T7305",
    "Model": "T7305"
  },
  {
    "Retail Branding": "Philips",
    "Marketing Name": "T7305_RU",
    "Device": "T7305",
    "Model": "T7305"
  },
  {
    "Retail Branding": "Philips",
    "Marketing Name": "T7305_TU",
    "Device": "T7305",
    "Model": "T7305"
  },
  {
    "Retail Branding": "Philips",
    "Marketing Name": "T7305_US",
    "Device": "T7305",
    "Model": "T7305"
  },
  {
    "Retail Branding": "Philips",
    "Marketing Name": "T7310_EEA",
    "Device": "T7310",
    "Model": "T7310"
  },
  {
    "Retail Branding": "Philips",
    "Marketing Name": "T7310_ROW",
    "Device": "T7310",
    "Model": "T7310"
  },
  {
    "Retail Branding": "Philips",
    "Marketing Name": "T7310_RU",
    "Device": "T7310",
    "Model": "T7310"
  },
  {
    "Retail Branding": "Philips",
    "Marketing Name": "T7310_TU",
    "Device": "T7310",
    "Model": "T7310"
  },
  {
    "Retail Branding": "Philips",
    "Marketing Name": "T7315",
    "Device": "T7315",
    "Model": "T7315"
  },
  {
    "Retail Branding": "Philips",
    "Marketing Name": "T7335",
    "Device": "T7335",
    "Model": "T7335"
  },
  {
    "Retail Branding": "Philips",
    "Marketing Name": "T8 PI7000",
    "Device": "Tablet_8",
    "Model": "PI7000"
  },
  {
    "Retail Branding": "Philips",
    "Marketing Name": "T8010A",
    "Device": "T8010A",
    "Model": "T8010A"
  },
  {
    "Retail Branding": "Philips",
    "Marketing Name": "T8015",
    "Device": "T8015",
    "Model": "T8015"
  },
  {
    "Retail Branding": "Philips",
    "Marketing Name": "T8015S",
    "Device": "T8015S",
    "Model": "T8015S"
  },
  {
    "Retail Branding": "Philips",
    "Marketing Name": "TLE722G",
    "Device": "TLE722G",
    "Model": "TLE722G"
  },
  {
    "Retail Branding": "Philips",
    "Marketing Name": "TLE732",
    "Device": "TLE732",
    "Model": "TLE732"
  },
  {
    "Retail Branding": "Philips",
    "Marketing Name": "V377",
    "Device": "Philips_V377",
    "Model": "Philips V377"
  },
  {
    "Retail Branding": "Philips",
    "Marketing Name": "V387",
    "Device": "V387",
    "Model": "Philips V387"
  },
  {
    "Retail Branding": "Philips",
    "Marketing Name": "V526",
    "Device": "Philips_V526",
    "Model": "Philips V526"
  },
  {
    "Retail Branding": "Philips",
    "Marketing Name": "V787",
    "Device": "Philips_Xenium_V787",
    "Model": "Philips Xenium V787"
  },
  {
    "Retail Branding": "Philips",
    "Marketing Name": "W337",
    "Device": "W337",
    "Model": "W337"
  },
  {
    "Retail Branding": "Philips",
    "Marketing Name": "W3500",
    "Device": "Philips_W3500",
    "Model": "Philips_W3500"
  },
  {
    "Retail Branding": "Philips",
    "Marketing Name": "W3568",
    "Device": "Philips_W3568",
    "Model": "Philips W3568"
  },
  {
    "Retail Branding": "Philips",
    "Marketing Name": "W3620",
    "Device": "W3620",
    "Model": "W3620"
  },
  {
    "Retail Branding": "Philips",
    "Marketing Name": "W6500",
    "Device": "Philips_W6500_A",
    "Model": "W6500"
  },
  {
    "Retail Branding": "Philips",
    "Marketing Name": "W6610",
    "Device": "Marathon",
    "Model": "Philips W6610"
  },
  {
    "Retail Branding": "Philips",
    "Marketing Name": "W6620",
    "Device": "W6620",
    "Model": "W6620"
  },
  {
    "Retail Branding": "Philips",
    "Marketing Name": "W8510",
    "Device": "Topaz",
    "Model": "Philips W8510"
  },
  {
    "Retail Branding": "Philips",
    "Marketing Name": "W8555",
    "Device": "Pride",
    "Model": "Philips W8555"
  },
  {
    "Retail Branding": "Philips",
    "Marketing Name": "X586",
    "Device": "Philips_X586",
    "Model": "Philips_X586"
  },
  {
    "Retail Branding": "Philips",
    "Marketing Name": "X586",
    "Device": "Philips_X586_NEW",
    "Model": "Philips_X586"
  },
  {
    "Retail Branding": "Philips",
    "Marketing Name": "X588",
    "Device": "X588_RU",
    "Model": "Philips X588"
  },
  {
    "Retail Branding": "Philips",
    "Marketing Name": "X818",
    "Device": "X818",
    "Model": "Philips X818"
  },
  {
    "Retail Branding": "Philips",
    "Marketing Name": "X818",
    "Device": "X818_EE",
    "Model": "Philips X818"
  },
  {
    "Retail Branding": "Philips",
    "Marketing Name": "X818",
    "Device": "X818_RU",
    "Model": "Philips X818"
  },
  {
    "Retail Branding": "Philips",
    "Marketing Name": "Xenium S266",
    "Device": "S266",
    "Model": "Xenium S266"
  },
  {
    "Retail Branding": "Philips",
    "Marketing Name": "Xenium S386",
    "Device": "S386",
    "Model": "Philips S386"
  },
  {
    "Retail Branding": "Philips",
    "Marketing Name": "Xenium S566",
    "Device": "S566",
    "Model": "Xenium S566"
  },
  {
    "Retail Branding": "Philips",
    "Marketing Name": "Xenium V377",
    "Device": "Philips_V377",
    "Model": "Philips V377"
  },
  {
    "Retail Branding": "Philips",
    "Marketing Name": "whitefield",
    "Device": "whitefield",
    "Model": "R8G"
  },
  {
    "Retail Branding": "Phoenix",
    "Marketing Name": "PHONETABPRO",
    "Device": "PHONETABPRO",
    "Model": "PHONETABPRO"
  },
  {
    "Retail Branding": "Phoenix Note",
    "Marketing Name": "M701A",
    "Device": "M701A",
    "Model": "M701A"
  },
  {
    "Retail Branding": "Phoenix Note",
    "Marketing Name": "PPS2022-P156",
    "Device": "PPS2022-P156",
    "Model": "PPS2022-P156"
  },
  {
    "Retail Branding": "Phone Max",
    "Marketing Name": "M10",
    "Device": "M10",
    "Model": "M10"
  },
  {
    "Retail Branding": "Phone Max",
    "Marketing Name": "M3PRO",
    "Device": "M3PRO",
    "Model": "M3PRO"
  },
  {
    "Retail Branding": "Phone Max",
    "Marketing Name": "P1000",
    "Device": "P1000",
    "Model": "P1000"
  },
  {
    "Retail Branding": "Phone Max",
    "Marketing Name": "P20 Pro",
    "Device": "P20_Pro",
    "Model": "P20 Pro"
  },
  {
    "Retail Branding": "Phone Max",
    "Marketing Name": "R4 GT",
    "Device": "R4_GT",
    "Model": "R4 GT"
  },
  {
    "Retail Branding": "Phone Max",
    "Marketing Name": "Rocky 2",
    "Device": "Rocky_2",
    "Model": "Rocky 2"
  },
  {
    "Retail Branding": "Phone Max",
    "Marketing Name": "Rocky_1",
    "Device": "Rocky_1",
    "Model": "Rocky_1"
  },
  {
    "Retail Branding": "Phone Max",
    "Marketing Name": "S4G",
    "Device": "S4G",
    "Model": "S4G"
  },
  {
    "Retail Branding": "Phone Max",
    "Marketing Name": "T12",
    "Device": "T12",
    "Model": "T12"
  },
  {
    "Retail Branding": "Phone Max",
    "Marketing Name": "T1_N",
    "Device": "T1",
    "Model": "T1"
  },
  {
    "Retail Branding": "Phone Max",
    "Marketing Name": "X1",
    "Device": "X1",
    "Model": "X1"
  },
  {
    "Retail Branding": "Phone Max",
    "Marketing Name": "X1_Pro",
    "Device": "X1_Pro",
    "Model": "X1 Pro"
  },
  {
    "Retail Branding": "Phone Max",
    "Marketing Name": "X3Pro",
    "Device": "X3Pro",
    "Model": "X3Pro"
  },
  {
    "Retail Branding": "PicassoTab",
    "Marketing Name": "PicassoTab_A10",
    "Device": "A10",
    "Model": "PicassoTab A10"
  },
  {
    "Retail Branding": "PicassoTab",
    "Marketing Name": "PicassoTab_X11",
    "Device": "X11",
    "Model": "PicassoTab X11"
  },
  {
    "Retail Branding": "PicassoTab",
    "Marketing Name": "PicassoTab_X11_2025",
    "Device": "PicassoTab_X11_2025",
    "Model": "PicassoTab_X11_2025"
  },
  {
    "Retail Branding": "PicassoTab",
    "Marketing Name": "PicassoTab_Z13",
    "Device": "Z13",
    "Model": "PicassoTab_Z13"
  },
  {
    "Retail Branding": "Pioneer",
    "Marketing Name": "AV Receiver",
    "Device": "AVH_W4400NEX",
    "Model": "Jupiter"
  },
  {
    "Retail Branding": "Pioneer",
    "Marketing Name": "Android TV",
    "Device": "R2",
    "Model": "ATV R2"
  },
  {
    "Retail Branding": "Pioneer",
    "Marketing Name": "B.PROカーナビ",
    "Device": "AVIC_BX500",
    "Model": "jupiter"
  },
  {
    "Retail Branding": "Pioneer",
    "Marketing Name": "B.PROカーナビ",
    "Device": "AVIC_BZ500",
    "Model": "jupiter"
  },
  {
    "Retail Branding": "Pioneer",
    "Marketing Name": "Car Navigation",
    "Device": "AVIC_W6400NEX",
    "Model": "Jupiter"
  },
  {
    "Retail Branding": "Pioneer",
    "Marketing Name": "Car Navigation",
    "Device": "AVIC_W8400NEX",
    "Model": "Jupiter"
  },
  {
    "Retail Branding": "Pioneer",
    "Marketing Name": "Car Navigation",
    "Device": "AVIC_Z710DAB",
    "Model": "Jupiter"
  },
  {
    "Retail Branding": "Pioneer",
    "Marketing Name": "Car Navigation",
    "Device": "AVIC_Z710DAB_C",
    "Model": "Jupiter"
  },
  {
    "Retail Branding": "Pioneer",
    "Marketing Name": "Car Navigation",
    "Device": "AVIC_Z810DAB_C",
    "Model": "Jupiter"
  },
  {
    "Retail Branding": "Pioneer",
    "Marketing Name": "Car Navigation",
    "Device": "AVIC_Z910DAB",
    "Model": "Jupiter"
  },
  {
    "Retail Branding": "Pioneer",
    "Marketing Name": "CyberNavi",
    "Device": "AVIC_CE900",
    "Model": "jupiter"
  },
  {
    "Retail Branding": "Pioneer",
    "Marketing Name": "CyberNavi",
    "Device": "AVIC_CE901",
    "Model": "jupiter"
  },
  {
    "Retail Branding": "Pioneer",
    "Marketing Name": "CyberNavi",
    "Device": "AVIC_CL900",
    "Model": "jupiter"
  },
  {
    "Retail Branding": "Pioneer",
    "Marketing Name": "CyberNavi",
    "Device": "AVIC_CL901",
    "Model": "jupiter"
  },
  {
    "Retail Branding": "Pioneer",
    "Marketing Name": "CyberNavi",
    "Device": "AVIC_CZ700",
    "Model": "jupiter"
  },
  {
    "Retail Branding": "Pioneer",
    "Marketing Name": "CyberNavi",
    "Device": "AVIC_CZ900",
    "Model": "jupiter"
  },
  {
    "Retail Branding": "Pioneer",
    "Marketing Name": "CyberNavi",
    "Device": "AVIC_CZ901",
    "Model": "jupiter"
  },
  {
    "Retail Branding": "Pioneer",
    "Marketing Name": "DTP9762",
    "Device": "PDTV-Combo-Box",
    "Model": "DTP9762"
  },
  {
    "Retail Branding": "Pioneer",
    "Marketing Name": "Navigation",
    "Device": "NVF_0068ZY",
    "Model": "jupiter"
  },
  {
    "Retail Branding": "Pioneer",
    "Marketing Name": "Navigation",
    "Device": "NVF_0078ZY",
    "Model": "jupiter"
  },
  {
    "Retail Branding": "Pioneer",
    "Marketing Name": "Navigation",
    "Device": "NVF_0168ZY",
    "Model": "jupiter"
  },
  {
    "Retail Branding": "Pioneer",
    "Marketing Name": "Navigation",
    "Device": "NVF_0178ZY",
    "Model": "jupiter"
  },
  {
    "Retail Branding": "Pioneer",
    "Marketing Name": "Navigation",
    "Device": "NVF_0188ZY",
    "Model": "jupiter"
  },
  {
    "Retail Branding": "Pioneer",
    "Marketing Name": "Navigation",
    "Device": "NVF_0288ZY",
    "Model": "jupiter"
  },
  {
    "Retail Branding": "Pioneer",
    "Marketing Name": "R1",
    "Device": "RCK8726Y703H",
    "Model": "R1"
  },
  {
    "Retail Branding": "Pioneer",
    "Marketing Name": "R3_GTV",
    "Device": "R3_GTV",
    "Model": "R3G"
  },
  {
    "Retail Branding": "Pioneer",
    "Marketing Name": "R4_GTV",
    "Device": "R4_GTV",
    "Model": "R4G"
  },
  {
    "Retail Branding": "Pioneer",
    "Marketing Name": "SDA-80TAB",
    "Device": "SDA_80TAB",
    "Model": "SDA-80TAB"
  },
  {
    "Retail Branding": "Pioneer",
    "Marketing Name": "SDA-835TAB",
    "Device": "SDA_835TAB",
    "Model": "SDA-835TAB"
  },
  {
    "Retail Branding": "Pioneer",
    "Marketing Name": "SDA-8TAB",
    "Device": "SDA_8TAB",
    "Model": "SDA-8TAB"
  },
  {
    "Retail Branding": "Pioneer",
    "Marketing Name": "XDP-100R",
    "Device": "Fu_Zin_32",
    "Model": "XDP-100R"
  },
  {
    "Retail Branding": "Pioneer",
    "Marketing Name": "XDP-300R",
    "Device": "Fu_Zin2R_32",
    "Model": "XDP-300R"
  },
  {
    "Retail Branding": "Pioneer_Digital_TV",
    "Marketing Name": "PD900BOX",
    "Device": "SEI900PD",
    "Model": "PD900BOX"
  },
  {
    "Retail Branding": "Pioneer_Digital_TV",
    "Marketing Name": "PD_DV_8535",
    "Device": "DV8535-KIP",
    "Model": "PD_DV_8535"
  },
  {
    "Retail Branding": "Piranha",
    "Marketing Name": "Piranha8032",
    "Device": "Piranha8032",
    "Model": "Piranha8032"
  },
  {
    "Retail Branding": "Pitney Bowes",
    "Marketing Name": "Pitney Bowes C-Series",
    "Device": "ELINK2",
    "Model": "CSD-ELINK2"
  },
  {
    "Retail Branding": "Pitney Bowes",
    "Marketing Name": "SendPro C Series",
    "Device": "TitanX2",
    "Model": "CSD-TXT2"
  },
  {
    "Retail Branding": "Pixela",
    "Marketing Name": "4K SmartTuner",
    "Device": "tennouji",
    "Model": "PIX-SMB400"
  },
  {
    "Retail Branding": "Pixela",
    "Marketing Name": "KSTB5043",
    "Device": "KSTB5043",
    "Model": "KSTB5043"
  },
  {
    "Retail Branding": "Pixela",
    "Marketing Name": "PIX-SMB400",
    "Device": "tennouji",
    "Model": "PIX-SMB400"
  },
  {
    "Retail Branding": "Pixela",
    "Marketing Name": "PIX_VP100",
    "Device": "kyobashi",
    "Model": "PIX-VP100"
  },
  {
    "Retail Branding": "Pixus",
    "Marketing Name": "PixusJoker",
    "Device": "PixusJoker",
    "Model": "PixusJoker"
  },
  {
    "Retail Branding": "Pixus",
    "Marketing Name": "Pixus_Arena",
    "Device": "Pixus_Arena",
    "Model": "Pixus_Arena"
  },
  {
    "Retail Branding": "Pixus",
    "Marketing Name": "Pixus_BigTab",
    "Device": "Pixus_BigTab",
    "Model": "Pixus_BigTab"
  },
  {
    "Retail Branding": "Pixus",
    "Marketing Name": "Pixus_Blast",
    "Device": "Pixus_Blast",
    "Model": "Pixus_Blast"
  },
  {
    "Retail Branding": "Pixus",
    "Marketing Name": "Pixus_Combo",
    "Device": "Pixus_Combo",
    "Model": "Pixus Combo"
  },
  {
    "Retail Branding": "Pixus",
    "Marketing Name": "Pixus_Deon",
    "Device": "Pixus_Deon",
    "Model": "Pixus_Deon"
  },
  {
    "Retail Branding": "Pixus",
    "Marketing Name": "Pixus_Drive",
    "Device": "Pixus_Drive",
    "Model": "Pixus_Drive"
  },
  {
    "Retail Branding": "Pixus",
    "Marketing Name": "Pixus_Falcon",
    "Device": "Pixus_Falcon",
    "Model": "Pixus_Falcon"
  },
  {
    "Retail Branding": "Pixus",
    "Marketing Name": "Pixus_Folio",
    "Device": "Pixus_Folio",
    "Model": "Pixus_Folio"
  },
  {
    "Retail Branding": "Pixus",
    "Marketing Name": "Pixus_Hammer",
    "Device": "Pixus_Hammer",
    "Model": "Pixus_Hammer"
  },
  {
    "Retail Branding": "Pixus",
    "Marketing Name": "Pixus_Joker",
    "Device": "Pixus_Joker",
    "Model": "Pixus_Joker"
  },
  {
    "Retail Branding": "Pixus",
    "Marketing Name": "Pixus_Line",
    "Device": "Pixus_Line",
    "Model": "Pixus_Line"
  },
  {
    "Retail Branding": "Pixus",
    "Marketing Name": "Pixus_Line",
    "Device": "Pixus_Line_v2",
    "Model": "Pixus Line"
  },
  {
    "Retail Branding": "Pixus",
    "Marketing Name": "Pixus_Line",
    "Device": "Pixus_Line_v2",
    "Model": "Pixus Line v2"
  },
  {
    "Retail Branding": "Pixus",
    "Marketing Name": "Pixus_Loga",
    "Device": "Pixus_Loga",
    "Model": "Pixus Loga"
  },
  {
    "Retail Branding": "Pixus",
    "Marketing Name": "Pixus_Sprint",
    "Device": "Sprint",
    "Model": "Pixus_Sprint"
  },
  {
    "Retail Branding": "Pixus",
    "Marketing Name": "Pixus_Sprint_2_16",
    "Device": "Sprint_2_16",
    "Model": "Pixus_Sprint_2_16"
  },
  {
    "Retail Branding": "Pixus",
    "Marketing Name": "Pixus_Titan",
    "Device": "Pixus_Titan",
    "Model": "Pixus_Titan"
  },
  {
    "Retail Branding": "Pixus",
    "Marketing Name": "Pixus_Touch_7_3G",
    "Device": "Pixus_Touch_7_3G",
    "Model": "Pixus_Touch_7_3G"
  },
  {
    "Retail Branding": "Pixus",
    "Marketing Name": "Pixus_Wing",
    "Device": "Pixus_Wing",
    "Model": "Pixus_Wing"
  },
  {
    "Retail Branding": "Plaisio",
    "Marketing Name": "A2",
    "Device": "Turbo-X_A2",
    "Model": "Turbo-X_A2"
  },
  {
    "Retail Branding": "Plaisio",
    "Marketing Name": "A4",
    "Device": "A4",
    "Model": "A4"
  },
  {
    "Retail Branding": "Plaisio",
    "Marketing Name": "Aqua",
    "Device": "Aqua",
    "Model": "Aqua"
  },
  {
    "Retail Branding": "Plaisio",
    "Marketing Name": "Aqua_II",
    "Device": "Aqua_II",
    "Model": "Aqua_II"
  },
  {
    "Retail Branding": "Plaisio",
    "Marketing Name": "Calltab 7”",
    "Device": "Calltab7inch",
    "Model": "Calltab7inch"
  },
  {
    "Retail Branding": "Plaisio",
    "Marketing Name": "Calltab2GB10.1",
    "Device": "Calltab2GB10",
    "Model": "Calltab2GB10"
  },
  {
    "Retail Branding": "Plaisio",
    "Marketing Name": "CalltabII 10.1",
    "Device": "E1031H2C",
    "Model": "Calltab10.1"
  },
  {
    "Retail Branding": "Plaisio",
    "Marketing Name": "Coral II",
    "Device": "CoralII",
    "Model": "Turbo-X Coral II"
  },
  {
    "Retail Branding": "Plaisio",
    "Marketing Name": "E4",
    "Device": "E4",
    "Model": "E4"
  },
  {
    "Retail Branding": "Plaisio",
    "Marketing Name": "Earth",
    "Device": "Earth",
    "Model": "Earth"
  },
  {
    "Retail Branding": "Plaisio",
    "Marketing Name": "Earth 7.0\\' 3G",
    "Device": "Earth3G",
    "Model": "Earth 7.0\\'3G"
  },
  {
    "Retail Branding": "Plaisio",
    "Marketing Name": "Fire",
    "Device": "Fire",
    "Model": "Fire"
  },
  {
    "Retail Branding": "Plaisio",
    "Marketing Name": "G320",
    "Device": "G320",
    "Model": "G320"
  },
  {
    "Retail Branding": "Plaisio",
    "Marketing Name": "Hive V 3G",
    "Device": "mg978",
    "Model": "Hive V 3G"
  },
  {
    "Retail Branding": "Plaisio",
    "Marketing Name": "Hive V 3G",
    "Device": "mr978",
    "Model": "Hive V 3G"
  },
  {
    "Retail Branding": "Plaisio",
    "Marketing Name": "I4G",
    "Device": "I4G",
    "Model": "TURBOX_I4G"
  },
  {
    "Retail Branding": "Plaisio",
    "Marketing Name": "Lithium Ion",
    "Device": "Turbo-X_e3",
    "Model": "Turbo-X_e3"
  },
  {
    "Retail Branding": "Plaisio",
    "Marketing Name": "Rainbow II 3G 8",
    "Device": "mr801",
    "Model": "RainbowII 3G"
  },
  {
    "Retail Branding": "Plaisio",
    "Marketing Name": "RainbowIII3G",
    "Device": "RainbowIII3G",
    "Model": "RainbowIII3G"
  },
  {
    "Retail Branding": "Plaisio",
    "Marketing Name": "Rubik-II",
    "Device": "RubikII7",
    "Model": "RubikII7"
  },
  {
    "Retail Branding": "Plaisio",
    "Marketing Name": "Rubik10.1\"II",
    "Device": "H1021H4C1_I",
    "Model": "Rubik 10.1 II"
  },
  {
    "Retail Branding": "Plaisio",
    "Marketing Name": "RubikII 10",
    "Device": "q102",
    "Model": "Rubik 10.1 II"
  },
  {
    "Retail Branding": "Plaisio",
    "Marketing Name": "Rubik_10_III",
    "Device": "Rubik_10_III",
    "Model": "Rubik_10_III"
  },
  {
    "Retail Branding": "Plaisio",
    "Marketing Name": "Turbo-X Twister",
    "Device": "Twister_IV_IPS",
    "Model": "QUAD-CORE A33 inet"
  },
  {
    "Retail Branding": "Plaisio",
    "Marketing Name": "Turbo-X s2",
    "Device": "s2",
    "Model": "s2"
  },
  {
    "Retail Branding": "Plaisio",
    "Marketing Name": "Turbo-X_epsilon",
    "Device": "Turbo-X_epsilon",
    "Model": "Turbo-X_epsilon"
  },
  {
    "Retail Branding": "Plaisio",
    "Marketing Name": "Turbo-X_pi_4G",
    "Device": "Turbo-X_pi_4G",
    "Model": "Turbo-X_pi_4G"
  },
  {
    "Retail Branding": "Plaisio",
    "Marketing Name": "Turbo-X_z",
    "Device": "Turbo-X_z",
    "Model": "Turbo-X_z"
  },
  {
    "Retail Branding": "Plaisio",
    "Marketing Name": "Turbox_A3",
    "Device": "Turbox_A3",
    "Model": "Turbox_A3"
  },
  {
    "Retail Branding": "Plaisio",
    "Marketing Name": "Turbox_S3",
    "Device": "Turbox_S3",
    "Model": "Turbox_S3"
  },
  {
    "Retail Branding": "Plaisio",
    "Marketing Name": "lamda",
    "Device": "Turbo-X_lamda",
    "Model": "Turbo-X lamda"
  },
  {
    "Retail Branding": "Planet Computers",
    "Marketing Name": "Astro_Slide_5G_Transformer",
    "Device": "Astro",
    "Model": "Astro_Slide_5G_Transformer"
  },
  {
    "Retail Branding": "Planet Computers",
    "Marketing Name": "Cosmo_Communicator",
    "Device": "Cosmo_Communicator",
    "Model": "Cosmo_Communicator"
  },
  {
    "Retail Branding": "Planet Computers",
    "Marketing Name": "Gemini",
    "Device": "Gemini_4G",
    "Model": "Gemini_4G"
  },
  {
    "Retail Branding": "PlayPoland",
    "Marketing Name": "PLAY BOX TV 4B",
    "Device": "PLAY_BOX_TV_4B",
    "Model": "PLAY BOX TV 4B"
  },
  {
    "Retail Branding": "PlayPoland",
    "Marketing Name": "PLAY NOW TV BOX 2",
    "Device": "DV8545-PLAY",
    "Model": "PLAY NOW TV BOX 2"
  },
  {
    "Retail Branding": "PlayPoland",
    "Marketing Name": "PLAY NOW TV BOX 3",
    "Device": "DV8945-KPP",
    "Model": "PLAY NOW TV BOX 3"
  },
  {
    "Retail Branding": "PlayPoland",
    "Marketing Name": "PLAY TV BOX 4A",
    "Device": "DV8990-KPP",
    "Model": "PLAY TV BOX 4A"
  },
  {
    "Retail Branding": "PlayPoland",
    "Marketing Name": "Play Now",
    "Device": "dctiw362p",
    "Model": "DCTIW362_PLAY"
  },
  {
    "Retail Branding": "PlayPoland",
    "Marketing Name": "play_dctiw362",
    "Device": "dctiw362p",
    "Model": "DCTIW362_PLAY"
  },
  {
    "Retail Branding": "Pleio",
    "Marketing Name": "N9600",
    "Device": "NETGEM_TV_B866W6M",
    "Model": "N9600"
  },
  {
    "Retail Branding": "Plimpton",
    "Marketing Name": "Kids10_A15",
    "Device": "Kids10_A15",
    "Model": "Kids10_A15"
  },
  {
    "Retail Branding": "Plimpton",
    "Marketing Name": "Kids10_A15_EEA",
    "Device": "Kids10_A15_EEA",
    "Model": "Kids10_A15_EEA"
  },
  {
    "Retail Branding": "Plimpton",
    "Marketing Name": "Kids10_A16_EEA_JAE",
    "Device": "Kids10_A16_EEA_JAE",
    "Model": "Kids10_A16_EEA_JAE"
  },
  {
    "Retail Branding": "Plimpton",
    "Marketing Name": "Kids10_A16_JAE",
    "Device": "Kids10_A16_JAE",
    "Model": "Kids10_A16_JAE"
  },
  {
    "Retail Branding": "Plimpton",
    "Marketing Name": "Kids20",
    "Device": "Kids20",
    "Model": "Kids20"
  },
  {
    "Retail Branding": "Plimpton",
    "Marketing Name": "Kids20A14",
    "Device": "Kids20A14",
    "Model": "Kids20"
  },
  {
    "Retail Branding": "Plimpton",
    "Marketing Name": "Kids20A14_EEA",
    "Device": "Kids20A14_EEA",
    "Model": "Kids20"
  },
  {
    "Retail Branding": "Plimpton",
    "Marketing Name": "Kids20A15",
    "Device": "Kids20A15",
    "Model": "Kids20"
  },
  {
    "Retail Branding": "Plimpton",
    "Marketing Name": "Kids20A15_EEA",
    "Device": "Kids20A15_EEA",
    "Model": "Kids20"
  },
  {
    "Retail Branding": "Plimpton",
    "Marketing Name": "Kids20_A16_EEA_JAE",
    "Device": "Kids20_A16_EEA_JAE",
    "Model": "Kids20_A16_EEA_JAE"
  },
  {
    "Retail Branding": "Plimpton",
    "Marketing Name": "Kids20_A16_JAE",
    "Device": "Kids20_A16_JAE",
    "Model": "Kids20_A16_JAE"
  },
  {
    "Retail Branding": "Plimpton",
    "Marketing Name": "Kids20_EEA",
    "Device": "Kids20_EEA",
    "Model": "Kids20"
  },
  {
    "Retail Branding": "Plimpton",
    "Marketing Name": "Kids20_PA15",
    "Device": "Kids20_PA15",
    "Model": "Kids20_PA15"
  },
  {
    "Retail Branding": "Plimpton",
    "Marketing Name": "Kids20_PA15_EEA",
    "Device": "Kids20_PA15_EEA",
    "Model": "Kids20_PA15_EEA"
  },
  {
    "Retail Branding": "Plimpton",
    "Marketing Name": "Kids_10",
    "Device": "Kids_10",
    "Model": "Kids_10"
  },
  {
    "Retail Branding": "Plimpton",
    "Marketing Name": "Kids_10_EEA",
    "Device": "Kids_10_EEA",
    "Model": "Kids 10"
  },
  {
    "Retail Branding": "Plimpton",
    "Marketing Name": "Kids_10_ver13",
    "Device": "Kids_10_ver13",
    "Model": "Kids 10"
  },
  {
    "Retail Branding": "Plimpton",
    "Marketing Name": "Kids_10_ver14",
    "Device": "Kids_10_ver14",
    "Model": "Kids 10"
  },
  {
    "Retail Branding": "Plimpton",
    "Marketing Name": "Kids_10_ver14_EEA",
    "Device": "Kids_10_ver14_EEA",
    "Model": "Kids 10"
  },
  {
    "Retail Branding": "Plimpton",
    "Marketing Name": "Kids_8",
    "Device": "Kids_8",
    "Model": "Kids_8"
  },
  {
    "Retail Branding": "Plimpton",
    "Marketing Name": "P1",
    "Device": "P1",
    "Model": "P1"
  },
  {
    "Retail Branding": "Plimpton",
    "Marketing Name": "P1A15",
    "Device": "P1A15",
    "Model": "P1A15"
  },
  {
    "Retail Branding": "Plimpton",
    "Marketing Name": "P1A15_EEA",
    "Device": "P1A15_EEA",
    "Model": "P1A15_EEA"
  },
  {
    "Retail Branding": "Plimpton",
    "Marketing Name": "P1_A16_EEA_JAE",
    "Device": "P1_A16_EEA_JAE",
    "Model": "P1_A16_EEA_JAE"
  },
  {
    "Retail Branding": "Plimpton",
    "Marketing Name": "P1_A16_JAE",
    "Device": "P1_A16_JAE",
    "Model": "P1_A16_JAE"
  },
  {
    "Retail Branding": "Plimpton",
    "Marketing Name": "P2",
    "Device": "P2",
    "Model": "P2"
  },
  {
    "Retail Branding": "Plimpton",
    "Marketing Name": "P2A16",
    "Device": "P2A16",
    "Model": "P2A16"
  },
  {
    "Retail Branding": "Plimpton",
    "Marketing Name": "P2_EEA",
    "Device": "P2_EEA",
    "Model": "P2_EEA"
  },
  {
    "Retail Branding": "Plimpton",
    "Marketing Name": "P60Plus",
    "Device": "P60Plus",
    "Model": "P60Plus"
  },
  {
    "Retail Branding": "Plimpton",
    "Marketing Name": "P60Plus_EEA",
    "Device": "P60Plus_EEA",
    "Model": "P60Plus_EEA"
  },
  {
    "Retail Branding": "Plimpton",
    "Marketing Name": "P60Pro",
    "Device": "P60Pro",
    "Model": "P60_Pro"
  },
  {
    "Retail Branding": "Plimpton",
    "Marketing Name": "P60_Pro",
    "Device": "P60_Pro",
    "Model": "PlimPad_P60_Pro"
  },
  {
    "Retail Branding": "Plimpton",
    "Marketing Name": "P70_14",
    "Device": "P70_14",
    "Model": "P70"
  },
  {
    "Retail Branding": "Plimpton",
    "Marketing Name": "P70_14_EEA",
    "Device": "P70_14_EEA",
    "Model": "P70"
  },
  {
    "Retail Branding": "Plimpton",
    "Marketing Name": "P8",
    "Device": "P8",
    "Model": "P8"
  },
  {
    "Retail Branding": "Plimpton",
    "Marketing Name": "P8Pro",
    "Device": "P8Pro",
    "Model": "P8Pro"
  },
  {
    "Retail Branding": "Plimpton",
    "Marketing Name": "P8ProA14",
    "Device": "P8ProA14",
    "Model": "P8Pro"
  },
  {
    "Retail Branding": "Plimpton",
    "Marketing Name": "P8ProA14_EEA",
    "Device": "P8ProA14_EEA",
    "Model": "P8Pro"
  },
  {
    "Retail Branding": "Plimpton",
    "Marketing Name": "P8Pro_EEA",
    "Device": "P8Pro_EEA",
    "Model": "P8Pro"
  },
  {
    "Retail Branding": "Plimpton",
    "Marketing Name": "P8Prov2",
    "Device": "P8Prov2",
    "Model": "P8Prov2"
  },
  {
    "Retail Branding": "Plimpton",
    "Marketing Name": "Paper_8",
    "Device": "Paper_8",
    "Model": "Paper_8"
  },
  {
    "Retail Branding": "Plimpton",
    "Marketing Name": "PlimPad_P3",
    "Device": "PlimPad_P3",
    "Model": "PlimPad P3"
  },
  {
    "Retail Branding": "Plimpton",
    "Marketing Name": "PlimPad_P3_Pro",
    "Device": "PlimPad_P3_Pro",
    "Model": "PlimPad_P3_Pro"
  },
  {
    "Retail Branding": "Plimpton",
    "Marketing Name": "PlimPad_P60",
    "Device": "PlimPad_P60",
    "Model": "PlimPad_P60"
  },
  {
    "Retail Branding": "Plimpton",
    "Marketing Name": "PlimPad_P60_Pro",
    "Device": "PlimPad_P60_Pro",
    "Model": "PlimPad_P60_Pro"
  },
  {
    "Retail Branding": "Plimpton",
    "Marketing Name": "X100",
    "Device": "X100",
    "Model": "X100"
  },
  {
    "Retail Branding": "Plimpton",
    "Marketing Name": "kids20A15_A537",
    "Device": "kids20A15_A537",
    "Model": "kids20A15_A537"
  },
  {
    "Retail Branding": "Plum",
    "Marketing Name": "Phantom3",
    "Device": "Z621",
    "Model": "Z621"
  },
  {
    "Retail Branding": "Plum",
    "Marketing Name": "Z518",
    "Device": "Z518",
    "Model": "Z518"
  },
  {
    "Retail Branding": "Plum",
    "Marketing Name": "Z519",
    "Device": "Z519",
    "Model": "Z519"
  },
  {
    "Retail Branding": "Plum",
    "Marketing Name": "Z555",
    "Device": "Z555",
    "Model": "Z555"
  },
  {
    "Retail Branding": "Plum",
    "Marketing Name": "Z570",
    "Device": "Z570",
    "Model": "Z570"
  },
  {
    "Retail Branding": "Plum",
    "Marketing Name": "Z621",
    "Device": "Z621",
    "Model": "Z621"
  },
  {
    "Retail Branding": "Plum",
    "Marketing Name": "Z711",
    "Device": "Z711",
    "Model": "PLUM Z711"
  },
  {
    "Retail Branding": "Plum",
    "Marketing Name": "Z712",
    "Device": "Z712",
    "Model": "PLUM Z712"
  },
  {
    "Retail Branding": "Plus4",
    "Marketing Name": "Q-Touch",
    "Device": "Q-Touch",
    "Model": "Q-Touch"
  },
  {
    "Retail Branding": "PlusStyle",
    "Marketing Name": "PS_TAB_WB01",
    "Device": "PS_TAB_WB01",
    "Model": "PS_TAB_WB01"
  },
  {
    "Retail Branding": "Plusone",
    "Marketing Name": "FREETEL Priori3S",
    "Device": "FTU152A",
    "Model": "FTU152A"
  },
  {
    "Retail Branding": "Plusone",
    "Marketing Name": "FREETEL SAMURAI KIWAMI 2",
    "Device": "SAMURAI_KIWAMI2",
    "Model": "FTJ162B"
  },
  {
    "Retail Branding": "Plusone",
    "Marketing Name": "FREETEL Samurai Rei",
    "Device": "FTJ161B",
    "Model": "FTJ161B"
  },
  {
    "Retail Branding": "Plusone",
    "Marketing Name": "FTJ152C",
    "Device": "FTJ152C",
    "Model": "FTJ152C"
  },
  {
    "Retail Branding": "Plusone",
    "Marketing Name": "FTJ161A",
    "Device": "FTJ161A",
    "Model": "FTJ161A"
  },
  {
    "Retail Branding": "Plusone",
    "Marketing Name": "FTU152D",
    "Device": "FTU152D",
    "Model": "FTU152D"
  },
  {
    "Retail Branding": "Plusone",
    "Marketing Name": "Fun +",
    "Device": "FTU161G",
    "Model": "FTU161G"
  },
  {
    "Retail Branding": "Plusone",
    "Marketing Name": "Fun +",
    "Device": "FTU161G",
    "Model": "Fun +"
  },
  {
    "Retail Branding": "Plusone",
    "Marketing Name": "Ice 2",
    "Device": "FTJ161E-VN",
    "Model": "FTJ161E-VN"
  },
  {
    "Retail Branding": "Plusone",
    "Marketing Name": "Ice 2",
    "Device": "ICE2",
    "Model": "FTE161E"
  },
  {
    "Retail Branding": "Plusone",
    "Marketing Name": "Ice 2",
    "Device": "ICE2",
    "Model": "ICE2"
  },
  {
    "Retail Branding": "Plusone",
    "Marketing Name": "Kiwami",
    "Device": "FTJ152D",
    "Model": "FTJ152D"
  },
  {
    "Retail Branding": "Plusone",
    "Marketing Name": "Priori 3",
    "Device": "FTJ152A",
    "Model": "FTJ152A"
  },
  {
    "Retail Branding": "Plusone",
    "Marketing Name": "Priori3S",
    "Device": "FTJ152B",
    "Model": "FTJ152B"
  },
  {
    "Retail Branding": "Plusone",
    "Marketing Name": "Smart HD",
    "Device": "Smart_HD",
    "Model": "Smart_HD"
  },
  {
    "Retail Branding": "Pluzz",
    "Marketing Name": "P13",
    "Device": "P13",
    "Model": "P13"
  },
  {
    "Retail Branding": "Pluzz",
    "Marketing Name": "PL4010",
    "Device": "PL4010",
    "Model": "PLUZZ_PL4010"
  },
  {
    "Retail Branding": "Pluzz",
    "Marketing Name": "PLUZZ_PL5010",
    "Device": "PL5010",
    "Model": "PLUZZ_PL5010"
  },
  {
    "Retail Branding": "Pluzz",
    "Marketing Name": "PLUZZ_PL5510",
    "Device": "PLUZZ_PL5510",
    "Model": "PLUZZ_PL5510"
  },
  {
    "Retail Branding": "Point Mobile",
    "Marketing Name": "MX450",
    "Device": "MX450",
    "Model": "MX450"
  },
  {
    "Retail Branding": "Point Mobile",
    "Marketing Name": "PM30",
    "Device": "pm30",
    "Model": "PM30"
  },
  {
    "Retail Branding": "Point Mobile",
    "Marketing Name": "PM351",
    "Device": "PM351",
    "Model": "PM351"
  },
  {
    "Retail Branding": "Point Mobile",
    "Marketing Name": "PM352",
    "Device": "PM352",
    "Model": "PM352"
  },
  {
    "Retail Branding": "Point Mobile",
    "Marketing Name": "PM45",
    "Device": "pm45",
    "Model": "PM45"
  },
  {
    "Retail Branding": "Point Mobile",
    "Marketing Name": "PM451",
    "Device": "PM451",
    "Model": "PM451"
  },
  {
    "Retail Branding": "Point Mobile",
    "Marketing Name": "PM45E",
    "Device": "pm45e",
    "Model": "PM45E"
  },
  {
    "Retail Branding": "Point Mobile",
    "Marketing Name": "PM550",
    "Device": "pm550",
    "Model": "PM550"
  },
  {
    "Retail Branding": "Point Mobile",
    "Marketing Name": "PM550A",
    "Device": "pm550a",
    "Model": "PM550"
  },
  {
    "Retail Branding": "Point Mobile",
    "Marketing Name": "PM550R",
    "Device": "pm550r",
    "Model": "PM550"
  },
  {
    "Retail Branding": "Point Mobile",
    "Marketing Name": "PM66",
    "Device": "pm66",
    "Model": "PM66"
  },
  {
    "Retail Branding": "Point Mobile",
    "Marketing Name": "PM67",
    "Device": "PM67",
    "Model": "PM67"
  },
  {
    "Retail Branding": "Point Mobile",
    "Marketing Name": "PM68",
    "Device": "PM68",
    "Model": "PM68"
  },
  {
    "Retail Branding": "Point Mobile",
    "Marketing Name": "PM70",
    "Device": "pm70",
    "Model": "PM70"
  },
  {
    "Retail Branding": "Point Mobile",
    "Marketing Name": "PM75",
    "Device": "PM75",
    "Model": "PM75"
  },
  {
    "Retail Branding": "Point Mobile",
    "Marketing Name": "PM80",
    "Device": "pm80",
    "Model": "PM80"
  },
  {
    "Retail Branding": "Point Mobile",
    "Marketing Name": "PM84",
    "Device": "PM84",
    "Model": "PM84"
  },
  {
    "Retail Branding": "Point Mobile",
    "Marketing Name": "PM84P",
    "Device": "PM84P",
    "Model": "PM84P"
  },
  {
    "Retail Branding": "Point Mobile",
    "Marketing Name": "PM84R",
    "Device": "PM84",
    "Model": "PM84R"
  },
  {
    "Retail Branding": "Point Mobile",
    "Marketing Name": "PM85",
    "Device": "pm85",
    "Model": "PM85"
  },
  {
    "Retail Branding": "Point Mobile",
    "Marketing Name": "PM85",
    "Device": "pm85e",
    "Model": "PM85E"
  },
  {
    "Retail Branding": "Point Mobile",
    "Marketing Name": "PM85R",
    "Device": "pm85r",
    "Model": "PM85R"
  },
  {
    "Retail Branding": "Point Mobile",
    "Marketing Name": "PM86",
    "Device": "PM86",
    "Model": "PM86"
  },
  {
    "Retail Branding": "Point Mobile",
    "Marketing Name": "PM90",
    "Device": "pm90",
    "Model": "PM90"
  },
  {
    "Retail Branding": "Point Mobile",
    "Marketing Name": "PM95",
    "Device": "PM95",
    "Model": "PM95"
  },
  {
    "Retail Branding": "Point Mobile",
    "Marketing Name": "PT11",
    "Device": "PT11",
    "Model": "PT11"
  },
  {
    "Retail Branding": "Point Mobile",
    "Marketing Name": "TR54",
    "Device": "TR54",
    "Model": "TR54"
  },
  {
    "Retail Branding": "Point of view",
    "Marketing Name": "PVT-R78-3288",
    "Device": "PVT-R78-3288",
    "Model": "PVT-R78-3288"
  },
  {
    "Retail Branding": "Point of view",
    "Marketing Name": "TAB-7232-3G",
    "Device": "TAB_7232_3G_EEA",
    "Model": "TAB-7232-3G-V2"
  },
  {
    "Retail Branding": "Point of view",
    "Marketing Name": "TAB-P10232-3G",
    "Device": "TAB-P10232-3G",
    "Model": "TAB-P10232-3G"
  },
  {
    "Retail Branding": "Point of view",
    "Marketing Name": "TAB-PTDF-116",
    "Device": "TAB-PTDF-116",
    "Model": "TAB-PTDF-116"
  },
  {
    "Retail Branding": "Point of view",
    "Marketing Name": "TAB_7232_3G_A",
    "Device": "TAB_7232_3G_A",
    "Model": "TAB_7232_3G_A"
  },
  {
    "Retail Branding": "Point of view",
    "Marketing Name": "TAB_ASR_7232_3G_SERIES",
    "Device": "TABLET_PC",
    "Model": "TAB_ASR_7232_3G_SERIES"
  },
  {
    "Retail Branding": "Point of view",
    "Marketing Name": "TAB_TS101S_LTE",
    "Device": "TAB_TS101S_LTE",
    "Model": "TAB_TS101S_LTE"
  },
  {
    "Retail Branding": "PointMobile",
    "Marketing Name": "PM452",
    "Device": "PM452",
    "Model": "PM452"
  },
  {
    "Retail Branding": "Pokini",
    "Marketing Name": "K6",
    "Device": "K6",
    "Model": "K6"
  },
  {
    "Retail Branding": "Polar",
    "Marketing Name": "M600",
    "Device": "pike",
    "Model": "Polar M600"
  },
  {
    "Retail Branding": "Polaris",
    "Marketing Name": "Condroid_X7",
    "Device": "polaris-Condroid_X7",
    "Model": "Condroid_X7"
  },
  {
    "Retail Branding": "Polaroid",
    "Marketing Name": "A/S10",
    "Device": "wing-AS10",
    "Model": "A/S10"
  },
  {
    "Retail Branding": "Polaroid",
    "Marketing Name": "A/S7",
    "Device": "wing-AS7",
    "Model": "A/S7"
  },
  {
    "Retail Branding": "Polaroid",
    "Marketing Name": "A/S8",
    "Device": "wing-AS8",
    "Model": "A/S8"
  },
  {
    "Retail Branding": "Polaroid",
    "Marketing Name": "A6",
    "Device": "A6",
    "Model": "A6"
  },
  {
    "Retail Branding": "Polaroid",
    "Marketing Name": "A7X_PTAB735X",
    "Device": "PTAB735X",
    "Model": "A7X_PTAB735X"
  },
  {
    "Retail Branding": "Polaroid",
    "Marketing Name": "A7_PTAB735",
    "Device": "A7_PTAB735",
    "Model": "HS-7DTB39"
  },
  {
    "Retail Branding": "Polaroid",
    "Marketing Name": "A9x/PTAB935x",
    "Device": "A9xPTAB935x",
    "Model": "A9x/PTAB935x"
  },
  {
    "Retail Branding": "Polaroid",
    "Marketing Name": "Android TV",
    "Device": "R1",
    "Model": "ATV R1"
  },
  {
    "Retail Branding": "Polaroid",
    "Marketing Name": "Android TV",
    "Device": "R2",
    "Model": "ATV R2"
  },
  {
    "Retail Branding": "Polaroid",
    "Marketing Name": "BDL0232PR",
    "Device": "BDL0232PR",
    "Model": "BDL0232PR"
  },
  {
    "Retail Branding": "Polaroid",
    "Marketing Name": "BDL1064PR001",
    "Device": "BDL1064PR001",
    "Model": "BDL1064PR001"
  },
  {
    "Retail Branding": "Polaroid",
    "Marketing Name": "BDL424",
    "Device": "BDL424",
    "Model": "BDL424"
  },
  {
    "Retail Branding": "Polaroid",
    "Marketing Name": "BDL5048",
    "Device": "BDL5048",
    "Model": "BDL5048PR001"
  },
  {
    "Retail Branding": "Polaroid",
    "Marketing Name": "BDLE716",
    "Device": "BDLE716_EEA",
    "Model": "BDLE716"
  },
  {
    "Retail Branding": "Polaroid",
    "Marketing Name": "BDLE716PR",
    "Device": "BDLE716PR",
    "Model": "BDLE716PR"
  },
  {
    "Retail Branding": "Polaroid",
    "Marketing Name": "BDLT107",
    "Device": "BDLT107",
    "Model": "BDLT107"
  },
  {
    "Retail Branding": "Polaroid",
    "Marketing Name": "Connect4G",
    "Device": "Connect4G",
    "Model": "Connect4G"
  },
  {
    "Retail Branding": "Polaroid",
    "Marketing Name": "Cosmo L",
    "Device": "P5026A",
    "Model": "P5026A"
  },
  {
    "Retail Branding": "Polaroid",
    "Marketing Name": "Cosmo P5s",
    "Device": "P5046A",
    "Model": "P5046A"
  },
  {
    "Retail Branding": "Polaroid",
    "Marketing Name": "Cosmo Z",
    "Device": "P5047A",
    "Model": "P5047A"
  },
  {
    "Retail Branding": "Polaroid",
    "Marketing Name": "Cosmo Z2",
    "Device": "PSPCZ20A0",
    "Model": "PSPCZ20A0"
  },
  {
    "Retail Branding": "Polaroid",
    "Marketing Name": "Cosmo Z2 Plus",
    "Device": "PSPCM20A0",
    "Model": "PSPCM20A0"
  },
  {
    "Retail Branding": "Polaroid",
    "Marketing Name": "G5N",
    "Device": "redwood",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "Polaroid",
    "Marketing Name": "Infinite",
    "Device": "MID1324",
    "Model": "MID 1324"
  },
  {
    "Retail Branding": "Polaroid",
    "Marketing Name": "K7",
    "Device": "PTAB782",
    "Model": "K7/PTAB782"
  },
  {
    "Retail Branding": "Polaroid",
    "Marketing Name": "L9",
    "Device": "L9",
    "Model": "L9"
  },
  {
    "Retail Branding": "Polaroid",
    "Marketing Name": "MID1028",
    "Device": "MID1028",
    "Model": "MID1028"
  },
  {
    "Retail Branding": "Polaroid",
    "Marketing Name": "MID1048PHE",
    "Device": "MID1048PHE",
    "Model": "MID1048PHE"
  },
  {
    "Retail Branding": "Polaroid",
    "Marketing Name": "MID1064FHDP",
    "Device": "MID1064FHDP",
    "Model": "MID1064FHDP"
  },
  {
    "Retail Branding": "Polaroid",
    "Marketing Name": "MID1095PR001",
    "Device": "MID1095PR001",
    "Model": "MID1095PR001"
  },
  {
    "Retail Branding": "Polaroid",
    "Marketing Name": "MID1264",
    "Device": "MID1264",
    "Model": "MID1264"
  },
  {
    "Retail Branding": "Polaroid",
    "Marketing Name": "MID1464PR001",
    "Device": "MID1464PR001",
    "Model": "MID1464PR001"
  },
  {
    "Retail Branding": "Polaroid",
    "Marketing Name": "MID3810PVE02",
    "Device": "MID3810PVE02",
    "Model": "MID3810PVE02"
  },
  {
    "Retail Branding": "Polaroid",
    "Marketing Name": "MID4004JBL",
    "Device": "MID4004JBL",
    "Model": "MID4004JBL"
  },
  {
    "Retail Branding": "Polaroid",
    "Marketing Name": "MID44JBLPR01",
    "Device": "MID44JBLPR01",
    "Model": "MID44JBLPR01"
  },
  {
    "Retail Branding": "Polaroid",
    "Marketing Name": "MID4G64PR002",
    "Device": "MID4G64PR002",
    "Model": "MID4G64PR002"
  },
  {
    "Retail Branding": "Polaroid",
    "Marketing Name": "MID4X07",
    "Device": "RCT6773W22",
    "Model": "MID4X07"
  },
  {
    "Retail Branding": "Polaroid",
    "Marketing Name": "MID4X10",
    "Device": "RCT6203W46",
    "Model": "MID4X10"
  },
  {
    "Retail Branding": "Polaroid",
    "Marketing Name": "MID8254PR",
    "Device": "MID8254PR",
    "Model": "MID8254PR"
  },
  {
    "Retail Branding": "Polaroid",
    "Marketing Name": "MIDB1048PHE",
    "Device": "MIDB1048PHE",
    "Model": "MIDB1048PHE"
  },
  {
    "Retail Branding": "Polaroid",
    "Marketing Name": "MIDI109PDE",
    "Device": "MIDI109PDE",
    "Model": "MIDI109PDE"
  },
  {
    "Retail Branding": "Polaroid",
    "Marketing Name": "MIDI163PDE",
    "Device": "MIDI163PDE",
    "Model": "MIDI163PDE"
  },
  {
    "Retail Branding": "Polaroid",
    "Marketing Name": "MIDI70WPDE",
    "Device": "MIDI70WPDE",
    "Model": "MIDI70WPDE"
  },
  {
    "Retail Branding": "Polaroid",
    "Marketing Name": "MIDS185PR",
    "Device": "MIDS185PR",
    "Model": "MIDS185PR"
  },
  {
    "Retail Branding": "Polaroid",
    "Marketing Name": "MIDS2410PR001",
    "Device": "MIDS2410PR001",
    "Model": "MIDS2410PR001"
  },
  {
    "Retail Branding": "Polaroid",
    "Marketing Name": "Mobility3G",
    "Device": "Mobility3G",
    "Model": "Mobility3G"
  },
  {
    "Retail Branding": "Polaroid",
    "Marketing Name": "P10/Q10/PTAB1040/PTAB1041",
    "Device": "pq10-Polaroid",
    "Model": "P10/Q10/PTAB1040/PTAB1041"
  },
  {
    "Retail Branding": "Polaroid",
    "Marketing Name": "P1000",
    "Device": "P1000",
    "Model": "P1000"
  },
  {
    "Retail Branding": "Polaroid",
    "Marketing Name": "P1001",
    "Device": "P1001",
    "Model": "P1001"
  },
  {
    "Retail Branding": "Polaroid",
    "Marketing Name": "P4526A",
    "Device": "P4526A",
    "Model": "P4526A"
  },
  {
    "Retail Branding": "Polaroid",
    "Marketing Name": "P5006A",
    "Device": "P5006A",
    "Model": "P5006A"
  },
  {
    "Retail Branding": "Polaroid",
    "Marketing Name": "P5526A",
    "Device": "P5526A",
    "Model": "P5526A"
  },
  {
    "Retail Branding": "Polaroid",
    "Marketing Name": "P7/Q7/PTAB740/PTAB741",
    "Device": "pq7-Polaroid",
    "Model": "P7/Q7/PTAB740/PTAB741"
  },
  {
    "Retail Branding": "Polaroid",
    "Marketing Name": "P791",
    "Device": "P791",
    "Model": "P791"
  },
  {
    "Retail Branding": "Polaroid",
    "Marketing Name": "P9/Q9/PTAB940/PTAB941",
    "Device": "pq9-Polaroid",
    "Model": "P9/Q9/PTAB940/PTAB941"
  },
  {
    "Retail Branding": "Polaroid",
    "Marketing Name": "P900",
    "Device": "P900",
    "Model": "P900/Q900"
  },
  {
    "Retail Branding": "Polaroid",
    "Marketing Name": "P901",
    "Device": "P901",
    "Model": "P901"
  },
  {
    "Retail Branding": "Polaroid",
    "Marketing Name": "PMID7102DC",
    "Device": "PMID7102DC",
    "Model": "PMID7102DC"
  },
  {
    "Retail Branding": "Polaroid",
    "Marketing Name": "POCMTV000",
    "Device": "POCMTV000",
    "Model": "POCMTV000"
  },
  {
    "Retail Branding": "Polaroid",
    "Marketing Name": "POMDTB002",
    "Device": "POMDTB002",
    "Model": "POMDTB002"
  },
  {
    "Retail Branding": "Polaroid",
    "Marketing Name": "POMDTB005",
    "Device": "POMDTB005",
    "Model": "POMDTB005"
  },
  {
    "Retail Branding": "Polaroid",
    "Marketing Name": "POMDTB006",
    "Device": "POMDTB006",
    "Model": "POMDTB006"
  },
  {
    "Retail Branding": "Polaroid",
    "Marketing Name": "POMDTB007",
    "Device": "POMDTB007",
    "Model": "POMDTB007"
  },
  {
    "Retail Branding": "Polaroid",
    "Marketing Name": "POMDTB008",
    "Device": "POMDTB008",
    "Model": "POMDTB008"
  },
  {
    "Retail Branding": "Polaroid",
    "Marketing Name": "PRO5023PW",
    "Device": "up06_h25_polaroid",
    "Model": "PRO5023PW"
  },
  {
    "Retail Branding": "Polaroid",
    "Marketing Name": "PRO5043",
    "Device": "PRO5043",
    "Model": "PRO5043"
  },
  {
    "Retail Branding": "Polaroid",
    "Marketing Name": "PRO5044PEE01",
    "Device": "Polaroid_PRO5044PEE01",
    "Model": "PRO5044PEE01"
  },
  {
    "Retail Branding": "Polaroid",
    "Marketing Name": "PRO55164PGE01",
    "Device": "PRO55164PGE01",
    "Model": "PRO55164PGE01"
  },
  {
    "Retail Branding": "Polaroid",
    "Marketing Name": "PRO5544PEE01",
    "Device": "PRO5544PEE01",
    "Model": "PRO5544PEE01"
  },
  {
    "Retail Branding": "Polaroid",
    "Marketing Name": "PRO5548PR010.191",
    "Device": "PRO5548PR010",
    "Model": "PRO5548PR010"
  },
  {
    "Retail Branding": "Polaroid",
    "Marketing Name": "PRO5584PGE01",
    "Device": "PRO5584PGE01",
    "Model": "PRO5584PGE01"
  },
  {
    "Retail Branding": "Polaroid",
    "Marketing Name": "PRO5584PHE01",
    "Device": "PRO5584PHE01",
    "Model": "PRO5584PHE01"
  },
  {
    "Retail Branding": "Polaroid",
    "Marketing Name": "PRO6048",
    "Device": "PRO6048",
    "Model": "PRO6048PR001"
  },
  {
    "Retail Branding": "Polaroid",
    "Marketing Name": "PRO6084FPGE01",
    "Device": "PRO6084FPGE01",
    "Model": "PRO6084FPGE01"
  },
  {
    "Retail Branding": "Polaroid",
    "Marketing Name": "PSPCK20NA",
    "Device": "PSPCK20NA",
    "Model": "PSPCK20NA"
  },
  {
    "Retail Branding": "Polaroid",
    "Marketing Name": "PSPCK21NA",
    "Device": "PSPCK21NA",
    "Model": "PSPCK21NA"
  },
  {
    "Retail Branding": "Polaroid",
    "Marketing Name": "PSPCL20A0",
    "Device": "PSPCL20A0",
    "Model": "PSPCL20A0"
  },
  {
    "Retail Branding": "Polaroid",
    "Marketing Name": "PSPCL30A0",
    "Device": "PSPCL30A0",
    "Model": "PSPCL30A0"
  },
  {
    "Retail Branding": "Polaroid",
    "Marketing Name": "PSPTD21NA",
    "Device": "PSPTD21NA",
    "Model": "PSPTD21NA"
  },
  {
    "Retail Branding": "Polaroid",
    "Marketing Name": "PTAB1051-PTAB1055",
    "Device": "RCT6203W46",
    "Model": "PTAB1051_PTAB1055"
  },
  {
    "Retail Branding": "Polaroid",
    "Marketing Name": "PTAB751",
    "Device": "STJR76",
    "Model": "PTAB751"
  },
  {
    "Retail Branding": "Polaroid",
    "Marketing Name": "Phantom 5",
    "Device": "Phantom5",
    "Model": "PRO5023"
  },
  {
    "Retail Branding": "Polaroid",
    "Marketing Name": "Polaroid",
    "Device": "bangbae",
    "Model": "Polaroid 4K Android TV"
  },
  {
    "Retail Branding": "Polaroid",
    "Marketing Name": "Polaroid",
    "Device": "bruno",
    "Model": "Polaroid 2K Android TV"
  },
  {
    "Retail Branding": "Polaroid",
    "Marketing Name": "Polaroid",
    "Device": "ewha",
    "Model": "AQUOS-TVE19K"
  },
  {
    "Retail Branding": "Polaroid",
    "Marketing Name": "Polaroid",
    "Device": "ewha",
    "Model": "POLA-TVE19K"
  },
  {
    "Retail Branding": "Polaroid",
    "Marketing Name": "Polaroid",
    "Device": "komagome",
    "Model": "Polaroid 2K Android TV"
  },
  {
    "Retail Branding": "Polaroid",
    "Marketing Name": "Polaroid",
    "Device": "shilin",
    "Model": "Polaroid4KAndroidTV"
  },
  {
    "Retail Branding": "Polaroid",
    "Marketing Name": "Polaroid 2K Android TV",
    "Device": "lasalle",
    "Model": "Polaroid 2K Android TV"
  },
  {
    "Retail Branding": "Polaroid",
    "Marketing Name": "Polaroid 4K Android TV",
    "Device": "kenton",
    "Model": "Polaroid 4K Android TV"
  },
  {
    "Retail Branding": "Polaroid",
    "Marketing Name": "Polaroid android TV",
    "Device": "hanyang",
    "Model": "Polaroid Android TV"
  },
  {
    "Retail Branding": "Polaroid",
    "Marketing Name": "SIGMA 5",
    "Device": "SIGMA-5",
    "Model": "SIGMA-5"
  },
  {
    "Retail Branding": "Polaroid",
    "Marketing Name": "SMX4K",
    "Device": "GMP",
    "Model": "SMX4K"
  },
  {
    "Retail Branding": "Polaroid",
    "Marketing Name": "SOHO",
    "Device": "SOHO",
    "Model": "SOHO"
  },
  {
    "Retail Branding": "Polaroid",
    "Marketing Name": "V45M",
    "Device": "V45M",
    "Model": "CARBON_PRO4543"
  },
  {
    "Retail Branding": "Polaroid",
    "Marketing Name": "V7",
    "Device": "nuclear-M7021",
    "Model": "V7"
  },
  {
    "Retail Branding": "Polaroid",
    "Marketing Name": "midcb232pr_EEA",
    "Device": "midcb232pr",
    "Model": "midcb232pr"
  },
  {
    "Retail Branding": "Polaroid",
    "Marketing Name": "polaroid",
    "Device": "ewha",
    "Model": "POLA-TVE19K"
  },
  {
    "Retail Branding": "Polaroid",
    "Marketing Name": "polaroid",
    "Device": "sindang",
    "Model": "POLA-TVE19M"
  },
  {
    "Retail Branding": "Polestar",
    "Marketing Name": "Polestar",
    "Device": "ihu42",
    "Model": "Polestar"
  },
  {
    "Retail Branding": "Polestar",
    "Marketing Name": "Polestar",
    "Device": "ihu_abl_car",
    "Model": "Polestar"
  },
  {
    "Retail Branding": "Polestar",
    "Marketing Name": "Polestar",
    "Device": "jalapeno",
    "Model": "PS4"
  },
  {
    "Retail Branding": "Polestar",
    "Marketing Name": "Polestar",
    "Device": "moose",
    "Model": "Polestar"
  },
  {
    "Retail Branding": "Polestar",
    "Marketing Name": "Polestar Emu",
    "Device": "ihu_emulator",
    "Model": "Polestar 2"
  },
  {
    "Retail Branding": "Polytron",
    "Marketing Name": "2K",
    "Device": "hayward",
    "Model": "POLYTRON2K"
  },
  {
    "Retail Branding": "Polytron",
    "Marketing Name": "4K Smart TV",
    "Device": "pioneer",
    "Model": "4K PA Smart TV"
  },
  {
    "Retail Branding": "Polytron",
    "Marketing Name": "P500",
    "Device": "P500",
    "Model": "P500"
  },
  {
    "Retail Branding": "Polytron",
    "Marketing Name": "P551S",
    "Device": "P551S",
    "Model": "P551S"
  },
  {
    "Retail Branding": "Polytron",
    "Marketing Name": "PDB-F2",
    "Device": "PDB_F2",
    "Model": "PDB-F2"
  },
  {
    "Retail Branding": "Polytron",
    "Marketing Name": "PLD43UG5959/PLD43BUG5959/PLD50UG5959/PLD50BUG5959/PLD55UG5959/",
    "Device": "songshan",
    "Model": "POLYTRON4K"
  },
  {
    "Retail Branding": "Polytron",
    "Marketing Name": "POLYTRON P552",
    "Device": "POLYTRON_P552",
    "Model": "POLYTRON_P552"
  },
  {
    "Retail Branding": "Polytron",
    "Marketing Name": "POLYTRON R2509",
    "Device": "POLYTRON_R2509",
    "Model": "POLYTRON R2509"
  },
  {
    "Retail Branding": "Polytron",
    "Marketing Name": "POLYTRON R2509SE",
    "Device": "POLYTRON_R2509SE",
    "Model": "POLYTRON R2509SE"
  },
  {
    "Retail Branding": "Polytron",
    "Marketing Name": "POLYTRON R250A",
    "Device": "POLYTRON_R250A",
    "Model": "POLYTRON R250A"
  },
  {
    "Retail Branding": "Polytron",
    "Marketing Name": "POLYTRON2K",
    "Device": "hirano",
    "Model": "POLYTRON2K"
  },
  {
    "Retail Branding": "Polytron",
    "Marketing Name": "POLYTRON4K",
    "Device": "lushan",
    "Model": "POLYTRON4K"
  },
  {
    "Retail Branding": "Polytron",
    "Marketing Name": "POLYTRON_T553",
    "Device": "POLYTRON_T553",
    "Model": "POLYTRON_T553"
  },
  {
    "Retail Branding": "Polytron",
    "Marketing Name": "PRIME A8",
    "Device": "POLYTRON_A552",
    "Model": "A552"
  },
  {
    "Retail Branding": "Polytron",
    "Marketing Name": "PRIME T8",
    "Device": "POLYTRON_R255B",
    "Model": "R255B"
  },
  {
    "Retail Branding": "Polytron",
    "Marketing Name": "Polytron 2K AI Smart TV",
    "Device": "osaki",
    "Model": "2K AI Smart TV"
  },
  {
    "Retail Branding": "Polytron",
    "Marketing Name": "R10G",
    "Device": "R10G",
    "Model": "POLYTRON4K"
  },
  {
    "Retail Branding": "Polytron",
    "Marketing Name": "Smart TV",
    "Device": "mateo",
    "Model": "2K PA Smart TV"
  },
  {
    "Retail Branding": "Polytron",
    "Marketing Name": "T7001",
    "Device": "T7001",
    "Model": "T7001"
  },
  {
    "Retail Branding": "Polytron",
    "Marketing Name": "T8001",
    "Device": "T8001",
    "Model": "T8001"
  },
  {
    "Retail Branding": "Porodo",
    "Marketing Name": "Ultra_Max_10_1",
    "Device": "Ultra_Max_10_1",
    "Model": "Ultra_Max_10_1"
  },
  {
    "Retail Branding": "Porsche",
    "Marketing Name": "Porsche",
    "Device": "sdis1",
    "Model": "Porsche Rear Seat Entertainment"
  },
  {
    "Retail Branding": "Porsche",
    "Marketing Name": "Rear  Seat  Entertainment",
    "Device": "sdis1",
    "Model": "Porsche Rear Seat Entertainment"
  },
  {
    "Retail Branding": "Porsche",
    "Marketing Name": "SDIS1",
    "Device": "sdis1",
    "Model": "Porsche Rear Seat Entertainment"
  },
  {
    "Retail Branding": "Portworld",
    "Marketing Name": "YC-M10",
    "Device": "YC-M10",
    "Model": "YC-M10"
  },
  {
    "Retail Branding": "Posiflex",
    "Marketing Name": "BT-2000",
    "Device": "BT-2000",
    "Model": "BT-2000"
  },
  {
    "Retail Branding": "Posiflex",
    "Marketing Name": "MK_1000",
    "Device": "MK_1000",
    "Model": "MK_1000"
  },
  {
    "Retail Branding": "Posiflex",
    "Marketing Name": "MT-6208A",
    "Device": "Opera",
    "Model": "Posiflex MT62"
  },
  {
    "Retail Branding": "Positivo",
    "Marketing Name": "8MA-A",
    "Device": "ochoMA_A_3G",
    "Model": "8MA-A 3G"
  },
  {
    "Retail Branding": "Positivo",
    "Marketing Name": "AB10PGN",
    "Device": "AB10PGN",
    "Model": "AB10PGN"
  },
  {
    "Retail Branding": "Positivo",
    "Marketing Name": "AB7",
    "Device": "YPY_AB7D",
    "Model": "YPY_AB7D"
  },
  {
    "Retail Branding": "Positivo",
    "Marketing Name": "AB7D",
    "Device": "YPY_AB7DC",
    "Model": "YPY_AB7DC"
  },
  {
    "Retail Branding": "Positivo",
    "Marketing Name": "BGH 7Di-A",
    "Device": "Y210",
    "Model": "Positivo BGH 7Di-A"
  },
  {
    "Retail Branding": "Positivo",
    "Marketing Name": "BGH Y200",
    "Device": "T710",
    "Model": "Positivo BGH Y200"
  },
  {
    "Retail Branding": "Positivo",
    "Marketing Name": "BGH Y230",
    "Device": "T760",
    "Model": "Y230"
  },
  {
    "Retail Branding": "Positivo",
    "Marketing Name": "First",
    "Device": "S410",
    "Model": "First"
  },
  {
    "Retail Branding": "Positivo",
    "Marketing Name": "Life",
    "Device": "S421",
    "Model": "S421 Positivo Life"
  },
  {
    "Retail Branding": "Positivo",
    "Marketing Name": "M10 4G PRO X",
    "Device": "T2040",
    "Model": "M10 4G PRO X"
  },
  {
    "Retail Branding": "Positivo",
    "Marketing Name": "M10 4G PRO X",
    "Device": "T2040",
    "Model": "T2040"
  },
  {
    "Retail Branding": "Positivo",
    "Marketing Name": "M10 4G PRO X",
    "Device": "T2040",
    "Model": "TAB Q10"
  },
  {
    "Retail Branding": "Positivo",
    "Marketing Name": "M10 4G PRO X",
    "Device": "T2040",
    "Model": "Tab Q10"
  },
  {
    "Retail Branding": "Positivo",
    "Marketing Name": "Mini",
    "Device": "mini",
    "Model": "Positivo Mini"
  },
  {
    "Retail Branding": "Positivo",
    "Marketing Name": "Mini",
    "Device": "mini",
    "Model": "Positivo Mini TE"
  },
  {
    "Retail Branding": "Positivo",
    "Marketing Name": "Next",
    "Device": "X500",
    "Model": "Positivo Next"
  },
  {
    "Retail Branding": "Positivo",
    "Marketing Name": "OCTA",
    "Device": "OCTA",
    "Model": "OCTA"
  },
  {
    "Retail Branding": "Positivo",
    "Marketing Name": "One",
    "Device": "S420",
    "Model": "Positivo One"
  },
  {
    "Retail Branding": "Positivo",
    "Marketing Name": "One",
    "Device": "S420",
    "Model": "S420"
  },
  {
    "Retail Branding": "Positivo",
    "Marketing Name": "Positivo Q20",
    "Device": "Q20",
    "Model": "Positivo Q20"
  },
  {
    "Retail Branding": "Positivo",
    "Marketing Name": "Positivo Q20",
    "Device": "Q20",
    "Model": "Quantum Q20"
  },
  {
    "Retail Branding": "Positivo",
    "Marketing Name": "Positivo T1075B",
    "Device": "T1075B",
    "Model": "T1075B"
  },
  {
    "Retail Branding": "Positivo",
    "Marketing Name": "Positivo T760",
    "Device": "T760",
    "Model": "T760"
  },
  {
    "Retail Branding": "Positivo",
    "Marketing Name": "Positivo Ypy 10 STA",
    "Device": "YPY10STA",
    "Model": "YPY10STA"
  },
  {
    "Retail Branding": "Positivo",
    "Marketing Name": "Positivo Ypy 10FTA",
    "Device": "YPY10FTA",
    "Model": "YPY10FTA"
  },
  {
    "Retail Branding": "Positivo",
    "Marketing Name": "S380",
    "Device": "S380",
    "Model": "S380"
  },
  {
    "Retail Branding": "Positivo",
    "Marketing Name": "S430 Positivo Twist Mini",
    "Device": "S430",
    "Model": "S430 Positivo Twist Mini"
  },
  {
    "Retail Branding": "Positivo",
    "Marketing Name": "S440",
    "Device": "S440",
    "Model": "S440"
  },
  {
    "Retail Branding": "Positivo",
    "Marketing Name": "S450",
    "Device": "S450",
    "Model": "S450"
  },
  {
    "Retail Branding": "Positivo",
    "Marketing Name": "S480",
    "Device": "S480",
    "Model": "S480"
  },
  {
    "Retail Branding": "Positivo",
    "Marketing Name": "S550",
    "Device": "S550",
    "Model": "S550"
  },
  {
    "Retail Branding": "Positivo",
    "Marketing Name": "S620",
    "Device": "S620",
    "Model": "S620"
  },
  {
    "Retail Branding": "Positivo",
    "Marketing Name": "S620",
    "Device": "S620",
    "Model": "Twist 5"
  },
  {
    "Retail Branding": "Positivo",
    "Marketing Name": "SP2",
    "Device": "SP2",
    "Model": "SP2"
  },
  {
    "Retail Branding": "Positivo",
    "Marketing Name": "SX1000",
    "Device": "SX1000",
    "Model": "Positivo SX1000"
  },
  {
    "Retail Branding": "Positivo",
    "Marketing Name": "Selfie",
    "Device": "S455",
    "Model": "S455"
  },
  {
    "Retail Branding": "Positivo",
    "Marketing Name": "Slim",
    "Device": "S510",
    "Model": "Positivo Slim"
  },
  {
    "Retail Branding": "Positivo",
    "Marketing Name": "Stilo T725",
    "Device": "T725",
    "Model": "Stilo T725"
  },
  {
    "Retail Branding": "Positivo",
    "Marketing Name": "T1060",
    "Device": "t1060",
    "Model": "T1060"
  },
  {
    "Retail Branding": "Positivo",
    "Marketing Name": "T1060",
    "Device": "t1060",
    "Model": "T1060B"
  },
  {
    "Retail Branding": "Positivo",
    "Marketing Name": "T1060",
    "Device": "t1060",
    "Model": "T1060C"
  },
  {
    "Retail Branding": "Positivo",
    "Marketing Name": "T1075",
    "Device": "T1075",
    "Model": "Positivo T1075"
  },
  {
    "Retail Branding": "Positivo",
    "Marketing Name": "T1085",
    "Device": "T1085",
    "Model": "T1085"
  },
  {
    "Retail Branding": "Positivo",
    "Marketing Name": "T2040",
    "Device": "T2040B",
    "Model": "T2040"
  },
  {
    "Retail Branding": "Positivo",
    "Marketing Name": "T2050C",
    "Device": "T2050C",
    "Model": "T2050C"
  },
  {
    "Retail Branding": "Positivo",
    "Marketing Name": "T2050C",
    "Device": "T2050C",
    "Model": "Tab Q10"
  },
  {
    "Retail Branding": "Positivo",
    "Marketing Name": "T2070D",
    "Device": "T2070D",
    "Model": "T2070"
  },
  {
    "Retail Branding": "Positivo",
    "Marketing Name": "T3010D",
    "Device": "T3010D",
    "Model": "Vision Tab 10"
  },
  {
    "Retail Branding": "Positivo",
    "Marketing Name": "T701 TV",
    "Device": "T701",
    "Model": "T701"
  },
  {
    "Retail Branding": "Positivo",
    "Marketing Name": "T705",
    "Device": "T705",
    "Model": "T705"
  },
  {
    "Retail Branding": "Positivo",
    "Marketing Name": "T705",
    "Device": "T705",
    "Model": "T705/T708"
  },
  {
    "Retail Branding": "Positivo",
    "Marketing Name": "T705",
    "Device": "T705",
    "Model": "T705K"
  },
  {
    "Retail Branding": "Positivo",
    "Marketing Name": "T710",
    "Device": "T710",
    "Model": "Positivo T710"
  },
  {
    "Retail Branding": "Positivo",
    "Marketing Name": "T715",
    "Device": "T715",
    "Model": "Stilo T715"
  },
  {
    "Retail Branding": "Positivo",
    "Marketing Name": "T730",
    "Device": "T730",
    "Model": "Positivo Stilo T730 Kids"
  },
  {
    "Retail Branding": "Positivo",
    "Marketing Name": "T750",
    "Device": "t750",
    "Model": "Positivo T750"
  },
  {
    "Retail Branding": "Positivo",
    "Marketing Name": "T800",
    "Device": "T800",
    "Model": "T800"
  },
  {
    "Retail Branding": "Positivo",
    "Marketing Name": "T800",
    "Device": "T800",
    "Model": "TabQ8-T800"
  },
  {
    "Retail Branding": "Positivo",
    "Marketing Name": "T800",
    "Device": "T800M",
    "Model": "T800"
  },
  {
    "Retail Branding": "Positivo",
    "Marketing Name": "T800",
    "Device": "T800M",
    "Model": "TabQ8-T800"
  },
  {
    "Retail Branding": "Positivo",
    "Marketing Name": "T810",
    "Device": "T810",
    "Model": "T810"
  },
  {
    "Retail Branding": "Positivo",
    "Marketing Name": "T810",
    "Device": "T810",
    "Model": "Tab Q8 Lite"
  },
  {
    "Retail Branding": "Positivo",
    "Marketing Name": "T810C",
    "Device": "T810C",
    "Model": "T810"
  },
  {
    "Retail Branding": "Positivo",
    "Marketing Name": "TL10",
    "Device": "TL10",
    "Model": "TL10"
  },
  {
    "Retail Branding": "Positivo",
    "Marketing Name": "TL10",
    "Device": "TL10",
    "Model": "Vaio TL10"
  },
  {
    "Retail Branding": "Positivo",
    "Marketing Name": "TL10",
    "Device": "TL10",
    "Model": "Vaio TL10A"
  },
  {
    "Retail Branding": "Positivo",
    "Marketing Name": "Tab Q10",
    "Device": "T2050M",
    "Model": "Tab Q10"
  },
  {
    "Retail Branding": "Positivo",
    "Marketing Name": "Twist",
    "Device": "S520",
    "Model": "Positivo Twist M"
  },
  {
    "Retail Branding": "Positivo",
    "Marketing Name": "Twist",
    "Device": "S520",
    "Model": "Positivo Twist S"
  },
  {
    "Retail Branding": "Positivo",
    "Marketing Name": "Twist 2",
    "Device": "S512",
    "Model": "Twist 2"
  },
  {
    "Retail Branding": "Positivo",
    "Marketing Name": "Twist 2 Fit",
    "Device": "S509",
    "Model": "Twist 2 Fit"
  },
  {
    "Retail Branding": "Positivo",
    "Marketing Name": "Twist 2 Go",
    "Device": "S541",
    "Model": "Twist 2 Go"
  },
  {
    "Retail Branding": "Positivo",
    "Marketing Name": "Twist 2 Pro",
    "Device": "S532",
    "Model": "Twist 2 Pro"
  },
  {
    "Retail Branding": "Positivo",
    "Marketing Name": "Twist 2 Pro",
    "Device": "S532",
    "Model": "Twist 3"
  },
  {
    "Retail Branding": "Positivo",
    "Marketing Name": "Twist 2018",
    "Device": "S511",
    "Model": "Twist (2018)"
  },
  {
    "Retail Branding": "Positivo",
    "Marketing Name": "Twist 4",
    "Device": "S514",
    "Model": "Twist 4"
  },
  {
    "Retail Branding": "Positivo",
    "Marketing Name": "Twist 4 Fit",
    "Device": "S509N",
    "Model": "Twist 4 Fit"
  },
  {
    "Retail Branding": "Positivo",
    "Marketing Name": "Twist 4 Fit",
    "Device": "S509N",
    "Model": "YOLO"
  },
  {
    "Retail Branding": "Positivo",
    "Marketing Name": "Twist 4 Mini",
    "Device": "S432",
    "Model": "Twist 4 Mini"
  },
  {
    "Retail Branding": "Positivo",
    "Marketing Name": "Twist 4 Pro",
    "Device": "S518",
    "Model": "Twist 4 Pro"
  },
  {
    "Retail Branding": "Positivo",
    "Marketing Name": "Twist 4 Pro",
    "Device": "S518",
    "Model": "Twist 4 Pro Correios"
  },
  {
    "Retail Branding": "Positivo",
    "Marketing Name": "Twist 4 Pro",
    "Device": "S518",
    "Model": "UP 32"
  },
  {
    "Retail Branding": "Positivo",
    "Marketing Name": "Twist 4G",
    "Device": "S5094G",
    "Model": "Twist 4G"
  },
  {
    "Retail Branding": "Positivo",
    "Marketing Name": "Twist 4G",
    "Device": "S520_4G",
    "Model": "Positivo Twist 4G"
  },
  {
    "Retail Branding": "Positivo",
    "Marketing Name": "Twist 5 Max",
    "Device": "S650",
    "Model": "Twist 5 Max"
  },
  {
    "Retail Branding": "Positivo",
    "Marketing Name": "Twist 5 Pro",
    "Device": "S640",
    "Model": "Twist 5 Pro"
  },
  {
    "Retail Branding": "Positivo",
    "Marketing Name": "Twist Max",
    "Device": "S540",
    "Model": "Twist Max"
  },
  {
    "Retail Branding": "Positivo",
    "Marketing Name": "Twist Metal",
    "Device": "S530",
    "Model": "Twist Metal"
  },
  {
    "Retail Branding": "Positivo",
    "Marketing Name": "Twist Metal 32G",
    "Device": "S531",
    "Model": "Twist Metal 32GB"
  },
  {
    "Retail Branding": "Positivo",
    "Marketing Name": "Twist Mini",
    "Device": "S430B",
    "Model": "Twist Mini"
  },
  {
    "Retail Branding": "Positivo",
    "Marketing Name": "Twist Mini (2018)",
    "Device": "S431",
    "Model": "Twist Mini"
  },
  {
    "Retail Branding": "Positivo",
    "Marketing Name": "Twist SE",
    "Device": "SP2",
    "Model": "S545"
  },
  {
    "Retail Branding": "Positivo",
    "Marketing Name": "Twist SE",
    "Device": "SP2",
    "Model": "Twist SE"
  },
  {
    "Retail Branding": "Positivo",
    "Marketing Name": "Twist Tab",
    "Device": "T770",
    "Model": "Twist Tab"
  },
  {
    "Retail Branding": "Positivo",
    "Marketing Name": "Twist Tab",
    "Device": "T770",
    "Model": "Twist Tab Kids"
  },
  {
    "Retail Branding": "Positivo",
    "Marketing Name": "Twist Tab",
    "Device": "T770E",
    "Model": "T790"
  },
  {
    "Retail Branding": "Positivo",
    "Marketing Name": "Twist Tab",
    "Device": "T770E",
    "Model": "Twist Tab"
  },
  {
    "Retail Branding": "Positivo",
    "Marketing Name": "Twist Tab",
    "Device": "T770G",
    "Model": "Twist Tab"
  },
  {
    "Retail Branding": "Positivo",
    "Marketing Name": "Twist Tab",
    "Device": "T770G",
    "Model": "Twist Tab +"
  },
  {
    "Retail Branding": "Positivo",
    "Marketing Name": "Twist Tab",
    "Device": "T770G",
    "Model": "Twist Tab Minions +"
  },
  {
    "Retail Branding": "Positivo",
    "Marketing Name": "Twist Tab",
    "Device": "T770G",
    "Model": "Twist Tab SPIDEY +"
  },
  {
    "Retail Branding": "Positivo",
    "Marketing Name": "Twist Tab Kids",
    "Device": "T770",
    "Model": "Twist Tab"
  },
  {
    "Retail Branding": "Positivo",
    "Marketing Name": "Twist Tab Kids",
    "Device": "T770",
    "Model": "Twist Tab Kids"
  },
  {
    "Retail Branding": "Positivo",
    "Marketing Name": "Twist XL",
    "Device": "S555",
    "Model": "Twist XL"
  },
  {
    "Retail Branding": "Positivo",
    "Marketing Name": "Union US2070",
    "Device": "US2070",
    "Model": "Positivo US2070"
  },
  {
    "Retail Branding": "Positivo",
    "Marketing Name": "Vaio TL12",
    "Device": "TL12",
    "Model": "Vaio TL12"
  },
  {
    "Retail Branding": "Positivo",
    "Marketing Name": "Vision Tab 7",
    "Device": "T307F",
    "Model": "T307F"
  },
  {
    "Retail Branding": "Positivo",
    "Marketing Name": "X400",
    "Device": "X400",
    "Model": "X400"
  },
  {
    "Retail Branding": "Positivo",
    "Marketing Name": "YPY 10 3G",
    "Device": "YPY_10FTA",
    "Model": "YPY_10FTA"
  },
  {
    "Retail Branding": "Positivo",
    "Marketing Name": "YPY AB7",
    "Device": "YPY_AB7",
    "Model": "Positivo Ypy AB7E"
  },
  {
    "Retail Branding": "Positivo",
    "Marketing Name": "YPY AB7",
    "Device": "YPY_AB7",
    "Model": "Positivo Ypy AB7EC"
  },
  {
    "Retail Branding": "Positivo",
    "Marketing Name": "YPY S400",
    "Device": "YPY_S400",
    "Model": "YPY_S400"
  },
  {
    "Retail Branding": "Positivo",
    "Marketing Name": "YPY7 3G",
    "Device": "TB07FTA",
    "Model": "Positivo Ypy 7 - TB07FTA"
  },
  {
    "Retail Branding": "Positivo",
    "Marketing Name": "YPY7 3G",
    "Device": "TB07FTA",
    "Model": "Ypy 7 - TB07FTA"
  },
  {
    "Retail Branding": "Positivo",
    "Marketing Name": "YPY7 3G",
    "Device": "YPY_07FTA",
    "Model": "YPY_07FTA"
  },
  {
    "Retail Branding": "Positivo",
    "Marketing Name": "YPY7 wifi",
    "Device": "TB07STA",
    "Model": "Positivo Ypy 7 - TB07STA"
  },
  {
    "Retail Branding": "Positivo",
    "Marketing Name": "YPY7 wifi",
    "Device": "TB07STA",
    "Model": "Ypy 7 - TB07STA"
  },
  {
    "Retail Branding": "Positivo",
    "Marketing Name": "YPY7 wifi",
    "Device": "YPY_07STA",
    "Model": "YPY_07STA"
  },
  {
    "Retail Branding": "Positivo",
    "Marketing Name": "Ypy 07FTB",
    "Device": "YPY_07FTB",
    "Model": "POSITIVO TABLET YPY 07FTB PM BELÉM"
  },
  {
    "Retail Branding": "Positivo",
    "Marketing Name": "Ypy 07FTB",
    "Device": "YPY_07FTB",
    "Model": "YPY_07FTB"
  },
  {
    "Retail Branding": "Positivo",
    "Marketing Name": "Ypy 07FTBF",
    "Device": "YPY_07FTBF",
    "Model": "YPY_07FTBF"
  },
  {
    "Retail Branding": "Positivo",
    "Marketing Name": "Ypy 07STB",
    "Device": "YPY_07STB",
    "Model": "YPY_07STB"
  },
  {
    "Retail Branding": "Positivo",
    "Marketing Name": "Ypy 07STBF",
    "Device": "YPY_07STBF",
    "Model": "YPY_07STBF"
  },
  {
    "Retail Branding": "Positivo",
    "Marketing Name": "Ypy 10FTB",
    "Device": "YPY_10FTB",
    "Model": "YPY_10FTB"
  },
  {
    "Retail Branding": "Positivo",
    "Marketing Name": "Ypy 10FTBF",
    "Device": "YPY_10FTBF",
    "Model": "YPY_10FTBF"
  },
  {
    "Retail Branding": "Positivo",
    "Marketing Name": "Ypy 10STB",
    "Device": "YPY_10STB",
    "Model": "YPY_10STB"
  },
  {
    "Retail Branding": "Positivo",
    "Marketing Name": "Ypy 10STBF",
    "Device": "YPY_10STBF",
    "Model": "YPY_10STBF"
  },
  {
    "Retail Branding": "Positivo",
    "Marketing Name": "Ypy AB10",
    "Device": "YPY_AB10D",
    "Model": "YPY_AB10D"
  },
  {
    "Retail Branding": "Positivo",
    "Marketing Name": "Ypy AB10D",
    "Device": "YPY_AB10DC",
    "Model": "YPY_AB10DC"
  },
  {
    "Retail Branding": "Positivo",
    "Marketing Name": "Ypy AB10DP",
    "Device": "YPY_AB10DP",
    "Model": "YPY_AB10DP"
  },
  {
    "Retail Branding": "Positivo",
    "Marketing Name": "Ypy AB10E",
    "Device": "YPY_AB10E",
    "Model": "Positivo Ypy AB10E"
  },
  {
    "Retail Branding": "Positivo",
    "Marketing Name": "Ypy AB10E",
    "Device": "YPY_AB10EC",
    "Model": "Positivo Ypy AB10EC"
  },
  {
    "Retail Branding": "Positivo",
    "Marketing Name": "Ypy AB10H",
    "Device": "YPY_AB10H",
    "Model": "Positivo Ypy AB10H"
  },
  {
    "Retail Branding": "Positivo",
    "Marketing Name": "Ypy AB10i",
    "Device": "Ypy_AB10i",
    "Model": "Ypy AB10i"
  },
  {
    "Retail Branding": "Positivo",
    "Marketing Name": "Ypy AB7F",
    "Device": "YPY_AB7F",
    "Model": "Positivo Ypy AB7F"
  },
  {
    "Retail Branding": "Positivo",
    "Marketing Name": "Ypy AB7F",
    "Device": "YPY_AB7F",
    "Model": "T720"
  },
  {
    "Retail Branding": "Positivo",
    "Marketing Name": "Ypy AB7K",
    "Device": "YPY_AB7K",
    "Model": "YPY_AB7K"
  },
  {
    "Retail Branding": "Positivo",
    "Marketing Name": "Ypy Kids",
    "Device": "YPY_L700",
    "Model": "Positivo Ypy L700 Kids"
  },
  {
    "Retail Branding": "Positivo",
    "Marketing Name": "Ypy Kids",
    "Device": "YPY_L700",
    "Model": "Positivo Ypy L700+ Kids"
  },
  {
    "Retail Branding": "Positivo",
    "Marketing Name": "Ypy L1000",
    "Device": "YPY_L1000",
    "Model": "Positivo Ypy L1000"
  },
  {
    "Retail Branding": "Positivo",
    "Marketing Name": "Ypy L1000",
    "Device": "YPY_L1000",
    "Model": "Positivo Ypy L1000F"
  },
  {
    "Retail Branding": "Positivo",
    "Marketing Name": "Ypy L1050",
    "Device": "YPY_L1050",
    "Model": "Positivo Ypy L1050"
  },
  {
    "Retail Branding": "Positivo",
    "Marketing Name": "Ypy L1050",
    "Device": "YPY_L1050",
    "Model": "Positivo Ypy L1050F"
  },
  {
    "Retail Branding": "Positivo",
    "Marketing Name": "Ypy L1050E",
    "Device": "YPY_L1050E",
    "Model": "Positivo Ypy L1050E"
  },
  {
    "Retail Branding": "Positivo",
    "Marketing Name": "Ypy L700",
    "Device": "YPY_L700",
    "Model": "Positivo Ypy L700"
  },
  {
    "Retail Branding": "Positivo",
    "Marketing Name": "Ypy L700",
    "Device": "YPY_L700",
    "Model": "Positivo Ypy L700 Ed. Especial"
  },
  {
    "Retail Branding": "Positivo",
    "Marketing Name": "Ypy L700",
    "Device": "YPY_L700",
    "Model": "Positivo Ypy L700+"
  },
  {
    "Retail Branding": "Positivo",
    "Marketing Name": "Ypy Mini",
    "Device": "mini",
    "Model": "Positivo BGH Mini"
  },
  {
    "Retail Branding": "Positivo",
    "Marketing Name": "Ypy S350",
    "Device": "YPY_S350",
    "Model": "YPY_S350"
  },
  {
    "Retail Branding": "Positivo",
    "Marketing Name": "Ypy S350p",
    "Device": "YPY_S350",
    "Model": "YPY_S350_PLUS"
  },
  {
    "Retail Branding": "Positivo",
    "Marketing Name": "Ypy S405",
    "Device": "YPY_S405",
    "Model": "YPY_S405"
  },
  {
    "Retail Branding": "Positivo",
    "Marketing Name": "Ypy S450",
    "Device": "YPY_S450",
    "Model": "YPY_S450"
  },
  {
    "Retail Branding": "Positivo",
    "Marketing Name": "Ypy S460",
    "Device": "YPY_S460",
    "Model": "YPY_S460"
  },
  {
    "Retail Branding": "Positivo",
    "Marketing Name": "Ypy S500",
    "Device": "YPY_S500",
    "Model": "YPY_S500"
  },
  {
    "Retail Branding": "Positivo",
    "Marketing Name": "Ypy TQ7",
    "Device": "YPY_TQ7",
    "Model": "YPY_TQ7"
  },
  {
    "Retail Branding": "Positivo",
    "Marketing Name": "mini I",
    "Device": "mini_i",
    "Model": "Positivo BGH Y300"
  },
  {
    "Retail Branding": "Positivo",
    "Marketing Name": "mini I",
    "Device": "mini_i",
    "Model": "Positivo Mini I"
  },
  {
    "Retail Branding": "Positivo",
    "Marketing Name": "quattro",
    "Device": "X435",
    "Model": "quattro"
  },
  {
    "Retail Branding": "Positivo BGH",
    "Marketing Name": "BGH Series Q10",
    "Device": "M16QF1XMT8183",
    "Model": "Positivo BGH Series Q10"
  },
  {
    "Retail Branding": "Positivo BGH",
    "Marketing Name": "BGH Series Q10",
    "Device": "M16QF1XMT8183",
    "Model": "TAB Q10\"s"
  },
  {
    "Retail Branding": "Positivo BGH",
    "Marketing Name": "BGH Y100",
    "Device": "Y700",
    "Model": "Positivo BGH Y100"
  },
  {
    "Retail Branding": "Positivo BGH",
    "Marketing Name": "BGH Y210",
    "Device": "Y210",
    "Model": "Positivo BGH 7Di-A"
  },
  {
    "Retail Branding": "Positivo BGH",
    "Marketing Name": "BGH Y210",
    "Device": "Y210",
    "Model": "Positivo BGH Y210"
  },
  {
    "Retail Branding": "Positivo BGH",
    "Marketing Name": "BGH Y400",
    "Device": "Y400",
    "Model": "Y400"
  },
  {
    "Retail Branding": "Positivo BGH",
    "Marketing Name": "BGH Y700",
    "Device": "Y700",
    "Model": "Positivo BGH Y700"
  },
  {
    "Retail Branding": "Positivo BGH",
    "Marketing Name": "BGH Y710 kids",
    "Device": "Y700",
    "Model": "Positivo BGH Y710 KIDS"
  },
  {
    "Retail Branding": "Positivo BGH",
    "Marketing Name": "G1036",
    "Device": "G1036",
    "Model": "G1036"
  },
  {
    "Retail Branding": "Positivo BGH",
    "Marketing Name": "G1101T",
    "Device": "MJA1031",
    "Model": "G1101T"
  },
  {
    "Retail Branding": "Positivo BGH",
    "Marketing Name": "KC770",
    "Device": "KC770",
    "Model": "KC770"
  },
  {
    "Retail Branding": "Positivo BGH",
    "Marketing Name": "KC770",
    "Device": "KC771",
    "Model": "KC770"
  },
  {
    "Retail Branding": "Positivo BGH",
    "Marketing Name": "M840",
    "Device": "M840",
    "Model": "Positivo BGH M840"
  },
  {
    "Retail Branding": "Positivo BGH",
    "Marketing Name": "P718TAB",
    "Device": "P718TAB",
    "Model": "Positivo BGH P718TAB"
  },
  {
    "Retail Branding": "Positivo BGH",
    "Marketing Name": "Positivo BGH +Simple",
    "Device": "C805",
    "Model": "Positivo BGH +Simple"
  },
  {
    "Retail Branding": "Positivo BGH",
    "Marketing Name": "W750",
    "Device": "W750",
    "Model": "Positivo BGH W750"
  },
  {
    "Retail Branding": "Positivo BGH",
    "Marketing Name": "Y1000",
    "Device": "Y1000",
    "Model": "Y1000"
  },
  {
    "Retail Branding": "Positivo BGH",
    "Marketing Name": "Y1010",
    "Device": "Y1010",
    "Model": "Positivo BGH Y1010"
  },
  {
    "Retail Branding": "Positivo BGH",
    "Marketing Name": "Ypy",
    "Device": "T701_AR",
    "Model": "L701 TV"
  },
  {
    "Retail Branding": "Positivo BGH",
    "Marketing Name": "Ypy",
    "Device": "YPY_L700",
    "Model": "Positivo BGH Ypy L700"
  },
  {
    "Retail Branding": "Positivo BGH",
    "Marketing Name": "Ypy Kids",
    "Device": "YPY_L700",
    "Model": "Positivo BGH Ypy L700 Kids"
  },
  {
    "Retail Branding": "Poslab",
    "Marketing Name": "SF1560",
    "Device": "SF1560",
    "Model": "SF1560"
  },
  {
    "Retail Branding": "Postef",
    "Marketing Name": "RAISECOM_M6511",
    "Device": "RAISECOM_M6511",
    "Model": "RAISECOM M6511"
  },
  {
    "Retail Branding": "Power Green",
    "Marketing Name": "POWER GREEN",
    "Device": "zhongshan",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "Power Green",
    "Marketing Name": "POWER_GREEN",
    "Device": "stanford",
    "Model": "2K SMART TV"
  },
  {
    "Retail Branding": "Powerway",
    "Marketing Name": "DRN",
    "Device": "DRN",
    "Model": "DRN"
  },
  {
    "Retail Branding": "Powerway",
    "Marketing Name": "DRN_EEA",
    "Device": "DRN_EEA",
    "Model": "DRN_EEA"
  },
  {
    "Retail Branding": "Pozzi",
    "Marketing Name": "Pozzi Neo 1",
    "Device": "Pozzi_Neo_1",
    "Model": "Neo 1"
  },
  {
    "Retail Branding": "Pozzi",
    "Marketing Name": "Turbo",
    "Device": "Turbo",
    "Model": "Turbo"
  },
  {
    "Retail Branding": "Pravion",
    "Marketing Name": "TMS-KR01P",
    "Device": "TMS-KR01P",
    "Model": "TMS-KR01P"
  },
  {
    "Retail Branding": "Precision Biometric",
    "Marketing Name": "PBTAB-100",
    "Device": "PBTAB-100",
    "Model": "PBTAB-100"
  },
  {
    "Retail Branding": "Precision Biometric",
    "Marketing Name": "PBTAB100-1G3",
    "Device": "PBTAB100-1G3",
    "Model": "PBTAB100-1G3"
  },
  {
    "Retail Branding": "Precision Biometric",
    "Marketing Name": "PBTAB100-2G4",
    "Device": "PBTAB100-2G4",
    "Model": "PBTAB100-2G4"
  },
  {
    "Retail Branding": "Premier",
    "Marketing Name": "Android TV",
    "Device": "ikebukuro",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "Premier",
    "Marketing Name": "MAXI 20",
    "Device": "MAXI_20",
    "Model": "MAXI 20"
  },
  {
    "Retail Branding": "Premier",
    "Marketing Name": "PRM750USV",
    "Device": "samseong",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "Premier",
    "Marketing Name": "Premier_P50",
    "Device": "Premier_P50",
    "Model": "Premier P50"
  },
  {
    "Retail Branding": "Premier",
    "Marketing Name": "Smart TV",
    "Device": "longshan",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "Premier",
    "Marketing Name": "Smart TV",
    "Device": "osaka",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "Premier",
    "Marketing Name": "Smart TV",
    "Device": "redwood",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "Premier",
    "Marketing Name": "TAB-7001-16G",
    "Device": "TAB-7001-16G",
    "Model": "TAB-7001-16G"
  },
  {
    "Retail Branding": "Premier",
    "Marketing Name": "TAB-7293-16G",
    "Device": "TAB-7293-16G",
    "Model": "TAB-7293-16G"
  },
  {
    "Retail Branding": "Premier",
    "Marketing Name": "TAB-7304-16G3GS",
    "Device": "TAB-7304-16G3GS",
    "Model": "TAB-7304-16G3GS"
  },
  {
    "Retail Branding": "Premier",
    "Marketing Name": "TAB-7383-16G3GS",
    "Device": "TAB-7383-16G3GS",
    "Model": "TAB-7383-16G3GS"
  },
  {
    "Retail Branding": "Premier",
    "Marketing Name": "TAB-7522-16G3G",
    "Device": "TAB-7522-16G3G",
    "Model": "TAB-7522-16G3G"
  },
  {
    "Retail Branding": "Premier",
    "Marketing Name": "TAB-7769-32G4GS",
    "Device": "TAB-7769-32G4GS",
    "Model": "TAB-7769-32G4GS"
  },
  {
    "Retail Branding": "Premier",
    "Marketing Name": "TAB-7887-32G3GB",
    "Device": "TAB-7887-32G3GB",
    "Model": "IT_701A"
  },
  {
    "Retail Branding": "Premier",
    "Marketing Name": "TAB-7887-32G3GB",
    "Device": "TAB-7887-32G3GB",
    "Model": "TAB-7887-32G3GB"
  },
  {
    "Retail Branding": "Premier",
    "Marketing Name": "TAB-7888-32G3GB",
    "Device": "TAB-7888-32G3GB",
    "Model": "TAB-7888-32G3GB"
  },
  {
    "Retail Branding": "Premier",
    "Marketing Name": "TAB-9440-128G4G",
    "Device": "TAB-9440-128G4G",
    "Model": "TAB-9440-128G4G"
  },
  {
    "Retail Branding": "Premio",
    "Marketing Name": "185FT5050231",
    "Device": "185FT5050231",
    "Model": "185FT5050231"
  },
  {
    "Retail Branding": "Premio",
    "Marketing Name": "186FT1080231",
    "Device": "186FT1080231",
    "Model": "186FT1080231"
  },
  {
    "Retail Branding": "Premio",
    "Marketing Name": "186HS1050232",
    "Device": "186HS1050232",
    "Model": "186HS1050232"
  },
  {
    "Retail Branding": "Premio",
    "Marketing Name": "186HS1050531",
    "Device": "186HS1050531",
    "Model": "186HS1050531"
  },
  {
    "Retail Branding": "Premio",
    "Marketing Name": "186HS1080233",
    "Device": "186HS1080233",
    "Model": "P570"
  },
  {
    "Retail Branding": "Premio",
    "Marketing Name": "187HT1020331",
    "Device": "187HT1020331",
    "Model": "P710"
  },
  {
    "Retail Branding": "Premio",
    "Marketing Name": "AXE_II",
    "Device": "Premio",
    "Model": "AXE_II"
  },
  {
    "Retail Branding": "Premio",
    "Marketing Name": "Axe",
    "Device": "HMR5510",
    "Model": "Axe"
  },
  {
    "Retail Branding": "Premio",
    "Marketing Name": "EA07B00001H",
    "Device": "EA07B00001H",
    "Model": "EA07B00001H"
  },
  {
    "Retail Branding": "Premio",
    "Marketing Name": "EA07C00001H",
    "Device": "EA07C00001H",
    "Model": "EA07C00001H"
  },
  {
    "Retail Branding": "Premio",
    "Marketing Name": "ECHO",
    "Device": "ECHO",
    "Model": "ECHO"
  },
  {
    "Retail Branding": "Premio",
    "Marketing Name": "NEON_RAY_2",
    "Device": "X82",
    "Model": "X82"
  },
  {
    "Retail Branding": "Premio",
    "Marketing Name": "P490",
    "Device": "P490",
    "Model": "P490"
  },
  {
    "Retail Branding": "Premio",
    "Marketing Name": "P520",
    "Device": "P520",
    "Model": "P520"
  },
  {
    "Retail Branding": "Premio",
    "Marketing Name": "P530",
    "Device": "P530",
    "Model": "P530"
  },
  {
    "Retail Branding": "Premio",
    "Marketing Name": "P540",
    "Device": "P540",
    "Model": "P540"
  },
  {
    "Retail Branding": "Premio",
    "Marketing Name": "PREMIO P450",
    "Device": "P450",
    "Model": "P450"
  },
  {
    "Retail Branding": "Premio",
    "Marketing Name": "PREMIO_S50",
    "Device": "PREMIO_S50",
    "Model": "PREMIO S50"
  },
  {
    "Retail Branding": "Premio",
    "Marketing Name": "PREMIO_S58",
    "Device": "S58",
    "Model": "PREMIO S58"
  },
  {
    "Retail Branding": "Premio",
    "Marketing Name": "PREMIO_S89",
    "Device": "S89",
    "Model": "PREMIO_S89"
  },
  {
    "Retail Branding": "Premio",
    "Marketing Name": "PREMIO_S98",
    "Device": "S98",
    "Model": "PREMIO S98"
  },
  {
    "Retail Branding": "Premio",
    "Marketing Name": "Premio P420",
    "Device": "Premio_P420",
    "Model": "Premio P420"
  },
  {
    "Retail Branding": "Premio",
    "Marketing Name": "Premio P610",
    "Device": "Premio_P610",
    "Model": "P610"
  },
  {
    "Retail Branding": "Premio",
    "Marketing Name": "Premio P620",
    "Device": "Premio_P620",
    "Model": "P620"
  },
  {
    "Retail Branding": "Premio",
    "Marketing Name": "Premio_P451",
    "Device": "Premio_P451",
    "Model": "Premio P451"
  },
  {
    "Retail Branding": "Premio",
    "Marketing Name": "S40",
    "Device": "S40",
    "Model": "S40"
  },
  {
    "Retail Branding": "Premio",
    "Marketing Name": "S51",
    "Device": "S51",
    "Model": "S51"
  },
  {
    "Retail Branding": "Premio",
    "Marketing Name": "S53",
    "Device": "S53",
    "Model": "S53"
  },
  {
    "Retail Branding": "Premio",
    "Marketing Name": "S54",
    "Device": "S54",
    "Model": "S54"
  },
  {
    "Retail Branding": "Premio",
    "Marketing Name": "S55",
    "Device": "S55",
    "Model": "S55"
  },
  {
    "Retail Branding": "Premio",
    "Marketing Name": "S56",
    "Device": "S56",
    "Model": "S56"
  },
  {
    "Retail Branding": "Premio",
    "Marketing Name": "S57",
    "Device": "S57",
    "Model": "S57"
  },
  {
    "Retail Branding": "Premio",
    "Marketing Name": "S59",
    "Device": "S59",
    "Model": "S59"
  },
  {
    "Retail Branding": "Premio",
    "Marketing Name": "S70",
    "Device": "S70",
    "Model": "S70"
  },
  {
    "Retail Branding": "Premio",
    "Marketing Name": "S71",
    "Device": "S71",
    "Model": "S71"
  },
  {
    "Retail Branding": "Premio",
    "Marketing Name": "S72",
    "Device": "Premio_S72",
    "Model": "S72"
  },
  {
    "Retail Branding": "Premio",
    "Marketing Name": "S73",
    "Device": "S73",
    "Model": "S73"
  },
  {
    "Retail Branding": "Premio",
    "Marketing Name": "S75",
    "Device": "S75",
    "Model": "PREMIO S75"
  },
  {
    "Retail Branding": "Premio",
    "Marketing Name": "S75",
    "Device": "S75",
    "Model": "S75"
  },
  {
    "Retail Branding": "Premio",
    "Marketing Name": "S80",
    "Device": "S80",
    "Model": "S80"
  },
  {
    "Retail Branding": "Premio",
    "Marketing Name": "S81",
    "Device": "S81",
    "Model": "S81"
  },
  {
    "Retail Branding": "Premio",
    "Marketing Name": "S82",
    "Device": "S82",
    "Model": "S82"
  },
  {
    "Retail Branding": "Premio",
    "Marketing Name": "S83",
    "Device": "S83",
    "Model": "S83"
  },
  {
    "Retail Branding": "Premio",
    "Marketing Name": "S85",
    "Device": "S85",
    "Model": "S85"
  },
  {
    "Retail Branding": "Premio",
    "Marketing Name": "S86",
    "Device": "S86",
    "Model": "S86"
  },
  {
    "Retail Branding": "Premio",
    "Marketing Name": "S87",
    "Device": "S87",
    "Model": "S87"
  },
  {
    "Retail Branding": "Premio",
    "Marketing Name": "S88",
    "Device": "S88",
    "Model": "S88"
  },
  {
    "Retail Branding": "Premio",
    "Marketing Name": "S89",
    "Device": "S89",
    "Model": "S89"
  },
  {
    "Retail Branding": "Premio",
    "Marketing Name": "S90",
    "Device": "S90",
    "Model": "S90"
  },
  {
    "Retail Branding": "Premio",
    "Marketing Name": "S91",
    "Device": "S91",
    "Model": "S91"
  },
  {
    "Retail Branding": "Premio",
    "Marketing Name": "S93",
    "Device": "S93",
    "Model": "S93"
  },
  {
    "Retail Branding": "Premio",
    "Marketing Name": "S94",
    "Device": "S94",
    "Model": "S94"
  },
  {
    "Retail Branding": "Premio",
    "Marketing Name": "T1",
    "Device": "T1",
    "Model": "T1"
  },
  {
    "Retail Branding": "Premio",
    "Marketing Name": "TAB7",
    "Device": "TAB7",
    "Model": "TAB7"
  },
  {
    "Retail Branding": "Premio",
    "Marketing Name": "TAB8",
    "Device": "TAB8",
    "Model": "TAB8"
  },
  {
    "Retail Branding": "Premio",
    "Marketing Name": "TAB_7_1",
    "Device": "TAB_7_1",
    "Model": "TAB 7.1"
  },
  {
    "Retail Branding": "Premio",
    "Marketing Name": "TAB_8.1",
    "Device": "TAB_8_1",
    "Model": "TAB 8.1"
  },
  {
    "Retail Branding": "Premio",
    "Marketing Name": "X1",
    "Device": "186HS2080531",
    "Model": "186HS2080531"
  },
  {
    "Retail Branding": "Premio",
    "Marketing Name": "X70-2021",
    "Device": "X70-2021",
    "Model": "X70-2021"
  },
  {
    "Retail Branding": "Premio",
    "Marketing Name": "X75",
    "Device": "X75",
    "Model": "X75"
  },
  {
    "Retail Branding": "Premio",
    "Marketing Name": "X750-2021",
    "Device": "X75-2021",
    "Model": "X75-2021"
  },
  {
    "Retail Branding": "Premio",
    "Marketing Name": "X76",
    "Device": "X76",
    "Model": "X76"
  },
  {
    "Retail Branding": "Premio",
    "Marketing Name": "X77",
    "Device": "X77",
    "Model": "X77"
  },
  {
    "Retail Branding": "Premio",
    "Marketing Name": "X80",
    "Device": "X80",
    "Model": "X80"
  },
  {
    "Retail Branding": "Premio",
    "Marketing Name": "X81",
    "Device": "X81",
    "Model": "X81"
  },
  {
    "Retail Branding": "Premio",
    "Marketing Name": "X83",
    "Device": "X83",
    "Model": "X83"
  },
  {
    "Retail Branding": "Premio",
    "Marketing Name": "X84",
    "Device": "X84",
    "Model": "X84"
  },
  {
    "Retail Branding": "Premio",
    "Marketing Name": "X85",
    "Device": "X85",
    "Model": "X85"
  },
  {
    "Retail Branding": "Premio",
    "Marketing Name": "X85 PRO",
    "Device": "X85_PRO",
    "Model": "X85 PRO"
  },
  {
    "Retail Branding": "Premio",
    "Marketing Name": "X86",
    "Device": "X86",
    "Model": "X86"
  },
  {
    "Retail Branding": "Premio",
    "Marketing Name": "X87",
    "Device": "X87",
    "Model": "X87"
  },
  {
    "Retail Branding": "Premio",
    "Marketing Name": "X88",
    "Device": "X88",
    "Model": "X88"
  },
  {
    "Retail Branding": "Premio",
    "Marketing Name": "X90",
    "Device": "X90",
    "Model": "X90"
  },
  {
    "Retail Branding": "Premio",
    "Marketing Name": "X91",
    "Device": "X91",
    "Model": "X91"
  },
  {
    "Retail Branding": "Premio",
    "Marketing Name": "X95",
    "Device": "X95",
    "Model": "X95"
  },
  {
    "Retail Branding": "Premio",
    "Marketing Name": "X96",
    "Device": "X96",
    "Model": "X96"
  },
  {
    "Retail Branding": "Premio",
    "Marketing Name": "X97",
    "Device": "X97",
    "Model": "X97"
  },
  {
    "Retail Branding": "Premio",
    "Marketing Name": "Z1",
    "Device": "Z1",
    "Model": "Z1"
  },
  {
    "Retail Branding": "Prestige",
    "Marketing Name": "7G",
    "Device": "Prestige-7G",
    "Model": "Prestige 7G"
  },
  {
    "Retail Branding": "Prestige",
    "Marketing Name": "ELITE10Q",
    "Device": "Elite10Q",
    "Model": "Elite10Q"
  },
  {
    "Retail Branding": "Prestige",
    "Marketing Name": "ELITE7Q",
    "Device": "Elite7Q",
    "Model": "Elite7Q"
  },
  {
    "Retail Branding": "Prestige",
    "Marketing Name": "ELITE8Q",
    "Device": "ELITE8Q",
    "Model": "ELITE8Q"
  },
  {
    "Retail Branding": "Prestige",
    "Marketing Name": "ELITE8QS",
    "Device": "Elite8QS",
    "Model": "Elite8QS"
  },
  {
    "Retail Branding": "Prestige",
    "Marketing Name": "ELITE9Q",
    "Device": "ELITE9Q",
    "Model": "ELITE9Q"
  },
  {
    "Retail Branding": "Prestige",
    "Marketing Name": "PMT5778_4G",
    "Device": "CF80A5L",
    "Model": "PMT5778_4G"
  },
  {
    "Retail Branding": "Prestige",
    "Marketing Name": "PRO10D",
    "Device": "PRO10D",
    "Model": "PRO10D"
  },
  {
    "Retail Branding": "Prestige",
    "Marketing Name": "PRO7DS",
    "Device": "PRO7DS",
    "Model": "PRO7DS"
  },
  {
    "Retail Branding": "Prestige",
    "Marketing Name": "PRO8D",
    "Device": "PRO8D",
    "Model": "PRO8D"
  },
  {
    "Retail Branding": "Prestige",
    "Marketing Name": "PRO9D",
    "Device": "PRO9D",
    "Model": "PRO9D"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "CD10A7G",
    "Device": "CD10A7G",
    "Model": "PMT4311_3G_RU"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "CD80A5G",
    "Device": "CD80A5G",
    "Model": "PMT4118_3G_EEA"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "CD80A5G",
    "Device": "CD80A5G",
    "Model": "PMT4638_3G_RU"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "GRACE P5",
    "Device": "HT50B2G",
    "Model": "PSP5515DUO"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "GRACE V7 LTE",
    "Device": "CF59B6L",
    "Model": "PSP7590DUO"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "GRACE V7 LTE",
    "Device": "CF59B6L",
    "Model": "PSP7590DUO_EU"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "GV7790",
    "Device": "GV7790",
    "Model": "GV7790"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "Grace",
    "Device": "PSP7557",
    "Model": "PSP7557"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "Grace 3118 3G",
    "Device": "JU80A2G",
    "Model": "PMT3118_3G"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "Grace 3738 3G",
    "Device": "CD80A1G",
    "Model": "PMT3738_3G"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "Grace 3748 3G",
    "Device": "CD80A1G",
    "Model": "PMT3748_3G"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "Grace 3758 3G",
    "Device": "CD80A1G",
    "Model": "PMT3758_3G"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "Grace 3768 3G",
    "Device": "CD80A1G",
    "Model": "PMT3768_3G"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "Grace 3778 3G",
    "Device": "CD80A1G",
    "Model": "PMT3778_3G"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "Grace 3778 3G",
    "Device": "CD80A1G",
    "Model": "PMT3778_3G_EU"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "Grace 3838 4G",
    "Device": "CD80A3L",
    "Model": "PMT3838_4G"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "Grace 3848 4G",
    "Device": "CD80A3L",
    "Model": "PMT3848_4G"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "Grace 3858 4G",
    "Device": "CD80A3L",
    "Model": "PMT3858_4G"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "Grace 3868 4G",
    "Device": "CD80A3L",
    "Model": "PMT3868_4G"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "Grace 3878 4G",
    "Device": "CD80A3L",
    "Model": "PMT3878_4G_EU"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "Grace X3",
    "Device": "PSP3455DUO",
    "Model": "PSP3455DUO"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "Grace X5",
    "Device": "PSP5470DUO",
    "Model": "PSP5470DUO"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "Grace X7",
    "Device": "PSP7505DUO",
    "Model": "PSP7505DUO"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "Grace Y7 LTE",
    "Device": "KN54B1L",
    "Model": "PSP7546DUO_EEA"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "HP10A4L",
    "Device": "HP10A4L",
    "Model": "PMT4791_4G_RU"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "HP10A4L",
    "Device": "HP10A4L",
    "Model": "PMT4991_4G"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "HP10A5L",
    "Device": "HP10A5L",
    "Model": "PMT4891_4G_EEA"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "HP80A16G",
    "Device": "HP80A16G",
    "Model": "PMT4228_3G_RU"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "HP80A21G",
    "Device": "HP80A21G",
    "Model": "PMT4348_3G_E_RU"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "HP8A6L",
    "Device": "HP8A6L",
    "Model": "PMT4238_4G_EEA"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "LS96A7G",
    "Device": "LS96A7G",
    "Model": "PMT3196_3G"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "MT3237_3G",
    "Device": "JP70A1W",
    "Model": "PMT3237_3G"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "MULTIPAD WIZE 3027",
    "Device": "HF80A01W",
    "Model": "PMT3027_Wi"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "MULTIPAD WIZE 3108 3G",
    "Device": "PN80A03G",
    "Model": "PMT3108_3G"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "MULTIPAD WIZE 3111",
    "Device": "NS70A03W",
    "Model": "PMT3111_Wi"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "MULTIPAD WIZE 3121",
    "Device": "NS70A03W",
    "Model": "PMT3121_Wi"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "MULTIPAD WIZE 3308 3G",
    "Device": "PN80A03G",
    "Model": "PMT3308_3G"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "MULTIPAD WIZE 3331 3G",
    "Device": "PN10A01G",
    "Model": "PMT3331_3G"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "MULTIPAD WIZE 3341 3G",
    "Device": "PN10A01G",
    "Model": "PMT3341_3G"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "MULTIPAD WIZE 3787 3G",
    "Device": "PMT3777_3G",
    "Model": "PMT3787_3G"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "MUZE E5 LTE",
    "Device": "TL55B3L",
    "Model": "PSP5545DUO"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "MUZE U3 LTE",
    "Device": "BW50B1L",
    "Model": "PSP3515DUO"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "MUZE V3",
    "Device": "TL49B4L",
    "Model": "PSP3495DUO"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "MultiPad Thunder 7.0i",
    "Device": "g01p",
    "Model": "PMT3377_Wi"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "MultiPad Wize 3009",
    "Device": "PMT3009_Wi_C",
    "Model": "PMT3009_Wi_C"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "MultiPad Wize 3017",
    "Device": "PMT3017_WI",
    "Model": "PMT3017_WI"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "MultiPad Wize 3018",
    "Device": "PMT3018_WI",
    "Model": "PMT3018_WI"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "MultiPad Wize 3037 3G",
    "Device": "PMT3038_3G",
    "Model": "PMT3037_3G"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "MultiPad Wize 3038 3G",
    "Device": "PMT3038_3G",
    "Model": "PMT3038_3G"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "MultiPhone 5453 DUO",
    "Device": "PSP5453DUO",
    "Model": "PSP5453DUO"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "MultiPhone 5455 DUO",
    "Device": "PSP5455DUO",
    "Model": "PSP5455DUO"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "MultiPhone 5504 DUO",
    "Device": "PSP5504DUO",
    "Model": "PSP5504DUO"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "MultiPhone 5505 DUO",
    "Device": "PSP5505DUO",
    "Model": "PSP5505DUO"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "MultiPhone 5517 DUO",
    "Device": "PSP5517DUO",
    "Model": "PSP5517DUO"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "Multipad Wize 3407 4G",
    "Device": "WT70A1L",
    "Model": "PMT3407_4G"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "Multipad Wize 3408 4G",
    "Device": "LS80A1L",
    "Model": "PMT3408_4G"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "Multipad Wize 3508 4G",
    "Device": "LS80A1L",
    "Model": "PMT3508_4G"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "Multipad Wize 3757 3G",
    "Device": "PMT3777_3G",
    "Model": "PMT3757_3G"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "Multiphone 5508 DUO",
    "Device": "PSP5508DUO",
    "Model": "PSP5508DUO"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "Muze A3",
    "Device": "PSP3452DUO",
    "Model": "PSP3452DUO"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PGPS7795",
    "Device": "PMT3057_3G",
    "Model": "PGPS7795"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PMT1107_4G_D_RU",
    "Device": "HP70A6L",
    "Model": "PMT1107_4G_D_RU"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PMT1157_4G_C_RU",
    "Device": "HP70A13L",
    "Model": "PMT1157_4G_C_RU"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PMT1157_4G_RU",
    "Device": "HP70A6L",
    "Model": "PMT1157_4G_RU"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PMT1177_ 4G",
    "Device": "LS70A6L",
    "Model": "PMT1177_4G"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PMT1177_3G",
    "Device": "LS70A5G",
    "Model": "PMT1177_3G"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PMT1196_3G",
    "Device": "LS96A7G",
    "Model": "PMT1196_3G"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PMT3008_Wi",
    "Device": "PMT3008_Wi_C",
    "Model": "PMT3008_Wi_C"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PMT3011_3G",
    "Device": "PMT3011_3G",
    "Model": "PMT3011_3G"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PMT3021_3G",
    "Device": "PMT3011_3G",
    "Model": "PMT3021_3G"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PMT3031_3G",
    "Device": "PMT3011_3G",
    "Model": "PMT3031_3G"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PMT3047_3G",
    "Device": "PMT3047_3G",
    "Model": "PMT3047_3G"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PMT3057_3G",
    "Device": "PMT3057_3G",
    "Model": "PMT3057_3G"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PMT3067_3G",
    "Device": "PMT3057_3G",
    "Model": "PMT3067_3G"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PMT3077_Wi",
    "Device": "HF80A01W",
    "Model": "PMT3077_Wi"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PMT3087_3G",
    "Device": "PMT3057_3G",
    "Model": "PMT3087_3G"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PMT3096_3G",
    "Device": "LS96A7G",
    "Model": "PMT3096_3G"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PMT3101_4G",
    "Device": "CF10A1L",
    "Model": "PMT3101_4G"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PMT3103_W",
    "Device": "JR10A1W",
    "Model": "PMT3103_W"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PMT3103_W_RU",
    "Device": "JR10A1W",
    "Model": "PMT3103_W_RU"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PMT3104_Wi_D",
    "Device": "HP10A11W",
    "Model": "PMT3104_Wi_D"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PMT3104_Wi_D_EEA",
    "Device": "HP10A11W",
    "Model": "PMT3104_Wi_D_EEA"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PMT3104_Wi_D_RU",
    "Device": "HP10A11W",
    "Model": "PMT3104_Wi_D_RU"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PMT3137_3G",
    "Device": "JP70A1W",
    "Model": "PMT3137_3G"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PMT3151_3G",
    "Device": "WT10A1G",
    "Model": "PMT3151_3G"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PMT3151_3G_D_CIS",
    "Device": "WT10A2G",
    "Model": "PMT3151_3G_D_CIS"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PMT3157_3G",
    "Device": "LS70A5G",
    "Model": "PMT3157_3G"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PMT3157_4G",
    "Device": "LS70A6L",
    "Model": "PMT3157_4G"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PMT3161_3G",
    "Device": "WT10A1G",
    "Model": "PMT3161_3G"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PMT3171_3G",
    "Device": "WT10A1G",
    "Model": "PMT3171_3G"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PMT3177_3G",
    "Device": "PMT3177_3G",
    "Model": "PMT3177_3G"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PMT3197_W_D",
    "Device": "HP70A14W",
    "Model": "PMT3197_W_D"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PMT3197_W_D_EU",
    "Device": "HP70A14W",
    "Model": "PMT3197_W_D_EU"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PMT3197_W_EU",
    "Device": "HP70A1W",
    "Model": "PMT3197_W_EU"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PMT3201_4G",
    "Device": "CF10A1L",
    "Model": "PMT3201_4G"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PMT3208_3G",
    "Device": "PN80A03G",
    "Model": "PMT3208_3G"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PMT3231_4G_D",
    "Device": "HP10A12L",
    "Model": "PMT3231_4G_D"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PMT3231_4G_D_EEA",
    "Device": "HP10A12L",
    "Model": "PMT3231_4G_D_EEA"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PMT3231_4G_D_RU",
    "Device": "HP10A12L",
    "Model": "PMT3231_4G_D_RU"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PMT3257_4G",
    "Device": "LS70A6L",
    "Model": "PMT3257_4G"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PMT3277_3G",
    "Device": "PMT3277_3G",
    "Model": "PMT3277_3G"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PMT3287_3G",
    "Device": "PMT3287_3G",
    "Model": "PMT3287_3G"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PMT3301_4G",
    "Device": "CF10A1L",
    "Model": "PMT3301_4G"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PMT3317_3G",
    "Device": "LS70A5G",
    "Model": "PMT3317_3G"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PMT3327_3G",
    "Device": "LS70A5G",
    "Model": "PMT3327_3G"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PMT3351_3G",
    "Device": "PN10A01G",
    "Model": "PMT3351_3G"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PMT3418_4G",
    "Device": "LS80A4L",
    "Model": "PMT3418_4G"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PMT3427_3G",
    "Device": "LS70A5G",
    "Model": "PMT3427_3G"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PMT3437_3G",
    "Device": "JP70A1W",
    "Model": "PMT3437_3G"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PMT3437_4G",
    "Device": "LS70A6L",
    "Model": "PMT3437_4G"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PMT3507_4G",
    "Device": "WT70A1L",
    "Model": "PMT3507_4G"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PMT3537_4G",
    "Device": "LS70A6L",
    "Model": "PMT3537_4G"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PMT3607_4G",
    "Device": "WT70A1L",
    "Model": "PMT3607_4G"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PMT3608_4G",
    "Device": "LS80A1L",
    "Model": "PMT3608_4G"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PMT3637_4G",
    "Device": "LS70A6L",
    "Model": "PMT3637_4G"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PMT3677_Wi",
    "Device": "PMT3677",
    "Model": "PMT3677_Wi"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PMT3718_3G",
    "Device": "CF80A2G",
    "Model": "PMT3718_3G"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PMT3767_3G",
    "Device": "PMT3777_3G",
    "Model": "PMT3767_3G"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PMT3777_3G",
    "Device": "PMT3777_3G",
    "Model": "PMT3777_3G"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PMT3797_3G",
    "Device": "JU70A1G",
    "Model": "PMT3797_3G"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PMT3831_4G",
    "Device": "CD10A4L",
    "Model": "PMT3831_4G"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PMT3841_4G",
    "Device": "CD10A4L",
    "Model": "PMT3841_4G"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PMT3851_4G",
    "Device": "CD10A4L",
    "Model": "PMT3851_4G"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PMT3861_4G",
    "Device": "CD10A4L",
    "Model": "PMT3861_4G"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PMT3871_4G",
    "Device": "CD10A4L",
    "Model": "PMT3871_4G"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PMT3878_4G",
    "Device": "CD80A3L",
    "Model": "PMT3878_4G"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PMT3997_W_D_RU",
    "Device": "HP70A14W",
    "Model": "PMT3997_W_D_RU"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PMT4111_3G",
    "Device": "CD10A7G",
    "Model": "PMT4111_3G"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PMT4111_3G_D_EEA",
    "Device": "CD10A10G",
    "Model": "PMT4111_3G_D_EEA"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PMT4117_3G",
    "Device": "HP70A2G",
    "Model": "PMT4117_3G"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PMT4117_3G_EEA",
    "Device": "HP70A2G",
    "Model": "PMT4117_3G_EEA"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PMT4131_4G",
    "Device": "CD10A8L",
    "Model": "PMT4131_4G"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PMT4137_4G",
    "Device": "HP70A3L",
    "Model": "PMT4137_4G"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PMT4137_4G_EEA",
    "Device": "HP70A10L",
    "Model": "PMT4137_4G_EEA"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PMT4138_4G_EEA",
    "Device": "CD80A6L",
    "Model": "PMT4138_4G_EEA"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PMT4208_3G_EEA",
    "Device": "TL80A15G",
    "Model": "PMT4208_3G_EEA"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PMT4208_3G_E_RU",
    "Device": "TL80A15G",
    "Model": "PMT4208_3G_E_RU"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PMT4227_3G_RU",
    "Device": "HP70A2G",
    "Model": "PMT4227_3G_RU"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PMT4231_4G_D_EEA",
    "Device": "TC10A2L",
    "Model": "PMT4231_4G_D_EEA"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PMT4231_4G_D_RU",
    "Device": "TC10A2L",
    "Model": "PMT4231_4G_D_RU"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PMT4238_4G_RU",
    "Device": "HP8A6L",
    "Model": "PMT4238_4G_RU"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PMT4317_3G_RU",
    "Device": "HP70A2G",
    "Model": "PMT4317_3G_RU"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PMT4337_3G",
    "Device": "HP70A15G",
    "Model": "PMT4337_3G"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PMT4337_3G_EEA",
    "Device": "HP70A15G",
    "Model": "PMT4337_3G_EEA"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PMT4337_3G_RU",
    "Device": "HP70A15G",
    "Model": "PMT4337_3G_RU"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PMT4338_4G_E_EEA",
    "Device": "HP80A18L",
    "Model": "PMT4338_4G_E_EEA"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PMT4511_4G_EEA",
    "Device": "HP10A17L",
    "Model": "PMT4511_4G_EEA"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PMT4511_4G_RU",
    "Device": "HP10A17L",
    "Model": "PMT4511_4G_RU"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PMT4518_4G_E_RU",
    "Device": "HP80A20L",
    "Model": "PMT4518_4G_E_RU"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PMT4528_4G_E_RU",
    "Device": "TL80A17L",
    "Model": "PMT4528_4G_E_RU"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PMT4541_4G_E_RU",
    "Device": "TL10A16L",
    "Model": "PMT4541_4G_E_RU"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PMT4667_3G_RU",
    "Device": "HP70A7G",
    "Model": "PMT4667_3G_RU"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PMT4881_4G_F_EEA",
    "Device": "HP10A19L",
    "Model": "PMT4881_4G_F_EEA"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PMT5001_3G",
    "Device": "PMT5001_3G",
    "Model": "PMT5001_3G"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PMT5002_Wi",
    "Device": "PMT5002_Wi",
    "Model": "PMT5002_Wi"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PMT5008_3G",
    "Device": "PMT5008_3G",
    "Model": "PMT5008_3G"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PMT5011_3G",
    "Device": "PMT5001_3G",
    "Model": "PMT5011_3G"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PMT5018_3G",
    "Device": "PMT5008_3G",
    "Model": "PMT5018_3G"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PMT5021_3G",
    "Device": "PMT5001_3G",
    "Model": "PMT5021_3G"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PMT5287_4G",
    "Device": "PMT5287_4G",
    "Model": "PMT5287_4G"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PMT5487_3G",
    "Device": "PMT5487_3G",
    "Model": "PMT5487_3G"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PMT5587_Wi",
    "Device": "AML8726-MXS",
    "Model": "PMT5587_Wi"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PMT5588_4G",
    "Device": "CF80A5L",
    "Model": "PMT5588_4G"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PMT5718_4G",
    "Device": "CF80A5L",
    "Model": "PMT5718_4G"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PMT5771_4G",
    "Device": "LS10A8L",
    "Model": "PMT5771_4G"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PMT5777_3G",
    "Device": "PMT5777_3G",
    "Model": "PMT5777_3G"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PMT5791_4G",
    "Device": "LS10A8L",
    "Model": "PMT5791_4G"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PMT5877C",
    "Device": "PMT5877C",
    "Model": "PMT5877C"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PMT5887_3G",
    "Device": "PMT5887_3G",
    "Model": "PMT5887_3G"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PMT7008_4G",
    "Device": "PMT7008_4G",
    "Model": "PMT7008_4G"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PMT7077_3G",
    "Device": "PMT7077_3G",
    "Model": "PMT7077_3G"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PMT7177_3G",
    "Device": "PMT7177_3G",
    "Model": "PMT7177_3G"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PMT7287C3G",
    "Device": "PMT7287C3G",
    "Model": "PMT7287C3G"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PMT7287_3G",
    "Device": "PMT7287_3G",
    "Model": "PMT7287_3G"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PMT7781_4G_D_CIS",
    "Device": "LS10A8L",
    "Model": "PMT7781_4G"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PMT7787_3G",
    "Device": "PMT7787_3G",
    "Model": "PMT7787_3G"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PMT7788_4G",
    "Device": "CF80A5L",
    "Model": "PMT7788_4G"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PSP3403DUO",
    "Device": "GF40B1G",
    "Model": "PSP3403DUO"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PSP3404DUO",
    "Device": "PSP3404DUO",
    "Model": "PSP3404DUO"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PSP3405DUO",
    "Device": "PSP3405DUO",
    "Model": "PSP3405DUO"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PSP3413DUO",
    "Device": "GF40B1G",
    "Model": "PSP3413DUO"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PSP3423DUO",
    "Device": "GF40B1G",
    "Model": "PSP3423DUO"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PSP3450DUO",
    "Device": "PSP3450DUO",
    "Model": "PSP3450DUO"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PSP3456DUO",
    "Device": "PSP3456DUO",
    "Model": "PSP3456DUO"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PSP3457DUO",
    "Device": "KT45B01G",
    "Model": "PSP3457DUO"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PSP3458DUO",
    "Device": "TE45B3G",
    "Model": "PSP3458DUO"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PSP3459DUO",
    "Device": "TE45B3G",
    "Model": "PSP3459DUO"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PSP3468DUO",
    "Device": "TE45B7G",
    "Model": "PSP3468DUO"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PSP3470DUO",
    "Device": "TL47B1G",
    "Model": "PSP3470DUO"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PSP3471DUO",
    "Device": "TL47B1G",
    "Model": "PSP3471DUO"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PSP3502DUO",
    "Device": "PSP3502DUO",
    "Model": "PSP3502DUO"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PSP3503DUO",
    "Device": "PSP3503DUO",
    "Model": "PSP3503DUO"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PSP3504DUO",
    "Device": "PSP3504DUO",
    "Model": "PSP3504DUO"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PSP3505DUO",
    "Device": "PSP3503DUO",
    "Model": "PSP3505DUO"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PSP3506DUO",
    "Device": "TE50B2G",
    "Model": "PSP3506DUO"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PSP3507DUO",
    "Device": "TE50B2G",
    "Model": "PSP3507DUO"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PSP3508DUO",
    "Device": "TE50B4G",
    "Model": "PSP3508DUO"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PSP3510DUO",
    "Device": "DTE50B8L",
    "Model": "PSP3510DUO"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PSP3511DUO",
    "Device": "DTE50B8L",
    "Model": "PSP3511DUO"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PSP3512",
    "Device": "DTE50B8L",
    "Model": "PSP3512DUO"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PSP3513DUO",
    "Device": "HN50B1G",
    "Model": "PSP3513DUO"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PSP3513DUO_RU",
    "Device": "HN50B1G",
    "Model": "PSP3513DUO_RU"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PSP3514DUO",
    "Device": "TL50B9G",
    "Model": "PSP3514DUO"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PSP3515DUO_RU",
    "Device": "BW50B1L",
    "Model": "PSP3515DUO_RU"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PSP3516DUO",
    "Device": "TE50B2G",
    "Model": "PSP3516DUO"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PSP3517DUO",
    "Device": "TE50B2G",
    "Model": "PSP3517DUO"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PSP3518DUO",
    "Device": "TE50B4G",
    "Model": "PSP3518DUO"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PSP3522DUO",
    "Device": "TL50B10G",
    "Model": "PSP3522DUO"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PSP3527DUO",
    "Device": "TE50B6G",
    "Model": "PSP3527DUO"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PSP3528DUO",
    "Device": "IM50B1G",
    "Model": "PSP3528DUO"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PSP3530DUO",
    "Device": "DW53B01G",
    "Model": "PSP3530DUO"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PSP3531DUO",
    "Device": "DW53B01G",
    "Model": "PSP3531DUO"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PSP3533DUO",
    "Device": "DW53B6G",
    "Model": "PSP3533DUO"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PSP3534DUO_RU",
    "Device": "HN53B2G",
    "Model": "PSP3534DUO_RU"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PSP3537DUO",
    "Device": "GF50B2G",
    "Model": "PSP3537DUO"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PSP3551",
    "Device": "DTE50B8L",
    "Model": "PSP3551DUO"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PSP3552DUO",
    "Device": "TE55B9G",
    "Model": "PSP3552DUO"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PSP5047DUO",
    "Device": "MT6589",
    "Model": "PSP5047DUO"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PSP5307DUO",
    "Device": "PSP5307DUO",
    "Model": "PSP5307DUO"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PSP5454DUO",
    "Device": "PSP5454DUO",
    "Model": "PSP5454DUO"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PSP5457DUO",
    "Device": "MT6572",
    "Model": "PSP5457DUO"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PSP5502DUO",
    "Device": "TE50B3G",
    "Model": "PSP5502DUO"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PSP5506DUO",
    "Device": "DW50A03G",
    "Model": "PSP5506DUO"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PSP5507DUO",
    "Device": "PSP5507DUO",
    "Model": "PSP5507DUO"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PSP5509DUO",
    "Device": "TE50B4L",
    "Model": "PSP5509DUO"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PSP5510DUO",
    "Device": "EB50B2G",
    "Model": "PSP5510DUO"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PSP5511DUO",
    "Device": "IN50B1L",
    "Model": "PSP5511DUO"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PSP5512DUO",
    "Device": "TE50B3G",
    "Model": "PSP5512DUO"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PSP5514DUO",
    "Device": "EB50B2G",
    "Model": "PSP5514DUO"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PSP5516DUO",
    "Device": "DW50A03G",
    "Model": "PSP5516DUO"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PSP5518DUO",
    "Device": "IN50B2L",
    "Model": "PSP5518DUO"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PSP5519DUO",
    "Device": "TE50B4L",
    "Model": "PSP5519DUO"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PSP5520DUO",
    "Device": "TE52B10G",
    "Model": "PSP5520DUO"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PSP5521DUO",
    "Device": "TE52B10G",
    "Model": "PSP5521DUO"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PSP5522DUO",
    "Device": "TL52B5L",
    "Model": "PSP5522DUO"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PSP5523DUO",
    "Device": "TL52B5L",
    "Model": "PSP5523DUO"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PSP5524DUO",
    "Device": "TL52B7G",
    "Model": "PSP5524DUO"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PSP5530DUO",
    "Device": "DW53B4G",
    "Model": "PSP5530DUO"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PSP5531",
    "Device": "DW53B4G",
    "Model": "PSP5531DUO"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PSP5545DUO",
    "Device": "TL55B3L",
    "Model": "PSP5545DUO"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PSP5550DUO",
    "Device": "PSP5550DUO",
    "Model": "PSP5550DUO"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PSP5551DUO",
    "Device": "DW55B02L",
    "Model": "PSP5551DUO"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PSP5552DUO",
    "Device": "UE55B1L",
    "Model": "PSP5552DUO"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PSP5553DUO",
    "Device": "TL55B3L",
    "Model": "PSP5553DUO"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PSP7501DUO",
    "Device": "DW50B5G",
    "Model": "PSP7501DUO"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PSP7510DUO",
    "Device": "EB50B1L",
    "Model": "PSP7510DUO"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PSP7511DUO",
    "Device": "DW50B5G",
    "Model": "PSP7511DUO"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PSP7512DUO",
    "Device": "EB50B1L",
    "Model": "PSP7512DUO"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PSP7530DUO",
    "Device": "DW53B3G",
    "Model": "PSP7530DUO"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PSP7550DUO",
    "Device": "DW55B8L",
    "Model": "PSP7550DUO"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PSP7551DUO",
    "Device": "DW55B8L",
    "Model": "PSP7551DUO"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PSP7552DUO",
    "Device": "DW55B8L",
    "Model": "PSP7552DUO"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PSP7610DUO",
    "Device": "TL61B8L",
    "Model": "PSP7610DUO"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "PSP7610DUO_RU",
    "Device": "TL61B8L",
    "Model": "PSP7610DUO_RU"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "Prestigio Muze 3708 3G",
    "Device": "CF80A2G",
    "Model": "PMT3708_3G"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "Prestigio SmartKids",
    "Device": "HP70A1W",
    "Model": "PMT3997_W_RU"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "Prestigio X pro",
    "Device": "KN54B1L",
    "Model": "PSP7546DUO"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "Prestigio X pro",
    "Device": "KN54B1L",
    "Model": "PSP7546DUO_RU"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "Russia",
    "Device": "yeongdeungpo",
    "Model": "Prestigio UHD Android TV"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "TC10A3L",
    "Device": "TC10A3L",
    "Model": "PMT4771_4G_EEA"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "TC10A3L",
    "Device": "TC10A3L",
    "Model": "PMT4771_4G_RU"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "TC70A1G",
    "Device": "TC70A1G",
    "Model": "PMT4327_3G_RU"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "WIZE A3",
    "Device": "PSP3453DUO",
    "Model": "PSP3453DUO"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "WIZE U3",
    "Device": "TL50B9G",
    "Model": "PSP3514DUO_RU"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "WIZE Y3",
    "Device": "IN39B3G",
    "Model": "PSP3406DUO"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "WIZE YA3",
    "Device": "IN39B3G",
    "Model": "PSP3416DUO"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "WIZE YA3",
    "Device": "IN39B3G",
    "Model": "PSP3416DUO_EU"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "Wize 3131 3G",
    "Device": "LS10A3G",
    "Model": "PMT3131_3G"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "Wize 3147 3G",
    "Device": "LS70A2G",
    "Model": "PMT3147_3G"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "Wize 3401 3G",
    "Device": "JU10A3G",
    "Model": "PMT3401_3G"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "Wize 3731 3G",
    "Device": "CD10A2G",
    "Model": "PMT3731_3G"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "Wize 3731 3G",
    "Device": "CD10A2G",
    "Model": "PMT3771_3G_EU"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "Wize 3741 3G",
    "Device": "CD10A2G",
    "Model": "PMT3741_3G"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "Wize 3751 3G",
    "Device": "CD10A2G",
    "Model": "PMT3751_3G"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "Wize 3761 3G",
    "Device": "CD10A2G",
    "Model": "PMT3761_3G"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "Wize 3771 3G",
    "Device": "CD10A2G",
    "Model": "PMT3771_3G"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "Wize J3",
    "Device": "TL50B10G",
    "Model": "PSP3522DUO_RU"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "Wize W3",
    "Device": "TL49B11G",
    "Model": "PSP3497DUO"
  },
  {
    "Retail Branding": "Prestigio",
    "Marketing Name": "Wize W3",
    "Device": "TL49B11G",
    "Model": "PSP3497DUO_RU"
  },
  {
    "Retail Branding": "Prestigio_Solutions",
    "Marketing Name": "Multiboard Prism",
    "Device": "Multiboard_Prism",
    "Model": "Prism"
  },
  {
    "Retail Branding": "Prestigio_Solutions",
    "Marketing Name": "PSMB011Pxx1",
    "Device": "PSMB011Pxx1",
    "Model": "PSMB011Pxx1"
  },
  {
    "Retail Branding": "Prestigio_Solutions",
    "Marketing Name": "PSTA103",
    "Device": "HP10A32L",
    "Model": "PSTA103"
  },
  {
    "Retail Branding": "Prestigio_Solutions",
    "Marketing Name": "PSTA104",
    "Device": "VS12A1L",
    "Model": "PSTA104"
  },
  {
    "Retail Branding": "Prestigio_Solutions",
    "Marketing Name": "PSTA111",
    "Device": "HP80A33L",
    "Model": "PSTA111"
  },
  {
    "Retail Branding": "Prestigio_Solutions",
    "Marketing Name": "PSTA112",
    "Device": "HP10A34L",
    "Model": "PSTA112"
  },
  {
    "Retail Branding": "Prestigio_Solutions",
    "Marketing Name": "Virtuoso PSTA101",
    "Device": "HE10A3L",
    "Model": "PSTA101"
  },
  {
    "Retail Branding": "Prestigio_Solutions",
    "Marketing Name": "Vitruoso",
    "Device": "BO11A1W",
    "Model": "PSTA107"
  },
  {
    "Retail Branding": "Pretech",
    "Marketing Name": 1108,
    "Device": "1108A",
    "Model": "L1108"
  },
  {
    "Retail Branding": "Pretech",
    "Marketing Name": "1108A",
    "Device": "1108A",
    "Model": "L1108"
  },
  {
    "Retail Branding": "Pretech",
    "Marketing Name": "L1108",
    "Device": "L1108",
    "Model": "P301_L1108"
  },
  {
    "Retail Branding": "Pretech",
    "Marketing Name": "WP101",
    "Device": "WP101",
    "Model": "WP101"
  },
  {
    "Retail Branding": "Pretech",
    "Marketing Name": "WP30",
    "Device": "WP30",
    "Model": "WP30"
  },
  {
    "Retail Branding": "Prime",
    "Marketing Name": "O9",
    "Device": "PRIME_O9",
    "Model": "O9"
  },
  {
    "Retail Branding": "Prime",
    "Marketing Name": "PRIME Android TV",
    "Device": "shinagawa",
    "Model": "PRIME Android TV"
  },
  {
    "Retail Branding": "Prime",
    "Marketing Name": "PRIME P1",
    "Device": "PRIME_P1",
    "Model": "P1"
  },
  {
    "Retail Branding": "Prime",
    "Marketing Name": "X6_Pro",
    "Device": "X6_Pro",
    "Model": "X6_Pro"
  },
  {
    "Retail Branding": "Primux",
    "Marketing Name": "Primux_ioxphone",
    "Device": "Primux_ioxphone",
    "Model": "Primux_ioxphone"
  },
  {
    "Retail Branding": "Prince Mobile",
    "Marketing Name": "PC9",
    "Device": "PC9",
    "Model": "PC9"
  },
  {
    "Retail Branding": "Prism",
    "Marketing Name": "Android TV",
    "Device": "longshan",
    "Model": "AI PONT NA"
  },
  {
    "Retail Branding": "Prism",
    "Marketing Name": "Smart TV",
    "Device": "alimos",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "Prism",
    "Marketing Name": "Smart TV",
    "Device": "dangni",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "Prism",
    "Marketing Name": "UHD Android TV",
    "Device": "sindorim",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "Pritom",
    "Marketing Name": "1AZ2P_eea",
    "Device": "1AZ2P_eea",
    "Model": "1AZ2P_eea"
  },
  {
    "Retail Branding": "Pritom",
    "Marketing Name": "Benton_M10",
    "Device": "Benton_M10",
    "Model": "Benton_M10"
  },
  {
    "Retail Branding": "Pritom",
    "Marketing Name": "K7",
    "Device": "K7",
    "Model": "K7"
  },
  {
    "Retail Branding": "Pritom",
    "Marketing Name": "K7",
    "Device": "K7_A04",
    "Model": "K7"
  },
  {
    "Retail Branding": "Pritom",
    "Marketing Name": "K7",
    "Device": "K7_A04_EEA",
    "Model": "K7"
  },
  {
    "Retail Branding": "Pritom",
    "Marketing Name": "K7",
    "Device": "K7_A103",
    "Model": "K7"
  },
  {
    "Retail Branding": "Pritom",
    "Marketing Name": "K7",
    "Device": "K7_A103_EEA",
    "Model": "K7"
  },
  {
    "Retail Branding": "Pritom",
    "Marketing Name": "K7Pro",
    "Device": "K7Pro",
    "Model": "M901"
  },
  {
    "Retail Branding": "Pritom",
    "Marketing Name": "K7Pro",
    "Device": "K7Pro",
    "Model": "TOUCH 7"
  },
  {
    "Retail Branding": "Pritom",
    "Marketing Name": "K7Pro_EEA",
    "Device": "K7Pro_EEA",
    "Model": "TOUCH 7"
  },
  {
    "Retail Branding": "Pritom",
    "Marketing Name": "K7_A03",
    "Device": "K7_A03",
    "Model": "K7"
  },
  {
    "Retail Branding": "Pritom",
    "Marketing Name": "K7_A03_EEA",
    "Device": "K7_A03_EEA",
    "Model": "K7"
  },
  {
    "Retail Branding": "Pritom",
    "Marketing Name": "K7_A05",
    "Device": "K7_A05",
    "Model": "K7"
  },
  {
    "Retail Branding": "Pritom",
    "Marketing Name": "K7_A05_EEA",
    "Device": "K7_A05_EEA",
    "Model": "K7"
  },
  {
    "Retail Branding": "Pritom",
    "Marketing Name": "K7_A06",
    "Device": "K7_A06",
    "Model": "K7"
  },
  {
    "Retail Branding": "Pritom",
    "Marketing Name": "K7_A07K",
    "Device": "K7_A07K",
    "Model": "K7_A07K"
  },
  {
    "Retail Branding": "Pritom",
    "Marketing Name": "K7_A101",
    "Device": "K7_A101",
    "Model": "K7_A101"
  },
  {
    "Retail Branding": "Pritom",
    "Marketing Name": "K7_A101_EEA",
    "Device": "K7_A101_EEA",
    "Model": "K7_A101"
  },
  {
    "Retail Branding": "Pritom",
    "Marketing Name": "K7_A101_EEA",
    "Device": "K7_A101_EEA",
    "Model": "K7_A101_EEA"
  },
  {
    "Retail Branding": "Pritom",
    "Marketing Name": "K7_A102",
    "Device": "K7_A102",
    "Model": "K7_A102"
  },
  {
    "Retail Branding": "Pritom",
    "Marketing Name": "K7_A102_EEA",
    "Device": "K7_A102_EEA",
    "Model": "K7_A102"
  },
  {
    "Retail Branding": "Pritom",
    "Marketing Name": "K7_EEA",
    "Device": "K7",
    "Model": "K7"
  },
  {
    "Retail Branding": "Pritom",
    "Marketing Name": "L10",
    "Device": "L10",
    "Model": "L10"
  },
  {
    "Retail Branding": "Pritom",
    "Marketing Name": "L10_EEA",
    "Device": "L10_EEA",
    "Model": "L10_EEA"
  },
  {
    "Retail Branding": "Pritom",
    "Marketing Name": "L10_PRO",
    "Device": "L10_PRO",
    "Model": "L10_PRO"
  },
  {
    "Retail Branding": "Pritom",
    "Marketing Name": "L10_PRO_EEA",
    "Device": "L10_PRO_EEA",
    "Model": "L10_PRO_EEA"
  },
  {
    "Retail Branding": "Pritom",
    "Marketing Name": "L10_T07",
    "Device": "L10_T07",
    "Model": "L10"
  },
  {
    "Retail Branding": "Pritom",
    "Marketing Name": "L10_T07_EEA",
    "Device": "L10_T07",
    "Model": "L10"
  },
  {
    "Retail Branding": "Pritom",
    "Marketing Name": "L10_T13",
    "Device": "L10_T13",
    "Model": "L10"
  },
  {
    "Retail Branding": "Pritom",
    "Marketing Name": "L10_T13_EEA",
    "Device": "L10_T13_EEA",
    "Model": "L10"
  },
  {
    "Retail Branding": "Pritom",
    "Marketing Name": "L8",
    "Device": "L8",
    "Model": "L8"
  },
  {
    "Retail Branding": "Pritom",
    "Marketing Name": "L8-T01",
    "Device": "L8-T01",
    "Model": "L8-T01"
  },
  {
    "Retail Branding": "Pritom",
    "Marketing Name": "L8-T01_EEA",
    "Device": "L8-T01_EEA",
    "Model": "L8-T01_EEA"
  },
  {
    "Retail Branding": "Pritom",
    "Marketing Name": "L8_A01",
    "Device": "L8_A01",
    "Model": "L8"
  },
  {
    "Retail Branding": "Pritom",
    "Marketing Name": "L8_A01_EEA",
    "Device": "L8_A01_EEA",
    "Model": "L8"
  },
  {
    "Retail Branding": "Pritom",
    "Marketing Name": "L8_A02",
    "Device": "L8_A02",
    "Model": "L8_A02"
  },
  {
    "Retail Branding": "Pritom",
    "Marketing Name": "L8_A02_EEA",
    "Device": "L8_A02_EEA",
    "Model": "L8_A02_EEA"
  },
  {
    "Retail Branding": "Pritom",
    "Marketing Name": "L8_B01",
    "Device": "L8_B01",
    "Model": "TAB_8"
  },
  {
    "Retail Branding": "Pritom",
    "Marketing Name": "L8_B01_EEA",
    "Device": "L8_B01_EEA",
    "Model": "TAB_8"
  },
  {
    "Retail Branding": "Pritom",
    "Marketing Name": "L8_B02",
    "Device": "L8_B02",
    "Model": "L8"
  },
  {
    "Retail Branding": "Pritom",
    "Marketing Name": "L8_B02_EEA",
    "Device": "L8_B02_EEA",
    "Model": "L8"
  },
  {
    "Retail Branding": "Pritom",
    "Marketing Name": "L8_B03",
    "Device": "L8_B03",
    "Model": "L8"
  },
  {
    "Retail Branding": "Pritom",
    "Marketing Name": "L8_B03_EEA",
    "Device": "L8_B03_EEA",
    "Model": "L8"
  },
  {
    "Retail Branding": "Pritom",
    "Marketing Name": "L8_B03_Kids_EEA",
    "Device": "L8_B03_Kids_EEA",
    "Model": "L8"
  },
  {
    "Retail Branding": "Pritom",
    "Marketing Name": "L8_B04",
    "Device": "L8_B04",
    "Model": "L8"
  },
  {
    "Retail Branding": "Pritom",
    "Marketing Name": "L8_B04_EEA",
    "Device": "L8_B04_EEA",
    "Model": "L8"
  },
  {
    "Retail Branding": "Pritom",
    "Marketing Name": "L8_B04_Kids",
    "Device": "L8_B04_Kids",
    "Model": "L8"
  },
  {
    "Retail Branding": "Pritom",
    "Marketing Name": "L8_B04_Kids_EEA",
    "Device": "L8_B04_Kids_EEA",
    "Model": "L8"
  },
  {
    "Retail Branding": "Pritom",
    "Marketing Name": "L8_B05",
    "Device": "L8_B05",
    "Model": "L8"
  },
  {
    "Retail Branding": "Pritom",
    "Marketing Name": "L8_B05_EEA",
    "Device": "L8_B05_EEA",
    "Model": "L8"
  },
  {
    "Retail Branding": "Pritom",
    "Marketing Name": "L8_C01",
    "Device": "L8_C01",
    "Model": "L8_C01"
  },
  {
    "Retail Branding": "Pritom",
    "Marketing Name": "L8_C01_EEA",
    "Device": "L8_C01_EEA",
    "Model": "L8_C01_EEA"
  },
  {
    "Retail Branding": "Pritom",
    "Marketing Name": "L8_C02",
    "Device": "L8_C02",
    "Model": "L8_C02"
  },
  {
    "Retail Branding": "Pritom",
    "Marketing Name": "L8_C02_EEA",
    "Device": "L8_C02_EEA",
    "Model": "L8_C02_EEA"
  },
  {
    "Retail Branding": "Pritom",
    "Marketing Name": "L8_D01",
    "Device": "L8_D01",
    "Model": "L8_D01"
  },
  {
    "Retail Branding": "Pritom",
    "Marketing Name": "L8_D01_EEA",
    "Device": "L8_D01_EEA",
    "Model": "L8_D01_EEA"
  },
  {
    "Retail Branding": "Pritom",
    "Marketing Name": "L8_EEA",
    "Device": "L8_EEA",
    "Model": "L8_EEA"
  },
  {
    "Retail Branding": "Pritom",
    "Marketing Name": "L8_PRO",
    "Device": "L8_PRO",
    "Model": "L8"
  },
  {
    "Retail Branding": "Pritom",
    "Marketing Name": "L8_PRO_EEA",
    "Device": "L8_PRO_EEA",
    "Model": "L8"
  },
  {
    "Retail Branding": "Pritom",
    "Marketing Name": "M10",
    "Device": "M10",
    "Model": "M10"
  },
  {
    "Retail Branding": "Pritom",
    "Marketing Name": "M10",
    "Device": "M10_A01",
    "Model": "M10"
  },
  {
    "Retail Branding": "Pritom",
    "Marketing Name": "M10",
    "Device": "M10_A05_EEA",
    "Model": "M10"
  },
  {
    "Retail Branding": "Pritom",
    "Marketing Name": "M10-EEA",
    "Device": "M10-EEA",
    "Model": "M10-EEA"
  },
  {
    "Retail Branding": "Pritom",
    "Marketing Name": "M10_A01_EEA",
    "Device": "M10_A01_EEA",
    "Model": "M10"
  },
  {
    "Retail Branding": "Pritom",
    "Marketing Name": "M10_A06",
    "Device": "M10_A06",
    "Model": "M10"
  },
  {
    "Retail Branding": "Pritom",
    "Marketing Name": "M10_A06_EEA",
    "Device": "M10_A06_EEA",
    "Model": "M10"
  },
  {
    "Retail Branding": "Pritom",
    "Marketing Name": "M10_Air",
    "Device": "M10_Air",
    "Model": "M10_Air"
  },
  {
    "Retail Branding": "Pritom",
    "Marketing Name": "M10_Air_EEA",
    "Device": "M10_Air_EEA",
    "Model": "M10_Air_EEA"
  },
  {
    "Retail Branding": "Pritom",
    "Marketing Name": "M10_B01",
    "Device": "M10",
    "Model": "M10"
  },
  {
    "Retail Branding": "Pritom",
    "Marketing Name": "M10_B01_EEA",
    "Device": "M10_EEA",
    "Model": "M10"
  },
  {
    "Retail Branding": "Pritom",
    "Marketing Name": "M10_B02",
    "Device": "M10_B02",
    "Model": "M10"
  },
  {
    "Retail Branding": "Pritom",
    "Marketing Name": "M10_B02_EEA",
    "Device": "M10_B02_EEA",
    "Model": "M10"
  },
  {
    "Retail Branding": "Pritom",
    "Marketing Name": "M10_B03",
    "Device": "M10_B03",
    "Model": "M10"
  },
  {
    "Retail Branding": "Pritom",
    "Marketing Name": "M10_B03_EEA",
    "Device": "M10_B03_EEA",
    "Model": "M10"
  },
  {
    "Retail Branding": "Pritom",
    "Marketing Name": "M10_B05",
    "Device": "M10_B05",
    "Model": "M10"
  },
  {
    "Retail Branding": "Pritom",
    "Marketing Name": "M10_B05_EEA",
    "Device": "M10_B05_EEA",
    "Model": "M10"
  },
  {
    "Retail Branding": "Pritom",
    "Marketing Name": "M10_B06",
    "Device": "M10_B06",
    "Model": "M10"
  },
  {
    "Retail Branding": "Pritom",
    "Marketing Name": "M10_B07",
    "Device": "M10_B07",
    "Model": "M10"
  },
  {
    "Retail Branding": "Pritom",
    "Marketing Name": "M10_B07_EEA",
    "Device": "M10_B07_EEA",
    "Model": "M10"
  },
  {
    "Retail Branding": "Pritom",
    "Marketing Name": "M10_B08",
    "Device": "M10_B08",
    "Model": "M10"
  },
  {
    "Retail Branding": "Pritom",
    "Marketing Name": "M10_B08EEA",
    "Device": "M10_B08EEA",
    "Model": "M10"
  },
  {
    "Retail Branding": "Pritom",
    "Marketing Name": "M10_B09",
    "Device": "M10_B09",
    "Model": "M10"
  },
  {
    "Retail Branding": "Pritom",
    "Marketing Name": "M10_B09K",
    "Device": "M10_B09K",
    "Model": "M10"
  },
  {
    "Retail Branding": "Pritom",
    "Marketing Name": "M10_B09_EEA",
    "Device": "M10_B09_EEA",
    "Model": "M10"
  },
  {
    "Retail Branding": "Pritom",
    "Marketing Name": "M10_B10",
    "Device": "M10_B10",
    "Model": "M10"
  },
  {
    "Retail Branding": "Pritom",
    "Marketing Name": "M10_B10_EEA",
    "Device": "M10_B10_EEA",
    "Model": "M10"
  },
  {
    "Retail Branding": "Pritom",
    "Marketing Name": "M10_C01",
    "Device": "M10_C01",
    "Model": "M10_C01"
  },
  {
    "Retail Branding": "Pritom",
    "Marketing Name": "M10_C01_EEA",
    "Device": "M10_C01_EEA",
    "Model": "M10_C01_EEA"
  },
  {
    "Retail Branding": "Pritom",
    "Marketing Name": "M10_C02",
    "Device": "M10_C02",
    "Model": "M10_C02"
  },
  {
    "Retail Branding": "Pritom",
    "Marketing Name": "M10_C02_EEA",
    "Device": "M10_C02_EEA",
    "Model": "M10_C02_EEA"
  },
  {
    "Retail Branding": "Pritom",
    "Marketing Name": "M10_C03",
    "Device": "M10_C03",
    "Model": "M10_C03"
  },
  {
    "Retail Branding": "Pritom",
    "Marketing Name": "M10_C03_EEA",
    "Device": "M10_C03_EEA",
    "Model": "M10_C03_EEA"
  },
  {
    "Retail Branding": "Pritom",
    "Marketing Name": "M10_C04",
    "Device": "M10_C04",
    "Model": "M10"
  },
  {
    "Retail Branding": "Pritom",
    "Marketing Name": "M10_C04_EEA",
    "Device": "M10_C04_EEA",
    "Model": "M10"
  },
  {
    "Retail Branding": "Pritom",
    "Marketing Name": "M10_C05",
    "Device": "M10_C05",
    "Model": "M10"
  },
  {
    "Retail Branding": "Pritom",
    "Marketing Name": "M10_C05_EEA",
    "Device": "M10_C05_EEA",
    "Model": "M10"
  },
  {
    "Retail Branding": "Pritom",
    "Marketing Name": "M10_C05_Kids",
    "Device": "M10_C05_Kids",
    "Model": "M10"
  },
  {
    "Retail Branding": "Pritom",
    "Marketing Name": "M10_C05_Kids_EEA",
    "Device": "M10_C05_Kids_EEA",
    "Model": "M10"
  },
  {
    "Retail Branding": "Pritom",
    "Marketing Name": "M10_C06_Kids",
    "Device": "M10_C06_Kids",
    "Model": "M10"
  },
  {
    "Retail Branding": "Pritom",
    "Marketing Name": "M10_C06_Kids_EEA",
    "Device": "M10_C06_Kids_EEA",
    "Model": "M10"
  },
  {
    "Retail Branding": "Pritom",
    "Marketing Name": "M10_C07",
    "Device": "M10_C07",
    "Model": "M10"
  },
  {
    "Retail Branding": "Pritom",
    "Marketing Name": "M10_C07_EEA",
    "Device": "M10_C07_EEA",
    "Model": "M10"
  },
  {
    "Retail Branding": "Pritom",
    "Marketing Name": "M10_C07_Kids",
    "Device": "M10_C07_Kids",
    "Model": "M10"
  },
  {
    "Retail Branding": "Pritom",
    "Marketing Name": "M10_C07_Kids_EEA",
    "Device": "M10_C07_Kids_EEA",
    "Model": "M10"
  },
  {
    "Retail Branding": "Pritom",
    "Marketing Name": "M10_C08",
    "Device": "M10_C08",
    "Model": "M10"
  },
  {
    "Retail Branding": "Pritom",
    "Marketing Name": "M10_C08_EEA",
    "Device": "M10_C08_EEA",
    "Model": "M10"
  },
  {
    "Retail Branding": "Pritom",
    "Marketing Name": "M10_C08_Kids",
    "Device": "M10_C08_Kids",
    "Model": "M10"
  },
  {
    "Retail Branding": "Pritom",
    "Marketing Name": "M10_C08_Kids_EEA",
    "Device": "M10_C08_Kids_EEA",
    "Model": "M10"
  },
  {
    "Retail Branding": "Pritom",
    "Marketing Name": "M10_C09",
    "Device": "M10_C09",
    "Model": "M10"
  },
  {
    "Retail Branding": "Pritom",
    "Marketing Name": "M10_C09_EEA",
    "Device": "M10_C09_EEA",
    "Model": "M10"
  },
  {
    "Retail Branding": "Pritom",
    "Marketing Name": "M10_C10",
    "Device": "M10_C10",
    "Model": "M10"
  },
  {
    "Retail Branding": "Pritom",
    "Marketing Name": "M10_C10_EEA",
    "Device": "M10_C10_EEA",
    "Model": "M10"
  },
  {
    "Retail Branding": "Pritom",
    "Marketing Name": "M10_C10_Kids",
    "Device": "M10_C10_Kids",
    "Model": "M10"
  },
  {
    "Retail Branding": "Pritom",
    "Marketing Name": "M10_C10_Kids_EEA",
    "Device": "M10_C10_Kids_EEA",
    "Model": "M10"
  },
  {
    "Retail Branding": "Pritom",
    "Marketing Name": "M10_C11",
    "Device": "M10_C11",
    "Model": "M10_C11"
  },
  {
    "Retail Branding": "Pritom",
    "Marketing Name": "M10_C11_Kids",
    "Device": "M10_C11_Kids",
    "Model": "M10_C11_Kids"
  },
  {
    "Retail Branding": "Pritom",
    "Marketing Name": "M10_Lite",
    "Device": "M10_Lite",
    "Model": "M10_Lite"
  },
  {
    "Retail Branding": "Pritom",
    "Marketing Name": "M10_Max",
    "Device": "M10_Max",
    "Model": "M10_Max"
  },
  {
    "Retail Branding": "Pritom",
    "Marketing Name": "M10_Max_EEA",
    "Device": "M10_Max_EEA",
    "Model": "M10_Max_EEA"
  },
  {
    "Retail Branding": "Pritom",
    "Marketing Name": "M10_PLUS",
    "Device": "M10_PLUS",
    "Model": "M10_PLUS"
  },
  {
    "Retail Branding": "Pritom",
    "Marketing Name": "M10_PLUS_EEA",
    "Device": "M10_PLUS_EEA",
    "Model": "M10_PLUS_EEA"
  },
  {
    "Retail Branding": "Pritom",
    "Marketing Name": "M10_PRO",
    "Device": "M10_PRO",
    "Model": "M10_PRO"
  },
  {
    "Retail Branding": "Pritom",
    "Marketing Name": "M10_PRO_EEA",
    "Device": "M10_PRO_EEA",
    "Model": "M10_PRO_EEA"
  },
  {
    "Retail Branding": "Pritom",
    "Marketing Name": "M10_R01",
    "Device": "M10_R01",
    "Model": "M10_R01"
  },
  {
    "Retail Branding": "Pritom",
    "Marketing Name": "M10_R01_EEA",
    "Device": "M10_R01_EEA",
    "Model": "M10_R01_EEA"
  },
  {
    "Retail Branding": "Pritom",
    "Marketing Name": "M10_R02",
    "Device": "M10_R02",
    "Model": "M10_R02"
  },
  {
    "Retail Branding": "Pritom",
    "Marketing Name": "M10_R02_EEA",
    "Device": "M10_R02_EEA",
    "Model": "M10"
  },
  {
    "Retail Branding": "Pritom",
    "Marketing Name": "M10_R02_EEA",
    "Device": "M10_R02_EEA",
    "Model": "M10_R02_EEA"
  },
  {
    "Retail Branding": "Pritom",
    "Marketing Name": "M10_R03",
    "Device": "M10_R03",
    "Model": "M10_R03"
  },
  {
    "Retail Branding": "Pritom",
    "Marketing Name": "M10_R04",
    "Device": "M10_R04",
    "Model": "M10_R04"
  },
  {
    "Retail Branding": "Pritom",
    "Marketing Name": "M10_R06",
    "Device": "M10_R06",
    "Model": "M10_R06"
  },
  {
    "Retail Branding": "Pritom",
    "Marketing Name": "M10_R07",
    "Device": "M10_R07",
    "Model": "M10_R07"
  },
  {
    "Retail Branding": "Pritom",
    "Marketing Name": "M10_R07_EEA",
    "Device": "M10_R07_EEA",
    "Model": "M10_R07_EEA"
  },
  {
    "Retail Branding": "Pritom",
    "Marketing Name": "M10_T01",
    "Device": "M10_T01",
    "Model": "M10_T01"
  },
  {
    "Retail Branding": "Pritom",
    "Marketing Name": "M10_T01_EEA",
    "Device": "M10_T01_EEA",
    "Model": "M10_T01_EEA"
  },
  {
    "Retail Branding": "Pritom",
    "Marketing Name": "M20",
    "Device": "M10_A05",
    "Model": "M10"
  },
  {
    "Retail Branding": "Pritom",
    "Marketing Name": "M20",
    "Device": "M10_A05",
    "Model": "M20"
  },
  {
    "Retail Branding": "Pritom",
    "Marketing Name": "M30",
    "Device": "M30",
    "Model": "M30"
  },
  {
    "Retail Branding": "Pritom",
    "Marketing Name": "M30_EEA",
    "Device": "M30_EEA",
    "Model": "M30_EEA"
  },
  {
    "Retail Branding": "Pritom",
    "Marketing Name": "M60",
    "Device": "M60",
    "Model": "M60"
  },
  {
    "Retail Branding": "Pritom",
    "Marketing Name": "M60_EEA",
    "Device": "M60_EU",
    "Model": "M60_EEA"
  },
  {
    "Retail Branding": "Pritom",
    "Marketing Name": "P7",
    "Device": "P7",
    "Model": "P7"
  },
  {
    "Retail Branding": "Pritom",
    "Marketing Name": "P7",
    "Device": "P7_A1",
    "Model": "P7"
  },
  {
    "Retail Branding": "Pritom",
    "Marketing Name": "P7PLUS",
    "Device": "P7PLUS",
    "Model": "P7PLUS"
  },
  {
    "Retail Branding": "Pritom",
    "Marketing Name": "P7PLUS_EEA",
    "Device": "P7PLUS_EEA",
    "Model": "P7PLUS"
  },
  {
    "Retail Branding": "Pritom",
    "Marketing Name": "P7PRO",
    "Device": "P7PRO",
    "Model": "P7PRO"
  },
  {
    "Retail Branding": "Pritom",
    "Marketing Name": "P7PRO_1",
    "Device": "P7PRO_1",
    "Model": "P7PRO_1"
  },
  {
    "Retail Branding": "Pritom",
    "Marketing Name": "P7PRO_EEA",
    "Device": "P7PRO_EEA",
    "Model": "P7PRO_EEA"
  },
  {
    "Retail Branding": "Pritom",
    "Marketing Name": "P7_A03",
    "Device": "P7_A03",
    "Model": "P7"
  },
  {
    "Retail Branding": "Pritom",
    "Marketing Name": "P7_A03_EEA",
    "Device": "P7_A03_EEA",
    "Model": "P7"
  },
  {
    "Retail Branding": "Pritom",
    "Marketing Name": "P7_A04",
    "Device": "P7_A04",
    "Model": "P7"
  },
  {
    "Retail Branding": "Pritom",
    "Marketing Name": "P7_A04_EEA",
    "Device": "P7_A04_EEA",
    "Model": "P7"
  },
  {
    "Retail Branding": "Pritom",
    "Marketing Name": "P7_A05",
    "Device": "P7_A05",
    "Model": "P7"
  },
  {
    "Retail Branding": "Pritom",
    "Marketing Name": "P7_A06",
    "Device": "P7_A06",
    "Model": "P7"
  },
  {
    "Retail Branding": "Pritom",
    "Marketing Name": "P7_A06_EEA",
    "Device": "P7_A06_EEA",
    "Model": "P7"
  },
  {
    "Retail Branding": "Pritom",
    "Marketing Name": "P7_A07",
    "Device": "P7_A07",
    "Model": "P7"
  },
  {
    "Retail Branding": "Pritom",
    "Marketing Name": "P7_A07_EEA",
    "Device": "P7_A07_EEA",
    "Model": "P7"
  },
  {
    "Retail Branding": "Pritom",
    "Marketing Name": "P7_A08",
    "Device": "P7_A08",
    "Model": "P7"
  },
  {
    "Retail Branding": "Pritom",
    "Marketing Name": "P7_EEA",
    "Device": "P7_A1_EEA",
    "Model": "P7_EEA"
  },
  {
    "Retail Branding": "Pritom",
    "Marketing Name": "P7_EEA",
    "Device": "P7_EEA",
    "Model": "P7_EEA"
  },
  {
    "Retail Branding": "Pritom",
    "Marketing Name": "PRITOM",
    "Device": "M10_EEA",
    "Model": "M10_EEA"
  },
  {
    "Retail Branding": "Pritom",
    "Marketing Name": "Pritom_M10_EEA",
    "Device": "Pritom_M10_EEA",
    "Model": "Pritom_M10_EEA"
  },
  {
    "Retail Branding": "Pritom",
    "Marketing Name": "Pritom_M50",
    "Device": "Pritom_M50",
    "Model": "Pritom_M50"
  },
  {
    "Retail Branding": "Pritom",
    "Marketing Name": "Pritom_M50_EEA",
    "Device": "Pritom_M50_EEA",
    "Model": "Pritom_M50_EEA"
  },
  {
    "Retail Branding": "Pritom",
    "Marketing Name": "S84",
    "Device": "S84",
    "Model": "S84"
  },
  {
    "Retail Branding": "Pritom",
    "Marketing Name": "USA",
    "Device": "L8_B03_Kids",
    "Model": "L8"
  },
  {
    "Retail Branding": "Pritom",
    "Marketing Name": "USA",
    "Device": "M10",
    "Model": "M10 Pro"
  },
  {
    "Retail Branding": "Prixton",
    "Marketing Name": "Expert",
    "Device": "Expert",
    "Model": "Expert"
  },
  {
    "Retail Branding": "Prixton",
    "Marketing Name": "Nova",
    "Device": "Nova",
    "Model": "Nova"
  },
  {
    "Retail Branding": "Prixton",
    "Marketing Name": "T1700Q",
    "Device": "T1700Q",
    "Model": "T1700Q"
  },
  {
    "Retail Branding": "Prixton",
    "Marketing Name": "T1800Q＿Plus",
    "Device": "T1800Q_Plus",
    "Model": "T1800Q Plus"
  },
  {
    "Retail Branding": "Prixton",
    "Marketing Name": "T7014Q_Plus",
    "Device": "T7014Q_Plus",
    "Model": "T7014Q_Plus"
  },
  {
    "Retail Branding": "Prixton",
    "Marketing Name": "T9120_EEA",
    "Device": "T9120",
    "Model": "T9120"
  },
  {
    "Retail Branding": "ProDVX",
    "Marketing Name": "APPC-10SLBe",
    "Device": "rk3399_Android11",
    "Model": "APPC-10SLBe"
  },
  {
    "Retail Branding": "ProGLP",
    "Marketing Name": "SMIG_VI",
    "Device": "SMIG_VI",
    "Model": "SMIG_VI"
  },
  {
    "Retail Branding": "ProGLP",
    "Marketing Name": "SMIG_VII",
    "Device": "SMIG_VII",
    "Model": "SMIG_VII"
  },
  {
    "Retail Branding": "Prodigi Connect12",
    "Marketing Name": "Prodigi Connect 12",
    "Device": "connect",
    "Model": "Prodigi Connect 12"
  },
  {
    "Retail Branding": "Professional Mobile",
    "Marketing Name": "Pro V5",
    "Device": "Pro_V5",
    "Model": "Pro V5"
  },
  {
    "Retail Branding": "Profilo",
    "Marketing Name": "PROFILO Smart TV",
    "Device": "dongnae",
    "Model": "PROFILO Smart TV"
  },
  {
    "Retail Branding": "Profilo",
    "Marketing Name": "Profilo Smart TV",
    "Device": "marina",
    "Model": "Profilo Smart TV"
  },
  {
    "Retail Branding": "Profilo",
    "Marketing Name": "Smart TV",
    "Device": "mateo",
    "Model": "2K PA Smart TV"
  },
  {
    "Retail Branding": "Profilo",
    "Marketing Name": "Turkey",
    "Device": "guandu",
    "Model": "Profilo 4K Android TV"
  },
  {
    "Retail Branding": "Profilo",
    "Marketing Name": "Turkey",
    "Device": "martin",
    "Model": "Profilo 2K Android TV"
  },
  {
    "Retail Branding": "Profilo",
    "Marketing Name": "Turkey",
    "Device": "nagata",
    "Model": "Profilo Smart TV"
  },
  {
    "Retail Branding": "Profilo",
    "Marketing Name": "Turkey",
    "Device": "sepolia",
    "Model": "PROFILO Smart TV"
  },
  {
    "Retail Branding": "Profilo",
    "Marketing Name": "Turkey",
    "Device": "tamachi",
    "Model": "Profilo 2K Android TV"
  },
  {
    "Retail Branding": "Profilo",
    "Marketing Name": "Turkey",
    "Device": "yeongdeungpo",
    "Model": "Profilo 4K Android TV"
  },
  {
    "Retail Branding": "Proline",
    "Marketing Name": "H10885M",
    "Device": "H10885M",
    "Model": "H10885M"
  },
  {
    "Retail Branding": "Proline",
    "Marketing Name": "H10888M",
    "Device": "H10888M",
    "Model": "H10888M"
  },
  {
    "Retail Branding": "Proline",
    "Marketing Name": "H7835M",
    "Device": "H7835M",
    "Model": "H7835M"
  },
  {
    "Retail Branding": "Proline",
    "Marketing Name": "H7885M",
    "Device": "H7885M",
    "Model": "H7885M"
  },
  {
    "Retail Branding": "Proline",
    "Marketing Name": "M504",
    "Device": "M504",
    "Model": "M504"
  },
  {
    "Retail Branding": "Proline",
    "Marketing Name": "Proline FalconXL",
    "Device": "Proline_FalconXL",
    "Model": "Proline_FalconXL"
  },
  {
    "Retail Branding": "Proline",
    "Marketing Name": "base10.3g silver",
    "Device": "H1010",
    "Model": "H1010"
  },
  {
    "Retail Branding": "Prolink",
    "Marketing Name": "NeoSmart5",
    "Device": "NeoSmart5",
    "Model": "NeoSmart5"
  },
  {
    "Retail Branding": "Promark",
    "Marketing Name": "PRO AT Series",
    "Device": "PRO-AT-Series",
    "Model": "PRO-AT-Series"
  },
  {
    "Retail Branding": "Promethean",
    "Marketing Name": "ActivPanel-LE",
    "Device": "ActivPanel-LE",
    "Model": "APLE"
  },
  {
    "Retail Branding": "Promethean",
    "Marketing Name": "Promethean OPS-A1",
    "Device": "XM3566D",
    "Model": "OPS-A1"
  },
  {
    "Retail Branding": "Promethean",
    "Marketing Name": "Promethean OPS-A2",
    "Device": "OPS-A2",
    "Model": "OPS-A2"
  },
  {
    "Retail Branding": "Prometheus",
    "Marketing Name": "PROMETHEUS",
    "Device": "stanford",
    "Model": "SMART TV"
  },
  {
    "Retail Branding": "Proscan",
    "Marketing Name": "PELTDV1029",
    "Device": "mdt1008_mr_32",
    "Model": "PELTDV1029"
  },
  {
    "Retail Branding": "Proscan",
    "Marketing Name": "PELTDV1029",
    "Device": "mdt1008_mr_32",
    "Model": "PELTDVD1029"
  },
  {
    "Retail Branding": "Proscan",
    "Marketing Name": "PELTDVD1029",
    "Device": "mdt1008_mr_32",
    "Model": "PELTDVD1029"
  },
  {
    "Retail Branding": "Proscan",
    "Marketing Name": "PLT1065G",
    "Device": "PLT1065G",
    "Model": "PLT1065G"
  },
  {
    "Retail Branding": "Proscan",
    "Marketing Name": "PLT1077G(1GB/8GB)",
    "Device": "PLT1077G",
    "Model": "PLT1077G"
  },
  {
    "Retail Branding": "Proscan",
    "Marketing Name": "PLT1077G_16G",
    "Device": "PLT1077G_16G",
    "Model": "PLT1077G_16G"
  },
  {
    "Retail Branding": "Proscan",
    "Marketing Name": "PLT7100G",
    "Device": "PLT7100G",
    "Model": "PLT7100G"
  },
  {
    "Retail Branding": "Proscan",
    "Marketing Name": "PLT7109G",
    "Device": "PLT7109G",
    "Model": "PLT7109G"
  },
  {
    "Retail Branding": "Proscan",
    "Marketing Name": "PLT7130G",
    "Device": "PLT7130G",
    "Model": "PLT7130G"
  },
  {
    "Retail Branding": "Proscan",
    "Marketing Name": "PLT7602G",
    "Device": "PLT7602G",
    "Model": "PLT7602G"
  },
  {
    "Retail Branding": "Proscan",
    "Marketing Name": "PLT7649G",
    "Device": "PLT7649G",
    "Model": "PLT7649G"
  },
  {
    "Retail Branding": "Proscan",
    "Marketing Name": "PLT7650G",
    "Device": "PLT7650G",
    "Model": "PLT7650G"
  },
  {
    "Retail Branding": "Proscan",
    "Marketing Name": "PLT7770G",
    "Device": "PLT7770G",
    "Model": "PLT7770G"
  },
  {
    "Retail Branding": "Proscan",
    "Marketing Name": "PLT7774G",
    "Device": "PLT1074G",
    "Model": "PLT1074G"
  },
  {
    "Retail Branding": "Proscan",
    "Marketing Name": "PLT7774G",
    "Device": "PLT7774G",
    "Model": "PLT7774G"
  },
  {
    "Retail Branding": "Proscan",
    "Marketing Name": "PLT7775G",
    "Device": "PLT7775G",
    "Model": "PLT7775G"
  },
  {
    "Retail Branding": "Proscan",
    "Marketing Name": "PLT7800",
    "Device": "PLT7800",
    "Model": "PLT7800"
  },
  {
    "Retail Branding": "Proscan",
    "Marketing Name": "PLT7803G",
    "Device": "PLT7803G",
    "Model": "PLT7803G"
  },
  {
    "Retail Branding": "Proscan",
    "Marketing Name": "PLT7804G",
    "Device": "PLT7804G",
    "Model": "PLT7804G"
  },
  {
    "Retail Branding": "Proscan",
    "Marketing Name": "PLT8235G Tablet",
    "Device": "MID807_K",
    "Model": "PLT8235G"
  },
  {
    "Retail Branding": "Proscan",
    "Marketing Name": "PLT8802G",
    "Device": "PLT8802G",
    "Model": "PLT8802G"
  },
  {
    "Retail Branding": "Proscan",
    "Marketing Name": "PLT9602G",
    "Device": "PLT9602G",
    "Model": "PLT9602G"
  },
  {
    "Retail Branding": "Proscan",
    "Marketing Name": "PLT9606G",
    "Device": "PLT9606G",
    "Model": "PLT9606G"
  },
  {
    "Retail Branding": "Proscan",
    "Marketing Name": "PLT9609G",
    "Device": "PLT9609G",
    "Model": "PLT9609G"
  },
  {
    "Retail Branding": "Proscan",
    "Marketing Name": "PLT9649G",
    "Device": "PLT9649G",
    "Model": "PLT9649G"
  },
  {
    "Retail Branding": "Proscan",
    "Marketing Name": "PLT9650G",
    "Device": "PLT9650G",
    "Model": "PLT9650G"
  },
  {
    "Retail Branding": "Proscan",
    "Marketing Name": "PLT9774G",
    "Device": "PLT9774G",
    "Model": "PLT9774G"
  },
  {
    "Retail Branding": "Proscan",
    "Marketing Name": "PLT9999G",
    "Device": "PLT9999G",
    "Model": "PLT9999G"
  },
  {
    "Retail Branding": "Proscan",
    "Marketing Name": "PROSCAN 2K SMART TV",
    "Device": "nagata",
    "Model": "PROSCAN 2K SMART TV"
  },
  {
    "Retail Branding": "Proscan",
    "Marketing Name": "Smart TV",
    "Device": "dangni",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "Protab",
    "Marketing Name": "PTBPT5QCB7",
    "Device": "PTBPT5QCB7",
    "Model": "PTBPT5QCB7"
  },
  {
    "Retail Branding": "Proximus",
    "Marketing Name": "Proximus TV",
    "Device": "uiw4020pxm",
    "Model": "decoder"
  },
  {
    "Retail Branding": "Proximus",
    "Marketing Name": "Proximus TV",
    "Device": "uiw4068pxm",
    "Model": "tvbox"
  },
  {
    "Retail Branding": "Pulsaris",
    "Marketing Name": "Fresh",
    "Device": "Fresh",
    "Model": "Fresh"
  },
  {
    "Retail Branding": "Pulsaris",
    "Marketing Name": "Pluma",
    "Device": "Pluma",
    "Model": "Pluma"
  },
  {
    "Retail Branding": "Punos",
    "Marketing Name": "Punos X10",
    "Device": "PTX1022G",
    "Model": "X10 Tablet"
  },
  {
    "Retail Branding": "Punos",
    "Marketing Name": "Punos X8 PTX822G",
    "Device": "PTX822G",
    "Model": "X8 Tablet"
  },
  {
    "Retail Branding": "Punos",
    "Marketing Name": "Punos_10",
    "Device": "Punos_10",
    "Model": "Punos 10"
  },
  {
    "Retail Branding": "Punos",
    "Marketing Name": "Punos_7",
    "Device": "Punos_7",
    "Model": "Punos 7"
  },
  {
    "Retail Branding": "Punos",
    "Marketing Name": "XR10_Tablet",
    "Device": "PTXR1024B",
    "Model": "XR10 Tablet"
  },
  {
    "Retail Branding": "Punos",
    "Marketing Name": "XR8_Tablet",
    "Device": "PTXR824B",
    "Model": "XR8 Tablet"
  },
  {
    "Retail Branding": "Q phone",
    "Marketing Name": 2022,
    "Device": 2022,
    "Model": 2022
  },
  {
    "Retail Branding": "Q-electronics",
    "Marketing Name": "QP-TAQC70",
    "Device": "QP-TAQC70",
    "Model": "QP-TAQC70"
  },
  {
    "Retail Branding": "Q-electronics",
    "Marketing Name": "QP-TAQC80",
    "Device": "QP-TAQC80",
    "Model": "QP-TAQC80"
  },
  {
    "Retail Branding": "Q7mobile",
    "Marketing Name": "S11",
    "Device": "S11",
    "Model": "S11"
  },
  {
    "Retail Branding": "Q7mobile",
    "Marketing Name": "S25",
    "Device": "S25",
    "Model": "S25"
  },
  {
    "Retail Branding": "QBell",
    "Marketing Name": "EU",
    "Device": "nippori",
    "Model": "QBELL Android TV 2K"
  },
  {
    "Retail Branding": "QBell",
    "Marketing Name": "EU、UK、AP",
    "Device": "martin",
    "Model": "Qbell 2K Android TV"
  },
  {
    "Retail Branding": "QBell",
    "Marketing Name": "EU、UK、AP",
    "Device": "martin",
    "Model": "Qbell 2K Android TV"
  },
  {
    "Retail Branding": "QBell",
    "Marketing Name": "Italy",
    "Device": "guandu",
    "Model": "Qbell 4K Android TV"
  },
  {
    "Retail Branding": "QBell",
    "Marketing Name": "Italy",
    "Device": "tamachi",
    "Model": "Qbell FHD Android TV"
  },
  {
    "Retail Branding": "QBell",
    "Marketing Name": "Italy",
    "Device": "yeongdeungpo",
    "Model": "Qbell UHD Android TV"
  },
  {
    "Retail Branding": "QBell",
    "Marketing Name": "QBELL",
    "Device": "hongkong",
    "Model": "QBELL 4K Android TV"
  },
  {
    "Retail Branding": "QBell",
    "Marketing Name": "QBELL",
    "Device": "lavender",
    "Model": "QBELL 4K Android TV"
  },
  {
    "Retail Branding": "QBell",
    "Marketing Name": "QBELL",
    "Device": "mountbaker",
    "Model": "QBELL 2K Android TV"
  },
  {
    "Retail Branding": "QBell",
    "Marketing Name": "QBELL",
    "Device": "stanford",
    "Model": "QBELL 2K Android TV"
  },
  {
    "Retail Branding": "QBell",
    "Marketing Name": "QBELL",
    "Device": "zhongshan",
    "Model": "QBELL 4K Android TV"
  },
  {
    "Retail Branding": "QBell",
    "Marketing Name": "QBell",
    "Device": "bangbae",
    "Model": "QBell 4K Android TV"
  },
  {
    "Retail Branding": "QBell",
    "Marketing Name": "QBell",
    "Device": "komagome",
    "Model": "QBell 2K Android TV"
  },
  {
    "Retail Branding": "QBell",
    "Marketing Name": "QPHONE_10_1",
    "Device": "QPHONE_10_1",
    "Model": "QPHONE_10.1"
  },
  {
    "Retail Branding": "QBell",
    "Marketing Name": "QPHONE_9_3",
    "Device": "QPHONE_9_3",
    "Model": "QPHONE_9_3"
  },
  {
    "Retail Branding": "QBell",
    "Marketing Name": "QTAB10",
    "Device": "QTAB10",
    "Model": "QTAB10"
  },
  {
    "Retail Branding": "QBell",
    "Marketing Name": "Qbell android TV",
    "Device": "hanyang",
    "Model": "QBELL Android TV"
  },
  {
    "Retail Branding": "QCELL",
    "Marketing Name": "Qsmart",
    "Device": "QSmart",
    "Model": "QSmart"
  },
  {
    "Retail Branding": "QCELL",
    "Marketing Name": "Qsmart",
    "Device": "QSmart_Plus",
    "Model": "QSmart Plus"
  },
  {
    "Retail Branding": "QFX USA",
    "Marketing Name": "TLW-100",
    "Device": "PhonePad",
    "Model": "TLW-100"
  },
  {
    "Retail Branding": "QIN(cn)",
    "Marketing Name": "F22 Pro",
    "Device": "F22Pro",
    "Model": "F22Pro"
  },
  {
    "Retail Branding": "QIUWOKY",
    "Marketing Name": "C10S",
    "Device": "C10S",
    "Model": "C10S"
  },
  {
    "Retail Branding": "QLA",
    "Marketing Name": "C600",
    "Device": "GBC_bravo",
    "Model": "C600"
  },
  {
    "Retail Branding": "QLA (tw)",
    "Marketing Name": "T1",
    "Device": "QLA",
    "Model": "T1"
  },
  {
    "Retail Branding": "QMobile",
    "Marketing Name": "A1",
    "Device": "QMobile_Noir_A1",
    "Model": "Noir A1"
  },
  {
    "Retail Branding": "QMobile",
    "Marketing Name": "A1 lite",
    "Device": "Noir_A1_lite",
    "Model": "Noir A1 lite"
  },
  {
    "Retail Branding": "QMobile",
    "Marketing Name": "Beat 1",
    "Device": "QMobile_Beat_1",
    "Model": "QMobile Beat 1"
  },
  {
    "Retail Branding": "QMobile",
    "Marketing Name": "Blue 5",
    "Device": "QMobile_Blue_5",
    "Model": "QMobile Blue 5"
  },
  {
    "Retail Branding": "QMobile",
    "Marketing Name": "CS1",
    "Device": "CS1",
    "Model": "QMobile CS1"
  },
  {
    "Retail Branding": "QMobile",
    "Marketing Name": "CS1 Plus",
    "Device": "CS1_Plus",
    "Model": "QMobile CS1 Plus"
  },
  {
    "Retail Branding": "QMobile",
    "Marketing Name": "Dual One",
    "Device": "QMobile_Dual_One",
    "Model": "QMobile Dual One"
  },
  {
    "Retail Branding": "QMobile",
    "Marketing Name": "E1",
    "Device": "QMobile_E1",
    "Model": "E1"
  },
  {
    "Retail Branding": "QMobile",
    "Marketing Name": "E1",
    "Device": "QMobile_E1",
    "Model": "QMobile E1"
  },
  {
    "Retail Branding": "QMobile",
    "Marketing Name": "E2",
    "Device": "E2_Noir",
    "Model": "E2 Noir"
  },
  {
    "Retail Branding": "QMobile",
    "Marketing Name": "E3 Dual",
    "Device": "E3_Dual",
    "Model": "E3 Dual"
  },
  {
    "Retail Branding": "QMobile",
    "Marketing Name": "E8",
    "Device": "GBL5805QM",
    "Model": "E8"
  },
  {
    "Retail Branding": "QMobile",
    "Marketing Name": "ENERGY X1",
    "Device": "ENERGY_X1",
    "Model": "QMobile ENERGY X1"
  },
  {
    "Retail Branding": "QMobile",
    "Marketing Name": "ENERGY X2",
    "Device": "ENERGY_X2",
    "Model": "QMobile ENERGY X2"
  },
  {
    "Retail Branding": "QMobile",
    "Marketing Name": "Energy X10 4G",
    "Device": "Energy_X10_4G",
    "Model": "QMobile Energy X10 4G"
  },
  {
    "Retail Branding": "QMobile",
    "Marketing Name": "Energy X5 4G",
    "Device": "Energy_X5_4G",
    "Model": "QMobile Energy X5 4G"
  },
  {
    "Retail Branding": "QMobile",
    "Marketing Name": "Evok Power",
    "Device": "QMobile_Evok_Power",
    "Model": "QMobile Evok Power"
  },
  {
    "Retail Branding": "QMobile",
    "Marketing Name": "Evok Power Lite",
    "Device": "Evok_Power_Lite",
    "Model": "QMobile Evok Power Lite"
  },
  {
    "Retail Branding": "QMobile",
    "Marketing Name": "Fire",
    "Device": "Fire",
    "Model": "Fire"
  },
  {
    "Retail Branding": "QMobile",
    "Marketing Name": "GLi 2020",
    "Device": "GLi_2020",
    "Model": "GLi 2020"
  },
  {
    "Retail Branding": "QMobile",
    "Marketing Name": "GLi Lite",
    "Device": "GLi_Lite",
    "Model": "GLi Lite"
  },
  {
    "Retail Branding": "QMobile",
    "Marketing Name": "Grande",
    "Device": "QSmart_Grande",
    "Model": "Grande"
  },
  {
    "Retail Branding": "QMobile",
    "Marketing Name": "HD Plus",
    "Device": "QMobile_HD_Plus",
    "Model": "HD Plus"
  },
  {
    "Retail Branding": "QMobile",
    "Marketing Name": "J1",
    "Device": "J1",
    "Model": "QMobile J1"
  },
  {
    "Retail Branding": "QMobile",
    "Marketing Name": "J2",
    "Device": "J2",
    "Model": "QMobile J2"
  },
  {
    "Retail Branding": "QMobile",
    "Marketing Name": "J5",
    "Device": "J5",
    "Model": "J5"
  },
  {
    "Retail Branding": "QMobile",
    "Marketing Name": "J7",
    "Device": "J7",
    "Model": "J7"
  },
  {
    "Retail Branding": "QMobile",
    "Marketing Name": "J7 PRO",
    "Device": "J7_PRO",
    "Model": "J7 PRO"
  },
  {
    "Retail Branding": "QMobile",
    "Marketing Name": "JS10",
    "Device": "JAZZX_JS10",
    "Model": "JAZZX JS10"
  },
  {
    "Retail Branding": "QMobile",
    "Marketing Name": "JazzX JS7 PRO",
    "Device": "JS7_PRO",
    "Model": "JazzX JS7 PRO"
  },
  {
    "Retail Branding": "QMobile",
    "Marketing Name": "KING KONG MAX",
    "Device": "KING_KONG_MAX",
    "Model": "KING KONG MAX"
  },
  {
    "Retail Branding": "QMobile",
    "Marketing Name": "L20",
    "Device": "L20",
    "Model": "QMobile L20"
  },
  {
    "Retail Branding": "QMobile",
    "Marketing Name": "LT100",
    "Device": "LT100",
    "Model": "QMobile LT100"
  },
  {
    "Retail Branding": "QMobile",
    "Marketing Name": "LT300",
    "Device": "LT300",
    "Model": "LT300"
  },
  {
    "Retail Branding": "QMobile",
    "Marketing Name": "LT360",
    "Device": "LT360",
    "Model": "LT360"
  },
  {
    "Retail Branding": "QMobile",
    "Marketing Name": "LT500 PRO",
    "Device": "QMobile_LT500_PRO",
    "Model": "LT500 PRO"
  },
  {
    "Retail Branding": "QMobile",
    "Marketing Name": "LT550",
    "Device": "QMobile_LT550",
    "Model": "QMobile LT550"
  },
  {
    "Retail Branding": "QMobile",
    "Marketing Name": "LT600 PRO",
    "Device": "QMobile_LT600_PRO",
    "Model": "QMobile_LT600_PRO"
  },
  {
    "Retail Branding": "QMobile",
    "Marketing Name": "LT650",
    "Device": "LT650",
    "Model": "LT650"
  },
  {
    "Retail Branding": "QMobile",
    "Marketing Name": "LT680",
    "Device": "QMobile_LT680",
    "Model": "LT680"
  },
  {
    "Retail Branding": "QMobile",
    "Marketing Name": "LT700",
    "Device": "GBL7325QM",
    "Model": "LT700"
  },
  {
    "Retail Branding": "QMobile",
    "Marketing Name": "LT700 PRO",
    "Device": "LT700_PRO",
    "Model": "LT700 PRO"
  },
  {
    "Retail Branding": "QMobile",
    "Marketing Name": "LT900",
    "Device": "LT900",
    "Model": "QMobile LT900"
  },
  {
    "Retail Branding": "QMobile",
    "Marketing Name": "LT900",
    "Device": "QSmart_LT900",
    "Model": "QSmart LT900"
  },
  {
    "Retail Branding": "QMobile",
    "Marketing Name": "M350 Pro",
    "Device": "M350_Pro",
    "Model": "M350 Pro"
  },
  {
    "Retail Branding": "QMobile",
    "Marketing Name": "M6",
    "Device": "BBL7551QM",
    "Model": "M6"
  },
  {
    "Retail Branding": "QMobile",
    "Marketing Name": "M6 Lite",
    "Device": "M6_Lite",
    "Model": "M6 Lite"
  },
  {
    "Retail Branding": "QMobile",
    "Marketing Name": "Mark 5",
    "Device": "Mark_5",
    "Model": "Mark 5"
  },
  {
    "Retail Branding": "QMobile",
    "Marketing Name": "NOIR A3",
    "Device": "A3",
    "Model": "QMobile A3"
  },
  {
    "Retail Branding": "QMobile",
    "Marketing Name": "NOIR A6",
    "Device": "A6",
    "Model": "QMobile A6"
  },
  {
    "Retail Branding": "QMobile",
    "Marketing Name": "Noir S9",
    "Device": "QMobile_Noir_S9",
    "Model": "QMobile Noir S9"
  },
  {
    "Retail Branding": "QMobile",
    "Marketing Name": "Pakistan",
    "Device": "A1_sprout",
    "Model": "QMobile A1"
  },
  {
    "Retail Branding": "QMobile",
    "Marketing Name": "Phantom_P1",
    "Device": "Phantom_P1",
    "Model": "Qmobile Phantom P1"
  },
  {
    "Retail Branding": "QMobile",
    "Marketing Name": "Phantom_P1_Pro",
    "Device": "Phantom_P1_Pro",
    "Model": "Qmobile Phantom P1 Pro"
  },
  {
    "Retail Branding": "QMobile",
    "Marketing Name": "Q Infinity",
    "Device": "Q_Infinity",
    "Model": "Q Infinity"
  },
  {
    "Retail Branding": "QMobile",
    "Marketing Name": "Q Infinity B",
    "Device": "Q_Infinity_B",
    "Model": "QMobile Q Infinity B"
  },
  {
    "Retail Branding": "QMobile",
    "Marketing Name": "Q Infinity C",
    "Device": "Q_Infinity_C",
    "Model": "QMobile Q Infinity C"
  },
  {
    "Retail Branding": "QMobile",
    "Marketing Name": "Q Infinity Cinema",
    "Device": "Q_Infinity_Cinema",
    "Model": "QMobile_Q_Infinity_Cinema"
  },
  {
    "Retail Branding": "QMobile",
    "Marketing Name": "Q Infinity D",
    "Device": "Q_Infinity_D",
    "Model": "QMobile Q Infinity D"
  },
  {
    "Retail Branding": "QMobile",
    "Marketing Name": "Q Infinity E",
    "Device": "Q_Infinity_E",
    "Model": "QMobile Q Infinity E"
  },
  {
    "Retail Branding": "QMobile",
    "Marketing Name": "Q Infinity E Lite",
    "Device": "Q_Infinity_E_Lite",
    "Model": "QMobile Q Infinity E Lite"
  },
  {
    "Retail Branding": "QMobile",
    "Marketing Name": "Q Infinity Prime",
    "Device": "Q_Infinity_Prime",
    "Model": "QMobile Q Infinity Prime"
  },
  {
    "Retail Branding": "QMobile",
    "Marketing Name": "QMobile S15",
    "Device": "S15",
    "Model": "QMobile S15"
  },
  {
    "Retail Branding": "QMobile",
    "Marketing Name": "QNote",
    "Device": "QMobile_QNote",
    "Model": "QMobile QNote"
  },
  {
    "Retail Branding": "QMobile",
    "Marketing Name": "QTab_Y1",
    "Device": "QTab_Y1",
    "Model": "QTab Y1"
  },
  {
    "Retail Branding": "QMobile",
    "Marketing Name": "QTab_Y1_2M",
    "Device": "QTab_Y1",
    "Model": "QTab Y1"
  },
  {
    "Retail Branding": "QMobile",
    "Marketing Name": "QTab_Y2",
    "Device": "QTab_Y2",
    "Model": "QTab Y2"
  },
  {
    "Retail Branding": "QMobile",
    "Marketing Name": "QTab_Y3",
    "Device": "QTab_Y3",
    "Model": "QTab Y3"
  },
  {
    "Retail Branding": "QMobile",
    "Marketing Name": "Qmobile S8 Plus",
    "Device": "QMobile_S8_Plus",
    "Model": "S8 Plus"
  },
  {
    "Retail Branding": "QMobile",
    "Marketing Name": "Rocket Pro",
    "Device": "Rocket_Pro",
    "Model": "Rocket Pro"
  },
  {
    "Retail Branding": "QMobile",
    "Marketing Name": "S1 Lite",
    "Device": "S1_Lite",
    "Model": "QMobile S1 Lite"
  },
  {
    "Retail Branding": "QMobile",
    "Marketing Name": "S1 PRO",
    "Device": "S1_PRO",
    "Model": "QMobile S1 PRO"
  },
  {
    "Retail Branding": "QMobile",
    "Marketing Name": "S2 Plus",
    "Device": "S2_Plus",
    "Model": "QMobile S2 Plus"
  },
  {
    "Retail Branding": "QMobile",
    "Marketing Name": "S2 Pro",
    "Device": "S2_Pro",
    "Model": "S2 Pro"
  },
  {
    "Retail Branding": "QMobile",
    "Marketing Name": "S4",
    "Device": "QMobile_S4",
    "Model": "S4"
  },
  {
    "Retail Branding": "QMobile",
    "Marketing Name": "S6",
    "Device": "QMobileS6",
    "Model": "QMobile S6"
  },
  {
    "Retail Branding": "QMobile",
    "Marketing Name": "S6 PLUS",
    "Device": "QMobile_S6_PLUS",
    "Model": "QMobile S6 PLUS"
  },
  {
    "Retail Branding": "QMobile",
    "Marketing Name": "S6S",
    "Device": "QMobile_S6S",
    "Model": "QMobile S6S"
  },
  {
    "Retail Branding": "QMobile",
    "Marketing Name": "S8",
    "Device": "QMobile_S8",
    "Model": "S8"
  },
  {
    "Retail Branding": "QMobile",
    "Marketing Name": "S8_Lite",
    "Device": "QMobile_S8_Lite",
    "Model": "S8_Lite"
  },
  {
    "Retail Branding": "QMobile",
    "Marketing Name": "S9",
    "Device": "S9",
    "Model": "S9"
  },
  {
    "Retail Branding": "QMobile",
    "Marketing Name": "Smart",
    "Device": "Smart",
    "Model": "Smart"
  },
  {
    "Retail Branding": "QMobile",
    "Marketing Name": "Smart_Power",
    "Device": "Smart_Power",
    "Model": "QMobile Smart Power"
  },
  {
    "Retail Branding": "QMobile",
    "Marketing Name": "V100",
    "Device": "QTab_V100",
    "Model": "V100"
  },
  {
    "Retail Branding": "QMobile",
    "Marketing Name": "V2 2018",
    "Device": "V2_2018",
    "Model": "V2 2018"
  },
  {
    "Retail Branding": "QMobile",
    "Marketing Name": "V200",
    "Device": "QTab_V200",
    "Model": "V200"
  },
  {
    "Retail Branding": "QMobile",
    "Marketing Name": "V500",
    "Device": "QTab_V500",
    "Model": "V500"
  },
  {
    "Retail Branding": "QMobile",
    "Marketing Name": "V6 Metal",
    "Device": "V6_Metal",
    "Model": "V6_Metal"
  },
  {
    "Retail Branding": "QMobile",
    "Marketing Name": "V7 Metal",
    "Device": "V7_Metal",
    "Model": "V7_Metal"
  },
  {
    "Retail Branding": "QMobile",
    "Marketing Name": "V8 Plus",
    "Device": "V8_Plus",
    "Model": "V8 Plus"
  },
  {
    "Retail Branding": "QMobile",
    "Marketing Name": "VIEW PRO",
    "Device": "VIEW_PRO",
    "Model": "VIEW PRO"
  },
  {
    "Retail Branding": "QMobile",
    "Marketing Name": "W70",
    "Device": "W70",
    "Model": "W70"
  },
  {
    "Retail Branding": "QMobile",
    "Marketing Name": "W80",
    "Device": "WBW5615QM",
    "Model": "W80"
  },
  {
    "Retail Branding": "QMobile",
    "Marketing Name": "X1S",
    "Device": "Noir_X1S",
    "Model": "Noir X1S"
  },
  {
    "Retail Branding": "QMobile",
    "Marketing Name": "X32",
    "Device": "X32",
    "Model": "QMobile X32"
  },
  {
    "Retail Branding": "QMobile",
    "Marketing Name": "X32",
    "Device": "X32_new",
    "Model": "QMobile X32"
  },
  {
    "Retail Branding": "QMobile",
    "Marketing Name": "X32 Power",
    "Device": "X32_Power",
    "Model": "QMobile X32 Power"
  },
  {
    "Retail Branding": "QMobile",
    "Marketing Name": "X33",
    "Device": "QMobile_X33",
    "Model": "QMobile X33"
  },
  {
    "Retail Branding": "QMobile",
    "Marketing Name": "X36",
    "Device": "QMobile_X36",
    "Model": "QMobile X36"
  },
  {
    "Retail Branding": "QMobile",
    "Marketing Name": "X700 PRO",
    "Device": "X700_PRO",
    "Model": "QMobile X700 PRO"
  },
  {
    "Retail Branding": "QMobile",
    "Marketing Name": "X700 PRO II",
    "Device": "X700_PRO_II",
    "Model": "QMobile X700 PRO II"
  },
  {
    "Retail Branding": "QMobile",
    "Marketing Name": "X700 PRO Lite",
    "Device": "X700_PRO_Lite",
    "Model": "QMobile X700 PRO Lite"
  },
  {
    "Retail Branding": "QMobile",
    "Marketing Name": "X75",
    "Device": "WBW5613QM",
    "Model": "X75"
  },
  {
    "Retail Branding": "QMobile",
    "Marketing Name": "XLi",
    "Device": "QMobile_XLi",
    "Model": "QMobile XLi"
  },
  {
    "Retail Branding": "QMobile",
    "Marketing Name": "Z10",
    "Device": "Z10",
    "Model": "QMobile Z10"
  },
  {
    "Retail Branding": "QMobile",
    "Marketing Name": "Z12",
    "Device": "CBL7521QM",
    "Model": "Z12"
  },
  {
    "Retail Branding": "QMobile",
    "Marketing Name": "Z12 PRO",
    "Device": "Z12_PRO",
    "Model": "Z12 PRO"
  },
  {
    "Retail Branding": "QMobile",
    "Marketing Name": "Z14",
    "Device": "Z14",
    "Model": "Z14"
  },
  {
    "Retail Branding": "QMobile",
    "Marketing Name": "Z9 Plus",
    "Device": "WBL7511QM",
    "Model": "Z9 Plus"
  },
  {
    "Retail Branding": "QMobile",
    "Marketing Name": "i2 POWER",
    "Device": "i2_POWER",
    "Model": "QMobile i2 POWER"
  },
  {
    "Retail Branding": "QMobile",
    "Marketing Name": "i2 PRO",
    "Device": "i2_PRO",
    "Model": "QMobile i2 PRO"
  },
  {
    "Retail Branding": "QMobile",
    "Marketing Name": "i5.5",
    "Device": "i5_5",
    "Model": "QMobile i5.5"
  },
  {
    "Retail Branding": "QMobile",
    "Marketing Name": "i5i 2018",
    "Device": "i5i_2018",
    "Model": "QMobile i5i 2018"
  },
  {
    "Retail Branding": "QMobile",
    "Marketing Name": "i5i 2019",
    "Device": "i5i_2019",
    "Model": "QMobile i5i 2019"
  },
  {
    "Retail Branding": "QMobile",
    "Marketing Name": "i6 Metal 2017",
    "Device": "i6_Metal_2017",
    "Model": "QMobile i6 Metal 2017"
  },
  {
    "Retail Branding": "QMobile",
    "Marketing Name": "i6 Metal 2018",
    "Device": "i6_Metal_2018",
    "Model": "QMobile i6 Metal 2018"
  },
  {
    "Retail Branding": "QMobile",
    "Marketing Name": "i6 Metal HD",
    "Device": "i6_Metal_HD",
    "Model": "i6 Metal HD"
  },
  {
    "Retail Branding": "QMobile",
    "Marketing Name": "i6 Metal ONE",
    "Device": "i6_Metal_ONE",
    "Model": "QMobile i6 Metal ONE"
  },
  {
    "Retail Branding": "QMobile",
    "Marketing Name": "i6 Metal One",
    "Device": "i6_Metal_ONE_new",
    "Model": "QMobile i6 Metal ONE"
  },
  {
    "Retail Branding": "QMobile",
    "Marketing Name": "i7i 2020",
    "Device": "i7i_2020",
    "Model": "i7i 2020"
  },
  {
    "Retail Branding": "QMobile",
    "Marketing Name": "i7i PRO",
    "Device": "i7i_PRO",
    "Model": "QMobile i7i PRO"
  },
  {
    "Retail Branding": "QMobile",
    "Marketing Name": "i8i",
    "Device": "i8i",
    "Model": "QMobile i8i"
  },
  {
    "Retail Branding": "QMobile",
    "Marketing Name": "i8i 2019",
    "Device": "i8i_2019",
    "Model": "QMobile i8i 2019"
  },
  {
    "Retail Branding": "QMobile",
    "Marketing Name": "i8i PRO",
    "Device": "i8i_PRO",
    "Model": "QMobile i8i PRO"
  },
  {
    "Retail Branding": "QMobile",
    "Marketing Name": "i8i_Pro_Ⅱ",
    "Device": "i8i_Pro_II",
    "Model": "QMobile i8i Pro II"
  },
  {
    "Retail Branding": "QOCA",
    "Marketing Name": "QT-133W-aa2",
    "Device": "QF5",
    "Model": "QT-133W-aa2"
  },
  {
    "Retail Branding": "QOMO",
    "Marketing Name": "QITBBxxI",
    "Device": "BundleBoardI",
    "Model": "QITBBxxI"
  },
  {
    "Retail Branding": "QOOQ",
    "Marketing Name": "QOOQV3",
    "Device": "QOOQ",
    "Model": "QOOQ"
  },
  {
    "Retail Branding": "QPS Digital Electronics",
    "Marketing Name": "ASIUR-702",
    "Device": "ASIUR-702",
    "Model": "ASIUR-702"
  },
  {
    "Retail Branding": "QPS Digital Electronics",
    "Marketing Name": "ASIUR-703",
    "Device": "ASIUR-703",
    "Model": "ASIUR-703"
  },
  {
    "Retail Branding": "QPS Digital Electronics",
    "Marketing Name": "ASIUR_101",
    "Device": "ASIUR_101",
    "Model": "ASIUR_101"
  },
  {
    "Retail Branding": "QPS Digital Electronics",
    "Marketing Name": "KID15",
    "Device": "KID15",
    "Model": "KID15"
  },
  {
    "Retail Branding": "QPS Digital Electronics",
    "Marketing Name": "KIDS01",
    "Device": "KIDS01",
    "Model": "KIDS01"
  },
  {
    "Retail Branding": "QPS Digital Electronics",
    "Marketing Name": "M002KID-15",
    "Device": "M002KID-15",
    "Model": "M002KID-15"
  },
  {
    "Retail Branding": "QPS Digital Electronics",
    "Marketing Name": "P50",
    "Device": "P50",
    "Model": "P50"
  },
  {
    "Retail Branding": "QPS Digital Electronics",
    "Marketing Name": "P70-EEA",
    "Device": "P70-EEA",
    "Model": "P70-EEA"
  },
  {
    "Retail Branding": "QPS Digital Electronics",
    "Marketing Name": "S11",
    "Device": "S11",
    "Model": "S11"
  },
  {
    "Retail Branding": "QPS Digital Electronics",
    "Marketing Name": "T1",
    "Device": "T1",
    "Model": "T1"
  },
  {
    "Retail Branding": "QPS Digital Electronics",
    "Marketing Name": "T1mini",
    "Device": "T1mini",
    "Model": "T1mini"
  },
  {
    "Retail Branding": "QTab",
    "Marketing Name": "V5",
    "Device": "V5",
    "Model": "V5"
  },
  {
    "Retail Branding": "QTab",
    "Marketing Name": "V5_Plus",
    "Device": "V5_Plus",
    "Model": "V5_Plus"
  },
  {
    "Retail Branding": "QTab",
    "Marketing Name": "V7_Pro",
    "Device": "V7_Pro",
    "Model": "V7_Pro"
  },
  {
    "Retail Branding": "QUBO",
    "Marketing Name": "BIG1",
    "Device": "BIG1",
    "Model": "BIG1"
  },
  {
    "Retail Branding": "QUBO",
    "Marketing Name": "Hermes",
    "Device": "Hermes",
    "Model": "Hermes"
  },
  {
    "Retail Branding": "QUBO",
    "Marketing Name": "MINERVA",
    "Device": "MINERVA",
    "Model": "MINERVA"
  },
  {
    "Retail Branding": "QUBO",
    "Marketing Name": "MINERVA_32GB",
    "Device": "MINERVA_32GB",
    "Model": "MINERVA_32GB"
  },
  {
    "Retail Branding": "QUBO",
    "Marketing Name": "P19",
    "Device": "P19",
    "Model": "P19"
  },
  {
    "Retail Branding": "QUBO",
    "Marketing Name": "P6",
    "Device": "P6",
    "Model": "P6"
  },
  {
    "Retail Branding": "QUBO",
    "Marketing Name": "P_545BL_EEA",
    "Device": "P_545BL_EEA",
    "Model": "P_545BL"
  },
  {
    "Retail Branding": "QUBO",
    "Marketing Name": "Q7_Tablet",
    "Device": "Q7_Tablet",
    "Model": "Q7_Tablet"
  },
  {
    "Retail Branding": "QUBO",
    "Marketing Name": "SP510",
    "Device": "SP510",
    "Model": "SP510"
  },
  {
    "Retail Branding": "QUBO",
    "Marketing Name": "T104_64GB",
    "Device": "T104_64GB",
    "Model": "T104_64GB"
  },
  {
    "Retail Branding": "QUBO",
    "Marketing Name": "T10_32GB",
    "Device": "T10_32GB",
    "Model": "T10_32GB"
  },
  {
    "Retail Branding": "QUBO",
    "Marketing Name": "T3G_Q07",
    "Device": "T3G_Q07",
    "Model": "T3G_Q07"
  },
  {
    "Retail Branding": "QUBO",
    "Marketing Name": "THOR",
    "Device": "THOR",
    "Model": "THOR"
  },
  {
    "Retail Branding": "QUBO",
    "Marketing Name": "X626",
    "Device": "X626",
    "Model": "X626"
  },
  {
    "Retail Branding": "QUBO",
    "Marketing Name": "X626_4G",
    "Device": "X626_4G",
    "Model": "X626_4G"
  },
  {
    "Retail Branding": "QUBO",
    "Marketing Name": "X668_32GB",
    "Device": "X668_32GB",
    "Model": "X668_32GB"
  },
  {
    "Retail Branding": "QUBO",
    "Marketing Name": "X668_64GB",
    "Device": "X668_64GB",
    "Model": "X668_64GB"
  },
  {
    "Retail Branding": "QUBO",
    "Marketing Name": "YKIDS_100_EEA",
    "Device": "TKIDS_100_EEA",
    "Model": "TKIDS_100"
  },
  {
    "Retail Branding": "QUEST",
    "Marketing Name": "Amber",
    "Device": "Amber",
    "Model": "Amber"
  },
  {
    "Retail Branding": "QUEST",
    "Marketing Name": "Q8_Tablet",
    "Device": "Q8_Tablet",
    "Model": "Q8_Tablet"
  },
  {
    "Retail Branding": "QUEST",
    "Marketing Name": "RAPTOR",
    "Device": "RAPTOR",
    "Model": "RAPTOR"
  },
  {
    "Retail Branding": "QUEST",
    "Marketing Name": "VISION",
    "Device": "VISION",
    "Model": "VISION"
  },
  {
    "Retail Branding": "QUEST",
    "Marketing Name": "Vibe",
    "Device": "Vibe",
    "Model": "Vibe"
  },
  {
    "Retail Branding": "QUICK",
    "Marketing Name": "U55",
    "Device": "U55",
    "Model": "U55"
  },
  {
    "Retail Branding": "QVWI",
    "Marketing Name": "Leap-S3",
    "Device": "YDA",
    "Model": "4K Google TV Box"
  },
  {
    "Retail Branding": "QVWI",
    "Marketing Name": "Smart TV",
    "Device": "osaka",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "QVY TV",
    "Marketing Name": "huangshan_QVY",
    "Device": "huangshan",
    "Model": "QVY 4K Laser Home Theatre"
  },
  {
    "Retail Branding": "QWILI",
    "Marketing Name": "pula",
    "Device": "Pula",
    "Model": "Pula"
  },
  {
    "Retail Branding": "Q_LINE",
    "Marketing Name": "Easy Touch Q_LINE",
    "Device": "Q_LINE",
    "Model": "Q_LINE_Series"
  },
  {
    "Retail Branding": "Qilive",
    "Marketing Name": "Europe",
    "Device": "tamachi",
    "Model": "Qilive FHD Android TV"
  },
  {
    "Retail Branding": "Qilive",
    "Marketing Name": "Europe",
    "Device": "yeongdeungpo",
    "Model": "Qilive UHD Android TV"
  },
  {
    "Retail Branding": "Qilive",
    "Marketing Name": "France",
    "Device": "sepolia",
    "Model": "Qilive 4K Smart TV"
  },
  {
    "Retail Branding": "Qilive",
    "Marketing Name": "France, Spain, Portugal, Poland, Romania, Hungary",
    "Device": "guandu",
    "Model": "Qilive Android TV"
  },
  {
    "Retail Branding": "Qilive",
    "Marketing Name": "France, Spain, Portugal, Poland, Romania, Hungary",
    "Device": "martin",
    "Model": "Qilive Android TV"
  },
  {
    "Retail Branding": "Qilive",
    "Marketing Name": "Q.3778",
    "Device": "Q3778",
    "Model": "Q.3778"
  },
  {
    "Retail Branding": "Qilive",
    "Marketing Name": "Q1-21",
    "Device": "QT21101_464_EEA",
    "Model": "QT21101"
  },
  {
    "Retail Branding": "Qilive",
    "Marketing Name": "Q10S55IN4G",
    "Device": "Q10S55IN4G",
    "Model": "Q10S55IN4G"
  },
  {
    "Retail Branding": "Qilive",
    "Marketing Name": "Q10S55IN4G2",
    "Device": "Q10S55IN4G2",
    "Model": "Q10S55IN4G2"
  },
  {
    "Retail Branding": "Qilive",
    "Marketing Name": "Q10S5IN4G",
    "Device": "Q10S5IN4G",
    "Model": "Q10S5IN4G"
  },
  {
    "Retail Branding": "Qilive",
    "Marketing Name": "Q10T10INP",
    "Device": "Q10T10INP",
    "Model": "Q10T10INP"
  },
  {
    "Retail Branding": "Qilive",
    "Marketing Name": "Q8S5IN4GP",
    "Device": "Q8S5IN4GP",
    "Model": "Q8S5IN4GP"
  },
  {
    "Retail Branding": "Qilive",
    "Marketing Name": "Q9S55IN4G",
    "Device": "Q9S55IN4G",
    "Model": "Q9S55IN4G"
  },
  {
    "Retail Branding": "Qilive",
    "Marketing Name": "Q9T10IN4G",
    "Device": "Q9T10IN4G",
    "Model": "Q9T10IN4G"
  },
  {
    "Retail Branding": "Qilive",
    "Marketing Name": "Q9T7IN4G",
    "Device": "Q9T7IN4G",
    "Model": "Q9T7IN4G"
  },
  {
    "Retail Branding": "Qilive",
    "Marketing Name": "Q9T9IN",
    "Device": "Q9T9IN",
    "Model": "Q9T9IN"
  },
  {
    "Retail Branding": "Qilive",
    "Marketing Name": "QT19071",
    "Device": "QT19071",
    "Model": "QT19071"
  },
  {
    "Retail Branding": "Qilive",
    "Marketing Name": "QT19101",
    "Device": "QT19101",
    "Model": "QT19101"
  },
  {
    "Retail Branding": "Qilive",
    "Marketing Name": "QT19101B",
    "Device": "QT19101B",
    "Model": "QT19101B"
  },
  {
    "Retail Branding": "Qilive",
    "Marketing Name": "QT19101HV",
    "Device": "QT19101HV",
    "Model": "QT19101HV"
  },
  {
    "Retail Branding": "Qilive",
    "Marketing Name": "QT19101K",
    "Device": "QT19101K_116_EEA",
    "Model": "QT19101K"
  },
  {
    "Retail Branding": "Qilive",
    "Marketing Name": "QT201101L",
    "Device": "QT21101L_232_EEA",
    "Model": "QT21101L"
  },
  {
    "Retail Branding": "Qilive",
    "Marketing Name": "QT2108BP",
    "Device": "QT2108BP",
    "Model": "QT2108BP"
  },
  {
    "Retail Branding": "Qilive",
    "Marketing Name": "QT2110BP",
    "Device": "QT2110BP",
    "Model": "QT2110BP"
  },
  {
    "Retail Branding": "Qilive",
    "Marketing Name": "QT22101B",
    "Device": "QT22101B",
    "Model": "QT22101B"
  },
  {
    "Retail Branding": "Qilive",
    "Marketing Name": "QT22103BP",
    "Device": "QT22103BP",
    "Model": "QT22103BP"
  },
  {
    "Retail Branding": "Qilive",
    "Marketing Name": "QT2308BK",
    "Device": "QT2308BK",
    "Model": "QT2308BK"
  },
  {
    "Retail Branding": "Qilive",
    "Marketing Name": "QT23109BP",
    "Device": "QT23109BP",
    "Model": "QT23109BP"
  },
  {
    "Retail Branding": "Qilive",
    "Marketing Name": "QT23126BP",
    "Device": "QT23126BP",
    "Model": "QT23126BP"
  },
  {
    "Retail Branding": "Qilive",
    "Marketing Name": "QT24101B",
    "Device": "QT24101B",
    "Model": "QT24101B"
  },
  {
    "Retail Branding": "Qilive",
    "Marketing Name": "QT24105BP",
    "Device": "QT24105BP",
    "Model": "QT24105BP"
  },
  {
    "Retail Branding": "Qilive",
    "Marketing Name": "QT24109B",
    "Device": "QT24109B",
    "Model": "QT24109B"
  },
  {
    "Retail Branding": "Qilive",
    "Marketing Name": "Qilive 2K Smart TV",
    "Device": "dongnae",
    "Model": "Qilive 2K Smart TV"
  },
  {
    "Retail Branding": "Qilive",
    "Marketing Name": "Qilive SMART TV",
    "Device": "marina",
    "Model": "Qilive SMART TV"
  },
  {
    "Retail Branding": "Qilive",
    "Marketing Name": "Qilive SMART TV",
    "Device": "nagata",
    "Model": "Qilive SMART TV"
  },
  {
    "Retail Branding": "Qilive",
    "Marketing Name": "W55",
    "Device": "W55",
    "Model": "W55"
  },
  {
    "Retail Branding": "Qisur",
    "Marketing Name": "R106",
    "Device": "R106",
    "Model": "R106"
  },
  {
    "Retail Branding": "Qisur",
    "Marketing Name": "X72",
    "Device": "X72",
    "Model": "X72"
  },
  {
    "Retail Branding": "Qlink",
    "Marketing Name": "Scepter 8 Tablet",
    "Device": "Scepter8_tablet",
    "Model": "Scepter 8 Tablet"
  },
  {
    "Retail Branding": "Qlink",
    "Marketing Name": "Scepter_8",
    "Device": "Scepter_8",
    "Model": "Scepter 8 Tablet"
  },
  {
    "Retail Branding": "Qlink",
    "Marketing Name": "scepter8",
    "Device": "Scepter8",
    "Model": "Scepter8"
  },
  {
    "Retail Branding": "Qoobex",
    "Marketing Name": "Qphone2019_A",
    "Device": "Qphone2019_A",
    "Model": "Qphone2019_A"
  },
  {
    "Retail Branding": "Qpad",
    "Marketing Name": "XL PLUS",
    "Device": "t591_hwd_q19_hiya_we",
    "Model": "XL PLUS"
  },
  {
    "Retail Branding": "Qriom",
    "Marketing Name": "QA15-101",
    "Device": "QA15-101",
    "Model": "QA15-101"
  },
  {
    "Retail Branding": "Qriom",
    "Marketing Name": "QA15-80",
    "Device": "QA15-80",
    "Model": "QA15-80"
  },
  {
    "Retail Branding": "Qriom",
    "Marketing Name": "QRIOM",
    "Device": "jagalchi",
    "Model": "2K SMART TV"
  },
  {
    "Retail Branding": "Qsmart",
    "Marketing Name": "GLi",
    "Device": "GLi",
    "Model": "GLi"
  },
  {
    "Retail Branding": "Qsmart",
    "Marketing Name": "Hot 1",
    "Device": "Hot_1",
    "Model": "Hot 1"
  },
  {
    "Retail Branding": "Qsmart",
    "Marketing Name": "Hot 5",
    "Device": "Hot_5",
    "Model": "Hot 5"
  },
  {
    "Retail Branding": "Qsmart",
    "Marketing Name": "LT900",
    "Device": "QSmart_LT900",
    "Model": "LT900"
  },
  {
    "Retail Branding": "Qsmart",
    "Marketing Name": "LT950",
    "Device": "LT950",
    "Model": "LT950"
  },
  {
    "Retail Branding": "Qsmart",
    "Marketing Name": "Mark 2",
    "Device": "MARK_2",
    "Model": "Mark 2"
  },
  {
    "Retail Branding": "Qsmart",
    "Marketing Name": "QSmart Blaze",
    "Device": "Blaze",
    "Model": "Blaze"
  },
  {
    "Retail Branding": "Qsmart",
    "Marketing Name": "QSmart Canopus",
    "Device": "Canopus",
    "Model": "QSmart_Canopus"
  },
  {
    "Retail Branding": "Qsmart",
    "Marketing Name": "QSmart Rocket",
    "Device": "Rocket",
    "Model": "QSmart Rocket"
  },
  {
    "Retail Branding": "Qsmart",
    "Marketing Name": "QSmart Ultra",
    "Device": "Ultra",
    "Model": "Ultra"
  },
  {
    "Retail Branding": "Qsmart",
    "Marketing Name": "QSmart X10",
    "Device": "X10",
    "Model": "QSmart X10"
  },
  {
    "Retail Branding": "Qsmart",
    "Marketing Name": "QSmart X20",
    "Device": "X20",
    "Model": "QSmart X20"
  },
  {
    "Retail Branding": "Qsmart",
    "Marketing Name": "QSmart X40",
    "Device": "X40",
    "Model": "QSmart X40"
  },
  {
    "Retail Branding": "Qsmart",
    "Marketing Name": "QSmart i4i",
    "Device": "i4i",
    "Model": "QSmart i4i"
  },
  {
    "Retail Branding": "Qsmart",
    "Marketing Name": "Rocket_Lite",
    "Device": "Rocket_Lite",
    "Model": "Rocket Lite"
  },
  {
    "Retail Branding": "Qsmart",
    "Marketing Name": "Smart 8",
    "Device": "Smart_8",
    "Model": "Smart 8"
  },
  {
    "Retail Branding": "Qsmart",
    "Marketing Name": "Smart HD Pro",
    "Device": "Smart_HD_Pro",
    "Model": "Smart HD Pro"
  },
  {
    "Retail Branding": "Qsmart",
    "Marketing Name": "View",
    "Device": "View",
    "Model": "View"
  },
  {
    "Retail Branding": "Qsmart",
    "Marketing Name": "View Max",
    "Device": "View_Max",
    "Model": "View Max"
  },
  {
    "Retail Branding": "Qsmart",
    "Marketing Name": "View Max Pro",
    "Device": "View_Max_Pro",
    "Model": "View Max Pro"
  },
  {
    "Retail Branding": "Qsmart",
    "Marketing Name": "i10 2019",
    "Device": "i10_2019",
    "Model": "i10 2019"
  },
  {
    "Retail Branding": "Qsmart",
    "Marketing Name": "i10_2020",
    "Device": "i10_2020",
    "Model": "i10 2020"
  },
  {
    "Retail Branding": "Qsmart",
    "Marketing Name": "i5i 2019",
    "Device": "QSmart_i5i_2019",
    "Model": "QSmart i5i 2019"
  },
  {
    "Retail Branding": "Qsmart",
    "Marketing Name": "i6i_2020",
    "Device": "QSmart_i6i_2020",
    "Model": "i6i 2020"
  },
  {
    "Retail Branding": "Qtouch",
    "Marketing Name": "CMC_AL10",
    "Device": "CMC_AL10",
    "Model": "CMC_AL10"
  },
  {
    "Retail Branding": "Qtouch",
    "Marketing Name": "Q01A",
    "Device": "Q01A",
    "Model": "Q01A"
  },
  {
    "Retail Branding": "Qtouch",
    "Marketing Name": "Q05A",
    "Device": "Q05A",
    "Model": "Q05A"
  },
  {
    "Retail Branding": "Qtouch",
    "Marketing Name": "Q524",
    "Device": "Q524",
    "Model": "Q524"
  },
  {
    "Retail Branding": "Qtouch",
    "Marketing Name": "Q624",
    "Device": "Q624",
    "Model": "Q624"
  },
  {
    "Retail Branding": "Qtouch",
    "Marketing Name": "Q624H",
    "Device": "Q624H",
    "Model": "Q624H"
  },
  {
    "Retail Branding": "Qtouch",
    "Marketing Name": "Q625",
    "Device": "Q625",
    "Model": "Q625"
  },
  {
    "Retail Branding": "Qtouch",
    "Marketing Name": "QS31",
    "Device": "QS31",
    "Model": "QS31"
  },
  {
    "Retail Branding": "Qtouch",
    "Marketing Name": "QS355",
    "Device": "QS355",
    "Model": "QS355"
  },
  {
    "Retail Branding": "Qtouch",
    "Marketing Name": "QS362",
    "Device": "QS362",
    "Model": "QS362"
  },
  {
    "Retail Branding": "Qtouch",
    "Marketing Name": "QS701",
    "Device": "QS701",
    "Model": "QS701"
  },
  {
    "Retail Branding": "Qtouch",
    "Marketing Name": "QS702",
    "Device": "QTOUCH-QS702",
    "Model": "QS702"
  },
  {
    "Retail Branding": "Qtouch",
    "Marketing Name": "Qtouch_Q502",
    "Device": "Qtouch_Q502",
    "Model": "Qtouch_Q502"
  },
  {
    "Retail Branding": "Qtouch",
    "Marketing Name": "Qtouch_Q81",
    "Device": "Qtouch_Q81",
    "Model": "Qtouch_Q81"
  },
  {
    "Retail Branding": "Qtouch",
    "Marketing Name": "Qtouch_Q85",
    "Device": "Qtouch_Q85",
    "Model": "Qtouch_Q85"
  },
  {
    "Retail Branding": "Qtouch",
    "Marketing Name": "Qtouch_Q88",
    "Device": "Qtouch_Q88",
    "Model": "Qtouch_Q88"
  },
  {
    "Retail Branding": "Qtouch",
    "Marketing Name": "Qtouch_QT10",
    "Device": "Qtouch_QT10",
    "Model": "Qtouch_QT10"
  },
  {
    "Retail Branding": "Quamtum",
    "Marketing Name": "Quamtum_Elegance_E1",
    "Device": "Quamtum_Elegance_E1",
    "Model": "Quamtum_Elegance_E1"
  },
  {
    "Retail Branding": "Quanta",
    "Marketing Name": "",
    "Device": "Nirvana_Tablet",
    "Model": "Nirvana_Tablet"
  },
  {
    "Retail Branding": "Quanta",
    "Marketing Name": "",
    "Device": "infinity_g",
    "Model": "INFINITY G NK2"
  },
  {
    "Retail Branding": "Quanta",
    "Marketing Name": "",
    "Device": "nk1",
    "Model": "IGS-1000"
  },
  {
    "Retail Branding": "Quanta",
    "Marketing Name": "",
    "Device": "nk1",
    "Model": "TA1013"
  },
  {
    "Retail Branding": "Quanta",
    "Marketing Name": "",
    "Device": "ventana",
    "Model": "NK1_111018_002_HC"
  },
  {
    "Retail Branding": "Quanta",
    "Marketing Name": "",
    "Device": "ventana",
    "Model": "Q10"
  },
  {
    "Retail Branding": "Quanta",
    "Marketing Name": "CT2200",
    "Device": "CT2200",
    "Model": "CT2200"
  },
  {
    "Retail Branding": "Quanta",
    "Marketing Name": "FT103",
    "Device": "FT103",
    "Model": "FT103"
  },
  {
    "Retail Branding": "Quanta",
    "Marketing Name": "True Beyond 4G",
    "Device": "al7",
    "Model": "TRUE BEYOND 4G"
  },
  {
    "Retail Branding": "Quanta",
    "Marketing Name": "VSD220",
    "Device": "VSD220",
    "Model": "VSD220"
  },
  {
    "Retail Branding": "Quantic",
    "Marketing Name": "CM4805",
    "Device": "CM4805",
    "Model": "CM4805"
  },
  {
    "Retail Branding": "Quantic",
    "Marketing Name": "CM4806",
    "Device": "CM4806",
    "Model": "CM4806"
  },
  {
    "Retail Branding": "Quantum",
    "Marketing Name": "Elise_T65",
    "Device": "Elise_T65",
    "Model": "Elise_T65"
  },
  {
    "Retail Branding": "Quantum",
    "Marketing Name": "Elise_T65V",
    "Device": "Elise_T65V",
    "Model": "Elise T65V"
  },
  {
    "Retail Branding": "Quantum",
    "Marketing Name": "Elise_T65V",
    "Device": "Elise_T65V",
    "Model": "Elise T80P"
  },
  {
    "Retail Branding": "Quantum",
    "Marketing Name": "FLY",
    "Device": "Q7",
    "Model": "Quantum Fly"
  },
  {
    "Retail Branding": "Quantum",
    "Marketing Name": "Fit",
    "Device": "QF73",
    "Model": "Quantum Fit"
  },
  {
    "Retail Branding": "Quantum",
    "Marketing Name": "Go",
    "Device": "Q1",
    "Model": "Quantum Go"
  },
  {
    "Retail Branding": "Quantum",
    "Marketing Name": "Go",
    "Device": "Q2",
    "Model": "Quantum Go"
  },
  {
    "Retail Branding": "Quantum",
    "Marketing Name": "Go 2",
    "Device": "Q19",
    "Model": "GO 2"
  },
  {
    "Retail Branding": "Quantum",
    "Marketing Name": "MUV",
    "Device": "Q3B",
    "Model": "Quantum MUV"
  },
  {
    "Retail Branding": "Quantum",
    "Marketing Name": "MUV 3G",
    "Device": "Q3C",
    "Model": "MUV"
  },
  {
    "Retail Branding": "Quantum",
    "Marketing Name": "MUV 3G",
    "Device": "Q3C",
    "Model": "MUV 3G"
  },
  {
    "Retail Branding": "Quantum",
    "Marketing Name": "MUV PRO",
    "Device": "Q5",
    "Model": "Quantum MUV PRO"
  },
  {
    "Retail Branding": "Quantum",
    "Marketing Name": "MUV UP",
    "Device": "Q13",
    "Model": "Quantum MUV UP"
  },
  {
    "Retail Branding": "Quantum",
    "Marketing Name": "Mini",
    "Device": "S431",
    "Model": "Quantum Mini"
  },
  {
    "Retail Branding": "Quantum",
    "Marketing Name": "Muv",
    "Device": "Q3",
    "Model": "MUV"
  },
  {
    "Retail Branding": "Quantum",
    "Marketing Name": "Muv",
    "Device": "Q3",
    "Model": "Quantum MUV"
  },
  {
    "Retail Branding": "Quantum",
    "Marketing Name": "Q-Test",
    "Device": "S518AR",
    "Model": "Q-test"
  },
  {
    "Retail Branding": "Quantum",
    "Marketing Name": "Q03",
    "Device": "Q03",
    "Model": "Quantum Q03"
  },
  {
    "Retail Branding": "Quantum",
    "Marketing Name": "QSPT-1952",
    "Device": "QF3A",
    "Model": "QT-195W-aa2"
  },
  {
    "Retail Branding": "Quantum",
    "Marketing Name": "Qrash",
    "Device": "S600AR",
    "Model": "Qrash"
  },
  {
    "Retail Branding": "Quantum",
    "Marketing Name": "Quantum FIT",
    "Device": "S511",
    "Model": "Quantum Fit"
  },
  {
    "Retail Branding": "Quantum",
    "Marketing Name": "Quantum Lio +",
    "Device": "QC84",
    "Model": "LIO+"
  },
  {
    "Retail Branding": "Quantum",
    "Marketing Name": "Quantum M",
    "Device": "QM83",
    "Model": "Quantum M"
  },
  {
    "Retail Branding": "Quantum",
    "Marketing Name": "Quantum UP",
    "Device": "QF74",
    "Model": "Quantum UP"
  },
  {
    "Retail Branding": "Quantum",
    "Marketing Name": "Sky",
    "Device": "QX1",
    "Model": "Sky"
  },
  {
    "Retail Branding": "Quantum",
    "Marketing Name": "Twist Neo",
    "Device": "S501",
    "Model": "twist neo"
  },
  {
    "Retail Branding": "Quantum",
    "Marketing Name": "V",
    "Device": "QX2",
    "Model": "Quantum V"
  },
  {
    "Retail Branding": "Quantum",
    "Marketing Name": "You",
    "Device": "Q17",
    "Model": "Quantum You"
  },
  {
    "Retail Branding": "Quantum",
    "Marketing Name": "You",
    "Device": "Q17",
    "Model": "You"
  },
  {
    "Retail Branding": "Quantum",
    "Marketing Name": "You 2",
    "Device": "QE83",
    "Model": "Quantum You 2"
  },
  {
    "Retail Branding": "Quantum",
    "Marketing Name": "You E",
    "Device": "QY77",
    "Model": "Quantum You E"
  },
  {
    "Retail Branding": "Quantum",
    "Marketing Name": "You L",
    "Device": "Q11",
    "Model": "You L"
  },
  {
    "Retail Branding": "Quantum",
    "Marketing Name": "i9i",
    "Device": "QMobile_i9i",
    "Model": "QMobile I9i"
  },
  {
    "Retail Branding": "Quatro",
    "Marketing Name": "Quatro 10",
    "Device": "Quatro_10",
    "Model": "Quatro 10"
  },
  {
    "Retail Branding": "Quatro",
    "Marketing Name": "Quatro_8",
    "Device": "Quatro_8",
    "Model": "Quatro 8"
  },
  {
    "Retail Branding": "Quickline",
    "Marketing Name": "Quickline UHD Box",
    "Device": "dciw387",
    "Model": "M387_QL"
  },
  {
    "Retail Branding": "Qwerty",
    "Marketing Name": "QW-800",
    "Device": "QW-800",
    "Model": "QW-800"
  },
  {
    "Retail Branding": "QÜINT",
    "Marketing Name": "R3",
    "Device": "R3",
    "Model": "R3"
  },
  {
    "Retail Branding": "QÜINT",
    "Marketing Name": "R3_GTV",
    "Device": "R3_GTV",
    "Model": "R3G"
  },
  {
    "Retail Branding": "QÜINT",
    "Marketing Name": "R4",
    "Device": "R4",
    "Model": "R4"
  },
  {
    "Retail Branding": "QÜINT",
    "Marketing Name": "R4_GTV",
    "Device": "R4_GTV",
    "Model": "R4G"
  },
  {
    "Retail Branding": "RADDY",
    "Marketing Name": "A-K1061PRO",
    "Device": "A-K1061PRO",
    "Model": "A-K1061PRO"
  },
  {
    "Retail Branding": "RADDY",
    "Marketing Name": "RADDY_JANJA",
    "Device": "RADDY_JANJA",
    "Model": "R_6503"
  },
  {
    "Retail Branding": "RADDY",
    "Marketing Name": "RADDY_JANJA_PRO",
    "Device": "RADDY_JANJA_PRO",
    "Model": "R-6502"
  },
  {
    "Retail Branding": "RAINBOX",
    "Marketing Name": "K90",
    "Device": "K90",
    "Model": "K90"
  },
  {
    "Retail Branding": "RAMTECHNOLOGY",
    "Marketing Name": "RM-705",
    "Device": "RM-705",
    "Model": "RM-705"
  },
  {
    "Retail Branding": "RAMTECHNOLOGY",
    "Marketing Name": "Star",
    "Device": "STAR",
    "Model": "STAR"
  },
  {
    "Retail Branding": "RAVOZ",
    "Marketing Name": "RAVOZ Z3",
    "Device": "RAVOZ_Z3",
    "Model": "RAVOZ Z3"
  },
  {
    "Retail Branding": "RAVOZ",
    "Marketing Name": "RAVOZ Z3 Pro",
    "Device": "RAVOZ_Z3_Pro",
    "Model": "RAVOZ Z3 Pro"
  },
  {
    "Retail Branding": "RAVOZ",
    "Marketing Name": "RAVOZ Z5 Pro",
    "Device": "RAVOZ_Z5_Pro",
    "Model": "RAVOZ Z5 Pro"
  },
  {
    "Retail Branding": "RAVOZ",
    "Marketing Name": "RAVOZ Z6 Lite",
    "Device": "RAVOZ_Z6_Lite",
    "Model": "RAVOZ Z6 Lite"
  },
  {
    "Retail Branding": "RAVOZ",
    "Marketing Name": "RAVOZ Z6 Pro",
    "Device": "RAVOZ_Z6_Pro",
    "Model": "RAVOZ Z6 Pro"
  },
  {
    "Retail Branding": "RAVOZ",
    "Marketing Name": "RAVOZ Z7",
    "Device": "RAVOZ_Z7",
    "Model": "RAVOZ Z7"
  },
  {
    "Retail Branding": "RAVOZ",
    "Marketing Name": "RAVOZ Z7 Pro",
    "Device": "RAVOZ_Z7_Pro",
    "Model": "RAVOZ Z7 Pro"
  },
  {
    "Retail Branding": "RAVOZ",
    "Marketing Name": "RAVOZ_V2",
    "Device": "RAVOZ_V2",
    "Model": "RAVOZ V2"
  },
  {
    "Retail Branding": "RAVOZ",
    "Marketing Name": "RAVOZ_V3",
    "Device": "RAVOZ_V3",
    "Model": "RAVOZ V3"
  },
  {
    "Retail Branding": "RAVOZ",
    "Marketing Name": "RAVOZ_V5",
    "Device": "RAVOZ_V5",
    "Model": "RAVOZ V5"
  },
  {
    "Retail Branding": "RAVOZ",
    "Marketing Name": "RAVOZ_V6",
    "Device": "RAVOZ_V6",
    "Model": "RAVOZ V6"
  },
  {
    "Retail Branding": "RAVOZ",
    "Marketing Name": "RAVOZ_V7",
    "Device": "RAVOZ_V7",
    "Model": "RAVOZ V7"
  },
  {
    "Retail Branding": "RAVOZ",
    "Marketing Name": "RAVOZ_V8",
    "Device": "RAVOZ_V8",
    "Model": "RAVOZ V8"
  },
  {
    "Retail Branding": "RAVOZ",
    "Marketing Name": "RAVOZ_V9",
    "Device": "RAVOZ_V9",
    "Model": "RAVOZ V9"
  },
  {
    "Retail Branding": "RAVOZ",
    "Marketing Name": "RAVOZ_Z3_Lite",
    "Device": "RAVOZ_Z3_Lite",
    "Model": "RAVOZ Z3 Lite"
  },
  {
    "Retail Branding": "RAVOZ",
    "Marketing Name": "RAVOZ_Z4",
    "Device": "RAVOZ_Z4",
    "Model": "RAVOZ_Z4"
  },
  {
    "Retail Branding": "RAVOZ",
    "Marketing Name": "RAVOZ_Z6",
    "Device": "RAVOZ_Z6",
    "Model": "RAVOZ_Z6"
  },
  {
    "Retail Branding": "RAVOZ",
    "Marketing Name": "RAVOZ_Z8",
    "Device": "RAVOZ_Z8",
    "Model": "RAVOZ Z8"
  },
  {
    "Retail Branding": "RAVOZ",
    "Marketing Name": "Z3_Lite",
    "Device": "RAVOZ_Z3_Lite",
    "Model": "RAVOZ Z3 Lite"
  },
  {
    "Retail Branding": "RAYLAN",
    "Marketing Name": "Smart TV",
    "Device": "alimos",
    "Model": "RAYLAN GOOGLE TV"
  },
  {
    "Retail Branding": "RAYLAN",
    "Marketing Name": "Smart TV",
    "Device": "osaka",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "RAYO_MOVIl",
    "Marketing Name": "ATLAS 2",
    "Device": "ATLAS_2",
    "Model": "ATLAS 2"
  },
  {
    "Retail Branding": "RAYO_MOVIl",
    "Marketing Name": "Atlas",
    "Device": "Atlas",
    "Model": "Atlas"
  },
  {
    "Retail Branding": "RAYO_MOVIl",
    "Marketing Name": "RAYO X1",
    "Device": "RAYO_X1",
    "Model": "RAYO X1"
  },
  {
    "Retail Branding": "RAYO_MOVIl",
    "Marketing Name": "X1Plus",
    "Device": "X1Plus",
    "Model": "X1 Plus"
  },
  {
    "Retail Branding": "RCA",
    "Marketing Name": "10 Viking",
    "Device": "RCT6A03W13",
    "Model": "RCT6A03W13"
  },
  {
    "Retail Branding": "RCA",
    "Marketing Name": "10 Viking II",
    "Device": "RCT6603W47M7",
    "Model": "RCT6603W47M7"
  },
  {
    "Retail Branding": "RCA",
    "Marketing Name": "10 Viking II Pro",
    "Device": "RCT6603W87M7",
    "Model": "RCT6603W87M7"
  },
  {
    "Retail Branding": "RCA",
    "Marketing Name": "10 Viking Pro",
    "Device": "RCT6303W87DK",
    "Model": "RCT6303W87DK"
  },
  {
    "Retail Branding": "RCA",
    "Marketing Name": "10 Viking Pro",
    "Device": "RCT6303W87M",
    "Model": "RCT6303W87M"
  },
  {
    "Retail Branding": "RCA",
    "Marketing Name": "10 Viking Pro",
    "Device": "RCT6303W87M7",
    "Model": "RCT6303W87M7"
  },
  {
    "Retail Branding": "RCA",
    "Marketing Name": "10 Viking Pro",
    "Device": "RCT6A03W13M",
    "Model": "RCT6A03W13M"
  },
  {
    "Retail Branding": "RCA",
    "Marketing Name": "10 Viking Pro",
    "Device": "RCT6K03W13",
    "Model": "RCT6K03W13"
  },
  {
    "Retail Branding": "RCA",
    "Marketing Name": "11 Delta Pro",
    "Device": "RCT6613W23P",
    "Model": "RCT6613W23P"
  },
  {
    "Retail Branding": "RCA",
    "Marketing Name": "11 Galileo Pro",
    "Device": "RCT6513W87",
    "Model": "RCT6513W87"
  },
  {
    "Retail Branding": "RCA",
    "Marketing Name": "11 Maven Pro",
    "Device": "RCT6213W87DK",
    "Model": "RCT6213W87DK"
  },
  {
    "Retail Branding": "RCA",
    "Marketing Name": "2K PA Smart TV",
    "Device": "mateo",
    "Model": "2K PA Smart TV"
  },
  {
    "Retail Branding": "RCA",
    "Marketing Name": "4K Smart TV",
    "Device": "gangbyeon",
    "Model": "4K AI Smart TV"
  },
  {
    "Retail Branding": "RCA",
    "Marketing Name": "4K Smart TV",
    "Device": "gangbyeon",
    "Model": "4K Smart TV"
  },
  {
    "Retail Branding": "RCA",
    "Marketing Name": "4K Smart TV",
    "Device": "gangbyeon",
    "Model": "Treeview 4K AI Smart TV"
  },
  {
    "Retail Branding": "RCA",
    "Marketing Name": "4K Smart TV",
    "Device": "pioneer",
    "Model": "4K SA Smart TV"
  },
  {
    "Retail Branding": "RCA",
    "Marketing Name": "7 Mercury",
    "Device": "RCT6673W23M",
    "Model": "RCT6673W23M"
  },
  {
    "Retail Branding": "RCA",
    "Marketing Name": "7 Mercury",
    "Device": "RCT6673W43M",
    "Model": "RCT6673W43M"
  },
  {
    "Retail Branding": "RCA",
    "Marketing Name": "7 Voyager",
    "Device": "RCT6873W42",
    "Model": "RCT6873W42"
  },
  {
    "Retail Branding": "RCA",
    "Marketing Name": "7 Voyager II",
    "Device": "RCT6773W22B",
    "Model": "RCT6773W22B"
  },
  {
    "Retail Branding": "RCA",
    "Marketing Name": "7 Voyager II",
    "Device": "RCT6773W22BM",
    "Model": "RCT6773W22BM"
  },
  {
    "Retail Branding": "RCA",
    "Marketing Name": "7 Voyager III",
    "Device": "RCT6973W43MD",
    "Model": "RCT6973W43MD"
  },
  {
    "Retail Branding": "RCA",
    "Marketing Name": "Artemis 10",
    "Device": "RCT6T06E13",
    "Model": "RCT6T06E13"
  },
  {
    "Retail Branding": "RCA",
    "Marketing Name": "Atlas 10",
    "Device": "RCT6703W12",
    "Model": "RCT6703W12"
  },
  {
    "Retail Branding": "RCA",
    "Marketing Name": "Atlas 10",
    "Device": "RCT6B03W12",
    "Model": "RCT6B03W12"
  },
  {
    "Retail Branding": "RCA",
    "Marketing Name": "Atlas 10",
    "Device": "RCT6B03W13",
    "Model": "RCT6B03W13"
  },
  {
    "Retail Branding": "RCA",
    "Marketing Name": "BNT-710",
    "Device": "BNT-710",
    "Model": "BNT-710"
  },
  {
    "Retail Branding": "RCA",
    "Marketing Name": "DAA730R / RCA DAA738R",
    "Device": "MD7081",
    "Model": "DAA730R"
  },
  {
    "Retail Branding": "RCA",
    "Marketing Name": "DAA730R / RCA DAA738R",
    "Device": "MD7081",
    "Model": "DAA738R"
  },
  {
    "Retail Branding": "RCA",
    "Marketing Name": "DRP2091Q",
    "Device": "DRP2091Q",
    "Model": "DRP2091Q"
  },
  {
    "Retail Branding": "RCA",
    "Marketing Name": "DRP29101QD",
    "Device": "DRP29101QD",
    "Model": "DRP29101QD"
  },
  {
    "Retail Branding": "RCA",
    "Marketing Name": "DRP29101QT",
    "Device": "DRP29101QT",
    "Model": "DRP29101QT"
  },
  {
    "Retail Branding": "RCA",
    "Marketing Name": "Gemini 10 pro",
    "Device": "RCT6A03W13FU",
    "Model": "RCT6A03W13FU"
  },
  {
    "Retail Branding": "RCA",
    "Marketing Name": "Juno 10",
    "Device": "RCT6A03W12EU",
    "Model": "RCT6A03W12EU"
  },
  {
    "Retail Branding": "RCA",
    "Marketing Name": "Mercury 7",
    "Device": "CT9973W43M",
    "Model": "CT9973W43M"
  },
  {
    "Retail Branding": "RCA",
    "Marketing Name": "Mexico",
    "Device": "yeongdeungpo",
    "Model": "AiPlus4K"
  },
  {
    "Retail Branding": "RCA",
    "Marketing Name": "Prime",
    "Device": "RCA_Prime",
    "Model": "Prime"
  },
  {
    "Retail Branding": "RCA",
    "Marketing Name": "Pro10 Edition II",
    "Device": "RCT6203W46L",
    "Model": "RCT6203W46L"
  },
  {
    "Retail Branding": "RCA",
    "Marketing Name": "Pro12",
    "Device": "RCT6223W87",
    "Model": "RCT6223W87"
  },
  {
    "Retail Branding": "RCA",
    "Marketing Name": "Q2",
    "Device": "Q2",
    "Model": "Q2"
  },
  {
    "Retail Branding": "RCA",
    "Marketing Name": "RAKR30824",
    "Device": "RAKR30824",
    "Model": "RAKR30824"
  },
  {
    "Retail Branding": "RCA",
    "Marketing Name": "RATM20831",
    "Device": "RATM20831",
    "Model": "RATM20831"
  },
  {
    "Retail Branding": "RCA",
    "Marketing Name": "RATM21036",
    "Device": "RATM21036",
    "Model": "RATM21036"
  },
  {
    "Retail Branding": "RCA",
    "Marketing Name": "RATM30846",
    "Device": "RATM30846",
    "Model": "RATM30846"
  },
  {
    "Retail Branding": "RCA",
    "Marketing Name": "RATM31046",
    "Device": "RATM31046",
    "Model": "RATM31046"
  },
  {
    "Retail Branding": "RCA",
    "Marketing Name": "RATM31249",
    "Device": "RATM31249",
    "Model": "RATM31249"
  },
  {
    "Retail Branding": "RCA",
    "Marketing Name": "RATM3144B",
    "Device": "RATM3144B",
    "Model": "RATM3144B"
  },
  {
    "Retail Branding": "RCA",
    "Marketing Name": "RATR30824",
    "Device": "RATR30824",
    "Model": "RATR30824"
  },
  {
    "Retail Branding": "RCA",
    "Marketing Name": "RATR31024",
    "Device": "RATR31024",
    "Model": "RATR31024"
  },
  {
    "Retail Branding": "RCA",
    "Marketing Name": "RC10T3G21",
    "Device": "RC10T3G21",
    "Model": "RC10T3G21"
  },
  {
    "Retail Branding": "RCA",
    "Marketing Name": "RC10TB",
    "Device": "RC10TB",
    "Model": "OA-SAHARA"
  },
  {
    "Retail Branding": "RCA",
    "Marketing Name": "RC10TB",
    "Device": "RC10TB",
    "Model": "RC10TB"
  },
  {
    "Retail Branding": "RCA",
    "Marketing Name": "RC7T3G19",
    "Device": "RC7T3G19",
    "Model": "RC7T3G19"
  },
  {
    "Retail Branding": "RCA",
    "Marketing Name": "RC7T3G21",
    "Device": "RC7T3G21",
    "Model": "RC7T3G21"
  },
  {
    "Retail Branding": "RCA",
    "Marketing Name": "RC8T3G21",
    "Device": "RC8T3G21",
    "Model": "RC8T3G21"
  },
  {
    "Retail Branding": "RCA",
    "Marketing Name": "RCA",
    "Device": "elliniko",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "RCA",
    "Marketing Name": "RCA",
    "Device": "elliniko",
    "Model": "RCA 4K SMART TV"
  },
  {
    "Retail Branding": "RCA",
    "Marketing Name": "RCA",
    "Device": "hongkong",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "RCA",
    "Marketing Name": "RCA",
    "Device": "jagalchi",
    "Model": "2K SMART TV"
  },
  {
    "Retail Branding": "RCA",
    "Marketing Name": "RCA",
    "Device": "lavender",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "RCA",
    "Marketing Name": "RCA",
    "Device": "mountbaker",
    "Model": "2K SMART TV"
  },
  {
    "Retail Branding": "RCA",
    "Marketing Name": "RCA",
    "Device": "mountbaker",
    "Model": "RCA SMART TV"
  },
  {
    "Retail Branding": "RCA",
    "Marketing Name": "RCA",
    "Device": "seocho",
    "Model": "RCA 4K Android TV"
  },
  {
    "Retail Branding": "RCA",
    "Marketing Name": "RCA 2K Android TV",
    "Device": "lasalle",
    "Model": "RCA 2K Android TV"
  },
  {
    "Retail Branding": "RCA",
    "Marketing Name": "RCA 2K Google TV-E",
    "Device": "capitolhill",
    "Model": "RCA 2K Google TV-E"
  },
  {
    "Retail Branding": "RCA",
    "Marketing Name": "RCA 2K SMART TV",
    "Device": "nagata",
    "Model": "RCA 2K SMART TV"
  },
  {
    "Retail Branding": "RCA",
    "Marketing Name": "RCA 4K Android TV",
    "Device": "kenton",
    "Model": "RCA 4K Android TV"
  },
  {
    "Retail Branding": "RCA",
    "Marketing Name": "RCA 4K Google TV",
    "Device": "keoneae",
    "Model": "RCA 4K Google TV"
  },
  {
    "Retail Branding": "RCA",
    "Marketing Name": "RCA 4K Google TV-E",
    "Device": "keoneae",
    "Model": "RCA 4K Google TV-E"
  },
  {
    "Retail Branding": "RCA",
    "Marketing Name": "RCA DRP2091",
    "Device": "DRP2091",
    "Model": "DRP2091"
  },
  {
    "Retail Branding": "RCA",
    "Marketing Name": "RCA RCT6213W22",
    "Device": "RCT6213W22",
    "Model": "RCT6213W22"
  },
  {
    "Retail Branding": "RCA",
    "Marketing Name": "RCA RCT6213W23",
    "Device": "RCT6213W23",
    "Model": "RCT6213W23"
  },
  {
    "Retail Branding": "RCA",
    "Marketing Name": "RCA RCT6213W24",
    "Device": "RCT6213W24",
    "Model": "RCT6213W24"
  },
  {
    "Retail Branding": "RCA",
    "Marketing Name": "RCA RCT6613W23PU",
    "Device": "RCT6613W23PU",
    "Model": "RCT6613W23PU"
  },
  {
    "Retail Branding": "RCA",
    "Marketing Name": "RCA RCT6703W13",
    "Device": "RCT6703W13",
    "Model": "RCT6703W13"
  },
  {
    "Retail Branding": "RCA",
    "Marketing Name": "RCA RCT6716Q25",
    "Device": "RCT6716Q25",
    "Model": "RCT6716Q25"
  },
  {
    "Retail Branding": "RCA",
    "Marketing Name": "RCA RCT6973W43MDC8",
    "Device": "RCT6973W43MDC8",
    "Model": "RCT6973W43MDC8"
  },
  {
    "Retail Branding": "RCA",
    "Marketing Name": "RCA RCT6A03W12",
    "Device": "RCT6A03W12",
    "Model": "RCT6A03W12"
  },
  {
    "Retail Branding": "RCA",
    "Marketing Name": "RCA RCT6A03W13E",
    "Device": "RCT6A03W13E",
    "Model": "RCT6A03W13E"
  },
  {
    "Retail Branding": "RCA",
    "Marketing Name": "RCA RCT6B03W12",
    "Device": "RCT6B03W12",
    "Model": "RCT6B03W12"
  },
  {
    "Retail Branding": "RCA",
    "Marketing Name": "RCA RCT6B03W13",
    "Device": "RCT6B03W13",
    "Model": "RCT6B03W13"
  },
  {
    "Retail Branding": "RCA",
    "Marketing Name": "RCA RCT6B06P23",
    "Device": "RCT6B06P23",
    "Model": "RCT6B06P23"
  },
  {
    "Retail Branding": "RCA",
    "Marketing Name": "RCA RCT6B83W12",
    "Device": "RCT6B83W12",
    "Model": "RCT6B83W12"
  },
  {
    "Retail Branding": "RCA",
    "Marketing Name": "RCA RCT6B86E12",
    "Device": "RCT6B86E12",
    "Model": "RCT6B86E12"
  },
  {
    "Retail Branding": "RCA",
    "Marketing Name": "RCA RCT6S03W12",
    "Device": "RCT6S03W12",
    "Model": "RCT6S03W12"
  },
  {
    "Retail Branding": "RCA",
    "Marketing Name": "RCA RCT6S03W14",
    "Device": "RCT6S03W14",
    "Model": "RCT6S03W14"
  },
  {
    "Retail Branding": "RCA",
    "Marketing Name": "RCA Reno Max",
    "Device": "RCA_Reno_Max",
    "Model": "Reno Max"
  },
  {
    "Retail Branding": "RCA",
    "Marketing Name": "RCA TV 2K-A",
    "Device": "lasalle",
    "Model": "RCA TV 2K-A"
  },
  {
    "Retail Branding": "RCA",
    "Marketing Name": "RCA TV 4K G",
    "Device": "keoneae",
    "Model": "HK 4K Google TV"
  },
  {
    "Retail Branding": "RCA",
    "Marketing Name": "RCA TV 4K G",
    "Device": "keoneae",
    "Model": "RCA TV 4K G"
  },
  {
    "Retail Branding": "RCA",
    "Marketing Name": "RCARENO5011619",
    "Device": "RCARENO5011619",
    "Model": "RCARENO5011619"
  },
  {
    "Retail Branding": "RCA",
    "Marketing Name": "RCA_G2",
    "Device": "RCA_G2",
    "Model": "RCA G2"
  },
  {
    "Retail Branding": "RCA",
    "Marketing Name": "RCS13101T",
    "Device": "RCS13101T",
    "Model": "RCS13101T"
  },
  {
    "Retail Branding": "RCA",
    "Marketing Name": "RCT6002W46",
    "Device": "RCT6002W46",
    "Model": "RCT6002W46"
  },
  {
    "Retail Branding": "RCA",
    "Marketing Name": "RCT6077W2",
    "Device": "RCT6077W2",
    "Model": "RCT6077W2"
  },
  {
    "Retail Branding": "RCA",
    "Marketing Name": "RCT6077W22",
    "Device": "RCT6077W22",
    "Model": "RCT6077W22"
  },
  {
    "Retail Branding": "RCA",
    "Marketing Name": "RCT6103W46",
    "Device": "RCT6103W46",
    "Model": "RCT6103W46"
  },
  {
    "Retail Branding": "RCA",
    "Marketing Name": "RCT6203W46",
    "Device": "RCT6203W46",
    "Model": "RCT6203W46"
  },
  {
    "Retail Branding": "RCA",
    "Marketing Name": "RCT6223W97",
    "Device": "RCT6223W97",
    "Model": "RCT6223W97"
  },
  {
    "Retail Branding": "RCA",
    "Marketing Name": "RCT6272W23",
    "Device": "RCT6272W23",
    "Model": "RCT6272W23"
  },
  {
    "Retail Branding": "RCA",
    "Marketing Name": "RCT6273W26",
    "Device": "RCT6273W26",
    "Model": "RCT6273W26"
  },
  {
    "Retail Branding": "RCA",
    "Marketing Name": "RCT6283W27",
    "Device": "RCT6283W27",
    "Model": "RCT6283W27"
  },
  {
    "Retail Branding": "RCA",
    "Marketing Name": "RCT6293W23",
    "Device": "RCT6293W23",
    "Model": "RCT6293W23"
  },
  {
    "Retail Branding": "RCA",
    "Marketing Name": "RCT6378W2",
    "Device": "RCT6378W2",
    "Model": "RCT6378W2"
  },
  {
    "Retail Branding": "RCA",
    "Marketing Name": "RCT6513W87",
    "Device": "RCT6513W87DK5eQm",
    "Model": "RCT6513W87DK5eQm"
  },
  {
    "Retail Branding": "RCA",
    "Marketing Name": "RCT6513W87DK5e",
    "Device": "RCT6513W87DK5e",
    "Model": "RCT6513W87DK5e"
  },
  {
    "Retail Branding": "RCA",
    "Marketing Name": "RCT6513W87DK5eQ",
    "Device": "RCT6513W87DK5eQ",
    "Model": "RCT6513W87DK5eQ"
  },
  {
    "Retail Branding": "RCA",
    "Marketing Name": "RCT6513W87DK5eQe",
    "Device": "RCT6513W87DK5eQe",
    "Model": "RCT6513W87DK5eQe"
  },
  {
    "Retail Branding": "RCA",
    "Marketing Name": "RCT6573W23",
    "Device": "RCT6573W23",
    "Model": "RCT6573W23"
  },
  {
    "Retail Branding": "RCA",
    "Marketing Name": "RCT6603W47",
    "Device": "RCT6603W47DK",
    "Model": "RCT6603W47DK"
  },
  {
    "Retail Branding": "RCA",
    "Marketing Name": "RCT6613W23Q",
    "Device": "RCT6613W23Q",
    "Model": "RCT6613W23Q"
  },
  {
    "Retail Branding": "RCA",
    "Marketing Name": "RCT6672W23",
    "Device": "RCT6672W23",
    "Model": "RCT6672W23"
  },
  {
    "Retail Branding": "RCA",
    "Marketing Name": "RCT6673W-V1",
    "Device": "RCT6673W-V1",
    "Model": "RCT6673W-V1"
  },
  {
    "Retail Branding": "RCA",
    "Marketing Name": "RCT6691W3",
    "Device": "RCT6691W3",
    "Model": "RCT6691W3"
  },
  {
    "Retail Branding": "RCA",
    "Marketing Name": "RCT6716Q23",
    "Device": "RCT6716Q23",
    "Model": "RCT6716Q23"
  },
  {
    "Retail Branding": "RCA",
    "Marketing Name": "RCT6716Q24",
    "Device": "RCT6716Q24",
    "Model": "RCT6716Q24"
  },
  {
    "Retail Branding": "RCA",
    "Marketing Name": "RCT6773W22",
    "Device": "RCT6773W22",
    "Model": "RCT6773W22"
  },
  {
    "Retail Branding": "RCA",
    "Marketing Name": "RCT6773W42B",
    "Device": "RCT6773W42B",
    "Model": "RCT6773W42B"
  },
  {
    "Retail Branding": "RCA",
    "Marketing Name": "RCT6873W42BMF8QE",
    "Device": "RCT6873W42BMF8QE",
    "Model": "RCT6873W42BMF8QE"
  },
  {
    "Retail Branding": "RCA",
    "Marketing Name": "RCT6873W42BMF9A",
    "Device": "RCT6873W42BMF9A",
    "Model": "RCT6873W42BMF9A"
  },
  {
    "Retail Branding": "RCA",
    "Marketing Name": "RCT6873W42M",
    "Device": "RCT6873W42M",
    "Model": "RCT6873W42M"
  },
  {
    "Retail Branding": "RCA",
    "Marketing Name": "RCT6876Q22",
    "Device": "RCT6876Q22",
    "Model": "RCT6876Q22"
  },
  {
    "Retail Branding": "RCA",
    "Marketing Name": "RCT6876Q22N",
    "Device": "RCT6876Q22N",
    "Model": "RCT6876Q22N"
  },
  {
    "Retail Branding": "RCA",
    "Marketing Name": "RCT6973W43",
    "Device": "RCT6973W43",
    "Model": "RCT6973W43"
  },
  {
    "Retail Branding": "RCA",
    "Marketing Name": "RCT6973W43M",
    "Device": "RCT6973W43M",
    "Model": "RCT6973W43M"
  },
  {
    "Retail Branding": "RCA",
    "Marketing Name": "RCT6973W43MDEU",
    "Device": "RCT6973W43MDEU",
    "Model": "RCT6973W43MDEU"
  },
  {
    "Retail Branding": "RCA",
    "Marketing Name": "RCT6973W43R",
    "Device": "RCT6973W43R",
    "Model": "RCT6973W43R"
  },
  {
    "Retail Branding": "RCA",
    "Marketing Name": "RCT6A03W13Q",
    "Device": "RCT6A03W13Q",
    "Model": "RCT6A03W13Q"
  },
  {
    "Retail Branding": "RCA",
    "Marketing Name": "RCT6A06E12",
    "Device": "RCT6A06E12",
    "Model": "RCT6A06E12"
  },
  {
    "Retail Branding": "RCA",
    "Marketing Name": "RCT6A06Q22",
    "Device": "RCT6A06Q22",
    "Model": "RCT6A06Q22"
  },
  {
    "Retail Branding": "RCA",
    "Marketing Name": "RCT6B03Q23",
    "Device": "RCT6B03Q23",
    "Model": "RCT6B03Q23"
  },
  {
    "Retail Branding": "RCA",
    "Marketing Name": "RCT6B06Q23",
    "Device": "RCT6B06Q23",
    "Model": "RCT6B06Q23"
  },
  {
    "Retail Branding": "RCA",
    "Marketing Name": "RCT6T48Q35",
    "Device": "RCT6T48Q35",
    "Model": "RCT6T48Q35"
  },
  {
    "Retail Branding": "RCA",
    "Marketing Name": "RENO_NAPA",
    "Device": "RENO_NAPA",
    "Model": "RENO_NAPA"
  },
  {
    "Retail Branding": "RCA",
    "Marketing Name": "RLTP5573",
    "Device": "RLTP5573",
    "Model": "RLTP5573"
  },
  {
    "Retail Branding": "RCA",
    "Marketing Name": "Reno_Pro",
    "Device": "Reno_Pro",
    "Model": "Reno Pro"
  },
  {
    "Retail Branding": "RCA",
    "Marketing Name": "Smart Monitor",
    "Device": "mateo",
    "Model": "2K Smart Monitor"
  },
  {
    "Retail Branding": "RCA",
    "Marketing Name": "Smart TV",
    "Device": "kanda",
    "Model": "2K Smart TV"
  },
  {
    "Retail Branding": "RCA",
    "Marketing Name": "Smart TV",
    "Device": "mateo",
    "Model": "2K PA Smart TV"
  },
  {
    "Retail Branding": "RCA",
    "Marketing Name": "Smart TV",
    "Device": "mateo",
    "Model": "2K SA Smart TV"
  },
  {
    "Retail Branding": "RCA",
    "Marketing Name": "Smart TV",
    "Device": "osaki",
    "Model": "2K AI Smart TV"
  },
  {
    "Retail Branding": "RCA",
    "Marketing Name": "Smart TV",
    "Device": "osaki",
    "Model": "Treeview 2K AI Smart TV"
  },
  {
    "Retail Branding": "RCA",
    "Marketing Name": "Smart TV",
    "Device": "ueno",
    "Model": "2K Android TV"
  },
  {
    "Retail Branding": "RCA",
    "Marketing Name": "TAB_One",
    "Device": "TAB_One",
    "Model": "TAB_One"
  },
  {
    "Retail Branding": "RCA",
    "Marketing Name": "TAB_One_Plus",
    "Device": "TAB_One_Plus",
    "Model": "TAB_One_Plus"
  },
  {
    "Retail Branding": "RCA",
    "Marketing Name": "Tab_Pro",
    "Device": "Tab_Pro",
    "Model": "Tab_Pro"
  },
  {
    "Retail Branding": "RCA",
    "Marketing Name": "US",
    "Device": "marina",
    "Model": "RCA 4K SMART TV"
  },
  {
    "Retail Branding": "RCA",
    "Marketing Name": "Voyager",
    "Device": "RCT6873W42BMF8",
    "Model": "RCT6873W42BMF8"
  },
  {
    "Retail Branding": "RCA",
    "Marketing Name": "Voyager",
    "Device": "RCT6873W42BMF9E",
    "Model": "RCT6873W42BMF9E"
  },
  {
    "Retail Branding": "RCA",
    "Marketing Name": "Voyager III",
    "Device": "RCT6973MDN",
    "Model": "RCT6973MDN"
  },
  {
    "Retail Branding": "RCA",
    "Marketing Name": "Voyager Pro",
    "Device": "RCT6873W42M_F7",
    "Model": "RCT6873W42M_F7"
  },
  {
    "Retail Branding": "RCA",
    "Marketing Name": "XLD Series",
    "Device": "XLDRCAV1",
    "Model": "XLDRCAV1"
  },
  {
    "Retail Branding": "RCT",
    "Marketing Name": "Pulse_10",
    "Device": "Pulse_10",
    "Model": "Pulse_10"
  },
  {
    "Retail Branding": "RCT",
    "Marketing Name": "Pulse_8",
    "Device": "Pulse_8",
    "Model": "Pulse_8"
  },
  {
    "Retail Branding": "RDP(in)",
    "Marketing Name": "TP802",
    "Device": "TP802",
    "Model": "TP802"
  },
  {
    "Retail Branding": "REACH",
    "Marketing Name": "Q882",
    "Device": "Q882",
    "Model": "Q882"
  },
  {
    "Retail Branding": "REBEOSOII",
    "Marketing Name": "C11",
    "Device": "C11",
    "Model": "C11"
  },
  {
    "Retail Branding": "REBEOSOII",
    "Marketing Name": "G11",
    "Device": "G11",
    "Model": "G11"
  },
  {
    "Retail Branding": "REBEOSOII",
    "Marketing Name": "P31",
    "Device": "P31",
    "Model": "P31"
  },
  {
    "Retail Branding": "RECCO",
    "Marketing Name": "Android TV",
    "Device": "R1",
    "Model": "ATV R1"
  },
  {
    "Retail Branding": "RECCO",
    "Marketing Name": "Android TV",
    "Device": "R2",
    "Model": "ATV R2"
  },
  {
    "Retail Branding": "RED",
    "Marketing Name": "HydrogenONE",
    "Device": "HydrogenONE",
    "Model": "H1A1000"
  },
  {
    "Retail Branding": "REDLINE",
    "Marketing Name": "Space_A10",
    "Device": "Space_A10",
    "Model": "Space_A10"
  },
  {
    "Retail Branding": "REDLINE",
    "Marketing Name": "Space_A18",
    "Device": "Space_A8",
    "Model": "Space_A8"
  },
  {
    "Retail Branding": "REDLINE",
    "Marketing Name": "Space_M10",
    "Device": "Space_M10",
    "Model": "Space_M10"
  },
  {
    "Retail Branding": "REDLINE",
    "Marketing Name": "Space_M10Pro",
    "Device": "Space_M10Pro",
    "Model": "Space_M10Pro"
  },
  {
    "Retail Branding": "REDMAGIC",
    "Marketing Name": "NX799J",
    "Device": "NX799J",
    "Model": "NX799J"
  },
  {
    "Retail Branding": "REDMAGIC",
    "Marketing Name": "REDMAGIC 11 Pro+",
    "Device": "NX809J",
    "Model": "NX809J"
  },
  {
    "Retail Branding": "REDTONE",
    "Marketing Name": "RTSP-A124ML",
    "Device": "RTSP-A124ML",
    "Model": "RTSP-A124ML"
  },
  {
    "Retail Branding": "REDTONE",
    "Marketing Name": "RTSP-A258HM",
    "Device": "RTSP-A258HM",
    "Model": "RTSP-A258HM"
  },
  {
    "Retail Branding": "REDTONE",
    "Marketing Name": "RTSP-A64B",
    "Device": "RTSP-A64B",
    "Model": "RTSP-A64B"
  },
  {
    "Retail Branding": "REGZA",
    "Marketing Name": "REGZA Projector",
    "Device": "hengshan",
    "Model": "REGZA Projector"
  },
  {
    "Retail Branding": "REGZA",
    "Marketing Name": "RSG-11B",
    "Device": "YYT",
    "Model": "4K Google TV Stick"
  },
  {
    "Retail Branding": "RENSO",
    "Marketing Name": "NEP N1",
    "Device": "NEP_N1",
    "Model": "NEP N1"
  },
  {
    "Retail Branding": "REVENGER",
    "Marketing Name": "RG-TB711",
    "Device": "RG-TB711",
    "Model": "RG-TB711"
  },
  {
    "Retail Branding": "REVOX",
    "Marketing Name": "REVOX-RM-RX1-EU",
    "Device": "REVOX-RM-RX1-EU",
    "Model": "C200-RM-RX1"
  },
  {
    "Retail Branding": "RIKOR",
    "Marketing Name": "S3",
    "Device": "S3_RU",
    "Model": "S3"
  },
  {
    "Retail Branding": "RIKOR",
    "Marketing Name": "S5",
    "Device": "S5_RU",
    "Model": "S5"
  },
  {
    "Retail Branding": "RIKOR",
    "Marketing Name": "S7",
    "Device": "S7_RU",
    "Model": "S7"
  },
  {
    "Retail Branding": "RIO Mobile",
    "Marketing Name": "R7MAX",
    "Device": "R7MAX",
    "Model": "R7MAX"
  },
  {
    "Retail Branding": "RIO Mobile",
    "Marketing Name": "RIOPAD_S10_Pro",
    "Device": "RIOPAD_S10_Pro",
    "Model": "RIOPAD_S10_Pro"
  },
  {
    "Retail Branding": "RIO Mobile",
    "Marketing Name": "RW10",
    "Device": "RW10",
    "Model": "RW10"
  },
  {
    "Retail Branding": "RIO Mobile",
    "Marketing Name": "RW8",
    "Device": "RW8",
    "Model": "RW8"
  },
  {
    "Retail Branding": "RIRO",
    "Marketing Name": "RIRO_X100",
    "Device": "RIRO_X100",
    "Model": "RG-TB711-V1"
  },
  {
    "Retail Branding": "RIRO",
    "Marketing Name": "RIRO_X100",
    "Device": "RIRO_X100",
    "Model": "RIRO Pad"
  },
  {
    "Retail Branding": "RIRO",
    "Marketing Name": "RIRO_X100",
    "Device": "RIRO_X100",
    "Model": "RIRO X100"
  },
  {
    "Retail Branding": "RIVERSONG",
    "Marketing Name": "Astro_6",
    "Device": "Astro_6",
    "Model": "Astro_6"
  },
  {
    "Retail Branding": "RIVERSONG",
    "Marketing Name": "BLACK",
    "Device": "BLACK",
    "Model": "BLACK"
  },
  {
    "Retail Branding": "RLG-ADULAWO-LIMITED",
    "Marketing Name": "Eagle-2024",
    "Device": "Eagle-2024",
    "Model": "Eagle-2024"
  },
  {
    "Retail Branding": "RNRUO",
    "Marketing Name": "T10A863-21",
    "Device": "T10A863-21",
    "Model": "T10A863-21"
  },
  {
    "Retail Branding": "RNRUO",
    "Marketing Name": "T10A863-51",
    "Device": "T10A863-51",
    "Model": "T10A863-51"
  },
  {
    "Retail Branding": "ROKiT",
    "Marketing Name": "IO 3D",
    "Device": "Dingo",
    "Model": "IO 3D"
  },
  {
    "Retail Branding": "ROKiT",
    "Marketing Name": "IO Light",
    "Device": "Chinchilla",
    "Model": "IO Light"
  },
  {
    "Retail Branding": "ROKiT",
    "Marketing Name": "IO Pro",
    "Device": "Emu",
    "Model": "IO Pro"
  },
  {
    "Retail Branding": "ROKiT",
    "Marketing Name": "Orb_S",
    "Device": "Gecko",
    "Model": "Orb S"
  },
  {
    "Retail Branding": "ROKiT",
    "Marketing Name": "dingo",
    "Device": "Dingo",
    "Model": "IO 3D"
  },
  {
    "Retail Branding": "ROLLCALL",
    "Marketing Name": "DT",
    "Device": "DT",
    "Model": "DT"
  },
  {
    "Retail Branding": "ROVER",
    "Marketing Name": "CHIPPY",
    "Device": "CHIPPY",
    "Model": "CHIPPY"
  },
  {
    "Retail Branding": "ROVER",
    "Marketing Name": "R10_M",
    "Device": "R10_M",
    "Model": "R10_M"
  },
  {
    "Retail Branding": "ROVER",
    "Marketing Name": "R8",
    "Device": "R8",
    "Model": "R8"
  },
  {
    "Retail Branding": "ROWA",
    "Marketing Name": "R4",
    "Device": "R4",
    "Model": "R4"
  },
  {
    "Retail Branding": "RSEA",
    "Marketing Name": "RSE E1",
    "Device": "RSE_E1",
    "Model": "RSE E1"
  },
  {
    "Retail Branding": "RT Project",
    "Marketing Name": "Glam",
    "Device": "Glam",
    "Model": "Glam"
  },
  {
    "Retail Branding": "RT Project",
    "Marketing Name": "SHOCK6",
    "Device": "SHOCK6",
    "Model": "SHOCK6"
  },
  {
    "Retail Branding": "RT Project",
    "Marketing Name": "WIDE",
    "Device": "WIDE",
    "Model": "WIDE"
  },
  {
    "Retail Branding": "RT Project",
    "Marketing Name": "Wide",
    "Device": "Wide",
    "Model": "Wide"
  },
  {
    "Retail Branding": "RT Project",
    "Marketing Name": "popper2",
    "Device": "popper2",
    "Model": "popper2"
  },
  {
    "Retail Branding": "RUGLINE",
    "Marketing Name": "T14",
    "Device": "T14",
    "Model": "T14"
  },
  {
    "Retail Branding": "RUGLINE",
    "Marketing Name": "T14_EEA",
    "Device": "T14",
    "Model": "T14"
  },
  {
    "Retail Branding": "RUGSTORM",
    "Marketing Name": "UA100",
    "Device": "UA100",
    "Model": "UA100"
  },
  {
    "Retail Branding": "RUGSTORM",
    "Marketing Name": "UA80",
    "Device": "UA80",
    "Model": "UA80"
  },
  {
    "Retail Branding": "RUSHAR",
    "Marketing Name": "M132-EEA",
    "Device": "M132-EEA",
    "Model": "M132-EEA"
  },
  {
    "Retail Branding": "RUSHAR",
    "Marketing Name": "M159",
    "Device": "M159",
    "Model": "M159"
  },
  {
    "Retail Branding": "RUSHAR",
    "Marketing Name": "M159-EEA",
    "Device": "M159-EEA",
    "Model": "M159-EEA"
  },
  {
    "Retail Branding": "RVP(AB)",
    "Marketing Name": "RVPVK808",
    "Device": "RVPVK808",
    "Model": "RVPVK808"
  },
  {
    "Retail Branding": "RWC_JP",
    "Marketing Name": "HNPD01",
    "Device": "HNPD01",
    "Model": "HNPD01"
  },
  {
    "Retail Branding": "Radger",
    "Marketing Name": "IMP-F01K",
    "Device": "IMP-F01K",
    "Model": "IMP-F01K"
  },
  {
    "Retail Branding": "Radger",
    "Marketing Name": "Redmi 10 Prime",
    "Device": "selene",
    "Model": "21061119BI"
  },
  {
    "Retail Branding": "Radger",
    "Marketing Name": "Redmi 10 Prime",
    "Device": "selene",
    "Model": "22011119TI"
  },
  {
    "Retail Branding": "Radger",
    "Marketing Name": "Redmi 10C",
    "Device": "fog",
    "Model": "220333QAG"
  },
  {
    "Retail Branding": "Rainbow",
    "Marketing Name": "WIKO",
    "Device": "s5501",
    "Model": "RAINBOW"
  },
  {
    "Retail Branding": "Rakioo",
    "Marketing Name": "X5",
    "Device": "X5",
    "Model": "X5"
  },
  {
    "Retail Branding": "Rakuten",
    "Marketing Name": "C330",
    "Device": "C330",
    "Model": "C330"
  },
  {
    "Retail Branding": "Rakuten",
    "Marketing Name": "Rakuten BIG s",
    "Device": "gaea",
    "Model": "3917JR"
  },
  {
    "Retail Branding": "Rakuten",
    "Marketing Name": "Rakuten Hand",
    "Device": "P710",
    "Model": "P710"
  },
  {
    "Retail Branding": "Rakuten",
    "Marketing Name": "Rakuten Hand5G",
    "Device": "P780",
    "Model": "P780"
  },
  {
    "Retail Branding": "Rangs",
    "Marketing Name": "RANGS",
    "Device": "elliniko",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "Rangs",
    "Marketing Name": "RANGS",
    "Device": "hongkong",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "Rangs",
    "Marketing Name": "RANGS",
    "Device": "lavender",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "Rangs",
    "Marketing Name": "RANGS",
    "Device": "mountbaker",
    "Model": "2K SMART TV"
  },
  {
    "Retail Branding": "Ratel",
    "Marketing Name": "Cell",
    "Device": "Cell",
    "Model": "CELL"
  },
  {
    "Retail Branding": "Rayan",
    "Marketing Name": "AM_TAB_7_03",
    "Device": "AMAA703",
    "Model": "AMA_A703"
  },
  {
    "Retail Branding": "Raylandz",
    "Marketing Name": "H1 PLUS",
    "Device": "PHOENIX_H1PLUS",
    "Model": "PHOENIX_H1PLUS"
  },
  {
    "Retail Branding": "Raylandz",
    "Marketing Name": "P20 PLUS",
    "Device": "RAYLAN_P20_Plus",
    "Model": "P20 PLUS"
  },
  {
    "Retail Branding": "Raylandz",
    "Marketing Name": "P5000",
    "Device": "P5000",
    "Model": "P5000"
  },
  {
    "Retail Branding": "Raylandz",
    "Marketing Name": "PHOENIX_N1",
    "Device": "PHOENIX_N1",
    "Model": "PHOENIX N1"
  },
  {
    "Retail Branding": "Raylandz",
    "Marketing Name": "Smart TV",
    "Device": "longshan",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "Raylandz",
    "Marketing Name": "V6_Pro",
    "Device": "V6_Pro",
    "Model": "V6_Pro"
  },
  {
    "Retail Branding": "Raylandz",
    "Marketing Name": "X3_Pro",
    "Device": "X3_Pro",
    "Model": "X3_Pro"
  },
  {
    "Retail Branding": "Raylandz",
    "Marketing Name": "XPOWER_P6000",
    "Device": "XPOWER_P6000",
    "Model": "XPOWER_P6000"
  },
  {
    "Retail Branding": "Razer",
    "Marketing Name": "Forge TV",
    "Device": "pearlyn",
    "Model": "Forge"
  },
  {
    "Retail Branding": "Razer",
    "Marketing Name": "Phone 2",
    "Device": "aura",
    "Model": "Phone 2"
  },
  {
    "Retail Branding": "Razer",
    "Marketing Name": "Phone 2",
    "Device": "bolt",
    "Model": "Phone 2"
  },
  {
    "Retail Branding": "Razer",
    "Marketing Name": "Phone 2",
    "Device": "linus",
    "Model": "Phone 2"
  },
  {
    "Retail Branding": "Razer",
    "Marketing Name": "Razer Edge",
    "Device": "Razer-Edge-WiFi",
    "Model": "Razer Edge WiFi"
  },
  {
    "Retail Branding": "Razer",
    "Marketing Name": "Razer Edge 5G",
    "Device": "RZ45-0460",
    "Model": "Razer Edge 5G"
  },
  {
    "Retail Branding": "Razer",
    "Marketing Name": "Razer Phone",
    "Device": "cheryl",
    "Model": "Phone"
  },
  {
    "Retail Branding": "Razer",
    "Marketing Name": "Razer phone",
    "Device": "cheryl_ckh",
    "Model": "Phone"
  },
  {
    "Retail Branding": "ReSYS",
    "Marketing Name": "RE SYS-IFPD",
    "Device": "oversea_v",
    "Model": "ReSYS_IB"
  },
  {
    "Retail Branding": "Readly",
    "Marketing Name": "ReadlyReaderOne",
    "Device": "ReadlyReaderOne",
    "Model": "ReadlyReaderOne"
  },
  {
    "Retail Branding": "Realix",
    "Marketing Name": "RxIS02",
    "Device": "RxIS02",
    "Model": "RxIS02"
  },
  {
    "Retail Branding": "Realix",
    "Marketing Name": "RxIS201",
    "Device": "RxIS201",
    "Model": "RxIS201"
  },
  {
    "Retail Branding": "Realix",
    "Marketing Name": "RxIS202",
    "Device": "RxIS202",
    "Model": "RxIS202"
  },
  {
    "Retail Branding": "Realme",
    "Marketing Name": "RMX2020",
    "Device": "RMX2020",
    "Model": "RMX2020"
  },
  {
    "Retail Branding": "Realme",
    "Marketing Name": "RMX2040",
    "Device": "RMX2040",
    "Model": "RMX2040"
  },
  {
    "Retail Branding": "Realme",
    "Marketing Name": "RMX3063",
    "Device": "RMX3063",
    "Model": "RMX3063"
  },
  {
    "Retail Branding": "Realme",
    "Marketing Name": "RMX3231",
    "Device": "RMX3231",
    "Model": "RMX3231"
  },
  {
    "Retail Branding": "Realme",
    "Marketing Name": "realme  GT 5G",
    "Device": "RMX2202L1",
    "Model": "RMX2202"
  },
  {
    "Retail Branding": "Realme",
    "Marketing Name": "realme 2 Pro",
    "Device": "RMX1801",
    "Model": "RMX1801"
  },
  {
    "Retail Branding": "Realme",
    "Marketing Name": "realme 3Pro",
    "Device": "RMX1851",
    "Model": "RMX1851"
  },
  {
    "Retail Branding": "Realme",
    "Marketing Name": "realme 5",
    "Device": "RMX1911L1",
    "Model": "RMX1911"
  },
  {
    "Retail Branding": "Realme",
    "Marketing Name": "realme 5",
    "Device": "RMX1915",
    "Model": "RMX1915"
  },
  {
    "Retail Branding": "Realme",
    "Marketing Name": "realme 5",
    "Device": "RMX1919",
    "Model": "RMX1919"
  },
  {
    "Retail Branding": "Realme",
    "Marketing Name": "realme 5",
    "Device": "RMX1925",
    "Model": "RMX1925"
  },
  {
    "Retail Branding": "Realme",
    "Marketing Name": "realme 5",
    "Device": "RMX1926",
    "Model": "RMX1926"
  },
  {
    "Retail Branding": "Realme",
    "Marketing Name": "realme 5",
    "Device": "RMX1927",
    "Model": "RMX1927"
  },
  {
    "Retail Branding": "Realme",
    "Marketing Name": "realme 5Pro",
    "Device": "RMX1971",
    "Model": "RMX1971"
  },
  {
    "Retail Branding": "Realme",
    "Marketing Name": "realme 5Pro",
    "Device": "RMX1971L1",
    "Model": "RMX1971"
  },
  {
    "Retail Branding": "Realme",
    "Marketing Name": "realme 5i",
    "Device": "RMX2030",
    "Model": "RMX2030"
  },
  {
    "Retail Branding": "Realme",
    "Marketing Name": "realme 5i",
    "Device": "RMX2030L1",
    "Model": "RMX2030"
  },
  {
    "Retail Branding": "Realme",
    "Marketing Name": "realme 5i",
    "Device": "RMX2031",
    "Model": "RMX2031"
  },
  {
    "Retail Branding": "Realme",
    "Marketing Name": "realme 5i",
    "Device": "RMX2032",
    "Model": "RMX2032"
  },
  {
    "Retail Branding": "Realme",
    "Marketing Name": "realme 5pro",
    "Device": "RMX1971",
    "Model": "RMX1971"
  },
  {
    "Retail Branding": "Realme",
    "Marketing Name": "realme 5pro",
    "Device": "RMX1973",
    "Model": "RMX1973"
  },
  {
    "Retail Branding": "Realme",
    "Marketing Name": "realme 6",
    "Device": "RMX2001L1",
    "Model": "RMX2001"
  },
  {
    "Retail Branding": "Realme",
    "Marketing Name": "realme 6",
    "Device": "RMX2003L1",
    "Model": "RMX2003"
  },
  {
    "Retail Branding": "Realme",
    "Marketing Name": "realme 6Pro",
    "Device": "RMX2063L1",
    "Model": "RMX2063"
  },
  {
    "Retail Branding": "Realme",
    "Marketing Name": "realme 6i",
    "Device": "RMX2030",
    "Model": "RMX2190"
  },
  {
    "Retail Branding": "Realme",
    "Marketing Name": "realme 6i",
    "Device": "RMX2040",
    "Model": "RMX2040"
  },
  {
    "Retail Branding": "Realme",
    "Marketing Name": "realme 6i",
    "Device": "RMX2041",
    "Model": "RMX2041"
  },
  {
    "Retail Branding": "Realme",
    "Marketing Name": "realme 6i",
    "Device": "RMX2042",
    "Model": "RMX2042"
  },
  {
    "Retail Branding": "Realme",
    "Marketing Name": "realme 6s",
    "Device": "RMX2002L1",
    "Model": "RMX2002"
  },
  {
    "Retail Branding": "Realme",
    "Marketing Name": "realme 7 Pro",
    "Device": "RMX2170L1",
    "Model": "RMX2170"
  },
  {
    "Retail Branding": "Realme",
    "Marketing Name": "realme 7i",
    "Device": "RE50C1L1",
    "Model": "RMX2103"
  },
  {
    "Retail Branding": "Realme",
    "Marketing Name": "realme 7i",
    "Device": "RMX2193",
    "Model": "RMX2193"
  },
  {
    "Retail Branding": "Realme",
    "Marketing Name": "realme 8Pro",
    "Device": "RMX3081L1",
    "Model": "RMX3081"
  },
  {
    "Retail Branding": "Realme",
    "Marketing Name": "realme 8i",
    "Device": "RE54B4L1",
    "Model": "RMX3151"
  },
  {
    "Retail Branding": "Realme",
    "Marketing Name": "realme C11",
    "Device": "RMX2185",
    "Model": "RMX2185"
  },
  {
    "Retail Branding": "Realme",
    "Marketing Name": "realme C11",
    "Device": "RMX2186",
    "Model": "RMX2186"
  },
  {
    "Retail Branding": "Realme",
    "Marketing Name": "realme C12",
    "Device": "RMX2184",
    "Model": "RMX2184"
  },
  {
    "Retail Branding": "Realme",
    "Marketing Name": "realme C12",
    "Device": "RMX2189",
    "Model": "RMX2189"
  },
  {
    "Retail Branding": "Realme",
    "Marketing Name": "realme C15",
    "Device": "RMX2180",
    "Model": "RMX2180"
  },
  {
    "Retail Branding": "Realme",
    "Marketing Name": "realme C15",
    "Device": "RMX2181",
    "Model": "RMX2181"
  },
  {
    "Retail Branding": "Realme",
    "Marketing Name": "realme C15",
    "Device": "RMX2183",
    "Model": "RMX2183"
  },
  {
    "Retail Branding": "Realme",
    "Marketing Name": "realme C15 Qualcomm Edition",
    "Device": "RECE4244",
    "Model": "RMX2195"
  },
  {
    "Retail Branding": "Realme",
    "Marketing Name": "realme C17",
    "Device": "RE50BF",
    "Model": "RMX2101"
  },
  {
    "Retail Branding": "Realme",
    "Marketing Name": "realme C2",
    "Device": "RMX1946",
    "Model": "RMX1946"
  },
  {
    "Retail Branding": "Realme",
    "Marketing Name": "realme C20",
    "Device": "RMX3061",
    "Model": "RMX3061"
  },
  {
    "Retail Branding": "Realme",
    "Marketing Name": "realme C20",
    "Device": "RMX3063",
    "Model": "RMX3063"
  },
  {
    "Retail Branding": "Realme",
    "Marketing Name": "realme C21",
    "Device": "RMX3201",
    "Model": "RMX3201"
  },
  {
    "Retail Branding": "Realme",
    "Marketing Name": "realme C21",
    "Device": "RMX3202",
    "Model": "RMX3202"
  },
  {
    "Retail Branding": "Realme",
    "Marketing Name": "realme C21",
    "Device": "RMX3203L1",
    "Model": "RMX3203"
  },
  {
    "Retail Branding": "Realme",
    "Marketing Name": "realme C21 Y",
    "Device": "RMX3261",
    "Model": "RMX3261"
  },
  {
    "Retail Branding": "Realme",
    "Marketing Name": "realme C3",
    "Device": "RMX2020",
    "Model": "RMX2020"
  },
  {
    "Retail Branding": "Realme",
    "Marketing Name": "realme C3",
    "Device": "RMX2021",
    "Model": "RMX2021"
  },
  {
    "Retail Branding": "Realme",
    "Marketing Name": "realme C3",
    "Device": "RMX2022",
    "Model": "RMX2022"
  },
  {
    "Retail Branding": "Realme",
    "Marketing Name": "realme C3",
    "Device": "RMX2027",
    "Model": "RMX2027"
  },
  {
    "Retail Branding": "Realme",
    "Marketing Name": "realme C3i",
    "Device": "RMX2027",
    "Model": "RMX2027"
  },
  {
    "Retail Branding": "Realme",
    "Marketing Name": "realme GT 5G",
    "Device": "RMX2202L1",
    "Model": "RMX2202"
  },
  {
    "Retail Branding": "Realme",
    "Marketing Name": "realme GT Explorer Master Edition",
    "Device": "RE546F",
    "Model": "RMX3366"
  },
  {
    "Retail Branding": "Realme",
    "Marketing Name": "realme GT Master Edition",
    "Device": "RE54ABL1",
    "Model": "RMX3363"
  },
  {
    "Retail Branding": "Realme",
    "Marketing Name": "realme GT Neo 2",
    "Device": "RE5473",
    "Model": "RMX3370"
  },
  {
    "Retail Branding": "Realme",
    "Marketing Name": "realme GT Neo2 5G",
    "Device": "RE879AL1",
    "Model": "RMX3370"
  },
  {
    "Retail Branding": "Realme",
    "Marketing Name": "realme Narzo 20",
    "Device": "RMX2193",
    "Model": "RMX2193"
  },
  {
    "Retail Branding": "Realme",
    "Marketing Name": "realme Pad",
    "Device": "RE54C1L1",
    "Model": "RMP2102"
  },
  {
    "Retail Branding": "Realme",
    "Marketing Name": "realme Q",
    "Device": "RMX1971CN",
    "Model": "RMX1971"
  },
  {
    "Retail Branding": "Realme",
    "Marketing Name": "realme SA Smart TV",
    "Device": "SW4H_FF",
    "Model": "realme SA Smart TV"
  },
  {
    "Retail Branding": "Realme",
    "Marketing Name": "realme Smart TV",
    "Device": "SW4H_FF",
    "Model": "realme Smart TV"
  },
  {
    "Retail Branding": "Realme",
    "Marketing Name": "realme TV",
    "Device": "ikebukuro",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "Realme",
    "Marketing Name": "realme TV 32",
    "Device": "ikebukuro",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "Realme",
    "Marketing Name": "realme TW Smart TV",
    "Device": "SW4H_FF",
    "Model": "realme TW Smart TV"
  },
  {
    "Retail Branding": "Realme",
    "Marketing Name": "realme V11 5G",
    "Device": "RMX3121CN",
    "Model": "RMX3121"
  },
  {
    "Retail Branding": "Realme",
    "Marketing Name": "realme V11 5G",
    "Device": "RMX3122CN",
    "Model": "RMX3122"
  },
  {
    "Retail Branding": "Realme",
    "Marketing Name": "realme V3  5G",
    "Device": "RMX2200CN",
    "Model": "RMX2200"
  },
  {
    "Retail Branding": "Realme",
    "Marketing Name": "realme V3 5G",
    "Device": "RMX2201CN",
    "Model": "RMX2201"
  },
  {
    "Retail Branding": "Realme",
    "Marketing Name": "realme X2",
    "Device": "RMX1991CN",
    "Model": "RMX1991"
  },
  {
    "Retail Branding": "Realme",
    "Marketing Name": "realme X2",
    "Device": "RMX1992L1",
    "Model": "RMX1992"
  },
  {
    "Retail Branding": "Realme",
    "Marketing Name": "realme X2",
    "Device": "RMX1993L1",
    "Model": "RMX1993"
  },
  {
    "Retail Branding": "Realme",
    "Marketing Name": "realme X2Pro",
    "Device": "RMX1931CN",
    "Model": "RMX1931"
  },
  {
    "Retail Branding": "Realme",
    "Marketing Name": "realme X2Pro",
    "Device": "RMX1931L1",
    "Model": "RMX1931"
  },
  {
    "Retail Branding": "Realme",
    "Marketing Name": "realme X3",
    "Device": "RMX2081L1",
    "Model": "RMX2081"
  },
  {
    "Retail Branding": "Realme",
    "Marketing Name": "realme X3",
    "Device": "RMX2085L1",
    "Model": "RMX2085"
  },
  {
    "Retail Branding": "Realme",
    "Marketing Name": "realme X50 5G",
    "Device": "RMX2025CN",
    "Model": "RMX2025"
  },
  {
    "Retail Branding": "Realme",
    "Marketing Name": "realme X50 5G",
    "Device": "RMX2144L1",
    "Model": "RMX2144"
  },
  {
    "Retail Branding": "Realme",
    "Marketing Name": "realme X50 Pro",
    "Device": "RMX2071CN",
    "Model": "RMX2071"
  },
  {
    "Retail Branding": "Realme",
    "Marketing Name": "realme X50 Pro",
    "Device": "RMX2075L1",
    "Model": "RMX2075"
  },
  {
    "Retail Branding": "Realme",
    "Marketing Name": "realme X50m 5G",
    "Device": "RE508C",
    "Model": "RMX2141"
  },
  {
    "Retail Branding": "Realme",
    "Marketing Name": "realme X50m 5G",
    "Device": "RE508C",
    "Model": "RMX2142"
  },
  {
    "Retail Branding": "Realme",
    "Marketing Name": "realme X50m 5G",
    "Device": "RMX2142CN",
    "Model": "RMX2142"
  },
  {
    "Retail Branding": "Realme",
    "Marketing Name": "realme X50t 5G",
    "Device": "RE508C",
    "Model": "RMX2052"
  },
  {
    "Retail Branding": "Realme",
    "Marketing Name": "realme X50t 5G",
    "Device": "RMX2052CN",
    "Model": "RMX2052"
  },
  {
    "Retail Branding": "Realme",
    "Marketing Name": "realme XT",
    "Device": "RMX1921",
    "Model": "RMX1921"
  },
  {
    "Retail Branding": "Realme",
    "Marketing Name": "realme XT",
    "Device": "RMX1921L1",
    "Model": "RMX1921"
  },
  {
    "Retail Branding": "Realme",
    "Marketing Name": "realme XT",
    "Device": "RMX1922",
    "Model": "RMX1922"
  },
  {
    "Retail Branding": "Realme",
    "Marketing Name": "realme narzo 20A",
    "Device": "RMX2050",
    "Model": "RMX2050"
  },
  {
    "Retail Branding": "Realme",
    "Marketing Name": "realme narzo 30A",
    "Device": "RMX3171",
    "Model": "RMX3171"
  },
  {
    "Retail Branding": "Realme",
    "Marketing Name": "realme pad",
    "Device": "RE54C1L1",
    "Model": "RMP2103"
  },
  {
    "Retail Branding": "Realme",
    "Marketing Name": "realme 7i",
    "Device": "RE50C1",
    "Model": "RMX2103"
  },
  {
    "Retail Branding": "Realme",
    "Marketing Name": "realme 7i",
    "Device": "RE50C1",
    "Model": "RMX2104"
  },
  {
    "Retail Branding": "Realme",
    "Marketing Name": "真我 X7 pro至尊版",
    "Device": "RMX3116CN",
    "Model": "RMX3116"
  },
  {
    "Retail Branding": "Realme",
    "Marketing Name": "真我GT",
    "Device": "RMX2202CN",
    "Model": "RMX2202"
  },
  {
    "Retail Branding": "Realme",
    "Marketing Name": "真我GT Neo 闪速版",
    "Device": "RE5469",
    "Model": "RMX3350"
  },
  {
    "Retail Branding": "Realme",
    "Marketing Name": "真我GT Neo2T",
    "Device": "RE5469",
    "Model": "RMX3357"
  },
  {
    "Retail Branding": "Realme",
    "Marketing Name": "真我V11s 5G",
    "Device": "RE5485",
    "Model": "RMX3125"
  },
  {
    "Retail Branding": "Realme Techlife",
    "Marketing Name": "Realme TV",
    "Device": "beomil",
    "Model": "Realme TV"
  },
  {
    "Retail Branding": "Realme Techlife",
    "Marketing Name": "Realme TV",
    "Device": "eleonas",
    "Model": "Realme TV"
  },
  {
    "Retail Branding": "Realme Techlife",
    "Marketing Name": "Realme TV FF",
    "Device": "eleonas",
    "Model": "Realme TV FF"
  },
  {
    "Retail Branding": "Realtek",
    "Marketing Name": "RealtekHank",
    "Device": "RealtekHank",
    "Model": "RealtekHank"
  },
  {
    "Retail Branding": "Realtek",
    "Marketing Name": "RealtekThor",
    "Device": "RealtekThor",
    "Model": "RealtekThor"
  },
  {
    "Retail Branding": "Realtime",
    "Marketing Name": "RS405",
    "Device": "RS405",
    "Model": "RS405"
  },
  {
    "Retail Branding": "Realtime",
    "Marketing Name": "RT503",
    "Device": "RT503",
    "Model": "RT503"
  },
  {
    "Retail Branding": "Realtime",
    "Marketing Name": "RT8",
    "Device": "RT8",
    "Model": "RT8"
  },
  {
    "Retail Branding": "Realtime",
    "Marketing Name": "Realtime_T503F_L1",
    "Device": "Realtime_T503F_L1",
    "Model": "Realtime_T503F_L1"
  },
  {
    "Retail Branding": "Realtime",
    "Marketing Name": "T503F",
    "Device": "T503F",
    "Model": "T503F"
  },
  {
    "Retail Branding": "Realtime",
    "Marketing Name": "T503F_L1",
    "Device": "T503F_L1",
    "Model": "T503F_L1"
  },
  {
    "Retail Branding": "Rebecco",
    "Marketing Name": "K30_EEA",
    "Device": "K30_EEA",
    "Model": "K30_EEA"
  },
  {
    "Retail Branding": "Rebecco",
    "Marketing Name": "K30_EEA_B",
    "Device": "K30_EEA_B",
    "Model": "K30_EEA"
  },
  {
    "Retail Branding": "Rebecco",
    "Marketing Name": "K30_EEA_B",
    "Device": "K30_EEA_B",
    "Model": "K30_EEA_B"
  },
  {
    "Retail Branding": "Rebecco",
    "Marketing Name": "K30_EEA_B",
    "Device": "K30_EEA_B",
    "Model": "L30_EEA"
  },
  {
    "Retail Branding": "Rebecco",
    "Marketing Name": "K30_ROW",
    "Device": "K30_ROW",
    "Model": "K30_ROW"
  },
  {
    "Retail Branding": "Rebecco",
    "Marketing Name": "K30_ROW_B",
    "Device": "K30_ROW_B",
    "Model": "K30_ROW"
  },
  {
    "Retail Branding": "Rebecco",
    "Marketing Name": "K30_ROW_B",
    "Device": "K30_ROW_B",
    "Model": "K30_ROW_B"
  },
  {
    "Retail Branding": "Rebecco",
    "Marketing Name": "K30_ROW_B",
    "Device": "K30_ROW_B",
    "Model": "L30_ROW"
  },
  {
    "Retail Branding": "Rebecco",
    "Marketing Name": "K50-R",
    "Device": "K50-R",
    "Model": "K50-R"
  },
  {
    "Retail Branding": "Rebecco",
    "Marketing Name": "K50_EEA",
    "Device": "K50_EEA",
    "Model": "K50_EEA"
  },
  {
    "Retail Branding": "Rebecco",
    "Marketing Name": "K50_EEA_B",
    "Device": "K50_EEA_B",
    "Model": "K30_EEA"
  },
  {
    "Retail Branding": "Rebecco",
    "Marketing Name": "K50_EEA_B",
    "Device": "K50_EEA_B",
    "Model": "K50_EEA"
  },
  {
    "Retail Branding": "Rebecco",
    "Marketing Name": "K50_EEA_B",
    "Device": "K50_EEA_B",
    "Model": "K50_EEA_B"
  },
  {
    "Retail Branding": "Rebecco",
    "Marketing Name": "K50_ROW",
    "Device": "K50_ROW",
    "Model": "K50_ROW"
  },
  {
    "Retail Branding": "Rebecco",
    "Marketing Name": "K50_ROW_A",
    "Device": "K50_ROW_A",
    "Model": "K50_ROW_A"
  },
  {
    "Retail Branding": "Rebecco",
    "Marketing Name": "K50_ROW_B",
    "Device": "K50_ROW_B",
    "Model": "K50_ROW"
  },
  {
    "Retail Branding": "Rebecco",
    "Marketing Name": "K50_ROW_B",
    "Device": "K50_ROW_B",
    "Model": "K50_ROW_B"
  },
  {
    "Retail Branding": "Rebecco",
    "Marketing Name": "K70_EEA",
    "Device": "K70_EEA",
    "Model": "K70_EEA"
  },
  {
    "Retail Branding": "Rebecco",
    "Marketing Name": "K70_EEA_B",
    "Device": "K70_EEA_B",
    "Model": "K70_EEA"
  },
  {
    "Retail Branding": "Rebecco",
    "Marketing Name": "K70_EEA_B",
    "Device": "K70_EEA_B",
    "Model": "K70_EEA_B"
  },
  {
    "Retail Branding": "Rebecco",
    "Marketing Name": "K70_EEA_B",
    "Device": "K70_EEA_B",
    "Model": "Z30_EEA"
  },
  {
    "Retail Branding": "Rebecco",
    "Marketing Name": "K70_ROW",
    "Device": "K70_ROW",
    "Model": "K70_ROW"
  },
  {
    "Retail Branding": "Rebecco",
    "Marketing Name": "K70_ROW_A",
    "Device": "K70_ROW_A",
    "Model": "K70_ROW_A"
  },
  {
    "Retail Branding": "Rebecco",
    "Marketing Name": "K70i_EEA",
    "Device": "K70i_EEA",
    "Model": "K70i_EEA"
  },
  {
    "Retail Branding": "Rebecco",
    "Marketing Name": "K70i_EEA_B",
    "Device": "K70i_EEA_B",
    "Model": "K70i_EEA_B"
  },
  {
    "Retail Branding": "Rebecco",
    "Marketing Name": "K80_EEA_B",
    "Device": "K80_EEA",
    "Model": "K80_EEA"
  },
  {
    "Retail Branding": "Rebecco",
    "Marketing Name": "K80_ROW",
    "Device": "K80_ROW",
    "Model": "K80_ROW"
  },
  {
    "Retail Branding": "Rebecco",
    "Marketing Name": "K80_ROW_B",
    "Device": "K80_ROW_B",
    "Model": "K80_ROW"
  },
  {
    "Retail Branding": "Rebecco",
    "Marketing Name": "L70",
    "Device": "L70",
    "Model": "L70"
  },
  {
    "Retail Branding": "Rebecco",
    "Marketing Name": "L70_EEA",
    "Device": "L70",
    "Model": "L70"
  },
  {
    "Retail Branding": "Rebecco",
    "Marketing Name": "M30Pro-a",
    "Device": "M30Pro",
    "Model": "M30Pro"
  },
  {
    "Retail Branding": "Rebecco",
    "Marketing Name": "M30_Pro",
    "Device": "M30_Pro",
    "Model": "M30"
  },
  {
    "Retail Branding": "Rebecco",
    "Marketing Name": "M70_EEA",
    "Device": "M70",
    "Model": "M70"
  },
  {
    "Retail Branding": "Rebecco",
    "Marketing Name": "M70_ROW",
    "Device": "M70",
    "Model": "M70"
  },
  {
    "Retail Branding": "Rebecco",
    "Marketing Name": "M70_US",
    "Device": "M70_US",
    "Model": "M70"
  },
  {
    "Retail Branding": "Rebecco",
    "Marketing Name": "X30",
    "Device": "X30",
    "Model": "A20Plus_ROW"
  },
  {
    "Retail Branding": "Rebecco",
    "Marketing Name": "X30",
    "Device": "X30",
    "Model": "X30"
  },
  {
    "Retail Branding": "Rebecco",
    "Marketing Name": "X30_EEA",
    "Device": "X30",
    "Model": "X30"
  },
  {
    "Retail Branding": "Rebecco",
    "Marketing Name": "Z50_EEA",
    "Device": "Z50",
    "Model": "Z50"
  },
  {
    "Retail Branding": "Rebecco",
    "Marketing Name": "Z70_EEA",
    "Device": "Z70",
    "Model": "Z70"
  },
  {
    "Retail Branding": "RebotAi",
    "Marketing Name": "A10_PRO",
    "Device": "A10_PRO",
    "Model": "A10_PRO"
  },
  {
    "Retail Branding": "RebotAi",
    "Marketing Name": "A10_PRO_EEA",
    "Device": "A10_PRO",
    "Model": "A10_PRO"
  },
  {
    "Retail Branding": "RebotAi",
    "Marketing Name": "A10_PRO_EEA",
    "Device": "A10_PRO",
    "Model": "A10_PRO_EEA"
  },
  {
    "Retail Branding": "RebotAi",
    "Marketing Name": "A11",
    "Device": "A11",
    "Model": "A11"
  },
  {
    "Retail Branding": "RebotAi",
    "Marketing Name": "A11_EEA",
    "Device": "A11_EEA",
    "Model": "A11_EEA"
  },
  {
    "Retail Branding": "RebotAi",
    "Marketing Name": "A9_EEA",
    "Device": "A9_EEA",
    "Model": "A9"
  },
  {
    "Retail Branding": "RebotAi",
    "Marketing Name": "AD11",
    "Device": "AD11",
    "Model": "AD11"
  },
  {
    "Retail Branding": "RebotAi",
    "Marketing Name": "AD11_EEA",
    "Device": "AD11_EEA",
    "Model": "AD11_EEA"
  },
  {
    "Retail Branding": "RebotAi",
    "Marketing Name": "AF12",
    "Device": "AF12",
    "Model": "AF12"
  },
  {
    "Retail Branding": "RebotAi",
    "Marketing Name": "AF12_EEA",
    "Device": "AF12",
    "Model": "AF12"
  },
  {
    "Retail Branding": "RebotAi",
    "Marketing Name": "AF13",
    "Device": "AF13",
    "Model": "AF13"
  },
  {
    "Retail Branding": "RebotAi",
    "Marketing Name": "AF13_EEA",
    "Device": "AF13_EEA",
    "Model": "AF13_EEA"
  },
  {
    "Retail Branding": "RebotAi",
    "Marketing Name": "B11_EEA",
    "Device": "B11",
    "Model": "B11"
  },
  {
    "Retail Branding": "RebotAi",
    "Marketing Name": "B11_EEA",
    "Device": "B11",
    "Model": "B11_EEA"
  },
  {
    "Retail Branding": "RebotAi",
    "Marketing Name": "D101",
    "Device": "D101",
    "Model": "D101"
  },
  {
    "Retail Branding": "RebotAi",
    "Marketing Name": "D101_EEA",
    "Device": "D101_EEA",
    "Model": "D101"
  },
  {
    "Retail Branding": "RebotAi",
    "Marketing Name": "D101_EEA",
    "Device": "D101_EEA",
    "Model": "D101_EEA"
  },
  {
    "Retail Branding": "Rectron",
    "Marketing Name": "MX101M2",
    "Device": "MX101M2",
    "Model": "MX101M2"
  },
  {
    "Retail Branding": "Rectron",
    "Marketing Name": "MX702M1",
    "Device": "MX702M1",
    "Model": "MX702M1"
  },
  {
    "Retail Branding": "Red Mobile",
    "Marketing Name": "Quick_5_0",
    "Device": "Quick_5_0",
    "Model": "Quick 5.0"
  },
  {
    "Retail Branding": "Red Mobile",
    "Marketing Name": "Volt L",
    "Device": "Volt_L",
    "Model": "Volt L"
  },
  {
    "Retail Branding": "Red-X",
    "Marketing Name": "RX3503",
    "Device": "RX3503",
    "Model": "RX3503"
  },
  {
    "Retail Branding": "Red-X",
    "Marketing Name": "RX4505",
    "Device": "RED-X_RX4505",
    "Model": "RX4505"
  },
  {
    "Retail Branding": "Red-X",
    "Marketing Name": "RX4559",
    "Device": "RED-X_RX4559",
    "Model": "RX4559"
  },
  {
    "Retail Branding": "Red-X",
    "Marketing Name": "RX4618",
    "Device": "RX4618",
    "Model": "RX4618"
  },
  {
    "Retail Branding": "Red-X",
    "Marketing Name": "RX4702",
    "Device": "RX4702",
    "Model": "RX4702"
  },
  {
    "Retail Branding": "Red-X",
    "Marketing Name": "RX4802",
    "Device": "RX4802",
    "Model": "RX4802"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "K30 PRO",
    "Device": "lmi",
    "Model": "Lmi"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "K30 PRO",
    "Device": "lmi",
    "Model": "Redmi K30 Pro"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Mi  9T  Pro",
    "Device": "raphaelin",
    "Model": "Redmi K20 Pro"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Mi 9T",
    "Device": "davinci",
    "Model": "Mi 9T"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "MiTV",
    "Device": "rango",
    "Model": "MiTV-AXFR0"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "POCO F5",
    "Device": "marblein",
    "Model": "23049PCD8I"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "REDMI 15C 5G",
    "Device": "tornado",
    "Model": "2508CRN2BI"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "REDMI A7 Pro",
    "Device": "arctic",
    "Model": "25128RN17A"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "REDMI A7 Pro",
    "Device": "arctic",
    "Model": "25128RN17L"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "REDMI A7 Pro",
    "Device": "arctic",
    "Model": "25128RN17Y"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "REDMI K Pad",
    "Device": "turner",
    "Model": "25079RPDCC"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "REDMI K80",
    "Device": "zorn",
    "Model": "24117RK2CC"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "REDMI K80 Pro",
    "Device": "miro",
    "Model": "24122RKC7C"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "REDMI K80 Ultra",
    "Device": "dali",
    "Model": "25060RK16C"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "REDMI K90",
    "Device": "annibale",
    "Model": "2510DRK44C"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "REDMI K90 Pro Max",
    "Device": "myron",
    "Model": "25102RK69C"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "REDMI K90 Pro Max",
    "Device": "myron",
    "Model": "25102RKBEC"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "REDMI Note 15",
    "Device": "kunzite",
    "Model": "25098RA98C"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "REDMI Note 15",
    "Device": "spinel",
    "Model": "2510DRA23E"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "REDMI Note 15",
    "Device": "spinel",
    "Model": "2510DRA23G"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "REDMI Note 15",
    "Device": "spinel",
    "Model": "2510DRA23L"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "REDMI Note 15 5G",
    "Device": "kunzite",
    "Model": "25098RA98G"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "REDMI Note 15 5G",
    "Device": "kunzite",
    "Model": "25098RA98I"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "REDMI Note 15 5G",
    "Device": "kunzite",
    "Model": "25098RA98T"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "REDMI Note 15 Pro",
    "Device": "charoite",
    "Model": "25100RA69G"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "REDMI Note 15 Pro",
    "Device": "lapis",
    "Model": "25080RABDC"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "REDMI Note 15 Pro 5G",
    "Device": "lapis",
    "Model": "25080RABDG"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "REDMI Note 15 Pro 5G",
    "Device": "lapis",
    "Model": "25080RABDI"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "REDMI Note 15 Pro 5G",
    "Device": "lapis",
    "Model": "25080RABDR"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "REDMI Note 15 Pro+",
    "Device": "flourite",
    "Model": "25104RADAC"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "REDMI Note 15 Pro+",
    "Device": "flourite",
    "Model": "2510ERA8BC"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "REDMI Note 15 Pro+5G",
    "Device": "flourite",
    "Model": "2510ERA8BG"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "REDMI Note 15 Pro+5G",
    "Device": "flourite",
    "Model": "2510ERA8BI"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "REDMI Note 15R",
    "Device": "spring",
    "Model": "25057RA09C"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "REDMI Pad 2",
    "Device": "taiko",
    "Model": "25040RP0AC"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "REDMI Pad 2 Pro",
    "Device": "flute",
    "Model": "25099RP13C"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "REDMI Turbo 4",
    "Device": "rodin",
    "Model": "24129RT7CC"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "REDMI Turbo 4 Pro",
    "Device": "onyx",
    "Model": "25053RT47C"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "REDMI Turbo 5 Max",
    "Device": "dash",
    "Model": "2602BRT18C"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi  7A",
    "Device": "pine",
    "Model": "Redmi 7A"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi  7A",
    "Device": "pine",
    "Model": "pine"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi  Note  7",
    "Device": "lavender",
    "Model": "Redmi Note 7"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi 10",
    "Device": "eos",
    "Model": "21061119DG"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi 10",
    "Device": "eos",
    "Model": "22011119UY"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi 10",
    "Device": "fog",
    "Model": "220333QBI"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi 10 2022",
    "Device": "eos",
    "Model": "21061119DG"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi 10 2022",
    "Device": "eos",
    "Model": "22011119UY"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi 10 2022",
    "Device": "selene",
    "Model": "21061119AG"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi 10 2022",
    "Device": "selene",
    "Model": "21061119AL"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi 10 2022",
    "Device": "selene",
    "Model": "21121119SG"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi 10 2022",
    "Device": "selene",
    "Model": "21121119VL"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi 10 5G",
    "Device": "light",
    "Model": "22041219G"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi 10 5G",
    "Device": "thunder",
    "Model": "22041219NY"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi 10 Power",
    "Device": "fog",
    "Model": "220333QBI"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi 10A",
    "Device": "dandelion",
    "Model": "220233L2C"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi 10A",
    "Device": "dandelion",
    "Model": "220233L2G"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi 10A Sport",
    "Device": "dandelion",
    "Model": "220233L2I"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi 10C",
    "Device": "fog",
    "Model": "220333QAG"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi 10C",
    "Device": "rain",
    "Model": "220333QNY"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi 10C",
    "Device": "wind",
    "Model": "220333QL"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi 10X",
    "Device": "apricot",
    "Model": "M2004J7AC"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi 10X",
    "Device": "atom",
    "Model": "M2004J7AC"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi 10X",
    "Device": "atom",
    "Model": "atom"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi 10X 4G",
    "Device": "merlin",
    "Model": "M2003J15SC"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi 10X Pro",
    "Device": "banana",
    "Model": "M2004J7BC"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi 10X pro",
    "Device": "bomb",
    "Model": "M2004J7BC"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi 10X pro",
    "Device": "bomb",
    "Model": "bomb"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi 11 Prime",
    "Device": "rock",
    "Model": "22071219AI"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi 11 Prime 5G",
    "Device": "light",
    "Model": "22041219I"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi 12",
    "Device": "fire",
    "Model": "23053RN02A"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi 12",
    "Device": "fire",
    "Model": "23053RN02I"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi 12",
    "Device": "fire",
    "Model": "23053RN02L"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi 12",
    "Device": "heat",
    "Model": "23053RN02Y"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi 12 5G",
    "Device": "XIG03",
    "Model": "XIG03"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi 12 5G",
    "Device": "river",
    "Model": "23076RA4BR"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi 12 5G",
    "Device": "river",
    "Model": "23076RN8DY"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi 12 5G",
    "Device": "river",
    "Model": "A401XM"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi 12C",
    "Device": "aether",
    "Model": "22126RN91Y"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi 12C",
    "Device": "earth",
    "Model": "22120RN86G"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi 12C",
    "Device": "earth",
    "Model": "22120RN86I"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi 12C",
    "Device": "earth",
    "Model": "2212ARNC4L"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi 13",
    "Device": "moon",
    "Model": "24040RN64Y"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi 13",
    "Device": "tides",
    "Model": "24049RN28L"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi 13",
    "Device": "tides",
    "Model": "2404ARN45A"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi 13 5G",
    "Device": "breeze",
    "Model": "2406ERN9CI"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi 13C",
    "Device": "gale",
    "Model": "23100RN82L"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi 13C",
    "Device": "gale",
    "Model": "23106RN0DA"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi 13C",
    "Device": "gale",
    "Model": "2311DRN14I"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi 13C",
    "Device": "gust",
    "Model": "23108RN04Y"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi 13C 5G",
    "Device": "air",
    "Model": "23124RN87I"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi 13C 5G",
    "Device": "atmos",
    "Model": "23124RN87G"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi 13x",
    "Device": "moon",
    "Model": "24040RN64Y"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi 13x",
    "Device": "tides",
    "Model": "24049RN28L"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi 13x",
    "Device": "tides",
    "Model": "2404ARN45A"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi 14C",
    "Device": "lake",
    "Model": "2409BRN2CY"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi 14C",
    "Device": "pond",
    "Model": "2409BRN2CA"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi 14C",
    "Device": "pond",
    "Model": "2409BRN2CL"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi 14C 5G",
    "Device": "flame",
    "Model": "2411DRN47I"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi 15",
    "Device": "creek",
    "Model": "25062RN2DE"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi 15",
    "Device": "creek",
    "Model": "25062RN2DL"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi 15",
    "Device": "creek",
    "Model": "25062RN2DY"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi 15 5G",
    "Device": "spring",
    "Model": "25057RN09E"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi 15 5G",
    "Device": "spring",
    "Model": "25057RN09G"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi 15 5G",
    "Device": "spring",
    "Model": "25057RN09I"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi 15 5G",
    "Device": "spring",
    "Model": "25057RN09R"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi 15 5G",
    "Device": "spring",
    "Model": "A501XM"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi 15C",
    "Device": "dew",
    "Model": "25078RA3EA"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi 15C",
    "Device": "dew",
    "Model": "25078RA3EE"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi 15C",
    "Device": "dew",
    "Model": "25078RA3EL"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi 15C",
    "Device": "dew",
    "Model": "25078RA3EY"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi 15C 5G",
    "Device": "tornado",
    "Model": "2508CRN2BE"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi 6",
    "Device": "cereus",
    "Model": "Redmi 6"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi 7",
    "Device": "onc",
    "Model": "Redmi 7"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi 7",
    "Device": "onc",
    "Model": "Redmi Y3"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi 7A",
    "Device": "pine",
    "Model": "Redmi 7A"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi 8",
    "Device": "olive",
    "Model": "Redmi 8"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi 8A",
    "Device": "olivelite",
    "Model": "Redmi 8A"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi 8A Dual",
    "Device": "olivewood",
    "Model": "Redmi 8A Dual"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi 8A Dual",
    "Device": "olivewood",
    "Model": "Redmi 8A Pro"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi 9",
    "Device": "cattail",
    "Model": "M2006C3MII"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi 9",
    "Device": "cattail",
    "Model": "cattail"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi 9",
    "Device": "galahad",
    "Model": "M2004J19C"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi 9",
    "Device": "galahad",
    "Model": "galahad"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi 9",
    "Device": "lancelot",
    "Model": "M2004J19C"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi 9",
    "Device": "lancelot",
    "Model": "M2004J19G"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi 9 Power",
    "Device": "lime",
    "Model": "M2010J19SI"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi 9 Prime",
    "Device": "lancelot",
    "Model": "M2004J19C"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi 9 Prime",
    "Device": "lancelot",
    "Model": "M2004J19I"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi 9A",
    "Device": "dandelion",
    "Model": "220233L2G"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi 9A",
    "Device": "dandelion",
    "Model": "M2006C3LC"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi 9A",
    "Device": "dandelion",
    "Model": "M2006C3LG"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi 9A",
    "Device": "dandelion",
    "Model": "M2006C3LI"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi 9A",
    "Device": "dandelion",
    "Model": "M2006C3LVG"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi 9A",
    "Device": "dandelion",
    "Model": "dandelion"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi 9C",
    "Device": "angelica",
    "Model": "M2006C3MG"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi 9C",
    "Device": "angelica",
    "Model": "angelica"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi 9C NFC",
    "Device": "angelican",
    "Model": "M2006C3MNG"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi 9C NFC",
    "Device": "angelican",
    "Model": "angelican"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi 9T",
    "Device": "lemon",
    "Model": "M2010J19SY"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi 9T",
    "Device": "lime",
    "Model": "M2010J19SG"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi 9T",
    "Device": "pomelo",
    "Model": "M2010J19SL"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi A1",
    "Device": "ice",
    "Model": "220733SG"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi A1",
    "Device": "ice",
    "Model": "220733SI"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi A1",
    "Device": "ice",
    "Model": "220733SL"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi A1+",
    "Device": "snow",
    "Model": "220733SFG"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi A1+",
    "Device": "snow",
    "Model": "220743FI"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi A2",
    "Device": "cloud",
    "Model": "23026RN54G"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi A2",
    "Device": "cloud",
    "Model": "23028RN4DG"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi A2+",
    "Device": "water",
    "Model": "23028RNCAG"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi A3",
    "Device": "blue",
    "Model": "23129RN51H"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi A3",
    "Device": "blue",
    "Model": "23129RN51X"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi A3",
    "Device": "blue",
    "Model": "2312CRNCCL"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi A3 Pro",
    "Device": "pond",
    "Model": "2409BRN2CG"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi A3x",
    "Device": "klein",
    "Model": "24044RN32L"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi A3x",
    "Device": "klein",
    "Model": "24048RN6CG"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi A3x",
    "Device": "klein",
    "Model": "24048RN6CI"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi A4 5G",
    "Device": "warm",
    "Model": "24116RNC1I"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi A5",
    "Device": "serenity",
    "Model": "25028RN03A"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi A5",
    "Device": "serenity",
    "Model": "25028RN03I"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi A5",
    "Device": "serenity",
    "Model": "25028RN03L"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi A5",
    "Device": "serenity",
    "Model": "25028RN03Y"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi K20",
    "Device": "davinci",
    "Model": "Mi 9T"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi K20",
    "Device": "davinci",
    "Model": "Redmi K20"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi K20",
    "Device": "davinciin",
    "Model": "Redmi K20"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi K20 Pro",
    "Device": "raphael",
    "Model": "Mi 9T Pro"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi K20 Pro",
    "Device": "raphael",
    "Model": "Redmi K20 Pro"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi K20 Pro",
    "Device": "raphael",
    "Model": "Redmi K20 Pro Premium Edition"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi K30",
    "Device": "phoenix",
    "Model": "Redmi K30"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi K30 5G",
    "Device": "picasso",
    "Model": "Redmi K30 5G"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi K30 Ultra",
    "Device": "cezanne",
    "Model": "M2006J10C"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi K30S Ultra",
    "Device": "apollo",
    "Model": "M2007J3SC"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi K30i 5G",
    "Device": "picasso",
    "Model": "Redmi K30i 5G"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi K40",
    "Device": "alioth",
    "Model": "M2012K11AC"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi K40 Gaming",
    "Device": "ares",
    "Model": "M2012K10C"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi K40 Pro",
    "Device": "haydn",
    "Model": "M2012K11C"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi K40 Pro +",
    "Device": "haydn",
    "Model": "M2012K11C"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi K40S",
    "Device": "munch",
    "Model": "22021211RC"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi K50",
    "Device": "rubens",
    "Model": "22041211AC"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi K50 Pro",
    "Device": "matisse",
    "Model": "22011211C"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi K50G",
    "Device": "ingres",
    "Model": "21121210C"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi K50i",
    "Device": "xagain",
    "Model": "22041216I"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi K60",
    "Device": "mondrian",
    "Model": "23013RK75C"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi K60 Pro",
    "Device": "socrates",
    "Model": "22127RK46C"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi K60 Ultra",
    "Device": "corot",
    "Model": "23078RKD5C"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi K60E",
    "Device": "rembrandt",
    "Model": "22122RK93C"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi K70",
    "Device": "vermeer",
    "Model": "23113RKC6C"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi K70 Pro",
    "Device": "manet",
    "Model": "23117RK66C"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi K70 Ultra",
    "Device": "rothko",
    "Model": "2407FRK8EC"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi K70E",
    "Device": "duchamp",
    "Model": "2311DRK48C"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi Note 10",
    "Device": "camellia",
    "Model": "M2103K19C"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi Note 10",
    "Device": "sunny",
    "Model": "M2101K7AG"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi Note 10",
    "Device": "sunny",
    "Model": "M2101K7AI"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi Note 10 5G",
    "Device": "camellian",
    "Model": "M2103K19G"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi Note 10 JE",
    "Device": "XIG02",
    "Model": "XIG02"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi Note 10 Pro",
    "Device": "chopin",
    "Model": "21061110AG"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi Note 10 Pro",
    "Device": "sweet",
    "Model": "M2101K6G"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi Note 10 Pro",
    "Device": "sweetin",
    "Model": "M2101K6P"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi Note 10 Pro Max",
    "Device": "sweetin",
    "Model": "M2101K6I"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi Note 10 pro",
    "Device": "chopin",
    "Model": "M2104K10AC"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi Note 10S",
    "Device": "maltose",
    "Model": "M2101K7BL"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi Note 10S",
    "Device": "rosemary",
    "Model": "M2101K7BL"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi Note 10S",
    "Device": "rosemary",
    "Model": "M2101K7BNY"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi Note 10S",
    "Device": "secret",
    "Model": "M2101K7BG"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi Note 10S",
    "Device": "secret",
    "Model": "M2101K7BI"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi Note 10T",
    "Device": "camellian",
    "Model": "M2103K19Y"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi Note 10T 5G",
    "Device": "camellia",
    "Model": "M2103K19I"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi Note 10T 5G",
    "Device": "camellia",
    "Model": "TBD"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi Note 11",
    "Device": "spes",
    "Model": "2201117TG"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi Note 11",
    "Device": "spes",
    "Model": "2201117TI"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi Note 11",
    "Device": "spes",
    "Model": "2201117TL"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi Note 11",
    "Device": "spesn",
    "Model": "2201117TY"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi Note 11 4G",
    "Device": "selene",
    "Model": "21121119SC"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi Note 11 5G",
    "Device": "evergo",
    "Model": "21091116AC"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi Note 11 Pro",
    "Device": "pissarro",
    "Model": "21091116C"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi Note 11 Pro",
    "Device": "vida",
    "Model": "2201116TI"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi Note 11 Pro",
    "Device": "viva",
    "Model": "2201116TG"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi Note 11 Pro 5G",
    "Device": "veux",
    "Model": "2201116SG"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi Note 11 Pro 5G",
    "Device": "veux",
    "Model": "2201116SR"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi Note 11 Pro+",
    "Device": "pissarropro",
    "Model": "21091116UC"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi Note 11 Pro+ 5G",
    "Device": "peux",
    "Model": "2201116SI"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi Note 11 Pro+ 5G",
    "Device": "pissarropro",
    "Model": "21091116UG"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi Note 11 SE",
    "Device": "secret",
    "Model": "22087RA4DI"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi Note 11 SE",
    "Device": "secret",
    "Model": "M2101K7BI"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi Note 11E",
    "Device": "light",
    "Model": "22041219C"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi Note 11E Pro",
    "Device": "veux",
    "Model": "2201116SC"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi Note 11S",
    "Device": "fleur",
    "Model": "2201117SY"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi Note 11S",
    "Device": "miel",
    "Model": "2201117SG"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi Note 11S",
    "Device": "miel",
    "Model": "2201117SI"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi Note 11S",
    "Device": "miel",
    "Model": "2201117SL"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi Note 11S 5G",
    "Device": "opal",
    "Model": "22031116BG"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi Note 11T 5G",
    "Device": "evergo",
    "Model": "21091116AI"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi Note 11T Pro",
    "Device": "xaga",
    "Model": "22041216C"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi Note 11T Pro +",
    "Device": "xagapro",
    "Model": "22041216UC"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi Note 12",
    "Device": "tapas",
    "Model": "23021RAAEG"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi Note 12",
    "Device": "tapas",
    "Model": "23027RAD4I"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi Note 12",
    "Device": "tapas",
    "Model": "23028RA60L"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi Note 12",
    "Device": "topaz",
    "Model": "23021RAA2Y"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi Note 12 5G",
    "Device": "sunstone",
    "Model": "22101317C"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi Note 12 DISCOVERY EDITION",
    "Device": "rubyplus",
    "Model": "22101316UC"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi Note 12 Pro",
    "Device": "ruby",
    "Model": "22101316C"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi Note 12 Pro",
    "Device": "sweet",
    "Model": "2209116AG"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi Note 12 Pro + 5G",
    "Device": "rubypro",
    "Model": "22101316UP"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi Note 12 Pro 5G",
    "Device": "ruby",
    "Model": "22101316G"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi Note 12 Pro 5G",
    "Device": "ruby",
    "Model": "22101316I"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi Note 12 Pro Speed",
    "Device": "redwood",
    "Model": "22101320C"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi Note 12 Pro+",
    "Device": "rubypro",
    "Model": "22101316UCP"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi Note 12 Pro+ 5G",
    "Device": "rubypro",
    "Model": "22101316UG"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi Note 12 Turbo",
    "Device": "marble",
    "Model": "23049RAD8C"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi Note 12S",
    "Device": "ocean",
    "Model": "2303CRA44A"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi Note 12S",
    "Device": "ocean",
    "Model": "2303ERA42L"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi Note 12S",
    "Device": "sea",
    "Model": "23030RAC7Y"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi Note 12T Pro",
    "Device": "pearl",
    "Model": "23054RA19C"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi Note 13",
    "Device": "sapphire",
    "Model": "23129RA5FL"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi Note 13",
    "Device": "sapphire",
    "Model": "23129RAA4G"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi Note 13",
    "Device": "sapphiren",
    "Model": "23124RA7EO"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi Note 13 5G",
    "Device": "gold",
    "Model": "2312DRAABC"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi Note 13 5G",
    "Device": "gold",
    "Model": "2312DRAABI"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi Note 13 5G",
    "Device": "iron",
    "Model": "2312DRAABG"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi Note 13 Pro",
    "Device": "emerald",
    "Model": "23117RA68G"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi Note 13 Pro 5G",
    "Device": "XIG05",
    "Model": "XIG05"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi Note 13 Pro 5G",
    "Device": "garnet",
    "Model": "2312CRAD3C"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi Note 13 Pro 5G",
    "Device": "garnet",
    "Model": "2312DRA50C"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi Note 13 Pro 5G",
    "Device": "garnet",
    "Model": "2312DRA50G"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi Note 13 Pro 5G",
    "Device": "garnet",
    "Model": "2312DRA50I"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi Note 13 Pro+",
    "Device": "zircon",
    "Model": "23090RA98C"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi Note 13 Pro+ 5G",
    "Device": "zircon",
    "Model": "23090RA98G"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi Note 13 Pro+ 5G",
    "Device": "zircon",
    "Model": "23090RA98I"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi Note 13 Pro+ 5G",
    "Device": "zircon",
    "Model": "24040RA98R"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi Note 13R",
    "Device": "breeze",
    "Model": "2406ERN9CC"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi Note 13R Pro",
    "Device": "gold",
    "Model": "2311FRAFDC"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi Note 14",
    "Device": "tanzanite",
    "Model": "24117RN76E"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi Note 14",
    "Device": "tanzanite",
    "Model": "24117RN76G"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi Note 14",
    "Device": "tanzanite",
    "Model": "24117RN76L"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi Note 14",
    "Device": "tanzanite",
    "Model": "24117RN76O"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi Note 14 5G",
    "Device": "beryl",
    "Model": "24094RAD4C"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi Note 14 5G",
    "Device": "beryl",
    "Model": "24094RAD4I"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi Note 14 5G",
    "Device": "citrine",
    "Model": "24094RAD4G"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi Note 14 Pro",
    "Device": "malachite",
    "Model": "24090RA29C"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi Note 14 Pro",
    "Device": "obsidian",
    "Model": "24116RACCG"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi Note 14 Pro 5G",
    "Device": "malachite",
    "Model": "24090RA29G"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi Note 14 Pro 5G",
    "Device": "malachite",
    "Model": "24090RA29I"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi Note 14 Pro+",
    "Device": "amethyst",
    "Model": "24115RA8EC"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi Note 14 Pro+ 5G",
    "Device": "amethyst",
    "Model": "24115RA8EG"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi Note 14 Pro+ 5G",
    "Device": "amethyst",
    "Model": "24115RA8EI"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi Note 14S",
    "Device": "emerald",
    "Model": "2502FRA65G"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi Note 7",
    "Device": "lavender",
    "Model": "Redmi Note 7"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi Note 8",
    "Device": "biloba",
    "Model": "M1908C3JGG"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi Note 8",
    "Device": "ginkgo",
    "Model": "GINKGO"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi Note 8",
    "Device": "ginkgo",
    "Model": "Redmi Note 8"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi Note 8 Pro",
    "Device": "begonia",
    "Model": "Redmi Note 8 Pro"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi Note 8 Pro",
    "Device": "begonia",
    "Model": "begonia"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi Note 8 pro",
    "Device": "begoniain",
    "Model": "Redmi Note 8 Pro"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi Note 8T",
    "Device": "willow",
    "Model": "Redmi Note 8T"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi Note 8T",
    "Device": "willow",
    "Model": "willow"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi Note 9",
    "Device": "cannon",
    "Model": "M2007J22C"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi Note 9",
    "Device": "merlin",
    "Model": "M2003J15SC"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi Note 9",
    "Device": "merlin",
    "Model": "M2003J15SI"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi Note 9",
    "Device": "merlin",
    "Model": "M2003J15SS"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi Note 9",
    "Device": "merlinnfc",
    "Model": "M2003J15SC"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi Note 9",
    "Device": "merlinnfc",
    "Model": "M2003J15SG"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi Note 9 4G",
    "Device": "lime",
    "Model": "M2010J19SC"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi Note 9 Pro",
    "Device": "curtana",
    "Model": "Redmi Note 9 Pro"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi Note 9 Pro",
    "Device": "curtana",
    "Model": "curtana"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi Note 9 Pro",
    "Device": "joyeuse",
    "Model": "Redmi Note 9 Pro"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi Note 9 Pro Max",
    "Device": "excalibur",
    "Model": "Redmi Note 9 Pro Max"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi Note 9 pro",
    "Device": "gauguinpro",
    "Model": "M2007J17C"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi Note 9S",
    "Device": "curtana",
    "Model": "Redmi Note 9 Pro"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi Note 9S",
    "Device": "curtana",
    "Model": "Redmi Note 9S"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi Note 9T",
    "Device": "cannong",
    "Model": "A001XM"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi Note 9T",
    "Device": "cannong",
    "Model": "M2007J22G"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi Pad",
    "Device": "yunluo",
    "Model": "22081283G"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi Pad 2",
    "Device": "taiko",
    "Model": "25040RP0AE"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi Pad 2",
    "Device": "taiko",
    "Model": "25040RP0AG"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi Pad 2",
    "Device": "taiko",
    "Model": "25040RP0AI"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi Pad 2",
    "Device": "taiko",
    "Model": "25040RP0AL"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi Pad 2 4G",
    "Device": "koto",
    "Model": "2505DRP06E"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi Pad 2 4G",
    "Device": "koto",
    "Model": "2505DRP06G"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi Pad 2 Pro",
    "Device": "flute",
    "Model": "25099RP13G"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi Pad 2 Pro",
    "Device": "flute",
    "Model": "25099RP13I"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi Pad 2 Pro 5G",
    "Device": "organ",
    "Model": "2509BRP2DG"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi Pad 2 Pro 5G",
    "Device": "organ",
    "Model": "2509BRP2DI"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi Pad 2 Wi-Fi + Cellular",
    "Device": "koto",
    "Model": "2505DRP06I"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi Pad Pro",
    "Device": "dizi",
    "Model": "2405CRPFDC"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi Pad Pro",
    "Device": "dizi",
    "Model": "2405CRPFDG"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi Pad Pro",
    "Device": "dizi",
    "Model": "2405CRPFDI"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi Pad Pro 5G",
    "Device": "ruan",
    "Model": "24074RPD2C"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi Pad Pro 5G",
    "Device": "ruan",
    "Model": "24074RPD2G"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi Pad SE",
    "Device": "xun",
    "Model": "23073RPBFC"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi Pad SE",
    "Device": "xun",
    "Model": "23073RPBFG"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi Pad SE",
    "Device": "xun",
    "Model": "23073RPBFL"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi Pad SE 4G",
    "Device": "spark",
    "Model": "24076RP19I"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi Pad SE 8.7",
    "Device": "flare",
    "Model": "24075RP89G"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi Pad SE 8.7 4G",
    "Device": "spark",
    "Model": "24076RP19G"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Redmi Turbo 3",
    "Device": "peridot",
    "Model": "24069RA21C"
  },
  {
    "Retail Branding": "Redmi",
    "Marketing Name": "Smart TV",
    "Device": "tarzan",
    "Model": "MiTV-MOOQ3"
  },
  {
    "Retail Branding": "Redway",
    "Marketing Name": "redway10",
    "Device": "redway10",
    "Model": "redway10"
  },
  {
    "Retail Branding": "Redway",
    "Marketing Name": "redway10_lite",
    "Device": "redway10_lite",
    "Model": "redway10_lite"
  },
  {
    "Retail Branding": "Redway",
    "Marketing Name": "redway7_pro",
    "Device": "redway7_pro",
    "Model": "redway7_pro"
  },
  {
    "Retail Branding": "Redway",
    "Marketing Name": "redway_7",
    "Device": "redway_7",
    "Model": "redway_7"
  },
  {
    "Retail Branding": "Reeder",
    "Marketing Name": "A8i Q2",
    "Device": "A8i-Q2",
    "Model": "A8i-Q2"
  },
  {
    "Retail Branding": "Reeder",
    "Marketing Name": "M10S",
    "Device": "M10S",
    "Model": "M10S"
  },
  {
    "Retail Branding": "Reeder",
    "Marketing Name": "M10SPlus",
    "Device": "M10SPlus",
    "Model": "M10SPlus"
  },
  {
    "Retail Branding": "Reeder",
    "Marketing Name": "M10_Blue_Max",
    "Device": "M10_Blue_Max",
    "Model": "M10_Blue_Max"
  },
  {
    "Retail Branding": "Reeder",
    "Marketing Name": "M10_Pro_LTE",
    "Device": "M10_Pro_LTE",
    "Model": "M10 Pro LTE"
  },
  {
    "Retail Branding": "Reeder",
    "Marketing Name": "M11_Pro_Max",
    "Device": "M11_Pro_Max",
    "Model": "M11_Pro_Max"
  },
  {
    "Retail Branding": "Reeder",
    "Marketing Name": "M7 Plus",
    "Device": "reeder_M7Plus",
    "Model": "M7Plus"
  },
  {
    "Retail Branding": "Reeder",
    "Marketing Name": "M7Go_2019",
    "Device": "M7Go_2019",
    "Model": "M7Go_2019"
  },
  {
    "Retail Branding": "Reeder",
    "Marketing Name": "M7S",
    "Device": "M7S",
    "Model": "M7S"
  },
  {
    "Retail Branding": "Reeder",
    "Marketing Name": "M8 Go",
    "Device": "M8_Go",
    "Model": "M8_Go"
  },
  {
    "Retail Branding": "Reeder",
    "Marketing Name": "M8Go2020",
    "Device": "M8Go2020",
    "Model": "M8Go2020"
  },
  {
    "Retail Branding": "Reeder",
    "Marketing Name": "M8S",
    "Device": "reeder_M8S",
    "Model": "reeder_M8S"
  },
  {
    "Retail Branding": "Reeder",
    "Marketing Name": "M8_Go",
    "Device": "M8_Go",
    "Model": "M8_Go"
  },
  {
    "Retail Branding": "Reeder",
    "Marketing Name": "P10",
    "Device": "P10",
    "Model": "P10"
  },
  {
    "Retail Branding": "Reeder",
    "Marketing Name": "P10S",
    "Device": "P10S",
    "Model": "P10S"
  },
  {
    "Retail Branding": "Reeder",
    "Marketing Name": "P10SE",
    "Device": "P10SE",
    "Model": "P10SE"
  },
  {
    "Retail Branding": "Reeder",
    "Marketing Name": "P12 Curve",
    "Device": "P12Curve",
    "Model": "P12Curve"
  },
  {
    "Retail Branding": "Reeder",
    "Marketing Name": "P13",
    "Device": "P13",
    "Model": "P13"
  },
  {
    "Retail Branding": "Reeder",
    "Marketing Name": "P13  Blue Max Pro Lite 2022",
    "Device": "P13_Blue_Pro_2022",
    "Model": "P13 Blue Max Pro Lite 2022"
  },
  {
    "Retail Branding": "Reeder",
    "Marketing Name": "P13 Blue",
    "Device": "P13_Blue",
    "Model": "P13_Blue"
  },
  {
    "Retail Branding": "Reeder",
    "Marketing Name": "P13 Blue  Max Lite 32GB",
    "Device": "P13_BML_32",
    "Model": "P13 Blue Max Lite 32GB"
  },
  {
    "Retail Branding": "Reeder",
    "Marketing Name": "P13 Blue 2022",
    "Device": "P13_Blue_2022",
    "Model": "P13 Blue 2022"
  },
  {
    "Retail Branding": "Reeder",
    "Marketing Name": "P13 Blue Maks",
    "Device": "P13_Blue_Maks",
    "Model": "P13_Blue_Maks"
  },
  {
    "Retail Branding": "Reeder",
    "Marketing Name": "P13 Blue Max",
    "Device": "P13_Blue_Max",
    "Model": "P13_Blue_Max"
  },
  {
    "Retail Branding": "Reeder",
    "Marketing Name": "P13 Blue Max 128 GB",
    "Device": "P13_Blue_Max_128_GB",
    "Model": "P13 Blue Max 128 GB"
  },
  {
    "Retail Branding": "Reeder",
    "Marketing Name": "P13 Blue Max 128 GB 2022",
    "Device": "Blue_Max_128GB_2022k1",
    "Model": "P13 Blue Max 128 GB 2022"
  },
  {
    "Retail Branding": "Reeder",
    "Marketing Name": "P13 Blue Max Lite",
    "Device": "P13_BML",
    "Model": "P13 Blue Max Lite"
  },
  {
    "Retail Branding": "Reeder",
    "Marketing Name": "P13 Blue Max Lite 2022",
    "Device": "P13_Blue_2022kk1",
    "Model": "P13 Blue Max Lite 2022"
  },
  {
    "Retail Branding": "Reeder",
    "Marketing Name": "P13 Blue Max Pro",
    "Device": "P13_Blue_Max_Pro",
    "Model": "P13 Blue Max Pro"
  },
  {
    "Retail Branding": "Reeder",
    "Marketing Name": "P13 Blue Max Pro 2021",
    "Device": "P13_Blue_Max_Pro_2021",
    "Model": "P13 Blue Max Pro 2021"
  },
  {
    "Retail Branding": "Reeder",
    "Marketing Name": "P13 Blue Max Pro 256 GB",
    "Device": "P13_Blue_Max_Pro_256_GB",
    "Model": "P13 Blue Max Pro 256 GB"
  },
  {
    "Retail Branding": "Reeder",
    "Marketing Name": "P13 Blue MaxL 2022",
    "Device": "P13_Blue_MaxL_2022",
    "Model": "P13 Blue MaxL 2022"
  },
  {
    "Retail Branding": "Reeder",
    "Marketing Name": "P13 Blue MaxL 2022s",
    "Device": "P13_Blue_MaxL_2022",
    "Model": "P13 Blue MaxL 2022"
  },
  {
    "Retail Branding": "Reeder",
    "Marketing Name": "P13 Blue Plus",
    "Device": "P13_Blue_Plus",
    "Model": "P13_Blue_Plus"
  },
  {
    "Retail Branding": "Reeder",
    "Marketing Name": "P13 Blue Pro Lite",
    "Device": "P13_Blue_Max_PL",
    "Model": "P13 Blue Max PL"
  },
  {
    "Retail Branding": "Reeder",
    "Marketing Name": "P13 Max Blue",
    "Device": "P13_Max_Blue",
    "Model": "P13_Max_Blue"
  },
  {
    "Retail Branding": "Reeder",
    "Marketing Name": "P13_Black",
    "Device": "P13_Black",
    "Model": "P13_Black"
  },
  {
    "Retail Branding": "Reeder",
    "Marketing Name": "P13_Blue_2021",
    "Device": "P13_Blue_2021",
    "Model": "P13 Blue 2021"
  },
  {
    "Retail Branding": "Reeder",
    "Marketing Name": "P13_Blue_2022",
    "Device": "P13_Blue_2022kk1",
    "Model": "P13 Blue Max Lite 2022"
  },
  {
    "Retail Branding": "Reeder",
    "Marketing Name": "P13_Blue_MaxL_2021",
    "Device": "P13_Blue_MaxL_2021",
    "Model": "P13 Blue MaxL 2021"
  },
  {
    "Retail Branding": "Reeder",
    "Marketing Name": "P13_Blue_Plus_2022",
    "Device": "P13_Blue_Plus_2022",
    "Model": "P13_Blue_Plus_2022"
  },
  {
    "Retail Branding": "Reeder",
    "Marketing Name": "P13_Blue_Pro_2022",
    "Device": "P13_Blue_Pro_2022",
    "Model": "P13 Blue Max Pro Lite 2022"
  },
  {
    "Retail Branding": "Reeder",
    "Marketing Name": "P13_Lite",
    "Device": "P13_Lite",
    "Model": "P13_Lite"
  },
  {
    "Retail Branding": "Reeder",
    "Marketing Name": "P9C",
    "Device": "P9C",
    "Model": "P9C"
  },
  {
    "Retail Branding": "Reeder",
    "Marketing Name": "Preo P3",
    "Device": "Preo_P3",
    "Model": "Preo P3"
  },
  {
    "Retail Branding": "Reeder",
    "Marketing Name": "Pro Max 256GB",
    "Device": "Pro_Max_256GB",
    "Model": "Pro Max 256GB"
  },
  {
    "Retail Branding": "Reeder",
    "Marketing Name": "S19 Max",
    "Device": "S19_Max",
    "Model": "S19 Max"
  },
  {
    "Retail Branding": "Reeder",
    "Marketing Name": "S19 Max 32GB",
    "Device": "S19_Max_32GB",
    "Model": "S19 Max 32GB"
  },
  {
    "Retail Branding": "Reeder",
    "Marketing Name": "S19 Max 64GB",
    "Device": "S19_Max_64GB",
    "Model": "S19 Max 64GB"
  },
  {
    "Retail Branding": "Reeder",
    "Marketing Name": "S19 Max Pro",
    "Device": "S19_Max_Pro",
    "Model": "S19 Max Pro"
  },
  {
    "Retail Branding": "Reeder",
    "Marketing Name": "S19 Max Pro S",
    "Device": "S19_Max_Pro_S",
    "Model": "S19 Max Pro S"
  },
  {
    "Retail Branding": "Reeder",
    "Marketing Name": "S19 Max Pro S 108 MP",
    "Device": "S19_Max_Pro_S_108_MP",
    "Model": "S19 Max Pro S 108 MP"
  },
  {
    "Retail Branding": "Reeder",
    "Marketing Name": "S19 Max Pro S Edge",
    "Device": "S19MaxProSEdge",
    "Model": "S19 Max Pro S Edge"
  },
  {
    "Retail Branding": "Reeder",
    "Marketing Name": "S19 MaxL 128GB",
    "Device": "S19_MaxL_128GB",
    "Model": "S19 MaxL 128GB"
  },
  {
    "Retail Branding": "Reeder",
    "Marketing Name": "S19_Max_2_128GB",
    "Device": "S19_Max_2_128GB",
    "Model": "S19 Max 2/128GB"
  },
  {
    "Retail Branding": "Reeder",
    "Marketing Name": "S19_Max_Pro_S_108_MP_N",
    "Device": "S19_Max_Pro_S_108_MP",
    "Model": "S19 Max Pro S 108 MP"
  },
  {
    "Retail Branding": "Reeder",
    "Marketing Name": "S19 Max Pro S Zoom",
    "Device": "S19_Max_Pro_S_Zoom",
    "Model": "S19 Max Pro S Zoom"
  },
  {
    "Retail Branding": "Reeder",
    "Marketing Name": "S23 Pro Max",
    "Device": "S23_Pro_Max",
    "Model": "S23 Pro Max"
  },
  {
    "Retail Branding": "Reeder",
    "Marketing Name": "S23 Pro Max 256GB",
    "Device": "S23_Pro_Max_256GB",
    "Model": "S23 Pro Max 256GB"
  },
  {
    "Retail Branding": "Reeder",
    "Marketing Name": "S23 SE",
    "Device": "S23_SE",
    "Model": "S23 SE"
  },
  {
    "Retail Branding": "Reeder",
    "Marketing Name": "S53",
    "Device": "S53",
    "Model": "S53"
  },
  {
    "Retail Branding": "Reeder",
    "Marketing Name": "S71",
    "Device": "S71",
    "Model": "S71"
  },
  {
    "Retail Branding": "Reeder",
    "Marketing Name": "S71 Flip",
    "Device": "S71_Flip",
    "Model": "S71 Flip"
  },
  {
    "Retail Branding": "Reeder",
    "Marketing Name": "S919",
    "Device": "S919",
    "Model": "S919"
  },
  {
    "Retail Branding": "Reeder",
    "Marketing Name": "S919_SE",
    "Device": "S919_SE",
    "Model": "S919 SE"
  },
  {
    "Retail Branding": "Reeder",
    "Marketing Name": "T71",
    "Device": "T71",
    "Model": "T71"
  },
  {
    "Retail Branding": "Reeder",
    "Marketing Name": "T8",
    "Device": "reeder_T8",
    "Model": "reeder_T8"
  },
  {
    "Retail Branding": "Reeder",
    "Marketing Name": "Turkcell_T_Tablet",
    "Device": "Turkcell_T_Tablet",
    "Model": "Turkcell_T_Tablet"
  },
  {
    "Retail Branding": "Reeder",
    "Marketing Name": "reeder M10 Plus",
    "Device": "reeder_M10_Plus",
    "Model": "reeder_M10 Plus"
  },
  {
    "Retail Branding": "Reeder",
    "Marketing Name": "reeder M7",
    "Device": "reeder_M7_Go",
    "Model": "reeder_M7_Go"
  },
  {
    "Retail Branding": "Reeder",
    "Marketing Name": "reeder M8 Plus",
    "Device": "reeder_M8_Plus",
    "Model": "reeder_M8 Plus"
  },
  {
    "Retail Branding": "Reeder",
    "Marketing Name": "reeder P12",
    "Device": "P12",
    "Model": "P12"
  },
  {
    "Retail Branding": "Reeder",
    "Marketing Name": "reeder P12S",
    "Device": "P12S",
    "Model": "P12S"
  },
  {
    "Retail Branding": "Reekoo",
    "Marketing Name": "AllCall_60",
    "Device": "AllCall_60",
    "Model": "AllCall_60"
  },
  {
    "Retail Branding": "Reekoo",
    "Marketing Name": "HERO_70",
    "Device": "HERO_70",
    "Model": "HERO_70"
  },
  {
    "Retail Branding": "Reeva",
    "Marketing Name": "Reeva_Plus",
    "Device": "Reeva_Plus",
    "Model": "Reeva_Plus"
  },
  {
    "Retail Branding": "Rego",
    "Marketing Name": "Chocolate",
    "Device": "chocolate",
    "Model": "Rego"
  },
  {
    "Retail Branding": "Reliance",
    "Marketing Name": "FL7008",
    "Device": "FL7008",
    "Model": "FL7008"
  },
  {
    "Retail Branding": "Reliance",
    "Marketing Name": "LS-4008",
    "Device": "LS-4008",
    "Model": "LS-4008"
  },
  {
    "Retail Branding": "Reliance",
    "Marketing Name": "LS-5506",
    "Device": "LS-5506",
    "Model": "LS-5506"
  },
  {
    "Retail Branding": "Reliance",
    "Marketing Name": "LS-5512",
    "Device": "LS-5512",
    "Model": "LS-5512"
  },
  {
    "Retail Branding": "Reliance",
    "Marketing Name": "MCM3000",
    "Device": "MCM3000",
    "Model": "IPSetTopBox"
  },
  {
    "Retail Branding": "Reliance",
    "Marketing Name": "Orbic RC505L-RW",
    "Device": "RC505L-RW",
    "Model": "RC505L-RW"
  },
  {
    "Retail Branding": "Reliance",
    "Marketing Name": "RC500L",
    "Device": "RC500L",
    "Model": "RC500L"
  },
  {
    "Retail Branding": "Reliance",
    "Marketing Name": "RC501L",
    "Device": "RC501L",
    "Model": "RC501L"
  },
  {
    "Retail Branding": "Reliance",
    "Marketing Name": "RC555L",
    "Device": "RC555L",
    "Model": "RC555L"
  },
  {
    "Retail Branding": "Reliance",
    "Marketing Name": "RC608L",
    "Device": "RC608L",
    "Model": "RC608L"
  },
  {
    "Retail Branding": "Reliance",
    "Marketing Name": "Reliance Retail Limited",
    "Device": "chester",
    "Model": "BPL Smart"
  },
  {
    "Retail Branding": "Reliance",
    "Marketing Name": "Reliance Retail Limited",
    "Device": "chester",
    "Model": "BPL Smart TV"
  },
  {
    "Retail Branding": "Reliance",
    "Marketing Name": "Reliance Retail Limited",
    "Device": "landen",
    "Model": "BPL Smart"
  },
  {
    "Retail Branding": "Reliance",
    "Marketing Name": "Smartphone JS LS-5010",
    "Device": "LS-5010",
    "Model": "LS-5010"
  },
  {
    "Retail Branding": "Relink",
    "Marketing Name": "RLP8T",
    "Device": "RLP8T",
    "Model": "RLP8T"
  },
  {
    "Retail Branding": "Relndoo",
    "Marketing Name": "P30_EUR",
    "Device": "P30_EUR",
    "Model": "P30"
  },
  {
    "Retail Branding": "Relndoo",
    "Marketing Name": "P30_US",
    "Device": "P30_US",
    "Model": "P30"
  },
  {
    "Retail Branding": "Relndoo",
    "Marketing Name": "P60_EEA",
    "Device": "P60_EEA",
    "Model": "P60"
  },
  {
    "Retail Branding": "Relndoo",
    "Marketing Name": "P60_EUR",
    "Device": "P60_EUR",
    "Model": "P60_EUR"
  },
  {
    "Retail Branding": "Relndoo",
    "Marketing Name": "P60_ROW",
    "Device": "P60_ROW",
    "Model": "P60"
  },
  {
    "Retail Branding": "Relndoo",
    "Marketing Name": "P60_US",
    "Device": "P60_US",
    "Model": "P60_US"
  },
  {
    "Retail Branding": "Relndoo",
    "Marketing Name": "P60_U_US",
    "Device": "P60_U_US",
    "Model": "P60"
  },
  {
    "Retail Branding": "Relndoo",
    "Marketing Name": "P60_U_US",
    "Device": "P60_U_US",
    "Model": "P60_U_US"
  },
  {
    "Retail Branding": "Relndoo",
    "Marketing Name": "P80_EU",
    "Device": "P80_EU",
    "Model": "P80"
  },
  {
    "Retail Branding": "Relndoo",
    "Marketing Name": "P80_EUR",
    "Device": "P80",
    "Model": "P80"
  },
  {
    "Retail Branding": "Relndoo",
    "Marketing Name": "P80_US",
    "Device": "P80_US",
    "Model": "P80"
  },
  {
    "Retail Branding": "Relndoo",
    "Marketing Name": "P90_EEA",
    "Device": "P90",
    "Model": "P90"
  },
  {
    "Retail Branding": "Relndoo",
    "Marketing Name": "P90_ROW",
    "Device": "P90_ROW",
    "Model": "P90"
  },
  {
    "Retail Branding": "Relndoo",
    "Marketing Name": "P90_US",
    "Device": "P90",
    "Model": "P90"
  },
  {
    "Retail Branding": "Relndoo",
    "Marketing Name": "T10-M",
    "Device": "T10-M",
    "Model": "T10"
  },
  {
    "Retail Branding": "Relndoo",
    "Marketing Name": "T10P",
    "Device": "T10P",
    "Model": "T10P"
  },
  {
    "Retail Branding": "Relndoo",
    "Marketing Name": "T10P_A",
    "Device": "T10P_A",
    "Model": "T10P"
  },
  {
    "Retail Branding": "Relndoo",
    "Marketing Name": "T10P_B",
    "Device": "T10P_B",
    "Model": "T10P"
  },
  {
    "Retail Branding": "Relndoo",
    "Marketing Name": "T10P_EEA",
    "Device": "T10P_EEA",
    "Model": "T10P_EEA"
  },
  {
    "Retail Branding": "Relndoo",
    "Marketing Name": "T10P_ROW",
    "Device": "T10P_ROW",
    "Model": "T10P"
  },
  {
    "Retail Branding": "Relndoo",
    "Marketing Name": "T10P_US",
    "Device": "T10P_US",
    "Model": "T10P"
  },
  {
    "Retail Branding": "Relndoo",
    "Marketing Name": "T618",
    "Device": "T618",
    "Model": "T618"
  },
  {
    "Retail Branding": "Relndoo",
    "Marketing Name": "T618_US",
    "Device": "T618_US",
    "Model": "T618_US"
  },
  {
    "Retail Branding": "Relndoo",
    "Marketing Name": "T618_WIFI",
    "Device": "T618_WIFI",
    "Model": "T618"
  },
  {
    "Retail Branding": "Relndoo",
    "Marketing Name": "T618_WIFI_EEA",
    "Device": "T618_WIFI_EEA",
    "Model": "T618"
  },
  {
    "Retail Branding": "Relndoo",
    "Marketing Name": "T88",
    "Device": "T88",
    "Model": "T88"
  },
  {
    "Retail Branding": "Relndoo",
    "Marketing Name": "T901_EUR",
    "Device": "T901_EUR",
    "Model": "T901"
  },
  {
    "Retail Branding": "Relndoo",
    "Marketing Name": "T901_U",
    "Device": "T901_U",
    "Model": "T901"
  },
  {
    "Retail Branding": "Relndoo",
    "Marketing Name": "TAB10",
    "Device": "TAB10",
    "Model": "TAB10"
  },
  {
    "Retail Branding": "Relndoo",
    "Marketing Name": "TAB10-Pro",
    "Device": "TAB10-Pro",
    "Model": "TAB10"
  },
  {
    "Retail Branding": "Relndoo",
    "Marketing Name": "TAB10_EEA",
    "Device": "TAB10_EEA",
    "Model": "TAB10"
  },
  {
    "Retail Branding": "Relndoo",
    "Marketing Name": "TAB10_EU",
    "Device": "TAB10_EU",
    "Model": "TAB10"
  },
  {
    "Retail Branding": "Relndoo",
    "Marketing Name": "TAB10_EUR",
    "Device": "TAB10_EUR",
    "Model": "TAB10"
  },
  {
    "Retail Branding": "Relndoo",
    "Marketing Name": "TAB10_O",
    "Device": "TAB10_O",
    "Model": "TAB10"
  },
  {
    "Retail Branding": "Relndoo",
    "Marketing Name": "TAB10_ROW",
    "Device": "TAB10_ROW",
    "Model": "TAB10"
  },
  {
    "Retail Branding": "Relndoo",
    "Marketing Name": "TAB10_U",
    "Device": "TAB10_U",
    "Model": "TAB10"
  },
  {
    "Retail Branding": "Relndoo",
    "Marketing Name": "TAB10_US",
    "Device": "TAB10_US",
    "Model": "TAB10"
  },
  {
    "Retail Branding": "Relndoo",
    "Marketing Name": "TAB10_US",
    "Device": "TAB10_US",
    "Model": "TAB10_US"
  },
  {
    "Retail Branding": "Relndoo",
    "Marketing Name": "TAB9-E-EEA",
    "Device": "TAB9",
    "Model": "TAB9"
  },
  {
    "Retail Branding": "Relndoo",
    "Marketing Name": "TAB9-US",
    "Device": "TAB9",
    "Model": "TAB9"
  },
  {
    "Retail Branding": "Relndoo",
    "Marketing Name": "TAB9_EEA",
    "Device": "TAB9_EEA",
    "Model": "TAB9_EEA"
  },
  {
    "Retail Branding": "Relndoo",
    "Marketing Name": "TB02",
    "Device": "TB02",
    "Model": "TB02"
  },
  {
    "Retail Branding": "Relndoo",
    "Marketing Name": "TB02_E",
    "Device": "TB02_E",
    "Model": "TB02_E"
  },
  {
    "Retail Branding": "Relndoo",
    "Marketing Name": "TB02_EEA_A",
    "Device": "TB02_EEA_A",
    "Model": "TB02"
  },
  {
    "Retail Branding": "Relndoo",
    "Marketing Name": "TB02_EUR",
    "Device": "TB02_EUR",
    "Model": "TB02"
  },
  {
    "Retail Branding": "Relndoo",
    "Marketing Name": "TB02_Pro_EEA",
    "Device": "TB02_Pro_EEA",
    "Model": "TB02"
  },
  {
    "Retail Branding": "Relndoo",
    "Marketing Name": "TB02_ROW",
    "Device": "TB02_ROW",
    "Model": "TB02"
  },
  {
    "Retail Branding": "Relndoo",
    "Marketing Name": "TB02_US",
    "Device": "TB02_US",
    "Model": "TB02"
  },
  {
    "Retail Branding": "Remdun",
    "Marketing Name": "RD-52",
    "Device": "RD52",
    "Model": "RD52"
  },
  {
    "Retail Branding": "Remdun",
    "Marketing Name": "RD115MQ",
    "Device": "RD115MQ",
    "Model": "RD115MQ"
  },
  {
    "Retail Branding": "Remdun",
    "Marketing Name": "RD115MQE",
    "Device": "RD115MQE",
    "Model": "RD115MQE"
  },
  {
    "Retail Branding": "Remdun",
    "Marketing Name": "RD11PT",
    "Device": "RD11PT",
    "Model": "RD11PT"
  },
  {
    "Retail Branding": "Remdun",
    "Marketing Name": "RD11PTE",
    "Device": "RD11PTE",
    "Model": "RD11PTE"
  },
  {
    "Retail Branding": "Remdun",
    "Marketing Name": "RD15PQE",
    "Device": "RD15PQE",
    "Model": "RD15PQE"
  },
  {
    "Retail Branding": "Remdun",
    "Marketing Name": "RD15QE",
    "Device": "RD15QE",
    "Model": "RD15QE"
  },
  {
    "Retail Branding": "Remdun",
    "Marketing Name": "RD16Q",
    "Device": "RD16Q",
    "Model": "RD16Q"
  },
  {
    "Retail Branding": "Remdun",
    "Marketing Name": "RD16QE",
    "Device": "RD16QE",
    "Model": "RD16QE"
  },
  {
    "Retail Branding": "Remdun",
    "Marketing Name": "RD195T",
    "Device": "RD195T",
    "Model": "RD195T"
  },
  {
    "Retail Branding": "Remdun",
    "Marketing Name": "RD1XT",
    "Device": "RD1XT",
    "Model": "RD1XT"
  },
  {
    "Retail Branding": "Remdun",
    "Marketing Name": "RD40T",
    "Device": "RD40T",
    "Model": "RD40T"
  },
  {
    "Retail Branding": "Remdun",
    "Marketing Name": "RD40TE",
    "Device": "RD40TE",
    "Model": "RD40TE"
  },
  {
    "Retail Branding": "Remdun",
    "Marketing Name": "RD50T",
    "Device": "RD50T",
    "Model": "RD50T"
  },
  {
    "Retail Branding": "Remdun",
    "Marketing Name": "RD50TE",
    "Device": "RD50TE",
    "Model": "RD50TE"
  },
  {
    "Retail Branding": "Remdun",
    "Marketing Name": "RD51QE",
    "Device": "RD51QE",
    "Model": "RD51QE"
  },
  {
    "Retail Branding": "Remdun",
    "Marketing Name": "RD52E",
    "Device": "RD52E",
    "Model": "RD52E"
  },
  {
    "Retail Branding": "Remdun",
    "Marketing Name": "RD60TE",
    "Device": "RD60TE",
    "Model": "RD60TE"
  },
  {
    "Retail Branding": "Remdun",
    "Marketing Name": "RD62E",
    "Device": "RD62E",
    "Model": "RD62E"
  },
  {
    "Retail Branding": "Remdun",
    "Marketing Name": "RD695T",
    "Device": "RD695TE",
    "Model": "RD695TE"
  },
  {
    "Retail Branding": "Remdun",
    "Marketing Name": "RD695TE",
    "Device": "RD695TE",
    "Model": "RD695TE"
  },
  {
    "Retail Branding": "Remdun",
    "Marketing Name": "RD81PT",
    "Device": "RD81PT",
    "Model": "RD81PT"
  },
  {
    "Retail Branding": "Remdun",
    "Marketing Name": "RD81PTE",
    "Device": "RD81PTE",
    "Model": "RD81PTE"
  },
  {
    "Retail Branding": "Remdun",
    "Marketing Name": "RD86",
    "Device": "RD86",
    "Model": "RD86"
  },
  {
    "Retail Branding": "Remdun",
    "Marketing Name": "RD865MQ",
    "Device": "RD865MQ",
    "Model": "RD865MQ"
  },
  {
    "Retail Branding": "Remdun",
    "Marketing Name": "RD865MQE",
    "Device": "RD865MQE",
    "Model": "RD865MQE"
  },
  {
    "Retail Branding": "Remdun",
    "Marketing Name": "RD86E",
    "Device": "RD86E",
    "Model": "RD86E"
  },
  {
    "Retail Branding": "Remdun",
    "Marketing Name": "RD86QE",
    "Device": "RD86QE",
    "Model": "RD86QE"
  },
  {
    "Retail Branding": "Remdun",
    "Marketing Name": "RD895T",
    "Device": "RD895T",
    "Model": "RD895T"
  },
  {
    "Retail Branding": "Remdun",
    "Marketing Name": "RD895TE",
    "Device": "RD895TE",
    "Model": "RD895TE"
  },
  {
    "Retail Branding": "Remdun",
    "Marketing Name": "t8332_T10_64_k419",
    "Device": "t8332_T10_64_k419",
    "Model": "t8332_l40mmeiw_T10_64_k419"
  },
  {
    "Retail Branding": "Renault",
    "Marketing Name": "OpenR Link",
    "Device": "aivi2_full",
    "Model": "AIVI2 FULL"
  },
  {
    "Retail Branding": "Renault",
    "Marketing Name": "OpenR Link",
    "Device": "aivi2_r_full_dom",
    "Model": "AIVI2 R FULL DOM"
  },
  {
    "Retail Branding": "Reputer",
    "Marketing Name": "ideaBoard",
    "Device": "idea_Board",
    "Model": "idea_Board"
  },
  {
    "Retail Branding": "RetroidPocket",
    "Marketing Name": "4Pro",
    "Device": "4Pro",
    "Model": "Retroid Pocket 4 Pro"
  },
  {
    "Retail Branding": "Reveal 16i",
    "Marketing Name": "rk3399_rvlEEA_box",
    "Device": "rk3399_reveal16i_box",
    "Model": "Reveal 16i"
  },
  {
    "Retail Branding": "Reveal 16i",
    "Marketing Name": "rk3399_rvl_box",
    "Device": "rk3399_reveal16i_box",
    "Model": "Reveal 16i"
  },
  {
    "Retail Branding": "Revko",
    "Marketing Name": "BE XL",
    "Device": "BE_xl",
    "Model": "BE_xl"
  },
  {
    "Retail Branding": "Revo",
    "Marketing Name": "Pearl",
    "Device": "Pearl",
    "Model": "Pearl"
  },
  {
    "Retail Branding": "Revo",
    "Marketing Name": "Power",
    "Device": "Power",
    "Model": "Power"
  },
  {
    "Retail Branding": "Revomovil",
    "Marketing Name": "S6523_RU",
    "Device": "S6523_RU",
    "Model": "S6523 RU"
  },
  {
    "Retail Branding": "Revomovil",
    "Marketing Name": "S6525",
    "Device": "S6525",
    "Model": "S6525"
  },
  {
    "Retail Branding": "Revomovil",
    "Marketing Name": "S6525 EEA",
    "Device": "S6525_EEA",
    "Model": "S6525 EEA"
  },
  {
    "Retail Branding": "Revomovil",
    "Marketing Name": "X12",
    "Device": "S6523",
    "Model": "S6523"
  },
  {
    "Retail Branding": "Revomovil",
    "Marketing Name": "X12",
    "Device": "S6523_EEA",
    "Model": "S6523 EEA"
  },
  {
    "Retail Branding": "Revrica",
    "Marketing Name": "Uko108T",
    "Device": "Uko108T",
    "Model": "Uko108T"
  },
  {
    "Retail Branding": "Revtel",
    "Marketing Name": "R45",
    "Device": "Revel_R45",
    "Model": "R45"
  },
  {
    "Retail Branding": "Rhino",
    "Marketing Name": "C10",
    "Device": "Rhino_C10",
    "Model": "C10"
  },
  {
    "Retail Branding": "Rhino",
    "Marketing Name": "EVOTAB",
    "Device": "armor",
    "Model": "EVOTAB"
  },
  {
    "Retail Branding": "Rhino",
    "Marketing Name": "RHINO C10",
    "Device": "Rhino_C10",
    "Model": "C10"
  },
  {
    "Retail Branding": "Rhino",
    "Marketing Name": "RHINO C6",
    "Device": "nova",
    "Model": "C6"
  },
  {
    "Retail Branding": "Rhino",
    "Marketing Name": "RHINO C6",
    "Device": "novax",
    "Model": "C6"
  },
  {
    "Retail Branding": "Rhino",
    "Marketing Name": "RHINO C6D",
    "Device": "novad",
    "Model": "C6D"
  },
  {
    "Retail Branding": "Rhino",
    "Marketing Name": "RHINO C6R",
    "Device": "novar",
    "Model": "C6R"
  },
  {
    "Retail Branding": "Rhino",
    "Marketing Name": "RHINO M10p",
    "Device": "Rhino_M10p",
    "Model": "M10p"
  },
  {
    "Retail Branding": "Rhino",
    "Marketing Name": "RHINO PACE",
    "Device": "pace",
    "Model": "PACE A1"
  },
  {
    "Retail Branding": "Rhino",
    "Marketing Name": "RHINO PACE A1",
    "Device": "portal",
    "Model": "PACE A1"
  },
  {
    "Retail Branding": "Rhino",
    "Marketing Name": "RHINO T100",
    "Device": "scoutxl",
    "Model": "T100"
  },
  {
    "Retail Branding": "Rhino",
    "Marketing Name": "RHINO T100",
    "Device": "scoutxlx",
    "Model": "T100"
  },
  {
    "Retail Branding": "Rhino",
    "Marketing Name": "RHINO T105",
    "Device": "stratos",
    "Model": "T105"
  },
  {
    "Retail Branding": "Rhino",
    "Marketing Name": "RHINO T5se",
    "Device": "atom",
    "Model": "T5se"
  },
  {
    "Retail Branding": "Rhino",
    "Marketing Name": "RHINO T8",
    "Device": "Rhino_T8",
    "Model": "T8"
  },
  {
    "Retail Branding": "Rhino",
    "Marketing Name": "RHINO T80",
    "Device": "scout",
    "Model": "T80"
  },
  {
    "Retail Branding": "Rhino",
    "Marketing Name": "RHINO T80",
    "Device": "scoutx",
    "Model": "T80"
  },
  {
    "Retail Branding": "Rhino",
    "Marketing Name": "T100",
    "Device": "scoutxlx",
    "Model": "T100"
  },
  {
    "Retail Branding": "Rhino",
    "Marketing Name": "T5SE",
    "Device": "Rhino_T5SE",
    "Model": "T5SE-001"
  },
  {
    "Retail Branding": "Rhino",
    "Marketing Name": "T8",
    "Device": "Rhino_T8",
    "Model": "T8"
  },
  {
    "Retail Branding": "Rhino",
    "Marketing Name": "T80",
    "Device": "scoutx",
    "Model": "T80"
  },
  {
    "Retail Branding": "Rhino",
    "Marketing Name": "Vision_12",
    "Device": "Vision_12",
    "Model": "Vision 12"
  },
  {
    "Retail Branding": "Rhino",
    "Marketing Name": "Vision_7",
    "Device": "Vision_7",
    "Model": "Vision 7"
  },
  {
    "Retail Branding": "Ricoh",
    "Marketing Name": "AXX10",
    "Device": "AXX10",
    "Model": "AXX10"
  },
  {
    "Retail Branding": "RiksTV",
    "Marketing Name": "SRT412",
    "Device": "HP40A3",
    "Model": "SRT412"
  },
  {
    "Retail Branding": "Rimo_Mobile",
    "Marketing Name": "Rimo",
    "Device": "Rimo",
    "Model": "Rimo"
  },
  {
    "Retail Branding": "Rimo_Mobile",
    "Marketing Name": "Rimo Plus",
    "Device": "Rimo_Plus",
    "Model": "Rimo Plus"
  },
  {
    "Retail Branding": "Rindo",
    "Marketing Name": "R-32B6600",
    "Device": "ikebukuro",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "Rindo",
    "Marketing Name": "RINDO 2K Android TV",
    "Device": "lasalle",
    "Model": "RINDO 2K Android TV"
  },
  {
    "Retail Branding": "Rindo",
    "Marketing Name": "Smart TV",
    "Device": "longshan",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "Rindo",
    "Marketing Name": "Smart TV",
    "Device": "redwood",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "Rindo",
    "Marketing Name": "Smart TV",
    "Device": "samseong",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "Rinno",
    "Marketing Name": "K27p",
    "Device": "K27p",
    "Model": "K27p"
  },
  {
    "Retail Branding": "Rinno",
    "Marketing Name": "R455",
    "Device": "R455",
    "Model": "R455"
  },
  {
    "Retail Branding": "Rinno",
    "Marketing Name": "R505",
    "Device": "Rinno_R505",
    "Model": "R505"
  },
  {
    "Retail Branding": "Rinno",
    "Marketing Name": "R520",
    "Device": "R520",
    "Model": "R520"
  },
  {
    "Retail Branding": "Rinno",
    "Marketing Name": "R550",
    "Device": "R550",
    "Model": "R550"
  },
  {
    "Retail Branding": "Riotouch",
    "Marketing Name": "RK882",
    "Device": "RK882",
    "Model": "RK882"
  },
  {
    "Retail Branding": "Rivian",
    "Marketing Name": "Rivian R1",
    "Device": "xmm_revc_r1",
    "Model": "Rivian"
  },
  {
    "Retail Branding": "Riviera",
    "Marketing Name": "Android TV",
    "Device": "ikebukuro",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "Riviera",
    "Marketing Name": "Android TV",
    "Device": "sindorim",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "Riviera",
    "Marketing Name": "HIKA5",
    "Device": "songshan",
    "Model": "SmartTV 4K"
  },
  {
    "Retail Branding": "Riviera",
    "Marketing Name": "Riviera",
    "Device": "hamamatsucho",
    "Model": "Smart TV"
  },
  {
    "Retail Branding": "Riviera",
    "Marketing Name": "Smart TV",
    "Device": "alimos",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "Riviera",
    "Marketing Name": "Smart TV",
    "Device": "bridgeport",
    "Model": "AI PONT PLUS FF"
  },
  {
    "Retail Branding": "Riviera",
    "Marketing Name": "Smart TV",
    "Device": "dangni",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "Riviera",
    "Marketing Name": "Smart TV",
    "Device": "osaka",
    "Model": "AI PONT SA"
  },
  {
    "Retail Branding": "Riviera",
    "Marketing Name": "xiaoyushan_riviera",
    "Device": "xiaoyushan",
    "Model": "HiSmartTV A4"
  },
  {
    "Retail Branding": "Rixun",
    "Marketing Name": "T107",
    "Device": "T107",
    "Model": "T107"
  },
  {
    "Retail Branding": "Rizzen",
    "Marketing Name": "LunaPadG1",
    "Device": "LunaPadG1",
    "Model": "LunaPadG1"
  },
  {
    "Retail Branding": "Rizzen",
    "Marketing Name": "NovaTab_R10",
    "Device": "NovaTab_R10",
    "Model": "NovaTab_R10"
  },
  {
    "Retail Branding": "Rizzen",
    "Marketing Name": "NovaTab_R10s",
    "Device": "NovaTab_R10s",
    "Model": "R10s"
  },
  {
    "Retail Branding": "Rizzen",
    "Marketing Name": "Novatab",
    "Device": "S1s",
    "Model": "S1s"
  },
  {
    "Retail Branding": "Rizzen",
    "Marketing Name": "Rizzen_Ultra_26S50",
    "Device": "Rizzen_Ultra_26S50",
    "Model": "Ultra_26S50"
  },
  {
    "Retail Branding": "Rizzen",
    "Marketing Name": "Rizzen_X_26X2",
    "Device": "Rizzen_X_26X2",
    "Model": "Rizzen_X_26X2"
  },
  {
    "Retail Branding": "Rizzen",
    "Marketing Name": "S1",
    "Device": "S1",
    "Model": "S1"
  },
  {
    "Retail Branding": "Rizzen",
    "Marketing Name": "X1",
    "Device": "X1",
    "Model": "X1"
  },
  {
    "Retail Branding": "Rizzen",
    "Marketing Name": "X1x",
    "Device": "X1x",
    "Model": "X1x"
  },
  {
    "Retail Branding": "RoadQuest",
    "Marketing Name": "RoadQuest",
    "Device": "RQ-G",
    "Model": "RQ-G"
  },
  {
    "Retail Branding": "RockTek",
    "Marketing Name": "GT1",
    "Device": "RMQ",
    "Model": "UHD Streaming STB"
  },
  {
    "Retail Branding": "RockTek",
    "Marketing Name": "GX1",
    "Device": "RMQ",
    "Model": "UHD Google TV STB"
  },
  {
    "Retail Branding": "RockTek",
    "Marketing Name": "RT-G1",
    "Device": "RTBox",
    "Model": "RT-G1"
  },
  {
    "Retail Branding": "RockTek",
    "Marketing Name": "RT-G2",
    "Device": "YYJ",
    "Model": "RT-G2"
  },
  {
    "Retail Branding": "Rockcel",
    "Marketing Name": "Quartzo UP",
    "Device": "Quartzo_UP",
    "Model": "Quartzo UP"
  },
  {
    "Retail Branding": "Rockcel",
    "Marketing Name": "Quartzo Up",
    "Device": "Quartzo_up",
    "Model": "Quartzo_up"
  },
  {
    "Retail Branding": "Rockcel",
    "Marketing Name": "Quartzo_4G",
    "Device": "Quartzo_4G",
    "Model": "Quartzo_4G"
  },
  {
    "Retail Branding": "Roenllce",
    "Marketing Name": "L10-T12",
    "Device": "L10-T12",
    "Model": "L10"
  },
  {
    "Retail Branding": "Roenllce",
    "Marketing Name": "L10-T12-EEA",
    "Device": "L10-T12-EEA",
    "Model": "L10"
  },
  {
    "Retail Branding": "Rogue mobile Inc",
    "Marketing Name": "R67S",
    "Device": "R67S",
    "Model": "R67S"
  },
  {
    "Retail Branding": "Rogue mobile Inc",
    "Marketing Name": "R67SA",
    "Device": "R67SA",
    "Model": "R67S"
  },
  {
    "Retail Branding": "Rogue mobile Inc",
    "Marketing Name": "R67T",
    "Device": "R67T",
    "Model": "R67T"
  },
  {
    "Retail Branding": "Rokid",
    "Marketing Name": "station2",
    "Device": "station2",
    "Model": "RG-station2"
  },
  {
    "Retail Branding": "Rombica",
    "Marketing Name": "myPhone Jet",
    "Device": "myPhone_Jet",
    "Model": "myPhone Jet"
  },
  {
    "Retail Branding": "Rosso",
    "Marketing Name": "ROSSO",
    "Device": "jagalchi",
    "Model": "SMART TV"
  },
  {
    "Retail Branding": "Rosso",
    "Marketing Name": "ROSSO",
    "Device": "zhongshan",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "Rosso",
    "Marketing Name": "Rosso",
    "Device": "stanford",
    "Model": "40D"
  },
  {
    "Retail Branding": "Rotai",
    "Marketing Name": "Remoter",
    "Device": "Rotai_1201_Remoter",
    "Model": "Remoter"
  },
  {
    "Retail Branding": "Royal-rahmani",
    "Marketing Name": "ROYALRAHMANI",
    "Device": "hongkong",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "Royal-rahmani",
    "Marketing Name": "ROYALRAHMANI",
    "Device": "stanford",
    "Model": "2K SMART TV"
  },
  {
    "Retail Branding": "Royal-rahmani",
    "Marketing Name": "Smart TV",
    "Device": "osaka",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "Royaltek",
    "Marketing Name": "FGAD",
    "Device": "FGAD",
    "Model": "FGAD"
  },
  {
    "Retail Branding": "Royole",
    "Marketing Name": "VERTU Ayxta Fold 3",
    "Device": "RY1205",
    "Model": "VERTU Ayxta Fold 3"
  },
  {
    "Retail Branding": "Royqueen",
    "Marketing Name": "RQ-712",
    "Device": "RQ-712",
    "Model": "RQ-712"
  },
  {
    "Retail Branding": "Royqueen",
    "Marketing Name": "RQ-713S",
    "Device": "RQ-713S",
    "Model": "RQ-713S"
  },
  {
    "Retail Branding": "Royqueen",
    "Marketing Name": "RQ-768",
    "Device": "RQ-768",
    "Model": "RQ-768"
  },
  {
    "Retail Branding": "RugOne",
    "Marketing Name": "Xever 7",
    "Device": "GR1000BF2",
    "Model": "Xever 7"
  },
  {
    "Retail Branding": "RugOne",
    "Marketing Name": "Xever 7 Pro",
    "Device": "GR1000BF1",
    "Model": "Xever 7 Pro"
  },
  {
    "Retail Branding": "RugOne",
    "Marketing Name": "Xever 7 Pro",
    "Device": "GR1000BF2",
    "Model": "Xever 7"
  },
  {
    "Retail Branding": "RugOne",
    "Marketing Name": "Xever 7 Pro Thermal",
    "Device": "GR1000BF1",
    "Model": "Xever 7 Pro"
  },
  {
    "Retail Branding": "RuggON",
    "Marketing Name": "MT7030",
    "Device": "MT7030",
    "Model": "MT7030"
  },
  {
    "Retail Branding": "RuggON",
    "Marketing Name": "PA501",
    "Device": "PA501BG",
    "Model": "PA501"
  },
  {
    "Retail Branding": "RuggON",
    "Marketing Name": "PA501",
    "Device": "PA501BW",
    "Model": "PA501"
  },
  {
    "Retail Branding": "RuggON",
    "Marketing Name": "PA501BGR",
    "Device": "PA501BGR",
    "Model": "PA501BGR"
  },
  {
    "Retail Branding": "RuggON",
    "Marketing Name": "PA501BWR",
    "Device": "PA501BWR",
    "Model": "PA501BWR"
  },
  {
    "Retail Branding": "RuggON",
    "Marketing Name": "Xever 7 Pro Thermal",
    "Device": "GR1000BF1",
    "Model": "Xever 7 Pro"
  },
  {
    "Retail Branding": "Ruggear",
    "Marketing Name": "CP250",
    "Device": "cp250_gts",
    "Model": "cp250_gts"
  },
  {
    "Retail Branding": "Ruggear",
    "Marketing Name": "DEWALT MD501",
    "Device": "md501",
    "Model": "DeWalt MD501"
  },
  {
    "Retail Branding": "Ruggear",
    "Marketing Name": "IMO S",
    "Device": "IMO_S",
    "Model": "IMO_S"
  },
  {
    "Retail Branding": "Ruggear",
    "Marketing Name": "PSM01E",
    "Device": "PSM01E",
    "Model": "PSM01E"
  },
  {
    "Retail Branding": "Ruggear",
    "Marketing Name": "RG540",
    "Device": "RG540",
    "Model": "RG540"
  },
  {
    "Retail Branding": "Ruggear",
    "Marketing Name": "RG650",
    "Device": "RG650",
    "Model": "RG650"
  },
  {
    "Retail Branding": "Ruggear",
    "Marketing Name": "RG650",
    "Device": "RG650",
    "Model": "RG650 U"
  },
  {
    "Retail Branding": "Ruggear",
    "Marketing Name": "RG655",
    "Device": "RG655",
    "Model": "RG655"
  },
  {
    "Retail Branding": "Ruggear",
    "Marketing Name": "RG720",
    "Device": "RG720",
    "Model": "RG720"
  },
  {
    "Retail Branding": "Ruggear",
    "Marketing Name": "RG725",
    "Device": "RG725",
    "Model": "RG725"
  },
  {
    "Retail Branding": "Ruggear",
    "Marketing Name": "RG725 Plus",
    "Device": "RG725Plus",
    "Model": "RG725Plus"
  },
  {
    "Retail Branding": "Ruggear",
    "Marketing Name": "RG725_P_EEA",
    "Device": "RG725",
    "Model": "RG725"
  },
  {
    "Retail Branding": "Ruggear",
    "Marketing Name": "RG725_P_ROW",
    "Device": "RG725",
    "Model": "RG725"
  },
  {
    "Retail Branding": "Ruggear",
    "Marketing Name": "RG725_Q_EEA",
    "Device": "RG725",
    "Model": "RG725"
  },
  {
    "Retail Branding": "Ruggear",
    "Marketing Name": "RG725_Q_ROW",
    "Device": "RG725",
    "Model": "RG725"
  },
  {
    "Retail Branding": "Ruggear",
    "Marketing Name": "RG725_Q_US",
    "Device": "RG725",
    "Model": "RG725"
  },
  {
    "Retail Branding": "Ruggear",
    "Marketing Name": "RG730",
    "Device": "rg730",
    "Model": "RugGear RG730"
  },
  {
    "Retail Branding": "Ruggear",
    "Marketing Name": "RG740B",
    "Device": "RG740B",
    "Model": "RG740B"
  },
  {
    "Retail Branding": "Ruggear",
    "Marketing Name": "RG750",
    "Device": "RG750_EEA",
    "Model": "RG750"
  },
  {
    "Retail Branding": "Ruggear",
    "Marketing Name": "RG750",
    "Device": "RG750_ROW",
    "Model": "RG750"
  },
  {
    "Retail Branding": "Ruggear",
    "Marketing Name": "RG760",
    "Device": "RG760",
    "Model": "RG760"
  },
  {
    "Retail Branding": "Ruggear",
    "Marketing Name": "RG850",
    "Device": "RG850",
    "Model": "RG850"
  },
  {
    "Retail Branding": "Ruggear",
    "Marketing Name": "RG880",
    "Device": "RG880",
    "Model": "RG880"
  },
  {
    "Retail Branding": "Ruggear",
    "Marketing Name": "RG880i",
    "Device": "RG880i",
    "Model": "RG880i"
  },
  {
    "Retail Branding": "Ruggear",
    "Marketing Name": "RG910",
    "Device": "RG910",
    "Model": "RG910"
  },
  {
    "Retail Branding": "Ruggear",
    "Marketing Name": "RG930i",
    "Device": "RG930i",
    "Model": "RG930i"
  },
  {
    "Retail Branding": "Ruggear",
    "Marketing Name": "RG935",
    "Device": "RG935",
    "Model": "RG935"
  },
  {
    "Retail Branding": "Ruggear",
    "Marketing Name": "RG940",
    "Device": "RG940",
    "Model": "RG940"
  },
  {
    "Retail Branding": "Ruggear",
    "Marketing Name": "RugGear rg730",
    "Device": "rg730",
    "Model": "rg730"
  },
  {
    "Retail Branding": "Ruio",
    "Marketing Name": "A870",
    "Device": "A870",
    "Model": "A870"
  },
  {
    "Retail Branding": "Ruio",
    "Marketing Name": "Blitz",
    "Device": "Blitz",
    "Model": "Blitz"
  },
  {
    "Retail Branding": "Ruio",
    "Marketing Name": "Cola",
    "Device": "M671M3",
    "Model": "M671M3"
  },
  {
    "Retail Branding": "Ruio",
    "Marketing Name": "Cola 4G",
    "Device": "M671M4",
    "Model": "M671M4"
  },
  {
    "Retail Branding": "Ruio",
    "Marketing Name": "Cola Plus 4G",
    "Device": "M675M4",
    "Model": "M675M4"
  },
  {
    "Retail Branding": "Ruio",
    "Marketing Name": "M31",
    "Device": "AIS-M31",
    "Model": "AIS-M31"
  },
  {
    "Retail Branding": "Ruio",
    "Marketing Name": "RUIO S5506",
    "Device": "S5506",
    "Model": "S5506"
  },
  {
    "Retail Branding": "Ruio",
    "Marketing Name": "RUIO S6518",
    "Device": "S6518",
    "Model": "S6518"
  },
  {
    "Retail Branding": "Ruio",
    "Marketing Name": "RUIO ZIP",
    "Device": "RUIO_ZIP",
    "Model": "RS2503-AU"
  },
  {
    "Retail Branding": "Ruio",
    "Marketing Name": "RUIO i7c Tablet",
    "Device": "i7c",
    "Model": "i7c"
  },
  {
    "Retail Branding": "Ruio",
    "Marketing Name": "RUIO_S518",
    "Device": "RUIO_S518",
    "Model": "S518"
  },
  {
    "Retail Branding": "Ruio",
    "Marketing Name": "Ruio_S4 Plus",
    "Device": "S4Plus",
    "Model": "S4Plus"
  },
  {
    "Retail Branding": "Ruio",
    "Marketing Name": "Ruio_S5Plus",
    "Device": "Ruio_S5Plus",
    "Model": "Ruio_S5Plus"
  },
  {
    "Retail Branding": "Ruio",
    "Marketing Name": "Ruio_i7Plus",
    "Device": "i7Plus",
    "Model": "i7Plus"
  },
  {
    "Retail Branding": "Ruio",
    "Marketing Name": "Ruio_i7Ultra",
    "Device": "Ruio_i7Ultra",
    "Model": "Ruio_i7Ultra"
  },
  {
    "Retail Branding": "Ruio",
    "Marketing Name": "S4",
    "Device": "RUIO_S4",
    "Model": "RUIO_S4"
  },
  {
    "Retail Branding": "Ruio",
    "Marketing Name": "S5006",
    "Device": "RUIO_S5006",
    "Model": "S5006"
  },
  {
    "Retail Branding": "Ruio",
    "Marketing Name": "S5521",
    "Device": "S5521",
    "Model": "Orange Kova one"
  },
  {
    "Retail Branding": "Ruio",
    "Marketing Name": "S5521",
    "Device": "S5521",
    "Model": "S5521"
  },
  {
    "Retail Branding": "Ruio",
    "Marketing Name": "S6501",
    "Device": "S6501",
    "Model": "S6501"
  },
  {
    "Retail Branding": "Ruio",
    "Marketing Name": "S6506",
    "Device": "S6506",
    "Model": "S6506"
  },
  {
    "Retail Branding": "Ruio",
    "Marketing Name": "S6528",
    "Device": "S6528",
    "Model": "S6528"
  },
  {
    "Retail Branding": "Ruio",
    "Marketing Name": "S6537G",
    "Device": "S6537G",
    "Model": "S6537G"
  },
  {
    "Retail Branding": "Ruio",
    "Marketing Name": "S6539Q",
    "Device": "S6539Q",
    "Model": "Celtiis Smart 3"
  },
  {
    "Retail Branding": "Ruio",
    "Marketing Name": "S6539Q",
    "Device": "S6539Q",
    "Model": "Edge X1"
  },
  {
    "Retail Branding": "Ruio",
    "Marketing Name": "S6539Q",
    "Device": "S6539Q",
    "Model": "Hot2"
  },
  {
    "Retail Branding": "Ruio",
    "Marketing Name": "S6539Q",
    "Device": "S6539Q",
    "Model": "S6539"
  },
  {
    "Retail Branding": "Ruio",
    "Marketing Name": "S6539Q",
    "Device": "S6539Q",
    "Model": "S6539Q"
  },
  {
    "Retail Branding": "Ruio",
    "Marketing Name": "S6539Q",
    "Device": "S6539Q",
    "Model": "T1"
  },
  {
    "Retail Branding": "Ruio",
    "Marketing Name": "S6539Q",
    "Device": "S6539Q",
    "Model": "VISION"
  },
  {
    "Retail Branding": "Ruio",
    "Marketing Name": "S6705",
    "Device": "S6705",
    "Model": "S6705"
  },
  {
    "Retail Branding": "Ruio",
    "Marketing Name": "smart",
    "Device": "Blitz",
    "Model": "Blitz"
  },
  {
    "Retail Branding": "Rumie",
    "Marketing Name": "RT-1708",
    "Device": "RT-1708",
    "Model": "RT-1708"
  },
  {
    "Retail Branding": "Runbo",
    "Marketing Name": "F1Plus",
    "Device": "F1Plus",
    "Model": "F1Plus"
  },
  {
    "Retail Branding": "Russound",
    "Marketing Name": "XTS7",
    "Device": "XTS7",
    "Model": "XTS7"
  },
  {
    "Retail Branding": "Ruufuuxy",
    "Marketing Name": "R16Max",
    "Device": "R16Max",
    "Model": "R16Max"
  },
  {
    "Retail Branding": "Ruufuuxy",
    "Marketing Name": "R16Plus",
    "Device": "R16Plus",
    "Model": "R16Plus"
  },
  {
    "Retail Branding": "S Vision",
    "Marketing Name": "AP",
    "Device": "stanford",
    "Model": "2K SMART TV"
  },
  {
    "Retail Branding": "S Vision",
    "Marketing Name": "AUSTRALIA, JAPAN, EUROPE",
    "Device": "guandu",
    "Model": "SVISION 4K Android TV"
  },
  {
    "Retail Branding": "S Vision",
    "Marketing Name": "Australia",
    "Device": "nippori",
    "Model": "Svision Android TV 2K"
  },
  {
    "Retail Branding": "S Vision",
    "Marketing Name": "EU、UK、AP",
    "Device": "martin",
    "Model": "SVISION 2K Android TV"
  },
  {
    "Retail Branding": "S Vision",
    "Marketing Name": "EU、UK、AP",
    "Device": "martin",
    "Model": "SVISION 2K Android TV"
  },
  {
    "Retail Branding": "S Vision",
    "Marketing Name": "Japan,USA,Australia, Italy,German",
    "Device": "martin",
    "Model": "SVISION Android Monitor"
  },
  {
    "Retail Branding": "S Vision",
    "Marketing Name": "S android TV",
    "Device": "hanyang",
    "Model": "Svision Android TV"
  },
  {
    "Retail Branding": "S Vision",
    "Marketing Name": "SVISION",
    "Device": "lavender",
    "Model": "SVISION 4K Android TV"
  },
  {
    "Retail Branding": "S Vision",
    "Marketing Name": "SVISION",
    "Device": "mountbaker",
    "Model": "SVISION 2K Android TV"
  },
  {
    "Retail Branding": "S Vision",
    "Marketing Name": "SVISION",
    "Device": "zhongshan",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "S&T Global",
    "Marketing Name": "8788_7",
    "Device": "8788_7",
    "Model": "8788_7"
  },
  {
    "Retail Branding": "S&T Global",
    "Marketing Name": "C20",
    "Device": "C20",
    "Model": "C20"
  },
  {
    "Retail Branding": "S-tell",
    "Marketing Name": "M555i",
    "Device": "M555i",
    "Model": "M555i"
  },
  {
    "Retail Branding": "S-tell",
    "Marketing Name": "M558",
    "Device": "M558",
    "Model": "M558"
  },
  {
    "Retail Branding": "S-tell",
    "Marketing Name": "M578",
    "Device": "M578",
    "Model": "M578"
  },
  {
    "Retail Branding": "S-tell",
    "Marketing Name": "M580",
    "Device": "M580",
    "Model": "M580"
  },
  {
    "Retail Branding": "S-tell",
    "Marketing Name": "M630",
    "Device": "M630",
    "Model": "M630"
  },
  {
    "Retail Branding": "S-tell",
    "Marketing Name": "M655",
    "Device": "M655",
    "Model": "M655"
  },
  {
    "Retail Branding": "S-tell",
    "Marketing Name": "P750i",
    "Device": "P750i",
    "Model": "P750i"
  },
  {
    "Retail Branding": "S-tell",
    "Marketing Name": "P760",
    "Device": "P760",
    "Model": "P760"
  },
  {
    "Retail Branding": "S-tell",
    "Marketing Name": "P771",
    "Device": "S-TELL",
    "Model": "P771"
  },
  {
    "Retail Branding": "S-tell",
    "Marketing Name": "P850",
    "Device": "P850",
    "Model": "P850"
  },
  {
    "Retail Branding": "SABA",
    "Marketing Name": "A11",
    "Device": "longshan",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "SABA",
    "Marketing Name": "A11",
    "Device": "redwood",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "SABA",
    "Marketing Name": "Smart TV",
    "Device": "alimos",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "SABA",
    "Marketing Name": "Smart TV",
    "Device": "alimos",
    "Model": "AI PONT FR"
  },
  {
    "Retail Branding": "SABA",
    "Marketing Name": "Smart TV",
    "Device": "dangni",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "SABA",
    "Marketing Name": "Smart TV",
    "Device": "dangni",
    "Model": "AI PONT FR"
  },
  {
    "Retail Branding": "SABA",
    "Marketing Name": "Smart TV",
    "Device": "longshan",
    "Model": "AI PONT IT"
  },
  {
    "Retail Branding": "SABA",
    "Marketing Name": "Smart TV",
    "Device": "redwood",
    "Model": "AI PONT IT"
  },
  {
    "Retail Branding": "SAELITE",
    "Marketing Name": "MD1063B",
    "Device": "MD1063B",
    "Model": "MD1063B"
  },
  {
    "Retail Branding": "SAELITE",
    "Marketing Name": "SAELITE",
    "Device": "mountbaker",
    "Model": "2K SMART TV"
  },
  {
    "Retail Branding": "SAGI",
    "Marketing Name": "E5501",
    "Device": "E5501",
    "Model": "E5501"
  },
  {
    "Retail Branding": "SAIET",
    "Marketing Name": "STS502",
    "Device": "STS502",
    "Model": "STS502"
  },
  {
    "Retail Branding": "SAIET",
    "Marketing Name": "STS550",
    "Device": "STS550",
    "Model": "STS550"
  },
  {
    "Retail Branding": "SAIET",
    "Marketing Name": "STS570",
    "Device": "STS570",
    "Model": "STS570"
  },
  {
    "Retail Branding": "SAIET",
    "Marketing Name": "STS571",
    "Device": "STS571",
    "Model": "STS571"
  },
  {
    "Retail Branding": "SAIET",
    "Marketing Name": "STS600",
    "Device": "STS600",
    "Model": "STS600"
  },
  {
    "Retail Branding": "SAIET",
    "Marketing Name": "STS601",
    "Device": "STS601",
    "Model": "STS601"
  },
  {
    "Retail Branding": "SAIET",
    "Marketing Name": "STS602",
    "Device": "STS602",
    "Model": "STS602"
  },
  {
    "Retail Branding": "SAIET",
    "Marketing Name": "STS650",
    "Device": "STS650",
    "Model": "STS650"
  },
  {
    "Retail Branding": "SAKAISIO",
    "Marketing Name": "FP-U320-711-WIFI",
    "Device": "U320-WF",
    "Model": "FP-U320-711-WIFI"
  },
  {
    "Retail Branding": "SAKAISIO",
    "Marketing Name": "FP-U320-711-WWAN",
    "Device": "U320-3G",
    "Model": "FP-U320-711-WWAN"
  },
  {
    "Retail Branding": "SALT",
    "Marketing Name": "SALT A78",
    "Device": "SALT_A78",
    "Model": "SALT A78"
  },
  {
    "Retail Branding": "SAMA",
    "Marketing Name": "M1039A",
    "Device": "M1039A",
    "Model": "M1039A"
  },
  {
    "Retail Branding": "SAMPO",
    "Marketing Name": "Android TV",
    "Device": "R2",
    "Model": "ATV R2"
  },
  {
    "Retail Branding": "SAMPO",
    "Marketing Name": "R4",
    "Device": "R4",
    "Model": "R4"
  },
  {
    "Retail Branding": "SAMPO",
    "Marketing Name": "R4_GTV",
    "Device": "R4_GTV",
    "Model": "R4G"
  },
  {
    "Retail Branding": "SAMPO",
    "Marketing Name": "vileparle",
    "Device": "vileparle",
    "Model": "R6G"
  },
  {
    "Retail Branding": "SANCO",
    "Marketing Name": "S3201",
    "Device": "S3201",
    "Model": "S3201"
  },
  {
    "Retail Branding": "SANCO",
    "Marketing Name": "Vietnam",
    "Device": "tamachi",
    "Model": "SANCO Android TV"
  },
  {
    "Retail Branding": "SANCO",
    "Marketing Name": "Vietnam",
    "Device": "yeongdeungpo",
    "Model": "SANCO Android TV"
  },
  {
    "Retail Branding": "SANLUX",
    "Marketing Name": "SANLUX 4K MONITOR",
    "Device": "SW4H",
    "Model": "SANLUX 4K MONITOR"
  },
  {
    "Retail Branding": "SANLUX",
    "Marketing Name": "Smart TV",
    "Device": "alimos",
    "Model": "AI PONT NA"
  },
  {
    "Retail Branding": "SANLUX",
    "Marketing Name": "Smart TV",
    "Device": "dangni",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "SANNUO",
    "Marketing Name": "K101",
    "Device": "K101",
    "Model": "K101"
  },
  {
    "Retail Branding": "SANNUO",
    "Marketing Name": "K102",
    "Device": "K102",
    "Model": "K102"
  },
  {
    "Retail Branding": "SANNUO",
    "Marketing Name": "K108",
    "Device": "K108",
    "Model": "K108"
  },
  {
    "Retail Branding": "SARL WISE TECHNOLOGIE",
    "Marketing Name": "P1_Plus",
    "Device": "P1_Plus",
    "Model": "P1+"
  },
  {
    "Retail Branding": "SARL WISE TECHNOLOGIE",
    "Marketing Name": "Wise_Tab",
    "Device": "Wise_Tab",
    "Model": "Wise_Tab"
  },
  {
    "Retail Branding": "SARL WISE TECHNOLOGIE",
    "Marketing Name": "Wise_Tech_Wifi",
    "Device": "Wise_Tech_Wifi",
    "Model": "Wise Tech Wifi"
  },
  {
    "Retail Branding": "SATCO",
    "Marketing Name": "SATCO_Y-20",
    "Device": "Y-20",
    "Model": "Y-20"
  },
  {
    "Retail Branding": "SATIR",
    "Marketing Name": "S1_ROW",
    "Device": "S1",
    "Model": "S1"
  },
  {
    "Retail Branding": "SAWINK",
    "Marketing Name": "M8_Max",
    "Device": "M8_Max",
    "Model": "M8_Max"
  },
  {
    "Retail Branding": "SAWINK",
    "Marketing Name": "S8_Ultra",
    "Device": "S8_Ultra",
    "Model": "S8_Ultra"
  },
  {
    "Retail Branding": "SAWINK",
    "Marketing Name": "T10",
    "Device": "T10",
    "Model": "T10"
  },
  {
    "Retail Branding": "SBET",
    "Marketing Name": "X7",
    "Device": "X7",
    "Model": "X7"
  },
  {
    "Retail Branding": "SCHNEIDER",
    "Marketing Name": "Android TV",
    "Device": "R1",
    "Model": "ATV R1"
  },
  {
    "Retail Branding": "SCHNEIDER",
    "Marketing Name": "Android TV",
    "Device": "R2",
    "Model": "ATV R2"
  },
  {
    "Retail Branding": "SCHNEIDER",
    "Marketing Name": "EU、UK、AP",
    "Device": "martin",
    "Model": "Schneider 2K Android TV"
  },
  {
    "Retail Branding": "SCHNEIDER",
    "Marketing Name": "EU、UK、AP",
    "Device": "martin",
    "Model": "Schneider 2K Android TV"
  },
  {
    "Retail Branding": "SCHNEIDER",
    "Marketing Name": "GMS55A1G",
    "Device": "barking",
    "Model": "SCHNEIDER AndroidTV"
  },
  {
    "Retail Branding": "SCHNEIDER",
    "Marketing Name": "SCHNEIDER",
    "Device": "bangbae",
    "Model": "SCHNEIDER 4K Android TV"
  },
  {
    "Retail Branding": "SCHNEIDER",
    "Marketing Name": "SCHNEIDER",
    "Device": "komagome",
    "Model": "SCHNEIDER 2K Android TV"
  },
  {
    "Retail Branding": "SCHNEIDER",
    "Marketing Name": "SCHNEIDER AndroidTV",
    "Device": "beaudry",
    "Model": "SCHNEIDER AndroidTV"
  },
  {
    "Retail Branding": "SCHNEIDER",
    "Marketing Name": "Smart TV",
    "Device": "osaka",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "SCHNEIDER",
    "Marketing Name": "Smart TV",
    "Device": "osaka",
    "Model": "AI PONT DZ"
  },
  {
    "Retail Branding": "SCHNEIDER",
    "Marketing Name": "Wave 3",
    "Device": "Wave_3",
    "Model": "Wave 3"
  },
  {
    "Retail Branding": "SCIENTIA",
    "Marketing Name": "BBT1019863",
    "Device": "BBT1019863",
    "Model": "BBT1019863"
  },
  {
    "Retail Branding": "SCIENTIA",
    "Marketing Name": "eWs10164T",
    "Device": "eWs10164T",
    "Model": "eWs10164T"
  },
  {
    "Retail Branding": "SCV Infinity",
    "Marketing Name": "SCVinfi 4K",
    "Device": "SEI630SCV",
    "Model": "SCVinfi 4K"
  },
  {
    "Retail Branding": "SEBBE",
    "Marketing Name": "S21",
    "Device": "S21",
    "Model": "S21_US"
  },
  {
    "Retail Branding": "SEBBE",
    "Marketing Name": "S21_EEA",
    "Device": "S21_EEA",
    "Model": "S21_EEA"
  },
  {
    "Retail Branding": "SEBBE",
    "Marketing Name": "S22-EEA",
    "Device": "S22-EEA",
    "Model": "S22-EEA"
  },
  {
    "Retail Branding": "SEBBE",
    "Marketing Name": "S22-US",
    "Device": "S22-US",
    "Model": "S22-US"
  },
  {
    "Retail Branding": "SEBBE",
    "Marketing Name": "S22_EEA",
    "Device": "S22_EEA",
    "Model": "S22_EEA"
  },
  {
    "Retail Branding": "SEBBE",
    "Marketing Name": "S22_M_EEA",
    "Device": "S22_M_EEA",
    "Model": "S22_M_EEA"
  },
  {
    "Retail Branding": "SEBBE",
    "Marketing Name": "S22_M_US",
    "Device": "S22_M_US",
    "Model": "S22_M_US"
  },
  {
    "Retail Branding": "SEBBE",
    "Marketing Name": "S22_T_EEA",
    "Device": "S22_T_EEA",
    "Model": "S22_T_EEA"
  },
  {
    "Retail Branding": "SEBBE",
    "Marketing Name": "S22_T_US",
    "Device": "S22_T_US",
    "Model": "S22_T_US"
  },
  {
    "Retail Branding": "SEBBE",
    "Marketing Name": "S22_US",
    "Device": "S22_US",
    "Model": "S22_US"
  },
  {
    "Retail Branding": "SEBBE",
    "Marketing Name": "S23_EEA",
    "Device": "S23_EEA",
    "Model": "S23_EEA"
  },
  {
    "Retail Branding": "SEBBE",
    "Marketing Name": "S23_EEA_A",
    "Device": "S23_EEA_A",
    "Model": "S23_EEA_A"
  },
  {
    "Retail Branding": "SEBBE",
    "Marketing Name": "S23_M_US",
    "Device": "S23_M_US",
    "Model": "S23_M_US"
  },
  {
    "Retail Branding": "SEBBE",
    "Marketing Name": "S23_T_EEA",
    "Device": "S23_T_EEA",
    "Model": "S23_T_EEA"
  },
  {
    "Retail Branding": "SEBBE",
    "Marketing Name": "S23_T_US",
    "Device": "S23_T_US",
    "Model": "S23_T_US"
  },
  {
    "Retail Branding": "SEBBE",
    "Marketing Name": "S23_US",
    "Device": "S23_US",
    "Model": "S23_US"
  },
  {
    "Retail Branding": "SEBBE",
    "Marketing Name": "S23_US_B",
    "Device": "S23_US_B",
    "Model": "S23_US_B"
  },
  {
    "Retail Branding": "SEBBE",
    "Marketing Name": "S23_U_EEA",
    "Device": "S23_U_EEA",
    "Model": "S23_U_EEA"
  },
  {
    "Retail Branding": "SEBBE",
    "Marketing Name": "S23_U_US",
    "Device": "S23_U_US",
    "Model": "S23_U_US"
  },
  {
    "Retail Branding": "SED Wireless",
    "Marketing Name": "GPH-650R",
    "Device": "SPH_650R",
    "Model": "GPH-650R"
  },
  {
    "Retail Branding": "SEGO",
    "Marketing Name": "MATE_10",
    "Device": "MATE_10",
    "Model": "MATE 10"
  },
  {
    "Retail Branding": "SEGO",
    "Marketing Name": "Note_70",
    "Device": "Note_70",
    "Model": "Note 70"
  },
  {
    "Retail Branding": "SEGO",
    "Marketing Name": "Orbit O1",
    "Device": "Orbit_O1",
    "Model": "Orbit O1"
  },
  {
    "Retail Branding": "SEGO",
    "Marketing Name": "Orbit O2",
    "Device": "Orbit_O2",
    "Model": "Orbit O2"
  },
  {
    "Retail Branding": "SEGO",
    "Marketing Name": "S24 Neo",
    "Device": "S24_Neo",
    "Model": "S24 Neo"
  },
  {
    "Retail Branding": "SEGO",
    "Marketing Name": "S25",
    "Device": "S25",
    "Model": "S25"
  },
  {
    "Retail Branding": "SEGO",
    "Marketing Name": "S25 Neo",
    "Device": "S25_Neo",
    "Model": "S25 Neo"
  },
  {
    "Retail Branding": "SEGO",
    "Marketing Name": "SEGO_EPIC",
    "Device": "SEGO_EPIC",
    "Model": "SEGO EPIC"
  },
  {
    "Retail Branding": "SEGO",
    "Marketing Name": "SEGO_EPIC_X",
    "Device": "EPIC_X",
    "Model": "EPIC X"
  },
  {
    "Retail Branding": "SEGO",
    "Marketing Name": "SEGO_NOTE_80",
    "Device": "SEGO_NOTE_80",
    "Model": "NOTE 80"
  },
  {
    "Retail Branding": "SEGO",
    "Marketing Name": "SEGO_NOTE_80",
    "Device": "SEGO_NOTE_80",
    "Model": "NOTE_80"
  },
  {
    "Retail Branding": "SEGO",
    "Marketing Name": "SEGO_S24",
    "Device": "S24",
    "Model": "S24"
  },
  {
    "Retail Branding": "SEGO",
    "Marketing Name": "SEGO_Zero_50",
    "Device": "ZERO_50",
    "Model": "ZERO 50"
  },
  {
    "Retail Branding": "SEGO",
    "Marketing Name": "S_PAD",
    "Device": "S_PAD",
    "Model": "DT6P30YK"
  },
  {
    "Retail Branding": "SEGO",
    "Marketing Name": "S_PAD",
    "Device": "S_PAD",
    "Model": "S_PAD"
  },
  {
    "Retail Branding": "SEGO",
    "Marketing Name": "Shark",
    "Device": "Shark",
    "Model": "Shark"
  },
  {
    "Retail Branding": "SEGO",
    "Marketing Name": "Smart_10",
    "Device": "Smart_10",
    "Model": "Smart 10"
  },
  {
    "Retail Branding": "SEGO",
    "Marketing Name": "s_tron",
    "Device": "s_tron",
    "Model": "s-tron"
  },
  {
    "Retail Branding": "SELECLINE",
    "Marketing Name": "MID7526CM",
    "Device": "MID7526CM",
    "Model": "NID_7010"
  },
  {
    "Retail Branding": "SELECLINE",
    "Marketing Name": "MID_9526CM",
    "Device": "MID_9526CM",
    "Model": "S952"
  },
  {
    "Retail Branding": "SEMP TCL",
    "Marketing Name": "GO3C",
    "Device": "GO3C",
    "Model": "GO3C"
  },
  {
    "Retail Branding": "SEMP TCL",
    "Marketing Name": "GO3C_Plus",
    "Device": "GO3C_Plus",
    "Model": "GO3C Plus"
  },
  {
    "Retail Branding": "SEMP TCL",
    "Marketing Name": "GO3C_Plus_VIVO",
    "Device": "GO3C_Plus",
    "Model": "GO3C Plus"
  },
  {
    "Retail Branding": "SEMP TCL",
    "Marketing Name": "GO3C_VIVO",
    "Device": "GO3C",
    "Model": "GO3C"
  },
  {
    "Retail Branding": "SEMP TCL",
    "Marketing Name": "GO3E",
    "Device": "GO3E",
    "Model": "GO3E"
  },
  {
    "Retail Branding": "SEMP TCL",
    "Marketing Name": "GO5E",
    "Device": "GO5E",
    "Model": "GO5E"
  },
  {
    "Retail Branding": "SENRAISE",
    "Marketing Name": "H10",
    "Device": "H10",
    "Model": "H10"
  },
  {
    "Retail Branding": "SENRAISE",
    "Marketing Name": "H10_EEA",
    "Device": "H10",
    "Model": "H10"
  },
  {
    "Retail Branding": "SENSE",
    "Marketing Name": "TW102",
    "Device": "TW102",
    "Model": "TW102"
  },
  {
    "Retail Branding": "SENSES",
    "Marketing Name": "XXIP1000",
    "Device": "SE_9679",
    "Model": "SE_9679"
  },
  {
    "Retail Branding": "SENSETALK",
    "Marketing Name": "ACM-T01K",
    "Device": "ACM-T01K",
    "Model": "ACM-T01K"
  },
  {
    "Retail Branding": "SENSONICS",
    "Marketing Name": "K3C_7570",
    "Device": "K3C",
    "Model": "K3C_7570"
  },
  {
    "Retail Branding": "SERVO",
    "Marketing Name": "P20",
    "Device": "P20",
    "Model": "P20"
  },
  {
    "Retail Branding": "SEWOO",
    "Marketing Name": "BPR-10IIA",
    "Device": "BPR-10IIA",
    "Model": "BPR-10IIA"
  },
  {
    "Retail Branding": "SEWOO",
    "Marketing Name": "NBP_65",
    "Device": "NBP_65",
    "Model": "NBP-65"
  },
  {
    "Retail Branding": "SEWOO",
    "Marketing Name": "SEWOO NBP-75",
    "Device": "NBP-75",
    "Model": "NBP-75"
  },
  {
    "Retail Branding": "SEWOO",
    "Marketing Name": "ST11_EEA",
    "Device": "ST11_EEA",
    "Model": "ST11_EEA"
  },
  {
    "Retail Branding": "SEWOO",
    "Marketing Name": "ST11_ROW",
    "Device": "ST11_ROW",
    "Model": "ST11"
  },
  {
    "Retail Branding": "SFR",
    "Marketing Name": "G8800",
    "Device": "stb_dvb_sfr",
    "Model": "SFR-G8800"
  },
  {
    "Retail Branding": "SFR",
    "Marketing Name": "STARADDICT 4",
    "Device": "staraddict4",
    "Model": "STARADDICT 4"
  },
  {
    "Retail Branding": "SFR",
    "Marketing Name": "STARXTREM3",
    "Device": "STARXTREM3",
    "Model": "STARXTREM3"
  },
  {
    "Retail Branding": "SFR",
    "Marketing Name": "Star Shine II",
    "Device": "up11_sfr_mensa",
    "Model": "STARSHINE II"
  },
  {
    "Retail Branding": "SFR",
    "Marketing Name": "Star Trail 5",
    "Device": "STARTRAIL5",
    "Model": "STARTRAIL5"
  },
  {
    "Retail Branding": "SFR",
    "Marketing Name": "Star Trail 6",
    "Device": "STARTRAIL6",
    "Model": "STARTRAIL6"
  },
  {
    "Retail Branding": "SFR",
    "Marketing Name": "Star Trail III",
    "Device": "mobiwire_startrail3",
    "Model": "StarTrail III"
  },
  {
    "Retail Branding": "SFR.fr",
    "Marketing Name": "Connect TV de SFR",
    "Device": "DV8555-SFR",
    "Model": "Connect TV de SFR"
  },
  {
    "Retail Branding": "SFR.fr",
    "Marketing Name": "Connect TV de SFR",
    "Device": "DV8945-KFS",
    "Model": "Connect TV de SFR"
  },
  {
    "Retail Branding": "SFR.fr",
    "Marketing Name": "Connect V3",
    "Device": "DIW377_ALT_FR",
    "Model": "Connect TV de SFR"
  },
  {
    "Retail Branding": "SFR.fr",
    "Marketing Name": "DV8219_SFR",
    "Device": "DV8219",
    "Model": "DV8219_SFR"
  },
  {
    "Retail Branding": "SFR.fr",
    "Marketing Name": "FR",
    "Device": "DV8219",
    "Model": "DV8219_SFR"
  },
  {
    "Retail Branding": "SGIN",
    "Marketing Name": "A10",
    "Device": "A10",
    "Model": "A10"
  },
  {
    "Retail Branding": "SGIN",
    "Marketing Name": "C10",
    "Device": "C10",
    "Model": "C10"
  },
  {
    "Retail Branding": "SGIN",
    "Marketing Name": "C8",
    "Device": "C8",
    "Model": "C8"
  },
  {
    "Retail Branding": "SGIN",
    "Marketing Name": "E10P",
    "Device": "E10P",
    "Model": "E10P"
  },
  {
    "Retail Branding": "SGIN",
    "Marketing Name": "M1046W",
    "Device": "M1046W",
    "Model": "M1046W"
  },
  {
    "Retail Branding": "SGIN",
    "Marketing Name": "M806BW6",
    "Device": "M806BW6",
    "Model": "M806BW6"
  },
  {
    "Retail Branding": "SGIN",
    "Marketing Name": "SGIN_E10M",
    "Device": "SGIN_E10M",
    "Model": "SGIN_E10M"
  },
  {
    "Retail Branding": "SGIN",
    "Marketing Name": "SGIN_X10",
    "Device": "SGIN_X10",
    "Model": "SGIN_X10"
  },
  {
    "Retail Branding": "SGIN",
    "Marketing Name": "SGIN_X10_EEA",
    "Device": "SGIN_X10_EEA",
    "Model": "SGIN_X10_EEA"
  },
  {
    "Retail Branding": "SGIN",
    "Marketing Name": "T10S",
    "Device": "T10S",
    "Model": "T10S"
  },
  {
    "Retail Branding": "SGIN",
    "Marketing Name": "T10S_EEA",
    "Device": "T10S",
    "Model": "T10S"
  },
  {
    "Retail Branding": "SGIN",
    "Marketing Name": "T12S",
    "Device": "T12S",
    "Model": "T120G"
  },
  {
    "Retail Branding": "SGIN",
    "Marketing Name": "T12S",
    "Device": "T12S",
    "Model": "T12S"
  },
  {
    "Retail Branding": "SGIN",
    "Marketing Name": "T12S_EEA",
    "Device": "T12S_EEA",
    "Model": "T12S_EEA"
  },
  {
    "Retail Branding": "SGIN",
    "Marketing Name": "T12S_ROW",
    "Device": "T12S_ROW",
    "Model": "T12S_ROW"
  },
  {
    "Retail Branding": "SGIN",
    "Marketing Name": "T12_EEA",
    "Device": "T12_EEA",
    "Model": "T12_EEA"
  },
  {
    "Retail Branding": "SGIN",
    "Marketing Name": "T12_ROW",
    "Device": "T12_ROW",
    "Model": "T12_ROW"
  },
  {
    "Retail Branding": "SGINO",
    "Marketing Name": "6S",
    "Device": "6S",
    "Model": "6S"
  },
  {
    "Retail Branding": "SGINO",
    "Marketing Name": "CP093",
    "Device": "CP093",
    "Model": "CP093"
  },
  {
    "Retail Branding": "SGINO",
    "Marketing Name": "SGINO6",
    "Device": "SGINO6",
    "Model": "SGINO6"
  },
  {
    "Retail Branding": "SHIFT",
    "Marketing Name": "SHIFT6m",
    "Device": "SHIFT6m",
    "Model": "SHIFT6m"
  },
  {
    "Retail Branding": "SHIFT",
    "Marketing Name": "SHIFT6mq",
    "Device": "axolotl",
    "Model": "SHIFT6mq"
  },
  {
    "Retail Branding": "SHIFT",
    "Marketing Name": "SHIFTphone 8",
    "Device": "otter",
    "Model": "SHIFTphone 8"
  },
  {
    "Retail Branding": "SHINON",
    "Marketing Name": "SH32G7S",
    "Device": "ikebukuro",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "SHINON",
    "Marketing Name": "SH55G7K",
    "Device": "samseong",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "SHINON",
    "Marketing Name": "Smart TV",
    "Device": "alimos",
    "Model": "SHINON Google TV"
  },
  {
    "Retail Branding": "SHINON",
    "Marketing Name": "Smart TV",
    "Device": "dangni",
    "Model": "SHINON Google TV"
  },
  {
    "Retail Branding": "SHINON",
    "Marketing Name": "Smart TV",
    "Device": "longshan",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "SHINON",
    "Marketing Name": "Smart TV",
    "Device": "osaka",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "SHINON",
    "Marketing Name": "Smart TV",
    "Device": "redwood",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "SHOWNIC",
    "Marketing Name": "EMEA",
    "Device": "sepolia",
    "Model": "SHOWNIC 4K Google TV"
  },
  {
    "Retail Branding": "SIAFU",
    "Marketing Name": "M5855",
    "Device": "M5855",
    "Model": "M5855"
  },
  {
    "Retail Branding": "SICON",
    "Marketing Name": "SICON 2K Google TV",
    "Device": "capitolhill",
    "Model": "SICON 2K Google TV"
  },
  {
    "Retail Branding": "SICON",
    "Marketing Name": "SICON 4K Google TV",
    "Device": "keoneae",
    "Model": "SICON 4K Google TV"
  },
  {
    "Retail Branding": "SILVER MAX",
    "Marketing Name": "ST-710G",
    "Device": "ST_710G",
    "Model": "ST-710G"
  },
  {
    "Retail Branding": "SILVER MAX",
    "Marketing Name": "ST-810",
    "Device": "ST_810A",
    "Model": "ST-810"
  },
  {
    "Retail Branding": "SILVERWIN",
    "Marketing Name": "SWA10E5LTE",
    "Device": "SWA10E5LTE",
    "Model": "SWA10E5LTE"
  },
  {
    "Retail Branding": "SILVERWIN",
    "Marketing Name": "SWA8E2",
    "Device": "SWA8E2",
    "Model": "SWA8E2"
  },
  {
    "Retail Branding": "SIMI",
    "Marketing Name": "COOL2",
    "Device": "COOL2",
    "Model": "COOL2"
  },
  {
    "Retail Branding": "SIMI",
    "Marketing Name": "COOL2",
    "Device": "COOL2",
    "Model": "Edge X2"
  },
  {
    "Retail Branding": "SIMI",
    "Marketing Name": "COOL2",
    "Device": "COOL2",
    "Model": "Edge_X2"
  },
  {
    "Retail Branding": "SIMI",
    "Marketing Name": "DREAM2",
    "Device": "DREAM2",
    "Model": "DREAM2"
  },
  {
    "Retail Branding": "SIMI",
    "Marketing Name": "DREAM2",
    "Device": "DREAM2",
    "Model": "Dream2"
  },
  {
    "Retail Branding": "SIMI",
    "Marketing Name": "simi X3",
    "Device": "simi_X3",
    "Model": "simi X3"
  },
  {
    "Retail Branding": "SINAL",
    "Marketing Name": "SA08_310",
    "Device": "SA08_310",
    "Model": "SA08_310"
  },
  {
    "Retail Branding": "SITI_Playtop",
    "Marketing Name": "SITIH3455N",
    "Device": "DTC2141",
    "Model": "SITIH3455N"
  },
  {
    "Retail Branding": "SK Broadband",
    "Marketing Name": "B tv smart",
    "Device": "BHX-S100",
    "Model": "BHX-S100"
  },
  {
    "Retail Branding": "SK Broadband",
    "Marketing Name": "B tv smart",
    "Device": "BKO-S200",
    "Model": "BKO-S200"
  },
  {
    "Retail Branding": "SK Broadband",
    "Marketing Name": "BFX-AT100",
    "Device": "BFX-AT100",
    "Model": "BFX-AT100"
  },
  {
    "Retail Branding": "SK Broadband",
    "Marketing Name": "BFX-UA300",
    "Device": "BFX-UA300",
    "Model": "BFX-UA300"
  },
  {
    "Retail Branding": "SK Broadband",
    "Marketing Name": "BKO-AT800",
    "Device": "BKO-AT800",
    "Model": "BKO-AT800"
  },
  {
    "Retail Branding": "SK Broadband",
    "Marketing Name": "BTV",
    "Device": "vip5442",
    "Model": "BAS-AT800"
  },
  {
    "Retail Branding": "SK Broadband",
    "Marketing Name": "SWAN",
    "Device": "BFX-UA300",
    "Model": "BFX-UA300"
  },
  {
    "Retail Branding": "SK Telesys",
    "Marketing Name": "",
    "Device": "K4",
    "Model": "SK-S170"
  },
  {
    "Retail Branding": "SK Telesys",
    "Marketing Name": "",
    "Device": "msm8255_k5",
    "Model": "SK-S150"
  },
  {
    "Retail Branding": "SK Telesys",
    "Marketing Name": "",
    "Device": "qsd8250_s1",
    "Model": "SK-S100"
  },
  {
    "Retail Branding": "SK Telesys",
    "Marketing Name": "AN200",
    "Device": "AN200",
    "Model": "AN200"
  },
  {
    "Retail Branding": "SK Telesys",
    "Marketing Name": "EG68BE",
    "Device": "EG668BE",
    "Model": "EG668"
  },
  {
    "Retail Branding": "SK Telesys",
    "Marketing Name": "EG978TW",
    "Device": "EG978TW",
    "Model": "EG978"
  },
  {
    "Retail Branding": "SK Telesys",
    "Marketing Name": "EG980",
    "Device": "eg980tw",
    "Model": "EG980"
  },
  {
    "Retail Branding": "SK Telesys",
    "Marketing Name": "Fly",
    "Device": "htt77_ics2",
    "Model": "Fly"
  },
  {
    "Retail Branding": "SK Telesys",
    "Marketing Name": "ITP-E410W",
    "Device": "willow",
    "Model": "ITP-E410W"
  },
  {
    "Retail Branding": "SK Telesys",
    "Marketing Name": "ITP-R208W",
    "Device": "rk30sdk",
    "Model": "ITP-R208W"
  },
  {
    "Retail Branding": "SK Telesys",
    "Marketing Name": "Ice-Phone Forever",
    "Device": "z262_wvga_mge",
    "Model": "Ice-Phone Forever"
  },
  {
    "Retail Branding": "SK Telesys",
    "Marketing Name": "K2401",
    "Device": "K2401",
    "Model": "S201"
  },
  {
    "Retail Branding": "SK Telesys",
    "Marketing Name": "S150",
    "Device": "msm8255_k5",
    "Model": "S150"
  },
  {
    "Retail Branding": "SK Telesys",
    "Marketing Name": "T720",
    "Device": "T720",
    "Model": "Clear"
  },
  {
    "Retail Branding": "SK Telesys",
    "Marketing Name": "UTA200",
    "Device": "htt75_nand_6628_ics",
    "Model": "UTA200"
  },
  {
    "Retail Branding": "SK Telesys",
    "Marketing Name": "WA966",
    "Device": "u966e_2",
    "Model": "WA966"
  },
  {
    "Retail Branding": "SK Telesys",
    "Marketing Name": "WA978",
    "Device": "u978e_1",
    "Model": "WA978"
  },
  {
    "Retail Branding": "SK Telesys",
    "Marketing Name": "icube-830",
    "Device": "icube-830",
    "Model": "icube-830"
  },
  {
    "Retail Branding": "SK broadband",
    "Marketing Name": "AI2",
    "Device": "BIP-AI100",
    "Model": "BIP-AI100"
  },
  {
    "Retail Branding": "SK broadband",
    "Marketing Name": "AI2 ATV",
    "Device": "INTEKS21SI",
    "Model": "BID-AI100"
  },
  {
    "Retail Branding": "SK broadband",
    "Marketing Name": "BFX-AT100",
    "Device": "BFX-AT100",
    "Model": "BFX-AT100"
  },
  {
    "Retail Branding": "SK broadband",
    "Marketing Name": "BKO-UC500",
    "Device": "K1100UA",
    "Model": "BKO-UC500"
  },
  {
    "Retail Branding": "SK broadband",
    "Marketing Name": "BMA-AI100",
    "Device": "BMA-AI100",
    "Model": "BMA-AI100"
  },
  {
    "Retail Branding": "SK broadband",
    "Marketing Name": "PlayZ",
    "Device": "BIP-EB100",
    "Model": "BIP-EB100"
  },
  {
    "Retail Branding": "SK broadband",
    "Marketing Name": "SMART3",
    "Device": "INTEKS20SI",
    "Model": "BID-AT200"
  },
  {
    "Retail Branding": "SK broadband",
    "Marketing Name": "Smart3 Mini",
    "Device": "BIP-UW200",
    "Model": "BIP-UW200"
  },
  {
    "Retail Branding": "SKY EVO",
    "Marketing Name": "Elite L55",
    "Device": "Elite_L55",
    "Model": "Elite L55"
  },
  {
    "Retail Branding": "SKY EVO",
    "Marketing Name": "Elite OctaPlus",
    "Device": "Elite_OctaPlus",
    "Model": "Elite OctaPlus"
  },
  {
    "Retail Branding": "SKY EVO",
    "Marketing Name": "Elite OctaPlus",
    "Device": "Elite_OctaPlus3us",
    "Model": "ELITE_Octaplus"
  },
  {
    "Retail Branding": "SKY EVO",
    "Marketing Name": "Elite OctaPlus",
    "Device": "Elite_OctaPlusa2",
    "Model": "Elite OctaPlus"
  },
  {
    "Retail Branding": "SKY EVO",
    "Marketing Name": "Elite OctaX",
    "Device": "Elite_OctaXK2",
    "Model": "Elite OctaX"
  },
  {
    "Retail Branding": "SKY EVO",
    "Marketing Name": "Elite_OctaXS",
    "Device": "Elite_OctaXS",
    "Model": "Elite_OctaXS"
  },
  {
    "Retail Branding": "SKY EVO",
    "Marketing Name": "SA100",
    "Device": "HY40A",
    "Model": "SA100"
  },
  {
    "Retail Branding": "SKY Perfect JSAT",
    "Marketing Name": "SKP-IS401",
    "Device": "SKP-IS401",
    "Model": "SKP-IS401"
  },
  {
    "Retail Branding": "SKYEGG",
    "Marketing Name": "K11_EEA",
    "Device": "K11_EEA",
    "Model": "K11_EEA"
  },
  {
    "Retail Branding": "SKYEGG",
    "Marketing Name": "K11_US",
    "Device": "K11_US",
    "Model": "K11_US"
  },
  {
    "Retail Branding": "SKYEGG",
    "Marketing Name": "K13-U-EEA",
    "Device": "K13-U-EEA",
    "Model": "K13-EEA"
  },
  {
    "Retail Branding": "SKYEGG",
    "Marketing Name": "K13-U-EEA",
    "Device": "K13-U-EEA",
    "Model": "K13-U-EEA"
  },
  {
    "Retail Branding": "SKYEGG",
    "Marketing Name": "K13-U-US",
    "Device": "K13-U-US",
    "Model": "K13-U-US"
  },
  {
    "Retail Branding": "SKYEGG",
    "Marketing Name": "K13-U-US",
    "Device": "K13-U-US",
    "Model": "K13-US"
  },
  {
    "Retail Branding": "SKYEGG",
    "Marketing Name": "K13_EEA",
    "Device": "K13_EEA",
    "Model": "K13_EEA"
  },
  {
    "Retail Branding": "SKYEGG",
    "Marketing Name": "K13_US",
    "Device": "K13_US",
    "Model": "K13_US"
  },
  {
    "Retail Branding": "SKYEGG",
    "Marketing Name": "K15_EEA",
    "Device": "K15_EEA",
    "Model": "K15_EEA"
  },
  {
    "Retail Branding": "SKYEGG",
    "Marketing Name": "K15_US",
    "Device": "K15_US",
    "Model": "K15_US"
  },
  {
    "Retail Branding": "SKYEGG",
    "Marketing Name": "K16_US",
    "Device": "K16_US",
    "Model": "K16_US"
  },
  {
    "Retail Branding": "SKYEGG",
    "Marketing Name": "X2_S_EEA",
    "Device": "X2_EEA",
    "Model": "X2_EEA"
  },
  {
    "Retail Branding": "SKYEGG",
    "Marketing Name": "X2_S_EEA",
    "Device": "X2_EEA",
    "Model": "X2_S_EEA"
  },
  {
    "Retail Branding": "SKYEGG",
    "Marketing Name": "X2_S_US",
    "Device": "X2_US",
    "Model": "X2_S_US"
  },
  {
    "Retail Branding": "SKYEGG",
    "Marketing Name": "X2_S_US",
    "Device": "X2_US",
    "Model": "X2_US"
  },
  {
    "Retail Branding": "SKY_Brasil",
    "Marketing Name": "EV-9157-ISDBT",
    "Device": "EV-9157-ISDBT",
    "Model": "EV-9157-ISDBT"
  },
  {
    "Retail Branding": "SKY_Brasil",
    "Marketing Name": "Sky Brazil",
    "Device": "usw8052skb",
    "Model": "SKR02"
  },
  {
    "Retail Branding": "SLIDER",
    "Marketing Name": "S1000",
    "Device": "S1000",
    "Model": "S1000"
  },
  {
    "Retail Branding": "SLIDER",
    "Marketing Name": "S1000",
    "Device": "S1000",
    "Model": "TAB PRO 14"
  },
  {
    "Retail Branding": "SLIDER",
    "Marketing Name": "S800",
    "Device": "S800",
    "Model": "S800"
  },
  {
    "Retail Branding": "SMART +",
    "Marketing Name": "S40_PLUS",
    "Device": "S40_PLUS",
    "Model": "Smartplus"
  },
  {
    "Retail Branding": "SMART TECHNOLOGY",
    "Marketing Name": "Airpro4KS",
    "Device": "halandri",
    "Model": "Airpro4KS"
  },
  {
    "Retail Branding": "SMART TECHNOLOGY",
    "Marketing Name": "Smart TV",
    "Device": "alimos",
    "Model": "Google TV"
  },
  {
    "Retail Branding": "SMART TECHNOLOGY",
    "Marketing Name": "Smart TV",
    "Device": "osaka",
    "Model": "Google TV"
  },
  {
    "Retail Branding": "SMART Technologies",
    "Marketing Name": "AM60 series",
    "Device": "komodo",
    "Model": "AM60 series"
  },
  {
    "Retail Branding": "SMART Technologies",
    "Marketing Name": "AM60 series",
    "Device": "komodo",
    "Model": "SMART AM60"
  },
  {
    "Retail Branding": "SMART Technologies",
    "Marketing Name": "AMG1",
    "Device": "komodo",
    "Model": "AMG series"
  },
  {
    "Retail Branding": "SMART Technologies",
    "Marketing Name": "GX1xxG-V4",
    "Device": "sorbet",
    "Model": "SMART Board GX (V4) Plus Series"
  },
  {
    "Retail Branding": "SMART Technologies",
    "Marketing Name": "SMART AMG series",
    "Device": "komodo",
    "Model": "SMART AMG1"
  },
  {
    "Retail Branding": "SMART Technologies",
    "Marketing Name": "SMART Board MX Series (V5)",
    "Device": "groundhog",
    "Model": "SMART Board MX Series (V5)"
  },
  {
    "Retail Branding": "SMART Technologies",
    "Marketing Name": "SMART Board® RX Series",
    "Device": "groundhog",
    "Model": "SMART Board Interactive Display"
  },
  {
    "Retail Branding": "SMART Technologies",
    "Marketing Name": "gxv4na",
    "Device": "sherbet",
    "Model": "SMART Board GX (V4) Plus Series NA"
  },
  {
    "Retail Branding": "SMART_KASSEL",
    "Marketing Name": "ARGENTINA",
    "Device": "SK3402",
    "Model": "SK3402"
  },
  {
    "Retail Branding": "SMART_KASSEL",
    "Marketing Name": "SK-5503AR",
    "Device": "SK-5503AR",
    "Model": "SK-5503AR"
  },
  {
    "Retail Branding": "SMART_KASSEL",
    "Marketing Name": "SK3403",
    "Device": "SK3403",
    "Model": "SK3403"
  },
  {
    "Retail Branding": "SMART_KASSEL",
    "Marketing Name": "SK3404",
    "Device": "SK3404",
    "Model": "SK3404"
  },
  {
    "Retail Branding": "SMART_KASSEL",
    "Marketing Name": "SK3405",
    "Device": "SK3405",
    "Model": "SK3405"
  },
  {
    "Retail Branding": "SMART_KASSEL",
    "Marketing Name": "SK3501",
    "Device": "SK3501",
    "Model": "SK3501"
  },
  {
    "Retail Branding": "SMART_KASSEL",
    "Marketing Name": "SK5501",
    "Device": "SK5501",
    "Model": "SK5501"
  },
  {
    "Retail Branding": "SMART_KASSEL",
    "Marketing Name": "SK5502",
    "Device": "SK5502",
    "Model": "SK5502"
  },
  {
    "Retail Branding": "SMART_VISSION",
    "Marketing Name": "SMART_VISSION_IFP_Series",
    "Device": "IFP_Series",
    "Model": "SMART_VISSION"
  },
  {
    "Retail Branding": "SMB Gadgets",
    "Marketing Name": "SMB8112BK",
    "Device": "SMB8112BK",
    "Model": "SMB8112BK"
  },
  {
    "Retail Branding": "SMT_LW",
    "Marketing Name": "CRUSH X565",
    "Device": "CRUSH_X565",
    "Model": "CRUSH_X565"
  },
  {
    "Retail Branding": "SMT_LW",
    "Marketing Name": "X450",
    "Device": "X450",
    "Model": "X450-Locked to Life Wireless"
  },
  {
    "Retail Branding": "SMT_SN",
    "Marketing Name": "CRUSH X565",
    "Device": "CRUSH_X565",
    "Model": "CRUSH_X565"
  },
  {
    "Retail Branding": "SMT_SN",
    "Marketing Name": "CRUSH_X565",
    "Device": "CRUSH_X565",
    "Model": "CRUSH_X565"
  },
  {
    "Retail Branding": "SMT_TSC",
    "Marketing Name": "BLAZE X500",
    "Device": "BLAZE_X500",
    "Model": "BLAZE_X500"
  },
  {
    "Retail Branding": "SMT_TSC",
    "Marketing Name": "CRUSH_X565",
    "Device": "CRUSH_X565",
    "Model": "CRUSH_X565"
  },
  {
    "Retail Branding": "SMT_TSC",
    "Marketing Name": "FLAME X555",
    "Device": "FLAME_X555",
    "Model": "FLAME_X555"
  },
  {
    "Retail Branding": "SMV",
    "Marketing Name": "SMV_3588",
    "Device": "SMV_3588",
    "Model": "SMV_3588"
  },
  {
    "Retail Branding": "SOHO STYLE",
    "Marketing Name": "S1582C",
    "Device": "S1582C",
    "Model": "S1582C"
  },
  {
    "Retail Branding": "SOHO STYLE",
    "Marketing Name": "S1586K",
    "Device": "S1586K",
    "Model": "S1586K"
  },
  {
    "Retail Branding": "SOHO STYLE",
    "Marketing Name": "S1587K",
    "Device": "S1587K",
    "Model": "S1587K"
  },
  {
    "Retail Branding": "SOHO STYLE",
    "Marketing Name": "S65",
    "Device": "S65",
    "Model": "S65"
  },
  {
    "Retail Branding": "SOHO STYLE",
    "Marketing Name": "S6561",
    "Device": "S6561",
    "Model": "S6561"
  },
  {
    "Retail Branding": "SOHO STYLE",
    "Marketing Name": "SS5214G",
    "Device": "SS5214G",
    "Model": "SS5214G"
  },
  {
    "Retail Branding": "SOHO STYLE",
    "Marketing Name": "SS5314G",
    "Device": "SS5314G",
    "Model": "SS5314G"
  },
  {
    "Retail Branding": "SOHO STYLE",
    "Marketing Name": "SS5414G",
    "Device": "SS5414G",
    "Model": "SS5414G"
  },
  {
    "Retail Branding": "SOHO STYLE",
    "Marketing Name": "SS5424G",
    "Device": "SS5424G",
    "Model": "SS5424G"
  },
  {
    "Retail Branding": "SOHO STYLE",
    "Marketing Name": "SS5514G",
    "Device": "SS5514G",
    "Model": "SS5514G"
  },
  {
    "Retail Branding": "SOHO STYLE",
    "Marketing Name": "SS5524G",
    "Device": "SS5524G",
    "Model": "SS5524G"
  },
  {
    "Retail Branding": "SOHO STYLE",
    "Marketing Name": "SS5539G",
    "Device": "SS5539G",
    "Model": "SS5539G"
  },
  {
    "Retail Branding": "SOHO STYLE",
    "Marketing Name": "SS650G",
    "Device": "SS650G",
    "Model": "SS650G"
  },
  {
    "Retail Branding": "SOLITAIRE",
    "Marketing Name": "Solitaire_SLTR_XXi_Series",
    "Device": "IFPD",
    "Model": "Solitaire_SLTR_XXi_Series"
  },
  {
    "Retail Branding": "SOLO",
    "Marketing Name": "Inspire_U5",
    "Device": "Inspire_U5",
    "Model": "Inspire_U5"
  },
  {
    "Retail Branding": "SOLO",
    "Marketing Name": "Inspire_U5_PLUS",
    "Device": "Inspire_U5_PLUS",
    "Model": "Inspire_U5_PLUS"
  },
  {
    "Retail Branding": "SOLSLife",
    "Marketing Name": "RRS12",
    "Device": "RRS12",
    "Model": "RRS12"
  },
  {
    "Retail Branding": "SORIANA",
    "Marketing Name": "BE_ets",
    "Device": "BE_ets",
    "Model": "BE_ets"
  },
  {
    "Retail Branding": "SOSMART",
    "Marketing Name": "T5",
    "Device": "SOSMART_T5",
    "Model": "SOSMART_T5"
  },
  {
    "Retail Branding": "SOUTH",
    "Marketing Name": "H6LM",
    "Device": "H6LM",
    "Model": "H6LM"
  },
  {
    "Retail Branding": "SOWLY",
    "Marketing Name": "AG_1088_A133",
    "Device": "AG_1088_A133",
    "Model": "AG_1088_A133"
  },
  {
    "Retail Branding": "SOWLY",
    "Marketing Name": "AG_1088_A133P",
    "Device": "AG_1088_A133P",
    "Model": "AG_1088_A133P"
  },
  {
    "Retail Branding": "SOWLY",
    "Marketing Name": "AG_1088_A523P",
    "Device": "AG_1088_A523P",
    "Model": "AG_1088_A523P"
  },
  {
    "Retail Branding": "SPC",
    "Marketing Name": "DISCOVERY_2_EEA",
    "Device": "DISCOVERY_2",
    "Model": "DISCOVERY_2"
  },
  {
    "Retail Branding": "SPC",
    "Marketing Name": "DISCOVERY_2_ME_EEA",
    "Device": "DISCOVERY_2_ME",
    "Model": "DISCOVERY_2_ME"
  },
  {
    "Retail Branding": "SPC",
    "Marketing Name": "DISCOVERY_3",
    "Device": "DISCOVERY_3",
    "Model": "DISCOVERY 3"
  },
  {
    "Retail Branding": "SPC",
    "Marketing Name": "DISCOVERY_3_PRO_EEA",
    "Device": "DISCOVERY_3_PRO",
    "Model": "DISCOVERY 3 PRO"
  },
  {
    "Retail Branding": "SPC",
    "Marketing Name": "Discovery",
    "Device": "Discovery",
    "Model": "Discovery"
  },
  {
    "Retail Branding": "SPC",
    "Marketing Name": "Discovery Pro",
    "Device": "Discovery_Pro",
    "Model": "Discovery Pro"
  },
  {
    "Retail Branding": "SPC",
    "Marketing Name": "Discovery SE",
    "Device": "Discovery_SE",
    "Model": "Discovery SE"
  },
  {
    "Retail Branding": "SPC",
    "Marketing Name": "EB PRO MAX",
    "Device": "EB_PRO_MAX_2",
    "Model": "EB_PRO_MAX_2"
  },
  {
    "Retail Branding": "SPC",
    "Marketing Name": "EU、UK、AP",
    "Device": "martin",
    "Model": "SPC Android TV"
  },
  {
    "Retail Branding": "SPC",
    "Marketing Name": "GRAVITY-2",
    "Device": "GRAVITY-2",
    "Model": "GRAVITY 2"
  },
  {
    "Retail Branding": "SPC",
    "Marketing Name": "GRAVITY-PRO-2",
    "Device": "GRAVITY-PRO-2",
    "Model": "GRAVITY PRO 2"
  },
  {
    "Retail Branding": "SPC",
    "Marketing Name": "GRAVITY-SE",
    "Device": "GRAVITY-SE",
    "Model": "GRAVITY SE"
  },
  {
    "Retail Branding": "SPC",
    "Marketing Name": "GRAVITY-ULTIMATE-2",
    "Device": "GRAVITY-ULTIMATE-2",
    "Model": "GRAVITY ULTIMATE 2"
  },
  {
    "Retail Branding": "SPC",
    "Marketing Name": "GRAVITY_3",
    "Device": "GRAVITY_3",
    "Model": "GRAVITY_3"
  },
  {
    "Retail Branding": "SPC",
    "Marketing Name": "GRAVITY_3_MINI",
    "Device": "GRAVITY_3_MINI",
    "Model": "GRAVITY_3_MINI"
  },
  {
    "Retail Branding": "SPC",
    "Marketing Name": "GRAVITY_3_PRO",
    "Device": "GRAVITY_3_PRO",
    "Model": "GRAVITY 3 PRO"
  },
  {
    "Retail Branding": "SPC",
    "Marketing Name": "GRAVITY_3_SE",
    "Device": "GRAVITY_3_SE",
    "Model": "GRAVITY_3_SE"
  },
  {
    "Retail Branding": "SPC",
    "Marketing Name": "GRAVITY_4",
    "Device": "GRAVITY_4",
    "Model": "GRAVITY_4"
  },
  {
    "Retail Branding": "SPC",
    "Marketing Name": "GRAVITY_4_PLUS",
    "Device": "GRAVITY_4_PLUS",
    "Model": "GRAVITY_4_PLUS"
  },
  {
    "Retail Branding": "SPC",
    "Marketing Name": "GRAVITY_5_EEA",
    "Device": "GRAVITY_5_EEA",
    "Model": "GRAVITY_5_EEA"
  },
  {
    "Retail Branding": "SPC",
    "Marketing Name": "GRAVITY_5_PRO",
    "Device": "GRAVITY_5_PRO",
    "Model": "GRAVITY 5 PRO"
  },
  {
    "Retail Branding": "SPC",
    "Marketing Name": "GRAVITY_5_SE_EEA",
    "Device": "GRAVITY_5_SE_EEA",
    "Model": "GRAVITY 5 SE"
  },
  {
    "Retail Branding": "SPC",
    "Marketing Name": "GRAVITY_6_10_EEA",
    "Device": "GRAVITY_6_10",
    "Model": "GRAVITY"
  },
  {
    "Retail Branding": "SPC",
    "Marketing Name": "GRAVITY_6_11_EEA",
    "Device": "GRAVITY_6_11",
    "Model": "GRAVITY"
  },
  {
    "Retail Branding": "SPC",
    "Marketing Name": "GRAVITY_6_PRO_11_EEA",
    "Device": "GRAVITY_6_PRO_11",
    "Model": "GRAVITY PRO"
  },
  {
    "Retail Branding": "SPC",
    "Marketing Name": "GRAVITY_6_PRO_12_EEA",
    "Device": "GRAVITY_6_PRO_12",
    "Model": "GRAVITY PRO"
  },
  {
    "Retail Branding": "SPC",
    "Marketing Name": "GRAVITY_6_SE_11_EEA",
    "Device": "GRAVITY_6_SE_11",
    "Model": "GRAVITY 6 SE 11"
  },
  {
    "Retail Branding": "SPC",
    "Marketing Name": "GRAVITY_7_11_EEA",
    "Device": "GRAVITY_7_11",
    "Model": "GRAVITY"
  },
  {
    "Retail Branding": "SPC",
    "Marketing Name": "Gravity_Max_EEA",
    "Device": "Gravity_Max",
    "Model": "Gravity Max"
  },
  {
    "Retail Branding": "SPC",
    "Marketing Name": "Indonesia",
    "Device": "guandu",
    "Model": "SPC Android TV"
  },
  {
    "Retail Branding": "SPC",
    "Marketing Name": "L80W",
    "Device": "L80W",
    "Model": "L80W"
  },
  {
    "Retail Branding": "SPC",
    "Marketing Name": "LIGHTYEAR-2",
    "Device": "LIGHTYEAR-2",
    "Model": "LIGHTYEAR 2"
  },
  {
    "Retail Branding": "SPC",
    "Marketing Name": "LIGHTYEAR-PRO-2",
    "Device": "LIGHTYEAR-PRO-2",
    "Model": "LIGHTYEAR PRO 2"
  },
  {
    "Retail Branding": "SPC",
    "Marketing Name": "LUMACORE_MEETING",
    "Device": "LUMACORE_MEETING",
    "Model": "LUMACORE_MEETING"
  },
  {
    "Retail Branding": "SPC",
    "Marketing Name": "SMART  2",
    "Device": "SMART_2",
    "Model": "SMART 2"
  },
  {
    "Retail Branding": "SPC",
    "Marketing Name": "SMART 3",
    "Device": "SMART_3",
    "Model": "SMART 3"
  },
  {
    "Retail Branding": "SPC",
    "Marketing Name": "SMART_MAX_2",
    "Device": "SMART_MAX_2",
    "Model": "SMART_MAX_2"
  },
  {
    "Retail Branding": "SPC",
    "Marketing Name": "SMART_PLUS_2",
    "Device": "SMART_PLUS_2",
    "Model": "SMART_PLUS_2"
  },
  {
    "Retail Branding": "SPC",
    "Marketing Name": "SMART_PRO",
    "Device": "SMART_PRO",
    "Model": "SMART_PRO"
  },
  {
    "Retail Branding": "SPC",
    "Marketing Name": "SMART_PRO",
    "Device": "SMART_PRO_EEA",
    "Model": "SMART_PRO"
  },
  {
    "Retail Branding": "SPC",
    "Marketing Name": "SMART_ULTIMATE",
    "Device": "SMART_ULTIMATE",
    "Model": "SMART_ULTIMATE"
  },
  {
    "Retail Branding": "SPC",
    "Marketing Name": "US",
    "Device": "martin",
    "Model": "SPC Android Monitor"
  },
  {
    "Retail Branding": "SPC",
    "Marketing Name": "WUUM S",
    "Device": "Discovery",
    "Model": "Discovery"
  },
  {
    "Retail Branding": "SPC",
    "Marketing Name": "WUUM_S_PRO_EEA",
    "Device": "DISCOVERY_2",
    "Model": "WUUM S PRO"
  },
  {
    "Retail Branding": "SPC",
    "Marketing Name": "WUUM_TAB_EEA",
    "Device": "WUUM_TAB",
    "Model": "WUUM TAB"
  },
  {
    "Retail Branding": "SPC",
    "Marketing Name": "ZEUS 2",
    "Device": "ZEUS_2",
    "Model": "ZEUS 2"
  },
  {
    "Retail Branding": "SPC",
    "Marketing Name": "ZEUS 2 PRO",
    "Device": "ZEUS_2_PRO",
    "Model": "ZEUS 2 PRO"
  },
  {
    "Retail Branding": "SPC Mobile",
    "Marketing Name": "APOLO",
    "Device": "APOLO",
    "Model": "APOLO"
  },
  {
    "Retail Branding": "SPC Mobile",
    "Marketing Name": "GRAVITY-2-MAX",
    "Device": "GRAVITY-2-MAX",
    "Model": "GRAVITY-2-MAX"
  },
  {
    "Retail Branding": "SPC Mobile",
    "Marketing Name": "GRAVITY2-4G",
    "Device": "GRAVITY2-4G",
    "Model": "GRAVITY2-4G"
  },
  {
    "Retail Branding": "SPC Mobile",
    "Marketing Name": "GRAVITY_3G_2019_eea",
    "Device": "GRAVITY_3G",
    "Model": "GRAVITY 3G_2019"
  },
  {
    "Retail Branding": "SPC Mobile",
    "Marketing Name": "GRAVITY_3_4G",
    "Device": "GRAVITY_3_4G",
    "Model": "GRAVITY 3 4G"
  },
  {
    "Retail Branding": "SPC Mobile",
    "Marketing Name": "L100",
    "Device": "L100",
    "Model": "L100"
  },
  {
    "Retail Branding": "SPC Mobile",
    "Marketing Name": "L50",
    "Device": "SPC_L50",
    "Model": "L50"
  },
  {
    "Retail Branding": "SPC Mobile",
    "Marketing Name": "L50E",
    "Device": "L50E",
    "Model": "SPC L50E"
  },
  {
    "Retail Branding": "SPC Mobile",
    "Marketing Name": "L51 BLITZ",
    "Device": "L51",
    "Model": "L51"
  },
  {
    "Retail Branding": "SPC Mobile",
    "Marketing Name": "L51 PRO",
    "Device": "L51_Pro",
    "Model": "L51 Pro"
  },
  {
    "Retail Branding": "SPC Mobile",
    "Marketing Name": "L52 PRO",
    "Device": "L52_Pro",
    "Model": "L52 Pro"
  },
  {
    "Retail Branding": "SPC Mobile",
    "Marketing Name": "L52 STEEL+",
    "Device": "L52",
    "Model": "L52"
  },
  {
    "Retail Branding": "SPC Mobile",
    "Marketing Name": "L52F",
    "Device": "L52F",
    "Model": "L52F"
  },
  {
    "Retail Branding": "SPC Mobile",
    "Marketing Name": "L52X",
    "Device": "SPC_L52X",
    "Model": "L52X"
  },
  {
    "Retail Branding": "SPC Mobile",
    "Marketing Name": "L53",
    "Device": "L53",
    "Model": "L53"
  },
  {
    "Retail Branding": "SPC Mobile",
    "Marketing Name": "L54",
    "Device": "L54",
    "Model": "L54"
  },
  {
    "Retail Branding": "SPC Mobile",
    "Marketing Name": "L55",
    "Device": "L55",
    "Model": "L55"
  },
  {
    "Retail Branding": "SPC Mobile",
    "Marketing Name": "L56",
    "Device": "L56",
    "Model": "L56"
  },
  {
    "Retail Branding": "SPC Mobile",
    "Marketing Name": "L60",
    "Device": "L60",
    "Model": "L60"
  },
  {
    "Retail Branding": "SPC Mobile",
    "Marketing Name": "L60",
    "Device": "SPC_L60",
    "Model": "L60"
  },
  {
    "Retail Branding": "SPC Mobile",
    "Marketing Name": "L60 Pro",
    "Device": "L60_Pro",
    "Model": "L60 Pro"
  },
  {
    "Retail Branding": "SPC Mobile",
    "Marketing Name": "L60 Turbo",
    "Device": "L60_Turbo",
    "Model": "L60 Turbo"
  },
  {
    "Retail Branding": "SPC Mobile",
    "Marketing Name": "L70_Lite",
    "Device": "L70_Lite",
    "Model": "L70_Lite"
  },
  {
    "Retail Branding": "SPC Mobile",
    "Marketing Name": "L70_PRO",
    "Device": "L70_PRO",
    "Model": "L70_PRO"
  },
  {
    "Retail Branding": "SPC Mobile",
    "Marketing Name": "L80",
    "Device": "L80",
    "Model": "L80"
  },
  {
    "Retail Branding": "SPC Mobile",
    "Marketing Name": "L80_S",
    "Device": "L80_S",
    "Model": "L80_S"
  },
  {
    "Retail Branding": "SPC Mobile",
    "Marketing Name": "LIGHTYEAR2-4G",
    "Device": "LIGHTYEAR2-4G",
    "Model": "LIGHTYEAR2-4G"
  },
  {
    "Retail Branding": "SPC Mobile",
    "Marketing Name": "Lightyear",
    "Device": "Lightyear",
    "Model": "Lightyear"
  },
  {
    "Retail Branding": "SPC Mobile",
    "Marketing Name": "S19",
    "Device": "S19",
    "Model": "S19"
  },
  {
    "Retail Branding": "SPC Mobile",
    "Marketing Name": "X1",
    "Device": "SPC_X1",
    "Model": "X1"
  },
  {
    "Retail Branding": "SPC Mobile",
    "Marketing Name": "X3",
    "Device": "SPC_X3",
    "Model": "X3"
  },
  {
    "Retail Branding": "SPC Mobile",
    "Marketing Name": "X5",
    "Device": "X5",
    "Model": "X5"
  },
  {
    "Retail Branding": "SPC Universe",
    "Marketing Name": "Blink_10_1",
    "Device": "Blink_10_1",
    "Model": "Blink 10.1"
  },
  {
    "Retail Branding": "SPC Universe",
    "Marketing Name": "FLOW_7",
    "Device": "FLOW_7",
    "Model": "FLOW 7"
  },
  {
    "Retail Branding": "SPC Universe",
    "Marketing Name": "GRAVITY",
    "Device": "GRAVITY",
    "Model": "GRAVITY"
  },
  {
    "Retail Branding": "SPC Universe",
    "Marketing Name": "GRAVITY3G",
    "Device": "GRAVITY3G",
    "Model": "GRAVITY 3G"
  },
  {
    "Retail Branding": "SPC Universe",
    "Marketing Name": "GRAVITY4G",
    "Device": "GRAVITY4G",
    "Model": "GRAVITY 4G"
  },
  {
    "Retail Branding": "SPC Universe",
    "Marketing Name": "GRAVITY_ PRO",
    "Device": "GRAVITY_PRO",
    "Model": "GRAVITY PRO"
  },
  {
    "Retail Branding": "SPC Universe",
    "Marketing Name": "GRAVITY_4G_2019_eea",
    "Device": "GRAVITY_4G",
    "Model": "GRAVITY 4G_2019"
  },
  {
    "Retail Branding": "SPC Universe",
    "Marketing Name": "GRAVITY_OCTACORE",
    "Device": "GRAVITY_OCTACORE",
    "Model": "GRAVITY_OCTACORE"
  },
  {
    "Retail Branding": "SPC Universe",
    "Marketing Name": "Gravity_2019",
    "Device": "GRAVITY_2019",
    "Model": "GRAVITY_2019"
  },
  {
    "Retail Branding": "SPC Universe",
    "Marketing Name": "Gravity_Max",
    "Device": "Gravity_Max",
    "Model": "Gravity Max"
  },
  {
    "Retail Branding": "SPC Universe",
    "Marketing Name": "LAIKA",
    "Device": "LAIKA",
    "Model": "LAIKA"
  },
  {
    "Retail Branding": "SPC Universe",
    "Marketing Name": "Laika",
    "Device": "Laika",
    "Model": "Laika"
  },
  {
    "Retail Branding": "SPC Universe",
    "Marketing Name": "Lightyear",
    "Device": "Lightyear",
    "Model": "Lightyear"
  },
  {
    "Retail Branding": "SPC Universe",
    "Marketing Name": "SMART_3",
    "Device": "SMART_3",
    "Model": "SMART_3"
  },
  {
    "Retail Branding": "SPC Universe",
    "Marketing Name": "SMART_MAX_3",
    "Device": "SMART_MAX_3",
    "Model": "SMART_MAX_3"
  },
  {
    "Retail Branding": "SPC Universe",
    "Marketing Name": "SPC GEN",
    "Device": "SPC_GEN",
    "Model": "SPC GEN"
  },
  {
    "Retail Branding": "SPC Universe",
    "Marketing Name": "SPC GEN LITE",
    "Device": "SPC_GEN_LITE",
    "Model": "SPC GEN LITE"
  },
  {
    "Retail Branding": "SPC Universe",
    "Marketing Name": "SPC GEN MAX",
    "Device": "SPC_GEN_MAX",
    "Model": "SPC GEN MAX"
  },
  {
    "Retail Branding": "SPC Universe",
    "Marketing Name": "SPC GEN PLUS",
    "Device": "SPC_GEN_PLUS",
    "Model": "SPC GEN PLUS"
  },
  {
    "Retail Branding": "SPC Universe",
    "Marketing Name": "SPC SMART",
    "Device": "SPC_SMART",
    "Model": "SPC SMART"
  },
  {
    "Retail Branding": "SPC Universe",
    "Marketing Name": "SPC SMART LITE",
    "Device": "SPC_SMART_LITE",
    "Model": "SPC SMART LITE"
  },
  {
    "Retail Branding": "SPC Universe",
    "Marketing Name": "SPC SMART MAX",
    "Device": "SPC_SMART_MAX",
    "Model": "SPC SMART MAX"
  },
  {
    "Retail Branding": "SPC Universe",
    "Marketing Name": "SPC SMART PLUS",
    "Device": "SPC_SMART_PLUS",
    "Model": "SPC SMART PLUS"
  },
  {
    "Retail Branding": "SPC Universe",
    "Marketing Name": "ZEUS_4G",
    "Device": "ZEUS_4G",
    "Model": "ZEUS_4G"
  },
  {
    "Retail Branding": "SPC Universe",
    "Marketing Name": "ZEUS_4G_PRO",
    "Device": "ZEUS_4G_PRO",
    "Model": "ZEUS_4G_PRO"
  },
  {
    "Retail Branding": "SPC Universe",
    "Marketing Name": "heaven_10_1",
    "Device": "heaven-10_1",
    "Model": "HEAVEN 10.1"
  },
  {
    "Retail Branding": "SPECTRA",
    "Marketing Name": "Cell_C",
    "Device": "Spectra_J2",
    "Model": "Spectra_J2"
  },
  {
    "Retail Branding": "SPECTRA",
    "Marketing Name": "Cell_C_Pro",
    "Device": "Spectra_J2_Pro",
    "Model": "Spectra_J2_Pro"
  },
  {
    "Retail Branding": "SPECTRA",
    "Marketing Name": "Ranger710",
    "Device": "akita",
    "Model": "Ranger710"
  },
  {
    "Retail Branding": "SPECTRA",
    "Marketing Name": "SALT X5",
    "Device": "Spectra_J2",
    "Model": "Spectra_J2"
  },
  {
    "Retail Branding": "SPECTRA",
    "Marketing Name": "Spectra J2",
    "Device": "Spectra_J2",
    "Model": "Spectra_J2"
  },
  {
    "Retail Branding": "SPECTRA",
    "Marketing Name": "Spectra J2 MTN",
    "Device": "Spectra_J2_MTN",
    "Model": "Spectra_J2_MTN"
  },
  {
    "Retail Branding": "SPECTRA",
    "Marketing Name": "Spectra J2 Pro",
    "Device": "Spectra_J2_Pro_MTN",
    "Model": "Spectra_J2_Pro"
  },
  {
    "Retail Branding": "SPECTRA",
    "Marketing Name": "Spectra J2 Pro",
    "Device": "Spectra_J2_Pro_VC",
    "Model": "Spectra_J2_Pro"
  },
  {
    "Retail Branding": "SPECTRA",
    "Marketing Name": "Spectra MobileMapper6",
    "Device": "MobileMapper6",
    "Model": "MobileMapper6"
  },
  {
    "Retail Branding": "SPECTRA",
    "Marketing Name": "TAP-POS",
    "Device": "TAP-POS",
    "Model": "SAH55"
  },
  {
    "Retail Branding": "SPECTRA",
    "Marketing Name": "ZCM Z1",
    "Device": "ZCM_Z1",
    "Model": "ZCM_Z1"
  },
  {
    "Retail Branding": "SPECTRA",
    "Marketing Name": "ZCM Z1 Pro",
    "Device": "ZCM_Z1_Pro",
    "Model": "ZCM_Z1_Pro"
  },
  {
    "Retail Branding": "SPECTRA",
    "Marketing Name": "tap-POS-AM",
    "Device": "tap-POS-AM",
    "Model": "SAH55AM"
  },
  {
    "Retail Branding": "SPEEDSTAR",
    "Marketing Name": "StarTab_A324G",
    "Device": "StarTab_A324G",
    "Model": "StarTab-A324G"
  },
  {
    "Retail Branding": "SPJtv",
    "Marketing Name": "Android TV",
    "Device": "R1",
    "Model": "ATV R1"
  },
  {
    "Retail Branding": "SPJtv",
    "Marketing Name": "Android TV",
    "Device": "R2",
    "Model": "ATV R2"
  },
  {
    "Retail Branding": "SPJtv",
    "Marketing Name": "R3",
    "Device": "R3",
    "Model": "R3"
  },
  {
    "Retail Branding": "SPJtv",
    "Marketing Name": "R4",
    "Device": "R4",
    "Model": "R4"
  },
  {
    "Retail Branding": "SPRANGE",
    "Marketing Name": "M20_PLUS",
    "Device": "M20_PLUS",
    "Model": "M20 PLUS"
  },
  {
    "Retail Branding": "SPRANGE",
    "Marketing Name": "M30_PLUS",
    "Device": "M30_PLUS",
    "Model": "M30_PLUS"
  },
  {
    "Retail Branding": "SPRANGE",
    "Marketing Name": "Sprange_L8",
    "Device": "Sprange_L8",
    "Model": "Sprange_L8"
  },
  {
    "Retail Branding": "SPURT",
    "Marketing Name": "Spurt_K800",
    "Device": "Spurt_K800",
    "Model": "Spurt K800"
  },
  {
    "Retail Branding": "SQ(max)",
    "Marketing Name": "Hope10_Max",
    "Device": "Hope10_Max",
    "Model": "Hope10 Max"
  },
  {
    "Retail Branding": "SQ(max)",
    "Marketing Name": "Hope8_Max",
    "Device": "Hope8_Max",
    "Model": "Hope8_Max"
  },
  {
    "Retail Branding": "SSA-Digital",
    "Marketing Name": "MID-1015T",
    "Device": "MID-1015T",
    "Model": "MID-1015T"
  },
  {
    "Retail Branding": "SSA-Digital",
    "Marketing Name": "MID-1016T",
    "Device": "MID-1016T",
    "Model": "MID-1016T"
  },
  {
    "Retail Branding": "SSA-Digital",
    "Marketing Name": "MID736-737",
    "Device": "MID736-737",
    "Model": "MID736-737"
  },
  {
    "Retail Branding": "SSB PHONES",
    "Marketing Name": "AMS5118R_GO",
    "Device": "AMS5118R_GO",
    "Model": "AMS5118R_GO"
  },
  {
    "Retail Branding": "SSB PHONES",
    "Marketing Name": "AMS5518R",
    "Device": "AMS5518R",
    "Model": "AMS5518R"
  },
  {
    "Retail Branding": "SSB PHONES",
    "Marketing Name": "BS5214G",
    "Device": "BS5214G",
    "Model": "BS5214G"
  },
  {
    "Retail Branding": "SSB PHONES",
    "Marketing Name": "LM5118R",
    "Device": "LM5118R",
    "Model": "LM5118R"
  },
  {
    "Retail Branding": "SSB PHONES",
    "Marketing Name": "LM5118R_GO",
    "Device": "LM5118R_GO",
    "Model": "LM5118R_GO"
  },
  {
    "Retail Branding": "SSB PHONES",
    "Marketing Name": "LM5184G",
    "Device": "LM5184G",
    "Model": "LM5184G"
  },
  {
    "Retail Branding": "SSB PHONES",
    "Marketing Name": "LM5518R",
    "Device": "LM5518R",
    "Model": "LM5518R"
  },
  {
    "Retail Branding": "SSB PHONES",
    "Marketing Name": "MM5014G",
    "Device": "MM5014G",
    "Model": "MM5014G"
  },
  {
    "Retail Branding": "SSB PHONES",
    "Marketing Name": "MP5184G",
    "Device": "MP5184G",
    "Model": "MP5184G"
  },
  {
    "Retail Branding": "SSB PHONES",
    "Marketing Name": "SS5114G",
    "Device": "SS5114G",
    "Model": "SS5114G"
  },
  {
    "Retail Branding": "SSB PHONES",
    "Marketing Name": "SSB-508D",
    "Device": "SSB-508D",
    "Model": "SSB-508D"
  },
  {
    "Retail Branding": "SSB PHONES",
    "Marketing Name": "SSB-508LTE",
    "Device": "SSB-508LTE",
    "Model": "SSB-508LTE"
  },
  {
    "Retail Branding": "SSB PHONES",
    "Marketing Name": "SSB504",
    "Device": "SSB504",
    "Model": "SSB504"
  },
  {
    "Retail Branding": "SSB PHONES",
    "Marketing Name": "SSB504A",
    "Device": "SSB504A",
    "Model": "SSB504A"
  },
  {
    "Retail Branding": "SSB PHONES",
    "Marketing Name": "SSB504R",
    "Device": "SSB504R",
    "Model": "SSB504R"
  },
  {
    "Retail Branding": "SSB PHONES",
    "Marketing Name": "SSB5118R",
    "Device": "SSB5118R",
    "Model": "SSB5118R"
  },
  {
    "Retail Branding": "SSB PHONES",
    "Marketing Name": "SSB5118R_GO",
    "Device": "SSB5118R_GO",
    "Model": "SSB5118R_GO"
  },
  {
    "Retail Branding": "SSB PHONES",
    "Marketing Name": "SSB5518",
    "Device": "SSB5518",
    "Model": "SSB5518"
  },
  {
    "Retail Branding": "SSB PHONES",
    "Marketing Name": "SSB554R",
    "Device": "SSB554R",
    "Model": "SSB554R"
  },
  {
    "Retail Branding": "SSmooth",
    "Marketing Name": "NOVA 6.5",
    "Device": "NOVA_6_5",
    "Model": "NOVA 6.5"
  },
  {
    "Retail Branding": "SSmooth",
    "Marketing Name": "SMV15523216",
    "Device": "SMV15523216",
    "Model": "Smooth 5"
  },
  {
    "Retail Branding": "SSmooth",
    "Marketing Name": "Smooth 5.0 2022",
    "Device": "Smooth_5_0_2022",
    "Model": "Smooth 5.0 2022"
  },
  {
    "Retail Branding": "SSmooth",
    "Marketing Name": "Smooth 5.5 Lite",
    "Device": "Smooth5_5_Lite",
    "Model": "Smooth 5.5 Lite"
  },
  {
    "Retail Branding": "SSmooth",
    "Marketing Name": "Smooth 5.5 MAX",
    "Device": "Smooth_5_5_MAX",
    "Model": "Smooth 5.5 MAX"
  },
  {
    "Retail Branding": "SSmooth",
    "Marketing Name": "Smooth 6.0",
    "Device": "Smooth_6_0",
    "Model": "Smooth 6.0"
  },
  {
    "Retail Branding": "SSmooth",
    "Marketing Name": "Smooth 6.26 Lite",
    "Device": "Smooth6_26_Lite",
    "Model": "Smooth 6.26 Lite"
  },
  {
    "Retail Branding": "SSmooth",
    "Marketing Name": "Smooth 6.26 Max",
    "Device": "Smooth6_26_Max",
    "Model": "Smooth 6.26 Max"
  },
  {
    "Retail Branding": "SSmooth",
    "Marketing Name": "Smooth 6.26 Pro",
    "Device": "Smooth6_26_Pro",
    "Model": "Smooth 6.26 Pro"
  },
  {
    "Retail Branding": "SSmooth",
    "Marketing Name": "Smooth 6.5",
    "Device": "Smooth6_5",
    "Model": "Smooth 6.5"
  },
  {
    "Retail Branding": "SSmooth",
    "Marketing Name": "Smooth Kids",
    "Device": "Smooth_Kids",
    "Model": "Smooth_Kids"
  },
  {
    "Retail Branding": "SSmooth",
    "Marketing Name": "Smooth Note 6.8",
    "Device": "Smooth_Note_6_8",
    "Model": "Smooth Note 6.8"
  },
  {
    "Retail Branding": "SSmooth",
    "Marketing Name": "Smooth6_1",
    "Device": "Smooth6_1",
    "Model": "Smooth 6.1"
  },
  {
    "Retail Branding": "SSmooth",
    "Marketing Name": "Smooth6_5",
    "Device": "Smooth6_5",
    "Model": "Smooth 6.5"
  },
  {
    "Retail Branding": "SSmooth",
    "Marketing Name": "Smooth_5",
    "Device": "SSmooth_5",
    "Model": "Smooth 5.0"
  },
  {
    "Retail Branding": "SSmooth",
    "Marketing Name": "Smooth_8GT",
    "Device": "Smooth_8GT",
    "Model": "Smooth 8GT"
  },
  {
    "Retail Branding": "SSmooth",
    "Marketing Name": "Vision",
    "Device": "Vision",
    "Model": "Vision"
  },
  {
    "Retail Branding": "SSmooth",
    "Marketing Name": "Vision Plus",
    "Device": "Vision_Plus",
    "Model": "Vision Plus"
  },
  {
    "Retail Branding": "STARK_FUTURE",
    "Marketing Name": "ARKENSTONE",
    "Device": "ARKENSTONE",
    "Model": "ARKENSTONE"
  },
  {
    "Retail Branding": "STARK_FUTURE",
    "Marketing Name": "VARG",
    "Device": "VARG",
    "Model": "VARG"
  },
  {
    "Retail Branding": "STARSAT",
    "Marketing Name": "Smart TV",
    "Device": "osaka",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "STARSAT",
    "Marketing Name": "StarSat 2K TV",
    "Device": "dongnae",
    "Model": "StarSat 2K TV"
  },
  {
    "Retail Branding": "STARSAT",
    "Marketing Name": "United Arab Emirates",
    "Device": "sepolia",
    "Model": "StarSat 4K TV"
  },
  {
    "Retail Branding": "STARSHINE",
    "Marketing Name": "STARSHINE",
    "Device": "mountbaker",
    "Model": "2K SMART TV"
  },
  {
    "Retail Branding": "STARSHINE",
    "Marketing Name": "STARSHINE 2K Google TV",
    "Device": "capitolhill",
    "Model": "STARSHINE  2K Google TV"
  },
  {
    "Retail Branding": "START",
    "Marketing Name": "SH4651",
    "Device": "SH4651",
    "Model": "SH4651"
  },
  {
    "Retail Branding": "START",
    "Marketing Name": "Start S",
    "Device": "Start_S",
    "Model": "Start S"
  },
  {
    "Retail Branding": "STARTMOBIS",
    "Marketing Name": "START24",
    "Device": "START24",
    "Model": "START24"
  },
  {
    "Retail Branding": "STE (A)",
    "Marketing Name": "S11",
    "Device": "S11",
    "Model": "S11"
  },
  {
    "Retail Branding": "STF Mobile",
    "Marketing Name": "AERIAL",
    "Device": "STFAERIAL",
    "Model": "AERIAL"
  },
  {
    "Retail Branding": "STF Mobile",
    "Marketing Name": "AERIAL PLUS",
    "Device": "AERIAL",
    "Model": "AERIAL PLUS"
  },
  {
    "Retail Branding": "STF Mobile",
    "Marketing Name": "AURA",
    "Device": "AURA",
    "Model": "AURA"
  },
  {
    "Retail Branding": "STF Mobile",
    "Marketing Name": "AURA PLUS",
    "Device": "AURA_PLUS",
    "Model": "AURA PLUS"
  },
  {
    "Retail Branding": "STF Mobile",
    "Marketing Name": "BLOCK MINI",
    "Device": "BLOCK_MINI",
    "Model": "BLOCK_MINI"
  },
  {
    "Retail Branding": "STF Mobile",
    "Marketing Name": "BLOCK_3",
    "Device": "BLOCK_3",
    "Model": "BLOCK 3"
  },
  {
    "Retail Branding": "STF Mobile",
    "Marketing Name": "BLOCK_3_mini",
    "Device": "BLOCK_3_mini",
    "Model": "BLOCK 3 mini"
  },
  {
    "Retail Branding": "STF Mobile",
    "Marketing Name": "BLOCK_GO",
    "Device": "BLOCK_GO",
    "Model": "BLOCK GO"
  },
  {
    "Retail Branding": "STF Mobile",
    "Marketing Name": "DUO",
    "Device": "DUO",
    "Model": "DUO"
  },
  {
    "Retail Branding": "STF Mobile",
    "Marketing Name": "Fractal",
    "Device": "Fractal",
    "Model": "Fractal"
  },
  {
    "Retail Branding": "STF Mobile",
    "Marketing Name": "HIT",
    "Device": "HIT",
    "Model": "HIT"
  },
  {
    "Retail Branding": "STF Mobile",
    "Marketing Name": "HK-914581",
    "Device": "HK-914581",
    "Model": "HK-914581"
  },
  {
    "Retail Branding": "STF Mobile",
    "Marketing Name": "ICON",
    "Device": "ICON",
    "Model": "ICON"
  },
  {
    "Retail Branding": "STF Mobile",
    "Marketing Name": "IO",
    "Device": "IO",
    "Model": "IO"
  },
  {
    "Retail Branding": "STF Mobile",
    "Marketing Name": "Joy Pro",
    "Device": "Joy_Pro",
    "Model": "Joy Pro"
  },
  {
    "Retail Branding": "STF Mobile",
    "Marketing Name": "NATIVO",
    "Device": "NATIVO",
    "Model": "NATIVO"
  },
  {
    "Retail Branding": "STF Mobile",
    "Marketing Name": "Origins Pro",
    "Device": "Origins_Pro",
    "Model": "Origins Pro"
  },
  {
    "Retail Branding": "STF Mobile",
    "Marketing Name": "ST-919975",
    "Device": "ST-919975",
    "Model": "ST-919975"
  },
  {
    "Retail Branding": "STF Mobile",
    "Marketing Name": "ST-922081",
    "Device": "ST-922081",
    "Model": "ST-922081"
  },
  {
    "Retail Branding": "STF Mobile",
    "Marketing Name": "ST-922098",
    "Device": "ST-922098",
    "Model": "ST-922098"
  },
  {
    "Retail Branding": "STF Mobile",
    "Marketing Name": "STF-BLOCK",
    "Device": "Block",
    "Model": "Block"
  },
  {
    "Retail Branding": "STF Mobile",
    "Marketing Name": "aura ULTRA",
    "Device": "aura_ULTRA",
    "Model": "aura ULTRA"
  },
  {
    "Retail Branding": "STG Telecom",
    "Marketing Name": "STG A1",
    "Device": "STG_A1",
    "Model": "STG A1"
  },
  {
    "Retail Branding": "STG Telecom",
    "Marketing Name": "STG A1 Pro",
    "Device": "STG_A1_Pro",
    "Model": "STG A1 Pro"
  },
  {
    "Retail Branding": "STG Telecom",
    "Marketing Name": "STG A2 Pro",
    "Device": "STG_A2_Pro",
    "Model": "STG A2 Pro"
  },
  {
    "Retail Branding": "STG Telecom",
    "Marketing Name": "STG H10",
    "Device": "STG_H10",
    "Model": "STG H10"
  },
  {
    "Retail Branding": "STG Telecom",
    "Marketing Name": "STG S1",
    "Device": "STG_S1",
    "Model": "STG S1"
  },
  {
    "Retail Branding": "STG Telecom",
    "Marketing Name": "STG S10",
    "Device": "STG_S10",
    "Model": "STG S10"
  },
  {
    "Retail Branding": "STG Telecom",
    "Marketing Name": "STG X1",
    "Device": "STG_X1",
    "Model": "STG X1"
  },
  {
    "Retail Branding": "STG Telecom",
    "Marketing Name": "STG X2",
    "Device": "STG_X2",
    "Model": "STG X2"
  },
  {
    "Retail Branding": "STG Telecom",
    "Marketing Name": "STG X20",
    "Device": "STG_X20",
    "Model": "STG X20"
  },
  {
    "Retail Branding": "STG Telecom",
    "Marketing Name": "STG X3",
    "Device": "STG_X3",
    "Model": "STG X3"
  },
  {
    "Retail Branding": "STG Telecom",
    "Marketing Name": "STG-KeyTab",
    "Device": "STG-KeyTab",
    "Model": "STG-KeyTab"
  },
  {
    "Retail Branding": "STG Telecom",
    "Marketing Name": "STG_A1",
    "Device": "STG_A1",
    "Model": "STG A1"
  },
  {
    "Retail Branding": "STG Telecom",
    "Marketing Name": "STG_B10",
    "Device": "STG_B10",
    "Model": "STG_B10"
  },
  {
    "Retail Branding": "STG Telecom",
    "Marketing Name": "STG_C10",
    "Device": "STG_C10",
    "Model": "STG_C10"
  },
  {
    "Retail Branding": "STG Telecom",
    "Marketing Name": "STG_K10",
    "Device": "STG_K10",
    "Model": "STG_K10"
  },
  {
    "Retail Branding": "STG Telecom",
    "Marketing Name": "STG_P10",
    "Device": "STG_P10",
    "Model": "STG_P10"
  },
  {
    "Retail Branding": "STG Telecom",
    "Marketing Name": "STG_S1",
    "Device": "STG_S1",
    "Model": "STG S1"
  },
  {
    "Retail Branding": "STG Telecom",
    "Marketing Name": "STG_S20",
    "Device": "STG_S20",
    "Model": "STG S20"
  },
  {
    "Retail Branding": "STG Telecom",
    "Marketing Name": "STG_S30",
    "Device": "STG_S30",
    "Model": "STG S30"
  },
  {
    "Retail Branding": "STG Telecom",
    "Marketing Name": "STG_X1",
    "Device": "STG_X1",
    "Model": "STG X1"
  },
  {
    "Retail Branding": "STIP",
    "Marketing Name": "MS9",
    "Device": "MS9",
    "Model": "MS9"
  },
  {
    "Retail Branding": "STK(Santok)",
    "Marketing Name": "Evo_2",
    "Device": "Evo_2",
    "Model": "Evo 2"
  },
  {
    "Retail Branding": "STK(Santok)",
    "Marketing Name": "Hero X",
    "Device": "STK_Hero_X",
    "Model": "STK_Hero_X"
  },
  {
    "Retail Branding": "STK(Santok)",
    "Marketing Name": "Life 8S",
    "Device": "Life_8S",
    "Model": "Life 8S"
  },
  {
    "Retail Branding": "STK(Santok)",
    "Marketing Name": "Life_9",
    "Device": "Life_9",
    "Model": "Life 9"
  },
  {
    "Retail Branding": "STK(Santok)",
    "Marketing Name": "STK Ace Plus",
    "Device": "Ace_Plus",
    "Model": "STK Ace Plus"
  },
  {
    "Retail Branding": "STK(Santok)",
    "Marketing Name": "STK Ace Plus",
    "Device": "STK_Ace_Plus",
    "Model": "STK Ace Plus"
  },
  {
    "Retail Branding": "STK(Santok)",
    "Marketing Name": "STK EVO",
    "Device": "STK_EVO",
    "Model": "STK EVO"
  },
  {
    "Retail Branding": "STK(Santok)",
    "Marketing Name": "STK EVO",
    "Device": "STK_EVO_US",
    "Model": "STK EVO"
  },
  {
    "Retail Branding": "STK(Santok)",
    "Marketing Name": "STK Hero Lite",
    "Device": "Hero_Lite",
    "Model": "STK Hero Lite"
  },
  {
    "Retail Branding": "STK(Santok)",
    "Marketing Name": "STK Hero Lite",
    "Device": "STK_Hero_Lite",
    "Model": "STK Hero Lite"
  },
  {
    "Retail Branding": "STK(Santok)",
    "Marketing Name": "STK Life 5",
    "Device": "STK_Life_5",
    "Model": "STK Life 5"
  },
  {
    "Retail Branding": "STK(Santok)",
    "Marketing Name": "STK Life 7 3G",
    "Device": "Life_7_3G",
    "Model": "STK Life 7 3G"
  },
  {
    "Retail Branding": "STK(Santok)",
    "Marketing Name": "STK Life 7 4G",
    "Device": "STK_Life_7_4G",
    "Model": "STK Life 7 4G"
  },
  {
    "Retail Branding": "STK(Santok)",
    "Marketing Name": "STK Life 8",
    "Device": "STK_Life_8",
    "Model": "STK Life 8"
  },
  {
    "Retail Branding": "STK(Santok)",
    "Marketing Name": "STK Life Plus S",
    "Device": "Life_Plus_S",
    "Model": "STK Life Plus S"
  },
  {
    "Retail Branding": "STK(Santok)",
    "Marketing Name": "STK Life Plus S",
    "Device": "STK_Life_Plus_S",
    "Model": "STK Life Plus S"
  },
  {
    "Retail Branding": "STK(Santok)",
    "Marketing Name": "STK X2",
    "Device": "STK_X2",
    "Model": "STK X2"
  },
  {
    "Retail Branding": "STK(Santok)",
    "Marketing Name": "STKX3",
    "Device": "X3",
    "Model": "X3"
  },
  {
    "Retail Branding": "STK(Santok)",
    "Marketing Name": "SYNC 5C",
    "Device": "STK_Sync_5c",
    "Model": "STK_Sync_5c"
  },
  {
    "Retail Branding": "STK(Santok)",
    "Marketing Name": "Storm 2e  Plus",
    "Device": "Storm_2e_Plus",
    "Model": "Storm 2e Plus"
  },
  {
    "Retail Branding": "STK(Santok)",
    "Marketing Name": "Storm 2e Pluz",
    "Device": "Storm_2e_Pluz",
    "Model": "Storm 2e Pluz"
  },
  {
    "Retail Branding": "STK(Santok)",
    "Marketing Name": "Storm 3",
    "Device": "W230",
    "Model": "STK Storm 3"
  },
  {
    "Retail Branding": "STK(Santok)",
    "Marketing Name": "Sync 5e",
    "Device": "STK_Sync_5e",
    "Model": "STK_Sync_5e"
  },
  {
    "Retail Branding": "STK(Santok)",
    "Marketing Name": "Sync 5z",
    "Device": "STK_Sync_5z",
    "Model": "STK Sync 5z"
  },
  {
    "Retail Branding": "STK(Santok)",
    "Marketing Name": "Transporter 1",
    "Device": "STK_Transporter_1",
    "Model": "STK_Transporter_1"
  },
  {
    "Retail Branding": "STK(Santok)",
    "Marketing Name": "X3",
    "Device": "X3",
    "Model": "X3"
  },
  {
    "Retail Branding": "STK(Santok)",
    "Marketing Name": "cayenne",
    "Device": "cayenne",
    "Model": "STK Ace"
  },
  {
    "Retail Branding": "STUDYNLEARN",
    "Marketing Name": "Education Market",
    "Device": "mensa_an64",
    "Model": "IS-IFP_Series_86"
  },
  {
    "Retail Branding": "STUDYNLEARN",
    "Marketing Name": "IS-IFPSeries",
    "Device": "mensa_an64",
    "Model": "IS-IFPSeries"
  },
  {
    "Retail Branding": "STboard",
    "Marketing Name": "HJ_M2",
    "Device": "HJ_M2",
    "Model": "HJ_M2"
  },
  {
    "Retail Branding": "STboard",
    "Marketing Name": "HJ_TD",
    "Device": "HJ_TD",
    "Model": "HJ_TD"
  },
  {
    "Retail Branding": "SUAAT",
    "Marketing Name": "G2_S_EEA",
    "Device": "G2_EEA",
    "Model": "G2_EEA"
  },
  {
    "Retail Branding": "SUAAT",
    "Marketing Name": "G2_S_EEA",
    "Device": "G2_EEA",
    "Model": "G2_S_EEA"
  },
  {
    "Retail Branding": "SUAAT",
    "Marketing Name": "G2_S_US",
    "Device": "G2_US",
    "Model": "G2_S_US"
  },
  {
    "Retail Branding": "SUAAT",
    "Marketing Name": "G2_S_US",
    "Device": "G2_US",
    "Model": "G2_US"
  },
  {
    "Retail Branding": "SUAAT",
    "Marketing Name": "S10_U_EEA",
    "Device": "S10_U_EEA",
    "Model": "S10_EEA"
  },
  {
    "Retail Branding": "SUAAT",
    "Marketing Name": "S10_U_EEA",
    "Device": "S10_U_EEA",
    "Model": "S10_U_EEA"
  },
  {
    "Retail Branding": "SUAAT",
    "Marketing Name": "S10_U_US",
    "Device": "S10_U_US",
    "Model": "S10_US"
  },
  {
    "Retail Branding": "SUAAT",
    "Marketing Name": "S10_U_US",
    "Device": "S10_U_US",
    "Model": "S10_U_US"
  },
  {
    "Retail Branding": "SUAAT",
    "Marketing Name": "S10_V_EEA",
    "Device": "S10_V_EEA",
    "Model": "S10_V_EEA"
  },
  {
    "Retail Branding": "SUAAT",
    "Marketing Name": "S10_V_US",
    "Device": "S10_V_US",
    "Model": "S10_V_US"
  },
  {
    "Retail Branding": "SUAAT",
    "Marketing Name": "S11_V_EEA",
    "Device": "S11_V_EEA",
    "Model": "S11_V_EEA"
  },
  {
    "Retail Branding": "SUAAT",
    "Marketing Name": "S11_V_US",
    "Device": "S11_V_US",
    "Model": "S11_V_US"
  },
  {
    "Retail Branding": "SUAAT",
    "Marketing Name": "S3_EEA",
    "Device": "S3_EEA",
    "Model": "S3_EEA"
  },
  {
    "Retail Branding": "SUAAT",
    "Marketing Name": "S3_US",
    "Device": "S3_US",
    "Model": "S3_US"
  },
  {
    "Retail Branding": "SUAAT",
    "Marketing Name": "S3_U_EEA",
    "Device": "S3_U_EEA",
    "Model": "S3_U_EEA"
  },
  {
    "Retail Branding": "SUAAT",
    "Marketing Name": "S3_U_US",
    "Device": "S3_U_US",
    "Model": "S3_U_US"
  },
  {
    "Retail Branding": "SUAAT",
    "Marketing Name": "S3_V_EEA",
    "Device": "S3_V_EEA",
    "Model": "S3_V_EEA"
  },
  {
    "Retail Branding": "SUAAT",
    "Marketing Name": "S3_V_US",
    "Device": "S3_V_US",
    "Model": "S3_V_US"
  },
  {
    "Retail Branding": "SUAAT",
    "Marketing Name": "S6-U-EEA",
    "Device": "S6-U-EEA",
    "Model": "S6-EEA"
  },
  {
    "Retail Branding": "SUAAT",
    "Marketing Name": "S6_EEA",
    "Device": "S6_EEA",
    "Model": "S6_EEA"
  },
  {
    "Retail Branding": "SUAAT",
    "Marketing Name": "S6_US",
    "Device": "S6_US",
    "Model": "S6_US"
  },
  {
    "Retail Branding": "SUNCONNECTION",
    "Marketing Name": "SUNTB_01_GY",
    "Device": "SUNTB_01_GY",
    "Model": "SUNTB 01 GY"
  },
  {
    "Retail Branding": "SUNMAX",
    "Marketing Name": "Model 6 Pro Max 4G",
    "Device": "Model_6_Pro_Max_4G",
    "Model": "Model_6_Pro_Max_4G"
  },
  {
    "Retail Branding": "SUNMAX",
    "Marketing Name": "Model D",
    "Device": "Model_D",
    "Model": "Model D"
  },
  {
    "Retail Branding": "SUNMAX",
    "Marketing Name": "Model E",
    "Device": "Model_E",
    "Model": "Model E"
  },
  {
    "Retail Branding": "SUNMAX",
    "Marketing Name": "Model K",
    "Device": "Model_K",
    "Model": "Model K"
  },
  {
    "Retail Branding": "SUNMAX",
    "Marketing Name": "Model K  4G",
    "Device": "Model_K_4G",
    "Model": "Model K 4G"
  },
  {
    "Retail Branding": "SUNMAX",
    "Marketing Name": "Model X 4G",
    "Device": "Model_X_4G_A",
    "Model": "Model_X_4G_A"
  },
  {
    "Retail Branding": "SUNMAX",
    "Marketing Name": "Model_3",
    "Device": "Model_3",
    "Model": "Model 3"
  },
  {
    "Retail Branding": "SUNMAX",
    "Marketing Name": "Model_6",
    "Device": "Model_6",
    "Model": "Model 6"
  },
  {
    "Retail Branding": "SUNMAX",
    "Marketing Name": "Model_6_4G",
    "Device": "Model_6_4G",
    "Model": "Model_6_4G"
  },
  {
    "Retail Branding": "SUNMAX",
    "Marketing Name": "Model_6_Pro",
    "Device": "Model_6_Pro",
    "Model": "Model 6 Pro"
  },
  {
    "Retail Branding": "SUNMAX",
    "Marketing Name": "Model_6_Pro_4G",
    "Device": "Model_6_pro_4G",
    "Model": "Model_6_pro_4G"
  },
  {
    "Retail Branding": "SUNMAX",
    "Marketing Name": "Model_6_Pro_Max",
    "Device": "Model_6_Pro_Max",
    "Model": "Model 6 Pro Max"
  },
  {
    "Retail Branding": "SUNMAX",
    "Marketing Name": "Model_E_4G",
    "Device": "Model_E_4G",
    "Model": "Model E 4G"
  },
  {
    "Retail Branding": "SUNMAX",
    "Marketing Name": "Model_One",
    "Device": "Model_One",
    "Model": "Model One"
  },
  {
    "Retail Branding": "SUNMAX",
    "Marketing Name": "Model_S",
    "Device": "Model_S",
    "Model": "Model S"
  },
  {
    "Retail Branding": "SUNMAX",
    "Marketing Name": "Model_S_4G",
    "Device": "Model_S_4G",
    "Model": "Model S 4G"
  },
  {
    "Retail Branding": "SUNMAX",
    "Marketing Name": "Model_S_Ultra_4G_AO",
    "Device": "Model_S_Ultra_4G",
    "Model": "Model S Ultra 4G"
  },
  {
    "Retail Branding": "SUNMAX",
    "Marketing Name": "Model_T",
    "Device": "Model_T",
    "Model": "Model T"
  },
  {
    "Retail Branding": "SUNMAX",
    "Marketing Name": "Model_T1",
    "Device": "Model_T1",
    "Model": "Model T1"
  },
  {
    "Retail Branding": "SUNMAX",
    "Marketing Name": "Model_T2",
    "Device": "Model_T2",
    "Model": "Model T2"
  },
  {
    "Retail Branding": "SUNMAX",
    "Marketing Name": "Model_T_4G",
    "Device": "Model_T_4G",
    "Model": "Model_T_4G"
  },
  {
    "Retail Branding": "SUNMAX",
    "Marketing Name": "Model_X",
    "Device": "Model_X",
    "Model": "Model X"
  },
  {
    "Retail Branding": "SUNMAX",
    "Marketing Name": "Model_Y",
    "Device": "Model_Y",
    "Model": "Model Y"
  },
  {
    "Retail Branding": "SUNMAX",
    "Marketing Name": "SP125D_2",
    "Device": "SP125D_2",
    "Model": "SP125D_2"
  },
  {
    "Retail Branding": "SUNMAX",
    "Marketing Name": "Sunmax Model Tab 10",
    "Device": "Sunmax_Model_Tab_10",
    "Model": "Sunmax Model Tab 10"
  },
  {
    "Retail Branding": "SUNMAX",
    "Marketing Name": "Tab_6",
    "Device": "Tab_6",
    "Model": "Tab_6"
  },
  {
    "Retail Branding": "SUNPHONE",
    "Marketing Name": "L3",
    "Device": "L4",
    "Model": "L4"
  },
  {
    "Retail Branding": "SUNPHONE",
    "Marketing Name": "L4",
    "Device": "L4",
    "Model": "L3"
  },
  {
    "Retail Branding": "SUNTAK",
    "Marketing Name": "CHIPPY_S",
    "Device": "CHIPPY",
    "Model": "CHIPPY"
  },
  {
    "Retail Branding": "SUNTAK",
    "Marketing Name": "MOJO",
    "Device": "MOJO",
    "Model": "MOJO"
  },
  {
    "Retail Branding": "SUNTAK",
    "Marketing Name": "MOX  2",
    "Device": "MOX_2",
    "Model": "MOX_2"
  },
  {
    "Retail Branding": "SUNWIND",
    "Marketing Name": "SKY 9 E201 3G",
    "Device": "SS9237MG",
    "Model": "SKY 9 E201 3G SS9237MG"
  },
  {
    "Retail Branding": "SUNWIND",
    "Marketing Name": "SKY_9_A102_3G",
    "Device": "SS9236PG",
    "Model": "SKY 9 A102 3G SS9236PG"
  },
  {
    "Retail Branding": "SUNWIND",
    "Marketing Name": "SS1270PL",
    "Device": "SS1270PL",
    "Model": "Sky 1430D 4G SS1270PL"
  },
  {
    "Retail Branding": "SUNWIND",
    "Marketing Name": "SS7238PG",
    "Device": "SS7238PG",
    "Model": "SKY Kids 70 SS7238PG"
  },
  {
    "Retail Branding": "SUNWIND",
    "Marketing Name": "SUNWIND_SKY_7_E200_3G",
    "Device": "ST7230MG",
    "Model": "SUNWIND SKY 7 E200 3G ST7230MG"
  },
  {
    "Retail Branding": "SUNWIND",
    "Marketing Name": "Sky_1123B_3G",
    "Device": "SS1259PG",
    "Model": "Sky 1123B 3G SS1259PG"
  },
  {
    "Retail Branding": "SUNWIND",
    "Marketing Name": "Sky_1262C_3G",
    "Device": "SS1260PG",
    "Model": "Sky 1262C 3G SS1260PG"
  },
  {
    "Retail Branding": "SUNWIND",
    "Marketing Name": "Sky_7143B_3G_SS7265PG",
    "Device": "SS7265PG",
    "Model": "Sky 7143B 3G SS7265PG"
  },
  {
    "Retail Branding": "SUNWIND",
    "Marketing Name": "Sky_8244B_3G_SS8263PG",
    "Device": "SS8263PG",
    "Model": "Sky 8244B 3G SS8263PG"
  },
  {
    "Retail Branding": "SUPERSONIC",
    "Marketing Name": "SC-2109",
    "Device": "SC-2109",
    "Model": "SC-2109"
  },
  {
    "Retail Branding": "SUPERSONIC",
    "Marketing Name": "SC-2110",
    "Device": "SC-2110",
    "Model": "SC-2110"
  },
  {
    "Retail Branding": "SUPERSONIC",
    "Marketing Name": "SC-2110A",
    "Device": "SC_2110A",
    "Model": "SC-2110A"
  },
  {
    "Retail Branding": "SUPERSONIC",
    "Marketing Name": "SC-4317BT",
    "Device": "SC-4317BT",
    "Model": "SC-4317BT"
  },
  {
    "Retail Branding": "SUPERSONIC",
    "Marketing Name": "SC-5310BDL",
    "Device": "SC_5310BDL",
    "Model": "SC-5310BDL"
  },
  {
    "Retail Branding": "SUPERSONIC",
    "Marketing Name": "SC-774KT",
    "Device": "SC-774KT",
    "Model": "SC-774KT"
  },
  {
    "Retail Branding": "SUPERSONIC",
    "Marketing Name": "SC-813",
    "Device": "SC-813",
    "Model": "SC-813"
  },
  {
    "Retail Branding": "SUPERSONIC",
    "Marketing Name": "SC-9810",
    "Device": "Hatch_102S",
    "Model": "Hatch_102S"
  },
  {
    "Retail Branding": "SUPERSONIC",
    "Marketing Name": "SC-9810",
    "Device": "SC-9810",
    "Model": "SC-9810"
  },
  {
    "Retail Branding": "SUPERSONIC",
    "Marketing Name": "SC4009DL",
    "Device": "SC4009DL",
    "Model": "SC-4009DL"
  },
  {
    "Retail Branding": "SUPERSONIC",
    "Marketing Name": "SC_1010JBBT",
    "Device": "SC_1010JBBT",
    "Model": "SC_1010JBBT"
  },
  {
    "Retail Branding": "SUPERSONIC",
    "Marketing Name": "SC_3107",
    "Device": "SC_3107",
    "Model": "SC-3107"
  },
  {
    "Retail Branding": "SUPERSONIC",
    "Marketing Name": "SC_3110",
    "Device": "SC_3110",
    "Model": "SC-3110"
  },
  {
    "Retail Branding": "SUPERSONIC",
    "Marketing Name": "SC_4107",
    "Device": "SC_4107",
    "Model": "SC-4107"
  },
  {
    "Retail Branding": "SUPERSONIC",
    "Marketing Name": "SC_4110",
    "Device": "SC_4110",
    "Model": "SC-4110"
  },
  {
    "Retail Branding": "SUPERSONIC",
    "Marketing Name": "SC_4317",
    "Device": "SC_4317",
    "Model": "SC_4317"
  },
  {
    "Retail Branding": "SUPERSONIC",
    "Marketing Name": "SC_4317BT",
    "Device": "SC_4317BT",
    "Model": "SC_4317BT"
  },
  {
    "Retail Branding": "SUPERSONIC",
    "Marketing Name": "SC_774KT",
    "Device": "SC_774KT",
    "Model": "SC_774KT"
  },
  {
    "Retail Branding": "SUPERSONIC",
    "Marketing Name": "SC_779KT",
    "Device": "SC_779KT",
    "Model": "SC-779KT"
  },
  {
    "Retail Branding": "SUPERSONIC",
    "Marketing Name": "SC_780KT",
    "Device": "SC_780KT",
    "Model": "SC-780KT"
  },
  {
    "Retail Branding": "SUPERSONIC",
    "Marketing Name": "Smart TV",
    "Device": "kanda",
    "Model": "SUPERSONIC 2K Smart TV"
  },
  {
    "Retail Branding": "SUPERSONIC",
    "Marketing Name": "Smart TV",
    "Device": "mateo",
    "Model": "2K US Smart TV"
  },
  {
    "Retail Branding": "SUPERSONIC",
    "Marketing Name": "TAB7091",
    "Device": "TAB7091",
    "Model": "TAB7091"
  },
  {
    "Retail Branding": "SUPERSONIC",
    "Marketing Name": "USA",
    "Device": "yeongdeungpo",
    "Model": "SUPERSONIC UHD Android TV"
  },
  {
    "Retail Branding": "SUPOIN",
    "Marketing Name": "S66",
    "Device": "S66",
    "Model": "S66"
  },
  {
    "Retail Branding": "SUXI",
    "Marketing Name": "SUXI_I11",
    "Device": "SUXI_I11",
    "Model": "SUXI I11"
  },
  {
    "Retail Branding": "SUXI",
    "Marketing Name": "SUXI_S700",
    "Device": "SUXI_S700",
    "Model": "SUXI S700"
  },
  {
    "Retail Branding": "SUXI",
    "Marketing Name": "T700",
    "Device": "T700",
    "Model": "T700"
  },
  {
    "Retail Branding": "SUXI",
    "Marketing Name": "T900",
    "Device": "T900",
    "Model": "T900"
  },
  {
    "Retail Branding": "SVD (Sun Vision Display)",
    "Marketing Name": "SunBook",
    "Device": "SunBook",
    "Model": "SunBook"
  },
  {
    "Retail Branding": "SVITOO",
    "Marketing Name": "G99",
    "Device": "G99",
    "Model": "G99"
  },
  {
    "Retail Branding": "SVITOO",
    "Marketing Name": "G99_EEA",
    "Device": "G99",
    "Model": "G99"
  },
  {
    "Retail Branding": "SVITOO",
    "Marketing Name": "MOMO8",
    "Device": "MOMO8",
    "Model": "MOMO8"
  },
  {
    "Retail Branding": "SVITOO",
    "Marketing Name": "MOMO8-EEA",
    "Device": "MOMO8-EEA",
    "Model": "MOMO8"
  },
  {
    "Retail Branding": "SVITOO",
    "Marketing Name": "P08",
    "Device": "P08",
    "Model": "P08"
  },
  {
    "Retail Branding": "SVITOO",
    "Marketing Name": "P08_T",
    "Device": "P08_T",
    "Model": "P08_T"
  },
  {
    "Retail Branding": "SVITOO",
    "Marketing Name": "P108_EEA",
    "Device": "P108",
    "Model": "P108"
  },
  {
    "Retail Branding": "SVITOO",
    "Marketing Name": "P108_T",
    "Device": "P108_T",
    "Model": "P108_T"
  },
  {
    "Retail Branding": "SVITOO",
    "Marketing Name": "P108_T_EEA",
    "Device": "P108_T",
    "Model": "P108_T"
  },
  {
    "Retail Branding": "SVITOO",
    "Marketing Name": "P10_A",
    "Device": "P10_A",
    "Model": "P10_A"
  },
  {
    "Retail Branding": "SVITOO",
    "Marketing Name": "P10_A1",
    "Device": "P10_A1",
    "Model": "P10_A1"
  },
  {
    "Retail Branding": "SVITOO",
    "Marketing Name": "P10_A1_EEA",
    "Device": "P10_A1",
    "Model": "P10_A1"
  },
  {
    "Retail Branding": "SVITOO",
    "Marketing Name": "P10_A_EEA",
    "Device": "P10_A",
    "Model": "P10_A"
  },
  {
    "Retail Branding": "SVITOO",
    "Marketing Name": "P10_B",
    "Device": "P10_B",
    "Model": "P10_B"
  },
  {
    "Retail Branding": "SVITOO",
    "Marketing Name": "P10_B_EEA",
    "Device": "P10_B",
    "Model": "P10_B"
  },
  {
    "Retail Branding": "SVITOO",
    "Marketing Name": "P10_T_EEA",
    "Device": "P10_T",
    "Model": "P10_T"
  },
  {
    "Retail Branding": "SVITOO",
    "Marketing Name": "P10_pro",
    "Device": "P10",
    "Model": "P10"
  },
  {
    "Retail Branding": "SVITOO",
    "Marketing Name": "P11",
    "Device": "P11",
    "Model": "P11"
  },
  {
    "Retail Branding": "SVITOO",
    "Marketing Name": "P11",
    "Device": "P11",
    "Model": "P13"
  },
  {
    "Retail Branding": "SVITOO",
    "Marketing Name": "P11_T_ROW",
    "Device": "P11_T",
    "Model": "P11_T"
  },
  {
    "Retail Branding": "SVITOO",
    "Marketing Name": "P11_pro",
    "Device": "P11",
    "Model": "P11"
  },
  {
    "Retail Branding": "SVITOO",
    "Marketing Name": "P11_pro_EEA",
    "Device": "P11_pro_EEA",
    "Model": "P11"
  },
  {
    "Retail Branding": "SVITOO",
    "Marketing Name": "P11_pro_EEA",
    "Device": "P11_pro_EEA",
    "Model": "P11_pro_EEA"
  },
  {
    "Retail Branding": "SVITOO",
    "Marketing Name": "SVITOO_P10",
    "Device": "SVITOO_P10",
    "Model": "P10"
  },
  {
    "Retail Branding": "SVITOO",
    "Marketing Name": "TAB_P10",
    "Device": "TAB_P10",
    "Model": "TAB_P10"
  },
  {
    "Retail Branding": "SVITOO",
    "Marketing Name": "TAB_P10_CZ_ROW",
    "Device": "TAB_P10_CZ_ROW",
    "Model": "TAB_P10"
  },
  {
    "Retail Branding": "SVITOO",
    "Marketing Name": "TAB_P10_C_EEA",
    "Device": "TAB_P10_C_EEA",
    "Model": "TAB_P10_C_EEA"
  },
  {
    "Retail Branding": "SVITOO",
    "Marketing Name": "TAB_P10_C_ROW",
    "Device": "TAB_P10_C_ROW",
    "Model": "TAB_P10_C_ROW"
  },
  {
    "Retail Branding": "SVITOO",
    "Marketing Name": "TAB_P10_EEA",
    "Device": "TAB_P10_EEA",
    "Model": "TAB_P10"
  },
  {
    "Retail Branding": "SVITOO",
    "Marketing Name": "TAB_P10_EEA",
    "Device": "TAB_P10_EEA",
    "Model": "TAB_P10_EEA"
  },
  {
    "Retail Branding": "SVITOO",
    "Marketing Name": "TAB_P10_EEA_C",
    "Device": "TAB_P10",
    "Model": "TAB_P10"
  },
  {
    "Retail Branding": "SVITOO",
    "Marketing Name": "TAB_P10_ROW",
    "Device": "TAB_P10_ROW",
    "Model": "TAB_P10"
  },
  {
    "Retail Branding": "SVITOO",
    "Marketing Name": "TAB_P10_ROW",
    "Device": "TAB_P10_ROW",
    "Model": "TAB_P10_ROW"
  },
  {
    "Retail Branding": "SVITOO",
    "Marketing Name": "TAB_P12",
    "Device": "TAB_P12",
    "Model": "TAB P12"
  },
  {
    "Retail Branding": "SVITOO",
    "Marketing Name": "TAB_P12_EEA",
    "Device": "TAB_P12",
    "Model": "TAB P12"
  },
  {
    "Retail Branding": "SVITOO",
    "Marketing Name": "TAB_P1300",
    "Device": "TAB_P1300",
    "Model": "TAB_P1300"
  },
  {
    "Retail Branding": "SVITOO",
    "Marketing Name": "TAB_P1300_EEA",
    "Device": "TAB_P1300_EEA",
    "Model": "TAB_P1300_EEA"
  },
  {
    "Retail Branding": "SVITOO",
    "Marketing Name": "V13",
    "Device": "V13",
    "Model": "V13"
  },
  {
    "Retail Branding": "SVITOO",
    "Marketing Name": "V13_B",
    "Device": "V13_B",
    "Model": "V13_B"
  },
  {
    "Retail Branding": "SVITOO",
    "Marketing Name": "V13_B_EEA",
    "Device": "V13_B",
    "Model": "V13_B"
  },
  {
    "Retail Branding": "SVITOO",
    "Marketing Name": "V13_EEA",
    "Device": "V13",
    "Model": "V13"
  },
  {
    "Retail Branding": "SWACONNECT",
    "Marketing Name": "SWA310",
    "Device": "SWA310",
    "Model": "SWA310"
  },
  {
    "Retail Branding": "SWACONNECT",
    "Marketing Name": "SWA310_NEU",
    "Device": "SWA310",
    "Model": "BCGA92"
  },
  {
    "Retail Branding": "SWACONNECT",
    "Marketing Name": "SWA310_NEU",
    "Device": "SWA310",
    "Model": "GMS_TAB10"
  },
  {
    "Retail Branding": "SWACONNECT",
    "Marketing Name": "SWA310_NEU",
    "Device": "SWA310",
    "Model": "SWA310"
  },
  {
    "Retail Branding": "SWTV",
    "Marketing Name": "Asia",
    "Device": "SW3_ATV",
    "Model": "SWTV"
  },
  {
    "Retail Branding": "SWTV",
    "Marketing Name": "Europe",
    "Device": "SW3H_ATV",
    "Model": "SWTV"
  },
  {
    "Retail Branding": "SWTV",
    "Marketing Name": "North America",
    "Device": "SW3_ATV",
    "Model": "SWTV"
  },
  {
    "Retail Branding": "SWTV",
    "Marketing Name": "SW-22AE NF",
    "Device": "SW6H",
    "Model": "SW-22AE NF"
  },
  {
    "Retail Branding": "SWTV",
    "Marketing Name": "SW-22HK NF",
    "Device": "SW6H",
    "Model": "SW-22HK NF"
  },
  {
    "Retail Branding": "SWTV",
    "Marketing Name": "SW-22JP NF",
    "Device": "SW6H",
    "Model": "SW-22JP NF"
  },
  {
    "Retail Branding": "SWTV",
    "Marketing Name": "SW-22NA",
    "Device": "SW6H",
    "Model": "SW-22NA"
  },
  {
    "Retail Branding": "SWTV",
    "Marketing Name": "SW-22NA NF",
    "Device": "SW6H",
    "Model": "SW-22NA NF"
  },
  {
    "Retail Branding": "SWTV",
    "Marketing Name": "SW-22SA",
    "Device": "SW6H",
    "Model": "SW-22SA"
  },
  {
    "Retail Branding": "SWTV",
    "Marketing Name": "SW-22SA NF",
    "Device": "SW6H",
    "Model": "SW-22SA NF"
  },
  {
    "Retail Branding": "SWTV",
    "Marketing Name": "SWTV-20AE",
    "Device": "SW4H",
    "Model": "SWTV-20AE"
  },
  {
    "Retail Branding": "SWTV",
    "Marketing Name": "SWTV-20AE-PRO",
    "Device": "SW4H_FF",
    "Model": "SWTV-20AE-PRO"
  },
  {
    "Retail Branding": "SWTV",
    "Marketing Name": "SWTV-20HK",
    "Device": "SW4H",
    "Model": "SWTV-20HK"
  },
  {
    "Retail Branding": "SWTV",
    "Marketing Name": "SWTV-20HK-PRO",
    "Device": "SW4H_FF",
    "Model": "SWTV-20HK-PRO"
  },
  {
    "Retail Branding": "SWTV",
    "Marketing Name": "SWTV-20N",
    "Device": "SW4H",
    "Model": "SWTV-20NA"
  },
  {
    "Retail Branding": "SWTV",
    "Marketing Name": "SWTV-20NA-PRO",
    "Device": "SW4H_FF",
    "Model": "SWTV-20NA-PRO"
  },
  {
    "Retail Branding": "SWTV",
    "Marketing Name": "SWTV-20SA",
    "Device": "SW4H",
    "Model": "SWTV-20SA"
  },
  {
    "Retail Branding": "SWTV",
    "Marketing Name": "SWTV-20SA-PRO",
    "Device": "SW4H_FF",
    "Model": "SWTV-20SA-PRO"
  },
  {
    "Retail Branding": "SWTV",
    "Marketing Name": "SWTV-20TW",
    "Device": "SW4H",
    "Model": "SWTV-20TW"
  },
  {
    "Retail Branding": "SWTV",
    "Marketing Name": "SWTV-20TW-PRO",
    "Device": "SW4H_FF",
    "Model": "SWTV-20TW-PRO"
  },
  {
    "Retail Branding": "SWTV",
    "Marketing Name": "SWTV-21AE",
    "Device": "sunnyvale",
    "Model": "SWTV-21AE"
  },
  {
    "Retail Branding": "SWTV",
    "Marketing Name": "SWTV-21SA",
    "Device": "sunnyvale",
    "Model": "SWTV-21SA"
  },
  {
    "Retail Branding": "SWTV",
    "Marketing Name": "SWTV-22AE",
    "Device": "SW6H",
    "Model": "SWTV-22AE"
  },
  {
    "Retail Branding": "SWTV",
    "Marketing Name": "SWTV-22AE-4K",
    "Device": "anaheim",
    "Model": "SWTV-22AE-4K"
  },
  {
    "Retail Branding": "SWTV",
    "Marketing Name": "SWTV-22AE-4K NF",
    "Device": "anaheim",
    "Model": "SWTV-22AE-4K NF"
  },
  {
    "Retail Branding": "SWTV",
    "Marketing Name": "SWTV-22AE-FHD",
    "Device": "umeda",
    "Model": "SWTV-22AE-FHD"
  },
  {
    "Retail Branding": "SWTV",
    "Marketing Name": "SWTV-22COL-4K",
    "Device": "anaheim",
    "Model": "SWTV-22COL-4K"
  },
  {
    "Retail Branding": "SWTV",
    "Marketing Name": "SWTV-22HK-4K",
    "Device": "anaheim",
    "Model": "SWTV-22HK-4K"
  },
  {
    "Retail Branding": "SWTV",
    "Marketing Name": "SWTV-22HK-4K NF",
    "Device": "anaheim",
    "Model": "SWTV-22HK-4K NF"
  },
  {
    "Retail Branding": "SWTV",
    "Marketing Name": "SWTV-22NA-4K",
    "Device": "anaheim",
    "Model": "SWTV-22NA-4K"
  },
  {
    "Retail Branding": "SWTV",
    "Marketing Name": "SWTV-22NA-FHD",
    "Device": "umeda",
    "Model": "SWTV-22NA-FHD"
  },
  {
    "Retail Branding": "SWTV",
    "Marketing Name": "SWTV-22SA-4K",
    "Device": "anaheim",
    "Model": "SWTV-22SA-4K"
  },
  {
    "Retail Branding": "SWTV",
    "Marketing Name": "SWTV-22SA-FHD",
    "Device": "umeda",
    "Model": "SWTV-22SA-FHD"
  },
  {
    "Retail Branding": "SWTV",
    "Marketing Name": "SWTV-22TGS-4K",
    "Device": "anaheim",
    "Model": "SWTV-22TGS-4K"
  },
  {
    "Retail Branding": "SWTV",
    "Marketing Name": "SWTV-22TW-4K",
    "Device": "anaheim",
    "Model": "SWTV-22TW-4K"
  },
  {
    "Retail Branding": "SWTV",
    "Marketing Name": "SWTV-23AE-4KR3",
    "Device": "byculla",
    "Model": "SWTV-23AE-4KR3"
  },
  {
    "Retail Branding": "SWTV",
    "Marketing Name": "SWTV-23NA-4KR3",
    "Device": "byculla",
    "Model": "SWTV-23NA-4KR3"
  },
  {
    "Retail Branding": "SWTV",
    "Marketing Name": "SWTV-23SA-4KR3",
    "Device": "byculla",
    "Model": "SWTV-23SA-4KR3"
  },
  {
    "Retail Branding": "SWTV",
    "Marketing Name": "SWTV-24AE-4K",
    "Device": "eleonas",
    "Model": "SWTV-24AE-4K"
  },
  {
    "Retail Branding": "SWTV",
    "Marketing Name": "SWTV-24AE-4K NF",
    "Device": "eleonas",
    "Model": "SWTV-24AE-4K NF"
  },
  {
    "Retail Branding": "SWTV",
    "Marketing Name": "SWTV-24AE-FHD",
    "Device": "beomil",
    "Model": "SWTV-24AE-FHD"
  },
  {
    "Retail Branding": "SWTV",
    "Marketing Name": "SWTV-24HK-4K",
    "Device": "eleonas",
    "Model": "SWTV-24H-4K"
  },
  {
    "Retail Branding": "SWTV",
    "Marketing Name": "SWTV-24HK-4K",
    "Device": "eleonas",
    "Model": "SWTV-24HK-4K"
  },
  {
    "Retail Branding": "SWTV",
    "Marketing Name": "SWTV-24HK-4K NF",
    "Device": "eleonas",
    "Model": "SWTV-24H-4K NF"
  },
  {
    "Retail Branding": "SWTV",
    "Marketing Name": "SWTV-24HK-4K NF",
    "Device": "eleonas",
    "Model": "SWTV-24HK-4K NF"
  },
  {
    "Retail Branding": "SWTV",
    "Marketing Name": "SWTV-24HK-FHD",
    "Device": "beomil",
    "Model": "SWTV-24HK-FHD"
  },
  {
    "Retail Branding": "SWTV",
    "Marketing Name": "SWTV-24NA-4K",
    "Device": "eleonas",
    "Model": "SWTV-24NA-4K"
  },
  {
    "Retail Branding": "SWTV",
    "Marketing Name": "SWTV-24NA-4K NF",
    "Device": "eleonas",
    "Model": "SWTV-24NA-4K NF"
  },
  {
    "Retail Branding": "SWTV",
    "Marketing Name": "SWTV-24NA-FHD",
    "Device": "beomil",
    "Model": "SWTV-24NA-FHD"
  },
  {
    "Retail Branding": "SWTV",
    "Marketing Name": "SWTV-24SA-4K",
    "Device": "eleonas",
    "Model": "SWTV-24SA-4K"
  },
  {
    "Retail Branding": "SWTV",
    "Marketing Name": "SWTV-24SA-4K NF",
    "Device": "eleonas",
    "Model": "SWTV-24SA-4K NF"
  },
  {
    "Retail Branding": "SWTV",
    "Marketing Name": "SWTV-24SA-FHD",
    "Device": "beomil",
    "Model": "SWTV-24SA-FHD"
  },
  {
    "Retail Branding": "SWTV",
    "Marketing Name": "SWTV-25TGL-4K",
    "Device": "katehaki",
    "Model": "SWTV-25TGL-4K"
  },
  {
    "Retail Branding": "SWTV",
    "Marketing Name": "South America",
    "Device": "SW3_ATV",
    "Model": "SWTV"
  },
  {
    "Retail Branding": "SWTV",
    "Marketing Name": "TV",
    "Device": "SW3H_ATV",
    "Model": "SWTV"
  },
  {
    "Retail Branding": "SWTV",
    "Marketing Name": "Taiwan",
    "Device": "SW3H_ATV",
    "Model": "SWTV"
  },
  {
    "Retail Branding": "SYLVANIA",
    "Marketing Name": "4K Smart TV",
    "Device": "gangbyeon",
    "Model": "4K Smart TV"
  },
  {
    "Retail Branding": "SYLVANIA",
    "Marketing Name": "SLTDVD1024",
    "Device": "mdt1005_mk_32",
    "Model": "SLTDVD1024"
  },
  {
    "Retail Branding": "SYLVANIA",
    "Marketing Name": "SLTDVD1024_B",
    "Device": "SLTDVD1024_B",
    "Model": "SLTDVD1024_B"
  },
  {
    "Retail Branding": "SYLVANIA",
    "Marketing Name": "SLTDVD9220_C",
    "Device": "SLTDVD9220-C",
    "Model": "SLTDVD9220-C"
  },
  {
    "Retail Branding": "SYLVANIA",
    "Marketing Name": "Smart TV",
    "Device": "kanda",
    "Model": "2K Smart TV"
  },
  {
    "Retail Branding": "SYLVOX",
    "Marketing Name": "SYLVOX 2K Google TV",
    "Device": "capitolhill",
    "Model": "SYLVOX  2K Google TV"
  },
  {
    "Retail Branding": "SYLVOX",
    "Marketing Name": "SYLVOX 4K Google TV-A",
    "Device": "keoneae",
    "Model": "SYLVOX 4K Google TV-A"
  },
  {
    "Retail Branding": "SYLVOX",
    "Marketing Name": "SYLVOX 4K Google TV-B",
    "Device": "keoneae",
    "Model": "SYLVOX 4K Google TV-B"
  },
  {
    "Retail Branding": "SYLVOX",
    "Marketing Name": "SYLVOX 4K Google TV-D",
    "Device": "keoneae",
    "Model": "SYLVOX 4K Google TV-D"
  },
  {
    "Retail Branding": "SYLVOX",
    "Marketing Name": "SYLVOX 4K Google TV-E",
    "Device": "keoneae",
    "Model": "SYLVOX 4K Google TV-E"
  },
  {
    "Retail Branding": "SYLVOX",
    "Marketing Name": "SYLVOX Google TV",
    "Device": "bandra",
    "Model": "SYLVOX Google TV"
  },
  {
    "Retail Branding": "SYLVOX",
    "Marketing Name": "SYLVOX Google TV-A",
    "Device": "bandra",
    "Model": "SYLVOX Google TV-A"
  },
  {
    "Retail Branding": "SYLVOX",
    "Marketing Name": "Smart TV 2K",
    "Device": "lasalle",
    "Model": "Smart TV 2K"
  },
  {
    "Retail Branding": "SYLVOX",
    "Marketing Name": "Smart TV 2K-A",
    "Device": "lasalle",
    "Model": "Smart TV 2K-A"
  },
  {
    "Retail Branding": "SYLVOX",
    "Marketing Name": "Smart TV 2K-B",
    "Device": "lasalle",
    "Model": "Smart TV 2K-B"
  },
  {
    "Retail Branding": "SYLVOX",
    "Marketing Name": "Smart TV 4K",
    "Device": "kenton",
    "Model": "Smart TV 4K"
  },
  {
    "Retail Branding": "SYLVOX",
    "Marketing Name": "Smart TV 4K-A",
    "Device": "kenton",
    "Model": "Smart TV 4K-A"
  },
  {
    "Retail Branding": "SYLVOX",
    "Marketing Name": "Smart TV 4K-B",
    "Device": "kenton",
    "Model": "Smart TV 4K-B"
  },
  {
    "Retail Branding": "SYMFONY",
    "Marketing Name": "TAB_105",
    "Device": "TAB_105",
    "Model": "SYMFONY TAB 105"
  },
  {
    "Retail Branding": "SZSUPER",
    "Marketing Name": "KIDS05-X5",
    "Device": "KIDS05-X5",
    "Model": "KIDS05-X5"
  },
  {
    "Retail Branding": "Safaricom",
    "Marketing Name": "NEON LITE",
    "Device": "NEON_LITE",
    "Model": "NEON LITE"
  },
  {
    "Retail Branding": "Safaricom",
    "Marketing Name": "NEON PLUS",
    "Device": "NEON_PLUS",
    "Model": "NEON PLUS"
  },
  {
    "Retail Branding": "Safaricom",
    "Marketing Name": "NEON RAY 2",
    "Device": "NEON-RAY-2",
    "Model": "NEON RAY 2"
  },
  {
    "Retail Branding": "Safaricom",
    "Marketing Name": "NEON SKY",
    "Device": "NEON_SKY",
    "Model": "NEON_SKY"
  },
  {
    "Retail Branding": "Safaricom",
    "Marketing Name": "NEON STREAM",
    "Device": "NEON_STREAM",
    "Model": "NEON_STREAM"
  },
  {
    "Retail Branding": "Safaricom",
    "Marketing Name": "NEON VISION",
    "Device": "NEON_VISION",
    "Model": "NEON_VISION"
  },
  {
    "Retail Branding": "Safaricom",
    "Marketing Name": "NEON-RAY-2",
    "Device": "NEON-RAY-2",
    "Model": "NEON RAY 2"
  },
  {
    "Retail Branding": "Safaricom",
    "Marketing Name": "NEON_NOVA",
    "Device": "NEON_NOVA",
    "Model": "NEON_NOVA"
  },
  {
    "Retail Branding": "Safaricom",
    "Marketing Name": "NEON_RAY",
    "Device": "NEON_RAY",
    "Model": "NEON_RAY"
  },
  {
    "Retail Branding": "Safaricom",
    "Marketing Name": "NEON_RAY_2",
    "Device": "NEON_RAY_2",
    "Model": "NEON RAY 2"
  },
  {
    "Retail Branding": "Safaricom",
    "Marketing Name": "NEON_RAY_PRO",
    "Device": "NEON_RAY_PRO",
    "Model": "NEON_RAY_PRO"
  },
  {
    "Retail Branding": "Safaricom",
    "Marketing Name": "Neon Storm",
    "Device": "Neon_Storm",
    "Model": "Neon Storm"
  },
  {
    "Retail Branding": "Safaricom",
    "Marketing Name": "Neon Ultra 2",
    "Device": "Neon_Ultra_2",
    "Model": "Neon Ultra 2"
  },
  {
    "Retail Branding": "Safaricom",
    "Marketing Name": "Neon_Smarta_2",
    "Device": "Neon_Smarta_2",
    "Model": "Neon Smarta 2"
  },
  {
    "Retail Branding": "Safaricom",
    "Marketing Name": "Neon_Smarta_2",
    "Device": "Neon_Smarta_2",
    "Model": "Neon Smarta 2 H"
  },
  {
    "Retail Branding": "Safaricom",
    "Marketing Name": "Neon_Smarta_2",
    "Device": "Neon_Smarta_2",
    "Model": "Neon Smarta 2 K"
  },
  {
    "Retail Branding": "Safaricom",
    "Marketing Name": "Neon_Smarta_2",
    "Device": "Neon_Smarta_2",
    "Model": "Neon Smarta 2 T"
  },
  {
    "Retail Branding": "Safaricom",
    "Marketing Name": "Neon_Ultra_2_M",
    "Device": "Neon_Ultra_2_M",
    "Model": "Neon Ultra 2 M"
  },
  {
    "Retail Branding": "Safaricom",
    "Marketing Name": "SFCSTB2LITE",
    "Device": "SFCSTB2LITE",
    "Model": "SFCSTB2LITE"
  },
  {
    "Retail Branding": "Safaricom",
    "Marketing Name": "Safaricom ET Kimem",
    "Device": "Safaricom_ET_Kimem",
    "Model": "Safaricom ET Kimem"
  },
  {
    "Retail Branding": "Safaricom",
    "Marketing Name": "Sajipro",
    "Device": "Sajipro",
    "Model": "Sajipro"
  },
  {
    "Retail Branding": "SafeGear_Mobile",
    "Marketing Name": "SG390",
    "Device": "SG390",
    "Model": "SG390"
  },
  {
    "Retail Branding": "Safex_Instruments",
    "Marketing Name": "Ex Mobile 20",
    "Device": "Ex_Mobile_20",
    "Model": "Ex_Mobile_20_Series"
  },
  {
    "Retail Branding": "Safex_Instruments",
    "Marketing Name": "Ex_Mobile_20_NC",
    "Device": "Ex_Mobile_20_NC",
    "Model": "Ex_Mobile_20_Series"
  },
  {
    "Retail Branding": "Sagemcom",
    "Marketing Name": "Wibox",
    "Device": "dtiw384wb",
    "Model": "m384wb"
  },
  {
    "Retail Branding": "Saltillo",
    "Marketing Name": "CF10",
    "Device": "CF10",
    "Model": "CF10"
  },
  {
    "Retail Branding": "Samsonix",
    "Marketing Name": "A1250",
    "Device": "A1250",
    "Model": "A125"
  },
  {
    "Retail Branding": "Samsonix",
    "Marketing Name": "A1250",
    "Device": "A1250",
    "Model": "A1250"
  },
  {
    "Retail Branding": "Samsonix",
    "Marketing Name": "W12",
    "Device": "W12",
    "Model": "P34 Ultra"
  },
  {
    "Retail Branding": "Samsonix",
    "Marketing Name": "W12",
    "Device": "W12",
    "Model": "W12"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "",
    "Device": "GT-I5510M",
    "Model": "GT-I5510M"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "",
    "Device": "GT-I5510T",
    "Model": "GT-I5510T"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "",
    "Device": "GT-I5800L",
    "Model": "GT-I5800L"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "",
    "Device": "GT-N7000B",
    "Model": "GT-N7000B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "",
    "Device": "GT-P7300B",
    "Model": "GT-P7300B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "",
    "Device": "GT-P7320T",
    "Model": "GT-P7320T"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "",
    "Device": "GT-P7500M",
    "Model": "GT-P7500M"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "",
    "Device": "GT-P7500R",
    "Model": "GT-P7500R"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "",
    "Device": "GT-P7500V",
    "Model": "GT-P7500V"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "",
    "Device": "GT-S5698",
    "Model": "GT-S5698"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "",
    "Device": "GT-S5820",
    "Model": "GT-S5820"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "",
    "Device": "GT-S5830V",
    "Model": "GT-S5830V"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "",
    "Device": "SCH-I339",
    "Model": "SCH-I339"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "",
    "Device": "SCH-I405U",
    "Model": "SCH-I405U"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "",
    "Device": "SCH-I509U",
    "Model": "SCH-I509U"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "",
    "Device": "SCH-I519",
    "Model": "SCH-I519"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "",
    "Device": "SCH-I559",
    "Model": "SCH-I559"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "",
    "Device": "SCH-I559",
    "Model": "SCH-i559"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "",
    "Device": "SCH-I639",
    "Model": "SCH-I639"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "",
    "Device": "SCH-I659",
    "Model": "SCH-I659"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "",
    "Device": "SCH-I699",
    "Model": "SCH-I699"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "",
    "Device": "SCH-I779",
    "Model": "SCH-I779"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "",
    "Device": "SCH-I919U",
    "Model": "SCH-I919U"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "",
    "Device": "SCH-W899",
    "Model": "SCH-W899"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "",
    "Device": "SCH-W999",
    "Model": "SCH-W999"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "",
    "Device": "SCH-i809",
    "Model": "SCH-i809"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "",
    "Device": "SCH-i919",
    "Model": "SCH-i919"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "",
    "Device": "SGH-I987",
    "Model": "SGH-I987"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "",
    "Device": "SGH_T939",
    "Model": "Behold II"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "",
    "Device": "SHV-E150S",
    "Model": "SHV-E150S"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "",
    "Device": "SHW-M115S",
    "Model": "SHW-M115S"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "",
    "Device": "SHW-M135K",
    "Model": "SHW-M135K"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "",
    "Device": "SHW-M135L",
    "Model": "SHW-M135L"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "",
    "Device": "SHW-M340D",
    "Model": "SHW-M340D"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "",
    "Device": "SHW-M340K",
    "Model": "SHW-M340K"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "",
    "Device": "SHW-M460D",
    "Model": "SHW-M460D"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "",
    "Device": "amazingtrf",
    "Model": "SGH-S730G"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "",
    "Device": "aruba3gchn",
    "Model": "GT-I8262D"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "",
    "Device": "espressorfcmcc",
    "Model": "GT-P3108"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "",
    "Device": "gd1ltektt",
    "Model": "EK-KC120K"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "",
    "Device": "godivaltevzw",
    "Model": "SCH-I425"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "",
    "Device": "ironcmcc",
    "Model": "GT-B9388"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "",
    "Device": "m0grandectc",
    "Model": "SCH-W2013"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "",
    "Device": "m0grandectc",
    "Model": "SCH-W9913"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "",
    "Device": "p4noterfskt",
    "Model": "SHW-M480S"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "",
    "Device": "stunnerltespr",
    "Model": "SPH-L500"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "",
    "Device": "superiorchn",
    "Model": "GT-I9260"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Absolute",
    "Device": "GT-B9120",
    "Model": "GT-B9120"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Acclaim",
    "Device": "SCH-R880",
    "Model": "SCH-R880"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Admire",
    "Device": "SCH-R720",
    "Model": "SCH-R720"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Amazing",
    "Device": "amazingtrf",
    "Model": "SGH-S730M"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Baffin",
    "Device": "baffinltelgt",
    "Model": "SHV-E270L"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Captivate Glide",
    "Device": "SGH-I927",
    "Model": "SAMSUNG-SGH-I927"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Captivate Glide",
    "Device": "SGH-I927",
    "Model": "SGH-I927"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "China Telecom",
    "Device": "kylevectc",
    "Model": "SCH-I699I"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Chromebook 3",
    "Device": "celes_cheets",
    "Model": "Samsung Chromebook 3"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Chromebook Plus",
    "Device": "",
    "Model": ""
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Chromebook Plus",
    "Device": "kevin_cheets",
    "Model": "Samsung Chromebook Plus"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Chromebook Plus",
    "Device": "kevin_cheets",
    "Model": "kevin"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Chromebook Plus (V2)",
    "Device": "nautilus_cheets",
    "Model": "Samsung Chromebook Plus (V2)"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Chromebook Plus (V2)",
    "Device": "nautilus_cheets",
    "Model": "nautilus"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Chromebook Pro",
    "Device": "",
    "Model": ""
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Chromebook Pro",
    "Device": "caroline_cheets",
    "Model": "Samsung Chromebook Pro"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Chromebook Pro",
    "Device": "caroline_cheets",
    "Model": "caroline"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Conquer",
    "Device": "SPH-D600",
    "Model": "SPH-D600"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "DoubleTime",
    "Device": "SGH-I857",
    "Model": "SAMSUNG-SGH-I857"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Droid Charge",
    "Device": "SCH-I510",
    "Model": "SCH-I510"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Elite",
    "Device": "eliteltechn",
    "Model": "SM-G1600"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Elite",
    "Device": "elitexltechn",
    "Model": "SM-G1650"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Europa",
    "Device": "GT-I5500B",
    "Model": "GT-I5500B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Europa",
    "Device": "GT-I5500L",
    "Model": "GT-I5500L"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Europa",
    "Device": "GT-I5500M",
    "Model": "GT-I5500M"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Europa",
    "Device": "GT-I5503T",
    "Model": "GT-I5503T"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Europa",
    "Device": "GT-I5510L",
    "Model": "GT-I5510L"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Exhibit",
    "Device": "SGH-T759",
    "Model": "SGH-T759"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "GALAXY Camera",
    "Device": "gd1",
    "Model": "EK-GC100"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy (China)",
    "Device": "GT-B9062",
    "Model": "GT-B9062"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy 070",
    "Device": "hendrix",
    "Model": "YP-GI2"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A",
    "Device": "archer",
    "Model": "SHW-M100S"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A",
    "Device": "archer",
    "Model": "archer"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A Quantum",
    "Device": "a71x",
    "Model": "SM-A716S"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A01",
    "Device": "a01q",
    "Model": "SM-A015A"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A01",
    "Device": "a01q",
    "Model": "SM-A015AZ"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A01",
    "Device": "a01q",
    "Model": "SM-A015F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A01",
    "Device": "a01q",
    "Model": "SM-A015G"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A01",
    "Device": "a01q",
    "Model": "SM-A015M"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A01",
    "Device": "a01q",
    "Model": "SM-A015T1"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A01",
    "Device": "a01q",
    "Model": "SM-A015U"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A01",
    "Device": "a01q",
    "Model": "SM-A015U1"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A01",
    "Device": "a01q",
    "Model": "SM-A015V"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A01",
    "Device": "a01q",
    "Model": "SM-S111DL"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A01 Core",
    "Device": "a01core",
    "Model": "SM-A013F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A01 Core",
    "Device": "a01core",
    "Model": "SM-A013G"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A01 Core",
    "Device": "a01core",
    "Model": "SM-A013M"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A02",
    "Device": "a02",
    "Model": "SM-A022F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A02",
    "Device": "a02",
    "Model": "SM-A022G"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A02",
    "Device": "a02",
    "Model": "SM-A022M"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A02s",
    "Device": "a02q",
    "Model": "SM-A025A"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A02s",
    "Device": "a02q",
    "Model": "SM-A025AZ"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A02s",
    "Device": "a02q",
    "Model": "SM-A025F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A02s",
    "Device": "a02q",
    "Model": "SM-A025G"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A02s",
    "Device": "a02q",
    "Model": "SM-A025M"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A02s",
    "Device": "a02q",
    "Model": "SM-A025U"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A02s",
    "Device": "a02q",
    "Model": "SM-A025U1"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A02s",
    "Device": "a02q",
    "Model": "SM-A025V"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A02s",
    "Device": "a02q",
    "Model": "SM-S124DL"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A03",
    "Device": "a03",
    "Model": "SM-A035F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A03",
    "Device": "a03",
    "Model": "SM-A035G"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A03",
    "Device": "a03",
    "Model": "SM-A035M"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A03 Core",
    "Device": "a3core",
    "Model": "SM-A032F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A03 Core",
    "Device": "a3core",
    "Model": "SM-A032M"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A03s",
    "Device": "a03s",
    "Model": "SM-A037F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A03s",
    "Device": "a03s",
    "Model": "SM-A037G"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A03s",
    "Device": "a03s",
    "Model": "SM-A037M"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A03s",
    "Device": "a03su",
    "Model": "SM-A037U"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A03s",
    "Device": "a03su",
    "Model": "SM-A037U1"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A03s",
    "Device": "a03su",
    "Model": "SM-A037W"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A03s",
    "Device": "a03su",
    "Model": "SM-S134DL"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A04",
    "Device": "a04",
    "Model": "SM-A045F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A04",
    "Device": "a04",
    "Model": "SM-A045M"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A04e",
    "Device": "a04e",
    "Model": "SM-A042F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A04e",
    "Device": "a04e",
    "Model": "SM-A042M"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A04s",
    "Device": "a04s",
    "Model": "SM-A047F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A04s",
    "Device": "a04s",
    "Model": "SM-A047M"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A05",
    "Device": "a05m",
    "Model": "SM-A055F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A05",
    "Device": "a05m",
    "Model": "SM-A055M"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A05s",
    "Device": "a05s",
    "Model": "SM-A057F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A05s",
    "Device": "a05s",
    "Model": "SM-A057G"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A05s",
    "Device": "a05s",
    "Model": "SM-A057M"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A06",
    "Device": "a06",
    "Model": "SM-A065F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A06",
    "Device": "a06",
    "Model": "SM-A065M"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A06 5G",
    "Device": "a06x",
    "Model": "SM-A066B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A06 5G",
    "Device": "a06x",
    "Model": "SM-A066E"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A06 5G",
    "Device": "a06x",
    "Model": "SM-A066M"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A07",
    "Device": "a07",
    "Model": "SM-A075F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A07",
    "Device": "a07",
    "Model": "SM-A075M"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A07 5G",
    "Device": "a07x",
    "Model": "SM-A076B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A07 5G",
    "Device": "a07x",
    "Model": "SM-A076E"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A07 5G",
    "Device": "a07x",
    "Model": "SM-A076M"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A10",
    "Device": "a10",
    "Model": "SM-A105F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A10",
    "Device": "a10",
    "Model": "SM-A105FN"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A10",
    "Device": "a10",
    "Model": "SM-A105G"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A10",
    "Device": "a10",
    "Model": "SM-A105M"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A10",
    "Device": "a10",
    "Model": "SM-A105N"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A10e",
    "Device": "a10e",
    "Model": "SM-A102U"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A10e",
    "Device": "a10e",
    "Model": "SM-A102U1"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A10e",
    "Device": "a10e",
    "Model": "SM-A102W"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A10e",
    "Device": "a10e",
    "Model": "SM-S102DL"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A10e",
    "Device": "a10ekx",
    "Model": "SM-A102N"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A10s",
    "Device": "a10s",
    "Model": "SM-A107F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A10s",
    "Device": "a10s",
    "Model": "SM-A107M"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A11",
    "Device": "a11q",
    "Model": "SM-A115A"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A11",
    "Device": "a11q",
    "Model": "SM-A115AP"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A11",
    "Device": "a11q",
    "Model": "SM-A115AZ"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A11",
    "Device": "a11q",
    "Model": "SM-A115F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A11",
    "Device": "a11q",
    "Model": "SM-A115M"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A11",
    "Device": "a11q",
    "Model": "SM-A115U"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A11",
    "Device": "a11q",
    "Model": "SM-A115U1"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A11",
    "Device": "a11q",
    "Model": "SM-A115W"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A11",
    "Device": "a11q",
    "Model": "SM-S115DL"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A12",
    "Device": "a12",
    "Model": "SM-A125F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A12",
    "Device": "a12",
    "Model": "SM-A125M"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A12",
    "Device": "a12",
    "Model": "SM-A125N"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A12",
    "Device": "a12s",
    "Model": "SM-A127F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A12",
    "Device": "a12s",
    "Model": "SM-A127M"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A12",
    "Device": "a12u",
    "Model": "SM-A125U"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A12",
    "Device": "a12u",
    "Model": "SM-A125U1"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A12",
    "Device": "a12u",
    "Model": "SM-A125W"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A12",
    "Device": "a12u",
    "Model": "SM-S127DL"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A13",
    "Device": "a13",
    "Model": "SM-A135F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A13",
    "Device": "a13",
    "Model": "SM-A135M"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A13",
    "Device": "a13",
    "Model": "SM-A135N"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A13",
    "Device": "a13",
    "Model": "SM-A135U"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A13",
    "Device": "a13",
    "Model": "SM-A135U1"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A13",
    "Device": "a13ve",
    "Model": "SM-A137F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A13 5G",
    "Device": "a13x",
    "Model": "SM-A136B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A13 5G",
    "Device": "a13x",
    "Model": "SM-A136M"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A13 5G",
    "Device": "a13x",
    "Model": "SM-A136S"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A13 5G",
    "Device": "a13x",
    "Model": "SM-A136U"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A13 5G",
    "Device": "a13x",
    "Model": "SM-A136U1"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A13 5G",
    "Device": "a13x",
    "Model": "SM-A136W"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A13 5G",
    "Device": "a13x",
    "Model": "SM-S136DL"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A14",
    "Device": "a14",
    "Model": "SM-A145F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A14",
    "Device": "a14",
    "Model": "SM-A145FB"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A14",
    "Device": "a14",
    "Model": "SM-A145M"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A14",
    "Device": "a14",
    "Model": "SM-A145MB"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A14",
    "Device": "a14m",
    "Model": "SM-A145P"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A14",
    "Device": "a14m",
    "Model": "SM-A145R"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A14 5G",
    "Device": "a14x",
    "Model": "SM-A146B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A14 5G",
    "Device": "a14x",
    "Model": "SM-A146M"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A14 5G",
    "Device": "a14xm",
    "Model": "SM-A146P"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A14 5G",
    "Device": "a14xm",
    "Model": "SM-A146U"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A14 5G",
    "Device": "a14xm",
    "Model": "SM-A146U1"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A14 5G",
    "Device": "a14xm",
    "Model": "SM-A146W"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A14 5G",
    "Device": "a14xm",
    "Model": "SM-S146VL"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A15",
    "Device": "a15",
    "Model": "SM-A155F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A15",
    "Device": "a15",
    "Model": "SM-A155M"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A15",
    "Device": "a15",
    "Model": "SM-A155N"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A15 5G",
    "Device": "a15x",
    "Model": "SM-A1560"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A15 5G",
    "Device": "a15x",
    "Model": "SM-A156B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A15 5G",
    "Device": "a15x",
    "Model": "SM-A156E"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A15 5G",
    "Device": "a15x",
    "Model": "SM-A156M"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A15 5G",
    "Device": "a15x",
    "Model": "SM-A156U"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A15 5G",
    "Device": "a15x",
    "Model": "SM-A156U1"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A15 5G",
    "Device": "a15x",
    "Model": "SM-A156W"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A15 5G",
    "Device": "a15x",
    "Model": "SM-S156V"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A16",
    "Device": "a16",
    "Model": "SM-A165F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A16",
    "Device": "a16",
    "Model": "SM-A165M"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A16",
    "Device": "a16",
    "Model": "SM-A165N"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A16 5G",
    "Device": "a16x",
    "Model": "SM-A1660"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A16 5G",
    "Device": "a16x",
    "Model": "SM-A166B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A16 5G",
    "Device": "a16x",
    "Model": "SM-A166E"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A16 5G",
    "Device": "a16x",
    "Model": "SM-A166M"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A16 5G",
    "Device": "a16x",
    "Model": "SM-A166U"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A16 5G",
    "Device": "a16x",
    "Model": "SM-A166U1"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A16 5G",
    "Device": "a16x",
    "Model": "SM-A166W"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A16 5G",
    "Device": "a16x",
    "Model": "SM-S166V"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A16 5G",
    "Device": "a16xm",
    "Model": "SM-A166P"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A17",
    "Device": "a17",
    "Model": "SM-A175F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A17",
    "Device": "a17",
    "Model": "SM-A175N"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A17 5G",
    "Device": "a17x",
    "Model": "SM-A1760"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A17 5G",
    "Device": "a17x",
    "Model": "SM-A176B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A17 5G",
    "Device": "a17x",
    "Model": "SM-A176U"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A17 5G",
    "Device": "a17x",
    "Model": "SM-A176U1"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A17 5G",
    "Device": "a17x",
    "Model": "SM-A176W"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A17 5G",
    "Device": "a17x",
    "Model": "SM-S176V"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A2 Core",
    "Device": "a2corelte",
    "Model": "SM-A260F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A2 Core",
    "Device": "a2corelte",
    "Model": "SM-A260G"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A20",
    "Device": "SC-02M",
    "Model": "SC-02M"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A20",
    "Device": "SCV46",
    "Model": "SCV46"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A20",
    "Device": "SCV46",
    "Model": "SCV46-j"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A20",
    "Device": "SCV46",
    "Model": "SCV46-u"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A20",
    "Device": "a20",
    "Model": "SM-A205F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A20",
    "Device": "a20",
    "Model": "SM-A205FN"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A20",
    "Device": "a20",
    "Model": "SM-A205G"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A20",
    "Device": "a20",
    "Model": "SM-A205GN"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A20",
    "Device": "a20",
    "Model": "SM-A205W"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A20",
    "Device": "a20",
    "Model": "SM-A205YN"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A20",
    "Device": "a20p",
    "Model": "SM-A205U"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A20",
    "Device": "a20p",
    "Model": "SM-A205U1"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A20",
    "Device": "a20p",
    "Model": "SM-S205DL"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A20e",
    "Device": "a20e",
    "Model": "SM-A202F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A20s",
    "Device": "a20s",
    "Model": "SM-A2070"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A20s",
    "Device": "a20s",
    "Model": "SM-A207F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A20s",
    "Device": "a20s",
    "Model": "SM-A207M"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A21",
    "Device": "SC-42A",
    "Model": "SC-42A"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A21",
    "Device": "SCV49",
    "Model": "SCV49"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A21",
    "Device": "a21",
    "Model": "SM-A215U"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A21",
    "Device": "a21",
    "Model": "SM-A215U1"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A21",
    "Device": "a21",
    "Model": "SM-A215W"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A21",
    "Device": "a21",
    "Model": "SM-S215DL"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A21s",
    "Device": "a21s",
    "Model": "SM-A217F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A21s",
    "Device": "a21s",
    "Model": "SM-A217M"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A21s",
    "Device": "a21s",
    "Model": "SM-A217N"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A22",
    "Device": "a22",
    "Model": "SM-A225F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A22",
    "Device": "a22",
    "Model": "SM-A225M"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A22 5G",
    "Device": "SC-56B",
    "Model": "SC-56B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A22 5G",
    "Device": "a22x",
    "Model": "SM-A226B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A22 5G",
    "Device": "a22x",
    "Model": "SM-A226BR"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A22s 5G",
    "Device": "a22x",
    "Model": "SM-A226B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A23",
    "Device": "a23",
    "Model": "SM-A235F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A23",
    "Device": "a23",
    "Model": "SM-A235M"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A23",
    "Device": "a23",
    "Model": "SM-A235N"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A23 5G",
    "Device": "SC-56C",
    "Model": "SC-56C"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A23 5G",
    "Device": "SCG18",
    "Model": "SCG18"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A23 5G",
    "Device": "a23ex",
    "Model": "SM-A233C"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A23 5G",
    "Device": "a23xq",
    "Model": "SM-A2360"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A23 5G",
    "Device": "a23xq",
    "Model": "SM-A236B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A23 5G",
    "Device": "a23xq",
    "Model": "SM-A236E"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A23 5G",
    "Device": "a23xq",
    "Model": "SM-A236M"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A23 5G",
    "Device": "a23xq",
    "Model": "SM-A236U"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A23 5G",
    "Device": "a23xq",
    "Model": "SM-A236U1"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A23 5G",
    "Device": "a23xq",
    "Model": "SM-S236DL"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A23 5G",
    "Device": "a23xq",
    "Model": "SM-S237VL"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A23 5G UW",
    "Device": "a23xq",
    "Model": "SM-A236V"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A24",
    "Device": "a24",
    "Model": "SM-A245F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A24",
    "Device": "a24",
    "Model": "SM-A245M"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A24",
    "Device": "a24",
    "Model": "SM-A245N"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A25 5G",
    "Device": "SC-53F",
    "Model": "SC-53F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A25 5G",
    "Device": "SCG33",
    "Model": "SCG33"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A25 5G",
    "Device": "a25ex",
    "Model": "SM-A253C"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A25 5G",
    "Device": "a25ex",
    "Model": "SM-A253Q"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A25 5G",
    "Device": "a25ex",
    "Model": "SM-A253Z"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A25 5G",
    "Device": "a25x",
    "Model": "SM-A2560"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A25 5G",
    "Device": "a25x",
    "Model": "SM-A256B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A25 5G",
    "Device": "a25x",
    "Model": "SM-A256E"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A25 5G",
    "Device": "a25x",
    "Model": "SM-A256N"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A25 5G",
    "Device": "a25x",
    "Model": "SM-A256U"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A25 5G",
    "Device": "a25x",
    "Model": "SM-A256U1"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A25 5G",
    "Device": "a25x",
    "Model": "SM-S256VL"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A26 5G",
    "Device": "a26x",
    "Model": "SM-A266B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A26 5G",
    "Device": "a26x",
    "Model": "SM-A266U"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A26 5G",
    "Device": "a26x",
    "Model": "SM-A266U1"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A26 5G",
    "Device": "a26x",
    "Model": "SM-S266V"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A26 5G",
    "Device": "a26xs",
    "Model": "SM-A266M"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A3",
    "Device": "a33g",
    "Model": "SM-A300H"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A3",
    "Device": "a3lte",
    "Model": "SM-A300F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A3",
    "Device": "a3lte",
    "Model": "SM-A300M"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A3",
    "Device": "a3lte",
    "Model": "SM-A300XZ"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A3",
    "Device": "a3lte",
    "Model": "SM-A300YZ"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A3",
    "Device": "a3ltechn",
    "Model": "SM-A3000"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A3",
    "Device": "a3ltechn",
    "Model": "SM-A300X"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A3",
    "Device": "a3ltectc",
    "Model": "SM-A3009"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A3",
    "Device": "a3ltedd",
    "Model": "SM-A300G"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A3",
    "Device": "a3lteslk",
    "Model": "SM-A300F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A3",
    "Device": "a3ltezh",
    "Model": "SM-A3000"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A3",
    "Device": "a3ltezt",
    "Model": "SM-A300YZ"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A3",
    "Device": "a3ulte",
    "Model": "SM-A300FU"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A3",
    "Device": "a3ulte",
    "Model": "SM-A300XU"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A3",
    "Device": "a3ulte",
    "Model": "SM-A300Y"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A3 (2017)",
    "Device": "a3y17lte",
    "Model": "SM-A320Y"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A3 Core",
    "Device": "a01core",
    "Model": "SM-A013G"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A3(2016)",
    "Device": "a3xelte",
    "Model": "SM-A310F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A3(2016)",
    "Device": "a3xelte",
    "Model": "SM-A310M"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A3(2016)",
    "Device": "a3xelte",
    "Model": "SM-A310X"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A3(2016)",
    "Device": "a3xelte",
    "Model": "SM-A310Y"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A3(2016)",
    "Device": "a3xeltekx",
    "Model": "SM-A310N0"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A3(2017)",
    "Device": "a3y17lte",
    "Model": "SM-A320F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A3(2017)",
    "Device": "a3y17lte",
    "Model": "SM-A320FL"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A3(2017)",
    "Device": "a3y17lte",
    "Model": "SM-A320X"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A30",
    "Device": "SCV43",
    "Model": "SCV43"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A30",
    "Device": "SCV43-j",
    "Model": "SCV43-j"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A30",
    "Device": "SCV43-u",
    "Model": "SCV43-u"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A30",
    "Device": "a30",
    "Model": "SM-A305F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A30",
    "Device": "a30",
    "Model": "SM-A305FN"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A30",
    "Device": "a30",
    "Model": "SM-A305G"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A30",
    "Device": "a30",
    "Model": "SM-A305GN"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A30",
    "Device": "a30",
    "Model": "SM-A305GT"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A30",
    "Device": "a30",
    "Model": "SM-A305N"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A30",
    "Device": "a30",
    "Model": "SM-A305YN"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A30s",
    "Device": "a30s",
    "Model": "SM-A307FN"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A30s",
    "Device": "a30s",
    "Model": "SM-A307G"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A30s",
    "Device": "a30s",
    "Model": "SM-A307GN"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A30s",
    "Device": "a30s",
    "Model": "SM-A307GT"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A31",
    "Device": "a31",
    "Model": "SM-A315F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A31",
    "Device": "a31",
    "Model": "SM-A315G"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A31",
    "Device": "a31",
    "Model": "SM-A315N"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A32",
    "Device": "a32",
    "Model": "SM-A325F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A32",
    "Device": "a32",
    "Model": "SM-A325M"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A32",
    "Device": "a32",
    "Model": "SM-A325N"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A32 5G",
    "Device": "SCG08",
    "Model": "SCG08"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A32 5G",
    "Device": "a32x",
    "Model": "SM-A326B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A32 5G",
    "Device": "a32x",
    "Model": "SM-A326BR"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A32 5G",
    "Device": "a32x",
    "Model": "SM-A326U"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A32 5G",
    "Device": "a32x",
    "Model": "SM-A326U1"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A32 5G",
    "Device": "a32x",
    "Model": "SM-A326W"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A32 5G",
    "Device": "a32x",
    "Model": "SM-S326DL"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A33 5G",
    "Device": "a33x",
    "Model": "SM-A3360"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A33 5G",
    "Device": "a33x",
    "Model": "SM-A336B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A33 5G",
    "Device": "a33x",
    "Model": "SM-A336E"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A33 5G",
    "Device": "a33x",
    "Model": "SM-A336M"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A33 5G",
    "Device": "a33x",
    "Model": "SM-A336N"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A34 5G",
    "Device": "a34x",
    "Model": "SM-A3460"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A34 5G",
    "Device": "a34x",
    "Model": "SM-A346B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A34 5G",
    "Device": "a34x",
    "Model": "SM-A346E"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A34 5G",
    "Device": "a34x",
    "Model": "SM-A346M"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A34 5G",
    "Device": "a34x",
    "Model": "SM-A346N"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A35 5G",
    "Device": "a35x",
    "Model": "SM-A3560"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A35 5G",
    "Device": "a35x",
    "Model": "SM-A356B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A35 5G",
    "Device": "a35x",
    "Model": "SM-A356E"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A35 5G",
    "Device": "a35x",
    "Model": "SM-A356N"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A35 5G",
    "Device": "a35x",
    "Model": "SM-A356U"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A35 5G",
    "Device": "a35x",
    "Model": "SM-A356U1"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A35 5G",
    "Device": "a35x",
    "Model": "SM-A356W"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A35 5G",
    "Device": "a35x",
    "Model": "SM-S356V"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A36 5G",
    "Device": "SC-54F",
    "Model": "SC-54F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A36 5G",
    "Device": "a36xq",
    "Model": "SM-A3660"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A36 5G",
    "Device": "a36xq",
    "Model": "SM-A366B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A36 5G",
    "Device": "a36xq",
    "Model": "SM-A366E"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A36 5G",
    "Device": "a36xq",
    "Model": "SM-A366N"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A36 5G",
    "Device": "a36xq",
    "Model": "SM-A366Q"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A36 5G",
    "Device": "a36xq",
    "Model": "SM-A366U"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A36 5G",
    "Device": "a36xq",
    "Model": "SM-A366U1"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A36 5G",
    "Device": "a36xq",
    "Model": "SM-A366W"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A36 5G",
    "Device": "a36xq",
    "Model": "SM-S366V"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A37 5G",
    "Device": "a37x",
    "Model": "SM-A3760"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A37 5G",
    "Device": "a37x",
    "Model": "SM-A376B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A37 5G",
    "Device": "a37x",
    "Model": "SM-A376E"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A37 5G",
    "Device": "a37x",
    "Model": "SM-A376U"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A37 5G",
    "Device": "a37x",
    "Model": "SM-A376U1"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A37 5G",
    "Device": "a37x",
    "Model": "SM-A376W"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A37 5G",
    "Device": "a37x",
    "Model": "SM-S376V"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A40",
    "Device": "a40",
    "Model": "SM-A405FM"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A40",
    "Device": "a40",
    "Model": "SM-A405FN"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A40",
    "Device": "a40",
    "Model": "SM-A405S"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A40s",
    "Device": "a30c",
    "Model": "SM-A3050"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A40s",
    "Device": "a30c",
    "Model": "SM-A3051"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A40s",
    "Device": "a30c",
    "Model": "SM-A3058"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A41",
    "Device": "SC-41A",
    "Model": "SC-41A"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A41",
    "Device": "SCV48",
    "Model": "SCV48"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A41",
    "Device": "a41",
    "Model": "SM-A415F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A42 5G",
    "Device": "a42xq",
    "Model": "SM-A4260"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A42 5G",
    "Device": "a42xq",
    "Model": "SM-A426B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A42 5G",
    "Device": "a42xq",
    "Model": "SM-A426N"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A42 5G",
    "Device": "a42xuq",
    "Model": "SM-A426U"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A42 5G",
    "Device": "a42xuq",
    "Model": "SM-A426U1"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A42 5G",
    "Device": "a42xuq",
    "Model": "SM-S426DL"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A5",
    "Device": "a53g",
    "Model": "SM-A500H"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A5",
    "Device": "a5lte",
    "Model": "SM-A500F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A5",
    "Device": "a5lte",
    "Model": "SM-A500G"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A5",
    "Device": "a5lte",
    "Model": "SM-A500M"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A5",
    "Device": "a5lte",
    "Model": "SM-A500XZ"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A5",
    "Device": "a5ltechn",
    "Model": "SM-A5000"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A5",
    "Device": "a5ltechn",
    "Model": "SM-A500X"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A5",
    "Device": "a5ltectc",
    "Model": "SM-A5009"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A5",
    "Device": "a5ltezh",
    "Model": "SM-A5000"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A5",
    "Device": "a5ltezt",
    "Model": "SM-A500YZ"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A5",
    "Device": "a5ulte",
    "Model": "SM-A500FU"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A5",
    "Device": "a5ulte",
    "Model": "SM-A500Y"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A5",
    "Device": "a5ultebmc",
    "Model": "SM-A500W"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A5",
    "Device": "a5ultektt",
    "Model": "SM-A500K"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A5",
    "Device": "a5ultelgt",
    "Model": "SM-A500L"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A5",
    "Device": "a5ulteskt",
    "Model": "SM-A500F1"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A5",
    "Device": "a5ulteskt",
    "Model": "SM-A500S"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A5 (2016)",
    "Device": "a5xeltextc",
    "Model": "SM-A510Y"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A5(2016)",
    "Device": "a5xelte",
    "Model": "SM-A510F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A5(2016)",
    "Device": "a5xelte",
    "Model": "SM-A510M"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A5(2016)",
    "Device": "a5xelte",
    "Model": "SM-A510X"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A5(2016)",
    "Device": "a5xelte",
    "Model": "SM-A510Y"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A5(2016)",
    "Device": "a5xeltecmcc",
    "Model": "SM-A5108"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A5(2016)",
    "Device": "a5xeltektt",
    "Model": "SM-A510K"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A5(2016)",
    "Device": "a5xeltelgt",
    "Model": "SM-A510L"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A5(2016)",
    "Device": "a5xelteskt",
    "Model": "SM-A510S"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A5(2016)",
    "Device": "a5xeltextc",
    "Model": "SM-A510Y"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A5(2016)",
    "Device": "a5xltechn",
    "Model": "SM-A5100"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A5(2016)",
    "Device": "a5xltechn",
    "Model": "SM-A5100X"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A5(2016)",
    "Device": "a5xltechn",
    "Model": "SM-A510XZ"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A5(2017)",
    "Device": "a5y17lte",
    "Model": "SM-A520F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A5(2017)",
    "Device": "a5y17lte",
    "Model": "SM-A520X"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A5(2017)",
    "Device": "a5y17ltecan",
    "Model": "SM-A520W"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A5(2017)",
    "Device": "a5y17ltektt",
    "Model": "SM-A520K"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A5(2017)",
    "Device": "a5y17ltelgt",
    "Model": "SM-A520L"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A5(2017)",
    "Device": "a5y17lteskt",
    "Model": "SM-A520S"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A50",
    "Device": "a50",
    "Model": "SM-A505F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A50",
    "Device": "a50",
    "Model": "SM-A505FM"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A50",
    "Device": "a50",
    "Model": "SM-A505FN"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A50",
    "Device": "a50",
    "Model": "SM-A505G"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A50",
    "Device": "a50",
    "Model": "SM-A505GN"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A50",
    "Device": "a50",
    "Model": "SM-A505GT"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A50",
    "Device": "a50",
    "Model": "SM-A505N"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A50",
    "Device": "a50",
    "Model": "SM-A505U"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A50",
    "Device": "a50",
    "Model": "SM-A505U1"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A50",
    "Device": "a50",
    "Model": "SM-A505W"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A50",
    "Device": "a50",
    "Model": "SM-A505YN"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A50",
    "Device": "a50",
    "Model": "SM-S506DL"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A50s",
    "Device": "a50s",
    "Model": "SM-A5070"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A50s",
    "Device": "a50s",
    "Model": "SM-A507FN"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A51",
    "Device": "a51",
    "Model": "SM-A515F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A51",
    "Device": "a51",
    "Model": "SM-A515U"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A51",
    "Device": "a51",
    "Model": "SM-A515U1"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A51",
    "Device": "a51",
    "Model": "SM-A515W"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A51",
    "Device": "a51",
    "Model": "SM-A515X"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A51",
    "Device": "a51",
    "Model": "SM-S515DL"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A51 5G",
    "Device": "SC-54A",
    "Model": "SC-54A"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A51 5G",
    "Device": "SCG07",
    "Model": "SCG07"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A51 5G",
    "Device": "a51x",
    "Model": "SM-A5160"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A51 5G",
    "Device": "a51x",
    "Model": "SM-A516B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A51 5G",
    "Device": "a51x",
    "Model": "SM-A516N"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A51 5G",
    "Device": "a51x",
    "Model": "SM-A516U"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A51 5G",
    "Device": "a51x",
    "Model": "SM-A516U1"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A51 5G",
    "Device": "a51xq",
    "Model": "SM-A516V"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A52",
    "Device": "a52q",
    "Model": "SM-A525F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A52",
    "Device": "a52q",
    "Model": "SM-A525M"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A52 5G",
    "Device": "SC-53B",
    "Model": "SC-53B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A52 5G",
    "Device": "a52xq",
    "Model": "SM-A5260"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A52 5G",
    "Device": "a52xq",
    "Model": "SM-A526B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A52 5G",
    "Device": "a52xq",
    "Model": "SM-A526N"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A52 5G",
    "Device": "a52xq",
    "Model": "SM-A526U"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A52 5G",
    "Device": "a52xq",
    "Model": "SM-A526U1"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A52 5G",
    "Device": "a52xq",
    "Model": "SM-A526W"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A52s 5G",
    "Device": "a52sxq",
    "Model": "SM-A528B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A52s 5G",
    "Device": "a52sxq",
    "Model": "SM-A528N"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A53 5G",
    "Device": "SC-53C",
    "Model": "SC-53C"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A53 5G",
    "Device": "SCG15",
    "Model": "SCG15"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A53 5G",
    "Device": "a53x",
    "Model": "SM-A5360"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A53 5G",
    "Device": "a53x",
    "Model": "SM-A536B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A53 5G",
    "Device": "a53x",
    "Model": "SM-A536E"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A53 5G",
    "Device": "a53x",
    "Model": "SM-A536N"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A53 5G",
    "Device": "a53x",
    "Model": "SM-A536U"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A53 5G",
    "Device": "a53x",
    "Model": "SM-A536U1"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A53 5G",
    "Device": "a53x",
    "Model": "SM-A536W"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A53 5G",
    "Device": "a53x",
    "Model": "SM-S536DL"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A53 5G UW",
    "Device": "a53x",
    "Model": "SM-A536V"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A54 5G",
    "Device": "SC-53D",
    "Model": "SC-53D"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A54 5G",
    "Device": "SCG21",
    "Model": "SCG21"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A54 5G",
    "Device": "a54x",
    "Model": "SM-A5460"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A54 5G",
    "Device": "a54x",
    "Model": "SM-A546B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A54 5G",
    "Device": "a54x",
    "Model": "SM-A546E"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A54 5G",
    "Device": "a54x",
    "Model": "SM-A546U"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A54 5G",
    "Device": "a54x",
    "Model": "SM-A546U1"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A54 5G",
    "Device": "a54x",
    "Model": "SM-A546V"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A54 5G",
    "Device": "a54x",
    "Model": "SM-A546W"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A54 5G",
    "Device": "a54x",
    "Model": "SM-S546VL"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A55 5G",
    "Device": "SC-53E",
    "Model": "SC-53E"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A55 5G",
    "Device": "SCG27",
    "Model": "SCG27"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A55 5G",
    "Device": "a55x",
    "Model": "SM-A5560"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A55 5G",
    "Device": "a55x",
    "Model": "SM-A556B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A55 5G",
    "Device": "a55x",
    "Model": "SM-A556E"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A56 5G",
    "Device": "a56x",
    "Model": "SM-A5660"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A56 5G",
    "Device": "a56x",
    "Model": "SM-A566B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A56 5G",
    "Device": "a56x",
    "Model": "SM-A566E"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A56 5G",
    "Device": "a56x",
    "Model": "SM-A566U1"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A56 5G",
    "Device": "a56x",
    "Model": "SM-A566W"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A57 5G",
    "Device": "a57x",
    "Model": "SM-A5760"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A57 5G",
    "Device": "a57x",
    "Model": "SM-A576B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A57 5G",
    "Device": "a57x",
    "Model": "SM-A576Q"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A57 5G",
    "Device": "a57x",
    "Model": "SM-A576U1"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A57 5G",
    "Device": "a57x",
    "Model": "SM-A576W"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A57 5G",
    "Device": "a57x",
    "Model": "SM-A576Z"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A6",
    "Device": "a6elteaio",
    "Model": "SM-A600AZ"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A6",
    "Device": "a6elteatt",
    "Model": "SM-A600A"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A6",
    "Device": "a6eltemtr",
    "Model": "SM-A600T1"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A6",
    "Device": "a6eltespr",
    "Model": "SM-A600P"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A6",
    "Device": "a6eltetmo",
    "Model": "SM-A600T"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A6",
    "Device": "a6elteue",
    "Model": "SM-A600U"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A6",
    "Device": "a6lte",
    "Model": "SM-A600F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A6",
    "Device": "a6lte",
    "Model": "SM-A600FN"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A6",
    "Device": "a6lte",
    "Model": "SM-A600G"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A6",
    "Device": "a6lte",
    "Model": "SM-A600GN"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A6",
    "Device": "a6lteks",
    "Model": "SM-A600N"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A6+",
    "Device": "a6plte",
    "Model": "SM-A605F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A6+",
    "Device": "a6plte",
    "Model": "SM-A605FN"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A6+",
    "Device": "a6plte",
    "Model": "SM-A605G"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A6+",
    "Device": "a6plte",
    "Model": "SM-A605GN"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A6+",
    "Device": "a6pltechn",
    "Model": "SM-A6050"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A60",
    "Device": "a60q",
    "Model": "SM-A6060"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A60",
    "Device": "a60q",
    "Model": "SM-A606Y"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A7",
    "Device": "a73g",
    "Model": "SM-A700H"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A7",
    "Device": "a7alte",
    "Model": "SM-A700F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A7",
    "Device": "a7lte",
    "Model": "SM-A700FD"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A7",
    "Device": "a7lte",
    "Model": "SM-A700X"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A7",
    "Device": "a7ltechn",
    "Model": "SM-A7000"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A7",
    "Device": "a7ltechn",
    "Model": "SM-A700YD"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A7",
    "Device": "a7ltectc",
    "Model": "SM-A7009"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A7",
    "Device": "a7ltektt",
    "Model": "SM-A700K"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A7",
    "Device": "a7ltelgt",
    "Model": "SM-A700L"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A7",
    "Device": "a7lteskt",
    "Model": "SM-A700S"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A7",
    "Device": "a7y18ve",
    "Model": "SM-A750C"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A7 (2018)",
    "Device": "a7y18lte",
    "Model": "SM-A750F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A7 (2018)",
    "Device": "a7y18lte",
    "Model": "SM-A750FN"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A7 (2018)",
    "Device": "a7y18lte",
    "Model": "SM-A750G"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A7 (2018)",
    "Device": "a7y18lte",
    "Model": "SM-A750GN"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A7 (2018)",
    "Device": "a7y18lteks",
    "Model": "SM-A750N"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A7(2016)",
    "Device": "a7xelte",
    "Model": "SM-A710F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A7(2016)",
    "Device": "a7xelte",
    "Model": "SM-A710M"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A7(2016)",
    "Device": "a7xelte",
    "Model": "SM-A710X"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A7(2016)",
    "Device": "a7xeltecmcc",
    "Model": "SM-A7108"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A7(2016)",
    "Device": "a7xeltektt",
    "Model": "SM-A710K"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A7(2016)",
    "Device": "a7xeltelgt",
    "Model": "SM-A710L"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A7(2016)",
    "Device": "a7xelteskt",
    "Model": "SM-A710S"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A7(2016)",
    "Device": "a7xeltextc",
    "Model": "SM-A710Y"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A7(2016)",
    "Device": "a7xltechn",
    "Model": "SM-A7100"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A7(2016)",
    "Device": "a7xltechn",
    "Model": "SM-A710XZ"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A7(2017)",
    "Device": "a7y17lte",
    "Model": "SM-A720F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A7(2017)",
    "Device": "a7y17lteskt",
    "Model": "SM-A720S"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A70",
    "Device": "a70q",
    "Model": "SM-A7050"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A70",
    "Device": "a70q",
    "Model": "SM-A705F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A70",
    "Device": "a70q",
    "Model": "SM-A705FN"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A70",
    "Device": "a70q",
    "Model": "SM-A705GM"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A70",
    "Device": "a70q",
    "Model": "SM-A705MN"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A70",
    "Device": "a70q",
    "Model": "SM-A705U"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A70",
    "Device": "a70q",
    "Model": "SM-A705W"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A70",
    "Device": "a70q",
    "Model": "SM-A705YN"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A70s",
    "Device": "a70s",
    "Model": "SM-A7070"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A70s",
    "Device": "a70s",
    "Model": "SM-A707F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A71",
    "Device": "a71",
    "Model": "SM-A715F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A71",
    "Device": "a71",
    "Model": "SM-A715W"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A71",
    "Device": "a71",
    "Model": "SM-A715X"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A71 5G",
    "Device": "a71x",
    "Model": "SM-A7160"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A71 5G",
    "Device": "a71x",
    "Model": "SM-A716B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A71 5G",
    "Device": "a71xq",
    "Model": "SM-A716U"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A71 5G",
    "Device": "a71xq",
    "Model": "SM-A716U1"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A71 5G",
    "Device": "a71xq",
    "Model": "SM-A716V"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A72",
    "Device": "a72q",
    "Model": "SM-A725F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A72",
    "Device": "a72q",
    "Model": "SM-A725M"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A73 5G",
    "Device": "a73xq",
    "Model": "SM-A736B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A8",
    "Device": "SCV32",
    "Model": "SCV32"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A8",
    "Device": "a8elte",
    "Model": "SM-A800F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A8",
    "Device": "a8elte",
    "Model": "SM-A800YZ"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A8",
    "Device": "a8elteskt",
    "Model": "SM-A800S"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A8",
    "Device": "a8hplte",
    "Model": "SM-A800I"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A8",
    "Device": "a8hplte",
    "Model": "SM-A800IZ"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A8",
    "Device": "a8ltechn",
    "Model": "SM-A8000"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A8",
    "Device": "a8ltechn",
    "Model": "SM-A800X"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A8 Star",
    "Device": "astarqlte",
    "Model": "SM-G885F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A8 Star",
    "Device": "astarqlte",
    "Model": "SM-G885Y"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A8 Star",
    "Device": "astarqltechn",
    "Model": "SM-G8850"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A8 Star",
    "Device": "astarqlteskt",
    "Model": "SM-G885S"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A8(2016)",
    "Device": "a8xelte",
    "Model": "SM-A810F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A8(2016)",
    "Device": "a8xelte",
    "Model": "SM-A810YZ"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A8(2016)",
    "Device": "a8xelteskt",
    "Model": "SM-A810S"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A8(2018)",
    "Device": "jackpotlte",
    "Model": "SM-A530F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A8(2018)",
    "Device": "jackpotlte",
    "Model": "SM-A530X"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A8(2018)",
    "Device": "jackpotltecan",
    "Model": "SM-A530W"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A8(2018)",
    "Device": "jackpotlteks",
    "Model": "SM-A530N"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A8+(2018)",
    "Device": "jackpot2lte",
    "Model": "SM-A730F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A8+(2018)",
    "Device": "jackpot2lte",
    "Model": "SM-A730X"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A80",
    "Device": "r1q",
    "Model": "SM-A8050"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A80",
    "Device": "r1q",
    "Model": "SM-A805F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A80",
    "Device": "r1q",
    "Model": "SM-A805N"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A8s",
    "Device": "a8sqlte",
    "Model": "SM-G887F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A8s",
    "Device": "a8sqltechn",
    "Model": "SM-G8870"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A9 (2018)",
    "Device": "a9y18qlte",
    "Model": "SM-A920F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A9 (2018)",
    "Device": "a9y18qltekx",
    "Model": "SM-A920N"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A9 2018",
    "Device": "a9y18qltechn",
    "Model": "SM-A9200"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A9 Pro",
    "Device": "a8sqlteks",
    "Model": "SM-G887N"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A9 Pro",
    "Device": "a9xproltechn",
    "Model": "SM-A9100"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A9 Pro",
    "Device": "a9xproltesea",
    "Model": "SM-A910F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A9 Star",
    "Device": "astarqltechn",
    "Model": "SM-G8850"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A9 Star",
    "Device": "astarqltecmcc",
    "Model": "SM-G8858"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A9 Star Lite",
    "Device": "a6pltechn",
    "Model": "SM-A6050"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A9 Star Lite",
    "Device": "a6pltechn",
    "Model": "SM-A605XC"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A9 Star Lite",
    "Device": "a6pltecmcc",
    "Model": "SM-A6058"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A9(2016)",
    "Device": "a9xltechn",
    "Model": "SM-A9000"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A90 5G",
    "Device": "r3q",
    "Model": "SM-A9080"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A90 5G",
    "Device": "r3q",
    "Model": "SM-A908B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A90 5G",
    "Device": "r3q",
    "Model": "SM-A908N"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy A9s",
    "Device": "a9y18qltechn",
    "Model": "SM-A9200"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Ace",
    "Device": "GT-S5830",
    "Model": "GT-S5830"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Ace",
    "Device": "GT-S5830B",
    "Model": "GT-S5830B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Ace",
    "Device": "GT-S5830C",
    "Model": "GT-S5830C"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Ace",
    "Device": "GT-S5830D",
    "Model": "GT-S5830D"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Ace",
    "Device": "GT-S5830F",
    "Model": "GT-S5830F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Ace",
    "Device": "GT-S5830G",
    "Model": "GT-S5830G"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Ace",
    "Device": "GT-S5830L",
    "Model": "GT-S5830L"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Ace",
    "Device": "GT-S5830M",
    "Model": "GT-S5830M"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Ace",
    "Device": "GT-S5830T",
    "Model": "GT-S5830T"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Ace",
    "Device": "GT-S5830i",
    "Model": "GT-S5830i"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Ace",
    "Device": "GT-S5831i",
    "Model": "GT-S5831i"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Ace",
    "Device": "GT-S5838",
    "Model": "GT-S5838"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Ace",
    "Device": "GT-S5839i",
    "Model": "GT-S5839i"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Ace",
    "Device": "GT-S6358",
    "Model": "GT-S6358"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Ace",
    "Device": "SCH-I619",
    "Model": "SCH-I619"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Ace",
    "Device": "SHW-M240S",
    "Model": "SHW-M240S"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Ace",
    "Device": "heat3gou",
    "Model": "SM-G310R5"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Ace",
    "Device": "heatlte",
    "Model": "SM-G357M"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Ace 4",
    "Device": "vivaltods5m",
    "Model": "SM-G313HU"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Ace 4",
    "Device": "vivaltods5m",
    "Model": "SM-G313HY"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Ace 4",
    "Device": "vivaltods5m",
    "Model": "SM-G313M"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Ace 4",
    "Device": "vivaltods5m",
    "Model": "SM-G313MY"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Ace 4 Lite",
    "Device": "vivalto3g",
    "Model": "SM-G313U"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Ace Advance",
    "Device": "GT-S6800",
    "Model": "GT-S6800"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Ace Duos",
    "Device": "GT-S6352",
    "Model": "GT-S6352"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Ace Duos",
    "Device": "GT-S6802",
    "Model": "GT-S6802"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Ace Duos",
    "Device": "GT-S6802B",
    "Model": "GT-S6802B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Ace Duos",
    "Device": "SCH-I579",
    "Model": "SCH-i579"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Ace Duos",
    "Device": "SCH-I589",
    "Model": "SCH-I589"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Ace Duos",
    "Device": "SCH-I589",
    "Model": "SCH-i589"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Ace Duos",
    "Device": "SCH-i579",
    "Model": "SCH-i579"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Ace Duos",
    "Device": "SCH-i589",
    "Model": "SCH-i589"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Ace Plus",
    "Device": "GT-S7500",
    "Model": "GT-S7500"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Ace Plus",
    "Device": "GT-S7500L",
    "Model": "GT-S7500L"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Ace Plus",
    "Device": "GT-S7500T",
    "Model": "GT-S7500T"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Ace Plus",
    "Device": "GT-S7500W",
    "Model": "GT-S7500W"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Ace Plus",
    "Device": "GT-S7508",
    "Model": "GT-S7508"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Ace Q",
    "Device": "SGH-I827D",
    "Model": "SGH-I827D"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Ace Style",
    "Device": "heat3gtfnvzw",
    "Model": "SM-S765C"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Ace Style",
    "Device": "heat3gtfnvzw",
    "Model": "SM-S766C"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Ace Style",
    "Device": "heatnfc3g",
    "Model": "SM-G310HN"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Ace Style",
    "Device": "heatqlte",
    "Model": "SM-G357FZ"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Ace2",
    "Device": "GT-I8160",
    "Model": "GT-I8160"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Ace2",
    "Device": "GT-I8160L",
    "Model": "GT-I8160L"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Ace2",
    "Device": "GT-I8160P",
    "Model": "GT-I8160P"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Ace2 X",
    "Device": "kylessopen",
    "Model": "GT-S7560"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Ace2 X",
    "Device": "kylessopen",
    "Model": "GT-S7560M"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Ace3",
    "Device": "logan",
    "Model": "GT-S7270"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Ace3",
    "Device": "logan",
    "Model": "GT-S7270L"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Ace3",
    "Device": "logan",
    "Model": "SCH-I679"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Ace3",
    "Device": "logan3gcmcc",
    "Model": "GT-S7278"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Ace3",
    "Device": "logands",
    "Model": "GT-S7272"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Ace3",
    "Device": "loganlte",
    "Model": "GT-S7275"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Ace3",
    "Device": "loganrelte",
    "Model": "GT-S7275B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Ace3",
    "Device": "loganrelte",
    "Model": "GT-S7275R"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Ace3",
    "Device": "loganrelte",
    "Model": "GT-S7275T"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Ace3",
    "Device": "loganrelte",
    "Model": "GT-S7275Y"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Ace3 Duos",
    "Device": "loganlite3g",
    "Model": "GT-S7272C"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Ace3 Duos",
    "Device": "loganu3gcmcc",
    "Model": "GT-S7278U"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Ace3 Duos TV",
    "Device": "logandsdtv",
    "Model": "GT-S7273T"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Ace4",
    "Device": "vivalto3g",
    "Model": "SM-G313ML"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Ace4",
    "Device": "vivalto3mve3g",
    "Model": "SM-G316H"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Ace4",
    "Device": "vivalto5mve3g",
    "Model": "SM-G316HU"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Ace4",
    "Device": "vivalto5mve3g",
    "Model": "SM-G316M"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Ace4",
    "Device": "vivalto5mve3g",
    "Model": "SM-G316MY"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Ace4",
    "Device": "vivaltolte",
    "Model": "SM-G313F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Ace4",
    "Device": "vivaltolte",
    "Model": "SM-G313MU"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Ace4",
    "Device": "vivaltonfc3g",
    "Model": "SM-G313HN"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Ace4 Lite",
    "Device": "vivalto",
    "Model": "SM-G3139D"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Ace4 Lite",
    "Device": "vivalto3g",
    "Model": "SM-G313H"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Ace4 Lite",
    "Device": "vivalto3mve3gltn",
    "Model": "SM-G316U"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Ace4 Lite",
    "Device": "vivalto3mveml3g",
    "Model": "SM-G318H"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Ace4 Lite",
    "Device": "vivalto3mveml3g",
    "Model": "SM-G318ML"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Ace4 Lite",
    "Device": "vivalto3mveml3gsea",
    "Model": "SM-G318HZ"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Ace4 Lite",
    "Device": "vivalto3mveml3gsea",
    "Model": "SM-G318MZ"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Ace4 Neo",
    "Device": "vivalto3mve3gltn",
    "Model": "SM-G316ML"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Active neo",
    "Device": "SC-01H",
    "Model": "SC-01H"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Admire",
    "Device": "SCH-R820",
    "Model": "SCH-R820"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Admire 2",
    "Device": "goghcri",
    "Model": "SCH-R830C"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Alpha",
    "Device": "slte",
    "Model": "SM-G850F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Alpha",
    "Device": "slte",
    "Model": "SM-G850FQ"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Alpha",
    "Device": "slte",
    "Model": "SM-G850M"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Alpha",
    "Device": "slte",
    "Model": "SM-G850X"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Alpha",
    "Device": "slte",
    "Model": "SM-G850Y"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Alpha",
    "Device": "slteatt",
    "Model": "SAMSUNG-SM-G850A"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Alpha",
    "Device": "sltecan",
    "Model": "SM-G850W"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Alpha",
    "Device": "sltechn",
    "Model": "SM-G8508S"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Alpha",
    "Device": "sltektt",
    "Model": "SM-G850K"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Alpha",
    "Device": "sltelgt",
    "Model": "SM-G850L"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Alpha",
    "Device": "slteskt",
    "Model": "SM-G850S"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Amp",
    "Device": "kyleatt",
    "Model": "SAMSUNG-SGH-I407"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Apollo",
    "Device": "GT-I5800",
    "Model": "GT-I5800"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Apollo",
    "Device": "GT-I5800",
    "Model": "GT-I5800L"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Apollo",
    "Device": "GT-I5800D",
    "Model": "GT-I5800D"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Apollo",
    "Device": "GT-I5801",
    "Model": "GT-I5801"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Appeal",
    "Device": "SGH-I827",
    "Model": "SAMSUNG-SGH-I827"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Attain",
    "Device": "SCH-R920",
    "Model": "SCH-R920"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Avant",
    "Device": "afyonltetmo",
    "Model": "SM-G386T"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Axiom",
    "Device": "infiniteusc",
    "Model": "SCH-R830"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Beam",
    "Device": "GT-I8250",
    "Model": "GT-I8250"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Beam",
    "Device": "GT-I8530",
    "Model": "GT-I8530"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Buddy",
    "Device": "a22x",
    "Model": "SM-A226L"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Buddy2",
    "Device": "m23xq",
    "Model": "SM-M236L"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Buddy3",
    "Device": "a15x",
    "Model": "SM-A156L"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Buddy4",
    "Device": "a16x",
    "Model": "SM-A166L"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy C5",
    "Device": "c5ltechn",
    "Model": "SM-C5000"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy C5",
    "Device": "c5ltechn",
    "Model": "SM-C500X"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy C5",
    "Device": "c5pltechn",
    "Model": "SM-C5000"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy C5 Pro",
    "Device": "c5proltechn",
    "Model": "SM-C5010"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy C5 Pro",
    "Device": "c5proltechn",
    "Model": "SM-C5018"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy C55 5G",
    "Device": "m55xq",
    "Model": "SM-C5560"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy C7",
    "Device": "c7ltechn",
    "Model": "SM-C7000"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy C7",
    "Device": "c7ltechn",
    "Model": "SM-C700X"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy C7",
    "Device": "c7proltechn",
    "Model": "SM-C701X"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy C7 Pro",
    "Device": "c7prolte",
    "Model": "SM-C701F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy C7 Pro",
    "Device": "c7proltechn",
    "Model": "SM-C7010"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy C7 Pro",
    "Device": "c7proltechn",
    "Model": "SM-C7018"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy C8",
    "Device": "jadeltechn",
    "Model": "SM-C7100"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy C8",
    "Device": "jadeltechn",
    "Model": "SM-C710X"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy C8",
    "Device": "jadeltecmcc",
    "Model": "SM-C7108"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy C9 Pro",
    "Device": "c9lte",
    "Model": "SM-C900F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy C9 Pro",
    "Device": "c9lte",
    "Model": "SM-C900Y"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy C9 Pro",
    "Device": "c9ltechn",
    "Model": "SM-C9000"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy C9 Pro",
    "Device": "c9ltechn",
    "Model": "SM-C9008"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy C9 Pro",
    "Device": "c9ltechn",
    "Model": "SM-C900X"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Camera",
    "Device": "gd1",
    "Model": "EK-GC100"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Camera",
    "Device": "gd1att",
    "Model": "SAMSUNG-EK-GC100"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Camera",
    "Device": "gd1can",
    "Model": "EK-GC100"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Camera",
    "Device": "gd1ktt",
    "Model": "EK-KC100K"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Camera",
    "Device": "gd1ltelgt",
    "Model": "EK-KC120L"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Camera",
    "Device": "gd1lteskt",
    "Model": "EK-KC120S"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Camera",
    "Device": "gd1ltevzw",
    "Model": "EK-GC120"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Camera",
    "Device": "gd1skt",
    "Model": "EK-KC100S"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Camera",
    "Device": "gd1wifi",
    "Model": "EK-GC110"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Camera",
    "Device": "gd1wifiany",
    "Model": "EK-GC110"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Camera",
    "Device": "u0lte",
    "Model": "EK-GN100"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Camera",
    "Device": "u0lte",
    "Model": "EK-GN120"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Camera 2",
    "Device": "sf2wifi",
    "Model": "EK-GC200"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Centura",
    "Device": "amazing3gtrf",
    "Model": "SCH-S738C"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Chat",
    "Device": "zanin",
    "Model": "GT-B5330"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Chat",
    "Device": "zanin",
    "Model": "GT-B5330B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Chat",
    "Device": "zanin",
    "Model": "GT-B5330L"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Core",
    "Device": "afyonlteMetroPCS",
    "Model": "SM-G386T1"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Core",
    "Device": "afyonltecan",
    "Model": "SM-G386W"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Core",
    "Device": "arubaslim",
    "Model": "GT-I8262"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Core",
    "Device": "arubaslimss",
    "Model": "GT-I8260"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Core",
    "Device": "arubaslimss",
    "Model": "GT-I8260L"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Core 2",
    "Device": "kanas",
    "Model": "SM-G355H"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Core Advance",
    "Device": "cane3g",
    "Model": "GT-I8580"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Core Advance",
    "Device": "cane3gskt",
    "Model": "SHW-M570S"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Core LTE",
    "Device": "afyonlte",
    "Model": "SM-G386F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Core LTE",
    "Device": "cs03lte",
    "Model": "SM-G3518"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Core Lite",
    "Device": "victorlte",
    "Model": "SM-G3586V"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Core Lite",
    "Device": "victorlte",
    "Model": "SM-G3589W"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Core Max",
    "Device": "kleoslte",
    "Model": "SM-G5108"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Core Max Duos",
    "Device": "kleoslte",
    "Model": "SM-G5108Q"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Core Plus",
    "Device": "cs02",
    "Model": "SM-G350"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Core Plus",
    "Device": "cs023g",
    "Model": "SM-G3502"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Core Plus",
    "Device": "cs02ve3g",
    "Model": "SM-G3502L"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Core Plus",
    "Device": "cs02ve3gdtv",
    "Model": "SM-G3502T"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Core Plus",
    "Device": "cs02ve3gss",
    "Model": "SM-G350L"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Core Plus",
    "Device": "cs02ve3gss",
    "Model": "SM-G350M"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Core Prime",
    "Device": "core33g",
    "Model": "SM-G360H"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Core Prime",
    "Device": "core33g",
    "Model": "SM-G360HU"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Core Prime",
    "Device": "coreprimelte",
    "Model": "SM-G360F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Core Prime",
    "Device": "coreprimelte",
    "Model": "SM-G360FY"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Core Prime",
    "Device": "coreprimelte",
    "Model": "SM-G360M"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Core Prime",
    "Device": "coreprimelteaio",
    "Model": "SAMSUNG-SM-G360AZ"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Core Prime",
    "Device": "coreprimeltelra",
    "Model": "SM-G360R6"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Core Prime",
    "Device": "coreprimeltespr",
    "Model": "SM-G360P"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Core Prime",
    "Device": "coreprimeltetfnvzw",
    "Model": "SM-S820L"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Core Prime",
    "Device": "coreprimeltevzw",
    "Model": "SM-G360V"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Core Prime",
    "Device": "coreprimeve3g",
    "Model": "SM-G361H"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Core Prime",
    "Device": "coreprimeve3g",
    "Model": "SM-G361HU"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Core Prime",
    "Device": "coreprimevelte",
    "Model": "SM-G361F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Core Prime",
    "Device": "coreprimevelte",
    "Model": "SM-G361M"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Core Prime",
    "Device": "cprimeltemtr",
    "Model": "SM-G360T1"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Core Prime",
    "Device": "cprimeltetmo",
    "Model": "SM-G360T"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Core Prime",
    "Device": "rossalte",
    "Model": "SM-G3606"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Core Prime",
    "Device": "rossalte",
    "Model": "SM-G3608"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Core Prime",
    "Device": "rossaltectc",
    "Model": "SM-G3609"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Core Prime",
    "Device": "rossaltexsa",
    "Model": "SM-G360GY"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Core Safe",
    "Device": "arubaslimss",
    "Model": "GT-I8260E"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Core Safe",
    "Device": "arubaslimss",
    "Model": "SHW-M580D"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Core Safe",
    "Device": "arubaslimss",
    "Model": "SHW-M585D"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Core2",
    "Device": "kanas",
    "Model": "SM-G355H"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Core2",
    "Device": "kanas",
    "Model": "SM-G355HQ"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Core2",
    "Device": "kanas",
    "Model": "SM-G355M"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Core2",
    "Device": "kanas3g",
    "Model": "SM-G3556D"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Core2",
    "Device": "kanas3gcmcc",
    "Model": "SM-G3558"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Core2",
    "Device": "kanas3gctc",
    "Model": "SM-G3559"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Core2",
    "Device": "kanas3gnfc",
    "Model": "SM-G355HN"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Discover",
    "Device": "amazing3gcri",
    "Model": "SCH-R740C"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Discover",
    "Device": "amazingtrfcd",
    "Model": "SCH-S735C"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Duos",
    "Device": "aruba3gcmcc",
    "Model": "GT-I8268"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy E5",
    "Device": "e53g",
    "Model": "SM-E500H"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy E5",
    "Device": "e5lte",
    "Model": "SM-E500F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy E5",
    "Device": "e5lte",
    "Model": "SM-E500M"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy E5",
    "Device": "e5ltetfnvzw",
    "Model": "SM-S978L"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy E5",
    "Device": "e5ltetw",
    "Model": "SM-E500YZ"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy E7",
    "Device": "e73g",
    "Model": "SM-E700H"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy E7",
    "Device": "e7lte",
    "Model": "SM-E700F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy E7",
    "Device": "e7lte",
    "Model": "SM-E700M"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy E7",
    "Device": "e7ltechn",
    "Model": "SM-E7000"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy E7",
    "Device": "e7ltectc",
    "Model": "SM-E7009"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy E7",
    "Device": "e7ltehktw",
    "Model": "SM-E7000"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Elite",
    "Device": "elite3gkx",
    "Model": "SM-G165N"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Europa",
    "Device": "GT-I5500",
    "Model": "GT-I5500"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Europa",
    "Device": "GT-I5503",
    "Model": "GT-I5503"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Europa",
    "Device": "GT-I5508",
    "Model": "GT-I5508"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Europa",
    "Device": "GT-I5510",
    "Model": "GT-I5510"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Exhibit",
    "Device": "codinaMetroPCS",
    "Model": "SGH-T599N"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Exhibit",
    "Device": "codinatmo",
    "Model": "SGH-T599"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Exhibit",
    "Device": "codinavid",
    "Model": "SGH-T599V"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Exhibit2",
    "Device": "SGH-T679",
    "Model": "SGH-T679"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Exhilarate",
    "Device": "SGH-I577",
    "Model": "SAMSUNG-SGH-I577"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Express",
    "Device": "expressatt",
    "Model": "SAMSUNG-SGH-I437"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Express",
    "Device": "expressatt",
    "Model": "SAMSUNG-SGH-I437P"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Express",
    "Device": "expresslte",
    "Model": "GT-I8730"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Express",
    "Device": "expresslte",
    "Model": "GT-I8730T"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Express",
    "Device": "expressziglteatt",
    "Model": "SAMSUNG-SGH-I437Z"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Express2",
    "Device": "wilcoxlte",
    "Model": "SM-G3815"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy F02s",
    "Device": "a02q",
    "Model": "SM-E025F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy F04",
    "Device": "m04",
    "Model": "SM-E045F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy F05",
    "Device": "a05m",
    "Model": "SM-E055F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy F06 5G",
    "Device": "a06x",
    "Model": "SM-E066B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy F07",
    "Device": "a07",
    "Model": "SM-E075F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy F12",
    "Device": "f12",
    "Model": "SM-F127G"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy F13",
    "Device": "m13",
    "Model": "SM-E135F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy F14",
    "Device": "a05s",
    "Model": "SM-E145F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy F14 5G",
    "Device": "m14x",
    "Model": "SM-E146B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy F15 5G",
    "Device": "m15x",
    "Model": "SM-E156B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy F16 5G",
    "Device": "m16xm",
    "Model": "SM-E166P"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy F17 5G",
    "Device": "a17x",
    "Model": "SM-E176B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy F22",
    "Device": "f22",
    "Model": "SM-E225F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy F23 5G",
    "Device": "m23xq",
    "Model": "SM-E236B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy F34 5G",
    "Device": "m34x",
    "Model": "SM-E346B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy F36 5G",
    "Device": "m36x",
    "Model": "SM-E366B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy F41",
    "Device": "f41",
    "Model": "SM-F415F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy F42 5G",
    "Device": "f42x",
    "Model": "SM-E426B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy F52 5G",
    "Device": "f52x",
    "Model": "SM-E5260"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy F54 5G",
    "Device": "m54x",
    "Model": "SM-E546B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy F55 5G",
    "Device": "m55xq",
    "Model": "SM-E556B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy F56 5G",
    "Device": "m56x",
    "Model": "SM-E566B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy F62",
    "Device": "f62",
    "Model": "SM-E625F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy F70e 5G",
    "Device": "a07x",
    "Model": "SM-E076B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Fame",
    "Device": "SCH-I629",
    "Model": "SCH-I629"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Fame",
    "Device": "nevis",
    "Model": "GT-S6810"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Fame",
    "Device": "nevis",
    "Model": "GT-S6810B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Fame",
    "Device": "nevis",
    "Model": "GT-S6810E"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Fame",
    "Device": "nevis",
    "Model": "GT-S6810L"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Fame",
    "Device": "nevis3g",
    "Model": "GT-S6812i"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Fame",
    "Device": "nevis3gcmcc",
    "Model": "GT-S6818"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Fame",
    "Device": "nevis3gcmcc",
    "Model": "GT-S6818V"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Fame",
    "Device": "nevisds",
    "Model": "GT-S6812"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Fame",
    "Device": "nevisds",
    "Model": "GT-S6812B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Fame",
    "Device": "nevisnvess",
    "Model": "GT-S6790N"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Fame",
    "Device": "nevisp",
    "Model": "GT-S6810M"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Fame",
    "Device": "nevisp",
    "Model": "GT-S6810P"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Fame",
    "Device": "nevisvess",
    "Model": "GT-S6790"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Fame",
    "Device": "nevisvess",
    "Model": "GT-S6790E"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Fame",
    "Device": "nevisvess",
    "Model": "GT-S6790L"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Fame",
    "Device": "nevisw",
    "Model": "GT-S6812C"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Fame Lite Duos",
    "Device": "nevisw",
    "Model": "GT-S6792L"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Feel",
    "Device": "SC-04J",
    "Model": "SC-04J"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Feel2",
    "Device": "SC-02L",
    "Model": "SC-02L"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Fit",
    "Device": "GT-S5670",
    "Model": "GT-S5670"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Fit",
    "Device": "GT-S5670B",
    "Model": "GT-S5670B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Fit",
    "Device": "GT-S5670L",
    "Model": "GT-S5670L"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Fold",
    "Device": "SCV44",
    "Model": "SCV44"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Fold",
    "Device": "winner",
    "Model": "SM-F9000"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Fold",
    "Device": "winner",
    "Model": "SM-F900F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Fold",
    "Device": "winner",
    "Model": "SM-F900U"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Fold",
    "Device": "winner",
    "Model": "SM-F900U1"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Fold",
    "Device": "winner",
    "Model": "SM-F900W"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Fold 5G",
    "Device": "winner",
    "Model": "SM-F907B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Fold 5G",
    "Device": "winner",
    "Model": "SM-F907N"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Folder",
    "Device": "novel3gskt",
    "Model": "SM-G155S"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Folder",
    "Device": "novelltektt",
    "Model": "SM-G150NK"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Folder",
    "Device": "novelltekx",
    "Model": "SM-G150N0"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Folder",
    "Device": "novelltelgt",
    "Model": "SM-G150NL"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Folder",
    "Device": "novellteskt",
    "Model": "SM-G150NS"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Folder2",
    "Device": "eliteltekx",
    "Model": "SM-G160N"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Folder2",
    "Device": "elitexlte",
    "Model": "SM-G1650"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Fresh",
    "Device": "kylevess",
    "Model": "GT-S7390"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Fresh",
    "Device": "kylevess",
    "Model": "GT-S7390E"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Fresh",
    "Device": "kylevess",
    "Model": "GT-S7390G"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Gio",
    "Device": "GT-S5660",
    "Model": "GT-S5660"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Gio",
    "Device": "GT-S5660B",
    "Model": "GT-S5660B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Gio",
    "Device": "GT-S5660L",
    "Model": "GT-S5660L"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Gio",
    "Device": "GT-S5660M",
    "Model": "GT-S5660M"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Gio",
    "Device": "GT-S5660V",
    "Model": "GT-S5660V"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Gio",
    "Device": "SCH-i569",
    "Model": "SCH-i569"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Gio",
    "Device": "SHW-M290K",
    "Model": "SHW-M290K"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Gio",
    "Device": "SHW-M290S",
    "Model": "SHW-M290S"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Go Prime",
    "Device": "grandprimelteatt",
    "Model": "SAMSUNG-SM-G530A"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Golden",
    "Device": "ks02lte",
    "Model": "GT-I9230"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Golden",
    "Device": "ks02lte",
    "Model": "GT-I9235"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Golden",
    "Device": "ks02ltektt",
    "Model": "SHV-E400K"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Golden",
    "Device": "ks02lteskt",
    "Model": "SHV-E400S"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Golden 2",
    "Device": "pateklte",
    "Model": "SM-W2015"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Grand",
    "Device": "baffin3gduosctc",
    "Model": "SCH-I879"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Grand",
    "Device": "baffincmcc",
    "Model": "GT-I9128"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Grand",
    "Device": "baffincmcc",
    "Model": "GT-I9128V"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Grand",
    "Device": "baffinltektt",
    "Model": "SHV-E270K"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Grand",
    "Device": "baffinlteskt",
    "Model": "SHV-E270S"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Grand",
    "Device": "baffinrd",
    "Model": "GT-I9118"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Grand",
    "Device": "baffinss",
    "Model": "GT-I9080E"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Grand",
    "Device": "baffinss",
    "Model": "GT-I9080L"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Grand",
    "Device": "baffinvektt",
    "Model": "SHV-E275K"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Grand",
    "Device": "baffinveskt",
    "Model": "SHV-E275S"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Grand",
    "Device": "baffinvetd3g",
    "Model": "GT-I9128E"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Grand",
    "Device": "baffinvetd3g",
    "Model": "GT-I9128I"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Grand Duos",
    "Device": "baffin",
    "Model": "GT-I9082"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Grand Duos",
    "Device": "baffin",
    "Model": "GT-I9082L"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Grand Max",
    "Device": "grandmax3g",
    "Model": "SM-G7202"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Grand Max",
    "Device": "grandmaxltechn",
    "Model": "SM-G7200"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Grand Max",
    "Device": "grandmaxltechn",
    "Model": "SM-G720AX"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Grand Neo",
    "Device": "baffinlite",
    "Model": "GT-I9060"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Grand Neo",
    "Device": "baffinlite",
    "Model": "GT-I9060L"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Grand Neo",
    "Device": "baffinlite",
    "Model": "GT-I9082C"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Grand Neo",
    "Device": "baffinlitedtv",
    "Model": "GT-I9063T"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Grand Neo",
    "Device": "baffinq3g",
    "Model": "GT-I9168"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Grand Neo",
    "Device": "baffinq3g",
    "Model": "GT-I9168I"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Grand Neo Plus",
    "Device": "grandneove3g",
    "Model": "GT-I9060C"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Grand Neo Plus",
    "Device": "grandneove3g",
    "Model": "GT-I9060I"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Grand Neo Plus",
    "Device": "grandneove3g",
    "Model": "GT-I9060M"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Grand Neo+",
    "Device": "baffinq3gduosctc",
    "Model": "SCH-I879E"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Grand Prime",
    "Device": "fortuna3g",
    "Model": "SM-G530H"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Grand Prime",
    "Device": "fortuna3gdtv",
    "Model": "SM-G530BT"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Grand Prime",
    "Device": "fortunalte",
    "Model": "SM-G5306W"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Grand Prime",
    "Device": "fortunalte",
    "Model": "SM-G5308W"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Grand Prime",
    "Device": "fortunalte",
    "Model": "SM-G530F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Grand Prime",
    "Device": "fortunalte",
    "Model": "SM-G530M"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Grand Prime",
    "Device": "fortunaltectc",
    "Model": "SM-G5309W"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Grand Prime",
    "Device": "fortunaltezh",
    "Model": "SM-G5308W"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Grand Prime",
    "Device": "fortunaltezt",
    "Model": "SM-G530MU"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Grand Prime",
    "Device": "fortunaltezt",
    "Model": "SM-G530Y"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Grand Prime",
    "Device": "fortunave3g",
    "Model": "SM-G530H"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Grand Prime",
    "Device": "gprimelteacg",
    "Model": "SM-G530R7"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Grand Prime",
    "Device": "gprimelteacg",
    "Model": "gprimelteacg"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Grand Prime",
    "Device": "gprimeltecan",
    "Model": "SM-G530W"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Grand Prime",
    "Device": "gprimeltemtr",
    "Model": "SM-G530T1"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Grand Prime",
    "Device": "gprimeltespr",
    "Model": "SM-G530P"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Grand Prime",
    "Device": "gprimeltetfnvzw",
    "Model": "SM-S920L"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Grand Prime",
    "Device": "gprimeltetmo",
    "Model": "SM-G530T"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Grand Prime",
    "Device": "gprimelteusc",
    "Model": "SM-G530R4"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Grand Prime",
    "Device": "grandprimelte",
    "Model": "SM-G530FZ"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Grand Prime",
    "Device": "grandprimelteaio",
    "Model": "SAMSUNG-SM-G530AZ"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Grand Prime",
    "Device": "grandprimeve3g",
    "Model": "SM-G531H"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Grand Prime",
    "Device": "grandprimeve3gdtv",
    "Model": "SM-G531BT"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Grand Prime",
    "Device": "grandprimevelte",
    "Model": "SM-G531F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Grand Prime",
    "Device": "grandprimevelteltn",
    "Model": "SM-G531M"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Grand Prime",
    "Device": "grandprimeveltezt",
    "Model": "SM-G531Y"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Grand Prime Plus",
    "Device": "grandpplte",
    "Model": "SM-G532F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Grand Prime Plus",
    "Device": "grandppltedtv",
    "Model": "SM-G532MT"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Grand Prime Pro",
    "Device": "j2y18lte",
    "Model": "SM-J250F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Grand duos",
    "Device": "baffin",
    "Model": "GT-I9082i"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Grand-Max",
    "Device": "grandmaxltekx",
    "Model": "SM-G720N0"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Grand2",
    "Device": "ms013g",
    "Model": "SM-G7102"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Grand2",
    "Device": "ms013g",
    "Model": "SM-G7106"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Grand2",
    "Device": "ms013g",
    "Model": "SM-G7108"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Grand2",
    "Device": "ms013g",
    "Model": "SM-G7109"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Grand2",
    "Device": "ms013gdtv",
    "Model": "SM-G7102T"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Grand2",
    "Device": "ms013gss",
    "Model": "SM-G710"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Grand2",
    "Device": "ms01lte",
    "Model": "SM-G7105"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Grand2",
    "Device": "ms01lte",
    "Model": "SM-G7105H"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Grand2",
    "Device": "ms01lte",
    "Model": "SM-G7105L"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Grand2",
    "Device": "ms01ltektt",
    "Model": "SM-G710K"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Grand2",
    "Device": "ms01ltelgt",
    "Model": "SM-G710L"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Grand2",
    "Device": "ms01lteskt",
    "Model": "SM-G710S"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Indulge",
    "Device": "SCH-R910",
    "Model": "SCH-R910"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Indulge",
    "Device": "SCH-R915",
    "Model": "SCH-R915"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Infinite",
    "Device": "infinite3gduosctc",
    "Model": "SCH-I759"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J",
    "Device": "hltejs01tw",
    "Model": "SGH-N075T"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J1",
    "Device": "j13g",
    "Model": "SM-J100H"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J1",
    "Device": "j13g",
    "Model": "SM-J100ML"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J1",
    "Device": "j13gtfnvzw",
    "Model": "SM-S777C"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J1",
    "Device": "j1lte",
    "Model": "SM-J100F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J1",
    "Device": "j1lte",
    "Model": "SM-J100G"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J1",
    "Device": "j1lte",
    "Model": "SM-J100M"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J1",
    "Device": "j1nlte",
    "Model": "SM-J100FN"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J1",
    "Device": "j1nlte",
    "Model": "SM-J100MU"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J1",
    "Device": "j1nlte",
    "Model": "SM-J100Y"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J1",
    "Device": "j1qltevzw",
    "Model": "SM-J100VPP"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J1",
    "Device": "j1xlte",
    "Model": "SM-J120F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J1",
    "Device": "j1xlte",
    "Model": "SM-J120FN"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J1",
    "Device": "j1xlte",
    "Model": "SM-J120M"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J1",
    "Device": "j1xlteaio",
    "Model": "SAMSUNG-SM-J120AZ"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J1",
    "Device": "j1xlteatt",
    "Model": "SAMSUNG-SM-J120A"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J1",
    "Device": "j1xltecan",
    "Model": "SM-J120W"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J1",
    "Device": "j1xqltespr",
    "Model": "SM-J120P"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J1",
    "Device": "j1xqltetfnvzw",
    "Model": "SM-S120VL"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J1 (2016)",
    "Device": "j1xlte",
    "Model": "SM-J120F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J1 Ace",
    "Device": "j1acelte",
    "Model": "SM-J110F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J1 Ace",
    "Device": "j1acelte",
    "Model": "SM-J110G"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J1 Ace",
    "Device": "j1acelteltn",
    "Model": "SM-J110M"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J1 Ace",
    "Device": "j1acevelte",
    "Model": "SM-J111F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J1 Ace",
    "Device": "j1acevelte",
    "Model": "SM-J111M"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J1 Ace",
    "Device": "j1pop3g",
    "Model": "SM-J110H"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J1 Ace",
    "Device": "j1pop3g",
    "Model": "SM-J110L"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J1 Mini",
    "Device": "j1mini3g",
    "Model": "SM-J105B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J1 Mini",
    "Device": "j1mini3g",
    "Model": "SM-J105H"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J1 Mini",
    "Device": "j1mini3gdx",
    "Model": "SM-J105B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J1 Mini",
    "Device": "j1mini3gxw",
    "Model": "SM-J105H"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J1 Mini",
    "Device": "j1minilte",
    "Model": "SM-J105F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J1 Mini",
    "Device": "j1minilte",
    "Model": "SM-J105M"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J1 Mini",
    "Device": "j1minilte",
    "Model": "SM-J105Y"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J1 Mini Prime",
    "Device": "j1minive3g",
    "Model": "SM-J106B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J1 Mini Prime",
    "Device": "j1minive3g",
    "Model": "SM-J106H"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J1 Mini Prime",
    "Device": "j1minive3gxtc",
    "Model": "SM-J106B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J1 Mini Prime",
    "Device": "j1minivelte",
    "Model": "SM-J106M"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J1(2016)",
    "Device": "j1x3g",
    "Model": "SM-J120H"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J1(2016)",
    "Device": "j1xlte",
    "Model": "SM-J120G"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J1(2016)",
    "Device": "j1xlte",
    "Model": "SM-J120ZN"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J2",
    "Device": "j23g",
    "Model": "SM-J200H"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J2",
    "Device": "j2corepltemtr",
    "Model": "SM-J260T1"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J2",
    "Device": "j2corepltetfntmo",
    "Model": "SM-S260DL"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J2",
    "Device": "j2lte",
    "Model": "SM-J200F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J2",
    "Device": "j2lte",
    "Model": "SM-J200G"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J2",
    "Device": "j2lte",
    "Model": "SM-J200GU"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J2",
    "Device": "j2lte",
    "Model": "SM-J200M"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J2",
    "Device": "j2lte",
    "Model": "SM-J200Y"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J2",
    "Device": "j2ltedtv",
    "Model": "SM-J200BT"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J2",
    "Device": "j2y18lte",
    "Model": "SM-J250F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J2",
    "Device": "j2y18lte",
    "Model": "SM-J250Y"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J2 Core",
    "Device": "j2corelte",
    "Model": "SM-J260F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J2 Core",
    "Device": "j2corelte",
    "Model": "SM-J260G"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J2 Core",
    "Device": "j2corelte",
    "Model": "SM-J260M"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J2 Core",
    "Device": "j2corelte",
    "Model": "SM-J260Y"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J2 Core",
    "Device": "j2corey20lte",
    "Model": "SM-J260FU"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J2 Core",
    "Device": "j2corey20lte",
    "Model": "SM-J260GU"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J2 Core",
    "Device": "j2corey20lte",
    "Model": "SM-J260MU"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J2 Prime",
    "Device": "grandpplte",
    "Model": "SM-G532G"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J2 Prime",
    "Device": "grandpplte",
    "Model": "SM-G532M"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J2 Pro",
    "Device": "j2xlteins",
    "Model": "SM-J210F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J2 Pro",
    "Device": "j2y18lte",
    "Model": "SM-J250F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J2 Pro",
    "Device": "j2y18lte",
    "Model": "SM-J250G"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J2 Pro",
    "Device": "j2y18lte",
    "Model": "SM-J250M"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J2 Pure",
    "Device": "j2coreplteaio",
    "Model": "SM-J260AZ"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J2(2016)",
    "Device": "j2xlte",
    "Model": "SM-J210F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J3",
    "Device": "j3ltectc",
    "Model": "SM-J3109"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J3",
    "Device": "j3ltespr",
    "Model": "SM-J320P"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J3",
    "Device": "j3popelteue",
    "Model": "SM-J327U"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J3",
    "Device": "j3poplteacg",
    "Model": "SM-J327R7"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J3",
    "Device": "j3popltelra",
    "Model": "SM-J327R6"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J3",
    "Device": "j3poplteusc",
    "Model": "SM-J327R4"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J3",
    "Device": "j3topelteacg",
    "Model": "SM-J337R7"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J3",
    "Device": "j3topeltevzw",
    "Model": "SM-J337VPP"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J3",
    "Device": "j3toplteue",
    "Model": "SM-J337U"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J3",
    "Device": "j3x3g",
    "Model": "SM-J320H"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J3",
    "Device": "j3y17qltecmcc",
    "Model": "SM-J3300"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J3",
    "Device": "j3y17qltecmcc",
    "Model": "SM-J3308"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J3 Achieve",
    "Device": "j3topeltespr",
    "Model": "SM-J337P"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J3 Aura",
    "Device": "j3topelteusc",
    "Model": "SM-J337R4"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J3 Eclipse",
    "Device": "j3popltevzw",
    "Model": "SM-J327V"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J3 Emerge",
    "Device": "j3popltespr",
    "Model": "SM-J327P"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J3 Mission",
    "Device": "j3popltevzw",
    "Model": "SM-J327VPP"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J3 Orbit",
    "Device": "j3topeltetfnvzw",
    "Model": "SM-S367VL"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J3 Orbit",
    "Device": "j3topltetfntmo",
    "Model": "SM-S357BL"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J3 Pop",
    "Device": "j3popelteaio",
    "Model": "SAMSUNG-SM-J326AZ"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J3 Pop",
    "Device": "j3popelteaio",
    "Model": "SAMSUNG-SM-J327AZ"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J3 Pop",
    "Device": "j3popelteatt",
    "Model": "SAMSUNG-SM-J327A"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J3 Pop",
    "Device": "j3popeltetfntmo",
    "Model": "SM-S337TL"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J3 Pop",
    "Device": "j3popltetfnvzw",
    "Model": "SM-S327VL"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J3 Prime",
    "Device": "j3popeltecan",
    "Model": "SM-J327W"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J3 Prime",
    "Device": "j3popeltemtr",
    "Model": "SM-J327T1"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J3 Prime",
    "Device": "j3popeltetmo",
    "Model": "SM-J327T"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J3 Pro",
    "Device": "j3xproltechn",
    "Model": "SM-J3110"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J3 Pro",
    "Device": "j3xproltectc",
    "Model": "SM-J3119"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J3 Pro",
    "Device": "j3y17lte",
    "Model": "SM-J330G"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J3 Pro 增强版",
    "Device": "j3xpro6mltechn",
    "Model": "SM-J3119S"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J3 Star",
    "Device": "j3topltetmo",
    "Model": "SM-J337T"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J3 V",
    "Device": "j3topeltevzw",
    "Model": "SM-J337V"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J3(2016)",
    "Device": "j3ltekx",
    "Model": "SM-J320N0"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J3(2016)",
    "Device": "j3ltetfnvzw",
    "Model": "SM-S320VL"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J3(2016)",
    "Device": "j3ltetw",
    "Model": "SM-J320Y"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J3(2016)",
    "Device": "j3ltetw",
    "Model": "SM-J320YZ"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J3(2016)",
    "Device": "j3lteusc",
    "Model": "SM-J320R4"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J3(2016)",
    "Device": "j3ltevzw",
    "Model": "SM-J320V"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J3(2016)",
    "Device": "j3ltevzw",
    "Model": "SM-J320VPP"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J3(2016)",
    "Device": "j3ltexsa",
    "Model": "SM-J320ZN"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J3(2016)",
    "Device": "j3xlte",
    "Model": "SM-J320F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J3(2016)",
    "Device": "j3xlte",
    "Model": "SM-J320G"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J3(2016)",
    "Device": "j3xlte",
    "Model": "SM-J320M"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J3(2016)",
    "Device": "j3xlteaio",
    "Model": "SAMSUNG-SM-J320AZ"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J3(2016)",
    "Device": "j3xlteaio",
    "Model": "SAMSUNG-SM-J321AZ"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J3(2016)",
    "Device": "j3xlteatt",
    "Model": "SAMSUNG-SM-J320A"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J3(2016)",
    "Device": "j3xltebmc",
    "Model": "SM-J320W8"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J3(2016)",
    "Device": "j3xnlte",
    "Model": "SM-J320FN"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J3(2017)",
    "Device": "j3y17lte",
    "Model": "SM-J330F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J3(2017)",
    "Device": "j3y17lte",
    "Model": "SM-J330FN"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J3(2017)",
    "Device": "j3y17ltekx",
    "Model": "SM-J330N"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J3(2017)",
    "Device": "j3y17ltelgt",
    "Model": "SM-J330L"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J3(2018)",
    "Device": "j3topltecs",
    "Model": "SM-J337W"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J4",
    "Device": "j4lte",
    "Model": "SM-J400F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J4",
    "Device": "j4lte",
    "Model": "SM-J400G"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J4",
    "Device": "j4lte",
    "Model": "SM-J400M"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J4 Core",
    "Device": "j4corelte",
    "Model": "SM-J410F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J4 Core",
    "Device": "j4corelte",
    "Model": "SM-J410G"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J4+",
    "Device": "j4primelte",
    "Model": "SM-J415F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J4+",
    "Device": "j4primelte",
    "Model": "SM-J415FN"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J4+",
    "Device": "j4primelte",
    "Model": "SM-J415G"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J4+",
    "Device": "j4primelte",
    "Model": "SM-J415GN"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J4+",
    "Device": "j4primeltekx",
    "Model": "SM-J415N"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J5",
    "Device": "j53g",
    "Model": "SM-J500H"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J5",
    "Device": "j5lte",
    "Model": "SM-J5007"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J5",
    "Device": "j5lte",
    "Model": "SM-J500F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J5",
    "Device": "j5lte",
    "Model": "SM-J500G"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J5",
    "Device": "j5lte",
    "Model": "SM-J500M"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J5",
    "Device": "j5ltechn",
    "Model": "SM-J5008"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J5",
    "Device": "j5ltekx",
    "Model": "SM-J500N0"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J5",
    "Device": "j5nlte",
    "Model": "SM-J500FN"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J5",
    "Device": "j5y17lte",
    "Model": "SM-J530F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J5",
    "Device": "j5y17lte",
    "Model": "SM-J530FM"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J5",
    "Device": "j5y17ltektt",
    "Model": "SM-J530K"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J5",
    "Device": "j5y17ltelgt",
    "Model": "SM-J530L"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J5",
    "Device": "j5y17lteskt",
    "Model": "SM-J530S"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J5",
    "Device": "j5ylte",
    "Model": "SM-J500Y"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J5 Prime",
    "Device": "on5xelte",
    "Model": "SM-G570F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J5 Prime",
    "Device": "on5xelte",
    "Model": "SM-G570M"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J5 Prime",
    "Device": "on5xelte",
    "Model": "SM-G570Y"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J5 Prime",
    "Device": "on5xelteins",
    "Model": "SM-G570F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J5 Prime",
    "Device": "on5xltechn",
    "Model": "SM-G5700"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J5 Pro",
    "Device": "j5y17lte",
    "Model": "SM-J530G"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J5 Pro",
    "Device": "j5y17lte",
    "Model": "SM-J530GM"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J5 Pro",
    "Device": "j5y17ltedx",
    "Model": "SM-J530Y"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J5 Pro",
    "Device": "j5y17ltextc",
    "Model": "SM-J530YM"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J5(2016)",
    "Device": "j5x3g",
    "Model": "SM-J510H"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J5(2016)",
    "Device": "j5xltecmcc",
    "Model": "SM-J5108"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J5(2016)",
    "Device": "j5xnlte",
    "Model": "SM-J510F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J5(2016)",
    "Device": "j5xnlte",
    "Model": "SM-J510FN"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J5(2016)",
    "Device": "j5xnlte",
    "Model": "SM-J510FQ"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J5(2016)",
    "Device": "j5xnlte",
    "Model": "SM-J510GN"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J5(2016)",
    "Device": "j5xnlte",
    "Model": "SM-J510MN"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J5(2016)",
    "Device": "j5xnlte",
    "Model": "SM-J510UN"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J5(2016)",
    "Device": "j5xnltektt",
    "Model": "SM-J510K"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J5(2016)",
    "Device": "j5xnltelgt",
    "Model": "SM-J510L"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J5(2016)",
    "Device": "j5xnlteskt",
    "Model": "SM-J510S"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J6",
    "Device": "j6lte",
    "Model": "SM-J600F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J6",
    "Device": "j6lte",
    "Model": "SM-J600FN"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J6",
    "Device": "j6lte",
    "Model": "SM-J600G"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J6",
    "Device": "j6lte",
    "Model": "SM-J600GT"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J6",
    "Device": "j6ltekx",
    "Model": "SM-J600N"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J6",
    "Device": "j6ltelgt",
    "Model": "SM-J600L"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J6+",
    "Device": "j6primelte",
    "Model": "SM-J610F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J6+",
    "Device": "j6primelte",
    "Model": "SM-J610FN"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J6+",
    "Device": "j6primelte",
    "Model": "SM-J610G"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J7",
    "Device": "",
    "Model": ""
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J7",
    "Device": "j75ltektt",
    "Model": "SM-J700K"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J7",
    "Device": "j7e3g",
    "Model": "SM-J700H"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J7",
    "Device": "j7elte",
    "Model": "SM-J700F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J7",
    "Device": "j7elte",
    "Model": "SM-J700M"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J7",
    "Device": "j7ltechn",
    "Model": "SM-J7008"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J7",
    "Device": "j7popelteue",
    "Model": "SM-J727U"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J7",
    "Device": "j7poplteusc",
    "Model": "SM-J727R4"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J7",
    "Device": "j7popltevzw",
    "Model": "SM-J727VPP"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J7",
    "Device": "j7topeltevzw",
    "Model": "SM-J737VPP"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J7",
    "Device": "j7toplteatt",
    "Model": "SM-J737A"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J7",
    "Device": "j7toplteue",
    "Model": "SM-J737U"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J7",
    "Device": "j7y17lte",
    "Model": "SM-J730F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J7",
    "Device": "j7y17lte",
    "Model": "SM-J730FM"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J7 Aura",
    "Device": "j7topelteusc",
    "Model": "SM-J737R4"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J7 Crown",
    "Device": "j7topeltetfnvzw",
    "Model": "SM-S767VL"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J7 Crown",
    "Device": "j7topltetfntmo",
    "Model": "SM-S757BL"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J7 Duo",
    "Device": "j7duolte",
    "Model": "SM-J720F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J7 Duo",
    "Device": "j7duolte",
    "Model": "SM-J720M"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J7 Max",
    "Device": "j7maxlte",
    "Model": "SM-G615F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J7 Neo",
    "Device": "j7velte",
    "Model": "SM-J701F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J7 Neo",
    "Device": "j7velte",
    "Model": "SM-J701M"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J7 Neo",
    "Device": "j7velte",
    "Model": "SM-J701MT"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J7 Perx",
    "Device": "j7popltespr",
    "Model": "SM-J727P"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J7 Pop",
    "Device": "j7popelteaio",
    "Model": "SAMSUNG-SM-J727AZ"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J7 Pop",
    "Device": "j7popelteatt",
    "Model": "SAMSUNG-SM-J727A"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J7 Pop",
    "Device": "j7popqltetfnvzw",
    "Model": "SM-S727VL"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J7 Prime",
    "Device": "j7popeltemtr",
    "Model": "SM-J727T1"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J7 Prime",
    "Device": "j7popeltetmo",
    "Model": "SM-J727T"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J7 Prime",
    "Device": "on7xelte",
    "Model": "SM-G610F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J7 Prime",
    "Device": "on7xelte",
    "Model": "SM-G610M"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J7 Prime",
    "Device": "on7xelte",
    "Model": "SM-G610Y"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J7 Prime",
    "Device": "on7xltechn",
    "Model": "SM-G6100"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J7 Prime2",
    "Device": "on7xreflte",
    "Model": "SM-G611M"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J7 Prime2",
    "Device": "on7xreflte",
    "Model": "SM-G611MT"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J7 Prime2",
    "Device": "on7xreflteins",
    "Model": "SM-G611FF"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J7 Pro",
    "Device": "j7y17lte",
    "Model": "SM-J730G"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J7 Pro",
    "Device": "j7y17lte",
    "Model": "SM-J730GM"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J7 Refine",
    "Device": "j7topeltespr",
    "Model": "SM-J737P"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J7 Sky Pro",
    "Device": "j7popeltetfntmo",
    "Model": "SM-S737TL"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J7 Star",
    "Device": "j7topltemtr",
    "Model": "SM-J737T1"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J7 Star",
    "Device": "j7topltetmo",
    "Model": "SM-J737T"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J7 V",
    "Device": "j7popltevzw",
    "Model": "SM-J727V"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J7 V",
    "Device": "j7topeltevzw",
    "Model": "SM-J737V"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J7(2015)",
    "Device": "j7ltespr",
    "Model": "SM-J700P"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J7(2016)",
    "Device": "j7eltemtr",
    "Model": "SM-J700T1"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J7(2016)",
    "Device": "j7eltetmo",
    "Model": "SM-J700T"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J7(2016)",
    "Device": "j7xelte",
    "Model": "SM-J710F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J7(2016)",
    "Device": "j7xelte",
    "Model": "SM-J710FQ"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J7(2016)",
    "Device": "j7xelte",
    "Model": "SM-J710GN"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J7(2016)",
    "Device": "j7xelte",
    "Model": "SM-J710MN"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J7(2016)",
    "Device": "j7xeltecmcc",
    "Model": "SM-J7108"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J7(2016)",
    "Device": "j7xeltektt",
    "Model": "SM-J710K"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J7(2016)",
    "Device": "j7xltectc",
    "Model": "SM-J7109"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J7(2017)",
    "Device": "j7y17ltektt",
    "Model": "SM-J730K"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J7+",
    "Device": "jadelte",
    "Model": "SM-C710F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J8",
    "Device": "j8y18lte",
    "Model": "SM-J810F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J8",
    "Device": "j8y18lte",
    "Model": "SM-J810G"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J8",
    "Device": "j8y18lte",
    "Model": "SM-J810M"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy J8",
    "Device": "j8y18lte",
    "Model": "SM-J810Y"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Jean",
    "Device": "a6pltektt",
    "Model": "SM-A605K"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Jean2",
    "Device": "a20e",
    "Model": "SM-A202K"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Jump2",
    "Device": "m33x",
    "Model": "SM-M336K"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Jump3",
    "Device": "m44x",
    "Model": "SM-M446K"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Jump4",
    "Device": "m36x",
    "Model": "SM-M366K"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy K",
    "Device": "SHW-M130K",
    "Model": "SHW-M130K"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy K Zoom",
    "Device": "m2a3g",
    "Model": "SM-C111"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy K Zoom",
    "Device": "m2a3g",
    "Model": "SM-C111M"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy K Zoom",
    "Device": "m2alte",
    "Model": "SM-C115"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy K Zoom",
    "Device": "m2alte",
    "Model": "SM-C115M"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy K Zoom",
    "Device": "m2altecan",
    "Model": "SM-C115W"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy K Zoom",
    "Device": "m2altelgt",
    "Model": "SM-C115L"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy M Pro2",
    "Device": "lucas",
    "Model": "GT-B7810"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy M Style",
    "Device": "SHW-M340L",
    "Model": "SHW-M340L"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy M Style",
    "Device": "SHW-M340S",
    "Model": "SHW-M340S"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy M Style",
    "Device": "vastoicmcc",
    "Model": "GT-I8258"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy M01",
    "Device": "m01q",
    "Model": "SM-M015F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy M01",
    "Device": "m01q",
    "Model": "SM-M015G"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy M01 Core",
    "Device": "a01core",
    "Model": "SM-M013F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy M01s",
    "Device": "a10s",
    "Model": "SM-M017F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy M02",
    "Device": "a02",
    "Model": "SM-M022F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy M02",
    "Device": "a02",
    "Model": "SM-M022G"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy M02",
    "Device": "a02",
    "Model": "SM-M022M"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy M02s",
    "Device": "a02q",
    "Model": "SM-M025F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy M04",
    "Device": "m04",
    "Model": "SM-M045F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy M05",
    "Device": "a05m",
    "Model": "SM-M055F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy M06 5G",
    "Device": "a06x",
    "Model": "SM-M066B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy M07",
    "Device": "a07",
    "Model": "SM-M075F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy M10",
    "Device": "m10lte",
    "Model": "SM-M105F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy M10",
    "Device": "m10lte",
    "Model": "SM-M105G"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy M10",
    "Device": "m10lte",
    "Model": "SM-M105M"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy M10",
    "Device": "m10lte",
    "Model": "SM-M105Y"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy M10s",
    "Device": "m10s",
    "Model": "SM-M107F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy M11",
    "Device": "m11q",
    "Model": "SM-M115F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy M11",
    "Device": "m11q",
    "Model": "SM-M115M"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy M12",
    "Device": "m12",
    "Model": "SM-M127F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy M12",
    "Device": "m12",
    "Model": "SM-M127G"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy M12",
    "Device": "m12",
    "Model": "SM-M127N"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy M13",
    "Device": "m13",
    "Model": "SM-M135F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy M13",
    "Device": "m13",
    "Model": "SM-M135FU"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy M13",
    "Device": "m13",
    "Model": "SM-M135M"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy M13 5G",
    "Device": "a13x",
    "Model": "SM-M136B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy M14",
    "Device": "a05s",
    "Model": "SM-M145F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy M14 5G",
    "Device": "m14x",
    "Model": "SM-M146B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy M15 5G",
    "Device": "m15x",
    "Model": "SM-M156B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy M16 5G",
    "Device": "m16xm",
    "Model": "SM-M166P"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy M17 5G",
    "Device": "a17x",
    "Model": "SM-M176B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy M17e 5G",
    "Device": "a07x",
    "Model": "SM-M076B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy M20",
    "Device": "m20",
    "Model": "SM-M205N"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy M20",
    "Device": "m20lte",
    "Model": "SM-M205F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy M20",
    "Device": "m20lte",
    "Model": "SM-M205FN"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy M20",
    "Device": "m20lte",
    "Model": "SM-M205G"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy M20",
    "Device": "m20lte",
    "Model": "SM-M205M"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy M21",
    "Device": "m21",
    "Model": "SM-M215F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy M21 2021 Edition",
    "Device": "m21",
    "Model": "SM-M215G"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy M22",
    "Device": "m22",
    "Model": "SM-M225FV"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy M23 5G",
    "Device": "m23xq",
    "Model": "SM-M236B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy M23 5G",
    "Device": "m23xq",
    "Model": "SM-M236Q"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy M30",
    "Device": "m30lte",
    "Model": "SM-M305F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy M30",
    "Device": "m30lte",
    "Model": "SM-M305M"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy M30s",
    "Device": "m30s",
    "Model": "SM-M3070"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy M30s",
    "Device": "m30s",
    "Model": "SM-M307F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy M30s",
    "Device": "m30s",
    "Model": "SM-M307FN"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy M31",
    "Device": "m31",
    "Model": "SM-M315F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy M31s",
    "Device": "m31s",
    "Model": "SM-M317F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy M32",
    "Device": "m32",
    "Model": "SM-M325F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy M32",
    "Device": "m32",
    "Model": "SM-M325FV"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy M32 5G",
    "Device": "a32x",
    "Model": "SM-M326B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy M33 5G",
    "Device": "m33x",
    "Model": "SM-M336B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy M33 5G",
    "Device": "m33x",
    "Model": "SM-M336BU"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy M34 5G",
    "Device": "m34x",
    "Model": "SM-M346B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy M34 5G",
    "Device": "m34x",
    "Model": "SM-M346B1"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy M34 5G",
    "Device": "m34x",
    "Model": "SM-M346B2"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy M35 5G",
    "Device": "m35x",
    "Model": "SM-M356B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy M36 5G",
    "Device": "m36x",
    "Model": "SM-M366B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy M40",
    "Device": "m40",
    "Model": "SM-M405F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy M42 5G",
    "Device": "a42xq",
    "Model": "SM-M426B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy M51",
    "Device": "m51",
    "Model": "SM-M515F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy M52 5G",
    "Device": "m52xq",
    "Model": "SM-M526B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy M52 5G",
    "Device": "m52xq",
    "Model": "SM-M526BR"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy M53 5G",
    "Device": "m53x",
    "Model": "SM-M536B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy M54 5G",
    "Device": "m54x",
    "Model": "SM-M546B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy M55 5G",
    "Device": "m55xq",
    "Model": "SM-M556B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy M55 5G",
    "Device": "m55xq",
    "Model": "SM-M556E"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy M55s 5G",
    "Device": "m55xq",
    "Model": "SM-M558B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy M56 5G",
    "Device": "m56x",
    "Model": "SM-M566B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy M62",
    "Device": "m62",
    "Model": "SM-M625F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Mega 2",
    "Device": "mega23g",
    "Model": "SM-G750H"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Mega 5.8",
    "Device": "crater",
    "Model": "GT-I9152"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Mega 5.8",
    "Device": "crater3gctc",
    "Model": "SCH-P709"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Mega 5.8",
    "Device": "craterss",
    "Model": "GT-I9150"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Mega 5.8",
    "Device": "cratertd3g",
    "Model": "GT-I9158"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Mega 6.3",
    "Device": "melius3g",
    "Model": "GT-I9200"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Mega 6.3",
    "Device": "melius3g",
    "Model": "GT-I9208"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Mega 6.3",
    "Device": "melius3gduosctc",
    "Model": "SCH-P729"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Mega 6.3",
    "Device": "meliuslte",
    "Model": "GT-I9205"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Mega 6.3",
    "Device": "meliuslteMetroPCS",
    "Model": "SGH-M819N"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Mega 6.3",
    "Device": "meliuslteatt",
    "Model": "SAMSUNG-SGH-I527"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Mega 6.3",
    "Device": "meliusltecan",
    "Model": "SGH-I527M"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Mega 6.3",
    "Device": "meliusltektt",
    "Model": "SHV-E310K"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Mega 6.3",
    "Device": "meliusltelgt",
    "Model": "SHV-E310L"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Mega 6.3",
    "Device": "meliuslteskt",
    "Model": "SHV-E310S"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Mega 6.3",
    "Device": "meliusltespr",
    "Model": "SPH-L600"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Mega 6.3",
    "Device": "meliuslteusc",
    "Model": "SCH-R960"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Mega Plus",
    "Device": "craterq3g",
    "Model": "GT-I9152P"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Mega Plus",
    "Device": "craterq3g",
    "Model": "GT-I9158P"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Mega Plus",
    "Device": "megapluslte",
    "Model": "GT-I9158V"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Mega2",
    "Device": "mega2lte",
    "Model": "SM-G750F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Mega2",
    "Device": "mega2lteatt",
    "Model": "SAMSUNG-SM-G750A"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Mega2",
    "Device": "vasta3g",
    "Model": "SM-G750H"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Mega2",
    "Device": "vastalte",
    "Model": "SM-G7508Q"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Mega2",
    "Device": "vastaltezh",
    "Model": "SM-G7508Q"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Mini",
    "Device": "GT-S5570",
    "Model": "GT-S5570"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Mini",
    "Device": "GT-S5570B",
    "Model": "GT-S5570B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Mini",
    "Device": "GT-S5570I",
    "Model": "GT-S5570I"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Mini",
    "Device": "GT-S5570L",
    "Model": "GT-S5570L"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Mini",
    "Device": "GT-S5578",
    "Model": "GT-S5578"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Mini",
    "Device": "SGH-T499",
    "Model": "SGH-T499"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Mini",
    "Device": "SGH-T499V",
    "Model": "SGH-T499V"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Mini",
    "Device": "SGH-T499Y",
    "Model": "SGH-T499Y"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Mini2",
    "Device": "GT-S6500",
    "Model": "GT-S6500"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Mini2",
    "Device": "GT-S6500D",
    "Model": "GT-S6500D"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Mini2",
    "Device": "GT-S6500L",
    "Model": "GT-S6500L"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Mini2",
    "Device": "GT-S6500T",
    "Model": "GT-S6500T"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Music",
    "Device": "ivoryss",
    "Model": "GT-S6010"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Music",
    "Device": "ivoryss",
    "Model": "GT-S6010L"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Music Duos",
    "Device": "ivory",
    "Model": "GT-S6012"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Music Duos",
    "Device": "ivory",
    "Model": "GT-S6012B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy NX",
    "Device": "u0lte",
    "Model": "EK-GN120"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy NX",
    "Device": "u0lte",
    "Model": "EK-GN120A"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy NX",
    "Device": "u0lteue",
    "Model": "EK-GN120A"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Neo",
    "Device": "SHW-M220L",
    "Model": "SHW-M220L"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Nexus",
    "Device": "maguro",
    "Model": "Galaxy Nexus"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Nexus",
    "Device": "maguro",
    "Model": "Galaxy X"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Nexus",
    "Device": "toro",
    "Model": "Galaxy Nexus"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Nexus",
    "Device": "toroplus",
    "Model": "Galaxy Nexus"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note",
    "Device": "GT-I9220",
    "Model": "GT-I9220"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note",
    "Device": "GT-I9228",
    "Model": "GT-I9228"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note",
    "Device": "GT-N7000",
    "Model": "GT-N7000"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note",
    "Device": "GT-N7005",
    "Model": "GT-N7005"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note",
    "Device": "SC-05D",
    "Model": "SC-05D"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note",
    "Device": "SCH-i889",
    "Model": "SCH-i889"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note",
    "Device": "SGH-I717",
    "Model": "SAMSUNG-SGH-I717"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note",
    "Device": "SGH-I717",
    "Model": "SGH-I717"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note",
    "Device": "SGH-I717D",
    "Model": "SGH-I717D"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note",
    "Device": "SGH-I717M",
    "Model": "SGH-I717M"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note",
    "Device": "SGH-I717R",
    "Model": "SGH-I717R"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note",
    "Device": "SGH-T879",
    "Model": "SGH-T879"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note",
    "Device": "SHV-E160K",
    "Model": "SHV-E160K"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note",
    "Device": "SHV-E160L",
    "Model": "SHV-E160L"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note",
    "Device": "SHV-E160S",
    "Model": "SHV-E160S"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note 10.1",
    "Device": "lt033g",
    "Model": "SM-P601"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note 10.1",
    "Device": "lt033g",
    "Model": "SM-P602"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note 10.1",
    "Device": "lt03ltektt",
    "Model": "SM-P605K"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note 10.1",
    "Device": "lt03ltelgt",
    "Model": "SM-P605L"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note 10.1",
    "Device": "lt03lteskt",
    "Model": "SM-P605S"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note 10.1",
    "Device": "p4notelte",
    "Model": "GT-N8020"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note 10.1",
    "Device": "p4noteltektt",
    "Model": "SHV-E230K"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note 10.1",
    "Device": "p4noteltelgt",
    "Model": "SHV-E230L"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note 10.1",
    "Device": "p4notelteskt",
    "Model": "SHV-E230S"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note 10.1",
    "Device": "p4noteltespr",
    "Model": "SPH-P600"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note 10.1",
    "Device": "p4notelteusc",
    "Model": "SCH-I925U"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note 10.1",
    "Device": "p4noteltevzw",
    "Model": "SCH-I925"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note 10.1",
    "Device": "p4noterf",
    "Model": "GT-N8000"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note 10.1",
    "Device": "p4noterf",
    "Model": "GT-N8005"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note 10.1",
    "Device": "p4noterfktt",
    "Model": "SHW-M480K"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note 10.1",
    "Device": "p4notewifi",
    "Model": "GT-N8013"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note 10.1",
    "Device": "p4notewifi43241any",
    "Model": "SHW-M486W"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note 10.1",
    "Device": "p4notewifiany",
    "Model": "SHW-M480W"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note 10.1",
    "Device": "p4notewifiktt",
    "Model": "SHW-M485W"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note 10.1",
    "Device": "p4notewifiww",
    "Model": "GT-N8010"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note 10.1 2014 Edition",
    "Device": "",
    "Model": ""
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note 10.1 2014 Edition",
    "Device": "lt033g",
    "Model": "SM-P601"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note 10.1 2014 Edition",
    "Device": "lt03lte",
    "Model": "SM-P605"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note 10.1 2014 Edition",
    "Device": "lt03lte",
    "Model": "SM-P605M"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note 10.1 2014 Edition",
    "Device": "lt03ltetmo",
    "Model": "SM-P607T"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note 10.1 2014 Edition",
    "Device": "lt03ltevzw",
    "Model": "SM-P605V"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note 10.1 2014 Edition",
    "Device": "lt03wifi",
    "Model": "SM-P600"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note 10.1 2014 Edition",
    "Device": "lt03wifikx",
    "Model": "SM-P600"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note 10.1 2014 Edition",
    "Device": "lt03wifiue",
    "Model": "SM-P600"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note 8.0",
    "Device": "kona3g",
    "Model": "GT-N5100"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note 8.0",
    "Device": "kona3g",
    "Model": "GT-N5105"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note 8.0",
    "Device": "konalte",
    "Model": "GT-N5120"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note 8.0",
    "Device": "konalteatt",
    "Model": "SAMSUNG-SGH-I467"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note 8.0",
    "Device": "konaltecan",
    "Model": "SGH-I467M"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note 8.0",
    "Device": "konawifi",
    "Model": "GT-N5110"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note 8.0",
    "Device": "konawifiany",
    "Model": "SHW-M500W"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note Edge",
    "Device": "SC-01G",
    "Model": "SC-01G"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note Edge",
    "Device": "SCL24",
    "Model": "SCL24"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note Edge",
    "Device": "tbeltektt",
    "Model": "SM-N915K"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note Edge",
    "Device": "tbeltelgt",
    "Model": "SM-N915L"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note Edge",
    "Device": "tbelteskt",
    "Model": "SM-N915S"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note Edge",
    "Device": "tblte",
    "Model": "SM-N9150"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note Edge",
    "Device": "tblte",
    "Model": "SM-N915F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note Edge",
    "Device": "tblte",
    "Model": "SM-N915FY"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note Edge",
    "Device": "tblte",
    "Model": "SM-N915G"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note Edge",
    "Device": "tblte",
    "Model": "SM-N915X"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note Edge",
    "Device": "tblteatt",
    "Model": "SAMSUNG-SM-N915A"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note Edge",
    "Device": "tbltecan",
    "Model": "SM-N915W8"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note Edge",
    "Device": "tbltechn",
    "Model": "SM-N9150"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note Edge",
    "Device": "tbltespr",
    "Model": "SM-N915P"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note Edge",
    "Device": "tbltetmo",
    "Model": "SM-N915T"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note Edge",
    "Device": "tbltetmo",
    "Model": "SM-N915T3"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note Edge",
    "Device": "tblteusc",
    "Model": "SM-N915R4"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note Edge",
    "Device": "tbltevzw",
    "Model": "SM-N915V"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note Fan Edition",
    "Device": "gracerlte",
    "Model": "SM-N935F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note Fan Edition",
    "Device": "gracerltektt",
    "Model": "SM-N935K"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note Fan Edition",
    "Device": "gracerltelgt",
    "Model": "SM-N935L"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note Fan Edition",
    "Device": "gracerlteskt",
    "Model": "SM-N935S"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note II",
    "Device": "t0lteatt",
    "Model": "SAMSUNG-SGH-I317"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note Pro",
    "Device": "v1awifi",
    "Model": "SM-P900"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note Pro 12.2",
    "Device": "v1a3g",
    "Model": "SM-P901"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note Pro 12.2",
    "Device": "v1awifi",
    "Model": "SM-P900"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note Pro 12.2",
    "Device": "v1awifikx",
    "Model": "SM-P900"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note Pro 12.2",
    "Device": "viennalte",
    "Model": "SM-P905"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note Pro 12.2",
    "Device": "viennalte",
    "Model": "SM-P905M"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note Pro 12.2",
    "Device": "viennalteatt",
    "Model": "SAMSUNG-SM-P907A"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note Pro 12.2",
    "Device": "viennaltekx",
    "Model": "SM-P905F0"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note Pro 12.2",
    "Device": "viennaltevzw",
    "Model": "SM-P905V"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note10",
    "Device": "d1",
    "Model": "SM-N970F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note10",
    "Device": "d1q",
    "Model": "SM-N9700"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note10",
    "Device": "d1q",
    "Model": "SM-N970U"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note10",
    "Device": "d1q",
    "Model": "SM-N970U1"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note10",
    "Device": "d1q",
    "Model": "SM-N970W"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note10 5G",
    "Device": "d1x",
    "Model": "SM-N971N"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note10 Lite",
    "Device": "r7",
    "Model": "SM-N770F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note10 Lite",
    "Device": "r7",
    "Model": "SM-N770X"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note10+",
    "Device": "SC-01M",
    "Model": "SC-01M"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note10+",
    "Device": "SCV45",
    "Model": "SCV45"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note10+",
    "Device": "d2q",
    "Model": "SM-N9750"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note10+",
    "Device": "d2q",
    "Model": "SM-N975C"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note10+",
    "Device": "d2q",
    "Model": "SM-N975U"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note10+",
    "Device": "d2q",
    "Model": "SM-N975U1"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note10+",
    "Device": "d2q",
    "Model": "SM-N975W"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note10+",
    "Device": "d2s",
    "Model": "SM-N975F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note10+ 5G",
    "Device": "d2x",
    "Model": "SM-N976B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note10+ 5G",
    "Device": "d2x",
    "Model": "SM-N976N"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note10+ 5G",
    "Device": "d2xq",
    "Model": "SM-N9760"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note10+ 5G",
    "Device": "d2xq",
    "Model": "SM-N976Q"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note10+ 5G",
    "Device": "d2xq",
    "Model": "SM-N976V"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note10+ 5G",
    "Device": "d2xq2",
    "Model": "SM-N976U"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note2",
    "Device": "SC-02E",
    "Model": "SC-02E"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note2",
    "Device": "t03g",
    "Model": "GT-N7100"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note2",
    "Device": "t03g",
    "Model": "GT-N7100T"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note2",
    "Device": "t03gchn",
    "Model": "GT-N7100"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note2",
    "Device": "t03gchnduos",
    "Model": "GT-N7102"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note2",
    "Device": "t03gchnduos",
    "Model": "GT-N7102i"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note2",
    "Device": "t03gcmcc",
    "Model": "GT-N7108"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note2",
    "Device": "t03gctc",
    "Model": "SCH-N719"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note2",
    "Device": "t03gcuduos",
    "Model": "GT-N7102"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note2",
    "Device": "t03gcuduos",
    "Model": "GT-N7102i"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note2",
    "Device": "t0lte",
    "Model": "GT-N7105"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note2",
    "Device": "t0lte",
    "Model": "GT-N7105T"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note2",
    "Device": "t0lteatt",
    "Model": "SAMSUNG-SGH-I317"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note2",
    "Device": "t0ltecan",
    "Model": "SGH-I317M"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note2",
    "Device": "t0ltecan",
    "Model": "SGH-T889V"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note2",
    "Device": "t0ltecmcc",
    "Model": "GT-N7108D"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note2",
    "Device": "t0ltedcm",
    "Model": "SC-02E"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note2",
    "Device": "t0ltektt",
    "Model": "SHV-E250K"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note2",
    "Device": "t0ltelgt",
    "Model": "SHV-E250L"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note2",
    "Device": "t0lteskt",
    "Model": "SHV-E250S"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note2",
    "Device": "t0ltespr",
    "Model": "SPH-L900"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note2",
    "Device": "t0ltetmo",
    "Model": "SGH-T889"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note2",
    "Device": "t0lteusc",
    "Model": "SCH-R950"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note2",
    "Device": "t0ltevzw",
    "Model": "SCH-I605"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note20",
    "Device": "c1s",
    "Model": "SM-N980F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note20 5G",
    "Device": "c1q",
    "Model": "SM-N9810"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note20 5G",
    "Device": "c1q",
    "Model": "SM-N981N"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note20 5G",
    "Device": "c1q",
    "Model": "SM-N981U"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note20 5G",
    "Device": "c1q",
    "Model": "SM-N981U1"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note20 5G",
    "Device": "c1q",
    "Model": "SM-N981W"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note20 5G",
    "Device": "c1s",
    "Model": "SM-N981B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note20 Ultra",
    "Device": "c2s",
    "Model": "SM-N985F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note20 Ultra 5G",
    "Device": "SC-53A",
    "Model": "SC-53A"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note20 Ultra 5G",
    "Device": "SCG06",
    "Model": "SCG06"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note20 Ultra 5G",
    "Device": "c2q",
    "Model": "SM-N9860"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note20 Ultra 5G",
    "Device": "c2q",
    "Model": "SM-N986N"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note20 Ultra 5G",
    "Device": "c2q",
    "Model": "SM-N986U"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note20 Ultra 5G",
    "Device": "c2q",
    "Model": "SM-N986U1"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note20 Ultra 5G",
    "Device": "c2q",
    "Model": "SM-N986W"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note20 Ultra 5G",
    "Device": "c2s",
    "Model": "SM-N986B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note3",
    "Device": "SC-01F",
    "Model": "SC-01F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note3",
    "Device": "SC-02F",
    "Model": "SC-02F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note3",
    "Device": "SCL22",
    "Model": "SCL22"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note3",
    "Device": "ha3g",
    "Model": "SM-N900"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note3",
    "Device": "ha3g",
    "Model": "SM-N9000Q"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note3",
    "Device": "hlte",
    "Model": "SM-N9005"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note3",
    "Device": "hlte",
    "Model": "SM-N9006"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note3",
    "Device": "hlte",
    "Model": "SM-N9007"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note3",
    "Device": "hlte",
    "Model": "SM-N9008V"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note3",
    "Device": "hlte",
    "Model": "SM-N9009"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note3",
    "Device": "hlte",
    "Model": "SM-N900U"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note3",
    "Device": "hlteatt",
    "Model": "SAMSUNG-SM-N900A"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note3",
    "Device": "hltecan",
    "Model": "SM-N900W8"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note3",
    "Device": "hltektt",
    "Model": "SM-N900K"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note3",
    "Device": "hltelgt",
    "Model": "SM-N900L"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note3",
    "Device": "hlteskt",
    "Model": "SM-N900S"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note3",
    "Device": "hltespr",
    "Model": "SM-N900P"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note3",
    "Device": "hltetmo",
    "Model": "SM-N900T"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note3",
    "Device": "hlteusc",
    "Model": "SM-N900R4"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note3",
    "Device": "hltevzw",
    "Model": "SM-N900V"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note3",
    "Device": "htdlte",
    "Model": "SM-N9007"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note3 Duos",
    "Device": "hlte",
    "Model": "SM-N9002"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note3 Duos",
    "Device": "hlte",
    "Model": "SM-N9008"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note3 Neo",
    "Device": "frescoltektt",
    "Model": "SM-N750K"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note3 Neo",
    "Device": "frescoltelgt",
    "Model": "SM-N750L"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note3 Neo",
    "Device": "frescolteskt",
    "Model": "SM-N750S"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note3 Neo",
    "Device": "hl3g",
    "Model": "SM-N750"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note3 Neo",
    "Device": "hl3g",
    "Model": "SM-N7500Q"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note3 Neo",
    "Device": "hl3gds",
    "Model": "SM-N7502"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note3 Neo",
    "Device": "hllte",
    "Model": "SM-N7505"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note3 Neo",
    "Device": "hllte",
    "Model": "SM-N7505L"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note3 Neo",
    "Device": "hllte",
    "Model": "SM-N7507"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note4",
    "Device": "tre3caltektt",
    "Model": "SM-N916K"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note4",
    "Device": "tre3g",
    "Model": "SM-N910H"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note4",
    "Device": "trelte",
    "Model": "SM-N910C"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note4",
    "Device": "treltektt",
    "Model": "SM-N910K"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note4",
    "Device": "treltelgt",
    "Model": "SM-N910L"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note4",
    "Device": "trelteskt",
    "Model": "SM-N910S"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note4",
    "Device": "trhplte",
    "Model": "SM-N910U"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note4",
    "Device": "trlte",
    "Model": "SM-N910F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note4",
    "Device": "trlte",
    "Model": "SM-N910G"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note4",
    "Device": "trlte",
    "Model": "SM-N910X"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note4",
    "Device": "trlteatt",
    "Model": "SAMSUNG-SM-N910A"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note4",
    "Device": "trlteatt",
    "Model": "SM-N910F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note4",
    "Device": "trltecan",
    "Model": "SM-N910W8"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note4",
    "Device": "trltechn",
    "Model": "SM-N9100"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note4",
    "Device": "trltechn",
    "Model": "SM-N9106W"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note4",
    "Device": "trltechn",
    "Model": "SM-N9108V"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note4",
    "Device": "trltechn",
    "Model": "SM-N9109W"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note4",
    "Device": "trltechnzh",
    "Model": "SM-N9100"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note4",
    "Device": "trltespr",
    "Model": "SM-N910P"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note4",
    "Device": "trltetmo",
    "Model": "SM-N910T"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note4",
    "Device": "trltetmo",
    "Model": "SM-N910T2"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note4",
    "Device": "trltetmo",
    "Model": "SM-N910T3"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note4",
    "Device": "trlteusc",
    "Model": "SM-N910R4"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note4",
    "Device": "trltevzw",
    "Model": "SM-N910V"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note4 S-LTE",
    "Device": "tre3caltelgt",
    "Model": "SM-N916L"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note4 S-LTE",
    "Device": "tre3calteskt",
    "Model": "SM-N916S"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note5",
    "Device": "noblelte",
    "Model": "SM-N9208"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note5",
    "Device": "noblelte",
    "Model": "SM-N920C"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note5",
    "Device": "noblelte",
    "Model": "SM-N920F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note5",
    "Device": "noblelte",
    "Model": "SM-N920G"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note5",
    "Device": "noblelte",
    "Model": "SM-N920I"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note5",
    "Device": "noblelte",
    "Model": "SM-N920X"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note5",
    "Device": "noblelteacg",
    "Model": "SM-N920R7"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note5",
    "Device": "noblelteatt",
    "Model": "SAMSUNG-SM-N920A"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note5",
    "Device": "nobleltebmc",
    "Model": "SM-N920W8"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note5",
    "Device": "nobleltechn",
    "Model": "SM-N9200"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note5",
    "Device": "nobleltecmcc",
    "Model": "SM-N9208"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note5",
    "Device": "nobleltehk",
    "Model": "SM-N9200"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note5",
    "Device": "nobleltektt",
    "Model": "SM-N920K"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note5",
    "Device": "nobleltelgt",
    "Model": "SM-N920L"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note5",
    "Device": "nobleltelra",
    "Model": "SM-N920R6"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note5",
    "Device": "noblelteskt",
    "Model": "SM-N920S"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note5",
    "Device": "nobleltespr",
    "Model": "SM-N920P"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note5",
    "Device": "nobleltetmo",
    "Model": "SM-N920T"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note5",
    "Device": "noblelteusc",
    "Model": "SM-N920R4"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note5",
    "Device": "nobleltevzw",
    "Model": "SM-N920V"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note7",
    "Device": "SC-01J",
    "Model": "SC-01J"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note7",
    "Device": "SCV34",
    "Model": "SCV34"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note7",
    "Device": "gracelte",
    "Model": "SM-N930F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note7",
    "Device": "gracelte",
    "Model": "SM-N930X"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note7",
    "Device": "graceltektt",
    "Model": "SM-N930K"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note7",
    "Device": "graceltelgt",
    "Model": "SM-N930L"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note7",
    "Device": "gracelteskt",
    "Model": "SM-N930S"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note7",
    "Device": "graceqlteacg",
    "Model": "SM-N930R7"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note7",
    "Device": "graceqlteatt",
    "Model": "SAMSUNG-SM-N930A"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note7",
    "Device": "graceqltebmc",
    "Model": "SM-N930W8"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note7",
    "Device": "graceqltechn",
    "Model": "SM-N9300"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note7",
    "Device": "graceqltedcm",
    "Model": "SGH-N037"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note7",
    "Device": "graceqltelra",
    "Model": "SM-N930R6"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note7",
    "Device": "graceqltespr",
    "Model": "SM-N930P"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note7",
    "Device": "graceqltetfnvzw",
    "Model": "SM-N930VL"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note7",
    "Device": "graceqltetmo",
    "Model": "SM-N930T"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note7",
    "Device": "graceqlteue",
    "Model": "SM-N930U"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note7",
    "Device": "graceqlteusc",
    "Model": "SM-N930R4"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note7",
    "Device": "graceqltevzw",
    "Model": "SM-N930V"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note8",
    "Device": "SC-01K",
    "Model": "SC-01K"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note8",
    "Device": "SCV37",
    "Model": "SCV37"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note8",
    "Device": "greatlte",
    "Model": "SM-N950F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note8",
    "Device": "greatlteks",
    "Model": "SM-N950N"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note8",
    "Device": "greatlteks",
    "Model": "SM-N950XN"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note8",
    "Device": "greatqlte",
    "Model": "SM-N950U"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note8",
    "Device": "greatqltechn",
    "Model": "SM-N9500"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note8",
    "Device": "greatqltecmcc",
    "Model": "SM-N9508"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note8",
    "Device": "greatqltecs",
    "Model": "SM-N950W"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note8",
    "Device": "greatqlteue",
    "Model": "SM-N950U1"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note9",
    "Device": "SC-01L",
    "Model": "SC-01L"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note9",
    "Device": "SCV40",
    "Model": "SCV40"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note9",
    "Device": "crownlte",
    "Model": "SM-N960F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note9",
    "Device": "crownlteks",
    "Model": "SM-N960N"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note9",
    "Device": "crownqltechn",
    "Model": "SM-N9600"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note9",
    "Device": "crownqltecs",
    "Model": "SM-N960W"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note9",
    "Device": "crownqltesq",
    "Model": "SM-N960U"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Note9",
    "Device": "crownqlteue",
    "Model": "SM-N960U1"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy On Max",
    "Device": "j7maxlte",
    "Model": "SM-G615FU"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy On Nxt",
    "Device": "on7xelte",
    "Model": "SM-G610F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy On5",
    "Device": "o5lte",
    "Model": "SM-G550FY"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy On5",
    "Device": "o5ltechn",
    "Model": "SM-G5500"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy On5",
    "Device": "on5ltemtr",
    "Model": "SM-G550T1"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy On5",
    "Device": "on5ltetfntmo",
    "Model": "SM-S550TL"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy On5",
    "Device": "on5ltetmo",
    "Model": "SM-G550T"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy On5",
    "Device": "on5ltetmo",
    "Model": "SM-G550T2"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy On5 2016 时尚版",
    "Device": "on5xfltechn",
    "Model": "SM-G5520"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy On5 2016 时尚版",
    "Device": "on5xfltechn",
    "Model": "SM-G5528"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy On5 2016 青春版",
    "Device": "on5xlltechn",
    "Model": "SM-G5510"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy On5 Pro",
    "Device": "o5prolte",
    "Model": "SM-G550FY"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy On5(2016)",
    "Device": "on5xltechn",
    "Model": "SM-G5700"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy On6",
    "Device": "j6lte",
    "Model": "SM-J600GF"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy On7",
    "Device": "o7lte",
    "Model": "SM-G600FY"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy On7",
    "Device": "o7ltechn",
    "Model": "SM-G6000"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy On7",
    "Device": "on7elte",
    "Model": "SM-G600F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy On7 Prime",
    "Device": "on7xreflte",
    "Model": "SM-G611F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy On7 Prime",
    "Device": "on7xrefltektt",
    "Model": "SM-G611K"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy On7 Prime",
    "Device": "on7xrefltelgt",
    "Model": "SM-G611L"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy On7 Prime",
    "Device": "on7xreflteskt",
    "Model": "SM-G611S"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy On7 Pro",
    "Device": "o7prolte",
    "Model": "SM-G600FY"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy On7(2016)",
    "Device": "on7xeltektt",
    "Model": "SM-G610K"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy On7(2016)",
    "Device": "on7xeltelgt",
    "Model": "SM-G610L"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy On7(2016)",
    "Device": "on7xelteskt",
    "Model": "SM-G610S"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy On7(2016)",
    "Device": "on7xltechn",
    "Model": "SM-G6100"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy On8",
    "Device": "j7xlte",
    "Model": "SM-J710FN"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy On8",
    "Device": "j8y18lte",
    "Model": "SM-J810GF"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Player",
    "Device": "YP-GB70",
    "Model": "YP-GB70"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Player 3.6",
    "Device": "YP-GS1",
    "Model": "YP-GS1"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Player 4",
    "Device": "YP-GB1",
    "Model": "YP-GB1"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Player 4.0",
    "Device": "YP-G1",
    "Model": "YP-G1"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Player 4.2",
    "Device": "YP-GI1",
    "Model": "YP-GI1"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Player 5",
    "Device": "YP-G70",
    "Model": "YP-G70"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Player 5.8",
    "Device": "harrison",
    "Model": "YP-GP1"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Player 5.8",
    "Device": "harrisonkrktt",
    "Model": "YP-GP1"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Player 5.8",
    "Device": "harrisonkrlgt",
    "Model": "YP-GP1"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Player 50",
    "Device": "YP-G50",
    "Model": "YP-G50"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Pocket",
    "Device": "GT-S5300",
    "Model": "GT-S5300"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Pocket",
    "Device": "GT-S5300B",
    "Model": "GT-S5300B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Pocket",
    "Device": "GT-S5300L",
    "Model": "GT-S5300L"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Pocket",
    "Device": "GT-S5302",
    "Model": "GT-S5302"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Pocket",
    "Device": "GT-S5302B",
    "Model": "GT-S5302B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Pocket",
    "Device": "coriplus",
    "Model": "GT-S5301"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Pocket",
    "Device": "coriplusds",
    "Model": "GT-S5303"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Pocket Neo",
    "Device": "corsica",
    "Model": "GT-S5312"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Pocket Neo",
    "Device": "corsica",
    "Model": "GT-S5312B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Pocket Neo",
    "Device": "corsica",
    "Model": "GT-S5312L"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Pocket Neo",
    "Device": "corsicass",
    "Model": "GT-S5310"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Pocket Neo",
    "Device": "corsicass",
    "Model": "GT-S5310B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Pocket Neo",
    "Device": "corsicass",
    "Model": "GT-S5310E"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Pocket Neo",
    "Device": "corsicass",
    "Model": "GT-S5310G"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Pocket Neo",
    "Device": "corsicass",
    "Model": "GT-S5310L"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Pocket Neo",
    "Device": "corsicass",
    "Model": "GT-S5310T"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Pocket Neo",
    "Device": "corsicave3g",
    "Model": "GT-S5310I"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Pocket Neo",
    "Device": "corsicave3g",
    "Model": "GT-S5310N"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Pocket Neo",
    "Device": "corsicaveds3gvj",
    "Model": "GT-S5312C"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Pocket Neo",
    "Device": "corsicaveds3gvj",
    "Model": "GT-S5312M"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Pocket Neo",
    "Device": "d2aio",
    "Model": "SAMSUNG-SGH-I747Z"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Pocket Plus",
    "Device": "coriplus",
    "Model": "GT-S5301"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Pocket Plus",
    "Device": "coriplus",
    "Model": "GT-S5301B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Pocket Plus",
    "Device": "coriplus",
    "Model": "GT-S5301L"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Pocket SS",
    "Device": "corsicave3g",
    "Model": "GT-S5310C"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Pocket SS",
    "Device": "corsicave3g",
    "Model": "GT-S5310M"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Pocket2",
    "Device": "pocket23g",
    "Model": "SM-G110B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Pocket2",
    "Device": "pocket23g",
    "Model": "SM-G110M"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Pocket2",
    "Device": "pocket2ss3g",
    "Model": "SM-G110H"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Pop",
    "Device": "superiorlteskt",
    "Model": "SHV-E220S"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Pop (CDMA)",
    "Device": "SCH-i559",
    "Model": "SCH-i559"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Precedent",
    "Device": "SCH-M828C",
    "Model": "SCH-M828C"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Premier",
    "Device": "superior",
    "Model": "GT-I9260"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Premier",
    "Device": "superiorcmcc",
    "Model": "GT-I9268"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Prevail",
    "Device": "SPH-M820",
    "Model": "SPH-M820-BST"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Prevail2",
    "Device": "raybst",
    "Model": "SPH-M840"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Pro",
    "Device": "GT-B7510",
    "Model": "GT-B7510"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Pro",
    "Device": "GT-B7510B",
    "Model": "GT-B7510B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Pro",
    "Device": "GT-B7510L",
    "Model": "GT-B7510L"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Proclaim",
    "Device": "SCH-S720C",
    "Model": "SCH-S720C"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Q",
    "Device": "SGH-T589",
    "Model": "SGH-T589"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Q",
    "Device": "SGH-T589R",
    "Model": "SGH-T589R"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Q",
    "Device": "SGH-T589W",
    "Model": "SGH-T589W"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Quantum2",
    "Device": "a82xq",
    "Model": "SM-A826S"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Quantum3",
    "Device": "m53x",
    "Model": "SM-M536S"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Quantum4",
    "Device": "a54x",
    "Model": "SM-A546S"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Quantum5",
    "Device": "a55x",
    "Model": "SM-A556S"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Quantum6",
    "Device": "a56x",
    "Model": "SM-A566S"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy R-Style",
    "Device": "jaguark",
    "Model": "SHV-E170K"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy R-Style",
    "Device": "jaguarl",
    "Model": "SHV-E170L"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy R-Style",
    "Device": "jaguars",
    "Model": "SHV-E170S"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Reverb",
    "Device": "iconvmu",
    "Model": "SPH-M950"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Round",
    "Device": "flteskt",
    "Model": "SM-G910S"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Rugby",
    "Device": "comanchecan",
    "Model": "SGH-I547C"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Rugby Pro",
    "Device": "comancheatt",
    "Model": "SAMSUNG-SGH-I547"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Rush",
    "Device": "prevail2spr",
    "Model": "SPH-M830"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S",
    "Device": "GT-I9000",
    "Model": "GT-I9000"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S",
    "Device": "GT-I9000B",
    "Model": "GT-I9000B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S",
    "Device": "GT-I9000M",
    "Model": "GT-I9000M"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S",
    "Device": "GT-I9000T",
    "Model": "GT-I9000T"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S",
    "Device": "GT-I9003",
    "Model": "GT-I9003"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S",
    "Device": "GT-I9003L",
    "Model": "GT-I9003L"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S",
    "Device": "GT-I9008L",
    "Model": "GT-I9008L"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S",
    "Device": "GT-I9010",
    "Model": "GT-I9010"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S",
    "Device": "GT-I9018",
    "Model": "GT-I9018"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S",
    "Device": "GT-I9050",
    "Model": "GT-I9050"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S",
    "Device": "SC-02B",
    "Model": "SC-02B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S",
    "Device": "SCH-I500",
    "Model": "SCH-I500"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S",
    "Device": "SCH-S950C",
    "Model": "SCH-S950C"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S",
    "Device": "SCH-i909",
    "Model": "SCH-i909"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S",
    "Device": "SGH-I897",
    "Model": "SAMSUNG-SGH-I897"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S",
    "Device": "SGH-T959V",
    "Model": "SGH-T959V"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S",
    "Device": "SGH-T959W",
    "Model": "SGH-T959W"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S",
    "Device": "SHW-M110S",
    "Model": "SHW-M110S"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S",
    "Device": "SHW-M190S",
    "Model": "SHW-M190S"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S",
    "Device": "SPH-D700",
    "Model": "SPH-D700"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S",
    "Device": "loganlte",
    "Model": "GT-S7275"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S Advance",
    "Device": "GT-I9070",
    "Model": "GT-I9070"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S Advance",
    "Device": "GT-I9070P",
    "Model": "GT-I9070P"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S Aviator",
    "Device": "SCH-R930",
    "Model": "SCH-R930"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S Blaze",
    "Device": "SGH-T769",
    "Model": "SGH-T769"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S BlazeQ",
    "Device": "apexqtmo",
    "Model": "SGH-T699"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S Captivate",
    "Device": "SGH-I896",
    "Model": "SAMSUNG-SGH-I896"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S Captivate",
    "Device": "SGH-I896",
    "Model": "SGH-I896"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S Continuum",
    "Device": "SCH-I400",
    "Model": "SCH-I400"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S DUOS",
    "Device": "kyleopen",
    "Model": "GT-S7562"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S DUOS",
    "Device": "kyleopen",
    "Model": "GT-S7562L"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S Duos",
    "Device": "kylechn",
    "Model": "GT-S7562"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S Duos",
    "Device": "kyleopen",
    "Model": "GT-S7562"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S Duos",
    "Device": "kyletdcmcc",
    "Model": "GT-S7568"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S Duos2",
    "Device": "kyleprods",
    "Model": "GT-S7582"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S Duos2",
    "Device": "kyleprods",
    "Model": "GT-S7582L"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S Duos3",
    "Device": "vivalto3gvn",
    "Model": "SM-G313HZ"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S Epic",
    "Device": "SPH-D700",
    "Model": "SPH-D700"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S Fascinate",
    "Device": "SGH-T959P",
    "Model": "SGH-T959P"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S Glide",
    "Device": "SGH-I927R",
    "Model": "SAMSUNG-SGH-I927R"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S Lightray",
    "Device": "SCH-R940",
    "Model": "SCH-R940"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S Plus",
    "Device": "GT-I9001",
    "Model": "GT-I9001"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S Stratosphere",
    "Device": "SCH-I405",
    "Model": "SCH-I405"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S Vibrant",
    "Device": "SGH-T959",
    "Model": "SGH-T959"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S Vibrant",
    "Device": "SGH-T959D",
    "Model": "SGH-T959D"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S duos",
    "Device": "kyleichn",
    "Model": "GT-S7566"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S 轻奢版",
    "Device": "dreamliteqltechn",
    "Model": "SM-G8750"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S10",
    "Device": "SC-03L",
    "Model": "SC-03L"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S10",
    "Device": "SCV41",
    "Model": "SCV41"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S10",
    "Device": "beyond1",
    "Model": "SM-G973F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S10",
    "Device": "beyond1",
    "Model": "SM-G973N"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S10",
    "Device": "beyond1q",
    "Model": "SM-G9730"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S10",
    "Device": "beyond1q",
    "Model": "SM-G9738"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S10",
    "Device": "beyond1q",
    "Model": "SM-G973C"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S10",
    "Device": "beyond1q",
    "Model": "SM-G973U"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S10",
    "Device": "beyond1q",
    "Model": "SM-G973U1"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S10",
    "Device": "beyond1q",
    "Model": "SM-G973W"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S10 5G",
    "Device": "beyondx",
    "Model": "SM-G977B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S10 5G",
    "Device": "beyondx",
    "Model": "SM-G977N"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S10 5G",
    "Device": "beyondxq",
    "Model": "SM-G977P"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S10 5G",
    "Device": "beyondxq",
    "Model": "SM-G977T"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S10 5G",
    "Device": "beyondxq",
    "Model": "SM-G977U"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S10 Lite",
    "Device": "r5q",
    "Model": "SM-G770F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S10 Lite",
    "Device": "r5q",
    "Model": "SM-G770U1"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S10+",
    "Device": "SC-04L",
    "Model": "SC-04L"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S10+",
    "Device": "SCV42",
    "Model": "SCV42"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S10+",
    "Device": "beyond2",
    "Model": "SM-G975F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S10+",
    "Device": "beyond2",
    "Model": "SM-G975N"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S10+",
    "Device": "beyond2q",
    "Model": "SM-G9750"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S10+",
    "Device": "beyond2q",
    "Model": "SM-G9758"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S10+",
    "Device": "beyond2q",
    "Model": "SM-G975U"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S10+",
    "Device": "beyond2q",
    "Model": "SM-G975U1"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S10+",
    "Device": "beyond2q",
    "Model": "SM-G975W"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S10+ Olympic Games Edition",
    "Device": "SC-05L",
    "Model": "SC-05L"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S10e",
    "Device": "beyond0",
    "Model": "SM-G970F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S10e",
    "Device": "beyond0",
    "Model": "SM-G970N"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S10e",
    "Device": "beyond0q",
    "Model": "SM-G9700"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S10e",
    "Device": "beyond0q",
    "Model": "SM-G9708"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S10e",
    "Device": "beyond0q",
    "Model": "SM-G970U"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S10e",
    "Device": "beyond0q",
    "Model": "SM-G970U1"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S10e",
    "Device": "beyond0q",
    "Model": "SM-G970W"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S2",
    "Device": "GT-I9100",
    "Model": "GT-I9100"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S2",
    "Device": "GT-I9100M",
    "Model": "GT-I9100M"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S2",
    "Device": "GT-I9100P",
    "Model": "GT-I9100P"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S2",
    "Device": "GT-I9100T",
    "Model": "GT-I9100T"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S2",
    "Device": "GT-I9103",
    "Model": "GT-I9103"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S2",
    "Device": "GT-I9108",
    "Model": "GT-I9108"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S2",
    "Device": "GT-I9210T",
    "Model": "GT-I9210T"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S2",
    "Device": "SC-02C",
    "Model": "SC-02C"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S2",
    "Device": "SCH-R760X",
    "Model": "SCH-R760X"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S2",
    "Device": "SGH-I777",
    "Model": "SAMSUNG-SGH-I777"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S2",
    "Device": "SGH-S959G",
    "Model": "SGH-S959G"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S2",
    "Device": "SGH-T989",
    "Model": "SGH-T989"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S2",
    "Device": "SHV-E110S",
    "Model": "SHV-E110S"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S2",
    "Device": "SHW-M250K",
    "Model": "SHW-M250K"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S2",
    "Device": "SHW-M250L",
    "Model": "SHW-M250L"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S2",
    "Device": "SHW-M250S",
    "Model": "SHW-M250S"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S2",
    "Device": "t1cmcc",
    "Model": "GT-I9108"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S2 Duos",
    "Device": "SCH-i929",
    "Model": "SCH-i929"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S2 Duos TV",
    "Device": "logandsdtv",
    "Model": "GT-S7273T"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S2 Epic",
    "Device": "SCH-R760",
    "Model": "SCH-R760"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S2 Epic",
    "Device": "SPH-D710",
    "Model": "SPH-D710"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S2 Epic",
    "Device": "SPH-D710BST",
    "Model": "SPH-D710BST"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S2 Epic",
    "Device": "SPH-D710VMUB",
    "Model": "SPH-D710VMUB"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S2 HD LTE",
    "Device": "SGH-I757M",
    "Model": "SGH-I757M"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S2 HD LTE",
    "Device": "SHV-E120K",
    "Model": "SHV-E120K"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S2 HD LTE",
    "Device": "SHV-E120L",
    "Model": "SHV-E120L"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S2 HD LTE",
    "Device": "SHV-E120S",
    "Model": "SHV-E120S"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S2 LTE",
    "Device": "GT-I9210",
    "Model": "GT-I9210"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S2 LTE",
    "Device": "SC-03D",
    "Model": "SC-03D"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S2 LTE",
    "Device": "SGH-I727R",
    "Model": "SGH-I727R"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S2 Plus",
    "Device": "GT-I9100G",
    "Model": "GT-I9100G"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S2 Plus",
    "Device": "s2ve",
    "Model": "GT-I9105"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S2 Plus",
    "Device": "s2vep",
    "Model": "GT-I9105P"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S2 Skyrocket",
    "Device": "SGH-I727",
    "Model": "SAMSUNG-SGH-I727"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S2 Skyrocket",
    "Device": "SGH-I727",
    "Model": "SGH-I727"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S2 Wimax",
    "Device": "ISW11SC",
    "Model": "ISW11SC"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S2 X",
    "Device": "SGH-T989D",
    "Model": "SGH-T989D"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S20",
    "Device": "x1s",
    "Model": "SM-G980F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S20 5G",
    "Device": "SC-51A",
    "Model": "SC-51A"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S20 5G",
    "Device": "SC51Aa",
    "Model": "SC51Aa"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S20 5G",
    "Device": "SCG01",
    "Model": "SCG01"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S20 5G",
    "Device": "x1q",
    "Model": "SM-G9810"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S20 5G",
    "Device": "x1q",
    "Model": "SM-G981N"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S20 5G",
    "Device": "x1q",
    "Model": "SM-G981U"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S20 5G",
    "Device": "x1q",
    "Model": "SM-G981U1"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S20 5G",
    "Device": "x1q",
    "Model": "SM-G981V"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S20 5G",
    "Device": "x1q",
    "Model": "SM-G981W"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S20 5G",
    "Device": "x1s",
    "Model": "SM-G981B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S20 FE",
    "Device": "r8q",
    "Model": "SM-G780G"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S20 FE",
    "Device": "r8s",
    "Model": "SM-G780F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S20 FE 5G",
    "Device": "r8q",
    "Model": "SM-G7810"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S20 FE 5G",
    "Device": "r8q",
    "Model": "SM-G781B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S20 FE 5G",
    "Device": "r8q",
    "Model": "SM-G781N"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S20 FE 5G",
    "Device": "r8q",
    "Model": "SM-G781U"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S20 FE 5G",
    "Device": "r8q",
    "Model": "SM-G781U1"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S20 FE 5G",
    "Device": "r8q",
    "Model": "SM-G781V"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S20 FE 5G",
    "Device": "r8q",
    "Model": "SM-G781W"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S20 Ultra 5G",
    "Device": "SCG03",
    "Model": "SCG03"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S20 Ultra 5G",
    "Device": "z3q",
    "Model": "SM-G9880"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S20 Ultra 5G",
    "Device": "z3q",
    "Model": "SM-G988N"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S20 Ultra 5G",
    "Device": "z3q",
    "Model": "SM-G988Q"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S20 Ultra 5G",
    "Device": "z3q",
    "Model": "SM-G988U"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S20 Ultra 5G",
    "Device": "z3q",
    "Model": "SM-G988U1"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S20 Ultra 5G",
    "Device": "z3q",
    "Model": "SM-G988W"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S20 Ultra 5G",
    "Device": "z3s",
    "Model": "SM-G988B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S20+",
    "Device": "y2s",
    "Model": "SM-G985F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S20+ 5G",
    "Device": "SC-52A",
    "Model": "SC-52A"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S20+ 5G",
    "Device": "SCG02",
    "Model": "SCG02"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S20+ 5G",
    "Device": "y2q",
    "Model": "SM-G9860"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S20+ 5G",
    "Device": "y2q",
    "Model": "SM-G986N"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S20+ 5G",
    "Device": "y2q",
    "Model": "SM-G986U"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S20+ 5G",
    "Device": "y2q",
    "Model": "SM-G986U1"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S20+ 5G",
    "Device": "y2q",
    "Model": "SM-G986W"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S20+ 5G",
    "Device": "y2s",
    "Model": "SM-G986B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S21 5G",
    "Device": "SC-51B",
    "Model": "SC-51B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S21 5G",
    "Device": "SCG09",
    "Model": "SCG09"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S21 5G",
    "Device": "o1q",
    "Model": "SM-G9910"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S21 5G",
    "Device": "o1q",
    "Model": "SM-G991Q"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S21 5G",
    "Device": "o1q",
    "Model": "SM-G991U1"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S21 5G",
    "Device": "o1q",
    "Model": "SM-G991W"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S21 5G",
    "Device": "o1s",
    "Model": "SM-G991B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S21 5G",
    "Device": "o1s",
    "Model": "SM-G991N"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S21 FE 5G",
    "Device": "r9q",
    "Model": "SM-G9900"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S21 FE 5G",
    "Device": "r9q",
    "Model": "SM-G990B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S21 FE 5G",
    "Device": "r9q",
    "Model": "SM-G990B2"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S21 FE 5G",
    "Device": "r9q",
    "Model": "SM-G990U"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S21 FE 5G",
    "Device": "r9q",
    "Model": "SM-G990U1"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S21 FE 5G",
    "Device": "r9q",
    "Model": "SM-G990U2"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S21 FE 5G",
    "Device": "r9q",
    "Model": "SM-G990U3"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S21 FE 5G",
    "Device": "r9q",
    "Model": "SM-G990W"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S21 FE 5G",
    "Device": "r9q",
    "Model": "SM-G990W2"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S21 FE 5G",
    "Device": "r9s",
    "Model": "SM-G990E"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S21 Ultra 5G",
    "Device": "SC-52B",
    "Model": "SC-52B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S21 Ultra 5G",
    "Device": "p3q",
    "Model": "SM-G9980"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S21 Ultra 5G",
    "Device": "p3q",
    "Model": "SM-G998U"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S21 Ultra 5G",
    "Device": "p3q",
    "Model": "SM-G998U1"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S21 Ultra 5G",
    "Device": "p3q",
    "Model": "SM-G998W"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S21 Ultra 5G",
    "Device": "p3s",
    "Model": "SM-G998B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S21 Ultra 5G",
    "Device": "p3s",
    "Model": "SM-G998N"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S21+ 5G",
    "Device": "SCG10",
    "Model": "SCG10"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S21+ 5G",
    "Device": "t2q",
    "Model": "SM-G9960"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S21+ 5G",
    "Device": "t2q",
    "Model": "SM-G996U"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S21+ 5G",
    "Device": "t2q",
    "Model": "SM-G996U1"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S21+ 5G",
    "Device": "t2q",
    "Model": "SM-G996W"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S21+ 5G",
    "Device": "t2s",
    "Model": "SM-G996B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S21+ 5G",
    "Device": "t2s",
    "Model": "SM-G996N"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S22",
    "Device": "SC-51C",
    "Model": "SC-51C"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S22",
    "Device": "SCG13",
    "Model": "SCG13"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S22",
    "Device": "r0q",
    "Model": "SM-S9010"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S22",
    "Device": "r0q",
    "Model": "SM-S901E"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S22",
    "Device": "r0q",
    "Model": "SM-S901N"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S22",
    "Device": "r0q",
    "Model": "SM-S901U"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S22",
    "Device": "r0q",
    "Model": "SM-S901U1"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S22",
    "Device": "r0q",
    "Model": "SM-S901W"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S22",
    "Device": "r0s",
    "Model": "SM-S901B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S22 Ultra",
    "Device": "SC-52C",
    "Model": "SC-52C"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S22 Ultra",
    "Device": "SCG14",
    "Model": "SCG14"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S22 Ultra",
    "Device": "b0q",
    "Model": "SM-S9080"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S22 Ultra",
    "Device": "b0q",
    "Model": "SM-S908E"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S22 Ultra",
    "Device": "b0q",
    "Model": "SM-S908N"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S22 Ultra",
    "Device": "b0q",
    "Model": "SM-S908U"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S22 Ultra",
    "Device": "b0q",
    "Model": "SM-S908U1"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S22 Ultra",
    "Device": "b0q",
    "Model": "SM-S908W"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S22 Ultra",
    "Device": "b0s",
    "Model": "SM-S908B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S22+",
    "Device": "g0q",
    "Model": "SM-S9060"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S22+",
    "Device": "g0q",
    "Model": "SM-S906E"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S22+",
    "Device": "g0q",
    "Model": "SM-S906N"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S22+",
    "Device": "g0q",
    "Model": "SM-S906U"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S22+",
    "Device": "g0q",
    "Model": "SM-S906U1"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S22+",
    "Device": "g0q",
    "Model": "SM-S906W"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S22+",
    "Device": "g0s",
    "Model": "SM-S906B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S23",
    "Device": "SC-51D",
    "Model": "SC-51D"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S23",
    "Device": "SCG19",
    "Model": "SCG19"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S23",
    "Device": "dm1q",
    "Model": "SM-S9110"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S23",
    "Device": "dm1q",
    "Model": "SM-S911B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S23",
    "Device": "dm1q",
    "Model": "SM-S911C"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S23",
    "Device": "dm1q",
    "Model": "SM-S911N"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S23",
    "Device": "dm1q",
    "Model": "SM-S911U"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S23",
    "Device": "dm1q",
    "Model": "SM-S911U1"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S23",
    "Device": "dm1q",
    "Model": "SM-S911W"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S23 FE",
    "Device": "SCG24",
    "Model": "SCG24"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S23 FE",
    "Device": "r11q",
    "Model": "SM-S7110"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S23 FE",
    "Device": "r11q",
    "Model": "SM-S711U"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S23 FE",
    "Device": "r11q",
    "Model": "SM-S711U1"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S23 FE",
    "Device": "r11q",
    "Model": "SM-S711W"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S23 FE",
    "Device": "r11s",
    "Model": "SM-S711B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S23 FE",
    "Device": "r11s",
    "Model": "SM-S711N"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S23 Ultra",
    "Device": "SC-52D",
    "Model": "SC-52D"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S23 Ultra",
    "Device": "SCG20",
    "Model": "SCG20"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S23 Ultra",
    "Device": "dm3q",
    "Model": "SM-S9180"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S23 Ultra",
    "Device": "dm3q",
    "Model": "SM-S918B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S23 Ultra",
    "Device": "dm3q",
    "Model": "SM-S918N"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S23 Ultra",
    "Device": "dm3q",
    "Model": "SM-S918Q"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S23 Ultra",
    "Device": "dm3q",
    "Model": "SM-S918U"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S23 Ultra",
    "Device": "dm3q",
    "Model": "SM-S918U1"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S23 Ultra",
    "Device": "dm3q",
    "Model": "SM-S918W"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S23+",
    "Device": "dm2q",
    "Model": "SM-S9160"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S23+",
    "Device": "dm2q",
    "Model": "SM-S916B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S23+",
    "Device": "dm2q",
    "Model": "SM-S916N"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S23+",
    "Device": "dm2q",
    "Model": "SM-S916U"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S23+",
    "Device": "dm2q",
    "Model": "SM-S916U1"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S23+",
    "Device": "dm2q",
    "Model": "SM-S916W"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S24",
    "Device": "SC-51E",
    "Model": "SC-51E"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S24",
    "Device": "SCG25",
    "Model": "SCG25"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S24",
    "Device": "e1q",
    "Model": "SM-S9210"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S24",
    "Device": "e1q",
    "Model": "SM-S921E"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S24",
    "Device": "e1q",
    "Model": "SM-S921Q"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S24",
    "Device": "e1q",
    "Model": "SM-S921U"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S24",
    "Device": "e1q",
    "Model": "SM-S921U1"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S24",
    "Device": "e1q",
    "Model": "SM-S921W"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S24",
    "Device": "e1s",
    "Model": "SM-S921B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S24",
    "Device": "e1s",
    "Model": "SM-S921N"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S24 FE",
    "Device": "SCG30",
    "Model": "SCG30"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S24 FE",
    "Device": "r12s",
    "Model": "SM-S7210"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S24 FE",
    "Device": "r12s",
    "Model": "SM-S721B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S24 FE",
    "Device": "r12s",
    "Model": "SM-S721N"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S24 FE",
    "Device": "r12s",
    "Model": "SM-S721Q"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S24 FE",
    "Device": "r12s",
    "Model": "SM-S721U"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S24 FE",
    "Device": "r12s",
    "Model": "SM-S721U1"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S24 FE",
    "Device": "r12s",
    "Model": "SM-S721W"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S24 Ultra",
    "Device": "SC-52E",
    "Model": "SC-52E"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S24 Ultra",
    "Device": "SCG26",
    "Model": "SCG26"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S24 Ultra",
    "Device": "e3q",
    "Model": "SM-S9280"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S24 Ultra",
    "Device": "e3q",
    "Model": "SM-S928B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S24 Ultra",
    "Device": "e3q",
    "Model": "SM-S928N"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S24 Ultra",
    "Device": "e3q",
    "Model": "SM-S928Q"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S24 Ultra",
    "Device": "e3q",
    "Model": "SM-S928U"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S24 Ultra",
    "Device": "e3q",
    "Model": "SM-S928U1"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S24 Ultra",
    "Device": "e3q",
    "Model": "SM-S928W"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S24+",
    "Device": "e2q",
    "Model": "SM-S9260"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S24+",
    "Device": "e2q",
    "Model": "SM-S926U"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S24+",
    "Device": "e2q",
    "Model": "SM-S926U1"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S24+",
    "Device": "e2q",
    "Model": "SM-S926W"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S24+",
    "Device": "e2s",
    "Model": "SM-S926B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S24+",
    "Device": "e2s",
    "Model": "SM-S926N"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S25",
    "Device": "SC-51F",
    "Model": "SC-51F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S25",
    "Device": "SCG31",
    "Model": "SCG31"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S25",
    "Device": "pa1q",
    "Model": "SM-S9310"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S25",
    "Device": "pa1q",
    "Model": "SM-S931B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S25",
    "Device": "pa1q",
    "Model": "SM-S931N"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S25",
    "Device": "pa1q",
    "Model": "SM-S931Q"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S25",
    "Device": "pa1q",
    "Model": "SM-S931U"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S25",
    "Device": "pa1q",
    "Model": "SM-S931U1"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S25",
    "Device": "pa1q",
    "Model": "SM-S931W"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S25",
    "Device": "pa1q",
    "Model": "SM-S931Z"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S25 Edge",
    "Device": "psq",
    "Model": "SM-S9370"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S25 Edge",
    "Device": "psq",
    "Model": "SM-S937B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S25 Edge",
    "Device": "psq",
    "Model": "SM-S937N"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S25 Edge",
    "Device": "psq",
    "Model": "SM-S937U"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S25 Edge",
    "Device": "psq",
    "Model": "SM-S937U1"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S25 Edge",
    "Device": "psq",
    "Model": "SM-S937W"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S25 FE",
    "Device": "r13s",
    "Model": "SM-S731B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S25 FE",
    "Device": "r13s",
    "Model": "SM-S731N"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S25 FE",
    "Device": "r13s",
    "Model": "SM-S731U"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S25 FE",
    "Device": "r13s",
    "Model": "SM-S731U1"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S25 FE",
    "Device": "r13s",
    "Model": "SM-S731W"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S25 Ultra",
    "Device": "SC-52F",
    "Model": "SC-52F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S25 Ultra",
    "Device": "SCG32",
    "Model": "SCG32"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S25 Ultra",
    "Device": "pa3q",
    "Model": "SM-S9380"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S25 Ultra",
    "Device": "pa3q",
    "Model": "SM-S938B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S25 Ultra",
    "Device": "pa3q",
    "Model": "SM-S938N"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S25 Ultra",
    "Device": "pa3q",
    "Model": "SM-S938Q"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S25 Ultra",
    "Device": "pa3q",
    "Model": "SM-S938U"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S25 Ultra",
    "Device": "pa3q",
    "Model": "SM-S938U1"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S25 Ultra",
    "Device": "pa3q",
    "Model": "SM-S938W"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S25 Ultra",
    "Device": "pa3q",
    "Model": "SM-S938Z"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S25+",
    "Device": "pa2q",
    "Model": "SM-S9360"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S25+",
    "Device": "pa2q",
    "Model": "SM-S936B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S25+",
    "Device": "pa2q",
    "Model": "SM-S936N"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S25+",
    "Device": "pa2q",
    "Model": "SM-S936U"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S25+",
    "Device": "pa2q",
    "Model": "SM-S936U1"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S25+",
    "Device": "pa2q",
    "Model": "SM-S936W"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S26",
    "Device": "m1q",
    "Model": "SC-51G"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S26",
    "Device": "m1q",
    "Model": "SCG36"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S26",
    "Device": "m1q",
    "Model": "SM-S9420"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S26",
    "Device": "m1q",
    "Model": "SM-S942C"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S26",
    "Device": "m1q",
    "Model": "SM-S942Q"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S26",
    "Device": "m1q",
    "Model": "SM-S942U"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S26",
    "Device": "m1q",
    "Model": "SM-S942U1"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S26",
    "Device": "m1q",
    "Model": "SM-S942W"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S26",
    "Device": "m1q",
    "Model": "SM-S942Z"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S26",
    "Device": "m1s",
    "Model": "SM-S942B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S26",
    "Device": "m1s",
    "Model": "SM-S942N"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S26 Ultra",
    "Device": "m3q",
    "Model": "SC-53G"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S26 Ultra",
    "Device": "m3q",
    "Model": "SCG37"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S26 Ultra",
    "Device": "m3q",
    "Model": "SM-S9480"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S26 Ultra",
    "Device": "m3q",
    "Model": "SM-S948B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S26 Ultra",
    "Device": "m3q",
    "Model": "SM-S948C"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S26 Ultra",
    "Device": "m3q",
    "Model": "SM-S948N"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S26 Ultra",
    "Device": "m3q",
    "Model": "SM-S948Q"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S26 Ultra",
    "Device": "m3q",
    "Model": "SM-S948U"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S26 Ultra",
    "Device": "m3q",
    "Model": "SM-S948U1"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S26 Ultra",
    "Device": "m3q",
    "Model": "SM-S948W"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S26 Ultra",
    "Device": "m3q",
    "Model": "SM-S948Z"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S26+",
    "Device": "m2q",
    "Model": "SC-52G"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S26+",
    "Device": "m2q",
    "Model": "SCG38"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S26+",
    "Device": "m2q",
    "Model": "SM-S9470"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S26+",
    "Device": "m2q",
    "Model": "SM-S947C"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S26+",
    "Device": "m2q",
    "Model": "SM-S947Q"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S26+",
    "Device": "m2q",
    "Model": "SM-S947U"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S26+",
    "Device": "m2q",
    "Model": "SM-S947U1"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S26+",
    "Device": "m2q",
    "Model": "SM-S947W"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S26+",
    "Device": "m2q",
    "Model": "SM-S947Z"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S26+",
    "Device": "m2s",
    "Model": "SM-S947B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S26+",
    "Device": "m2s",
    "Model": "SM-S947N"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S3",
    "Device": "SC-03E",
    "Model": "SC-03E"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S3",
    "Device": "c1att",
    "Model": "SGH-I748"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S3",
    "Device": "c1ktt",
    "Model": "SHV-E210K"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S3",
    "Device": "c1lgt",
    "Model": "SHV-E210L"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S3",
    "Device": "c1skt",
    "Model": "SHV-E210S"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S3",
    "Device": "d2att",
    "Model": "SAMSUNG-SGH-I747"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S3",
    "Device": "d2can",
    "Model": "SGH-I747M"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S3",
    "Device": "d2can",
    "Model": "SGH-T999V"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S3",
    "Device": "d2cri",
    "Model": "SCH-R530C"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S3",
    "Device": "d2dcm",
    "Model": "Gravity"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S3",
    "Device": "d2dcm",
    "Model": "SC-06D"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S3",
    "Device": "d2lteMetroPCS",
    "Model": "SGH-T999N"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S3",
    "Device": "d2lterefreshspr",
    "Model": "SPH-L710T"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S3",
    "Device": "d2ltetmo",
    "Model": "SGH-T999L"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S3",
    "Device": "d2mtr",
    "Model": "SCH-R530M"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S3",
    "Device": "d2spi",
    "Model": "SCH-L710"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S3",
    "Device": "d2spr",
    "Model": "SPH-L710"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S3",
    "Device": "d2tfnspr",
    "Model": "SCH-S960L"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S3",
    "Device": "d2tfnvzw",
    "Model": "SCH-S968C"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S3",
    "Device": "d2tmo",
    "Model": "SGH-T999"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S3",
    "Device": "d2usc",
    "Model": "SCH-R530U"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S3",
    "Device": "d2vmu",
    "Model": "SPH-L710"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S3",
    "Device": "d2vzw",
    "Model": "SCH-I535"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S3",
    "Device": "d2vzw",
    "Model": "SCH-I535PP"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S3",
    "Device": "d2xar",
    "Model": "SCH-R530X"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S3",
    "Device": "m0",
    "Model": "GT-I9300"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S3",
    "Device": "m0",
    "Model": "GT-I9300T"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S3",
    "Device": "m0apt",
    "Model": "SCH-I939"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S3",
    "Device": "m0chn",
    "Model": "GT-I9300"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S3",
    "Device": "m0cmcc",
    "Model": "GT-I9308"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S3",
    "Device": "m0ctc",
    "Model": "SCH-I939"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S3",
    "Device": "m0ctcduos",
    "Model": "SCH-I939D"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S3",
    "Device": "m0skt",
    "Model": "SHW-M440S"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S3",
    "Device": "m3",
    "Model": "GT-I9305"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S3",
    "Device": "m3",
    "Model": "GT-I9305N"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S3",
    "Device": "m3",
    "Model": "GT-I9305T"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S3",
    "Device": "m3dcm",
    "Model": "GravityQuad"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S3",
    "Device": "m3dcm",
    "Model": "SC-03E"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S3 Duos",
    "Device": "arubaslim",
    "Model": "GT-I8262B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S3 Mini",
    "Device": "golden",
    "Model": "GT-I8190"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S3 Mini",
    "Device": "golden",
    "Model": "GT-I8190L"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S3 Mini",
    "Device": "golden",
    "Model": "GT-I8190N"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S3 Mini",
    "Device": "golden",
    "Model": "GT-I8190T"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S3 Mini",
    "Device": "goldenlteatt",
    "Model": "SAMSUNG-SM-G730A"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S3 Mini",
    "Device": "goldenltebmc",
    "Model": "SM-G730W8"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S3 Mini",
    "Device": "goldenltevzw",
    "Model": "SM-G730V"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S3 Mini",
    "Device": "goldenve3g",
    "Model": "GT-I8200L"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S3 Mini Value Edition",
    "Device": "goldenve3g",
    "Model": "GT-I8200N"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S3 Mini Value Edition",
    "Device": "goldenvess3g",
    "Model": "GT-I8200"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S3 Mini Value Edition",
    "Device": "goldenvess3g",
    "Model": "GT-I8200Q"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S3 Neo",
    "Device": "s3ve3g",
    "Model": "GT-I9300I"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S3 Neo",
    "Device": "s3ve3g",
    "Model": "GT-I9301I"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S3 Neo",
    "Device": "s3ve3g",
    "Model": "GT-I9301Q"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S3 Neo",
    "Device": "s3ve3gdd",
    "Model": "GT-I9300I"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S3 Neo",
    "Device": "s3ve3gds",
    "Model": "GT-I9300I"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S3 Neo",
    "Device": "s3ve3gdsdd",
    "Model": "GT-I9300I"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S3 Neo Plus",
    "Device": "s3ve3g",
    "Model": "GT-I9300I"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S3 Neo Plus",
    "Device": "s3ve3g",
    "Model": "GT-I9308I"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S3 Progre",
    "Device": "SCL21",
    "Model": "SCL21"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S3 Slim",
    "Device": "wilcoxds",
    "Model": "SM-G3812B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S4",
    "Device": "SC-04E",
    "Model": "SC-04E"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S4",
    "Device": "ja3g",
    "Model": "GT-I9500"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S4",
    "Device": "ja3gduosctc",
    "Model": "SCH-I959"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S4",
    "Device": "jaltektt",
    "Model": "SHV-E300K"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S4",
    "Device": "jaltelgt",
    "Model": "SHV-E300L"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S4",
    "Device": "jalteskt",
    "Model": "SHV-E300S"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S4",
    "Device": "jflte",
    "Model": "GT-I9505"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S4",
    "Device": "jflte",
    "Model": "GT-I9508"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S4",
    "Device": "jflte",
    "Model": "GT-I9508C"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S4",
    "Device": "jflteMetroPCS",
    "Model": "SGH-M919N"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S4",
    "Device": "jflteaio",
    "Model": "SAMSUNG-SGH-I337Z"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S4",
    "Device": "jflteatt",
    "Model": "SAMSUNG-SGH-I337"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S4",
    "Device": "jfltecan",
    "Model": "SGH-I337M"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S4",
    "Device": "jfltecan",
    "Model": "SGH-M919V"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S4",
    "Device": "jfltecri",
    "Model": "SCH-R970C"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S4",
    "Device": "jfltecsp",
    "Model": "SCH-R970X"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S4",
    "Device": "jfltelra",
    "Model": "SCH-I545L"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S4",
    "Device": "jflterefreshspr",
    "Model": "SPH-L720T"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S4",
    "Device": "jfltespr",
    "Model": "SPH-L720"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S4",
    "Device": "jfltetfnatt",
    "Model": "SM-S975L"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S4",
    "Device": "jfltetfntmo",
    "Model": "SGH-S970G"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S4",
    "Device": "jfltetmo",
    "Model": "SGH-M919"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S4",
    "Device": "jflteusc",
    "Model": "SCH-R970"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S4",
    "Device": "jfltevzw",
    "Model": "SCH-I545"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S4",
    "Device": "jfltevzwpp",
    "Model": "SCH-I545PP"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S4",
    "Device": "jftdd",
    "Model": "GT-I9507"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S4",
    "Device": "jftdd",
    "Model": "GT-I9507V"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S4",
    "Device": "jfvelte",
    "Model": "GT-I9515"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S4",
    "Device": "jfvelte",
    "Model": "GT-I9515L"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S4",
    "Device": "jfwifi",
    "Model": "GT-I9505X"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S4",
    "Device": "jsglte",
    "Model": "GT-I9508V"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S4",
    "Device": "ks01lte",
    "Model": "GT-I9506"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S4",
    "Device": "ks01ltektt",
    "Model": "SHV-E330K"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S4",
    "Device": "ks01ltelgt",
    "Model": "SHV-E330L"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S4 Active",
    "Device": "jactivelte",
    "Model": "GT-I9295"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S4 Active",
    "Device": "jactivelteatt",
    "Model": "SAMSUNG-SGH-I537"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S4 Active",
    "Device": "jactivelteatt",
    "Model": "SGH-I537"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S4 Active",
    "Device": "jactivelteskt",
    "Model": "SHV-E470S"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S4 Duos",
    "Device": "ja3gchnduos",
    "Model": "GT-I9502"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S4 Google Play Edition",
    "Device": "jgedlte",
    "Model": "GT-I9505G"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S4 LTE-A",
    "Device": "ks01lteskt",
    "Model": "SHV-E330S"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S4 Mini",
    "Device": "serrano3g",
    "Model": "GT-I9190"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S4 Mini",
    "Device": "serranods",
    "Model": "GT-I9192"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S4 Mini",
    "Device": "serranolte",
    "Model": "GT-I9195"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S4 Mini",
    "Device": "serranolte",
    "Model": "GT-I9195L"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S4 Mini",
    "Device": "serranolte",
    "Model": "GT-I9195T"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S4 Mini",
    "Device": "serranolte",
    "Model": "GT-I9195X"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S4 Mini",
    "Device": "serranolte",
    "Model": "GT-I9197"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S4 Mini",
    "Device": "serranoltebmc",
    "Model": "SGH-I257M"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S4 Mini",
    "Device": "serranoltektt",
    "Model": "SHV-E370K"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S4 Mini",
    "Device": "serranoltekx",
    "Model": "SHV-E370D"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S4 Mini",
    "Device": "serranoltelra",
    "Model": "SCH-I435L"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S4 Mini",
    "Device": "serranoltespr",
    "Model": "SPH-L520"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S4 Mini",
    "Device": "serranolteusc",
    "Model": "SCH-R890"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S4 Mini",
    "Device": "serranoltevzw",
    "Model": "SCH-I435"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S4 Mini",
    "Device": "serranove3g",
    "Model": "GT-I9192I"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S4 Mini",
    "Device": "serranovelte",
    "Model": "GT-I9195I"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S4 Mini",
    "Device": "serranovolteatt",
    "Model": "SAMSUNG-SGH-I257"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S4 Zoom",
    "Device": "mproject3g",
    "Model": "SM-C101"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S4 Zoom",
    "Device": "mprojectlteatt",
    "Model": "SAMSUNG-SM-C105A"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S4 Zoom",
    "Device": "mprojectltektt",
    "Model": "SM-C105K"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S4 Zoom",
    "Device": "mprojectltelgt",
    "Model": "SM-C105L"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S4 Zoom",
    "Device": "mprojectlteskt",
    "Model": "SM-C105S"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S4 Zoom",
    "Device": "mprojectqlte",
    "Model": "SM-C105"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S5",
    "Device": "SC-04F",
    "Model": "SC-04F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S5",
    "Device": "SCL23",
    "Model": "SCL23"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S5",
    "Device": "k3g",
    "Model": "SM-G900H"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S5",
    "Device": "klte",
    "Model": "SM-G9008W"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S5",
    "Device": "klte",
    "Model": "SM-G9009W"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S5",
    "Device": "klte",
    "Model": "SM-G900F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S5",
    "Device": "klte",
    "Model": "SM-G900FQ"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S5",
    "Device": "klte",
    "Model": "SM-G900I"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S5",
    "Device": "klte",
    "Model": "SM-G900M"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S5",
    "Device": "klte",
    "Model": "SM-G900MD"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S5",
    "Device": "klteMetroPCS",
    "Model": "SM-G900T1"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S5",
    "Device": "klteMetroPCS",
    "Model": "SM-G900T4"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S5",
    "Device": "klteacg",
    "Model": "SM-G900R7"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S5",
    "Device": "klteaio",
    "Model": "SAMSUNG-SM-G900AZ"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S5",
    "Device": "klteatt",
    "Model": "SAMSUNG-SM-G900A"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S5",
    "Device": "kltecan",
    "Model": "SM-G900W8"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S5",
    "Device": "klteduoszn",
    "Model": "SM-G9006W"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S5",
    "Device": "kltektt",
    "Model": "SM-G900K"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S5",
    "Device": "kltelgt",
    "Model": "SM-G900L"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S5",
    "Device": "kltelra",
    "Model": "SM-G900R6"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S5",
    "Device": "klteskt",
    "Model": "SM-G900S"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S5",
    "Device": "kltespr",
    "Model": "SM-G900P"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S5",
    "Device": "kltetfnvzw",
    "Model": "SM-S903VL"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S5",
    "Device": "kltetmo",
    "Model": "SM-G900T"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S5",
    "Device": "kltetmo",
    "Model": "SM-G900T3"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S5",
    "Device": "klteusc",
    "Model": "SM-G900R4"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S5",
    "Device": "kltevzw",
    "Model": "SM-G900V"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S5",
    "Device": "kwifi",
    "Model": "SM-G900X"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S5",
    "Device": "lentisltektt",
    "Model": "SM-G906K"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S5",
    "Device": "lentisltelgt",
    "Model": "SM-G906L"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S5",
    "Device": "lentislteskt",
    "Model": "SM-G906S"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S5 Active",
    "Device": "SC-02G",
    "Model": "SC-02G"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S5 Active",
    "Device": "kactiveltekx",
    "Model": "SM-G870F0"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S5 Active",
    "Device": "klteactive",
    "Model": "SM-G870F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S5 Active",
    "Device": "klteattactive",
    "Model": "SAMSUNG-SM-G870A"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S5 Active",
    "Device": "kltecanactive",
    "Model": "SM-G870W"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S5 Dual SIM",
    "Device": "klte",
    "Model": "SM-G900FD"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S5 Google Play Edition",
    "Device": "kgedlte",
    "Model": "SM-G900FG"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S5 K Sport",
    "Device": "kltesprsports",
    "Model": "SM-G860P"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S5 LTE-A",
    "Device": "kccat6",
    "Model": "SM-G901F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S5 Mini",
    "Device": "kmini3g",
    "Model": "SM-G800H"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S5 Mini",
    "Device": "kminilteusc",
    "Model": "SM-G800R4"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S5 Neo",
    "Device": "s5neolte",
    "Model": "SM-G903F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S5 Neo",
    "Device": "s5neolte",
    "Model": "SM-G903M"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S5 Neo",
    "Device": "s5neoltecan",
    "Model": "SM-G903W"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S5 mini",
    "Device": "kmini3g",
    "Model": "SM-G800HQ"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S5 mini",
    "Device": "kminilte",
    "Model": "SM-G800F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S5 mini",
    "Device": "kminilte",
    "Model": "SM-G800M"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S5 mini",
    "Device": "kminilte",
    "Model": "SM-G800Y"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S5 mini",
    "Device": "kminilteatt",
    "Model": "SAMSUNG-SM-G800A"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S5 mini",
    "Device": "kminiwifi",
    "Model": "SM-G800X"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S6",
    "Device": "SC-05G",
    "Model": "SC-05G"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S6",
    "Device": "zeroflte",
    "Model": "SM-G920F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S6",
    "Device": "zeroflte",
    "Model": "SM-G920I"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S6",
    "Device": "zeroflte",
    "Model": "SM-G920X"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S6",
    "Device": "zeroflteacg",
    "Model": "SM-G920R7"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S6",
    "Device": "zeroflteaio",
    "Model": "SAMSUNG-SM-G920AZ"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S6",
    "Device": "zeroflteatt",
    "Model": "SAMSUNG-SM-G920A"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S6",
    "Device": "zerofltebmc",
    "Model": "SM-G920W8"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S6",
    "Device": "zerofltechn",
    "Model": "SM-G9200"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S6",
    "Device": "zerofltechn",
    "Model": "SM-G9208"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S6",
    "Device": "zerofltectc",
    "Model": "SM-G9209"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S6",
    "Device": "zerofltektt",
    "Model": "SM-G920K"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S6",
    "Device": "zerofltelgt",
    "Model": "SM-G920L"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S6",
    "Device": "zerofltelra",
    "Model": "SM-G920R6"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S6",
    "Device": "zerofltemtr",
    "Model": "SM-G920T1"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S6",
    "Device": "zeroflteskt",
    "Model": "SM-G920S"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S6",
    "Device": "zerofltespr",
    "Model": "SM-G920P"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S6",
    "Device": "zerofltetfnvzw",
    "Model": "SM-S906L"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S6",
    "Device": "zerofltetfnvzw",
    "Model": "SM-S907VL"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S6",
    "Device": "zerofltetmo",
    "Model": "SM-G920T"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S6",
    "Device": "zeroflteusc",
    "Model": "SM-G920R4"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S6",
    "Device": "zerofltevzw",
    "Model": "SM-G920V"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S6 Active",
    "Device": "marinelteatt",
    "Model": "SAMSUNG-SM-G890A"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S6 Edge",
    "Device": "404SC",
    "Model": "404SC"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S6 Edge",
    "Device": "SC-04G",
    "Model": "SC-04G"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S6 Edge",
    "Device": "SCV31",
    "Model": "SCV31"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S6 Edge",
    "Device": "zerolte",
    "Model": "SM-G925I"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S6 Edge",
    "Device": "zerolte",
    "Model": "SM-G925X"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S6 Edge",
    "Device": "zerolteacg",
    "Model": "SM-G925R7"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S6 Edge",
    "Device": "zerolteatt",
    "Model": "SAMSUNG-SM-G925A"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S6 Edge",
    "Device": "zeroltebmc",
    "Model": "SM-G925W8"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S6 Edge",
    "Device": "zeroltechn",
    "Model": "SM-G9250"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S6 Edge",
    "Device": "zeroltektt",
    "Model": "SM-G925K"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S6 Edge",
    "Device": "zeroltelra",
    "Model": "SM-G925R6"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S6 Edge",
    "Device": "zerolteskt",
    "Model": "SM-G925S"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S6 Edge",
    "Device": "zeroltespr",
    "Model": "SM-G925P"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S6 Edge",
    "Device": "zeroltetmo",
    "Model": "SM-G925T"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S6 Edge",
    "Device": "zerolteusc",
    "Model": "SM-G925R4"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S6 Edge",
    "Device": "zeroltevzw",
    "Model": "SM-G925V"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S6 Edge+",
    "Device": "zenlte",
    "Model": "SM-G9287C"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S6 Edge+",
    "Device": "zenlte",
    "Model": "SM-G928C"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S6 Edge+",
    "Device": "zenlte",
    "Model": "SM-G928G"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S6 Edge+",
    "Device": "zenlte",
    "Model": "SM-G928I"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S6 Edge+",
    "Device": "zenlte",
    "Model": "SM-G928X"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S6 Edge+",
    "Device": "zenlteatt",
    "Model": "SAMSUNG-SM-G928A"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S6 Edge+",
    "Device": "zenltebmc",
    "Model": "SM-G928W8"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S6 Edge+",
    "Device": "zenltechn",
    "Model": "SM-G9280"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S6 Edge+",
    "Device": "zenltektt",
    "Model": "SM-G928K"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S6 Edge+",
    "Device": "zenltekx",
    "Model": "SM-G928N0"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S6 Edge+",
    "Device": "zenltelgt",
    "Model": "SM-G928L"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S6 Edge+",
    "Device": "zenlteskt",
    "Model": "SM-G928S"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S6 Edge+",
    "Device": "zenltespr",
    "Model": "SM-G928P"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S6 Edge+",
    "Device": "zenltetmo",
    "Model": "SM-G928T"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S6 Edge+",
    "Device": "zenlteusc",
    "Model": "SM-G928R4"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S6 Edge+",
    "Device": "zenltevzw",
    "Model": "SM-G928V"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S6 edge",
    "Device": "zerolte",
    "Model": "SM-G925F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S6 edge",
    "Device": "zeroltelgt",
    "Model": "SM-G925L"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S6 edge+",
    "Device": "zenlte",
    "Model": "SM-G9287"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S6 edge+",
    "Device": "zenlte",
    "Model": "SM-G928F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S6 edge+",
    "Device": "zenlte",
    "Model": "SM-G928G"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S7",
    "Device": "herolte",
    "Model": "SM-G930F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S7",
    "Device": "herolte",
    "Model": "SM-G930X"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S7",
    "Device": "heroltebmc",
    "Model": "SM-G930W8"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S7",
    "Device": "heroltektt",
    "Model": "SM-G930K"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S7",
    "Device": "heroltelgt",
    "Model": "SM-G930L"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S7",
    "Device": "herolteskt",
    "Model": "SM-G930S"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S7",
    "Device": "heroqlteacg",
    "Model": "SM-G930R7"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S7",
    "Device": "heroqlteaio",
    "Model": "SAMSUNG-SM-G930AZ"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S7",
    "Device": "heroqlteatt",
    "Model": "SAMSUNG-SM-G930A"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S7",
    "Device": "heroqltecctvzw",
    "Model": "SM-G930VC"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S7",
    "Device": "heroqltechn",
    "Model": "SM-G9300"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S7",
    "Device": "heroqltechn",
    "Model": "SM-G9308"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S7",
    "Device": "heroqltelra",
    "Model": "SM-G930R6"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S7",
    "Device": "heroqltemtr",
    "Model": "SM-G930T1"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S7",
    "Device": "heroqltespr",
    "Model": "SM-G930P"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S7",
    "Device": "heroqltetfnvzw",
    "Model": "SM-G930VL"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S7",
    "Device": "heroqltetmo",
    "Model": "SM-G930T"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S7",
    "Device": "heroqlteue",
    "Model": "SM-G930U"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S7",
    "Device": "heroqlteusc",
    "Model": "SM-G930R4"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S7",
    "Device": "heroqltevzw",
    "Model": "SM-G930V"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S7 Active",
    "Device": "poseidonlteatt",
    "Model": "SAMSUNG-SM-G891A"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S7 Edge",
    "Device": "SC-02H",
    "Model": "SC-02H"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S7 Edge",
    "Device": "SCV33",
    "Model": "SCV33"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S7 Edge",
    "Device": "hero2lte",
    "Model": "SM-G935X"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S7 Edge",
    "Device": "hero2ltebmc",
    "Model": "SM-G935W8"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S7 Edge",
    "Device": "hero2ltektt",
    "Model": "SM-G935K"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S7 Edge",
    "Device": "hero2lteskt",
    "Model": "SM-G935S"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S7 Edge",
    "Device": "hero2qlteatt",
    "Model": "SAMSUNG-SM-G935A"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S7 Edge",
    "Device": "hero2qltecctvzw",
    "Model": "SM-G935VC"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S7 Edge",
    "Device": "hero2qltespr",
    "Model": "SM-G935P"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S7 Edge",
    "Device": "hero2qltetmo",
    "Model": "SM-G935T"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S7 Edge",
    "Device": "hero2qlteusc",
    "Model": "SM-G935R4"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S7 Edge",
    "Device": "hero2qltevzw",
    "Model": "SM-G935V"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S7 edge",
    "Device": "hero2lte",
    "Model": "SM-G935F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S7 edge",
    "Device": "hero2ltelgt",
    "Model": "SM-G935L"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S7 edge",
    "Device": "hero2qltechn",
    "Model": "SM-G9350"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S7 edge",
    "Device": "hero2qlteue",
    "Model": "SM-G935U"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S8",
    "Device": "SC-02J",
    "Model": "SC-02J"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S8",
    "Device": "SCV36",
    "Model": "SCV36"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S8",
    "Device": "dreamlte",
    "Model": "SM-G950F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S8",
    "Device": "dreamlteks",
    "Model": "SM-G950N"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S8",
    "Device": "dreamqltecan",
    "Model": "SM-G950W"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S8",
    "Device": "dreamqltechn",
    "Model": "SM-G9500"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S8",
    "Device": "dreamqltecmcc",
    "Model": "SM-G9508"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S8",
    "Device": "dreamqltesq",
    "Model": "SM-G950U"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S8",
    "Device": "dreamqlteue",
    "Model": "SM-G950U1"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S8 Active",
    "Device": "cruiserlteatt",
    "Model": "SM-G892A"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S8 Active",
    "Device": "cruiserltesq",
    "Model": "SM-G892U"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S8+",
    "Device": "SC-03J",
    "Model": "SC-03J"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S8+",
    "Device": "SCV35",
    "Model": "SCV35"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S8+",
    "Device": "dream2lte",
    "Model": "SM-G955F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S8+",
    "Device": "dream2lteks",
    "Model": "SM-G955N"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S8+",
    "Device": "dream2qltecan",
    "Model": "SM-G955W"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S8+",
    "Device": "dream2qltechn",
    "Model": "SM-G9550"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S8+",
    "Device": "dream2qltesq",
    "Model": "SM-G955U"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S8+",
    "Device": "dream2qlteue",
    "Model": "SM-G955U1"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S9",
    "Device": "SC-02K",
    "Model": "SC-02K"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S9",
    "Device": "SCV38",
    "Model": "SCV38"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S9",
    "Device": "starlte",
    "Model": "SM-G960F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S9",
    "Device": "starlteks",
    "Model": "SM-G960N"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S9",
    "Device": "starqltechn",
    "Model": "SM-G9600"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S9",
    "Device": "starqltecmcc",
    "Model": "SM-G9608"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S9",
    "Device": "starqltecs",
    "Model": "SM-G960W"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S9",
    "Device": "starqltesq",
    "Model": "SM-G960U"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S9",
    "Device": "starqlteue",
    "Model": "SM-G960U1"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S9+",
    "Device": "SC-03K",
    "Model": "SC-03K"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S9+",
    "Device": "SCV39",
    "Model": "SCV39"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S9+",
    "Device": "star2lte",
    "Model": "SM-G965F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S9+",
    "Device": "star2lteks",
    "Model": "SM-G965N"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S9+",
    "Device": "star2qltechn",
    "Model": "SM-G9650"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S9+",
    "Device": "star2qltecs",
    "Model": "SM-G965W"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S9+",
    "Device": "star2qltesq",
    "Model": "SM-G965U"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy S9+",
    "Device": "star2qlteue",
    "Model": "SM-G965U1"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Spica",
    "Device": "GT-I5700",
    "Model": "GT-I5700"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Spica",
    "Device": "GT-I5700",
    "Model": "GT-I5700L"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Spica",
    "Device": "GT-I5700",
    "Model": "GT-I5700R"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Spica",
    "Device": "GT-I5700L",
    "Model": "GT-I5700L"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Spica",
    "Device": "spica",
    "Model": "GT-I5700"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Spica",
    "Device": "spica",
    "Model": "GT-I5700L"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Spica",
    "Device": "spica",
    "Model": "GT-I5700R"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Spica",
    "Device": "spica",
    "Model": "GT-i5700"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Star",
    "Device": "mint",
    "Model": "GT-S5282"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Star",
    "Device": "mintss",
    "Model": "GT-S5280"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Star Plus",
    "Device": "logan2g",
    "Model": "GT-S7262"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Star Trios",
    "Device": "mintts",
    "Model": "GT-S5283B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Star2 Plus",
    "Device": "higgs2g",
    "Model": "SM-G350E"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Stellar",
    "Device": "jaspervzw",
    "Model": "SCH-I200"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Stellar",
    "Device": "jaspervzw",
    "Model": "SCH-I200PP"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Stratosphere2",
    "Device": "aegis2vzw",
    "Model": "SCH-I415"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Style Duos",
    "Device": "aruba3gduosctc",
    "Model": "SCH-I829"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy TAB Active2",
    "Device": "gtactive2lteue",
    "Model": "SM-T397U"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy TAB3 Lite",
    "Device": "goyairis3g",
    "Model": "SM-T116IR"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab",
    "Device": "GT-P1000",
    "Model": "GT-P1000"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab",
    "Device": "GT-P1000L",
    "Model": "GT-P1000L"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab",
    "Device": "GT-P1000M",
    "Model": "GT-P1000M"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab",
    "Device": "GT-P1000N",
    "Model": "GT-P1000N"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab",
    "Device": "GT-P1000R",
    "Model": "GT-P1000R"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab",
    "Device": "GT-P1000T",
    "Model": "GT-P1000T"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab",
    "Device": "GT-P1010",
    "Model": "GT-P1010"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab",
    "Device": "GT-P1013",
    "Model": "GT-P1013"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab",
    "Device": "SC-01C",
    "Model": "SC-01C"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab",
    "Device": "SCH-I800",
    "Model": "SCH-I800"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab",
    "Device": "SGH-T849",
    "Model": "SGH-T849"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab",
    "Device": "SHW-M180K",
    "Model": "SHW-M180K"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab",
    "Device": "SHW-M180L",
    "Model": "SHW-M180L"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab",
    "Device": "SHW-M180S",
    "Model": "SHW-M180S"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab",
    "Device": "SHW-M180W",
    "Model": "SHW-M180W"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab",
    "Device": "SMT-i9100",
    "Model": "SMT-i9100"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab 10.1",
    "Device": "GT-P7500",
    "Model": "GT-P7500"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab 10.1",
    "Device": "GT-P7500D",
    "Model": "GT-P7500D"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab 10.1",
    "Device": "GT-P7503",
    "Model": "GT-P7503"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab 10.1",
    "Device": "GT-P7510",
    "Model": "GT-P7510"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab 10.1",
    "Device": "SC-01D",
    "Model": "SC-01D"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab 10.1",
    "Device": "SCH-I905",
    "Model": "SCH-I905"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab 10.1",
    "Device": "SGH-T859",
    "Model": "SGH-T859"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab 10.1",
    "Device": "SHW-M300W",
    "Model": "SHW-M300W"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab 10.1",
    "Device": "SHW-M380K",
    "Model": "SHW-M380K"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab 10.1",
    "Device": "SHW-M380S",
    "Model": "SHW-M380S"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab 10.1",
    "Device": "SHW-M380W",
    "Model": "SHW-M380W"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab 10.1 N",
    "Device": "GT-P7501",
    "Model": "GT-P7501"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab 10.1 N",
    "Device": "GT-P7511",
    "Model": "GT-P7511"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab 10.1 v",
    "Device": "p3",
    "Model": "GT-P7100"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab 3 Lite",
    "Device": "goyairis3g",
    "Model": "SM-T116IR"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab 3V 7.0",
    "Device": "goyave3g5M",
    "Model": "SM-T116NY"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab 4 8.0",
    "Device": "milletwifi",
    "Model": "SM-T330X"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab 4 8.0",
    "Device": "milletwifikx",
    "Model": "SM-T330"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab 7.0",
    "Device": "SPH-P100",
    "Model": "SPH-P100"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab 7.0 Plus",
    "Device": "GT-P6200",
    "Model": "GT-P6200"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab 7.0 Plus",
    "Device": "GT-P6200L",
    "Model": "GT-P6200L"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab 7.0 Plus",
    "Device": "GT-P6201",
    "Model": "GT-P6201"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab 7.0 Plus",
    "Device": "GT-P6210",
    "Model": "GT-P6210"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab 7.0 Plus",
    "Device": "GT-P6211",
    "Model": "GT-P6211"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab 7.0 Plus",
    "Device": "SC-02D",
    "Model": "SC-02D"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab 7.0 Plus",
    "Device": "SGH-T869",
    "Model": "SGH-T869"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab 7.0 Plus",
    "Device": "SHW-M430W",
    "Model": "SHW-M430W"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab 7.7",
    "Device": "GT-P6800",
    "Model": "GT-P6800"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab 7.7",
    "Device": "GT-P6810",
    "Model": "GT-P6810"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab 7.7",
    "Device": "SCH-I815",
    "Model": "SCH-I815"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab 7.7 Plus",
    "Device": "SC-01E",
    "Model": "SC-01E"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab 8.9",
    "Device": "GT-P7300",
    "Model": "GT-P7300"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab 8.9",
    "Device": "GT-P7310",
    "Model": "GT-P7310"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab 8.9",
    "Device": "GT-P7320",
    "Model": "GT-P7320"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab 8.9",
    "Device": "SCH-P739",
    "Model": "SCH-P739"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab 8.9",
    "Device": "SGH-I957",
    "Model": "SAMSUNG-SGH-I957"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab 8.9",
    "Device": "SGH-I957D",
    "Model": "SAMSUNG-SGH-I957D"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab 8.9",
    "Device": "SGH-I957D",
    "Model": "SGH-I957D"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab 8.9",
    "Device": "SGH-I957M",
    "Model": "SAMSUNG-SGH-I957M"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab 8.9",
    "Device": "SGH-I957M",
    "Model": "SGH-I957M"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab 8.9",
    "Device": "SGH-I957R",
    "Model": "SAMSUNG-SGH-I957R"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab 8.9",
    "Device": "SGH-I957R",
    "Model": "SGH-I957R"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab 8.9",
    "Device": "SHV-E140K",
    "Model": "SHV-E140K"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab 8.9",
    "Device": "SHV-E140L",
    "Model": "SHV-E140L"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab 8.9",
    "Device": "SHV-E140S",
    "Model": "SHV-E140S"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab 8.9",
    "Device": "SHW-M305W",
    "Model": "SHW-M305W"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab A",
    "Device": "gt510lte",
    "Model": "SM-T555"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab A",
    "Device": "gt510wifi",
    "Model": "SM-T550"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab A",
    "Device": "gt58ltechn",
    "Model": "SM-T355C"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab A",
    "Device": "gt5note10lte",
    "Model": "SM-P555M"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab A",
    "Device": "gt5note10wifi",
    "Model": "SM-P550"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab A",
    "Device": "gt5note8lte",
    "Model": "SM-P355M"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab A",
    "Device": "gt5note8ltechn",
    "Model": "SM-P355C"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab A",
    "Device": "gta3xl",
    "Model": "SM-T515"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab A",
    "Device": "gta3xl",
    "Model": "SM-T515N"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab A",
    "Device": "gta3xl",
    "Model": "SM-T517"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab A",
    "Device": "gta3xl",
    "Model": "SM-T517P"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab A",
    "Device": "gta3xlwifi",
    "Model": "SM-T510"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab A",
    "Device": "gtaslitelteusc",
    "Model": "SM-T387R4"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab A",
    "Device": "gtaxlqltespr",
    "Model": "SM-T587P"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab A (10.5\")",
    "Device": "gta2xlltespr",
    "Model": "SM-T597P"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab A (10.5\")",
    "Device": "gta2xlltevzw",
    "Model": "SM-T597V"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab A (10.5)",
    "Device": "gta2xlltecs",
    "Model": "SM-T597W"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab A (2016)",
    "Device": "gtaxllte",
    "Model": "SM-T585"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab A (2016)",
    "Device": "gtaxlltechn",
    "Model": "SM-T585C"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab A (2016)",
    "Device": "gtaxlltekx",
    "Model": "SM-T585N0"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab A (2016)",
    "Device": "gtaxlwifi",
    "Model": "SM-T580"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab A (2016)",
    "Device": "gtaxlwifichn",
    "Model": "SM-T580"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab A (2016) with S Pen",
    "Device": "gtanotexllte",
    "Model": "SM-P585"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab A (2016) with S Pen",
    "Device": "gtanotexllte",
    "Model": "SM-P585M"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab A (2016) with S Pen",
    "Device": "gtanotexllte",
    "Model": "SM-P585Y"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab A (2016) with S Pen",
    "Device": "gtanotexllte",
    "Model": "SM-P587"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab A (2016) with S Pen",
    "Device": "gtanotexlltechn",
    "Model": "SM-P588C"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab A (2016) with S Pen",
    "Device": "gtanotexlltekx",
    "Model": "SM-P585N0"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab A (2016) with S Pen",
    "Device": "gtanotexlwifichn",
    "Model": "SM-P583"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab A (2016) with S Pen",
    "Device": "gtanotexlwifikx",
    "Model": "SM-P580"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab A (2017)",
    "Device": "gta2slte",
    "Model": "SM-T385"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab A (2017)",
    "Device": "gta2slte",
    "Model": "SM-T385M"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab A (2017)",
    "Device": "gta2sltechn",
    "Model": "SM-T385C"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab A (2017)",
    "Device": "gta2sltektt",
    "Model": "SM-T385K"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab A (2017)",
    "Device": "gta2sltelgt",
    "Model": "SM-T385L"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab A (2017)",
    "Device": "gta2slteskt",
    "Model": "SM-T385S"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab A (2017)",
    "Device": "gta2swifi",
    "Model": "SM-T380"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab A (2017)",
    "Device": "gta2swifichn",
    "Model": "SM-T380C"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab A (2018, 10.5)",
    "Device": "gta2xllte",
    "Model": "SM-T595"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab A (2018, 10.5)",
    "Device": "gta2xllte",
    "Model": "SM-T597"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab A (2018, 10.5)",
    "Device": "gta2xlltechn",
    "Model": "SM-T595C"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab A (2018, 10.5)",
    "Device": "gta2xlltekx",
    "Model": "SM-T595N"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab A (2018, 10.5)",
    "Device": "gta2xlwifi",
    "Model": "SM-T590"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab A (2018, 10.5)",
    "Device": "gta2xlwifichn",
    "Model": "SM-T590"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab A (8.0\", 2019)",
    "Device": "gto",
    "Model": "SM-T295"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab A (8.0\", 2019)",
    "Device": "gto",
    "Model": "SM-T295C"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab A (8.0\", 2019)",
    "Device": "gto",
    "Model": "SM-T295N"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab A (8.0\", 2019)",
    "Device": "gto",
    "Model": "SM-T297"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab A (8.0\", 2019)",
    "Device": "gtowifi",
    "Model": "SM-T290"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab A (8.0\",2019)",
    "Device": "gto",
    "Model": "SM-T295"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab A (8.4\", 2020)",
    "Device": "gta4s",
    "Model": "SM-T307U"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab A 10.1",
    "Device": "gtaxllte",
    "Model": "SM-T585M"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab A 10.1",
    "Device": "gtaxllte",
    "Model": "SM-T587"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab A 10.1",
    "Device": "gtaxlwifi",
    "Model": "SM-T580X"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab A 10.1",
    "Device": "gtaxlwifichn",
    "Model": "SM-T580X"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab A 7.0",
    "Device": "gtexslte",
    "Model": "SM-T285"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab A 7.0",
    "Device": "gtexslte",
    "Model": "SM-T285M"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab A 7.0",
    "Device": "gtexslte",
    "Model": "SM-T287"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab A 7.0",
    "Device": "gtexslteswa",
    "Model": "SM-T285YD"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab A 7.0",
    "Device": "gtexswifi",
    "Model": "SM-T280"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab A 8",
    "Device": "gtaslitelteatt",
    "Model": "SM-T387AA"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab A 8",
    "Device": "gtasliteltespr",
    "Model": "SM-T387P"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab A 8",
    "Device": "gtasliteltetmo",
    "Model": "SM-T387T"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab A 8.0",
    "Device": "gt58lte",
    "Model": "SM-T355"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab A 8.0",
    "Device": "gt58lte",
    "Model": "SM-T355Y"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab A 8.0",
    "Device": "gt58ltetmo",
    "Model": "SM-T357T"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab A 8.0",
    "Device": "gt58wifi",
    "Model": "SM-T350"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab A 8.0",
    "Device": "gt58wifi",
    "Model": "SM-T350X"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab A 8.0",
    "Device": "gt58wifichn",
    "Model": "SM-T350"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab A 8.0",
    "Device": "gt58wifichn",
    "Model": "SM-T350X"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab A 8.0",
    "Device": "gt5note8lte",
    "Model": "SM-P355"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab A 8.0",
    "Device": "gt5note8ltechn",
    "Model": "SM-P355Y"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab A 8.0",
    "Device": "gt5note8wifi",
    "Model": "SM-P350"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab A 8.0",
    "Device": "gt5note8wifichn",
    "Model": "SM-P350"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab A 8.0",
    "Device": "gtasliteltecs",
    "Model": "SM-T387W"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab A 8.0",
    "Device": "gtasliteltevzw",
    "Model": "SM-T387V"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab A 9.7",
    "Device": "gt510ltechn",
    "Model": "SM-T555C"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab A 9.7",
    "Device": "gt510wifi",
    "Model": "SM-T550X"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab A 9.7",
    "Device": "gt510wifichn",
    "Model": "SM-T550"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab A 9.7",
    "Device": "gt510wifichn",
    "Model": "SM-T550X"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab A 9.7",
    "Device": "gt5note10lte",
    "Model": "SM-P555"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab A 9.7",
    "Device": "gt5note10ltechn",
    "Model": "SM-P555C"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab A 9.7",
    "Device": "gt5note10ltehktw",
    "Model": "SM-P555Y"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab A 9.7",
    "Device": "gt5note10ltektt",
    "Model": "SM-P555K"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab A 9.7",
    "Device": "gt5note10ltelgt",
    "Model": "SM-P555L"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab A 9.7",
    "Device": "gt5note10lteskt",
    "Model": "SM-P555S"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab A 9.7",
    "Device": "gt5note10wifi",
    "Model": "SM-P550"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab A 9.7",
    "Device": "gt5note10wifichn",
    "Model": "SM-P550"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab A Kids Edition",
    "Device": "gtowifi",
    "Model": "SM-T290"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab A S 8.0",
    "Device": "gt58ltebmc",
    "Model": "SM-T357W"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab A with S Pen",
    "Device": "wisdom",
    "Model": "SM-P205"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab A with S Pen",
    "Device": "wisdomwifi",
    "Model": "SM-P200"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab A11",
    "Device": "gta11",
    "Model": "SM-X135F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab A11",
    "Device": "gta11",
    "Model": "SM-X135G"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab A11",
    "Device": "gta11",
    "Model": "SM-X135N"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab A11",
    "Device": "gta11wifi",
    "Model": "SM-X130"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab A11",
    "Device": "gta11wifi",
    "Model": "SM-X133"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab A11+",
    "Device": "gta11pwifi",
    "Model": "SM-X230"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab A11+ 5G",
    "Device": "gta11p",
    "Model": "SM-X236B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab A11+ 5G",
    "Device": "gta11p",
    "Model": "SM-X236C"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab A11+ 5G",
    "Device": "gta11p",
    "Model": "SM-X236N"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab A11+ 5G",
    "Device": "gta11p",
    "Model": "SM-X238Q"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab A11+ 5G",
    "Device": "gta11p",
    "Model": "SM-X238U"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab A11+ 5G",
    "Device": "gta11p",
    "Model": "SM-X238U1"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab A6",
    "Device": "gtexswifi",
    "Model": "SM-T280"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab A7",
    "Device": "gta4l",
    "Model": "SM-T505"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab A7",
    "Device": "gta4l",
    "Model": "SM-T505C"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab A7",
    "Device": "gta4l",
    "Model": "SM-T505N"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab A7",
    "Device": "gta4l",
    "Model": "SM-T507"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab A7",
    "Device": "gta4lve",
    "Model": "SM-T509"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab A7",
    "Device": "gta4lvewifi",
    "Model": "SM-T503"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab A7",
    "Device": "gta4lwifi",
    "Model": "SM-T500"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab A7 Lite",
    "Device": "gta7lite",
    "Model": "SM-T225"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab A7 Lite",
    "Device": "gta7lite",
    "Model": "SM-T225C"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab A7 Lite",
    "Device": "gta7lite",
    "Model": "SM-T225N"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab A7 Lite",
    "Device": "gta7lite",
    "Model": "SM-T227"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab A7 Lite",
    "Device": "gta7lite",
    "Model": "SM-T227U"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab A7 Lite",
    "Device": "gta7litewifi",
    "Model": "SM-T220"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab A8",
    "Device": "gta8",
    "Model": "SM-X205"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab A8",
    "Device": "gta8",
    "Model": "SM-X205C"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab A8",
    "Device": "gta8",
    "Model": "SM-X205N"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab A8",
    "Device": "gta8",
    "Model": "SM-X207"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab A8",
    "Device": "gta8wifi",
    "Model": "SM-X200"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab A9",
    "Device": "gta9",
    "Model": "SM-X115"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab A9",
    "Device": "gta9",
    "Model": "SM-X115N"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab A9",
    "Device": "gta9",
    "Model": "SM-X117"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab A9",
    "Device": "gta9",
    "Model": "SM-X117U"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab A9",
    "Device": "gta9wifi",
    "Model": "SM-X110"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab A9+",
    "Device": "gta9pwifi",
    "Model": "SM-X210"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab A9+",
    "Device": "gta9pwifi",
    "Model": "SM-X210R"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab A9+ 5G",
    "Device": "gta9p",
    "Model": "SM-X216B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab A9+ 5G",
    "Device": "gta9p",
    "Model": "SM-X216C"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab A9+ 5G",
    "Device": "gta9p",
    "Model": "SM-X216N"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab A9+ 5G",
    "Device": "gta9p",
    "Model": "SM-X216R"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab A9+ 5G",
    "Device": "gta9p",
    "Model": "SM-X218B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab A9+ 5G",
    "Device": "gta9p",
    "Model": "SM-X218U"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab Active",
    "Device": "rubenslte",
    "Model": "SM-T365"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab Active",
    "Device": "rubenslte",
    "Model": "SM-T365Y"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab Active Pro",
    "Device": "gtactivexl",
    "Model": "SM-T545"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab Active Pro",
    "Device": "gtactivexl",
    "Model": "SM-T547"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab Active Pro",
    "Device": "gtactivexl",
    "Model": "SM-T547U"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab Active Pro",
    "Device": "gtactivexlwifi",
    "Model": "SM-T540"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab Active2",
    "Device": "gtactive2lte",
    "Model": "SM-T395"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab Active2",
    "Device": "gtactive2ltechn",
    "Model": "SM-T395C"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab Active2",
    "Device": "gtactive2ltekx",
    "Model": "SM-T395N"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab Active2",
    "Device": "gtactive2lteue",
    "Model": "SM-T397U"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab Active2",
    "Device": "gtactive2wifi",
    "Model": "SM-T390"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab Active3",
    "Device": "gtactive3",
    "Model": "SM-T575"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab Active3",
    "Device": "gtactive3",
    "Model": "SM-T575N"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab Active3",
    "Device": "gtactive3",
    "Model": "SM-T577"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab Active3",
    "Device": "gtactive3",
    "Model": "SM-T577U"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab Active4 Pro 5G",
    "Device": "gtact4pro",
    "Model": "SM-T636B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab Active4 Pro 5G",
    "Device": "gtact4pro",
    "Model": "SM-T636N"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab Active4 Pro 5G",
    "Device": "gtact4pro",
    "Model": "SM-T638B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab Active4 Pro 5G",
    "Device": "gtact4pro",
    "Model": "SM-T638U"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab Active5",
    "Device": "gtactive5wifi",
    "Model": "SM-X300"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab Active5 5G",
    "Device": "gtactive5",
    "Model": "SM-X306B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab Active5 5G",
    "Device": "gtactive5",
    "Model": "SM-X306N"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab Active5 5G",
    "Device": "gtactive5",
    "Model": "SM-X308B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab Active5 5G",
    "Device": "gtactive5",
    "Model": "SM-X308U"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab Active5 Pro",
    "Device": "gtact5prowifi",
    "Model": "SM-X350"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab Active5 Pro 5G",
    "Device": "gtact5pro",
    "Model": "SM-X356B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab Active5 Pro 5G",
    "Device": "gtact5pro",
    "Model": "SM-X356N"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab Active5 Pro 5G",
    "Device": "gtact5pro",
    "Model": "SM-X358U"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab Advanced2",
    "Device": "gtaxladwifikx",
    "Model": "SM-T583"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab E",
    "Device": "gtel3g",
    "Model": "SM-T561M"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab E",
    "Device": "gtelwifi",
    "Model": "SM-T560"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab E 8.0",
    "Device": "gteslteatt",
    "Model": "SAMSUNG-SM-T377A"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab E 8.0",
    "Device": "gtesltebmc",
    "Model": "SM-T377W"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab E 8.0",
    "Device": "gtesltelgt",
    "Model": "SM-T375L"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab E 8.0",
    "Device": "gteslteskt",
    "Model": "SM-T375S"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab E 8.0",
    "Device": "gtesltetmo",
    "Model": "SM-T377T"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab E 8.0",
    "Device": "gtesltetw",
    "Model": "SM-T3777"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab E 8.0",
    "Device": "gtesltevzw",
    "Model": "SM-T377V"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab E 8.0",
    "Device": "gtesqltespr",
    "Model": "SM-T377P"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab E 8.0",
    "Device": "gtesqlteusc",
    "Model": "SM-T377R4"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab E 9.6",
    "Device": "gtel3g",
    "Model": "SM-T561"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab E 9.6",
    "Device": "gtel3g",
    "Model": "SM-T561Y"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab E 9.6",
    "Device": "gtel3g",
    "Model": "SM-T562"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab E 9.6",
    "Device": "gtelltevzw",
    "Model": "SM-T567V"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab E 9.6",
    "Device": "gtelwifi",
    "Model": "SM-T560"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab E 9.6",
    "Device": "gtelwifichn",
    "Model": "SM-T560"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab E 9.6",
    "Device": "gtelwifiue",
    "Model": "SM-T560NU"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab E8.0",
    "Device": "gtesveltevzw",
    "Model": "SM-T378V"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab Plus 7.0",
    "Device": "goyave3gsea",
    "Model": "SM-T116BU"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab Pro 10.1",
    "Device": "picassolte",
    "Model": "SM-T525"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab Pro 10.1",
    "Device": "picassowifi",
    "Model": "SM-T520"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab Pro 10.1 Chef Collection",
    "Device": "picassowificc",
    "Model": "SM-T520CC"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab Pro 12.2",
    "Device": "v2lte",
    "Model": "SM-T905"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab Pro 12.2",
    "Device": "v2wifi",
    "Model": "SM-T900"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab Pro 12.2",
    "Device": "v2wifi",
    "Model": "SM-T900X"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab Pro 8.4",
    "Device": "mondrianlte",
    "Model": "SM-T325"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab Pro 8.4",
    "Device": "mondrianwifi",
    "Model": "SM-T320"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab Pro 8.4",
    "Device": "mondrianwifi",
    "Model": "SM-T320X"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab Pro 8.4",
    "Device": "mondrianwifikx",
    "Model": "SM-T320"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab Pro 8.4",
    "Device": "mondrianwifiue",
    "Model": "SM-T320"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab Pro 8.4",
    "Device": "mondrianwifiue",
    "Model": "SM-T320NU"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab Q",
    "Device": "q7",
    "Model": "SM-T2519"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S 10.5",
    "Device": "chagallwifi",
    "Model": "SM-T800"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S 8.4",
    "Device": "SC-03G",
    "Model": "SC-03G"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S 8.4",
    "Device": "klimtlte",
    "Model": "SM-T705"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S 8.4",
    "Device": "klimtlte",
    "Model": "SM-T705C"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S 8.4",
    "Device": "klimtlte",
    "Model": "SM-T705Y"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S 8.4",
    "Device": "klimtltevzw",
    "Model": "SM-T707V"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S 8.4",
    "Device": "klimtwifi",
    "Model": "SM-T700"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S10 FE",
    "Device": "gts10fewifi",
    "Model": "SM-X520"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S10 FE 5G",
    "Device": "gts10fe",
    "Model": "SM-X526B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S10 FE 5G",
    "Device": "gts10fe",
    "Model": "SM-X526C"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S10 FE 5G",
    "Device": "gts10fe",
    "Model": "SM-X526E"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S10 FE 5G",
    "Device": "gts10fe",
    "Model": "SM-X526N"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S10 FE 5G",
    "Device": "gts10fe",
    "Model": "SM-X528U"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S10 FE+",
    "Device": "gts10fepwifi",
    "Model": "SM-X620"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S10 FE+ 5G",
    "Device": "gts10fep",
    "Model": "SM-X626B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S10 FE+ 5G",
    "Device": "gts10fep",
    "Model": "SM-X626C"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S10 FE+ 5G",
    "Device": "gts10fep",
    "Model": "SM-X626N"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S10 Lite",
    "Device": "gts10litewifi",
    "Model": "SM-X400"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S10 Lite 5G",
    "Device": "gts10lite",
    "Model": "SM-X406B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S10 Lite 5G",
    "Device": "gts10lite",
    "Model": "SM-X406N"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S10 Ultra",
    "Device": "gts10uwifi",
    "Model": "SM-X920"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S10 Ultra 5G",
    "Device": "gts10u",
    "Model": "SM-X926B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S10 Ultra 5G",
    "Device": "gts10u",
    "Model": "SM-X926C"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S10 Ultra 5G",
    "Device": "gts10u",
    "Model": "SM-X926N"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S10+",
    "Device": "gts10pwifi",
    "Model": "SM-X820"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S10+ 5G",
    "Device": "gts10p",
    "Model": "SM-X826B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S10+ 5G",
    "Device": "gts10p",
    "Model": "SM-X826N"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S10+ 5G",
    "Device": "gts10p",
    "Model": "SM-X828U"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S11",
    "Device": "gts11wifi",
    "Model": "SM-X730"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S11 5G",
    "Device": "gts11",
    "Model": "SM-X736B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S11 5G",
    "Device": "gts11",
    "Model": "SM-X736C"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S11 5G",
    "Device": "gts11",
    "Model": "SM-X736N"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S11 Ultra",
    "Device": "gts11uwifi",
    "Model": "SM-X930"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S11 Ultra 5G",
    "Device": "gts11u",
    "Model": "SM-X936B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S11 Ultra 5G",
    "Device": "gts11u",
    "Model": "SM-X936C"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S11 Ultra 5G",
    "Device": "gts11u",
    "Model": "SM-X936N"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S2",
    "Device": "gts210lte",
    "Model": "SM-T815"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S2",
    "Device": "gts210lte",
    "Model": "SM-T815C"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S2",
    "Device": "gts210lte",
    "Model": "SM-T815Y"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S2",
    "Device": "gts210velte",
    "Model": "SM-T819"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S2",
    "Device": "gts210velte",
    "Model": "SM-T819Y"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S2",
    "Device": "gts210veltechn",
    "Model": "SM-T819C"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S2",
    "Device": "gts210vewifi",
    "Model": "SM-T813"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S2",
    "Device": "gts210vewifichn",
    "Model": "SM-T813"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S2",
    "Device": "gts210wifi",
    "Model": "SM-T810"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S2",
    "Device": "gts28lte",
    "Model": "SM-T715"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S2",
    "Device": "gts28velte",
    "Model": "SM-T719"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S2",
    "Device": "gts28velte",
    "Model": "SM-T719Y"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S2",
    "Device": "gts28veltechn",
    "Model": "SM-T719C"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S2",
    "Device": "gts28vewifi",
    "Model": "SM-T713"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S2",
    "Device": "gts28vewifichn",
    "Model": "SM-T713"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S2",
    "Device": "gts28wifi",
    "Model": "SM-T710"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S2 8.0",
    "Device": "gts28lte",
    "Model": "SM-T715Y"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S2 8.0",
    "Device": "gts28ltechn",
    "Model": "SM-T715C"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S2 8.0",
    "Device": "gts28ltekx",
    "Model": "SM-T715N0"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S2 8.0",
    "Device": "gts28vewifi",
    "Model": "SM-T713"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S2 8.0",
    "Device": "gts28wifi",
    "Model": "SM-T710"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S2 8.0",
    "Device": "gts28wifi",
    "Model": "SM-T710X"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S2 8.0",
    "Device": "gts28wifichn",
    "Model": "SM-T710"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S2 9.7",
    "Device": "gts210lte",
    "Model": "SM-T817"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S2 9.7",
    "Device": "gts210lteatt",
    "Model": "SAMSUNG-SM-T817A"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S2 9.7",
    "Device": "gts210ltecan",
    "Model": "SM-T817W"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S2 9.7",
    "Device": "gts210ltekx",
    "Model": "SM-T815N0"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S2 9.7",
    "Device": "gts210ltespr",
    "Model": "SM-T817P"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S2 9.7",
    "Device": "gts210ltetmo",
    "Model": "SM-T817T"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S2 9.7",
    "Device": "gts210lteusc",
    "Model": "SM-T817R4"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S2 9.7",
    "Device": "gts210ltevzw",
    "Model": "SM-T817V"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S2 9.7",
    "Device": "gts210velte",
    "Model": "SM-T818"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S2 9.7",
    "Device": "gts210velteatt",
    "Model": "SAMSUNG-SM-T818A"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S2 9.7",
    "Device": "gts210veltecan",
    "Model": "SM-T818W"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S2 9.7",
    "Device": "gts210veltetmo",
    "Model": "SM-T818T"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S2 9.7",
    "Device": "gts210vewifi",
    "Model": "SM-T813"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S2 9.7",
    "Device": "gts210wifi",
    "Model": "SM-T810"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S2 9.7",
    "Device": "gts210wifi",
    "Model": "SM-T810X"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S3",
    "Device": "gts3llte",
    "Model": "SM-T825"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S3",
    "Device": "gts3llte",
    "Model": "SM-T825C"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S3",
    "Device": "gts3llte",
    "Model": "SM-T825X"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S3",
    "Device": "gts3llte",
    "Model": "SM-T827"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S3",
    "Device": "gts3lltekx",
    "Model": "SM-T825N0"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S3",
    "Device": "gts3llteusc",
    "Model": "SM-T827R4"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S3",
    "Device": "gts3lltevzw",
    "Model": "SM-T827V"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S3",
    "Device": "gts3lwifi",
    "Model": "SM-T820"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S3",
    "Device": "gts3lwifi",
    "Model": "SM-T820X"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S3",
    "Device": "gts3lwifichn",
    "Model": "SM-T820"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S4",
    "Device": "gts4llte",
    "Model": "SM-T835"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S4",
    "Device": "gts4llte",
    "Model": "SM-T837"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S4",
    "Device": "gts4llteatt",
    "Model": "SM-T837A"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S4",
    "Device": "gts4lltechn",
    "Model": "SM-T835C"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S4",
    "Device": "gts4lltekx",
    "Model": "SM-T835N"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S4",
    "Device": "gts4lltespr",
    "Model": "SM-T837P"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S4",
    "Device": "gts4lltetmo",
    "Model": "SM-T837T"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S4",
    "Device": "gts4llteusc",
    "Model": "SM-T837R4"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S4",
    "Device": "gts4lltevzw",
    "Model": "SM-T837V"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S4",
    "Device": "gts4lwifi",
    "Model": "SM-T830"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S4",
    "Device": "gts4lwifichn",
    "Model": "SM-T830"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S5e",
    "Device": "gts4lv",
    "Model": "SM-T725"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S5e",
    "Device": "gts4lv",
    "Model": "SM-T725C"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S5e",
    "Device": "gts4lv",
    "Model": "SM-T725N"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S5e",
    "Device": "gts4lv",
    "Model": "SM-T727"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S5e",
    "Device": "gts4lv",
    "Model": "SM-T727A"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S5e",
    "Device": "gts4lv",
    "Model": "SM-T727R4"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S5e",
    "Device": "gts4lv",
    "Model": "SM-T727U"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S5e",
    "Device": "gts4lv",
    "Model": "SM-T727V"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S5e",
    "Device": "gts4lvwifi",
    "Model": "SM-T720"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S5e",
    "Device": "gts4lvwifichn",
    "Model": "SM-T720"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S6",
    "Device": "gts6l",
    "Model": "SM-T865"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S6",
    "Device": "gts6l",
    "Model": "SM-T865N"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S6",
    "Device": "gts6l",
    "Model": "SM-T867"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S6",
    "Device": "gts6l",
    "Model": "SM-T867R4"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S6",
    "Device": "gts6l",
    "Model": "SM-T867U"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S6",
    "Device": "gts6l",
    "Model": "SM-T867V"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S6",
    "Device": "gts6lwifi",
    "Model": "SM-T860"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S6 5G",
    "Device": "gts6x",
    "Model": "SM-T866N"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S6 Lite",
    "Device": "gta4xl",
    "Model": "SM-P615"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S6 Lite",
    "Device": "gta4xl",
    "Model": "SM-P615C"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S6 Lite",
    "Device": "gta4xl",
    "Model": "SM-P615N"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S6 Lite",
    "Device": "gta4xl",
    "Model": "SM-P617"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S6 Lite",
    "Device": "gta4xls",
    "Model": "SM-P625"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S6 Lite",
    "Device": "gta4xlswifi",
    "Model": "SM-P620"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S6 Lite",
    "Device": "gta4xlve",
    "Model": "SM-P619"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S6 Lite",
    "Device": "gta4xlve",
    "Model": "SM-P619N"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S6 Lite",
    "Device": "gta4xlvewifi",
    "Model": "SM-P613"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S6 Lite",
    "Device": "gta4xlwifi",
    "Model": "SM-P610"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S6 Lite",
    "Device": "gta4xlwifi",
    "Model": "SM-P610X"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S7",
    "Device": "gts7l",
    "Model": "SM-T875"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S7",
    "Device": "gts7l",
    "Model": "SM-T875N"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S7",
    "Device": "gts7lwifi",
    "Model": "SM-T870"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S7 5G",
    "Device": "gts7l",
    "Model": "SM-T878U"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S7 FE",
    "Device": "gts7fewifi",
    "Model": "SM-T733"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S7 FE",
    "Device": "gts7xllite",
    "Model": "SM-T735"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S7 FE",
    "Device": "gts7xllite",
    "Model": "SM-T735C"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S7 FE",
    "Device": "gts7xllite",
    "Model": "SM-T735N"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S7 FE",
    "Device": "gts7xllite",
    "Model": "SM-T737"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S7 FE",
    "Device": "gts7xllitewifi",
    "Model": "SM-T730"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S7 FE 5G",
    "Device": "gts7xllite",
    "Model": "SM-T736B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S7 FE 5G",
    "Device": "gts7xllite",
    "Model": "SM-T736N"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S7 FE 5G",
    "Device": "gts7xllite",
    "Model": "SM-T738U"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S7+",
    "Device": "gts7xl",
    "Model": "SM-T975"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S7+",
    "Device": "gts7xl",
    "Model": "SM-T975N"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S7+",
    "Device": "gts7xlwifi",
    "Model": "SM-T970"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S7+ 5G",
    "Device": "gts7xl",
    "Model": "SM-T976B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S7+ 5G",
    "Device": "gts7xl",
    "Model": "SM-T976N"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S7+ 5G",
    "Device": "gts7xl",
    "Model": "SM-T978U"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S8",
    "Device": "gts8wifi",
    "Model": "SM-X700"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S8 5G",
    "Device": "gts8",
    "Model": "SM-X706B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S8 5G",
    "Device": "gts8",
    "Model": "SM-X706C"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S8 5G",
    "Device": "gts8",
    "Model": "SM-X706N"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S8 Ultra",
    "Device": "gts8uwifi",
    "Model": "SM-X900"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S8 Ultra 5G",
    "Device": "gts8u",
    "Model": "SM-X906B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S8 Ultra 5G",
    "Device": "gts8u",
    "Model": "SM-X906C"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S8 Ultra 5G",
    "Device": "gts8u",
    "Model": "SM-X906N"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S8+",
    "Device": "gts8pwifi",
    "Model": "SM-X800"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S8+ 5G",
    "Device": "gts8p",
    "Model": "SM-X806B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S8+ 5G",
    "Device": "gts8p",
    "Model": "SM-X806C"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S8+ 5G",
    "Device": "gts8p",
    "Model": "SM-X806E"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S8+ 5G",
    "Device": "gts8p",
    "Model": "SM-X806N"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S8+ 5G",
    "Device": "gts8p",
    "Model": "SM-X808U"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S9",
    "Device": "gts9wifi",
    "Model": "SM-X710"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S9 5G",
    "Device": "gts9",
    "Model": "SM-X716B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S9 5G",
    "Device": "gts9",
    "Model": "SM-X716N"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S9 FE",
    "Device": "gts9fewifi",
    "Model": "SM-X510"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S9 FE 5G",
    "Device": "gts9fe",
    "Model": "SM-X516B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S9 FE 5G",
    "Device": "gts9fe",
    "Model": "SM-X516C"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S9 FE 5G",
    "Device": "gts9fe",
    "Model": "SM-X516N"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S9 FE 5G",
    "Device": "gts9fe",
    "Model": "SM-X518U"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S9 FE+",
    "Device": "gts9fepwifi",
    "Model": "SM-X610"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S9 FE+ 5G",
    "Device": "SCT22",
    "Model": "SCT22"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S9 FE+ 5G",
    "Device": "gts9fep",
    "Model": "SM-X616B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S9 FE+ 5G",
    "Device": "gts9fep",
    "Model": "SM-X616C"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S9 FE+ 5G",
    "Device": "gts9fep",
    "Model": "SM-X616N"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S9 Ultra",
    "Device": "gts9uwifi",
    "Model": "SM-X910"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S9 Ultra 5G",
    "Device": "gts9u",
    "Model": "SM-X916B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S9 Ultra 5G",
    "Device": "gts9u",
    "Model": "SM-X916C"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S9 Ultra 5G",
    "Device": "gts9u",
    "Model": "SM-X916N"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S9+",
    "Device": "gts9pwifi",
    "Model": "SM-X810"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S9+ 5G",
    "Device": "gts9p",
    "Model": "SM-X816B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S9+ 5G",
    "Device": "gts9p",
    "Model": "SM-X816N"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab S9+ 5G",
    "Device": "gts9p",
    "Model": "SM-X818U"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab2 10.1",
    "Device": "espresso10att",
    "Model": "SAMSUNG-SGH-I497"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab2 10.1",
    "Device": "espresso10can",
    "Model": "SGH-I497"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab2 10.1",
    "Device": "espresso10rf",
    "Model": "GT-P5100"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab2 10.1",
    "Device": "espresso10spr",
    "Model": "SPH-P500"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab2 10.1",
    "Device": "espresso10tmo",
    "Model": "SGH-T779"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab2 10.1",
    "Device": "espresso10vzw",
    "Model": "SCH-I915"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab2 10.1",
    "Device": "espresso10wifi",
    "Model": "GT-P5110"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab2 10.1",
    "Device": "espresso10wifi",
    "Model": "GT-P5113"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab2 7.0",
    "Device": "espressorf",
    "Model": "GT-P3100"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab2 7.0",
    "Device": "espressorf",
    "Model": "GT-P3100B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab2 7.0",
    "Device": "espressorf",
    "Model": "GT-P3105"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab2 7.0",
    "Device": "espressovzw",
    "Model": "SCH-I705"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab2 7.0",
    "Device": "espressovzw",
    "Model": "SCH-i705"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab2 7.0",
    "Device": "espressowifi",
    "Model": "GT-P3110"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab2 7.0",
    "Device": "espressowifi",
    "Model": "GT-P3113"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab3",
    "Device": "lt01wifikx",
    "Model": "SM-T310"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab3 10.1",
    "Device": "santos103g",
    "Model": "GT-P5200"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab3 10.1",
    "Device": "santos10lte",
    "Model": "GT-P5220"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab3 10.1",
    "Device": "santos10wifi",
    "Model": "GT-P5210"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab3 10.1",
    "Device": "santos10wifi",
    "Model": "GT-P5210XD1"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab3 7.0",
    "Device": "lt023g",
    "Model": "SM-T211"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab3 7.0",
    "Device": "lt023g",
    "Model": "SM-T212"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab3 7.0",
    "Device": "lt023gdtv",
    "Model": "SM-T211M"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab3 7.0",
    "Device": "lt02lte",
    "Model": "SM-T215"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab3 7.0",
    "Device": "lt02lteatt",
    "Model": "SAMSUNG-SM-T217A"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab3 7.0",
    "Device": "lt02ltespr",
    "Model": "SM-T217S"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab3 7.0",
    "Device": "lt02ltetmo",
    "Model": "SM-T217T"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab3 7.0",
    "Device": "lt02wifi",
    "Model": "SM-T210"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab3 7.0",
    "Device": "lt02wifi",
    "Model": "SM-T210R"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab3 7.0",
    "Device": "lt02wifilgt",
    "Model": "SM-T210L"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab3 8.0",
    "Device": "lt013g",
    "Model": "SM-T311"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab3 8.0",
    "Device": "lt013g",
    "Model": "SM-T312"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab3 8.0",
    "Device": "lt01lte",
    "Model": "SM-T315"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab3 8.0",
    "Device": "lt01lte",
    "Model": "SM-T315T"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab3 8.0",
    "Device": "lt01wifi",
    "Model": "SM-T310"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab3 8.0",
    "Device": "lt01wifi",
    "Model": "SM-T310X"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab3 8.0",
    "Device": "lt02lduwifi",
    "Model": "SM-T210X"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab3 Kids",
    "Device": "lt02kidswifi",
    "Model": "SM-T2105"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab3 Lite",
    "Device": "goya3g",
    "Model": "SM-T111"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab3 Lite",
    "Device": "goya3g",
    "Model": "SM-T111M"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab3 Lite",
    "Device": "goyawifi",
    "Model": "SM-T110"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab3 Lite 7.0",
    "Device": "goyave3g",
    "Model": "SM-T116NQ"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab3 Lite 7.0",
    "Device": "goyavewifi",
    "Model": "SM-T113"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab3 VE 7.0",
    "Device": "goyave3g",
    "Model": "SM-T116"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab3V 7.0",
    "Device": "goyave3gsea",
    "Model": "SM-T116NU"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab3V 7.0",
    "Device": "goyavewifixtc",
    "Model": "SM-T113NU"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab4",
    "Device": "matissewifigoogle",
    "Model": "SM-T530NN"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab4 10.0",
    "Device": "matisse3g",
    "Model": "SM-T531"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab4 10.0",
    "Device": "matisselte",
    "Model": "SM-T535"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab4 10.0",
    "Device": "matisselteatt",
    "Model": "SAMSUNG-SM-T537A"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab4 10.0",
    "Device": "matisselteusc",
    "Model": "SM-T537R4"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab4 10.0",
    "Device": "matisseltevzw",
    "Model": "SM-T537V"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab4 10.1",
    "Device": "matisse10wifikx",
    "Model": "SM-T536"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab4 10.1",
    "Device": "matissevewifi",
    "Model": "SM-T533"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab4 10.1",
    "Device": "matissewifi",
    "Model": "SM-T530"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab4 10.1",
    "Device": "matissewifi",
    "Model": "SM-T530X"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab4 10.1",
    "Device": "matissewifikx",
    "Model": "SM-T530"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab4 10.1",
    "Device": "matissewifiue",
    "Model": "SM-T530NU"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab4 7",
    "Device": "degasy18wifi",
    "Model": "SM-T230NZ"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab4 7.0",
    "Device": "403SC",
    "Model": "403SC"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab4 7.0",
    "Device": "degas2wifi",
    "Model": "SM-T230NW"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab4 7.0",
    "Device": "degas2wifibmwchn",
    "Model": "SM-T230NW"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab4 7.0",
    "Device": "degas3g",
    "Model": "SM-T231"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab4 7.0",
    "Device": "degas3g",
    "Model": "SM-T232"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab4 7.0",
    "Device": "degaslte",
    "Model": "SM-T235"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab4 7.0",
    "Device": "degaslte",
    "Model": "SM-T235Y"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab4 7.0",
    "Device": "degasltespr",
    "Model": "SM-T237P"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab4 7.0",
    "Device": "degasltevzw",
    "Model": "SM-T237V"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab4 7.0",
    "Device": "degasvelte",
    "Model": "SM-T239"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab4 7.0",
    "Device": "degasvelte",
    "Model": "SM-T2397"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab4 7.0",
    "Device": "degasvelte",
    "Model": "SM-T239M"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab4 7.0",
    "Device": "degasveltechn",
    "Model": "SM-T239C"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab4 7.0",
    "Device": "degaswifi",
    "Model": "SM-T230"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab4 7.0",
    "Device": "degaswifi",
    "Model": "SM-T230NY"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab4 7.0",
    "Device": "degaswifi",
    "Model": "SM-T230X"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab4 7.0",
    "Device": "degaswifibmwzc",
    "Model": "SM-T230NY"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab4 7.0",
    "Device": "degaswifidtv",
    "Model": "SM-T230NT"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab4 7.0",
    "Device": "degaswifiopenbnn",
    "Model": "SM-T230NU"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab4 7.0",
    "Device": "degaswifiue",
    "Model": "SM-T230NU"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab4 8.0",
    "Device": "millet3g",
    "Model": "SM-T331"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab4 8.0",
    "Device": "milletlte",
    "Model": "SM-T335"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab4 8.0",
    "Device": "milletlteatt",
    "Model": "SAMSUNG-SM-T337A"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab4 8.0",
    "Device": "milletltektt",
    "Model": "SM-T335K"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab4 8.0",
    "Device": "milletltelgt",
    "Model": "SM-T335L"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab4 8.0",
    "Device": "milletltetmo",
    "Model": "SM-T337T"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab4 8.0",
    "Device": "milletltevzw",
    "Model": "SM-T337V"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab4 8.0",
    "Device": "milletwifi",
    "Model": "SM-T330"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab4 8.0",
    "Device": "milletwifiue",
    "Model": "SM-T330NU"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab4 Active",
    "Device": "rubenslte",
    "Model": "SM-T365"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab4 Active",
    "Device": "rubenslte",
    "Model": "SM-T365M"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab4 Active",
    "Device": "rubensltekx",
    "Model": "SM-T365F0"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab4 Active",
    "Device": "rubenswifi",
    "Model": "SM-T360"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab4 Active",
    "Device": "rubenswifichn",
    "Model": "SM-T360"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tab4 Nook 10.1",
    "Device": "matissewifiopenbnn",
    "Model": "SM-T530NU"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy TabA Plus10.1",
    "Device": "gtanotexlwifikx",
    "Model": "SM-P580X"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy TabE 8.0",
    "Device": "gtesltektt",
    "Model": "SM-T378K"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy TabE 8.0",
    "Device": "gtesltelgt",
    "Model": "SM-T378L"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy TabE 8.0",
    "Device": "gteslteskt",
    "Model": "SM-T378S"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy TabS 10.5",
    "Device": "SCT21",
    "Model": "SCT21"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy TabS 10.5",
    "Device": "chagallhltektt",
    "Model": "SM-T805K"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy TabS 10.5",
    "Device": "chagallhltelgt",
    "Model": "SM-T805L"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy TabS 10.5",
    "Device": "chagallhlteskt",
    "Model": "SM-T805S"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy TabS 10.5",
    "Device": "chagalllte",
    "Model": "SM-T805"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy TabS 10.5",
    "Device": "chagalllte",
    "Model": "SM-T805C"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy TabS 10.5",
    "Device": "chagalllte",
    "Model": "SM-T805M"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy TabS 10.5",
    "Device": "chagalllte",
    "Model": "SM-T805Y"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy TabS 10.5",
    "Device": "chagalllte",
    "Model": "SM-T807"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy TabS 10.5",
    "Device": "chagalllteatt",
    "Model": "SAMSUNG-SM-T807A"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy TabS 10.5",
    "Device": "chagallltecan",
    "Model": "SM-T805W"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy TabS 10.5",
    "Device": "chagallltespr",
    "Model": "SM-T807P"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy TabS 10.5",
    "Device": "chagallltetmo",
    "Model": "SM-T807T"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy TabS 10.5",
    "Device": "chagalllteusc",
    "Model": "SM-T807R4"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy TabS 10.5",
    "Device": "chagallltevzw",
    "Model": "SM-T807V"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy TabS 10.5",
    "Device": "chagallwifi",
    "Model": "SM-T800"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy TabS 10.5",
    "Device": "chagallwifi",
    "Model": "SM-T800X"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy TabS 10.5",
    "Device": "chagallwifikx",
    "Model": "SM-T800"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy TabS 8.4",
    "Device": "klimtlte",
    "Model": "SM-T705"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy TabS 8.4",
    "Device": "klimtlte",
    "Model": "SM-T705M"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy TabS 8.4",
    "Device": "klimtlteatt",
    "Model": "SAMSUNG-SM-T707A"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy TabS 8.4",
    "Device": "klimtltecan",
    "Model": "SM-T705W"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy TabS 8.4",
    "Device": "klimtwifi",
    "Model": "SM-T700"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy TabS 8.4",
    "Device": "klimtwifikx",
    "Model": "SM-T700"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy TabS2 9.7",
    "Device": "gts210veltevzw",
    "Model": "SM-T818V"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy TabS3",
    "Device": "gts3llte",
    "Model": "SM-T825"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy TabS3",
    "Device": "gts3llte",
    "Model": "SM-T825Y"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy TabS3",
    "Device": "gts3lltechn",
    "Model": "SM-T825C"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tap Pro 10.1",
    "Device": "picassolte",
    "Model": "SM-T525"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Tap Pro 8.4",
    "Device": "mondrianwifi",
    "Model": "SM-T320"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Trend",
    "Device": "kyleve",
    "Model": "GT-S7392"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Trend",
    "Device": "kyleve",
    "Model": "GT-S7392L"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Trend",
    "Device": "kyleve3gcmcc",
    "Model": "GT-S7568I"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Trend Duos",
    "Device": "kyleichn",
    "Model": "GT-S7562i"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Trend Duos",
    "Device": "kylepluschn",
    "Model": "GT-S7572"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Trend Duos",
    "Device": "kyleve",
    "Model": "GT-S7390"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Trend Duos",
    "Device": "kyleve",
    "Model": "GT-S7392"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Trend Duos",
    "Device": "kyleve",
    "Model": "GT-S7562C"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Trend Lite",
    "Device": "kylevess",
    "Model": "GT-S7390"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Trend Lite",
    "Device": "kylevess",
    "Model": "GT-S7390L"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Trend Plus",
    "Device": "kylepro",
    "Model": "GT-S7580"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Trend Plus",
    "Device": "kylepro",
    "Model": "GT-S7580E"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Trend Plus",
    "Device": "kylepro",
    "Model": "GT-S7580L"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Trend Plus",
    "Device": "kylepro",
    "Model": "GT-S7583T"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Trend2",
    "Device": "garda3gcmcc",
    "Model": "GT-S7898"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Trend2",
    "Device": "gardave3gcmcc",
    "Model": "GT-S7898I"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Trend2",
    "Device": "kyleplusctc",
    "Model": "SCH-I739"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Trend3",
    "Device": "cs023g",
    "Model": "SM-G3502U"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Trend3",
    "Device": "cs02cmcc",
    "Model": "SM-G3508"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Trend3",
    "Device": "cs02ctc",
    "Model": "SM-G3509"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Trend3",
    "Device": "cs02ve",
    "Model": "SM-G3508I"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Trend3",
    "Device": "cs02ve3g",
    "Model": "SM-G3502C"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Trend3",
    "Device": "cs02ve3g",
    "Model": "SM-G3502I"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Trend3",
    "Device": "cs02ve3g",
    "Model": "SM-G3508J"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Trend3",
    "Device": "cs02ve3g",
    "Model": "SM-G3509I"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy U",
    "Device": "SHW-M130L",
    "Model": "SHW-M130L"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Victory",
    "Device": "goghspr",
    "Model": "SPH-L300"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Victory",
    "Device": "goghvmu",
    "Model": "SPH-L300"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy View",
    "Device": "gvlte",
    "Model": "SM-T677"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy View",
    "Device": "gvlteatt",
    "Model": "SAMSUNG-SM-T677A"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy View",
    "Device": "gvltevzw",
    "Model": "SM-T677V"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy View",
    "Device": "gvltexsp",
    "Model": "SM-T677"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy View",
    "Device": "gvwifijpn",
    "Model": "SM-T670"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy View",
    "Device": "gvwifiue",
    "Model": "SM-T670"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy View2",
    "Device": "gview2lteatt",
    "Model": "SM-T927A"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy W",
    "Device": "GT-I8150",
    "Model": "GT-I8150"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy W",
    "Device": "GT-I8150B",
    "Model": "GT-I8150B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy W",
    "Device": "GT-I8150T",
    "Model": "GT-I8150T"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy W",
    "Device": "SGH-T679M",
    "Model": "SGH-T679M"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy W",
    "Device": "q7lteskt",
    "Model": "SM-T255S"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Watch FE",
    "Device": "lucky7bs",
    "Model": "SM-R861"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Watch FE",
    "Device": "lucky7us",
    "Model": "SM-R866U"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Watch Ultra",
    "Device": "projectx2bl",
    "Model": "SM-L700"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Watch Ultra",
    "Device": "projectx2ul",
    "Model": "SM-L7050"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Watch Ultra",
    "Device": "projectx2ul",
    "Model": "SM-L705F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Watch Ultra",
    "Device": "projectx2ul",
    "Model": "SM-L705N"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Watch Ultra",
    "Device": "projectx2ul",
    "Model": "SM-L705U"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Watch4",
    "Device": "freshbl",
    "Model": "SM-R870"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Watch4",
    "Device": "freshbs",
    "Model": "SM-R860"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Watch4",
    "Device": "freshul",
    "Model": "SM-R875F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Watch4",
    "Device": "freshul",
    "Model": "SM-R875N"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Watch4",
    "Device": "freshul",
    "Model": "SM-R875U"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Watch4",
    "Device": "freshus",
    "Model": "SM-R865F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Watch4",
    "Device": "freshus",
    "Model": "SM-R865N"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Watch4",
    "Device": "freshus",
    "Model": "SM-R865U"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Watch4 Classic",
    "Device": "wisebl",
    "Model": "SM-R890"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Watch4 Classic",
    "Device": "wisebs",
    "Model": "SM-R880"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Watch4 Classic",
    "Device": "wiseul",
    "Model": "SM-R8950"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Watch4 Classic",
    "Device": "wiseul",
    "Model": "SM-R895F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Watch4 Classic",
    "Device": "wiseul",
    "Model": "SM-R895N"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Watch4 Classic",
    "Device": "wiseul",
    "Model": "SM-R895U"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Watch4 Classic",
    "Device": "wiseus",
    "Model": "SM-R885F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Watch4 Classic",
    "Device": "wiseus",
    "Model": "SM-R885N"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Watch4 Classic",
    "Device": "wiseus",
    "Model": "SM-R885U"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Watch5",
    "Device": "heartbl",
    "Model": "SM-R910"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Watch5",
    "Device": "heartbs",
    "Model": "SM-R900"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Watch5",
    "Device": "heartul",
    "Model": "SM-R9150"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Watch5",
    "Device": "heartul",
    "Model": "SM-R915F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Watch5",
    "Device": "heartul",
    "Model": "SM-R915N"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Watch5",
    "Device": "heartul",
    "Model": "SM-R915U"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Watch5",
    "Device": "heartus",
    "Model": "SM-R905F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Watch5",
    "Device": "heartus",
    "Model": "SM-R905N"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Watch5",
    "Device": "heartus",
    "Model": "SM-R905U"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Watch5 Pro",
    "Device": "projectxbl",
    "Model": "SM-R920"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Watch5 Pro",
    "Device": "projectxul",
    "Model": "SM-R925F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Watch5 Pro",
    "Device": "projectxul",
    "Model": "SM-R925N"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Watch5 Pro",
    "Device": "projectxul",
    "Model": "SM-R925U"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Watch6",
    "Device": "fresh6bl",
    "Model": "SM-R940"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Watch6",
    "Device": "fresh6bs",
    "Model": "SM-R930"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Watch6",
    "Device": "fresh6ul",
    "Model": "SM-R9450"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Watch6",
    "Device": "fresh6ul",
    "Model": "SM-R945F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Watch6",
    "Device": "fresh6ul",
    "Model": "SM-R945N"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Watch6",
    "Device": "fresh6ul",
    "Model": "SM-R945U"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Watch6",
    "Device": "fresh6us",
    "Model": "SM-R935F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Watch6",
    "Device": "fresh6us",
    "Model": "SM-R935N"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Watch6",
    "Device": "fresh6us",
    "Model": "SM-R935U"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Watch6 Classic",
    "Device": "wise6bl",
    "Model": "SM-R960"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Watch6 Classic",
    "Device": "wise6bs",
    "Model": "SM-R950"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Watch6 Classic",
    "Device": "wise6ul",
    "Model": "SM-R9650"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Watch6 Classic",
    "Device": "wise6ul",
    "Model": "SM-R965F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Watch6 Classic",
    "Device": "wise6ul",
    "Model": "SM-R965N"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Watch6 Classic",
    "Device": "wise6ul",
    "Model": "SM-R965U"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Watch6 Classic",
    "Device": "wise6us",
    "Model": "SM-R955F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Watch6 Classic",
    "Device": "wise6us",
    "Model": "SM-R955N"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Watch6 Classic",
    "Device": "wise6us",
    "Model": "SM-R955U"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Watch7",
    "Device": "fresh7bl",
    "Model": "SM-L310"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Watch7",
    "Device": "fresh7bs",
    "Model": "SM-L300"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Watch7",
    "Device": "fresh7ul",
    "Model": "SM-L3150"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Watch7",
    "Device": "fresh7ul",
    "Model": "SM-L315F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Watch7",
    "Device": "fresh7ul",
    "Model": "SM-L315N"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Watch7",
    "Device": "fresh7ul",
    "Model": "SM-L315U"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Watch7",
    "Device": "fresh7us",
    "Model": "SM-L305F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Watch7",
    "Device": "fresh7us",
    "Model": "SM-L305N"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Watch7",
    "Device": "fresh7us",
    "Model": "SM-L305U"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Watch8",
    "Device": "fresh8bl",
    "Model": "SM-L330"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Watch8",
    "Device": "fresh8bs",
    "Model": "SM-L320"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Watch8",
    "Device": "fresh8ul",
    "Model": "SM-L3350"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Watch8",
    "Device": "fresh8ul",
    "Model": "SM-L335F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Watch8",
    "Device": "fresh8ul",
    "Model": "SM-L335N"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Watch8",
    "Device": "fresh8ul",
    "Model": "SM-L335U"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Watch8",
    "Device": "fresh8us",
    "Model": "SM-L325F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Watch8",
    "Device": "fresh8us",
    "Model": "SM-L325N"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Watch8",
    "Device": "fresh8us",
    "Model": "SM-L325U"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Watch8 Classic",
    "Device": "wise8bs",
    "Model": "SM-L500"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Watch8 Classic",
    "Device": "wise8us",
    "Model": "SM-L5050"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Watch8 Classic",
    "Device": "wise8us",
    "Model": "SM-L505F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Watch8 Classic",
    "Device": "wise8us",
    "Model": "SM-L505N"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Watch8 Classic",
    "Device": "wise8us",
    "Model": "SM-L505U"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Wide",
    "Device": "on7nlteskt",
    "Model": "SM-G600S"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Wide2",
    "Device": "j7popelteskt",
    "Model": "SM-J727S"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Wide3",
    "Device": "j7toplteskt",
    "Model": "SM-J737S"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Wide4",
    "Device": "a20",
    "Model": "SM-A205S"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Wide5",
    "Device": "f42x",
    "Model": "SM-E426S"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Wide7",
    "Device": "m15x",
    "Model": "SM-M156S"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Wide8",
    "Device": "m16x",
    "Model": "SM-M166S"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Win",
    "Device": "delos3gcmcc",
    "Model": "GT-I8558"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Win",
    "Device": "delos3gduosctc",
    "Model": "SCH-I869"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Win",
    "Device": "delos3geur",
    "Model": "GT-I8552"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Win",
    "Device": "delos3geur",
    "Model": "GT-I8552B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Win",
    "Device": "delos3gss",
    "Model": "GT-I8550E"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Win",
    "Device": "delosltelgt",
    "Model": "SHV-E500L"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Win",
    "Device": "deloslteskt",
    "Model": "SHV-E500S"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Win Duos",
    "Device": "delos3gchn",
    "Model": "GT-I8552"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Win Pro",
    "Device": "wilcox3g",
    "Model": "SM-G3818"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Win Pro",
    "Device": "wilcoxctc",
    "Model": "SM-G3819"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Win Pro",
    "Device": "wilcoxctc",
    "Model": "SM-G3819D"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Win Pro",
    "Device": "wilcoxds",
    "Model": "SM-G3812"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Win2",
    "Device": "coreprimeltedtv",
    "Model": "SM-G360BT"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy XCover 4s",
    "Device": "xcover4s",
    "Model": "SM-G398FN"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy XCover 5",
    "Device": "xcover5",
    "Model": "SM-G525F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy XCover 5",
    "Device": "xcover5",
    "Model": "SM-G525N"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy XCover Field Pro",
    "Device": "haechiy19",
    "Model": "SM-G889F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy XCover FieldPro",
    "Device": "haechiy19",
    "Model": "SM-G889G"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy XCover FieldPro",
    "Device": "haechiy19",
    "Model": "SM-G889YB"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy XCover FieldPro",
    "Device": "haechiy19lteatt",
    "Model": "SM-G889A"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy XCover Pro",
    "Device": "xcoverpro",
    "Model": "SM-G715FN"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy XCover4",
    "Device": "xcover4lte",
    "Model": "SM-G390F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy XCover6 Pro",
    "Device": "xcoverpro2",
    "Model": "SM-G736B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy XCover6 Pro",
    "Device": "xcoverpro2",
    "Model": "SM-G736U"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy XCover6 Pro",
    "Device": "xcoverpro2",
    "Model": "SM-G736U1"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy XCover6 Pro",
    "Device": "xcoverpro2",
    "Model": "SM-G736W"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy XCover7",
    "Device": "xcover7",
    "Model": "SM-G556B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy XCover7 Pro",
    "Device": "xcover7pro",
    "Model": "SM-G766B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy XCover7 Pro",
    "Device": "xcover7pro",
    "Model": "SM-G766N"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy XCover7 Pro",
    "Device": "xcover7pro",
    "Model": "SM-G766U"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy XCover7 Pro",
    "Device": "xcover7pro",
    "Model": "SM-G766U1"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy XCover7 Pro",
    "Device": "xcover7pro",
    "Model": "SM-G766W"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy XR",
    "Device": "xrvst2",
    "Model": "SM-I610"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy XR",
    "Device": "xrvst2",
    "Model": "SM-I610H"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Xcover",
    "Device": "GT-S5690",
    "Model": "GT-S5690"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Xcover",
    "Device": "GT-S5690L",
    "Model": "GT-S5690L"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Xcover",
    "Device": "GT-S5690M",
    "Model": "GT-S5690M"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Xcover",
    "Device": "GT-S5690R",
    "Model": "GT-S5690R"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Xcover2",
    "Device": "skomer",
    "Model": "GT-S7710"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Xcover2",
    "Device": "skomer",
    "Model": "GT-S7710L"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Xcover3",
    "Device": "xcover3lte",
    "Model": "SM-G388F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Xcover3",
    "Device": "xcover3velte",
    "Model": "SM-G389F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Xcover4",
    "Device": "xcover4lte",
    "Model": "SM-G390Y"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Xcover4",
    "Device": "xcover4ltecan",
    "Model": "SM-G390W"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Y",
    "Device": "GT-S5360",
    "Model": "GT-S5360"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Y",
    "Device": "GT-S5360B",
    "Model": "GT-S5360B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Y",
    "Device": "GT-S5360L",
    "Model": "GT-S5360L"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Y",
    "Device": "GT-S5360T",
    "Model": "GT-S5360T"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Y",
    "Device": "GT-S5363",
    "Model": "GT-S5363"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Y",
    "Device": "GT-S5368",
    "Model": "GT-S5368"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Y",
    "Device": "GT-S5369",
    "Model": "GT-S5369"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Y",
    "Device": "SCH-I509",
    "Model": "SCH-I509"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Y",
    "Device": "SCH-i509",
    "Model": "SCH-i509"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Y Duos",
    "Device": "GT-S6102",
    "Model": "GT-S6102"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Y Duos",
    "Device": "GT-S6102B",
    "Model": "GT-S6102B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Y Duos",
    "Device": "GT-S6102E",
    "Model": "GT-S6102E"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Y Plus",
    "Device": "coriplusds",
    "Model": "GT-S5303"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Y Plus",
    "Device": "coriplusds",
    "Model": "GT-S5303B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Y Pop",
    "Device": "GT-S6108",
    "Model": "GT-S6108"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Y Pro",
    "Device": "GT-B5510",
    "Model": "GT-B5510"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Y Pro",
    "Device": "GT-B5510B",
    "Model": "GT-B5510B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Y Pro",
    "Device": "GT-B5510L",
    "Model": "GT-B5510L"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Y Pro Duos",
    "Device": "GT-B5512",
    "Model": "GT-B5512"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Y Pro Duos",
    "Device": "GT-B5512B",
    "Model": "GT-B5512B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Y TV",
    "Device": "GT-S5367",
    "Model": "GT-S5367"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Young",
    "Device": "roy",
    "Model": "GT-S6312"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Young",
    "Device": "roydtv",
    "Model": "GT-S6313T"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Young",
    "Device": "royss",
    "Model": "GT-S6310"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Young",
    "Device": "royss",
    "Model": "GT-S6310B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Young",
    "Device": "royss",
    "Model": "GT-S6310L"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Young",
    "Device": "royss",
    "Model": "GT-S6310T"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Young",
    "Device": "royssdtv",
    "Model": "GT-S6313T"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Young",
    "Device": "royssnfc",
    "Model": "GT-S6310N"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Young2",
    "Device": "young23g",
    "Model": "SM-G130H"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Young2",
    "Device": "young23g",
    "Model": "SM-G130M"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Young2",
    "Device": "young23g",
    "Model": "SM-G130U"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Young2",
    "Device": "young23gdtv",
    "Model": "SM-G130BT"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Young2",
    "Device": "young2ds2g",
    "Model": "SM-G130E"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Young2",
    "Device": "young2nfc3g",
    "Model": "SM-G130HN"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Young2 Pro",
    "Device": "young2ve3g",
    "Model": "SM-G130BU"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Z Flip",
    "Device": "SCV47",
    "Model": "SCV47"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Z Flip",
    "Device": "bloomq",
    "Model": "SM-F7000"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Z Flip",
    "Device": "bloomq",
    "Model": "SM-F700F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Z Flip",
    "Device": "bloomq",
    "Model": "SM-F700N"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Z Flip",
    "Device": "bloomq",
    "Model": "SM-F700U"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Z Flip",
    "Device": "bloomq",
    "Model": "SM-F700U1"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Z Flip",
    "Device": "bloomq",
    "Model": "SM-F700W"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Z Flip 5G",
    "Device": "SCG04",
    "Model": "SCG04"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Z Flip 5G",
    "Device": "bloomxq",
    "Model": "SM-F7070"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Z Flip 5G",
    "Device": "bloomxq",
    "Model": "SM-F707B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Z Flip 5G",
    "Device": "bloomxq",
    "Model": "SM-F707N"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Z Flip 5G",
    "Device": "bloomxq",
    "Model": "SM-F707U"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Z Flip 5G",
    "Device": "bloomxq",
    "Model": "SM-F707U1"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Z Flip 5G",
    "Device": "bloomxq",
    "Model": "SM-F707W"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Z Flip3 5G",
    "Device": "SC-54B",
    "Model": "SC-54B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Z Flip3 5G",
    "Device": "SCG12",
    "Model": "SCG12"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Z Flip3 5G",
    "Device": "b2q",
    "Model": "SM-F7110"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Z Flip3 5G",
    "Device": "b2q",
    "Model": "SM-F711B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Z Flip3 5G",
    "Device": "b2q",
    "Model": "SM-F711N"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Z Flip3 5G",
    "Device": "b2q",
    "Model": "SM-F711U"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Z Flip3 5G",
    "Device": "b2q",
    "Model": "SM-F711U1"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Z Flip3 5G",
    "Device": "b2q",
    "Model": "SM-F711W"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Z Flip4",
    "Device": "SC-54C",
    "Model": "SC-54C"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Z Flip4",
    "Device": "SCG17",
    "Model": "SCG17"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Z Flip4",
    "Device": "b4q",
    "Model": "SM-F7210"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Z Flip4",
    "Device": "b4q",
    "Model": "SM-F721B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Z Flip4",
    "Device": "b4q",
    "Model": "SM-F721C"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Z Flip4",
    "Device": "b4q",
    "Model": "SM-F721N"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Z Flip4",
    "Device": "b4q",
    "Model": "SM-F721U"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Z Flip4",
    "Device": "b4q",
    "Model": "SM-F721U1"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Z Flip4",
    "Device": "b4q",
    "Model": "SM-F721W"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Z Flip5",
    "Device": "SC-54D",
    "Model": "SC-54D"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Z Flip5",
    "Device": "SCG23",
    "Model": "SCG23"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Z Flip5",
    "Device": "b5q",
    "Model": "SM-F7310"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Z Flip5",
    "Device": "b5q",
    "Model": "SM-F731B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Z Flip5",
    "Device": "b5q",
    "Model": "SM-F731N"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Z Flip5",
    "Device": "b5q",
    "Model": "SM-F731Q"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Z Flip5",
    "Device": "b5q",
    "Model": "SM-F731U"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Z Flip5",
    "Device": "b5q",
    "Model": "SM-F731U1"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Z Flip5",
    "Device": "b5q",
    "Model": "SM-F731W"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Z Flip6",
    "Device": "SC-54E",
    "Model": "SC-54E"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Z Flip6",
    "Device": "SCG29",
    "Model": "SCG29"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Z Flip6",
    "Device": "b6q",
    "Model": "SM-F7410"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Z Flip6",
    "Device": "b6q",
    "Model": "SM-F741B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Z Flip6",
    "Device": "b6q",
    "Model": "SM-F741N"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Z Flip6",
    "Device": "b6q",
    "Model": "SM-F741Q"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Z Flip6",
    "Device": "b6q",
    "Model": "SM-F741U"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Z Flip6",
    "Device": "b6q",
    "Model": "SM-F741U1"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Z Flip6",
    "Device": "b6q",
    "Model": "SM-F741W"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Z Flip7",
    "Device": "SC-55F",
    "Model": "SC-55F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Z Flip7",
    "Device": "SCG35",
    "Model": "SCG35"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Z Flip7",
    "Device": "b7s",
    "Model": "SM-F7660"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Z Flip7",
    "Device": "b7s",
    "Model": "SM-F766B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Z Flip7",
    "Device": "b7s",
    "Model": "SM-F766N"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Z Flip7",
    "Device": "b7s",
    "Model": "SM-F766Q"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Z Flip7",
    "Device": "b7s",
    "Model": "SM-F766U"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Z Flip7",
    "Device": "b7s",
    "Model": "SM-F766U1"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Z Flip7",
    "Device": "b7s",
    "Model": "SM-F766W"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Z Flip7",
    "Device": "b7s",
    "Model": "SM-F766Z"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Z Flip7 FE",
    "Device": "b7r",
    "Model": "SM-F7610"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Z Flip7 FE",
    "Device": "b7r",
    "Model": "SM-F761B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Z Flip7 FE",
    "Device": "b7r",
    "Model": "SM-F761N"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Z Flip7 FE",
    "Device": "b7r",
    "Model": "SM-F761U"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Z Flip7 FE",
    "Device": "b7r",
    "Model": "SM-F761U1"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Z Fold Special Edition",
    "Device": "q6aq",
    "Model": "SM-F958N"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Z Fold2 5G",
    "Device": "f2q",
    "Model": "SM-F9160"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Z Fold2 5G",
    "Device": "f2q",
    "Model": "SM-F916B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Z Fold2 5G",
    "Device": "f2q",
    "Model": "SM-F916N"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Z Fold2 5G",
    "Device": "f2q",
    "Model": "SM-F916Q"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Z Fold2 5G",
    "Device": "f2q",
    "Model": "SM-F916U"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Z Fold2 5G",
    "Device": "f2q",
    "Model": "SM-F916U1"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Z Fold2 5G",
    "Device": "f2q",
    "Model": "SM-F916W"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Z Fold3 5G",
    "Device": "SC-55B",
    "Model": "SC-55B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Z Fold3 5G",
    "Device": "SCG11",
    "Model": "SCG11"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Z Fold3 5G",
    "Device": "q2q",
    "Model": "SM-F9260"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Z Fold3 5G",
    "Device": "q2q",
    "Model": "SM-F926B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Z Fold3 5G",
    "Device": "q2q",
    "Model": "SM-F926N"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Z Fold3 5G",
    "Device": "q2q",
    "Model": "SM-F926U"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Z Fold3 5G",
    "Device": "q2q",
    "Model": "SM-F926U1"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Z Fold3 5G",
    "Device": "q2q",
    "Model": "SM-F926W"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Z Fold4",
    "Device": "SC-55C",
    "Model": "SC-55C"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Z Fold4",
    "Device": "SCG16",
    "Model": "SCG16"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Z Fold4",
    "Device": "q4q",
    "Model": "SM-F9360"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Z Fold4",
    "Device": "q4q",
    "Model": "SM-F936B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Z Fold4",
    "Device": "q4q",
    "Model": "SM-F936N"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Z Fold4",
    "Device": "q4q",
    "Model": "SM-F936U"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Z Fold4",
    "Device": "q4q",
    "Model": "SM-F936U1"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Z Fold4",
    "Device": "q4q",
    "Model": "SM-F936W"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Z Fold5",
    "Device": "SC-55D",
    "Model": "SC-55D"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Z Fold5",
    "Device": "SCG22",
    "Model": "SCG22"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Z Fold5",
    "Device": "q5q",
    "Model": "SM-F9460"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Z Fold5",
    "Device": "q5q",
    "Model": "SM-F946B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Z Fold5",
    "Device": "q5q",
    "Model": "SM-F946N"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Z Fold5",
    "Device": "q5q",
    "Model": "SM-F946Q"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Z Fold5",
    "Device": "q5q",
    "Model": "SM-F946U"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Z Fold5",
    "Device": "q5q",
    "Model": "SM-F946U1"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Z Fold5",
    "Device": "q5q",
    "Model": "SM-F946W"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Z Fold6",
    "Device": "SC-55E",
    "Model": "SC-55E"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Z Fold6",
    "Device": "SCG28",
    "Model": "SCG28"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Z Fold6",
    "Device": "q6q",
    "Model": "SM-F9560"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Z Fold6",
    "Device": "q6q",
    "Model": "SM-F956B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Z Fold6",
    "Device": "q6q",
    "Model": "SM-F956N"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Z Fold6",
    "Device": "q6q",
    "Model": "SM-F956Q"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Z Fold6",
    "Device": "q6q",
    "Model": "SM-F956U"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Z Fold6",
    "Device": "q6q",
    "Model": "SM-F956U1"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Z Fold6",
    "Device": "q6q",
    "Model": "SM-F956W"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Z Fold7",
    "Device": "SC-56F",
    "Model": "SC-56F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Z Fold7",
    "Device": "SCG34",
    "Model": "SCG34"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Z Fold7",
    "Device": "q7q",
    "Model": "SM-F9660"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Z Fold7",
    "Device": "q7q",
    "Model": "SM-F966B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Z Fold7",
    "Device": "q7q",
    "Model": "SM-F966N"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Z Fold7",
    "Device": "q7q",
    "Model": "SM-F966Q"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Z Fold7",
    "Device": "q7q",
    "Model": "SM-F966U"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Z Fold7",
    "Device": "q7q",
    "Model": "SM-F966U1"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Z Fold7",
    "Device": "q7q",
    "Model": "SM-F966W"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Z Fold7",
    "Device": "q7q",
    "Model": "SM-F966Z"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Z TriFold",
    "Device": "q7mq",
    "Model": "SM-F9680"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Z TriFold",
    "Device": "q7mq",
    "Model": "SM-F968B"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Z TriFold",
    "Device": "q7mq",
    "Model": "SM-F968N"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy Z TriFold",
    "Device": "q7mq",
    "Model": "SM-F968U1"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy player 70 Plus",
    "Device": "YP-GB70D",
    "Model": "YP-GB70D"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy view",
    "Device": "gvltektt",
    "Model": "SM-T677NK"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy view",
    "Device": "gvltelgt",
    "Model": "SM-T677NL"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy win",
    "Device": "delos3gss",
    "Model": "GT-I8550L"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Galaxy-A9(2016)",
    "Device": "a9xltechn",
    "Model": "SM-A9000"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Garda",
    "Device": "gardalteMetroPCS",
    "Model": "SGH-T399N"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Garda",
    "Device": "gardaltetmo",
    "Model": "SGH-T399"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Gear Live",
    "Device": "sprat",
    "Model": "Gear Live"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Gem",
    "Device": "SCH-I100",
    "Model": "SCH-I100"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Gizmo Tablet",
    "Device": "gtasliteltevzw",
    "Model": "SM-T387VK"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Hennessy",
    "Device": "hennessy3gduosctc",
    "Model": "SCH-W789"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Homesync",
    "Device": "spcwifi",
    "Model": "GT-B9150"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Homesync",
    "Device": "spcwifiany",
    "Model": "GT-B9150"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "IceTouch",
    "Device": "gokey",
    "Model": "YP-GH1"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Illusion",
    "Device": "SCH-I110",
    "Model": "SCH-I110"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Infuse",
    "Device": "SGH-I997",
    "Model": "SAMSUNG-SGH-I997"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Infuse",
    "Device": "SGH-I997R",
    "Model": "SAMSUNG-SGH-I997R"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "J1 Mini Prime",
    "Device": "j1minivelte",
    "Model": "SM-J106F"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Moment",
    "Device": "SPH-M900",
    "Model": "SPH-M900"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Montblanc",
    "Device": "montblanc3gctc",
    "Model": "SM-W2014"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Nexus 10",
    "Device": "manta",
    "Model": "Nexus 10"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Nexus S",
    "Device": "crespo",
    "Model": "Nexus S"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Nexus S",
    "Device": "crespo4g",
    "Model": "Nexus S 4G"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "ProXpress M4580",
    "Device": "fiber-athena",
    "Model": "samsung-printer-tablet"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Replenish",
    "Device": "SPH-M580",
    "Model": "SPH-M580"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Replenish",
    "Device": "SPH-M580BST",
    "Model": "SPH-M580BST"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Repp",
    "Device": "SCH-R680",
    "Model": "SCH-R680"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Roy VE DTV",
    "Device": "royssvedtv",
    "Model": "GT-S6293T"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Roy VE DTV",
    "Device": "royvedtv",
    "Model": "GT-S6293T"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Rugby Smart",
    "Device": "SGH-I847",
    "Model": "SAMSUNG-SGH-I847"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "SM-G6200",
    "Device": "Phoenix",
    "Model": "SM-G6200"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "SM-G9198",
    "Device": "philippeltechn",
    "Model": "SM-G9198"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "SM-J260A",
    "Device": "j2coreplteatt",
    "Model": "SM-J260A"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "SM-J336AZ",
    "Device": "j3toplteaio",
    "Model": "SM-J336AZ"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "SM-J337A",
    "Device": "j3toplteatt",
    "Model": "SM-J337A"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "SM-J337AZ",
    "Device": "j3toplteaio",
    "Model": "SM-J337AZ"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "SM-T230NZ",
    "Device": "degasy18wifichn",
    "Model": "SM-T230NZ"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "SM-W2018",
    "Device": "kellyltechn",
    "Model": "SM-W2018"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "SM-W2018",
    "Device": "kellyltechn",
    "Model": "SM-W2018X"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Samsung Interactive Display",
    "Device": "SAMSUNG_INTERACTIVE_DISPLAY",
    "Model": "WA65D"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Samsung Interactive Display",
    "Device": "SAMSUNG_INTERACTIVE_DISPLAY",
    "Model": "WA75D"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Samsung Interactive Display",
    "Device": "SAMSUNG_INTERACTIVE_DISPLAY",
    "Model": "WA86D"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Samsung WAF",
    "Device": "SAMSUNG_INTERACTIVE_DISPLAY",
    "Model": "WAF"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Sidekick",
    "Device": "SGH-T839",
    "Model": "SGH-T839"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Transfix",
    "Device": "SCH-R730",
    "Model": "SCH-R730"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Transform",
    "Device": "SPH-M920",
    "Model": "SPH-M920"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Transform Ultra",
    "Device": "SPH-M930",
    "Model": "SPH-M930"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "Transform Ultra",
    "Device": "SPH-M930BST",
    "Model": "SPH-M930BST"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "VinsQ",
    "Device": "SPH-M910",
    "Model": "SPH-M910"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "VinsQ(M910)",
    "Device": "SPH-M910",
    "Model": "SPH-M910"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "W2016",
    "Device": "royceltectc",
    "Model": "SM-W2016"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "W2017",
    "Device": "veyronltectc",
    "Model": "SM-W2017"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "WAFX-P",
    "Device": "SAMSUNG_INTERACTIVE_DISPLAY",
    "Model": "WAFX-P"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "olleh",
    "Device": "ik1",
    "Model": "SMT-E5015"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "三星 W21 5G",
    "Device": "victory",
    "Model": "SM-W2021"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "三星W20",
    "Device": "zodiac",
    "Model": "SM-W2020"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "三星W22 5G",
    "Device": "v2q",
    "Model": "SM-W2022"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "心系天下 三星 W23",
    "Device": "v4q",
    "Model": "SM-W9023"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "心系天下 三星 W23 Flip",
    "Device": "e4q",
    "Model": "SM-W7023"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "心系天下 三星 W25",
    "Device": "q6aq",
    "Model": "SM-W9025"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "心系天下 三星 W25 Flip",
    "Device": "b6q",
    "Model": "SM-W7025"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "心系天下 三星 W26",
    "Device": "q7q",
    "Model": "SM-W9026"
  },
  {
    "Retail Branding": "Samsung",
    "Marketing Name": "领世旗舰8",
    "Device": "venenoltechn",
    "Model": "SM-G9298"
  },
  {
    "Retail Branding": "Samtech",
    "Marketing Name": "MID_M1023",
    "Device": "MID_M1023",
    "Model": "MID_M10"
  },
  {
    "Retail Branding": "Samtech",
    "Marketing Name": "MID_M1023_EEA",
    "Device": "MID_M1023_EEA",
    "Model": "MID_M10"
  },
  {
    "Retail Branding": "Samtech",
    "Marketing Name": "T3G_04",
    "Device": "T3G_04",
    "Model": "T3G_04"
  },
  {
    "Retail Branding": "Samtech",
    "Marketing Name": "TWIFI-04",
    "Device": "TWIFI-04",
    "Model": "TWIFI-04"
  },
  {
    "Retail Branding": "Samtech",
    "Marketing Name": "TWIFI-06",
    "Device": "TWIFI-06",
    "Model": "TWIFI-06"
  },
  {
    "Retail Branding": "Samtech",
    "Marketing Name": "TWIFI_07",
    "Device": "TWIFI-07",
    "Model": "TWIFI-07"
  },
  {
    "Retail Branding": "Samtech",
    "Marketing Name": "TWIFI_Q07",
    "Device": "TWIFI_Q07",
    "Model": "TWIFI_Q07"
  },
  {
    "Retail Branding": "Samview",
    "Marketing Name": "SAMVIEW",
    "Device": "hongkong",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "Sanaeko",
    "Marketing Name": "FX9",
    "Device": "SANAEKO",
    "Model": "FX9"
  },
  {
    "Retail Branding": "Sandata",
    "Marketing Name": "Sandata",
    "Device": "Sandata_T5",
    "Model": "T5"
  },
  {
    "Retail Branding": "Sandata",
    "Marketing Name": "Sandata_T5",
    "Device": "Sandata_T5",
    "Model": "T5"
  },
  {
    "Retail Branding": "Sankey",
    "Marketing Name": "TAB1012FKY",
    "Device": "TAB1012FKY",
    "Model": "TAB1012FKY"
  },
  {
    "Retail Branding": "Sankey",
    "Marketing Name": "TAB10A3G02",
    "Device": "TAB10A3G02",
    "Model": "TAB10A3G02"
  },
  {
    "Retail Branding": "Sankey",
    "Marketing Name": "TAB7A3G05",
    "Device": "TAB7A3G05",
    "Model": "TAB7A3G05"
  },
  {
    "Retail Branding": "Sankey",
    "Marketing Name": "TAB7A3G06",
    "Device": "TAB7A3G06",
    "Model": "TAB7A3G06"
  },
  {
    "Retail Branding": "Sansei",
    "Marketing Name": "TS10A1",
    "Device": "TS10A1",
    "Model": "TS10A1"
  },
  {
    "Retail Branding": "Sansei",
    "Marketing Name": "TS7A1",
    "Device": "TS7A1",
    "Model": "TS7A1"
  },
  {
    "Retail Branding": "Sansei",
    "Marketing Name": "TS7K",
    "Device": "TS7K",
    "Model": "TS7K"
  },
  {
    "Retail Branding": "Sansui",
    "Marketing Name": "AiPro2K",
    "Device": "dongnae",
    "Model": "AiPro2K"
  },
  {
    "Retail Branding": "Sansui",
    "Marketing Name": "AiPro2KN",
    "Device": "dongnae",
    "Model": "AiPro2KN"
  },
  {
    "Retail Branding": "Sansui",
    "Marketing Name": "Apollo Premium2K TV",
    "Device": "nagata",
    "Model": "Apollo Premium2K TV"
  },
  {
    "Retail Branding": "Sansui",
    "Marketing Name": "Apollo Premium4K TV",
    "Device": "marina",
    "Model": "Apollo Premium4K TV"
  },
  {
    "Retail Branding": "Sansui",
    "Marketing Name": "ETAB M9021G",
    "Device": "ETAB_M9021G",
    "Model": "ETAB_M9021G"
  },
  {
    "Retail Branding": "Sansui",
    "Marketing Name": "ETAB S7042G",
    "Device": "S7042G",
    "Model": "ETAB_S7042G"
  },
  {
    "Retail Branding": "Sansui",
    "Marketing Name": "Europe",
    "Device": "sepolia",
    "Model": "SANSUI 4K Smart TV"
  },
  {
    "Retail Branding": "Sansui",
    "Marketing Name": "Fun",
    "Device": "Sansui_Fun",
    "Model": "Sansui Fun"
  },
  {
    "Retail Branding": "Sansui",
    "Marketing Name": "Go",
    "Device": "S401",
    "Model": "Go"
  },
  {
    "Retail Branding": "Sansui",
    "Marketing Name": "Grand",
    "Device": "Grand",
    "Model": "Grand"
  },
  {
    "Retail Branding": "Sansui",
    "Marketing Name": "Israel",
    "Device": "SAN-8487",
    "Model": "SAN-8487"
  },
  {
    "Retail Branding": "Sansui",
    "Marketing Name": "Mexio",
    "Device": "yeongdeungpo",
    "Model": "AiPlus4K"
  },
  {
    "Retail Branding": "Sansui",
    "Marketing Name": "NGamer",
    "Device": "cottongreen",
    "Model": "NGamer"
  },
  {
    "Retail Branding": "Sansui",
    "Marketing Name": "Nitro",
    "Device": "Nitro",
    "Model": "Nitro"
  },
  {
    "Retail Branding": "Sansui",
    "Marketing Name": "North America",
    "Device": "sepolia",
    "Model": "AOW4KMNTV"
  },
  {
    "Retail Branding": "Sansui",
    "Marketing Name": "SANSUI 2K Smart TV",
    "Device": "dongnae",
    "Model": "SANSUI 2K Smart TV"
  },
  {
    "Retail Branding": "Sansui",
    "Marketing Name": "SANSUI 2K Smart TV",
    "Device": "dongnae",
    "Model": "SANSUI 2K Smart TV"
  },
  {
    "Retail Branding": "Sansui",
    "Marketing Name": "SANSUI SmartTV",
    "Device": "sunnyvale",
    "Model": "SANSUI SmartTV"
  },
  {
    "Retail Branding": "Sansui",
    "Marketing Name": "SANSUI TV",
    "Device": "beomil",
    "Model": "SANSUI TV"
  },
  {
    "Retail Branding": "Sansui",
    "Marketing Name": "SANSUI TV",
    "Device": "eleonas",
    "Model": "SANSUI TV"
  },
  {
    "Retail Branding": "Sansui",
    "Marketing Name": "SANSUI TV FF",
    "Device": "eleonas",
    "Model": "SANSUI TV FF"
  },
  {
    "Retail Branding": "Sansui",
    "Marketing Name": "SANSUITV UHD",
    "Device": "SW4H",
    "Model": "SANSUITV UHD"
  },
  {
    "Retail Branding": "Sansui",
    "Marketing Name": "Sansui Play",
    "Device": "Play",
    "Model": "Sansui Play"
  },
  {
    "Retail Branding": "Sansui",
    "Marketing Name": "Sansui Smart TV",
    "Device": "stanford",
    "Model": "40D"
  },
  {
    "Retail Branding": "Sansui",
    "Marketing Name": "Sansui_Nova",
    "Device": "Sansui_Nova",
    "Model": "Sansui_Nova"
  },
  {
    "Retail Branding": "Sansui",
    "Marketing Name": "Switch",
    "Device": "SansuiSwitch",
    "Model": "Sansui_Switch"
  },
  {
    "Retail Branding": "Sansui",
    "Marketing Name": "Tab 7",
    "Device": "ETAB_I7043G",
    "Model": "ETAB I7043G"
  },
  {
    "Retail Branding": "Sansui",
    "Marketing Name": "Tab 7",
    "Device": "ETAB_I7043G",
    "Model": "ETAB_I7043G"
  },
  {
    "Retail Branding": "Sansui",
    "Marketing Name": "Tab 7",
    "Device": "ETAB_I7043G_VP3",
    "Model": "ETAB_I7043G_VP3"
  },
  {
    "Retail Branding": "Sansui",
    "Marketing Name": "USA,Canada,Mexico",
    "Device": "martin",
    "Model": "AiPlus2K"
  },
  {
    "Retail Branding": "Sansui TV",
    "Marketing Name": "Canada",
    "Device": "yeongdeungpo",
    "Model": "AiPlus4K"
  },
  {
    "Retail Branding": "Sansui TV",
    "Marketing Name": "JSC43ASUHD",
    "Device": "samseong",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "Sansui TV",
    "Marketing Name": "SANSUITV",
    "Device": "shibuya",
    "Model": "SANSUITV"
  },
  {
    "Retail Branding": "Sansui TV",
    "Marketing Name": "USA",
    "Device": "yeongdeungpo",
    "Model": "AiPlus4K"
  },
  {
    "Retail Branding": "Sanyo",
    "Marketing Name": "55CE6139M1",
    "Device": "CEM1",
    "Model": "CEM1"
  },
  {
    "Retail Branding": "Sanyo",
    "Marketing Name": "Android TV",
    "Device": "R1",
    "Model": "ATV R1"
  },
  {
    "Retail Branding": "Sanyo",
    "Marketing Name": "Android TV",
    "Device": "R2",
    "Model": "ATV R2"
  },
  {
    "Retail Branding": "Sanyo",
    "Marketing Name": "Benesse",
    "Device": "31TL04",
    "Model": "31TL04"
  },
  {
    "Retail Branding": "Sanyo",
    "Marketing Name": "Benesse",
    "Device": "40TL04",
    "Model": "40TL04"
  },
  {
    "Retail Branding": "Sanyo",
    "Marketing Name": "Benesse",
    "Device": "41EA04",
    "Model": "41EA04"
  },
  {
    "Retail Branding": "Sanyo",
    "Marketing Name": "CEA1",
    "Device": "CEA1",
    "Model": "CEA1"
  },
  {
    "Retail Branding": "Sanyo",
    "Marketing Name": "CEA3",
    "Device": "CEA3",
    "Model": "CEA3"
  },
  {
    "Retail Branding": "Sanyo",
    "Marketing Name": "CEH1",
    "Device": "CEH1",
    "Model": "CEH1"
  },
  {
    "Retail Branding": "Sanyo",
    "Marketing Name": "CER2",
    "Device": "CER2",
    "Model": "CER2"
  },
  {
    "Retail Branding": "Sanyo",
    "Marketing Name": "CER3",
    "Device": "CER3",
    "Model": "CER3"
  },
  {
    "Retail Branding": "Sanyo",
    "Marketing Name": "SanyoTV",
    "Device": "shibuya",
    "Model": "SanyoTV"
  },
  {
    "Retail Branding": "Sappa",
    "Marketing Name": "Sappa TV Hub",
    "Device": "SEI904SAP",
    "Model": "Sappa TV Hub"
  },
  {
    "Retail Branding": "Sapphire",
    "Marketing Name": "Sapphire Phone",
    "Device": "Sapphire_Phone",
    "Model": "Sapphire Phone"
  },
  {
    "Retail Branding": "Sasktel",
    "Marketing Name": "HMB2213PW22WA",
    "Device": "HMB2213PW22WA",
    "Model": "HMB2213PW22WA"
  },
  {
    "Retail Branding": "Sasktel",
    "Marketing Name": "SaskTel maxTV Stream",
    "Device": "HMB2213PW22WA",
    "Model": "HMB2213PW22WA"
  },
  {
    "Retail Branding": "Sasktel",
    "Marketing Name": "maxTV Stream",
    "Device": "uiw4054sas",
    "Model": "maxTV Stream"
  },
  {
    "Retail Branding": "Satewave",
    "Marketing Name": "HPAD-IP8045",
    "Device": "HPAD-IP8045",
    "Model": "HPAD-IP8045"
  },
  {
    "Retail Branding": "Scanfrost",
    "Marketing Name": "Nigeria",
    "Device": "marina",
    "Model": "Scanfrost TV"
  },
  {
    "Retail Branding": "Scanfrost",
    "Marketing Name": "Nigeria",
    "Device": "martin",
    "Model": "Scanfrost 2K Android TV"
  },
  {
    "Retail Branding": "Scanfrost",
    "Marketing Name": "Scanfrost TV",
    "Device": "nagata",
    "Model": "Scanfrost TV"
  },
  {
    "Retail Branding": "Sceptre",
    "Marketing Name": "4K Smart TV",
    "Device": "gangbyeon",
    "Model": "4K Smart TV"
  },
  {
    "Retail Branding": "Sceptre",
    "Marketing Name": "A557CV-UMRBX",
    "Device": "barking",
    "Model": "SCEPTRE AndroidTV"
  },
  {
    "Retail Branding": "Sceptre",
    "Marketing Name": "Smart TV",
    "Device": "kanda",
    "Model": "2K Smart TV"
  },
  {
    "Retail Branding": "Schok",
    "Marketing Name": "FreedomTurboXL",
    "Device": "SFT57216",
    "Model": "FreedomTurboXL"
  },
  {
    "Retail Branding": "Schok",
    "Marketing Name": "SCHOK",
    "Device": "SM7216H",
    "Model": "SM7216H"
  },
  {
    "Retail Branding": "Schok",
    "Marketing Name": "SV10Q",
    "Device": "SV10Q",
    "Model": "Schok Volt SV10Q"
  },
  {
    "Retail Branding": "Schok",
    "Marketing Name": "SV55216",
    "Device": "SV55216",
    "Model": "Schok Volt SV55"
  },
  {
    "Retail Branding": "Schok",
    "Marketing Name": "SV55216A",
    "Device": "SV55216",
    "Model": "Schok Volt SV55"
  },
  {
    "Retail Branding": "Schok",
    "Marketing Name": "SV67Q",
    "Device": "SV67Q",
    "Model": "Schok Volt SV67Q"
  },
  {
    "Retail Branding": "Schok",
    "Marketing Name": "Schok Volt SV55U",
    "Device": "SV55U216",
    "Model": "Schok Volt SV55U"
  },
  {
    "Retail Branding": "Schok",
    "Marketing Name": "Schok Volt SV69S",
    "Device": "SV69S",
    "Model": "Schok Volt SV69S"
  },
  {
    "Retail Branding": "Schok",
    "Marketing Name": "freedom turbo",
    "Device": "SFT5216",
    "Model": "freedom turbo"
  },
  {
    "Retail Branding": "Schok",
    "Marketing Name": "freedom turbo XL",
    "Device": "freedom_turbo_XL",
    "Model": "freedom turbo XL"
  },
  {
    "Retail Branding": "Schok",
    "Marketing Name": "mini_SM7216",
    "Device": "SM7216",
    "Model": "SM7216"
  },
  {
    "Retail Branding": "Scope",
    "Marketing Name": "F503V",
    "Device": "F503V",
    "Model": "F503V"
  },
  {
    "Retail Branding": "Scope",
    "Marketing Name": "F5O3V",
    "Device": "F5O3V",
    "Model": "F503V"
  },
  {
    "Retail Branding": "Scope",
    "Marketing Name": "SP1089",
    "Device": "SP1089",
    "Model": "SP1089"
  },
  {
    "Retail Branding": "Scope",
    "Marketing Name": "SP1089X",
    "Device": "SP1089X",
    "Model": "SP1089X"
  },
  {
    "Retail Branding": "Scope",
    "Marketing Name": "SP1099A",
    "Device": "SP1099A",
    "Model": "SP1099A"
  },
  {
    "Retail Branding": "Scope",
    "Marketing Name": "SP1099R",
    "Device": "SP1099R",
    "Model": "SP1099R"
  },
  {
    "Retail Branding": "Scope",
    "Marketing Name": "SP1099V",
    "Device": "SP1099V",
    "Model": "SP1099V"
  },
  {
    "Retail Branding": "Sea Mobile",
    "Marketing Name": "S503L",
    "Device": "S503L",
    "Model": "S503L"
  },
  {
    "Retail Branding": "Seatel",
    "Marketing Name": "L4",
    "Device": "L4",
    "Model": "L4"
  },
  {
    "Retail Branding": "Seatel",
    "Marketing Name": "T8",
    "Device": "seatel_T8",
    "Model": "Seatel T8"
  },
  {
    "Retail Branding": "Seatel",
    "Marketing Name": "V8A",
    "Device": "Seatel_V8A",
    "Model": "Seatel V8A"
  },
  {
    "Retail Branding": "Seatel",
    "Marketing Name": "V8E",
    "Device": "Seatel_V8E",
    "Model": "Seatel V8E"
  },
  {
    "Retail Branding": "SecQre",
    "Marketing Name": "ATV HD Stick",
    "Device": "SEI100",
    "Model": "ATV HD Stick"
  },
  {
    "Retail Branding": "Secureye",
    "Marketing Name": "S-SAB220",
    "Device": "S-SAB220",
    "Model": "S-SAB220"
  },
  {
    "Retail Branding": "Secureye",
    "Marketing Name": "S-SAB5000",
    "Device": "S-SAB5000",
    "Model": "S-SAB5000"
  },
  {
    "Retail Branding": "Secureye",
    "Marketing Name": "SAB200_001",
    "Device": "SAB200_001",
    "Model": "SAB200_001"
  },
  {
    "Retail Branding": "Sederick",
    "Marketing Name": "KT101",
    "Device": "KT101",
    "Model": "KT101"
  },
  {
    "Retail Branding": "Seeken",
    "Marketing Name": "SG2",
    "Device": "SG2",
    "Model": "SG2"
  },
  {
    "Retail Branding": "Seeken",
    "Marketing Name": "SG3",
    "Device": "Seeken_SG3",
    "Model": "SG3"
  },
  {
    "Retail Branding": "Seeken",
    "Marketing Name": "ST-107",
    "Device": "ST-107",
    "Model": "ST-107"
  },
  {
    "Retail Branding": "Seemahale Telecoms",
    "Marketing Name": "ST5000",
    "Device": "ST5000",
    "Model": "ST5000"
  },
  {
    "Retail Branding": "Seiki",
    "Marketing Name": "North America",
    "Device": "hongik",
    "Model": "Seiki Android TV"
  },
  {
    "Retail Branding": "Seiki",
    "Marketing Name": "North America",
    "Device": "uguisudani",
    "Model": "Seiki Android TV 2K"
  },
  {
    "Retail Branding": "Seleco",
    "Marketing Name": "Seleco 2K Smart TV",
    "Device": "beaudry",
    "Model": "Seleco AndroidTV"
  },
  {
    "Retail Branding": "Seleco",
    "Marketing Name": "Seleco 4K Smart TV",
    "Device": "barking",
    "Model": "Seleco AndroidTV"
  },
  {
    "Retail Branding": "Selectron",
    "Marketing Name": "T101G",
    "Device": "T101G",
    "Model": "T101G"
  },
  {
    "Retail Branding": "Selectron",
    "Marketing Name": "T856G",
    "Device": "T856G",
    "Model": "T856G"
  },
  {
    "Retail Branding": "Selfix",
    "Marketing Name": "ES733",
    "Device": "ES733",
    "Model": "ES733"
  },
  {
    "Retail Branding": "Selfix",
    "Marketing Name": "SELFIX_ES732_EXPERIUS",
    "Device": "EXPERIUS",
    "Model": "SELFIX_ES732_EXPERIUS"
  },
  {
    "Retail Branding": "Selfix",
    "Marketing Name": "X5",
    "Device": "X5",
    "Model": "X5"
  },
  {
    "Retail Branding": "Selfix",
    "Marketing Name": "X7",
    "Device": "X7",
    "Model": "X7"
  },
  {
    "Retail Branding": "Selvas",
    "Marketing Name": "BrailleSense Polaris",
    "Device": "polaris",
    "Model": "BrailleSensePolaris"
  },
  {
    "Retail Branding": "Selvas",
    "Marketing Name": "BrailleSenseMini",
    "Device": "BrailleSenseMini",
    "Model": "H620B"
  },
  {
    "Retail Branding": "Selvas",
    "Marketing Name": "BrailleSense_EEA",
    "Device": "BrailleSense",
    "Model": "H632B"
  },
  {
    "Retail Branding": "Selvas",
    "Marketing Name": "H620B",
    "Device": "BrailleSenseMini",
    "Model": "H620B"
  },
  {
    "Retail Branding": "Selvas",
    "Marketing Name": "H632B",
    "Device": "BrailleSense",
    "Model": "H632B"
  },
  {
    "Retail Branding": "Semeakoko",
    "Marketing Name": "M_766",
    "Device": "M_766",
    "Model": "M_766"
  },
  {
    "Retail Branding": "Semeakoko",
    "Marketing Name": "S-764",
    "Device": "S-764",
    "Model": "S-764"
  },
  {
    "Retail Branding": "Semeakoko",
    "Marketing Name": "S-764-EEA",
    "Device": "S-764-EEA",
    "Model": "S-764-EEA"
  },
  {
    "Retail Branding": "Semeakoko",
    "Marketing Name": "S10A",
    "Device": "S10A",
    "Model": "S10A"
  },
  {
    "Retail Branding": "Semeakoko",
    "Marketing Name": "SS-35",
    "Device": "SS-35",
    "Model": "SS-35"
  },
  {
    "Retail Branding": "Semeakoko",
    "Marketing Name": "SS-35_EEA",
    "Device": "SS-35_EEA",
    "Model": "SS-35_EEA"
  },
  {
    "Retail Branding": "Semeakoko",
    "Marketing Name": "SS-P30",
    "Device": "SS-P30",
    "Model": "SS-P30"
  },
  {
    "Retail Branding": "Semeakoko",
    "Marketing Name": "SS-P30_EEA",
    "Device": "SS-P30_EEA",
    "Model": "SS-P30_EEA"
  },
  {
    "Retail Branding": "Semeakoko",
    "Marketing Name": "SS1010",
    "Device": "SS1010",
    "Model": "SS1010"
  },
  {
    "Retail Branding": "Semeakoko",
    "Marketing Name": "SS10A",
    "Device": "SS10A",
    "Model": "SS10A"
  },
  {
    "Retail Branding": "Semeakoko",
    "Marketing Name": "SS10A_EEA",
    "Device": "SS10A_EEA",
    "Model": "SS10A_EEA"
  },
  {
    "Retail Branding": "SenlinTech",
    "Marketing Name": "S12_Pro",
    "Device": "S12_Pro",
    "Model": "S12_Pro"
  },
  {
    "Retail Branding": "SenlinTech",
    "Marketing Name": "S12_Pro_EEA",
    "Device": "S12_Pro_EEA",
    "Model": "S12_Pro"
  },
  {
    "Retail Branding": "SenlinTech",
    "Marketing Name": "S30-Pro",
    "Device": "S30-Pro",
    "Model": "S30-Pro"
  },
  {
    "Retail Branding": "SenlinTech",
    "Marketing Name": "S30-Pro",
    "Device": "S30-Pro",
    "Model": "T50PRO"
  },
  {
    "Retail Branding": "SenlinTech",
    "Marketing Name": "pad6_EEA",
    "Device": "pad6_EEA",
    "Model": "pad6_EEA"
  },
  {
    "Retail Branding": "Senseit",
    "Marketing Name": "A109",
    "Device": "SENSEIT_A109",
    "Model": "SENSEIT_A109"
  },
  {
    "Retail Branding": "Senseit",
    "Marketing Name": "C205",
    "Device": "C205",
    "Model": "C205"
  },
  {
    "Retail Branding": "Senseit",
    "Marketing Name": "L301",
    "Device": "SENSEIT-L301",
    "Model": "SENSEIT L301"
  },
  {
    "Retail Branding": "Senseit",
    "Marketing Name": "SENSEIT T250",
    "Device": "SENSEIT_T250",
    "Model": "SENSEIT T250"
  },
  {
    "Retail Branding": "Senseit",
    "Marketing Name": "SENSEIT W289",
    "Device": "SENSEIT_W289",
    "Model": "SENSEIT W289"
  },
  {
    "Retail Branding": "Senseit",
    "Marketing Name": "SENSEIT_A247",
    "Device": "SENSEIT_A247",
    "Model": "SENSEIT A247"
  },
  {
    "Retail Branding": "Senseit",
    "Marketing Name": "Senseit N151",
    "Device": "SENSEIT_N151",
    "Model": "SENSEIT N151"
  },
  {
    "Retail Branding": "Senseit",
    "Marketing Name": "Senseit_J2",
    "Device": "Senseit",
    "Model": "Senseit_J2"
  },
  {
    "Retail Branding": "Senter",
    "Marketing Name": "S917V18",
    "Device": "bengal_515",
    "Model": "S917V18"
  },
  {
    "Retail Branding": "Senter",
    "Marketing Name": "S917V9",
    "Device": "S917V9",
    "Model": "S917V9"
  },
  {
    "Retail Branding": "Senter",
    "Marketing Name": "SD917R",
    "Device": "SD917R_Tablet",
    "Model": "SD917R"
  },
  {
    "Retail Branding": "Senwa",
    "Marketing Name": "LS5",
    "Device": "Telcel_LS5",
    "Model": "LS5"
  },
  {
    "Retail Branding": "Senwa",
    "Marketing Name": "LS5000",
    "Device": "Senwa_LS5000",
    "Model": "LS5000"
  },
  {
    "Retail Branding": "Senwa",
    "Marketing Name": "LS5018FP",
    "Device": "LS5018FP",
    "Model": "LS5018FP"
  },
  {
    "Retail Branding": "Senwa",
    "Marketing Name": "LS5518H",
    "Device": "Senwa_LS5518H",
    "Model": "LS5518H"
  },
  {
    "Retail Branding": "Senwa",
    "Marketing Name": "LS55M",
    "Device": "Senwa_LS55M",
    "Model": "LS55M"
  },
  {
    "Retail Branding": "Senwa",
    "Marketing Name": "LS5718",
    "Device": "Senwa_LS5718",
    "Model": "LS5718"
  },
  {
    "Retail Branding": "Senwa",
    "Marketing Name": "LS5U",
    "Device": "Senwa_LS5U",
    "Model": "LS5U"
  },
  {
    "Retail Branding": "Senwa",
    "Marketing Name": "S40E_Claro_CO",
    "Device": "S40E_Claro_CO",
    "Model": "S40E"
  },
  {
    "Retail Branding": "Senwa",
    "Marketing Name": "S40E_Claro_EC",
    "Device": "S40E_Claro_EC",
    "Model": "S40E"
  },
  {
    "Retail Branding": "Senwa",
    "Marketing Name": "S45",
    "Device": "Senwa_S45",
    "Model": "S45"
  },
  {
    "Retail Branding": "Senwa",
    "Marketing Name": "S50",
    "Device": "Senwa_S50",
    "Model": "S50"
  },
  {
    "Retail Branding": "Senwa",
    "Marketing Name": "Senwa_LS5018",
    "Device": "Senwa_LS5018",
    "Model": "LS5018"
  },
  {
    "Retail Branding": "Senwa",
    "Marketing Name": "Senwa_LS5018F",
    "Device": "Senwa_LS5018F",
    "Model": "LS5018F"
  },
  {
    "Retail Branding": "Senwa",
    "Marketing Name": "Senwa_S40",
    "Device": "Senwa_S40",
    "Model": "S40"
  },
  {
    "Retail Branding": "Senwa",
    "Marketing Name": "Senwa_S50V24",
    "Device": "Senwa_S50V24",
    "Model": "S50"
  },
  {
    "Retail Branding": "Senwa",
    "Marketing Name": "Senwa_S571",
    "Device": "Senwa_S571",
    "Model": "S571"
  },
  {
    "Retail Branding": "Senwa",
    "Marketing Name": "Senwa_S5_PLUS",
    "Device": "Senwa_S5_PLUS",
    "Model": "S5 PLUS"
  },
  {
    "Retail Branding": "Senwa",
    "Marketing Name": "Telcel S6000",
    "Device": "Telcel_S6000",
    "Model": "S6000"
  },
  {
    "Retail Branding": "Senwa",
    "Marketing Name": "Telcel_LS50",
    "Device": "Telcel_LS50",
    "Model": "LS50"
  },
  {
    "Retail Branding": "Senwa",
    "Marketing Name": "Telcel_LS55",
    "Device": "Telcel_LS55",
    "Model": "LS55"
  },
  {
    "Retail Branding": "Serenity",
    "Marketing Name": "BE109",
    "Device": "BE109",
    "Model": "BE109"
  },
  {
    "Retail Branding": "Serenity",
    "Marketing Name": "T1000",
    "Device": "T1000",
    "Model": "T1000"
  },
  {
    "Retail Branding": "Serenity",
    "Marketing Name": "T2000",
    "Device": "T2000",
    "Model": "T2000"
  },
  {
    "Retail Branding": "Servicom IT",
    "Marketing Name": "IT-1101S",
    "Device": "IT_1101S",
    "Model": "IT_1101S"
  },
  {
    "Retail Branding": "Servicom IT",
    "Marketing Name": "Smart Class",
    "Device": "Smart_Class",
    "Model": "Smart Class"
  },
  {
    "Retail Branding": "Servicom IT",
    "Marketing Name": "T6000",
    "Device": "T6000",
    "Model": "T6000"
  },
  {
    "Retail Branding": "Seuic",
    "Marketing Name": "AUTOID Pad Air",
    "Device": "d520",
    "Model": "AUTOID Pad Air"
  },
  {
    "Retail Branding": "Seuic",
    "Marketing Name": "AUTOID Pad Air-5G",
    "Device": "D527",
    "Model": "AUTOID Pad Air-5G"
  },
  {
    "Retail Branding": "Seuic",
    "Marketing Name": "AUTOID Q7",
    "Device": "d310m",
    "Model": "AUTOID Q7"
  },
  {
    "Retail Branding": "Seuic",
    "Marketing Name": "AUTOID Q9",
    "Device": "d550",
    "Model": "AUTOID Q9"
  },
  {
    "Retail Branding": "Seuic",
    "Marketing Name": "AUTOID10",
    "Device": "d560",
    "Model": "AUTOID10"
  },
  {
    "Retail Branding": "Seuic",
    "Marketing Name": "AUTOID11",
    "Device": "d310x",
    "Model": "AUTOID11"
  },
  {
    "Retail Branding": "Seuic",
    "Marketing Name": "AUTOID9N",
    "Device": "d500b",
    "Model": "AUTIOD9N"
  },
  {
    "Retail Branding": "Seuic",
    "Marketing Name": "AUTOID9N",
    "Device": "d500b",
    "Model": "AUTOID9N"
  },
  {
    "Retail Branding": "Seuic",
    "Marketing Name": "AUTOIDQ9",
    "Device": "D360",
    "Model": "AUTOIDQ9"
  },
  {
    "Retail Branding": "Seuic",
    "Marketing Name": "AUTOIDQ9G",
    "Device": "d550",
    "Model": "AUTOID Q9"
  },
  {
    "Retail Branding": "Seuic",
    "Marketing Name": "CRUISE1",
    "Device": "d700s",
    "Model": "CRUISE1"
  },
  {
    "Retail Branding": "Seuic",
    "Marketing Name": "CRUISE2",
    "Device": "d730",
    "Model": "CRUISE2"
  },
  {
    "Retail Branding": "Seuic",
    "Marketing Name": "CRUISE2 5G",
    "Device": "d740",
    "Model": "CRUISE2 5G"
  },
  {
    "Retail Branding": "Seuic",
    "Marketing Name": "CRUISE2 5GA",
    "Device": "d740p",
    "Model": "CRUISE2 5GA"
  },
  {
    "Retail Branding": "Seuic",
    "Marketing Name": "HHT8B",
    "Device": "hht8b",
    "Model": "HHT8B"
  },
  {
    "Retail Branding": "Shaks",
    "Marketing Name": "Gretzky",
    "Device": "TSA",
    "Model": "Shaks G1"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "",
    "Device": "SH7218T",
    "Model": "SH7218T"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "",
    "Device": "SH8268U",
    "Model": "SH8268U"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "",
    "Device": "SH8288U",
    "Model": "SH8288U"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "",
    "Device": "SH8298U",
    "Model": "SH8298U"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "",
    "Device": "msm7627_surf",
    "Model": "SH8118U"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "2T-B40BCH1; 2T-B40BCH3; 2T-B45BCH1; 2T-B45BCH3",
    "Device": "Lcd_xxsffocbc_h",
    "Model": "LCD_xxSFFOCBC_H"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "2T-BG1X",
    "Device": "ebisu",
    "Model": "AQUOS-TVX19A"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "2T-C**GF1/GF2",
    "Device": "shonandai",
    "Model": "AQUOS-2KTVJ24-2"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "2T-C12AF",
    "Device": "taurus_2tcxxaf",
    "Model": "2T-C12AF"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "2T-C12AP",
    "Device": "taurus_2tcxxap",
    "Model": "2T-C12AP"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "2T-C16AP",
    "Device": "taurus_2tcfxxap",
    "Model": "2T-C16AP"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "2T-C32ACSA, 2T-C32ACMA, 2T-C32ACTA, 2T-C32ACZA",
    "Device": "Lcd_32sfinf380a",
    "Model": "LCD_32SFINF380A"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "2T-C40ACxA; 2T-C45ACxA; 2T-C45ADxA",
    "Device": "Lcd_xxsffocca_c",
    "Model": "LCD_xxSFFOCCA_C"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "2T-C50BG1X",
    "Device": "meguro",
    "Model": "AQUOS-TVX19C"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "306SH",
    "Device": "SG306SH",
    "Model": "306SH"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "401SH",
    "Device": "SG401SH",
    "Model": "401SH"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "4T-C**AM1/AN1/AL1, 8T-C**AX1/AW1",
    "Device": "tcsu2uj",
    "Model": "AQUOS-TVJ18"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "4T-C**AM1/AN1/AL1,8T-C**AX1/AW1",
    "Device": "tcsu2uj",
    "Model": "AQUOS-TVJ18"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "4T-C**BL1/BJ1/BN1/CL1/CN1/CQ1",
    "Device": "tcmeruj",
    "Model": "AQUOS-TVJ19"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "4T-C**BN1/BL1",
    "Device": "tcmeruj",
    "Model": "AQUOS-TVJ19B"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "4T-C**BN1H/BL1H",
    "Device": "tcmeruj",
    "Model": "AQUOS-TVJ20B"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "4T-C**DL1/DJ1/DQ1/DN2",
    "Device": "tcve2uj",
    "Model": "AQUOS-TVJ21-2"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "4T-C**DS1/DN1/DP1",
    "Device": "tcvenuj",
    "Model": "AQUOS-TVJ21"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "4T-C**EN1/EQ1/ES1/EU1/EP1/FN1/FS1/FQ1",
    "Device": "tcvenruj",
    "Model": "AQUOS-4KTVJ22"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "4T-C**EN2/EL1/EJ1/EQ2/FN2/FL1/GQ3",
    "Device": "tcvenruj",
    "Model": "AQUOS-4KTVJ22-2"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "4T-C**GL1/GJ1/GJ2",
    "Device": "awaroa",
    "Model": "AQUOS-4KTVJ24-2"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "4T-C**GP1/GS1/GQ1/GN1",
    "Device": "tcmar1uj",
    "Model": "AQUOS-4KTVJ23-1"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "4T-C**GP2/GQ2/GN2",
    "Device": "tcmar1uj",
    "Model": "AQUOS-4KTVJ23-2"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "4T-C**HP1/HS1/HQ1/HV1",
    "Device": "tcmar2uj",
    "Model": "AQUOS-4KTVJ25-1"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "4T-C**HP2/HQ2/HN2",
    "Device": "tcmar2uj",
    "Model": "AQUOS-4KTVJ25-2"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "4T-C50AG1T",
    "Device": "LCD_50FOCAG1T",
    "Model": "LCD_50FOCAG1T"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "4T-C50BDXA;4T-C50BDKA;4T-C50BDMA;4T-C50BDCA;4T-C50BDZA",
    "Device": "Lcd_50sumtcca_xa",
    "Model": "LCD_50SUMTCCA_XA"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "4T-C50BJ8T",
    "Device": "gangnam",
    "Model": "TVX19B"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "4T-C50BK1X",
    "Device": "gangnam",
    "Model": "AQUOS-TVX19B"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "4T-C50BK1X",
    "Device": "jamsil",
    "Model": "AQUOS-TVX19D"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "4T-C60AL1H,4T-C70AL1H",
    "Device": "lc_xxeos5h",
    "Model": "LC-xxEOS5H"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "4T-C60AM1H,4T-C70AM1H",
    "Device": "lc_xxdem6h",
    "Model": "LC-xxDEM6H"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "4T-C60ANAA,4T-C70ANAA,4T-C60ASAA,4T-C70ASAA",
    "Device": "lcd_xxgae7a",
    "Model": "LCD-xxGAE7A"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "4T-C60BK2UD",
    "Device": "guro",
    "Model": "AQUOS-TVU19A"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "4T-C60CFZA  4T-C70CFZA 4T-C60CFMA 4T-C70CFMA 4T-C60CFKA 4T-C70CFKA 4T-C60CFXA 4T-C70CFXA 4T-C60CFCA 4T-C70CFCA",
    "Device": "lcd_xxhad5a",
    "Model": "LCD-xxHAD5A"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "507SH",
    "Device": "eve_sprout",
    "Model": "507SH"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "8T-C**BW1",
    "Device": "tcme8sj",
    "Model": "AQUOS-8KTVJ19"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "8T-C**CX1",
    "Device": "tcme8tsj",
    "Model": "AQUOS-8KTVJ20"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "8T-C**DW1/DX1",
    "Device": "tcve8sj",
    "Model": "AQUOS-8KTVJ21"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "8T-C**DW1X",
    "Device": "tcba8sx",
    "Model": "AQUOS-TVH21A"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "8T-C**DW1X/DW2X",
    "Device": "tcba8sx",
    "Model": "AQUOS-TVX21A"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "8T-CxxAXAA",
    "Device": "lcd_xxgae9a",
    "Model": "LCD-xxGAE9A"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "A01SH",
    "Device": "A01SH",
    "Model": "A01SH"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "A1",
    "Device": "TSL",
    "Model": "FS8002"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "ADS1",
    "Device": "ADS1",
    "Model": "SHARP-ADS1"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AN-NP40",
    "Device": "an_np40",
    "Model": "AN-NP40"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS 4T/8T-C**AL1X/AL2X/AX1X",
    "Device": "tcth2ux",
    "Model": "AQUOS-TVX18"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS 8T-**AX1T",
    "Device": "tcth2ut",
    "Model": "AQUOS-TVT18"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS CRYSTAL 2",
    "Device": "SG403SH",
    "Model": "403SH"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS CRYSTAL X",
    "Device": "SG402SH",
    "Model": "402SH"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS Compact SH-02H",
    "Device": "SH-02H",
    "Model": "SH-02H"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS EVER SH-02J",
    "Device": "SH-02J",
    "Model": "SH-02J"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS EVER SH-04G",
    "Device": "SH-04G",
    "Model": "SH-04G"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS K SHF31",
    "Device": "SHF31",
    "Model": "SHF31"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS K SHF32",
    "Device": "SHF32",
    "Model": "SHF32"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS K SHF33",
    "Device": "SHF33",
    "Model": "SHF33"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS L SHV37",
    "Device": "FSP_u",
    "Model": "SHV37_u"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS L2",
    "Device": "SH-L02",
    "Model": "SH-L02"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS M1",
    "Device": "MS1",
    "Model": "FS8001"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS P1",
    "Device": "P1X",
    "Model": "P1X"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS PAD  SHT22",
    "Device": "SHT22",
    "Model": "SHT22"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS PAD SH-05G",
    "Device": "SH-05G",
    "Model": "SH-05G"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS PAD SH-06F",
    "Device": "SH-06F",
    "Model": "SH-06F"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS PAD SH-08E",
    "Device": "SH-08E",
    "Model": "SH-08E"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS PAD SHT21",
    "Device": "SHT21",
    "Model": "SHT21"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS PHONE  SERIE SHL22",
    "Device": "SHL22",
    "Model": "SHL22"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS PHONE  SERIE SHL23",
    "Device": "SHL23",
    "Model": "SHL23"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS PHONE  SERIE mini SHL24",
    "Device": "SHL24",
    "Model": "SHL24"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS PHONE CL IS17SH",
    "Device": "SHI17",
    "Model": "IS17SH"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS PHONE EX SH-02F",
    "Device": "SH-02F",
    "Model": "SH-02F"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS PHONE EX SH-04E",
    "Device": "SH04E",
    "Model": "SH-04E"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS PHONE IS11SH",
    "Device": "SHI11",
    "Model": "IS11SH"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS PHONE IS12SH",
    "Device": "SHI12",
    "Model": "IS12SH"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS PHONE IS13SH",
    "Device": "SHI13",
    "Model": "IS13SH"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS PHONE IS14SH",
    "Device": "SHI14",
    "Model": "IS14SH"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS PHONE SERIE ISW16SH",
    "Device": "SHI16",
    "Model": "ISW16SH"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS PHONE SERIE SHL21",
    "Device": "SHL21",
    "Model": "SHL21"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS PHONE SH-01D",
    "Device": "SH01D",
    "Model": "SH-01D"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS PHONE SH-06D",
    "Device": "SH06D",
    "Model": "SH-06D"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS PHONE SH-12C",
    "Device": "SH12C",
    "Model": "SH-12C"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS PHONE SH90B",
    "Device": "SH90B",
    "Model": "SH90B"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS PHONE SL IS15SH",
    "Device": "SHI15",
    "Model": "IS15SH"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS PHONE SoftBank  102SH II",
    "Device": "SBM102SH2",
    "Model": "SBM102SH2"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS PHONE SoftBank 006SH",
    "Device": "SBM006SH",
    "Model": "SBM006SH"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS PHONE SoftBank 102SH",
    "Device": "SBM102SH",
    "Model": "SBM102SH"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS PHONE SoftBank 103SH",
    "Device": "SBM103SH",
    "Model": "SBM103SH"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS PHONE SoftBank 104SH",
    "Device": "SBM104SH",
    "Model": "SBM104SH"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS PHONE THE HYBRID SoftBank 007SH",
    "Device": "SBM007SH",
    "Model": "SBM007SH"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS PHONE THE HYBRID SoftBank 007SH J",
    "Device": "SBM007SHJ",
    "Model": "SBM007SHJ"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS PHONE THE HYBRID SoftBank 101SH",
    "Device": "SBM101SH",
    "Model": "SBM101SH"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS PHONE THE PREMIUM SoftBank 009SH",
    "Device": "SBM009SH",
    "Model": "SBM009SH"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS PHONE WX05SH",
    "Device": "WX05SH",
    "Model": "WX05SH"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS PHONE Xx 206SH",
    "Device": "SBM206SH",
    "Model": "SBM206SH"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS PHONE Xx 302SH",
    "Device": "SBM302SH",
    "Model": "SBM302SH"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS PHONE Xx SoftBank 106SH",
    "Device": "SBM106SH",
    "Model": "SBM106SH"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS PHONE Xx mini 303SH",
    "Device": "SBM303SH",
    "Model": "SBM303SH"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS PHONE ZETA  SH-01F",
    "Device": "SH-01F",
    "Model": "SH-01F"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS PHONE ZETA SH-02E",
    "Device": "SH02E",
    "Model": "SH-02E"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS PHONE ZETA SH-06E",
    "Device": "SH-06E",
    "Model": "SH-06E"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS PHONE ZETA SH-09D",
    "Device": "SH09D",
    "Model": "SH-09D"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS PHONE es WX04SH",
    "Device": "WX04SH",
    "Model": "WX04SH"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS PHONE f SH-13C",
    "Device": "SH13C",
    "Model": "SH-13C"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS PHONE si SH-01E",
    "Device": "SH01E",
    "Model": "SH-01E"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS PHONE si SH-07E",
    "Device": "SH-07E",
    "Model": "SH-07E"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS PHONE slider SH-02D",
    "Device": "SH02D",
    "Model": "SH-02D"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS PHONE ss 205SH",
    "Device": "SBM205SH",
    "Model": "SBM205SH"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS PHONE st SH-07D",
    "Device": "SH07D",
    "Model": "SH-07D"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS PHONE sv SH-10D",
    "Device": "SH10D",
    "Model": "SH-10D"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS R",
    "Device": "SG605SH",
    "Model": "605SH"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS R SH-03J",
    "Device": "SH-03J",
    "Model": "SH-03J"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS R SHV39",
    "Device": "HUR",
    "Model": "SHV39"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS R compact 701SH",
    "Device": "SG701SH",
    "Model": "701SH"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS R compact SH-M06",
    "Device": "SH-M06",
    "Model": "SH-M06"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS R compact SHV41",
    "Device": "JWT",
    "Model": "SHV41"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS R10",
    "Device": "Lockon",
    "Model": "A501SH"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS R10",
    "Device": "Lockon",
    "Model": "SH-M31"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS R10",
    "Device": "SH-51F",
    "Model": "SH-51F"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS R2",
    "Device": "SG706SH",
    "Model": "706SH"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS R2 SH-03K",
    "Device": "SH-03K",
    "Model": "SH-03K"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS R2 SHV42",
    "Device": "LYV",
    "Model": "SHV42"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS R2 compact (SH-M09)",
    "Device": "SH-M09",
    "Model": "SH-M09"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS R2 compact 803SH",
    "Device": "SG803SH",
    "Model": "803SH"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS R3 808SH",
    "Device": "SG808SH",
    "Model": "808SH"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS R3 SH-04L",
    "Device": "SH-04L",
    "Model": "SH-04L"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS R3 SH-R10A",
    "Device": "SH-R10",
    "Model": "SH-R10A"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS R3 SHV44",
    "Device": "NAX",
    "Model": "SHV44"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS R5G 908SH",
    "Device": "SG908SH",
    "Model": "908SH"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS R5G SH-51A",
    "Device": "SH-51A",
    "Model": "SH-51A"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS R5G SH-R50",
    "Device": "Banagher",
    "Model": "SH-R50"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS R5G SH-RM14",
    "Device": "Banagher",
    "Model": "SH-M14"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS R5G SHG01",
    "Device": "TGD",
    "Model": "SHG01"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS R6",
    "Device": "Judau",
    "Model": "A101SH"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS R6",
    "Device": "Judau",
    "Model": "SH-M22"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS R6",
    "Device": "SH-51B",
    "Model": "SH-51B"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS R7",
    "Device": "Mineva",
    "Model": "A202SH"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS R7",
    "Device": "SH-52C",
    "Model": "SH-52C"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS R8",
    "Device": "FaYuiry",
    "Model": "SH-R80"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS R8",
    "Device": "SH-52D",
    "Model": "SH-52D"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS R8 pro",
    "Device": "Kamille",
    "Model": "A301SH"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS R8 pro",
    "Device": "Kamille",
    "Model": "SH-R80P"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS R8 pro",
    "Device": "SH-51D",
    "Model": "SH-51D"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS R9",
    "Device": "Orga",
    "Model": "A401SH"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS R9",
    "Device": "Orga",
    "Model": "SH-M28"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS R9",
    "Device": "SH-51E",
    "Model": "SH-51E"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS R9 pro",
    "Device": "Mikazuki",
    "Model": "A504SH"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS R9 pro",
    "Device": "Mikazuki",
    "Model": "SH-M30"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS R9 pro",
    "Device": "SH-54E",
    "Model": "SH-54E"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS SERIE SHL25",
    "Device": "SHL25",
    "Model": "SHL25"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS SERIE SHV32",
    "Device": "SHV32",
    "Model": "SHV32"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS SERIE SHV34",
    "Device": "SHV34",
    "Model": "SHV34"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS SERIE mini SHV31",
    "Device": "SHV31",
    "Model": "SHV31"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS SERIE mini SHV33",
    "Device": "SHV33",
    "Model": "SHV33"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS SERIE mini SHV38",
    "Device": "GTQ",
    "Model": "SHV38"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS SH-M01",
    "Device": "SH-M01",
    "Model": "SH-M01"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS SH-M02",
    "Device": "SH-M02",
    "Model": "SH-M02"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS SH-M02-EVA20",
    "Device": "SH-M02-EVA20",
    "Model": "SH-M02-EVA20"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS SH-RM02",
    "Device": "SH-RM02",
    "Model": "SH-RM02"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS U SHV35",
    "Device": "SHV35",
    "Model": "SHV35"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS U SHV37",
    "Device": "FSP",
    "Model": "SHV37"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS V",
    "Device": "VGO",
    "Model": "SH-C02"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS V6 5G",
    "Device": "Levin",
    "Model": "SH-C05"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS V7 plus",
    "Device": "Model_3",
    "Model": "SH-C06"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS Xx",
    "Device": "SG404SH",
    "Model": "404SH"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS Xx 3",
    "Device": "SG506SH",
    "Model": "506SH"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS Xx 304SH",
    "Device": "SG304SH",
    "Model": "304SH"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS Xx2",
    "Device": "SG502SH",
    "Model": "502SH"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS Xx2 mini",
    "Device": "SG503SH",
    "Model": "503SH"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS Xx3 mini",
    "Device": "SG603SH",
    "Model": "603SH"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS ZETA SH-01G",
    "Device": "SH-01G",
    "Model": "SH-01G"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS ZETA SH-01H",
    "Device": "SH-01H",
    "Model": "SH-01H"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS ZETA SH-03G",
    "Device": "SH-03G",
    "Model": "SH-03G"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS ZETA SH-04F",
    "Device": "SH-04F",
    "Model": "SH-04F"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS ZETA SH-04H",
    "Device": "SH-04H",
    "Model": "SH-04H"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS ea",
    "Device": "SG606SH",
    "Model": "606SH"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS mini SH-M03",
    "Device": "SH-M03",
    "Model": "SH-M03"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS sense",
    "Device": "KXU_u",
    "Model": "SHV40_u"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS sense SH-01K",
    "Device": "SH-01K",
    "Model": "SH-01K"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS sense SHV40",
    "Device": "KXU",
    "Model": "SHV40"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS sense basic",
    "Device": "SG702SH",
    "Model": "702SH"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS sense lite (SH-M05)",
    "Device": "SH-M05",
    "Model": "SH-M05"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS sense plus (SH-M07)",
    "Device": "SH-M07",
    "Model": "SH-M07"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS sense10",
    "Device": "Lyle",
    "Model": "A505SH"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS sense10",
    "Device": "Lyle",
    "Model": "SH-M33"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS sense10",
    "Device": "SH-53F",
    "Model": "SH-53F"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS sense2",
    "Device": "MZW-u",
    "Model": "SHV43-u"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS sense2 (SH-M08)",
    "Device": "SH-M08",
    "Model": "SH-M08"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS sense2 SH-01L",
    "Device": "SH-01L",
    "Model": "SH-01L"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS sense2 SHV43",
    "Device": "MZW",
    "Model": "SHV43"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS sense3",
    "Device": "PCZ-u",
    "Model": "SHV45-u"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS sense3",
    "Device": "SH-M12",
    "Model": "SH-M12-y"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS sense3 SH-02M",
    "Device": "SH-02M",
    "Model": "SH-02M"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS sense3 SH-M12",
    "Device": "SH-M12",
    "Model": "SH-M12"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS sense3 SHV45",
    "Device": "PCZ",
    "Model": "SHV45"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS sense3 basic",
    "Device": "SG907SH",
    "Model": "907SH"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS sense3 basic",
    "Device": "VIF",
    "Model": "SHV48"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS sense3 lite",
    "Device": "SH-RM12",
    "Model": "SH-RM12"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS sense3 plus (901SH)",
    "Device": "SG901SH",
    "Model": "901SH"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS sense3 plus SH-M11",
    "Device": "SH-M11",
    "Model": "SH-M11"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS sense3 plus SH-RM11",
    "Device": "SH-RM11",
    "Model": "SH-RM11"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS sense3 plus　サウンド SHV46",
    "Device": "OBY",
    "Model": "SHV46"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS sense4 SH-41A",
    "Device": "Jerid",
    "Model": "SH-41A"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS sense4 SH-M15",
    "Device": "JeridA",
    "Model": "SH-M15"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS sense4 basic A003SH",
    "Device": "JeridB",
    "Model": "A003SH"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS sense4 lite SH-RM15",
    "Device": "JeridL",
    "Model": "SH-RM15"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS sense4 plus",
    "Device": "VG2",
    "Model": "SH-M16"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS sense4 plus",
    "Device": "VG2",
    "Model": "SH-S40P"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS sense5G",
    "Device": "SH-53A",
    "Model": "SH-53A"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS sense5G",
    "Device": "Sarah",
    "Model": "A004SH"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS sense5G",
    "Device": "Sarah",
    "Model": "A105SH"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS sense5G",
    "Device": "Sarah",
    "Model": "SH-M17"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS sense5G",
    "Device": "WJG",
    "Model": "SHG03"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS sense5G SH-S50",
    "Device": "SarahH",
    "Model": "SH-S50"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS sense6",
    "Device": "Chara",
    "Model": "SH-M19"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS sense6",
    "Device": "Chara",
    "Model": "SH-RM19"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS sense6",
    "Device": "SH-54B",
    "Model": "SH-54B"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS sense6",
    "Device": "ZMJ",
    "Model": "SHG05"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS sense6s",
    "Device": "BOL",
    "Model": "SHG07"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS sense6s",
    "Device": "Nee",
    "Model": "SH-M19s-y"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS sense6s",
    "Device": "Nee",
    "Model": "SH-RM19s"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS sense7",
    "Device": "IVR",
    "Model": "SHG10"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS sense7",
    "Device": "Rakan",
    "Model": "SH-M24"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS sense7",
    "Device": "SH-53C",
    "Model": "SH-53C"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS sense7 plus",
    "Device": "Quattro",
    "Model": "A208SH"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS sense7 plus",
    "Device": "Quattro",
    "Model": "SH-S70P"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS sense8",
    "Device": "Quess",
    "Model": "SH-M26"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS sense8",
    "Device": "SH-54D",
    "Model": "SH-54D"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS sense8",
    "Device": "XIJ",
    "Model": "SHG11"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS sense9",
    "Device": "Naze",
    "Model": "A405SH"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS sense9",
    "Device": "Naze",
    "Model": "SH-M29"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS sense9",
    "Device": "RCL",
    "Model": "RCL"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS sense9",
    "Device": "RCL",
    "Model": "SHG14"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS sense9",
    "Device": "SH-53E",
    "Model": "SD0C4"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS sense9",
    "Device": "SH-53E",
    "Model": "SH-53E"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS wish",
    "Device": "SX1",
    "Model": "A103SH"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS wish",
    "Device": "SX1",
    "Model": "A104SH"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS wish",
    "Device": "SX1",
    "Model": "SH-M20"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS wish",
    "Device": "SX1",
    "Model": "SH-WS10"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS wish",
    "Device": "YLI",
    "Model": "SHG06"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS wish2",
    "Device": "ANK",
    "Model": "SHG08"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS wish2",
    "Device": "SH-51C",
    "Model": "SH-51C"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS wish2",
    "Device": "SXI",
    "Model": "A204SH"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS wish3",
    "Device": "SH-53D",
    "Model": "SH-53D"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS wish3",
    "Device": "SX3",
    "Model": "A302SH"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS wish3",
    "Device": "SX3",
    "Model": "A302SH-s"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS wish3",
    "Device": "SX3",
    "Model": "A303SH"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS wish3",
    "Device": "SX3",
    "Model": "A303SH-y"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS wish3",
    "Device": "SX3",
    "Model": "SH-M25"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS wish4",
    "Device": "JUD",
    "Model": "SHG13"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS wish4",
    "Device": "SH-52E",
    "Model": "SD0L4"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS wish4",
    "Device": "SH-52E",
    "Model": "SH-52E"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS wish4",
    "Device": "SX4",
    "Model": "A402SH"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS wish4",
    "Device": "SX4",
    "Model": "A403SH"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS wish4",
    "Device": "SX4",
    "Model": "SH-M27"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS wish4",
    "Device": "SX4",
    "Model": "SM0L4"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS wish5",
    "Device": "SH-52F",
    "Model": "SH-52F"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS wish5",
    "Device": "SX5",
    "Model": "A502SH"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS wish5",
    "Device": "SX5",
    "Model": "SH-M32"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS wish5s",
    "Device": "SX5",
    "Model": "SH-M34"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS zero",
    "Device": "SG801SH",
    "Model": "801SH"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS zero",
    "Device": "SH-Z10",
    "Model": "SH-Z10"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS zero",
    "Device": "SH-Z10A",
    "Model": "SH-Z10A"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS zero (SH-M10)",
    "Device": "SH-M10",
    "Model": "SH-M10"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS zero2 906SH",
    "Device": "SG906SH",
    "Model": "906SH"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS zero2 SH-01M",
    "Device": "SH-01M",
    "Model": "SH-01M"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS zero2 SH-M13",
    "Device": "SH-M13",
    "Model": "SH-M13"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS zero2 SH-Z20",
    "Device": "SH-Z20",
    "Model": "SH-Z20"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS zero2 SHV47",
    "Device": "QDA",
    "Model": "SHV47"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS zero5G basic",
    "Device": "SGA002SH",
    "Model": "A002SH"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS zero5G basic DX",
    "Device": "OJ6",
    "Model": "SHG02"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS zero6",
    "Device": "Recoa",
    "Model": "A102SH"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS zero6",
    "Device": "Recoa",
    "Model": "SH-RM18"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS zero6",
    "Device": "Recoa",
    "Model": "SH-Z60"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS zero6",
    "Device": "Recoa",
    "Model": "ST0B0"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS zero6",
    "Device": "XKH",
    "Model": "SHG04"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS ケータイ SH-02L",
    "Device": "SH-02L",
    "Model": "SH-02L"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS ケータイ SH-06G",
    "Device": "SH-06G",
    "Model": "SH-06G"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS-TVL23A",
    "Device": "SW6H",
    "Model": "AQUOS-TVL23A"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS-TVL23B",
    "Device": "umeda",
    "Model": "AQUOS-TVL23B"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS-TVN23A",
    "Device": "SW6H",
    "Model": "AQUOS-TVN23A"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "AQUOS-TVX26A",
    "Device": "eleonas",
    "Model": "AQUOS-TVX26A"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "Android One S1",
    "Device": "kaleido_sprout",
    "Model": "S1"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "B10",
    "Device": "SH-A01",
    "Model": "SH-A01"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "BASIO active",
    "Device": "DQO",
    "Model": "SHG09"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "BASIO active2",
    "Device": "ZKO",
    "Model": "SHG12"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "BASIO2 SHV36",
    "Device": "SHV36",
    "Model": "SHV36"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "BG/BE",
    "Device": "ebisu",
    "Model": "AQUOS-TVX19A"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "BG/BE/CG",
    "Device": "meguro",
    "Model": "AQUOS-TVX19C"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "BJ",
    "Device": "gangnam",
    "Model": "TVX19B"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "BK/BJ/CK/CL/CJ",
    "Device": "gangnam",
    "Model": "AQUOS-TVX19B"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "BK/BJ/CK/CL/CJ",
    "Device": "jamsil",
    "Model": "AQUOS-TVX19D"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "C1",
    "Device": "MS1",
    "Model": "FS8001"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "C20",
    "Device": "VGO",
    "Model": "SH-C02"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "DJ1",
    "Device": "banqiao",
    "Model": "AQUOS-TVW21A"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "DL1X",
    "Device": "banqiao",
    "Model": "AQUOS-TVH21B"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "DL1X",
    "Device": "banqiao",
    "Model": "AQUOS-TVP21A"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "DL1X",
    "Device": "banqiao",
    "Model": "AQUOS-TVX21B"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "DM009SH",
    "Device": "DM009SH",
    "Model": "DM009SH"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "DM010SH",
    "Device": "DM010SH",
    "Model": "DM010SH"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "DM011SH",
    "Device": "DM011SH",
    "Model": "DM011SH"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "DM012SH",
    "Device": "DM012SH",
    "Model": "DM012SH"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "DM013SH",
    "Device": "DM013SH",
    "Model": "DM013SH"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "DM016SH",
    "Device": "DM016SH",
    "Model": "DM016SH"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "Disney Mobile DM014SH",
    "Device": "DM014SH",
    "Model": "DM014SH"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "Disney Mobile on docomo DM-01H",
    "Device": "DM-01H",
    "Model": "DM-01H"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "Disney Mobile on docomo DM-01J",
    "Device": "DM-01J",
    "Model": "DM-01J"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "Disney Mobile on docomo SH-02G",
    "Device": "SH-02G",
    "Model": "SH-02G"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "Disney Mobile on docomo SH-05F",
    "Device": "SH-05F",
    "Model": "SH-05F"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "Dominica",
    "Device": "sepolia",
    "Model": "Sharp 4K Google 5.0 TV"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "EB-A71GJ",
    "Device": "EB-A71GJ",
    "Model": "EB-A71GJ"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "EB-WX1GJ/EB-W51GJ",
    "Device": "Galapagos",
    "Model": "EB-W51GJ"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "EB-WX1GJ/EB-W51GJ",
    "Device": "Galapagos",
    "Model": "EB-WX1GJ"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "EG1",
    "Device": "namba",
    "Model": "AQUOS-TVH22A"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "EG1",
    "Device": "namba",
    "Model": "AQUOS-TVP22A"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "EG1",
    "Device": "namba",
    "Model": "AQUOS-TVX22A"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "EN3/EL3",
    "Device": "banqiao",
    "Model": "AQUOS-TVE21F"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "EQ3/DN5",
    "Device": "banqiao",
    "Model": "AQUOS-TVE21A"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "EU",
    "Device": "sindang",
    "Model": "AQUOS-TVE19A"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "EU",
    "Device": "sindang",
    "Model": "AQUOS-TVE19C"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "EU",
    "Device": "sindang",
    "Model": "AQUOS-TVE21A2"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "EU",
    "Device": "sindang",
    "Model": "AQUOS_TVE19A"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "Europe",
    "Device": "guandu",
    "Model": "SHARP 4K EU Android TV"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "Europe",
    "Device": "martin",
    "Model": "SHARP 2K EU Android TV"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "FK1",
    "Device": "mongkok",
    "Model": "AQUOS-TVH23C"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "FK1",
    "Device": "mongkok",
    "Model": "AQUOS-TVT23C"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "FK1",
    "Device": "mongkok",
    "Model": "AQUOS-TVX23C"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "FQ",
    "Device": "sandiego",
    "Model": "AQUOS-TVE23A"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "FS8014",
    "Device": "SE3",
    "Model": "FS8014"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "FV1",
    "Device": "sandiego",
    "Model": "AQUOS-TVT23A"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "FV1",
    "Device": "sandiego",
    "Model": "AQUOS-TVU23A"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "FV1",
    "Device": "sandiego",
    "Model": "AQUOS-TVX23A"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "GALAPAGOS SoftBank 003SH",
    "Device": "SBM003SH",
    "Model": "SBM003SH"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "GALAPAGOS SoftBank 005SH",
    "Device": "SBM005SH",
    "Model": "SBM005SH"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "HC-16TT1",
    "Device": "HCTT1",
    "Model": "HCTT1"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "HJ6000",
    "Device": "egaleo",
    "Model": "AQUOS-TVW24C"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "HL6500",
    "Device": "egaleo",
    "Model": "AQUOS-TVW24B"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "HU8500",
    "Device": "gilmore",
    "Model": "AQUOS-TVW24A"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "INFOBAR A01",
    "Device": "SHX11",
    "Model": "INFOBAR A01"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "INFOBAR C01",
    "Device": "SHX12",
    "Model": "INFOBAR C01"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "IS01",
    "Device": "SHI01",
    "Model": "IS01"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "IS03",
    "Device": "SHI03",
    "Model": "IS03"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "IS05",
    "Device": "SHI05",
    "Model": "IS05"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "LC-**UH30U",
    "Device": "sharp_2k15_us_android",
    "Model": "LC-Ux30US"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "LC-40SF466T, 2T-C45AE1T, 2T-C40AE1T",
    "Device": "Lc_40foc466t",
    "Model": "LC_40FOC466T"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "LC-42LE860H",
    "Device": "LC-42LE860H",
    "Model": "LC-42LE860H"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "LC-42LE860M",
    "Device": "LC-42LE860M",
    "Model": "LC-42LE860M"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "LC-45SF460T",
    "Device": "Lc_45foc460t",
    "Model": "LC_45FOC460T"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "LC-50LE570X",
    "Device": "LC-xxLE570X",
    "Model": "LC-xxLE570X"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "LC-50LE860H",
    "Device": "LC-50LE860H",
    "Model": "LC-50LE860H"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "LC-50LE860M",
    "Device": "LC-50LE860M",
    "Model": "LC-50LE860M"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "LC-50UE1H",
    "Device": "LC-50UE1H",
    "Model": "LC-50UE1H"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "LC-50UE1M",
    "Device": "LC-50UE1M",
    "Model": "LC-50UE1M"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "LC-55LE860H",
    "Device": "LC-55LE860H",
    "Model": "LC-55LE860H"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "LC-55LE860M",
    "Device": "LC-55LE860M",
    "Model": "LC-55LE860M"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "LC-58UE1H",
    "Device": "LC-58UE1H",
    "Model": "LC-58UE1H"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "LC-58UE1M",
    "Device": "LC-58UE1M",
    "Model": "LC-58UE1M"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "LC-A11A",
    "Device": "a11a",
    "Model": "LC-A11A"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "LC-A1H",
    "Device": "a1h",
    "Model": "LC-A1H"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "LC-LE580T",
    "Device": "lc_le580t",
    "Model": "LC-LE580T"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "LC-LE580X",
    "Device": "lc_le580x",
    "Model": "LC-LE580X"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "LC-LX565H",
    "Device": "lx565h",
    "Model": "LC-LX565H"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "LC-S3H-01",
    "Device": "lc_s3h01",
    "Model": "LC-S3H-01"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "LC-S4H/LC-S45H/LC-S50H",
    "Device": "lc_xxcae5h",
    "Model": "LC-xxCAE5H"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "LC-SU666T/LC-SU766T",
    "Device": "lc_xxbel6t",
    "Model": "LC-xxBEL6T"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "LC-U35T",
    "Device": "lc_u35t",
    "Model": "LC-U35T"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "LC-UA6800T/4T-C**AM1T",
    "Device": "lc_theut",
    "Model": "AQUOS-4KTVT17"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "LC-UA6800X",
    "Device": "lc_theux",
    "Model": "AQUOS-4KTVX17"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "LC-US5/LC-UH5/4T-C**AJ1/4T-C70AU1",
    "Device": "lc_sunuj",
    "Model": "AQUOS-4KTVJ17"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "LC-XU35T",
    "Device": "lc_xu35t",
    "Model": "LC-XU35T"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "LC-XU930X_830X",
    "Device": "lc_xu930x_830x",
    "Model": "LC-XU930X_830X"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "LC-xxUA50H,LC-xxUF50H,LC-xxUD50H",
    "Device": "lc_xxbel8h_b",
    "Model": "LC-xxBEL8H-B"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "LC-xxUD50H",
    "Device": "lc_xxbel8h_c",
    "Model": "LC-xxBEL8H-C"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "LC-xxUE630X",
    "Device": "lc_ue630x",
    "Model": "LC-UE630X"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "LC-xxUX50H",
    "Device": "lc_xxbel9h",
    "Model": "LC-xxBEL9H"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "LCD-40SF465A",
    "Device": "Lcd_40foc465a",
    "Model": "LCD_40FOC465A"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "LCD-40SF466A, LCD-40TX3000A, LCD-40MX3000A, LCD-40DS3000A, LCD-40X508A",
    "Device": "Lcd_40foc466a",
    "Model": "LCD_40FOC466A"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "LCD-40SF468A",
    "Device": "Lcd_40foc468a",
    "Model": "LCD_40FOC468A"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "LCD-40SF480A",
    "Device": "Lcd_xxsffoc480a",
    "Model": "LCD_xxSFFOC480A"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "LCD-40X418H1A, LCD-40X418H2A, LCD-40X418H3A",
    "Device": "LCD_40X418FOCH1A",
    "Model": "LCD_40X418FOCH1A"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "LCD-45SF460A",
    "Device": "Lcd_45foc46a",
    "Model": "LCD_45FOC46A"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "LCD-45SF470A",
    "Device": "cv6a648_base",
    "Model": "LCD_xxSFFOC470A"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "LCD-45SF475A",
    "Device": "Lcd_xxsffoc475a",
    "Model": "LCD_xxSFFOC475A"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "LCD-45T45A/LCD-45T46A/LCD-45T47A",
    "Device": "Lcd_foc36a",
    "Model": "LCD_FOC36A"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "LCD-45TX3000A",
    "Device": "Lcd_45foc3000a",
    "Model": "LCD_45FOC3000A"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "LCD-45X418H1A, LCD-45X418H2A, LCD-45X418H3A",
    "Device": "LCD_45X418FOCH1A",
    "Model": "LCD_45X418FOCH1A"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "LCD-45X518H1A",
    "Device": "cv6a648_base",
    "Model": "LCD-45FOC518H1A"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "LCD-50MY4000A/TX4000A/50SU470A",
    "Device": "Lcd_50foc4000a",
    "Model": "LCD_50FOC4000A"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "LCD-60SU470A",
    "Device": "cv6a648_4K_base",
    "Model": "LCD_xxSUFOC470A"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "LCD-60SU471A",
    "Device": "Lcd_xxsufoc471a",
    "Model": "LCD_xxSUFOC471A"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "LCD-60SU475A",
    "Device": "Lcd_xxsufoc475a",
    "Model": "LCD_xxSUFOC475A"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "LCD-60X518H1A",
    "Device": "cv6a648_4K_base",
    "Model": "LCD-60FOC518H1A"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "LCD-LX460A",
    "Device": "lx460a",
    "Model": "LCD-LX460A"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "LCD-LX560A",
    "Device": "lx560a",
    "Model": "LCD-LX560A"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "LCD-LX565A",
    "Device": "lx565ab",
    "Model": "LCD-LX565A-B"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "LCD-LX565A",
    "Device": "msd818sharp",
    "Model": "LCD-LX565A"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "LCD-S3A",
    "Device": "lcd_s3a01",
    "Model": "LCD-S3A-01"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "LCD-SU460A/LCD-SU465A",
    "Device": "lcd_xxcae5a_c",
    "Model": "LCD-xxCAE5A-C"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "LCD-SU560A",
    "Device": "lcd_xxcae5a",
    "Model": "LCD-xxCAE5A"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "LCD-SU870A",
    "Device": "lcd_xxbel8a_b",
    "Model": "LCD-xxBEL8A-B"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "LCD-TX5000A",
    "Device": "lcd_xxcae5a_d",
    "Model": "LCD-xxCAE5A-D"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "LCD-UF30A",
    "Device": "lcd_uf30a",
    "Model": "LCD-UF30A"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "LCD-V3A",
    "Device": "v3a",
    "Model": "LCD-V3A"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "LCD-xxBEL6A",
    "Device": "lcd_xxbel6a",
    "Model": "LCD-xxBEL6A"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "LCD-xxBEL8A",
    "Device": "lcd_xxbel8a",
    "Model": "LCD-xxBEL8A"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "LCD-xxMY8009A",
    "Device": "lcd_xxbel7a_d",
    "Model": "LCD-xxBEL7A-D"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "LCD-xxSU585A,LCD-xxSU680A",
    "Device": "lcd_xxeos5a",
    "Model": "LCD-xxEOS5A"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "LCD-xxSU670A/xxMY6100A/xxSU675A/xxSU775A/xxSU875A",
    "Device": "lcd_xxdem6a",
    "Model": "LCD-xxDEM6A"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "LCD-xxSU671A",
    "Device": "Lcd_xxsufoc5a",
    "Model": "LCD_xxSUFOC5A"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "LCD-xxSU672A",
    "Device": "Lcd_xxsufoc6a",
    "Model": "LCD_xxSUFOC6A"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "LCD-xxSU775A;LCD-xxMY7100A",
    "Device": "lcd_xxdem7a",
    "Model": "LCD-xxDEM7A"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "LCD-xxSU875A;LCD-xxSU675A;LCD-xxMY8100A",
    "Device": "lcd_xxdem8a",
    "Model": "LCD-xxDEM8A"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "LCD-xxSX970A,LCD-xxMY9100A",
    "Device": "lcd_xxdem9a",
    "Model": "LCD-xxDEM9A"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "LCD-xxX818A,LCD-xxMY818A",
    "Device": "lcd_xxdemxa",
    "Model": "LCD-xxDEMXA"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "LC_50FOC45H",
    "Device": "Lc_50foc45h",
    "Model": "LC_50FOC45H"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "LYNX 3D SH-03C",
    "Device": "SH03C",
    "Model": "SH-03C"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "LYNX SH-10B",
    "Device": "SH10B",
    "Model": "SH-10B"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "Leitz Phone 2",
    "Device": "MinevaL",
    "Model": "LP-02"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "Leitz Phone 3",
    "Device": "KamilleL",
    "Model": "LP-03"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "Leitz Phone1",
    "Device": "JudauL",
    "Model": "LP-01"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "Media Tablet",
    "Device": "EB-L76G-B",
    "Model": "EB-L76G-B"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "PANTONE 5 SoftBank 107SH",
    "Device": "SBM107SH",
    "Model": "SBM107SH"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "PANTONE 6 SoftBank 200SH",
    "Device": "SBM200SH",
    "Model": "SBM200SH"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "PN-B501/PN-B401",
    "Device": "PN_B_series",
    "Model": "PN_B_series"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "PN-B501/PN-B401",
    "Device": "PN_B_series_w",
    "Model": "PN_B_series"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "PN-L752B",
    "Device": "PN_L2B_series",
    "Model": "PN_L2B_series"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "PN-M501/PN-M401",
    "Device": "PN_M_series",
    "Model": "PN_M_series"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "PN-M501/PN-M401",
    "Device": "PN_M_series_w",
    "Model": "PN_M_series"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "PN-ZC02",
    "Device": "PN_ZC02",
    "Model": "PN-ZC02"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "PN_LB3_Sereies",
    "Device": "PN_LB3_series",
    "Model": "PN_LB3_series"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "Q-pot.Phone SH-04D",
    "Device": "SH04D",
    "Model": "SH-04D"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "R4-SH",
    "Device": "R4",
    "Model": "R4-SH"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "ROUVO V",
    "Device": "STTM21VAPP",
    "Model": "STTM21VAPP"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "RW107",
    "Device": "RW107",
    "Model": "RW107"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "RZ-E302",
    "Device": "rk3188_10P_A",
    "Model": "RZ-E302"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "RZ-H271",
    "Device": "MC2200",
    "Model": "RZ-H270"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "S3",
    "Device": "rome_sprout",
    "Model": "S3-SH"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "S5",
    "Device": "zeon_sprout",
    "Model": "S5-SH"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "S7",
    "Device": "vespa_sprout",
    "Model": "S7-SH"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "SBM204SH",
    "Device": "SBM204SH",
    "Model": "SBM204SH"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "SC-S01",
    "Device": "scallop",
    "Model": "SC-S01"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "SH-01E Vivienne Westwood",
    "Device": "SH01EVW",
    "Model": "SH-01EVW"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "SH-01F DRAGON QUEST",
    "Device": "SH-01FDQ",
    "Model": "SH-01FDQ"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "SH-03F",
    "Device": "SH03F",
    "Model": "SH-03F"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "SH-03H",
    "Device": "SH-03H",
    "Model": "SH-03H"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "SH-05E",
    "Device": "SH05E",
    "Model": "SH-05E"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "SH-06D NERV",
    "Device": "SH06DNERV",
    "Model": "SH-06DNERV"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "SH-H01",
    "Device": "VZJ",
    "Model": "SH-H01"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "SH-M04",
    "Device": "SH-M04",
    "Model": "SH-M04"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "SH-T01",
    "Device": "OG6",
    "Model": "SH-T01"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "SH-T04C",
    "Device": "ST4",
    "Model": "SH-T04C"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "SH80F",
    "Device": "SH80F",
    "Model": "SH80F"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "SH8118U",
    "Device": "msm7627",
    "Model": "SH8118U"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "SH8128U",
    "Device": "msm7627",
    "Model": "SH8128U"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "SH8188U",
    "Device": "SH8188U",
    "Model": "SH8188U"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "SH825wi",
    "Device": "SH825Wi",
    "Model": "SH825Wi"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "SHARP",
    "Device": "lavender",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "SHARP",
    "Device": "mountbaker",
    "Model": "2K SMART TV"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "SHARP",
    "Device": "stanford",
    "Model": "2K SMART TV"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "SHARP",
    "Device": "zhongshan",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "SHARP 2K SMART TV",
    "Device": "shinagawa",
    "Model": "SHARP 2K SMART TV"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "SHARP 2K Smart TV",
    "Device": "umeda",
    "Model": "SHARP 2K Smart TV"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "SHARP 2K TV",
    "Device": "dongnae",
    "Model": "SHARP 2K TV"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "SHARP 2K TV",
    "Device": "umeda",
    "Model": "SHARP 2K TV"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "SHARP 4K TV",
    "Device": "SW6H",
    "Model": "SHARP 4K TV"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "SHARP 4K TV",
    "Device": "anaheim",
    "Model": "SHARP 4K TV"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "SHARP 4K TVH",
    "Device": "anaheim",
    "Model": "SHARP 4K TVH"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "SHARP 4K TVT",
    "Device": "anaheim",
    "Model": "SHARP 4K TV"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "SHARP 4K TVT",
    "Device": "anaheim",
    "Model": "SHARP 4K TVT"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "SHARP A2 Lite",
    "Device": "SJ3",
    "Model": "FS8026"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "SHARP A2 Mini",
    "Device": "HQ3",
    "Model": "IF9009"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "SHARP AQUOS C10",
    "Device": "SH-Z01",
    "Model": "SH-Z01"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "SHARP AQUOS D10",
    "Device": "SH-D01",
    "Model": "SH-D01"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "SHARP AQUOS S2",
    "Device": "SS2",
    "Model": "FS8010"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "SHARP AQUOS S2 Plus",
    "Device": "SAT",
    "Model": "FS8008"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "SHARP AQUOS S2 Plus",
    "Device": "SAT",
    "Model": "FS8016"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "SHARP AQUOS S3",
    "Device": "HH1",
    "Model": "FS8032"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "SHARP AQUOS S3",
    "Device": "SD1",
    "Model": "FS8015"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "SHARP AQUOS V1mini",
    "Device": "SG1",
    "Model": "FS8018"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "SHARP Android TV",
    "Device": "SW4H_FF",
    "Model": "SHARP Android TV"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "SHARP FHD TV",
    "Device": "takao",
    "Model": "SHARP FHD TV"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "SHARP R1S",
    "Device": "SK3",
    "Model": "FS8028"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "SHARP TBC",
    "Device": "SI3",
    "Model": "FS8025"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "SHARP UHD TV",
    "Device": "OD0M_EA_T32",
    "Model": "SHARP UHD TV"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "Sharp",
    "Device": "bruno",
    "Model": "Sharp 2K Android TV"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "Sharp",
    "Device": "ewha",
    "Model": "AQUOS-TVE19G"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "Sharp",
    "Device": "ewha",
    "Model": "AQUOS-TVE21B"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "Sharp",
    "Device": "expo",
    "Model": "4K Sharp Google TV"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "Sharp",
    "Device": "kaitak",
    "Model": "Sharp Google TV"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "Sharp",
    "Device": "shilin",
    "Model": "Sharp 4K Android TV"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "Sharp",
    "Device": "sindang",
    "Model": "AQUOS-TVE19C"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "Sharp",
    "Device": "sindang",
    "Model": "AQUOS-TVE21C"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "Sharp 2K Google 5.0 TV",
    "Device": "dongnae",
    "Model": "Sharp 2K Google 5.0 TV"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "Sharp 2k google tv",
    "Device": "dongnae",
    "Model": "Sharp 2k google tv"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "Sharp A Click",
    "Device": "AH3",
    "Model": "IF9003"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "Sharp HH6",
    "Device": "HH6_sprout",
    "Model": "FS8032"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "Sharp Pi",
    "Device": "AG3",
    "Model": "IF9007"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "Sharp R1",
    "Device": "SE3_TH",
    "Model": "FS8014"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "Sharp R1",
    "Device": "SE3_VN",
    "Model": "FS8014"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "SoftBank 007SH KT",
    "Device": "SBM007SHK",
    "Model": "SBM007SHK"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "SoftBank 107SH B",
    "Device": "SBM107SHB",
    "Model": "SBM107SHB"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "SoftBank 305SH",
    "Device": "SG305SH",
    "Model": "305SH"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "SoftBank AQUOS PHONE Xx 203SH",
    "Device": "SBM203SH",
    "Model": "SBM203SH"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "Star Wars mobile",
    "Device": "SW001SH",
    "Model": "SW001SH"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "X1",
    "Device": "nasa_sprout",
    "Model": "X1"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "X4",
    "Device": "vespa_sprout",
    "Model": "X4-SH"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "XLED-40Z4808A",
    "Device": "Lcd_xxffoczq48a",
    "Model": "LCD_xxFFOCZQ48A"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "XLED-50SU480A",
    "Device": "Lcd_50sufoc480a",
    "Model": "LCD_50SUFOC480A"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "XLED-50SU583A",
    "Device": "Lcd_xxfoc580a2",
    "Model": "LCD_xxFOC580A2"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "XLED-50Z4808A",
    "Device": "Lcd_50ufoczq48a",
    "Model": "LCD_50UFOCZQ48A"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "XLED-60SU485A, XLED-70SU480A",
    "Device": "Lcd_60sufoc485a",
    "Model": "LCD_60SUFOC485A"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "XLED-65SU480A",
    "Device": "Lcd_xxsufoc480a",
    "Model": "LCD_xxSUFOC480A"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "XLED-65SU583A",
    "Device": "Lcd_xxfoc580a1",
    "Model": "LCD_xxFOC580A1"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "XLED-65Z4808A",
    "Device": "Lcd_xxufoczq48a",
    "Model": "LCD_xxUFOCZQ48A"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "XLED-xxSU580A, XLED-xxZQ580A, XLED-xxMY5200A, XLED-xxTX5200A",
    "Device": "lcd_xxcae5a_e",
    "Model": "LCD-xxCAE5A-E"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "XLED-xxSU680A;XLED-xxMY6200A;XLED-xxTX6200A;XLED-xxZ6808A",
    "Device": "lcd_xxdem6a_b",
    "Model": "LCD-xxDEM6A-B"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "Yahoo! Phone SoftBank 009SH Y",
    "Device": "SBM009SHY",
    "Model": "SBM009SHY"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "Z2",
    "Device": "TSP",
    "Model": "FS8002"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "Z3",
    "Device": "VN3N",
    "Model": "FS8009"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "dtab d-41A",
    "Device": "d-41A",
    "Model": "d-41A"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "dtab d-51C",
    "Device": "d-51C",
    "Model": "d-51C"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "lcd_xxbel7a_c",
    "Device": "lcd_xxbel7a_c",
    "Model": "LCD-xxBEL7A-C"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "sharp",
    "Device": "maniatika",
    "Model": "SHARP 4K UHDTV"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "z3",
    "Device": "VN3N",
    "Model": "FS8009"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "シンプルスマホ３",
    "Device": "SG509SH",
    "Model": "509SH"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "シンプルスマホ４",
    "Device": "SG704SH",
    "Model": "704SH"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "シンプルスマホ５",
    "Device": "OI6",
    "Model": "A001SH"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "シンプルスマホ６",
    "Device": "Levil",
    "Model": "A201SH"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "シンプルスマホ７",
    "Device": "Levil5",
    "Model": "A404SH"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "ロボホン",
    "Device": "SR01MW",
    "Model": "SR01MW"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "ロボホン",
    "Device": "SR02MW",
    "Model": "SR02MW"
  },
  {
    "Retail Branding": "Sharp",
    "Marketing Name": "ロボホン",
    "Device": "SRX002",
    "Model": "SRX002"
  },
  {
    "Retail Branding": "Shelby",
    "Marketing Name": "ZA555",
    "Device": "ZA555",
    "Model": "ZA555"
  },
  {
    "Retail Branding": "Shenzhen Jiuzhou",
    "Marketing Name": "DTP9503",
    "Device": "DTP9503",
    "Model": "DTP9503"
  },
  {
    "Retail Branding": "Shenzhen Jiuzhou",
    "Marketing Name": "DTP9710",
    "Device": "DTP9710",
    "Model": "DTP9710"
  },
  {
    "Retail Branding": "Shenzhen SEI Robotics",
    "Marketing Name": "4K Dongle",
    "Device": "SEID00DYT",
    "Model": "4K Dongle Research"
  },
  {
    "Retail Branding": "Shenzhen SEI Robotics",
    "Marketing Name": "ADT-2",
    "Device": "adt2",
    "Model": "ADT-2"
  },
  {
    "Retail Branding": "Shenzhen SEI Robotics",
    "Marketing Name": "AMLogic Ref",
    "Device": "planck",
    "Model": "planck"
  },
  {
    "Retail Branding": "Shenzhen SEI Robotics",
    "Marketing Name": "BOX GTD TV 4K",
    "Device": "SEI700GTD",
    "Model": "BOX GTD TV 4K"
  },
  {
    "Retail Branding": "Shenzhen SEI Robotics",
    "Marketing Name": "CNTV Plus Smart Box",
    "Device": "SEI900BUQC",
    "Model": "CNTV Plus Smart Box"
  },
  {
    "Retail Branding": "Shenzhen SEI Robotics",
    "Marketing Name": "SEI103V",
    "Device": "SEI103",
    "Model": "ANDROID TV MEDIA BOX"
  },
  {
    "Retail Branding": "Shenzhen SEI Robotics",
    "Marketing Name": "Sensa Box 4K",
    "Device": "SEI700PTS",
    "Model": "Sensa Box 4K"
  },
  {
    "Retail Branding": "Shenzhen SEI Robotics",
    "Marketing Name": "mvshub Stick",
    "Device": "SEI300DM",
    "Model": "mvshub Stick"
  },
  {
    "Retail Branding": "Shenzhen SEI Robotics",
    "Marketing Name": "primetime TV",
    "Device": "SEID00PTTV",
    "Model": "primetime TV"
  },
  {
    "Retail Branding": "Shiarffe",
    "Marketing Name": "Global",
    "Device": "t7_an400",
    "Model": "X5"
  },
  {
    "Retail Branding": "Shiarffe",
    "Marketing Name": "Smart_Board",
    "Device": "rk3588_t",
    "Model": "SKIEDLA65"
  },
  {
    "Retail Branding": "Shivaki",
    "Marketing Name": "R3_GTV",
    "Device": "R3_GTV",
    "Model": "R3G"
  },
  {
    "Retail Branding": "Shivaki",
    "Marketing Name": "R4_GTV",
    "Device": "R4_GTV",
    "Model": "R4G"
  },
  {
    "Retail Branding": "Shuodum",
    "Marketing Name": "X50_15EEA",
    "Device": "X50_15EEA",
    "Model": "X50_15EEA"
  },
  {
    "Retail Branding": "Shuodum",
    "Marketing Name": "X50_15US",
    "Device": "X50_15US",
    "Model": "X50_15US"
  },
  {
    "Retail Branding": "Shuodum",
    "Marketing Name": "X50_P80_15EEA",
    "Device": "X50_P80_15EEA",
    "Model": "X50_P80_15EEA"
  },
  {
    "Retail Branding": "Shuodum",
    "Marketing Name": "X50_P80_15US",
    "Device": "X50_P80_15US",
    "Model": "X50_P80_15US"
  },
  {
    "Retail Branding": "Shuttle",
    "Marketing Name": "PNT-7045",
    "Device": "PNT-7045",
    "Model": "PNT-7045"
  },
  {
    "Retail Branding": "SiAL",
    "Marketing Name": "Bic camera",
    "Device": "Si01BB",
    "Model": "Si01BB"
  },
  {
    "Retail Branding": "SiAL",
    "Marketing Name": "Si01BE",
    "Device": "Si01BE",
    "Model": "Si01BE"
  },
  {
    "Retail Branding": "Sico",
    "Marketing Name": "Diamond 2",
    "Device": "Diamond_2",
    "Model": "Diamond 2"
  },
  {
    "Retail Branding": "Sico",
    "Marketing Name": "Infinity",
    "Device": "Infinity",
    "Model": "Infinity"
  },
  {
    "Retail Branding": "Sico",
    "Marketing Name": "Infinity Max",
    "Device": "InfinityMax",
    "Model": "Infinity Max"
  },
  {
    "Retail Branding": "Sico",
    "Marketing Name": "Infinity_2",
    "Device": "Infinity_2",
    "Model": "Infinity 2"
  },
  {
    "Retail Branding": "Sico",
    "Marketing Name": "Infinity_2_MAX",
    "Device": "Infinity_2_MAX",
    "Model": "Infinity 2 MAX"
  },
  {
    "Retail Branding": "Sico",
    "Marketing Name": "Mega2",
    "Device": "Mega2",
    "Model": "Mega2"
  },
  {
    "Retail Branding": "Sico",
    "Marketing Name": "Mega2max",
    "Device": "Mega2max",
    "Model": "Mega2max"
  },
  {
    "Retail Branding": "Sico",
    "Marketing Name": "More_3",
    "Device": "More_3",
    "Model": "More_3"
  },
  {
    "Retail Branding": "Sico",
    "Marketing Name": "Nile X",
    "Device": "Nile_X",
    "Model": "Nile X"
  },
  {
    "Retail Branding": "Sico",
    "Marketing Name": "PLUS2",
    "Device": "Plus2",
    "Model": "Plus2"
  },
  {
    "Retail Branding": "Sico",
    "Marketing Name": "PLUS2",
    "Device": "Plus2",
    "Model": "SICO_Plus2"
  },
  {
    "Retail Branding": "Sico",
    "Marketing Name": "PLUS2 4G",
    "Device": "Plus2_4G",
    "Model": "Plus2 4G"
  },
  {
    "Retail Branding": "Sico",
    "Marketing Name": "Plus3_4G",
    "Device": "Plus3_4G",
    "Model": "Plus3_4G"
  },
  {
    "Retail Branding": "Sico",
    "Marketing Name": "SICO Mega2",
    "Device": "sp9832a_2h11",
    "Model": "Sico Mega2"
  },
  {
    "Retail Branding": "Sico",
    "Marketing Name": "Sico Express 3",
    "Device": "SICO_Express3",
    "Model": "Express3"
  },
  {
    "Retail Branding": "Sico",
    "Marketing Name": "Sico Sapphire",
    "Device": "Sapphire",
    "Model": "Sapphire"
  },
  {
    "Retail Branding": "Sico",
    "Marketing Name": "Sico Topaz",
    "Device": "Topaz",
    "Model": "SICO Topaz"
  },
  {
    "Retail Branding": "Sico SmartPhone",
    "Marketing Name": "SSR1-5-8M",
    "Device": "GBC_bravo",
    "Model": "SSR1-5-8M"
  },
  {
    "Retail Branding": "Sico SmartPhone",
    "Marketing Name": "SSR1-5-8M",
    "Device": "GBC_bravo",
    "Model": "sico pro"
  },
  {
    "Retail Branding": "Sigma Mobile",
    "Marketing Name": "Tab A1015",
    "Device": "TabA1015",
    "Model": "Tab A1015"
  },
  {
    "Retail Branding": "Sigma Mobile",
    "Marketing Name": "Tab A1020",
    "Device": "TabA1020",
    "Model": "Tab A1020"
  },
  {
    "Retail Branding": "Sigma Mobile",
    "Marketing Name": "Tab A1025 X-treme 2",
    "Device": "Tab_A1025_2",
    "Model": "Tab A1025 X-treme 2"
  },
  {
    "Retail Branding": "Sigma Mobile",
    "Marketing Name": "Tab A802",
    "Device": "Tab_A802",
    "Model": "Tab A802"
  },
  {
    "Retail Branding": "Sigma Mobile",
    "Marketing Name": "Tab_A1010_Neo",
    "Device": "Tab_A1010_Neo",
    "Model": "Tab_A1010_Neo"
  },
  {
    "Retail Branding": "Sigma Mobile",
    "Marketing Name": "Tab_A1033_X_treme",
    "Device": "Tab_A1033_X-treme",
    "Model": "Tab_A1033_X_treme"
  },
  {
    "Retail Branding": "Sigma Mobile",
    "Marketing Name": "Tab_A1033_X_treme2",
    "Device": "Tab_A1033_X_treme2",
    "Model": "Tab_A1033_X-treme2"
  },
  {
    "Retail Branding": "Sigma Mobile",
    "Marketing Name": "Tab_A1035_Basic",
    "Device": "Tab_A1035_Basic",
    "Model": "Tab_A1035_Basic"
  },
  {
    "Retail Branding": "Sigma Mobile",
    "Marketing Name": "Tab_A1035_Max",
    "Device": "Tab_A1035_Max",
    "Model": "Tab_A1035_Max"
  },
  {
    "Retail Branding": "Sigma Mobile",
    "Marketing Name": "Tab_A1035_Ultra",
    "Device": "Tab_A1035_Ultra",
    "Model": "Tab_A1035_Ultra"
  },
  {
    "Retail Branding": "Sigma Mobile",
    "Marketing Name": "X-Style S5502",
    "Device": "X-Style_S5502",
    "Model": "X-Style_S5502"
  },
  {
    "Retail Branding": "Sigma Mobile",
    "Marketing Name": "X-Style_S5501",
    "Device": "X-Style_S5501",
    "Model": "X-Style_S5501"
  },
  {
    "Retail Branding": "Sigma Mobile",
    "Marketing Name": "X-TREME PQ24",
    "Device": "X-treme_PQ24",
    "Model": "X-treme_PQ24"
  },
  {
    "Retail Branding": "Sigma Mobile",
    "Marketing Name": "X-TREME PQ28",
    "Device": "X-treme_PQ28",
    "Model": "X-treme_PQ28"
  },
  {
    "Retail Branding": "Sigma Mobile",
    "Marketing Name": "X-TREME PQ37",
    "Device": "X-TREME_PQ37",
    "Model": "X-TREME_PQ37"
  },
  {
    "Retail Branding": "Sigma Mobile",
    "Marketing Name": "X-TREME PQ39",
    "Device": "X_TREME_PQ39",
    "Model": "X-TREME PQ39"
  },
  {
    "Retail Branding": "Sigma Mobile",
    "Marketing Name": "X-TREME PQ52",
    "Device": "X-TREME_PQ52",
    "Model": "X-TREME PQ52"
  },
  {
    "Retail Branding": "Sigma Mobile",
    "Marketing Name": "X-Treme_PQ51",
    "Device": "X-Treme_PQ51",
    "Model": "X-Treme_PQ51"
  },
  {
    "Retail Branding": "Sigma Mobile",
    "Marketing Name": "X-treme PQ18 MAX",
    "Device": "PQ18_MAX",
    "Model": "X-treme_PQ18_MAX"
  },
  {
    "Retail Branding": "Sigma Mobile",
    "Marketing Name": "X-treme PQ20",
    "Device": "X-treme_PQ20",
    "Model": "X-treme_PQ20"
  },
  {
    "Retail Branding": "Sigma Mobile",
    "Marketing Name": "X-treme PQ29",
    "Device": "X-treme_PQ29",
    "Model": "X-treme_PQ29"
  },
  {
    "Retail Branding": "Sigma Mobile",
    "Marketing Name": "X-treme PQ36",
    "Device": "X-treme_PQ36",
    "Model": "X-treme_PQ36"
  },
  {
    "Retail Branding": "Sigma Mobile",
    "Marketing Name": "X-treme PQ38",
    "Device": "X_treme_PQ38",
    "Model": "X-TREME_PQ38"
  },
  {
    "Retail Branding": "Sigma Mobile",
    "Marketing Name": "X-treme PQ53",
    "Device": "X-treme_PQ53",
    "Model": "X-treme PQ53"
  },
  {
    "Retail Branding": "Sigma Mobile",
    "Marketing Name": "X-treme PQ54",
    "Device": "X-treme_PQ54",
    "Model": "X-treme_PQ54"
  },
  {
    "Retail Branding": "Sigma Mobile",
    "Marketing Name": "X-treme PQ57",
    "Device": "X-treme_PQ57",
    "Model": "X-treme PQ57"
  },
  {
    "Retail Branding": "Sigma Mobile",
    "Marketing Name": "X-treme PQ58",
    "Device": "X-treme_PQ58",
    "Model": "X-treme PQ58"
  },
  {
    "Retail Branding": "Sigma Mobile",
    "Marketing Name": "X-treme_PQ18",
    "Device": "X-treme_PQ18",
    "Model": "X-treme_PQ18"
  },
  {
    "Retail Branding": "Sigma Mobile",
    "Marketing Name": "X-treme_PQ54 MAX",
    "Device": "X-treme_PQ54_MAX",
    "Model": "X-treme_PQ54 MAX"
  },
  {
    "Retail Branding": "Sigma Mobile",
    "Marketing Name": "X-treme_PQ55",
    "Device": "X-treme_PQ55",
    "Model": "X-treme PQ55"
  },
  {
    "Retail Branding": "Sigma Mobile",
    "Marketing Name": "X-treme_PQ56",
    "Device": "X_treme_PQ56",
    "Model": "X-treme_PQ56"
  },
  {
    "Retail Branding": "Sigma Mobile",
    "Marketing Name": "X_Style_Tab_A103",
    "Device": "X_Style_Tab_A103",
    "Model": "X_Style_Tab_A103"
  },
  {
    "Retail Branding": "Sigma Mobile",
    "Marketing Name": "X_Style_Tab_A104",
    "Device": "X_Style_Tab_A104",
    "Model": "X_Style_Tab_A104"
  },
  {
    "Retail Branding": "Sigma Mobile",
    "Marketing Name": "X_style_Tab_A1010",
    "Device": "X_style_Tab_A1010",
    "Model": "X_style_Tab_A1010"
  },
  {
    "Retail Branding": "Sigma Mobile",
    "Marketing Name": "X_style_Tab_A801",
    "Device": "X_style_Tab_A801",
    "Model": "X_style_Tab_A801"
  },
  {
    "Retail Branding": "Sigma Mobile",
    "Marketing Name": "X_style_Tab_A83",
    "Device": "X_style_Tab_A83",
    "Model": "X_style_Tab_A83"
  },
  {
    "Retail Branding": "Silent Circle",
    "Marketing Name": "Blackphone 2",
    "Device": "BP2",
    "Model": "Blackphone 2"
  },
  {
    "Retail Branding": "Silo",
    "Marketing Name": "SILO",
    "Device": "elliniko",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "Silo",
    "Marketing Name": "SILO",
    "Device": "hongkong",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "Silo",
    "Marketing Name": "SILO",
    "Device": "khardi",
    "Model": "SILO GOOGLE TV 4K"
  },
  {
    "Retail Branding": "Silo",
    "Marketing Name": "SILO",
    "Device": "mountbaker",
    "Model": "2K SMART TV"
  },
  {
    "Retail Branding": "Silver line",
    "Marketing Name": "SL1021",
    "Device": "SL1021",
    "Model": "SL1021"
  },
  {
    "Retail Branding": "Silver line",
    "Marketing Name": "SL1022",
    "Device": "SL1022",
    "Model": "SL1022"
  },
  {
    "Retail Branding": "Silver line",
    "Marketing Name": "SL1046",
    "Device": "SL1046",
    "Model": "SL1046"
  },
  {
    "Retail Branding": "Silver line",
    "Marketing Name": "SL1068",
    "Device": "SL1068",
    "Model": "SL1068"
  },
  {
    "Retail Branding": "Silver line",
    "Marketing Name": "SL1069",
    "Device": "SL1069",
    "Model": "SL1069"
  },
  {
    "Retail Branding": "Silver line",
    "Marketing Name": "SL721",
    "Device": "SL721",
    "Model": "SL721"
  },
  {
    "Retail Branding": "Silver line",
    "Marketing Name": "SL729",
    "Device": "SL729",
    "Model": "SL729"
  },
  {
    "Retail Branding": "Silver line",
    "Marketing Name": "SL868G",
    "Device": "SL868G",
    "Model": "SL868G"
  },
  {
    "Retail Branding": "Silver line",
    "Marketing Name": "Silver S45",
    "Device": "Silver_S45",
    "Model": "Silver_S45"
  },
  {
    "Retail Branding": "Simbans",
    "Marketing Name": "Excello",
    "Device": "ExcelloTab",
    "Model": "ExcelloTab"
  },
  {
    "Retail Branding": "Simbans",
    "Marketing Name": "PICASSOTABX14",
    "Device": "PICASSOTABX14",
    "Model": "PICASSOTABX14"
  },
  {
    "Retail Branding": "Simbans",
    "Marketing Name": "PicassoTab",
    "Device": "PicassoTab",
    "Model": "PicassoTab"
  },
  {
    "Retail Branding": "Simbans",
    "Marketing Name": "PicassoTab8s",
    "Device": "PicassoTab8s",
    "Model": "PicassoTab8s"
  },
  {
    "Retail Branding": "Simbans",
    "Marketing Name": "PicassoTab_9",
    "Device": "PicassoTab_9",
    "Model": "PicassoTab_9"
  },
  {
    "Retail Branding": "Simbans",
    "Marketing Name": "PicassoTab_A12",
    "Device": "PicassoTab_A12",
    "Model": "PicassoTab_A12"
  },
  {
    "Retail Branding": "Simbans",
    "Marketing Name": "PicassoTab_X",
    "Device": "PicassoTab_X",
    "Model": "PicassoTab_X"
  },
  {
    "Retail Branding": "Simbans",
    "Marketing Name": "PicassoTab_X12",
    "Device": "PicassoTab_X12",
    "Model": "PicassoTab_X"
  },
  {
    "Retail Branding": "Simbans",
    "Marketing Name": "PicassoTab_XL",
    "Device": "PicassoTab_XL",
    "Model": "PicassoTab_XL"
  },
  {
    "Retail Branding": "Simbans",
    "Marketing Name": "RestoTab",
    "Device": "RestoTab",
    "Model": "RestoTab"
  },
  {
    "Retail Branding": "Simbans",
    "Marketing Name": "TANGO",
    "Device": "TangoTab_9",
    "Model": "TangoTab_9"
  },
  {
    "Retail Branding": "Simbans",
    "Marketing Name": "TangoTab",
    "Device": "TangoTab",
    "Model": "TangoTab"
  },
  {
    "Retail Branding": "Simbans",
    "Marketing Name": "TangoTab8",
    "Device": "TangoTab8",
    "Model": "TangoTab8"
  },
  {
    "Retail Branding": "Simbans",
    "Marketing Name": "TangoTab_364",
    "Device": "TangoTab_364",
    "Model": "TangoTab_364"
  },
  {
    "Retail Branding": "Simbans",
    "Marketing Name": "TangoTab_X",
    "Device": "TangoTab_X",
    "Model": "TangoTab_X"
  },
  {
    "Retail Branding": "Simbans",
    "Marketing Name": "TangoTab_XL",
    "Device": "TangoTab_XL",
    "Model": "TangoTab_XL"
  },
  {
    "Retail Branding": "SimiMobile",
    "Marketing Name": "G507",
    "Device": "G507",
    "Model": "G507"
  },
  {
    "Retail Branding": "SimiMobile",
    "Marketing Name": "Hot1-z",
    "Device": "Hot1-z",
    "Model": "Hot1-z"
  },
  {
    "Retail Branding": "SimiMobile",
    "Marketing Name": "Mecha",
    "Device": "Mecha",
    "Model": "Mecha"
  },
  {
    "Retail Branding": "SimiMobile",
    "Marketing Name": "S10Y",
    "Device": "S10Y",
    "Model": "S10Y"
  },
  {
    "Retail Branding": "SimiMobile",
    "Marketing Name": "S501",
    "Device": "S501",
    "Model": "S501"
  },
  {
    "Retail Branding": "SimiMobile",
    "Marketing Name": "S501plus",
    "Device": "S501plus-Z",
    "Model": "S501plus-Z"
  },
  {
    "Retail Branding": "SimiMobile",
    "Marketing Name": "S502",
    "Device": "S502",
    "Model": "S502"
  },
  {
    "Retail Branding": "SimiMobile",
    "Marketing Name": "S507",
    "Device": "S507",
    "Model": "S507"
  },
  {
    "Retail Branding": "SimiMobile",
    "Marketing Name": "S630",
    "Device": "S630",
    "Model": "S630"
  },
  {
    "Retail Branding": "SimiMobile",
    "Marketing Name": "S630M",
    "Device": "S630M",
    "Model": "S630M"
  },
  {
    "Retail Branding": "SimiMobile",
    "Marketing Name": "S8001",
    "Device": "S8001",
    "Model": "S8001"
  },
  {
    "Retail Branding": "Simplytab",
    "Marketing Name": "S-101TAB",
    "Device": "S-101TAB",
    "Model": "S-101TAB"
  },
  {
    "Retail Branding": "Singer",
    "Marketing Name": "Android TV",
    "Device": "R1",
    "Model": "ATV R1"
  },
  {
    "Retail Branding": "Singer",
    "Marketing Name": "Android TV",
    "Device": "R2",
    "Model": "ATV R2"
  },
  {
    "Retail Branding": "Singer",
    "Marketing Name": "R3",
    "Device": "R3",
    "Model": "R3"
  },
  {
    "Retail Branding": "Singer",
    "Marketing Name": "R3_GTV",
    "Device": "R3_GTV",
    "Model": "R3G"
  },
  {
    "Retail Branding": "Singer",
    "Marketing Name": "R4",
    "Device": "R4",
    "Model": "R4"
  },
  {
    "Retail Branding": "Singer",
    "Marketing Name": "R4_GTV",
    "Device": "R4_GTV",
    "Model": "R4G"
  },
  {
    "Retail Branding": "Singer",
    "Marketing Name": "SINGER ANDROID TV",
    "Device": "sunnyvale",
    "Model": "SINGER ANDROID TV"
  },
  {
    "Retail Branding": "Singer",
    "Marketing Name": "SINGER BD SMART TV",
    "Device": "SW4H_FF",
    "Model": "SINGER BD SMART TV"
  },
  {
    "Retail Branding": "Singer",
    "Marketing Name": "SINGER SL SMART TV",
    "Device": "SW4H",
    "Model": "SINGER SL SMART TV"
  },
  {
    "Retail Branding": "Singer",
    "Marketing Name": "Singer 4K GSMART TV",
    "Device": "SW6H",
    "Model": "Singer 4K GSMART TV"
  },
  {
    "Retail Branding": "Singer",
    "Marketing Name": "Singer 4K GSMART TV FF",
    "Device": "anaheim",
    "Model": "Singer 4K GSMART TV FF"
  },
  {
    "Retail Branding": "Singer",
    "Marketing Name": "Singer Android TV",
    "Device": "kunyang",
    "Model": "Singer Android UHD TV"
  },
  {
    "Retail Branding": "Singer",
    "Marketing Name": "SingerTV",
    "Device": "shibuya",
    "Model": "SingerTV"
  },
  {
    "Retail Branding": "Singer",
    "Marketing Name": "Smart TV",
    "Device": "longshan",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "Singer",
    "Marketing Name": "Smart TV",
    "Device": "redwood",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "Singtech",
    "Marketing Name": "H1s",
    "Device": "H1s",
    "Model": "H1s"
  },
  {
    "Retail Branding": "Singtech",
    "Marketing Name": "H2",
    "Device": "Singtech_H2",
    "Model": "H2"
  },
  {
    "Retail Branding": "Singtech",
    "Marketing Name": "Infinity_I1",
    "Device": "Infinity_I1",
    "Model": "Infinity_I1"
  },
  {
    "Retail Branding": "Singtech",
    "Marketing Name": "Infinity_I_Mix",
    "Device": "Infinity_I_Mix",
    "Model": "Infinity_I_Mix"
  },
  {
    "Retail Branding": "Singtech",
    "Marketing Name": "Q3",
    "Device": "Q3",
    "Model": "Q3"
  },
  {
    "Retail Branding": "Singtech",
    "Marketing Name": "Q7",
    "Device": "Q7",
    "Model": "Q7"
  },
  {
    "Retail Branding": "Singtech",
    "Marketing Name": "S2 Pro",
    "Device": "S2_Pro",
    "Model": "S2 Pro"
  },
  {
    "Retail Branding": "Singtech",
    "Marketing Name": "SAPPHIRE H51",
    "Device": "H51",
    "Model": "H51"
  },
  {
    "Retail Branding": "Singtech",
    "Marketing Name": "Z500",
    "Device": "Z500",
    "Model": "Z500"
  },
  {
    "Retail Branding": "Singtech",
    "Marketing Name": "i-Tab Mini 3",
    "Device": "iTab",
    "Model": "i-Tab Mini 3"
  },
  {
    "Retail Branding": "Singtel TV",
    "Marketing Name": "VIP7702",
    "Device": "f561",
    "Model": "VIP7702"
  },
  {
    "Retail Branding": "SinoGNSS",
    "Marketing Name": "R60 Data Collector",
    "Device": "R60",
    "Model": "R60"
  },
  {
    "Retail Branding": "Sintel",
    "Marketing Name": "SINTEL-X1",
    "Device": "SINTEL_X1",
    "Model": "SINTEL-X1"
  },
  {
    "Retail Branding": "Siragon",
    "Marketing Name": "R3_GTV",
    "Device": "R3_GTV",
    "Model": "R3G"
  },
  {
    "Retail Branding": "Siragon",
    "Marketing Name": "R4_GTV",
    "Device": "R4_GTV",
    "Model": "R4G"
  },
  {
    "Retail Branding": "Siragon",
    "Marketing Name": "SA",
    "Device": "zhongshan",
    "Model": "SMART TV"
  },
  {
    "Retail Branding": "Siragon",
    "Marketing Name": "SIRAGON",
    "Device": "elliniko",
    "Model": "SIRAGON 4K SMART TV"
  },
  {
    "Retail Branding": "Siragon",
    "Marketing Name": "SIRAGON",
    "Device": "jagalchi",
    "Model": "2K SMART TV"
  },
  {
    "Retail Branding": "Siragon",
    "Marketing Name": "SIRAGON",
    "Device": "lavender",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "Siragon",
    "Marketing Name": "SIRAGON",
    "Device": "stanford",
    "Model": "SMART TV"
  },
  {
    "Retail Branding": "Siragon",
    "Marketing Name": "SP 6200",
    "Device": "SP-6200",
    "Model": "SP-6200"
  },
  {
    "Retail Branding": "Siragon",
    "Marketing Name": "SP-5000",
    "Device": "SP-5000",
    "Model": "Siragon SP-5000"
  },
  {
    "Retail Branding": "Siragon",
    "Marketing Name": "SP-5250",
    "Device": "SP-5250",
    "Model": "SP-5250"
  },
  {
    "Retail Branding": "Siragon",
    "Marketing Name": "SP-5300",
    "Device": "SP-5300",
    "Model": "SP-5300"
  },
  {
    "Retail Branding": "Siragon",
    "Marketing Name": "SP-5400",
    "Device": "SP-5400",
    "Model": "SP-5400"
  },
  {
    "Retail Branding": "Siragon",
    "Marketing Name": "SP-5450",
    "Device": "SP-5450",
    "Model": "SP-5450"
  },
  {
    "Retail Branding": "Siragon",
    "Marketing Name": "SP-6000",
    "Device": "SP-6000",
    "Model": "SP-6000"
  },
  {
    "Retail Branding": "Siragon",
    "Marketing Name": "SP-6100",
    "Device": "SP-6100",
    "Model": "SP-6100"
  },
  {
    "Retail Branding": "Siragon",
    "Marketing Name": "SP-6150",
    "Device": "SP-6150",
    "Model": "SP-6150"
  },
  {
    "Retail Branding": "Siragon",
    "Marketing Name": "SP-7050",
    "Device": "SP-7050",
    "Model": "SP-7050"
  },
  {
    "Retail Branding": "Siragon",
    "Marketing Name": "SP-7100",
    "Device": "SP-7100",
    "Model": "SP-7100"
  },
  {
    "Retail Branding": "Siragon",
    "Marketing Name": "SP_7250",
    "Device": "SP_7250",
    "Model": "SP_7250"
  },
  {
    "Retail Branding": "Siragon",
    "Marketing Name": "SP_7260",
    "Device": "SP_7260",
    "Model": "SP_7260"
  },
  {
    "Retail Branding": "Siragon",
    "Marketing Name": "SP_7275",
    "Device": "SP_7275",
    "Model": "SP_7275"
  },
  {
    "Retail Branding": "Siragon",
    "Marketing Name": "Siragon",
    "Device": "elliniko",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "Siragon",
    "Marketing Name": "Siragon",
    "Device": "hongkong",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "Siragon",
    "Marketing Name": "Siragon",
    "Device": "khardi",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "Siragon",
    "Marketing Name": "Siragon",
    "Device": "mountbaker",
    "Model": "2K SMART TV"
  },
  {
    "Retail Branding": "Siragon",
    "Marketing Name": "Siragon SP_6300",
    "Device": "SP_6300",
    "Model": "SP_6300"
  },
  {
    "Retail Branding": "Siragon",
    "Marketing Name": "Siragon_SP_7200",
    "Device": "Siragon_SP_7200",
    "Model": "Siragon_SP_7200"
  },
  {
    "Retail Branding": "Siragon",
    "Marketing Name": "Siragon_SP_7300",
    "Device": "Siragon_SP_7300",
    "Model": "SP_7300"
  },
  {
    "Retail Branding": "Siragon",
    "Marketing Name": "TB-5300",
    "Device": "TB-5300",
    "Model": "TB-5300"
  },
  {
    "Retail Branding": "Siragon",
    "Marketing Name": "TB_5400",
    "Device": "TB_5400",
    "Model": "TB_5400"
  },
  {
    "Retail Branding": "Siragon",
    "Marketing Name": "TB_7400",
    "Device": "TB_7400",
    "Model": "TB_7400"
  },
  {
    "Retail Branding": "Sirin",
    "Marketing Name": "FINNEY PHONE",
    "Device": "SR00300-W",
    "Model": "FINNEY U1"
  },
  {
    "Retail Branding": "Sirin",
    "Marketing Name": "LABS SOLARIN",
    "Device": "solarin",
    "Model": "SOLARIN"
  },
  {
    "Retail Branding": "Sirin",
    "Marketing Name": "LABS SOLARIN",
    "Device": "solarin",
    "Model": "Solarin"
  },
  {
    "Retail Branding": "Siyata",
    "Marketing Name": "SD7_Ultra_S",
    "Device": "SD7_Ultra_S",
    "Model": "Calgary"
  },
  {
    "Retail Branding": "Sky (CH)",
    "Marketing Name": "Elite A6",
    "Device": "Elite_A6",
    "Model": "Elite A6"
  },
  {
    "Retail Branding": "Sky (CH)",
    "Marketing Name": "Elite C55",
    "Device": "Elite_C55USA",
    "Model": "Elite C55"
  },
  {
    "Retail Branding": "Sky (CH)",
    "Marketing Name": "Elite N55Max",
    "Device": "Elite_N55Max",
    "Model": "Elite N55Max"
  },
  {
    "Retail Branding": "Sky (CH)",
    "Marketing Name": "Elite OctaPLus",
    "Device": "Elite_Octa_Plus",
    "Model": "Elite OctaPLus"
  },
  {
    "Retail Branding": "Sky (CH)",
    "Marketing Name": "Elite OctaPlus",
    "Device": "Elite_OctaPlus4us",
    "Model": "Elite OctaPlus"
  },
  {
    "Retail Branding": "Sky (CH)",
    "Marketing Name": "Elite OctaPlus",
    "Device": "Elite_OctaPlusKK1",
    "Model": "Elite OctaPlus"
  },
  {
    "Retail Branding": "Sky (CH)",
    "Marketing Name": "Elite OctaX",
    "Device": "Elite_OctaXkk3",
    "Model": "Elite OctaX"
  },
  {
    "Retail Branding": "Sky (CH)",
    "Marketing Name": "Elite T8",
    "Device": "ELITE_US_T8",
    "Model": "ELITE T8"
  },
  {
    "Retail Branding": "Sky (CH)",
    "Marketing Name": "Platinum_B7",
    "Device": "Platinum_B7",
    "Model": "Platinum B7"
  },
  {
    "Retail Branding": "Sky (CH)",
    "Marketing Name": "SKY_KIDsPro",
    "Device": "SKY_KIDsPro",
    "Model": "SKY_KIDsPro"
  },
  {
    "Retail Branding": "Sky (CH)",
    "Marketing Name": "SKY_PAD10Max",
    "Device": "SKY_PAD10Maxk3",
    "Model": "SKY PAD10Max"
  },
  {
    "Retail Branding": "Sky (CH)",
    "Marketing Name": "SKY_PAD8PROUS",
    "Device": "SKY_PAD8PROUS",
    "Model": "SKY PAD8PRO"
  },
  {
    "Retail Branding": "Sky (CH)",
    "Marketing Name": "Sky TV Stick",
    "Device": "DV6067Y_SKY",
    "Model": "Sky TV Stick"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "ASSIST 55",
    "Device": "ASSIST_55",
    "Model": "Elite_B55"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "ELIBI_55",
    "Device": "ELIBI_55",
    "Model": "Elite H55"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "ELITE 4.0S",
    "Device": "Elite_4_0S_GT_Tigo",
    "Model": "Elite_4.0S"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "ELITE 4.0S",
    "Device": "Elite_4_0S_HN_Tigo",
    "Model": "Elite_4.0S"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "ELITE 45T",
    "Device": "Elite_45T_GT",
    "Model": "Elite 45T"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "ELITE 4T",
    "Device": "Elite_4T_GT",
    "Model": "Elite 4T"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "ELITE 4T",
    "Device": "Elite_4T_HN",
    "Model": "Elite 4T"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "ELITE 5.0T",
    "Device": "Elite_5_0T",
    "Model": "Elite_5_0T"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "ELITE 5T",
    "Device": "Elite_5T_GT",
    "Model": "Elite 5T"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "ELITE 5T",
    "Device": "Elite_5T_SV",
    "Model": "Elite 5T"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "ELITE P55",
    "Device": "ELITE_P55LIFE",
    "Model": "Elite P55"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "ELITE T57",
    "Device": "Elite_T57_GT",
    "Model": "Elite T57"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "ELITE T8",
    "Device": "ELITE_US_T8",
    "Model": "ELITE T8"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "ELITE_P55Max",
    "Device": "ELITE_P55Max",
    "Model": "Elite P55Max"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "ELITE_P55US",
    "Device": "ELITE_P55US",
    "Model": "Elite P55"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "Elite 45T",
    "Device": "Elite_45SM",
    "Model": "Elite 45T"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "Elite 45T",
    "Device": "Elite_45T",
    "Model": "Elite 45T"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "Elite 5T",
    "Device": "Elite_5T_GT",
    "Model": "Elite 5T"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "Elite 63Pro",
    "Device": "Elite_63Pro",
    "Model": "Elite 63Pro"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "Elite 65Pro",
    "Device": "Elite65_Pro",
    "Model": "Elite 65Pro"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "Elite 65Pro",
    "Device": "Elite_65Pro",
    "Model": "Elite 65Pro"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "Elite 65Pro",
    "Device": "Elite_65_Pro",
    "Model": "Elite 65Pro"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "Elite 6Max",
    "Device": "Elite_6Max",
    "Model": "Elite 6Max"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "Elite A5",
    "Device": "BITA_5",
    "Model": "Elite A5"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "Elite A5",
    "Device": "Elite_A5",
    "Model": "Elite A5"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "Elite A5",
    "Device": "Elite_AMS",
    "Model": "Elite A5"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "Elite A55",
    "Device": "Elite_A55",
    "Model": "Elite_A55"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "Elite A55Max",
    "Device": "Elite_A55Max",
    "Model": "Elite A55Max"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "Elite A6",
    "Device": "Elite_A6",
    "Model": "Elite A6"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "Elite A63",
    "Device": "Elite_A63",
    "Model": "Elite A63"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "Elite A63Max",
    "Device": "Elite_A63B_Max_B",
    "Model": "Elite A63Max"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "Elite A63Max",
    "Device": "Elite_A63CMaxC",
    "Model": "Elite A63Max"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "Elite A63Max",
    "Device": "Elite_A63MUS",
    "Model": "Elite A63Max"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "Elite A63Max",
    "Device": "Elite_A63_A_MaxA",
    "Model": "Elite A63Max"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "Elite A63Max",
    "Device": "Elite_A63_D_Max_D",
    "Model": "Elite A63Max"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "Elite A63Mxca",
    "Device": "Elite_A63Mxca",
    "Model": "Elite A63Mxca"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "Elite B5",
    "Device": "Elite_B5",
    "Model": "Elite_B5"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "Elite B55",
    "Device": "Elite_B55",
    "Model": "Elite_B55"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "Elite B65",
    "Device": "Elite_B65",
    "Model": "Elite B65"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "Elite C5",
    "Device": "Elite_C5",
    "Model": "Elite C5"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "Elite C5",
    "Device": "Elite_C5MS",
    "Model": "Elite C5"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "Elite C55",
    "Device": "Elite_C55",
    "Model": "Elite C55"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "Elite C55",
    "Device": "Elite_C55US",
    "Model": "Elite C55"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "Elite C63",
    "Device": "Elite_C63",
    "Model": "Elite C63"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "Elite D55",
    "Device": "Elite_D55",
    "Model": "Elite_D55"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "Elite D55T",
    "Device": "Elite_D55T",
    "Model": "Elite D55T"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "Elite D5Max",
    "Device": "Elite_D5Max",
    "Model": "Elite D5Max"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "Elite D5Max",
    "Device": "Elite_D5MaxUS2",
    "Model": "Elite D5Max"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "Elite D5Max",
    "Device": "Elite_D5Max_US",
    "Model": "Elite D5Max"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "Elite E55",
    "Device": "Elite_E55",
    "Model": "Elite E55"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "Elite E55Max",
    "Device": "Elite_E55Max",
    "Model": "Elite E55Max"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "Elite F55",
    "Device": "Elite_F55",
    "Model": "Elite F55"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "Elite G55",
    "Device": "Elite_G55",
    "Model": "Elite_G55"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "Elite Go",
    "Device": "Elite_Go",
    "Model": "Elite Go"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "Elite Go",
    "Device": "Elite_Go_HN",
    "Model": "Elite Go"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "Elite Go",
    "Device": "Elite_Go_SV",
    "Model": "Elite Go"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "Elite H5",
    "Device": "Elite_H5",
    "Model": "Elite H5"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "Elite H5",
    "Device": "Elite_H5_FW",
    "Model": "Elite H5"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "Elite H55",
    "Device": "Elite_H55",
    "Model": "Elite H55"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "Elite I55",
    "Device": "Elite_I55",
    "Model": "Elite I55"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "Elite M45",
    "Device": "Elite_M45",
    "Model": "Elite M45"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "Elite M55",
    "Device": "Elite_M55",
    "Model": "Elite M55"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "Elite M5Plus",
    "Device": "Elite_M5Plus",
    "Model": "Elite M5Plus"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "Elite M5Plus",
    "Device": "Elite_M5Plus_PA",
    "Model": "Elite M5Plus"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "Elite M5Plus",
    "Device": "Elite_M5Plus_SAL",
    "Model": "Elite M5Plus"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "Elite Max",
    "Device": "Elite_Max",
    "Model": "Elite Max"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "Elite N55",
    "Device": "Elite_N55",
    "Model": "Elite N55"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "Elite N55",
    "Device": "Elite_N55PUA",
    "Model": "Elite N55"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "Elite N55Max",
    "Device": "Elite_N55Maxus",
    "Model": "Elite N55Max"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "Elite Octa",
    "Device": "Elite_OCTUS",
    "Model": "Elite Octa"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "Elite Octa",
    "Device": "Elite_OCUS3",
    "Model": "Elite Octa"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "Elite Octa",
    "Device": "Elite_Octa",
    "Model": "Elite Octa"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "Elite Octa",
    "Device": "Elite_Octa_PWG",
    "Model": "Elite Octa"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "Elite OctaMax",
    "Device": "Elite_OctaMax",
    "Model": "Elite OctaMax"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "Elite OctaMax",
    "Device": "Elite_OctaMax1",
    "Model": "Elite OctaMax"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "Elite OctaMax",
    "Device": "Elite_OctaMax1b",
    "Model": "Elite OctaMax"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "Elite OctaMax",
    "Device": "Elite_OctaMax3b",
    "Model": "Elite OctaMax"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "Elite OctaMax",
    "Device": "Elite_OctaMax3c",
    "Model": "Elite OctaMax"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "Elite OctaMax",
    "Device": "Elite_OctaMax3e",
    "Model": "Elite OctaMax"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "Elite OctaMax",
    "Device": "Elite_OctaMaxom",
    "Model": "Elite OctaMax"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "Elite OctaX",
    "Device": "Elite_OctaX",
    "Model": "Elite OctaX"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "Elite OctaX",
    "Device": "Elite_OctaXK",
    "Model": "Elite OctaX"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "Elite P5",
    "Device": "Elite_P5",
    "Model": "Elite P5"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "Elite P55Pro",
    "Device": "Elite_P55Pau",
    "Model": "Elite P55Pro"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "Elite P55Pro",
    "Device": "Elite_P55Pro",
    "Model": "Elite P55Pro"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "Elite P55Pro",
    "Device": "Elite_P55Pus",
    "Model": "Elite P55Pro"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "Elite R55",
    "Device": "Elite_R55",
    "Model": "Elite R55"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "Elite T10",
    "Device": "Elite_T10",
    "Model": "Elite T10"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "Elite T10",
    "Device": "Elite_T10A",
    "Model": "Elite T10"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "Elite T11 Max",
    "Device": "Elite_T11_Maxlt",
    "Model": "Elite T11 Max"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "Elite T4",
    "Device": "Elite_T4",
    "Model": "Elite T4"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "Elite T45",
    "Device": "Elite_T45",
    "Model": "Elite T45"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "Elite T55",
    "Device": "Elite_T55_HN",
    "Model": "Elite T55"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "Elite T55",
    "Device": "Elite_T55_SV",
    "Model": "Elite T55"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "Elite T6",
    "Device": "Elite_T6",
    "Model": "Elite T6"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "Elite T8",
    "Device": "ELITE_T8",
    "Model": "ELITE T8"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "Elite T8 Plus",
    "Device": "Elite_T8PUB",
    "Model": "Elite T8Plus"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "Elite T8Plus",
    "Device": "Elite_T8Plus",
    "Model": "Elite T8Plus"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "Elite T8Plus",
    "Device": "Elite_T8PlusK",
    "Model": "Elite T8Plus"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "Elite_65Max",
    "Device": "Elite_65Max",
    "Model": "Elite 65Max"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "Elite_67Pro",
    "Device": "Elite_67Pro",
    "Model": "Elite 67Pro"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "Elite_67ProLi",
    "Device": "Elite_67Pro",
    "Model": "Elite 67Pro"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "Elite_6Pras",
    "Device": "Elite_6Pro",
    "Model": "Elite 6Pro"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "Elite_6Pro",
    "Device": "Elite_6Pro",
    "Model": "Elite 6Pro"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "Elite_A63Max",
    "Device": "Elite_A63Max",
    "Model": "Elite A63Max"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "Elite_A65",
    "Device": "Elite_A65",
    "Model": "Elite A65"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "Elite_B5MS",
    "Device": "Elite_B5MS",
    "Model": "Elite B5"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "Elite_D5",
    "Device": "Elite_D5",
    "Model": "Elite D5"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "Elite_D55",
    "Device": "Elite_D55",
    "Model": "Elite_D55"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "Elite_D5T",
    "Device": "Elite_D5T",
    "Model": "Elite D5T"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "Elite_D65",
    "Device": "Elite_D65",
    "Model": "Elite D65"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "Elite_D65LIUS",
    "Device": "Elite_D65",
    "Model": "Elite D65"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "Elite_D65US",
    "Device": "Elite_D65",
    "Model": "Elite D65"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "Elite_E5",
    "Device": "Elite_E5",
    "Model": "Elite_E5"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "Elite_F5",
    "Device": "Elite_F5",
    "Model": "Elite_F5"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "Elite_G63",
    "Device": "Elite_G63",
    "Model": "Elite G63"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "Elite_H55",
    "Device": "Elite_H55",
    "Model": "Elite H55"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "Elite_H55_HD",
    "Device": "Elite_H55_HD",
    "Model": "Elite H55"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "Elite_H5_FW",
    "Device": "Elite_H5_FW",
    "Model": "Elite H5"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "Elite_J55",
    "Device": "Elite_J55",
    "Model": "Elite J55"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "Elite_J55US",
    "Device": "Elite_J55US",
    "Model": "Elite J55US"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "Elite_OctaX",
    "Device": "Elite_OctaXkk3",
    "Model": "Elite OctaX"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "Elite_P55",
    "Device": "Elite_P55",
    "Model": "Elite P55"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "Elite_P55BMax",
    "Device": "Elite_P55BMaxB",
    "Model": "Elite P55Max"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "Elite_P55MANAL",
    "Device": "Elite_P55MANAL",
    "Model": "Elite P55Max"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "Elite_P55MAXA",
    "Device": "Elite_P55MAXA",
    "Model": "Elite P55Max"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "Elite_P55MUSAN",
    "Device": "Elite_P55MUSAN",
    "Model": "Elite P55Max"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "Elite_P55MxUS",
    "Device": "Elite_P55MxUS",
    "Model": "Elite P55Max"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "Elite_P55XUSA2",
    "Device": "Elite_P55XUSA2",
    "Model": "Elite P55Max"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "Elite_P55_CMax",
    "Device": "Elite_P55_CMax",
    "Model": "Elite P55Max"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "Elite_P55_Max_D",
    "Device": "Elite_P55_Max_D",
    "Model": "Elite P55Max"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "Elite_PAD8USA",
    "Device": "Elite_PAD8USA",
    "Model": "SKY PAD8"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "Elite_Q55",
    "Device": "Elite_Q55",
    "Model": "Elite_Q55"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "Elite_T10_PRO",
    "Device": "Elite_T10_PRO",
    "Model": "Elite T10 PRO"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "Elite_T11_Max",
    "Device": "Elite_T11_Max",
    "Model": "Elite T11 Max"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "Elite_T14PRO",
    "Device": "Elite_T14PRO",
    "Model": "Elite_T14PRO"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "Elite_T8PUSA",
    "Device": "Elite_T8PUSA",
    "Model": "Elite T8Plus"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "Elite_T8Plus",
    "Device": "Elite_T8Plus",
    "Model": "Elite T8Plus"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "Elite_T8Pluss",
    "Device": "Elite_T8Pluss",
    "Model": "Elite T8Plus"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "Elite_T8Pluss",
    "Device": "Elite_T8Pluss2",
    "Model": "Elite T8Plus"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "Elite_V55",
    "Device": "Elite_V55",
    "Model": "Elite V55"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "F55Max",
    "Device": "F55Max",
    "Model": "F55Max"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "Fuego 4.0T",
    "Device": "Fuego_4_0T_EC",
    "Model": "Fuego 4.0T"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "PAD10Max",
    "Device": "SKY_PAD10Maxk2",
    "Model": "SKY PAD10Max"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "PLATINUM 4.0",
    "Device": "Platinum_40",
    "Model": "Platinum 4.0"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "PLATINUM 4.0",
    "Device": "Platinum_4_0",
    "Model": "Platinum 4.0"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "PLATINUM 4.0",
    "Device": "Platinum_4_0_CD",
    "Model": "Platinum 4.0"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "PLATINUM 4.0+",
    "Device": "Platinum_4_0Plus",
    "Model": "Platinum_4_0Plus"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "PLATINUM 5.0M",
    "Device": "Platinum_5_0M",
    "Model": "Platinum_5.0M"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "PLATINUM A5",
    "Device": "Platinum_A5",
    "Model": "Platinum_A5"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "PLATINUM A55",
    "Device": "Platinum_A55",
    "Model": "Platinum_A55"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "PLATINUM A57",
    "Device": "Platinum_A57_OP",
    "Model": "Platinum A57"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "PLATINUM B5",
    "Device": "Platinum_B5",
    "Model": "Platinum_B5"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "PLATINUM D5",
    "Device": "Platinum_D5",
    "Model": "Platinum D5"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "PLATINUM D5",
    "Device": "Platinum_D5_CA",
    "Model": "Platinum D5"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "PLATINUM M4",
    "Device": "Platinum_M4_SV",
    "Model": "Platinum M4"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "PLATINUM VIEW",
    "Device": "PLATINUMVIEW",
    "Model": "PLATINUMVIEW"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "PLATINUM_E5",
    "Device": "Platinum_E5",
    "Model": "Platinum_E5"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "PLATINUM_F5",
    "Device": "Platinum_F5",
    "Model": "Platinum_F5"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "PLATINUM_O",
    "Device": "PLATINUM_O",
    "Model": "PLATINUM_O"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "PLATINUM_O_B1",
    "Device": "PLATINUM_O",
    "Model": "PLATINUM_O"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "Platinum A7",
    "Device": "Platinum_A7",
    "Model": "Platinum_A7"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "Platinum B4",
    "Device": "Platinum_B4",
    "Model": "Platinum B4"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "Platinum B4",
    "Device": "Platinum_B4P",
    "Model": "Platinum_B4"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "Platinum C4",
    "Device": "Platinum_C4",
    "Model": "Platinum C4"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "Platinum C55",
    "Device": "Platinum_C55",
    "Model": "Platinum C55"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "Platinum F5",
    "Device": "Platinum_F5_2100",
    "Model": "Platinum_F5"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "Platinum G5",
    "Device": "Platinum_G5",
    "Model": "Platinum_G5"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "Platinum G55",
    "Device": "Platinum_G55",
    "Model": "Platinum_G55"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "Platinum K55",
    "Device": "Platinum_K55",
    "Model": "Platinum K55"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "Platinum M5",
    "Device": "Platinum_M5",
    "Model": "Platinum_M5"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "Platinum P4",
    "Device": "Platinum_P4",
    "Model": "Platinum_P4"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "Platinum View2",
    "Device": "PLATINUM_VIEW2",
    "Model": "PLATINUM_VIEW2"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "Platinum View2",
    "Device": "Platinum_View2_V2",
    "Model": "PLATINUM_VIEW2"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "Platinum View2_Plus",
    "Device": "PLATINUM_VIEW2_PLUS",
    "Model": "Platinum View2"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "Platinum_H5",
    "Device": "Platinum_H5_PLUS",
    "Model": "Platinum H5"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "Platinum_J5",
    "Device": "Platinum_J5",
    "Model": "Platinum J5"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "Platinum_J5US",
    "Device": "Platinum_J5US",
    "Model": "Platinum J5"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "Platinum_K5",
    "Device": "Platinum_K5",
    "Model": "Platinum K5"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "Platinum_P4",
    "Device": "Platinum_P4",
    "Model": "Platinum_P4"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "Platinum_UNO",
    "Device": "Platinum_UNO",
    "Model": "Platinum_UNO"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "Premier",
    "Device": "Premier",
    "Model": "Premier"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "Premier5",
    "Device": "Premier5_US",
    "Model": "Premier5"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "Premier_Pro",
    "Device": "Premier_Pro",
    "Model": "Premier Pro"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "Prestige2",
    "Device": "SKY_Prestige2_FP",
    "Model": "SKY Prestige2"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "SKY 5.0LM",
    "Device": "SKY_50LM",
    "Model": "SKY 5.0LM"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "SKY 5.0Pro II",
    "Device": "SKY_50Pro_II",
    "Model": "SKY 5.0Pro II"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "SKY 55M",
    "Device": "SKY_55M",
    "Model": "SKY 55M"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "SKY Black",
    "Device": "NEGTI28",
    "Model": "SKY Black"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "SKY Black",
    "Device": "Neg10_SKY_Black",
    "Model": "SKY Black"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "SKY Black",
    "Device": "Negro_SKY_Black",
    "Model": "SKY Black"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "SKY Black",
    "Device": "SKY_Black",
    "Model": "SKY Black"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "SKY Black",
    "Device": "TIBLA28",
    "Model": "SKY Black"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "SKY Black2",
    "Device": "Sky_Black2",
    "Model": "SKY Black2"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "SKY Black2",
    "Device": "Sky_Black2gt",
    "Model": "Sky Black2"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "SKY BlackMax",
    "Device": "Sky_BlackMax",
    "Model": "Sky BlackMax"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "SKY KID1",
    "Device": "SKY_KID1",
    "Model": "SKY_KID1"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "SKY KID1",
    "Device": "SKY_KID1us",
    "Model": "SKY_KID1"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "SKY KIDs PRO1",
    "Device": "SKY_KIDs_PRO1",
    "Model": "SKY_KIDs_PRO1"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "SKY PAD10",
    "Device": "SKY_PAD10",
    "Model": "SKY PAD10"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "SKY PAD10",
    "Device": "SKY_PAX10US",
    "Model": "SKY PAD10"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "SKY PAD10MAX",
    "Device": "SKY_PAD10MAXEXUS",
    "Model": "SKY_PAD10MAX"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "SKY PAD10MAX",
    "Device": "SKY_PAD10XOP",
    "Model": "SKY_PAD10MAX"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "SKY PAD10MAX",
    "Device": "SKY_PAD10_MAX",
    "Model": "SKY_PAD10MAX"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "SKY PAD10Max",
    "Device": "SKY_PAD10MaxNUS",
    "Model": "SKY PAD10Max"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "SKY PAD10Max",
    "Device": "SKY_PAD10MaxOPM",
    "Model": "SKY PAD10Max"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "SKY PAD10Max",
    "Device": "SKY_PADMaxNAL",
    "Model": "SKY PAD10Max"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "SKY PAD8",
    "Device": "SKY_PAD8",
    "Model": "SKY PAD8"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "SKY PAD8PRO",
    "Device": "SKY_PAD8PROUSON",
    "Model": "SKY_PAD8PRO"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "SKY Pad10",
    "Device": "SKY_Pad10k",
    "Model": "SKY Pad10"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "SKY Prestige",
    "Device": "SKY_Prestige",
    "Model": "SKY Prestige"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "SKY Prestige2",
    "Device": "SKY_Prestige2",
    "Model": "SKY Prestige2"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "SKY Prestige2",
    "Device": "Sky_Prestige2_NFP",
    "Model": "Sky Prestige2"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "SKY PrestigeX",
    "Device": "SKY_PrestigeX",
    "Model": "SKY PrestigeX"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "SKY PrestigeX1",
    "Device": "SKY_PrestigeX1",
    "Model": "SKY PrestigeX1"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "SKY PrestigeX2",
    "Device": "SKY_PrestigeX2",
    "Model": "SKY PrestigeX2"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "SKY VISION1",
    "Device": "SKYVISION",
    "Model": "SKYVISION"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "SKY Volt",
    "Device": "SKY_Volt",
    "Model": "SKY Volt"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "SKY_B632NUS",
    "Device": "SKY_B632NUS",
    "Model": "SKY B63"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "SKY_B63AUSN",
    "Device": "SKY_B63AUSN",
    "Model": "SKY B63"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "SKY_B63BUNS",
    "Device": "SKY_B63BUNS",
    "Model": "SKY B63"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "SKY_B63CUW",
    "Device": "SKY_B63CUW",
    "Model": "SKY B63"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "SKY_B63HA",
    "Device": "SKY_B63HA",
    "Model": "SKY B63"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "SKY_B63NAL",
    "Device": "SKY_B63NAL",
    "Model": "SKY B63"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "SKY_B63NUSA",
    "Device": "SKY_B63NUSA",
    "Model": "SKY B63"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "SKY_B63US",
    "Device": "SKY_B63",
    "Model": "SKY B63"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "SKY_D63",
    "Device": "SKY_D63",
    "Model": "SKY D63"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "SKY_E63",
    "Device": "SKY_E63",
    "Model": "SKY E63"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "SKY_E63BUS",
    "Device": "SKY_E63BUS",
    "Model": "SKY E63"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "SKY_E63CU",
    "Device": "SKY_E63CU",
    "Model": "SKY E63"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "SKY_PAD10MXUSNA",
    "Device": "SKY_PAD10MXUSNA",
    "Model": "SKY_PAD10Max"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "SKY_PAD10Max",
    "Device": "SKY_PAD10MXUSK2",
    "Model": "SKY PAD10Max"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "SKY_PAD10Max",
    "Device": "SKY_PAD10Maxk1",
    "Model": "SKY PAD10Max"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "SKY_PAD10MaxB",
    "Device": "SKY_PAD10MUS2B",
    "Model": "SKY PAD10Max"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "SKY_PAD10us",
    "Device": "SKY_PAD10us",
    "Model": "SKY_PAD10"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "SKY_PAD8MAX",
    "Device": "SKY_Pad8Max",
    "Model": "SKY_PAD8MAX"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "SKY_PAD8Pro",
    "Device": "SKY_PAD8Pro",
    "Model": "SKY PAD8Pro"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "SKY_Pad_Max",
    "Device": "SKY_Pad_Max",
    "Model": "SKY_Pad_Max"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "SKY_Pro_III",
    "Device": "SKY_Pro_III",
    "Model": "SKY_Pro_III"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "SKY_prestigeMax",
    "Device": "SKY_prestigeMax",
    "Model": "SKY_prestigeMax"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "Sky Vision2",
    "Device": "Sky_Vision2",
    "Model": "Sky Vision2"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "Sky Vision2_Plus",
    "Device": "SKY_VISION2_Plus",
    "Model": "SKY VISION2"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "Sky Vision2_Plus",
    "Device": "SKY_VISION2_Plus",
    "Model": "SKY_KID"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "Sky_A67",
    "Device": "Sky_A67",
    "Model": "SKY A67"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "UNO Personal",
    "Device": "UNO_Personal",
    "Model": "UNO Personal"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "UNO Personal Plus",
    "Device": "Personal_Plus",
    "Model": "UNO Personal Plus"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "UNO Royale Plus",
    "Device": "Royale_Plus",
    "Model": "UNO Royale Plus"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "X2",
    "Device": "Xmobile_X2",
    "Model": "X2"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "X2",
    "Device": "Xmobile_X2_US",
    "Model": "X2"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "X63",
    "Device": "X63",
    "Model": "X63"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "X63Max",
    "Device": "X63Max",
    "Model": "X63Max"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "X8A",
    "Device": "X8A",
    "Model": "X8A"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "Xmobile X55",
    "Device": "X55",
    "Model": "X55"
  },
  {
    "Retail Branding": "Sky Devices",
    "Marketing Name": "pro selfie",
    "Device": "PRO_SELFIE",
    "Model": "PRO_SELFIE"
  },
  {
    "Retail Branding": "Sky NZ",
    "Marketing Name": "Sky Box",
    "Device": "SkyNZ3151",
    "Model": "Sky Box"
  },
  {
    "Retail Branding": "Sky NZ",
    "Marketing Name": "Sky Pod",
    "Device": "SEI700SKY",
    "Model": "Sky Pod"
  },
  {
    "Retail Branding": "Sky+",
    "Marketing Name": "Sky+",
    "Device": "B866VH",
    "Model": "Sky+"
  },
  {
    "Retail Branding": "Sky+",
    "Marketing Name": "Sky+",
    "Device": "KSTB3226",
    "Model": "Sky+"
  },
  {
    "Retail Branding": "Sky+",
    "Marketing Name": "Sky+",
    "Device": "SEI800SKM",
    "Model": "Sky+"
  },
  {
    "Retail Branding": "SkyLife",
    "Marketing Name": "KSTB2019",
    "Device": "KSTB2019",
    "Model": "KSTB2019"
  },
  {
    "Retail Branding": "SkyLife",
    "Marketing Name": "KSTB6165",
    "Device": "KSTB6165",
    "Model": "KSTB6165"
  },
  {
    "Retail Branding": "SkyLife",
    "Marketing Name": "MA5000",
    "Device": "MA5000",
    "Model": "MA5000"
  },
  {
    "Retail Branding": "SkyLife",
    "Marketing Name": "MA5100",
    "Device": "ma5100",
    "Model": "MA5100"
  },
  {
    "Retail Branding": "SkyLife",
    "Marketing Name": "Skylife android 2nd TV",
    "Device": "DMTS18SS",
    "Model": "USI-7000NA"
  },
  {
    "Retail Branding": "SkyLife",
    "Marketing Name": "UHD2",
    "Device": "IC1110",
    "Model": "IC1110"
  },
  {
    "Retail Branding": "SkyLife",
    "Marketing Name": "UHD_S56AT",
    "Device": "INTEKS19SS",
    "Model": "UHD_S56AT"
  },
  {
    "Retail Branding": "SkyLife",
    "Marketing Name": "UHD_S63AT",
    "Device": "INTEKS22SS",
    "Model": "UHD-S63AT"
  },
  {
    "Retail Branding": "SkyLife",
    "Marketing Name": "skylife LTE TV",
    "Device": "DMTS17SS",
    "Model": "DMT_1621"
  },
  {
    "Retail Branding": "Skyview",
    "Marketing Name": "KENYA",
    "Device": "tamachi",
    "Model": "SKYVIEW Android TV"
  },
  {
    "Retail Branding": "Skyview",
    "Marketing Name": "KENYA",
    "Device": "yeongdeungpo",
    "Model": "SKYVIEW Android TV"
  },
  {
    "Retail Branding": "Skyview",
    "Marketing Name": "M5",
    "Device": "M5",
    "Model": "M5"
  },
  {
    "Retail Branding": "Skyworth",
    "Marketing Name": "APAC 2K TV",
    "Device": "shibuya",
    "Model": "SWTV"
  },
  {
    "Retail Branding": "Skyworth",
    "Marketing Name": "Asia",
    "Device": "globe_ap",
    "Model": "globe"
  },
  {
    "Retail Branding": "Skyworth",
    "Marketing Name": "Asia",
    "Device": "open_fhd_ap",
    "Model": "open_fhd"
  },
  {
    "Retail Branding": "Skyworth",
    "Marketing Name": "Asia",
    "Device": "open_uhd_ap",
    "Model": "open_uhd"
  },
  {
    "Retail Branding": "Skyworth",
    "Marketing Name": "Euro",
    "Device": "SW3_ATV",
    "Model": "SWTV"
  },
  {
    "Retail Branding": "Skyworth",
    "Marketing Name": "Europe",
    "Device": "globe_eu",
    "Model": "globe"
  },
  {
    "Retail Branding": "Skyworth",
    "Marketing Name": "HPR3B",
    "Device": "KHH",
    "Model": "UHD Google TV Stick"
  },
  {
    "Retail Branding": "Skyworth",
    "Marketing Name": "Hong Kong",
    "Device": "open_uhd_hk",
    "Model": "open_uhd"
  },
  {
    "Retail Branding": "Skyworth",
    "Marketing Name": "LEAP-S1",
    "Device": "LAS",
    "Model": "LEAP-S1"
  },
  {
    "Retail Branding": "Skyworth",
    "Marketing Name": "LEAP-S3pro",
    "Device": "RMQ",
    "Model": "UHD Google TV STB"
  },
  {
    "Retail Branding": "Skyworth",
    "Marketing Name": "Leap-L1",
    "Device": "BOS",
    "Model": "TV Stick"
  },
  {
    "Retail Branding": "Skyworth",
    "Marketing Name": "Leap-S2",
    "Device": "YYT",
    "Model": "4K Google TV Stick"
  },
  {
    "Retail Branding": "Skyworth",
    "Marketing Name": "Leap-S3",
    "Device": "YDA",
    "Model": "4K Google TV Box"
  },
  {
    "Retail Branding": "Skyworth",
    "Marketing Name": "Leap-S4",
    "Device": "YYC",
    "Model": "4K Android TV Box"
  },
  {
    "Retail Branding": "Skyworth",
    "Marketing Name": "METZ 2K TV",
    "Device": "shinagawa",
    "Model": "METZ 2K TV"
  },
  {
    "Retail Branding": "Skyworth",
    "Marketing Name": "NT-01",
    "Device": "HP40A",
    "Model": "NT-01"
  },
  {
    "Retail Branding": "Skyworth",
    "Marketing Name": "North America",
    "Device": "globe_na",
    "Model": "globe"
  },
  {
    "Retail Branding": "Skyworth",
    "Marketing Name": "North America",
    "Device": "shimbashi",
    "Model": "2K TV"
  },
  {
    "Retail Branding": "Skyworth",
    "Marketing Name": "Skyworth",
    "Device": "grape",
    "Model": "HPA02"
  },
  {
    "Retail Branding": "Skyworth",
    "Marketing Name": "South Africa",
    "Device": "open_fhd_sa",
    "Model": "open_fhd"
  },
  {
    "Retail Branding": "Skyworth",
    "Marketing Name": "South America",
    "Device": "globe_sa",
    "Model": "globe"
  },
  {
    "Retail Branding": "Skyworth",
    "Marketing Name": "South America",
    "Device": "shinjuku",
    "Model": "SA 2K TV"
  },
  {
    "Retail Branding": "Skyworth",
    "Marketing Name": "UrTV1",
    "Device": "HY44J",
    "Model": "UrTV1"
  },
  {
    "Retail Branding": "Skyworth",
    "Marketing Name": "VGK02",
    "Device": "HP46D",
    "Model": "VGK02"
  },
  {
    "Retail Branding": "SledovaniTV",
    "Marketing Name": "DV8220",
    "Device": "DV8220",
    "Model": "DV8220"
  },
  {
    "Retail Branding": "Smadl",
    "Marketing Name": "Abay5_Plus",
    "Device": "SMADL_Abay5_Plus",
    "Model": "SMADL Abay5+"
  },
  {
    "Retail Branding": "Smadl",
    "Marketing Name": "Matri8",
    "Device": "Matri8",
    "Model": "Matri8"
  },
  {
    "Retail Branding": "Smadl",
    "Marketing Name": "SMADL",
    "Device": "Matri2",
    "Model": "Matri2"
  },
  {
    "Retail Branding": "Smadl",
    "Marketing Name": "SMADL_R35",
    "Device": "SMADL_R35_FW",
    "Model": "SMADL R35"
  },
  {
    "Retail Branding": "Smadl",
    "Marketing Name": "Safari",
    "Device": "Safari",
    "Model": "Safari"
  },
  {
    "Retail Branding": "Smadl",
    "Marketing Name": "Safari_ 2plus",
    "Device": "Safari_2plus",
    "Model": "Safari_2plus"
  },
  {
    "Retail Branding": "Smadl",
    "Marketing Name": "Safari_2",
    "Device": "Safari_2",
    "Model": "Safari 2"
  },
  {
    "Retail Branding": "Smailo",
    "Marketing Name": "Smailo 2GO",
    "Device": "Smailo_2GO",
    "Model": "Smailo_2GO"
  },
  {
    "Retail Branding": "Smart",
    "Marketing Name": "ATV device",
    "Device": "tcl_eu",
    "Model": "ATV"
  },
  {
    "Retail Branding": "Smart",
    "Marketing Name": "Advance Pro",
    "Device": "Advance_Pro",
    "Model": "Advance Pro"
  },
  {
    "Retail Branding": "Smart",
    "Marketing Name": "B790",
    "Device": "B790",
    "Model": "B790"
  },
  {
    "Retail Branding": "Smart",
    "Marketing Name": "Coral 4",
    "Device": "Coral_4",
    "Model": "Coral 4"
  },
  {
    "Retail Branding": "Smart",
    "Marketing Name": "FW503KH",
    "Device": "FW503KH",
    "Model": "FW503KH"
  },
  {
    "Retail Branding": "Smart",
    "Marketing Name": "Grand",
    "Device": "Grand",
    "Model": "Grand"
  },
  {
    "Retail Branding": "Smart",
    "Marketing Name": "M20",
    "Device": "M20",
    "Model": "M20"
  },
  {
    "Retail Branding": "Smart",
    "Marketing Name": "M30",
    "Device": "M30",
    "Model": "M30"
  },
  {
    "Retail Branding": "Smart",
    "Marketing Name": "M50",
    "Device": "M50",
    "Model": "M50"
  },
  {
    "Retail Branding": "Smart",
    "Marketing Name": "Max",
    "Device": "Max",
    "Model": "Max"
  },
  {
    "Retail Branding": "Smart",
    "Marketing Name": "Mouridiyya_Phone",
    "Device": "Mouridiyya_Phone",
    "Model": "Expresso"
  },
  {
    "Retail Branding": "Smart",
    "Marketing Name": "Notrino",
    "Device": "Notrino",
    "Model": "Notrino"
  },
  {
    "Retail Branding": "Smart",
    "Marketing Name": "SK3401",
    "Device": "SK3401",
    "Model": "SK3401"
  },
  {
    "Retail Branding": "Smart",
    "Marketing Name": "Slide Lite",
    "Device": "Slide_Lite",
    "Model": "Slide Lite"
  },
  {
    "Retail Branding": "Smart",
    "Marketing Name": "Smart PRIME II",
    "Device": "Smart_PRIME_II",
    "Model": "Smart PRIME II"
  },
  {
    "Retail Branding": "Smart",
    "Marketing Name": "Smart_Hero_II",
    "Device": "Smart_Hero_II",
    "Model": "Smart_Hero_II"
  },
  {
    "Retail Branding": "Smart",
    "Marketing Name": "am60k",
    "Device": "komodo",
    "Model": "SMART AM60"
  },
  {
    "Retail Branding": "Smart",
    "Marketing Name": "e-PAD",
    "Device": "e-PAD",
    "Model": "e-PAD"
  },
  {
    "Retail Branding": "Smart",
    "Marketing Name": "hero A1",
    "Device": "hero_A1",
    "Model": "hero A1"
  },
  {
    "Retail Branding": "Smart (BD)",
    "Marketing Name": "MQ703G",
    "Device": "MQ703G",
    "Model": "MQ703G"
  },
  {
    "Retail Branding": "Smart (BD)",
    "Marketing Name": "MQ703G_1",
    "Device": "MQ703G_1",
    "Model": "MQ703G_1"
  },
  {
    "Retail Branding": "Smart (BD)",
    "Marketing Name": "SQ811G",
    "Device": "SQ811G",
    "Model": "SQ811G"
  },
  {
    "Retail Branding": "Smart-Tech TV",
    "Marketing Name": "AiPro2K",
    "Device": "dongnae",
    "Model": "AiPro2K"
  },
  {
    "Retail Branding": "Smart-Tech TV",
    "Marketing Name": "Aiplus4K",
    "Device": "guandu",
    "Model": "Aiplus4K"
  },
  {
    "Retail Branding": "Smart-Tech TV",
    "Marketing Name": "Apollo Premium4K TV",
    "Device": "marina",
    "Model": "Apollo Premium4K TV"
  },
  {
    "Retail Branding": "Smart-Tech TV",
    "Marketing Name": "Contex TV",
    "Device": "cottongreen",
    "Model": "Contex TV"
  },
  {
    "Retail Branding": "Smart-Tech TV",
    "Marketing Name": "Contex TV",
    "Device": "nagata",
    "Model": "Contex TV"
  },
  {
    "Retail Branding": "Smart-Tech TV",
    "Marketing Name": "EU",
    "Device": "cottongreen",
    "Model": "Gameplay"
  },
  {
    "Retail Branding": "Smart-Tech TV",
    "Marketing Name": "EU、UK、AP",
    "Device": "martin",
    "Model": "AiPlus2K"
  },
  {
    "Retail Branding": "Smart-Tech TV",
    "Marketing Name": "EU、UK、AP",
    "Device": "martin",
    "Model": "WALTON Android TV"
  },
  {
    "Retail Branding": "Smart-Tech TV",
    "Marketing Name": "Europe",
    "Device": "sepolia",
    "Model": "AiPro4K"
  },
  {
    "Retail Branding": "Smart-Tech TV",
    "Marketing Name": "France",
    "Device": "tamachi",
    "Model": "AiPlus2K"
  },
  {
    "Retail Branding": "Smart-Tech TV",
    "Marketing Name": "Germany",
    "Device": "yeongdeungpo",
    "Model": "AiPlus4K"
  },
  {
    "Retail Branding": "Smart-Tech TV",
    "Marketing Name": "SMART TECHNOLOGY",
    "Device": "elliniko",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "Smart-Tech TV",
    "Marketing Name": "SMART TECHNOLOGY",
    "Device": "stanford",
    "Model": "2K SMART TV"
  },
  {
    "Retail Branding": "Smart-Tech TV",
    "Marketing Name": "SMART TEcHNOLGY",
    "Device": "zhongshan",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "Smart-Tech TV",
    "Marketing Name": "SmartTech",
    "Device": "yeongdeungpo",
    "Model": "AiPlus4K"
  },
  {
    "Retail Branding": "SmartLabs",
    "Marketing Name": "SML-5442TW",
    "Device": "sml5442tw",
    "Model": "SML-5442TW"
  },
  {
    "Retail Branding": "SmartPad",
    "Marketing Name": "SM181301",
    "Device": "SM181301",
    "Model": "SM181301"
  },
  {
    "Retail Branding": "SmartPad",
    "Marketing Name": "Smartpad V7",
    "Device": "Smartpad-V7",
    "Model": "Smartpad-V7"
  },
  {
    "Retail Branding": "SmartPad",
    "Marketing Name": "Smartpad-V10",
    "Device": "Smartpad-V10",
    "Model": "Smartpad-V10"
  },
  {
    "Retail Branding": "SmartPeak",
    "Marketing Name": "P3000",
    "Device": "P3000",
    "Model": "P3000"
  },
  {
    "Retail Branding": "SmartSchool",
    "Marketing Name": "Interactive_Flat_Panel",
    "Device": "Interactive_Flat_Panel",
    "Model": "H-Series"
  },
  {
    "Retail Branding": "Smart_Touch",
    "Marketing Name": "ST IR13",
    "Device": "STG_IR13",
    "Model": "STG_Series"
  },
  {
    "Retail Branding": "Smart_Touch",
    "Marketing Name": "Smart Touch QERA",
    "Device": "QERA",
    "Model": "QERA_Series"
  },
  {
    "Retail Branding": "Smartab",
    "Marketing Name": "SRF79",
    "Device": "SRF79",
    "Model": "SRF79"
  },
  {
    "Retail Branding": "Smartab",
    "Marketing Name": "ST1009X",
    "Device": "ST1009X",
    "Model": "ST1009X"
  },
  {
    "Retail Branding": "Smartab",
    "Marketing Name": "ST1020",
    "Device": "ST1020",
    "Model": "ST1020"
  },
  {
    "Retail Branding": "Smartab",
    "Marketing Name": "ST700",
    "Device": "ST700",
    "Model": "ST700"
  },
  {
    "Retail Branding": "Smartab",
    "Marketing Name": "ST7150",
    "Device": "ST7150",
    "Model": "ST7150"
  },
  {
    "Retail Branding": "Smartab",
    "Marketing Name": "ST7150-19",
    "Device": "ST7150-19",
    "Model": "ST7150-19"
  },
  {
    "Retail Branding": "Smartab",
    "Marketing Name": "ST7160",
    "Device": "ST7160",
    "Model": "ST7160"
  },
  {
    "Retail Branding": "Smartab",
    "Marketing Name": "ST7650",
    "Device": "ST7650",
    "Model": "ST7650"
  },
  {
    "Retail Branding": "Smartab",
    "Marketing Name": "ST7680",
    "Device": "ST7680",
    "Model": "ST7680"
  },
  {
    "Retail Branding": "Smartab",
    "Marketing Name": "ST8200",
    "Device": "ST8200",
    "Model": "ST8200"
  },
  {
    "Retail Branding": "Smartab",
    "Marketing Name": "ST8888",
    "Device": "ST8888",
    "Model": "ST8888"
  },
  {
    "Retail Branding": "Smartab",
    "Marketing Name": "STJR700",
    "Device": "STJR700",
    "Model": "STJR700"
  },
  {
    "Retail Branding": "Smartab",
    "Marketing Name": "STJR76",
    "Device": "STJR76",
    "Model": "STJR76"
  },
  {
    "Retail Branding": "Smartable",
    "Marketing Name": "EH_V10",
    "Device": "EH_V10",
    "Model": "EH_V10"
  },
  {
    "Retail Branding": "Smartbook",
    "Marketing Name": "S204G",
    "Device": "S204G",
    "Model": "S204G"
  },
  {
    "Retail Branding": "Smartec",
    "Marketing Name": "Atractivo",
    "Device": "Atractivo",
    "Model": "Atractivo"
  },
  {
    "Retail Branding": "Smartec",
    "Marketing Name": "MiCA",
    "Device": "MiCA",
    "Model": "MiCA"
  },
  {
    "Retail Branding": "Smartec",
    "Marketing Name": "N4",
    "Device": "N4",
    "Model": "N4"
  },
  {
    "Retail Branding": "Smartec",
    "Marketing Name": "SmartabS32",
    "Device": "SmartabS32",
    "Model": "SmartabS32"
  },
  {
    "Retail Branding": "Smartec",
    "Marketing Name": "SmartabS4",
    "Device": "SmartabS4",
    "Model": "SmartabS4"
  },
  {
    "Retail Branding": "Smartec",
    "Marketing Name": "SmartabX8",
    "Device": "SmartabX8",
    "Model": "SmartabX8"
  },
  {
    "Retail Branding": "Smartedu_Touch",
    "Marketing Name": "WTC Series",
    "Device": "WTC_Pro",
    "Model": "Smartedu_WTC_Series"
  },
  {
    "Retail Branding": "Smartek",
    "Marketing Name": "MR_POTATO_HEAD",
    "Device": "MR_POTATO_HEAD",
    "Model": "MR_POTATO_HEAD"
  },
  {
    "Retail Branding": "Smartek",
    "Marketing Name": "PLAY_DOH",
    "Device": "PLAY_DOH",
    "Model": "PLAY_DOH"
  },
  {
    "Retail Branding": "Smartex",
    "Marketing Name": "M520",
    "Device": "M520",
    "Model": "M520"
  },
  {
    "Retail Branding": "Smartex",
    "Marketing Name": "M530",
    "Device": "M530",
    "Model": "M530"
  },
  {
    "Retail Branding": "Smartex",
    "Marketing Name": "M700",
    "Device": "M700",
    "Model": "M700"
  },
  {
    "Retail Branding": "Smartex",
    "Marketing Name": "P600",
    "Device": "P600",
    "Model": "P600"
  },
  {
    "Retail Branding": "Smartex",
    "Marketing Name": "SMARTEX_M512",
    "Device": "M512",
    "Model": "M512"
  },
  {
    "Retail Branding": "Smartfren",
    "Marketing Name": "A16C3H",
    "Device": "A16C3H",
    "Model": "Andromax A16C3H"
  },
  {
    "Retail Branding": "Smartfren",
    "Marketing Name": "A26C4H",
    "Device": "A26C4H",
    "Model": "Andromax A26C4H"
  },
  {
    "Retail Branding": "Smartfren",
    "Marketing Name": "AD688G",
    "Device": "AD688G",
    "Model": "Smartfren Andromax AD688G"
  },
  {
    "Retail Branding": "Smartfren",
    "Marketing Name": "AD689G",
    "Device": "AD689G",
    "Model": "Smartfren Andromax AD689G"
  },
  {
    "Retail Branding": "Smartfren",
    "Marketing Name": "Andromax AD682H",
    "Device": "AD682H",
    "Model": "Smartfren Andromax AD682H"
  },
  {
    "Retail Branding": "Smartfren",
    "Marketing Name": "Andromax AD687G",
    "Device": "AD687G",
    "Model": "Andromax AD687G"
  },
  {
    "Retail Branding": "Smartfren",
    "Marketing Name": "Andromax C46B2G",
    "Device": "HS8916QC",
    "Model": "Andromax C46B2G"
  },
  {
    "Retail Branding": "Smartfren",
    "Marketing Name": "AndromaxNC36B1H",
    "Device": "NC36B1H",
    "Model": "Smartfren Andromax NC36B1H"
  },
  {
    "Retail Branding": "Smartfren",
    "Marketing Name": "B16C2G",
    "Device": "MSM8909QC",
    "Model": "Andromax B16C2G"
  },
  {
    "Retail Branding": "Smartfren",
    "Marketing Name": "B16C2H",
    "Device": "B16C2H",
    "Model": "Andromax B16C2H"
  },
  {
    "Retail Branding": "Smartfren",
    "Marketing Name": "B26D2H",
    "Device": "B26D2H",
    "Model": "Andromax B26D2H"
  },
  {
    "Retail Branding": "Smartfren",
    "Marketing Name": "C2LEAD688G",
    "Device": "C2LEAD688G",
    "Model": "Smartfren Andromax AD688G"
  },
  {
    "Retail Branding": "Smartfren",
    "Marketing Name": "EG680",
    "Device": "eg680",
    "Model": "EG680"
  },
  {
    "Retail Branding": "Smartfren",
    "Marketing Name": "G36C1G",
    "Device": "HS8916QC",
    "Model": "Andromax G36C1G"
  },
  {
    "Retail Branding": "Smartfren",
    "Marketing Name": "G36C1H",
    "Device": "G36C1H",
    "Model": "Andromax G36C1H"
  },
  {
    "Retail Branding": "Smartfren",
    "Marketing Name": "I46D1G",
    "Device": "HS8916QC",
    "Model": "Andromax I46D1G"
  },
  {
    "Retail Branding": "Smartfren",
    "Marketing Name": "NC36B1G",
    "Device": "HS8610QC",
    "Model": "Smartfren Andromax NC36B1G"
  },
  {
    "Retail Branding": "Smartfren",
    "Marketing Name": "NEWAD688G",
    "Device": "NEWAD688G",
    "Model": "Smartfren Andromax AD688G"
  },
  {
    "Retail Branding": "Smartfy",
    "Marketing Name": "T701",
    "Device": "T701",
    "Model": "T701"
  },
  {
    "Retail Branding": "Smartfy",
    "Marketing Name": "T702",
    "Device": "T702",
    "Model": "T702"
  },
  {
    "Retail Branding": "Smarti",
    "Marketing Name": "Smarti T2 plus",
    "Device": "Smarti_T2_plus",
    "Model": "Smarti T2 plus"
  },
  {
    "Retail Branding": "Smarti",
    "Marketing Name": "Smarti_Gen_1",
    "Device": "Smarti_Gen_1",
    "Model": "Smarti_Gen_1"
  },
  {
    "Retail Branding": "Smarti",
    "Marketing Name": "Smarti_Gen_2",
    "Device": "Smarti_Gen_2",
    "Model": "Smarti_Gen_2"
  },
  {
    "Retail Branding": "Smarti",
    "Marketing Name": "Smarti_Gen_2_Plus",
    "Device": "Smarti_Gen_2_Plus",
    "Model": "Smarti_Gen_2_Plus"
  },
  {
    "Retail Branding": "Smartron",
    "Marketing Name": "Srtphone",
    "Device": "rimo02a",
    "Model": "T5524"
  },
  {
    "Retail Branding": "Smartron",
    "Marketing Name": "tphone",
    "Device": "rimo01a",
    "Model": "T5511"
  },
  {
    "Retail Branding": "Smartron",
    "Marketing Name": "tphone P",
    "Device": "P840F12",
    "Model": "T5211"
  },
  {
    "Retail Branding": "Smile",
    "Marketing Name": "A955Z",
    "Device": "A955Z",
    "Model": "A955Z"
  },
  {
    "Retail Branding": "Smooth",
    "Marketing Name": "S2",
    "Device": "S2",
    "Model": "S2"
  },
  {
    "Retail Branding": "Smooth",
    "Marketing Name": "S2_Advance",
    "Device": "SSmooth_S2_Advance",
    "Model": "S2 Advance"
  },
  {
    "Retail Branding": "Smooth",
    "Marketing Name": "Smooth5_5",
    "Device": "SSmooth5_5",
    "Model": "Smooth 5.5"
  },
  {
    "Retail Branding": "Smooth",
    "Marketing Name": "Smooth626",
    "Device": "Smooth626",
    "Model": "Smooth626"
  },
  {
    "Retail Branding": "Smooth",
    "Marketing Name": "Smooth_5_HD",
    "Device": "SSmooth_5_HD",
    "Model": "Smooth 5.0"
  },
  {
    "Retail Branding": "Snopow",
    "Marketing Name": "M10",
    "Device": "M10",
    "Model": "M10"
  },
  {
    "Retail Branding": "Snopow",
    "Marketing Name": "ServiceChecKIT",
    "Device": "ServiceChecKIT_EEA",
    "Model": "ServiceChecKIT_EEA"
  },
  {
    "Retail Branding": "So ! Generation",
    "Marketing Name": "T8100",
    "Device": "T8100",
    "Model": "T8100"
  },
  {
    "Retail Branding": "So ! Generation",
    "Marketing Name": "T8116",
    "Device": "T8116",
    "Model": "T8116"
  },
  {
    "Retail Branding": "So ! Generation",
    "Marketing Name": "T8133_EEA",
    "Device": "T8133_EEA",
    "Model": "T8133"
  },
  {
    "Retail Branding": "Socrates",
    "Marketing Name": "Socrates Phone 01",
    "Device": "Socrates_Phone_01",
    "Model": "Socrates Phone 01"
  },
  {
    "Retail Branding": "Soda",
    "Marketing Name": "E1",
    "Device": "soda_CSW1702",
    "Model": "soda E1"
  },
  {
    "Retail Branding": "Soda",
    "Marketing Name": "FIRE",
    "Device": "soda_CSW1803",
    "Model": "soda FIRE"
  },
  {
    "Retail Branding": "Soda",
    "Marketing Name": "Note 12",
    "Device": "Note_12",
    "Model": "Note 12"
  },
  {
    "Retail Branding": "Soda",
    "Marketing Name": "Note 12Pro",
    "Device": "Note_12Pro",
    "Model": "Note 12Pro"
  },
  {
    "Retail Branding": "Soda",
    "Marketing Name": "ROCK_30",
    "Device": "ROCK_30",
    "Model": "ROCK 30"
  },
  {
    "Retail Branding": "Soda",
    "Marketing Name": "s2",
    "Device": "soda_CSW1802",
    "Model": "soda S2"
  },
  {
    "Retail Branding": "Soda",
    "Marketing Name": "soda",
    "Device": "soda_SW17W16",
    "Model": "soda S1"
  },
  {
    "Retail Branding": "SoftBank",
    "Marketing Name": "602ZT",
    "Device": "P809F10",
    "Model": "602ZT"
  },
  {
    "Retail Branding": "Softlogic",
    "Marketing Name": "MaxAiPlus",
    "Device": "MaxAiPlus",
    "Model": "Max-M8"
  },
  {
    "Retail Branding": "Sohar",
    "Marketing Name": "S67",
    "Device": "S67",
    "Model": "S67"
  },
  {
    "Retail Branding": "Solinftec",
    "Marketing Name": "SOL07",
    "Device": "SOL07",
    "Model": "SOL07"
  },
  {
    "Retail Branding": "Solone",
    "Marketing Name": "E1457",
    "Device": "E1457",
    "Model": "E1457"
  },
  {
    "Retail Branding": "Solone",
    "Marketing Name": "W1450",
    "Device": "W1450",
    "Model": "W1450"
  },
  {
    "Retail Branding": "Solone",
    "Marketing Name": "W1452",
    "Device": "W1452",
    "Model": "W1452"
  },
  {
    "Retail Branding": "Solutionforpros",
    "Marketing Name": "R450",
    "Device": "R450",
    "Model": "R450"
  },
  {
    "Retail Branding": "Soneview",
    "Marketing Name": "SONEVIEW",
    "Device": "elliniko",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "Soneview",
    "Marketing Name": "SONEVIEW",
    "Device": "elliniko",
    "Model": "SONEVIEW 4K SMART TV"
  },
  {
    "Retail Branding": "Soneview",
    "Marketing Name": "SONEVIEW",
    "Device": "hongkong",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "Soneview",
    "Marketing Name": "SONEVIEW",
    "Device": "jagalchi",
    "Model": "2K SMART TV"
  },
  {
    "Retail Branding": "Soneview",
    "Marketing Name": "SONEVIEW",
    "Device": "lavender",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "Soneview",
    "Marketing Name": "SONEVIEW",
    "Device": "mountbaker",
    "Model": "2K SMART TV"
  },
  {
    "Retail Branding": "Soneview",
    "Marketing Name": "SONEVIEW",
    "Device": "stanford",
    "Model": "2K SMART TV"
  },
  {
    "Retail Branding": "Soneview",
    "Marketing Name": "SONEVIEW",
    "Device": "zhongshan",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "Soneview",
    "Marketing Name": "SV_TAB10",
    "Device": "SV_TAB10",
    "Model": "SV_TAB10"
  },
  {
    "Retail Branding": "Sonimtech",
    "Marketing Name": "Ex-Handy 09",
    "Device": "XP6700Z1",
    "Model": "Ex-Handy 09"
  },
  {
    "Retail Branding": "Sonimtech",
    "Marketing Name": "RS60",
    "Device": "RS60",
    "Model": "RS60"
  },
  {
    "Retail Branding": "Sonimtech",
    "Marketing Name": "RS80",
    "Device": "RS80",
    "Model": "RS80"
  },
  {
    "Retail Branding": "Sonimtech",
    "Marketing Name": "Smart-Ex 01",
    "Device": "XP7700Z1",
    "Model": "Smart-Ex 01"
  },
  {
    "Retail Branding": "Sonimtech",
    "Marketing Name": "XP Pro",
    "Device": "X801",
    "Model": "X800"
  },
  {
    "Retail Branding": "Sonimtech",
    "Marketing Name": "XP Pro 5G",
    "Device": "X800",
    "Model": "X800"
  },
  {
    "Retail Branding": "Sonimtech",
    "Marketing Name": "XP Pro E",
    "Device": "X803",
    "Model": "X802"
  },
  {
    "Retail Branding": "Sonimtech",
    "Marketing Name": "XP Pro Thermal",
    "Device": "X802",
    "Model": "X802"
  },
  {
    "Retail Branding": "Sonimtech",
    "Marketing Name": "XP10",
    "Device": "XP9900",
    "Model": "XP9900"
  },
  {
    "Retail Branding": "Sonimtech",
    "Marketing Name": "XP400",
    "Device": "X400",
    "Model": "X400"
  },
  {
    "Retail Branding": "Sonimtech",
    "Marketing Name": "XP6",
    "Device": "XP6700",
    "Model": "Ex-Handy 209"
  },
  {
    "Retail Branding": "Sonimtech",
    "Marketing Name": "XP6",
    "Device": "XP6700",
    "Model": "XP6700"
  },
  {
    "Retail Branding": "Sonimtech",
    "Marketing Name": "XP7",
    "Device": "XP7700",
    "Model": "Smart-Ex 201"
  },
  {
    "Retail Branding": "Sonimtech",
    "Marketing Name": "XP7",
    "Device": "XP7700",
    "Model": "XP7700"
  },
  {
    "Retail Branding": "Sonimtech",
    "Marketing Name": "XP7",
    "Device": "XP7700Z1",
    "Model": "Smart-Ex 01"
  },
  {
    "Retail Branding": "Sonimtech",
    "Marketing Name": "XP7700Z1",
    "Device": "XP7700Z1",
    "Model": "Smart-Ex 01"
  },
  {
    "Retail Branding": "Sonimtech",
    "Marketing Name": "XP7705",
    "Device": "XP7705",
    "Model": "XP7700"
  },
  {
    "Retail Branding": "Sonimtech",
    "Marketing Name": "XP8",
    "Device": "XP8800",
    "Model": "XP8800"
  },
  {
    "Retail Branding": "Soniq",
    "Marketing Name": "4K Smart TV",
    "Device": "pioneer",
    "Model": "4K PA Smart TV"
  },
  {
    "Retail Branding": "Soniq",
    "Marketing Name": "PT0719A",
    "Device": "PT0719A",
    "Model": "PT0719A"
  },
  {
    "Retail Branding": "Soniq",
    "Marketing Name": "PT1019A",
    "Device": "PT1019A",
    "Model": "PT1019A"
  },
  {
    "Retail Branding": "Soniq",
    "Marketing Name": "Smart TV",
    "Device": "mateo",
    "Model": "2K PA Smart TV"
  },
  {
    "Retail Branding": "Soniq",
    "Marketing Name": "Smart TV",
    "Device": "osaki",
    "Model": "2K AI Smart TV"
  },
  {
    "Retail Branding": "Soniq",
    "Marketing Name": "Soniq android TV",
    "Device": "hanyang",
    "Model": "SONIQ Android TV"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "",
    "Device": "C5503",
    "Model": "C5503"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "",
    "Device": "C6616",
    "Model": "C6616"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "",
    "Device": "SGP312",
    "Model": "SGP312"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "",
    "Device": "ST21i",
    "Model": "ST21i"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "",
    "Device": "ST23i",
    "Model": "ST23i"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "",
    "Device": "ST26i",
    "Model": "ST26i"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "",
    "Device": "nbx02",
    "Model": "Sony Tablet P"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "BRAVIA 2015",
    "Device": "SVP-DTV15",
    "Model": "BRAVIA 2015"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "BRAVIA 2K GB ATV3",
    "Device": "BRAVIA_ATV3_2K",
    "Model": "BRAVIA 2K GB ATV3"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "BRAVIA 4K 2015",
    "Device": "SVP-DTV15",
    "Model": "BRAVIA 2015"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "BRAVIA 4K 2015",
    "Device": "SVP-DTV15",
    "Model": "BRAVIA 4K 2015"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "BRAVIA 4K GB",
    "Device": "BRAVIA_ATV2",
    "Model": "BRAVIA 4K GB"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "BRAVIA 4K GB ATV3",
    "Device": "BRAVIA_ATV3_4K",
    "Model": "BRAVIA 4K GB ATV3"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "BRAVIA 4K UR1",
    "Device": "BRAVIA_UR1_4K",
    "Model": "BRAVIA 4K UR1"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "BRAVIA 4K UR2",
    "Device": "BRAVIA_UR2_4K",
    "Model": "BRAVIA 4K UR2"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "BRAVIA 4K UR3",
    "Device": "BRAVIA_UR3",
    "Model": "BRAVIA 4K UR3"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "BRAVIA AE M6L",
    "Device": "BRAVIA_AE_M6L",
    "Model": "BRAVIA 4K AE1"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "BRAVIA AE2",
    "Device": "BRAVIA_AE2",
    "Model": "BRAVIA 4K AE2"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "BRAVIA Smart Stick",
    "Device": "NSZGU1",
    "Model": "NSZ-GU1"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "BRAVIA TL",
    "Device": "OD0M_EA_T32",
    "Model": "BRAVIA TL"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "BRAVIA TL2",
    "Device": "OD0M_EA_T32",
    "Model": "BRAVIA TL2"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "BRAVIA VH1",
    "Device": "BRAVIA_VH1",
    "Model": "BRAVIA VH1"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "BRAVIA VH2",
    "Device": "BRAVIA_VH2",
    "Model": "BRAVIA 2K VH2"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "BRAVIA VH2",
    "Device": "BRAVIA_VH2",
    "Model": "BRAVIA 4K VH2"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "BRAVIA VH21",
    "Device": "BRAVIA_VH21",
    "Model": "BRAVIA 4K VH21"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "BRAVIA VH22",
    "Device": "BRAVIA_VH22",
    "Model": "BRAVIA 4K VH22"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "BRAVIA_BF1",
    "Device": "BRAVIA_BF1",
    "Model": "BRAVIA BF1"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "BRAVIA_BF1_4K_A",
    "Device": "BRAVIA_BF1",
    "Model": "BRAVIA BF1"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "BRAVIA_CT1",
    "Device": "BRAVIA_CT1",
    "Model": "BRAVIA CT1"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "BRAVIA_VH21",
    "Device": "BRAVIA_VH21",
    "Model": "BRAVIA 4K VH21"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "BRAVIA_VU",
    "Device": "BRAVIA_VU1",
    "Model": "BRAVIA VU1"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "BRAVIA_VU2",
    "Device": "BRAVIA_VU1_2K",
    "Model": "BRAVIA VU2"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "BRAVIA_VU2",
    "Device": "BRAVIA_VU1_4K",
    "Model": "BRAVIA VU2"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "BRAVIA_VU3",
    "Device": "BRAVIA_VU3_2K",
    "Model": "BRAVIA VU3"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "BRAVIA_VU3",
    "Device": "BRAVIA_VU3_4K",
    "Model": "BRAVIA VU3"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "BRAVIA_VU3.1",
    "Device": "BRAVIA_VU31_2K",
    "Model": "BRAVIA VU31"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "BRAVIA_VU3.1",
    "Device": "BRAVIA_VU31_4K",
    "Model": "BRAVIA VU31"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "BRAVIA_VU31",
    "Device": "BRAVIA_VU31_4K",
    "Model": "BRAVIA VU31"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Ericsson Live with Walkman",
    "Device": "WT19a",
    "Model": "WT19a"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Ericsson Live with Walkman",
    "Device": "WT19i",
    "Model": "WT19i"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Internet TV",
    "Device": "asura",
    "Model": "Internet TV"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Internet TV",
    "Device": "eagle",
    "Model": "Internet TV Box"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "NSZGS7",
    "Device": "NSZGS7",
    "Model": "NSZ-GS7/GX70"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "NW-A300Series",
    "Device": "icx1301",
    "Model": "NW-A300Series"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "NW-F800",
    "Device": "icx1227",
    "Model": "WALKMAN"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "NW-F880 Series",
    "Device": "icx1237",
    "Model": "WALKMAN"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "NW-WM1AM2",
    "Device": "icx1298",
    "Model": "NW-WM1AM2"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "NW-WM1ZM2",
    "Device": "icx1298",
    "Model": "NW-WM1ZM2"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "NW-Z1000",
    "Device": "icx1216",
    "Model": "NW-Z1000Series"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "NW-ZX1",
    "Device": "icx1240",
    "Model": "WALKMAN"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "NW-ZX2",
    "Device": "icx1265",
    "Model": "WALKMAN"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "NW-ZX700Series",
    "Device": "icx1302",
    "Model": "NW-ZX700Series"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "NWZ-Z1000",
    "Device": "icx1216",
    "Model": "NWZ-Z1000Series"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "NWZ-ZX1",
    "Device": "icx1240",
    "Model": "WALKMAN"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "PDT-FP1",
    "Device": "PDT-FP1",
    "Model": "PDT-FP1"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "SmartWatch 3",
    "Device": "tetra",
    "Model": "SmartWatch 3"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Smartphone Z Ultra Google Play edition",
    "Device": "",
    "Model": ""
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Smartphone Z Ultra Google Play edition",
    "Device": "C6806",
    "Model": "C6806_GPe"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Tablet P",
    "Device": "nbx02",
    "Model": "Sony Tablet P"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Tablet S",
    "Device": "nbx03",
    "Model": "Sony Tablet S"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia  E1 dual",
    "Device": "D2114",
    "Model": "D2114"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia  M",
    "Device": "C1905",
    "Model": "C1905"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia 1",
    "Device": "802SO",
    "Model": "802SO"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia 1",
    "Device": "J8110",
    "Model": "J8110"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia 1",
    "Device": "J8170",
    "Model": "J8170"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia 1",
    "Device": "J9110",
    "Model": "J9110"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia 1",
    "Device": "J9180",
    "Model": "J9180"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia 1",
    "Device": "SO-03L",
    "Model": "SO-03L"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia 1",
    "Device": "SOV40",
    "Model": "SOV40"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia 1 II",
    "Device": "SO-51A",
    "Model": "SO-51A"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia 1 II",
    "Device": "SOG01",
    "Model": "SOG01"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia 1 II",
    "Device": "XQ-AT42",
    "Model": "XQ-AT42"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia 1 II",
    "Device": "XQ-AT51",
    "Model": "XQ-AT51"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia 1 II",
    "Device": "XQ-AT52",
    "Model": "XQ-AT52"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia 1 II",
    "Device": "XQ-AT72",
    "Model": "XQ-AT72"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia 1 III",
    "Device": "A101SO",
    "Model": "A101SO"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia 1 III",
    "Device": "SO-51B",
    "Model": "SO-51B"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia 1 III",
    "Device": "SOG03",
    "Model": "SOG03"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia 1 III",
    "Device": "XQ-BC42",
    "Model": "XQ-BC42"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia 1 III",
    "Device": "XQ-BC52",
    "Model": "XQ-BC52"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia 1 III",
    "Device": "XQ-BC62",
    "Model": "XQ-BC62"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia 1 III",
    "Device": "XQ-BC72",
    "Model": "XQ-BC72"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia 1 IV",
    "Device": "A201SO",
    "Model": "A201SO"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia 1 IV",
    "Device": "SO-51C",
    "Model": "SO-51C"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia 1 IV",
    "Device": "SOG06",
    "Model": "SOG06"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia 1 IV",
    "Device": "XQ-CT44",
    "Model": "XQ-CT44"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia 1 IV",
    "Device": "XQ-CT54",
    "Model": "XQ-CT54"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia 1 IV",
    "Device": "XQ-CT62",
    "Model": "XQ-CT62"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia 1 IV",
    "Device": "XQ-CT72",
    "Model": "XQ-CT72"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia 1 Professional Edition",
    "Device": "J9150",
    "Model": "J9150"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia 1 V",
    "Device": "A301SO",
    "Model": "A301SO"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia 1 V",
    "Device": "SO-51D",
    "Model": "SO-51D"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia 1 V",
    "Device": "SOG10",
    "Model": "SOG10"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia 1 V",
    "Device": "XQ-DQ44",
    "Model": "XQ-DQ44"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia 1 V",
    "Device": "XQ-DQ54",
    "Model": "XQ-DQ54"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia 1 V",
    "Device": "XQ-DQ62",
    "Model": "XQ-DQ62"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia 1 V",
    "Device": "XQ-DQ72",
    "Model": "XQ-DQ72"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia 1 VI",
    "Device": "A401SO",
    "Model": "A401SO"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia 1 VI",
    "Device": "SO-51E",
    "Model": "SO-51E"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia 1 VI",
    "Device": "SOG13",
    "Model": "SOG13"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia 1 VI",
    "Device": "XQ-EC44",
    "Model": "XQ-EC44"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia 1 VI",
    "Device": "XQ-EC54",
    "Model": "XQ-EC54"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia 1 VI",
    "Device": "XQ-EC72",
    "Model": "XQ-EC72"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia 1 VII",
    "Device": "SO-51F",
    "Model": "SO-51F"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia 1 VII",
    "Device": "XQ-FS",
    "Model": "A501SO"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia 1 VII",
    "Device": "XQ-FS",
    "Model": "SOG15"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia 1 VII",
    "Device": "XQ-FS",
    "Model": "XQ-FS44"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia 1 VII",
    "Device": "XQ-FS",
    "Model": "XQ-FS54"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia 1 VII",
    "Device": "XQ-FS",
    "Model": "XQ-FS72"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia 10",
    "Device": "I3113",
    "Model": "I3113"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia 10",
    "Device": "I3123",
    "Model": "I3123"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia 10",
    "Device": "I4113",
    "Model": "I4113"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia 10",
    "Device": "I4193",
    "Model": "I4193"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia 10 II",
    "Device": "A001SO",
    "Model": "A001SO"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia 10 II",
    "Device": "SO-41A",
    "Model": "SO-41A"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia 10 II",
    "Device": "SOV43",
    "Model": "SOV43"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia 10 II",
    "Device": "XQ-AU42",
    "Model": "XQ-AU42"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia 10 II",
    "Device": "XQ-AU51",
    "Model": "XQ-AU51"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia 10 II",
    "Device": "XQ-AU52",
    "Model": "XQ-AU52"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia 10 III",
    "Device": "A102SO",
    "Model": "A102SO"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia 10 III",
    "Device": "SO-52B",
    "Model": "SO-52B"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia 10 III",
    "Device": "SOG04",
    "Model": "SOG04"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia 10 III",
    "Device": "XQ-BT52",
    "Model": "XQ-BT52"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia 10 III Lite",
    "Device": "XQ-BT44",
    "Model": "XQ-BT44"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia 10 IV",
    "Device": "A202SO",
    "Model": "A202SO"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia 10 IV",
    "Device": "SO-52C",
    "Model": "SO-52C"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia 10 IV",
    "Device": "SOG07",
    "Model": "SOG07"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia 10 IV",
    "Device": "XQ-CC44",
    "Model": "XQ-CC44"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia 10 IV",
    "Device": "XQ-CC54",
    "Model": "XQ-CC54"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia 10 IV",
    "Device": "XQ-CC72",
    "Model": "XQ-CC72"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia 10 Plus",
    "Device": "I3213",
    "Model": "I3213"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia 10 Plus",
    "Device": "I3223",
    "Model": "I3223"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia 10 Plus",
    "Device": "I4213",
    "Model": "I4213"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia 10 Plus",
    "Device": "I4293",
    "Model": "I4293"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia 10 V",
    "Device": "A302SO",
    "Model": "A302SO"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia 10 V",
    "Device": "SO-52D",
    "Model": "SO-52D"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia 10 V",
    "Device": "SOG11",
    "Model": "SOG11"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia 10 V",
    "Device": "XQ-DC44",
    "Model": "XQ-DC44"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia 10 V",
    "Device": "XQ-DC54",
    "Model": "XQ-DC54"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia 10 V",
    "Device": "XQ-DC72",
    "Model": "XQ-DC72"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia 10 VI",
    "Device": "A402SO",
    "Model": "A402SO"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia 10 VI",
    "Device": "SO-52E",
    "Model": "SO-52E"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia 10 VI",
    "Device": "SOG14",
    "Model": "SOG14"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia 10 VI",
    "Device": "XQ-ES44",
    "Model": "XQ-ES44"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia 10 VI",
    "Device": "XQ-ES54",
    "Model": "XQ-ES54"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia 10 VI",
    "Device": "XQ-ES72",
    "Model": "XQ-ES72"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia 10 VII",
    "Device": "SO-52F",
    "Model": "SO-52F"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia 10 VII",
    "Device": "XQ-FE",
    "Model": "A502SO"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia 10 VII",
    "Device": "XQ-FE",
    "Model": "SOG16"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia 10 VII",
    "Device": "XQ-FE",
    "Model": "XQ-FE44"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia 10 VII",
    "Device": "XQ-FE",
    "Model": "XQ-FE54"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia 10 VII",
    "Device": "XQ-FE",
    "Model": "XQ-FE72"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia 5",
    "Device": "901SO",
    "Model": "901SO"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia 5",
    "Device": "J8210",
    "Model": "J8210"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia 5",
    "Device": "J8270",
    "Model": "J8270"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia 5",
    "Device": "J9210",
    "Model": "J9210"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia 5",
    "Device": "J9260",
    "Model": "J9260"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia 5",
    "Device": "SO-01M",
    "Model": "SO-01M"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia 5",
    "Device": "SOV41",
    "Model": "SOV41"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia 5 II",
    "Device": "A002SO",
    "Model": "A002SO"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia 5 II",
    "Device": "SO-52A",
    "Model": "SO-52A"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia 5 II",
    "Device": "SOG02",
    "Model": "SOG02"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia 5 II",
    "Device": "XQ-AS42",
    "Model": "XQ-AS42"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia 5 II",
    "Device": "XQ-AS52",
    "Model": "XQ-AS52"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia 5 II",
    "Device": "XQ-AS62",
    "Model": "XQ-AS62"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia 5 II",
    "Device": "XQ-AS72",
    "Model": "XQ-AS72"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia 5 III",
    "Device": "A103SO",
    "Model": "A103SO"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia 5 III",
    "Device": "SO-53B",
    "Model": "SO-53B"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia 5 III",
    "Device": "SOG05",
    "Model": "SOG05"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia 5 III",
    "Device": "XQ-BQ42",
    "Model": "XQ-BQ42"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia 5 III",
    "Device": "XQ-BQ52",
    "Model": "XQ-BQ52"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia 5 III",
    "Device": "XQ-BQ62",
    "Model": "XQ-BQ62"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia 5 III",
    "Device": "XQ-BQ72",
    "Model": "XQ-BQ72"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia 5 IV",
    "Device": "A204SO",
    "Model": "A204SO"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia 5 IV",
    "Device": "SO-54C",
    "Model": "SO-54C"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia 5 IV",
    "Device": "SOG09",
    "Model": "SOG09"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia 5 IV",
    "Device": "XQ-CQ44",
    "Model": "XQ-CQ44"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia 5 IV",
    "Device": "XQ-CQ54",
    "Model": "XQ-CQ54"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia 5 IV",
    "Device": "XQ-CQ62",
    "Model": "XQ-CQ62"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia 5 IV",
    "Device": "XQ-CQ72",
    "Model": "XQ-CQ72"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia 5 V",
    "Device": "SO-53D",
    "Model": "SO-53D"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia 5 V",
    "Device": "SOG12",
    "Model": "SOG12"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia 5 V",
    "Device": "XQ-DE44",
    "Model": "XQ-DE44"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia 5 V",
    "Device": "XQ-DE54",
    "Model": "XQ-DE54"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia 5 V",
    "Device": "XQ-DE72",
    "Model": "XQ-DE72"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia 8",
    "Device": "902SO",
    "Model": "902SO"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia 8",
    "Device": "SOV42",
    "Model": "SOV42"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia 8",
    "Device": "SOV42-u",
    "Model": "SOV42-u"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia 8 Lite",
    "Device": "J3273",
    "Model": "J3273"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia A",
    "Device": "SO-04E",
    "Model": "SO-04E"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia A2",
    "Device": "SO-04F",
    "Model": "SO-04F"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia A4",
    "Device": "SO-04G",
    "Model": "SO-04G"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia Ace",
    "Device": "J3173",
    "Model": "J3173"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia Ace",
    "Device": "SO-02L",
    "Model": "SO-02L"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia Ace II",
    "Device": "SO-41B",
    "Model": "SO-41B"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia Ace III",
    "Device": "A203SO",
    "Model": "A203SO"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia Ace III",
    "Device": "SO-53C",
    "Model": "SO-53C"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia Ace III",
    "Device": "SOG08",
    "Model": "SOG08"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia C",
    "Device": "C2304",
    "Model": "C2304"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia C",
    "Device": "C2305",
    "Model": "C2305"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia C3",
    "Device": "D2533",
    "Model": "D2533"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia C3 Dual",
    "Device": "D2502",
    "Model": "D2502"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia C5 Ultra",
    "Device": "E5506",
    "Model": "E5506"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia C5 Ultra",
    "Device": "E5553",
    "Model": "E5553"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia C5 Ultra Dual",
    "Device": "E5533",
    "Model": "E5533"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia C5 Ultra Dual",
    "Device": "E5563",
    "Model": "E5563"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia E",
    "Device": "",
    "Model": ""
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia E",
    "Device": "C1504",
    "Model": "C1504"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia E",
    "Device": "C1505",
    "Model": "C1505"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia E dual",
    "Device": "C1604",
    "Model": "C1604"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia E dual",
    "Device": "C1605",
    "Model": "C1605"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia E1",
    "Device": "D2004",
    "Model": "D2004"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia E1",
    "Device": "D2005",
    "Model": "D2005"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia E1",
    "Device": "D2114",
    "Model": "D2114"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia E1 Dual",
    "Device": "D2104",
    "Model": "D2104"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia E1 Dual",
    "Device": "D2105",
    "Model": "D2105"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia E1 dual",
    "Device": "D2104",
    "Model": "D2104"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia E1 dual",
    "Device": "D2105",
    "Model": "D2105"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia E3",
    "Device": "D2202",
    "Model": "D2202"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia E3",
    "Device": "D2203",
    "Model": "D2203"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia E3",
    "Device": "D2206",
    "Model": "D2206"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia E3",
    "Device": "D2243",
    "Model": "D2243"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia E3 Dual",
    "Device": "D2212",
    "Model": "D2212"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia E4g",
    "Device": "E2053",
    "Model": "E2053"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia E4g Dual",
    "Device": "E2033",
    "Model": "E2033"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia E4g Dual",
    "Device": "E2043",
    "Model": "E2043"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia E5",
    "Device": "F3311",
    "Model": "F3311"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia E5",
    "Device": "F3313",
    "Model": "F3313"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia Go",
    "Device": "ST27a",
    "Model": "ST27a"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia Go",
    "Device": "ST27i",
    "Model": "ST27i"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia Hello",
    "Device": "G1209",
    "Model": "G1209"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia J",
    "Device": "ST26a",
    "Model": "ST26a"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia J",
    "Device": "ST26i",
    "Model": "ST26i"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia J1 Compact",
    "Device": "D5788",
    "Model": "D5788"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia L",
    "Device": "",
    "Model": ""
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia L",
    "Device": "C2104",
    "Model": "C2104"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia L",
    "Device": "C2105",
    "Model": "C2105"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia L1",
    "Device": "G3311",
    "Model": "G3311"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia L1",
    "Device": "G3312",
    "Model": "G3312"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia L1",
    "Device": "G3313",
    "Model": "G3313"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia L2",
    "Device": "H3311",
    "Model": "H3311"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia L2",
    "Device": "H3321",
    "Model": "H3321"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia L2",
    "Device": "H4311",
    "Model": "H4311"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia L2",
    "Device": "H4331",
    "Model": "H4331"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia L3",
    "Device": "I3312",
    "Model": "I3312"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia L3",
    "Device": "I4312",
    "Model": "I4312"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia L3",
    "Device": "I4332",
    "Model": "I4332"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia L4",
    "Device": "XQ-AD51",
    "Model": "XQ-AD51"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia L4",
    "Device": "XQ-AD52",
    "Model": "XQ-AD52"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia M",
    "Device": "C1904",
    "Model": "C1904"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia M",
    "Device": "C1905",
    "Model": "C1905"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia M Dual",
    "Device": "C2005",
    "Model": "C2005"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia M dual",
    "Device": "C2004",
    "Model": "C2004"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia M dual",
    "Device": "C2005",
    "Model": "C2005"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia M2",
    "Device": "D2303",
    "Model": "D2303"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia M2",
    "Device": "D2305",
    "Model": "D2305"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia M2",
    "Device": "D2306",
    "Model": "D2306"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia M2 Aqua",
    "Device": "D2403",
    "Model": "D2403"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia M2 Aqua",
    "Device": "D2406",
    "Model": "D2406"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia M2 Dual",
    "Device": "D2302",
    "Model": "D2302"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia M2 dual",
    "Device": "D2302",
    "Model": "D2302"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia M5",
    "Device": "E5603",
    "Model": "E5603"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia M5",
    "Device": "E5606",
    "Model": "E5606"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia M5",
    "Device": "E5653",
    "Model": "E5653"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia M5 Dual",
    "Device": "E5633",
    "Model": "E5633"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia M5 Dual",
    "Device": "E5643",
    "Model": "E5643"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia M5 Dual",
    "Device": "E5663",
    "Model": "E5663"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia Miro",
    "Device": "ST23i",
    "Model": "ST23i"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia P",
    "Device": "LT22i",
    "Model": "LT22i"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia PLAY",
    "Device": "R800a",
    "Model": "R800a"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia PLAY",
    "Device": "R800i",
    "Model": "R800i"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia PRO",
    "Device": "XQ-AQ52",
    "Model": "XQ-AQ52"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia PRO",
    "Device": "XQ-AQ62",
    "Model": "XQ-AQ62"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia PRO-I",
    "Device": "XQ-BE42",
    "Model": "XQ-BE42"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia PRO-I",
    "Device": "XQ-BE52",
    "Model": "XQ-BE52"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia PRO-I",
    "Device": "XQ-BE62",
    "Model": "XQ-BE62"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia PRO-I",
    "Device": "XQ-BE72",
    "Model": "XQ-BE72"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia R1",
    "Device": "G2199",
    "Model": "G2199"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia R1 Plus",
    "Device": "G2299",
    "Model": "G2299"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia S",
    "Device": "LT26i",
    "Model": "LT26i"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia SL",
    "Device": "LT26ii",
    "Model": "LT26ii"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia SP",
    "Device": "C5302",
    "Model": "C5302"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia SP",
    "Device": "C5303",
    "Model": "C5303"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia SP",
    "Device": "C5306",
    "Model": "C5306"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia SP",
    "Device": "M35h",
    "Model": "M35h"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia SP",
    "Device": "M35t",
    "Model": "M35t"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia T",
    "Device": "LT30a",
    "Model": "LT30a"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia T",
    "Device": "LT30p",
    "Model": "LT30p"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia T2 Ultra",
    "Device": "D5303",
    "Model": "D5303"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia T2 Ultra",
    "Device": "D5306",
    "Model": "D5306"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia T2 Ultra",
    "Device": "D5316",
    "Model": "D5316"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia T2 Ultra",
    "Device": "D5316N",
    "Model": "D5316N"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia T2 Ultra",
    "Device": "D5322",
    "Model": "D5322"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia T2 Ultra dual",
    "Device": "D5322",
    "Model": "D5322"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia T3",
    "Device": "D5102",
    "Model": "D5102"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia T3",
    "Device": "D5103",
    "Model": "D5103"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia T3",
    "Device": "D5106",
    "Model": "D5106"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia TX",
    "Device": "LT29i",
    "Model": "LT29i"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia Tablet S",
    "Device": "txs03",
    "Model": "SGPT12"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia Tablet S",
    "Device": "txs03",
    "Model": "SGPT13"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia Tablet Z",
    "Device": "SGP311",
    "Model": "SGP311"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia Tablet Z",
    "Device": "SGP312",
    "Model": "SGP312"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia Tablet Z",
    "Device": "SGP321",
    "Model": "SGP321"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia Tablet Z",
    "Device": "SGP351",
    "Model": "SGP351"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia Tipo",
    "Device": "ST21i",
    "Model": "ST21i"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia Tipo",
    "Device": "ST21i2",
    "Model": "ST21i2"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia Touch",
    "Device": "G1109",
    "Model": "G1109"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia U",
    "Device": "ST25a",
    "Model": "ST25a"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia U",
    "Device": "ST25i",
    "Model": "ST25i"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia V",
    "Device": "LT25i",
    "Model": "LT25i"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia X",
    "Device": "F5121",
    "Model": "F5121"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia X",
    "Device": "F5122",
    "Model": "F5122"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia X",
    "Device": "suzu",
    "Model": "F5121"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia X Compact",
    "Device": "F5321",
    "Model": "F5321"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia X Compact",
    "Device": "SO-02J",
    "Model": "SO-02J"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia X Performance",
    "Device": "502SO",
    "Model": "502SO"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia X Performance",
    "Device": "F8131",
    "Model": "F8131"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia X Performance",
    "Device": "F8132",
    "Model": "F8132"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia X Performance",
    "Device": "SO-04H",
    "Model": "SO-04H"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia X Performance",
    "Device": "SOV33",
    "Model": "SOV33"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia XA",
    "Device": "F3111",
    "Model": "F3111"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia XA",
    "Device": "F3112",
    "Model": "F3112"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia XA",
    "Device": "F3113",
    "Model": "F3113"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia XA",
    "Device": "F3115",
    "Model": "F3115"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia XA",
    "Device": "F3116",
    "Model": "F3116"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia XA Ultra",
    "Device": "F3211",
    "Model": "F3211"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia XA Ultra",
    "Device": "F3212",
    "Model": "F3212"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia XA Ultra",
    "Device": "F3213",
    "Model": "F3213"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia XA Ultra",
    "Device": "F3215",
    "Model": "F3215"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia XA Ultra",
    "Device": "F3216",
    "Model": "F3216"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia XA1",
    "Device": "G3112",
    "Model": "G3112"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia XA1",
    "Device": "G3116",
    "Model": "G3116"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia XA1",
    "Device": "G3121",
    "Model": "G3121"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia XA1",
    "Device": "G3123",
    "Model": "G3123"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia XA1",
    "Device": "G3125",
    "Model": "G3125"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia XA1 Plus",
    "Device": "G3412",
    "Model": "G3412"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia XA1 Plus",
    "Device": "G3416",
    "Model": "G3416"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia XA1 Plus",
    "Device": "G3421",
    "Model": "G3421"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia XA1 Plus",
    "Device": "G3423",
    "Model": "G3423"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia XA1 Plus",
    "Device": "G3426",
    "Model": "G3426"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia XA1 Ultra",
    "Device": "G3212",
    "Model": "G3212"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia XA1 Ultra",
    "Device": "G3221",
    "Model": "G3221"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia XA1 Ultra",
    "Device": "G3223",
    "Model": "G3223"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia XA1 Ultra",
    "Device": "G3226",
    "Model": "G3226"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia XA2",
    "Device": "H3113",
    "Model": "H3113"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia XA2",
    "Device": "H3123",
    "Model": "H3123"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia XA2",
    "Device": "H3133",
    "Model": "H3133"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia XA2",
    "Device": "H4113",
    "Model": "H4113"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia XA2",
    "Device": "H4133",
    "Model": "H4133"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia XA2 Plus",
    "Device": "H3413",
    "Model": "H3413"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia XA2 Plus",
    "Device": "H4413",
    "Model": "H4413"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia XA2 Plus",
    "Device": "H4493",
    "Model": "H4493"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia XA2 Ultra",
    "Device": "H3213",
    "Model": "H3213"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia XA2 Ultra",
    "Device": "H3223",
    "Model": "H3223"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia XA2 Ultra",
    "Device": "H4213",
    "Model": "H4213"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia XA2 Ultra",
    "Device": "H4233",
    "Model": "H4233"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia XZ",
    "Device": "601SO",
    "Model": "601SO"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia XZ",
    "Device": "F8331",
    "Model": "F8331"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia XZ",
    "Device": "F8332",
    "Model": "F8332"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia XZ",
    "Device": "SO-01J",
    "Model": "SO-01J"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia XZ",
    "Device": "SOV34",
    "Model": "SOV34"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia XZ Premium",
    "Device": "G8141",
    "Model": "G8141"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia XZ Premium",
    "Device": "G8142",
    "Model": "G8142"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia XZ Premium",
    "Device": "G8188",
    "Model": "G8188"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia XZ Premium",
    "Device": "SO-04J",
    "Model": "SO-04J"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia XZ1",
    "Device": "701SO",
    "Model": "701SO"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia XZ1",
    "Device": "G8341",
    "Model": "G8341"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia XZ1",
    "Device": "G8342",
    "Model": "G8342"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia XZ1",
    "Device": "G8343",
    "Model": "G8343"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia XZ1",
    "Device": "SO-01K",
    "Model": "SO-01K"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia XZ1",
    "Device": "SOV36",
    "Model": "SOV36"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia XZ1 Compact",
    "Device": "G8441",
    "Model": "G8441"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia XZ1 Compact",
    "Device": "SO-02K",
    "Model": "SO-02K"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia XZ2",
    "Device": "702SO",
    "Model": "702SO"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia XZ2",
    "Device": "H8216",
    "Model": "H8216"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia XZ2",
    "Device": "H8266",
    "Model": "H8266"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia XZ2",
    "Device": "H8276",
    "Model": "H8276"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia XZ2",
    "Device": "H8296",
    "Model": "H8296"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia XZ2",
    "Device": "SO-03K",
    "Model": "SO-03K"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia XZ2",
    "Device": "SOV37",
    "Model": "SOV37"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia XZ2 Compact",
    "Device": "H8314",
    "Model": "H8314"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia XZ2 Compact",
    "Device": "H8324",
    "Model": "H8324"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia XZ2 Compact",
    "Device": "SO-05K",
    "Model": "SO-05K"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia XZ2 Premium",
    "Device": "H8116",
    "Model": "H8116"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia XZ2 Premium",
    "Device": "H8166",
    "Model": "H8166"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia XZ2 Premium",
    "Device": "SO-04K",
    "Model": "SO-04K"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia XZ2 Premium",
    "Device": "SOV38",
    "Model": "SOV38"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia XZ3",
    "Device": "801SO",
    "Model": "801SO"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia XZ3",
    "Device": "H8416",
    "Model": "H8416"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia XZ3",
    "Device": "H9436",
    "Model": "H9436"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia XZ3",
    "Device": "H9493",
    "Model": "H9493"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia XZ3",
    "Device": "SO-01L",
    "Model": "SO-01L"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia XZ3",
    "Device": "SOV39",
    "Model": "SOV39"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia XZs",
    "Device": "602SO",
    "Model": "602SO"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia XZs",
    "Device": "G8231",
    "Model": "G8231"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia XZs",
    "Device": "G8232",
    "Model": "G8232"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia XZs",
    "Device": "SO-03J",
    "Model": "SO-03J"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia XZs",
    "Device": "SOV35",
    "Model": "SOV35"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia Z",
    "Device": "C6602",
    "Model": "C6602"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia Z",
    "Device": "C6603",
    "Model": "C6603"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia Z",
    "Device": "C6606",
    "Model": "C6606"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia Z",
    "Device": "C6616",
    "Model": "C6616"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia Z",
    "Device": "L36h",
    "Model": "L36h"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia Z",
    "Device": "SO-02E",
    "Model": "SO-02E"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia Z Ultra",
    "Device": "",
    "Model": ""
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia Z Ultra",
    "Device": "C6802",
    "Model": "C6802"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia Z Ultra",
    "Device": "C6806",
    "Model": "C6806"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia Z Ultra",
    "Device": "C6833",
    "Model": "C6833"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia Z Ultra",
    "Device": "C6843",
    "Model": "C6843"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia Z Ultra",
    "Device": "SGP412",
    "Model": "SGP412"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia Z Ultra",
    "Device": "SOL24",
    "Model": "SOL24"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia Z Ultra",
    "Device": "XL39h",
    "Model": "XL39h"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia Z1",
    "Device": "",
    "Model": ""
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia Z1",
    "Device": "C6902",
    "Model": "C6902"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia Z1",
    "Device": "C6903",
    "Model": "C6903"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia Z1",
    "Device": "C6906",
    "Model": "C6906"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia Z1",
    "Device": "C6916",
    "Model": "C6916"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia Z1",
    "Device": "C6943",
    "Model": "C6943"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia Z1",
    "Device": "L39h",
    "Model": "L39h"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia Z1",
    "Device": "L39t",
    "Model": "L39t"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia Z1",
    "Device": "L39u",
    "Model": "L39u"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia Z1",
    "Device": "SO-01F",
    "Model": "SO-01F"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia Z1",
    "Device": "SOL23",
    "Model": "SOL23"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia Z1 Compact",
    "Device": "D5503",
    "Model": "D5503"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia Z1 Compact",
    "Device": "M51w",
    "Model": "M51w"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia Z1f",
    "Device": "SO-02F",
    "Model": "SO-02F"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia Z2",
    "Device": "D6502",
    "Model": "D6502"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia Z2",
    "Device": "D6503",
    "Model": "D6503"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia Z2",
    "Device": "D6543",
    "Model": "D6543"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia Z2",
    "Device": "SO-03F",
    "Model": "SO-03F"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia Z2 Tablet",
    "Device": "SGP511",
    "Model": "SGP511"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia Z2 Tablet",
    "Device": "SGP512",
    "Model": "SGP512"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia Z2 Tablet",
    "Device": "SGP521",
    "Model": "SGP521"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia Z2 Tablet",
    "Device": "SGP551",
    "Model": "SGP551"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia Z2 Tablet",
    "Device": "SGP561",
    "Model": "SGP561"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia Z2 Tablet",
    "Device": "SO-05F",
    "Model": "SO-05F"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia Z2 Tablet",
    "Device": "SOT21",
    "Model": "SOT21"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia Z2a",
    "Device": "D6563",
    "Model": "D6563"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia Z3",
    "Device": "401SO",
    "Model": "401SO"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia Z3",
    "Device": "D6603",
    "Model": "D6603"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia Z3",
    "Device": "D6616",
    "Model": "D6616"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia Z3",
    "Device": "D6643",
    "Model": "D6643"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia Z3",
    "Device": "D6646",
    "Model": "D6646"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia Z3",
    "Device": "D6653",
    "Model": "D6653"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia Z3",
    "Device": "SO-01G",
    "Model": "SO-01G"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia Z3",
    "Device": "SOL26",
    "Model": "SOL26"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia Z3",
    "Device": "leo",
    "Model": "D6603"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia Z3 Compact",
    "Device": "D5803",
    "Model": "D5803"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia Z3 Compact",
    "Device": "D5833",
    "Model": "D5833"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia Z3 Compact",
    "Device": "SO-02G",
    "Model": "SO-02G"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia Z3 Compact",
    "Device": "aries",
    "Model": "D5803"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia Z3 Dual",
    "Device": "D6633",
    "Model": "D6633"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia Z3 Dual",
    "Device": "D6683",
    "Model": "D6683"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia Z3 Tablet Compact",
    "Device": "SGP611",
    "Model": "SGP611"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia Z3 Tablet Compact",
    "Device": "SGP612",
    "Model": "SGP612"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia Z3 Tablet Compact",
    "Device": "SGP621",
    "Model": "SGP621"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia Z3 Tablet Compact",
    "Device": "SGP641",
    "Model": "SGP641"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia Z3+",
    "Device": "E6553",
    "Model": "E6553"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia Z3+ Dual",
    "Device": "E6533",
    "Model": "E6533"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia Z3v",
    "Device": "D6708",
    "Model": "D6708"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia Z4",
    "Device": "402SO",
    "Model": "402SO"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia Z4",
    "Device": "SO-03G",
    "Model": "SO-03G"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia Z4",
    "Device": "SOV31",
    "Model": "SOV31"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia Z4 Tablet",
    "Device": "SGP712",
    "Model": "SGP712"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia Z4 Tablet",
    "Device": "SGP771",
    "Model": "SGP771"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia Z4 Tablet",
    "Device": "SO-05G",
    "Model": "SO-05G"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia Z4 Tablet",
    "Device": "SOT31",
    "Model": "SOT31"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia Z4v",
    "Device": "E6508",
    "Model": "E6508"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia Z5",
    "Device": "501SO",
    "Model": "501SO"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia Z5",
    "Device": "E6603",
    "Model": "E6603"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia Z5",
    "Device": "E6653",
    "Model": "E6653"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia Z5",
    "Device": "SO-01H",
    "Model": "SO-01H"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia Z5",
    "Device": "SOV32",
    "Model": "SOV32"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia Z5 Compact",
    "Device": "E5803",
    "Model": "E5803"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia Z5 Compact",
    "Device": "E5823",
    "Model": "E5823"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia Z5 Compact",
    "Device": "SO-02H",
    "Model": "SO-02H"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia Z5 Premium",
    "Device": "E6853",
    "Model": "E6853"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia Z5 Premium",
    "Device": "E6883",
    "Model": "E6883"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia Z5 Premium",
    "Device": "SO-03H",
    "Model": "SO-03H"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia Z5 Premium Dual",
    "Device": "E6833",
    "Model": "E6833"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia Z5 dual",
    "Device": "E6633",
    "Model": "E6633"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia Z5 dual",
    "Device": "E6683",
    "Model": "E6683"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia ZL",
    "Device": "C6502",
    "Model": "C6502"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia ZL",
    "Device": "C6503",
    "Model": "C6503"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia ZL",
    "Device": "C6506",
    "Model": "C6506"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia ZL",
    "Device": "L35h",
    "Model": "L35h"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia ZL2",
    "Device": "SOL25",
    "Model": "SOL25"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia ZR",
    "Device": "",
    "Model": ""
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia ZR",
    "Device": "C5306",
    "Model": "C5306"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia ZR",
    "Device": "C5502",
    "Model": "C5502"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia ZR",
    "Device": "C5503",
    "Model": "C5503"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia acro HD",
    "Device": "SO-03D",
    "Model": "SO-03D"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia acro S",
    "Device": "LT26w",
    "Model": "LT26w"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia active",
    "Device": "ST17i",
    "Model": "ST17i"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia arc S",
    "Device": "LT18i",
    "Model": "LT18i"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia go",
    "Device": "ST27i",
    "Model": "ST27i"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia ion",
    "Device": "LT28h",
    "Model": "LT28h"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia ion",
    "Device": "LT28i",
    "Model": "LT28i"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia mini pro",
    "Device": "SK17a",
    "Model": "SK17a"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia miro",
    "Device": "ST23a",
    "Model": "ST23a"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia miro",
    "Device": "ST23i",
    "Model": "ST23i"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia neo L",
    "Device": "MT25i",
    "Model": "MT25i"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia ray",
    "Device": "ST18i",
    "Model": "ST18i"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia sola",
    "Device": "MT27i",
    "Model": "MT27i"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia tipo",
    "Device": "ST21a",
    "Model": "ST21a"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia tipo dual",
    "Device": "ST21a2",
    "Model": "ST21a2"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia™ C4",
    "Device": "E5303",
    "Model": "E5303"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia™ C4",
    "Device": "E5306",
    "Model": "E5306"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia™ C4",
    "Device": "E5353",
    "Model": "E5353"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia™ C4 Dual",
    "Device": "E5333",
    "Model": "E5333"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia™ C4 Dual",
    "Device": "E5343",
    "Model": "E5343"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia™ C4 Dual",
    "Device": "E5363",
    "Model": "E5363"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia™ E4",
    "Device": "E2104",
    "Model": "E2104"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia™ E4",
    "Device": "E2105",
    "Model": "E2105"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia™ E4 Dual",
    "Device": "E2115",
    "Model": "E2115"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia™ E4 Dual",
    "Device": "E2124",
    "Model": "E2124"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia™ E4g",
    "Device": "E2003",
    "Model": "E2003"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia™ E4g",
    "Device": "E2006",
    "Model": "E2006"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia™ M4 Aqua",
    "Device": "E2303",
    "Model": "E2303"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia™ M4 Aqua",
    "Device": "E2306",
    "Model": "E2306"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia™ M4 Aqua",
    "Device": "E2353",
    "Model": "E2353"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia™ M4 Aqua Dual",
    "Device": "E2312",
    "Model": "E2312"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia™ M4 Aqua Dual",
    "Device": "E2333",
    "Model": "E2333"
  },
  {
    "Retail Branding": "Sony",
    "Marketing Name": "Xperia™ M4 Aqua Dual",
    "Device": "E2363",
    "Model": "E2363"
  },
  {
    "Retail Branding": "Sony Ericsson",
    "Marketing Name": "",
    "Device": "LT15a",
    "Model": "LT15a"
  },
  {
    "Retail Branding": "Sony Ericsson",
    "Marketing Name": "",
    "Device": "LT18i",
    "Model": "LT18i"
  },
  {
    "Retail Branding": "Sony Ericsson",
    "Marketing Name": "",
    "Device": "LT22i",
    "Model": "LT22i"
  },
  {
    "Retail Branding": "Sony Ericsson",
    "Marketing Name": "",
    "Device": "LT26i",
    "Model": "LT26i"
  },
  {
    "Retail Branding": "Sony Ericsson",
    "Marketing Name": "",
    "Device": "LT28h",
    "Model": "LT28h"
  },
  {
    "Retail Branding": "Sony Ericsson",
    "Marketing Name": "",
    "Device": "LT28i",
    "Model": "LT28i"
  },
  {
    "Retail Branding": "Sony Ericsson",
    "Marketing Name": "",
    "Device": "MK16a",
    "Model": "MK16a"
  },
  {
    "Retail Branding": "Sony Ericsson",
    "Marketing Name": "",
    "Device": "MK16i",
    "Model": "MK16i"
  },
  {
    "Retail Branding": "Sony Ericsson",
    "Marketing Name": "",
    "Device": "MT11i",
    "Model": "MT11i"
  },
  {
    "Retail Branding": "Sony Ericsson",
    "Marketing Name": "",
    "Device": "MT15i",
    "Model": "MT15i"
  },
  {
    "Retail Branding": "Sony Ericsson",
    "Marketing Name": "",
    "Device": "MT27i",
    "Model": "MT27i"
  },
  {
    "Retail Branding": "Sony Ericsson",
    "Marketing Name": "",
    "Device": "R800x",
    "Model": "R800x"
  },
  {
    "Retail Branding": "Sony Ericsson",
    "Marketing Name": "",
    "Device": "SK17i",
    "Model": "SK17i"
  },
  {
    "Retail Branding": "Sony Ericsson",
    "Marketing Name": "",
    "Device": "ST15i",
    "Model": "ST15i"
  },
  {
    "Retail Branding": "Sony Ericsson",
    "Marketing Name": "",
    "Device": "ST17i",
    "Model": "ST17i"
  },
  {
    "Retail Branding": "Sony Ericsson",
    "Marketing Name": "",
    "Device": "ST18i",
    "Model": "ST18i"
  },
  {
    "Retail Branding": "Sony Ericsson",
    "Marketing Name": "",
    "Device": "WT18i",
    "Model": "WT18i"
  },
  {
    "Retail Branding": "Sony Ericsson",
    "Marketing Name": "",
    "Device": "WT19a",
    "Model": "WT19a"
  },
  {
    "Retail Branding": "Sony Ericsson",
    "Marketing Name": "",
    "Device": "WT19i",
    "Model": "WT19i"
  },
  {
    "Retail Branding": "Sony Ericsson",
    "Marketing Name": "Live with Walkman",
    "Device": "WT19a",
    "Model": "WT19a"
  },
  {
    "Retail Branding": "Sony Ericsson",
    "Marketing Name": "Live with Walkman",
    "Device": "WT19i",
    "Model": "WT19i"
  },
  {
    "Retail Branding": "Sony Ericsson",
    "Marketing Name": "Live with Walkman(TM)",
    "Device": "WT19a",
    "Model": "WT19a"
  },
  {
    "Retail Branding": "Sony Ericsson",
    "Marketing Name": "X10 Xperia Mini",
    "Device": "robyn",
    "Model": "E10i"
  },
  {
    "Retail Branding": "Sony Ericsson",
    "Marketing Name": "Xperia AX",
    "Device": "SO-01E",
    "Model": "SO-01E"
  },
  {
    "Retail Branding": "Sony Ericsson",
    "Marketing Name": "Xperia Acro",
    "Device": "IS11S",
    "Model": "IS11S"
  },
  {
    "Retail Branding": "Sony Ericsson",
    "Marketing Name": "Xperia Acro",
    "Device": "SO-02C",
    "Model": "SO-02C"
  },
  {
    "Retail Branding": "Sony Ericsson",
    "Marketing Name": "Xperia Arc",
    "Device": "LT15i",
    "Model": "LT15i"
  },
  {
    "Retail Branding": "Sony Ericsson",
    "Marketing Name": "Xperia Arc",
    "Device": "SO-01C",
    "Model": "SO-01C"
  },
  {
    "Retail Branding": "Sony Ericsson",
    "Marketing Name": "Xperia C",
    "Device": "S39h",
    "Model": "S39h"
  },
  {
    "Retail Branding": "Sony Ericsson",
    "Marketing Name": "Xperia GX",
    "Device": "SO-04D",
    "Model": "SO-04D"
  },
  {
    "Retail Branding": "Sony Ericsson",
    "Marketing Name": "Xperia Go",
    "Device": "ST27a",
    "Model": "ST27a"
  },
  {
    "Retail Branding": "Sony Ericsson",
    "Marketing Name": "Xperia Go",
    "Device": "ST27i",
    "Model": "ST27i"
  },
  {
    "Retail Branding": "Sony Ericsson",
    "Marketing Name": "Xperia J",
    "Device": "ST26i",
    "Model": "ST26i"
  },
  {
    "Retail Branding": "Sony Ericsson",
    "Marketing Name": "Xperia Neo",
    "Device": "MT15i",
    "Model": "MT15i"
  },
  {
    "Retail Branding": "Sony Ericsson",
    "Marketing Name": "Xperia P",
    "Device": "LT22i",
    "Model": "LT22i"
  },
  {
    "Retail Branding": "Sony Ericsson",
    "Marketing Name": "Xperia PLAY",
    "Device": "R800a",
    "Model": "R800a"
  },
  {
    "Retail Branding": "Sony Ericsson",
    "Marketing Name": "Xperia PLAY",
    "Device": "R800at",
    "Model": "R800at"
  },
  {
    "Retail Branding": "Sony Ericsson",
    "Marketing Name": "Xperia PLAY",
    "Device": "R800i",
    "Model": "R800i"
  },
  {
    "Retail Branding": "Sony Ericsson",
    "Marketing Name": "Xperia PLAY",
    "Device": "R800x",
    "Model": "R800x"
  },
  {
    "Retail Branding": "Sony Ericsson",
    "Marketing Name": "Xperia PLAY",
    "Device": "SO-01D",
    "Model": "SO-01D"
  },
  {
    "Retail Branding": "Sony Ericsson",
    "Marketing Name": "Xperia Play",
    "Device": "R800i",
    "Model": "R800i"
  },
  {
    "Retail Branding": "Sony Ericsson",
    "Marketing Name": "Xperia Play",
    "Device": "Zeus",
    "Model": "Zeus"
  },
  {
    "Retail Branding": "Sony Ericsson",
    "Marketing Name": "Xperia S",
    "Device": "LT26i",
    "Model": "LT26i"
  },
  {
    "Retail Branding": "Sony Ericsson",
    "Marketing Name": "Xperia S",
    "Device": "SO-02D",
    "Model": "SO-02D"
  },
  {
    "Retail Branding": "Sony Ericsson",
    "Marketing Name": "Xperia SL",
    "Device": "LT26ii",
    "Model": "LT26ii"
  },
  {
    "Retail Branding": "Sony Ericsson",
    "Marketing Name": "Xperia SP",
    "Device": "M35c",
    "Model": "M35c"
  },
  {
    "Retail Branding": "Sony Ericsson",
    "Marketing Name": "Xperia SX",
    "Device": "SO-05D",
    "Model": "SO-05D"
  },
  {
    "Retail Branding": "Sony Ericsson",
    "Marketing Name": "Xperia T",
    "Device": "LT30a",
    "Model": "LT30a"
  },
  {
    "Retail Branding": "Sony Ericsson",
    "Marketing Name": "Xperia T",
    "Device": "LT30at",
    "Model": "LT30at"
  },
  {
    "Retail Branding": "Sony Ericsson",
    "Marketing Name": "Xperia T",
    "Device": "LT30p",
    "Model": "LT30p"
  },
  {
    "Retail Branding": "Sony Ericsson",
    "Marketing Name": "Xperia TX",
    "Device": "LT29i",
    "Model": "LT29i"
  },
  {
    "Retail Branding": "Sony Ericsson",
    "Marketing Name": "Xperia Tablet Z",
    "Device": "SGP311",
    "Model": "SGP311"
  },
  {
    "Retail Branding": "Sony Ericsson",
    "Marketing Name": "Xperia Tablet Z",
    "Device": "SGP321",
    "Model": "SGP321"
  },
  {
    "Retail Branding": "Sony Ericsson",
    "Marketing Name": "Xperia Tablet Z",
    "Device": "SGP341",
    "Model": "SGP341"
  },
  {
    "Retail Branding": "Sony Ericsson",
    "Marketing Name": "Xperia Tablet Z",
    "Device": "SO-03E",
    "Model": "SO-03E"
  },
  {
    "Retail Branding": "Sony Ericsson",
    "Marketing Name": "Xperia U",
    "Device": "ST25i",
    "Model": "ST25i"
  },
  {
    "Retail Branding": "Sony Ericsson",
    "Marketing Name": "Xperia UL",
    "Device": "SOL22",
    "Model": "SOL22"
  },
  {
    "Retail Branding": "Sony Ericsson",
    "Marketing Name": "Xperia V",
    "Device": "LT25c",
    "Model": "LT25c"
  },
  {
    "Retail Branding": "Sony Ericsson",
    "Marketing Name": "Xperia V",
    "Device": "LT25i",
    "Model": "LT25i"
  },
  {
    "Retail Branding": "Sony Ericsson",
    "Marketing Name": "Xperia VL",
    "Device": "SOL21",
    "Model": "SOL21"
  },
  {
    "Retail Branding": "Sony Ericsson",
    "Marketing Name": "Xperia X10",
    "Device": "SO-01B",
    "Model": "SO-01B"
  },
  {
    "Retail Branding": "Sony Ericsson",
    "Marketing Name": "Xperia X10",
    "Device": "SonyEricssonSO-01B",
    "Model": "SO-01B"
  },
  {
    "Retail Branding": "Sony Ericsson",
    "Marketing Name": "Xperia X10",
    "Device": "SonyEricssonX10iv",
    "Model": "X10i"
  },
  {
    "Retail Branding": "Sony Ericsson",
    "Marketing Name": "Xperia X10",
    "Device": "X10a",
    "Model": "X10a"
  },
  {
    "Retail Branding": "Sony Ericsson",
    "Marketing Name": "Xperia X10",
    "Device": "X10i",
    "Model": "X10i"
  },
  {
    "Retail Branding": "Sony Ericsson",
    "Marketing Name": "Xperia X10 Mini",
    "Device": "E10i",
    "Model": "E10i"
  },
  {
    "Retail Branding": "Sony Ericsson",
    "Marketing Name": "Xperia X10 Mini",
    "Device": "SonyEricssonE10i",
    "Model": "E10i"
  },
  {
    "Retail Branding": "Sony Ericsson",
    "Marketing Name": "Xperia X10 Mini Pro",
    "Device": "U20i",
    "Model": "U20i"
  },
  {
    "Retail Branding": "Sony Ericsson",
    "Marketing Name": "Xperia X10 mini",
    "Device": "SonyEricssonE10a",
    "Model": "E10a"
  },
  {
    "Retail Branding": "Sony Ericsson",
    "Marketing Name": "Xperia X10 mini pro",
    "Device": "SonyEricssonU20a",
    "Model": "U20a"
  },
  {
    "Retail Branding": "Sony Ericsson",
    "Marketing Name": "Xperia X8",
    "Device": "E15i",
    "Model": "E15i"
  },
  {
    "Retail Branding": "Sony Ericsson",
    "Marketing Name": "Xperia Z",
    "Device": "SO-02E",
    "Model": "SO-02E"
  },
  {
    "Retail Branding": "Sony Ericsson",
    "Marketing Name": "Xperia Z Ultra",
    "Device": "",
    "Model": ""
  },
  {
    "Retail Branding": "Sony Ericsson",
    "Marketing Name": "Xperia Z Ultra",
    "Device": "C6806",
    "Model": "C6806"
  },
  {
    "Retail Branding": "Sony Ericsson",
    "Marketing Name": "Xperia Z1",
    "Device": "",
    "Model": ""
  },
  {
    "Retail Branding": "Sony Ericsson",
    "Marketing Name": "Xperia Z1",
    "Device": "C6903",
    "Model": "C6903"
  },
  {
    "Retail Branding": "Sony Ericsson",
    "Marketing Name": "Xperia Z1",
    "Device": "C6906",
    "Model": "C6906"
  },
  {
    "Retail Branding": "Sony Ericsson",
    "Marketing Name": "Xperia Z1",
    "Device": "C6943",
    "Model": "C6943"
  },
  {
    "Retail Branding": "Sony Ericsson",
    "Marketing Name": "Xperia acro HD",
    "Device": "IS12S",
    "Model": "IS12S"
  },
  {
    "Retail Branding": "Sony Ericsson",
    "Marketing Name": "Xperia acro S",
    "Device": "LT26w",
    "Model": "LT26w"
  },
  {
    "Retail Branding": "Sony Ericsson",
    "Marketing Name": "Xperia active",
    "Device": "ST17i",
    "Model": "ST17i"
  },
  {
    "Retail Branding": "Sony Ericsson",
    "Marketing Name": "Xperia arc",
    "Device": "LT15a",
    "Model": "LT15a"
  },
  {
    "Retail Branding": "Sony Ericsson",
    "Marketing Name": "Xperia arc",
    "Device": "LT15i",
    "Model": "LT15i"
  },
  {
    "Retail Branding": "Sony Ericsson",
    "Marketing Name": "Xperia arc S",
    "Device": "LT18a",
    "Model": "LT18a"
  },
  {
    "Retail Branding": "Sony Ericsson",
    "Marketing Name": "Xperia arc S",
    "Device": "LT18i",
    "Model": "LT18i"
  },
  {
    "Retail Branding": "Sony Ericsson",
    "Marketing Name": "Xperia go",
    "Device": "ST27i",
    "Model": "ST27i"
  },
  {
    "Retail Branding": "Sony Ericsson",
    "Marketing Name": "Xperia ion",
    "Device": "LT28at",
    "Model": "LT28at"
  },
  {
    "Retail Branding": "Sony Ericsson",
    "Marketing Name": "Xperia ion",
    "Device": "LT28h",
    "Model": "LT28h"
  },
  {
    "Retail Branding": "Sony Ericsson",
    "Marketing Name": "Xperia ion",
    "Device": "LT28i",
    "Model": "LT28i"
  },
  {
    "Retail Branding": "Sony Ericsson",
    "Marketing Name": "Xperia live",
    "Device": "WT19a",
    "Model": "WT19a"
  },
  {
    "Retail Branding": "Sony Ericsson",
    "Marketing Name": "Xperia mini",
    "Device": "S51SE",
    "Model": "S51SE"
  },
  {
    "Retail Branding": "Sony Ericsson",
    "Marketing Name": "Xperia mini",
    "Device": "ST15a",
    "Model": "ST15a"
  },
  {
    "Retail Branding": "Sony Ericsson",
    "Marketing Name": "Xperia mini",
    "Device": "ST15i",
    "Model": "ST15i"
  },
  {
    "Retail Branding": "Sony Ericsson",
    "Marketing Name": "Xperia mini pro",
    "Device": "SK17a",
    "Model": "SK17a"
  },
  {
    "Retail Branding": "Sony Ericsson",
    "Marketing Name": "Xperia mini pro",
    "Device": "SK17i",
    "Model": "SK17i"
  },
  {
    "Retail Branding": "Sony Ericsson",
    "Marketing Name": "Xperia miro",
    "Device": "ST23i",
    "Model": "ST23i"
  },
  {
    "Retail Branding": "Sony Ericsson",
    "Marketing Name": "Xperia neo",
    "Device": "MT15a",
    "Model": "MT15a"
  },
  {
    "Retail Branding": "Sony Ericsson",
    "Marketing Name": "Xperia neo",
    "Device": "MT15i",
    "Model": "MT15i"
  },
  {
    "Retail Branding": "Sony Ericsson",
    "Marketing Name": "Xperia neo L",
    "Device": "MT25i",
    "Model": "MT25i"
  },
  {
    "Retail Branding": "Sony Ericsson",
    "Marketing Name": "Xperia neo V",
    "Device": "MT11a",
    "Model": "MT11a"
  },
  {
    "Retail Branding": "Sony Ericsson",
    "Marketing Name": "Xperia neo V",
    "Device": "MT11i",
    "Model": "MT11i"
  },
  {
    "Retail Branding": "Sony Ericsson",
    "Marketing Name": "Xperia pro",
    "Device": "MK16a",
    "Model": "MK16a"
  },
  {
    "Retail Branding": "Sony Ericsson",
    "Marketing Name": "Xperia ray",
    "Device": "SO-03C",
    "Model": "SO-03C"
  },
  {
    "Retail Branding": "Sony Ericsson",
    "Marketing Name": "Xperia ray",
    "Device": "ST18a",
    "Model": "ST18a"
  },
  {
    "Retail Branding": "Sony Ericsson",
    "Marketing Name": "Xperia ray",
    "Device": "ST18i",
    "Model": "ST18i"
  },
  {
    "Retail Branding": "Sony Ericsson",
    "Marketing Name": "Xperia sola",
    "Device": "MT27i",
    "Model": "MT27i"
  },
  {
    "Retail Branding": "Sony Ericsson",
    "Marketing Name": "Xperia tipo",
    "Device": "ST21i",
    "Model": "ST21i"
  },
  {
    "Retail Branding": "Sony Ericsson",
    "Marketing Name": "Xperia tipo dual",
    "Device": "ST21i2",
    "Model": "ST21i2"
  },
  {
    "Retail Branding": "Sony Ericsson",
    "Marketing Name": "Xperia_pro",
    "Device": "MK16i",
    "Model": "MK16i"
  },
  {
    "Retail Branding": "SonyAudio",
    "Marketing Name": "NW-A100",
    "Device": "icx1293",
    "Model": "NW-A100Series"
  },
  {
    "Retail Branding": "SonyAudio",
    "Marketing Name": "NW-ZX500",
    "Device": "icx1295",
    "Model": "NW-ZX500Series"
  },
  {
    "Retail Branding": "Sophix_Digix",
    "Marketing Name": "TAB-750_G",
    "Device": "TAB-750_G",
    "Model": "TAB-750_G"
  },
  {
    "Retail Branding": "Sosh",
    "Marketing Name": "SoshPhone",
    "Device": "SoshPhone",
    "Model": "SoshPhone"
  },
  {
    "Retail Branding": "Soultech",
    "Marketing Name": "TB001",
    "Device": "TB001",
    "Model": "TB001"
  },
  {
    "Retail Branding": "Sourcing Creation",
    "Marketing Name": "Connect 451",
    "Device": "Connect451",
    "Model": "Connect 451"
  },
  {
    "Retail Branding": "Sourcing Creation",
    "Marketing Name": "Connect 504",
    "Device": "Q9",
    "Model": "Connect504"
  },
  {
    "Retail Branding": "Sourcing Creation",
    "Marketing Name": "Connect502",
    "Device": "Connect502",
    "Model": "Connect502"
  },
  {
    "Retail Branding": "Sourcing Creation",
    "Marketing Name": "Connect502",
    "Device": "MT502",
    "Model": "Connect502"
  },
  {
    "Retail Branding": "Sourcing Creation",
    "Marketing Name": "Connect551",
    "Device": "Connect551",
    "Model": "Connect551"
  },
  {
    "Retail Branding": "Sourcing Creation",
    "Marketing Name": "Key\\'TAB 1001",
    "Device": "MB979T9",
    "Model": "Smarttab_9701"
  },
  {
    "Retail Branding": "Sourcing Creation",
    "Marketing Name": "SP402",
    "Device": "SP402",
    "Model": "SP402"
  },
  {
    "Retail Branding": "Sourcing Creation",
    "Marketing Name": "ST1003S",
    "Device": "T1882R",
    "Model": "Smart_TAB_1003s"
  },
  {
    "Retail Branding": "Sourcing Creation",
    "Marketing Name": "Smart TAB 1005",
    "Device": "M16Q1C",
    "Model": "SmartTab1005"
  },
  {
    "Retail Branding": "Sourcing Creation",
    "Marketing Name": "Smart Tab 1004XS",
    "Device": "SmartTab_1004_XS",
    "Model": "SmartTab_1004_XS"
  },
  {
    "Retail Branding": "Sourcing Creation",
    "Marketing Name": "Smart Tab 1006",
    "Device": "M16Q1A",
    "Model": "SmartTab1006"
  },
  {
    "Retail Branding": "Sourcing Creation",
    "Marketing Name": "Smart\\' Tab 1006",
    "Device": "M16Q1A",
    "Model": "SmartTab1006"
  },
  {
    "Retail Branding": "Sourcing Creation",
    "Marketing Name": "SmartTab_8004",
    "Device": "T814",
    "Model": "SmartTab_8004"
  },
  {
    "Retail Branding": "Sourcing Creation",
    "Marketing Name": "Web\\'Pad_1002_02",
    "Device": "Webpad_1002_02",
    "Model": "Webpad_1002_02"
  },
  {
    "Retail Branding": "Sourcing Creation",
    "Marketing Name": "WebPad1004",
    "Device": "WebPad1004",
    "Model": "WebPad1004"
  },
  {
    "Retail Branding": "Sourcing Creation",
    "Marketing Name": "WebPad7007",
    "Device": "WebPad7007",
    "Model": "WebPad7007"
  },
  {
    "Retail Branding": "Sourcing Creation",
    "Marketing Name": "WebPad_1003",
    "Device": "WebPad_1003",
    "Model": "WebPad_1003"
  },
  {
    "Retail Branding": "Sourcing Creation",
    "Marketing Name": "Webpad7006",
    "Device": "ES721",
    "Model": "Webpad7006"
  },
  {
    "Retail Branding": "Sourcing Creation",
    "Marketing Name": "Wooze I 5",
    "Device": "Wooze_I5",
    "Model": "Wooze_I5"
  },
  {
    "Retail Branding": "Sourcing Creation",
    "Marketing Name": "Wooze I 5.5 Gris",
    "Device": "Wooze_I55",
    "Model": "Wooze_I55"
  },
  {
    "Retail Branding": "Sourcing Creation",
    "Marketing Name": "Wooze L",
    "Device": "Wooze_L",
    "Model": "Wooze_L"
  },
  {
    "Retail Branding": "Sourcing Creation",
    "Marketing Name": "Wooze XL",
    "Device": "Wooze_XL",
    "Model": "Wooze_XL"
  },
  {
    "Retail Branding": "Sourcing Creation",
    "Marketing Name": "WoozeI45",
    "Device": "WoozeI45",
    "Model": "WoozeI45"
  },
  {
    "Retail Branding": "Sourcing Creation",
    "Marketing Name": "sp401",
    "Device": "sp401",
    "Model": "sp401"
  },
  {
    "Retail Branding": "Sourcing Creation",
    "Marketing Name": "webpad_7005",
    "Device": "MB709Q5",
    "Model": "Webpad_7005"
  },
  {
    "Retail Branding": "Southern Telecom",
    "Marketing Name": "A1000/P1003/P1010",
    "Device": "A1000",
    "Model": "A1000/P1003/P1010"
  },
  {
    "Retail Branding": "Southern Telecom",
    "Marketing Name": "A400",
    "Device": "A400",
    "Model": "A400"
  },
  {
    "Retail Branding": "Southern Telecom",
    "Marketing Name": "A5",
    "Device": "A5",
    "Model": "A5"
  },
  {
    "Retail Branding": "Southern Telecom",
    "Marketing Name": "A500",
    "Device": "Polaroid_Phone",
    "Model": "a500"
  },
  {
    "Retail Branding": "Southern Telecom",
    "Marketing Name": "A600",
    "Device": "A600",
    "Model": "A600"
  },
  {
    "Retail Branding": "Southern Telecom",
    "Marketing Name": "Emerson EM756",
    "Device": "EM756",
    "Model": "EM756"
  },
  {
    "Retail Branding": "Southern Telecom",
    "Marketing Name": "M10",
    "Device": "ST1009",
    "Model": "M10"
  },
  {
    "Retail Branding": "Southern Telecom",
    "Marketing Name": "M10",
    "Device": "ST1009",
    "Model": "M10/Q1010"
  },
  {
    "Retail Branding": "Southern Telecom",
    "Marketing Name": "M11H/Q1100",
    "Device": "M11H",
    "Model": "M11H/Q1100"
  },
  {
    "Retail Branding": "Southern Telecom",
    "Marketing Name": "P709/P716",
    "Device": "P709",
    "Model": "P709/P716"
  },
  {
    "Retail Branding": "Southern Telecom",
    "Marketing Name": "P7100",
    "Device": "P7100",
    "Model": "P7100"
  },
  {
    "Retail Branding": "Southern Telecom",
    "Marketing Name": "P909",
    "Device": "P909",
    "Model": "P909"
  },
  {
    "Retail Branding": "Southern Telecom",
    "Marketing Name": "PDT9000",
    "Device": "PDT9000",
    "Model": "PDT9000"
  },
  {
    "Retail Branding": "Southern Telecom",
    "Marketing Name": "Polaroid L10/P1000",
    "Device": "L10",
    "Model": "L10"
  },
  {
    "Retail Branding": "Southern Telecom",
    "Marketing Name": "Polaroid M11",
    "Device": "M11",
    "Model": "M11"
  },
  {
    "Retail Branding": "Southern Telecom",
    "Marketing Name": "Polaroid P700/A700",
    "Device": "P700",
    "Model": "P700/A700"
  },
  {
    "Retail Branding": "Southern Telecom",
    "Marketing Name": "Polaroid P902/A900",
    "Device": "P902",
    "Model": "P902/A900"
  },
  {
    "Retail Branding": "Southern Telecom",
    "Marketing Name": "Polaroid Power P600",
    "Device": "P600",
    "Model": "P600"
  },
  {
    "Retail Branding": "Southern Telecom",
    "Marketing Name": "Polaroid Snap S50",
    "Device": "S50",
    "Model": "S50"
  },
  {
    "Retail Branding": "Southern Telecom",
    "Marketing Name": "Polaroid Snap S55",
    "Device": "S55",
    "Model": "S55"
  },
  {
    "Retail Branding": "Southern Telecom",
    "Marketing Name": "Polaroid Snap S60",
    "Device": "S60",
    "Model": "S60"
  },
  {
    "Retail Branding": "Southern Telecom",
    "Marketing Name": "ST1009",
    "Device": "ST1009",
    "Model": "ST1009"
  },
  {
    "Retail Branding": "Southern Telecom",
    "Marketing Name": "ST13",
    "Device": "ST13",
    "Model": "ST13"
  },
  {
    "Retail Branding": "Southern Telecom",
    "Marketing Name": "ST706",
    "Device": "P709",
    "Model": "ST706"
  },
  {
    "Retail Branding": "Southern Telecom",
    "Marketing Name": "Smartab ST10",
    "Device": "ST10",
    "Model": "ST10/ST10x"
  },
  {
    "Retail Branding": "Southern Telecom",
    "Marketing Name": "Smartab ST7",
    "Device": "ST7",
    "Model": "ST7/ST7x"
  },
  {
    "Retail Branding": "Southern Telecom",
    "Marketing Name": "Streamachine",
    "Device": "X13",
    "Model": "X13"
  },
  {
    "Retail Branding": "Southern Telecom",
    "Marketing Name": "a4",
    "Device": "a4",
    "Model": "a4"
  },
  {
    "Retail Branding": "SoyMomo",
    "Marketing Name": "LATAM and America",
    "Device": "SoyMomo_Lite_V2",
    "Model": "SoyMomo_Lite_V2"
  },
  {
    "Retail Branding": "SoyMomo",
    "Marketing Name": "S8-RK3368",
    "Device": "S8-RK3368",
    "Model": "S8-RK3368"
  },
  {
    "Retail Branding": "SoyMomo",
    "Marketing Name": "SoyMomoLite_V2C",
    "Device": "SoyMomoLite_V2C",
    "Model": "SoyMomoLite_V2C"
  },
  {
    "Retail Branding": "SoyMomo",
    "Marketing Name": "SoyMomo_Lite_V1",
    "Device": "SoyMomo_Lite_V1",
    "Model": "SoyMomo_Lite_V1"
  },
  {
    "Retail Branding": "SoyMomo",
    "Marketing Name": "SoyMomo_Lite_V1_EEA",
    "Device": "SoyMomo_Lite_V1",
    "Model": "SoyMomo_Lite_V1"
  },
  {
    "Retail Branding": "SoyMomo",
    "Marketing Name": "SoyMomo_Lite_V3",
    "Device": "SoyMomo_Lite_V3",
    "Model": "SoyMomo_Lite_V3"
  },
  {
    "Retail Branding": "SoyMomo",
    "Marketing Name": "SoyMomo_Lite_V3_EEA",
    "Device": "SoyMomo_Lite_V3_EEA",
    "Model": "SoyMomo_Lite_V3_EEA"
  },
  {
    "Retail Branding": "SoyMomo",
    "Marketing Name": "SoyMomo_Pro_EU_V1",
    "Device": "SoyMomo_Pro_EU_V1",
    "Model": "SoyMomo_Pro_EU_V1"
  },
  {
    "Retail Branding": "SoyMomo",
    "Marketing Name": "SoyMomo_Pro_EU_V2",
    "Device": "SoyMomo_Pro_EU_V2",
    "Model": "SoyMomo_Pro_EU_V2"
  },
  {
    "Retail Branding": "SoyMomo",
    "Marketing Name": "SoyMomo_Pro_V1",
    "Device": "Pro_V1",
    "Model": "SoyMomo_Pro_V1"
  },
  {
    "Retail Branding": "SoyMomo",
    "Marketing Name": "SoyMomo_Pro_V2",
    "Device": "SoyMomo_Pro_V2",
    "Model": "SoyMomo_Pro_V2"
  },
  {
    "Retail Branding": "SoyMomo",
    "Marketing Name": "SoyMomo_Pro_V2_24",
    "Device": "SoyMomo_Pro_V2_24",
    "Model": "SoyMomo_Pro_V2_24"
  },
  {
    "Retail Branding": "SoyMomo_Tablet",
    "Marketing Name": "SoyMomo_PRO_V2MAX",
    "Device": "SoyMomo_PRO_V2MAX",
    "Model": "SoyMomo_PRO_V2MAX"
  },
  {
    "Retail Branding": "SparX",
    "Marketing Name": "Edge 20",
    "Device": "Edge_20",
    "Model": "Edge 20"
  },
  {
    "Retail Branding": "SparX",
    "Marketing Name": "Edge 20 Pro",
    "Device": "Sparx_Edge_20_Pro",
    "Model": "Edge 20 Pro"
  },
  {
    "Retail Branding": "SparX",
    "Marketing Name": "NEO 5",
    "Device": "NEO5",
    "Model": "NEO 5"
  },
  {
    "Retail Branding": "SparX",
    "Marketing Name": "NEO 9",
    "Device": "Sparx_NEO_9",
    "Model": "Sparx NEO 9"
  },
  {
    "Retail Branding": "SparX",
    "Marketing Name": "NEO_6",
    "Device": "NEO_6",
    "Model": "NEO_6"
  },
  {
    "Retail Branding": "SparX",
    "Marketing Name": "Neo 11",
    "Device": "Neo_11",
    "Model": "Neo 11"
  },
  {
    "Retail Branding": "SparX",
    "Marketing Name": "Neo 15 Ultra",
    "Device": "Neo_15_Ultra",
    "Model": "Neo 15 Ultra"
  },
  {
    "Retail Branding": "SparX",
    "Marketing Name": "Neo 5 Plus",
    "Device": "Neo_5_Plus",
    "Model": "Sparx Neo 5 Plus"
  },
  {
    "Retail Branding": "SparX",
    "Marketing Name": "Neo 5 Pro",
    "Device": "Neo_5_Pro",
    "Model": "Neo 5 Pro"
  },
  {
    "Retail Branding": "SparX",
    "Marketing Name": "Neo 7 Plus",
    "Device": "Neo_5_Plus",
    "Model": "Sparx Neo 7 Plus"
  },
  {
    "Retail Branding": "SparX",
    "Marketing Name": "Neo 7 Ultra",
    "Device": "Neo_7_Ultra",
    "Model": "Sparx Neo 7 Ultra"
  },
  {
    "Retail Branding": "SparX",
    "Marketing Name": "Neo 7 Ultra",
    "Device": "Neo_7_Ultra",
    "Model": "Sparx Neo 7 Ultra 8GB"
  },
  {
    "Retail Branding": "SparX",
    "Marketing Name": "Neo 8 Lite",
    "Device": "Neo8Lite",
    "Model": "Neo 8 Lite"
  },
  {
    "Retail Branding": "SparX",
    "Marketing Name": "Neo_X",
    "Device": "Neo_X",
    "Model": "Neo X"
  },
  {
    "Retail Branding": "SparX",
    "Marketing Name": "Note 12",
    "Device": "Note_12",
    "Model": "Note 12"
  },
  {
    "Retail Branding": "SparX",
    "Marketing Name": "Note_20",
    "Device": "Note_20",
    "Model": "Note 20"
  },
  {
    "Retail Branding": "SparX",
    "Marketing Name": "S3",
    "Device": "S3",
    "Model": "S3"
  },
  {
    "Retail Branding": "SparX",
    "Marketing Name": "S6",
    "Device": "S6",
    "Model": "S6"
  },
  {
    "Retail Branding": "SparX",
    "Marketing Name": "S7",
    "Device": "Sparx_S7",
    "Model": "Sparx S7"
  },
  {
    "Retail Branding": "SparX",
    "Marketing Name": "S9",
    "Device": "S9",
    "Model": "S9"
  },
  {
    "Retail Branding": "SparX",
    "Marketing Name": "Sparx",
    "Device": "Neo_8",
    "Model": "Neo 8"
  },
  {
    "Retail Branding": "SparX",
    "Marketing Name": "Sparx Neo 7",
    "Device": "Neo_7",
    "Model": "Sparx Neo 7"
  },
  {
    "Retail Branding": "SparX",
    "Marketing Name": "Sparx Neo 7 Pro",
    "Device": "Neo_7_Pro",
    "Model": "Sparx Neo 7 Pro"
  },
  {
    "Retail Branding": "SparX",
    "Marketing Name": "Sparx Neo 8 Plus",
    "Device": "Neo_8_Plus",
    "Model": "Sparx Neo 8 Plus"
  },
  {
    "Retail Branding": "SparX",
    "Marketing Name": "Sparx Neo 8 Pro",
    "Device": "Neo_8_Pro",
    "Model": "Sparx Neo 8 Pro"
  },
  {
    "Retail Branding": "SparX",
    "Marketing Name": "Sparx Neo 8i",
    "Device": "Neo_8_Plus",
    "Model": "Sparx Neo 8i"
  },
  {
    "Retail Branding": "SparX",
    "Marketing Name": "Sparx Neo 9i",
    "Device": "Neo_8_Plus",
    "Model": "Sparx Neo 9i"
  },
  {
    "Retail Branding": "SparX",
    "Marketing Name": "Sparx Ultra 8i",
    "Device": "Ultra_8i",
    "Model": "Ultra 8i"
  },
  {
    "Retail Branding": "SparX",
    "Marketing Name": "Sparx_Neo_15",
    "Device": "Sparx_Neo_15",
    "Model": "Sparx Neo 15"
  },
  {
    "Retail Branding": "SparX",
    "Marketing Name": "Sparx_Neo_15",
    "Device": "Sparx_Neo_15",
    "Model": "Sparx_Neo_15"
  },
  {
    "Retail Branding": "SparX",
    "Marketing Name": "Sparx_Neo_15_Pro",
    "Device": "Sparx_Neo_15_Pro",
    "Model": "Sparx Neo 15 Pro"
  },
  {
    "Retail Branding": "SparX",
    "Marketing Name": "Sparx_Neo_15_Pro",
    "Device": "Sparx_Neo_15_Pro",
    "Model": "Sparx_Neo_15_Pro"
  },
  {
    "Retail Branding": "SparX",
    "Marketing Name": "Ultra 11",
    "Device": "Ultra_11",
    "Model": "Ultra 11"
  },
  {
    "Retail Branding": "SparX",
    "Marketing Name": "Ultra 8",
    "Device": "Ultra8",
    "Model": "Ultra 8"
  },
  {
    "Retail Branding": "SparX",
    "Marketing Name": "Ultra 8",
    "Device": "Ultra_8",
    "Model": "Ultra 8"
  },
  {
    "Retail Branding": "SparX",
    "Marketing Name": "Ultra 8 Pro",
    "Device": "Ultra8Pro",
    "Model": "Ultra 8 Pro"
  },
  {
    "Retail Branding": "SparX",
    "Marketing Name": "Ultra 8 Pro",
    "Device": "Ultra_8_Pro",
    "Model": "Ultra 8 Pro"
  },
  {
    "Retail Branding": "SparX",
    "Marketing Name": "V5",
    "Device": "Sparx_V5",
    "Model": "Sparx V5"
  },
  {
    "Retail Branding": "SparX",
    "Marketing Name": "V7",
    "Device": "Sparx_V7",
    "Model": "V7"
  },
  {
    "Retail Branding": "Spark",
    "Marketing Name": "Spark_Plus_3",
    "Device": "Spark_Plus_3",
    "Model": "Spark Plus 3"
  },
  {
    "Retail Branding": "Specktron",
    "Marketing Name": "CDX",
    "Device": "CDX",
    "Model": "CDX"
  },
  {
    "Retail Branding": "Specktron",
    "Marketing Name": "UDX_Series",
    "Device": "UDX_series",
    "Model": "UDX_series"
  },
  {
    "Retail Branding": "Specktron",
    "Marketing Name": "UDX_series",
    "Device": "UDX_Pro_series",
    "Model": "UDX_Pro_series"
  },
  {
    "Retail Branding": "Spectra Geospatial",
    "Marketing Name": "MobileMapper60_2",
    "Device": "MM60_2",
    "Model": "MobileMapper60_2"
  },
  {
    "Retail Branding": "Spectra Geospatial",
    "Marketing Name": "Ranger 5",
    "Device": "bcat",
    "Model": "RGR5"
  },
  {
    "Retail Branding": "SpectraPrecision",
    "Marketing Name": "Ranger 5 Handheld",
    "Device": "workhorse_wifi",
    "Model": "Ranger5"
  },
  {
    "Retail Branding": "SpectraPrecision",
    "Marketing Name": "Ranger 8 Handheld",
    "Device": "pelican",
    "Model": "Ranger8"
  },
  {
    "Retail Branding": "SpectraPrecision",
    "Marketing Name": "Ranger 8 Handheld",
    "Device": "pelican_wifi",
    "Model": "Ranger8"
  },
  {
    "Retail Branding": "SpectraPrecision",
    "Marketing Name": "Spectra Ranger 5",
    "Device": "workhorse",
    "Model": "Ranger5"
  },
  {
    "Retail Branding": "Spectralink",
    "Marketing Name": 8744,
    "Device": "thor_6dq",
    "Model": 8744
  },
  {
    "Retail Branding": "Spectralink",
    "Marketing Name": "PIVOT 8741/8753",
    "Device": "thor_6dq",
    "Model": 8741
  },
  {
    "Retail Branding": "Spectralink",
    "Marketing Name": "PIVOT 8741/8753",
    "Device": "thor_6dq",
    "Model": 8742
  },
  {
    "Retail Branding": "Spectralink",
    "Marketing Name": "PIVOT 8741/8753",
    "Device": "thor_6dq",
    "Model": 8753
  },
  {
    "Retail Branding": "Spectralink",
    "Marketing Name": "PIVOT 8742",
    "Device": "thor_6dq",
    "Model": 8741
  },
  {
    "Retail Branding": "Spectralink",
    "Marketing Name": "PIVOT 8742",
    "Device": "thor_6dq",
    "Model": 8742
  },
  {
    "Retail Branding": "Spectralink",
    "Marketing Name": "Versity",
    "Device": "Versity",
    "Model": "Versity 9540"
  },
  {
    "Retail Branding": "Spectralink",
    "Marketing Name": "Versity",
    "Device": "Versity",
    "Model": "Versity 9553"
  },
  {
    "Retail Branding": "Spectralink",
    "Marketing Name": "Versity",
    "Device": "Versity",
    "Model": "Versity 9640"
  },
  {
    "Retail Branding": "Spectralink",
    "Marketing Name": "Versity",
    "Device": "Versity",
    "Model": "Versity 9653"
  },
  {
    "Retail Branding": "Spectralink",
    "Marketing Name": "Versity 92-Series",
    "Device": "VC92",
    "Model": "VC9253"
  },
  {
    "Retail Branding": "Spectralink",
    "Marketing Name": "Versity 9540",
    "Device": "Versity",
    "Model": "Versity 9540"
  },
  {
    "Retail Branding": "Spectralink",
    "Marketing Name": "Versity 9553",
    "Device": "Versity",
    "Model": "Versity 9553"
  },
  {
    "Retail Branding": "Spectralink",
    "Marketing Name": "Versity 9640",
    "Device": "Versity",
    "Model": "Versity 9640"
  },
  {
    "Retail Branding": "Spectralink",
    "Marketing Name": "Versity 9653",
    "Device": "Versity",
    "Model": "Versity 9653"
  },
  {
    "Retail Branding": "Spectralink",
    "Marketing Name": "Versity 9740",
    "Device": "Versity",
    "Model": "Versity 9740"
  },
  {
    "Retail Branding": "Spectralink",
    "Marketing Name": "Versity 9753",
    "Device": "Versity",
    "Model": "Versity 9753"
  },
  {
    "Retail Branding": "Speechi",
    "Marketing Name": "ST_xx_CONNECT_PRO5",
    "Device": "RK3576",
    "Model": "ST_xx_CONNECT_PRO5"
  },
  {
    "Retail Branding": "Speechi",
    "Marketing Name": "SUPERGLASS PRO",
    "Device": "RK3576",
    "Model": "ST_xx_CONNECT_SE5"
  },
  {
    "Retail Branding": "Speedata",
    "Marketing Name": "FG50",
    "Device": "FG50",
    "Model": "FG50"
  },
  {
    "Retail Branding": "Speedata",
    "Marketing Name": "FG60",
    "Device": "FG60",
    "Model": "FG60"
  },
  {
    "Retail Branding": "Speedata",
    "Marketing Name": "FG60 EEA",
    "Device": "FG60",
    "Model": "FG60"
  },
  {
    "Retail Branding": "Speedata",
    "Marketing Name": "SD100",
    "Device": "SD100",
    "Model": "SD100"
  },
  {
    "Retail Branding": "Speedmind",
    "Marketing Name": "AM801",
    "Device": "AM801",
    "Model": "AM801"
  },
  {
    "Retail Branding": "Speedmind",
    "Marketing Name": "Pr6145",
    "Device": "Pr6145",
    "Model": "Pr6145"
  },
  {
    "Retail Branding": "Spice",
    "Marketing Name": "Dream Uno",
    "Device": "Mi-498_sprout",
    "Model": "Spice Mi-498"
  },
  {
    "Retail Branding": "Spice",
    "Marketing Name": "Dream Uno",
    "Device": "Mi-498_sprout",
    "Model": "Spice Mi-498H"
  },
  {
    "Retail Branding": "Spice",
    "Marketing Name": "F301",
    "Device": "Spice_F301",
    "Model": "Spice F301"
  },
  {
    "Retail Branding": "Spice",
    "Marketing Name": "F302",
    "Device": "Spice_F302",
    "Model": "Spice F302"
  },
  {
    "Retail Branding": "Spice",
    "Marketing Name": "F305",
    "Device": "Spice-F305",
    "Model": "Spice F305"
  },
  {
    "Retail Branding": "Spice",
    "Marketing Name": "K601",
    "Device": "Spice_K601",
    "Model": "Spice K601"
  },
  {
    "Retail Branding": "Spice",
    "Marketing Name": "Smart Flo Mi-449",
    "Device": "SpiceMi449",
    "Model": "SpiceMi-449"
  },
  {
    "Retail Branding": "Spice",
    "Marketing Name": "Smart Flo Mi-449",
    "Device": "hongyu72_wet_jb3",
    "Model": "SpiceMi-449"
  },
  {
    "Retail Branding": "Spice",
    "Marketing Name": "Spice F302",
    "Device": "Spice_F302",
    "Model": "Spice F302"
  },
  {
    "Retail Branding": "Spice",
    "Marketing Name": "Spice V801",
    "Device": "Spice_V801",
    "Model": "Spice V801"
  },
  {
    "Retail Branding": "Spice",
    "Marketing Name": "Stellar Mi-438",
    "Device": "Spice",
    "Model": "MI-438"
  },
  {
    "Retail Branding": "Spice",
    "Marketing Name": "Stellar Mi-506",
    "Device": "SpiceMi506",
    "Model": "Spice Mi-506"
  },
  {
    "Retail Branding": "Spice",
    "Marketing Name": "V801",
    "Device": "Spice_V801",
    "Model": "Spice V801"
  },
  {
    "Retail Branding": "Spice",
    "Marketing Name": "Victor5",
    "Device": "Spice",
    "Model": "Xlife-Victor5"
  },
  {
    "Retail Branding": "Spice",
    "Marketing Name": "Xlife-441Q",
    "Device": "Spice",
    "Model": "Xlife-415"
  },
  {
    "Retail Branding": "Spice",
    "Marketing Name": "Xlife-441Q",
    "Device": "Spice",
    "Model": "Xlife-441Q"
  },
  {
    "Retail Branding": "Spice",
    "Marketing Name": "Xlife-450Q",
    "Device": "Spice",
    "Model": "Xlife-450Q"
  },
  {
    "Retail Branding": "Spice",
    "Marketing Name": "Xlife-514Q",
    "Device": "Spice",
    "Model": "Xlife-514Q"
  },
  {
    "Retail Branding": "Spice",
    "Marketing Name": "Xlife-M44Q",
    "Device": "Spice",
    "Model": "Xlife-M44Q"
  },
  {
    "Retail Branding": "Spice",
    "Marketing Name": "Xlife-Proton 5 pro",
    "Device": "Spice",
    "Model": "Xlife-Proton5 Pro"
  },
  {
    "Retail Branding": "Spider",
    "Marketing Name": "Spider_A10",
    "Device": "Spider_A10",
    "Model": "Spider_A10"
  },
  {
    "Retail Branding": "Spider",
    "Marketing Name": "Spider_M10Pro",
    "Device": "Spider_M10Pro",
    "Model": "Spider_M10Pro"
  },
  {
    "Retail Branding": "Spotside",
    "Marketing Name": "S_PRO_08_01_EU",
    "Device": "Spro",
    "Model": "Spotside S Pro 8"
  },
  {
    "Retail Branding": "Sprint",
    "Marketing Name": "AQT100",
    "Device": "NKJ_AQT100",
    "Model": "AQT100"
  },
  {
    "Retail Branding": "Sprint",
    "Marketing Name": "AQT82",
    "Device": "NKSA_AQT82",
    "Model": "AQT82"
  },
  {
    "Retail Branding": "Sprint",
    "Marketing Name": "HTC Bolt",
    "Device": "htc_acawhl",
    "Model": "2PYB2"
  },
  {
    "Retail Branding": "Sprint",
    "Marketing Name": "Slate 8 Tablet",
    "Device": "NKS_AQT80",
    "Model": "AQT80"
  },
  {
    "Retail Branding": "SriLankaTelecom",
    "Marketing Name": "DV8040",
    "Device": "DV8040",
    "Model": "DV8040"
  },
  {
    "Retail Branding": "Star-X",
    "Marketing Name": "Europe",
    "Device": "marina",
    "Model": "STAR-X 4K SMART TV"
  },
  {
    "Retail Branding": "Star-X",
    "Marketing Name": "Middle East",
    "Device": "tamachi",
    "Model": "STAR-X FHD Android TV"
  },
  {
    "Retail Branding": "Star-X",
    "Marketing Name": "Middle East",
    "Device": "yeongdeungpo",
    "Model": "STAR-X UHD Android TV"
  },
  {
    "Retail Branding": "Star-X",
    "Marketing Name": "STAR-X 2K SMART TV",
    "Device": "nagata",
    "Model": "STAR-X 2K SMART TV"
  },
  {
    "Retail Branding": "Star-X",
    "Marketing Name": "United Arab Emirates",
    "Device": "martin",
    "Model": "STAR-X 2K Android TV"
  },
  {
    "Retail Branding": "StarBoard",
    "Marketing Name": "Starboard Solution Inc",
    "Device": "TE_YL",
    "Model": "TE_YL"
  },
  {
    "Retail Branding": "StarBoard",
    "Marketing Name": "TE_QS",
    "Device": "TE_QS",
    "Model": "TE_QS"
  },
  {
    "Retail Branding": "StarBoard",
    "Marketing Name": "TE_QS_LL",
    "Device": "TE_QS_LL",
    "Model": "TE_QS_LL"
  },
  {
    "Retail Branding": "StarBoard",
    "Marketing Name": "TE_QS_PRO",
    "Device": "TE_QS_PRO",
    "Model": "TE_QS_PRO"
  },
  {
    "Retail Branding": "StarBoard",
    "Marketing Name": "TE_YL_PRO",
    "Device": "TE_YL_PRO",
    "Model": "TE_YL_PRO"
  },
  {
    "Retail Branding": "StarBoard",
    "Marketing Name": "YL",
    "Device": "YL",
    "Model": "YL"
  },
  {
    "Retail Branding": "StarHub",
    "Marketing Name": "Android TV Set-Top Box",
    "Device": "KM_SH368AT",
    "Model": "KM_SH368AT"
  },
  {
    "Retail Branding": "StarHub",
    "Marketing Name": "StarHub TV+ Box (Innopia)",
    "Device": "NVSH800H1",
    "Model": "NVSH800H1"
  },
  {
    "Retail Branding": "StarHub",
    "Marketing Name": "StarHub TV+ Pro",
    "Device": "m393vsb_starhub",
    "Model": "SCSH900AT"
  },
  {
    "Retail Branding": "StarMobile",
    "Marketing Name": "Mobiistar_Zumbo_J2",
    "Device": "Mobiistar_Zumbo_J2",
    "Model": "Mobiistar Zumbo J2"
  },
  {
    "Retail Branding": "StarMobile",
    "Marketing Name": "PLAY Click LTE",
    "Device": "PLAY_Click_LTE",
    "Model": "PLAY Click LTE"
  },
  {
    "Retail Branding": "StarMobile",
    "Marketing Name": "Play Go",
    "Device": "PLAY_GO",
    "Model": "Starmobile PLAY GO"
  },
  {
    "Retail Branding": "StarMobile",
    "Marketing Name": "UP Groove",
    "Device": "UP_Groove",
    "Model": "UP_Groove"
  },
  {
    "Retail Branding": "StarMobile",
    "Marketing Name": "UP Prime",
    "Device": "UP_Prime",
    "Model": "UP Prime"
  },
  {
    "Retail Branding": "StarMobile",
    "Marketing Name": "UP Selfie",
    "Device": "UP_Selfie",
    "Model": "UP_Selfie"
  },
  {
    "Retail Branding": "StarMobile",
    "Marketing Name": "UP Xtreme",
    "Device": "UP_Xtreme",
    "Model": "UP_Xtreme"
  },
  {
    "Retail Branding": "StarMobile",
    "Marketing Name": "UP_XL",
    "Device": "UP_XL",
    "Model": "UP_XL"
  },
  {
    "Retail Branding": "StarMobile",
    "Marketing Name": "Y11",
    "Device": "Y11",
    "Model": "Y11"
  },
  {
    "Retail Branding": "StarMobile",
    "Marketing Name": "Y15",
    "Device": "Y15",
    "Model": "Y15"
  },
  {
    "Retail Branding": "StarMobile",
    "Marketing Name": "up_octa",
    "Device": "UP_Octa",
    "Model": "UP Octa"
  },
  {
    "Retail Branding": "StarTV",
    "Marketing Name": "StarTV por fibra",
    "Device": "SEI700STAR",
    "Model": "StarTV por fibra"
  },
  {
    "Retail Branding": "Starlight",
    "Marketing Name": "Alpha 100",
    "Device": "Alpha_100",
    "Model": "Alpha 100"
  },
  {
    "Retail Branding": "Starlight",
    "Marketing Name": "Alpha 200",
    "Device": "Alpha_200",
    "Model": "Alpha 200"
  },
  {
    "Retail Branding": "Starlight",
    "Marketing Name": "Alpha_300",
    "Device": "Alpha_300",
    "Model": "Alpha 300"
  },
  {
    "Retail Branding": "Starlight",
    "Marketing Name": "Alpha_300",
    "Device": "Alpha_300",
    "Model": "NOTE TK02"
  },
  {
    "Retail Branding": "Starlight",
    "Marketing Name": "Alpha_300",
    "Device": "Alpha_300",
    "Model": "iHunt S26 ULTRA"
  },
  {
    "Retail Branding": "Starlight",
    "Marketing Name": "Alpha_400",
    "Device": "Alpha_400",
    "Model": "Alpha 400"
  },
  {
    "Retail Branding": "Starlight",
    "Marketing Name": "C_Note",
    "Device": "C_Note",
    "Model": "C_Note"
  },
  {
    "Retail Branding": "Starlight",
    "Marketing Name": "C_Note_Pro",
    "Device": "C_Note_Pro",
    "Model": "C_Note_Pro"
  },
  {
    "Retail Branding": "Starlight",
    "Marketing Name": "Future",
    "Device": "Future",
    "Model": "Future"
  },
  {
    "Retail Branding": "Starlight",
    "Marketing Name": "GioneeStar",
    "Device": "GioneeStar",
    "Model": "GioneeStar"
  },
  {
    "Retail Branding": "Starlight",
    "Marketing Name": "Gionee_Star",
    "Device": "Gionee_Star",
    "Model": "Gionee_Star"
  },
  {
    "Retail Branding": "Starlight",
    "Marketing Name": "I STAR PLUS",
    "Device": "I_STAR_PLUS",
    "Model": "I_STAR_PLUS"
  },
  {
    "Retail Branding": "Starlight",
    "Marketing Name": "I star",
    "Device": "I_star",
    "Model": "I star"
  },
  {
    "Retail Branding": "Starlight",
    "Marketing Name": "I star two",
    "Device": "I_star_two",
    "Model": "I star two"
  },
  {
    "Retail Branding": "Starlight",
    "Marketing Name": "I_Star_Plus",
    "Device": "I_Star_Plus",
    "Model": "I_Star_Plus"
  },
  {
    "Retail Branding": "Starlight",
    "Marketing Name": "Madrid",
    "Device": "Madrid",
    "Model": "Madrid"
  },
  {
    "Retail Branding": "Starlight",
    "Marketing Name": "Milan",
    "Device": "Milan",
    "Model": "Milan"
  },
  {
    "Retail Branding": "Starlight",
    "Marketing Name": "Milan_Pro",
    "Device": "Milan_Pro",
    "Model": "Milan_Pro"
  },
  {
    "Retail Branding": "Starlight",
    "Marketing Name": "My_Star_X",
    "Device": "My_Star_X",
    "Model": "My_Star_X"
  },
  {
    "Retail Branding": "Starlight",
    "Marketing Name": "My_star_18",
    "Device": "My_star_18",
    "Model": "My_star_18"
  },
  {
    "Retail Branding": "Starlight",
    "Marketing Name": "My_star_19",
    "Device": "My_star_19",
    "Model": "My_star_19"
  },
  {
    "Retail Branding": "Starlight",
    "Marketing Name": "RIO STAR",
    "Device": "RIO_STAR",
    "Model": "RIO STAR"
  },
  {
    "Retail Branding": "Starlight",
    "Marketing Name": "Rumania",
    "Device": "tamachi",
    "Model": "STARLIGHT Android TV"
  },
  {
    "Retail Branding": "Starlight",
    "Marketing Name": "Rumania",
    "Device": "yeongdeungpo",
    "Model": "STARLIGHT Android TV"
  },
  {
    "Retail Branding": "Starlight",
    "Marketing Name": "STAR PRO",
    "Device": "STAR_PRO",
    "Model": "STAR PRO"
  },
  {
    "Retail Branding": "Starlight",
    "Marketing Name": "STAR_MIX",
    "Device": "STAR_MIX",
    "Model": "STAR_MIX"
  },
  {
    "Retail Branding": "Starlight",
    "Marketing Name": "Safari",
    "Device": "Safari",
    "Model": "Safari"
  },
  {
    "Retail Branding": "Starlight",
    "Marketing Name": "Star Two",
    "Device": "star_two",
    "Model": "star_two"
  },
  {
    "Retail Branding": "Starlight",
    "Marketing Name": "Star-10WF",
    "Device": "Star-10WF",
    "Model": "Star-10WF"
  },
  {
    "Retail Branding": "Starlight",
    "Marketing Name": "Star-Plus7",
    "Device": "Star-Plus7",
    "Model": "Star-Plus7"
  },
  {
    "Retail Branding": "Starlight",
    "Marketing Name": "Star_Mix_2",
    "Device": "Star_Mix_2",
    "Model": "Star_Mix_2"
  },
  {
    "Retail Branding": "Starlight",
    "Marketing Name": "Star_Plus",
    "Device": "Star_Plus",
    "Model": "Star_Plus"
  },
  {
    "Retail Branding": "Starlight",
    "Marketing Name": "Starlight",
    "Device": "Milan_2G",
    "Model": "Milan"
  },
  {
    "Retail Branding": "Starlight",
    "Marketing Name": "Starplus 7",
    "Device": "STARPLUS7",
    "Model": "STARPLUS7"
  },
  {
    "Retail Branding": "Starlight",
    "Marketing Name": "UMI_G",
    "Device": "UMI_G",
    "Model": "UMI_G"
  },
  {
    "Retail Branding": "Starlight",
    "Marketing Name": "VENUS",
    "Device": "VENUS",
    "Model": "VENUS"
  },
  {
    "Retail Branding": "Starlight",
    "Marketing Name": "VENUS_PLUS",
    "Device": "VENUS_PLUS",
    "Model": "VENUS_PLUS"
  },
  {
    "Retail Branding": "Starlight",
    "Marketing Name": "Vegas",
    "Device": "Vegas",
    "Model": "Vegas"
  },
  {
    "Retail Branding": "Starlight",
    "Marketing Name": "star_X",
    "Device": "star_X",
    "Model": "star_X"
  },
  {
    "Retail Branding": "Starlight",
    "Marketing Name": "star_phone_x",
    "Device": "star_phone_x",
    "Model": "star_phone_x"
  },
  {
    "Retail Branding": "Starlight",
    "Marketing Name": "star_plus_plus",
    "Device": "star_plus_plus",
    "Model": "star_plus_plus"
  },
  {
    "Retail Branding": "Starlight",
    "Marketing Name": "star_two",
    "Device": "star_two",
    "Model": "star_two"
  },
  {
    "Retail Branding": "Starlight",
    "Marketing Name": "venus",
    "Device": "venus",
    "Model": "venus"
  },
  {
    "Retail Branding": "Steren",
    "Marketing Name": "INTV 1000",
    "Device": "INTV",
    "Model": "INTV 1000"
  },
  {
    "Retail Branding": "Steren",
    "Marketing Name": "INTV-ASIST",
    "Device": "INTV_ASIST",
    "Model": "INTV_ASIST"
  },
  {
    "Retail Branding": "Steren",
    "Marketing Name": "Steren INTV_1000",
    "Device": "INTV_1000",
    "Model": "Steren INTV_1000"
  },
  {
    "Retail Branding": "Stofa",
    "Marketing Name": "IC1130",
    "Device": "IC1130",
    "Model": "IC1130"
  },
  {
    "Retail Branding": "Storex",
    "Marketing Name": "MDDDI13310",
    "Device": "MDDDI13310",
    "Model": "FONDATION_ORANGE_2021"
  },
  {
    "Retail Branding": "Storex",
    "Marketing Name": "MDDDI13310",
    "Device": "MDDDI13310",
    "Model": "FONDATION_ORANGE_2023"
  },
  {
    "Retail Branding": "Storex",
    "Marketing Name": "MDDDI13311",
    "Device": "MDDDI13311",
    "Model": "FONDATION_ORANGEH_2021"
  },
  {
    "Retail Branding": "Storex",
    "Marketing Name": "MDDDI13311",
    "Device": "MDDDI13311",
    "Model": "FONDATION_ORANGEH_2023"
  },
  {
    "Retail Branding": "Storex",
    "Marketing Name": "eZee\\'Tab7Q11-M",
    "Device": "Tab7Q11",
    "Model": "Tab7Q11"
  },
  {
    "Retail Branding": "Storex",
    "Marketing Name": "eZeeTab10D12-S",
    "Device": "eZeeTab10D12-S",
    "Model": "eZeeTab10D12-S"
  },
  {
    "Retail Branding": "Storex",
    "Marketing Name": "eZeeTab7D15-M",
    "Device": "eZeeTab7D15-M",
    "Model": "eZeeTab7D15-M"
  },
  {
    "Retail Branding": "Storex",
    "Marketing Name": "eZee’Tab7D14-S",
    "Device": "STOREX7526",
    "Model": "NID_7010"
  },
  {
    "Retail Branding": "Strawberry",
    "Marketing Name": "ST9009",
    "Device": "ST9009",
    "Model": "ST9009"
  },
  {
    "Retail Branding": "Strawberry",
    "Marketing Name": "SX",
    "Device": "SX",
    "Model": "SX"
  },
  {
    "Retail Branding": "Strawberry",
    "Marketing Name": "SX",
    "Device": "SX",
    "Model": "Strawberry SX"
  },
  {
    "Retail Branding": "Stream",
    "Marketing Name": "B1",
    "Device": "B1",
    "Model": "B1"
  },
  {
    "Retail Branding": "Stream",
    "Marketing Name": "B1s",
    "Device": "B1s",
    "Model": "B1s"
  },
  {
    "Retail Branding": "Stream",
    "Marketing Name": "B2mini",
    "Device": "B2mini",
    "Model": "B2mini"
  },
  {
    "Retail Branding": "Stream",
    "Marketing Name": "B2s",
    "Device": "B2s",
    "Model": "B2s"
  },
  {
    "Retail Branding": "Stream",
    "Marketing Name": "B3Pro",
    "Device": "B3Pro",
    "Model": "B3Pro"
  },
  {
    "Retail Branding": "Stream",
    "Marketing Name": "B3S",
    "Device": "B3S",
    "Model": "B3S"
  },
  {
    "Retail Branding": "Stream",
    "Marketing Name": "Europe",
    "Device": "sepolia",
    "Model": "Stream TV G4K"
  },
  {
    "Retail Branding": "Stream",
    "Marketing Name": "Everest",
    "Device": "Everest",
    "Model": "S9"
  },
  {
    "Retail Branding": "Stream",
    "Marketing Name": "FIXION",
    "Device": "HS8937QC",
    "Model": "FIXION"
  },
  {
    "Retail Branding": "Stream",
    "Marketing Name": "HT16",
    "Device": "HT16",
    "Model": "HT16"
  },
  {
    "Retail Branding": "Stream",
    "Marketing Name": "HT28",
    "Device": "B2Plus",
    "Model": "HT28"
  },
  {
    "Retail Branding": "Stream",
    "Marketing Name": "Iron Pro",
    "Device": "IRON_Pro",
    "Model": "IRON Pro"
  },
  {
    "Retail Branding": "Stream",
    "Marketing Name": "PERLA",
    "Device": "PERLA",
    "Model": "PERLA"
  },
  {
    "Retail Branding": "Stream",
    "Marketing Name": "R10G",
    "Device": "R10G",
    "Model": "R10G"
  },
  {
    "Retail Branding": "Stream",
    "Marketing Name": "S7",
    "Device": "MIRROR",
    "Model": "S7"
  },
  {
    "Retail Branding": "Stream",
    "Marketing Name": "SHARK",
    "Device": "SHARK",
    "Model": "SHARK"
  },
  {
    "Retail Branding": "Stream",
    "Marketing Name": "STR-D2 G4K",
    "Device": "YYR",
    "Model": "STR-D2 G4K"
  },
  {
    "Retail Branding": "Stream",
    "Marketing Name": "STREAM 2K Google TV",
    "Device": "capitolhill",
    "Model": "STREAM 2K Google TV"
  },
  {
    "Retail Branding": "Stream",
    "Marketing Name": "STREAM 4K Google TV",
    "Device": "keoneae",
    "Model": "STREAM 4K Google TV"
  },
  {
    "Retail Branding": "Stream",
    "Marketing Name": "Stream",
    "Device": "DV8555-Altice",
    "Model": "Stream"
  },
  {
    "Retail Branding": "Stream",
    "Marketing Name": "Stream TV G2K",
    "Device": "dongnae",
    "Model": "Stream TV G2K"
  },
  {
    "Retail Branding": "Stream System",
    "Marketing Name": "Android TV",
    "Device": "R1",
    "Model": "ATV R1"
  },
  {
    "Retail Branding": "Stream System",
    "Marketing Name": "Android TV",
    "Device": "R2",
    "Model": "ATV R2"
  },
  {
    "Retail Branding": "Stream System",
    "Marketing Name": "R3",
    "Device": "R3",
    "Model": "R3"
  },
  {
    "Retail Branding": "Stream System",
    "Marketing Name": "R3_GTV",
    "Device": "R3_GTV",
    "Model": "R3G"
  },
  {
    "Retail Branding": "Stream System",
    "Marketing Name": "R4",
    "Device": "R4",
    "Model": "R4"
  },
  {
    "Retail Branding": "Stream System",
    "Marketing Name": "R4_GTV",
    "Device": "R4_GTV",
    "Model": "R4G"
  },
  {
    "Retail Branding": "Stream System",
    "Marketing Name": "vileparle",
    "Device": "vileparle",
    "Model": "R6G"
  },
  {
    "Retail Branding": "Strong",
    "Marketing Name": "Android TV",
    "Device": "R1",
    "Model": "ATV R1"
  },
  {
    "Retail Branding": "Strong",
    "Marketing Name": "Android TV",
    "Device": "R2",
    "Model": "ATV R2"
  },
  {
    "Retail Branding": "Strong",
    "Marketing Name": "Android TV",
    "Device": "redwood",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "Strong",
    "Marketing Name": "KM2 PLUS DELUXE",
    "Device": "YYC",
    "Model": "4K Android TV Box"
  },
  {
    "Retail Branding": "Strong",
    "Marketing Name": "LEAP-NEVE",
    "Device": "KHH",
    "Model": "UHD Google TV Stick"
  },
  {
    "Retail Branding": "Strong",
    "Marketing Name": "LEAP-NOVA",
    "Device": "CXR",
    "Model": "UHD Google TV Stick"
  },
  {
    "Retail Branding": "Strong",
    "Marketing Name": "LEAP-S1",
    "Device": "LAS",
    "Model": "LEAP-S1"
  },
  {
    "Retail Branding": "Strong",
    "Marketing Name": "LEAP-S3 PRO",
    "Device": "RMQ",
    "Model": "UHD Google TV STB"
  },
  {
    "Retail Branding": "Strong",
    "Marketing Name": "LEAP-UNA+",
    "Device": "BKK",
    "Model": "FHD Google TV Stick"
  },
  {
    "Retail Branding": "Strong",
    "Marketing Name": "LEAP-UNA+",
    "Device": "BKK",
    "Model": "FHD Streaming Stick"
  },
  {
    "Retail Branding": "Strong",
    "Marketing Name": "Leap-S3",
    "Device": "YDA",
    "Model": "4K Google TV Box"
  },
  {
    "Retail Branding": "Strong",
    "Marketing Name": "SRT41",
    "Device": "YYT",
    "Model": "4K Google TV Stick"
  },
  {
    "Retail Branding": "Strong",
    "Marketing Name": "SRT420",
    "Device": "ZRH",
    "Model": "4K Hybrid STB"
  },
  {
    "Retail Branding": "Strong",
    "Marketing Name": "Smart TV",
    "Device": "alimos",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "Strong",
    "Marketing Name": "Smart TV",
    "Device": "longshan",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "Strong",
    "Marketing Name": "Smart TV",
    "Device": "osaka",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "Strong",
    "Marketing Name": "Strong",
    "Device": "bangbae",
    "Model": "Strong 4K Android TV"
  },
  {
    "Retail Branding": "Strong",
    "Marketing Name": "Strong",
    "Device": "komagome",
    "Model": "Strong 2K Android TV"
  },
  {
    "Retail Branding": "Strong-ZWL",
    "Marketing Name": "SKWHP40A-ZWL",
    "Device": "HP40A1",
    "Model": "SKWHP40A-ZWL"
  },
  {
    "Retail Branding": "Strong-ZWL",
    "Marketing Name": "SKWHP44H-ZWL",
    "Device": "HP44H",
    "Model": "SKWHP44H-ZWL"
  },
  {
    "Retail Branding": "Sts-tottori",
    "Marketing Name": "JR-500",
    "Device": "JR-500",
    "Model": "JR-500"
  },
  {
    "Retail Branding": "Sts-tottori",
    "Marketing Name": "JR-P2000",
    "Device": "JR-P2000",
    "Model": "JR-P2000"
  },
  {
    "Retail Branding": "Sts-tottori",
    "Marketing Name": "TAB-A03",
    "Device": "TAB-A03",
    "Model": "TAB-A03-SD"
  },
  {
    "Retail Branding": "Stylo",
    "Marketing Name": "10_Notebook",
    "Device": "10_Notebook",
    "Model": "10_Notebook"
  },
  {
    "Retail Branding": "Stylo",
    "Marketing Name": 221,
    "Device": 221,
    "Model": 221
  },
  {
    "Retail Branding": "Stylo",
    "Marketing Name": 721,
    "Device": 721,
    "Model": 721
  },
  {
    "Retail Branding": "Stylo",
    "Marketing Name": "721_PRO",
    "Device": "721_PRO",
    "Model": "721_PRO"
  },
  {
    "Retail Branding": "Stylo",
    "Marketing Name": "AIR",
    "Device": "AIR",
    "Model": "AIR"
  },
  {
    "Retail Branding": "Stylo",
    "Marketing Name": "APEX_5G",
    "Device": "APEX_5G",
    "Model": "APEX_5G"
  },
  {
    "Retail Branding": "Stylo",
    "Marketing Name": "ARCTIC",
    "Device": "ARCTIC",
    "Model": "ARCTIC"
  },
  {
    "Retail Branding": "Stylo",
    "Marketing Name": "AS210291",
    "Device": "AS210291",
    "Model": "AS210291"
  },
  {
    "Retail Branding": "Stylo",
    "Marketing Name": "ATLAS",
    "Device": "AW230345",
    "Model": "ATLAS"
  },
  {
    "Retail Branding": "Stylo",
    "Marketing Name": "ATLAS",
    "Device": "DVK83",
    "Model": "ATLAS"
  },
  {
    "Retail Branding": "Stylo",
    "Marketing Name": "AURORA",
    "Device": "AURORA",
    "Model": "AURORA"
  },
  {
    "Retail Branding": "Stylo",
    "Marketing Name": "BOLD",
    "Device": "BOLD",
    "Model": "BOLD"
  },
  {
    "Retail Branding": "Stylo",
    "Marketing Name": "BOLD PLUS",
    "Device": "BOLD_PLUS",
    "Model": "BOLD_PLUS"
  },
  {
    "Retail Branding": "Stylo",
    "Marketing Name": "BOLD_PLUS",
    "Device": "BOLD_PLUS",
    "Model": "BOLD_PLUS"
  },
  {
    "Retail Branding": "Stylo",
    "Marketing Name": "BRAVE",
    "Device": "BRAVE",
    "Model": "BRAVE"
  },
  {
    "Retail Branding": "Stylo",
    "Marketing Name": "Comet",
    "Device": "Comet",
    "Model": "EEJ55"
  },
  {
    "Retail Branding": "Stylo",
    "Marketing Name": "DVK82 Mercury",
    "Device": "DVK82_Mercury",
    "Model": "DVK82 Mercury"
  },
  {
    "Retail Branding": "Stylo",
    "Marketing Name": "DVK87_Orion 8_Tab",
    "Device": "DVK87_Orion_8_Tab",
    "Model": "DVK87 Orion 8 Tab"
  },
  {
    "Retail Branding": "Stylo",
    "Marketing Name": "Destiny",
    "Device": "Destiny",
    "Model": "Destiny"
  },
  {
    "Retail Branding": "Stylo",
    "Marketing Name": "EOA39_STYLO_AXIS",
    "Device": "EOA39_STYLO_AXIS",
    "Model": "EOA39-STYLO AXIS"
  },
  {
    "Retail Branding": "Stylo",
    "Marketing Name": "ERA",
    "Device": "Smart_Phone",
    "Model": "EPY32"
  },
  {
    "Retail Branding": "Stylo",
    "Marketing Name": "Energy",
    "Device": "Energy",
    "Model": "Energy"
  },
  {
    "Retail Branding": "Stylo",
    "Marketing Name": "GRAVITY_PLUS_TAB_10",
    "Device": "GRAVITY_PLUS_TAB_10",
    "Model": "GRAVITY PLUS TAB 10"
  },
  {
    "Retail Branding": "Stylo",
    "Marketing Name": "GRAVITY_TAB_8",
    "Device": "GRAVITY_TAB_8",
    "Model": "GRAVITY TAB 8"
  },
  {
    "Retail Branding": "Stylo",
    "Marketing Name": "Galaxy",
    "Device": "Galaxy",
    "Model": "Galaxy"
  },
  {
    "Retail Branding": "Stylo",
    "Marketing Name": "INKOSI",
    "Device": "INKOSI",
    "Model": "INKOSI"
  },
  {
    "Retail Branding": "Stylo",
    "Marketing Name": "INKOSI-PRO",
    "Device": "INKOSI_PRO",
    "Model": "INKOSI_PRO"
  },
  {
    "Retail Branding": "Stylo",
    "Marketing Name": "INKOSI_PRO_4G",
    "Device": "INKOSI_PRO_4G",
    "Model": "INKOSI_PRO_4G"
  },
  {
    "Retail Branding": "Stylo",
    "Marketing Name": "INKULU",
    "Device": "INKULU",
    "Model": "INKULU"
  },
  {
    "Retail Branding": "Stylo",
    "Marketing Name": "INKULU_PRO",
    "Device": "INKULU_PRO",
    "Model": "INKULU_PRO"
  },
  {
    "Retail Branding": "Stylo",
    "Marketing Name": "Ithemba",
    "Device": "Ithemba",
    "Model": "Ithemba"
  },
  {
    "Retail Branding": "Stylo",
    "Marketing Name": "Jupiter",
    "Device": "DQR22",
    "Model": "DQR22"
  },
  {
    "Retail Branding": "Stylo",
    "Marketing Name": "LIFE_2",
    "Device": "LIFE_2",
    "Model": "LIFE_2"
  },
  {
    "Retail Branding": "Stylo",
    "Marketing Name": "Luna",
    "Device": "Luna",
    "Model": "Luna"
  },
  {
    "Retail Branding": "Stylo",
    "Marketing Name": "MARVEL",
    "Device": "MARVEL",
    "Model": "STYLO MARVEL"
  },
  {
    "Retail Branding": "Stylo",
    "Marketing Name": "MATRIX",
    "Device": "MATRIX",
    "Model": "MATRIX"
  },
  {
    "Retail Branding": "Stylo",
    "Marketing Name": "MAVERICK",
    "Device": "MAVERICK",
    "Model": "MAVERICK"
  },
  {
    "Retail Branding": "Stylo",
    "Marketing Name": "MIRAGE",
    "Device": "MIRAGE",
    "Model": "MIRAGE"
  },
  {
    "Retail Branding": "Stylo",
    "Marketing Name": "MOSCOW",
    "Device": "MOSCOW",
    "Model": "MOSCOW"
  },
  {
    "Retail Branding": "Stylo",
    "Marketing Name": "ORION PLUS TAB 10",
    "Device": "DVK88",
    "Model": "ORION PLUS TAB 10"
  },
  {
    "Retail Branding": "Stylo",
    "Marketing Name": "ORION_TAB_10_4G",
    "Device": "ORION_TAB_10_4G",
    "Model": "STYLO ORION TAB 10 4G"
  },
  {
    "Retail Branding": "Stylo",
    "Marketing Name": "Onyx",
    "Device": "Onyx",
    "Model": "Onyx"
  },
  {
    "Retail Branding": "Stylo",
    "Marketing Name": "Orion_Tab_8_4G",
    "Device": "Orion_Tab_8_4G",
    "Model": "Orion Tab 8 4G"
  },
  {
    "Retail Branding": "Stylo",
    "Marketing Name": "PRIME",
    "Device": "PRIME",
    "Model": "PRIME"
  },
  {
    "Retail Branding": "Stylo",
    "Marketing Name": "Phoenix",
    "Device": "Phoenix",
    "Model": "Phoenix"
  },
  {
    "Retail Branding": "Stylo",
    "Marketing Name": "Prizm",
    "Device": "Prizm",
    "Model": "Prizm"
  },
  {
    "Retail Branding": "Stylo",
    "Marketing Name": "Quantum",
    "Device": "Quantum",
    "Model": "Quantum"
  },
  {
    "Retail Branding": "Stylo",
    "Marketing Name": "RAIN",
    "Device": "RAIN",
    "Model": "STYLO RAIN"
  },
  {
    "Retail Branding": "Stylo",
    "Marketing Name": "S40 Vino",
    "Device": "S40_Vino",
    "Model": "S40 Vino"
  },
  {
    "Retail Branding": "Stylo",
    "Marketing Name": "S40_EBONY",
    "Device": "S40_EBONY",
    "Model": "S40_EBONY"
  },
  {
    "Retail Branding": "Stylo",
    "Marketing Name": "S40_LIFE",
    "Device": "S40_LIFE",
    "Model": "S40_LIFE"
  },
  {
    "Retail Branding": "Stylo",
    "Marketing Name": "S40_VINO_PLUS",
    "Device": "S40_VINO_PLUS",
    "Model": "S40 VINO PLUS"
  },
  {
    "Retail Branding": "Stylo",
    "Marketing Name": "S40_VISTA",
    "Device": "S40_VISTA",
    "Model": "S40_VISTA"
  },
  {
    "Retail Branding": "Stylo",
    "Marketing Name": "S49 ECO",
    "Device": "S49_ECO",
    "Model": "S49 ECO"
  },
  {
    "Retail Branding": "Stylo",
    "Marketing Name": "S49 MONO",
    "Device": "S49_MONO",
    "Model": "S49 MONO"
  },
  {
    "Retail Branding": "Stylo",
    "Marketing Name": "S49_Cobalt",
    "Device": "S49_cobalt",
    "Model": "S49 cobalt"
  },
  {
    "Retail Branding": "Stylo",
    "Marketing Name": "S49_POISE",
    "Device": "S49_POISE",
    "Model": "S49_POISE"
  },
  {
    "Retail Branding": "Stylo",
    "Marketing Name": "S49_cobalt",
    "Device": "S49_cobalt",
    "Model": "S49 cobalt"
  },
  {
    "Retail Branding": "Stylo",
    "Marketing Name": "S50",
    "Device": "STYLO_S50_Granite",
    "Model": "S50"
  },
  {
    "Retail Branding": "Stylo",
    "Marketing Name": "S501",
    "Device": "S501",
    "Model": "Stylo S501"
  },
  {
    "Retail Branding": "Stylo",
    "Marketing Name": "S50_BOLD",
    "Device": "S50_BOLD",
    "Model": "S50_BOLD"
  },
  {
    "Retail Branding": "Stylo",
    "Marketing Name": "S53_STARK",
    "Device": "S53_STARK",
    "Model": "S53_STARK"
  },
  {
    "Retail Branding": "Stylo",
    "Marketing Name": "S54 Zen",
    "Device": "CPE91",
    "Model": "CPE91"
  },
  {
    "Retail Branding": "Stylo",
    "Marketing Name": "S55 Nova",
    "Device": "S55_Nova",
    "Model": "S55 Nova"
  },
  {
    "Retail Branding": "Stylo",
    "Marketing Name": "S551",
    "Device": "STYLO_S551",
    "Model": "STYLO S551"
  },
  {
    "Retail Branding": "Stylo",
    "Marketing Name": "S56 Mist",
    "Device": "S56_MIST",
    "Model": "S56 MIST"
  },
  {
    "Retail Branding": "Stylo",
    "Marketing Name": "S57_ALURE",
    "Device": "S57_ALURE",
    "Model": "S57_ALURE"
  },
  {
    "Retail Branding": "Stylo",
    "Marketing Name": "S57_AZURE",
    "Device": "S57_AZURE",
    "Model": "S57_AZURE"
  },
  {
    "Retail Branding": "Stylo",
    "Marketing Name": "S61_JAZZ",
    "Device": "S61_JAZZ",
    "Model": "S61 JAZZ"
  },
  {
    "Retail Branding": "Stylo",
    "Marketing Name": "S64 ALPHA",
    "Device": "S64_ALPHA",
    "Model": "S64_ALPHA"
  },
  {
    "Retail Branding": "Stylo",
    "Marketing Name": "S9 TOPAZ",
    "Device": "S9_TOPAZ",
    "Model": "STYLO_S9_TOPAZ"
  },
  {
    "Retail Branding": "Stylo",
    "Marketing Name": "SATURN",
    "Device": "SATURN",
    "Model": "SATURN"
  },
  {
    "Retail Branding": "Stylo",
    "Marketing Name": "SIRIUS_TAB_8",
    "Device": "SIRIUS_TAB_8",
    "Model": "SIRIUS TAB 8"
  },
  {
    "Retail Branding": "Stylo",
    "Marketing Name": "SOLAR",
    "Device": "SOLAR",
    "Model": "SOLAR"
  },
  {
    "Retail Branding": "Stylo",
    "Marketing Name": "SONIC",
    "Device": "SONIC",
    "Model": "STYLO SONIC"
  },
  {
    "Retail Branding": "Stylo",
    "Marketing Name": "STEP_UP",
    "Device": "STEP_UP",
    "Model": "STEP_UP"
  },
  {
    "Retail Branding": "Stylo",
    "Marketing Name": "STYLO Future",
    "Device": "Future",
    "Model": "Future"
  },
  {
    "Retail Branding": "Stylo",
    "Marketing Name": "STYLO MAX",
    "Device": "Stylo_Max",
    "Model": "MAX"
  },
  {
    "Retail Branding": "Stylo",
    "Marketing Name": "STYLOF1",
    "Device": "STYLOF1",
    "Model": "STYLO F1"
  },
  {
    "Retail Branding": "Stylo",
    "Marketing Name": "STYLO_DASH",
    "Device": "DASH",
    "Model": "DASH"
  },
  {
    "Retail Branding": "Stylo",
    "Marketing Name": "STYLO_GEO",
    "Device": "GEO",
    "Model": "GEO"
  },
  {
    "Retail Branding": "Stylo",
    "Marketing Name": "STYLO_MESA",
    "Device": "MESA",
    "Model": "MESA"
  },
  {
    "Retail Branding": "Stylo",
    "Marketing Name": "STYLO_S61",
    "Device": "STYLO_S61",
    "Model": "STYLO SM61 MAGIC+"
  },
  {
    "Retail Branding": "Stylo",
    "Marketing Name": "STYLO_S61",
    "Device": "STYLO_S61",
    "Model": "STYLO SV61 VECTOR+"
  },
  {
    "Retail Branding": "Stylo",
    "Marketing Name": "SWIFT_4G",
    "Device": "SWIFT_4G",
    "Model": "SWIFT_4G"
  },
  {
    "Retail Branding": "Stylo",
    "Marketing Name": "Sirius_Plus_Tab_10",
    "Device": "Sirius_Plus_Tab_10",
    "Model": "Sirius Plus Tab 10"
  },
  {
    "Retail Branding": "Stylo",
    "Marketing Name": "Stylo S40",
    "Device": "S40_Vida",
    "Model": "Stylo S40"
  },
  {
    "Retail Branding": "Stylo",
    "Marketing Name": "Stylo_521",
    "Device": "Stylo_521",
    "Model": "Stylo_521"
  },
  {
    "Retail Branding": "Stylo",
    "Marketing Name": "Stylo_Viva",
    "Device": "Stylo_Viva",
    "Model": "Stylo_Viva"
  },
  {
    "Retail Branding": "Stylo",
    "Marketing Name": "TAB2",
    "Device": "TAB2",
    "Model": "TAB2"
  },
  {
    "Retail Branding": "Stylo",
    "Marketing Name": "TAB4",
    "Device": "TAB4",
    "Model": "TAB4"
  },
  {
    "Retail Branding": "Stylo",
    "Marketing Name": "TITAN",
    "Device": "TITAN",
    "Model": "TITAN"
  },
  {
    "Retail Branding": "Stylo",
    "Marketing Name": "UNIVERSE",
    "Device": "UNIVERSE",
    "Model": "UNIVERSE"
  },
  {
    "Retail Branding": "Stylo",
    "Marketing Name": "Ultra",
    "Device": "Ultra",
    "Model": "Ultra"
  },
  {
    "Retail Branding": "Stylo",
    "Marketing Name": "V",
    "Device": "V",
    "Model": "V"
  },
  {
    "Retail Branding": "Stylo",
    "Marketing Name": "VERTIGO",
    "Device": "VERTIGO",
    "Model": "VERTIGO"
  },
  {
    "Retail Branding": "Stylo",
    "Marketing Name": "VS5502",
    "Device": "VS5502",
    "Model": "VS5502"
  },
  {
    "Retail Branding": "Stylo",
    "Marketing Name": "VS571",
    "Device": "VS571",
    "Model": "VS571"
  },
  {
    "Retail Branding": "Stylo",
    "Marketing Name": "X5",
    "Device": "X5",
    "Model": "X5"
  },
  {
    "Retail Branding": "Stylo",
    "Marketing Name": "X7",
    "Device": "X7",
    "Model": "X7"
  },
  {
    "Retail Branding": "Stylos",
    "Marketing Name": "STTCE37",
    "Device": "STTCE37",
    "Model": "STTCE37"
  },
  {
    "Retail Branding": "Stylos",
    "Marketing Name": "TAB8B",
    "Device": "TAB8B",
    "Model": "TAB8"
  },
  {
    "Retail Branding": "Stylos",
    "Marketing Name": "TAB8F",
    "Device": "TAB8F",
    "Model": "Tab3"
  },
  {
    "Retail Branding": "Stylos",
    "Marketing Name": "TARISTAB2",
    "Device": "TARISTAB2",
    "Model": "TARISTAB2"
  },
  {
    "Retail Branding": "Stylos",
    "Marketing Name": "TARISTAB3",
    "Device": "TARISTAB3",
    "Model": "TARISTAB3"
  },
  {
    "Retail Branding": "Stylos",
    "Marketing Name": "TARISTAB4",
    "Device": "TARISTAB4",
    "Model": "TARISTAB4"
  },
  {
    "Retail Branding": "Stylos",
    "Marketing Name": "Tab104",
    "Device": "Tab104",
    "Model": "Tab104"
  },
  {
    "Retail Branding": "Stylos",
    "Marketing Name": "Tab2",
    "Device": "Tab2",
    "Model": "Tab2"
  },
  {
    "Retail Branding": "Stylos",
    "Marketing Name": "Tab8",
    "Device": "Tab8",
    "Model": "Tab8"
  },
  {
    "Retail Branding": "Stylus",
    "Marketing Name": "AT703",
    "Device": "AT703",
    "Model": "AT703"
  },
  {
    "Retail Branding": "Stylus",
    "Marketing Name": "Comet_SP5002G",
    "Device": "Comet_SP5002G",
    "Model": "Comet_SP5002G"
  },
  {
    "Retail Branding": "Stylus",
    "Marketing Name": "FUNDA",
    "Device": "ETAB_I1041G",
    "Model": "ETAB I1041G"
  },
  {
    "Retail Branding": "Stylus",
    "Marketing Name": "FUNDA",
    "Device": "ETAB_I7041G",
    "Model": "ETAB_I7041G"
  },
  {
    "Retail Branding": "Stylus",
    "Marketing Name": "IFS100",
    "Device": "IFS100",
    "Model": "IFS100"
  },
  {
    "Retail Branding": "Stylus",
    "Marketing Name": "Rida SP5003G LTE",
    "Device": "Rida_SP5003G_LTE",
    "Model": "Rida_SP5003G_LTE"
  },
  {
    "Retail Branding": "Stylus",
    "Marketing Name": "Sumo SP5201G LTE",
    "Device": "Sumo_SP5201G_LTE",
    "Model": "Sumo_SP5201G_LTE"
  },
  {
    "Retail Branding": "Stylus",
    "Marketing Name": "Sumo_XL_SP5501G_LTE",
    "Device": "Sumo_XL_SP5501G_LTE",
    "Model": "Sumo_XL_SP5501G_LTE"
  },
  {
    "Retail Branding": "Stylus",
    "Marketing Name": "Symbol SP4002G",
    "Device": "Symbol_SP4002G",
    "Model": "Symbol_SP4002G"
  },
  {
    "Retail Branding": "Stylus",
    "Marketing Name": "Wintech",
    "Device": "WIN4",
    "Model": "WIN4"
  },
  {
    "Retail Branding": "Subaru",
    "Marketing Name": "A-DA",
    "Device": "balticaBA",
    "Model": "MY22ADA"
  },
  {
    "Retail Branding": "Sugar",
    "Marketing Name": "SUGAR C11",
    "Device": "v12bns",
    "Model": "SUGAR C11"
  },
  {
    "Retail Branding": "Sugar",
    "Marketing Name": "SUGAR C12",
    "Device": "SUGAR_C12",
    "Model": "SUGAR C12"
  },
  {
    "Retail Branding": "Sugar",
    "Marketing Name": "SUGAR C13",
    "Device": "p210cn",
    "Model": "SUGAR C13"
  },
  {
    "Retail Branding": "Sugar",
    "Marketing Name": "SUGAR C60",
    "Device": "SUGAR_C60",
    "Model": "SUGAR C60"
  },
  {
    "Retail Branding": "Sugar",
    "Marketing Name": "SUGAR F20",
    "Device": "p700as",
    "Model": "SUGAR F20"
  },
  {
    "Retail Branding": "Sugar",
    "Marketing Name": "SUGAR P1",
    "Device": "SUGAR_P1",
    "Model": "SUGAR P1"
  },
  {
    "Retail Branding": "Sugar",
    "Marketing Name": "SUGAR S11",
    "Device": "i9071ae",
    "Model": "SUGAR S11"
  },
  {
    "Retail Branding": "Sugar",
    "Marketing Name": "SUGAR S20",
    "Device": "x600as_hk",
    "Model": "SUGAR S20"
  },
  {
    "Retail Branding": "Sugar",
    "Marketing Name": "SUGAR S20s",
    "Device": "x600as",
    "Model": "SUGAR S20s"
  },
  {
    "Retail Branding": "Sugar",
    "Marketing Name": "SUGAR S50",
    "Device": "SUGAR_S50",
    "Model": "SUGAR S50"
  },
  {
    "Retail Branding": "Sugar",
    "Marketing Name": "SUGAR S55",
    "Device": "SUGAR_S55",
    "Model": "SUGAR S55"
  },
  {
    "Retail Branding": "Sugar",
    "Marketing Name": "SUGAR T10",
    "Device": "p312cs_tw",
    "Model": "SUGAR T10"
  },
  {
    "Retail Branding": "Sugar",
    "Marketing Name": "SUGAR T20",
    "Device": "v730_64",
    "Model": "SUGAR T20"
  },
  {
    "Retail Branding": "Sugar",
    "Marketing Name": "SUGAR T30",
    "Device": "v830_64",
    "Model": "SUGAR T30"
  },
  {
    "Retail Branding": "Sugar",
    "Marketing Name": "SUGAR T35",
    "Device": "v830_64",
    "Model": "SUGAR T35"
  },
  {
    "Retail Branding": "Sugar",
    "Marketing Name": "SUGAR Y12",
    "Device": "p101bs",
    "Model": "SUGAR Y12"
  },
  {
    "Retail Branding": "Sugar",
    "Marketing Name": "SUGAR Y12s",
    "Device": "SUGAR_Y12s",
    "Model": "SUGAR Y12s"
  },
  {
    "Retail Branding": "Sugar",
    "Marketing Name": "SUGAR Y13s",
    "Device": "SUGAR_Y13s",
    "Model": "SUGAR Y13s"
  },
  {
    "Retail Branding": "Sugar",
    "Marketing Name": "SUGAR Y15",
    "Device": "p201as",
    "Model": "SUGAR Y15"
  },
  {
    "Retail Branding": "Sugar",
    "Marketing Name": "SUGAR Y16",
    "Device": "SUGAR_Y16",
    "Model": "SUGAR Y16"
  },
  {
    "Retail Branding": "Sugar",
    "Marketing Name": "SUGAR_P11",
    "Device": "SUGAR_P11",
    "Model": "SUGAR_P11"
  },
  {
    "Retail Branding": "Sugar",
    "Marketing Name": "SUGAR_Y18",
    "Device": "SUGAR_Y18",
    "Model": "SUGAR_Y18"
  },
  {
    "Retail Branding": "Sugar",
    "Marketing Name": "Sugar",
    "Device": "s9121",
    "Model": "SUGAR"
  },
  {
    "Retail Branding": "Sugar",
    "Marketing Name": "Sugar S30",
    "Device": "x800as",
    "Model": "SUGAR S30"
  },
  {
    "Retail Branding": "Sugar",
    "Marketing Name": "Sugar T50",
    "Device": "p611bn",
    "Model": "SUGAR T50"
  },
  {
    "Retail Branding": "Sumitomo Electric Industries",
    "Marketing Name": "ST-4500",
    "Device": "ST4500",
    "Model": "ST-4500"
  },
  {
    "Retail Branding": "Sumitomo Electric Industries",
    "Marketing Name": "ST4173",
    "Device": "ST4173",
    "Model": "ST4173"
  },
  {
    "Retail Branding": "Sumitomo Electric Industries",
    "Marketing Name": "ST4500",
    "Device": "ST4500",
    "Model": "ST-4500"
  },
  {
    "Retail Branding": "Sumitomo Electric Networks",
    "Marketing Name": "",
    "Device": "dhe1100",
    "Model": "Hikari-iFrame/WDPF-703SE"
  },
  {
    "Retail Branding": "Sumtec",
    "Marketing Name": "DV9061",
    "Device": "ATL",
    "Model": "DV9061"
  },
  {
    "Retail Branding": "SunDirectMax",
    "Marketing Name": "SunDirectMax",
    "Device": "SEI730SUN",
    "Model": "SunDirectMax"
  },
  {
    "Retail Branding": "Sun_King",
    "Marketing Name": "EZ 2",
    "Device": "EZ_2",
    "Model": "EZ 2"
  },
  {
    "Retail Branding": "Sun_King",
    "Marketing Name": "EZ_1",
    "Device": "EZ1_go",
    "Model": "EZ 1"
  },
  {
    "Retail Branding": "Sun_King",
    "Marketing Name": "EZ_1",
    "Device": "EZ_1",
    "Model": "EZ 1"
  },
  {
    "Retail Branding": "Sunbio",
    "Marketing Name": "SB-TM700",
    "Device": "SB-TM700",
    "Model": "SB-TM700"
  },
  {
    "Retail Branding": "Sunbrite",
    "Marketing Name": "huangshan_sunbrite",
    "Device": "huangshan",
    "Model": "SmartTV 4K"
  },
  {
    "Retail Branding": "Sunelan",
    "Marketing Name": "Mountain M8",
    "Device": "Mountain_M8",
    "Model": "Mountain M8"
  },
  {
    "Retail Branding": "Sunelan",
    "Marketing Name": "River X1",
    "Device": "River_X1",
    "Model": "River X1"
  },
  {
    "Retail Branding": "Sunelan",
    "Marketing Name": "River X3",
    "Device": "River_X3",
    "Model": "River X3"
  },
  {
    "Retail Branding": "Sunelan",
    "Marketing Name": "S826",
    "Device": "S826",
    "Model": "S826"
  },
  {
    "Retail Branding": "Sunmi",
    "Marketing Name": "D3",
    "Device": "D3",
    "Model": "D3"
  },
  {
    "Retail Branding": "Sunmi",
    "Marketing Name": "D3 MINI",
    "Device": "D3MINI",
    "Model": "D3 MINI"
  },
  {
    "Retail Branding": "Sunmi",
    "Marketing Name": "D3 PRO",
    "Device": "D3_PRO",
    "Model": "D3 PRO"
  },
  {
    "Retail Branding": "Sunmi",
    "Marketing Name": "FLEX 3",
    "Device": "FLEX3",
    "Model": "FLEX 3"
  },
  {
    "Retail Branding": "Sunmi",
    "Marketing Name": "K2",
    "Device": "K2",
    "Model": "K2_A13"
  },
  {
    "Retail Branding": "Sunmi",
    "Marketing Name": "L2H_EDLA_GL",
    "Device": "SUNMI-L2HNFC",
    "Model": "L2H_EDLA_GL"
  },
  {
    "Retail Branding": "Sunmi",
    "Marketing Name": "L2Ks",
    "Device": "SUNMI-L2KsNFC",
    "Model": "L2Ks_EDLA_GL"
  },
  {
    "Retail Branding": "Sunmi",
    "Marketing Name": "L2s_PRO",
    "Device": "SUNMI-L2s_PRO",
    "Model": "L2s_PRO"
  },
  {
    "Retail Branding": "Sunmi",
    "Marketing Name": "L3",
    "Device": "L3",
    "Model": "L3"
  },
  {
    "Retail Branding": "Sunmi",
    "Marketing Name": "OrderPAD 3",
    "Device": "OrderPAD_3",
    "Model": "OrderPAD 3"
  },
  {
    "Retail Branding": "Sunmi",
    "Marketing Name": "Sunmi L2H",
    "Device": "SUNMI-L2HNFC",
    "Model": "L2H_EEA"
  },
  {
    "Retail Branding": "Sunmi",
    "Marketing Name": "Sunmi L2H",
    "Device": "SUNMI-L2HNFC",
    "Model": "L2H_GL"
  },
  {
    "Retail Branding": "Sunmi",
    "Marketing Name": "Sunmi L2H",
    "Device": "SUNMI-L2HNFC",
    "Model": "L2H_TR"
  },
  {
    "Retail Branding": "Sunmi",
    "Marketing Name": "Sunmi L2Ks",
    "Device": "SUNMI-L2KsNFC",
    "Model": "L2Ks_EEA"
  },
  {
    "Retail Branding": "Sunmi",
    "Marketing Name": "Sunmi L2Ks",
    "Device": "SUNMI-L2KsNFC",
    "Model": "L2Ks_GL"
  },
  {
    "Retail Branding": "Sunmi",
    "Marketing Name": "Sunmi L2Ks",
    "Device": "SUNMI-L2KsNFC",
    "Model": "L2Ks_RU"
  },
  {
    "Retail Branding": "Sunmi",
    "Marketing Name": "Sunmi L2Ks",
    "Device": "SUNMI-L2KsNFC",
    "Model": "L2Ks_TR"
  },
  {
    "Retail Branding": "Sunmi",
    "Marketing Name": "Sunmi V2s",
    "Device": "V2s",
    "Model": "V2s_EEA"
  },
  {
    "Retail Branding": "Sunmi",
    "Marketing Name": "Sunmi V2s",
    "Device": "V2s",
    "Model": "V2s_GL"
  },
  {
    "Retail Branding": "Sunmi",
    "Marketing Name": "Sunmi V2s",
    "Device": "V2s",
    "Model": "V2s_TR"
  },
  {
    "Retail Branding": "Sunmi",
    "Marketing Name": "T3",
    "Device": "T3",
    "Model": "T3"
  },
  {
    "Retail Branding": "Sunmi",
    "Marketing Name": "T3 PRO",
    "Device": "T3_PRO",
    "Model": "T3 PRO"
  },
  {
    "Retail Branding": "Sunmi",
    "Marketing Name": "T3 PRO",
    "Device": "T3_PRO",
    "Model": "T3 Pro Max"
  },
  {
    "Retail Branding": "Sunmi",
    "Marketing Name": "T3 PRO MAX",
    "Device": "T3_PRO",
    "Model": "T3 Pro Max"
  },
  {
    "Retail Branding": "Sunmi",
    "Marketing Name": "V2s",
    "Device": "V2s",
    "Model": "V2s_EDLA_GL"
  },
  {
    "Retail Branding": "Sunmi",
    "Marketing Name": "V2s",
    "Device": "V2sNC",
    "Model": "V2sNC_EDLA_GL"
  },
  {
    "Retail Branding": "Sunmi",
    "Marketing Name": "V2sNC",
    "Device": "V2sNC",
    "Model": "V2sNC_EEA"
  },
  {
    "Retail Branding": "Sunmi",
    "Marketing Name": "V2sNC",
    "Device": "V2sNC",
    "Model": "V2sNC_GL"
  },
  {
    "Retail Branding": "Sunmi",
    "Marketing Name": "V2sNC",
    "Device": "V2sNC",
    "Model": "V2sNC_RU"
  },
  {
    "Retail Branding": "Sunmi",
    "Marketing Name": "V2sNC",
    "Device": "V2sNC",
    "Model": "V2sNC_TR"
  },
  {
    "Retail Branding": "Sunmi",
    "Marketing Name": "V2sPLUS",
    "Device": "V2sPLUSNC",
    "Model": "V2sPLUSNC_EDLA_GL"
  },
  {
    "Retail Branding": "Sunmi",
    "Marketing Name": "V2sPLUSNC",
    "Device": "V2sPLUSNC",
    "Model": "V2sPLUSNC_EEA"
  },
  {
    "Retail Branding": "Sunmi",
    "Marketing Name": "V2sPLUSNC",
    "Device": "V2sPLUSNC",
    "Model": "V2sPLUSNC_GL"
  },
  {
    "Retail Branding": "Sunmi",
    "Marketing Name": "V2sPLUSNC",
    "Device": "V2sPLUSNC",
    "Model": "V2sPLUSNC_RU"
  },
  {
    "Retail Branding": "Sunmi",
    "Marketing Name": "V2sPLUSNC",
    "Device": "V2sPLUSNC",
    "Model": "V2sPLUSNC_TR"
  },
  {
    "Retail Branding": "Sunmi",
    "Marketing Name": "V3",
    "Device": "V3",
    "Model": "V3"
  },
  {
    "Retail Branding": "Sunmi",
    "Marketing Name": "V3 MIX",
    "Device": "V3_MIX",
    "Model": "V3_MIX_EDLA_GL"
  },
  {
    "Retail Branding": "Sunmi",
    "Marketing Name": "V3 PLUS",
    "Device": "V3_PLUS",
    "Model": "V3_PLUS"
  },
  {
    "Retail Branding": "Sunny",
    "Marketing Name": "SN01DNGL300",
    "Device": "YQB",
    "Model": "SN01DNGL300"
  },
  {
    "Retail Branding": "Sunny",
    "Marketing Name": "SN10016",
    "Device": "SN10016",
    "Model": "SN10016"
  },
  {
    "Retail Branding": "Sunny",
    "Marketing Name": "SN10064",
    "Device": "TABLET",
    "Model": "SN10064"
  },
  {
    "Retail Branding": "Sunny",
    "Marketing Name": "SN7016",
    "Device": "SN7016",
    "Model": "SN7016"
  },
  {
    "Retail Branding": "Sunny",
    "Marketing Name": "SN7032",
    "Device": "SN7032",
    "Model": "SN7032"
  },
  {
    "Retail Branding": "Sunny",
    "Marketing Name": "SUNNY 2K Google TV",
    "Device": "capitolhill",
    "Model": "SUNNY 2K Google TV"
  },
  {
    "Retail Branding": "Sunny",
    "Marketing Name": "SUNNY 4K Google TV",
    "Device": "keoneae",
    "Model": "SUNNY 4K Google TV"
  },
  {
    "Retail Branding": "Sunstech",
    "Marketing Name": "Spain / Portugal",
    "Device": "martin",
    "Model": "SUNSTECH SD ANDROID TV"
  },
  {
    "Retail Branding": "Sunstech",
    "Marketing Name": "TAB1011",
    "Device": "TAB1011",
    "Model": "TAB1011"
  },
  {
    "Retail Branding": "Sunstech",
    "Marketing Name": "TAB1012",
    "Device": "TAB1012",
    "Model": "TAB1012"
  },
  {
    "Retail Branding": "Sunstech",
    "Marketing Name": "TAB1015GY",
    "Device": "TAB1015GY",
    "Model": "TAB1015GY"
  },
  {
    "Retail Branding": "Sunstech",
    "Marketing Name": "TAB1081",
    "Device": "TAB1081",
    "Model": "TAB1081"
  },
  {
    "Retail Branding": "Sunstech",
    "Marketing Name": "TAB1081_eea",
    "Device": "TAB1081",
    "Model": "TAB1081"
  },
  {
    "Retail Branding": "Sunstech",
    "Marketing Name": "TAB1090",
    "Device": "TAB1090",
    "Model": "TAB1090"
  },
  {
    "Retail Branding": "Sunstech",
    "Marketing Name": "TAB781",
    "Device": "TAB781",
    "Model": "TAB781"
  },
  {
    "Retail Branding": "SuperLead",
    "Marketing Name": "P3S",
    "Device": "P3S",
    "Model": "P3S"
  },
  {
    "Retail Branding": "SuperLead",
    "Marketing Name": "P3S_EEA",
    "Device": "P3S",
    "Model": "P3S"
  },
  {
    "Retail Branding": "SuperLead",
    "Marketing Name": "P3S_RU",
    "Device": "P3S",
    "Model": "P3S"
  },
  {
    "Retail Branding": "Supertab",
    "Marketing Name": "16G4H101",
    "Device": "16G4H101",
    "Model": "16G4H101"
  },
  {
    "Retail Branding": "Supertab",
    "Marketing Name": "A7A",
    "Device": "A7A",
    "Model": "A7A"
  },
  {
    "Retail Branding": "Supertab",
    "Marketing Name": "K7_KIDS",
    "Device": "K7_KIDS",
    "Model": "K7 Kids"
  },
  {
    "Retail Branding": "Supertab",
    "Marketing Name": "S7G",
    "Device": "S7G",
    "Model": "S7G"
  },
  {
    "Retail Branding": "Suponic",
    "Marketing Name": "JYP_777",
    "Device": "JYP_777",
    "Model": "JYP_777"
  },
  {
    "Retail Branding": "Supraim",
    "Marketing Name": "AQ21",
    "Device": "AQ21",
    "Model": "AQ21"
  },
  {
    "Retail Branding": "Supraim",
    "Marketing Name": "AYCON",
    "Device": "AYCON",
    "Model": "AYCON"
  },
  {
    "Retail Branding": "Supraim",
    "Marketing Name": "SN10",
    "Device": "SN10",
    "Model": "SN10"
  },
  {
    "Retail Branding": "Surface",
    "Marketing Name": "Surface Duo",
    "Device": "duo",
    "Model": "Surface Duo"
  },
  {
    "Retail Branding": "Surface",
    "Marketing Name": "Surface Duo 2",
    "Device": "duo2",
    "Model": "Surface Duo 2"
  },
  {
    "Retail Branding": "Surfans",
    "Marketing Name": "K10",
    "Device": "K10",
    "Model": "K10"
  },
  {
    "Retail Branding": "Surfans",
    "Marketing Name": "K7",
    "Device": "K7",
    "Model": "K7"
  },
  {
    "Retail Branding": "Surfans",
    "Marketing Name": "K7S",
    "Device": "K7S",
    "Model": "K7S"
  },
  {
    "Retail Branding": "Surfans",
    "Marketing Name": "P10P",
    "Device": "P10P",
    "Model": "Surfans P10P"
  },
  {
    "Retail Branding": "Surfans",
    "Marketing Name": "Y57A",
    "Device": "Y57A",
    "Model": "Y57A"
  },
  {
    "Retail Branding": "Surgephone",
    "Marketing Name": "SURGE",
    "Device": "VOLT_5XL",
    "Model": "VOLT_5XL"
  },
  {
    "Retail Branding": "Surtab",
    "Marketing Name": "SURTAB",
    "Device": "SURTAB_74G",
    "Model": "SURTAB_74G"
  },
  {
    "Retail Branding": "Suunto",
    "Marketing Name": "Suunto 7",
    "Device": "salmon",
    "Model": "Suunto 7"
  },
  {
    "Retail Branding": "Sweam",
    "Marketing Name": "S55E",
    "Device": "Senwa_S55E",
    "Model": "S55E"
  },
  {
    "Retail Branding": "Sweam",
    "Marketing Name": "Sweam",
    "Device": "sweam",
    "Model": "sweam"
  },
  {
    "Retail Branding": "Swiftcash",
    "Marketing Name": "M4",
    "Device": "M4",
    "Model": "M4"
  },
  {
    "Retail Branding": "Swipe",
    "Marketing Name": "Elite 4G",
    "Device": "Elite_4G",
    "Model": "Elite 4G"
  },
  {
    "Retail Branding": "Swipe",
    "Marketing Name": "Elite Dual",
    "Device": "EliteDual",
    "Model": "EliteDual"
  },
  {
    "Retail Branding": "Swipe",
    "Marketing Name": "Elite VR",
    "Device": "Elite_VR",
    "Model": "Elite_VR"
  },
  {
    "Retail Branding": "Swipe",
    "Marketing Name": "Razor",
    "Device": "Swipe_Razor",
    "Model": "Razor"
  },
  {
    "Retail Branding": "Swipe",
    "Marketing Name": "Slate2",
    "Device": "Slate2",
    "Model": "Slate2"
  },
  {
    "Retail Branding": "Swipe",
    "Marketing Name": "Strike",
    "Device": "Strike",
    "Model": "Strike"
  },
  {
    "Retail Branding": "Swipe",
    "Marketing Name": "Strike",
    "Device": "Swipe_Strike",
    "Model": "Strike"
  },
  {
    "Retail Branding": "Swipe",
    "Marketing Name": "Swipe_Slate_3",
    "Device": "Swipe_Slate_3",
    "Model": "Swipe_Slate_3"
  },
  {
    "Retail Branding": "Swipe",
    "Marketing Name": "Swipe_Slate_3_WiFi",
    "Device": "Swipe_Slate_3_WiFi",
    "Model": "Swipe_Slate_3_WiFi"
  },
  {
    "Retail Branding": "Swipe",
    "Marketing Name": "Swipe_Strike8",
    "Device": "Swipe_Strike8",
    "Model": "Swipe_Strike8"
  },
  {
    "Retail Branding": "Swipe",
    "Marketing Name": "Swipe_X1",
    "Device": "Swipe_X1",
    "Model": "Swipe_X1"
  },
  {
    "Retail Branding": "SwissMobility",
    "Marketing Name": "B4",
    "Device": "B4SWM",
    "Model": "B4"
  },
  {
    "Retail Branding": "SwissMobility",
    "Marketing Name": "M9",
    "Device": "M9",
    "Model": "M9"
  },
  {
    "Retail Branding": "SwissMobility",
    "Marketing Name": "Z7",
    "Device": "Z7",
    "Model": "Z7"
  },
  {
    "Retail Branding": "SwissMobility",
    "Marketing Name": "Z72",
    "Device": "Z72",
    "Model": "Z72"
  },
  {
    "Retail Branding": "SwissMobility",
    "Marketing Name": "Z9",
    "Device": "Z9",
    "Model": "Z9"
  },
  {
    "Retail Branding": "Swisscom",
    "Marketing Name": "IP1800",
    "Device": "IP1800",
    "Model": "IP1800"
  },
  {
    "Retail Branding": "Swisscom",
    "Marketing Name": "IP2000",
    "Device": "IP2000",
    "Model": "IP2000"
  },
  {
    "Retail Branding": "Swisscom",
    "Marketing Name": "TV-Box5",
    "Device": "IP2300",
    "Model": "IP2300"
  },
  {
    "Retail Branding": "Swisstone",
    "Marketing Name": "swisstone SD 510",
    "Device": "SD5103G",
    "Model": "swisstone SD 510"
  },
  {
    "Retail Branding": "Swisstone",
    "Marketing Name": "swisstone SD 530",
    "Device": "SD5304G",
    "Model": "swisstone SD 530"
  },
  {
    "Retail Branding": "Swissvoice",
    "Marketing Name": "G50",
    "Device": "G50",
    "Model": "G50"
  },
  {
    "Retail Branding": "Switel",
    "Marketing Name": "VS700",
    "Device": "VS700",
    "Model": "VS700"
  },
  {
    "Retail Branding": "Swosh",
    "Marketing Name": "AndroidTV",
    "Device": "samseong",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "Swosh",
    "Marketing Name": "Smart TV",
    "Device": "longshan",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "Swosh",
    "Marketing Name": "Smart TV",
    "Device": "samseong",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "Syco",
    "Marketing Name": "RS-403_EEA",
    "Device": "RS-403",
    "Model": "RS-403"
  },
  {
    "Retail Branding": "Syco",
    "Marketing Name": "RS-442_EEA",
    "Device": "RS-442_EEA",
    "Model": "SYCO RS-442"
  },
  {
    "Retail Branding": "Syco",
    "Marketing Name": "RT-402",
    "Device": "RT_402",
    "Model": "SYCO RT_402"
  },
  {
    "Retail Branding": "Syco",
    "Marketing Name": "SYCO RS-404",
    "Device": "GQ3112SH3",
    "Model": "SYCO RS-404"
  },
  {
    "Retail Branding": "Syco",
    "Marketing Name": "SYCO_RS-441",
    "Device": "SYCO_RS-441",
    "Model": "SYCO RS-441"
  },
  {
    "Retail Branding": "Syco",
    "Marketing Name": "SYCO_RT-401",
    "Device": "SYCO_RT-401",
    "Model": "SYCO RT-401"
  },
  {
    "Retail Branding": "Syinix",
    "Marketing Name": "32A1S",
    "Device": "ikebukuro",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "Syinix",
    "Marketing Name": "43A51",
    "Device": "beaudry",
    "Model": "Syinix AndroidTV"
  },
  {
    "Retail Branding": "Syinix",
    "Marketing Name": "55A1S",
    "Device": "samseong",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "Syinix",
    "Marketing Name": "55U51",
    "Device": "barking",
    "Model": "Syinix AndroidTV"
  },
  {
    "Retail Branding": "Syinix",
    "Marketing Name": "Africa",
    "Device": "yeongdeungpo",
    "Model": "Syinix UHD Android TV"
  },
  {
    "Retail Branding": "Syinix",
    "Marketing Name": "Glory TV",
    "Device": "SW6H",
    "Model": "Glory TV"
  },
  {
    "Retail Branding": "Syinix",
    "Marketing Name": "Glory TV",
    "Device": "umeda",
    "Model": "Glory TV"
  },
  {
    "Retail Branding": "Syinix",
    "Marketing Name": "Smart TV",
    "Device": "longshan",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "Syinix",
    "Marketing Name": "Smart TV",
    "Device": "redwood",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "Syinix",
    "Marketing Name": "Syinix TV",
    "Device": "eleonas",
    "Model": "Syinix TV"
  },
  {
    "Retail Branding": "Symphony",
    "Marketing Name": "ATOM",
    "Device": "ATOM",
    "Model": "ATOM"
  },
  {
    "Retail Branding": "Symphony",
    "Marketing Name": "ATOM4",
    "Device": "ATOM4",
    "Model": "ATOM4"
  },
  {
    "Retail Branding": "Symphony",
    "Marketing Name": "Allegro",
    "Device": "RFIP_ST4K_2",
    "Model": "Allegro"
  },
  {
    "Retail Branding": "Symphony",
    "Marketing Name": "Atom ii",
    "Device": "Atom_ii",
    "Model": "Symphony Atom ii"
  },
  {
    "Retail Branding": "Symphony",
    "Marketing Name": "Atom3",
    "Device": "Atom3",
    "Model": "Atom3"
  },
  {
    "Retail Branding": "Symphony",
    "Marketing Name": "E90",
    "Device": "E90",
    "Model": "E90"
  },
  {
    "Retail Branding": "Symphony",
    "Marketing Name": "E95",
    "Device": "E95",
    "Model": "E95"
  },
  {
    "Retail Branding": "Symphony",
    "Marketing Name": "G10",
    "Device": "G10",
    "Model": "Symphony G10"
  },
  {
    "Retail Branding": "Symphony",
    "Marketing Name": "G100",
    "Device": "G100",
    "Model": "Symphony G100"
  },
  {
    "Retail Branding": "Symphony",
    "Marketing Name": "G10plus",
    "Device": "G10plus",
    "Model": "G10+"
  },
  {
    "Retail Branding": "Symphony",
    "Marketing Name": "G27",
    "Device": "G27",
    "Model": "G27"
  },
  {
    "Retail Branding": "Symphony",
    "Marketing Name": "G27 Lite",
    "Device": "G27_Lite",
    "Model": "G27 Lite"
  },
  {
    "Retail Branding": "Symphony",
    "Marketing Name": "G50",
    "Device": "G50",
    "Model": "G50"
  },
  {
    "Retail Branding": "Symphony",
    "Marketing Name": "H300",
    "Device": "H300",
    "Model": "H300"
  },
  {
    "Retail Branding": "Symphony",
    "Marketing Name": "H400",
    "Device": "H400",
    "Model": "H400"
  },
  {
    "Retail Branding": "Symphony",
    "Marketing Name": "H58",
    "Device": "H58",
    "Model": "H58"
  },
  {
    "Retail Branding": "Symphony",
    "Marketing Name": "Helio S60",
    "Device": "Helio_S60",
    "Model": "Helio S60"
  },
  {
    "Retail Branding": "Symphony",
    "Marketing Name": "INOVA",
    "Device": "INOVA",
    "Model": "INOVA"
  },
  {
    "Retail Branding": "Symphony",
    "Marketing Name": "MAX 30",
    "Device": "MAX_30",
    "Model": "MAX 30"
  },
  {
    "Retail Branding": "Symphony",
    "Marketing Name": "MAX_5",
    "Device": "MAX_5",
    "Model": "MAX 5"
  },
  {
    "Retail Branding": "Symphony",
    "Marketing Name": "MAX_60",
    "Device": "MAX_60",
    "Model": "MAX 60"
  },
  {
    "Retail Branding": "Symphony",
    "Marketing Name": "P11",
    "Device": "P11",
    "Model": "P11"
  },
  {
    "Retail Branding": "Symphony",
    "Marketing Name": "P6 PRO",
    "Device": "P6_PRO",
    "Model": "P6 PRO"
  },
  {
    "Retail Branding": "Symphony",
    "Marketing Name": "P7",
    "Device": "Symphony_P7",
    "Model": "P7"
  },
  {
    "Retail Branding": "Symphony",
    "Marketing Name": "P7 Pro",
    "Device": "P7_PRO",
    "Model": "Symphony P7 PRO"
  },
  {
    "Retail Branding": "Symphony",
    "Marketing Name": "P8 PRO",
    "Device": "P8_PRO",
    "Model": "P8 PRO"
  },
  {
    "Retail Branding": "Symphony",
    "Marketing Name": "P9",
    "Device": "P9",
    "Model": "P9"
  },
  {
    "Retail Branding": "Symphony",
    "Marketing Name": "P9+",
    "Device": "P9_Plus",
    "Model": "P9 Plus"
  },
  {
    "Retail Branding": "Symphony",
    "Marketing Name": "R100",
    "Device": "R100",
    "Model": "Symphony R100"
  },
  {
    "Retail Branding": "Symphony",
    "Marketing Name": "R20",
    "Device": "R20",
    "Model": "R20"
  },
  {
    "Retail Branding": "Symphony",
    "Marketing Name": "R30",
    "Device": "R30",
    "Model": "R30"
  },
  {
    "Retail Branding": "Symphony",
    "Marketing Name": "R40",
    "Device": "R40",
    "Model": "R40"
  },
  {
    "Retail Branding": "Symphony",
    "Marketing Name": "Roar A50",
    "Device": "Roar_A50_sprout",
    "Model": "Roar_A50"
  },
  {
    "Retail Branding": "Symphony",
    "Marketing Name": "Roar_V78",
    "Device": "Roar_V78",
    "Model": "Roar_V78"
  },
  {
    "Retail Branding": "Symphony",
    "Marketing Name": "S501",
    "Device": "SYMPHONY_S501",
    "Model": "S501"
  },
  {
    "Retail Branding": "Symphony",
    "Marketing Name": "SYMTAB 80",
    "Device": "SYMTAB_80",
    "Model": "SYMTAB_80"
  },
  {
    "Retail Branding": "Symphony",
    "Marketing Name": "SYMTAB25",
    "Device": "SYMTAB25",
    "Model": "SYMTAB25"
  },
  {
    "Retail Branding": "Symphony",
    "Marketing Name": "SYMTAB60",
    "Device": "SYMTAB60",
    "Model": "SYMTAB60"
  },
  {
    "Retail Branding": "Symphony",
    "Marketing Name": "Symphony G26",
    "Device": "G26",
    "Model": "G26"
  },
  {
    "Retail Branding": "Symphony",
    "Marketing Name": "Symphony V138Lite",
    "Device": "V138Lite",
    "Model": "V138Lite"
  },
  {
    "Retail Branding": "Symphony",
    "Marketing Name": "Symphony i73",
    "Device": "i73",
    "Model": "i73"
  },
  {
    "Retail Branding": "Symphony",
    "Marketing Name": "Symphony_Z12",
    "Device": "Symphony_Z12",
    "Model": "Symphony_Z12"
  },
  {
    "Retail Branding": "Symphony",
    "Marketing Name": "Symphony_Z50",
    "Device": "Symphony_Z50",
    "Model": "Symphony Z50"
  },
  {
    "Retail Branding": "Symphony",
    "Marketing Name": "Symphony_Z9",
    "Device": "Z9",
    "Model": "Symphony Z9"
  },
  {
    "Retail Branding": "Symphony",
    "Marketing Name": "V100",
    "Device": "V100",
    "Model": "V100"
  },
  {
    "Retail Branding": "Symphony",
    "Marketing Name": "V102",
    "Device": "V102",
    "Model": "V102"
  },
  {
    "Retail Branding": "Symphony",
    "Marketing Name": "V105",
    "Device": "V105",
    "Model": "V105"
  },
  {
    "Retail Branding": "Symphony",
    "Marketing Name": "V110",
    "Device": "V110",
    "Model": "V110"
  },
  {
    "Retail Branding": "Symphony",
    "Marketing Name": "V120",
    "Device": "V120",
    "Model": "V120"
  },
  {
    "Retail Branding": "Symphony",
    "Marketing Name": "V125",
    "Device": "V125",
    "Model": "V125"
  },
  {
    "Retail Branding": "Symphony",
    "Marketing Name": "V128",
    "Device": "V128",
    "Model": "V128"
  },
  {
    "Retail Branding": "Symphony",
    "Marketing Name": "V130",
    "Device": "V130",
    "Model": "V130"
  },
  {
    "Retail Branding": "Symphony",
    "Marketing Name": "V136",
    "Device": "V136",
    "Model": "V136"
  },
  {
    "Retail Branding": "Symphony",
    "Marketing Name": "V138",
    "Device": "V138",
    "Model": "V138"
  },
  {
    "Retail Branding": "Symphony",
    "Marketing Name": "V139",
    "Device": "V139",
    "Model": "V139"
  },
  {
    "Retail Branding": "Symphony",
    "Marketing Name": "V140",
    "Device": "V140",
    "Model": "V140"
  },
  {
    "Retail Branding": "Symphony",
    "Marketing Name": "V141",
    "Device": "V141",
    "Model": "V141"
  },
  {
    "Retail Branding": "Symphony",
    "Marketing Name": "V142",
    "Device": "V142",
    "Model": "V142"
  },
  {
    "Retail Branding": "Symphony",
    "Marketing Name": "V145",
    "Device": "V145",
    "Model": "V145"
  },
  {
    "Retail Branding": "Symphony",
    "Marketing Name": "V155",
    "Device": "V155",
    "Model": "V155"
  },
  {
    "Retail Branding": "Symphony",
    "Marketing Name": "V34",
    "Device": "V34",
    "Model": "V34"
  },
  {
    "Retail Branding": "Symphony",
    "Marketing Name": "V44",
    "Device": "V44",
    "Model": "V44"
  },
  {
    "Retail Branding": "Symphony",
    "Marketing Name": "V47",
    "Device": "V47",
    "Model": "V47"
  },
  {
    "Retail Branding": "Symphony",
    "Marketing Name": "V48",
    "Device": "V48",
    "Model": "V48"
  },
  {
    "Retail Branding": "Symphony",
    "Marketing Name": "V65",
    "Device": "V65",
    "Model": "V65"
  },
  {
    "Retail Branding": "Symphony",
    "Marketing Name": "V75",
    "Device": "V75",
    "Model": "V75"
  },
  {
    "Retail Branding": "Symphony",
    "Marketing Name": "V75m",
    "Device": "V75m",
    "Model": "V75m"
  },
  {
    "Retail Branding": "Symphony",
    "Marketing Name": "V85",
    "Device": "V85",
    "Model": "V85"
  },
  {
    "Retail Branding": "Symphony",
    "Marketing Name": "V92",
    "Device": "V92",
    "Model": "V92"
  },
  {
    "Retail Branding": "Symphony",
    "Marketing Name": "V94",
    "Device": "V94",
    "Model": "V94"
  },
  {
    "Retail Branding": "Symphony",
    "Marketing Name": "V96",
    "Device": "V96",
    "Model": "V96"
  },
  {
    "Retail Branding": "Symphony",
    "Marketing Name": "V97",
    "Device": "V97",
    "Model": "V97"
  },
  {
    "Retail Branding": "Symphony",
    "Marketing Name": "V98",
    "Device": "V98",
    "Model": "V98"
  },
  {
    "Retail Branding": "Symphony",
    "Marketing Name": "V99",
    "Device": "V99",
    "Model": "V99"
  },
  {
    "Retail Branding": "Symphony",
    "Marketing Name": "V99+",
    "Device": "V99plus",
    "Model": "V99+"
  },
  {
    "Retail Branding": "Symphony",
    "Marketing Name": "Z10",
    "Device": "Z10",
    "Model": "SYMPHONY Z10"
  },
  {
    "Retail Branding": "Symphony",
    "Marketing Name": "Z15",
    "Device": "Z15",
    "Model": "Z15"
  },
  {
    "Retail Branding": "Symphony",
    "Marketing Name": "Z16",
    "Device": "Z16",
    "Model": "Z16"
  },
  {
    "Retail Branding": "Symphony",
    "Marketing Name": "Z18",
    "Device": "Z18",
    "Model": "Symphony Z18"
  },
  {
    "Retail Branding": "Symphony",
    "Marketing Name": "Z20",
    "Device": "Z20",
    "Model": "Z20"
  },
  {
    "Retail Branding": "Symphony",
    "Marketing Name": "Z22",
    "Device": "Z22",
    "Model": "Symphony Z22"
  },
  {
    "Retail Branding": "Symphony",
    "Marketing Name": "Z25",
    "Device": "Z25",
    "Model": "Z25"
  },
  {
    "Retail Branding": "Symphony",
    "Marketing Name": "Z28",
    "Device": "Z28",
    "Model": "Z28"
  },
  {
    "Retail Branding": "Symphony",
    "Marketing Name": "Z30",
    "Device": "Z30",
    "Model": "Z30"
  },
  {
    "Retail Branding": "Symphony",
    "Marketing Name": "Z30 pro",
    "Device": "Z30_pro",
    "Model": "Z30 pro"
  },
  {
    "Retail Branding": "Symphony",
    "Marketing Name": "Z32",
    "Device": "Z32",
    "Model": "Symphony Z32"
  },
  {
    "Retail Branding": "Symphony",
    "Marketing Name": "Z33",
    "Device": "Z33",
    "Model": "Z33"
  },
  {
    "Retail Branding": "Symphony",
    "Marketing Name": "Z35",
    "Device": "Z35",
    "Model": "Z35"
  },
  {
    "Retail Branding": "Symphony",
    "Marketing Name": "Z40",
    "Device": "Z40",
    "Model": "Z40"
  },
  {
    "Retail Branding": "Symphony",
    "Marketing Name": "Z42",
    "Device": "Z42",
    "Model": "Z42"
  },
  {
    "Retail Branding": "Symphony",
    "Marketing Name": "Z42_pro",
    "Device": "Z42_pro",
    "Model": "Z42 pro"
  },
  {
    "Retail Branding": "Symphony",
    "Marketing Name": "Z45",
    "Device": "Z45",
    "Model": "Symphony Z45"
  },
  {
    "Retail Branding": "Symphony",
    "Marketing Name": "Z47",
    "Device": "Z47",
    "Model": "Z47"
  },
  {
    "Retail Branding": "Symphony",
    "Marketing Name": "Z55",
    "Device": "Z55",
    "Model": "Z55"
  },
  {
    "Retail Branding": "Symphony",
    "Marketing Name": "Z60",
    "Device": "Z60",
    "Model": "Symphony Z60"
  },
  {
    "Retail Branding": "Symphony",
    "Marketing Name": "Z60",
    "Device": "Z60",
    "Model": "Z60"
  },
  {
    "Retail Branding": "Symphony",
    "Marketing Name": "Z60 Plus",
    "Device": "Z60_plus",
    "Model": "Z60 plus"
  },
  {
    "Retail Branding": "Symphony",
    "Marketing Name": "Z70",
    "Device": "Z70",
    "Model": "Z70"
  },
  {
    "Retail Branding": "Symphony",
    "Marketing Name": "Z72",
    "Device": "Z72",
    "Model": "Z72"
  },
  {
    "Retail Branding": "Symphony",
    "Marketing Name": "ZVII",
    "Device": "ZVII",
    "Model": "ZVII"
  },
  {
    "Retail Branding": "Symphony",
    "Marketing Name": "ZVIII",
    "Device": "ZVIII",
    "Model": "ZVIII"
  },
  {
    "Retail Branding": "Symphony",
    "Marketing Name": "helio_30",
    "Device": "helio_30",
    "Model": "helio 30"
  },
  {
    "Retail Branding": "Symphony",
    "Marketing Name": "helio_80",
    "Device": "helio_80",
    "Model": "helio 80"
  },
  {
    "Retail Branding": "Symphony",
    "Marketing Name": "i10",
    "Device": "i10",
    "Model": "i10"
  },
  {
    "Retail Branding": "Symphony",
    "Marketing Name": "i10 plus",
    "Device": "i10_plus",
    "Model": "i10 plus"
  },
  {
    "Retail Branding": "Symphony",
    "Marketing Name": "i100",
    "Device": "i100",
    "Model": "i100"
  },
  {
    "Retail Branding": "Symphony",
    "Marketing Name": "i12",
    "Device": "i12",
    "Model": "i12"
  },
  {
    "Retail Branding": "Symphony",
    "Marketing Name": "i120",
    "Device": "i120",
    "Model": "i120"
  },
  {
    "Retail Branding": "Symphony",
    "Marketing Name": "i15",
    "Device": "i15",
    "Model": "i15"
  },
  {
    "Retail Branding": "Symphony",
    "Marketing Name": "i18",
    "Device": "i18",
    "Model": "i18"
  },
  {
    "Retail Branding": "Symphony",
    "Marketing Name": "i20",
    "Device": "i20",
    "Model": "i20"
  },
  {
    "Retail Branding": "Symphony",
    "Marketing Name": "i25",
    "Device": "Symphonyi25",
    "Model": "i25"
  },
  {
    "Retail Branding": "Symphony",
    "Marketing Name": "i30",
    "Device": "i30",
    "Model": "i30"
  },
  {
    "Retail Branding": "Symphony",
    "Marketing Name": "i32",
    "Device": "i32",
    "Model": "i32"
  },
  {
    "Retail Branding": "Symphony",
    "Marketing Name": "i50",
    "Device": "i50",
    "Model": "i50"
  },
  {
    "Retail Branding": "Symphony",
    "Marketing Name": "i60",
    "Device": "i60",
    "Model": "i60"
  },
  {
    "Retail Branding": "Symphony",
    "Marketing Name": "i65",
    "Device": "i65",
    "Model": "i65"
  },
  {
    "Retail Branding": "Symphony",
    "Marketing Name": "i66",
    "Device": "i66",
    "Model": "i66"
  },
  {
    "Retail Branding": "Symphony",
    "Marketing Name": "i67",
    "Device": "i67",
    "Model": "i67"
  },
  {
    "Retail Branding": "Symphony",
    "Marketing Name": "i68",
    "Device": "i68",
    "Model": "i68"
  },
  {
    "Retail Branding": "Symphony",
    "Marketing Name": "i69",
    "Device": "i69",
    "Model": "i69"
  },
  {
    "Retail Branding": "Symphony",
    "Marketing Name": "i71",
    "Device": "i71",
    "Model": "i71"
  },
  {
    "Retail Branding": "Symphony",
    "Marketing Name": "i72",
    "Device": "i72",
    "Model": "i72"
  },
  {
    "Retail Branding": "Symphony",
    "Marketing Name": "i74",
    "Device": "i74",
    "Model": "i74"
  },
  {
    "Retail Branding": "Symphony",
    "Marketing Name": "i80",
    "Device": "i80",
    "Model": "i80"
  },
  {
    "Retail Branding": "Symphony",
    "Marketing Name": "i85",
    "Device": "i85",
    "Model": "i85"
  },
  {
    "Retail Branding": "Symphony",
    "Marketing Name": "i90",
    "Device": "i90",
    "Model": "i90"
  },
  {
    "Retail Branding": "Symphony",
    "Marketing Name": "i95",
    "Device": "i95",
    "Model": "i95"
  },
  {
    "Retail Branding": "Symphony",
    "Marketing Name": "i96",
    "Device": "i96",
    "Model": "i96"
  },
  {
    "Retail Branding": "Symphony",
    "Marketing Name": "i97",
    "Device": "i97",
    "Model": "i97"
  },
  {
    "Retail Branding": "Symphony",
    "Marketing Name": "i98",
    "Device": "i98",
    "Model": "i98"
  },
  {
    "Retail Branding": "Symphony",
    "Marketing Name": "i99",
    "Device": "i99",
    "Model": "i99"
  },
  {
    "Retail Branding": "Symphony",
    "Marketing Name": "innova10",
    "Device": "innova10",
    "Model": "innova10"
  },
  {
    "Retail Branding": "Symphony",
    "Marketing Name": "innova20",
    "Device": "innova20",
    "Model": "innova20"
  },
  {
    "Retail Branding": "Symphony",
    "Marketing Name": "innova30",
    "Device": "innova30",
    "Model": "innova30"
  },
  {
    "Retail Branding": "Symphony",
    "Marketing Name": "innova_40",
    "Device": "innova_40",
    "Model": "innova 40"
  },
  {
    "Retail Branding": "Symphony",
    "Marketing Name": "roarV95",
    "Device": "roarV95",
    "Model": "roarV95"
  },
  {
    "Retail Branding": "Symphony",
    "Marketing Name": "roar_V150",
    "Device": "roar_V150",
    "Model": "roar_V150"
  },
  {
    "Retail Branding": "Synetech",
    "Marketing Name": "Gemini",
    "Device": "Gemini",
    "Model": "G7576"
  },
  {
    "Retail Branding": "Synetech",
    "Marketing Name": "Piscis",
    "Device": "oversea_piscis",
    "Model": "P7579L"
  },
  {
    "Retail Branding": "Synetech",
    "Marketing Name": "Synetech Elite Taurus",
    "Device": "rk3588_t",
    "Model": "Synetech_T35"
  },
  {
    "Retail Branding": "Synetech",
    "Marketing Name": "Synetech Elite Taurus-VC",
    "Device": "oversea_v",
    "Model": "Synetech_T7535_VC"
  },
  {
    "Retail Branding": "Synetech",
    "Marketing Name": "Synetech_Elite_Taurus",
    "Device": "rk3588_t",
    "Model": "Synetech_T35"
  },
  {
    "Retail Branding": "Synetech",
    "Marketing Name": "Synetech_Elite_Taurus_V",
    "Device": "rk3588_t",
    "Model": "Synetech_T35_V"
  },
  {
    "Retail Branding": "Synetech",
    "Marketing Name": "infnity_Piscis_E1",
    "Device": "Piscis",
    "Model": "Pxx79"
  },
  {
    "Retail Branding": "T-Mobile",
    "Marketing Name": "REVVL 2",
    "Device": "A30ATMO",
    "Model": "REVVL 2"
  },
  {
    "Retail Branding": "T-Mobile",
    "Marketing Name": "REVVL 2",
    "Device": "A30ATMO",
    "Model": "REVVL_2_5052W"
  },
  {
    "Retail Branding": "T-Mobile",
    "Marketing Name": "REVVL 2 PLUS",
    "Device": "A70AXLTMO",
    "Model": "REVVL 2 PLUS"
  },
  {
    "Retail Branding": "T-Mobile",
    "Marketing Name": "REVVL 4",
    "Device": "Tokyo_Lite_4G",
    "Model": "5007W"
  },
  {
    "Retail Branding": "T-Mobile",
    "Marketing Name": "REVVL 4",
    "Device": "Tokyo_Lite_4G",
    "Model": "5007Z"
  },
  {
    "Retail Branding": "T-Mobile",
    "Marketing Name": "REVVL 4+",
    "Device": "Porto",
    "Model": "5062W"
  },
  {
    "Retail Branding": "T-Mobile",
    "Marketing Name": "REVVL 4+",
    "Device": "Porto",
    "Model": "5062Z"
  },
  {
    "Retail Branding": "T-Mobile",
    "Marketing Name": "REVVL 5G",
    "Device": "Seattle_5G",
    "Model": "T790W"
  },
  {
    "Retail Branding": "T-Mobile",
    "Marketing Name": "REVVL 5G",
    "Device": "Seattle_5G",
    "Model": "T790Z"
  },
  {
    "Retail Branding": "T-Mobile",
    "Marketing Name": "REVVL 6",
    "Device": "Bethpage",
    "Model": "TMAF025G"
  },
  {
    "Retail Branding": "T-Mobile",
    "Marketing Name": "REVVL 6 Pro",
    "Device": "Augusta",
    "Model": "TMAF035G"
  },
  {
    "Retail Branding": "T-Mobile",
    "Marketing Name": "REVVL 6x 5G",
    "Device": "TorreyPines",
    "Model": "TMRV065G"
  },
  {
    "Retail Branding": "T-Mobile",
    "Marketing Name": "REVVL 6x PRO 5G",
    "Device": "SouthernDunes",
    "Model": "TMRV06P5G"
  },
  {
    "Retail Branding": "T-Mobile",
    "Marketing Name": "REVVL 7",
    "Device": "CypressPoint",
    "Model": "TMRV075G"
  },
  {
    "Retail Branding": "T-Mobile",
    "Marketing Name": "REVVL 7 Pro",
    "Device": "Pinehurst",
    "Model": "TMRV07P5G"
  },
  {
    "Retail Branding": "T-Mobile",
    "Marketing Name": "REVVL TAB 5G",
    "Device": "REVVLTAB5G",
    "Model": "TMRV5GTB"
  },
  {
    "Retail Branding": "T-Mobile",
    "Marketing Name": "REVVL V",
    "Device": "Newcastle",
    "Model": "TMRVL4G"
  },
  {
    "Retail Branding": "T-Mobile",
    "Marketing Name": "REVVL V+ 5G",
    "Device": "Sprout",
    "Model": "REVVL V+ 5G"
  },
  {
    "Retail Branding": "T-Mobile",
    "Marketing Name": "REVVLRY",
    "Device": "channel",
    "Model": "REVVLRY"
  },
  {
    "Retail Branding": "T-Mobile",
    "Marketing Name": "REVVLRY",
    "Device": "channel",
    "Model": "REVVLry"
  },
  {
    "Retail Branding": "T-Mobile",
    "Marketing Name": "REVVLRY+",
    "Device": "lake_n",
    "Model": "REVVLRY+"
  },
  {
    "Retail Branding": "T-Mobile",
    "Marketing Name": "REVVLRY+",
    "Device": "lake_n",
    "Model": "REVVLution"
  },
  {
    "Retail Branding": "T-Mobile",
    "Marketing Name": "Revvl 8",
    "Device": "Bremerton",
    "Model": "TMRV085G"
  },
  {
    "Retail Branding": "T-Mobile",
    "Marketing Name": "Revvl 8 Pro",
    "Device": "Prescott",
    "Model": "TMRV08P5G"
  },
  {
    "Retail Branding": "T-Mobile",
    "Marketing Name": "T-Mobile REVVL TAB 2",
    "Device": "Diana_TMO",
    "Model": "9185W"
  },
  {
    "Retail Branding": "T-Mobile",
    "Marketing Name": "TCL 20 XE",
    "Device": "Doha_TMO",
    "Model": "5087Z"
  },
  {
    "Retail Branding": "T-Mobile",
    "Marketing Name": "TMRV065G",
    "Device": "TorreyPines",
    "Model": "TMRV065G"
  },
  {
    "Retail Branding": "T-Mobile",
    "Marketing Name": "TMRV06P5G",
    "Device": "SouthernDunes",
    "Model": "TMRV06P5G"
  },
  {
    "Retail Branding": "T-Mobile",
    "Marketing Name": "TMRV5GTB",
    "Device": "REVVLTAB5G",
    "Model": "TMRV5GTB"
  },
  {
    "Retail Branding": "T-Mobile",
    "Marketing Name": "TVision",
    "Device": "SEI400TM",
    "Model": "TVision"
  },
  {
    "Retail Branding": "T-Mobile",
    "Marketing Name": "Telekom_Puls",
    "Device": "T-Tab",
    "Model": "Telekom Puls"
  },
  {
    "Retail Branding": "T-Mobile-CZ-Telekom-SK",
    "Marketing Name": "TV Box HY4403",
    "Device": "HY44G",
    "Model": "TV Box"
  },
  {
    "Retail Branding": "T-SOURCE",
    "Marketing Name": "SA70",
    "Device": "T70",
    "Model": "T70"
  },
  {
    "Retail Branding": "TA71CA5_JP",
    "Marketing Name": "JP SA COUTO, S.A. _MG070A2T",
    "Device": "TA71CA5_1",
    "Model": "TA71CA5"
  },
  {
    "Retail Branding": "TABWEE",
    "Marketing Name": "K10_EEA",
    "Device": "K10_EEA",
    "Model": "K10"
  },
  {
    "Retail Branding": "TABWEE",
    "Marketing Name": "K10_NEU",
    "Device": "K10_NEU",
    "Model": "K10"
  },
  {
    "Retail Branding": "TABWEE",
    "Marketing Name": "K10_RU",
    "Device": "K10",
    "Model": "K10"
  },
  {
    "Retail Branding": "TABWEE",
    "Marketing Name": "T12_Pro_EEA",
    "Device": "T12_Pro",
    "Model": "T12 Pro"
  },
  {
    "Retail Branding": "TABWEE",
    "Marketing Name": "T12_Pro_NEU",
    "Device": "T12_Pro",
    "Model": "T12 Pro"
  },
  {
    "Retail Branding": "TABWEE",
    "Marketing Name": "T20_EEA",
    "Device": "T20",
    "Model": "T20"
  },
  {
    "Retail Branding": "TABWEE",
    "Marketing Name": "T20_NEU",
    "Device": "T20",
    "Model": "T20"
  },
  {
    "Retail Branding": "TABWEE",
    "Marketing Name": "T50_EEA",
    "Device": "T50",
    "Model": "T50"
  },
  {
    "Retail Branding": "TABWEE",
    "Marketing Name": "T60_EA",
    "Device": "T60",
    "Model": "T60"
  },
  {
    "Retail Branding": "TABWEE",
    "Marketing Name": "T60_NEU",
    "Device": "T60",
    "Model": "T60"
  },
  {
    "Retail Branding": "TABWEE",
    "Marketing Name": "T60_RU",
    "Device": "T60",
    "Model": "T60"
  },
  {
    "Retail Branding": "TABWEE",
    "Marketing Name": "T70_EEA",
    "Device": "T70",
    "Model": "T70"
  },
  {
    "Retail Branding": "TABWEE",
    "Marketing Name": "T70_NEU",
    "Device": "T70",
    "Model": "T70"
  },
  {
    "Retail Branding": "TABWEE",
    "Marketing Name": "T90_EEA",
    "Device": "T90",
    "Model": "T90"
  },
  {
    "Retail Branding": "TABWEE",
    "Marketing Name": "T90_NEU",
    "Device": "T90",
    "Model": "T90"
  },
  {
    "Retail Branding": "TABWEE",
    "Marketing Name": "W90_EEA",
    "Device": "W90",
    "Model": "W90"
  },
  {
    "Retail Branding": "TABWEE",
    "Marketing Name": "W90_NEU",
    "Device": "W90",
    "Model": "W90"
  },
  {
    "Retail Branding": "TABWEE",
    "Marketing Name": "W90_RU",
    "Device": "W90",
    "Model": "W90"
  },
  {
    "Retail Branding": "TADI",
    "Marketing Name": "TADI_TOUCH_1_SERIES",
    "Device": "TADI_TOUCH_1",
    "Model": "TADI_TOUCH_1"
  },
  {
    "Retail Branding": "TAG Heuer",
    "Marketing Name": "Connected",
    "Device": "glacier",
    "Model": "TAG Heuer"
  },
  {
    "Retail Branding": "TAG Heuer",
    "Marketing Name": "Connected 2020",
    "Device": "orbital",
    "Model": "TAG Heuer"
  },
  {
    "Retail Branding": "TAG Heuer",
    "Marketing Name": "Connected Calibre E4 42mm",
    "Device": "oxygen42",
    "Model": "TAG Heuer"
  },
  {
    "Retail Branding": "TAG Heuer",
    "Marketing Name": "Connected Calibre E4 45mm",
    "Device": "oxygen45",
    "Model": "TAG Heuer"
  },
  {
    "Retail Branding": "TAG Heuer",
    "Marketing Name": "Connected Modular 41",
    "Device": "spectralite",
    "Model": "TAG Heuer"
  },
  {
    "Retail Branding": "TAG Heuer",
    "Marketing Name": "Connected Modular 45",
    "Device": "anthracite",
    "Model": "TAG Heuer"
  },
  {
    "Retail Branding": "TAG Heuer",
    "Marketing Name": "Connected Modular 45 (China)",
    "Device": "anthracite",
    "Model": "TAG Heuer"
  },
  {
    "Retail Branding": "TAG-DC",
    "Marketing Name": "TAG-DC",
    "Device": "TAG-DC",
    "Model": "TAG-DC"
  },
  {
    "Retail Branding": "TAG-TECH",
    "Marketing Name": "TAG Phone",
    "Device": "TAG_Phone",
    "Model": "TAG_Phone"
  },
  {
    "Retail Branding": "TAG-TECH",
    "Marketing Name": "TAG-TAB-III",
    "Device": "TAG-TAB-III",
    "Model": "TAG-TAB-III"
  },
  {
    "Retail Branding": "TAG-TECH",
    "Marketing Name": "TAG-TABKIDS",
    "Device": "TAG-TABKIDS",
    "Model": "TT-III"
  },
  {
    "Retail Branding": "TAG-TECH",
    "Marketing Name": "TAG_Pluto_TAB_II",
    "Device": "TAG_Pluto_TAB_II",
    "Model": "TAG_Pluto_TAB_II"
  },
  {
    "Retail Branding": "TAG-TECH",
    "Marketing Name": "TAG_Pluto_TAB_II",
    "Device": "TAG_Pluto_TAB_II",
    "Model": "studybook_Tablets"
  },
  {
    "Retail Branding": "TAG-TECH",
    "Marketing Name": "TAG_TAB_II",
    "Device": "TAG_TAB_II",
    "Model": "TAG TAB II"
  },
  {
    "Retail Branding": "TAG-TECH",
    "Marketing Name": "Tagphone plus",
    "Device": "Tagphone_plus",
    "Model": "Tagphone plus"
  },
  {
    "Retail Branding": "TAGITAL",
    "Marketing Name": "K88",
    "Device": "K88",
    "Model": "K88"
  },
  {
    "Retail Branding": "TAGITAL",
    "Marketing Name": "T7K_PLUS",
    "Device": "T7K-PLUS",
    "Model": "T7K_PLUS"
  },
  {
    "Retail Branding": "TAIFA",
    "Marketing Name": "TL1B_68",
    "Device": "TL1B_68",
    "Model": "TL1B_68"
  },
  {
    "Retail Branding": "TAMBOARD",
    "Marketing Name": "TB_GH",
    "Device": "TB_GH",
    "Model": "TB_GH"
  },
  {
    "Retail Branding": "TAMBOARD",
    "Marketing Name": "TB_Series",
    "Device": "oversea_v",
    "Model": "TB_Series"
  },
  {
    "Retail Branding": "TASKPHONE",
    "Marketing Name": "T20",
    "Device": "T20P",
    "Model": "T20"
  },
  {
    "Retail Branding": "TATUNG",
    "Marketing Name": "Smart TV",
    "Device": "alimos",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "TATUNG",
    "Marketing Name": "Smart TV",
    "Device": "dangni",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "TATUNG",
    "Marketing Name": "Smart TV",
    "Device": "osaka",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "TBC (TW)",
    "Marketing Name": "TATV-8000",
    "Device": "TATV_8000",
    "Model": "TATV-8000"
  },
  {
    "Retail Branding": "TBC (TW)",
    "Marketing Name": "TATV_8000",
    "Device": "TATV_8000",
    "Model": "TATV-8000"
  },
  {
    "Retail Branding": "TCH(Timeless Connection Hero)",
    "Marketing Name": "NEO",
    "Device": "NEO",
    "Model": "NEO"
  },
  {
    "Retail Branding": "TCH(Timeless Connection Hero)",
    "Marketing Name": "ONE",
    "Device": "ONE",
    "Model": "ONE"
  },
  {
    "Retail Branding": "TCH(Timeless Connection Hero)",
    "Marketing Name": "ONE Lite",
    "Device": "ONE_Lite",
    "Model": "ONE Lite"
  },
  {
    "Retail Branding": "TCH(Timeless Connection Hero)",
    "Marketing Name": "ONE PRO",
    "Device": "ONE_PRO",
    "Model": "ONE PRO"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "3T10 WIFI KDDI",
    "Device": "Aquaman_10_KDDI",
    "Model": 8194
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "A1",
    "Device": "T1_LE",
    "Model": "T770K"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "AQUOS V6",
    "Device": "Cruze_Lite_S",
    "Model": "SH-C03"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "AQUOS V6 plus",
    "Device": "Cruze_Pro",
    "Model": "SH-C04"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "Alcatel 1",
    "Device": "Macau",
    "Model": "5033E"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "Alcatel 1B",
    "Device": "Seoul",
    "Model": "5002W"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "Alcatel A31 Pro",
    "Device": "DahliaMax",
    "Model": "T451A"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "Beyond TV",
    "Device": "BeyondTV",
    "Model": "BeyondTV"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "BeyondTV2",
    "Device": "BeyondTV",
    "Model": "BeyondTV"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "BeyondTV2",
    "Device": "BeyondTV",
    "Model": "BeyondTV2"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "BeyondTV4",
    "Device": "BeyondTV4",
    "Model": "Smart TV Pro"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "BeyondTV5",
    "Device": "BeyondTV",
    "Model": "BeyondTV5"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "BeyondTV6",
    "Device": "BeyondTV4",
    "Model": "Smart TV"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "BeyondTV6",
    "Device": "BeyondTV4",
    "Model": "Smart TV Pro"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "BeyondTV7",
    "Device": "BeyondTV4",
    "Model": "Smart TV"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "C02_2K_GLB",
    "Device": "BeyondTV",
    "Model": "BeyondTV5"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "C02_4K_US",
    "Device": "BeyondTV",
    "Model": "Smart TV"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "C03_4K_NA",
    "Device": "BeyondTV4",
    "Model": "Smart TV"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "C05_4K_GB",
    "Device": "C05",
    "Model": "Smart TV Pro"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "C06_2K_GB",
    "Device": "C06",
    "Model": "Smart TV"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "C06_2K_US",
    "Device": "C06",
    "Model": "Smart TV"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "C9",
    "Device": "A3A_XL_4G",
    "Model": "5199I"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "G03_4K_GB",
    "Device": "BeyondTV4",
    "Model": "Smart TV Pro"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "G03_4K_GB_NF",
    "Device": "BeyondTV4",
    "Model": "Smart TV"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "G03_4K_US",
    "Device": "BeyondTV4",
    "Model": "Smart TV Pro"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "G03_4K_US_NF",
    "Device": "BeyondTV4",
    "Model": "Smart TV"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "G03_4K_US_NF",
    "Device": "BeyondTV4",
    "Model": "Smart TV Pro"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "G03_4K_US_NF_DB",
    "Device": "BeyondTV4",
    "Model": "Smart TV"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "G05_4K_GB",
    "Device": "G05",
    "Model": "Smart TV Pro"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "G05_4K_US",
    "Device": "G05",
    "Model": "Smart TV Pro"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "G06_2K_GB",
    "Device": "G06",
    "Model": "Smart TV"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "G06_2K_US",
    "Device": "G06",
    "Model": "Smart TV"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "G07_4K_GB_NF",
    "Device": "G07",
    "Model": "Smart TV"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "G08",
    "Device": "G08",
    "Model": "Smart TV Pro"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "G08_4K_US_NF",
    "Device": "G08",
    "Model": "Smart TV"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "G09",
    "Device": "G09",
    "Model": "Smart TV Pro"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "G09_4K_GB_NF",
    "Device": "G09",
    "Model": "Smart TV"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "G10",
    "Device": "G10",
    "Model": "Smart TV"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "G10_4K_GB_NF",
    "Device": "G10",
    "Model": "Smart TV"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "G10_4K_US",
    "Device": "G10",
    "Model": "Smart TV Pro"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "G13_2K_GB",
    "Device": "G13",
    "Model": "Smart TV"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "G13_2K_US",
    "Device": "G13",
    "Model": "Smart TV"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "G15_4K_GB",
    "Device": "G15",
    "Model": "Smart TV Pro"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "G16_4K_US",
    "Device": "G16",
    "Model": "Smart TV Pro"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "GL TCL",
    "Device": "Titan_Vis_Wifi",
    "Model": "9494G"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "GO5c",
    "Device": "U3A_PLUS_4G",
    "Model": "5033E"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "HotelTV",
    "Device": "HotelTV",
    "Model": "WelcomeTV"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "Jitterbug Smart4",
    "Device": "Sonata_BBH",
    "Model": "T608G"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "L55E6700UDS",
    "Device": "movo_la",
    "Model": "movo_la"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "LE50UHDE5692G",
    "Device": "movo",
    "Model": "movo"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "LT10",
    "Device": "U3A_10_WIFI",
    "Model": 8182
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "LT7",
    "Device": "U3A_7_WIFI",
    "Model": 8167
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "Percee TV",
    "Device": "tcl_eu",
    "Model": "BPL TV"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "Percee TV",
    "Device": "tcl_eu",
    "Model": "MICROMAX TV"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "Percee TV",
    "Device": "tcl_eu",
    "Model": "PANASONIC TV"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "Percee TV",
    "Device": "tcl_eu",
    "Model": "Percee TV"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "Percee TV",
    "Device": "tcl_eu",
    "Model": "SANYO TV"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "Percee TV",
    "Device": "tcl_sa",
    "Model": "Percee TV"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "ProjectorC1",
    "Device": "himalaya",
    "Model": "ProjectorC1"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "R3",
    "Device": "R3",
    "Model": "R3"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "R3_GTV",
    "Device": "R3_GTV",
    "Model": "R3G"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "R4",
    "Device": "R4",
    "Model": "R4"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "R4_GTV",
    "Device": "R4_GTV",
    "Model": "R4G"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "Smart M26",
    "Device": "DahliaS",
    "Model": "T450H"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "Smartphone",
    "Device": "A5A_INFINI",
    "Model": "5086D"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "Smartphone",
    "Device": "A5A_INFINI",
    "Model": "5186D"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "South America",
    "Device": "tcl",
    "Model": "Percee TV"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "T-Mobile REVVL TAB 2",
    "Device": "Diana_Uber",
    "Model": "9185W"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "T607DL",
    "Device": "Bora_TF",
    "Model": "T607DL"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TAB 10s 2022",
    "Device": "Odin2",
    "Model": "9081X"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TAB 10s 4G 2022",
    "Device": "Odin2",
    "Model": "9080G"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TAB 10s 4G New",
    "Device": "Odin2",
    "Model": "9080G"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TAB 10s New",
    "Device": "Odin2",
    "Model": "9081X"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TBD",
    "Device": "Apollo84GBoostR",
    "Model": "9132S"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TBD",
    "Device": "Odin_5G_TMO",
    "Model": "9183W"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL",
    "Device": "Scarab_Pro_TF",
    "Model": "T510D"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL 10 5G",
    "Device": "Seattle",
    "Model": "T790B"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL 10 5G",
    "Device": "Seattle",
    "Model": "T790H"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL 10 5G",
    "Device": "Seattle",
    "Model": "T790Y"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL 10 Plus",
    "Device": "Boston",
    "Model": "T782H"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL 10 Plus",
    "Device": "Boston",
    "Model": "T782P"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL 10 Pro",
    "Device": "T1_PRO",
    "Model": "T799B"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL 10 Pro",
    "Device": "T1_PRO",
    "Model": "T799H"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL 10 SE",
    "Device": "Oakland",
    "Model": "T766A"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL 10 SE",
    "Device": "Oakland",
    "Model": "T766H"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL 10 SE",
    "Device": "Oakland",
    "Model": "T766H_EEA"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL 10 SE",
    "Device": "Oakland",
    "Model": "T766H_RU"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL 10 SE",
    "Device": "Oakland",
    "Model": "T766H_TR"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL 10 SE",
    "Device": "Oakland",
    "Model": "T766J"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL 10 SE",
    "Device": "Oakland",
    "Model": "T766S"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL 10 SE",
    "Device": "Oakland",
    "Model": "T766U"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL 10 SE",
    "Device": "Oakland",
    "Model": "T766U_EEA"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL 10 TABMAX",
    "Device": "Transformer",
    "Model": "9296G"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL 10 TABMAX",
    "Device": "Transformer",
    "Model": "9296G_EEA"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL 10 TABMAX",
    "Device": "Transformer",
    "Model": "9296G_RU"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL 10 TABMAX",
    "Device": "Transformer",
    "Model": "9296G_TR"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL 10 TABMAX",
    "Device": "Transformer_WIFI",
    "Model": "9296X"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL 10 TABMAX",
    "Device": "Transformer_WIFI",
    "Model": "9296X_EEA"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL 10 TABMAX",
    "Device": "Transformer_WIFI",
    "Model": "9296X_TR"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL 10 TABMAX 4G",
    "Device": "Transformer_4G",
    "Model": "9295G"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL 10 TABMAX 4G",
    "Device": "Transformer_4G",
    "Model": "9295G_EEA"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL 10 TABMAX 4G",
    "Device": "Transformer_4G",
    "Model": "9295G_RU"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL 103",
    "Device": "Jakarta_Mini",
    "Model": "4165F"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL 103",
    "Device": "Jakarta_Mini",
    "Model": "4165J"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL 10L",
    "Device": "T1_LITE",
    "Model": "T770B"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL 10L",
    "Device": "T1_LITE",
    "Model": "T770H"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL 20 5G",
    "Device": "Irvine",
    "Model": "T781"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL 20 Pro 5G",
    "Device": "Ottawa",
    "Model": "T810H"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL 20 R 5G",
    "Device": "Buffalo",
    "Model": "T767H"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL 20 SE",
    "Device": "Austin",
    "Model": "T671E"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL 20 SE",
    "Device": "Austin",
    "Model": "T671F"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL 20 SE",
    "Device": "Austin",
    "Model": "T671H"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL 20 SE",
    "Device": "Austin",
    "Model": "T671O"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL 205",
    "Device": "Jakarta_Lite_refresh",
    "Model": "4187D"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL 20E",
    "Device": "HONG_KONG",
    "Model": "6125A"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL 20E",
    "Device": "HONG_KONG",
    "Model": "6125D"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL 20E",
    "Device": "HONG_KONG",
    "Model": "6125F"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL 20E",
    "Device": "HONG_KONG",
    "Model": "6125H_RU"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL 20L",
    "Device": "Richland",
    "Model": "T774B"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL 20L",
    "Device": "Richland",
    "Model": "T774H"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL 20L+",
    "Device": "Richland_Pro",
    "Model": "T775B"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL 20L+",
    "Device": "Richland_Pro",
    "Model": "T775H"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL 20S",
    "Device": "Miami_Pro",
    "Model": "T773O"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL 20Y",
    "Device": "Hong_Kong_Pro",
    "Model": "6156A"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL 20Y",
    "Device": "Hong_Kong_Pro",
    "Model": "6156D"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL 20Y",
    "Device": "Hong_Kong_Pro",
    "Model": "6156H"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL 20Y",
    "Device": "Hong_Kong_Pro",
    "Model": "A1 Alpha 21"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL 30",
    "Device": "Passat",
    "Model": "T676H"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL 30 5G",
    "Device": "Passat_5G",
    "Model": "T776H"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL 30 5G",
    "Device": "Passat_5G",
    "Model": "T776O"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL 30 LE",
    "Device": "Jetta_Visible",
    "Model": "4188V"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL 30 SE",
    "Device": "Cruze_Pro",
    "Model": "6165A"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL 30 SE",
    "Device": "Cruze_Pro",
    "Model": "6165H"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL 30 SE",
    "Device": "Cruze_Pro",
    "Model": "6165H_EEA"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL 30 SE",
    "Device": "Cruze_Pro",
    "Model": "6165S"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL 30 XE 5G",
    "Device": "Buffalo_Boost",
    "Model": "T767W"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL 30 XE 5G",
    "Device": "Buffalo_CAN",
    "Model": "T767G"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL 30 XL",
    "Device": "Austin_TF",
    "Model": "T701DL"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL 30 XL",
    "Device": "Austin_US",
    "Model": "T671G"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL 30 Z",
    "Device": "Jetta_Dish",
    "Model": "4188L"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL 30 Z",
    "Device": "Jetta_NA_OM",
    "Model": "4188O"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL 30+",
    "Device": "Passat",
    "Model": "T676J"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL 30+",
    "Device": "Passat",
    "Model": "T676K"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL 303",
    "Device": "Kona",
    "Model": "5131G"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL 304",
    "Device": "Wright_Pro",
    "Model": "4163D"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL 305",
    "Device": "Cruze_Lite",
    "Model": "6102A"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL 305",
    "Device": "Cruze_Lite",
    "Model": "6102D"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL 305i",
    "Device": "Corolla",
    "Model": "5164D"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL 306",
    "Device": "Cruze_Lite_S",
    "Model": "6102H"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL 306",
    "Device": "Cruze_Lite_S",
    "Model": "6102K"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL 30E",
    "Device": "Cruze",
    "Model": "6127I"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL 30XE 5G",
    "Device": "Buffalo_TMO",
    "Model": "T767W"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL 40 NXTPAPER",
    "Device": "Ladybird_Pro",
    "Model": "T612B"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL 40 NXTPAPER 5G",
    "Device": "Firefly",
    "Model": "T771K"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL 40 R 5G",
    "Device": "Levin",
    "Model": "T771H"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL 40 SE",
    "Device": "Model_3",
    "Model": "T610E"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL 40 SE",
    "Device": "Model_3",
    "Model": "T610K"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL 40 SE",
    "Device": "Model_3",
    "Model": "T610P"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL 40 X 5G",
    "Device": "Encore_OM",
    "Model": "T609M"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL 40 XE 5G",
    "Device": "Encore_CAN",
    "Model": "T609J"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL 40 XE 5G",
    "Device": "Encore_Spectrum",
    "Model": "T609V"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL 40 XE 5G",
    "Device": "Encore_USCC",
    "Model": "T609L"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL 40 XE 5G",
    "Device": "Encore_VZW",
    "Model": "T609SPP"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL 40 XE 5G",
    "Device": "Encore_Visible",
    "Model": "T609B"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL 403",
    "Device": "Rio",
    "Model": "T431A"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL 403",
    "Device": "Rio",
    "Model": "T431D"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL 403",
    "Device": "Rio",
    "Model": "T431E"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL 403",
    "Device": "Rio",
    "Model": "T431P"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL 403",
    "Device": "Rio",
    "Model": "T431Q"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL 403",
    "Device": "Rio",
    "Model": "T431U"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL 405",
    "Device": "Civic",
    "Model": "T506A"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL 405",
    "Device": "Civic",
    "Model": "T506D"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL 406",
    "Device": "Civic_S",
    "Model": "T506G"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL 406",
    "Device": "Civic_S",
    "Model": "T506K"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL 406i",
    "Device": "Civic_S_Refresh",
    "Model": "T506F"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL 406s",
    "Device": "Civic_S",
    "Model": "T506T"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL 408",
    "Device": "Civic_Plus",
    "Model": "T507A"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL 408",
    "Device": "Civic_Plus",
    "Model": "T507D"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL 408",
    "Device": "Civic_Plus",
    "Model": "T507F"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL 408",
    "Device": "Civic_Plus",
    "Model": "T507J"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL 408",
    "Device": "Civic_Plus",
    "Model": "T507U"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL 40T",
    "Device": "Sonata_TF",
    "Model": "T608DL"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL 40XL",
    "Device": "Sonata_Pro_OM",
    "Model": "T608M"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL 50 5G",
    "Device": "Dragonfly",
    "Model": "T613K"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL 50 5G",
    "Device": "Dragonfly",
    "Model": "T613P"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL 50 LE",
    "Device": "Scarab_Pro_NA_OM",
    "Model": "T510WS"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL 50 LE",
    "Device": "Scarab_Pro_VZW",
    "Model": "T510SP"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL 50 NXTPAPER 5G",
    "Device": "Goldfinch_NP",
    "Model": "T702D"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL 50 PRO NXTPAPER 5G",
    "Device": "Goldfinch_NP_Pro",
    "Model": "T803D"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL 50 PRO NXTPAPER 5G",
    "Device": "Goldfinch_NP_Pro",
    "Model": "T803E"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL 50 SE",
    "Device": "Ladybird",
    "Model": "T611B"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL 50 XE 5G",
    "Device": "Dragonfly_TF",
    "Model": "T614D"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL 50 XE 5G",
    "Device": "Dragonfly_VZW",
    "Model": "T614SP"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL 50 XE NXTPAPER 5G",
    "Device": "Dragonfly_CAN",
    "Model": "T614J"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL 50 XE NXTPAPER 5G",
    "Device": "Dragonfly_OM",
    "Model": "T614WS"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL 50 XL 5G",
    "Device": "Goldfinch_TMO",
    "Model": "T702W"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL 50 XL NXTPAPER 5G",
    "Device": "Goldfinch_Dish",
    "Model": "T702Z"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL 50 XL NXTPAPER 5G",
    "Device": "Goldfinch_Pro_CS",
    "Model": "T702M"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL 50 XL NXTPAPER 5G",
    "Device": "Ruby_TF",
    "Model": "T704V"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL 50 XL NXTPAPER 5G",
    "Device": "Ruby_VZW",
    "Model": "T704SP"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL 501",
    "Device": "Bee_One",
    "Model": "T433D"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL 501",
    "Device": "Bee_One",
    "Model": "T433E"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL 502",
    "Device": "Lotus",
    "Model": "T442J"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL 502",
    "Device": "Rio_CAN",
    "Model": "T432J"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL 503",
    "Device": "Lotus",
    "Model": "T442A"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL 503",
    "Device": "Lotus",
    "Model": "T442M"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL 505",
    "Device": "Ant",
    "Model": "T509A"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL 505",
    "Device": "Ant",
    "Model": "T509K"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL 505 S",
    "Device": "Ant",
    "Model": "T509A"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL 60 5G",
    "Device": "Aster_Pro",
    "Model": "T521H"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL 60 NXTPAPER",
    "Device": "Erica_NP_Pro",
    "Model": "T626K"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL 60 SE",
    "Device": "Vinca",
    "Model": "T517H"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL 60 SE NXTPAPER 5G",
    "Device": "Aster_Pro",
    "Model": "T521D"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL 60 SE NXTPAPER 5G",
    "Device": "Aster_Pro",
    "Model": "T521K"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL 60 SE NXTPAPER 5G",
    "Device": "Aster_Pro",
    "Model": "T521N"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL 60 XE NXTPAPER 5G",
    "Device": "Sunrise_CAN",
    "Model": "T705J"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL 60 XE NXTPAPER 5G",
    "Device": "Sunrise_NA_OM",
    "Model": "T705M"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL 603",
    "Device": "DahliaS",
    "Model": "T451H"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL 605",
    "Device": "Vinca",
    "Model": "T517A"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL 605",
    "Device": "Vinca",
    "Model": "T517D"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL 605",
    "Device": "Vinca",
    "Model": "T517F"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL 605",
    "Device": "Vinca",
    "Model": "T517J"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL 60R 5G",
    "Device": "Aster",
    "Model": "T519H"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL 60R 5G",
    "Device": "Aster",
    "Model": "T519N"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL A3X",
    "Device": "Delhi_TF",
    "Model": "A600DL"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL C5",
    "Device": "A3A",
    "Model": "5152D"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL C5",
    "Device": "Gauss",
    "Model": "5153A"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL C5",
    "Device": "Gauss",
    "Model": "5153K"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL C7",
    "Device": "A3A_PLUS",
    "Model": "5158A"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL C9 Plus",
    "Device": "Venice",
    "Model": "5148I"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL ION V",
    "Device": "Bora_NA_OM",
    "Model": "T430M"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL ION X",
    "Device": "Bora_NA_OM",
    "Model": "T430WS"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL ION X",
    "Device": "Bora_TMO",
    "Model": "T430W"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL K11",
    "Device": "Rio_TMO",
    "Model": "T432W"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL K12",
    "Device": "Scarab_Lite_CAN",
    "Model": "T434J"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL K23",
    "Device": "ScarabLite_TMO",
    "Model": "T434W"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL K24",
    "Device": "Scarab_Lite_TF",
    "Model": "T434D"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL K32 5G",
    "Device": "Beryl_TMO",
    "Model": "T513W"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL K33 5G",
    "Device": "Beryl_Dish",
    "Model": "T513Z"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL K33 5G",
    "Device": "Beryl_TF",
    "Model": "T513V"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL K33 5G",
    "Device": "Beryl_VZW",
    "Model": "T513SP"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL K70 4G",
    "Device": "Bamboo",
    "Model": "T522A"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL K70 Power 4G",
    "Device": "Bamboo_Power",
    "Model": "T522E"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL K70 SE",
    "Device": "Thyme",
    "Model": "T453D"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL L10",
    "Device": "Faraday",
    "Model": "5124J"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL L10 Lite",
    "Device": "Jakarta_Lite",
    "Model": "4187M"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL L10 Lite",
    "Device": "Jakarta_Lite",
    "Model": "4187U"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL L10+",
    "Device": "Jakarta",
    "Model": "5030E_TCL"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL L10+",
    "Device": "Jakarta",
    "Model": "5130E"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL L10+",
    "Device": "Jakarta",
    "Model": "5130G"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL L10+",
    "Device": "Jakarta",
    "Model": "5130I"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL L10+",
    "Device": "Jakarta",
    "Model": "5130J"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL L10+",
    "Device": "Jakarta",
    "Model": "5130K"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL L10+",
    "Device": "Tokyo",
    "Model": "5128A"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL L10+",
    "Device": "Tokyo",
    "Model": "5128Y"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL L5",
    "Device": "U3A_PLUS_4G",
    "Model": "5133A"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL L7",
    "Device": "Seoul",
    "Model": "5102B"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL L7",
    "Device": "Seoul",
    "Model": "5102I"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL L7",
    "Device": "Seoul",
    "Model": "5102K"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL L7",
    "Device": "Seoul",
    "Model": "5102M"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL L7",
    "Device": "Seoul",
    "Model": "5102P"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL L9",
    "Device": "U5A_PLUS_4G",
    "Model": "5159A"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL L9",
    "Device": "U5A_PLUS_4G",
    "Model": "5159J"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL L9 Plus",
    "Device": "Wright",
    "Model": "5101A"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL L9 Plus",
    "Device": "Wright",
    "Model": "5101J"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL L9S",
    "Device": "Tokyo_Lite",
    "Model": "5107G"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL L9S",
    "Device": "Tokyo_Lite",
    "Model": "5107J"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL NXTPAPAER 4G",
    "Device": "Da_Vinci_4G",
    "Model": "9288A"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL NXTPAPER 10s",
    "Device": "Odin2",
    "Model": "9080G"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL NXTPAPER 10s",
    "Device": "Odin2",
    "Model": "9081X"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL NXTPAPER 11",
    "Device": "Eternals11",
    "Model": "9466X"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL NXTPAPER 11 Gen2",
    "Device": "Ares_Vis_WIFI",
    "Model": "9465X"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL NXTPAPER 11 Plus",
    "Device": "Bellona_WF_GL",
    "Model": "9469X"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL NXTPAPER 14",
    "Device": "Hera_Vis_WIFI",
    "Model": "9491G"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL NXTPAPER 14 Pro",
    "Device": "Hercules_Wifi",
    "Model": "9463A1"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL NXTPAPER 5G Junior",
    "Device": "Aster_Pro",
    "Model": "T521K"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL NXTPAPER 60 Ultra",
    "Device": "MonaLisa",
    "Model": "T951K"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL NXTPAPER 60 Ultra",
    "Device": "MonaLisa",
    "Model": "T951P"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL NXTPAPER 70 Pro",
    "Device": "Frida",
    "Model": "T807D"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL NXTPAPER 70 Pro",
    "Device": "Frida",
    "Model": "T807E"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL PLEX",
    "Device": "T1",
    "Model": "T780H"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL PLEX",
    "Device": "T1_L1",
    "Model": "T780H"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL Stylus 5G",
    "Device": "Challenger_CS",
    "Model": "T779W"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL Stylus 5G",
    "Device": "Challenger_TMO",
    "Model": "T779W"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL T Pro",
    "Device": "Jakarta",
    "Model": "5130M"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL T Pro",
    "Device": "Milan",
    "Model": "5161A"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL T Pro",
    "Device": "Milan",
    "Model": "5161K"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL T7",
    "Device": "A5A_INFINI",
    "Model": "5186A"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL T9",
    "Device": "Venice",
    "Model": "5148A"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL T9+",
    "Device": "TokyoPro",
    "Model": "5129A"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL T9x",
    "Device": "TokyoPro",
    "Model": "5129Y"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL TAB",
    "Device": "Thor_8_4G_VZW",
    "Model": "9048S"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL TAB 10",
    "Device": "Logan",
    "Model": "9160G"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL TAB 10 4G",
    "Device": "Aquaman_10_4G",
    "Model": "8094X"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL TAB 10 5G",
    "Device": "Odin5GACG",
    "Model": "9183W"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL TAB 10 FHD",
    "Device": "Logan_FHD",
    "Model": "9161G"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL TAB 10 FHD",
    "Device": "Logan_FHD",
    "Model": "9461G"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL TAB 10 FHD 4G",
    "Device": "Aquaman_10_Pro",
    "Model": "9060G"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL TAB 10 Gen4",
    "Device": "Lugh_FHD_WiFi",
    "Model": "8483A"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL TAB 10 HD",
    "Device": "Logan",
    "Model": "9160G"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL TAB 10 HD",
    "Device": "Logan",
    "Model": "9160G1"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL TAB 10 HD",
    "Device": "Logan",
    "Model": "9460G"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL TAB 10 HD 4G",
    "Device": "Aquaman_10_Pro",
    "Model": "9060X"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL TAB 10 HD 4G",
    "Device": "Aquaman_10_Pro",
    "Model": "9060X_EEA"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL TAB 10 LTE Gen4",
    "Device": "Lugh_FHD_4G",
    "Model": "8183A"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL TAB 10 NXTPAPER 5G",
    "Device": "Optimus_5G_VZW",
    "Model": "9199S"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL TAB 10 SMART",
    "Device": "Aquaman_10_4G",
    "Model": "8094T"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL TAB 10L",
    "Device": "Aquaman_10_Smart_WIFI",
    "Model": "8491X"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL TAB 10L",
    "Device": "Aquaman_10_Smart_WIFI",
    "Model": "8491X_EEA"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL TAB 10L",
    "Device": "Aquaman_10_Smart_WIFI",
    "Model": "8491X_RU"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL TAB 10L",
    "Device": "Aquaman_10_Smart_WIFI",
    "Model": "8491X_TR"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL TAB 10L Gen 2",
    "Device": "Freyr_10_1_WiFi",
    "Model": "8492A"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL TAB 10L LTE Gen 2",
    "Device": "Freyr_10_1_4G",
    "Model": "8192A"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL TAB 10L LTE Gen 3",
    "Device": "Freyr_Pro_4G_U",
    "Model": "8193A"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL TAB 10L LTE Gen 3",
    "Device": "Freyr_Pro_4G_U",
    "Model": "8194A"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL TAB 10L LTE Gen 4",
    "Device": "Lugh_10_4G",
    "Model": "8183A"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL TAB 10s",
    "Device": "Aquaman_10_Pro",
    "Model": 9061
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL TAB 10s",
    "Device": "Odin",
    "Model": "9081X"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL TAB 10s 4G",
    "Device": "Odin",
    "Model": "9080G"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL TAB 10s 4G",
    "Device": "Odin",
    "Model": "9080X"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL TAB 10s 5G",
    "Device": "Odin_5G",
    "Model": "9183G"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL TAB 11",
    "Device": "Eternals11",
    "Model": "9466X"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL TAB 11 FE",
    "Device": "Ares_11_WIFI",
    "Model": "9465X"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL TAB 11 FE LTE",
    "Device": "Ares_11_4G",
    "Model": "9465G"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL TAB 11 Gen2",
    "Device": "Ares_11_WIFI",
    "Model": "9465X"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL TAB 11 LTE",
    "Device": "Eternals11",
    "Model": "9166G"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL TAB 7 Lite",
    "Device": "U3A_7_WIFI_Refresh",
    "Model": "9309X"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL TAB 7 Lite",
    "Device": "U3A_7_WIFI_Refresh",
    "Model": "9309X2"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL TAB 8",
    "Device": "Apollo_8_4G",
    "Model": "9132X"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL TAB 8",
    "Device": "Luna",
    "Model": "9132G"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL TAB 8",
    "Device": "Luna",
    "Model": "9132X"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL TAB 8 4G",
    "Device": "Apollo_8_4G",
    "Model": "9032T"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL TAB 8 4G",
    "Device": "Apollo_8_4G",
    "Model": "9032X"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL TAB 8 4G",
    "Device": "Apollo_8_4G",
    "Model": "9132G"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL TAB 8 Gen2",
    "Device": "Venus_4G_NA_OM",
    "Model": "8188S"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL TAB 8 Gen2",
    "Device": "Venus_WF_NA_OM",
    "Model": "8188X"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL TAB 8 Gen2",
    "Device": "Venus_WiFi_GL",
    "Model": "8188X"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL TAB 8 LE",
    "Device": "Luna_8_4G_TMO",
    "Model": "9137W"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL TAB 8 LTE Gen2",
    "Device": "Venus_4G_GL",
    "Model": "8188G"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL TAB 8 NEO",
    "Device": "Apollo_8_4G",
    "Model": 9032
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL TAB 8 NXTPAPER 5G",
    "Device": "Selene_VZW",
    "Model": "8189S"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL TAB 8 Plus",
    "Device": "Luna_8_4G_VZW",
    "Model": "9138S"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL TAB 8 SE",
    "Device": "Luna_8_4G_ATT",
    "Model": "9136K"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL TAB 8 SE",
    "Device": "Luna_8_4G_ATT",
    "Model": "9136R"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL TAB 8 V",
    "Device": "Luna",
    "Model": "9132X"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL TAB 8 Wi-Fi",
    "Device": "Luna",
    "Model": "9132X"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL TAB A1 Plus",
    "Device": "Hermes_12_2",
    "Model": "9445X"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL TAB Disney Edition",
    "Device": "Thor_8_4G_VZW",
    "Model": "9050S"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL TAB Disney Edition 2",
    "Device": "Luna_8_4G_VZW",
    "Model": "9150S"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL TAB HD WIFI",
    "Device": "Logan",
    "Model": "9460G"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL TAB Lite",
    "Device": "Apollo84GBoostR",
    "Model": "9132S"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL TAB Lite",
    "Device": "Apollo84GUSCC",
    "Model": "9132L"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL TAB kids",
    "Device": "Thor_8_4G_VZW",
    "Model": "9049L"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL TAB10 Gen2",
    "Device": "Gaia",
    "Model": "8496G"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL TAB10 LTE Gen2",
    "Device": "Gaia",
    "Model": "8196G"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL TABMAX 10.4",
    "Device": "Transformer2",
    "Model": "9296Q"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL stylus 5G",
    "Device": "Challenger_TH",
    "Model": "T779P"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL 随学园 E8 4G",
    "Device": "E8",
    "Model": 9011
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL 随学堂 L10 5G",
    "Device": "Odin_5G",
    "Model": "9183T"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL 随学堂 L12 Pro",
    "Device": "Titan_12_Vision_Wifi",
    "Model": "9494G"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TCL201",
    "Device": "Macau",
    "Model": "5133MP"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TKEE MAX",
    "Device": "Aquaman_10_Smart_WIFI",
    "Model": "8491XN"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TKEE MAX",
    "Device": "Aquaman_10_Smart_WIFI",
    "Model": "8491XN_EEA"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TKEE MAX",
    "Device": "Aquaman_10_Smart_WIFI",
    "Model": "8491XN_RU"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TKEE MAX",
    "Device": "Aquaman_10_Smart_WIFI",
    "Model": "8491XN_TR"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TKEE MINI",
    "Device": "Hulk_7_KIDS_WIFI",
    "Model": 8093
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "TKEE mini",
    "Device": "Phoenix_7_Kids",
    "Model": "9317G"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "Telstra T-Inspire 2",
    "Device": "DahliaS",
    "Model": "T450H"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "Union TV",
    "Device": "UnionTV",
    "Model": "UnionTV"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "alcatel 1T7 NEW",
    "Device": "U3A_7_WIFI_Refresh",
    "Model": "9309X2_TR"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "alcatel 1T7 NEW",
    "Device": "U3A_7_WIFI_Refresh",
    "Model": "9309X_TR"
  },
  {
    "Retail Branding": "TCL",
    "Marketing Name": "tbd",
    "Device": "Jetta_VZW",
    "Model": "4188S"
  },
  {
    "Retail Branding": "TCST",
    "Marketing Name": "L7",
    "Device": "L7",
    "Model": "L7"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "",
    "Device": "A556C",
    "Model": "A556C"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "",
    "Device": "A919_gsm",
    "Model": "TCL A919"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "",
    "Device": "ASB-D_T918",
    "Model": "ASB-D T918"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "",
    "Device": "B-GriffinPlus_TD",
    "Model": "ASB-D T918"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "",
    "Device": "BASE_Varia_gsm",
    "Model": "BASE_Varia"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "",
    "Device": "E928_TD",
    "Model": "TCL E928"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "",
    "Device": "Griffin_TD",
    "Model": "TCL E928"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "",
    "Device": "MOVE_gsm",
    "Model": "MOVE"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "",
    "Device": "MTC-962_gsm",
    "Model": "MTC-962"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "",
    "Device": "Martini",
    "Model": "one touch 906"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "",
    "Device": "MegaFon_SP-A10",
    "Model": "MegaFon_SP-A10"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "",
    "Device": "ONE_TOUCH_928D_gsm",
    "Model": "ALCATEL ONE TOUCH 928D"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "",
    "Device": "ONE_TOUCH_983A_gsm",
    "Model": "ALCATEL_one_touch_983A"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "",
    "Device": "ONE_TOUCH_983M_gsm",
    "Model": "ONE TOUCH 983M"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "",
    "Device": "OP070",
    "Model": "OP070"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "",
    "Device": "OT-906",
    "Model": "ALCATEL_one_touch_906"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "",
    "Device": "OT-906",
    "Model": "ALCATEL_one_touch_906Y"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "",
    "Device": "OT-913D",
    "Model": "ALCATEL_one_touch_913D"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "",
    "Device": "OT-976",
    "Model": "ALCATEL_one_touch_976"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "",
    "Device": "OT-978",
    "Model": "ALCATEL_one_touch_978"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "",
    "Device": "OT-979",
    "Model": "ALCATEL_one_touch_979"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "",
    "Device": "OT-979",
    "Model": "ALCATEL_one_touch_979_HelloKitty"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "",
    "Device": "OT-980A_gsm",
    "Model": "Alcatel OT-980A"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "",
    "Device": "OT-980_gsm",
    "Model": "Alcatel OT-980"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "",
    "Device": "OT-980_gsm",
    "Model": "Alcatel OT-980A"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "",
    "Device": "OT-980_gsm",
    "Model": "Alcatel OT-981A"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "",
    "Device": "OT-981A_gsm",
    "Model": "Alcatel OT-981A"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "",
    "Device": "OT-981_gsm",
    "Model": "Alcatel OT-981A"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "",
    "Device": "OT_918_gsm",
    "Model": "ALCATEL OT 918"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "",
    "Device": "OT_919_HelloKitty_gsm",
    "Model": "ALCATEL OT 919 HelloKitty"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "",
    "Device": "OT_919_gsm",
    "Model": "ALCATEL OT 919"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "",
    "Device": "OT_990M_gsm",
    "Model": "ALCATEL_OT_990M"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "",
    "Device": "RASPG3201_umts",
    "Model": "RASPG3201"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "",
    "Device": "RPSPG3201_umts",
    "Model": "RPSPG3201"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "",
    "Device": "SmartIII4",
    "Model": "Vodafone 975N"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "",
    "Device": "T20",
    "Model": "one touch T20"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "",
    "Device": "T60",
    "Model": "onetouch T60"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "",
    "Device": "TCL-A909_A909_gsm",
    "Model": "TCL A909"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "",
    "Device": "TCL-S806",
    "Model": "TCL-S806"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "",
    "Device": "TCL_890D_gsm",
    "Model": "TCL A890 2SIM"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "",
    "Device": "TCL_A510",
    "Model": "TCL A510"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "",
    "Device": "TCL_A510",
    "Model": "TCL_A510"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "",
    "Device": "TCL_A919_umts",
    "Model": "TCL A919"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "",
    "Device": "TCL_A919_umts",
    "Model": "TCL_W969"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "",
    "Device": "TCL_A966_gsm",
    "Model": "TCL A966"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "",
    "Device": "TCL_A968",
    "Model": "TCL A968"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "",
    "Device": "TCL_A980_gsm",
    "Model": "TCL A980"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "",
    "Device": "TCL_A986_gsm",
    "Model": "TCL A986"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "",
    "Device": "TCL_A988_gsm",
    "Model": "TCL_A988"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "",
    "Device": "TCL_A998_gsm",
    "Model": "TCL A998"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "",
    "Device": "TCL_C990_Plus_cdma",
    "Model": "TCL C990+"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "",
    "Device": "TCL_D515_cdma",
    "Model": "TCL D515"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "",
    "Device": "TCL_D662_cdma",
    "Model": "TCL D662"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "",
    "Device": "TCL_S800_GSM",
    "Model": "TCL S800"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "",
    "Device": "TCL_W939_gsm",
    "Model": "TCL_W939"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "",
    "Device": "TCL_W969_gsm",
    "Model": "TCL W969"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "",
    "Device": "Vancouver_gsm",
    "Model": "Vancouver_Orange"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "",
    "Device": "mercury",
    "Model": "I-L1"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "",
    "Device": "move_2_gsm",
    "Model": "move 2"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "",
    "Device": "msm7627_ffa",
    "Model": "Alcatel OT-980"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "",
    "Device": "msm7627_ffa",
    "Model": "Alcatel OT-980A"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "",
    "Device": "one_touch_890D_gsm",
    "Model": "ALCATEL one touch 890D"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "",
    "Device": "one_touch_890_gsm",
    "Model": "ALCATEL_one_touch_890"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "",
    "Device": "one_touch_890_gsm",
    "Model": "Vip_MiniDroid"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "",
    "Device": "one_touch_891_gsm",
    "Model": "ALCATEL_one_touch_891"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "",
    "Device": "one_touch_908A_gsm",
    "Model": "ALCATEL_one_touch_908A"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "",
    "Device": "one_touch_908F_gsm",
    "Model": "ALCATEL_one_touch_908F"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "",
    "Device": "one_touch_908F_gsm",
    "Model": "ALCATEL_one_touch_908F_Orange"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "",
    "Device": "one_touch_908F_gsm",
    "Model": "Alcatel_one_touch_908F"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "",
    "Device": "one_touch_908F_gsm",
    "Model": "Alcatel_one_touch_908F_Orange"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "",
    "Device": "one_touch_908M_gsm",
    "Model": "ALCATEL_one_touch_908M"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "",
    "Device": "one_touch_908S_gsm",
    "Model": "ALCATEL_one_touch_908S"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "",
    "Device": "one_touch_908_gsm",
    "Model": "ALCATEL ONE TOUCH 908"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "",
    "Device": "one_touch_909A_gsm",
    "Model": "ALCATEL_one_touch_909A"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "",
    "Device": "one_touch_909B_cdma",
    "Model": "ALCATEL_one_touch_909B"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "",
    "Device": "one_touch_909B_cdma",
    "Model": "USCC_ALCATEL_one_touch_909B"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "",
    "Device": "one_touch_909S_gsm",
    "Model": "ALCATEL_one_touch_909S"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "",
    "Device": "one_touch_910A_gsm",
    "Model": "ALCATEL_one_touch_910A"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "",
    "Device": "one_touch_910_gsm",
    "Model": "ALCATEL_one_touch_910"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "",
    "Device": "one_touch_916A_gsm",
    "Model": "ALCATEL ONE TOUCH 916A"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "",
    "Device": "one_touch_916D_gsm",
    "Model": "ALCATEL ONE TOUCH 916D"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "",
    "Device": "one_touch_916_gsm",
    "Model": "ALCATEL ONE TOUCH 916"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "",
    "Device": "one_touch_918M_gsm",
    "Model": "ALCATEL_ONE_TOUCH_918M"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "",
    "Device": "one_touch_918M_umts",
    "Model": "ALCATEL_one_touch_918M"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "",
    "Device": "one_touch_918N_umts",
    "Model": "ALCATEL_one_touch_918N"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "",
    "Device": "one_touch_918_gsm",
    "Model": "ALCATEL ONE TOUCH 918"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "",
    "Device": "one_touch_985_gsm",
    "Model": "ALCATEL ONE TOUCH 985"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "",
    "Device": "one_touch_985_gsm",
    "Model": "Telenor Smart"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "",
    "Device": "one_touch_988_cdma",
    "Model": "ALCATEL_one_touch_988"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "",
    "Device": "one_touch_988_cdma",
    "Model": "USCC_ALCATEL_one_touch_988"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "",
    "Device": "one_touch_990A_gsm",
    "Model": "ALCATEL ONE TOUCH 990A"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "",
    "Device": "one_touch_990A_gsm",
    "Model": "ALCATEL_one_touch_990A"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "",
    "Device": "one_touch_990C_cdma",
    "Model": "ALCATEL one touch 990C"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "",
    "Device": "one_touch_990_gsm",
    "Model": "ALCATEL ONE TOUCH 990"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "",
    "Device": "one_touch_990_gsm",
    "Model": "Alcatel one touch 990 Orange"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "",
    "Device": "one_touch_990_gsm",
    "Model": "Telenor_OneTouch"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "",
    "Device": "one_touch_991S_gsm",
    "Model": "ALCATEL ONE TOUCH 991S"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "",
    "Device": "one_touch_993D_gsm",
    "Model": "ALCATEL ONE TOUCH 993D"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "",
    "Device": "one_touch_995A_gsm",
    "Model": "ALCATEL_one_touch_995A"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "",
    "Device": "one_touch_995C_cdma",
    "Model": "one touch 995C+"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "",
    "Device": "one_touch_996_gsm",
    "Model": "Orange_infinity_996"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "1T10  WIFI",
    "Device": "Aquaman_10_WIFI",
    "Model": 8091
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "1T10  WIFI",
    "Device": "Aquaman_10_WIFI",
    "Model": "8091_EEA"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "1T10  WIFI",
    "Device": "Aquaman_10_WIFI",
    "Model": "8091_TR"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "1T10 SMART",
    "Device": "Aquaman_10_Smart_WIFI",
    "Model": 8092
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "1T10 SMART",
    "Device": "Aquaman_10_Smart_WIFI",
    "Model": "8092_EEA"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "1T10 SMART",
    "Device": "Aquaman_10_Smart_WIFI",
    "Model": "8092_RU"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "1T10 SMART",
    "Device": "Aquaman_10_Smart_WIFI",
    "Model": "8092_TR"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "1T10 WIFI",
    "Device": "Aquaman_10_WIFI",
    "Model": "8091_RU"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "1T10 WIFI",
    "Device": "Aquaman_10_WIFI",
    "Model": 8391
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "3T10 4G",
    "Device": "A3A_10_4G",
    "Model": "8088G"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "3T10 4G",
    "Device": "A3A_10_4G",
    "Model": "8088X"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "3T10 4G",
    "Device": "Aquaman_10_4G",
    "Model": "8094M"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "3T10 4G",
    "Device": "Aquaman_10_4G",
    "Model": "8094T"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "3T10 4G",
    "Device": "Aquaman_10_4G",
    "Model": "8094T_EEA"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "3T10 4G",
    "Device": "Aquaman_10_4G",
    "Model": "8094T_RU"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "3T10 4G",
    "Device": "Aquaman_10_4G",
    "Model": "8094T_TR"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "3T10 4G",
    "Device": "Aquaman_10_4G",
    "Model": "8094X"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "3T10 4G",
    "Device": "Aquaman_10_4G",
    "Model": "8094X_EEA"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "3T10 4G",
    "Device": "Aquaman_10_4G",
    "Model": "8094X_RU"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "3T10 4G",
    "Device": "Aquaman_10_4G",
    "Model": "8094X_TR"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "4013M",
    "Device": "Pixi3-4",
    "Model": "4013M"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "4014A",
    "Device": "Pixi3-4",
    "Model": "4014A"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "4014M",
    "Device": "Pixi3-4",
    "Model": "4014M"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "4024X",
    "Device": "PLAY_P1",
    "Model": "4024X"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "4047D",
    "Device": "U5_3G",
    "Model": "4047D"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "4047G",
    "Device": "U5_3G",
    "Model": "4047G"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "4047N",
    "Device": "U5_3G",
    "Model": "4047N"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "4047X",
    "Device": "U5_3G",
    "Model": "4047X"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "4055A",
    "Device": "U3",
    "Model": "4055A"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "4055I",
    "Device": "U3",
    "Model": "4055I"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "4055J",
    "Device": "U3",
    "Model": "4055J"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "4055Q",
    "Device": "U3",
    "Model": "4055Q"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "4055T",
    "Device": "U3",
    "Model": "4055T"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "4055U",
    "Device": "U3",
    "Model": "4055U"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "4060W",
    "Device": "Pixi445",
    "Model": "4060W"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "4114E",
    "Device": "Pixi3-4",
    "Model": "4114E"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "5011A",
    "Device": "BUZZ6_55",
    "Model": "5011A"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "5017B",
    "Device": "Pixi3454GSPR",
    "Model": "5017B"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "5023E",
    "Device": "Pixi4PlusPower",
    "Model": "5023E"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "5023F",
    "Device": "Pixi4PlusPower",
    "Model": "5023F"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "5027B",
    "Device": "Pixi445SPR",
    "Model": "5027B"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "5038D",
    "Device": "SOUL45_GSM",
    "Model": "5038D"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "5042T",
    "Device": "ALTO45TMO",
    "Model": "5042T"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "5046S",
    "Device": "Mickey6VZW",
    "Model": "5046S"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "5049S",
    "Device": "Mickey6TVZW",
    "Model": "5049S"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "5049W",
    "Device": "Mickey6TTMO",
    "Model": "5049W"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "5049Z",
    "Device": "Mickey6TTMO",
    "Model": "5049Z"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": 5051,
    "Device": "POP45",
    "Model": 5051
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "5051A",
    "Device": "POP45",
    "Model": "5051A"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "5051D",
    "Device": "POP45",
    "Model": "5051D"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "5051J",
    "Device": "POP45",
    "Model": "5051J"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "5051M",
    "Device": "POP45",
    "Model": "5051M"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "5051T",
    "Device": "POP45",
    "Model": "5051T"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "5051X",
    "Device": "POP45",
    "Model": "5051X"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "5054A",
    "Device": "Pop355",
    "Model": "5054A"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "5054D",
    "Device": "Pop355",
    "Model": "5054D"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "5054S",
    "Device": "Pop355",
    "Model": "5054S"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "5054T",
    "Device": "Pop355",
    "Model": "5054T"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "5054W",
    "Device": "Pop355",
    "Model": "5054W"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "5054X",
    "Device": "Pop355",
    "Model": "5054X"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": 5056,
    "Device": "POP455C",
    "Model": 5056
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "5056A",
    "Device": "POP455C",
    "Model": "5056A"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "5056D",
    "Device": "POP455C",
    "Model": "5056D"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "5056E",
    "Device": "POP455C",
    "Model": "5056E"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "5056E",
    "Device": "POP455C",
    "Model": "5056M"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "5056G",
    "Device": "POP455C",
    "Model": "5056G"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "5056I",
    "Device": "POP455C",
    "Model": "5056I"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "5056N",
    "Device": "POP455C",
    "Model": "5056N"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "5056T",
    "Device": "POP455C",
    "Model": "5056T"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "5056U",
    "Device": "POP455C",
    "Model": "5056U"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "5056W",
    "Device": "POP455C",
    "Model": "5056W"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "5056X",
    "Device": "POP455C",
    "Model": "5056X"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "5059Z",
    "Device": "U50APLUSTMO",
    "Model": "5059Z"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "5065A",
    "Device": "Pop35",
    "Model": "5065A"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "5065D",
    "Device": "Pop35",
    "Model": "5065D"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "5065N",
    "Device": "Pop35",
    "Model": "5065N"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "5065W",
    "Device": "Pop35",
    "Model": "5065W"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "5065X",
    "Device": "Pop35",
    "Model": "5065X"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "5070D",
    "Device": "P3-5_4G",
    "Model": "5070D"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "5080A",
    "Device": "shine_lite",
    "Model": "5080A"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "5080F",
    "Device": "shine_lite",
    "Model": "5080F"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "5080Q",
    "Device": "shine_lite",
    "Model": "5080Q"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "5080U",
    "Device": "shine_lite",
    "Model": "5080U"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "5080U",
    "Device": "shine_lite",
    "Model": "ALCATEL_5080U"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "5085G",
    "Device": "elsa6_amz",
    "Model": "5085G"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "5085O",
    "Device": "elsa6_amz",
    "Model": "5085O"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "5098O",
    "Device": "Pixi4-64GMEX",
    "Model": "5098O"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "5098O",
    "Device": "Pixi4-6_4G_CKT",
    "Model": "Alcatel_5098O"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "5098O",
    "Device": "Pixi4-6_4G_CKT",
    "Model": "alcatel_5098O"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "5098S",
    "Device": "Pixi4-6_4G",
    "Model": "5098S"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "5154A",
    "Device": "Pop355",
    "Model": "5154A"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "6010A",
    "Device": "Miata_3G",
    "Model": "6016A"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "6014X",
    "Device": "Miata_3G",
    "Model": "6014X"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "6016D",
    "Device": "Miata_3G",
    "Model": "6016D"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "6016E",
    "Device": "Miata_3G",
    "Model": "6016E"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "6016X",
    "Device": "Miata_3G",
    "Model": "6016X"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "6037B",
    "Device": "Eclipse",
    "Model": "6037B"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "6037K",
    "Device": "Eclipse",
    "Model": "6037K"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "6037Y",
    "Device": "Eclipse",
    "Model": "6037Y"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "6039A",
    "Device": "idol347",
    "Model": "6039A"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "6039H",
    "Device": "idol347",
    "Model": "6039H"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "6039J",
    "Device": "idol347",
    "Model": "6039J"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "6039K",
    "Device": "idol347",
    "Model": "6039K"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "6039S",
    "Device": "idol347",
    "Model": "6039S"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "6039Y",
    "Device": "idol347",
    "Model": "6039Y"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "6042D",
    "Device": "CROSSAPAC",
    "Model": "6042D"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "6043A",
    "Device": "DIABLOXPLUS",
    "Model": "6043A"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "6043D",
    "Device": "DIABLOXPLUS",
    "Model": "6043D"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "6044D",
    "Device": "I1-5_4G",
    "Model": "6044D"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "6055A",
    "Device": "idol4",
    "Model": "6055A"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "6055B",
    "Device": "idol4",
    "Model": "6055B"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "6055D",
    "Device": "idol4",
    "Model": "6055D"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "6055K",
    "Device": "idol4",
    "Model": "6055K"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "6055P",
    "Device": "idol4",
    "Model": "6055P"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "6060X",
    "Device": "simba6_global",
    "Model": "6060X"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "6062W",
    "Device": "A70AXLTMO",
    "Model": "6062W"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "7040N",
    "Device": "Yaris5TMO",
    "Model": "7040N"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "7040R",
    "Device": "Yaris5TMO",
    "Model": "7040R"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "7040T",
    "Device": "Yaris5TMO",
    "Model": "7040T"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "7045Y",
    "Device": "RIO5",
    "Model": "7045Y"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "730U",
    "Device": "Rio5C",
    "Model": "J730U"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "8030B",
    "Device": "HERO2",
    "Model": "8030B"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "8030B",
    "Device": "HERO2PLUS",
    "Model": "8030B"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "8030Y",
    "Device": "HERO2",
    "Model": "8030Y"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "8050D",
    "Device": "Pixi4-6_3G",
    "Model": "8050D"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "8050E",
    "Device": "Pixi4-6_3G",
    "Model": "8050E"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "8050E",
    "Device": "Pixi4-6_3G",
    "Model": "T600M"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "8050G",
    "Device": "Pixi4-6_3G",
    "Model": "8050G"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "8050X",
    "Device": "Pixi4-6_3G",
    "Model": "8050X"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": 8053,
    "Device": "Pixi3-7",
    "Model": 8053
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": 8054,
    "Device": "Pixi3-7",
    "Model": 8054
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": 8055,
    "Device": "Pixi3-7",
    "Model": 8055
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": 8056,
    "Device": "Pixi3-7",
    "Model": 8056
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": 8057,
    "Device": "Pixi3-7",
    "Model": 8057
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": 8057,
    "Device": "Pixi3-7",
    "Model": "KR076"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": 8062,
    "Device": "Pixi4-7_WIFI",
    "Model": 8062
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": 8063,
    "Device": "Pixi4-7_WIFI",
    "Model": 8063
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": 8070,
    "Device": "Pixi3-8_WIFI",
    "Model": 8070
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": 8079,
    "Device": "Pixi3-10_WiFi",
    "Model": 8079
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": 8080,
    "Device": "Pixi3-10_WiFi",
    "Model": 8080
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": 8262,
    "Device": "Pixi4-7_WIFI",
    "Model": 8262
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "9001D",
    "Device": "Pixi4-6_4G",
    "Model": "9001D"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "9001I",
    "Device": "Pixi4-6_4G",
    "Model": "9001I"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "9001X",
    "Device": "Pixi4-6_4G",
    "Model": "9001X"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "9002A",
    "Device": "Pixi3-7_3G",
    "Model": "9002A"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "9002A",
    "Device": "Pixi3-7_3G",
    "Model": "ALCATEL ONE TOUCH 9002A"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "9002W",
    "Device": "Pixi3-7_3G",
    "Model": "9002W"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "9002X",
    "Device": "Pixi3-7_3G",
    "Model": "9002X"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "9003A",
    "Device": "Pixi4-7_3G",
    "Model": "9003A"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "9003X",
    "Device": "Pixi4-7_3G",
    "Model": "9003X"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "9005X",
    "Device": "PIXO8_3G",
    "Model": "9005X"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "9006W",
    "Device": "Pixi2-7_4G_TMO",
    "Model": "9006W"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "9007X",
    "Device": "Pixi3-7_4G_EE",
    "Model": "9007X"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "9010X",
    "Device": "Pixi3-10_3G",
    "Model": "9010X"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "9015B",
    "Device": "Pixi4-7_4G_Bell",
    "Model": "9015B"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "9015B",
    "Device": "Pixi4-7_4G_Bell",
    "Model": "ALCATEL ONETOUCH POP 7 LTE"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "9015B",
    "Device": "Pixi4-7_4G_NA",
    "Model": "9015B"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "9015B",
    "Device": "Pixi4-7_4G_Rogers",
    "Model": "9015B"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "9015B",
    "Device": "Pixi4-7_4G_Telus",
    "Model": "9015B"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "9015J",
    "Device": "PIXI4-7_4G",
    "Model": "9015J"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "9015Q",
    "Device": "PIXI4-7_4G",
    "Model": "9015Q"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "9015U",
    "Device": "PIXI4-7_4G",
    "Model": "9015U"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "9015W",
    "Device": "Pixi4-7_4G_TMO",
    "Model": "9015W"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "9015W",
    "Device": "Pixi4-7_4G_TMO",
    "Model": "ALCATEL ONETOUCH POP 7 LTE"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "9021A",
    "Device": "Pop2-8_4G_Telus",
    "Model": "9021A"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "9024O",
    "Device": "PIXI5-8_4G_Telus",
    "Model": "9024O"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "9024W",
    "Device": "PIXI5-8_4G_TMO",
    "Model": "9024W"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "9025Q",
    "Device": "POP4-7_4G",
    "Model": "9025Q"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "9027G",
    "Device": "A3A_8_4G",
    "Model": "9027G"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "9027W",
    "Device": "A3A_8_4G_TMO",
    "Model": "9027W"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "9029W",
    "Device": "EasyTAB8TMO",
    "Model": "9029W"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "9030G",
    "Device": "POP4-10_4G",
    "Model": "9030G"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "9030Q",
    "Device": "POP4-10_4G",
    "Model": "9030Q"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "9203A",
    "Device": "Pixi5-7_3G",
    "Model": "9203A"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "A3",
    "Device": "mickey6",
    "Model": "5046A"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "A3",
    "Device": "mickey6",
    "Model": "5046D"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "A3",
    "Device": "mickey6",
    "Model": "5046I"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "A3",
    "Device": "mickey6",
    "Model": "5046J"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "A3",
    "Device": "mickey6",
    "Model": "5046T"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "A3",
    "Device": "mickey6",
    "Model": "5046U"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "A3",
    "Device": "mickey6",
    "Model": "5046Y"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "A3 10\\'\\'",
    "Device": "Pixi5-10_4G",
    "Model": "9026T"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "A3 10\\'\\'",
    "Device": "Pixi5-10_4G",
    "Model": "9026X"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "A3 PLUS",
    "Device": "mickey6t",
    "Model": "5049E"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "A3 PLUS",
    "Device": "mickey6t",
    "Model": "5049G"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "A3 XL",
    "Device": "PIXI5-6_4G",
    "Model": "9008A"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "A3 XL",
    "Device": "PIXI5-6_4G",
    "Model": "9008D"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "A3 XL",
    "Device": "PIXI5-6_4G",
    "Model": "9008I"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "A3 XL",
    "Device": "PIXI5-6_4G",
    "Model": "9008J"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "A3 XL",
    "Device": "PIXI5-6_4G",
    "Model": "9008N"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "A3 XL",
    "Device": "PIXI5-6_4G",
    "Model": "9008T"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "A3 XL",
    "Device": "PIXI5-6_4G",
    "Model": "9008U"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "A3 XL",
    "Device": "PIXI5-6_4G",
    "Model": "9008X"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "A3 XL",
    "Device": "PIXI5-6_4G",
    "Model": "9108A"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "A3 XL",
    "Device": "PIXI5-6_4G",
    "Model": "TCLGalaG60(9108A)"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "A30",
    "Device": "MICKEY6US",
    "Model": "5046G"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "A30",
    "Device": "Mickey6RW",
    "Model": "A576RW"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "A450TL",
    "Device": "ALTO45_TF",
    "Model": "A450TL"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "A460T",
    "Device": "PIXI3_4TF",
    "Model": "A460T"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "A464BG",
    "Device": "Pixi3-35TF",
    "Model": "A464BG"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "A466BG",
    "Device": "PIXI4_4TF",
    "Model": "A466BG"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "A5",
    "Device": "ELSA6",
    "Model": "5085A"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "A5",
    "Device": "ELSA6",
    "Model": "5085B"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "A5",
    "Device": "ELSA6",
    "Model": "5085D"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "A5",
    "Device": "ELSA6",
    "Model": "5085H"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "A5",
    "Device": "ELSA6",
    "Model": "5085I"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "A5",
    "Device": "ELSA6",
    "Model": "5085J"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "A5",
    "Device": "ELSA6",
    "Model": "5085N"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "A5",
    "Device": "ELSA6",
    "Model": "5085Q"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "A5",
    "Device": "ELSA6",
    "Model": "5085Y"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "A520L",
    "Device": "Alto4EVDO",
    "Model": "A520L"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "A521L",
    "Device": "Alto4NA",
    "Model": "A521L"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "A570BL",
    "Device": "Pop445",
    "Model": "A570BL"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "A571VL",
    "Device": "Pixi445TFVZW",
    "Model": "A571VL"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "A572BG",
    "Device": "Pop445",
    "Model": "A572BG"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "A573VC",
    "Device": "Pixi445EVDO",
    "Model": "A573VC"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "A577VL",
    "Device": "Mickey6TFEVDO",
    "Model": "A577VL"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "A621BL",
    "Device": "Pop355",
    "Model": "A621BL"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "A621R",
    "Device": "Pop355",
    "Model": "A621R"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "A622GL",
    "Device": "Pixi3554GEVDO",
    "Model": "A622GL"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "A622VL",
    "Device": "Pixi3554GEVDO",
    "Model": "A622VL"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "A7",
    "Device": "ELSA6P",
    "Model": "5090A"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "A7",
    "Device": "ELSA6P",
    "Model": "5090I"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "A7",
    "Device": "ELSA6P",
    "Model": "5090Y"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "A7 XL",
    "Device": "POP5-6_4G",
    "Model": "7071A"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "A7 XL",
    "Device": "POP5-6_4G",
    "Model": "7071D"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "A846L",
    "Device": "Alto5TF",
    "Model": "A846L"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "A851L",
    "Device": "Viper_gsm",
    "Model": "Alcatel 7030L"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "A851L",
    "Device": "Viper_gsm",
    "Model": "Alcatel A851L"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL 1T 10",
    "Device": "U3A_10_WIFI",
    "Model": 8082
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL 1T 10",
    "Device": "U3A_10_WIFI_P",
    "Model": 8084
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL 1T 10",
    "Device": "U3A_10_WIFI_P",
    "Model": "8084_EEA"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL 1T 7",
    "Device": "U3A_7_3G",
    "Model": "9009A"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL 1T 7 3G",
    "Device": "U3A_7_3G",
    "Model": "9009G"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL 3C",
    "Device": "A3A_XL_3G",
    "Model": "5026A"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL 3C",
    "Device": "A3A_XL_3G",
    "Model": "5026D"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL 3C",
    "Device": "A3A_XL_3G",
    "Model": "5026J"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL 3V",
    "Device": "A3A_XL_4G",
    "Model": "5099Y"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL 4015T",
    "Device": "Yaris35_GSM",
    "Model": "ALCATEL 4015T"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL A564C",
    "Device": "Yaris5NA",
    "Model": "ALCATEL A564C"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL A564R",
    "Device": "Yaris5NA",
    "Model": "ALCATEL A564R"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONE TOUCH 4005D",
    "Device": "Beetle_Lite_Edge_GSM",
    "Model": "ALCATEL ONE TOUCH 4005D"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONE TOUCH 4005D",
    "Device": "Beetle_Lite_Edge_GSM",
    "Model": "ALCATEL_ONE_TOUCH_4005D"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONE TOUCH 4010X",
    "Device": "Beetle_Lite_GSM",
    "Model": "ALCATEL ONE TOUCH 4010A"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONE TOUCH 4010X",
    "Device": "Beetle_Lite_GSM",
    "Model": "ALCATEL ONE TOUCH 4010D"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONE TOUCH 4010X",
    "Device": "Beetle_Lite_GSM",
    "Model": "ALCATEL ONE TOUCH 4010E"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONE TOUCH 4010X",
    "Device": "Beetle_Lite_GSM",
    "Model": "ALCATEL ONE TOUCH 4010X"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONE TOUCH 4010X",
    "Device": "Beetle_Lite_GSM",
    "Model": "TCL_J210"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONE TOUCH 4010X",
    "Device": "Beetle_Lite_GSM",
    "Model": "Telenor Smart 2"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONE TOUCH 4030X",
    "Device": "Beetle_GSM",
    "Model": "ALCATEL ONE TOUCH 4029A"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONE TOUCH 4030X",
    "Device": "Beetle_GSM",
    "Model": "ALCATEL ONE TOUCH 4030D"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONE TOUCH 4030X",
    "Device": "Beetle_GSM",
    "Model": "ALCATEL ONE TOUCH 4030E"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONE TOUCH 4030X",
    "Device": "Beetle_GSM",
    "Model": "ALCATEL ONE TOUCH 4030X"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONE TOUCH 4030X",
    "Device": "Beetle_GSM",
    "Model": "ALCATEL ONE TOUCH 4030Y"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONE TOUCH 4030X",
    "Device": "Beetle_GSM",
    "Model": "ALCATEL ONE TOUCH 4030Y_orange"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONE TOUCH 4030X",
    "Device": "Beetle_GSM",
    "Model": "Infinity POP"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONE TOUCH 4030X",
    "Device": "Beetle_GSM",
    "Model": "Orange Runo"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONE TOUCH 4037N",
    "Device": "SOUL4NA",
    "Model": "ALCATEL ONE TOUCH 4037N"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONE TOUCH 4037N",
    "Device": "SOUL4NA",
    "Model": "ALCATEL ONE TOUCH 4037T"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONE TOUCH 5020D",
    "Device": "Megane_GSM",
    "Model": "ALCATEL ONE TOUCH 5020A"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONE TOUCH 5020D",
    "Device": "Megane_GSM",
    "Model": "ALCATEL ONE TOUCH 5020D"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONE TOUCH 5020D",
    "Device": "Megane_GSM",
    "Model": "ALCATEL ONE TOUCH 5020E"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONE TOUCH 5020D",
    "Device": "Megane_GSM",
    "Model": "ALCATEL ONE TOUCH 5020T"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONE TOUCH 5020D",
    "Device": "Megane_GSM",
    "Model": "ALCATEL ONE TOUCH 5020W"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONE TOUCH 5020D",
    "Device": "Megane_GSM",
    "Model": "ALCATEL ONE TOUCH 5020X"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONE TOUCH 5020D",
    "Device": "Megane_GSM",
    "Model": "ALCATEL ONE TOUCH 5021E"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONE TOUCH 5020D",
    "Device": "Megane_GSM",
    "Model": "ALCATEL_ONE_TOUCH_5020D_Orange"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONE TOUCH 5020D",
    "Device": "Megane_GSM",
    "Model": "ALCATEL_ONE_TOUCH_5020X_Orange"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONE TOUCH 5020D",
    "Device": "Megane_GSM",
    "Model": "AURUS III"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONE TOUCH 5020D",
    "Device": "Megane_GSM",
    "Model": "MTC 972"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONE TOUCH 5020D",
    "Device": "Megane_GSM",
    "Model": "Orange Kivo"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONE TOUCH 5020D",
    "Device": "Megane_GSM",
    "Model": "Telenor Smart Pro 2"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONE TOUCH 5020N",
    "Device": "Megane",
    "Model": "ALCATEL ONE TOUCH 5020N"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONE TOUCH 5035D",
    "Device": "Camry_GSM",
    "Model": "ALCATEL ONE TOUCH 5035A"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONE TOUCH 5035D",
    "Device": "Camry_GSM",
    "Model": "ALCATEL ONE TOUCH 5035D"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONE TOUCH 5035D",
    "Device": "Camry_GSM",
    "Model": "ALCATEL ONE TOUCH 5035E"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONE TOUCH 5035D",
    "Device": "Camry_GSM",
    "Model": "ALCATEL ONE TOUCH 5035X"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONE TOUCH 5035D",
    "Device": "Camry_GSM",
    "Model": "TCL J610"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONE TOUCH 5035D",
    "Device": "Camry_GSM",
    "Model": "TCL S810"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONE TOUCH 5036A",
    "Device": "YarisL_GSM",
    "Model": "ALCATEL ONE TOUCH 5036A"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONE TOUCH 5036D",
    "Device": "YarisL_GSM",
    "Model": "ALCATEL ONE TOUCH 5036D"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONE TOUCH 5036D",
    "Device": "YarisL_GSM",
    "Model": "ONE TOUCH 5036X"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONE TOUCH 5036F",
    "Device": "YarisL_GSM",
    "Model": "ALCATEL ONE TOUCH 5036F"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONE TOUCH 5036X",
    "Device": "YarisL_GSM",
    "Model": "ALCATEL ONE TOUCH 5036X"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONE TOUCH 5037E",
    "Device": "YarisL_GSM",
    "Model": "ALCATEL ONE TOUCH 5037E"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONE TOUCH 601",
    "Device": "Telsa",
    "Model": "ALCATEL ONE TOUCH 6010"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONE TOUCH 6010A",
    "Device": "Telsa",
    "Model": "ALCATEL ONE TOUCH 6010A"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONE TOUCH 6010D",
    "Device": "Telsa",
    "Model": "ALCATEL ONE TOUCH 6010D"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONE TOUCH 6010X",
    "Device": "Telsa",
    "Model": "ALCATEL ONE TOUCH 6010"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONE TOUCH 6010X",
    "Device": "Telsa",
    "Model": "ALCATEL ONE TOUCH 6010D"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONE TOUCH 6010X",
    "Device": "Telsa",
    "Model": "ALCATEL ONE TOUCH 6010X"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONE TOUCH 6010X",
    "Device": "Telsa",
    "Model": "ALCATEL ONE TOUCH 6010X-orange"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONE TOUCH 6010X",
    "Device": "Telsa",
    "Model": "TCL S520"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONE TOUCH 6030A",
    "Device": "Diablo",
    "Model": "ALCATEL ONE TOUCH 6030A"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONE TOUCH 6030D",
    "Device": "Diablo",
    "Model": "ALCATEL ONE TOUCH 6030D"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONE TOUCH 6030N",
    "Device": "Diablo",
    "Model": "ALCATEL ONE TOUCH 6030N"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONE TOUCH 6030X",
    "Device": "Diablo",
    "Model": "ALCATEL ONE TOUCH 6030A"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONE TOUCH 6030X",
    "Device": "Diablo",
    "Model": "ALCATEL ONE TOUCH 6030D"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONE TOUCH 6030X",
    "Device": "Diablo",
    "Model": "ALCATEL ONE TOUCH 6030X"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONE TOUCH 6030X",
    "Device": "Diablo",
    "Model": "ALCATEL ONE TOUCH 6030X-orange"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONE TOUCH 6030X",
    "Device": "Diablo",
    "Model": "ALCATEL_ONE_TOUCH_6030X_Orange"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONE TOUCH 6030X",
    "Device": "Diablo",
    "Model": "Optimus_San_Remo"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONE TOUCH 6030X",
    "Device": "Diablo",
    "Model": "TCL S820"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONE TOUCH 6030X-orange",
    "Device": "Diablo",
    "Model": "ALCATEL ONE TOUCH 6030X-orange"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONE TOUCH 6032",
    "Device": "Alpha",
    "Model": "ALCATEL ONE TOUCH 6032"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONE TOUCH 6032A",
    "Device": "Alpha",
    "Model": "ALCATEL ONE TOUCH 6032A"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONE TOUCH 6032X",
    "Device": "Alpha",
    "Model": "ALCATEL ONE TOUCH 6032X"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONE TOUCH 6033A",
    "Device": "DiabloHD",
    "Model": "ALCATEL ONE TOUCH 6033A"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONE TOUCH 6033M",
    "Device": "DiabloHD",
    "Model": "ALCATEL ONE TOUCH 6033M"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONE TOUCH 6033X",
    "Device": "DiabloHD",
    "Model": "ALCATEL ONE TOUCH 6033M"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONE TOUCH 6033X",
    "Device": "DiabloHD",
    "Model": "ALCATEL ONE TOUCH 6033X"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONE TOUCH 6033X",
    "Device": "DiabloHD",
    "Model": "TCL S850"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONE TOUCH 6037B",
    "Device": "Eclipse",
    "Model": "ALCATEL ONE TOUCH 6037B"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONE TOUCH 6040A",
    "Device": "DIABLOX",
    "Model": "ALCATEL ONE TOUCH 6040A"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONE TOUCH 6040D",
    "Device": "DIABLOX",
    "Model": "ALCATEL ONE TOUCH 6040D"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONE TOUCH 6040D",
    "Device": "DIABLOX",
    "Model": "TCL S950"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONE TOUCH 6040E",
    "Device": "DIABLOX",
    "Model": "ALCATEL ONE TOUCH 6040E"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONE TOUCH 6040X",
    "Device": "DIABLOX",
    "Model": "ALCATEL ONE TOUCH 6040X"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONE TOUCH 7024W",
    "Device": "Rav4",
    "Model": "ALCATEL ONE TOUCH 7024R"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONE TOUCH 7024W",
    "Device": "Rav4",
    "Model": "ALCATEL ONE TOUCH 7024W"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONE TOUCH 7024W",
    "Device": "Rav4",
    "Model": "ALCATEL ONE TOUCH FIERCE"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONE TOUCH 7025D",
    "Device": "Rav4",
    "Model": "ALCATEL ONE TOUCH 7025D"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONE TOUCH 7040A",
    "Device": "YARISXL",
    "Model": "ALCATEL ONE TOUCH 7040A"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONE TOUCH 7040D",
    "Device": "YARISXL",
    "Model": "ALCATEL ONE TOUCH 7040D"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONE TOUCH 7040E",
    "Device": "YARISXL",
    "Model": "ALCATEL ONE TOUCH 7040E"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONE TOUCH 7040K",
    "Device": "YARISXL",
    "Model": "ALCATEL ONE TOUCH 7040K"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONE TOUCH 7040X",
    "Device": "YARISXL",
    "Model": "ALCATEL ONE TOUCH 7040X"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONE TOUCH 7041D",
    "Device": "YARISXL",
    "Model": "ALCATEL ONE TOUCH 7041D"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONE TOUCH 7041X",
    "Device": "YARISXL",
    "Model": "ALCATEL ONE TOUCH 7041X"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONE TOUCH 7042A",
    "Device": "YARISXL",
    "Model": "ALCATEL ONE TOUCH 7042A"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONE TOUCH 7042D",
    "Device": "YARISXL",
    "Model": "ALCATEL ONE TOUCH 7042D"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONE TOUCH 7042E",
    "Device": "YARISXL",
    "Model": "ALCATEL ONE TOUCH 7042E"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONE TOUCH 7047D",
    "Device": "YARIS_55",
    "Model": "ALCATEL ONE TOUCH 7047D"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONE TOUCH 7047E",
    "Device": "YARIS_55",
    "Model": "ALCATEL ONE TOUCH 7047E"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONE TOUCH 7047X",
    "Device": "YARIS_55",
    "Model": "ALCATEL ONE TOUCH 7047X"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONE TOUCH 8008D",
    "Device": "Scribe5HD",
    "Model": "ALCATEL ONE TOUCH 8008D"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONE TOUCH 8008D",
    "Device": "Scribe5HD",
    "Model": "ALCATEL ONE TOUCH 8008X"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONE TOUCH 8008D",
    "Device": "Scribe5HD",
    "Model": "Orange Infinity 8008X"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONE TOUCH 8020A",
    "Device": "SCRIBEPRO",
    "Model": "ALCATEL ONE TOUCH 8020A"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONE TOUCH 8020D",
    "Device": "SCRIBEPRO",
    "Model": "ALCATEL ONE TOUCH 8020D"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONE TOUCH 8020E",
    "Device": "SCRIBEPRO",
    "Model": "ALCATEL ONE TOUCH 8020E"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONE TOUCH 8020X",
    "Device": "SCRIBEPRO",
    "Model": "ALCATEL ONE TOUCH 8020X"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONE TOUCH 903",
    "Device": "one_touch_903A_gsm",
    "Model": "ALCATEL_ONE_TOUCH_903"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONE TOUCH 903",
    "Device": "one_touch_903A_gsm",
    "Model": "ALCATEL_one_touch_903"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONE TOUCH 903",
    "Device": "one_touch_903D_gsm",
    "Model": "ALCATEL ONE TOUCH 903D"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONE TOUCH 903",
    "Device": "one_touch_903_gsm",
    "Model": "ALCATEL ONE TOUCH 903"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONE TOUCH 903",
    "Device": "one_touch_903_gsm",
    "Model": "ALCATEL_ONE_TOUCH_903"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONE TOUCH 903A",
    "Device": "one_touch_903A_gsm",
    "Model": "ALCATEL ONE TOUCH 903A"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONE TOUCH 903D",
    "Device": "one_touch_903D_gsm",
    "Model": "ALCATEL ONE TOUCH 903D"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONE TOUCH 918",
    "Device": "one_touch_918_gsm",
    "Model": "ALCATEL ONE TOUCH 918"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONE TOUCH 918",
    "Device": "one_touch_918_gsm",
    "Model": "ALCATEL one touch 918"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONE TOUCH 918",
    "Device": "one_touch_918_gsm",
    "Model": "ALCATEL_one_touch_918"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONE TOUCH 918",
    "Device": "one_touch_918_gsm",
    "Model": "Alcatel_one_touch_918_Orange"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONE TOUCH 918A",
    "Device": "one_touch_918A_gsm",
    "Model": "ALCATEL ONE TOUCH 918A"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONE TOUCH 918A",
    "Device": "one_touch_918A_gsm",
    "Model": "ALCATEL_one_touch_918A"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONE TOUCH 918D",
    "Device": "ONE_TOUCH_918D_umts",
    "Model": "ALCATEL ONE TOUCH 918D"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONE TOUCH 918D",
    "Device": "one_touch_918D_gsm",
    "Model": "ALCATEL ONE TOUCH 918D"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONE TOUCH 918N",
    "Device": "ONE_TOUCH_918N_umts",
    "Model": "ALCATEL ONE TOUCH 918N"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONE TOUCH 918N",
    "Device": "one_touch_918N_gsm",
    "Model": "ALCATEL ONE TOUCH 918N"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONE TOUCH 918S",
    "Device": "one_touch_918S_gsm",
    "Model": "ALCATEL ONE TOUCH 918S"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONE TOUCH 922",
    "Device": "one_touch_922_gsm",
    "Model": "ALCATEL ONE TOUCH 922"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONE TOUCH 930D",
    "Device": "OT-930",
    "Model": "ALCATEL ONE TOUCH 930D"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONE TOUCH 930D",
    "Device": "OT-930",
    "Model": "ALCATEL ONE TOUCH 930N"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONE TOUCH 985",
    "Device": "one_touch_985_gsm",
    "Model": "ALCATEL ONE TOUCH 985"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONE TOUCH 985",
    "Device": "one_touch_985_gsm",
    "Model": "ALCATEL_ONE_TOUCH_985"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONE TOUCH 985",
    "Device": "one_touch_985_gsm",
    "Model": "ALCATEL_one_touch_985"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONE TOUCH 985",
    "Device": "one_touch_985_gsm",
    "Model": "Telenor_One_Touch_C"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONE TOUCH 985D",
    "Device": "one_touch_985D_gsm",
    "Model": "ALCATEL ONE TOUCH 985D"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONE TOUCH 985N",
    "Device": "one_touch_985N_gsm",
    "Model": "ALCATEL ONE TOUCH 985N"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONE TOUCH 991",
    "Device": "ONE_TOUCH_991D_gsm",
    "Model": "ALCATEL ONE TOUCH 991D"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONE TOUCH 991",
    "Device": "ONE_TOUCH_991_gsm",
    "Model": "ALCATEL ONE TOUCH 991"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONE TOUCH 991",
    "Device": "ONE_TOUCH_991_gsm",
    "Model": "ALCATEL_one_touch_991"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONE TOUCH 991",
    "Device": "ONE_TOUCH_991_gsm",
    "Model": "Telenor_Smart_Pro"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONE TOUCH 991",
    "Device": "one_touch_991_gsm",
    "Model": "ALCATEL ONE TOUCH 991"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONE TOUCH 991A",
    "Device": "ONE_TOUCH_991A_gsm",
    "Model": "ALCATEL ONE TOUCH 991A"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONE TOUCH 991D",
    "Device": "ONE_TOUCH_991D_gsm",
    "Model": "ALCATEL ONE TOUCH 991D"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONE TOUCH 991D",
    "Device": "one_touch_991D_gsm",
    "Model": "ALCATEL ONE TOUCH 991D"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONE TOUCH 991T",
    "Device": "one_touch_991T_gsm",
    "Model": "ALCATEL ONE TOUCH 991T"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONE TOUCH 992D",
    "Device": "Martell_lite_GSM",
    "Model": "ALCATEL ONE TOUCH 992"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONE TOUCH 992D",
    "Device": "Martell_lite_GSM",
    "Model": "ALCATEL ONE TOUCH 992D"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONE TOUCH 992D",
    "Device": "Martell_lite_GSM",
    "Model": "TCL S500"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONE TOUCH 992D",
    "Device": "Martell_lite_GSM",
    "Model": "TCL S600"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONE TOUCH 995",
    "Device": "one_touch_995_gsm",
    "Model": "ALCATEL_one_touch_995"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONE TOUCH 995",
    "Device": "one_touch_995_gsm",
    "Model": "Optimus_Madrid"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONE TOUCH 995",
    "Device": "one_touch_995_gsm",
    "Model": "Telenor_Smart_HD"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONE TOUCH 995A",
    "Device": "one_touch_995_gsm",
    "Model": "ALCATEL_one_touch_995A"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONE TOUCH 997D",
    "Device": "Martell_GSM",
    "Model": "ALCATEL ONE TOUCH 997"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONE TOUCH 997D",
    "Device": "Martell_GSM",
    "Model": "ALCATEL ONE TOUCH 997D"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONE TOUCH 997D",
    "Device": "Martell_GSM",
    "Model": "BASE_Lutea_3"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONE TOUCH 997D",
    "Device": "Martell_GSM",
    "Model": "TCL S710"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONE TOUCH 997D",
    "Device": "Martell_GSM",
    "Model": "TCL S800"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONE TOUCH D668",
    "Device": "DANIEL",
    "Model": "ALCATEL ONE TOUCH D668"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONE TOUCH D668",
    "Device": "DANIEL",
    "Model": "TCL D668"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONE TOUCH D668",
    "Device": "DANIEL",
    "Model": "TCL-D668"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONE TOUCH Fierce",
    "Device": "Rav4",
    "Model": "ALCATEL ONE TOUCH 7024N"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONE TOUCH Fierce",
    "Device": "Rav4",
    "Model": "ALCATEL ONE TOUCH 7024W"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONE TOUCH Fierce",
    "Device": "Rav4",
    "Model": "ALCATEL ONE TOUCH Fierce"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONE TOUCH P310A",
    "Device": "POP7",
    "Model": "ALCATEL ONE TOUCH P310A"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONE TOUCH P320A",
    "Device": "POP8",
    "Model": "ALCATEL ONE TOUCH P320A"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONE TOUCH P321",
    "Device": "POP8",
    "Model": "ALCATEL ONE TOUCH P321"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONE TOUCH918N",
    "Device": "one_touch_918_gsm",
    "Model": "ALCATEL ONE TOUCH 918N"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONETOUCH 4037R",
    "Device": "SOUL4NA",
    "Model": "ALCATEL ONE TOUCH 4037R"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONETOUCH 4037R",
    "Device": "SOUL4NA",
    "Model": "ALCATEL ONETOUCH 4037R"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONETOUCH 6032",
    "Device": "Alpha",
    "Model": "ALCATEL ONETOUCH 6032"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONETOUCH 6032A",
    "Device": "Alpha",
    "Model": "ALCATEL ONETOUCH 6032A"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONETOUCH 6032X",
    "Device": "Alpha",
    "Model": "ALCATEL ONETOUCH 6032X"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONETOUCH 6043D",
    "Device": "DIABLOXPLUS",
    "Model": "ALCATEL ONETOUCH 6043D"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONETOUCH Flash Plus",
    "Device": "CROSS2",
    "Model": "ALCATEL ONETOUCH Flash Plus"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONETOUCH IDOL 3 (5.5)",
    "Device": "idol3",
    "Model": "6045B"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONETOUCH IDOL 3 (5.5)",
    "Device": "idol3",
    "Model": "6045F"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONETOUCH IDOL 3 (5.5)",
    "Device": "idol3",
    "Model": "6045I"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONETOUCH IDOL 3 (5.5)",
    "Device": "idol3",
    "Model": "6045K"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONETOUCH IDOL 3 (5.5)",
    "Device": "idol3",
    "Model": "6045Y"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONETOUCH IDOL 3 (5.5)",
    "Device": "idol3",
    "Model": "TCL i806"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONETOUCH P310A",
    "Device": "POP7",
    "Model": "ALCATEL ONE TOUCH P310A"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONETOUCH P310A",
    "Device": "POP7",
    "Model": "ALCATEL ONETOUCH P310A"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONETOUCH PIXI 3 (3.5)",
    "Device": "",
    "Model": ""
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONETOUCH PIXI 3 (3.5)",
    "Device": "PIXI3_35",
    "Model": "4009A"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONETOUCH PIXI 3 (3.5)",
    "Device": "PIXI3_35",
    "Model": "4009D"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONETOUCH PIXI 3 (3.5)",
    "Device": "PIXI3_35",
    "Model": "4009E"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONETOUCH PIXI 3 (3.5)",
    "Device": "PIXI3_35",
    "Model": "4009F"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONETOUCH PIXI 3 (3.5)",
    "Device": "PIXI3_35",
    "Model": "4009K"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONETOUCH PIXI 3 (3.5)",
    "Device": "PIXI3_35",
    "Model": "4009M"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONETOUCH PIXI 3 (3.5)",
    "Device": "PIXI3_35",
    "Model": "4009S"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONETOUCH PIXI 3 (3.5)",
    "Device": "PIXI3_35",
    "Model": "4009X"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONETOUCH PIXI 3 (3.5)",
    "Device": "PIXI3_35",
    "Model": "SoshPhone_mini"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONETOUCH PIXI 3 (4.5)",
    "Device": "PIXI3_45_4G",
    "Model": "5017A"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONETOUCH PIXI 3 (4.5)",
    "Device": "PIXI3_45_4G",
    "Model": "5017D"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONETOUCH PIXI 3 (4.5)",
    "Device": "PIXI3_45_4G",
    "Model": "5017E"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONETOUCH PIXI 3 (4.5)",
    "Device": "PIXI3_45_4G",
    "Model": "5017X"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONETOUCH PIXI 3 (4.5)",
    "Device": "PIXI3_45_4G",
    "Model": "5019D"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONETOUCH PIXI 4 (4)",
    "Device": "Pixi4-4",
    "Model": "4034A"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONETOUCH PIXI 4 (4)",
    "Device": "Pixi4-4",
    "Model": "4034D"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONETOUCH PIXI 4 (4)",
    "Device": "Pixi4-4",
    "Model": "4034E"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONETOUCH PIXI 4 (4)",
    "Device": "Pixi4-4",
    "Model": "4034F"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONETOUCH PIXI 4 (4)",
    "Device": "Pixi4-4",
    "Model": "4034G"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONETOUCH PIXI 4 (4)",
    "Device": "Pixi4-4",
    "Model": "4034X"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONETOUCH PIXI 4 (4)",
    "Device": "Pixi4-4",
    "Model": "Alcatel_4034F"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONETOUCH PIXI 4 (4)",
    "Device": "Pixi4-4",
    "Model": "DIGICEL DL 1 lite"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONETOUCH PIXI 4 (4)",
    "Device": "Pixi4-4",
    "Model": "Orange Rise 34"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONETOUCH PIXI™ 3 (4.5)",
    "Device": "PIXI3_45_4G",
    "Model": "5017O"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONETOUCH POP 3 (5)",
    "Device": "PIXI3-5",
    "Model": "5015A"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONETOUCH POP 3 (5)",
    "Device": "PIXI3-5",
    "Model": "5015D"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONETOUCH POP 3 (5)",
    "Device": "PIXI3-5",
    "Model": "5015E"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONETOUCH POP 3 (5)",
    "Device": "PIXI3-5",
    "Model": "5015X"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONETOUCH POP 3 (5)",
    "Device": "PIXI3-5",
    "Model": "5016A"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONETOUCH POP 3 (5)",
    "Device": "PIXI3-5",
    "Model": "5016J"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONETOUCH POP 3 (5)",
    "Device": "PIXI3-5",
    "Model": "5116J"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONETOUCH POP 3 (5.5)",
    "Device": "PIXI3-55",
    "Model": "5025D"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONETOUCH POP 3 (5.5)",
    "Device": "PIXI3-55",
    "Model": "5025E"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONETOUCH POP 3 (5.5)",
    "Device": "PIXI3-55",
    "Model": "5025G"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONETOUCH POP 3 (5.5)",
    "Device": "PIXI3-55",
    "Model": "5025X"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONETOUCH POP 3 (5.5)",
    "Device": "PIXI3-55",
    "Model": "DIGICEL DL1000"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONETOUCH POP 3 (5.5)",
    "Device": "PIXI3-55",
    "Model": "S4035 3G"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONETOUCH POP D3",
    "Device": "SOUL4NA",
    "Model": "ALCATEL ONETOUCH POP D3"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL ONETOUCH Victory",
    "Device": "7046T",
    "Model": "Alcatel 7046T"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL PIXI 4 (5)",
    "Device": "PIXI4_5_4G",
    "Model": "5041D"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL PIXI 4 (5)",
    "Device": "PIXI4_5_4G",
    "Model": "5045A"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL PIXI 4 (5)",
    "Device": "PIXI4_5_4G",
    "Model": "5045D"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL PIXI 4 (5)",
    "Device": "PIXI4_5_4G",
    "Model": "5045F"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL PIXI 4 (5)",
    "Device": "PIXI4_5_4G",
    "Model": "5045G"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL PIXI 4 (5)",
    "Device": "PIXI4_5_4G",
    "Model": "5045I"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL PIXI 4 (5)",
    "Device": "PIXI4_5_4G",
    "Model": "5045J"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL PIXI 4 (5)",
    "Device": "PIXI4_5_4G",
    "Model": "5045T"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL PIXI 4 (5)",
    "Device": "PIXI4_5_4G",
    "Model": "5045X"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL PIXI 4 (5)",
    "Device": "PIXI4_5_4G",
    "Model": "5045Y"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL PIXI 4 (5)",
    "Device": "PIXI4_5_4G",
    "Model": "5145A"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL PIXI 4 (5)",
    "Device": "PIXI4_5_4G",
    "Model": "DIGICELDL1"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL one touch 986+",
    "Device": "OT986",
    "Model": "ALCATEL one touch 986+"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL one touch 990C+",
    "Device": "one_touch_990C_Plus_cdma",
    "Model": "ALCATEL one touch 990C+"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL one touch J320",
    "Device": "Iris",
    "Model": "ALCATEL one touch J320"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL_ 4034A",
    "Device": "Pixi4-4",
    "Model": "ALCATEL_4034A"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL_6055K",
    "Device": "idol4",
    "Model": "ALCATEL_6055K"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL_ONETOUCH_5022D",
    "Device": "PLAY-5",
    "Model": "ALCATEL_ONETOUCH_5022D"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL_ONETOUCH_7053D",
    "Device": "X1",
    "Model": "7053D"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL_ONETOUCH_7053D",
    "Device": "X1",
    "Model": "ALCATEL_ONETOUCH_7053D"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL_ONE_TOUCH_4027A",
    "Device": "Pixi3-45",
    "Model": "ALCATEL ONE TOUCH 4027A"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL_ONE_TOUCH_5037A",
    "Device": "YarisL_GSM",
    "Model": "ALCATEL ONE TOUCH 5037A"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL_ONE_TOUCH_5037X",
    "Device": "YarisL_GSM",
    "Model": "ALCATEL ONE TOUCH 5037X"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL_ONE_TOUCH_6010X_Orange",
    "Device": "ONE_TOUCH_6010X_gsm",
    "Model": "ALCATEL_ONE_TOUCH_6010X_Orange"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL_ONE_TOUCH_6030X_Orange",
    "Device": "ONE_TOUCH_6030X_gsm",
    "Model": "ALCATEL_ONE_TOUCH_6030X_Orange"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL_ONE_TOUCH_7047A",
    "Device": "YARIS_55",
    "Model": "ALCATEL ONE TOUCH 7047A"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL_ONE_TOUCH_903",
    "Device": "one_touch_903A_gsm",
    "Model": "ALCATEL_ONE_TOUCH_903"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL_ONE_TOUCH_903",
    "Device": "one_touch_903_gsm",
    "Model": "ALCATEL_ONE_TOUCH_903"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL_ONE_TOUCH_991_Orange",
    "Device": "one_touch_991_gsm",
    "Model": "ALCATEL_ONE_TOUCH_991_Orange"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL_ONE_TOUCH_P310X",
    "Device": "POP7",
    "Model": "ALCATEL ONE TOUCH P310X"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL_ONE_TOUCH_P320X",
    "Device": "POP8",
    "Model": "ALCATEL ONE TOUCH P320X"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL_one_touch_918D",
    "Device": "one_touch_918D_umts",
    "Model": "ALCATEL_one_touch_918D"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL_one_touch_991",
    "Device": "ONE_TOUCH_991A_gsm",
    "Model": "ALCATEL_one_touch_991"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL_one_touch_991",
    "Device": "one_touch_991_gsm",
    "Model": "ALCATEL_one_touch_991"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL_one_touch_995",
    "Device": "one_touch_995_gsm",
    "Model": "ALCATEL_one_touch_995"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL_one_touch_995",
    "Device": "one_touch_995_gsm",
    "Model": "RPSPE4301"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL_one_touch_995",
    "Device": "one_touch_995_gsm",
    "Model": "Telenor_One_Touch_S"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL_one_touch_995",
    "Device": "one_touch_995_gsm",
    "Model": "Telenor_Smart_HD"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL_one_touch_995A",
    "Device": "one_touch_995_gsm",
    "Model": "ALCATEL_one_touch_995A"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALCATEL_one_touch_995S",
    "Device": "one_touch_995_gsm",
    "Model": "ALCATEL_one_touch_995S"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ALOO 6032",
    "Device": "Alpha",
    "Model": "ALOO 6032"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "AM-H100",
    "Device": "EOS_lte",
    "Model": "AM-H100"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ATEL ONE TOUCH 995",
    "Device": "one_touch_995_gsm",
    "Model": "ALCATEL_one_touch_995"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 1",
    "Device": "Macau",
    "Model": "5033D"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 1",
    "Device": "Macau",
    "Model": "5033D_EEA"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 1",
    "Device": "Macau",
    "Model": "5033EP"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 1",
    "Device": "Macau",
    "Model": "5033F"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 1",
    "Device": "Macau",
    "Model": "5033FP"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 1",
    "Device": "Macau",
    "Model": "5033F_EEA"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 1",
    "Device": "Macau",
    "Model": "5033F_RU"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 1",
    "Device": "Macau",
    "Model": "5033M"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 1",
    "Device": "Macau",
    "Model": "5033MP"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 1",
    "Device": "Macau",
    "Model": "5033Q"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 1",
    "Device": "Macau",
    "Model": "5033Y"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 1",
    "Device": "Macau",
    "Model": "5033Y_EEA"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 1",
    "Device": "U3A_PLUS_4G",
    "Model": "5033A"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 1",
    "Device": "U3A_PLUS_4G",
    "Model": "5033D"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 1",
    "Device": "U3A_PLUS_4G",
    "Model": "5033D_EEA"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 1",
    "Device": "U3A_PLUS_4G",
    "Model": "5033D_RU"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 1",
    "Device": "U3A_PLUS_4G",
    "Model": "5033F"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 1",
    "Device": "U3A_PLUS_4G",
    "Model": "5033F_EEA"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 1",
    "Device": "U3A_PLUS_4G",
    "Model": "5033G"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 1",
    "Device": "U3A_PLUS_4G",
    "Model": "5033G_EEA"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 1",
    "Device": "U3A_PLUS_4G",
    "Model": "5033J"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 1",
    "Device": "U3A_PLUS_4G",
    "Model": "5033M"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 1",
    "Device": "U3A_PLUS_4G",
    "Model": "5033O"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 1",
    "Device": "U3A_PLUS_4G",
    "Model": "5033S"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 1",
    "Device": "U3A_PLUS_4G",
    "Model": "5033T"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 1",
    "Device": "U3A_PLUS_4G",
    "Model": "5033X"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 1",
    "Device": "U3A_PLUS_4G",
    "Model": "5033X_EEA"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 1",
    "Device": "U3A_PLUS_4G",
    "Model": "5033Y"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 1",
    "Device": "U3A_PLUS_4G",
    "Model": "5033Y_EEA"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 1",
    "Device": "U3A_PLUS_4G",
    "Model": "Alcatel T 5033T"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 1",
    "Device": "U3A_PLUS_4G",
    "Model": "HEYOU10"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 1",
    "Device": "U3A_PLUS_4G",
    "Model": "Optus X Start"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 1",
    "Device": "U3A_PLUS_4G",
    "Model": "Orange Rise 54_Alcatel_5033D"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 1 SE Lite",
    "Device": "Corolla",
    "Model": "5064A"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 1A",
    "Device": "Seoul",
    "Model": "5002F_RU"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 1B",
    "Device": "Kona",
    "Model": "5031A"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 1B",
    "Device": "Kona",
    "Model": "5031D"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 1B",
    "Device": "Kona",
    "Model": "5031G"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 1B",
    "Device": "Kona",
    "Model": "5031J"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 1B",
    "Device": "Kona",
    "Model": "5131E"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 1B",
    "Device": "Seoul",
    "Model": "5002A"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 1B",
    "Device": "Seoul",
    "Model": "5002B"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 1B",
    "Device": "Seoul",
    "Model": "5002D"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 1B",
    "Device": "Seoul",
    "Model": "5002D_EEA"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 1B",
    "Device": "Seoul",
    "Model": "5002D_RU"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 1B",
    "Device": "Seoul",
    "Model": "5002D_TR"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 1B",
    "Device": "Seoul",
    "Model": "5002E"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 1B",
    "Device": "Seoul",
    "Model": "5002F"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 1B",
    "Device": "Seoul",
    "Model": "5002F_EEA"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 1B",
    "Device": "Seoul",
    "Model": "5002H"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 1B",
    "Device": "Seoul",
    "Model": "5002H_EEA"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 1B",
    "Device": "Seoul",
    "Model": "5002H_RU"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 1B",
    "Device": "Seoul",
    "Model": "5002H_TR"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 1B",
    "Device": "Seoul",
    "Model": "5002I"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 1B",
    "Device": "Seoul",
    "Model": "5002J"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 1B",
    "Device": "Seoul",
    "Model": "5002L"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 1B",
    "Device": "Seoul",
    "Model": "5002M"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 1B",
    "Device": "Seoul",
    "Model": "5002Q"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 1B",
    "Device": "Seoul",
    "Model": "5002S"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 1B",
    "Device": "Seoul",
    "Model": "5002T"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 1B",
    "Device": "Seoul",
    "Model": "5002U"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 1B",
    "Device": "Seoul",
    "Model": "5002V"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 1B",
    "Device": "Seoul",
    "Model": "5002X"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 1B",
    "Device": "Seoul",
    "Model": "5002X_EEA"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 1C",
    "Device": "Curie",
    "Model": "5003A"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 1C",
    "Device": "Curie",
    "Model": "5003D"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 1C",
    "Device": "Curie",
    "Model": "5003D_EEA"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 1C",
    "Device": "Curie",
    "Model": "Listo SP50"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 1C",
    "Device": "U5A_PLUS_3G",
    "Model": "5009A"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 1C",
    "Device": "U5A_PLUS_3G",
    "Model": "5009D"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 1C",
    "Device": "U5A_PLUS_3G",
    "Model": "5009D_RU"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 1C",
    "Device": "U5A_PLUS_3G",
    "Model": "5009U"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 1E",
    "Device": "PIXI4-4C_GO",
    "Model": "4034T"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 1L",
    "Device": "Wright_Pro",
    "Model": "4063A"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 1L",
    "Device": "Wright_Pro",
    "Model": "4063A1"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 1L PLUS",
    "Device": "Wright_Pro",
    "Model": "4063F"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 1L Pro",
    "Device": "Jakarta_Mini",
    "Model": "4065D"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 1L Pro",
    "Device": "Jakarta_Mini",
    "Model": "4065D_EEA"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 1L Pro",
    "Device": "Jakarta_Mini",
    "Model": "4065D_RU"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 1L Pro",
    "Device": "Jakarta_Mini",
    "Model": "4065F"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 1S",
    "Device": "Faraday",
    "Model": "5024A"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 1S",
    "Device": "Faraday",
    "Model": "5024D"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 1S",
    "Device": "Faraday",
    "Model": "5024D_EEA"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 1S",
    "Device": "Faraday",
    "Model": "5024D_RU"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 1S",
    "Device": "Faraday",
    "Model": "5024F"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 1S",
    "Device": "Faraday",
    "Model": "5024F_EEA"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 1S",
    "Device": "Faraday",
    "Model": "5024I"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 1S",
    "Device": "Faraday",
    "Model": "5024J"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 1S",
    "Device": "HONG_KONG",
    "Model": "6025A"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 1S",
    "Device": "HONG_KONG",
    "Model": "6025D"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 1S",
    "Device": "HONG_KONG",
    "Model": "6025D_EEA"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 1S",
    "Device": "HONG_KONG",
    "Model": "6025D_RU"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 1S",
    "Device": "HONG_KONG",
    "Model": "6025H"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 1S",
    "Device": "HONG_KONG",
    "Model": "6025H_EEA"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 1S",
    "Device": "HONG_KONG",
    "Model": "6025H_RU"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 1S",
    "Device": "Tokyo",
    "Model": "5028A"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 1S",
    "Device": "Tokyo",
    "Model": "5028D"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 1S",
    "Device": "Tokyo",
    "Model": "5028D_EEA"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 1S",
    "Device": "Tokyo",
    "Model": "5028D_RU"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 1S",
    "Device": "Tokyo",
    "Model": "5028D_TR"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 1S",
    "Device": "Tokyo",
    "Model": "5028Y"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 1S",
    "Device": "Tokyo",
    "Model": "5028Y_EEA"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 1S",
    "Device": "Tokyo",
    "Model": "5028Y_RU"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 1S",
    "Device": "Tokyo_CAN",
    "Model": "5007O"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 1SE",
    "Device": "Jakarta",
    "Model": "5030A"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 1SE",
    "Device": "Jakarta",
    "Model": "5030D"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 1SE",
    "Device": "Jakarta",
    "Model": "5030D_EEA"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 1SE",
    "Device": "Jakarta",
    "Model": "5030D_RU"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 1SE",
    "Device": "Jakarta",
    "Model": "5030E"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 1SE",
    "Device": "Jakarta",
    "Model": "5030F"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 1SE",
    "Device": "Jakarta",
    "Model": "5030F_EEA"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 1SE",
    "Device": "Jakarta",
    "Model": "5030F_TR"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 1SE",
    "Device": "Jakarta",
    "Model": "5030G"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 1SE",
    "Device": "Jakarta",
    "Model": "5030I"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 1SE",
    "Device": "Jakarta",
    "Model": "5030J"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 1SE",
    "Device": "Jakarta",
    "Model": "5030M"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 1SE",
    "Device": "Jakarta",
    "Model": "5030U"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 1SE elite edition",
    "Device": "Jakarta_Lite",
    "Model": "4087M"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 1SE elite edition",
    "Device": "Jakarta_Lite",
    "Model": "4087N"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 1SE elite edition",
    "Device": "Jakarta_Lite",
    "Model": "4087U"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 1SE light",
    "Device": "Jakarta_Lite",
    "Model": "4087U_RU"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 1SE lite edition",
    "Device": "Jakarta_Lite",
    "Model": "4087U_EEA"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 1SP",
    "Device": "Jakarta",
    "Model": "5030E_RU"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 1T 7 3G NEW",
    "Device": "U3A_7_3G_Refresh",
    "Model": "9009F"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 1T 7 WIFI",
    "Device": "U3A_7_WIFI",
    "Model": 8068
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 1V",
    "Device": "Cruze_Lite",
    "Model": "6002A"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 1V",
    "Device": "Cruze_Lite",
    "Model": "6002D"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 1V",
    "Device": "Cruze_Lite",
    "Model": "6002J"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 1V",
    "Device": "Tokyo_Lite",
    "Model": "5007A"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 1V",
    "Device": "Tokyo_Lite",
    "Model": "5007G"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 1V",
    "Device": "Tokyo_Lite",
    "Model": "5007U"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 1V",
    "Device": "Tokyo_Lite",
    "Model": "5007U_EEA"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 1V",
    "Device": "Tokyo_Lite",
    "Model": "5007U_RU"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 1V",
    "Device": "Tokyo_Lite",
    "Model": "5007U_TR"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 1V",
    "Device": "Tokyo_Lite",
    "Model": "HEYOU40"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 1V",
    "Device": "Wright",
    "Model": "5001A"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 1V",
    "Device": "Wright",
    "Model": "5001D_EEA"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 1V",
    "Device": "Wright",
    "Model": "5001D_RU"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 1V",
    "Device": "Wright",
    "Model": "5001J"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 1V",
    "Device": "Wright",
    "Model": "5001T"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 1V",
    "Device": "Wright",
    "Model": "5001U"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 1X",
    "Device": "U5A_PLUS_4G",
    "Model": "5059A"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 1X",
    "Device": "U5A_PLUS_4G",
    "Model": "5059D"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 1X",
    "Device": "U5A_PLUS_4G",
    "Model": "5059D_RU"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 1X",
    "Device": "U5A_PLUS_4G",
    "Model": "5059I"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 1X",
    "Device": "U5A_PLUS_4G",
    "Model": "5059J"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 1X",
    "Device": "U5A_PLUS_4G",
    "Model": "5059T"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 1X",
    "Device": "U5A_PLUS_4G",
    "Model": "5059X"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 1X",
    "Device": "U5A_PLUS_4G",
    "Model": "5059Y"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 1X",
    "Device": "U5A_PLUS_4G",
    "Model": "HEYOU3"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 3",
    "Device": "A3A",
    "Model": "5052A"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 3",
    "Device": "A3A",
    "Model": "5052D"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 3",
    "Device": "A3A",
    "Model": "5052D_EEA"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 3",
    "Device": "A3A",
    "Model": "5052D_RU"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 3",
    "Device": "A3A",
    "Model": "5052Y"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 3",
    "Device": "A3A",
    "Model": "5052Y_EEA"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 3",
    "Device": "DahliaPro",
    "Model": "T451A"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 3",
    "Device": "Dive_73",
    "Model": "Orange Dive 73"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 3",
    "Device": "Gauss",
    "Model": "5053A"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 3",
    "Device": "Gauss",
    "Model": "5053D"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 3",
    "Device": "Gauss",
    "Model": "5053D_EEA"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 3",
    "Device": "Gauss",
    "Model": "5053K"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 3",
    "Device": "Gauss",
    "Model": "5053K_EEA"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 3",
    "Device": "Gauss",
    "Model": "5053K_RU"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 3",
    "Device": "Gauss",
    "Model": "5053Y"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 3",
    "Device": "Gauss",
    "Model": "5053Y_EEA"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 3",
    "Device": "Gauss",
    "Model": "5053Y_RU"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 3",
    "Device": "TokyoPro",
    "Model": "5029E"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 3C",
    "Device": 5006,
    "Model": "5006A"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 3C",
    "Device": 5006,
    "Model": "5006G"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 3H Plus",
    "Device": "Cruze",
    "Model": "6027A"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 3L",
    "Device": "A3A_LITE",
    "Model": "5034D"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 3L",
    "Device": "A3A_LITE",
    "Model": "5034D_EEA"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 3L",
    "Device": "A3A_LITE",
    "Model": "5034D_RU"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 3L",
    "Device": "A3A_LITE",
    "Model": "HEYOU5"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 3L",
    "Device": "Benz",
    "Model": "5039D"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 3L",
    "Device": "Benz",
    "Model": "5039D_EEA"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 3L",
    "Device": "Benz",
    "Model": "5039D_RU"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 3L",
    "Device": "Benz",
    "Model": "5039U"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 3L",
    "Device": "Benz",
    "Model": "5039Y_RU"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 3L",
    "Device": "Benz",
    "Model": "HEYOU50"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 3L",
    "Device": "Dahlia",
    "Model": "T450A"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 3L",
    "Device": "Hong_Kong_Pro",
    "Model": "6056A"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 3L",
    "Device": "Hong_Kong_Pro",
    "Model": "6056D"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 3L",
    "Device": "Hong_Kong_Pro",
    "Model": "6056D_EEA"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 3L",
    "Device": "Hong_Kong_Pro",
    "Model": "6056D_RU"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 3L",
    "Device": "Hong_Kong_Pro",
    "Model": "6056D_TR"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 3L",
    "Device": "Hong_Kong_Pro",
    "Model": "6056H"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 3L",
    "Device": "Hong_Kong_Pro",
    "Model": "6056H_EEA"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 3L",
    "Device": "Hong_Kong_Pro",
    "Model": "6056H_RU"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 3L",
    "Device": "Hong_Kong_Pro",
    "Model": "6056H_TR"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 3L",
    "Device": "TokyoPro",
    "Model": "5029D"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 3L",
    "Device": "TokyoPro",
    "Model": "5029D_EEA"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 3L",
    "Device": "TokyoPro",
    "Model": "5029D_RU"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 3L",
    "Device": "TokyoPro",
    "Model": "5029D_TR"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 3L",
    "Device": "TokyoPro",
    "Model": "5029F"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 3L",
    "Device": "TokyoPro",
    "Model": "5029Y"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 3L",
    "Device": "TokyoPro",
    "Model": "5029Y_EEA"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 3L",
    "Device": "TokyoPro",
    "Model": "5029Y_RU"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 3L",
    "Device": "TokyoPro",
    "Model": "Alpha 20"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 3L",
    "Device": "TokyoPro",
    "Model": "HEYOU60"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 3L",
    "Device": "TokyoPro",
    "Model": "TECTOY"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 3T 10",
    "Device": "A3A_10_4G",
    "Model": "8088M"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 3T 8",
    "Device": "A3A_8_4G",
    "Model": "9027F"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 3T 8",
    "Device": "A3A_8_4G",
    "Model": "9027Q"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 3T 8",
    "Device": "A3A_8_4G",
    "Model": "9027T"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 3T 8",
    "Device": "A3A_8_4G",
    "Model": "9027X"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 3V",
    "Device": "A3A_XL_4G",
    "Model": "5099A"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 3V",
    "Device": "A3A_XL_4G",
    "Model": "5099D"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 3V",
    "Device": "A3A_XL_4G",
    "Model": "5099D_RU"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 3V",
    "Device": "A3A_XL_4G",
    "Model": "5099I"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 3V",
    "Device": "A3A_XL_4G",
    "Model": "5099U"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 3V",
    "Device": "Morgan_4G",
    "Model": "5032W"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 3X",
    "Device": "A3A_PLUS",
    "Model": "5058A"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 3X",
    "Device": "A3A_PLUS",
    "Model": "5058I"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 3X",
    "Device": "A3A_PLUS",
    "Model": "5058I_RU"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 3X",
    "Device": "A3A_PLUS",
    "Model": "5058J"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 3X",
    "Device": "A3A_PLUS",
    "Model": "5058T"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 3X",
    "Device": "A3A_PLUS",
    "Model": "5058Y"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 3X",
    "Device": "Milan",
    "Model": "5061A"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 3X",
    "Device": "Milan",
    "Model": "5061K"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 3X",
    "Device": "Milan",
    "Model": "5061K_EEA"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 3X",
    "Device": "Milan",
    "Model": "5061K_RU"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 3X",
    "Device": "Milan",
    "Model": "5061K_TR"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 3X",
    "Device": "Milan",
    "Model": "5061U"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 3X",
    "Device": "Milan",
    "Model": "5061U_EEA"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 3X",
    "Device": "Milan",
    "Model": "5061U_TR"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 3X",
    "Device": "Venice",
    "Model": "5048A"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 3X",
    "Device": "Venice",
    "Model": "5048I"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 3X",
    "Device": "Venice",
    "Model": "5048U"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 3X",
    "Device": "Venice",
    "Model": "5048U_EEA"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 3X",
    "Device": "Venice",
    "Model": "5048Y"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 3X",
    "Device": "Venice",
    "Model": "5048Y_EEA"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 3X",
    "Device": "Venice",
    "Model": "5048Y_RU"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 3X",
    "Device": "Venice",
    "Model": "5048Y_TR"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 3X Plus",
    "Device": "TokyoPro",
    "Model": "5029A"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 5",
    "Device": "A5A_INFINI",
    "Model": "5086A"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 5",
    "Device": "A5A_INFINI",
    "Model": "5086Y"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 5H Plus",
    "Device": "Cruze_Pro",
    "Model": "6065A"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 5V",
    "Device": "A5X",
    "Model": "5060A"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 5V",
    "Device": "A5X",
    "Model": "5060D_RU"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 5X",
    "Device": "A5X",
    "Model": "5060D"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 5X",
    "Device": "A5X",
    "Model": "5060D_EEA"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel 5X",
    "Device": "A5X",
    "Model": "5060J"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel A11",
    "Device": "Vanilla",
    "Model": "T452A"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel A11",
    "Device": "Vanilla",
    "Model": "T452B"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel A11",
    "Device": "Vanilla",
    "Model": "T452M"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel A11 SE",
    "Device": "Vanilla",
    "Model": "T452Q"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel A31 Prime",
    "Device": "DahliaMax",
    "Model": "T451A"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel A31 Pro",
    "Device": "DahliaMax",
    "Model": "T451A"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel A62",
    "Device": "A01",
    "Model": "A601N"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel A62",
    "Device": "A01",
    "Model": "A601Q"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel AXEL™",
    "Device": "Dubai_Plus_ATT",
    "Model": "Alcatel_5004R"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel JOY TAB",
    "Device": "EasyTAB8MPCS",
    "Model": "9029Z"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel JOY TAB KIDS",
    "Device": "EasyTAB8TMO",
    "Model": "9029G"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel LUMOS™",
    "Device": "Dubai_Plus_ATT",
    "Model": "Alcatel_5004C"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel ONYX™",
    "Device": "Edison_CKT",
    "Model": "5008R"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel ONYX™",
    "Device": "Edison_CKT",
    "Model": "Alcatel_5008R"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel Raven LTE",
    "Device": "BUZZ6T4GTFUMTS",
    "Model": "A574BL"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel U3",
    "Device": "PIXI4-4C_GO",
    "Model": "4034L"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel U3",
    "Device": "PIXI4-4C_GO",
    "Model": "4034L_EEA"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel V3 Classic",
    "Device": "Aster",
    "Model": "T519H"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel V3 Pro",
    "Device": "Aster_Pro",
    "Model": "T521D"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel V3 Ultra",
    "Device": "Goldfinch_NP_Pro",
    "Model": "T803D"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel one touch 985",
    "Device": "one_touch_985A_gsm",
    "Model": "ALCATEL_one_touch_985"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel9007T",
    "Device": "Pixi3_7_4G",
    "Model": "Alcatel9007T"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel_4060A",
    "Device": "Pop445",
    "Model": "Alcatel_4060A"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel_5044C",
    "Device": "BUZZ6T4GCRICKET",
    "Model": "Alcatel_5044C"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel_5045A",
    "Device": "PIXI4_5_4G",
    "Model": "Alcatel_5045A"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel_5054O",
    "Device": "Pop355",
    "Model": "Alcatel_5054O"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel_5056O",
    "Device": "Pop355",
    "Model": "Alcatel_5056O"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel_5085C",
    "Device": "elsa6_na",
    "Model": "Alcatel 5085C"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel_5098O",
    "Device": "Pixi4-64GMEX",
    "Model": "Alcatel_5098O"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel_6055U",
    "Device": "idol4",
    "Model": "Alcatel 6055U"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel_6055U",
    "Device": "idol4",
    "Model": "Alcatel_6055U"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel_6060C",
    "Device": "simba6_cricket",
    "Model": "Alcatel_6060C"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel_7049D",
    "Device": "Lion-5",
    "Model": "Alcatel_7049D"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel_9001X",
    "Device": "Pixi4-6_4G",
    "Model": "Alcatel_9001X"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel_9026S",
    "Device": "Pixi5-10_4G",
    "Model": "Alcatel 9026S"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Alcatel_one_touch_918_Orange",
    "Device": "one_touch_918_gsm",
    "Model": "Alcatel_one_touch_918_Orange"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Boost View 5.0",
    "Device": "YARISXL",
    "Model": "Boost View 5.0"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "CTCC: TCL Y660/CMCC: TCL V760",
    "Device": "A3A_PLUS",
    "Model": "TCL V760"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "CTCC: TCL Y660/CMCC: TCL V760",
    "Device": "A3A_PLUS",
    "Model": "TCL Y660"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "D819",
    "Device": "HERO8",
    "Model": "D819"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "D820",
    "Device": "HERO8",
    "Model": "D820"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "D820X",
    "Device": "HERO8",
    "Model": "D820X"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "DL900",
    "Device": "YARISXL",
    "Model": "DL900"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "DLGICELDL1 plus",
    "Device": "POP455C",
    "Model": "DIGICELDL1plus"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "E500",
    "Device": "X50D",
    "Model": "E500"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ELEMENT5",
    "Device": "BUZZ6T4GGOPHONE",
    "Model": "Alcatel_5044R"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "EVO7",
    "Device": "EVO7",
    "Model": "MTC 1065"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "EVO7",
    "Device": "EVO7",
    "Model": "onetouch EVO7"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "EVO7",
    "Device": "EVO7",
    "Model": "starTIM tab 7"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "FL03",
    "Device": "FLASH3",
    "Model": "FL03"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Flash Plus 2",
    "Device": "shine_plus",
    "Model": "FL02"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Flash2_7049D",
    "Device": "Lion-5",
    "Model": "Flash2_7049D"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "GL TCL",
    "Device": "Titan_Vis_5G",
    "Model": "9194T"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "GL TCL",
    "Device": "Titan_Vis_Wifi",
    "Model": "9494G"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Go PLAY",
    "Device": "alto5_sporty",
    "Model": "7048A"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Go PLAY",
    "Device": "alto5_sporty",
    "Model": "7048S"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Go PLAY",
    "Device": "alto5_sporty",
    "Model": "7048W"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Go PLAY",
    "Device": "alto5_sporty",
    "Model": "7048X"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Hero2C",
    "Device": "Hero2C",
    "Model": "7055A"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "I216A",
    "Device": "PIXI7",
    "Model": "I216A"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "I216X",
    "Device": "PIXI7",
    "Model": "I216X"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "I220",
    "Device": "PIXI8",
    "Model": "I220"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "I221",
    "Device": "PIXI8",
    "Model": "I221"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "IDOL 2 S",
    "Device": "EOS4G",
    "Model": "6050Y"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "IDOL 2 S",
    "Device": "EOS4G",
    "Model": "ALCATEL ONE TOUCH 6050Y"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "IDOL 2 S",
    "Device": "EOS4G",
    "Model": "Idol2S_Orange"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "IDOL 2 S",
    "Device": "EOS_lte",
    "Model": "6050A"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "IDOL 2 S",
    "Device": "EOS_lte",
    "Model": "6050F"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "IDOL 2 S",
    "Device": "EOS_lte",
    "Model": "6050W"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "IDOL 2 S",
    "Device": "EOS_lte",
    "Model": "6050Y"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "IDOL 2 S",
    "Device": "EOS_lte",
    "Model": "ALCATEL ONE TOUCH 6050Y"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "IDOL 2 S",
    "Device": "EOS_lte",
    "Model": "ALCATEL ONETOUCH 6050A"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "IDOL 2 S",
    "Device": "EOS_lte",
    "Model": "OWN S5030"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "IDOL 2 S",
    "Device": "EOS_lte",
    "Model": "TCL S830U"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "IDOL 2 S",
    "Device": "EOS_lte",
    "Model": "TCL S838M"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "IDOL 4S",
    "Device": "idol4s",
    "Model": "6070K"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "IDOL 4S",
    "Device": "idol4s",
    "Model": "6070O"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "IDOL 5",
    "Device": "SIMBA6L",
    "Model": "6058A"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "IDOL 5",
    "Device": "SIMBA6L",
    "Model": "6058D"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "IDOL 5",
    "Device": "SIMBA6L",
    "Model": "6058X"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "IDOL 5S",
    "Device": "IDOL5S",
    "Model": "6060S"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "INSIGHT™",
    "Device": "FERMI_ATT",
    "Model": "Alcatel_5005R"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Idol S",
    "Device": "DiabloHD_LTE",
    "Model": "ALCATEL ONE TOUCH 6035L"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Idol S",
    "Device": "DiabloHD_LTE",
    "Model": "BS472"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Idol S",
    "Device": "DiabloHD_LTE",
    "Model": "MTC 978"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Idol S",
    "Device": "Diablo_LTE",
    "Model": "ALCATEL ONE TOUCH 6034L"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Idol S",
    "Device": "Diablo_LTE",
    "Model": "ALCATEL ONE TOUCH 6034M"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Idol S",
    "Device": "Diablo_LTE",
    "Model": "ALCATEL ONE TOUCH 6034R"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Idol S",
    "Device": "Diablo_LTE",
    "Model": "ALCATEL ONE TOUCH 6034Y"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Idol S",
    "Device": "Diablo_LTE",
    "Model": "San Remo 4G"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Idol S",
    "Device": "Diablo_LTE",
    "Model": "TCL-S850L"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Idol X",
    "Device": "DiabloHD_LTE",
    "Model": "ALCATEL ONE TOUCH 6035R"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Idol2 MINI S",
    "Device": "MIATA_lte",
    "Model": "6036A"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Idol2 MINI S",
    "Device": "MIATA_lte",
    "Model": "6036X"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Idol2 MINI S",
    "Device": "MIATA_lte",
    "Model": "6036Y"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Juke-A554C",
    "Device": "A554C",
    "Model": "A554C"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "LCATEL ONETOUCH PIXI 3 (4.5)",
    "Device": "PIXI3_45_4G",
    "Model": "DIGICEL DL810"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Lively Smart",
    "Device": "Tokyo_GC",
    "Model": "5007S"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "M812C",
    "Device": "M812",
    "Model": "M812C"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "MTC 960",
    "Device": "MTC_960_gsm",
    "Model": "MTC 960"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "MTC 970",
    "Device": "Beetle_GSM",
    "Model": "MTC 970"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "MTC975",
    "Device": "Camry_GSM",
    "Model": "MTC975"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "MegaFon_SP-A10",
    "Device": "one_touch_995_gsm",
    "Model": "MegaFon_SP-A10"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Megafon Login",
    "Device": "OT-930",
    "Model": "MegaFon_SP-AI"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Mirage",
    "Device": "feijao",
    "Model": "5057M"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Moov2",
    "Device": "move_2_gsm",
    "Model": "move 2"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "NA",
    "Device": "Bremen_NA_OM",
    "Model": "T768O"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "NeXT by Maxis (B1)",
    "Device": "VFD500",
    "Model": "VFD 500"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "NeXT by Maxis (M1)",
    "Device": "VFD700",
    "Model": "Maxis VFD 700"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "NeXT by Maxis (M1)",
    "Device": "VFD700",
    "Model": "VFD 700"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "NeXT by Maxis (M1)",
    "Device": "VFD700",
    "Model": "VFD700"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Nitro",
    "Device": "idol3",
    "Model": "6045O"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "No",
    "Device": "Pixi445Cricket",
    "Model": "Alcatel_4060O"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ONE TOUCH 4007X",
    "Device": "Pixo_GSM",
    "Model": "ONE TOUCH 4007A"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ONE TOUCH 4007X",
    "Device": "Pixo_GSM",
    "Model": "ONE TOUCH 4007D"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ONE TOUCH 4007X",
    "Device": "Pixo_GSM",
    "Model": "ONE TOUCH 4007E"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ONE TOUCH 4007X",
    "Device": "Pixo_GSM",
    "Model": "ONE TOUCH 4007X"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ONE TOUCH 4011X",
    "Device": "BeetleliteJB",
    "Model": "ONE TOUCH 4011X"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ONE TOUCH 4015X",
    "Device": "Yaris35_GSM",
    "Model": "4016D"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ONE TOUCH 4015X",
    "Device": "Yaris35_GSM",
    "Model": "ONE TOUCH 4015A"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ONE TOUCH 4015X",
    "Device": "Yaris35_GSM",
    "Model": "ONE TOUCH 4015D"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ONE TOUCH 4015X",
    "Device": "Yaris35_GSM",
    "Model": "ONE TOUCH 4015N"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ONE TOUCH 4015X",
    "Device": "Yaris35_GSM",
    "Model": "ONE TOUCH 4015X"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ONE TOUCH 4015X",
    "Device": "Yaris35_GSM",
    "Model": "ONE TOUCH 4015X-orange"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ONE TOUCH 4015X",
    "Device": "Yaris35_GSM",
    "Model": "ONE TOUCH 4016A"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ONE TOUCH 4015X",
    "Device": "Yaris35_GSM",
    "Model": "Orange Yomi"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ONE TOUCH 4033X",
    "Device": "Yaris_M_GSM",
    "Model": "4032A"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ONE TOUCH 4033X",
    "Device": "Yaris_M_GSM",
    "Model": "4032D"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ONE TOUCH 4033X",
    "Device": "Yaris_M_GSM",
    "Model": "4032E"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ONE TOUCH 4033X",
    "Device": "Yaris_M_GSM",
    "Model": "4032X"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ONE TOUCH 4033X",
    "Device": "Yaris_M_GSM",
    "Model": "4033L"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ONE TOUCH 4033X",
    "Device": "Yaris_M_GSM",
    "Model": "MS3B"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ONE TOUCH 4033X",
    "Device": "Yaris_M_GSM",
    "Model": "ONE TOUCH 4032A"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ONE TOUCH 4033X",
    "Device": "Yaris_M_GSM",
    "Model": "ONE TOUCH 4033A"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ONE TOUCH 4033X",
    "Device": "Yaris_M_GSM",
    "Model": "ONE TOUCH 4033D"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ONE TOUCH 4033X",
    "Device": "Yaris_M_GSM",
    "Model": "ONE TOUCH 4033E"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ONE TOUCH 4033X",
    "Device": "Yaris_M_GSM",
    "Model": "ONE TOUCH 4033X"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ONE TOUCH 4033X",
    "Device": "Yaris_M_GSM",
    "Model": "OWN S3010"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ONE TOUCH 4033X",
    "Device": "Yaris_M_GSM",
    "Model": "OWN S3010D"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ONE TOUCH 4033X",
    "Device": "Yaris_M_GSM",
    "Model": "TCLJ330"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ONE TOUCH 6012A",
    "Device": "California_GSM",
    "Model": "ONE TOUCH 6012A"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ONE TOUCH 6012D",
    "Device": "California",
    "Model": "ALCATEL ONE TOUCH 6012D"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ONE TOUCH 6012D",
    "Device": "California",
    "Model": "ALCATEL ONE TOUCH 6012X"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ONE TOUCH 6012D",
    "Device": "California",
    "Model": "Mobile Sosh"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ONE TOUCH 6012D",
    "Device": "California",
    "Model": "ONE TOUCH 6012A"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ONE TOUCH 6012D",
    "Device": "California",
    "Model": "ONE TOUCH 6012D"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ONE TOUCH 6012D",
    "Device": "California",
    "Model": "ONE TOUCH 6012E"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ONE TOUCH 6012D",
    "Device": "California",
    "Model": "ONE TOUCH 6012X"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ONE TOUCH 6012D",
    "Device": "California",
    "Model": "ONE TOUCH IDOL MINI"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ONE TOUCH 6012D",
    "Device": "California",
    "Model": "Orange Covo"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ONE TOUCH 6012D",
    "Device": "California",
    "Model": "Orange Hiro"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ONE TOUCH 6012X",
    "Device": "California",
    "Model": "ONE TOUCH 6012X"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ONE TOUCH 8020D",
    "Device": "SCRIBEPRO",
    "Model": "ONE TOUCH 8020D"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ONE TOUCH 983",
    "Device": "ONE_TOUCH_983_gsm",
    "Model": "ALCATEL_one_touch_983"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ONE TOUCH 983",
    "Device": "ONE_TOUCH_983_gsm",
    "Model": "ONE TOUCH 983"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ONE TOUCH 983",
    "Device": "ONE_TOUCH_983_gsm",
    "Model": "VALENCIA"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ONE TOUCH 983",
    "Device": "one_touch_983_gsm",
    "Model": "ALCATEL_one_touch_983"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ONE TOUCH C505C",
    "Device": "ONE_TOUCH_C505C_cdma",
    "Model": "ONE TOUCH C505C"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ONE TOUCH EVO7HD",
    "Device": "E710",
    "Model": "MTC 1078"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ONE TOUCH EVO7HD",
    "Device": "E710",
    "Model": "ONE TOUCH E710"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ONE TOUCH EVO7HD",
    "Device": "E710",
    "Model": "ONE TOUCH EVO7HD"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ONE TOUCH EVO8HD",
    "Device": "E720",
    "Model": "ONE TOUCH EVO7HD"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ONE TOUCH EVO8HD",
    "Device": "E720",
    "Model": "ONE TOUCH EVO8HD"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ONE TOUCH SCRIBE 5",
    "Device": "Scribe5_gsm",
    "Model": "ALCATEL ONE TOUCH 8000A"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ONE TOUCH SCRIBE 5",
    "Device": "Scribe5_gsm",
    "Model": "ALCATEL ONE TOUCH 8000D"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ONE TOUCH SCRIBE 5",
    "Device": "Scribe5_gsm",
    "Model": "TCL Y710"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ONE TOUCH T10",
    "Device": "GR-TB7",
    "Model": "GR-TB7"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ONE TOUCH TAB 7",
    "Device": "T011",
    "Model": "ONE TOUCH TAB 7"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ONE TOUCH TAB 7",
    "Device": "T011",
    "Model": "TCL TAB 7"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ONE TOUCH TAB 7HD",
    "Device": "T016",
    "Model": "ONE TOUCH TAB 7HD"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ONE TOUCH TAB 8HD",
    "Device": "T021",
    "Model": "ONE TOUCH TAB 8HD"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ONE TOUCH Ultra 960c",
    "Device": "Alltel",
    "Model": "ONE_TOUCH_960C"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ONE TOUCH Ultra 960c",
    "Device": "ONE_TOUCH_960C",
    "Model": "ADR3010"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ONE TOUCH Ultra 960c",
    "Device": "ONE_TOUCH_960C",
    "Model": "ONE TOUCH 960C"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ONE TOUCH Ultra 960c",
    "Device": "RadioShack",
    "Model": "ADR3010"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ONE TOUCH Ultra 960c",
    "Device": "nTelos",
    "Model": "ONE_TOUCH_960C"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ONE TOUCH Ultra 960c",
    "Device": "vulcan",
    "Model": "ONE_TOUCH_960C"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ONETOUCH PIXI 3 (8)",
    "Device": "pixi384g",
    "Model": "9022S"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ONETOUCH PIXI 3 (8)",
    "Device": "pixi384g",
    "Model": "9022X"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ONETOUCH PIXI 3 (8)",
    "Device": "pixi384g",
    "Model": "Alcatel9022S"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ONETOUCH PIXI 3 (8)",
    "Device": "pixi384g",
    "Model": "Alcatel_9022S"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ONETOUCH PIXI3(7)",
    "Device": "pixi37",
    "Model": "9007A"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ONETOUCH PIXI3(7)",
    "Device": "pixi37",
    "Model": "9007X"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ONE_TOUCH_P310A",
    "Device": "POP7",
    "Model": "ONE TOUCH P310A"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "ONE_TOUCH_P310X",
    "Device": "POP7",
    "Model": "ALCATEL ONE TOUCH P310X"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "OT-990C",
    "Device": "OT-990C_cdma",
    "Model": "OT-990C"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "OWN S4010",
    "Device": "Telsa",
    "Model": "OWN S4010"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "OWN S5010",
    "Device": "DiabloHD",
    "Model": "OWN S5010"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "OWN_S4025",
    "Device": "YARIS_55",
    "Model": "OWN_S4025"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "One Touch 890D",
    "Device": "one_touch_890D_gsm",
    "Model": "ALCATEL one touch 890D"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "One Touch 906",
    "Device": "one_touch_906_gsm",
    "Model": "ALCATEL_one_touch_906Y"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "One Touch 908",
    "Device": "one_touch_908_gsm",
    "Model": "ALCATEL ONE TOUCH 908"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "One Touch 908",
    "Device": "one_touch_908_gsm",
    "Model": "ALCATEL_one_touch_908"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "One Touch 908",
    "Device": "one_touch_908_gsm",
    "Model": "Alcatel_one_touch_908F_Orange"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "One Touch 990",
    "Device": "one_touch_990_gsm",
    "Model": "ALCATEL ONE TOUCH 990"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "One Touch 990",
    "Device": "one_touch_990_gsm",
    "Model": "ALCATEL one touch 990"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "One Touch 990",
    "Device": "one_touch_990_gsm",
    "Model": "ALCATEL_one_touch_990"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "One Touch 990",
    "Device": "one_touch_990_gsm",
    "Model": "Alcatel one touch 908F Orange"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "One Touch 990",
    "Device": "one_touch_990_gsm",
    "Model": "Alcatel one touch 990 Orange"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "One Touch 990",
    "Device": "one_touch_990_gsm",
    "Model": "Los Angeles"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "One Touch 990",
    "Device": "one_touch_990_gsm",
    "Model": "TCL A990"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "One Touch 990",
    "Device": "one_touch_990_gsm",
    "Model": "TCL ONE TOUCH 990"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "One Touch 990",
    "Device": "one_touch_990_gsm",
    "Model": "Telenor_OneTouch"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "One Touch 990",
    "Device": "one_touch_990_gsm",
    "Model": "Vodafone 958"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "One Touch 990A",
    "Device": "one_touch_990A_gsm",
    "Model": "ALCATEL_one_touch_990A"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "One Touch 990S",
    "Device": "one_touch_990S_gsm",
    "Model": "ALCATEL_one_touch_990S"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "One Touch 990S",
    "Device": "one_touch_990S_gsm",
    "Model": "Alcatel one touch 990S"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "P330X",
    "Device": "Pop7_LTE",
    "Model": "P330X"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "P330X_orange",
    "Device": "Pop7_LTE",
    "Model": "P330X_orange"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "P350X",
    "Device": "POP8_LTE",
    "Model": "P350X"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "P360X",
    "Device": "POP10",
    "Model": "P360X"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "P688L",
    "Device": "Rio5C",
    "Model": "TCL-P688L"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "P688L",
    "Device": "Rio5C",
    "Model": "TOM007"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "PIXI 4 (5)",
    "Device": "Pixi4-5",
    "Model": "5010D"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "PIXI 4 (5)",
    "Device": "Pixi4-5",
    "Model": "5010E"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "PIXI 4 (5)",
    "Device": "Pixi4-5",
    "Model": "5010G"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "PIXI 4 (5)",
    "Device": "Pixi4-5",
    "Model": "5010S"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "PIXI 4 (5)",
    "Device": "Pixi4-5",
    "Model": "5010U"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "PIXI 4 (5)",
    "Device": "Pixi4-5",
    "Model": "5010X"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "PIXI 5 HD",
    "Device": "Mickey6CC",
    "Model": "A576CC"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "PIXI3(4)",
    "Device": "Pixi3-4",
    "Model": "4003A"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "PIXI3(4)",
    "Device": "Pixi3-4",
    "Model": "4003J"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "PIXI3(4)",
    "Device": "Pixi3-4",
    "Model": "4013D"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "PIXI3(4)",
    "Device": "Pixi3-4",
    "Model": "4013E"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "PIXI3(4)",
    "Device": "Pixi3-4",
    "Model": "4013J"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "PIXI3(4)",
    "Device": "Pixi3-4",
    "Model": "4013K"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "PIXI3(4)",
    "Device": "Pixi3-4",
    "Model": "4013X"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "PIXI3(4)",
    "Device": "Pixi3-4",
    "Model": "4014E"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "PIXI3(4)",
    "Device": "Pixi3-4",
    "Model": "ONE_TOUCH_PIXI3"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "PIXI3(4)",
    "Device": "Pixi3-4",
    "Model": "ONE_TOUCH_PIXI3D"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "PIXI3(4.5)",
    "Device": "Pixi3-45",
    "Model": "4027A"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "PIXI3(4.5)",
    "Device": "Pixi3-45",
    "Model": "4027D"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "PIXI3(4.5)",
    "Device": "Pixi3-45",
    "Model": "4027N"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "PIXI3(4.5)",
    "Device": "Pixi3-45",
    "Model": "4027X"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "PIXI3(4.5)",
    "Device": "Pixi3-45",
    "Model": "4028A"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "PIXI3(4.5)",
    "Device": "Pixi3-45",
    "Model": "4028E"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "PIXI3(4.5)",
    "Device": "Pixi3-45",
    "Model": "4028J"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "PIXI3(4.5)",
    "Device": "Pixi3-45",
    "Model": "4028S"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "PIXI4 (3.5)",
    "Device": "PIXI4-35",
    "Model": "4017A"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "PIXI4 (3.5)",
    "Device": "PIXI4-35",
    "Model": "4017D"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "PIXI4 (3.5)",
    "Device": "PIXI4-35",
    "Model": "4017F"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "PIXI4 (3.5)",
    "Device": "PIXI4-35",
    "Model": "4017S"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "PIXI4 (3.5)",
    "Device": "PIXI4-35",
    "Model": "4017X"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "PIXI™4",
    "Device": "Pixi445CAN",
    "Model": "4060S"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "PLAY_P1",
    "Device": "PLAY_P1",
    "Model": "4024D"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "PLAY_P1",
    "Device": "PLAY_P1",
    "Model": "4024E"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "POP 2",
    "Device": "Alto45",
    "Model": "5042A"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "POP 2",
    "Device": "Alto45",
    "Model": "5042D"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "POP 2",
    "Device": "Alto45",
    "Model": "5042X"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "POP 2 (5)",
    "Device": "alto5",
    "Model": "7043A"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "POP 2 (5)",
    "Device": "alto5",
    "Model": "7043K"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "POP 2 (5)",
    "Device": "alto5",
    "Model": "7043Y"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "POP 2 (5)",
    "Device": "alto5_premium",
    "Model": "7044A"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "POP 2 (5)",
    "Device": "alto5_premium",
    "Model": "7044X"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "POP 4 6\" 4G android",
    "Device": "POP4-6_4G",
    "Model": "7070I"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "POP 4 6\" 4G android",
    "Device": "POP4-6_4G",
    "Model": "7070Q"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "POP 4 6\" 4G android",
    "Device": "POP4-6_4G",
    "Model": "7070X"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "POP 4S",
    "Device": "shine_plus",
    "Model": "5095I"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "POP 4S",
    "Device": "shine_plus",
    "Model": "5095K"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "POP 4S",
    "Device": "shine_plus",
    "Model": "5095Y"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "POP S3",
    "Device": "RIO4G_TF",
    "Model": "ALCATEL A845L"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "POP S3",
    "Device": "RIO_4G",
    "Model": "5050A"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "POP S3",
    "Device": "RIO_4G",
    "Model": "5050S"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "POP S3",
    "Device": "RIO_4G",
    "Model": "5050X"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "POP S3",
    "Device": "RIO_4G",
    "Model": "5050Y"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "POP S3",
    "Device": "RIO_4G",
    "Model": "ALCATEL ONETOUCH 5050X"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "POP S3",
    "Device": "RIO_4G",
    "Model": "Siru"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "POP S9",
    "Device": "RIO6_lte",
    "Model": "7050Y"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "POP S9",
    "Device": "RIO6_lte",
    "Model": "ALCATEL A995L"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "POP S9",
    "Device": "RIO6_lte",
    "Model": "STARXTREM II"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "POP S9",
    "Device": "RIO6_lte",
    "Model": "Smartphone Android by SFR STARXTREM II"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "POP2 (4)",
    "Device": "alto4",
    "Model": "4045A"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "POP2 (4)",
    "Device": "alto4_8g",
    "Model": "4045A"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "POP2 (4)",
    "Device": "alto4_8g",
    "Model": "4045D"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "POP2 (4)",
    "Device": "alto4_8g",
    "Model": "4045L"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "POP2 (4)",
    "Device": "alto4_8g",
    "Model": "4045O"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "POP2 (4)",
    "Device": "alto4_8g",
    "Model": "4045X"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "POP2 (4.5)",
    "Device": "alto45_latam_b28",
    "Model": "5042G"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "POP2 (4.5)",
    "Device": "alto45_latam_b28",
    "Model": "5042W"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "PandA_m14",
    "Device": "YARIS_55",
    "Model": "PandA_m14"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Pixi3-3.5 TF",
    "Device": "Pixi3-35TF",
    "Model": "A463BG"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Pixi3-4 TF",
    "Device": "PIXI3_4TF",
    "Model": "A460G"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Pixi4-4 3G Telus",
    "Device": "PIXI4_4TF",
    "Model": "A466T"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Pixo 7",
    "Device": "PIXO7",
    "Model": "I211"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Pixo 7",
    "Device": "PIXO7",
    "Model": "I212"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Pixo 7",
    "Device": "PIXO7",
    "Model": "I213"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Pop4",
    "Device": "POP455C",
    "Model": "Pop4"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "S4035_4G",
    "Device": "Pop355",
    "Model": "S4035_4G"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "SHINE LITE",
    "Device": "shine_lite",
    "Model": "5080D"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "SHINE LITE",
    "Device": "shine_lite",
    "Model": "5080X"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "SMART 4G 5.5 Enterprise",
    "Device": "M812",
    "Model": "SMART 4G 5.5 Enterprise"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "SMART_ PLUS",
    "Device": "PIXI4_55_3G",
    "Model": "SMART_PLUS"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "SOL PRIME",
    "Device": "idol4s",
    "Model": "T-1000"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "SOL PRIME",
    "Device": "idol4s_skt",
    "Model": "T-1000"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "SOLO Aspire M",
    "Device": "PIXI3-5",
    "Model": "SOLO Aspire M"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "SOUL 4.5",
    "Device": "SOUL45_GSM",
    "Model": "5038X"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Smart P11",
    "Device": "Seoul",
    "Model": "Smart_P11"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Smart Tab 7",
    "Device": "Phoenix_7",
    "Model": "9317X"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Smart Tab 7",
    "Device": "Phoenix_7",
    "Model": "9317X1"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Smart Tab 7",
    "Device": "Phoenix_7_KD",
    "Model": "9317H"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Smartphone Android by SFR STARADDICT II",
    "Device": "one_touch_996_gsm",
    "Model": "Smartphone Android by SFR STARADDICT II"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Smartphone Android by SFR STARADDICT II",
    "Device": "one_touch_996_gsm",
    "Model": "Smartphone_Android_by_SFR_STARADDICT_II"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Sol",
    "Device": "idol3",
    "Model": "AM-H200"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Soul 3.5",
    "Device": "SOUL35",
    "Model": "4018A"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Soul 3.5",
    "Device": "SOUL35",
    "Model": "4018D"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Soul 3.5",
    "Device": "SOUL35",
    "Model": "4018E"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Soul 3.5",
    "Device": "SOUL35",
    "Model": "4018F"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Soul 3.5",
    "Device": "SOUL35",
    "Model": "4018M"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Soul 3.5",
    "Device": "SOUL35",
    "Model": "4018X"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Soul 3.5",
    "Device": "SOUL35",
    "Model": "T4018"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Soul 4",
    "Device": "SOUL4",
    "Model": "4035A"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Soul 4",
    "Device": "SOUL4",
    "Model": "4035D"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Soul 4",
    "Device": "SOUL4",
    "Model": "4035X"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Soul 4",
    "Device": "SOUL4",
    "Model": "4035X_Orange"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Soul 4",
    "Device": "SOUL4",
    "Model": "4035Y"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Soul 4",
    "Device": "SOUL4",
    "Model": "4036E"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Soul 4.5",
    "Device": "SOUL45_GSM",
    "Model": "5038A"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Soul 4.5",
    "Device": "SOUL45_GSM",
    "Model": "5038E"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Soul 4.5",
    "Device": "SOUL45_GSM",
    "Model": "D45"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "T10",
    "Device": "T10",
    "Model": "one touch T10"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "T2",
    "Device": "HANDYT2",
    "Model": "T700A"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "T2",
    "Device": "HANDYT2",
    "Model": "T700X"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "T70",
    "Device": "PIXO7",
    "Model": "T70"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "TAB 7 DUAL CORE",
    "Device": "T015",
    "Model": "TAB 7 DUAL CORE"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "TAB 7 DUAL CORE",
    "Device": "T017",
    "Model": "TAB 7 DUAL CORE"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "TBD",
    "Device": "Apollo_8_4G_TMO",
    "Model": "9032W"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "TBD",
    "Device": "Jetta_ATT",
    "Model": "4188C"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "TBD",
    "Device": "Seoul_ATT",
    "Model": "Alcatel_5002C"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "TBD",
    "Device": "Seoul_ATT",
    "Model": "Alcatel_5002R"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "TBD",
    "Device": "Seoul_TF",
    "Model": "A507DL"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "TBD",
    "Device": "Transformer2",
    "Model": "9199G"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "TCL 10 5G UW",
    "Device": "Seattle_VZW",
    "Model": "T790S"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "TCL 30 Z",
    "Device": "Jetta_ATT",
    "Model": "4188R"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "TCL 30 Z",
    "Device": "Jetta_TF",
    "Model": "T602DL"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "TCL 302U",
    "Device": "Festa5_CU",
    "Model": "TCL 302U"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "TCL 303",
    "Device": "Kona",
    "Model": "5131A"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "TCL 305",
    "Device": "Cruze_Lite",
    "Model": "6102D"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "TCL 305i",
    "Device": "Corolla",
    "Model": "5164A"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "TCL 30E",
    "Device": "Cruze",
    "Model": "6127A"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "TCL 30V 5G",
    "Device": "Irvine_VZW",
    "Model": "T781SPP"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "TCL 40 R 5G",
    "Device": "Levin",
    "Model": "T771A"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "TCL 40 R 5G",
    "Device": "Levin",
    "Model": "T771K"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "TCL 40 XE 5G",
    "Device": "Encore_TF",
    "Model": "T609DL"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "TCL 4X 5G",
    "Device": "Bremen_TF",
    "Model": "T601DL"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "TCL 520",
    "Device": "shine_lite",
    "Model": "TCL 520"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "TCL 562",
    "Device": "shine_plus",
    "Model": 562
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "TCL 580",
    "Device": "idol4_mini",
    "Model": "TCL 580"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "TCL 736L",
    "Device": "Rio5C",
    "Model": "TCL-J736L"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "TCL 738M",
    "Device": "Rio5C",
    "Model": "TCL J738M"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "TCL 750",
    "Device": "x1_plus",
    "Model": "TCL 750"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "TCL 950",
    "Device": "idol4s_cn",
    "Model": "TCL 950"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "TCL A2X",
    "Device": "Tokyo_TF",
    "Model": "A508DL"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "TCL A3",
    "Device": "Bangkok_TF",
    "Model": "A509DL"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "TCL A506",
    "Device": "TCL_A506",
    "Model": "TCL A506"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "TCL A865",
    "Device": "TCL_A865",
    "Model": "TCL A865"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "TCL A988",
    "Device": "one_touch_993D_gsm",
    "Model": "ALCATEL ONE TOUCH 993D"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "TCL A988",
    "Device": "one_touch_993_gsm",
    "Model": "ALCATEL ONE TOUCH 993"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "TCL A988",
    "Device": "one_touch_993_gsm",
    "Model": "MTC_968"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "TCL C995",
    "Device": "TCL_C995_cdma",
    "Model": "TCL C995"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "TCL D35",
    "Device": "SOUL35",
    "Model": "TCL D35"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "TCL D40 DUAL",
    "Device": "D40",
    "Model": "TCL D40 DUAL"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "TCL D55",
    "Device": "YARIS_55",
    "Model": "TCL D55"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "TCL D662",
    "Device": "TCL_D662_cdma",
    "Model": "TCL D662"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "TCL D706",
    "Device": "EG502",
    "Model": "TCL D706"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "TCL D768",
    "Device": "EG501",
    "Model": "TCL D768"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "TCL D920",
    "Device": "TCL_D920",
    "Model": "TCL D920"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "TCL D920",
    "Device": "TCL_D920",
    "Model": "TCL-D920"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "TCL DL750",
    "Device": "SOUL4",
    "Model": "DL750"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "TCL H900M",
    "Device": "HERO2",
    "Model": "TCL H900M"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "TCL ION",
    "Device": "Rapid_CKT",
    "Model": "T501C"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "TCL ION",
    "Device": "Rapid_USCC",
    "Model": "T501L"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "TCL J210C",
    "Device": "TCL_J210C_cdma",
    "Model": "TCL J210C"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "TCL J210C",
    "Device": "TCL_J210C_cdma",
    "Model": "TCL-J210C"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "TCL J300",
    "Device": "Megane",
    "Model": "ALCATEL ONE TOUCH 5020T"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "TCL J300",
    "Device": "Megane",
    "Model": "TCL J300"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "TCL J310",
    "Device": "MeganeB",
    "Model": "TCL J310"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "TCL J320",
    "Device": "Iris",
    "Model": "TCL J320"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "TCL J320C",
    "Device": "Daniel_lite",
    "Model": "TCL J320C"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "TCL J320T",
    "Device": "IrisTD",
    "Model": "TCL J320T"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "TCL J600T",
    "Device": "Iris2TD",
    "Model": "TCL J600T"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "TCL J620",
    "Device": "md501",
    "Model": "TCL J620"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "TCL J630",
    "Device": "Iris2PlusUMTS",
    "Model": "J630"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "TCL J630T",
    "Device": "Iris2PlusTD",
    "Model": "TCL J630T"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "TCL J720",
    "Device": "YARISXL",
    "Model": "TCL J720"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "TCL J726T",
    "Device": "YARISXL",
    "Model": "TCL J726T"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "TCL J900",
    "Device": "Camry2",
    "Model": "TCL J900"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "TCL J900T",
    "Device": "Camry2_TD",
    "Model": "TCL J900T"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "TCL J920",
    "Device": "YARIS_55",
    "Model": "TCL J920"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "TCL J926T",
    "Device": "YARIS_55",
    "Model": "TCL J926T"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "TCL J928",
    "Device": "Prius",
    "Model": "TCL J928"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "TCL J929L",
    "Device": "Diablo_LTE",
    "Model": "TCL-J929L"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "TCL J938M",
    "Device": "RIO55_LTE",
    "Model": "TCL J938M"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "TCL LX",
    "Device": "U50A_PLUS_TF",
    "Model": "A502DL"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "TCL M2M",
    "Device": "CROSS2",
    "Model": "TCL M2M"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "TCL M2U",
    "Device": "CROSS2",
    "Model": "TCL M2U"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "TCL NXTPAPER PRO 12 5G",
    "Device": "Titan_Vis_5G",
    "Model": "9194T"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "TCL P301C",
    "Device": "Cooper_40",
    "Model": "TCL P301C"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "TCL P301M",
    "Device": "TCL_P301M",
    "Model": "TCL P301M"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "TCL P302C",
    "Device": "Cooper40",
    "Model": "TCL P302C"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "TCL P316L",
    "Device": "Festa5_CT",
    "Model": "TCL P316L"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "TCL P331M",
    "Device": "TCL_P331M",
    "Model": "TCL P331M"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "TCL P332U",
    "Device": "TCL_P332U",
    "Model": "TCL P332U"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "TCL P360W",
    "Device": "Focus5_CU",
    "Model": "TCL P360W"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "TCL P500M",
    "Device": "Festa_L",
    "Model": "TCL P500M"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "TCL P502U",
    "Device": "Festa5_CU",
    "Model": "TCL P502U"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "TCL P520L",
    "Device": "Bora5_CT",
    "Model": "TCL P520L"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "TCL P606",
    "Device": "Rav4_GSM",
    "Model": "TCL P600"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "TCL P606",
    "Device": "Rav4_GSM",
    "Model": "TCL P606"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "TCL P606",
    "Device": "Rav4_GSM",
    "Model": "TCL P606T"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "TCL P618L",
    "Device": "HUMMER5_CT",
    "Model": "TCL P618L"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "TCL P631M",
    "Device": "Civic_X",
    "Model": "TCL P631M"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "TCL P689L",
    "Device": "POLO55",
    "Model": "TCL_P689L"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "TCL P728M",
    "Device": "CROSS_LTE",
    "Model": "TCL P728M"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "TCL S300T",
    "Device": "TCLS300T",
    "Model": "TCL S300T"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "TCL S500",
    "Device": "TCL_S500_GSM",
    "Model": "TCL S500"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "TCL S520",
    "Device": "TCL_S520_GSM",
    "Model": "TCL S520"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "TCL S530T",
    "Device": "California",
    "Model": "TCL S530T"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "TCL S600",
    "Device": "TCL_S600_GSM",
    "Model": "TCL S600"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "TCL S700",
    "Device": "TCLS700",
    "Model": "TCL S700"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "TCL S700T",
    "Device": "TCLS700T",
    "Model": "TCL S700T"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "TCL S720",
    "Device": "Cross55",
    "Model": "TCL S720"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "TCL S720T",
    "Device": "Cross55",
    "Model": "TCL S720T"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "TCL S725T",
    "Device": "Cross55_TD_Plus",
    "Model": "TCL_S725T"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "TCL S820",
    "Device": "Diablo",
    "Model": "TCL S820"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "TCL S850",
    "Device": "DiabloHD",
    "Model": "TCL S850"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "TCL S860",
    "Device": "Alpha",
    "Model": "TCL S860"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "TCL S900",
    "Device": "S900",
    "Model": "TCL S900"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "TCL S950",
    "Device": "DIABLOX",
    "Model": "TCL S950"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "TCL S950T",
    "Device": "DIABLOX",
    "Model": "TCL S950T"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "TCL S960",
    "Device": "DIABLOXPLUS",
    "Model": "TCL S960"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "TCL S960T",
    "Device": "DIABLOXPLUS",
    "Model": "TCL S960T"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "TCL SIGNA",
    "Device": "Dubai_VZW",
    "Model": "5004S"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "TCL Stylus 5G",
    "Device": "Challenger_TMO",
    "Model": "T779W"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "TCL T500L",
    "Device": "evoque_cn",
    "Model": "TCL T500L"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "TCL XL2",
    "Device": "EDISON_TF",
    "Model": "A503DL"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "TCL Y900",
    "Device": "Scribe5HD_GSM",
    "Model": "TCL Y900"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "TCL Y910",
    "Device": "SCRIBEPRO",
    "Model": "TCL Y910"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "TCL Y910T",
    "Device": "SCRIBEPRO",
    "Model": "TCL Y910T"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "TCL i708U",
    "Device": "EOS_MACAN",
    "Model": "TCL i708U"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "TCL i718M",
    "Device": "EOS2",
    "Model": "TCL i718M"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "TCL i718M",
    "Device": "EOS_Plus",
    "Model": "TCL i709M"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "TCL 随学堂 L10",
    "Device": "Odin2",
    "Model": "9080X"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "TCL 随学堂 S8 4G",
    "Device": "Da_Vinci_4G",
    "Model": "9288M"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "TCL-550",
    "Device": "shine_plus",
    "Model": "TCL-550"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "TCL-J320D",
    "Device": "Daniel_lite_2S",
    "Model": "TCL-J320D"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "TCL-J900C",
    "Device": "TCL_J900C",
    "Model": "TCL-J900C"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "TCL-P306C",
    "Device": "Ford50",
    "Model": "TCL-P306C"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "TCL201",
    "Device": "Macau",
    "Model": "5033TP"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "TCL_6110A",
    "Device": "Telsa",
    "Model": "TCL 6110A"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "TCL_6110A",
    "Device": "Telsa",
    "Model": "TCL_6110A"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "TCL_J636D",
    "Device": "msm7627a_a5y_j636d",
    "Model": "TCL_J636D"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "TCL_J706T",
    "Device": "Focus_L",
    "Model": "TCL_J706T"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "TCL_P561U",
    "Device": "Fit55_CU",
    "Model": "TCL_P561U"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "TCL_U980",
    "Device": "TCL_U980",
    "Model": "TCL_U980"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "TCL_Xess_P17AA",
    "Device": "Xess",
    "Model": "TCL Xess P17AA"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "TCL_Xess_P17AA_OS",
    "Device": "Xess",
    "Model": "TCL Xess P17AA"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "TETRA",
    "Device": "U50A_ATT",
    "Model": "5041C"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "TKEE MAX",
    "Device": "Aquaman_10_Kids_WIFI",
    "Model": 8095
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "TKEE MAX",
    "Device": "Aquaman_10_Kids_WIFI",
    "Model": "8095_EEA"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "TKEE MAX",
    "Device": "Aquaman_10_Kids_WIFI",
    "Model": "8095_RU"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "TKEE MAX",
    "Device": "Aquaman_10_Kids_WIFI",
    "Model": "8095_TR"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "TKEE MINI",
    "Device": "Hulk_7_KIDS_WIFI",
    "Model": 8052
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "TKEE MINI",
    "Device": "Hulk_7_KIDS_WIFI",
    "Model": "8052_EEA"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "TKEE MINI",
    "Device": "Hulk_7_KIDS_WIFI",
    "Model": "8052_RU"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "TKEE MINI NEW",
    "Device": "U3A_7_WIFI_Refresh",
    "Model": "9309X"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "TKEE MINI NEW",
    "Device": "U3A_7_WIFI_Refresh",
    "Model": "9309X_EEA"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "TKEE MINI NEW",
    "Device": "U3A_7_WIFI_Refresh",
    "Model": "9309X_RU"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "TKEE MINI NEW",
    "Device": "U3A_7_WIFI_Refresh",
    "Model": "9309X_TR"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "TKEE mini",
    "Device": "Phoenix_7_Kids",
    "Model": "9317G"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "TKEE mini",
    "Device": "Phoenix_7_Kids",
    "Model": "9317G1"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Telenor_Smart",
    "Device": "one_touch_985_gsm",
    "Model": "Telenor_Smart"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Telenor_Smart_Mini",
    "Device": "SOUL4",
    "Model": "Telenor Smart Mini"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Telstra Enhanced Tab 2",
    "Device": "Aquaman_10_4G",
    "Model": "8094X"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "U3",
    "Device": "U3_3G",
    "Model": "4049D"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "U3",
    "Device": "U3_3G",
    "Model": "4049E"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "U3",
    "Device": "U3_3G",
    "Model": "4049G"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "U3",
    "Device": "U3_3G",
    "Model": "4049M"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "U3",
    "Device": "U3_3G",
    "Model": "4049X"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "U5",
    "Device": "BUZZ6T4G",
    "Model": "5044A"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "U5",
    "Device": "BUZZ6T4G",
    "Model": "5044P"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "U5",
    "Device": "BUZZ6T4G",
    "Model": "5044Y"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "U5 3G",
    "Device": "U5_3G",
    "Model": "4047A"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "U5 3G",
    "Device": "U5_3G",
    "Model": "4047F"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "U5 HD",
    "Device": "BUZZ6E",
    "Model": "5047D"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "U5 HD",
    "Device": "BUZZ6E",
    "Model": "5047I"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "U5 HD",
    "Device": "BUZZ6E",
    "Model": "5047U"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "U5 HD",
    "Device": "BUZZ6E",
    "Model": "5047Y"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "U50™",
    "Device": "BUZZ6T4GTELUS",
    "Model": "5044G"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "U50™",
    "Device": "BUZZ6T4GTELUS",
    "Model": "5044S"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "VF 860",
    "Device": "Vodafone_Smart_II_gsm",
    "Model": "Vodafone Smart II"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Vodafone 785",
    "Device": "Vodafone_785",
    "Model": "MTC 982"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Vodafone 861",
    "Device": "one_touch_922_gsm",
    "Model": "ALCATEL ONE TOUCH 922"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Vodafone 861",
    "Device": "one_touch_922_gsm",
    "Model": "Vodafone 861"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Vodafone 985N",
    "Device": "Vodafone985N",
    "Model": "Vodafone 985N"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Vodafone Smart III",
    "Device": "Vodafone_975",
    "Model": "Vodafone 975"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Vodafone Smart III (with NFC)",
    "Device": "Vodafone_975N",
    "Model": "Vodafone 975N"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "X35E",
    "Device": "X35E",
    "Model": "X35E"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "X50D",
    "Device": "X50D",
    "Model": "X50D"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Xess mini",
    "Device": "Xess-mini",
    "Model": "TCL Xess miniC15BA"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "Xess-mini",
    "Device": "Xess-mini",
    "Model": "TCL Xess C15BA"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "alcatel 1T7 4G",
    "Device": "King_Kong_7_4G",
    "Model": "9013A"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "alcatel 1T7 4G",
    "Device": "King_Kong_7_4G",
    "Model": "9013T"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "alcatel 1T7 4G",
    "Device": "King_Kong_7_4G",
    "Model": "9013X"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "alcatel 1T7 4G",
    "Device": "King_Kong_7_4G",
    "Model": "9013X_EEA"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "alcatel 1T7 4G",
    "Device": "King_Kong_7_4G",
    "Model": "9013X_RU"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "alcatel 1T7 4G",
    "Device": "King_Kong_7_4G",
    "Model": "9013X_TR"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "alcatel 1T7 NEW",
    "Device": "U3A_7_WIFI_Refresh",
    "Model": "9309X"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "alcatel 1T7 NEW",
    "Device": "U3A_7_WIFI_Refresh",
    "Model": "9309X2"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "alcatel 1T7 NEW",
    "Device": "U3A_7_WIFI_Refresh",
    "Model": "9309X_RU"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "alcatel 1X",
    "Device": "Edison",
    "Model": "5008A"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "alcatel 1X",
    "Device": "Edison",
    "Model": "5008D"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "alcatel 1X",
    "Device": "Edison",
    "Model": "5008D_EEA"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "alcatel 1X",
    "Device": "Edison",
    "Model": "5008T"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "alcatel 1X",
    "Device": "Edison",
    "Model": "5008U"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "alcatel 1X",
    "Device": "Edison",
    "Model": "5008Y"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "alcatel 1X",
    "Device": "Edison",
    "Model": "5008Y_EEA"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "alcatel 1X",
    "Device": "Edison",
    "Model": "5008Y_RU"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "alcatel 3T8",
    "Device": "Apollo_8_4G",
    "Model": "9032T"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "alcatel 3T8",
    "Device": "Apollo_8_4G",
    "Model": "9032X"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "alcatel 3T8",
    "Device": "Apollo_8_4G",
    "Model": "9032X_EEA"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "alcatel 3T8",
    "Device": "Apollo_8_4G",
    "Model": "9032X_RU"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "alcatel 3T8",
    "Device": "Apollo_8_4G",
    "Model": "9032X_TR"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "alcatel 3T8 WIFI",
    "Device": "Apollo_8_4G",
    "Model": 9032
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "alcatel PIXI 4 (5.5)",
    "Device": "PIXI4_55_3G",
    "Model": "5012D"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "alcatel PIXI 4 (5.5)",
    "Device": "PIXI4_55_3G",
    "Model": "5012F"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "alcatel PIXI 4 (5.5)",
    "Device": "PIXI4_55_3G",
    "Model": "5012G"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "alcatel U5",
    "Device": "BUZZ6T4G",
    "Model": "5044D"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "alcatel U5",
    "Device": "BUZZ6T4G",
    "Model": "5044I"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "alcatel U5",
    "Device": "BUZZ6T4G",
    "Model": "5044K"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "alcatel U5",
    "Device": "BUZZ6T4G",
    "Model": "5044O"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "alcatel U5",
    "Device": "BUZZ6T4G",
    "Model": "5044T"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "freebit PandA_m14",
    "Device": "YARIS_55",
    "Model": "freebit PandA_m14"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "one touch 995C+",
    "Device": "one_touch_995C_cdma",
    "Model": "one touch 995C+"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "one touch D920",
    "Device": "one_touch_D920",
    "Model": "ALCATEL one touch D920"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "one touch D920",
    "Device": "one_touch_D920",
    "Model": "one touch D920"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "one_touch_4030_TLVE",
    "Device": "Beetle_GSM",
    "Model": "ALCATEL_one_touch_4030A"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "one_touch_D920_ALIQ",
    "Device": "one_touch_D920",
    "Model": "one touch D920"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "onetouch_P689L",
    "Device": "POLO55",
    "Model": "onetouch_P689L"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "smart tab 7",
    "Device": "Hulk_7_GL_WIFI",
    "Model": 8051
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "smart tab 7",
    "Device": "Hulk_7_GL_WIFI",
    "Model": "8051_EEA"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "smart tab 7",
    "Device": "Hulk_7_GL_WIFI",
    "Model": "8051_RU"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "smart tab 7",
    "Device": "Hulk_7_GL_WIFI",
    "Model": "8051_TR"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "tbd",
    "Device": "Apollo_8_4G_TMO",
    "Model": "9032Z"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "tbd",
    "Device": "Cruze_Lite_TF",
    "Model": "T603DL"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "tbd",
    "Device": "FERMI_TF",
    "Model": "A501DL"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "tbd",
    "Device": "Mickey6TFUMTS",
    "Model": "A576BL"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "tbd",
    "Device": "U50A_PLUS_ATT",
    "Model": "Alcatel_5059R"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "tmn smarta8",
    "Device": "ONE_TOUCH_991D_gsm",
    "Model": "moche smart a8"
  },
  {
    "Retail Branding": "TCT (Alcatel)",
    "Marketing Name": "tmn smarta8",
    "Device": "ONE_TOUCH_991D_gsm",
    "Model": "tmn smart a8"
  },
  {
    "Retail Branding": "TD SYSTEMS",
    "Marketing Name": "Android TV",
    "Device": "martin",
    "Model": "TD SYSTEMS Android TV"
  },
  {
    "Retail Branding": "TD SYSTEMS",
    "Marketing Name": "Android TV",
    "Device": "redwood",
    "Model": "TD SYSTEMS Android TV"
  },
  {
    "Retail Branding": "TD SYSTEMS",
    "Marketing Name": "Android TV",
    "Device": "tamachi",
    "Model": "TD SYSTEMS Android TV"
  },
  {
    "Retail Branding": "TD SYSTEMS",
    "Marketing Name": "Android TV",
    "Device": "yeongdeungpo",
    "Model": "TD SYSTEMS Android TV"
  },
  {
    "Retail Branding": "TD SYSTEMS",
    "Marketing Name": "EUROPE",
    "Device": "guandu",
    "Model": "TD SYSTEMS Android TV"
  },
  {
    "Retail Branding": "TD SYSTEMS",
    "Marketing Name": "Smart TV",
    "Device": "alimos",
    "Model": "TD SYSTEMS Android TV"
  },
  {
    "Retail Branding": "TD SYSTEMS",
    "Marketing Name": "Smart TV",
    "Device": "dangni",
    "Model": "TD SYSTEMS Android TV"
  },
  {
    "Retail Branding": "TD SYSTEMS",
    "Marketing Name": "Smart TV",
    "Device": "osaka",
    "Model": "TD SYSTEMS Android TV"
  },
  {
    "Retail Branding": "TD Tech",
    "Marketing Name": "TD Tech V800",
    "Device": "V800",
    "Model": "V800"
  },
  {
    "Retail Branding": "TD Tech",
    "Marketing Name": "TD Tech V900",
    "Device": "V900",
    "Model": "V900"
  },
  {
    "Retail Branding": "TDS",
    "Marketing Name": "VIP6102W",
    "Device": "vip6102w",
    "Model": "VIP6102W"
  },
  {
    "Retail Branding": "TEAMGEE",
    "Marketing Name": "Touch-Screen-Monitor",
    "Device": "G2",
    "Model": "G2"
  },
  {
    "Retail Branding": "TECHLIFE",
    "Marketing Name": "Smart TV",
    "Device": "alimos",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "TECHLIFE",
    "Marketing Name": "Smart TV",
    "Device": "osaka",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "TECHLIFE",
    "Marketing Name": "Smart TV",
    "Device": "redwood",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "TECHLIFE",
    "Marketing Name": "TLPAD001",
    "Device": "TLPAD001",
    "Model": "TLPAD001"
  },
  {
    "Retail Branding": "TECHLIFE",
    "Marketing Name": "TLPAD002",
    "Device": "TLPAD002",
    "Model": "TLPAD002"
  },
  {
    "Retail Branding": "TECHLIFE",
    "Marketing Name": "TLPADL03",
    "Device": "TLPADL03",
    "Model": "TLPADL03"
  },
  {
    "Retail Branding": "TECHLIFE",
    "Marketing Name": "TLPADNEO_a",
    "Device": "TLPADNEO",
    "Model": "TLPADNEO"
  },
  {
    "Retail Branding": "TECHLIFE",
    "Marketing Name": "TLPADP04",
    "Device": "TLPADP04",
    "Model": "TLPADP04"
  },
  {
    "Retail Branding": "TECHLIFE",
    "Marketing Name": "TLPADPLUS",
    "Device": "TLPADPLUS",
    "Model": "TLPADPLUS"
  },
  {
    "Retail Branding": "TECHLIFE",
    "Marketing Name": "TechLife Pad Pro 12",
    "Device": "TLPADPRO1",
    "Model": "TLPADPRO1"
  },
  {
    "Retail Branding": "TECHNOLOGIA Y CRATIVIDAD",
    "Marketing Name": "M103H",
    "Device": "M103H",
    "Model": "M103H"
  },
  {
    "Retail Branding": "TECH_VIEW",
    "Marketing Name": "Tab_80_pro",
    "Device": "Tab_80_pro",
    "Model": "Tab_80_pro"
  },
  {
    "Retail Branding": "TECHcomputer",
    "Marketing Name": "F102-T610-EEA",
    "Device": "F102-T610-EEA",
    "Model": "F102-T610-EEA"
  },
  {
    "Retail Branding": "TECHcomputer",
    "Marketing Name": "F102-T610-EEA-GG5",
    "Device": "F102-T610-EEA-GG5",
    "Model": "F102-T610-EEA-GG5"
  },
  {
    "Retail Branding": "TECHcomputer",
    "Marketing Name": "F102-T618-EEA",
    "Device": "F102-T618-EEA",
    "Model": "F102-T618-EEA"
  },
  {
    "Retail Branding": "TECHcomputer",
    "Marketing Name": "P11 F102-MT8781-EEA",
    "Device": "F102-MT8781-EEA",
    "Model": "P11-F102-MT8781-EEA"
  },
  {
    "Retail Branding": "TECHcomputer",
    "Marketing Name": "P11-F102-MT8781-EEA-WIFI",
    "Device": "P11-F102",
    "Model": "P11-F102-MT8781-EEA-WIFI"
  },
  {
    "Retail Branding": "TECHcomputer",
    "Marketing Name": "P31-F102-T606-EEA",
    "Device": "P31-F102-T606",
    "Model": "P31-F102-T606-EEA"
  },
  {
    "Retail Branding": "TECHcomputer",
    "Marketing Name": "TEC-M1310",
    "Device": "TEC-M1310",
    "Model": "TEC-M1310"
  },
  {
    "Retail Branding": "TECO",
    "Marketing Name": "Android TV",
    "Device": "longshan",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "TECO",
    "Marketing Name": "K5T",
    "Device": "ikebukuro",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "TECO",
    "Marketing Name": "Smart TV",
    "Device": "alimos",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "TECO",
    "Marketing Name": "Smart TV",
    "Device": "dangni",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "TECO",
    "Marketing Name": "Smart TV",
    "Device": "osaka",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "TECO",
    "Marketing Name": "TL55U12TRE",
    "Device": "samseong",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "TEConnect",
    "Marketing Name": "CHALK_2series",
    "Device": "CHALK_2series",
    "Model": "CHALK_2series"
  },
  {
    "Retail Branding": "TEConnect",
    "Marketing Name": "TEC_Board",
    "Device": "rk3588_t",
    "Model": "CA-ET"
  },
  {
    "Retail Branding": "TEConnect",
    "Marketing Name": "TEConnect_IFPD",
    "Device": "rk3576",
    "Model": "CG_series"
  },
  {
    "Retail Branding": "TEKLIO",
    "Marketing Name": "Smart TV",
    "Device": "osaka",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "TEKLIO",
    "Marketing Name": "Smart TV",
    "Device": "redwood",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "TELE System",
    "Marketing Name": "EU、UK、AP",
    "Device": "martin",
    "Model": "TELESYSTEM 2K Android TV"
  },
  {
    "Retail Branding": "TELE System",
    "Marketing Name": "Italy，Poland,Czech,BeNeLux",
    "Device": "guandu",
    "Model": "TELESYSTEM 4K Android TV"
  },
  {
    "Retail Branding": "TELE System",
    "Marketing Name": "ON T2 HD",
    "Device": "ONT2HD",
    "Model": "ONT2HD"
  },
  {
    "Retail Branding": "TELE System",
    "Marketing Name": "UP1",
    "Device": "ROM",
    "Model": "UP1"
  },
  {
    "Retail Branding": "TELE System",
    "Marketing Name": "UPT24K",
    "Device": "UPT24K",
    "Model": "UPT24K"
  },
  {
    "Retail Branding": "TELECAB",
    "Marketing Name": "B866V2FA",
    "Device": "B866V2FA_TELECAB",
    "Model": "B866V2FA"
  },
  {
    "Retail Branding": "TELOX",
    "Marketing Name": "BN500",
    "Device": "BN500",
    "Model": "BN500"
  },
  {
    "Retail Branding": "TELOX",
    "Marketing Name": "BP900",
    "Device": "BP900",
    "Model": "BP900"
  },
  {
    "Retail Branding": "TELOX",
    "Marketing Name": "TE620G",
    "Device": "TE620G",
    "Model": "TE620G"
  },
  {
    "Retail Branding": "TELSTAR",
    "Marketing Name": "TELSTAR 2K Google TV",
    "Device": "capitolhill",
    "Model": "TELSTAR 2K Google TV"
  },
  {
    "Retail Branding": "TELSTAR",
    "Marketing Name": "TELSTAR 4K Google TV",
    "Device": "keoneae",
    "Model": "TELSTAR 4K Google TV"
  },
  {
    "Retail Branding": "TENCH",
    "Marketing Name": "TAB_A10",
    "Device": "TAB_A10",
    "Model": "ADVAN TAB A10"
  },
  {
    "Retail Branding": "TEROS",
    "Marketing Name": "TE8614W",
    "Device": "TE_8614W",
    "Model": "TE_8614W"
  },
  {
    "Retail Branding": "TERRA",
    "Marketing Name": "GPAD702",
    "Device": "GPAD702",
    "Model": "GPAD702"
  },
  {
    "Retail Branding": "TERRA",
    "Marketing Name": "TERRA PAD 101",
    "Device": "TERRA_PAD_101",
    "Model": "TERRA_PAD_101"
  },
  {
    "Retail Branding": "TERRA",
    "Marketing Name": "TERRA_MOBILE_PAD_1200",
    "Device": "TERRA_MOBILE_PAD_1200",
    "Model": "TERRA_MOBILE_PAD_1200"
  },
  {
    "Retail Branding": "TERRA",
    "Marketing Name": "TERRA_PAD_1005",
    "Device": "TERRA_PAD_1005",
    "Model": "TERRA_PAD_1005"
  },
  {
    "Retail Branding": "TERRA",
    "Marketing Name": "TERRA_PAD_1005POKO",
    "Device": "TERRA_PAD_1005POKO",
    "Model": "TERRA_PAD_1005POKO"
  },
  {
    "Retail Branding": "TERRA",
    "Marketing Name": "TERRA_PAD_1006",
    "Device": "TERRA_PAD_1006",
    "Model": "TERRA_PAD_1006"
  },
  {
    "Retail Branding": "TERRA",
    "Marketing Name": "TERRA_PAD_1006_V2",
    "Device": "TERRA_PAD_1006_V2",
    "Model": "TERRA_PAD_1006_V2"
  },
  {
    "Retail Branding": "TERRA",
    "Marketing Name": "TERRA_PAD_1007",
    "Device": "TERRA_PAD_1007",
    "Model": "TERRA_PAD_1007"
  },
  {
    "Retail Branding": "TERRA",
    "Marketing Name": "TERRA_PAD_1200_V2",
    "Device": "TERRA_PAD_1200_V2",
    "Model": "TERRA_PAD_1200_V2"
  },
  {
    "Retail Branding": "TERRA",
    "Marketing Name": "TERRA_PAD_1201",
    "Device": "TERRA_PAD_1201",
    "Model": "TERRA_PAD_1201"
  },
  {
    "Retail Branding": "TES (Touch Embedded Solutions)",
    "Marketing Name": "igs-series",
    "Device": "igs-series",
    "Model": "igs-series"
  },
  {
    "Retail Branding": "TES (Touch Embedded Solutions)",
    "Marketing Name": "igs-series-gen2",
    "Device": "igs-series-gen2",
    "Model": "igs-series-gen2"
  },
  {
    "Retail Branding": "TESPRO",
    "Marketing Name": "Mayumi U1",
    "Device": "Mayumi_U1",
    "Model": "Mayumi U1"
  },
  {
    "Retail Branding": "TEYES",
    "Marketing Name": "CC4PRO",
    "Device": "CC4PRO",
    "Model": "CC4PRO"
  },
  {
    "Retail Branding": "TG&Co.",
    "Marketing Name": "TG-L800S",
    "Device": "PHX",
    "Model": "TG-L800S"
  },
  {
    "Retail Branding": "TG&Co.",
    "Marketing Name": "TG-L900S",
    "Device": "JGR",
    "Model": "TG-L900S"
  },
  {
    "Retail Branding": "THANHHUNG_TECHNOLOGY",
    "Marketing Name": "HERO 9",
    "Device": "HERO_9",
    "Model": "HERO 9"
  },
  {
    "Retail Branding": "THE UHD",
    "Marketing Name": "Android TV",
    "Device": "R2",
    "Model": "ATV R2"
  },
  {
    "Retail Branding": "THE UHD",
    "Marketing Name": "R4",
    "Device": "R4",
    "Model": "R4"
  },
  {
    "Retail Branding": "THE UHD",
    "Marketing Name": "THE UHD",
    "Device": "elliniko",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "THE UHD",
    "Marketing Name": "THEUHD",
    "Device": "mountbaker",
    "Model": "2K SMART TV"
  },
  {
    "Retail Branding": "THEHAM",
    "Marketing Name": "Android TV",
    "Device": "longshan",
    "Model": "AI PONT NA"
  },
  {
    "Retail Branding": "THEHAM",
    "Marketing Name": "Smart TV",
    "Device": "osaka",
    "Model": "AI PONT NA"
  },
  {
    "Retail Branding": "THEHAM",
    "Marketing Name": "THEHAM",
    "Device": "hongkong",
    "Model": "Smart UHD TV"
  },
  {
    "Retail Branding": "THEHAM",
    "Marketing Name": "THEHAM",
    "Device": "stanford",
    "Model": "Smart FHD TV"
  },
  {
    "Retail Branding": "THEHAM",
    "Marketing Name": "THEHAM",
    "Device": "zhongshan",
    "Model": "Smart UHD TV"
  },
  {
    "Retail Branding": "THEHAM",
    "Marketing Name": "UHD Android TV",
    "Device": "sindorim",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "THEHAM",
    "Marketing Name": "huangshan_theham",
    "Device": "huangshan",
    "Model": "SmartTV 4K FFM"
  },
  {
    "Retail Branding": "THEHAM",
    "Marketing Name": "vileparle",
    "Device": "vileparle",
    "Model": "R6G"
  },
  {
    "Retail Branding": "THL",
    "Marketing Name": "Knight 2",
    "Device": "Knight_2",
    "Model": "Knight 2"
  },
  {
    "Retail Branding": "THOMSON_KODAK",
    "Marketing Name": "PATH_7XPRO",
    "Device": "LEDTV32HD",
    "Model": "PATH_7XPRO"
  },
  {
    "Retail Branding": "THOMSON_KODAK",
    "Marketing Name": "PATH_UHDXANDROID",
    "Device": "LEDTVUHD",
    "Model": "PATH_UHDXANDROID"
  },
  {
    "Retail Branding": "THTF",
    "Marketing Name": "A21",
    "Device": "A21",
    "Model": "A21"
  },
  {
    "Retail Branding": "THTF",
    "Marketing Name": "THT TV",
    "Device": "SEI700THT",
    "Model": "THT TV"
  },
  {
    "Retail Branding": "THTF",
    "Marketing Name": "TSINGHUA TONGFANG CO., LTD.",
    "Device": "TR10CD1_3",
    "Model": "TR10CD1"
  },
  {
    "Retail Branding": "TIANHOO",
    "Marketing Name": "EOS Pro",
    "Device": "EOS_Pro",
    "Model": "EOS Pro"
  },
  {
    "Retail Branding": "TIANYU",
    "Marketing Name": "S40",
    "Device": "S40",
    "Model": "S40"
  },
  {
    "Retail Branding": "TIANYU",
    "Marketing Name": "S40E",
    "Device": "S40",
    "Model": "S40"
  },
  {
    "Retail Branding": "TIGO",
    "Marketing Name": "ONEtv",
    "Device": "uiw4054mil",
    "Model": "ONEtv"
  },
  {
    "Retail Branding": "TIGO",
    "Marketing Name": "ONEtv",
    "Device": "uiw4059mil",
    "Model": "ONEtv"
  },
  {
    "Retail Branding": "TIGO",
    "Marketing Name": "ONEtv",
    "Device": "vip6102w",
    "Model": "ONEtv"
  },
  {
    "Retail Branding": "TIM",
    "Marketing Name": "TIM BOX",
    "Device": "uzw4010tim",
    "Model": "TIM_BOX"
  },
  {
    "Retail Branding": "TIM",
    "Marketing Name": "TIMVISION Box",
    "Device": "uzw4054tim",
    "Model": "TIMVISION Box"
  },
  {
    "Retail Branding": "TIM",
    "Marketing Name": "TIMVISION VSB",
    "Device": "m393vsb_tim",
    "Model": "TIMVISION VSB"
  },
  {
    "Retail Branding": "TIM",
    "Marketing Name": "TIMVISIONBOX",
    "Device": "m393gena_tim",
    "Model": "TIMVISIONBOX"
  },
  {
    "Retail Branding": "TIM",
    "Marketing Name": "TIMvision",
    "Device": "dwt765ti",
    "Model": "skipper"
  },
  {
    "Retail Branding": "TINSIK",
    "Marketing Name": "A19_Plus",
    "Device": "A19_Plus",
    "Model": "A19 Plus"
  },
  {
    "Retail Branding": "TIOK",
    "Marketing Name": "S32",
    "Device": "S32",
    "Model": "S32"
  },
  {
    "Retail Branding": "TIT(SA)",
    "Marketing Name": "TIT SMART TV",
    "Device": "SW4H",
    "Model": "TIT SMART TV"
  },
  {
    "Retail Branding": "TIT(SA)",
    "Marketing Name": "TITTV",
    "Device": "shibuya",
    "Model": "TITTV"
  },
  {
    "Retail Branding": "TJC",
    "Marketing Name": "Metal Tablet",
    "Device": "Metal_Tablet_10",
    "Model": "Metal_Tablet_10"
  },
  {
    "Retail Branding": "TJD(SZ)",
    "Marketing Name": "MT 750QU",
    "Device": "MT-750QU",
    "Model": "MT-750QU"
  },
  {
    "Retail Branding": "TJD(SZ)",
    "Marketing Name": "MT-1010OF",
    "Device": "MT-1010OF",
    "Model": "MT-1010OF"
  },
  {
    "Retail Branding": "TJD(SZ)",
    "Marketing Name": "MT-1011",
    "Device": "MT-1011",
    "Model": "MT-1011"
  },
  {
    "Retail Branding": "TJD(SZ)",
    "Marketing Name": "MT-1011OF",
    "Device": "MT-1011OF",
    "Model": "MT-1011OF"
  },
  {
    "Retail Branding": "TJD(SZ)",
    "Marketing Name": "MT-1011QR",
    "Device": "MT-1011QR",
    "Model": "MT-1011QR"
  },
  {
    "Retail Branding": "TJD(SZ)",
    "Marketing Name": "MT-701QU",
    "Device": "MT-701QU",
    "Model": "MT-701QU"
  },
  {
    "Retail Branding": "TJD(SZ)",
    "Marketing Name": "MT-702QU",
    "Device": "MT-702QU",
    "Model": "MT-702QU"
  },
  {
    "Retail Branding": "TJD(SZ)",
    "Marketing Name": "MT-707OF",
    "Device": "MT-707OF",
    "Model": "MT-707OF"
  },
  {
    "Retail Branding": "TJD(SZ)",
    "Marketing Name": "MT-710QF",
    "Device": "MT-710QF",
    "Model": "MT-710QF"
  },
  {
    "Retail Branding": "TJD(SZ)",
    "Marketing Name": "MT-710QU",
    "Device": "MT-710QU",
    "Model": "TJD MT-710QU"
  },
  {
    "Retail Branding": "TJD(SZ)",
    "Marketing Name": "MT-710QU_Pro",
    "Device": "MT-710QU_Pro",
    "Model": "MT-710QU_Pro"
  },
  {
    "Retail Branding": "TJD(SZ)",
    "Marketing Name": "MT-715QR",
    "Device": "MT-715QR",
    "Model": "MT-715QR"
  },
  {
    "Retail Branding": "TJD(SZ)",
    "Marketing Name": "MT-717QW",
    "Device": "MT-717QW",
    "Model": "MT-717QW"
  },
  {
    "Retail Branding": "TJD(SZ)",
    "Marketing Name": "MT-750QR",
    "Device": "MT-750QR",
    "Model": "MT-750QR"
  },
  {
    "Retail Branding": "TJD(SZ)",
    "Marketing Name": "MT-750QU_Pro",
    "Device": "MT-750QU_Pro",
    "Model": "MT-750QU_Pro"
  },
  {
    "Retail Branding": "TJD(SZ)",
    "Marketing Name": "MT-750QU_V1",
    "Device": "MT-750QU_V1",
    "Model": "MT-750QU"
  },
  {
    "Retail Branding": "TJD(SZ)",
    "Marketing Name": "MT-761QU",
    "Device": "MT-761QU",
    "Model": "MT-761QU"
  },
  {
    "Retail Branding": "TJD(SZ)",
    "Marketing Name": "MT-761QU_Pro",
    "Device": "MT-761QU_Pro",
    "Model": "MT-761QU_Pro"
  },
  {
    "Retail Branding": "TJD(SZ)",
    "Marketing Name": "MT-762QR",
    "Device": "MT-762QR",
    "Model": "MT-762QR"
  },
  {
    "Retail Branding": "TJD(SZ)",
    "Marketing Name": "MT-790QR_V1",
    "Device": "MT-790QR_V1",
    "Model": "MT-790QR_V1"
  },
  {
    "Retail Branding": "TJD(SZ)",
    "Marketing Name": "MT-790QR_V1_EEA",
    "Device": "MT-790QR_V1_EEA",
    "Model": "MT-790QR_V1_EEA"
  },
  {
    "Retail Branding": "TJD(SZ)",
    "Marketing Name": "MT-792OF_EEA",
    "Device": "MT-792OF_EEA",
    "Model": "MT-792OF"
  },
  {
    "Retail Branding": "TJD(SZ)",
    "Marketing Name": "MT_1025QU",
    "Device": "MT_1025QU",
    "Model": "MT_1025QU"
  },
  {
    "Retail Branding": "TKDS",
    "Marketing Name": "T_101H",
    "Device": "T_101H",
    "Model": "T_101H"
  },
  {
    "Retail Branding": "TM Cell",
    "Marketing Name": "ISWAG KRONOS",
    "Device": "ISWAG_KRONOSX",
    "Model": "ISWAG KRONOS"
  },
  {
    "Retail Branding": "TM Cell",
    "Marketing Name": "LOGIC X50",
    "Device": "LOGIC_X50X",
    "Model": "LOGIC X50"
  },
  {
    "Retail Branding": "TM Cell",
    "Marketing Name": "LOGIC_X60_PLUS",
    "Device": "LOGIC_X60_PLUS",
    "Model": "LOGIC_X60_PLUS"
  },
  {
    "Retail Branding": "TM Cell",
    "Marketing Name": "UNONU W50",
    "Device": "UNONU_W50X",
    "Model": "UNONU W50"
  },
  {
    "Retail Branding": "TM Cell",
    "Marketing Name": "UNONU_W60_PLUSt",
    "Device": "UNONU_W60_PLUS",
    "Model": "UNONU_W60_PLUS"
  },
  {
    "Retail Branding": "TM Cell",
    "Marketing Name": "X40L",
    "Device": "X40L",
    "Model": "X40L"
  },
  {
    "Retail Branding": "TM Cell",
    "Marketing Name": "X50A",
    "Device": "X50A",
    "Model": "X50A"
  },
  {
    "Retail Branding": "TMAX",
    "Marketing Name": "TM9S775",
    "Device": "MID908A-K",
    "Model": "TM9S775"
  },
  {
    "Retail Branding": "TMB(A)",
    "Marketing Name": "Max",
    "Device": "Max",
    "Model": "Max"
  },
  {
    "Retail Branding": "TMEE",
    "Marketing Name": "T1185S4RT-TMEE",
    "Device": "T1185S4RT-TMEE",
    "Model": "T1185S4RT-TMEE"
  },
  {
    "Retail Branding": "TNT (Panalo)",
    "Marketing Name": "TNT PANALO PHONE 5G",
    "Device": "TNT_PANALO_PHONE_5G",
    "Model": "TNT PANALO PHONE 5G"
  },
  {
    "Retail Branding": "TO21COMMS",
    "Marketing Name": "TOP10",
    "Device": "TOP10",
    "Model": "TOP10"
  },
  {
    "Retail Branding": "TOAD",
    "Marketing Name": "Q863",
    "Device": "Q863",
    "Model": "Q863"
  },
  {
    "Retail Branding": "TOCHMOBILE",
    "Marketing Name": "ANGEL_SMART",
    "Device": "ANGEL_SMART",
    "Model": "ANGEL_SMART"
  },
  {
    "Retail Branding": "TOKECY",
    "Marketing Name": "T847",
    "Device": "T847",
    "Model": "T847"
  },
  {
    "Retail Branding": "TOKECY",
    "Marketing Name": "T847_EEA",
    "Device": "T847_EEA",
    "Model": "T847_EEA"
  },
  {
    "Retail Branding": "TOKYO",
    "Marketing Name": "Paraguay",
    "Device": "marina",
    "Model": "TOKYO SMART 4K TV"
  },
  {
    "Retail Branding": "TOKYO",
    "Marketing Name": "Paraguay",
    "Device": "nagata",
    "Model": "TOKYO SMART 2K TV"
  },
  {
    "Retail Branding": "TOKYO",
    "Marketing Name": "Paraguay",
    "Device": "sepolia",
    "Model": "TOKYO 4K GOOGLE TV"
  },
  {
    "Retail Branding": "TOKYO",
    "Marketing Name": "TOKYO 2K GOOGLE TV",
    "Device": "dongnae",
    "Model": "TOKYO 2K Google TV"
  },
  {
    "Retail Branding": "TONE",
    "Marketing Name": "TONE e20",
    "Device": "TONE_e20",
    "Model": "TONE e20"
  },
  {
    "Retail Branding": "TONE",
    "Marketing Name": "TONE_e21",
    "Device": "TONE_e21",
    "Model": "TONE_e21"
  },
  {
    "Retail Branding": "TONE",
    "Marketing Name": "TONE_e22",
    "Device": "TONE_e22",
    "Model": "TONE_e22"
  },
  {
    "Retail Branding": "TOPELOTEK",
    "Marketing Name": "KIDS06",
    "Device": "KIDS06",
    "Model": "KIDS06"
  },
  {
    "Retail Branding": "TOPELOTEK",
    "Marketing Name": "KIDS08-X8",
    "Device": "KIDS08-X8",
    "Model": "KIDS08-X8"
  },
  {
    "Retail Branding": "TOPELOTEK",
    "Marketing Name": "KIDS09S",
    "Device": "KIDS09S",
    "Model": "KIDS09S"
  },
  {
    "Retail Branding": "TOPELOTEK",
    "Marketing Name": "KIDS707",
    "Device": "TOPELOTEK_KIDS707",
    "Model": "KIDS707"
  },
  {
    "Retail Branding": "TOPELOTEK",
    "Marketing Name": "KIDS708",
    "Device": "KIDS708",
    "Model": "KIDS708"
  },
  {
    "Retail Branding": "TOPELOTEK",
    "Marketing Name": "KIDS708_709A",
    "Device": "KIDS708_709A",
    "Model": "KIDS708-709A"
  },
  {
    "Retail Branding": "TOPELOTEK",
    "Marketing Name": "KIDS709",
    "Device": "KIDS709",
    "Model": "KIDS709"
  },
  {
    "Retail Branding": "TOPELOTEK",
    "Marketing Name": "KIDS710",
    "Device": "KIDS710",
    "Model": "KIDS710"
  },
  {
    "Retail Branding": "TOPELOTEK",
    "Marketing Name": "KIDS720",
    "Device": "KIDS720",
    "Model": "KIDS720"
  },
  {
    "Retail Branding": "TOPELOTEK",
    "Marketing Name": "TOPELOTEK",
    "Device": "KIDS08",
    "Model": "KIDS08"
  },
  {
    "Retail Branding": "TOPELOTEK",
    "Marketing Name": "TOPELOTEK",
    "Device": "KIDS09",
    "Model": "KIDS09"
  },
  {
    "Retail Branding": "TOPELOTEK",
    "Marketing Name": "V7",
    "Device": "V7",
    "Model": "V7"
  },
  {
    "Retail Branding": "TOPELOTEK",
    "Marketing Name": "Y8",
    "Device": "Y8",
    "Model": "Y8"
  },
  {
    "Retail Branding": "TOPELOTEK",
    "Marketing Name": "ZIDS_701",
    "Device": "ZIDS_701",
    "Model": "ZIDS_701"
  },
  {
    "Retail Branding": "TOPJOY",
    "Marketing Name": "PNC450",
    "Device": "PNC450",
    "Model": "PNC450"
  },
  {
    "Retail Branding": "TOPJOY",
    "Marketing Name": "SC0802",
    "Device": "SC0802",
    "Model": "SC0802"
  },
  {
    "Retail Branding": "TOPNICE",
    "Marketing Name": "H66",
    "Device": "mensa_an64",
    "Model": "TOPNICE_H66"
  },
  {
    "Retail Branding": "TOPNICE",
    "Marketing Name": "IFPD-H66",
    "Device": "IFPD",
    "Model": "TOPNICE-H66"
  },
  {
    "Retail Branding": "TORNADO",
    "Marketing Name": "Smart TV",
    "Device": "dangni",
    "Model": "TORNADO Google TV"
  },
  {
    "Retail Branding": "TORNADO",
    "Marketing Name": "TORNADO 2K SMART TV",
    "Device": "shinagawa",
    "Model": "TORNADO 2K SMART TV"
  },
  {
    "Retail Branding": "TORNADO",
    "Marketing Name": "TORNADO 2K SMART TV",
    "Device": "umeda",
    "Model": "TORNADO 2K SMART TV"
  },
  {
    "Retail Branding": "TORNADO",
    "Marketing Name": "TORNADO 4K SmartTV",
    "Device": "SW6H",
    "Model": "TORNADO 4K SmartTV"
  },
  {
    "Retail Branding": "TORNADO",
    "Marketing Name": "TORNADO Android TV",
    "Device": "SW4H",
    "Model": "TORNADO Android TV"
  },
  {
    "Retail Branding": "TORNADO",
    "Marketing Name": "TORNADO EA53 AndroidTV",
    "Device": "beaudry",
    "Model": "TORNADO EA53 AndroidTV"
  },
  {
    "Retail Branding": "TORNADO",
    "Marketing Name": "TORNADO UA53 AndroidTV",
    "Device": "barking",
    "Model": "TORNADO UA53 AndroidTV"
  },
  {
    "Retail Branding": "TOSCIDO",
    "Marketing Name": "P101",
    "Device": "P101",
    "Model": "P101"
  },
  {
    "Retail Branding": "TOSCIDO",
    "Marketing Name": "P101-EEA",
    "Device": "P101-EEA",
    "Model": "P101-EEA"
  },
  {
    "Retail Branding": "TOSCIDO",
    "Marketing Name": "T12-EEA",
    "Device": "T12-EEA",
    "Model": "T12-EEA"
  },
  {
    "Retail Branding": "TOSCIDO",
    "Marketing Name": "T13-EEA",
    "Device": "T13-EEA",
    "Model": "T13-EEA"
  },
  {
    "Retail Branding": "TOSCIDO",
    "Marketing Name": "T15",
    "Device": "T15",
    "Model": "T15"
  },
  {
    "Retail Branding": "TOSCIDO",
    "Marketing Name": "T15-EEA",
    "Device": "T15-EEA",
    "Model": "T15-EEA"
  },
  {
    "Retail Branding": "TOSCIDO",
    "Marketing Name": "T151",
    "Device": "T151",
    "Model": "T151"
  },
  {
    "Retail Branding": "TOSCIDO",
    "Marketing Name": "T151-EEA",
    "Device": "T151-EEA",
    "Model": "T151-EEA"
  },
  {
    "Retail Branding": "TOSCIDO",
    "Marketing Name": "T18",
    "Device": "T18",
    "Model": "T18"
  },
  {
    "Retail Branding": "TOSCIDO",
    "Marketing Name": "T18-EEA",
    "Device": "T18-EEA",
    "Model": "T18-EEA"
  },
  {
    "Retail Branding": "TOSCIDO",
    "Marketing Name": "T181",
    "Device": "T181",
    "Model": "T181"
  },
  {
    "Retail Branding": "TOSCIDO",
    "Marketing Name": "T181-EEA",
    "Device": "T181-EEA",
    "Model": "T181-EEA"
  },
  {
    "Retail Branding": "TOSCIDO",
    "Marketing Name": "T20-EEA",
    "Device": "T20-EEA",
    "Model": "T20-EEA"
  },
  {
    "Retail Branding": "TOSCIDO",
    "Marketing Name": "T201",
    "Device": "T201",
    "Model": "T201"
  },
  {
    "Retail Branding": "TOSCIDO",
    "Marketing Name": "T201-EEA",
    "Device": "T201-EEA",
    "Model": "T201-EEA"
  },
  {
    "Retail Branding": "TOSCIDO",
    "Marketing Name": "T21-EEA",
    "Device": "T21-EEA",
    "Model": "T21-EEA"
  },
  {
    "Retail Branding": "TOSCIDO",
    "Marketing Name": "T21-EEA",
    "Device": "T21-EEA",
    "Model": "X10"
  },
  {
    "Retail Branding": "TOSCIDO",
    "Marketing Name": "T211-EEA",
    "Device": "T211-EEA",
    "Model": "T211-EEA"
  },
  {
    "Retail Branding": "TOSCIDO",
    "Marketing Name": "T22",
    "Device": "T22",
    "Model": "T22"
  },
  {
    "Retail Branding": "TOSCIDO",
    "Marketing Name": "T22-EEA",
    "Device": "T22-EEA",
    "Model": "T22-EEA"
  },
  {
    "Retail Branding": "TOSCIDO",
    "Marketing Name": "T221",
    "Device": "T221",
    "Model": "T221"
  },
  {
    "Retail Branding": "TOSCIDO",
    "Marketing Name": "T26",
    "Device": "T26",
    "Model": "T26"
  },
  {
    "Retail Branding": "TOSCIDO",
    "Marketing Name": "T26-EEA",
    "Device": "T26-EEA",
    "Model": "T26-EEA"
  },
  {
    "Retail Branding": "TOSCIDO",
    "Marketing Name": "T28",
    "Device": "T28",
    "Model": "T28"
  },
  {
    "Retail Branding": "TOSCIDO",
    "Marketing Name": "T28-EEA",
    "Device": "T28-EEA",
    "Model": "T28-EEA"
  },
  {
    "Retail Branding": "TOSCIDO",
    "Marketing Name": "T30-EEA",
    "Device": "T30-EEA",
    "Model": "T30-EEA"
  },
  {
    "Retail Branding": "TOSCIDO",
    "Marketing Name": "T32-EEA",
    "Device": "T32-EEA",
    "Model": "T32-EEA"
  },
  {
    "Retail Branding": "TOSCIDO",
    "Marketing Name": "T50",
    "Device": "T50",
    "Model": "T50"
  },
  {
    "Retail Branding": "TOSCIDO",
    "Marketing Name": "T50-EEA",
    "Device": "T50-EEA",
    "Model": "T50-EEA"
  },
  {
    "Retail Branding": "TOSCIDO",
    "Marketing Name": "T501-EEA",
    "Device": "T501-EEA",
    "Model": "T501-EEA"
  },
  {
    "Retail Branding": "TOSCIDO",
    "Marketing Name": "X102",
    "Device": "X102",
    "Model": "X102"
  },
  {
    "Retail Branding": "TOUCHSMART",
    "Marketing Name": "QUICKTAB",
    "Device": "Quicktab",
    "Model": "Quicktab"
  },
  {
    "Retail Branding": "TOUCH_DYNAMIC",
    "Marketing Name": "Nexus",
    "Device": "Nexus",
    "Model": "Nexus"
  },
  {
    "Retail Branding": "TOUCH_DYNAMIC",
    "Marketing Name": "Quest-Handheld",
    "Device": "Quest-Handheld",
    "Model": "Quest-Handheld"
  },
  {
    "Retail Branding": "TOUCH_DYNAMIC",
    "Marketing Name": "QuestGamingTablet",
    "Device": "QuestGamingTablet",
    "Model": "QuestGamingTablet"
  },
  {
    "Retail Branding": "TOUCH_DYNAMIC",
    "Marketing Name": "Vector",
    "Device": "Vector",
    "Model": "Vector"
  },
  {
    "Retail Branding": "TOUMAI",
    "Marketing Name": "MI_1",
    "Device": "MI_1",
    "Model": "MI_1"
  },
  {
    "Retail Branding": "TOXIIK",
    "Marketing Name": "A7K",
    "Device": "A7K",
    "Model": "A7K"
  },
  {
    "Retail Branding": "TOXIIK",
    "Marketing Name": "M10_KID",
    "Device": "TOXIIK_M10_KID",
    "Model": "M10_KID"
  },
  {
    "Retail Branding": "TOXIIK",
    "Marketing Name": "TOXIIK_A8",
    "Device": "TOXIIK_A8",
    "Model": "A8"
  },
  {
    "Retail Branding": "TOYA",
    "Marketing Name": "Poland",
    "Device": "DTC974x",
    "Model": "DTC974x"
  },
  {
    "Retail Branding": "TOYA",
    "Marketing Name": "Poland",
    "Device": "DTC974y",
    "Model": "DTC9740"
  },
  {
    "Retail Branding": "TOYIN",
    "Marketing Name": "RJ TOYIN",
    "Device": "RJ_TOYIN",
    "Model": "RJ TOYIN"
  },
  {
    "Retail Branding": "TPLAY",
    "Marketing Name": "Telecentro 4K",
    "Device": "SEI800TCT",
    "Model": "Telecentro 4K"
  },
  {
    "Retail Branding": "TPLAY",
    "Marketing Name": "Telecentro 4K",
    "Device": "SEID00TCT",
    "Model": "Telecentro 4K S2"
  },
  {
    "Retail Branding": "TPS",
    "Marketing Name": "ALTAB08",
    "Device": "ALTAB08",
    "Model": "ALTAB08"
  },
  {
    "Retail Branding": "TPS",
    "Marketing Name": "K1091F",
    "Device": "K1091F",
    "Model": "K1091F"
  },
  {
    "Retail Branding": "TPS",
    "Marketing Name": "KF7",
    "Device": "KF7",
    "Model": "KF7"
  },
  {
    "Retail Branding": "TPS",
    "Marketing Name": "MTC 982o",
    "Device": "MTC_982O",
    "Model": "MTC_982O"
  },
  {
    "Retail Branding": "TPS",
    "Marketing Name": "S10-9863",
    "Device": "S10-9863",
    "Model": "S10-9863"
  },
  {
    "Retail Branding": "TPS",
    "Marketing Name": "S50",
    "Device": "S50",
    "Model": "BT-S50"
  },
  {
    "Retail Branding": "TPS",
    "Marketing Name": "SMART Sprint",
    "Device": "SMARTSprint",
    "Model": "SMART Sprint"
  },
  {
    "Retail Branding": "TPS",
    "Marketing Name": "SZTPS",
    "Device": "A101",
    "Model": "A101"
  },
  {
    "Retail Branding": "TPS",
    "Marketing Name": "TPS-SC10",
    "Device": "TPS-SC10",
    "Model": "TPS-SC10"
  },
  {
    "Retail Branding": "TREQ",
    "Marketing Name": "SmarTab-8",
    "Device": "SmarTab-8",
    "Model": "SmarTab-8"
  },
  {
    "Retail Branding": "TRIPLTEK",
    "Marketing Name": "T mini",
    "Device": "T_mini",
    "Model": "T mini"
  },
  {
    "Retail Branding": "TRIUMPH_BOARD",
    "Marketing Name": "TRIUMPH BOARD",
    "Device": "rk3576_u",
    "Model": "TRIUMPH_BOARD_BLACK"
  },
  {
    "Retail Branding": "TRIUMPH_BOARD",
    "Marketing Name": "TRIUMPH_IFP_BLACK_G",
    "Device": "mt9679_u",
    "Model": "TRIUMPH_BOARD_BLACK"
  },
  {
    "Retail Branding": "TRT(SZ)",
    "Marketing Name": "NOTEXPRO",
    "Device": "NOTEXPRO",
    "Model": "NOTEXPRO"
  },
  {
    "Retail Branding": "TRUE_SLIM",
    "Marketing Name": "T1586K",
    "Device": "T1586K",
    "Model": "T1586K"
  },
  {
    "Retail Branding": "TRUFON",
    "Marketing Name": "TRUFON FLEX",
    "Device": "TRUFON_FLEX",
    "Model": "TRUFON FLEX"
  },
  {
    "Retail Branding": "TSUNAMi",
    "Marketing Name": "Tablet Tsunami TSTA080D1",
    "Device": "MG080D1T",
    "Model": "MG080D1T"
  },
  {
    "Retail Branding": "TTKIDS",
    "Marketing Name": "K06",
    "Device": "K06",
    "Model": "K06"
  },
  {
    "Retail Branding": "TTKIDS",
    "Marketing Name": "K06_EEA",
    "Device": "K06",
    "Model": "K06"
  },
  {
    "Retail Branding": "TTKIDS",
    "Marketing Name": "K106",
    "Device": "K106",
    "Model": "K106"
  },
  {
    "Retail Branding": "TTKIDS",
    "Marketing Name": "K106_EEA",
    "Device": "K106",
    "Model": "K106"
  },
  {
    "Retail Branding": "TTS-group",
    "Marketing Name": "IT10268",
    "Device": "IT10268",
    "Model": "IT10268"
  },
  {
    "Retail Branding": "TTfone",
    "Marketing Name": "TT20_eea",
    "Device": "TTfone_TT20",
    "Model": "TTfone TT20"
  },
  {
    "Retail Branding": "TUFEN",
    "Marketing Name": "Q718",
    "Device": "Q718",
    "Model": "Q718"
  },
  {
    "Retail Branding": "TUFEN",
    "Marketing Name": "Q718A_EEA",
    "Device": "TUFEN_Q718A",
    "Model": "Q718A"
  },
  {
    "Retail Branding": "TUFEN",
    "Marketing Name": "Q718B_EEA",
    "Device": "Q718B_EEA",
    "Model": "Q718B"
  },
  {
    "Retail Branding": "TUFEN",
    "Marketing Name": "Q718B_EEA",
    "Device": "Q718B_EEA",
    "Model": "Q718B_EEA"
  },
  {
    "Retail Branding": "TUFEN",
    "Marketing Name": "Q738",
    "Device": "Q738",
    "Model": "Q738"
  },
  {
    "Retail Branding": "TUFEN",
    "Marketing Name": "Q801",
    "Device": "Q801",
    "Model": "Q801"
  },
  {
    "Retail Branding": "TUFEN",
    "Marketing Name": "Q86V",
    "Device": "Q86V_EEA",
    "Model": "Q86V"
  },
  {
    "Retail Branding": "TUFEN",
    "Marketing Name": "Q88A_EEA",
    "Device": "Q88A_EEA",
    "Model": "Q88A"
  },
  {
    "Retail Branding": "TUFEN",
    "Marketing Name": "Q88C",
    "Device": "Q88C",
    "Model": "Q88C"
  },
  {
    "Retail Branding": "TUFEN",
    "Marketing Name": "Q88D_FUFEN_EEA",
    "Device": "Q88D_FUFEN_EEA",
    "Model": "Q88D_FUFEN_EEA"
  },
  {
    "Retail Branding": "TUFEN",
    "Marketing Name": "TUFEN_10",
    "Device": "TUFEN_10",
    "Model": "TUFEN_10"
  },
  {
    "Retail Branding": "TUFEN",
    "Marketing Name": "TUFEN_701_EEA",
    "Device": "TUFEN_701_EEA",
    "Model": "TUFEN_701_EEA"
  },
  {
    "Retail Branding": "TUFEN",
    "Marketing Name": "TUFEN_804",
    "Device": "TUFEN_804",
    "Model": "TUFEN_804"
  },
  {
    "Retail Branding": "TUFF",
    "Marketing Name": "T500",
    "Device": "T500",
    "Model": "T500"
  },
  {
    "Retail Branding": "TUNTUN English",
    "Marketing Name": "DREAM PAD",
    "Device": "delight",
    "Model": "ITP-R408W"
  },
  {
    "Retail Branding": "TUPAD",
    "Marketing Name": "TU7_58212_18222",
    "Device": "TU7_58212",
    "Model": "TU7_18222"
  },
  {
    "Retail Branding": "TV Smart",
    "Marketing Name": "TV Smart 4K BOX",
    "Device": "DV8981-KPV",
    "Model": "TV Smart 4K BOX"
  },
  {
    "Retail Branding": "TVB",
    "Marketing Name": "A15",
    "Device": "A151",
    "Model": "A15"
  },
  {
    "Retail Branding": "TVB",
    "Marketing Name": "A20",
    "Device": "A20",
    "Model": "A20"
  },
  {
    "Retail Branding": "TVCore",
    "Marketing Name": "TV Stick",
    "Device": "ts401",
    "Model": "TV Stick"
  },
  {
    "Retail Branding": "TVCore",
    "Marketing Name": "ts401l",
    "Device": "ts401",
    "Model": "TV StickL"
  },
  {
    "Retail Branding": "TVHerYerde",
    "Marketing Name": "KF-1500",
    "Device": "DV8957X-KTT",
    "Model": "KF-1500"
  },
  {
    "Retail Branding": "TVPLUS",
    "Marketing Name": "TV PLUS 4K BOX",
    "Device": "DV6069Y_TVPLUS",
    "Model": "TV PLUS 4K BOX"
  },
  {
    "Retail Branding": "TVPLUS",
    "Marketing Name": "TVPLUS",
    "Device": "HP4CD-TVplus",
    "Model": "HP5432"
  },
  {
    "Retail Branding": "TVPLUS",
    "Marketing Name": "TVPLUS BOX",
    "Device": "HP44H",
    "Model": "TVPLUS BOX"
  },
  {
    "Retail Branding": "TVT(A)",
    "Marketing Name": "TVT-T108",
    "Device": "TVT-T108",
    "Model": "TVT-T108"
  },
  {
    "Retail Branding": "TVUp",
    "Marketing Name": "Denali",
    "Device": "Denali_B866V2F",
    "Model": "Denali"
  },
  {
    "Retail Branding": "TVUp",
    "Marketing Name": "HP5116",
    "Device": "HPA12_8GB",
    "Model": "HP5116"
  },
  {
    "Retail Branding": "TVUp",
    "Marketing Name": "Mediacenter 6G 4K",
    "Device": "SEI300T",
    "Model": "Mediacenter 6G 4K"
  },
  {
    "Retail Branding": "TVision",
    "Marketing Name": "SEI400TM",
    "Device": "SEI400TM",
    "Model": "TVision"
  },
  {
    "Retail Branding": "TVision",
    "Marketing Name": "TVision HUB v2",
    "Device": "SEI700TM",
    "Model": "TVision HUB v2"
  },
  {
    "Retail Branding": "TWOE",
    "Marketing Name": "2E E450A 2018",
    "Device": "E450A2018",
    "Model": "2E E450 2018"
  },
  {
    "Retail Branding": "TWOE",
    "Marketing Name": "E500A_2019",
    "Device": "E500A_2019",
    "Model": "E500A_2019"
  },
  {
    "Retail Branding": "TWOE",
    "Marketing Name": "F534L",
    "Device": "F534L",
    "Model": "F534L"
  },
  {
    "Retail Branding": "TWOE",
    "Marketing Name": "F572L",
    "Device": "F572L",
    "Model": "F572L"
  },
  {
    "Retail Branding": "TWZ Corporation PLC",
    "Marketing Name": 2,
    "Device": 2,
    "Model": 2
  },
  {
    "Retail Branding": "TWZ Corporation PLC",
    "Marketing Name": "OX_X1",
    "Device": "OX_X1",
    "Model": "OX_X1"
  },
  {
    "Retail Branding": "TWZ Corporation PLC",
    "Marketing Name": "T10",
    "Device": "T10",
    "Model": "T10"
  },
  {
    "Retail Branding": "TWZ Corporation PLC",
    "Marketing Name": "T11",
    "Device": "T11",
    "Model": "T11"
  },
  {
    "Retail Branding": "TWZ Corporation PLC",
    "Marketing Name": "T12",
    "Device": "T12",
    "Model": "T12"
  },
  {
    "Retail Branding": "TWZ Corporation PLC",
    "Marketing Name": "Tab-PLAY125",
    "Device": "Tab-PLAY125",
    "Model": "Tab-PLAY125"
  },
  {
    "Retail Branding": "TWZ Corporation PLC",
    "Marketing Name": "U18",
    "Device": "U18",
    "Model": "U18"
  },
  {
    "Retail Branding": "TWZ Corporation PLC",
    "Marketing Name": "V10",
    "Device": "V10",
    "Model": "V10"
  },
  {
    "Retail Branding": "Tabi_by_T_GO",
    "Marketing Name": "EUTB_758G",
    "Device": "EUTB_758G",
    "Model": "EUTB_758G_TABI_Argos_KIDS"
  },
  {
    "Retail Branding": "Tabi_by_T_GO",
    "Marketing Name": "EUTB_758_Argos",
    "Device": "EUTB_758_Argos",
    "Model": "EUTB-758 TABI Argos"
  },
  {
    "Retail Branding": "Tabi_by_T_GO",
    "Marketing Name": "TGO_TB1001_2R",
    "Device": "TGO_TB1001_2R",
    "Model": "TGO_TB1001_2R"
  },
  {
    "Retail Branding": "Tabi_by_T_GO",
    "Marketing Name": "TGO_TB1001_4R",
    "Device": "TGO_TB1001_4R",
    "Model": "TGO_TB1001_4R"
  },
  {
    "Retail Branding": "Tabi_by_T_GO",
    "Marketing Name": "TGO_TB1001_4RO",
    "Device": "TGO_TB1001_4RO",
    "Model": "TGO_TB1001_4RO"
  },
  {
    "Retail Branding": "Tabi_by_T_GO",
    "Marketing Name": "TGO_TB780i",
    "Device": "TGO_TB780i",
    "Model": "TGO_TB780i"
  },
  {
    "Retail Branding": "Tabi_by_T_GO",
    "Marketing Name": "TGO_TB780ik",
    "Device": "TGO_TB780ik",
    "Model": "TGO_TB780ik"
  },
  {
    "Retail Branding": "TabletKiosk",
    "Marketing Name": "TK80",
    "Device": "TK80",
    "Model": "TK80"
  },
  {
    "Retail Branding": "Tablet_PC",
    "Marketing Name": "T3G_07",
    "Device": "T3G_07",
    "Model": "T3G_07"
  },
  {
    "Retail Branding": "Tablet_PC",
    "Marketing Name": "T3G_10B",
    "Device": "T3G_10B",
    "Model": "T3G_10B"
  },
  {
    "Retail Branding": "Tabletop",
    "Marketing Name": "Tabletop_T2",
    "Device": "Tabletop_T2",
    "Model": "Tabletop_T2"
  },
  {
    "Retail Branding": "Tabletop",
    "Marketing Name": "Tabletop_T2_2",
    "Device": "Tabletop_T2_2",
    "Model": "Tabletop_T2_2"
  },
  {
    "Retail Branding": "Tabsera",
    "Marketing Name": "TB8A",
    "Device": "TAE10C10",
    "Model": "TB8A"
  },
  {
    "Retail Branding": "Tagtech",
    "Marketing Name": "TAG-Pluto-TAB",
    "Device": "TAG-Pluto-TAB",
    "Model": "TAG-Pluto-TAB"
  },
  {
    "Retail Branding": "Tagtech",
    "Marketing Name": "TAGPhone",
    "Device": "TAGPhone",
    "Model": "TAGPhone"
  },
  {
    "Retail Branding": "Taipeinet",
    "Marketing Name": "LINKTV01",
    "Device": "HY40A3",
    "Model": "LINKTV01"
  },
  {
    "Retail Branding": "TaiwanMobile",
    "Marketing Name": "A5C",
    "Device": "A5C",
    "Model": "A5C"
  },
  {
    "Retail Branding": "TaiwanMobile",
    "Marketing Name": "A6S",
    "Device": "A6S",
    "Model": "A6S"
  },
  {
    "Retail Branding": "TaiwanMobile",
    "Marketing Name": "Amazing A8",
    "Device": "D78",
    "Model": "Amazing A8"
  },
  {
    "Retail Branding": "TaiwanMobile",
    "Marketing Name": "Amazing X3",
    "Device": "TX3",
    "Model": "Amazing X3"
  },
  {
    "Retail Branding": "TaiwanMobile",
    "Marketing Name": "Amazing_A32",
    "Device": "Amazing_A32",
    "Model": "Amazing_A32"
  },
  {
    "Retail Branding": "TaiwanMobile",
    "Marketing Name": "Amazing_A35",
    "Device": "Amazing_A35",
    "Model": "Amazing_A35"
  },
  {
    "Retail Branding": "TaiwanMobile",
    "Marketing Name": "Amazing_A55",
    "Device": "Amazing_A55",
    "Model": "Amazing_A55"
  },
  {
    "Retail Branding": "TaiwanMobile",
    "Marketing Name": "Amazing_A57",
    "Device": "Amazing_A57",
    "Model": "Amazing_A57"
  },
  {
    "Retail Branding": "Takara",
    "Marketing Name": "MID 107",
    "Device": "MID107",
    "Model": "MID107"
  },
  {
    "Retail Branding": "Takara",
    "Marketing Name": "MID169",
    "Device": "MID169",
    "Model": "MID169"
  },
  {
    "Retail Branding": "Takara",
    "Marketing Name": "MID210",
    "Device": "MID210",
    "Model": "MID210"
  },
  {
    "Retail Branding": "Takara",
    "Marketing Name": "MID225",
    "Device": "MID225",
    "Model": "MID225"
  },
  {
    "Retail Branding": "Talius",
    "Marketing Name": "Zircon_1015",
    "Device": "Zircon_1015",
    "Model": "Zircon_1015"
  },
  {
    "Retail Branding": "Talius",
    "Marketing Name": "Zircon_1016_4G",
    "Device": "Zircon_1016_4G",
    "Model": "Zircon_1016_4G"
  },
  {
    "Retail Branding": "TalkTalk",
    "Marketing Name": "TalkTalk TV",
    "Device": "uzw4054ttg",
    "Model": "TalkTalk STB"
  },
  {
    "Retail Branding": "Tambo",
    "Marketing Name": "Elite 3T",
    "Device": "S6537G",
    "Model": "Elite 3T"
  },
  {
    "Retail Branding": "Tambo",
    "Marketing Name": "Elite 4T",
    "Device": "Elite4T",
    "Model": "Elite 4T"
  },
  {
    "Retail Branding": "Tambo",
    "Marketing Name": "TA-1",
    "Device": "TA-1",
    "Model": "TA-1"
  },
  {
    "Retail Branding": "Tambo",
    "Marketing Name": "TA-10",
    "Device": "TA-10",
    "Model": "TA-10"
  },
  {
    "Retail Branding": "Tambo",
    "Marketing Name": "TA-2",
    "Device": "TA-2",
    "Model": "TA-2"
  },
  {
    "Retail Branding": "Tambo",
    "Marketing Name": "TA-20",
    "Device": "TA-20",
    "Model": "TA-20"
  },
  {
    "Retail Branding": "Tambo",
    "Marketing Name": "TA-2_3G",
    "Device": "TA-2_3G",
    "Model": "TA-2_3G"
  },
  {
    "Retail Branding": "Tambo",
    "Marketing Name": "TA-2_Pro",
    "Device": "TA-2_Pro",
    "Model": "TA-2_Pro"
  },
  {
    "Retail Branding": "Tambo",
    "Marketing Name": "TA-3",
    "Device": "TA-3",
    "Model": "TA-3"
  },
  {
    "Retail Branding": "Tambo",
    "Marketing Name": "TA-4",
    "Device": "TA-4",
    "Model": "TA-4"
  },
  {
    "Retail Branding": "Tambo",
    "Marketing Name": "TA-40",
    "Device": "TA-40",
    "Model": "TA-40"
  },
  {
    "Retail Branding": "Tambo",
    "Marketing Name": "TA-40 3G",
    "Device": "TA-40_3G",
    "Model": "TA-40 3G"
  },
  {
    "Retail Branding": "Tambo",
    "Marketing Name": "TA-45",
    "Device": "TA-45",
    "Model": "TA-45"
  },
  {
    "Retail Branding": "Tambo",
    "Marketing Name": "TA-55_Power",
    "Device": "TA-55_Power",
    "Model": "TA-55_Power"
  },
  {
    "Retail Branding": "Tambo",
    "Marketing Name": "TA-60",
    "Device": "TA-60",
    "Model": "TA-60"
  },
  {
    "Retail Branding": "Tanoshi",
    "Marketing Name": "TTBKB10-01",
    "Device": "TTBKB10-01",
    "Model": "Tanoshi 2-in-1"
  },
  {
    "Retail Branding": "Tanoshi",
    "Marketing Name": "TTBKB10-A1",
    "Device": "TTBKB10-A1",
    "Model": "TTBKB10-A1"
  },
  {
    "Retail Branding": "Tataplay",
    "Marketing Name": "Tata Sky Binge Plus",
    "Device": "usw4026tat",
    "Model": "Tata Sky Binge Plus"
  },
  {
    "Retail Branding": "TazTag",
    "Marketing Name": "TazPad-FAP30",
    "Device": "TazPad-FAP30",
    "Model": "TazPad-FAP30"
  },
  {
    "Retail Branding": "TazTag",
    "Marketing Name": "Tazpad-FAP60",
    "Device": "Tazpad-FAP60",
    "Model": "Tazpad-FAP60"
  },
  {
    "Retail Branding": "Tbltaca",
    "Marketing Name": "KIDS02",
    "Device": "KIDS02",
    "Model": "KIDS02"
  },
  {
    "Retail Branding": "Tbltaca",
    "Marketing Name": "Y108",
    "Device": "Y108",
    "Model": "Y108"
  },
  {
    "Retail Branding": "TeachmintX",
    "Marketing Name": "Teachmint_X_PRO",
    "Device": "75W82B",
    "Model": "TeachmintX_75_Pro"
  },
  {
    "Retail Branding": "Teachmint_X",
    "Marketing Name": "Teachmint_X",
    "Device": "IIP",
    "Model": "Teachmint_X"
  },
  {
    "Retail Branding": "Tech 4u",
    "Marketing Name": "Aqua",
    "Device": "Aqua",
    "Model": "Aqua"
  },
  {
    "Retail Branding": "Tech 4u",
    "Marketing Name": "Earth",
    "Device": "Earth",
    "Model": "Earth"
  },
  {
    "Retail Branding": "Tech 4u",
    "Marketing Name": "Fire",
    "Device": "Fire",
    "Model": "Fire"
  },
  {
    "Retail Branding": "Tech 4u",
    "Marketing Name": "Force",
    "Device": "t592_otd_tech_4u_we",
    "Model": "Force"
  },
  {
    "Retail Branding": "Tech 4u",
    "Marketing Name": "I8",
    "Device": "I8",
    "Model": "I8"
  },
  {
    "Retail Branding": "Tech 4u",
    "Marketing Name": "Prime",
    "Device": "Prime",
    "Model": "Prime"
  },
  {
    "Retail Branding": "Tech 4u",
    "Marketing Name": "Prix",
    "Device": "Prix",
    "Model": "Prix"
  },
  {
    "Retail Branding": "Tech 4u",
    "Marketing Name": "Rocket",
    "Device": "Rocket",
    "Model": "Rocket"
  },
  {
    "Retail Branding": "Tech 4u",
    "Marketing Name": "S8 Pro",
    "Device": "S8_Pro",
    "Model": "S8_Pro"
  },
  {
    "Retail Branding": "Tech 4u",
    "Marketing Name": "Tech4U S8",
    "Device": "S8",
    "Model": "S8"
  },
  {
    "Retail Branding": "Technicolor",
    "Marketing Name": "",
    "Device": "omap4_WT3",
    "Model": "T-Hub2"
  },
  {
    "Retail Branding": "Technicolor",
    "Marketing Name": "Elisa Elamus",
    "Device": "uzw4026ele",
    "Model": "Elisa Elamus"
  },
  {
    "Retail Branding": "Technicolor",
    "Marketing Name": "Euskaltel",
    "Device": "dci765ekt",
    "Model": "cooper"
  },
  {
    "Retail Branding": "Technicolor",
    "Marketing Name": "LMT viedtelevīzijas iekārta",
    "Device": "dwt765lmt",
    "Model": "skipper"
  },
  {
    "Retail Branding": "Technicolor",
    "Marketing Name": "NETBOX",
    "Device": "uiw4030dnm",
    "Model": "pearl"
  },
  {
    "Retail Branding": "Technicolor",
    "Marketing Name": "NETBOX",
    "Device": "uiw4030dnm",
    "Model": "uiw4030dnm"
  },
  {
    "Retail Branding": "Technicolor",
    "Marketing Name": "Shortcut",
    "Device": "dwt765ltt",
    "Model": "Shortcut"
  },
  {
    "Retail Branding": "Technicolor",
    "Marketing Name": "Tv Hub",
    "Device": "uzx8020chm",
    "Model": "Tv Hub"
  },
  {
    "Retail Branding": "Technicolor",
    "Marketing Name": "WOW! Sapphire",
    "Device": "uiw4020wow",
    "Model": "CWM19"
  },
  {
    "Retail Branding": "Technicolor",
    "Marketing Name": "Wind",
    "Device": "uzw4030wnh",
    "Model": "WIND"
  },
  {
    "Retail Branding": "Technicolor",
    "Marketing Name": "Wind",
    "Device": "uzw4030wnh",
    "Model": "Wind"
  },
  {
    "Retail Branding": "Technocrat",
    "Marketing Name": "SC777",
    "Device": "SC777",
    "Model": "SC777"
  },
  {
    "Retail Branding": "Technocrat",
    "Marketing Name": "SC777-F",
    "Device": "SC777-F",
    "Model": "SC777-F"
  },
  {
    "Retail Branding": "Technopc",
    "Marketing Name": "QUANTUM_ZIRCON_11Q801_TR",
    "Device": "QUANTUM_ZIRCON_11Q801",
    "Model": "QUANTUM ZIRCON 11Q801"
  },
  {
    "Retail Branding": "Technopc",
    "Marketing Name": "TM-T10SA",
    "Device": "TM-T10SA",
    "Model": "TM-T10SA"
  },
  {
    "Retail Branding": "Technopc",
    "Marketing Name": "TM-T10SA-V2",
    "Device": "TM-T10SA-V2",
    "Model": "TM-T10SA-V2"
  },
  {
    "Retail Branding": "Technopc",
    "Marketing Name": "UP10S43LA",
    "Device": "Technopc_UP10S43LA",
    "Model": "UP10S43LA"
  },
  {
    "Retail Branding": "Technopc",
    "Marketing Name": "UP10SI36LA",
    "Device": "Technopc_UP10SI36LA",
    "Model": "UP10SI36LA"
  },
  {
    "Retail Branding": "Technopc",
    "Marketing Name": "UP10_SH36LAG",
    "Device": "UP10_SH36LAG",
    "Model": "UP10_SH36LAG"
  },
  {
    "Retail Branding": "Techpad",
    "Marketing Name": "1016S",
    "Device": "1016S",
    "Model": "1016S"
  },
  {
    "Retail Branding": "Techpad",
    "Marketing Name": 1032,
    "Device": 1032,
    "Model": 1032
  },
  {
    "Retail Branding": "Techpad",
    "Marketing Name": "3GR",
    "Device": "Tech_Pad_3GR",
    "Model": "3GR"
  },
  {
    "Retail Branding": "Techpad",
    "Marketing Name": "3G_16",
    "Device": "Tech_Pad_3G16",
    "Model": "3G_16"
  },
  {
    "Retail Branding": "Techpad",
    "Marketing Name": 816,
    "Device": 816,
    "Model": 816
  },
  {
    "Retail Branding": "Techpad",
    "Marketing Name": "GamePad",
    "Device": "GamePad",
    "Model": "GamePad"
  },
  {
    "Retail Branding": "Techpad",
    "Marketing Name": "K13",
    "Device": "K13",
    "Model": "K13"
  },
  {
    "Retail Branding": "Techpad",
    "Marketing Name": "Kids_Pro",
    "Device": "Kids_Pro",
    "Model": "Kids_Pro"
  },
  {
    "Retail Branding": "Techpad",
    "Marketing Name": "M55_4G",
    "Device": "M55_4G",
    "Model": "M55_4G"
  },
  {
    "Retail Branding": "Techpad",
    "Marketing Name": "M5GO",
    "Device": "M5GO",
    "Model": "M5GO"
  },
  {
    "Retail Branding": "Techpad",
    "Marketing Name": "M5Go",
    "Device": "M5Go",
    "Model": "M5Go"
  },
  {
    "Retail Branding": "Techpad",
    "Marketing Name": "M5Plus",
    "Device": "M5Plus",
    "Model": "M5Plus"
  },
  {
    "Retail Branding": "Techpad",
    "Marketing Name": "M6",
    "Device": "M6",
    "Model": "M6"
  },
  {
    "Retail Branding": "Techpad",
    "Marketing Name": "M6 Plus",
    "Device": "M6Plus",
    "Model": "M6Plus"
  },
  {
    "Retail Branding": "Techpad",
    "Marketing Name": "M6Plus",
    "Device": "M6Plus",
    "Model": "M6Plus"
  },
  {
    "Retail Branding": "Techpad",
    "Marketing Name": "NOTE_4CAM",
    "Device": "NOTE_4CAM",
    "Model": "NOTE 4CAM"
  },
  {
    "Retail Branding": "Techpad",
    "Marketing Name": "Note_4CAM",
    "Device": "Note_4CAM_R",
    "Model": "Note_4CAM"
  },
  {
    "Retail Branding": "Techpad",
    "Marketing Name": "R10",
    "Device": "R10",
    "Model": "R10"
  },
  {
    "Retail Branding": "Techpad",
    "Marketing Name": "R11_ULTRA",
    "Device": "R11_ULTRA",
    "Model": "R11_ULTRA"
  },
  {
    "Retail Branding": "Techpad",
    "Marketing Name": "S6",
    "Device": "S6",
    "Model": "S6"
  },
  {
    "Retail Branding": "Techpad",
    "Marketing Name": "S813G",
    "Device": "Tech_Pad_S813G",
    "Model": "S813G"
  },
  {
    "Retail Branding": "Techpad",
    "Marketing Name": "TECHPAD X5",
    "Device": "F518",
    "Model": "Techpad X5"
  },
  {
    "Retail Branding": "Techpad",
    "Marketing Name": "Tech Pad",
    "Device": "816x",
    "Model": "816x"
  },
  {
    "Retail Branding": "Techpad",
    "Marketing Name": "Tech732",
    "Device": "Tech_Pad_732",
    "Model": 732
  },
  {
    "Retail Branding": "Techpad",
    "Marketing Name": "TechPad",
    "Device": "TechPad_916",
    "Model": 916
  },
  {
    "Retail Branding": "Techpad",
    "Marketing Name": "TechPad 10Y",
    "Device": "TechPad_10Y",
    "Model": "TechPad_10Y"
  },
  {
    "Retail Branding": "Techpad",
    "Marketing Name": "TechPad 9x",
    "Device": "TechPad_9x",
    "Model": "TechPad_9x"
  },
  {
    "Retail Branding": "Techpad",
    "Marketing Name": "TechPad M5",
    "Device": "TechPad_M5",
    "Model": "TechPad M5"
  },
  {
    "Retail Branding": "Techpad",
    "Marketing Name": "TechPad_1032",
    "Device": "TechPad_1032",
    "Model": "TechPad_1032"
  },
  {
    "Retail Branding": "Techpad",
    "Marketing Name": "TechPad_1032s",
    "Device": "TechPad_1032s",
    "Model": "TechPad_1032s"
  },
  {
    "Retail Branding": "Techpad",
    "Marketing Name": "TechPad_10Z",
    "Device": "TechPad_10Z",
    "Model": "TechPad_10Z"
  },
  {
    "Retail Branding": "Techpad",
    "Marketing Name": "TechPad_10x",
    "Device": "TechPad_10x",
    "Model": "TechPad_10x"
  },
  {
    "Retail Branding": "Techpad",
    "Marketing Name": "TechPad_10xx",
    "Device": "TechPad_10xx",
    "Model": "TechPad_10xx"
  },
  {
    "Retail Branding": "Techpad",
    "Marketing Name": "TechPad_3Gx",
    "Device": "TechPad_3Gx",
    "Model": "TechPad_3Gx"
  },
  {
    "Retail Branding": "Techpad",
    "Marketing Name": "TechPad_716",
    "Device": "TechPad_716",
    "Model": 716
  },
  {
    "Retail Branding": "Techpad",
    "Marketing Name": "TechPad_i700",
    "Device": "Techpad_i700",
    "Model": "Techpad_i700"
  },
  {
    "Retail Branding": "Techpad",
    "Marketing Name": "Tech_Pad_X10",
    "Device": "Tech_Pad_X10",
    "Model": "Tech Pad X10"
  },
  {
    "Retail Branding": "Techpad",
    "Marketing Name": "Tech_Pad_X10B",
    "Device": "Tech_Pad_X10",
    "Model": "Tech Pad X10"
  },
  {
    "Retail Branding": "Techpad",
    "Marketing Name": "Techpad_864",
    "Device": "Techpad_864",
    "Model": "Techpad_864"
  },
  {
    "Retail Branding": "Techpad",
    "Marketing Name": "Techpad_Kids_7",
    "Device": "Techpad_Kids_7",
    "Model": "Techpad_Kids_7"
  },
  {
    "Retail Branding": "Techpad",
    "Marketing Name": "X11",
    "Device": "X11",
    "Model": "X11"
  },
  {
    "Retail Branding": "Techpad",
    "Marketing Name": "X6",
    "Device": "X6",
    "Model": "X6"
  },
  {
    "Retail Branding": "Techpad",
    "Marketing Name": "X7",
    "Device": "X7",
    "Model": "X7"
  },
  {
    "Retail Branding": "Techpad",
    "Marketing Name": "X9",
    "Device": "X9_PLUS",
    "Model": "X9"
  },
  {
    "Retail Branding": "Techpad",
    "Marketing Name": "Z10",
    "Device": "Z10",
    "Model": "Z10"
  },
  {
    "Retail Branding": "Techpad",
    "Marketing Name": "i700",
    "Device": "i700",
    "Model": "Tech Pad i700"
  },
  {
    "Retail Branding": "Techpad",
    "Marketing Name": "k13pro",
    "Device": "K13pro",
    "Model": "K13pro"
  },
  {
    "Retail Branding": "Techsonic",
    "Marketing Name": "TECHR720W",
    "Device": "TECHR720W",
    "Model": "TECHR720W"
  },
  {
    "Retail Branding": "Techview",
    "Marketing Name": "S1000Pro",
    "Device": "S1000Pro",
    "Model": "S1000Pro"
  },
  {
    "Retail Branding": "Techview",
    "Marketing Name": "S17Pro",
    "Device": "S17Pro",
    "Model": "S17Pro"
  },
  {
    "Retail Branding": "Techview",
    "Marketing Name": "Techview_Tab_80_LTE",
    "Device": "Tab_80_LTE",
    "Model": "Tab_80_LTE"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "APEX_P10HD_PRO",
    "Device": "APEX_P10HD_PRO",
    "Model": "APEX_P10HD_PRO"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "ArtPadAir_EEA",
    "Device": "ArtPadAir",
    "Model": "ArtPadAir_EEA"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "ArtPadAir_ROW",
    "Device": "ArtPadAir",
    "Model": "ArtPadAir_ROW"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "ArtPadPro_EEA",
    "Device": "ArtPadPro_EEA",
    "Model": "ArtPadPro_EEA"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "ArtPadPro_ROW",
    "Device": "ArtPadPro_ROW",
    "Model": "ArtPadPro_ROW"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "M20_4G",
    "Device": "M20_4G",
    "Model": "M20_4G"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "M30_Pro_ROW",
    "Device": "M30_Pro_ROW",
    "Model": "M30_Pro_ROW"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "M40 Pro",
    "Device": "M40_Pro_2022_EEA",
    "Model": "M40 Pro"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "M40 Pro",
    "Device": "M40_Pro_2022_ROW",
    "Model": "M40 Pro"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "M40 Pro",
    "Device": "M40_Pro_2022_RUS",
    "Model": "M40 Pro"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "M40 Pro_EEA",
    "Device": "M40Pro_A_EEA",
    "Model": "M40 Pro_EEA"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "M40 Pro_EEA",
    "Device": "M40Pro_T",
    "Model": "M40 Pro_EEA"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "M40 Pro_ROW",
    "Device": "M40Pro_A_ROW",
    "Model": "M40 Pro_ROW"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "M40 Pro_ROW",
    "Device": "M40Pro_T",
    "Model": "M40 Pro_ROW"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "M40 Pro_RUS",
    "Device": "M40Pro_A_RU",
    "Model": "M40 Pro_RUS"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "M40Air_EEA",
    "Device": "M40Air",
    "Model": "M40Air_EEA"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "M40Air_KR",
    "Device": "M40Air",
    "Model": "M40Air_KR"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "M40Air_ROW",
    "Device": "M40Air",
    "Model": "M40Air_ROW"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "M40Plus_EEA",
    "Device": "M40Plus_EEA",
    "Model": "M40Plus_EEA"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "M40Plus_E_EEA",
    "Device": "M40Plus_E_EEA",
    "Model": "M40Plus_EEA"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "M40Plus_E_ROW",
    "Device": "M40Plus_E_ROW",
    "Model": "M40Plus_ROW"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "M40Plus_ROW",
    "Device": "M40Plus_ROW",
    "Model": "M40Plus_ROW"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "M40Pro_EEA",
    "Device": "M40Pro_EEA",
    "Model": "M40Pro_EEA"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "M40Pro_ROW",
    "Device": "M40Pro_ROW",
    "Model": "M40Pro_ROW"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "M40Pro_RUS",
    "Device": "M40Pro_RUS",
    "Model": "M40Pro_RUS"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "M40SE_EEA",
    "Device": "M40SE",
    "Model": "M40SE_EEA"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "M40SE_ROW",
    "Device": "M40SE",
    "Model": "M40SE"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "M40SE_ROW",
    "Device": "M40SE",
    "Model": "M40SE_ROW"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "M40SE_Y_EEA",
    "Device": "M40SE_Y_EEA",
    "Model": "M40SE"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "M40SE_Y_ROW",
    "Device": "M40SE_Y_ROW",
    "Model": "M40SE"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "M40_EEA",
    "Device": "M40_EEA",
    "Model": "M40_EEA"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "M40_Plus_EEA",
    "Device": "M40_Plus_EEA",
    "Model": "M40_Plus_EEA"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "M40_Plus_ROW",
    "Device": "M40_Plus_ROW",
    "Model": "M40_Plus_ROW"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "M40_ROW",
    "Device": "M40_ROW",
    "Model": "M40_ROW"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "M50-EEA",
    "Device": "M50-EEA",
    "Model": "M50"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "M50-EEA",
    "Device": "M50-EEA",
    "Model": "M50-EEA"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "M50-ROW",
    "Device": "M50-ROW",
    "Model": "M50"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "M50-ROW",
    "Device": "M50-ROW",
    "Model": "M50-ROW"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "M50HD_EEA",
    "Device": "M50HD_EEA",
    "Model": "M50HD"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "M50HD_EEA",
    "Device": "M50HD_EEA",
    "Model": "M50HD_EEA"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "M50HD_EEA",
    "Device": "M50HD_T",
    "Model": "M50HD_EEA"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "M50HD_ROW",
    "Device": "M50HD_ROW",
    "Model": "M50HD"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "M50HD_ROW",
    "Device": "M50HD_ROW",
    "Model": "M50HD_ROW"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "M50HD_ROW",
    "Device": "M50HD_T",
    "Model": "M50HD_ROW"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "M50HD_RUS",
    "Device": "M50HD_RUS",
    "Model": "M50HD_RUS"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "M50Mini_EEA",
    "Device": "M50Mini_EEA",
    "Model": "M50Mini"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "M50Mini_ROW",
    "Device": "M50Mini_ROW",
    "Model": "M50Mini"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "M50Mini_W_EEA",
    "Device": "M50Mini_W_EEA",
    "Model": "M50Mini"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "M50Mini_W_ROW",
    "Device": "M50Mini_W_ROW",
    "Model": "M50Mini"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "M50Plus_EEA",
    "Device": "M50Plus",
    "Model": "M50Plus_EEA"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "M50Plus_EEA",
    "Device": "M50Plus_EEA",
    "Model": "M50Plus"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "M50Plus_ROW",
    "Device": "M50Plus",
    "Model": "M50Plus_ROW"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "M50Plus_ROW",
    "Device": "M50Plus_ROW",
    "Model": "M50Plus"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "M50Pro_EEA",
    "Device": "M50Pro_EEA",
    "Model": "M50 Pro"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "M50Pro_ROW",
    "Device": "M50Pro_ROW",
    "Model": "M50 Pro"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "M50Pro_RUS",
    "Device": "M50Pro_RUS",
    "Model": "M50 Pro_RUS"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "M50S_EEA",
    "Device": "M50S_EEA",
    "Model": "M50S"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "M50S_ROW",
    "Device": "M50S_ROW",
    "Model": "M50S"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "M50_EEA",
    "Device": "M50_T",
    "Model": "M50_EEA"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "M50_EU",
    "Device": "M50_EU",
    "Model": "M50"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "M50_EU",
    "Device": "M50_EU",
    "Model": "M50_EU"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "M50_ROW",
    "Device": "M50_ROW",
    "Model": "M50"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "M50_ROW",
    "Device": "M50_ROW",
    "Model": "M50_ROW"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "M50_ROW",
    "Device": "M50_T",
    "Model": "M50_ROW"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "M50_RUS",
    "Device": "M50_RUS",
    "Model": "M50_RUS"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "M50mini_ROW",
    "Device": "M50mini",
    "Model": "M50mini_ROW"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "P10HD_N5H6",
    "Device": "P10S_ROW",
    "Model": "P10S_ROW"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "P10SE_EEA",
    "Device": "P10SE_EEA",
    "Model": "P10SE_EEA"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "P10SE_ROW",
    "Device": "P10SE_ROW",
    "Model": "P10SE_ROW"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "P10S_EEA",
    "Device": "P10S_EEA",
    "Model": "P10S_EEA"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "P10S_ROW",
    "Device": "P10S_ROW",
    "Model": "P10S_ROW"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "P10_HD_EEA",
    "Device": "P10_HD_EEA",
    "Model": "P10_HD_EEA"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "P10_HD_ROW",
    "Device": "P10_HD_ROW",
    "Model": "P10_HD_ROW"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "P20HD_EEA",
    "Device": "P20HD_EEA",
    "Model": "P20HD_EEA"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "P20HD_Pro_EEA",
    "Device": "P20HD_Pro_EEA",
    "Model": "P20HD"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "P20HD_Pro_ROW",
    "Device": "P20HD_Pro_ROW",
    "Model": "P20HD"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "P20HD_Pro_RUS",
    "Device": "P20HD_Pro_RUS",
    "Model": "P20HD"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "P20HD_ROW",
    "Device": "P20HD_ROW",
    "Model": "P20HD_ROW"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "P20HD_RUS",
    "Device": "P20HD_RUS",
    "Model": "P20HD_RUS"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "P20S_EEA",
    "Device": "P20S_EEA",
    "Model": "P20S_EEA"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "P20S_ROW",
    "Device": "P20S_ROW",
    "Model": "P20S_ROW"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "P20_EEA",
    "Device": "P20_EEA",
    "Model": "P20_EEA"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "P20_ROW",
    "Device": "P20_ROW",
    "Model": "P20_ROW"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "P20_RUS",
    "Device": "P20_RUS",
    "Model": "P20_RUS"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "P25T_Y_EEA",
    "Device": "P25T_Y_EEA",
    "Model": "P25T"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "P25T_Y_ROW",
    "Device": "P25T_Y_ROW",
    "Model": "P25T"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "P25T_Y_RUS",
    "Device": "P25T_Y_RUS",
    "Model": "P25T"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "P25_EEA",
    "Device": "P25_EEA",
    "Model": "P25_EEA"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "P25_ROW",
    "Device": "P25_ROW",
    "Model": "P25_ROW"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "P25_RUS",
    "Device": "P25_RUS",
    "Model": "P25_RUS"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "P25_T_EEA",
    "Device": "P25_T",
    "Model": "P25_T_EEA"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "P25_T_ROW",
    "Device": "P25_T",
    "Model": "P25_T_ROW"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "P26T_EEA",
    "Device": "P26T",
    "Model": "P26T_EEA"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "P26T_ROW",
    "Device": "P26T",
    "Model": "P26T_ROW"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "P30Air_EEA",
    "Device": "P30Air_EEA",
    "Model": "P30Air_EEA"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "P30Air_KR",
    "Device": "P30Air",
    "Model": "P30Air_KR"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "P30Air_ROW",
    "Device": "P30Air_ROW",
    "Model": "P30Air_ROW"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "P30HD",
    "Device": "P30HD",
    "Model": "P30HD"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "P30HD",
    "Device": "P30HD",
    "Model": "P30HD_EEA"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "P30HD_ROW",
    "Device": "P30HD",
    "Model": "P30HD"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "P30HD_ROW",
    "Device": "P30HD",
    "Model": "P30HD_ROW"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "P30HD_RU",
    "Device": "P30HD",
    "Model": "P30HD"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "P30S_EEA",
    "Device": "P30S_EEA",
    "Model": "P30S_EEA"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "P30S_ROW",
    "Device": "P30S_ROW",
    "Model": "P30S_ROW"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "P30S_W_EEA",
    "Device": "P30S_W_EEA",
    "Model": "P30S_W_EEA"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "P30S_W_ROW",
    "Device": "P30S_W_ROW",
    "Model": "P30S_W_ROW"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "P30T_EEA",
    "Device": "P30T",
    "Model": "P30T"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "P30T_EEA",
    "Device": "P30T_B",
    "Model": "P30T"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "P30T_EEA",
    "Device": "P30T_B",
    "Model": "P30T_EEA"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "P30T_EEA",
    "Device": "P30T_EEA",
    "Model": "P30T"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "P30T_EEA",
    "Device": "P30T_EEA",
    "Model": "P30T_EEA"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "P30T_ROW",
    "Device": "P30T",
    "Model": "P30T"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "P30T_ROW",
    "Device": "P30T_B",
    "Model": "P30T"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "P30T_ROW",
    "Device": "P30T_B",
    "Model": "P30T_ROW"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "P30T_ROW",
    "Device": "P30T_ROW",
    "Model": "P30T"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "P30T_ROW",
    "Device": "P30T_ROW",
    "Model": "P30T_ROW"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "P30T_Y_EEA",
    "Device": "P30T_Y",
    "Model": "P30T_Y"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "P30T_Y_ROW",
    "Device": "P30T_Y",
    "Model": "P30T"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "P30T_Y_ROW",
    "Device": "P30T_Y",
    "Model": "P30T_Y"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "P30T_Y_RUS",
    "Device": "P30T_Y",
    "Model": "P30T_Y"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "P30_EEA",
    "Device": "P30",
    "Model": "P30"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "P30_EEA",
    "Device": "P30_B",
    "Model": "P30"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "P30_EEA",
    "Device": "P30_B",
    "Model": "P30_EEA"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "P30_EEA",
    "Device": "P30_EEA",
    "Model": "P30"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "P30_EEA",
    "Device": "P30_EEA",
    "Model": "P30_EEA"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "P30_ROW",
    "Device": "P30",
    "Model": "P30"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "P30_ROW",
    "Device": "P30",
    "Model": "P30_ROW"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "P30_ROW",
    "Device": "P30_B",
    "Model": "P30"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "P30_ROW",
    "Device": "P30_B",
    "Model": "P30_ROW"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "P30_ROW",
    "Device": "P30_B",
    "Model": "bnd"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "P30_ROW",
    "Device": "P30_ROW",
    "Model": "P30"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "P30_ROW",
    "Device": "P30_ROW",
    "Model": "P30_ROW"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "P30_RUS",
    "Device": "P30_RUS",
    "Model": "P30_RUS"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "P33_EEA",
    "Device": "P33_EEA",
    "Model": "P33_EEA"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "P33_ROW",
    "Device": "P33_ROW",
    "Model": "P33_ROW"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "P40HD_EEA",
    "Device": "P40HD_EEA",
    "Model": "P40HD"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "P40HD_EEA",
    "Device": "P40HD_T",
    "Model": "P40HD_EEA"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "P40HD_ROW",
    "Device": "P40HD_ROW",
    "Model": "P40HD"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "P40HD_ROW",
    "Device": "P40HD_T",
    "Model": "P40HD_ROW"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "P40HD_RUS",
    "Device": "P40HD_RUS",
    "Model": "P40HD"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "P40HD_T_EEA",
    "Device": "P40HD_T_EEA",
    "Model": "P40HD_T_EEA"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "P40HD_T_ROW",
    "Device": "P40HD_T_ROW",
    "Model": "P40HD_T_ROW"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "P40HD_T_RUS",
    "Device": "P40HD_T_RUS",
    "Model": "P40HD_RUS"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "P50Ai_EEA",
    "Device": "P50Ai",
    "Model": "P50Ai_EEA"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "P50Ai_ROW",
    "Device": "P50Ai",
    "Model": "P50Ai_ROW"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "P50Case",
    "Device": "P50Case",
    "Model": "N868"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "P50Case",
    "Device": "P50Case",
    "Model": "P50Case"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "P50Case",
    "Device": "P50Case",
    "Model": "P50Case_ROW"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "P50Case_EEA",
    "Device": "P50Case",
    "Model": "P50Case"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "P50Case_EEA",
    "Device": "P50Case",
    "Model": "P50Case_EEA"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "P50Mini_EEA",
    "Device": "P50Mini_EEA",
    "Model": "P50Mini"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "P50Mini_EEA",
    "Device": "P50Mini_EEA",
    "Model": "P50Mini_EEA"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "P50Mini_ROW",
    "Device": "P50Mini_ROW",
    "Model": "P50Mini"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "P50Mini_ROW",
    "Device": "P50Mini_ROW",
    "Model": "P50Mini_ROW"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "P50S_EEA",
    "Device": "P50S_EEA",
    "Model": "P50S"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "P50S_ROW",
    "Device": "P50S_ROW",
    "Model": "P50S"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "P50T_E_ROW",
    "Device": "P50T_E",
    "Model": "P50T_E_ROW"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "P50_B_EEA",
    "Device": "P50_B_EEA",
    "Model": "P50"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "P50_B_EEA",
    "Device": "P50_B_EEA",
    "Model": "P50_B"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "P50_B_EEA",
    "Device": "P50_B_EEA",
    "Model": "P50_B_EEA"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "P50_EEA",
    "Device": "P50",
    "Model": "P50_EEA"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "P50_EEA",
    "Device": "P50_EEA",
    "Model": "P50"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "P50_ROW",
    "Device": "P50",
    "Model": "P50_ROW"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "P50_ROW",
    "Device": "P50_ROW",
    "Model": "P50"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "P80T_EEA",
    "Device": "P80T",
    "Model": "P80T_EEA"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "P80T_ROW",
    "Device": "P80T",
    "Model": "P80T_ROW"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "P80T_Y_EEA",
    "Device": "P80T_Y_EEA",
    "Model": "P80T_EEA"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "P80T_Y_ROW",
    "Device": "P80T_Y_ROW",
    "Model": "P80T_ROW"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "P80T_Y_RUS",
    "Device": "P80T_Y_RUS",
    "Model": "P80T_RUS"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "P80X",
    "Device": "P80X",
    "Model": "P80X"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "P80X_EEA",
    "Device": "P80X",
    "Model": "P80X"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "P80X_EEA",
    "Device": "P80X",
    "Model": "P80X_EEA"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "P80_EEA",
    "Device": "P80",
    "Model": "P80_EEA"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "P80_EEA",
    "Device": "P80_EEA",
    "Model": "P80_EEA"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "P80_EEA",
    "Device": "P80_G3M2_EEA",
    "Model": "P80_EEA"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "P80_KOR",
    "Device": "P80_KOR",
    "Model": "P80_KOR"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "P80_ROW",
    "Device": "P80",
    "Model": "P80_ROW"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "P80_ROW",
    "Device": "P80_G3M2_ROW",
    "Model": "P80_ROW"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "P80_ROW",
    "Device": "P80_ROW",
    "Model": "P80_ROW"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "P80h_EEA",
    "Device": "P80h_EEA",
    "Model": "P80h_EEA"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "P80h_KR",
    "Device": "P80h_KR",
    "Model": "P80h_KR"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "P80h_ROW",
    "Device": "P80h_ROW",
    "Model": "P80h_ROW"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "P85Kids_ROW",
    "Device": "P85Kids_ROW",
    "Model": "P85Kids_ROW"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "P85Pro_EEA",
    "Device": "P85Pro_EEA",
    "Model": "P85Pro_EEA"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "P85Pro_ROW",
    "Device": "P85Pro_ROW",
    "Model": "P85Pro_ROW"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "P85T_EEA",
    "Device": "P85T",
    "Model": "P85T_EEA"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "P85T_ROW",
    "Device": "P85T",
    "Model": "P85T_ROW"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "P85_B_EEA",
    "Device": "P85_B_EEA",
    "Model": "P85_B_EEA"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "P85_B_EEA",
    "Device": "P85_B_EEA",
    "Model": "P85_EEA"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "P85_B_ROW",
    "Device": "P85_B_ROW",
    "Model": "P85_B_ROW"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "P85_B_ROW",
    "Device": "P85_B_ROW",
    "Model": "P85_ROW"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "P85_EEA",
    "Device": "P85_EEA",
    "Model": "P85_EEA"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "P85_ROW",
    "Device": "P85_ROW",
    "Model": "P85_ROW"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "P85_RUS",
    "Device": "P85_RUS",
    "Model": "P85_RUS"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "T30_EEA",
    "Device": "T30",
    "Model": "T30_EEA"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "T30_ROW",
    "Device": "T30",
    "Model": "T30_ROW"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "T30_RU",
    "Device": "T30",
    "Model": "T30_RU"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "T40",
    "Device": "T40",
    "Model": "TLA001"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "T40 Pro_EEA",
    "Device": "T40Pro_A",
    "Model": "T40 Pro_EEA"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "T40 Pro_EEA",
    "Device": "T40Pro_T",
    "Model": "T40 Pro_EEA"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "T40 Pro_ROW",
    "Device": "T40Pro_A",
    "Model": "T40 Pro_ROW"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "T40 Pro_ROW",
    "Device": "T40Pro_T",
    "Model": "T40 Pro_ROW"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "T40 Pro_RUS",
    "Device": "T40Pro_A",
    "Model": "T40 Pro_RUS"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "T40Air_EEA",
    "Device": "T40Air",
    "Model": "T40Air_EEA"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "T40Air_EEA",
    "Device": "T40Air_EEA",
    "Model": "T40 Air"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "T40Air_EEA",
    "Device": "T40Air_EEA",
    "Model": "T40 Air_EEA"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "T40Air_ROW",
    "Device": "T40Air_ROW",
    "Model": "T40 Air"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "T40Air_RUS",
    "Device": "T40Air_RUS",
    "Model": "T40Air_RUS"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "T40HD_EEA",
    "Device": "T40HD_EEA",
    "Model": "T40HD"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "T40HD_EEA",
    "Device": "T40HD_EEA",
    "Model": "T40HD_EEA"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "T40HD_EEA",
    "Device": "T40HD_T",
    "Model": "T40HD_EEA"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "T40HD_ROW",
    "Device": "T40HD_ROW",
    "Model": "T40HD"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "T40HD_ROW",
    "Device": "T40HD_ROW",
    "Model": "T40HD_ROW"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "T40HD_ROW",
    "Device": "T40HD_T",
    "Model": "T40HD_ROW"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "T40HD_RUS",
    "Device": "T40HD_RUS",
    "Model": "T40HD_RUS"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "T40Pro",
    "Device": "Teclast_T40Pro",
    "Model": "T40 PRO_ROW"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "T40Pro",
    "Device": "Teclast_T40Pro",
    "Model": "T40Pro"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "T40Pro_2022_EEA",
    "Device": "T40Pro_2022_EEA",
    "Model": "T40 Pro"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "T40Pro_2022_ROW",
    "Device": "T40Pro_2022_ROW",
    "Model": "T40 Pro"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "T40Pro_2022_RUS",
    "Device": "T40Pro_2022_RUS",
    "Model": "T40 Pro"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "T40Pro_EA",
    "Device": "Teclast_T40Pro_EA",
    "Model": "T40Pro"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "T40Pro_EEA",
    "Device": "T40Pro_EEA",
    "Model": "T40Pro_EEA"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "T40Pro_M_EEA",
    "Device": "T40Pro_M_EEA",
    "Model": "T40Pro_M_EEA"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "T40Pro_M_ROW",
    "Device": "T40Pro_M_ROW",
    "Model": "T40Pro_M_ROW"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "T40Pro_ROW",
    "Device": "T40Pro_ROW",
    "Model": "T40Pro_ROW"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "T40Pro_RU",
    "Device": "Teclast_T40Pro_RU",
    "Model": "T40Pro"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "T40Pro_RUS",
    "Device": "T40Pro_RUS",
    "Model": "T40Pro_RUS"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "T40Pro_YKM_EEA",
    "Device": "T40Pro_YKM_EEA",
    "Model": "T40Pro_YKM_EEA"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "T40Pro_YKM_ROW",
    "Device": "T40Pro_YKM_ROW",
    "Model": "T40Pro_YKM_ROW"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "T40Pro_YKM_RUS",
    "Device": "T40Pro_YKM_RUS",
    "Model": "T40Pro_YKM_RUS"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "T40_Plus_EEA",
    "Device": "T40_Plus_EEA",
    "Model": "T40_Plus_EEA"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "T40_Plus_ROW",
    "Device": "T40_Plus_ROW",
    "Model": "T40_Plus_ROW"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "T40_Plus_RUS",
    "Device": "T40_Plus_RUS",
    "Model": "T40_Plus_RUS"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "T40_Pro_W_EEA",
    "Device": "T40_Pro_W_EEA",
    "Model": "T40_Pro_W_EEA"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "T40_Pro_W_ROW",
    "Device": "T40_Pro_W_ROW",
    "Model": "T40_Pro_W_ROW"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "T40_ROW",
    "Device": "T40",
    "Model": "TLA001"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "T45HD_EEA",
    "Device": "T45HD_EEA",
    "Model": "T45HD"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "T45HD_EEA",
    "Device": "T45HD_T",
    "Model": "T45HD_EEA"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "T45HD_ROW",
    "Device": "T45HD_ROW",
    "Model": "T45HD"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "T45HD_ROW",
    "Device": "T45HD_T",
    "Model": "T45HD_ROW"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "T45HD_RUS",
    "Device": "T45HD_RUS",
    "Model": "T45HD_RUS"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "T50",
    "Device": "Teclast_T50_EEA",
    "Model": "T50"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "T50",
    "Device": "Teclast_T50_ROW",
    "Model": "T50"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "T50",
    "Device": "Teclast_T50_RUS",
    "Model": "T50"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "T50Air_EEA",
    "Device": "T50Air",
    "Model": "T50Air_EEA"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "T50HD_EEA",
    "Device": "T50HD",
    "Model": "T50HD_EEA"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "T50HD_EEA",
    "Device": "T50HD_EEA",
    "Model": "T50HD"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "T50HD_ROW",
    "Device": "T50HD",
    "Model": "T50HD_ROW"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "T50HD_ROW",
    "Device": "T50HD_ROW",
    "Model": "T50HD"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "T50Max_EEA",
    "Device": "T50Max_EEA",
    "Model": "T50Max_EEA"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "T50Max_ROW",
    "Device": "T50Max_ROW",
    "Model": "T50Max_ROW"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "T50Mini_A_EEA",
    "Device": "T50Mini_A_EEA",
    "Model": "T50Mini_A_EEA"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "T50Mini_A_ROW",
    "Device": "T50Mini_A_ROW",
    "Model": "T50Mini_A_ROW"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "T50Mini_EEA",
    "Device": "T50Mini_EEA",
    "Model": "T50Mini_EEA"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "T50Plus_E_EEA",
    "Device": "T50Plus_E",
    "Model": "T50Plus_E_EEA"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "T50Pro_W_EEA",
    "Device": "T50Pro_W_EEA",
    "Model": "T50Pro_W_EEA"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "T50Pro_W_ROW",
    "Device": "T50Pro_W_ROW",
    "Model": "T50Pro_W_ROW"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "T50_2022_EEA",
    "Device": "T50_2022_EEA",
    "Model": "T50_EEA"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "T50_2022_ROW",
    "Device": "T50_2022_ROW",
    "Model": "T50_ROW"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "T50_2022_RUS",
    "Device": "T50_2022_RUS",
    "Model": "T50_RUS"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "T50_EEA",
    "Device": "T50_T",
    "Model": "T50_EEA"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "T50_ROW",
    "Device": "T50_T",
    "Model": "T50_ROW"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "T50_Y_EEA",
    "Device": "T50_Y_EEA",
    "Model": "T50"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "T50_Y_EEA",
    "Device": "T50_Y_EEA",
    "Model": "T50_Y_EEA"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "T50_Y_ROW",
    "Device": "T50_Y_ROW",
    "Model": "T50"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "T50_Y_ROW",
    "Device": "T50_Y_ROW",
    "Model": "T50_Y_ROW"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "T50_Y_RUS",
    "Device": "T50_Y_RUS",
    "Model": "T50_Y_RUS"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "T60",
    "Device": "T60",
    "Model": "T60"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "T60-EEA",
    "Device": "T60-EEA",
    "Model": "T60"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "T60-ROW",
    "Device": "T60-ROW",
    "Model": "T60"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "T60Ai_EEA",
    "Device": "T60Ai",
    "Model": "T60Ai_EEA"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "T60Ai_ROW",
    "Device": "T60Ai",
    "Model": "T60Ai_ROW"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "T60Plus_EEA",
    "Device": "T60Plus_EEA",
    "Model": "T60Plus_EEA"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "T60Plus_ROW",
    "Device": "T60Plus_ROW",
    "Model": "T60Plus_ROW"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "T60Pro_A_ROW",
    "Device": "T60Pro_A_ROW",
    "Model": "T60Pro_A_EEA"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "T60_EEA",
    "Device": "T60_EEA",
    "Model": "T60"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "T60_EEA",
    "Device": "T60_EEA",
    "Model": "T60_EEA"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "T60_ROW",
    "Device": "T60_ROW",
    "Model": "T60"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "T60_RUS",
    "Device": "T60_RUS",
    "Model": "T60_RUS"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "T65Max_A_EEA",
    "Device": "T65Max_A_EEA",
    "Model": "T65Max_A_EEA"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "T65Max_A_ROW",
    "Device": "T65Max_A_ROW",
    "Model": "T65Max_A_ROW"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "T65Max_EEA",
    "Device": "T65Max_EEA",
    "Model": "T65Max_EEA"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "T65Max_ROW",
    "Device": "T65Max_ROW",
    "Model": "T65Max_ROW"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "T65Plus_EEA",
    "Device": "T65Plus_EEA",
    "Model": "T65Plus_EEA"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "T65Plus_ROW",
    "Device": "T65Plus_ROW",
    "Model": "T65Plus_EEA"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "T65Plus_ROW",
    "Device": "T65Plus_ROW",
    "Model": "T65Plus_ROW"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "T65_A5D8",
    "Device": "T65_A5D8",
    "Model": "T65_A5D8"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "T65_EEA",
    "Device": "T65",
    "Model": "T65_EEA"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "T65_L_ROW",
    "Device": "T65_L",
    "Model": "T65_L_ROW"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "T65_ROW",
    "Device": "T65",
    "Model": "T65_ROW"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "T70_EEA",
    "Device": "T70_EEA",
    "Model": "T70_EEA"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "T70_E_ROW",
    "Device": "T70_E",
    "Model": "T70_E_ROW"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "T70_ROW",
    "Device": "T70_ROW",
    "Model": "T70_ROW"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "T70_T_EEA",
    "Device": "T70",
    "Model": "T70_T_EEA"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "T8",
    "Device": "T8",
    "Model": "T8"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "TLG01_EEA",
    "Device": "TLG01_EEA",
    "Model": "TLG01_EEA"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "TLG01_ROW",
    "Device": "TLG01_ROW",
    "Model": "TLG01_ROW"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "X_EEA",
    "Device": "X_EEA",
    "Model": "X_EEA"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "X_ROW",
    "Device": "X_ROW",
    "Model": "X_ROW"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "ssaemyo-inuriTab",
    "Device": "P10S_ROW",
    "Model": "P10S_ROW"
  },
  {
    "Retail Branding": "Teclast",
    "Marketing Name": "tPad8",
    "Device": "tPad8",
    "Model": "tPad8"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "5S",
    "Device": "TECNO-A571LS",
    "Model": "TECNO A571LS"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "A7S",
    "Device": "TECNO-A7S",
    "Model": "TECNO-A7S"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "C5",
    "Device": "TECNO-C5",
    "Model": "TECNO-C5"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "C7",
    "Device": "TECNO-C7",
    "Model": "TECNO-C7"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "C8",
    "Device": "TECNO-C8",
    "Model": "TECNO-C8"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "C9",
    "Device": "TECNO-C9",
    "Model": "TECNO-C9"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "C9S",
    "Device": "TECNO-C9",
    "Model": "TECNO-C9S"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "CAMON",
    "Device": "TECNO-CE7j",
    "Model": "TECNO CE7j"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "CAMON",
    "Device": "TECNO-CG6",
    "Model": "TECNO CG6"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "CAMON",
    "Device": "TECNO-CG7",
    "Model": "TECNO CG7"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "CAMON",
    "Device": "TECNO-CH6h",
    "Model": "TECNO CH6h"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "CAMON 11",
    "Device": "TECNO-CF7",
    "Model": "TECNO CF7"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "CAMON 11",
    "Device": "TECNO-CF7",
    "Model": "TECNO CF7S"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "CAMON 11",
    "Device": "TECNO-CF7k",
    "Model": "TECNO CF7k"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "CAMON 11 Pro",
    "Device": "TECNO-CF8",
    "Model": "TECNO CF8"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "CAMON 12",
    "Device": "TECNO-CC7",
    "Model": "TECNO CC7"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "CAMON 12",
    "Device": "TECNO-CC7S",
    "Model": "TECNO CC7S"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "CAMON 12 Air",
    "Device": "TECNO-CC6",
    "Model": "TECNO CC6"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "CAMON 15 Air",
    "Device": "TECNO-CD6",
    "Model": "TECNO CD6"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "CAMON 15 Air",
    "Device": "TECNO-CD6",
    "Model": "TECNO CD6S"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "CAMON 15 Premier",
    "Device": "TECNO-CD8j",
    "Model": "TECNO CD8j"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "CAMON 15 Pro",
    "Device": "TECNO-CD8",
    "Model": "TECNO CD8"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "CAMON 16",
    "Device": "TECNO-CE7",
    "Model": "TECNO CE7"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "CAMON 16",
    "Device": "TECNO-CE7j",
    "Model": "TECNO CE7j"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "CAMON 16 Pro",
    "Device": "TECNO-CE8",
    "Model": "TECNO CE8"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "CAMON 16 S",
    "Device": "TECNO-CD6j",
    "Model": "TECNO CD6j"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "CAMON 17",
    "Device": "TECNO-CG6j",
    "Model": "TECNO CG6j"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "CAMON 17 Pro",
    "Device": "TECNO-CG8",
    "Model": "TECNO CG8"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "CAMON 17 Pro",
    "Device": "TECNO-CG8h",
    "Model": "TECNO CG8h"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "CAMON 17P",
    "Device": "TECNO-CG7",
    "Model": "TECNO CG7"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "CAMON 17P",
    "Device": "TECNO-CG7n",
    "Model": "TECNO CG7n"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "CAMON 18",
    "Device": "TECNO-CH6",
    "Model": "TECNO CH6"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "CAMON 18",
    "Device": "TECNO-CH6n",
    "Model": "TECNO CH6n"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "CAMON 18",
    "Device": "TECNO-Mobile-CH6n",
    "Model": "TECNO Mobile CH6n"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "CAMON 18P",
    "Device": "TECNO-CH7",
    "Model": "TECNO CH7"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "CAMON 18P",
    "Device": "TECNO-CH7n",
    "Model": "TECNO CH7n"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "CAMON 19",
    "Device": "TECNO-CI6",
    "Model": "TECNO CI6"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "CAMON 19",
    "Device": "TECNO-CI6n",
    "Model": "TECNO CI6n"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "CAMON 19",
    "Device": "TECNO-Mobile-CI6n",
    "Model": "TECNO Mobile CI6n"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "CAMON 19 Pro",
    "Device": "TECNO-CI8",
    "Model": "TECNO CI8"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "CAMON 19 Pro",
    "Device": "TECNO-CI8n",
    "Model": "TECNO CI8n"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "CAMON 19 Pro 5G",
    "Device": "TECNO-CI7n",
    "Model": "TECNO CI7n"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "CAMON 20 Pro",
    "Device": "TECNO-CK7n",
    "Model": "TECNO CK7n"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "CAMON 20 Pro 5G",
    "Device": "TECNO-CK8n",
    "Model": "TECNO CK8n"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "CAMON C7",
    "Device": "TECNO-C7",
    "Model": "TECNO-C7"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "CAMON CM",
    "Device": "TECNO-CA6",
    "Model": "TECNO CA6"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "CAMON I Ace",
    "Device": "TECNO-IN1",
    "Model": "TECNO IN1"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "CAMON X",
    "Device": "TECNO-CA7",
    "Model": "TECNO CA7"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "CAMON X Pro",
    "Device": "TECNO-CA8",
    "Model": "TECNO CA8"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "CAMON X Pro",
    "Device": "TECNO-CA8",
    "Model": "TECNO CA8S"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "CAMON i 2",
    "Device": "TECNO-ID5a",
    "Model": "TECNO ID5a"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "CAMON i 2X",
    "Device": "TECNO-ID5b",
    "Model": "TECNO ID5b"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "CAMON i 4",
    "Device": "TECNO-CB7",
    "Model": "TECNO CB7"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "CAMON i 4",
    "Device": "TECNO-CB7j",
    "Model": "TECNO CB7j"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "CAMON i SKY3",
    "Device": "TECNO-KB3",
    "Model": "TECNO KB3"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "CAMON i2",
    "Device": "TECNO-ID5",
    "Model": "TECNO ID5"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "CAMON iAIR 2+",
    "Device": "TECNO-ID3k",
    "Model": "TECNO ID3k"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "CAMON iCLICK 2",
    "Device": "TECNO-ID6",
    "Model": "TECNO ID6"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "CAMON iClick",
    "Device": "TECNO-IN6",
    "Model": "TECNO IN6"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "CAMON iSky",
    "Device": "TECNO-IN2",
    "Model": "TECNO IN2"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "CAMON iSky2",
    "Device": "TECNO-IN1-Pro",
    "Model": "TECNO IN1 Pro"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "COMAN CM",
    "Device": "TECNO-CA6",
    "Model": "TECNO CA6S"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "Camon 11S",
    "Device": "TECNO-CB7",
    "Model": "TECNO CB7"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "Camon C9",
    "Device": "TECNO-C9",
    "Model": "TECNO-C9"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "Camon CX",
    "Device": "TECNO-CX",
    "Model": "TECNO Camon CX"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "Camon CX Air",
    "Device": "TECNO-CX-Air",
    "Model": "TECNO CX Air"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "Camon CXS",
    "Device": "TECNO-CX",
    "Model": "TECNO Camon CXS"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "Camon I",
    "Device": "TECNO-IN5",
    "Model": "TECNO IN5"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "Camon I Air",
    "Device": "TECNO-IN3",
    "Model": "TECNO IN3"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "Camon i Twin",
    "Device": "TECNO-IA5",
    "Model": "TECNO IA5"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "DP10APro-SLA1",
    "Device": "DP10APro",
    "Model": "DP10APro"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "DP7CPro-SGA1",
    "Device": "DP7CPro-SGA1",
    "Model": "DP7CPro-SGA1"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "DroiPad 10 ProⅡ",
    "Device": "DP10APro",
    "Model": "DP10APro"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "DroiPad 10D",
    "Device": "TECNO-P904",
    "Model": "TECNO P904"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "DroiPad 7C Pro",
    "Device": "DP7CPRO",
    "Model": "DP7CPRO"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "DroiPad 7D",
    "Device": "TECNO-P701",
    "Model": "TECNO P701"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "DroiPad 7D LTE",
    "Device": "TECNO-P702",
    "Model": "TECNO P702A"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "DroiPad 7D ProLTE",
    "Device": "TECNO-P702",
    "Model": "TECNO P702"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "DroiPad 7D ProLTE",
    "Device": "TECNO-P702",
    "Model": "TECNO P702A"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "DroiPad 7F",
    "Device": "TECNO-P703",
    "Model": "TECNO P703"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "DroiPad 8Ⅱ",
    "Device": "DP8D",
    "Model": "DP8D"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "Droipad10",
    "Device": "DP10A",
    "Model": "DP10A"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "Droipad10",
    "Device": "DP10A",
    "Model": "TECNO DP10A"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "F1",
    "Device": "TECNO-F1",
    "Model": "TECNO F1"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "F1",
    "Device": "TECNO-F1-PRO",
    "Model": "TECNO F1"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "F2",
    "Device": "TECNO-F2",
    "Model": "TECNO F2"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "F2LTE",
    "Device": "TECNO-F2LTE",
    "Model": "TECNO F2LTE"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "H5S",
    "Device": "up09_tecno_h5s",
    "Model": "TECNO H5S"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "H7S",
    "Device": "qp16_tecno_h7s",
    "Model": "H7S"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "Infinix SMART 7",
    "Device": "Infinix-X6515",
    "Model": "Infinix X6515"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "J5",
    "Device": "TECNO-J5",
    "Model": "TECNO-J5"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "J7",
    "Device": "TECNO-J7",
    "Model": "TECNO-J7"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "J8",
    "Device": "TECNO-J8",
    "Model": "TECNO-J8"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "L5",
    "Device": "TECNO-L5",
    "Model": "TECNO-L5"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "L8",
    "Device": "TECNO-L8",
    "Model": "TECNO-L8"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "L8 Lite",
    "Device": "L8Lite",
    "Model": "TECNO L8 Lite"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "L8Plus",
    "Device": "TECNO-L8",
    "Model": "TECNO-L8Plus"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "L9",
    "Device": "TECNO-L9",
    "Model": "TECNO L9"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "L9Plus",
    "Device": "TECNO-L9Plus",
    "Model": "TECNO L9 Plus"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "M3",
    "Device": "up11_tecno_m3s",
    "Model": "TECNO M3S"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "M6S",
    "Device": "g335_b1",
    "Model": "TECNO-M6S"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "N2",
    "Device": "TECNO_N2S",
    "Model": "TECNO-N2"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "N2S",
    "Device": "TECNO_N2S",
    "Model": "TECNO-N2S"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "N5S",
    "Device": "N5S",
    "Model": "TECNO N5S"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "N6",
    "Device": "TECNO-N6",
    "Model": "TECNO-N6"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "N6S",
    "Device": "TECNO-N6S",
    "Model": "TECNO-N6S"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "N8",
    "Device": "TECNO-N8",
    "Model": "TECNO N8"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "N8",
    "Device": "TECNO-N8",
    "Model": "TECNO-N8"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "N8R",
    "Device": "N8R",
    "Model": "TECNO-N8R"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "N8S",
    "Device": "TECNO-N8S",
    "Model": "TECNO-N8S"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "N9",
    "Device": "N9",
    "Model": "TECNO-N9"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "N9S",
    "Device": "N9S",
    "Model": "TECNO-N9S"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "NX",
    "Device": "TECNO-R8",
    "Model": "TECNO R8O"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "NX",
    "Device": "TECNO-R8",
    "Model": "TECNO R8S"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "P5",
    "Device": "up08_tecno_p5s",
    "Model": "TECNO P5S"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "P702AS",
    "Device": "TECNO-P702",
    "Model": "TECNO P702AS"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "PHANTOM V Flip 5G",
    "Device": "TECNO-AD11",
    "Model": "TECNO AD11"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "PHANTOM X",
    "Device": "TECNO-AC8",
    "Model": "TECNO AC8"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "PHANTOM X2 5G",
    "Device": "TECNO-AD8",
    "Model": "TECNO AD8"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "PHANTOM X2 Pro 5G",
    "Device": "TECNO-AD9",
    "Model": "TECNO AD9"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "PHANTOM-Z-mini",
    "Device": "PTM-Z-mini",
    "Model": "PTM-Z-mini"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "PHANTOM5",
    "Device": "TECNO-PHANTOM5",
    "Model": "TECNO-PHANTOM5"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "POP 1 Pro",
    "Device": "TECNO-F3-13M",
    "Model": "TECNO F3"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "POP 1s",
    "Device": "TECNO-F4",
    "Model": "TECNO F4"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "POP 1s Pro",
    "Device": "TECNO-F4Pro",
    "Model": "TECNO F4 Pro"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "POP 2",
    "Device": "TECNO-B1",
    "Model": "TECNO B1"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "POP 2",
    "Device": "TECNO-B1S",
    "Model": "TECNO B1S"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "POP 2 Plus",
    "Device": "TECNO-BA2",
    "Model": "TECNO BA2"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "POP 2 Power",
    "Device": "TECNO-B1p",
    "Model": "TECNO B1p"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "POP 2F",
    "Device": "TECNO-B1f",
    "Model": "TECNO B1f"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "POP 2S",
    "Device": "TECNO-RA8",
    "Model": "TECNO RA8"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "POP 2s",
    "Device": "TECNO-KB2h",
    "Model": "TECNO KB2h"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "POP 3 Plus",
    "Device": "TECNO-BB4",
    "Model": "TECNO BB4"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "POP 4 LTE",
    "Device": "TECNO-BC1s",
    "Model": "TECNO BC1s"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "POP 4 Pro",
    "Device": "TECNO-BC3",
    "Model": "TECNO BC3"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "POP 5 LTE",
    "Device": "TECNO-BD4i",
    "Model": "TECNO BD4i"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "POP 5P",
    "Device": "TECNO-BD3",
    "Model": "TECNO BD3"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "POP 6 Pro",
    "Device": "TECNO-BE8",
    "Model": "TECNO BE8"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "POP 6 Pro",
    "Device": "TECNO-BE8i",
    "Model": "TECNO BE8i"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "POP 7 Pro",
    "Device": "TECNO-BF7h",
    "Model": "TECNO BF7h"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "POP 8",
    "Device": "TECNO-BG6h",
    "Model": "TECNO BG6h"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "POP1",
    "Device": "TECNO-F3",
    "Model": "TECNO F3"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "POVA",
    "Device": "TECNO-LD7",
    "Model": "TECNO LD7"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "POVA",
    "Device": "TECNO-LD7j",
    "Model": "TECNO LD7j"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "POVA 5",
    "Device": "TECNO-LH7n",
    "Model": "TECNO LH7n"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "POVA 5 Pro 5G",
    "Device": "TECNO-LH8n",
    "Model": "TECNO LH8n"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "POVA Neo",
    "Device": "TECNO-LE6",
    "Model": "TECNO LE6"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "POVA Neo 2",
    "Device": "TECNO-LG6n",
    "Model": "TECNO LG6n"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "Phantom 9",
    "Device": "TECNO-AB7",
    "Model": "TECNO AB7"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "Phantom6",
    "Device": "Phantom6",
    "Model": "Phantom6"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "Phantom6 plus",
    "Device": "Phantom6-Plus",
    "Model": "Phantom6-Plus"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "Phantom6S",
    "Device": "Phantom6",
    "Model": "Phantom6S"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "Phantom8",
    "Device": "TECNO-AX8",
    "Model": "TECNO AX8"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "Phantom8S",
    "Device": "TECNO-AX8",
    "Model": "TECNO AX8S"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "PhonePad 3",
    "Device": "TECNO-PP7FPro",
    "Model": "TECNO PhonePad 3"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "PhonePad 7 II",
    "Device": "PP7E-DLA1",
    "Model": "TECNO PP7E-DLA1"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "PhonePad 7 II",
    "Device": "PP7E-DLA1",
    "Model": "TECNO PP7E-SLA1"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "Pouvoir 1",
    "Device": "TECNO-LA6",
    "Model": "TECNO LA6"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "Pouvoir 2",
    "Device": "TECNO-LA7",
    "Model": "TECNO LA7"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "Pouvoir 2 Pro",
    "Device": "TECNO-LA7-13M",
    "Model": "TECNO LA7 Pro"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "Pouvoir 3",
    "Device": "TECNO-LB7",
    "Model": "TECNO LB7"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "Pouvoir 3 Air",
    "Device": "TECNO-LC6",
    "Model": "TECNO LC6"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "Pouvoir 3 Air",
    "Device": "TECNO-LC6a",
    "Model": "TECNO LC6a"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "Pouvoir 4",
    "Device": "TECNO-LC7",
    "Model": "TECNO LC7"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "Pouvoir 4",
    "Device": "TECNO-LC7",
    "Model": "TECNO LC7S"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "Pouvoir 4 Pro",
    "Device": "TECNO-LC8",
    "Model": "TECNO LC8"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "R6",
    "Device": "TECNO-R6",
    "Model": "TECNO R6"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "R6+",
    "Device": "TECNO-RA6",
    "Model": "TECNO RA6"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "R7 4G",
    "Device": "TECNO-F2LTE",
    "Model": "TECNO RA7"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "RA6",
    "Device": "TECNO-RA6",
    "Model": "TECNO RA6"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "RA6",
    "Device": "TECNO-RA6",
    "Model": "TECNO RA6S"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "S1",
    "Device": "TECNO-S1",
    "Model": "TECNO S1"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "S1",
    "Device": "TECNO-S1",
    "Model": "TECNO S1M"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "S1 Pro",
    "Device": "TECNO-S1-Pro",
    "Model": "TECNO S1 Pro"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "S1 Pro",
    "Device": "TECNO-S1-Pro",
    "Model": "TECNO S1E Pro"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "S1E Pro",
    "Device": "TECNO-S1-Pro",
    "Model": "TECNO S1E Pro"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "S2",
    "Device": "TECNO-SA1",
    "Model": "TECNO SA1"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "S6",
    "Device": "TECNO-S6S",
    "Model": "TECNO S6"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "S6S",
    "Device": "TECNO-S6S",
    "Model": "TECNO S6S"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "S6s",
    "Device": "TECNO-S6S",
    "Model": "TECNO S6S"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "SA1 Pro",
    "Device": "TECNO-SA1S-PRO",
    "Model": "TECNO SA1S Pro"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "SA6",
    "Device": "TECNO-SA6",
    "Model": "TECNO SA6"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "SA6",
    "Device": "TECNO-SA6",
    "Model": "TECNO SA6S"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "SAPRK GO 2021",
    "Device": "TECNO-KE5",
    "Model": "TECNO KE5"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "SPARK",
    "Device": "TECNO-K7",
    "Model": "TECNO K7"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "SPARK 10 5G",
    "Device": "TECNO-KI8",
    "Model": "TECNO KI8"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "SPARK 2",
    "Device": "TECNO-KA7-GO",
    "Model": "TECNO KA7"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "SPARK 2",
    "Device": "TECNO-KA7-O",
    "Model": "TECNO KA7O"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "SPARK 2 YOUTH",
    "Device": "TECNO-LB6",
    "Model": "TECNO LB6"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "SPARK 3",
    "Device": "TECNO-KB7",
    "Model": "TECNO KB7"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "SPARK 3",
    "Device": "TECNO-KB7j",
    "Model": "TECNO KB7j"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "SPARK 3 Pro",
    "Device": "TECNO-KB8",
    "Model": "TECNO KB8"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "SPARK 4",
    "Device": "TECNO-KC8",
    "Model": "TECNO KC8"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "SPARK 4",
    "Device": "TECNO-KC8S",
    "Model": "TECNO KC8S"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "SPARK 4 Lite",
    "Device": "TECNO-BB4k",
    "Model": "TECNO BB4k"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "SPARK 5 Air",
    "Device": "TECNO-KD6",
    "Model": "TECNO KD6"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "SPARK 5 Air",
    "Device": "TECNO-KD6",
    "Model": "TECNO KD6a"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "SPARK 6 Air",
    "Device": "TECNO-KE6",
    "Model": "TECNO KE6"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "SPARK 6 Air",
    "Device": "TECNO-KE6j",
    "Model": "TECNO KE6j"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "SPARK 6 GO",
    "Device": "TECNO-KE5j",
    "Model": "TECNO KE5j"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "SPARK 6 GO",
    "Device": "TECNO-KE5k",
    "Model": "TECNO KE5k"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "SPARK 6 Go",
    "Device": "TECNO-KE5",
    "Model": "TECNO KE5"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "SPARK 6 Go",
    "Device": "TECNO-KE5k",
    "Model": "TECNO KE5k"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "SPARK 8 Pro",
    "Device": "TECNO-KG8",
    "Model": "TECNO KG8"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "SPARK 8 Pro",
    "Device": "TECNO-Mobile-KG8",
    "Model": "TECNO Mobile KG8"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "SPARK 8C",
    "Device": "TECNO-KG5q",
    "Model": "TECNO KG5q"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "SPARK CM",
    "Device": "TECNO-KA9",
    "Model": "TECNO KA9"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "SPARK Go 2020",
    "Device": "TECNO-KE5S",
    "Model": "TECNO KE5S"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "SPARK Go 2021(SPARK 6 Go)",
    "Device": "TECNO-KE5",
    "Model": "TECNO KE5"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "SPARK Go 2023",
    "Device": "TECNO-BF7n",
    "Model": "TECNO BF7n"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "SPARK Go 2024",
    "Device": "TECNO-BG6",
    "Model": "TECNO BG6"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "SPARK Go Plus",
    "Device": "TECNO-BB4k",
    "Model": "TECNO BB4k"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "SPARK Plus",
    "Device": "TECNO-K9",
    "Model": "TECNO K9"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "SPARK Pro",
    "Device": "TECNO-K8",
    "Model": "TECNO K8"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "SPARK Youth",
    "Device": "TECNO-KA6",
    "Model": "TECNO KA6"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "T1201-OP",
    "Device": "TECNO-T1201",
    "Model": "TECNO T1201"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO",
    "Device": "TECNO-BF7",
    "Model": "TECNO BF7"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO",
    "Device": "TECNO-BF7n",
    "Model": "TECNO BF7n"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO",
    "Device": "TECNO-BF7s",
    "Model": "TECNO BF7s"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO",
    "Device": "TECNO-BG6",
    "Model": "TECNO BG6"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO",
    "Device": "TECNO-BG6m",
    "Model": "TECNO BG6m"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO AX8",
    "Device": "TECNO-AX8",
    "Model": "TECNO AX8"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO CAMON 12 Air",
    "Device": "TECNO-KC3",
    "Model": "TECNO KC3"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO CAMON 12 Pro",
    "Device": "TECNO-CC9",
    "Model": "TECNO CC9"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO CAMON 15",
    "Device": "TECNO-CD7",
    "Model": "TECNO CD7"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO CAMON 16",
    "Device": "TECNO-CE9h",
    "Model": "TECNO CE9h"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO CAMON 16 Premier",
    "Device": "TECNO-CE9",
    "Model": "TECNO CE9"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO CAMON 18 Premier",
    "Device": "TECNO-CH9",
    "Model": "TECNO CH9"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO CAMON 18 Premier",
    "Device": "TECNO-CH9n",
    "Model": "TECNO CH9n"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO CAMON 19 Neo",
    "Device": "TECNO-CH6IS",
    "Model": "TECNO CH6IS"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO CAMON 19 Neo",
    "Device": "TECNO-CH6i",
    "Model": "TECNO CH6i"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO CAMON 20",
    "Device": "TECNO-CK6",
    "Model": "TECNO CK6"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO CAMON 20",
    "Device": "TECNO-CK6n",
    "Model": "TECNO CK6n"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO CAMON 20",
    "Device": "TECNO-CK6ns",
    "Model": "TECNO CK6ns"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO CAMON 20 PRO",
    "Device": "TECNO-CK6n",
    "Model": "TECNO CK6n"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO CAMON 20 Premier 5G",
    "Device": "TECNO-CK9n",
    "Model": "TECNO CK9n"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO CAMON 20s Pro 5G",
    "Device": "TECNO-CK8nB",
    "Model": "TECNO CK8nB"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO CAMON 30",
    "Device": "TECNO-CL6",
    "Model": "TECNO CL6"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO CAMON 30",
    "Device": "TECNO-CL6k",
    "Model": "TECNO CL6k"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO CAMON 30",
    "Device": "TECNO-CL6s",
    "Model": "TECNO CL6s"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO CAMON 30 5G",
    "Device": "TECNO-CL7",
    "Model": "TECNO CL7"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO CAMON 30 5G",
    "Device": "TECNO-CL7k",
    "Model": "TECNO CL7k"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO CAMON 30 5G",
    "Device": "TECNO-CL7s",
    "Model": "TECNO CL7s"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO CAMON 30 Premier 5G",
    "Device": "TECNO-CL9",
    "Model": "TECNO CL9"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO CAMON 30 Pro 5G",
    "Device": "TECNO-CL8",
    "Model": "TECNO CL8"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO CAMON 30S",
    "Device": "TECNO-CLA5",
    "Model": "TECNO CLA5"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO CAMON 30S Pro",
    "Device": "TECNO-CLA6",
    "Model": "TECNO CLA6"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO CAMON 30T",
    "Device": "TECNO-Mobile-CLA6",
    "Model": "TECNO Mobile CLA6"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO CAMON 40",
    "Device": "TECNO-CM5",
    "Model": "TECNO CM5"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO CAMON 40 5G",
    "Device": "TECNO-CM7",
    "Model": "TECNO CM7"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO CAMON 40 Premier 5G",
    "Device": "TECNO-CM8",
    "Model": "TECNO CM8"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO CAMON 40 Pro",
    "Device": "TECNO-CM6",
    "Model": "TECNO CM6"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO CAMON 40 Pro 5G",
    "Device": "TECNO-CM7",
    "Model": "TECNO CM7"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO CAMON 50",
    "Device": "TECNO-CN5",
    "Model": "TECNO CN5"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO CAMON 50 Pro",
    "Device": "TECNO-CN5c",
    "Model": "TECNO CN5c"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO CAMON 50 Pro 5G",
    "Device": "TECNO-CN7c",
    "Model": "TECNO CN7c"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO CAMON 50 Ultra 5G",
    "Device": "TECNO-CN7c",
    "Model": "TECNO CN7c"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO CAMON iACE 2",
    "Device": "TECNO-KB2",
    "Model": "TECNO KB2"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO CAMON iACE 2x",
    "Device": "TECNO-KB2j",
    "Model": "TECNO KB2j"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO CX Air",
    "Device": "TECNO-CX-Air",
    "Model": "TECNO CX Air"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO K7",
    "Device": "TECNO-K7",
    "Model": "TECNO K7"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO K9",
    "Device": "TECNO-K9",
    "Model": "TECNO K9"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO MEGAPAD  SE",
    "Device": "TECNO-T1102",
    "Model": "TECNO T1102"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO MEGAPAD  SE",
    "Device": "TECNO-T1102W",
    "Model": "TECNO T1102W"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO MegaPad 11",
    "Device": "TECNO-T1101",
    "Model": "TECNO T1101"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO MegaPad Pro",
    "Device": "TECNO-T1201",
    "Model": "TECNO T1201"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO Mobile SPARK 20 Pro",
    "Device": "TECNO-Mobile-KJ6",
    "Model": "TECNO Mobile KJ6"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO Mobile SPARK 8",
    "Device": "TECNO-Mobile-KG6k",
    "Model": "TECNO Mobile KG6k"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO Mobile SPARK 8C",
    "Device": "TECNO-Mobile-KG5k",
    "Model": "TECNO Mobile KG5k"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO Mobile SPARK 8T",
    "Device": "TECNO-Mobile-KG6p",
    "Model": "TECNO Mobile KG6p"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO Mobile SPARK Go 1",
    "Device": "TECNO-Mobile-KL4",
    "Model": "TECNO Mobile KL4"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO P904",
    "Device": "TECNO-P904",
    "Model": "TECNO P904"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO PHANTOM V Flip2 5G",
    "Device": "TECNO-AE11",
    "Model": "TECNO AE11"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO PHANTOM V Fold",
    "Device": "TECNO-AD10",
    "Model": "TECNO AD10"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO PHANTOM V Fold2 5G",
    "Device": "TECNO-AE10",
    "Model": "TECNO AE10"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO POP 10",
    "Device": "TECNO-KM4",
    "Model": "TECNO KM4"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO POP 10",
    "Device": "TECNO-KM4s",
    "Model": "TECNO KM4s"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO POP 2 Air",
    "Device": "TECNO-SC7S",
    "Model": "TECNO SC7S"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO POP 20",
    "Device": "TECNO-KN3",
    "Model": "TECNO KN3"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO POP 2F",
    "Device": "TECNO-B1g",
    "Model": "TECNO B1g"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO POP 2X Plus",
    "Device": "TECNO-RB8S",
    "Model": "TECNO RB8S"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO POP 2s Pro",
    "Device": "TECNO-KB2j",
    "Model": "TECNO KB2j"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO POP 3",
    "Device": "TECNO-BB2",
    "Model": "TECNO BB2"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO POP 4",
    "Device": "TECNO-BC2",
    "Model": "TECNO BC2"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO POP 4",
    "Device": "TECNO-BC2c",
    "Model": "TECNO BC2c"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO POP 4 Air",
    "Device": "TECNO-BC1",
    "Model": "TECNO BC1"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO POP 5",
    "Device": "TECNO-BD2",
    "Model": "TECNO BD2"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO POP 5",
    "Device": "TECNO-BD2d",
    "Model": "TECNO BD2d"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO POP 5",
    "Device": "TECNO-BD2p",
    "Model": "TECNO BD2p"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO POP 5 Go",
    "Device": "TECNO-BD1",
    "Model": "TECNO BD1"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO POP 5 LTE",
    "Device": "TECNO-BD4",
    "Model": "TECNO BD4"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO POP 6",
    "Device": "TECNO-BE7",
    "Model": "TECNO BE7"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO POP 6 Go",
    "Device": "TECNO-BE6-R2",
    "Model": "TECNO BE6"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO POP 6 Go",
    "Device": "TECNO-BE7",
    "Model": "TECNO BE7"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO POP 6 Go 4G",
    "Device": "TECNO-BE6j",
    "Model": "TECNO BE6j"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO POP 7",
    "Device": "TECNO-BF6",
    "Model": "TECNO BF6"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO POP 8",
    "Device": "TECNO-BG6i",
    "Model": "TECNO BG6i"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO POP 9",
    "Device": "TECNO-KL4",
    "Model": "TECNO KL4"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO POP 9 5G",
    "Device": "TECNO-KL8h",
    "Model": "TECNO KL8h"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO POP X",
    "Device": "TECNO-KN3",
    "Model": "TECNO KN3"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO POP X5",
    "Device": "TECNO-L6502S",
    "Model": "TECNO L6502S"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO POVA 2",
    "Device": "TECNO-LE7",
    "Model": "TECNO LE7"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO POVA 2",
    "Device": "TECNO-LE7n",
    "Model": "TECNO LE7n"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO POVA 3",
    "Device": "TECNO-LF7",
    "Model": "TECNO LF7"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO POVA 3",
    "Device": "TECNO-LF7n",
    "Model": "TECNO LF7n"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO POVA 4",
    "Device": "TECNO-LG7n",
    "Model": "TECNO LG7n"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO POVA 4 Pro",
    "Device": "TECNO-LG8n",
    "Model": "TECNO LG8n"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO POVA 5G",
    "Device": "TECNO-LE8",
    "Model": "TECNO LE8"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO POVA 6",
    "Device": "TECNO-LI7",
    "Model": "TECNO LI7"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO POVA 6 5G",
    "Device": "TECNO-KJ8s",
    "Model": "TECNO KJ8s"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO POVA 6 Neo",
    "Device": "TECNO-LI6",
    "Model": "TECNO LI6"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO POVA 6 Neo 5G",
    "Device": "TECNO-KL8",
    "Model": "TECNO KL8"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO POVA 6 Pro 5G",
    "Device": "TECNO-LI9",
    "Model": "TECNO LI9"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO POVA 7",
    "Device": "TECNO-LJ6",
    "Model": "TECNO LJ6"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO POVA 7 5G",
    "Device": "TECNO-LJ7",
    "Model": "TECNO LJ7"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO POVA 7 Neo",
    "Device": "TECNO-LJ6",
    "Model": "TECNO LJ6"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO POVA 7 Pro 5G",
    "Device": "TECNO-LJ8",
    "Model": "TECNO LJ8"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO POVA 7 Ultra 5G",
    "Device": "TECNO-LJ9",
    "Model": "TECNO LJ9"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO POVA Curve 2 5G",
    "Device": "TECNO-LK7k",
    "Model": "TECNO LK7k"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO POVA Curve 5G",
    "Device": "TECNO-LJ8k",
    "Model": "TECNO LJ8k"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO POVA Neo 3",
    "Device": "TECNO-LH6n",
    "Model": "TECNO LH6n"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO POVA Slim 5G",
    "Device": "TECNO-KM9",
    "Model": "TECNO KM9"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO R6S",
    "Device": "TECNO-R6",
    "Model": "TECNO R6S"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO R7+",
    "Device": "TECNO-RC6",
    "Model": "TECNO RC6"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO RB7S",
    "Device": "TECNO-RB7S",
    "Model": "TECNO RB7S"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO S1 Lite",
    "Device": "TECNO-S1Lite",
    "Model": "TECNO S1 Lite"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO SA2S",
    "Device": "TECNO-SA2S",
    "Model": "TECNO SA2S"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO SA7S",
    "Device": "TECNO-SA7S",
    "Model": "TECNO SA7S"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO SPARK 10",
    "Device": "TECNO-KI5n",
    "Model": "TECNO KI5n"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO SPARK 10",
    "Device": "TECNO-KI5q",
    "Model": "TECNO KI5q"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO SPARK 10",
    "Device": "TECNO-KI5qs",
    "Model": "TECNO KI5qs"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO SPARK 10 Pro",
    "Device": "TECNO-KI7",
    "Model": "TECNO KI7"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO SPARK 10 Pro",
    "Device": "TECNO-KI7s",
    "Model": "TECNO KI7s"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO SPARK 10C",
    "Device": "TECNO-KI5k",
    "Model": "TECNO KI5k"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO SPARK 10C",
    "Device": "TECNO-KI5m",
    "Model": "TECNO KI5m"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO SPARK 20",
    "Device": "TECNO-KJ5",
    "Model": "TECNO KJ5"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO SPARK 20",
    "Device": "TECNO-KJ5n",
    "Model": "TECNO KJ5n"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO SPARK 20",
    "Device": "TECNO-KJ5s",
    "Model": "TECNO KJ5s"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO SPARK 20 Pro",
    "Device": "TECNO-KJ6",
    "Model": "TECNO KJ6"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO SPARK 20 Pro 5G",
    "Device": "TECNO-KJ8",
    "Model": "TECNO KJ8"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO SPARK 20 Pro+",
    "Device": "TECNO-KJ7",
    "Model": "TECNO KJ7"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO SPARK 20 Pro+",
    "Device": "TECNO-KJ7s",
    "Model": "TECNO KJ7s"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO SPARK 20C",
    "Device": "TECNO-BG7",
    "Model": "TECNO BG7"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO SPARK 20C",
    "Device": "TECNO-BG7n",
    "Model": "TECNO BG7n"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO SPARK 30",
    "Device": "TECNO-KL6",
    "Model": "TECNO KL6"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO SPARK 30 5G",
    "Device": "TECNO-KL8",
    "Model": "TECNO KL8"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO SPARK 30 5G",
    "Device": "TECNO-KL8s",
    "Model": "TECNO KL8s"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO SPARK 30 Pro",
    "Device": "TECNO-KL7",
    "Model": "TECNO KL7"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO SPARK 30C",
    "Device": "TECNO-KL5",
    "Model": "TECNO KL5"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO SPARK 30C",
    "Device": "TECNO-KL5n",
    "Model": "TECNO KL5n"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO SPARK 30C",
    "Device": "TECNO-KL5s",
    "Model": "TECNO KL5s"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO SPARK 30C 5G",
    "Device": "TECNO-KL8h",
    "Model": "TECNO KL8h"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO SPARK 30C 5G",
    "Device": "TECNO-KL8hs",
    "Model": "TECNO KL8hs"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO SPARK 4",
    "Device": "TECNO-KC2",
    "Model": "TECNO KC2"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO SPARK 4",
    "Device": "TECNO-KC2j",
    "Model": "TECNO KC2j"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO SPARK 4 Air",
    "Device": "TECNO-KC1j",
    "Model": "TECNO KC1j"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO SPARK 4 Air",
    "Device": "TECNO-KC6",
    "Model": "TECNO KC6"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO SPARK 4 Air",
    "Device": "TECNO-KC6S",
    "Model": "TECNO KC6S"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO SPARK 40",
    "Device": "TECNO-KM5",
    "Model": "TECNO KM5"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO SPARK 40",
    "Device": "TECNO-KM5n",
    "Model": "TECNO KM5n"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO SPARK 40",
    "Device": "TECNO-KM5s",
    "Model": "TECNO KM5s"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO SPARK 40 5G",
    "Device": "TECNO-KM8n",
    "Model": "TECNO KM8n"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO SPARK 40 Pro",
    "Device": "TECNO-KM6",
    "Model": "TECNO KM6"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO SPARK 40 Pro+",
    "Device": "TECNO-KM7",
    "Model": "TECNO KM7"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO SPARK 40/SPARK 40 Plus",
    "Device": "TECNO-KM5s",
    "Model": "TECNO KM5s"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO SPARK 40C",
    "Device": "TECNO-KM4k",
    "Model": "TECNO KM4k"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO SPARK 5",
    "Device": "TECNO-KD7h",
    "Model": "TECNO KD7S"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO SPARK 5",
    "Device": "TECNO-KD7h",
    "Model": "TECNO KD7h"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO SPARK 5 Pro",
    "Device": "TECNO-KD7",
    "Model": "TECNO KD7"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO SPARK 50",
    "Device": "TECNO-KN4",
    "Model": "TECNO KN4"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO SPARK 50",
    "Device": "TECNO-KN4n",
    "Model": "TECNO KN4n"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO SPARK 50 5G",
    "Device": "TECNO-KN8",
    "Model": "TECNO KN8"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO SPARK 50/50C",
    "Device": "TECNO-KN3",
    "Model": "TECNO KN3"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO SPARK 50/50S",
    "Device": "TECNO-KN4",
    "Model": "TECNO KN4"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO SPARK 7",
    "Device": "TECNO-KF6",
    "Model": "TECNO KF6"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO SPARK 7",
    "Device": "TECNO-KF6h",
    "Model": "TECNO KF6h"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO SPARK 7",
    "Device": "TECNO-KF6i",
    "Model": "TECNO KF6i"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO SPARK 7",
    "Device": "TECNO-KF6j",
    "Model": "TECNO KF6j"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO SPARK 7",
    "Device": "TECNO-KF6k",
    "Model": "TECNO KF6k"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO SPARK 7",
    "Device": "TECNO-KF6ks",
    "Model": "TECNO KF6ks"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO SPARK 7",
    "Device": "TECNO-KF6m",
    "Model": "TECNO KF6m"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO SPARK 7",
    "Device": "TECNO-KF6n",
    "Model": "TECNO KF6n"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO SPARK 7",
    "Device": "TECNO-KF6p",
    "Model": "TECNO KF6p"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO SPARK 7",
    "Device": "TECNO-PR651",
    "Model": "TECNO PR651"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO SPARK 7",
    "Device": "TECNO-PR651E",
    "Model": "TECNO PR651E"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO SPARK 7",
    "Device": "TECNO-PR651H",
    "Model": "TECNO PR651H"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO SPARK 7 Pro",
    "Device": "TECNO-KF8",
    "Model": "TECNO KF8"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO SPARK 7P",
    "Device": "TECNO-KF7j",
    "Model": "TECNO KF7j"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO SPARK 7T",
    "Device": "TECNO-KF6p",
    "Model": "TECNO KF6p"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO SPARK 8",
    "Device": "TECNO-KG6",
    "Model": "TECNO KG6"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO SPARK 8",
    "Device": "TECNO-KG6k",
    "Model": "TECNO KG6k"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO SPARK 8 P",
    "Device": "TECNO-KG7",
    "Model": "TECNO KG7"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO SPARK 8 P",
    "Device": "TECNO-KG7n",
    "Model": "TECNO KG7n"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO SPARK 8C",
    "Device": "TECNO-KG5j",
    "Model": "TECNO KG5j"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO SPARK 8C",
    "Device": "TECNO-KG5k",
    "Model": "TECNO KG5k"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO SPARK 8C",
    "Device": "TECNO-KG5ks",
    "Model": "TECNO KG5ks"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO SPARK 8P",
    "Device": "TECNO-KG7n",
    "Model": "TECNO KG7n"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO SPARK 8T",
    "Device": "TECNO-KG6P",
    "Model": "TECNO KG6P"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO SPARK 8T",
    "Device": "TECNO-KG6P",
    "Model": "TECNO KG6p"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO SPARK 9",
    "Device": "TECNO-KG5p",
    "Model": "TECNO KG5p"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO SPARK 9 Pro",
    "Device": "TECNO-KH7S",
    "Model": "TECNO KH7S"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO SPARK 9 Pro",
    "Device": "TECNO-KH7n",
    "Model": "TECNO KH7n"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO SPARK 9T",
    "Device": "TECNO-KH6",
    "Model": "TECNO KH6"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO SPARK Go",
    "Device": "TECNO-KC1",
    "Model": "TECNO KC1"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO SPARK Go 1",
    "Device": "TECNO-KL4",
    "Model": "TECNO KL4"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO SPARK Go 1",
    "Device": "TECNO-KL4s",
    "Model": "TECNO KL4s"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO SPARK Go 2",
    "Device": "TECNO-KM4",
    "Model": "TECNO KM4"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO SPARK Go 2",
    "Device": "TECNO-KM4s",
    "Model": "TECNO KM4s"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO SPARK Go 2/2S",
    "Device": "TECNO-KM4",
    "Model": "TECNO KM4"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO SPARK Go 2022",
    "Device": "TECNO-KG5",
    "Model": "TECNO KG5"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO SPARK Go 2022",
    "Device": "TECNO-KG5h",
    "Model": "TECNO KG5h"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO SPARK Go 2022",
    "Device": "TECNO-KG5m",
    "Model": "TECNO KG5m"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO SPARK Go 2024",
    "Device": "TECNO-BG6m",
    "Model": "TECNO BG6m"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO SPARK Go 2024",
    "Device": "TECNO-BG6s",
    "Model": "TECNO BG6"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO SPARK Go 2024",
    "Device": "TECNO-BG6s",
    "Model": "TECNO BG6s"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO SPARK Go 2025",
    "Device": "TECNO-BG6m",
    "Model": "TECNO BG6m"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO SPARK Go 3",
    "Device": "TECNO-KN3",
    "Model": "TECNO KN3"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO SPARK Go 5G",
    "Device": "TECNO-KM8",
    "Model": "TECNO KM8"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO SPARK Slim",
    "Device": "TECNO-KM7k",
    "Model": "TECNO KM7k"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO SPARK Slim 5G",
    "Device": "TECNO-KM9",
    "Model": "TECNO KM9"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO Tab",
    "Device": "TECNO-P704",
    "Model": "TECNO P704"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO Tab",
    "Device": "TECNO-P704a",
    "Model": "TECNO P704a"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO W5",
    "Device": "TECNO-W5",
    "Model": "TECNO-W5"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO WX4 Pro S",
    "Device": "TECNO-WX4-Pro",
    "Model": "TECNO WX4 Pro S"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO-W5",
    "Device": "TECNO-W5",
    "Model": "TECNO-W5"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO-Y2",
    "Device": "TECNO-Y2",
    "Model": "TECNO-Y2"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNO-Y2",
    "Device": "TECNO-Y2",
    "Model": "TECNO-Y3+"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "TECNOPOP 5C",
    "Device": "TECNO-W5006S",
    "Model": "TECNO W5006S"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "Techno L6",
    "Device": "TECNO-L6",
    "Model": "TECNO-L6"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "Tecno pop 2x Air",
    "Device": "TECNO-RB6S",
    "Model": "TECNO RB6S"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "W1",
    "Device": "TECNO_W1",
    "Model": "TECNO W1"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "W2",
    "Device": "TECNO_W2",
    "Model": "TECNO W2"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "W3",
    "Device": "TECNO-W3",
    "Model": "TECNO-W3"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "W3 Pro",
    "Device": "TECNO-W3Pro",
    "Model": "TECNO W3 Pro"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "W3LTE",
    "Device": "TECNO-W3LTE",
    "Model": "TECNO-W3LTE"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "W4",
    "Device": "TECNO_W4",
    "Model": "TECNO_W4"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "W5",
    "Device": "TECNO-W5",
    "Model": "TECNO-W5"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "W5 Lite",
    "Device": "W5Lite",
    "Model": "TECNO W5 Lite"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "WX3",
    "Device": "TECNO-WX3",
    "Model": "TECNO WX3"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "WX3 FLTE",
    "Device": "TECNO-WX3FLTE",
    "Model": "TECNO WX3F LTE"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "WX3F LTE",
    "Device": "TECNO-WX3FLTE",
    "Model": "TECNO WX3F LTE"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "WX3LTE",
    "Device": "TECNO-WX3LTE",
    "Model": "TECNO WX3LTE"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "WX3P",
    "Device": "TECNO-WX3P",
    "Model": "TECNO WX3P"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "WX4",
    "Device": "TECNO-WX4",
    "Model": "TECNO WX4"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "WX4 Pro",
    "Device": "TECNO-WX4-Pro",
    "Model": "TECNO WX4 Pro"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "WX4 Pro S",
    "Device": "TECNO-WX4-Pro",
    "Model": "TECNO WX4 Pro S"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "Y3",
    "Device": "TECNO-Y3",
    "Model": "TECNO-Y3"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "Y3+",
    "Device": "TECNO-Y2",
    "Model": "TECNO-Y2"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "Y3+",
    "Device": "TECNO-Y2",
    "Model": "TECNO-Y3+"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "Y3S",
    "Device": "TECNO-Y3S",
    "Model": "TECNO-Y3S"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "Y4",
    "Device": "TECNO-Y4",
    "Model": "TECNO-Y4"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "Y5",
    "Device": "TECNO-Y5",
    "Model": "TECNO-Y5"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "Y6",
    "Device": "TECNO-Y6",
    "Model": "TECNO-Y6"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "i3",
    "Device": "TECNO-i3",
    "Model": "TECNO i3"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "i3 Pro",
    "Device": "TECNO-i3-Pro",
    "Model": "TECNO i3 Pro"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "i3-Pro",
    "Device": "TECNO-i3-Pro",
    "Model": "TECNO i3 Pro"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "i5",
    "Device": "TECNO-i5",
    "Model": "TECNO i5"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "i5-Pro",
    "Device": "TECNO-i5-Pro",
    "Model": "TECNO i5 Pro"
  },
  {
    "Retail Branding": "Tecno",
    "Marketing Name": "i7",
    "Device": "TECNO-i7",
    "Model": "TECNO i7"
  },
  {
    "Retail Branding": "Tecno Mobile",
    "Marketing Name": "CAMON 19 Neo",
    "Device": "TECNO-Mobile-CH6i",
    "Model": "TECNO Mobile CH6i"
  },
  {
    "Retail Branding": "Tecno Mobile",
    "Marketing Name": "PHANTOM X2 5G",
    "Device": "TECNO-Mobile-AD8",
    "Model": "TECNO Mobile AD8"
  },
  {
    "Retail Branding": "Tecno Mobile",
    "Marketing Name": "POVA 5",
    "Device": "TECNO-Mobile-LH7n",
    "Model": "TECNO Mobile LH7n"
  },
  {
    "Retail Branding": "Tecno Mobile",
    "Marketing Name": "POVA 5 Pro 5G",
    "Device": "TECNO-Mobile-LH8n",
    "Model": "TECNO Mobile LH8n"
  },
  {
    "Retail Branding": "Tecno Mobile",
    "Marketing Name": "POVA Neo 2",
    "Device": "TECNO-Mobile-LG6n",
    "Model": "TECNO Mobile LG6n"
  },
  {
    "Retail Branding": "Tecno Mobile",
    "Marketing Name": "SPARK Go 2023",
    "Device": "TECNO-Mobile-BF7n",
    "Model": "TECNO Mobile BF7n"
  },
  {
    "Retail Branding": "Tecno Mobile",
    "Marketing Name": "SPARK Go 2024",
    "Device": "TECNO-Mobile-BG6",
    "Model": "TECNO Mobile BG6"
  },
  {
    "Retail Branding": "Tecno Mobile",
    "Marketing Name": "TECNO Mobile POVA 6 Neo",
    "Device": "TECNO-Mobile-LI6",
    "Model": "TECNO Mobile LI6"
  },
  {
    "Retail Branding": "Tecno Mobile",
    "Marketing Name": "TECNO Mobile SPARK 20",
    "Device": "TECNO-Mobile-KJ5n",
    "Model": "TECNO Mobile KJ5n"
  },
  {
    "Retail Branding": "Tecno Mobile",
    "Marketing Name": "TECNO Mobile SPARK 20 Pro+",
    "Device": "TECNO-Mobile-KJ7",
    "Model": "TECNO Mobile KJ7"
  },
  {
    "Retail Branding": "Tecno Mobile",
    "Marketing Name": "TECNO Mobile SPARK 20C",
    "Device": "TECNO-Mobile-BG7n",
    "Model": "TECNO Mobile BG7n"
  },
  {
    "Retail Branding": "Tecno Mobile",
    "Marketing Name": "TECNO Mobile SPARK 30 Pro",
    "Device": "TECNO-Mobile-KL7",
    "Model": "TECNO Mobile KL7"
  },
  {
    "Retail Branding": "Tecno Mobile",
    "Marketing Name": "TECNO SPARK 10",
    "Device": "TECNO-Mobile-KI5q",
    "Model": "TECNO Mobile KI5q"
  },
  {
    "Retail Branding": "Tecno Mobile",
    "Marketing Name": "TECNO SPARK 30 5G",
    "Device": "TECNO-Mobile-KL8",
    "Model": "TECNO Mobile KL8"
  },
  {
    "Retail Branding": "Tecno Mobile",
    "Marketing Name": "TECNO SPARK 30C",
    "Device": "TECNO-Mobile-KL5n",
    "Model": "TECNO Mobile KL5n"
  },
  {
    "Retail Branding": "Tecnomaster",
    "Marketing Name": "EDT800",
    "Device": "EDT800",
    "Model": "EDT800"
  },
  {
    "Retail Branding": "Tecnomaster",
    "Marketing Name": "Smart TV",
    "Device": "osaka",
    "Model": "AI PONT NA"
  },
  {
    "Retail Branding": "Tecnomaster",
    "Marketing Name": "TESHM1863",
    "Device": "TESHM1863",
    "Model": "TESHM1863"
  },
  {
    "Retail Branding": "Tecnomaster",
    "Marketing Name": "TESHM8863",
    "Device": "TESHM8863",
    "Model": "TESHM8863"
  },
  {
    "Retail Branding": "Tecnomaster",
    "Marketing Name": "Tecnomaster",
    "Device": "seocho",
    "Model": "Tecnomaster 4K Android TV"
  },
  {
    "Retail Branding": "Tecnomaster",
    "Marketing Name": "Tecnomaster",
    "Device": "sugamo",
    "Model": "Tecnomaster 2K Android TV"
  },
  {
    "Retail Branding": "Tecnomaster",
    "Marketing Name": "Tecnomaster 2K Android TV",
    "Device": "lasalle",
    "Model": "Tecnomaster 2K Android TV"
  },
  {
    "Retail Branding": "Tecnomaster",
    "Marketing Name": "Tecnomaster 4K Android TV",
    "Device": "kenton",
    "Model": "Tecnomaster 4K Android TV"
  },
  {
    "Retail Branding": "Tectoy",
    "Marketing Name": "TECTOY ON 128GB",
    "Device": "TokyoPro",
    "Model": "TECTOY_5029Y"
  },
  {
    "Retail Branding": "Tectoy",
    "Marketing Name": "TT1000",
    "Device": "TT1000",
    "Model": "TT1000"
  },
  {
    "Retail Branding": "Teeno",
    "Marketing Name": "A1",
    "Device": "A1_EEA",
    "Model": "A1"
  },
  {
    "Retail Branding": "Teeno",
    "Marketing Name": "TEENO S9",
    "Device": "TEENO_S9",
    "Model": "TEENO_S9"
  },
  {
    "Retail Branding": "Teeno",
    "Marketing Name": "TEENO_i12",
    "Device": "TEENO_i12",
    "Model": "TEENO_i12"
  },
  {
    "Retail Branding": "Teesso",
    "Marketing Name": "X2",
    "Device": "X2",
    "Model": "X2"
  },
  {
    "Retail Branding": "Teesso",
    "Marketing Name": "X3",
    "Device": "Teesso_X3",
    "Model": "Teesso X3"
  },
  {
    "Retail Branding": "TekSavvy",
    "Marketing Name": "TekSavvy_DV8219",
    "Device": "DV8219",
    "Model": "TekSavvy_DV8219"
  },
  {
    "Retail Branding": "Teknosa",
    "Marketing Name": "Preo P2",
    "Device": "Preo_P2",
    "Model": "Preo_P2"
  },
  {
    "Retail Branding": "Tekwind",
    "Marketing Name": "A10A",
    "Device": "A10A",
    "Model": "A10A"
  },
  {
    "Retail Branding": "Tekwind",
    "Marketing Name": "Clide A10B",
    "Device": "A10B",
    "Model": "A10B"
  },
  {
    "Retail Branding": "Tekwind",
    "Marketing Name": "TC97RA1",
    "Device": "TC97RA1_1",
    "Model": "TC97RA1"
  },
  {
    "Retail Branding": "Telaeris",
    "Marketing Name": "XPID210",
    "Device": "XPID210",
    "Model": "XPID210"
  },
  {
    "Retail Branding": "Telas",
    "Marketing Name": "RKG107",
    "Device": "RKG107",
    "Model": "RKG107"
  },
  {
    "Retail Branding": "Telas",
    "Marketing Name": "RKG107_EEA",
    "Device": "RKG107_EEA",
    "Model": "RKG107_EEA"
  },
  {
    "Retail Branding": "Telcel",
    "Marketing Name": "i50F",
    "Device": "i50F",
    "Model": "i50F"
  },
  {
    "Retail Branding": "Tele2",
    "Marketing Name": "Maxi",
    "Device": "Tele2_Maxi",
    "Model": "Tele2_Maxi"
  },
  {
    "Retail Branding": "Tele2",
    "Marketing Name": "Maxi 1.1",
    "Device": "TELE2_Maxi_1_1",
    "Model": "TELE2_Maxi_1_1"
  },
  {
    "Retail Branding": "Tele2",
    "Marketing Name": "Maxi_Plus",
    "Device": "Tele2_Maxi_Plus",
    "Model": "Tele2_Maxi_Plus"
  },
  {
    "Retail Branding": "Tele2",
    "Marketing Name": "Midi",
    "Device": "Tele2_Midi",
    "Model": "Tele2"
  },
  {
    "Retail Branding": "Tele2",
    "Marketing Name": "Midi 1.1",
    "Device": "Tele2_Midi_1_1",
    "Model": "Tele2_Midi_1_1"
  },
  {
    "Retail Branding": "Tele2",
    "Marketing Name": "Midi LTE",
    "Device": "Tele2_Midi_LTE",
    "Model": "Tele2_Midi_LTE"
  },
  {
    "Retail Branding": "Tele2",
    "Marketing Name": "Mini",
    "Device": "Tele2_Mini",
    "Model": "Tele2_Mini"
  },
  {
    "Retail Branding": "Tele2",
    "Marketing Name": "Mini 1.1",
    "Device": "Tele2_Mini_1_1",
    "Model": "Tele2_Mini_1.1"
  },
  {
    "Retail Branding": "Tele2",
    "Marketing Name": "Mini 1.1",
    "Device": "Tele2_Mini_1_1",
    "Model": "Tele2_Mini_1_1"
  },
  {
    "Retail Branding": "Tele2",
    "Marketing Name": "Tele 2 Maxi LTE",
    "Device": "Tele2_Maxi_LTE",
    "Model": "Tele2_Maxi_LTE"
  },
  {
    "Retail Branding": "Tele2",
    "Marketing Name": "Tele2_Midi_2_0",
    "Device": "Tele2_Midi_2_0",
    "Model": "Tele2_Midi_2_0"
  },
  {
    "Retail Branding": "Tele2",
    "Marketing Name": "Tele2fon V4",
    "Device": "Tele2fon_v4",
    "Model": "Tele2fon v4"
  },
  {
    "Retail Branding": "Tele2",
    "Marketing Name": "Tele2fon V5",
    "Device": "Tele2fon_v5",
    "Model": "Tele2fon v5"
  },
  {
    "Retail Branding": "Tele2",
    "Marketing Name": "Tv Hub 2",
    "Device": "KSTB4231",
    "Model": "Tv Hub 2"
  },
  {
    "Retail Branding": "Tele2",
    "Marketing Name": "Tv Hub Mini",
    "Device": "SEI700TE",
    "Model": "Tv Hub Mini"
  },
  {
    "Retail Branding": "Telecable",
    "Marketing Name": "Telecable Smart Box",
    "Device": "SEI700TC",
    "Model": "Telecable Smart Box"
  },
  {
    "Retail Branding": "Telecable",
    "Marketing Name": "tedi",
    "Device": "dtiw384",
    "Model": "Telecable ATV"
  },
  {
    "Retail Branding": "Teleepoch",
    "Marketing Name": "",
    "Device": "MaxBravo",
    "Model": "PMI920"
  },
  {
    "Retail Branding": "Teleepoch",
    "Marketing Name": "",
    "Device": "U670C",
    "Model": "U670C"
  },
  {
    "Retail Branding": "Teleepoch",
    "Marketing Name": "",
    "Device": "chaser-921",
    "Model": "Chaser"
  },
  {
    "Retail Branding": "Teleepoch",
    "Marketing Name": "Essentiel B SmartTab 1002",
    "Device": "T9660R",
    "Model": "SmartTAB 1002"
  },
  {
    "Retail Branding": "Teleepoch",
    "Marketing Name": "U675",
    "Device": "U675",
    "Model": "U675"
  },
  {
    "Retail Branding": "Teleepoch",
    "Marketing Name": "UMX U680C",
    "Device": "U680C",
    "Model": "U680C"
  },
  {
    "Retail Branding": "Telefield",
    "Marketing Name": "TF-GZ6100",
    "Device": "TF-GZ6100",
    "Model": "TF-GZ6100"
  },
  {
    "Retail Branding": "Telefunken",
    "Marketing Name": "Enjoy TE1",
    "Device": "TE1",
    "Model": "TE1"
  },
  {
    "Retail Branding": "Telefunken",
    "Marketing Name": "TEL-1013GIQA",
    "Device": "TEL-1013GIQA",
    "Model": "TEL-1013GIQA"
  },
  {
    "Retail Branding": "Telefunken",
    "Marketing Name": "TEL-1014GIQ",
    "Device": "TEL-1014GIQ",
    "Model": "TEL-1014GIQ"
  },
  {
    "Retail Branding": "Telefunken",
    "Marketing Name": "TEL-1014GIQA",
    "Device": "TEL-1014GIQA",
    "Model": "TEL-1014GIQA"
  },
  {
    "Retail Branding": "Telefunken",
    "Marketing Name": "TEL-73GIQA",
    "Device": "TEL-73GIQA",
    "Model": "TEL-73GIQA"
  },
  {
    "Retail Branding": "Telefunken",
    "Marketing Name": "TEL-73GIQA11",
    "Device": "TEL-73GIQA11",
    "Model": "TEL-73GIQA11"
  },
  {
    "Retail Branding": "Telefunken",
    "Marketing Name": "TEL-74GIQA",
    "Device": "TEL-74GIQA",
    "Model": "TEL-74GIQA"
  },
  {
    "Retail Branding": "Telefunken",
    "Marketing Name": "TELEFUNKEN SMART TV",
    "Device": "SW4H",
    "Model": "TELEFUNKEN SMART TV"
  },
  {
    "Retail Branding": "Telefunken",
    "Marketing Name": "TF501_EC",
    "Device": "TF501_EC",
    "Model": "TF501_EC"
  },
  {
    "Retail Branding": "Telefunken",
    "Marketing Name": "TF5X",
    "Device": "TF5X",
    "Model": "TF5X"
  },
  {
    "Retail Branding": "Telefunken",
    "Marketing Name": "TF6",
    "Device": "TF6",
    "Model": "TF6"
  },
  {
    "Retail Branding": "Telefunken",
    "Marketing Name": "TF600",
    "Device": "TF600",
    "Model": "TF600"
  },
  {
    "Retail Branding": "Telefunken",
    "Marketing Name": "TelefunkenTV",
    "Device": "shibuya",
    "Model": "TelefunkenTV"
  },
  {
    "Retail Branding": "Telefunken",
    "Marketing Name": "VP73_Telefunken",
    "Device": "Telefunken",
    "Model": "VP73_Telefunken"
  },
  {
    "Retail Branding": "Telegenic",
    "Marketing Name": "TELEGENIC-AML-1",
    "Device": "DMTS19TIA",
    "Model": "TELEGENIC-AML-1"
  },
  {
    "Retail Branding": "Telego",
    "Marketing Name": "F10",
    "Device": "F10",
    "Model": "F10"
  },
  {
    "Retail Branding": "Telego",
    "Marketing Name": "F8",
    "Device": "F8",
    "Model": "F8"
  },
  {
    "Retail Branding": "Teleguard",
    "Marketing Name": "TF_GZ5100",
    "Device": "TF_GZ5100",
    "Model": "TF_GZ5100"
  },
  {
    "Retail Branding": "TelekomTV",
    "Marketing Name": "SmartBox",
    "Device": "SEI800DT-Telekom",
    "Model": "SmartBox"
  },
  {
    "Retail Branding": "TelekomTV",
    "Marketing Name": "TelekomTV-STB",
    "Device": "DV8519B-Telekom",
    "Model": "TelekomTV-STB"
  },
  {
    "Retail Branding": "Telelynx",
    "Marketing Name": "TP-MDM107",
    "Device": "TP-MDM107",
    "Model": "TP-MDM107"
  },
  {
    "Retail Branding": "Telemor",
    "Marketing Name": "T8408",
    "Device": "Telemor_T8408",
    "Model": "T8408"
  },
  {
    "Retail Branding": "Telemor",
    "Marketing Name": "T9501",
    "Device": "T9501",
    "Model": "T9501"
  },
  {
    "Retail Branding": "Telemor",
    "Marketing Name": "T9503",
    "Device": "T9503",
    "Model": "T9503"
  },
  {
    "Retail Branding": "Telemor",
    "Marketing Name": "T9503",
    "Device": "Telemor_T9503",
    "Model": "Telemor T9503"
  },
  {
    "Retail Branding": "Telemor",
    "Marketing Name": "Telemor T9502",
    "Device": "T9502",
    "Model": "Telemor T9502"
  },
  {
    "Retail Branding": "Telenet",
    "Marketing Name": "TADAAM Box",
    "Device": "sti6160d332",
    "Model": "TADAAM Box"
  },
  {
    "Retail Branding": "Telenet",
    "Marketing Name": "Tadaam",
    "Device": "sti6160d332",
    "Model": "TADAAM Box"
  },
  {
    "Retail Branding": "Telenor",
    "Marketing Name": "Elite57",
    "Device": "Elite57",
    "Model": "Elite57"
  },
  {
    "Retail Branding": "Telenor",
    "Marketing Name": "Infinity K",
    "Device": "Infinity_K",
    "Model": "Infinity_K"
  },
  {
    "Retail Branding": "Telenor",
    "Marketing Name": "Infinity a2",
    "Device": "b3680",
    "Model": "Infinity_a2"
  },
  {
    "Retail Branding": "Telenor",
    "Marketing Name": "Infinity e2",
    "Device": "i6379",
    "Model": "Infinity_e2"
  },
  {
    "Retail Branding": "Telenor",
    "Marketing Name": "Infinity e3",
    "Device": "Infinity_e3",
    "Model": "Infinity_e3"
  },
  {
    "Retail Branding": "Telenor",
    "Marketing Name": "Infinity k2",
    "Device": "Infinity_k2",
    "Model": "Infinity_k2"
  },
  {
    "Retail Branding": "Telenor",
    "Marketing Name": "Infinity_a",
    "Device": "Telenor_Infinity_a",
    "Model": "Infinity_a"
  },
  {
    "Retail Branding": "Telenor",
    "Marketing Name": "Infinity_e",
    "Device": "Telenor_Infinity_e",
    "Model": "Infinity_e"
  },
  {
    "Retail Branding": "Telenor",
    "Marketing Name": "Infinity_i",
    "Device": "TELENOR_Infinity_i",
    "Model": "Infinity i"
  },
  {
    "Retail Branding": "Telenor",
    "Marketing Name": "K530",
    "Device": "Telenor_K530",
    "Model": "Telenor K530"
  },
  {
    "Retail Branding": "Telenor",
    "Marketing Name": "N940",
    "Device": "Telenor_N940",
    "Model": "Telenor N940"
  },
  {
    "Retail Branding": "Telenor",
    "Marketing Name": "Smart",
    "Device": "Telenor_Smart",
    "Model": "Telenor_Smart"
  },
  {
    "Retail Branding": "Telenor",
    "Marketing Name": "Smart II",
    "Device": "SmartII",
    "Model": "SmartII"
  },
  {
    "Retail Branding": "Telenor",
    "Marketing Name": "Smart plus II",
    "Device": "SmartPlusII",
    "Model": "SmartPlusII"
  },
  {
    "Retail Branding": "Telenor",
    "Marketing Name": "Smart4G",
    "Device": "Telenor_Smart_4G",
    "Model": "Telenor_Smart_4G"
  },
  {
    "Retail Branding": "Telenor",
    "Marketing Name": "Stream Dongle",
    "Device": "DV6113Z-KST",
    "Model": "Streaming Dongle"
  },
  {
    "Retail Branding": "Telenor",
    "Marketing Name": "T-We Boks III",
    "Device": "KSTB7277",
    "Model": "T-We Boks III"
  },
  {
    "Retail Branding": "Telenor",
    "Marketing Name": "Telenor Mediahubb",
    "Device": "vip5702w_tn",
    "Model": "Telenor Mediahubb"
  },
  {
    "Retail Branding": "Telenor",
    "Marketing Name": "V51",
    "Device": "V51",
    "Model": "Infinity_i4"
  },
  {
    "Retail Branding": "Telenor(HU)",
    "Marketing Name": "Hipernet TV Box",
    "Device": "Hipernet_TV_Box_B866V2",
    "Model": "Hipernet TV Box"
  },
  {
    "Retail Branding": "Teleone",
    "Marketing Name": "I06",
    "Device": "I06",
    "Model": "I06"
  },
  {
    "Retail Branding": "Teletab",
    "Marketing Name": "TL-4",
    "Device": "TL-4",
    "Model": "TL-4"
  },
  {
    "Retail Branding": "Teletab",
    "Marketing Name": "TL-5",
    "Device": "TL-5",
    "Model": "TL-5"
  },
  {
    "Retail Branding": "Teletab",
    "Marketing Name": "TL-9",
    "Device": "TL-9",
    "Model": "TL-9"
  },
  {
    "Retail Branding": "Telev8",
    "Marketing Name": "MH700",
    "Device": "MH700",
    "Model": "MH700"
  },
  {
    "Retail Branding": "Telia",
    "Marketing Name": "DV8919X-KET",
    "Device": "DV8919X-KET",
    "Model": "DV8919X-EE"
  },
  {
    "Retail Branding": "Telia",
    "Marketing Name": "DV8919X-LT",
    "Device": "DV8919-KLT",
    "Model": "DV8919X-LT"
  },
  {
    "Retail Branding": "Telia",
    "Marketing Name": "Telia Nordic STB",
    "Device": "DV8919-KST",
    "Model": "Telia Nordic STB"
  },
  {
    "Retail Branding": "Telikom",
    "Marketing Name": "TA810",
    "Device": "TA810",
    "Model": "TA810"
  },
  {
    "Retail Branding": "Telkom",
    "Marketing Name": "TVB-100",
    "Device": "DV8219",
    "Model": "TVB-100"
  },
  {
    "Retail Branding": "Telkom",
    "Marketing Name": "Telkom",
    "Device": "DV8219",
    "Model": "TVB-100"
  },
  {
    "Retail Branding": "Telkom Indonesia",
    "Marketing Name": "Telkom  Indonesia",
    "Device": "DV8219",
    "Model": "AX117 ATV"
  },
  {
    "Retail Branding": "TellyTablet",
    "Marketing Name": "VM_MD_001",
    "Device": "VM_MD_001",
    "Model": "VM_MD_001"
  },
  {
    "Retail Branding": "Telma",
    "Marketing Name": "F1+4G",
    "Device": "TELMA_F1_4G",
    "Model": "TELMA F1+4G"
  },
  {
    "Retail Branding": "Telma",
    "Marketing Name": "F1x4G",
    "Device": "F1x4G",
    "Model": "F1x4G"
  },
  {
    "Retail Branding": "Telma",
    "Marketing Name": "Feel_Plus",
    "Device": "Feel_Plus",
    "Model": "Feel_Plus"
  },
  {
    "Retail Branding": "Telma",
    "Marketing Name": "IFEEL MAX",
    "Device": "TELMA_IFEEL_MAX",
    "Model": "TELMA IFEEL MAX"
  },
  {
    "Retail Branding": "Telma",
    "Marketing Name": "IFeel_Max_4G",
    "Device": "IFeel_Max_4G",
    "Model": "Telma IFeel Max 4G"
  },
  {
    "Retail Branding": "Telma",
    "Marketing Name": "S_Max",
    "Device": "S_Max",
    "Model": "S_Max"
  },
  {
    "Retail Branding": "Telma",
    "Marketing Name": "TELMA FEEL",
    "Device": "TELMA_FEEL",
    "Model": "TELMA FEEL"
  },
  {
    "Retail Branding": "Telma",
    "Marketing Name": "TITAN",
    "Device": "Telma_Titan_4G",
    "Model": "Telma_Titan_4G"
  },
  {
    "Retail Branding": "Telma",
    "Marketing Name": "Telma EGO",
    "Device": "Telma_EGO",
    "Model": "Telma EGO"
  },
  {
    "Retail Branding": "Telma",
    "Marketing Name": "Telma F1XS4G",
    "Device": "Telma_F1XS4G",
    "Model": "Telma F1XS4G"
  },
  {
    "Retail Branding": "Telma",
    "Marketing Name": "Telma i401",
    "Device": "telma_i401",
    "Model": "telma i401"
  },
  {
    "Retail Branding": "Telma",
    "Marketing Name": "Telma_F1Prime4G",
    "Device": "Telma_F1Prime4G",
    "Model": "F1 Prime 4G"
  },
  {
    "Retail Branding": "Telma",
    "Marketing Name": "Telma_F1_Max_4G",
    "Device": "Telma_F1_Max_4G",
    "Model": "Telma_F1_Max_4G"
  },
  {
    "Retail Branding": "Telma",
    "Marketing Name": "Telma_S_Prime",
    "Device": "Telma_S_Prime",
    "Model": "Telma_S_Prime"
  },
  {
    "Retail Branding": "Telma",
    "Marketing Name": "telma_i401",
    "Device": "telma_i401",
    "Model": "telma i401"
  },
  {
    "Retail Branding": "TeloSystems",
    "Marketing Name": "TE580P",
    "Device": "TE580P",
    "Model": "TE580P"
  },
  {
    "Retail Branding": "TeloSystems",
    "Marketing Name": "TE580PS",
    "Device": "TE580PS",
    "Model": "TE580PS"
  },
  {
    "Retail Branding": "TeloSystems",
    "Marketing Name": "TE590P",
    "Device": "TE590P_E",
    "Model": "TE590P_E"
  },
  {
    "Retail Branding": "TeloSystems",
    "Marketing Name": "TE590P",
    "Device": "TE590P_O",
    "Model": "TE590P_O"
  },
  {
    "Retail Branding": "TeloSystems",
    "Marketing Name": "TE590P",
    "Device": "TE590P_U",
    "Model": "TE590P"
  },
  {
    "Retail Branding": "TeloSystems",
    "Marketing Name": "TELO_TE610",
    "Device": "TELO_TE610",
    "Model": "TELO_TE610"
  },
  {
    "Retail Branding": "TeloSystems",
    "Marketing Name": "TELO_TE610_O",
    "Device": "TELO_TE610_O",
    "Model": "TELO_TE610_O"
  },
  {
    "Retail Branding": "TeloSystems",
    "Marketing Name": "Telo_TE590P",
    "Device": "TE590P_U",
    "Model": "TE590P"
  },
  {
    "Retail Branding": "Telpo",
    "Marketing Name": "C1",
    "Device": "C1",
    "Model": "C1"
  },
  {
    "Retail Branding": "Telpo",
    "Marketing Name": "C9",
    "Device": "C9",
    "Model": "C9"
  },
  {
    "Retail Branding": "Telpo",
    "Marketing Name": "C9D",
    "Device": "C9D",
    "Model": "C9D"
  },
  {
    "Retail Branding": "Telpo",
    "Marketing Name": "C9H",
    "Device": "C9H",
    "Model": "C9H"
  },
  {
    "Retail Branding": "Telpo",
    "Marketing Name": "M1",
    "Device": "M1s",
    "Model": "M1s"
  },
  {
    "Retail Branding": "Telpo",
    "Marketing Name": "M10",
    "Device": "M10",
    "Model": "M10 for arm64"
  },
  {
    "Retail Branding": "Telpo",
    "Marketing Name": "M10B",
    "Device": "M10B",
    "Model": "Pos terminal"
  },
  {
    "Retail Branding": "Telpo",
    "Marketing Name": "M1K",
    "Device": "M1K",
    "Model": "M1K"
  },
  {
    "Retail Branding": "Telpo",
    "Marketing Name": "M1T",
    "Device": "M1T",
    "Model": "Mobile POS"
  },
  {
    "Retail Branding": "Telpo",
    "Marketing Name": "M8",
    "Device": "M8",
    "Model": "M8 for arm64"
  },
  {
    "Retail Branding": "Telpo",
    "Marketing Name": "P9",
    "Device": "P9",
    "Model": "P9_arm64"
  },
  {
    "Retail Branding": "Telus",
    "Marketing Name": "HMB2213PW22TS",
    "Device": "HMB2213PW22TS",
    "Model": "HMB2213PW22TS"
  },
  {
    "Retail Branding": "Telus",
    "Marketing Name": "Pik TV Media Box",
    "Device": "HMB2213PW22TS",
    "Model": "HMB2213PW22TS"
  },
  {
    "Retail Branding": "Telus",
    "Marketing Name": "TELUSTV-21T",
    "Device": "uiw4054tlu",
    "Model": "TELUSTV-21T"
  },
  {
    "Retail Branding": "Telus",
    "Marketing Name": "TELUSTV-24S",
    "Device": "SER2024TLU",
    "Model": "TELUSTV-24S"
  },
  {
    "Retail Branding": "Telus",
    "Marketing Name": "UIW4020TLU",
    "Device": "uiw4020tlu",
    "Model": "UIW4020TLU"
  },
  {
    "Retail Branding": "Teracube",
    "Marketing Name": "Teracube 2e",
    "Device": "Teracube_2e",
    "Model": "Teracube 2e"
  },
  {
    "Retail Branding": "Teracube",
    "Marketing Name": "Teracube 2s",
    "Device": "sapphire",
    "Model": "Teracube 2s"
  },
  {
    "Retail Branding": "Teracube",
    "Marketing Name": "Teracube_One",
    "Device": "Teracube_One",
    "Model": "Teracube One"
  },
  {
    "Retail Branding": "Tesco",
    "Marketing Name": "Hudl 2",
    "Device": "HTF8A4",
    "Model": "Hudl 2"
  },
  {
    "Retail Branding": "Tesco",
    "Marketing Name": "Hudl HT7S3",
    "Device": "ht7s3",
    "Model": "Hudl HT7S3"
  },
  {
    "Retail Branding": "Tesco",
    "Marketing Name": "Hudl HT7S3",
    "Device": "ht7s3",
    "Model": "hudl ht7s3"
  },
  {
    "Retail Branding": "Tesco",
    "Marketing Name": "Technika",
    "Device": "ewha",
    "Model": "AQUOS-TVE19J"
  },
  {
    "Retail Branding": "Tesco",
    "Marketing Name": "Technika",
    "Device": "ewha",
    "Model": "TECH-TVE19J"
  },
  {
    "Retail Branding": "Tesco",
    "Marketing Name": "W032I_C3",
    "Device": "w032i_c3",
    "Model": "W032I_C3"
  },
  {
    "Retail Branding": "Tesco",
    "Marketing Name": "hudl 2",
    "Device": "HTF8A4",
    "Model": "Hudl 2"
  },
  {
    "Retail Branding": "Tesla",
    "Marketing Name": "AEONSR570",
    "Device": "AEONSR570",
    "Model": "AEONSR570"
  },
  {
    "Retail Branding": "Tesla",
    "Marketing Name": "EU",
    "Device": "tamachi",
    "Model": "Tesla 2K Android TV"
  },
  {
    "Retail Branding": "Tesla",
    "Marketing Name": "EU",
    "Device": "yeongdeungpo",
    "Model": "Tesla 4K Android TV"
  },
  {
    "Retail Branding": "Tesla",
    "Marketing Name": "EU、UK、AP",
    "Device": "martin",
    "Model": "Tesla Android TV"
  },
  {
    "Retail Branding": "Tesla",
    "Marketing Name": "Europe",
    "Device": "guandu",
    "Model": "Tesla Android TV"
  },
  {
    "Retail Branding": "Tesla",
    "Marketing Name": "Europe",
    "Device": "sepolia",
    "Model": "Tesla Smart TV"
  },
  {
    "Retail Branding": "Tesla",
    "Marketing Name": "Explr 9",
    "Device": "Explr_9",
    "Model": "Explr 9"
  },
  {
    "Retail Branding": "Tesla",
    "Marketing Name": "LEAP-S1",
    "Device": "LAS",
    "Model": "LEAP-S1"
  },
  {
    "Retail Branding": "Tesla",
    "Marketing Name": "M8.1 3G",
    "Device": "TTM813G",
    "Model": "TTM813G"
  },
  {
    "Retail Branding": "Tesla",
    "Marketing Name": "P80X_ROW",
    "Device": "P80X",
    "Model": "P80X"
  },
  {
    "Retail Branding": "Tesla",
    "Marketing Name": "SMARTPHONE3.5",
    "Device": "Tesla_SP3_5",
    "Model": "Tesla_SP3.5"
  },
  {
    "Retail Branding": "Tesla",
    "Marketing Name": "SOUTH AMERICA",
    "Device": "sepolia",
    "Model": "Tesla Google TV"
  },
  {
    "Retail Branding": "Tesla",
    "Marketing Name": "Smartphone 3.4",
    "Device": "Tesla_SP3_4",
    "Model": "Tesla_SP3_4"
  },
  {
    "Retail Branding": "Tesla",
    "Marketing Name": "Smartphone 6.4 Lite",
    "Device": "Tesla_SP6_4_Lite",
    "Model": "Tesla_SP6_4_Lite"
  },
  {
    "Retail Branding": "Tesla",
    "Marketing Name": "South American",
    "Device": "patrick",
    "Model": "Tesla 4K Android TV"
  },
  {
    "Retail Branding": "Tesla",
    "Marketing Name": "TESLA",
    "Device": "zhongshan",
    "Model": "Tesla 4K Android TV"
  },
  {
    "Retail Branding": "Tesla",
    "Marketing Name": "TESLA 2K SMART TV",
    "Device": "umeda",
    "Model": "TESLA 2K SMART TV"
  },
  {
    "Retail Branding": "Tesla",
    "Marketing Name": "TESLA 2K TV",
    "Device": "dongnae",
    "Model": "TESLA 2K TV"
  },
  {
    "Retail Branding": "Tesla",
    "Marketing Name": "TESLA 4K GSMART TV",
    "Device": "anaheim",
    "Model": "TESLA 4K GSMART TV"
  },
  {
    "Retail Branding": "Tesla",
    "Marketing Name": "TESLA 4K GSMART TV FF",
    "Device": "SW6H",
    "Model": "TESLA 4K GSMART TV FF"
  },
  {
    "Retail Branding": "Tesla",
    "Marketing Name": "TESLA 4K SMART TV",
    "Device": "SW6H",
    "Model": "TESLA 4K SMART TV"
  },
  {
    "Retail Branding": "Tesla",
    "Marketing Name": "TESLA 4K SMART TV FF",
    "Device": "SW6H",
    "Model": "TESLA 4K SMART TV FF"
  },
  {
    "Retail Branding": "Tesla",
    "Marketing Name": "TESLA 4K SMART TV FF",
    "Device": "anaheim",
    "Model": "TESLA 4K SMART TV FF"
  },
  {
    "Retail Branding": "Tesla",
    "Marketing Name": "TESLA 4K TV FF",
    "Device": "SW6H",
    "Model": "TESLA 4K TV FF"
  },
  {
    "Retail Branding": "Tesla",
    "Marketing Name": "TESLA 4K TV FF",
    "Device": "anaheim",
    "Model": "TESLA 4K TV FF"
  },
  {
    "Retail Branding": "Tesla",
    "Marketing Name": "Tablet_L7_1",
    "Device": "Tablet_L7_1",
    "Model": "Tesla L7.1"
  },
  {
    "Retail Branding": "Tesla",
    "Marketing Name": "Tesla 2K TV",
    "Device": "shinagawa",
    "Model": "Tesla 2K TV"
  },
  {
    "Retail Branding": "Tesla",
    "Marketing Name": "Tesla S906",
    "Device": "SW4H",
    "Model": "Tesla S906"
  },
  {
    "Retail Branding": "Tesla",
    "Marketing Name": "Tesla Smartphone 3.3",
    "Device": "Tesla_SP3_3",
    "Model": "Tesla_SP3.3"
  },
  {
    "Retail Branding": "Tesla",
    "Marketing Name": "Tesla Smartphone 6.3",
    "Device": "Tesla_SP6_3",
    "Model": "Tesla_SP6.3"
  },
  {
    "Retail Branding": "Tesla",
    "Marketing Name": "Tesla Smartphone 9.1",
    "Device": "L6195",
    "Model": "Tesla_SP9.1"
  },
  {
    "Retail Branding": "Tesla",
    "Marketing Name": "Tesla Smartphone 9.1 Lite",
    "Device": "Tesla_SP9_1_Lite",
    "Model": "Tesla_SP9.1L"
  },
  {
    "Retail Branding": "Tesla",
    "Marketing Name": "Tesla Tablet L8.1",
    "Device": "Tesla_L8_1",
    "Model": "Tesla L8.1"
  },
  {
    "Retail Branding": "Tesla",
    "Marketing Name": "Tesla_9_3",
    "Device": "Tesla_9_3",
    "Model": "Tesla_9_3"
  },
  {
    "Retail Branding": "Tesla",
    "Marketing Name": "Tesla_L8_2",
    "Device": "Tesla_L8_2",
    "Model": "Tesla_L8_2"
  },
  {
    "Retail Branding": "Tesla",
    "Marketing Name": "Tesla_SP3.3 Lite",
    "Device": "Tesla_SP3_3Lite",
    "Model": "Tesla_SP3.3 Lite"
  },
  {
    "Retail Branding": "Tesla",
    "Marketing Name": "Tesla_SP6_4_Lite",
    "Device": "Tesla_SP6_4_Lite",
    "Model": "Tesla_SP6_4_Lite"
  },
  {
    "Retail Branding": "Tesla",
    "Marketing Name": "Tesla_SP9.1",
    "Device": "L6195",
    "Model": "Tesla_SP9.1"
  },
  {
    "Retail Branding": "Tesla",
    "Marketing Name": "Tesla_SP9_2",
    "Device": "Tesla_SP9_2",
    "Model": "Tesla_SP9_2"
  },
  {
    "Retail Branding": "Tesla",
    "Marketing Name": "Venezuela",
    "Device": "martin",
    "Model": "Tesla 2K Android TV"
  },
  {
    "Retail Branding": "Tesla",
    "Marketing Name": "Venezuela",
    "Device": "martin",
    "Model": "Tesla Android TV"
  },
  {
    "Retail Branding": "Tesla",
    "Marketing Name": "Venezuela",
    "Device": "patrick",
    "Model": "Tesla Android TV"
  },
  {
    "Retail Branding": "Tetratab",
    "Marketing Name": "TF10EA2",
    "Device": "TF10EA2_Medical_1",
    "Model": "CASEBOOK_3"
  },
  {
    "Retail Branding": "Tevau",
    "Marketing Name": "T1",
    "Device": "T1",
    "Model": "T1"
  },
  {
    "Retail Branding": "The Edge",
    "Marketing Name": "NLE",
    "Device": "oversea_v",
    "Model": "NLE"
  },
  {
    "Retail Branding": "TheNudge",
    "Marketing Name": "Smartboard_Ai",
    "Device": "oversea_v",
    "Model": "HDJN"
  },
  {
    "Retail Branding": "ThinkAcademy",
    "Marketing Name": "T100",
    "Device": "T100",
    "Model": "T100"
  },
  {
    "Retail Branding": "Thinpad",
    "Marketing Name": "TH805",
    "Device": "TH805",
    "Model": "TH805"
  },
  {
    "Retail Branding": "Thomson",
    "Marketing Name": 150,
    "Device": "YYR",
    "Model": "Thomson 150"
  },
  {
    "Retail Branding": "Thomson",
    "Marketing Name": 270,
    "Device": "SNA",
    "Model": 270
  },
  {
    "Retail Branding": "Thomson",
    "Marketing Name": "32TG6A9",
    "Device": "ikebukuro",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "Thomson",
    "Marketing Name": "5014G_EEA",
    "Device": "5014G",
    "Model": "5014G"
  },
  {
    "Retail Branding": "Thomson",
    "Marketing Name": "50TG7UA9X",
    "Device": "samseong",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "Thomson",
    "Marketing Name": "Android TV",
    "Device": "R1",
    "Model": "ATV R1"
  },
  {
    "Retail Branding": "Thomson",
    "Marketing Name": "Android TV",
    "Device": "R2",
    "Model": "ATV R2"
  },
  {
    "Retail Branding": "Thomson",
    "Marketing Name": "Delight TH201",
    "Device": "Delight_TH201",
    "Model": "Delight TH201"
  },
  {
    "Retail Branding": "Thomson",
    "Marketing Name": "EBK_5014G",
    "Device": "EBK_5014G",
    "Model": "EBK_5014G"
  },
  {
    "Retail Branding": "Thomson",
    "Marketing Name": "EBL-5304G",
    "Device": "EBL_5304G",
    "Model": "EBL-5304G"
  },
  {
    "Retail Branding": "Thomson",
    "Marketing Name": "EGO_5014G",
    "Device": "EGO_5014G",
    "Model": "EGO_5014G"
  },
  {
    "Retail Branding": "Thomson",
    "Marketing Name": "EMEA",
    "Device": "sepolia",
    "Model": "Thomson 4K Smart TV"
  },
  {
    "Retail Branding": "Thomson",
    "Marketing Name": "Europe",
    "Device": "guandu",
    "Model": "Thomson TV"
  },
  {
    "Retail Branding": "Thomson",
    "Marketing Name": "Europe",
    "Device": "martin",
    "Model": "Thomson TV"
  },
  {
    "Retail Branding": "Thomson",
    "Marketing Name": "Friendly TH101",
    "Device": "Friendly_TH101",
    "Model": "Friendly_TH101"
  },
  {
    "Retail Branding": "Thomson",
    "Marketing Name": "HERO10RK",
    "Device": "HERO10RK_EEA",
    "Model": "HERO10RK"
  },
  {
    "Retail Branding": "Thomson",
    "Marketing Name": "Hero10RK",
    "Device": "HERO10RK",
    "Model": "HERO10RK"
  },
  {
    "Retail Branding": "Thomson",
    "Marketing Name": "LEAP-S1",
    "Device": "LAS",
    "Model": "LEAP-S1"
  },
  {
    "Retail Branding": "Thomson",
    "Marketing Name": "LEAP-S3+",
    "Device": "YDA",
    "Model": "4K Google TV Box"
  },
  {
    "Retail Branding": "Thomson",
    "Marketing Name": "Origin_1010_EEA",
    "Device": "Origin_1010",
    "Model": "Origin_1010"
  },
  {
    "Retail Branding": "Thomson",
    "Marketing Name": "Origin_679",
    "Device": "Origin_679",
    "Model": "Origin_679"
  },
  {
    "Retail Branding": "Thomson",
    "Marketing Name": "PRIMO7 Tablet",
    "Device": "PRIMO7",
    "Model": "PRIMO7"
  },
  {
    "Retail Branding": "Thomson",
    "Marketing Name": "PRIMO8 Tablet",
    "Device": "AMLMY8306P",
    "Model": "PRIMO8"
  },
  {
    "Retail Branding": "Thomson",
    "Marketing Name": "R3",
    "Device": "R3",
    "Model": "R3"
  },
  {
    "Retail Branding": "Thomson",
    "Marketing Name": "R4",
    "Device": "R4",
    "Model": "R4"
  },
  {
    "Retail Branding": "Thomson",
    "Marketing Name": "SPPL 2K GSmartTV",
    "Device": "umeda",
    "Model": "SPPL 2K GSmartTV"
  },
  {
    "Retail Branding": "Thomson",
    "Marketing Name": "SPPL 4K GSmartTV",
    "Device": "SW6H",
    "Model": "SPPL 4K GSmartTV"
  },
  {
    "Retail Branding": "Thomson",
    "Marketing Name": "SPPL 4K GSmartTV FF",
    "Device": "SW6H",
    "Model": "SPPL 4K GSmartTV FF"
  },
  {
    "Retail Branding": "Thomson",
    "Marketing Name": "Smart TV",
    "Device": "redwood",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "Thomson",
    "Marketing Name": "T13M4BK64LTE",
    "Device": "TEO13M",
    "Model": "T13M4BK64LTE"
  },
  {
    "Retail Branding": "Thomson",
    "Marketing Name": "T240G",
    "Device": "YXQ",
    "Model": "Thomson 240G"
  },
  {
    "Retail Branding": "Thomson",
    "Marketing Name": "TEO 8",
    "Device": "TEO8LTE32",
    "Model": "TEO8LTE"
  },
  {
    "Retail Branding": "Thomson",
    "Marketing Name": "TEO10",
    "Device": "TEO10",
    "Model": "SPTEO10BK16"
  },
  {
    "Retail Branding": "Thomson",
    "Marketing Name": "TEO10-KID2BL32",
    "Device": "TEO10-KID2BL32",
    "Model": "TEO10-KID2BL32"
  },
  {
    "Retail Branding": "Thomson",
    "Marketing Name": "TEO104G",
    "Device": "TEO104G",
    "Model": "TEO104G"
  },
  {
    "Retail Branding": "Thomson",
    "Marketing Name": "TEO10A",
    "Device": "TEO10A1BK32",
    "Model": "TEO10A"
  },
  {
    "Retail Branding": "Thomson",
    "Marketing Name": "TEO10A",
    "Device": "TEO10A2BK32P_EEA",
    "Model": "TEO10A"
  },
  {
    "Retail Branding": "Thomson",
    "Marketing Name": "TEO10A",
    "Device": "TEO10A4BK64P_EEA",
    "Model": "TEO10A"
  },
  {
    "Retail Branding": "Thomson",
    "Marketing Name": "TEO13P",
    "Device": "TEO13P",
    "Model": "TEO13P"
  },
  {
    "Retail Branding": "Thomson",
    "Marketing Name": "TEO7RK",
    "Device": "TEO7RK",
    "Model": "TEO7RK"
  },
  {
    "Retail Branding": "Thomson",
    "Marketing Name": "TEO8-A2BK32",
    "Device": "TEO8-A2BK32",
    "Model": "TEO8-A2BK32"
  },
  {
    "Retail Branding": "Thomson",
    "Marketing Name": "TEO84G",
    "Device": "TEO84G332",
    "Model": "TEO84G"
  },
  {
    "Retail Branding": "Thomson",
    "Marketing Name": "TEO8M2BK32LTE",
    "Device": "TEO8M2BK32LTE",
    "Model": "TEO8M"
  },
  {
    "Retail Branding": "Thomson",
    "Marketing Name": "TEO8M4BK64",
    "Device": "TE08",
    "Model": "TEO8M4BK64"
  },
  {
    "Retail Branding": "Thomson",
    "Marketing Name": "TEOX10-MT8SL128LTE",
    "Device": "TEOX10-MT8SL128LTE",
    "Model": "TEOX10-MT8SL128LTE"
  },
  {
    "Retail Branding": "Thomson",
    "Marketing Name": "TEOX102",
    "Device": "TEOX102",
    "Model": "TEOX102"
  },
  {
    "Retail Branding": "Thomson",
    "Marketing Name": "TEOX103",
    "Device": "TEOX103",
    "Model": "TEOX103"
  },
  {
    "Retail Branding": "Thomson",
    "Marketing Name": "THOMSON GS-SMART",
    "Device": "SW6H",
    "Model": "THOMSON GS-SMART"
  },
  {
    "Retail Branding": "Thomson",
    "Marketing Name": "THOMSON GS-SMART",
    "Device": "anaheim",
    "Model": "THOMSON GS-SMART"
  },
  {
    "Retail Branding": "Thomson",
    "Marketing Name": "THOMSON SEREA500",
    "Device": "L35_A",
    "Model": "THOMSON SEREA500"
  },
  {
    "Retail Branding": "Thomson",
    "Marketing Name": "THOMSON_TEO10S",
    "Device": "TEO10S",
    "Model": "TEO10S"
  },
  {
    "Retail Branding": "Thomson",
    "Marketing Name": "TLink 455",
    "Device": "TLINK455",
    "Model": "TLINK455"
  },
  {
    "Retail Branding": "Thomson",
    "Marketing Name": "Thomson 140G",
    "Device": "YZF",
    "Model": "Thomson 140G"
  },
  {
    "Retail Branding": "Thomson",
    "Marketing Name": "Thomson Smart TV",
    "Device": "dongnae",
    "Model": "Thomson Smart TV"
  },
  {
    "Retail Branding": "Thomson",
    "Marketing Name": "Thomson T50",
    "Device": "Thomson_T50",
    "Model": "Thomson T50"
  },
  {
    "Retail Branding": "Thomson",
    "Marketing Name": "Thomson TV",
    "Device": "marina",
    "Model": "Thomson TV"
  },
  {
    "Retail Branding": "Thomson",
    "Marketing Name": "Thomson TV",
    "Device": "nagata",
    "Model": "Thomson TV"
  },
  {
    "Retail Branding": "Thomson",
    "Marketing Name": "ThomsonTV",
    "Device": "shibuya",
    "Model": "ThomsonTV"
  },
  {
    "Retail Branding": "Thomson",
    "Marketing Name": "Thomson_Go",
    "Device": "Thomson_Go",
    "Model": "Thomson Go"
  },
  {
    "Retail Branding": "Thrive",
    "Marketing Name": "NT-T710",
    "Device": "NT-T710",
    "Model": "NT-T710"
  },
  {
    "Retail Branding": "Thuraya",
    "Marketing Name": "Thuraya X5-Touch",
    "Device": "X5-Touch",
    "Model": "Thuraya X5-Touch"
  },
  {
    "Retail Branding": "TiVo Stream 4K",
    "Marketing Name": "TiVo Stream 4K",
    "Device": "SEI400TV",
    "Model": "TiVo Stream 4K"
  },
  {
    "Retail Branding": "Tibuta",
    "Marketing Name": "A10_M_EU",
    "Device": "A10_M_EU",
    "Model": "A10_M_EU"
  },
  {
    "Retail Branding": "Tibuta",
    "Marketing Name": "A30",
    "Device": "A30",
    "Model": "A30"
  },
  {
    "Retail Branding": "Tibuta",
    "Marketing Name": "A40",
    "Device": "A40",
    "Model": "A40"
  },
  {
    "Retail Branding": "Tibuta",
    "Marketing Name": "A70W_A_EU",
    "Device": "A70W_A_EU",
    "Model": "A70W_A_EU"
  },
  {
    "Retail Branding": "Tibuta",
    "Marketing Name": "E100_25EU",
    "Device": "E100_25EU",
    "Model": "E100_25EU"
  },
  {
    "Retail Branding": "Tibuta",
    "Marketing Name": "E100_25US",
    "Device": "E100_25US",
    "Model": "E100_25US"
  },
  {
    "Retail Branding": "Tibuta",
    "Marketing Name": "E100_R25_EU",
    "Device": "E100_R25_EU",
    "Model": "E100_R25_EU"
  },
  {
    "Retail Branding": "Tibuta",
    "Marketing Name": "E101",
    "Device": "E101",
    "Model": "E101"
  },
  {
    "Retail Branding": "Tibuta",
    "Marketing Name": "E220_M_EU",
    "Device": "E220_M_EU",
    "Model": "E220_M_EU"
  },
  {
    "Retail Branding": "Tibuta",
    "Marketing Name": "SmartPad_E220",
    "Device": "SmartPad_E220",
    "Model": "SmartPad_E220"
  },
  {
    "Retail Branding": "Tibuta",
    "Marketing Name": "TAB_868_PRO",
    "Device": "TAB_868_PRO",
    "Model": "TAB_868_PRO"
  },
  {
    "Retail Branding": "Tibuta",
    "Marketing Name": "Tibuta_MasterPad-E100",
    "Device": "Tibuta_MasterPad-E100",
    "Model": "Tibuta_MasterPad-E100"
  },
  {
    "Retail Branding": "Tibuta",
    "Marketing Name": "Tibuta_MasterPad-T100",
    "Device": "Tibuta_MasterPad-T100",
    "Model": "Tibuta_MasterPad-T100"
  },
  {
    "Retail Branding": "Tibuta",
    "Marketing Name": "Tibuta_MasterPad-W200",
    "Device": "MasterPad-W200",
    "Model": "Tibuta_MasterPad-W200"
  },
  {
    "Retail Branding": "Tibuta",
    "Marketing Name": "Tibuta_MasterPad_K100",
    "Device": "Tibuta_MasterPad_K100",
    "Model": "Tibuta_MasterPad_K100"
  },
  {
    "Retail Branding": "Tigers",
    "Marketing Name": "TIS001",
    "Device": "TIS001",
    "Model": "TIS001"
  },
  {
    "Retail Branding": "Tigers",
    "Marketing Name": "TIS001",
    "Device": "TIS001-T2",
    "Model": "TIS001-T2"
  },
  {
    "Retail Branding": "Tigers",
    "Marketing Name": "TIS001-S3",
    "Device": "TIS001-S3",
    "Model": "TIS001-S3"
  },
  {
    "Retail Branding": "Tigers",
    "Marketing Name": "TIS001A",
    "Device": "TIS001A",
    "Model": "TIS001A"
  },
  {
    "Retail Branding": "Tigers",
    "Marketing Name": "TIS001B",
    "Device": "TIS001B",
    "Model": "TIS001B"
  },
  {
    "Retail Branding": "Tigers",
    "Marketing Name": "TIS001C",
    "Device": "TIS001C",
    "Model": "TIS001C"
  },
  {
    "Retail Branding": "Tigers",
    "Marketing Name": "TIS001_S4",
    "Device": "TIS001_S4",
    "Model": "TIS001_S4"
  },
  {
    "Retail Branding": "Tigers",
    "Marketing Name": "TIS_001",
    "Device": "TIS_001",
    "Model": "TIS_001"
  },
  {
    "Retail Branding": "Tigers",
    "Marketing Name": "TWIFI_08",
    "Device": "TWIFI_08",
    "Model": "TWIFI_08"
  },
  {
    "Retail Branding": "Tigers",
    "Marketing Name": "TWIFI_09",
    "Device": "TWIFI_09",
    "Model": "TWIFI_09"
  },
  {
    "Retail Branding": "Tigorr",
    "Marketing Name": "Z7",
    "Device": "Z7",
    "Model": "Z7"
  },
  {
    "Retail Branding": "Tiitan",
    "Marketing Name": "T54",
    "Device": "T54",
    "Model": "T54"
  },
  {
    "Retail Branding": "Time2",
    "Marketing Name": "TIME2",
    "Device": "TP1060J",
    "Model": "TP1060J"
  },
  {
    "Retail Branding": "Time2",
    "Marketing Name": "TIME2",
    "Device": "TP860P",
    "Model": "TP860B"
  },
  {
    "Retail Branding": "Timmy",
    "Marketing Name": "M40_plus",
    "Device": "M40_plus",
    "Model": "M40_plus"
  },
  {
    "Retail Branding": "Timmy",
    "Marketing Name": "M40_pro",
    "Device": "M40_pro",
    "Model": "M40_pro"
  },
  {
    "Retail Branding": "Timmy",
    "Marketing Name": "M68_Plus",
    "Device": "M68_Plus",
    "Model": "M68_Plus"
  },
  {
    "Retail Branding": "Timor Telecom",
    "Marketing Name": "V500",
    "Device": "V500",
    "Model": "V500"
  },
  {
    "Retail Branding": "Timovi",
    "Marketing Name": "Epix",
    "Device": "Epix",
    "Model": "Epix"
  },
  {
    "Retail Branding": "Timovi",
    "Marketing Name": "Infinit Lite 2",
    "Device": "Timovi_Infinit_Lite_2",
    "Model": "Infinit_Lite_2"
  },
  {
    "Retail Branding": "Timovi",
    "Marketing Name": "Infinit MX Pro",
    "Device": "Infinit_MX_Pro",
    "Model": "Infinit MX Pro"
  },
  {
    "Retail Branding": "Timovi",
    "Marketing Name": "Insignia Delta 2",
    "Device": "Insignia_Delta_2",
    "Model": "Insignia Delta 2"
  },
  {
    "Retail Branding": "Timovi",
    "Marketing Name": "Insignia_Lab",
    "Device": "Insignia_Lab",
    "Model": "Insignia_Lab"
  },
  {
    "Retail Branding": "Timovi",
    "Marketing Name": "Timovi",
    "Device": "Insignia_Delta_2",
    "Model": "Insignia Delta 2"
  },
  {
    "Retail Branding": "Timovi",
    "Marketing Name": "Timovi Infinit MX",
    "Device": "Timovi_Infinit_MX",
    "Model": "Infinit MX"
  },
  {
    "Retail Branding": "Timovi",
    "Marketing Name": "Timovi Infinit X CAM",
    "Device": "Timovi_Infinit_X_CAM",
    "Model": "Infinit_X_CAM"
  },
  {
    "Retail Branding": "Timovi",
    "Marketing Name": "Timovi_Vision_PRO",
    "Device": "Timovi_Vision_PRO",
    "Model": "Vision_PRO"
  },
  {
    "Retail Branding": "Timovi",
    "Marketing Name": "VISION ULTRA",
    "Device": "VISION_ULTRA",
    "Model": "VISION ULTRA"
  },
  {
    "Retail Branding": "Timovi",
    "Marketing Name": "Yeah_Go",
    "Device": "Yeah_Go",
    "Model": "Yeah_Go"
  },
  {
    "Retail Branding": "Tinhvan",
    "Marketing Name": "TA80TA1",
    "Device": "TA80TA1_1",
    "Model": "TA80TA1"
  },
  {
    "Retail Branding": "Tinmo",
    "Marketing Name": "K1",
    "Device": "K1",
    "Model": "K1"
  },
  {
    "Retail Branding": "Tinp",
    "Marketing Name": "HaTV",
    "Device": "DV8330-C",
    "Model": "HaTV"
  },
  {
    "Retail Branding": "Tinp",
    "Marketing Name": "Play TV",
    "Device": "DV8219",
    "Model": "Play TV"
  },
  {
    "Retail Branding": "Tiwell",
    "Marketing Name": "AP-115G",
    "Device": "AP-115G",
    "Model": "AP-115G"
  },
  {
    "Retail Branding": "Tiwell",
    "Marketing Name": "AP-727G",
    "Device": "AP-727G",
    "Model": "AP-727G"
  },
  {
    "Retail Branding": "Tiwell",
    "Marketing Name": "AS-501",
    "Device": "AS_501",
    "Model": "AS_501"
  },
  {
    "Retail Branding": "Tiwell",
    "Marketing Name": "AS-502",
    "Device": "t662_dh4_tiwell",
    "Model": "AS-502"
  },
  {
    "Retail Branding": "Tiwell",
    "Marketing Name": "AS-503",
    "Device": "t662_gq_tiwell",
    "Model": "AS-503"
  },
  {
    "Retail Branding": "Tiwell",
    "Marketing Name": "AS_401L",
    "Device": "AS_401L",
    "Model": "AS_401L"
  },
  {
    "Retail Branding": "Tiwell",
    "Marketing Name": "AS_601L",
    "Device": "AS_601L",
    "Model": "AS_601L"
  },
  {
    "Retail Branding": "Tobii DynaVox",
    "Marketing Name": "T10+",
    "Device": "T10plus",
    "Model": "T10+"
  },
  {
    "Retail Branding": "Tobii DynaVox",
    "Marketing Name": "T7",
    "Device": "T7",
    "Model": "T7"
  },
  {
    "Retail Branding": "Todos",
    "Marketing Name": "TABAI1",
    "Device": "TABAI1",
    "Model": "TABAI1"
  },
  {
    "Retail Branding": "Todos",
    "Marketing Name": "Tab64",
    "Device": "Tab64",
    "Model": "Tab64"
  },
  {
    "Retail Branding": "Togocel",
    "Marketing Name": "S63",
    "Device": "S63",
    "Model": "S63"
  },
  {
    "Retail Branding": "Togocel",
    "Marketing Name": "Togocel EGO plus",
    "Device": "Togocel_EGO_plus",
    "Model": "Togocel EGO plus"
  },
  {
    "Retail Branding": "Togocel",
    "Marketing Name": "Togocel_F1_Max_4G",
    "Device": "Togocel_F1_Max_4G",
    "Model": "Togocel_F1_Max_4G"
  },
  {
    "Retail Branding": "Tokio",
    "Marketing Name": "Phablet_III",
    "Device": "Phablet_III",
    "Model": "Phablet III"
  },
  {
    "Retail Branding": "Tokio",
    "Marketing Name": "Tokio_Tablet_8",
    "Device": "Tokio_Tablet_8",
    "Model": "Tokio_Tablet_8"
  },
  {
    "Retail Branding": "TomStar",
    "Marketing Name": "A1000",
    "Device": "A1000",
    "Model": "A1000"
  },
  {
    "Retail Branding": "TomStar",
    "Marketing Name": "A1020",
    "Device": "A1020",
    "Model": "A1020"
  },
  {
    "Retail Branding": "TomStar",
    "Marketing Name": "A1110",
    "Device": "A1110",
    "Model": "A1110"
  },
  {
    "Retail Branding": "TomStar",
    "Marketing Name": "G6_pro",
    "Device": "G6_pro",
    "Model": "G6_pro"
  },
  {
    "Retail Branding": "Tonino Lamborghini",
    "Marketing Name": "Antares",
    "Device": "TL66",
    "Model": "TL66"
  },
  {
    "Retail Branding": "Tonino Lamborghini",
    "Marketing Name": "Antares",
    "Device": "TL_Antares",
    "Model": "Antares"
  },
  {
    "Retail Branding": "Tonino Lamborghini",
    "Marketing Name": "TL99",
    "Device": "ailsa_ii",
    "Model": "TL99"
  },
  {
    "Retail Branding": "Tonino Lamborghini",
    "Marketing Name": "TL99G",
    "Device": "ailsa_ii",
    "Model": "TL99G"
  },
  {
    "Retail Branding": "Topicon",
    "Marketing Name": "Topicon MDT1060",
    "Device": "mdt1060",
    "Model": "mdt1060"
  },
  {
    "Retail Branding": "Topicon",
    "Marketing Name": "mdt865_gms",
    "Device": "mdt865",
    "Model": "mdt865"
  },
  {
    "Retail Branding": "Topicon",
    "Marketing Name": "mdt865_row",
    "Device": "mdt865",
    "Model": "mdt865"
  },
  {
    "Retail Branding": "Topsand",
    "Marketing Name": "G12",
    "Device": "G12_A14",
    "Model": "G12"
  },
  {
    "Retail Branding": "Topsand",
    "Marketing Name": "G12_Pro",
    "Device": "G12_Pro",
    "Model": "G12_Pro"
  },
  {
    "Retail Branding": "Topsand",
    "Marketing Name": "M8_U",
    "Device": "M8_U",
    "Model": "M8"
  },
  {
    "Retail Branding": "Topsand",
    "Marketing Name": "N10",
    "Device": "N10_T",
    "Model": "N10"
  },
  {
    "Retail Branding": "Topsand",
    "Marketing Name": "N8",
    "Device": "N8",
    "Model": "N8"
  },
  {
    "Retail Branding": "Topsand",
    "Marketing Name": "N8_KIDS",
    "Device": "N8_KIDS",
    "Model": "N8 KIDS"
  },
  {
    "Retail Branding": "Topsand",
    "Marketing Name": "N8_Plus",
    "Device": "N8_Plus",
    "Model": "N8_Plus"
  },
  {
    "Retail Branding": "Topwise",
    "Marketing Name": "SK210",
    "Device": "SK210",
    "Model": "SK210"
  },
  {
    "Retail Branding": "Torex",
    "Marketing Name": "Rugged_tablets",
    "Device": "Torex8plus",
    "Model": "Torex8plus"
  },
  {
    "Retail Branding": "Tormaxx",
    "Marketing Name": "TX_R-824",
    "Device": "TX_R-824",
    "Model": "TX_R-824"
  },
  {
    "Retail Branding": "Toshiba",
    "Marketing Name": "",
    "Device": "WDPF-703TI",
    "Model": "Hikari-iFrame/WDPF-703TI"
  },
  {
    "Retail Branding": "Toshiba",
    "Marketing Name": "",
    "Device": "tosebook01",
    "Model": "DB50"
  },
  {
    "Retail Branding": "Toshiba",
    "Marketing Name": "",
    "Device": "tostab05",
    "Model": "AT200"
  },
  {
    "Retail Branding": "Toshiba",
    "Marketing Name": "",
    "Device": "tostabg1",
    "Model": "LT170"
  },
  {
    "Retail Branding": "Toshiba",
    "Marketing Name": "2007-100",
    "Device": "TCxM7",
    "Model": "2007-100"
  },
  {
    "Retail Branding": "Toshiba",
    "Marketing Name": "2011-100",
    "Device": "TCxM11",
    "Model": "2011-100"
  },
  {
    "Retail Branding": "Toshiba",
    "Marketing Name": "2K TV",
    "Device": "songshan",
    "Model": "2K Toshiba TV"
  },
  {
    "Retail Branding": "Toshiba",
    "Marketing Name": "4K TV",
    "Device": "songshan",
    "Model": "Toshiba TV"
  },
  {
    "Retail Branding": "Toshiba",
    "Marketing Name": "4K TV",
    "Device": "songshan",
    "Model": "Toshiba TV with MIC"
  },
  {
    "Retail Branding": "Toshiba",
    "Marketing Name": "A204",
    "Device": "tos14ast10",
    "Model": "A204"
  },
  {
    "Retail Branding": "Toshiba",
    "Marketing Name": "A205",
    "Device": "tos15ast20",
    "Model": "A205"
  },
  {
    "Retail Branding": "Toshiba",
    "Marketing Name": "AT10-A/AT15-A (Japan: AT503)",
    "Device": "tostab12BL",
    "Model": "AT10-A"
  },
  {
    "Retail Branding": "Toshiba",
    "Marketing Name": "AT10-A/AT15-A (Japan: AT503)",
    "Device": "tostab12BL",
    "Model": "AT502"
  },
  {
    "Retail Branding": "Toshiba",
    "Marketing Name": "AT10-A/AT15-A (Japan: AT503)",
    "Device": "tostab12BL",
    "Model": "AT503"
  },
  {
    "Retail Branding": "Toshiba",
    "Marketing Name": "AT10-A/AT15-A (Japan: AT503)",
    "Device": "tostab12BL",
    "Model": "AT503_HEMS"
  },
  {
    "Retail Branding": "Toshiba",
    "Marketing Name": "AT100",
    "Device": "tostab03",
    "Model": "AT100"
  },
  {
    "Retail Branding": "Toshiba",
    "Marketing Name": "AT100",
    "Device": "tostab03",
    "Model": "Tostab03"
  },
  {
    "Retail Branding": "Toshiba",
    "Marketing Name": "AT10LE-A/AT15LE-A/AT10PE-A/AT15PE-A  (Japan: AT703)",
    "Device": "tostab12BA",
    "Model": "AT10LE-A"
  },
  {
    "Retail Branding": "Toshiba",
    "Marketing Name": "AT10LE-A/AT15LE-A/AT10PE-A/AT15PE-A  (Japan: AT703)",
    "Device": "tostab12BA",
    "Model": "AT10PE-A"
  },
  {
    "Retail Branding": "Toshiba",
    "Marketing Name": "AT10LE-A/AT15LE-A/AT10PE-A/AT15PE-A  (Japan: AT703)",
    "Device": "tostab12BA",
    "Model": "AT702"
  },
  {
    "Retail Branding": "Toshiba",
    "Marketing Name": "AT10LE-A/AT15LE-A/AT10PE-A/AT15PE-A  (Japan: AT703)",
    "Device": "tostab12BA",
    "Model": "AT703"
  },
  {
    "Retail Branding": "Toshiba",
    "Marketing Name": "AT400",
    "Device": "tostab12AL",
    "Model": "AT300SE"
  },
  {
    "Retail Branding": "Toshiba",
    "Marketing Name": "AT400",
    "Device": "tostab12AL",
    "Model": "AT400"
  },
  {
    "Retail Branding": "Toshiba",
    "Marketing Name": "AT7-A",
    "Device": "tost7t",
    "Model": "AT374"
  },
  {
    "Retail Branding": "Toshiba",
    "Marketing Name": "AT7-A",
    "Device": "tost7t",
    "Model": "AT7-A"
  },
  {
    "Retail Branding": "Toshiba",
    "Marketing Name": "AT7-B",
    "Device": "tos13t7gt",
    "Model": "AT374"
  },
  {
    "Retail Branding": "Toshiba",
    "Marketing Name": "AT7-B",
    "Device": "tos13t7gt",
    "Model": "AT7-B"
  },
  {
    "Retail Branding": "Toshiba",
    "Marketing Name": "AT7-C",
    "Device": "tos14riy20",
    "Model": "A17"
  },
  {
    "Retail Branding": "Toshiba",
    "Marketing Name": "AT7-C",
    "Device": "tos14riy20",
    "Model": "AT7-C"
  },
  {
    "Retail Branding": "Toshiba",
    "Marketing Name": "JP:REGZA Tablet AT570  Others:TOSHIBA AT270",
    "Device": "tostab11BS",
    "Model": "AT270"
  },
  {
    "Retail Branding": "Toshiba",
    "Marketing Name": "JP:REGZA Tablet AT570  Others:TOSHIBA AT270",
    "Device": "tostab11BS",
    "Model": "AT470"
  },
  {
    "Retail Branding": "Toshiba",
    "Marketing Name": "JP:REGZA Tablet AT570  Others:TOSHIBA AT270",
    "Device": "tostab11BS",
    "Model": "AT570"
  },
  {
    "Retail Branding": "Toshiba",
    "Marketing Name": "JPN:REGZA Tablet AT500  Other countries:TOSHIBA AT300",
    "Device": "tostab11BA",
    "Model": "AT300"
  },
  {
    "Retail Branding": "Toshiba",
    "Marketing Name": "JPN:REGZA Tablet AT500  Other countries:TOSHIBA AT300",
    "Device": "tostab11BA",
    "Model": "AT500"
  },
  {
    "Retail Branding": "Toshiba",
    "Marketing Name": "JPN:REGZA Tablet AT500  Other countries:TOSHIBA AT300",
    "Device": "tostab11BA",
    "Model": "AT500a"
  },
  {
    "Retail Branding": "Toshiba",
    "Marketing Name": "JPN:REGZA Tablet AT830 Other countries:TOSHIBA AT330",
    "Device": "tostab11BT",
    "Model": "AT330"
  },
  {
    "Retail Branding": "Toshiba",
    "Marketing Name": "JPN:REGZA Tablet AT830 Other countries:TOSHIBA AT330",
    "Device": "tostab11BT",
    "Model": "AT830"
  },
  {
    "Retail Branding": "Toshiba",
    "Marketing Name": "L4300",
    "Device": "l4300",
    "Model": "l4300"
  },
  {
    "Retail Branding": "Toshiba",
    "Marketing Name": "L5450",
    "Device": "tostv14rtk1",
    "Model": "l5400"
  },
  {
    "Retail Branding": "Toshiba",
    "Marketing Name": "L5450",
    "Device": "tostv14rtk1",
    "Model": "l5450"
  },
  {
    "Retail Branding": "Toshiba",
    "Marketing Name": "L5450/L5400",
    "Device": "tostv14rtk1",
    "Model": "l5400"
  },
  {
    "Retail Branding": "Toshiba",
    "Marketing Name": "L5450/L5400",
    "Device": "tostv14rtk1",
    "Model": "l5450"
  },
  {
    "Retail Branding": "Toshiba",
    "Marketing Name": "L5450/L5400",
    "Device": "tostv14rtk2",
    "Model": "l5400"
  },
  {
    "Retail Branding": "Toshiba",
    "Marketing Name": "L5450/L5400",
    "Device": "tostv14rtk2",
    "Model": "l5450"
  },
  {
    "Retail Branding": "Toshiba",
    "Marketing Name": "L5450C",
    "Device": "l5450",
    "Model": "l3453"
  },
  {
    "Retail Branding": "Toshiba",
    "Marketing Name": "L5450C",
    "Device": "l5450",
    "Model": "l5450"
  },
  {
    "Retail Branding": "Toshiba",
    "Marketing Name": "L5450ME",
    "Device": "tostv14rtk2",
    "Model": "l5400"
  },
  {
    "Retail Branding": "Toshiba",
    "Marketing Name": "L5450ME",
    "Device": "tostv14rtk2",
    "Model": "l5450"
  },
  {
    "Retail Branding": "Toshiba",
    "Marketing Name": "L5550/L5551/L5552",
    "Device": "tostv15rtk2",
    "Model": "l5550"
  },
  {
    "Retail Branding": "Toshiba",
    "Marketing Name": "L9450",
    "Device": "l9450",
    "Model": "l9450"
  },
  {
    "Retail Branding": "Toshiba",
    "Marketing Name": "Mozart",
    "Device": "Mozart",
    "Model": "Mozart"
  },
  {
    "Retail Branding": "Toshiba",
    "Marketing Name": "STB10",
    "Device": "TOSPASB",
    "Model": "TOSPASB"
  },
  {
    "Retail Branding": "Toshiba",
    "Marketing Name": "SmartTV 4K",
    "Device": "hengshan",
    "Model": "SmartTV 4K FFM"
  },
  {
    "Retail Branding": "Toshiba",
    "Marketing Name": "TD-E657TS",
    "Device": "xinnong",
    "Model": "HIDB 4K"
  },
  {
    "Retail Branding": "Toshiba",
    "Marketing Name": "TD-E757TS",
    "Device": "ligen",
    "Model": "HIDB 4K"
  },
  {
    "Retail Branding": "Toshiba",
    "Marketing Name": "TOSHIBA TV",
    "Device": "hirano",
    "Model": "TOSHIBA TV"
  },
  {
    "Retail Branding": "Toshiba",
    "Marketing Name": "Thrive 7",
    "Device": "tostab04",
    "Model": "AT1S0"
  },
  {
    "Retail Branding": "Toshiba",
    "Marketing Name": "Toshiba Chromebook 2 (2015 Edition)",
    "Device": "gandof_cheets",
    "Model": "Toshiba Chromebook 2 (2015 Edition)"
  },
  {
    "Retail Branding": "Toshiba",
    "Marketing Name": "ToshibaTV",
    "Device": "hayward",
    "Model": "ToshibaTV"
  },
  {
    "Retail Branding": "Toshiba",
    "Marketing Name": "Toshiba_TV",
    "Device": "MTK9632",
    "Model": "Toshiba_TV"
  },
  {
    "Retail Branding": "Toshiba",
    "Marketing Name": "Toshiba_TV",
    "Device": "MTK9652",
    "Model": "Toshiba_TV"
  },
  {
    "Retail Branding": "Toshiba",
    "Marketing Name": "Toshiba_TV",
    "Device": "NOVA72685",
    "Model": "Toshiba_TV"
  },
  {
    "Retail Branding": "Toshiba",
    "Marketing Name": "fushan_Toshiba",
    "Device": "hamamatsucho",
    "Model": "HiSmart 2K ATV4"
  },
  {
    "Retail Branding": "Toshiba",
    "Marketing Name": "fushan_euT",
    "Device": "hamamatsucho",
    "Model": "Smart TV"
  },
  {
    "Retail Branding": "Toshiba",
    "Marketing Name": "huangshan_emT",
    "Device": "huangshan",
    "Model": "Toshiba TV"
  },
  {
    "Retail Branding": "Toshiba",
    "Marketing Name": "huashan_emT",
    "Device": "hayward",
    "Model": "Toshiba TV"
  },
  {
    "Retail Branding": "Toshiba",
    "Marketing Name": "laoshan_Toshiba",
    "Device": "laoshan",
    "Model": "U7900"
  },
  {
    "Retail Branding": "Toshiba",
    "Marketing Name": "lushan-Toshiba",
    "Device": "lushan",
    "Model": "SmartTV 4K"
  },
  {
    "Retail Branding": "Toshiba",
    "Marketing Name": "lushan-Toshiba-FFM",
    "Device": "lushan",
    "Model": "SmartTV 4K FFM"
  },
  {
    "Retail Branding": "Toshiba",
    "Marketing Name": "taishan-jpT",
    "Device": "taishan",
    "Model": "SmartTV FFM"
  },
  {
    "Retail Branding": "Toshiba",
    "Marketing Name": "tt300/tt301/tt302",
    "Device": "Mozart",
    "Model": "Mozart"
  },
  {
    "Retail Branding": "Toshiba",
    "Marketing Name": "xiaoyushan_emT",
    "Device": "xiaoyushan",
    "Model": "HiSmartTV A4"
  },
  {
    "Retail Branding": "Toshiba",
    "Marketing Name": "xiaoyushan_etT",
    "Device": "xiaoyushan",
    "Model": "HiSmartTV A4"
  },
  {
    "Retail Branding": "Toshiba Tec Corporation",
    "Marketing Name": "TBL-300",
    "Device": "TBL-300",
    "Model": "TBL-300"
  },
  {
    "Retail Branding": "Tototheo",
    "Marketing Name": "Armor X",
    "Device": "ArmorX",
    "Model": "ArmorX"
  },
  {
    "Retail Branding": "Touch plus",
    "Marketing Name": "1100AS",
    "Device": "1100AS",
    "Model": "1100AS"
  },
  {
    "Retail Branding": "Touch plus",
    "Marketing Name": "770G",
    "Device": "770G",
    "Model": "770G"
  },
  {
    "Retail Branding": "Touch plus",
    "Marketing Name": "770N",
    "Device": "770N",
    "Model": "770N"
  },
  {
    "Retail Branding": "Touch plus",
    "Marketing Name": "AS1000",
    "Device": "AS1000",
    "Model": "AS1000"
  },
  {
    "Retail Branding": "Touchmate",
    "Marketing Name": "TM-MID1010",
    "Device": "TM-MID1010",
    "Model": "TM-MID1010"
  },
  {
    "Retail Branding": "Touchmate",
    "Marketing Name": "TM-MID1010NB",
    "Device": "TM-MID1010NB",
    "Model": "TM-MID1010NB"
  },
  {
    "Retail Branding": "Touchmate",
    "Marketing Name": "TM-MID1050B",
    "Device": "TM-MID1050B",
    "Model": "TM-MID1050B"
  },
  {
    "Retail Branding": "Touchmate",
    "Marketing Name": "TM-MID1065",
    "Device": "TM-MID1065",
    "Model": "TM-MID1065"
  },
  {
    "Retail Branding": "Touchmate",
    "Marketing Name": "TM-MID1080",
    "Device": "TM-MID1080",
    "Model": "TM-MID1080"
  },
  {
    "Retail Branding": "Touchmate",
    "Marketing Name": "TM-MID792SB",
    "Device": "TM_MID792SB",
    "Model": "TM-MID792SB"
  },
  {
    "Retail Branding": "Touchmate",
    "Marketing Name": "TM-MID794",
    "Device": "TM-MID794",
    "Model": "TM-MID794"
  },
  {
    "Retail Branding": "Touchmate",
    "Marketing Name": "TM-MID795",
    "Device": "TM-MID795",
    "Model": "TM-MID795"
  },
  {
    "Retail Branding": "Touchmate",
    "Marketing Name": "TM-MID880PRO",
    "Device": "TM-MID880PRO",
    "Model": "TM-MID880PRO"
  },
  {
    "Retail Branding": "Touchmate",
    "Marketing Name": "TM-TAB1085",
    "Device": "TM-TAB1085",
    "Model": "TM-TAB1085"
  },
  {
    "Retail Branding": "Touchmate",
    "Marketing Name": "TM_MID792WP",
    "Device": "TM_MID792WP",
    "Model": "TM-MID792WP"
  },
  {
    "Retail Branding": "Touchmate",
    "Marketing Name": "TOUCHMATE-TM-MID811A",
    "Device": "TM-MID811A",
    "Model": "TOUCHMATE-TM-MID811A"
  },
  {
    "Retail Branding": "Touchview Interactive",
    "Marketing Name": "SD_ODMGM02",
    "Device": "TouchView_Companion",
    "Model": "TouchView Companion"
  },
  {
    "Retail Branding": "Touchview Interactive",
    "Marketing Name": "TVULTRA98_G5",
    "Device": "TVULTRA98_G5",
    "Model": "TVULTRA98_G5"
  },
  {
    "Retail Branding": "Touchview Interactive",
    "Marketing Name": "TouchView_Gen6",
    "Device": "TouchView_Gen6",
    "Model": "TouchView_Gen6"
  },
  {
    "Retail Branding": "Touchview Interactive",
    "Marketing Name": "Touchview_Interactive",
    "Device": "TV_G5UPGRADE",
    "Model": "TV_G5UPGRADE"
  },
  {
    "Retail Branding": "Toughshield",
    "Marketing Name": "R200",
    "Device": "R200",
    "Model": "R200"
  },
  {
    "Retail Branding": "Toughshield",
    "Marketing Name": "T700_TABLET",
    "Device": "T700_TABLET",
    "Model": "T700"
  },
  {
    "Retail Branding": "Toush",
    "Marketing Name": "4K FF SMART TV",
    "Device": "SW6H",
    "Model": "4K FF SMART TV"
  },
  {
    "Retail Branding": "Toyota",
    "Marketing Name": "Toyota",
    "Device": "TSA",
    "Model": "OTT"
  },
  {
    "Retail Branding": "Tpad",
    "Marketing Name": "T255",
    "Device": "T255",
    "Model": "T255"
  },
  {
    "Retail Branding": "Tpad",
    "Marketing Name": "TPAD-F45A",
    "Device": "Tpad-F45A",
    "Model": "Tpad-F45A"
  },
  {
    "Retail Branding": "Tpad",
    "Marketing Name": "TPAD-T30B_EEA",
    "Device": "TPAD-T30B",
    "Model": "TPAD-T30B"
  },
  {
    "Retail Branding": "Transvision",
    "Marketing Name": "SEI500TR",
    "Device": "SEI500TR",
    "Model": "TRANSVISION-Xstream"
  },
  {
    "Retail Branding": "Transvision",
    "Marketing Name": "TRANSVISION-OTT-Box",
    "Device": "UHD_I56AD_TRV",
    "Model": "TRANSVISION-OTT-Box"
  },
  {
    "Retail Branding": "Transvision",
    "Marketing Name": "TRANSVISION-Xstream",
    "Device": "SEI500TR",
    "Model": "TRANSVISION-Xstream"
  },
  {
    "Retail Branding": "Transvision",
    "Marketing Name": "Transvision",
    "Device": "USB6_IR80",
    "Model": "TRANSVISION-iTV"
  },
  {
    "Retail Branding": "TravelWifi",
    "Marketing Name": "Sapphire Tablet",
    "Device": "Sapphire_Tablet",
    "Model": "S_TAB"
  },
  {
    "Retail Branding": "Trayoo",
    "Marketing Name": "K13",
    "Device": "K13",
    "Model": "K13"
  },
  {
    "Retail Branding": "Trecfone",
    "Marketing Name": "17 Pro Max",
    "Device": "17_Pro_Max",
    "Model": "17_Pro_Max"
  },
  {
    "Retail Branding": "Trecfone",
    "Marketing Name": "T15",
    "Device": "T15",
    "Model": "T15"
  },
  {
    "Retail Branding": "Trecfone",
    "Marketing Name": "T20",
    "Device": "T20",
    "Model": "T20"
  },
  {
    "Retail Branding": "Trecfone",
    "Marketing Name": "TRECFONE S26",
    "Device": "S26",
    "Model": "S26"
  },
  {
    "Retail Branding": "Trecfone",
    "Marketing Name": "Trecfone_16 Pro Max",
    "Device": "16_Pro_Max",
    "Model": "16 Pro Max"
  },
  {
    "Retail Branding": "Trecfone",
    "Marketing Name": "V30",
    "Device": "V30",
    "Model": "V30"
  },
  {
    "Retail Branding": "Trecfone",
    "Marketing Name": "V35",
    "Device": "V35",
    "Model": "V35"
  },
  {
    "Retail Branding": "Trekstor",
    "Marketing Name": "SurfTab ST70204-3",
    "Device": "TREKM7100KLD",
    "Model": "SurfTab ST70204-3"
  },
  {
    "Retail Branding": "Trekstor",
    "Marketing Name": "SurfTab breeze 9.6 quad",
    "Device": "SurfTab",
    "Model": "TrekStor SurfTab breeze 9.6 quad"
  },
  {
    "Retail Branding": "Trekstor",
    "Marketing Name": "SurfTab breeze 9.6 quad 3G",
    "Device": "ST9641602",
    "Model": "TrekStor SurfTab breeze 9.6 quad 3G"
  },
  {
    "Retail Branding": "Trekstor",
    "Marketing Name": "SurfTab breeze 9.6 quad 3G",
    "Device": "ST9643203",
    "Model": "TrekStor SurfTab breeze 9.6 quad 3G"
  },
  {
    "Retail Branding": "Trekstor",
    "Marketing Name": "SurfTab xintron i 7.0",
    "Device": "st70408_4_coho",
    "Model": "st70408_4"
  },
  {
    "Retail Branding": "Trekstor",
    "Marketing Name": "SurfTab xintron i 7.0",
    "Device": "st70408_4_coho",
    "Model": "st70408_4_coho"
  },
  {
    "Retail Branding": "Trekstor",
    "Marketing Name": "TFMTKAW01232",
    "Device": "TFMTKAW01232",
    "Model": "TFMTKAW01232"
  },
  {
    "Retail Branding": "Trekstor",
    "Marketing Name": "THMTKAL01232_eea",
    "Device": "THMTKAL01232",
    "Model": "Trekstor Surftab Y10"
  },
  {
    "Retail Branding": "Trekstor",
    "Marketing Name": "THMTKAW03232_eea",
    "Device": "THMTKAW03232",
    "Model": "Trekstor Surftab Y10"
  },
  {
    "Retail Branding": "Trekstor",
    "Marketing Name": "THMTKAW04232_eea",
    "Device": "THMTKAW04232",
    "Model": "PEAQ PET 100"
  },
  {
    "Retail Branding": "Trekstor",
    "Marketing Name": "Trekstor Surftab B10",
    "Device": "THMTKAW01232",
    "Model": "Trekstor Surftab B10"
  },
  {
    "Retail Branding": "Trekstor",
    "Marketing Name": "Trekstor Surftab theatre K13",
    "Device": "TFMTKAW01216",
    "Model": "Trekstor Surftab theatre K13"
  },
  {
    "Retail Branding": "Trekstor",
    "Marketing Name": "Trekstor Surftab theatre S11",
    "Device": "TFMTKAW01332",
    "Model": "Trekstor Surftab theatre S11"
  },
  {
    "Retail Branding": "Trekstor",
    "Marketing Name": "tolino tab 7",
    "Device": "tolino7",
    "Model": "tolino tab 7"
  },
  {
    "Retail Branding": "Trekstor",
    "Marketing Name": "tolino tab 8",
    "Device": "tolino8",
    "Model": "tolino tab 8"
  },
  {
    "Retail Branding": "Trekstor",
    "Marketing Name": "tolino tab 8.9",
    "Device": "tolino89",
    "Model": "tolino tab 8.9"
  },
  {
    "Retail Branding": "Trend Mobile",
    "Marketing Name": "ECHO",
    "Device": "Trend_Echo",
    "Model": "Trend Echo"
  },
  {
    "Retail Branding": "Trend Mobile",
    "Marketing Name": "Lite_07",
    "Device": "Lite_07",
    "Model": "Lite 07"
  },
  {
    "Retail Branding": "Trend Mobile",
    "Marketing Name": "Meta_17",
    "Device": "Meta_17",
    "Model": "Meta 17"
  },
  {
    "Retail Branding": "Trend Mobile",
    "Marketing Name": "Prime_100",
    "Device": "Prime_100",
    "Model": "Prime 100"
  },
  {
    "Retail Branding": "Trend Mobile",
    "Marketing Name": "T5",
    "Device": "T5",
    "Model": "T5"
  },
  {
    "Retail Branding": "Trend Mobile",
    "Marketing Name": "TREND_T4",
    "Device": "TREND_T4",
    "Model": "TREND_T4"
  },
  {
    "Retail Branding": "Trend Solar",
    "Marketing Name": "TS-X",
    "Device": "TRENDPHONE2_0",
    "Model": "TS-X"
  },
  {
    "Retail Branding": "Trevi",
    "Marketing Name": "KID-Tab-7-S03_EEA",
    "Device": "KID-Tab-7-S03_EEA",
    "Model": "KID-Tab-7-S03"
  },
  {
    "Retail Branding": "Trevi",
    "Marketing Name": "KIDTAB_7_S04",
    "Device": "KIDTAB_7_S04",
    "Model": "KIDTAB_7_S04"
  },
  {
    "Retail Branding": "Trevi",
    "Marketing Name": "Retailer Stores",
    "Device": "KID_TAB_7_S02",
    "Model": "KID_TAB_7_S02"
  },
  {
    "Retail Branding": "Trevi",
    "Marketing Name": "Tab104GS2",
    "Device": "Tab104GS2",
    "Model": "Tab104GS2"
  },
  {
    "Retail Branding": "TriaPlay",
    "Marketing Name": "TriaPlayBox",
    "Device": "TriaPlayBox",
    "Model": "TriaPlayBox"
  },
  {
    "Retail Branding": "Trident",
    "Marketing Name": "A23 Max",
    "Device": "A23_Max",
    "Model": "A23 Max"
  },
  {
    "Retail Branding": "Trident",
    "Marketing Name": "A23_Max",
    "Device": "A23_Max",
    "Model": "A23 Max"
  },
  {
    "Retail Branding": "Trident",
    "Marketing Name": "A24",
    "Device": "A24",
    "Model": "A24"
  },
  {
    "Retail Branding": "Trident",
    "Marketing Name": "A25",
    "Device": "A25",
    "Model": "A25"
  },
  {
    "Retail Branding": "Trident",
    "Marketing Name": "A43",
    "Device": "A43",
    "Model": "A43"
  },
  {
    "Retail Branding": "Trident",
    "Marketing Name": "A53 PRO",
    "Device": "A53_PRO",
    "Model": "A53 PRO"
  },
  {
    "Retail Branding": "Trident",
    "Marketing Name": "A54",
    "Device": "A54",
    "Model": "A54"
  },
  {
    "Retail Branding": "Trident",
    "Marketing Name": "A55",
    "Device": "A55",
    "Model": "A55"
  },
  {
    "Retail Branding": "Trident",
    "Marketing Name": "A60",
    "Device": "A60",
    "Model": "A60"
  },
  {
    "Retail Branding": "Trident",
    "Marketing Name": "A75 Pro Max",
    "Device": "A75",
    "Model": "Trident A75 Pro Max"
  },
  {
    "Retail Branding": "Trifone",
    "Marketing Name": "Passion-1S",
    "Device": "Passion-1S",
    "Model": "Passion-1S"
  },
  {
    "Retail Branding": "Trifone",
    "Marketing Name": "Passion-Plus",
    "Device": "Passion-Plus",
    "Model": "Passion-Plus"
  },
  {
    "Retail Branding": "Trifone",
    "Marketing Name": "Passion1",
    "Device": "Passion1",
    "Model": "Passion1"
  },
  {
    "Retail Branding": "Trifone",
    "Marketing Name": "Passion_Pro",
    "Device": "Passion_Pro",
    "Model": "Passion_Pro"
  },
  {
    "Retail Branding": "Trifone",
    "Marketing Name": "T-FASHION",
    "Device": "T-FASHION",
    "Model": "T-FASHION"
  },
  {
    "Retail Branding": "Trifone",
    "Marketing Name": "TRI_POWER",
    "Device": "TRIFONE_TRI_POWER",
    "Model": "TRI_POWER"
  },
  {
    "Retail Branding": "Trifone",
    "Marketing Name": "Trifone_X7",
    "Device": "Trifone_X7",
    "Model": "Trifone_X7"
  },
  {
    "Retail Branding": "Trifone",
    "Marketing Name": "X701",
    "Device": "X701",
    "Model": "X701"
  },
  {
    "Retail Branding": "Trimble Navigation",
    "Marketing Name": "MM50",
    "Device": "EE773X_4G",
    "Model": "MobileMapper50_4G"
  },
  {
    "Retail Branding": "Trimble Navigation",
    "Marketing Name": "MM50",
    "Device": "EE773X_4G",
    "Model": "TDC100_4G"
  },
  {
    "Retail Branding": "Trimble Navigation",
    "Marketing Name": "MM50",
    "Device": "EE773X_WiFi",
    "Model": "MobileMapper50_WiFi"
  },
  {
    "Retail Branding": "Trimble Navigation",
    "Marketing Name": "MM50",
    "Device": "EE773X_WiFi",
    "Model": "TDC100_WiFi"
  },
  {
    "Retail Branding": "Trimble Navigation",
    "Marketing Name": "MobileDisplayTerminal",
    "Device": "PD5",
    "Model": "PD5"
  },
  {
    "Retail Branding": "Trimble Navigation",
    "Marketing Name": "Nomad 5",
    "Device": "pdog",
    "Model": "Nomad 5"
  },
  {
    "Retail Branding": "Trimble Navigation",
    "Marketing Name": "PeopleNet ConnectedTablet",
    "Device": "MS5",
    "Model": "MS5"
  },
  {
    "Retail Branding": "Trimble Navigation",
    "Marketing Name": "Ranger 5",
    "Device": "bcat",
    "Model": "RGR5"
  },
  {
    "Retail Branding": "Trimble Navigation",
    "Marketing Name": "TD-520",
    "Device": "td520",
    "Model": "TD520"
  },
  {
    "Retail Branding": "Trimble Navigation",
    "Marketing Name": "TDC100_WiFi",
    "Device": "EE773X_WiFi",
    "Model": "MobileMapper50_WiFi"
  },
  {
    "Retail Branding": "Trimble Navigation",
    "Marketing Name": "TDC100_WiFi",
    "Device": "EE773X_WiFi",
    "Model": "TDC100_WiFi"
  },
  {
    "Retail Branding": "Trimble Navigation",
    "Marketing Name": "TDC500 Handheld",
    "Device": "workhorse",
    "Model": "TDC500"
  },
  {
    "Retail Branding": "Trimble Navigation",
    "Marketing Name": "TDC500 Handheld",
    "Device": "workhorse_wifi",
    "Model": "TDC500"
  },
  {
    "Retail Branding": "Trimble Navigation",
    "Marketing Name": "TDC600/MM60",
    "Device": "E7167",
    "Model": "MobileMapper60"
  },
  {
    "Retail Branding": "Trimble Navigation",
    "Marketing Name": "TDC600/MM60",
    "Device": "E7167",
    "Model": "TDC600"
  },
  {
    "Retail Branding": "Trimble Navigation",
    "Marketing Name": "TDC600_2",
    "Device": "TDC600_2",
    "Model": "TDC600_2"
  },
  {
    "Retail Branding": "Trimble Navigation",
    "Marketing Name": "TDC800 Handheld",
    "Device": "pelican",
    "Model": "TDC800"
  },
  {
    "Retail Branding": "Trimble Navigation",
    "Marketing Name": "TDC800 Handheld",
    "Device": "pelican_wifi",
    "Model": "TDC800"
  },
  {
    "Retail Branding": "Trimble Navigation",
    "Marketing Name": "TDI 600",
    "Device": "ulmo_pro",
    "Model": "Rugged Tablet"
  },
  {
    "Retail Branding": "Trimble Navigation",
    "Marketing Name": "TDI 600",
    "Device": "ulmo_pro",
    "Model": "TDI 600"
  },
  {
    "Retail Branding": "Trimble Navigation",
    "Marketing Name": "TSC5",
    "Device": "bcat",
    "Model": "TSC5"
  },
  {
    "Retail Branding": "Trimble Navigation",
    "Marketing Name": "TSC510",
    "Device": "meerkat",
    "Model": "TSC510"
  },
  {
    "Retail Branding": "Trimble Navigation",
    "Marketing Name": "TSC710",
    "Device": "akita",
    "Model": "TSC710"
  },
  {
    "Retail Branding": "Trimble Navigation",
    "Marketing Name": "Trimble ConnectedTablet",
    "Device": "MS5",
    "Model": "MS5"
  },
  {
    "Retail Branding": "Trimble Navigation",
    "Marketing Name": "Trimble DUO",
    "Device": "DUO",
    "Model": "DUO"
  },
  {
    "Retail Branding": "Trimble Navigation",
    "Marketing Name": "Trimble TDC6",
    "Device": "TDC6",
    "Model": "TDC6"
  },
  {
    "Retail Branding": "Trio",
    "Marketing Name": 7.85,
    "Device": "astar-y3",
    "Model": "TRIO-7.85"
  },
  {
    "Retail Branding": "Trio",
    "Marketing Name": "7.85 vQ",
    "Device": "Trio-785-vQ",
    "Model": "Trio 7.85 vQ"
  },
  {
    "Retail Branding": "Trio",
    "Marketing Name": "AXS 3G",
    "Device": "Trio_AXS_3G",
    "Model": "Trio AXS 3G"
  },
  {
    "Retail Branding": "Trio",
    "Marketing Name": "MINI",
    "Device": "Trio-MINI",
    "Model": "Trio MINI"
  },
  {
    "Retail Branding": "Trio",
    "Marketing Name": "MST711",
    "Device": "nuclear-MST711",
    "Model": "MST711"
  },
  {
    "Retail Branding": "Trio",
    "Marketing Name": "Stealth G4 7",
    "Device": "Trio-Stealth-G4-7",
    "Model": "Trio-Stealth-G4-7"
  },
  {
    "Retail Branding": "Trio",
    "Marketing Name": "Stealth-G4-101",
    "Device": "Trio-Stealth-G4-101",
    "Model": "Trio-Stealth G4 10.1"
  },
  {
    "Retail Branding": "Trio",
    "Marketing Name": "Stealth-G4-7.85",
    "Device": "Trio-Stealth-G4-785",
    "Model": "Trio-Stealth-G4-7.85"
  },
  {
    "Retail Branding": "Trouver",
    "Marketing Name": "Fk01",
    "Device": "Fk01",
    "Model": "Fk01"
  },
  {
    "Retail Branding": "True",
    "Marketing Name": 20721400,
    "Device": "Tablet",
    "Model": 20721400
  },
  {
    "Retail Branding": "True",
    "Marketing Name": "20721400E_EEA",
    "Device": "Tablet",
    "Model": "20721400E"
  },
  {
    "Retail Branding": "True",
    "Marketing Name": "20721400R",
    "Device": "Tablet",
    "Model": "20721400R"
  },
  {
    "Retail Branding": "True",
    "Marketing Name": 20725300,
    "Device": "Tablet",
    "Model": 20725300
  },
  {
    "Retail Branding": "True",
    "Marketing Name": "20725300E_EEA",
    "Device": "Tablet",
    "Model": "20725300E"
  },
  {
    "Retail Branding": "True",
    "Marketing Name": "20725300R",
    "Device": "Tablet",
    "Model": "20725300R"
  },
  {
    "Retail Branding": "True",
    "Marketing Name": 20726600,
    "Device": "Tablet",
    "Model": 20726600
  },
  {
    "Retail Branding": "True",
    "Marketing Name": 20728200,
    "Device": "Tablet",
    "Model": 20728200
  },
  {
    "Retail Branding": "True",
    "Marketing Name": "20728200E_EEA",
    "Device": "Tablet",
    "Model": "20728200E"
  },
  {
    "Retail Branding": "True",
    "Marketing Name": "20728200R",
    "Device": "Tablet",
    "Model": "20728200R"
  },
  {
    "Retail Branding": "True",
    "Marketing Name": "Alpha_5G",
    "Device": "Alpha_5G",
    "Model": "Alpha 5G"
  },
  {
    "Retail Branding": "True",
    "Marketing Name": "HCH03",
    "Device": "TrueHCH03",
    "Model": "HCH03"
  },
  {
    "Retail Branding": "True",
    "Marketing Name": "S1",
    "Device": "S1",
    "Model": "S1"
  },
  {
    "Retail Branding": "True",
    "Marketing Name": "S1A",
    "Device": "S1A",
    "Model": "S1A"
  },
  {
    "Retail Branding": "True",
    "Marketing Name": "SMART 4G Adventure",
    "Device": "SMART_4G_ADVENTURE",
    "Model": "SMART 4G Adventure"
  },
  {
    "Retail Branding": "True",
    "Marketing Name": "SMART 4G Adventure Pro",
    "Device": "SMART_4G",
    "Model": "SMART 4G Adventure Pro"
  },
  {
    "Retail Branding": "True",
    "Marketing Name": "SMART 4G Champion",
    "Device": "SMART_4G_Champion",
    "Model": "SMART 4G Champion"
  },
  {
    "Retail Branding": "True",
    "Marketing Name": "SMART 4G GEN C 4.0",
    "Device": "SMART_4G_GEN_C_4",
    "Model": "SMART 4G GEN C 4.0"
  },
  {
    "Retail Branding": "True",
    "Marketing Name": "SMART 4G GEN C 5.0",
    "Device": "SMART_4G_GEN_C_5",
    "Model": "SMART 4G GEN C 5.0"
  },
  {
    "Retail Branding": "True",
    "Marketing Name": "SMART 4G M1",
    "Device": "SMART_4G_M1",
    "Model": "SMART 4G M1"
  },
  {
    "Retail Branding": "True",
    "Marketing Name": "SMART 4G M1 Plus",
    "Device": "SMART_4G_M1_Plus",
    "Model": "SMART 4G M1 Plus"
  },
  {
    "Retail Branding": "True",
    "Marketing Name": "SMART 4G Octa 5.5",
    "Device": "M636T",
    "Model": "SMART 4G Octa 5.5"
  },
  {
    "Retail Branding": "True",
    "Marketing Name": "SMART 4G P1",
    "Device": "SMART_4G_P1",
    "Model": "SMART 4G P1"
  },
  {
    "Retail Branding": "True",
    "Marketing Name": "SMART 4G P1 Prime",
    "Device": "SMART_4G_P1_PRIME",
    "Model": "SMART 4G P1 Prime"
  },
  {
    "Retail Branding": "True",
    "Marketing Name": "SMART TAB 4G M1",
    "Device": "SMART_TAB_4G_M1",
    "Model": "SMART TAB 4G M1"
  },
  {
    "Retail Branding": "True",
    "Marketing Name": "SMART TAB 4G e-Biz",
    "Device": "SMART_TAB_4G_e-Biz",
    "Model": "SMART TAB 4G e-Biz"
  },
  {
    "Retail Branding": "True",
    "Marketing Name": "SMART TAB 4G e-Biz PRO",
    "Device": "SMART_TAB_4G_e-Biz_PRO",
    "Model": "SMART TAB 4G e-Biz PRO"
  },
  {
    "Retail Branding": "True",
    "Marketing Name": "SMART_4G_GEN_C_5.5",
    "Device": "SMART_4G_GEN_C_5_5",
    "Model": "SMART 4G GEN C 5.5"
  },
  {
    "Retail Branding": "True",
    "Marketing Name": "SMART_Champ_4inch",
    "Device": "SMART_Champ_4inch",
    "Model": "SMART Champ 4.0"
  },
  {
    "Retail Branding": "True",
    "Marketing Name": "SMART_MAX_4.0_PLUS",
    "Device": "P909",
    "Model": "SMART_MAX_4.0_PLUS"
  },
  {
    "Retail Branding": "True",
    "Marketing Name": "True ID TV",
    "Device": "TrueHPH07",
    "Model": "HPH07"
  },
  {
    "Retail Branding": "True",
    "Marketing Name": "TrueID TV",
    "Device": "TV_A01",
    "Model": "STI6030_TRUE_TV_A01"
  },
  {
    "Retail Branding": "True",
    "Marketing Name": "TrueID TV",
    "Device": "TrueHPH07",
    "Model": "HPH07"
  },
  {
    "Retail Branding": "TrueBoard",
    "Marketing Name": "750TAIO",
    "Device": "TAIO",
    "Model": "750TAIO"
  },
  {
    "Retail Branding": "TrueIDTV",
    "Marketing Name": "CHMT52",
    "Device": "GIU7AG0D",
    "Model": "CHMT52"
  },
  {
    "Retail Branding": "TrueIDTV",
    "Marketing Name": "T3AMX3",
    "Device": "SEI600TID",
    "Model": "T3AMX3"
  },
  {
    "Retail Branding": "TrustKernel",
    "Marketing Name": "PS01",
    "Device": "PS01",
    "Model": "PS01"
  },
  {
    "Retail Branding": "TuCEL",
    "Marketing Name": "TC504B",
    "Device": "TC504B",
    "Model": "TC504B"
  },
  {
    "Retail Branding": "TuCEL",
    "Marketing Name": "TL554B",
    "Device": "TL554B",
    "Model": "TL554B"
  },
  {
    "Retail Branding": "Tunisie Telecom",
    "Marketing Name": "Star Trail by TT",
    "Device": "startrail3_tt",
    "Model": "StarTrail TT"
  },
  {
    "Retail Branding": "Turbo-X",
    "Marketing Name": "EUROPE",
    "Device": "guandu",
    "Model": "TURBO-X Android TV"
  },
  {
    "Retail Branding": "Turbo-X",
    "Marketing Name": "EU、UK、AP",
    "Device": "martin",
    "Model": "TURBO-X Android TV"
  },
  {
    "Retail Branding": "Turbo-X",
    "Marketing Name": "Greece",
    "Device": "tamachi",
    "Model": "TURBO-X FHD Android TV"
  },
  {
    "Retail Branding": "Turbo-X",
    "Marketing Name": "Greek and Bulgarian",
    "Device": "yeongdeungpo",
    "Model": "TURBO-X UHD Android TV"
  },
  {
    "Retail Branding": "Turbo-X",
    "Marketing Name": "Turbo-X Fire II (2GB) Tablet 10.1\" WIFI",
    "Device": "Fire_II_WiFi",
    "Model": "Fire_II_WiFi"
  },
  {
    "Retail Branding": "Turbo-X",
    "Marketing Name": "Turbo_X8",
    "Device": "Turbo_X8",
    "Model": "Turbo_X8"
  },
  {
    "Retail Branding": "Turbokids",
    "Marketing Name": "Monsterpad_3G",
    "Device": "Monsterpad_3G",
    "Model": "Monsterpad 3G"
  },
  {
    "Retail Branding": "Turbokids",
    "Marketing Name": "Princess",
    "Device": "Princess",
    "Model": "Princess"
  },
  {
    "Retail Branding": "Turbokids",
    "Marketing Name": "Princess 3G",
    "Device": "Princess_3G",
    "Model": "Princess 3G"
  },
  {
    "Retail Branding": "Turbokids",
    "Marketing Name": "Turbokids-TMNT",
    "Device": "Turbokids_TMNT",
    "Model": "Turbokids-TMNT"
  },
  {
    "Retail Branding": "Turbokids",
    "Marketing Name": "Turbokids3GNEW",
    "Device": "Turbokids3GNEW",
    "Model": "Turbokids3GNEW"
  },
  {
    "Retail Branding": "Turbokids",
    "Marketing Name": "TurbokidsP",
    "Device": "TurbokidsP",
    "Model": "TurbokidsP"
  },
  {
    "Retail Branding": "Turbokids",
    "Marketing Name": "TurbokidsS5",
    "Device": "TurbokidsS5",
    "Model": "TurbokidsS5"
  },
  {
    "Retail Branding": "Turbokids",
    "Marketing Name": "TurbokidsStarA100",
    "Device": "TurbokidsStarA100",
    "Model": "Turbokids Star"
  },
  {
    "Retail Branding": "Turbokids",
    "Marketing Name": "Turbokids_Star",
    "Device": "Turbokids_Star",
    "Model": "Turbokids_Star"
  },
  {
    "Retail Branding": "Turbonet",
    "Marketing Name": "ADR1776",
    "Device": "ADR1776",
    "Model": "ADR1776"
  },
  {
    "Retail Branding": "Turbonet",
    "Marketing Name": "TN451A1",
    "Device": "TN451A1",
    "Model": "TN451A1"
  },
  {
    "Retail Branding": "Turbonet",
    "Marketing Name": "TN451A1",
    "Device": "TN451A1-RF",
    "Model": "TN451A1"
  },
  {
    "Retail Branding": "Turbonet",
    "Marketing Name": "TN500A1",
    "Device": "TN500A1",
    "Model": "TN500A1"
  },
  {
    "Retail Branding": "Turbonet",
    "Marketing Name": "TN500A2",
    "Device": "TN500A2",
    "Model": "TN500A2"
  },
  {
    "Retail Branding": "Turbonet",
    "Marketing Name": "TN502A1",
    "Device": "TN502A1",
    "Model": "TN502A1"
  },
  {
    "Retail Branding": "Turbonet",
    "Marketing Name": "TurboTab E1",
    "Device": "TN800A1",
    "Model": "TN800A1"
  },
  {
    "Retail Branding": "Turbopad",
    "Marketing Name": "Dream",
    "Device": "Dream",
    "Model": "Dream"
  },
  {
    "Retail Branding": "Turbopad",
    "Marketing Name": "Mercury",
    "Device": "Mercury",
    "Model": "Mercury"
  },
  {
    "Retail Branding": "Turbopad",
    "Marketing Name": "S5",
    "Device": "S5",
    "Model": "S5"
  },
  {
    "Retail Branding": "Turbopad",
    "Marketing Name": "TurboX",
    "Device": "TurboX_Ray",
    "Model": "TurboX_Ray"
  },
  {
    "Retail Branding": "Turbopad",
    "Marketing Name": "TurboX5Black",
    "Device": "TurboX5Black",
    "Model": "TurboX5Black"
  },
  {
    "Retail Branding": "Turbopad",
    "Marketing Name": "Turbopad1015NEW",
    "Device": "Turbopad1015NEW",
    "Model": "Turbopad1015NEW"
  },
  {
    "Retail Branding": "Turbopad",
    "Marketing Name": "Turbopad1016",
    "Device": "Turbopad1016",
    "Model": "Turbopad1016"
  },
  {
    "Retail Branding": "Turbopad",
    "Marketing Name": "Turbopad1016NEW",
    "Device": "Turbopad1016NEW",
    "Model": "Turbopad1016NEW"
  },
  {
    "Retail Branding": "Turbopad",
    "Marketing Name": "Turbopadpro",
    "Device": "TurboPadPro",
    "Model": "TurboPadPro"
  },
  {
    "Retail Branding": "Turk Telekom",
    "Marketing Name": "E4",
    "Device": "722T",
    "Model": "E4"
  },
  {
    "Retail Branding": "Tv360 by Metfone",
    "Marketing Name": "B866V2F",
    "Device": "MediaBox_B866V2F",
    "Model": "B866V2F"
  },
  {
    "Retail Branding": "Tvera",
    "Marketing Name": "Tvera",
    "Device": "seocho",
    "Model": "Tvera 4K Android TV"
  },
  {
    "Retail Branding": "Tvstar",
    "Marketing Name": "TVSTAR",
    "Device": "seocho",
    "Model": "TVSTAR 4K Android TV"
  },
  {
    "Retail Branding": "TwinMOS",
    "Marketing Name": "MQ703G",
    "Device": "MQ703G",
    "Model": "MQ703G"
  },
  {
    "Retail Branding": "UAUU",
    "Marketing Name": "M10",
    "Device": "M10",
    "Model": "M10"
  },
  {
    "Retail Branding": "UAUU",
    "Marketing Name": "T30",
    "Device": "T30",
    "Model": "T30"
  },
  {
    "Retail Branding": "UAUU",
    "Marketing Name": "T30 2023",
    "Device": "T30_2023",
    "Model": "T30"
  },
  {
    "Retail Branding": "UAUU",
    "Marketing Name": "T30Pro",
    "Device": "T30Pro",
    "Model": "T30Pro"
  },
  {
    "Retail Branding": "UAUU",
    "Marketing Name": "T60",
    "Device": "T60",
    "Model": "T60"
  },
  {
    "Retail Branding": "UAUU",
    "Marketing Name": "T90_NEW",
    "Device": "T90_NEW",
    "Model": "T90_NEW"
  },
  {
    "Retail Branding": "UAUU",
    "Marketing Name": "U10_RU",
    "Device": "U10",
    "Model": "U10"
  },
  {
    "Retail Branding": "UBCtv",
    "Marketing Name": "Vietnam",
    "Device": "tamachi",
    "Model": "UBC Android TV"
  },
  {
    "Retail Branding": "UBCtv",
    "Marketing Name": "Vietnam",
    "Device": "yeongdeungpo",
    "Model": "UBC Android TV"
  },
  {
    "Retail Branding": "UBOS",
    "Marketing Name": "UTAB",
    "Device": "UTAB",
    "Model": "UTAB"
  },
  {
    "Retail Branding": "UCM(M)",
    "Marketing Name": "T12",
    "Device": "T12",
    "Model": "T12"
  },
  {
    "Retail Branding": "UD (EU)",
    "Marketing Name": "Smart TV",
    "Device": "longshan",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "UD (EU)",
    "Marketing Name": "Smart TV",
    "Device": "osaka",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "UD (EU)",
    "Marketing Name": "Smart TV",
    "Device": "redwood",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "UD (EU)",
    "Marketing Name": "UD",
    "Device": "elliniko",
    "Model": "UD SMART TV"
  },
  {
    "Retail Branding": "UGRIHACH",
    "Marketing Name": "A7",
    "Device": "A7",
    "Model": "A7"
  },
  {
    "Retail Branding": "UGRIHACH",
    "Marketing Name": "A7_EEA",
    "Device": "A7",
    "Model": "A7"
  },
  {
    "Retail Branding": "UGRIHACH",
    "Marketing Name": "C11",
    "Device": "C11",
    "Model": "C11"
  },
  {
    "Retail Branding": "UGRIHACH",
    "Marketing Name": "C11_EEA",
    "Device": "C11",
    "Model": "C11"
  },
  {
    "Retail Branding": "UGRIHACH",
    "Marketing Name": "MB1001",
    "Device": "MB1001",
    "Model": "MB1001"
  },
  {
    "Retail Branding": "UGRIHACH",
    "Marketing Name": "MB1001_EEA",
    "Device": "MB1001",
    "Model": "MB1001"
  },
  {
    "Retail Branding": "UJJ(SZ)",
    "Marketing Name": "U3_EEA",
    "Device": "U3_EEA",
    "Model": "U3_EEA"
  },
  {
    "Retail Branding": "UJJ(SZ)",
    "Marketing Name": "U3_US",
    "Device": "U3_US",
    "Model": "U3_US"
  },
  {
    "Retail Branding": "UJJ(SZ)",
    "Marketing Name": "U3_V_EEA",
    "Device": "U3_V_EEA",
    "Model": "U3_V_EEA"
  },
  {
    "Retail Branding": "UJJ(SZ)",
    "Marketing Name": "U3_V_US",
    "Device": "U3_V_US",
    "Model": "U3_V_US"
  },
  {
    "Retail Branding": "UJJ(SZ)",
    "Marketing Name": "U6_EEA",
    "Device": "U6_EEA",
    "Model": "U6_EEA"
  },
  {
    "Retail Branding": "UJJ(SZ)",
    "Marketing Name": "U6_US",
    "Device": "U6_US",
    "Model": "U6_US"
  },
  {
    "Retail Branding": "UJJ(SZ)",
    "Marketing Name": "U6_V_EEA",
    "Device": "U6_V_EEA",
    "Model": "U6_V_EEA"
  },
  {
    "Retail Branding": "UJJ(SZ)",
    "Marketing Name": "U6_V_US",
    "Device": "U6_V_US",
    "Model": "U6_V_US"
  },
  {
    "Retail Branding": "UJJ(SZ)",
    "Marketing Name": "U7_EEA",
    "Device": "U7_EEA",
    "Model": "U7_EEA"
  },
  {
    "Retail Branding": "UJJ(SZ)",
    "Marketing Name": "U7_US",
    "Device": "U7_US",
    "Model": "U7_US"
  },
  {
    "Retail Branding": "UJJ(SZ)",
    "Marketing Name": "U8_EEA",
    "Device": "U8_EEA",
    "Model": "U8_EEA"
  },
  {
    "Retail Branding": "UJJ(SZ)",
    "Marketing Name": "U8_US",
    "Device": "U8_US",
    "Model": "U8_US"
  },
  {
    "Retail Branding": "UJJ(SZ)",
    "Marketing Name": "U8_V_EEA",
    "Device": "U8_V_EEA",
    "Model": "U8_V_EEA"
  },
  {
    "Retail Branding": "UJJ(SZ)",
    "Marketing Name": "U8_V_US",
    "Device": "U8_V_US",
    "Model": "U8_V_US"
  },
  {
    "Retail Branding": "UJoyFeel",
    "Marketing Name": "KIDS705-701A",
    "Device": "KIDS705_701A",
    "Model": "KIDS705-701A"
  },
  {
    "Retail Branding": "UJoyFeel",
    "Marketing Name": "KIDS705_701",
    "Device": "KIDS705-701",
    "Model": "KIDS705-701"
  },
  {
    "Retail Branding": "UKA-Dream",
    "Marketing Name": "UKA_Dream_1",
    "Device": "UKA_Dream_1",
    "Model": "UKA_Dream_1"
  },
  {
    "Retail Branding": "ULCOOL",
    "Marketing Name": "U1",
    "Device": "U1",
    "Model": "U1"
  },
  {
    "Retail Branding": "ULCOOL",
    "Marketing Name": "U2",
    "Device": "U2",
    "Model": "U2"
  },
  {
    "Retail Branding": "UNEVA",
    "Marketing Name": "Smart TV",
    "Device": "alimos",
    "Model": "UNEVA Google TV"
  },
  {
    "Retail Branding": "UNEVA",
    "Marketing Name": "Smart TV",
    "Device": "dangni",
    "Model": "UNEVA Google TV"
  },
  {
    "Retail Branding": "UNEVA",
    "Marketing Name": "Smart TV",
    "Device": "osaka",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "UNICO",
    "Marketing Name": "Smart TV",
    "Device": "osaki",
    "Model": "UNICO 2K AI Smart TV"
  },
  {
    "Retail Branding": "UNILORIN",
    "Marketing Name": "UNI10IN",
    "Device": "UNI10IN",
    "Model": "UNI10IN"
  },
  {
    "Retail Branding": "UNION99",
    "Marketing Name": "UNION99_ZL833",
    "Device": "UNION99_ZL833",
    "Model": "ZL833"
  },
  {
    "Retail Branding": "UNION99",
    "Marketing Name": "ZLQ9",
    "Device": "ZLQ9",
    "Model": "ZLQ9"
  },
  {
    "Retail Branding": "UNIQ-CELL",
    "Marketing Name": "D10",
    "Device": "D10",
    "Model": "D10"
  },
  {
    "Retail Branding": "UNIQ-CELL",
    "Marketing Name": "D7",
    "Device": "D7",
    "Model": "D7"
  },
  {
    "Retail Branding": "UNIQ-CELL",
    "Marketing Name": "D7PRO",
    "Device": "D7PRO",
    "Model": "D7PRO"
  },
  {
    "Retail Branding": "UNIQ-CELL",
    "Marketing Name": "K7_PRO",
    "Device": "K7_PRO",
    "Model": "K7pro"
  },
  {
    "Retail Branding": "UNIQ-CELL",
    "Marketing Name": "UNIQ0122",
    "Device": "UNIQ0122",
    "Model": "UNIQ0122"
  },
  {
    "Retail Branding": "UNIQ-CELL",
    "Marketing Name": "UNIQ0222",
    "Device": "UNIQ0222",
    "Model": "UNIQ0222"
  },
  {
    "Retail Branding": "UNIQ-CELL",
    "Marketing Name": "UNIQCELL_A4",
    "Device": "UNIQCELL_A4",
    "Model": "UNIQCELL_A4"
  },
  {
    "Retail Branding": "UNIQ-CELL",
    "Marketing Name": "UNIQCELL_A5",
    "Device": "UNIQCELL_A5",
    "Model": "UNIQCELL_A5"
  },
  {
    "Retail Branding": "UNIQ-CELL",
    "Marketing Name": "UNIQCELL_A55",
    "Device": "UNIQCELL_A55",
    "Model": "UNIQCELL_A55"
  },
  {
    "Retail Branding": "UNIQ-CELL",
    "Marketing Name": "W7",
    "Device": "W7",
    "Model": "W7"
  },
  {
    "Retail Branding": "UNIQ-CELL",
    "Marketing Name": "ZX_001",
    "Device": "ZX_001",
    "Model": "ZX_001"
  },
  {
    "Retail Branding": "UNISCED",
    "Marketing Name": "UNISCEDTAB24",
    "Device": "UNISCEDTAB24",
    "Model": "UNISCEDTAB24"
  },
  {
    "Retail Branding": "UNITED TV",
    "Marketing Name": "4K Smart TV",
    "Device": "gangbyeon",
    "Model": "4K AI Smart TV"
  },
  {
    "Retail Branding": "UNITED TV",
    "Marketing Name": "LED32HS72A9",
    "Device": "ikebukuro",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "UNITED TV",
    "Marketing Name": "Smart TV",
    "Device": "osaka",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "UNITED TV",
    "Marketing Name": "Smart TV",
    "Device": "osaki",
    "Model": "2K AI Smart TV"
  },
  {
    "Retail Branding": "UNITED TV",
    "Marketing Name": "Smart TV",
    "Device": "redwood",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "UNITRADING",
    "Marketing Name": "UNITRADING-IFPD",
    "Device": "rk3588_t",
    "Model": "UNIDEAS"
  },
  {
    "Retail Branding": "UNIWA",
    "Marketing Name": "K626_EEA",
    "Device": "K626",
    "Model": "K626"
  },
  {
    "Retail Branding": "UNIWA",
    "Marketing Name": "M101",
    "Device": "M101",
    "Model": "M101"
  },
  {
    "Retail Branding": "UNIWA",
    "Marketing Name": "M101",
    "Device": "M101",
    "Model": "UNIWA M101"
  },
  {
    "Retail Branding": "UNIWA",
    "Marketing Name": "UNIWA W888",
    "Device": "UNIWA_W888",
    "Model": "W888"
  },
  {
    "Retail Branding": "UNIWA",
    "Marketing Name": "UNIWA_F400",
    "Device": "UNIWA_F400",
    "Model": "UNIWA_F400"
  },
  {
    "Retail Branding": "UNIWA",
    "Marketing Name": "UNIWA_F400_EEA",
    "Device": "UNIWA_F400",
    "Model": "UNIWA_F400"
  },
  {
    "Retail Branding": "UNIWA",
    "Marketing Name": "UNIWA_W999",
    "Device": "UNIWA_W999",
    "Model": "UNIWA_W999"
  },
  {
    "Retail Branding": "UNIWA",
    "Marketing Name": "W555",
    "Device": "W555",
    "Model": "W555"
  },
  {
    "Retail Branding": "UNNIC",
    "Marketing Name": "UC_TK03",
    "Device": "UC_TK03",
    "Model": "UC_TK03"
  },
  {
    "Retail Branding": "UNOCP",
    "Marketing Name": "Premier",
    "Device": "Premier",
    "Model": "Premier"
  },
  {
    "Retail Branding": "UNOWHY",
    "Marketing Name": "QOOQ",
    "Device": "QOOQ",
    "Model": "QOOQ"
  },
  {
    "Retail Branding": "UNOWHY",
    "Marketing Name": "QOOQ",
    "Device": "QOOQ-V41",
    "Model": "QOOQ-V41"
  },
  {
    "Retail Branding": "UNOWHY",
    "Marketing Name": "S10G001S4M",
    "Device": "S10G001S4M",
    "Model": "S10G001S4M"
  },
  {
    "Retail Branding": "UNOWHY",
    "Marketing Name": "S10G001S4M_EEA",
    "Device": "S10G001S4M_EEA",
    "Model": "S10G001S4M_EEA"
  },
  {
    "Retail Branding": "UNOWHY",
    "Marketing Name": "SQOOL-V4",
    "Device": "SQOOL-V4",
    "Model": "SQOOL-V4"
  },
  {
    "Retail Branding": "UNOWHY",
    "Marketing Name": "UNOWHY",
    "Device": "QOOQ-V50",
    "Model": "QOOQ-V50"
  },
  {
    "Retail Branding": "UNOWHY",
    "Marketing Name": "UNOWHY",
    "Device": "SQOOL-V41",
    "Model": "SQOOL-V41"
  },
  {
    "Retail Branding": "UNOWHY",
    "Marketing Name": "Y10G001S4M_EEA",
    "Device": "Y10G001S4M",
    "Model": "Y10G001S4M_EEA"
  },
  {
    "Retail Branding": "UNOWHY",
    "Marketing Name": "Y10G007S4MI_EEA",
    "Device": "Y10G007S4MI_EEA",
    "Model": "Y10G007S4MI_EEA"
  },
  {
    "Retail Branding": "UNOWHY",
    "Marketing Name": "Y10G007S4M_EEA",
    "Device": "Y10G007S4M_EEA",
    "Model": "Y10G007S4M_EEA"
  },
  {
    "Retail Branding": "UNOWHY",
    "Marketing Name": "Y10PG2",
    "Device": "Y10PG2_EEA",
    "Model": "Y10G652S8M"
  },
  {
    "Retail Branding": "UNOWHY",
    "Marketing Name": "Y10_Premium",
    "Device": "Y10_Premium",
    "Model": "Y10 Premium"
  },
  {
    "Retail Branding": "URAO",
    "Marketing Name": "A10Max",
    "Device": "A10Max",
    "Model": "A10Max"
  },
  {
    "Retail Branding": "URAO",
    "Marketing Name": "A10Max_EEA",
    "Device": "A10Max",
    "Model": "A10Max"
  },
  {
    "Retail Branding": "URAO",
    "Marketing Name": "C109-2",
    "Device": "C109",
    "Model": "C109"
  },
  {
    "Retail Branding": "URAO",
    "Marketing Name": "C109-2_EEA",
    "Device": "C109",
    "Model": "C109"
  },
  {
    "Retail Branding": "URAO",
    "Marketing Name": "C109-3",
    "Device": "C109",
    "Model": "C109"
  },
  {
    "Retail Branding": "URAO",
    "Marketing Name": "G140L",
    "Device": "G140L",
    "Model": "G140L"
  },
  {
    "Retail Branding": "URAO",
    "Marketing Name": "G140L_EEA",
    "Device": "G140L",
    "Model": "G140L"
  },
  {
    "Retail Branding": "URAO",
    "Marketing Name": "G142L_EEA",
    "Device": "G142L",
    "Model": "G142L"
  },
  {
    "Retail Branding": "URAO",
    "Marketing Name": "G143A",
    "Device": "G143A",
    "Model": "G143A"
  },
  {
    "Retail Branding": "URAO",
    "Marketing Name": "G143A_EEA",
    "Device": "G143A",
    "Model": "G143A"
  },
  {
    "Retail Branding": "URAO",
    "Marketing Name": "G143L",
    "Device": "G143L",
    "Model": "G143L"
  },
  {
    "Retail Branding": "URAO",
    "Marketing Name": "G143L_EEA",
    "Device": "G143L",
    "Model": "G143L"
  },
  {
    "Retail Branding": "URAO",
    "Marketing Name": "X107",
    "Device": "X107",
    "Model": "X107"
  },
  {
    "Retail Branding": "URAO",
    "Marketing Name": "X107_EEA",
    "Device": "X107",
    "Model": "X107"
  },
  {
    "Retail Branding": "URAO",
    "Marketing Name": "X108",
    "Device": "X108",
    "Model": "X108"
  },
  {
    "Retail Branding": "URAO",
    "Marketing Name": "X108_EEA",
    "Device": "X108",
    "Model": "X108"
  },
  {
    "Retail Branding": "USA111",
    "Marketing Name": "IRULU X11",
    "Device": "iRULU-X11",
    "Model": "iRULU X11"
  },
  {
    "Retail Branding": "USA111",
    "Marketing Name": "IRULU X9",
    "Device": "X9",
    "Model": "X9"
  },
  {
    "Retail Branding": "USA111",
    "Marketing Name": "Irulu X7",
    "Device": "X7",
    "Model": "X7"
  },
  {
    "Retail Branding": "USA111",
    "Marketing Name": "iRULU V3",
    "Device": "iRULU_V3",
    "Model": "iRULU_V3"
  },
  {
    "Retail Branding": "USA111",
    "Marketing Name": "iRULU V3",
    "Device": "iRULU_V3i",
    "Model": "iRULU_V3"
  },
  {
    "Retail Branding": "USA111",
    "Marketing Name": "iRULU_V4",
    "Device": "iRULU",
    "Model": "V4"
  },
  {
    "Retail Branding": "USConnect",
    "Marketing Name": "VT10M2",
    "Device": "VT10M2",
    "Model": "VT10M2"
  },
  {
    "Retail Branding": "USEN",
    "Marketing Name": "V11",
    "Device": "V11",
    "Model": "V11"
  },
  {
    "Retail Branding": "USP (The University of the South Pacific)",
    "Marketing Name": "USP- 201901",
    "Device": "USP-201901",
    "Model": "USP-201901"
  },
  {
    "Retail Branding": "UTIME",
    "Marketing Name": "H5013",
    "Device": "H5013",
    "Model": "H5013"
  },
  {
    "Retail Branding": "UTIME",
    "Marketing Name": "TH602",
    "Device": "TH602",
    "Model": "TH602"
  },
  {
    "Retail Branding": "UTIME",
    "Marketing Name": "TH651",
    "Device": "TH651",
    "Model": "TH651"
  },
  {
    "Retail Branding": "UTVbox",
    "Marketing Name": "MGV2002_HK",
    "Device": "MGV2002_HK",
    "Model": "MGV2002_HK"
  },
  {
    "Retail Branding": "UWIN",
    "Marketing Name": "Aquarius",
    "Device": "Aquarius",
    "Model": "Aquarius"
  },
  {
    "Retail Branding": "UWIN",
    "Marketing Name": "Draco",
    "Device": "Draco",
    "Model": "Draco"
  },
  {
    "Retail Branding": "Ubiquiti",
    "Marketing Name": "USS",
    "Device": "grizzlies_telefi4wm",
    "Model": "USS"
  },
  {
    "Retail Branding": "Ubiquiti",
    "Marketing Name": "UVP",
    "Device": "capri_ubq_telefi5",
    "Model": "UVP"
  },
  {
    "Retail Branding": "Ubiquiti",
    "Marketing Name": "UVP Executive",
    "Device": "capri_ubq_telefi7",
    "Model": "UVP Executive"
  },
  {
    "Retail Branding": "Ubiquiti",
    "Marketing Name": "UVP Pro",
    "Device": "capri_ubq_telefi5p",
    "Model": "UVP Pro"
  },
  {
    "Retail Branding": "Ubiquiti",
    "Marketing Name": "UVP-X",
    "Device": "grizzlies_telefi4x",
    "Model": "UVP-X"
  },
  {
    "Retail Branding": "Ubiquiti",
    "Marketing Name": "UVP-X",
    "Device": "grizzlies_telefi4xp",
    "Model": "UVP-X"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "4dym",
    "Device": "Armor_X3",
    "Model": "Armor_X3"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "Armor 10 5G",
    "Device": "Armor_10_5G",
    "Model": "Armor 10 5G"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "Armor 11 5G",
    "Device": "Armor_11_5G",
    "Model": "Armor 11 5G"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "Armor 11T 5G",
    "Device": "Armor_11T_5G",
    "Model": "Armor 11T 5G"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "Armor 12 5G",
    "Device": "Armor_12_5G",
    "Model": "Armor 12 5G"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "Armor 12S",
    "Device": "Armor_12S",
    "Model": "Armor 12S"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "Armor 15",
    "Device": "Armor_15",
    "Model": "Armor 15"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "Armor 17 Pro",
    "Device": "Armor_17_Pro",
    "Model": "Armor 17 Pro"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "Armor 2",
    "Device": "Armor_2",
    "Model": "Armor_2"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "Armor 20WT",
    "Device": "Armor_20WT",
    "Model": "Armor 20WT"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "Armor 21",
    "Device": "Armor_21",
    "Model": "Armor 21"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "Armor 22",
    "Device": "Armor_22",
    "Model": "Armor 22"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "Armor 22",
    "Device": "GQ3115TF5",
    "Model": "Armor 22"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "Armor 23 Ultra",
    "Device": "Armor_23_Ultra",
    "Model": "Armor 23 Ultra"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "Armor 24",
    "Device": "Armor_24",
    "Model": "Armor 24"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "Armor 25 Pro+",
    "Device": "GQ5007AF2",
    "Model": "Armor 25T Pro"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "Armor 25T 4G",
    "Device": "GQ5007TF1",
    "Model": "Armor 25T"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "Armor 26 Ultra",
    "Device": "Armor_26_Ultra",
    "Model": "Armor 26 Ultra"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "Armor 27",
    "Device": "GQ5008TF2",
    "Model": "Armor 27"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "Armor 27 Pro",
    "Device": "GQ5008AF3",
    "Model": "Armor 27 Pro"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "Armor 27T",
    "Device": "GQ5008TF1",
    "Model": "Armor 27T"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "Armor 27T Pro",
    "Device": "GQ5008AF2",
    "Model": "Armor 27T Pro"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "Armor 28 Pro",
    "Device": "GQ5011BF1",
    "Model": "Armor 28 Pro"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "Armor 28 Ultra",
    "Device": "GQ5011AF1",
    "Model": "Armor 28 Ultra"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "Armor 29 Pro",
    "Device": "GQ5012BF1",
    "Model": "Armor 29 Pro"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "Armor 29 Ultra",
    "Device": "GQ5012AF1",
    "Model": "Armor 29 Ultra"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "Armor 2S",
    "Device": "Armor_2S",
    "Model": "Armor_2S"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "Armor 30",
    "Device": "GQ5013TF1",
    "Model": "Armor 30"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "Armor 30 Pro",
    "Device": "GQ5013BF2",
    "Model": "Armor 30 Pro"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "Armor 31 Pro",
    "Device": "GQ5016BF1",
    "Model": "Armor 33 Pro"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "Armor 33",
    "Device": "GQ5016TF1",
    "Model": "Armor 33"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "Armor 34",
    "Device": "GQ5017BF4",
    "Model": "Armor 34"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "Armor 34 Pro",
    "Device": "GQ5017BF3",
    "Model": "Armor 34 Pro"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "Armor 6",
    "Device": "Armor_6",
    "Model": "Armor_6"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "Armor 7",
    "Device": "Armor_7_Q",
    "Model": "Armor 7"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "Armor 8",
    "Device": "Armor_8",
    "Model": "Armor 8"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "Armor 8",
    "Device": "Armor_8_R",
    "Model": "Armor 8"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "Armor 8 Pro",
    "Device": "Armor_8_Pro",
    "Model": "Armor 8 Pro"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "Armor 9",
    "Device": "Armor_9",
    "Model": "Armor 9"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "Armor 9E",
    "Device": "Armor_9E",
    "Model": "Armor 9E"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "Armor Mini 20",
    "Device": "GQ5010TH1",
    "Model": "Armor Mini 20"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "Armor Mini 20 Pro",
    "Device": "GQ5010AH2",
    "Model": "Armor Mini 20 Pro"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "Armor Mini 20T Pro",
    "Device": "GQ5010AH1",
    "Model": "Armor Mini 20T Pro"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "Armor Pad",
    "Device": "Armor_Pad",
    "Model": "Armor Pad"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "Armor Pad 2",
    "Device": "Armor_Pad_2",
    "Model": "Armor Pad 2"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "Armor Pad 2",
    "Device": "Armor_Pad_2",
    "Model": "UTAB A2"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "Armor Pad 3 Pro",
    "Device": "ArmorPad3Pro",
    "Model": "Armor Pad 3 Pro"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "Armor Pad 4 Ultra",
    "Device": "GQ3121AF1",
    "Model": "Armor Pad 4 Ultra"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "Armor Pad 5 Pro",
    "Device": "GQ8000BF3",
    "Model": "Armor Pad 5 Pro"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "Armor Pad 5 Ultra",
    "Device": "GQ8000BF1",
    "Model": "Armor Pad 5 Ultra"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "Armor Pad Lite",
    "Device": "ArmorPadLite",
    "Model": "Armor Pad Lite"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "Armor Pad Pro",
    "Device": "ArmorPadPro",
    "Model": "Armor Pad Pro"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "Armor X",
    "Device": "Armor_X",
    "Model": "Armor_X"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "Armor X10",
    "Device": "Armor_X10",
    "Model": "Armor X10"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "Armor X10 Pro",
    "Device": "Armor_X10_Pro",
    "Model": "Armor X10 Pro"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "Armor X12",
    "Device": "Armor_X12",
    "Model": "Armor X12"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "Armor X12 Pro",
    "Device": "Armor_X12_Pro",
    "Model": "Armor X12 Pro"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "Armor X13",
    "Device": "Armor_X12_Pro",
    "Model": "Armor X12 Pro"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "Armor X13",
    "Device": "Armor_X13",
    "Model": "Armor X13"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "Armor X13",
    "Device": "GQ3117SH2_MTN",
    "Model": "Armor X13"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "Armor X16",
    "Device": "GQ5020TH1P19",
    "Model": "Armor X16"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "Armor X16 Pro",
    "Device": "GQ5020BH1",
    "Model": "Armor X16 Pro"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "Armor X2",
    "Device": "Armor_X2",
    "Model": "Armor_X2"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "Armor X31",
    "Device": "GQ5015RH1",
    "Model": "Armor X31"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "Armor X31 Pro",
    "Device": "GQ5015AH1",
    "Model": "Armor X31 Pro"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "Armor X32",
    "Device": "GQ5021RH1",
    "Model": "Armor X32"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "Armor X32 Pro",
    "Device": "GQ5021AH1",
    "Model": "Armor X32 Pro"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "Armor X33 Pro",
    "Device": "GQ5020BH1",
    "Model": "Armor X16 Pro"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "Armor X5",
    "Device": "Armor_X5_Q",
    "Model": "Armor X5"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "Armor X5 Pro",
    "Device": "Armor_X5_Pro",
    "Model": "Armor X5 Pro"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "Armor X5 Pro",
    "Device": "Armor_X5_Pro_R",
    "Model": "Armor X5 Pro"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "Armor X5 Q",
    "Device": "Armor_X5_Q",
    "Model": "Armor X5"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "Armor X6 Pro",
    "Device": "Armor_X6_Pro",
    "Model": "Armor X6 Pro"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "Armor X7",
    "Device": "Armor_X7_Q",
    "Model": "Armor X7"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "Armor X7 Pro",
    "Device": "Armor_X7_Pro",
    "Model": "Armor X7 Pro"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "Armor X7 Pro",
    "Device": "GQ3087",
    "Model": "Armor X7 Pro"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "Armor X8",
    "Device": "Armor_X8_R",
    "Model": "Armor X8"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "Armor X8i",
    "Device": "Armor_X8i",
    "Model": "Armor X8i"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "Armor X9",
    "Device": "Armor_X9",
    "Model": "Armor X9"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "Armor X9 Pro",
    "Device": "Armor_X9_Pro",
    "Model": "Armor X9 Pro"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "Armor6",
    "Device": "Armor_6",
    "Model": "Armor_6"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "ArmorPad3Pro_EEA",
    "Device": "ArmorPad3Pro",
    "Model": "Armor Pad 3 Pro"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "Armor_11T_5G",
    "Device": "Armor_11T_5G",
    "Model": "Armor 11T 5G"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "Armor_11_5G",
    "Device": "Armor_11_5G",
    "Model": "Armor 11 5G"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "Armor_22",
    "Device": "Armor_22",
    "Model": "Armor 22"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "Armor_3",
    "Device": "Armor_3",
    "Model": "Armor_3"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "Armor_3W",
    "Device": "Armor_3W",
    "Model": "Armor_3W"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "Armor_3WT",
    "Device": "Armor_3WT",
    "Model": "Armor_3WT"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "Armor_5",
    "Device": "Ulefone_Armor_5",
    "Model": "Ulefone_Armor_5"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "Armor_5S",
    "Device": "Armor_5S",
    "Model": "Armor 5S"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "Armor_6E",
    "Device": "Armor_6E",
    "Model": "Armor_6E"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "Armor_6S",
    "Device": "Armor_6S",
    "Model": "Armor_6S"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "Armor_7",
    "Device": "Armor_7",
    "Model": "Armor_7"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "Armor_7E",
    "Device": "Armor_7E",
    "Model": "Armor 7E"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "Armor_7E",
    "Device": "Armor_7E_Q",
    "Model": "Armor 7E"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "Armor_9E",
    "Device": "Armor_9E",
    "Model": "Armor 9E"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "Armor_X13",
    "Device": "Armor_X13",
    "Model": "Armor X13"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "Armor_X2",
    "Device": "Armor_X2",
    "Model": "Armor_X2"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "Armor_X3",
    "Device": "Armor_X3",
    "Model": "Armor_X3"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "Armor_X5",
    "Device": "Armor_X5",
    "Model": "Armor X5"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "Armor_X5",
    "Device": "Armor_X5_R",
    "Model": "Armor X5"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "Armor_X6",
    "Device": "Armor_X6",
    "Model": "Armor_X6"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "Armor_X8_R_EEA",
    "Device": "Armor_X8_R",
    "Model": "Armor X8"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "Armor_X9",
    "Device": "Armor_X9",
    "Model": "Armor X9"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "GQ5007AF2",
    "Device": "GQ5007AF2",
    "Model": "Armor 25T Pro"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "GQ5008AF3",
    "Device": "GQ5008AF3",
    "Model": "Armor 27 Pro"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "GQ5010AH1",
    "Device": "GQ5010AH1_VID",
    "Model": "GQ5010AH1"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "MIX",
    "Device": "t816_gq_ulefone",
    "Model": "MIX"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "MIX S",
    "Device": "t815_gq_ulefone",
    "Model": "MIX_S"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "MIX_2",
    "Device": "MIX_2",
    "Model": "MIX_2"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "Note 10",
    "Device": "Note_10",
    "Model": "Note 10"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "Note 10P",
    "Device": "Note_10P",
    "Model": "Note 10P"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "Note 11P",
    "Device": "Note_11P",
    "Model": "Note 11P"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "Note 12",
    "Device": "Note_12",
    "Model": "Note 12"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "Note 12P",
    "Device": "Note_12P",
    "Model": "Note 12P"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "Note 13P",
    "Device": "Note_13P",
    "Model": "Note 13P"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "Note 14",
    "Device": "Note_14",
    "Model": "Note 14"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "Note 15",
    "Device": "Note_15",
    "Model": "Note 15"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "Note 16 Pro",
    "Device": "GQ3106",
    "Model": "Note 16 Pro"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "Note 16 Pro",
    "Device": "Note_16_Pro",
    "Model": "Note 16 Pro"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "Note 17 Pro",
    "Device": "Note_17_Pro",
    "Model": "Note 17 Pro"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "Note 18 Pro",
    "Device": "GQ5009TH1",
    "Model": "Note 18 Pro"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "Note 18 Ultra",
    "Device": "Note_18_Ultra",
    "Model": "Note 18 Ultra"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "Note 19",
    "Device": "GQ3290BH1",
    "Model": "Note 19"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "Note 19 Pro",
    "Device": "GQ3290RH1",
    "Model": "Note 19 Pro"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "Note 19Pro",
    "Device": "GQ3291SH1",
    "Model": "Note 21"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "Note 20Pro",
    "Device": "GQ3289SH1",
    "Model": "Note 20 Pro"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "Note 21",
    "Device": "GQ3291SH1",
    "Model": "Note 21"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "Note 6",
    "Device": "Note_6",
    "Model": "Note 6"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "Note 6P",
    "Device": "Note_6P",
    "Model": "Note 6P"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "Note 6T",
    "Device": "Note_6T",
    "Model": "Note 6T"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "Note 8",
    "Device": "Note_8",
    "Model": "Note 8"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "Note 8P",
    "Device": "Note_8P",
    "Model": "Note 8P"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "Note 9P",
    "Device": "Note_9P",
    "Model": "Note 9P"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "Note_10",
    "Device": "Note_10",
    "Model": "Note 10"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "Note_7P",
    "Device": "Note_7P",
    "Model": "Note_7P"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "Note_7T",
    "Device": "Note_7T",
    "Model": "Note 7T"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "Note_7T_EEA",
    "Device": "Note_7T",
    "Model": "Note 7T"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "P6000_Plus",
    "Device": "P6000_Plus",
    "Model": "P6000_Plus"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "Power 2",
    "Device": "Power_2",
    "Model": "Power_2"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "Power 3",
    "Device": "Power_3",
    "Model": "Power_3"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "Power 3S",
    "Device": "Power_3S",
    "Model": "Power 3S"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "Power 3S",
    "Device": "Power_3S",
    "Model": "Power_3S"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "Power 5",
    "Device": "Power_5",
    "Model": "Power_5"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "Power 5S",
    "Device": "Power_5S",
    "Model": "Power_5S"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "Power Armor 13",
    "Device": "Power_Armor_13",
    "Model": "Power Armor 13"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "Power Armor 14",
    "Device": "Power_Armor_14",
    "Model": "Power Armor 14"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "Power Armor 14 Pro",
    "Device": "Power_Armor14_Pro",
    "Model": "Power Armor14 Pro"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "Power Armor 16 Pro",
    "Device": "PowerArmor16Pro",
    "Model": "Power Armor 16 Pro"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "Power Armor 16S",
    "Device": "Power_Armor_16S",
    "Model": "Power Armor 16S"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "Power Armor 18",
    "Device": "Power_Armor_18",
    "Model": "Power Armor 18"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "Power Armor 18T",
    "Device": "Power_Armor_18T",
    "Model": "Power Armor 18T"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "Power Armor 19",
    "Device": "Power_Armor_19",
    "Model": "Power Armor 19"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "Power Armor 19T",
    "Device": "Power_Armor_19T",
    "Model": "Power Armor 19T"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "Power Armor X11",
    "Device": "Power_Armor_X11",
    "Model": "Power Armor X11"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "Power Armor X11 Pro",
    "Device": "PowerArmorX11Pro",
    "Model": "Power Armor X11 Pro"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "Power_3L",
    "Device": "Power_3L",
    "Model": "Power_3L"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "Power_3L_EEA",
    "Device": "Power_3L_EEA",
    "Model": "Power_3L"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "Power_6",
    "Device": "Power_6",
    "Model": "Power_6"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "Power_6_EEA",
    "Device": "Power_6",
    "Model": "Power_6"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "Power_Armor_19T",
    "Device": "Power_Armor_19T",
    "Model": "Power Armor 19T"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "RugKing",
    "Device": "GQ3103RH2",
    "Model": "RugKing"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "RugKing 2 Pro",
    "Device": "GQ3127RH1",
    "Model": "RugKing 2 Pro"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "RugKing 3 Pro",
    "Device": "GQ3128RH1",
    "Model": "RugKing 3 Pro"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "RugKing 4 Pro",
    "Device": "GQ3129RH1",
    "Model": "RugKing 4 Pro"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "RugKing 5 Pro",
    "Device": "GQ3131RF1",
    "Model": "RugKing 5 Pro"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "RugKing Pad 2 Pro",
    "Device": "GQ8002RH1",
    "Model": "RugKing Pad 2 Pro"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "RugKing Pad Pro",
    "Device": "GQ8001RH1",
    "Model": "RugKing Pad Pro"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "S10_Pro",
    "Device": "S10_Pro",
    "Model": "S10_Pro"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "S11_Pro",
    "Device": "S11_Pro",
    "Model": "S11 Pro"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "S7",
    "Device": "t662_gq_n1616_we",
    "Model": "Ulefone S7"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "S7",
    "Device": "t662_gq_ulefone",
    "Model": "Ulefone S7"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "S8",
    "Device": "S8",
    "Model": "Ulefone S8"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "S8 Pro",
    "Device": "S8_Pro",
    "Model": "S8_Pro"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "S8_",
    "Device": "S8",
    "Model": "Ulefone S8"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "S8_Pro",
    "Device": "S8_pro1",
    "Model": "S8_Pro"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "S9_Pro",
    "Device": "S9_Pro",
    "Model": "S9_Pro"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "T1",
    "Device": "Ulefone_T1",
    "Model": "T1"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "T2",
    "Device": "T2",
    "Model": "T2"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "Tab A10",
    "Device": "UF1002A-1",
    "Model": "Tab A10"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "Tab A10 Pro",
    "Device": "UF1002",
    "Model": "Tab A10 Pro"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "Tab A11",
    "Device": "UF1103A",
    "Model": "Tab A11"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "Tab A11 Pro",
    "Device": "UF1103",
    "Model": "Tab A11 Pro"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "Tab A7",
    "Device": "Ulefone_Tab_A7",
    "Model": "Ulefone Tab A7"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "Tab A8",
    "Device": "GQ3286",
    "Model": "Tab A8"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "Tab A8",
    "Device": "Tab_A8",
    "Model": "Tab A8"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "Tab A8",
    "Device": "Tab_A8_EEA",
    "Model": "Tab A8"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "Tab A9 Pro",
    "Device": "UF0901-1",
    "Model": "Tab A9 Pro"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "Tab R8 5G",
    "Device": "Tab_R8_5G",
    "Model": "Tab R8 5G"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "Tab W10",
    "Device": "UF1001_1",
    "Model": "Tab W10"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "Ulefone Tab A7",
    "Device": "Ulefone_Tab_A7",
    "Model": "Ulefone Tab A7"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "Ulefone_Note_7",
    "Device": "Note_7P",
    "Model": "Note_7P"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "Ulefone_Note_7",
    "Device": "Ulefone_Note_7",
    "Model": "Ulefone_Note 7"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "Ulefone_S1",
    "Device": "Ulefone_S1",
    "Model": "Ulefone_S1"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "Ulefone_S11",
    "Device": "Ulefone_S11",
    "Model": "Ulefone_S11"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "Ulefone_S7",
    "Device": "Ulefone_S7",
    "Model": "Ulefone S7"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "Ulefone_X",
    "Device": "Ulefone_X",
    "Model": "Ulefone_X"
  },
  {
    "Retail Branding": "Ulefone",
    "Marketing Name": "Ulfone_S11",
    "Device": "Ulefone_S11",
    "Model": "Ulefone_S11"
  },
  {
    "Retail Branding": "Uleway",
    "Marketing Name": "T6501",
    "Device": "T6501",
    "Model": "T6501"
  },
  {
    "Retail Branding": "Ultimate",
    "Marketing Name": "Ultimate FU",
    "Device": "Ultimate_FU",
    "Model": "Ultimate FU"
  },
  {
    "Retail Branding": "Umax",
    "Marketing Name": "10A_3G",
    "Device": "10A_3G",
    "Model": "10A_3G"
  },
  {
    "Retail Branding": "Umax",
    "Marketing Name": "10A_LTE_eea",
    "Device": "10A_LTE",
    "Model": "10A_LTE_eea"
  },
  {
    "Retail Branding": "Umax",
    "Marketing Name": "10C-LTE-A11",
    "Device": "10C-LTE-A11",
    "Model": "10C-LTE-A11"
  },
  {
    "Retail Branding": "Umax",
    "Marketing Name": "10C-PRO-LTE",
    "Device": "10C-PRO-LTE",
    "Model": "10C-PRO-LTE"
  },
  {
    "Retail Branding": "Umax",
    "Marketing Name": "10C_LTE",
    "Device": "10C_LTE",
    "Model": "10C_LTE"
  },
  {
    "Retail Branding": "Umax",
    "Marketing Name": "10L-PLUS",
    "Device": "10L-PLUS",
    "Model": "10L-PLUS"
  },
  {
    "Retail Branding": "Umax",
    "Marketing Name": "10Qa_3G",
    "Device": "10Qa_3G",
    "Model": "VisionBook_10Qa_3G"
  },
  {
    "Retail Branding": "Umax",
    "Marketing Name": "10T-LTE_EEA",
    "Device": "10T-LTE_EEA",
    "Model": "10T-LTE"
  },
  {
    "Retail Branding": "Umax",
    "Marketing Name": "11T-LTE-Pro_EEA",
    "Device": "11T-LTE-Pro_EEA",
    "Model": "11T-LTE-Pro"
  },
  {
    "Retail Branding": "Umax",
    "Marketing Name": "7A_3G",
    "Device": "7A_3G",
    "Model": "7A_3G"
  },
  {
    "Retail Branding": "Umax",
    "Marketing Name": "7A_Plus_eea",
    "Device": "7A_Plus",
    "Model": "7A_Plus"
  },
  {
    "Retail Branding": "Umax",
    "Marketing Name": "7Qa_3G",
    "Device": "7Qa_3G",
    "Model": "7Qa_3G"
  },
  {
    "Retail Branding": "Umax",
    "Marketing Name": "8A_Plus_eea",
    "Device": "8A_Plus_eea",
    "Model": "8A_Plus"
  },
  {
    "Retail Branding": "Umax",
    "Marketing Name": "8C_LTE",
    "Device": "8C_LTE",
    "Model": "8C_LTE"
  },
  {
    "Retail Branding": "Umax",
    "Marketing Name": "8L_PLUS_EEA",
    "Device": "8L_PLUS_EEA",
    "Model": "8L_PLUS_EEA"
  },
  {
    "Retail Branding": "Umax",
    "Marketing Name": "MediaTek",
    "Device": "8Qa_3G",
    "Model": "8Qa_3G"
  },
  {
    "Retail Branding": "Umax",
    "Marketing Name": "T8_3G_eea",
    "Device": "T8_3G",
    "Model": "T8_3G"
  },
  {
    "Retail Branding": "Umax",
    "Marketing Name": "U452TL",
    "Device": "U452TL",
    "Model": "U452TL"
  },
  {
    "Retail Branding": "Umax",
    "Marketing Name": "UMAX",
    "Device": "kaitak",
    "Model": "Ultra 4K GTV"
  },
  {
    "Retail Branding": "Umax",
    "Marketing Name": "UMAX",
    "Device": "seocho",
    "Model": "UMAX 4K Android TV"
  },
  {
    "Retail Branding": "Umax",
    "Marketing Name": "UMAX",
    "Device": "tennoji",
    "Model": "Premium 2K GTV"
  },
  {
    "Retail Branding": "Umax",
    "Marketing Name": "UMAX",
    "Device": "visionbook_P55_LTE",
    "Model": "visionbook P55 LTE"
  },
  {
    "Retail Branding": "Umax",
    "Marketing Name": "Umax",
    "Device": "shilin",
    "Model": "UMAX4KAndroidTV"
  },
  {
    "Retail Branding": "Umax",
    "Marketing Name": "VisionBook P50 Plus LTE",
    "Device": "P50Plus_LTE",
    "Model": "VisionBook_P50Plus_LTE"
  },
  {
    "Retail Branding": "Umax",
    "Marketing Name": "VisionBook P55 X2 LTE",
    "Device": "VisionBook_P55_X2_LTE",
    "Model": "VisionBook P55 X2 LTE"
  },
  {
    "Retail Branding": "Umax",
    "Marketing Name": "VisionBook10Q",
    "Device": "VB_10Q_Plus",
    "Model": "VB_10Q_Plus"
  },
  {
    "Retail Branding": "Umax",
    "Marketing Name": "VisionBook_P55_LTE_Pro",
    "Device": "VisionBook_P55_LTE_Pro",
    "Model": "VisionBook P55 LTE Pro"
  },
  {
    "Retail Branding": "Umax",
    "Marketing Name": "Visionbook_10Q_Pro",
    "Device": "Visionbook_10Q_Pro",
    "Model": "Visionbook_10Q_Pro"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "A11",
    "Device": "A11",
    "Model": "A11"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "A11 EEA",
    "Device": "A11",
    "Model": "A11"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "A11 Pro Max",
    "Device": "A11_Pro_Max",
    "Model": "A11 Pro Max"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "A11 Pro Max EEA",
    "Device": "A11_Pro_Max",
    "Model": "A11 Pro Max"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "A11S",
    "Device": "A11S",
    "Model": "MP01"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "A11S EEA",
    "Device": "A11S",
    "Model": "MP01"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "A11_Tab",
    "Device": "A11_Tab",
    "Model": "MT01"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "A11_Tab-EEA",
    "Device": "A11_Tab-EEA",
    "Model": "MT01"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "A13",
    "Device": "A13",
    "Model": "MP05"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "A13 EEA",
    "Device": "A13",
    "Model": "MP05"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "A13 Pro",
    "Device": "A13_Pro",
    "Model": "MP05"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "A13 Pro 5G",
    "Device": "A13_Pro_5G",
    "Model": "MP03"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "A13 Pro 5G EEA",
    "Device": "A13_Pro_5G",
    "Model": "MP03"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "A13 Pro EEA",
    "Device": "A13_Pro",
    "Model": "MP05"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "A13 Pro Max 5G",
    "Device": "A13_Pro_Max_5G",
    "Model": "MP04"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "A13 Pro Max 5G EEA",
    "Device": "A13_Pro_Max_5G",
    "Model": "MP04"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "A13S",
    "Device": "A13S",
    "Model": "MP05"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "A13S EEA",
    "Device": "A13S",
    "Model": "MP05"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "A13_Tab",
    "Device": "A13_Tab",
    "Model": "MT07"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "A13_Tab_EEA",
    "Device": "A13_Tab_EEA",
    "Model": "MT07"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "A15T",
    "Device": "A15T",
    "Model": "PA2310GBB"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "A15T EEA",
    "Device": "A15T",
    "Model": "PA2310GBB"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "A15_Pro",
    "Device": "A15_Pro",
    "Model": "PA3NB15PA"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "A15_Pro_5G",
    "Device": "A15_Pro_5G",
    "Model": "MP36"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "A15_Pro_5G_EEA",
    "Device": "A15_Pro_5G",
    "Model": "MP36"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "A15_Pro_EEA",
    "Device": "A15_Pro",
    "Model": "PA3NB15PA"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "A15_Tab",
    "Device": "A15_Tab",
    "Model": "MT08"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "A15_Tab_EEA",
    "Device": "A15_Tab_EEA",
    "Model": "MT08"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "A3",
    "Device": "A3",
    "Model": "A3"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "A3S",
    "Device": "A3S",
    "Model": "A3S"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "A3S_EEA",
    "Device": "A3S",
    "Model": "A3S"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "A3X",
    "Device": "A3X",
    "Model": "A3X"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "A3_Pro",
    "Device": "A3_Pro",
    "Model": "A3_Pro"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "A5 Pro",
    "Device": "A5_Pro",
    "Model": "A5_Pro"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "A7",
    "Device": "A7",
    "Model": "A7"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "A7",
    "Device": "A7_EEA",
    "Model": "A7"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "A7 Pro",
    "Device": "A7_Pro",
    "Model": "A7 Pro"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "A7 Pro EEA",
    "Device": "A7_Pro",
    "Model": "A7 Pro"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "A7S",
    "Device": "A7S",
    "Model": "A7S"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "A7S EEA",
    "Device": "A7S",
    "Model": "A7S"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "A9",
    "Device": "A9",
    "Model": "A9"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "A9 EEA",
    "Device": "A9",
    "Model": "A9"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "A9 Pro",
    "Device": "A9_Pro",
    "Model": "A9 Pro"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "A9 Pro 128G",
    "Device": "A9_Pro_128GB",
    "Model": "A9 Pro"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "A9 Pro 128G EEA",
    "Device": "A9_Pro_128GB",
    "Model": "A9 Pro"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "A9 Pro R",
    "Device": "A9_Pro_R",
    "Model": "A9 Pro"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "A9 Pro R EEA",
    "Device": "A9_Pro_R",
    "Model": "A9 Pro"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "A9 Pro_EEA",
    "Device": "A9_Pro",
    "Model": "A9 Pro"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "AblePad S EEA",
    "Device": "AblePad_S",
    "Model": "MT03"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "AblePad_Pro",
    "Device": "AblePad_Pro",
    "Model": "MT04"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "AblePad_Pro-EEA",
    "Device": "AblePad_Pro-EEA",
    "Model": "MT04"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "Active T1",
    "Device": "Active_T1",
    "Model": "MT09"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "Active T1 EEA",
    "Device": "Active_T1",
    "Model": "MT09"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "BISON",
    "Device": "BISON",
    "Model": "BISON"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "BISON 2",
    "Device": "BISON_2",
    "Model": "RP04"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "BISON 2 EEA",
    "Device": "BISON_2",
    "Model": "RP04"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "BISON GT EEA",
    "Device": "BISON_GT",
    "Model": "BISON GT"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "BISON Pro",
    "Device": "BISON_Pro",
    "Model": "BISON Pro"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "BISON Pro EEA",
    "Device": "BISON_Pro",
    "Model": "BISON Pro"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "BISON R",
    "Device": "BISON_R",
    "Model": "BISON"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "BISON R EEA",
    "Device": "BISON_R",
    "Model": "BISON"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "BISON X10",
    "Device": "BISON_X10",
    "Model": "RP01"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "BISON X10 EEA",
    "Device": "BISON_X10",
    "Model": "RP01"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "BISON X10 Pro",
    "Device": "BISON_X10_Pro",
    "Model": "RP01"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "BISON X10 Pro EEA",
    "Device": "BISON_X10_Pro",
    "Model": "RP01"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "BISON X10 Pro TR",
    "Device": "BISON_X10_Pro",
    "Model": "RP01"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "BISON X10 RU",
    "Device": "BISON_X10",
    "Model": "RP01"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "BISON X10G",
    "Device": "BISON_X10G",
    "Model": "RP05"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "BISON X10G EEA",
    "Device": "BISON_X10G",
    "Model": "RP05"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "BISON X10G NFC",
    "Device": "BISON_X10G_NFC",
    "Model": "RP05"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "BISON X10G NFC EEA",
    "Device": "BISON_X10G_NFC",
    "Model": "RP05"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "BISON X10S",
    "Device": "BISON_X10S",
    "Model": "RP05"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "BISON X10S EEA",
    "Device": "BISON_X10S",
    "Model": "RP05"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "BISON X10S NFC",
    "Device": "BISON_X10S_NFC",
    "Model": "RP05"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "BISON X20",
    "Device": "BISON_X20",
    "Model": "PR4JBX20A"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "BISON X20 EEA",
    "Device": "BISON_X20",
    "Model": "PR4JBX20A"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "BISON_GT",
    "Device": "BISON_GT",
    "Model": "BISON GT"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "BISON_GT2",
    "Device": "BISON_GT2",
    "Model": "RP03"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "BISON_GT2_5G",
    "Device": "BISON_GT2_5G",
    "Model": "RP02"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "BISON_Pro_RU",
    "Device": "BISON_Pro",
    "Model": "BISON Pro"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "BISON_Pro_TR",
    "Device": "BISON_Pro",
    "Model": "BISON Pro"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "BISON_X10_Pro_RU",
    "Device": "BISON_X10_Pro",
    "Model": "RP01"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "BISON_X10_TR",
    "Device": "BISON_X10",
    "Model": "RP01"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "C1 Max",
    "Device": "C1_Max",
    "Model": "MP17"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "C1 Max EEA",
    "Device": "C1_Max",
    "Model": "MP17"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "C1 Plus",
    "Device": "C1_Plus",
    "Model": "MP29"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "C1 Plus EEA",
    "Device": "C1_Plus",
    "Model": "MP29"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "F1",
    "Device": "F1",
    "Model": "F1"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "F1_EEA",
    "Device": "F1",
    "Model": "F1"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "F2",
    "Device": "F2",
    "Model": "F2"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "F3",
    "Device": "UMIDIGI_F3",
    "Model": "MP09"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "F3 EEA",
    "Device": "UMIDIGI_F3",
    "Model": "MP09"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "F3 SE",
    "Device": "F3_SE",
    "Model": "MP09"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "F3 SE EEA",
    "Device": "F3_SE",
    "Model": "MP09"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "F3S",
    "Device": "F3S",
    "Model": "MP09"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "F3S EEA",
    "Device": "F3S",
    "Model": "MP09"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "F3_5G",
    "Device": "F3_5G",
    "Model": "MP13"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "F3_Pro_5G",
    "Device": "F3_Pro_5G",
    "Model": "MP19"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "G1 Max",
    "Device": "G1_Max",
    "Model": "MP18"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "G1 Max EEA",
    "Device": "G1_Max",
    "Model": "MP18"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "G1 Max RU",
    "Device": "G1_Max",
    "Model": "MP18"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "G1 Plus",
    "Device": "G1_Plus",
    "Model": "MP28"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "G1 Plus EEA",
    "Device": "G1_Plus",
    "Model": "MP28"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "G1_Tab",
    "Device": "G1_Tab",
    "Model": "MT10"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "G1_Tab_EEA",
    "Device": "G1_Tab_EEA",
    "Model": "MT10"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "G1_Tab_Kids",
    "Device": "G1_Tab_Kids",
    "Model": "MT10"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "G1_Tab_Kids_EEA",
    "Device": "G1_Tab_Kids_EEA",
    "Model": "MT10"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "G1_Tab_Mini",
    "Device": "G1_Tab_Mini",
    "Model": "FunPad-8-WIFI"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "G1_Tab_Mini",
    "Device": "G1_Tab_Mini",
    "Model": "TG3DBG1MA"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "G1_Tab_Mini_EEA",
    "Device": "G1_Tab_Mini_EEA",
    "Model": "TG3DBG1MA"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "G1_Tab_Mini_GO",
    "Device": "G1_Tab_Mini_GO",
    "Model": "TG3DBG1MA"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "G1_Tab_Mini_Kids",
    "Device": "G1_Tab_Mini_Kids",
    "Model": "TG3DBG1MA"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "G1_Tab_Mini_Kids_EEA",
    "Device": "G1_Tab_Mini_Kids_EEA",
    "Model": "TG3DBG1MA"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "G2",
    "Device": "UMIDIGI_G2",
    "Model": "MP21"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "G2 EEA",
    "Device": "UMIDIGI_G2",
    "Model": "MP21"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "G2_Tab",
    "Device": "G2_Tab",
    "Model": "MT11"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "G2_Tab_EEA",
    "Device": "G2_Tab_EEA",
    "Model": "MT11"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "G2_Tab_Kids",
    "Device": "G2_Tab_Kids",
    "Model": "MT11"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "G2_Tab_Kids_EEA",
    "Device": "G2_Tab_Kids_EEA",
    "Model": "MT11"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "G3",
    "Device": "UMIDIGI_G3",
    "Model": "MP24"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "G3 EEA",
    "Device": "UMIDIGI_G3",
    "Model": "MP24"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "G3 Plus",
    "Device": "G3_Plus",
    "Model": "MP25"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "G3 Plus EEA",
    "Device": "G3_Plus",
    "Model": "MP25"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "G3_Tab_Ultra",
    "Device": "G3_Tab_Ultra",
    "Model": "MT13"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "G3_Tab_Ultra_EEA",
    "Device": "G3_Tab_Ultra",
    "Model": "MT13"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "G4_Tab",
    "Device": "G4_Tab",
    "Model": "TG4ABG4TA"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "G4_Tab_Mini",
    "Device": "G4_Tab_Mini",
    "Model": "TG4ABG4MA"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "G5 Mecha",
    "Device": "G5_Mecha",
    "Model": "RP08"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "G5 Mecha EEA",
    "Device": "G5_Mecha",
    "Model": "RP08"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "G5 Mecha RU",
    "Device": "G5_Mecha",
    "Model": "RP08"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "G5_Tab",
    "Device": "G5_Tab",
    "Model": "3Q-3"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "G5_Tab",
    "Device": "G5_Tab",
    "Model": "A3-Pro"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "G5_Tab",
    "Device": "G5_Tab",
    "Model": "MT16"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "G5_Tab",
    "Device": "G5_Tab",
    "Model": "Tab-A100"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "G5_Tab_EEA",
    "Device": "G5_Tab_EEA",
    "Model": "MT16"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "G5_Tab_Kids",
    "Device": "G5_Tab_Kids",
    "Model": "MT16"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "G5_Tab_Kids_EEA",
    "Device": "G5_Tab_Kids_EEA",
    "Model": "MT16"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "G6_Tab",
    "Device": "G6_Tab",
    "Model": "TG2404GBA"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "G6_Tab_EEA",
    "Device": "G6_Tab_EEA",
    "Model": "TG2404GBA"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "G7_Tab",
    "Device": "G7_Tab",
    "Model": "TG4FBG7TA"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "G7_Tab_EEA",
    "Device": "G7_Tab",
    "Model": "TG4FBG7TA"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "G7_Tab_Mini",
    "Device": "G7_Tab_Mini",
    "Model": "TG2405GBA"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "G7_Tab_Mini_EEA",
    "Device": "G7_Tab_Mini_EEA",
    "Model": "TG2405GBA"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "G7_Tab_Pro",
    "Device": "G7_Tab_Pro",
    "Model": "TG2403GBA"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "G9 Tab",
    "Device": "G9_Tab",
    "Model": "TAB21"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "G9 Tab",
    "Device": "G9_Tab",
    "Model": "TG4FBG9TA"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "G9 Tab",
    "Device": "G9_Tab_EEA",
    "Model": "TG4FBG9TA"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "MT02_EEA",
    "Device": "MT02_EEA",
    "Model": "AblePad"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "One",
    "Device": "One",
    "Model": "One"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "One Max",
    "Device": "One_Max",
    "Model": "One Max"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "One Max E",
    "Device": "One_Max",
    "Model": "One Max"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "One Max RU",
    "Device": "One_Max",
    "Model": "One Max"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "One Pro",
    "Device": "One_Pro",
    "Model": "One Pro"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "Power",
    "Device": "Power",
    "Model": "Power"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "Power 5",
    "Device": "Power_5",
    "Model": "Power 5"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "Power 5 EEA",
    "Device": "Power_5",
    "Model": "Power 5"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "Power 5S",
    "Device": "Power_5S",
    "Model": "MP02"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "Power 5S EEA",
    "Device": "Power_5S",
    "Model": "MP02"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "Power 5S RU",
    "Device": "Power_5S",
    "Model": "MP02"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "Power 5S TR",
    "Device": "Power_5S",
    "Model": "MP02"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "Power 7",
    "Device": "Power_7",
    "Model": "MP06"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "Power 7 EEA",
    "Device": "Power_7",
    "Model": "MP06"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "Power 7 Max",
    "Device": "Power_7_Max",
    "Model": "MP06"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "Power 7 Max EEA",
    "Device": "Power_7_Max",
    "Model": "MP06"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "Power 7S",
    "Device": "Power_7S",
    "Model": "MP06"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "Power 7S EEA",
    "Device": "Power_7S",
    "Model": "MP06"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "Power_3",
    "Device": "Power_3",
    "Model": "Power_3"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "Power_3_EEA",
    "Device": "Power_3",
    "Model": "Power_3"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "Qin3ultra",
    "Device": "Qin3ultra",
    "Model": "Qin3ultra"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "S2PRO",
    "Device": "S2_PRO",
    "Model": "S2_PRO"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "S3_Pro",
    "Device": "S3_Pro",
    "Model": "S3_Pro"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "S5 Pro",
    "Device": "S5_Pro",
    "Model": "S5 Pro"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "S5_Pro_EEA",
    "Device": "S5_Pro",
    "Model": "S5 Pro"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "UMIDIGI A13 Pro Max",
    "Device": "UMIDIGI_A13_Pro_Max",
    "Model": "MP16"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "UMIDIGI A13 Pro Max EEA",
    "Device": "UMIDIGI_A13_Pro_Max",
    "Model": "MP16"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "UMIDIGI A15",
    "Device": "UMIDIGI_A15",
    "Model": "MP33"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "UMIDIGI A15 EEA",
    "Device": "UMIDIGI_A15",
    "Model": "MP33"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "UMIDIGI A15 RU",
    "Device": "UMIDIGI_A15",
    "Model": "MP33"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "UMIDIGI A15 Ultra",
    "Device": "A15_Ultra",
    "Model": "MP32"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "UMIDIGI A15C",
    "Device": "UMIDIGI_A15C",
    "Model": "MP34"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "UMIDIGI A15C EEA",
    "Device": "UMIDIGI_A15C",
    "Model": "MP34"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "UMIDIGI A16 Pro",
    "Device": "A16_Pro",
    "Model": "PA3NB16PB"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "UMIDIGI A75x",
    "Device": "CPA2651",
    "Model": "UMIDIGI A75x"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "UMIDIGI A76",
    "Device": "CPA2660",
    "Model": "UMIDIGI A76"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "UMIDIGI C1",
    "Device": "UMIDIGI_C1",
    "Model": "MP07"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "UMIDIGI C1 EEA",
    "Device": "UMIDIGI_C1",
    "Model": "MP07"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "UMIDIGI C2",
    "Device": "UMIDIGI_C2",
    "Model": "MP20"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "UMIDIGI C2 EEA",
    "Device": "UMIDIGI_C2",
    "Model": "MP20"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "UMIDIGI F3 Pro",
    "Device": "UMIDIGI_F3_Pro",
    "Model": "MP10"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "UMIDIGI F3 Pro EEA",
    "Device": "UMIDIGI_F3_Pro",
    "Model": "MP10"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "UMIDIGI G1",
    "Device": "UMIDIGI_G1",
    "Model": "MP08"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "UMIDIGI G1 EEA",
    "Device": "UMIDIGI_G1",
    "Model": "MP08"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "UMIDIGI G100",
    "Device": "G100",
    "Model": "UMIDIGI G100"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "UMIDIGI G100 5G",
    "Device": "G100_5G",
    "Model": "UMIDIGI G100 5G"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "UMIDIGI G100 Pro",
    "Device": "G100_Pro",
    "Model": "UMIDIGI G100 Pro"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "UMIDIGI G100A",
    "Device": "G100A",
    "Model": "UMIDIGI G100A"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "UMIDIGI G100x",
    "Device": "G100x",
    "Model": "UMIDIGI G100x"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "UMIDIGI G100x 5G",
    "Device": "G100x_5G",
    "Model": "UMIDIGI G100x 5G"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "UMIDIGI G3 Max",
    "Device": "G3_Max",
    "Model": "MP26"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "UMIDIGI G3 Max EEA",
    "Device": "G3_Max",
    "Model": "MP26"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "UMIDIGI G5",
    "Device": "UMIDIGI_G5",
    "Model": "MP27"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "UMIDIGI G5 EEA",
    "Device": "UMIDIGI_G5",
    "Model": "MP27"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "UMIDIGI G5A",
    "Device": "UMIDIGI_G5A",
    "Model": "MP38"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "UMIDIGI G5A EEA",
    "Device": "UMIDIGI_G5A",
    "Model": "MP38"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "UMIDIGI G5C",
    "Device": "UMIDIGI_G5C",
    "Model": "MP39"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "UMIDIGI G5C EEA",
    "Device": "UMIDIGI_G5C",
    "Model": "MP39"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "UMIDIGI G6",
    "Device": "G6",
    "Model": "PG2311GBA"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "UMIDIGI G6 5G",
    "Device": "G6_5G",
    "Model": "PG2309GBA"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "UMIDIGI G7",
    "Device": "G7",
    "Model": "PG3NBG7YA"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "UMIDIGI G7_5G",
    "Device": "G7_5G",
    "Model": "PG3NBG7YB"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "UMIDIGI G7_EEA",
    "Device": "G7",
    "Model": "PG3NBG7YA"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "UMIDIGI G9A",
    "Device": "G9A",
    "Model": "UMIDIGI G9A"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "UMIDIGI G9C",
    "Device": "G9C",
    "Model": "UMIDIGI G9C"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "UMIDIGI G9T",
    "Device": "G9T",
    "Model": "UMIDIGI G9T"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "UMIDIGI G9x",
    "Device": "G9x",
    "Model": "UMIDIGI G9x"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "UMIDIGI Note 100",
    "Device": "Note_100",
    "Model": "UMIDIGI Note 100"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "UMIDIGI Note 100 5G",
    "Device": "Note_100_5G",
    "Model": "UMIDIGI Note 100 5G"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "UMIDIGI Note 100A",
    "Device": "Note_100A",
    "Model": "UMIDIGI Note 100A"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "UMIDIGI Note 100x",
    "Device": "Note_100x",
    "Model": "UMIDIGI Note 100x"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "UMIDIGI Note 100x 5G",
    "Device": "Note_100x_5G",
    "Model": "UMIDIGI Note 100x 5G"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "UMIDIGI X",
    "Device": "UMIDIGI_X",
    "Model": "UMIDIGI X"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "Z2",
    "Device": "Z2",
    "Model": "Z2"
  },
  {
    "Retail Branding": "Umidigi",
    "Marketing Name": "Z2 Pro",
    "Device": "Z2_PRO",
    "Model": "Z2_PRO"
  },
  {
    "Retail Branding": "Umiio",
    "Marketing Name": "Q2",
    "Device": "Q2",
    "Model": "Q2"
  },
  {
    "Retail Branding": "Umix",
    "Marketing Name": "Lite L",
    "Device": "UMIX_LITE_L",
    "Model": "UMIX LITE L"
  },
  {
    "Retail Branding": "Umix",
    "Marketing Name": "Lite M",
    "Device": "UMIX_LITE_M",
    "Model": "UMIX LITE M"
  },
  {
    "Retail Branding": "Umix",
    "Marketing Name": "Lite XL",
    "Device": "UMIX_LITE_XL",
    "Model": "UMIX LITE XL"
  },
  {
    "Retail Branding": "Umix",
    "Marketing Name": "SP151",
    "Device": "SP151",
    "Model": "SP151"
  },
  {
    "Retail Branding": "Umix",
    "Marketing Name": "V1",
    "Device": "V1",
    "Model": "V1"
  },
  {
    "Retail Branding": "Umix",
    "Marketing Name": "Vinci M",
    "Device": "UMIX_VINCI_M",
    "Model": "UMIX VINCI M"
  },
  {
    "Retail Branding": "Umx(Ultimate Mobile Experience)",
    "Marketing Name": "U2-PLUS-TE-VR",
    "Device": "U2-PLUS-TE-VR",
    "Model": "U2-PLUS-TE-VR"
  },
  {
    "Retail Branding": "Umx(Ultimate Mobile Experience)",
    "Marketing Name": "U2VR",
    "Device": "U2VR",
    "Model": "U2VR"
  },
  {
    "Retail Branding": "Umx(Ultimate Mobile Experience)",
    "Marketing Name": "U3AR",
    "Device": "U3AR",
    "Model": "U3AR"
  },
  {
    "Retail Branding": "Umx(Ultimate Mobile Experience)",
    "Marketing Name": "U504TL",
    "Device": "U504TL",
    "Model": "U504TL"
  },
  {
    "Retail Branding": "Umx(Ultimate Mobile Experience)",
    "Marketing Name": "U673C",
    "Device": "U673C",
    "Model": "U673C"
  },
  {
    "Retail Branding": "Umx(Ultimate Mobile Experience)",
    "Marketing Name": "U683CL",
    "Device": "U683CL",
    "Model": "U683CL"
  },
  {
    "Retail Branding": "Umx(Ultimate Mobile Experience)",
    "Marketing Name": "U693CL",
    "Device": "U693CL",
    "Model": "U693CL"
  },
  {
    "Retail Branding": "Umx(Ultimate Mobile Experience)",
    "Marketing Name": "U696CL",
    "Device": "U696CL",
    "Model": "U696CL"
  },
  {
    "Retail Branding": "Unbluable)",
    "Marketing Name": "T7",
    "Device": "PaperTablet",
    "Model": "PAPER 7"
  },
  {
    "Retail Branding": "Unbluable)",
    "Marketing Name": "T7E",
    "Device": "PaperTablet",
    "Model": "PAPER 7"
  },
  {
    "Retail Branding": "Uneone",
    "Marketing Name": "SD50",
    "Device": "SD50",
    "Model": "SD50"
  },
  {
    "Retail Branding": "Uneone",
    "Marketing Name": "SD55",
    "Device": "UNEONE_SD55",
    "Model": "SD55"
  },
  {
    "Retail Branding": "Uneone",
    "Marketing Name": "SD57",
    "Device": "SD57",
    "Model": "SD57"
  },
  {
    "Retail Branding": "Uneone",
    "Marketing Name": "SD70",
    "Device": "SD70",
    "Model": "SD70"
  },
  {
    "Retail Branding": "Uneone",
    "Marketing Name": "SD80",
    "Device": "SD80",
    "Model": "SD80"
  },
  {
    "Retail Branding": "Unifi-TV",
    "Marketing Name": "Unifi-TV",
    "Device": "HP4BF-TM",
    "Model": "unifi-TV"
  },
  {
    "Retail Branding": "Unifi-TV",
    "Marketing Name": "unifi-TV",
    "Device": "HP40A3",
    "Model": "unifi-TV"
  },
  {
    "Retail Branding": "Unifi-TV",
    "Marketing Name": "unifi-TV",
    "Device": "HP43A",
    "Model": "unifi-TV"
  },
  {
    "Retail Branding": "Unifone",
    "Marketing Name": "Armor_5S",
    "Device": "Armor_5S",
    "Model": "Armor 5S"
  },
  {
    "Retail Branding": "Unifone",
    "Marketing Name": "U5_Breeze",
    "Device": "U5_Breeze",
    "Model": "U5_Breeze"
  },
  {
    "Retail Branding": "Unihertz",
    "Marketing Name": "Atom",
    "Device": "Atom",
    "Model": "Atom"
  },
  {
    "Retail Branding": "Unihertz",
    "Marketing Name": "Atom_L",
    "Device": "Atom_L",
    "Model": "Atom_L"
  },
  {
    "Retail Branding": "Unihertz",
    "Marketing Name": "Atom_XL",
    "Device": "Atom_XL",
    "Model": "Atom_XL"
  },
  {
    "Retail Branding": "Unihertz",
    "Marketing Name": "Jelly 2E",
    "Device": "Jelly_2E",
    "Model": "Jelly 2E"
  },
  {
    "Retail Branding": "Unihertz",
    "Marketing Name": "Jelly Max",
    "Device": "Jelly_Max",
    "Model": "Jelly Max"
  },
  {
    "Retail Branding": "Unihertz",
    "Marketing Name": "Jelly Star",
    "Device": "Jelly_Star",
    "Model": "Jelly Star"
  },
  {
    "Retail Branding": "Unihertz",
    "Marketing Name": "Jelly2",
    "Device": "Jelly2",
    "Model": "Jelly2"
  },
  {
    "Retail Branding": "Unihertz",
    "Marketing Name": "Jelly2_JP",
    "Device": "Jelly2_JP",
    "Model": "Jelly2_JP"
  },
  {
    "Retail Branding": "Unihertz",
    "Marketing Name": "Luna",
    "Device": "Luna",
    "Model": "Luna"
  },
  {
    "Retail Branding": "Unihertz",
    "Marketing Name": "TANK 01",
    "Device": "TANK_01",
    "Model": "TANK 01"
  },
  {
    "Retail Branding": "Unihertz",
    "Marketing Name": "TickTock-E",
    "Device": "UNIA62",
    "Model": "UNIA62_S01"
  },
  {
    "Retail Branding": "Unihertz",
    "Marketing Name": "TickTock-S",
    "Device": "TickTock-S",
    "Model": "TickTock-S"
  },
  {
    "Retail Branding": "Unihertz",
    "Marketing Name": "Ticktock",
    "Device": "Ticktock",
    "Model": "Ticktock"
  },
  {
    "Retail Branding": "Unihertz",
    "Marketing Name": "Titan",
    "Device": "Titan",
    "Model": "Titan"
  },
  {
    "Retail Branding": "Unihertz",
    "Marketing Name": "Titan 2",
    "Device": "Titan_2",
    "Model": "Titan 2"
  },
  {
    "Retail Branding": "Unihertz",
    "Marketing Name": "Titan Slim",
    "Device": "Titan_Slim",
    "Model": "Titan Slim"
  },
  {
    "Retail Branding": "Unihertz",
    "Marketing Name": "Titan pocket",
    "Device": "Titan_pocket",
    "Model": "Titan pocket"
  },
  {
    "Retail Branding": "UnionTek",
    "Marketing Name": "S65",
    "Device": "S65",
    "Model": "S65"
  },
  {
    "Retail Branding": "UnionTek",
    "Marketing Name": "S65L",
    "Device": "S65L",
    "Model": "S65L"
  },
  {
    "Retail Branding": "Unionaire",
    "Marketing Name": "Africa",
    "Device": "nippori",
    "Model": "Unionaire Android TV 2K"
  },
  {
    "Retail Branding": "Unionaire",
    "Marketing Name": "UnionaireATV4K",
    "Device": "hanyang",
    "Model": "Unionaire Android TV"
  },
  {
    "Retail Branding": "Unionbell",
    "Marketing Name": "U30",
    "Device": "U30",
    "Model": "U30"
  },
  {
    "Retail Branding": "Uniqcell",
    "Marketing Name": "UNI 10X",
    "Device": "UNI_10X",
    "Model": "UNI 10X"
  },
  {
    "Retail Branding": "Uniqcell",
    "Marketing Name": "UNI GO",
    "Device": "UNI_GO",
    "Model": "UNI_GO"
  },
  {
    "Retail Branding": "Uniqcell",
    "Marketing Name": "UNI X",
    "Device": "UNI_X",
    "Model": "UNI X"
  },
  {
    "Retail Branding": "Uniscope",
    "Marketing Name": "S6s",
    "Device": "S6s",
    "Model": "S6s"
  },
  {
    "Retail Branding": "Uniscope",
    "Marketing Name": "s6w",
    "Device": "s6w",
    "Model": "s6w"
  },
  {
    "Retail Branding": "Unistrong",
    "Marketing Name": "UT10",
    "Device": "UT10",
    "Model": "UT10"
  },
  {
    "Retail Branding": "Unistrong",
    "Marketing Name": "UT12",
    "Device": "UT12",
    "Model": "UT12"
  },
  {
    "Retail Branding": "Unistrong",
    "Marketing Name": "UT12P",
    "Device": "UT12P",
    "Model": "UT12P"
  },
  {
    "Retail Branding": "Unistrong",
    "Marketing Name": "UT30",
    "Device": "UT30",
    "Model": "UT30"
  },
  {
    "Retail Branding": "Unistrong",
    "Marketing Name": "UT30_EEA",
    "Device": "UT30",
    "Model": "UT30"
  },
  {
    "Retail Branding": "Unistrong",
    "Marketing Name": "UT32",
    "Device": "UT32",
    "Model": "UT32"
  },
  {
    "Retail Branding": "Unistrong",
    "Marketing Name": "UT56",
    "Device": "UT56",
    "Model": "UT56"
  },
  {
    "Retail Branding": "Unitech",
    "Marketing Name": "EA320",
    "Device": "EA320",
    "Model": "EA320"
  },
  {
    "Retail Branding": "Unitech",
    "Marketing Name": "EA500Plus",
    "Device": "EA500Plus",
    "Model": "EA500Plus"
  },
  {
    "Retail Branding": "Unitech",
    "Marketing Name": "EA510",
    "Device": "EA510",
    "Model": "EA510"
  },
  {
    "Retail Branding": "Unitech",
    "Marketing Name": "EA520",
    "Device": "EA520",
    "Model": "EA520"
  },
  {
    "Retail Branding": "Unitech",
    "Marketing Name": "EA520_US",
    "Device": "EA520_US",
    "Model": "EA520_US"
  },
  {
    "Retail Branding": "Unitech",
    "Marketing Name": "EA630",
    "Device": "EA630",
    "Model": "EA630"
  },
  {
    "Retail Branding": "Unitech",
    "Marketing Name": "EA630Plus",
    "Device": "EA630Plus",
    "Model": "EA630Plus"
  },
  {
    "Retail Branding": "Unitech",
    "Marketing Name": "EA630_Plus",
    "Device": "EA630_Plus",
    "Model": "EA630_Plus"
  },
  {
    "Retail Branding": "Unitech",
    "Marketing Name": "EA660",
    "Device": "EA660",
    "Model": "EA660"
  },
  {
    "Retail Branding": "Unitech",
    "Marketing Name": "HT330",
    "Device": "HT330",
    "Model": "HT330"
  },
  {
    "Retail Branding": "Unitech",
    "Marketing Name": "HT730",
    "Device": "HT730",
    "Model": "HT730"
  },
  {
    "Retail Branding": "Unitech",
    "Marketing Name": "HT730P",
    "Device": "HT730P",
    "Model": "HT730P"
  },
  {
    "Retail Branding": "Unitech",
    "Marketing Name": "PA760",
    "Device": "PA760",
    "Model": "PA760"
  },
  {
    "Retail Branding": "Unitech",
    "Marketing Name": "PA760_EE",
    "Device": "PA760",
    "Model": "PA760"
  },
  {
    "Retail Branding": "Unitech",
    "Marketing Name": "PA760_FP",
    "Device": "PA760",
    "Model": "PA760"
  },
  {
    "Retail Branding": "Unitech",
    "Marketing Name": "PA768",
    "Device": "PA768",
    "Model": "PA768"
  },
  {
    "Retail Branding": "Unitech",
    "Marketing Name": "PA768e",
    "Device": "PA768",
    "Model": "PA768"
  },
  {
    "Retail Branding": "Unitech",
    "Marketing Name": "RT112",
    "Device": "RT112",
    "Model": "RT112"
  },
  {
    "Retail Branding": "Unitech",
    "Marketing Name": "TB85",
    "Device": "TB85",
    "Model": "TB85"
  },
  {
    "Retail Branding": "Unitech",
    "Marketing Name": "TB85Plus",
    "Device": "TB85Plus",
    "Model": "TB85Plus"
  },
  {
    "Retail Branding": "Unitech",
    "Marketing Name": "WD200",
    "Device": "wd200",
    "Model": "WD200"
  },
  {
    "Retail Branding": "Unitech",
    "Marketing Name": "WD200 Plus",
    "Device": "WD200P",
    "Model": "WD200P"
  },
  {
    "Retail Branding": "United Group",
    "Marketing Name": "KSTB6020",
    "Device": "KSTB6020",
    "Model": "KSTB6020"
  },
  {
    "Retail Branding": "UnityWireless",
    "Marketing Name": "EPIC E55",
    "Device": "EPIC-E55",
    "Model": "EPIC-E55"
  },
  {
    "Retail Branding": "Univision",
    "Marketing Name": "Univision S800",
    "Device": "SEI800UV",
    "Model": "Univision S800"
  },
  {
    "Retail Branding": "Unnecto",
    "Marketing Name": "Bolt 1U",
    "Device": "Bolt_1U",
    "Model": "Bolt 1U"
  },
  {
    "Retail Branding": "Unnecto",
    "Marketing Name": "Bolt1",
    "Device": "Bolt1",
    "Model": "Bolt 1"
  },
  {
    "Retail Branding": "Unnecto",
    "Marketing Name": "QUATTRO_M-3",
    "Device": "QUATTRO_M-3",
    "Model": "QUATTRO_M-3"
  },
  {
    "Retail Branding": "Unnecto",
    "Marketing Name": "U4560",
    "Device": "U4560",
    "Model": "U4560"
  },
  {
    "Retail Branding": "Unnecto",
    "Marketing Name": "UB101",
    "Device": "Bolt10",
    "Model": "UB101"
  },
  {
    "Retail Branding": "Unnecto",
    "Marketing Name": "UB101_albssl",
    "Device": "Bolt10",
    "Model": "UB101"
  },
  {
    "Retail Branding": "Unnecto",
    "Marketing Name": "UB202",
    "Device": "Bolt20",
    "Model": "UB202"
  },
  {
    "Retail Branding": "Unnecto",
    "Marketing Name": "UB202_albssl",
    "Device": "Bolt20",
    "Model": "UB202"
  },
  {
    "Retail Branding": "Unnecto",
    "Marketing Name": "UB501_enetnp",
    "Device": "Bolt_5G",
    "Model": "UB501"
  },
  {
    "Retail Branding": "Unnecto",
    "Marketing Name": "UB501_licar",
    "Device": "Bolt_5G",
    "Model": "UB501"
  },
  {
    "Retail Branding": "Unnecto",
    "Marketing Name": "UB501_openesm",
    "Device": "Bolt_5G",
    "Model": "UB501"
  },
  {
    "Retail Branding": "Unnecto",
    "Marketing Name": "UB501_openla",
    "Device": "Bolt_5G",
    "Model": "UB501"
  },
  {
    "Retail Branding": "Unnecto",
    "Marketing Name": "UE010",
    "Device": "ECO_10",
    "Model": "UE010"
  },
  {
    "Retail Branding": "Unnecto",
    "Marketing Name": "UE020",
    "Device": "ECO_20",
    "Model": "UE020"
  },
  {
    "Retail Branding": "Unnecto",
    "Marketing Name": "UE020_albssl",
    "Device": "ECO_20",
    "Model": "UE020"
  },
  {
    "Retail Branding": "Unnion Technologies",
    "Marketing Name": "HH25",
    "Device": "HH25",
    "Model": "HH25"
  },
  {
    "Retail Branding": "Unnion Technologies",
    "Marketing Name": "UN-CT101",
    "Device": "UN-CT101",
    "Model": "UN-CT101"
  },
  {
    "Retail Branding": "Unnion Technologies",
    "Marketing Name": "UNSP7",
    "Device": "UNSP7",
    "Model": "UNSP7"
  },
  {
    "Retail Branding": "Unnion Technologies",
    "Marketing Name": "Unnion SP10",
    "Device": "SP10",
    "Model": "SP10"
  },
  {
    "Retail Branding": "UnoPhone",
    "Marketing Name": "NewPad 10",
    "Device": "NewPad_10",
    "Model": "NewPad 10"
  },
  {
    "Retail Branding": "UnoPhone",
    "Marketing Name": "Premier5",
    "Device": "Premier5",
    "Model": "Premier5"
  },
  {
    "Retail Branding": "UnoPhone",
    "Marketing Name": "Premier5Max",
    "Device": "Premier5Max",
    "Model": "Premier5Max"
  },
  {
    "Retail Branding": "UnoPhone",
    "Marketing Name": "Premier8",
    "Device": "Premier8",
    "Model": "Premier8"
  },
  {
    "Retail Branding": "UnoPhone",
    "Marketing Name": "Premier_ProA",
    "Device": "Premier_ProA",
    "Model": "Premier Pro"
  },
  {
    "Retail Branding": "UnoPhone",
    "Marketing Name": "Premier_Pro_B",
    "Device": "Premier_Pro_B",
    "Model": "Premier Pro"
  },
  {
    "Retail Branding": "UnoPhone",
    "Marketing Name": "Prime6_US",
    "Device": "Prime6_US",
    "Model": "Prime6"
  },
  {
    "Retail Branding": "UnoPhone",
    "Marketing Name": "UNO_Premier55",
    "Device": "Premier55",
    "Model": "Premier55"
  },
  {
    "Retail Branding": "UnoPhone",
    "Marketing Name": "UNO_Prime6",
    "Device": "UNO_Prime6",
    "Model": "Prime6"
  },
  {
    "Retail Branding": "Unonu",
    "Marketing Name": "N63A",
    "Device": "N63A",
    "Model": "UNONU N63"
  },
  {
    "Retail Branding": "Unonu",
    "Marketing Name": "UN55L",
    "Device": "UN55L",
    "Model": "UN55L"
  },
  {
    "Retail Branding": "Unonu",
    "Marketing Name": "UNONU N65 LITE",
    "Device": "UNONU_N65_LITE",
    "Model": "UNONU N65 LITE"
  },
  {
    "Retail Branding": "Unonu",
    "Marketing Name": "UNONU U4001",
    "Device": "UNONU_U4001",
    "Model": "U4001"
  },
  {
    "Retail Branding": "Unonu",
    "Marketing Name": "UNONU W61",
    "Device": "UNONU_W61",
    "Model": "UNONU W61"
  },
  {
    "Retail Branding": "Unonu",
    "Marketing Name": "UNONU X5C",
    "Device": "X5C",
    "Model": "X5C"
  },
  {
    "Retail Branding": "Unonu",
    "Marketing Name": "UNONU_L55D",
    "Device": "UNONU_L55D",
    "Model": "UNONU_L55D"
  },
  {
    "Retail Branding": "Unonu",
    "Marketing Name": "UNONU_N55S",
    "Device": "UNONU_N55S",
    "Model": "UNONU N55S"
  },
  {
    "Retail Branding": "Unonu",
    "Marketing Name": "UNONU_W609",
    "Device": "UNONU_W609",
    "Model": "UNONU_W609"
  },
  {
    "Retail Branding": "Unonu",
    "Marketing Name": "UT3G",
    "Device": "UT3G",
    "Model": "UT3G"
  },
  {
    "Retail Branding": "Unonu",
    "Marketing Name": "UT3GPlus",
    "Device": "UT3GPlus",
    "Model": "UT3G"
  },
  {
    "Retail Branding": "Unonu",
    "Marketing Name": "W40L",
    "Device": "W40L",
    "Model": "W40L"
  },
  {
    "Retail Branding": "Unonu",
    "Marketing Name": "W50A",
    "Device": "W50A",
    "Model": "W50A"
  },
  {
    "Retail Branding": "Unonu",
    "Marketing Name": "W55G",
    "Device": "W55G",
    "Model": "W55G"
  },
  {
    "Retail Branding": "Unonu",
    "Marketing Name": "W55_PLUS_B125",
    "Device": "W55_PLUS",
    "Model": "W55_PLUS"
  },
  {
    "Retail Branding": "Unonu",
    "Marketing Name": "W55_PLUS_B18",
    "Device": "W55_PLUS",
    "Model": "W55_PLUS"
  },
  {
    "Retail Branding": "Unonu",
    "Marketing Name": "W57A",
    "Device": "UNONU_W57A",
    "Model": "UNONU W57A"
  },
  {
    "Retail Branding": "Unonu",
    "Marketing Name": "X4G",
    "Device": "X4G",
    "Model": "UNONU X4G"
  },
  {
    "Retail Branding": "Unonu",
    "Marketing Name": "X4G",
    "Device": "X4G",
    "Model": "X4G"
  },
  {
    "Retail Branding": "Up_Mobile",
    "Marketing Name": "Mover_Edition",
    "Device": "Mover_Edition",
    "Model": "Up_Mobile_Mover_Edition"
  },
  {
    "Retail Branding": "Up_Mobile",
    "Marketing Name": "Mover_Edition_EEA",
    "Device": "Mover_Edition",
    "Model": "Up_Mobile_Mover_Edition"
  },
  {
    "Retail Branding": "Uphone",
    "Marketing Name": "SPURT R3",
    "Device": "SPURT_R3",
    "Model": "SPURT R3"
  },
  {
    "Retail Branding": "Upserve",
    "Marketing Name": "5-Inches",
    "Device": "5-Inches",
    "Model": "5-Inches"
  },
  {
    "Retail Branding": "Urovo",
    "Marketing Name": "CT58S",
    "Device": "CT58S",
    "Model": "CT58S"
  },
  {
    "Retail Branding": "Urovo",
    "Marketing Name": "DT20",
    "Device": "SQ57",
    "Model": "DT20"
  },
  {
    "Retail Branding": "Urovo",
    "Marketing Name": "DT20 Pro",
    "Device": "SQ57S",
    "Model": "DT20_Pro"
  },
  {
    "Retail Branding": "Urovo",
    "Marketing Name": "DT20_EEA",
    "Device": "SQ57",
    "Model": "DT20"
  },
  {
    "Retail Branding": "Urovo",
    "Marketing Name": "DT20_RU",
    "Device": "SQ57",
    "Model": "DT20"
  },
  {
    "Retail Branding": "Urovo",
    "Marketing Name": "DT40",
    "Device": "DT40",
    "Model": "DT40"
  },
  {
    "Retail Branding": "Urovo",
    "Marketing Name": "DT40_EEA",
    "Device": "DT40",
    "Model": "DT40"
  },
  {
    "Retail Branding": "Urovo",
    "Marketing Name": "DT50",
    "Device": "DT50",
    "Model": "DT50"
  },
  {
    "Retail Branding": "Urovo",
    "Marketing Name": "DT50",
    "Device": "DT50S",
    "Model": "DT50"
  },
  {
    "Retail Branding": "Urovo",
    "Marketing Name": "DT50 5G",
    "Device": "DT50_5G",
    "Model": "DT50_5G"
  },
  {
    "Retail Branding": "Urovo",
    "Marketing Name": "DT610",
    "Device": "DT610",
    "Model": "DT610"
  },
  {
    "Retail Branding": "Urovo",
    "Marketing Name": "DT630",
    "Device": "DT630",
    "Model": "DT630"
  },
  {
    "Retail Branding": "Urovo",
    "Marketing Name": "DT66",
    "Device": "DT66",
    "Model": "DT66"
  },
  {
    "Retail Branding": "Urovo",
    "Marketing Name": "K388 Pro",
    "Device": "K388_Pro",
    "Model": "K388_Pro"
  },
  {
    "Retail Branding": "Urovo",
    "Marketing Name": "P8100",
    "Device": "P8100",
    "Model": "P8100"
  },
  {
    "Retail Branding": "Urovo",
    "Marketing Name": "P8100P",
    "Device": "P8100P",
    "Model": "P8100P 4G"
  },
  {
    "Retail Branding": "Urovo",
    "Marketing Name": "P8100P 5G",
    "Device": "P8100P_5G",
    "Model": "P8100P_5G"
  },
  {
    "Retail Branding": "Urovo",
    "Marketing Name": "RT40",
    "Device": "SQ47",
    "Model": "RT40"
  },
  {
    "Retail Branding": "Urovo",
    "Marketing Name": "RT40S",
    "Device": "RT40S",
    "Model": "RT40S"
  },
  {
    "Retail Branding": "Urovo",
    "Marketing Name": "U2",
    "Device": "SQ46M",
    "Model": "U2"
  },
  {
    "Retail Branding": "Urovo",
    "Marketing Name": "U2S",
    "Device": "U2S",
    "Model": "U2S"
  },
  {
    "Retail Branding": "Urovo",
    "Marketing Name": "i6200Series",
    "Device": "i6200Series",
    "Model": "i6200Series"
  },
  {
    "Retail Branding": "Urovo",
    "Marketing Name": "i6310",
    "Device": "i6310",
    "Model": "i6310"
  },
  {
    "Retail Branding": "Urovo",
    "Marketing Name": "i9000S",
    "Device": "i9000S",
    "Model": "i9000S"
  },
  {
    "Retail Branding": "Urovo",
    "Marketing Name": "i9100",
    "Device": "i9100",
    "Model": "i9100"
  },
  {
    "Retail Branding": "Usha Shriram",
    "Marketing Name": "RA_1_GENIUS_STAR",
    "Device": "RA_1_GENIUS_STAR",
    "Model": "RA_1_GENIUS_STAR"
  },
  {
    "Retail Branding": "Utopia",
    "Marketing Name": "UH0342  UHTABLET10.1INCH",
    "Device": "UH0342",
    "Model": "UH0342"
  },
  {
    "Retail Branding": "V-MOCCS",
    "Marketing Name": "VT-A9",
    "Device": "VT-A9",
    "Model": "VT-A9"
  },
  {
    "Retail Branding": "V2COM",
    "Marketing Name": "T2",
    "Device": "ROCKY_T2",
    "Model": "ROCKY T2"
  },
  {
    "Retail Branding": "V7",
    "Marketing Name": "BUV7TBLT10A",
    "Device": "BUV7TBLT10A",
    "Model": "BUV7TBLT10A"
  },
  {
    "Retail Branding": "V7",
    "Marketing Name": "IFPXX03-V7PRO",
    "Device": "rk3588_t",
    "Model": "IFP03V7PRO"
  },
  {
    "Retail Branding": "V7",
    "Marketing Name": "IFPXX03-V7PRO",
    "Device": "rk3588_t",
    "Model": "IFPO3V7PRO"
  },
  {
    "Retail Branding": "V7",
    "Marketing Name": "Zyro",
    "Device": "zyro",
    "Model": "V7 Zyro"
  },
  {
    "Retail Branding": "VAARAHI",
    "Marketing Name": "TEO 8",
    "Device": "T8LTE32G",
    "Model": "TEO8LTE"
  },
  {
    "Retail Branding": "VAIO",
    "Marketing Name": "VA-10J",
    "Device": "VA-10J",
    "Model": "JCI VA-10J"
  },
  {
    "Retail Branding": "VAIO",
    "Marketing Name": "VPA051",
    "Device": "VPA051",
    "Model": "VPA051"
  },
  {
    "Retail Branding": "VALE",
    "Marketing Name": "V10A",
    "Device": "V10A",
    "Model": "V10A"
  },
  {
    "Retail Branding": "VALE",
    "Marketing Name": "V10A",
    "Device": "V10A-4128",
    "Model": "V10A"
  },
  {
    "Retail Branding": "VALE",
    "Marketing Name": "V10E-LTE",
    "Device": "V10E-LTE",
    "Model": "V10E-LTE-464"
  },
  {
    "Retail Branding": "VALE",
    "Marketing Name": "V10E_LTE_464",
    "Device": "V10E_LTE_464",
    "Model": "V10E_LTE_464"
  },
  {
    "Retail Branding": "VALE",
    "Marketing Name": "V11E LTE_4128",
    "Device": "V11E_LTE_4128",
    "Model": "V11E LTE"
  },
  {
    "Retail Branding": "VALE",
    "Marketing Name": "V12E LTE_14",
    "Device": "V12E_LTE_8128",
    "Model": "V12E LTE-8128"
  },
  {
    "Retail Branding": "VALE",
    "Marketing Name": "V12E-LTE",
    "Device": "V12E-LTE",
    "Model": "V12E-LTE-8128"
  },
  {
    "Retail Branding": "VALERION",
    "Marketing Name": "VisionMaster",
    "Device": "hengshan",
    "Model": "VisionMaster"
  },
  {
    "Retail Branding": "VALIFONE",
    "Marketing Name": "M790",
    "Device": "M790",
    "Model": "M790"
  },
  {
    "Retail Branding": "VALIFONE",
    "Marketing Name": "V200_EEA",
    "Device": "V200",
    "Model": "V200"
  },
  {
    "Retail Branding": "VALIFONE",
    "Marketing Name": "V210",
    "Device": "V210",
    "Model": "V210"
  },
  {
    "Retail Branding": "VALIFONE",
    "Marketing Name": "V350",
    "Device": "V350",
    "Model": "V350"
  },
  {
    "Retail Branding": "VALIFONE",
    "Marketing Name": "V700",
    "Device": "V700",
    "Model": "V700"
  },
  {
    "Retail Branding": "VALIFONE",
    "Marketing Name": "V710",
    "Device": "V710",
    "Model": "V710"
  },
  {
    "Retail Branding": "VALIFONE",
    "Marketing Name": "V730",
    "Device": "V730",
    "Model": "V730"
  },
  {
    "Retail Branding": "VALIFONE",
    "Marketing Name": "V950",
    "Device": "V950",
    "Model": "V950"
  },
  {
    "Retail Branding": "VALIFONE",
    "Marketing Name": "W888",
    "Device": "W888",
    "Model": "W888"
  },
  {
    "Retail Branding": "VALIFONE",
    "Marketing Name": "W999",
    "Device": "W999",
    "Model": "W999"
  },
  {
    "Retail Branding": "VALTECH",
    "Marketing Name": "TAB7Q804VAL",
    "Device": "TAB7Q804VAL",
    "Model": "TAB7Q804VAL"
  },
  {
    "Retail Branding": "VANTEC",
    "Marketing Name": "G4",
    "Device": "G4",
    "Model": "G4"
  },
  {
    "Retail Branding": "VANTEC",
    "Marketing Name": "G5",
    "Device": "G5",
    "Model": "G5"
  },
  {
    "Retail Branding": "VANTEC",
    "Marketing Name": "telma_i401",
    "Device": "G4",
    "Model": "G4"
  },
  {
    "Retail Branding": "VASOUN",
    "Marketing Name": "L10-C03",
    "Device": "L10-C03",
    "Model": "L10-C03"
  },
  {
    "Retail Branding": "VASOUN",
    "Marketing Name": "L10-C03_EEA",
    "Device": "L10-C03_EEA",
    "Model": "L10-C03_EEA"
  },
  {
    "Retail Branding": "VASOUN",
    "Marketing Name": "L10-M01",
    "Device": "TAB12_Pro",
    "Model": "L10-M01"
  },
  {
    "Retail Branding": "VASOUN",
    "Marketing Name": "L10-T01",
    "Device": "L10-T01",
    "Model": "L10-T01"
  },
  {
    "Retail Branding": "VASOUN",
    "Marketing Name": "L10-T02",
    "Device": "L10-T02",
    "Model": "L10-T02"
  },
  {
    "Retail Branding": "VASOUN",
    "Marketing Name": "L10-T02",
    "Device": "L10-T02",
    "Model": "VISION Tab"
  },
  {
    "Retail Branding": "VASOUN",
    "Marketing Name": "L10-T02-EEA",
    "Device": "L10-T02-EEA",
    "Model": "L10-T02"
  },
  {
    "Retail Branding": "VASOUN",
    "Marketing Name": "L10-T02-EEA",
    "Device": "L10-T02-EEA",
    "Model": "L10-T02-EEA"
  },
  {
    "Retail Branding": "VASOUN",
    "Marketing Name": "L10-T11",
    "Device": "L10-T11",
    "Model": "L10-T11"
  },
  {
    "Retail Branding": "VASOUN",
    "Marketing Name": "L10-T11-EEA",
    "Device": "L10-T11-EEA",
    "Model": "L10-T11-EEA"
  },
  {
    "Retail Branding": "VASOUN",
    "Marketing Name": "L10-T17",
    "Device": "L10-T17",
    "Model": "L10-T17"
  },
  {
    "Retail Branding": "VASOUN",
    "Marketing Name": "L10-T17-EEA",
    "Device": "L10-T17-EEA",
    "Model": "L10-T17-EEA"
  },
  {
    "Retail Branding": "VASOUN",
    "Marketing Name": "L10_A01",
    "Device": "L10_A01",
    "Model": "L10"
  },
  {
    "Retail Branding": "VASOUN",
    "Marketing Name": "L10_A01_EEA",
    "Device": "L10_A01_EEA",
    "Model": "L10"
  },
  {
    "Retail Branding": "VASOUN",
    "Marketing Name": "L10_A02",
    "Device": "L10_A02",
    "Model": "L10"
  },
  {
    "Retail Branding": "VASOUN",
    "Marketing Name": "L10_A02_EEA",
    "Device": "L10_A02_EEA",
    "Model": "L10"
  },
  {
    "Retail Branding": "VASOUN",
    "Marketing Name": "L10_A03",
    "Device": "L10_A03",
    "Model": "L10"
  },
  {
    "Retail Branding": "VASOUN",
    "Marketing Name": "L10_A03_EEA",
    "Device": "L10_A03_EEA",
    "Model": "L10"
  },
  {
    "Retail Branding": "VASOUN",
    "Marketing Name": "L10_A05",
    "Device": "L10_A05",
    "Model": "L10"
  },
  {
    "Retail Branding": "VASOUN",
    "Marketing Name": "L10_A05_EEA",
    "Device": "L10_A05_EEA",
    "Model": "L10"
  },
  {
    "Retail Branding": "VASOUN",
    "Marketing Name": "L10_A06",
    "Device": "L10_A06",
    "Model": "L10"
  },
  {
    "Retail Branding": "VASOUN",
    "Marketing Name": "L10_T05",
    "Device": "L10_T05",
    "Model": "L10"
  },
  {
    "Retail Branding": "VASOUN",
    "Marketing Name": "L10_T05_EEA",
    "Device": "L10_T05_EEA",
    "Model": "L10"
  },
  {
    "Retail Branding": "VASOUN",
    "Marketing Name": "L10_T06",
    "Device": "L10_T06",
    "Model": "L10_T06"
  },
  {
    "Retail Branding": "VASOUN",
    "Marketing Name": "L10_T06_EEA",
    "Device": "L10_T06_EEA",
    "Model": "L10_T06_EEA"
  },
  {
    "Retail Branding": "VASOUN",
    "Marketing Name": "L10_T08",
    "Device": "L10_T08",
    "Model": "L10_T08"
  },
  {
    "Retail Branding": "VASOUN",
    "Marketing Name": "L10_T08_EEA",
    "Device": "L10_T08_EEA",
    "Model": "L10_T08"
  },
  {
    "Retail Branding": "VASOUN",
    "Marketing Name": "L10_T08_EEA",
    "Device": "L10_T08_EEA",
    "Model": "L10_T08_EEA"
  },
  {
    "Retail Branding": "VASOUN",
    "Marketing Name": "L10_T10",
    "Device": "L10_T10",
    "Model": "L10_T10"
  },
  {
    "Retail Branding": "VASOUN",
    "Marketing Name": "L10_T10_EEA",
    "Device": "L10_T10_EEA",
    "Model": "L10_T10_EEA"
  },
  {
    "Retail Branding": "VASOUN",
    "Marketing Name": "L10_T14",
    "Device": "L10_T14",
    "Model": "L10"
  },
  {
    "Retail Branding": "VASOUN",
    "Marketing Name": "L10_T14_EEA",
    "Device": "L10_T14_EEA",
    "Model": "L10"
  },
  {
    "Retail Branding": "VASOUN",
    "Marketing Name": "L10_T16",
    "Device": "L10_T16",
    "Model": "L10_T16"
  },
  {
    "Retail Branding": "VASOUN",
    "Marketing Name": "L10_T16_EEA",
    "Device": "L10_T16",
    "Model": "L10_T16"
  },
  {
    "Retail Branding": "VASOUN",
    "Marketing Name": "M7",
    "Device": "M7",
    "Model": "M7"
  },
  {
    "Retail Branding": "VASOUN",
    "Marketing Name": "M7_EEA",
    "Device": "M7_EEA",
    "Model": "M7_EEA"
  },
  {
    "Retail Branding": "VASOUN",
    "Marketing Name": "Rugged_Tablet_PC",
    "Device": "TAB_15_Plus",
    "Model": "L10"
  },
  {
    "Retail Branding": "VASOUN",
    "Marketing Name": "TAB12",
    "Device": "TAB12",
    "Model": "L10"
  },
  {
    "Retail Branding": "VASOUN",
    "Marketing Name": "TAB12_EEA",
    "Device": "TAB12_EEA",
    "Model": "L10"
  },
  {
    "Retail Branding": "VBox",
    "Marketing Name": "XTi",
    "Device": "DTP9539",
    "Model": "XTi"
  },
  {
    "Retail Branding": "VECT",
    "Marketing Name": "VECT-IFPD",
    "Device": "rk3588_t",
    "Model": "UIT"
  },
  {
    "Retail Branding": "VENSTAR",
    "Marketing Name": "VENSTAR2050",
    "Device": "VENSTAR2050",
    "Model": "VENSTAR2050"
  },
  {
    "Retail Branding": "VETOO",
    "Marketing Name": "T4GB07",
    "Device": "T4GB07",
    "Model": "T4GB07"
  },
  {
    "Retail Branding": "VETOO",
    "Marketing Name": "T4GB10",
    "Device": "T4GB10",
    "Model": "T4GB10"
  },
  {
    "Retail Branding": "VETOO",
    "Marketing Name": "TWIFIB07",
    "Device": "TWIFIB07",
    "Model": "TWIFIB07"
  },
  {
    "Retail Branding": "VETOO",
    "Marketing Name": "V10",
    "Device": "V10",
    "Model": "V10"
  },
  {
    "Retail Branding": "VEXO",
    "Marketing Name": "VEXO_SMART_INTERACTIVE_PANEL",
    "Device": "rk3588_t",
    "Model": "VEXO_X1PRO"
  },
  {
    "Retail Branding": "VFONE",
    "Marketing Name": "Mix",
    "Device": "Mix",
    "Model": "Mix"
  },
  {
    "Retail Branding": "VIA Tech",
    "Marketing Name": "Mobile360 IVT01",
    "Device": "IVT01",
    "Model": "Mobile360 IVT01"
  },
  {
    "Retail Branding": "VIBE Z",
    "Marketing Name": "K910",
    "Device": "kitonw",
    "Model": "Lenovo K910"
  },
  {
    "Retail Branding": "VICKUN",
    "Marketing Name": "N101C",
    "Device": "N101C",
    "Model": "N101C"
  },
  {
    "Retail Branding": "VICTUS",
    "Marketing Name": "VRS5_Plus",
    "Device": "VRS5_Plus",
    "Model": "VRS5_Plus"
  },
  {
    "Retail Branding": "VICTUS",
    "Marketing Name": "VRS6_Plus",
    "Device": "VRS6_Plus",
    "Model": "VRS6 Plus"
  },
  {
    "Retail Branding": "VID(CN)",
    "Marketing Name": "GQ3103RH2",
    "Device": "GQ3103RH2_VID",
    "Model": "GQ3103RH2"
  },
  {
    "Retail Branding": "VID(CN)",
    "Marketing Name": "GQ3107TF3",
    "Device": "GQ3107TF3",
    "Model": "GQ3107TF3"
  },
  {
    "Retail Branding": "VID(CN)",
    "Marketing Name": "GQ3112SH3",
    "Device": "GQ3112SH3_VID",
    "Model": "GQ3112SH3"
  },
  {
    "Retail Branding": "VID(CN)",
    "Marketing Name": "GQ3115TF5",
    "Device": "GQ3115TF5_VID",
    "Model": "GQ3115TF5"
  },
  {
    "Retail Branding": "VID(CN)",
    "Marketing Name": "GQ3116TF4",
    "Device": "GQ3116TF4",
    "Model": "GQ3116TF4"
  },
  {
    "Retail Branding": "VID(CN)",
    "Marketing Name": "GQ3117SH2",
    "Device": "GQ3117SH2_VID",
    "Model": "GQ3117SH2"
  },
  {
    "Retail Branding": "VID(CN)",
    "Marketing Name": "GQ3121AF1",
    "Device": "GQ3121AF1_VID",
    "Model": "GQ3121AF1"
  },
  {
    "Retail Branding": "VID(CN)",
    "Marketing Name": "GQ3127RH1",
    "Device": "GQ3127RH1_VID",
    "Model": "GQ3127RH1"
  },
  {
    "Retail Branding": "VID(CN)",
    "Marketing Name": "GQ3128RH1",
    "Device": "GQ3128RH1_VID",
    "Model": "GQ3128RH1"
  },
  {
    "Retail Branding": "VID(CN)",
    "Marketing Name": "GQ3129RH1",
    "Device": "GQ3129RH1",
    "Model": "GQ3129RH1"
  },
  {
    "Retail Branding": "VID(CN)",
    "Marketing Name": "GQ5007AF2",
    "Device": "GQ5007AF2",
    "Model": "GQ5007AF2"
  },
  {
    "Retail Branding": "VID(CN)",
    "Marketing Name": "GQ5007TF2",
    "Device": "GQ5007TF2_VID",
    "Model": "GQ5007TF2"
  },
  {
    "Retail Branding": "VID(CN)",
    "Marketing Name": "GQ5008 AF3",
    "Device": "GQ5008AF3_VID",
    "Model": "GQ5008AF3"
  },
  {
    "Retail Branding": "VID(CN)",
    "Marketing Name": "GQ5008TF4",
    "Device": "GQ5008TF4_VID",
    "Model": "GQ5008TF4"
  },
  {
    "Retail Branding": "VID(CN)",
    "Marketing Name": "GQ5010",
    "Device": "GQ5010",
    "Model": "GQ5010"
  },
  {
    "Retail Branding": "VID(CN)",
    "Marketing Name": "GQ5012BF3",
    "Device": "GQ5012BF3",
    "Model": "GQ5012BF3"
  },
  {
    "Retail Branding": "VID(CN)",
    "Marketing Name": "GQ5013TF1",
    "Device": "GQ5013TF2_VID",
    "Model": "GQ5013TF1"
  },
  {
    "Retail Branding": "VID(CN)",
    "Marketing Name": "GQ5015",
    "Device": "GQ5015",
    "Model": "GQ5015"
  },
  {
    "Retail Branding": "VID(CN)",
    "Marketing Name": "GQ5015RH1",
    "Device": "GQ5015RH1_VID",
    "Model": "GQ5015RH1"
  },
  {
    "Retail Branding": "VID(CN)",
    "Marketing Name": "GQ5016TF1",
    "Device": "GQ5016TF1_VID",
    "Model": "GQ5016TF1"
  },
  {
    "Retail Branding": "VID(CN)",
    "Marketing Name": "GQ5017BF2",
    "Device": "GQ5017BF2_VID",
    "Model": "GQ5017BF2"
  },
  {
    "Retail Branding": "VID(CN)",
    "Marketing Name": "GQ5021AH2",
    "Device": "GQ5021AH2_VID",
    "Model": "GQ5021AH2"
  },
  {
    "Retail Branding": "VID(CN)",
    "Marketing Name": "GQ5021RH1",
    "Device": "GQ5021RH1_VID",
    "Model": "GQ5021RH1"
  },
  {
    "Retail Branding": "VID(CN)",
    "Marketing Name": "GQ8000BF2",
    "Device": "GQ8000BF2",
    "Model": "GQ8000BF2"
  },
  {
    "Retail Branding": "VID(CN)",
    "Marketing Name": "R1000BF4",
    "Device": "GR1000BF4",
    "Model": "GR1000BF4"
  },
  {
    "Retail Branding": "VIEWEDGE",
    "Marketing Name": "V11",
    "Device": "V11",
    "Model": "Viewedge Tab 11"
  },
  {
    "Retail Branding": "VIEWEDGE",
    "Marketing Name": "V11_EEA",
    "Device": "V11",
    "Model": "Viewedge Tab 11"
  },
  {
    "Retail Branding": "VIISAN",
    "Marketing Name": "FB-K6",
    "Device": "FB-K6",
    "Model": "FB-K6"
  },
  {
    "Retail Branding": "VIKUSHA",
    "Marketing Name": "V-E5",
    "Device": "V-E5",
    "Model": "V-E5"
  },
  {
    "Retail Branding": "VIKUSHA",
    "Marketing Name": "V-N5",
    "Device": "V-N5",
    "Model": "V-N5"
  },
  {
    "Retail Branding": "VIKUSHA",
    "Marketing Name": "V-Z40",
    "Device": "V-Z40",
    "Model": "V-Z40"
  },
  {
    "Retail Branding": "VIKUSHA",
    "Marketing Name": "V-Z40Pro",
    "Device": "V-Z40Pro",
    "Model": "V-Z40Pro"
  },
  {
    "Retail Branding": "VIKUSHA",
    "Marketing Name": "V-Z70",
    "Device": "V-Z70",
    "Model": "V-Z70"
  },
  {
    "Retail Branding": "VIKUSHA",
    "Marketing Name": "V-Z70",
    "Device": "V-Z70",
    "Model": "V-Z70Plus"
  },
  {
    "Retail Branding": "VIKUSHA",
    "Marketing Name": "V-Z80Plus",
    "Device": "V-Z80Plus",
    "Model": "V-Z80Plus"
  },
  {
    "Retail Branding": "VIKUSHA",
    "Marketing Name": "VZ-30",
    "Device": "VZ-30",
    "Model": "VZ-30"
  },
  {
    "Retail Branding": "VIKUSHA",
    "Marketing Name": "VZ-30Pro",
    "Device": "VZ-30Pro",
    "Model": "P32 Pro"
  },
  {
    "Retail Branding": "VIKUSHA",
    "Marketing Name": "VZ-30Pro",
    "Device": "VZ-30Pro",
    "Model": "VZ-30"
  },
  {
    "Retail Branding": "VIKUSHA",
    "Marketing Name": "VZ-30Pro",
    "Device": "VZ-30Pro",
    "Model": "VZ-30Pro"
  },
  {
    "Retail Branding": "VIKUSHA",
    "Marketing Name": "V_M1",
    "Device": "V_M1",
    "Model": "Pad12pro"
  },
  {
    "Retail Branding": "VIKUSHA",
    "Marketing Name": "V_M1",
    "Device": "V_M1",
    "Model": "V_M1"
  },
  {
    "Retail Branding": "VILLAON",
    "Marketing Name": "A06s",
    "Device": "VILLAON-V652L",
    "Model": "VILLAON V652L"
  },
  {
    "Retail Branding": "VILLAON",
    "Marketing Name": "A200S",
    "Device": "VILLAON-V6752L",
    "Model": "VILLAON V6752L"
  },
  {
    "Retail Branding": "VILLAON",
    "Marketing Name": "AC52",
    "Device": "VILLAON-V501L",
    "Model": "VILLAON V501L"
  },
  {
    "Retail Branding": "VILLAON",
    "Marketing Name": "AC65",
    "Device": "VILLAON-V652L",
    "Model": "VILLAON V652L"
  },
  {
    "Retail Branding": "VILLAON",
    "Marketing Name": "Telkom TS pro",
    "Device": "VILLAON-V40s",
    "Model": "VILLAON V651L"
  },
  {
    "Retail Branding": "VILLAON",
    "Marketing Name": "V-Pad1",
    "Device": "VP10001L",
    "Model": "VP10001L"
  },
  {
    "Retail Branding": "VILLAON",
    "Marketing Name": "V-Pad1",
    "Device": "VP10001L",
    "Model": "VP1001L_Liv"
  },
  {
    "Retail Branding": "VILLAON",
    "Marketing Name": "V20",
    "Device": "V20",
    "Model": "V20"
  },
  {
    "Retail Branding": "VILLAON",
    "Marketing Name": "V20 SE",
    "Device": "VILLAON_V20_SE",
    "Model": "VILLAON V501W"
  },
  {
    "Retail Branding": "VILLAON",
    "Marketing Name": "V20_SE",
    "Device": "VILLAON_V20_SE",
    "Model": "VILLAON V501W"
  },
  {
    "Retail Branding": "VILLAON",
    "Marketing Name": "V30 RS",
    "Device": "VILLAON-V30-RS",
    "Model": "VILLAON V6751L"
  },
  {
    "Retail Branding": "VILLAON",
    "Marketing Name": "V40",
    "Device": "VILLAON-V40",
    "Model": "VILLAON V651W"
  },
  {
    "Retail Branding": "VILLAON",
    "Marketing Name": "V40s",
    "Device": "VILLAON-V40s",
    "Model": "VILLAON V651L"
  },
  {
    "Retail Branding": "VILLAON",
    "Marketing Name": "V50s",
    "Device": "VILLAON-V653L",
    "Model": "VILLAON V653L"
  },
  {
    "Retail Branding": "VILLAON",
    "Marketing Name": "V50s",
    "Device": "VILLAON-V654L",
    "Model": "VILLAON V654L"
  },
  {
    "Retail Branding": "VILLAON",
    "Marketing Name": "VILLAON Hyper 100",
    "Device": "VILLAON-V6752L",
    "Model": "VILLAON V6752L"
  },
  {
    "Retail Branding": "VILLAON",
    "Marketing Name": "VILLAON V30",
    "Device": "V30",
    "Model": "VILLAON V30"
  },
  {
    "Retail Branding": "VILLAON",
    "Marketing Name": "VILLAON V30",
    "Device": "VILLAON-V30",
    "Model": "VILLAON V30"
  },
  {
    "Retail Branding": "VILLAON",
    "Marketing Name": "VILLAON V45s",
    "Device": "VILLAON-V652L",
    "Model": "VILLAON V652L"
  },
  {
    "Retail Branding": "VILLAON",
    "Marketing Name": "Vibe 50",
    "Device": "VILLAON-V653L",
    "Model": "VILLAON V653L"
  },
  {
    "Retail Branding": "VILLAON",
    "Marketing Name": "Vodacom A06s",
    "Device": "VILLAON-V652L",
    "Model": "VILLAON V652L"
  },
  {
    "Retail Branding": "VILLAON",
    "Marketing Name": "Vodacom V54",
    "Device": "VILLAON-V501L",
    "Model": "VILLAON V501L"
  },
  {
    "Retail Branding": "VILLAON",
    "Marketing Name": "Vodacom Vibe 20",
    "Device": "VILLAON-V652L",
    "Model": "VILLAON V652L"
  },
  {
    "Retail Branding": "VILLAON",
    "Marketing Name": "Yas Y50",
    "Device": "VILLAON-V501L",
    "Model": "VILLAON V501L"
  },
  {
    "Retail Branding": "VILLAON",
    "Marketing Name": "Yas Y60",
    "Device": "VILLAON-V652L",
    "Model": "VILLAON V652L"
  },
  {
    "Retail Branding": "VILLAON",
    "Marketing Name": "vibe-10",
    "Device": "VILLAON-V501L",
    "Model": "VILLAON V501L"
  },
  {
    "Retail Branding": "VIMOQ",
    "Marketing Name": "A18",
    "Device": "VIMOQ-A512WS",
    "Model": "VIMOQ A512WS"
  },
  {
    "Retail Branding": "VIMOQ",
    "Marketing Name": "A662LS",
    "Device": "VIMOQ-A662LS",
    "Model": "VIMOQ A662LS"
  },
  {
    "Retail Branding": "VIMOQ",
    "Marketing Name": "SE668S",
    "Device": "VIMOQ-P662LO",
    "Model": "VIMOQ P662LO"
  },
  {
    "Retail Branding": "VIMOQ",
    "Marketing Name": "VIMOQ  AC50",
    "Device": "VIMOQ-A507LD",
    "Model": "VIMOQ A507LD"
  },
  {
    "Retail Branding": "VIMOQ",
    "Marketing Name": "VIMOQ A20 Core",
    "Device": "VIMOQ-A632WS",
    "Model": "VIMOQ A632WS"
  },
  {
    "Retail Branding": "VIMOQ",
    "Marketing Name": "VIMOQ A40",
    "Device": "Nola-ultra",
    "Model": "Orange Nola ultra"
  },
  {
    "Retail Branding": "VIMOQ",
    "Marketing Name": "VIMOQ A40",
    "Device": "VIMOQ-A662LMO",
    "Model": "VIMOQ A662LMO"
  },
  {
    "Retail Branding": "VIMOQ",
    "Marketing Name": "VIMOQ A40",
    "Device": "VIMOQ-A662LMS",
    "Model": "VIMOQ A662LMS"
  },
  {
    "Retail Branding": "VIMOQ",
    "Marketing Name": "VIMOQ A40",
    "Device": "VIMOQ-A662LO",
    "Model": "VIMOQ A662LO"
  },
  {
    "Retail Branding": "VIMOQ",
    "Marketing Name": "VIMOQ A40",
    "Device": "VIMOQ-A662LS",
    "Model": "VIMOQ A662LS"
  },
  {
    "Retail Branding": "VIMOQ",
    "Marketing Name": "VIMOQ A49 Play",
    "Device": "VIMOQ-A631LO",
    "Model": "VIMOQ A631LO"
  },
  {
    "Retail Branding": "VIMOQ",
    "Marketing Name": "VIMOQ A49 Play",
    "Device": "VIMOQ-A631LS",
    "Model": "VIMOQ A631LS"
  },
  {
    "Retail Branding": "VIMOQ",
    "Marketing Name": "VIMOQ A507LT",
    "Device": "VIMOQ-A507LT",
    "Model": "VIMOQ A507LT"
  },
  {
    "Retail Branding": "VIMOQ",
    "Marketing Name": "VIMOQ V51 LTE",
    "Device": "VIMOQ-A507LE",
    "Model": "VIMOQ A507LE"
  },
  {
    "Retail Branding": "VIMOQ",
    "Marketing Name": "VIMOQ Vision 3",
    "Device": "VIMOQ-S661LS",
    "Model": "VIMOQ S661LS"
  },
  {
    "Retail Branding": "VIMOQ",
    "Marketing Name": "VIMOQ-A661WS",
    "Device": "VIMOQ-A661WS",
    "Model": "VIMOQ A661WS"
  },
  {
    "Retail Branding": "VIMOQ",
    "Marketing Name": "itel A18",
    "Device": "VIMOQ-A512WS",
    "Model": "VIMOQ A512WS"
  },
  {
    "Retail Branding": "VIOMI",
    "Marketing Name": "Smart TV",
    "Device": "longshan",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "VIOS",
    "Marketing Name": "65PB1",
    "Device": "65PB1",
    "Model": "VI65PB1401NA"
  },
  {
    "Retail Branding": "VIOS",
    "Marketing Name": "65PB1_2",
    "Device": "65PB1",
    "Model": "VI65PB1401NA"
  },
  {
    "Retail Branding": "VIOS",
    "Marketing Name": "C9",
    "Device": "C9",
    "Model": "C9"
  },
  {
    "Retail Branding": "VIOS",
    "Marketing Name": "VIOS_series",
    "Device": "VI65PA1402NA",
    "Model": "65PA1"
  },
  {
    "Retail Branding": "VIOS",
    "Marketing Name": "VTAB7",
    "Device": "VTAB7",
    "Model": "VTAB7"
  },
  {
    "Retail Branding": "VIOS",
    "Marketing Name": "VTABX",
    "Device": "VTABX",
    "Model": "VTABX"
  },
  {
    "Retail Branding": "VIPER",
    "Marketing Name": "SZ11MK1",
    "Device": "SZ11MK1",
    "Model": "SZ11MK1"
  },
  {
    "Retail Branding": "VIPER",
    "Marketing Name": "VIPER-Z08MK",
    "Device": "VIPER-Z08MK",
    "Model": "Z08MK"
  },
  {
    "Retail Branding": "VIPER",
    "Marketing Name": "Z11MK",
    "Device": "Z11MK",
    "Model": "Z11MK"
  },
  {
    "Retail Branding": "VIRSA",
    "Marketing Name": "Interactive_Flat_Panel",
    "Device": "VIRSAE25",
    "Model": "VIRSAE25"
  },
  {
    "Retail Branding": "VISIO",
    "Marketing Name": "VISIO 4K Android TV",
    "Device": "SW4H",
    "Model": "VISIO 4K Android TV"
  },
  {
    "Retail Branding": "VISIO",
    "Marketing Name": "VISIO TV",
    "Device": "shinagawa",
    "Model": "VISIO TV"
  },
  {
    "Retail Branding": "VISIONTEK",
    "Marketing Name": "VT_31",
    "Device": "VT_31",
    "Model": "VT 31"
  },
  {
    "Retail Branding": "VIVIMAGE",
    "Marketing Name": "E8",
    "Device": "E8",
    "Model": "E8"
  },
  {
    "Retail Branding": "VIVIMAGE",
    "Marketing Name": "VIVIMAGE_A10",
    "Device": "VIVIMAGE_A10",
    "Model": "VIVIMAGE_A10"
  },
  {
    "Retail Branding": "VIVIMAGE",
    "Marketing Name": "VIVIMAGE_A10_EEA",
    "Device": "VIVIMAGE_A10_EEA",
    "Model": "VIVIMAGE_A10_EEA"
  },
  {
    "Retail Branding": "VIVIMAGE",
    "Marketing Name": "VIVIMAGE_E10",
    "Device": "E10",
    "Model": "E10"
  },
  {
    "Retail Branding": "VIVIMAGE",
    "Marketing Name": "VIVIMAGE_E10_EEA",
    "Device": "E10",
    "Model": "E10_EEA"
  },
  {
    "Retail Branding": "VIVIMAGE",
    "Marketing Name": "VIVIMAGE_E11",
    "Device": "E11",
    "Model": "VIVIMAGE_E11"
  },
  {
    "Retail Branding": "VIVITEK",
    "Marketing Name": "BK3_TH3_series",
    "Device": "rk3576_u",
    "Model": "BK3_TH3_series"
  },
  {
    "Retail Branding": "VIVITEK",
    "Marketing Name": "EK5_series",
    "Device": "rk3576_u",
    "Model": "EK5_series"
  },
  {
    "Retail Branding": "VIVITEK",
    "Marketing Name": "NovoTouch",
    "Device": "rk3588_t",
    "Model": "EK4"
  },
  {
    "Retail Branding": "VIVIVIEW",
    "Marketing Name": "V10",
    "Device": "V10",
    "Model": "V10"
  },
  {
    "Retail Branding": "VIVIVIEW",
    "Marketing Name": "V5Pro",
    "Device": "V5Pro",
    "Model": "V5Pro"
  },
  {
    "Retail Branding": "VIVIVIEW",
    "Marketing Name": "V8",
    "Device": "V8",
    "Model": "V8"
  },
  {
    "Retail Branding": "VIZZION",
    "Marketing Name": "VIZZION",
    "Device": "elliniko",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "VIZZION",
    "Marketing Name": "VIZZION",
    "Device": "stanford",
    "Model": "F VIZZION TV"
  },
  {
    "Retail Branding": "VIZZION",
    "Marketing Name": "VIZZION 4K TV",
    "Device": "SW4H",
    "Model": "VIZZION 4K TV"
  },
  {
    "Retail Branding": "VIZZION",
    "Marketing Name": "VIZZION Smart TV",
    "Device": "sunnyvale",
    "Model": "VIZZION Smart TV"
  },
  {
    "Retail Branding": "VIZZION",
    "Marketing Name": "VIZZION TV",
    "Device": "shinjuku",
    "Model": "VIZZION TV"
  },
  {
    "Retail Branding": "VIZZION",
    "Marketing Name": "vizzion",
    "Device": "zhongshan",
    "Model": "F VIZZION TV"
  },
  {
    "Retail Branding": "VK DIGITAL",
    "Marketing Name": "VKONBOX",
    "Device": "SEI740VK",
    "Model": "VKONEBOX"
  },
  {
    "Retail Branding": "VL Wireless Inc",
    "Marketing Name": "VL10",
    "Device": "VL10",
    "Model": "VL10"
  },
  {
    "Retail Branding": "VL Wireless Inc",
    "Marketing Name": "VL68",
    "Device": "VL68",
    "Model": "VL68"
  },
  {
    "Retail Branding": "VL Wireless Inc",
    "Marketing Name": "VL68_Lite",
    "Device": "VL68_Lite",
    "Model": "VL68"
  },
  {
    "Retail Branding": "VL Wireless Inc",
    "Marketing Name": "VL68_Lite",
    "Device": "VL68_Lite",
    "Model": "VL68 Lite"
  },
  {
    "Retail Branding": "VL Wireless Inc",
    "Marketing Name": "VL68_Lite",
    "Device": "VL68_Lite",
    "Model": "VL68_Lite"
  },
  {
    "Retail Branding": "VL Wireless Inc",
    "Marketing Name": "VL68_Pro",
    "Device": "VL68_Pro",
    "Model": "VL68 Pro"
  },
  {
    "Retail Branding": "VNPT Technology",
    "Marketing Name": "VNPT SmartBox",
    "Device": "vnptt_smb_3",
    "Model": "VNPT SmartBox 3"
  },
  {
    "Retail Branding": "VNPT Technology",
    "Marketing Name": "VNPT SmartBox 2x",
    "Device": "vnptt_smb_v2x",
    "Model": "VNPT SmartBox 2x"
  },
  {
    "Retail Branding": "VNPT Technology",
    "Marketing Name": "VNPTTechnology",
    "Device": "VNTTab2",
    "Model": "VNTTab2"
  },
  {
    "Retail Branding": "VNPT Technology",
    "Marketing Name": "VNT_Tab8",
    "Device": "VNT_Tab8",
    "Model": "VNT_Tab8"
  },
  {
    "Retail Branding": "VOD_Horizon",
    "Marketing Name": "Pro Max",
    "Device": "Pro_Max",
    "Model": "Pro Max"
  },
  {
    "Retail Branding": "VOD_Horizon",
    "Marketing Name": "Web 3 Pro 8",
    "Device": "5G_Smart_Phone",
    "Model": "Pro 8"
  },
  {
    "Retail Branding": "VOLENTEX",
    "Marketing Name": "M10",
    "Device": "M10_A04",
    "Model": "Volentex_101"
  },
  {
    "Retail Branding": "VOLENTEX",
    "Marketing Name": "M10_A04_EEA",
    "Device": "M10_A04_EEA",
    "Model": "Volentex_101"
  },
  {
    "Retail Branding": "VOLENTEX",
    "Marketing Name": "T10",
    "Device": "T10",
    "Model": "T10"
  },
  {
    "Retail Branding": "VOLENTEX",
    "Marketing Name": "T8",
    "Device": "T8",
    "Model": "T8"
  },
  {
    "Retail Branding": "VOLFEN",
    "Marketing Name": "NEXO TAB 10A",
    "Device": "NEXO_TAB_10A",
    "Model": "NEXO TAB 10A"
  },
  {
    "Retail Branding": "VOLFEN",
    "Marketing Name": "NEXO-TAB-70",
    "Device": "NEXO-TAB-70",
    "Model": "NEXO TAB 70"
  },
  {
    "Retail Branding": "VOLFEN",
    "Marketing Name": "NEXO_TAB_10",
    "Device": "NEXO_TAB_10",
    "Model": "NEXO_TAB_10"
  },
  {
    "Retail Branding": "VOLFEN",
    "Marketing Name": "Nexo TAB 7",
    "Device": "Nexo-TAB-7",
    "Model": "Nexo-TAB-7"
  },
  {
    "Retail Branding": "VOLIA",
    "Marketing Name": "VOL001",
    "Device": "VOL001",
    "Model": "VOL001"
  },
  {
    "Retail Branding": "VOPLLS",
    "Marketing Name": "G3",
    "Device": "himalaya",
    "Model": "G3"
  },
  {
    "Retail Branding": "VOPLLS",
    "Marketing Name": "G7",
    "Device": "himalaya",
    "Model": "G7"
  },
  {
    "Retail Branding": "VORCOM",
    "Marketing Name": "AVALON",
    "Device": "AVALON",
    "Model": "AVALON"
  },
  {
    "Retail Branding": "VORCOM",
    "Marketing Name": "QuartzLITE",
    "Device": "QuartzLITE",
    "Model": "QuartzLITE"
  },
  {
    "Retail Branding": "VORCOM",
    "Marketing Name": "QuartzPRO",
    "Device": "QuartzPRO",
    "Model": "QuartzPRO"
  },
  {
    "Retail Branding": "VORCOM",
    "Marketing Name": "S12_classic",
    "Device": "S12_classic",
    "Model": "S12_classic"
  },
  {
    "Retail Branding": "VORCOM",
    "Marketing Name": "S7-classic",
    "Device": "S7-classic",
    "Model": "S7-classic"
  },
  {
    "Retail Branding": "VORCOM",
    "Marketing Name": "S7-classic-10",
    "Device": "S7-classic-10",
    "Model": "S7-classic"
  },
  {
    "Retail Branding": "VORCOM",
    "Marketing Name": "S7Pro",
    "Device": "S7Pro",
    "Model": "S7Pro"
  },
  {
    "Retail Branding": "VORCOM",
    "Marketing Name": "S8-CLASSIC",
    "Device": "S8-CLASSIC",
    "Model": "S8-CLASSIC"
  },
  {
    "Retail Branding": "VORCOM",
    "Marketing Name": "S8Pro",
    "Device": "S8Pro",
    "Model": "S8Pro"
  },
  {
    "Retail Branding": "VORCOM",
    "Marketing Name": "SXPRO",
    "Device": "SXPRO",
    "Model": "SXPRO"
  },
  {
    "Retail Branding": "VORCOM",
    "Marketing Name": "SXPRO_classic",
    "Device": "SXPRO_classic",
    "Model": "SXPRO_classic"
  },
  {
    "Retail Branding": "VORCOM",
    "Marketing Name": "SXPro-P40",
    "Device": "SXPro-P40",
    "Model": "SXPro-P40"
  },
  {
    "Retail Branding": "VORCOM",
    "Marketing Name": "ULTRAPAD",
    "Device": "ULTRAPAD",
    "Model": "ULTRAPAD"
  },
  {
    "Retail Branding": "VOXelectronics",
    "Marketing Name": "VOXELECTRONICS",
    "Device": "jagalchi",
    "Model": "2K SMART TV"
  },
  {
    "Retail Branding": "VOXelectronics",
    "Marketing Name": "VOXELECTRONICS",
    "Device": "lavender",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "VOXelectronics",
    "Marketing Name": "VOXelectronics 2K Android TV",
    "Device": "lasalle",
    "Model": "Pseries 2K Android TV"
  },
  {
    "Retail Branding": "VOXelectronics",
    "Marketing Name": "VOXelectronics 2K Android TV",
    "Device": "lasalle",
    "Model": "VOXelectronics 2K Android TV"
  },
  {
    "Retail Branding": "VOXelectronics",
    "Marketing Name": "VOXelectronics 4K Android TV",
    "Device": "kenton",
    "Model": "VOXelectronics 4K Android TV"
  },
  {
    "Retail Branding": "VS Visu",
    "Marketing Name": "VS-DUAL-86",
    "Device": "t7_an400",
    "Model": "VS-DUAL-86"
  },
  {
    "Retail Branding": "VS Visu",
    "Marketing Name": "VS_S_P4",
    "Device": "oversea_v",
    "Model": "VS_S_P4"
  },
  {
    "Retail Branding": "VSN",
    "Marketing Name": "V.35",
    "Device": "up11_h1_vsn",
    "Model": "V.35"
  },
  {
    "Retail Branding": "VSP(VN)",
    "Marketing Name": "VSP AndroidTV",
    "Device": "barking",
    "Model": "VSP AndroidTV"
  },
  {
    "Retail Branding": "VSP(VN)",
    "Marketing Name": "VSP AndroidTV",
    "Device": "beaudry",
    "Model": "VSP AndroidTV"
  },
  {
    "Retail Branding": "VSP(VN)",
    "Marketing Name": "VSP Google TV",
    "Device": "alken",
    "Model": "VSP Google TV"
  },
  {
    "Retail Branding": "VSP(VN)",
    "Marketing Name": "VSP Google TV",
    "Device": "surface",
    "Model": "VSP Google TV"
  },
  {
    "Retail Branding": "VSP(VN)",
    "Marketing Name": "VSP Google TV P",
    "Device": "surface",
    "Model": "VSP Google TV P"
  },
  {
    "Retail Branding": "VT",
    "Marketing Name": "MB300",
    "Device": "MB300",
    "Model": "SmartTV"
  },
  {
    "Retail Branding": "VTCNOWRINDO",
    "Marketing Name": "VR-42AF6800",
    "Device": "ikebukuro",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "VTEX",
    "Marketing Name": "MT8768",
    "Device": "MT8768",
    "Model": "MT8768"
  },
  {
    "Retail Branding": "VTEX",
    "Marketing Name": "VK-A116",
    "Device": "VK-A116",
    "Model": "VK-A116"
  },
  {
    "Retail Branding": "VTEX",
    "Marketing Name": "VK102W",
    "Device": "VK102W",
    "Model": "VK102W"
  },
  {
    "Retail Branding": "VTEX",
    "Marketing Name": "VK802W",
    "Device": "VK802W",
    "Model": "VK802W"
  },
  {
    "Retail Branding": "VUCATIMES",
    "Marketing Name": "HAOQIN",
    "Device": "E10",
    "Model": "E10"
  },
  {
    "Retail Branding": "VUCATIMES",
    "Marketing Name": "N10",
    "Device": "N10",
    "Model": "N10"
  },
  {
    "Retail Branding": "VUCATIMES",
    "Marketing Name": "N10_EEA",
    "Device": "N10",
    "Model": "N10"
  },
  {
    "Retail Branding": "VUCATIMES",
    "Marketing Name": "N7",
    "Device": "N7",
    "Model": "N7"
  },
  {
    "Retail Branding": "VUCATIMES",
    "Marketing Name": "N8",
    "Device": "N8",
    "Model": "N8"
  },
  {
    "Retail Branding": "VUCATIMES",
    "Marketing Name": "N8_EEA",
    "Device": "N8_EEA",
    "Model": "N8_EEA"
  },
  {
    "Retail Branding": "VUCATIMES",
    "Marketing Name": "VUCATIMES",
    "Device": "N7",
    "Model": "N7"
  },
  {
    "Retail Branding": "VUCATIMES",
    "Marketing Name": "VucaPad_N20",
    "Device": "VucaPad_N20",
    "Model": "VucaPad_N20"
  },
  {
    "Retail Branding": "VUCATIMES",
    "Marketing Name": "VucaPad_N20PRO",
    "Device": "VucaPad_N20PRO",
    "Model": "VucaPad_N20PRO"
  },
  {
    "Retail Branding": "VUCATIMES",
    "Marketing Name": "VucaPad_N20_LTE",
    "Device": "VucaPad_N20_LTE",
    "Model": "VucaPad_N20_LTE"
  },
  {
    "Retail Branding": "VUCATIMES",
    "Marketing Name": "VucaPad_NS20",
    "Device": "VucaPad_NS20",
    "Model": "VucaPad_NS20"
  },
  {
    "Retail Branding": "VUCATIMES",
    "Marketing Name": "VucaPad_NS20_EEA",
    "Device": "VucaPad_NS20_EEA",
    "Model": "VucaPad_NS20_EEA"
  },
  {
    "Retail Branding": "VUCATIMES",
    "Marketing Name": "Vucatimes",
    "Device": "VucaPad_N20_LTE_JP",
    "Model": "VucaPad_N20_LTE_JP"
  },
  {
    "Retail Branding": "Valo Innovations",
    "Marketing Name": "TAB0001NG",
    "Device": "TAB0001NG",
    "Model": "TAB0001NG"
  },
  {
    "Retail Branding": "Vankyo",
    "Marketing Name": "MatrixPad-X36",
    "Device": "MatrixPad-X36",
    "Model": "MatrixPad-X36"
  },
  {
    "Retail Branding": "Vankyo",
    "Marketing Name": "P10",
    "Device": "P10",
    "Model": "P10"
  },
  {
    "Retail Branding": "Vankyo",
    "Marketing Name": "P10_EEA",
    "Device": "P10_EEA",
    "Model": "P10_EEA"
  },
  {
    "Retail Branding": "Vankyo",
    "Marketing Name": "P31",
    "Device": "P31",
    "Model": "P31"
  },
  {
    "Retail Branding": "Vankyo",
    "Marketing Name": "P31-E",
    "Device": "P31-E_EEA",
    "Model": "P31-E"
  },
  {
    "Retail Branding": "Vankyo",
    "Marketing Name": "P40",
    "Device": "P40",
    "Model": "P40"
  },
  {
    "Retail Branding": "Vankyo",
    "Marketing Name": "QTAB1010X",
    "Device": "QTAB1010X_EEA",
    "Model": "QTAB1010X"
  },
  {
    "Retail Branding": "Vankyo",
    "Marketing Name": "S10",
    "Device": "S10",
    "Model": "S10"
  },
  {
    "Retail Branding": "Vankyo",
    "Marketing Name": "S10_EEA",
    "Device": "S10_EEA",
    "Model": "S10_EEA"
  },
  {
    "Retail Branding": "Vankyo",
    "Marketing Name": "S10_ROW",
    "Device": "S10_ROW",
    "Model": "S10_ROW"
  },
  {
    "Retail Branding": "Vankyo",
    "Marketing Name": "S20",
    "Device": "S20",
    "Model": "S20"
  },
  {
    "Retail Branding": "Vankyo",
    "Marketing Name": "S20_2020",
    "Device": "S20_2020",
    "Model": "S20_2020"
  },
  {
    "Retail Branding": "Vankyo",
    "Marketing Name": "S20_EEA",
    "Device": "S20_EEA",
    "Model": "S20_EEA"
  },
  {
    "Retail Branding": "Vankyo",
    "Marketing Name": "S20_EEA",
    "Device": "S20_EEA_2020",
    "Model": "S20_EEA"
  },
  {
    "Retail Branding": "Vankyo",
    "Marketing Name": "S21",
    "Device": "S21",
    "Model": "S21"
  },
  {
    "Retail Branding": "Vankyo",
    "Marketing Name": "S21_EEA",
    "Device": "S21_EEA",
    "Model": "S21_EEA"
  },
  {
    "Retail Branding": "Vankyo",
    "Marketing Name": "S21_Plus",
    "Device": "S21_Plus",
    "Model": "S21_Plus"
  },
  {
    "Retail Branding": "Vankyo",
    "Marketing Name": "S30",
    "Device": "S30",
    "Model": "S30"
  },
  {
    "Retail Branding": "Vankyo",
    "Marketing Name": "S30",
    "Device": "S30_2020",
    "Model": "S30"
  },
  {
    "Retail Branding": "Vankyo",
    "Marketing Name": "S30_EEA",
    "Device": "S30_EEA",
    "Model": "S30_EEA"
  },
  {
    "Retail Branding": "Vankyo",
    "Marketing Name": "S30_EEA",
    "Device": "S30_EEA_2020",
    "Model": "S30_EEA"
  },
  {
    "Retail Branding": "Vankyo",
    "Marketing Name": "S7",
    "Device": "S7",
    "Model": "S7"
  },
  {
    "Retail Branding": "Vankyo",
    "Marketing Name": "S7_EEA",
    "Device": "S7_EEA",
    "Model": "S7_EEA"
  },
  {
    "Retail Branding": "Vankyo",
    "Marketing Name": "S8_EEA",
    "Device": "S8_EEA",
    "Model": "S8_EEA"
  },
  {
    "Retail Branding": "Vankyo",
    "Marketing Name": "S9",
    "Device": "S9",
    "Model": "S9"
  },
  {
    "Retail Branding": "Vankyo",
    "Marketing Name": "S9_EEA",
    "Device": "S9_EEA",
    "Model": "S9_EEA"
  },
  {
    "Retail Branding": "Vankyo",
    "Marketing Name": "V700",
    "Device": "himalaya",
    "Model": "V700"
  },
  {
    "Retail Branding": "Vankyo",
    "Marketing Name": "V702P",
    "Device": "himalaya",
    "Model": "V702P"
  },
  {
    "Retail Branding": "Vankyo",
    "Marketing Name": "VANKYO_S7",
    "Device": "VANKYO_S7",
    "Model": "VANKYO_S7"
  },
  {
    "Retail Branding": "Vankyo",
    "Marketing Name": "VANKYO_S7_EEA",
    "Device": "VANKYO_S7_EEA",
    "Model": "VANKYO_S7_EEA"
  },
  {
    "Retail Branding": "Vankyo",
    "Marketing Name": "VANKYO_S8",
    "Device": "VANKYO_S8",
    "Model": "VANKYO_S8"
  },
  {
    "Retail Branding": "Vankyo",
    "Marketing Name": "VANKYO_S8_EEA",
    "Device": "VANKYO_S8_EEA",
    "Model": "VANKYO_S8_EEA"
  },
  {
    "Retail Branding": "Vankyo",
    "Marketing Name": "Vankyo_S10",
    "Device": "Vankyo_S10",
    "Model": "Vankyo_S10"
  },
  {
    "Retail Branding": "Vankyo",
    "Marketing Name": "Vankyo_S10_EEA",
    "Device": "Vankyo_S10_EEA",
    "Model": "Vankyo_S10_EEA"
  },
  {
    "Retail Branding": "Vankyo",
    "Marketing Name": "X10",
    "Device": "X10",
    "Model": "X10"
  },
  {
    "Retail Branding": "Vankyo",
    "Marketing Name": "Z1",
    "Device": "Z1",
    "Model": "Z1"
  },
  {
    "Retail Branding": "Vankyo",
    "Marketing Name": "Z10",
    "Device": "Z10",
    "Model": "Z10"
  },
  {
    "Retail Branding": "Vankyo",
    "Marketing Name": "Z12",
    "Device": "Z1",
    "Model": "Z1"
  },
  {
    "Retail Branding": "Vankyo",
    "Marketing Name": "Z1_EEA",
    "Device": "Z1_EEA",
    "Model": "Z1_EEA"
  },
  {
    "Retail Branding": "Vankyo",
    "Marketing Name": "Z4",
    "Device": "Z4",
    "Model": "Z4"
  },
  {
    "Retail Branding": "Vankyo",
    "Marketing Name": "Z4_EEA",
    "Device": "Z4_EEA",
    "Model": "Z4_EEA"
  },
  {
    "Retail Branding": "Vankyo",
    "Marketing Name": "s8",
    "Device": "S8",
    "Model": "S8"
  },
  {
    "Retail Branding": "Vantiva",
    "Marketing Name": "Agile TV",
    "Device": "dwt765mm",
    "Model": "AgileTV"
  },
  {
    "Retail Branding": "Vantiva",
    "Marketing Name": "Agile TV",
    "Device": "uzw4060mm",
    "Model": "AgileTV"
  },
  {
    "Retail Branding": "Vantiva",
    "Marketing Name": "CogecoTV",
    "Device": "uiw4020cog",
    "Model": "TV"
  },
  {
    "Retail Branding": "Vantron",
    "Marketing Name": "HMI04-RK3326S",
    "Device": "HMI04_RK3326S",
    "Model": "HMI04_RK3326S"
  },
  {
    "Retail Branding": "Vantron",
    "Marketing Name": "IBOX66",
    "Device": "IBOX66",
    "Model": "IBOX66"
  },
  {
    "Retail Branding": "Vantron",
    "Marketing Name": "M10 Pro",
    "Device": "M10Pro",
    "Model": "M10Pro"
  },
  {
    "Retail Branding": "Vantron",
    "Marketing Name": "M10_Pro",
    "Device": "M10Pro",
    "Model": "M10Pro"
  },
  {
    "Retail Branding": "Vastking",
    "Marketing Name": "H20",
    "Device": "H20",
    "Model": "H20"
  },
  {
    "Retail Branding": "Vastking",
    "Marketing Name": "KindPad_SA8_EEA",
    "Device": "KindPad_SA8_EEA",
    "Model": "KindPad_SA8_EEA"
  },
  {
    "Retail Branding": "Vastking",
    "Marketing Name": "KindPad_SA8_EEA",
    "Device": "KindPad_SA8_EEA",
    "Model": "KingPad_SA8_EEA"
  },
  {
    "Retail Branding": "Vastking",
    "Marketing Name": "KingPad_K10",
    "Device": "KingPad_K10",
    "Model": "KingPad_K10"
  },
  {
    "Retail Branding": "Vastking",
    "Marketing Name": "KingPad_K10Pro",
    "Device": "KingPad_K10Pro",
    "Model": "KingPad_K10Pro"
  },
  {
    "Retail Branding": "Vastking",
    "Marketing Name": "KingPad_K10Pro_EEA",
    "Device": "KingPad_K10Pro_EEA",
    "Model": "KingPad_K10Pro_EEA"
  },
  {
    "Retail Branding": "Vastking",
    "Marketing Name": "KingPad_K10_EEA",
    "Device": "KingPad_K10_EEA",
    "Model": "KingPad_K10_EEA"
  },
  {
    "Retail Branding": "Vastking",
    "Marketing Name": "KingPad_M10",
    "Device": "KingPad_M10",
    "Model": "KingPad_M10"
  },
  {
    "Retail Branding": "Vastking",
    "Marketing Name": "KingPad_M10_EEA",
    "Device": "KingPad_M10_EEA",
    "Model": "KingPad_M10_EEA"
  },
  {
    "Retail Branding": "Vastking",
    "Marketing Name": "KingPad_SA10",
    "Device": "KingPad_SA10",
    "Model": "KingPad_SA10"
  },
  {
    "Retail Branding": "Vastking",
    "Marketing Name": "KingPad_SA10_EEA",
    "Device": "KingPad_SA10_EEA",
    "Model": "KingPad_SA10_EEA"
  },
  {
    "Retail Branding": "Vastking",
    "Marketing Name": "KingPad_SA8",
    "Device": "KingPad_SA8",
    "Model": "KingPad_SA8"
  },
  {
    "Retail Branding": "Vastking",
    "Marketing Name": "KingPad_Z10",
    "Device": "KingPad_Z10",
    "Model": "KingPad_Z10"
  },
  {
    "Retail Branding": "Vastking",
    "Marketing Name": "KingPad_Z10Mini",
    "Device": "KingPad_Z10Mini",
    "Model": "KingPad_Z10Mini"
  },
  {
    "Retail Branding": "Vastking",
    "Marketing Name": "KingPad_Z10Mini_EEA",
    "Device": "KingPad_Z10Mini_EEA",
    "Model": "KingPad_Z10Mini"
  },
  {
    "Retail Branding": "Vastking",
    "Marketing Name": "KingPad_Z10S",
    "Device": "KingPad_Z10S",
    "Model": "KingPad_Z10S"
  },
  {
    "Retail Branding": "Vastking",
    "Marketing Name": "KingPad_Z10S_EEA",
    "Device": "KingPad_Z10S_EEA",
    "Model": "KingPad_Z10S_EEA"
  },
  {
    "Retail Branding": "Vastking",
    "Marketing Name": "KingPad_Z10_EEA",
    "Device": "KingPad_Z10_EEA",
    "Model": "KingPad_Z10_EEA"
  },
  {
    "Retail Branding": "Vastking",
    "Marketing Name": "VZ-1",
    "Device": "VZ-1",
    "Model": "VZ-1"
  },
  {
    "Retail Branding": "Vava",
    "Marketing Name": "V1",
    "Device": "V1",
    "Model": "V1"
  },
  {
    "Retail Branding": "Vava",
    "Marketing Name": "V1 Plus",
    "Device": "V1_Plus",
    "Model": "V1 Plus"
  },
  {
    "Retail Branding": "Vava",
    "Marketing Name": "V2",
    "Device": "V2",
    "Model": "V2"
  },
  {
    "Retail Branding": "Vava",
    "Marketing Name": "X2",
    "Device": "X2",
    "Model": "X2"
  },
  {
    "Retail Branding": "Vava",
    "Marketing Name": "XP3",
    "Device": "XP3",
    "Model": "XP3"
  },
  {
    "Retail Branding": "Vaxcare",
    "Marketing Name": "VAX114",
    "Device": "VAX114",
    "Model": "VAX114"
  },
  {
    "Retail Branding": "Vaxcare",
    "Marketing Name": "VaxHub2",
    "Device": "VaxHub2",
    "Model": "VaxHub2"
  },
  {
    "Retail Branding": "Vectra",
    "Marketing Name": "Vectra 4K Box",
    "Device": "DV8519-Vectra",
    "Model": "Vectra 4K Box"
  },
  {
    "Retail Branding": "Vectron_Systems_AG",
    "Marketing Name": "Vectron_K8",
    "Device": "Vectron_K8",
    "Model": "Vectron_K8"
  },
  {
    "Retail Branding": "Vega",
    "Marketing Name": "D2120",
    "Device": "D2140-Cosmos",
    "Model": "D2120"
  },
  {
    "Retail Branding": "Vega",
    "Marketing Name": "Europe",
    "Device": "marina",
    "Model": "VEGA Smart TV"
  },
  {
    "Retail Branding": "Vega",
    "Marketing Name": "European and African countries",
    "Device": "guandu",
    "Model": "VEGA 4K Android TV"
  },
  {
    "Retail Branding": "Vega",
    "Marketing Name": "Tunisa, Europe and Algeria",
    "Device": "tamachi",
    "Model": "VEGA FHD Android TV"
  },
  {
    "Retail Branding": "Vega",
    "Marketing Name": "Tunisa, Europe and Algeria",
    "Device": "yeongdeungpo",
    "Model": "VEGA UHD Android TV"
  },
  {
    "Retail Branding": "Vega",
    "Marketing Name": "VEGA Smart TV",
    "Device": "nagata",
    "Model": "VEGA Smart TV"
  },
  {
    "Retail Branding": "Vega",
    "Marketing Name": "Vega Q7128",
    "Device": "Vega_Q7128",
    "Model": "Vega Q7128"
  },
  {
    "Retail Branding": "Veidoo",
    "Marketing Name": "SMART_TabbyBoo",
    "Device": "SMART_TabbyBoo",
    "Model": "SMART_TabbyBoo"
  },
  {
    "Retail Branding": "Veidoo",
    "Marketing Name": "T12",
    "Device": "T12",
    "Model": "T12"
  },
  {
    "Retail Branding": "Veidoo",
    "Marketing Name": "T20",
    "Device": "T20",
    "Model": "T20"
  },
  {
    "Retail Branding": "Veidoo",
    "Marketing Name": "T20-Plus",
    "Device": "T20-Plus",
    "Model": "T20-Plus"
  },
  {
    "Retail Branding": "Veidoo",
    "Marketing Name": "T20_Play",
    "Device": "T20_Play",
    "Model": "T20_Play"
  },
  {
    "Retail Branding": "Veidoo",
    "Marketing Name": "T20_Play_EEA",
    "Device": "T20_Play_EEA",
    "Model": "T20_Play"
  },
  {
    "Retail Branding": "Veidoo",
    "Marketing Name": "T30_EEA",
    "Device": "T30_EEA",
    "Model": "T30"
  },
  {
    "Retail Branding": "Veidoo",
    "Marketing Name": "T30_PLUS",
    "Device": "T30_PLUS",
    "Model": "GetMi_Plus_95"
  },
  {
    "Retail Branding": "Veidoo",
    "Marketing Name": "T30_PLUS",
    "Device": "T30_PLUS",
    "Model": "OA-DUNE"
  },
  {
    "Retail Branding": "Veidoo",
    "Marketing Name": "T30_PLUS",
    "Device": "T30_PLUS",
    "Model": "P1095"
  },
  {
    "Retail Branding": "Veidoo",
    "Marketing Name": "T30_PLUS",
    "Device": "T30_PLUS",
    "Model": "T30_PLUS"
  },
  {
    "Retail Branding": "Veidoo",
    "Marketing Name": "T30_Plus_EEA",
    "Device": "T30_Plus_EEA",
    "Model": "T30_Plus_EEA"
  },
  {
    "Retail Branding": "Veidoo",
    "Marketing Name": "T40",
    "Device": "T40",
    "Model": "T40"
  },
  {
    "Retail Branding": "Veidoo",
    "Marketing Name": "T50",
    "Device": "T50",
    "Model": "T50"
  },
  {
    "Retail Branding": "Veidoo",
    "Marketing Name": "T50",
    "Device": "T50_EEA",
    "Model": "T50_EEA"
  },
  {
    "Retail Branding": "Veidoo",
    "Marketing Name": "T50_PLUS",
    "Device": "T50_PLUS",
    "Model": "T50_PLUS"
  },
  {
    "Retail Branding": "Veidoo",
    "Marketing Name": "T60_PLUS",
    "Device": "T60_PLUS",
    "Model": "T60_PLUS"
  },
  {
    "Retail Branding": "Veidoo",
    "Marketing Name": "T7",
    "Device": "T7",
    "Model": "T7"
  },
  {
    "Retail Branding": "Veidoo",
    "Marketing Name": "T70",
    "Device": "T70",
    "Model": "T70"
  },
  {
    "Retail Branding": "Veidoo",
    "Marketing Name": "T7S",
    "Device": "T7S",
    "Model": "T7S"
  },
  {
    "Retail Branding": "Veidoo",
    "Marketing Name": "T80",
    "Device": "T80",
    "Model": "T80"
  },
  {
    "Retail Branding": "Veidoo",
    "Marketing Name": "T80_PLUS",
    "Device": "T80_PLUS",
    "Model": "T80_PLUS"
  },
  {
    "Retail Branding": "Veidoo",
    "Marketing Name": "T80_PLUS",
    "Device": "T80_PLUS_EEA",
    "Model": "T80_PLUS_EEA"
  },
  {
    "Retail Branding": "Veidoo",
    "Marketing Name": "V88",
    "Device": "V88",
    "Model": "V88"
  },
  {
    "Retail Branding": "Veidoo",
    "Marketing Name": "VEIDOO_T30_PLUS",
    "Device": "VEIDOO_T30_PLUS",
    "Model": "VEIDOO_T30_PLUS"
  },
  {
    "Retail Branding": "Veidoo",
    "Marketing Name": "VEIDOO_T30_PLUS_EEA",
    "Device": "VEIDOO_T30_PLUS_EEA",
    "Model": "VEIDOO_T30_PLUS_EEA"
  },
  {
    "Retail Branding": "Veidoo",
    "Marketing Name": "VEIDOO_T40",
    "Device": "VEIDOO_T40",
    "Model": "VEIDOO_T40"
  },
  {
    "Retail Branding": "Veidoo",
    "Marketing Name": "VEIDOO_T40_EEA",
    "Device": "VEIDOO_T40_EEA",
    "Model": "VEIDOO_T40_EEA"
  },
  {
    "Retail Branding": "Veidoo",
    "Marketing Name": "VEIDOO_T50",
    "Device": "VEIDOO_T50",
    "Model": "VEIDOO_T50"
  },
  {
    "Retail Branding": "Veidoo",
    "Marketing Name": "VEIDOO_T60",
    "Device": "VEIDOO_T60",
    "Model": "VEIDOO_T60"
  },
  {
    "Retail Branding": "Veidoo",
    "Marketing Name": "VEIDOO_T60_EEA",
    "Device": "VEIDOO_T60_EEA",
    "Model": "VEIDOO_T60_EEA"
  },
  {
    "Retail Branding": "Veidoo",
    "Marketing Name": "VEIDOO_T60_PLUS",
    "Device": "VEIDOO_T60_PLUS",
    "Model": "VEIDOO_T60_PLUS"
  },
  {
    "Retail Branding": "Veidoo",
    "Marketing Name": "VEIDOO_T60_PLUS_EEA",
    "Device": "VEIDOO_T60_PLUS_EEA",
    "Model": "VEIDOO_T60_PLUS_EEA"
  },
  {
    "Retail Branding": "Veidoo",
    "Marketing Name": "VEIDOO_T70",
    "Device": "VEIDOO_T70",
    "Model": "VEIDOO_T70"
  },
  {
    "Retail Branding": "Veidoo",
    "Marketing Name": "VEIDOO_T70_PLUS",
    "Device": "VEIDOO_T70_PLUS",
    "Model": "VEIDOO_T70_PLUS"
  },
  {
    "Retail Branding": "Veidoo",
    "Marketing Name": "VEIDOO_T8",
    "Device": "VEIDOO_T8",
    "Model": "T8"
  },
  {
    "Retail Branding": "Veidoo",
    "Marketing Name": "VEIDOO_T80",
    "Device": "VEIDOO_T80",
    "Model": "VEIDOO_T80"
  },
  {
    "Retail Branding": "Veidoo",
    "Marketing Name": "VEIDOO_T80_EEA",
    "Device": "VEIDOO_T80_EEA",
    "Model": "VEIDOO_T80_EEA"
  },
  {
    "Retail Branding": "Veidoo",
    "Marketing Name": "VeidooT30_EEA",
    "Device": "VeidooT30_EEA",
    "Model": "VeidooT30_EEA"
  },
  {
    "Retail Branding": "Veidoo",
    "Marketing Name": "Veidoo_S10",
    "Device": "Veidoo_S10",
    "Model": "Veidoo_S10"
  },
  {
    "Retail Branding": "Veidoo",
    "Marketing Name": "Veidoo_S10_Pro",
    "Device": "Veidoo_S10_Pro",
    "Model": "Veidoo_S10_Pro"
  },
  {
    "Retail Branding": "Veira",
    "Marketing Name": "Smart TV",
    "Device": "alimos",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "Veira",
    "Marketing Name": "Smart TV",
    "Device": "dangni",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "Veld",
    "Marketing Name": "Veld Board",
    "Device": "Veld_Board",
    "Model": "SXX01G"
  },
  {
    "Retail Branding": "Venso",
    "Marketing Name": "CX-508",
    "Device": "CX-508",
    "Model": "CX-508"
  },
  {
    "Retail Branding": "Venso",
    "Marketing Name": "Venso CX-551",
    "Device": "Venso_CX_551",
    "Model": "Venso CX-551"
  },
  {
    "Retail Branding": "Venturer",
    "Marketing Name": "CT202",
    "Device": "CT202",
    "Model": "CT202"
  },
  {
    "Retail Branding": "Venturer",
    "Marketing Name": "CT212",
    "Device": "CT212",
    "Model": "CT212"
  },
  {
    "Retail Branding": "Venturer",
    "Marketing Name": "CT9A06P23_eea",
    "Device": "CT9A06P23",
    "Model": "CT9A06P23"
  },
  {
    "Retail Branding": "Venturer",
    "Marketing Name": "CT9B83W12",
    "Device": "CT9B83W12",
    "Model": "CT9B83W12"
  },
  {
    "Retail Branding": "Venturer",
    "Marketing Name": "Mariner 10 Pro",
    "Device": "CT9A03W23",
    "Model": "CT9A03W23"
  },
  {
    "Retail Branding": "Venturer",
    "Marketing Name": "VCT9716Q24",
    "Device": "VCT9716Q24",
    "Model": "VCT9716Q24"
  },
  {
    "Retail Branding": "Venturer",
    "Marketing Name": "VCT9B06Q22N",
    "Device": "VCT9B06Q22N",
    "Model": "VCT9B06Q22N"
  },
  {
    "Retail Branding": "Venturer",
    "Marketing Name": "VCT9B06Q22_eea",
    "Device": "VCT9B06Q22",
    "Model": "VCT9B06Q22"
  },
  {
    "Retail Branding": "Venturer",
    "Marketing Name": "VCT9B06Q23",
    "Device": "VCT9B06Q23",
    "Model": "VCT9B06Q23"
  },
  {
    "Retail Branding": "Venturer",
    "Marketing Name": "VCT9C0AT",
    "Device": "VCT9C0AT",
    "Model": "VCT9C0AT"
  },
  {
    "Retail Branding": "Venturer",
    "Marketing Name": "VCT9F08Q22D",
    "Device": "VCT9F08Q22D",
    "Model": "VCT9F08Q22D"
  },
  {
    "Retail Branding": "Venturer",
    "Marketing Name": "VCT9F0A68R",
    "Device": "VCT9F0A68R",
    "Model": "VCT9F0A68R"
  },
  {
    "Retail Branding": "Venturer",
    "Marketing Name": "VCT9F0A68R23EU",
    "Device": "VCT9F0A68R23EU",
    "Model": "VCT9F0A68R23EU"
  },
  {
    "Retail Branding": "Venturer",
    "Marketing Name": "VCT9F0A68R44",
    "Device": "VCT9F0A68R44",
    "Model": "VCT9F0A68R44"
  },
  {
    "Retail Branding": "Venturer",
    "Marketing Name": "VCT9F1A68R44",
    "Device": "VCT9F1A68R44",
    "Model": "VCT9F1A68R44"
  },
  {
    "Retail Branding": "Venturer",
    "Marketing Name": "VCT9F78Q22",
    "Device": "VCT9F78Q22",
    "Model": "VCT9F78Q22"
  },
  {
    "Retail Branding": "Venturer",
    "Marketing Name": "VCT9F78Q22-A0",
    "Device": "VCT9F78Q22-A0",
    "Model": "VCT9F78Q22-A0"
  },
  {
    "Retail Branding": "Venturer",
    "Marketing Name": "VCT9F78Q22-A1",
    "Device": "VCT9F78Q22-A1",
    "Model": "VCT9F78Q22-A1"
  },
  {
    "Retail Branding": "Venturer",
    "Marketing Name": "VCT9F78Q22-E",
    "Device": "VCT9F78Q22-E",
    "Model": "VCT9F78Q22-E"
  },
  {
    "Retail Branding": "Venturer",
    "Marketing Name": "VCT9F78Q22EU_eea",
    "Device": "VCT9F78Q22EU",
    "Model": "VCT9F78Q22EU"
  },
  {
    "Retail Branding": "Venturer",
    "Marketing Name": "VCT9F8A68R",
    "Device": "VCT9F8A68R",
    "Model": "VCT9F8A68R"
  },
  {
    "Retail Branding": "Venturer",
    "Marketing Name": "VCT9F8A68RD",
    "Device": "VCT9F8A68RD",
    "Model": "VCT9F8A68RD"
  },
  {
    "Retail Branding": "Venturer",
    "Marketing Name": "VCT9R4A68R",
    "Device": "VCT9R4A68R",
    "Model": "VCT9R4A68R"
  },
  {
    "Retail Branding": "Venturer",
    "Marketing Name": "VCT9R5A78R",
    "Device": "VCT9R5A78R",
    "Model": "VCT9R5A78R"
  },
  {
    "Retail Branding": "Venturer",
    "Marketing Name": "VCT9T48Q34EU_eea",
    "Device": "VCT9T48Q34EU",
    "Model": "VCT9T48Q34EU"
  },
  {
    "Retail Branding": "Venturer",
    "Marketing Name": "i7",
    "Device": "RCT6773W22",
    "Model": "i7"
  },
  {
    "Retail Branding": "Venus",
    "Marketing Name": "V1401",
    "Device": "V1401",
    "Model": "V1401"
  },
  {
    "Retail Branding": "Venus",
    "Marketing Name": "V5",
    "Device": "V5",
    "Model": "V5"
  },
  {
    "Retail Branding": "Venus",
    "Marketing Name": "V5Plus",
    "Device": "V5_Plus",
    "Model": "V5_Plus"
  },
  {
    "Retail Branding": "Venus",
    "Marketing Name": "V5Plus Lite",
    "Device": "V5_Plus_Lite",
    "Model": "V5_Plus_Lite"
  },
  {
    "Retail Branding": "Venus",
    "Marketing Name": "V5_Plus_",
    "Device": "V5_Plus_",
    "Model": "V5_Plus_"
  },
  {
    "Retail Branding": "Venus",
    "Marketing Name": "V5_Pro",
    "Device": "V5_Pro",
    "Model": "V5_Pro"
  },
  {
    "Retail Branding": "Venus",
    "Marketing Name": "V6",
    "Device": "V6",
    "Model": "V6"
  },
  {
    "Retail Branding": "Venus",
    "Marketing Name": "Venus V6",
    "Device": "Samos",
    "Model": "Venus V6"
  },
  {
    "Retail Branding": "Veon",
    "Marketing Name": "VEON",
    "Device": "bangbae",
    "Model": "VEON 4K Android TV"
  },
  {
    "Retail Branding": "Veon",
    "Marketing Name": "VEON",
    "Device": "bruno",
    "Model": "VEON 2K Android TV"
  },
  {
    "Retail Branding": "Veon",
    "Marketing Name": "VEON",
    "Device": "shilin",
    "Model": "VEON 4K Android TV"
  },
  {
    "Retail Branding": "Veon",
    "Marketing Name": "VEON 4K Smart TV",
    "Device": "SW6H",
    "Model": "VEON 4K Smart TV"
  },
  {
    "Retail Branding": "Veon",
    "Marketing Name": "VEON UHD TV G0325",
    "Device": "eleonas",
    "Model": "VEON UHD TV G0325"
  },
  {
    "Retail Branding": "Veon",
    "Marketing Name": "VEON UHD TV G0325N",
    "Device": "eleonas",
    "Model": "VEON UHD TV G0325N"
  },
  {
    "Retail Branding": "VerD",
    "Marketing Name": "E1",
    "Device": "E1",
    "Model": "E1"
  },
  {
    "Retail Branding": "VerD",
    "Marketing Name": "E2",
    "Device": "E2",
    "Model": "E2"
  },
  {
    "Retail Branding": "Verizon",
    "Marketing Name": "Fios TV",
    "Device": "SCSIP02",
    "Model": "Fios TV"
  },
  {
    "Retail Branding": "Verizon",
    "Marketing Name": "Stream TV",
    "Device": "JS8V",
    "Model": "Stream TV"
  },
  {
    "Retail Branding": "Verizon",
    "Marketing Name": "Stream TV",
    "Device": "SCSIP02",
    "Model": "Stream TV"
  },
  {
    "Retail Branding": "Verizon",
    "Marketing Name": "Stream TV",
    "Device": "f354",
    "Model": "Stream TV"
  },
  {
    "Retail Branding": "Verizon",
    "Marketing Name": "Stream TV",
    "Device": "sti6220d315",
    "Model": "Stream TV"
  },
  {
    "Retail Branding": "Verizon",
    "Marketing Name": "Stream TV Soundbar",
    "Device": "sti6251d315",
    "Model": "Stream TV Soundbar"
  },
  {
    "Retail Branding": "Verizon",
    "Marketing Name": "Stream TV Soundbar Pro",
    "Device": "sti6250d315",
    "Model": "Stream TV Soundbar Pro"
  },
  {
    "Retail Branding": "Verizon",
    "Marketing Name": "StreamTV",
    "Device": "f354",
    "Model": "Stream TV"
  },
  {
    "Retail Branding": "Verizon",
    "Marketing Name": "Visible Midnight",
    "Device": "WTVIS01",
    "Model": "WTVIS01"
  },
  {
    "Retail Branding": "Verizon Wireless",
    "Marketing Name": "5059S",
    "Device": "U50PLUS",
    "Model": "5059S"
  },
  {
    "Retail Branding": "Verizon Wireless",
    "Marketing Name": "Ellipsis 10",
    "Device": "QTAIR7",
    "Model": "QTAIR7"
  },
  {
    "Retail Branding": "Verizon Wireless",
    "Marketing Name": "Ellipsis 7",
    "Device": "QMV7A",
    "Model": "QMV7A"
  },
  {
    "Retail Branding": "Verizon Wireless",
    "Marketing Name": "Ellipsis 7",
    "Device": "QMV7A",
    "Model": "QMV7B"
  },
  {
    "Retail Branding": "Verizon Wireless",
    "Marketing Name": "Ellipsis 7 (QMV7A)",
    "Device": "QMV7A",
    "Model": "QMV7A"
  },
  {
    "Retail Branding": "Verizon Wireless",
    "Marketing Name": "Ellipsis 7 (QMV7B)",
    "Device": "QMV7A",
    "Model": "QMV7B"
  },
  {
    "Retail Branding": "Verizon Wireless",
    "Marketing Name": "Ellipsis 8",
    "Device": "QTAQZ3",
    "Model": "QTAQZ3"
  },
  {
    "Retail Branding": "Verizon Wireless",
    "Marketing Name": "Ellipsis 8 HD",
    "Device": "QTASUN1",
    "Model": "QTASUN1"
  },
  {
    "Retail Branding": "Verizon Wireless",
    "Marketing Name": "Ellipsis 8 HD",
    "Device": "QTASUN1",
    "Model": "QTASUN2"
  },
  {
    "Retail Branding": "Verizon Wireless",
    "Marketing Name": "Ellipsis ® 10 HD",
    "Device": "QTAXIA1",
    "Model": "QTAXIA1"
  },
  {
    "Retail Branding": "Verizon Wireless",
    "Marketing Name": "Gizmo Tab",
    "Device": "QTASUN2",
    "Model": "QTASUN2"
  },
  {
    "Retail Branding": "Verizon Wireless",
    "Marketing Name": "Gizo Tab",
    "Device": "QTASUN2",
    "Model": "QTASUN2"
  },
  {
    "Retail Branding": "Verizon Wireless",
    "Marketing Name": "QTAQZ3KID",
    "Device": "QTAQZ3KID",
    "Model": "QTAQZ3KID"
  },
  {
    "Retail Branding": "Verizon Wireless",
    "Marketing Name": "TCL TAB Pro 5G",
    "Device": "Transformer_VZW",
    "Model": "9198S"
  },
  {
    "Retail Branding": "Verizon Wireless",
    "Marketing Name": "Wear24",
    "Device": "dorado",
    "Model": "Wear24"
  },
  {
    "Retail Branding": "Vernee",
    "Marketing Name": "Active",
    "Device": "V1",
    "Model": "V1"
  },
  {
    "Retail Branding": "Vernee",
    "Marketing Name": "M3",
    "Device": "M3",
    "Model": "M3"
  },
  {
    "Retail Branding": "Vernee",
    "Marketing Name": "M5",
    "Device": "vernee_M5",
    "Model": "vernee_M5"
  },
  {
    "Retail Branding": "Vernee",
    "Marketing Name": "M6",
    "Device": "M6",
    "Model": "M6"
  },
  {
    "Retail Branding": "Vernee",
    "Marketing Name": "M7_EEA",
    "Device": "M7_EEA",
    "Model": "M7_EEA"
  },
  {
    "Retail Branding": "Vernee",
    "Marketing Name": "M8 Pro",
    "Device": "M8_Pro",
    "Model": "M8 Pro"
  },
  {
    "Retail Branding": "Vernee",
    "Marketing Name": "MIX 2",
    "Device": "M2",
    "Model": "M2"
  },
  {
    "Retail Branding": "Vernee",
    "Marketing Name": "MIX 2",
    "Device": "M2_PRO",
    "Model": "M2"
  },
  {
    "Retail Branding": "Vernee",
    "Marketing Name": "T3",
    "Device": "T3",
    "Model": "T3"
  },
  {
    "Retail Branding": "Vernee",
    "Marketing Name": "T3 Pro",
    "Device": "T3_Pro",
    "Model": "T3 Pro"
  },
  {
    "Retail Branding": "Vernee",
    "Marketing Name": "Thor E",
    "Device": "Thor_E",
    "Model": "Thor E"
  },
  {
    "Retail Branding": "Vernee",
    "Marketing Name": "Thor Plus",
    "Device": "Thor_Plus",
    "Model": "Thor Plus"
  },
  {
    "Retail Branding": "Vernee",
    "Marketing Name": "V2 Pro",
    "Device": "V2_Pro",
    "Model": "V2 Pro"
  },
  {
    "Retail Branding": "Vernee",
    "Marketing Name": "V3",
    "Device": "V3",
    "Model": "V3"
  },
  {
    "Retail Branding": "Vernee",
    "Marketing Name": "X1",
    "Device": "X1",
    "Model": "X1"
  },
  {
    "Retail Branding": "Vernee",
    "Marketing Name": "X1",
    "Device": "X1_PRO",
    "Model": "X1"
  },
  {
    "Retail Branding": "Vernee",
    "Marketing Name": "X2",
    "Device": "X2",
    "Model": "X2"
  },
  {
    "Retail Branding": "Vernee",
    "Marketing Name": "X2_euro",
    "Device": "X2_euro",
    "Model": "X2_euro"
  },
  {
    "Retail Branding": "Vernee",
    "Marketing Name": "note",
    "Device": "note",
    "Model": "note"
  },
  {
    "Retail Branding": "Verssed",
    "Marketing Name": "FW8977-ED",
    "Device": "FW8977-ED",
    "Model": "FW8977-ED"
  },
  {
    "Retail Branding": "Vertex",
    "Marketing Name": "BLK3D",
    "Device": "BLK3D",
    "Model": "BLK3D"
  },
  {
    "Retail Branding": "Vertex",
    "Marketing Name": "Baccara",
    "Device": "Baccara",
    "Model": "Baccara"
  },
  {
    "Retail Branding": "Vertex",
    "Marketing Name": "CS24",
    "Device": "CS24",
    "Model": "CS24"
  },
  {
    "Retail Branding": "Vertex",
    "Marketing Name": "CS28",
    "Device": "CS28",
    "Model": "CS28"
  },
  {
    "Retail Branding": "Vertex",
    "Marketing Name": "Calypso",
    "Device": "Calypso",
    "Model": "Impress_Calypso"
  },
  {
    "Retail Branding": "Vertex",
    "Marketing Name": "Click_M_4095_4G",
    "Device": "Click_M_4095_4G",
    "Model": "Vertex_Click_M_4095_4G"
  },
  {
    "Retail Branding": "Vertex",
    "Marketing Name": "EF",
    "Device": "EF",
    "Model": "EF"
  },
  {
    "Retail Branding": "Vertex",
    "Marketing Name": "EO",
    "Device": "EO",
    "Model": "EO"
  },
  {
    "Retail Branding": "Vertex",
    "Marketing Name": "ET",
    "Device": "ET",
    "Model": "ET"
  },
  {
    "Retail Branding": "Vertex",
    "Marketing Name": "Impress Action",
    "Device": "Impress_Action",
    "Model": "Impress_Action"
  },
  {
    "Retail Branding": "Vertex",
    "Marketing Name": "Impress City",
    "Device": "Impress_City",
    "Model": "Impress_City"
  },
  {
    "Retail Branding": "Vertex",
    "Marketing Name": "Impress Click (3G)",
    "Device": "IMPRESS_CLICK",
    "Model": "IMPRESS CLICK"
  },
  {
    "Retail Branding": "Vertex",
    "Marketing Name": "Impress Click NFC",
    "Device": "Impress_Click_NFC",
    "Model": "Impress Click NFC"
  },
  {
    "Retail Branding": "Vertex",
    "Marketing Name": "Impress Cube",
    "Device": "Impress_Cube",
    "Model": "Impress_Cube"
  },
  {
    "Retail Branding": "Vertex",
    "Marketing Name": "Impress Dune",
    "Device": "Impress_Dune",
    "Model": "Impress_Dune"
  },
  {
    "Retail Branding": "Vertex",
    "Marketing Name": "Impress Eagle",
    "Device": "Impress_Eagle",
    "Model": "Impress_Eagle"
  },
  {
    "Retail Branding": "Vertex",
    "Marketing Name": "Impress Eclipse (4G)",
    "Device": "IMPRESS_ECLIPSE",
    "Model": "IMPRESS ECLIPSE"
  },
  {
    "Retail Branding": "Vertex",
    "Marketing Name": "Impress Fire",
    "Device": "Impress_Fire",
    "Model": "Impress_Fire"
  },
  {
    "Retail Branding": "Vertex",
    "Marketing Name": "Impress Forest",
    "Device": "Impress_Forest",
    "Model": "Impress_Forest"
  },
  {
    "Retail Branding": "Vertex",
    "Marketing Name": "Impress Fortune",
    "Device": "Impress_Fortune",
    "Model": "Impress_Fortune"
  },
  {
    "Retail Branding": "Vertex",
    "Marketing Name": "Impress Grip",
    "Device": "Grip",
    "Model": "Impress_Grip"
  },
  {
    "Retail Branding": "Vertex",
    "Marketing Name": "Impress Groove",
    "Device": "Impress_Groove",
    "Model": "Impress_Groove"
  },
  {
    "Retail Branding": "Vertex",
    "Marketing Name": "Impress Life",
    "Device": "Impress_Life",
    "Model": "Impress_Life"
  },
  {
    "Retail Branding": "Vertex",
    "Marketing Name": "Impress Lightning",
    "Device": "Impress_Lightning",
    "Model": "Impress_Lightning"
  },
  {
    "Retail Branding": "Vertex",
    "Marketing Name": "Impress Lion (3G)",
    "Device": "Impress_Lion_3G",
    "Model": "Impress_Lion_3G"
  },
  {
    "Retail Branding": "Vertex",
    "Marketing Name": "Impress Lion (4G)",
    "Device": "Impress_Lion_4G",
    "Model": "Impress_Lion_4G"
  },
  {
    "Retail Branding": "Vertex",
    "Marketing Name": "Impress Lotus",
    "Device": "Impress_Lotus",
    "Model": "Impress_Lotus"
  },
  {
    "Retail Branding": "Vertex",
    "Marketing Name": "Impress Luck",
    "Device": "Impress_Luck",
    "Model": "Impress_Luck"
  },
  {
    "Retail Branding": "Vertex",
    "Marketing Name": "Impress Phonic",
    "Device": "Impress_Phonic",
    "Model": "Impress_Phonic"
  },
  {
    "Retail Branding": "Vertex",
    "Marketing Name": "Impress Play (4G)",
    "Device": "Impress_Play",
    "Model": "Impress_Play"
  },
  {
    "Retail Branding": "Vertex",
    "Marketing Name": "Impress Ra (4G)",
    "Device": "Impress_Ra",
    "Model": "Impress_Ra"
  },
  {
    "Retail Branding": "Vertex",
    "Marketing Name": "Impress Razor",
    "Device": "Impress_Razor",
    "Model": "Impress_Razor"
  },
  {
    "Retail Branding": "Vertex",
    "Marketing Name": "Impress Reef",
    "Device": "Impress_Reef",
    "Model": "Impress_Reef"
  },
  {
    "Retail Branding": "Vertex",
    "Marketing Name": "Impress Saturn",
    "Device": "Impress_Saturn",
    "Model": "Impress_Saturn"
  },
  {
    "Retail Branding": "Vertex",
    "Marketing Name": "Impress Spring (4G)",
    "Device": "Impress_Spring",
    "Model": "Impress_Spring"
  },
  {
    "Retail Branding": "Vertex",
    "Marketing Name": "Impress Stone",
    "Device": "Impress_Stone",
    "Model": "Impress_Stone"
  },
  {
    "Retail Branding": "Vertex",
    "Marketing Name": "Impress Sun",
    "Device": "Sun",
    "Model": "Sun"
  },
  {
    "Retail Branding": "Vertex",
    "Marketing Name": "Impress Tiger",
    "Device": "Tiger",
    "Model": "Tiger"
  },
  {
    "Retail Branding": "Vertex",
    "Marketing Name": "Impress Tor",
    "Device": "Impress_Tor",
    "Model": "Impress_Tor"
  },
  {
    "Retail Branding": "Vertex",
    "Marketing Name": "Impress Vega (4G)",
    "Device": "Impress_Vega",
    "Model": "Impress_Vega"
  },
  {
    "Retail Branding": "Vertex",
    "Marketing Name": "Impress Win",
    "Device": "Impress_Win",
    "Model": "Impress_Win"
  },
  {
    "Retail Branding": "Vertex",
    "Marketing Name": "Impress_Aqua",
    "Device": "Impress_Aqua",
    "Model": "Impress_Aqua"
  },
  {
    "Retail Branding": "Vertex",
    "Marketing Name": "Impress_Astra4G",
    "Device": "Impress_Astra4G",
    "Model": "Impress_Astra4G"
  },
  {
    "Retail Branding": "Vertex",
    "Marketing Name": "Impress_Bear",
    "Device": "Impress_Bear",
    "Model": "Impress_Bear"
  },
  {
    "Retail Branding": "Vertex",
    "Marketing Name": "Impress_Blade",
    "Device": "Impress_Blade",
    "Model": "Impress_Blade"
  },
  {
    "Retail Branding": "Vertex",
    "Marketing Name": "Impress_City",
    "Device": "Impress_City",
    "Model": "Impress_City"
  },
  {
    "Retail Branding": "Vertex",
    "Marketing Name": "Impress_Disco",
    "Device": "Impress_Disco",
    "Model": "Impress Disco"
  },
  {
    "Retail Branding": "Vertex",
    "Marketing Name": "Impress_Eagle_4G",
    "Device": "Impress_Eagle4G",
    "Model": "Impress_Eagle4G"
  },
  {
    "Retail Branding": "Vertex",
    "Marketing Name": "Impress_Energy",
    "Device": "Impress_Energy",
    "Model": "Impress_Energy"
  },
  {
    "Retail Branding": "Vertex",
    "Marketing Name": "Impress_Flash",
    "Device": "Impress_Flash",
    "Model": "Impress_Flash"
  },
  {
    "Retail Branding": "Vertex",
    "Marketing Name": "Impress_Frost",
    "Device": "Impress_Frost",
    "Model": "Impress_Frost"
  },
  {
    "Retail Branding": "Vertex",
    "Marketing Name": "Impress_Funk",
    "Device": "Impress_Funk",
    "Model": "Impress_Funk"
  },
  {
    "Retail Branding": "Vertex",
    "Marketing Name": "Impress_Game",
    "Device": "Impress_Game",
    "Model": "Impress_Game"
  },
  {
    "Retail Branding": "Vertex",
    "Marketing Name": "Impress_Indigo",
    "Device": "Impress_Indigo",
    "Model": "Impress_Indigo"
  },
  {
    "Retail Branding": "Vertex",
    "Marketing Name": "Impress_Lagune",
    "Device": "Impress_Lagune",
    "Model": "Impress_Lagune"
  },
  {
    "Retail Branding": "Vertex",
    "Marketing Name": "Impress_Luck4G_NFC",
    "Device": "Impress_Luck4G_NFC",
    "Model": "Impress_Luck4G_NFC"
  },
  {
    "Retail Branding": "Vertex",
    "Marketing Name": "Impress_Nero",
    "Device": "Impress_Nero",
    "Model": "Impress_Nero"
  },
  {
    "Retail Branding": "Vertex",
    "Marketing Name": "Impress_New",
    "Device": "Impress_New",
    "Model": "Impress_New"
  },
  {
    "Retail Branding": "Vertex",
    "Marketing Name": "Impress_Pear",
    "Device": "Impress_Pear",
    "Model": "Impress_Pear"
  },
  {
    "Retail Branding": "Vertex",
    "Marketing Name": "Impress_Pluto",
    "Device": "Impress_Pluto",
    "Model": "Impress_Pluto"
  },
  {
    "Retail Branding": "Vertex",
    "Marketing Name": "Impress_Rosso",
    "Device": "Impress_Rosso",
    "Model": "Impress_Rosso"
  },
  {
    "Retail Branding": "Vertex",
    "Marketing Name": "Impress_Sunset4G",
    "Device": "Impress_Sunset4G",
    "Model": "Impress_Sunset4G"
  },
  {
    "Retail Branding": "Vertex",
    "Marketing Name": "Impress_Vira",
    "Device": "Impress_Vira",
    "Model": "Impress_Vira"
  },
  {
    "Retail Branding": "Vertex",
    "Marketing Name": "Impress_Wolf",
    "Device": "Impress_Wolf",
    "Model": "Impress_Wolf"
  },
  {
    "Retail Branding": "Vertex",
    "Marketing Name": "Impress_Zeon3G",
    "Device": "Impress_Zeon3G",
    "Model": "Impress_Zeon3G"
  },
  {
    "Retail Branding": "Vertex",
    "Marketing Name": "Impress_Zeon4G",
    "Device": "Impress_Zeon4G",
    "Model": "Impress_Zeon4G"
  },
  {
    "Retail Branding": "Vertex",
    "Marketing Name": "Interactive-Multimedia-Display",
    "Device": "Interactive-Multimedia-Display",
    "Model": "IL-5865-PRO"
  },
  {
    "Retail Branding": "Vertex",
    "Marketing Name": "Lion_DC",
    "Device": "Lion_DC",
    "Model": "Lion_DC"
  },
  {
    "Retail Branding": "Vertex",
    "Marketing Name": "Lion_Dual",
    "Device": "Lion_Dual",
    "Model": "Lion_Dual"
  },
  {
    "Retail Branding": "Vertex",
    "Marketing Name": "Luck",
    "Device": "Luck",
    "Model": "Luck"
  },
  {
    "Retail Branding": "Vertex",
    "Marketing Name": "Luck_L100_3G",
    "Device": "Luck_L100_3G",
    "Model": "Luck_L100_3G"
  },
  {
    "Retail Branding": "Vertex",
    "Marketing Name": "Luck_L120_4G",
    "Device": "Luck_L120_4G",
    "Model": "Luck_L120_4G"
  },
  {
    "Retail Branding": "Vertex",
    "Marketing Name": "Luck_L130",
    "Device": "Luck_L130",
    "Model": "Luck L130"
  },
  {
    "Retail Branding": "Vertex",
    "Marketing Name": "Luck_L_5045_3G",
    "Device": "Luck_L_5045_3G",
    "Model": "Vertex_Luck_L_5045_3G"
  },
  {
    "Retail Branding": "Vertex",
    "Marketing Name": "Luck_L_5045_4G",
    "Device": "Luck_L_5045_4G",
    "Model": "Vertex_Luck_L_5045_4G"
  },
  {
    "Retail Branding": "Vertex",
    "Marketing Name": "Luck_M_5000N_4G",
    "Device": "Luck_M_5000N_4G",
    "Model": "Luck_M_5000N_4G"
  },
  {
    "Retail Branding": "Vertex",
    "Marketing Name": "Luck_XS_3097_3G",
    "Device": "Luck_XS_3097_3G",
    "Model": "Luck_XS_3097_3G"
  },
  {
    "Retail Branding": "Vertex",
    "Marketing Name": "Pro_L_5045_4G",
    "Device": "Pro_L_5045_4G",
    "Model": "Pro_L_5045_4G"
  },
  {
    "Retail Branding": "Vertex",
    "Marketing Name": "Pro_P200_4G",
    "Device": "Pro_P200_4G",
    "Model": "Pro_P200_4G"
  },
  {
    "Retail Branding": "Vertex",
    "Marketing Name": "Pro_P300_4G",
    "Device": "Pro_P300_4G",
    "Model": "Pro_P300_4G"
  },
  {
    "Retail Branding": "Vertex",
    "Marketing Name": "Pro_P300_4G",
    "Device": "Pro_P310_4G",
    "Model": "Pro_P310_4G"
  },
  {
    "Retail Branding": "Vertex",
    "Marketing Name": "S1",
    "Device": "GlocalMe_S1",
    "Model": "G1701"
  },
  {
    "Retail Branding": "Vertex",
    "Marketing Name": "Smart Touch",
    "Device": "smart_touch",
    "Model": "smart_touch"
  },
  {
    "Retail Branding": "Vertex",
    "Marketing Name": "Smart_S_100_4G",
    "Device": "Smart_S_100_4G",
    "Model": "Smart_S_100_4G"
  },
  {
    "Retail Branding": "Vertex",
    "Marketing Name": "TAB-X10",
    "Device": "TABX10",
    "Model": "TAB X10"
  },
  {
    "Retail Branding": "Vertex",
    "Marketing Name": "TAB-X8",
    "Device": "TABX8",
    "Model": "TAB X8"
  },
  {
    "Retail Branding": "Vertex",
    "Marketing Name": "Tab_4G_10_1",
    "Device": "Tab_4G_10-1",
    "Model": "Tab 4G 10-1"
  },
  {
    "Retail Branding": "Vertex",
    "Marketing Name": "Tab_4G_8-1",
    "Device": "Tab_4G_8-1",
    "Model": "Tab 4G 8-1"
  },
  {
    "Retail Branding": "Vertex",
    "Marketing Name": "VERTEX",
    "Device": "IL_3xx6_Pro",
    "Model": "IL_3xx6_Pro"
  },
  {
    "Retail Branding": "Vertex",
    "Marketing Name": "Vertex Tab 3G 7-1",
    "Device": "Tab_3G_7_1",
    "Model": "Tab_3G_7-1"
  },
  {
    "Retail Branding": "Vertex",
    "Marketing Name": "Vertex Tab 3G 7-2",
    "Device": "Vertex_Tab",
    "Model": "Tab 3G 7-2"
  },
  {
    "Retail Branding": "Vertex",
    "Marketing Name": "Wolverine12",
    "Device": "wolverine12",
    "Model": "wolverine12"
  },
  {
    "Retail Branding": "Vertex",
    "Marketing Name": "Wolverine7",
    "Device": "wolverine7",
    "Model": "wolverine7"
  },
  {
    "Retail Branding": "Vertu",
    "Marketing Name": "ASTER  P",
    "Device": "ASTER_P",
    "Model": "ASTER P"
  },
  {
    "Retail Branding": "Vertu",
    "Marketing Name": "Aster",
    "Device": "alexa",
    "Model": "Aster"
  },
  {
    "Retail Branding": "Vertu",
    "Marketing Name": "Aster T",
    "Device": "alexa",
    "Model": "Aster T"
  },
  {
    "Retail Branding": "Vertu",
    "Marketing Name": "Constellation V",
    "Device": "gambit",
    "Model": "Constellation V"
  },
  {
    "Retail Branding": "Vertu",
    "Marketing Name": "Constellation X",
    "Device": "tron",
    "Model": "CONSTELLATION X"
  },
  {
    "Retail Branding": "Vertu",
    "Marketing Name": "METAFLIP",
    "Device": "VTL-202302",
    "Model": "VTL-202302"
  },
  {
    "Retail Branding": "Vertu",
    "Marketing Name": "METAVERTU 2",
    "Device": "VTL-202301",
    "Model": "VTL-202301"
  },
  {
    "Retail Branding": "Vertu",
    "Marketing Name": "Signature Touch",
    "Device": "odin",
    "Model": "Signature Touch"
  },
  {
    "Retail Branding": "Vertu",
    "Marketing Name": "Signature Touch",
    "Device": "titan",
    "Model": "Signature Touch"
  },
  {
    "Retail Branding": "Vertu",
    "Marketing Name": "Signature Touch",
    "Device": "titan",
    "Model": "Signature Touch L"
  },
  {
    "Retail Branding": "Vertu",
    "Marketing Name": "Ti",
    "Device": "hermione",
    "Model": "VERTU Ti"
  },
  {
    "Retail Branding": "Vertu",
    "Marketing Name": "VTL-202101",
    "Device": "VTL-202101",
    "Model": "VTL-202101"
  },
  {
    "Retail Branding": "Vertu",
    "Marketing Name": "VTL-202201",
    "Device": "VTL-202201",
    "Model": "VTL-202201"
  },
  {
    "Retail Branding": "Verve",
    "Marketing Name": "K1",
    "Device": "K1",
    "Model": "K1"
  },
  {
    "Retail Branding": "Verykool",
    "Marketing Name": "SL5029",
    "Device": "verykoolSL5029",
    "Model": "verykoolSL5029"
  },
  {
    "Retail Branding": "Verykool",
    "Marketing Name": "SL5050",
    "Device": "verykoolSL5050",
    "Model": "verykoolSL5050"
  },
  {
    "Retail Branding": "Verykool",
    "Marketing Name": "SL5200",
    "Device": "verykoolSL5200",
    "Model": "verykoolSL5200"
  },
  {
    "Retail Branding": "Verykool",
    "Marketing Name": "SL5560",
    "Device": "verykoolSL5560",
    "Model": "verykoolSL5560"
  },
  {
    "Retail Branding": "Verykool",
    "Marketing Name": "T7445",
    "Device": "verykoolT7445",
    "Model": "verykoolT7445"
  },
  {
    "Retail Branding": "Verykool",
    "Marketing Name": "s4513",
    "Device": "verykoolS4513",
    "Model": "verykool Luna II S4513"
  },
  {
    "Retail Branding": "Verykool",
    "Marketing Name": "s5007",
    "Device": "verykoolS5007",
    "Model": "verykoolS5007"
  },
  {
    "Retail Branding": "Verykool",
    "Marketing Name": "s5021",
    "Device": "verykoolS5021",
    "Model": "verykool Wave Pro s5021"
  },
  {
    "Retail Branding": "Verykool",
    "Marketing Name": "s5021",
    "Device": "verykoolS5021",
    "Model": "verykoolS5021"
  },
  {
    "Retail Branding": "Verykool",
    "Marketing Name": "s5027",
    "Device": "verykoolS5027",
    "Model": "verykoolS5027"
  },
  {
    "Retail Branding": "Verykool",
    "Marketing Name": "s5028",
    "Device": "verykoolS5028",
    "Model": "verykoolS5028"
  },
  {
    "Retail Branding": "Verykool",
    "Marketing Name": "s5029",
    "Device": "verykool_s5029",
    "Model": "s5029"
  },
  {
    "Retail Branding": "Verykool",
    "Marketing Name": "s5031",
    "Device": "verykool_s5031",
    "Model": "s5031"
  },
  {
    "Retail Branding": "Verykool",
    "Marketing Name": "s5034",
    "Device": "verykools5034",
    "Model": "verykools5034"
  },
  {
    "Retail Branding": "Verykool",
    "Marketing Name": "s5035",
    "Device": "verykools5035",
    "Model": "verykools5035"
  },
  {
    "Retail Branding": "Verykool",
    "Marketing Name": "s5204",
    "Device": "verykools5204",
    "Model": "verykools5204"
  },
  {
    "Retail Branding": "Verykool",
    "Marketing Name": "s5526",
    "Device": "verykools5526",
    "Model": "verykools5526"
  },
  {
    "Retail Branding": "Verykool",
    "Marketing Name": "s5527",
    "Device": "verykools5527",
    "Model": "verykools5527"
  },
  {
    "Retail Branding": "Verykool",
    "Marketing Name": "s5528",
    "Device": "verykools5528",
    "Model": "verykools5528"
  },
  {
    "Retail Branding": "Verykool",
    "Marketing Name": "verykool s5036",
    "Device": "verykools5036",
    "Model": "verykools5036"
  },
  {
    "Retail Branding": "Verykool",
    "Marketing Name": "verykool s5037",
    "Device": "verykools5037",
    "Model": "verykools5037"
  },
  {
    "Retail Branding": "Verykool",
    "Marketing Name": "verykool s6005x",
    "Device": "verykools6005X",
    "Model": "s6005X"
  },
  {
    "Retail Branding": "Verykool",
    "Marketing Name": "verykool s6005x",
    "Device": "verykools6005X",
    "Model": "verykools6005X"
  },
  {
    "Retail Branding": "Verykool",
    "Marketing Name": "verykoolS5019",
    "Device": "verykoolS5019",
    "Model": "verykoolS5019"
  },
  {
    "Retail Branding": "Verykool",
    "Marketing Name": "verykoolS5019",
    "Device": "verykoolS5019",
    "Model": "verykools5019"
  },
  {
    "Retail Branding": "Verykool",
    "Marketing Name": "verykoolSL5029",
    "Device": "verykoolSL5029",
    "Model": "verykoolSL5029"
  },
  {
    "Retail Branding": "Verykool",
    "Marketing Name": "verykoolSL5565",
    "Device": "verykoolSL5565",
    "Model": "verykoolSL5565"
  },
  {
    "Retail Branding": "Verykool",
    "Marketing Name": "verykools5205",
    "Device": "verykools5205",
    "Model": "verykools5205"
  },
  {
    "Retail Branding": "Verykool",
    "Marketing Name": "verykools5528Jr",
    "Device": "verykools5528Jr",
    "Model": "verykools5528Jr"
  },
  {
    "Retail Branding": "Verykool",
    "Marketing Name": "verykools5702",
    "Device": "verykools5702",
    "Model": "verykools5702"
  },
  {
    "Retail Branding": "Vestel",
    "Marketing Name": 5000,
    "Device": "Leo",
    "Model": "Vestel_5000"
  },
  {
    "Retail Branding": "Vestel",
    "Marketing Name": 5000,
    "Device": "Leo",
    "Model": "Vestel_5000_Dual"
  },
  {
    "Retail Branding": "Vestel",
    "Marketing Name": 5530,
    "Device": "Pars",
    "Model": "Vestel_5530"
  },
  {
    "Retail Branding": "Vestel",
    "Marketing Name": 5530,
    "Device": "Pars",
    "Model": "Vestel_5530_Dual"
  },
  {
    "Retail Branding": "Vestel",
    "Marketing Name": "ARWEN",
    "Device": "ARWEN",
    "Model": "V TAB Z1 PRO"
  },
  {
    "Retail Branding": "Vestel",
    "Marketing Name": "Farabi",
    "Device": "frb3g",
    "Model": "Farabi"
  },
  {
    "Retail Branding": "Vestel",
    "Marketing Name": "Leo_2GB",
    "Device": "Leo_2GB",
    "Model": "Vestel_5000_2gb"
  },
  {
    "Retail Branding": "Vestel",
    "Marketing Name": "S7252",
    "Device": "BCM7252S",
    "Model": "S7252"
  },
  {
    "Retail Branding": "Vestel",
    "Marketing Name": "V TAB 7\" LITE II",
    "Device": "V_TAB_7_LITE_II",
    "Model": "VTAB7LITEII"
  },
  {
    "Retail Branding": "Vestel",
    "Marketing Name": "V TAB 7\\'\\' LITE II",
    "Device": "V_TAB_7_LITE_II",
    "Model": "V_TAB_7_LITE_II"
  },
  {
    "Retail Branding": "Vestel",
    "Marketing Name": "V TAB 7011",
    "Device": "V_TAB_7011",
    "Model": "V_TAB_7011"
  },
  {
    "Retail Branding": "Vestel",
    "Marketing Name": "V TAB 7015",
    "Device": "V_TAB_7015",
    "Model": "V_TAB_7015"
  },
  {
    "Retail Branding": "Vestel",
    "Marketing Name": "V TAB 7020",
    "Device": "V_TAB_7020",
    "Model": "V_TAB_7020"
  },
  {
    "Retail Branding": "Vestel",
    "Marketing Name": "V TAB 7020A",
    "Device": "V_TAB_7020A",
    "Model": "V_TAB_7020A"
  },
  {
    "Retail Branding": "Vestel",
    "Marketing Name": "V TAB 7020B",
    "Device": "V_TAB_7020B",
    "Model": "V_TAB_7020B"
  },
  {
    "Retail Branding": "Vestel",
    "Marketing Name": "V TAB 7025",
    "Device": "V_TAB_7025",
    "Model": "V_TAB_7025"
  },
  {
    "Retail Branding": "Vestel",
    "Marketing Name": "V TAB 7810",
    "Device": "V_TAB_7810",
    "Model": "V_TAB_7810"
  },
  {
    "Retail Branding": "Vestel",
    "Marketing Name": "V TAB 8010",
    "Device": "V_TAB_8010",
    "Model": "V_TAB_8010"
  },
  {
    "Retail Branding": "Vestel",
    "Marketing Name": "V TAB 8029",
    "Device": "V_TAB_8029",
    "Model": "V TAB 8029"
  },
  {
    "Retail Branding": "Vestel",
    "Marketing Name": "V TAB 9.7\\'\\' PRO",
    "Device": "VT97PRO",
    "Model": "VT97PRO"
  },
  {
    "Retail Branding": "Vestel",
    "Marketing Name": "V TAB Z1",
    "Device": "ATLAS",
    "Model": "V TAB Z1"
  },
  {
    "Retail Branding": "Vestel",
    "Marketing Name": "V TAB Z2 LTE",
    "Device": "EKVATOR",
    "Model": "V TAB Z2 LTE"
  },
  {
    "Retail Branding": "Vestel",
    "Marketing Name": "V TAB c1",
    "Device": "MELTEM",
    "Model": "V TAB c1"
  },
  {
    "Retail Branding": "Vestel",
    "Marketing Name": "V Tab 7010",
    "Device": "VTab7010",
    "Model": "V Tab 7010"
  },
  {
    "Retail Branding": "Vestel",
    "Marketing Name": "V3 5580 Dual",
    "Device": "Orsa",
    "Model": "V3_5580_Dual"
  },
  {
    "Retail Branding": "Vestel",
    "Marketing Name": "VP100+",
    "Device": "ephesus",
    "Model": "10.1Myros"
  },
  {
    "Retail Branding": "Vestel",
    "Marketing Name": "VP100+",
    "Device": "ephesus",
    "Model": "VP100+"
  },
  {
    "Retail Branding": "Vestel",
    "Marketing Name": "VP73",
    "Device": "wing-ibt",
    "Model": "VP73"
  },
  {
    "Retail Branding": "Vestel",
    "Marketing Name": "VP73",
    "Device": "wing-ibt",
    "Model": "VP73_Hyundai"
  },
  {
    "Retail Branding": "Vestel",
    "Marketing Name": "VP73",
    "Device": "wing-ibt",
    "Model": "VP73_Myros"
  },
  {
    "Retail Branding": "Vestel",
    "Marketing Name": "VP73",
    "Device": "wing-ibt",
    "Model": "VP73_Vox"
  },
  {
    "Retail Branding": "Vestel",
    "Marketing Name": "VP73",
    "Device": "wing-ibt",
    "Model": "VP73_le"
  },
  {
    "Retail Branding": "Vestel",
    "Marketing Name": "VP74",
    "Device": "wifionly-gms",
    "Model": "VP74"
  },
  {
    "Retail Branding": "Vestel",
    "Marketing Name": "VP74",
    "Device": "wifionly-gms",
    "Model": "VP74-Celcus"
  },
  {
    "Retail Branding": "Vestel",
    "Marketing Name": "VP74",
    "Device": "wifionly-gms",
    "Model": "VP74-Finlux"
  },
  {
    "Retail Branding": "Vestel",
    "Marketing Name": "VP74",
    "Device": "wifionly-gms",
    "Model": "VP74-Luxor"
  },
  {
    "Retail Branding": "Vestel",
    "Marketing Name": "VP74",
    "Device": "wifionly-gms",
    "Model": "VP74-Orava"
  },
  {
    "Retail Branding": "Vestel",
    "Marketing Name": "VP74",
    "Device": "wifionly-gms",
    "Model": "VP74-Telefunken"
  },
  {
    "Retail Branding": "Vestel",
    "Marketing Name": "VP74",
    "Device": "wifionly-gms",
    "Model": "VP74-Vox"
  },
  {
    "Retail Branding": "Vestel",
    "Marketing Name": "VSP145M",
    "Device": "VSP145M",
    "Model": "VSP145M"
  },
  {
    "Retail Branding": "Vestel",
    "Marketing Name": "VSP250g",
    "Device": "VSP250g",
    "Model": "VSP250g"
  },
  {
    "Retail Branding": "Vestel",
    "Marketing Name": "VSP250s",
    "Device": "VSP250s",
    "Model": "VSP250s"
  },
  {
    "Retail Branding": "Vestel",
    "Marketing Name": "VSP355g",
    "Device": "g55",
    "Model": "VSP355g"
  },
  {
    "Retail Branding": "Vestel",
    "Marketing Name": "VSP355s",
    "Device": "s55",
    "Model": "VSP355s"
  },
  {
    "Retail Branding": "Vestel",
    "Marketing Name": "VT10E",
    "Device": "VT10E",
    "Model": "VT10E"
  },
  {
    "Retail Branding": "Vestel",
    "Marketing Name": "VT10E2",
    "Device": "VT10E2",
    "Model": "S TAB 10\\'\\' II"
  },
  {
    "Retail Branding": "Vestel",
    "Marketing Name": "VT10E2",
    "Device": "VT10E2",
    "Model": "V TAB 10\\'\\' LITE"
  },
  {
    "Retail Branding": "Vestel",
    "Marketing Name": "VT10E2",
    "Device": "VT10E2",
    "Model": "VT10E2"
  },
  {
    "Retail Branding": "Vestel",
    "Marketing Name": "VT785P2",
    "Device": "VT785P2",
    "Model": "V TAB 7.85\\'\\' LITE"
  },
  {
    "Retail Branding": "Vestel",
    "Marketing Name": "VT785P2",
    "Device": "VT785P2",
    "Model": "VT785P2-Celcus"
  },
  {
    "Retail Branding": "Vestel",
    "Marketing Name": "VT785P2",
    "Device": "VT785P2",
    "Model": "VT785P2-Cleverpad"
  },
  {
    "Retail Branding": "Vestel",
    "Marketing Name": "VT785P2",
    "Device": "VT785P2",
    "Model": "VT785P2-Finlux"
  },
  {
    "Retail Branding": "Vestel",
    "Marketing Name": "VT785P2",
    "Device": "VT785P2",
    "Model": "VT785P2-Vestel"
  },
  {
    "Retail Branding": "Vestel",
    "Marketing Name": "VTAB 1040",
    "Device": "V_TAB_1040",
    "Model": "V_TAB_1040"
  },
  {
    "Retail Branding": "Vestel",
    "Marketing Name": "VTAB 7040",
    "Device": "V_TAB_7040",
    "Model": "V_TAB_7040"
  },
  {
    "Retail Branding": "Vestel",
    "Marketing Name": "VTAB 8059",
    "Device": "V_TAB_8059",
    "Model": "V_TAB_8059"
  },
  {
    "Retail Branding": "Vestel",
    "Marketing Name": "VTAB1049",
    "Device": "V_TAB_1049",
    "Model": "V_TAB_1049"
  },
  {
    "Retail Branding": "Vestel",
    "Marketing Name": "VTAB1050",
    "Device": "V_TAB_1050",
    "Model": "V_TAB_1050"
  },
  {
    "Retail Branding": "Vestel",
    "Marketing Name": "VTAB1069",
    "Device": "V_TAB_1069",
    "Model": "V_TAB_1069"
  },
  {
    "Retail Branding": "Vestel",
    "Marketing Name": "VTABZ1A",
    "Device": "VTABZ1A",
    "Model": "V TAB Z1 A"
  },
  {
    "Retail Branding": "Vestel",
    "Marketing Name": "VTABZ2A",
    "Device": "VTABZ2A",
    "Model": "V Tab Z2 LTE A"
  },
  {
    "Retail Branding": "Vestel",
    "Marketing Name": "V_TAB_7030",
    "Device": "V_TAB_7030",
    "Model": "V_TAB_7030"
  },
  {
    "Retail Branding": "Vestel",
    "Marketing Name": "Venus E2 Plus",
    "Device": "Ada",
    "Model": "Venus E2 Plus"
  },
  {
    "Retail Branding": "Vestel",
    "Marketing Name": "Venus E3",
    "Device": "Riga",
    "Model": "Venus E3"
  },
  {
    "Retail Branding": "Vestel",
    "Marketing Name": "Venus E4",
    "Device": "Truva",
    "Model": "Venus E4"
  },
  {
    "Retail Branding": "Vestel",
    "Marketing Name": "Venus E5",
    "Device": "Lodos",
    "Model": "Venus e5"
  },
  {
    "Retail Branding": "Vestel",
    "Marketing Name": "Venus Go",
    "Device": "AdaGo",
    "Model": "Venus GO"
  },
  {
    "Retail Branding": "Vestel",
    "Marketing Name": "Venus V3 5020",
    "Device": "Arya",
    "Model": "Venus_V3_5020"
  },
  {
    "Retail Branding": "Vestel",
    "Marketing Name": "Venus V3 5030",
    "Device": "Dyno",
    "Model": "Venus_V3_5030"
  },
  {
    "Retail Branding": "Vestel",
    "Marketing Name": "Venus V3 5040",
    "Device": "Venus_V3_5040",
    "Model": "Venus_V3_5040"
  },
  {
    "Retail Branding": "Vestel",
    "Marketing Name": "Venus V3 5040",
    "Device": "Venus_V3_5045",
    "Model": "Venus_V3_5040_2GB"
  },
  {
    "Retail Branding": "Vestel",
    "Marketing Name": "Venus V3 5070",
    "Device": "Venus_V3_5070",
    "Model": "Venus_V3_5070"
  },
  {
    "Retail Branding": "Vestel",
    "Marketing Name": "Venus V3 5570",
    "Device": "Venus_V3_5570",
    "Model": "Venus_V3_5570"
  },
  {
    "Retail Branding": "Vestel",
    "Marketing Name": "Venus V3 5580",
    "Device": "Orsa",
    "Model": "Venus_V3_5580"
  },
  {
    "Retail Branding": "Vestel",
    "Marketing Name": "Venus V5",
    "Device": "Teos",
    "Model": "Venus V5"
  },
  {
    "Retail Branding": "Vestel",
    "Marketing Name": "Venus V6 S",
    "Device": "Iletee",
    "Model": "V6S"
  },
  {
    "Retail Branding": "Vestel",
    "Marketing Name": "Venus V7",
    "Device": "Pardus",
    "Model": "Venus V7"
  },
  {
    "Retail Branding": "Vestel",
    "Marketing Name": "Venus Z10",
    "Device": "Reys",
    "Model": "Venus Z10"
  },
  {
    "Retail Branding": "Vestel",
    "Marketing Name": "Venus Z30",
    "Device": "Troia",
    "Model": "Venus Z30"
  },
  {
    "Retail Branding": "Vestel",
    "Marketing Name": "Venus Z40",
    "Device": "Poyraz",
    "Model": "Venus Z40"
  },
  {
    "Retail Branding": "Vestel",
    "Marketing Name": "Venus_V3_5040_2GB",
    "Device": "Venus_V3_5045",
    "Model": "Venus_V3_5040_2GB"
  },
  {
    "Retail Branding": "Vestel",
    "Marketing Name": "Venus_V4",
    "Device": "V4",
    "Model": "Venus_V4"
  },
  {
    "Retail Branding": "Vestel",
    "Marketing Name": "Vestel Z20",
    "Device": "Cunda",
    "Model": "Venus Z20"
  },
  {
    "Retail Branding": "Vestel",
    "Marketing Name": "Vestel_5000_2gb",
    "Device": "Leo_2GB",
    "Model": "Vestel_5000_2gb"
  },
  {
    "Retail Branding": "Vestel",
    "Marketing Name": "venus_v3_5010",
    "Device": "DynoLight",
    "Model": "Venus_V3_5010"
  },
  {
    "Retail Branding": "Vexia",
    "Marketing Name": "NicatabletV3",
    "Device": "NicatabletV3",
    "Model": "NicatabletV3"
  },
  {
    "Retail Branding": "Vexia",
    "Marketing Name": "Vexia FCS E2 CLM",
    "Device": "Vexia_FCS_E2_CLM",
    "Model": "Vexia FCS E2 CLM"
  },
  {
    "Retail Branding": "Vexia",
    "Marketing Name": "Vexia_TRES_10",
    "Device": "Vexia_TRES_10",
    "Model": "Vexia_TRES_10"
  },
  {
    "Retail Branding": "VfonX",
    "Marketing Name": "GP8",
    "Device": "GP8",
    "Model": "GP8"
  },
  {
    "Retail Branding": "Vgo Tel",
    "Marketing Name": "Flex_2",
    "Device": "Flex_2",
    "Model": "Flex 2"
  },
  {
    "Retail Branding": "Vgo Tel",
    "Marketing Name": "Flex_3",
    "Device": "Flex_3",
    "Model": "Flex 3"
  },
  {
    "Retail Branding": "Vgo Tel",
    "Marketing Name": "NEW 10",
    "Device": "NEW_10",
    "Model": "NEW 10"
  },
  {
    "Retail Branding": "Vgo Tel",
    "Marketing Name": "NEW 11",
    "Device": "Smartphone",
    "Model": "NEW 11"
  },
  {
    "Retail Branding": "Vgo Tel",
    "Marketing Name": "NEW 15",
    "Device": "NEW_15",
    "Model": "NEW 15"
  },
  {
    "Retail Branding": "Vgo Tel",
    "Marketing Name": "NEW 15 Pro",
    "Device": "NEW_15_Pro",
    "Model": "NEW 15 Pro"
  },
  {
    "Retail Branding": "Vgo Tel",
    "Marketing Name": "NEW 17",
    "Device": "NEW_17",
    "Model": "NEW 17"
  },
  {
    "Retail Branding": "Vgo Tel",
    "Marketing Name": "NEW 24",
    "Device": "NEW_24",
    "Model": "NEW 24"
  },
  {
    "Retail Branding": "Vgo Tel",
    "Marketing Name": "NEW 25",
    "Device": "NEW_25",
    "Model": "NEW 25"
  },
  {
    "Retail Branding": "Vgo Tel",
    "Marketing Name": "NEW 26",
    "Device": "NEW_26",
    "Model": "NEW 26"
  },
  {
    "Retail Branding": "Vgo Tel",
    "Marketing Name": "NEW 26 Lite",
    "Device": "NEW_26_Lite",
    "Model": "NEW 26 Lite"
  },
  {
    "Retail Branding": "Vgo Tel",
    "Marketing Name": "NEW 7",
    "Device": "NEW_7",
    "Model": "NEW 7"
  },
  {
    "Retail Branding": "Vgo Tel",
    "Marketing Name": "NEW_16_PRO",
    "Device": "NEW_16_PRO",
    "Model": "NEW 16 PRO"
  },
  {
    "Retail Branding": "Vgo Tel",
    "Marketing Name": "NEW_20",
    "Device": "NEW_20",
    "Model": "NEW 20"
  },
  {
    "Retail Branding": "Vgo Tel",
    "Marketing Name": "NOTE 24",
    "Device": "NOTE_24",
    "Model": "NOTE 24"
  },
  {
    "Retail Branding": "Vgo Tel",
    "Marketing Name": "NOTE_23_V02",
    "Device": "NOTE_23",
    "Model": "NOTE 23"
  },
  {
    "Retail Branding": "Vgo Tel",
    "Marketing Name": "New 5",
    "Device": "NEW_5",
    "Model": "NEW 5"
  },
  {
    "Retail Branding": "Vgo Tel",
    "Marketing Name": "OCEAN 6",
    "Device": "VGOTEL_OCEAN_6",
    "Model": "Ocean 6"
  },
  {
    "Retail Branding": "Vgo Tel",
    "Marketing Name": "Ocean 8",
    "Device": "Ocean_8",
    "Model": "Ocean_8"
  },
  {
    "Retail Branding": "Vgo Tel",
    "Marketing Name": "Ocean 9",
    "Device": "Ocean_9",
    "Model": "Ocean_9"
  },
  {
    "Retail Branding": "Vgo Tel",
    "Marketing Name": "Ocean9L",
    "Device": "Ocean9L",
    "Model": "Ocean9L"
  },
  {
    "Retail Branding": "Vgo Tel",
    "Marketing Name": "SMART 12",
    "Device": "SMART_12",
    "Model": "SMART 12"
  },
  {
    "Retail Branding": "Vgo Tel",
    "Marketing Name": "SMART 13",
    "Device": "SMART_13",
    "Model": "SMART 13"
  },
  {
    "Retail Branding": "Vgo Tel",
    "Marketing Name": "SMART 8",
    "Device": "SMART_8",
    "Model": "SMART 8"
  },
  {
    "Retail Branding": "Vgo Tel",
    "Marketing Name": "SMART 8 Go",
    "Device": "SMART_8_Go",
    "Model": "SMART 8 Go"
  },
  {
    "Retail Branding": "Vgo Tel",
    "Marketing Name": "SMART 9 PRO",
    "Device": "SMART_9_PRO",
    "Model": "SMART_9_PRO"
  },
  {
    "Retail Branding": "Vgo Tel",
    "Marketing Name": "Smart 2",
    "Device": "Smart_2",
    "Model": "Smart 2"
  },
  {
    "Retail Branding": "Vgo Tel",
    "Marketing Name": "Smart 4",
    "Device": "Smart_4",
    "Model": "Smart 4"
  },
  {
    "Retail Branding": "Vgo Tel",
    "Marketing Name": "Smart 5",
    "Device": "Smart_5",
    "Model": "Smart 5"
  },
  {
    "Retail Branding": "Vgo Tel",
    "Marketing Name": "Smart 7",
    "Device": "Smart_7",
    "Model": "Smart 7"
  },
  {
    "Retail Branding": "Vgo Tel",
    "Marketing Name": "VENTURE V12",
    "Device": "Venture_V12",
    "Model": "Venture V12"
  },
  {
    "Retail Branding": "Vgo Tel",
    "Marketing Name": "VTAB2_3G",
    "Device": "VTAB2_3G",
    "Model": "V TAB 2"
  },
  {
    "Retail Branding": "Vgo Tel",
    "Marketing Name": "Venture V8",
    "Device": "VentureV8",
    "Model": "Venture V8"
  },
  {
    "Retail Branding": "Vgo Tel",
    "Marketing Name": "VentureV10",
    "Device": "VentureV10",
    "Model": "VentureV10"
  },
  {
    "Retail Branding": "Vgo Tel",
    "Marketing Name": "i Smart",
    "Device": "i_Smart",
    "Model": "i_Smart"
  },
  {
    "Retail Branding": "ViMASS",
    "Marketing Name": "VPhone_22",
    "Device": "VPhone_22",
    "Model": "VPhone 22"
  },
  {
    "Retail Branding": "ViMa-Tek",
    "Marketing Name": "VM20",
    "Device": "VM20",
    "Model": "VM20"
  },
  {
    "Retail Branding": "Victurio",
    "Marketing Name": "VI106",
    "Device": "VI106",
    "Model": "VI106"
  },
  {
    "Retail Branding": "Victurio",
    "Marketing Name": "VI108",
    "Device": "VI108",
    "Model": "VI108"
  },
  {
    "Retail Branding": "Victurio",
    "Marketing Name": "VI86",
    "Device": "VI86",
    "Model": "VI86"
  },
  {
    "Retail Branding": "Victurio",
    "Marketing Name": "VI87",
    "Device": "VI87",
    "Model": "VI87"
  },
  {
    "Retail Branding": "Vida",
    "Marketing Name": "EGO_plus",
    "Device": "EGO_plus",
    "Model": "EGO plus"
  },
  {
    "Retail Branding": "Vida",
    "Marketing Name": "GINI_D9",
    "Device": "GINI_D9",
    "Model": "GINI_D9"
  },
  {
    "Retail Branding": "Vida",
    "Marketing Name": "ORION",
    "Device": "ORION",
    "Model": "ORION"
  },
  {
    "Retail Branding": "Vida",
    "Marketing Name": "S63Plus",
    "Device": "S63Plus",
    "Model": "S63Plus"
  },
  {
    "Retail Branding": "Vida",
    "Marketing Name": "V401",
    "Device": "VIDA_V401",
    "Model": "VIDA-V401"
  },
  {
    "Retail Branding": "Vida",
    "Marketing Name": "V555K",
    "Device": "V555K",
    "Model": "V555K"
  },
  {
    "Retail Branding": "Vida",
    "Marketing Name": "VIDA - i512",
    "Device": "i512",
    "Model": "VIDA_i512"
  },
  {
    "Retail Branding": "Vida",
    "Marketing Name": "VIDA_V555Plus",
    "Device": "VIDA_V555Plus",
    "Model": "VIDA_V555Plus"
  },
  {
    "Retail Branding": "Vida",
    "Marketing Name": "VIDA_i450",
    "Device": "VIDA_i450",
    "Model": "VIDA_i450"
  },
  {
    "Retail Branding": "Vida",
    "Marketing Name": "VIDA_i501",
    "Device": "VIDA_i501",
    "Model": "VIDA_i501"
  },
  {
    "Retail Branding": "Vida",
    "Marketing Name": "i-450",
    "Device": "i-450",
    "Model": "i-450"
  },
  {
    "Retail Branding": "Vida",
    "Marketing Name": "i401",
    "Device": "VIDA-i401",
    "Model": "VIDA-i401"
  },
  {
    "Retail Branding": "Viettel",
    "Marketing Name": "B866V2",
    "Device": "MediaBox_B866V2",
    "Model": "B866V2"
  },
  {
    "Retail Branding": "Viettel",
    "Marketing Name": "V8802",
    "Device": "V8802",
    "Model": "V8802"
  },
  {
    "Retail Branding": "Viettel",
    "Marketing Name": "ViettelTV 4K BOX",
    "Device": "VTTV-SD4K-20",
    "Model": "ViettelTV 4K BOX"
  },
  {
    "Retail Branding": "Viettel",
    "Marketing Name": "ViettelTV 4K Box",
    "Device": "HP40A",
    "Model": "ViettelTV 4K Box"
  },
  {
    "Retail Branding": "ViewSonic",
    "Marketing Name": "",
    "Device": "ViewPad_IR10Q",
    "Model": "IR10Q"
  },
  {
    "Retail Branding": "ViewSonic",
    "Marketing Name": "",
    "Device": "ViewPad_IR8Q",
    "Model": "IR8Q"
  },
  {
    "Retail Branding": "ViewSonic",
    "Marketing Name": "",
    "Device": "v350",
    "Model": "ViewSonic-V350"
  },
  {
    "Retail Branding": "ViewSonic",
    "Marketing Name": "",
    "Device": "viewpad4",
    "Model": "ViewSonic-ViewPad4"
  },
  {
    "Retail Branding": "ViewSonic",
    "Marketing Name": "",
    "Device": "viewpad7",
    "Model": "ViewPad7"
  },
  {
    "Retail Branding": "ViewSonic",
    "Marketing Name": "",
    "Device": "viewpad7x",
    "Model": "ViewPad7X"
  },
  {
    "Retail Branding": "ViewSonic",
    "Marketing Name": "",
    "Device": "viewpad7x",
    "Model": "ViewPad7x"
  },
  {
    "Retail Branding": "ViewSonic",
    "Marketing Name": "IFP34",
    "Device": "IFP34",
    "Model": "IFP34"
  },
  {
    "Retail Branding": "ViewSonic",
    "Marketing Name": "IFP41_1_Series",
    "Device": "IFP41_1",
    "Model": "IFP41_1"
  },
  {
    "Retail Branding": "ViewSonic",
    "Marketing Name": "IFP51_Series",
    "Device": "IFP51",
    "Model": "IFP51"
  },
  {
    "Retail Branding": "ViewSonic",
    "Marketing Name": "IFP53_Series",
    "Device": "IFP53",
    "Model": "IFP53"
  },
  {
    "Retail Branding": "ViewSonic",
    "Marketing Name": "IFP63 Series",
    "Device": "IFP63",
    "Model": "IFP63"
  },
  {
    "Retail Branding": "ViewSonic",
    "Marketing Name": "IFP8652-2",
    "Device": "IFP8652-2",
    "Model": "IFP8652-2"
  },
  {
    "Retail Branding": "ViewSonic",
    "Marketing Name": "IN01_2_1N",
    "Device": "IN01_2_1N",
    "Model": "IN01_2_1N"
  },
  {
    "Retail Branding": "ViewSonic",
    "Marketing Name": "IN02 series",
    "Device": "IN02_series",
    "Model": "IN02_series"
  },
  {
    "Retail Branding": "ViewSonic",
    "Marketing Name": "IN03_Series",
    "Device": "IN03",
    "Model": "IN03"
  },
  {
    "Retail Branding": "ViewSonic",
    "Marketing Name": "IN05_Series",
    "Device": "INxx05",
    "Model": "INxx05"
  },
  {
    "Retail Branding": "ViewSonic",
    "Marketing Name": "IN21C_Series",
    "Device": "IN21C",
    "Model": "IN21C"
  },
  {
    "Retail Branding": "ViewSonic",
    "Marketing Name": "Q5",
    "Device": "Q5",
    "Model": "Viewphone Q5"
  },
  {
    "Retail Branding": "ViewSonic",
    "Marketing Name": "VIEWSONIC",
    "Device": "VIEWPAD_AW7M_PLUS",
    "Model": "VIEWPAD_AW7M_PLUS"
  },
  {
    "Retail Branding": "ViewSonic",
    "Marketing Name": "VPC-A31-O1",
    "Device": "VPC-A31-O1",
    "Model": "VPC-A31-O1"
  },
  {
    "Retail Branding": "ViewSonic",
    "Marketing Name": "VSD221",
    "Device": "VSD221",
    "Model": "VSD221"
  },
  {
    "Retail Branding": "ViewSonic",
    "Marketing Name": "VSD231",
    "Device": "VSD231-VSA",
    "Model": "VSD231"
  },
  {
    "Retail Branding": "ViewSonic",
    "Marketing Name": "VSD241 Smart Display",
    "Device": "VSD241",
    "Model": "VSD241"
  },
  {
    "Retail Branding": "ViewSonic",
    "Marketing Name": "VSD242",
    "Device": "VSD242",
    "Model": "VSD242"
  },
  {
    "Retail Branding": "ViewSonic",
    "Marketing Name": "VS_EDLA_Box",
    "Device": "rk3588_t",
    "Model": "VS_EDLA_Box"
  },
  {
    "Retail Branding": "ViewSonic",
    "Marketing Name": "ViewPad I7M",
    "Device": "VIEWPAD",
    "Model": "VIEWPAD I7M"
  },
  {
    "Retail Branding": "ViewSonic",
    "Marketing Name": "ViewPad IR7Q",
    "Device": "IR7Q",
    "Model": "IR7Q"
  },
  {
    "Retail Branding": "ViewSonic",
    "Marketing Name": "ViewPad_M10",
    "Device": "mid1016_ma",
    "Model": "ViewPad_M10"
  },
  {
    "Retail Branding": "ViewSonic",
    "Marketing Name": "ViewPad_M10_2_32",
    "Device": "mid1032_mk",
    "Model": "ViewPad M10-2/32"
  },
  {
    "Retail Branding": "ViewSonic",
    "Marketing Name": "ViewPad_M7_2_32",
    "Device": "mid7015_mk_32",
    "Model": "ViewPad M7-2/32"
  },
  {
    "Retail Branding": "ViewSonic",
    "Marketing Name": "ViewPadi7Q",
    "Device": "vsi7q_1_coho",
    "Model": "vsi7q_1"
  },
  {
    "Retail Branding": "ViewSonic",
    "Marketing Name": "ViewPadi7Q",
    "Device": "vsi7q_1_coho",
    "Model": "vsi7q_1_coho"
  },
  {
    "Retail Branding": "ViewSonic",
    "Marketing Name": "ViewPadi8Q",
    "Device": "vsi8q_1_coho",
    "Model": "vsi8q_1"
  },
  {
    "Retail Branding": "ViewSonic",
    "Marketing Name": "ViewPadi8Q",
    "Device": "vsi8q_1_coho",
    "Model": "vsi8q_1_coho"
  },
  {
    "Retail Branding": "ViewSonic",
    "Marketing Name": "Viewsonic Technologies  India private Limited",
    "Device": "chester",
    "Model": "ViewSonic smart"
  },
  {
    "Retail Branding": "ViewSonic",
    "Marketing Name": "Viewsonic Technologies  India private Limited",
    "Device": "landen",
    "Model": "ViewSonic Smart"
  },
  {
    "Retail Branding": "ViewZ",
    "Marketing Name": "VZ-24IPM",
    "Device": "VZ-24IPM",
    "Model": "VZ-24IPM"
  },
  {
    "Retail Branding": "VigorPhone",
    "Marketing Name": "Vigor17",
    "Device": "eraser",
    "Model": "Vigor17"
  },
  {
    "Retail Branding": "Virse",
    "Marketing Name": "E95",
    "Device": "E95",
    "Model": "E95"
  },
  {
    "Retail Branding": "Virtual",
    "Marketing Name": "Interactive-Flat-Panel",
    "Device": "Interactive-Flat-Panel",
    "Model": "Interactive Flat Panel"
  },
  {
    "Retail Branding": "Virzo",
    "Marketing Name": "V501C",
    "Device": "V501C",
    "Model": "V501C"
  },
  {
    "Retail Branding": "Virzo",
    "Marketing Name": "V505c",
    "Device": "V505c",
    "Model": "V505c"
  },
  {
    "Retail Branding": "Virzo",
    "Marketing Name": "V511",
    "Device": "V511",
    "Model": "V511"
  },
  {
    "Retail Branding": "Virzo",
    "Marketing Name": "V608C",
    "Device": "V608C",
    "Model": "V608C"
  },
  {
    "Retail Branding": "Virzo",
    "Marketing Name": "V608C",
    "Device": "V608_C",
    "Model": "V608C"
  },
  {
    "Retail Branding": "Virzo",
    "Marketing Name": "VT1001",
    "Device": "VT1001",
    "Model": "VT1001"
  },
  {
    "Retail Branding": "Virzo",
    "Marketing Name": "VT701",
    "Device": "VT701",
    "Model": "VT701"
  },
  {
    "Retail Branding": "Vise",
    "Marketing Name": "32VRCHG5SP",
    "Device": "ikebukuro",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "Vise",
    "Marketing Name": "R3",
    "Device": "R3",
    "Model": "R3"
  },
  {
    "Retail Branding": "Vise",
    "Marketing Name": "R4",
    "Device": "R4",
    "Model": "R4"
  },
  {
    "Retail Branding": "Vision",
    "Marketing Name": "B866V2",
    "Device": "MediaBox_B866V2",
    "Model": "B866V2"
  },
  {
    "Retail Branding": "Vision",
    "Marketing Name": "B866V2F",
    "Device": "B866V2F",
    "Model": "B866V2F"
  },
  {
    "Retail Branding": "Vision",
    "Marketing Name": "Bangladesh",
    "Device": "guandu",
    "Model": "Vision Android TV"
  },
  {
    "Retail Branding": "Vision",
    "Marketing Name": "Bangladesh",
    "Device": "sepolia",
    "Model": "VISION 4K Google TV"
  },
  {
    "Retail Branding": "Vision",
    "Marketing Name": "Bangladesh",
    "Device": "tamachi",
    "Model": "Vision FHD Android TV"
  },
  {
    "Retail Branding": "Vision",
    "Marketing Name": "EU、UK、AP",
    "Device": "martin",
    "Model": "Vision Android TV"
  },
  {
    "Retail Branding": "Vision",
    "Marketing Name": "VISION",
    "Device": "shibuya",
    "Model": "VISION"
  },
  {
    "Retail Branding": "Vision",
    "Marketing Name": "VISION 2K Google TV",
    "Device": "dongnae",
    "Model": "VISION 2K Google TV"
  },
  {
    "Retail Branding": "Vision",
    "Marketing Name": "VISION 2K SMART TV",
    "Device": "nagata",
    "Model": "VISION 2K SMART TV"
  },
  {
    "Retail Branding": "Vision",
    "Marketing Name": "VISION 4K SMART TV",
    "Device": "marina",
    "Model": "VISION 4K SMART TV"
  },
  {
    "Retail Branding": "Vision",
    "Marketing Name": "VISION GALAXY 4K TV",
    "Device": "eleonas",
    "Model": "VISION GALAXY 4K TV"
  },
  {
    "Retail Branding": "Vision",
    "Marketing Name": "VISION GALAXY 4K TV FF",
    "Device": "eleonas",
    "Model": "VISION GALAXY 4K TV FF"
  },
  {
    "Retail Branding": "Vision",
    "Marketing Name": "VISION GSMART 2KTV",
    "Device": "umeda",
    "Model": "VISION GSMART 2KTV"
  },
  {
    "Retail Branding": "Vision",
    "Marketing Name": "VISION GSMART 4KTV",
    "Device": "SW6H",
    "Model": "VISION GSMART 4KTV"
  },
  {
    "Retail Branding": "Vision",
    "Marketing Name": "VISION GSMART 4KTV FF",
    "Device": "SW6H",
    "Model": "VISION GSMART 4KTV FF"
  },
  {
    "Retail Branding": "Vision",
    "Marketing Name": "VISION GSMART 4KTV FF",
    "Device": "anaheim",
    "Model": "VISION GSMART 4KTV FF"
  },
  {
    "Retail Branding": "Vision",
    "Marketing Name": "VISION LED TV",
    "Device": "beomil",
    "Model": "VISION LED TV"
  },
  {
    "Retail Branding": "Vision",
    "Marketing Name": "VISION SMART TV",
    "Device": "SW4H",
    "Model": "VISION SMART TV"
  },
  {
    "Retail Branding": "Vision",
    "Marketing Name": "Vision G 4K dongle",
    "Device": "YQX",
    "Model": "Vision G 4K dongle"
  },
  {
    "Retail Branding": "Vision",
    "Marketing Name": "Vision V1",
    "Device": "VISION_V1",
    "Model": "V1"
  },
  {
    "Retail Branding": "Vision Technology",
    "Marketing Name": "2K SMART TV",
    "Device": "nagata",
    "Model": "2K SMART TV"
  },
  {
    "Retail Branding": "Vision Technology",
    "Marketing Name": "Android TV",
    "Device": "R1",
    "Model": "ATV R1"
  },
  {
    "Retail Branding": "Vision Technology",
    "Marketing Name": "Android TV",
    "Device": "R2",
    "Model": "ATV R2"
  },
  {
    "Retail Branding": "Vision Technology",
    "Marketing Name": "R3",
    "Device": "R3",
    "Model": "R3"
  },
  {
    "Retail Branding": "Vision Technology",
    "Marketing Name": "R4",
    "Device": "R4",
    "Model": "R4"
  },
  {
    "Retail Branding": "Visiontech",
    "Marketing Name": 100011885,
    "Device": 100011885,
    "Model": 100011885
  },
  {
    "Retail Branding": "Visiontech",
    "Marketing Name": "4K SMART TV",
    "Device": "marina",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "Visiontech",
    "Marketing Name": "PVT-8-A50-R1",
    "Device": "PVT-8-A50-R1",
    "Model": "PVT-8-A50-R1"
  },
  {
    "Retail Branding": "Visiontouch",
    "Marketing Name": "Inspire",
    "Device": "VisionTouchInspire",
    "Model": "Vision Touch Inspire"
  },
  {
    "Retail Branding": "Visiontouch",
    "Marketing Name": "Life",
    "Device": "VisionTouchLife",
    "Model": "VisionTouchLife"
  },
  {
    "Retail Branding": "Visual Land",
    "Marketing Name": "10QH_Plus",
    "Device": "Prestige_10QH_Plus",
    "Model": "Prestige_10QH_Plus"
  },
  {
    "Retail Branding": "Visual Land",
    "Marketing Name": "Elite10QH",
    "Device": "Elite10QH",
    "Model": "Elite10QH"
  },
  {
    "Retail Branding": "Visual Land",
    "Marketing Name": "Elite10QHPro",
    "Device": "Elite10QHPro",
    "Model": "Elite10QHPro"
  },
  {
    "Retail Branding": "Visual Land",
    "Marketing Name": "P10_Plus",
    "Device": "Prestige_P10_Plus",
    "Model": "Prestige_P10_Plus"
  },
  {
    "Retail Branding": "Visual Land",
    "Marketing Name": "P11P",
    "Device": "Prestige_P11_Pro",
    "Model": "Prestige_P11_Pro"
  },
  {
    "Retail Branding": "Visual Land",
    "Marketing Name": "Prestige Elite10QI",
    "Device": "Elite10QI",
    "Model": "Elite10QI"
  },
  {
    "Retail Branding": "Visual Land",
    "Marketing Name": "Prestige Elite10QL",
    "Device": "Elite10QL",
    "Model": "Elite10QL"
  },
  {
    "Retail Branding": "Visual Land",
    "Marketing Name": "Prestige Elite10QS",
    "Device": "Elite10QS",
    "Model": "Elite10QS"
  },
  {
    "Retail Branding": "Visual Land",
    "Marketing Name": "Prestige Elite11Q",
    "Device": "Elite11Q",
    "Model": "Elite11Q"
  },
  {
    "Retail Branding": "Visual Land",
    "Marketing Name": "Prestige Elite13Q",
    "Device": "Elite13Q",
    "Model": "Elite13Q"
  },
  {
    "Retail Branding": "Visual Land",
    "Marketing Name": "Prestige Elite7QL",
    "Device": "Elite7QL",
    "Model": "Elite7QL"
  },
  {
    "Retail Branding": "Visual Land",
    "Marketing Name": "Prestige Elite7QS",
    "Device": "Elite7QS",
    "Model": "Elite7QS"
  },
  {
    "Retail Branding": "Visual Land",
    "Marketing Name": "Prestige Elite8QI",
    "Device": "Elite8QI",
    "Model": "Elite8QI"
  },
  {
    "Retail Branding": "Visual Land",
    "Marketing Name": "Prestige Elite8QL",
    "Device": "Elite8QL",
    "Model": "Elite8QL"
  },
  {
    "Retail Branding": "Visual Land",
    "Marketing Name": "Prestige Elite9QL",
    "Device": "Elite9QL",
    "Model": "Elite9QL"
  },
  {
    "Retail Branding": "Visual Land",
    "Marketing Name": "Prestige Prime10ES",
    "Device": "Prime10ES",
    "Model": "Prime10ES"
  },
  {
    "Retail Branding": "Visual Land",
    "Marketing Name": "Prestige Prime10SE",
    "Device": "Prime10SE",
    "Model": "Prime10SE"
  },
  {
    "Retail Branding": "Visual Land",
    "Marketing Name": "Prestige Prime11E",
    "Device": "Prime11E",
    "Model": "Prime11E"
  },
  {
    "Retail Branding": "Vitsmo",
    "Marketing Name": "Zero Spin",
    "Device": "Zero_Spin",
    "Model": "Zero_Spin"
  },
  {
    "Retail Branding": "Vitumi",
    "Marketing Name": "TV46410B01",
    "Device": "TV46410B01",
    "Model": "Vitumi 10.1"
  },
  {
    "Retail Branding": "Viumee",
    "Marketing Name": "EV5",
    "Device": "EV5",
    "Model": "EV5"
  },
  {
    "Retail Branding": "Viumee",
    "Marketing Name": "EV5 X",
    "Device": "EV5_X",
    "Model": "EV5 X"
  },
  {
    "Retail Branding": "Viumee",
    "Marketing Name": "EV6",
    "Device": "EV6",
    "Model": "EV6"
  },
  {
    "Retail Branding": "Viumee",
    "Marketing Name": "EV6 ELITE",
    "Device": "EV6_ELITE",
    "Model": "EV6 ELITE"
  },
  {
    "Retail Branding": "Viumee",
    "Marketing Name": "EV7",
    "Device": "EV7",
    "Model": "EV7"
  },
  {
    "Retail Branding": "Viumee",
    "Marketing Name": "EV7 Play",
    "Device": "EV7_Play",
    "Model": "EV7_Play"
  },
  {
    "Retail Branding": "Viumee",
    "Marketing Name": "EV7 Pro",
    "Device": "EV7_Pro",
    "Model": "EV7_Pro"
  },
  {
    "Retail Branding": "Viumee",
    "Marketing Name": "SMART EV5",
    "Device": "SMART_EV5",
    "Model": "SMART_EV5"
  },
  {
    "Retail Branding": "Vivax",
    "Marketing Name": "FUN S20",
    "Device": "FUN_S20",
    "Model": "FUN_S20"
  },
  {
    "Retail Branding": "Vivax",
    "Marketing Name": "Point X502",
    "Device": "Point_X502",
    "Model": "Point X502"
  },
  {
    "Retail Branding": "Vivax",
    "Marketing Name": "Point_X2",
    "Device": "Point_X2",
    "Model": "Point_X2"
  },
  {
    "Retail Branding": "Vivax",
    "Marketing Name": "Point_X503",
    "Device": "Point_X503",
    "Model": "Point_X503"
  },
  {
    "Retail Branding": "Vivax",
    "Marketing Name": "Smart TV",
    "Device": "longshan",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "Vivax",
    "Marketing Name": "Smart TV",
    "Device": "longshan",
    "Model": "VIVAX TV"
  },
  {
    "Retail Branding": "Vivax",
    "Marketing Name": "TPC-102_4G_eea",
    "Device": "TPC-102_4G",
    "Model": "VIVAX TPC-102 4G"
  },
  {
    "Retail Branding": "Vivax",
    "Marketing Name": "TPC-704-3G",
    "Device": "TPC-704-3G",
    "Model": "TPC-704-3G"
  },
  {
    "Retail Branding": "Vivax",
    "Marketing Name": "TPC_8043G",
    "Device": "TPC_8043G",
    "Model": "TPC_8043G"
  },
  {
    "Retail Branding": "Vivax",
    "Marketing Name": "TPC_8053G",
    "Device": "TPC_8053G",
    "Model": "TPC_8053G"
  },
  {
    "Retail Branding": "Vivax",
    "Marketing Name": "TPC_8063G",
    "Device": "TPC_8063G",
    "Model": "TPC_8063G"
  },
  {
    "Retail Branding": "Vivax",
    "Marketing Name": "TPC_8074G",
    "Device": "TPC_8074G",
    "Model": "TPC_8074G"
  },
  {
    "Retail Branding": "Vivax",
    "Marketing Name": "VIVAX",
    "Device": "elliniko",
    "Model": "VIVAX SMART TV"
  },
  {
    "Retail Branding": "Vivax",
    "Marketing Name": "VIVAX",
    "Device": "stanford",
    "Model": "2K SMART TV"
  },
  {
    "Retail Branding": "Vivax",
    "Marketing Name": "VIVAX",
    "Device": "zhongshan",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "Vivax",
    "Marketing Name": "VIVAX Fly6",
    "Device": "VIVAX_Fly6",
    "Model": "VIVAX Fly6"
  },
  {
    "Retail Branding": "Vivax",
    "Marketing Name": "VIVAX Fun_S1",
    "Device": "FUN_S1",
    "Model": "FUN S1"
  },
  {
    "Retail Branding": "Vivax",
    "Marketing Name": "VIVAX Point X2 Lite",
    "Device": "VIVAX_Point_X2_Lite",
    "Model": "VIVAX_Point_X2_Lite"
  },
  {
    "Retail Branding": "Vivax",
    "Marketing Name": "VIVAX_Fly_V1",
    "Device": "VIVAX_Fly_V1",
    "Model": "VIVAX_Fly_V1"
  },
  {
    "Retail Branding": "Vivax",
    "Marketing Name": "VIVAX_PRO3",
    "Device": "VIVAX_PRO3",
    "Model": "VIVAX_PRO3"
  },
  {
    "Retail Branding": "Vivax",
    "Marketing Name": "VIVAX_TPC-105_4G",
    "Device": "VIVAX_TPC-105_4G",
    "Model": "VIVAX_TPC-105_4G"
  },
  {
    "Retail Branding": "Vivensis",
    "Marketing Name": "Vivensis VX Smart",
    "Device": "HYR2B-Vivensis",
    "Model": "Vivensis VX Smart"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": 1601,
    "Device": 1601,
    "Model": "vivo 1601"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": 1601,
    "Device": 1601,
    "Model": "vivo 1713"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": 1609,
    "Device": 1609,
    "Model": "vivo 1609"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "G2",
    "Device": "PD2318",
    "Model": "V2318A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "I1927",
    "Device": "I1928",
    "Model": "I1927"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "I1928",
    "Device": "I1928",
    "Model": "I1928"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "I2009",
    "Device": 2009,
    "Model": "I2009"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "I2011",
    "Device": 2011,
    "Model": "I2011"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "I2012",
    "Device": 2012,
    "Model": "I2012"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "I2017",
    "Device": 2017,
    "Model": "I2017"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "I2127",
    "Device": "I2127",
    "Model": "I2127"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "I2202",
    "Device": "I2202",
    "Model": "I2202"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "I2306",
    "Device": "I2306",
    "Model": "I2306"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "NEX A",
    "Device": "PD1806B",
    "Model": "vivo NEX A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "PA2170",
    "Device": "DPD2106",
    "Model": "PA2170"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "PD1304DL",
    "Device": "PD1304DL",
    "Model": "vivo Y13iL"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "PD1419V",
    "Device": "PD1419V",
    "Model": "vivo Y923"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "PD1612",
    "Device": "PD1612",
    "Model": "vivo PD1612"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "PD1612",
    "Device": "PD1612",
    "Model": "vivo Y67"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "PD1731D",
    "Device": "PD1731D",
    "Model": "vivo Y71A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "S17",
    "Device": "PD2283",
    "Model": "V2283A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "S17 Pro",
    "Device": "PD2284",
    "Model": "V2284A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "S17t",
    "Device": "PD2282",
    "Model": "V2282A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "S18 Pro",
    "Device": "PD2344",
    "Model": "V2344A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "S19 Pro",
    "Device": "PD2362",
    "Model": "V2362A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "S20",
    "Device": "PD2429",
    "Model": "V2429A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "S20 Pro",
    "Device": "PD2430",
    "Model": "V2430A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "T1",
    "Device": "V2154",
    "Model": "V2153"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "T1",
    "Device": "V2154",
    "Model": "V2154"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "T1",
    "Device": "V2154",
    "Model": "V2168"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "T1 5G",
    "Device": "V2151",
    "Model": "V2150"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "T1 Pro 5G",
    "Device": "V2151",
    "Model": "V2151"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "T1x",
    "Device": 2135,
    "Model": "V2143"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "T2",
    "Device": "V2237",
    "Model": "V2320"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "T2 5G",
    "Device": "V2222",
    "Model": "V2240"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "T2 Pro 5G",
    "Device": "V2321",
    "Model": "V2321"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "T2x 5G",
    "Device": "V2225",
    "Model": "V2253"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "T2x 5G",
    "Device": "V2225",
    "Model": "V2312"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "T3 5G",
    "Device": "V2334",
    "Model": "V2334"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "T3 Lite 5G",
    "Device": "V2346",
    "Model": "V2356"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "T3 Ultra",
    "Device": "V2347",
    "Model": "V2426"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "T3x 5G",
    "Device": "V2338",
    "Model": "V2338"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "T4 Lite 5G",
    "Device": "V2446",
    "Model": "V2509"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "T4R 5G",
    "Device": "V2428",
    "Model": "V2518"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "U5x",
    "Device": "PD2180",
    "Model": "V2180GA"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V1",
    "Device": "V1",
    "Model": "vivo V1"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V1730EA",
    "Device": "PD1730E",
    "Model": "V1730EA"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V1731CA",
    "Device": "PD1731C",
    "Model": "V1731CA"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V1732A",
    "Device": "PD1732",
    "Model": "V1732A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V1809A",
    "Device": "PD1809",
    "Model": "V1809A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V1813BA",
    "Device": "PD1813B",
    "Model": "V1813BA"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V1813BT",
    "Device": "PD1813D",
    "Model": "V1813BT"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V1814A",
    "Device": "PD1814",
    "Model": "V1814A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V1816A",
    "Device": "PD1816",
    "Model": "V1816A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V1818A",
    "Device": "PD1818",
    "Model": "V1818A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V1818A",
    "Device": "PD1818G",
    "Model": "V1818A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V1818CA",
    "Device": "PD1818E",
    "Model": "V1818CA"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V1821BA",
    "Device": "PD1821",
    "Model": "V1821A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V1824A",
    "Device": "PD1824",
    "Model": "V1824A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V1829A",
    "Device": "PD1829",
    "Model": "V1829A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V1836A",
    "Device": "PD1836",
    "Model": "V1836A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V1838A",
    "Device": "PD1838",
    "Model": "V1838A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V1901A",
    "Device": "PD1901",
    "Model": "V1901A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V1901K",
    "Device": "PD1901",
    "Model": "V1901A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V1911A",
    "Device": "PD1911",
    "Model": "V1911A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V1913A",
    "Device": "PD1913",
    "Model": "V1913A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V1914A",
    "Device": "PD1914",
    "Model": "V1914A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V1916A",
    "Device": "PD1916",
    "Model": "V1916A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V1921A",
    "Device": "PD1921",
    "Model": "V1921A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V1922A",
    "Device": "PD1922",
    "Model": "V1922A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V1923A",
    "Device": "PD1923",
    "Model": "V1923A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V1924A",
    "Device": "PD1924",
    "Model": "V1924A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V1926",
    "Device": 1926,
    "Model": "V1926"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V1928A",
    "Device": "PD1928",
    "Model": "V1928A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V1930",
    "Device": 1930,
    "Model": "V1930"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V1930A",
    "Device": "PD1930",
    "Model": "V1930A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V1932A",
    "Device": "PD1932",
    "Model": "V1932A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V1934A",
    "Device": "PD1934",
    "Model": "V1934A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V1936A",
    "Device": "PD1936",
    "Model": "V1936A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V1936AL",
    "Device": "PD1936G",
    "Model": "V1936AL"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V1937",
    "Device": 1920,
    "Model": "V1937"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V1937",
    "Device": 1937,
    "Model": "V1937"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V1938A",
    "Device": "PD1938",
    "Model": "V1938T"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V1938CT",
    "Device": "PD1938",
    "Model": "V1938CT"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V1941A",
    "Device": "PD1941",
    "Model": "V1941A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V1945A",
    "Device": "PD1945",
    "Model": "V1945A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V1950A",
    "Device": "PD1950",
    "Model": "V1950A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V1955A",
    "Device": "PD1955",
    "Model": "V1955A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V1962A",
    "Device": "PD1962",
    "Model": "V1962A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V1963A",
    "Device": "PD1963",
    "Model": "V1963A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V1965A",
    "Device": "PD1965",
    "Model": "V1965A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V1981A",
    "Device": "PD1981",
    "Model": "V1981A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V1986A",
    "Device": "PD1986",
    "Model": "V1986A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V1990A",
    "Device": "PD1990",
    "Model": "V1990A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V1Max",
    "Device": "Y37",
    "Model": "vivo Y37"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V2001A",
    "Device": "PD2001",
    "Model": "V2001A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V2002A",
    "Device": "PD2002",
    "Model": "V2002A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V2002A",
    "Device": "PD2019",
    "Model": "V2002A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V2002A",
    "Device": "PD2019",
    "Model": "V2019A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V2005A",
    "Device": "PD2005",
    "Model": "V2005A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V2006",
    "Device": 2006,
    "Model": "V2006"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V2009A",
    "Device": "PD2156",
    "Model": "V2009A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V2011A",
    "Device": "PD2011",
    "Model": "V2011A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V2012A",
    "Device": "PD2012",
    "Model": "V2012A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V2020A",
    "Device": "PD2020",
    "Model": "V2020A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V2022",
    "Device": 2023,
    "Model": "V2022"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V2023",
    "Device": 2023,
    "Model": "V2023"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V2023A",
    "Device": "PD2023",
    "Model": "V2023A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V2023EA",
    "Device": "PD2023",
    "Model": "V2023EA"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V2024",
    "Device": 1920,
    "Model": "V2024"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V2024A",
    "Device": "PD2024",
    "Model": "V2024A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V2025",
    "Device": 2025,
    "Model": "V2025"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V2025A",
    "Device": "PD2024",
    "Model": "V2025A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V2026",
    "Device": 2026,
    "Model": "V2026"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V2026_21",
    "Device": 2026,
    "Model": "V2026_21"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V2027",
    "Device": 2027,
    "Model": "V2027"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V2028",
    "Device": 2027,
    "Model": "V2028"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V2028",
    "Device": 2028,
    "Model": "V2028"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V2029",
    "Device": 2027,
    "Model": "V2029"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V2029_PK",
    "Device": 2027,
    "Model": "V2029_PK"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V2030",
    "Device": 2030,
    "Model": "V2030"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V2031",
    "Device": 2036,
    "Model": "V2031"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V2031A",
    "Device": "PD2031",
    "Model": "V2031A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V2031EA",
    "Device": "PD2031EA",
    "Model": "V2031EA"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V2031_21",
    "Device": 2036,
    "Model": "V2031_21"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V2032",
    "Device": 2027,
    "Model": "V2032"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V2033",
    "Device": 2034,
    "Model": "V2033"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V2034",
    "Device": 2034,
    "Model": "V2034"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V2034A",
    "Device": "PD2034",
    "Model": "V2034A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V2035",
    "Device": 2036,
    "Model": "V2035"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V2036",
    "Device": 2036,
    "Model": "V2036"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V2036A",
    "Device": "PD2036",
    "Model": "V2036A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V2036_21",
    "Device": 2036,
    "Model": "V2036_21"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V2037",
    "Device": 2037,
    "Model": "V2037"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V2038",
    "Device": 2037,
    "Model": "V2038"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V2039",
    "Device": 2034,
    "Model": "V2039"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V2040",
    "Device": 2040,
    "Model": "V2040"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V2041",
    "Device": 2041,
    "Model": "V2041"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V2042",
    "Device": 2026,
    "Model": "V2042"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V2043",
    "Device": 2026,
    "Model": "V2043"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V2043_21",
    "Device": 2026,
    "Model": "V2043_21"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V2044",
    "Device": 2044,
    "Model": "V2044"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V2045",
    "Device": 2045,
    "Model": "V2045"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V2045A",
    "Device": "PD2068",
    "Model": "V2045A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V2046",
    "Device": 2046,
    "Model": "V2046"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V2046A",
    "Device": "PD2046",
    "Model": "V2046A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V2047",
    "Device": 2047,
    "Model": "V2047"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V2047A",
    "Device": "PD2047",
    "Model": "V2047A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V2048",
    "Device": 2026,
    "Model": "V2048"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V2048A",
    "Device": "PD2048",
    "Model": "V2048A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V2049A",
    "Device": "PD2049",
    "Model": "V2049A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V2050",
    "Device": 2050,
    "Model": "V2050"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V2050",
    "Device": 2050,
    "Model": "V2066"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V2052",
    "Device": 2034,
    "Model": "V2052"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V2053",
    "Device": 2041,
    "Model": "V2053"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V2054",
    "Device": 2034,
    "Model": "V2052"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V2054",
    "Device": 2034,
    "Model": "V2054"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V2054",
    "Device": 2034,
    "Model": "V2069"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V2054",
    "Device": 2034,
    "Model": "V2101"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V2054A",
    "Device": "PD2054",
    "Model": "V2054A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V2054A",
    "Device": "PD2092",
    "Model": "V2054A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V2054A",
    "Device": "PD2106",
    "Model": "V2054A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V2055",
    "Device": 2055,
    "Model": "V2055"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V2055A",
    "Device": "PD2055",
    "Model": "V2055A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V2056A",
    "Device": "PD2056",
    "Model": "V2056A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V2057",
    "Device": 2058,
    "Model": "V2057"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V2057A",
    "Device": "PD2057",
    "Model": "V2057A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V2058",
    "Device": 2058,
    "Model": "V2058"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V2059",
    "Device": 2059,
    "Model": "V2059"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V2059A",
    "Device": "PD2047",
    "Model": "V2059A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V2060",
    "Device": 2060,
    "Model": "V2060"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V2061",
    "Device": 2061,
    "Model": "V2061"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V2061A",
    "Device": "PD2061",
    "Model": "V2061A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V2065",
    "Device": 2026,
    "Model": "V2065"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V2065A",
    "Device": "PD2065",
    "Model": "V2065A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V2066",
    "Device": 2050,
    "Model": "V2066"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V2066A",
    "Device": "PD2066",
    "Model": "V2066A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V2066BA",
    "Device": "PD2066B",
    "Model": "V2066BA"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V2068",
    "Device": 2034,
    "Model": "V2068"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V2068A",
    "Device": "PD2068",
    "Model": "V2068A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V2069",
    "Device": 2034,
    "Model": "V2069"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V2069A",
    "Device": "PD2069",
    "Model": "V2069A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V2070",
    "Device": 2034,
    "Model": "V2070"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V2072A",
    "Device": "PD2072",
    "Model": "V2072A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V2073A",
    "Device": "PD2073",
    "Model": "V2073A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V2080A",
    "Device": "PD2080",
    "Model": "V2080A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V2085A",
    "Device": "PD2085",
    "Model": "V2085A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V2099A",
    "Device": "PD2034",
    "Model": "V2034A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V2099A",
    "Device": "PD2034D",
    "Model": "V2099A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V2101",
    "Device": 2034,
    "Model": "V2101"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V2102",
    "Device": 2034,
    "Model": "V2102"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V2102A",
    "Device": "PD2102",
    "Model": "V2102A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V2104",
    "Device": 2105,
    "Model": "V2104"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V2105",
    "Device": 2105,
    "Model": "V2105"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V2106A",
    "Device": "PD2106",
    "Model": "V2106A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V2106A",
    "Device": "PD2106B",
    "Model": "V2106A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V2108",
    "Device": 2061,
    "Model": "V2061"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V2108",
    "Device": 2061,
    "Model": "V2108"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V2109",
    "Device": 2109,
    "Model": "V2109"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V2110",
    "Device": 2109,
    "Model": "V2110"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V2110",
    "Device": 2109,
    "Model": "V2136"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V2110",
    "Device": 2110,
    "Model": "V2110"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V2111",
    "Device": 2111,
    "Model": "V2111"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V2111-EG",
    "Device": 2111,
    "Model": "V2111-EG"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V2111A",
    "Device": "PD2111",
    "Model": "V2111A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V2113",
    "Device": 2113,
    "Model": "V2113"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V2115",
    "Device": 2116,
    "Model": "V2115"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V2115A",
    "Device": "PD2115",
    "Model": "V2115A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V2116",
    "Device": 2116,
    "Model": "V2116"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V2117",
    "Device": 2116,
    "Model": "V2117"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V2118",
    "Device": 2120,
    "Model": "V2118"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V2118A",
    "Device": "PD2118",
    "Model": "V2118A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V2120",
    "Device": 2120,
    "Model": "V2120"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V2121A",
    "Device": "PD2121",
    "Model": "V2121A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V2123A",
    "Device": "PD2123",
    "Model": "V2123A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V2124",
    "Device": 2124,
    "Model": "V2124"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V2125",
    "Device": 2120,
    "Model": "V2125"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V2126",
    "Device": 2126,
    "Model": "V2126"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V2127",
    "Device": 2127,
    "Model": "V2127"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V2129",
    "Device": 2129,
    "Model": "V2129"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V2130",
    "Device": 2130,
    "Model": "V2130"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V2130A",
    "Device": "PD2130",
    "Model": "V2130A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V2131",
    "Device": 2131,
    "Model": "V2131"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V2131A",
    "Device": "PD2131",
    "Model": "V2131A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V2132",
    "Device": 2132,
    "Model": "V2132"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V2132A",
    "Device": "PD2134",
    "Model": "V2132A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V2133A",
    "Device": "PD2133",
    "Model": "V2133A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V2134",
    "Device": 2120,
    "Model": "V2134"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V2134A",
    "Device": "PD2134",
    "Model": "V2134A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V2135",
    "Device": 2135,
    "Model": "V2135"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V2135A",
    "Device": "PD2133",
    "Model": "V2135A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V2136A",
    "Device": "PD2136",
    "Model": "V2136A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V2136GA",
    "Device": "PD2136",
    "Model": "V2136GA"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V2139",
    "Device": 2120,
    "Model": "V2139"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V2140",
    "Device": 2131,
    "Model": "V2140"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V2140A",
    "Device": "PD2140",
    "Model": "V2140A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V2141",
    "Device": 2141,
    "Model": "V2141"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V2141A",
    "Device": "PD2141",
    "Model": "V2141A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V2142",
    "Device": 2127,
    "Model": "V2142"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V2143",
    "Device": 2135,
    "Model": "V2143"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V2143A",
    "Device": "PD2143",
    "Model": "V2143A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V2145A",
    "Device": "PD2145",
    "Model": "V2145A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V2146",
    "Device": 2135,
    "Model": "V2146"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V2147",
    "Device": 2120,
    "Model": "V2147"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V2148A",
    "Device": "PD2148",
    "Model": "V2148A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V2152",
    "Device": 2110,
    "Model": "V2152"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V2156A",
    "Device": "PD2156",
    "Model": "V2156A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V2156FA",
    "Device": "PD2156U",
    "Model": "V2156FA"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V2157A",
    "Device": "PD2157",
    "Model": "V2157A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V2158A",
    "Device": "PD2158",
    "Model": "V2158A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V2162",
    "Device": 2120,
    "Model": "V2162"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V2162A",
    "Device": "PD2162",
    "Model": "V2162A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V2163A",
    "Device": "PD2163",
    "Model": "V2163A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V2164A",
    "Device": "PD2164",
    "Model": "V2164A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V2164PA",
    "Device": "PD2164",
    "Model": "V2164PA"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V2164PA",
    "Device": "PD2164U",
    "Model": "V2164PA"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V2165A",
    "Device": "PD2165",
    "Model": "V2165A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V2166A",
    "Device": "PD2166",
    "Model": "V2166A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V2166BA",
    "Device": "PD2224",
    "Model": "V2166BA"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V2168A",
    "Device": "PD2168",
    "Model": "V2168A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V2171A",
    "Device": "PD2171",
    "Model": "V2171A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V2172A",
    "Device": "PD2172",
    "Model": "V2172A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V2180A",
    "Device": "PD2180",
    "Model": "V2180A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V2197A",
    "Device": "PD2166",
    "Model": "V2197A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V2202",
    "Device": "V2202",
    "Model": "V2202"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V2202A",
    "Device": "PD2202",
    "Model": "V2202A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V2203A",
    "Device": "PD2203",
    "Model": "V2203A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V2220A",
    "Device": "PD2220",
    "Model": "V2220A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V2279A",
    "Device": "PD2279J",
    "Model": "V2279A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V2353A",
    "Device": "PD2353",
    "Model": "V2353A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V2353A",
    "Device": "PD2353",
    "Model": "V2353DA"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V2417",
    "Device": "V2418",
    "Model": "V2417"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V25",
    "Device": "V2202",
    "Model": "V2202"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V25",
    "Device": "V2202",
    "Model": "V2228"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V25 Pro",
    "Device": "V2158",
    "Model": "V2158"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V25e",
    "Device": "V2201",
    "Model": "V2201"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V25e",
    "Device": "V2201",
    "Model": "V2209"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V25e",
    "Device": "V2237",
    "Model": "V2242"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V27",
    "Device": "V2231",
    "Model": "V2231"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V27",
    "Device": "V2231",
    "Model": "V2246"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V27 Pro",
    "Device": "V2230",
    "Model": "V2230"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V27e",
    "Device": "V2237",
    "Model": "V2237"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V29",
    "Device": "V2250",
    "Model": "V2250"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V29 Lite 5G",
    "Device": "V2244",
    "Model": "V2244"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V29e",
    "Device": "V2303",
    "Model": "V2303"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V29e 5G",
    "Device": "V2317",
    "Model": "V2317"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V3",
    "Device": "PD1524",
    "Model": "vivo V3"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V3",
    "Device": "V3",
    "Model": "vivo V3"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V30",
    "Device": "V2318",
    "Model": "V2318"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V30 Lite",
    "Device": "V2317",
    "Model": "V2314"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V30 Lite",
    "Device": "V2342",
    "Model": "V2342"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V30 Lite 5G",
    "Device": "V2327",
    "Model": "V2327"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V30 Pro",
    "Device": "V2319",
    "Model": "V2319"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V30 SE",
    "Device": "V2327",
    "Model": "V2349"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V30e",
    "Device": "V2339",
    "Model": "V2339"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V3Lite",
    "Device": "V3Lite",
    "Model": "vivo V3Lite"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V3M A",
    "Device": "PD1524B",
    "Model": "vivo PD1524B"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V3Max",
    "Device": "V3Max",
    "Model": "vivo V3Max"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V3Max + A",
    "Device": "PD1523B",
    "Model": "vivo V3Max+ A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V3Max A",
    "Device": "PD1523",
    "Model": "vivo PD1523A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V40",
    "Device": "V2348",
    "Model": "V2348"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V40 Lite",
    "Device": "V2339",
    "Model": "V2340"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V40 Lite",
    "Device": "V2339",
    "Model": "V2341"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V40 Lite",
    "Device": "V2342",
    "Model": "V2424"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V40 Lite",
    "Device": "V2418",
    "Model": "V2417"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V40 Lite",
    "Device": "V2418",
    "Model": "V2418"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V40 Lite 5G",
    "Device": "V2418",
    "Model": "V2417"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V40 Lite 5G",
    "Device": "V2418",
    "Model": "V2418"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V40 Pro",
    "Device": "V2347",
    "Model": "V2347"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V40 SE",
    "Device": "V2342",
    "Model": "V2342"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V40 SE",
    "Device": "V2418",
    "Model": "V2418"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V40 SE 5G",
    "Device": "V2327",
    "Model": "V2337"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V40 SE 80W",
    "Device": "V2418",
    "Model": "V2418"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V40e",
    "Device": "V2403",
    "Model": "V2403"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V50",
    "Device": "V2427",
    "Model": "V2427"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V50",
    "Device": "V2427",
    "Model": "V2448"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V50",
    "Device": "V2427",
    "Model": "V2451"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V5Plus",
    "Device": "V5Plus",
    "Model": "vivo V5Plus"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V9",
    "Device": "1727ID",
    "Model": "vivo 1727"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V9 6GB",
    "Device": "1723CF",
    "Model": "vivo 1723"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "V9 Pro",
    "Device": 1851,
    "Model": "vivo 1851"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "X Flip",
    "Device": "PD2256",
    "Model": "V2256A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "X Fold3 Pro",
    "Device": "PD2337",
    "Model": "V2337A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "X Fold3 Pro",
    "Device": "V2330",
    "Model": "V2330"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "X100",
    "Device": "PD2309",
    "Model": "V2309A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "X100",
    "Device": "V2308",
    "Model": "V2308"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "X100 Pro",
    "Device": "PD2324",
    "Model": "V2324A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "X100 Pro",
    "Device": "V2309",
    "Model": "V2309"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "X100 Ultra",
    "Device": "PD2366",
    "Model": "V2366GA"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "X100 Ultra",
    "Device": "PD2366",
    "Model": "V2366HA"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "X100s",
    "Device": "PD2309",
    "Model": "V2359A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "X100s Pro",
    "Device": "PD2324",
    "Model": "V2324HA"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "X200 Pro",
    "Device": "PD2405",
    "Model": "V2405A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "X200 Pro",
    "Device": "V2413",
    "Model": "V2413"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "X200 Pro 卫星通信版",
    "Device": "PD2405",
    "Model": "V2405A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "X200 Pro 卫星通信版",
    "Device": "PD2405",
    "Model": "V2405DA"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "X200 Ultra",
    "Device": "PD2454",
    "Model": "V2454A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "X200 Ultra",
    "Device": "PD2454",
    "Model": "V2454DA"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "X5",
    "Device": "X5",
    "Model": "vivo X5"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "X50",
    "Device": 2004,
    "Model": "vivo 2004"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "X50 Pro",
    "Device": 2006,
    "Model": "vivo 2006"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "X5M",
    "Device": "PD1401CL",
    "Model": "vivo X5M"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "X5Max",
    "Device": "X5Max",
    "Model": "vivo X5Max"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "X5Max S",
    "Device": "bbk6752_lwt_kk",
    "Model": "vivo X5Max S"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "X5MaxV",
    "Device": "msm8916_32",
    "Model": "vivo X5MaxV"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "X5Pro",
    "Device": "X5Pro",
    "Model": "vivo X5Pro"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "X5Pro D",
    "Device": "bbk6752_lwt_l",
    "Model": "vivo X5Pro D"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "X5Pro V",
    "Device": "PD1421V",
    "Model": "vivo X5Pro V"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "X6A",
    "Device": "PD1415A",
    "Model": "vivo PD1415A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "X6D",
    "Device": "PD1415D",
    "Model": "vivo X6D"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "X6Plus A",
    "Device": "PD1515A",
    "Model": "vivo PD1515A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "X6Plus D",
    "Device": "PD1501D",
    "Model": "vivo PD1501D"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "X6S A",
    "Device": "PD1415BA",
    "Model": "vivo X6S A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "X6SPlusA",
    "Device": "PD1515BA",
    "Model": "vivo PD1515BA"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "X7",
    "Device": "PD1602",
    "Model": "vivo X7"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "X7Plus",
    "Device": "PD1603",
    "Model": "vivo X7Plus"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "X80",
    "Device": "V2144",
    "Model": "V2144"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "X80 Lite  5G",
    "Device": "V2202",
    "Model": "V2208"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "X80 Pro",
    "Device": "V2145",
    "Model": "V2145"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "X9",
    "Device": "PD1616",
    "Model": "vivo X9"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "X90",
    "Device": "V2218",
    "Model": "V2218"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "X90 Pro",
    "Device": "V2219",
    "Model": "V2219"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "X9i",
    "Device": "PD1624",
    "Model": "vivo X9i"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "Xplay5A",
    "Device": "PD1522A",
    "Model": "vivo PD1522A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "Xplay5A",
    "Device": "PD1522A",
    "Model": "vivo Xplay5A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "Xplay6",
    "Device": "PD1610",
    "Model": "vivo Xplay6"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "Y01A",
    "Device": 2120,
    "Model": "V2166"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "Y02",
    "Device": "V2217",
    "Model": "V2217"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "Y02",
    "Device": "V2236",
    "Model": "V2234_PK"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "Y02",
    "Device": "V2236",
    "Model": "V2236"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "Y02A",
    "Device": "V2236",
    "Model": "V2234"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "Y02s",
    "Device": "V2204",
    "Model": "V2203"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "Y02s",
    "Device": "V2204",
    "Model": "V2221"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "Y02s",
    "Device": "V2204",
    "Model": "V2229"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "Y02t",
    "Device": "V2254",
    "Model": "V2252"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "Y02t",
    "Device": "V2254",
    "Model": "V2254"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "Y02t",
    "Device": "V2254",
    "Model": "V2325"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "Y03",
    "Device": "V2333",
    "Model": "V2332"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "Y03",
    "Device": "V2333",
    "Model": "V2406"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "Y03t",
    "Device": "V2344",
    "Model": "V2344"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "Y03t",
    "Device": "V2344",
    "Model": "V2409"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "Y04s",
    "Device": "V2430",
    "Model": "V2531"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "Y100",
    "Device": "PD2313",
    "Model": "V2313A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "Y100",
    "Device": "V2239",
    "Model": "V2239"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "Y100",
    "Device": "V2342",
    "Model": "V2342"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "Y100",
    "Device": "V2342",
    "Model": "V2412"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "Y100 5G",
    "Device": "V2327",
    "Model": "V2327"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "Y100+",
    "Device": "PD2354",
    "Model": "V2354A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "Y100A",
    "Device": "V2222",
    "Model": "V2222"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "Y11",
    "Device": "PD2236",
    "Model": "V2236A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "Y11",
    "Device": "Y11",
    "Model": "vivo Y11"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "Y12",
    "Device": "PD2317",
    "Model": "V2317A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "Y15",
    "Device": "Y15",
    "Model": "vivo Y15"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "Y15C",
    "Device": 2120,
    "Model": "V2212"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "Y15S",
    "Device": "Y15S",
    "Model": "vivo Y15S"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "Y16",
    "Device": "V2204",
    "Model": "V2204"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "Y16",
    "Device": "V2204",
    "Model": "V2214"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "Y16",
    "Device": "V2204",
    "Model": "V2305"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "Y17",
    "Device": "1902D",
    "Model": "vivo 1902"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "Y17s",
    "Device": "V2310",
    "Model": "V2310"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "Y17s",
    "Device": "V2310",
    "Model": "V2331"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "Y18",
    "Device": "V2333",
    "Model": "V2333"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "Y18",
    "Device": "V2333",
    "Model": "V2345"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "Y18e",
    "Device": "V2333",
    "Model": "V2350"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "Y18i",
    "Device": "V2344",
    "Model": "V2414"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "Y18s",
    "Device": "V2333",
    "Model": "V2410"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "Y18t",
    "Device": "V2344",
    "Model": "V2408"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "Y19 5G",
    "Device": "V2446",
    "Model": "V2432"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "Y19s pro",
    "Device": "V2419",
    "Model": "V2419"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "Y19s pro",
    "Device": "V2419",
    "Model": "V2458"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "Y19s pro",
    "Device": "V2419",
    "Model": "V2507"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "Y19s pro",
    "Device": "V2419",
    "Model": "V2508"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "Y19s pro",
    "Device": "V2419",
    "Model": "V2519"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "Y19sGT 5G",
    "Device": "V2446",
    "Model": "V2526"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "Y200",
    "Device": "V2342",
    "Model": "V2424"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "Y200",
    "Device": "V2342",
    "Model": "V2425"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "Y200 5G",
    "Device": "V2307",
    "Model": "V2307"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "Y200 GT",
    "Device": "PD2361",
    "Model": "V2361GA"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "Y200 Pro 5G",
    "Device": "V2303",
    "Model": "V2303"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "Y200 Pro 5G",
    "Device": "V2303",
    "Model": "V2401"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "Y200e 5G",
    "Device": "V2327",
    "Model": "V2336"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "Y200i",
    "Device": "PD2354",
    "Model": "V2354A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "Y21",
    "Device": "Y21",
    "Model": "vivo Y21"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "Y21A",
    "Device": 2149,
    "Model": "V2149"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "Y21L",
    "Device": "Y21L",
    "Model": "vivo Y21L"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "Y22",
    "Device": "Y22",
    "Model": "vivo Y22"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "Y22s",
    "Device": "V2206",
    "Model": "V2206"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "Y27",
    "Device": "V2249",
    "Model": "V2249"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "Y27",
    "Device": "Y27",
    "Model": "vivo Y27"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "Y27 5G",
    "Device": "V2248",
    "Model": "V2302"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "Y27 5G",
    "Device": "V2248G",
    "Model": "V2302"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "Y27s",
    "Device": "V2247",
    "Model": "V2322"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "Y27s",
    "Device": "V2247",
    "Model": "V2335"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "Y28",
    "Device": "V2352",
    "Model": "V2352"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "Y28",
    "Device": "V2352",
    "Model": "V2433"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "Y28",
    "Device": "Y28",
    "Model": "vivo Y28"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "Y28 5G",
    "Device": "V2315",
    "Model": "V2315"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "Y28e 5G",
    "Device": "V2346",
    "Model": "V2407"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "Y28s 5G",
    "Device": "V2346",
    "Model": "V2346"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "Y28s 5G",
    "Device": "V2346",
    "Model": "V2351"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "Y29s 5G",
    "Device": "V2446",
    "Model": "V2446"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "Y29t 5G",
    "Device": "V2446",
    "Model": "V2527"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "Y30 5G",
    "Device": 2160,
    "Model": "V2160"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "Y300 5G",
    "Device": "V2418",
    "Model": "V2416"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "Y300 Plus 5G",
    "Device": "V2422",
    "Model": "V2422"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "Y300 Pro",
    "Device": "PD2410",
    "Model": "V2410A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "Y300+",
    "Device": "PD2445",
    "Model": "V2445EA"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "Y300c",
    "Device": "PD2435",
    "Model": "V2435A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "Y31",
    "Device": "PD1505",
    "Model": "vivo Y31"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "Y31",
    "Device": "Y31",
    "Model": "vivo Y31"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "Y31L",
    "Device": "Y31L",
    "Model": "vivo Y31L"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "Y31i",
    "Device": "Y31i",
    "Model": "vivo 1707"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "Y31i",
    "Device": "Y31i",
    "Model": "vivo Y31"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "Y31i",
    "Device": "Y31i",
    "Model": "vivo Y31i"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "Y33",
    "Device": "bbk6735_65c_l",
    "Model": "vivo Y33"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "Y33t",
    "Device": "PD2236",
    "Model": "V2236A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "Y33t",
    "Device": "PD2317",
    "Model": "V2317A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "Y35",
    "Device": "PD1502L",
    "Model": "vivo Y35"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "Y35",
    "Device": "PD2230",
    "Model": "V2230A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "Y35",
    "Device": "V2205",
    "Model": "V2205"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "Y35+",
    "Device": "PD2279",
    "Model": "V2279A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "Y35A",
    "Device": "PD1502A",
    "Model": "vivo Y35A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "Y35m",
    "Device": "PD2230",
    "Model": "V2230A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "Y35m+",
    "Device": "PD2279",
    "Model": "V2279A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "Y36",
    "Device": "PD2318",
    "Model": "V2318A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "Y36",
    "Device": "V2247",
    "Model": "V2247"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "Y36",
    "Device": "V2247",
    "Model": "V2324"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "Y36 5G",
    "Device": "V2248",
    "Model": "V2248"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "Y36m",
    "Device": "PD2318",
    "Model": "V2318A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "Y36s",
    "Device": "PD2318",
    "Model": "V2318A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "Y36t",
    "Device": "PD2327",
    "Model": "V2327A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "Y37 Pro",
    "Device": "PD2354M",
    "Model": "V2354A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "Y37c",
    "Device": "PD2442",
    "Model": "V2442A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "Y38 5G",
    "Device": "V2343",
    "Model": "V2343"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "Y51",
    "Device": "Y51",
    "Model": "vivo Y51"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "Y51A",
    "Device": "PD1510",
    "Model": "vivo Y51A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "Y53",
    "Device": 1606,
    "Model": "vivo 1606"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "Y53L",
    "Device": "PD1628",
    "Model": "vivo PD1628"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "Y53t",
    "Device": "PD2230",
    "Model": "V2230A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "Y55",
    "Device": 1603,
    "Model": "vivo 1603"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "Y55",
    "Device": "V2154",
    "Model": "V2154"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "Y55A",
    "Device": "PD1613",
    "Model": "vivo Y55"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "Y55s",
    "Device": 1610,
    "Model": "vivo 1610"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "Y55s",
    "Device": "PD2164",
    "Model": "V2164A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "Y55t",
    "Device": "PD2279",
    "Model": "V2279A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "Y56 5G",
    "Device": "V2225",
    "Model": "V2225"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "Y56 5G",
    "Device": "V2225",
    "Model": "V2311"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "Y58 5G",
    "Device": "V2355",
    "Model": "V2355"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "Y66",
    "Device": "PD1621",
    "Model": "vivo Y66"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "Y67",
    "Device": "PD1612",
    "Model": "vivo Y67"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "Y71",
    "Device": 1801,
    "Model": "vivo 1801"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "Y77t",
    "Device": "PD2278",
    "Model": "V2278A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "Y78",
    "Device": "PD2278",
    "Model": "V2278A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "Y78 5G",
    "Device": "V2244",
    "Model": "V2244"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "Y78+",
    "Device": "PD2271",
    "Model": "V2271A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "Y78m",
    "Device": "PD2278",
    "Model": "V2278A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "Y79A",
    "Device": "PD1708",
    "Model": "vivo PD1708"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "Y79A",
    "Device": "PD1708",
    "Model": "vivo Y79A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "Y937",
    "Device": "PD1503",
    "Model": "vivo Y937"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "Y93s",
    "Device": "PD1818C",
    "Model": "V1818CA"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "Y93标准版 64G",
    "Device": "PD1818B",
    "Model": "V1818BA"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "Y93标准版 64G",
    "Device": "PD1818B",
    "Model": "V1818CA"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "Y97",
    "Device": "PD1813",
    "Model": "V1813A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "Z1",
    "Device": "PD1730C",
    "Model": "vivo Z1"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "Z1 Pro",
    "Device": 1951,
    "Model": "vivo 1951"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "Z3i",
    "Device": "PD1813C",
    "Model": "V1813A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "Z3i",
    "Device": "PD1813E",
    "Model": "V1813A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "iQOO 10",
    "Device": "PD2217",
    "Model": "V2217A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "iQOO 10 Pro",
    "Device": "PD2218",
    "Model": "V2218A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "iQOO 11",
    "Device": "I2212",
    "Model": "I2212"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "iQOO 11",
    "Device": "PD2243",
    "Model": "V2243A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "iQOO 11 Pro",
    "Device": "PD2254",
    "Model": "V2254A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "iQOO 11S",
    "Device": "PD2304",
    "Model": "V2304A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "iQOO 12",
    "Device": "I2220",
    "Model": "I2220"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "iQOO 12",
    "Device": "PD2307",
    "Model": "V2307A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "iQOO 12 Pro",
    "Device": "PD2329",
    "Model": "V2329A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "iQOO 13",
    "Device": "I2401",
    "Model": "I2401"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "iQOO 13",
    "Device": "PD2408",
    "Model": "V2408A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "iQOO 9 Pro",
    "Device": 2022,
    "Model": "I2022"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "iQOO 9 SE",
    "Device": 2019,
    "Model": "I2019"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "iQOO 9T",
    "Device": "I2201",
    "Model": "I2201"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "iQOO Neo 10R",
    "Device": "I2221",
    "Model": "I2221"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "iQOO Neo10",
    "Device": "PD2425",
    "Model": "V2425A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "iQOO Neo10 Pro",
    "Device": "PD2426",
    "Model": "V2426A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "iQOO Neo5S",
    "Device": "PD2154",
    "Model": "V2154A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "iQOO Neo6",
    "Device": "PD2196",
    "Model": "V2196A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "iQOO Neo6 SE",
    "Device": "PD2199",
    "Model": "V2199A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "iQOO Neo7",
    "Device": "I2214",
    "Model": "I2214"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "iQOO Neo7",
    "Device": "PD2231",
    "Model": "V2231A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "iQOO Neo7 Pro",
    "Device": "I2217",
    "Model": "I2217"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "iQOO Neo7 SE",
    "Device": "PD2238",
    "Model": "V2238A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "iQOO Neo7 竞速版",
    "Device": "",
    "Model": "V2232A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "iQOO Neo7 竞速版",
    "Device": "PD2232",
    "Model": "V2232A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "iQOO Neo8",
    "Device": "PD2301",
    "Model": "V2301A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "iQOO Neo8 Pro",
    "Device": "PD2302",
    "Model": "V2302A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "iQOO Neo9",
    "Device": "PD2338",
    "Model": "V2338A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "iQOO Neo9 Pro",
    "Device": "I2304",
    "Model": "I2304"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "iQOO Neo9 Pro",
    "Device": "PD2339",
    "Model": "V2339A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "iQOO Neo9S Pro",
    "Device": "PD2339",
    "Model": "V2339FA"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "iQOO Neo9S Pro+",
    "Device": "PD2403",
    "Model": "V2403A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "iQOO Pad",
    "Device": "DPD2307",
    "Model": "iPA2375"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "iQOO Pad Air",
    "Device": "DPD2305",
    "Model": "iPA2451"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "iQOO Pad2",
    "Device": "DPD2345",
    "Model": "iPA2453"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "iQOO Pad2 Pro",
    "Device": "DPD2329",
    "Model": "iPA2475"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "iQOO Z10 5G",
    "Device": "I2407",
    "Model": "I2407"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "iQOO Z10 Turbo Pro",
    "Device": "PD2453",
    "Model": "V2453A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "iQOO Z10R 5G",
    "Device": "I2410",
    "Model": "I2410"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "iQOO Z10x",
    "Device": "PD2445",
    "Model": "V2445A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "iQOO Z10x 5G",
    "Device": "I2404",
    "Model": "I2404"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "iQOO Z5",
    "Device": 2018,
    "Model": "I2018"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "iQOO Z5 6000mAh",
    "Device": "PD2188",
    "Model": "V2188A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "iQOO Z6",
    "Device": "I2203",
    "Model": "I2203"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "iQOO Z6",
    "Device": "I2203",
    "Model": "I2206"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "iQOO Z6 Lite 5G",
    "Device": "I2208",
    "Model": "I2208"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "iQOO Z6 Pro",
    "Device": "I2126",
    "Model": "I2126"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "iQOO Z6x",
    "Device": "PD2164U",
    "Model": "V2164KA"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "iQOO Z7",
    "Device": "PD2270",
    "Model": "V2270A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "iQOO Z7 5G",
    "Device": "I2207",
    "Model": "I2207"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "iQOO Z7 5G",
    "Device": "I2213",
    "Model": "I2213"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "iQOO Z7 Pro 5G",
    "Device": "I2301",
    "Model": "I2301"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "iQOO Z7i",
    "Device": "PD2230",
    "Model": "V2230EA"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "iQOO Z7s 5G",
    "Device": "I2223",
    "Model": "I2223"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "iQOO Z7x",
    "Device": "PD2272",
    "Model": "V2272A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "iQOO Z7x (m)",
    "Device": "PD2272",
    "Model": "V2272A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "iQOO Z7x 5G",
    "Device": "I2216",
    "Model": "I2216"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "iQOO Z8",
    "Device": "PD2314",
    "Model": "V2314A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "iQOO Z8x",
    "Device": "PD2312",
    "Model": "V2312A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "iQOO Z9",
    "Device": "PD2361",
    "Model": "V2361A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "iQOO Z9 5G",
    "Device": "I2218",
    "Model": "I2218"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "iQOO Z9 5G",
    "Device": "I2302",
    "Model": "I2302"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "iQOO Z9 Turbo",
    "Device": "PD2352",
    "Model": "V2352A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "iQOO Z9 Turbo 长续航版",
    "Device": "PD2352",
    "Model": "V2352GA"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "iQOO Z9 Turbo+",
    "Device": "PD2417",
    "Model": "V2417A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "iQOO Z9s 5G",
    "Device": "I2403",
    "Model": "I2403"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "iQOO Z9s Pro 5G",
    "Device": "I2305",
    "Model": "I2305"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "iQOO Z9x 5G",
    "Device": "I2219",
    "Model": "I2219"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "vivo  1907",
    "Device": 1907,
    "Model": "vivo 1907"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "vivo  X21i  A",
    "Device": "PD1801",
    "Model": "vivo X21i A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "vivo  Y75s",
    "Device": "PD1708C",
    "Model": "vivo Y75s"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "vivo  Y85A",
    "Device": "PD1730",
    "Model": "vivo Y85A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "vivo 1611",
    "Device": 1611,
    "Model": "vivo 1611"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "vivo 1714",
    "Device": 1714,
    "Model": "vivo 1714"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "vivo 1716",
    "Device": 1716,
    "Model": "vivo 1716"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "vivo 1718",
    "Device": 1718,
    "Model": "vivo 1718"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "vivo 1720",
    "Device": "PD1710F_EX",
    "Model": "vivo 1720"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "vivo 1721",
    "Device": "PD1709F_EX",
    "Model": "vivo 1721"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "vivo 1723",
    "Device": 1723,
    "Model": "vivo 1723"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "vivo 1724",
    "Device": 1724,
    "Model": "vivo 1724"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "vivo 1725",
    "Device": 1725,
    "Model": "vivo 1725"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "vivo 1726",
    "Device": 1726,
    "Model": "vivo 1726"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "vivo 1727",
    "Device": 1727,
    "Model": "vivo 1727"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "vivo 1802",
    "Device": 1802,
    "Model": "vivo 1802"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "vivo 1803",
    "Device": 1803,
    "Model": "vivo 1803"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "vivo 1804",
    "Device": 1804,
    "Model": "vivo 1804"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "vivo 1805",
    "Device": 1805,
    "Model": "vivo 1805"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "vivo 1806",
    "Device": 1806,
    "Model": "vivo 1806"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "vivo 1807",
    "Device": 1807,
    "Model": "vivo 1807"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "vivo 1807",
    "Device": "1807N",
    "Model": "vivo 1807"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "vivo 1808",
    "Device": 1808,
    "Model": "vivo 1808"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "vivo 1811",
    "Device": 1811,
    "Model": "vivo 1811"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "vivo 1812",
    "Device": 1812,
    "Model": "vivo 1812"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "vivo 1813",
    "Device": 1813,
    "Model": "vivo 1813"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "vivo 1814",
    "Device": 1814,
    "Model": "vivo 1814"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "vivo 1815",
    "Device": 1815,
    "Model": "vivo 1815"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "vivo 1816",
    "Device": 1816,
    "Model": "vivo 1816"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "vivo 1817",
    "Device": 1817,
    "Model": "vivo 1817"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "vivo 1818",
    "Device": 1818,
    "Model": "vivo 1818"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "vivo 1818",
    "Device": "1818N",
    "Model": "vivo 1818"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "vivo 1818",
    "Device": "PD1832",
    "Model": "V1832A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "vivo 1819",
    "Device": 1819,
    "Model": "vivo 1819"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "vivo 1819",
    "Device": "1819N",
    "Model": "vivo 1819"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "vivo 1820",
    "Device": 1820,
    "Model": "vivo 1820"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "vivo 1901",
    "Device": 1901,
    "Model": "vivo 1901"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "vivo 1902",
    "Device": 1902,
    "Model": "vivo 1902"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "vivo 1904",
    "Device": 1904,
    "Model": "vivo 1904"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "vivo 1906",
    "Device": 1906,
    "Model": "vivo 1906"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "vivo 1906",
    "Device": 1906,
    "Model": "vivo 2007"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "vivo 1907",
    "Device": 1907,
    "Model": "vivo 1907"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "vivo 1907",
    "Device": "1907N",
    "Model": "vivo 1907"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "vivo 1909",
    "Device": 1909,
    "Model": "vivo 1909"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "vivo 1910",
    "Device": 1910,
    "Model": "vivo 1910"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "vivo 1910",
    "Device": "1910N",
    "Model": "vivo 1910"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "vivo 1912",
    "Device": 1912,
    "Model": "vivo 1912"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "vivo 1913",
    "Device": 1913,
    "Model": "vivo 1913"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "vivo 1914",
    "Device": 1811,
    "Model": "vivo 1914"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "vivo 1915",
    "Device": 1915,
    "Model": "vivo 1915"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "vivo 1916",
    "Device": 1916,
    "Model": "vivo 1916"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "vivo 1917",
    "Device": 1917,
    "Model": "vivo 1917"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "vivo 1919",
    "Device": 1919,
    "Model": "vivo 1919"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "vivo 1920",
    "Device": 1920,
    "Model": "vivo 1920"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "vivo 1921",
    "Device": 1921,
    "Model": "vivo 1921"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "vivo 1929",
    "Device": 2015,
    "Model": "vivo 1929"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "vivo 1933",
    "Device": 1933,
    "Model": "vivo 1933"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "vivo 1935",
    "Device": 1935,
    "Model": "vivo 1935"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "vivo 1937",
    "Device": 1937,
    "Model": "vivo 1937"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "vivo 1938",
    "Device": 1938,
    "Model": "vivo 1938"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "vivo 1940",
    "Device": 1938,
    "Model": "vivo 1940"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "vivo 2005",
    "Device": 2005,
    "Model": "vivo 2005"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "vivo 2010",
    "Device": 1902,
    "Model": "vivo 1902"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "vivo 2010",
    "Device": 1902,
    "Model": "vivo 2010"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "vivo 2015",
    "Device": 2015,
    "Model": "vivo 2015"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "vivo 2015_21",
    "Device": 2015,
    "Model": "vivo 2015_21"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "vivo 2018",
    "Device": 2018,
    "Model": "vivo 2018"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "vivo 2019",
    "Device": 1938,
    "Model": "vivo 2019"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "vivo NEX A",
    "Device": "PD1806",
    "Model": "vivo NEX A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "vivo NEX S",
    "Device": "PD1805",
    "Model": "vivo NEX S"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "vivo Pad Air",
    "Device": "DPD2305",
    "Model": "PA2353"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "vivo Pad SE",
    "Device": "DPD2424",
    "Model": "PA2511"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "vivo Pad2",
    "Device": "DPD2221",
    "Model": "PA2373"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "vivo Pad3",
    "Device": "DPD2345",
    "Model": "PA2455"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "vivo Pad3 Pro",
    "Device": "DPD2329",
    "Model": "PA2473"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "vivo Pad5 Pro",
    "Device": "DPD2429",
    "Model": "PA2573"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "vivo S1",
    "Device": "PD1831",
    "Model": "V1831A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "vivo S1",
    "Device": "PD1831",
    "Model": "V1831T"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "vivo S15 Pro",
    "Device": "PD2207",
    "Model": "V2207A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "vivo S15e",
    "Device": "PD2190",
    "Model": "V2190A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "vivo S16",
    "Device": "PD2244",
    "Model": "V2244A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "vivo S16 Pro",
    "Device": "PD2245",
    "Model": "V2245A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "vivo S16e",
    "Device": "PD2239",
    "Model": "V2239A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "vivo S17e",
    "Device": "PD2285",
    "Model": "V2285A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "vivo S18",
    "Device": "PD2323",
    "Model": "V2323A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "vivo S18e",
    "Device": "PD2334",
    "Model": "V2334A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "vivo S19",
    "Device": "PD2364",
    "Model": "V2364A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "vivo T2",
    "Device": "PD2199",
    "Model": "V2199GA"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "vivo T3 Pro 5G",
    "Device": "V2404",
    "Model": "V2404"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "vivo T4 5G",
    "Device": "V2502",
    "Model": "V2502"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "vivo T4x 5G",
    "Device": "V2437",
    "Model": "V2437"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "vivo V50 Lite",
    "Device": "V2441",
    "Model": "V2441"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "vivo V50 Lite",
    "Device": "V2441",
    "Model": "V2453"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "vivo V50e",
    "Device": "V2428",
    "Model": "V2428"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "vivo X Fold",
    "Device": "PD2178",
    "Model": "V2178A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "vivo X Fold+",
    "Device": "PD2229",
    "Model": "V2229A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "vivo X Fold2",
    "Device": "PD2266",
    "Model": "V2266A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "vivo X Fold3",
    "Device": "PD2303",
    "Model": "V2303A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "vivo X Note",
    "Device": "PD2170",
    "Model": "V2170A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "vivo X20",
    "Device": "PD1709",
    "Model": "vivo PD1709"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "vivo X20",
    "Device": "PD1709",
    "Model": "vivo X20A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "vivo X200",
    "Device": "PD2415",
    "Model": "V2415A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "vivo X200",
    "Device": "V2415",
    "Model": "V2415"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "vivo X200 Pro mini",
    "Device": "PD2419",
    "Model": "V2419A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "vivo X200s",
    "Device": "PD2415",
    "Model": "V2458A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "vivo X20Plus",
    "Device": "PD1710",
    "Model": "vivo PD1710"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "vivo X20Plus",
    "Device": "PD1710",
    "Model": "vivo X20Plus A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "vivo X20Plus UD",
    "Device": "PD1721",
    "Model": "vivo PD1721"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "vivo X20Plus UD",
    "Device": "PD1721",
    "Model": "vivo X20Plus UD"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "vivo X21A",
    "Device": "PD1728",
    "Model": "vivo X21A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "vivo X21UD A",
    "Device": "PD1728UD",
    "Model": "vivo X21UD A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "vivo X70 Pro+",
    "Device": 2114,
    "Model": "V2114"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "vivo X80",
    "Device": "PD2183",
    "Model": "V2183A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "vivo X80 Pro",
    "Device": "PD2185",
    "Model": "V2185A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "vivo X80 Pro 天玑9000版",
    "Device": "PD2186",
    "Model": "V2186A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "vivo X90",
    "Device": "PD2241",
    "Model": "V2241A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "vivo X90 Pro",
    "Device": "PD2242",
    "Model": "V2242A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "vivo X90 Pro+",
    "Device": "PD2227",
    "Model": "V2227A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "vivo X90s",
    "Device": "PD2241",
    "Model": "V2241HA"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "vivo X9Plus",
    "Device": "PD1619",
    "Model": "vivo X9Plus"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "vivo X9s",
    "Device": "PD1616B",
    "Model": "vivo PD1616B"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "vivo X9s",
    "Device": "PD1616B",
    "Model": "vivo X9s"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "vivo X9s Plus",
    "Device": "PD1635",
    "Model": "vivo PD1635"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "vivo X9s Plus",
    "Device": "PD1635",
    "Model": "vivo X9s Plus"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "vivo Y04",
    "Device": "V2430",
    "Model": "V2430"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "vivo Y04",
    "Device": "V2430",
    "Model": "V2438"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "vivo Y04",
    "Device": "V2430",
    "Model": "V2531"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "vivo Y04",
    "Device": "V2430",
    "Model": "V2547"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "vivo Y100i长续航版",
    "Device": "PD2312",
    "Model": "V2312BA"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "vivo Y11",
    "Device": "Y11",
    "Model": "vivo Y11"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "vivo Y19e",
    "Device": "V2430",
    "Model": "V2431"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "vivo Y19s",
    "Device": "V2419",
    "Model": "V2419"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "vivo Y19s",
    "Device": "V2419",
    "Model": "V2423"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "vivo Y22",
    "Device": "V2207",
    "Model": "V2207"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "vivo Y22",
    "Device": "V2207",
    "Model": "V2238"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "vivo Y22",
    "Device": "Y22",
    "Model": "vivo Y22"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "vivo Y28",
    "Device": "Y28",
    "Model": "vivo Y28"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "vivo Y29",
    "Device": "V2434",
    "Model": "V2434"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "vivo Y29",
    "Device": "V2434",
    "Model": "V2435"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "vivo Y29",
    "Device": "V2434L",
    "Model": "V2434"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "vivo Y29 5G",
    "Device": "V2420",
    "Model": "V2420"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "vivo Y300",
    "Device": "PD2435",
    "Model": "V2435A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "vivo Y300 Pro+",
    "Device": "PD2456",
    "Model": "V2456A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "vivo Y300i",
    "Device": "PD2444",
    "Model": "V2444A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "vivo Y300t",
    "Device": "PD2445",
    "Model": "V2445EA"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "vivo Y36c",
    "Device": "PD2357",
    "Model": "V2357A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "vivo Y37",
    "Device": "PD2357",
    "Model": "V2357A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "vivo Y37m",
    "Device": "PD2357",
    "Model": "V2357EA"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "vivo Y39 5G",
    "Device": "V2436",
    "Model": "V2436"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "vivo Y39 5G",
    "Device": "V2436",
    "Model": "V2443"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "vivo Y39 5G",
    "Device": "V2436",
    "Model": "V2447"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "vivo Y65",
    "Device": 1719,
    "Model": "vivo 1719"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "vivo Y66i A",
    "Device": "PD1621B",
    "Model": "vivo Y66i A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "vivo Y69A",
    "Device": "PD1705",
    "Model": "vivo Y69A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "vivo Y71A",
    "Device": "PD1731",
    "Model": "vivo Y71A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "vivo Y75A",
    "Device": "PD1718",
    "Model": "vivo Y75A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "vivo Y75s",
    "Device": "PD2069",
    "Model": "V2069BA"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "vivo Y77",
    "Device": "PD2219",
    "Model": "V2219A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "vivo Y78t",
    "Device": "PD2312",
    "Model": "V2312BA"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "vivo Y83A",
    "Device": "PD1803",
    "Model": "vivo Y83A"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "vivo Z1i",
    "Device": "PD1730D",
    "Model": "vivo Y89"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "vivo Z1i",
    "Device": "PD1730D",
    "Model": "vivo Z1i"
  },
  {
    "Retail Branding": "Vivo",
    "Marketing Name": "vivo Z3x",
    "Device": "PD1730G",
    "Model": "vivo Z3x"
  },
  {
    "Retail Branding": "Viwa",
    "Marketing Name": "LIGHT ONE",
    "Device": "VIWA_LIGHT_ONE",
    "Model": "LIGHT ONE"
  },
  {
    "Retail Branding": "Viwa",
    "Marketing Name": "LIGHT PLUS",
    "Device": "VIWA_LIGHT_PLUS",
    "Model": "LIGHT PLUS"
  },
  {
    "Retail Branding": "Viwa",
    "Marketing Name": "LIGHT X",
    "Device": "LIGHT_X",
    "Model": "LIGHT X"
  },
  {
    "Retail Branding": "Viwa",
    "Marketing Name": "M4",
    "Device": "M4",
    "Model": "M4"
  },
  {
    "Retail Branding": "Viwa",
    "Marketing Name": "VISION",
    "Device": "VIWA_VISION",
    "Model": "VISION"
  },
  {
    "Retail Branding": "Viwa",
    "Marketing Name": "VIWA_V10",
    "Device": "VIWA_V10",
    "Model": "VIWA_V10"
  },
  {
    "Retail Branding": "Viwa",
    "Marketing Name": "VIWA_V20",
    "Device": "VIWA_V20",
    "Model": "VIWA_V20"
  },
  {
    "Retail Branding": "Viwa",
    "Marketing Name": "X2",
    "Device": "VIWA_X2",
    "Model": "X2"
  },
  {
    "Retail Branding": "Vizio",
    "Marketing Name": "StreamPlayer",
    "Device": "VAP430",
    "Model": "VAP430"
  },
  {
    "Retail Branding": "Vizio",
    "Marketing Name": "VTAB1008",
    "Device": "VTAB1008",
    "Model": "VTAB1008"
  },
  {
    "Retail Branding": "Vizio",
    "Marketing Name": "XR6M10",
    "Device": "XR6M10",
    "Model": "XR6M10"
  },
  {
    "Retail Branding": "Vizio",
    "Marketing Name": "XR6P10",
    "Device": "XR6P10",
    "Model": "XR6P10"
  },
  {
    "Retail Branding": "Vizmo",
    "Marketing Name": "VIZ070TAB711",
    "Device": "VIZ070TAB711",
    "Model": "VIZ070TAB711"
  },
  {
    "Retail Branding": "Vizmo",
    "Marketing Name": "VIZ070TAB811BLU",
    "Device": "VIZ070TAB811BLU",
    "Model": "VIZ070TAB811BLU"
  },
  {
    "Retail Branding": "Vizmo",
    "Marketing Name": "VIZ070TAB811PNK",
    "Device": "VIZ070TAB811PNK",
    "Model": "VIZ070TAB811PNK"
  },
  {
    "Retail Branding": "Vizmo",
    "Marketing Name": "VIZ101TAB711",
    "Device": "VIZ101TAB711",
    "Model": "VIZ101TAB711"
  },
  {
    "Retail Branding": "Vizmo",
    "Marketing Name": "VIZ101TAB811BLK",
    "Device": "VIZ101TAB811BLK",
    "Model": "VIZ101TAB811BLK"
  },
  {
    "Retail Branding": "Vizualogic",
    "Marketing Name": "Q83",
    "Device": "Q83",
    "Model": "Q83"
  },
  {
    "Retail Branding": "Vkworld",
    "Marketing Name": "K1",
    "Device": "K1",
    "Model": "K1"
  },
  {
    "Retail Branding": "Vkworld",
    "Marketing Name": "Mix3",
    "Device": "Mix3",
    "Model": "Mix3"
  },
  {
    "Retail Branding": "Vkworld",
    "Marketing Name": "Mix_Plus",
    "Device": "Mix_Plus",
    "Model": "Mix_Plus"
  },
  {
    "Retail Branding": "Vkworld",
    "Marketing Name": "S8",
    "Device": "vkworld_S8",
    "Model": "S8"
  },
  {
    "Retail Branding": "Vkworld",
    "Marketing Name": "S8Lite",
    "Device": "S8Lite",
    "Model": "S8Lite"
  },
  {
    "Retail Branding": "Vkworld",
    "Marketing Name": "S9",
    "Device": "S9",
    "Model": "S9"
  },
  {
    "Retail Branding": "Vkworld",
    "Marketing Name": "VK400",
    "Device": "VK4000",
    "Model": "VK4000"
  },
  {
    "Retail Branding": "Vkworld",
    "Marketing Name": "VK7000",
    "Device": "VK7000",
    "Model": "VK7000"
  },
  {
    "Retail Branding": "Vmobile",
    "Marketing Name": "A10_Y",
    "Device": "A10_Y",
    "Model": "A10_Y"
  },
  {
    "Retail Branding": "Vmobile",
    "Marketing Name": "A11_N",
    "Device": "A11_N",
    "Model": "A11_N"
  },
  {
    "Retail Branding": "Vmobile",
    "Marketing Name": "A11_Y",
    "Device": "A11_Y",
    "Model": "A11_Y"
  },
  {
    "Retail Branding": "Vmobile",
    "Marketing Name": "A13",
    "Device": "A13",
    "Model": "A13"
  },
  {
    "Retail Branding": "Vmobile",
    "Marketing Name": "A13_Y",
    "Device": "A13_Y",
    "Model": "A13_Y"
  },
  {
    "Retail Branding": "Vmobile",
    "Marketing Name": "A15",
    "Device": "A15",
    "Model": "A15"
  },
  {
    "Retail Branding": "Vocal",
    "Marketing Name": "V01",
    "Device": "V01",
    "Model": "VOCAL V01"
  },
  {
    "Retail Branding": "Vocal",
    "Marketing Name": "V0Core",
    "Device": "V0Core",
    "Model": "VOCAL V0Core"
  },
  {
    "Retail Branding": "Vocal",
    "Marketing Name": "V11",
    "Device": "V11",
    "Model": "VOCAL V11"
  },
  {
    "Retail Branding": "Vocal",
    "Marketing Name": "Vocal V1 Core",
    "Device": "V1_Core",
    "Model": "Vocal V1 Core"
  },
  {
    "Retail Branding": "Vocal",
    "Marketing Name": "Vocal V2 Pro",
    "Device": "V2_Pro",
    "Model": "Vocal V2 Pro"
  },
  {
    "Retail Branding": "Vocal",
    "Marketing Name": "v0",
    "Device": "v0",
    "Model": "VOCAL V0"
  },
  {
    "Retail Branding": "Vocal",
    "Marketing Name": "v1",
    "Device": "v1",
    "Model": "VOCAL V1"
  },
  {
    "Retail Branding": "Vodacom",
    "Marketing Name": "Kicka7",
    "Device": "H6032_VDC",
    "Model": "Kicka7"
  },
  {
    "Retail Branding": "Vodacom",
    "Marketing Name": "Neon_Ultra_2",
    "Device": "Neon_Ultra_2",
    "Model": "Neon Ultra 2 TZ"
  },
  {
    "Retail Branding": "Vodacom",
    "Marketing Name": "Sechocha_Ultra_2",
    "Device": "Sechocha_Ultra_2",
    "Model": "Sechocha Ultra 2"
  },
  {
    "Retail Branding": "Vodafone",
    "Marketing Name": 785,
    "Device": "Vodafone_785",
    "Model": "Vodafone 785"
  },
  {
    "Retail Branding": "Vodafone",
    "Marketing Name": 895,
    "Device": "VF-895N",
    "Model": "VF-895N"
  },
  {
    "Retail Branding": "Vodafone",
    "Marketing Name": "GigaTV Net",
    "Device": "diw362",
    "Model": "GigaTV"
  },
  {
    "Retail Branding": "Vodafone",
    "Marketing Name": "Smart N8",
    "Device": "VFD610",
    "Model": "VFD 610"
  },
  {
    "Retail Branding": "Vodafone",
    "Marketing Name": "Smart Tab 4",
    "Device": "Vodafone_Smart_Tab_4",
    "Model": "Vodafone Smart Tab 4"
  },
  {
    "Retail Branding": "Vodafone",
    "Marketing Name": "Smart Tab N8",
    "Device": "VFD1300",
    "Model": "VFD 1300"
  },
  {
    "Retail Branding": "Vodafone",
    "Marketing Name": "Smart V8",
    "Device": "VFD710",
    "Model": "VFD 710"
  },
  {
    "Retail Branding": "Vodafone",
    "Marketing Name": "Smart first 7",
    "Device": "P731V35",
    "Model": "VFD 200"
  },
  {
    "Retail Branding": "Vodafone",
    "Marketing Name": "Smart mini 7",
    "Device": "VFD300",
    "Model": "VFD 300"
  },
  {
    "Retail Branding": "Vodafone",
    "Marketing Name": "Smart mini 7 dual",
    "Device": "VFD301",
    "Model": "VFD 301"
  },
  {
    "Retail Branding": "Vodafone",
    "Marketing Name": "Smart platinum 7",
    "Device": "VFD900",
    "Model": "VFD 900"
  },
  {
    "Retail Branding": "Vodafone",
    "Marketing Name": "Smart prime 7",
    "Device": "P809V50",
    "Model": "VFD 600"
  },
  {
    "Retail Branding": "Vodafone",
    "Marketing Name": "Smart turbo 7",
    "Device": "VFD500",
    "Model": "VFD 500"
  },
  {
    "Retail Branding": "Vodafone",
    "Marketing Name": "Smart turbo 7",
    "Device": "VFD501",
    "Model": "VFD 501"
  },
  {
    "Retail Branding": "Vodafone",
    "Marketing Name": "Smart turbo 7 dual",
    "Device": "VFD502",
    "Model": "VFD 502"
  },
  {
    "Retail Branding": "Vodafone",
    "Marketing Name": "Smart ultra 6",
    "Device": "P839V55",
    "Model": "Vodafone Smart ultra 6"
  },
  {
    "Retail Branding": "Vodafone",
    "Marketing Name": "Smart ultra 7",
    "Device": "VFD700",
    "Model": "Maxis VFD700"
  },
  {
    "Retail Branding": "Vodafone",
    "Marketing Name": "Smart ultra 7",
    "Device": "VFD700",
    "Model": "VFD 700"
  },
  {
    "Retail Branding": "Vodafone",
    "Marketing Name": "SmartV22",
    "Device": "Smart_V22",
    "Model": "SmartV22"
  },
  {
    "Retail Branding": "Vodafone",
    "Marketing Name": "Smart_N9_Lite",
    "Device": "VFD620",
    "Model": "VFD 620"
  },
  {
    "Retail Branding": "Vodafone",
    "Marketing Name": "Smart_Tab_3G",
    "Device": "Vodafone_Smart_Tab_3G",
    "Model": "Vodafone Smart Tab 3G"
  },
  {
    "Retail Branding": "Vodafone",
    "Marketing Name": "Smart_Tab_4G",
    "Device": "Vodafone_Smart_Tab_4G",
    "Model": "Vodafone Smart Tab 4G"
  },
  {
    "Retail Branding": "Vodafone",
    "Marketing Name": "TV Stick",
    "Device": "HP46D",
    "Model": "VODAFONE TV STICK 1"
  },
  {
    "Retail Branding": "Vodafone",
    "Marketing Name": "Tab Prime 7",
    "Device": "VFD1400",
    "Model": "VFD 1400"
  },
  {
    "Retail Branding": "Vodafone",
    "Marketing Name": "Tab Prime 7",
    "Device": "VFD1400",
    "Model": "VFD1400"
  },
  {
    "Retail Branding": "Vodafone",
    "Marketing Name": "Tab mini 7",
    "Device": "Tab7",
    "Model": "VFD 1100"
  },
  {
    "Retail Branding": "Vodafone",
    "Marketing Name": "V Lite 3",
    "Device": "V_Lite_3",
    "Model": "V Lite 3"
  },
  {
    "Retail Branding": "Vodafone",
    "Marketing Name": "V Pro 3",
    "Device": "V_Pro_3",
    "Model": "V Pro 3"
  },
  {
    "Retail Branding": "Vodafone",
    "Marketing Name": "VDF 600",
    "Device": "P809V50",
    "Model": "VFD 600"
  },
  {
    "Retail Branding": "Vodafone",
    "Marketing Name": "VF-1296",
    "Device": "voda_tab",
    "Model": "Vodacom Power Tab 10"
  },
  {
    "Retail Branding": "Vodafone",
    "Marketing Name": "VF-1296",
    "Device": "voda_tab",
    "Model": "Vodafone Tab grand 6"
  },
  {
    "Retail Branding": "Vodafone",
    "Marketing Name": "VF-1397",
    "Device": "Vodafone_Tab_speed_6",
    "Model": "VF-1397"
  },
  {
    "Retail Branding": "Vodafone",
    "Marketing Name": "VF-1497",
    "Device": "Vodafone_Tab_Prime",
    "Model": "VF-1497"
  },
  {
    "Retail Branding": "Vodafone",
    "Marketing Name": "VF-696",
    "Device": "smart_grand",
    "Model": "VF-696"
  },
  {
    "Retail Branding": "Vodafone",
    "Marketing Name": "VF685",
    "Device": "VF685",
    "Model": "VF685"
  },
  {
    "Retail Branding": "Vodafone",
    "Marketing Name": "VF695",
    "Device": "VF695",
    "Model": "VF695"
  },
  {
    "Retail Branding": "Vodafone",
    "Marketing Name": "VFD 200",
    "Device": "P731V35",
    "Model": "VFD 200"
  },
  {
    "Retail Branding": "Vodafone",
    "Marketing Name": "VFD320",
    "Device": "VFD320",
    "Model": "VFD320"
  },
  {
    "Retail Branding": "Vodafone",
    "Marketing Name": "VFD321",
    "Device": "VFD321",
    "Model": "VFD321"
  },
  {
    "Retail Branding": "Vodafone",
    "Marketing Name": "VIP6102W",
    "Device": "vip6102w",
    "Model": "VIP6102W"
  },
  {
    "Retail Branding": "Vodafone",
    "Marketing Name": "VODAFONE TV",
    "Device": "m393gena_vf",
    "Model": "VODAFONE TV"
  },
  {
    "Retail Branding": "Vodafone",
    "Marketing Name": "Vodacom Kicka VE",
    "Device": "VFD100",
    "Model": "VFD 100"
  },
  {
    "Retail Branding": "Vodafone",
    "Marketing Name": "Vodacom Smart 4G",
    "Device": "VFD525",
    "Model": "VFD 525"
  },
  {
    "Retail Branding": "Vodafone",
    "Marketing Name": "Vodafone Smart E8",
    "Device": "VFD510",
    "Model": "VFD 510"
  },
  {
    "Retail Branding": "Vodafone",
    "Marketing Name": "Vodafone Smart E8",
    "Device": "VFD511",
    "Model": "VFD 511"
  },
  {
    "Retail Branding": "Vodafone",
    "Marketing Name": "Vodafone Smart E8",
    "Device": "VFD512",
    "Model": "VFD 512"
  },
  {
    "Retail Branding": "Vodafone",
    "Marketing Name": "Vodafone Smart E8",
    "Device": "VFD513",
    "Model": "VFD 513"
  },
  {
    "Retail Branding": "Vodafone",
    "Marketing Name": "Vodafone Smart E9",
    "Device": "VFD527",
    "Model": "VFD 527"
  },
  {
    "Retail Branding": "Vodafone",
    "Marketing Name": "Vodafone Smart E9",
    "Device": "VFD528",
    "Model": "VFD 528"
  },
  {
    "Retail Branding": "Vodafone",
    "Marketing Name": "Vodafone Smart E9",
    "Device": "VFD529",
    "Model": "VFD 529"
  },
  {
    "Retail Branding": "Vodafone",
    "Marketing Name": "Vodafone Smart N10",
    "Device": "VFD630",
    "Model": "VFD 630"
  },
  {
    "Retail Branding": "Vodafone",
    "Marketing Name": "Vodafone Smart N9",
    "Device": "VFD720",
    "Model": "VFD 720"
  },
  {
    "Retail Branding": "Vodafone",
    "Marketing Name": "Vodafone Smart V10",
    "Device": "VFD730",
    "Model": "VFD 730"
  },
  {
    "Retail Branding": "Vodafone",
    "Marketing Name": "Vodafone Smart X9",
    "Device": "VFD820",
    "Model": "VFD 820"
  },
  {
    "Retail Branding": "Vodafone",
    "Marketing Name": "Vodafone Smart mini",
    "Device": "Vodafone_875",
    "Model": "Vodafone 875"
  },
  {
    "Retail Branding": "Vodafone",
    "Marketing Name": "Vodafone Smart mini 7 ve",
    "Device": "U3_3G",
    "Model": "VFD 310"
  },
  {
    "Retail Branding": "Vodafone",
    "Marketing Name": "Vodafone Smart mini 7 ve dual",
    "Device": "U3_3G",
    "Model": "VFD 311"
  },
  {
    "Retail Branding": "Vodafone",
    "Marketing Name": "Vodafone TV",
    "Device": "uiw4030vha",
    "Model": "Vodafone TV"
  },
  {
    "Retail Branding": "Vodafone",
    "Marketing Name": "Vodafone TV 3",
    "Device": "m377_vf",
    "Model": "Vodafone TV 3"
  },
  {
    "Retail Branding": "Voger",
    "Marketing Name": "X100",
    "Device": "X100",
    "Model": "X100"
  },
  {
    "Retail Branding": "Voger",
    "Marketing Name": "X100_EEA",
    "Device": "X100_EEA",
    "Model": "X100_EEA"
  },
  {
    "Retail Branding": "Volkano",
    "Marketing Name": "Cosmic",
    "Device": "VK_5400_BK",
    "Model": "VK_5400_BK"
  },
  {
    "Retail Branding": "Volkano",
    "Marketing Name": "VK74012BLV2",
    "Device": "VK74012BLV2",
    "Model": "VK74012BLV2"
  },
  {
    "Retail Branding": "Volkano",
    "Marketing Name": "VK_740_12",
    "Device": "VK_740_12",
    "Model": "VK_740_12"
  },
  {
    "Retail Branding": "Volt Mobile",
    "Marketing Name": "VOLT_SV451_Vision",
    "Device": "VOLT_SV451_Vision",
    "Model": "VOLT_SV451_Vision"
  },
  {
    "Retail Branding": "Volt Mobile",
    "Marketing Name": "v7",
    "Device": "v7",
    "Model": "v7"
  },
  {
    "Retail Branding": "Volvo",
    "Marketing Name": "EX30",
    "Device": "habanero",
    "Model": "EX30"
  },
  {
    "Retail Branding": "Volvo",
    "Marketing Name": "Volvo",
    "Device": "ihu_abl_car",
    "Model": "Volvo"
  },
  {
    "Retail Branding": "Volvo",
    "Marketing Name": "Volvo",
    "Device": "moose",
    "Model": "Volvo"
  },
  {
    "Retail Branding": "Volvo",
    "Marketing Name": "Volvo XC40 Emulator",
    "Device": "ihu_emulator",
    "Model": "Volvo XC40"
  },
  {
    "Retail Branding": "Vonino",
    "Marketing Name": "Druid_L10",
    "Device": "Druid_L10",
    "Model": "Druid_L10"
  },
  {
    "Retail Branding": "Vonino",
    "Marketing Name": "Epic E8",
    "Device": "Epic_E8",
    "Model": "Epic E8"
  },
  {
    "Retail Branding": "Vonino",
    "Marketing Name": "Epic P7",
    "Device": "Epic_P7",
    "Model": "Epic_P7"
  },
  {
    "Retail Branding": "Vonino",
    "Marketing Name": "G50_PRO",
    "Device": "G50_PRO",
    "Model": "G50_PRO"
  },
  {
    "Retail Branding": "Vonino",
    "Marketing Name": "JAX_M",
    "Device": "JAX_M",
    "Model": "JAX_M"
  },
  {
    "Retail Branding": "Vonino",
    "Marketing Name": "Jax X",
    "Device": "Jax_X",
    "Model": "Jax X"
  },
  {
    "Retail Branding": "Vonino",
    "Marketing Name": "Jax X A6",
    "Device": "Jax_X",
    "Model": "Jax X"
  },
  {
    "Retail Branding": "Vonino",
    "Marketing Name": "Jax_N",
    "Device": "JAX_N",
    "Model": "JAX_N"
  },
  {
    "Retail Branding": "Vonino",
    "Marketing Name": "Jax_S",
    "Device": "Jax_S_A7",
    "Model": "Jax_S_A7"
  },
  {
    "Retail Branding": "Vonino",
    "Marketing Name": "Jax_X_TM",
    "Device": "JAX",
    "Model": "Jax X"
  },
  {
    "Retail Branding": "Vonino",
    "Marketing Name": "MAGNET_G90",
    "Device": "MAGNET_G90",
    "Model": "MAGNET_G90"
  },
  {
    "Retail Branding": "Vonino",
    "Marketing Name": "Magnet M1_A7",
    "Device": "Magnet_M1_A7",
    "Model": "Magnet M1"
  },
  {
    "Retail Branding": "Vonino",
    "Marketing Name": "Magnet_G10",
    "Device": "Magnet_G10",
    "Model": "Magnet_G10"
  },
  {
    "Retail Branding": "Vonino",
    "Marketing Name": "Magnet_G20",
    "Device": "Magnet_G50",
    "Model": "Magnet_G20"
  },
  {
    "Retail Branding": "Vonino",
    "Marketing Name": "Magnet_G25",
    "Device": "Magnet_G50",
    "Model": "Magnet_G25"
  },
  {
    "Retail Branding": "Vonino",
    "Marketing Name": "Magnet_G30_EEA",
    "Device": "Magnet_G30",
    "Model": "Magnet_G30"
  },
  {
    "Retail Branding": "Vonino",
    "Marketing Name": "Magnet_G30_lite",
    "Device": "Magnet_G30",
    "Model": "Magnet_G30_lite"
  },
  {
    "Retail Branding": "Vonino",
    "Marketing Name": "Magnet_G40",
    "Device": "Magnet_G50",
    "Model": "Magnet_G40"
  },
  {
    "Retail Branding": "Vonino",
    "Marketing Name": "Magnet_G50",
    "Device": "Magnet_G50",
    "Model": "Magnet_G50"
  },
  {
    "Retail Branding": "Vonino",
    "Marketing Name": "Magnet_G50_lite",
    "Device": "Magnet_G50_lite",
    "Model": "Magnet_G50_lite"
  },
  {
    "Retail Branding": "Vonino",
    "Marketing Name": "Magnet_M1",
    "Device": "Magnet_M1",
    "Model": "Magnet M1"
  },
  {
    "Retail Branding": "Vonino",
    "Marketing Name": "Magnet_M10",
    "Device": "Magnet_M10",
    "Model": "Magnet_M10"
  },
  {
    "Retail Branding": "Vonino",
    "Marketing Name": "Magnet_M10_2020",
    "Device": "Magnet_M10_2020",
    "Model": "Magnet_M10_2020"
  },
  {
    "Retail Branding": "Vonino",
    "Marketing Name": "Magnet_W10",
    "Device": "Magnet_W10",
    "Model": "Magnet_W10"
  },
  {
    "Retail Branding": "Vonino",
    "Marketing Name": "MusicPAD",
    "Device": "MusicPAD",
    "Model": "MusicPAD"
  },
  {
    "Retail Branding": "Vonino",
    "Marketing Name": "Navo  P",
    "Device": "Navo_P",
    "Model": "Navo_P"
  },
  {
    "Retail Branding": "Vonino",
    "Marketing Name": "Navo QS",
    "Device": "Navo_QS",
    "Model": "Navo_QS"
  },
  {
    "Retail Branding": "Vonino",
    "Marketing Name": "Navo S",
    "Device": "Navo_S",
    "Model": "Navo S"
  },
  {
    "Retail Branding": "Vonino",
    "Marketing Name": "Pluri B7",
    "Device": "Pluri_B7",
    "Model": "Pluri B7"
  },
  {
    "Retail Branding": "Vonino",
    "Marketing Name": "Pluri C7",
    "Device": "Pluri_C7",
    "Model": "Pluri C7"
  },
  {
    "Retail Branding": "Vonino",
    "Marketing Name": "Pluri C8",
    "Device": "Pluri_C8",
    "Model": "Pluri C8"
  },
  {
    "Retail Branding": "Vonino",
    "Marketing Name": "Pluri M7",
    "Device": "Pluri_M7",
    "Model": "Pluri_M7"
  },
  {
    "Retail Branding": "Vonino",
    "Marketing Name": "Pluri M7 A6",
    "Device": "Pluri_M7",
    "Model": "Pluri_M7"
  },
  {
    "Retail Branding": "Vonino",
    "Marketing Name": "Pluri Q8",
    "Device": "Pluri_Q8",
    "Model": "Pluri_Q8"
  },
  {
    "Retail Branding": "Vonino",
    "Marketing Name": "Pluri Q8 A6",
    "Device": "Pluri_Q8",
    "Model": "Pluri_Q8"
  },
  {
    "Retail Branding": "Vonino",
    "Marketing Name": "Pluri Q8 TM",
    "Device": "Pluri_Q8",
    "Model": "Pluri_Q8"
  },
  {
    "Retail Branding": "Vonino",
    "Marketing Name": "Pluri_B7_TM",
    "Device": "Pluri_B7_TM",
    "Model": "Pluri_B7_TM"
  },
  {
    "Retail Branding": "Vonino",
    "Marketing Name": "Pluri_G7",
    "Device": "Pluri_G7",
    "Model": "Pluri G7"
  },
  {
    "Retail Branding": "Vonino",
    "Marketing Name": "Pluri_M7_2020",
    "Device": "Pluri_M7_2020",
    "Model": "Pluri_M7_2020"
  },
  {
    "Retail Branding": "Vonino",
    "Marketing Name": "Pluri_M8",
    "Device": "Pluri_M8",
    "Model": "Pluri_M8"
  },
  {
    "Retail Branding": "Vonino",
    "Marketing Name": "Pluri_M8_2020",
    "Device": "Pluri_M8_2020",
    "Model": "Pluri_M8_2020"
  },
  {
    "Retail Branding": "Vonino",
    "Marketing Name": "Pluri_M8_2020_A10",
    "Device": "Pluri_M8_2020_A10",
    "Model": "Pluri_M8_2020_A10"
  },
  {
    "Retail Branding": "Vonino",
    "Marketing Name": "Volt S",
    "Device": "Volt_S",
    "Model": "Volt S"
  },
  {
    "Retail Branding": "Vonino",
    "Marketing Name": "Volt_S",
    "Device": "Volt_S_A7",
    "Model": "Volt_S_A7"
  },
  {
    "Retail Branding": "Vonino",
    "Marketing Name": "Volt_X",
    "Device": "Volt_X",
    "Model": "Volt_X"
  },
  {
    "Retail Branding": "Vonino",
    "Marketing Name": "Xavy G7",
    "Device": "Xavy_G7",
    "Model": "Xavy G7"
  },
  {
    "Retail Branding": "Vonino",
    "Marketing Name": "Xavy L8 A6",
    "Device": "Xavy_L8",
    "Model": "Xavy_L8"
  },
  {
    "Retail Branding": "Vonino",
    "Marketing Name": "Xavy T7 A6",
    "Device": "Xavy_T7",
    "Model": "Xavy_T7"
  },
  {
    "Retail Branding": "Vonino",
    "Marketing Name": "Xavy_G8",
    "Device": "Xavy_G8",
    "Model": "Xavy_G8"
  },
  {
    "Retail Branding": "Vonino",
    "Marketing Name": "Xavy_L8",
    "Device": "Xavy_L8",
    "Model": "Xavy_L8"
  },
  {
    "Retail Branding": "Vonino",
    "Marketing Name": "Xavy_T7",
    "Device": "Xavy_T7",
    "Model": "Xavy_T7"
  },
  {
    "Retail Branding": "Vonino",
    "Marketing Name": "Xylo  P",
    "Device": "Xylo_P",
    "Model": "Xylo P"
  },
  {
    "Retail Branding": "Vonino",
    "Marketing Name": "Xylo X A6",
    "Device": "Xylo_X",
    "Model": "Xylo X"
  },
  {
    "Retail Branding": "Vonino",
    "Marketing Name": "Xylo_T",
    "Device": "Xylo_T",
    "Model": "Xylo_T"
  },
  {
    "Retail Branding": "Vonino",
    "Marketing Name": "Xylo_X_TM",
    "Device": "Xylo",
    "Model": "Xylo X"
  },
  {
    "Retail Branding": "Vonino",
    "Marketing Name": "Xylo_Z",
    "Device": "Xylo_Z",
    "Model": "Xylo"
  },
  {
    "Retail Branding": "Vonino",
    "Marketing Name": "ZUN XO",
    "Device": "ZUN_XO",
    "Model": "ZUN XO"
  },
  {
    "Retail Branding": "Vonino",
    "Marketing Name": "ZUN XO A6",
    "Device": "Zun_XO",
    "Model": "ZUN XO"
  },
  {
    "Retail Branding": "Vonino",
    "Marketing Name": "Zun X",
    "Device": "Zun_X",
    "Model": "Zun X"
  },
  {
    "Retail Branding": "Vonino",
    "Marketing Name": "Zun X A6",
    "Device": "Zun_X",
    "Model": "Zun X"
  },
  {
    "Retail Branding": "Vonino",
    "Marketing Name": "Zun XS",
    "Device": "Zun_XS",
    "Model": "Zun XS"
  },
  {
    "Retail Branding": "Vonino",
    "Marketing Name": "Zun_N",
    "Device": "Zun_N",
    "Model": "Zun_N"
  },
  {
    "Retail Branding": "Vonino",
    "Marketing Name": "iMart_MAX",
    "Device": "iMart_MAX",
    "Model": "iMart_MAX"
  },
  {
    "Retail Branding": "Vonino",
    "Marketing Name": "iMart_Pro",
    "Device": "iMart_Pro",
    "Model": "iMart_Pro"
  },
  {
    "Retail Branding": "Vonino",
    "Marketing Name": "jax_S",
    "Device": "Jax_S",
    "Model": "Jax_S"
  },
  {
    "Retail Branding": "Voo",
    "Marketing Name": "DV8220",
    "Device": "DV8220",
    "Model": "DV8220"
  },
  {
    "Retail Branding": "Voo",
    "Marketing Name": "VOO Box",
    "Device": "SEI700TMM",
    "Model": "VOO Box"
  },
  {
    "Retail Branding": "Vorago",
    "Marketing Name": "PAD-7",
    "Device": "PAD-7",
    "Model": "PAD-7"
  },
  {
    "Retail Branding": "Vorago",
    "Marketing Name": "PAD-7-KIDS",
    "Device": "PAD-7-KIDS",
    "Model": "PAD-7-KIDS"
  },
  {
    "Retail Branding": "Vorago",
    "Marketing Name": "PAD-7-V5",
    "Device": "PAD-7-V5",
    "Model": "PAD-7-V5"
  },
  {
    "Retail Branding": "Vorago",
    "Marketing Name": "PAD-7-V6",
    "Device": "PAD-7-V6",
    "Model": "PAD-7-V6"
  },
  {
    "Retail Branding": "Vorago",
    "Marketing Name": "PAD-8",
    "Device": "PAD-8",
    "Model": "PAD-8"
  },
  {
    "Retail Branding": "Vortex",
    "Marketing Name": "A24",
    "Device": "A24",
    "Model": "A24"
  },
  {
    "Retail Branding": "Vortex",
    "Marketing Name": "B55",
    "Device": "B55",
    "Model": "B55"
  },
  {
    "Retail Branding": "Vortex",
    "Marketing Name": "BTAB8M",
    "Device": "BTAB8M",
    "Model": "BTAB8M"
  },
  {
    "Retail Branding": "Vortex",
    "Marketing Name": "Beat 8",
    "Device": "BEAT8",
    "Model": "BEAT 8"
  },
  {
    "Retail Branding": "Vortex",
    "Marketing Name": "C24",
    "Device": "C24",
    "Model": "C24"
  },
  {
    "Retail Branding": "Vortex",
    "Marketing Name": "C24L",
    "Device": "C24L",
    "Model": "C24L"
  },
  {
    "Retail Branding": "Vortex",
    "Marketing Name": "CB68",
    "Device": "CB68",
    "Model": "CB68"
  },
  {
    "Retail Branding": "Vortex",
    "Marketing Name": "CG65",
    "Device": "CG65",
    "Model": "CG65"
  },
  {
    "Retail Branding": "Vortex",
    "Marketing Name": "CG65_Pro",
    "Device": "CG65_Pro",
    "Model": "CG65 Pro"
  },
  {
    "Retail Branding": "Vortex",
    "Marketing Name": "G8",
    "Device": "G8",
    "Model": "G8"
  },
  {
    "Retail Branding": "Vortex",
    "Marketing Name": "HD55",
    "Device": "HD55",
    "Model": "HD55"
  },
  {
    "Retail Branding": "Vortex",
    "Marketing Name": "HD60",
    "Device": "HD60",
    "Model": "HD60"
  },
  {
    "Retail Branding": "Vortex",
    "Marketing Name": "HD60L",
    "Device": "HD60L",
    "Model": "HD60L"
  },
  {
    "Retail Branding": "Vortex",
    "Marketing Name": "HD60i",
    "Device": "HD60i",
    "Model": "HD60i"
  },
  {
    "Retail Branding": "Vortex",
    "Marketing Name": "HD62",
    "Device": "HD62",
    "Model": "HD62"
  },
  {
    "Retail Branding": "Vortex",
    "Marketing Name": "HD65",
    "Device": "HD65",
    "Model": "HD65"
  },
  {
    "Retail Branding": "Vortex",
    "Marketing Name": "HD65_PLUS",
    "Device": "HD65_PLUS",
    "Model": "HD65_PLUS"
  },
  {
    "Retail Branding": "Vortex",
    "Marketing Name": "HD65_Select",
    "Device": "HD65_Select",
    "Model": "HD65_Select"
  },
  {
    "Retail Branding": "Vortex",
    "Marketing Name": "HD65_Ultra",
    "Device": "HD65_Ultra",
    "Model": "HD65_Ultra"
  },
  {
    "Retail Branding": "Vortex",
    "Marketing Name": "HD67",
    "Device": "HD67",
    "Model": "HD67"
  },
  {
    "Retail Branding": "Vortex",
    "Marketing Name": "J24",
    "Device": "J24",
    "Model": "J24"
  },
  {
    "Retail Branding": "Vortex",
    "Marketing Name": "JK68",
    "Device": "JK68",
    "Model": "JK68"
  },
  {
    "Retail Branding": "Vortex",
    "Marketing Name": "MUV",
    "Device": "MUV",
    "Model": "MUV"
  },
  {
    "Retail Branding": "Vortex",
    "Marketing Name": "NS65",
    "Device": "NS65",
    "Model": "NS65"
  },
  {
    "Retail Branding": "Vortex",
    "Marketing Name": "NS68",
    "Device": "NS68",
    "Model": "NS68"
  },
  {
    "Retail Branding": "Vortex",
    "Marketing Name": "PG65",
    "Device": "PG65",
    "Model": "PG65"
  },
  {
    "Retail Branding": "Vortex",
    "Marketing Name": "SYNQ",
    "Device": "SYNQ",
    "Model": "SYNQ"
  },
  {
    "Retail Branding": "Vortex",
    "Marketing Name": "Sync",
    "Device": "Sync",
    "Model": "Sync"
  },
  {
    "Retail Branding": "Vortex",
    "Marketing Name": "T101",
    "Device": "T101",
    "Model": "T101"
  },
  {
    "Retail Branding": "Vortex",
    "Marketing Name": "T10M_Pro",
    "Device": "T10M_Pro",
    "Model": "T10M_Pro"
  },
  {
    "Retail Branding": "Vortex",
    "Marketing Name": "T10U",
    "Device": "T10U",
    "Model": "T10"
  },
  {
    "Retail Branding": "Vortex",
    "Marketing Name": "T8",
    "Device": "T8",
    "Model": "T8"
  },
  {
    "Retail Branding": "Vortex",
    "Marketing Name": "TAB8",
    "Device": "TAB8",
    "Model": "TAB8"
  },
  {
    "Retail Branding": "Vortex",
    "Marketing Name": "TAB8V",
    "Device": "TAB8V",
    "Model": "TAB8V"
  },
  {
    "Retail Branding": "Vortex",
    "Marketing Name": "V22",
    "Device": "V22",
    "Model": "V22"
  },
  {
    "Retail Branding": "Vortex",
    "Marketing Name": "V22S",
    "Device": "V22S",
    "Model": "V22S"
  },
  {
    "Retail Branding": "Vortex",
    "Marketing Name": "V50LTE",
    "Device": "V50LTE",
    "Model": "V50LTE"
  },
  {
    "Retail Branding": "Vortex",
    "Marketing Name": "V65",
    "Device": "V65",
    "Model": "V65"
  },
  {
    "Retail Branding": "Vortex",
    "Marketing Name": "VORTEX BTAB10",
    "Device": "BTAB10",
    "Model": "BTAB10"
  },
  {
    "Retail Branding": "Vortex",
    "Marketing Name": "VORTEX BTAB8U",
    "Device": "VORTEX_BTAB8U",
    "Model": "VORTEX BTAB8U"
  },
  {
    "Retail Branding": "Vortex",
    "Marketing Name": "VORTEX CM62",
    "Device": "CM62",
    "Model": "VORTEX CM62"
  },
  {
    "Retail Branding": "Vortex",
    "Marketing Name": "VORTEX HD65 Choice",
    "Device": "VORTEX_HD65_Choice",
    "Model": "VORTEX HD65 Choice"
  },
  {
    "Retail Branding": "Vortex",
    "Marketing Name": "VORTEX_HD55_Choice",
    "Device": "VORTEX_HD55_Choice",
    "Model": "VORTEX_HD55_Choice"
  },
  {
    "Retail Branding": "Vortex",
    "Marketing Name": "VORTEX_K65",
    "Device": "VORTEX_K65",
    "Model": "VORTEX K65"
  },
  {
    "Retail Branding": "Vortex",
    "Marketing Name": "Vortex N55",
    "Device": "N55",
    "Model": "N55"
  },
  {
    "Retail Branding": "Vortex",
    "Marketing Name": "Vortex Z22",
    "Device": "Z22",
    "Model": "Z22"
  },
  {
    "Retail Branding": "Vortex",
    "Marketing Name": "Vortex Z23",
    "Device": "Z23",
    "Model": "Z23"
  },
  {
    "Retail Branding": "Vortex",
    "Marketing Name": "VortexV20",
    "Device": "VortexV20",
    "Model": "V20"
  },
  {
    "Retail Branding": "Vortex",
    "Marketing Name": "Z67",
    "Device": "Z67",
    "Model": "Z67"
  },
  {
    "Retail Branding": "Vortex",
    "Marketing Name": "Z8",
    "Device": "Z8",
    "Model": "Z8"
  },
  {
    "Retail Branding": "Vortex",
    "Marketing Name": "ZG55",
    "Device": "ZG55",
    "Model": "ZG55"
  },
  {
    "Retail Branding": "Vortex",
    "Marketing Name": "ZG65",
    "Device": "ZG65",
    "Model": "ZG65"
  },
  {
    "Retail Branding": "Vortex",
    "Marketing Name": "ZG65",
    "Device": "ZG65",
    "Model": "ZG65H"
  },
  {
    "Retail Branding": "Vortex",
    "Marketing Name": "ZG65 Pro",
    "Device": "ZG65_Pro",
    "Model": "ZG65 Pro"
  },
  {
    "Retail Branding": "Vortex",
    "Marketing Name": "ZG65s",
    "Device": "ZG65",
    "Model": "ZG65"
  },
  {
    "Retail Branding": "Voto",
    "Marketing Name": "V9",
    "Device": "VOTO_V9",
    "Model": "V9"
  },
  {
    "Retail Branding": "Voto",
    "Marketing Name": "VOTO V2",
    "Device": "VOTO_V2",
    "Model": "VOTO V2"
  },
  {
    "Retail Branding": "Voto",
    "Marketing Name": "VOTO V2i`",
    "Device": "VOTO_V2i",
    "Model": "VOTO V2i"
  },
  {
    "Retail Branding": "Voto",
    "Marketing Name": "VOTO V3",
    "Device": "VOTO_V3",
    "Model": "VOTO V3"
  },
  {
    "Retail Branding": "Voto",
    "Marketing Name": "VX",
    "Device": "VX",
    "Model": "VX"
  },
  {
    "Retail Branding": "Voto",
    "Marketing Name": "Voto V5X",
    "Device": "VOTO_V5X",
    "Model": "VOTO V5X"
  },
  {
    "Retail Branding": "Vsmart",
    "Marketing Name": "AT&T Fusion Z",
    "Device": "v340u",
    "Model": "V340U"
  },
  {
    "Retail Branding": "Vsmart",
    "Marketing Name": "Active 1",
    "Device": "PQ6001",
    "Model": "Active 1"
  },
  {
    "Retail Branding": "Vsmart",
    "Marketing Name": "Active 1 +",
    "Device": "PQ6002",
    "Model": "Active 1+"
  },
  {
    "Retail Branding": "Vsmart",
    "Marketing Name": "Active 1+",
    "Device": "PQ6002",
    "Model": "Active 1+"
  },
  {
    "Retail Branding": "Vsmart",
    "Marketing Name": "Active 3",
    "Device": "coconut",
    "Model": "Active 3"
  },
  {
    "Retail Branding": "Vsmart",
    "Marketing Name": "Aris",
    "Device": "jacaranda",
    "Model": "Aris"
  },
  {
    "Retail Branding": "Vsmart",
    "Marketing Name": "Aris Pro",
    "Device": "jacarandapro",
    "Model": "Aris Pro"
  },
  {
    "Retail Branding": "Vsmart",
    "Marketing Name": "Bee",
    "Device": "V220A",
    "Model": "Bee"
  },
  {
    "Retail Branding": "Vsmart",
    "Marketing Name": "Bee",
    "Device": "V220B",
    "Model": "Bee"
  },
  {
    "Retail Branding": "Vsmart",
    "Marketing Name": "Bee 3",
    "Device": "clover",
    "Model": "Bee 3"
  },
  {
    "Retail Branding": "Vsmart",
    "Marketing Name": "Bee Lite",
    "Device": "rice",
    "Model": "Bee Lite"
  },
  {
    "Retail Branding": "Vsmart",
    "Marketing Name": "Hobson",
    "Device": "v341u",
    "Model": "V341U"
  },
  {
    "Retail Branding": "Vsmart",
    "Marketing Name": "Joy 1",
    "Device": "PQ4001",
    "Model": "Joy 1"
  },
  {
    "Retail Branding": "Vsmart",
    "Marketing Name": "Joy 1 +",
    "Device": "PQ4002",
    "Model": "Joy 1+"
  },
  {
    "Retail Branding": "Vsmart",
    "Marketing Name": "Joy 1+",
    "Device": "PQ4002",
    "Model": "Joy 1+"
  },
  {
    "Retail Branding": "Vsmart",
    "Marketing Name": "Joy 2+",
    "Device": "V420A",
    "Model": "Joy 2+"
  },
  {
    "Retail Branding": "Vsmart",
    "Marketing Name": "Joy 3",
    "Device": "casuarina",
    "Model": "Joy 3"
  },
  {
    "Retail Branding": "Vsmart",
    "Marketing Name": "Joy 4",
    "Device": "juniper",
    "Model": "Joy 4"
  },
  {
    "Retail Branding": "Vsmart",
    "Marketing Name": "Live",
    "Device": "V620A",
    "Model": "Live"
  },
  {
    "Retail Branding": "Vsmart",
    "Marketing Name": "Live 4",
    "Device": "cassia",
    "Model": "Live 4"
  },
  {
    "Retail Branding": "Vsmart",
    "Marketing Name": "Star",
    "Device": "V320A",
    "Model": "Star"
  },
  {
    "Retail Branding": "Vsmart",
    "Marketing Name": "Star 3",
    "Device": "sugarcane",
    "Model": "Star 3"
  },
  {
    "Retail Branding": "Vsmart",
    "Marketing Name": "Star 4",
    "Device": "willowpro",
    "Model": "Star 4"
  },
  {
    "Retail Branding": "Vsmart",
    "Marketing Name": "Star 5",
    "Device": "fivestar",
    "Model": "Star 5"
  },
  {
    "Retail Branding": "Vsmart",
    "Marketing Name": "VINATV 4K",
    "Device": "TR2001",
    "Model": "VINATV 4K"
  },
  {
    "Retail Branding": "Vsmart",
    "Marketing Name": "VINATV 4K",
    "Device": "samseong",
    "Model": "VINATV 4K"
  },
  {
    "Retail Branding": "Vsmart",
    "Marketing Name": "VINTV 2K",
    "Device": "TR2002",
    "Model": "VINTV 2K"
  },
  {
    "Retail Branding": "Vsmart",
    "Marketing Name": "VINTV 4K",
    "Device": "TR2003",
    "Model": "VINTV 4K"
  },
  {
    "Retail Branding": "Vsun",
    "Marketing Name": "MARS  Touch",
    "Device": "MARS_TOUCH",
    "Model": "MARS TOUCH"
  },
  {
    "Retail Branding": "Vsun",
    "Marketing Name": "MARS Nocam",
    "Device": "MARS_NOCAM",
    "Model": "MARS NOCAM"
  },
  {
    "Retail Branding": "Vsun",
    "Marketing Name": "MARS Note",
    "Device": "MARS_NOTE",
    "Model": "MARS NOTE"
  },
  {
    "Retail Branding": "Vsun",
    "Marketing Name": "MERCURY Tough",
    "Device": "MERCURY_Tough",
    "Model": "MERCURY Tough"
  },
  {
    "Retail Branding": "Vsun",
    "Marketing Name": "SATURN Selfie",
    "Device": "SATURN_SELFIE",
    "Model": "SATURN SELFIE"
  },
  {
    "Retail Branding": "Vu Televisions",
    "Marketing Name": "43GloLED",
    "Device": "songshan",
    "Model": "VU SMART TV"
  },
  {
    "Retail Branding": "Vu Televisions",
    "Marketing Name": "43UA",
    "Device": "ikebukuro",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "Vu Televisions",
    "Marketing Name": "50CA",
    "Device": "samseong",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "Vu Televisions",
    "Marketing Name": "50CLED/55CLED/65CLED",
    "Device": "songshan",
    "Model": "VU TV FFM"
  },
  {
    "Retail Branding": "Vu Televisions",
    "Marketing Name": "55QMP",
    "Device": "hengshan",
    "Model": "VU TV FFM"
  },
  {
    "Retail Branding": "Vu Televisions",
    "Marketing Name": "Android TV",
    "Device": "longshan",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "Vu Televisions",
    "Marketing Name": "ULED",
    "Device": "wuyishan",
    "Model": "VU TV FFM"
  },
  {
    "Retail Branding": "Vu Televisions",
    "Marketing Name": "VU 4K",
    "Device": "lushan",
    "Model": "VU 4K"
  },
  {
    "Retail Branding": "Vu Televisions",
    "Marketing Name": "VU 4K Google TV",
    "Device": "keoneae",
    "Model": "VU 4K Google TV"
  },
  {
    "Retail Branding": "Vu Televisions",
    "Marketing Name": "fushan_vu",
    "Device": "hamamatsucho",
    "Model": "Smart 2K ATV4"
  },
  {
    "Retail Branding": "Vu Televisions",
    "Marketing Name": "huangshan_emV",
    "Device": "huangshan",
    "Model": "VU TV"
  },
  {
    "Retail Branding": "Vu Televisions",
    "Marketing Name": "xiaoyushan-vu",
    "Device": "xiaoyushan",
    "Model": "HiSmartTV A4"
  },
  {
    "Retail Branding": "Vue Micro",
    "Marketing Name": "Vue7LV",
    "Device": "Vue7LV",
    "Model": "7LV"
  },
  {
    "Retail Branding": "Vue Micro",
    "Marketing Name": "Vue81V",
    "Device": "Vue81V",
    "Model": "81V"
  },
  {
    "Retail Branding": "Vulcan",
    "Marketing Name": "Eternity_G57",
    "Device": "HT2G57K",
    "Model": "Hyundai_Eternity_G57"
  },
  {
    "Retail Branding": "Vulcan",
    "Marketing Name": "Koral 7W4",
    "Device": "HT0704W08",
    "Model": "HT0704W08"
  },
  {
    "Retail Branding": "Vulcan",
    "Marketing Name": "Koral_10W3",
    "Device": "Koral_10W3",
    "Model": "HT1003W16"
  },
  {
    "Retail Branding": "Vulcan",
    "Marketing Name": "Pulse 7",
    "Device": "VT0701A08",
    "Model": "VT0701A08"
  },
  {
    "Retail Branding": "Vulcan",
    "Marketing Name": "Pulse 7S",
    "Device": "VT0702A16",
    "Model": "VT0702A16"
  },
  {
    "Retail Branding": "Vulcan",
    "Marketing Name": "TA10TA2",
    "Device": "TA10TA2_1",
    "Model": "TA10TA2"
  },
  {
    "Retail Branding": "Vulcan",
    "Marketing Name": "TA71CA1",
    "Device": "TA71CA1",
    "Model": "TA71CA1"
  },
  {
    "Retail Branding": "Vulcan",
    "Marketing Name": "TA71CA2",
    "Device": "TA71CA2_1",
    "Model": "TA71CA2"
  },
  {
    "Retail Branding": "Vulcan",
    "Marketing Name": "TEMPO R14",
    "Device": "VR5014",
    "Model": "VR5014"
  },
  {
    "Retail Branding": "Vulcan",
    "Marketing Name": "TEMPO S11",
    "Device": "VS4011",
    "Model": "VS4011"
  },
  {
    "Retail Branding": "Vulcan",
    "Marketing Name": "TEMPO S12",
    "Device": "VS5012",
    "Model": "VS5012"
  },
  {
    "Retail Branding": "Vulcan",
    "Marketing Name": "TEMPO S13",
    "Device": "VS5513",
    "Model": "VS5513"
  },
  {
    "Retail Branding": "Vulcan",
    "Marketing Name": "TEMPO S16",
    "Device": "VS5016",
    "Model": "VS5016"
  },
  {
    "Retail Branding": "Vulcan",
    "Marketing Name": "Tempo 5",
    "Device": "VP5004A",
    "Model": "VP5004A"
  },
  {
    "Retail Branding": "Vulcan",
    "Marketing Name": "VM5021",
    "Device": "VM5021",
    "Model": "VM5021"
  },
  {
    "Retail Branding": "Vulcan",
    "Marketing Name": "VT0702A08",
    "Device": "VT0702A08",
    "Model": "VT0702A08"
  },
  {
    "Retail Branding": "Vulcan",
    "Marketing Name": "Vulcan Rhyme 10A",
    "Device": "VT1002A16",
    "Model": "VT1002A16"
  },
  {
    "Retail Branding": "Vulcan",
    "Marketing Name": "Vulcan Rhyme 10J",
    "Device": "VT1003J16",
    "Model": "VT1003J16"
  },
  {
    "Retail Branding": "Vulcan",
    "Marketing Name": "Vulcan Rhyme 7C",
    "Device": "VT0703",
    "Model": "VT0703C16"
  },
  {
    "Retail Branding": "Vulcan",
    "Marketing Name": "Vulcan VR5533",
    "Device": "VR5533",
    "Model": "VR5533"
  },
  {
    "Retail Branding": "Vulcan",
    "Marketing Name": "Vulcan VR6031",
    "Device": "VR6031",
    "Model": "VR6031"
  },
  {
    "Retail Branding": "Vulcan",
    "Marketing Name": "Vulcan VR6032",
    "Device": "VR6032",
    "Model": "VR6032"
  },
  {
    "Retail Branding": "W&O",
    "Marketing Name": "Max 7",
    "Device": "MAX_7",
    "Model": "MAX 7"
  },
  {
    "Retail Branding": "W&O",
    "Marketing Name": "Max 7i",
    "Device": "MAX_7i",
    "Model": "MAX 7i"
  },
  {
    "Retail Branding": "W&O",
    "Marketing Name": "X6",
    "Device": "X6",
    "Model": "X6"
  },
  {
    "Retail Branding": "W.e.",
    "Marketing Name": "WETAB700DG",
    "Device": "WETAB700DG",
    "Model": "WETAB700DG"
  },
  {
    "Retail Branding": "W.e.",
    "Marketing Name": "WeTab1004B",
    "Device": "WeTab1004B",
    "Model": "WeTab1004B"
  },
  {
    "Retail Branding": "WANYOU",
    "Marketing Name": "G999X",
    "Device": "G999X",
    "Model": "G999X"
  },
  {
    "Retail Branding": "WAOO",
    "Marketing Name": "Waoo TV-boks",
    "Device": "m393gena_w",
    "Model": "Waoo TV-boks"
  },
  {
    "Retail Branding": "WARP",
    "Marketing Name": "TAB-WP11",
    "Device": "TAB-WP11",
    "Model": "TAB-WP11"
  },
  {
    "Retail Branding": "WCED",
    "Marketing Name": "H1010_M50",
    "Device": "H1010_M50",
    "Model": "H1010_M50"
  },
  {
    "Retail Branding": "WELLS_BOARD",
    "Marketing Name": "WELLS AI BOARD",
    "Device": "WELLS_BOARD",
    "Model": "WM_YL_Series"
  },
  {
    "Retail Branding": "WEONEX",
    "Marketing Name": "Interactive Flat Panel",
    "Device": "WX_IFPD01",
    "Model": "WX_IFPD01"
  },
  {
    "Retail Branding": "WEROCK",
    "Marketing Name": "RockscanA260",
    "Device": "RockscanA260",
    "Model": "A260"
  },
  {
    "Retail Branding": "WEROCK",
    "Marketing Name": "RockscanA265",
    "Device": "RockscanA265",
    "Model": "A265"
  },
  {
    "Retail Branding": "WEROCK",
    "Marketing Name": "WEROCK Rocktab S508",
    "Device": "S508",
    "Model": "Rocktab S508"
  },
  {
    "Retail Branding": "WEROCK",
    "Marketing Name": "WEROCK Rocktab S510",
    "Device": "S510",
    "Model": "Rocktab S510"
  },
  {
    "Retail Branding": "WESCOM",
    "Marketing Name": "GS8A-L7",
    "Device": "GS8A-L7",
    "Model": "GS8A-L7"
  },
  {
    "Retail Branding": "WHOOP",
    "Marketing Name": "TAB-8US2",
    "Device": "TAB-8US2",
    "Model": "TAB-8US2"
  },
  {
    "Retail Branding": "WHOOP",
    "Marketing Name": "TAB_8US1",
    "Device": "TAB_8US1",
    "Model": "TAB_8US1"
  },
  {
    "Retail Branding": "WIDE",
    "Marketing Name": "WD_PL",
    "Device": "WD_PL",
    "Model": "WD_PL"
  },
  {
    "Retail Branding": "WIDEVISION",
    "Marketing Name": "WIDEVISION",
    "Device": "WIDEVISION_IFPD",
    "Model": "WIDEVISION_IFPD"
  },
  {
    "Retail Branding": "WIIGO",
    "Marketing Name": "WG-7650",
    "Device": "WG-7650",
    "Model": "WG-7650"
  },
  {
    "Retail Branding": "WILL (JP)",
    "Marketing Name": "Willfon_Pad_02",
    "Device": "Willfon_Pad_02",
    "Model": "Willfon_Pad_02"
  },
  {
    "Retail Branding": "WILLETT",
    "Marketing Name": "India",
    "Device": "tamachi",
    "Model": "WILLETT FHD Android TV"
  },
  {
    "Retail Branding": "WILLETT",
    "Marketing Name": "India",
    "Device": "yeongdeungpo",
    "Model": "WILLETT UHD Android TV"
  },
  {
    "Retail Branding": "WILLKOTECH",
    "Marketing Name": "Kishi-001",
    "Device": "Kishi-001",
    "Model": "Kishi-001"
  },
  {
    "Retail Branding": "WILLKOTECH",
    "Marketing Name": "WK1863L",
    "Device": "WK1863L",
    "Model": "WK1863L"
  },
  {
    "Retail Branding": "WIMIUS",
    "Marketing Name": "G1",
    "Device": "himalaya",
    "Model": "G1"
  },
  {
    "Retail Branding": "WIMIUS",
    "Marketing Name": "G2",
    "Device": "coorg",
    "Model": "G2"
  },
  {
    "Retail Branding": "WIN(PE)",
    "Marketing Name": "WINBOX DV8947",
    "Device": "DV8947-KPW",
    "Model": "WINBOX DV8947"
  },
  {
    "Retail Branding": "WINTEK",
    "Marketing Name": "W405",
    "Device": "W405",
    "Model": "W405"
  },
  {
    "Retail Branding": "WITECOR",
    "Marketing Name": "M623-EEA",
    "Device": "M623-EEA",
    "Model": "M623-EEA"
  },
  {
    "Retail Branding": "WOM",
    "Marketing Name": "SEI500W",
    "Device": "SEI500W",
    "Model": "WOM"
  },
  {
    "Retail Branding": "WOM",
    "Marketing Name": "WOM",
    "Device": "SEI500W",
    "Model": "WOM"
  },
  {
    "Retail Branding": "WONGKUO",
    "Marketing Name": "T10",
    "Device": "T10",
    "Model": "T10"
  },
  {
    "Retail Branding": "WONGKUO",
    "Marketing Name": "T20",
    "Device": "T20",
    "Model": "T20"
  },
  {
    "Retail Branding": "WOREGOO",
    "Marketing Name": "M226-EEA",
    "Device": "M226-EEA",
    "Model": "M226-EEA"
  },
  {
    "Retail Branding": "WOREGOO",
    "Marketing Name": "M396-EEA",
    "Device": "M396-EEA",
    "Model": "M396-EEA"
  },
  {
    "Retail Branding": "WOWtv",
    "Marketing Name": "WOWYTVBox",
    "Device": "SEI800WOW",
    "Model": "WOWYTVBox"
  },
  {
    "Retail Branding": "WOZIFAN",
    "Marketing Name": "3W_EEA",
    "Device": "W3_EEA",
    "Model": "3W_EEA"
  },
  {
    "Retail Branding": "WOZIFAN",
    "Marketing Name": "3W_US",
    "Device": "W3_US",
    "Model": "3W_US"
  },
  {
    "Retail Branding": "WOZIFAN",
    "Marketing Name": "W10_EEA",
    "Device": "W10_EEA",
    "Model": "W10_EEA"
  },
  {
    "Retail Branding": "WOZIFAN",
    "Marketing Name": "W10_T_EEA",
    "Device": "W10_T_EEA",
    "Model": "W10_T_EEA"
  },
  {
    "Retail Branding": "WOZIFAN",
    "Marketing Name": "W10_T_US",
    "Device": "W10_T_US",
    "Model": "W10_T_US"
  },
  {
    "Retail Branding": "WOZIFAN",
    "Marketing Name": "W10_US",
    "Device": "W10_US",
    "Model": "W10_US"
  },
  {
    "Retail Branding": "WOZIFAN",
    "Marketing Name": "W11_EEA",
    "Device": "W11_EEA",
    "Model": "W11_EEA"
  },
  {
    "Retail Branding": "WOZIFAN",
    "Marketing Name": "W11_US",
    "Device": "W11_US",
    "Model": "W11_US"
  },
  {
    "Retail Branding": "WOZIFAN",
    "Marketing Name": "W500 _EEA",
    "Device": "W500_EEA",
    "Model": "W500_EEA"
  },
  {
    "Retail Branding": "WOZIFAN",
    "Marketing Name": "W500_M_US",
    "Device": "W500_M_US",
    "Model": "W500_M_US"
  },
  {
    "Retail Branding": "WOZIFAN",
    "Marketing Name": "W500_US",
    "Device": "W500_US",
    "Model": "W500_US"
  },
  {
    "Retail Branding": "WS(SZ)",
    "Marketing Name": "TD-TP010G-2",
    "Device": "TD-TP010G-2",
    "Model": "TD-TP010G-2"
  },
  {
    "Retail Branding": "WS(SZ)",
    "Marketing Name": "WS-T01",
    "Device": "WS-T01",
    "Model": "WS-T01"
  },
  {
    "Retail Branding": "WS(SZ)",
    "Marketing Name": "WS_T02",
    "Device": "WS_T02",
    "Model": "WS_T02"
  },
  {
    "Retail Branding": "WXUNJA",
    "Marketing Name": "E10_EEA",
    "Device": "E10",
    "Model": "E10"
  },
  {
    "Retail Branding": "WXUNJA",
    "Marketing Name": "E10_ROW",
    "Device": "E10",
    "Model": "E10"
  },
  {
    "Retail Branding": "Wacom",
    "Marketing Name": "Cintiq Companion Hybrid 13HD",
    "Device": "CintiqCompanionHybrid13HD",
    "Model": "Cintiq Companion Hybrid 13HD"
  },
  {
    "Retail Branding": "Wacom",
    "Marketing Name": "DTHA116",
    "Device": "RosePlus",
    "Model": "DTHA116"
  },
  {
    "Retail Branding": "Wacom",
    "Marketing Name": "DTHA140",
    "Device": "Wacom_MovinkPad_14",
    "Model": "DTHA140"
  },
  {
    "Retail Branding": "Waf",
    "Marketing Name": "F803YM",
    "Device": "F803YM",
    "Model": "F803YM"
  },
  {
    "Retail Branding": "Waf",
    "Marketing Name": "F808NM",
    "Device": "F808NM",
    "Model": "F808NM"
  },
  {
    "Retail Branding": "Waf",
    "Marketing Name": "THMTKAW01216_eea",
    "Device": "THMTKAW01216",
    "Model": "Surftab WAF"
  },
  {
    "Retail Branding": "Wainyok",
    "Marketing Name": "K8",
    "Device": "K8",
    "Model": "K8"
  },
  {
    "Retail Branding": "Wainyok",
    "Marketing Name": "P10S_EEA",
    "Device": "P10S",
    "Model": "P10S"
  },
  {
    "Retail Branding": "Wainyok",
    "Marketing Name": "P10U",
    "Device": "P10U",
    "Model": "P10U"
  },
  {
    "Retail Branding": "Wainyok",
    "Marketing Name": "P10X",
    "Device": "P10X",
    "Model": "P10X"
  },
  {
    "Retail Branding": "Walton",
    "Marketing Name": "4K Smart TV",
    "Device": "pioneer",
    "Model": "4K PA Smart TV"
  },
  {
    "Retail Branding": "Walton",
    "Marketing Name": "Bangladesh and EU",
    "Device": "tamachi",
    "Model": "WALTON Android TV"
  },
  {
    "Retail Branding": "Walton",
    "Marketing Name": "Bangladesh and EU",
    "Device": "yeongdeungpo",
    "Model": "WALTON Android TV"
  },
  {
    "Retail Branding": "Walton",
    "Marketing Name": "Customer need debug",
    "Device": "NEXG_N9",
    "Model": "NEXG N9"
  },
  {
    "Retail Branding": "Walton",
    "Marketing Name": "EXPRESS",
    "Device": "guandu",
    "Model": "WALTON Android TV"
  },
  {
    "Retail Branding": "Walton",
    "Marketing Name": "G 4K TV Dongle",
    "Device": "YQX",
    "Model": "G 4K TV Dongle"
  },
  {
    "Retail Branding": "Walton",
    "Marketing Name": "LT750",
    "Device": "LT750",
    "Model": "LT750"
  },
  {
    "Retail Branding": "Walton",
    "Marketing Name": "NEXG N26",
    "Device": "NEXG_N26",
    "Model": "NEXG N26"
  },
  {
    "Retail Branding": "Walton",
    "Marketing Name": "NEXG N28",
    "Device": "NEXG_N28",
    "Model": "N28"
  },
  {
    "Retail Branding": "Walton",
    "Marketing Name": "NEXG N71",
    "Device": "NEXG_N71",
    "Model": "NEXG N71"
  },
  {
    "Retail Branding": "Walton",
    "Marketing Name": "NEXG N71 Plus",
    "Device": "NEXG_N71_Plus",
    "Model": "NEXG N71 Plus"
  },
  {
    "Retail Branding": "Walton",
    "Marketing Name": "NEXG N72",
    "Device": "NEXG_N72",
    "Model": "NEXG N72"
  },
  {
    "Retail Branding": "Walton",
    "Marketing Name": "NEXG N73",
    "Device": "NEXG_N73",
    "Model": "NEXG N73"
  },
  {
    "Retail Branding": "Walton",
    "Marketing Name": "NEXG N74",
    "Device": "NEXG_N74",
    "Model": "NEXG N74"
  },
  {
    "Retail Branding": "Walton",
    "Marketing Name": "NEXG N75",
    "Device": "NEXG_N75",
    "Model": "NEXG N75"
  },
  {
    "Retail Branding": "Walton",
    "Marketing Name": "NEXG N8",
    "Device": "NEXG_N8",
    "Model": "NEXG N8"
  },
  {
    "Retail Branding": "Walton",
    "Marketing Name": "NEXG N9",
    "Device": "NEXG_N9",
    "Model": "NEXG N9"
  },
  {
    "Retail Branding": "Walton",
    "Marketing Name": "NEXG_N25",
    "Device": "NEXG_N25",
    "Model": "NEXG N25"
  },
  {
    "Retail Branding": "Walton",
    "Marketing Name": "NEXG_N27",
    "Device": "NEXG_N27",
    "Model": "NEXG N27"
  },
  {
    "Retail Branding": "Walton",
    "Marketing Name": "NEXG_N76",
    "Device": "NEXG_N76",
    "Model": "N76"
  },
  {
    "Retail Branding": "Walton",
    "Marketing Name": "ORBIT Y12",
    "Device": "ORBIT_Y12",
    "Model": "ORBIT Y12"
  },
  {
    "Retail Branding": "Walton",
    "Marketing Name": "ORBIT Y13",
    "Device": "ORBIT_Y13",
    "Model": "ORBIT Y13"
  },
  {
    "Retail Branding": "Walton",
    "Marketing Name": "ORBIT Y70",
    "Device": "ORBIT_Y70",
    "Model": "ORBIT Y70"
  },
  {
    "Retail Branding": "Walton",
    "Marketing Name": "ORBIT Y70c",
    "Device": "ORBIT_Y70",
    "Model": "ORBIT Y70c"
  },
  {
    "Retail Branding": "Walton",
    "Marketing Name": "Orbit M20",
    "Device": "OrbitM20",
    "Model": "Orbit M20"
  },
  {
    "Retail Branding": "Walton",
    "Marketing Name": "Orbit Y11",
    "Device": "Orbit_Y11",
    "Model": "Orbit Y11"
  },
  {
    "Retail Branding": "Walton",
    "Marketing Name": "Orbit Y20",
    "Device": "OrbitY20",
    "Model": "Orbit Y20"
  },
  {
    "Retail Branding": "Walton",
    "Marketing Name": "Orbit Y72",
    "Device": "Orbit_Y72",
    "Model": "Orbit Y72"
  },
  {
    "Retail Branding": "Walton",
    "Marketing Name": "PRIMO D10",
    "Device": "PRIMO_D10",
    "Model": "PRIMO D10"
  },
  {
    "Retail Branding": "Walton",
    "Marketing Name": "PRIMO F10",
    "Device": "PRIMO_F10",
    "Model": "PRIMO F10"
  },
  {
    "Retail Branding": "Walton",
    "Marketing Name": "PRIMO GH10",
    "Device": "Primo_GH10",
    "Model": "Primo GH10"
  },
  {
    "Retail Branding": "Walton",
    "Marketing Name": "PRIMO NH4",
    "Device": "PRIMO_NH4",
    "Model": "PRIMO NH4"
  },
  {
    "Retail Branding": "Walton",
    "Marketing Name": "PRIMO_EF10",
    "Device": "PRIMO_EF10",
    "Model": "PRIMO EF10"
  },
  {
    "Retail Branding": "Walton",
    "Marketing Name": "PRIMO_RX8",
    "Device": "PRIMO_RX8",
    "Model": "PRIMO RX8"
  },
  {
    "Retail Branding": "Walton",
    "Marketing Name": "PRIMO_RX9",
    "Device": "PRIMO_RX9",
    "Model": "PRIMO RX9"
  },
  {
    "Retail Branding": "Walton",
    "Marketing Name": "PRIMO_S7",
    "Device": "Primo_S7",
    "Model": "Primo S7"
  },
  {
    "Retail Branding": "Walton",
    "Marketing Name": "PRIMO_S8",
    "Device": "PRIMO_S8",
    "Model": "PRIMO S8"
  },
  {
    "Retail Branding": "Walton",
    "Marketing Name": "PRIMO_ZX4",
    "Device": "PRIMO_ZX4",
    "Model": "PRIMO ZX4"
  },
  {
    "Retail Branding": "Walton",
    "Marketing Name": "Primo D9",
    "Device": "Primo_D9",
    "Model": "Primo D9"
  },
  {
    "Retail Branding": "Walton",
    "Marketing Name": "Primo E10",
    "Device": "PRIMO_E10",
    "Model": "PRIMO E10"
  },
  {
    "Retail Branding": "Walton",
    "Marketing Name": "Primo E10 PlUS",
    "Device": "Primo_E10_Plus",
    "Model": "Primo E10 Plus"
  },
  {
    "Retail Branding": "Walton",
    "Marketing Name": "Primo E11",
    "Device": "Primo_E11",
    "Model": "Primo E11"
  },
  {
    "Retail Branding": "Walton",
    "Marketing Name": "Primo E12",
    "Device": "Primo_E12",
    "Model": "Primo E12"
  },
  {
    "Retail Branding": "Walton",
    "Marketing Name": "Primo E8s",
    "Device": "Primo_E8s",
    "Model": "Primo E8s"
  },
  {
    "Retail Branding": "Walton",
    "Marketing Name": "Primo E9",
    "Device": "Primo_E9",
    "Model": "Primo E9"
  },
  {
    "Retail Branding": "Walton",
    "Marketing Name": "Primo EF7",
    "Device": "Primo_EF7",
    "Model": "Primo EF7"
  },
  {
    "Retail Branding": "Walton",
    "Marketing Name": "Primo EF8 4G",
    "Device": "Primo_EF8_4G",
    "Model": "Primo EF8 4G"
  },
  {
    "Retail Branding": "Walton",
    "Marketing Name": "Primo EM2",
    "Device": "Primo_EM2",
    "Model": "Primo EM2"
  },
  {
    "Retail Branding": "Walton",
    "Marketing Name": "Primo F7s",
    "Device": "Primo_F7s",
    "Model": "Primo F7s"
  },
  {
    "Retail Branding": "Walton",
    "Marketing Name": "Primo F8",
    "Device": "Primo_F8",
    "Model": "Primo F8"
  },
  {
    "Retail Branding": "Walton",
    "Marketing Name": "Primo F8s",
    "Device": "Primo_F8s",
    "Model": "Primo F8s"
  },
  {
    "Retail Branding": "Walton",
    "Marketing Name": "Primo F9",
    "Device": "Primo_F9",
    "Model": "Primo F9"
  },
  {
    "Retail Branding": "Walton",
    "Marketing Name": "Primo G8",
    "Device": "Primo_G8",
    "Model": "Primo G8"
  },
  {
    "Retail Branding": "Walton",
    "Marketing Name": "Primo G8i",
    "Device": "Primo_G8i",
    "Model": "Primo G8i"
  },
  {
    "Retail Branding": "Walton",
    "Marketing Name": "Primo G8i 4G",
    "Device": "Primo_G8i_4G",
    "Model": "Primo G8i 4G"
  },
  {
    "Retail Branding": "Walton",
    "Marketing Name": "Primo G9",
    "Device": "Primo_G9",
    "Model": "Primo G9"
  },
  {
    "Retail Branding": "Walton",
    "Marketing Name": "Primo GF6",
    "Device": "Primo_GF6",
    "Model": "Primo GF6"
  },
  {
    "Retail Branding": "Walton",
    "Marketing Name": "Primo GF7",
    "Device": "Primo_GF7",
    "Model": "Primo GF7"
  },
  {
    "Retail Branding": "Walton",
    "Marketing Name": "Primo GH5",
    "Device": "WBW5615WA",
    "Model": "Primo GH5"
  },
  {
    "Retail Branding": "Walton",
    "Marketing Name": "Primo GH5 mini",
    "Device": "Primo_GH5_mini",
    "Model": "Primo GH5 mini"
  },
  {
    "Retail Branding": "Walton",
    "Marketing Name": "Primo GH7",
    "Device": "Primo_GH7",
    "Model": "Primo GH7"
  },
  {
    "Retail Branding": "Walton",
    "Marketing Name": "Primo GH7i",
    "Device": "Primo_GH7i",
    "Model": "Primo GH7i"
  },
  {
    "Retail Branding": "Walton",
    "Marketing Name": "Primo GH8",
    "Device": "Primo_GH8",
    "Model": "Primo GH8"
  },
  {
    "Retail Branding": "Walton",
    "Marketing Name": "Primo GH9",
    "Device": "Primo_GH9",
    "Model": "Primo GH9"
  },
  {
    "Retail Branding": "Walton",
    "Marketing Name": "Primo GM2",
    "Device": "Primo_GM2",
    "Model": "Primo GM2"
  },
  {
    "Retail Branding": "Walton",
    "Marketing Name": "Primo GM2 Plus",
    "Device": "Primo_GM2_Plus",
    "Model": "Primo GM2 Plus"
  },
  {
    "Retail Branding": "Walton",
    "Marketing Name": "Primo GM3",
    "Device": "Primo_GM3",
    "Model": "Primo GM3"
  },
  {
    "Retail Branding": "Walton",
    "Marketing Name": "Primo GM3+",
    "Device": "Primo_GM3_plus",
    "Model": "Primo GM3 plus"
  },
  {
    "Retail Branding": "Walton",
    "Marketing Name": "Primo GM4",
    "Device": "Primo_GM4",
    "Model": "Primo GM4"
  },
  {
    "Retail Branding": "Walton",
    "Marketing Name": "Primo H10",
    "Device": "Primo_H10",
    "Model": "Primo H10"
  },
  {
    "Retail Branding": "Walton",
    "Marketing Name": "Primo H6+",
    "Device": "Primo_H6_Plus",
    "Model": "Primo H6 Plus"
  },
  {
    "Retail Branding": "Walton",
    "Marketing Name": "Primo H7",
    "Device": "Primo_H7",
    "Model": "Primo H7"
  },
  {
    "Retail Branding": "Walton",
    "Marketing Name": "Primo H7s",
    "Device": "Primo_H7s",
    "Model": "Primo H7s"
  },
  {
    "Retail Branding": "Walton",
    "Marketing Name": "Primo H8 Pro",
    "Device": "Primo_H8_Pro",
    "Model": "Primo H8 Pro"
  },
  {
    "Retail Branding": "Walton",
    "Marketing Name": "Primo H9",
    "Device": "Primo_H9",
    "Model": "Primo H9"
  },
  {
    "Retail Branding": "Walton",
    "Marketing Name": "Primo H9 Pro",
    "Device": "Primo_H9_Pro",
    "Model": "Primo H9 Pro"
  },
  {
    "Retail Branding": "Walton",
    "Marketing Name": "Primo HM4",
    "Device": "Primo_HM4",
    "Model": "Primo HM4"
  },
  {
    "Retail Branding": "Walton",
    "Marketing Name": "Primo HM4+",
    "Device": "Primo_HM4_PLUS",
    "Model": "Primo HM4+"
  },
  {
    "Retail Branding": "Walton",
    "Marketing Name": "Primo HM4i",
    "Device": "Primo_HM4i",
    "Model": "Primo HM4i"
  },
  {
    "Retail Branding": "Walton",
    "Marketing Name": "Primo HM5",
    "Device": "Primo_HM5",
    "Model": "Primo HM5"
  },
  {
    "Retail Branding": "Walton",
    "Marketing Name": "Primo HM6",
    "Device": "Primo_HM6",
    "Model": "Primo HM6"
  },
  {
    "Retail Branding": "Walton",
    "Marketing Name": "Primo HM6 Lite",
    "Device": "Primo_HM6_Lite",
    "Model": "Primo HM6 Lite"
  },
  {
    "Retail Branding": "Walton",
    "Marketing Name": "Primo HM7",
    "Device": "Primo_HM7",
    "Model": "Primo HM7"
  },
  {
    "Retail Branding": "Walton",
    "Marketing Name": "Primo N3",
    "Device": "Primo_N3",
    "Model": "Primo N3"
  },
  {
    "Retail Branding": "Walton",
    "Marketing Name": "Primo N4",
    "Device": "PRIMO_N4",
    "Model": "PRIMO N4"
  },
  {
    "Retail Branding": "Walton",
    "Marketing Name": "Primo N5",
    "Device": "Primo_N5",
    "Model": "Primo N5"
  },
  {
    "Retail Branding": "Walton",
    "Marketing Name": "Primo NF3",
    "Device": "Primo_NF3",
    "Model": "Primo NF3"
  },
  {
    "Retail Branding": "Walton",
    "Marketing Name": "Primo NF4",
    "Device": "Primo_NF4",
    "Model": "Primo NF4"
  },
  {
    "Retail Branding": "Walton",
    "Marketing Name": "Primo NF4",
    "Device": "Primo_NF4_2GB",
    "Model": "Primo_NF4_2GB"
  },
  {
    "Retail Branding": "Walton",
    "Marketing Name": "Primo NF5",
    "Device": "Primo_NF5",
    "Model": "Primo NF5"
  },
  {
    "Retail Branding": "Walton",
    "Marketing Name": "Primo NH3",
    "Device": "Primo_NH3",
    "Model": "Primo NH3"
  },
  {
    "Retail Branding": "Walton",
    "Marketing Name": "Primo NH3 Lite",
    "Device": "Primo_NH3_Lite",
    "Model": "Primo NH3 Lite"
  },
  {
    "Retail Branding": "Walton",
    "Marketing Name": "Primo NH3i",
    "Device": "Primo_NH3i",
    "Model": "Primo NH3i"
  },
  {
    "Retail Branding": "Walton",
    "Marketing Name": "Primo NH5",
    "Device": "PRIMO_NH5",
    "Model": "PRIMO NH5"
  },
  {
    "Retail Branding": "Walton",
    "Marketing Name": "Primo NH6",
    "Device": "PRIMO_NH6",
    "Model": "PRIMO NH6"
  },
  {
    "Retail Branding": "Walton",
    "Marketing Name": "Primo NX3",
    "Device": "Primo_NX3",
    "Model": "Primo_NX3"
  },
  {
    "Retail Branding": "Walton",
    "Marketing Name": "Primo NX4",
    "Device": "Primo_NX4",
    "Model": "Primo NX4"
  },
  {
    "Retail Branding": "Walton",
    "Marketing Name": "Primo NX4 mini",
    "Device": "Primo_NX4_mini",
    "Model": "Primo NX4 mini"
  },
  {
    "Retail Branding": "Walton",
    "Marketing Name": "Primo NX6",
    "Device": "Primo_NX6",
    "Model": "Primo NX6"
  },
  {
    "Retail Branding": "Walton",
    "Marketing Name": "Primo R4",
    "Device": "Primo_R4",
    "Model": "Primo R4"
  },
  {
    "Retail Branding": "Walton",
    "Marketing Name": "Primo R4 Plus",
    "Device": "Primo_R4_Plus",
    "Model": "Primo R4 Plus"
  },
  {
    "Retail Branding": "Walton",
    "Marketing Name": "Primo R5",
    "Device": "Primo_R5",
    "Model": "Primo R5"
  },
  {
    "Retail Branding": "Walton",
    "Marketing Name": "Primo R5 Plus",
    "Device": "Primo_R5_Plus",
    "Model": "Primo R5 Plus"
  },
  {
    "Retail Branding": "Walton",
    "Marketing Name": "Primo R6",
    "Device": "Primo_R6",
    "Model": "Primo R6"
  },
  {
    "Retail Branding": "Walton",
    "Marketing Name": "Primo R6 Max",
    "Device": "Primo_R6_Max",
    "Model": "Primo R6 Max"
  },
  {
    "Retail Branding": "Walton",
    "Marketing Name": "Primo R8",
    "Device": "Primo_R8",
    "Model": "Primo R8"
  },
  {
    "Retail Branding": "Walton",
    "Marketing Name": "Primo R9",
    "Device": "Primo_R9",
    "Model": "Primo R9"
  },
  {
    "Retail Branding": "Walton",
    "Marketing Name": "Primo RH3",
    "Device": "Primo_RH3",
    "Model": "Primo RH3"
  },
  {
    "Retail Branding": "Walton",
    "Marketing Name": "Primo RM2 mini",
    "Device": "WBW5616WA",
    "Model": "Primo RM2 mini"
  },
  {
    "Retail Branding": "Walton",
    "Marketing Name": "Primo RM4",
    "Device": "Primo_RM4",
    "Model": "Primo RM4"
  },
  {
    "Retail Branding": "Walton",
    "Marketing Name": "Primo RX5",
    "Device": "Primo_RX5",
    "Model": "Primo RX5"
  },
  {
    "Retail Branding": "Walton",
    "Marketing Name": "Primo RX6",
    "Device": "Primo_RX6",
    "Model": "Primo RX6"
  },
  {
    "Retail Branding": "Walton",
    "Marketing Name": "Primo RX7",
    "Device": "Primo_RX7",
    "Model": "Primo RX7"
  },
  {
    "Retail Branding": "Walton",
    "Marketing Name": "Primo RX8 Mini",
    "Device": "Primo_RX8_Mini",
    "Model": "Primo RX8 Mini"
  },
  {
    "Retail Branding": "Walton",
    "Marketing Name": "Primo S5",
    "Device": "Primo_S5",
    "Model": "Primo_S5"
  },
  {
    "Retail Branding": "Walton",
    "Marketing Name": "Primo S6",
    "Device": "Primo_S6",
    "Model": "Primo S6"
  },
  {
    "Retail Branding": "Walton",
    "Marketing Name": "Primo S6 infinity",
    "Device": "Primo_S6_infinity",
    "Model": "Primo S6 infinity"
  },
  {
    "Retail Branding": "Walton",
    "Marketing Name": "Primo S7  Pro",
    "Device": "Primo_S7_Pro",
    "Model": "Primo S7 Pro"
  },
  {
    "Retail Branding": "Walton",
    "Marketing Name": "Primo X4",
    "Device": "WALTON_Primo_X4",
    "Model": "Primo X4"
  },
  {
    "Retail Branding": "Walton",
    "Marketing Name": "Primo X4 Pro",
    "Device": "Primo_X4_Pro",
    "Model": "Primo X4 Pro"
  },
  {
    "Retail Branding": "Walton",
    "Marketing Name": "Primo ZX2",
    "Device": "GBL5805WA",
    "Model": "Primo_ZX2"
  },
  {
    "Retail Branding": "Walton",
    "Marketing Name": "Primo ZX2 Lite",
    "Device": "BBL7505WA",
    "Model": "Primo ZX2 Lite"
  },
  {
    "Retail Branding": "Walton",
    "Marketing Name": "Primo ZX2 mini",
    "Device": "Primo_ZX2_mini",
    "Model": "Primo ZX2 mini"
  },
  {
    "Retail Branding": "Walton",
    "Marketing Name": "Primo ZX3",
    "Device": "Primo_ZX3",
    "Model": "Primo ZX3"
  },
  {
    "Retail Branding": "Walton",
    "Marketing Name": "Primo_EF9",
    "Device": "Primo_EF9",
    "Model": "Primo EF9"
  },
  {
    "Retail Branding": "Walton",
    "Marketing Name": "Primo_R7",
    "Device": "Primo_R7",
    "Model": "Primo_R7"
  },
  {
    "Retail Branding": "Walton",
    "Marketing Name": "Primo_RM3",
    "Device": "Primo_RM3",
    "Model": "Primo RM3"
  },
  {
    "Retail Branding": "Walton",
    "Marketing Name": "Primo S6 Dual",
    "Device": "Primo_S6_Dual",
    "Model": "Primo S6 Dual"
  },
  {
    "Retail Branding": "Walton",
    "Marketing Name": "RX7 Mini",
    "Device": "RX7_Mini",
    "Model": "RX7 Mini"
  },
  {
    "Retail Branding": "Walton",
    "Marketing Name": "Smart TV",
    "Device": "alimos",
    "Model": "WALTON UHD GOOGLE TV 5.0"
  },
  {
    "Retail Branding": "Walton",
    "Marketing Name": "Smart TV",
    "Device": "bridgeport",
    "Model": "WALTON UHD GOOGLE TV 5.0"
  },
  {
    "Retail Branding": "Walton",
    "Marketing Name": "Smart TV",
    "Device": "dangni",
    "Model": "WALTON GOOGLE TV5.0"
  },
  {
    "Retail Branding": "Walton",
    "Marketing Name": "Smart TV",
    "Device": "mateo",
    "Model": "2K PA Smart TV"
  },
  {
    "Retail Branding": "Walton",
    "Marketing Name": "Smart TV",
    "Device": "mateo",
    "Model": "2K US Smart TV"
  },
  {
    "Retail Branding": "Walton",
    "Marketing Name": "Smart TV",
    "Device": "osaki",
    "Model": "2K AI Smart TV"
  },
  {
    "Retail Branding": "Walton",
    "Marketing Name": "WALPAD 10H",
    "Device": "Walpad_10H",
    "Model": "Walpad_10H"
  },
  {
    "Retail Branding": "Walton",
    "Marketing Name": "WALPAD 10H Pro",
    "Device": "WALPAD_10H_Pro",
    "Model": "WALPAD 10H Pro"
  },
  {
    "Retail Branding": "Walton",
    "Marketing Name": "WALPAD 10P",
    "Device": "10P",
    "Model": "WALPAD 10P"
  },
  {
    "Retail Branding": "Walton",
    "Marketing Name": "WALPAD 8G",
    "Device": "WALPAD8G_V2",
    "Model": "WALPAD8G"
  },
  {
    "Retail Branding": "Walton",
    "Marketing Name": "WALPAD 8G",
    "Device": "WALPAD8G_V2",
    "Model": "WALPAD_8G"
  },
  {
    "Retail Branding": "Walton",
    "Marketing Name": "WALPAD 8G",
    "Device": "WALPAD_8G",
    "Model": "WALPAD_8G"
  },
  {
    "Retail Branding": "Walton",
    "Marketing Name": "WALPAD_11G",
    "Device": "WALPAD_11G",
    "Model": "WALPAD 11G"
  },
  {
    "Retail Branding": "Walton",
    "Marketing Name": "WALPAD_9G",
    "Device": "WALPAD_9G",
    "Model": "WALPAD_9G"
  },
  {
    "Retail Branding": "Walton",
    "Marketing Name": "WALTON GSMART 2KTV",
    "Device": "umeda",
    "Model": "WALTON GSMART 2KTV"
  },
  {
    "Retail Branding": "Walton",
    "Marketing Name": "WALTON GSMART 4KTV",
    "Device": "SW6H",
    "Model": "WALTON GSMART 4KTV"
  },
  {
    "Retail Branding": "Walton",
    "Marketing Name": "WALTON GSMART 4KTV FF",
    "Device": "SW6H",
    "Model": "WALTON GSMART 4KTV FF"
  },
  {
    "Retail Branding": "Walton",
    "Marketing Name": "WALTON GSMART 4KTV FF",
    "Device": "anaheim",
    "Model": "WALTON GSMART 4KTV FF"
  },
  {
    "Retail Branding": "Walton",
    "Marketing Name": "WALTON GSMART5.0 2KTV",
    "Device": "beomil",
    "Model": "WALTON GSMART5.0 2KTV"
  },
  {
    "Retail Branding": "Walton",
    "Marketing Name": "WALTON GSMART5.0 4KTV",
    "Device": "eleonas",
    "Model": "WALTON GSMART5.0 4KTV"
  },
  {
    "Retail Branding": "Walton",
    "Marketing Name": "WALTON GSMART5.0 4KTV FF",
    "Device": "eleonas",
    "Model": "WALTON GSMART5.0 4KTV FF"
  },
  {
    "Retail Branding": "Walton",
    "Marketing Name": "WAS2KA11",
    "Device": "IAD",
    "Model": "WAS2KA11"
  },
  {
    "Retail Branding": "Walton",
    "Marketing Name": "Walpad10HProMax",
    "Device": "Walpad10HProMax",
    "Model": "Walpad10HProMax"
  },
  {
    "Retail Branding": "Walton",
    "Marketing Name": "Walpad11G",
    "Device": "Walpad11G",
    "Model": "Walpad11G"
  },
  {
    "Retail Branding": "Walton",
    "Marketing Name": "Walpad8GPro",
    "Device": "Walpad8GPro",
    "Model": "Walpad 8G Pro"
  },
  {
    "Retail Branding": "Walton",
    "Marketing Name": "Walton Primo X5",
    "Device": "Primo_X5",
    "Model": "Walton Primo X5"
  },
  {
    "Retail Branding": "Walton",
    "Marketing Name": "XANON X1 Ultra",
    "Device": "XANON_X1_ultra",
    "Model": "XANON X1 ultra"
  },
  {
    "Retail Branding": "Walton",
    "Marketing Name": "XANON X20",
    "Device": "XANON_X20",
    "Model": "XANON X20"
  },
  {
    "Retail Branding": "Walton",
    "Marketing Name": "XANON X21",
    "Device": "XANON_X21",
    "Model": "XANON X21"
  },
  {
    "Retail Branding": "Walton",
    "Marketing Name": "XANON X50",
    "Device": "XANON_X50",
    "Model": "XANON X50"
  },
  {
    "Retail Branding": "Walton",
    "Marketing Name": "XANON_X90",
    "Device": "XANON_X90",
    "Model": "XANON X90"
  },
  {
    "Retail Branding": "Walton",
    "Marketing Name": "XANON_X91",
    "Device": "XANON_X91",
    "Model": "XANON X91"
  },
  {
    "Retail Branding": "Walton",
    "Marketing Name": "ZenX 1",
    "Device": "ZENX_1",
    "Model": "ZENX 1"
  },
  {
    "Retail Branding": "Walton",
    "Marketing Name": "zenx 2",
    "Device": "zenx_2",
    "Model": "zenx 2"
  },
  {
    "Retail Branding": "Wansa",
    "Marketing Name": "Smart TV",
    "Device": "alimos",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "Wansa",
    "Marketing Name": "Smart TV",
    "Device": "bridgeport",
    "Model": "AI PONT PLUS FF"
  },
  {
    "Retail Branding": "Wansa",
    "Marketing Name": "Smart TV",
    "Device": "dangni",
    "Model": "WANSA Google TV"
  },
  {
    "Retail Branding": "Wansa",
    "Marketing Name": "Smart TV",
    "Device": "longshan",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "Wansa",
    "Marketing Name": "Smart TV",
    "Device": "osaka",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "Wansa",
    "Marketing Name": "Smart TV",
    "Device": "redwood",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "Wansa",
    "Marketing Name": "WUD55JOA63S",
    "Device": "samseong",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "Wansa",
    "Marketing Name": "xiaoyushan_emW",
    "Device": "xiaoyushan",
    "Model": "HiSmartTV A4"
  },
  {
    "Retail Branding": "Warner Bros",
    "Marketing Name": "Avengers",
    "Device": "Avengers",
    "Model": "Avengers"
  },
  {
    "Retail Branding": "Warner Bros",
    "Marketing Name": "DC_Comics_G9",
    "Device": "DC_Comics_G9",
    "Model": "DC_Comics_G9"
  },
  {
    "Retail Branding": "Wave 8",
    "Marketing Name": "WAVETEC-S025",
    "Device": "WAVETEC-S025",
    "Model": "WAVETEC-S025"
  },
  {
    "Retail Branding": "Wave 8",
    "Marketing Name": "WV7P",
    "Device": "Wave_8_7",
    "Model": "WV7P"
  },
  {
    "Retail Branding": "Wave 8",
    "Marketing Name": "WV8O",
    "Device": "WV8O",
    "Model": "WV8O"
  },
  {
    "Retail Branding": "Wave 8",
    "Marketing Name": "WV8TV",
    "Device": "WV8TV",
    "Model": "WV8TV"
  },
  {
    "Retail Branding": "Wave 8",
    "Marketing Name": "Wave_8_10",
    "Device": "Wave_8_10",
    "Model": "WV10Q"
  },
  {
    "Retail Branding": "Wave 8 Red Nougat",
    "Marketing Name": "WV8R-N",
    "Device": "WV8R_N",
    "Model": "WV8R_N"
  },
  {
    "Retail Branding": "We (BD)",
    "Marketing Name": "F1",
    "Device": "F1",
    "Model": "F1"
  },
  {
    "Retail Branding": "We (BD)",
    "Marketing Name": "L7",
    "Device": "L7",
    "Model": "L7"
  },
  {
    "Retail Branding": "We (BD)",
    "Marketing Name": "T1",
    "Device": "WE_T1",
    "Model": "T1"
  },
  {
    "Retail Branding": "We (BD)",
    "Marketing Name": "WE B3",
    "Device": "WE_B3",
    "Model": "WE B3"
  },
  {
    "Retail Branding": "We (BD)",
    "Marketing Name": "WE F10",
    "Device": "WE_F10",
    "Model": "WE F10"
  },
  {
    "Retail Branding": "We (BD)",
    "Marketing Name": "WE F20",
    "Device": "WE_F20",
    "Model": "WE F20"
  },
  {
    "Retail Branding": "We (BD)",
    "Marketing Name": "WE L9",
    "Device": "WE_L9",
    "Model": "WE L9"
  },
  {
    "Retail Branding": "We (BD)",
    "Marketing Name": "WE R4",
    "Device": "WE_R4",
    "Model": "WE R4"
  },
  {
    "Retail Branding": "We (BD)",
    "Marketing Name": "WE V4",
    "Device": "WE_V4",
    "Model": "WE V4"
  },
  {
    "Retail Branding": "We (BD)",
    "Marketing Name": "WE V5",
    "Device": "V5",
    "Model": "V5"
  },
  {
    "Retail Branding": "We (BD)",
    "Marketing Name": "WE_A15",
    "Device": "WE_A15",
    "Model": "A15"
  },
  {
    "Retail Branding": "WeTap",
    "Marketing Name": "WeTap_Y10",
    "Device": "WeTap_Y10",
    "Model": "WeTap_Y10"
  },
  {
    "Retail Branding": "WeTap",
    "Marketing Name": "WeTap_Y10_EEA",
    "Device": "WeTap_Y10_EEA",
    "Model": "WeTap_Y10"
  },
  {
    "Retail Branding": "WeTek",
    "Marketing Name": "Play",
    "Device": "Play",
    "Model": "Play"
  },
  {
    "Retail Branding": "WeTek",
    "Marketing Name": "WeTek",
    "Device": "wh220",
    "Model": "Air"
  },
  {
    "Retail Branding": "Webee",
    "Marketing Name": "Webee_Tab_8",
    "Device": "Webee_Tab_8",
    "Model": "Webee_Tab_8"
  },
  {
    "Retail Branding": "Weber",
    "Marketing Name": "S10PLUS",
    "Device": "S10PLUS",
    "Model": "S10PLUS"
  },
  {
    "Retail Branding": "Webfleet Solutions",
    "Marketing Name": "PRO 8475",
    "Device": "triton",
    "Model": "PRO 8475"
  },
  {
    "Retail Branding": "Weimei",
    "Marketing Name": "WEIMEI NEON2",
    "Device": "WEIMEI_NEON2",
    "Model": "WEIMEI_NEON2"
  },
  {
    "Retail Branding": "Weimei",
    "Marketing Name": "weplus 3",
    "Device": "weplus_3",
    "Model": "weplus_3"
  },
  {
    "Retail Branding": "Welgate",
    "Marketing Name": "WA-U420D",
    "Device": "WA-U420D",
    "Model": "WA-U420D"
  },
  {
    "Retail Branding": "Welio",
    "Marketing Name": "wPad_Aura",
    "Device": "wPad_Aura",
    "Model": "wPad_Aura"
  },
  {
    "Retail Branding": "Welwitcha",
    "Marketing Name": "P20",
    "Device": "P20",
    "Model": "P20"
  },
  {
    "Retail Branding": "Wemax",
    "Marketing Name": "WEMAX VP01",
    "Device": "tianshan",
    "Model": "C015OGN-WE1"
  },
  {
    "Retail Branding": "Wemax",
    "Marketing Name": "WEMAX VP02",
    "Device": "tianshan",
    "Model": "C025OGN-WE1"
  },
  {
    "Retail Branding": "Wenu",
    "Marketing Name": "Kate",
    "Device": "Wenu",
    "Model": "Kate"
  },
  {
    "Retail Branding": "Westgate",
    "Marketing Name": "Westgate_T801",
    "Device": "Westgate-T801",
    "Model": "T801"
  },
  {
    "Retail Branding": "Westgate Resorts",
    "Marketing Name": "T802",
    "Device": "T802",
    "Model": "T802"
  },
  {
    "Retail Branding": "Westgate Resorts",
    "Marketing Name": "T803",
    "Device": "T803",
    "Model": "T803"
  },
  {
    "Retail Branding": "Westgate Resorts",
    "Marketing Name": "T805",
    "Device": "T805",
    "Model": "T805"
  },
  {
    "Retail Branding": "Westinghouse",
    "Marketing Name": "Smart TV",
    "Device": "ueno",
    "Model": "2K Android TV"
  },
  {
    "Retail Branding": "Westinghouse",
    "Marketing Name": "W10TWF19",
    "Device": "W10TWF19",
    "Model": "W10TWF19"
  },
  {
    "Retail Branding": "Westinghouse",
    "Marketing Name": "W7T3G19",
    "Device": "W7T3G19",
    "Model": "W7T3G19"
  },
  {
    "Retail Branding": "Westinghouse",
    "Marketing Name": "W7TBL19",
    "Device": "W7TBL19",
    "Model": "W7TBL19"
  },
  {
    "Retail Branding": "Westinghouse",
    "Marketing Name": "W7TPK19",
    "Device": "W7TPK19",
    "Model": "W7TPK19"
  },
  {
    "Retail Branding": "Westinghouse",
    "Marketing Name": "W7TWF19",
    "Device": "W7TWF19",
    "Model": "W7TWF19"
  },
  {
    "Retail Branding": "Westinghouse",
    "Marketing Name": "WDTLQA102",
    "Device": "WDTLQA102",
    "Model": "WDTLQA102"
  },
  {
    "Retail Branding": "Westinghouse",
    "Marketing Name": "WH10S9863232",
    "Device": "WH10S9863232",
    "Model": "WH10S9863232"
  },
  {
    "Retail Branding": "Wexler",
    "Marketing Name": "WLT710M",
    "Device": "WLT710M",
    "Model": "WLT710M"
  },
  {
    "Retail Branding": "Whisbird",
    "Marketing Name": "S888",
    "Device": "S888",
    "Model": "S888"
  },
  {
    "Retail Branding": "Whitedeer",
    "Marketing Name": "G13",
    "Device": "G13",
    "Model": "G13"
  },
  {
    "Retail Branding": "Whitedeer",
    "Marketing Name": "G13A",
    "Device": "G13A",
    "Model": "G13A"
  },
  {
    "Retail Branding": "Whitedeer",
    "Marketing Name": "G13A_EEA",
    "Device": "G13A",
    "Model": "G13A"
  },
  {
    "Retail Branding": "Whitedeer",
    "Marketing Name": "G13L",
    "Device": "G13L",
    "Model": "G13L"
  },
  {
    "Retail Branding": "Whitedeer",
    "Marketing Name": "G13L_EEA",
    "Device": "G13L",
    "Model": "G13L"
  },
  {
    "Retail Branding": "Whitedeer",
    "Marketing Name": "G13_EEA",
    "Device": "G13",
    "Model": "G13"
  },
  {
    "Retail Branding": "Whitedeer",
    "Marketing Name": "K7",
    "Device": "K7",
    "Model": "K7"
  },
  {
    "Retail Branding": "Whitedeer",
    "Marketing Name": "K7_EEA",
    "Device": "K7",
    "Model": "K7"
  },
  {
    "Retail Branding": "Whitedeer",
    "Marketing Name": "KT1028",
    "Device": "KT1028",
    "Model": "KT1028"
  },
  {
    "Retail Branding": "Whitedeer",
    "Marketing Name": "KT1028A_EEA",
    "Device": "KT1028",
    "Model": "KT1028"
  },
  {
    "Retail Branding": "Whitedeer",
    "Marketing Name": "KT1028_EEA",
    "Device": "KT1028",
    "Model": "KT1028"
  },
  {
    "Retail Branding": "Whitedeer",
    "Marketing Name": "X7",
    "Device": "X7L",
    "Model": "X7L"
  },
  {
    "Retail Branding": "Whitedeer",
    "Marketing Name": "X7_EEA",
    "Device": "X7L",
    "Model": "X7L"
  },
  {
    "Retail Branding": "Wibox",
    "Marketing Name": "WiBox.tv V3",
    "Device": "WiBox-tv",
    "Model": "WiBox.tv V3"
  },
  {
    "Retail Branding": "Wibox",
    "Marketing Name": "WiboxTv",
    "Device": "dtiw384wb",
    "Model": "m384wb"
  },
  {
    "Retail Branding": "Widevu",
    "Marketing Name": "Korea",
    "Device": "yeongdeungpo",
    "Model": "Widevu UHD Android TV"
  },
  {
    "Retail Branding": "Widevu",
    "Marketing Name": "korea",
    "Device": "sepolia",
    "Model": "WIDEVU Smart TV"
  },
  {
    "Retail Branding": "Wieppo",
    "Marketing Name": "Wieppo E1",
    "Device": "Wieppo_E1",
    "Model": "Wieppo E1"
  },
  {
    "Retail Branding": "Wieppo",
    "Marketing Name": "Wieppo S5",
    "Device": "Wieppo_S5",
    "Model": "Wieppo S5"
  },
  {
    "Retail Branding": "Wieppo",
    "Marketing Name": "Wieppo S6",
    "Device": "t596_jw_wieppo",
    "Model": "Wieppo S6"
  },
  {
    "Retail Branding": "Wieppo",
    "Marketing Name": "Wieppo S8",
    "Device": "Wieppo_S8",
    "Model": "Wieppo S8"
  },
  {
    "Retail Branding": "Wigor",
    "Marketing Name": "V2",
    "Device": "V2",
    "Model": "V2"
  },
  {
    "Retail Branding": "Wigor",
    "Marketing Name": "V3",
    "Device": "V3",
    "Model": "V3"
  },
  {
    "Retail Branding": "Wigor",
    "Marketing Name": "V5",
    "Device": "V5",
    "Model": "V5"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "B-KOOL",
    "Device": "V2502AN01D",
    "Model": "B-KOOL"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "BIRDY",
    "Device": "BIRDY",
    "Model": "BIRDY"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "BLOOM",
    "Device": "s4700",
    "Model": "BLOOM"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "Barry",
    "Device": "s7811",
    "Model": "BARRY"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "C210AE",
    "Device": "C210AE",
    "Model": "C210AE"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "C800",
    "Device": "W_C800S",
    "Model": "W_C800S"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "C860",
    "Device": "W_C860",
    "Model": "W_C860"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "CINK SLIM 2",
    "Device": "s8074",
    "Model": "CINK SLIM 2"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "DARKFULL",
    "Device": "s9311",
    "Model": "DARKFULL"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "DARKFULL",
    "Device": "s9311",
    "Model": "Dream"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "DARKNIGHT",
    "Device": "s9203",
    "Model": "DARKNIGHT"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "DARKNIGHT",
    "Device": "s9203",
    "Model": "X-tremer"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "FEVER",
    "Device": "L5460AP25E",
    "Model": "FEVER"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "FEVER",
    "Device": "l5460",
    "Model": "FEVER"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "FEVER",
    "Device": "l5460",
    "Model": "Ridge 4G-Fever"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "FREDDY",
    "Device": "T3903BN",
    "Model": "FREDDY"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "FREDDY",
    "Device": "V3903BN",
    "Model": "FREDDY"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "GETAWAY",
    "Device": "s8812",
    "Model": "GETAWAY"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "GOA",
    "Device": "s3511",
    "Model": "GOA"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "Gallardo",
    "Device": "W-U300",
    "Model": "W-U300"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "HARRY",
    "Device": "V3953AN25K",
    "Model": "HARRY"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "HARRY",
    "Device": "v3953",
    "Model": "HARRY"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "HIGHWAY",
    "Device": "s9320",
    "Model": "HIGHWAY"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "HIGHWAY 4G",
    "Device": "s9321",
    "Model": "HIGHWAY 4G"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "HIGHWAY PURE",
    "Device": "l9010",
    "Model": "HIGHWAY PURE"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "HIGHWAY SIGNS",
    "Device": "s4750",
    "Model": "HIGHWAY SIGNS"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "HIGHWAY STAR",
    "Device": "l5560ae",
    "Model": "HIGHWAY STAR"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "Harry2",
    "Device": "W-V600",
    "Model": "W-V600"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "IGGY",
    "Device": "s7521",
    "Model": "Cynus F4"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "IGGY",
    "Device": "s7521",
    "Model": "Golf"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "IGGY",
    "Device": "s7521",
    "Model": "IGGY"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "JERRY",
    "Device": "V2802AN",
    "Model": "JERRY"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "JERRY",
    "Device": "v2806",
    "Model": "JERRY"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "JERRY MAX",
    "Device": "V3610AN",
    "Model": "JERRY MAX"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "JERRY2",
    "Device": "v2610",
    "Model": "JERRY2"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "JIMMY",
    "Device": "s4300ae",
    "Model": "JIMMY"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "Jerry4",
    "Device": "W-K420",
    "Model": "W-K420-TVM"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "K-KOOL",
    "Device": "T2800AN",
    "Model": "K-KOOL"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "K-KOOL",
    "Device": "V2800AN",
    "Model": "K-KOOL"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "K300S",
    "Device": "W_K300S",
    "Model": "W_K300S"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "KENNY",
    "Device": "V3913BN22I",
    "Model": "KENNY"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "KENNY",
    "Device": "v3913",
    "Model": "KENNY"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "KITE",
    "Device": "l4020",
    "Model": "KITE"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "LENNY",
    "Device": "s5201ap",
    "Model": "LENNY"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "LENNY2",
    "Device": "S5030AP12H",
    "Model": "LENNY2"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "LENNY2",
    "Device": "s5030",
    "Model": "LENNY2"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "LENNY3",
    "Device": "V3702AN",
    "Model": "LENNY3"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "LENNY3 MAX",
    "Device": "V3802AN",
    "Model": "LENNY3 MAX"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "Lenny4",
    "Device": "v3720",
    "Model": "Lenny4"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "Lenny4 Plus",
    "Device": "v3740",
    "Model": "Lenny4 Plus"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "M10 Lite",
    "Device": "M10_Lite",
    "Model": "M10 Lite"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "MACARON",
    "Device": "l8401_international",
    "Model": "MACARON"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "P311",
    "Device": "W-P311",
    "Model": "W-P311-EEA"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "P4903JP",
    "Device": "P4903JP",
    "Model": "P4903JP"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "PULP",
    "Device": "S5420",
    "Model": "PULP"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "PULP 4G",
    "Device": "l5421",
    "Model": "PULP 4G"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "PULP FAB",
    "Device": "S5260",
    "Model": "PULP FAB"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "PULP FAB",
    "Device": "S5260",
    "Model": "SLIDE2"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "PULP FAB 4G",
    "Device": "l5261",
    "Model": "PULP FAB 4G"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "Power U10",
    "Device": "W-V745",
    "Model": "W-V745-EEA"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "Power U10",
    "Device": "W-V745",
    "Model": "W-V745-OPE"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "Power U10",
    "Device": "W-V745",
    "Model": "W-V745-TVM"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "Power U20",
    "Device": "W-V750BN",
    "Model": "W-V750BN-EEA"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "Power U20",
    "Device": "W-V750BN",
    "Model": "W-V750BN-OPE"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "Power U20",
    "Device": "W-V750BN",
    "Model": "W-V750BN-TVM"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "Power U30",
    "Device": "W-V755",
    "Model": "W-V755-EEA"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "Power U30",
    "Device": "W-V755",
    "Model": "W-V755-OPE"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "Power U30",
    "Device": "W-V755",
    "Model": "W-V755-TVM"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "RAINBOW",
    "Device": "s5501",
    "Model": "RAINBOW"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "RAINBOW 4G",
    "Device": "l5503",
    "Model": "RAINBOW 4G"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "RAINBOW JAM",
    "Device": "S5254AP24K",
    "Model": "RAINBOW JAM"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "RAINBOW JAM",
    "Device": "s5250",
    "Model": "RAINBOW JAM"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "RAINBOW JAM",
    "Device": "s5254",
    "Model": "RAINBOW JAM"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "RAINBOW LITE",
    "Device": "s5222",
    "Model": "RAINBOW LITE"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "RAINBOW LITE 4G",
    "Device": "L5221",
    "Model": "RAINBOW LITE 4G"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "RAINBOW LITE 4G",
    "Device": "L5221AE23G",
    "Model": "RAINBOW LITE 4G"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "RAINBOW LITE 4G",
    "Device": "L5225AC",
    "Model": "RAINBOW LITE 4G"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "RAINBOW LITE 4G",
    "Device": "L5227AC",
    "Model": "RAINBOW LITE 4G"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "RAINBOW LITE 4G",
    "Device": "L5251",
    "Model": "RAINBOW JAM 4G"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "RAINBOW UP",
    "Device": "s5400",
    "Model": "RAINBOW UP"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "RAINBOW UP 4G",
    "Device": "l5401",
    "Model": "RAINBOW UP 4G"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "RIDGE",
    "Device": "s5513ap",
    "Model": "RIDGE"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "RIDGE 4G",
    "Device": "l5510",
    "Model": "RIDGE 4G"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "RIDGE FAB 4G",
    "Device": "l5320",
    "Model": "RIDGE FAB 4G"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "ROBBY",
    "Device": "V3750AN",
    "Model": "ROBBY"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "ROBBY",
    "Device": "V3750AN24K",
    "Model": "ROBBY"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "ROBBY2",
    "Device": "V3921",
    "Model": "ROBBY2"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "SELFY",
    "Device": "SELFY",
    "Model": "SELFY"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "SELFY 4G",
    "Device": "l4801",
    "Model": "SELFY 4G"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "SLIDE",
    "Device": "s8321",
    "Model": "SLIDE"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "SUGAR F7 mini",
    "Device": "p7203",
    "Model": "SUGAR F7 mini"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "SUGAR S9",
    "Device": "i9031",
    "Model": "SUGAR S9"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "SUNNY",
    "Device": "T2504AN",
    "Model": "SUNNY"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "SUNNY",
    "Device": "V2502AN",
    "Model": "SUNNY"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "SUNNY",
    "Device": "V2504AN",
    "Model": "SUNNY"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "SUNNY",
    "Device": "V2504AN01D",
    "Model": "SUNNY"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "SUNNY",
    "Device": "V2508AN01D",
    "Model": "SUNNY"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "SUNNY",
    "Device": "v2508",
    "Model": "SUNNY"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "SUNNY MAX",
    "Device": "T2520AN",
    "Model": "SUNNY MAX"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "SUNNY MAX",
    "Device": "v2520",
    "Model": "SUNNY MAX"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "SUNNY2",
    "Device": "v2510",
    "Model": "SUNNY2"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "SUNSET",
    "Device": "s4011",
    "Model": "SUNSET"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "SUNSET2",
    "Device": "s4050ap",
    "Model": "SUNSET2"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "Sunny2 Plus",
    "Device": "v2600cn",
    "Model": "Sunny2 Plus"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "Sunny3",
    "Device": "W_K120",
    "Model": "Sunny3"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "Sunny3 Mini",
    "Device": "W_K101",
    "Model": "Sunny3 Mini"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "Sunny3 Mini",
    "Device": "W_K101S",
    "Model": "Sunny3 Mini"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "Sunny4",
    "Device": "W-K130",
    "Model": "W-K130-TMV"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "Sunny5",
    "Device": "W-K380",
    "Model": "W-K380-TH"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "Sunny5",
    "Device": "W-K380",
    "Model": "W-K380-TVM"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "Sunny5",
    "Device": "W-K380",
    "Model": "W-K380-TVM2G"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "Sunny5 Lite",
    "Device": "W-K211",
    "Model": "W-K211-TH"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "Sunny5 Lite",
    "Device": "W-K211",
    "Model": "W-K211-TVM"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "T10",
    "Device": "W-V673",
    "Model": "WIKO T10"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "T20",
    "Device": "T20",
    "Model": "Aix-AN00"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "T3",
    "Device": "W-V770",
    "Model": "W-V770"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "T50",
    "Device": "W-P861",
    "Model": "WIKO T50"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "T60",
    "Device": "T60",
    "Model": "T60"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "TOMMY",
    "Device": "P4901AC",
    "Model": "TOMMY"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "TOMMY",
    "Device": "P4903LA",
    "Model": "TOMMY"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "TOMMY2",
    "Device": "T3931AC",
    "Model": "TOMMY2"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "TOMMY2",
    "Device": "V3931AC",
    "Model": "TOMMY2"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "TOMMY2",
    "Device": "V3933AC",
    "Model": "TOMMY2"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "Tommy2 Plus",
    "Device": "v3941",
    "Model": "Tommy2 Plus"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "Tommy3",
    "Device": "W_C200SN",
    "Model": "Tommy3"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "Tommy3",
    "Device": "W_C201",
    "Model": "Tommy3"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "Tommy3",
    "Device": "W_K600",
    "Model": "W_K600"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "Tommy3 Plus",
    "Device": "W-V600",
    "Model": "W-V600"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "Tone E19",
    "Device": "TONE_e19",
    "Model": "TONE e19"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "U FEEL",
    "Device": "P6601AE",
    "Model": "U FEEL"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "U FEEL",
    "Device": "P6609BC",
    "Model": "U FEEL"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "U FEEL",
    "Device": "P6609BCD",
    "Model": "U FEEL"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "U FEEL FAB",
    "Device": "V3991AN",
    "Model": "SUGAR Y7 MAX"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "U FEEL FAB",
    "Device": "V3991AN",
    "Model": "SUGAR Y8"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "U FEEL FAB",
    "Device": "V3991AN",
    "Model": "U FEEL FAB"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "U FEEL GO",
    "Device": "P4661AN",
    "Model": "U FEEL GO"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "U FEEL LITE",
    "Device": "P4601AN",
    "Model": "U FEEL LITE"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "U FEEL LITE",
    "Device": "T4601AN",
    "Model": "U FEEL LITE"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "U FEEL PRIME",
    "Device": "p7201",
    "Model": "U FEEL PRIME"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "U PULSE",
    "Device": "v3961",
    "Model": "U PULSE"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "U PULSE LITE",
    "Device": "v3971",
    "Model": "U PULSE LITE"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "U307AS",
    "Device": "U307AS",
    "Model": "U307AS"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "U520AS",
    "Device": "U520AS",
    "Model": "Wiko U520AS"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "VIEW",
    "Device": "v12dnlite",
    "Model": "View"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "VIEW",
    "Device": "v12enlite",
    "Model": "View"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "VIEW3",
    "Device": "W-P311",
    "Model": "W-P311-OPE"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "VIEW3",
    "Device": "W-P311",
    "Model": "W-P311-TVM"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "View",
    "Device": "v12bnlite",
    "Model": "View"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "View Max",
    "Device": "W_P200",
    "Model": "View Max"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "View Prime",
    "Device": "v12bn",
    "Model": "View Prime"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "View XL",
    "Device": "v11cnlite",
    "Model": "View XL"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "View2 Go",
    "Device": "W-P220",
    "Model": "View2 Go"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "View2 Plus",
    "Device": "W-P210",
    "Model": "View2 Plus"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "View3",
    "Device": "W-P311",
    "Model": "W-P311-CA"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "View3",
    "Device": "W-P311",
    "Model": "W-P311-EEA"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "View3",
    "Device": "W-P311",
    "Model": "W-P311-JP"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "View3 Lite",
    "Device": "W-V800",
    "Model": "W-V800-CA"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "View3 Lite",
    "Device": "W-V800",
    "Model": "W-V800-DU"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "View3 Lite",
    "Device": "W-V800",
    "Model": "W-V800-EEA"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "View3 Lite",
    "Device": "W-V800",
    "Model": "W-V800-OPE"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "View3 Lite",
    "Device": "W-V800",
    "Model": "W-V800-TIM"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "View3 Lite",
    "Device": "W-V800",
    "Model": "W-V800-TVM"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "View3 Pro",
    "Device": "W-P611",
    "Model": "W-P611-EEA"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "View3 Pro",
    "Device": "W-P611",
    "Model": "W-P611-OPE"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "View3 Pro",
    "Device": "W-P611",
    "Model": "W-P611-TVM"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "View4",
    "Device": "W-V830",
    "Model": "W-V830-EEA"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "View4",
    "Device": "W-V830",
    "Model": "W-V830-ID"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "View4",
    "Device": "W-V830",
    "Model": "W-V830-OPE"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "View4 Lite",
    "Device": "W-V730",
    "Model": "W-V730-EEA"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "View4 Lite",
    "Device": "W-V730",
    "Model": "W-V730-ID"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "View4 Lite",
    "Device": "W-V730",
    "Model": "W-V730-OPE"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "View4 Lite",
    "Device": "W-V730",
    "Model": "W-V730-TVM"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "View5",
    "Device": "W-V851",
    "Model": "W-V851-EEA"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "View5",
    "Device": "W-V851",
    "Model": "W-V851-OPE"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "View5",
    "Device": "W-V851",
    "Model": "W-V851-TVM"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "View5 Plus",
    "Device": "W-V850",
    "Model": "W-V850-EEA"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "View5 Plus",
    "Device": "W-V850",
    "Model": "W-V850-OPE"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "W-K200",
    "Device": "W-K200",
    "Model": "W-K200"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "WAX",
    "Device": "s8515",
    "Model": "WAX"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "WC300",
    "Device": "WC300",
    "Model": "WC300"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "WC300SN",
    "Device": "WC300SN",
    "Model": "WC300SN"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "WIKO 10",
    "Device": "VHEM",
    "Model": "VHEM"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "WIKO T21",
    "Device": "DBA-AN00",
    "Model": "WIKO T21"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "WIKO T30",
    "Device": "CAPT-AN00",
    "Model": "CAPT-AN00"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "WIKO T40",
    "Device": "T40",
    "Model": "ArkF-AF00"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "WIKO VOIX",
    "Device": "U616AT",
    "Model": "U616AT"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "WIM",
    "Device": "T9051AC",
    "Model": "WIM"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "WIM",
    "Device": "i9051",
    "Model": "WIM"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "WIM Lite",
    "Device": "T6901AC",
    "Model": "WIM Lite"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "WIM Lite",
    "Device": "p6901",
    "Model": "WIM Lite"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "W_C200SN",
    "Device": "W_C200SN",
    "Model": "W_C200SN"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "W_C800",
    "Device": "W_C800",
    "Model": "W_C800"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "W_C860",
    "Device": "W_C860",
    "Model": "W_C860"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "W_K120",
    "Device": "W_K120",
    "Model": "Sunny3"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "W_K300",
    "Device": "W_K300",
    "Model": "W_K300"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "W_K400",
    "Device": "W_K400",
    "Model": "W_K400"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "W_K600",
    "Device": "W_K600",
    "Model": "W_K600"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "W_P130",
    "Device": "W_P130",
    "Model": "W_P130"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "W_P200",
    "Device": "W_P200",
    "Model": "W_P200"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "W_P200CM",
    "Device": "W_P200CM",
    "Model": "View Max"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "W_P200CM",
    "Device": "W_P200CM",
    "Model": "W_P200CM"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "Wiko Life 3",
    "Device": "U316AT",
    "Model": "Wiko U316AT"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "Wiko Ride 3",
    "Device": "U614AS",
    "Model": "Wiko U614AS"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "Y50",
    "Device": "W-K130",
    "Model": "W-K130-BYT"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "Y50",
    "Device": "W-K130",
    "Model": "W-K130-EEA"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "Y50",
    "Device": "W-K130",
    "Model": "W-K130-OPE"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "Y50",
    "Device": "W-K420",
    "Model": "W-K420-EEA"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "Y51",
    "Device": "W-K211",
    "Model": "W-K211-EEA"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "Y51",
    "Device": "W-K211",
    "Model": "W-K211-OPE"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "Y52",
    "Device": "W-K521",
    "Model": "W-K521-EEA"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "Y52",
    "Device": "W-K521",
    "Model": "W-K521-OPE"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "Y60",
    "Device": "W-K510",
    "Model": "W-K510-BYT"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "Y60",
    "Device": "W-K510",
    "Model": "W-K510-EEA"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "Y60",
    "Device": "W-K510",
    "Model": "W-K510-OPE"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "Y60",
    "Device": "W-K510",
    "Model": "W-K510-SFC"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "Y60",
    "Device": "W-K510",
    "Model": "W-K510-SUN"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "Y60",
    "Device": "W-K510",
    "Model": "W-K510-TVM"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "Y60",
    "Device": "W-K510",
    "Model": "W-K510S-OPE"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "Y60",
    "Device": "W-K510",
    "Model": "W-K510S-SWI"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "Y60",
    "Device": "W-K510DG",
    "Model": "W-K510-TH"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "Y61",
    "Device": "W-K560",
    "Model": "W-K560-EEA"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "Y61",
    "Device": "W-K560",
    "Model": "W-K560-ID"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "Y61",
    "Device": "W-K560",
    "Model": "W-K560-OPE"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "Y61",
    "Device": "W-K560",
    "Model": "W-K560-TVM"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "Y61",
    "Device": "W-K560",
    "Model": "W-K560-TVM1G"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "Y62",
    "Device": "W-K610",
    "Model": "W-K610-EEA"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "Y62",
    "Device": "W-K610",
    "Model": "W-K610-OPE"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "Y62",
    "Device": "W-K610",
    "Model": "W-K610-TVM"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "Y62 Plus",
    "Device": "W-K610",
    "Model": "W-K610-FRA"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "Y62 Plus",
    "Device": "W-K610",
    "Model": "W-K610-SUI"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "Y80",
    "Device": "W-V720",
    "Model": "W-V720-CA"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "Y80",
    "Device": "W-V720",
    "Model": "W-V720-EEA"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "Y80",
    "Device": "W-V720",
    "Model": "W-V720-OPE"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "Y80",
    "Device": "W-V720",
    "Model": "W-V720-SUN"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "Y80",
    "Device": "W-V720",
    "Model": "W-V720-TVM"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "Y81",
    "Device": "W-V680",
    "Model": "W-V680-EEA"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "Y81",
    "Device": "W-V680",
    "Model": "W-V680-ID"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "Y81",
    "Device": "W-V680",
    "Model": "W-V680-OPE"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "Y81",
    "Device": "W-V680",
    "Model": "W-V680-SUN"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "Y82",
    "Device": "W-K630",
    "Model": "W-K630-EEA"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "Y82",
    "Device": "W-K630",
    "Model": "W-K630-OPE"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "Y82",
    "Device": "W-K630",
    "Model": "W-K630-TRU"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "Y82",
    "Device": "W-K630",
    "Model": "W-K630-TVM"
  },
  {
    "Retail Branding": "Wiko",
    "Marketing Name": "sunny4 Plus",
    "Device": "W-K360",
    "Model": "W-K360-TV"
  },
  {
    "Retail Branding": "Wileyfox",
    "Marketing Name": "Spark",
    "Device": "porridge",
    "Model": "Wileyfox Spark"
  },
  {
    "Retail Branding": "Wileyfox",
    "Marketing Name": "Spark",
    "Device": "porridge",
    "Model": "Wileyfox Spark +"
  },
  {
    "Retail Branding": "Wileyfox",
    "Marketing Name": "Spark",
    "Device": "porridgek3",
    "Model": "Wileyfox Spark X"
  },
  {
    "Retail Branding": "Wileyfox",
    "Marketing Name": "Spark Add-X",
    "Device": "porridge",
    "Model": "Wileyfox Spark"
  },
  {
    "Retail Branding": "Wileyfox",
    "Marketing Name": "Spark Add-X",
    "Device": "porridge",
    "Model": "Wileyfox Spark +"
  },
  {
    "Retail Branding": "Wileyfox",
    "Marketing Name": "Spark X",
    "Device": "porridgek3",
    "Model": "Wileyfox Spark X"
  },
  {
    "Retail Branding": "Wileyfox",
    "Marketing Name": "Spark X Add-X",
    "Device": "porridgek3",
    "Model": "Wileyfox Spark X"
  },
  {
    "Retail Branding": "Wileyfox",
    "Marketing Name": "Storm",
    "Device": "kipper",
    "Model": "Wileyfox Storm"
  },
  {
    "Retail Branding": "Wileyfox",
    "Marketing Name": "Swift",
    "Device": "crackling",
    "Model": "Wileyfox Swift"
  },
  {
    "Retail Branding": "Wileyfox",
    "Marketing Name": "Swift 2",
    "Device": "marmite",
    "Model": "Swift 2"
  },
  {
    "Retail Branding": "Wileyfox",
    "Marketing Name": "Swift 2",
    "Device": "marmite",
    "Model": "Swift 2 Plus"
  },
  {
    "Retail Branding": "Wileyfox",
    "Marketing Name": "Swift 2",
    "Device": "marmite",
    "Model": "Swift 2 X"
  },
  {
    "Retail Branding": "Wileyfox",
    "Marketing Name": "Swift 2",
    "Device": "marmite",
    "Model": "Wileyfox Swift 2 Plus"
  },
  {
    "Retail Branding": "Wileyfox",
    "Marketing Name": "Swift2 Add-X",
    "Device": "marmite",
    "Model": "Swift 2 Plus"
  },
  {
    "Retail Branding": "Win (VE)",
    "Marketing Name": "M3",
    "Device": "M3",
    "Model": "M3"
  },
  {
    "Retail Branding": "Win (VE)",
    "Marketing Name": "M5",
    "Device": "M5",
    "Model": "M5"
  },
  {
    "Retail Branding": "Win (VE)",
    "Marketing Name": "M5plus",
    "Device": "M5plus",
    "Model": "M5plus"
  },
  {
    "Retail Branding": "Win (VE)",
    "Marketing Name": "N4",
    "Device": "N4",
    "Model": "N4"
  },
  {
    "Retail Branding": "Win (VE)",
    "Marketing Name": "N4plus",
    "Device": "N4plus",
    "Model": "N4plus"
  },
  {
    "Retail Branding": "Win (VE)",
    "Marketing Name": "Q7",
    "Device": "Q7",
    "Model": "Q7"
  },
  {
    "Retail Branding": "Win (VE)",
    "Marketing Name": "Q9",
    "Device": "Q9",
    "Model": "Q9"
  },
  {
    "Retail Branding": "WinRo",
    "Marketing Name": "Voni10",
    "Device": "Voni10",
    "Model": "Voni 10"
  },
  {
    "Retail Branding": "WinRo",
    "Marketing Name": "Voni10Pro",
    "Device": "Voni10Pro",
    "Model": "TK-P86"
  },
  {
    "Retail Branding": "WinRo",
    "Marketing Name": "Voni10Pro",
    "Device": "Voni10Pro",
    "Model": "Voni 10 Pro"
  },
  {
    "Retail Branding": "Winds Mobile",
    "Marketing Name": "MT7001",
    "Device": "MT7001",
    "Model": "MT7001"
  },
  {
    "Retail Branding": "Winds Mobile",
    "Marketing Name": "WINDS-T3",
    "Device": "WINDS-T3",
    "Model": "T3"
  },
  {
    "Retail Branding": "Wings",
    "Marketing Name": "W1",
    "Device": "W1",
    "Model": "W1"
  },
  {
    "Retail Branding": "Wings",
    "Marketing Name": "W4",
    "Device": "W4",
    "Model": "W4"
  },
  {
    "Retail Branding": "Wings",
    "Marketing Name": "W4 EEA",
    "Device": "W4",
    "Model": "W4"
  },
  {
    "Retail Branding": "Wings",
    "Marketing Name": "W6",
    "Device": "W6",
    "Model": "W6"
  },
  {
    "Retail Branding": "Wings",
    "Marketing Name": "W7",
    "Device": "W7",
    "Model": "W7"
  },
  {
    "Retail Branding": "Wings",
    "Marketing Name": "W7 Q",
    "Device": "W7_Q",
    "Model": "W7"
  },
  {
    "Retail Branding": "Wings",
    "Marketing Name": "W7_Q_EEA",
    "Device": "W7_Q",
    "Model": "W7"
  },
  {
    "Retail Branding": "Wings",
    "Marketing Name": "WX",
    "Device": "WX",
    "Model": "WX"
  },
  {
    "Retail Branding": "Wink",
    "Marketing Name": "City S",
    "Device": "Wink_City_S",
    "Model": "Wink_City_S"
  },
  {
    "Retail Branding": "Wink",
    "Marketing Name": "Glory_SE",
    "Device": "Wink_Glory_SE",
    "Model": "Wink Glory SE"
  },
  {
    "Retail Branding": "Wink",
    "Marketing Name": "Share SE",
    "Device": "Wink_Share_SE",
    "Model": "Wink_Share_SE"
  },
  {
    "Retail Branding": "Wink",
    "Marketing Name": "World SE",
    "Device": "Wink_World_SE",
    "Model": "Wink World SE"
  },
  {
    "Retail Branding": "Winmax",
    "Marketing Name": "PolarH4",
    "Device": "PolarH4",
    "Model": "PolarH4"
  },
  {
    "Retail Branding": "Winmax",
    "Marketing Name": "TIGER X7",
    "Device": "TIGER_X7",
    "Model": "TIGER X7"
  },
  {
    "Retail Branding": "Winmax",
    "Marketing Name": "Tiger X12",
    "Device": "Tiger_X12",
    "Model": "Tiger X12"
  },
  {
    "Retail Branding": "Winmax",
    "Marketing Name": "Tiger X4",
    "Device": "TIGER_X4",
    "Model": "TIGER X4"
  },
  {
    "Retail Branding": "Winmax",
    "Marketing Name": "Tiger_X10",
    "Device": "TIGER_X10",
    "Model": "TIGER_X10"
  },
  {
    "Retail Branding": "Winmax",
    "Marketing Name": "X50",
    "Device": "X50",
    "Model": "X50"
  },
  {
    "Retail Branding": "Winmax",
    "Marketing Name": "x40",
    "Device": "X40",
    "Model": "X40"
  },
  {
    "Retail Branding": "Winnovo",
    "Marketing Name": "H10",
    "Device": "H10",
    "Model": "H10_EEA"
  },
  {
    "Retail Branding": "Winnovo",
    "Marketing Name": "H10Pro_eea",
    "Device": "H10Pro",
    "Model": "H10Pro"
  },
  {
    "Retail Branding": "Winnovo",
    "Marketing Name": "H10_US",
    "Device": "H10_US",
    "Model": "H10_US"
  },
  {
    "Retail Branding": "Winnovo",
    "Marketing Name": "H7",
    "Device": "H7",
    "Model": "H7_EEA"
  },
  {
    "Retail Branding": "Winnovo",
    "Marketing Name": "H7_US",
    "Device": "H7_US",
    "Model": "H7_US"
  },
  {
    "Retail Branding": "Winnovo",
    "Marketing Name": "H8",
    "Device": "H8",
    "Model": "H8_EEA"
  },
  {
    "Retail Branding": "Winnovo",
    "Marketing Name": "H8_US",
    "Device": "H8_US",
    "Model": "H8_US"
  },
  {
    "Retail Branding": "Winnovo",
    "Marketing Name": "M86",
    "Device": "M86",
    "Model": "M86"
  },
  {
    "Retail Branding": "Winnovo",
    "Marketing Name": "M8_EEA",
    "Device": "M8",
    "Model": "M8"
  },
  {
    "Retail Branding": "Winnovo",
    "Marketing Name": "P20-Tab",
    "Device": "P20-Tab",
    "Model": "P20-Tab"
  },
  {
    "Retail Branding": "Winnovo",
    "Marketing Name": "P20-Tab_EEA",
    "Device": "P20-Tab_EEA",
    "Model": "P20-Tab_EEA"
  },
  {
    "Retail Branding": "Winnovo",
    "Marketing Name": "T10",
    "Device": "T10",
    "Model": "T10"
  },
  {
    "Retail Branding": "Winnovo",
    "Marketing Name": "T10LTE_eea",
    "Device": "T10LTE",
    "Model": "T10LTE"
  },
  {
    "Retail Branding": "Winnovo",
    "Marketing Name": "T113",
    "Device": "T113",
    "Model": "T113"
  },
  {
    "Retail Branding": "Winnovo",
    "Marketing Name": "T113_eea",
    "Device": "T113",
    "Model": "T113"
  },
  {
    "Retail Branding": "Winnovo",
    "Marketing Name": "T7_eea",
    "Device": "T7",
    "Model": "T7"
  },
  {
    "Retail Branding": "Winnovo",
    "Marketing Name": "T8",
    "Device": "T8",
    "Model": "T8"
  },
  {
    "Retail Branding": "Winnovo",
    "Marketing Name": "T8_eea",
    "Device": "T8",
    "Model": "T8"
  },
  {
    "Retail Branding": "Winnovo",
    "Marketing Name": "TS10",
    "Device": "TS10",
    "Model": "TS10"
  },
  {
    "Retail Branding": "Winnovo",
    "Marketing Name": "TS10_EEA",
    "Device": "TS10_EEA",
    "Model": "TS10_EEA"
  },
  {
    "Retail Branding": "Winnovo",
    "Marketing Name": "TS7",
    "Device": "TS7",
    "Model": "TS7"
  },
  {
    "Retail Branding": "Winnovo",
    "Marketing Name": "TS7",
    "Device": "TS7_EEA",
    "Model": "TS7_EEA"
  },
  {
    "Retail Branding": "Winnovo",
    "Marketing Name": "Winnovo",
    "Device": "M8",
    "Model": "M8"
  },
  {
    "Retail Branding": "Winnovo",
    "Marketing Name": "WinnovoT5",
    "Device": "WinnovoT5",
    "Model": "WinnovoT5"
  },
  {
    "Retail Branding": "Winny",
    "Marketing Name": "K11",
    "Device": "K11",
    "Model": "K11"
  },
  {
    "Retail Branding": "Winovo",
    "Marketing Name": "Winovo_M50B",
    "Device": "Winovo_M50B",
    "Model": "Winovo_M50B"
  },
  {
    "Retail Branding": "Winovo",
    "Marketing Name": "Winovo_M50B_EEA",
    "Device": "Winovo_M50B",
    "Model": "Winovo_M50B"
  },
  {
    "Retail Branding": "Wintec",
    "Marketing Name": "T730",
    "Device": "T730",
    "Model": "Clear"
  },
  {
    "Retail Branding": "Wintec",
    "Marketing Name": "T730",
    "Device": "T730",
    "Model": "T730"
  },
  {
    "Retail Branding": "Wintec",
    "Marketing Name": "T750",
    "Device": "T750",
    "Model": "Clear"
  },
  {
    "Retail Branding": "Wintouch",
    "Marketing Name": "A20",
    "Device": "A20",
    "Model": "A20"
  },
  {
    "Retail Branding": "Wintouch",
    "Marketing Name": "A50",
    "Device": "A50",
    "Model": "A50"
  },
  {
    "Retail Branding": "Wintouch",
    "Marketing Name": "A60_EEA",
    "Device": "A60_EEA",
    "Model": "A60"
  },
  {
    "Retail Branding": "Wintouch",
    "Marketing Name": "K19",
    "Device": "K19",
    "Model": "K19"
  },
  {
    "Retail Branding": "Wintouch",
    "Marketing Name": "K705A",
    "Device": "K705A",
    "Model": "K705A"
  },
  {
    "Retail Branding": "Wintouch",
    "Marketing Name": "K705A_EEA",
    "Device": "K705A_EEA",
    "Model": "K705A_EEA"
  },
  {
    "Retail Branding": "Wintouch",
    "Marketing Name": "K72P",
    "Device": "K72P",
    "Model": "K72P"
  },
  {
    "Retail Branding": "Wintouch",
    "Marketing Name": "Q705",
    "Device": "Q705",
    "Model": "Q705"
  },
  {
    "Retail Branding": "Wintouch",
    "Marketing Name": "WINTOUCH_K702",
    "Device": "WINTOUCH_K702",
    "Model": "K702"
  },
  {
    "Retail Branding": "Wirele-X",
    "Marketing Name": "MT70",
    "Device": "MT70",
    "Model": "MT70"
  },
  {
    "Retail Branding": "WirelessGate",
    "Marketing Name": "wg_tablet_01",
    "Device": "wg_tablet_01",
    "Model": "wg_tablet_01"
  },
  {
    "Retail Branding": "Wise-Tech",
    "Marketing Name": "P33",
    "Device": "P33",
    "Model": "P33"
  },
  {
    "Retail Branding": "Wise-Tech",
    "Marketing Name": "P33Lite",
    "Device": "P33Lite",
    "Model": "P33Lite"
  },
  {
    "Retail Branding": "Wise-Tech",
    "Marketing Name": "P55",
    "Device": "P55",
    "Model": "P55"
  },
  {
    "Retail Branding": "Wise-Tech",
    "Marketing Name": "Tech-A1",
    "Device": "Tech-A1",
    "Model": "Tech A1"
  },
  {
    "Retail Branding": "Wise-Tech",
    "Marketing Name": "Tech_A1_Plus",
    "Device": "Tech_A1_Plus",
    "Model": "Tech_A1_Plus"
  },
  {
    "Retail Branding": "Wise-Tech",
    "Marketing Name": "Wise-Tech_M1",
    "Device": "Wise-Tech_M1",
    "Model": "Wise-Tech_M1"
  },
  {
    "Retail Branding": "Wise-Tech",
    "Marketing Name": "WiseTech_Note_12",
    "Device": "WiseTech_Note_12",
    "Model": "WiseTech Note 12"
  },
  {
    "Retail Branding": "WiseTech",
    "Marketing Name": "WiseTech_Note_10",
    "Device": "WiseTech_Note_10",
    "Model": "WiseTech Note 10"
  },
  {
    "Retail Branding": "Wiseasy",
    "Marketing Name": "Nano 6",
    "Device": "Nano6",
    "Model": "Nano6"
  },
  {
    "Retail Branding": "Wiseasy",
    "Marketing Name": "P5_EEA",
    "Device": "P5",
    "Model": "P5"
  },
  {
    "Retail Branding": "Wiseasy",
    "Marketing Name": "T2",
    "Device": "T2",
    "Model": "T2"
  },
  {
    "Retail Branding": "Wiseasy",
    "Marketing Name": "WISEASY N6",
    "Device": "Nano6",
    "Model": "Nano6"
  },
  {
    "Retail Branding": "Wiseasy",
    "Marketing Name": "WISENET5",
    "Device": "WISENET5",
    "Model": "WISENET5"
  },
  {
    "Retail Branding": "Wiseasy",
    "Marketing Name": "Wiseasy P5",
    "Device": "P5",
    "Model": "P5"
  },
  {
    "Retail Branding": "Wishtel",
    "Marketing Name": 102017,
    "Device": 102017,
    "Model": 102017
  },
  {
    "Retail Branding": "Wishtel",
    "Marketing Name": "IRA",
    "Device": "IRA",
    "Model": "IRAI1705"
  },
  {
    "Retail Branding": "Wishtel",
    "Marketing Name": "IRA07",
    "Device": "IRA07",
    "Model": "IRA07"
  },
  {
    "Retail Branding": "Wishtel",
    "Marketing Name": "IRA102017I",
    "Device": "IRA102017I",
    "Model": "IRA102017I"
  },
  {
    "Retail Branding": "Wishtel",
    "Marketing Name": "IRAJ2",
    "Device": "IRAJ2",
    "Model": "IRAJ2"
  },
  {
    "Retail Branding": "Wishtel",
    "Marketing Name": "IRAW7258",
    "Device": "IRAW7258",
    "Model": "IRAW7258"
  },
  {
    "Retail Branding": "Wishtel",
    "Marketing Name": "IRAW801",
    "Device": "IRAW801",
    "Model": "IRAW801"
  },
  {
    "Retail Branding": "Wishtel",
    "Marketing Name": "IRAW801I",
    "Device": "IRAW801I",
    "Model": "IRAW801I"
  },
  {
    "Retail Branding": "Wishtel",
    "Marketing Name": "IRA_DUO",
    "Device": "IRA_DUO",
    "Model": "IRA_DUO"
  },
  {
    "Retail Branding": "Wishtel",
    "Marketing Name": "IRA_S1",
    "Device": "IRA_S1",
    "Model": "IRA_S1"
  },
  {
    "Retail Branding": "Wishtel",
    "Marketing Name": "IRA_S2",
    "Device": "IRA_S2",
    "Model": "IRA_S2"
  },
  {
    "Retail Branding": "Wishtel",
    "Marketing Name": "T811",
    "Device": "T811",
    "Model": "T811"
  },
  {
    "Retail Branding": "Wismann",
    "Marketing Name": "WISMANN",
    "Device": "elliniko",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "Wismann",
    "Marketing Name": "WISMANN",
    "Device": "stanford",
    "Model": "2K SMART TV"
  },
  {
    "Retail Branding": "Wismann",
    "Marketing Name": "WISMANN",
    "Device": "zhongshan",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "Wistron",
    "Marketing Name": "DW-21(A)",
    "Device": "DA-21",
    "Model": "DW-21(A)"
  },
  {
    "Retail Branding": "Wistron",
    "Marketing Name": "W1011A",
    "Device": "w1011a",
    "Model": "W1011A"
  },
  {
    "Retail Branding": "Witooth",
    "Marketing Name": "Android TV",
    "Device": "longshan",
    "Model": "AI PONT NA"
  },
  {
    "Retail Branding": "Witooth",
    "Marketing Name": "UHD Android TV",
    "Device": "sindorim",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "Wizphone",
    "Marketing Name": "Arc8",
    "Device": "Arc8",
    "Model": "WIZ Arc 8"
  },
  {
    "Retail Branding": "Wizphone",
    "Marketing Name": "Slate10",
    "Device": "Slate10",
    "Model": "Slate 10"
  },
  {
    "Retail Branding": "Wizphone",
    "Marketing Name": "WP003",
    "Device": "WP003",
    "Model": "WP003"
  },
  {
    "Retail Branding": "Wizphone",
    "Marketing Name": "WP005",
    "Device": "WP005",
    "Model": "WP005"
  },
  {
    "Retail Branding": "Wizz",
    "Marketing Name": "DV-PTB1080",
    "Device": "DV-PTB1080",
    "Model": "DV-PTB1080"
  },
  {
    "Retail Branding": "Wobble",
    "Marketing Name": "WB25SPMTA15P2",
    "Device": "WB25SPMTA15P2",
    "Model": "WB25SPMTA15P2"
  },
  {
    "Retail Branding": "Wolki",
    "Marketing Name": "WS040",
    "Device": "WS040",
    "Model": "WS040"
  },
  {
    "Retail Branding": "Wolki",
    "Marketing Name": "WS041",
    "Device": "WS041",
    "Model": "WS041"
  },
  {
    "Retail Branding": "Wolki",
    "Marketing Name": "WS051",
    "Device": "WS051",
    "Model": "WS051"
  },
  {
    "Retail Branding": "Wonder",
    "Marketing Name": "Wonder",
    "Device": "W5",
    "Model": "W5"
  },
  {
    "Retail Branding": "Woongjin",
    "Marketing Name": "WoongjinThinkbig",
    "Device": "BP-1001",
    "Model": "BP-1001"
  },
  {
    "Retail Branding": "Wopad",
    "Marketing Name": "Wopad-Kids7Q",
    "Device": "Wopad-Kids7Q",
    "Model": "Wopad-Kids7Q"
  },
  {
    "Retail Branding": "Workmate",
    "Marketing Name": "U13",
    "Device": "U13",
    "Model": "U13"
  },
  {
    "Retail Branding": "Wowi",
    "Marketing Name": "S8e",
    "Device": "S8e",
    "Model": "S8e"
  },
  {
    "Retail Branding": "Wowi",
    "Marketing Name": "SQ733",
    "Device": "SQ733",
    "Model": "SQ733"
  },
  {
    "Retail Branding": "Wowi",
    "Marketing Name": "SQ753",
    "Device": "SQ753",
    "Model": "SQ753"
  },
  {
    "Retail Branding": "Wowi",
    "Marketing Name": "SQ758",
    "Device": "SQ758",
    "Model": "SQ758"
  },
  {
    "Retail Branding": "Wowi",
    "Marketing Name": "SQ776",
    "Device": "SQ776",
    "Model": "SQ776"
  },
  {
    "Retail Branding": "Wowi",
    "Marketing Name": "SQ788",
    "Device": "SQ788",
    "Model": "SQ788"
  },
  {
    "Retail Branding": "Wowi",
    "Marketing Name": "SQ788Extreme",
    "Device": "SQ788Extreme",
    "Model": "SQ788Extreme"
  },
  {
    "Retail Branding": "Wowi",
    "Marketing Name": "SQ788_1",
    "Device": "SQ788_1",
    "Model": "SQ788"
  },
  {
    "Retail Branding": "Wowi",
    "Marketing Name": "Tab_X5",
    "Device": "Tab_X5",
    "Model": "Tab_X5"
  },
  {
    "Retail Branding": "Woxter",
    "Marketing Name": "Woxter",
    "Device": "Woxter_N70",
    "Model": "Woxter_N70"
  },
  {
    "Retail Branding": "Woxter",
    "Marketing Name": "Woxter_N100",
    "Device": "Woxter_N100",
    "Model": "Woxter_N100"
  },
  {
    "Retail Branding": "Woxter",
    "Marketing Name": "Woxter_N200",
    "Device": "Woxter_N200",
    "Model": "Woxter_N200"
  },
  {
    "Retail Branding": "Woxter",
    "Marketing Name": "Woxter_N90",
    "Device": "Woxter_N90",
    "Model": "Woxter_N90"
  },
  {
    "Retail Branding": "Woxter",
    "Marketing Name": "X100",
    "Device": "X100",
    "Model": "X100"
  },
  {
    "Retail Branding": "Woxter",
    "Marketing Name": "X100_PRO",
    "Device": "X100_PRO",
    "Model": "X100_PRO"
  },
  {
    "Retail Branding": "Woxter",
    "Marketing Name": "X100v3",
    "Device": "X100v3",
    "Model": "X100v3"
  },
  {
    "Retail Branding": "Woxter",
    "Marketing Name": "X200",
    "Device": "X200",
    "Model": "X200"
  },
  {
    "Retail Branding": "Woxter",
    "Marketing Name": "X200_PRO_v2",
    "Device": "X200_PRO_v2",
    "Model": "X200_PRO_v2"
  },
  {
    "Retail Branding": "Woxter",
    "Marketing Name": "X70",
    "Device": "X70",
    "Model": "X70"
  },
  {
    "Retail Branding": "Woxter",
    "Marketing Name": "X70_PRO",
    "Device": "X70_PRO",
    "Model": "X70_PRO"
  },
  {
    "Retail Branding": "Woxter",
    "Marketing Name": "X70v2",
    "Device": "X70v2",
    "Model": "X70v2"
  },
  {
    "Retail Branding": "Wpawa",
    "Marketing Name": "HT10-A",
    "Device": "HT10-A",
    "Model": "HT10-A"
  },
  {
    "Retail Branding": "Wpawa",
    "Marketing Name": "HT10-AB",
    "Device": "HT10-AB",
    "Model": "HT10-AB"
  },
  {
    "Retail Branding": "Wpawa",
    "Marketing Name": "HT10-AB",
    "Device": "HT10-AB",
    "Model": "HT10-PRO"
  },
  {
    "Retail Branding": "Wpawa",
    "Marketing Name": "HT10-PRO",
    "Device": "HT10-PRO",
    "Model": "HT10-PRO"
  },
  {
    "Retail Branding": "Wpawa",
    "Marketing Name": "HT10_Plus",
    "Device": "HT10_Plus",
    "Model": "HT10_Plus"
  },
  {
    "Retail Branding": "Wpawa",
    "Marketing Name": "HT10_Ultra",
    "Device": "HT10_Ultra",
    "Model": "HT10_Ultra"
  },
  {
    "Retail Branding": "X-Age",
    "Marketing Name": "A1",
    "Device": "A1",
    "Model": "A1"
  },
  {
    "Retail Branding": "X-Age",
    "Marketing Name": "ACE",
    "Device": "ACE",
    "Model": "ACE"
  },
  {
    "Retail Branding": "X-Age",
    "Marketing Name": "G1",
    "Device": "G1",
    "Model": "G1"
  },
  {
    "Retail Branding": "X-Age",
    "Marketing Name": "G1LITE",
    "Device": "G1LITE",
    "Model": "G1LITE"
  },
  {
    "Retail Branding": "X-Age",
    "Marketing Name": "G2",
    "Device": "G2",
    "Model": "G2"
  },
  {
    "Retail Branding": "X-Age",
    "Marketing Name": "Tab40",
    "Device": "Tab40",
    "Model": "Tab40"
  },
  {
    "Retail Branding": "X-Age",
    "Marketing Name": "Tab_31",
    "Device": "Tab_31",
    "Model": "Tab_31"
  },
  {
    "Retail Branding": "X-Age",
    "Marketing Name": "X_AGE_Leap_1",
    "Device": "X_AGE_Leap_1",
    "Model": "X-AGE Leap 1"
  },
  {
    "Retail Branding": "X-Age",
    "Marketing Name": "X_AGE_Snap_1",
    "Device": "X_AGE_Snap_1",
    "Model": "X-AGE Snap 1"
  },
  {
    "Retail Branding": "X-PREMIUM",
    "Marketing Name": "X1",
    "Device": "X1",
    "Model": "X1"
  },
  {
    "Retail Branding": "X-PREMIUM",
    "Marketing Name": "X_1",
    "Device": "X_1",
    "Model": "X_1"
  },
  {
    "Retail Branding": "X-TEK",
    "Marketing Name": "X2",
    "Device": "X2",
    "Model": "X2"
  },
  {
    "Retail Branding": "X-TIGI",
    "Marketing Name": "9A",
    "Device": "9A",
    "Model": "9A"
  },
  {
    "Retail Branding": "X-TIGI",
    "Marketing Name": "9C",
    "Device": "9C",
    "Model": "9C"
  },
  {
    "Retail Branding": "X-TIGI",
    "Marketing Name": "A10S",
    "Device": "A10S",
    "Model": "A10S"
  },
  {
    "Retail Branding": "X-TIGI",
    "Marketing Name": "A10c",
    "Device": "A10c",
    "Model": "A10c"
  },
  {
    "Retail Branding": "X-TIGI",
    "Marketing Name": "A20C",
    "Device": "A20C",
    "Model": "A20C"
  },
  {
    "Retail Branding": "X-TIGI",
    "Marketing Name": "A20S",
    "Device": "A20S",
    "Model": "A20S"
  },
  {
    "Retail Branding": "X-TIGI",
    "Marketing Name": "A20S_PRO",
    "Device": "A20S_PRO",
    "Model": "A20S PRO"
  },
  {
    "Retail Branding": "X-TIGI",
    "Marketing Name": "A3",
    "Device": "A3",
    "Model": "A3"
  },
  {
    "Retail Branding": "X-TIGI",
    "Marketing Name": "A55",
    "Device": "X-TIGI_A55",
    "Model": "A55"
  },
  {
    "Retail Branding": "X-TIGI",
    "Marketing Name": "A90S",
    "Device": "A90S",
    "Model": "A90S"
  },
  {
    "Retail Branding": "X-TIGI",
    "Marketing Name": "Hope10Pro",
    "Device": "Hope10Pro",
    "Model": "Hope10Pro"
  },
  {
    "Retail Branding": "X-TIGI",
    "Marketing Name": "Hope10_Mate",
    "Device": "Hope10_Mate",
    "Model": "Hope10 Mate"
  },
  {
    "Retail Branding": "X-TIGI",
    "Marketing Name": "Hope10_Plus",
    "Device": "Hope10_Plus",
    "Model": "Hope10 Plus"
  },
  {
    "Retail Branding": "X-TIGI",
    "Marketing Name": "Hope10_Pro",
    "Device": "Hope10_Pro",
    "Model": "Hope10 Pro"
  },
  {
    "Retail Branding": "X-TIGI",
    "Marketing Name": "Hope7_LTE",
    "Device": "Hope7_LTE",
    "Model": "Hope7 LTE"
  },
  {
    "Retail Branding": "X-TIGI",
    "Marketing Name": "Hope7_Mate",
    "Device": "Hope7_Mate",
    "Model": "Hope7_Mate"
  },
  {
    "Retail Branding": "X-TIGI",
    "Marketing Name": "Hope7_Max",
    "Device": "Hope7_Max",
    "Model": "Hope7 Max"
  },
  {
    "Retail Branding": "X-TIGI",
    "Marketing Name": "Hope7_Plus",
    "Device": "Hope7_Plus",
    "Model": "Hope7_Plus"
  },
  {
    "Retail Branding": "X-TIGI",
    "Marketing Name": "Hope7_Pro",
    "Device": "Hope7_Pro",
    "Model": "Hope7_Pro"
  },
  {
    "Retail Branding": "X-TIGI",
    "Marketing Name": "Hope8_LTE",
    "Device": "Hope8_LTE",
    "Model": "Hope8_LTE"
  },
  {
    "Retail Branding": "X-TIGI",
    "Marketing Name": "Hope8_Mate",
    "Device": "Hope8_Mate",
    "Model": "Hope8_Mate"
  },
  {
    "Retail Branding": "X-TIGI",
    "Marketing Name": "JOY10_LTE",
    "Device": "MID",
    "Model": "JOY10_LTE"
  },
  {
    "Retail Branding": "X-TIGI",
    "Marketing Name": "JOY10_Mate",
    "Device": "JOY10_Mate",
    "Model": "X-TIGI_JOY10 Mate"
  },
  {
    "Retail Branding": "X-TIGI",
    "Marketing Name": "JOY7_Mate",
    "Device": "JOY7_Mate",
    "Model": "X_TIGI_JOY7_Mate"
  },
  {
    "Retail Branding": "X-TIGI",
    "Marketing Name": "JOY7_TV",
    "Device": "JOY7_TV",
    "Model": "X_TIGI_JOY7_TV"
  },
  {
    "Retail Branding": "X-TIGI",
    "Marketing Name": "JOY8_LTE",
    "Device": "MID",
    "Model": "JOY8_LTE"
  },
  {
    "Retail Branding": "X-TIGI",
    "Marketing Name": "JOY8_Mate",
    "Device": "JOY8_Mate",
    "Model": "X-TIGI_JOY8 Mate"
  },
  {
    "Retail Branding": "X-TIGI",
    "Marketing Name": "KIDS_TAB",
    "Device": "KIDS_TAB",
    "Model": "KIDS_TAB"
  },
  {
    "Retail Branding": "X-TIGI",
    "Marketing Name": "Kids7_Pro",
    "Device": "Kids7_Pro",
    "Model": "Kids7 Pro"
  },
  {
    "Retail Branding": "X-TIGI",
    "Marketing Name": "Kids8 Pro",
    "Device": "Kids8_Pro",
    "Model": "X-TIGI_Kids8 Pro"
  },
  {
    "Retail Branding": "X-TIGI",
    "Marketing Name": "Kids9 Pro",
    "Device": "Kids9_Pro",
    "Model": "Kids9 Pro"
  },
  {
    "Retail Branding": "X-TIGI",
    "Marketing Name": "M20S",
    "Device": "M20S",
    "Model": "M20S"
  },
  {
    "Retail Branding": "X-TIGI",
    "Marketing Name": "Photo P15 Lite",
    "Device": "Photo_P15_Lite",
    "Model": "Photo_P15_Lite"
  },
  {
    "Retail Branding": "X-TIGI",
    "Marketing Name": "SHARP1",
    "Device": "SHARP1",
    "Model": "SHARP1"
  },
  {
    "Retail Branding": "X-TIGI",
    "Marketing Name": "SHARP2_Pro",
    "Device": "SHARP2_Pro",
    "Model": "SHARP2_Pro"
  },
  {
    "Retail Branding": "X-TIGI",
    "Marketing Name": "SHARP_2",
    "Device": "SHARP_2",
    "Model": "SHARP_2"
  },
  {
    "Retail Branding": "X-TIGI",
    "Marketing Name": "Sharp1_Lite",
    "Device": "Sharp1_Lite",
    "Model": "Sharp1_Lite"
  },
  {
    "Retail Branding": "X-TIGI",
    "Marketing Name": "V12",
    "Device": "V12",
    "Model": "V12"
  },
  {
    "Retail Branding": "X-TIGI",
    "Marketing Name": "V18",
    "Device": "X_TIGI_V18",
    "Model": "X_TIGI_V18"
  },
  {
    "Retail Branding": "X-TIGI",
    "Marketing Name": "V18 pro_A",
    "Device": "V18_pro_A",
    "Model": "V18 pro_A"
  },
  {
    "Retail Branding": "X-TIGI",
    "Marketing Name": "V21",
    "Device": "X-TIGI_V21",
    "Model": "X-TIGI_V21"
  },
  {
    "Retail Branding": "X-TIGI",
    "Marketing Name": "V28",
    "Device": "V28",
    "Model": "X-TIGI_V28"
  },
  {
    "Retail Branding": "X-TIGI",
    "Marketing Name": "V28 LTE",
    "Device": "V28_LTE",
    "Model": "X-TIGI_V28 LTE"
  },
  {
    "Retail Branding": "X-TIGI",
    "Marketing Name": "V3+",
    "Device": "X-TIGI_V3_Plus",
    "Model": "X-TIGI_V3+"
  },
  {
    "Retail Branding": "X-TIGI",
    "Marketing Name": "V51",
    "Device": "V51",
    "Model": "V51"
  },
  {
    "Retail Branding": "X-TIGI",
    "Marketing Name": "V8",
    "Device": "V8",
    "Model": "V8"
  },
  {
    "Retail Branding": "X-TIGI",
    "Marketing Name": "X-TIGI P16",
    "Device": "Photo_P16",
    "Model": "X_TIGI_Photo P16"
  },
  {
    "Retail Branding": "X-TIGI",
    "Marketing Name": "X-TIGI V19",
    "Device": "X_TIGI_V19",
    "Model": "X_TIGI_V19"
  },
  {
    "Retail Branding": "X-TIGI",
    "Marketing Name": "X-TIGI_JOY7_MAX",
    "Device": "X-TIGI_JOY7_MAX",
    "Model": "X-TIGI_JOY7_MAX"
  },
  {
    "Retail Branding": "X-TIGI",
    "Marketing Name": "X-TIGI_V11",
    "Device": "X-TIGI_V11",
    "Model": "X-TIGI_V11"
  },
  {
    "Retail Branding": "X-TIGI",
    "Marketing Name": "X-TIGI_V12",
    "Device": "V12",
    "Model": "V12"
  },
  {
    "Retail Branding": "X-TIGI",
    "Marketing Name": "X-TIGI_V13",
    "Device": "X-TIGI_V13",
    "Model": "X-TIGI_V13"
  },
  {
    "Retail Branding": "X-TIGI",
    "Marketing Name": "X-TIGI_V15",
    "Device": "X-TIGI_V15",
    "Model": "X-TIGI_V15"
  },
  {
    "Retail Branding": "X-TIGI",
    "Marketing Name": "X-TIGI_V18 Pro",
    "Device": "X-TIGI_V18_Pro",
    "Model": "X-TIGI_V18 Pro"
  },
  {
    "Retail Branding": "X-TIGI",
    "Marketing Name": "X-TIGI_V33",
    "Device": "X-TIGI_V33",
    "Model": "X-TIGI_V33"
  },
  {
    "Retail Branding": "X-TIGI",
    "Marketing Name": "X-TIGI_V5",
    "Device": "X-TIGI_V5",
    "Model": "X-TIGI_V5"
  },
  {
    "Retail Branding": "X-TIGI",
    "Marketing Name": "X-TIGI_V9",
    "Device": "X-TIGI_V9",
    "Model": "X-TIGI_V9"
  },
  {
    "Retail Branding": "X-TIGI",
    "Marketing Name": "X_TIGI_A1",
    "Device": "X_TIGI_A1",
    "Model": "X_TIGI_A1"
  },
  {
    "Retail Branding": "X-TIGI",
    "Marketing Name": "X_TIGI_A1Plus",
    "Device": "X_TIGI_A1Plus",
    "Model": "X_TIGI_A1Plus"
  },
  {
    "Retail Branding": "X-TIGI",
    "Marketing Name": "X_TIGI_A2",
    "Device": "X_TIGI_A2",
    "Model": "X_TIGI_A2"
  },
  {
    "Retail Branding": "X-TIGI",
    "Marketing Name": "X_TIGI_Photo P20",
    "Device": "X_TIGI_Photo_P20",
    "Model": "X_TIGI_Photo P20"
  },
  {
    "Retail Branding": "X-TIGI",
    "Marketing Name": "X_TIGI_V16",
    "Device": "X_TIGI_V16",
    "Model": "X_TIGI_V16"
  },
  {
    "Retail Branding": "X-TIGI",
    "Marketing Name": "X_TIGI_V16_LTE",
    "Device": "X_TIGI_V16_LTE",
    "Model": "X_TIGI_V16_LTE"
  },
  {
    "Retail Branding": "X-TIGI",
    "Marketing Name": "Y10",
    "Device": "Y10",
    "Model": "Y10"
  },
  {
    "Retail Branding": "X-View",
    "Marketing Name": "AMBER_KIDS",
    "Device": "AMBER_KIDS",
    "Model": "AMBER_KIDS"
  },
  {
    "Retail Branding": "X-View",
    "Marketing Name": "Bears",
    "Device": "Bears",
    "Model": "Bears"
  },
  {
    "Retail Branding": "X-View",
    "Marketing Name": "FTB13",
    "Device": "FTB13",
    "Model": "FTB13"
  },
  {
    "Retail Branding": "X-View",
    "Marketing Name": "Kids10",
    "Device": "Kids10",
    "Model": "Kids10"
  },
  {
    "Retail Branding": "X-View",
    "Marketing Name": "PROTON_AMBER_HD",
    "Device": "Proton_Amber_HD",
    "Model": "Proton_Amber_HD"
  },
  {
    "Retail Branding": "X-View",
    "Marketing Name": "PRO_BOOK",
    "Device": "PRO_BOOK",
    "Model": "PRO_BOOK"
  },
  {
    "Retail Branding": "X-View",
    "Marketing Name": "Probook_E_L-10",
    "Device": "Probook_E_L-10",
    "Model": "Probook_E_L-10"
  },
  {
    "Retail Branding": "X-View",
    "Marketing Name": "Probook_E_M-10",
    "Device": "Probook_E_M-10",
    "Model": "Probook_E_M-10"
  },
  {
    "Retail Branding": "X-View",
    "Marketing Name": "Proton_Helium_Max",
    "Device": "Proton_Helium_Max",
    "Model": "Proton_Helium_Max"
  },
  {
    "Retail Branding": "X-View",
    "Marketing Name": "Proton_Neon",
    "Device": "Proton_Neon",
    "Model": "Proton_Neon"
  },
  {
    "Retail Branding": "X-View",
    "Marketing Name": "Proton_Tungsten_Max",
    "Device": "Proton_Tungsten_Max",
    "Model": "Proton_Tungsten_Max"
  },
  {
    "Retail Branding": "X-View",
    "Marketing Name": "Q10",
    "Device": "Q10",
    "Model": "Q10"
  },
  {
    "Retail Branding": "X-View",
    "Marketing Name": "Q11",
    "Device": "Q11",
    "Model": "Q11"
  },
  {
    "Retail Branding": "X-View",
    "Marketing Name": "Q7",
    "Device": "Q7",
    "Model": "Q7"
  },
  {
    "Retail Branding": "X-View",
    "Marketing Name": "Quantum_Q7s",
    "Device": "Quantum_Q7s",
    "Model": "Quantum_Q7s"
  },
  {
    "Retail Branding": "X-View",
    "Marketing Name": "Quantum_Q7s_Plus",
    "Device": "Quantum_Q7s_Plus",
    "Model": "Quantum_Q7s_Plus"
  },
  {
    "Retail Branding": "X-View",
    "Marketing Name": "Tablet10_X-View",
    "Device": "Tablet10_X_View",
    "Model": "Tablet10_X-View"
  },
  {
    "Retail Branding": "X-View",
    "Marketing Name": "Tablet7_X_View",
    "Device": "Tablet7_X_View",
    "Model": "Tablet7_X_View"
  },
  {
    "Retail Branding": "X-View",
    "Marketing Name": "X-View",
    "Device": "X-ViewTablet7",
    "Model": "X-ViewTablet7"
  },
  {
    "Retail Branding": "X-View",
    "Marketing Name": "X-ViewGamer10",
    "Device": "X-ViewGamer10",
    "Model": "X-ViewGamer10"
  },
  {
    "Retail Branding": "X-View",
    "Marketing Name": "X-ViewTablet10",
    "Device": "X-ViewTablet10",
    "Model": "X-ViewTablet10"
  },
  {
    "Retail Branding": "X-View",
    "Marketing Name": "XRB15",
    "Device": "XRB15",
    "Model": "XRB15"
  },
  {
    "Retail Branding": "X-View",
    "Marketing Name": "X_ViewTablet10",
    "Device": "X_ViewTablet10",
    "Model": "X-ViewTablet"
  },
  {
    "Retail Branding": "X-View",
    "Marketing Name": "Xview_tablet_7",
    "Device": "Xview_tablet_7",
    "Model": "Xview_tablet_7"
  },
  {
    "Retail Branding": "X-View",
    "Marketing Name": "ZPB17",
    "Device": "ZPB17",
    "Model": "ZPB17"
  },
  {
    "Retail Branding": "X-View",
    "Marketing Name": "ZPB18",
    "Device": "ZPB18",
    "Model": "ZPB18"
  },
  {
    "Retail Branding": "X-mobile",
    "Marketing Name": "X-mobile SmartWiFi",
    "Device": "XM-SW1",
    "Model": "XM-SW1"
  },
  {
    "Retail Branding": "X-mobile",
    "Marketing Name": "X4",
    "Device": "X4",
    "Model": "X4"
  },
  {
    "Retail Branding": "X-mobile",
    "Marketing Name": "X63Pro",
    "Device": "X_63_B_ProB",
    "Model": "X63Pro"
  },
  {
    "Retail Branding": "X-mobile",
    "Marketing Name": "XW",
    "Device": "XW",
    "Model": "XW"
  },
  {
    "Retail Branding": "XB(TABLETS INDIA)",
    "Marketing Name": "XB-T11i",
    "Device": "XB-T11i",
    "Model": "XB-T11i"
  },
  {
    "Retail Branding": "XD-DML",
    "Marketing Name": "ITALY",
    "Device": "guandu",
    "Model": "XD 4K Andriod TV"
  },
  {
    "Retail Branding": "XD-DML",
    "Marketing Name": "XD",
    "Device": "martin",
    "Model": "XD 2K Andriod TV"
  },
  {
    "Retail Branding": "XD-Enjoy",
    "Marketing Name": "XDDGM10",
    "Device": "XDDGM10",
    "Model": "XDDGM10"
  },
  {
    "Retail Branding": "XD-Enjoy",
    "Marketing Name": "XDDGM11BS",
    "Device": "XDDGM11BS",
    "Model": "XDDGM11BS"
  },
  {
    "Retail Branding": "XD-Enjoy",
    "Marketing Name": "XDDGM99PM",
    "Device": "XDDGM99PM",
    "Model": "XDDGM99PM"
  },
  {
    "Retail Branding": "XENON",
    "Marketing Name": "PHILIPPINES",
    "Device": "marina",
    "Model": "XENON ANDROID TV"
  },
  {
    "Retail Branding": "XENON",
    "Marketing Name": "Philippines",
    "Device": "sepolia",
    "Model": "XENON TV G4K"
  },
  {
    "Retail Branding": "XENON",
    "Marketing Name": "XENON  TV  G2K",
    "Device": "dongnae",
    "Model": "XENON  TV  G2K"
  },
  {
    "Retail Branding": "XENON",
    "Marketing Name": "XENON ANDROID TV",
    "Device": "nagata",
    "Model": "XENON ANDROID TV"
  },
  {
    "Retail Branding": "XForge",
    "Marketing Name": "XForge 01",
    "Device": "XForge01",
    "Model": "XForge 01"
  },
  {
    "Retail Branding": "XGIMI",
    "Marketing Name": "AURA 2 (New)",
    "Device": "kasol",
    "Model": "WM18P"
  },
  {
    "Retail Branding": "XGIMI",
    "Marketing Name": "Elfin Flip Plus",
    "Device": "altai",
    "Model": "WK03C"
  },
  {
    "Retail Branding": "XGIMI",
    "Marketing Name": "HORIZON 20",
    "Device": "kasol",
    "Model": "XR13A"
  },
  {
    "Retail Branding": "XGIMI",
    "Marketing Name": "HORIZON 20 Max",
    "Device": "kasol",
    "Model": "XR16A"
  },
  {
    "Retail Branding": "XGIMI",
    "Marketing Name": "HORIZON 20 Pro",
    "Device": "kasol",
    "Model": "XR14A"
  },
  {
    "Retail Branding": "XGIMI",
    "Marketing Name": "Halo",
    "Device": "xgimiapollo",
    "Model": "Halo"
  },
  {
    "Retail Branding": "XGIMI",
    "Marketing Name": "Halo+",
    "Device": "altai",
    "Model": "H0030"
  },
  {
    "Retail Branding": "XGIMI",
    "Marketing Name": "MoGo",
    "Device": "xgimiapollo",
    "Model": "MoGo"
  },
  {
    "Retail Branding": "XGIMI",
    "Marketing Name": "MoGo 2 Plus",
    "Device": "altai",
    "Model": "H0031"
  },
  {
    "Retail Branding": "XGIMI",
    "Marketing Name": "MoGo 2 Pro (New)",
    "Device": "altai",
    "Model": "XK10T"
  },
  {
    "Retail Branding": "XGIMI",
    "Marketing Name": "MoGo 2 Pro（NEW）with battery",
    "Device": "altai",
    "Model": "H0053"
  },
  {
    "Retail Branding": "XGIMI",
    "Marketing Name": "MoGo 3 Pro",
    "Device": "altai",
    "Model": "G0035"
  },
  {
    "Retail Branding": "XGIMI",
    "Marketing Name": "MoGo 4",
    "Device": "altai",
    "Model": "WK08K"
  },
  {
    "Retail Branding": "XGIMI",
    "Marketing Name": "MoGo 4 Laser",
    "Device": "altai",
    "Model": "H0030"
  },
  {
    "Retail Branding": "XGIMI",
    "Marketing Name": "MoGo 4 Laser",
    "Device": "altai",
    "Model": "WK03K"
  },
  {
    "Retail Branding": "XGIMI",
    "Marketing Name": "MoGo Pro",
    "Device": "xgimiapollo",
    "Model": "MoGo Pro"
  },
  {
    "Retail Branding": "XGIMI",
    "Marketing Name": "P_FHD_2020",
    "Device": "xgimiapollo",
    "Model": "Mogo Pro Plus"
  },
  {
    "Retail Branding": "XGIMI",
    "Marketing Name": "P_FHD_2020",
    "Device": "xgimiapollo",
    "Model": "P_FHD_2020"
  },
  {
    "Retail Branding": "XGIMI",
    "Marketing Name": "XGIMI Vibe One",
    "Device": "altai",
    "Model": "WM03M"
  },
  {
    "Retail Branding": "XGIMI",
    "Marketing Name": "XGIMI Vibe One (Battery Powered)",
    "Device": "altai",
    "Model": "WM03H"
  },
  {
    "Retail Branding": "XGIMI",
    "Marketing Name": "XK03H",
    "Device": "xgimigalileo",
    "Model": "XK03H"
  },
  {
    "Retail Branding": "XHSM",
    "Marketing Name": "A60_EEA",
    "Device": "A60",
    "Model": "A60"
  },
  {
    "Retail Branding": "XHSM",
    "Marketing Name": "XHA537_EEA",
    "Device": "XHA537",
    "Model": "XHA537"
  },
  {
    "Retail Branding": "XHSM",
    "Marketing Name": "XHSM",
    "Device": "XHSM",
    "Model": "XHSM"
  },
  {
    "Retail Branding": "XING_XING",
    "Marketing Name": "Xingxing10",
    "Device": "XING_XING",
    "Model": "Xingxing10"
  },
  {
    "Retail Branding": "XION",
    "Marketing Name": "XI_CEU55",
    "Device": "XI_CEU55",
    "Model": "XI_CEU55"
  },
  {
    "Retail Branding": "XL Axiata",
    "Marketing Name": "AX512",
    "Device": "DV8252",
    "Model": "AX512"
  },
  {
    "Retail Branding": "XL Axiata",
    "Marketing Name": "SDN200",
    "Device": "lte_siden",
    "Model": "SDN200"
  },
  {
    "Retail Branding": "XL Axiata",
    "Marketing Name": "Siden - XL Axiata",
    "Device": "lte_siden",
    "Model": "SDN200"
  },
  {
    "Retail Branding": "XL Axiata",
    "Marketing Name": "XL Home Pow",
    "Device": "STI6xxx",
    "Model": "STI6030"
  },
  {
    "Retail Branding": "XMART",
    "Marketing Name": "X10S",
    "Device": "X10S",
    "Model": "X10S"
  },
  {
    "Retail Branding": "XORO",
    "Marketing Name": "MegaPAD_1333_Pro_2",
    "Device": "MegaPAD_1333_Pro_2",
    "Model": "MegaPAD 1333 Pro 2"
  },
  {
    "Retail Branding": "XORO",
    "Marketing Name": "MegaPAD_Medline_1854",
    "Device": "MP1854ML",
    "Model": "MegaPAD Medline 1854"
  },
  {
    "Retail Branding": "XORO",
    "Marketing Name": "Megapad_1333",
    "Device": "XORO",
    "Model": "Megapad_1333"
  },
  {
    "Retail Branding": "XORO",
    "Marketing Name": "Megapad_1333_Pro",
    "Device": "Megapad_1333_Pro",
    "Model": "Megapad_1333_Pro"
  },
  {
    "Retail Branding": "XPLORE",
    "Marketing Name": "XPLORE X7U",
    "Device": "X7U",
    "Model": "XPLORE X7U"
  },
  {
    "Retail Branding": "XPPen",
    "Marketing Name": "XPPen_Magic_Drawing_Pad",
    "Device": "Titan_XPPen",
    "Model": "MagicDrawingPad"
  },
  {
    "Retail Branding": "XPPen",
    "Marketing Name": "XPPen_Magic_Drawing_Pad_RU",
    "Device": "Titan_XPPen",
    "Model": "MagicDrawingPad"
  },
  {
    "Retail Branding": "XREAL",
    "Marketing Name": "Beam Pro",
    "Device": "X4000",
    "Model": "X4000"
  },
  {
    "Retail Branding": "XTRATECH_IGUANAPAD",
    "Marketing Name": "X8MT16",
    "Device": "X8MT16",
    "Model": "X8MT16"
  },
  {
    "Retail Branding": "X_View",
    "Marketing Name": "Protab10",
    "Device": "Protab10",
    "Model": "Protab10"
  },
  {
    "Retail Branding": "X_View",
    "Marketing Name": "X_View_Q7",
    "Device": "X_View_Q7",
    "Model": "X_View_Q7"
  },
  {
    "Retail Branding": "Xcell",
    "Marketing Name": "Enia",
    "Device": "Xcell_Enia",
    "Model": "Enia"
  },
  {
    "Retail Branding": "Xcell",
    "Marketing Name": "View",
    "Device": "View",
    "Model": "View"
  },
  {
    "Retail Branding": "Xcell",
    "Marketing Name": "Zoom",
    "Device": "Xcell_Zoom",
    "Model": "Zoom"
  },
  {
    "Retail Branding": "Xelex",
    "Marketing Name": "Gama_Tab_X8",
    "Device": "Gama_Tab_X8",
    "Model": "Gama_Tab_X8"
  },
  {
    "Retail Branding": "Xgody",
    "Marketing Name": "Mate_70_EEA",
    "Device": "Mate_70",
    "Model": "Mate 70"
  },
  {
    "Retail Branding": "Xgody",
    "Marketing Name": "N02",
    "Device": "N02",
    "Model": "N02"
  },
  {
    "Retail Branding": "Xgody",
    "Marketing Name": "N02_A",
    "Device": "N02_A",
    "Model": "N02_A"
  },
  {
    "Retail Branding": "Xgody",
    "Marketing Name": "N02_Pro",
    "Device": "N02_Pro",
    "Model": "N02_Pro"
  },
  {
    "Retail Branding": "Xgody",
    "Marketing Name": "N02_ProA",
    "Device": "N02_ProA",
    "Model": "N02_ProA"
  },
  {
    "Retail Branding": "Xgody",
    "Marketing Name": "N05_PRO",
    "Device": "N05_PRO",
    "Model": "N05 PRO"
  },
  {
    "Retail Branding": "Xgody",
    "Marketing Name": "P60Pro",
    "Device": "P60Pro",
    "Model": "P60Pro"
  },
  {
    "Retail Branding": "Xgody",
    "Marketing Name": "P60pro_15",
    "Device": "P60pro_15",
    "Model": "P60pro_15"
  },
  {
    "Retail Branding": "Xgody",
    "Marketing Name": "Q16",
    "Device": "Q16",
    "Model": "Q16"
  },
  {
    "Retail Branding": "Xgody",
    "Marketing Name": "Q17",
    "Device": "Q17",
    "Model": "Q17"
  },
  {
    "Retail Branding": "Xgody",
    "Marketing Name": "R15_EEA",
    "Device": "R15_EEA",
    "Model": "R15_EEA"
  },
  {
    "Retail Branding": "Xgody",
    "Marketing Name": "T702",
    "Device": "T702",
    "Model": "T702"
  },
  {
    "Retail Branding": "Xgody",
    "Marketing Name": "T702A",
    "Device": "T702A",
    "Model": "T702A"
  },
  {
    "Retail Branding": "Xgody",
    "Marketing Name": "T702E_EEA",
    "Device": "T702E_EEA",
    "Model": "T702E_EEA"
  },
  {
    "Retail Branding": "Xgody",
    "Marketing Name": "T702Pro",
    "Device": "T702Pro",
    "Model": "T702Pro"
  },
  {
    "Retail Branding": "Xgody",
    "Marketing Name": "T702Pro",
    "Device": "T702Pro_A",
    "Model": "T702Pro"
  },
  {
    "Retail Branding": "Xgody",
    "Marketing Name": "T702Pro-A",
    "Device": "T702Pro-A",
    "Model": "T702Pro-A"
  },
  {
    "Retail Branding": "Xgody",
    "Marketing Name": "T702Pro-EEA",
    "Device": "T702Pro-EEA",
    "Model": "T702Pro-EEA"
  },
  {
    "Retail Branding": "Xgody",
    "Marketing Name": "T702Pro_S",
    "Device": "T702Pro_S",
    "Model": "T702Pro_S"
  },
  {
    "Retail Branding": "Xgody",
    "Marketing Name": "T702_EEA",
    "Device": "T702_EEA",
    "Model": "T702_EEA"
  },
  {
    "Retail Branding": "Xgody",
    "Marketing Name": "T901Pro-A",
    "Device": "T901Pro-A",
    "Model": "T901Pro-A"
  },
  {
    "Retail Branding": "Xgody",
    "Marketing Name": "T901Pro-EEA",
    "Device": "T901Pro-EEA",
    "Model": "T901Pro-E"
  },
  {
    "Retail Branding": "Xgody",
    "Marketing Name": "TAB10",
    "Device": "TAB10",
    "Model": "TAB10"
  },
  {
    "Retail Branding": "Xgody",
    "Marketing Name": "TAB_M10",
    "Device": "TAB_M10",
    "Model": "TAB_M10"
  },
  {
    "Retail Branding": "Xgody",
    "Marketing Name": "TAB_M10_EEA",
    "Device": "TAB_M10_EEA",
    "Model": "TAB_M10_EEA"
  },
  {
    "Retail Branding": "Xgody",
    "Marketing Name": "X24_EU",
    "Device": "X24_EU",
    "Model": "X24_EU"
  },
  {
    "Retail Branding": "Xgody",
    "Marketing Name": "X32_EEA",
    "Device": "X32",
    "Model": "X32"
  },
  {
    "Retail Branding": "Xgody",
    "Marketing Name": "X36_EEA",
    "Device": "X36",
    "Model": "X36"
  },
  {
    "Retail Branding": "Xgody",
    "Marketing Name": "XGT",
    "Device": "XGT",
    "Model": "XGT"
  },
  {
    "Retail Branding": "Xgody",
    "Marketing Name": "XGT-T901-A",
    "Device": "XGT-T901-A",
    "Model": "XGT-T901-A"
  },
  {
    "Retail Branding": "Xgody",
    "Marketing Name": "XGT-T901-E",
    "Device": "XGT-T901-E",
    "Model": "XGT-T901-E"
  },
  {
    "Retail Branding": "Xgody",
    "Marketing Name": "XGTB-A",
    "Device": "XGTB-A",
    "Model": "XGTB-A"
  },
  {
    "Retail Branding": "Xgody",
    "Marketing Name": "XGTB-E",
    "Device": "XGTB-E",
    "Model": "XGTB-E"
  },
  {
    "Retail Branding": "Xgody",
    "Marketing Name": "XGT_EEA",
    "Device": "XGT_EEA",
    "Model": "XGT_EEA"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "China",
    "Device": "braveheart",
    "Model": "MiTV"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Formovie Laser TV 4K Cinema",
    "Device": "angleeUHD",
    "Model": "MiProjL1"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "HM 1SC",
    "Device": "armani",
    "Model": "HM 1AC"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "HM 1SC",
    "Device": "armani",
    "Model": "HM 1S"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "HM 1SC",
    "Device": "armani",
    "Model": "HM 1SC"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "HM 1SC",
    "Device": "armani",
    "Model": "HM 1SW"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "HM 1SLTETD",
    "Device": "HM2014501",
    "Model": 2014501
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "HM 1STD",
    "Device": "HM2014011",
    "Model": 2014011
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "HM 2A",
    "Device": "lte26007",
    "Model": 2014502
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "HM 2A",
    "Device": "lte26007",
    "Model": "HM 2A"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "HM 2LTE-BR",
    "Device": "HM2014819",
    "Model": 2014819
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "HM 2LTE-CMCC",
    "Device": "HM2014813",
    "Model": 2014813
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "HM 2LTE-CT",
    "Device": "HM2014812",
    "Model": 2014812
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "HM 2LTE-CU",
    "Device": "HM2014811",
    "Model": 2014811
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "HM 2LTE-IN",
    "Device": "HM2014818",
    "Model": 2014818
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "HM 2LTE-SA",
    "Device": "HM2014817",
    "Model": 2014817
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "HM NOTE 1LTETD",
    "Device": "dior",
    "Model": "HM NOTE 1LTE"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "HM NOTE 1LTETD",
    "Device": "dior",
    "Model": "HM NOTE 1LTETD"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "HM NOTE 1LTETD",
    "Device": "dior",
    "Model": "HM NOTE 1LTEW"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "HM NOTE 1S CT",
    "Device": "gucci",
    "Model": "HM NOTE 1S"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "HM NOTE 1S CT",
    "Device": "gucci",
    "Model": "gucci"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "HM NOTE 1TD",
    "Device": "lcsh92_wet_tdd",
    "Model": "HM NOTE 1TD"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "HM NOTE 1W",
    "Device": "lcsh92_wet_jb9",
    "Model": "HM NOTE 1W"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "HM Note 2",
    "Device": "hermes",
    "Model": "Redmi Note 2"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Hong Mi",
    "Device": "HM2013022",
    "Model": 2013022
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "K30 PRO",
    "Device": "lmiinpro",
    "Model": "Redmi K30 Pro 5G Zoom Edition"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "K30 pro",
    "Device": "lmiin",
    "Model": "Redmi K30 Pro 5G"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Leitzphone powered by Xiaomi",
    "Device": "nezha",
    "Model": "2512BPNDAG"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "MI  8  Explorer  Edition",
    "Device": "ursa",
    "Model": "MI 8 Explorer Edition"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "MI  8  Pro",
    "Device": "equuleus",
    "Model": "MI 8 Pro"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "MI  8  Pro",
    "Device": "equuleus",
    "Model": "MI 8 UD"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "MI  MAX  3",
    "Device": "nitrogen",
    "Model": "MI MAX 3"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "MI  PLAY",
    "Device": "lotus",
    "Model": "MI PLAY"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "MI  PLAY",
    "Device": "lotus",
    "Model": "lotus"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "MI 10",
    "Device": "umi",
    "Model": "Mi 10"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "MI 2",
    "Device": "aries",
    "Model": "MI 2"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "MI 2",
    "Device": "aries",
    "Model": "MI 2S"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "MI 2A",
    "Device": "taurus",
    "Model": "MI 2A"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "MI 3W",
    "Device": "cancro",
    "Model": "MI 3W"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "MI 4LTE",
    "Device": "cancro",
    "Model": "MI 4C"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "MI 4LTE",
    "Device": "cancro",
    "Model": "MI 4LTE"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "MI 4LTE",
    "Device": "cancro",
    "Model": "MI 4W"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "MI 4LTE-CT",
    "Device": "cancro",
    "Model": "MI 4LTE"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "MI 4s",
    "Device": "aqua",
    "Model": "MI 4S"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "MI 5C",
    "Device": "meri",
    "Model": "MI 5C"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "MI 5C",
    "Device": "meri",
    "Model": "Meri"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "MI 5X",
    "Device": "tiffany",
    "Model": "MI 5X"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "MI 5s Plus",
    "Device": "natrium",
    "Model": "MI 5s Plus"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "MI 6X",
    "Device": "wayne",
    "Model": "MI 6X"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "MI 8",
    "Device": "dipper",
    "Model": "MI 8"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "MI 8 Lite",
    "Device": "platina",
    "Model": "MI 8 Lite"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "MI 8 Lite",
    "Device": "platina",
    "Model": "Platina"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "MI 8 SE",
    "Device": "sirius",
    "Model": "MI 8 SE"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "MI 8 SE",
    "Device": "sirius",
    "Model": "sirius"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "MI 8 UD",
    "Device": "equuleus",
    "Model": "MI 8 Pro"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "MI 8 UD",
    "Device": "equuleus",
    "Model": "MI 8 UD"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "MI 8 UD",
    "Device": "equuleus",
    "Model": "equuleus"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "MI 9",
    "Device": "cepheus",
    "Model": "MI 9"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "MI 9 SE",
    "Device": "grus",
    "Model": "MI 9 SE"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "MI 9 SE",
    "Device": "grus",
    "Model": "Mi 9 SE"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "MI CC 9",
    "Device": "pyxis",
    "Model": "MI CC 9"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "MI CC 9",
    "Device": "pyxis",
    "Model": "Mi 9 Lite"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "MI CC 9",
    "Device": "pyxis",
    "Model": "Pyxis"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "MI CC 9e",
    "Device": "laurus",
    "Model": "MI CC 9e"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "MI CC 9e",
    "Device": "laurus",
    "Model": "laurus"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "MI CC9 Pro",
    "Device": "tucana",
    "Model": "MI CC9 Pro"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "MI CC9 Pro",
    "Device": "tucana",
    "Model": "Mi Note 10"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "MI MAX",
    "Device": "helium",
    "Model": "MI MAX"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "MI MAX",
    "Device": "hydrogen",
    "Model": "MI MAX"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "MI MAX 2",
    "Device": "oxygen",
    "Model": "MI MAX 2"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "MI MAX 3",
    "Device": "nitrogen",
    "Model": "MI MAX 3"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "MI MIX 2S",
    "Device": "polaris",
    "Model": "Mi MIX 2S"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "MI NOTE LTE",
    "Device": "virgo",
    "Model": "MI NOTE LTE"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "MI NOTE Pro",
    "Device": "leo",
    "Model": "MI NOTE Pro"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "MI Note 3",
    "Device": "jason",
    "Model": "Mi Note 3"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "MI PAD",
    "Device": "mocha",
    "Model": "MI PAD"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "MI PAD 3",
    "Device": "cappu",
    "Model": "MI PAD 3"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "MI PAD 4",
    "Device": "clover",
    "Model": "MI PAD 4"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "MI PLAY",
    "Device": "lotus",
    "Model": "MI PLAY"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "MI6",
    "Device": "sagit",
    "Model": "MI 6"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "MIBOXPRO",
    "Device": "kungfupanda",
    "Model": "MiBOX_PRO"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "MIPAD2",
    "Device": "latte",
    "Model": "MI PAD 2"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "MITV3S",
    "Device": "missionimpossible",
    "Model": "MiTV3S"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "MITV3S-55/60",
    "Device": "pulpfiction",
    "Model": "MiTV3S"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "MITV3S-55/60",
    "Device": "pulpfiction",
    "Model": "MiTV4"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "MIX",
    "Device": "lithium",
    "Model": "MIX"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "MIX",
    "Device": "lithium",
    "Model": "lithium"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "MIX 2",
    "Device": "chiron",
    "Model": "MIX 2"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "MIX 2",
    "Device": "chiron",
    "Model": "Mi MIX 2"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "MIX 2S",
    "Device": "polaris",
    "Model": "MIX 2S"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "MIX 2S",
    "Device": "polaris",
    "Model": "Mi MIX 2S"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "MIX 3",
    "Device": "perseus",
    "Model": "MIX 3"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "MIX 3",
    "Device": "perseus",
    "Model": "Mi MIX 3"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "MIX 4",
    "Device": "odin",
    "Model": "2106118C"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Mi 10",
    "Device": "umi",
    "Model": "Mi 10"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Mi 10",
    "Device": "umi",
    "Model": "Umi"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Mi 10 Lite 5G",
    "Device": "monet",
    "Model": "XIG01"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Mi 10 Lite zoom",
    "Device": "vangogh",
    "Model": "M2002J9E"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Mi 10 Pro",
    "Device": "cmi",
    "Model": "Cmi"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Mi 10 Pro",
    "Device": "cmi",
    "Model": "Mi 10 Pro"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Mi 10 Ultra",
    "Device": "cas",
    "Model": "M2007J1SC"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Mi 10 lite 5G",
    "Device": "monet",
    "Model": "M2002J9G"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Mi 10 lite 5G",
    "Device": "monet",
    "Model": "M2002J9S"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Mi 10S",
    "Device": "thyme",
    "Model": "M2102J2SC"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Mi 10S",
    "Device": "thyme",
    "Model": "Thyme"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Mi 10T",
    "Device": "apollo",
    "Model": "M2007J3SP"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Mi 10T",
    "Device": "apollo",
    "Model": "M2007J3SY"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Mi 10T Lite",
    "Device": "gauguin",
    "Model": "M2007J17G"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Mi 10T Pro",
    "Device": "apollo",
    "Model": "M2007J3SG"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Mi 10T pro",
    "Device": "apollo",
    "Model": "M2007J3SI"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Mi 10i",
    "Device": "gauguininpro",
    "Model": "M2007J17I"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Mi 11",
    "Device": "venus",
    "Model": "M2011K2C"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Mi 11",
    "Device": "venus",
    "Model": "M2011K2G"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Mi 11 LE",
    "Device": "lisa",
    "Model": "2107119DC"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Mi 11 Lite",
    "Device": "courbet",
    "Model": "M2101K9AG"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Mi 11 Lite",
    "Device": "courbetin",
    "Model": "M2101K9AI"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Mi 11 Lite 5G",
    "Device": "renoir",
    "Model": "M2101K9C"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Mi 11 Lite 5G",
    "Device": "renoir",
    "Model": "M2101K9G"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Mi 11 Pro",
    "Device": "mars",
    "Model": "M2102K1AC"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Mi 11 Ultra",
    "Device": "star",
    "Model": "M2102K1C"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Mi 11 Ultra",
    "Device": "star",
    "Model": "M2102K1G"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Mi 11X Pro",
    "Device": "haydnin",
    "Model": "M2012K11I"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Mi 11i",
    "Device": "haydn",
    "Model": "M2012K11G"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Mi 3",
    "Device": "pisces",
    "Model": "MI 3"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Mi 4c",
    "Device": "libra",
    "Model": "Mi-4c"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Mi 4i",
    "Device": "ferrari",
    "Model": "Mi 4i"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Mi 5",
    "Device": "gemini",
    "Model": "MI 5"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Mi 5s",
    "Device": "capricorn",
    "Model": "MI 5s"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Mi 9 Lite",
    "Device": "pyxis",
    "Model": "Mi 9 Lite"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Mi 9 SE",
    "Device": "grus",
    "Model": "MI 9 SE"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Mi 9 SE",
    "Device": "grus",
    "Model": "Mi 9 SE"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Mi 9T",
    "Device": "davinci",
    "Model": "Mi 9T"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Mi 9T Pro",
    "Device": "raphael",
    "Model": "Mi 9T Pro"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Mi A1",
    "Device": "tissot_sprout",
    "Model": "MI A1"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Mi A1",
    "Device": "tissot_sprout",
    "Model": "Mi A1"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Mi A2",
    "Device": "jasmine_sprout",
    "Model": "Mi A2"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Mi A2 Lite",
    "Device": "daisy_sprout",
    "Model": "Mi A2 Lite"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Mi A3",
    "Device": "laurel_sprout",
    "Model": "Mi A3"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Mi Box",
    "Device": "once",
    "Model": "MIBOX3"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Mi Laser Projector 150",
    "Device": "anglee",
    "Model": "MiProjA1"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Mi Laser Projector 4K",
    "Device": "angleeUHD",
    "Model": "MiProjL1"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Mi MIX 3 5G",
    "Device": "andromeda",
    "Model": "Mi MIX 3 5G"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Mi Note",
    "Device": "virgo",
    "Model": "MI NOTE LTE"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Mi Note 10",
    "Device": "tucana",
    "Model": "Mi Note 10"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Mi Note 10 Lite",
    "Device": "toco",
    "Model": "Mi Note 10 Lite"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Mi Note 10 Lite",
    "Device": "toco",
    "Model": "toco"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Mi Note2",
    "Device": "scorpio",
    "Model": "Mi Note 2"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Mi TV Stick",
    "Device": "aquaman",
    "Model": "MiTV-AESP0"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Mi smart projector",
    "Device": "eva",
    "Model": "MiProjM05"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Mi9 Pro 5G",
    "Device": "crux",
    "Model": "Mi9 Pro 5G"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "MiBOX1S",
    "Device": "casablanca",
    "Model": "MiBOX1S"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "MiBOX2",
    "Device": "dredd",
    "Model": "MiBOX2"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "MiBOX3S",
    "Device": "queenchristina",
    "Model": "MiBOX3S"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "MiBOX_mini",
    "Device": "forrestgump",
    "Model": "MiBOX_mini"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "MiBox S",
    "Device": "oneday",
    "Model": "MIBOX4"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "MiTV",
    "Device": "amelie",
    "Model": "MiTV-MSSP0"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "MiTV",
    "Device": "croods",
    "Model": "MiTV-MOOQ0"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "MiTV",
    "Device": "croods",
    "Model": "MiTV-MOOQ2"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "MiTV",
    "Device": "dangal",
    "Model": "MiTV-AXSO0"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "MiTV",
    "Device": "dangalFHD",
    "Model": "MiTV-AXSO1"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "MiTV",
    "Device": "dangalUHD",
    "Model": "MiTV-AXSO2"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "MiTV",
    "Device": "furiosa",
    "Model": "MiTV-AXFU1"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "MiTV",
    "Device": "hermano",
    "Model": "MiTV-MOSR0"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "MiTV",
    "Device": "hermano",
    "Model": "MiTV-MOSR1"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "MiTV",
    "Device": "irobot",
    "Model": "MiTV-MOOR1"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "MiTV",
    "Device": "irobot",
    "Model": "MiTV-MOSR2"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "MiTV",
    "Device": "irobot",
    "Model": "MiTV-MOSR3"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "MiTV",
    "Device": "irobot",
    "Model": "MiTV-MOSR4"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "MiTV",
    "Device": "ladybird",
    "Model": "MiTV-MOEU0"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "MiTV",
    "Device": "lalaland",
    "Model": "MiTV-MOEU1"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "MiTV",
    "Device": "machuca",
    "Model": "MiTV-MSSP3"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "MiTV",
    "Device": "magnolia",
    "Model": "MiTV4I"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "MiTV",
    "Device": "martian",
    "Model": "MiTV-MSOR0"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "MiTV",
    "Device": "nino",
    "Model": "MiTV-MSSP1"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "MiTV",
    "Device": "rango",
    "Model": "MiTV-AXFR1"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "MiTV",
    "Device": "river",
    "Model": "MiTV-MZTU0"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "MiTV",
    "Device": "stepup",
    "Model": "MiTV-MZTU1"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "MiTV",
    "Device": "tarzan",
    "Model": "MiTV-MOOQ1"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "MiTV",
    "Device": "venom",
    "Model": "MiTV-MOOR0"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "MiTV",
    "Device": "venom",
    "Model": "MiTV-MOOR2"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "MiTV",
    "Device": "venom",
    "Model": "MiTV-MOOR3"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "MiTV",
    "Device": "venom",
    "Model": "MiTV-MOOR4"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "MiTV",
    "Device": "venom",
    "Model": "MiTV-MOOR6"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "MiTV",
    "Device": "volver",
    "Model": "MiTV-MSSP2"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "MiTV",
    "Device": "watchmen",
    "Model": "MiTV-AXFR2"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "MiTV2",
    "Device": "entrapment",
    "Model": "MiTV2"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "MiTV4C",
    "Device": "matrix",
    "Model": "MiTV4C"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "POCO F1",
    "Device": "beryllium",
    "Model": "POCOPHONE F1"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "POCO M5s",
    "Device": "rosemary",
    "Model": "2207117BPG"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Redmi",
    "Device": "HM2013023",
    "Model": 2013023
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Redmi  Go",
    "Device": "tiare",
    "Model": "Redmi Go"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Redmi  Note  6  Pro",
    "Device": "tulip",
    "Model": "Redmi Note 6 Pro"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Redmi  Note  7 Pro",
    "Device": "violet",
    "Model": "Redmi Note 7 Pro"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Redmi  S2",
    "Device": "ysl",
    "Model": "Redmi S2"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Redmi 3",
    "Device": "ido",
    "Model": "Redmi 3"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Redmi 3",
    "Device": "ido",
    "Model": "ido"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Redmi 3S",
    "Device": "land",
    "Model": "Redmi 3S"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Redmi 4",
    "Device": "prada",
    "Model": "Redmi 4"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Redmi 4 Pro",
    "Device": "markw",
    "Model": "Redmi 4"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Redmi 4A",
    "Device": "rolex",
    "Model": "Redmi 4A"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Redmi 4X",
    "Device": "santoni",
    "Model": "Redmi 4X"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Redmi 4X",
    "Device": "santoni",
    "Model": "santoni"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Redmi 5",
    "Device": "rosy",
    "Model": "Redmi 5"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Redmi 5 Plus",
    "Device": "vince",
    "Model": "Redmi 5 Plus"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Redmi 5 Plus",
    "Device": "vince",
    "Model": "Redmi Note 5"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Redmi 5A",
    "Device": "riva",
    "Model": "Redmi 5A"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Redmi 6",
    "Device": "cereus",
    "Model": "Redmi 6"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Redmi 6 Pro",
    "Device": "sakura_india",
    "Model": "Redmi 6 Pro"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Redmi 6A",
    "Device": "cactus",
    "Model": "Redmi 6A"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Redmi 6Pro",
    "Device": "sakura",
    "Model": "Redmi 6 Pro"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Redmi 7",
    "Device": "onc",
    "Model": "ONC"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Redmi 7",
    "Device": "onc",
    "Model": "Redmi 7"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Redmi 7A",
    "Device": "pine",
    "Model": "Redmi 7A"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Redmi 8",
    "Device": "olive",
    "Model": "Redmi 8"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Redmi Go",
    "Device": "tiare",
    "Model": "Redmi Go"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Redmi K30 Pro Zoom Edition",
    "Device": "lmipro",
    "Model": "Redmi K30 Pro Zoom Edition"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Redmi Note 3",
    "Device": "hennessy",
    "Model": "Redmi Note 3"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Redmi Note 3",
    "Device": "kate",
    "Model": "Redmi Note 3"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Redmi Note 3",
    "Device": "kenzo",
    "Model": "Redmi Note 3"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Redmi Note 4",
    "Device": "mido",
    "Model": "Redmi Note 4"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Redmi Note 4",
    "Device": "mido",
    "Model": "Redmi Note 4X"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Redmi Note 4",
    "Device": "nikel",
    "Model": "Redmi Note 4"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Redmi Note 5",
    "Device": "whyred",
    "Model": "Redmi Note 5"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Redmi Note 5 Pro",
    "Device": "whyred",
    "Model": "Redmi Note 5"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Redmi Note 5 Pro",
    "Device": "whyred",
    "Model": "Redmi Note 5 Pro"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Redmi Note 5A",
    "Device": "ugg",
    "Model": "Redmi Note 5A"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Redmi Note 5A",
    "Device": "ugg",
    "Model": "Redmi Y1"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Redmi Note 5A",
    "Device": "ugglite",
    "Model": "Redmi Note 5A"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Redmi Note 8",
    "Device": "ginkgo",
    "Model": "Redmi Note 8"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Redmi Pro",
    "Device": "omega",
    "Model": "Redmi Pro"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Redmi S2",
    "Device": "ysl",
    "Model": "Redmi S2"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "TELEBEE",
    "Device": "once",
    "Model": "MIBOX3"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Xiaomi 11 Lite 5G NE",
    "Device": "lisa",
    "Model": "2109119DG"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Xiaomi 11 Lite NE",
    "Device": "lisa",
    "Model": "2109119DI"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Xiaomi 11T",
    "Device": "amber",
    "Model": "21081111RG"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Xiaomi 11T Pro",
    "Device": "vili",
    "Model": "2107113SG"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Xiaomi 11T Pro",
    "Device": "vili",
    "Model": "2107113SI"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Xiaomi 11T Pro",
    "Device": "vili",
    "Model": "2107113SR"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Xiaomi 11i",
    "Device": "pissarroin",
    "Model": "21091116I"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Xiaomi 11i HyperCharge",
    "Device": "pissarroinpro",
    "Model": "21091116UI"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Xiaomi 12",
    "Device": "cupid",
    "Model": "2201123C"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Xiaomi 12",
    "Device": "cupid",
    "Model": "2201123G"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Xiaomi 12 Lite",
    "Device": "taoyao",
    "Model": "2203129G"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Xiaomi 12 Pro",
    "Device": "zeus",
    "Model": "2201122C"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Xiaomi 12 Pro",
    "Device": "zeus",
    "Model": "2201122G"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Xiaomi 12 Pro Dimensity",
    "Device": "daumier",
    "Model": "2207122MC"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Xiaomi 12S",
    "Device": "mayfly",
    "Model": "2206123SC"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Xiaomi 12S Pro",
    "Device": "unicorn",
    "Model": "2206122SC"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Xiaomi 12S Ultra",
    "Device": "thor",
    "Model": "2203121C"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Xiaomi 12T",
    "Device": "plato",
    "Model": "22071212AG"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Xiaomi 12T Pro",
    "Device": "diting",
    "Model": "22081212C"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Xiaomi 12T Pro",
    "Device": "diting",
    "Model": "22081212R"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Xiaomi 12T Pro",
    "Device": "diting",
    "Model": "22081212UG"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Xiaomi 12T Pro",
    "Device": "diting",
    "Model": "22200414R"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Xiaomi 12T Pro",
    "Device": "diting",
    "Model": "A201XM"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Xiaomi 12X",
    "Device": "psyche",
    "Model": "2112123AC"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Xiaomi 13",
    "Device": "fuxi",
    "Model": "2211133C"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Xiaomi 13",
    "Device": "fuxi",
    "Model": "2211133G"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Xiaomi 13 Lite",
    "Device": "ziyi",
    "Model": "2210129SG"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Xiaomi 13 Pro",
    "Device": "nuwa",
    "Model": "2210132G"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Xiaomi 13 Ultra",
    "Device": "ishtar",
    "Model": "2304FPN6DC"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Xiaomi 13 Ultra",
    "Device": "ishtar",
    "Model": "2304FPN6DG"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Xiaomi 13 pro",
    "Device": "nuwa",
    "Model": "2210132C"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Xiaomi 13T",
    "Device": "XIG04",
    "Model": "XIG04"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Xiaomi 13T",
    "Device": "aristotle",
    "Model": "2306EPN60G"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Xiaomi 13T Pro",
    "Device": "corot",
    "Model": "23078PND5G"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Xiaomi 13T Pro",
    "Device": "corot",
    "Model": "23088PND5R"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Xiaomi 13T Pro",
    "Device": "corot",
    "Model": "A301XM"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Xiaomi 14",
    "Device": "houji",
    "Model": "23127PN0CC"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Xiaomi 14",
    "Device": "houji",
    "Model": "23127PN0CG"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Xiaomi 14 Civi",
    "Device": "chenfeng",
    "Model": "24053PY09I"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Xiaomi 14 Pro",
    "Device": "shennong",
    "Model": "23116PN5BC"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Xiaomi 14 Pro",
    "Device": "shennong",
    "Model": "2311BPN23C"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Xiaomi 14 Ultra",
    "Device": "aurora",
    "Model": "24030PN60G"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Xiaomi 14 Ultra",
    "Device": "aurora",
    "Model": "24031PN0DC"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Xiaomi 14 Ultra",
    "Device": "aurora",
    "Model": "Xiaomi for arm64"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Xiaomi 14T",
    "Device": "XIG07",
    "Model": "XIG07"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Xiaomi 14T",
    "Device": "degas",
    "Model": "2406APNFAG"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Xiaomi 14T Pro",
    "Device": "rothko",
    "Model": "2407FPN8EG"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Xiaomi 14T Pro",
    "Device": "rothko",
    "Model": "2407FPN8ER"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Xiaomi 14T Pro",
    "Device": "rothko",
    "Model": "A402XM"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Xiaomi 15",
    "Device": "dada",
    "Model": "24129PN74C"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Xiaomi 15",
    "Device": "dada",
    "Model": "24129PN74G"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Xiaomi 15",
    "Device": "dada",
    "Model": "24129PN74I"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Xiaomi 15 Pro",
    "Device": "haotian",
    "Model": "2410DPN6CC"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Xiaomi 15 Ultra",
    "Device": "xuanyuan",
    "Model": "25010PN30C"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Xiaomi 15 Ultra",
    "Device": "xuanyuan",
    "Model": "25010PN30G"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Xiaomi 15 Ultra",
    "Device": "xuanyuan",
    "Model": "25010PN30I"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Xiaomi 15 Ultra",
    "Device": "xuanyuan",
    "Model": "25019PNF3C"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Xiaomi 15S Pro",
    "Device": "dijun",
    "Model": "25042PN24C"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Xiaomi 15T",
    "Device": "goya",
    "Model": "25069PTEBG"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Xiaomi 15T Pro",
    "Device": "klimt",
    "Model": "2506BPN68G"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Xiaomi 15T Pro",
    "Device": "klimt",
    "Model": "2506BPN68R"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Xiaomi 17",
    "Device": "pudding",
    "Model": "25113PN0EC"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Xiaomi 17",
    "Device": "pudding",
    "Model": "25113PN0EG"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Xiaomi 17",
    "Device": "pudding",
    "Model": "25113PN0EI"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Xiaomi 17 Pro",
    "Device": "pandora",
    "Model": "25098PN5AC"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Xiaomi 17 Pro Max",
    "Device": "popsicle",
    "Model": "2509FPN0BC"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Xiaomi 17 Ultra",
    "Device": "nezha",
    "Model": "2512BPNDAC"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Xiaomi 17 Ultra",
    "Device": "nezha",
    "Model": "2512BPNDAG"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Xiaomi 17 Ultra",
    "Device": "nezha",
    "Model": "2512BPNDAI"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Xiaomi Civi",
    "Device": "mona",
    "Model": "2109119BC"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Xiaomi Civi 1S",
    "Device": "zijin",
    "Model": "2109119BC"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Xiaomi Civi 4",
    "Device": "chenfeng",
    "Model": "24053PY09C"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Xiaomi Civi 5 Pro",
    "Device": "luming",
    "Model": "25067PYE3C"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Xiaomi MIX Flip",
    "Device": "ruyi",
    "Model": "2405CPX3DC"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Xiaomi MIX Flip",
    "Device": "ruyi",
    "Model": "2405CPX3DG"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Xiaomi MIX Fold",
    "Device": "cetus",
    "Model": "M2011J18C"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Xiaomi MIX Fold 2",
    "Device": "zizhan",
    "Model": "22061218C"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Xiaomi MIX Fold 3",
    "Device": "babylon",
    "Model": "2308CPXD0C"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Xiaomi MIX Fold 4",
    "Device": "goku",
    "Model": "24072PX77C"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Xiaomi MIX Fold 4",
    "Device": "goku",
    "Model": "Xiaomi for arm64"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Xiaomi Pad 5",
    "Device": "nabu",
    "Model": "21051182C"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Xiaomi Pad 5",
    "Device": "nabu",
    "Model": "21051182G"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Xiaomi Pad 5 Pro",
    "Device": "dagu",
    "Model": "22081281AC"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Xiaomi Pad 5 Pro",
    "Device": "elish",
    "Model": "M2105K81AC"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Xiaomi Pad 5 Pro 5G",
    "Device": "enuma",
    "Model": "M2105K81C"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Xiaomi Pad 6",
    "Device": "pipa",
    "Model": "23043RP34C"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Xiaomi Pad 6",
    "Device": "pipa",
    "Model": "23043RP34G"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Xiaomi Pad 6",
    "Device": "pipa",
    "Model": "23043RP34I"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Xiaomi Pad 6 Max 14",
    "Device": "yudi",
    "Model": "2307BRPDCC"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Xiaomi Pad 6S Pro 12.4",
    "Device": "sheng",
    "Model": "24018RPACG"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Xiaomi Pad 7",
    "Device": "uke",
    "Model": "2410CRP4CC"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Xiaomi Pad 7",
    "Device": "uke",
    "Model": "2410CRP4CG"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Xiaomi Pad 7",
    "Device": "uke",
    "Model": "2410CRP4CI"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Xiaomi Pad 7 Pro",
    "Device": "muyu",
    "Model": "24091RPADC"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Xiaomi Pad 7 Pro",
    "Device": "muyu",
    "Model": "24091RPADG"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Xiaomi Pad 7 Ultra",
    "Device": "jinghu",
    "Model": "25032RP42C"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Xiaomi Pad 7S Pro 12.5",
    "Device": "violin",
    "Model": "25053RP5CC"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Xiaomi Pad 8",
    "Device": "yupei",
    "Model": "25097RP43C"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Xiaomi Pad 8 Pro",
    "Device": "piano",
    "Model": "25091RP04C"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Xiaomi Pad Mini",
    "Device": "turner",
    "Model": "25079RPDCG"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Xiaomi Smart Projector L1",
    "Device": "tianshan",
    "Model": "C025RGN"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Xiaomi Smart Projector L1 Pro",
    "Device": "tianshan",
    "Model": "C045RGN"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Xiaomi TV",
    "Device": "arctictale",
    "Model": "MiTV-AXFU0"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Xiaomi TV Box S",
    "Device": "twilight",
    "Model": "MiTV-AFMU0"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Xiaomi TV Box S (2nd Gen)",
    "Device": "jaws",
    "Model": "MiTV-AFKR0"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Xiaomi TV Stick 4K (2nd Gen)",
    "Device": "twilight",
    "Model": "MiTV-AFMU1"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Xiaomi TV stick 4K",
    "Device": "soul",
    "Model": "MiTV-AYFR0"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Xiaomi Watch 2",
    "Device": "axolotlaxie",
    "Model": "Xiaomi Watch 2"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Xiaomi Watch 2 Pro",
    "Device": "axolotl",
    "Model": "Xiaomi Watch 2 Pro"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Xiaomi Watch 2 Pro",
    "Device": "axolotlte",
    "Model": "Xiaomi Watch 2 Pro"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Xiaomi civi 3",
    "Device": "yuechu",
    "Model": "23046PNC9C"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Xiaomi civi2",
    "Device": "ziyi",
    "Model": "2209129SC"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Xiaomi pad 6",
    "Device": "pipa",
    "Model": "23043RP34G"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "Xiaomi pad 6 Pro",
    "Device": "liuqin",
    "Model": "23046RP50C"
  },
  {
    "Retail Branding": "Xiaomi",
    "Marketing Name": "小米手表",
    "Device": "baiji",
    "Model": "Mi Watch"
  },
  {
    "Retail Branding": "Xinlian",
    "Marketing Name": "HC750",
    "Device": "HC750",
    "Model": "HC750"
  },
  {
    "Retail Branding": "Xitrix",
    "Marketing Name": "TravelPad A10",
    "Device": "TravelPad_A10",
    "Model": "TravelPad A10"
  },
  {
    "Retail Branding": "Xitrix",
    "Marketing Name": "XITRIX",
    "Device": "elliniko",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "Xitrix",
    "Marketing Name": "XITRIX",
    "Device": "stanford",
    "Model": "SMART TV"
  },
  {
    "Retail Branding": "Xitrix",
    "Marketing Name": "XITRIX",
    "Device": "zhongshan",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "Xming",
    "Marketing Name": "Page One Smart Projector",
    "Device": "tianshan",
    "Model": "Xming Google TV"
  },
  {
    "Retail Branding": "Xming",
    "Marketing Name": "Xming Episode One Smart Projector",
    "Device": "tianshan",
    "Model": "Xming Google TV"
  },
  {
    "Retail Branding": "Xmobile",
    "Marketing Name": "X1",
    "Device": "X1",
    "Model": "X1"
  },
  {
    "Retail Branding": "Xmobile",
    "Marketing Name": "X10",
    "Device": "XMOBILE",
    "Model": "X10"
  },
  {
    "Retail Branding": "Xmobile",
    "Marketing Name": "X10Max",
    "Device": "X10Max",
    "Model": "X10Max"
  },
  {
    "Retail Branding": "Xmobile",
    "Marketing Name": "X3",
    "Device": "Xmobile_X3",
    "Model": "X3"
  },
  {
    "Retail Branding": "Xmobile",
    "Marketing Name": "X55",
    "Device": "X55NALU",
    "Model": "X55"
  },
  {
    "Retail Branding": "Xmobile",
    "Marketing Name": "X55",
    "Device": "X_55_A",
    "Model": "X55"
  },
  {
    "Retail Branding": "Xmobile",
    "Marketing Name": "X55USA",
    "Device": "X55USA",
    "Model": "X55"
  },
  {
    "Retail Branding": "Xmobile",
    "Marketing Name": "X55_C",
    "Device": "X55_C",
    "Model": "X55"
  },
  {
    "Retail Branding": "Xmobile",
    "Marketing Name": "X63",
    "Device": "X_63_A",
    "Model": "X63"
  },
  {
    "Retail Branding": "Xmobile",
    "Marketing Name": "X63Pro",
    "Device": "X63Pro",
    "Model": "X63Pro"
  },
  {
    "Retail Branding": "Xmobile",
    "Marketing Name": "X63Pro",
    "Device": "X_63_ProA",
    "Model": "X63Pro"
  },
  {
    "Retail Branding": "Xmobile",
    "Marketing Name": "X6_Pro",
    "Device": "X6_Pro",
    "Model": "X6Pro"
  },
  {
    "Retail Branding": "Xmobile",
    "Marketing Name": "X7",
    "Device": "X7",
    "Model": "XMOBILE X7"
  },
  {
    "Retail Branding": "Xmobile",
    "Marketing Name": "X8Max",
    "Device": "X8Max",
    "Model": "X8Max"
  },
  {
    "Retail Branding": "Xmobile",
    "Marketing Name": "X8Pro",
    "Device": "X8Pro",
    "Model": "X8Pro"
  },
  {
    "Retail Branding": "Xmobile",
    "Marketing Name": "X8Pro",
    "Device": "X8Pronus",
    "Model": "X8Pro"
  },
  {
    "Retail Branding": "Xmobile",
    "Marketing Name": "X8ProUSNal",
    "Device": "X8ProUSNal",
    "Model": "X8Pro"
  },
  {
    "Retail Branding": "Xmobile",
    "Marketing Name": "X_55B",
    "Device": "X_55B",
    "Model": "X55"
  },
  {
    "Retail Branding": "Xmobile",
    "Marketing Name": "Xmovi_X8",
    "Device": "Xmovi_X8",
    "Model": "X8"
  },
  {
    "Retail Branding": "Xolo",
    "Marketing Name": "Era 2X 2GB",
    "Device": "XE2X",
    "Model": "Era 2X"
  },
  {
    "Retail Branding": "Xolo",
    "Marketing Name": "Era 2X 3GB",
    "Device": "XE2X3GB",
    "Model": "Era 2X 3GB"
  },
  {
    "Retail Branding": "Xolo",
    "Marketing Name": "Era3",
    "Device": "Era_3",
    "Model": "Era 3"
  },
  {
    "Retail Branding": "Xolo",
    "Marketing Name": "Era5X",
    "Device": "Era5X",
    "Model": "Era5X"
  },
  {
    "Retail Branding": "Xolo",
    "Marketing Name": "Era_4X",
    "Device": "Era_4X",
    "Model": "Era_4X"
  },
  {
    "Retail Branding": "Xolo",
    "Marketing Name": "Era_4X_2GB",
    "Device": "Era_4X_2GB",
    "Model": "Era_4X_2GB"
  },
  {
    "Retail Branding": "Xolo",
    "Marketing Name": "XOLO ERA 2V",
    "Device": "Era_2V",
    "Model": "Era 2V"
  },
  {
    "Retail Branding": "Xolo",
    "Marketing Name": "XOLO ERA 3X",
    "Device": "Era_3X",
    "Model": "era3x"
  },
  {
    "Retail Branding": "Xolo",
    "Marketing Name": "era1X",
    "Device": "era1X",
    "Model": "era1X"
  },
  {
    "Retail Branding": "Xphoenix",
    "Marketing Name": "OneTabPro2",
    "Device": "OneTabPro2",
    "Model": "OneTabPro2"
  },
  {
    "Retail Branding": "Xphoenix",
    "Marketing Name": "OneTabProMate",
    "Device": "OneTabProMate",
    "Model": "OneTabProMate"
  },
  {
    "Retail Branding": "Xplore Technologies",
    "Marketing Name": "M6",
    "Device": "M6",
    "Model": "M6"
  },
  {
    "Retail Branding": "Xplore Technologies",
    "Marketing Name": "RangerX",
    "Device": "iX101T1",
    "Model": "iX101T1"
  },
  {
    "Retail Branding": "Xplore Technologies",
    "Marketing Name": "RangerX",
    "Device": "iX101T1_2G",
    "Model": "iX101T1-2G"
  },
  {
    "Retail Branding": "Xplore Technologies",
    "Marketing Name": "XP8105",
    "Device": "XP8105",
    "Model": "XP8105"
  },
  {
    "Retail Branding": "Xplore Technologies",
    "Marketing Name": "XP8105A",
    "Device": "XP8105A",
    "Model": "XP8105A"
  },
  {
    "Retail Branding": "Xplore Technologies",
    "Marketing Name": "XP8776",
    "Device": "XP8776",
    "Model": "XP8776"
  },
  {
    "Retail Branding": "Xplore Technologies",
    "Marketing Name": "XSLATE_D10",
    "Device": "XSLATE_D10",
    "Model": "iX101B1"
  },
  {
    "Retail Branding": "Xplore Technologies",
    "Marketing Name": "XSLATE_D10",
    "Device": "XSLATE_D10",
    "Model": "iX101D1"
  },
  {
    "Retail Branding": "Xplore Technologies",
    "Marketing Name": "XSLATE_D10",
    "Device": "XSLATE_D10",
    "Model": "iX101D1-FIOS"
  },
  {
    "Retail Branding": "Xsmart",
    "Marketing Name": "CORE_X",
    "Device": "CORE_X",
    "Model": "CORE_X"
  },
  {
    "Retail Branding": "Xsmart",
    "Marketing Name": "Mate 20",
    "Device": "XsmartMate20",
    "Model": "Mate 20"
  },
  {
    "Retail Branding": "Xsmart",
    "Marketing Name": "Mate_10",
    "Device": "Mate_10",
    "Model": "Mate 10"
  },
  {
    "Retail Branding": "Xsmart",
    "Marketing Name": "NOVA_7",
    "Device": "NOVA_7",
    "Model": "NOVA_7"
  },
  {
    "Retail Branding": "Xsmart",
    "Marketing Name": "NOVA_7",
    "Device": "NOVA_7",
    "Model": "Xsmart Nova 7"
  },
  {
    "Retail Branding": "Xsmart",
    "Marketing Name": "Nova 10",
    "Device": "Xsmart_Nova_10",
    "Model": "Nova_10"
  },
  {
    "Retail Branding": "Xsmart",
    "Marketing Name": "Nova_8",
    "Device": "Xsmart_Nova_8",
    "Model": "Xsmart Nova 8"
  },
  {
    "Retail Branding": "Xstar",
    "Marketing Name": "S2",
    "Device": "S2",
    "Model": "S2"
  },
  {
    "Retail Branding": "Xstar",
    "Marketing Name": "T20",
    "Device": "T20",
    "Model": "T20"
  },
  {
    "Retail Branding": "Xtratech",
    "Marketing Name": "BRIO_X31",
    "Device": "BRIO_X31",
    "Model": "BRIO_X31"
  },
  {
    "Retail Branding": "Xtratech",
    "Marketing Name": "South America,Ecuador",
    "Device": "martin",
    "Model": "XTRATECH Android TV"
  },
  {
    "Retail Branding": "Xtratech",
    "Marketing Name": "South America,Ecuador",
    "Device": "patrick",
    "Model": "XTRATECH Android TV"
  },
  {
    "Retail Branding": "Xtratech",
    "Marketing Name": "X10MT16",
    "Device": "X10MT16",
    "Model": "X10MT16"
  },
  {
    "Retail Branding": "Xtratech",
    "Marketing Name": "X10MT87",
    "Device": "X10MT87",
    "Model": "X10MT87"
  },
  {
    "Retail Branding": "Xtratech",
    "Marketing Name": "X739Q",
    "Device": "bnd8163_tb_n",
    "Model": "X739Q"
  },
  {
    "Retail Branding": "Xtratech",
    "Marketing Name": "X8MT16",
    "Device": "X8MT16",
    "Model": "X8MT16"
  },
  {
    "Retail Branding": "Xtratech",
    "Marketing Name": "X8MT87",
    "Device": "X8MT87",
    "Model": "X8MT87"
  },
  {
    "Retail Branding": "Xtratech",
    "Marketing Name": "XTRATECH",
    "Device": "KT-755M",
    "Model": "KT-755M"
  },
  {
    "Retail Branding": "Xtreme",
    "Marketing Name": "Android TV",
    "Device": "R1",
    "Model": "ATV R1"
  },
  {
    "Retail Branding": "Xtreme",
    "Marketing Name": "R3",
    "Device": "R3",
    "Model": "R3"
  },
  {
    "Retail Branding": "Xtreme",
    "Marketing Name": "R4",
    "Device": "R4",
    "Model": "R4"
  },
  {
    "Retail Branding": "Xtreme",
    "Marketing Name": "XTREME 4K TV",
    "Device": "SW4H",
    "Model": "XTREME 4K TV"
  },
  {
    "Retail Branding": "Xtreme",
    "Marketing Name": "XTREME AI TV",
    "Device": "sunnyvale",
    "Model": "XTREME AI TV"
  },
  {
    "Retail Branding": "Xtreme",
    "Marketing Name": "XTREME TV",
    "Device": "shinjuku",
    "Model": "XTREME TV"
  },
  {
    "Retail Branding": "Xtreme",
    "Marketing Name": "Xtreme 2K Smart TV",
    "Device": "umeda",
    "Model": "Xtreme 2K Smart TV"
  },
  {
    "Retail Branding": "Xtreme",
    "Marketing Name": "Xtreme 4K Smart TV",
    "Device": "SW6H",
    "Model": "Xtreme 4K Smart TV"
  },
  {
    "Retail Branding": "Xtreme",
    "Marketing Name": "Xtreme 4K Smart TV FF",
    "Device": "SW6H",
    "Model": "Xtreme 4K Smart TV FF"
  },
  {
    "Retail Branding": "Xwave",
    "Marketing Name": "Xpad",
    "Device": "Xpad",
    "Model": "Xpad_M9_3G"
  },
  {
    "Retail Branding": "YASHI",
    "Marketing Name": "MARTINI",
    "Device": "MARTINI",
    "Model": "MARTINI"
  },
  {
    "Retail Branding": "YAYGO",
    "Marketing Name": "SEI600YAY",
    "Device": "HND",
    "Model": "ATV-101"
  },
  {
    "Retail Branding": "YAYGO",
    "Marketing Name": "SEI600YAY4",
    "Device": "HND",
    "Model": "ATV-101"
  },
  {
    "Retail Branding": "YCQ_SZ",
    "Marketing Name": "YCQ_Q88",
    "Device": "YCQ_Q88",
    "Model": "YCQ_Q88"
  },
  {
    "Retail Branding": "YELLYOUTH",
    "Marketing Name": "TAB_101",
    "Device": "TAB_101",
    "Model": "TAB_101"
  },
  {
    "Retail Branding": "YETRUE",
    "Marketing Name": "yetruepad21",
    "Device": "yetruepad21_EEA",
    "Model": "yetruepad21"
  },
  {
    "Retail Branding": "YGF(tech)",
    "Marketing Name": "YGF-F35",
    "Device": "YGF-F35",
    "Model": "YGF-F35"
  },
  {
    "Retail Branding": "YGF(tech)",
    "Marketing Name": "YGF-F7",
    "Device": "YGF_F7",
    "Model": "YGF-F7"
  },
  {
    "Retail Branding": "YIKEMI",
    "Marketing Name": "Pad6_Plus_EEA",
    "Device": "Pad6_Plus_EEA",
    "Model": "Pad6 PLUS"
  },
  {
    "Retail Branding": "YIKEMI",
    "Marketing Name": "pad7_Ultra_EEA",
    "Device": "pad7_Ultra_EEA",
    "Model": "Pad6_Plus"
  },
  {
    "Retail Branding": "YINBER",
    "Marketing Name": "S11Ultra",
    "Device": "S11Ultra",
    "Model": "S11Ultra"
  },
  {
    "Retail Branding": "YINKE",
    "Marketing Name": "P6501",
    "Device": "P6501",
    "Model": "P6501"
  },
  {
    "Retail Branding": "YINOCHE",
    "Marketing Name": "R8",
    "Device": "R8",
    "Model": "R8"
  },
  {
    "Retail Branding": "YISHENGTC",
    "Marketing Name": "EMEETING_3576",
    "Device": "EMEETING_3576",
    "Model": "EMEETING_3576"
  },
  {
    "Retail Branding": "YISHENGTC",
    "Marketing Name": "OPS_3576",
    "Device": "OPS_3576",
    "Model": "OPS_3576"
  },
  {
    "Retail Branding": "YOBANSE",
    "Marketing Name": "T88",
    "Device": "T88",
    "Model": "T88"
  },
  {
    "Retail Branding": "YOBANSE",
    "Marketing Name": "Y101",
    "Device": "Y101",
    "Model": "Y101"
  },
  {
    "Retail Branding": "YOBANSE",
    "Marketing Name": "Z-T10",
    "Device": "Z-T10",
    "Model": "Z-T10"
  },
  {
    "Retail Branding": "YOBANSE",
    "Marketing Name": "Z-TAB10",
    "Device": "Z-TAB10",
    "Model": "Z-TAB10"
  },
  {
    "Retail Branding": "YOSATOO",
    "Marketing Name": "K15",
    "Device": "K15",
    "Model": "K15"
  },
  {
    "Retail Branding": "YOSATOO",
    "Marketing Name": "K15-B",
    "Device": "K15-B",
    "Model": "K15-B"
  },
  {
    "Retail Branding": "YOSATOO",
    "Marketing Name": "KIDS07A",
    "Device": "KIDS07A",
    "Model": "KIDS07A"
  },
  {
    "Retail Branding": "YOSATOO",
    "Marketing Name": "P10",
    "Device": "P10",
    "Model": "P10"
  },
  {
    "Retail Branding": "YOSATOO",
    "Marketing Name": "Y10",
    "Device": "Y10",
    "Model": "Y10"
  },
  {
    "Retail Branding": "YOSATOO",
    "Marketing Name": "Y101",
    "Device": "Y101",
    "Model": "Y101"
  },
  {
    "Retail Branding": "YOSATOO",
    "Marketing Name": "Y102",
    "Device": "Y102",
    "Model": "Y102"
  },
  {
    "Retail Branding": "YOTOPT",
    "Marketing Name": "M60_EEA",
    "Device": "M60_EEA",
    "Model": "M60_EEA"
  },
  {
    "Retail Branding": "YOTOPT",
    "Marketing Name": "Q11-EEA",
    "Device": "Q11-EEA",
    "Model": "Q11-EEA"
  },
  {
    "Retail Branding": "YOTOPT",
    "Marketing Name": "X109",
    "Device": "X109",
    "Model": "X109"
  },
  {
    "Retail Branding": "YOTOPT",
    "Marketing Name": "Y103_EEA",
    "Device": "Y103_EEA",
    "Model": "Y103_EEA"
  },
  {
    "Retail Branding": "YOTOPT",
    "Marketing Name": "Y121-EEA",
    "Device": "Y121-EEA",
    "Model": "Y121-EEA"
  },
  {
    "Retail Branding": "YOTOPT",
    "Marketing Name": "Y3-EEA",
    "Device": "Y3-EEA",
    "Model": "Y3-EEA"
  },
  {
    "Retail Branding": "YOTOPT",
    "Marketing Name": "Y5-EEA",
    "Device": "Y5-EEA",
    "Model": "Y5-EEA"
  },
  {
    "Retail Branding": "YOTOPT",
    "Marketing Name": "Y61",
    "Device": "Y61",
    "Model": "Y61"
  },
  {
    "Retail Branding": "YOTOPT",
    "Marketing Name": "Y61-EEA",
    "Device": "Y61-EEA",
    "Model": "Y61-EEA"
  },
  {
    "Retail Branding": "YOTOPT",
    "Marketing Name": "Y8-EEA",
    "Device": "Y8-EEA",
    "Model": "Y8-EEA"
  },
  {
    "Retail Branding": "YOUIN",
    "Marketing Name": "SEI600EN",
    "Device": "HND",
    "Model": "YOU-BOX"
  },
  {
    "Retail Branding": "YOUNG",
    "Marketing Name": "YETC_1123",
    "Device": "YETC_1123",
    "Model": "YETC 1123"
  },
  {
    "Retail Branding": "YOUTAB",
    "Marketing Name": "YOUTAB_S7",
    "Device": "YOUTAB_S7",
    "Model": "YOUTAB S7"
  },
  {
    "Retail Branding": "YQSAVIOR",
    "Marketing Name": "P80_RU",
    "Device": "P80_RU",
    "Model": "P80_RU"
  },
  {
    "Retail Branding": "YQSAVIOR",
    "Marketing Name": "Q2K",
    "Device": "Q2K",
    "Model": "Q2K"
  },
  {
    "Retail Branding": "YQSAVIOR",
    "Marketing Name": "YQ10S",
    "Device": "YQ10S",
    "Model": "YQ10S"
  },
  {
    "Retail Branding": "YQSAVIOR",
    "Marketing Name": "YQ10S_Pro",
    "Device": "YQ10S_Pro",
    "Model": "YQ10S_Pro"
  },
  {
    "Retail Branding": "YQSAVIOR",
    "Marketing Name": "YQ30",
    "Device": "YQ30",
    "Model": "YQ30"
  },
  {
    "Retail Branding": "YQSVAIOR",
    "Marketing Name": "P80_EEA",
    "Device": "P80_EEA",
    "Model": "P80_EEA"
  },
  {
    "Retail Branding": "YQSVAIOR",
    "Marketing Name": "P80_ROW",
    "Device": "P80_ROW",
    "Model": "P80_ROW"
  },
  {
    "Retail Branding": "YQSVAIOR",
    "Marketing Name": "YQ-SVAIOR-EEA",
    "Device": "YQ-SVAIOR-EEA",
    "Model": "YQ-SVAIOR-EEA"
  },
  {
    "Retail Branding": "YQSVAIOR",
    "Marketing Name": "YQ10",
    "Device": "YQ10",
    "Model": "YQ10"
  },
  {
    "Retail Branding": "YQSVAIOR",
    "Marketing Name": "YQ11",
    "Device": "YQ11",
    "Model": "YQ11"
  },
  {
    "Retail Branding": "YQSVAIOR",
    "Marketing Name": "YQ81-ROW",
    "Device": "YQ81-ROW",
    "Model": "YQ81-ROW"
  },
  {
    "Retail Branding": "YSF(tyd)",
    "Marketing Name": "Rugged tablet",
    "Device": "Rugged_tablet",
    "Model": "Rugged tablet"
  },
  {
    "Retail Branding": "YSFEN",
    "Marketing Name": "B9000",
    "Device": "B9000",
    "Model": "B9000"
  },
  {
    "Retail Branding": "YSFPHONE",
    "Marketing Name": "Rugged tablet",
    "Device": "Rugged_tablet",
    "Model": "Rugged_tablet"
  },
  {
    "Retail Branding": "YU",
    "Marketing Name": "YUNICORN",
    "Device": "YUNICORN",
    "Model": "YU5530"
  },
  {
    "Retail Branding": "YU",
    "Marketing Name": "YUNIQUE",
    "Device": "YU4711",
    "Model": "YU4711"
  },
  {
    "Retail Branding": "YU",
    "Marketing Name": "YUPHORIA",
    "Device": "YUPHORIA",
    "Model": "YU5010"
  },
  {
    "Retail Branding": "YU",
    "Marketing Name": "YUPHORIA",
    "Device": "YUPHORIA",
    "Model": "YU5010A"
  },
  {
    "Retail Branding": "YU",
    "Marketing Name": "YUREKA",
    "Device": "YUREKA",
    "Model": "YU5510"
  },
  {
    "Retail Branding": "YU",
    "Marketing Name": "YUREKAS",
    "Device": "YUREKAS",
    "Model": "YU5200"
  },
  {
    "Retail Branding": "YU",
    "Marketing Name": "Yunique 2",
    "Device": "YU5011",
    "Model": "YU5011"
  },
  {
    "Retail Branding": "YU",
    "Marketing Name": "Yureka",
    "Device": "YUREKA",
    "Model": "AO5510"
  },
  {
    "Retail Branding": "YU",
    "Marketing Name": "Yureka",
    "Device": "YUREKA",
    "Model": "YU5510"
  },
  {
    "Retail Branding": "YU",
    "Marketing Name": "Yureka",
    "Device": "YUREKA",
    "Model": "YU5510A"
  },
  {
    "Retail Branding": "YU",
    "Marketing Name": "Yureka",
    "Device": "YUREKA",
    "Model": "YUREKA"
  },
  {
    "Retail Branding": "YU",
    "Marketing Name": "Yureka Black",
    "Device": "YU5040",
    "Model": "YU5040"
  },
  {
    "Retail Branding": "YU",
    "Marketing Name": "Yureka Black",
    "Device": "YU5041",
    "Model": "YU5041"
  },
  {
    "Retail Branding": "YU",
    "Marketing Name": "Yureka Note",
    "Device": "YU6000",
    "Model": "YU 6000"
  },
  {
    "Retail Branding": "YUMKEM",
    "Marketing Name": "N10-EEA",
    "Device": "N10-EEA",
    "Model": "N10-EEA"
  },
  {
    "Retail Branding": "YUMKEM",
    "Marketing Name": "U221",
    "Device": "U221",
    "Model": "U221"
  },
  {
    "Retail Branding": "YUMKEM",
    "Marketing Name": "U221-EEA",
    "Device": "U221-EEA",
    "Model": "U221-EEA"
  },
  {
    "Retail Branding": "YUMKEM",
    "Marketing Name": "U320",
    "Device": "U320",
    "Model": "U320"
  },
  {
    "Retail Branding": "YUMKEM",
    "Marketing Name": "U320-EEA",
    "Device": "U320-EEA",
    "Model": "U320-EEA"
  },
  {
    "Retail Branding": "YUNTAB",
    "Marketing Name": "D107",
    "Device": "D107",
    "Model": "D107"
  },
  {
    "Retail Branding": "YUNTAB",
    "Marketing Name": "YUNTAB-K107",
    "Device": "YUNTAB-K107",
    "Model": "YUNTAB-K107"
  },
  {
    "Retail Branding": "YUNTAB",
    "Marketing Name": "YUNTAB-K107_EEA",
    "Device": "YUNTAB-K107_EEA",
    "Model": "YUNTAB-K107_EEA"
  },
  {
    "Retail Branding": "YUNTAB",
    "Marketing Name": "YUNTAB-Q88",
    "Device": "YUNTAB-Q88",
    "Model": "YUNTAB-Q88"
  },
  {
    "Retail Branding": "Yandex",
    "Marketing Name": "Amber",
    "Device": "Amber",
    "Model": "YNDX-000SB"
  },
  {
    "Retail Branding": "Yandex",
    "Marketing Name": "YNDX-000SB",
    "Device": "Amber",
    "Model": "YNDX-000SB"
  },
  {
    "Retail Branding": "Yasin",
    "Marketing Name": "YASIN",
    "Device": "elliniko",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "Yasin",
    "Marketing Name": "YASIN",
    "Device": "komagome",
    "Model": "YASIN 2K Android TV"
  },
  {
    "Retail Branding": "Yasin",
    "Marketing Name": "YASIN 2K G Smart TV",
    "Device": "umeda",
    "Model": "YASIN 2K G Smart TV"
  },
  {
    "Retail Branding": "Yasin",
    "Marketing Name": "YASIN 2K TV",
    "Device": "shinagawa",
    "Model": "YASIN 2K TV"
  },
  {
    "Retail Branding": "Yasin",
    "Marketing Name": "YASIN 4K G Smart TV",
    "Device": "SW6H",
    "Model": "YASIN 4K G Smart TV"
  },
  {
    "Retail Branding": "Yasin",
    "Marketing Name": "YASIN 4K G Smart TV FF",
    "Device": "SW6H",
    "Model": "YASIN 4K G Smart TV FF"
  },
  {
    "Retail Branding": "Yasin",
    "Marketing Name": "Yasin",
    "Device": "bangbae",
    "Model": "YASIN 4K Android TV"
  },
  {
    "Retail Branding": "Yasin",
    "Marketing Name": "Yasin Android TV",
    "Device": "SW4H",
    "Model": "Yasin Android TV"
  },
  {
    "Retail Branding": "Yealink",
    "Marketing Name": "MeetingBoardC",
    "Device": "MeetingBoardC",
    "Model": "MeetingBoardC"
  },
  {
    "Retail Branding": "Yekani",
    "Marketing Name": "T3A  Trend",
    "Device": "T3A_Trend",
    "Model": "Trend"
  },
  {
    "Retail Branding": "Yes",
    "Marketing Name": "Altitude 2",
    "Device": "M651G_MY",
    "Model": "M651G_MY"
  },
  {
    "Retail Branding": "Yes",
    "Marketing Name": "Altitude 3",
    "Device": "M685Y4",
    "Model": "M685Y4"
  },
  {
    "Retail Branding": "Yes",
    "Marketing Name": "Altitude 4",
    "Device": "Altitude_4",
    "Model": "YES Altitude 4"
  },
  {
    "Retail Branding": "Yes",
    "Marketing Name": "M631Y",
    "Device": "M631Y",
    "Model": "M631Y"
  },
  {
    "Retail Branding": "Yes",
    "Marketing Name": "STING",
    "Device": "dwi765yes",
    "Model": "STING"
  },
  {
    "Retail Branding": "Yes",
    "Marketing Name": "Yes",
    "Device": "SEI800Y",
    "Model": "yes"
  },
  {
    "Retail Branding": "Yes",
    "Marketing Name": "Yes",
    "Device": "SEID00Y",
    "Model": "Yes"
  },
  {
    "Retail Branding": "Yes",
    "Marketing Name": "Yes",
    "Device": "SEID00Y",
    "Model": "yes"
  },
  {
    "Retail Branding": "Yes",
    "Marketing Name": "yes",
    "Device": "SEI500Y",
    "Model": "yes"
  },
  {
    "Retail Branding": "Yes",
    "Marketing Name": "yes",
    "Device": "SEI800Y",
    "Model": "yes"
  },
  {
    "Retail Branding": "YesTeL",
    "Marketing Name": "Note_30_pro",
    "Device": "Note_30_pro",
    "Model": "Note 30 pro"
  },
  {
    "Retail Branding": "YesTeL",
    "Marketing Name": "T10_V_EEA",
    "Device": "T10_V_EEA",
    "Model": "T10_EEA"
  },
  {
    "Retail Branding": "YesTeL",
    "Marketing Name": "T10_V_EEA",
    "Device": "T10_V_EEA",
    "Model": "T10_V_EEA"
  },
  {
    "Retail Branding": "YesTeL",
    "Marketing Name": "T13-EEA",
    "Device": "T13-EEA",
    "Model": "T13-EEA"
  },
  {
    "Retail Branding": "YesTeL",
    "Marketing Name": "T13-US",
    "Device": "T13-US",
    "Model": "T13-US"
  },
  {
    "Retail Branding": "YesTeL",
    "Marketing Name": "T13_EEA",
    "Device": "T13_EEA",
    "Model": "T13_EEA"
  },
  {
    "Retail Branding": "YesTeL",
    "Marketing Name": "T13_T_EEA",
    "Device": "T13_T_EEA",
    "Model": "T13_T_EEA"
  },
  {
    "Retail Branding": "YesTeL",
    "Marketing Name": "T13_T_US",
    "Device": "T13_T_US",
    "Model": "T13_T_US"
  },
  {
    "Retail Branding": "YesTeL",
    "Marketing Name": "T13_US",
    "Device": "T13_US",
    "Model": "T13_US"
  },
  {
    "Retail Branding": "YesTeL",
    "Marketing Name": "T13_V_EEA",
    "Device": "T13_V_EEA",
    "Model": "T13_EEA"
  },
  {
    "Retail Branding": "YesTeL",
    "Marketing Name": "T13_V_EEA",
    "Device": "T13_V_EEA",
    "Model": "T13_V_EEA"
  },
  {
    "Retail Branding": "YesTeL",
    "Marketing Name": "T15_EEA",
    "Device": "T15_EEA",
    "Model": "T15_EEA"
  },
  {
    "Retail Branding": "YesTeL",
    "Marketing Name": "T15_US",
    "Device": "T15_US",
    "Model": "T15_US"
  },
  {
    "Retail Branding": "YesTeL",
    "Marketing Name": "T15_U_EEA",
    "Device": "T15_U_EEA",
    "Model": "T15_U_EEA"
  },
  {
    "Retail Branding": "YesTeL",
    "Marketing Name": "T15_U_US",
    "Device": "T15_U_US",
    "Model": "T15_U_US"
  },
  {
    "Retail Branding": "YesTeL",
    "Marketing Name": "T15_V_EEA",
    "Device": "T15_V_EEA",
    "Model": "T15_V_EEA"
  },
  {
    "Retail Branding": "YesTeL",
    "Marketing Name": "T5",
    "Device": "T5",
    "Model": "T5"
  },
  {
    "Retail Branding": "YesTeL",
    "Marketing Name": "T5-plus",
    "Device": "T5-plus",
    "Model": "T5-plus"
  },
  {
    "Retail Branding": "YesTeL",
    "Marketing Name": "T5_0",
    "Device": "T5_0",
    "Model": "T5_0"
  },
  {
    "Retail Branding": "YesTeL",
    "Marketing Name": "T5_EEA",
    "Device": "T5-plus-EEA",
    "Model": "T5-plus-EEA"
  },
  {
    "Retail Branding": "YesTeL",
    "Marketing Name": "T5_EEA",
    "Device": "T5_EEA",
    "Model": "T5_EEA"
  },
  {
    "Retail Branding": "YesTeL",
    "Marketing Name": "T5_EEA_0",
    "Device": "T5_EEA_0",
    "Model": "T5_EEA_0"
  },
  {
    "Retail Branding": "YesTeL",
    "Marketing Name": "X11_EEA",
    "Device": "X11_EEA",
    "Model": "X11_EEA"
  },
  {
    "Retail Branding": "YesTeL",
    "Marketing Name": "X2_EEA",
    "Device": "X2_EEA",
    "Model": "X2_EEA"
  },
  {
    "Retail Branding": "YesTeL",
    "Marketing Name": "X2_T_EEA",
    "Device": "X2_T_EEA",
    "Model": "X2_T_EEA"
  },
  {
    "Retail Branding": "YesTeL",
    "Marketing Name": "X2_T_US",
    "Device": "X2_T_US",
    "Model": "X2_T_US"
  },
  {
    "Retail Branding": "YesTeL",
    "Marketing Name": "X2_US",
    "Device": "X2_US",
    "Model": "X2_US"
  },
  {
    "Retail Branding": "YesTeL",
    "Marketing Name": "X2_U_EEA",
    "Device": "X2_U_EEA",
    "Model": "X2_U_EEA"
  },
  {
    "Retail Branding": "YesTeL",
    "Marketing Name": "X2_U_US",
    "Device": "X2_U_US",
    "Model": "X2_U_US"
  },
  {
    "Retail Branding": "YesTeL",
    "Marketing Name": "X3",
    "Device": "X3",
    "Model": "X3"
  },
  {
    "Retail Branding": "YesTeL",
    "Marketing Name": "X3_EEA",
    "Device": "X3_EEA",
    "Model": "X3_EEA"
  },
  {
    "Retail Branding": "YesTeL",
    "Marketing Name": "X7_EEA",
    "Device": "X7_EEA",
    "Model": "X7_EEA"
  },
  {
    "Retail Branding": "YesTeL",
    "Marketing Name": "X8",
    "Device": "YESTEL_X8",
    "Model": "X8"
  },
  {
    "Retail Branding": "YesTeL",
    "Marketing Name": "X8_EEA",
    "Device": "X8_EEA",
    "Model": "X8"
  },
  {
    "Retail Branding": "YesTeL",
    "Marketing Name": "X9_EEA",
    "Device": "X9_EEA",
    "Model": "X9_EEA"
  },
  {
    "Retail Branding": "YesTeL",
    "Marketing Name": "X9_US",
    "Device": "X9_US",
    "Model": "X9_US"
  },
  {
    "Retail Branding": "Yettel",
    "Marketing Name": "MediaBox",
    "Device": "MediaBox_B866V2",
    "Model": "MediaBox"
  },
  {
    "Retail Branding": "Yettel",
    "Marketing Name": "STB BG",
    "Device": "STB_BG_B866V2H01",
    "Model": "STB BG"
  },
  {
    "Retail Branding": "Yezz",
    "Marketing Name": "4E",
    "Device": "4E",
    "Model": "4E"
  },
  {
    "Retail Branding": "Yezz",
    "Marketing Name": "5.5M",
    "Device": "5_5M",
    "Model": "5.5M"
  },
  {
    "Retail Branding": "Yezz",
    "Marketing Name": "5E",
    "Device": "5E",
    "Model": "5E"
  },
  {
    "Retail Branding": "Yezz",
    "Marketing Name": 50000,
    "Device": 50000,
    "Model": 50000
  },
  {
    "Retail Branding": "Yezz",
    "Marketing Name": "5EQ",
    "Device": "5EQ",
    "Model": "5EQ"
  },
  {
    "Retail Branding": "Yezz",
    "Marketing Name": "ART1",
    "Device": "ART1",
    "Model": "ART1"
  },
  {
    "Retail Branding": "Yezz",
    "Marketing Name": "ART1_PRO",
    "Device": "ART1_PRO",
    "Model": "ART1_PRO"
  },
  {
    "Retail Branding": "Yezz",
    "Marketing Name": "ART2PRO",
    "Device": "ART2PRO",
    "Model": "ART2PRO"
  },
  {
    "Retail Branding": "Yezz",
    "Marketing Name": "ART3_PRO",
    "Device": "ART3_PRO",
    "Model": "ART3_PRO"
  },
  {
    "Retail Branding": "Yezz",
    "Marketing Name": "ART_3S",
    "Device": "ART_3S",
    "Model": "ART 3S"
  },
  {
    "Retail Branding": "Yezz",
    "Marketing Name": "ART_3_Lite",
    "Device": "ART_3_Lite",
    "Model": "ART 3 Lite"
  },
  {
    "Retail Branding": "Yezz",
    "Marketing Name": "E400A",
    "Device": "E400A",
    "Model": "E400A"
  },
  {
    "Retail Branding": "Yezz",
    "Marketing Name": "EPIC_3_MAX",
    "Device": "EPIC_3_MAX",
    "Model": "EPIC_3_MAX"
  },
  {
    "Retail Branding": "Yezz",
    "Marketing Name": "EPIC_MAX",
    "Device": "EPIC_3_MAX",
    "Model": "EPIC_3_MAX"
  },
  {
    "Retail Branding": "Yezz",
    "Marketing Name": "EPIC_T",
    "Device": "EPIC_T",
    "Model": "EPIC T"
  },
  {
    "Retail Branding": "Yezz",
    "Marketing Name": "GO 3",
    "Device": "GO_3",
    "Model": "GO 3"
  },
  {
    "Retail Branding": "Yezz",
    "Marketing Name": "GO1",
    "Device": "GO1",
    "Model": "GO1"
  },
  {
    "Retail Branding": "Yezz",
    "Marketing Name": "GO2",
    "Device": "GO_2",
    "Model": "GO2"
  },
  {
    "Retail Branding": "Yezz",
    "Marketing Name": "LIV 1S",
    "Device": "LIV_1S",
    "Model": "LIV 1S"
  },
  {
    "Retail Branding": "Yezz",
    "Marketing Name": "LIV 3S LTE",
    "Device": "LIV_3S_LTE",
    "Model": "LIV 3S LTE"
  },
  {
    "Retail Branding": "Yezz",
    "Marketing Name": "LIV1",
    "Device": "LIV1",
    "Model": "LIV1"
  },
  {
    "Retail Branding": "Yezz",
    "Marketing Name": "LIV2LTE",
    "Device": "LIV2LTE",
    "Model": "LIV2LTE"
  },
  {
    "Retail Branding": "Yezz",
    "Marketing Name": "LIV2_LTE",
    "Device": "LIV2_LTE",
    "Model": "LIV2_LTE"
  },
  {
    "Retail Branding": "Yezz",
    "Marketing Name": "LIV3_LTE",
    "Device": "LIV3_LTE",
    "Model": "LIV 3 LTE"
  },
  {
    "Retail Branding": "Yezz",
    "Marketing Name": "LIV_3S",
    "Device": "LIV_3S",
    "Model": "LIV_3S"
  },
  {
    "Retail Branding": "Yezz",
    "Marketing Name": "MAX 3 PLUS",
    "Device": "MAX_3_PLUS",
    "Model": "MAX 3 PLUS"
  },
  {
    "Retail Branding": "Yezz",
    "Marketing Name": "MAX 3 ULTRA",
    "Device": "MAX3_ULTRA",
    "Model": "MAX3 ULTRA"
  },
  {
    "Retail Branding": "Yezz",
    "Marketing Name": "MAX1",
    "Device": "MAX1",
    "Model": "MAX1"
  },
  {
    "Retail Branding": "Yezz",
    "Marketing Name": "MAX2",
    "Device": "MAX2",
    "Model": "MAX2"
  },
  {
    "Retail Branding": "Yezz",
    "Marketing Name": "MAX2 PLUS",
    "Device": "MAX2_PLUS",
    "Model": "MAX2 PLUS"
  },
  {
    "Retail Branding": "Yezz",
    "Marketing Name": "MAX3",
    "Device": "MAX3",
    "Model": "MAX3"
  },
  {
    "Retail Branding": "Yezz",
    "Marketing Name": "MAX_2_Ultra",
    "Device": "MAX_2_Ultra",
    "Model": "MAX_2_Ultra"
  },
  {
    "Retail Branding": "Yokis",
    "Marketing Name": "WS107_eea",
    "Device": "WS107",
    "Model": "WS107"
  },
  {
    "Retail Branding": "Yokoscan",
    "Marketing Name": "TC100pro",
    "Device": "TC100pro",
    "Model": "TC100pro"
  },
  {
    "Retail Branding": "Yokoscan",
    "Marketing Name": "TC60",
    "Device": "TC60",
    "Model": "TC60"
  },
  {
    "Retail Branding": "Yokoscan",
    "Marketing Name": "TC60_EEA",
    "Device": "TC60_EEA",
    "Model": "TC60_EEA"
  },
  {
    "Retail Branding": "Yota Devices",
    "Marketing Name": "C9660",
    "Device": "yotaphone",
    "Model": "C9660"
  },
  {
    "Retail Branding": "Yota Devices",
    "Marketing Name": "YotaPhone2",
    "Device": "yotaphone2",
    "Model": "YD201"
  },
  {
    "Retail Branding": "YouSee",
    "Marketing Name": "YouSee Streamer",
    "Device": "VIP7020_YouSee",
    "Model": "YouSee Streamer"
  },
  {
    "Retail Branding": "Youfone",
    "Marketing Name": "Amigo7xYUF",
    "Device": "Amigo7xYUF",
    "Model": "Amigo7xYUF"
  },
  {
    "Retail Branding": "Ytab",
    "Marketing Name": "Pad2",
    "Device": "Pad2",
    "Model": "Pad 2"
  },
  {
    "Retail Branding": "Yuho",
    "Marketing Name": "A1332E",
    "Device": "A1332E",
    "Model": "A1332E"
  },
  {
    "Retail Branding": "Yuho",
    "Marketing Name": "Candy",
    "Device": "Candy",
    "Model": "Candy"
  },
  {
    "Retail Branding": "Yuho",
    "Marketing Name": "Candy_Pro",
    "Device": "Candy_Pro",
    "Model": "Candy_Pro"
  },
  {
    "Retail Branding": "Yuho",
    "Marketing Name": "Netra",
    "Device": "Netra",
    "Model": "Netra"
  },
  {
    "Retail Branding": "Yuho",
    "Marketing Name": "Netra_Lite",
    "Device": "Netra_Lite",
    "Model": "Netra_Lite"
  },
  {
    "Retail Branding": "Yuho",
    "Marketing Name": "Netra_Plus",
    "Device": "Netra_Plus",
    "Model": "Netra_Plus"
  },
  {
    "Retail Branding": "Yuho",
    "Marketing Name": "O2 PRO",
    "Device": "YUHO_O2_PRO",
    "Model": "YUHO_O2_PRO"
  },
  {
    "Retail Branding": "Yuho",
    "Marketing Name": "Y1 ACE",
    "Device": "YUHO_Y1_ACE",
    "Model": "YUHO_Y1_ACE"
  },
  {
    "Retail Branding": "Yuho",
    "Marketing Name": "Y1 PRO",
    "Device": "YUHO_Y1_PRO",
    "Model": "YUHO_Y1_PRO"
  },
  {
    "Retail Branding": "Yuho",
    "Marketing Name": "Y2",
    "Device": "YUHO_Y2",
    "Model": "YUHO_Y2"
  },
  {
    "Retail Branding": "Yuho",
    "Marketing Name": "Y2_PRO",
    "Device": "YUHO_Y2_PRO",
    "Model": "YUHO_Y2_PRO"
  },
  {
    "Retail Branding": "Yuho",
    "Marketing Name": "YUHO_O1",
    "Device": "YUHO_O1",
    "Model": "YUHO_O1"
  },
  {
    "Retail Branding": "Yuho",
    "Marketing Name": "YUHO_O1",
    "Device": "YUHO_O1_LITE",
    "Model": "YUHO_O1_LITE"
  },
  {
    "Retail Branding": "Yuho",
    "Marketing Name": "YUHO_Vast",
    "Device": "YUHO_Vast",
    "Model": "YUHO_Vast"
  },
  {
    "Retail Branding": "Yuho",
    "Marketing Name": "YUHO_Vast2",
    "Device": "YUHO_Vast2",
    "Model": "YUHO_Vast2"
  },
  {
    "Retail Branding": "Yuho",
    "Marketing Name": "YUHO_Vast2_Plus",
    "Device": "YUHO_Vast2_Plus",
    "Model": "YUHO_Vast2_Plus"
  },
  {
    "Retail Branding": "Yuho",
    "Marketing Name": "YUHO_Vast_Plus",
    "Device": "YUHO_Vast_Plus",
    "Model": "YUHO_Vast_Plus"
  },
  {
    "Retail Branding": "Yuho",
    "Marketing Name": "YUHO_Y1_STAR",
    "Device": "YUHO_Y1_STAR",
    "Model": "YUHO_Y1_STAR"
  },
  {
    "Retail Branding": "Yuho",
    "Marketing Name": "YUHO_Y1_StarS",
    "Device": "YUHO_Y1_StarS",
    "Model": "YUHO_Y1_StarS"
  },
  {
    "Retail Branding": "Yuho",
    "Marketing Name": "YUHO_Y3_PRO",
    "Device": "YUHO_Y3_PRO",
    "Model": "YUHO_Y3_PRO"
  },
  {
    "Retail Branding": "Yuho",
    "Marketing Name": "Yuho_Tab10",
    "Device": "Yuho_Tab10",
    "Model": "TC1031"
  },
  {
    "Retail Branding": "Yuho",
    "Marketing Name": "Yuho_Tab8",
    "Device": "Yuho_Tab8",
    "Model": "TC8091"
  },
  {
    "Retail Branding": "Yumpingo",
    "Marketing Name": "YUMPINGO_1",
    "Device": "YUMPINGO_1",
    "Model": "YUMPINGO_1"
  },
  {
    "Retail Branding": "ZAIKAI",
    "Marketing Name": "GPROseries",
    "Device": "t7_an400",
    "Model": "GPROseries"
  },
  {
    "Retail Branding": "ZAIKAI",
    "Marketing Name": "Gseries",
    "Device": "mensa_an64",
    "Model": "Gseries"
  },
  {
    "Retail Branding": "ZAIKAI",
    "Marketing Name": "Mannat_Smart_Board",
    "Device": "mensa_an64",
    "Model": "G-8600"
  },
  {
    "Retail Branding": "ZAIKAI",
    "Marketing Name": "ZAIKAI",
    "Device": "t7_an400",
    "Model": "G-8600"
  },
  {
    "Retail Branding": "ZAMOLXE",
    "Marketing Name": "ZXT-10FL323G-PRO",
    "Device": "ZXT-10FL323G-PRO",
    "Model": "ZXT-10FL323G-PRO"
  },
  {
    "Retail Branding": "ZAMOLXE",
    "Marketing Name": "ZXT-10HL323S",
    "Device": "ZXT-10HL323S",
    "Model": "ZXT-10HL323S"
  },
  {
    "Retail Branding": "ZBOE",
    "Marketing Name": "Interactive_Flat_Display",
    "Device": "t7_an400",
    "Model": "ZH600_Series"
  },
  {
    "Retail Branding": "ZCS(SZ)",
    "Marketing Name": "Z108",
    "Device": "Z108",
    "Model": "Z108"
  },
  {
    "Retail Branding": "ZCS(SZ)",
    "Marketing Name": "Z91",
    "Device": "Z91",
    "Model": "Z91"
  },
  {
    "Retail Branding": "ZCS(SZ)",
    "Marketing Name": "Z92",
    "Device": "Z92",
    "Model": "Z92"
  },
  {
    "Retail Branding": "ZDK(SZ)",
    "Marketing Name": "ZDKMP-T30A_ROW",
    "Device": "ZDKMP-T30A",
    "Model": "ZDKMP-T30A"
  },
  {
    "Retail Branding": "ZDK(SZ)",
    "Marketing Name": "ZDKMP-T30B_ROW",
    "Device": "ZDKMP-T30B",
    "Model": "ZDKMP-T30B"
  },
  {
    "Retail Branding": "ZEEKER",
    "Marketing Name": "ZEEKER_P10",
    "Device": "ZEEKER_P10",
    "Model": "ZEEKER P10"
  },
  {
    "Retail Branding": "ZEEKER",
    "Marketing Name": "ZEEKER_P10_EEA",
    "Device": "ZEEKER_P10",
    "Model": "ZEEKER P10"
  },
  {
    "Retail Branding": "ZEEKER",
    "Marketing Name": "ZEEKER_P10_RU",
    "Device": "ZEEKER_P10",
    "Model": "ZEEKER P10"
  },
  {
    "Retail Branding": "ZEEKER",
    "Marketing Name": "ZEEKER_T100",
    "Device": "ZEEKER_T100",
    "Model": "ZEEKER T100"
  },
  {
    "Retail Branding": "ZEEKER",
    "Marketing Name": "ZEEKER_T100_EEA",
    "Device": "ZEEKER_T100",
    "Model": "ZEEKER T100"
  },
  {
    "Retail Branding": "ZEEKER",
    "Marketing Name": "ZEEKER_T100_RU",
    "Device": "ZEEKER_T100",
    "Model": "ZEEKER T100"
  },
  {
    "Retail Branding": "ZEEPAD",
    "Marketing Name": "2QRK",
    "Device": "2QRK",
    "Model": "2QRK"
  },
  {
    "Retail Branding": "ZENOS",
    "Marketing Name": "ZENOS 4K Android TV",
    "Device": "kenton",
    "Model": "ZENOS 4K Android TV"
  },
  {
    "Retail Branding": "ZENTALITY",
    "Marketing Name": "C-601",
    "Device": "C-601",
    "Model": "C-601"
  },
  {
    "Retail Branding": "ZENTALITY",
    "Marketing Name": "C-700",
    "Device": "C-700",
    "Model": "C-700"
  },
  {
    "Retail Branding": "ZENTALITY",
    "Marketing Name": "C-705",
    "Device": "C-705",
    "Model": "C-705"
  },
  {
    "Retail Branding": "ZETATV",
    "Marketing Name": "Zeta TV TATU",
    "Device": "DV8545-C-KUT",
    "Model": "Zeta TV TATU"
  },
  {
    "Retail Branding": "ZIFFLER",
    "Marketing Name": "ABMS Android TV",
    "Device": "shinagawa",
    "Model": "ABMS Android TV"
  },
  {
    "Retail Branding": "ZIK (kz)",
    "Marketing Name": "ZIK_W1027",
    "Device": "ZIK_W1027",
    "Model": "ZIK_W1027"
  },
  {
    "Retail Branding": "ZIOVO",
    "Marketing Name": "Z118-EEA",
    "Device": "Z118-EEA",
    "Model": "Z118-EEA"
  },
  {
    "Retail Branding": "ZIOVO",
    "Marketing Name": "Z118-T-EEA",
    "Device": "Z118-T-EEA",
    "Model": "Z118-T-EEA"
  },
  {
    "Retail Branding": "ZIOVO",
    "Marketing Name": "Z118-T-US",
    "Device": "Z118-T-US",
    "Model": "Z118-T-US"
  },
  {
    "Retail Branding": "ZIOVO",
    "Marketing Name": "Z118-U-EEA",
    "Device": "Z118-U-EEA",
    "Model": "Z118-U-EEA"
  },
  {
    "Retail Branding": "ZIOVO",
    "Marketing Name": "Z118-U-EEA",
    "Device": "Z118-U-EEA",
    "Model": "Z118_EEA"
  },
  {
    "Retail Branding": "ZIOVO",
    "Marketing Name": "Z118-U-US",
    "Device": "Z118-U-US",
    "Model": "Z118-U-US"
  },
  {
    "Retail Branding": "ZIOVO",
    "Marketing Name": "Z118-U-US",
    "Device": "Z118-U-US",
    "Model": "Z118_US"
  },
  {
    "Retail Branding": "ZIOVO",
    "Marketing Name": "Z118-US",
    "Device": "Z118-US",
    "Model": "Z118-US"
  },
  {
    "Retail Branding": "ZIOVO",
    "Marketing Name": "Z128_EEA",
    "Device": "Z128_EEA",
    "Model": "Z128_EEA"
  },
  {
    "Retail Branding": "ZIOVO",
    "Marketing Name": "Z128_T_EEA",
    "Device": "Z128_T_EEA",
    "Model": "Z128_EEA"
  },
  {
    "Retail Branding": "ZIOVO",
    "Marketing Name": "Z128_T_EEA",
    "Device": "Z128_T_EEA",
    "Model": "Z128_T_EEA"
  },
  {
    "Retail Branding": "ZIOVO",
    "Marketing Name": "Z128_T_US",
    "Device": "Z128_T_US",
    "Model": "Z128_T_US"
  },
  {
    "Retail Branding": "ZIOVO",
    "Marketing Name": "Z128_T_US",
    "Device": "Z128_T_US",
    "Model": "Z128_US"
  },
  {
    "Retail Branding": "ZIOVO",
    "Marketing Name": "Z128_US",
    "Device": "Z128_US",
    "Model": "Z128_US"
  },
  {
    "Retail Branding": "ZIOVO",
    "Marketing Name": "Z138_EEA",
    "Device": "Z138_EEA",
    "Model": "Z138_EEA"
  },
  {
    "Retail Branding": "ZIOVO",
    "Marketing Name": "Z138_EU",
    "Device": "Z138_EU",
    "Model": "Z138_EU"
  },
  {
    "Retail Branding": "ZIOVO",
    "Marketing Name": "Z138_US",
    "Device": "Z138_US",
    "Model": "Z138_US"
  },
  {
    "Retail Branding": "ZIOVO",
    "Marketing Name": "Z138_V_EEA",
    "Device": "Z138_V_EEA",
    "Model": "Z138_V_EEA"
  },
  {
    "Retail Branding": "ZIOVO",
    "Marketing Name": "Z138_V_US",
    "Device": "Z138_V_US",
    "Model": "Z138_V_US"
  },
  {
    "Retail Branding": "ZIOVO",
    "Marketing Name": "Z138_W",
    "Device": "Z138_W",
    "Model": "Z138_W"
  },
  {
    "Retail Branding": "ZIOVO",
    "Marketing Name": "Z158_EEA",
    "Device": "Z158_EEA",
    "Model": "Z158_EEA"
  },
  {
    "Retail Branding": "ZIOVO",
    "Marketing Name": "Z158_US",
    "Device": "Z158_US",
    "Model": "Z158_US"
  },
  {
    "Retail Branding": "ZIOVO",
    "Marketing Name": "Z168-EU",
    "Device": "Z168-EU",
    "Model": "Z168-EU"
  },
  {
    "Retail Branding": "ZIOVO",
    "Marketing Name": "Z168-W",
    "Device": "Z168-W",
    "Model": "Z168-W"
  },
  {
    "Retail Branding": "ZIOVO",
    "Marketing Name": "Z168_EEA",
    "Device": "Z168_EEA",
    "Model": "Z168_EEA"
  },
  {
    "Retail Branding": "ZIOVO",
    "Marketing Name": "Z168_US",
    "Device": "Z168_US",
    "Model": "Z168_US"
  },
  {
    "Retail Branding": "ZIOVO",
    "Marketing Name": "Z168_U_EEA",
    "Device": "Z168_U_EEA",
    "Model": "Z168_U_EEA"
  },
  {
    "Retail Branding": "ZIOVO",
    "Marketing Name": "Z168_U_US",
    "Device": "Z168_U_US",
    "Model": "Z168_U_US"
  },
  {
    "Retail Branding": "ZKTeco",
    "Marketing Name": "Interactive_Whiteboard",
    "Device": "oversea_v",
    "Model": "SC02-I5"
  },
  {
    "Retail Branding": "ZLINE",
    "Marketing Name": "ZLINE_Z_742",
    "Device": "ZLINE_Z_742",
    "Model": "Z_742"
  },
  {
    "Retail Branding": "ZMBIZI",
    "Marketing Name": "ZMBIZI",
    "Device": "ZMBIZI_Z1",
    "Model": "ZMBIZI Z1"
  },
  {
    "Retail Branding": "ZMBIZI",
    "Marketing Name": "ZMBIZI Z2",
    "Device": "ZMBIZI_Z2",
    "Model": "ZMBIZI Z2"
  },
  {
    "Retail Branding": "ZMOOTH",
    "Marketing Name": "ZMOOTH ZTAB020",
    "Device": "Zkai-study-Tab",
    "Model": "ZTAB020"
  },
  {
    "Retail Branding": "ZOFYWNAS",
    "Marketing Name": "D10",
    "Device": "D10",
    "Model": "D10"
  },
  {
    "Retail Branding": "ZOFYWNAS",
    "Marketing Name": "D10_EEA",
    "Device": "D10",
    "Model": "D10"
  },
  {
    "Retail Branding": "ZOLON",
    "Marketing Name": "E0113",
    "Device": "E0113",
    "Model": "E0113"
  },
  {
    "Retail Branding": "ZOLON",
    "Marketing Name": "E0214",
    "Device": "E0214",
    "Model": "E0214"
  },
  {
    "Retail Branding": "ZOLON",
    "Marketing Name": "E0514",
    "Device": "E0514",
    "Model": "E0514"
  },
  {
    "Retail Branding": "ZOLON",
    "Marketing Name": "L161x",
    "Device": "L161X",
    "Model": "L161X"
  },
  {
    "Retail Branding": "ZOLON",
    "Marketing Name": "L16XX",
    "Device": "L16XX",
    "Model": "L16XX"
  },
  {
    "Retail Branding": "ZOLON",
    "Marketing Name": "M0315",
    "Device": "M11",
    "Model": "M11"
  },
  {
    "Retail Branding": "ZOLON",
    "Marketing Name": "M30",
    "Device": "M30",
    "Model": "M30"
  },
  {
    "Retail Branding": "ZOLON",
    "Marketing Name": "M50",
    "Device": "M50",
    "Model": "M50"
  },
  {
    "Retail Branding": "ZOLON",
    "Marketing Name": "M8100",
    "Device": "M8100",
    "Model": "M8100"
  },
  {
    "Retail Branding": "ZOLON",
    "Marketing Name": "M8100_EEA",
    "Device": "M8100",
    "Model": "M8100"
  },
  {
    "Retail Branding": "ZOLON",
    "Marketing Name": "M9200",
    "Device": "M9200",
    "Model": "M9200"
  },
  {
    "Retail Branding": "ZOLON",
    "Marketing Name": "M9200_ZLEEA",
    "Device": "M9200",
    "Model": "M9200"
  },
  {
    "Retail Branding": "ZOLON",
    "Marketing Name": "MP1x",
    "Device": "MP1x",
    "Model": "MP1x"
  },
  {
    "Retail Branding": "ZOLON",
    "Marketing Name": "MP1x_EEA",
    "Device": "MP1x",
    "Model": "MP1x"
  },
  {
    "Retail Branding": "ZONGHENGCA",
    "Marketing Name": "ZONGHENGCA_G8",
    "Device": "ZONGHENGCA",
    "Model": "ZONGHENGCA_G8"
  },
  {
    "Retail Branding": "ZONMAI",
    "Marketing Name": "MX2",
    "Device": "MX2",
    "Model": "MX2"
  },
  {
    "Retail Branding": "ZONMAI",
    "Marketing Name": "MX2_EEA",
    "Device": "MX2_EEA",
    "Model": "MX2_EEA"
  },
  {
    "Retail Branding": "ZOOMME",
    "Marketing Name": "M1",
    "Device": "M1",
    "Model": "M1"
  },
  {
    "Retail Branding": "ZOOMME",
    "Marketing Name": "M2",
    "Device": "M2",
    "Model": "M2"
  },
  {
    "Retail Branding": "ZOOMME",
    "Marketing Name": "M3",
    "Device": "M3",
    "Model": "M3"
  },
  {
    "Retail Branding": "ZOOMME",
    "Marketing Name": "M6",
    "Device": "M6",
    "Model": "M6"
  },
  {
    "Retail Branding": "ZOOMME",
    "Marketing Name": "Z1",
    "Device": "Z1",
    "Model": "Z1"
  },
  {
    "Retail Branding": "ZOOMSMART",
    "Marketing Name": "LT600T",
    "Device": "LT600T",
    "Model": "LT600T"
  },
  {
    "Retail Branding": "ZOOMSMART",
    "Marketing Name": "LT800",
    "Device": "LT800",
    "Model": "LT800"
  },
  {
    "Retail Branding": "ZOOMSMART",
    "Marketing Name": "ZM10_EEA",
    "Device": "ZM10",
    "Model": "ZM10"
  },
  {
    "Retail Branding": "ZOOMSMART",
    "Marketing Name": "ZM800_EEA",
    "Device": "ZM800",
    "Model": "ZM800"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "BUL_P726G",
    "Model": "ZTE-RACER"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "D930",
    "Model": "D930"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "Grand-S",
    "Model": "ZTE Grand S"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "N720",
    "Model": "N720"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "N720_Micromax",
    "Model": "Micromax A60"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "N721",
    "Model": "N721"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "N721",
    "Model": "ZTE-U N721"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "N721",
    "Model": "ZTE_U N721"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "N8010_CT",
    "Model": "ZXY-ZTE_N8010"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "N8010_CT_BL",
    "Model": "ZXY-ZTE_N8010"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "N8300_CT",
    "Model": "ZXY-ZTE N8300"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "NX501",
    "Model": "NX501"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "P117A11",
    "Model": "ZTE U807"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "P117A13",
    "Model": "ZTE U807N"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "P117A20qHD",
    "Model": "ZTE U817"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "P117A30",
    "Model": "ZTE U935"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "P253A20",
    "Model": "ZTE V768"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "P722G",
    "Model": "ZTE-U X876"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "P726CU",
    "Model": "ZTE-U X850"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "P726G",
    "Model": "ZTE-LINK"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "P726G",
    "Model": "ZTE-RACER"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "P726G",
    "Model": "ZTE-WAVE"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "P726N",
    "Model": "soft stone"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "P726N",
    "Model": "soft-stone"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "P726VV",
    "Model": "ZTE-U X850"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "P727A",
    "Model": "VF945"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "P729B",
    "Model": "Orange Tactile internet 2"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "P729C",
    "Model": "ZTE-BLADE"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "P810A10",
    "Model": "ZTE U880s2"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "P810T02",
    "Model": "ZTE U793"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "QB7211",
    "Model": "QB7211"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "QB7211",
    "Model": "STARTEXT II"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "T9",
    "Model": "ZTE-T T9"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "TWM_P726G",
    "Model": "Taiwan Mobile T2"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "U788",
    "Model": "ZTE U788"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "U790",
    "Model": "ZTE U790"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "U795",
    "Model": "ZTE U795"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "U805",
    "Model": "ZTE-T U805"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "U812",
    "Model": "ZTE-T U812"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "U830",
    "Model": "ZTE-T U830"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "U880E",
    "Model": "ZTE U880E"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "U880F1",
    "Model": "ZTE U880F1"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "U880s",
    "Model": "ZTE U880s"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "U885",
    "Model": "ZTE U885"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "U930HD",
    "Model": "ZTE U930HD"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "U960s",
    "Model": "ZTE-T U960s"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "U960s2",
    "Model": "ZTE U960s2"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "U960s3",
    "Model": "ZTE U960s3"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "V6020_Claro",
    "Model": "V6020_Claro"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "V66",
    "Model": "V66"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "V68",
    "Model": "V68"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "V71A",
    "Model": "STARTAB"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "V71A",
    "Model": "V71B"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "V768",
    "Model": "ZTE V768"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "V8100_Z55",
    "Model": "V8100_Z55"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "V8200_EE_UK",
    "Model": "V8200_EE_UK"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "V8200_OSK",
    "Model": "V8200-Memphis-orange-Slovakia"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "V8300_Z39",
    "Model": "V8300_Z39"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "V857",
    "Model": "ZTE-U V857"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "V875m",
    "Model": "ZTE-U V875m"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "X500",
    "Model": "X500"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "X500",
    "Model": "X500_USA_General"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "X500MMB",
    "Model": "ZTE-C X500"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "ZTE-Grand-S",
    "Model": "ZTE Grand S"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "ZTE-N5",
    "Model": "ZTE N5"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "ZTE-N807",
    "Model": "ZTE N807"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "ZTE-N880F",
    "Model": "ZTE N880F"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "ZTE-N881E",
    "Model": "ZTE N881E"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "ZTE-N881F",
    "Model": "ZTE N881F"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "ZTE-N980",
    "Model": "ZTE N980"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "ZTE-N988",
    "Model": "ZTE N988"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "ZTE-U-V889F",
    "Model": "ZTE-U V889F"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "ZTE-V72A",
    "Model": "V72A"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "ZTE-V889F",
    "Model": "ZTE V889F"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "ZTE-V955",
    "Model": "ZTE V955"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "ZTE-V956",
    "Model": "ZTE V956"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "ZTE-V988",
    "Model": "ZTE Grand S"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "ZTE-V988",
    "Model": "ZTE V988"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "amigo",
    "Model": "Android Edition Starnaute"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "arthur",
    "Model": "N860"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "atlas40",
    "Model": "Acqua"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "atlas40",
    "Model": "BLADE III"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "atlas40",
    "Model": "MEDION LIFE P4012"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "atlas40",
    "Model": "N880E"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "atlas40",
    "Model": "ZTE G882"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "atlas40",
    "Model": "ZTE N880E"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "atlas40",
    "Model": "ZTE N881D"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "atlas40",
    "Model": "ZTE N882E"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "atlas40",
    "Model": "ZTE R22"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "atlas40",
    "Model": "ZTE T22"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "atlas40",
    "Model": "ZTE V880E"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "atlas40",
    "Model": "ZTE V889D"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "banana",
    "Model": "ZTE-C N780"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "blade",
    "Model": "MegaFon SP-A5"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "blade",
    "Model": "V880"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "blade",
    "Model": "ZTE Libra"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "blade",
    "Model": "ZTE-BLADE"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "blade2",
    "Model": "ATLAS W"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "blade2",
    "Model": "BLADEII"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "blade2",
    "Model": "Blade S"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "blade2",
    "Model": "San Francisco II"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "bladeplus",
    "Model": "008Z"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "bladeplus",
    "Model": "V881"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "bladeplus",
    "Model": "ZTE V881"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "bladeplus",
    "Model": "ZTE-U V881"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "cardhu",
    "Model": "ZTE-T T98"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "crane-zte7",
    "Model": "K75"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "dana",
    "Model": "ZTE N970"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "deepblue",
    "Model": "ZTE N790"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "deepblue",
    "Model": "ZTE N790S"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "enterprise_HK",
    "Model": "ZTE Grand Era"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "enterprise_U950",
    "Model": "ZTE U950"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "enterprise_U985",
    "Model": "ZTE U985"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "enterprise_V985",
    "Model": "ZTE V985"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "frosty",
    "Model": "ZTE T82"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "hope",
    "Model": "N855D"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "hope",
    "Model": "N855D_PERFECTUM"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "hope",
    "Model": "N855D_YM"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "hope",
    "Model": "ZTE N855"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "hope",
    "Model": "ZTE N855D"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "hope",
    "Model": "ZTE N855D+"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "iliamna",
    "Model": "ZTE T81"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "joe",
    "Model": "V871"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "joe",
    "Model": "Vodafone 945"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "kiska",
    "Model": "ZTE V9800"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "mooncake2",
    "Model": "MTS-SP102"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "mooncake2",
    "Model": "Mtag 281"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "mooncake2",
    "Model": "ZTE N660"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "msm7627a",
    "Model": "ZTE N880F"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "msm7627a",
    "Model": "ZTE V889F"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "msm7627a",
    "Model": "ZTE-U V889F"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "msm7630_zteu960",
    "Model": "ZTE U960D"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "msm7630_zteu960",
    "Model": "ZTE-T U960"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "nice",
    "Model": "A21plus"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "nice",
    "Model": "ICE"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "nice",
    "Model": "KIS II"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "nice",
    "Model": "Orange Zali"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "nice",
    "Model": "Turkcell Maxi Plus 5"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "nice",
    "Model": "V880S"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "nice",
    "Model": "ZTE Kis Pro"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "okmok",
    "Model": "ZTE V9500"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "p173a10",
    "Model": "ZTE-U V760"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "r750",
    "Model": "ZTE-C R750"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "racer2",
    "Model": "ARIZONA"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "racer2",
    "Model": "Kyivstar Shine"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "racer2",
    "Model": "RACERII"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "racer2",
    "Model": "RacerII"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "racer2",
    "Model": "Turkcell T11"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "racer2",
    "Model": "ZTE-U V859"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "roamer",
    "Model": "ZTE Roamer"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "roamer",
    "Model": "ZTE roamer"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "roamer",
    "Model": "ZTE-C N760"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "roamer2",
    "Model": "Dubai"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "roamer2",
    "Model": "Dublin"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "roamer2",
    "Model": "N788_BASHA"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "roamer2",
    "Model": "Orange Dublin"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "roamer2",
    "Model": "V788D"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "roamer2",
    "Model": "ZTE N788"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "roamer2",
    "Model": "ZTE N789"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "roamer2",
    "Model": "ZTE V788D"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "roundtop",
    "Model": "ZTE V9800"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "sailboat",
    "Model": "ZTE V875"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "sean",
    "Model": "N850"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "skate",
    "Model": "KPN Smart 200"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "skate",
    "Model": "MEDION LIFE P4310"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "skate",
    "Model": "Monte Carlo"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "skate",
    "Model": "Optimus Monte Carlo"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "skate",
    "Model": "Orange Monte Carlo"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "skate",
    "Model": "ZTE N960"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "skate",
    "Model": "ZTE Skate"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "skate",
    "Model": "ZTE V960"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "skate",
    "Model": "ZTE-SKATE"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "skate",
    "Model": "ZTE-Skate"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "skate",
    "Model": "ZTE-U V960"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "skateplus",
    "Model": "Skate4.3 H"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "turies",
    "Model": "Android Edition StarText"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "turies",
    "Model": "Vodafone Smart Chat"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "turies",
    "Model": "ZTE-Tureis"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "v9plus",
    "Model": "BASE Tab 7.1"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "v9plus",
    "Model": "Light Tab 2"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "v9plus",
    "Model": "Light Tab 2W"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "v9plus",
    "Model": "MegaFon V9+"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "v9plus",
    "Model": "TT102"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "v9plus",
    "Model": "Telenor Touch Pad"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "v9plus",
    "Model": "V9+"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "v9plus",
    "Model": "V9A"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "v9plus",
    "Model": "V9e+"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "v9plus",
    "Model": "ZTE V10"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "v9plus",
    "Model": "ZTE V9A"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "ventana",
    "Model": "ZTE U970"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "ventana_U880F",
    "Model": "ZTE U880F"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "ventana_U930",
    "Model": "ZTE U930"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "warp2",
    "Model": "N861"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "whistler",
    "Model": "STARADDICT II"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "whistler",
    "Model": "V961"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "whistler",
    "Model": "ZTE Grand X"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "whistler",
    "Model": "ZTE V970T"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "whistler",
    "Model": "ZTE-Mimosa X"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "z788",
    "Model": "ZTE U788+"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "z795",
    "Model": "ZTE U795+"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "",
    "Device": "zte_v857",
    "Model": "ZTE-U V857"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "009Z",
    "Device": "bladeplus",
    "Model": "009Z"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "009Z",
    "Device": "bladeplus",
    "Model": "ZTE V882"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "009Z",
    "Device": "bladeplus",
    "Model": "ZTE V886J"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "402ZT",
    "Device": "ZTE-402ZT",
    "Model": "402ZT"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "5G UG Phone U23",
    "Device": "P720F02",
    "Model": "5G UG Phone U23"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "5G UG Phone U23",
    "Device": "P720F02",
    "Model": "ZTE 7160N"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "5G UG Phone U25",
    "Device": "P720F09_U",
    "Model": "5G UG Phone U25"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "5G UG Phone U26",
    "Device": "P720F11UG",
    "Model": "5G UG Phone U26"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "5G UG Tablet T26",
    "Device": "P720T01",
    "Model": "5G UG Tablet T26"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "901ZT",
    "Device": "P450A01",
    "Model": "901ZT"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "902ZT",
    "Device": "Z8851S",
    "Model": "902ZT"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "A001ZT",
    "Device": "Z6202S",
    "Model": "A001ZT"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "A003ZT",
    "Device": "Z6650S",
    "Model": "A003ZT"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "A1 Alpha",
    "Device": "P963F01D",
    "Model": "A1 Alpha"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "A103ZT",
    "Device": "Z6571S",
    "Model": "A103ZT"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "A1P",
    "Device": "ailsa",
    "Model": "A1P"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "A1R",
    "Device": "billy",
    "Model": "A1"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "A1R",
    "Device": "billy",
    "Model": "A1R"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "A2",
    "Device": "A2",
    "Model": "A2"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "A2015",
    "Device": "msm8994",
    "Model": "ZTE A2015"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "A2016",
    "Device": "msm8994",
    "Model": "ZTE A2016"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "A2017",
    "Device": "ailsa_ii",
    "Model": "ZTE A2017"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "A2017G",
    "Device": "ailsa_ii",
    "Model": "ZTE A2017G"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "A2017U",
    "Device": "ailsa_ii",
    "Model": "ZTE A2017U"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "A2018",
    "Device": "candice",
    "Model": "ZTE A2018"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "A202ZT",
    "Device": "Z6575S",
    "Model": "A202ZT"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "A302ZT",
    "Device": "Z6561S",
    "Model": "A302ZT"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "A303ZT",
    "Device": "Z6576S",
    "Model": "A303ZT"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "A402ZT",
    "Device": "Z5501S",
    "Model": "A402ZT"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "A403ZT",
    "Device": "Z6701S",
    "Model": "A403ZT"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "A404ZT",
    "Device": "Z8900S",
    "Model": "A404ZT"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "A404ZT",
    "Device": "Z8900S",
    "Model": "NX732J"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "A504ZT",
    "Device": "Z6301S",
    "Model": "A504ZT"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "A505ZT",
    "Device": "Z8700S",
    "Model": "A505ZT"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "A506ZT",
    "Device": "Z6302S",
    "Model": "A506ZT"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "A880",
    "Device": "ZTE-A880",
    "Model": "ZTE A880"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ACT",
    "Device": "B860H_V1",
    "Model": "B860H"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "AV-ATB100",
    "Device": "B800S2_V1",
    "Model": "AV-ATB100"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "AXON 7 mini",
    "Device": "msm8952_64",
    "Model": "AXON 7 mini"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "AXON WATCH",
    "Device": "rolex",
    "Model": "AXON WATCH"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "AXON WATCH",
    "Device": "rolex",
    "Model": "ZTE W1010"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Amazing A1",
    "Device": "roamer2",
    "Model": "Amazing A1"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Amazing A30",
    "Device": "P809F20",
    "Model": "Amazing A30"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Amazing A50",
    "Device": "P637F02",
    "Model": "Amazing A50"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Amazing P6",
    "Device": "msm8226",
    "Model": "Amazing P6"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Amazing X2",
    "Device": "msm8226",
    "Model": "Amazing X2"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Amazing X5s",
    "Device": "ZTE_T620",
    "Model": "Amazing X5s"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Amazing X6",
    "Device": "P839F30",
    "Model": "Amazing X6"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Amazing X7",
    "Device": "P839V56",
    "Model": "Amazing X7"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Amazing p5_Lite",
    "Device": "V77",
    "Model": "Amazing p5_Lite"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Amazing_X3s",
    "Device": "Amazing_X3s",
    "Model": "Amazing_X3s"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Amazing_X3s_16G",
    "Device": "Amazing_X3s",
    "Model": "Amazing_X3s_16G"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Android edition by sfr STARADDICT",
    "Device": "skate",
    "Model": "Android edition by sfr STARADDICT"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Andromax G46D1Z",
    "Device": "Andromax_G46D1Z",
    "Model": "Andromax G46D1Z"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Avea inTouch 2",
    "Device": "atlas40",
    "Model": "Avea inTouch 2"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Avea inTouch 4",
    "Device": "msm8916_32",
    "Model": "Avea inTouch 4"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Avea inTouch 4",
    "Device": "msm8916_32",
    "Model": "ZTE Blade V220"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Avid Slate",
    "Device": "K82",
    "Model": "K82"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Axon 10 Pro 5G",
    "Device": "P855A21",
    "Model": "ZTE A2020N2 Pro"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "B2015",
    "Device": "msm8916_64",
    "Model": "ZTE B2015"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "B2016",
    "Device": "msm8916_64",
    "Model": "ZTE B2016"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "B2017G",
    "Device": "msm8952_64",
    "Model": "ZTE B2017G"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "B2017G",
    "Device": "tulip",
    "Model": "ZTE B2017G"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "B2017G",
    "Device": "verdandi",
    "Model": "ZTE B2017G"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "B760E",
    "Device": "ztemt85_bx_kk",
    "Model": "B760E"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "B760E",
    "Device": "ztemt85_bx_kk",
    "Model": "B760H"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "B790",
    "Device": "roamer2",
    "Model": "ZTE B790"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "B860AV2",
    "Device": "p200_2G",
    "Model": "B860AV2"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "B860H",
    "Device": "B860H_V1",
    "Model": "B860H"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "B860H",
    "Device": "B860H_V1",
    "Model": "B860H V1.0"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "B860H",
    "Device": "B860H_V1",
    "Model": "B860H V1.1"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "B866",
    "Device": "B866_ZTE",
    "Model": "B866"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "B880",
    "Device": "P635N30",
    "Model": "ZTE B880"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "B880",
    "Device": "S_P635N30",
    "Model": "ZTE B880"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "BA510",
    "Device": "P635T39",
    "Model": "ZTE BA510"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "BA520",
    "Device": "P637T10",
    "Model": "ZTE BA520"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "BA601",
    "Device": "ZTE_BA601",
    "Model": "ZTE BA601"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "BA602",
    "Device": "P637S02",
    "Model": "ZTE BA602"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "BA602T",
    "Device": "P637T02",
    "Model": "ZTE BA602T"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "BA603",
    "Device": "P809S10",
    "Model": "ZTE BA603"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "BA610C",
    "Device": "P635N36",
    "Model": "ZTE BA610C"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "BA610T",
    "Device": "P635T36",
    "Model": "ZTE BA610T"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "BA610T",
    "Device": "V_P635T36",
    "Model": "ZTE BA610T"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "BA611C",
    "Device": "P635N40",
    "Model": "ZTE BA611C"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "BA611T",
    "Device": "P635T40",
    "Model": "ZTE BA611T"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "BA611T",
    "Device": "V_P635T40",
    "Model": "ZTE BA611T"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "BA910",
    "Device": "P653N31",
    "Model": "ZTE BA910"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "BA910",
    "Device": "V_P653N31",
    "Model": "ZTE BA910"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "BA910T",
    "Device": "T_P653N31",
    "Model": "ZTE BA910T"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "BASE Lutea 2",
    "Device": "skate",
    "Model": "BASE Lutea 2"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "BBC100-1",
    "Device": "BBC100_1",
    "Model": "BBC100-1"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "BGH Joy X5",
    "Device": "ZTE_Blade_V580",
    "Model": "BGH Joy X5"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "BLADE",
    "Device": "blade",
    "Model": "ZTE-BLADE"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "BLADE A110",
    "Device": "ZTE_BLADE_A110",
    "Model": "BLADE A110"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "BLADE A110",
    "Device": "ZTE_BLADE_A110",
    "Model": "ZTE BLADE A110"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "BLADE A112",
    "Device": "P635A60",
    "Model": "ZTE BLADE A112"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "BLADE A3",
    "Device": "P809F40",
    "Model": "BLADE A3"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "BLADE A310",
    "Device": "P809A50",
    "Model": "Blade A310"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "BLADE A310",
    "Device": "P809A50",
    "Model": "ZTE BLADE A310"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "BLADE A320",
    "Device": "P809F20",
    "Model": "BLADE A320"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "BLADE A320",
    "Device": "P809F20",
    "Model": "ZTE BLADE A320"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "BLADE A506",
    "Device": "P809F52",
    "Model": "ZTE BLADE A506"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "BLADE A510",
    "Device": "P635A50",
    "Model": "BLADE A510"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "BLADE A510",
    "Device": "P635A50",
    "Model": "Blade A510"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "BLADE A510",
    "Device": "P635A50",
    "Model": "ZTE BLADE A510"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "BLADE A512",
    "Device": "P817E52",
    "Model": "ZTE BLADE A512"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "BLADE A512",
    "Device": "P817E52",
    "Model": "ZTE Z10"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "BLADE A520",
    "Device": "P637F10",
    "Model": "BLADE A520"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "BLADE A520",
    "Device": "P637F10",
    "Model": "ZTE BLADE A520"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "BLADE A521",
    "Device": "P809F10",
    "Model": "BLADE A521"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "BLADE A521",
    "Device": "P809F10",
    "Model": "ZTE BLADE A521"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "BLADE A530",
    "Device": "P639F10",
    "Model": "BLADE A530"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "BLADE A530",
    "Device": "P639F10L",
    "Model": "BLADE A530"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "BLADE A6",
    "Device": "P840F13",
    "Model": "BLADE A6"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "BLADE A6 MAX",
    "Device": "P809F15",
    "Model": "BLADE A6 MAX"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "BLADE A601",
    "Device": "ZTE_BLADE_A601",
    "Model": "ZTE BLADE A601"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "BLADE A602",
    "Device": "P637F02",
    "Model": "BLADE A602"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "BLADE A602",
    "Device": "P637F02",
    "Model": "ZTE BLADE A602"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "BLADE A610",
    "Device": "ZTE_BLADE_A610",
    "Model": "BLADE A610"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "BLADE A610",
    "Device": "ZTE_BLADE_A610",
    "Model": "ZTE BLADE A610"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "BLADE A610C",
    "Device": "P635F50",
    "Model": "ZTE BLADE A610C"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "BLADE A612",
    "Device": "P635F50",
    "Model": "ZTE BLADE A612"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "BLADE A910",
    "Device": "P635A31",
    "Model": "BLADE A910"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "BLADE A910",
    "Device": "P635A31",
    "Model": "ZTE BLADE A910"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "BLADE B112",
    "Device": "P635A60",
    "Model": "ZTE BLADE B112"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "BLADE III",
    "Device": "atlas40",
    "Model": "Skate Pro"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "BLADE III",
    "Device": "atlas40",
    "Model": "ZTE BLADE III"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "BLADE III",
    "Device": "atlas40",
    "Model": "ZTE Blade III"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "BLADE III_IL",
    "Device": "atlas40",
    "Model": "BLADE III_IL"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "BLADE L0510",
    "Device": "P680A20",
    "Model": "ZTE BLADE L0510"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "BLADE L0510",
    "Device": "P680A20",
    "Model": "ZTE Blade L5 Plus"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "BLADE L110",
    "Device": "ZTE_BLADE_L110",
    "Model": "Blade L110"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "BLADE L110",
    "Device": "ZTE_BLADE_L110",
    "Model": "ZTE BLADE L110"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "BLADE L111",
    "Device": "ZTE_BLADE_L110",
    "Model": "ZTE BLADE L111"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "BLADE L5 PLUS",
    "Device": "P680A20",
    "Model": "ZTE BLADE L5 PLUS"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "BLADE L7",
    "Device": "P731F10",
    "Model": "BLADE L7"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "BLADE L7",
    "Device": "P731F10",
    "Model": "ZTE BLADE L7"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "BLADE L7A",
    "Device": "P731F12",
    "Model": "BLADE L7A"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "BLADE V Ultra",
    "Device": "P840T22",
    "Model": "BLADE V Ultra"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "BLADE V0710",
    "Device": "ZTE_BLADE_V0710",
    "Model": "ZTE BLADE V0710"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "BLADE V0720",
    "Device": "ZTE_BLADE_V0720",
    "Model": "ZTE BLADE V0720"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "BLADE V0730",
    "Device": "ZTE_BLADE_V0730",
    "Model": "ZTE BLADE V0730"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "BLADE V0800",
    "Device": "ZTE_BLADE_V0800",
    "Model": "ZTE BLADE V0800"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "BLADE V0820",
    "Device": "ZTE_BLADE_V0820",
    "Model": "ZTE BLADE V0820"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "BLADE V0850",
    "Device": "ZTE_BLADE_V0850",
    "Model": "ZTE BLADE V0850"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "BLADE V7",
    "Device": "P653A10",
    "Model": "BLADE V7"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "BLADE V7",
    "Device": "P653A10",
    "Model": "ZTE BLADE V7"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "BLADE V7 LITE",
    "Device": "ZTE_BLADE_V0720",
    "Model": "ZTE BLADE V0720"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "BLADE V7 LITE",
    "Device": "ZTE_BLADE_V0720",
    "Model": "ZTE BLADE V7 LITE"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "BLADE V7 PLUS",
    "Device": "P653A11",
    "Model": "ZTE BLADE V7 PLUS"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "BLADE V8",
    "Device": "ZTE_BLADE_V0800",
    "Model": "BLADE V8"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "BLADE V8 MINI",
    "Device": "ZTE_BLADE_V0850",
    "Model": "BLADE V8 MINI"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "BLADE V8 MINI",
    "Device": "ZTE_BLADE_V0850",
    "Model": "ZTE BLADE V8 MINI"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "BLADE V8 SE",
    "Device": "ZTE_BLADE_V0820",
    "Model": "BLADE V8 SE"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "BLADE V8 mini",
    "Device": "ZTE_BLADE_V0850",
    "Model": "BLADE V8 mini"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "BLADE V8Q",
    "Device": "P817F01",
    "Model": "BLADE V8Q"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "BLADE V9",
    "Device": "P450L10",
    "Model": "BLADE V9"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "BLADE V9 VITA",
    "Device": "P840F03",
    "Model": "BLADE V9 VITA"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "BOLTON",
    "Device": "bolton",
    "Model": "N9560"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "BV0701",
    "Device": "P653N11",
    "Model": "ZTE BV0701"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "BV0701",
    "Device": "P653N11",
    "Model": "ZTE V0721"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "BV0710",
    "Device": "P655A30",
    "Model": "ZTE BV0710"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "BV0710T",
    "Device": "P655A30",
    "Model": "ZTE BV0710T"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "BV0720",
    "Device": "P650A30",
    "Model": "ZTE BV0720"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "BV0720T",
    "Device": "P650A30",
    "Model": "ZTE BV0720T"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "BV0730",
    "Device": "P650A31",
    "Model": "ZTE BV0730"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "BV0800",
    "Device": "P840S10",
    "Model": "ZTE BV0800"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "BV0850",
    "Device": "P840S01",
    "Model": "ZTE BV0850"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Baker",
    "Device": "ZTE-Baker",
    "Model": "Baker"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Beeline E600",
    "Device": "roamer2",
    "Model": "Beeline E600"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Beeline Smart 2",
    "Device": "P172R10",
    "Model": "Beeline Smart 2"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Blade",
    "Device": "blade",
    "Model": "003Z"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Blade",
    "Device": "blade",
    "Model": "Android Edition StarTrail"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Blade",
    "Device": "blade",
    "Model": "BASE lutea"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Blade",
    "Device": "blade",
    "Model": "BLADE_N880"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Blade",
    "Device": "blade",
    "Model": "Beeline E400"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Blade",
    "Device": "blade",
    "Model": "Kyivstar Spark"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Blade",
    "Device": "blade",
    "Model": "MF8604"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Blade",
    "Device": "blade",
    "Model": "Movistar Prime"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Blade",
    "Device": "blade",
    "Model": "N880"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Blade",
    "Device": "blade",
    "Model": "Netphone 701"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Blade",
    "Device": "blade",
    "Model": "Optimus San Francisco"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Blade",
    "Device": "blade",
    "Model": "Orange San Francisco"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Blade",
    "Device": "blade",
    "Model": "Orange Tactile internet 2"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Blade",
    "Device": "blade",
    "Model": "RTK V8"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Blade",
    "Device": "blade",
    "Model": "San Francisco"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Blade",
    "Device": "blade",
    "Model": "V8502"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Blade",
    "Device": "blade",
    "Model": "WayteQ Libra"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Blade",
    "Device": "blade",
    "Model": "XCD35"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Blade",
    "Device": "blade",
    "Model": "ZTE Libra"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Blade",
    "Device": "blade",
    "Model": "ZTE V880"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Blade",
    "Device": "blade",
    "Model": "ZTE-BLADE"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Blade",
    "Device": "blade",
    "Model": "ZTE-C N880S"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Blade",
    "Device": "blade",
    "Model": "ZTE-LIBRA"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Blade",
    "Device": "blade",
    "Model": "ZTE-Libra"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Blade",
    "Device": "blade",
    "Model": "ZTE-U V880"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Blade",
    "Device": "blade",
    "Model": "a5"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Blade A210",
    "Device": "ZTE_Blade_A210",
    "Model": "ZTE BLADE A210"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Blade A210",
    "Device": "ZTE_Blade_A210",
    "Model": "ZTE Blade A210"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Blade A3 2019",
    "Device": "Z3051T",
    "Model": "Blade A3 2019"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Blade A3 2019",
    "Device": "Z3051T",
    "Model": "Blade A3 2019-T"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Blade A3 Plus",
    "Device": "Z3102T",
    "Model": "Blade A3 Plus"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Blade A3 SE",
    "Device": "Z3101T",
    "Model": "Blade A3 SE"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Blade A30",
    "Device": "Z3052T",
    "Model": "Blade A30"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Blade A31",
    "Device": "Z5351T",
    "Model": "Blade A31"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Blade A315",
    "Device": "ZTE_Blade_A315",
    "Model": "ZTE Blade A315"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Blade A410",
    "Device": "P635E40",
    "Model": "Blade A410"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Blade A410",
    "Device": "P635E40",
    "Model": "ZTE Blade A410"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Blade A452",
    "Device": "P635F33",
    "Model": "NOS FIVE"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Blade A452",
    "Device": "P635F33",
    "Model": "ZTE Blade A452"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Blade A460",
    "Device": "P809A20",
    "Model": "A460-T"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Blade A460",
    "Device": "P809A20",
    "Model": "Blade A460"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Blade A460",
    "Device": "P809A20",
    "Model": "ZTE BLADE A460"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Blade A460",
    "Device": "P809A20",
    "Model": "ZTE Blade A460"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Blade A460",
    "Device": "P809A20",
    "Model": "ZTE T610"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Blade A462",
    "Device": "P809A50",
    "Model": "ZTE Blade A462"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Blade A465",
    "Device": "ZTE_Blade_A465",
    "Model": "Blade A465"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Blade A465",
    "Device": "ZTE_Blade_A465",
    "Model": "ZTE Blade A465"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Blade A470",
    "Device": "P809A40",
    "Model": "ZTE Blade A470"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Blade A475",
    "Device": "ZTE_Blade_A475",
    "Model": "BGH JOY X2"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Blade A475",
    "Device": "ZTE_Blade_A475",
    "Model": "Blade A475"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Blade A475",
    "Device": "ZTE_Blade_A475",
    "Model": "ZTE Blade A475"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Blade A475",
    "Device": "ZTE_Blade_A475",
    "Model": "ZTE Blade L4 Pro"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Blade A476",
    "Device": "ZTE_Blade_A476",
    "Model": "BLADE E01"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Blade A476",
    "Device": "ZTE_Blade_A476",
    "Model": "ZTE Blade A476"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Blade A5 2019-T",
    "Device": "Z5155T",
    "Model": "Blade A5 2019-T"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Blade A51",
    "Device": "P963F60",
    "Model": "Blade A51"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Blade A510",
    "Device": "P635A50",
    "Model": "Blade A510"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Blade A510",
    "Device": "ZTE_BLADE_A601",
    "Model": "ZTE BLADE A601"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Blade A511",
    "Device": "ZTE_Blade_A511",
    "Model": "Blade A511"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Blade A511",
    "Device": "ZTE_Blade_A511",
    "Model": "ZTE Blade A511"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Blade A515",
    "Device": "ZTE_Blade_A511",
    "Model": "ZTE Blade A515"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Blade A52 Pro",
    "Device": "Z5201T",
    "Model": "Blade A52 Pro"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Blade A570",
    "Device": "ZTE_T617",
    "Model": "ZTE Blade A570"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Blade A7 2019-T",
    "Device": "Z6100T",
    "Model": "Blade A7 2019-T"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Blade A7S 2020-T",
    "Device": "Z6350T",
    "Model": "Blade A7S 2020-T"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Blade Apex",
    "Device": "coeus",
    "Model": "Blade Apex"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Blade Apex",
    "Device": "oceanus",
    "Model": "ZTE Blade Apex"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Blade Apex2",
    "Device": "msm8226",
    "Model": "Blade Apex2"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Blade Apex2",
    "Device": "msm8226",
    "Model": "ZTE Blade Apex2"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Blade Apex3",
    "Device": "msm8916_32",
    "Model": "ZTE Blade Apex3"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Blade C312",
    "Device": "P715A20",
    "Model": "ZTE Blade C312"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Blade C340",
    "Device": "P172R12",
    "Model": "ZTE Blade C340"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Blade C340",
    "Device": "P172R12",
    "Model": "ZTE T220"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Blade C340",
    "Device": "P172R12",
    "Model": "ZTE V812"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Blade C370",
    "Device": "ZTE_Blade_C370",
    "Model": "NOS NOVU"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Blade C370",
    "Device": "ZTE_Blade_C370",
    "Model": "ZTE BLADE C370"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Blade C370",
    "Device": "ZTE_Blade_C370",
    "Model": "ZTE Blade C370"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Blade D6 Lite 3G",
    "Device": "P658A10",
    "Model": "ZTE Blade D6 Lite 3G"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Blade D6 Lite 4G",
    "Device": "P635A30",
    "Model": "ZTE Blade D6 Lite 4G"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Blade Force",
    "Device": "warp8",
    "Model": "N9517"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Blade G",
    "Device": "ZTE-Blade-G",
    "Model": "ZTE Blade G"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Blade G LTE",
    "Device": "coeus",
    "Model": "ZTE Blade G LTE"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Blade G LTE",
    "Device": "oceanus",
    "Model": "Blade G LTE"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Blade G Lux",
    "Device": "P172F10",
    "Model": "BGH Joy Smart A6"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Blade G Lux",
    "Device": "P172F10",
    "Model": "BGH Joy Smart A6d"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Blade G Lux",
    "Device": "P172F10",
    "Model": "Blade G Lux"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Blade G Lux",
    "Device": "P172F10",
    "Model": "DIGICEL DL800"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Blade G Lux",
    "Device": "P172F10",
    "Model": "MEO Smart A40"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Blade G Lux",
    "Device": "P172F10",
    "Model": "Orange Tado"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Blade G Lux",
    "Device": "P172F10",
    "Model": "ZTE Blade G Lux"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Blade G Lux",
    "Device": "P172F10",
    "Model": "ZTE Kis3 max"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Blade G Lux",
    "Device": "P172F10",
    "Model": "ZTE V830W"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Blade HN",
    "Device": "ZTE_Blade_HN",
    "Model": "ZTE Blade HN"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Blade III",
    "Device": "atlas40",
    "Model": "Blade III"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Blade III",
    "Device": "atlas40",
    "Model": "Skate Pro"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Blade III",
    "Device": "atlas40",
    "Model": "ZTE Blade III"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Blade III Pro",
    "Device": "Blade-III-Pro",
    "Model": "ZTE Blade III Pro"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Blade L110",
    "Device": "ZTE_BLADE_L110",
    "Model": "Blade L110"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Blade L110",
    "Device": "ZTE_BLADE_L110",
    "Model": "ZTE Blade L110"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Blade L2",
    "Device": "P182A10",
    "Model": "BGH Joy Smart AXS"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Blade L2",
    "Device": "P182A10",
    "Model": "BGH Joy Smart AXS D"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Blade L2",
    "Device": "P182A10",
    "Model": "Blade L2"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Blade L2",
    "Device": "P182A10",
    "Model": "MEO Smart A75"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Blade L2",
    "Device": "P182A10",
    "Model": "ZTE Blade L2"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Blade L2 Plus",
    "Device": "ZTE_Blade_L2_PLUS",
    "Model": "Blade L2 Plus"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Blade L3",
    "Device": "P182A20",
    "Model": "Blade L3"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Blade L3",
    "Device": "P182A20",
    "Model": "DIGICEL DL910"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Blade L3",
    "Device": "P182A20",
    "Model": "MEO Smart A80"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Blade L3",
    "Device": "P182A20",
    "Model": "X8607"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Blade L3",
    "Device": "P182A20",
    "Model": "ZTE Blade L3"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Blade L3 Apex",
    "Device": "ZTE_Blade_L3_Apex",
    "Model": "ZTE Blade L3 Apex"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Blade L3 Lite",
    "Device": "P172A50",
    "Model": "Blade L3 Lite"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Blade L3 Lite",
    "Device": "P172A50",
    "Model": "ZTE Blade L3 Lite"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Blade L3 Plus",
    "Device": "Blade_L3_Plus",
    "Model": "Blade L3 Plus"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Blade L3 Plus",
    "Device": "ZTE_Blade_L3_Plus",
    "Model": "ZTE Blade L3 Plus"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Blade L315",
    "Device": "ZTE_Blade_L315",
    "Model": "ZTE Blade L315"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Blade L370",
    "Device": "ZTE_Blade_C370",
    "Model": "ZTE Blade L370"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Blade L5",
    "Device": "P172A40",
    "Model": "Blade L5"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Blade L5",
    "Device": "P172A40",
    "Model": "ZTE Blade L5"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Blade L5 Plus",
    "Device": "P680A20",
    "Model": "Blade L5 Plus"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Blade L5 Plus",
    "Device": "P680A20",
    "Model": "ZTE Blade L5 Plus"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Blade L6",
    "Device": "P680A10",
    "Model": "ZTE Blade L6"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Blade L6",
    "Device": "P680A10",
    "Model": "ZTE Blade V6 Lite"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Blade Q Lux",
    "Device": "P632A10",
    "Model": "BGH Joy Smart A7G"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Blade Q Lux",
    "Device": "P632A10",
    "Model": "Beeline Pro"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Blade Q Lux",
    "Device": "P632A10",
    "Model": "UZTE Blade Q Lux"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Blade Q Lux",
    "Device": "P632A10",
    "Model": "ZTE Blade A430"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Blade Q Lux",
    "Device": "P632A10",
    "Model": "ZTE Blade Q Lux"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Blade Q Lux",
    "Device": "P632A10",
    "Model": "ZTE Blade Q Lux 3G"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Blade Q Lux",
    "Device": "P632A10",
    "Model": "ZTE Fit 4G Smart"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Blade Q Lux",
    "Device": "P632A10",
    "Model": "ZTE T311"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Blade Q Lux",
    "Device": "P816A12",
    "Model": "Blade Q Lux"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Blade Q Lux",
    "Device": "P816A12",
    "Model": "ZTE Blade Q Lux"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Blade Q Mini",
    "Device": "P172G10_UK_VIRGIN",
    "Model": "ZTE Blade Q Mini"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Blade Q2",
    "Device": "P172A12",
    "Model": "Blade Q2"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Blade Q3",
    "Device": "P731A30",
    "Model": "ZTE Blade Q3"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Blade Q3",
    "Device": "P731A30",
    "Model": "ZTE T230"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Blade S",
    "Device": "P839F30",
    "Model": "Blade S"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Blade S",
    "Device": "blade2",
    "Model": "Blade S"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Blade S Lite",
    "Device": "P839F30",
    "Model": "Blade S Lite"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Blade S6",
    "Device": "P839F30",
    "Model": "Blade S6"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Blade S6",
    "Device": "P839F30",
    "Model": "LS-5008"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Blade S6",
    "Device": "P839F30",
    "Model": "NOS SLIM"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Blade S6 Flex",
    "Device": "P839T60",
    "Model": "ZTE Blade S6 Flex"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Blade S6 Lite",
    "Device": "P839F30",
    "Model": "Blade S6"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Blade S6 Lite",
    "Device": "P839F30",
    "Model": "Blade S6 Lite"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Blade S6 Lite",
    "Device": "P839F30",
    "Model": "ZTE T912"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Blade S6 Plus",
    "Device": "P839F50",
    "Model": "Blade S6 Plus"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Blade V",
    "Device": "ZTE-Blade-V",
    "Model": "Vodafone Blade V"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Blade V",
    "Device": "ZTE-Blade-V",
    "Model": "ZTE Blade V"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Blade V+",
    "Device": "P816A12",
    "Model": "Blade V+"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Blade V2",
    "Device": "msm8916_32",
    "Model": "ZTE Blade V2"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Blade V220",
    "Device": "msm8916_32",
    "Model": "ZTE Blade V220"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Blade V580",
    "Device": "ZTE_Blade_V580",
    "Model": "Blade V580"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Blade V580",
    "Device": "ZTE_Blade_V580",
    "Model": "Turk Telekom TT175"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Blade V580",
    "Device": "ZTE_Blade_V580",
    "Model": "ZTE Blade V580"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Blade V6",
    "Device": "P635A20",
    "Model": "BGH Joy V6"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Blade V6",
    "Device": "P635A20",
    "Model": "Blade V6"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Blade V6",
    "Device": "P635A20",
    "Model": "ZTE Blade V6"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Blade V6",
    "Device": "P635A20",
    "Model": "ZTE T660"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Blade V6",
    "Device": "P635A20",
    "Model": "ZTE T663"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Blade V6 Max",
    "Device": "ZTE_BLADE_A610",
    "Model": "Blade V6 Max"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Blade V6 Plus",
    "Device": "ZTE_BLADE_V0720",
    "Model": "Blade V6 Plus"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Blade V6 Plus",
    "Device": "ZTE_BLADE_V0720",
    "Model": "ZTE Blade V6 Plus"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Blade V770",
    "Device": "P852F52",
    "Model": "ZTE Blade V770"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Blade VEC",
    "Device": "P692S20_Q82",
    "Model": "ZTE Blade VEC"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Blade Vec",
    "Device": "P692S20_Q82",
    "Model": "Blade Vec"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Blade Vec",
    "Device": "P692S20_Q82",
    "Model": "ZTE Blade Vec"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Blade Vec",
    "Device": "P692S20_Q82",
    "Model": "ZTE Geek 2"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Blade Vec 4G",
    "Device": "msm8226",
    "Model": "ZTE Blade Vec 4G"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Blade Vec Pro",
    "Device": "P692S20_M92",
    "Model": "ZTE Blade Vec Pro"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Blade X Max",
    "Device": "stollen",
    "Model": "Z983"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Blade X1 5G",
    "Device": "Z6750",
    "Model": "Z6750M"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Blade X2 Max",
    "Device": "Z6400",
    "Model": "Z6400C"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Bland A610",
    "Device": "ZTE_BLADE_A610",
    "Model": "ZTE BLADE A610"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Bland A610",
    "Device": "ZTE_BLADE_A610",
    "Model": "ZTE Blade A610"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Bolton",
    "Device": "florist",
    "Model": "Z986DL"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Bouygues Telecom Bs 351",
    "Device": "nice",
    "Model": "Bouygues Telecom Bs 351"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Bouygues Telecom Bs 402",
    "Device": "P172G10",
    "Model": "A4C"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Bouygues Telecom Bs 402",
    "Device": "P172G10",
    "Model": "Amazing A4C"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Bouygues Telecom Bs 402",
    "Device": "P172G10",
    "Model": "Bouygues Telecom Bs 402"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Bouygues Telecom Bs 402",
    "Device": "P172G10",
    "Model": "ZTE Blade Q Mini"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "C2016",
    "Device": "orchid",
    "Model": "ZTE C2016"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "C2017",
    "Device": "alice",
    "Model": "ZTE C2017"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "C310",
    "Device": "P172D04",
    "Model": "L8301"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "C310",
    "Device": "P172D04",
    "Model": "Movitel M8410"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "C310",
    "Device": "P172D04",
    "Model": "ZTE Blade C310"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "C310",
    "Device": "P172D04",
    "Model": "ZTE C310"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "C880",
    "Device": "P635N32",
    "Model": "ZTE C880"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "C880A",
    "Device": "P635B32",
    "Model": "ZTE C880A"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "C880D",
    "Device": "P635D32",
    "Model": "ZTE C880D"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "C880S",
    "Device": "P635N34",
    "Model": "ZTE C880S"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "C880S",
    "Device": "S_P635N34",
    "Model": "ZTE C880S"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "C880S",
    "Device": "T_P635N34",
    "Model": "ZTE C880S"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "C880S",
    "Device": "V_P635N34",
    "Model": "ZTE C880S"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "C880U",
    "Device": "P635V32",
    "Model": "ZTE C880U"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "CELL C EMPIRE E8",
    "Device": "P635F50",
    "Model": "CELL C EMPIRE E8"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Cepter Nivo V2",
    "Device": "P606F17",
    "Model": "Z2458"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Chapel",
    "Device": "chapel",
    "Model": "Z831"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "China Mobile Forerunner X1",
    "Device": "P855A23",
    "Model": "CMCC M970"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ConeXis A1",
    "Device": "ZTE_BLADE_L110",
    "Model": "ConeXis A1"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ConeXis X1",
    "Device": "P809F52",
    "Model": "ConeXis X1"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ConeXis X2",
    "Device": "ZTE_BLADE_V0850",
    "Model": "ConeXis X2"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Cosmote Smart Share",
    "Device": "nice",
    "Model": "Cosmote Smart Share"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Cosmote Xplore",
    "Device": "Cosmote",
    "Model": "Cosmote Xplore"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Cosmote Xplore",
    "Device": "Cosmote-Xplore",
    "Model": "Cosmote Xplore"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "DL2 PLUS",
    "Device": "P637F02",
    "Model": "DL2 PLUS"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "DL2 PLUS",
    "Device": "P637F02",
    "Model": "Digicel DL2 XL"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Dialog Q143L",
    "Device": "frosty",
    "Model": "Dialog Q143L"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Digicel DL2 XL",
    "Device": "P637F02",
    "Model": "Digicel DL2 XL"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Extreme E8",
    "Device": "P635A31",
    "Model": "Extreme E8"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "FT142D",
    "Device": "msm8226",
    "Model": "FT142D"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Fanfare 2",
    "Device": "sheen",
    "Model": "Z815"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "G601U",
    "Device": "P172E02",
    "Model": "ZTE G601U"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "G717C",
    "Device": "P692N30",
    "Model": "ZTE G717C"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "G718C",
    "Device": "ZTE-G718C",
    "Model": "ZTE G718C"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "G719C",
    "Device": "ZTE-G719C",
    "Model": "ZTE G719C"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "G720C",
    "Device": "ZTE-G720C",
    "Model": "ZTE G720C"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "G720T",
    "Device": "P839T30",
    "Model": "ZTE G720T"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "G720T",
    "Device": "V_P839T30",
    "Model": "ZTE G720T"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "GEEK II 4G",
    "Device": "msm8226",
    "Model": "ZTE GEEK II 4G"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "GEEK II Pro",
    "Device": "ztexasp92_wet_jb9",
    "Model": "ZTE GEEK II Pro"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "GEEK II Pro",
    "Device": "ztexasp92_wet_jb9",
    "Model": "ZTE M1001"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Geek",
    "Device": "redhookbay",
    "Model": "ZTE Geek"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Geek 2 LTE",
    "Device": "msm8226",
    "Model": "ZTE Geek 2 LTE"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Geek 2 pro",
    "Device": "P692S20_M92",
    "Model": "ZTE Geek 2 pro"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Grand Era",
    "Device": "enterprise_RU",
    "Model": "ZTE Grand Era"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Grand Memo",
    "Device": "prindle",
    "Model": "Grand Memo"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Grand Memo LTE",
    "Device": "Grand-Memo",
    "Model": "ZTE Grand Memo"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Grand Memo LTE",
    "Device": "Grand-Memo",
    "Model": "ZTE Grand Memo LTE"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Grand S Flex",
    "Device": "iris",
    "Model": "Grand S Flex"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Grand S Flex",
    "Device": "iris",
    "Model": "ZTE Grand S Flex"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Grand S II",
    "Device": "P541T50",
    "Model": "ZTE Grand S II"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Grand S II",
    "Device": "P541T50",
    "Model": "ZTE S221"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Grand S II",
    "Device": "P897A21",
    "Model": "ZTE Grand S II"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Grand S II LTE",
    "Device": "msm8974",
    "Model": "ZTE Grand S II LTE"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Grand X",
    "Device": "P175A20",
    "Model": "Grand X"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Grand X",
    "Device": "P175A20",
    "Model": "Grand X(M)"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Grand X",
    "Device": "P175A20",
    "Model": "ZTE Grand X Classic"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Grand X",
    "Device": "P175A20",
    "Model": "ZTE V970"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Grand X",
    "Device": "P175A20",
    "Model": "ZTE V970M"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Grand X",
    "Device": "P175A20",
    "Model": "ZTE-U V970M"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Grand X",
    "Device": "P175A20",
    "Model": "tmn smart a18"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Grand X 2",
    "Device": "P682F06",
    "Model": "Amazing A7"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Grand X 2",
    "Device": "P682F06",
    "Model": "ZTE Grand X 2"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Grand X 2",
    "Device": "P682F06",
    "Model": "ZTE V968"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Grand X 2",
    "Device": "P682F06",
    "Model": "ZTE V969"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Grand X In",
    "Device": "mfld_pr2",
    "Model": "Grand X In"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Grand X In",
    "Device": "mfld_pr2",
    "Model": "STARADDICT II Plus"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Grand X In",
    "Device": "mfld_pr2",
    "Model": "ZTE Grand X In"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Grand X Max 2",
    "Device": "jerry",
    "Model": "Z988"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Grand X Pro",
    "Device": "P177A20",
    "Model": "Blade Super"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Grand X Pro",
    "Device": "P177A20",
    "Model": "Grand X Pro"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Grand X Pro",
    "Device": "P177A20",
    "Model": "KPN Smart 300"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Grand X Quad Lite",
    "Device": "P188F07",
    "Model": "Amazing A6"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Grand X Quad Lite",
    "Device": "P188F07",
    "Model": "V8602"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Grand X Quad Lite",
    "Device": "P188F07",
    "Model": "ZTE Grand X Quad Lite"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Grand X Quad Lite",
    "Device": "P188F07",
    "Model": "ZTE Grand X2"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Grand X Quad Lite",
    "Device": "P188F07",
    "Model": "ZTE Skate 2"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Grand X Quad Lite",
    "Device": "P188F07",
    "Model": "ZTE V967S"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Grand X2 In",
    "Device": "redhookbay",
    "Model": "Grand X2 In"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Grand X2 In",
    "Device": "redhookbay",
    "Model": "ZTE Grand X2 In"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "GrayJoy",
    "Device": "grayjoy",
    "Model": "N9136"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Helios X1",
    "Device": "P809A01",
    "Model": "Helios X1"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "I-O DATA",
    "Device": "B800S2_V1",
    "Model": "AV-ATB100"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ISE-T100C",
    "Device": "K96",
    "Model": "ISE-T100C"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Infinity X^2 mini",
    "Device": "msm8226",
    "Model": "Infinity X^2 mini"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Jasper LTE",
    "Device": "lemon",
    "Model": "Z718TL"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "K70",
    "Device": "K70",
    "Model": "K70"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "K75",
    "Device": "crane-zte7",
    "Model": "K75"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "K81",
    "Device": "helen",
    "Model": "K81"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "K813",
    "Device": "P809K50",
    "Model": "ZTE-K813"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "K83",
    "Device": "K83",
    "Model": "Amazing_P8"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "K83",
    "Device": "K83",
    "Model": "K83"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "K83V",
    "Device": "K83",
    "Model": "K83V"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "K85",
    "Device": "K85",
    "Model": "K85"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "K87CA",
    "Device": "K87",
    "Model": "K87CA"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "K87CC",
    "Device": "K87",
    "Model": "K87CC"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "K88",
    "Device": "jasmine",
    "Model": "K88"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "K92",
    "Device": "primrose",
    "Model": "K92"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "K95L",
    "Device": "K95",
    "Model": "K95L"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "K97",
    "Device": "K97",
    "Model": "K97"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "K97",
    "Device": "K97",
    "Model": "ZTE K97"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "KIS",
    "Device": "roamer2",
    "Model": "KIS"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "KIS PLUS",
    "Device": "roamer2",
    "Model": "KIS PLUS"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "KPN Smart 400",
    "Device": "msm8226",
    "Model": "KPN Smart 400"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Karbonn_A1",
    "Device": "N721",
    "Model": "Karbonn_A1"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Kis 3",
    "Device": "ZTE-P821E10",
    "Model": "MEO SMART A16"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Kis 3",
    "Device": "ZTE-P821E10",
    "Model": "MEO Smart A16"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Kis 3",
    "Device": "ZTE-P821E10",
    "Model": "MOCHE SMART A16"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Kis 3",
    "Device": "ZTE-P821E10",
    "Model": "ZTE Kis 3"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Kis 3",
    "Device": "ZTE-P821E10",
    "Model": "ZTE V811"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Kis Lite",
    "Device": "roamer2",
    "Model": "ZTE Kis Lite"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Kis Pro",
    "Device": "nice",
    "Model": "Optimus Zali"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Kis Pro",
    "Device": "nice",
    "Model": "ZTE Kis Pro"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Kis Q",
    "Device": "P172D02",
    "Model": "ZTE Kis Q"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Kis T3",
    "Device": "roamer2",
    "Model": "Kis T3"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "LEO M1",
    "Device": "V883M",
    "Model": "V883M"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "LEO M1",
    "Device": "V883M",
    "Model": "ZTE LEO M1"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "LEO S1",
    "Device": "V972M",
    "Model": "V972M"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "LEO S1",
    "Device": "V972M",
    "Model": "ZTE LEO S1"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "LEO S2",
    "Device": "V982M_Z64",
    "Model": "ZTE LEO S2"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "LEO_Q1",
    "Device": "hct72_wet_jb3",
    "Model": "V765M"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "LEO_Q1",
    "Device": "hct72_wet_jb3",
    "Model": "ZTE LEO Q1"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "LEO_Q1",
    "Device": "hct72_wet_jb3",
    "Model": "ZTE V765M"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "LEO_Q1",
    "Device": "hct72_wet_jb3",
    "Model": "ZTE_CLARO_Q1"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "LEO_Q1",
    "Device": "hct72_wet_jb3",
    "Model": "ZTE_LEO_Q1"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "LEO_Q1",
    "Device": "hct72_wet_jb3",
    "Model": "mobifone M9001"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "LS-5503",
    "Device": "P839F50",
    "Model": "LS-5503"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "LS-5503",
    "Device": "P839F50",
    "Model": "ZTE Blade S6 Plus"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Lannister",
    "Device": "weeper",
    "Model": "Z863DL"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Leopard MF800",
    "Device": "roamer2",
    "Model": "Leopard MF800"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Libero Flip",
    "Device": "Z8888S",
    "Model": "A304ZT"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Libero Flip",
    "Device": "Z8888S",
    "Model": "XXXX"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Light Tab 2",
    "Device": "v9plus",
    "Model": "Light Tab 2"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "M8402",
    "Device": "roamer2",
    "Model": "M8402"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "M901C",
    "Device": "P692N60",
    "Model": "ZTE M901C"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "MEDION LIFE P4310",
    "Device": "skate",
    "Model": "MEDION LIFE P4310"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "MEDION Smartphone LIFE E3501",
    "Device": "roamer2",
    "Model": "MEDION Smartphone LIFE E3501"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "MF97A",
    "Device": "MF97A",
    "Model": "MF97A"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "MF97B",
    "Device": "msm8974",
    "Model": "MF97B"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "MF97B",
    "Device": "msm8974",
    "Model": "MF97B_ROGERS"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "MF97B_T",
    "Device": "msm8974",
    "Model": "MF97B_T"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "MF97E",
    "Device": "msm8974",
    "Model": "MF97E"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "MF97G",
    "Device": "msm8974",
    "Model": "MF97G"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "MF97W",
    "Device": "MF97W",
    "Model": "MF97W"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "MO-01J",
    "Device": "MO-01J",
    "Model": "MO-01J"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "MO-01K",
    "Device": "MO-01K",
    "Model": "MO-01K"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "MS4A",
    "Device": "kiska",
    "Model": "MS4A"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "MS4A",
    "Device": "roundtop",
    "Model": "MS4A"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "MTC SMART Run 4G",
    "Device": "P632T31",
    "Model": "MTC SMART Run 4G"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Majesty Pro LTE",
    "Device": "stark",
    "Model": "Z798BL"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Momodesign MD Droid",
    "Device": "atlas40",
    "Model": "Momodesign MD Droid"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Movistar Express",
    "Device": "QB7211",
    "Model": "Movistar Express"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Movistar Motion",
    "Device": "roamer2",
    "Model": "Movistar Motion"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "N5L",
    "Device": "prmthus",
    "Model": "ZTE N5L"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "N5S",
    "Device": "P189F10",
    "Model": "ZTE N5S"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "N720",
    "Device": "N720",
    "Model": "N720"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "N720",
    "Device": "N720",
    "Model": "ZTE-U N720"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "N720",
    "Device": "N720",
    "Model": "ZTE_U N720"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "N762",
    "Device": "roamer",
    "Model": "N762"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "N765_APT",
    "Device": "N765",
    "Model": "N765_APT"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "N790",
    "Device": "deepblue",
    "Model": "N790"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "N795",
    "Device": "deepblue",
    "Model": "ZTE N795"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "N798",
    "Device": "atlas40",
    "Model": "ZTE N798"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "N798+",
    "Device": "ZTE_N798",
    "Model": "ZTE N798+"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "N798+",
    "Device": "ZTE_N798P",
    "Model": "ZTE N798+"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "N799D",
    "Device": "ZTE-N799D",
    "Model": "N799D"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "N799D",
    "Device": "ZTE-N799D",
    "Model": "ZTE N799D"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "N800",
    "Device": "nex",
    "Model": "N800"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "N8000_USA_Cricket",
    "Device": "N8000",
    "Model": "N8000_USA_Cricket"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "N8000_USA_RS",
    "Device": "N8000",
    "Model": "N8000_USA_RS"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "N8000_WHTE_CKT",
    "Device": "N8000",
    "Model": "N8000_WHTE_CKT"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "N8010_APT",
    "Device": "N8010_APT",
    "Model": "N8010_APT"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "N810",
    "Device": "fluid",
    "Model": "N810"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "N817",
    "Device": "wellington",
    "Model": "N817"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "N818",
    "Device": "ZTE-N818",
    "Model": "N818"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "N818",
    "Device": "ZTE-N818",
    "Model": "ZTE N818"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "N8300_Reliance",
    "Device": "N8300_Reliance",
    "Model": "N8300_Reliance"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "N8303",
    "Device": "roamer2",
    "Model": "N8303"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "N850",
    "Device": "sean",
    "Model": "N850"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "N850L",
    "Device": "seanplus",
    "Model": "N850L"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "N855D",
    "Device": "hope",
    "Model": "N855D"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "N860",
    "Device": "arthur",
    "Model": "N860"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "N860",
    "Device": "arthur",
    "Model": "Warp"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "N861",
    "Device": "warp2",
    "Model": "N861"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "N880E",
    "Device": "atlas40",
    "Model": "ZTE N880E"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "N880G",
    "Device": "ZTE-N880G",
    "Model": "ZTE N880G"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "N900",
    "Device": "ZTE-N900",
    "Model": "ZTE N900"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "N900D",
    "Device": "ZTE-N900D",
    "Model": "ZTE N900D"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "N909",
    "Device": "ZTE-N909",
    "Model": "ZTE N909"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "N909D",
    "Device": "ZTE-N909D",
    "Model": "ZTE N909D"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "N910",
    "Device": "arthur4g",
    "Model": "ZTE-N910"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "N9100",
    "Device": "hayes",
    "Model": "N9100"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "N9101",
    "Device": "apollo",
    "Model": "N9101"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "N9120",
    "Device": "elden",
    "Model": "ZTE N9120"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "N9130",
    "Device": "speed",
    "Model": "N9130"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "N9132",
    "Device": "cinco",
    "Model": "N9132"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "N9137",
    "Device": "msm8909go",
    "Model": "N9137"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "N9180",
    "Device": "N9180",
    "Model": "N9180"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "N918St",
    "Device": "N918St",
    "Model": "BGH Joy Smart AXS II"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "N918St",
    "Device": "N918St",
    "Model": "BGH Joy Smart AXS II D"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "N918St",
    "Device": "N918St",
    "Model": "N918St"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "N918St",
    "Device": "N918St",
    "Model": "ZTE N918St"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "N919",
    "Device": "ZTE-N919",
    "Model": "ZTE N919"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "N919D",
    "Device": "ZTE-N919D",
    "Model": "N919D"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "N919D",
    "Device": "ZTE-N919D",
    "Model": "ZTE N919D"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "N928Dt",
    "Device": "N928Dt",
    "Model": "ZTE N928Dt"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "N940Sc",
    "Device": "N940Sc",
    "Model": "N940Sc"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "N9500",
    "Device": "gordon",
    "Model": "N9500"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "N9510",
    "Device": "warplte",
    "Model": "N9510"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "N9511",
    "Device": "hera",
    "Model": "ZTE_N9511"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "N9515",
    "Device": "warp4",
    "Model": "N9515"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "N9516",
    "Device": "eridani",
    "Model": "N9516"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "N9518",
    "Device": "warp6",
    "Model": "N9518"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "N9520",
    "Device": "stormer",
    "Model": "N9520"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "N9521",
    "Device": "max",
    "Model": "N9521"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "N958St",
    "Device": "N958St",
    "Model": "N958St"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "N9810",
    "Device": "quantum",
    "Model": "N9810"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "N983",
    "Device": "P177F03",
    "Model": "ZTE N983"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "N9835",
    "Device": "chovar",
    "Model": "N9835"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "N9835",
    "Device": "chovar",
    "Model": "ZTE N9835"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "N986",
    "Device": "P188F02",
    "Model": "N986"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "N986",
    "Device": "P188F02",
    "Model": "ZTE N986"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "N986D",
    "Device": "P188F10",
    "Model": "N986+"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "N986D",
    "Device": "P188F10",
    "Model": "N986D"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "NE501J",
    "Device": "NE501J",
    "Model": "NE501J"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "NE501J",
    "Device": "NE501J",
    "Model": "V5"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "NE501J",
    "Device": "NE501J",
    "Model": "ZTE_V5"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "NOS NEVA 80",
    "Device": "P852F52",
    "Model": "NOS NEVA 80"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "NOS NOVU II",
    "Device": "P680A20",
    "Model": "NOS NOVU II"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "NOS NOVU III",
    "Device": "P637F10",
    "Model": "NOS NOVU III"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "NP01J",
    "Device": "P898P02",
    "Model": "NP01J"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "NP03J",
    "Device": "PQ83P01",
    "Model": "NP03J"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "NP05J",
    "Device": "PQ84P01",
    "Model": "NP05J"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "NT01",
    "Device": "PQ83P02",
    "Model": "NT01"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "NX402",
    "Device": "NX40X",
    "Model": "NX402"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "NX403A",
    "Device": "NX403A",
    "Model": "NX403A"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "NX404H",
    "Device": "NX404H",
    "Model": "NX404H"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "NX405H",
    "Device": "NX405H",
    "Model": "NX405H"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "NX406E",
    "Device": "NX406E",
    "Model": "NX406E"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "NX40X",
    "Device": "NX402",
    "Model": "NX402"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "NX40X_APT",
    "Device": "NX40X",
    "Model": "NX40X"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "NX40X_APT",
    "Device": "NX40X",
    "Model": "NX40X_APT"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "NX501",
    "Device": "NX501",
    "Model": "NX501"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "NX501_APT",
    "Device": "NX501",
    "Model": "NX501_APT"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "NX503A_Z4",
    "Device": "NX503A_Z4",
    "Model": "NX503A_Z4"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "NX503J",
    "Device": "NX503J",
    "Model": "NX503J"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "NX505J",
    "Device": "NX505J",
    "Model": "NX505J"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "NX506J",
    "Device": "NX506J",
    "Model": "NX506J"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "NX507J",
    "Device": "NX507J",
    "Model": "NX507H"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "NX507J",
    "Device": "NX507J",
    "Model": "NX507J"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "NX508J",
    "Device": "NX508J",
    "Model": "NX508J"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "NX510J",
    "Device": "NX510J",
    "Model": "NX510J"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "NX511J",
    "Device": "NX511J",
    "Model": "NX511J"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "NX511J_V3",
    "Device": "NX511J_V3",
    "Model": "NX511J_V3"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "NX512J",
    "Device": "NX512J",
    "Model": "NX512J"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "NX513J",
    "Device": "NX513J",
    "Model": "NX513J"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "NX521J",
    "Device": "NX521J",
    "Model": "BGH Joy Smart AXS II"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "NX521J",
    "Device": "NX521J",
    "Model": "NX521J"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "NX523J_V1",
    "Device": "NX523J_V1",
    "Model": "NX523J_V1"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "NX527J_V1",
    "Device": "NX527J_V1",
    "Model": "NX527J_V1"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "NX529J",
    "Device": "NX529J",
    "Model": "NX529J"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "NX531J",
    "Device": "NX531J",
    "Model": "NX531J"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "NX535J",
    "Device": "NX535J",
    "Model": "NX535J"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "NX541J",
    "Device": "NX541J",
    "Model": "NX541J"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "NX549J",
    "Device": "NX549J",
    "Model": "NX549J"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "NX551J",
    "Device": "NX551J",
    "Model": "NX551J"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "NX563J",
    "Device": "NX563J",
    "Model": "NX563J"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "NX569J",
    "Device": "NX569J",
    "Model": "NX569J"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "NX573J",
    "Device": "NX573J",
    "Model": "NX573J"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "NX575J",
    "Device": "NX575J",
    "Model": "NX575J"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "NX589J",
    "Device": "NX589J",
    "Model": "NX589J"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "NX591J",
    "Device": "NX591J",
    "Model": "NX591J"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "NX595J",
    "Device": "NX595J",
    "Model": "NX595J"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "NX597J",
    "Device": "NX597J",
    "Model": "NX597J"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "NX601J",
    "Device": "NX601J",
    "Model": "NX601J"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "NX606J",
    "Device": "NX606J",
    "Model": "NX606J"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "NX607J",
    "Device": "NX607J",
    "Model": "NX607J"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "NX608J",
    "Device": "NX608J",
    "Model": "NX608J"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "NX609J",
    "Device": "NX609J",
    "Model": "NX609J"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "NX612J",
    "Device": "NX612J",
    "Model": "NX612J"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "NX619J",
    "Device": "NX619J",
    "Model": "NX619J"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "NX619J",
    "Device": "NX619J-EEA",
    "Model": "NX619J"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "NX627J",
    "Device": "NX627J",
    "Model": "NX627J"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "NX627J",
    "Device": "NX627J-EEA",
    "Model": "NX627J"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "NX629J",
    "Device": "NX629J",
    "Model": "NX629J"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "NX629J",
    "Device": "NX629J-EEA",
    "Model": "NX629J"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "NX659J",
    "Device": "NX659J-RU",
    "Model": "NX659J"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "NX659J",
    "Device": "NX659J-UN",
    "Model": "NX659J"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "NX666J",
    "Device": "NX666J",
    "Model": "NX666J"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "NX669J",
    "Device": "NX669J",
    "Model": "NX669J"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "NX669J",
    "Device": "NX669J-EEA",
    "Model": "NX669J"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "NX669J",
    "Device": "NX669J-UN",
    "Model": "NX669J"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "NX679J",
    "Device": "NX679J",
    "Model": "NX679J"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "NX679J",
    "Device": "NX679J-EEA",
    "Model": "NX679J"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "NX679J",
    "Device": "NX679J-UN",
    "Model": "NX679J"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "NX679S",
    "Device": "NX679S",
    "Model": "NX679S"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "NX702J",
    "Device": "P898A21",
    "Model": "NX702J"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "NX703J",
    "Device": "P870A22",
    "Model": "NX703J"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "NX709J",
    "Device": "NX709J",
    "Model": "NX709J"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "NX709S",
    "Device": "NX709S",
    "Model": "NX709S"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "NX709S",
    "Device": "NX709S-EEA",
    "Model": "NX709S"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "NX709S",
    "Device": "NX709S-UN",
    "Model": "NX709S"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "NX711J",
    "Device": "PQ82A01",
    "Model": "NX711J"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "NX729J",
    "Device": "NX729J",
    "Model": "NX729J"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "NX729J",
    "Device": "NX729J-EEA",
    "Model": "NX729J"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "NX729J",
    "Device": "NX729J-UN",
    "Model": "NX729J"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "NX907J",
    "Device": "NX907J",
    "Model": "NX907J"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Nubia 4010",
    "Device": "P963F60",
    "Model": "Nubia 4010"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Nubia 6010",
    "Device": "P963F07",
    "Model": "Nubia 6010"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Nubia 8011",
    "Device": "P963F05",
    "Model": "Nubia 8011"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Nubia 8031",
    "Device": "P963F06",
    "Model": "Nubia 8031"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Nubia N11",
    "Device": "P731F50",
    "Model": "Nubia N11"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Nubia N40",
    "Device": "P963F50_A",
    "Model": "Nubia N40"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Nubia N40",
    "Device": "P963F50_A",
    "Model": "ZTE Blade A51 Lite"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "OWN FUN 5(4G)",
    "Device": "VFD511",
    "Model": "OWN FUN 5(4G)"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "OWN FUN 5(4G)",
    "Device": "VFD511",
    "Model": "ZTE BLADE A321"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "OWN One Plus",
    "Device": "ZTE_Blade_V580",
    "Model": "OWN One Plus"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Optimus Barcelona",
    "Device": "blade2",
    "Model": "Optimus Barcelona"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Optus X Max",
    "Device": "P606F05",
    "Model": "Blade A72s"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Optus X Pro 5G",
    "Device": "P720F02",
    "Model": "A73 Pro 5G"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Optus X Tap 3",
    "Device": "P606F10",
    "Model": "P660"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Optus X-Plus",
    "Device": "Z3511O",
    "Model": "P602"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Optus X-Pro 2 5G",
    "Device": "Z7306O",
    "Model": "P9 Pro 5G"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Optus X-Total",
    "Device": "P963F65",
    "Model": "P656"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Orange Hi 4G",
    "Device": "Orange_Hi_4G",
    "Model": "Orange Hi 4G"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Orange Hi 4G",
    "Device": "msm8226",
    "Model": "Orange Hi 4G"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Orange Monte Carlo",
    "Device": "skate",
    "Model": "Orange Monte Carlo"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Orange Neva jet",
    "Device": "Neva_jet",
    "Model": "Orange Neva jet"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Orange Novi",
    "Device": "oceanus",
    "Model": "Orange Novi"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Orange Reyo",
    "Device": "P172D10",
    "Model": "Avea inTouch 3 Large"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Orange Reyo",
    "Device": "P172D10",
    "Model": "Blade Q Maxi"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Orange Reyo",
    "Device": "P172D10",
    "Model": "Orange Reyo"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Orange Reyo",
    "Device": "P172D10",
    "Model": "ZTE Blade Q Maxi"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Orange Rono",
    "Device": "Vec4G",
    "Model": "Orange Rono"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Orange Rono",
    "Device": "msm8226",
    "Model": "Orange Rono"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Orange Zali",
    "Device": "nice",
    "Model": "Orange Zali"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Own One",
    "Device": "P635A20",
    "Model": "Own One"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "P501",
    "Device": "Z3052O",
    "Model": "P501"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "P503",
    "Device": "Z3101T",
    "Model": "P503"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "P505",
    "Device": "Z3103O",
    "Model": "P505"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "P545",
    "Device": "P545",
    "Model": "P545"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "P600",
    "Device": "P963F80",
    "Model": "P600"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "P601",
    "Device": "P963F80",
    "Model": "P601"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "P609",
    "Device": "P609",
    "Model": "P609"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "P650 2021",
    "Device": "P963F60",
    "Model": "P650 2021"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "P650 Pro",
    "Device": "Z6351O",
    "Model": "P650 Pro"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "P651 2021",
    "Device": "Z6355O",
    "Model": "P651 2021"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "P652",
    "Device": "P963F61",
    "Model": "P652"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "P652 Pro",
    "Device": "Z6356O",
    "Model": "P652 Pro"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "P7 Pro 5G",
    "Device": "Z7602O",
    "Model": "P7 Pro 5G"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "P_C880S",
    "Device": "P_P635N34",
    "Model": "ZTE P_C880S"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Preo Teknosa P1",
    "Device": "msm8916_32",
    "Model": "Preo Teknosa P1"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Q101T",
    "Device": "P810T10",
    "Model": "ZTE Q101T"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Q201T",
    "Device": "P172T24",
    "Model": "ZTE Q201T"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Q2S-C",
    "Device": "P826N50",
    "Model": "ZTE Q2S-C"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Q2S-T",
    "Device": "P826T50",
    "Model": "ZTE Q2S-T"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Q301C",
    "Device": "APT_TW_P810N30",
    "Model": "ZTE Q301C"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Q301C",
    "Device": "P810N30",
    "Model": "ZTE Q301C"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Q301T",
    "Device": "P172T33",
    "Model": "ZTE Q301T"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Q302C",
    "Device": "P809N20",
    "Model": "ZTE Q302C"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Q5-C",
    "Device": "P816N34",
    "Model": "ZTE Q5-C"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Q5-T",
    "Device": "CU_P816T32",
    "Model": "ZTE Q5-T"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Q5-T",
    "Device": "P816T32",
    "Model": "ZTE Q5-T"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Q501T",
    "Device": "P172T31",
    "Model": "ZTE Q501T"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Q501U",
    "Device": "P172F04",
    "Model": "ZTE Q501U"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Q503U",
    "Device": "P682V53",
    "Model": "ZTE Q503U"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Q505T",
    "Device": "P826T20",
    "Model": "ZTE Q505T"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Q507T",
    "Device": "P682T20",
    "Model": "ZTE Q507T"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Q508U",
    "Device": "P816V50",
    "Model": "ZTE Q508U"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Q509T",
    "Device": "P632T31",
    "Model": "Amazing X5"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Q509T",
    "Device": "P632T31",
    "Model": "MTC SMART Run 4G"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Q509T",
    "Device": "P632T31",
    "Model": "ZTE Blade A450"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Q509T",
    "Device": "P632T31",
    "Model": "ZTE Blade V2 Lite"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Q509T",
    "Device": "P632T31",
    "Model": "ZTE Q509T"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Q519T",
    "Device": "ZTE_Q519T",
    "Model": "ZTE Q519T"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Q529C",
    "Device": "P635N33",
    "Model": "ZTE Q529C"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Q529C",
    "Device": "V_P635N33",
    "Model": "ZTE Q529C"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Q529E",
    "Device": "P635T35",
    "Model": "ZTE Q529E"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Q529T",
    "Device": "P635T33",
    "Model": "ZTE Q529T"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Q7",
    "Device": "CMCC_P839V50",
    "Model": "ZTE Q7"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Q7",
    "Device": "CU_P839V50",
    "Model": "ZTE Q7"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Q7",
    "Device": "P839V50",
    "Model": "ZTE Q7"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Q7-C",
    "Device": "P839N50",
    "Model": "ZTE Q7-C"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Q701C",
    "Device": "ZTE-Q701C",
    "Model": "ZTE Q701C"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Q705U",
    "Device": "P682V60",
    "Model": "ZTE Q705U"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Q801C",
    "Device": "ZTE-Q801C",
    "Model": "ZTE Q801C"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Q801L",
    "Device": "ZTE-Q801L",
    "Model": "ZTE Q801L"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Q801T",
    "Device": "P181L30",
    "Model": "ZTE Q801T"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Q801U",
    "Device": "P826V30",
    "Model": "ZTE Q801U"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Q802C",
    "Device": "ZTE-Q802C",
    "Model": "ZTE Q802C"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Q802D",
    "Device": "ZTE-Q802D",
    "Model": "ZTE Q802D"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Q802T",
    "Device": "P826T30",
    "Model": "ZTE Q802T"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Q805T",
    "Device": "P120T55",
    "Model": "ZTE Q805T"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Q806T",
    "Device": "V_P635T30",
    "Model": "ZTE Q806T"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Quartz",
    "Device": "platy",
    "Model": "Quartz"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Quartz",
    "Device": "platy",
    "Model": "ZW10"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "R83",
    "Device": "demeter",
    "Model": "ZTE R83"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "RACER III mini",
    "Device": "roamer2",
    "Model": "RACER III mini"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "RED MAGIC 5G",
    "Device": "NX659J",
    "Model": "NX659J"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "REDMAGIC 10 Pro",
    "Device": "NX789J",
    "Model": "NX789J"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "REDMAGIC 7",
    "Device": "NX709J-EEA",
    "Model": "NX709J"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "REDMAGIC 7Pro",
    "Device": "NX709J-UN",
    "Model": "NX709J"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "REDMAGIC 9",
    "Device": "NX769J",
    "Model": "NX769J"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "REDMAGIC 9 Pro",
    "Device": "NX769J",
    "Model": "NX769J"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Racer",
    "Device": "mooncake",
    "Model": "Carl"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Racer",
    "Device": "mooncake",
    "Model": "MTC 916"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Racer",
    "Device": "mooncake",
    "Model": "MTS-SP100"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Racer",
    "Device": "mooncake",
    "Model": "Movistar Link"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Racer",
    "Device": "mooncake",
    "Model": "RTK D1"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Racer",
    "Device": "mooncake",
    "Model": "Racer"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Racer",
    "Device": "mooncake",
    "Model": "TaiWan Mobile T2"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Racer",
    "Device": "mooncake",
    "Model": "V8402"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Racer",
    "Device": "mooncake",
    "Model": "Vip Droid"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Racer",
    "Device": "mooncake",
    "Model": "XCD 28"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Racer",
    "Device": "mooncake",
    "Model": "ZTE X850"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Racer",
    "Device": "mooncake",
    "Model": "ZTE-C N600"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Racer",
    "Device": "mooncake",
    "Model": "ZTE-C N600+"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Racer",
    "Device": "mooncake",
    "Model": "ZTE-LINK"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Racer",
    "Device": "mooncake",
    "Model": "ZTE-RACER"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Racer",
    "Device": "mooncake",
    "Model": "ZTE-U V852"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Racer",
    "Device": "mooncake",
    "Model": "ZTE-U X850"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Red Magic 5G",
    "Device": "NX659J-EEA",
    "Model": "NX659J"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Red Magic 5G lite",
    "Device": "NX651J-EEA",
    "Model": "NX651J"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Rook from EE",
    "Device": "P635E40",
    "Model": "Rook from EE"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Russia",
    "Device": "P606F02",
    "Model": "ZTE 8045RU"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "S118",
    "Device": "P189S10",
    "Model": "Grand S Lite"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "S118",
    "Device": "P189S10",
    "Model": "ZTE S118"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "S2004",
    "Device": "msm8974",
    "Model": "ZTE S2004"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "S2005",
    "Device": "msm8974",
    "Model": "ZTE S2005"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "S2007",
    "Device": "msm8974",
    "Model": "ZTE S2007"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "S2010",
    "Device": "P653S10",
    "Model": "ZTE S2010"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "S2010",
    "Device": "P_P653S10",
    "Model": "ZTE S2010"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "S2010",
    "Device": "V_P653S10",
    "Model": "ZTE S2010"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "S2010",
    "Device": "ZTE_S2010",
    "Model": "ZTE S2010"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "S2014",
    "Device": "ZTE-S2014",
    "Model": "ZTE S2014"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "S2015",
    "Device": "ZTE-S2015",
    "Model": "ZTE S2015"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "S8Q",
    "Device": "MT8123",
    "Model": "S8Q"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "SKATE",
    "Device": "skate",
    "Model": "ZTE-SKATE"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "SMART Start 3",
    "Device": "ZTE_BLADE_L110",
    "Model": "SMART Start 3"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "STAR",
    "Device": "msm8226",
    "Model": "ZTE GEEK II Pro 4G"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "STAR",
    "Device": "msm8226",
    "Model": "ZTE S2002"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "STAR",
    "Device": "msm8226",
    "Model": "ZTE STAR"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "STAR",
    "Device": "msm8226",
    "Model": "ZTE Star 1"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "STARNAUTE II",
    "Device": "V6600",
    "Model": "STARNAUTE II"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "STARTRAIL 4",
    "Device": "P172E10",
    "Model": "Avea inTouch 3"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "STARTRAIL 4",
    "Device": "P172E10",
    "Model": "STARTRAIL 4"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "STARTRAIL 4",
    "Device": "P172E10",
    "Model": "ZTE Blade Q"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "STARXTREM",
    "Device": "prindle",
    "Model": "STARXTREM"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "STARXTREM 4",
    "Device": "msm8916_32",
    "Model": "STARXTREM 4"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Sapphire 3G",
    "Device": "sapphire",
    "Model": "N818S"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Sirius",
    "Device": "msm8937",
    "Model": "Z610DL"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Skate",
    "Device": "skate",
    "Model": "ZTE Skate"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Skate  Pro",
    "Device": "atlas40",
    "Model": "Skate Pro"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "SmartTab10",
    "Device": "V11A",
    "Model": "SmartTab10"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "SmartTab7",
    "Device": "V71A",
    "Model": "SmartTab7"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "SoshPhone 3",
    "Device": "SoshPhone_3",
    "Model": "SoshPhone 3"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Soshphone 4G",
    "Device": "Vec4G",
    "Model": "Soshphone 4G"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Soshphone 4G",
    "Device": "msm8226",
    "Model": "Soshphone 4G"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Spro 2",
    "Device": "msm8974",
    "Model": "502ZT"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Spro 2",
    "Device": "msm8974",
    "Model": "MF97B"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Spro 2",
    "Device": "msm8974",
    "Model": "MF97V"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Spro 2",
    "Device": "msm8974",
    "Model": "Spro 2"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Spro 2",
    "Device": "msm8974",
    "Model": "Spro 2 LTE"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Spro 2",
    "Device": "msm8974",
    "Model": "ZKB2A"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Spro2",
    "Device": "msm8974",
    "Model": "Spro2"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Stack",
    "Device": "martell",
    "Model": "Z799VL"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Switch X1",
    "Device": "deepblue",
    "Model": "ZTE Switch X1"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Switch X1",
    "Device": "deepblue",
    "Model": "ZTE V796"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "T-Mobile Vivacity",
    "Device": "blade2",
    "Model": "T-Mobile Vivacity"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "T12",
    "Device": "P173A30T",
    "Model": "ZTE T12"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "T221",
    "Device": "P731A20",
    "Model": "Blade C341"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "T221",
    "Device": "P731A20",
    "Model": "DIGICEL DL755"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "T221",
    "Device": "P731A20",
    "Model": "KIS C341"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "T221",
    "Device": "P731A20",
    "Model": "ZTE Blade A5"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "T221",
    "Device": "P731A20",
    "Model": "ZTE Blade AF5"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "T221",
    "Device": "P731A20",
    "Model": "ZTE Blade C341"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "T221",
    "Device": "P731A20",
    "Model": "ZTE Blade C342"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "T221",
    "Device": "P731A20",
    "Model": "ZTE T221"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "T221",
    "Device": "P731A20",
    "Model": "ZTE T230"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "T28",
    "Device": "bluetick",
    "Model": "ZTE T28"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "T28",
    "Device": "bluetick",
    "Model": "ZTE T28 Prepaid"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "T3",
    "Device": "skate",
    "Model": "T3"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "T325",
    "Device": "ZTE_T325",
    "Model": "ZTE T325"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "T520",
    "Device": "P172A40",
    "Model": "ZTE T520"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "T57",
    "Device": "P809A01",
    "Model": "T57"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "T57",
    "Device": "P809A01",
    "Model": "ZTE T57"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "T60",
    "Device": "turies",
    "Model": "ZTE T60"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "T617",
    "Device": "ZTE_T617",
    "Model": "ZTE T617"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "T620",
    "Device": "ZTE_T620",
    "Model": "ZTE T620"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "T630",
    "Device": "P635T30",
    "Model": "ZTE T630"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "T760",
    "Device": "P173A10T",
    "Model": "ZTE T760"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "T77",
    "Device": "T77",
    "Model": "T77"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "T790",
    "Device": "roamer2",
    "Model": "ZTE T790"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "T792",
    "Device": "ZTE-T792",
    "Model": "ZTE B792"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "T792",
    "Device": "ZTE-T792",
    "Model": "ZTE T792"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "T80",
    "Device": "msm8226",
    "Model": "ZTE T80"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "T81",
    "Device": "iliamna",
    "Model": "ZTE T81"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "T82",
    "Device": "frosty",
    "Model": "ZTE T82"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "T83",
    "Device": "demeter",
    "Model": "ZTE T83"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "T84",
    "Device": "P816A20",
    "Model": "ZTE R84"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "T84",
    "Device": "P816A20",
    "Model": "ZTE T84"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "T85",
    "Device": "P840F20",
    "Model": "T85"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "T86",
    "Device": "msm8226",
    "Model": "Amazing X1"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "T86",
    "Device": "msm8226",
    "Model": "ZTE T86"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "T88",
    "Device": "msm8226",
    "Model": "ZTE T88"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "T911",
    "Device": "P839F30",
    "Model": "ZTE T911"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "T912",
    "Device": "P839F30",
    "Model": "ZTE T912"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "T920",
    "Device": "ZTE_T920",
    "Model": "ZTE T920"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "T98",
    "Device": "primrose",
    "Model": "T98"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "TE BLADE B125",
    "Device": "P809F01",
    "Model": "ZTE BLADE B125"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "TQ150",
    "Device": "QB7211",
    "Model": "TQ150"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "TURKCELL T40",
    "Device": "TURKCELL-T40",
    "Model": "TURKCELL T40"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "TURKCELL T50",
    "Device": "msm8226",
    "Model": "TURKCELL T50"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "TURKCELL T50",
    "Device": "msm8226",
    "Model": "TURKCELL TURBO T50"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "TURKCELL T60",
    "Device": "P839T60",
    "Model": "TURKCELL T60"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "TURKCELL T60",
    "Device": "msm8916_32",
    "Model": "TURKCELL T60"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "TURKCELL T70",
    "Device": "P809T70",
    "Model": "TURKCELL T70"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "TURKCELL T80",
    "Device": "P840F14",
    "Model": "TURKCELL T80"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "TV Stick 4K",
    "Device": "YEV",
    "Model": "TV Stick 4K"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Telenor Touch Plus",
    "Device": "blade2",
    "Model": "Telenor Touch Plus"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Telstra T-Elite 2 5G",
    "Device": "Z7303T",
    "Model": "Blade A9 Pro 5G"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Telstra T-Elite 5G",
    "Device": "P720F09",
    "Model": "A75 Pro 5G"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Telstra T-Pro 2 5G",
    "Device": "P780F03",
    "Model": "Blade A76 5G"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Telstra Tough Max 3",
    "Device": "T86",
    "Model": "T86"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Tempo",
    "Device": "xray45",
    "Model": "N9131"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Turkcell Maxi Plus 5",
    "Device": "nice",
    "Model": "Turkcell Maxi Plus 5"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "U N721",
    "Device": "N721",
    "Model": "ZTE-U N721"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "U V760",
    "Device": "ztenj73_gb",
    "Model": "MD Smart"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "U V760",
    "Device": "ztenj73_gb",
    "Model": "Telenor Touch Mini"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "U V760",
    "Device": "ztenj73_gb",
    "Model": "ZTE-U V760"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "U V760",
    "Device": "ztenj73_gb",
    "Model": "ZTE-U V856"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "U V760",
    "Device": "ztenj73_gb",
    "Model": "ZTE-U V857"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "U V760",
    "Device": "ztenj73_gb",
    "Model": "moii E598"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "U5S",
    "Device": "P188T51",
    "Model": "ZTE U5S"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "U809",
    "Device": "P172T11",
    "Model": "ZTE U809"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "U816",
    "Device": "P988T20",
    "Model": "ZTE U816"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "U817",
    "Device": "P117A20",
    "Model": "ZTE U817"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "U818",
    "Device": "P172T21",
    "Model": "ZTE U818"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "U879",
    "Device": "P172T30",
    "Model": "ZTE U879"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "U880",
    "Device": "U880",
    "Model": "ZTE-T U880"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "U889",
    "Device": "P183T30",
    "Model": "ZTE U889"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "U9180",
    "Device": "U9180",
    "Model": "U9180"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "U9180",
    "Device": "U9180",
    "Model": "ZTE U9180"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "U968",
    "Device": "P682T51",
    "Model": "ZTE U968"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "U969",
    "Device": "P682T50",
    "Model": "ZTE U969"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "U9815",
    "Device": "P945T20",
    "Model": "ZTE U9815"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "U988S",
    "Device": "pluto",
    "Model": "ZTE U988S"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "UZTE V790",
    "Device": "roamer2",
    "Model": "UZTE V790"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "UZTE V817",
    "Device": "ZTE-V956",
    "Model": "UZTE V817"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Uhura",
    "Device": "noah",
    "Model": "Z968"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Ukraine, Kazakhstan, Azerbaijan",
    "Device": "P963F30P",
    "Model": "Z3"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Ukraine, Kazakhstan, Azerbaijan",
    "Device": "P963F30P",
    "Model": "ZTE Blade A5 2019"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Ultym 5.2",
    "Device": "msm8916_32",
    "Model": "Ultym 5.2"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "V55",
    "Device": "V55",
    "Model": "V55"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "V5S",
    "Device": "P189F13",
    "Model": "ZTE Grand Memo lite"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "V5S",
    "Device": "P189F13",
    "Model": "ZTE V5S"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "V6500",
    "Device": "V6500",
    "Model": "Etisalat Smartphone"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "V6500",
    "Device": "V6500",
    "Model": "ZTE-V6500"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "V70",
    "Device": "ZTE-V70",
    "Model": "ZTE V70"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "V7073",
    "Device": "V7073",
    "Model": "ZTE V7073"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "V72",
    "Device": "V72",
    "Model": "MT7A"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "V72",
    "Device": "V72",
    "Model": "ZTE V72"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "V72",
    "Device": "V72",
    "Model": "myPad P4 Lite"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "V72C",
    "Device": "v72c",
    "Model": "V72C"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "V72M",
    "Device": "eos",
    "Model": "V72M"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "V768",
    "Device": "V768",
    "Model": "ZTE V768"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "V769M",
    "Device": "V769M",
    "Model": "V769M"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "V769M",
    "Device": "V769M",
    "Model": "ZTE LEO Q2"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "V769M",
    "Device": "V769M",
    "Model": "ZTE V769M"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "V779M",
    "Device": "ZTEV779M",
    "Model": "ZTE V779M"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "V790",
    "Device": "roamer2",
    "Model": "ZTE V790"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "V791",
    "Device": "P175A40",
    "Model": "V791"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "V791",
    "Device": "P175A40",
    "Model": "ZTE V791"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "V792C",
    "Device": "P810D01",
    "Model": "ZTE V792C"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "V793",
    "Device": "P175A60",
    "Model": "Amazing A3"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "V793",
    "Device": "P175A60",
    "Model": "Cellcom 4G"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "V793",
    "Device": "P175A60",
    "Model": "M9000"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "V793",
    "Device": "P175A60",
    "Model": "Telcel T20"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "V793",
    "Device": "P175A60",
    "Model": "ZTE KIS Flex"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "V793",
    "Device": "P175A60",
    "Model": "ZTE V793"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "V793",
    "Device": "P175A60",
    "Model": "tmn smart a6"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "V795",
    "Device": "P172D01",
    "Model": "BGH Joy Smart A1"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "V795",
    "Device": "P172D01",
    "Model": "V795(A3S)"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "V795",
    "Device": "P172D01",
    "Model": "ZTE B795"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "V795",
    "Device": "P172D01",
    "Model": "ZTE KIS II"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "V795",
    "Device": "P172D01",
    "Model": "ZTE KIS II PRO"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "V795",
    "Device": "P172D01",
    "Model": "ZTE Kis II"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "V795",
    "Device": "P172D01",
    "Model": "ZTE V795"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "V797",
    "Device": "P172D03",
    "Model": "VIETTEL V8411"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "V797",
    "Device": "P172D03",
    "Model": "ZTE V797"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "V8000_USA_Cricket",
    "Device": "V8000",
    "Model": "V8000_USA_Cricket"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "V807",
    "Device": "P177E01",
    "Model": "Amazing A4"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "V807",
    "Device": "P177E01",
    "Model": "Beeline E700"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "V807",
    "Device": "P177E01",
    "Model": "Leopard MF900"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "V807",
    "Device": "P177E01",
    "Model": "UZTE V807"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "V807",
    "Device": "P177E01",
    "Model": "V8501"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "V807",
    "Device": "P177E01",
    "Model": "ZTE BLADE C"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "V807",
    "Device": "P177E01",
    "Model": "ZTE V807"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "V807",
    "Device": "P177E01",
    "Model": "ZTE V889S"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "V808",
    "Device": "P172E01",
    "Model": "UZTE V808"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "V808",
    "Device": "P172E01",
    "Model": "ZTE V808"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "V809",
    "Device": "P172A10",
    "Model": "BGH Joy Smart A2"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "V809",
    "Device": "P172A10",
    "Model": "ZTE Blade C2"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "V809",
    "Device": "P172A10",
    "Model": "ZTE T809"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "V809",
    "Device": "P172A10",
    "Model": "ZTE V809"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "V809",
    "Device": "P172A10",
    "Model": "meo smart a12"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "V811",
    "Device": "ZTE-V811",
    "Model": "Beeline Smart2"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "V811",
    "Device": "ZTE-V811",
    "Model": "ZTE V811"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "V8110",
    "Device": "V8110",
    "Model": "V8110"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "V811C",
    "Device": "P810E01",
    "Model": "ZTE V811C"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "V811W",
    "Device": "P821E10",
    "Model": "ZTE V811"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "V811W",
    "Device": "P821E10",
    "Model": "ZTE V811W"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "V813W",
    "Device": "P172B20",
    "Model": "ZTE Blade C2 Plus"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "V813W",
    "Device": "P172B20",
    "Model": "ZTE V813W"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "V815W",
    "Device": "P172R10",
    "Model": "Amazing A4S"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "V815W",
    "Device": "P172R10",
    "Model": "B8405"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "V815W",
    "Device": "P172R10",
    "Model": "BGH Joy Smart A5C"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "V815W",
    "Device": "P172R10",
    "Model": "BGH Joy Smart A5d"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "V815W",
    "Device": "P172R10",
    "Model": "KIS II Max"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "V815W",
    "Device": "P172R10",
    "Model": "SMART Start"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "V815W",
    "Device": "P172R10",
    "Model": "UZTE GRAND V7"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "V815W",
    "Device": "P172R10",
    "Model": "ZTE B815"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "V815W",
    "Device": "P172R10",
    "Model": "ZTE B816"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "V815W",
    "Device": "P172R10",
    "Model": "ZTE Blade Buzz"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "V815W",
    "Device": "P172R10",
    "Model": "ZTE Blade C320"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "V815W",
    "Device": "P172R10",
    "Model": "ZTE Blade Q1"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "V815W",
    "Device": "P172R10",
    "Model": "ZTE Kis II Max"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "V815W",
    "Device": "P172R10",
    "Model": "ZTE Kis II Max Plus"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "V815W",
    "Device": "P172R10",
    "Model": "ZTE Kis II Max plus"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "V815W",
    "Device": "P172R10",
    "Model": "ZTE Maxx"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "V815W",
    "Device": "P172R10",
    "Model": "ZTE T815"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "V815W",
    "Device": "P172R10",
    "Model": "ZTE T816"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "V815W",
    "Device": "P172R10",
    "Model": "ZTE V815W"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "V815W",
    "Device": "P172R10",
    "Model": "ZTE V816W"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "V817",
    "Device": "ZTE-V817",
    "Model": "V817"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "V817",
    "Device": "ZTE-V817",
    "Model": "ZTE V817"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "V817",
    "Device": "ZTE-V956",
    "Model": "ZTE V817"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "V818",
    "Device": "P172F01",
    "Model": "ZTE Blade 2"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "V818",
    "Device": "P172F01",
    "Model": "ZTE V818"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "V8200plus",
    "Device": "V8200plus",
    "Model": "V8200plus"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "V8285",
    "Device": "MT8382",
    "Model": "V8285"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "V829",
    "Device": "P172A30",
    "Model": "BGH Joy Smart A3"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "V829",
    "Device": "P172A30",
    "Model": "Blade G Pro"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "V829",
    "Device": "P172A30",
    "Model": "V8507"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "V829",
    "Device": "P172A30",
    "Model": "ZTE Blade G Plus"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "V829",
    "Device": "P172A30",
    "Model": "ZTE Blade G Pro"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "V829",
    "Device": "P172A30",
    "Model": "ZTE V829"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "V831W",
    "Device": "P731A10",
    "Model": "Amazing A5S"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "V831W",
    "Device": "P731A10",
    "Model": "UZTE Blade Q Pro"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "V831W",
    "Device": "P731A10",
    "Model": "ZTE T320"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "V831W",
    "Device": "P731A10",
    "Model": "ZTE V831W"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "V8403",
    "Device": "roamer2",
    "Model": "V8403"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "V8514",
    "Device": "P821E10",
    "Model": "V8514"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "V856",
    "Device": "zte_v856",
    "Model": "ZTE-V856"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "V865M",
    "Device": "hct77_ics2",
    "Model": "V865M"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "V865M",
    "Device": "hct77_jb",
    "Model": "V865M"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "V879",
    "Device": "P172F02",
    "Model": "ZTE V879"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "V880E",
    "Device": "atlas40",
    "Model": "ZTE V880E"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "V880G",
    "Device": "ZTE-V880G",
    "Model": "ZTE V880G"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "V887",
    "Device": "P177A10",
    "Model": "ZTE Blade L"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "V887",
    "Device": "P177A10",
    "Model": "ZTE V887"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "V887",
    "Device": "P177A10",
    "Model": "tmn smart a20"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "V889D",
    "Device": "atlas40",
    "Model": "ZTE V889D"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "V889M",
    "Device": "P175A10",
    "Model": "UZTE V889M"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "V889M",
    "Device": "P175A10",
    "Model": "ZTE V889M"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "V891",
    "Device": "P986E01",
    "Model": "ZTE V891"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "V9",
    "Device": "v9",
    "Model": "A100"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "V9",
    "Device": "v9",
    "Model": "BASE Tab"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "V9",
    "Device": "v9",
    "Model": "BLACK 03"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "V9",
    "Device": "v9",
    "Model": "Beeline M2"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "V9",
    "Device": "v9",
    "Model": "Light"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "V9",
    "Device": "v9",
    "Model": "Light Tab"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "V9",
    "Device": "v9",
    "Model": "MTC 1055"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "V9",
    "Device": "v9",
    "Model": "One Pad"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "V9",
    "Device": "v9",
    "Model": "RTK V9"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "V9",
    "Device": "v9",
    "Model": "TO101"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "V9",
    "Device": "v9",
    "Model": "TT101"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "V9",
    "Device": "v9",
    "Model": "V9"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "V9",
    "Device": "v9",
    "Model": "V9C"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "V9",
    "Device": "v9",
    "Model": "V9c"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "V9",
    "Device": "v9",
    "Model": "V9e"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "V9",
    "Device": "v9",
    "Model": "myPad P2"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "V9180",
    "Device": "V9180",
    "Model": "V9180"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "V956",
    "Device": "ZTE-V956",
    "Model": "ZTE V956"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "V965",
    "Device": "P188F03",
    "Model": "ZTE Blade G2"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "V965",
    "Device": "P188F03",
    "Model": "ZTE R880H"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "V965",
    "Device": "P188F03",
    "Model": "ZTE V880H"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "V965",
    "Device": "P188F03",
    "Model": "ZTE V965"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "V969",
    "Device": "P682F01",
    "Model": "ZTE V969"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "V96A",
    "Device": "V96A",
    "Model": "V96A"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "V970",
    "Device": "whistler",
    "Model": "UZTE V970"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "V970",
    "Device": "whistler",
    "Model": "ZTE V970"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "V975",
    "Device": "redhookbay",
    "Model": "V975"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "V975",
    "Device": "redhookbay",
    "Model": "ZTE Geek"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "V975",
    "Device": "redhookbay",
    "Model": "ZTE V975"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "V9800",
    "Device": "kiska",
    "Model": "ZTE V9800"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "V9820",
    "Device": "ZTE-V9820",
    "Model": "ZTE V9820"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "V983",
    "Device": "P177A30",
    "Model": "ZTE V983"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "V987",
    "Device": "P188F04",
    "Model": "UZTE GRAND X Quad"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "V987",
    "Device": "P188F04",
    "Model": "ZTE Grand X"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "V987",
    "Device": "P188F04",
    "Model": "ZTE V987"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "V993W",
    "Device": "ZTE_V993W",
    "Model": "ZTE V993W"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "V9A",
    "Device": "v9plus",
    "Model": "Light Tab 2"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "V9A",
    "Device": "v9plus",
    "Model": "V9A"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "V9A",
    "Device": "v9plus",
    "Model": "ZTE V9A"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "V9A",
    "Device": "v9plus",
    "Model": "my Pad P3"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "V9A",
    "Device": "v9plus",
    "Model": "myPad P3"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "V9S",
    "Device": "V9S",
    "Model": "V9S"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "V9S",
    "Device": "V9S",
    "Model": "myPadP4"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "VERGATARIO 5",
    "Device": "ZTE_BLADE_L110",
    "Model": "VERGATARIO 5"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "VERGATARIO5PLUS",
    "Device": "ZTE_BLADE_L110",
    "Model": "VERGATARIO5PLUS"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "VFD 520",
    "Device": "VFD520",
    "Model": "VFD 520"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Verve Connect",
    "Device": "Z6201",
    "Model": "Z6103"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Vesta",
    "Device": "proline",
    "Model": "Z965"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Vip Racer III",
    "Device": "atlas40",
    "Model": "Vip Racer III"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Vodafone Smart Chat",
    "Device": "turies",
    "Model": "Vodafone Smart Chat"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Vodafone Smart X9",
    "Device": "VFD820",
    "Model": "VFD 820"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Vodafone Smart X9",
    "Device": "VFD822",
    "Model": "VFD 822"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Vodafone Smart ultra 6",
    "Device": "msm8916_32",
    "Model": "Vodafone Smart ultra 6"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Warp 7",
    "Device": "beam",
    "Model": "N9519"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "X500",
    "Device": "X500",
    "Model": "X500"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "X500",
    "Device": "X500",
    "Model": "ZTE-X500"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "X501_USA_Cricket",
    "Device": "X501",
    "Model": "X501_USA_Cricket"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "X501_USA_Cricket",
    "Device": "X501",
    "Model": "X501_USA_RS"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "X501_USA_OM",
    "Device": "X501",
    "Model": "X501_USA_OM"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "X9180",
    "Device": "X9180",
    "Model": "X9180"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Z-01K",
    "Device": "Z-01K",
    "Model": "Z-01K"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Z10",
    "Device": "P817E52",
    "Model": "ZTE Z10"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Z2020N3",
    "Device": "Z8850K",
    "Model": "A2020N3"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Z2339K",
    "Device": "Z2339",
    "Model": "Z2339K"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Z2351N",
    "Device": "P720F08",
    "Model": "Z2351N"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Z2359",
    "Device": "P606F13",
    "Model": "Z2359"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Z2450",
    "Device": "P963F65",
    "Model": "Z2450"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Z2453",
    "Device": "P963F95",
    "Model": "Z2453"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Z2453",
    "Device": "P963F95_A",
    "Model": "Z2453"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Z2459",
    "Device": "P616F05",
    "Model": "Z2459"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Z2465N",
    "Device": "P820F05",
    "Model": "Z2465N"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Z2472",
    "Device": "P606F20",
    "Model": "Z2472"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Z2472",
    "Device": "P606F20_A",
    "Model": "Z2472"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Z2570N",
    "Device": "P688F02",
    "Model": "Z2570N"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Z2575",
    "Device": "P620F02",
    "Model": "Z2575"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Z2576",
    "Device": "P620F01",
    "Model": "Z2576"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Z2577",
    "Device": "P615F02",
    "Model": "Z2577"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Z3153V",
    "Device": "Z3153",
    "Model": "Z3153V"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Z3351S",
    "Device": "Z3351",
    "Model": "Z3351S"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Z3352CA",
    "Device": "Z3352CA",
    "Model": "Z3352CA"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Z3353CA",
    "Device": "Z3353",
    "Model": "Z3353CA"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Z353VL",
    "Device": "oldman",
    "Model": "Z353VL"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Z40 Pro",
    "Device": "P898A11",
    "Model": "NX701J"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Z5031O",
    "Device": "Z5031O",
    "Model": "Z5031O"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Z5151V",
    "Device": "Z5151",
    "Model": "Z5151V"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Z5156CC",
    "Device": "Z5156U",
    "Model": "Z5156CC"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Z5158",
    "Device": "Z5158",
    "Model": "Z5158"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Z557BL",
    "Device": "Z557",
    "Model": "Z557BL"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Z557BL",
    "Device": "lewis",
    "Model": "Z557BL"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Z557BL",
    "Device": "msm8909",
    "Model": "Z557BL"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Z559DL",
    "Device": "Z559DL",
    "Model": "Z559DL"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Z6201V",
    "Device": "Z6201",
    "Model": "Z6201V"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Z6250CC",
    "Device": "Z6250",
    "Model": "Z6250CC"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Z6251",
    "Device": "Z6251",
    "Model": "Z6251"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Z6251V",
    "Device": "Z6251",
    "Model": "Z6251V"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Z6252CA",
    "Device": "Z6252",
    "Model": "Z6252CA"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Z6356T",
    "Device": "Z6356T",
    "Model": "Z6356T"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Z6410",
    "Device": "Z6410",
    "Model": "Z6410S"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Z6530M",
    "Device": "Z6530",
    "Model": "Z6530M"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Z6530V",
    "Device": "Z6530",
    "Model": "Z6530V"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Z6561J",
    "Device": "Z6561S",
    "Model": "Z6561J"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Z660G",
    "Device": "nice",
    "Model": "Z660G"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Z6621O",
    "Device": "Z6621O",
    "Model": "Z6621O"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Z665C",
    "Device": "seanplus",
    "Model": "Z665C"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Z667",
    "Device": "demi",
    "Model": "Z667"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Z667G",
    "Device": "demi",
    "Model": "Z667G"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Z667T",
    "Device": "bonnie",
    "Model": "Z667T"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Z669",
    "Device": "demi",
    "Model": "Z669"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Z716BL",
    "Device": "baffin",
    "Model": "Z716BL"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Z717VL",
    "Device": "lavender",
    "Model": "Z717VL"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Z730",
    "Device": "ada",
    "Model": "Z730"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Z740",
    "Device": "metis",
    "Model": "Z740"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Z740G",
    "Device": "metis",
    "Model": "Z740G"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Z750C",
    "Device": "Z750C",
    "Model": "Z750C"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Z752C",
    "Device": "eros",
    "Model": "Z752C"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Z753G",
    "Device": "faerie",
    "Model": "Z753G"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Z7540",
    "Device": "Z7540",
    "Model": "Z7540"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Z755",
    "Device": "iris",
    "Model": "Z755"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Z768G",
    "Device": "Z768G",
    "Model": "Z768G"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Z777",
    "Device": "betty",
    "Model": "Z777"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Z787",
    "Device": "apus",
    "Model": "Z787"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Z791G",
    "Device": "giant",
    "Model": "Z791G"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Z792",
    "Device": "giant",
    "Model": "Z792"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Z793C",
    "Device": "hera",
    "Model": "Z793C"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Z795G",
    "Device": "ZTE-Z795G",
    "Model": "Z795G"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Z796C",
    "Device": "Z796C",
    "Model": "Z796C"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Z797C",
    "Device": "carol",
    "Model": "Z797C"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Z812",
    "Device": "xuantan",
    "Model": "Z812"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Z813",
    "Device": "xuantan",
    "Model": "Z813"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Z818L",
    "Device": "sunny",
    "Model": "Z818L"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Z819L",
    "Device": "sungod",
    "Model": "Z819L"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Z820",
    "Device": "P675T07",
    "Model": "Z820"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Z826",
    "Device": "herculis",
    "Model": "Z826"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Z828",
    "Device": "achill",
    "Model": "Z828"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Z828",
    "Device": "achill",
    "Model": "Z828TL"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Z830",
    "Device": "gruis",
    "Model": "Z830"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Z832",
    "Device": "mimir",
    "Model": "Z832"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Z833",
    "Device": "camellia",
    "Model": "Z833"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Z835",
    "Device": "draco",
    "Model": "Z835"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Z836BL",
    "Device": "guardian",
    "Model": "Z836BL"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Z836F",
    "Device": "guardian",
    "Model": "Z836F"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Z837VL",
    "Device": "breaker",
    "Model": "Z837VL"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Z839",
    "Device": "sweet",
    "Model": "Z839"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Z839V",
    "Device": "sweet",
    "Model": "Z839V"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Z850",
    "Device": "sif",
    "Model": "Z850"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Z851M",
    "Device": "jeff",
    "Model": "Z851M"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Z861BL",
    "Device": "benz",
    "Model": "Z861BL"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Z862VL",
    "Device": "captain",
    "Model": "Z862VL"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Z899VL",
    "Device": "msm8909",
    "Model": "Z899VL"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Z916BL",
    "Device": "red",
    "Model": "Z916BL"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Z917VL",
    "Device": "fortune",
    "Model": "Z917VL"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Z930L",
    "Device": "coeus",
    "Model": "Z930L"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Z932L",
    "Device": "warplte",
    "Model": "Z932L"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Z932L",
    "Device": "warplte",
    "Model": "ZTE Z932L"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Z933",
    "Device": "glaucus",
    "Model": "Z933"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Z936L",
    "Device": "gift",
    "Model": "Z936L"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Z955L",
    "Device": "leo",
    "Model": "Z955A"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Z955L",
    "Device": "leo",
    "Model": "Z955L"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Z956",
    "Device": "financier",
    "Model": "Z956"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Z957",
    "Device": "financier",
    "Model": "Z957"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Z958",
    "Device": "lol",
    "Model": "Z958"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Z959",
    "Device": "abby",
    "Model": "Z959"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Z962BL",
    "Device": "tom",
    "Model": "Z962BL"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Z963U",
    "Device": "lily",
    "Model": "Z963U"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Z963VL",
    "Device": "nancy",
    "Model": "Z963VL"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Z970",
    "Device": "draconis",
    "Model": "Z970"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Z971",
    "Device": "peony",
    "Model": "Z971"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Z980L",
    "Device": "cygni",
    "Model": "Z980L"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Z981",
    "Device": "urd",
    "Model": "Z981"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Z986U",
    "Device": "cynthia",
    "Model": "Z986U"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Z987",
    "Device": "cygni",
    "Model": "Z987"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Z990",
    "Device": "roamer",
    "Model": "ZTE-Z990"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Z990G",
    "Device": "roamer",
    "Model": "ZTE-Z990G"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Z992",
    "Device": "aviva",
    "Model": "Z992"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Z993",
    "Device": "aviva",
    "Model": "Z993"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Z995",
    "Device": "becky",
    "Model": "Z995"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Z998",
    "Device": "coeus",
    "Model": "Z998"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Z999",
    "Device": "fujisan",
    "Model": "Z999"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZPAD",
    "Device": "gevjon",
    "Model": "K90U"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZR01",
    "Device": "Z7750R",
    "Model": "ZR01"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE  S30 Pro 5G",
    "Device": "P768A02",
    "Model": "ZTE A2122H"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE 1010L",
    "Device": "P963F61_A",
    "Model": "ZTE 1010L"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE 2050",
    "Device": "P671F50",
    "Model": "ZTE 2050"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE 2050",
    "Device": "P671F50_D",
    "Model": "ZTE 2050"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE 2050",
    "Device": "P671S50",
    "Model": "ZTE 2050"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE 2050RU",
    "Device": "P671F50_D",
    "Model": "ZTE 2050RU"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE 7060",
    "Device": "P606F07",
    "Model": "ZTE 7060"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE 7160N",
    "Device": "P720F02",
    "Model": "ZTE 7160N"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE 7530N",
    "Device": "P633S07",
    "Model": "ZTE 7530N"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE 7531N",
    "Device": "P720S07",
    "Model": "ZTE 7531N"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE 7532N",
    "Device": "P633S08",
    "Model": "ZTE 7532N"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE 7540N",
    "Device": "P633F08",
    "Model": "ZTE 7540N"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE 8010",
    "Device": "P963F05",
    "Model": "ZTE 8010"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE 8010",
    "Device": "P963S05",
    "Model": "ZTE 8010"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE 8010RU",
    "Device": "P963F05",
    "Model": "ZTE 8010RU"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE 8012N",
    "Device": "P653S06",
    "Model": "ZTE 8012N"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE 8030",
    "Device": "P720F05",
    "Model": "ZTE 9050N"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE 8030",
    "Device": "P963F06",
    "Model": "ZTE 8030"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE 8030",
    "Device": "P963F06",
    "Model": "ZTE 8031"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE 8030N",
    "Device": "P633S01",
    "Model": "ZTE 8030N"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE 8030RU",
    "Device": "P963F06",
    "Model": "ZTE 8030RU"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE 8031",
    "Device": "P963F06_A",
    "Model": "ZTE 8031"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE 8040N",
    "Device": "P633S05",
    "Model": "ZTE 8040N"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE 8045",
    "Device": "P606F02",
    "Model": "ZTE 8045"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE 8046",
    "Device": "P616F01",
    "Model": "ZTE 8046"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE 8050",
    "Device": "P606F08",
    "Model": "ZTE 8050"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE 8140N",
    "Device": "P633F10",
    "Model": "ZTE 8140N"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE 9030",
    "Device": "P618F05",
    "Model": "ZTE 9030"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE 9030N",
    "Device": "P653S07",
    "Model": "ZTE 9030N"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE 9030RU",
    "Device": "P618F05",
    "Model": "ZTE 9030RU"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE 9040N",
    "Device": "P653S11",
    "Model": "ZTE 9040N"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE 9041N",
    "Device": "P633S21",
    "Model": "ZTE 9041N"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE 9042N",
    "Device": "P633S31",
    "Model": "ZTE 9042N"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE 9045",
    "Device": "P618F06",
    "Model": "ZTE 9045"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE 9045RU",
    "Device": "P618F06",
    "Model": "ZTE 9045RU"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE 9046",
    "Device": "P618F07",
    "Model": "ZTE 9046"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE 9047",
    "Device": "P618F08",
    "Model": "ZTE 9047"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE 9050N",
    "Device": "P720F05",
    "Model": "ZTE 9050N"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE 9100N",
    "Device": "P633F05",
    "Model": "ZTE 9100N"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE A0616",
    "Device": "P637S15",
    "Model": "ZTE A0616"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE A0620",
    "Device": "P840S13",
    "Model": "ZTE A0620"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE A0622",
    "Device": "P817S13",
    "Model": "ZTE A0622"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE A0722",
    "Device": "P840S18",
    "Model": "ZTE A0722"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE A20 5G",
    "Device": "P725A02",
    "Model": "ZTE A2121"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE A2017",
    "Device": "msm8996",
    "Model": "ZTE A2017"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE A2017G",
    "Device": "ailsa_ii",
    "Model": "ZTE A2017G"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE A2017U",
    "Device": "ailsa_ii",
    "Model": "ZTE A2017U"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE A2018",
    "Device": "candice",
    "Model": "ZTE A2018"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE A2019 Pro",
    "Device": "P845A02",
    "Model": "ZTE A2019 Pro"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE A2019G Pro",
    "Device": "P845A01",
    "Model": "ZTE A2019G Pro"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE A2020N2 Pro",
    "Device": "P855A21",
    "Model": "ZTE A2020N2 Pro"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE A2020N2 Pro",
    "Device": "P855A21",
    "Model": "ZTE A2020N3 Pro"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE A2022L",
    "Device": "P618A11",
    "Model": "ZTE A2022L"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE A2022PG",
    "Device": "P875A11",
    "Model": "ZTE A2022PG"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE A2023",
    "Device": "P870A21",
    "Model": "ZTE A2023"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE A2023G",
    "Device": "P870F21",
    "Model": "ZTE A2023G"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE A2023P",
    "Device": "P898A01",
    "Model": "ZTE A2023P"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE A2023PG",
    "Device": "P898F01",
    "Model": "ZTE A2023PG"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE A2121E",
    "Device": "P618A01",
    "Model": "ZTE A2121E"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE A2121L",
    "Device": "P618A03",
    "Model": "ZTE A2121L"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE A2122H",
    "Device": "P768A02",
    "Model": "ZTE A2122H"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE A2322",
    "Device": "P870A01",
    "Model": "ZTE A2322"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE A2322G",
    "Device": "P870A02",
    "Model": "ZTE A2322G"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE A31 Lite",
    "Device": "Z3052O",
    "Model": "ZTE A31 Lite"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE A51",
    "Device": "P963F60",
    "Model": "ZTE A51"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE A520S",
    "Device": "P809S10",
    "Model": "ZTE A520S"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE A53",
    "Device": "P963F62",
    "Model": "ZTE A53"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE A530",
    "Device": "P639T10",
    "Model": "ZTE A530"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE A55",
    "Device": "P963F65",
    "Model": "ZTE A55"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE A606",
    "Device": "P639S10",
    "Model": "ZTE A606"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE A7000",
    "Device": "P671S02",
    "Model": "ZTE A7000"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE A7010",
    "Device": "P662S02",
    "Model": "ZTE A7010"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE A7020",
    "Device": "P963F03",
    "Model": "ZTE A7020"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE A7030",
    "Device": "P963F07",
    "Model": "ZTE A7030"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE A7030RU",
    "Device": "P963F07",
    "Model": "ZTE A7030RU"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE A7040",
    "Device": "P606F01",
    "Model": "ZTE A7040"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE A7050",
    "Device": "P606F05",
    "Model": "ZTE A7050"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE A71 5G",
    "Device": "Z6556O",
    "Model": "ZTE A71 5G"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE AVID 4",
    "Device": "calbee",
    "Model": "Z855"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE AVID 559",
    "Device": "Z559DL",
    "Model": "Z559DL"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE Avid 579",
    "Device": "Z5156",
    "Model": "Z5156CC"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE Axon 10 Pro",
    "Device": "P855A01",
    "Model": "ZTE A2020G Pro"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE Axon 10 Pro",
    "Device": "P855A01",
    "Model": "ZTE A2020RU Pro"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE Axon 10 Pro",
    "Device": "P855A02",
    "Model": "ZTE A2020 Pro"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE Axon 10 Pro",
    "Device": "P855A03",
    "Model": "ZTE Axon 10 Pro"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE Axon 10 Pro",
    "Device": "P855A03_NA",
    "Model": "ZTE A2020U Pro"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE Axon 10 Pro",
    "Device": "P855A21",
    "Model": "ZTE A2020N3 Pro"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE Axon 10s Pro 5G",
    "Device": "P865A02",
    "Model": "ZTE A2020 SP"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE Axon 11",
    "Device": "P671A11",
    "Model": "ZTE A2021L"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE Axon 11",
    "Device": "P671A13",
    "Model": "ZTE A2021E"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE Axon 11 5G",
    "Device": "P725A11",
    "Model": "ZTE A2021G"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE Axon 11 5G",
    "Device": "P725A12",
    "Model": "ZTE A2021"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE Axon 11 5G",
    "Device": "P725A12",
    "Model": "ZTE A2021H"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE Axon 11 SE 5G",
    "Device": "P683S10",
    "Model": "ZTE 9000N"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE Axon 20 5G",
    "Device": "P725A02",
    "Model": "ZTE A2121G"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE Axon 30 Pro 5G",
    "Device": "P875A12",
    "Model": "ZTE A2022P"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE Axon 30 Ultra 5G",
    "Device": "P875A11",
    "Model": "ZTE A2022PG"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE Axon 60",
    "Device": "P616F02",
    "Model": "Z2356"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE Axon 60 Lite",
    "Device": "P606F10",
    "Model": "Z2350"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE B2017",
    "Device": "msm8952_64",
    "Model": "ZTE B2017"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE BLADE A0605",
    "Device": "P809F15",
    "Model": "ZTE BLADE A0605"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE BLADE A0605",
    "Device": "P809F15",
    "Model": "ZTE BLADE A6 MAX"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE BLADE A0620",
    "Device": "P840F12",
    "Model": "ZTE BLADE A0620"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE BLADE A0621",
    "Device": "P840F13",
    "Model": "ZTE BLADE A0621"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE BLADE A0622",
    "Device": "P809F12",
    "Model": "ZTE BLADE A0622"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE BLADE A125",
    "Device": "P809F01",
    "Model": "ZTE BLADE A125"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE BLADE A3",
    "Device": "P809F40",
    "Model": "ZTE BLADE A3"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE BLADE A3 LITE",
    "Device": "P932F20",
    "Model": "ZTE Blade A3 Lite"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE BLADE A320",
    "Device": "P809F20",
    "Model": "ZTE BLADE A320"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE BLADE A321",
    "Device": "VFD511",
    "Model": "ZTE BLADE A321"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE BLADE A322",
    "Device": "P809V52",
    "Model": "ZTE BLADE A322"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE BLADE A330",
    "Device": "P809F30",
    "Model": "ZTE BLADE A330"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE BLADE A506",
    "Device": "P809T70",
    "Model": "ZTE BLADE A506"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE BLADE A520",
    "Device": "P637F10",
    "Model": "ZTE BLADE A520"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE BLADE A520C",
    "Device": "P809F10",
    "Model": "ZTE BLADE A520C"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE BLADE A521",
    "Device": "P809F10",
    "Model": "ZTE BLADE A521"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE BLADE A522",
    "Device": "P817E53",
    "Model": "ZTE BLADE A522"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE BLADE A522",
    "Device": "P817E53",
    "Model": "ZTE Blade A522"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE BLADE A530",
    "Device": "P639F10",
    "Model": "ZTE BLADE A530"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE BLADE A530",
    "Device": "P639F10L",
    "Model": "ZTE BLADE A530"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE BLADE A6",
    "Device": "P840F13",
    "Model": "ZTE BLADE A6"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE BLADE A6 MAX",
    "Device": "P809F15",
    "Model": "ZTE BLADE A6 MAX"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE BLADE A602",
    "Device": "P637F02",
    "Model": "ZTE BLADE A602"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE BLADE A610",
    "Device": "ZTE_BLADE_A610",
    "Model": "ZTE BLADE A610"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE BLADE A612",
    "Device": "P635F50",
    "Model": "ZTE BLADE A612"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE BLADE A910",
    "Device": "P635A31",
    "Model": "ZTE BLADE A910"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE BLADE L111",
    "Device": "ZTE_BLADE_L110",
    "Model": "ZTE BLADE B111"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE BLADE L111",
    "Device": "ZTE_BLADE_L110",
    "Model": "ZTE BLADE L110"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE BLADE L111",
    "Device": "ZTE_BLADE_L110",
    "Model": "ZTE BLADE L111"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE BLADE L7",
    "Device": "P731F10",
    "Model": "ZTE BLADE L7"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE BLADE L7A",
    "Device": "P731F12",
    "Model": "ZTE BLADE L7A"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE BLADE L8",
    "Device": "P731F12",
    "Model": "ZTE BLADE L8"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE BLADE V Ultra Z982",
    "Device": "crocus",
    "Model": "ZTE BLADE V Ultra Z982"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE BLADE V0710",
    "Device": "ZTE_BLADE_V0710",
    "Model": "ZTE BLADE V0710"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE BLADE V0720",
    "Device": "ZTE_BLADE_V0720",
    "Model": "ZTE BLADE V0720"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE BLADE V0800",
    "Device": "ZTE_BLADE_V0800",
    "Model": "ZTE BLADE V0800"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE BLADE V0820",
    "Device": "ZTE_BLADE_V0820",
    "Model": "ZTE BLADE V0820"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE BLADE V0840",
    "Device": "P817F01",
    "Model": "ZTE BLADE V0840"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE BLADE V0850",
    "Device": "ZTE_BLADE_V0850",
    "Model": "ZTE BLADE V0850"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE BLADE V0920",
    "Device": "P840F03",
    "Model": "ZTE BLADE V0920"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE BLADE V7 PLUS",
    "Device": "P653A11",
    "Model": "ZTE BLADE V7 PLUS"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE BLADE V9",
    "Device": "P450F10",
    "Model": "ZTE BLADE V0900"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE BLADE V9",
    "Device": "P450F10",
    "Model": "ZTE BLADE V9"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE BLADE V9",
    "Device": "P450L10",
    "Model": "ZTE BLADE V9"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE BLADE V9 VITA",
    "Device": "P840F03",
    "Model": "ZTE BLADE V9 VITA"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE BLade Zmax",
    "Device": "crocus",
    "Model": "Z982"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE BV0870",
    "Device": "P840V71",
    "Model": "ZTE BV0870"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE Blade 10 Vita",
    "Device": "P963F01",
    "Model": "ZTE Blade 10 Vita"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE Blade A0722",
    "Device": "P817F18",
    "Model": "ZTE Blade A0722"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE Blade A3 2019",
    "Device": "P932F20",
    "Model": "P500"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE Blade A3 2019",
    "Device": "P932F20",
    "Model": "ZTE Blade A3 2019"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE Blade A3 2019",
    "Device": "P932F20",
    "Model": "ZTE Blade A3 Lite"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE Blade A3 2019",
    "Device": "P932K20",
    "Model": "ZTE Blade A3 2019"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE Blade A3 2019RU",
    "Device": "P932F20",
    "Model": "ZTE Blade A3 2019RU"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE Blade A3 2020",
    "Device": "P932F50",
    "Model": "Blade A3 2020-T"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE Blade A3 2020",
    "Device": "P932F50",
    "Model": "ZTE Blade A3 2020"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE Blade A3 2020",
    "Device": "P932K30",
    "Model": "ZTE Blade A3 2020"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE Blade A3 2020RU",
    "Device": "P932F50",
    "Model": "ZTE Blade A3 2020RU"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE Blade A3 Lite",
    "Device": "P932F20",
    "Model": "ZTE Blade A3 Lite"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE Blade A31",
    "Device": "P963F70",
    "Model": "ZTE Blade A31"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE Blade A31 Lite",
    "Device": "P932F21",
    "Model": "ZTE Blade A31 Lite"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE Blade A31 Lite",
    "Device": "P932F21_A",
    "Model": "ZTE Blade A31 Lite"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE Blade A31 Lite RU",
    "Device": "P932F21",
    "Model": "ZTE Blade A31 Lite RU"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE Blade A31 Plus",
    "Device": "P963F80",
    "Model": "ZTE Blade A31 Plus"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE Blade A31 Plus RU",
    "Device": "P963F80",
    "Model": "ZTE Blade A31 Plus RU"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE Blade A31RU",
    "Device": "P963F70",
    "Model": "ZTE Blade A31RU"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE Blade A31RU",
    "Device": "P963F71",
    "Model": "ZTE Blade A31RU"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE Blade A32",
    "Device": "P963F90W",
    "Model": "ZTE Blade A32"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE Blade A33",
    "Device": "P932F22",
    "Model": "ZTE Blade A33"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE Blade A33 Cor",
    "Device": "P932F23",
    "Model": "ZTE Blade A33 Core"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE Blade A33 Core",
    "Device": "P932F23",
    "Model": "ZTE Blade A33 Core"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE Blade A33+",
    "Device": "P963F91",
    "Model": "ZTE Blade A33+"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE Blade A33+ Core",
    "Device": "P963F92",
    "Model": "ZTE Blade A33+ Core"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE Blade A33s",
    "Device": "P963F93",
    "Model": "ZTE Blade A33s"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE Blade A34",
    "Device": "P963F94",
    "Model": "ZTE Blade A34"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE Blade A34",
    "Device": "P963F94_A",
    "Model": "ZTE Blade A34"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE Blade A35 Core",
    "Device": "P963F10",
    "Model": "ZTE Blade A35 Core"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE Blade A35 Lite",
    "Device": "P963F10",
    "Model": "ZTE Blade A35 Lite"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE Blade A35e",
    "Device": "P963F66",
    "Model": "Z2466"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE Blade A35s",
    "Device": "P963F66",
    "Model": "Z2466"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE Blade A36e",
    "Device": "P963F66",
    "Model": "Z2466"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE Blade A3v",
    "Device": "Z5157",
    "Model": "Z5157V"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE Blade A3v",
    "Device": "Z5157",
    "Model": "Z5157Y"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE Blade A5 2019",
    "Device": "P963F30",
    "Model": "ZTE Blade A5 2019"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE Blade A5 2019",
    "Device": "P963F30P",
    "Model": "ZTE Blade A5 2019"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE Blade A5 2019RU",
    "Device": "P963F30P",
    "Model": "ZTE Blade A5 2019RU"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE Blade A5 2020",
    "Device": "P963F50",
    "Model": "Blade A5 2020-T"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE Blade A5 2020",
    "Device": "P963F50",
    "Model": "Z-Ultra"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE Blade A5 2020",
    "Device": "P963F50",
    "Model": "ZTE Blade A5 2020"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE Blade A5 2020",
    "Device": "P963F50_A",
    "Model": "ZTE Blade A5 2020"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE Blade A5 2020RU",
    "Device": "P963F50",
    "Model": "ZTE Blade A5 2020RU"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE Blade A51",
    "Device": "P963F60",
    "Model": "ZTE Blade A51"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE Blade A51",
    "Device": "Z6355O",
    "Model": "ZTE Blade A51"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE Blade A51 Lite",
    "Device": "P963F50_A",
    "Model": "ZTE Blade A51 Lite"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE Blade A51 Lite RU",
    "Device": "P963F50_A",
    "Model": "ZTE Blade A51 Lite RU"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE Blade A51RU",
    "Device": "P963F60",
    "Model": "ZTE Blade A51RU"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE Blade A52",
    "Device": "P963F61",
    "Model": "ZTE Blade A52"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE Blade A52",
    "Device": "P963F61_A",
    "Model": "ZTE Blade A52"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE Blade A52 Lite",
    "Device": "P963F51W",
    "Model": "ZTE Blade A52 Lite"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE Blade A522",
    "Device": "P817E53",
    "Model": "ZTE Blade A522"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE Blade A52RU",
    "Device": "P963F61",
    "Model": "ZTE Blade A52RU"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE Blade A52RU",
    "Device": "P963F61_A",
    "Model": "ZTE Blade A52RU"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE Blade A53",
    "Device": "P963F62",
    "Model": "ZTE Blade A53"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE Blade A53 Pro",
    "Device": "P963F63",
    "Model": "ZTE Blade A53 Pro"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE Blade A53+",
    "Device": "P963F62",
    "Model": "P630"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE Blade A53+",
    "Device": "P963F62",
    "Model": "ZTE Blade A53+"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE Blade A53+",
    "Device": "P963F62_A",
    "Model": "ZTE Blade A53+"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE Blade A531",
    "Device": "P932F10",
    "Model": "ZTE Blade A531"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE Blade A54",
    "Device": "P963F64",
    "Model": "ZTE Blade A54"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE Blade A56",
    "Device": "P606F21",
    "Model": "Z2473"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE Blade A56 Pro",
    "Device": "P615F01",
    "Model": "Z2474"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE Blade A7 2019",
    "Device": "P963F02",
    "Model": "ZTE Blade A7 2019"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE Blade A7 2019RU",
    "Device": "P963F02",
    "Model": "ZTE Blade A7 2019RU"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE Blade A7 2020",
    "Device": "P662F02",
    "Model": "ZTE Blade A7 2020"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE Blade A7 2020",
    "Device": "P662F02D",
    "Model": "ZTE Blade A7 2020"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE Blade A7 2020",
    "Device": "P662F02_D1",
    "Model": "ZTE Blade A7 2020"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE Blade A7 2020",
    "Device": "P662F02_D2",
    "Model": "ZTE Blade A7 2020"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE Blade A7 2020RU",
    "Device": "P662F02D",
    "Model": "ZTE Blade A7 2020RU"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE Blade A7 2020RU",
    "Device": "P662F02_D1",
    "Model": "ZTE Blade A7 2020RU"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE Blade A72s",
    "Device": "P606F05",
    "Model": "ZTE A7050"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE Blade A73",
    "Device": "P606F07",
    "Model": "ZTE 7060"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE Blade A75 5G",
    "Device": "P720F09",
    "Model": "Z2357N"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE Blade A75 5G S",
    "Device": "P720F09",
    "Model": "Z2357N"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE Blade A76",
    "Device": "P615F01",
    "Model": "Z2474"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE Blade A76 5G",
    "Device": "P780F03",
    "Model": "Z2469N"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE Blade A7s",
    "Device": "P662F02",
    "Model": "ZTE Blade A7s"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE Blade A7s 2020",
    "Device": "P963F03",
    "Model": "ZTE A7020"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE Blade A7s 2020",
    "Device": "P963F03",
    "Model": "ZTE A7020RU"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE Blade L110",
    "Device": "ZTE_BLADE_L110",
    "Model": "ZTE Blade L110"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE Blade L130",
    "Device": "P731F30",
    "Model": "ZTE Blade L130"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE Blade L130",
    "Device": "P731K30",
    "Model": "ZTE Blade L130"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE Blade L130RU",
    "Device": "P731F30",
    "Model": "ZTE Blade L130RU"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE Blade L210",
    "Device": "P731F50",
    "Model": "ZTE Blade L210"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE Blade L210RU",
    "Device": "P731F50",
    "Model": "ZTE Blade L210RU"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE Blade L220",
    "Device": "P731F60",
    "Model": "ZTE Blade L220"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE Blade L5",
    "Device": "P172A40",
    "Model": "ZTE Blade L5"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE Blade L8",
    "Device": "P731F20",
    "Model": "ZTE Blade L8"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE Blade L8RU",
    "Device": "P731F20",
    "Model": "ZTE Blade L8RU"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE Blade L9",
    "Device": "P731F21",
    "Model": "ZTE Blade L9"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE Blade L9RU",
    "Device": "P731F21",
    "Model": "ZTE Blade L9RU"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE Blade V 2020",
    "Device": "P671F60",
    "Model": "ZTE 9000"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE Blade V 2020",
    "Device": "P671F60",
    "Model": "ZTE 9000RU"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE Blade V10",
    "Device": "P671F20",
    "Model": "ZTE Blade V10"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE Blade V10 Vita",
    "Device": "P963F01",
    "Model": "ZTE Blade V10 Vita"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE Blade V10 Vita RU",
    "Device": "P963F01",
    "Model": "ZTE Blade V10 Vita RU"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE Blade V10 Vita RU",
    "Device": "P963F01D",
    "Model": "ZTE Blade V10 Vita RU"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE Blade V1000",
    "Device": "P671F20",
    "Model": "ZTE Blade V10"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE Blade V1000",
    "Device": "P671F20",
    "Model": "ZTE Blade V1000"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE Blade V1000RU",
    "Device": "P671F20D",
    "Model": "ZTE Blade V1000RU"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE Blade V2020 Vita",
    "Device": "P671F70",
    "Model": "ZTE 8000"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE Blade V41 Smart",
    "Device": "P606F05",
    "Model": "ZTE A7050"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE Blade V50 Design",
    "Device": "P606F08",
    "Model": "ZTE 8050"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE Blade V50 Design",
    "Device": "P606F08",
    "Model": "nubia 8050"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE Blade V50 Design 5G",
    "Device": "P720F03",
    "Model": "ZTE 8150N"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE Blade V50 Vita",
    "Device": "P606F09",
    "Model": "ZTE 8550"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE Blade V60",
    "Device": "P616F02",
    "Model": "Z2356"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE Blade V60 Design",
    "Device": "P606F10",
    "Model": "Z2350"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE Blade V60 Vita",
    "Device": "P606F10",
    "Model": "Z2350"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE Blade V70 Design",
    "Device": "P606F17",
    "Model": "Z2458"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE Blade V70 Max",
    "Device": "P606F19",
    "Model": "Z2467"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE Blade V70 Vita",
    "Device": "P606F17",
    "Model": "Z2458"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE Blade V770",
    "Device": "P852F52",
    "Model": "ZTE Blade V770"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE Blade V8 Arc",
    "Device": "P840V80",
    "Model": "ZTE Blade V8 Arc"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE Blade V9",
    "Device": "P450S10",
    "Model": "ZTE V0900"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE Blade X10",
    "Device": "P963T01C",
    "Model": "ZTE T1002"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE Blade X10 II",
    "Device": "P616T03C",
    "Model": "YURATAB YT110"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE Blade X10 II",
    "Device": "P616T03_AC",
    "Model": "ZTE T1006"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE Blade X10 II Pro+",
    "Device": "P618T01C",
    "Model": "ZTE T1004"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE Blade X10 Pro",
    "Device": "P963T02C",
    "Model": "ZTE T1003"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE Blade X1001",
    "Device": "P606T07C",
    "Model": "ZTE X1001"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE Blade X10s",
    "Device": "P963T01C",
    "Model": "ZTE T1002"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE Blade X1101",
    "Device": "P616T04C",
    "Model": "ZTE X1101"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE Blade X8 II",
    "Device": "P616T02C",
    "Model": "ZTE T0805"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE Blade X8 II",
    "Device": "P616T02_BC",
    "Model": "YURATAB YT108"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE Blade X8 II Pro",
    "Device": "P616T02_AC",
    "Model": "ZTE T0805"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE Blade X8 Pro",
    "Device": "P616T01C",
    "Model": "ZTE T0802"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE Blade X8701",
    "Device": "P606T05C",
    "Model": "ZTE X8701"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE C2017",
    "Device": "alice",
    "Model": "ZTE C2017"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE E7LS",
    "Device": "ZTE_E7LS",
    "Model": "ZTE E7LS"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE Fanfare 3",
    "Device": "kelly",
    "Model": "Z852"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE Focus",
    "Device": "P616F03",
    "Model": "Z2455"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE N939Sc",
    "Device": "zx55q05_64",
    "Model": "LS-5504"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE N939Sc",
    "Device": "zx55q05_64",
    "Model": "ZTE Blade X9"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE N939Sc",
    "Device": "zx55q05_64",
    "Model": "ZTE N939Sc"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE N939Sc",
    "Device": "zx55q05_64",
    "Model": "ZTE N939St"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE Note 13 Pro",
    "Device": "Z2470C",
    "Model": "Z2470C"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE Note14 Pro+",
    "Device": "Z2471C",
    "Model": "Z2471C"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE Overture 3",
    "Device": "jeff",
    "Model": "Z851"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE PA01",
    "Device": "P898P01",
    "Model": "ZTE PA01"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE Pad X1102N",
    "Device": "P720T01",
    "Model": "X1102N"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE T0801",
    "Device": "P876T01J",
    "Model": "ZTE T0801"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE Tempo X",
    "Device": "grayjoylite",
    "Model": "N9137"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE U5",
    "Device": "enterprise",
    "Model": "ZTE U5"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE U791",
    "Device": "P810T01",
    "Model": "ZTE U791"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE U791",
    "Device": "P810T01",
    "Model": "ZTE U791(OPEN)"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE U808",
    "Device": "P825T10",
    "Model": "ZTE U808"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE U808",
    "Device": "P825T10",
    "Model": "ZTE U808(OPEN)"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE U819",
    "Device": "P188T20",
    "Model": "ZTE U819"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE U887",
    "Device": "P810A20",
    "Model": "ZTE U887"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE U956",
    "Device": "P188T10",
    "Model": "ZTE U956"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE U960E",
    "Device": "P117T21",
    "Model": "ZTE U960E"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE V0840",
    "Device": "P817S01",
    "Model": "ZTE V0840"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE V0920",
    "Device": "P840S03",
    "Model": "ZTE V0920"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE V1000",
    "Device": "P671S20",
    "Model": "ZTE V1000"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE V1050",
    "Device": "P671S50",
    "Model": "ZTE V1050"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE V890",
    "Device": "sdm660_64",
    "Model": "ZTE V890"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE X1010",
    "Device": "P310T10",
    "Model": "ZTE X1010"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE ZFive C LTE",
    "Device": "msm8909",
    "Model": "Z558VL"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE ZPAD8",
    "Device": "K83",
    "Model": "K83V"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE-V9VITA",
    "Device": "P840F03",
    "Model": "ZTE-V9VITA"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE_Blade_V1000",
    "Device": "P671F20",
    "Model": "ZTE Blade V1000"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE_Blade_X10_II_Pro",
    "Device": "P616T03C",
    "Model": "ZTE T1006"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE_Blade_X10_II_Pro+",
    "Device": "P618T01C",
    "Model": "ZTE T1004"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE_Blade_X8_II_Pro",
    "Device": "P616T02C",
    "Model": "ZTE_T0805"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE_V971LM",
    "Device": "ZTE_V971LM",
    "Model": "ZTE_V971LM"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE_V97L",
    "Device": "ZTE_V97L",
    "Model": "ZTE_V97L"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE Axon 30 5G",
    "Device": "P875A02",
    "Model": "ZTE A2022"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE Axon 30 5G",
    "Device": "P875A02",
    "Model": "ZTE A2022H"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTE Grand X View 3",
    "Device": "K83CA",
    "Model": "K83CA"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTG01",
    "Device": "Z6750K",
    "Model": "ZTG01"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZTU31",
    "Device": "P852F52",
    "Model": "ZTU31"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZXV10_TCS500B",
    "Device": "ZXV10_TCS500B",
    "Model": "ZXV10_TCS500B"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZXY-ZTE_N8010",
    "Device": "N8010_YM",
    "Model": "ZXY-ZTE_N8010"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZXY-ZTE_V6700",
    "Device": "V6700",
    "Model": "ZTE V6700"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "ZXY-ZTE_V6700",
    "Device": "V6700",
    "Model": "ZXY-ZTE_V6700"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Zmax 3",
    "Device": "dandelion",
    "Model": "Z978"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Zmax One",
    "Device": "msm8909",
    "Model": "Z719DL"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "Zmax Pro",
    "Device": "urd",
    "Model": "Z981"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "blade S",
    "Device": "blade2",
    "Model": "Blade S"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "dtac phone M1",
    "Device": "P635A50",
    "Model": "dtac phone M1"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "myPad P5",
    "Device": "K78",
    "Model": "Amazing_P5"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "myPad P5",
    "Device": "K78",
    "Model": "myPad P5"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "nubia  Z30 Pro",
    "Device": "P875N02",
    "Model": "NX667J"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "nubia 8046",
    "Device": "P616F01",
    "Model": "nubia 8046"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "nubia A56",
    "Device": "P606F21",
    "Model": "Z2473"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "nubia A75",
    "Device": "Z6255",
    "Model": "Z6255CA"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "nubia A76",
    "Device": "P615F01",
    "Model": "Z2474"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "nubia A76",
    "Device": "Z6657",
    "Model": "Z6657CA"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "nubia A76 5G",
    "Device": "P780F03",
    "Model": "Z2469N"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "nubia Air",
    "Device": "P780F02",
    "Model": "Z2468N"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "nubia Flip 2 5G",
    "Device": "P678F01",
    "Model": "NX732J"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "nubia Flip 2 5G",
    "Device": "Z8900",
    "Model": "Z8900CA"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "nubia Flip 5G",
    "Device": "P745F01",
    "Model": "NX724J"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "nubia Flip 5G",
    "Device": "Z8888S",
    "Model": "NX724J"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "nubia Flip 5G S",
    "Device": "P745F01",
    "Model": "NX724J"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "nubia Focus",
    "Device": "P616F03",
    "Model": "Z2455"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "nubia Focus 2 5G",
    "Device": "P720F11",
    "Model": "Z2462N"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "nubia Focus 2 5G",
    "Device": "Z7305O",
    "Model": "nubia Focus 2 5G"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "nubia Focus 2 Ultra 5G",
    "Device": "P720F12",
    "Model": "Z2463N"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "nubia Focus 5G",
    "Device": "P720F09",
    "Model": "Focus 5G"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "nubia Focus 5G",
    "Device": "P720F09",
    "Model": "Z2357N"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "nubia Music",
    "Device": "P963F11",
    "Model": "Z2353"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "nubia Music 2",
    "Device": "P606F18",
    "Model": "Z2460"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "nubia Music Pro",
    "Device": "P606F18",
    "Model": "Z2460"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "nubia Neo 2 5G",
    "Device": "P820F03",
    "Model": "Z2352N"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "nubia Neo 3",
    "Device": "P720F10",
    "Model": "Z2461"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "nubia Neo 3 5G",
    "Device": "P780F01",
    "Model": "Z2464N"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "nubia Neo 3 GT 5G",
    "Device": "Z7606O",
    "Model": "Z2465N"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "nubia Neo 5G",
    "Device": "P720F03_A",
    "Model": "nubia 8150N"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "nubia Pad 3D",
    "Device": "LumePad",
    "Model": "LPD-20W"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "nubia Pad 3D II",
    "Device": "K68",
    "Model": "NP02J"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "nubia Pad 5G",
    "Device": "K99O",
    "Model": "nubia Pad 5G"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "nubia Pad SE",
    "Device": "K99J",
    "Model": "K99J"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "nubia Play",
    "Device": "NX651J",
    "Model": "NX651J"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "nubia S2R",
    "Device": "Z6305R",
    "Model": "Z6305R"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "nubia S2e",
    "Device": "Z6302S",
    "Model": "A507ZT"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "nubia V50 Vita",
    "Device": "P606F09",
    "Model": "nubia 8550"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "nubia V60",
    "Device": "P616F02",
    "Model": "Z2356"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "nubia V60 Design",
    "Device": "P606F10",
    "Model": "Z2350"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "nubia V70 Design",
    "Device": "P606F17",
    "Model": "Z2458"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "nubia V70 Max",
    "Device": "P606F19",
    "Model": "Z2467"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "nubia Z5",
    "Device": "NX501",
    "Model": "nubia Z5"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "nubia Z50 Ultra",
    "Device": "PQ82A11",
    "Model": "NX712J"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "nubia Z50S Pro",
    "Device": "PQ82A02",
    "Model": "NX713J"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "nubia Z60 Ultra",
    "Device": "PQ83A01",
    "Model": "NX721J"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "nubia Z60 Ultra",
    "Device": "PQ83F01",
    "Model": "NX721J"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "nubia Z60S Pro",
    "Device": "PQ82A04",
    "Model": "NX725J"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "nubia Z70 Ultra",
    "Device": "PQ84A01",
    "Model": "NX733J"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "nubia Z70 Ultra",
    "Device": "PQ84A01",
    "Model": "NX736J"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "nubia Z70S Ultra",
    "Device": "PQ84A02",
    "Model": "NX733J"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "nubia Z70S Ultra",
    "Device": "PQ84A02",
    "Model": "NX737J"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "nubia Z80",
    "Device": "PQ85A01",
    "Model": "NX741J"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "sapphire lte",
    "Device": "sapphire4g",
    "Model": "Z3001S"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "tmn smart a15",
    "Device": "atlas40",
    "Model": "tmn smart a15"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "tmn smart a60",
    "Device": "kiska",
    "Model": "tmn smart a60"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "tmn smart a7",
    "Device": "sailboat",
    "Model": "tmn smart a7"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "zBOX 2",
    "Device": "YMA",
    "Model": "zBOX 2"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "zBox 1",
    "Device": "YXE",
    "Model": "zBox 1"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "中兴Axon 50 Ultra 5G",
    "Device": "P898A25",
    "Model": "ZTE A2024H"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "中兴畅行40",
    "Device": "P963S71",
    "Model": "ZTE 1020L"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "中兴远航41",
    "Device": "P720S11",
    "Model": "ZTE 7541N"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "红魔10 Pro",
    "Device": "NX789J",
    "Model": "NX789J"
  },
  {
    "Retail Branding": "ZTE",
    "Marketing Name": "红魔11 Pro游戏手机",
    "Device": "NX809J",
    "Model": "NX809J"
  },
  {
    "Retail Branding": "ZTLEKE",
    "Marketing Name": "P10",
    "Device": "P10",
    "Model": "P10"
  },
  {
    "Retail Branding": "ZTLEKE",
    "Marketing Name": "P10MAX",
    "Device": "P10MAX",
    "Model": "P10MAX"
  },
  {
    "Retail Branding": "ZTLEKE",
    "Marketing Name": "P10MAX2",
    "Device": "P10MAX2",
    "Model": "P10MAX2"
  },
  {
    "Retail Branding": "ZTLEKE",
    "Marketing Name": "P10PRO",
    "Device": "P10PRO",
    "Model": "P10PRO"
  },
  {
    "Retail Branding": "ZTLEKE",
    "Marketing Name": "P10Pro3",
    "Device": "P10Pro3",
    "Model": "P10Pro3"
  },
  {
    "Retail Branding": "ZTLEKE",
    "Marketing Name": "S8Plus",
    "Device": "S8Plus",
    "Model": "S8Plus"
  },
  {
    "Retail Branding": "ZTLEKE",
    "Marketing Name": "S8Plus2",
    "Device": "S8Plus2",
    "Model": "S8Plus2"
  },
  {
    "Retail Branding": "ZUKU",
    "Marketing Name": "A151",
    "Device": "A155",
    "Model": "A151"
  },
  {
    "Retail Branding": "ZUKU",
    "Marketing Name": "DV8330-T2",
    "Device": "DV8330-T2",
    "Model": "DV8330-T2"
  },
  {
    "Retail Branding": "ZULEISY",
    "Marketing Name": "E10A_EA",
    "Device": "E10A",
    "Model": "E10A"
  },
  {
    "Retail Branding": "ZULEISY",
    "Marketing Name": "E10A_EA",
    "Device": "E10A",
    "Model": "E10A_EA"
  },
  {
    "Retail Branding": "ZULEISY",
    "Marketing Name": "E8A",
    "Device": "E8A",
    "Model": "E8A"
  },
  {
    "Retail Branding": "ZULEISY",
    "Marketing Name": "E8A_EEA",
    "Device": "E8A_EEA",
    "Model": "E8A"
  },
  {
    "Retail Branding": "ZUOPU",
    "Marketing Name": "JH101",
    "Device": "JH101",
    "Model": "JH101"
  },
  {
    "Retail Branding": "ZUOPU",
    "Marketing Name": "JH103",
    "Device": "JH103",
    "Model": "JH103"
  },
  {
    "Retail Branding": "ZUOPU",
    "Marketing Name": "JH105",
    "Device": "JH105",
    "Model": "JH105"
  },
  {
    "Retail Branding": "ZUOPU",
    "Marketing Name": "JH105",
    "Device": "JH105",
    "Model": "ZER A10"
  },
  {
    "Retail Branding": "ZUOPU",
    "Marketing Name": "JH786",
    "Device": "JH786",
    "Model": "JH786"
  },
  {
    "Retail Branding": "ZUOPU",
    "Marketing Name": "JH863",
    "Device": "JH863",
    "Model": "JH863"
  },
  {
    "Retail Branding": "ZUOPU",
    "Marketing Name": "M2a103",
    "Device": "M2a103",
    "Model": "M2a103"
  },
  {
    "Retail Branding": "ZZB (cn)",
    "Marketing Name": "ZB10",
    "Device": "ZB10",
    "Model": "ZB10"
  },
  {
    "Retail Branding": "ZZB (cn)",
    "Marketing Name": "ZB10M",
    "Device": "ZB10M",
    "Model": "ZB10M"
  },
  {
    "Retail Branding": "ZZB (cn)",
    "Marketing Name": "ZB10_EEA",
    "Device": "ZB10_EEA",
    "Model": "ZB10_EEA"
  },
  {
    "Retail Branding": "ZZB (cn)",
    "Marketing Name": "ZB40",
    "Device": "ZB40",
    "Model": "ZB40"
  },
  {
    "Retail Branding": "ZZB (cn)",
    "Marketing Name": "ZB40_EEA",
    "Device": "ZB40_EEA",
    "Model": "ZB40_EEA"
  },
  {
    "Retail Branding": "ZZB (cn)",
    "Marketing Name": "ZZB_ZB30",
    "Device": "ZZB_ZB30",
    "Model": "ZZB_ZB30"
  },
  {
    "Retail Branding": "Zaith",
    "Marketing Name": "Z3211G",
    "Device": "Z3211G",
    "Model": "Z3211G"
  },
  {
    "Retail Branding": "ZapiTV",
    "Marketing Name": "ZAPI2022",
    "Device": "SEI800ZAPI",
    "Model": "ZAPI2022"
  },
  {
    "Retail Branding": "ZapiTV",
    "Marketing Name": "ZAPI2023",
    "Device": "SEI700ZAPI",
    "Model": "ZAPI2023"
  },
  {
    "Retail Branding": "ZapiTV",
    "Marketing Name": "Zapi2020",
    "Device": "SEI500PTV",
    "Model": "Zapi2020"
  },
  {
    "Retail Branding": "Zatec",
    "Marketing Name": "JOY",
    "Device": "JOY",
    "Model": "JOY"
  },
  {
    "Retail Branding": "Zatec",
    "Marketing Name": "JOY_PLUS",
    "Device": "JOY_PLUS",
    "Model": "JOY_PLUS"
  },
  {
    "Retail Branding": "Zatec",
    "Marketing Name": "WIND",
    "Device": "WIND",
    "Model": "WIND"
  },
  {
    "Retail Branding": "Zatec",
    "Marketing Name": "ZATEC_Play",
    "Device": "ZATEC_Play",
    "Model": "Play"
  },
  {
    "Retail Branding": "Zatec",
    "Marketing Name": "ZPAD_1",
    "Device": "ZPAD_1",
    "Model": "ZPAD_1"
  },
  {
    "Retail Branding": "Zatec",
    "Marketing Name": "ZPLAY1_2018",
    "Device": "Zatec_Zplay",
    "Model": "ZPLAY1_2018"
  },
  {
    "Retail Branding": "Zatec",
    "Marketing Name": "Zpower_2018",
    "Device": "ZATEC_Zpower_2018",
    "Model": "Zpower_2018"
  },
  {
    "Retail Branding": "Zatec",
    "Marketing Name": "Zpower_Plus",
    "Device": "Zpower_Plus",
    "Model": "Zpower_Plus"
  },
  {
    "Retail Branding": "Zebex",
    "Marketing Name": "Z-2252",
    "Device": "Z-2252",
    "Model": "Z-2252"
  },
  {
    "Retail Branding": "Zebra",
    "Marketing Name": "CC5000",
    "Device": "concierge",
    "Model": "CCHUB1"
  },
  {
    "Retail Branding": "Zebra",
    "Marketing Name": "Customer Concierge 600",
    "Device": "CC605LN",
    "Model": "CC605"
  },
  {
    "Retail Branding": "Zebra",
    "Marketing Name": "Customer Concierge 600",
    "Device": "CC610LN",
    "Model": "CC610"
  },
  {
    "Retail Branding": "Zebra",
    "Marketing Name": "Customer Concierge 6000",
    "Device": "CC610LC",
    "Model": "CC610"
  },
  {
    "Retail Branding": "Zebra",
    "Marketing Name": "Customer Concierge 6000",
    "Device": "CC610PC",
    "Model": "CC610"
  },
  {
    "Retail Branding": "Zebra",
    "Marketing Name": "EC30",
    "Device": "EC30RT",
    "Model": "EC30"
  },
  {
    "Retail Branding": "Zebra",
    "Marketing Name": "EC50",
    "Device": "EC50",
    "Model": "EC50"
  },
  {
    "Retail Branding": "Zebra",
    "Marketing Name": "EC50SA AOSP",
    "Device": "EC50",
    "Model": "EC50"
  },
  {
    "Retail Branding": "Zebra",
    "Marketing Name": "EC50SANF AOSP",
    "Device": "EC50",
    "Model": "EC50"
  },
  {
    "Retail Branding": "Zebra",
    "Marketing Name": "EC55",
    "Device": "EC55",
    "Model": "EC55"
  },
  {
    "Retail Branding": "Zebra",
    "Marketing Name": "EC55SA AOSP",
    "Device": "EC55",
    "Model": "EC55"
  },
  {
    "Retail Branding": "Zebra",
    "Marketing Name": "EC55SANF AOSP",
    "Device": "EC55",
    "Model": "EC55"
  },
  {
    "Retail Branding": "Zebra",
    "Marketing Name": "EM45",
    "Device": "EM45",
    "Model": "EM45"
  },
  {
    "Retail Branding": "Zebra",
    "Marketing Name": "ET40",
    "Device": "ET40L",
    "Model": "ET40"
  },
  {
    "Retail Branding": "Zebra",
    "Marketing Name": "ET40",
    "Device": "ET40S",
    "Model": "ET40"
  },
  {
    "Retail Branding": "Zebra",
    "Marketing Name": "ET401",
    "Device": "ET401L0",
    "Model": "ET401"
  },
  {
    "Retail Branding": "Zebra",
    "Marketing Name": "ET401",
    "Device": "ET401L1",
    "Model": "ET401"
  },
  {
    "Retail Branding": "Zebra",
    "Marketing Name": "ET401",
    "Device": "ET401LV0",
    "Model": "ET401"
  },
  {
    "Retail Branding": "Zebra",
    "Marketing Name": "ET401",
    "Device": "ET401LV1",
    "Model": "ET401"
  },
  {
    "Retail Branding": "Zebra",
    "Marketing Name": "ET401",
    "Device": "ET401W0",
    "Model": "ET401"
  },
  {
    "Retail Branding": "Zebra",
    "Marketing Name": "ET401",
    "Device": "ET401W1",
    "Model": "ET401"
  },
  {
    "Retail Branding": "Zebra",
    "Marketing Name": "ET401",
    "Device": "ET401WV0",
    "Model": "ET401"
  },
  {
    "Retail Branding": "Zebra",
    "Marketing Name": "ET401",
    "Device": "ET401WV1",
    "Model": "ET401"
  },
  {
    "Retail Branding": "Zebra",
    "Marketing Name": "ET40A",
    "Device": "ET40L",
    "Model": "ET40"
  },
  {
    "Retail Branding": "Zebra",
    "Marketing Name": "ET40A",
    "Device": "ET40S",
    "Model": "ET40"
  },
  {
    "Retail Branding": "Zebra",
    "Marketing Name": "ET45",
    "Device": "ET45L",
    "Model": "ET45"
  },
  {
    "Retail Branding": "Zebra",
    "Marketing Name": "ET45",
    "Device": "ET45S",
    "Model": "ET45"
  },
  {
    "Retail Branding": "Zebra",
    "Marketing Name": "ET56CA",
    "Device": "ET56L",
    "Model": "ET56"
  },
  {
    "Retail Branding": "Zebra",
    "Marketing Name": "ET5X",
    "Device": "ET50E",
    "Model": "ET5X"
  },
  {
    "Retail Branding": "Zebra",
    "Marketing Name": "ET5X",
    "Device": "ET50T",
    "Model": "ET5X"
  },
  {
    "Retail Branding": "Zebra",
    "Marketing Name": "ET5X",
    "Device": "ET55E",
    "Model": "ET5X"
  },
  {
    "Retail Branding": "Zebra",
    "Marketing Name": "ET5X",
    "Device": "ET55T",
    "Model": "ET5X"
  },
  {
    "Retail Branding": "Zebra",
    "Marketing Name": "ET60",
    "Device": "ET60",
    "Model": "ET60"
  },
  {
    "Retail Branding": "Zebra",
    "Marketing Name": "ET65",
    "Device": "ET65",
    "Model": "ET65"
  },
  {
    "Retail Branding": "Zebra",
    "Marketing Name": "FR55",
    "Device": "TC58E",
    "Model": "FR55"
  },
  {
    "Retail Branding": "Zebra",
    "Marketing Name": "HC20",
    "Device": "TC22",
    "Model": "HC20"
  },
  {
    "Retail Branding": "Zebra",
    "Marketing Name": "HC25",
    "Device": "TC27",
    "Model": "HC25"
  },
  {
    "Retail Branding": "Zebra",
    "Marketing Name": "HC50",
    "Device": "TC22",
    "Model": "HC50"
  },
  {
    "Retail Branding": "Zebra",
    "Marketing Name": "HC50",
    "Device": "TC22",
    "Model": "TC22"
  },
  {
    "Retail Branding": "Zebra",
    "Marketing Name": "HC55",
    "Device": "TC27",
    "Model": "TC27"
  },
  {
    "Retail Branding": "Zebra",
    "Marketing Name": "HC55",
    "Device": "TC27-6490",
    "Model": "HC55"
  },
  {
    "Retail Branding": "Zebra",
    "Marketing Name": "KC50 Android™ Kiosk computers",
    "Device": "KC50L",
    "Model": "KC50"
  },
  {
    "Retail Branding": "Zebra",
    "Marketing Name": "KC50 Android™ Kiosk computers",
    "Device": "KC50S",
    "Model": "KC50"
  },
  {
    "Retail Branding": "Zebra",
    "Marketing Name": "MC18",
    "Device": "MC18",
    "Model": "MC18N0"
  },
  {
    "Retail Branding": "Zebra",
    "Marketing Name": "MC20",
    "Device": "MC2200",
    "Model": "MC20"
  },
  {
    "Retail Branding": "Zebra",
    "Marketing Name": "MC3300ax AOSP",
    "Device": "MC3300x",
    "Model": "MC3300ax"
  },
  {
    "Retail Branding": "Zebra",
    "Marketing Name": "MC3300axS AOSP",
    "Device": "MC3300xC",
    "Model": "MC3300ax"
  },
  {
    "Retail Branding": "Zebra",
    "Marketing Name": "MC330K",
    "Device": "MC33",
    "Model": "MC33"
  },
  {
    "Retail Branding": "Zebra",
    "Marketing Name": "MC330K",
    "Device": "MC33C",
    "Model": "MC33"
  },
  {
    "Retail Branding": "Zebra",
    "Marketing Name": "MC3400",
    "Device": "MC3400",
    "Model": "MC3400"
  },
  {
    "Retail Branding": "Zebra",
    "Marketing Name": "MC3450",
    "Device": "MC3450",
    "Model": "MC3450"
  },
  {
    "Retail Branding": "Zebra",
    "Marketing Name": "MC36",
    "Device": "cardhu",
    "Model": "MC36"
  },
  {
    "Retail Branding": "Zebra",
    "Marketing Name": "MC40",
    "Device": "MC40",
    "Model": "MC40N0"
  },
  {
    "Retail Branding": "Zebra",
    "Marketing Name": "MC9400",
    "Device": "MC9400",
    "Model": "MC9400"
  },
  {
    "Retail Branding": "Zebra",
    "Marketing Name": "MC9450",
    "Device": "MC9450",
    "Model": "MC9450"
  },
  {
    "Retail Branding": "Zebra",
    "Marketing Name": "PS20 (Personal Shopper)",
    "Device": "PS20JB",
    "Model": "PS20J"
  },
  {
    "Retail Branding": "Zebra",
    "Marketing Name": "PS20(Personal Shopper)",
    "Device": "PS20JP",
    "Model": "PS20J"
  },
  {
    "Retail Branding": "Zebra",
    "Marketing Name": "PS30J",
    "Device": "PS30Jx",
    "Model": "PS30J"
  },
  {
    "Retail Branding": "Zebra",
    "Marketing Name": "Pollux",
    "Device": "TC70",
    "Model": "TC700H"
  },
  {
    "Retail Branding": "Zebra",
    "Marketing Name": "Pollux",
    "Device": "TC75",
    "Model": "TC75"
  },
  {
    "Retail Branding": "Zebra",
    "Marketing Name": "TC101",
    "Device": "TC101L",
    "Model": "TC101"
  },
  {
    "Retail Branding": "Zebra",
    "Marketing Name": "TC101",
    "Device": "TC101L",
    "Model": "TC101L"
  },
  {
    "Retail Branding": "Zebra",
    "Marketing Name": "TC101",
    "Device": "TC101W",
    "Model": "TC101"
  },
  {
    "Retail Branding": "Zebra",
    "Marketing Name": "TC101",
    "Device": "TC101W",
    "Model": "TC101W"
  },
  {
    "Retail Branding": "Zebra",
    "Marketing Name": "TC15",
    "Device": "TC15",
    "Model": "TC15"
  },
  {
    "Retail Branding": "Zebra",
    "Marketing Name": "TC20",
    "Device": "TC20RD",
    "Model": "TC20"
  },
  {
    "Retail Branding": "Zebra",
    "Marketing Name": "TC20",
    "Device": "TC20RT",
    "Model": "TC20"
  },
  {
    "Retail Branding": "Zebra",
    "Marketing Name": "TC20KB",
    "Device": "TC20KB",
    "Model": "TC20"
  },
  {
    "Retail Branding": "Zebra",
    "Marketing Name": "TC21",
    "Device": "TC21",
    "Model": "TC21"
  },
  {
    "Retail Branding": "Zebra",
    "Marketing Name": "TC22",
    "Device": "TC22",
    "Model": "HC50"
  },
  {
    "Retail Branding": "Zebra",
    "Marketing Name": "TC22",
    "Device": "TC22",
    "Model": "TC22"
  },
  {
    "Retail Branding": "Zebra",
    "Marketing Name": "TC22R",
    "Device": "TC22",
    "Model": "HC20"
  },
  {
    "Retail Branding": "Zebra",
    "Marketing Name": "TC22R",
    "Device": "TC22",
    "Model": "TC22"
  },
  {
    "Retail Branding": "Zebra",
    "Marketing Name": "TC25",
    "Device": "TC25FM",
    "Model": "TC25"
  },
  {
    "Retail Branding": "Zebra",
    "Marketing Name": "TC26",
    "Device": "TC26",
    "Model": "TC26"
  },
  {
    "Retail Branding": "Zebra",
    "Marketing Name": "TC27",
    "Device": "TC27",
    "Model": "HC25"
  },
  {
    "Retail Branding": "Zebra",
    "Marketing Name": "TC27",
    "Device": "TC27",
    "Model": "TC27"
  },
  {
    "Retail Branding": "Zebra",
    "Marketing Name": "TC501",
    "Device": "TCX01L",
    "Model": "TC501"
  },
  {
    "Retail Branding": "Zebra",
    "Marketing Name": "TC501",
    "Device": "TCX01LD",
    "Model": "TC501"
  },
  {
    "Retail Branding": "Zebra",
    "Marketing Name": "TC501",
    "Device": "TCX01LU",
    "Model": "TC501"
  },
  {
    "Retail Branding": "Zebra",
    "Marketing Name": "TC51",
    "Device": "TC51",
    "Model": "TC51"
  },
  {
    "Retail Branding": "Zebra",
    "Marketing Name": "TC51",
    "Device": "TC51HC",
    "Model": "TC51"
  },
  {
    "Retail Branding": "Zebra",
    "Marketing Name": "TC52ax",
    "Device": "TC52X",
    "Model": "TC52AX"
  },
  {
    "Retail Branding": "Zebra",
    "Marketing Name": "TC53",
    "Device": "TC53",
    "Model": "TC53"
  },
  {
    "Retail Branding": "Zebra",
    "Marketing Name": "TC53A",
    "Device": "TC53",
    "Model": "TC53"
  },
  {
    "Retail Branding": "Zebra",
    "Marketing Name": "TC53E",
    "Device": "TC53E",
    "Model": "TC53E"
  },
  {
    "Retail Branding": "Zebra",
    "Marketing Name": "TC55",
    "Device": "TC55",
    "Model": "TC55"
  },
  {
    "Retail Branding": "Zebra",
    "Marketing Name": "TC56",
    "Device": "TC56",
    "Model": "TC56"
  },
  {
    "Retail Branding": "Zebra",
    "Marketing Name": "TC58",
    "Device": "TC58",
    "Model": "TC58"
  },
  {
    "Retail Branding": "Zebra",
    "Marketing Name": "TC58E",
    "Device": "TC58E",
    "Model": "TC58E"
  },
  {
    "Retail Branding": "Zebra",
    "Marketing Name": "TC701",
    "Device": "TCX01L",
    "Model": "TC701"
  },
  {
    "Retail Branding": "Zebra",
    "Marketing Name": "TC701",
    "Device": "TCX01LD",
    "Model": "TC701"
  },
  {
    "Retail Branding": "Zebra",
    "Marketing Name": "TC701",
    "Device": "TCX01LU",
    "Model": "TC701"
  },
  {
    "Retail Branding": "Zebra",
    "Marketing Name": "TC70x",
    "Device": "TC70x",
    "Model": "TC70x"
  },
  {
    "Retail Branding": "Zebra",
    "Marketing Name": "TC73",
    "Device": "TC73",
    "Model": "TC73"
  },
  {
    "Retail Branding": "Zebra",
    "Marketing Name": "TC73",
    "Device": "TC73T",
    "Model": "TC73"
  },
  {
    "Retail Branding": "Zebra",
    "Marketing Name": "TC75x",
    "Device": "TC75x",
    "Model": "TC75x"
  },
  {
    "Retail Branding": "Zebra",
    "Marketing Name": "TC75xDF",
    "Device": "TC75xDF",
    "Model": "TC75x"
  },
  {
    "Retail Branding": "Zebra",
    "Marketing Name": "TC78",
    "Device": "TC78",
    "Model": "TC78"
  },
  {
    "Retail Branding": "Zebra",
    "Marketing Name": "TC78",
    "Device": "TC78T",
    "Model": "TC78"
  },
  {
    "Retail Branding": "Zebra",
    "Marketing Name": "TC8000",
    "Device": "TC8000",
    "Model": "TC8000"
  },
  {
    "Retail Branding": "Zebra",
    "Marketing Name": "TN28",
    "Device": "TN28",
    "Model": "TN28"
  },
  {
    "Retail Branding": "Zebra",
    "Marketing Name": "VC80x",
    "Device": "VC80x",
    "Model": "VC80x"
  },
  {
    "Retail Branding": "Zebra",
    "Marketing Name": "WT5400",
    "Device": "WT5400",
    "Model": "WT5400"
  },
  {
    "Retail Branding": "Zebra",
    "Marketing Name": "WT6000",
    "Device": "WT6000",
    "Model": "WT6000"
  },
  {
    "Retail Branding": "Zebra",
    "Marketing Name": "WT6400",
    "Device": "WT6400",
    "Model": "WT6400"
  },
  {
    "Retail Branding": "Zebra",
    "Marketing Name": "Zebra Technologies ET51",
    "Device": "ET51L",
    "Model": "ET51"
  },
  {
    "Retail Branding": "Zebra",
    "Marketing Name": "Zebra Technologies ET51",
    "Device": "ET51S",
    "Model": "ET51"
  },
  {
    "Retail Branding": "Zebra",
    "Marketing Name": "Zebra Technologies ET56",
    "Device": "ET56L",
    "Model": "ET56"
  },
  {
    "Retail Branding": "Zebra",
    "Marketing Name": "Zebra Technologies ET56",
    "Device": "ET56S",
    "Model": "ET56"
  },
  {
    "Retail Branding": "Zebra",
    "Marketing Name": "Zebra Technologies L10",
    "Device": "L10A",
    "Model": "L10A"
  },
  {
    "Retail Branding": "Zebra",
    "Marketing Name": "Zebra Technologies L10",
    "Device": "L10AW",
    "Model": "L10AW"
  },
  {
    "Retail Branding": "Zebra",
    "Marketing Name": "Zebra Technologies MC2200",
    "Device": "MC2200",
    "Model": "MC2200"
  },
  {
    "Retail Branding": "Zebra",
    "Marketing Name": "Zebra Technologies MC2200",
    "Device": "generic_arm64",
    "Model": "MC2200"
  },
  {
    "Retail Branding": "Zebra",
    "Marketing Name": "Zebra Technologies MC2700",
    "Device": "MC2700",
    "Model": "MC2700"
  },
  {
    "Retail Branding": "Zebra",
    "Marketing Name": "Zebra Technologies MC3300ax",
    "Device": "MC3300x",
    "Model": "MC3300ax"
  },
  {
    "Retail Branding": "Zebra",
    "Marketing Name": "Zebra Technologies MC3300ax",
    "Device": "MC3300xC",
    "Model": "MC3300ax"
  },
  {
    "Retail Branding": "Zebra",
    "Marketing Name": "Zebra Technologies MC3300x",
    "Device": "MC3300x",
    "Model": "MC3300x"
  },
  {
    "Retail Branding": "Zebra",
    "Marketing Name": "Zebra Technologies MC3300x",
    "Device": "MC3300xC",
    "Model": "MC3300x"
  },
  {
    "Retail Branding": "Zebra",
    "Marketing Name": "Zebra Technologies MC3300xN",
    "Device": "MC3300x",
    "Model": "MC3300x"
  },
  {
    "Retail Branding": "Zebra",
    "Marketing Name": "Zebra Technologies MC3300xNS",
    "Device": "MC3300xC",
    "Model": "MC3300x"
  },
  {
    "Retail Branding": "Zebra",
    "Marketing Name": "Zebra Technologies MC9300",
    "Device": "MC93",
    "Model": "MC93"
  },
  {
    "Retail Branding": "Zebra",
    "Marketing Name": "Zebra Technologies MC9300",
    "Device": "MC93C",
    "Model": "MC93"
  },
  {
    "Retail Branding": "Zebra",
    "Marketing Name": "Zebra Technologies TC26",
    "Device": "TC26",
    "Model": "TC26"
  },
  {
    "Retail Branding": "Zebra",
    "Marketing Name": "Zebra Technologies TC52",
    "Device": "TC52",
    "Model": "TC52"
  },
  {
    "Retail Branding": "Zebra",
    "Marketing Name": "Zebra Technologies TC52XA",
    "Device": "TC52X",
    "Model": "TC52X"
  },
  {
    "Retail Branding": "Zebra",
    "Marketing Name": "Zebra Technologies TC52ax",
    "Device": "TC52X",
    "Model": "TC52AX"
  },
  {
    "Retail Branding": "Zebra",
    "Marketing Name": "Zebra Technologies TC52x",
    "Device": "TC52X",
    "Model": "TC52X"
  },
  {
    "Retail Branding": "Zebra",
    "Marketing Name": "Zebra Technologies TC57",
    "Device": "TC57",
    "Model": "TC57"
  },
  {
    "Retail Branding": "Zebra",
    "Marketing Name": "Zebra Technologies TC57XA",
    "Device": "TC57X",
    "Model": "TC57X"
  },
  {
    "Retail Branding": "Zebra",
    "Marketing Name": "Zebra Technologies TC57x",
    "Device": "TC57X",
    "Model": "TC57X"
  },
  {
    "Retail Branding": "Zebra",
    "Marketing Name": "Zebra Technologies TC72",
    "Device": "TC72",
    "Model": "TC72"
  },
  {
    "Retail Branding": "Zebra",
    "Marketing Name": "Zebra Technologies TC77",
    "Device": "TC77",
    "Model": "TC77"
  },
  {
    "Retail Branding": "Zebra",
    "Marketing Name": "Zebra Technologies TC8300",
    "Device": "TC83B0",
    "Model": "TC8300"
  },
  {
    "Retail Branding": "Zebra",
    "Marketing Name": "Zebra Technologies TC8300",
    "Device": "TC83BH",
    "Model": "TC8300"
  },
  {
    "Retail Branding": "Zebra",
    "Marketing Name": "Zebra Technologies VC8300",
    "Device": "VC8308",
    "Model": "VC8300"
  },
  {
    "Retail Branding": "Zebra",
    "Marketing Name": "Zebra Technologies VC8300",
    "Device": "VC8310",
    "Model": "VC8300"
  },
  {
    "Retail Branding": "Zebra",
    "Marketing Name": "Zebra Technologies WT6300",
    "Device": "WT63B0",
    "Model": "WT6300"
  },
  {
    "Retail Branding": "Zeki",
    "Marketing Name": "TBDG1073",
    "Device": "TBDG1073",
    "Model": "TBDG1073"
  },
  {
    "Retail Branding": "Zeki",
    "Marketing Name": "TBDG734",
    "Device": "TBDG734",
    "Model": "TBDG734"
  },
  {
    "Retail Branding": "Zeki",
    "Marketing Name": "TBDG874 Tablet",
    "Device": "TBDG874B",
    "Model": "TBDG874"
  },
  {
    "Retail Branding": "Zeki",
    "Marketing Name": "TBDV986",
    "Device": "TBDV986",
    "Model": "TBDV986"
  },
  {
    "Retail Branding": "Zeki",
    "Marketing Name": "TBOG1034",
    "Device": "TBOG1034",
    "Model": "TBOG1034"
  },
  {
    "Retail Branding": "Zeki",
    "Marketing Name": "TBOG1034BLK",
    "Device": "TBOG1034",
    "Model": "TBOG1034"
  },
  {
    "Retail Branding": "Zeki",
    "Marketing Name": "TBQC1063B",
    "Device": "TBQC1063B",
    "Model": "TBQC1063"
  },
  {
    "Retail Branding": "Zeki",
    "Marketing Name": "TBQG1031",
    "Device": "TBQG1031",
    "Model": "TBQG1031"
  },
  {
    "Retail Branding": "Zeki",
    "Marketing Name": "TBQG1038",
    "Device": "TBQG1038",
    "Model": "TBQG1038"
  },
  {
    "Retail Branding": "Zeki",
    "Marketing Name": "TBQG1084",
    "Device": "TBQG1084",
    "Model": "TBQG1084"
  },
  {
    "Retail Branding": "Zeki",
    "Marketing Name": "TBQG738",
    "Device": "TBQG738",
    "Model": "TBQG738"
  },
  {
    "Retail Branding": "Zeki",
    "Marketing Name": "TBQG774",
    "Device": "TBQG774",
    "Model": "TBQG774"
  },
  {
    "Retail Branding": "Zeki",
    "Marketing Name": "TBQG838",
    "Device": "TBQG838",
    "Model": "TBQG838"
  },
  {
    "Retail Branding": "Zeki",
    "Marketing Name": "TBQG855",
    "Device": "TBQG855",
    "Model": "TBQG855"
  },
  {
    "Retail Branding": "Zeki",
    "Marketing Name": "Zeki TBQG884",
    "Device": "TBQG884",
    "Model": "TBQG884"
  },
  {
    "Retail Branding": "Zelumobile",
    "Marketing Name": "C400",
    "Device": "C400",
    "Model": "C400"
  },
  {
    "Retail Branding": "Zelumobile",
    "Marketing Name": "C450",
    "Device": "C450",
    "Model": "C450"
  },
  {
    "Retail Branding": "Zelumobile",
    "Marketing Name": "C450_B",
    "Device": "C450_B",
    "Model": "C450_B"
  },
  {
    "Retail Branding": "Zelumobile",
    "Marketing Name": "C500",
    "Device": "C500",
    "Model": "C500"
  },
  {
    "Retail Branding": "Zen",
    "Marketing Name": "ADMIRE CURVE NEO",
    "Device": "ZEN_ADMIRE_CURVE_NEO",
    "Model": "ADMIRE_CURVE_NEO"
  },
  {
    "Retail Branding": "Zen",
    "Marketing Name": "ADMIRE SHINE",
    "Device": "ADMIRE_SHINE",
    "Model": "ADMIRE SHINE"
  },
  {
    "Retail Branding": "Zen",
    "Marketing Name": "Admire Beat",
    "Device": "ZEN_ADMIRE_BEAT",
    "Model": "ADMIRE_BEAT"
  },
  {
    "Retail Branding": "Zen",
    "Marketing Name": "Admire Blaze",
    "Device": "ZEN_ADMIRE_BLAZE",
    "Model": "Admire Blaze"
  },
  {
    "Retail Branding": "Zen",
    "Marketing Name": "Admire Infinity Neo",
    "Device": "ADMIRE_INFINITY_NEO",
    "Model": "ADMIRE_INFINITY_NEO"
  },
  {
    "Retail Branding": "Zen",
    "Marketing Name": "Blaze",
    "Device": "CIN_INFINITY_BLAZE",
    "Model": "CINEMAX_INFINITY_BLAZE"
  },
  {
    "Retail Branding": "Zen",
    "Marketing Name": "Cinemax Infinity +",
    "Device": "CIN_INFINITY_PLUS",
    "Model": "CINEMAX INFINITY+"
  },
  {
    "Retail Branding": "Zen",
    "Marketing Name": "ZEN ADMIRE NEO PLUS",
    "Device": "ZEN_ADMIRE_NEO_PLUS",
    "Model": "ADMIRE NEO+"
  },
  {
    "Retail Branding": "Zen",
    "Marketing Name": "ZEN ADMIRE UNITY",
    "Device": "ZEN_ADMIRE_UNITY",
    "Model": "ADMIRE_UNITY"
  },
  {
    "Retail Branding": "Zen",
    "Marketing Name": "ZEN_ADMIRE_INFINITY",
    "Device": "ZEN_ADMIRE_INFINITY",
    "Model": "ADMIRE_INFINITY"
  },
  {
    "Retail Branding": "Zen",
    "Marketing Name": "ZEN_CINEMAX_INFINITY",
    "Device": "ZEN_CINEMAX_INFINITY",
    "Model": "CINEMAX_INFINITY"
  },
  {
    "Retail Branding": "Zen",
    "Marketing Name": "Zen Admire Curve +",
    "Device": "ZEN_ADMIRE_CURVE_PLUS",
    "Model": "ADMIRE_CURVE+"
  },
  {
    "Retail Branding": "Zen",
    "Marketing Name": "Zen Admire Duo",
    "Device": "ZEN_ADMIRE_DUO",
    "Model": "ADMIRE_DUO"
  },
  {
    "Retail Branding": "Zen",
    "Marketing Name": "Zen Admire Glory+",
    "Device": "ADMIRE_GLORY_PLUS",
    "Model": "ADMIRE GLORY+"
  },
  {
    "Retail Branding": "Zen",
    "Marketing Name": "Zen Admire Sense+",
    "Device": "ZEN_ADMIRE_SENSE_PLUS",
    "Model": "ADMIRE_SENSE+"
  },
  {
    "Retail Branding": "Zen",
    "Marketing Name": "Zen Admire Strong",
    "Device": "ZEN_ADMIRE_STRONG",
    "Model": "ADMIRE STRONG"
  },
  {
    "Retail Branding": "Zen",
    "Marketing Name": "Zen Admire Swadesh+",
    "Device": "ADMIRE_SWADESH_PLUS",
    "Model": "ADMIRE SWADESH+"
  },
  {
    "Retail Branding": "Zen",
    "Marketing Name": "Zen Cinemax Prime",
    "Device": "ZEN_CINEMAX_PRIME",
    "Model": "CINEMAX_PRIME"
  },
  {
    "Retail Branding": "Zen",
    "Marketing Name": "Zen M72 Smart",
    "Device": "M72_Smart",
    "Model": "M72 Smart"
  },
  {
    "Retail Branding": "Zenijust",
    "Marketing Name": "H20",
    "Device": "H20_EEA",
    "Model": "H20"
  },
  {
    "Retail Branding": "Zeop",
    "Marketing Name": "Zeop N9000",
    "Device": "B866V2F",
    "Model": "Zeop N9000"
  },
  {
    "Retail Branding": "Zephir",
    "Marketing Name": "EU、UK、AP",
    "Device": "martin",
    "Model": "Zephir 2K Android TV"
  },
  {
    "Retail Branding": "Zephir",
    "Marketing Name": "EU、UK、AP",
    "Device": "martin",
    "Model": "Zephir 2K Android TV"
  },
  {
    "Retail Branding": "Zephir",
    "Marketing Name": "Italy",
    "Device": "guandu",
    "Model": "Zephir 4K Android TV"
  },
  {
    "Retail Branding": "Zephir",
    "Marketing Name": "Italy",
    "Device": "tamachi",
    "Model": "Zephir FHD Android TV"
  },
  {
    "Retail Branding": "Zephir",
    "Marketing Name": "Italy",
    "Device": "yeongdeungpo",
    "Model": "Zephir UHD Android TV"
  },
  {
    "Retail Branding": "Zephir",
    "Marketing Name": "ZEPHIR",
    "Device": "stanford",
    "Model": "ZEPHIR 2K Android TV"
  },
  {
    "Retail Branding": "Zephir",
    "Marketing Name": "ZEPHIR",
    "Device": "zhongshan",
    "Model": "ZEPHIR 4K Android TV"
  },
  {
    "Retail Branding": "Zephir",
    "Marketing Name": "Zephir",
    "Device": "bangbae",
    "Model": "Zephir 4K Android TV"
  },
  {
    "Retail Branding": "Zephir",
    "Marketing Name": "Zephir",
    "Device": "komagome",
    "Model": "Zephir 2K Android TV"
  },
  {
    "Retail Branding": "Zephir",
    "Marketing Name": "Zephir 2K android TV",
    "Device": "nippori",
    "Model": "ZEPHIR Android TV 2K"
  },
  {
    "Retail Branding": "Zephir",
    "Marketing Name": "Zephir android TV",
    "Device": "hanyang",
    "Model": "ZEPHIR Android TV"
  },
  {
    "Retail Branding": "Zettaly",
    "Marketing Name": "ZA-407",
    "Device": "ZA-407",
    "Model": "Zettaly Avy ZA-407"
  },
  {
    "Retail Branding": "Zexelon",
    "Marketing Name": "ZTAB01B",
    "Device": "ZTAB01B",
    "Model": "ZTAB01B"
  },
  {
    "Retail Branding": "Zigo",
    "Marketing Name": "EON_9",
    "Device": "EON_9",
    "Model": "EON 9"
  },
  {
    "Retail Branding": "Zigo",
    "Marketing Name": "Zigo_Nebula_10_1",
    "Device": "Zigo_Nebula_10_1",
    "Model": "Zigo_Nebula_10_1"
  },
  {
    "Retail Branding": "Zilo",
    "Marketing Name": "Zilo",
    "Device": "Zilo",
    "Model": "Zilo"
  },
  {
    "Retail Branding": "Zinox",
    "Marketing Name": "Zinox_Zirra_Pro_Tablet",
    "Device": "Zinox_Zirra_Pro",
    "Model": "Zinox_Zirra_Pro"
  },
  {
    "Retail Branding": "Zinox",
    "Marketing Name": "Zpad-X8",
    "Device": "Zpad-X8",
    "Model": "Zpad-X8"
  },
  {
    "Retail Branding": "Zinox",
    "Marketing Name": "Zpad-X8-PRO",
    "Device": "Zpad-X8-PRO",
    "Model": "Zpad-X8-PRO"
  },
  {
    "Retail Branding": "Ziox",
    "Marketing Name": "Astra Blaze",
    "Device": "Astra_Blaze",
    "Model": "Astra Blaze"
  },
  {
    "Retail Branding": "Ziox",
    "Marketing Name": "Astra Curve 4G",
    "Device": "Astra_Curve_4G",
    "Model": "Astra Curve 4G"
  },
  {
    "Retail Branding": "Ziox",
    "Marketing Name": "Astra Curve Pro",
    "Device": "Astra_Curve_Pro",
    "Model": "Astra Curve Pro"
  },
  {
    "Retail Branding": "Ziox",
    "Marketing Name": "Astra NXT Pro",
    "Device": "Astra_NXT_Pro",
    "Model": "Astra NXT Pro"
  },
  {
    "Retail Branding": "Ziox",
    "Marketing Name": "Astra Star",
    "Device": "Astra_Star",
    "Model": "Astra Star"
  },
  {
    "Retail Branding": "Ziox",
    "Marketing Name": "Astra Titan 4G",
    "Device": "Astra_Titan_4G",
    "Model": "Astra Titan 4G"
  },
  {
    "Retail Branding": "Ziox",
    "Marketing Name": "Astra Young Pro",
    "Device": "Astra_Young_Pro",
    "Model": "Astra Young Pro"
  },
  {
    "Retail Branding": "Ziox",
    "Marketing Name": "Duopix F1",
    "Device": "Duopix_F1",
    "Model": "Duopix F1"
  },
  {
    "Retail Branding": "Ziox",
    "Marketing Name": "Duopix F10",
    "Device": "Duopix_F10",
    "Model": "Duopix F10"
  },
  {
    "Retail Branding": "Ziox",
    "Marketing Name": "Duopix F9",
    "Device": "Duopix_F9",
    "Model": "Duopix F9"
  },
  {
    "Retail Branding": "Ziox",
    "Marketing Name": "Duopix F9 Pro",
    "Device": "Duopix_F9_Pro",
    "Model": "Duopix F9 Pro"
  },
  {
    "Retail Branding": "Ziox",
    "Marketing Name": "Duopix R1",
    "Device": "Duopix_R1",
    "Model": "Duopix R1"
  },
  {
    "Retail Branding": "Ziox",
    "Marketing Name": "Duotel_D1",
    "Device": "Duotel_D1",
    "Model": "Duotel_D1"
  },
  {
    "Retail Branding": "Ziox",
    "Marketing Name": "Duotel_R2",
    "Device": "Duotel_R2",
    "Model": "Duotel_R2"
  },
  {
    "Retail Branding": "Zitab",
    "Marketing Name": "Zitab01",
    "Device": "Zitab01",
    "Model": "ZC-100J"
  },
  {
    "Retail Branding": "Zoji",
    "Marketing Name": "Z11",
    "Device": "Z11",
    "Model": "Z11"
  },
  {
    "Retail Branding": "Zoji",
    "Marketing Name": "Z33",
    "Device": "Z33",
    "Model": "Z33"
  },
  {
    "Retail Branding": "Zoji",
    "Marketing Name": "Z9",
    "Device": "Z9",
    "Model": "Z9"
  },
  {
    "Retail Branding": "Zonda",
    "Marketing Name": "AWM533",
    "Device": "AWM533",
    "Model": "AWM533"
  },
  {
    "Retail Branding": "Zong 4G",
    "Marketing Name": "Z1",
    "Device": "Z1",
    "Model": "Z1"
  },
  {
    "Retail Branding": "Zong 4G",
    "Marketing Name": "Z2",
    "Device": "Z2",
    "Model": "Z2"
  },
  {
    "Retail Branding": "Zonko",
    "Marketing Name": "D105",
    "Device": "D105",
    "Model": "D105"
  },
  {
    "Retail Branding": "Zonko",
    "Marketing Name": "D105_EEA",
    "Device": "D105_EEA",
    "Model": "D105_EEA"
  },
  {
    "Retail Branding": "Zonko",
    "Marketing Name": "D106",
    "Device": "D106",
    "Model": "D106"
  },
  {
    "Retail Branding": "Zonko",
    "Marketing Name": "D110",
    "Device": "D110",
    "Model": "D110"
  },
  {
    "Retail Branding": "Zonko",
    "Marketing Name": "D115",
    "Device": "D115",
    "Model": "D115"
  },
  {
    "Retail Branding": "Zonko",
    "Marketing Name": "D115_EEA",
    "Device": "D115_EEA",
    "Model": "D115_EEA"
  },
  {
    "Retail Branding": "Zonko",
    "Marketing Name": "D118",
    "Device": "D118",
    "Model": "D118"
  },
  {
    "Retail Branding": "Zonko",
    "Marketing Name": "D136",
    "Device": "D136",
    "Model": "D136"
  },
  {
    "Retail Branding": "Zonko",
    "Marketing Name": "K100",
    "Device": "K100",
    "Model": "K100"
  },
  {
    "Retail Branding": "Zonko",
    "Marketing Name": "K101",
    "Device": "K101",
    "Model": "K101"
  },
  {
    "Retail Branding": "Zonko",
    "Marketing Name": "K101_EEA",
    "Device": "K101_EEA",
    "Model": "K101_EEA"
  },
  {
    "Retail Branding": "Zonko",
    "Marketing Name": "K105",
    "Device": "K105",
    "Model": "K105"
  },
  {
    "Retail Branding": "Zonko",
    "Marketing Name": "K105_EEA",
    "Device": "K105_EEA",
    "Model": "K105_EEA"
  },
  {
    "Retail Branding": "Zonko",
    "Marketing Name": "K106",
    "Device": "K106",
    "Model": "K106"
  },
  {
    "Retail Branding": "Zonko",
    "Marketing Name": "K108",
    "Device": "K108",
    "Model": "K108"
  },
  {
    "Retail Branding": "Zonko",
    "Marketing Name": "K108_EEA",
    "Device": "K108_EEA",
    "Model": "K108_EEA"
  },
  {
    "Retail Branding": "Zonko",
    "Marketing Name": "K110",
    "Device": "K110",
    "Model": "K110"
  },
  {
    "Retail Branding": "Zonko",
    "Marketing Name": "K112",
    "Device": "K112",
    "Model": "K112"
  },
  {
    "Retail Branding": "Zonko",
    "Marketing Name": "K113",
    "Device": "K113",
    "Model": "K113"
  },
  {
    "Retail Branding": "Zonko",
    "Marketing Name": "K116_M",
    "Device": "K116_M",
    "Model": "K116_M"
  },
  {
    "Retail Branding": "Zonko",
    "Marketing Name": "K118",
    "Device": "K118",
    "Model": "K118"
  },
  {
    "Retail Branding": "Zonko",
    "Marketing Name": "K150",
    "Device": "K150",
    "Model": "K150"
  },
  {
    "Retail Branding": "Zonko",
    "Marketing Name": "K70_EEA",
    "Device": "K70_EEA",
    "Model": "K70_EEA"
  },
  {
    "Retail Branding": "Zonko",
    "Marketing Name": "K710",
    "Device": "K710",
    "Model": "K710"
  },
  {
    "Retail Branding": "Zonko",
    "Marketing Name": "K710_EEA",
    "Device": "K710_EEA",
    "Model": "K710_EEA"
  },
  {
    "Retail Branding": "Zonko",
    "Marketing Name": "K711",
    "Device": "K711",
    "Model": "K711"
  },
  {
    "Retail Branding": "Zonko",
    "Marketing Name": "K78",
    "Device": "K78",
    "Model": "K78"
  },
  {
    "Retail Branding": "Zonko",
    "Marketing Name": "K78_EEA",
    "Device": "K78_EEA",
    "Model": "K78_EEA"
  },
  {
    "Retail Branding": "Zonko",
    "Marketing Name": "K79",
    "Device": "K79",
    "Model": "K79"
  },
  {
    "Retail Branding": "Zonko",
    "Marketing Name": "k70",
    "Device": "K70",
    "Model": "K70"
  },
  {
    "Retail Branding": "Zoom",
    "Marketing Name": "LitePro",
    "Device": "LitePro",
    "Model": "LitePro"
  },
  {
    "Retail Branding": "Zoom",
    "Marketing Name": "Social",
    "Device": "SOCIAL",
    "Model": "SOCIAL"
  },
  {
    "Retail Branding": "Zoom",
    "Marketing Name": "ULTRA",
    "Device": "ULTRA",
    "Model": "ULTRA"
  },
  {
    "Retail Branding": "Zoom",
    "Marketing Name": "ULTRA_Plus",
    "Device": "ULTRA_Plus",
    "Model": "Star9_3G-Gen2"
  },
  {
    "Retail Branding": "Zoom",
    "Marketing Name": "ULTRA_Plus",
    "Device": "ULTRA_Plus",
    "Model": "ULTRA"
  },
  {
    "Retail Branding": "Zoom",
    "Marketing Name": "Z101G",
    "Device": "Z101G",
    "Model": "Z101G"
  },
  {
    "Retail Branding": "ZooomTV",
    "Marketing Name": "OrbitMall",
    "Device": "DV8529-T2_S2-KSI",
    "Model": "OrbitMall"
  },
  {
    "Retail Branding": "Zopo",
    "Marketing Name": "L63",
    "Device": "INHOh_L63",
    "Model": "L63"
  },
  {
    "Retail Branding": "Zopo",
    "Marketing Name": "P5000",
    "Device": "P5000",
    "Model": "P5000"
  },
  {
    "Retail Branding": "Zopo",
    "Marketing Name": "PRO1",
    "Device": "Benten_PRO1",
    "Model": "PRO1"
  },
  {
    "Retail Branding": "Zopo",
    "Marketing Name": "Z5000",
    "Device": "Z5000",
    "Model": "Z5000"
  },
  {
    "Retail Branding": "Zopo",
    "Marketing Name": "ZOPO Flash X3",
    "Device": "ZOPO_Flash_X3",
    "Model": "ZOPO Flash X3"
  },
  {
    "Retail Branding": "Zopo",
    "Marketing Name": "ZOPO_Flash_X3",
    "Device": "ZOPO_Flash_X3",
    "Model": "ZOPO Flash X3"
  },
  {
    "Retail Branding": "Zpad",
    "Marketing Name": "ZKIDS",
    "Device": "ZKIDS",
    "Model": "ZKIDS"
  },
  {
    "Retail Branding": "Zpad",
    "Marketing Name": "ZpadX7",
    "Device": "ZpadX7",
    "Model": "ZpadX7"
  },
  {
    "Retail Branding": "Zpad",
    "Marketing Name": "Zpad_X7",
    "Device": "Zpad_X7",
    "Model": "Zpad X7"
  },
  {
    "Retail Branding": "Zucchetti",
    "Marketing Name": "Zpad 608",
    "Device": "Zpad_608",
    "Model": "Zpad 608"
  },
  {
    "Retail Branding": "Zuk",
    "Marketing Name": "Lenovo Z2 Plus",
    "Device": "z2_plus_hw",
    "Model": "ZUK Z2132"
  },
  {
    "Retail Branding": "Zuk",
    "Marketing Name": "Z1",
    "Device": "Z1",
    "Model": "Z1"
  },
  {
    "Retail Branding": "Zuk",
    "Marketing Name": "Z1",
    "Device": "Z1",
    "Model": "ZUK Z1"
  },
  {
    "Retail Branding": "Zuk",
    "Marketing Name": "Z1",
    "Device": "k9",
    "Model": "ZUK Z1"
  },
  {
    "Retail Branding": "Zuk",
    "Marketing Name": "Z2",
    "Device": "z2_plus",
    "Model": "ZUK Z2131"
  },
  {
    "Retail Branding": "Zuk",
    "Marketing Name": "Z2 Pro",
    "Device": "z2_row",
    "Model": "ZUK Z2121"
  },
  {
    "Retail Branding": "Zuk",
    "Marketing Name": "ZTE B2015",
    "Device": "msm8916_64",
    "Model": "ZTE B2015"
  },
  {
    "Retail Branding": "Zuk",
    "Marketing Name": "ZTE BLADE A5 PRO",
    "Device": "P731A20",
    "Model": "ZTE BLADE A5 PRO"
  },
  {
    "Retail Branding": "Zuum",
    "Marketing Name": "AKUS P1",
    "Device": "AKUS_P1",
    "Model": "AKUS P1"
  },
  {
    "Retail Branding": "Zuum",
    "Marketing Name": "AKUS PRO",
    "Device": "AKUS_PRO",
    "Model": "AKUS PRO"
  },
  {
    "Retail Branding": "Zuum",
    "Marketing Name": "AKUS Z",
    "Device": "Akus_Z",
    "Model": "Akus Z"
  },
  {
    "Retail Branding": "Zuum",
    "Marketing Name": "AKUS Z1",
    "Device": "AKUS_Z1",
    "Model": "AKUS Z1"
  },
  {
    "Retail Branding": "Zuum",
    "Marketing Name": "AKUS_TAB",
    "Device": "AKUS_TAB",
    "Model": "AKUS_TAB"
  },
  {
    "Retail Branding": "Zuum",
    "Marketing Name": "AURA M2",
    "Device": "AURA_M2",
    "Model": "AURA M2"
  },
  {
    "Retail Branding": "Zuum",
    "Marketing Name": "AURA PLUS JLO",
    "Device": "AURA_PLUS_JLO",
    "Model": "AURA PLUS JLO"
  },
  {
    "Retail Branding": "Zuum",
    "Marketing Name": "AURA PRO",
    "Device": "AURA_PRO",
    "Model": "AURA PRO"
  },
  {
    "Retail Branding": "Zuum",
    "Marketing Name": "AURA PRO JLO",
    "Device": "AURA_PRO_JLO",
    "Model": "AURA PRO JLO"
  },
  {
    "Retail Branding": "Zuum",
    "Marketing Name": "AURA X",
    "Device": "AURA_X",
    "Model": "AURA X"
  },
  {
    "Retail Branding": "Zuum",
    "Marketing Name": "AURA Z",
    "Device": "AURA_Z",
    "Model": "AURA_Z"
  },
  {
    "Retail Branding": "Zuum",
    "Marketing Name": "AURA Z1",
    "Device": "Aura_Z1",
    "Model": "AURA Z1"
  },
  {
    "Retail Branding": "Zuum",
    "Marketing Name": "Aura M1",
    "Device": "Aura_M1",
    "Model": "AURA M1"
  },
  {
    "Retail Branding": "Zuum",
    "Marketing Name": "Aura_X1",
    "Device": "Aura_X1",
    "Model": "AURA X1"
  },
  {
    "Retail Branding": "Zuum",
    "Marketing Name": "COVET",
    "Device": "COVET",
    "Model": "COVET"
  },
  {
    "Retail Branding": "Zuum",
    "Marketing Name": "COVET PLUS",
    "Device": "COVET_PLUS",
    "Model": "COVET PLUS"
  },
  {
    "Retail Branding": "Zuum",
    "Marketing Name": "COVET PRO",
    "Device": "COVET_PRO",
    "Model": "COVET PRO"
  },
  {
    "Retail Branding": "Zuum",
    "Marketing Name": "COVET PRO LITE",
    "Device": "COVET_PRO_LITE",
    "Model": "COVET_PRO_LITE"
  },
  {
    "Retail Branding": "Zuum",
    "Marketing Name": "COVET X",
    "Device": "COVET_X",
    "Model": "COVET X"
  },
  {
    "Retail Branding": "Zuum",
    "Marketing Name": "COVET Z",
    "Device": "COVET_Z",
    "Model": "COVET Z"
  },
  {
    "Retail Branding": "Zuum",
    "Marketing Name": "COVET mini",
    "Device": "Covet_Mini",
    "Model": "COVET mini"
  },
  {
    "Retail Branding": "Zuum",
    "Marketing Name": "GRANT",
    "Device": "GRANT",
    "Model": "GRANT"
  },
  {
    "Retail Branding": "Zuum",
    "Marketing Name": "GRAVITY M",
    "Device": "GRAVITY_M",
    "Model": "GRAVITY M"
  },
  {
    "Retail Branding": "Zuum",
    "Marketing Name": "GRAVITY Z",
    "Device": "GRAVITY_Z",
    "Model": "GRAVITY Z"
  },
  {
    "Retail Branding": "Zuum",
    "Marketing Name": "Gravity",
    "Device": "Gravity",
    "Model": "Gravity"
  },
  {
    "Retail Branding": "Zuum",
    "Marketing Name": "Gravity Life",
    "Device": "Gravity_Life",
    "Model": "Gravity Life"
  },
  {
    "Retail Branding": "Zuum",
    "Marketing Name": "HIDRA 807",
    "Device": "HIDRA_807",
    "Model": "HIDRA 807"
  },
  {
    "Retail Branding": "Zuum",
    "Marketing Name": "Hidra Max",
    "Device": "Hidra_Max",
    "Model": "Hidra Max"
  },
  {
    "Retail Branding": "Zuum",
    "Marketing Name": "Hidra Plus",
    "Device": "Hidra_Plus",
    "Model": "Hidra Plus"
  },
  {
    "Retail Branding": "Zuum",
    "Marketing Name": "LIMIT",
    "Device": "LIMIT",
    "Model": "LIMIT"
  },
  {
    "Retail Branding": "Zuum",
    "Marketing Name": "MAGNO",
    "Device": "ZUUM_MAGNO",
    "Model": "MAGNO"
  },
  {
    "Retail Branding": "Zuum",
    "Marketing Name": "MAGNO",
    "Device": "ZUUM_MAGNO-S",
    "Model": "MAGNO-S"
  },
  {
    "Retail Branding": "Zuum",
    "Marketing Name": "MAGNO C",
    "Device": "MAGNO_C",
    "Model": "MAGNO C"
  },
  {
    "Retail Branding": "Zuum",
    "Marketing Name": "MAGNO C PLUS",
    "Device": "Magno_C_Plus",
    "Model": "Magno C Plus"
  },
  {
    "Retail Branding": "Zuum",
    "Marketing Name": "MAGNO C1",
    "Device": "MAGNO_C1",
    "Model": "MAGNO C1"
  },
  {
    "Retail Branding": "Zuum",
    "Marketing Name": "MAGNO C2",
    "Device": "MAGNO_C2",
    "Model": "MAGNO C2"
  },
  {
    "Retail Branding": "Zuum",
    "Marketing Name": "MAGNO MINI",
    "Device": "MAGNO_MINI",
    "Model": "MAGNO MINI"
  },
  {
    "Retail Branding": "Zuum",
    "Marketing Name": "MAGNO R",
    "Device": "MAGNO_R",
    "Model": "MAGNO R"
  },
  {
    "Retail Branding": "Zuum",
    "Marketing Name": "MAGNO S",
    "Device": "MAGNO_S",
    "Model": "MAGNO S"
  },
  {
    "Retail Branding": "Zuum",
    "Marketing Name": "MAGNO_C3",
    "Device": "MAGNO_C3",
    "Model": "MAGNO C3"
  },
  {
    "Retail Branding": "Zuum",
    "Marketing Name": "MAGNO_P1",
    "Device": "MAGNO_P1",
    "Model": "MAGNO P1"
  },
  {
    "Retail Branding": "Zuum",
    "Marketing Name": "MAGNO_P4",
    "Device": "MAGNO_P4",
    "Model": "MAGNO P4"
  },
  {
    "Retail Branding": "Zuum",
    "Marketing Name": "Magno Pro",
    "Device": "Magno_Pro",
    "Model": "Magno Pro"
  },
  {
    "Retail Branding": "Zuum",
    "Marketing Name": "NOVA_10",
    "Device": "NOVA_10",
    "Model": "NOVA_10"
  },
  {
    "Retail Branding": "Zuum",
    "Marketing Name": "NOVUS_PRO",
    "Device": "NOVUS_PRO",
    "Model": "NOVUS_PRO"
  },
  {
    "Retail Branding": "Zuum",
    "Marketing Name": "NOVUS_TAB",
    "Device": "NOVUS_TAB",
    "Model": "NOVUS TAB"
  },
  {
    "Retail Branding": "Zuum",
    "Marketing Name": "ONIX",
    "Device": "ONIX",
    "Model": "ONIX"
  },
  {
    "Retail Branding": "Zuum",
    "Marketing Name": "ONIX S",
    "Device": "ONIX_S",
    "Model": "ONIX S"
  },
  {
    "Retail Branding": "Zuum",
    "Marketing Name": "ROCKET II",
    "Device": "ROCKET_II",
    "Model": "ROCKET II"
  },
  {
    "Retail Branding": "Zuum",
    "Marketing Name": "ROCKET III",
    "Device": "ROCKET_III",
    "Model": "ROCKET III"
  },
  {
    "Retail Branding": "Zuum",
    "Marketing Name": "SENS PRO",
    "Device": "SENS_PRO",
    "Model": "SENS PRO"
  },
  {
    "Retail Branding": "Zuum",
    "Marketing Name": "SENS_CURVE",
    "Device": "SENS_CURVE",
    "Model": "SENS CURVE"
  },
  {
    "Retail Branding": "Zuum",
    "Marketing Name": "SENS_G",
    "Device": "SENS_G",
    "Model": "SENS G"
  },
  {
    "Retail Branding": "Zuum",
    "Marketing Name": "SENS_PLUS",
    "Device": "SENS_PLUS",
    "Model": "SENS PLUS"
  },
  {
    "Retail Branding": "Zuum",
    "Marketing Name": "SENS_PLUS1",
    "Device": "SENS_PLUS",
    "Model": "SENS PLUS"
  },
  {
    "Retail Branding": "Zuum",
    "Marketing Name": "STELLAR",
    "Device": "STELLAR",
    "Model": "STELLAR"
  },
  {
    "Retail Branding": "Zuum",
    "Marketing Name": "STELLAR M1",
    "Device": "STELLAR_M1",
    "Model": "STELLAR M1"
  },
  {
    "Retail Branding": "Zuum",
    "Marketing Name": "STELLAR M2",
    "Device": "STELLAR_M2",
    "Model": "STELLAR M2"
  },
  {
    "Retail Branding": "Zuum",
    "Marketing Name": "STELLAR M3",
    "Device": "STELLAR_M3",
    "Model": "STELLAR M3"
  },
  {
    "Retail Branding": "Zuum",
    "Marketing Name": "STELLAR M4",
    "Device": "STELLAR_M4",
    "Model": "STELLAR M4"
  },
  {
    "Retail Branding": "Zuum",
    "Marketing Name": "STELLAR MINI",
    "Device": "STELLAR_MINI",
    "Model": "STELLAR MINI"
  },
  {
    "Retail Branding": "Zuum",
    "Marketing Name": "STELLAR P1",
    "Device": "STELLAR_P1",
    "Model": "STELLAR P1"
  },
  {
    "Retail Branding": "Zuum",
    "Marketing Name": "STELLAR P3",
    "Device": "STELLAR_P3",
    "Model": "STELLAR P3"
  },
  {
    "Retail Branding": "Zuum",
    "Marketing Name": "STELLAR P4",
    "Device": "STELLAR_P4",
    "Model": "STELLAR P4"
  },
  {
    "Retail Branding": "Zuum",
    "Marketing Name": "STELLAR P5",
    "Device": "STELLAR_P5",
    "Model": "STELLAR P5"
  },
  {
    "Retail Branding": "Zuum",
    "Marketing Name": "STELLAR P6",
    "Device": "STELLAR_P6",
    "Model": "STELLAR P6"
  },
  {
    "Retail Branding": "Zuum",
    "Marketing Name": "STELLAR PLUS",
    "Device": "STELLAR_PLUS",
    "Model": "STELLAR PLUS"
  },
  {
    "Retail Branding": "Zuum",
    "Marketing Name": "STELLAR PRO",
    "Device": "STELLAR_PRO",
    "Model": "STELLAR PRO"
  },
  {
    "Retail Branding": "Zuum",
    "Marketing Name": "STELLAR Z",
    "Device": "STELLAR_Z",
    "Model": "STELLAR Z"
  },
  {
    "Retail Branding": "Zuum",
    "Marketing Name": "STELLAR_M5",
    "Device": "STELLAR_M5",
    "Model": "STELLAR M5"
  },
  {
    "Retail Branding": "Zuum",
    "Marketing Name": "STELLAR_M6",
    "Device": "STELLAR_M6",
    "Model": "STELLAR M6"
  },
  {
    "Retail Branding": "Zuum",
    "Marketing Name": "STELLAR_P8",
    "Device": "STELLAR_P8",
    "Model": "STELLAR P8"
  },
  {
    "Retail Branding": "Zuum",
    "Marketing Name": "Stellar Max",
    "Device": "Stellar_Max",
    "Model": "Stellar Max"
  },
  {
    "Retail Branding": "Zuum",
    "Marketing Name": "ULTRA Z",
    "Device": "Ultra_Z",
    "Model": "ULTRA Z"
  },
  {
    "Retail Branding": "Zuum",
    "Marketing Name": "VOLTA_KIDS",
    "Device": "VOLTA_KIDS",
    "Model": "VOLTA_KIDS"
  },
  {
    "Retail Branding": "Zuum",
    "Marketing Name": "ZUUM AKUS",
    "Device": "AKUS",
    "Model": "AKUS"
  },
  {
    "Retail Branding": "Zuum",
    "Marketing Name": "ZUUM GRANT",
    "Device": "GRANT",
    "Model": "GRANT"
  },
  {
    "Retail Branding": "Zuum",
    "Marketing Name": "ZUUM Gravity",
    "Device": "Gravity",
    "Model": "Gravity"
  },
  {
    "Retail Branding": "Zuum",
    "Marketing Name": "ZUUM MAGNO PLUS",
    "Device": "MAGNO_PLUS",
    "Model": "MAGNO PLUS"
  },
  {
    "Retail Branding": "Zuum",
    "Marketing Name": "ZUUM PAD Kids",
    "Device": "ZUUM_PAD_Kids",
    "Model": "ZUUM PAD Kids"
  },
  {
    "Retail Branding": "Zuum",
    "Marketing Name": "ZUUM PAD Lightyear",
    "Device": "ZUUM_PAD_Lightyear",
    "Model": "ZUUM PAD Lightyear"
  },
  {
    "Retail Branding": "Zynex",
    "Marketing Name": "G141K",
    "Device": "G141K",
    "Model": "G141K"
  },
  {
    "Retail Branding": "Zynex",
    "Marketing Name": "G141L",
    "Device": "G141L",
    "Model": "G141L"
  },
  {
    "Retail Branding": "Zynex",
    "Marketing Name": "KB1002",
    "Device": "KB1002",
    "Model": "KB1002"
  },
  {
    "Retail Branding": "Zynex",
    "Marketing Name": "X107L",
    "Device": "X107L",
    "Model": "X107L"
  },
  {
    "Retail Branding": "abxylute",
    "Marketing Name": "abxylute_one",
    "Device": "abxylute_one",
    "Model": "abxylute_one"
  },
  {
    "Retail Branding": "abxylute",
    "Marketing Name": "abxylute_one",
    "Device": "abxylute_one",
    "Model": "abxylute_one_EEA"
  },
  {
    "Retail Branding": "afriphone",
    "Marketing Name": "smart_S5",
    "Device": "smart_S5",
    "Model": "smart_S5"
  },
  {
    "Retail Branding": "ahlo",
    "Marketing Name": 1,
    "Device": "CAV",
    "Model": "Ahlo 1"
  },
  {
    "Retail Branding": "aigo",
    "Marketing Name": "A16",
    "Device": "A16",
    "Model": "A16"
  },
  {
    "Retail Branding": "aigo",
    "Marketing Name": "A16pro",
    "Device": "A16pro",
    "Model": "A16pro"
  },
  {
    "Retail Branding": "aigo",
    "Marketing Name": "A18",
    "Device": "A18",
    "Model": "A18"
  },
  {
    "Retail Branding": "aigo",
    "Marketing Name": "A19",
    "Device": "A19",
    "Model": "A19"
  },
  {
    "Retail Branding": "aipan",
    "Marketing Name": "F819",
    "Device": "F819",
    "Model": "F819"
  },
  {
    "Retail Branding": "ajib",
    "Marketing Name": "ajib X1",
    "Device": "ajib_X1",
    "Model": "ajib X1"
  },
  {
    "Retail Branding": "ajib",
    "Marketing Name": "ajib l1",
    "Device": "ajib_l1",
    "Model": "ajib l1"
  },
  {
    "Retail Branding": "ajib",
    "Marketing Name": "ajib_i10",
    "Device": "ajib_i10",
    "Model": "ajib i10"
  },
  {
    "Retail Branding": "ajib",
    "Marketing Name": "i15",
    "Device": "i15",
    "Model": "i15"
  },
  {
    "Retail Branding": "ajib",
    "Marketing Name": "i25",
    "Device": "i25",
    "Model": "i25"
  },
  {
    "Retail Branding": "alter",
    "Marketing Name": "MIG",
    "Device": "MIG",
    "Model": "MIG"
  },
  {
    "Retail Branding": "amulet7",
    "Marketing Name": "P10SU_Plus",
    "Device": "P10SU_Plus",
    "Model": "P10SU_Plus"
  },
  {
    "Retail Branding": "amulet7",
    "Marketing Name": "P10SU_Pro",
    "Device": "P10SU_Pro",
    "Model": "P10SU_Pro"
  },
  {
    "Retail Branding": "angel care",
    "Marketing Name": "S6525 RU",
    "Device": "S6525_RU",
    "Model": "S6525 RU"
  },
  {
    "Retail Branding": "anyway-go",
    "Marketing Name": "Anya_S5U",
    "Device": "Anya_S5U",
    "Model": "Anya S5U"
  },
  {
    "Retail Branding": "anyway-go",
    "Marketing Name": "TP1040",
    "Device": "TP1040",
    "Model": "TP1040"
  },
  {
    "Retail Branding": "aoson",
    "Marketing Name": "M753",
    "Device": "M753",
    "Model": "M753"
  },
  {
    "Retail Branding": "aoson",
    "Marketing Name": "R103",
    "Device": "R103",
    "Model": "R103"
  },
  {
    "Retail Branding": "aoson",
    "Marketing Name": "aoson",
    "Device": "M815",
    "Model": "M815"
  },
  {
    "Retail Branding": "ascon",
    "Marketing Name": "AT14",
    "Device": "AT14",
    "Model": "AT14P464"
  },
  {
    "Retail Branding": "axs+",
    "Marketing Name": "AXS B866V2FA",
    "Device": "B866V2FA_AXS",
    "Model": "AXS B866V2FA"
  },
  {
    "Retail Branding": "bbox",
    "Marketing Name": "bbox",
    "Device": "IMTM741",
    "Model": "IMTM741"
  },
  {
    "Retail Branding": "bbox",
    "Marketing Name": "bbox",
    "Device": "bbox-M752A",
    "Model": "bbox-M752A"
  },
  {
    "Retail Branding": "beafon",
    "Marketing Name": "Class_C250",
    "Device": "Class_C250",
    "Model": "Class_C250"
  },
  {
    "Retail Branding": "beafon",
    "Marketing Name": "M5",
    "Device": "M5",
    "Model": "M5"
  },
  {
    "Retail Branding": "beafon",
    "Marketing Name": "M6",
    "Device": "M6",
    "Model": "M6"
  },
  {
    "Retail Branding": "beafon",
    "Marketing Name": "M6s",
    "Device": "M6s",
    "Model": "M6s"
  },
  {
    "Retail Branding": "beafon",
    "Marketing Name": "M7",
    "Device": "M7",
    "Model": "M7"
  },
  {
    "Retail Branding": "beafon",
    "Marketing Name": "M7 Lite",
    "Device": "M7_Lite",
    "Model": "M7 Lite"
  },
  {
    "Retail Branding": "beafon",
    "Marketing Name": "M8",
    "Device": "beafon_M8",
    "Model": "M8"
  },
  {
    "Retail Branding": "beafon",
    "Marketing Name": "MX1",
    "Device": "MX1",
    "Model": "MX1"
  },
  {
    "Retail Branding": "beafon",
    "Marketing Name": "TL20",
    "Device": "TL20",
    "Model": "TL20"
  },
  {
    "Retail Branding": "beafon",
    "Marketing Name": "TW10",
    "Device": "TW10_EEA",
    "Model": "TW10"
  },
  {
    "Retail Branding": "beafon",
    "Marketing Name": "TW20_EEA",
    "Device": "TW20_EEA",
    "Model": "TW20"
  },
  {
    "Retail Branding": "benco",
    "Marketing Name": "AE9110",
    "Device": "AE9110",
    "Model": "AE9110"
  },
  {
    "Retail Branding": "benco",
    "Marketing Name": "AE9230",
    "Device": "AE9230",
    "Model": "AE9230"
  },
  {
    "Retail Branding": "benco",
    "Marketing Name": "AE9240",
    "Device": "AE9240",
    "Model": "AE9240"
  },
  {
    "Retail Branding": "benco",
    "Marketing Name": "AE9250",
    "Device": "AE9250",
    "Model": "AE9250"
  },
  {
    "Retail Branding": "benco",
    "Marketing Name": "AE9270",
    "Device": "AE9270",
    "Model": "AE9270"
  },
  {
    "Retail Branding": "benco",
    "Marketing Name": "AE9310",
    "Device": "AE9310",
    "Model": "AE9310"
  },
  {
    "Retail Branding": "benco",
    "Marketing Name": "AE9950",
    "Device": "AE9950",
    "Model": "AE9950"
  },
  {
    "Retail Branding": "benco",
    "Marketing Name": "AEOP519",
    "Device": "AEOP519",
    "Model": "AEOP519"
  },
  {
    "Retail Branding": "benco",
    "Marketing Name": "AEOP520",
    "Device": "AEOP520",
    "Model": "AEOP520"
  },
  {
    "Retail Branding": "benco",
    "Marketing Name": "AEOP525R",
    "Device": "AEOP525",
    "Model": "AEOP525"
  },
  {
    "Retail Branding": "benco",
    "Marketing Name": "AF9010_F",
    "Device": "AF9010_F",
    "Model": "AF9010_F"
  },
  {
    "Retail Branding": "benco",
    "Marketing Name": "AF9020",
    "Device": "AF9020",
    "Model": "AF9020"
  },
  {
    "Retail Branding": "benco",
    "Marketing Name": "AF9030",
    "Device": "AF9030",
    "Model": "AF9030"
  },
  {
    "Retail Branding": "benco",
    "Marketing Name": "AH9130",
    "Device": "AH9130",
    "Model": "AH9130"
  },
  {
    "Retail Branding": "benco",
    "Marketing Name": "AH9910",
    "Device": "AH9910",
    "Model": "AH9910"
  },
  {
    "Retail Branding": "benco",
    "Marketing Name": "M1000",
    "Device": "M1000",
    "Model": "M1000"
  },
  {
    "Retail Branding": "benco",
    "Marketing Name": "M700",
    "Device": "M700",
    "Model": "M700"
  },
  {
    "Retail Branding": "benco",
    "Marketing Name": "benco S1 Max",
    "Device": "AEOP518",
    "Model": "AEOP518"
  },
  {
    "Retail Branding": "benco",
    "Marketing Name": "benco S1 Plus",
    "Device": "AEOP513",
    "Model": "AEOP513"
  },
  {
    "Retail Branding": "benco",
    "Marketing Name": "benco S1 Pro",
    "Device": "AE9260",
    "Model": "AE9260"
  },
  {
    "Retail Branding": "benco",
    "Marketing Name": "benco S2",
    "Device": "AEOP522",
    "Model": "AEOP522"
  },
  {
    "Retail Branding": "benco",
    "Marketing Name": "benco S2c",
    "Device": "AEOP523",
    "Model": "AEOP523"
  },
  {
    "Retail Branding": "benco",
    "Marketing Name": "benco V62",
    "Device": "AE9150",
    "Model": "AE9150"
  },
  {
    "Retail Branding": "benco",
    "Marketing Name": "benco V90",
    "Device": "AE9120",
    "Model": "AE9120"
  },
  {
    "Retail Branding": "benco",
    "Marketing Name": "benco V90i",
    "Device": "AEOP526",
    "Model": "AEOP526"
  },
  {
    "Retail Branding": "benco",
    "Marketing Name": "benco V91",
    "Device": "AE9310",
    "Model": "AE9310"
  },
  {
    "Retail Branding": "benco",
    "Marketing Name": "benco V92",
    "Device": "AEOP517",
    "Model": "AEOP517"
  },
  {
    "Retail Branding": "benco",
    "Marketing Name": "benco V93",
    "Device": "AEOP527",
    "Model": "AEOP527"
  },
  {
    "Retail Branding": "benco",
    "Marketing Name": "benco Y11",
    "Device": "AH9110",
    "Model": "AH9110"
  },
  {
    "Retail Branding": "benco",
    "Marketing Name": "benco Y30",
    "Device": "AF9030",
    "Model": "AF9030"
  },
  {
    "Retail Branding": "benco",
    "Marketing Name": "benco Y40",
    "Device": "AH9210",
    "Model": "AH9210"
  },
  {
    "Retail Branding": "benco",
    "Marketing Name": "benco Y41",
    "Device": "AH9910",
    "Model": "AH9910"
  },
  {
    "Retail Branding": "benco",
    "Marketing Name": "benco Y41",
    "Device": "AN9910",
    "Model": "AN9910"
  },
  {
    "Retail Branding": "benco",
    "Marketing Name": "benco Y50",
    "Device": "AF9010",
    "Model": "AF9010"
  },
  {
    "Retail Branding": "benco",
    "Marketing Name": "benco Y50",
    "Device": "AF9010_F",
    "Model": "AF9010_F"
  },
  {
    "Retail Branding": "benco",
    "Marketing Name": "benco Y50",
    "Device": "AF9020",
    "Model": "AF9020"
  },
  {
    "Retail Branding": "benco",
    "Marketing Name": "benco Y51",
    "Device": "AF9021",
    "Model": "AF9021"
  },
  {
    "Retail Branding": "benco",
    "Marketing Name": "benco v80",
    "Device": "AE9010",
    "Model": "AE9010"
  },
  {
    "Retail Branding": "benco",
    "Marketing Name": "v6",
    "Device": "LH9921",
    "Model": "LH9921"
  },
  {
    "Retail Branding": "benco",
    "Marketing Name": "v7",
    "Device": "LE9920_P",
    "Model": "LE9920_P"
  },
  {
    "Retail Branding": "biolux",
    "Marketing Name": "Android TV",
    "Device": "redwood",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "biolux",
    "Marketing Name": "Smart TV",
    "Device": "longshan",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "biolux",
    "Marketing Name": "Smart TV",
    "Device": "osaka",
    "Model": "Google TV"
  },
  {
    "Retail Branding": "bontel",
    "Marketing Name": "T20",
    "Device": "T20",
    "Model": "T20"
  },
  {
    "Retail Branding": "bontel",
    "Marketing Name": "X20",
    "Device": "X20",
    "Model": "X20"
  },
  {
    "Retail Branding": "boxchip",
    "Marketing Name": "S900Plus",
    "Device": "S900Plus",
    "Model": "S900Plus"
  },
  {
    "Retail Branding": "bq",
    "Marketing Name": "Aquaris A4.5",
    "Device": "Aquaris_A45_sprout",
    "Model": "Aquaris A4.5"
  },
  {
    "Retail Branding": "bq",
    "Marketing Name": "Aquaris A4.5",
    "Device": "Aquaris_A45_sprout",
    "Model": "Aquaris_A4.5"
  },
  {
    "Retail Branding": "bq",
    "Marketing Name": "Aquaris C",
    "Device": "jeice",
    "Model": "Aquaris C"
  },
  {
    "Retail Branding": "bq",
    "Marketing Name": "Aquaris E10",
    "Device": "Aquaris_E10",
    "Model": "Aquaris E10"
  },
  {
    "Retail Branding": "bq",
    "Marketing Name": "Aquaris E10 3G",
    "Device": "Aquaris_E10_3G",
    "Model": "Aquaris E10 3G"
  },
  {
    "Retail Branding": "bq",
    "Marketing Name": "Aquaris E4",
    "Device": "Aquaris_E4",
    "Model": "Aquaris E4"
  },
  {
    "Retail Branding": "bq",
    "Marketing Name": "Aquaris E4.5",
    "Device": "Aquaris_E45",
    "Model": "Aquaris E4.5"
  },
  {
    "Retail Branding": "bq",
    "Marketing Name": "Aquaris E5",
    "Device": "Aquaris_E5",
    "Model": "Aquaris E5"
  },
  {
    "Retail Branding": "bq",
    "Marketing Name": "Aquaris E5 FHD",
    "Device": "Aquaris_E5_FHD",
    "Model": "Aquaris E5 FHD"
  },
  {
    "Retail Branding": "bq",
    "Marketing Name": "Aquaris E5 HD",
    "Device": "Aquaris_E5_HD",
    "Model": "Aquaris E5 HD"
  },
  {
    "Retail Branding": "bq",
    "Marketing Name": "Aquaris E6",
    "Device": "Aquaris_E6",
    "Model": "Aquaris E6"
  },
  {
    "Retail Branding": "bq",
    "Marketing Name": "Aquaris M",
    "Device": "Aquaris_M55",
    "Model": "Aquaris M"
  },
  {
    "Retail Branding": "bq",
    "Marketing Name": "Aquaris M10",
    "Device": "Aquaris_M10",
    "Model": "Aquaris M10"
  },
  {
    "Retail Branding": "bq",
    "Marketing Name": "Aquaris M10 4G",
    "Device": "FREEZERLTE",
    "Model": "Aquaris M10 4G"
  },
  {
    "Retail Branding": "bq",
    "Marketing Name": "Aquaris M10 FHD",
    "Device": "Aquaris_M10_FHD",
    "Model": "Aquaris M10 FHD"
  },
  {
    "Retail Branding": "bq",
    "Marketing Name": "Aquaris M4.5",
    "Device": "Aquaris_M45",
    "Model": "Aquaris M4.5"
  },
  {
    "Retail Branding": "bq",
    "Marketing Name": "Aquaris M4.5",
    "Device": "Aquaris_M45",
    "Model": "Aquaris_M4.5"
  },
  {
    "Retail Branding": "bq",
    "Marketing Name": "Aquaris M5",
    "Device": "Aquaris_M5",
    "Model": "Aquaris M5"
  },
  {
    "Retail Branding": "bq",
    "Marketing Name": "Aquaris M5.5",
    "Device": "Aquaris_M55",
    "Model": "Aquaris M"
  },
  {
    "Retail Branding": "bq",
    "Marketing Name": "Aquaris M5.5",
    "Device": "Aquaris_M55",
    "Model": "Aquaris M5.5"
  },
  {
    "Retail Branding": "bq",
    "Marketing Name": "Aquaris U",
    "Device": "chaozu",
    "Model": "Aquaris U"
  },
  {
    "Retail Branding": "bq",
    "Marketing Name": "Aquaris U Plus",
    "Device": "tenshi",
    "Model": "Aquaris U Plus"
  },
  {
    "Retail Branding": "bq",
    "Marketing Name": "Aquaris U lite",
    "Device": "chaozulite",
    "Model": "Aquaris U Lite"
  },
  {
    "Retail Branding": "bq",
    "Marketing Name": "Aquaris U2",
    "Device": "yamcha",
    "Model": "Aquaris U2"
  },
  {
    "Retail Branding": "bq",
    "Marketing Name": "Aquaris U2 Lite",
    "Device": "yamchalite",
    "Model": "Aquaris U2 Lite"
  },
  {
    "Retail Branding": "bq",
    "Marketing Name": "Aquaris V",
    "Device": "nappa",
    "Model": "Aquaris V"
  },
  {
    "Retail Branding": "bq",
    "Marketing Name": "Aquaris V Plus",
    "Device": "raditz",
    "Model": "Aquaris V Plus"
  },
  {
    "Retail Branding": "bq",
    "Marketing Name": "Aquaris Vs",
    "Device": "nappa_s",
    "Model": "Aquaris VS"
  },
  {
    "Retail Branding": "bq",
    "Marketing Name": "Aquaris Vs Plus",
    "Device": "raditz_s",
    "Model": "Aquaris VS Plus"
  },
  {
    "Retail Branding": "bq",
    "Marketing Name": "Aquaris X",
    "Device": "bardock",
    "Model": "Aquaris X"
  },
  {
    "Retail Branding": "bq",
    "Marketing Name": "Aquaris X Pro",
    "Device": "bardock-pro",
    "Model": "Aquaris X Pro"
  },
  {
    "Retail Branding": "bq",
    "Marketing Name": "Aquaris X2",
    "Device": "zangya_sprout",
    "Model": "Aquaris X2"
  },
  {
    "Retail Branding": "bq",
    "Marketing Name": "Aquaris X2 PRO",
    "Device": "zangyapro_sprout",
    "Model": "Aquaris X2 Pro"
  },
  {
    "Retail Branding": "bq",
    "Marketing Name": "Aquaris X5",
    "Device": "Aquaris_X5",
    "Model": "Aquaris X5"
  },
  {
    "Retail Branding": "bq",
    "Marketing Name": "Aquaris X5 Plus",
    "Device": "Aquaris_X5_Plus",
    "Model": "Aquaris X5 Plus"
  },
  {
    "Retail Branding": "bq",
    "Marketing Name": "BQ-5515L",
    "Device": "BQru-5515L",
    "Model": "BQ-5515L"
  },
  {
    "Retail Branding": "bq",
    "Marketing Name": "BQ-5516L TWIN",
    "Device": "BQru-5516L",
    "Model": "BQ-5516L"
  },
  {
    "Retail Branding": "bq",
    "Marketing Name": "BQ-6016L Mercury",
    "Device": "BQru-6016L",
    "Model": "BQ-6016L"
  },
  {
    "Retail Branding": "bq",
    "Marketing Name": "Edison 3",
    "Device": "Edison_3",
    "Model": "Edison 3"
  },
  {
    "Retail Branding": "bq",
    "Marketing Name": "Edison 3 3G",
    "Device": "Edison_3_3G",
    "Model": "Edison 3 3G"
  },
  {
    "Retail Branding": "bq",
    "Marketing Name": "Edison_3_mini",
    "Device": "Edison_3_mini",
    "Model": "Edison 3 mini"
  },
  {
    "Retail Branding": "bq",
    "Marketing Name": "M8",
    "Device": "Aquaris_M8",
    "Model": "Aquaris M8"
  },
  {
    "Retail Branding": "care.ai",
    "Marketing Name": "AIM H1",
    "Device": "AIM-H1",
    "Model": "AIM H1"
  },
  {
    "Retail Branding": "care.ai",
    "Marketing Name": "AMS-R2O",
    "Device": "AMS_R2O",
    "Model": "AMS-R2O"
  },
  {
    "Retail Branding": "care.ai",
    "Marketing Name": "AMS_R2C",
    "Device": "AMS_R2C",
    "Model": "AMS-R2C"
  },
  {
    "Retail Branding": "carp(IN)",
    "Marketing Name": "carp 2K Android TV",
    "Device": "lasalle",
    "Model": "carp 2K Android TV"
  },
  {
    "Retail Branding": "carp(IN)",
    "Marketing Name": "carp 4K Android TV",
    "Device": "kenton",
    "Model": "carp 4K Android TV"
  },
  {
    "Retail Branding": "carrozzeria",
    "Marketing Name": "SDA-700TAB",
    "Device": "SDA_700TAB",
    "Model": "SDA-700TAB"
  },
  {
    "Retail Branding": "changing",
    "Marketing Name": "F10S",
    "Device": "F10S",
    "Model": "F10S"
  },
  {
    "Retail Branding": "chocoZAP",
    "Marketing Name": "RZ2408",
    "Device": "RZ2408",
    "Model": "RZ2408"
  },
  {
    "Retail Branding": "cosmos",
    "Marketing Name": "Aries_8in",
    "Device": "Aries_8in",
    "Model": "Aries_8in"
  },
  {
    "Retail Branding": "cosmos",
    "Marketing Name": "Lynx_10in",
    "Device": "Lynx_10in",
    "Model": "Lynx_10in"
  },
  {
    "Retail Branding": "cosmos",
    "Marketing Name": "Nova_10in",
    "Device": "Nova_10in",
    "Model": "Nova_10in"
  },
  {
    "Retail Branding": "cosmos",
    "Marketing Name": "VELA_1201P-EEA",
    "Device": "VELA_1201P-EEA",
    "Model": "VELA_1201P"
  },
  {
    "Retail Branding": "cypher",
    "Marketing Name": "Cypher_C10",
    "Device": "Cypher_C10",
    "Model": "Cypher C10"
  },
  {
    "Retail Branding": "cypher",
    "Marketing Name": "Cypher_C20",
    "Device": "Cypher_C20",
    "Model": "Cypher C20"
  },
  {
    "Retail Branding": "cypher",
    "Marketing Name": "Cypher_C50",
    "Device": "Cypher_C50",
    "Model": "Cypher C50"
  },
  {
    "Retail Branding": "cypher",
    "Marketing Name": "Cypher_C70",
    "Device": "Cypher_C70",
    "Model": "Cypher C70"
  },
  {
    "Retail Branding": "d.light",
    "Marketing Name": "M100",
    "Device": "M100",
    "Model": "M100"
  },
  {
    "Retail Branding": "d.light",
    "Marketing Name": "M1000",
    "Device": "M1000",
    "Model": "M1000"
  },
  {
    "Retail Branding": "d.light",
    "Marketing Name": "M1000D",
    "Device": "M1000",
    "Model": "M1000"
  },
  {
    "Retail Branding": "d.light",
    "Marketing Name": "M200",
    "Device": "M200",
    "Model": "M200"
  },
  {
    "Retail Branding": "d.light",
    "Marketing Name": "M200A",
    "Device": "M200",
    "Model": "M200"
  },
  {
    "Retail Branding": "dazen",
    "Marketing Name": "DAZN",
    "Device": "m393gena_dazn",
    "Model": "DAZN"
  },
  {
    "Retail Branding": "dazen",
    "Marketing Name": "dazen 6A",
    "Device": "dazen_6A",
    "Model": "dazen 6A"
  },
  {
    "Retail Branding": "dazen",
    "Marketing Name": "dazen 6E",
    "Device": "dazen_6E",
    "Model": "dazen 6E"
  },
  {
    "Retail Branding": "denver",
    "Marketing Name": "TIO_10525_EEA",
    "Device": "TIO_10525_EEA",
    "Model": "TIO_10525_EEA"
  },
  {
    "Retail Branding": "denver",
    "Marketing Name": "TIO_80",
    "Device": "TIO_80",
    "Model": "TIO-80"
  },
  {
    "Retail Branding": "denver",
    "Marketing Name": "TIO_80115KBUP_EEA",
    "Device": "TIO_80115KBUP_EEA",
    "Model": "TIO_80115KBUP_EEA"
  },
  {
    "Retail Branding": "digITS",
    "Marketing Name": "T1",
    "Device": "T1",
    "Model": "T1"
  },
  {
    "Retail Branding": "du (UAE)",
    "Marketing Name": "IPBS9520",
    "Device": "IPBS9520",
    "Model": "IPBS9520"
  },
  {
    "Retail Branding": "du (UAE)",
    "Marketing Name": "du TV",
    "Device": "f515",
    "Model": "VIP7802"
  },
  {
    "Retail Branding": "duraMOBI",
    "Marketing Name": "DK66",
    "Device": "DK66",
    "Model": "DK66"
  },
  {
    "Retail Branding": "e10 ETPad",
    "Marketing Name": "ETPad",
    "Device": "ETPad",
    "Model": "ETPad"
  },
  {
    "Retail Branding": "e10 ETPad",
    "Marketing Name": "ETPad_SE",
    "Device": "ETPad_SE",
    "Model": "ETPad_SE"
  },
  {
    "Retail Branding": "e4u(A)",
    "Marketing Name": "TAB900",
    "Device": "TAB900",
    "Model": "TAB900"
  },
  {
    "Retail Branding": "eBox",
    "Marketing Name": "EBOXS905X5M",
    "Device": "sti6280d391",
    "Model": "EBOXS905X5M"
  },
  {
    "Retail Branding": "eBox",
    "Marketing Name": "EBoxTv",
    "Device": "diw387eb",
    "Model": "EboxTV"
  },
  {
    "Retail Branding": "eBox",
    "Marketing Name": "Ebox",
    "Device": "diw387eb",
    "Model": "EboxTV"
  },
  {
    "Retail Branding": "eNOVA",
    "Marketing Name": "E10_View_Max",
    "Device": "E10_View_Max",
    "Model": "E10 View Max"
  },
  {
    "Retail Branding": "eNOVA",
    "Marketing Name": "E10_View_Max",
    "Device": "E10_View_Max",
    "Model": "E10_View_Max"
  },
  {
    "Retail Branding": "eNOVA",
    "Marketing Name": "E10_View_Max",
    "Device": "E10_View_Max",
    "Model": "T3"
  },
  {
    "Retail Branding": "eNOVA",
    "Marketing Name": "ENOVA",
    "Device": "jagalchi",
    "Model": "2K SMART TV"
  },
  {
    "Retail Branding": "eNOVA",
    "Marketing Name": "ENOVA",
    "Device": "stanford",
    "Model": "SA 2K SMART TV"
  },
  {
    "Retail Branding": "eNOVA",
    "Marketing Name": "Enova",
    "Device": "elliniko",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "eNOVA",
    "Marketing Name": "Enova",
    "Device": "zhongshan",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "eNOVA",
    "Marketing Name": "N10",
    "Device": "N10",
    "Model": "N10"
  },
  {
    "Retail Branding": "eNOVA",
    "Marketing Name": "N50E",
    "Device": "N50",
    "Model": "N50"
  },
  {
    "Retail Branding": "eNOVA",
    "Marketing Name": "N51",
    "Device": "N51",
    "Model": "N51"
  },
  {
    "Retail Branding": "eNOVA",
    "Marketing Name": "T1081",
    "Device": "T1081",
    "Model": "T1081"
  },
  {
    "Retail Branding": "eNOVA",
    "Marketing Name": "TAE08N10",
    "Device": "TAE08N10",
    "Model": "TAE08N10"
  },
  {
    "Retail Branding": "eNOVA",
    "Marketing Name": "TAE10C13",
    "Device": "TAE10C13",
    "Model": "TAE10C13"
  },
  {
    "Retail Branding": "eNOVA",
    "Marketing Name": "TAE10N12",
    "Device": "TAE10N12",
    "Model": "T1081"
  },
  {
    "Retail Branding": "eNOVA",
    "Marketing Name": "TAEI0C13",
    "Device": "TAE10C13",
    "Model": "TAE10C13"
  },
  {
    "Retail Branding": "eSSL",
    "Marketing Name": "Emerald",
    "Device": "Emerald",
    "Model": "Emerald"
  },
  {
    "Retail Branding": "eSTREAM 4K",
    "Marketing Name": "EVOPRO",
    "Device": "SEI500EV",
    "Model": "EVOPRO"
  },
  {
    "Retail Branding": "eSTREAM 4K",
    "Marketing Name": "IPA-1104HDH-01",
    "Device": "eSTREAM4K_4x4",
    "Model": "IPA-1104HDH-01"
  },
  {
    "Retail Branding": "eSTREAM 4K",
    "Marketing Name": "IPA1104HDW-02",
    "Device": "kunlun",
    "Model": "IPA1104HDW-02"
  },
  {
    "Retail Branding": "eSTREAM 4K",
    "Marketing Name": "Pyxis",
    "Device": "SEI500TV",
    "Model": "Pyxis"
  },
  {
    "Retail Branding": "eSTREAM 4K",
    "Marketing Name": "Pyxis-ABB",
    "Device": "SEI500ABB",
    "Model": "Pyxis-ABB"
  },
  {
    "Retail Branding": "eSTREAM 4K",
    "Marketing Name": "Pyxis-ARMSTRONG",
    "Device": "SEI500AS",
    "Model": "Pyxis-ARMSTRONG"
  },
  {
    "Retail Branding": "eSTREAM 4K",
    "Marketing Name": "Pyxis-BlueRidge",
    "Device": "SEI500BR",
    "Model": "Pyxis-BlueRidge"
  },
  {
    "Retail Branding": "eSTREAM 4K",
    "Marketing Name": "Pyxis-BlueStream",
    "Device": "SEI500BS",
    "Model": "Pyxis-BlueStream"
  },
  {
    "Retail Branding": "eSTREAM 4K",
    "Marketing Name": "Pyxis-CBT",
    "Device": "SEI500CB",
    "Model": "Pyxis-CBT"
  },
  {
    "Retail Branding": "eSTREAM 4K",
    "Marketing Name": "Pyxis-GRANDE",
    "Device": "SEI500GD",
    "Model": "Pyxis-GRANDE"
  },
  {
    "Retail Branding": "eSTREAM 4K",
    "Marketing Name": "Pyxis-MetroNet",
    "Device": "SEI500MN",
    "Model": "Pyxis-MetroNet"
  },
  {
    "Retail Branding": "eSTREAM 4K",
    "Marketing Name": "Pyxis-Midco",
    "Device": "SEI500MC",
    "Model": "Pyxis-Midco"
  },
  {
    "Retail Branding": "eSTREAM 4K",
    "Marketing Name": "Pyxis-RCN",
    "Device": "SEI500RCN",
    "Model": "Pyxis-RCN"
  },
  {
    "Retail Branding": "eSTREAM 4K",
    "Marketing Name": "Pyxis-SECV",
    "Device": "SEI500SECV",
    "Model": "Pyxis-SECV"
  },
  {
    "Retail Branding": "eSTREAM 4K",
    "Marketing Name": "Pyxis-TDS",
    "Device": "SEI500TDS",
    "Model": "Pyxis-TDS"
  },
  {
    "Retail Branding": "eSTREAM 4K",
    "Marketing Name": "TiVo Stream 4K",
    "Device": "SEI400TV",
    "Model": "TiVo Stream 4K"
  },
  {
    "Retail Branding": "eTalk",
    "Marketing Name": "KAZ-N20",
    "Device": "KAZ-N20",
    "Model": "KAZ-N20"
  },
  {
    "Retail Branding": "eTera",
    "Marketing Name": "E980",
    "Device": "E980U",
    "Model": "E980U"
  },
  {
    "Retail Branding": "ecalendar",
    "Marketing Name": "Smart_PTV_EEA",
    "Device": "Smart_PTV",
    "Model": "Smart_PTV"
  },
  {
    "Retail Branding": "ecom",
    "Marketing Name": "Ex-Handy 10",
    "Device": "Ex-Handy10",
    "Model": "Ex-Handy 10 ROW"
  },
  {
    "Retail Branding": "ecom",
    "Marketing Name": "Ex-Handy 10",
    "Device": "Ex-Handy10",
    "Model": "Ex-Handy 10 RUS"
  },
  {
    "Retail Branding": "ecom",
    "Marketing Name": "Smart-Ex02",
    "Device": "Smart-Ex02",
    "Model": "Smart-Ex 02 RUS"
  },
  {
    "Retail Branding": "ecom",
    "Marketing Name": "Smart-Ex02",
    "Device": "Smart-Ex02",
    "Model": "Smart-Ex02 ROW"
  },
  {
    "Retail Branding": "ecom",
    "Marketing Name": "Smart-Ex02",
    "Device": "Smart-Ex02",
    "Model": "Smart-Ex02 RUS"
  },
  {
    "Retail Branding": "efioo",
    "Marketing Name": "efiootabn7a",
    "Device": "efiootabn7a",
    "Model": "Tab N7a"
  },
  {
    "Retail Branding": "elactron",
    "Marketing Name": "R3",
    "Device": "R3",
    "Model": "R3"
  },
  {
    "Retail Branding": "elactron",
    "Marketing Name": "R4",
    "Device": "R4",
    "Model": "R4"
  },
  {
    "Retail Branding": "elevn",
    "Marketing Name": "elevn_eTab",
    "Device": "elevn_eTab",
    "Model": "elevn_eTab"
  },
  {
    "Retail Branding": "enGo",
    "Marketing Name": "SmartPad",
    "Device": "SmartPad",
    "Model": "SmartPad_01"
  },
  {
    "Retail Branding": "eroc",
    "Marketing Name": "F1",
    "Device": "BOS",
    "Model": "TV Stick"
  },
  {
    "Retail Branding": "fezawio",
    "Marketing Name": "F10_EEA",
    "Device": "F10_EEA",
    "Model": "F10_EEA"
  },
  {
    "Retail Branding": "fezawio",
    "Marketing Name": "F10_US",
    "Device": "F10_US",
    "Model": "F10_US"
  },
  {
    "Retail Branding": "fezawio",
    "Marketing Name": "F11_EEA",
    "Device": "F11_EEA",
    "Model": "F11_EEA"
  },
  {
    "Retail Branding": "fezawio",
    "Marketing Name": "F11_US",
    "Device": "F11_US",
    "Model": "F11_US"
  },
  {
    "Retail Branding": "fezawio",
    "Marketing Name": "F11_V_EEA",
    "Device": "F11_V_EEA",
    "Model": "F11_V_EEA"
  },
  {
    "Retail Branding": "fezawio",
    "Marketing Name": "F11_V_US",
    "Device": "F11_V_US",
    "Model": "F11_V_US"
  },
  {
    "Retail Branding": "fezawio",
    "Marketing Name": "F12_EEA",
    "Device": "F12_EEA",
    "Model": "F12_EEA"
  },
  {
    "Retail Branding": "fezawio",
    "Marketing Name": "F12_US",
    "Device": "F12_US",
    "Model": "F12_US"
  },
  {
    "Retail Branding": "fezawio",
    "Marketing Name": "F8_EEA",
    "Device": "F8_EEA",
    "Model": "F8_EEA"
  },
  {
    "Retail Branding": "firstIT",
    "Marketing Name": "FIRSTIT_IFPD",
    "Device": "rk3588_t",
    "Model": "FIT_Series"
  },
  {
    "Retail Branding": "firstIT",
    "Marketing Name": "Interactive_whiteboard",
    "Device": "FIT_G8613TCVR",
    "Model": "FIT_G8613TCVR"
  },
  {
    "Retail Branding": "fiscat",
    "Marketing Name": "fap5_rk76",
    "Device": "fap5_rk76",
    "Model": "fap5_rk76"
  },
  {
    "Retail Branding": "fplus",
    "Marketing Name": "H166",
    "Device": "H166",
    "Model": "H166"
  },
  {
    "Retail Branding": "fplus",
    "Marketing Name": "Life Tab Plus",
    "Device": "lifetabplus",
    "Model": "LifeTabPlus"
  },
  {
    "Retail Branding": "fplus",
    "Marketing Name": "P670",
    "Device": "P670",
    "Model": "P670"
  },
  {
    "Retail Branding": "fplus",
    "Marketing Name": "SA70",
    "Device": "SA70",
    "Model": "SA70"
  },
  {
    "Retail Branding": "fplus",
    "Marketing Name": "SP65_66440",
    "Device": "SP65_66440",
    "Model": "SP65_66440"
  },
  {
    "Retail Branding": "g-mee",
    "Marketing Name": "ConnectPro",
    "Device": "ConnectPro",
    "Model": "ConnectPro"
  },
  {
    "Retail Branding": "g-mee",
    "Marketing Name": "ConnectPro_L",
    "Device": "ConnectPro_L",
    "Model": "ConnectPro_L"
  },
  {
    "Retail Branding": "g-mee",
    "Marketing Name": "G-mee Play Pro",
    "Device": "G-mee_Play_Pro",
    "Model": "G-mee Play Pro"
  },
  {
    "Retail Branding": "g-mee",
    "Marketing Name": "connect 2 US",
    "Device": "connect_2_US",
    "Model": "connect 2 US"
  },
  {
    "Retail Branding": "g-mee",
    "Marketing Name": "connect_2",
    "Device": "connect_2",
    "Model": "connect 2"
  },
  {
    "Retail Branding": "g-mee",
    "Marketing Name": "connect_2",
    "Device": "connect_2V",
    "Model": "connect 2"
  },
  {
    "Retail Branding": "g-mee",
    "Marketing Name": "play2",
    "Device": "play2",
    "Model": "play2"
  },
  {
    "Retail Branding": "galneoscreen",
    "Marketing Name": "wende.interaktiv GmbH",
    "Device": "galneoscreen_V5",
    "Model": "galneoscreen_V5"
  },
  {
    "Retail Branding": "geaneePro",
    "Marketing Name": "JT08-X1",
    "Device": "JT08-X1",
    "Model": "JT08-X1"
  },
  {
    "Retail Branding": "geaneePro",
    "Marketing Name": "JT10-X",
    "Device": "JT10-X",
    "Model": "JT10-X"
  },
  {
    "Retail Branding": "geaneePro",
    "Marketing Name": "JT10-X1",
    "Device": "JT10-X1",
    "Model": "JT10-X1"
  },
  {
    "Retail Branding": "geaneePro",
    "Marketing Name": "JT10LTE-X1",
    "Device": "JT10LTE-X1",
    "Model": "JT10LTE-X1"
  },
  {
    "Retail Branding": "geaneePro",
    "Marketing Name": "JT10LTE-X1S",
    "Device": "JT10LTE-X1S",
    "Model": "JT10LTE-X1S"
  },
  {
    "Retail Branding": "geaneePro",
    "Marketing Name": "JT70-X",
    "Device": "JT07-X",
    "Model": "JT07-X"
  },
  {
    "Retail Branding": "generaltouch",
    "Marketing Name": "ERGO22",
    "Device": "ERGO22",
    "Model": "ERGO22"
  },
  {
    "Retail Branding": "generaltouch",
    "Marketing Name": "ERGO22",
    "Device": "ERGO22",
    "Model": "ERGO22_eea"
  },
  {
    "Retail Branding": "halotel",
    "Marketing Name": "H8502",
    "Device": "H8502",
    "Model": "H8502"
  },
  {
    "Retail Branding": "hanofer",
    "Marketing Name": "Axiom 1",
    "Device": "Axiom_1",
    "Model": "Axiom 1"
  },
  {
    "Retail Branding": "hanofer",
    "Marketing Name": "Axiom 2",
    "Device": "Axiom_2",
    "Model": "Axiom 2"
  },
  {
    "Retail Branding": "heinekingmedia",
    "Marketing Name": "Digitale_Tafel",
    "Device": "rk3588_t",
    "Model": "DTA13C10HM"
  },
  {
    "Retail Branding": "heinekingmedia",
    "Marketing Name": "HKM_Android_Box",
    "Device": "rk3588_t",
    "Model": "HKM_Android_Box"
  },
  {
    "Retail Branding": "hitabt",
    "Marketing Name": "K30A",
    "Device": "K30A",
    "Model": "K30A"
  },
  {
    "Retail Branding": "hitabt",
    "Marketing Name": "P30A",
    "Device": "P30A",
    "Model": "P30A"
  },
  {
    "Retail Branding": "hitabt",
    "Marketing Name": "T30A_SY07PC01",
    "Device": "T30A_SY07PC01",
    "Model": "SY07-PC01"
  },
  {
    "Retail Branding": "hitabt",
    "Marketing Name": "T30A_SY07PC01",
    "Device": "T30A_SY07PC01",
    "Model": "T30A"
  },
  {
    "Retail Branding": "hoco",
    "Marketing Name": "hoco_HI10",
    "Device": "hoco_HI10",
    "Model": "A523 PRO"
  },
  {
    "Retail Branding": "hoco",
    "Marketing Name": "hoco_HI10",
    "Device": "hoco_HI10",
    "Model": "K108"
  },
  {
    "Retail Branding": "hoco",
    "Marketing Name": "hoco_HI10",
    "Device": "hoco_HI10",
    "Model": "hoco_HI10"
  },
  {
    "Retail Branding": "hoco",
    "Marketing Name": "hoco_HI10_EEA",
    "Device": "hoco_HI10_EEA",
    "Model": "hoco_HI10_EEA"
  },
  {
    "Retail Branding": "hoco",
    "Marketing Name": "hoco_HI10_R",
    "Device": "hoco_HI10_R",
    "Model": "hoco_HI10_R"
  },
  {
    "Retail Branding": "hoco",
    "Marketing Name": "hoco_HI11",
    "Device": "hoco_HI11",
    "Model": "hoco_A14"
  },
  {
    "Retail Branding": "hoco",
    "Marketing Name": "hoco_HI11",
    "Device": "hoco_HI11",
    "Model": "hoco_HI11"
  },
  {
    "Retail Branding": "hoco",
    "Marketing Name": "hoco_HI12",
    "Device": "hoco_HI12",
    "Model": "hoco_HI12"
  },
  {
    "Retail Branding": "hoco",
    "Marketing Name": "hoco_HI14",
    "Device": "hoco_HI14",
    "Model": "hoco_HI14"
  },
  {
    "Retail Branding": "hoco",
    "Marketing Name": "hoco_HI15",
    "Device": "hoco_HI15",
    "Model": "hoco_HI15"
  },
  {
    "Retail Branding": "homez",
    "Marketing Name": "Smart TV",
    "Device": "redwood",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "i-Buddie",
    "Marketing Name": "TA10CA1",
    "Device": "TA10CA1",
    "Model": "TA10CA1"
  },
  {
    "Retail Branding": "i-Buddie",
    "Marketing Name": "TA10CA2",
    "Device": "TA10CA2",
    "Model": "TA10CA2"
  },
  {
    "Retail Branding": "i-Buddie",
    "Marketing Name": "TA10CA3",
    "Device": "TA10CA3",
    "Model": "TA10CA3"
  },
  {
    "Retail Branding": "i-Buddie",
    "Marketing Name": "TA10CA4",
    "Device": "TA10CA4",
    "Model": "TA10CA4"
  },
  {
    "Retail Branding": "i-Buddie",
    "Marketing Name": "TA71CA1",
    "Device": "TA71CA1",
    "Model": "TA71CA1"
  },
  {
    "Retail Branding": "i-Buddie",
    "Marketing Name": "TA71CA5",
    "Device": "TA71CA5",
    "Model": "TA71CA5"
  },
  {
    "Retail Branding": "i-Buddie",
    "Marketing Name": "TA80CA1",
    "Device": "TA80CA1",
    "Model": "TA80CA1"
  },
  {
    "Retail Branding": "i-Buddie",
    "Marketing Name": "TG08RK",
    "Device": "TG08RK",
    "Model": "TG08RK"
  },
  {
    "Retail Branding": "i-Buddie",
    "Marketing Name": "TG08RK1",
    "Device": "TG08RK1",
    "Model": "TG08RK1"
  },
  {
    "Retail Branding": "i-Buddie",
    "Marketing Name": "TM75A-V2",
    "Device": "TM75A-V2",
    "Model": "TM75A-V2"
  },
  {
    "Retail Branding": "i-Buddie",
    "Marketing Name": "TR10CD1",
    "Device": "TR10CD1_2",
    "Model": "TR10CD1"
  },
  {
    "Retail Branding": "i-Buddie",
    "Marketing Name": "TR10CD1",
    "Device": "TR10CD1_4",
    "Model": "TR10CD1"
  },
  {
    "Retail Branding": "i-Buddie",
    "Marketing Name": "TR10CD1_P",
    "Device": "TR10CD1",
    "Model": "TR10CD1"
  },
  {
    "Retail Branding": "i-Buddie",
    "Marketing Name": "TR10CS1",
    "Device": "TR10CS1_12",
    "Model": "TR10CS1"
  },
  {
    "Retail Branding": "i-Buddie",
    "Marketing Name": "TR10CS1",
    "Device": "TR10CS1_2",
    "Model": "TR10CS1"
  },
  {
    "Retail Branding": "i-Buddie",
    "Marketing Name": "TR10CS1_P",
    "Device": "TR10CS1",
    "Model": "TR10CS1"
  },
  {
    "Retail Branding": "i-Buddie",
    "Marketing Name": "TU10MK1",
    "Device": "TU10MK1",
    "Model": "TU10MK1"
  },
  {
    "Retail Branding": "i-Buddie",
    "Marketing Name": "TU10MK1_1",
    "Device": "TU10MK1_1",
    "Model": "TU10MK1_1"
  },
  {
    "Retail Branding": "i-Buddie",
    "Marketing Name": "TU11MK1_1",
    "Device": "TU11MK1_1",
    "Model": "TU11MK1_1"
  },
  {
    "Retail Branding": "i-Buddie",
    "Marketing Name": "TU11MK1_2",
    "Device": "TU11MK1_2",
    "Model": "TU11MK1_2"
  },
  {
    "Retail Branding": "i-Mobile",
    "Marketing Name": "A956",
    "Device": "A956",
    "Model": "A956"
  },
  {
    "Retail Branding": "i-Mobile",
    "Marketing Name": "A958",
    "Device": "A958",
    "Model": "A958"
  },
  {
    "Retail Branding": "i-Mobile",
    "Marketing Name": "HP-01A",
    "Device": "HP-01A",
    "Model": "HP-01A"
  },
  {
    "Retail Branding": "i-Mobile",
    "Marketing Name": "IQ II",
    "Device": "imobileiq2_sprout",
    "Model": "i-mobile IQ II"
  },
  {
    "Retail Branding": "i-Mobile",
    "Marketing Name": "IQX KEN",
    "Device": "IQX_KEN",
    "Model": "IQX KEN"
  },
  {
    "Retail Branding": "i-Mobile",
    "Marketing Name": "Y1",
    "Device": "Y1",
    "Model": "i-mobile Y1"
  },
  {
    "Retail Branding": "i-Mobile",
    "Marketing Name": "i-STYLE 713",
    "Device": "i-STYLE_713",
    "Model": "i-STYLE 713"
  },
  {
    "Retail Branding": "i-Mobile",
    "Marketing Name": "i-STYLE 812 4G",
    "Device": "i_style_812_4G",
    "Model": "i-mobile i-STYLE 812 4G"
  },
  {
    "Retail Branding": "i-Mobile",
    "Marketing Name": "i-note WiFi 1.1",
    "Device": "M1703",
    "Model": "i-mobile M1703"
  },
  {
    "Retail Branding": "i-Mobile",
    "Marketing Name": "iM319",
    "Device": "iM319",
    "Model": "iM319"
  },
  {
    "Retail Branding": "i-PLUS",
    "Marketing Name": "Nu65",
    "Device": "Nu65",
    "Model": "Nu65"
  },
  {
    "Retail Branding": "i-PLUS",
    "Marketing Name": "Nu70",
    "Device": "Nu70",
    "Model": "Nu70"
  },
  {
    "Retail Branding": "i-custom",
    "Marketing Name": "S10",
    "Device": "S10",
    "Model": "S10"
  },
  {
    "Retail Branding": "i-custom",
    "Marketing Name": "S11",
    "Device": "S11",
    "Model": "S11"
  },
  {
    "Retail Branding": "i-custom",
    "Marketing Name": "S13",
    "Device": "V25T1F",
    "Model": "S13"
  },
  {
    "Retail Branding": "i-custom",
    "Marketing Name": "S32",
    "Device": "S32",
    "Model": "S32"
  },
  {
    "Retail Branding": "i.safe MOBILE",
    "Marketing Name": "IS330",
    "Device": "IS330",
    "Model": "IS330"
  },
  {
    "Retail Branding": "i.safe MOBILE",
    "Marketing Name": "IS530",
    "Device": "IS530",
    "Model": "IS530"
  },
  {
    "Retail Branding": "i.safe MOBILE",
    "Marketing Name": "IS540",
    "Device": "IS540",
    "Model": "IS540"
  },
  {
    "Retail Branding": "i.safe MOBILE",
    "Marketing Name": "IS541",
    "Device": "IS541",
    "Model": "IS541"
  },
  {
    "Retail Branding": "i.safe MOBILE",
    "Marketing Name": "IS930",
    "Device": "IS930",
    "Model": "IS930"
  },
  {
    "Retail Branding": "i3CONNECT",
    "Marketing Name": "Aspen 4",
    "Device": "oversea_v",
    "Model": "Aspen_4"
  },
  {
    "Retail Branding": "i5 (dza)",
    "Marketing Name": "TABLET_PC",
    "Device": 10080,
    "Model": 10080
  },
  {
    "Retail Branding": "i5 (dza)",
    "Marketing Name": "V10",
    "Device": "V10",
    "Model": "V10"
  },
  {
    "Retail Branding": "iBRIT",
    "Marketing Name": "Alpha",
    "Device": "AF51",
    "Model": "AF51"
  },
  {
    "Retail Branding": "iBRIT",
    "Marketing Name": "Alpha_Plus",
    "Device": "Alpha_Plus",
    "Model": "Alpha_Plus"
  },
  {
    "Retail Branding": "iBRIT",
    "Marketing Name": "IB6001",
    "Device": "IB6001",
    "Model": "IB6001"
  },
  {
    "Retail Branding": "iBRIT",
    "Marketing Name": "IBRIT_I5",
    "Device": "i5",
    "Model": "IBRIT_I5"
  },
  {
    "Retail Branding": "iBRIT",
    "Marketing Name": "IBRIT_I7",
    "Device": "i7",
    "Model": "IBRIT_I7"
  },
  {
    "Retail Branding": "iBRIT",
    "Marketing Name": "IBRIT_POWER6",
    "Device": "iBRIT_POWER6",
    "Model": "iBRIT_POWER6"
  },
  {
    "Retail Branding": "iBRIT",
    "Marketing Name": "K2",
    "Device": "K2",
    "Model": "K2"
  },
  {
    "Retail Branding": "iBRIT",
    "Marketing Name": "M4",
    "Device": "M4",
    "Model": "M4"
  },
  {
    "Retail Branding": "iBRIT",
    "Marketing Name": "MAX10",
    "Device": "MAX10",
    "Model": "MAX10"
  },
  {
    "Retail Branding": "iBRIT",
    "Marketing Name": "MAX10-1",
    "Device": "MAX10-1",
    "Model": "MAX10-1"
  },
  {
    "Retail Branding": "iBRIT",
    "Marketing Name": "MAX12",
    "Device": "MAX12",
    "Model": "MAX12"
  },
  {
    "Retail Branding": "iBRIT",
    "Marketing Name": "MAX15",
    "Device": "MAX15",
    "Model": "MAX15"
  },
  {
    "Retail Branding": "iBRIT",
    "Marketing Name": "MAX4",
    "Device": "MAX4",
    "Model": "MAX4"
  },
  {
    "Retail Branding": "iBRIT",
    "Marketing Name": "MAX7",
    "Device": "MAX7",
    "Model": "MAX7"
  },
  {
    "Retail Branding": "iBRIT",
    "Marketing Name": "MAX8",
    "Device": "MAX8",
    "Model": "MAX8"
  },
  {
    "Retail Branding": "iBRIT",
    "Marketing Name": "Max12pro",
    "Device": "Max12pro",
    "Model": "Kidz Pro"
  },
  {
    "Retail Branding": "iBRIT",
    "Marketing Name": "POWER_X",
    "Device": "POWER_X",
    "Model": "POWER_X"
  },
  {
    "Retail Branding": "iBRIT",
    "Marketing Name": "Speed_Pro_Plus",
    "Device": "SF56",
    "Model": "SF56"
  },
  {
    "Retail Branding": "iBRIT",
    "Marketing Name": "VEGA",
    "Device": "VEGA",
    "Model": "VEGA"
  },
  {
    "Retail Branding": "iBRIT",
    "Marketing Name": "X10",
    "Device": "X10",
    "Model": "Ibrit X10"
  },
  {
    "Retail Branding": "iBRIT",
    "Marketing Name": "X10",
    "Device": "X10",
    "Model": "X10"
  },
  {
    "Retail Branding": "iBRIT",
    "Marketing Name": "X10_Pro",
    "Device": "X10_Pro",
    "Model": "Ibrit X10 Pro"
  },
  {
    "Retail Branding": "iBRIT",
    "Marketing Name": "X10_Pro",
    "Device": "X10_Pro",
    "Model": "X10_Pro"
  },
  {
    "Retail Branding": "iBRIT",
    "Marketing Name": "XL",
    "Device": "XL",
    "Model": "XL"
  },
  {
    "Retail Branding": "iBRIT",
    "Marketing Name": "XLPlus",
    "Device": "XLPlus",
    "Model": "XLPlus"
  },
  {
    "Retail Branding": "iBRIT",
    "Marketing Name": "Z2",
    "Device": "Z2",
    "Model": "Z2"
  },
  {
    "Retail Branding": "iBRIT",
    "Marketing Name": "Z2Lite",
    "Device": "Z2Lite",
    "Model": "Z2Lite"
  },
  {
    "Retail Branding": "iBRIT",
    "Marketing Name": "i2",
    "Device": "i2",
    "Model": "i2"
  },
  {
    "Retail Branding": "iBRIT",
    "Marketing Name": "i5+",
    "Device": "i5Plus",
    "Model": "i5+"
  },
  {
    "Retail Branding": "iBRIT",
    "Marketing Name": "i5Plus",
    "Device": "i5Plus",
    "Model": "i5Plus"
  },
  {
    "Retail Branding": "iBRIT",
    "Marketing Name": "iBRIT",
    "Device": "Diamond_Pro_Max",
    "Model": "Diamond Pro Max"
  },
  {
    "Retail Branding": "iBRIT",
    "Marketing Name": "iBRIT SpeedX",
    "Device": "SpeedX",
    "Model": "SpeedX"
  },
  {
    "Retail Branding": "iBRIT",
    "Marketing Name": "iBRIT_POWER6",
    "Device": "iBRIT_POWER6",
    "Model": "iBRIT_POWER6"
  },
  {
    "Retail Branding": "iBall",
    "Marketing Name": "Avid",
    "Device": "Avid",
    "Model": "Avid"
  },
  {
    "Retail Branding": "iBall",
    "Marketing Name": "Blaze_V4",
    "Device": "Blaze_V4",
    "Model": "Blaze_V4"
  },
  {
    "Retail Branding": "iBall",
    "Marketing Name": "Nova_4G",
    "Device": "Nova_4G",
    "Model": "Nova_4G"
  },
  {
    "Retail Branding": "iBall",
    "Marketing Name": "Slide_Dazzle_3500",
    "Device": "Slide_Dazzle_3500",
    "Model": "Slide_Dazzle_3500"
  },
  {
    "Retail Branding": "iBall",
    "Marketing Name": "Slide_Elan_3x32",
    "Device": "Slide_Elan_3x32",
    "Model": "iBall_Slide_Elan_3x32"
  },
  {
    "Retail Branding": "iBall",
    "Marketing Name": "Slide_Elan_4G2_Plus",
    "Device": "Slide_Elan_4G2_Plus",
    "Model": "iBall_Slide_Elan_4G2_Plus"
  },
  {
    "Retail Branding": "iBall",
    "Marketing Name": "Spirit_X2",
    "Device": "Spirit_X2",
    "Model": "Spirit_X2"
  },
  {
    "Retail Branding": "iBall",
    "Marketing Name": "iBall",
    "Device": "iBall_Slide_Brace_XJ",
    "Model": "iBall Slide Brace XJ"
  },
  {
    "Retail Branding": "iBall",
    "Marketing Name": "iBall",
    "Device": "iBall_Slide_Dazzle_i7",
    "Model": "iBall Slide Dazzle i7"
  },
  {
    "Retail Branding": "iBall",
    "Marketing Name": "iBall Slide Cleo S9",
    "Device": "iBall_Slide_Cleo_S9",
    "Model": "iBall Slide Cleo S9"
  },
  {
    "Retail Branding": "iBall",
    "Marketing Name": "iBall Slide Gorgeo 4GL",
    "Device": "Gorgeo_4GL",
    "Model": "Gorgeo_4GL"
  },
  {
    "Retail Branding": "iBall",
    "Marketing Name": "iBall Slide Imprint 4G",
    "Device": "Imprint_4G",
    "Model": "iBall_Slide_Imprint_4G"
  },
  {
    "Retail Branding": "iBall",
    "Marketing Name": "iBall Slide Iris Drishti 4G",
    "Device": "Iris_Drishti_4G",
    "Model": "iBall_Slide_Iris_Drishti_4G"
  },
  {
    "Retail Branding": "iBall",
    "Marketing Name": "iBall Slide Nimble 4GF",
    "Device": "Slide_Nimble_4GF",
    "Model": "iBall_Slide_Nimble_4GF"
  },
  {
    "Retail Branding": "iBall",
    "Marketing Name": "iBall Slide Snap 4G2",
    "Device": "Snap_4G2",
    "Model": "Snap_4G2"
  },
  {
    "Retail Branding": "iBall",
    "Marketing Name": "iBall Slide Twinkle i5",
    "Device": "Twinkle_i5",
    "Model": "Twinkle_i5"
  },
  {
    "Retail Branding": "iBall",
    "Marketing Name": "iBall Slide Wings 4GP",
    "Device": "Slide_Wings_4GP",
    "Model": "iBall_Slide_Wings_4GP"
  },
  {
    "Retail Branding": "iBall",
    "Marketing Name": "iBallSlide_Wings",
    "Device": "iBallSlide_Wings",
    "Model": "Wings"
  },
  {
    "Retail Branding": "iBall",
    "Marketing Name": "iBall_Slide",
    "Device": "Perfect_10",
    "Model": "iBall_Slide_Perfect_10"
  },
  {
    "Retail Branding": "iBall",
    "Marketing Name": "iBall_Slide_Majestic_01",
    "Device": "Slide_Majestic_01",
    "Model": "iBall_Slide_Majestic_01"
  },
  {
    "Retail Branding": "iBall",
    "Marketing Name": "iBall_Slide_Perfect_10",
    "Device": "Perfect_10",
    "Model": "iBall_Slide_Perfect_10"
  },
  {
    "Retail Branding": "iBall",
    "Marketing Name": "iBall_Slide_Skye_03",
    "Device": "Slide_Skye_03",
    "Model": "Slide_Skye_03"
  },
  {
    "Retail Branding": "iBall",
    "Marketing Name": "iBall_Slide_Spirit_V2",
    "Device": "iBall_Slide_Spirit_V2",
    "Model": "iBall Slide Spirit V2"
  },
  {
    "Retail Branding": "iBall",
    "Marketing Name": "iT-KSA0003",
    "Device": "iT-KSA0003",
    "Model": "iT-KSA0003"
  },
  {
    "Retail Branding": "iBall",
    "Marketing Name": "iT-KSA0012",
    "Device": "iT-KSA0012",
    "Model": "iT-KSA0012"
  },
  {
    "Retail Branding": "iBall",
    "Marketing Name": "iT-KSA0066",
    "Device": "iT-KSA0066",
    "Model": "iT-KSA0066"
  },
  {
    "Retail Branding": "iBao",
    "Marketing Name": "iS1",
    "Device": "iS1",
    "Model": "iS1"
  },
  {
    "Retail Branding": "iBoard",
    "Marketing Name": "IFPD",
    "Device": "TE_QS",
    "Model": "TE_QS"
  },
  {
    "Retail Branding": "iCare",
    "Marketing Name": "iCare07",
    "Device": "iCare07",
    "Model": "iCare07"
  },
  {
    "Retail Branding": "iCare",
    "Marketing Name": "iCare10",
    "Device": "iCare10",
    "Model": "iCare10"
  },
  {
    "Retail Branding": "iCraig",
    "Marketing Name": "CLP288",
    "Device": "ICRAIG_CLP288",
    "Model": "ICRAIG_CLP288"
  },
  {
    "Retail Branding": "iCraig",
    "Marketing Name": "CLP293",
    "Device": "CLP293",
    "Model": "CLP293"
  },
  {
    "Retail Branding": "iCraig",
    "Marketing Name": "CLP_291",
    "Device": "ICRAIG_CLP_291",
    "Model": "ICRAIG_CLP291"
  },
  {
    "Retail Branding": "iCraig",
    "Marketing Name": "CMP 756",
    "Device": "Omega9",
    "Model": "CMP 756"
  },
  {
    "Retail Branding": "iCraig",
    "Marketing Name": "CMP 759",
    "Device": "Omega7",
    "Model": "CMP 759"
  },
  {
    "Retail Branding": "iCraig",
    "Marketing Name": "CMP770",
    "Device": "ICRAIG_CMP770",
    "Model": "ICRAIG_CMP770"
  },
  {
    "Retail Branding": "iCraig",
    "Marketing Name": "CMP791",
    "Device": "CMP791",
    "Model": "CMP791"
  },
  {
    "Retail Branding": "iCraig",
    "Marketing Name": "CMP793",
    "Device": "CMP793",
    "Model": "CMP793"
  },
  {
    "Retail Branding": "iCraig",
    "Marketing Name": "CMP797",
    "Device": "CMP797",
    "Model": "CMP797"
  },
  {
    "Retail Branding": "iCraig",
    "Marketing Name": "CMP798",
    "Device": "CMP798",
    "Model": "CMP798"
  },
  {
    "Retail Branding": "iCraig",
    "Marketing Name": "CMP821",
    "Device": "CMP821",
    "Model": "CMP821"
  },
  {
    "Retail Branding": "iCraig",
    "Marketing Name": "CMP823",
    "Device": "CMP823",
    "Model": "CMP823"
  },
  {
    "Retail Branding": "iCraig",
    "Marketing Name": "CMP826",
    "Device": "CMP826",
    "Model": "CMP826"
  },
  {
    "Retail Branding": "iCraig",
    "Marketing Name": "CMP828",
    "Device": "CMP828",
    "Model": "CMP828"
  },
  {
    "Retail Branding": "iCraig",
    "Marketing Name": "CMP834",
    "Device": "CMP834",
    "Model": "CMP834"
  },
  {
    "Retail Branding": "iCraig",
    "Marketing Name": "CMP837",
    "Device": "CMP837",
    "Model": "CMP837"
  },
  {
    "Retail Branding": "iCraig",
    "Marketing Name": "CMP838",
    "Device": "CMP838",
    "Model": "CMP838"
  },
  {
    "Retail Branding": "iCraig",
    "Marketing Name": "CMP840",
    "Device": "CMP840",
    "Model": "CMP840"
  },
  {
    "Retail Branding": "iCraig",
    "Marketing Name": "CMP_771",
    "Device": "ICRAIG_CMP_771",
    "Model": "ICRAIG_CMP771"
  },
  {
    "Retail Branding": "iCraig",
    "Marketing Name": "CMP_773",
    "Device": "ICRAIG_CMP_773",
    "Model": "ICRAIG_CMP773"
  },
  {
    "Retail Branding": "iData",
    "Marketing Name": "K3S",
    "Device": "K3S",
    "Model": "K3S"
  },
  {
    "Retail Branding": "iData",
    "Marketing Name": "K8",
    "Device": "K8",
    "Model": "K8"
  },
  {
    "Retail Branding": "iData",
    "Marketing Name": "K8Pro",
    "Device": "K8Pro",
    "Model": "K8Pro"
  },
  {
    "Retail Branding": "iData",
    "Marketing Name": "T1UHF",
    "Device": "iData_T1_UHF",
    "Model": "iData T1 UHF"
  },
  {
    "Retail Branding": "iData",
    "Marketing Name": "iData 50",
    "Device": "iData_50_EEA",
    "Model": "iData 50"
  },
  {
    "Retail Branding": "iData",
    "Marketing Name": "iData K1",
    "Device": "iData_K1_EEA",
    "Model": "iData K1"
  },
  {
    "Retail Branding": "iData",
    "Marketing Name": "iData K3 Pro",
    "Device": "K3Pro",
    "Model": "K3Pro"
  },
  {
    "Retail Branding": "iData",
    "Marketing Name": "iData P1",
    "Device": "iData_P1",
    "Model": "iData P1"
  },
  {
    "Retail Branding": "iData",
    "Marketing Name": "iData P1 mini",
    "Device": "iData_P1_mini",
    "Model": "iData P1 mini"
  },
  {
    "Retail Branding": "iData",
    "Marketing Name": "iData T1",
    "Device": "T1",
    "Model": "iData T1"
  },
  {
    "Retail Branding": "iData",
    "Marketing Name": "iData T1 Pro",
    "Device": "T1Pro",
    "Model": "T1Pro"
  },
  {
    "Retail Branding": "iData",
    "Marketing Name": "iData T1S",
    "Device": "iData_T1S",
    "Model": "iData T1S"
  },
  {
    "Retail Branding": "iData",
    "Marketing Name": "iData T2",
    "Device": "iData_T2",
    "Model": "iData_T2"
  },
  {
    "Retail Branding": "iData",
    "Marketing Name": "iData T3 Pro",
    "Device": "T3_Pro",
    "Model": "T3_Pro"
  },
  {
    "Retail Branding": "iData",
    "Marketing Name": "iData T5",
    "Device": "iDataT5",
    "Model": "iData T5"
  },
  {
    "Retail Branding": "iData",
    "Marketing Name": "iData T5X",
    "Device": "iDataT5X",
    "Model": "iData T5"
  },
  {
    "Retail Branding": "iData",
    "Marketing Name": "iData i2",
    "Device": "i2",
    "Model": "iData i2"
  },
  {
    "Retail Branding": "iData",
    "Marketing Name": "iData i3",
    "Device": "i3",
    "Model": "iData i3"
  },
  {
    "Retail Branding": "iData",
    "Marketing Name": "iDataT2",
    "Device": "iDataT2",
    "Model": "iDataT2"
  },
  {
    "Retail Branding": "iData",
    "Marketing Name": "iDataW7",
    "Device": "iDataW7",
    "Model": "iDataW7"
  },
  {
    "Retail Branding": "iData",
    "Marketing Name": "iData_50",
    "Device": "iData_50",
    "Model": "iData 50"
  },
  {
    "Retail Branding": "iData",
    "Marketing Name": "iData_K1",
    "Device": "iData_K1",
    "Model": "iData K1"
  },
  {
    "Retail Branding": "iDea USA",
    "Marketing Name": "CT8",
    "Device": "CT8",
    "Model": "CT8"
  },
  {
    "Retail Branding": "iDeaUSA",
    "Marketing Name": "CT10",
    "Device": "CT10",
    "Model": "CT10"
  },
  {
    "Retail Branding": "iDeaUSA",
    "Marketing Name": "CT7",
    "Device": "CT7",
    "Model": "CT7"
  },
  {
    "Retail Branding": "iDevice",
    "Marketing Name": "Uzbekistan",
    "Device": "Uzbekistan",
    "Model": "Uzbekistan"
  },
  {
    "Retail Branding": "iFLYTEK",
    "Marketing Name": "GOV-AI",
    "Device": "SMART-BLACKBOARD",
    "Model": "GOV-AI251"
  },
  {
    "Retail Branding": "iFit",
    "Marketing Name": "IFT1018",
    "Device": "IFT1018",
    "Model": "IFT1018"
  },
  {
    "Retail Branding": "iGet",
    "Marketing Name": "S100",
    "Device": "iGET_S100",
    "Model": "S100"
  },
  {
    "Retail Branding": "iGet",
    "Marketing Name": "SMART",
    "Device": "iGET_SMART",
    "Model": "SMART"
  },
  {
    "Retail Branding": "iGet",
    "Marketing Name": "SMART_G101",
    "Device": "iGET_SMART_G101",
    "Model": "SMART_G101"
  },
  {
    "Retail Branding": "iGet",
    "Marketing Name": "SMART_G102",
    "Device": "iGET_SMART_G102",
    "Model": "SMART_G102"
  },
  {
    "Retail Branding": "iGet",
    "Marketing Name": "SMART_G71",
    "Device": "iGET_SMART_G71",
    "Model": "SMART_G71"
  },
  {
    "Retail Branding": "iGet",
    "Marketing Name": "SMART_G81",
    "Device": "SMART_G81",
    "Model": "SMART_G81"
  },
  {
    "Retail Branding": "iGet",
    "Marketing Name": "SMART_G81H",
    "Device": "SMART_G81H",
    "Model": "SMART_G81H"
  },
  {
    "Retail Branding": "iGet",
    "Marketing Name": "SMART_L102",
    "Device": "iGET_SMART_L102",
    "Model": "SMART_L102"
  },
  {
    "Retail Branding": "iGet",
    "Marketing Name": "SMART_L103_eea",
    "Device": "SMART_L103",
    "Model": "SMART_L103_eea"
  },
  {
    "Retail Branding": "iGet",
    "Marketing Name": "SMART_L104_eea",
    "Device": "SMART_L104_eea",
    "Model": "SMART_L104_eea"
  },
  {
    "Retail Branding": "iGet",
    "Marketing Name": "SMART_L11",
    "Device": "SMART_L11",
    "Model": "SMART L11"
  },
  {
    "Retail Branding": "iGet",
    "Marketing Name": "SMART_L206",
    "Device": "SMART_L206",
    "Model": "SMART_L206"
  },
  {
    "Retail Branding": "iGet",
    "Marketing Name": "SMART_L20X",
    "Device": "SMART_L20X",
    "Model": "SMART_L20X"
  },
  {
    "Retail Branding": "iGet",
    "Marketing Name": "SMART_L30",
    "Device": "SMART_L30",
    "Model": "SMART L30"
  },
  {
    "Retail Branding": "iGet",
    "Marketing Name": "SMART_L31",
    "Device": "SMART_L31",
    "Model": "SMART L31"
  },
  {
    "Retail Branding": "iGet",
    "Marketing Name": "SMART_L31",
    "Device": "SMART_L31",
    "Model": "SMART_L31"
  },
  {
    "Retail Branding": "iGet",
    "Marketing Name": "SMART_L32",
    "Device": "SMART_L32",
    "Model": "SMART L32"
  },
  {
    "Retail Branding": "iGet",
    "Marketing Name": "SMART_L42",
    "Device": "SMART_L42",
    "Model": "SMART L42"
  },
  {
    "Retail Branding": "iGet",
    "Marketing Name": "SMART_L43",
    "Device": "SMART_L43",
    "Model": "SMART L43"
  },
  {
    "Retail Branding": "iGet",
    "Marketing Name": "SMART_RT2",
    "Device": "SMART_RT2",
    "Model": "SMART RT2"
  },
  {
    "Retail Branding": "iGet",
    "Marketing Name": "SMART_W101",
    "Device": "SMART_W101",
    "Model": "SMART_W101"
  },
  {
    "Retail Branding": "iGet",
    "Marketing Name": "SMART_W10X_EEA",
    "Device": "SMART_W10X_EEA",
    "Model": "SMART_W10X_EEA"
  },
  {
    "Retail Branding": "iGet",
    "Marketing Name": "SMART_W202",
    "Device": "SMART_W202",
    "Model": "SMART_W202"
  },
  {
    "Retail Branding": "iGet",
    "Marketing Name": "SMART_W203",
    "Device": "SMART_W203",
    "Model": "SMART_W203"
  },
  {
    "Retail Branding": "iGet",
    "Marketing Name": "SMART_W20X",
    "Device": "SMART_W20X",
    "Model": "SMART_W20X"
  },
  {
    "Retail Branding": "iGet",
    "Marketing Name": "SMART_W30_EEA",
    "Device": "SMART_W30_EEA",
    "Model": "SMART_W30"
  },
  {
    "Retail Branding": "iGet",
    "Marketing Name": "SMART_W31_EEA",
    "Device": "SMART_W31_EEA",
    "Model": "SMART_W31"
  },
  {
    "Retail Branding": "iGet",
    "Marketing Name": "SMART_W32",
    "Device": "SMART_W32",
    "Model": "SMART W32"
  },
  {
    "Retail Branding": "iGet",
    "Marketing Name": "SMART_W41",
    "Device": "SMART_W41",
    "Model": "SMART W41"
  },
  {
    "Retail Branding": "iGet",
    "Marketing Name": "SMART_W84_EEA",
    "Device": "SMART_W84_EEA",
    "Model": "SMART_W84"
  },
  {
    "Retail Branding": "iGet",
    "Marketing Name": "SMART_W8X",
    "Device": "SMART_W8X",
    "Model": "SMART_W8X"
  },
  {
    "Retail Branding": "iGet",
    "Marketing Name": "SMART_W8_Kids",
    "Device": "SMART_W8_Kids",
    "Model": "SMART W8 Kids"
  },
  {
    "Retail Branding": "iGet",
    "Marketing Name": "T1",
    "Device": "iGET_T1",
    "Model": "T1"
  },
  {
    "Retail Branding": "iGet",
    "Marketing Name": "iGET T2",
    "Device": "T2",
    "Model": "iGET T2"
  },
  {
    "Retail Branding": "iHunt",
    "Marketing Name": "Alien X",
    "Device": "Alien_X",
    "Model": "Alien_X"
  },
  {
    "Retail Branding": "iHunt",
    "Marketing Name": "Alien X Apex 2020",
    "Device": "Alien_X_Apex_2020",
    "Model": "Alien_X_Apex_2020"
  },
  {
    "Retail Branding": "iHunt",
    "Marketing Name": "Alien X Lite",
    "Device": "Alien_X_Lite",
    "Model": "Alien X Lite"
  },
  {
    "Retail Branding": "iHunt",
    "Marketing Name": "AlienXLite2020",
    "Device": "AlienXLite2020",
    "Model": "AlienXLite2020"
  },
  {
    "Retail Branding": "iHunt",
    "Marketing Name": "Alien_X_ApeX",
    "Device": "Alien_X_ApeX",
    "Model": "Alien_X_ApeX"
  },
  {
    "Retail Branding": "iHunt",
    "Marketing Name": "Alien_X_Pro_2021",
    "Device": "Alien_X_Pro_2021",
    "Model": "Alien X Pro 2021"
  },
  {
    "Retail Branding": "iHunt",
    "Marketing Name": "Cyber DOG 4G",
    "Device": "Cyber_DOG_4G",
    "Model": "Cyber DOG 4G"
  },
  {
    "Retail Branding": "iHunt",
    "Marketing Name": "Cyber_Shark_EEA",
    "Device": "Cyber_Shark",
    "Model": "iHunt Cyber Shark 4G"
  },
  {
    "Retail Branding": "iHunt",
    "Marketing Name": "Like 11 Panda Pro 2022",
    "Device": "iHunt",
    "Model": "Like 11 Panda Pro 2022"
  },
  {
    "Retail Branding": "iHunt",
    "Marketing Name": "Like 4U",
    "Device": "Like_4U",
    "Model": "Like_4U"
  },
  {
    "Retail Branding": "iHunt",
    "Marketing Name": "Like 8",
    "Device": "Like_8",
    "Model": "Like_8"
  },
  {
    "Retail Branding": "iHunt",
    "Marketing Name": "Like_7",
    "Device": "Like_7",
    "Model": "Like_7"
  },
  {
    "Retail Branding": "iHunt",
    "Marketing Name": "Like_Hi10_2021",
    "Device": "Like_Hi10_2021",
    "Model": "Like_Hi10_2021"
  },
  {
    "Retail Branding": "iHunt",
    "Marketing Name": "Like_Hi5",
    "Device": "Like_Hi5",
    "Model": "Like Hi5"
  },
  {
    "Retail Branding": "iHunt",
    "Marketing Name": "P11000 Pro",
    "Device": "P11000_Pro",
    "Model": "P11000 Pro"
  },
  {
    "Retail Branding": "iHunt",
    "Marketing Name": "P11001_ULTRA_EEA",
    "Device": "P11001_ULTRA",
    "Model": "P11001 ULTRA"
  },
  {
    "Retail Branding": "iHunt",
    "Marketing Name": "P22000 Ultra",
    "Device": "P22000_Ultra",
    "Model": "P22000 Ultra"
  },
  {
    "Retail Branding": "iHunt",
    "Marketing Name": "P25000 Pro",
    "Device": "P25000_Pro",
    "Model": "iHunt Titan P25000 Xtreme"
  },
  {
    "Retail Branding": "iHunt",
    "Marketing Name": "P32000_Ultra_EEA",
    "Device": "P32000_Ultra",
    "Model": "Strong Tablet P32000 Ultra 5G"
  },
  {
    "Retail Branding": "iHunt",
    "Marketing Name": "P8000_Ultra_EEA",
    "Device": "P8000_Ultra",
    "Model": "Titan P8000 Ultra Carbon"
  },
  {
    "Retail Branding": "iHunt",
    "Marketing Name": "S10 Tank 2020",
    "Device": "S10_Tank_2020",
    "Model": "S10 Tank 2020"
  },
  {
    "Retail Branding": "iHunt",
    "Marketing Name": "S10 Tank PRO 2020",
    "Device": "S10_Tank_PRO_2020",
    "Model": "S10 Tank PRO 2020"
  },
  {
    "Retail Branding": "iHunt",
    "Marketing Name": "S100ApeX",
    "Device": "S100ApeX",
    "Model": "S100ApeX"
  },
  {
    "Retail Branding": "iHunt",
    "Marketing Name": "S10_Tank_2019",
    "Device": "S10_Tank_2019",
    "Model": "S10_Tank_2019"
  },
  {
    "Retail Branding": "iHunt",
    "Marketing Name": "S21_Plus_2021_EEA",
    "Device": "S21_Plus_2021_EEA",
    "Model": "S21 Plus 2021_EEA"
  },
  {
    "Retail Branding": "iHunt",
    "Marketing Name": "S21_Ultra_4G_2021_EEA",
    "Device": "S21_Ultra_4G",
    "Model": "S21 Ultra 4G 2021_EEA"
  },
  {
    "Retail Branding": "iHunt",
    "Marketing Name": "S30 ULTRA APEX 2021",
    "Device": "S30_ULTRA_APEX_2021",
    "Model": "S30 ULTRA APEX 2021"
  },
  {
    "Retail Branding": "iHunt",
    "Marketing Name": "S60 Discovery Plus",
    "Device": "S60_Discovery_Plus",
    "Model": "S60 Discovery Plus"
  },
  {
    "Retail Branding": "iHunt",
    "Marketing Name": "S60_Discovery_2019",
    "Device": "S60_Discovery_2019",
    "Model": "S60_Discovery_2019"
  },
  {
    "Retail Branding": "iHunt",
    "Marketing Name": "Strong Tablet P15000 Pro",
    "Device": "Tablet_P15000",
    "Model": "Strong Tablet P15000 Pro"
  },
  {
    "Retail Branding": "iHunt",
    "Marketing Name": "Strong Tablet P15000 Ultra",
    "Device": "P15000_Ultra",
    "Model": "Strong Tablet P15000 Ultra"
  },
  {
    "Retail Branding": "iHunt",
    "Marketing Name": "TITAN P11000 PRO",
    "Device": "TITAN_P11000_PRO",
    "Model": "TITAN_P11000_PRO"
  },
  {
    "Retail Branding": "iHunt",
    "Marketing Name": "TITAN P15000 PRO 5G",
    "Device": "P15000PRO_5G",
    "Model": "TITAN P15000 PRO 5G"
  },
  {
    "Retail Branding": "iHunt",
    "Marketing Name": "Tablet PC 10 PRO",
    "Device": "Tablet_PC_10_PRO_EEA",
    "Model": "Tablet PC 10 PRO"
  },
  {
    "Retail Branding": "iHunt",
    "Marketing Name": "Tablet_PC_12_Ultra",
    "Device": "Tablet_PC_12_Ultra",
    "Model": "AR1"
  },
  {
    "Retail Branding": "iHunt",
    "Marketing Name": "Tablet_PC_12_Ultra",
    "Device": "Tablet_PC_12_Ultra",
    "Model": "Tablet_PC_12_Ultra"
  },
  {
    "Retail Branding": "iHunt",
    "Marketing Name": "Tablet_X_EEA",
    "Device": "Tablet_X",
    "Model": "iHunt STRONG Tablet X PRO"
  },
  {
    "Retail Branding": "iHunt",
    "Marketing Name": "Tian_P3000",
    "Device": "Tian_P3000",
    "Model": "Tian_P3000"
  },
  {
    "Retail Branding": "iHunt",
    "Marketing Name": "Tian_P7000",
    "Device": "Tian_P7000",
    "Model": "Tian_P7000"
  },
  {
    "Retail Branding": "iHunt",
    "Marketing Name": "Titan P8000 PRO 2021",
    "Device": "Titan_P8000_PRO_2021",
    "Model": "Titan P8000 PRO 2021"
  },
  {
    "Retail Branding": "iHunt",
    "Marketing Name": "TitanP6000",
    "Device": "TitanP6000",
    "Model": "TitanP6000"
  },
  {
    "Retail Branding": "iHunt",
    "Marketing Name": "Titan_P4000_Pro_2021_EEA",
    "Device": "Titan_P4000_Pro",
    "Model": "Titan P4000 Pro 2021_EEA"
  },
  {
    "Retail Branding": "iHunt",
    "Marketing Name": "Titan_P6000_PRO",
    "Device": "Titan_P6000_PRO",
    "Model": "Titan_P6000_PRO"
  },
  {
    "Retail Branding": "iHunt",
    "Marketing Name": "Titan_X_EEA",
    "Device": "Titan_X_EEA",
    "Model": "iHunt Titan X 5G"
  },
  {
    "Retail Branding": "iHunt",
    "Marketing Name": "iHunt Cyber Wolf 5G",
    "Device": "Cyber_Wolf_5G",
    "Model": "iHunt Cyber Wolf 5G"
  },
  {
    "Retail Branding": "iHunt",
    "Marketing Name": "iHunt Fit Runner",
    "Device": "iHunt_Fit_Runner",
    "Model": "iHunt Fit Runner"
  },
  {
    "Retail Branding": "iHunt",
    "Marketing Name": "iHunt S22  ULTRA",
    "Device": "iHuntS22ULTRA",
    "Model": "iHunt S22 ULTRA"
  },
  {
    "Retail Branding": "iHunt",
    "Marketing Name": "iHunt S24 PLUS",
    "Device": "iHunt_S24_PLUS",
    "Model": "iHunt S24 PLUS"
  },
  {
    "Retail Branding": "iHunt",
    "Marketing Name": "iHunt S24 ULTRA",
    "Device": "iHunt_S24_ULTRA",
    "Model": "iHunt S24 ULTRA"
  },
  {
    "Retail Branding": "iHunt",
    "Marketing Name": "iHunt S60 Discovery Pro 2021",
    "Device": "iHunt_S60",
    "Model": "iHunt S60 Discovery Pro 2022"
  },
  {
    "Retail Branding": "iHunt",
    "Marketing Name": "iHunt S90 Apex",
    "Device": "S90_Apex",
    "Model": "S90_Apex"
  },
  {
    "Retail Branding": "iHunt",
    "Marketing Name": "iHunt Tablet PC 11 Ultra",
    "Device": "Tablet_PC_11_Ultra",
    "Model": "iHunt Tablet PC 11 Ultra"
  },
  {
    "Retail Branding": "iHunt",
    "Marketing Name": "iHunt Titan P10000 Pro",
    "Device": "P10000_Pro",
    "Model": "iHunt Titan P10000 Pro"
  },
  {
    "Retail Branding": "iHunt",
    "Marketing Name": "iHuntLike12PRO",
    "Device": "iHuntLike12PRO",
    "Model": "iHunt Like 12 PRO"
  },
  {
    "Retail Branding": "iHunt",
    "Marketing Name": "iHuntS22PLUS",
    "Device": "iHuntS22PLUS",
    "Model": "iHunt S22 PLUS"
  },
  {
    "Retail Branding": "iHunt",
    "Marketing Name": "iHunt_Like_12_EEA",
    "Device": "iHunt_Like_12",
    "Model": "iHunt Like 12"
  },
  {
    "Retail Branding": "iHunt",
    "Marketing Name": "iHunt_Note_Ultra",
    "Device": "iHunt_Note_Ultra",
    "Model": "iHunt Note Ultra"
  },
  {
    "Retail Branding": "iHunt",
    "Marketing Name": "iHunt_P15000_EEA",
    "Device": "iHunt_P15000",
    "Model": "iHunt Titan P15000 Ultra"
  },
  {
    "Retail Branding": "iHunt",
    "Marketing Name": "iHunt_S23_PLUS_EEA",
    "Device": "iHunt_S23_PLUS_EEA",
    "Model": "iHunt_S23_PLUS"
  },
  {
    "Retail Branding": "iHunt",
    "Marketing Name": "iHunt_S23_ULTRA",
    "Device": "iHunt_S23_ULTRA",
    "Model": "iHunt S23 ULTRA"
  },
  {
    "Retail Branding": "iHunt",
    "Marketing Name": "iHunt_S24_Xtreme_EEA",
    "Device": "iHunt_S24_Xtreme",
    "Model": "iHunt S24 Xtreme"
  },
  {
    "Retail Branding": "iHunt",
    "Marketing Name": "iHunt_S25_ULTRA",
    "Device": "iHunt_S25_ULTRA",
    "Model": "iHunt S25 ULTRA"
  },
  {
    "Retail Branding": "iHunt",
    "Marketing Name": "iHunt_S60_Discovery_Pro_2020",
    "Device": "iHunt_S60_Discovery_Pro_2020",
    "Model": "iHunt_S60_Discovery_Pro_2020"
  },
  {
    "Retail Branding": "iLa Mobile",
    "Marketing Name": "C3",
    "Device": "C3",
    "Model": "C3"
  },
  {
    "Retail Branding": "iLa Mobile",
    "Marketing Name": "D1",
    "Device": "D1",
    "Model": "D1"
  },
  {
    "Retail Branding": "iLa Mobile",
    "Marketing Name": "E1 Plus",
    "Device": "E1_Plus",
    "Model": "E1 Plus"
  },
  {
    "Retail Branding": "iLa Mobile",
    "Marketing Name": "E3",
    "Device": "E3",
    "Model": "E3"
  },
  {
    "Retail Branding": "iLa Mobile",
    "Marketing Name": "ILA C1",
    "Device": "ILA_C1",
    "Model": "ILA C1"
  },
  {
    "Retail Branding": "iLa Mobile",
    "Marketing Name": "ILA E1",
    "Device": "ILA_E1",
    "Model": "ILA E1"
  },
  {
    "Retail Branding": "iLa Mobile",
    "Marketing Name": "ILA R1",
    "Device": "ILA_R1",
    "Model": "ILA R1"
  },
  {
    "Retail Branding": "iLa Mobile",
    "Marketing Name": "ILA X2",
    "Device": "ILA_X2",
    "Model": "ILA X2"
  },
  {
    "Retail Branding": "iLa Mobile",
    "Marketing Name": "ILA_X1",
    "Device": "ILA_X1",
    "Model": "ILA X1"
  },
  {
    "Retail Branding": "iLa Mobile",
    "Marketing Name": "ILA_X3",
    "Device": "ILA_X3",
    "Model": "ILA X3"
  },
  {
    "Retail Branding": "iLa Mobile",
    "Marketing Name": "R1 Lite",
    "Device": "R1_Lite",
    "Model": "R1 Lite"
  },
  {
    "Retail Branding": "iLa Mobile",
    "Marketing Name": "S1",
    "Device": "S1",
    "Model": "S1"
  },
  {
    "Retail Branding": "iLa Mobile",
    "Marketing Name": "iLA Silk",
    "Device": "iLA_Silk",
    "Model": "iLA_Silk"
  },
  {
    "Retail Branding": "iLa Mobile",
    "Marketing Name": "iLA-X",
    "Device": "iLA-X",
    "Model": "iLA-X"
  },
  {
    "Retail Branding": "iLife",
    "Marketing Name": "I-LIFE",
    "Device": "KIDS_TAB_7",
    "Model": "KIDS_TAB_7"
  },
  {
    "Retail Branding": "iLife",
    "Marketing Name": "ITELL K4700",
    "Device": "ITELL_K4700",
    "Model": "ITELL K4700"
  },
  {
    "Retail Branding": "iLife",
    "Marketing Name": "ITELL_K3102N",
    "Device": "ITELL_K3102N",
    "Model": "ITELL_K3102N"
  },
  {
    "Retail Branding": "iLife",
    "Marketing Name": "ITELL_K3500N",
    "Device": "ITELL_K3500N",
    "Model": "ITELL_K3500N"
  },
  {
    "Retail Branding": "iLife",
    "Marketing Name": "ITELL_K3800Q",
    "Device": "ITELL_K3800Q",
    "Model": "ITELL_K3800Q"
  },
  {
    "Retail Branding": "iLife",
    "Marketing Name": "KIDS-TAB-4",
    "Device": "KIDS-TAB-4",
    "Model": "KIDS-TAB-4"
  },
  {
    "Retail Branding": "iLife",
    "Marketing Name": "KIDS-TAB-5",
    "Device": "KIDS-TAB-5",
    "Model": "KIDS-TAB-5"
  },
  {
    "Retail Branding": "iLife",
    "Marketing Name": "KIDS_TAB_6",
    "Device": "KIDS_TAB_6",
    "Model": "KIDS_TAB_6"
  },
  {
    "Retail Branding": "iLife",
    "Marketing Name": "MISA",
    "Device": "MISA",
    "Model": "MISA"
  },
  {
    "Retail Branding": "iMACHINE",
    "Marketing Name": "MobilePOSTerminal",
    "Device": "MobilePOSTerminal",
    "Model": "AP12"
  },
  {
    "Retail Branding": "iMACHINE",
    "Marketing Name": "iMACHINE AP02 PLUS",
    "Device": "AP02_PLUS",
    "Model": "AP02 PLUS"
  },
  {
    "Retail Branding": "iMACHINE",
    "Marketing Name": "iMachine AP12",
    "Device": "AP12",
    "Model": "AP12"
  },
  {
    "Retail Branding": "iMACHINE",
    "Marketing Name": "iMachine i2",
    "Device": "i2",
    "Model": "i2"
  },
  {
    "Retail Branding": "iMESH",
    "Marketing Name": "IM-560",
    "Device": "IM-560",
    "Model": "IM-560"
  },
  {
    "Retail Branding": "iMESH",
    "Marketing Name": "IM-A850T",
    "Device": "IM-A850T",
    "Model": "IM-A850T"
  },
  {
    "Retail Branding": "iMin",
    "Marketing Name": "Crane 1",
    "Device": "Crane1",
    "Model": "Crane1-21_27_32"
  },
  {
    "Retail Branding": "iMin",
    "Marketing Name": "Crane1",
    "Device": "Crane1",
    "Model": "Crane1-16"
  },
  {
    "Retail Branding": "iMin",
    "Marketing Name": "D4 Pro",
    "Device": "D4Pro",
    "Model": "I23D01"
  },
  {
    "Retail Branding": "iMin",
    "Marketing Name": "D4Pro",
    "Device": "D4Pro",
    "Model": "I23D01"
  },
  {
    "Retail Branding": "iMin",
    "Marketing Name": "Falcon 1",
    "Device": "I22T01",
    "Model": "I22T01"
  },
  {
    "Retail Branding": "iMin",
    "Marketing Name": "Falcon 1 Pro",
    "Device": "Falcon1Pro",
    "Model": "I25T01"
  },
  {
    "Retail Branding": "iMin",
    "Marketing Name": "Falcon 2",
    "Device": "Falcon2",
    "Model": "I24T01"
  },
  {
    "Retail Branding": "iMin",
    "Marketing Name": "Falcon 2",
    "Device": "Falcon2",
    "Model": "I24T02"
  },
  {
    "Retail Branding": "iMin",
    "Marketing Name": "Heron 1",
    "Device": "Heron1",
    "Model": "I25S02"
  },
  {
    "Retail Branding": "iMin",
    "Marketing Name": "Heron 1 mini",
    "Device": "Heron1mini",
    "Model": "I25S01"
  },
  {
    "Retail Branding": "iMin",
    "Marketing Name": "I24D02",
    "Device": "Swan2",
    "Model": "I24D02"
  },
  {
    "Retail Branding": "iMin",
    "Marketing Name": "I24T03",
    "Device": "Falcon2Max",
    "Model": "I24T03"
  },
  {
    "Retail Branding": "iMin",
    "Marketing Name": "Lark 1",
    "Device": "Lark1",
    "Model": "I24P01"
  },
  {
    "Retail Branding": "iMin",
    "Marketing Name": "Roc 1",
    "Device": "Roc1",
    "Model": "I25M01"
  },
  {
    "Retail Branding": "iMin",
    "Marketing Name": "Roc 1 Max",
    "Device": "Roc1Max",
    "Model": "I25M02"
  },
  {
    "Retail Branding": "iMin",
    "Marketing Name": "Swan 1 Pro",
    "Device": "Swan1Pro",
    "Model": "I23D02"
  },
  {
    "Retail Branding": "iMin",
    "Marketing Name": "Swan1Gen2",
    "Device": "Swan1Plus",
    "Model": "I24D06"
  },
  {
    "Retail Branding": "iMin",
    "Marketing Name": "Swan1Plus",
    "Device": "Swan1Plus",
    "Model": "I24D05"
  },
  {
    "Retail Branding": "iMin",
    "Marketing Name": "Swan1Pro",
    "Device": "Swan1Pro",
    "Model": "I23D02"
  },
  {
    "Retail Branding": "iMin",
    "Marketing Name": "Swan2Printer",
    "Device": "Swan2Printer",
    "Model": "I24D03"
  },
  {
    "Retail Branding": "iMin",
    "Marketing Name": "Swan2Scale",
    "Device": "Swan2Scale",
    "Model": "I24D04"
  },
  {
    "Retail Branding": "iMin",
    "Marketing Name": "Swift 1",
    "Device": "I22M01",
    "Model": "I22M01"
  },
  {
    "Retail Branding": "iMin",
    "Marketing Name": "Swift 1",
    "Device": "I22M01",
    "Model": "Swift_1"
  },
  {
    "Retail Branding": "iMin",
    "Marketing Name": "Swift 1 Pro",
    "Device": "Swift1Pro",
    "Model": "I23M03"
  },
  {
    "Retail Branding": "iMin",
    "Marketing Name": "Swift 1 Pro (A15)",
    "Device": "Swift1Pro",
    "Model": "I23M03"
  },
  {
    "Retail Branding": "iMin",
    "Marketing Name": "Swift 2",
    "Device": "Swift2",
    "Model": "I23M01_EEA"
  },
  {
    "Retail Branding": "iMin",
    "Marketing Name": "Swift 2",
    "Device": "Swift2",
    "Model": "I23M01_GL"
  },
  {
    "Retail Branding": "iMin",
    "Marketing Name": "Swift 2 Pro",
    "Device": "Swift2Pro",
    "Model": "I23M02"
  },
  {
    "Retail Branding": "iMin",
    "Marketing Name": "Swift2Ultra",
    "Device": "Swift2Ultra",
    "Model": "I24M01"
  },
  {
    "Retail Branding": "iMin",
    "Marketing Name": "iMinCrane1",
    "Device": "Crane1",
    "Model": "Crane1-16"
  },
  {
    "Retail Branding": "iMin",
    "Marketing Name": "iMinSwift2Pro",
    "Device": "Swift2Pro",
    "Model": "I23M02"
  },
  {
    "Retail Branding": "iMuz",
    "Marketing Name": "4K Smart TV",
    "Device": "pioneer",
    "Model": "4K SA Smart TV"
  },
  {
    "Retail Branding": "iMuz",
    "Marketing Name": "EG104",
    "Device": "EG104",
    "Model": "EG104"
  },
  {
    "Retail Branding": "iMuz",
    "Marketing Name": "EG110",
    "Device": "EG110",
    "Model": "EG110"
  },
  {
    "Retail Branding": "iMuz",
    "Marketing Name": "Foryou Digital Co.,Ltd",
    "Device": "EG125",
    "Model": "EG125"
  },
  {
    "Retail Branding": "iMuz",
    "Marketing Name": "G10",
    "Device": "G10",
    "Model": "G10"
  },
  {
    "Retail Branding": "iMuz",
    "Marketing Name": "G10E",
    "Device": "G10",
    "Model": "G10"
  },
  {
    "Retail Branding": "iMuz",
    "Marketing Name": "IM-B101F",
    "Device": "IM-B101F",
    "Model": "IM-B101F"
  },
  {
    "Retail Branding": "iMuz",
    "Marketing Name": "IM-B101H",
    "Device": "IM-B101H",
    "Model": "IM-B101H"
  },
  {
    "Retail Branding": "iMuz",
    "Marketing Name": "IM-H031",
    "Device": "IM-H031",
    "Model": "IM-H031"
  },
  {
    "Retail Branding": "iMuz",
    "Marketing Name": "IM-H092L",
    "Device": "IM-H092L",
    "Model": "IM-H092L"
  },
  {
    "Retail Branding": "iMuz",
    "Marketing Name": "IM-H092W",
    "Device": "IM-H092W",
    "Model": "IM-H092W"
  },
  {
    "Retail Branding": "iMuz",
    "Marketing Name": "IM-H261",
    "Device": "IM-H261",
    "Model": "IM-H261"
  },
  {
    "Retail Branding": "iMuz",
    "Marketing Name": "IM-H842",
    "Device": "IM-H842",
    "Model": "IM-H842"
  },
  {
    "Retail Branding": "iMuz",
    "Marketing Name": "IM-L101",
    "Device": "IM-L101",
    "Model": "IM-L101"
  },
  {
    "Retail Branding": "iMuz",
    "Marketing Name": "IM-L801",
    "Device": "IM-L801",
    "Model": "IM-L801"
  },
  {
    "Retail Branding": "iMuz",
    "Marketing Name": "IM-W261",
    "Device": "IM-W261",
    "Model": "IM-W261"
  },
  {
    "Retail Branding": "iMuz",
    "Marketing Name": "IMH101",
    "Device": "IMH101",
    "Model": "IMH101"
  },
  {
    "Retail Branding": "iMuz",
    "Marketing Name": "L101",
    "Device": "G10",
    "Model": "L101"
  },
  {
    "Retail Branding": "iMuz",
    "Marketing Name": "M101",
    "Device": "G10",
    "Model": "M101"
  },
  {
    "Retail Branding": "iMuz",
    "Marketing Name": "M101N",
    "Device": "G10",
    "Model": "L101"
  },
  {
    "Retail Branding": "iMuz",
    "Marketing Name": "RA10",
    "Device": "RA10",
    "Model": "RA10"
  },
  {
    "Retail Branding": "iMuz",
    "Marketing Name": "RG11",
    "Device": "RG11",
    "Model": "RG11"
  },
  {
    "Retail Branding": "iMuz",
    "Marketing Name": "Smart TV",
    "Device": "mateo",
    "Model": "2K SA Smart TV"
  },
  {
    "Retail Branding": "iMuz",
    "Marketing Name": "muPAD L10",
    "Device": "muPAD_L10",
    "Model": "muPAD L10"
  },
  {
    "Retail Branding": "iMuz",
    "Marketing Name": "muPAD102",
    "Device": "muPAD102",
    "Model": "muPAD102"
  },
  {
    "Retail Branding": "iMuz",
    "Marketing Name": "muPAD104",
    "Device": "muPAD104",
    "Model": "muPAD104"
  },
  {
    "Retail Branding": "iMuz",
    "Marketing Name": "muPADT7",
    "Device": "muPADT7",
    "Model": "muPADT7"
  },
  {
    "Retail Branding": "iMuz",
    "Marketing Name": "muPAD_K10",
    "Device": "muPAD_K10",
    "Model": "muPAD_K10"
  },
  {
    "Retail Branding": "iNFONE",
    "Marketing Name": "INFONE XE",
    "Device": "INFONE_XE",
    "Model": "INFONE XE"
  },
  {
    "Retail Branding": "iNFONE",
    "Marketing Name": "X_RAINBOW",
    "Device": "X_RAINBOW",
    "Model": "X_RAINBOW"
  },
  {
    "Retail Branding": "iNFONE",
    "Marketing Name": "infone X",
    "Device": "infone_X",
    "Model": "infone X"
  },
  {
    "Retail Branding": "iNO Mobile",
    "Marketing Name": "S9",
    "Device": "iNO_S9",
    "Model": "iNO S9"
  },
  {
    "Retail Branding": "iNanny",
    "Marketing Name": "NC1000",
    "Device": "NC1000",
    "Model": "NC1000"
  },
  {
    "Retail Branding": "iNew",
    "Marketing Name": "P20",
    "Device": "P20",
    "Model": "P20"
  },
  {
    "Retail Branding": "iNew",
    "Marketing Name": "P30",
    "Device": "P30",
    "Model": "P30"
  },
  {
    "Retail Branding": "iNew",
    "Marketing Name": "k1",
    "Device": "K1",
    "Model": "K1"
  },
  {
    "Retail Branding": "iPlus",
    "Marketing Name": "Nu60",
    "Device": "Nu60",
    "Model": "Nu60"
  },
  {
    "Retail Branding": "iPlus",
    "Marketing Name": "Nu70",
    "Device": "NU70",
    "Model": "Nu70"
  },
  {
    "Retail Branding": "iPlus",
    "Marketing Name": "Omega7",
    "Device": "Omega7",
    "Model": "Omega7"
  },
  {
    "Retail Branding": "iPlus",
    "Marketing Name": "Omega8",
    "Device": "Omega8",
    "Model": "Omega8"
  },
  {
    "Retail Branding": "iPlus",
    "Marketing Name": "iPlus P1",
    "Device": "iPlus_P1",
    "Model": "iPlus P1"
  },
  {
    "Retail Branding": "iPlus",
    "Marketing Name": "iPlus1",
    "Device": "iPlus1",
    "Model": "iPlus1"
  },
  {
    "Retail Branding": "iPlus",
    "Marketing Name": "iPlus_P3",
    "Device": "iPlus_P3",
    "Model": "iPlus P3"
  },
  {
    "Retail Branding": "iQOO",
    "Marketing Name": "I40-5_RU",
    "Device": "I2347-2_RU",
    "Model": "I2347-4_RU"
  },
  {
    "Retail Branding": "iQOO",
    "Marketing Name": "iQOO 15",
    "Device": "I2501",
    "Model": "I2501"
  },
  {
    "Retail Branding": "iQOO",
    "Marketing Name": "iQOO 15",
    "Device": "PD2505",
    "Model": "V2505A"
  },
  {
    "Retail Branding": "iQOO",
    "Marketing Name": "iQOO 15 Ultra",
    "Device": "PD2546",
    "Model": "V2546A"
  },
  {
    "Retail Branding": "iQOO",
    "Marketing Name": "iQOO 15R",
    "Device": "I2508",
    "Model": "I2508"
  },
  {
    "Retail Branding": "iQOO",
    "Marketing Name": "iQOO Neo 10",
    "Device": "I2405",
    "Model": "I2405"
  },
  {
    "Retail Branding": "iQOO",
    "Marketing Name": "iQOO Neo 10",
    "Device": "I2405",
    "Model": "I2408"
  },
  {
    "Retail Branding": "iQOO",
    "Marketing Name": "iQOO Neo10 Pro+",
    "Device": "PD2463",
    "Model": "V2463A"
  },
  {
    "Retail Branding": "iQOO",
    "Marketing Name": "iQOO Neo11",
    "Device": "PD2520",
    "Model": "V2520A"
  },
  {
    "Retail Branding": "iQOO",
    "Marketing Name": "iQOO Pad5",
    "Device": "DPD2437",
    "Model": "iPA2556"
  },
  {
    "Retail Branding": "iQOO",
    "Marketing Name": "iQOO Pad5 Pro",
    "Device": "DPD2429",
    "Model": "iPA2575"
  },
  {
    "Retail Branding": "iQOO",
    "Marketing Name": "iQOO Pad5e",
    "Device": "DPD2345",
    "Model": "iPA2453"
  },
  {
    "Retail Branding": "iQOO",
    "Marketing Name": "iQOO Pad5e",
    "Device": "DPD2345",
    "Model": "iPA2537"
  },
  {
    "Retail Branding": "iQOO",
    "Marketing Name": "iQOO Z10 Lite",
    "Device": "I2502",
    "Model": "I2502"
  },
  {
    "Retail Branding": "iQOO",
    "Marketing Name": "iQOO Z10 Lite 5G",
    "Device": "I2409",
    "Model": "I2409"
  },
  {
    "Retail Branding": "iQOO",
    "Marketing Name": "iQOO Z10 Turbo",
    "Device": "PD2452",
    "Model": "V2452A"
  },
  {
    "Retail Branding": "iQOO",
    "Marketing Name": "iQOO Z10 Turbo+",
    "Device": "PD2507",
    "Model": "V2507A"
  },
  {
    "Retail Branding": "iQOO",
    "Marketing Name": "iQOO Z10R 5G",
    "Device": "I2505",
    "Model": "I2505"
  },
  {
    "Retail Branding": "iQOO",
    "Marketing Name": "iQOO Z11 Turbo",
    "Device": "PD2536",
    "Model": "V2536A"
  },
  {
    "Retail Branding": "iQOO",
    "Marketing Name": "iQOO Z11x",
    "Device": "PD2532",
    "Model": "V2532A"
  },
  {
    "Retail Branding": "iQOO",
    "Marketing Name": "iQOO Z11x 5G",
    "Device": "I2507",
    "Model": "I2507"
  },
  {
    "Retail Branding": "iQandT",
    "Marketing Name": "G3",
    "Device": "G3",
    "Model": "G3"
  },
  {
    "Retail Branding": "iQandT",
    "Marketing Name": "N3",
    "Device": "N3",
    "Model": "N3"
  },
  {
    "Retail Branding": "iQandT",
    "Marketing Name": "N6",
    "Device": "N6",
    "Model": "N6"
  },
  {
    "Retail Branding": "iQandT",
    "Marketing Name": "N8",
    "Device": "iQT_N8",
    "Model": "iQ&T N8"
  },
  {
    "Retail Branding": "iQual",
    "Marketing Name": "T10G",
    "Device": "T10G",
    "Model": "T10G"
  },
  {
    "Retail Branding": "iQual",
    "Marketing Name": "T10L",
    "Device": "T10L",
    "Model": "T10L"
  },
  {
    "Retail Branding": "iQual",
    "Marketing Name": "T10W",
    "Device": "T10W",
    "Model": "T10W"
  },
  {
    "Retail Branding": "iQual",
    "Marketing Name": "T10W2",
    "Device": "T10W2",
    "Model": "T10W2"
  },
  {
    "Retail Branding": "iQual",
    "Marketing Name": "T7G",
    "Device": "T7G",
    "Model": "T7G"
  },
  {
    "Retail Branding": "iQual",
    "Marketing Name": "T7K",
    "Device": "T7K",
    "Model": "T7K"
  },
  {
    "Retail Branding": "iQual",
    "Marketing Name": "T7L",
    "Device": "T7L",
    "Model": "T7L"
  },
  {
    "Retail Branding": "iQual",
    "Marketing Name": "T7W",
    "Device": "T7W",
    "Model": "T7W"
  },
  {
    "Retail Branding": "iRainbow",
    "Marketing Name": "B12017",
    "Device": "B12017",
    "Model": "B12017"
  },
  {
    "Retail Branding": "iReplace",
    "Marketing Name": "Frog One",
    "Device": "FrogOne",
    "Model": "FrogOne"
  },
  {
    "Retail Branding": "iRiver",
    "Marketing Name": "",
    "Device": "smdkc110",
    "Model": "ILT-MX100"
  },
  {
    "Retail Branding": "iRiver",
    "Marketing Name": "DMT580D",
    "Device": "m805_892x",
    "Model": "DDA800R"
  },
  {
    "Retail Branding": "iRiver",
    "Marketing Name": "DMT580D",
    "Device": "m805_892x",
    "Model": "DMT580D"
  },
  {
    "Retail Branding": "iRiver",
    "Marketing Name": "DMT580D",
    "Device": "m805_892x",
    "Model": "MIT700"
  },
  {
    "Retail Branding": "iRiver",
    "Marketing Name": "MM3202",
    "Device": "mm3201",
    "Model": "MM-3201"
  },
  {
    "Retail Branding": "iRiver",
    "Marketing Name": "MM3202",
    "Device": "mm3201",
    "Model": "MM-3202"
  },
  {
    "Retail Branding": "iRiver",
    "Marketing Name": "ULALA",
    "Device": "msm7627a_sku3",
    "Model": "I-K1"
  },
  {
    "Retail Branding": "iRiver",
    "Marketing Name": "WOW Tab+(ITQ1000)",
    "Device": "itq1000",
    "Model": "ITQ1000"
  },
  {
    "Retail Branding": "iRiver",
    "Marketing Name": "WPT005",
    "Device": "wikipad",
    "Model": "WPT005"
  },
  {
    "Retail Branding": "iRiver",
    "Marketing Name": "Wow TAB +",
    "Device": "itq701",
    "Model": "ITQ701"
  },
  {
    "Retail Branding": "iRiver",
    "Marketing Name": "Wow(Window of the world)",
    "Device": "itq700",
    "Model": "ITQ700"
  },
  {
    "Retail Branding": "iRiver",
    "Marketing Name": "Wow(Window of the world)",
    "Device": "itq700",
    "Model": "YBMK01"
  },
  {
    "Retail Branding": "iRiver",
    "Marketing Name": "iRiver",
    "Device": "seocho",
    "Model": "Iriver 4K Android TV"
  },
  {
    "Retail Branding": "iRulu",
    "Marketing Name": "Irulu",
    "Device": "octopus-masu",
    "Model": "X10"
  },
  {
    "Retail Branding": "iRulu",
    "Marketing Name": "L20",
    "Device": "L20",
    "Model": "L20"
  },
  {
    "Retail Branding": "iRulu",
    "Marketing Name": "L21",
    "Device": "L21",
    "Model": "L21"
  },
  {
    "Retail Branding": "iRulu",
    "Marketing Name": "P10",
    "Device": "P10",
    "Model": "P10"
  },
  {
    "Retail Branding": "iRulu",
    "Marketing Name": "X18",
    "Device": "X18",
    "Model": "X18"
  },
  {
    "Retail Branding": "iRulu",
    "Marketing Name": "X27",
    "Device": "X27",
    "Model": "X27"
  },
  {
    "Retail Branding": "iRulu",
    "Marketing Name": "X37",
    "Device": "iRULU-X37",
    "Model": "X37"
  },
  {
    "Retail Branding": "iRulu",
    "Marketing Name": "X4",
    "Device": "iRULU_X4",
    "Model": "X4"
  },
  {
    "Retail Branding": "iRulu",
    "Marketing Name": "X40",
    "Device": "iRULU-X40",
    "Model": "X40"
  },
  {
    "Retail Branding": "iRulu",
    "Marketing Name": "X47",
    "Device": "X47",
    "Model": "X47"
  },
  {
    "Retail Branding": "iRulu",
    "Marketing Name": "X57",
    "Device": "iRULU_X57",
    "Model": "X57"
  },
  {
    "Retail Branding": "iRulu",
    "Marketing Name": "X58",
    "Device": "iRULU-X58",
    "Model": "X58"
  },
  {
    "Retail Branding": "iRulu",
    "Marketing Name": "X67",
    "Device": "iRULU_X67",
    "Model": "X67"
  },
  {
    "Retail Branding": "iRulu",
    "Marketing Name": "X77",
    "Device": "X77",
    "Model": "X77"
  },
  {
    "Retail Branding": "iRulu",
    "Marketing Name": "Y57",
    "Device": "Y57",
    "Model": "Y57"
  },
  {
    "Retail Branding": "iRulu",
    "Marketing Name": "Y57",
    "Device": "iRULU_Y57",
    "Model": "Y57"
  },
  {
    "Retail Branding": "iRulu",
    "Marketing Name": "Y57P_EEA",
    "Device": "Y57P",
    "Model": "Y57P"
  },
  {
    "Retail Branding": "iRulu",
    "Marketing Name": "iRULU_G36",
    "Device": "iRULU_G36",
    "Model": "G36"
  },
  {
    "Retail Branding": "iSTAR",
    "Marketing Name": "S32WD02",
    "Device": "beaudry",
    "Model": "iSTAR AndroidTV"
  },
  {
    "Retail Branding": "iSTAR",
    "Marketing Name": "S55WD01",
    "Device": "barking",
    "Model": "iSTAR AndroidTV"
  },
  {
    "Retail Branding": "iSWAG",
    "Marketing Name": "ALPHA",
    "Device": "Alpha",
    "Model": "Alpha"
  },
  {
    "Retail Branding": "iSWAG",
    "Marketing Name": "APOLLO",
    "Device": "APOLLO",
    "Model": "APOLLO"
  },
  {
    "Retail Branding": "iSWAG",
    "Marketing Name": "BLINK",
    "Device": "BLINK",
    "Model": "BLINK"
  },
  {
    "Retail Branding": "iSWAG",
    "Marketing Name": "ISWAG_NEMESIS",
    "Device": "ISWAG_NEMESIS",
    "Model": "ISWAG_NEMESIS"
  },
  {
    "Retail Branding": "iSWAG",
    "Marketing Name": "ISWAG_VIPER",
    "Device": "ISWAG_VIPER",
    "Model": "ISWAG VIPER"
  },
  {
    "Retail Branding": "iSWAG",
    "Marketing Name": "MATRIX",
    "Device": "ISWAG_MATRIX",
    "Model": "ISWAG MATRIX"
  },
  {
    "Retail Branding": "iSWAG",
    "Marketing Name": "NEO",
    "Device": "ISWAG_NEO",
    "Model": "ISWAG NEO"
  },
  {
    "Retail Branding": "iSWAG",
    "Marketing Name": "ODIN",
    "Device": "ODIN",
    "Model": "ODIN"
  },
  {
    "Retail Branding": "iSWAG",
    "Marketing Name": "STREAM7",
    "Device": "STREAM7",
    "Model": "STREAM7"
  },
  {
    "Retail Branding": "iSWAG",
    "Marketing Name": "STREAM7Plus",
    "Device": "STREAM7Plus",
    "Model": "STREAM7"
  },
  {
    "Retail Branding": "iSWAG",
    "Marketing Name": "iSWAG ACTIV",
    "Device": "iSWAG_ACTIV",
    "Model": "iSWAG ACTIV"
  },
  {
    "Retail Branding": "iTab XPLUS",
    "Marketing Name": "ITAB_X38T",
    "Device": "ITAB_X38T",
    "Model": "ITAB_X38T"
  },
  {
    "Retail Branding": "iTab XPLUS",
    "Marketing Name": "iTAB-A1",
    "Device": "iTAB-A1",
    "Model": "iTAB-A1"
  },
  {
    "Retail Branding": "iTab XPLUS",
    "Marketing Name": "iTab_XPLUS_10_1",
    "Device": "iTab_XPLUS_10_1",
    "Model": "iTab_XPLUS_10_1"
  },
  {
    "Retail Branding": "iTree",
    "Marketing Name": "S898",
    "Device": "S898",
    "Model": "S898"
  },
  {
    "Retail Branding": "iTree",
    "Marketing Name": "S988",
    "Device": "S988",
    "Model": "S988"
  },
  {
    "Retail Branding": "iTree",
    "Marketing Name": "S988",
    "Device": "S988_itree",
    "Model": "S988"
  },
  {
    "Retail Branding": "iVOOMi",
    "Marketing Name": "Me 1",
    "Device": "Me_1",
    "Model": "iV 505"
  },
  {
    "Retail Branding": "iVOOMi",
    "Marketing Name": "Me 1+",
    "Device": "Me_1_plus",
    "Model": "Me 1+"
  },
  {
    "Retail Branding": "iVOOMi",
    "Marketing Name": "Me 2",
    "Device": "Me_2",
    "Model": "Me 2"
  },
  {
    "Retail Branding": "iVOOMi",
    "Marketing Name": "Me 3",
    "Device": "Me_3",
    "Model": "Me 3"
  },
  {
    "Retail Branding": "iVOOMi",
    "Marketing Name": "Me 3S",
    "Device": "Me_3S",
    "Model": "Me 3S"
  },
  {
    "Retail Branding": "iVOOMi",
    "Marketing Name": "Me 4",
    "Device": "Me_4",
    "Model": "Me 4"
  },
  {
    "Retail Branding": "iVOOMi",
    "Marketing Name": "Me 5",
    "Device": "Me_5",
    "Model": "Me 5"
  },
  {
    "Retail Branding": "iVOOMi",
    "Marketing Name": "V5",
    "Device": "V5",
    "Model": "V5"
  },
  {
    "Retail Branding": "iVOOMi",
    "Marketing Name": "i1",
    "Device": "i1",
    "Model": "i1"
  },
  {
    "Retail Branding": "iVOOMi",
    "Marketing Name": "i1s",
    "Device": "i1s",
    "Model": "i1s"
  },
  {
    "Retail Branding": "iVOOMi",
    "Marketing Name": "i2",
    "Device": "i2",
    "Model": "i2"
  },
  {
    "Retail Branding": "iVOOMi",
    "Marketing Name": "i2 Lite",
    "Device": "i2_Lite",
    "Model": "i2_Lite"
  },
  {
    "Retail Branding": "iVOOMi",
    "Marketing Name": "iV_301",
    "Device": "iV_301",
    "Model": "iV_301"
  },
  {
    "Retail Branding": "iWaylink",
    "Marketing Name": "MC401",
    "Device": "MC401_GWL",
    "Model": "MC401_GWL"
  },
  {
    "Retail Branding": "iWaylink",
    "Marketing Name": "MC432",
    "Device": "MC432A_GWL",
    "Model": "MC432A_GWL"
  },
  {
    "Retail Branding": "iWaylink",
    "Marketing Name": "MC432A_W",
    "Device": "MC432A_GWL",
    "Model": "MC432A_GWL"
  },
  {
    "Retail Branding": "iWaylink",
    "Marketing Name": "TC601",
    "Device": "TC601_GWL",
    "Model": "TC601_GWL"
  },
  {
    "Retail Branding": "iWaylink",
    "Marketing Name": "TC601A",
    "Device": "TC601A_GWL",
    "Model": "TC601A_GWL"
  },
  {
    "Retail Branding": "iWaylink",
    "Marketing Name": "TC601B",
    "Device": "TC601B_GWL",
    "Model": "TC601B_GWL"
  },
  {
    "Retail Branding": "iWaylink",
    "Marketing Name": "TC603B",
    "Device": "TC603B_GWL",
    "Model": "TC603B_GWL"
  },
  {
    "Retail Branding": "iWaylink",
    "Marketing Name": "TC603B_P",
    "Device": "TC603B_GWL",
    "Model": "TC603B_GWL"
  },
  {
    "Retail Branding": "iYOU",
    "Marketing Name": "A10",
    "Device": "A10",
    "Model": "A10"
  },
  {
    "Retail Branding": "iYOU",
    "Marketing Name": "A30",
    "Device": "A30",
    "Model": "A30"
  },
  {
    "Retail Branding": "iYOU",
    "Marketing Name": "iYOU_M1",
    "Device": "iYOU_M1",
    "Model": "iYOU_M1"
  },
  {
    "Retail Branding": "i_con",
    "Marketing Name": "V1",
    "Device": "V1",
    "Model": "V1"
  },
  {
    "Retail Branding": "ibowin",
    "Marketing Name": "M10ES11",
    "Device": "M10ES11",
    "Model": "M130s"
  },
  {
    "Retail Branding": "iiyama",
    "Marketing Name": "PLXX12U",
    "Device": "RK3576",
    "Model": "TEXX12MIS"
  },
  {
    "Retail Branding": "iiyama",
    "Marketing Name": "TEXX13A",
    "Device": "TEXX13A",
    "Model": "TEXX13A"
  },
  {
    "Retail Branding": "iiyama",
    "Marketing Name": "TEXX14MIS-B2AG",
    "Device": "rk3588_t",
    "Model": "TEXX14MIS-B2AG"
  },
  {
    "Retail Branding": "iiyama",
    "Marketing Name": "TEXX15A",
    "Device": "TEXX15A",
    "Model": "TEXX15A"
  },
  {
    "Retail Branding": "imiia",
    "Marketing Name": "4K Smart TV",
    "Device": "gangbyeon",
    "Model": "imiia 4K AI Smart TV"
  },
  {
    "Retail Branding": "imiia",
    "Marketing Name": "4K Smart TV",
    "Device": "pioneer",
    "Model": "4K PA Smart TV"
  },
  {
    "Retail Branding": "imiia",
    "Marketing Name": "Smart TV",
    "Device": "mateo",
    "Model": "2K PA Smart TV"
  },
  {
    "Retail Branding": "imiia",
    "Marketing Name": "i-217D1",
    "Device": "YUL",
    "Model": "i-217D1"
  },
  {
    "Retail Branding": "imiia",
    "Marketing Name": "imiia 2k stick",
    "Device": "IAD",
    "Model": "imiia 2k stick"
  },
  {
    "Retail Branding": "imiia",
    "Marketing Name": "imiia 4K Google TV",
    "Device": "keoneae",
    "Model": "imiia 4K Google TV"
  },
  {
    "Retail Branding": "imiia",
    "Marketing Name": "imiia 4K Google TV-Y",
    "Device": "keoneae",
    "Model": "imiia 4K Google TV-Y"
  },
  {
    "Retail Branding": "imose",
    "Marketing Name": "BAM III",
    "Device": "BAM_III",
    "Model": "BAM III"
  },
  {
    "Retail Branding": "imose",
    "Marketing Name": "BAM-II",
    "Device": "BAM-II",
    "Model": "BAM-II"
  },
  {
    "Retail Branding": "imose",
    "Marketing Name": "OPOR",
    "Device": "OPOR",
    "Model": "OPOR"
  },
  {
    "Retail Branding": "imose",
    "Marketing Name": "Omotab2",
    "Device": "Omotab2",
    "Model": "Omotab2"
  },
  {
    "Retail Branding": "imose",
    "Marketing Name": "Omotab_2s",
    "Device": "Omotab_2s",
    "Model": "Omotab 2s"
  },
  {
    "Retail Branding": "imose",
    "Marketing Name": "SEMPE",
    "Device": "SEMPE",
    "Model": "SEMPE"
  },
  {
    "Retail Branding": "imozen",
    "Marketing Name": "TC605AN",
    "Device": "TC605",
    "Model": "TC605"
  },
  {
    "Retail Branding": "imozen",
    "Marketing Name": "TC605AW",
    "Device": "TC605",
    "Model": "TC605"
  },
  {
    "Retail Branding": "incar",
    "Marketing Name": "E38_RU",
    "Device": "E38",
    "Model": "E38"
  },
  {
    "Retail Branding": "incar",
    "Marketing Name": "OMR104GT25-L",
    "Device": "R10_4G",
    "Model": "R10_4G"
  },
  {
    "Retail Branding": "incar",
    "Marketing Name": "TL65611S01",
    "Device": "TL65611S01",
    "Model": "TL65611S01"
  },
  {
    "Retail Branding": "indigi",
    "Marketing Name": "G4i",
    "Device": "G4i",
    "Model": "G4i"
  },
  {
    "Retail Branding": "inefi",
    "Marketing Name": "Android_G17",
    "Device": "Android_G17",
    "Model": "Android_G17"
  },
  {
    "Retail Branding": "inefi",
    "Marketing Name": "Android_G18",
    "Device": "Android_G18",
    "Model": "Android_G18"
  },
  {
    "Retail Branding": "inefi",
    "Marketing Name": "SlimPOS319",
    "Device": "SlimPOS319",
    "Model": "SlimPOS319"
  },
  {
    "Retail Branding": "innex",
    "Marketing Name": "Meeting_hub_EU",
    "Device": "EU_3588",
    "Model": "EU"
  },
  {
    "Retail Branding": "innex",
    "Marketing Name": "innex_Meeting_Hub_EU",
    "Device": "oversea_v",
    "Model": "EU15"
  },
  {
    "Retail Branding": "innos",
    "Marketing Name": "Android TV",
    "Device": "R2",
    "Model": "ATV R2"
  },
  {
    "Retail Branding": "innos",
    "Marketing Name": "Innos",
    "Device": "shilin",
    "Model": "Innos4KAndroidTV"
  },
  {
    "Retail Branding": "innos",
    "Marketing Name": "innos",
    "Device": "bruno",
    "Model": "Innos2KAndroidTV"
  },
  {
    "Retail Branding": "innos",
    "Marketing Name": "innos 2K Google TV",
    "Device": "capitolhill",
    "Model": "innos 2K Google TV"
  },
  {
    "Retail Branding": "innos",
    "Marketing Name": "innos 2K Google TV-A",
    "Device": "capitolhill",
    "Model": "innos 2K Google TV-A"
  },
  {
    "Retail Branding": "innos",
    "Marketing Name": "innos 4K Google TV",
    "Device": "keoneae",
    "Model": "innos 4K Google TV"
  },
  {
    "Retail Branding": "innos",
    "Marketing Name": "innos 4K Google TV-A",
    "Device": "keoneae",
    "Model": "innos 4K Google TV-A"
  },
  {
    "Retail Branding": "innos",
    "Marketing Name": "innos Google TV",
    "Device": "bandra",
    "Model": "innos Google TV"
  },
  {
    "Retail Branding": "intelkom",
    "Marketing Name": "meanIT_C1",
    "Device": "meanIT_C1",
    "Model": "meanIT_C1"
  },
  {
    "Retail Branding": "intelkom",
    "Marketing Name": "meanIT_C2",
    "Device": "meanIT_C2",
    "Model": "meanIT_C2"
  },
  {
    "Retail Branding": "intelkom",
    "Marketing Name": "meanIT_X2",
    "Device": "meanIT_X2",
    "Model": "meanIT_X2"
  },
  {
    "Retail Branding": "iotapk",
    "Marketing Name": "HONOR CHOICE T10",
    "Device": "BLK-L03",
    "Model": "BLK-L03"
  },
  {
    "Retail Branding": "iotapk",
    "Marketing Name": "HONOR CHOICE T10",
    "Device": "BLK-L09",
    "Model": "BLK-L09"
  },
  {
    "Retail Branding": "ioutdoor",
    "Marketing Name": "L611",
    "Device": "L611",
    "Model": "L611"
  },
  {
    "Retail Branding": "ioutdoor",
    "Marketing Name": "Polar3",
    "Device": "Polar3",
    "Model": "Polar3"
  },
  {
    "Retail Branding": "ioutdoor",
    "Marketing Name": "Polar3_EEA",
    "Device": "Polar3",
    "Model": "Polar3"
  },
  {
    "Retail Branding": "jAC-EG",
    "Marketing Name": "43JB822",
    "Device": "beaudry",
    "Model": "jAC AndroidTV"
  },
  {
    "Retail Branding": "jAC-EG",
    "Marketing Name": "55JB832",
    "Device": "barking",
    "Model": "jAC AndroidTV"
  },
  {
    "Retail Branding": "jHon",
    "Marketing Name": "H800",
    "Device": "H800",
    "Model": "H800"
  },
  {
    "Retail Branding": "jetfon",
    "Marketing Name": "MT1",
    "Device": "MT1",
    "Model": "MS4GSA02"
  },
  {
    "Retail Branding": "joyar",
    "Marketing Name": "joyar_mid",
    "Device": "joyar_mid",
    "Model": "joyar_mid"
  },
  {
    "Retail Branding": "kiddoboo",
    "Marketing Name": "KB101",
    "Device": "KB101",
    "Model": "KB101"
  },
  {
    "Retail Branding": "kiddoboo",
    "Marketing Name": "KB101B",
    "Device": "KB101B",
    "Model": "KB101B"
  },
  {
    "Retail Branding": "kiddoboo",
    "Marketing Name": "KB102",
    "Device": "KB102",
    "Model": "KB102"
  },
  {
    "Retail Branding": "kiddoboo",
    "Marketing Name": "KB82P",
    "Device": "KB82P",
    "Model": "KB82P"
  },
  {
    "Retail Branding": "kiddoboo",
    "Marketing Name": "Kiddoboo Plus KB80P",
    "Device": "KB80P",
    "Model": "Kiddoboo Plus KB80P"
  },
  {
    "Retail Branding": "koobee",
    "Marketing Name": "F2",
    "Device": "koobee_F2",
    "Model": "F2"
  },
  {
    "Retail Branding": "koobee",
    "Marketing Name": "F2 Plus",
    "Device": "koobee_F2_Plus",
    "Model": "F2_Plus"
  },
  {
    "Retail Branding": "koobee",
    "Marketing Name": "F2_Plus",
    "Device": "koobee_F2_Plus",
    "Model": "F2_Plus"
  },
  {
    "Retail Branding": "koobee",
    "Marketing Name": "K20",
    "Device": "koobee_K20",
    "Model": "K20"
  },
  {
    "Retail Branding": "koobee",
    "Marketing Name": "K8",
    "Device": "Koobee_K8",
    "Model": "K8"
  },
  {
    "Retail Branding": "koobee",
    "Marketing Name": "Koobee K60",
    "Device": "Koobee_K60",
    "Model": "K60"
  },
  {
    "Retail Branding": "koobee",
    "Marketing Name": "Koobee_K100",
    "Device": "SL004T",
    "Model": "SL004T"
  },
  {
    "Retail Branding": "koobee",
    "Marketing Name": "S12",
    "Device": "koobee_S12",
    "Model": "S12"
  },
  {
    "Retail Branding": "koobee",
    "Marketing Name": "S16",
    "Device": "koobee_S16",
    "Model": "S16"
  },
  {
    "Retail Branding": "koobee",
    "Marketing Name": "S19",
    "Device": "Koobee_S19",
    "Model": "S19"
  },
  {
    "Retail Branding": "koobee",
    "Marketing Name": "koobee_K10",
    "Device": "koobee_K10",
    "Model": "K10"
  },
  {
    "Retail Branding": "koobee",
    "Marketing Name": "koobee_S12",
    "Device": "koobee_S12",
    "Model": "S12"
  },
  {
    "Retail Branding": "kozen",
    "Marketing Name": "D1",
    "Device": "D1",
    "Model": "D1"
  },
  {
    "Retail Branding": "kozen",
    "Marketing Name": "D8",
    "Device": "D8",
    "Model": "D8"
  },
  {
    "Retail Branding": "kozen",
    "Marketing Name": "P18",
    "Device": "P18",
    "Model": "P18"
  },
  {
    "Retail Branding": "kozen",
    "Marketing Name": "T5",
    "Device": "T05",
    "Model": "T5"
  },
  {
    "Retail Branding": "leaderhub",
    "Marketing Name": "S18PRO-H_EEA",
    "Device": "S18PRO-H_EEA",
    "Model": "S18PRO-H"
  },
  {
    "Retail Branding": "leaderhub",
    "Marketing Name": "S19_EEA",
    "Device": "S19_EEA",
    "Model": "S19"
  },
  {
    "Retail Branding": "leaderhub",
    "Marketing Name": "S20",
    "Device": "S20",
    "Model": "S20C"
  },
  {
    "Retail Branding": "leaderhub",
    "Marketing Name": "S21",
    "Device": "S21",
    "Model": "S21"
  },
  {
    "Retail Branding": "loopDL",
    "Marketing Name": "Loop",
    "Device": "theloop_ROW",
    "Model": "theloop_ROW"
  },
  {
    "Retail Branding": "mMax",
    "Marketing Name": "mMax M55",
    "Device": "M55",
    "Model": "M55"
  },
  {
    "Retail Branding": "memetech",
    "Marketing Name": "P30",
    "Device": "P30",
    "Model": "P30"
  },
  {
    "Retail Branding": "menfop",
    "Marketing Name": "HaierP8B",
    "Device": "HaierP8B",
    "Model": "HaierP8B"
  },
  {
    "Retail Branding": "menfop",
    "Marketing Name": "T1085",
    "Device": "T1085",
    "Model": "T1085"
  },
  {
    "Retail Branding": "mipo",
    "Marketing Name": "M34",
    "Device": "mipo_M34",
    "Model": "mipo_M34"
  },
  {
    "Retail Branding": "mipo",
    "Marketing Name": "M36",
    "Device": "mipo_M36",
    "Model": "mipo_M36"
  },
  {
    "Retail Branding": "mipo",
    "Marketing Name": "mipo_M17",
    "Device": "mipo_M17",
    "Model": "mipo_M17"
  },
  {
    "Retail Branding": "mipo",
    "Marketing Name": "mipo_M25",
    "Device": "mipo_M25",
    "Model": "mipo_M25"
  },
  {
    "Retail Branding": "mipo",
    "Marketing Name": "mipo_M46_Plus",
    "Device": "mipo_M46_Plus",
    "Model": "mipo_M46_Plus"
  },
  {
    "Retail Branding": "mipo",
    "Marketing Name": "mipo_M59",
    "Device": "mipo_M59",
    "Model": "mipo_M59"
  },
  {
    "Retail Branding": "mipo",
    "Marketing Name": "mipo_m26",
    "Device": "mipo_m26",
    "Model": "mipo_m26"
  },
  {
    "Retail Branding": "mipo",
    "Marketing Name": "mipo_m28",
    "Device": "mipo_m28",
    "Model": "mipo_m28"
  },
  {
    "Retail Branding": "miracle_tap",
    "Marketing Name": "miracle_tap_10",
    "Device": "miracle_tap_10",
    "Model": "miracle_tap_10"
  },
  {
    "Retail Branding": "mirarel",
    "Marketing Name": "16MBTW+",
    "Device": "ksr",
    "Model": "mirarel JTB Google TV"
  },
  {
    "Retail Branding": "moderness.online",
    "Marketing Name": "TK807",
    "Device": "TK807",
    "Model": "TK807"
  },
  {
    "Retail Branding": "mytel",
    "Marketing Name": "M9501",
    "Device": "M9501",
    "Model": "M9501"
  },
  {
    "Retail Branding": "mytel",
    "Marketing Name": "M9502",
    "Device": "M9502",
    "Model": "M9502"
  },
  {
    "Retail Branding": "mytel",
    "Marketing Name": "M9503",
    "Device": "M9503",
    "Model": "M9503"
  },
  {
    "Retail Branding": "mytel",
    "Marketing Name": "M9602",
    "Device": "M9602",
    "Model": "M9602"
  },
  {
    "Retail Branding": "mytel",
    "Marketing Name": "Msuper",
    "Device": "Msuper",
    "Model": "Msuper"
  },
  {
    "Retail Branding": "mytel",
    "Marketing Name": "Mytel M9601",
    "Device": "Mytel_M9601",
    "Model": "M9601"
  },
  {
    "Retail Branding": "naomicase",
    "Marketing Name": "N4",
    "Device": "N4",
    "Model": "N4"
  },
  {
    "Retail Branding": "naomicase",
    "Marketing Name": "N4MAX",
    "Device": "N4MAX",
    "Model": "N4MAX"
  },
  {
    "Retail Branding": "neocore",
    "Marketing Name": "NEOCORE-E2S",
    "Device": "NEOCORE-E2S",
    "Model": "NEOCORE-E2S"
  },
  {
    "Retail Branding": "neocore",
    "Marketing Name": "NEOCORE_E2",
    "Device": "NEOCORE_E2",
    "Model": "NEOCORE_E2"
  },
  {
    "Retail Branding": "neocore",
    "Marketing Name": "neocore_E1_2",
    "Device": "neocore_E1_2_eea",
    "Model": "neocore E1-2"
  },
  {
    "Retail Branding": "neocore",
    "Marketing Name": "neocore_N1G1",
    "Device": "neocore_N1G1",
    "Model": "neocore_N1G1"
  },
  {
    "Retail Branding": "neutab",
    "Marketing Name": "K1S",
    "Device": "K1S",
    "Model": "K1S"
  },
  {
    "Retail Branding": "neutab",
    "Marketing Name": "i7",
    "Device": "i7",
    "Model": "i7"
  },
  {
    "Retail Branding": "newsan",
    "Marketing Name": "N405",
    "Device": "N405",
    "Model": "N405"
  },
  {
    "Retail Branding": "noDROPOUT",
    "Marketing Name": "T25",
    "Device": "T25",
    "Model": "T25"
  },
  {
    "Retail Branding": "novo",
    "Marketing Name": "Bonvi Prime",
    "Device": "t596_novo_37m35",
    "Model": "Bonvi Prime"
  },
  {
    "Retail Branding": "novo",
    "Marketing Name": "Bonvi Pro",
    "Device": "t596_dp_n_37m35",
    "Model": "Bonvi Pro"
  },
  {
    "Retail Branding": "oboni",
    "Marketing Name": "Smart TV",
    "Device": "alimos",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "oboni",
    "Marketing Name": "Smart TV",
    "Device": "bridgeport",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "oboni",
    "Marketing Name": "Smart TV",
    "Device": "bridgeport",
    "Model": "AI PONT FF"
  },
  {
    "Retail Branding": "oboni",
    "Marketing Name": "Smart TV",
    "Device": "dangni",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "oboni",
    "Marketing Name": "Smart TV",
    "Device": "osaka",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "oboni",
    "Marketing Name": "Smart TV",
    "Device": "osaka",
    "Model": "AI PONT SA"
  },
  {
    "Retail Branding": "okayseamedia",
    "Marketing Name": "TK706",
    "Device": "TK706",
    "Model": "TK706"
  },
  {
    "Retail Branding": "okayseamedia",
    "Marketing Name": "TK708",
    "Device": "TK708",
    "Model": "TK708"
  },
  {
    "Retail Branding": "okayseamedia",
    "Marketing Name": "TK708_EEA",
    "Device": "TK708_EEA",
    "Model": "TK708_EEA"
  },
  {
    "Retail Branding": "okulaku",
    "Marketing Name": "K10",
    "Device": "K10",
    "Model": "K10"
  },
  {
    "Retail Branding": "okulaku",
    "Marketing Name": "UKD30",
    "Device": "UKD30",
    "Model": "UKD30"
  },
  {
    "Retail Branding": "okulaku",
    "Marketing Name": "ZIDS701",
    "Device": "ZIDS701",
    "Model": "ZIDS701"
  },
  {
    "Retail Branding": "oneview",
    "Marketing Name": "OV2219",
    "Device": "OV2219",
    "Model": "OV2219"
  },
  {
    "Retail Branding": "onn.",
    "Marketing Name": "10.4“ Tablet Pro",
    "Device": 100110603,
    "Model": 100110603
  },
  {
    "Retail Branding": "onn.",
    "Marketing Name": 100003562,
    "Device": "mid1035_mq",
    "Model": 100003562
  },
  {
    "Retail Branding": "onn.",
    "Marketing Name": 100011885,
    "Device": 100011885,
    "Model": 100011885
  },
  {
    "Retail Branding": "onn.",
    "Marketing Name": 100011886,
    "Device": 100011886,
    "Model": 100011886
  },
  {
    "Retail Branding": "onn.",
    "Marketing Name": "100015685-A",
    "Device": "100015685-A",
    "Model": "100015685-A"
  },
  {
    "Retail Branding": "onn.",
    "Marketing Name": 100044018,
    "Device": 100044018,
    "Model": 100044018
  },
  {
    "Retail Branding": "onn.",
    "Marketing Name": "100044018G",
    "Device": "100044018G",
    "Model": "100044018G"
  },
  {
    "Retail Branding": "onn.",
    "Marketing Name": "100044018P",
    "Device": "100044018P",
    "Model": "100044018P"
  },
  {
    "Retail Branding": "onn.",
    "Marketing Name": 100071481,
    "Device": "mid7019_mr_32",
    "Model": 100071481
  },
  {
    "Retail Branding": "onn.",
    "Marketing Name": "100071481A",
    "Device": "mid7019_mr_32",
    "Model": "100071481A"
  },
  {
    "Retail Branding": "onn.",
    "Marketing Name": 100071483,
    "Device": 100071483,
    "Model": 100071483
  },
  {
    "Retail Branding": "onn.",
    "Marketing Name": "100071483A",
    "Device": "100071483A",
    "Model": "100071483A"
  },
  {
    "Retail Branding": "onn.",
    "Marketing Name": 100071485,
    "Device": 100071485,
    "Model": 100071485
  },
  {
    "Retail Branding": "onn.",
    "Marketing Name": "100071485A",
    "Device": "100071485A",
    "Model": "100071485A"
  },
  {
    "Retail Branding": "onn.",
    "Marketing Name": 100071486,
    "Device": 100071486,
    "Model": 100071486
  },
  {
    "Retail Branding": "onn.",
    "Marketing Name": "100071486A",
    "Device": "100071486A",
    "Model": "100071486A"
  },
  {
    "Retail Branding": "onn.",
    "Marketing Name": 100092980,
    "Device": 100092980,
    "Model": 100092980
  },
  {
    "Retail Branding": "onn.",
    "Marketing Name": "100092980A",
    "Device": "100092980A",
    "Model": "100092980A"
  },
  {
    "Retail Branding": "onn.",
    "Marketing Name": 100092988,
    "Device": "mid7019_mr_32",
    "Model": 100092988
  },
  {
    "Retail Branding": "onn.",
    "Marketing Name": "100092988A",
    "Device": "mid7019_mr_32",
    "Model": "100092988A"
  },
  {
    "Retail Branding": "onn.",
    "Marketing Name": 100110027,
    "Device": "mid1108_ms_64",
    "Model": 100110027
  },
  {
    "Retail Branding": "onn.",
    "Marketing Name": 100135794,
    "Device": 100135794,
    "Model": 100135794
  },
  {
    "Retail Branding": "onn.",
    "Marketing Name": 100135920,
    "Device": 100135920,
    "Model": 100135920
  },
  {
    "Retail Branding": "onn.",
    "Marketing Name": 100135921,
    "Device": "mid7021_mq",
    "Model": 100135921
  },
  {
    "Retail Branding": "onn.",
    "Marketing Name": 100135924,
    "Device": "mid7021_mq",
    "Model": 100135924
  },
  {
    "Retail Branding": "onn.",
    "Marketing Name": 36020962,
    "Device": "onn7core",
    "Model": 36020962
  },
  {
    "Retail Branding": "onn.",
    "Marketing Name": "M17QF21W",
    "Device": "M17QF21W",
    "Model": "M17QF21W"
  },
  {
    "Retail Branding": "onn.",
    "Marketing Name": "MID8016",
    "Device": "mid8016_mk_32",
    "Model": "MID8016"
  },
  {
    "Retail Branding": "onn.",
    "Marketing Name": "PK76A",
    "Device": "PK76A",
    "Model": "PK76A"
  },
  {
    "Retail Branding": "onn.",
    "Marketing Name": "PM1042T-W",
    "Device": "PM1042T-W",
    "Model": "PM1042T-W"
  },
  {
    "Retail Branding": "onn.",
    "Marketing Name": "PM1042TW",
    "Device": "PM1042TW",
    "Model": "PM1042TW"
  },
  {
    "Retail Branding": "onn.",
    "Marketing Name": "PM116T",
    "Device": "PM116T",
    "Model": "PM116T"
  },
  {
    "Retail Branding": "onn.",
    "Marketing Name": "PM116T_LTE",
    "Device": "PM116T_LTE",
    "Model": "PM116T_LTE"
  },
  {
    "Retail Branding": "onn.",
    "Marketing Name": "PM82T",
    "Device": "PM82T",
    "Model": "PM82T"
  },
  {
    "Retail Branding": "onn.",
    "Marketing Name": "PM82TW",
    "Device": "PM82TW",
    "Model": "PM82TW"
  },
  {
    "Retail Branding": "onn.",
    "Marketing Name": "PP86AK",
    "Device": "PP86AK",
    "Model": "PP86AK"
  },
  {
    "Retail Branding": "onn.",
    "Marketing Name": "SL713B1",
    "Device": "SL713B1",
    "Model": "SL713B1"
  },
  {
    "Retail Branding": "onn.",
    "Marketing Name": "Tablet Gen 4",
    "Device": 100135923,
    "Model": 100135923
  },
  {
    "Retail Branding": "onn.",
    "Marketing Name": "Tablet Gen 4",
    "Device": 100135925,
    "Model": 100135925
  },
  {
    "Retail Branding": "onn.",
    "Marketing Name": "onn. 11  Tablet Pro",
    "Device": "onn11TabletPro",
    "Model": 100146660
  },
  {
    "Retail Branding": "onn.",
    "Marketing Name": "onn. 12 Tablet  Pro",
    "Device": "onn12TabletPro",
    "Model": 100146663
  },
  {
    "Retail Branding": "onn.",
    "Marketing Name": "onn. 4K Plus Streaming",
    "Device": "coffey",
    "Model": "onn. 4K Plus Streaming"
  },
  {
    "Retail Branding": "onn.",
    "Marketing Name": "onn. 4K Streaming Box",
    "Device": "YOC",
    "Model": "onn. 4K Streaming Box"
  },
  {
    "Retail Branding": "onn.",
    "Marketing Name": "onn. 4k TV",
    "Device": "sti6140d360",
    "Model": "sti6140d360"
  },
  {
    "Retail Branding": "onn.",
    "Marketing Name": "onn. Full HD Streaming Device",
    "Device": "XNA",
    "Model": "onn. Full HD Streaming Device"
  },
  {
    "Retail Branding": "onn.",
    "Marketing Name": "onn. Streaming Device 4K pro",
    "Device": "SNA",
    "Model": "onn. Streaming Device 4K pro"
  },
  {
    "Retail Branding": "onn.",
    "Marketing Name": "onn11Kids",
    "Device": "onn11Kids",
    "Model": 36018345
  },
  {
    "Retail Branding": "onn.",
    "Marketing Name": "onn8Kids",
    "Device": "onn8Kids",
    "Model": 36018344
  },
  {
    "Retail Branding": "onn.",
    "Marketing Name": "onn_100003561",
    "Device": "mid8011",
    "Model": 100003561
  },
  {
    "Retail Branding": "pendo",
    "Marketing Name": "PNDPP44QC10",
    "Device": "PNDPP44QC10",
    "Model": "PNDPP44QC10"
  },
  {
    "Retail Branding": "pendo",
    "Marketing Name": "PNDPP44QC7",
    "Device": "PNDPP44QC7",
    "Model": "PNDPP44QC7"
  },
  {
    "Retail Branding": "predia",
    "Marketing Name": "Odin Groep",
    "Device": "rk3588_t",
    "Model": "general_en_bytello_edla"
  },
  {
    "Retail Branding": "preo",
    "Marketing Name": "PTABP10",
    "Device": "PTABP10",
    "Model": "PTABP10"
  },
  {
    "Retail Branding": "preo",
    "Marketing Name": "PTAB_P8",
    "Device": "PTAB_P8",
    "Model": "PTAB_P8"
  },
  {
    "Retail Branding": "prowise",
    "Marketing Name": "Prowise Touchscreen Ten",
    "Device": "ifpd",
    "Model": "prowise"
  },
  {
    "Retail Branding": "prowise",
    "Marketing Name": "Prowise Touchscreen Ultra",
    "Device": "ifpd",
    "Model": "prowise"
  },
  {
    "Retail Branding": "prowise",
    "Marketing Name": "Prowise_TSxG4",
    "Device": "Mercury",
    "Model": "TSxG4"
  },
  {
    "Retail Branding": "qunyiCO",
    "Marketing Name": "Y10",
    "Device": "Y10",
    "Model": "Y10"
  },
  {
    "Retail Branding": "qunyiCO",
    "Marketing Name": "Y10_1",
    "Device": "Y10_1",
    "Model": "Y10"
  },
  {
    "Retail Branding": "qunyiCO",
    "Marketing Name": "Y10_1_EEA",
    "Device": "Y10_1_EEA",
    "Model": "Y10"
  },
  {
    "Retail Branding": "qunyiCO",
    "Marketing Name": "Y10_EEA",
    "Device": "Y10_EEA",
    "Model": "Y10"
  },
  {
    "Retail Branding": "qunyiCO",
    "Marketing Name": "Y7",
    "Device": "Y7",
    "Model": "Y7"
  },
  {
    "Retail Branding": "qunyiCO",
    "Marketing Name": "Y7",
    "Device": "Y7_0",
    "Model": "Y7"
  },
  {
    "Retail Branding": "qunyiCO",
    "Marketing Name": "Y7",
    "Device": "Y7_0_EEA",
    "Model": "Y7"
  },
  {
    "Retail Branding": "qunyiCO",
    "Marketing Name": "Y7_EEA",
    "Device": "Y7_EEA",
    "Model": "Y7"
  },
  {
    "Retail Branding": "raemond",
    "Marketing Name": "L90_EEA",
    "Device": "L90",
    "Model": "L90"
  },
  {
    "Retail Branding": "raemond",
    "Marketing Name": "L90_ROW",
    "Device": "L90",
    "Model": "L90"
  },
  {
    "Retail Branding": "raemond",
    "Marketing Name": "M70_EEA_A",
    "Device": "M70_EEA_A",
    "Model": "M70"
  },
  {
    "Retail Branding": "raemond",
    "Marketing Name": "X70_EEA",
    "Device": "X70",
    "Model": "X70"
  },
  {
    "Retail Branding": "raemond",
    "Marketing Name": "X70_ROW",
    "Device": "X70",
    "Model": "X70"
  },
  {
    "Retail Branding": "raemond",
    "Marketing Name": "X70_US",
    "Device": "X70_US",
    "Model": "X70"
  },
  {
    "Retail Branding": "raemond",
    "Marketing Name": "X90_EEA",
    "Device": "X90",
    "Model": "K30_EEA"
  },
  {
    "Retail Branding": "raemond",
    "Marketing Name": "X90_EEA",
    "Device": "X90",
    "Model": "X90"
  },
  {
    "Retail Branding": "raemond",
    "Marketing Name": "Z90",
    "Device": "Z90",
    "Model": "Z90"
  },
  {
    "Retail Branding": "raemond",
    "Marketing Name": "Z90_EEA",
    "Device": "Z90",
    "Model": "Z90"
  },
  {
    "Retail Branding": "rainx",
    "Marketing Name": "Loop",
    "Device": "the101loop",
    "Model": "the101loop"
  },
  {
    "Retail Branding": "rainx",
    "Marketing Name": "Loop",
    "Device": "theloop",
    "Model": "theloop"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "4K Google TV Stick",
    "Device": "YYT",
    "Model": "4K Google TV Stick"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "4K Smart TV",
    "Device": "gangbyeon",
    "Model": "4K AI Smart TV"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "NARZO 70 5G",
    "Device": "RE5C86L1",
    "Model": "RMX3869"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "NARZO 70 Pro 5G",
    "Device": "RE5C86L1",
    "Model": "RMX3868"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "RMX3268",
    "Device": "RED8D7",
    "Model": "RMX3268"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "RMX3612",
    "Device": "RE588DL1",
    "Model": "RMX3612"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "RMX3627",
    "Device": "RE58AF",
    "Model": "RMX3627"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "RMX3710",
    "Device": "REE2ADL1",
    "Model": "RMX3710"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "RMX3771",
    "Device": "RE58B8L1",
    "Model": "RMX3771"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "RMX3782",
    "Device": "RE5C6CL1",
    "Model": "RMX3782"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "RMX3834",
    "Device": "RE5C9F",
    "Model": "RMX3834"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "RMX3871",
    "Device": "RE6063L1",
    "Model": "RMX3871"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "RMX3933",
    "Device": "RE6054",
    "Model": "RMX3933"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "RMX3939",
    "Device": "RE6054",
    "Model": "RMX3939"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "RMX3940",
    "Device": "RE606B",
    "Model": "RMX3940"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "RMX3943",
    "Device": "RE6092",
    "Model": "RMX3943"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "RMX3944",
    "Device": "RE6083L1",
    "Model": "RMX3944"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "RMX3945",
    "Device": "RE6092",
    "Model": "RMX3945"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "RMX3990",
    "Device": "RE5CA3L1",
    "Model": "RMX3990"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "RMX3997",
    "Device": "RE5C9AL1",
    "Model": "RMX3997"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "RMX3998",
    "Device": "RE5C94L1",
    "Model": "RMX3998"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "RMX5000",
    "Device": "RE6066L1",
    "Model": "RMX5000"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "RMX5061",
    "Device": "RE60ADL1",
    "Model": "RMX5061"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "RMX5107",
    "Device": "RE646FL1",
    "Model": "RMX5107"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "RMX5111",
    "Device": "RE6444L1",
    "Model": "RMX5111"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "RMX5200",
    "Device": "RE6030L1",
    "Model": "RMX5200"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "RMX5210",
    "Device": "RE60C8L1",
    "Model": "RMX5210"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "RMX5258",
    "Device": "RE6478L1",
    "Model": "RMX5258"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "RMX5261",
    "Device": "RE6478L1",
    "Model": "RMX5261"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "RMX5303",
    "Device": "RE60B8",
    "Model": "RMX5303"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "RMX5313",
    "Device": "RE60BA",
    "Model": "RMX5313"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "RMX5377",
    "Device": "RE648B",
    "Model": "RMX5377"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "RMX5388",
    "Device": "RE60BA",
    "Model": "RMX5388"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "RMX5555",
    "Device": "RE6441L1",
    "Model": "RMX5555"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "Smart TV",
    "Device": "mateo",
    "Model": "2K PA Smart TV"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "Smart TV",
    "Device": "redwood",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "TV Stick",
    "Device": "BOS",
    "Model": "TV Stick"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "narzo 50 5G",
    "Device": "RED8CDL1",
    "Model": "RMX3571"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "narzo 50 5G",
    "Device": "RED8CDL1",
    "Model": "RMX3572"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "narzo 50 Pro 5G",
    "Device": "RE879EL1",
    "Model": "RMX3395"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "narzo 50 Pro 5G",
    "Device": "RE879EL1",
    "Model": "RMX3396"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme  8",
    "Device": "RMX3085L1",
    "Model": "RMX3085"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme  9i",
    "Device": "RED8C1L1",
    "Model": "RMX3491"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme  V23i",
    "Device": "RE873B",
    "Model": "RMX3576"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme  X7 Max",
    "Device": "RMX3031L1",
    "Model": "RMX3031"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme  narzo  30",
    "Device": "RMX2156L1",
    "Model": "RMX2156"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme 10",
    "Device": "RE8D4B",
    "Model": "RMX3615"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme 10",
    "Device": "RE8DDCL1",
    "Model": "RMX3630"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme 10 Pro",
    "Device": "RE5849",
    "Model": "RMX3663"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme 10 Pro 5G",
    "Device": "RE588BL1",
    "Model": "RMX3660"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme 10 Pro 5G",
    "Device": "RE588BL1",
    "Model": "RMX3661"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme 10 Pro 5G",
    "Device": "RE58B8L1",
    "Model": "RMX3771"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme 10 Pro+",
    "Device": "RE5854",
    "Model": "RMX3687"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme 10 Pro+ 5G",
    "Device": "RE58A5L1",
    "Model": "RMX3686"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme 10 Pro+ 5G",
    "Device": "RE58A6L1",
    "Model": "RMX3686"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme 10s",
    "Device": "RE5851",
    "Model": "RMX3617"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme 11",
    "Device": "RE5852",
    "Model": "RMX3751"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme 11",
    "Device": "RE5C7CL1",
    "Model": "RMX3636"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme 11 5G",
    "Device": "RE5C6CL1",
    "Model": "RMX3780"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme 11 Pro 5G",
    "Device": "RE58B8L1",
    "Model": "RMX3771"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme 11 Pro+",
    "Device": "RE5865",
    "Model": "RMX3740"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme 11 Pro+ 5G",
    "Device": "RE58B6L1",
    "Model": "RMX3741"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme 11x 5G",
    "Device": "RE5C6CL1",
    "Model": "RMX3785"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme 12",
    "Device": "RE6063L1",
    "Model": "RMX3871"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme 12 5G",
    "Device": "RE5C94L1",
    "Model": "RMX3999"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme 12 Lite",
    "Device": "RE5C91L1",
    "Model": "RMX3890"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme 12 Pro 5G",
    "Device": "RE5C84L1",
    "Model": "RMX3842"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme 12 Pro+ 5G",
    "Device": "RE5C82L1",
    "Model": "RMX3840"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme 12+ 5G",
    "Device": "RE5C86L1",
    "Model": "RMX3867"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme 12x 5G",
    "Device": "RE5C9AL1",
    "Model": "RMX3997"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme 13 5G",
    "Device": "RE6070L1",
    "Model": "RMX3951"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme 13 Pro 5G",
    "Device": "RE5CA3L1",
    "Model": "RMX3988"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme 13 Pro+ 5G",
    "Device": "RE5CA3L1",
    "Model": "RMX3921"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme 13+ 5G",
    "Device": "RE6066L1",
    "Model": "RMX5000"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme 14 5G",
    "Device": "RE608EL1",
    "Model": "RMX5070"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme 14 Pro 5G",
    "Device": "RE6081L1",
    "Model": "RMX5056"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme 14 Pro 5G",
    "Device": "RE6081L1",
    "Model": "RMX5057"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme 14 Pro+ 5G",
    "Device": "RE6079L1",
    "Model": "RMX5051"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme 14 Pro+ 5G",
    "Device": "RE6079L1",
    "Model": "RMX5054"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme 14T 5G",
    "Device": "RE60AFL1",
    "Model": "RMX5074"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme 14T 5G",
    "Device": "RE60AFL1",
    "Model": "RMX5078"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme 14x 5G",
    "Device": "RE6092",
    "Model": "RMX3943"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme 15 5G",
    "Device": "RE60CCL1",
    "Model": "RMX5106"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme 15 5G",
    "Device": "RE60CDL1",
    "Model": "RMX5106"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme 15 Pro 5G",
    "Device": "RE60B4L1",
    "Model": "RMX5101"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme 15T",
    "Device": "RE6444L1",
    "Model": "RMX5111"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme 15x 5G",
    "Device": "RE644C",
    "Model": "RMX5250"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme 16 5G",
    "Device": "RE6474L1",
    "Model": "RMX5171"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme 16 Pro 5G",
    "Device": "RE645DL1",
    "Model": "RMX5120"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme 16 Pro+ 5G",
    "Device": "RE6458L1",
    "Model": "RMX5131"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme 2K G Smart TV",
    "Device": "umeda",
    "Model": "realme 2K G Smart TV"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme 4K G Smart TV",
    "Device": "SW6H",
    "Model": "realme 4K G Smart TV"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme 4K G Smart TV FF",
    "Device": "SW6H",
    "Model": "realme 4K G Smart TV FF"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme 6",
    "Device": "RMX2001L1",
    "Model": "RMX2001"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme 6",
    "Device": "RMX2002L1",
    "Model": "RMX2002"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme 6Pro",
    "Device": "RMX2061L1",
    "Model": "RMX2061"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme 6Pro",
    "Device": "RMX2063L1",
    "Model": "RMX2063"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme 7",
    "Device": "RMX2151L1",
    "Model": "RMX2151"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme 7 5G",
    "Device": "RMX2111L1",
    "Model": "RMX2111"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme 7 Pro",
    "Device": "RMX2170L1",
    "Model": "RMX2170"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme 8",
    "Device": "RMX3085L1",
    "Model": "RMX3085"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme 8 5G",
    "Device": "RE513CL1",
    "Model": "RMX3241"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme 8 Pro",
    "Device": "RMX3081L1",
    "Model": "RMX3081"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme 8i",
    "Device": "RE54B4L1",
    "Model": "RMX3151"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme 8s 5G",
    "Device": "RE58A0L1",
    "Model": "RMX3381"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme 9",
    "Device": "RE54E2L1",
    "Model": "RMX3521"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme 9 5G",
    "Device": "RE54CBL1",
    "Model": "RMX3474"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme 9 5G",
    "Device": "RE54F3L1",
    "Model": "RMX3388"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme 9 5G Speed Edition",
    "Device": "RE54BFL1",
    "Model": "RMX3461"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme 9 Pro+",
    "Device": "RE879EL1",
    "Model": "RMX3392"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme 9 Pro+",
    "Device": "RE879EL1",
    "Model": "RMX3393"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme 9Pro 5G",
    "Device": "RE54CBL1",
    "Model": "RMX3471"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme 9Pro 5G",
    "Device": "RE54CBL1",
    "Model": "RMX3472"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme 9Pro 5G",
    "Device": "RE54CBL1",
    "Model": "RMX3474"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme 9i",
    "Device": "RED8C1L1",
    "Model": "RMX3491"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme 9i",
    "Device": "RED8C1L1",
    "Model": "RMX3492"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme 9i",
    "Device": "RED8C1L1",
    "Model": "RMX3493"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme 9i 5G",
    "Device": "RE588DL1",
    "Model": "RMX3612"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme C100 5G",
    "Device": "RE6478L1",
    "Model": "RMX5258"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme C100i",
    "Device": "RE648B",
    "Model": "RMX5377"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme C11 2021",
    "Device": "RMX3231",
    "Model": "RMX3231"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme C15",
    "Device": "RMX2180",
    "Model": "RMX2180"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme C15 Qualcomm Edition",
    "Device": "RMX2195L1",
    "Model": "RMX2195"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme C20",
    "Device": "RMX3061",
    "Model": "RMX3061"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme C20",
    "Device": "RMX3063",
    "Model": "RMX3063"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme C21 Y",
    "Device": "RMX3261",
    "Model": "RMX3261"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme C21-Y",
    "Device": "RED8D1",
    "Model": "RMX3263"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme C21Y",
    "Device": "RMX3261",
    "Model": "RMX3261"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme C21Y",
    "Device": "RMX3262",
    "Model": "RMX3262"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme C25",
    "Device": "RMX3191",
    "Model": "RMX3191"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme C25",
    "Device": "RMX3193",
    "Model": "RMX3193"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme C25Y",
    "Device": "RE54D1",
    "Model": "RMX3265"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme C25Y",
    "Device": "RED8F6",
    "Model": "RMX3269"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme C25s",
    "Device": "RMX3195",
    "Model": "RMX3195"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme C25s",
    "Device": "RMX3197",
    "Model": "RMX3197"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme C30",
    "Device": "RE5887",
    "Model": "RMX3581"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme C30",
    "Device": "RE588E",
    "Model": "RMX3623"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme C30s",
    "Device": "RE58AB",
    "Model": "RMX3690"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme C31",
    "Device": "RE549C",
    "Model": "RMX3501"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme C31",
    "Device": "RE549C",
    "Model": "RMX3502"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme C31",
    "Device": "RE549C",
    "Model": "RMX3503"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme C33",
    "Device": "RE5894",
    "Model": "RMX3624"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme C33 128GB",
    "Device": "RE58AF",
    "Model": "RMX3627"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme C35",
    "Device": "RE87BAL1",
    "Model": "RMX3511"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme C35",
    "Device": "RE87BAL1",
    "Model": "RMX3512"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme C35",
    "Device": "RE87BAL1",
    "Model": "RMX3513"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme C51",
    "Device": "RE58BC",
    "Model": "RMX3830"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme C51s",
    "Device": "RE5C51",
    "Model": "RMX3765"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme C53",
    "Device": "RE58C2",
    "Model": "RMX3760"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme C53",
    "Device": "RE58CE",
    "Model": "RMX3762"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme C55",
    "Device": "REE2ADL1",
    "Model": "RMX3710"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme C61",
    "Device": "RE6054",
    "Model": "RMX3930"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme C63",
    "Device": "RE6054",
    "Model": "RMX3939"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme C63 5G",
    "Device": "RE6070L1",
    "Model": "RMX3950"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme C65",
    "Device": "RE5C42",
    "Model": "RMX3910"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme C67",
    "Device": "RE5C91L1",
    "Model": "RMX3890"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme C71",
    "Device": "RE60B8",
    "Model": "RMX5303"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme C75",
    "Device": "RE607CL1",
    "Model": "RMX3941"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme C75 5G",
    "Device": "RE6092",
    "Model": "RMX3943"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme C75 5G",
    "Device": "RE6092",
    "Model": "RMX3963"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme C75x",
    "Device": "RE6089",
    "Model": "RMX5020"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme C83 5G",
    "Device": "RE6478L1",
    "Model": "RMX5256"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme C85",
    "Device": "RE645F",
    "Model": "RMX5566"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme C85 5G",
    "Device": "RE644C",
    "Model": "RMX5253"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme C85 Pro",
    "Device": "RE6441L1",
    "Model": "RMX5555"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme GT 2",
    "Device": "RE58B2L1",
    "Model": "RMX3312"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme GT 2 Pro",
    "Device": "RED8ACL1",
    "Model": "RMX3301"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme GT 5G",
    "Device": "RMX2202L1",
    "Model": "RMX2202"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme GT 6",
    "Device": "RE5CA6L1",
    "Model": "RMX3851"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme GT 6T",
    "Device": "RE606FL1",
    "Model": "RMX3853"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme GT 7 Pro",
    "Device": "RE605FL1",
    "Model": "RMX5011"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme GT 7T",
    "Device": "RE6090L1",
    "Model": "RMX5085"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme GT Master Edition",
    "Device": "RE507C",
    "Model": "RMX3361"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme GT Master Edition",
    "Device": "RE54ABL1",
    "Model": "RMX3360"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme GT NEO 3",
    "Device": "RED8BEL1",
    "Model": "RMX3561"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme GT NEO 3 150W",
    "Device": "RED8BEL1",
    "Model": "RMX3563"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme GT NEO 3T",
    "Device": "RE54E4L1",
    "Model": "RMX3371"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme GT Neo 5 SE",
    "Device": "RE58D1L1",
    "Model": "RMX3701"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme GT Neo2 5G",
    "Device": "RE879AL1",
    "Model": "RMX3370"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme GT3 240W",
    "Device": "REE2B2L1",
    "Model": "RMX3709"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme GT5",
    "Device": "RE5C33",
    "Model": "RMX3820"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme GT5 240W",
    "Device": "RE5C33",
    "Model": "RMX3823"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme GT5 Pro",
    "Device": "RE5C37",
    "Model": "RMX3888"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme NARZO 70 Turbo 5G",
    "Device": "RE6066L1",
    "Model": "RMX5003"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme NARZO 80 Pro 5G",
    "Device": "RE60AEL1",
    "Model": "RMX5033"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme NARZO 90x 5G",
    "Device": "RE644C",
    "Model": "RMX5264"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme Narzo 30 Pro 5G",
    "Device": "RMX2117L1",
    "Model": "RMX2117"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme Note 50",
    "Device": "RE5C9F",
    "Model": "RMX3834"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme Note 60",
    "Device": "RE6054",
    "Model": "RMX3933"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme Note 60x",
    "Device": "RE6095",
    "Model": "RMX3938"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme Note 70",
    "Device": "RE60BA",
    "Model": "RMX5313"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme Note 70T",
    "Device": "RE60BA",
    "Model": "RMX5313"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme Note 80",
    "Device": "RE60BA",
    "Model": "RMX5388"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme P1 5G",
    "Device": "RE5C86L1",
    "Model": "RMX3870"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme P1 Pro 5G",
    "Device": "RE5C84L1",
    "Model": "RMX3844"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme P1 Speed 5G",
    "Device": "RE6066L1",
    "Model": "RMX5004"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme P2 Pro 5G",
    "Device": "RE5CA3L1",
    "Model": "RMX3987"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme P3 5G",
    "Device": "RE608EL1",
    "Model": "RMX5070"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme P3 5G",
    "Device": "RE608EL1",
    "Model": "RMX5079"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme P3 Lite",
    "Device": "RE60B8",
    "Model": "RMX5300"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme P3 Pro 5G",
    "Device": "RE6079L1",
    "Model": "RMX5032"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme P3 Ultra 5G",
    "Device": "RE60A4L1",
    "Model": "RMX5030"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme P3 Ultra 5G",
    "Device": "RE60A4L1",
    "Model": "RMX5031"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme P4 5G",
    "Device": "RE6440L1",
    "Model": "RMX5110"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme P4 Power 5G",
    "Device": "RE646FL1",
    "Model": "RMX5107"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme P4 Pro 5G",
    "Device": "RE644BL1",
    "Model": "RMX5116"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme P4x 5G",
    "Device": "RE6450L1",
    "Model": "RMX5108"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme Pad 2",
    "Device": "RE5C6EL1",
    "Model": "RMP2204"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme Pad 2",
    "Device": "RE5C70L1",
    "Model": "RMP2205"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme Pad 2 Lite",
    "Device": "RE6077L1",
    "Model": "RMP2402"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme Pad 3",
    "Device": "RE6453L1",
    "Model": "RMP2502"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme Pad 3 5G",
    "Device": "RE6452L1",
    "Model": "RMP2501"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme Pad X",
    "Device": "RE5496",
    "Model": "RMP2108"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme Pad X",
    "Device": "RE54F2L1",
    "Model": "RMP2107"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme Pad X",
    "Device": "RE54F2L1",
    "Model": "RMP2108"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme Pad mini",
    "Device": "RE87CCL1",
    "Model": "RMP2105"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme Pad mini",
    "Device": "RE87CCL1",
    "Model": "RMP2106"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme Q2 5G",
    "Device": "RMX2117CN",
    "Model": "RMX2117"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme Q3 5G",
    "Device": "RMX3161CN",
    "Model": "RMX3161"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme Q3 Pro Play",
    "Device": "RE811C",
    "Model": "RMX3142"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme Q3s",
    "Device": "RE548BL1",
    "Model": "RMX3461"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme Q5",
    "Device": "RE547D",
    "Model": "RMX3478"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme Q5 Pro",
    "Device": "RE5477",
    "Model": "RMX3372"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme Q5i",
    "Device": "RE873D",
    "Model": "RMX3574"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme V15 5G",
    "Device": "RMX3092CN",
    "Model": "RMX3092"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme V15 5G",
    "Device": "RMX3093CN",
    "Model": "RMX3093"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme V23",
    "Device": "RE5487",
    "Model": "RMX3571"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme V25",
    "Device": "RE547D",
    "Model": "RMX3475"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme V30",
    "Device": "RE584B",
    "Model": "RMX3618"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme V30",
    "Device": "RE584B",
    "Model": "RMX3619"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme V5 5G",
    "Device": "RMX2111CN",
    "Model": "RMX2111"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme V5 5G",
    "Device": "RMX2112CN",
    "Model": "RMX2112"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme X3",
    "Device": "RMX2083L1",
    "Model": "RMX2083"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme X3",
    "Device": "RMX2086L1",
    "Model": "RMX2086"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme X50 Pro",
    "Device": "RMX2075L1",
    "Model": "RMX2075"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme X50 Pro",
    "Device": "RMX2076L1",
    "Model": "RMX2076"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme X50 Pro Play",
    "Device": "RMX2072CN",
    "Model": "RMX2072"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme X50m 5G",
    "Device": "RMX2141CN",
    "Model": "RMX2141"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme X7 5G",
    "Device": "RMX3092L1",
    "Model": "RMX3092"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme X7Pro Ultra",
    "Device": "RMX3115CN",
    "Model": "RMX3115"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme X7 5G",
    "Device": "RMX2176CN",
    "Model": "RMX2176"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme narzo 20 Pro",
    "Device": "RMX2161L1",
    "Model": "RMX2161"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme narzo 30",
    "Device": "RMX2156L1",
    "Model": "RMX2156"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme narzo 30 5G",
    "Device": "RE513CL1",
    "Model": "RMX3242"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme narzo 30A",
    "Device": "RMX3171",
    "Model": "RMX3171"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme narzo 50",
    "Device": "RE54B4L1",
    "Model": "RMX3286"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme narzo 50 5G",
    "Device": "RED8CDL1",
    "Model": "RMX3572"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme narzo 50A",
    "Device": "RED8AF",
    "Model": "RMX3430"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme narzo 50A Prime",
    "Device": "RE54D8L1",
    "Model": "RMX3516"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme narzo 50A Prime",
    "Device": "RE54D8L1",
    "Model": "RMX3517"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme narzo 50i",
    "Device": "RED8FA",
    "Model": "RMX3235"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme narzo 50i Prime",
    "Device": "RE588E",
    "Model": "RMX3506"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme narzo 60 5G",
    "Device": "RE58B1L1",
    "Model": "RMX3750"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme narzo N53",
    "Device": "RE58C6",
    "Model": "RMX3761"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme note 50",
    "Device": "RE5C9F",
    "Model": "RMX3834"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme pad",
    "Device": "RE54C1L1",
    "Model": "RMP2102"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme pad",
    "Device": "RE54C1L1",
    "Model": "RMP2103"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realme  X7 Pro",
    "Device": "RMX2121CN",
    "Model": "RMX2121"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realmeGT Neo5",
    "Device": "RE5860",
    "Model": "RMX3706"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "realmeGT Neo5 240W",
    "Device": "RE5860",
    "Model": "RMX3708"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "真我 GT NEO  3  150W",
    "Device": "RE5489",
    "Model": "RMX3562"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "真我 GT NEO 3",
    "Device": "RE5489",
    "Model": "RMX3560"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "真我 GT2 大师探索版",
    "Device": "RE5465",
    "Model": "RMX3551"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "真我 Q3 Pro 5G",
    "Device": "RMX2205CN",
    "Model": "RMX2205"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "真我 V20",
    "Device": "RE584B",
    "Model": "RMX3610"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "真我 V20",
    "Device": "RE584B",
    "Model": "RMX3611"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "真我11 Pro",
    "Device": "RE5869",
    "Model": "RMX3770"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "真我12",
    "Device": "RE5C3F",
    "Model": "RMX3992"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "真我12 Pro",
    "Device": "RE5C3C",
    "Model": "RMX3843"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "真我12 Pro+",
    "Device": "RE5C3B",
    "Model": "RMX3841"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "真我12x",
    "Device": "RE5C3F",
    "Model": "RMX3993"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "真我13",
    "Device": "RE5C44",
    "Model": "RMX3952"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "真我13 Pro",
    "Device": "RE601EL1",
    "Model": "RMX5002"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "真我13 Pro+",
    "Device": "RE5C49L1",
    "Model": "RMX3920"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "真我13 Pro至尊版",
    "Device": "RE5C49L1",
    "Model": "RMX3989"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "真我14",
    "Device": "RE6024L1",
    "Model": "RMX5075"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "真我14 Pro",
    "Device": "RE6020L1",
    "Model": "RMX5055"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "真我14 Pro+",
    "Device": "RE601FL1",
    "Model": "RMX5050"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "真我15",
    "Device": "RE6032L1",
    "Model": "RMX5105"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "真我15 Pro",
    "Device": "RE6031L1",
    "Model": "RMX5100"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "真我15T",
    "Device": "RE6404L1",
    "Model": "RMX5112"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "真我GT 2",
    "Device": "RE5471",
    "Model": "RMX3310"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "真我GT 2",
    "Device": "RE58B2L1",
    "Model": "RMX3311"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "真我GT 2 Pro",
    "Device": "RE547F",
    "Model": "RMX3300"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "真我GT Neo",
    "Device": "RMX3031CN",
    "Model": "RMX3031"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "真我GT Neo6",
    "Device": "RE5C46L1",
    "Model": "RMX3852"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "真我GT Neo6 SE",
    "Device": "RE5C39L1",
    "Model": "RMX3850"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "真我GT6",
    "Device": "RE5C4FL1",
    "Model": "RMX3800"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "真我GT7",
    "Device": "RE602AL1",
    "Model": "RMX6688"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "真我GT7 Pro",
    "Device": "RE6018L1",
    "Model": "RMX5010"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "真我GT7 Pro竞速版",
    "Device": "RE602CL1",
    "Model": "RMX5090"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "真我GT8",
    "Device": "RE6400L1",
    "Model": "RMX6699"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "真我Neo7",
    "Device": "RE6022L1",
    "Model": "RMX5060"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "真我Neo7 SE",
    "Device": "RE6025L1",
    "Model": "RMX5080"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "真我Neo7 Turbo",
    "Device": "RE602EL1",
    "Model": "RMX5062"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "真我Neo7x",
    "Device": "RE6024L1",
    "Model": "RMX5071"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "真我Neo8",
    "Device": "RE6402L1",
    "Model": "RMX8899"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "真我Q3s",
    "Device": "RE548B",
    "Model": "RMX3461"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "真我Q3s",
    "Device": "RE548B",
    "Model": "RMX3462"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "真我V13 5G",
    "Device": "RE5081",
    "Model": "RMX3041"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "真我V13 5G",
    "Device": "RE5081",
    "Model": "RMX3042"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "真我V13 5G",
    "Device": "RE5081",
    "Model": "RMX3043"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "真我V50",
    "Device": "RE5C34",
    "Model": "RMX3783"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "真我V50s",
    "Device": "RE5C34",
    "Model": "RMX3781"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "真我V60",
    "Device": "RE5C44",
    "Model": "RMX3995"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "真我V60 Pro",
    "Device": "RE6019",
    "Model": "RMX3953"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "真我V60s",
    "Device": "RE5C44",
    "Model": "RMX3996"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "真我V70",
    "Device": "RE6027",
    "Model": "RMX3946"
  },
  {
    "Retail Branding": "realme",
    "Marketing Name": "真我V70s",
    "Device": "RE6027",
    "Model": "RMX3948"
  },
  {
    "Retail Branding": "redbeat",
    "Marketing Name": "D5",
    "Device": "D5",
    "Model": "D5"
  },
  {
    "Retail Branding": "redbeat",
    "Marketing Name": "E3",
    "Device": "E3",
    "Model": "E3"
  },
  {
    "Retail Branding": "redbeat",
    "Marketing Name": "redbeatA2",
    "Device": "redbeatA2",
    "Model": "RG-TB10"
  },
  {
    "Retail Branding": "redbeat",
    "Marketing Name": "redbeatA2",
    "Device": "redbeatA2",
    "Model": "redbeatA2"
  },
  {
    "Retail Branding": "redbeat",
    "Marketing Name": "redbeatB2",
    "Device": "redbeatB2",
    "Model": "B2"
  },
  {
    "Retail Branding": "redbeat",
    "Marketing Name": "redbeatC1",
    "Device": "redbeatC1",
    "Model": "C1"
  },
  {
    "Retail Branding": "redbeat",
    "Marketing Name": "redbeatC1",
    "Device": "redbeatC1",
    "Model": "redbeatC1"
  },
  {
    "Retail Branding": "redbeat",
    "Marketing Name": "redbeatD5",
    "Device": "redbeatD5",
    "Model": "redbeat D5"
  },
  {
    "Retail Branding": "redbeat",
    "Marketing Name": "redbeatM2",
    "Device": "redbeatM2",
    "Model": "I11"
  },
  {
    "Retail Branding": "redbeat",
    "Marketing Name": "redbeatM2",
    "Device": "redbeatM2",
    "Model": "M2"
  },
  {
    "Retail Branding": "redbeat",
    "Marketing Name": "redbeatM2",
    "Device": "redbeatM2",
    "Model": "redbeatM2"
  },
  {
    "Retail Branding": "redfox",
    "Marketing Name": "P11",
    "Device": "P11",
    "Model": "P11-6128H"
  },
  {
    "Retail Branding": "redfox",
    "Marketing Name": "Valuer_V8",
    "Device": "Valuer_V8",
    "Model": "Valuer_V8"
  },
  {
    "Retail Branding": "redfox",
    "Marketing Name": "Wizpad_Valuer_R10S",
    "Device": "R10S",
    "Model": "Wizpad Valuer R10S"
  },
  {
    "Retail Branding": "redfox",
    "Marketing Name": "Wizpad_Valuer_R10X",
    "Device": "Wizpad_Valuer_R10X",
    "Model": "R10X"
  },
  {
    "Retail Branding": "redfox",
    "Marketing Name": "Wizpad_Valuer_V8",
    "Device": "wvv832",
    "Model": "Wizpad_Valuer_V8"
  },
  {
    "Retail Branding": "rephone",
    "Marketing Name": "rephone",
    "Device": "rephone",
    "Model": "2000_000170_00"
  },
  {
    "Retail Branding": "rephone",
    "Marketing Name": "rephone5G",
    "Device": "rephone5G",
    "Model": "2000_000176_00"
  },
  {
    "Retail Branding": "robi",
    "Marketing Name": "B1",
    "Device": "BingeStick",
    "Model": "B1"
  },
  {
    "Retail Branding": "sencor",
    "Marketing Name": "10_1Q205",
    "Device": "10_1Q205",
    "Model": "10_1Q205"
  },
  {
    "Retail Branding": "sencor",
    "Marketing Name": "7Q105",
    "Device": "SENCOR_7Q105",
    "Model": "SENCOR_7Q105"
  },
  {
    "Retail Branding": "sencor",
    "Marketing Name": "7Q204",
    "Device": "7Q204",
    "Model": "7Q204"
  },
  {
    "Retail Branding": "sencor",
    "Marketing Name": "P5504",
    "Device": "P5504",
    "Model": "P5504"
  },
  {
    "Retail Branding": "sencor",
    "Marketing Name": "P5700",
    "Device": "P5700",
    "Model": "P5700"
  },
  {
    "Retail Branding": "sencor",
    "Marketing Name": "SENCOR_10_1Q102",
    "Device": "SENCOR_10_1Q102",
    "Model": "SENCOR_10_1Q102"
  },
  {
    "Retail Branding": "sf-express",
    "Marketing Name": "HHT7AX_HK1",
    "Device": "HHT7AX_HK1",
    "Model": "HHT7AX_HK1"
  },
  {
    "Retail Branding": "sf-express",
    "Marketing Name": "HHT7AX_TW1",
    "Device": "HHT7AX_TW1",
    "Model": "HHT7AX_TW1"
  },
  {
    "Retail Branding": "sf-express",
    "Marketing Name": "HHT7A_HK1",
    "Device": "HHT7A_HK1",
    "Model": "HHT7A_HK1"
  },
  {
    "Retail Branding": "sf-express",
    "Marketing Name": "HHT7A_TW1",
    "Device": "HHT7A_TW1",
    "Model": "HHT7A_TW1"
  },
  {
    "Retail Branding": "shoudum",
    "Marketing Name": "X50",
    "Device": "X50",
    "Model": "X50"
  },
  {
    "Retail Branding": "shoudum",
    "Marketing Name": "X50US",
    "Device": "X50US",
    "Model": "X50US"
  },
  {
    "Retail Branding": "shoudum",
    "Marketing Name": "X_50",
    "Device": "X_50",
    "Model": "X_50"
  },
  {
    "Retail Branding": "shoudum",
    "Marketing Name": "X_50US",
    "Device": "X_50US",
    "Model": "X_50US"
  },
  {
    "Retail Branding": "shoudum",
    "Marketing Name": "X_50_EEA",
    "Device": "X_50_EEA",
    "Model": "X_50_EEA"
  },
  {
    "Retail Branding": "simfer",
    "Marketing Name": "simfer 2K Android TV",
    "Device": "lasalle",
    "Model": "simfer 2K Android TV"
  },
  {
    "Retail Branding": "simfer",
    "Marketing Name": "simfer 4K Android TV",
    "Device": "kenton",
    "Model": "simfer 4K Android TV"
  },
  {
    "Retail Branding": "simpliTV",
    "Marketing Name": "Strong-SRT4150",
    "Device": "HY43X",
    "Model": "Strong-SRT4150"
  },
  {
    "Retail Branding": "simpliTV",
    "Marketing Name": "Strong-SRT4250",
    "Device": "HY43X",
    "Model": "Strong-SRT4250"
  },
  {
    "Retail Branding": "sincoole",
    "Marketing Name": "PAD-A7",
    "Device": "Rugged_Tablet-A7",
    "Model": "PAD-A7"
  },
  {
    "Retail Branding": "sincoole",
    "Marketing Name": "ST11-A5",
    "Device": "ST11-A5",
    "Model": "ST11-A5"
  },
  {
    "Retail Branding": "sky HCN",
    "Marketing Name": "KSTB1157",
    "Device": "K1100UA",
    "Model": "KSTB1157"
  },
  {
    "Retail Branding": "sky HCN",
    "Marketing Name": "KSTB4200",
    "Device": "KSTB4200",
    "Model": "KSTB4200"
  },
  {
    "Retail Branding": "sky HCN",
    "Marketing Name": "skyhcn Android UHD STB",
    "Device": "IMT-H6300",
    "Model": "IMT-H6300"
  },
  {
    "Retail Branding": "skywooo",
    "Marketing Name": "DDT_002",
    "Device": "DDT_002",
    "Model": "DDT_002"
  },
  {
    "Retail Branding": "snowa",
    "Marketing Name": "Smart TV",
    "Device": "alimos",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "snowa",
    "Marketing Name": "Smart TV",
    "Device": "bridgeport",
    "Model": "AI PONT PLUS FF"
  },
  {
    "Retail Branding": "snowa",
    "Marketing Name": "Smart TV",
    "Device": "dangni",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "solanamobile",
    "Marketing Name": "Seeker",
    "Device": "seeker",
    "Model": "Seeker"
  },
  {
    "Retail Branding": "spectramobile",
    "Marketing Name": "Spectra J1",
    "Device": "Spectra_J1",
    "Model": "Spectra J1"
  },
  {
    "Retail Branding": "spectramobile",
    "Marketing Name": "Spectra J1 PRO",
    "Device": "Spectra_J1P",
    "Model": "Spectra J1 PRO"
  },
  {
    "Retail Branding": "spectramobile",
    "Marketing Name": "Spectra J2 Pro",
    "Device": "Spectra_J2_Pro",
    "Model": "Spectra_J2_Pro"
  },
  {
    "Retail Branding": "spectramobile",
    "Marketing Name": "SpectraTab1",
    "Device": "SpectraTab1",
    "Model": "SpectraTab1"
  },
  {
    "Retail Branding": "stc myhome",
    "Marketing Name": "myHome",
    "Device": "SEI560STC",
    "Model": "myHome"
  },
  {
    "Retail Branding": "stc myhome",
    "Marketing Name": "stc-tv",
    "Device": "HP44J",
    "Model": "HP44J-stc-tv-3.0"
  },
  {
    "Retail Branding": "sugar_aums",
    "Marketing Name": "QPOINT",
    "Device": "QPI-1",
    "Model": "QPI-1"
  },
  {
    "Retail Branding": "t_go(Argentina)",
    "Marketing Name": "TGO_TB1021",
    "Device": "TGO_TB1021",
    "Model": "TGO_TB1021"
  },
  {
    "Retail Branding": "t_go(Argentina)",
    "Marketing Name": "TGO_TB850iH",
    "Device": "TGO_TB850iH",
    "Model": "TGO_TB850iH"
  },
  {
    "Retail Branding": "teXet",
    "Marketing Name": "TM-4510",
    "Device": "TM-4510",
    "Model": "TM-4510"
  },
  {
    "Retail Branding": "teXet",
    "Marketing Name": "TM-5071",
    "Device": "TM_5071",
    "Model": "TM-5071"
  },
  {
    "Retail Branding": "teXet",
    "Marketing Name": "TM-5073",
    "Device": "TM-5073",
    "Model": "TM-5073"
  },
  {
    "Retail Branding": "teXet",
    "Marketing Name": "TM-5075",
    "Device": "TM-5075",
    "Model": "TM-5075"
  },
  {
    "Retail Branding": "teXet",
    "Marketing Name": "TM-5076",
    "Device": "TM-5076",
    "Model": "TM-5076"
  },
  {
    "Retail Branding": "teXet",
    "Marketing Name": "TM-5077",
    "Device": "TM-5077",
    "Model": "TM-5077"
  },
  {
    "Retail Branding": "teXet",
    "Marketing Name": "TM-5081",
    "Device": "TM-5081",
    "Model": "Texet TM-5081"
  },
  {
    "Retail Branding": "teXet",
    "Marketing Name": "TM-5082",
    "Device": "TM-5082",
    "Model": "TM-5082"
  },
  {
    "Retail Branding": "teXet",
    "Marketing Name": "TM-5083",
    "Device": "TM-5083",
    "Model": "TM-5083"
  },
  {
    "Retail Branding": "teXet",
    "Marketing Name": "TM-5084",
    "Device": "TM-5084",
    "Model": "TM-5084"
  },
  {
    "Retail Branding": "teXet",
    "Marketing Name": "TM-5201",
    "Device": "TM-5201",
    "Model": "TM-5201"
  },
  {
    "Retail Branding": "teXet",
    "Marketing Name": "TM-5583",
    "Device": "TM-5583",
    "Model": "TM-5583"
  },
  {
    "Retail Branding": "teXet",
    "Marketing Name": "TM-5702",
    "Device": "TM-5702",
    "Model": "TM-5702"
  },
  {
    "Retail Branding": "teXet",
    "Marketing Name": "TM-5703",
    "Device": "TM-5703",
    "Model": "TM-5703"
  },
  {
    "Retail Branding": "teXet",
    "Marketing Name": "Texet TM-5571",
    "Device": "tm5571",
    "Model": "TM-5571"
  },
  {
    "Retail Branding": "teXet",
    "Marketing Name": "Texet TM-5581",
    "Device": "tm5581",
    "Model": "TM-5581"
  },
  {
    "Retail Branding": "teXet",
    "Marketing Name": "Texet TM-5584",
    "Device": "TM-5584",
    "Model": "TM-5584"
  },
  {
    "Retail Branding": "techBITE",
    "Marketing Name": "Flix  TV  Box",
    "Device": "DV8219",
    "Model": "Flix TV Box"
  },
  {
    "Retail Branding": "techBITE",
    "Marketing Name": "SmartBoard 10 LTE",
    "Device": "SmartBoard_10_LTE",
    "Model": "SmartBoard_10_LTE"
  },
  {
    "Retail Branding": "techBITE",
    "Marketing Name": "Smartboard_III_12_EEA",
    "Device": "TT2401x",
    "Model": "Smartboard III 12"
  },
  {
    "Retail Branding": "techBITE",
    "Marketing Name": "smartboard_2",
    "Device": "smartboard_2",
    "Model": "smartboard_2"
  },
  {
    "Retail Branding": "tecmobile",
    "Marketing Name": "OmnisOne",
    "Device": "OmnisOne",
    "Model": "Omnis One"
  },
  {
    "Retail Branding": "thehaam",
    "Marketing Name": "Smart TV",
    "Device": "alimos",
    "Model": "AI PONT"
  },
  {
    "Retail Branding": "thehaam",
    "Marketing Name": "Smart TV",
    "Device": "osaka",
    "Model": "AI PONT NA"
  },
  {
    "Retail Branding": "thehaam",
    "Marketing Name": "THEHAAM",
    "Device": "hongkong",
    "Model": "4K SMART TV"
  },
  {
    "Retail Branding": "thehaam",
    "Marketing Name": "vileparle",
    "Device": "vileparle",
    "Model": "R6G"
  },
  {
    "Retail Branding": "tonwelt",
    "Marketing Name": "supraGuide_DIVA_5_EEA",
    "Device": "supraGuide_DIVA_5",
    "Model": "supraGuide_DIVA_5"
  },
  {
    "Retail Branding": "trueslim",
    "Marketing Name": "5516D",
    "Device": "5516D",
    "Model": "5516D"
  },
  {
    "Retail Branding": "truevisions",
    "Marketing Name": "HCH03",
    "Device": "TrueHCH03",
    "Model": "HCH03"
  },
  {
    "Retail Branding": "truevisions",
    "Marketing Name": "N9106H-B",
    "Device": "HB_N9106H_B_truevisions",
    "Model": "N9106H-B"
  },
  {
    "Retail Branding": "truevisions",
    "Marketing Name": "N9106H-C",
    "Device": "HB_N9106H_C_truevisions",
    "Model": "N9106H-C"
  },
  {
    "Retail Branding": "truevisions",
    "Marketing Name": "SKWAMX3",
    "Device": "HP42F",
    "Model": "SKWAMX3"
  },
  {
    "Retail Branding": "truevisions",
    "Marketing Name": "SKWAMX5M",
    "Device": "HP4CE-Truevisions",
    "Model": "SKWAMX5M"
  },
  {
    "Retail Branding": "truevisions",
    "Marketing Name": "STI6030_TRUE_TV_A01",
    "Device": "TV_A01",
    "Model": "STI6030_TRUE_TV_A01"
  },
  {
    "Retail Branding": "truvii",
    "Marketing Name": "Truvii",
    "Device": "bruno",
    "Model": "Truvii2KAndroidTV"
  },
  {
    "Retail Branding": "truvii",
    "Marketing Name": "Truvii",
    "Device": "seocho",
    "Model": "Truvii 4K Android TV"
  },
  {
    "Retail Branding": "truvii",
    "Marketing Name": "Truvii",
    "Device": "shilin",
    "Model": "Truvii4KAndroidTV"
  },
  {
    "Retail Branding": "truvii",
    "Marketing Name": "Truvii",
    "Device": "sugamo",
    "Model": "Truvii 2K Android TV"
  },
  {
    "Retail Branding": "uLesson",
    "Marketing Name": "uLesson_Education_Tab",
    "Device": "uLesson_Education_Tab",
    "Model": "uLesson_Education_Tab"
  },
  {
    "Retail Branding": "uLesson",
    "Marketing Name": "uLesson_Education_Tab_V2",
    "Device": "uLesson_Tab_V2",
    "Model": "uLesson_Education_Tab_V2"
  },
  {
    "Retail Branding": "ucall",
    "Marketing Name": "EASY1",
    "Device": "EASY1",
    "Model": "EASY1"
  },
  {
    "Retail Branding": "ugee",
    "Marketing Name": "DT120QH",
    "Device": "ugeeDT120QH",
    "Model": "DT120QH"
  },
  {
    "Retail Branding": "ugee",
    "Marketing Name": "DT120QH_EEA",
    "Device": "ugeeDT120QH",
    "Model": "DT120QH"
  },
  {
    "Retail Branding": "ugee",
    "Marketing Name": "DT120QH_In",
    "Device": "ugeeDT120QH",
    "Model": "DT120QH"
  },
  {
    "Retail Branding": "ugee",
    "Marketing Name": "DT120QH_RU",
    "Device": "ugeeDT120QH",
    "Model": "DT120QH"
  },
  {
    "Retail Branding": "ugee",
    "Marketing Name": "UT1Lite_NOEEA",
    "Device": "ugeeUT1Lite_NOEEA",
    "Model": "UT2"
  },
  {
    "Retail Branding": "ugee",
    "Marketing Name": "UT2",
    "Device": "ugeeUT1Lite_EEA",
    "Model": "UT2"
  },
  {
    "Retail Branding": "ugee",
    "Marketing Name": "UT2",
    "Device": "ugeeUT1Lite_RU",
    "Model": "UT2"
  },
  {
    "Retail Branding": "ugee",
    "Marketing Name": "UT3 Drawing Pad",
    "Device": "Hera_Vis_WIFI",
    "Model": "UT3"
  },
  {
    "Retail Branding": "unioncore",
    "Marketing Name": "Handheld_printer_EEA",
    "Device": "Handheld_printer",
    "Model": "X8"
  },
  {
    "Retail Branding": "unitel",
    "Marketing Name": "BOX TV 4K UNITEL NET CASA",
    "Device": "Unitel_B866V6-H",
    "Model": "BOX TV 4K UNITEL NET CASA"
  },
  {
    "Retail Branding": "unitel",
    "Marketing Name": "P45",
    "Device": "P45",
    "Model": "P45"
  },
  {
    "Retail Branding": "unitel",
    "Marketing Name": "SMART_4G_II",
    "Device": "SMART_4G_II",
    "Model": "Unitel SMART 4G II SP136"
  },
  {
    "Retail Branding": "unitel",
    "Marketing Name": "U901",
    "Device": "U901",
    "Model": "U901"
  },
  {
    "Retail Branding": "unitel",
    "Marketing Name": "U902",
    "Device": "U902",
    "Model": "U902"
  },
  {
    "Retail Branding": "unitel",
    "Marketing Name": "U903",
    "Device": "U903",
    "Model": "U903"
  },
  {
    "Retail Branding": "unitel",
    "Marketing Name": "UNITEL_SMART_5G_S25",
    "Device": "UNITEL_SMART_5G_S25",
    "Model": "UNITEL SMART 5G S25"
  },
  {
    "Retail Branding": "unitel",
    "Marketing Name": "UNITEL_TAB_4G_H101",
    "Device": "UNITEL_TAB_4G_H101",
    "Model": "UNITEL_TAB_4G_H101"
  },
  {
    "Retail Branding": "unitel",
    "Marketing Name": "USMART6",
    "Device": "USMART6",
    "Model": "USMART6"
  },
  {
    "Retail Branding": "unitel",
    "Marketing Name": "Unitel_Smart_1",
    "Device": "Unitel_Smart_1",
    "Model": "Unitel Smart 1"
  },
  {
    "Retail Branding": "unitel",
    "Marketing Name": "Usmart5",
    "Device": "Usmart5",
    "Model": "Usmart5"
  },
  {
    "Retail Branding": "unv(Uniview Technologies Co.,Ltd)",
    "Marketing Name": "rk3588_t",
    "Device": "rk3588_t",
    "Model": "MW3565-U-CE"
  },
  {
    "Retail Branding": "vatenick",
    "Marketing Name": "M03",
    "Device": "M03",
    "Model": "M03"
  },
  {
    "Retail Branding": "vatenick",
    "Marketing Name": "v7",
    "Device": "v7",
    "Model": "v7"
  },
  {
    "Retail Branding": "vatenick",
    "Marketing Name": "v7-EEA",
    "Device": "v7-EEA",
    "Model": "v7-EEA"
  },
  {
    "Retail Branding": "verifone",
    "Marketing Name": "IX90_CQA1103",
    "Device": "IX90_CQA1103",
    "Model": "IX90_CQA1103"
  },
  {
    "Retail Branding": "verifone",
    "Marketing Name": "IX90_CQA1103_EEA",
    "Device": "IX90_CQA1103_EEA",
    "Model": "IX90_CQA1103_EEA"
  },
  {
    "Retail Branding": "verifone",
    "Marketing Name": "VG1",
    "Device": "VG100",
    "Model": "VG100"
  },
  {
    "Retail Branding": "videocon",
    "Marketing Name": "Delite 11",
    "Device": "V503630",
    "Model": "V503630"
  },
  {
    "Retail Branding": "videocon",
    "Marketing Name": "Krypton 22+",
    "Device": "V505024",
    "Model": "V505024"
  },
  {
    "Retail Branding": "videocon",
    "Marketing Name": "Metal Pro 1",
    "Device": "V505820",
    "Model": "V505820"
  },
  {
    "Retail Branding": "videocon",
    "Marketing Name": "Metal Pro 2",
    "Device": "V505920",
    "Model": "V505920"
  },
  {
    "Retail Branding": "videocon",
    "Marketing Name": "Starr 100",
    "Device": "V406018",
    "Model": "V406018"
  },
  {
    "Retail Branding": "vivo",
    "Marketing Name": "G3",
    "Device": "PD2443",
    "Model": "V2443A"
  },
  {
    "Retail Branding": "vivo",
    "Marketing Name": "Pad5",
    "Device": "DPD2437",
    "Model": "PA2553"
  },
  {
    "Retail Branding": "vivo",
    "Marketing Name": "Pad5e",
    "Device": "DPD2345",
    "Model": "PA2455"
  },
  {
    "Retail Branding": "vivo",
    "Marketing Name": "Pad5e",
    "Device": "DPD2345",
    "Model": "PA2535"
  },
  {
    "Retail Branding": "vivo",
    "Marketing Name": "Pad6 Pro",
    "Device": "DPD2540",
    "Model": "PA2671"
  },
  {
    "Retail Branding": "vivo",
    "Marketing Name": "S30",
    "Device": "PD2464",
    "Model": "V2464A"
  },
  {
    "Retail Branding": "vivo",
    "Marketing Name": "S30 Pro mini",
    "Device": "PD2465",
    "Model": "V2465A"
  },
  {
    "Retail Branding": "vivo",
    "Marketing Name": "S50",
    "Device": "PD2528",
    "Model": "V2528A"
  },
  {
    "Retail Branding": "vivo",
    "Marketing Name": "S50 Pro mini",
    "Device": "PD2527",
    "Model": "V2527A"
  },
  {
    "Retail Branding": "vivo",
    "Marketing Name": "T4 Pro",
    "Device": "V2511",
    "Model": "V2510"
  },
  {
    "Retail Branding": "vivo",
    "Marketing Name": "T4 Ultra",
    "Device": "V2504",
    "Model": "V2504"
  },
  {
    "Retail Branding": "vivo",
    "Marketing Name": "T5x 5G",
    "Device": "V2545",
    "Model": "V2545"
  },
  {
    "Retail Branding": "vivo",
    "Marketing Name": "V60",
    "Device": "V2511",
    "Model": "V2511"
  },
  {
    "Retail Branding": "vivo",
    "Marketing Name": "V60",
    "Device": "V2511",
    "Model": "V2512"
  },
  {
    "Retail Branding": "vivo",
    "Marketing Name": "V60 Lite",
    "Device": "V2441",
    "Model": "V2530"
  },
  {
    "Retail Branding": "vivo",
    "Marketing Name": "V60 Lite",
    "Device": "V2441U",
    "Model": "V2549"
  },
  {
    "Retail Branding": "vivo",
    "Marketing Name": "V60 Lite 5G",
    "Device": "V2529",
    "Model": "V2529"
  },
  {
    "Retail Branding": "vivo",
    "Marketing Name": "V60e",
    "Device": "V2513",
    "Model": "V2513"
  },
  {
    "Retail Branding": "vivo",
    "Marketing Name": "V70",
    "Device": "V2538",
    "Model": "V2538"
  },
  {
    "Retail Branding": "vivo",
    "Marketing Name": "V70",
    "Device": "V2538",
    "Model": "V2539"
  },
  {
    "Retail Branding": "vivo",
    "Marketing Name": "V70",
    "Device": "V2538",
    "Model": "V2540"
  },
  {
    "Retail Branding": "vivo",
    "Marketing Name": "V70 Elite",
    "Device": "V2548",
    "Model": "V2548"
  },
  {
    "Retail Branding": "vivo",
    "Marketing Name": "V70 FE",
    "Device": "V2550",
    "Model": "V2550"
  },
  {
    "Retail Branding": "vivo",
    "Marketing Name": "V70 FE",
    "Device": "V2550",
    "Model": "V2551"
  },
  {
    "Retail Branding": "vivo",
    "Marketing Name": "V70 FE",
    "Device": "V2550",
    "Model": "V2552"
  },
  {
    "Retail Branding": "vivo",
    "Marketing Name": "V70 FE",
    "Device": "V2550",
    "Model": "V2558"
  },
  {
    "Retail Branding": "vivo",
    "Marketing Name": "X Fold5",
    "Device": "PD2436",
    "Model": "V2436A"
  },
  {
    "Retail Branding": "vivo",
    "Marketing Name": "X Fold5",
    "Device": "V2429",
    "Model": "V2429"
  },
  {
    "Retail Branding": "vivo",
    "Marketing Name": "X200 FE",
    "Device": "V2503",
    "Model": "V2503"
  },
  {
    "Retail Branding": "vivo",
    "Marketing Name": "X200 FE",
    "Device": "V2503",
    "Model": "V2505"
  },
  {
    "Retail Branding": "vivo",
    "Marketing Name": "X200T",
    "Device": "V2561",
    "Model": "V2561"
  },
  {
    "Retail Branding": "vivo",
    "Marketing Name": "X300",
    "Device": "PD2509",
    "Model": "V2509A"
  },
  {
    "Retail Branding": "vivo",
    "Marketing Name": "X300",
    "Device": "V2515",
    "Model": "V2515"
  },
  {
    "Retail Branding": "vivo",
    "Marketing Name": "X300 Pro",
    "Device": "PD2502",
    "Model": "V2502A"
  },
  {
    "Retail Branding": "vivo",
    "Marketing Name": "X300 Pro",
    "Device": "V2514",
    "Model": "V2514"
  },
  {
    "Retail Branding": "vivo",
    "Marketing Name": "X300 Pro 卫星通信版",
    "Device": "PD2502",
    "Model": "V2502DA"
  },
  {
    "Retail Branding": "vivo",
    "Marketing Name": "X300 Ultra",
    "Device": "PD2547",
    "Model": "V2547A"
  },
  {
    "Retail Branding": "vivo",
    "Marketing Name": "X300 Ultra",
    "Device": "PD2547",
    "Model": "V2547DA"
  },
  {
    "Retail Branding": "vivo",
    "Marketing Name": "X300 Ultra 卫星通信版",
    "Device": "PD2547",
    "Model": "V2547DA"
  },
  {
    "Retail Branding": "vivo",
    "Marketing Name": "X300s",
    "Device": "PD2548",
    "Model": "V2548A"
  },
  {
    "Retail Branding": "vivo",
    "Marketing Name": "Y04e",
    "Device": "V2430",
    "Model": "V2532"
  },
  {
    "Retail Branding": "vivo",
    "Marketing Name": "Y05",
    "Device": "V2556",
    "Model": "V2556"
  },
  {
    "Retail Branding": "vivo",
    "Marketing Name": "Y05",
    "Device": "V2556",
    "Model": "V2565"
  },
  {
    "Retail Branding": "vivo",
    "Marketing Name": "Y11 5G",
    "Device": "V2553",
    "Model": "V2575"
  },
  {
    "Retail Branding": "vivo",
    "Marketing Name": "Y11d",
    "Device": "V2556",
    "Model": "V2555"
  },
  {
    "Retail Branding": "vivo",
    "Marketing Name": "Y11d",
    "Device": "V2556",
    "Model": "V2578"
  },
  {
    "Retail Branding": "vivo",
    "Marketing Name": "Y11d",
    "Device": "V2556",
    "Model": "V2580"
  },
  {
    "Retail Branding": "vivo",
    "Marketing Name": "Y11e",
    "Device": "V2556",
    "Model": "V2577"
  },
  {
    "Retail Branding": "vivo",
    "Marketing Name": "Y19s 5G",
    "Device": "V2446",
    "Model": "V2541"
  },
  {
    "Retail Branding": "vivo",
    "Marketing Name": "Y21 5G",
    "Device": "V2553",
    "Model": "V2553"
  },
  {
    "Retail Branding": "vivo",
    "Marketing Name": "Y21 5G",
    "Device": "V2553",
    "Model": "V2554"
  },
  {
    "Retail Branding": "vivo",
    "Marketing Name": "Y21d",
    "Device": "V2520",
    "Model": "V2520"
  },
  {
    "Retail Branding": "vivo",
    "Marketing Name": "Y21d",
    "Device": "V2520",
    "Model": "V2524"
  },
  {
    "Retail Branding": "vivo",
    "Marketing Name": "Y21d",
    "Device": "V2520",
    "Model": "V2525"
  },
  {
    "Retail Branding": "vivo",
    "Marketing Name": "Y21d",
    "Device": "V2520",
    "Model": "V2535"
  },
  {
    "Retail Branding": "vivo",
    "Marketing Name": "Y21d",
    "Device": "V2520",
    "Model": "V2560"
  },
  {
    "Retail Branding": "vivo",
    "Marketing Name": "Y21e",
    "Device": "V2520",
    "Model": "V2525"
  },
  {
    "Retail Branding": "vivo",
    "Marketing Name": "Y300 GT",
    "Device": "PD2452",
    "Model": "V2452GA"
  },
  {
    "Retail Branding": "vivo",
    "Marketing Name": "Y31 5G",
    "Device": "V2521",
    "Model": "V2521"
  },
  {
    "Retail Branding": "vivo",
    "Marketing Name": "Y31 5G",
    "Device": "V2521L",
    "Model": "V2521"
  },
  {
    "Retail Branding": "vivo",
    "Marketing Name": "Y31 Pro 5G",
    "Device": "V2437",
    "Model": "V2534"
  },
  {
    "Retail Branding": "vivo",
    "Marketing Name": "Y31d",
    "Device": "V2543",
    "Model": "V2543"
  },
  {
    "Retail Branding": "vivo",
    "Marketing Name": "Y31d",
    "Device": "V2543",
    "Model": "V2546"
  },
  {
    "Retail Branding": "vivo",
    "Marketing Name": "Y31d",
    "Device": "V2543",
    "Model": "V2582"
  },
  {
    "Retail Branding": "vivo",
    "Marketing Name": "Y31d",
    "Device": "V2543",
    "Model": "V2611"
  },
  {
    "Retail Branding": "vivo",
    "Marketing Name": "Y31e 5G",
    "Device": "V2521",
    "Model": "V2533"
  },
  {
    "Retail Branding": "vivo",
    "Marketing Name": "Y37+",
    "Device": "PD2443",
    "Model": "V2443A"
  },
  {
    "Retail Branding": "vivo",
    "Marketing Name": "Y37t",
    "Device": "PD2443",
    "Model": "V2443A"
  },
  {
    "Retail Branding": "vivo",
    "Marketing Name": "Y400",
    "Device": "V2455",
    "Model": "V2455"
  },
  {
    "Retail Branding": "vivo",
    "Marketing Name": "Y400 5G",
    "Device": "V2506",
    "Model": "V2506"
  },
  {
    "Retail Branding": "vivo",
    "Marketing Name": "Y400 Pro 5G",
    "Device": "V2439",
    "Model": "V2439"
  },
  {
    "Retail Branding": "vivo",
    "Marketing Name": "Y50 5G",
    "Device": "PD2443",
    "Model": "V2443A"
  },
  {
    "Retail Branding": "vivo",
    "Marketing Name": "Y50 AI版",
    "Device": "PD2443",
    "Model": "V2443A"
  },
  {
    "Retail Branding": "vivo",
    "Marketing Name": "Y50 移动定制版",
    "Device": "PD2443",
    "Model": "V2443A"
  },
  {
    "Retail Branding": "vivo",
    "Marketing Name": "Y500",
    "Device": "PD2506",
    "Model": "V2506A"
  },
  {
    "Retail Branding": "vivo",
    "Marketing Name": "Y500 Pro",
    "Device": "PD2516",
    "Model": "V2516A"
  },
  {
    "Retail Branding": "vivo",
    "Marketing Name": "Y500i",
    "Device": "PD2531",
    "Model": "V2531A"
  },
  {
    "Retail Branding": "vivo",
    "Marketing Name": "Y500i AI版",
    "Device": "PD2531",
    "Model": "V2531A"
  },
  {
    "Retail Branding": "vivo",
    "Marketing Name": "Y500s",
    "Device": "PD2531",
    "Model": "V2531A"
  },
  {
    "Retail Branding": "vivo",
    "Marketing Name": "Y500s AI版",
    "Device": "PD2531",
    "Model": "V2531A"
  },
  {
    "Retail Branding": "vivo",
    "Marketing Name": "Y50c",
    "Device": "PD2443",
    "Model": "V2443BA"
  },
  {
    "Retail Branding": "vivo",
    "Marketing Name": "Y50e 5G",
    "Device": "PD2443",
    "Model": "V2443A"
  },
  {
    "Retail Branding": "vivo",
    "Marketing Name": "Y50e AI版",
    "Device": "PD2443",
    "Model": "V2443A"
  },
  {
    "Retail Branding": "vivo",
    "Marketing Name": "Y50i",
    "Device": "PD2443",
    "Model": "V2443A"
  },
  {
    "Retail Branding": "vivo",
    "Marketing Name": "Y50i 12+256版",
    "Device": "PD2443",
    "Model": "V2443A"
  },
  {
    "Retail Branding": "vivo",
    "Marketing Name": "Y50i 8+256版",
    "Device": "PD2443",
    "Model": "V2443A"
  },
  {
    "Retail Branding": "vivo",
    "Marketing Name": "Y50i 移动定制版",
    "Device": "PD2443",
    "Model": "V2443A"
  },
  {
    "Retail Branding": "vivo",
    "Marketing Name": "Y50m 5G",
    "Device": "PD2443",
    "Model": "V2443BA"
  },
  {
    "Retail Branding": "vivo",
    "Marketing Name": "Y50s 5G",
    "Device": "PD2443",
    "Model": "V2443A"
  },
  {
    "Retail Branding": "vivo",
    "Marketing Name": "Y50s AI版",
    "Device": "PD2443",
    "Model": "V2443A"
  },
  {
    "Retail Branding": "vivo",
    "Marketing Name": "Y51 Pro 5G",
    "Device": "V2545L",
    "Model": "V2544"
  },
  {
    "Retail Branding": "vivo",
    "Marketing Name": "Y51 Pro 5G",
    "Device": "V2545L",
    "Model": "V2613"
  },
  {
    "Retail Branding": "vivo",
    "Marketing Name": "Y60",
    "Device": "PD2559",
    "Model": "V2559A"
  },
  {
    "Retail Branding": "vivo",
    "Marketing Name": "Y60 AI版",
    "Device": "PD2559",
    "Model": "V2559A"
  },
  {
    "Retail Branding": "vivo",
    "Marketing Name": "Y60m",
    "Device": "PD2559",
    "Model": "V2559BA"
  },
  {
    "Retail Branding": "vivo",
    "Marketing Name": "vivo V50 Lite 5G",
    "Device": "V2440",
    "Model": "V2440"
  },
  {
    "Retail Branding": "vivo",
    "Marketing Name": "vivo V50 Lite 5G",
    "Device": "V2440",
    "Model": "V2450"
  },
  {
    "Retail Branding": "waiputv",
    "Marketing Name": "Hybrid Stick",
    "Device": "SEI730WP",
    "Model": "Hybrid Stick"
  },
  {
    "Retail Branding": "waiputv",
    "Marketing Name": "waipu tv stick",
    "Device": "SEI700WP",
    "Model": "waipu tv stick"
  },
  {
    "Retail Branding": "waiputv",
    "Marketing Name": "waipu.tv Box",
    "Device": "SEID00BWP",
    "Model": "waipu.tv Box"
  },
  {
    "Retail Branding": "waiputv",
    "Marketing Name": "waipu.tv Stick (G2)",
    "Device": "SEID00DWP",
    "Model": "waipu.tv Stick (G2)"
  },
  {
    "Retail Branding": "wanbo",
    "Marketing Name": "Vali1 Pro",
    "Device": "coorg",
    "Model": "Vali1 Pro"
  },
  {
    "Retail Branding": "wancheng",
    "Marketing Name": "WC-F11",
    "Device": "WC-F11",
    "Model": "WC-F11"
  },
  {
    "Retail Branding": "weelikeit",
    "Marketing Name": "C19W",
    "Device": "C19W",
    "Model": "C19W"
  },
  {
    "Retail Branding": "weelikeit",
    "Marketing Name": "C19W_EEA",
    "Device": "C19W_EEA",
    "Model": "C19W_EEA"
  },
  {
    "Retail Branding": "weelikeit",
    "Marketing Name": "C28",
    "Device": "C28",
    "Model": "C28"
  },
  {
    "Retail Branding": "weelikeit",
    "Marketing Name": "C72W",
    "Device": "C72W",
    "Model": "C72W"
  },
  {
    "Retail Branding": "weelikeit",
    "Marketing Name": "C72W_EEA",
    "Device": "C72W_EEA",
    "Model": "C72W_EEA"
  },
  {
    "Retail Branding": "weelikeit",
    "Marketing Name": "C74W_EEA",
    "Device": "C74W_EEA",
    "Model": "C74W_EEA"
  },
  {
    "Retail Branding": "weelikeit",
    "Marketing Name": "C76W",
    "Device": "C76W",
    "Model": "C76W"
  },
  {
    "Retail Branding": "weelikeit",
    "Marketing Name": "C76W_EEA",
    "Device": "C76W_EEA",
    "Model": "C76W_EEA"
  },
  {
    "Retail Branding": "weelikeit",
    "Marketing Name": "C81W",
    "Device": "C81W",
    "Model": "C81W"
  },
  {
    "Retail Branding": "weelikeit",
    "Marketing Name": "C81W_EEA",
    "Device": "C81W_EEA",
    "Model": "C81W_EEA"
  },
  {
    "Retail Branding": "weelikeit",
    "Marketing Name": "C83W",
    "Device": "C83W",
    "Model": "C83W"
  },
  {
    "Retail Branding": "weelikeit",
    "Marketing Name": "C83W_EEA",
    "Device": "C83W_EEA",
    "Model": "C83W_EEA"
  },
  {
    "Retail Branding": "weelikeit",
    "Marketing Name": "C85W",
    "Device": "C85W",
    "Model": "C85W"
  },
  {
    "Retail Branding": "weelikeit",
    "Marketing Name": "C85W_EEA",
    "Device": "C85W_EEA",
    "Model": "C85W_EEA"
  },
  {
    "Retail Branding": "weelikeit",
    "Marketing Name": "F11W",
    "Device": "F11W",
    "Model": "F11W"
  },
  {
    "Retail Branding": "weelikeit",
    "Marketing Name": "F11W_EEA",
    "Device": "F11W",
    "Model": "F11W_EEA"
  },
  {
    "Retail Branding": "weelikeit",
    "Marketing Name": "F37W",
    "Device": "F37W",
    "Model": "F37W"
  },
  {
    "Retail Branding": "weelikeit",
    "Marketing Name": "F37W_EEA",
    "Device": "F37W_EEA",
    "Model": "F37W_EEA"
  },
  {
    "Retail Branding": "weelikeit",
    "Marketing Name": "F83W",
    "Device": "F83W",
    "Model": "F83W"
  },
  {
    "Retail Branding": "weelikeit",
    "Marketing Name": "P10W",
    "Device": "P10W",
    "Model": "P10W"
  },
  {
    "Retail Branding": "weelikeit",
    "Marketing Name": "P10W_EEA",
    "Device": "P10W_EEA",
    "Model": "P10W_EEA"
  },
  {
    "Retail Branding": "weelikeit",
    "Marketing Name": "P11W",
    "Device": "P11W",
    "Model": "P11W"
  },
  {
    "Retail Branding": "weelikeit",
    "Marketing Name": "P11W_EEA",
    "Device": "P11W_EEA",
    "Model": "P11W_EEA"
  },
  {
    "Retail Branding": "weelikeit",
    "Marketing Name": "P16-W",
    "Device": "P16-W",
    "Model": "P16"
  },
  {
    "Retail Branding": "weelikeit",
    "Marketing Name": "P16-W",
    "Device": "P16-W",
    "Model": "P16-W"
  },
  {
    "Retail Branding": "weelikeit",
    "Marketing Name": "P16W",
    "Device": "P16W",
    "Model": "P16W"
  },
  {
    "Retail Branding": "weelikeit",
    "Marketing Name": "P16W_EEA",
    "Device": "P16W_EEA",
    "Model": "P16W_EEA"
  },
  {
    "Retail Branding": "weelikeit",
    "Marketing Name": "P26W",
    "Device": "P26W",
    "Model": "P26W"
  },
  {
    "Retail Branding": "weelikeit",
    "Marketing Name": "P26W_EEA",
    "Device": "P26W_EEA",
    "Model": "P26W_EEA"
  },
  {
    "Retail Branding": "weelikeit",
    "Marketing Name": "P36W",
    "Device": "P36W",
    "Model": "P36W"
  },
  {
    "Retail Branding": "weelikeit",
    "Marketing Name": "P36W_EEA",
    "Device": "P36W_EEA",
    "Model": "P36W_EEA"
  },
  {
    "Retail Branding": "weelikeit",
    "Marketing Name": "P39W",
    "Device": "P39W",
    "Model": "P39W"
  },
  {
    "Retail Branding": "weelikeit",
    "Marketing Name": "P39W_EEA",
    "Device": "P39W_EEA",
    "Model": "P39W_EEA"
  },
  {
    "Retail Branding": "weelikeit",
    "Marketing Name": "P51L",
    "Device": "P51L",
    "Model": "P51L"
  },
  {
    "Retail Branding": "weelikeit",
    "Marketing Name": "P51L_EEA",
    "Device": "P51L_EEA",
    "Model": "P51L_EEA"
  },
  {
    "Retail Branding": "weelikeit",
    "Marketing Name": "P82L",
    "Device": "P82L",
    "Model": "P82L"
  },
  {
    "Retail Branding": "xTouch",
    "Marketing Name": "A4",
    "Device": "XTOUCH_A4",
    "Model": "A4"
  },
  {
    "Retail Branding": "xTouch",
    "Marketing Name": "A5",
    "Device": "A5",
    "Model": "XTOUCH_A5"
  },
  {
    "Retail Branding": "xTouch",
    "Marketing Name": "E4",
    "Device": "E4",
    "Model": "E4"
  },
  {
    "Retail Branding": "xTouch",
    "Marketing Name": "E5",
    "Device": "E5",
    "Model": "E5"
  },
  {
    "Retail Branding": "xTouch",
    "Marketing Name": "S10",
    "Device": "S10",
    "Model": "S10"
  },
  {
    "Retail Branding": "xTouch",
    "Marketing Name": "S20",
    "Device": "S20",
    "Model": "S20"
  },
  {
    "Retail Branding": "xTouch",
    "Marketing Name": "S40",
    "Device": "S40",
    "Model": "S40"
  },
  {
    "Retail Branding": "xTouch",
    "Marketing Name": "X10",
    "Device": "X10",
    "Model": "X10"
  },
  {
    "Retail Branding": "xTouch",
    "Marketing Name": "X40",
    "Device": "X40",
    "Model": "X40"
  },
  {
    "Retail Branding": "xTouch",
    "Marketing Name": "X9",
    "Device": "X9_16GB",
    "Model": "X9_16GB"
  },
  {
    "Retail Branding": "xTouch",
    "Marketing Name": "XBOT_SENIOR",
    "Device": "XBot_Senior",
    "Model": "X Bot Senior"
  },
  {
    "Retail Branding": "xTouch",
    "Marketing Name": "XBOT_SENIOR",
    "Device": "XBot_Senior",
    "Model": "XBot_Senior"
  },
  {
    "Retail Branding": "xTouch",
    "Marketing Name": "XBot Junior",
    "Device": "XBot_Junior",
    "Model": "XBot Junior"
  },
  {
    "Retail Branding": "xTouch",
    "Marketing Name": "XP10_4G",
    "Device": "XP10_4G",
    "Model": "XP10_4G"
  },
  {
    "Retail Branding": "xTouch",
    "Marketing Name": "XP10_Wifi",
    "Device": "XP10_Wifi",
    "Model": "XP10_Wifi"
  },
  {
    "Retail Branding": "xTouch",
    "Marketing Name": "XTOUCH X",
    "Device": "XTouch_X",
    "Model": "XTouch X"
  },
  {
    "Retail Branding": "xTouch",
    "Marketing Name": "XTOUCH X10",
    "Device": "XTOUCH_X10",
    "Model": "XTOUCH X10"
  },
  {
    "Retail Branding": "yikomi",
    "Marketing Name": "T7Ultra",
    "Device": "T7Ultra",
    "Model": "T7Ultra"
  },
  {
    "Retail Branding": "yikomi",
    "Marketing Name": "T7_US",
    "Device": "T7_US",
    "Model": "T7_US"
  },
  {
    "Retail Branding": "yyswie",
    "Marketing Name": "A74W",
    "Device": "A74W",
    "Model": "A74W"
  },
  {
    "Retail Branding": "yyswie",
    "Marketing Name": "CT1001",
    "Device": "CT1001",
    "Model": "CT1001"
  },
  {
    "Retail Branding": "yyswie",
    "Marketing Name": "CT1001_EEA",
    "Device": "CT1001_EEA",
    "Model": "CT1001"
  },
  {
    "Retail Branding": "yyswie",
    "Marketing Name": "Z10",
    "Device": "Z10",
    "Model": "Z10"
  },
  {
    "Retail Branding": "zcobro",
    "Marketing Name": "KIDS710",
    "Device": "KIDS710",
    "Model": "KIDS710"
  },
  {
    "Retail Branding": "zyrex",
    "Marketing Name": "ZT 216",
    "Device": "ZT_216",
    "Model": "ZT 216"
  },
  {
    "Retail Branding": "zyrex",
    "Marketing Name": "ZT216_1",
    "Device": "ZT216_1",
    "Model": "ZT216_1"
  },
  {
    "Retail Branding": "zyrex",
    "Marketing Name": "ZT216_17",
    "Device": "ZT216_17",
    "Model": "ZT216_17"
  },
  {
    "Retail Branding": "zyrex",
    "Marketing Name": "ZT216_19",
    "Device": "ZT216_19",
    "Model": "ZT216_19"
  },
  {
    "Retail Branding": "zyrex",
    "Marketing Name": "ZT216_2",
    "Device": "ZT216_2",
    "Model": "ZT216_2"
  },
  {
    "Retail Branding": "zyrex",
    "Marketing Name": "ZT216_23",
    "Device": "ZT216_23",
    "Model": "ZT216_23"
  },
  {
    "Retail Branding": "zyrex",
    "Marketing Name": "ZT216_3",
    "Device": "ZT216_3",
    "Model": "ZT216_3"
  },
  {
    "Retail Branding": "zyrex",
    "Marketing Name": "ZT216_4",
    "Device": "ZT216_4",
    "Model": "ZT216_4"
  },
  {
    "Retail Branding": "zyrex",
    "Marketing Name": "ZT216_5",
    "Device": "ZT216_5",
    "Model": "ZT216_5"
  },
  {
    "Retail Branding": "zyrex",
    "Marketing Name": "ZT8332_1",
    "Device": "ZT8332_1",
    "Model": "ZT8332_1"
  },
  {
    "Retail Branding": "zyrex",
    "Marketing Name": "ZT8332_2",
    "Device": "ZT8332_2",
    "Model": "ZT8332_2"
  },
  {
    "Retail Branding": "zyrex",
    "Marketing Name": "ZT_216",
    "Device": "ZT_216",
    "Model": "ZT_216"
  },
  {
    "Retail Branding": "zyrex",
    "Marketing Name": "Zyrex  ZA833",
    "Device": "ZA833",
    "Model": "ZA833"
  },
  {
    "Retail Branding": "zyrex",
    "Marketing Name": "zyrex",
    "Device": "ZT216_7",
    "Model": "ZT216_7"
  }
]